
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return import.meta.resolve($parcel$distDir + url);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea39d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea39d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fl9nK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2lD5F"));

});
parcelRegister("2lD5F", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1b5bdd7a69f0dbc1$export$ffb0004e005737fa, (v) => $1b5bdd7a69f0dbc1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $1b5bdd7a69f0dbc1$export$34b9dba7ce09269b, (v) => $1b5bdd7a69f0dbc1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $1b5bdd7a69f0dbc1$export$25062201e9e25d76, (v) => $1b5bdd7a69f0dbc1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1b5bdd7a69f0dbc1$export$ffb0004e005737fa;
var $1b5bdd7a69f0dbc1$export$34b9dba7ce09269b;
var $1b5bdd7a69f0dbc1$export$25062201e9e25d76;
'use strict';

var $bxRTa = parcelRequire("bxRTa");
var $1b5bdd7a69f0dbc1$var$k = Symbol.for("react.element"), $1b5bdd7a69f0dbc1$var$l = Symbol.for("react.fragment"), $1b5bdd7a69f0dbc1$var$m = Object.prototype.hasOwnProperty, $1b5bdd7a69f0dbc1$var$n = $bxRTa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1b5bdd7a69f0dbc1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1b5bdd7a69f0dbc1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1b5bdd7a69f0dbc1$var$m.call(a, b) && !$1b5bdd7a69f0dbc1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1b5bdd7a69f0dbc1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1b5bdd7a69f0dbc1$var$n.current
    };
}
$1b5bdd7a69f0dbc1$export$ffb0004e005737fa = $1b5bdd7a69f0dbc1$var$l;
$1b5bdd7a69f0dbc1$export$34b9dba7ce09269b = $1b5bdd7a69f0dbc1$var$q;
$1b5bdd7a69f0dbc1$export$25062201e9e25d76 = $1b5bdd7a69f0dbc1$var$q;

});
parcelRegister("bxRTa", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2O5Ek"));

});
parcelRegister("2O5Ek", function(module, exports) {

$parcel$export(module.exports, "Children", () => $20b4a222995d258f$export$dca3b0875bd9a954, (v) => $20b4a222995d258f$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $20b4a222995d258f$export$16fa2f45be04daa8, (v) => $20b4a222995d258f$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $20b4a222995d258f$export$ffb0004e005737fa, (v) => $20b4a222995d258f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $20b4a222995d258f$export$e2c29f18771995cb, (v) => $20b4a222995d258f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $20b4a222995d258f$export$221d75b3f55bb0bd, (v) => $20b4a222995d258f$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $20b4a222995d258f$export$5f8d39834fd61797, (v) => $20b4a222995d258f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $20b4a222995d258f$export$74bf444e3cd11ea5, (v) => $20b4a222995d258f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $20b4a222995d258f$export$ae55be85d98224ed, (v) => $20b4a222995d258f$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $20b4a222995d258f$export$3ba232387fd5d6dd, (v) => $20b4a222995d258f$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $20b4a222995d258f$export$e530037191fcd5d7, (v) => $20b4a222995d258f$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $20b4a222995d258f$export$fd42f52fd3ae1109, (v) => $20b4a222995d258f$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $20b4a222995d258f$export$c8a8987d4410bf2d, (v) => $20b4a222995d258f$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $20b4a222995d258f$export$d38cd72104c1f0e9, (v) => $20b4a222995d258f$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $20b4a222995d258f$export$7d1e3a5e95ceca43, (v) => $20b4a222995d258f$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $20b4a222995d258f$export$257a8862b851cb5b, (v) => $20b4a222995d258f$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $20b4a222995d258f$export$a8257692ac88316c, (v) => $20b4a222995d258f$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $20b4a222995d258f$export$488013bae63b21da, (v) => $20b4a222995d258f$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $20b4a222995d258f$export$7c73462e0d25e514, (v) => $20b4a222995d258f$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $20b4a222995d258f$export$7568632d0d33d16d, (v) => $20b4a222995d258f$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $20b4a222995d258f$export$88948ce120ea2619, (v) => $20b4a222995d258f$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $20b4a222995d258f$export$35808ee640e87ca7, (v) => $20b4a222995d258f$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $20b4a222995d258f$export$fae74005e78b1a27, (v) => $20b4a222995d258f$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $20b4a222995d258f$export$dc8fbce3eb94dc1e, (v) => $20b4a222995d258f$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $20b4a222995d258f$export$6a7bc4e911dc01cf, (v) => $20b4a222995d258f$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $20b4a222995d258f$export$6d9c69b0de29b591, (v) => $20b4a222995d258f$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $20b4a222995d258f$export$f680877a34711e37, (v) => $20b4a222995d258f$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $20b4a222995d258f$export$d5a552a76deda3c2, (v) => $20b4a222995d258f$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $20b4a222995d258f$export$aaabe4eda9ed9969, (v) => $20b4a222995d258f$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $20b4a222995d258f$export$e5c5a5f917a5871c, (v) => $20b4a222995d258f$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $20b4a222995d258f$export$1538c33de8887b59, (v) => $20b4a222995d258f$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $20b4a222995d258f$export$13e3392192263954, (v) => $20b4a222995d258f$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $20b4a222995d258f$export$b8f5890fc79d6aca, (v) => $20b4a222995d258f$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $20b4a222995d258f$export$60241385465d0a34, (v) => $20b4a222995d258f$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $20b4a222995d258f$export$306c0aa65ff9ec16, (v) => $20b4a222995d258f$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $20b4a222995d258f$export$7b286972b8d8ccbf, (v) => $20b4a222995d258f$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $20b4a222995d258f$export$83d89fbfd8236492, (v) => $20b4a222995d258f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $20b4a222995d258f$export$dca3b0875bd9a954;
var $20b4a222995d258f$export$16fa2f45be04daa8;
var $20b4a222995d258f$export$ffb0004e005737fa;
var $20b4a222995d258f$export$e2c29f18771995cb;
var $20b4a222995d258f$export$221d75b3f55bb0bd;
var $20b4a222995d258f$export$5f8d39834fd61797;
var $20b4a222995d258f$export$74bf444e3cd11ea5;
var $20b4a222995d258f$export$ae55be85d98224ed;
var $20b4a222995d258f$export$3ba232387fd5d6dd;
var $20b4a222995d258f$export$e530037191fcd5d7;
var $20b4a222995d258f$export$fd42f52fd3ae1109;
var $20b4a222995d258f$export$c8a8987d4410bf2d;
var $20b4a222995d258f$export$d38cd72104c1f0e9;
var $20b4a222995d258f$export$7d1e3a5e95ceca43;
var $20b4a222995d258f$export$257a8862b851cb5b;
var $20b4a222995d258f$export$a8257692ac88316c;
var $20b4a222995d258f$export$488013bae63b21da;
var $20b4a222995d258f$export$7c73462e0d25e514;
var $20b4a222995d258f$export$7568632d0d33d16d;
var $20b4a222995d258f$export$88948ce120ea2619;
var $20b4a222995d258f$export$35808ee640e87ca7;
var $20b4a222995d258f$export$fae74005e78b1a27;
var $20b4a222995d258f$export$dc8fbce3eb94dc1e;
var $20b4a222995d258f$export$6a7bc4e911dc01cf;
var $20b4a222995d258f$export$6d9c69b0de29b591;
var $20b4a222995d258f$export$f680877a34711e37;
var $20b4a222995d258f$export$d5a552a76deda3c2;
var $20b4a222995d258f$export$aaabe4eda9ed9969;
var $20b4a222995d258f$export$e5c5a5f917a5871c;
var $20b4a222995d258f$export$1538c33de8887b59;
var $20b4a222995d258f$export$13e3392192263954;
var $20b4a222995d258f$export$b8f5890fc79d6aca;
var $20b4a222995d258f$export$60241385465d0a34;
var $20b4a222995d258f$export$306c0aa65ff9ec16;
var $20b4a222995d258f$export$7b286972b8d8ccbf;
var $20b4a222995d258f$export$83d89fbfd8236492;
'use strict';
var $20b4a222995d258f$var$l = Symbol.for("react.element"), $20b4a222995d258f$var$n = Symbol.for("react.portal"), $20b4a222995d258f$var$p = Symbol.for("react.fragment"), $20b4a222995d258f$var$q = Symbol.for("react.strict_mode"), $20b4a222995d258f$var$r = Symbol.for("react.profiler"), $20b4a222995d258f$var$t = Symbol.for("react.provider"), $20b4a222995d258f$var$u = Symbol.for("react.context"), $20b4a222995d258f$var$v = Symbol.for("react.forward_ref"), $20b4a222995d258f$var$w = Symbol.for("react.suspense"), $20b4a222995d258f$var$x = Symbol.for("react.memo"), $20b4a222995d258f$var$y = Symbol.for("react.lazy"), $20b4a222995d258f$var$z = Symbol.iterator;
function $20b4a222995d258f$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $20b4a222995d258f$var$z && a[$20b4a222995d258f$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $20b4a222995d258f$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $20b4a222995d258f$var$C = Object.assign, $20b4a222995d258f$var$D = {};
function $20b4a222995d258f$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $20b4a222995d258f$var$D;
    this.updater = e || $20b4a222995d258f$var$B;
}
$20b4a222995d258f$var$E.prototype.isReactComponent = {};
$20b4a222995d258f$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$20b4a222995d258f$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $20b4a222995d258f$var$F() {}
$20b4a222995d258f$var$F.prototype = $20b4a222995d258f$var$E.prototype;
function $20b4a222995d258f$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $20b4a222995d258f$var$D;
    this.updater = e || $20b4a222995d258f$var$B;
}
var $20b4a222995d258f$var$H = $20b4a222995d258f$var$G.prototype = new $20b4a222995d258f$var$F;
$20b4a222995d258f$var$H.constructor = $20b4a222995d258f$var$G;
$20b4a222995d258f$var$C($20b4a222995d258f$var$H, $20b4a222995d258f$var$E.prototype);
$20b4a222995d258f$var$H.isPureReactComponent = !0;
var $20b4a222995d258f$var$I = Array.isArray, $20b4a222995d258f$var$J = Object.prototype.hasOwnProperty, $20b4a222995d258f$var$K = {
    current: null
}, $20b4a222995d258f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $20b4a222995d258f$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$20b4a222995d258f$var$J.call(b, d) && !$20b4a222995d258f$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $20b4a222995d258f$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $20b4a222995d258f$var$K.current
    };
}
function $20b4a222995d258f$var$N(a, b) {
    return {
        $$typeof: $20b4a222995d258f$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $20b4a222995d258f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $20b4a222995d258f$var$l;
}
function $20b4a222995d258f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $20b4a222995d258f$var$P = /\/+/g;
function $20b4a222995d258f$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $20b4a222995d258f$var$escape("" + a.key) : b.toString(36);
}
function $20b4a222995d258f$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $20b4a222995d258f$var$l:
                case $20b4a222995d258f$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $20b4a222995d258f$var$Q(h, 0) : d, $20b4a222995d258f$var$I(c) ? (e = "", null != a && (e = a.replace($20b4a222995d258f$var$P, "$&/") + "/"), $20b4a222995d258f$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($20b4a222995d258f$var$O(c) && (c = $20b4a222995d258f$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($20b4a222995d258f$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($20b4a222995d258f$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $20b4a222995d258f$var$Q(k, g);
        h += $20b4a222995d258f$var$R(k, b, e, f, c);
    }
    else if (f = $20b4a222995d258f$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $20b4a222995d258f$var$Q(k, g++), h += $20b4a222995d258f$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $20b4a222995d258f$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $20b4a222995d258f$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $20b4a222995d258f$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $20b4a222995d258f$var$U = {
    current: null
}, $20b4a222995d258f$var$V = {
    transition: null
}, $20b4a222995d258f$var$W = {
    ReactCurrentDispatcher: $20b4a222995d258f$var$U,
    ReactCurrentBatchConfig: $20b4a222995d258f$var$V,
    ReactCurrentOwner: $20b4a222995d258f$var$K
};
function $20b4a222995d258f$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$20b4a222995d258f$export$dca3b0875bd9a954 = {
    map: $20b4a222995d258f$var$S,
    forEach: function(a, b, e) {
        $20b4a222995d258f$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $20b4a222995d258f$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $20b4a222995d258f$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$20b4a222995d258f$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$20b4a222995d258f$export$16fa2f45be04daa8 = $20b4a222995d258f$var$E;
$20b4a222995d258f$export$ffb0004e005737fa = $20b4a222995d258f$var$p;
$20b4a222995d258f$export$e2c29f18771995cb = $20b4a222995d258f$var$r;
$20b4a222995d258f$export$221d75b3f55bb0bd = $20b4a222995d258f$var$G;
$20b4a222995d258f$export$5f8d39834fd61797 = $20b4a222995d258f$var$q;
$20b4a222995d258f$export$74bf444e3cd11ea5 = $20b4a222995d258f$var$w;
$20b4a222995d258f$export$ae55be85d98224ed = $20b4a222995d258f$var$W;
$20b4a222995d258f$export$3ba232387fd5d6dd = $20b4a222995d258f$var$X;
$20b4a222995d258f$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $20b4a222995d258f$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $20b4a222995d258f$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$20b4a222995d258f$var$J.call(b, f) && !$20b4a222995d258f$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $20b4a222995d258f$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$20b4a222995d258f$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $20b4a222995d258f$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $20b4a222995d258f$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$20b4a222995d258f$export$c8a8987d4410bf2d = $20b4a222995d258f$var$M;
$20b4a222995d258f$export$d38cd72104c1f0e9 = function(a) {
    var b = $20b4a222995d258f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$20b4a222995d258f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$20b4a222995d258f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $20b4a222995d258f$var$v,
        render: a
    };
};
$20b4a222995d258f$export$a8257692ac88316c = $20b4a222995d258f$var$O;
$20b4a222995d258f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $20b4a222995d258f$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $20b4a222995d258f$var$T
    };
};
$20b4a222995d258f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $20b4a222995d258f$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$20b4a222995d258f$export$7568632d0d33d16d = function(a) {
    var b = $20b4a222995d258f$var$V.transition;
    $20b4a222995d258f$var$V.transition = {};
    try {
        a();
    } finally{
        $20b4a222995d258f$var$V.transition = b;
    }
};
$20b4a222995d258f$export$88948ce120ea2619 = $20b4a222995d258f$var$X;
$20b4a222995d258f$export$35808ee640e87ca7 = function(a, b) {
    return $20b4a222995d258f$var$U.current.useCallback(a, b);
};
$20b4a222995d258f$export$fae74005e78b1a27 = function(a) {
    return $20b4a222995d258f$var$U.current.useContext(a);
};
$20b4a222995d258f$export$dc8fbce3eb94dc1e = function() {};
$20b4a222995d258f$export$6a7bc4e911dc01cf = function(a) {
    return $20b4a222995d258f$var$U.current.useDeferredValue(a);
};
$20b4a222995d258f$export$6d9c69b0de29b591 = function(a, b) {
    return $20b4a222995d258f$var$U.current.useEffect(a, b);
};
$20b4a222995d258f$export$f680877a34711e37 = function() {
    return $20b4a222995d258f$var$U.current.useId();
};
$20b4a222995d258f$export$d5a552a76deda3c2 = function(a, b, e) {
    return $20b4a222995d258f$var$U.current.useImperativeHandle(a, b, e);
};
$20b4a222995d258f$export$aaabe4eda9ed9969 = function(a, b) {
    return $20b4a222995d258f$var$U.current.useInsertionEffect(a, b);
};
$20b4a222995d258f$export$e5c5a5f917a5871c = function(a, b) {
    return $20b4a222995d258f$var$U.current.useLayoutEffect(a, b);
};
$20b4a222995d258f$export$1538c33de8887b59 = function(a, b) {
    return $20b4a222995d258f$var$U.current.useMemo(a, b);
};
$20b4a222995d258f$export$13e3392192263954 = function(a, b, e) {
    return $20b4a222995d258f$var$U.current.useReducer(a, b, e);
};
$20b4a222995d258f$export$b8f5890fc79d6aca = function(a) {
    return $20b4a222995d258f$var$U.current.useRef(a);
};
$20b4a222995d258f$export$60241385465d0a34 = function(a) {
    return $20b4a222995d258f$var$U.current.useState(a);
};
$20b4a222995d258f$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $20b4a222995d258f$var$U.current.useSyncExternalStore(a, b, e);
};
$20b4a222995d258f$export$7b286972b8d8ccbf = function() {
    return $20b4a222995d258f$var$U.current.useTransition();
};
$20b4a222995d258f$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("aRBoq", function(module, exports) {
'use strict';
function $7e8bdc0fcebcbe5b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e8bdc0fcebcbe5b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e8bdc0fcebcbe5b$var$checkDCE();

module.exports = (parcelRequire("RwUN7"));

});
parcelRegister("RwUN7", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0a0e7b9537100374$export$ae55be85d98224ed, (v) => $0a0e7b9537100374$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0a0e7b9537100374$export$d39a5bbd09211389, (v) => $0a0e7b9537100374$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0a0e7b9537100374$export$882461b6382ed46c, (v) => $0a0e7b9537100374$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0a0e7b9537100374$export$466bfc07425424d5, (v) => $0a0e7b9537100374$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0a0e7b9537100374$export$cd75ccfd720a3cd4, (v) => $0a0e7b9537100374$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0a0e7b9537100374$export$fa8d919ba61d84db, (v) => $0a0e7b9537100374$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0a0e7b9537100374$export$757ceba2d55c277e, (v) => $0a0e7b9537100374$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0a0e7b9537100374$export$b3890eb0ae9dca99, (v) => $0a0e7b9537100374$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0a0e7b9537100374$export$502457920280e6be, (v) => $0a0e7b9537100374$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0a0e7b9537100374$export$c78a37762a8d58e1, (v) => $0a0e7b9537100374$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0a0e7b9537100374$export$dc54d992c10e8a18, (v) => $0a0e7b9537100374$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0a0e7b9537100374$export$83d89fbfd8236492, (v) => $0a0e7b9537100374$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0a0e7b9537100374$export$ae55be85d98224ed;
var $0a0e7b9537100374$export$d39a5bbd09211389;
var $0a0e7b9537100374$export$882461b6382ed46c;
var $0a0e7b9537100374$export$466bfc07425424d5;
var $0a0e7b9537100374$export$cd75ccfd720a3cd4;
var $0a0e7b9537100374$export$fa8d919ba61d84db;
var $0a0e7b9537100374$export$757ceba2d55c277e;
var $0a0e7b9537100374$export$b3890eb0ae9dca99;
var $0a0e7b9537100374$export$502457920280e6be;
var $0a0e7b9537100374$export$c78a37762a8d58e1;
var $0a0e7b9537100374$export$dc54d992c10e8a18;
var $0a0e7b9537100374$export$83d89fbfd8236492;
'use strict';

var $bxRTa = parcelRequire("bxRTa");

var $9rFeI = parcelRequire("9rFeI");
function $0a0e7b9537100374$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0a0e7b9537100374$var$da = new Set, $0a0e7b9537100374$var$ea = {};
function $0a0e7b9537100374$var$fa(a, b) {
    $0a0e7b9537100374$var$ha(a, b);
    $0a0e7b9537100374$var$ha(a + "Capture", b);
}
function $0a0e7b9537100374$var$ha(a, b) {
    $0a0e7b9537100374$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0a0e7b9537100374$var$da.add(b[a]);
}
var $0a0e7b9537100374$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0a0e7b9537100374$var$ja = Object.prototype.hasOwnProperty, $0a0e7b9537100374$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0a0e7b9537100374$var$la = {}, $0a0e7b9537100374$var$ma = {};
function $0a0e7b9537100374$var$oa(a) {
    if ($0a0e7b9537100374$var$ja.call($0a0e7b9537100374$var$ma, a)) return !0;
    if ($0a0e7b9537100374$var$ja.call($0a0e7b9537100374$var$la, a)) return !1;
    if ($0a0e7b9537100374$var$ka.test(a)) return $0a0e7b9537100374$var$ma[a] = !0;
    $0a0e7b9537100374$var$la[a] = !0;
    return !1;
}
function $0a0e7b9537100374$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0a0e7b9537100374$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0a0e7b9537100374$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0a0e7b9537100374$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0a0e7b9537100374$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0a0e7b9537100374$var$z[b] = new $0a0e7b9537100374$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0a0e7b9537100374$var$ra = /[\-:]([a-z])/g;
function $0a0e7b9537100374$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0a0e7b9537100374$var$ra, $0a0e7b9537100374$var$sa);
    $0a0e7b9537100374$var$z[b] = new $0a0e7b9537100374$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0a0e7b9537100374$var$ra, $0a0e7b9537100374$var$sa);
    $0a0e7b9537100374$var$z[b] = new $0a0e7b9537100374$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0a0e7b9537100374$var$ra, $0a0e7b9537100374$var$sa);
    $0a0e7b9537100374$var$z[b] = new $0a0e7b9537100374$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0a0e7b9537100374$var$z.xlinkHref = new $0a0e7b9537100374$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0a0e7b9537100374$var$ta(a, b, c, d) {
    var e = $0a0e7b9537100374$var$z.hasOwnProperty(b) ? $0a0e7b9537100374$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0a0e7b9537100374$var$qa(b, c, e, d) && (c = null), d || null === e ? $0a0e7b9537100374$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0a0e7b9537100374$var$ua = $bxRTa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0a0e7b9537100374$var$va = Symbol.for("react.element"), $0a0e7b9537100374$var$wa = Symbol.for("react.portal"), $0a0e7b9537100374$var$ya = Symbol.for("react.fragment"), $0a0e7b9537100374$var$za = Symbol.for("react.strict_mode"), $0a0e7b9537100374$var$Aa = Symbol.for("react.profiler"), $0a0e7b9537100374$var$Ba = Symbol.for("react.provider"), $0a0e7b9537100374$var$Ca = Symbol.for("react.context"), $0a0e7b9537100374$var$Da = Symbol.for("react.forward_ref"), $0a0e7b9537100374$var$Ea = Symbol.for("react.suspense"), $0a0e7b9537100374$var$Fa = Symbol.for("react.suspense_list"), $0a0e7b9537100374$var$Ga = Symbol.for("react.memo"), $0a0e7b9537100374$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0a0e7b9537100374$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0a0e7b9537100374$var$Ja = Symbol.iterator;
function $0a0e7b9537100374$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0a0e7b9537100374$var$Ja && a[$0a0e7b9537100374$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0a0e7b9537100374$var$A = Object.assign, $0a0e7b9537100374$var$La;
function $0a0e7b9537100374$var$Ma(a) {
    if (void 0 === $0a0e7b9537100374$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0a0e7b9537100374$var$La = b && b[1] || "";
    }
    return "\n" + $0a0e7b9537100374$var$La + a;
}
var $0a0e7b9537100374$var$Na = !1;
function $0a0e7b9537100374$var$Oa(a, b) {
    if (!a || $0a0e7b9537100374$var$Na) return "";
    $0a0e7b9537100374$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0a0e7b9537100374$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0a0e7b9537100374$var$Ma(a) : "";
}
function $0a0e7b9537100374$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0a0e7b9537100374$var$Ma(a.type);
        case 16:
            return $0a0e7b9537100374$var$Ma("Lazy");
        case 13:
            return $0a0e7b9537100374$var$Ma("Suspense");
        case 19:
            return $0a0e7b9537100374$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0a0e7b9537100374$var$Oa(a.type, !1), a;
        case 11:
            return a = $0a0e7b9537100374$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0a0e7b9537100374$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0a0e7b9537100374$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0a0e7b9537100374$var$ya:
            return "Fragment";
        case $0a0e7b9537100374$var$wa:
            return "Portal";
        case $0a0e7b9537100374$var$Aa:
            return "Profiler";
        case $0a0e7b9537100374$var$za:
            return "StrictMode";
        case $0a0e7b9537100374$var$Ea:
            return "Suspense";
        case $0a0e7b9537100374$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0a0e7b9537100374$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0a0e7b9537100374$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0a0e7b9537100374$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0a0e7b9537100374$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0a0e7b9537100374$var$Qa(a.type) || "Memo";
        case $0a0e7b9537100374$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0a0e7b9537100374$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0a0e7b9537100374$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0a0e7b9537100374$var$Qa(b);
        case 8:
            return b === $0a0e7b9537100374$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0a0e7b9537100374$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0a0e7b9537100374$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0a0e7b9537100374$var$Ua(a) {
    var b = $0a0e7b9537100374$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0a0e7b9537100374$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0a0e7b9537100374$var$Ua(a));
}
function $0a0e7b9537100374$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0a0e7b9537100374$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0a0e7b9537100374$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0a0e7b9537100374$var$Ya(a, b) {
    var c = b.checked;
    return $0a0e7b9537100374$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0a0e7b9537100374$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0a0e7b9537100374$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0a0e7b9537100374$var$ab(a, b) {
    b = b.checked;
    null != b && $0a0e7b9537100374$var$ta(a, "checked", b, !1);
}
function $0a0e7b9537100374$var$bb(a, b) {
    $0a0e7b9537100374$var$ab(a, b);
    var c = $0a0e7b9537100374$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0a0e7b9537100374$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0a0e7b9537100374$var$cb(a, b.type, $0a0e7b9537100374$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0a0e7b9537100374$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0a0e7b9537100374$var$cb(a, b, c) {
    if ("number" !== b || $0a0e7b9537100374$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0a0e7b9537100374$var$eb = Array.isArray;
function $0a0e7b9537100374$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0a0e7b9537100374$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0a0e7b9537100374$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0a0e7b9537100374$var$p(91));
    return $0a0e7b9537100374$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0a0e7b9537100374$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0a0e7b9537100374$var$p(92));
            if ($0a0e7b9537100374$var$eb(c)) {
                if (1 < c.length) throw Error($0a0e7b9537100374$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0a0e7b9537100374$var$Sa(c)
    };
}
function $0a0e7b9537100374$var$ib(a, b) {
    var c = $0a0e7b9537100374$var$Sa(b.value), d = $0a0e7b9537100374$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0a0e7b9537100374$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0a0e7b9537100374$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0a0e7b9537100374$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0a0e7b9537100374$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0a0e7b9537100374$var$mb, $0a0e7b9537100374$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0a0e7b9537100374$var$mb = $0a0e7b9537100374$var$mb || document.createElement("div");
        $0a0e7b9537100374$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0a0e7b9537100374$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0a0e7b9537100374$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0a0e7b9537100374$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0a0e7b9537100374$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0a0e7b9537100374$var$pb).forEach(function(a) {
    $0a0e7b9537100374$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0a0e7b9537100374$var$pb[b] = $0a0e7b9537100374$var$pb[a];
    });
});
function $0a0e7b9537100374$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0a0e7b9537100374$var$pb.hasOwnProperty(a) && $0a0e7b9537100374$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0a0e7b9537100374$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0a0e7b9537100374$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0a0e7b9537100374$var$tb = $0a0e7b9537100374$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0a0e7b9537100374$var$ub(a, b) {
    if (b) {
        if ($0a0e7b9537100374$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0a0e7b9537100374$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0a0e7b9537100374$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0a0e7b9537100374$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0a0e7b9537100374$var$p(62));
    }
}
function $0a0e7b9537100374$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0a0e7b9537100374$var$wb = null;
function $0a0e7b9537100374$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0a0e7b9537100374$var$yb = null, $0a0e7b9537100374$var$zb = null, $0a0e7b9537100374$var$Ab = null;
function $0a0e7b9537100374$var$Bb(a) {
    if (a = $0a0e7b9537100374$var$Cb(a)) {
        if ("function" !== typeof $0a0e7b9537100374$var$yb) throw Error($0a0e7b9537100374$var$p(280));
        var b = a.stateNode;
        b && (b = $0a0e7b9537100374$var$Db(b), $0a0e7b9537100374$var$yb(a.stateNode, a.type, b));
    }
}
function $0a0e7b9537100374$var$Eb(a) {
    $0a0e7b9537100374$var$zb ? $0a0e7b9537100374$var$Ab ? $0a0e7b9537100374$var$Ab.push(a) : $0a0e7b9537100374$var$Ab = [
        a
    ] : $0a0e7b9537100374$var$zb = a;
}
function $0a0e7b9537100374$var$Fb() {
    if ($0a0e7b9537100374$var$zb) {
        var a = $0a0e7b9537100374$var$zb, b = $0a0e7b9537100374$var$Ab;
        $0a0e7b9537100374$var$Ab = $0a0e7b9537100374$var$zb = null;
        $0a0e7b9537100374$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0a0e7b9537100374$var$Bb(b[a]);
    }
}
function $0a0e7b9537100374$var$Gb(a, b) {
    return a(b);
}
function $0a0e7b9537100374$var$Hb() {}
var $0a0e7b9537100374$var$Ib = !1;
function $0a0e7b9537100374$var$Jb(a, b, c) {
    if ($0a0e7b9537100374$var$Ib) return a(b, c);
    $0a0e7b9537100374$var$Ib = !0;
    try {
        return $0a0e7b9537100374$var$Gb(a, b, c);
    } finally{
        if ($0a0e7b9537100374$var$Ib = !1, null !== $0a0e7b9537100374$var$zb || null !== $0a0e7b9537100374$var$Ab) $0a0e7b9537100374$var$Hb(), $0a0e7b9537100374$var$Fb();
    }
}
function $0a0e7b9537100374$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0a0e7b9537100374$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0a0e7b9537100374$var$p(231, b, typeof c));
    return c;
}
var $0a0e7b9537100374$var$Lb = !1;
if ($0a0e7b9537100374$var$ia) try {
    var $0a0e7b9537100374$var$Mb = {};
    Object.defineProperty($0a0e7b9537100374$var$Mb, "passive", {
        get: function() {
            $0a0e7b9537100374$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0a0e7b9537100374$var$Mb, $0a0e7b9537100374$var$Mb);
    window.removeEventListener("test", $0a0e7b9537100374$var$Mb, $0a0e7b9537100374$var$Mb);
} catch (a) {
    $0a0e7b9537100374$var$Lb = !1;
}
function $0a0e7b9537100374$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0a0e7b9537100374$var$Ob = !1, $0a0e7b9537100374$var$Pb = null, $0a0e7b9537100374$var$Qb = !1, $0a0e7b9537100374$var$Rb = null, $0a0e7b9537100374$var$Sb = {
    onError: function(a) {
        $0a0e7b9537100374$var$Ob = !0;
        $0a0e7b9537100374$var$Pb = a;
    }
};
function $0a0e7b9537100374$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0a0e7b9537100374$var$Ob = !1;
    $0a0e7b9537100374$var$Pb = null;
    $0a0e7b9537100374$var$Nb.apply($0a0e7b9537100374$var$Sb, arguments);
}
function $0a0e7b9537100374$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0a0e7b9537100374$var$Tb.apply(this, arguments);
    if ($0a0e7b9537100374$var$Ob) {
        if ($0a0e7b9537100374$var$Ob) {
            var l = $0a0e7b9537100374$var$Pb;
            $0a0e7b9537100374$var$Ob = !1;
            $0a0e7b9537100374$var$Pb = null;
        } else throw Error($0a0e7b9537100374$var$p(198));
        $0a0e7b9537100374$var$Qb || ($0a0e7b9537100374$var$Qb = !0, $0a0e7b9537100374$var$Rb = l);
    }
}
function $0a0e7b9537100374$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0a0e7b9537100374$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0a0e7b9537100374$var$Xb(a) {
    if ($0a0e7b9537100374$var$Vb(a) !== a) throw Error($0a0e7b9537100374$var$p(188));
}
function $0a0e7b9537100374$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0a0e7b9537100374$var$Vb(a);
        if (null === b) throw Error($0a0e7b9537100374$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0a0e7b9537100374$var$Xb(e), a;
                if (f === d) return $0a0e7b9537100374$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0a0e7b9537100374$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0a0e7b9537100374$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0a0e7b9537100374$var$p(190));
    }
    if (3 !== c.tag) throw Error($0a0e7b9537100374$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0a0e7b9537100374$var$Zb(a) {
    a = $0a0e7b9537100374$var$Yb(a);
    return null !== a ? $0a0e7b9537100374$var$$b(a) : null;
}
function $0a0e7b9537100374$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0a0e7b9537100374$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0a0e7b9537100374$var$ac = $9rFeI.unstable_scheduleCallback, $0a0e7b9537100374$var$bc = $9rFeI.unstable_cancelCallback, $0a0e7b9537100374$var$cc = $9rFeI.unstable_shouldYield, $0a0e7b9537100374$var$dc = $9rFeI.unstable_requestPaint, $0a0e7b9537100374$var$B = $9rFeI.unstable_now, $0a0e7b9537100374$var$ec = $9rFeI.unstable_getCurrentPriorityLevel, $0a0e7b9537100374$var$fc = $9rFeI.unstable_ImmediatePriority, $0a0e7b9537100374$var$gc = $9rFeI.unstable_UserBlockingPriority, $0a0e7b9537100374$var$hc = $9rFeI.unstable_NormalPriority, $0a0e7b9537100374$var$ic = $9rFeI.unstable_LowPriority, $0a0e7b9537100374$var$jc = $9rFeI.unstable_IdlePriority, $0a0e7b9537100374$var$kc = null, $0a0e7b9537100374$var$lc = null;
function $0a0e7b9537100374$var$mc(a) {
    if ($0a0e7b9537100374$var$lc && "function" === typeof $0a0e7b9537100374$var$lc.onCommitFiberRoot) try {
        $0a0e7b9537100374$var$lc.onCommitFiberRoot($0a0e7b9537100374$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0a0e7b9537100374$var$oc = Math.clz32 ? Math.clz32 : $0a0e7b9537100374$var$nc, $0a0e7b9537100374$var$pc = Math.log, $0a0e7b9537100374$var$qc = Math.LN2;
function $0a0e7b9537100374$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0a0e7b9537100374$var$pc(a) / $0a0e7b9537100374$var$qc | 0) | 0;
}
var $0a0e7b9537100374$var$rc = 64, $0a0e7b9537100374$var$sc = 4194304;
function $0a0e7b9537100374$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0a0e7b9537100374$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0a0e7b9537100374$var$tc(h) : (f &= g, 0 !== f && (d = $0a0e7b9537100374$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0a0e7b9537100374$var$tc(g) : 0 !== f && (d = $0a0e7b9537100374$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0a0e7b9537100374$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0a0e7b9537100374$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0a0e7b9537100374$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0a0e7b9537100374$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0a0e7b9537100374$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0a0e7b9537100374$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0a0e7b9537100374$var$yc() {
    var a = $0a0e7b9537100374$var$rc;
    $0a0e7b9537100374$var$rc <<= 1;
    0 === ($0a0e7b9537100374$var$rc & 4194240) && ($0a0e7b9537100374$var$rc = 64);
    return a;
}
function $0a0e7b9537100374$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0a0e7b9537100374$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0a0e7b9537100374$var$oc(b);
    a[b] = c;
}
function $0a0e7b9537100374$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0a0e7b9537100374$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0a0e7b9537100374$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0a0e7b9537100374$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0a0e7b9537100374$var$C = 0;
function $0a0e7b9537100374$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0a0e7b9537100374$var$Ec, $0a0e7b9537100374$var$Fc, $0a0e7b9537100374$var$Gc, $0a0e7b9537100374$var$Hc, $0a0e7b9537100374$var$Ic, $0a0e7b9537100374$var$Jc = !1, $0a0e7b9537100374$var$Kc = [], $0a0e7b9537100374$var$Lc = null, $0a0e7b9537100374$var$Mc = null, $0a0e7b9537100374$var$Nc = null, $0a0e7b9537100374$var$Oc = new Map, $0a0e7b9537100374$var$Pc = new Map, $0a0e7b9537100374$var$Qc = [], $0a0e7b9537100374$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0a0e7b9537100374$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0a0e7b9537100374$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0a0e7b9537100374$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0a0e7b9537100374$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0a0e7b9537100374$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0a0e7b9537100374$var$Pc.delete(b.pointerId);
    }
}
function $0a0e7b9537100374$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0a0e7b9537100374$var$Cb(b), null !== b && $0a0e7b9537100374$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0a0e7b9537100374$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0a0e7b9537100374$var$Lc = $0a0e7b9537100374$var$Tc($0a0e7b9537100374$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0a0e7b9537100374$var$Mc = $0a0e7b9537100374$var$Tc($0a0e7b9537100374$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0a0e7b9537100374$var$Nc = $0a0e7b9537100374$var$Tc($0a0e7b9537100374$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0a0e7b9537100374$var$Oc.set(f, $0a0e7b9537100374$var$Tc($0a0e7b9537100374$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0a0e7b9537100374$var$Pc.set(f, $0a0e7b9537100374$var$Tc($0a0e7b9537100374$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0a0e7b9537100374$var$Vc(a) {
    var b = $0a0e7b9537100374$var$Wc(a.target);
    if (null !== b) {
        var c = $0a0e7b9537100374$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0a0e7b9537100374$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0a0e7b9537100374$var$Ic(a.priority, function() {
                        $0a0e7b9537100374$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0a0e7b9537100374$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0a0e7b9537100374$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0a0e7b9537100374$var$wb = d;
            c.target.dispatchEvent(d);
            $0a0e7b9537100374$var$wb = null;
        } else return b = $0a0e7b9537100374$var$Cb(c), null !== b && $0a0e7b9537100374$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0a0e7b9537100374$var$Zc(a, b, c) {
    $0a0e7b9537100374$var$Xc(a) && c.delete(b);
}
function $0a0e7b9537100374$var$$c() {
    $0a0e7b9537100374$var$Jc = !1;
    null !== $0a0e7b9537100374$var$Lc && $0a0e7b9537100374$var$Xc($0a0e7b9537100374$var$Lc) && ($0a0e7b9537100374$var$Lc = null);
    null !== $0a0e7b9537100374$var$Mc && $0a0e7b9537100374$var$Xc($0a0e7b9537100374$var$Mc) && ($0a0e7b9537100374$var$Mc = null);
    null !== $0a0e7b9537100374$var$Nc && $0a0e7b9537100374$var$Xc($0a0e7b9537100374$var$Nc) && ($0a0e7b9537100374$var$Nc = null);
    $0a0e7b9537100374$var$Oc.forEach($0a0e7b9537100374$var$Zc);
    $0a0e7b9537100374$var$Pc.forEach($0a0e7b9537100374$var$Zc);
}
function $0a0e7b9537100374$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0a0e7b9537100374$var$Jc || ($0a0e7b9537100374$var$Jc = !0, $9rFeI.unstable_scheduleCallback($9rFeI.unstable_NormalPriority, $0a0e7b9537100374$var$$c)));
}
function $0a0e7b9537100374$var$bd(a) {
    function b(b) {
        return $0a0e7b9537100374$var$ad(b, a);
    }
    if (0 < $0a0e7b9537100374$var$Kc.length) {
        $0a0e7b9537100374$var$ad($0a0e7b9537100374$var$Kc[0], a);
        for(var c = 1; c < $0a0e7b9537100374$var$Kc.length; c++){
            var d = $0a0e7b9537100374$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0a0e7b9537100374$var$Lc && $0a0e7b9537100374$var$ad($0a0e7b9537100374$var$Lc, a);
    null !== $0a0e7b9537100374$var$Mc && $0a0e7b9537100374$var$ad($0a0e7b9537100374$var$Mc, a);
    null !== $0a0e7b9537100374$var$Nc && $0a0e7b9537100374$var$ad($0a0e7b9537100374$var$Nc, a);
    $0a0e7b9537100374$var$Oc.forEach(b);
    $0a0e7b9537100374$var$Pc.forEach(b);
    for(c = 0; c < $0a0e7b9537100374$var$Qc.length; c++)d = $0a0e7b9537100374$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0a0e7b9537100374$var$Qc.length && (c = $0a0e7b9537100374$var$Qc[0], null === c.blockedOn);)$0a0e7b9537100374$var$Vc(c), null === c.blockedOn && $0a0e7b9537100374$var$Qc.shift();
}
var $0a0e7b9537100374$var$cd = $0a0e7b9537100374$var$ua.ReactCurrentBatchConfig, $0a0e7b9537100374$var$dd = !0;
function $0a0e7b9537100374$var$ed(a, b, c, d) {
    var e = $0a0e7b9537100374$var$C, f = $0a0e7b9537100374$var$cd.transition;
    $0a0e7b9537100374$var$cd.transition = null;
    try {
        $0a0e7b9537100374$var$C = 1, $0a0e7b9537100374$var$fd(a, b, c, d);
    } finally{
        $0a0e7b9537100374$var$C = e, $0a0e7b9537100374$var$cd.transition = f;
    }
}
function $0a0e7b9537100374$var$gd(a, b, c, d) {
    var e = $0a0e7b9537100374$var$C, f = $0a0e7b9537100374$var$cd.transition;
    $0a0e7b9537100374$var$cd.transition = null;
    try {
        $0a0e7b9537100374$var$C = 4, $0a0e7b9537100374$var$fd(a, b, c, d);
    } finally{
        $0a0e7b9537100374$var$C = e, $0a0e7b9537100374$var$cd.transition = f;
    }
}
function $0a0e7b9537100374$var$fd(a, b, c, d) {
    if ($0a0e7b9537100374$var$dd) {
        var e = $0a0e7b9537100374$var$Yc(a, b, c, d);
        if (null === e) $0a0e7b9537100374$var$hd(a, b, d, $0a0e7b9537100374$var$id, c), $0a0e7b9537100374$var$Sc(a, d);
        else if ($0a0e7b9537100374$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0a0e7b9537100374$var$Sc(a, d), b & 4 && -1 < $0a0e7b9537100374$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0a0e7b9537100374$var$Cb(e);
                null !== f && $0a0e7b9537100374$var$Ec(f);
                f = $0a0e7b9537100374$var$Yc(a, b, c, d);
                null === f && $0a0e7b9537100374$var$hd(a, b, d, $0a0e7b9537100374$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0a0e7b9537100374$var$hd(a, b, d, null, c);
    }
}
var $0a0e7b9537100374$var$id = null;
function $0a0e7b9537100374$var$Yc(a, b, c, d) {
    $0a0e7b9537100374$var$id = null;
    a = $0a0e7b9537100374$var$xb(d);
    a = $0a0e7b9537100374$var$Wc(a);
    if (null !== a) {
        if (b = $0a0e7b9537100374$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0a0e7b9537100374$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0a0e7b9537100374$var$id = a;
    return null;
}
function $0a0e7b9537100374$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0a0e7b9537100374$var$ec()){
                case $0a0e7b9537100374$var$fc:
                    return 1;
                case $0a0e7b9537100374$var$gc:
                    return 4;
                case $0a0e7b9537100374$var$hc:
                case $0a0e7b9537100374$var$ic:
                    return 16;
                case $0a0e7b9537100374$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0a0e7b9537100374$var$kd = null, $0a0e7b9537100374$var$ld = null, $0a0e7b9537100374$var$md = null;
function $0a0e7b9537100374$var$nd() {
    if ($0a0e7b9537100374$var$md) return $0a0e7b9537100374$var$md;
    var a, b = $0a0e7b9537100374$var$ld, c = b.length, d, e = "value" in $0a0e7b9537100374$var$kd ? $0a0e7b9537100374$var$kd.value : $0a0e7b9537100374$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0a0e7b9537100374$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0a0e7b9537100374$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0a0e7b9537100374$var$pd() {
    return !0;
}
function $0a0e7b9537100374$var$qd() {
    return !1;
}
function $0a0e7b9537100374$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0a0e7b9537100374$var$pd : $0a0e7b9537100374$var$qd;
        this.isPropagationStopped = $0a0e7b9537100374$var$qd;
        return this;
    }
    $0a0e7b9537100374$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0a0e7b9537100374$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0a0e7b9537100374$var$pd);
        },
        persist: function() {},
        isPersistent: $0a0e7b9537100374$var$pd
    });
    return b;
}
var $0a0e7b9537100374$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0a0e7b9537100374$var$td = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$sd), $0a0e7b9537100374$var$ud = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$sd, {
    view: 0,
    detail: 0
}), $0a0e7b9537100374$var$vd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$ud), $0a0e7b9537100374$var$wd, $0a0e7b9537100374$var$xd, $0a0e7b9537100374$var$yd, $0a0e7b9537100374$var$Ad = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0a0e7b9537100374$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0a0e7b9537100374$var$yd && ($0a0e7b9537100374$var$yd && "mousemove" === a.type ? ($0a0e7b9537100374$var$wd = a.screenX - $0a0e7b9537100374$var$yd.screenX, $0a0e7b9537100374$var$xd = a.screenY - $0a0e7b9537100374$var$yd.screenY) : $0a0e7b9537100374$var$xd = $0a0e7b9537100374$var$wd = 0, $0a0e7b9537100374$var$yd = a);
        return $0a0e7b9537100374$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0a0e7b9537100374$var$xd;
    }
}), $0a0e7b9537100374$var$Bd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Ad), $0a0e7b9537100374$var$Cd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$Ad, {
    dataTransfer: 0
}), $0a0e7b9537100374$var$Dd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Cd), $0a0e7b9537100374$var$Ed = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$ud, {
    relatedTarget: 0
}), $0a0e7b9537100374$var$Fd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Ed), $0a0e7b9537100374$var$Gd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0a0e7b9537100374$var$Hd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Gd), $0a0e7b9537100374$var$Id = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0a0e7b9537100374$var$Jd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Id), $0a0e7b9537100374$var$Kd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$sd, {
    data: 0
}), $0a0e7b9537100374$var$Ld = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Kd), $0a0e7b9537100374$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0a0e7b9537100374$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0a0e7b9537100374$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0a0e7b9537100374$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0a0e7b9537100374$var$Od[a]) ? !!b[a] : !1;
}
function $0a0e7b9537100374$var$zd() {
    return $0a0e7b9537100374$var$Pd;
}
var $0a0e7b9537100374$var$Qd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0a0e7b9537100374$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0a0e7b9537100374$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0a0e7b9537100374$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0a0e7b9537100374$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0a0e7b9537100374$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0a0e7b9537100374$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0a0e7b9537100374$var$Rd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Qd), $0a0e7b9537100374$var$Sd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0a0e7b9537100374$var$Td = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Sd), $0a0e7b9537100374$var$Ud = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0a0e7b9537100374$var$zd
}), $0a0e7b9537100374$var$Vd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Ud), $0a0e7b9537100374$var$Wd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0a0e7b9537100374$var$Xd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Wd), $0a0e7b9537100374$var$Yd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0a0e7b9537100374$var$Zd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Yd), $0a0e7b9537100374$var$$d = [
    9,
    13,
    27,
    32
], $0a0e7b9537100374$var$ae = $0a0e7b9537100374$var$ia && "CompositionEvent" in window, $0a0e7b9537100374$var$be = null;
$0a0e7b9537100374$var$ia && "documentMode" in document && ($0a0e7b9537100374$var$be = document.documentMode);
var $0a0e7b9537100374$var$ce = $0a0e7b9537100374$var$ia && "TextEvent" in window && !$0a0e7b9537100374$var$be, $0a0e7b9537100374$var$de = $0a0e7b9537100374$var$ia && (!$0a0e7b9537100374$var$ae || $0a0e7b9537100374$var$be && 8 < $0a0e7b9537100374$var$be && 11 >= $0a0e7b9537100374$var$be), $0a0e7b9537100374$var$ee = String.fromCharCode(32), $0a0e7b9537100374$var$fe = !1;
function $0a0e7b9537100374$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0a0e7b9537100374$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0a0e7b9537100374$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0a0e7b9537100374$var$ie = !1;
function $0a0e7b9537100374$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0a0e7b9537100374$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0a0e7b9537100374$var$fe = !0;
            return $0a0e7b9537100374$var$ee;
        case "textInput":
            return a = b.data, a === $0a0e7b9537100374$var$ee && $0a0e7b9537100374$var$fe ? null : a;
        default:
            return null;
    }
}
function $0a0e7b9537100374$var$ke(a, b) {
    if ($0a0e7b9537100374$var$ie) return "compositionend" === a || !$0a0e7b9537100374$var$ae && $0a0e7b9537100374$var$ge(a, b) ? (a = $0a0e7b9537100374$var$nd(), $0a0e7b9537100374$var$md = $0a0e7b9537100374$var$ld = $0a0e7b9537100374$var$kd = null, $0a0e7b9537100374$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0a0e7b9537100374$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0a0e7b9537100374$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0a0e7b9537100374$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0a0e7b9537100374$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0a0e7b9537100374$var$ne(a, b, c, d) {
    $0a0e7b9537100374$var$Eb(d);
    b = $0a0e7b9537100374$var$oe(b, "onChange");
    0 < b.length && (c = new $0a0e7b9537100374$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0a0e7b9537100374$var$pe = null, $0a0e7b9537100374$var$qe = null;
function $0a0e7b9537100374$var$re(a) {
    $0a0e7b9537100374$var$se(a, 0);
}
function $0a0e7b9537100374$var$te(a) {
    var b = $0a0e7b9537100374$var$ue(a);
    if ($0a0e7b9537100374$var$Wa(b)) return a;
}
function $0a0e7b9537100374$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0a0e7b9537100374$var$we = !1;
if ($0a0e7b9537100374$var$ia) {
    var $0a0e7b9537100374$var$xe;
    if ($0a0e7b9537100374$var$ia) {
        var $0a0e7b9537100374$var$ye = "oninput" in document;
        if (!$0a0e7b9537100374$var$ye) {
            var $0a0e7b9537100374$var$ze = document.createElement("div");
            $0a0e7b9537100374$var$ze.setAttribute("oninput", "return;");
            $0a0e7b9537100374$var$ye = "function" === typeof $0a0e7b9537100374$var$ze.oninput;
        }
        $0a0e7b9537100374$var$xe = $0a0e7b9537100374$var$ye;
    } else $0a0e7b9537100374$var$xe = !1;
    $0a0e7b9537100374$var$we = $0a0e7b9537100374$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0a0e7b9537100374$var$Ae() {
    $0a0e7b9537100374$var$pe && ($0a0e7b9537100374$var$pe.detachEvent("onpropertychange", $0a0e7b9537100374$var$Be), $0a0e7b9537100374$var$qe = $0a0e7b9537100374$var$pe = null);
}
function $0a0e7b9537100374$var$Be(a) {
    if ("value" === a.propertyName && $0a0e7b9537100374$var$te($0a0e7b9537100374$var$qe)) {
        var b = [];
        $0a0e7b9537100374$var$ne(b, $0a0e7b9537100374$var$qe, a, $0a0e7b9537100374$var$xb(a));
        $0a0e7b9537100374$var$Jb($0a0e7b9537100374$var$re, b);
    }
}
function $0a0e7b9537100374$var$Ce(a, b, c) {
    "focusin" === a ? ($0a0e7b9537100374$var$Ae(), $0a0e7b9537100374$var$pe = b, $0a0e7b9537100374$var$qe = c, $0a0e7b9537100374$var$pe.attachEvent("onpropertychange", $0a0e7b9537100374$var$Be)) : "focusout" === a && $0a0e7b9537100374$var$Ae();
}
function $0a0e7b9537100374$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0a0e7b9537100374$var$te($0a0e7b9537100374$var$qe);
}
function $0a0e7b9537100374$var$Ee(a, b) {
    if ("click" === a) return $0a0e7b9537100374$var$te(b);
}
function $0a0e7b9537100374$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0a0e7b9537100374$var$te(b);
}
function $0a0e7b9537100374$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0a0e7b9537100374$var$He = "function" === typeof Object.is ? Object.is : $0a0e7b9537100374$var$Ge;
function $0a0e7b9537100374$var$Ie(a, b) {
    if ($0a0e7b9537100374$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0a0e7b9537100374$var$ja.call(b, e) || !$0a0e7b9537100374$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0a0e7b9537100374$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0a0e7b9537100374$var$Ke(a, b) {
    var c = $0a0e7b9537100374$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0a0e7b9537100374$var$Je(c);
    }
}
function $0a0e7b9537100374$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0a0e7b9537100374$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0a0e7b9537100374$var$Me() {
    for(var a = window, b = $0a0e7b9537100374$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0a0e7b9537100374$var$Xa(a.document);
    }
    return b;
}
function $0a0e7b9537100374$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0a0e7b9537100374$var$Oe(a) {
    var b = $0a0e7b9537100374$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0a0e7b9537100374$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0a0e7b9537100374$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0a0e7b9537100374$var$Ke(c, f);
                var g = $0a0e7b9537100374$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0a0e7b9537100374$var$Pe = $0a0e7b9537100374$var$ia && "documentMode" in document && 11 >= document.documentMode, $0a0e7b9537100374$var$Qe = null, $0a0e7b9537100374$var$Re = null, $0a0e7b9537100374$var$Se = null, $0a0e7b9537100374$var$Te = !1;
function $0a0e7b9537100374$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0a0e7b9537100374$var$Te || null == $0a0e7b9537100374$var$Qe || $0a0e7b9537100374$var$Qe !== $0a0e7b9537100374$var$Xa(d) || (d = $0a0e7b9537100374$var$Qe, "selectionStart" in d && $0a0e7b9537100374$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0a0e7b9537100374$var$Se && $0a0e7b9537100374$var$Ie($0a0e7b9537100374$var$Se, d) || ($0a0e7b9537100374$var$Se = d, d = $0a0e7b9537100374$var$oe($0a0e7b9537100374$var$Re, "onSelect"), 0 < d.length && (b = new $0a0e7b9537100374$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0a0e7b9537100374$var$Qe)));
}
function $0a0e7b9537100374$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0a0e7b9537100374$var$We = {
    animationend: $0a0e7b9537100374$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0a0e7b9537100374$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0a0e7b9537100374$var$Ve("Animation", "AnimationStart"),
    transitionend: $0a0e7b9537100374$var$Ve("Transition", "TransitionEnd")
}, $0a0e7b9537100374$var$Xe = {}, $0a0e7b9537100374$var$Ye = {};
$0a0e7b9537100374$var$ia && ($0a0e7b9537100374$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0a0e7b9537100374$var$We.animationend.animation, delete $0a0e7b9537100374$var$We.animationiteration.animation, delete $0a0e7b9537100374$var$We.animationstart.animation), "TransitionEvent" in window || delete $0a0e7b9537100374$var$We.transitionend.transition);
function $0a0e7b9537100374$var$Ze(a) {
    if ($0a0e7b9537100374$var$Xe[a]) return $0a0e7b9537100374$var$Xe[a];
    if (!$0a0e7b9537100374$var$We[a]) return a;
    var b = $0a0e7b9537100374$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0a0e7b9537100374$var$Ye) return $0a0e7b9537100374$var$Xe[a] = b[c];
    return a;
}
var $0a0e7b9537100374$var$$e = $0a0e7b9537100374$var$Ze("animationend"), $0a0e7b9537100374$var$af = $0a0e7b9537100374$var$Ze("animationiteration"), $0a0e7b9537100374$var$bf = $0a0e7b9537100374$var$Ze("animationstart"), $0a0e7b9537100374$var$cf = $0a0e7b9537100374$var$Ze("transitionend"), $0a0e7b9537100374$var$df = new Map, $0a0e7b9537100374$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0a0e7b9537100374$var$ff(a, b) {
    $0a0e7b9537100374$var$df.set(a, b);
    $0a0e7b9537100374$var$fa(b, [
        a
    ]);
}
for(var $0a0e7b9537100374$var$gf = 0; $0a0e7b9537100374$var$gf < $0a0e7b9537100374$var$ef.length; $0a0e7b9537100374$var$gf++){
    var $0a0e7b9537100374$var$hf = $0a0e7b9537100374$var$ef[$0a0e7b9537100374$var$gf], $0a0e7b9537100374$var$jf = $0a0e7b9537100374$var$hf.toLowerCase(), $0a0e7b9537100374$var$kf = $0a0e7b9537100374$var$hf[0].toUpperCase() + $0a0e7b9537100374$var$hf.slice(1);
    $0a0e7b9537100374$var$ff($0a0e7b9537100374$var$jf, "on" + $0a0e7b9537100374$var$kf);
}
$0a0e7b9537100374$var$ff($0a0e7b9537100374$var$$e, "onAnimationEnd");
$0a0e7b9537100374$var$ff($0a0e7b9537100374$var$af, "onAnimationIteration");
$0a0e7b9537100374$var$ff($0a0e7b9537100374$var$bf, "onAnimationStart");
$0a0e7b9537100374$var$ff("dblclick", "onDoubleClick");
$0a0e7b9537100374$var$ff("focusin", "onFocus");
$0a0e7b9537100374$var$ff("focusout", "onBlur");
$0a0e7b9537100374$var$ff($0a0e7b9537100374$var$cf, "onTransitionEnd");
$0a0e7b9537100374$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0a0e7b9537100374$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0a0e7b9537100374$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0a0e7b9537100374$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0a0e7b9537100374$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0a0e7b9537100374$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0a0e7b9537100374$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0a0e7b9537100374$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0a0e7b9537100374$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0a0e7b9537100374$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0a0e7b9537100374$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0a0e7b9537100374$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0a0e7b9537100374$var$lf));
function $0a0e7b9537100374$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0a0e7b9537100374$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0a0e7b9537100374$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0a0e7b9537100374$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0a0e7b9537100374$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0a0e7b9537100374$var$Qb) throw a = $0a0e7b9537100374$var$Rb, $0a0e7b9537100374$var$Qb = !1, $0a0e7b9537100374$var$Rb = null, a;
}
function $0a0e7b9537100374$var$D(a, b) {
    var c = b[$0a0e7b9537100374$var$of];
    void 0 === c && (c = b[$0a0e7b9537100374$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0a0e7b9537100374$var$pf(b, a, 2, !1), c.add(d));
}
function $0a0e7b9537100374$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0a0e7b9537100374$var$pf(c, a, d, b);
}
var $0a0e7b9537100374$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0a0e7b9537100374$var$sf(a) {
    if (!a[$0a0e7b9537100374$var$rf]) {
        a[$0a0e7b9537100374$var$rf] = !0;
        $0a0e7b9537100374$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0a0e7b9537100374$var$mf.has(b) || $0a0e7b9537100374$var$qf(b, !1, a), $0a0e7b9537100374$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0a0e7b9537100374$var$rf] || (b[$0a0e7b9537100374$var$rf] = !0, $0a0e7b9537100374$var$qf("selectionchange", !1, b));
    }
}
function $0a0e7b9537100374$var$pf(a, b, c, d) {
    switch($0a0e7b9537100374$var$jd(b)){
        case 1:
            var e = $0a0e7b9537100374$var$ed;
            break;
        case 4:
            e = $0a0e7b9537100374$var$gd;
            break;
        default:
            e = $0a0e7b9537100374$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0a0e7b9537100374$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0a0e7b9537100374$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0a0e7b9537100374$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0a0e7b9537100374$var$Jb(function() {
        var d = f, e = $0a0e7b9537100374$var$xb(c), g = [];
        a: {
            var h = $0a0e7b9537100374$var$df.get(a);
            if (void 0 !== h) {
                var k = $0a0e7b9537100374$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0a0e7b9537100374$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0a0e7b9537100374$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0a0e7b9537100374$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0a0e7b9537100374$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0a0e7b9537100374$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0a0e7b9537100374$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0a0e7b9537100374$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0a0e7b9537100374$var$Vd;
                        break;
                    case $0a0e7b9537100374$var$$e:
                    case $0a0e7b9537100374$var$af:
                    case $0a0e7b9537100374$var$bf:
                        k = $0a0e7b9537100374$var$Hd;
                        break;
                    case $0a0e7b9537100374$var$cf:
                        k = $0a0e7b9537100374$var$Xd;
                        break;
                    case "scroll":
                        k = $0a0e7b9537100374$var$vd;
                        break;
                    case "wheel":
                        k = $0a0e7b9537100374$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0a0e7b9537100374$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0a0e7b9537100374$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0a0e7b9537100374$var$Kb(w, x), null != F && t.push($0a0e7b9537100374$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0a0e7b9537100374$var$wb && (n = c.relatedTarget || c.fromElement) && ($0a0e7b9537100374$var$Wc(n) || n[$0a0e7b9537100374$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0a0e7b9537100374$var$Wc(n) : null, null !== n && (J = $0a0e7b9537100374$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0a0e7b9537100374$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0a0e7b9537100374$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0a0e7b9537100374$var$ue(k);
                        u = null == n ? h : $0a0e7b9537100374$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0a0e7b9537100374$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0a0e7b9537100374$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0a0e7b9537100374$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0a0e7b9537100374$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0a0e7b9537100374$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0a0e7b9537100374$var$vf(t);
                                x = $0a0e7b9537100374$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0a0e7b9537100374$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0a0e7b9537100374$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0a0e7b9537100374$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0a0e7b9537100374$var$ve;
                else if ($0a0e7b9537100374$var$me(h)) {
                    if ($0a0e7b9537100374$var$we) na = $0a0e7b9537100374$var$Fe;
                    else {
                        na = $0a0e7b9537100374$var$De;
                        var xa = $0a0e7b9537100374$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0a0e7b9537100374$var$Ee);
                if (na && (na = na(a, d))) {
                    $0a0e7b9537100374$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0a0e7b9537100374$var$cb(h, "number", h.value);
            }
            xa = d ? $0a0e7b9537100374$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0a0e7b9537100374$var$me(xa) || "true" === xa.contentEditable) $0a0e7b9537100374$var$Qe = xa, $0a0e7b9537100374$var$Re = d, $0a0e7b9537100374$var$Se = null;
                    break;
                case "focusout":
                    $0a0e7b9537100374$var$Se = $0a0e7b9537100374$var$Re = $0a0e7b9537100374$var$Qe = null;
                    break;
                case "mousedown":
                    $0a0e7b9537100374$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0a0e7b9537100374$var$Te = !1;
                    $0a0e7b9537100374$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0a0e7b9537100374$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0a0e7b9537100374$var$Ue(g, c, e);
            }
            var $a;
            if ($0a0e7b9537100374$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0a0e7b9537100374$var$ie ? $0a0e7b9537100374$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0a0e7b9537100374$var$de && "ko" !== c.locale && ($0a0e7b9537100374$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0a0e7b9537100374$var$ie && ($a = $0a0e7b9537100374$var$nd()) : ($0a0e7b9537100374$var$kd = e, $0a0e7b9537100374$var$ld = "value" in $0a0e7b9537100374$var$kd ? $0a0e7b9537100374$var$kd.value : $0a0e7b9537100374$var$kd.textContent, $0a0e7b9537100374$var$ie = !0)), xa = $0a0e7b9537100374$var$oe(d, ba), 0 < xa.length && (ba = new $0a0e7b9537100374$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0a0e7b9537100374$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0a0e7b9537100374$var$ce ? $0a0e7b9537100374$var$je(a, c) : $0a0e7b9537100374$var$ke(a, c)) d = $0a0e7b9537100374$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0a0e7b9537100374$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0a0e7b9537100374$var$se(g, b);
    });
}
function $0a0e7b9537100374$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0a0e7b9537100374$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0a0e7b9537100374$var$Kb(a, c), null != f && d.unshift($0a0e7b9537100374$var$tf(a, f, e)), f = $0a0e7b9537100374$var$Kb(a, b), null != f && d.push($0a0e7b9537100374$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0a0e7b9537100374$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0a0e7b9537100374$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0a0e7b9537100374$var$Kb(c, f), null != k && g.unshift($0a0e7b9537100374$var$tf(c, k, h))) : e || (k = $0a0e7b9537100374$var$Kb(c, f), null != k && g.push($0a0e7b9537100374$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0a0e7b9537100374$var$xf = /\r\n?/g, $0a0e7b9537100374$var$yf = /\u0000|\uFFFD/g;
function $0a0e7b9537100374$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0a0e7b9537100374$var$xf, "\n").replace($0a0e7b9537100374$var$yf, "");
}
function $0a0e7b9537100374$var$Af(a, b, c) {
    b = $0a0e7b9537100374$var$zf(b);
    if ($0a0e7b9537100374$var$zf(a) !== b && c) throw Error($0a0e7b9537100374$var$p(425));
}
function $0a0e7b9537100374$var$Bf() {}
var $0a0e7b9537100374$var$Cf = null, $0a0e7b9537100374$var$Df = null;
function $0a0e7b9537100374$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0a0e7b9537100374$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0a0e7b9537100374$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0a0e7b9537100374$var$Hf = "function" === typeof Promise ? Promise : void 0, $0a0e7b9537100374$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0a0e7b9537100374$var$Hf ? function(a) {
    return $0a0e7b9537100374$var$Hf.resolve(null).then(a).catch($0a0e7b9537100374$var$If);
} : $0a0e7b9537100374$var$Ff;
function $0a0e7b9537100374$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0a0e7b9537100374$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0a0e7b9537100374$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0a0e7b9537100374$var$bd(b);
}
function $0a0e7b9537100374$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0a0e7b9537100374$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0a0e7b9537100374$var$Nf = Math.random().toString(36).slice(2), $0a0e7b9537100374$var$Of = "__reactFiber$" + $0a0e7b9537100374$var$Nf, $0a0e7b9537100374$var$Pf = "__reactProps$" + $0a0e7b9537100374$var$Nf, $0a0e7b9537100374$var$uf = "__reactContainer$" + $0a0e7b9537100374$var$Nf, $0a0e7b9537100374$var$of = "__reactEvents$" + $0a0e7b9537100374$var$Nf, $0a0e7b9537100374$var$Qf = "__reactListeners$" + $0a0e7b9537100374$var$Nf, $0a0e7b9537100374$var$Rf = "__reactHandles$" + $0a0e7b9537100374$var$Nf;
function $0a0e7b9537100374$var$Wc(a) {
    var b = a[$0a0e7b9537100374$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0a0e7b9537100374$var$uf] || c[$0a0e7b9537100374$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0a0e7b9537100374$var$Mf(a); null !== a;){
                if (c = a[$0a0e7b9537100374$var$Of]) return c;
                a = $0a0e7b9537100374$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0a0e7b9537100374$var$Cb(a) {
    a = a[$0a0e7b9537100374$var$Of] || a[$0a0e7b9537100374$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0a0e7b9537100374$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0a0e7b9537100374$var$p(33));
}
function $0a0e7b9537100374$var$Db(a) {
    return a[$0a0e7b9537100374$var$Pf] || null;
}
var $0a0e7b9537100374$var$Sf = [], $0a0e7b9537100374$var$Tf = -1;
function $0a0e7b9537100374$var$Uf(a) {
    return {
        current: a
    };
}
function $0a0e7b9537100374$var$E(a) {
    0 > $0a0e7b9537100374$var$Tf || (a.current = $0a0e7b9537100374$var$Sf[$0a0e7b9537100374$var$Tf], $0a0e7b9537100374$var$Sf[$0a0e7b9537100374$var$Tf] = null, $0a0e7b9537100374$var$Tf--);
}
function $0a0e7b9537100374$var$G(a, b) {
    $0a0e7b9537100374$var$Tf++;
    $0a0e7b9537100374$var$Sf[$0a0e7b9537100374$var$Tf] = a.current;
    a.current = b;
}
var $0a0e7b9537100374$var$Vf = {}, $0a0e7b9537100374$var$H = $0a0e7b9537100374$var$Uf($0a0e7b9537100374$var$Vf), $0a0e7b9537100374$var$Wf = $0a0e7b9537100374$var$Uf(!1), $0a0e7b9537100374$var$Xf = $0a0e7b9537100374$var$Vf;
function $0a0e7b9537100374$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0a0e7b9537100374$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0a0e7b9537100374$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0a0e7b9537100374$var$$f() {
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf);
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$H);
}
function $0a0e7b9537100374$var$ag(a, b, c) {
    if ($0a0e7b9537100374$var$H.current !== $0a0e7b9537100374$var$Vf) throw Error($0a0e7b9537100374$var$p(168));
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$H, b);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$Wf, c);
}
function $0a0e7b9537100374$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0a0e7b9537100374$var$p(108, $0a0e7b9537100374$var$Ra(a) || "Unknown", e));
    return $0a0e7b9537100374$var$A({}, c, d);
}
function $0a0e7b9537100374$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0a0e7b9537100374$var$Vf;
    $0a0e7b9537100374$var$Xf = $0a0e7b9537100374$var$H.current;
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$H, a);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$Wf, $0a0e7b9537100374$var$Wf.current);
    return !0;
}
function $0a0e7b9537100374$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0a0e7b9537100374$var$p(169));
    c ? (a = $0a0e7b9537100374$var$bg(a, b, $0a0e7b9537100374$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf), $0a0e7b9537100374$var$E($0a0e7b9537100374$var$H), $0a0e7b9537100374$var$G($0a0e7b9537100374$var$H, a)) : $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$Wf, c);
}
var $0a0e7b9537100374$var$eg = null, $0a0e7b9537100374$var$fg = !1, $0a0e7b9537100374$var$gg = !1;
function $0a0e7b9537100374$var$hg(a) {
    null === $0a0e7b9537100374$var$eg ? $0a0e7b9537100374$var$eg = [
        a
    ] : $0a0e7b9537100374$var$eg.push(a);
}
function $0a0e7b9537100374$var$ig(a) {
    $0a0e7b9537100374$var$fg = !0;
    $0a0e7b9537100374$var$hg(a);
}
function $0a0e7b9537100374$var$jg() {
    if (!$0a0e7b9537100374$var$gg && null !== $0a0e7b9537100374$var$eg) {
        $0a0e7b9537100374$var$gg = !0;
        var a = 0, b = $0a0e7b9537100374$var$C;
        try {
            var c = $0a0e7b9537100374$var$eg;
            for($0a0e7b9537100374$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0a0e7b9537100374$var$eg = null;
            $0a0e7b9537100374$var$fg = !1;
        } catch (e) {
            throw null !== $0a0e7b9537100374$var$eg && ($0a0e7b9537100374$var$eg = $0a0e7b9537100374$var$eg.slice(a + 1)), $0a0e7b9537100374$var$ac($0a0e7b9537100374$var$fc, $0a0e7b9537100374$var$jg), e;
        } finally{
            $0a0e7b9537100374$var$C = b, $0a0e7b9537100374$var$gg = !1;
        }
    }
    return null;
}
var $0a0e7b9537100374$var$kg = [], $0a0e7b9537100374$var$lg = 0, $0a0e7b9537100374$var$mg = null, $0a0e7b9537100374$var$ng = 0, $0a0e7b9537100374$var$og = [], $0a0e7b9537100374$var$pg = 0, $0a0e7b9537100374$var$qg = null, $0a0e7b9537100374$var$rg = 1, $0a0e7b9537100374$var$sg = "";
function $0a0e7b9537100374$var$tg(a, b) {
    $0a0e7b9537100374$var$kg[$0a0e7b9537100374$var$lg++] = $0a0e7b9537100374$var$ng;
    $0a0e7b9537100374$var$kg[$0a0e7b9537100374$var$lg++] = $0a0e7b9537100374$var$mg;
    $0a0e7b9537100374$var$mg = a;
    $0a0e7b9537100374$var$ng = b;
}
function $0a0e7b9537100374$var$ug(a, b, c) {
    $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$rg;
    $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$sg;
    $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$qg;
    $0a0e7b9537100374$var$qg = a;
    var d = $0a0e7b9537100374$var$rg;
    a = $0a0e7b9537100374$var$sg;
    var e = 32 - $0a0e7b9537100374$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0a0e7b9537100374$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0a0e7b9537100374$var$rg = 1 << 32 - $0a0e7b9537100374$var$oc(b) + e | c << e | d;
        $0a0e7b9537100374$var$sg = f + a;
    } else $0a0e7b9537100374$var$rg = 1 << f | c << e | d, $0a0e7b9537100374$var$sg = a;
}
function $0a0e7b9537100374$var$vg(a) {
    null !== a.return && ($0a0e7b9537100374$var$tg(a, 1), $0a0e7b9537100374$var$ug(a, 1, 0));
}
function $0a0e7b9537100374$var$wg(a) {
    for(; a === $0a0e7b9537100374$var$mg;)$0a0e7b9537100374$var$mg = $0a0e7b9537100374$var$kg[--$0a0e7b9537100374$var$lg], $0a0e7b9537100374$var$kg[$0a0e7b9537100374$var$lg] = null, $0a0e7b9537100374$var$ng = $0a0e7b9537100374$var$kg[--$0a0e7b9537100374$var$lg], $0a0e7b9537100374$var$kg[$0a0e7b9537100374$var$lg] = null;
    for(; a === $0a0e7b9537100374$var$qg;)$0a0e7b9537100374$var$qg = $0a0e7b9537100374$var$og[--$0a0e7b9537100374$var$pg], $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg] = null, $0a0e7b9537100374$var$sg = $0a0e7b9537100374$var$og[--$0a0e7b9537100374$var$pg], $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg] = null, $0a0e7b9537100374$var$rg = $0a0e7b9537100374$var$og[--$0a0e7b9537100374$var$pg], $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg] = null;
}
var $0a0e7b9537100374$var$xg = null, $0a0e7b9537100374$var$yg = null, $0a0e7b9537100374$var$I = !1, $0a0e7b9537100374$var$zg = null;
function $0a0e7b9537100374$var$Ag(a, b) {
    var c = $0a0e7b9537100374$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0a0e7b9537100374$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0a0e7b9537100374$var$xg = a, $0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0a0e7b9537100374$var$xg = a, $0a0e7b9537100374$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0a0e7b9537100374$var$qg ? {
                id: $0a0e7b9537100374$var$rg,
                overflow: $0a0e7b9537100374$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0a0e7b9537100374$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0a0e7b9537100374$var$xg = a, $0a0e7b9537100374$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0a0e7b9537100374$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0a0e7b9537100374$var$Eg(a) {
    if ($0a0e7b9537100374$var$I) {
        var b = $0a0e7b9537100374$var$yg;
        if (b) {
            var c = b;
            if (!$0a0e7b9537100374$var$Cg(a, b)) {
                if ($0a0e7b9537100374$var$Dg(a)) throw Error($0a0e7b9537100374$var$p(418));
                b = $0a0e7b9537100374$var$Lf(c.nextSibling);
                var d = $0a0e7b9537100374$var$xg;
                b && $0a0e7b9537100374$var$Cg(a, b) ? $0a0e7b9537100374$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0a0e7b9537100374$var$I = !1, $0a0e7b9537100374$var$xg = a);
            }
        } else {
            if ($0a0e7b9537100374$var$Dg(a)) throw Error($0a0e7b9537100374$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0a0e7b9537100374$var$I = !1;
            $0a0e7b9537100374$var$xg = a;
        }
    }
}
function $0a0e7b9537100374$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0a0e7b9537100374$var$xg = a;
}
function $0a0e7b9537100374$var$Gg(a) {
    if (a !== $0a0e7b9537100374$var$xg) return !1;
    if (!$0a0e7b9537100374$var$I) return $0a0e7b9537100374$var$Fg(a), $0a0e7b9537100374$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0a0e7b9537100374$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0a0e7b9537100374$var$yg)) {
        if ($0a0e7b9537100374$var$Dg(a)) throw $0a0e7b9537100374$var$Hg(), Error($0a0e7b9537100374$var$p(418));
        for(; b;)$0a0e7b9537100374$var$Ag(a, b), b = $0a0e7b9537100374$var$Lf(b.nextSibling);
    }
    $0a0e7b9537100374$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0a0e7b9537100374$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0a0e7b9537100374$var$yg = null;
        }
    } else $0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$xg ? $0a0e7b9537100374$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0a0e7b9537100374$var$Hg() {
    for(var a = $0a0e7b9537100374$var$yg; a;)a = $0a0e7b9537100374$var$Lf(a.nextSibling);
}
function $0a0e7b9537100374$var$Ig() {
    $0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$xg = null;
    $0a0e7b9537100374$var$I = !1;
}
function $0a0e7b9537100374$var$Jg(a) {
    null === $0a0e7b9537100374$var$zg ? $0a0e7b9537100374$var$zg = [
        a
    ] : $0a0e7b9537100374$var$zg.push(a);
}
var $0a0e7b9537100374$var$Kg = $0a0e7b9537100374$var$ua.ReactCurrentBatchConfig;
function $0a0e7b9537100374$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0a0e7b9537100374$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0a0e7b9537100374$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0a0e7b9537100374$var$p(284));
        if (!c._owner) throw Error($0a0e7b9537100374$var$p(290, a));
    }
    return a;
}
function $0a0e7b9537100374$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0a0e7b9537100374$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0a0e7b9537100374$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0a0e7b9537100374$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0a0e7b9537100374$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0a0e7b9537100374$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0a0e7b9537100374$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0a0e7b9537100374$var$Ha && $0a0e7b9537100374$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0a0e7b9537100374$var$Lg(a, b, c), d.return = a, d;
        d = $0a0e7b9537100374$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0a0e7b9537100374$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0a0e7b9537100374$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0a0e7b9537100374$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0a0e7b9537100374$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0a0e7b9537100374$var$va:
                    return c = $0a0e7b9537100374$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0a0e7b9537100374$var$Lg(a, null, b), c.return = a, c;
                case $0a0e7b9537100374$var$wa:
                    return b = $0a0e7b9537100374$var$Sg(b, a.mode, c), b.return = a, b;
                case $0a0e7b9537100374$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0a0e7b9537100374$var$eb(b) || $0a0e7b9537100374$var$Ka(b)) return b = $0a0e7b9537100374$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0a0e7b9537100374$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0a0e7b9537100374$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0a0e7b9537100374$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0a0e7b9537100374$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0a0e7b9537100374$var$eb(c) || $0a0e7b9537100374$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0a0e7b9537100374$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0a0e7b9537100374$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0a0e7b9537100374$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0a0e7b9537100374$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0a0e7b9537100374$var$eb(d) || $0a0e7b9537100374$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0a0e7b9537100374$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0a0e7b9537100374$var$Ka(h);
        if ("function" !== typeof l) throw Error($0a0e7b9537100374$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0a0e7b9537100374$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0a0e7b9537100374$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0a0e7b9537100374$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0a0e7b9537100374$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0a0e7b9537100374$var$Ha && $0a0e7b9537100374$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0a0e7b9537100374$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0a0e7b9537100374$var$ya ? (d = $0a0e7b9537100374$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0a0e7b9537100374$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0a0e7b9537100374$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0a0e7b9537100374$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0a0e7b9537100374$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0a0e7b9537100374$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0a0e7b9537100374$var$eb(f)) return n(a, d, f, h);
            if ($0a0e7b9537100374$var$Ka(f)) return t(a, d, f, h);
            $0a0e7b9537100374$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0a0e7b9537100374$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0a0e7b9537100374$var$Ug = $0a0e7b9537100374$var$Og(!0), $0a0e7b9537100374$var$Vg = $0a0e7b9537100374$var$Og(!1), $0a0e7b9537100374$var$Wg = $0a0e7b9537100374$var$Uf(null), $0a0e7b9537100374$var$Xg = null, $0a0e7b9537100374$var$Yg = null, $0a0e7b9537100374$var$Zg = null;
function $0a0e7b9537100374$var$$g() {
    $0a0e7b9537100374$var$Zg = $0a0e7b9537100374$var$Yg = $0a0e7b9537100374$var$Xg = null;
}
function $0a0e7b9537100374$var$ah(a) {
    var b = $0a0e7b9537100374$var$Wg.current;
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wg);
    a._currentValue = b;
}
function $0a0e7b9537100374$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0a0e7b9537100374$var$ch(a, b) {
    $0a0e7b9537100374$var$Xg = a;
    $0a0e7b9537100374$var$Zg = $0a0e7b9537100374$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0a0e7b9537100374$var$dh = !0), a.firstContext = null);
}
function $0a0e7b9537100374$var$eh(a) {
    var b = a._currentValue;
    if ($0a0e7b9537100374$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0a0e7b9537100374$var$Yg) {
            if (null === $0a0e7b9537100374$var$Xg) throw Error($0a0e7b9537100374$var$p(308));
            $0a0e7b9537100374$var$Yg = a;
            $0a0e7b9537100374$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0a0e7b9537100374$var$Yg = $0a0e7b9537100374$var$Yg.next = a;
    }
    return b;
}
var $0a0e7b9537100374$var$fh = null;
function $0a0e7b9537100374$var$gh(a) {
    null === $0a0e7b9537100374$var$fh ? $0a0e7b9537100374$var$fh = [
        a
    ] : $0a0e7b9537100374$var$fh.push(a);
}
function $0a0e7b9537100374$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0a0e7b9537100374$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0a0e7b9537100374$var$ih(a, d);
}
function $0a0e7b9537100374$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0a0e7b9537100374$var$jh = !1;
function $0a0e7b9537100374$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0a0e7b9537100374$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0a0e7b9537100374$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0a0e7b9537100374$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0a0e7b9537100374$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0a0e7b9537100374$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0a0e7b9537100374$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0a0e7b9537100374$var$ih(a, c);
}
function $0a0e7b9537100374$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0a0e7b9537100374$var$Cc(a, c);
    }
}
function $0a0e7b9537100374$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0a0e7b9537100374$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0a0e7b9537100374$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0a0e7b9537100374$var$A({}, q, r);
                            break a;
                        case 2:
                            $0a0e7b9537100374$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0a0e7b9537100374$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0a0e7b9537100374$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0a0e7b9537100374$var$p(191, e));
            e.call(d);
        }
    }
}
var $0a0e7b9537100374$var$th = {}, $0a0e7b9537100374$var$uh = $0a0e7b9537100374$var$Uf($0a0e7b9537100374$var$th), $0a0e7b9537100374$var$vh = $0a0e7b9537100374$var$Uf($0a0e7b9537100374$var$th), $0a0e7b9537100374$var$wh = $0a0e7b9537100374$var$Uf($0a0e7b9537100374$var$th);
function $0a0e7b9537100374$var$xh(a) {
    if (a === $0a0e7b9537100374$var$th) throw Error($0a0e7b9537100374$var$p(174));
    return a;
}
function $0a0e7b9537100374$var$yh(a, b) {
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$wh, b);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$vh, a);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$uh, $0a0e7b9537100374$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0a0e7b9537100374$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0a0e7b9537100374$var$lb(b, a);
    }
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$uh);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$uh, b);
}
function $0a0e7b9537100374$var$zh() {
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$uh);
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$vh);
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$wh);
}
function $0a0e7b9537100374$var$Ah(a) {
    $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$wh.current);
    var b = $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$uh.current);
    var c = $0a0e7b9537100374$var$lb(b, a.type);
    b !== c && ($0a0e7b9537100374$var$G($0a0e7b9537100374$var$vh, a), $0a0e7b9537100374$var$G($0a0e7b9537100374$var$uh, c));
}
function $0a0e7b9537100374$var$Bh(a) {
    $0a0e7b9537100374$var$vh.current === a && ($0a0e7b9537100374$var$E($0a0e7b9537100374$var$uh), $0a0e7b9537100374$var$E($0a0e7b9537100374$var$vh));
}
var $0a0e7b9537100374$var$L = $0a0e7b9537100374$var$Uf(0);
function $0a0e7b9537100374$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0a0e7b9537100374$var$Dh = [];
function $0a0e7b9537100374$var$Eh() {
    for(var a = 0; a < $0a0e7b9537100374$var$Dh.length; a++)$0a0e7b9537100374$var$Dh[a]._workInProgressVersionPrimary = null;
    $0a0e7b9537100374$var$Dh.length = 0;
}
var $0a0e7b9537100374$var$Fh = $0a0e7b9537100374$var$ua.ReactCurrentDispatcher, $0a0e7b9537100374$var$Gh = $0a0e7b9537100374$var$ua.ReactCurrentBatchConfig, $0a0e7b9537100374$var$Hh = 0, $0a0e7b9537100374$var$M = null, $0a0e7b9537100374$var$N = null, $0a0e7b9537100374$var$O = null, $0a0e7b9537100374$var$Ih = !1, $0a0e7b9537100374$var$Jh = !1, $0a0e7b9537100374$var$Kh = 0, $0a0e7b9537100374$var$Lh = 0;
function $0a0e7b9537100374$var$P() {
    throw Error($0a0e7b9537100374$var$p(321));
}
function $0a0e7b9537100374$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0a0e7b9537100374$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0a0e7b9537100374$var$Nh(a, b, c, d, e, f) {
    $0a0e7b9537100374$var$Hh = f;
    $0a0e7b9537100374$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0a0e7b9537100374$var$Fh.current = null === a || null === a.memoizedState ? $0a0e7b9537100374$var$Oh : $0a0e7b9537100374$var$Ph;
    a = c(d, e);
    if ($0a0e7b9537100374$var$Jh) {
        f = 0;
        do {
            $0a0e7b9537100374$var$Jh = !1;
            $0a0e7b9537100374$var$Kh = 0;
            if (25 <= f) throw Error($0a0e7b9537100374$var$p(301));
            f += 1;
            $0a0e7b9537100374$var$O = $0a0e7b9537100374$var$N = null;
            b.updateQueue = null;
            $0a0e7b9537100374$var$Fh.current = $0a0e7b9537100374$var$Qh;
            a = c(d, e);
        }while ($0a0e7b9537100374$var$Jh);
    }
    $0a0e7b9537100374$var$Fh.current = $0a0e7b9537100374$var$Rh;
    b = null !== $0a0e7b9537100374$var$N && null !== $0a0e7b9537100374$var$N.next;
    $0a0e7b9537100374$var$Hh = 0;
    $0a0e7b9537100374$var$O = $0a0e7b9537100374$var$N = $0a0e7b9537100374$var$M = null;
    $0a0e7b9537100374$var$Ih = !1;
    if (b) throw Error($0a0e7b9537100374$var$p(300));
    return a;
}
function $0a0e7b9537100374$var$Sh() {
    var a = 0 !== $0a0e7b9537100374$var$Kh;
    $0a0e7b9537100374$var$Kh = 0;
    return a;
}
function $0a0e7b9537100374$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0a0e7b9537100374$var$O ? $0a0e7b9537100374$var$M.memoizedState = $0a0e7b9537100374$var$O = a : $0a0e7b9537100374$var$O = $0a0e7b9537100374$var$O.next = a;
    return $0a0e7b9537100374$var$O;
}
function $0a0e7b9537100374$var$Uh() {
    if (null === $0a0e7b9537100374$var$N) {
        var a = $0a0e7b9537100374$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0a0e7b9537100374$var$N.next;
    var b = null === $0a0e7b9537100374$var$O ? $0a0e7b9537100374$var$M.memoizedState : $0a0e7b9537100374$var$O.next;
    if (null !== b) $0a0e7b9537100374$var$O = b, $0a0e7b9537100374$var$N = a;
    else {
        if (null === a) throw Error($0a0e7b9537100374$var$p(310));
        $0a0e7b9537100374$var$N = a;
        a = {
            memoizedState: $0a0e7b9537100374$var$N.memoizedState,
            baseState: $0a0e7b9537100374$var$N.baseState,
            baseQueue: $0a0e7b9537100374$var$N.baseQueue,
            queue: $0a0e7b9537100374$var$N.queue,
            next: null
        };
        null === $0a0e7b9537100374$var$O ? $0a0e7b9537100374$var$M.memoizedState = $0a0e7b9537100374$var$O = a : $0a0e7b9537100374$var$O = $0a0e7b9537100374$var$O.next = a;
    }
    return $0a0e7b9537100374$var$O;
}
function $0a0e7b9537100374$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0a0e7b9537100374$var$Wh(a) {
    var b = $0a0e7b9537100374$var$Uh(), c = b.queue;
    if (null === c) throw Error($0a0e7b9537100374$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0a0e7b9537100374$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0a0e7b9537100374$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0a0e7b9537100374$var$M.lanes |= m;
                $0a0e7b9537100374$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0a0e7b9537100374$var$He(d, b.memoizedState) || ($0a0e7b9537100374$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0a0e7b9537100374$var$M.lanes |= f, $0a0e7b9537100374$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0a0e7b9537100374$var$Xh(a) {
    var b = $0a0e7b9537100374$var$Uh(), c = b.queue;
    if (null === c) throw Error($0a0e7b9537100374$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0a0e7b9537100374$var$He(f, b.memoizedState) || ($0a0e7b9537100374$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0a0e7b9537100374$var$Yh() {}
function $0a0e7b9537100374$var$Zh(a, b) {
    var c = $0a0e7b9537100374$var$M, d = $0a0e7b9537100374$var$Uh(), e = b(), f = !$0a0e7b9537100374$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0a0e7b9537100374$var$dh = !0);
    d = d.queue;
    $0a0e7b9537100374$var$$h($0a0e7b9537100374$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0a0e7b9537100374$var$O && $0a0e7b9537100374$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0a0e7b9537100374$var$bi(9, $0a0e7b9537100374$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0a0e7b9537100374$var$Q) throw Error($0a0e7b9537100374$var$p(349));
        0 !== ($0a0e7b9537100374$var$Hh & 30) || $0a0e7b9537100374$var$di(c, b, e);
    }
    return e;
}
function $0a0e7b9537100374$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0a0e7b9537100374$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0a0e7b9537100374$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0a0e7b9537100374$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0a0e7b9537100374$var$ei(b) && $0a0e7b9537100374$var$fi(a);
}
function $0a0e7b9537100374$var$ai(a, b, c) {
    return c(function() {
        $0a0e7b9537100374$var$ei(b) && $0a0e7b9537100374$var$fi(a);
    });
}
function $0a0e7b9537100374$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0a0e7b9537100374$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0a0e7b9537100374$var$fi(a) {
    var b = $0a0e7b9537100374$var$ih(a, 1);
    null !== b && $0a0e7b9537100374$var$gi(b, a, 1, -1);
}
function $0a0e7b9537100374$var$hi(a) {
    var b = $0a0e7b9537100374$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0a0e7b9537100374$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0a0e7b9537100374$var$ii.bind(null, $0a0e7b9537100374$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0a0e7b9537100374$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0a0e7b9537100374$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0a0e7b9537100374$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0a0e7b9537100374$var$ji() {
    return $0a0e7b9537100374$var$Uh().memoizedState;
}
function $0a0e7b9537100374$var$ki(a, b, c, d) {
    var e = $0a0e7b9537100374$var$Th();
    $0a0e7b9537100374$var$M.flags |= a;
    e.memoizedState = $0a0e7b9537100374$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0a0e7b9537100374$var$li(a, b, c, d) {
    var e = $0a0e7b9537100374$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0a0e7b9537100374$var$N) {
        var g = $0a0e7b9537100374$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0a0e7b9537100374$var$Mh(d, g.deps)) {
            e.memoizedState = $0a0e7b9537100374$var$bi(b, c, f, d);
            return;
        }
    }
    $0a0e7b9537100374$var$M.flags |= a;
    e.memoizedState = $0a0e7b9537100374$var$bi(1 | b, c, f, d);
}
function $0a0e7b9537100374$var$mi(a, b) {
    return $0a0e7b9537100374$var$ki(8390656, 8, a, b);
}
function $0a0e7b9537100374$var$$h(a, b) {
    return $0a0e7b9537100374$var$li(2048, 8, a, b);
}
function $0a0e7b9537100374$var$ni(a, b) {
    return $0a0e7b9537100374$var$li(4, 2, a, b);
}
function $0a0e7b9537100374$var$oi(a, b) {
    return $0a0e7b9537100374$var$li(4, 4, a, b);
}
function $0a0e7b9537100374$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0a0e7b9537100374$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0a0e7b9537100374$var$li(4, 4, $0a0e7b9537100374$var$pi.bind(null, b, a), c);
}
function $0a0e7b9537100374$var$ri() {}
function $0a0e7b9537100374$var$si(a, b) {
    var c = $0a0e7b9537100374$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0a0e7b9537100374$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0a0e7b9537100374$var$ti(a, b) {
    var c = $0a0e7b9537100374$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0a0e7b9537100374$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0a0e7b9537100374$var$ui(a, b, c) {
    if (0 === ($0a0e7b9537100374$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0a0e7b9537100374$var$dh = !0), a.memoizedState = c;
    $0a0e7b9537100374$var$He(c, b) || (c = $0a0e7b9537100374$var$yc(), $0a0e7b9537100374$var$M.lanes |= c, $0a0e7b9537100374$var$rh |= c, a.baseState = !0);
    return b;
}
function $0a0e7b9537100374$var$vi(a, b) {
    var c = $0a0e7b9537100374$var$C;
    $0a0e7b9537100374$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0a0e7b9537100374$var$Gh.transition;
    $0a0e7b9537100374$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0a0e7b9537100374$var$C = c, $0a0e7b9537100374$var$Gh.transition = d;
    }
}
function $0a0e7b9537100374$var$wi() {
    return $0a0e7b9537100374$var$Uh().memoizedState;
}
function $0a0e7b9537100374$var$xi(a, b, c) {
    var d = $0a0e7b9537100374$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0a0e7b9537100374$var$zi(a)) $0a0e7b9537100374$var$Ai(b, c);
    else if (c = $0a0e7b9537100374$var$hh(a, b, c, d), null !== c) {
        var e = $0a0e7b9537100374$var$R();
        $0a0e7b9537100374$var$gi(c, a, d, e);
        $0a0e7b9537100374$var$Bi(c, b, d);
    }
}
function $0a0e7b9537100374$var$ii(a, b, c) {
    var d = $0a0e7b9537100374$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0a0e7b9537100374$var$zi(a)) $0a0e7b9537100374$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0a0e7b9537100374$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0a0e7b9537100374$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0a0e7b9537100374$var$hh(a, b, e, d);
        null !== c && (e = $0a0e7b9537100374$var$R(), $0a0e7b9537100374$var$gi(c, a, d, e), $0a0e7b9537100374$var$Bi(c, b, d));
    }
}
function $0a0e7b9537100374$var$zi(a) {
    var b = a.alternate;
    return a === $0a0e7b9537100374$var$M || null !== b && b === $0a0e7b9537100374$var$M;
}
function $0a0e7b9537100374$var$Ai(a, b) {
    $0a0e7b9537100374$var$Jh = $0a0e7b9537100374$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0a0e7b9537100374$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0a0e7b9537100374$var$Cc(a, c);
    }
}
var $0a0e7b9537100374$var$Rh = {
    readContext: $0a0e7b9537100374$var$eh,
    useCallback: $0a0e7b9537100374$var$P,
    useContext: $0a0e7b9537100374$var$P,
    useEffect: $0a0e7b9537100374$var$P,
    useImperativeHandle: $0a0e7b9537100374$var$P,
    useInsertionEffect: $0a0e7b9537100374$var$P,
    useLayoutEffect: $0a0e7b9537100374$var$P,
    useMemo: $0a0e7b9537100374$var$P,
    useReducer: $0a0e7b9537100374$var$P,
    useRef: $0a0e7b9537100374$var$P,
    useState: $0a0e7b9537100374$var$P,
    useDebugValue: $0a0e7b9537100374$var$P,
    useDeferredValue: $0a0e7b9537100374$var$P,
    useTransition: $0a0e7b9537100374$var$P,
    useMutableSource: $0a0e7b9537100374$var$P,
    useSyncExternalStore: $0a0e7b9537100374$var$P,
    useId: $0a0e7b9537100374$var$P,
    unstable_isNewReconciler: !1
}, $0a0e7b9537100374$var$Oh = {
    readContext: $0a0e7b9537100374$var$eh,
    useCallback: function(a, b) {
        $0a0e7b9537100374$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0a0e7b9537100374$var$eh,
    useEffect: $0a0e7b9537100374$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0a0e7b9537100374$var$ki(4194308, 4, $0a0e7b9537100374$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0a0e7b9537100374$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0a0e7b9537100374$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0a0e7b9537100374$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0a0e7b9537100374$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0a0e7b9537100374$var$xi.bind(null, $0a0e7b9537100374$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0a0e7b9537100374$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0a0e7b9537100374$var$hi,
    useDebugValue: $0a0e7b9537100374$var$ri,
    useDeferredValue: function(a) {
        return $0a0e7b9537100374$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0a0e7b9537100374$var$hi(!1), b = a[0];
        a = $0a0e7b9537100374$var$vi.bind(null, a[1]);
        $0a0e7b9537100374$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0a0e7b9537100374$var$M, e = $0a0e7b9537100374$var$Th();
        if ($0a0e7b9537100374$var$I) {
            if (void 0 === c) throw Error($0a0e7b9537100374$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0a0e7b9537100374$var$Q) throw Error($0a0e7b9537100374$var$p(349));
            0 !== ($0a0e7b9537100374$var$Hh & 30) || $0a0e7b9537100374$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0a0e7b9537100374$var$mi($0a0e7b9537100374$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0a0e7b9537100374$var$bi(9, $0a0e7b9537100374$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0a0e7b9537100374$var$Th(), b = $0a0e7b9537100374$var$Q.identifierPrefix;
        if ($0a0e7b9537100374$var$I) {
            var c = $0a0e7b9537100374$var$sg;
            var d = $0a0e7b9537100374$var$rg;
            c = (d & ~(1 << 32 - $0a0e7b9537100374$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0a0e7b9537100374$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0a0e7b9537100374$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0a0e7b9537100374$var$Ph = {
    readContext: $0a0e7b9537100374$var$eh,
    useCallback: $0a0e7b9537100374$var$si,
    useContext: $0a0e7b9537100374$var$eh,
    useEffect: $0a0e7b9537100374$var$$h,
    useImperativeHandle: $0a0e7b9537100374$var$qi,
    useInsertionEffect: $0a0e7b9537100374$var$ni,
    useLayoutEffect: $0a0e7b9537100374$var$oi,
    useMemo: $0a0e7b9537100374$var$ti,
    useReducer: $0a0e7b9537100374$var$Wh,
    useRef: $0a0e7b9537100374$var$ji,
    useState: function() {
        return $0a0e7b9537100374$var$Wh($0a0e7b9537100374$var$Vh);
    },
    useDebugValue: $0a0e7b9537100374$var$ri,
    useDeferredValue: function(a) {
        var b = $0a0e7b9537100374$var$Uh();
        return $0a0e7b9537100374$var$ui(b, $0a0e7b9537100374$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0a0e7b9537100374$var$Wh($0a0e7b9537100374$var$Vh)[0], b = $0a0e7b9537100374$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0a0e7b9537100374$var$Yh,
    useSyncExternalStore: $0a0e7b9537100374$var$Zh,
    useId: $0a0e7b9537100374$var$wi,
    unstable_isNewReconciler: !1
}, $0a0e7b9537100374$var$Qh = {
    readContext: $0a0e7b9537100374$var$eh,
    useCallback: $0a0e7b9537100374$var$si,
    useContext: $0a0e7b9537100374$var$eh,
    useEffect: $0a0e7b9537100374$var$$h,
    useImperativeHandle: $0a0e7b9537100374$var$qi,
    useInsertionEffect: $0a0e7b9537100374$var$ni,
    useLayoutEffect: $0a0e7b9537100374$var$oi,
    useMemo: $0a0e7b9537100374$var$ti,
    useReducer: $0a0e7b9537100374$var$Xh,
    useRef: $0a0e7b9537100374$var$ji,
    useState: function() {
        return $0a0e7b9537100374$var$Xh($0a0e7b9537100374$var$Vh);
    },
    useDebugValue: $0a0e7b9537100374$var$ri,
    useDeferredValue: function(a) {
        var b = $0a0e7b9537100374$var$Uh();
        return null === $0a0e7b9537100374$var$N ? b.memoizedState = a : $0a0e7b9537100374$var$ui(b, $0a0e7b9537100374$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0a0e7b9537100374$var$Xh($0a0e7b9537100374$var$Vh)[0], b = $0a0e7b9537100374$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0a0e7b9537100374$var$Yh,
    useSyncExternalStore: $0a0e7b9537100374$var$Zh,
    useId: $0a0e7b9537100374$var$wi,
    unstable_isNewReconciler: !1
};
function $0a0e7b9537100374$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0a0e7b9537100374$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0a0e7b9537100374$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0a0e7b9537100374$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0a0e7b9537100374$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0a0e7b9537100374$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0a0e7b9537100374$var$R(), e = $0a0e7b9537100374$var$yi(a), f = $0a0e7b9537100374$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0a0e7b9537100374$var$nh(a, f, e);
        null !== b && ($0a0e7b9537100374$var$gi(b, a, e, d), $0a0e7b9537100374$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0a0e7b9537100374$var$R(), e = $0a0e7b9537100374$var$yi(a), f = $0a0e7b9537100374$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0a0e7b9537100374$var$nh(a, f, e);
        null !== b && ($0a0e7b9537100374$var$gi(b, a, e, d), $0a0e7b9537100374$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0a0e7b9537100374$var$R(), d = $0a0e7b9537100374$var$yi(a), e = $0a0e7b9537100374$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0a0e7b9537100374$var$nh(a, e, d);
        null !== b && ($0a0e7b9537100374$var$gi(b, a, d, c), $0a0e7b9537100374$var$oh(b, a, d));
    }
};
function $0a0e7b9537100374$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0a0e7b9537100374$var$Ie(c, d) || !$0a0e7b9537100374$var$Ie(e, f) : !0;
}
function $0a0e7b9537100374$var$Gi(a, b, c) {
    var d = !1, e = $0a0e7b9537100374$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0a0e7b9537100374$var$eh(f) : (e = $0a0e7b9537100374$var$Zf(b) ? $0a0e7b9537100374$var$Xf : $0a0e7b9537100374$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0a0e7b9537100374$var$Yf(a, e) : $0a0e7b9537100374$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0a0e7b9537100374$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0a0e7b9537100374$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0a0e7b9537100374$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0a0e7b9537100374$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0a0e7b9537100374$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0a0e7b9537100374$var$eh(f) : (f = $0a0e7b9537100374$var$Zf(b) ? $0a0e7b9537100374$var$Xf : $0a0e7b9537100374$var$H.current, e.context = $0a0e7b9537100374$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0a0e7b9537100374$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0a0e7b9537100374$var$Ei.enqueueReplaceState(e, e.state, null), $0a0e7b9537100374$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0a0e7b9537100374$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0a0e7b9537100374$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0a0e7b9537100374$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0a0e7b9537100374$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0a0e7b9537100374$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0a0e7b9537100374$var$Ni(a, b, c) {
    c = $0a0e7b9537100374$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0a0e7b9537100374$var$Oi || ($0a0e7b9537100374$var$Oi = !0, $0a0e7b9537100374$var$Pi = d);
        $0a0e7b9537100374$var$Li(a, b);
    };
    return c;
}
function $0a0e7b9537100374$var$Qi(a, b, c) {
    c = $0a0e7b9537100374$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0a0e7b9537100374$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0a0e7b9537100374$var$Li(a, b);
        "function" !== typeof d && (null === $0a0e7b9537100374$var$Ri ? $0a0e7b9537100374$var$Ri = new Set([
            this
        ]) : $0a0e7b9537100374$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0a0e7b9537100374$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0a0e7b9537100374$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0a0e7b9537100374$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0a0e7b9537100374$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0a0e7b9537100374$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0a0e7b9537100374$var$mh(-1, 1), b.tag = 2, $0a0e7b9537100374$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0a0e7b9537100374$var$Wi = $0a0e7b9537100374$var$ua.ReactCurrentOwner, $0a0e7b9537100374$var$dh = !1;
function $0a0e7b9537100374$var$Xi(a, b, c, d) {
    b.child = null === a ? $0a0e7b9537100374$var$Vg(b, null, c, d) : $0a0e7b9537100374$var$Ug(b, a.child, c, d);
}
function $0a0e7b9537100374$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0a0e7b9537100374$var$ch(b, e);
    d = $0a0e7b9537100374$var$Nh(a, b, c, d, f, e);
    c = $0a0e7b9537100374$var$Sh();
    if (null !== a && !$0a0e7b9537100374$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0a0e7b9537100374$var$Zi(a, b, e);
    $0a0e7b9537100374$var$I && c && $0a0e7b9537100374$var$vg(b);
    b.flags |= 1;
    $0a0e7b9537100374$var$Xi(a, b, d, e);
    return b.child;
}
function $0a0e7b9537100374$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0a0e7b9537100374$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0a0e7b9537100374$var$bj(a, b, f, d, e);
        a = $0a0e7b9537100374$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0a0e7b9537100374$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0a0e7b9537100374$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0a0e7b9537100374$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0a0e7b9537100374$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0a0e7b9537100374$var$Ie(f, d) && a.ref === b.ref) {
            if ($0a0e7b9537100374$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0a0e7b9537100374$var$dh = !0);
            else return b.lanes = a.lanes, $0a0e7b9537100374$var$Zi(a, b, e);
        }
    }
    return $0a0e7b9537100374$var$cj(a, b, c, d, e);
}
function $0a0e7b9537100374$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0a0e7b9537100374$var$G($0a0e7b9537100374$var$ej, $0a0e7b9537100374$var$fj), $0a0e7b9537100374$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0a0e7b9537100374$var$G($0a0e7b9537100374$var$ej, $0a0e7b9537100374$var$fj), $0a0e7b9537100374$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0a0e7b9537100374$var$G($0a0e7b9537100374$var$ej, $0a0e7b9537100374$var$fj);
            $0a0e7b9537100374$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0a0e7b9537100374$var$G($0a0e7b9537100374$var$ej, $0a0e7b9537100374$var$fj), $0a0e7b9537100374$var$fj |= d;
    $0a0e7b9537100374$var$Xi(a, b, e, c);
    return b.child;
}
function $0a0e7b9537100374$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0a0e7b9537100374$var$cj(a, b, c, d, e) {
    var f = $0a0e7b9537100374$var$Zf(c) ? $0a0e7b9537100374$var$Xf : $0a0e7b9537100374$var$H.current;
    f = $0a0e7b9537100374$var$Yf(b, f);
    $0a0e7b9537100374$var$ch(b, e);
    c = $0a0e7b9537100374$var$Nh(a, b, c, d, f, e);
    d = $0a0e7b9537100374$var$Sh();
    if (null !== a && !$0a0e7b9537100374$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0a0e7b9537100374$var$Zi(a, b, e);
    $0a0e7b9537100374$var$I && d && $0a0e7b9537100374$var$vg(b);
    b.flags |= 1;
    $0a0e7b9537100374$var$Xi(a, b, c, e);
    return b.child;
}
function $0a0e7b9537100374$var$hj(a, b, c, d, e) {
    if ($0a0e7b9537100374$var$Zf(c)) {
        var f = !0;
        $0a0e7b9537100374$var$cg(b);
    } else f = !1;
    $0a0e7b9537100374$var$ch(b, e);
    if (null === b.stateNode) $0a0e7b9537100374$var$ij(a, b), $0a0e7b9537100374$var$Gi(b, c, d), $0a0e7b9537100374$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0a0e7b9537100374$var$eh(l) : (l = $0a0e7b9537100374$var$Zf(c) ? $0a0e7b9537100374$var$Xf : $0a0e7b9537100374$var$H.current, l = $0a0e7b9537100374$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0a0e7b9537100374$var$Hi(b, g, d, l);
        $0a0e7b9537100374$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0a0e7b9537100374$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0a0e7b9537100374$var$Wf.current || $0a0e7b9537100374$var$jh ? ("function" === typeof m && ($0a0e7b9537100374$var$Di(b, c, m, d), k = b.memoizedState), (h = $0a0e7b9537100374$var$jh || $0a0e7b9537100374$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0a0e7b9537100374$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0a0e7b9537100374$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0a0e7b9537100374$var$eh(k) : (k = $0a0e7b9537100374$var$Zf(c) ? $0a0e7b9537100374$var$Xf : $0a0e7b9537100374$var$H.current, k = $0a0e7b9537100374$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0a0e7b9537100374$var$Hi(b, g, d, k);
        $0a0e7b9537100374$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0a0e7b9537100374$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0a0e7b9537100374$var$Wf.current || $0a0e7b9537100374$var$jh ? ("function" === typeof y && ($0a0e7b9537100374$var$Di(b, c, y, d), n = b.memoizedState), (l = $0a0e7b9537100374$var$jh || $0a0e7b9537100374$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0a0e7b9537100374$var$jj(a, b, c, d, f, e);
}
function $0a0e7b9537100374$var$jj(a, b, c, d, e, f) {
    $0a0e7b9537100374$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0a0e7b9537100374$var$dg(b, c, !1), $0a0e7b9537100374$var$Zi(a, b, f);
    d = b.stateNode;
    $0a0e7b9537100374$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0a0e7b9537100374$var$Ug(b, a.child, null, f), b.child = $0a0e7b9537100374$var$Ug(b, null, h, f)) : $0a0e7b9537100374$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0a0e7b9537100374$var$dg(b, c, !0);
    return b.child;
}
function $0a0e7b9537100374$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0a0e7b9537100374$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0a0e7b9537100374$var$ag(a, b.context, !1);
    $0a0e7b9537100374$var$yh(a, b.containerInfo);
}
function $0a0e7b9537100374$var$lj(a, b, c, d, e) {
    $0a0e7b9537100374$var$Ig();
    $0a0e7b9537100374$var$Jg(e);
    b.flags |= 256;
    $0a0e7b9537100374$var$Xi(a, b, c, d);
    return b.child;
}
var $0a0e7b9537100374$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0a0e7b9537100374$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0a0e7b9537100374$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0a0e7b9537100374$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, e & 1);
    if (null === a) {
        $0a0e7b9537100374$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0a0e7b9537100374$var$pj(g, d, 0, null), a = $0a0e7b9537100374$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0a0e7b9537100374$var$nj(c), b.memoizedState = $0a0e7b9537100374$var$mj, a) : $0a0e7b9537100374$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0a0e7b9537100374$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0a0e7b9537100374$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0a0e7b9537100374$var$Pg(h, f) : (f = $0a0e7b9537100374$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0a0e7b9537100374$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0a0e7b9537100374$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0a0e7b9537100374$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0a0e7b9537100374$var$qj(a, b) {
    b = $0a0e7b9537100374$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0a0e7b9537100374$var$sj(a, b, c, d) {
    null !== d && $0a0e7b9537100374$var$Jg(d);
    $0a0e7b9537100374$var$Ug(b, a.child, null, c);
    a = $0a0e7b9537100374$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0a0e7b9537100374$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0a0e7b9537100374$var$Ki(Error($0a0e7b9537100374$var$p(422))), $0a0e7b9537100374$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0a0e7b9537100374$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0a0e7b9537100374$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0a0e7b9537100374$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0a0e7b9537100374$var$nj(g);
        b.memoizedState = $0a0e7b9537100374$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0a0e7b9537100374$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0a0e7b9537100374$var$p(419));
        d = $0a0e7b9537100374$var$Ki(f, d, void 0);
        return $0a0e7b9537100374$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0a0e7b9537100374$var$dh || h) {
        d = $0a0e7b9537100374$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0a0e7b9537100374$var$ih(a, e), $0a0e7b9537100374$var$gi(d, a, e, -1));
        }
        $0a0e7b9537100374$var$tj();
        d = $0a0e7b9537100374$var$Ki(Error($0a0e7b9537100374$var$p(421)));
        return $0a0e7b9537100374$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0a0e7b9537100374$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$Lf(e.nextSibling);
    $0a0e7b9537100374$var$xg = b;
    $0a0e7b9537100374$var$I = !0;
    $0a0e7b9537100374$var$zg = null;
    null !== a && ($0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$rg, $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$sg, $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$qg, $0a0e7b9537100374$var$rg = a.id, $0a0e7b9537100374$var$sg = a.overflow, $0a0e7b9537100374$var$qg = b);
    b = $0a0e7b9537100374$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0a0e7b9537100374$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0a0e7b9537100374$var$bh(a.return, b, c);
}
function $0a0e7b9537100374$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0a0e7b9537100374$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0a0e7b9537100374$var$Xi(a, b, d.children, c);
    d = $0a0e7b9537100374$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0a0e7b9537100374$var$vj(a, c, b);
            else if (19 === a.tag) $0a0e7b9537100374$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0a0e7b9537100374$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0a0e7b9537100374$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0a0e7b9537100374$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0a0e7b9537100374$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0a0e7b9537100374$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0a0e7b9537100374$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0a0e7b9537100374$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0a0e7b9537100374$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0a0e7b9537100374$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0a0e7b9537100374$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0a0e7b9537100374$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0a0e7b9537100374$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0a0e7b9537100374$var$kj(b);
            $0a0e7b9537100374$var$Ig();
            break;
        case 5:
            $0a0e7b9537100374$var$Ah(b);
            break;
        case 1:
            $0a0e7b9537100374$var$Zf(b.type) && $0a0e7b9537100374$var$cg(b);
            break;
        case 4:
            $0a0e7b9537100374$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0a0e7b9537100374$var$G($0a0e7b9537100374$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, $0a0e7b9537100374$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0a0e7b9537100374$var$oj(a, b, c);
                $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, $0a0e7b9537100374$var$L.current & 1);
                a = $0a0e7b9537100374$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, $0a0e7b9537100374$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0a0e7b9537100374$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, $0a0e7b9537100374$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0a0e7b9537100374$var$dj(a, b, c);
    }
    return $0a0e7b9537100374$var$Zi(a, b, c);
}
var $0a0e7b9537100374$var$zj, $0a0e7b9537100374$var$Aj, $0a0e7b9537100374$var$Bj, $0a0e7b9537100374$var$Cj;
$0a0e7b9537100374$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0a0e7b9537100374$var$Aj = function() {};
$0a0e7b9537100374$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0a0e7b9537100374$var$Ya(a, e);
                d = $0a0e7b9537100374$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0a0e7b9537100374$var$A({}, e, {
                    value: void 0
                });
                d = $0a0e7b9537100374$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0a0e7b9537100374$var$gb(a, e);
                d = $0a0e7b9537100374$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0a0e7b9537100374$var$Bf);
        }
        $0a0e7b9537100374$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0a0e7b9537100374$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0a0e7b9537100374$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0a0e7b9537100374$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0a0e7b9537100374$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0a0e7b9537100374$var$Dj(a, b) {
    if (!$0a0e7b9537100374$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0a0e7b9537100374$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0a0e7b9537100374$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0a0e7b9537100374$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0a0e7b9537100374$var$S(b), null;
        case 1:
            return $0a0e7b9537100374$var$Zf(b.type) && $0a0e7b9537100374$var$$f(), $0a0e7b9537100374$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0a0e7b9537100374$var$zh();
            $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf);
            $0a0e7b9537100374$var$E($0a0e7b9537100374$var$H);
            $0a0e7b9537100374$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0a0e7b9537100374$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0a0e7b9537100374$var$zg && ($0a0e7b9537100374$var$Fj($0a0e7b9537100374$var$zg), $0a0e7b9537100374$var$zg = null));
            $0a0e7b9537100374$var$Aj(a, b);
            $0a0e7b9537100374$var$S(b);
            return null;
        case 5:
            $0a0e7b9537100374$var$Bh(b);
            var e = $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0a0e7b9537100374$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0a0e7b9537100374$var$p(166));
                    $0a0e7b9537100374$var$S(b);
                    return null;
                }
                a = $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$uh.current);
                if ($0a0e7b9537100374$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0a0e7b9537100374$var$Of] = b;
                    d[$0a0e7b9537100374$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0a0e7b9537100374$var$D("cancel", d);
                            $0a0e7b9537100374$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0a0e7b9537100374$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0a0e7b9537100374$var$lf.length; e++)$0a0e7b9537100374$var$D($0a0e7b9537100374$var$lf[e], d);
                            break;
                        case "source":
                            $0a0e7b9537100374$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0a0e7b9537100374$var$D("error", d);
                            $0a0e7b9537100374$var$D("load", d);
                            break;
                        case "details":
                            $0a0e7b9537100374$var$D("toggle", d);
                            break;
                        case "input":
                            $0a0e7b9537100374$var$Za(d, f);
                            $0a0e7b9537100374$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0a0e7b9537100374$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0a0e7b9537100374$var$hb(d, f), $0a0e7b9537100374$var$D("invalid", d);
                    }
                    $0a0e7b9537100374$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0a0e7b9537100374$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0a0e7b9537100374$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0a0e7b9537100374$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0a0e7b9537100374$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0a0e7b9537100374$var$Va(d);
                            $0a0e7b9537100374$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0a0e7b9537100374$var$Va(d);
                            $0a0e7b9537100374$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0a0e7b9537100374$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0a0e7b9537100374$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0a0e7b9537100374$var$Of] = b;
                    a[$0a0e7b9537100374$var$Pf] = d;
                    $0a0e7b9537100374$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0a0e7b9537100374$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0a0e7b9537100374$var$D("cancel", a);
                                $0a0e7b9537100374$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0a0e7b9537100374$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0a0e7b9537100374$var$lf.length; e++)$0a0e7b9537100374$var$D($0a0e7b9537100374$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0a0e7b9537100374$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0a0e7b9537100374$var$D("error", a);
                                $0a0e7b9537100374$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0a0e7b9537100374$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0a0e7b9537100374$var$Za(a, d);
                                e = $0a0e7b9537100374$var$Ya(a, d);
                                $0a0e7b9537100374$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0a0e7b9537100374$var$A({}, d, {
                                    value: void 0
                                });
                                $0a0e7b9537100374$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0a0e7b9537100374$var$hb(a, d);
                                e = $0a0e7b9537100374$var$gb(a, d);
                                $0a0e7b9537100374$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0a0e7b9537100374$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0a0e7b9537100374$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0a0e7b9537100374$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0a0e7b9537100374$var$ob(a, k) : "number" === typeof k && $0a0e7b9537100374$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0a0e7b9537100374$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0a0e7b9537100374$var$D("scroll", a) : null != k && $0a0e7b9537100374$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0a0e7b9537100374$var$Va(a);
                                $0a0e7b9537100374$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0a0e7b9537100374$var$Va(a);
                                $0a0e7b9537100374$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0a0e7b9537100374$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0a0e7b9537100374$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0a0e7b9537100374$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0a0e7b9537100374$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0a0e7b9537100374$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0a0e7b9537100374$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0a0e7b9537100374$var$p(166));
                c = $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$wh.current);
                $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$uh.current);
                if ($0a0e7b9537100374$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0a0e7b9537100374$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0a0e7b9537100374$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0a0e7b9537100374$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0a0e7b9537100374$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0a0e7b9537100374$var$Of] = b, b.stateNode = d;
            }
            $0a0e7b9537100374$var$S(b);
            return null;
        case 13:
            $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0a0e7b9537100374$var$I && null !== $0a0e7b9537100374$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0a0e7b9537100374$var$Hg(), $0a0e7b9537100374$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0a0e7b9537100374$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0a0e7b9537100374$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0a0e7b9537100374$var$p(317));
                        f[$0a0e7b9537100374$var$Of] = b;
                    } else $0a0e7b9537100374$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0a0e7b9537100374$var$S(b);
                    f = !1;
                } else null !== $0a0e7b9537100374$var$zg && ($0a0e7b9537100374$var$Fj($0a0e7b9537100374$var$zg), $0a0e7b9537100374$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0a0e7b9537100374$var$L.current & 1) ? 0 === $0a0e7b9537100374$var$T && ($0a0e7b9537100374$var$T = 3) : $0a0e7b9537100374$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0a0e7b9537100374$var$S(b);
            return null;
        case 4:
            return $0a0e7b9537100374$var$zh(), $0a0e7b9537100374$var$Aj(a, b), null === a && $0a0e7b9537100374$var$sf(b.stateNode.containerInfo), $0a0e7b9537100374$var$S(b), null;
        case 10:
            return $0a0e7b9537100374$var$ah(b.type._context), $0a0e7b9537100374$var$S(b), null;
        case 17:
            return $0a0e7b9537100374$var$Zf(b.type) && $0a0e7b9537100374$var$$f(), $0a0e7b9537100374$var$S(b), null;
        case 19:
            $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L);
            f = b.memoizedState;
            if (null === f) return $0a0e7b9537100374$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0a0e7b9537100374$var$Dj(f, !1);
                else {
                    if (0 !== $0a0e7b9537100374$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0a0e7b9537100374$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0a0e7b9537100374$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, $0a0e7b9537100374$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0a0e7b9537100374$var$B() > $0a0e7b9537100374$var$Gj && (b.flags |= 128, d = !0, $0a0e7b9537100374$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0a0e7b9537100374$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0a0e7b9537100374$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0a0e7b9537100374$var$I) return $0a0e7b9537100374$var$S(b), null;
                    } else 2 * $0a0e7b9537100374$var$B() - f.renderingStartTime > $0a0e7b9537100374$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0a0e7b9537100374$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0a0e7b9537100374$var$B(), b.sibling = null, c = $0a0e7b9537100374$var$L.current, $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, d ? c & 1 | 2 : c & 1), b;
            $0a0e7b9537100374$var$S(b);
            return null;
        case 22:
        case 23:
            return $0a0e7b9537100374$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0a0e7b9537100374$var$fj & 1073741824) && ($0a0e7b9537100374$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0a0e7b9537100374$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0a0e7b9537100374$var$p(156, b.tag));
}
function $0a0e7b9537100374$var$Ij(a, b) {
    $0a0e7b9537100374$var$wg(b);
    switch(b.tag){
        case 1:
            return $0a0e7b9537100374$var$Zf(b.type) && $0a0e7b9537100374$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0a0e7b9537100374$var$zh(), $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf), $0a0e7b9537100374$var$E($0a0e7b9537100374$var$H), $0a0e7b9537100374$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0a0e7b9537100374$var$Bh(b), null;
        case 13:
            $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0a0e7b9537100374$var$p(340));
                $0a0e7b9537100374$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L), null;
        case 4:
            return $0a0e7b9537100374$var$zh(), null;
        case 10:
            return $0a0e7b9537100374$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0a0e7b9537100374$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0a0e7b9537100374$var$Jj = !1, $0a0e7b9537100374$var$U = !1, $0a0e7b9537100374$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0a0e7b9537100374$var$V = null;
function $0a0e7b9537100374$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0a0e7b9537100374$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0a0e7b9537100374$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0a0e7b9537100374$var$W(a, b, d);
    }
}
var $0a0e7b9537100374$var$Nj = !1;
function $0a0e7b9537100374$var$Oj(a, b) {
    $0a0e7b9537100374$var$Cf = $0a0e7b9537100374$var$dd;
    a = $0a0e7b9537100374$var$Me();
    if ($0a0e7b9537100374$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0a0e7b9537100374$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0a0e7b9537100374$var$dd = !1;
    for($0a0e7b9537100374$var$V = b; null !== $0a0e7b9537100374$var$V;)if (b = $0a0e7b9537100374$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0a0e7b9537100374$var$V = a;
    else for(; null !== $0a0e7b9537100374$var$V;){
        b = $0a0e7b9537100374$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0a0e7b9537100374$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0a0e7b9537100374$var$p(163));
            }
        } catch (F) {
            $0a0e7b9537100374$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0a0e7b9537100374$var$V = a;
            break;
        }
        $0a0e7b9537100374$var$V = b.return;
    }
    n = $0a0e7b9537100374$var$Nj;
    $0a0e7b9537100374$var$Nj = !1;
    return n;
}
function $0a0e7b9537100374$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0a0e7b9537100374$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0a0e7b9537100374$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0a0e7b9537100374$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0a0e7b9537100374$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0a0e7b9537100374$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0a0e7b9537100374$var$Of], delete b[$0a0e7b9537100374$var$Pf], delete b[$0a0e7b9537100374$var$of], delete b[$0a0e7b9537100374$var$Qf], delete b[$0a0e7b9537100374$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0a0e7b9537100374$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0a0e7b9537100374$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0a0e7b9537100374$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0a0e7b9537100374$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0a0e7b9537100374$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0a0e7b9537100374$var$Vj(a, b, c), a = a.sibling; null !== a;)$0a0e7b9537100374$var$Vj(a, b, c), a = a.sibling;
}
function $0a0e7b9537100374$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0a0e7b9537100374$var$Wj(a, b, c), a = a.sibling; null !== a;)$0a0e7b9537100374$var$Wj(a, b, c), a = a.sibling;
}
var $0a0e7b9537100374$var$X = null, $0a0e7b9537100374$var$Xj = !1;
function $0a0e7b9537100374$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0a0e7b9537100374$var$Zj(a, b, c), c = c.sibling;
}
function $0a0e7b9537100374$var$Zj(a, b, c) {
    if ($0a0e7b9537100374$var$lc && "function" === typeof $0a0e7b9537100374$var$lc.onCommitFiberUnmount) try {
        $0a0e7b9537100374$var$lc.onCommitFiberUnmount($0a0e7b9537100374$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0a0e7b9537100374$var$U || $0a0e7b9537100374$var$Lj(c, b);
        case 6:
            var d = $0a0e7b9537100374$var$X, e = $0a0e7b9537100374$var$Xj;
            $0a0e7b9537100374$var$X = null;
            $0a0e7b9537100374$var$Yj(a, b, c);
            $0a0e7b9537100374$var$X = d;
            $0a0e7b9537100374$var$Xj = e;
            null !== $0a0e7b9537100374$var$X && ($0a0e7b9537100374$var$Xj ? (a = $0a0e7b9537100374$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0a0e7b9537100374$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0a0e7b9537100374$var$X && ($0a0e7b9537100374$var$Xj ? (a = $0a0e7b9537100374$var$X, c = c.stateNode, 8 === a.nodeType ? $0a0e7b9537100374$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0a0e7b9537100374$var$Kf(a, c), $0a0e7b9537100374$var$bd(a)) : $0a0e7b9537100374$var$Kf($0a0e7b9537100374$var$X, c.stateNode));
            break;
        case 4:
            d = $0a0e7b9537100374$var$X;
            e = $0a0e7b9537100374$var$Xj;
            $0a0e7b9537100374$var$X = c.stateNode.containerInfo;
            $0a0e7b9537100374$var$Xj = !0;
            $0a0e7b9537100374$var$Yj(a, b, c);
            $0a0e7b9537100374$var$X = d;
            $0a0e7b9537100374$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0a0e7b9537100374$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0a0e7b9537100374$var$Mj(c, b, g) : 0 !== (f & 4) && $0a0e7b9537100374$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0a0e7b9537100374$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0a0e7b9537100374$var$U && ($0a0e7b9537100374$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0a0e7b9537100374$var$W(c, b, h);
            }
            $0a0e7b9537100374$var$Yj(a, b, c);
            break;
        case 21:
            $0a0e7b9537100374$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0a0e7b9537100374$var$U = (d = $0a0e7b9537100374$var$U) || null !== c.memoizedState, $0a0e7b9537100374$var$Yj(a, b, c), $0a0e7b9537100374$var$U = d) : $0a0e7b9537100374$var$Yj(a, b, c);
            break;
        default:
            $0a0e7b9537100374$var$Yj(a, b, c);
    }
}
function $0a0e7b9537100374$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0a0e7b9537100374$var$Kj);
        b.forEach(function(b) {
            var d = $0a0e7b9537100374$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0a0e7b9537100374$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0a0e7b9537100374$var$X = h.stateNode;
                        $0a0e7b9537100374$var$Xj = !1;
                        break a;
                    case 3:
                        $0a0e7b9537100374$var$X = h.stateNode.containerInfo;
                        $0a0e7b9537100374$var$Xj = !0;
                        break a;
                    case 4:
                        $0a0e7b9537100374$var$X = h.stateNode.containerInfo;
                        $0a0e7b9537100374$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0a0e7b9537100374$var$X) throw Error($0a0e7b9537100374$var$p(160));
            $0a0e7b9537100374$var$Zj(f, g, e);
            $0a0e7b9537100374$var$X = null;
            $0a0e7b9537100374$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0a0e7b9537100374$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0a0e7b9537100374$var$dk(b, a), b = b.sibling;
}
function $0a0e7b9537100374$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            if (d & 4) {
                try {
                    $0a0e7b9537100374$var$Pj(3, a, a.return), $0a0e7b9537100374$var$Qj(3, a);
                } catch (t) {
                    $0a0e7b9537100374$var$W(a, a.return, t);
                }
                try {
                    $0a0e7b9537100374$var$Pj(5, a, a.return);
                } catch (t) {
                    $0a0e7b9537100374$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            d & 512 && null !== c && $0a0e7b9537100374$var$Lj(c, c.return);
            break;
        case 5:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            d & 512 && null !== c && $0a0e7b9537100374$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0a0e7b9537100374$var$ob(e, "");
                } catch (t) {
                    $0a0e7b9537100374$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0a0e7b9537100374$var$ab(e, f);
                    $0a0e7b9537100374$var$vb(h, g);
                    var l = $0a0e7b9537100374$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0a0e7b9537100374$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0a0e7b9537100374$var$nb(e, q) : "children" === m ? $0a0e7b9537100374$var$ob(e, q) : $0a0e7b9537100374$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0a0e7b9537100374$var$bb(e, f);
                            break;
                        case "textarea":
                            $0a0e7b9537100374$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0a0e7b9537100374$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0a0e7b9537100374$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0a0e7b9537100374$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0a0e7b9537100374$var$Pf] = f;
                } catch (t) {
                    $0a0e7b9537100374$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0a0e7b9537100374$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0a0e7b9537100374$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0a0e7b9537100374$var$bd(b.containerInfo);
            } catch (t) {
                $0a0e7b9537100374$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            break;
        case 13:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0a0e7b9537100374$var$fk = $0a0e7b9537100374$var$B()));
            d & 4 && $0a0e7b9537100374$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0a0e7b9537100374$var$U = (l = $0a0e7b9537100374$var$U) || m, $0a0e7b9537100374$var$ck(b, a), $0a0e7b9537100374$var$U = l) : $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0a0e7b9537100374$var$V = a, m = a.child; null !== m;){
                    for(q = $0a0e7b9537100374$var$V = m; null !== $0a0e7b9537100374$var$V;){
                        r = $0a0e7b9537100374$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0a0e7b9537100374$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0a0e7b9537100374$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0a0e7b9537100374$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0a0e7b9537100374$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0a0e7b9537100374$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0a0e7b9537100374$var$V = y) : $0a0e7b9537100374$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0a0e7b9537100374$var$rb("display", g));
                            } catch (t) {
                                $0a0e7b9537100374$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0a0e7b9537100374$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            d & 4 && $0a0e7b9537100374$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0a0e7b9537100374$var$ck(b, a), $0a0e7b9537100374$var$ek(a);
    }
}
function $0a0e7b9537100374$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0a0e7b9537100374$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0a0e7b9537100374$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0a0e7b9537100374$var$ob(e, ""), d.flags &= -33);
                    var f = $0a0e7b9537100374$var$Uj(a);
                    $0a0e7b9537100374$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0a0e7b9537100374$var$Uj(a);
                    $0a0e7b9537100374$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0a0e7b9537100374$var$p(161));
            }
        } catch (k) {
            $0a0e7b9537100374$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0a0e7b9537100374$var$hk(a, b, c) {
    $0a0e7b9537100374$var$V = a;
    $0a0e7b9537100374$var$ik(a, b, c);
}
function $0a0e7b9537100374$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0a0e7b9537100374$var$V;){
        var e = $0a0e7b9537100374$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0a0e7b9537100374$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0a0e7b9537100374$var$U;
                h = $0a0e7b9537100374$var$Jj;
                var l = $0a0e7b9537100374$var$U;
                $0a0e7b9537100374$var$Jj = g;
                if (($0a0e7b9537100374$var$U = k) && !l) for($0a0e7b9537100374$var$V = e; null !== $0a0e7b9537100374$var$V;)g = $0a0e7b9537100374$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0a0e7b9537100374$var$jk(e) : null !== k ? (k.return = g, $0a0e7b9537100374$var$V = k) : $0a0e7b9537100374$var$jk(e);
                for(; null !== f;)$0a0e7b9537100374$var$V = f, $0a0e7b9537100374$var$ik(f, b, c), f = f.sibling;
                $0a0e7b9537100374$var$V = e;
                $0a0e7b9537100374$var$Jj = h;
                $0a0e7b9537100374$var$U = l;
            }
            $0a0e7b9537100374$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0a0e7b9537100374$var$V = f) : $0a0e7b9537100374$var$kk(a, b, c);
    }
}
function $0a0e7b9537100374$var$kk(a) {
    for(; null !== $0a0e7b9537100374$var$V;){
        var b = $0a0e7b9537100374$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0a0e7b9537100374$var$U || $0a0e7b9537100374$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0a0e7b9537100374$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0a0e7b9537100374$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0a0e7b9537100374$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0a0e7b9537100374$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0a0e7b9537100374$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0a0e7b9537100374$var$p(163));
                }
                $0a0e7b9537100374$var$U || b.flags & 512 && $0a0e7b9537100374$var$Rj(b);
            } catch (r) {
                $0a0e7b9537100374$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0a0e7b9537100374$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0a0e7b9537100374$var$V = c;
            break;
        }
        $0a0e7b9537100374$var$V = b.return;
    }
}
function $0a0e7b9537100374$var$gk(a) {
    for(; null !== $0a0e7b9537100374$var$V;){
        var b = $0a0e7b9537100374$var$V;
        if (b === a) {
            $0a0e7b9537100374$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0a0e7b9537100374$var$V = c;
            break;
        }
        $0a0e7b9537100374$var$V = b.return;
    }
}
function $0a0e7b9537100374$var$jk(a) {
    for(; null !== $0a0e7b9537100374$var$V;){
        var b = $0a0e7b9537100374$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0a0e7b9537100374$var$Qj(4, b);
                    } catch (k) {
                        $0a0e7b9537100374$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0a0e7b9537100374$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0a0e7b9537100374$var$Rj(b);
                    } catch (k) {
                        $0a0e7b9537100374$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0a0e7b9537100374$var$Rj(b);
                    } catch (k) {
                        $0a0e7b9537100374$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0a0e7b9537100374$var$W(b, b.return, k);
        }
        if (b === a) {
            $0a0e7b9537100374$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0a0e7b9537100374$var$V = h;
            break;
        }
        $0a0e7b9537100374$var$V = b.return;
    }
}
var $0a0e7b9537100374$var$lk = Math.ceil, $0a0e7b9537100374$var$mk = $0a0e7b9537100374$var$ua.ReactCurrentDispatcher, $0a0e7b9537100374$var$nk = $0a0e7b9537100374$var$ua.ReactCurrentOwner, $0a0e7b9537100374$var$ok = $0a0e7b9537100374$var$ua.ReactCurrentBatchConfig, $0a0e7b9537100374$var$K = 0, $0a0e7b9537100374$var$Q = null, $0a0e7b9537100374$var$Y = null, $0a0e7b9537100374$var$Z = 0, $0a0e7b9537100374$var$fj = 0, $0a0e7b9537100374$var$ej = $0a0e7b9537100374$var$Uf(0), $0a0e7b9537100374$var$T = 0, $0a0e7b9537100374$var$pk = null, $0a0e7b9537100374$var$rh = 0, $0a0e7b9537100374$var$qk = 0, $0a0e7b9537100374$var$rk = 0, $0a0e7b9537100374$var$sk = null, $0a0e7b9537100374$var$tk = null, $0a0e7b9537100374$var$fk = 0, $0a0e7b9537100374$var$Gj = Infinity, $0a0e7b9537100374$var$uk = null, $0a0e7b9537100374$var$Oi = !1, $0a0e7b9537100374$var$Pi = null, $0a0e7b9537100374$var$Ri = null, $0a0e7b9537100374$var$vk = !1, $0a0e7b9537100374$var$wk = null, $0a0e7b9537100374$var$xk = 0, $0a0e7b9537100374$var$yk = 0, $0a0e7b9537100374$var$zk = null, $0a0e7b9537100374$var$Ak = -1, $0a0e7b9537100374$var$Bk = 0;
function $0a0e7b9537100374$var$R() {
    return 0 !== ($0a0e7b9537100374$var$K & 6) ? $0a0e7b9537100374$var$B() : -1 !== $0a0e7b9537100374$var$Ak ? $0a0e7b9537100374$var$Ak : $0a0e7b9537100374$var$Ak = $0a0e7b9537100374$var$B();
}
function $0a0e7b9537100374$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0a0e7b9537100374$var$K & 2) && 0 !== $0a0e7b9537100374$var$Z) return $0a0e7b9537100374$var$Z & -$0a0e7b9537100374$var$Z;
    if (null !== $0a0e7b9537100374$var$Kg.transition) return 0 === $0a0e7b9537100374$var$Bk && ($0a0e7b9537100374$var$Bk = $0a0e7b9537100374$var$yc()), $0a0e7b9537100374$var$Bk;
    a = $0a0e7b9537100374$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0a0e7b9537100374$var$jd(a.type);
    return a;
}
function $0a0e7b9537100374$var$gi(a, b, c, d) {
    if (50 < $0a0e7b9537100374$var$yk) throw $0a0e7b9537100374$var$yk = 0, $0a0e7b9537100374$var$zk = null, Error($0a0e7b9537100374$var$p(185));
    $0a0e7b9537100374$var$Ac(a, c, d);
    if (0 === ($0a0e7b9537100374$var$K & 2) || a !== $0a0e7b9537100374$var$Q) a === $0a0e7b9537100374$var$Q && (0 === ($0a0e7b9537100374$var$K & 2) && ($0a0e7b9537100374$var$qk |= c), 4 === $0a0e7b9537100374$var$T && $0a0e7b9537100374$var$Ck(a, $0a0e7b9537100374$var$Z)), $0a0e7b9537100374$var$Dk(a, d), 1 === c && 0 === $0a0e7b9537100374$var$K && 0 === (b.mode & 1) && ($0a0e7b9537100374$var$Gj = $0a0e7b9537100374$var$B() + 500, $0a0e7b9537100374$var$fg && $0a0e7b9537100374$var$jg());
}
function $0a0e7b9537100374$var$Dk(a, b) {
    var c = a.callbackNode;
    $0a0e7b9537100374$var$wc(a, b);
    var d = $0a0e7b9537100374$var$uc(a, a === $0a0e7b9537100374$var$Q ? $0a0e7b9537100374$var$Z : 0);
    if (0 === d) null !== c && $0a0e7b9537100374$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0a0e7b9537100374$var$bc(c);
        if (1 === b) 0 === a.tag ? $0a0e7b9537100374$var$ig($0a0e7b9537100374$var$Ek.bind(null, a)) : $0a0e7b9537100374$var$hg($0a0e7b9537100374$var$Ek.bind(null, a)), $0a0e7b9537100374$var$Jf(function() {
            0 === ($0a0e7b9537100374$var$K & 6) && $0a0e7b9537100374$var$jg();
        }), c = null;
        else {
            switch($0a0e7b9537100374$var$Dc(d)){
                case 1:
                    c = $0a0e7b9537100374$var$fc;
                    break;
                case 4:
                    c = $0a0e7b9537100374$var$gc;
                    break;
                case 16:
                    c = $0a0e7b9537100374$var$hc;
                    break;
                case 536870912:
                    c = $0a0e7b9537100374$var$jc;
                    break;
                default:
                    c = $0a0e7b9537100374$var$hc;
            }
            c = $0a0e7b9537100374$var$Fk(c, $0a0e7b9537100374$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0a0e7b9537100374$var$Gk(a, b) {
    $0a0e7b9537100374$var$Ak = -1;
    $0a0e7b9537100374$var$Bk = 0;
    if (0 !== ($0a0e7b9537100374$var$K & 6)) throw Error($0a0e7b9537100374$var$p(327));
    var c = a.callbackNode;
    if ($0a0e7b9537100374$var$Hk() && a.callbackNode !== c) return null;
    var d = $0a0e7b9537100374$var$uc(a, a === $0a0e7b9537100374$var$Q ? $0a0e7b9537100374$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0a0e7b9537100374$var$Ik(a, d);
    else {
        b = d;
        var e = $0a0e7b9537100374$var$K;
        $0a0e7b9537100374$var$K |= 2;
        var f = $0a0e7b9537100374$var$Jk();
        if ($0a0e7b9537100374$var$Q !== a || $0a0e7b9537100374$var$Z !== b) $0a0e7b9537100374$var$uk = null, $0a0e7b9537100374$var$Gj = $0a0e7b9537100374$var$B() + 500, $0a0e7b9537100374$var$Kk(a, b);
        for(;;)try {
            $0a0e7b9537100374$var$Lk();
            break;
        } catch (h) {
            $0a0e7b9537100374$var$Mk(a, h);
        }
        $0a0e7b9537100374$var$$g();
        $0a0e7b9537100374$var$mk.current = f;
        $0a0e7b9537100374$var$K = e;
        null !== $0a0e7b9537100374$var$Y ? b = 0 : ($0a0e7b9537100374$var$Q = null, $0a0e7b9537100374$var$Z = 0, b = $0a0e7b9537100374$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0a0e7b9537100374$var$xc(a), 0 !== e && (d = e, b = $0a0e7b9537100374$var$Nk(a, e)));
        if (1 === b) throw c = $0a0e7b9537100374$var$pk, $0a0e7b9537100374$var$Kk(a, 0), $0a0e7b9537100374$var$Ck(a, d), $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B()), c;
        if (6 === b) $0a0e7b9537100374$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0a0e7b9537100374$var$Ok(e) && (b = $0a0e7b9537100374$var$Ik(a, d), 2 === b && (f = $0a0e7b9537100374$var$xc(a), 0 !== f && (d = f, b = $0a0e7b9537100374$var$Nk(a, f))), 1 === b)) throw c = $0a0e7b9537100374$var$pk, $0a0e7b9537100374$var$Kk(a, 0), $0a0e7b9537100374$var$Ck(a, d), $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0a0e7b9537100374$var$p(345));
                case 2:
                    $0a0e7b9537100374$var$Pk(a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk);
                    break;
                case 3:
                    $0a0e7b9537100374$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0a0e7b9537100374$var$fk + 500 - $0a0e7b9537100374$var$B(), 10 < b)) {
                        if (0 !== $0a0e7b9537100374$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0a0e7b9537100374$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0a0e7b9537100374$var$Ff($0a0e7b9537100374$var$Pk.bind(null, a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk), b);
                        break;
                    }
                    $0a0e7b9537100374$var$Pk(a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk);
                    break;
                case 4:
                    $0a0e7b9537100374$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0a0e7b9537100374$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0a0e7b9537100374$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0a0e7b9537100374$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0a0e7b9537100374$var$Ff($0a0e7b9537100374$var$Pk.bind(null, a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk), d);
                        break;
                    }
                    $0a0e7b9537100374$var$Pk(a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk);
                    break;
                case 5:
                    $0a0e7b9537100374$var$Pk(a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk);
                    break;
                default:
                    throw Error($0a0e7b9537100374$var$p(329));
            }
        }
    }
    $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B());
    return a.callbackNode === c ? $0a0e7b9537100374$var$Gk.bind(null, a) : null;
}
function $0a0e7b9537100374$var$Nk(a, b) {
    var c = $0a0e7b9537100374$var$sk;
    a.current.memoizedState.isDehydrated && ($0a0e7b9537100374$var$Kk(a, b).flags |= 256);
    a = $0a0e7b9537100374$var$Ik(a, b);
    2 !== a && (b = $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$tk = c, null !== b && $0a0e7b9537100374$var$Fj(b));
    return a;
}
function $0a0e7b9537100374$var$Fj(a) {
    null === $0a0e7b9537100374$var$tk ? $0a0e7b9537100374$var$tk = a : $0a0e7b9537100374$var$tk.push.apply($0a0e7b9537100374$var$tk, a);
}
function $0a0e7b9537100374$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0a0e7b9537100374$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0a0e7b9537100374$var$Ck(a, b) {
    b &= ~$0a0e7b9537100374$var$rk;
    b &= ~$0a0e7b9537100374$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0a0e7b9537100374$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0a0e7b9537100374$var$Ek(a) {
    if (0 !== ($0a0e7b9537100374$var$K & 6)) throw Error($0a0e7b9537100374$var$p(327));
    $0a0e7b9537100374$var$Hk();
    var b = $0a0e7b9537100374$var$uc(a, 0);
    if (0 === (b & 1)) return $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B()), null;
    var c = $0a0e7b9537100374$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0a0e7b9537100374$var$xc(a);
        0 !== d && (b = d, c = $0a0e7b9537100374$var$Nk(a, d));
    }
    if (1 === c) throw c = $0a0e7b9537100374$var$pk, $0a0e7b9537100374$var$Kk(a, 0), $0a0e7b9537100374$var$Ck(a, b), $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B()), c;
    if (6 === c) throw Error($0a0e7b9537100374$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0a0e7b9537100374$var$Pk(a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk);
    $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B());
    return null;
}
function $0a0e7b9537100374$var$Qk(a, b) {
    var c = $0a0e7b9537100374$var$K;
    $0a0e7b9537100374$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0a0e7b9537100374$var$K = c, 0 === $0a0e7b9537100374$var$K && ($0a0e7b9537100374$var$Gj = $0a0e7b9537100374$var$B() + 500, $0a0e7b9537100374$var$fg && $0a0e7b9537100374$var$jg());
    }
}
function $0a0e7b9537100374$var$Rk(a) {
    null !== $0a0e7b9537100374$var$wk && 0 === $0a0e7b9537100374$var$wk.tag && 0 === ($0a0e7b9537100374$var$K & 6) && $0a0e7b9537100374$var$Hk();
    var b = $0a0e7b9537100374$var$K;
    $0a0e7b9537100374$var$K |= 1;
    var c = $0a0e7b9537100374$var$ok.transition, d = $0a0e7b9537100374$var$C;
    try {
        if ($0a0e7b9537100374$var$ok.transition = null, $0a0e7b9537100374$var$C = 1, a) return a();
    } finally{
        $0a0e7b9537100374$var$C = d, $0a0e7b9537100374$var$ok.transition = c, $0a0e7b9537100374$var$K = b, 0 === ($0a0e7b9537100374$var$K & 6) && $0a0e7b9537100374$var$jg();
    }
}
function $0a0e7b9537100374$var$Hj() {
    $0a0e7b9537100374$var$fj = $0a0e7b9537100374$var$ej.current;
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$ej);
}
function $0a0e7b9537100374$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0a0e7b9537100374$var$Gf(c));
    if (null !== $0a0e7b9537100374$var$Y) for(c = $0a0e7b9537100374$var$Y.return; null !== c;){
        var d = c;
        $0a0e7b9537100374$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0a0e7b9537100374$var$$f();
                break;
            case 3:
                $0a0e7b9537100374$var$zh();
                $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf);
                $0a0e7b9537100374$var$E($0a0e7b9537100374$var$H);
                $0a0e7b9537100374$var$Eh();
                break;
            case 5:
                $0a0e7b9537100374$var$Bh(d);
                break;
            case 4:
                $0a0e7b9537100374$var$zh();
                break;
            case 13:
                $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L);
                break;
            case 19:
                $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L);
                break;
            case 10:
                $0a0e7b9537100374$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0a0e7b9537100374$var$Hj();
        }
        c = c.return;
    }
    $0a0e7b9537100374$var$Q = a;
    $0a0e7b9537100374$var$Y = a = $0a0e7b9537100374$var$Pg(a.current, null);
    $0a0e7b9537100374$var$Z = $0a0e7b9537100374$var$fj = b;
    $0a0e7b9537100374$var$T = 0;
    $0a0e7b9537100374$var$pk = null;
    $0a0e7b9537100374$var$rk = $0a0e7b9537100374$var$qk = $0a0e7b9537100374$var$rh = 0;
    $0a0e7b9537100374$var$tk = $0a0e7b9537100374$var$sk = null;
    if (null !== $0a0e7b9537100374$var$fh) {
        for(b = 0; b < $0a0e7b9537100374$var$fh.length; b++)if (c = $0a0e7b9537100374$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0a0e7b9537100374$var$fh = null;
    }
    return a;
}
function $0a0e7b9537100374$var$Mk(a, b) {
    do {
        var c = $0a0e7b9537100374$var$Y;
        try {
            $0a0e7b9537100374$var$$g();
            $0a0e7b9537100374$var$Fh.current = $0a0e7b9537100374$var$Rh;
            if ($0a0e7b9537100374$var$Ih) {
                for(var d = $0a0e7b9537100374$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0a0e7b9537100374$var$Ih = !1;
            }
            $0a0e7b9537100374$var$Hh = 0;
            $0a0e7b9537100374$var$O = $0a0e7b9537100374$var$N = $0a0e7b9537100374$var$M = null;
            $0a0e7b9537100374$var$Jh = !1;
            $0a0e7b9537100374$var$Kh = 0;
            $0a0e7b9537100374$var$nk.current = null;
            if (null === c || null === c.return) {
                $0a0e7b9537100374$var$T = 1;
                $0a0e7b9537100374$var$pk = b;
                $0a0e7b9537100374$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0a0e7b9537100374$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0a0e7b9537100374$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0a0e7b9537100374$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0a0e7b9537100374$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0a0e7b9537100374$var$Si(f, l, b);
                            $0a0e7b9537100374$var$tj();
                            break a;
                        }
                        k = Error($0a0e7b9537100374$var$p(426));
                    }
                } else if ($0a0e7b9537100374$var$I && h.mode & 1) {
                    var J = $0a0e7b9537100374$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0a0e7b9537100374$var$Vi(J, g, h, f, b);
                        $0a0e7b9537100374$var$Jg($0a0e7b9537100374$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0a0e7b9537100374$var$Ji(k, h);
                4 !== $0a0e7b9537100374$var$T && ($0a0e7b9537100374$var$T = 2);
                null === $0a0e7b9537100374$var$sk ? $0a0e7b9537100374$var$sk = [
                    f
                ] : $0a0e7b9537100374$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0a0e7b9537100374$var$Ni(f, k, b);
                            $0a0e7b9537100374$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0a0e7b9537100374$var$Ri || !$0a0e7b9537100374$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0a0e7b9537100374$var$Qi(f, h, b);
                                $0a0e7b9537100374$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0a0e7b9537100374$var$Sk(c);
        } catch (na) {
            b = na;
            $0a0e7b9537100374$var$Y === c && null !== c && ($0a0e7b9537100374$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0a0e7b9537100374$var$Jk() {
    var a = $0a0e7b9537100374$var$mk.current;
    $0a0e7b9537100374$var$mk.current = $0a0e7b9537100374$var$Rh;
    return null === a ? $0a0e7b9537100374$var$Rh : a;
}
function $0a0e7b9537100374$var$tj() {
    if (0 === $0a0e7b9537100374$var$T || 3 === $0a0e7b9537100374$var$T || 2 === $0a0e7b9537100374$var$T) $0a0e7b9537100374$var$T = 4;
    null === $0a0e7b9537100374$var$Q || 0 === ($0a0e7b9537100374$var$rh & 268435455) && 0 === ($0a0e7b9537100374$var$qk & 268435455) || $0a0e7b9537100374$var$Ck($0a0e7b9537100374$var$Q, $0a0e7b9537100374$var$Z);
}
function $0a0e7b9537100374$var$Ik(a, b) {
    var c = $0a0e7b9537100374$var$K;
    $0a0e7b9537100374$var$K |= 2;
    var d = $0a0e7b9537100374$var$Jk();
    if ($0a0e7b9537100374$var$Q !== a || $0a0e7b9537100374$var$Z !== b) $0a0e7b9537100374$var$uk = null, $0a0e7b9537100374$var$Kk(a, b);
    for(;;)try {
        $0a0e7b9537100374$var$Tk();
        break;
    } catch (e) {
        $0a0e7b9537100374$var$Mk(a, e);
    }
    $0a0e7b9537100374$var$$g();
    $0a0e7b9537100374$var$K = c;
    $0a0e7b9537100374$var$mk.current = d;
    if (null !== $0a0e7b9537100374$var$Y) throw Error($0a0e7b9537100374$var$p(261));
    $0a0e7b9537100374$var$Q = null;
    $0a0e7b9537100374$var$Z = 0;
    return $0a0e7b9537100374$var$T;
}
function $0a0e7b9537100374$var$Tk() {
    for(; null !== $0a0e7b9537100374$var$Y;)$0a0e7b9537100374$var$Uk($0a0e7b9537100374$var$Y);
}
function $0a0e7b9537100374$var$Lk() {
    for(; null !== $0a0e7b9537100374$var$Y && !$0a0e7b9537100374$var$cc();)$0a0e7b9537100374$var$Uk($0a0e7b9537100374$var$Y);
}
function $0a0e7b9537100374$var$Uk(a) {
    var b = $0a0e7b9537100374$var$Vk(a.alternate, a, $0a0e7b9537100374$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0a0e7b9537100374$var$Sk(a) : $0a0e7b9537100374$var$Y = b;
    $0a0e7b9537100374$var$nk.current = null;
}
function $0a0e7b9537100374$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0a0e7b9537100374$var$Ej(c, b, $0a0e7b9537100374$var$fj), null !== c) {
                $0a0e7b9537100374$var$Y = c;
                return;
            }
        } else {
            c = $0a0e7b9537100374$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0a0e7b9537100374$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0a0e7b9537100374$var$T = 6;
                $0a0e7b9537100374$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0a0e7b9537100374$var$Y = b;
            return;
        }
        $0a0e7b9537100374$var$Y = b = a;
    }while (null !== b);
    0 === $0a0e7b9537100374$var$T && ($0a0e7b9537100374$var$T = 5);
}
function $0a0e7b9537100374$var$Pk(a, b, c) {
    var d = $0a0e7b9537100374$var$C, e = $0a0e7b9537100374$var$ok.transition;
    try {
        $0a0e7b9537100374$var$ok.transition = null, $0a0e7b9537100374$var$C = 1, $0a0e7b9537100374$var$Wk(a, b, c, d);
    } finally{
        $0a0e7b9537100374$var$ok.transition = e, $0a0e7b9537100374$var$C = d;
    }
    return null;
}
function $0a0e7b9537100374$var$Wk(a, b, c, d) {
    do $0a0e7b9537100374$var$Hk();
    while (null !== $0a0e7b9537100374$var$wk);
    if (0 !== ($0a0e7b9537100374$var$K & 6)) throw Error($0a0e7b9537100374$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0a0e7b9537100374$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0a0e7b9537100374$var$Bc(a, f);
    a === $0a0e7b9537100374$var$Q && ($0a0e7b9537100374$var$Y = $0a0e7b9537100374$var$Q = null, $0a0e7b9537100374$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0a0e7b9537100374$var$vk || ($0a0e7b9537100374$var$vk = !0, $0a0e7b9537100374$var$Fk($0a0e7b9537100374$var$hc, function() {
        $0a0e7b9537100374$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0a0e7b9537100374$var$ok.transition;
        $0a0e7b9537100374$var$ok.transition = null;
        var g = $0a0e7b9537100374$var$C;
        $0a0e7b9537100374$var$C = 1;
        var h = $0a0e7b9537100374$var$K;
        $0a0e7b9537100374$var$K |= 4;
        $0a0e7b9537100374$var$nk.current = null;
        $0a0e7b9537100374$var$Oj(a, c);
        $0a0e7b9537100374$var$dk(c, a);
        $0a0e7b9537100374$var$Oe($0a0e7b9537100374$var$Df);
        $0a0e7b9537100374$var$dd = !!$0a0e7b9537100374$var$Cf;
        $0a0e7b9537100374$var$Df = $0a0e7b9537100374$var$Cf = null;
        a.current = c;
        $0a0e7b9537100374$var$hk(c, a, e);
        $0a0e7b9537100374$var$dc();
        $0a0e7b9537100374$var$K = h;
        $0a0e7b9537100374$var$C = g;
        $0a0e7b9537100374$var$ok.transition = f;
    } else a.current = c;
    $0a0e7b9537100374$var$vk && ($0a0e7b9537100374$var$vk = !1, $0a0e7b9537100374$var$wk = a, $0a0e7b9537100374$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0a0e7b9537100374$var$Ri = null);
    $0a0e7b9537100374$var$mc(c.stateNode, d);
    $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0a0e7b9537100374$var$Oi) throw $0a0e7b9537100374$var$Oi = !1, a = $0a0e7b9537100374$var$Pi, $0a0e7b9537100374$var$Pi = null, a;
    0 !== ($0a0e7b9537100374$var$xk & 1) && 0 !== a.tag && $0a0e7b9537100374$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0a0e7b9537100374$var$zk ? $0a0e7b9537100374$var$yk++ : ($0a0e7b9537100374$var$yk = 0, $0a0e7b9537100374$var$zk = a) : $0a0e7b9537100374$var$yk = 0;
    $0a0e7b9537100374$var$jg();
    return null;
}
function $0a0e7b9537100374$var$Hk() {
    if (null !== $0a0e7b9537100374$var$wk) {
        var a = $0a0e7b9537100374$var$Dc($0a0e7b9537100374$var$xk), b = $0a0e7b9537100374$var$ok.transition, c = $0a0e7b9537100374$var$C;
        try {
            $0a0e7b9537100374$var$ok.transition = null;
            $0a0e7b9537100374$var$C = 16 > a ? 16 : a;
            if (null === $0a0e7b9537100374$var$wk) var d = !1;
            else {
                a = $0a0e7b9537100374$var$wk;
                $0a0e7b9537100374$var$wk = null;
                $0a0e7b9537100374$var$xk = 0;
                if (0 !== ($0a0e7b9537100374$var$K & 6)) throw Error($0a0e7b9537100374$var$p(331));
                var e = $0a0e7b9537100374$var$K;
                $0a0e7b9537100374$var$K |= 4;
                for($0a0e7b9537100374$var$V = a.current; null !== $0a0e7b9537100374$var$V;){
                    var f = $0a0e7b9537100374$var$V, g = f.child;
                    if (0 !== ($0a0e7b9537100374$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0a0e7b9537100374$var$V = l; null !== $0a0e7b9537100374$var$V;){
                                    var m = $0a0e7b9537100374$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0a0e7b9537100374$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0a0e7b9537100374$var$V = q;
                                    else for(; null !== $0a0e7b9537100374$var$V;){
                                        m = $0a0e7b9537100374$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0a0e7b9537100374$var$Sj(m);
                                        if (m === l) {
                                            $0a0e7b9537100374$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0a0e7b9537100374$var$V = r;
                                            break;
                                        }
                                        $0a0e7b9537100374$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0a0e7b9537100374$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0a0e7b9537100374$var$V = g;
                    else b: for(; null !== $0a0e7b9537100374$var$V;){
                        f = $0a0e7b9537100374$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0a0e7b9537100374$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0a0e7b9537100374$var$V = x;
                            break b;
                        }
                        $0a0e7b9537100374$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0a0e7b9537100374$var$V = w; null !== $0a0e7b9537100374$var$V;){
                    g = $0a0e7b9537100374$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0a0e7b9537100374$var$V = u;
                    else b: for(g = w; null !== $0a0e7b9537100374$var$V;){
                        h = $0a0e7b9537100374$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0a0e7b9537100374$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0a0e7b9537100374$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0a0e7b9537100374$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0a0e7b9537100374$var$V = F;
                            break b;
                        }
                        $0a0e7b9537100374$var$V = h.return;
                    }
                }
                $0a0e7b9537100374$var$K = e;
                $0a0e7b9537100374$var$jg();
                if ($0a0e7b9537100374$var$lc && "function" === typeof $0a0e7b9537100374$var$lc.onPostCommitFiberRoot) try {
                    $0a0e7b9537100374$var$lc.onPostCommitFiberRoot($0a0e7b9537100374$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0a0e7b9537100374$var$C = c, $0a0e7b9537100374$var$ok.transition = b;
        }
    }
    return !1;
}
function $0a0e7b9537100374$var$Xk(a, b, c) {
    b = $0a0e7b9537100374$var$Ji(c, b);
    b = $0a0e7b9537100374$var$Ni(a, b, 1);
    a = $0a0e7b9537100374$var$nh(a, b, 1);
    b = $0a0e7b9537100374$var$R();
    null !== a && ($0a0e7b9537100374$var$Ac(a, 1, b), $0a0e7b9537100374$var$Dk(a, b));
}
function $0a0e7b9537100374$var$W(a, b, c) {
    if (3 === a.tag) $0a0e7b9537100374$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0a0e7b9537100374$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0a0e7b9537100374$var$Ri || !$0a0e7b9537100374$var$Ri.has(d))) {
                a = $0a0e7b9537100374$var$Ji(c, a);
                a = $0a0e7b9537100374$var$Qi(b, a, 1);
                b = $0a0e7b9537100374$var$nh(b, a, 1);
                a = $0a0e7b9537100374$var$R();
                null !== b && ($0a0e7b9537100374$var$Ac(b, 1, a), $0a0e7b9537100374$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0a0e7b9537100374$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0a0e7b9537100374$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0a0e7b9537100374$var$Q === a && ($0a0e7b9537100374$var$Z & c) === c && (4 === $0a0e7b9537100374$var$T || 3 === $0a0e7b9537100374$var$T && ($0a0e7b9537100374$var$Z & 130023424) === $0a0e7b9537100374$var$Z && 500 > $0a0e7b9537100374$var$B() - $0a0e7b9537100374$var$fk ? $0a0e7b9537100374$var$Kk(a, 0) : $0a0e7b9537100374$var$rk |= c);
    $0a0e7b9537100374$var$Dk(a, b);
}
function $0a0e7b9537100374$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0a0e7b9537100374$var$sc, $0a0e7b9537100374$var$sc <<= 1, 0 === ($0a0e7b9537100374$var$sc & 130023424) && ($0a0e7b9537100374$var$sc = 4194304)));
    var c = $0a0e7b9537100374$var$R();
    a = $0a0e7b9537100374$var$ih(a, b);
    null !== a && ($0a0e7b9537100374$var$Ac(a, b, c), $0a0e7b9537100374$var$Dk(a, c));
}
function $0a0e7b9537100374$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0a0e7b9537100374$var$Yk(a, c);
}
function $0a0e7b9537100374$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0a0e7b9537100374$var$p(314));
    }
    null !== d && d.delete(b);
    $0a0e7b9537100374$var$Yk(a, c);
}
var $0a0e7b9537100374$var$Vk;
$0a0e7b9537100374$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0a0e7b9537100374$var$Wf.current) $0a0e7b9537100374$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0a0e7b9537100374$var$dh = !1, $0a0e7b9537100374$var$yj(a, b, c);
            $0a0e7b9537100374$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0a0e7b9537100374$var$dh = !1, $0a0e7b9537100374$var$I && 0 !== (b.flags & 1048576) && $0a0e7b9537100374$var$ug(b, $0a0e7b9537100374$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0a0e7b9537100374$var$ij(a, b);
            a = b.pendingProps;
            var e = $0a0e7b9537100374$var$Yf(b, $0a0e7b9537100374$var$H.current);
            $0a0e7b9537100374$var$ch(b, c);
            e = $0a0e7b9537100374$var$Nh(null, b, d, a, e, c);
            var f = $0a0e7b9537100374$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0a0e7b9537100374$var$Zf(d) ? (f = !0, $0a0e7b9537100374$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0a0e7b9537100374$var$kh(b), e.updater = $0a0e7b9537100374$var$Ei, b.stateNode = e, e._reactInternals = b, $0a0e7b9537100374$var$Ii(b, d, a, c), b = $0a0e7b9537100374$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0a0e7b9537100374$var$I && f && $0a0e7b9537100374$var$vg(b), $0a0e7b9537100374$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0a0e7b9537100374$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0a0e7b9537100374$var$Zk(d);
                a = $0a0e7b9537100374$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0a0e7b9537100374$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0a0e7b9537100374$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0a0e7b9537100374$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0a0e7b9537100374$var$$i(null, b, d, $0a0e7b9537100374$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0a0e7b9537100374$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0a0e7b9537100374$var$Ci(d, e), $0a0e7b9537100374$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0a0e7b9537100374$var$Ci(d, e), $0a0e7b9537100374$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0a0e7b9537100374$var$kj(b);
                if (null === a) throw Error($0a0e7b9537100374$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0a0e7b9537100374$var$lh(a, b);
                $0a0e7b9537100374$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0a0e7b9537100374$var$Ji(Error($0a0e7b9537100374$var$p(423)), b);
                        b = $0a0e7b9537100374$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0a0e7b9537100374$var$Ji(Error($0a0e7b9537100374$var$p(424)), b);
                        b = $0a0e7b9537100374$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$Lf(b.stateNode.containerInfo.firstChild), $0a0e7b9537100374$var$xg = b, $0a0e7b9537100374$var$I = !0, $0a0e7b9537100374$var$zg = null, c = $0a0e7b9537100374$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0a0e7b9537100374$var$Ig();
                    if (d === e) {
                        b = $0a0e7b9537100374$var$Zi(a, b, c);
                        break a;
                    }
                    $0a0e7b9537100374$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0a0e7b9537100374$var$Ah(b), null === a && $0a0e7b9537100374$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0a0e7b9537100374$var$Ef(d, e) ? g = null : null !== f && $0a0e7b9537100374$var$Ef(d, f) && (b.flags |= 32), $0a0e7b9537100374$var$gj(a, b), $0a0e7b9537100374$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0a0e7b9537100374$var$Eg(b), null;
        case 13:
            return $0a0e7b9537100374$var$oj(a, b, c);
        case 4:
            return $0a0e7b9537100374$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0a0e7b9537100374$var$Ug(b, null, d, c) : $0a0e7b9537100374$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0a0e7b9537100374$var$Ci(d, e), $0a0e7b9537100374$var$Yi(a, b, d, e, c);
        case 7:
            return $0a0e7b9537100374$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0a0e7b9537100374$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0a0e7b9537100374$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0a0e7b9537100374$var$G($0a0e7b9537100374$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0a0e7b9537100374$var$He(f.value, g)) {
                        if (f.children === e.children && !$0a0e7b9537100374$var$Wf.current) {
                            b = $0a0e7b9537100374$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0a0e7b9537100374$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0a0e7b9537100374$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0a0e7b9537100374$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0a0e7b9537100374$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0a0e7b9537100374$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0a0e7b9537100374$var$ch(b, c), e = $0a0e7b9537100374$var$eh(e), d = d(e), b.flags |= 1, $0a0e7b9537100374$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0a0e7b9537100374$var$Ci(d, b.pendingProps), e = $0a0e7b9537100374$var$Ci(d.type, e), $0a0e7b9537100374$var$$i(a, b, d, e, c);
        case 15:
            return $0a0e7b9537100374$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0a0e7b9537100374$var$Ci(d, e), $0a0e7b9537100374$var$ij(a, b), b.tag = 1, $0a0e7b9537100374$var$Zf(d) ? (a = !0, $0a0e7b9537100374$var$cg(b)) : a = !1, $0a0e7b9537100374$var$ch(b, c), $0a0e7b9537100374$var$Gi(b, d, e), $0a0e7b9537100374$var$Ii(b, d, e, c), $0a0e7b9537100374$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0a0e7b9537100374$var$xj(a, b, c);
        case 22:
            return $0a0e7b9537100374$var$dj(a, b, c);
    }
    throw Error($0a0e7b9537100374$var$p(156, b.tag));
};
function $0a0e7b9537100374$var$Fk(a, b) {
    return $0a0e7b9537100374$var$ac(a, b);
}
function $0a0e7b9537100374$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0a0e7b9537100374$var$Bg(a, b, c, d) {
    return new $0a0e7b9537100374$var$$k(a, b, c, d);
}
function $0a0e7b9537100374$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0a0e7b9537100374$var$Zk(a) {
    if ("function" === typeof a) return $0a0e7b9537100374$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0a0e7b9537100374$var$Da) return 11;
        if (a === $0a0e7b9537100374$var$Ga) return 14;
    }
    return 2;
}
function $0a0e7b9537100374$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0a0e7b9537100374$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0a0e7b9537100374$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0a0e7b9537100374$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0a0e7b9537100374$var$ya:
            return $0a0e7b9537100374$var$Tg(c.children, e, f, b);
        case $0a0e7b9537100374$var$za:
            g = 8;
            e |= 8;
            break;
        case $0a0e7b9537100374$var$Aa:
            return a = $0a0e7b9537100374$var$Bg(12, c, b, e | 2), a.elementType = $0a0e7b9537100374$var$Aa, a.lanes = f, a;
        case $0a0e7b9537100374$var$Ea:
            return a = $0a0e7b9537100374$var$Bg(13, c, b, e), a.elementType = $0a0e7b9537100374$var$Ea, a.lanes = f, a;
        case $0a0e7b9537100374$var$Fa:
            return a = $0a0e7b9537100374$var$Bg(19, c, b, e), a.elementType = $0a0e7b9537100374$var$Fa, a.lanes = f, a;
        case $0a0e7b9537100374$var$Ia:
            return $0a0e7b9537100374$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0a0e7b9537100374$var$Ba:
                    g = 10;
                    break a;
                case $0a0e7b9537100374$var$Ca:
                    g = 9;
                    break a;
                case $0a0e7b9537100374$var$Da:
                    g = 11;
                    break a;
                case $0a0e7b9537100374$var$Ga:
                    g = 14;
                    break a;
                case $0a0e7b9537100374$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0a0e7b9537100374$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0a0e7b9537100374$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0a0e7b9537100374$var$Tg(a, b, c, d) {
    a = $0a0e7b9537100374$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0a0e7b9537100374$var$pj(a, b, c, d) {
    a = $0a0e7b9537100374$var$Bg(22, a, d, b);
    a.elementType = $0a0e7b9537100374$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0a0e7b9537100374$var$Qg(a, b, c) {
    a = $0a0e7b9537100374$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0a0e7b9537100374$var$Sg(a, b, c) {
    b = $0a0e7b9537100374$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0a0e7b9537100374$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0a0e7b9537100374$var$zc(0);
    this.expirationTimes = $0a0e7b9537100374$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0a0e7b9537100374$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0a0e7b9537100374$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0a0e7b9537100374$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0a0e7b9537100374$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0a0e7b9537100374$var$kh(f);
    return a;
}
function $0a0e7b9537100374$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0a0e7b9537100374$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0a0e7b9537100374$var$dl(a) {
    if (!a) return $0a0e7b9537100374$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0a0e7b9537100374$var$Vb(a) !== a || 1 !== a.tag) throw Error($0a0e7b9537100374$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0a0e7b9537100374$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0a0e7b9537100374$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0a0e7b9537100374$var$Zf(c)) return $0a0e7b9537100374$var$bg(a, c, b);
    }
    return b;
}
function $0a0e7b9537100374$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0a0e7b9537100374$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0a0e7b9537100374$var$dl(null);
    c = a.current;
    d = $0a0e7b9537100374$var$R();
    e = $0a0e7b9537100374$var$yi(c);
    f = $0a0e7b9537100374$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0a0e7b9537100374$var$nh(c, f, e);
    a.current.lanes = e;
    $0a0e7b9537100374$var$Ac(a, e, d);
    $0a0e7b9537100374$var$Dk(a, d);
    return a;
}
function $0a0e7b9537100374$var$fl(a, b, c, d) {
    var e = b.current, f = $0a0e7b9537100374$var$R(), g = $0a0e7b9537100374$var$yi(e);
    c = $0a0e7b9537100374$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0a0e7b9537100374$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0a0e7b9537100374$var$nh(e, b, g);
    null !== a && ($0a0e7b9537100374$var$gi(a, e, g, f), $0a0e7b9537100374$var$oh(a, e, g));
    return g;
}
function $0a0e7b9537100374$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0a0e7b9537100374$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0a0e7b9537100374$var$il(a, b) {
    $0a0e7b9537100374$var$hl(a, b);
    (a = a.alternate) && $0a0e7b9537100374$var$hl(a, b);
}
function $0a0e7b9537100374$var$jl() {
    return null;
}
var $0a0e7b9537100374$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0a0e7b9537100374$var$ll(a) {
    this._internalRoot = a;
}
$0a0e7b9537100374$var$ml.prototype.render = $0a0e7b9537100374$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0a0e7b9537100374$var$p(409));
    $0a0e7b9537100374$var$fl(a, b, null, null);
};
$0a0e7b9537100374$var$ml.prototype.unmount = $0a0e7b9537100374$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0a0e7b9537100374$var$Rk(function() {
            $0a0e7b9537100374$var$fl(null, a, null, null);
        });
        b[$0a0e7b9537100374$var$uf] = null;
    }
};
function $0a0e7b9537100374$var$ml(a) {
    this._internalRoot = a;
}
$0a0e7b9537100374$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0a0e7b9537100374$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0a0e7b9537100374$var$Qc.length && 0 !== b && b < $0a0e7b9537100374$var$Qc[c].priority; c++);
        $0a0e7b9537100374$var$Qc.splice(c, 0, a);
        0 === c && $0a0e7b9537100374$var$Vc(a);
    }
};
function $0a0e7b9537100374$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0a0e7b9537100374$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0a0e7b9537100374$var$pl() {}
function $0a0e7b9537100374$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0a0e7b9537100374$var$gl(g);
                f.call(a);
            };
        }
        var g = $0a0e7b9537100374$var$el(b, d, a, 0, null, !1, !1, "", $0a0e7b9537100374$var$pl);
        a._reactRootContainer = g;
        a[$0a0e7b9537100374$var$uf] = g.current;
        $0a0e7b9537100374$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0a0e7b9537100374$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0a0e7b9537100374$var$gl(k);
            h.call(a);
        };
    }
    var k = $0a0e7b9537100374$var$bl(a, 0, !1, null, null, !1, !1, "", $0a0e7b9537100374$var$pl);
    a._reactRootContainer = k;
    a[$0a0e7b9537100374$var$uf] = k.current;
    $0a0e7b9537100374$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0a0e7b9537100374$var$Rk(function() {
        $0a0e7b9537100374$var$fl(b, k, c, d);
    });
    return k;
}
function $0a0e7b9537100374$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0a0e7b9537100374$var$gl(g);
                h.call(a);
            };
        }
        $0a0e7b9537100374$var$fl(b, g, a, e);
    } else g = $0a0e7b9537100374$var$ql(c, b, a, e, d);
    return $0a0e7b9537100374$var$gl(g);
}
$0a0e7b9537100374$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0a0e7b9537100374$var$tc(b.pendingLanes);
                0 !== c && ($0a0e7b9537100374$var$Cc(b, c | 1), $0a0e7b9537100374$var$Dk(b, $0a0e7b9537100374$var$B()), 0 === ($0a0e7b9537100374$var$K & 6) && ($0a0e7b9537100374$var$Gj = $0a0e7b9537100374$var$B() + 500, $0a0e7b9537100374$var$jg()));
            }
            break;
        case 13:
            $0a0e7b9537100374$var$Rk(function() {
                var b = $0a0e7b9537100374$var$ih(a, 1);
                if (null !== b) {
                    var c = $0a0e7b9537100374$var$R();
                    $0a0e7b9537100374$var$gi(b, a, 1, c);
                }
            }), $0a0e7b9537100374$var$il(a, 1);
    }
};
$0a0e7b9537100374$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0a0e7b9537100374$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0a0e7b9537100374$var$R();
            $0a0e7b9537100374$var$gi(b, a, 134217728, c);
        }
        $0a0e7b9537100374$var$il(a, 134217728);
    }
};
$0a0e7b9537100374$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0a0e7b9537100374$var$yi(a), c = $0a0e7b9537100374$var$ih(a, b);
        if (null !== c) {
            var d = $0a0e7b9537100374$var$R();
            $0a0e7b9537100374$var$gi(c, a, b, d);
        }
        $0a0e7b9537100374$var$il(a, b);
    }
};
$0a0e7b9537100374$var$Hc = function() {
    return $0a0e7b9537100374$var$C;
};
$0a0e7b9537100374$var$Ic = function(a, b) {
    var c = $0a0e7b9537100374$var$C;
    try {
        return $0a0e7b9537100374$var$C = a, b();
    } finally{
        $0a0e7b9537100374$var$C = c;
    }
};
$0a0e7b9537100374$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0a0e7b9537100374$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0a0e7b9537100374$var$Db(d);
                        if (!e) throw Error($0a0e7b9537100374$var$p(90));
                        $0a0e7b9537100374$var$Wa(d);
                        $0a0e7b9537100374$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0a0e7b9537100374$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0a0e7b9537100374$var$fb(a, !!c.multiple, b, !1);
    }
};
$0a0e7b9537100374$var$Gb = $0a0e7b9537100374$var$Qk;
$0a0e7b9537100374$var$Hb = $0a0e7b9537100374$var$Rk;
var $0a0e7b9537100374$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0a0e7b9537100374$var$Cb,
        $0a0e7b9537100374$var$ue,
        $0a0e7b9537100374$var$Db,
        $0a0e7b9537100374$var$Eb,
        $0a0e7b9537100374$var$Fb,
        $0a0e7b9537100374$var$Qk
    ]
}, $0a0e7b9537100374$var$tl = {
    findFiberByHostInstance: $0a0e7b9537100374$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0a0e7b9537100374$var$ul = {
    bundleType: $0a0e7b9537100374$var$tl.bundleType,
    version: $0a0e7b9537100374$var$tl.version,
    rendererPackageName: $0a0e7b9537100374$var$tl.rendererPackageName,
    rendererConfig: $0a0e7b9537100374$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0a0e7b9537100374$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0a0e7b9537100374$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0a0e7b9537100374$var$tl.findFiberByHostInstance || $0a0e7b9537100374$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0a0e7b9537100374$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0a0e7b9537100374$var$vl.isDisabled && $0a0e7b9537100374$var$vl.supportsFiber) try {
        $0a0e7b9537100374$var$kc = $0a0e7b9537100374$var$vl.inject($0a0e7b9537100374$var$ul), $0a0e7b9537100374$var$lc = $0a0e7b9537100374$var$vl;
    } catch (a) {}
}
$0a0e7b9537100374$export$ae55be85d98224ed = $0a0e7b9537100374$var$sl;
$0a0e7b9537100374$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0a0e7b9537100374$var$nl(b)) throw Error($0a0e7b9537100374$var$p(200));
    return $0a0e7b9537100374$var$cl(a, b, null, c);
};
$0a0e7b9537100374$export$882461b6382ed46c = function(a, b) {
    if (!$0a0e7b9537100374$var$nl(a)) throw Error($0a0e7b9537100374$var$p(299));
    var c = !1, d = "", e = $0a0e7b9537100374$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0a0e7b9537100374$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0a0e7b9537100374$var$uf] = b.current;
    $0a0e7b9537100374$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0a0e7b9537100374$var$ll(b);
};
$0a0e7b9537100374$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0a0e7b9537100374$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0a0e7b9537100374$var$p(268, a));
    }
    a = $0a0e7b9537100374$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0a0e7b9537100374$export$cd75ccfd720a3cd4 = function(a) {
    return $0a0e7b9537100374$var$Rk(a);
};
$0a0e7b9537100374$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0a0e7b9537100374$var$ol(b)) throw Error($0a0e7b9537100374$var$p(200));
    return $0a0e7b9537100374$var$rl(null, a, b, !0, c);
};
$0a0e7b9537100374$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0a0e7b9537100374$var$nl(a)) throw Error($0a0e7b9537100374$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0a0e7b9537100374$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0a0e7b9537100374$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0a0e7b9537100374$var$uf] = b.current;
    $0a0e7b9537100374$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0a0e7b9537100374$var$ml(b);
};
$0a0e7b9537100374$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0a0e7b9537100374$var$ol(b)) throw Error($0a0e7b9537100374$var$p(200));
    return $0a0e7b9537100374$var$rl(null, a, b, !1, c);
};
$0a0e7b9537100374$export$502457920280e6be = function(a) {
    if (!$0a0e7b9537100374$var$ol(a)) throw Error($0a0e7b9537100374$var$p(40));
    return a._reactRootContainer ? ($0a0e7b9537100374$var$Rk(function() {
        $0a0e7b9537100374$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0a0e7b9537100374$var$uf] = null;
        });
    }), !0) : !1;
};
$0a0e7b9537100374$export$c78a37762a8d58e1 = $0a0e7b9537100374$var$Qk;
$0a0e7b9537100374$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0a0e7b9537100374$var$ol(c)) throw Error($0a0e7b9537100374$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0a0e7b9537100374$var$p(38));
    return $0a0e7b9537100374$var$rl(a, b, c, !1, d);
};
$0a0e7b9537100374$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("9rFeI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4zHOU"));

});
parcelRegister("4zHOU", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $354c6c187ec2d025$export$c4744153514ff05d, (v) => $354c6c187ec2d025$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $354c6c187ec2d025$export$3e506c1ccc9cc1a7, (v) => $354c6c187ec2d025$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $354c6c187ec2d025$export$e26fe2ed2fa76875, (v) => $354c6c187ec2d025$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $354c6c187ec2d025$export$502329bbf4b505b1, (v) => $354c6c187ec2d025$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $354c6c187ec2d025$export$6e3807111c4874c4, (v) => $354c6c187ec2d025$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $354c6c187ec2d025$export$c27134553091fb3a, (v) => $354c6c187ec2d025$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $354c6c187ec2d025$export$33ee1acdc04fd2a2, (v) => $354c6c187ec2d025$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $354c6c187ec2d025$export$b00a404bbd5edef2, (v) => $354c6c187ec2d025$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $354c6c187ec2d025$export$8352ce38b91d0c62, (v) => $354c6c187ec2d025$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $354c6c187ec2d025$export$d66a1c1c77bd778b, (v) => $354c6c187ec2d025$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $354c6c187ec2d025$export$d3dfb8e4810cb555, (v) => $354c6c187ec2d025$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $354c6c187ec2d025$export$839f9183b0465a69, (v) => $354c6c187ec2d025$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $354c6c187ec2d025$export$72fdf0e06517287b, (v) => $354c6c187ec2d025$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $354c6c187ec2d025$export$4b844e58a3e414b4, (v) => $354c6c187ec2d025$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $354c6c187ec2d025$export$816d2913ae6b83b1, (v) => $354c6c187ec2d025$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $354c6c187ec2d025$export$61bcfe829111a1d0, (v) => $354c6c187ec2d025$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $354c6c187ec2d025$export$7ee8c9beb337bc3f, (v) => $354c6c187ec2d025$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $354c6c187ec2d025$export$b5836b71941fa3ed, (v) => $354c6c187ec2d025$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $354c6c187ec2d025$export$cf845f2c119da08a, (v) => $354c6c187ec2d025$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $354c6c187ec2d025$export$c4744153514ff05d;
var $354c6c187ec2d025$export$3e506c1ccc9cc1a7;
var $354c6c187ec2d025$export$e26fe2ed2fa76875;
var $354c6c187ec2d025$export$502329bbf4b505b1;
var $354c6c187ec2d025$export$6e3807111c4874c4;
var $354c6c187ec2d025$export$c27134553091fb3a;
var $354c6c187ec2d025$export$33ee1acdc04fd2a2;
var $354c6c187ec2d025$export$b00a404bbd5edef2;
var $354c6c187ec2d025$export$8352ce38b91d0c62;
var $354c6c187ec2d025$export$d66a1c1c77bd778b;
var $354c6c187ec2d025$export$d3dfb8e4810cb555;
var $354c6c187ec2d025$export$839f9183b0465a69;
var $354c6c187ec2d025$export$72fdf0e06517287b;
var $354c6c187ec2d025$export$4b844e58a3e414b4;
var $354c6c187ec2d025$export$816d2913ae6b83b1;
var $354c6c187ec2d025$export$61bcfe829111a1d0;
var $354c6c187ec2d025$export$7ee8c9beb337bc3f;
var $354c6c187ec2d025$export$b5836b71941fa3ed;
var $354c6c187ec2d025$export$cf845f2c119da08a;
'use strict';
function $354c6c187ec2d025$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $354c6c187ec2d025$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $354c6c187ec2d025$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $354c6c187ec2d025$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $354c6c187ec2d025$var$g(C, c)) n < e && 0 > $354c6c187ec2d025$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $354c6c187ec2d025$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $354c6c187ec2d025$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $354c6c187ec2d025$var$l = performance;
    $354c6c187ec2d025$export$c4744153514ff05d = function() {
        return $354c6c187ec2d025$var$l.now();
    };
} else {
    var $354c6c187ec2d025$var$p = Date, $354c6c187ec2d025$var$q = $354c6c187ec2d025$var$p.now();
    $354c6c187ec2d025$export$c4744153514ff05d = function() {
        return $354c6c187ec2d025$var$p.now() - $354c6c187ec2d025$var$q;
    };
}
var $354c6c187ec2d025$var$r = [], $354c6c187ec2d025$var$t = [], $354c6c187ec2d025$var$u = 1, $354c6c187ec2d025$var$v = null, $354c6c187ec2d025$var$y = 3, $354c6c187ec2d025$var$z = !1, $354c6c187ec2d025$var$A = !1, $354c6c187ec2d025$var$B = !1, $354c6c187ec2d025$var$D = "function" === typeof setTimeout ? setTimeout : null, $354c6c187ec2d025$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $354c6c187ec2d025$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $354c6c187ec2d025$var$G(a) {
    for(var b = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$t); null !== b;){
        if (null === b.callback) $354c6c187ec2d025$var$k($354c6c187ec2d025$var$t);
        else if (b.startTime <= a) $354c6c187ec2d025$var$k($354c6c187ec2d025$var$t), b.sortIndex = b.expirationTime, $354c6c187ec2d025$var$f($354c6c187ec2d025$var$r, b);
        else break;
        b = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$t);
    }
}
function $354c6c187ec2d025$var$H(a) {
    $354c6c187ec2d025$var$B = !1;
    $354c6c187ec2d025$var$G(a);
    if (!$354c6c187ec2d025$var$A) {
        if (null !== $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r)) $354c6c187ec2d025$var$A = !0, $354c6c187ec2d025$var$I($354c6c187ec2d025$var$J);
        else {
            var b = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$t);
            null !== b && $354c6c187ec2d025$var$K($354c6c187ec2d025$var$H, b.startTime - a);
        }
    }
}
function $354c6c187ec2d025$var$J(a, b) {
    $354c6c187ec2d025$var$A = !1;
    $354c6c187ec2d025$var$B && ($354c6c187ec2d025$var$B = !1, $354c6c187ec2d025$var$E($354c6c187ec2d025$var$L), $354c6c187ec2d025$var$L = -1);
    $354c6c187ec2d025$var$z = !0;
    var c = $354c6c187ec2d025$var$y;
    try {
        $354c6c187ec2d025$var$G(b);
        for($354c6c187ec2d025$var$v = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r); null !== $354c6c187ec2d025$var$v && (!($354c6c187ec2d025$var$v.expirationTime > b) || a && !$354c6c187ec2d025$var$M());){
            var d = $354c6c187ec2d025$var$v.callback;
            if ("function" === typeof d) {
                $354c6c187ec2d025$var$v.callback = null;
                $354c6c187ec2d025$var$y = $354c6c187ec2d025$var$v.priorityLevel;
                var e = d($354c6c187ec2d025$var$v.expirationTime <= b);
                b = $354c6c187ec2d025$export$c4744153514ff05d();
                "function" === typeof e ? $354c6c187ec2d025$var$v.callback = e : $354c6c187ec2d025$var$v === $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r) && $354c6c187ec2d025$var$k($354c6c187ec2d025$var$r);
                $354c6c187ec2d025$var$G(b);
            } else $354c6c187ec2d025$var$k($354c6c187ec2d025$var$r);
            $354c6c187ec2d025$var$v = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r);
        }
        if (null !== $354c6c187ec2d025$var$v) var w = !0;
        else {
            var m = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$t);
            null !== m && $354c6c187ec2d025$var$K($354c6c187ec2d025$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $354c6c187ec2d025$var$v = null, $354c6c187ec2d025$var$y = c, $354c6c187ec2d025$var$z = !1;
    }
}
var $354c6c187ec2d025$var$N = !1, $354c6c187ec2d025$var$O = null, $354c6c187ec2d025$var$L = -1, $354c6c187ec2d025$var$P = 5, $354c6c187ec2d025$var$Q = -1;
function $354c6c187ec2d025$var$M() {
    return $354c6c187ec2d025$export$c4744153514ff05d() - $354c6c187ec2d025$var$Q < $354c6c187ec2d025$var$P ? !1 : !0;
}
function $354c6c187ec2d025$var$R() {
    if (null !== $354c6c187ec2d025$var$O) {
        var a = $354c6c187ec2d025$export$c4744153514ff05d();
        $354c6c187ec2d025$var$Q = a;
        var b = !0;
        try {
            b = $354c6c187ec2d025$var$O(!0, a);
        } finally{
            b ? $354c6c187ec2d025$var$S() : ($354c6c187ec2d025$var$N = !1, $354c6c187ec2d025$var$O = null);
        }
    } else $354c6c187ec2d025$var$N = !1;
}
var $354c6c187ec2d025$var$S;
if ("function" === typeof $354c6c187ec2d025$var$F) $354c6c187ec2d025$var$S = function() {
    $354c6c187ec2d025$var$F($354c6c187ec2d025$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $354c6c187ec2d025$var$T = new MessageChannel, $354c6c187ec2d025$var$U = $354c6c187ec2d025$var$T.port2;
    $354c6c187ec2d025$var$T.port1.onmessage = $354c6c187ec2d025$var$R;
    $354c6c187ec2d025$var$S = function() {
        $354c6c187ec2d025$var$U.postMessage(null);
    };
} else $354c6c187ec2d025$var$S = function() {
    $354c6c187ec2d025$var$D($354c6c187ec2d025$var$R, 0);
};
function $354c6c187ec2d025$var$I(a) {
    $354c6c187ec2d025$var$O = a;
    $354c6c187ec2d025$var$N || ($354c6c187ec2d025$var$N = !0, $354c6c187ec2d025$var$S());
}
function $354c6c187ec2d025$var$K(a, b) {
    $354c6c187ec2d025$var$L = $354c6c187ec2d025$var$D(function() {
        a($354c6c187ec2d025$export$c4744153514ff05d());
    }, b);
}
$354c6c187ec2d025$export$3e506c1ccc9cc1a7 = 5;
$354c6c187ec2d025$export$e26fe2ed2fa76875 = 1;
$354c6c187ec2d025$export$502329bbf4b505b1 = 4;
$354c6c187ec2d025$export$6e3807111c4874c4 = 3;
$354c6c187ec2d025$export$c27134553091fb3a = null;
$354c6c187ec2d025$export$33ee1acdc04fd2a2 = 2;
$354c6c187ec2d025$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$354c6c187ec2d025$export$8352ce38b91d0c62 = function() {
    $354c6c187ec2d025$var$A || $354c6c187ec2d025$var$z || ($354c6c187ec2d025$var$A = !0, $354c6c187ec2d025$var$I($354c6c187ec2d025$var$J));
};
$354c6c187ec2d025$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $354c6c187ec2d025$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$354c6c187ec2d025$export$d3dfb8e4810cb555 = function() {
    return $354c6c187ec2d025$var$y;
};
$354c6c187ec2d025$export$839f9183b0465a69 = function() {
    return $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r);
};
$354c6c187ec2d025$export$72fdf0e06517287b = function(a) {
    switch($354c6c187ec2d025$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $354c6c187ec2d025$var$y;
    }
    var c = $354c6c187ec2d025$var$y;
    $354c6c187ec2d025$var$y = b;
    try {
        return a();
    } finally{
        $354c6c187ec2d025$var$y = c;
    }
};
$354c6c187ec2d025$export$4b844e58a3e414b4 = function() {};
$354c6c187ec2d025$export$816d2913ae6b83b1 = function() {};
$354c6c187ec2d025$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $354c6c187ec2d025$var$y;
    $354c6c187ec2d025$var$y = a;
    try {
        return b();
    } finally{
        $354c6c187ec2d025$var$y = c;
    }
};
$354c6c187ec2d025$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $354c6c187ec2d025$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $354c6c187ec2d025$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $354c6c187ec2d025$var$f($354c6c187ec2d025$var$t, a), null === $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r) && a === $354c6c187ec2d025$var$h($354c6c187ec2d025$var$t) && ($354c6c187ec2d025$var$B ? ($354c6c187ec2d025$var$E($354c6c187ec2d025$var$L), $354c6c187ec2d025$var$L = -1) : $354c6c187ec2d025$var$B = !0, $354c6c187ec2d025$var$K($354c6c187ec2d025$var$H, c - d))) : (a.sortIndex = e, $354c6c187ec2d025$var$f($354c6c187ec2d025$var$r, a), $354c6c187ec2d025$var$A || $354c6c187ec2d025$var$z || ($354c6c187ec2d025$var$A = !0, $354c6c187ec2d025$var$I($354c6c187ec2d025$var$J)));
    return a;
};
$354c6c187ec2d025$export$b5836b71941fa3ed = $354c6c187ec2d025$var$M;
$354c6c187ec2d025$export$cf845f2c119da08a = function(a) {
    var b = $354c6c187ec2d025$var$y;
    return function() {
        var c = $354c6c187ec2d025$var$y;
        $354c6c187ec2d025$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $354c6c187ec2d025$var$y = c;
        }
    };
};

});




parcelRegister("kdMEA", function(module, exports) {

$parcel$export(module.exports, "mobileBreakpoint", () => $983afd5d6596f47e$export$2e65b7c7134e01f0);
$parcel$export(module.exports, "mediumBreakpoint", () => $983afd5d6596f47e$export$91e4bf93df95a062);
$parcel$export(module.exports, "CDNCharactersAddress", () => $983afd5d6596f47e$export$2475544086fd222b);
$parcel$export(module.exports, "CDNImagesAddress", () => $983afd5d6596f47e$export$f718170a6537817b);
$parcel$export(module.exports, "CDNAudioAddress", () => $983afd5d6596f47e$export$eefca12493f9e9b9);
$parcel$export(module.exports, "studioRetorik", () => $983afd5d6596f47e$export$c398bfda6cfa19ff);
$parcel$export(module.exports, "studioRetorikDev", () => $983afd5d6596f47e$export$9adff68f093278ec);
$parcel$export(module.exports, "studioRetorikStaging", () => $983afd5d6596f47e$export$409889737849a04f);
$parcel$export(module.exports, "studioRetorikExperimental", () => $983afd5d6596f47e$export$a4481ccc388fce2a);
$parcel$export(module.exports, "docsRetorik", () => $983afd5d6596f47e$export$1f4373411c991e56);
$parcel$export(module.exports, "openRoute", () => $983afd5d6596f47e$export$d6542303192de6db);
$parcel$export(module.exports, "openRouteAPIKey", () => $983afd5d6596f47e$export$6f60da16472d34a7);
$parcel$export(module.exports, "webchatTokenRetrievalAddress", () => $983afd5d6596f47e$export$d9e38c0112bbdae6);
$parcel$export(module.exports, "defaultDirectLineAddress", () => $983afd5d6596f47e$export$342c646308e8fa62);
$parcel$export(module.exports, "hospitalityApiAddress", () => $983afd5d6596f47e$export$1ca3e229e23d7f42);
$parcel$export(module.exports, "telemetryAddress", () => $983afd5d6596f47e$export$1e8c600abff9ea62);
$parcel$export(module.exports, "googleMapsAddress", () => $983afd5d6596f47e$export$f3c31933b33f3693);
$parcel$export(module.exports, "DEFAULT_LANGUAGE_DATA", () => $983afd5d6596f47e$export$8828fbbb6034a09b);
$parcel$export(module.exports, "DEFAULT_VIEWS", () => $983afd5d6596f47e$export$9bbca248acc786d3);
$parcel$export(module.exports, "DEFAULT_SUB_VIEWS", () => $983afd5d6596f47e$export$890576ebf405f6b7);
$parcel$export(module.exports, "mobileDisplays", () => $983afd5d6596f47e$export$78f16669b353a880);
$parcel$export(module.exports, "widgetDisplays", () => $983afd5d6596f47e$export$909f4c209eb70365);
$parcel$export(module.exports, "commonColors", () => $983afd5d6596f47e$export$c0da64553318f2cb);
$parcel$export(module.exports, "nonResponseInducingEvents", () => $983afd5d6596f47e$export$6a32bf5257e620e1);

var $2rYkD = parcelRequire("2rYkD");
const $983afd5d6596f47e$export$2e65b7c7134e01f0 = 600;
const $983afd5d6596f47e$export$91e4bf93df95a062 = 1300;
const $983afd5d6596f47e$export$66b40c15080ce99b = 'https://cdn.retorik.ai';
const $983afd5d6596f47e$export$2475544086fd222b = `${$983afd5d6596f47e$export$66b40c15080ce99b}/spiritenginehtml5/characters`;
const $983afd5d6596f47e$export$f718170a6537817b = `${$983afd5d6596f47e$export$66b40c15080ce99b}/retorik-framework/imagefiles`;
const $983afd5d6596f47e$export$eefca12493f9e9b9 = `${$983afd5d6596f47e$export$66b40c15080ce99b}/retorik-framework/audiofiles`;
const $983afd5d6596f47e$export$c398bfda6cfa19ff = 'https://studio.retorik.ai';
const $983afd5d6596f47e$export$9adff68f093278ec = 'https://dev.studio.retorik.ai';
const $983afd5d6596f47e$export$409889737849a04f = 'https://preview.studio.retorik.ai';
const $983afd5d6596f47e$export$a4481ccc388fce2a = 'https://experimental.studio.retorik.ai';
const $983afd5d6596f47e$export$1f4373411c991e56 = 'https://docs.retorik.ai';
const $983afd5d6596f47e$export$d6542303192de6db = 'https://api.openrouteservice.org/v2/directions';
const $983afd5d6596f47e$export$6f60da16472d34a7 = '5b3ce3597851110001cf62483cfd6bd46f934b7d96f108a35e0f08b8';
const $983afd5d6596f47e$export$dc91bcad81fffb1f = 'https://api.open-meteo.com/v1/forecast?';
const $983afd5d6596f47e$export$68b4ac416ba801c6 = '&daily=weathercode,temperature_2m_max,temperature_2m_min&timezone=auto&current_weather=true';
const $983afd5d6596f47e$export$d9e38c0112bbdae6 = 'K2.ContentFields.WebChat/api/GetWebchatToken';
const $983afd5d6596f47e$export$342c646308e8fa62 = 'https://directline.botframework.com/v3/directline';
const $983afd5d6596f47e$export$1ca3e229e23d7f42 = 'api/hospitality/Emergency';
const $983afd5d6596f47e$export$1e8c600abff9ea62 = 'https://telemetry.retorik.ai/otlp-http/v1/traces';
const $983afd5d6596f47e$export$f3c31933b33f3693 = 'https://www.google.com/maps/dir/?api=1&';
const $983afd5d6596f47e$export$8828fbbb6034a09b = {
    default: 'fr-FR',
    all: [
        'fr-FR'
    ]
};
const $983afd5d6596f47e$export$9bbca248acc786d3 = [
    {
        view: (0, $2rYkD.AvailableViews).home,
        indice: 1
    },
    {
        view: (0, $2rYkD.AvailableViews).emergency,
        indice: 2
    }
];
const $983afd5d6596f47e$export$890576ebf405f6b7 = [
    {
        view: (0, $2rYkD.AvailableSubViews).history,
        indice: 1
    },
    {
        view: (0, $2rYkD.AvailableSubViews).tutorial,
        indice: 2
    }
];
const $983afd5d6596f47e$export$78f16669b353a880 = [
    (0, $2rYkD.DeviceType).mobile,
    (0, $2rYkD.DeviceType).widget
];
const $983afd5d6596f47e$export$909f4c209eb70365 = [
    (0, $2rYkD.DeviceType).widget,
    (0, $2rYkD.DeviceType).widgetBorne,
    (0, $2rYkD.DeviceType).widgetLandscape
];
const $983afd5d6596f47e$export$baf53ca377ebf861 = [
    (0, $2rYkD.DeviceType).landscape,
    (0, $2rYkD.DeviceType).widgetLandscape
];
const $983afd5d6596f47e$export$a8576d98c9c928de = [
    (0, $2rYkD.DeviceType).borne,
    (0, $2rYkD.DeviceType).widgetBorne
];
const $983afd5d6596f47e$export$c0da64553318f2cb = {
    primary: '#00D7FF',
    secondary: '#1999B1',
    black: '#101219',
    whereToEatColor: '#FC952E',
    whereToSleepColor: '#9F007D',
    tobeSeenColor: '#76AB2A',
    tobeDoneColor: '#E23C2A',
    localProductsColor: '#AFB942',
    servicesColor: '#00C8BC',
    agendaColor: '#865DA2',
    occupantColor: '#6DEDBC'
};
const $983afd5d6596f47e$export$6a32bf5257e620e1 = [
    'davi.closewindow',
    'setuser',
    'davi.gdprconsent'
];
const $983afd5d6596f47e$export$882049267ad78ff6 = [
    'ar',
    'fa',
    'he',
    'ps',
    'ur'
];

});
parcelRegister("2rYkD", function(module, exports) {

$parcel$export(module.exports, "ActionType", () => $2f88b96f1155ba4b$export$e4a712fff93fb00f);
$parcel$export(module.exports, "AnimationSize", () => $2f88b96f1155ba4b$export$a2a634340dd7e3e3);
$parcel$export(module.exports, "AvailableViews", () => $2f88b96f1155ba4b$export$3b4d92ba873f009a);
$parcel$export(module.exports, "AvailableSubViews", () => $2f88b96f1155ba4b$export$c5a4c3ea2d78493c);
$parcel$export(module.exports, "CategoryId", () => $2f88b96f1155ba4b$export$22b261e08140d6b2);
$parcel$export(module.exports, "CloseButtonCause", () => $2f88b96f1155ba4b$export$ddddf2c97763af65);
$parcel$export(module.exports, "ContainerParent", () => $2f88b96f1155ba4b$export$a31c5a03aaeee5f);
$parcel$export(module.exports, "CurrentSubView", () => $2f88b96f1155ba4b$export$f05d0fed0593ead7);
$parcel$export(module.exports, "DeviceType", () => $2f88b96f1155ba4b$export$ec1e04e4e5ef8233);
$parcel$export(module.exports, "DisplayDataTypes", () => $2f88b96f1155ba4b$export$382c3885a1d469b4);
$parcel$export(module.exports, "Displays", () => $2f88b96f1155ba4b$export$972614fc43112105);
$parcel$export(module.exports, "ListStatus", () => $2f88b96f1155ba4b$export$2ba8159153a76219);
$parcel$export(module.exports, "Mode", () => $2f88b96f1155ba4b$export$9484bbecc3c49a2e);
$parcel$export(module.exports, "PermissionStatus", () => $2f88b96f1155ba4b$export$24ebbf8ea19b9f23);
$parcel$export(module.exports, "RetorikEvent", () => $2f88b96f1155ba4b$export$4f7cd669585dc69f);
$parcel$export(module.exports, "RecognitionState", () => $2f88b96f1155ba4b$export$3f0071308968cd80);
$parcel$export(module.exports, "RemoteButtonType", () => $2f88b96f1155ba4b$export$4112462e5af80a05);
$parcel$export(module.exports, "Routes", () => $2f88b96f1155ba4b$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "Source3DEngine", () => $2f88b96f1155ba4b$export$beb88f8efcd110a3);
$parcel$export(module.exports, "UIPart", () => $2f88b96f1155ba4b$export$63fc5f52b5b4da1e);
$parcel$export(module.exports, "TemplateTarget", () => $2f88b96f1155ba4b$export$a86aed12858d578);
$parcel$export(module.exports, "TextFrom", () => $2f88b96f1155ba4b$export$b685c7d489184507);
$parcel$export(module.exports, "Theme", () => $2f88b96f1155ba4b$export$14faa19a0f3bbeb2);
$parcel$export(module.exports, "TraceType", () => $2f88b96f1155ba4b$export$d4b4ca0ba30ae29c);
var $2f88b96f1155ba4b$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["message"] = "message";
    ActionType["event"] = "event";
    ActionType["url"] = "url";
    ActionType["internal"] = "internal";
    return ActionType;
}($2f88b96f1155ba4b$export$e4a712fff93fb00f || {});
var $2f88b96f1155ba4b$export$a2a634340dd7e3e3 = /*#__PURE__*/ function(AnimationSize) {
    AnimationSize[AnimationSize["small"] = 0] = "small";
    AnimationSize[AnimationSize["medium"] = 1] = "medium";
    AnimationSize[AnimationSize["large"] = 2] = "large";
    return AnimationSize;
}($2f88b96f1155ba4b$export$a2a634340dd7e3e3 || {});
/**
 * @deprecated AvailableViews is deprecated without replacement since version 2.2.0 and the new menu system
 */ var $2f88b96f1155ba4b$export$3b4d92ba873f009a = /*#__PURE__*/ function(AvailableViews) {
    AvailableViews[AvailableViews["home"] = 1] = "home";
    AvailableViews[AvailableViews["news"] = 2] = "news";
    AvailableViews[AvailableViews["weather"] = 3] = "weather";
    AvailableViews[AvailableViews["emergency"] = 4] = "emergency";
    return AvailableViews;
}($2f88b96f1155ba4b$export$3b4d92ba873f009a || {});
/**
 * @deprecated AvailableSubViews is deprecated without replacement since version 2.2.0 and the new menu system
 */ var $2f88b96f1155ba4b$export$c5a4c3ea2d78493c = /*#__PURE__*/ function(AvailableSubViews) {
    AvailableSubViews[AvailableSubViews["history"] = 1000] = "history";
    AvailableSubViews[AvailableSubViews["tutorial"] = 1001] = "tutorial";
    return AvailableSubViews;
}($2f88b96f1155ba4b$export$c5a4c3ea2d78493c || {});
var $2f88b96f1155ba4b$export$22b261e08140d6b2 = /*#__PURE__*/ function(CategoryId) {
    CategoryId["eat"] = "where to eat";
    CategoryId["sleep"] = "where to sleep";
    CategoryId["see"] = "what to see";
    CategoryId["do"] = "what to do";
    CategoryId["localproducts"] = "local products";
    CategoryId["services"] = "services";
    CategoryId["agenda"] = "events";
    CategoryId["occupant"] = "occupant";
    return CategoryId;
}($2f88b96f1155ba4b$export$22b261e08140d6b2 || {});
var $2f88b96f1155ba4b$export$ddddf2c97763af65 = /*#__PURE__*/ function(CloseButtonCause) {
    CloseButtonCause["none"] = "None";
    CloseButtonCause["detailedpoi"] = "Detailed";
    CloseButtonCause["list"] = "List";
    CloseButtonCause["history"] = "History";
    CloseButtonCause["languages"] = "Languages";
    CloseButtonCause["weather"] = "Weather";
    CloseButtonCause["emergency"] = "Emergency";
    CloseButtonCause["map"] = "Map";
    CloseButtonCause["dashboard"] = "Dashboard";
    CloseButtonCause["fullscreenimage"] = "FullscreenImage";
    CloseButtonCause["news"] = "News";
    return CloseButtonCause;
}($2f88b96f1155ba4b$export$ddddf2c97763af65 || {});
var $2f88b96f1155ba4b$export$a31c5a03aaeee5f = /*#__PURE__*/ function(ContainerParent) {
    ContainerParent[ContainerParent["agent"] = 1] = "agent";
    ContainerParent[ContainerParent["widget"] = 2] = "widget";
    ContainerParent[ContainerParent["news"] = 3] = "news";
    return ContainerParent;
}($2f88b96f1155ba4b$export$a31c5a03aaeee5f || {});
var $2f88b96f1155ba4b$export$f05d0fed0593ead7 = /*#__PURE__*/ function(CurrentSubView) {
    CurrentSubView[CurrentSubView["none"] = 1] = "none";
    CurrentSubView[CurrentSubView["history"] = 2] = "history";
    CurrentSubView[CurrentSubView["languages"] = 3] = "languages";
    CurrentSubView[CurrentSubView["weather"] = 4] = "weather";
    CurrentSubView[CurrentSubView["emergency"] = 5] = "emergency";
    CurrentSubView[CurrentSubView["map"] = 6] = "map";
    CurrentSubView[CurrentSubView["custom"] = 7] = "custom";
    return CurrentSubView;
}($2f88b96f1155ba4b$export$f05d0fed0593ead7 || {});
var $2f88b96f1155ba4b$export$950556173b6cbecb = /*#__PURE__*/ function(Depth) {
    Depth[Depth["background"] = 1] = "background";
    Depth[Depth["util"] = 2] = "util";
    Depth[Depth["chatbot"] = 3] = "chatbot";
    Depth[Depth["ui"] = 4] = "ui";
    Depth[Depth["dropdown"] = 5] = "dropdown";
    Depth[Depth["overlay"] = 6] = "overlay";
    Depth[Depth["menu"] = 7] = "menu";
    Depth[Depth["modal"] = 8] = "modal";
    Depth[Depth["exitwidget"] = 9] = "exitwidget";
    return Depth;
}($2f88b96f1155ba4b$export$950556173b6cbecb || {});
var $2f88b96f1155ba4b$export$ec1e04e4e5ef8233 = /*#__PURE__*/ function(DeviceType) {
    DeviceType[DeviceType["mobile"] = 1] = "mobile";
    DeviceType[DeviceType["borne"] = 2] = "borne";
    DeviceType[DeviceType["landscape"] = 3] = "landscape";
    DeviceType[DeviceType["widget"] = 4] = "widget";
    DeviceType[DeviceType["widgetLandscape"] = 5] = "widgetLandscape";
    DeviceType[DeviceType["widgetBorne"] = 6] = "widgetBorne";
    return DeviceType;
}($2f88b96f1155ba4b$export$ec1e04e4e5ef8233 || {});
var $2f88b96f1155ba4b$export$382c3885a1d469b4 = /*#__PURE__*/ function(DisplayDataTypes) {
    DisplayDataTypes[DisplayDataTypes["text"] = 0] = "text";
    DisplayDataTypes[DisplayDataTypes["attachment"] = 1] = "attachment";
    return DisplayDataTypes;
}($2f88b96f1155ba4b$export$382c3885a1d469b4 || {});
var $2f88b96f1155ba4b$export$972614fc43112105 = /*#__PURE__*/ function(Displays) {
    Displays[Displays["none"] = 0] = "none";
    Displays[Displays["normal"] = 1] = "normal";
    Displays[Displays["carousel"] = 2] = "carousel";
    Displays[Displays["grid"] = 3] = "grid";
    Displays[Displays["carouselgrid"] = 4] = "carouselgrid";
    Displays[Displays["list"] = 5] = "list";
    return Displays;
}($2f88b96f1155ba4b$export$972614fc43112105 || {});
var $2f88b96f1155ba4b$export$f0cfc93288d9ec06 = /*#__PURE__*/ function(Emotions) {
    Emotions["Regret"] = "regret";
    Emotions["Dislike"] = "dislike";
    Emotions["Distress"] = "distress";
    Emotions["Fear"] = "fear";
    Emotions["Sadness"] = "sadness";
    Emotions["Shame"] = "shame";
    Emotions["Contempt"] = "contempt";
    Emotions["Disgust"] = "disgust";
    Emotions["Guilt"] = "guilt";
    Emotions["Anger"] = "anger";
    Emotions["Frustration"] = "frustration";
    Emotions["Pride"] = "pride";
    Emotions["Love"] = "love";
    Emotions["Relief"] = "relief";
    Emotions["Joy"] = "joy";
    Emotions["Hope"] = "hope";
    return Emotions;
}($2f88b96f1155ba4b$export$f0cfc93288d9ec06 || {});
var $2f88b96f1155ba4b$export$d5c9907f7475220b = /*#__PURE__*/ function(InputHintBehaviour) {
    InputHintBehaviour["auto"] = "auto";
    InputHintBehaviour["always"] = "always";
    InputHintBehaviour["never"] = "never";
    InputHintBehaviour["ignore"] = "ignore";
    return InputHintBehaviour;
}($2f88b96f1155ba4b$export$d5c9907f7475220b || {});
var $2f88b96f1155ba4b$export$2ba8159153a76219 = /*#__PURE__*/ function(ListStatus) {
    ListStatus[ListStatus["available"] = 1] = "available";
    ListStatus[ListStatus["opened"] = 2] = "opened";
    ListStatus[ListStatus["closing"] = 3] = "closing";
    ListStatus[ListStatus["closed"] = 4] = "closed";
    return ListStatus;
}($2f88b96f1155ba4b$export$2ba8159153a76219 || {});
var $2f88b96f1155ba4b$export$bd7313a2f8345cae = /*#__PURE__*/ function(LoaderSteps) {
    LoaderSteps[LoaderSteps["loader"] = 1] = "loader";
    LoaderSteps[LoaderSteps["locale"] = 2] = "locale";
    LoaderSteps[LoaderSteps["supported"] = 3] = "supported";
    LoaderSteps[LoaderSteps["store"] = 4] = "store";
    LoaderSteps[LoaderSteps["directline"] = 5] = "directline";
    LoaderSteps[LoaderSteps["ponyfill"] = 6] = "ponyfill";
    LoaderSteps[LoaderSteps["agentdata"] = 7] = "agentdata";
    return LoaderSteps;
}($2f88b96f1155ba4b$export$bd7313a2f8345cae || {});
var $2f88b96f1155ba4b$export$9484bbecc3c49a2e = /*#__PURE__*/ function(Mode) {
    Mode[Mode["vocal"] = 1] = "vocal";
    Mode[Mode["text"] = 2] = "text";
    Mode[Mode["dashboard"] = 3] = "dashboard";
    return Mode;
}($2f88b96f1155ba4b$export$9484bbecc3c49a2e || {});
var $2f88b96f1155ba4b$export$24ebbf8ea19b9f23 = /*#__PURE__*/ function(PermissionStatus) {
    PermissionStatus[PermissionStatus["waiting"] = 1] = "waiting";
    PermissionStatus[PermissionStatus["allowed"] = 2] = "allowed";
    PermissionStatus[PermissionStatus["refused"] = 3] = "refused";
    PermissionStatus[PermissionStatus["error"] = 4] = "error";
    return PermissionStatus;
}($2f88b96f1155ba4b$export$24ebbf8ea19b9f23 || {});
var $2f88b96f1155ba4b$export$13807d9ee5a34a42 = /*#__PURE__*/ function(Position) {
    Position[Position["top"] = 1] = "top";
    Position[Position["right"] = 2] = "right";
    Position[Position["bottom"] = 3] = "bottom";
    Position[Position["left"] = 4] = "left";
    return Position;
}($2f88b96f1155ba4b$export$13807d9ee5a34a42 || {});
var $2f88b96f1155ba4b$export$4f7cd669585dc69f = /*#__PURE__*/ function(RetorikEvent) {
    RetorikEvent[RetorikEvent["DetailViewOpen"] = 1] = "DetailViewOpen";
    RetorikEvent[RetorikEvent["DetailViewClose"] = 2] = "DetailViewClose";
    RetorikEvent[RetorikEvent["SpeechStarted"] = 3] = "SpeechStarted";
    RetorikEvent[RetorikEvent["SpeechEnded"] = 4] = "SpeechEnded";
    return RetorikEvent;
}($2f88b96f1155ba4b$export$4f7cd669585dc69f || {});
var $2f88b96f1155ba4b$export$3f0071308968cd80 = /*#__PURE__*/ function(RecognitionState) {
    RecognitionState[RecognitionState["Initializing"] = 1] = "Initializing";
    RecognitionState[RecognitionState["Listening"] = 2] = "Listening";
    RecognitionState[RecognitionState["Closing"] = 3] = "Closing";
    RecognitionState[RecognitionState["ForceClosing"] = 4] = "ForceClosing";
    RecognitionState[RecognitionState["Closed"] = 5] = "Closed";
    return RecognitionState;
}($2f88b96f1155ba4b$export$3f0071308968cd80 || {});
var $2f88b96f1155ba4b$export$4112462e5af80a05 = /*#__PURE__*/ function(RemoteButtonType) {
    RemoteButtonType["home"] = "home";
    RemoteButtonType["menu"] = "menu";
    RemoteButtonType["language"] = "language";
    RemoteButtonType["subtitles"] = "subtitles";
    RemoteButtonType["sound"] = "sound";
    RemoteButtonType["history"] = "history";
    RemoteButtonType["text"] = "text";
    RemoteButtonType["close"] = "close";
    return RemoteButtonType;
}($2f88b96f1155ba4b$export$4112462e5af80a05 || {});
var $2f88b96f1155ba4b$export$3565eb3d00ca5a74 = /*#__PURE__*/ function(Routes) {
    Routes[Routes["Home"] = 1] = "Home";
    Routes[Routes["News"] = 2] = "News";
    Routes[Routes["EmptyVeille"] = 3] = "EmptyVeille";
    Routes[Routes["ScreenSaver"] = 4] = "ScreenSaver";
    Routes[Routes["SlideShow"] = 5] = "SlideShow";
    Routes[Routes["NewsInVeille"] = 6] = "NewsInVeille";
    return Routes;
}($2f88b96f1155ba4b$export$3565eb3d00ca5a74 || {});
var $2f88b96f1155ba4b$export$beb88f8efcd110a3 = /*#__PURE__*/ function(Source3DEngine) {
    Source3DEngine["avatarsdk"] = "avatarsdk";
    Source3DEngine["avatarsdkbis"] = "avatar-sdk";
    Source3DEngine["avaturn"] = "avaturn";
    Source3DEngine["cc3"] = "cc3";
    Source3DEngine["cc4"] = "cc4";
    Source3DEngine["rpm"] = "rpm";
    Source3DEngine["readyplayerme"] = "readyplayerme";
    return Source3DEngine;
}($2f88b96f1155ba4b$export$beb88f8efcd110a3 || {});
var $2f88b96f1155ba4b$export$63fc5f52b5b4da1e = /*#__PURE__*/ function(UIPart) {
    UIPart[UIPart["none"] = 1] = "none";
    UIPart[UIPart["agent"] = 2] = "agent";
    UIPart[UIPart["background"] = 3] = "background";
    UIPart[UIPart["remote"] = 4] = "remote";
    UIPart[UIPart["languages"] = 5] = "languages";
    UIPart[UIPart["card"] = 6] = "card";
    UIPart[UIPart["qroverlay"] = 7] = "qroverlay";
    return UIPart;
}($2f88b96f1155ba4b$export$63fc5f52b5b4da1e || {});
var $2f88b96f1155ba4b$export$a86aed12858d578 = /*#__PURE__*/ function(TemplateTarget) {
    TemplateTarget["detailedAttachment"] = "detailed-attachment";
    TemplateTarget["fullscreenImage"] = "fullscreen-image";
    TemplateTarget["history"] = "history";
    TemplateTarget["languages"] = "languages";
    TemplateTarget["emergency"] = "emergency";
    TemplateTarget["weather"] = "weather";
    TemplateTarget["list"] = "list";
    TemplateTarget["map"] = "map";
    TemplateTarget["menu"] = "menu";
    TemplateTarget["modal"] = "modal";
    TemplateTarget["mobileDefault"] = "mobile-default";
    TemplateTarget["mobileConversation"] = "mobile-conversation";
    TemplateTarget["mobileOther"] = "mobile-other";
    return TemplateTarget;
}($2f88b96f1155ba4b$export$a86aed12858d578 || {});
var $2f88b96f1155ba4b$export$b685c7d489184507 = /*#__PURE__*/ function(TextFrom) {
    TextFrom["user"] = "user";
    TextFrom["bot"] = "bot";
    return TextFrom;
}($2f88b96f1155ba4b$export$b685c7d489184507 || {});
var $2f88b96f1155ba4b$export$14faa19a0f3bbeb2 = /*#__PURE__*/ function(Theme) {
    Theme["dark"] = "dark";
    Theme["light"] = "light";
    Theme["auto"] = "auto";
    return Theme;
}($2f88b96f1155ba4b$export$14faa19a0f3bbeb2 || {});
var $2f88b96f1155ba4b$export$d4b4ca0ba30ae29c = /*#__PURE__*/ function(TraceType) {
    TraceType["message"] = "directlineMessage";
    TraceType["utteranceStart"] = "utteranceStart";
    TraceType["utteranceEnd"] = "utteranceEnd";
    return TraceType;
}($2f88b96f1155ba4b$export$d4b4ca0ba30ae29c || {});

});


parcelRegister("5FZWK", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $98814d3898247587$export$2881499e37b75b9a);
$parcel$export(module.exports, "useDispatch", () => $98814d3898247587$export$8ad76b76a4c905f8);
$parcel$export(module.exports, "useSelector", () => $98814d3898247587$export$2105062e25df4afe);
// src/utils/react.ts

var $bxRTa = parcelRequire("bxRTa");

var $ikm5s = parcelRequire("ikm5s");
// src/utils/react-is.ts
var $98814d3898247587$var$IS_REACT_19 = /* @__PURE__ */ $bxRTa.version.startsWith("19");
var $98814d3898247587$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($98814d3898247587$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $98814d3898247587$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $98814d3898247587$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $98814d3898247587$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $98814d3898247587$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $98814d3898247587$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $98814d3898247587$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $98814d3898247587$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $98814d3898247587$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $98814d3898247587$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $98814d3898247587$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $98814d3898247587$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $98814d3898247587$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $98814d3898247587$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $98814d3898247587$var$ForwardRef = $98814d3898247587$var$REACT_FORWARD_REF_TYPE;
var $98814d3898247587$var$Memo = $98814d3898247587$var$REACT_MEMO_TYPE;
function $98814d3898247587$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $98814d3898247587$var$REACT_FRAGMENT_TYPE || type === $98814d3898247587$var$REACT_PROFILER_TYPE || type === $98814d3898247587$var$REACT_STRICT_MODE_TYPE || type === $98814d3898247587$var$REACT_SUSPENSE_TYPE || type === $98814d3898247587$var$REACT_SUSPENSE_LIST_TYPE || type === $98814d3898247587$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $98814d3898247587$var$REACT_LAZY_TYPE || type.$$typeof === $98814d3898247587$var$REACT_MEMO_TYPE || type.$$typeof === $98814d3898247587$var$REACT_CONTEXT_TYPE || type.$$typeof === $98814d3898247587$var$REACT_CONSUMER_TYPE || type.$$typeof === $98814d3898247587$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $98814d3898247587$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $98814d3898247587$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $98814d3898247587$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $98814d3898247587$var$REACT_FRAGMENT_TYPE:
                    case $98814d3898247587$var$REACT_PROFILER_TYPE:
                    case $98814d3898247587$var$REACT_STRICT_MODE_TYPE:
                    case $98814d3898247587$var$REACT_SUSPENSE_TYPE:
                    case $98814d3898247587$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $98814d3898247587$var$REACT_CONTEXT_TYPE:
                            case $98814d3898247587$var$REACT_FORWARD_REF_TYPE:
                            case $98814d3898247587$var$REACT_LAZY_TYPE:
                            case $98814d3898247587$var$REACT_MEMO_TYPE:
                                return object;
                            case $98814d3898247587$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $98814d3898247587$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $98814d3898247587$var$isContextConsumer(object) {
    return $98814d3898247587$var$IS_REACT_19 ? $98814d3898247587$var$typeOf(object) === $98814d3898247587$var$REACT_CONSUMER_TYPE : $98814d3898247587$var$typeOf(object) === $98814d3898247587$var$REACT_CONTEXT_TYPE;
}
function $98814d3898247587$var$isMemo(object) {
    return $98814d3898247587$var$typeOf(object) === $98814d3898247587$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $98814d3898247587$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $98814d3898247587$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $98814d3898247587$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $98814d3898247587$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $98814d3898247587$var$verify(mapStateToProps, "mapStateToProps");
    $98814d3898247587$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $98814d3898247587$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $98814d3898247587$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $98814d3898247587$var$finalPropsSelectorFactory(dispatch, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps, ...options }) {
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $98814d3898247587$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $98814d3898247587$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $98814d3898247587$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $98814d3898247587$var$verifyPlainObject(value, displayName, methodName) {
    if (!$98814d3898247587$var$isPlainObject(value)) $98814d3898247587$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $98814d3898247587$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $98814d3898247587$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $98814d3898247587$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $98814d3898247587$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $98814d3898247587$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $98814d3898247587$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $98814d3898247587$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $98814d3898247587$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $98814d3898247587$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $98814d3898247587$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $98814d3898247587$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $98814d3898247587$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $98814d3898247587$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $98814d3898247587$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $98814d3898247587$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $98814d3898247587$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $98814d3898247587$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
}
function $98814d3898247587$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $98814d3898247587$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$98814d3898247587$var$defaultMergeProps : typeof mergeProps === "function" ? $98814d3898247587$var$wrapMergePropsFunc(mergeProps) : $98814d3898247587$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $98814d3898247587$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $98814d3898247587$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $98814d3898247587$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $98814d3898247587$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $98814d3898247587$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $98814d3898247587$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $98814d3898247587$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $98814d3898247587$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $98814d3898247587$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $98814d3898247587$var$isDOM = /* @__PURE__ */ $98814d3898247587$var$canUseDOM();
var $98814d3898247587$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $98814d3898247587$var$isReactNative = /* @__PURE__ */ $98814d3898247587$var$isRunningInReactNative();
var $98814d3898247587$var$getUseIsomorphicLayoutEffect = ()=>$98814d3898247587$var$isDOM || $98814d3898247587$var$isReactNative ? $bxRTa.useLayoutEffect : $bxRTa.useEffect;
var $98814d3898247587$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $98814d3898247587$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $98814d3898247587$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $98814d3898247587$export$d36bdfa510afb180(objA, objB) {
    if ($98814d3898247587$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$98814d3898247587$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $98814d3898247587$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $98814d3898247587$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $98814d3898247587$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $98814d3898247587$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $98814d3898247587$var$TYPE_STATICS = {
    [$98814d3898247587$var$ForwardRef]: $98814d3898247587$var$FORWARD_REF_STATICS,
    [$98814d3898247587$var$Memo]: $98814d3898247587$var$MEMO_STATICS
};
function $98814d3898247587$var$getStatics(component) {
    if ($98814d3898247587$var$isMemo(component)) return $98814d3898247587$var$MEMO_STATICS;
    return $98814d3898247587$var$TYPE_STATICS[component["$$typeof"]] || $98814d3898247587$var$REACT_STATICS;
}
var $98814d3898247587$var$defineProperty = Object.defineProperty;
var $98814d3898247587$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $98814d3898247587$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $98814d3898247587$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $98814d3898247587$var$getPrototypeOf = Object.getPrototypeOf;
var $98814d3898247587$var$objectPrototype = Object.prototype;
function $98814d3898247587$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($98814d3898247587$var$objectPrototype) {
            const inheritedComponent = $98814d3898247587$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $98814d3898247587$var$objectPrototype) $98814d3898247587$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $98814d3898247587$var$getOwnPropertyNames(sourceComponent);
        if ($98814d3898247587$var$getOwnPropertySymbols) keys = keys.concat($98814d3898247587$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $98814d3898247587$var$getStatics(targetComponent);
        const sourceStatics = $98814d3898247587$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$98814d3898247587$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $98814d3898247587$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $98814d3898247587$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $98814d3898247587$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $98814d3898247587$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $98814d3898247587$var$getContext() {
    if (!$bxRTa.createContext) return {};
    const contextMap = $98814d3898247587$var$gT[$98814d3898247587$var$ContextKey] ??= /* @__PURE__ */ new Map();
    let realContext = contextMap.get($bxRTa.createContext);
    if (!realContext) {
        realContext = $bxRTa.createContext(null);
        contextMap.set($bxRTa.createContext, realContext);
    }
    return realContext;
}
var $98814d3898247587$export$cc80c08dc91f1c00 = /* @__PURE__ */ $98814d3898247587$var$getContext();
// src/components/connect.tsx
var $98814d3898247587$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $98814d3898247587$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $98814d3898247587$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $98814d3898247587$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $98814d3898247587$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $98814d3898247587$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $98814d3898247587$var$strictEqual(a, b) {
    return a === b;
}
var $98814d3898247587$var$hasWarnedAboutDeprecatedPureOption = false;
function $98814d3898247587$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $98814d3898247587$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $98814d3898247587$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $98814d3898247587$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $98814d3898247587$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $98814d3898247587$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $98814d3898247587$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $98814d3898247587$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $98814d3898247587$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $bxRTa.useMemo(()=>{
                const { reactReduxForwardedRef: reactReduxForwardedRef2, ...wrapperProps2 } = props;
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $bxRTa.useMemo(()=>{
                let ResultContext = Context;
                propsContext?.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $bxRTa.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $bxRTa.useMemo(()=>{
                return $98814d3898247587$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $bxRTa.useMemo(()=>{
                if (!shouldHandleStateChanges) return $98814d3898247587$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $98814d3898247587$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $bxRTa.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return {
                    ...contextValue,
                    subscription: subscription
                };
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $bxRTa.useRef(void 0);
            const lastWrapperProps = $bxRTa.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $bxRTa.useRef(void 0);
            const renderIsScheduled = $bxRTa.useRef(false);
            const isMounted = $bxRTa.useRef(false);
            const latestSubscriptionCallbackError = $bxRTa.useRef(void 0);
            $98814d3898247587$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $bxRTa.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $bxRTa.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $98814d3898247587$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $98814d3898247587$var$useIsomorphicLayoutEffectWithArgs($98814d3898247587$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $bxRTa.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $98814d3898247587$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $bxRTa.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $bxRTa.createElement(WrappedComponent, {
                    ...actualChildProps,
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $bxRTa.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $bxRTa.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $bxRTa.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $bxRTa.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $bxRTa.createElement(Connect, {
                    ...props,
                    reactReduxForwardedRef: ref
                });
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $98814d3898247587$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $98814d3898247587$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $98814d3898247587$export$64605811ab45167f = $98814d3898247587$var$connect;
// src/components/Provider.tsx
function $98814d3898247587$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $bxRTa.useMemo(()=>{
        const subscription = $98814d3898247587$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $bxRTa.useMemo(()=>store.getState(), [
        store
    ]);
    $98814d3898247587$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $98814d3898247587$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $bxRTa.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $98814d3898247587$export$2881499e37b75b9a = $98814d3898247587$var$Provider;
// src/hooks/useReduxContext.ts
function $98814d3898247587$var$createReduxContextHook(context = $98814d3898247587$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $bxRTa.useContext(context);
        return contextValue;
    };
}
var $98814d3898247587$var$useReduxContext = /* @__PURE__ */ $98814d3898247587$var$createReduxContextHook();
// src/hooks/useStore.ts
function $98814d3898247587$export$671dba69185d0304(context = $98814d3898247587$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $98814d3898247587$export$cc80c08dc91f1c00 ? $98814d3898247587$var$useReduxContext : // @ts-ignore
    $98814d3898247587$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $98814d3898247587$export$6ccbb43953eebf8 = /* @__PURE__ */ $98814d3898247587$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $98814d3898247587$export$bc9b55530897c558(context = $98814d3898247587$export$cc80c08dc91f1c00) {
    const useStore2 = context === $98814d3898247587$export$cc80c08dc91f1c00 ? $98814d3898247587$export$6ccbb43953eebf8 : $98814d3898247587$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $98814d3898247587$export$8ad76b76a4c905f8 = /* @__PURE__ */ $98814d3898247587$export$bc9b55530897c558();
var $98814d3898247587$var$refEquality = (a, b)=>a === b;
function $98814d3898247587$export$2b53f90d2bd1cbfb(context = $98814d3898247587$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $98814d3898247587$export$cc80c08dc91f1c00 ? $98814d3898247587$var$useReduxContext : $98814d3898247587$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $98814d3898247587$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $bxRTa.useRef(true);
        const wrappedSelector = $bxRTa.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $ikm5s.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $bxRTa.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $98814d3898247587$export$2105062e25df4afe = /* @__PURE__ */ $98814d3898247587$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $98814d3898247587$export$712ea50be43a7858 = $98814d3898247587$var$defaultNoopBatch;

});
parcelRegister("ikm5s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lkmQM"));

});
parcelRegister("lkmQM", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $f86d30ceadfde919$export$bf730a2d8bf68b42, (v) => $f86d30ceadfde919$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f86d30ceadfde919$export$bf730a2d8bf68b42;
"use strict";

var $bxRTa = parcelRequire("bxRTa");
function $f86d30ceadfde919$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f86d30ceadfde919$var$objectIs = "function" === typeof Object.is ? Object.is : $f86d30ceadfde919$var$is, $f86d30ceadfde919$var$useSyncExternalStore = $bxRTa.useSyncExternalStore, $f86d30ceadfde919$var$useRef = $bxRTa.useRef, $f86d30ceadfde919$var$useEffect = $bxRTa.useEffect, $f86d30ceadfde919$var$useMemo = $bxRTa.useMemo, $f86d30ceadfde919$var$useDebugValue = $bxRTa.useDebugValue;
$f86d30ceadfde919$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $f86d30ceadfde919$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $f86d30ceadfde919$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($f86d30ceadfde919$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $f86d30ceadfde919$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $f86d30ceadfde919$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $f86d30ceadfde919$var$useDebugValue(value);
    return value;
};

});



parcelRegister("cto9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $914aec8743edd630$export$2e2bcd8739ae039);
$parcel$export(module.exports, "storeActions", () => $914aec8743edd630$export$8b3bc28eb06c49b6);
$parcel$export(module.exports, "ConnectionStatus", () => $914aec8743edd630$export$7516420eb880ab68);
var $914aec8743edd630$var$pv = Object.defineProperty;
var $914aec8743edd630$var$mv = (e, t, r)=>t in e ? $914aec8743edd630$var$pv(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r;
var $914aec8743edd630$var$gi = (e, t, r)=>$914aec8743edd630$var$mv(e, typeof t != "symbol" ? t + "" : t, r);
function $914aec8743edd630$var$Le(e) {
    return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var $914aec8743edd630$var$gv = typeof Symbol == "function" && Symbol.observable || "@@observable", $914aec8743edd630$var$qc = $914aec8743edd630$var$gv, $914aec8743edd630$var$bi = ()=>Math.random().toString(36).substring(7).split("").join("."), $914aec8743edd630$var$bv = {
    INIT: `@@redux/INIT${$914aec8743edd630$var$bi()}`,
    REPLACE: `@@redux/REPLACE${$914aec8743edd630$var$bi()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$914aec8743edd630$var$bi()}`
}, $914aec8743edd630$var$jt = $914aec8743edd630$var$bv;
function $914aec8743edd630$var$nn(e) {
    if (typeof e != "object" || e === null) return !1;
    let t = e;
    for(; Object.getPrototypeOf(t) !== null;)t = Object.getPrototypeOf(t);
    return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function $914aec8743edd630$var$vv(e) {
    if (e === void 0) return "undefined";
    if (e === null) return "null";
    const t = typeof e;
    switch(t){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return t;
    }
    if (Array.isArray(e)) return "array";
    if ($914aec8743edd630$var$_v(e)) return "date";
    if ($914aec8743edd630$var$wv(e)) return "error";
    const r = $914aec8743edd630$var$yv(e);
    switch(r){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return r;
    }
    return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $914aec8743edd630$var$yv(e) {
    return typeof e.constructor == "function" ? e.constructor.name : null;
}
function $914aec8743edd630$var$wv(e) {
    return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function $914aec8743edd630$var$_v(e) {
    return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function $914aec8743edd630$var$xt(e) {
    let t = typeof e;
    return t;
}
function $914aec8743edd630$var$ym(e, t, r) {
    if (typeof e != "function") throw new Error($914aec8743edd630$var$Le(2));
    if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function") throw new Error($914aec8743edd630$var$Le(0));
    if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
        if (typeof r != "function") throw new Error($914aec8743edd630$var$Le(1));
        return r($914aec8743edd630$var$ym)(e, t);
    }
    let i = e, n = t, o = /* @__PURE__ */ new Map(), s = o, a = 0, u = !1;
    function l() {
        s === o && (s = /* @__PURE__ */ new Map(), o.forEach((w, v)=>{
            s.set(v, w);
        }));
    }
    function c() {
        if (u) throw new Error($914aec8743edd630$var$Le(3));
        return n;
    }
    function d(w) {
        if (typeof w != "function") throw new Error($914aec8743edd630$var$Le(4));
        if (u) throw new Error($914aec8743edd630$var$Le(5));
        let v = !0;
        l();
        const g = a++;
        return s.set(g, w), function() {
            if (v) {
                if (u) throw new Error($914aec8743edd630$var$Le(6));
                v = !1, l(), s.delete(g), o = null;
            }
        };
    }
    function h(w) {
        if (!$914aec8743edd630$var$nn(w)) throw new Error($914aec8743edd630$var$Le(7));
        if (typeof w.type > "u") throw new Error($914aec8743edd630$var$Le(8));
        if (typeof w.type != "string") throw new Error($914aec8743edd630$var$Le(17));
        if (u) throw new Error($914aec8743edd630$var$Le(9));
        try {
            u = !0, n = i(n, w);
        } finally{
            u = !1;
        }
        return (o = s).forEach((g)=>{
            g();
        }), w;
    }
    function f(w) {
        if (typeof w != "function") throw new Error($914aec8743edd630$var$Le(10));
        i = w, h({
            type: $914aec8743edd630$var$jt.REPLACE
        });
    }
    function p() {
        const w = d;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (v) {
                if (typeof v != "object" || v === null) throw new Error($914aec8743edd630$var$Le(11));
                function g() {
                    const b = v;
                    b.next && b.next(c());
                }
                return g(), {
                    unsubscribe: w(g)
                };
            },
            [$914aec8743edd630$var$qc] () {
                return this;
            }
        };
    }
    return h({
        type: $914aec8743edd630$var$jt.INIT
    }), {
        dispatch: h,
        subscribe: d,
        getState: c,
        replaceReducer: f,
        [$914aec8743edd630$var$qc]: p
    };
}
function $914aec8743edd630$var$zc(e) {
    typeof console < "u" && typeof console.error == "function" && console.error(e);
    try {
        throw new Error(e);
    } catch  {}
}
function $914aec8743edd630$var$kv(e, t, r, i) {
    const n = Object.keys(t), o = r && r.type === $914aec8743edd630$var$jt.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (n.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$914aec8743edd630$var$nn(e)) return `The ${o} has unexpected type of "${$914aec8743edd630$var$xt(e)}". Expected argument to be an object with the following keys: "${n.join('", "')}"`;
    const s = Object.keys(e).filter((a)=>!t.hasOwnProperty(a) && !i[a]);
    if (s.forEach((a)=>{
        i[a] = !0;
    }), !(r && r.type === $914aec8743edd630$var$jt.REPLACE) && s.length > 0) return `Unexpected ${s.length > 1 ? "keys" : "key"} "${s.join('", "')}" found in ${o}. Expected to find one of the known reducer keys instead: "${n.join('", "')}". Unexpected keys will be ignored.`;
}
function $914aec8743edd630$var$xv(e) {
    Object.keys(e).forEach((t)=>{
        const r = e[t];
        if (typeof r(void 0, {
            type: $914aec8743edd630$var$jt.INIT
        }) > "u") throw new Error($914aec8743edd630$var$Le(12));
        if (typeof r(void 0, {
            type: $914aec8743edd630$var$jt.PROBE_UNKNOWN_ACTION()
        }) > "u") throw new Error($914aec8743edd630$var$Le(13));
    });
}
function $914aec8743edd630$var$wm(e) {
    const t = Object.keys(e), r = {};
    for(let s = 0; s < t.length; s++){
        const a = t[s];
        typeof e[a] == "function" && (r[a] = e[a]);
    }
    const i = Object.keys(r);
    let n;
    let o;
    try {
        $914aec8743edd630$var$xv(r);
    } catch (s) {
        o = s;
    }
    return function(a = {}, u) {
        if (o) throw o;
        let l = !1;
        const c = {};
        for(let d = 0; d < i.length; d++){
            const h = i[d], f = r[h], p = a[h], m = f(p, u);
            if (typeof m > "u") {
                const w = u && u.type;
                throw new Error($914aec8743edd630$var$Le(14));
            }
            c[h] = m, l = l || m !== p;
        }
        return l = l || i.length !== Object.keys(a).length, l ? c : a;
    };
}
function $914aec8743edd630$var$jn(...e) {
    return e.length === 0 ? (t)=>t : e.length === 1 ? e[0] : e.reduce((t, r)=>(...i)=>t(r(...i)));
}
function $914aec8743edd630$var$Sv(...e) {
    return (t)=>(r, i)=>{
            const n = t(r, i);
            let o = ()=>{
                throw new Error($914aec8743edd630$var$Le(15));
            };
            const s = {
                getState: n.getState,
                dispatch: (u, ...l)=>o(u, ...l)
            }, a = e.map((u)=>u(s));
            return o = $914aec8743edd630$var$jn(...a)(n.dispatch), {
                ...n,
                dispatch: o
            };
        };
}
function $914aec8743edd630$var$_m(e) {
    return $914aec8743edd630$var$nn(e) && "type" in e && typeof e.type == "string";
}
var $914aec8743edd630$var$km = Symbol.for("immer-nothing"), $914aec8743edd630$var$Uc = Symbol.for("immer-draftable"), $914aec8743edd630$var$qe = Symbol.for("immer-state"), $914aec8743edd630$var$Ev = [];
function $914aec8743edd630$var$He(e, ...t) {
    throw new Error(`[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`);
}
var $914aec8743edd630$var$Ke = Object, $914aec8743edd630$var$Yt = $914aec8743edd630$var$Ke.getPrototypeOf, $914aec8743edd630$var$Fn = "constructor", $914aec8743edd630$var$Gn = "prototype", $914aec8743edd630$var$yu = "configurable", $914aec8743edd630$var$$n = "enumerable", $914aec8743edd630$var$On = "writable", $914aec8743edd630$var$Kr = "value", $914aec8743edd630$var$pt = (e)=>!!e && !!e[$914aec8743edd630$var$qe];
function $914aec8743edd630$var$Ze(e) {
    var t;
    return e ? $914aec8743edd630$var$xm(e) || $914aec8743edd630$var$Wn(e) || !!e[$914aec8743edd630$var$Uc] || !!((t = e[$914aec8743edd630$var$Fn]) != null && t[$914aec8743edd630$var$Uc]) || $914aec8743edd630$var$Hn(e) || $914aec8743edd630$var$Kn(e) : !1;
}
var $914aec8743edd630$var$Av = $914aec8743edd630$var$Ke[$914aec8743edd630$var$Gn][$914aec8743edd630$var$Fn].toString(), $914aec8743edd630$var$Vc = /* @__PURE__ */ new WeakMap();
function $914aec8743edd630$var$xm(e) {
    if (!e || !$914aec8743edd630$var$Nu(e)) return !1;
    const t = $914aec8743edd630$var$Yt(e);
    if (t === null || t === $914aec8743edd630$var$Ke[$914aec8743edd630$var$Gn]) return !0;
    const r = $914aec8743edd630$var$Ke.hasOwnProperty.call(t, $914aec8743edd630$var$Fn) && t[$914aec8743edd630$var$Fn];
    if (r === Object) return !0;
    if (!$914aec8743edd630$var$Mt(r)) return !1;
    let i = $914aec8743edd630$var$Vc.get(r);
    return i === void 0 && (i = Function.toString.call(r), $914aec8743edd630$var$Vc.set(r, i)), i === $914aec8743edd630$var$Av;
}
function $914aec8743edd630$var$on(e, t, r = !0) {
    $914aec8743edd630$var$an(e) === 0 ? (r ? Reflect.ownKeys(e) : $914aec8743edd630$var$Ke.keys(e)).forEach((n)=>{
        t(n, e[n], e);
    }) : e.forEach((i, n)=>t(n, i, e));
}
function $914aec8743edd630$var$an(e) {
    const t = e[$914aec8743edd630$var$qe];
    return t ? t.type_ : $914aec8743edd630$var$Wn(e) ? 1 : $914aec8743edd630$var$Hn(e) ? 2 : $914aec8743edd630$var$Kn(e) ? 3 : 0;
}
var $914aec8743edd630$var$Gc = (e, t, r = $914aec8743edd630$var$an(e))=>r === 2 ? e.has(t) : $914aec8743edd630$var$Ke[$914aec8743edd630$var$Gn].hasOwnProperty.call(e, t), $914aec8743edd630$var$wu = (e, t, r = $914aec8743edd630$var$an(e))=>// @ts-ignore
    r === 2 ? e.get(t) : e[t], $914aec8743edd630$var$Ln = (e, t, r, i = $914aec8743edd630$var$an(e))=>{
    i === 2 ? e.set(t, r) : i === 3 ? e.add(r) : e[t] = r;
};
function $914aec8743edd630$var$Tv(e, t) {
    return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var $914aec8743edd630$var$Wn = Array.isArray, $914aec8743edd630$var$Hn = (e)=>e instanceof Map, $914aec8743edd630$var$Kn = (e)=>e instanceof Set, $914aec8743edd630$var$Nu = (e)=>typeof e == "object", $914aec8743edd630$var$Mt = (e)=>typeof e == "function", $914aec8743edd630$var$vi = (e)=>typeof e == "boolean", $914aec8743edd630$var$ft = (e)=>e.copy_ || e.base_, $914aec8743edd630$var$Bu = (e)=>e.modified_ ? e.copy_ : e.base_;
function $914aec8743edd630$var$_u(e, t) {
    if ($914aec8743edd630$var$Hn(e)) return new Map(e);
    if ($914aec8743edd630$var$Kn(e)) return new Set(e);
    if ($914aec8743edd630$var$Wn(e)) return Array[$914aec8743edd630$var$Gn].slice.call(e);
    const r = $914aec8743edd630$var$xm(e);
    if (t === !0 || t === "class_only" && !r) {
        const i = $914aec8743edd630$var$Ke.getOwnPropertyDescriptors(e);
        delete i[$914aec8743edd630$var$qe];
        let n = Reflect.ownKeys(i);
        for(let o = 0; o < n.length; o++){
            const s = n[o], a = i[s];
            a[$914aec8743edd630$var$On] === !1 && (a[$914aec8743edd630$var$On] = !0, a[$914aec8743edd630$var$yu] = !0), (a.get || a.set) && (i[s] = {
                [$914aec8743edd630$var$yu]: !0,
                [$914aec8743edd630$var$On]: !0,
                // could live with !!desc.set as well here...
                [$914aec8743edd630$var$$n]: a[$914aec8743edd630$var$$n],
                [$914aec8743edd630$var$Kr]: e[s]
            });
        }
        return $914aec8743edd630$var$Ke.create($914aec8743edd630$var$Yt(e), i);
    } else {
        const i = $914aec8743edd630$var$Yt(e);
        if (i !== null && r) return {
            ...e
        };
        const n = $914aec8743edd630$var$Ke.create(i);
        return $914aec8743edd630$var$Ke.assign(n, e);
    }
}
function $914aec8743edd630$var$qu(e, t = !1) {
    return $914aec8743edd630$var$Qn(e) || $914aec8743edd630$var$pt(e) || !$914aec8743edd630$var$Ze(e) || ($914aec8743edd630$var$an(e) > 1 && $914aec8743edd630$var$Ke.defineProperties(e, {
        set: $914aec8743edd630$var$vn,
        add: $914aec8743edd630$var$vn,
        clear: $914aec8743edd630$var$vn,
        delete: $914aec8743edd630$var$vn
    }), $914aec8743edd630$var$Ke.freeze(e), t && $914aec8743edd630$var$on(e, (r, i)=>{
        $914aec8743edd630$var$qu(i, !0);
    }, !1)), e;
}
function $914aec8743edd630$var$Cv() {
    $914aec8743edd630$var$He(2);
}
var $914aec8743edd630$var$vn = {
    [$914aec8743edd630$var$Kr]: $914aec8743edd630$var$Cv
};
function $914aec8743edd630$var$Qn(e) {
    return e === null || !$914aec8743edd630$var$Nu(e) ? !0 : $914aec8743edd630$var$Ke.isFrozen(e);
}
var $914aec8743edd630$var$Nn = "MapSet", $914aec8743edd630$var$ku = "Patches", $914aec8743edd630$var$Sm = {};
function $914aec8743edd630$var$Jt(e) {
    const t = $914aec8743edd630$var$Sm[e];
    return t || $914aec8743edd630$var$He(0, e), t;
}
var $914aec8743edd630$var$Rv = (e)=>!!$914aec8743edd630$var$Sm[e], $914aec8743edd630$var$Qr, $914aec8743edd630$var$Em = ()=>$914aec8743edd630$var$Qr, $914aec8743edd630$var$Ov = (e, t)=>({
        drafts_: [],
        parent_: e,
        immer_: t,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: !0,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $914aec8743edd630$var$Rv($914aec8743edd630$var$Nn) ? $914aec8743edd630$var$Jt($914aec8743edd630$var$Nn) : void 0
    });
function $914aec8743edd630$var$Wc(e, t) {
    t && (e.patchPlugin_ = $914aec8743edd630$var$Jt($914aec8743edd630$var$ku), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function $914aec8743edd630$var$xu(e) {
    $914aec8743edd630$var$Su(e), e.drafts_.forEach($914aec8743edd630$var$Dv), e.drafts_ = null;
}
function $914aec8743edd630$var$Su(e) {
    e === $914aec8743edd630$var$Qr && ($914aec8743edd630$var$Qr = e.parent_);
}
var $914aec8743edd630$var$Hc = (e)=>$914aec8743edd630$var$Qr = $914aec8743edd630$var$Ov($914aec8743edd630$var$Qr, e);
function $914aec8743edd630$var$Dv(e) {
    const t = e[$914aec8743edd630$var$qe];
    t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function $914aec8743edd630$var$Kc(e, t) {
    t.unfinalizedDrafts_ = t.drafts_.length;
    const r = t.drafts_[0];
    if (e !== void 0 && e !== r) {
        r[$914aec8743edd630$var$qe].modified_ && ($914aec8743edd630$var$xu(t), $914aec8743edd630$var$He(4)), $914aec8743edd630$var$Ze(e) && (e = $914aec8743edd630$var$Qc(t, e));
        const { patchPlugin_: n } = t;
        n && n.generateReplacementPatches_(r[$914aec8743edd630$var$qe].base_, e, t);
    } else e = $914aec8743edd630$var$Qc(t, r);
    return $914aec8743edd630$var$Pv(t, e, !0), $914aec8743edd630$var$xu(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== $914aec8743edd630$var$km ? e : void 0;
}
function $914aec8743edd630$var$Qc(e, t) {
    if ($914aec8743edd630$var$Qn(t)) return t;
    const r = t[$914aec8743edd630$var$qe];
    if (!r) return $914aec8743edd630$var$zu(t, e.handledSet_, e);
    if (!$914aec8743edd630$var$Yn(r, e)) return t;
    if (!r.modified_) return r.base_;
    if (!r.finalized_) {
        const { callbacks_: i } = r;
        if (i) for(; i.length > 0;)i.pop()(e);
        $914aec8743edd630$var$Cm(r, e);
    }
    return r.copy_;
}
function $914aec8743edd630$var$Pv(e, t, r = !1) {
    !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && $914aec8743edd630$var$qu(t, r);
}
function $914aec8743edd630$var$Am(e) {
    e.finalized_ = !0, e.scope_.unfinalizedDrafts_--;
}
var $914aec8743edd630$var$Yn = (e, t)=>e.scope_ === t, $914aec8743edd630$var$Iv = [];
function $914aec8743edd630$var$Tm(e, t, r, i) {
    const n = $914aec8743edd630$var$ft(e), o = e.type_;
    if (i !== void 0 && $914aec8743edd630$var$wu(n, i, o) === t) {
        $914aec8743edd630$var$Ln(n, i, r, o);
        return;
    }
    if (!e.draftLocations_) {
        const a = e.draftLocations_ = /* @__PURE__ */ new Map();
        $914aec8743edd630$var$on(n, (u, l)=>{
            if ($914aec8743edd630$var$pt(l)) {
                const c = a.get(l) || [];
                c.push(u), a.set(l, c);
            }
        });
    }
    const s = e.draftLocations_.get(t) ?? $914aec8743edd630$var$Iv;
    for (const a of s)$914aec8743edd630$var$Ln(n, a, r, o);
}
function $914aec8743edd630$var$Mv(e, t, r) {
    e.callbacks_.push(function(n) {
        var a;
        const o = t;
        if (!o || !$914aec8743edd630$var$Yn(o, n)) return;
        (a = n.mapSetPlugin_) == null || a.fixSetContents(o);
        const s = $914aec8743edd630$var$Bu(o);
        $914aec8743edd630$var$Tm(e, o.draft_ ?? o, s, r), $914aec8743edd630$var$Cm(o, n);
    });
}
function $914aec8743edd630$var$Cm(e, t) {
    var i;
    if (e.modified_ && !e.finalized_ && (e.type_ === 3 || (((i = e.assigned_) == null ? void 0 : i.size) ?? 0) > 0)) {
        const { patchPlugin_: n } = t;
        if (n) {
            const o = n.getPath(e);
            o && n.generatePatches_(e, o, t);
        }
        $914aec8743edd630$var$Am(e);
    }
}
function $914aec8743edd630$var$jv(e, t, r) {
    const { scope_: i } = e;
    if ($914aec8743edd630$var$pt(r)) {
        const n = r[$914aec8743edd630$var$qe];
        $914aec8743edd630$var$Yn(n, i) && n.callbacks_.push(function() {
            $914aec8743edd630$var$Dn(e);
            const s = $914aec8743edd630$var$Bu(n);
            $914aec8743edd630$var$Tm(e, r, s, t);
        });
    } else $914aec8743edd630$var$Ze(r) && e.callbacks_.push(function() {
        const o = $914aec8743edd630$var$ft(e);
        $914aec8743edd630$var$wu(o, t, e.type_) === r && i.drafts_.length > 1 && (e.assigned_.get(t) ?? !1) === !0 && e.copy_ && $914aec8743edd630$var$zu($914aec8743edd630$var$wu(e.copy_, t, e.type_), i.handledSet_, i);
    });
}
function $914aec8743edd630$var$zu(e, t, r) {
    return !r.immer_.autoFreeze_ && r.unfinalizedDrafts_ < 1 || $914aec8743edd630$var$pt(e) || t.has(e) || !$914aec8743edd630$var$Ze(e) || $914aec8743edd630$var$Qn(e) || (t.add(e), $914aec8743edd630$var$on(e, (i, n)=>{
        if ($914aec8743edd630$var$pt(n)) {
            const o = n[$914aec8743edd630$var$qe];
            if ($914aec8743edd630$var$Yn(o, r)) {
                const s = $914aec8743edd630$var$Bu(o);
                $914aec8743edd630$var$Ln(e, i, s, e.type_), $914aec8743edd630$var$Am(o);
            }
        } else $914aec8743edd630$var$Ze(n) && $914aec8743edd630$var$zu(n, t, r);
    })), e;
}
function $914aec8743edd630$var$Fv(e, t) {
    const r = $914aec8743edd630$var$Wn(e), i = {
        type_: r ? 1 : 0,
        // Track which produce call this is associated with.
        scope_: t ? t.scope_ : $914aec8743edd630$var$Em(),
        // True for both shallow and deep changes.
        modified_: !1,
        // Used during finalization.
        finalized_: !1,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: t,
        // The base state.
        base_: e,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: !1,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let n = i, o = $914aec8743edd630$var$Uu;
    r && (n = [
        i
    ], o = $914aec8743edd630$var$Yr);
    const { revoke: s, proxy: a } = Proxy.revocable(n, o);
    return i.draft_ = a, i.revoke_ = s, [
        a,
        i
    ];
}
var $914aec8743edd630$var$Uu = {
    get (e, t) {
        if (t === $914aec8743edd630$var$qe) return e;
        const r = $914aec8743edd630$var$ft(e);
        if (!$914aec8743edd630$var$Gc(r, t, e.type_)) return $914aec8743edd630$var$$v(e, r, t);
        const i = r[t];
        if (e.finalized_ || !$914aec8743edd630$var$Ze(i)) return i;
        if (i === $914aec8743edd630$var$yi(e.base_, t)) {
            $914aec8743edd630$var$Dn(e);
            const n = e.type_ === 1 ? +t : t, o = $914aec8743edd630$var$Au(e.scope_, i, e, n);
            return e.copy_[n] = o;
        }
        return i;
    },
    has (e, t) {
        return t in $914aec8743edd630$var$ft(e);
    },
    ownKeys (e) {
        return Reflect.ownKeys($914aec8743edd630$var$ft(e));
    },
    set (e, t, r) {
        const i = $914aec8743edd630$var$Rm($914aec8743edd630$var$ft(e), t);
        if (i != null && i.set) return i.set.call(e.draft_, r), !0;
        if (!e.modified_) {
            const n = $914aec8743edd630$var$yi($914aec8743edd630$var$ft(e), t), o = n == null ? void 0 : n[$914aec8743edd630$var$qe];
            if (o && o.base_ === r) return e.copy_[t] = r, e.assigned_.set(t, !1), !0;
            if ($914aec8743edd630$var$Tv(r, n) && (r !== void 0 || $914aec8743edd630$var$Gc(e.base_, t, e.type_))) return !0;
            $914aec8743edd630$var$Dn(e), $914aec8743edd630$var$Eu(e);
        }
        return e.copy_[t] === r && // special case: handle new props with value 'undefined'
        (r !== void 0 || t in e.copy_) || // special case: NaN
        Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_.set(t, !0), $914aec8743edd630$var$jv(e, t, r)), !0;
    },
    deleteProperty (e, t) {
        return $914aec8743edd630$var$Dn(e), $914aec8743edd630$var$yi(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_.set(t, !1), $914aec8743edd630$var$Eu(e)) : e.assigned_.delete(t), e.copy_ && delete e.copy_[t], !0;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (e, t) {
        const r = $914aec8743edd630$var$ft(e), i = Reflect.getOwnPropertyDescriptor(r, t);
        return i && {
            [$914aec8743edd630$var$On]: !0,
            [$914aec8743edd630$var$yu]: e.type_ !== 1 || t !== "length",
            [$914aec8743edd630$var$$n]: i[$914aec8743edd630$var$$n],
            [$914aec8743edd630$var$Kr]: r[t]
        };
    },
    defineProperty () {
        $914aec8743edd630$var$He(11);
    },
    getPrototypeOf (e) {
        return $914aec8743edd630$var$Yt(e.base_);
    },
    setPrototypeOf () {
        $914aec8743edd630$var$He(12);
    }
}, $914aec8743edd630$var$Yr = {};
$914aec8743edd630$var$on($914aec8743edd630$var$Uu, (e, t)=>{
    $914aec8743edd630$var$Yr[e] = function() {
        const r = arguments;
        return r[0] = r[0][0], t.apply(this, r);
    };
});
$914aec8743edd630$var$Yr.deleteProperty = function(e, t) {
    return $914aec8743edd630$var$Yr.set.call(this, e, t, void 0);
};
$914aec8743edd630$var$Yr.set = function(e, t, r) {
    return $914aec8743edd630$var$Uu.set.call(this, e[0], t, r, e[0]);
};
function $914aec8743edd630$var$yi(e, t) {
    const r = e[$914aec8743edd630$var$qe];
    return (r ? $914aec8743edd630$var$ft(r) : e)[t];
}
function $914aec8743edd630$var$$v(e, t, r) {
    var n;
    const i = $914aec8743edd630$var$Rm(t, r);
    return i ? $914aec8743edd630$var$Kr in i ? i[$914aec8743edd630$var$Kr] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (n = i.get) == null ? void 0 : n.call(e.draft_) : void 0;
}
function $914aec8743edd630$var$Rm(e, t) {
    if (!(t in e)) return;
    let r = $914aec8743edd630$var$Yt(e);
    for(; r;){
        const i = Object.getOwnPropertyDescriptor(r, t);
        if (i) return i;
        r = $914aec8743edd630$var$Yt(r);
    }
}
function $914aec8743edd630$var$Eu(e) {
    e.modified_ || (e.modified_ = !0, e.parent_ && $914aec8743edd630$var$Eu(e.parent_));
}
function $914aec8743edd630$var$Dn(e) {
    e.copy_ || (e.assigned_ = /* @__PURE__ */ new Map(), e.copy_ = $914aec8743edd630$var$_u(e.base_, e.scope_.immer_.useStrictShallowCopy_));
}
var $914aec8743edd630$var$Lv = class {
    constructor(e){
        this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !1, this.produce = (t, r, i)=>{
            if ($914aec8743edd630$var$Mt(t) && !$914aec8743edd630$var$Mt(r)) {
                const o = r;
                r = t;
                const s = this;
                return function(u = o, ...l) {
                    return s.produce(u, (c)=>r.call(this, c, ...l));
                };
            }
            $914aec8743edd630$var$Mt(r) || $914aec8743edd630$var$He(6), i !== void 0 && !$914aec8743edd630$var$Mt(i) && $914aec8743edd630$var$He(7);
            let n;
            if ($914aec8743edd630$var$Ze(t)) {
                const o = $914aec8743edd630$var$Hc(this), s = $914aec8743edd630$var$Au(o, t, void 0);
                let a = !0;
                try {
                    n = r(s), a = !1;
                } finally{
                    a ? $914aec8743edd630$var$xu(o) : $914aec8743edd630$var$Su(o);
                }
                return $914aec8743edd630$var$Wc(o, i), $914aec8743edd630$var$Kc(n, o);
            } else if (!t || !$914aec8743edd630$var$Nu(t)) {
                if (n = r(t), n === void 0 && (n = t), n === $914aec8743edd630$var$km && (n = void 0), this.autoFreeze_ && $914aec8743edd630$var$qu(n, !0), i) {
                    const o = [], s = [];
                    $914aec8743edd630$var$Jt($914aec8743edd630$var$ku).generateReplacementPatches_(t, n, {
                        patches_: o,
                        inversePatches_: s
                    }), i(o, s);
                }
                return n;
            } else $914aec8743edd630$var$He(1, t);
        }, this.produceWithPatches = (t, r)=>{
            if ($914aec8743edd630$var$Mt(t)) return (s, ...a)=>this.produceWithPatches(s, (u)=>t(u, ...a));
            let i, n;
            return [
                this.produce(t, r, (s, a)=>{
                    i = s, n = a;
                }),
                i,
                n
            ];
        }, $914aec8743edd630$var$vi(e == null ? void 0 : e.autoFreeze) && this.setAutoFreeze(e.autoFreeze), $914aec8743edd630$var$vi(e == null ? void 0 : e.useStrictShallowCopy) && this.setUseStrictShallowCopy(e.useStrictShallowCopy), $914aec8743edd630$var$vi(e == null ? void 0 : e.useStrictIteration) && this.setUseStrictIteration(e.useStrictIteration);
    }
    createDraft(e) {
        $914aec8743edd630$var$Ze(e) || $914aec8743edd630$var$He(8), $914aec8743edd630$var$pt(e) && (e = $914aec8743edd630$var$Nv(e));
        const t = $914aec8743edd630$var$Hc(this), r = $914aec8743edd630$var$Au(t, e, void 0);
        return r[$914aec8743edd630$var$qe].isManual_ = !0, $914aec8743edd630$var$Su(t), r;
    }
    finishDraft(e, t) {
        const r = e && e[$914aec8743edd630$var$qe];
        (!r || !r.isManual_) && $914aec8743edd630$var$He(9);
        const { scope_: i } = r;
        return $914aec8743edd630$var$Wc(i, t), $914aec8743edd630$var$Kc(void 0, i);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(e) {
        this.autoFreeze_ = e;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(e) {
        this.useStrictShallowCopy_ = e;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(e) {
        this.useStrictIteration_ = e;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(e, t) {
        let r;
        for(r = t.length - 1; r >= 0; r--){
            const n = t[r];
            if (n.path.length === 0 && n.op === "replace") {
                e = n.value;
                break;
            }
        }
        r > -1 && (t = t.slice(r + 1));
        const i = $914aec8743edd630$var$Jt($914aec8743edd630$var$ku).applyPatches_;
        return $914aec8743edd630$var$pt(e) ? i(e, t) : this.produce(e, (n)=>i(n, t));
    }
};
function $914aec8743edd630$var$Au(e, t, r, i) {
    const [n, o] = $914aec8743edd630$var$Hn(t) ? $914aec8743edd630$var$Jt($914aec8743edd630$var$Nn).proxyMap_(t, r) : $914aec8743edd630$var$Kn(t) ? $914aec8743edd630$var$Jt($914aec8743edd630$var$Nn).proxySet_(t, r) : $914aec8743edd630$var$Fv(t, r);
    return ((r == null ? void 0 : r.scope_) ?? $914aec8743edd630$var$Em()).drafts_.push(n), o.callbacks_ = (r == null ? void 0 : r.callbacks_) ?? [], o.key_ = i, r && i !== void 0 ? $914aec8743edd630$var$Mv(r, o, i) : o.callbacks_.push(function(u) {
        var c;
        (c = u.mapSetPlugin_) == null || c.fixSetContents(o);
        const { patchPlugin_: l } = u;
        o.modified_ && l && l.generatePatches_(o, [], u);
    }), n;
}
function $914aec8743edd630$var$Nv(e) {
    return $914aec8743edd630$var$pt(e) || $914aec8743edd630$var$He(10, e), $914aec8743edd630$var$Om(e);
}
function $914aec8743edd630$var$Om(e) {
    if (!$914aec8743edd630$var$Ze(e) || $914aec8743edd630$var$Qn(e)) return e;
    const t = e[$914aec8743edd630$var$qe];
    let r, i = !0;
    if (t) {
        if (!t.modified_) return t.base_;
        t.finalized_ = !0, r = $914aec8743edd630$var$_u(e, t.scope_.immer_.useStrictShallowCopy_), i = t.scope_.immer_.shouldUseStrictIteration();
    } else r = $914aec8743edd630$var$_u(e, !0);
    return $914aec8743edd630$var$on(r, (n, o)=>{
        $914aec8743edd630$var$Ln(r, n, $914aec8743edd630$var$Om(o));
    }, i), t && (t.finalized_ = !1), r;
}
var $914aec8743edd630$var$Bv = new $914aec8743edd630$var$Lv(), $914aec8743edd630$var$Dm = $914aec8743edd630$var$Bv.produce;
function $914aec8743edd630$var$Pm(e) {
    return ({ dispatch: r, getState: i })=>(n)=>(o)=>typeof o == "function" ? o(r, i, e) : n(o);
}
var $914aec8743edd630$var$qv = $914aec8743edd630$var$Pm(), $914aec8743edd630$var$zv = $914aec8743edd630$var$Pm, $914aec8743edd630$var$Uv = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length !== 0) return typeof arguments[0] == "object" ? $914aec8743edd630$var$jn : $914aec8743edd630$var$jn.apply(null, arguments);
}, $914aec8743edd630$var$Im = (e)=>e && typeof e.match == "function";
function $914aec8743edd630$var$Wr(e, t) {
    function r(...i) {
        if (t) {
            let n = t(...i);
            if (!n) throw new Error($914aec8743edd630$var$Ce(0));
            return {
                type: e,
                payload: n.payload,
                ..."meta" in n && {
                    meta: n.meta
                },
                ..."error" in n && {
                    error: n.error
                }
            };
        }
        return {
            type: e,
            payload: i[0]
        };
    }
    return r.toString = ()=>`${e}`, r.type = e, r.match = (i)=>$914aec8743edd630$var$_m(i) && i.type === e, r;
}
function $914aec8743edd630$var$Vv(e) {
    return typeof e == "function" && "type" in e && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $914aec8743edd630$var$Im(e);
}
function $914aec8743edd630$var$Gv(e) {
    const t = e ? `${e}`.split("/") : [], r = t[t.length - 1] || "actionCreator";
    return `Detected an action creator with type "${e || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${r}())\` instead of \`dispatch(${r})\`. This is necessary even if the action has no payload.`;
}
function $914aec8743edd630$var$Wv(e = {}) {
    var r, i;
    return ()=>(r)=>(i)=>r(i);
}
function $914aec8743edd630$var$Mm(e, t) {
    let r = 0;
    return {
        measureTime (i) {
            const n = Date.now();
            try {
                return i();
            } finally{
                const o = Date.now();
                r += o - n;
            }
        },
        warnIfExceeded () {
            r > e && console.warn(`${t} took ${r}ms, which is more than the warning threshold of ${e}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $914aec8743edd630$var$jm = class Ur extends Array {
    constructor(...t){
        super(...t), Object.setPrototypeOf(this, Ur.prototype);
    }
    static get [Symbol.species]() {
        return Ur;
    }
    concat(...t) {
        return super.concat.apply(this, t);
    }
    prepend(...t) {
        return t.length === 1 && Array.isArray(t[0]) ? new Ur(...t[0].concat(this)) : new Ur(...t.concat(this));
    }
};
function $914aec8743edd630$var$Yc(e) {
    return $914aec8743edd630$var$Ze(e) ? $914aec8743edd630$var$Dm(e, ()=>{}) : e;
}
function $914aec8743edd630$var$yn(e, t, r) {
    return e.has(t) ? e.get(t) : e.set(t, r(t)).get(t);
}
function $914aec8743edd630$var$Hv(e) {
    return typeof e != "object" || e == null || Object.isFrozen(e);
}
function $914aec8743edd630$var$Kv(e, t, r) {
    const i = $914aec8743edd630$var$Fm(e, t, r);
    return {
        detectMutations () {
            return $914aec8743edd630$var$$m(e, t, i, r);
        }
    };
}
function $914aec8743edd630$var$Fm(e, t = [], r, i = "", n = /* @__PURE__ */ new Set()) {
    const o = {
        value: r
    };
    if (!e(r) && !n.has(r)) {
        n.add(r), o.children = {};
        const s = t.length > 0;
        for(const a in r){
            const u = i ? i + "." + a : a;
            s && t.some((c)=>c instanceof RegExp ? c.test(u) : u === c) || (o.children[a] = $914aec8743edd630$var$Fm(e, t, r[a], u));
        }
    }
    return o;
}
function $914aec8743edd630$var$$m(e, t = [], r, i, n = !1, o = "") {
    const s = r ? r.value : void 0, a = s === i;
    if (n && !a && !Number.isNaN(i)) return {
        wasMutated: !0,
        path: o
    };
    if (e(s) || e(i)) return {
        wasMutated: !1
    };
    const u = {};
    for(let c in r.children)u[c] = !0;
    for(let c in i)u[c] = !0;
    const l = t.length > 0;
    for(let c in u){
        const d = o ? o + "." + c : c;
        if (l && t.some((p)=>p instanceof RegExp ? p.test(d) : d === p)) continue;
        const h = $914aec8743edd630$var$$m(e, t, r.children[c], i[c], a, d);
        if (h.wasMutated) return h;
    }
    return {
        wasMutated: !1
    };
}
function $914aec8743edd630$var$Qv(e = {}) {
    var a, d, h;
    return ()=>(t)=>(r)=>t(r);
}
function $914aec8743edd630$var$Lm(e) {
    const t = typeof e;
    return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || $914aec8743edd630$var$nn(e);
}
function $914aec8743edd630$var$Tu(e, t = "", r = $914aec8743edd630$var$Lm, i, n = [], o) {
    let s;
    if (!r(e)) return {
        keyPath: t || "<root>",
        value: e
    };
    if (typeof e != "object" || e === null || o != null && o.has(e)) return !1;
    const a = i != null ? i(e) : Object.entries(e), u = n.length > 0;
    for (const [l, c] of a){
        const d = t ? t + "." + l : l;
        if (!(u && n.some((f)=>f instanceof RegExp ? f.test(d) : d === f))) {
            if (!r(c)) return {
                keyPath: d,
                value: c
            };
            if (typeof c == "object" && (s = $914aec8743edd630$var$Tu(c, d, r, i, n, o), s)) return s;
        }
    }
    return o && $914aec8743edd630$var$Nm(e) && o.add(e), !1;
}
function $914aec8743edd630$var$Nm(e) {
    if (!Object.isFrozen(e)) return !1;
    for (const t of Object.values(e))if (!(typeof t != "object" || t === null) && !$914aec8743edd630$var$Nm(t)) return !1;
    return !0;
}
function $914aec8743edd630$var$Yv(e = {}) {
    var d, h, f;
    return ()=>(t)=>(r)=>t(r);
}
function $914aec8743edd630$var$wn(e) {
    return typeof e == "boolean";
}
var $914aec8743edd630$var$Jv = ()=>function(t) {
        const { thunk: r = !0, immutableCheck: i = !0, serializableCheck: n = !0, actionCreatorCheck: o = !0 } = t ?? {};
        let s = new $914aec8743edd630$var$jm();
        r && ($914aec8743edd630$var$wn(r) ? s.push($914aec8743edd630$var$qv) : s.push($914aec8743edd630$var$zv(r.extraArgument)));
        return s;
    }, $914aec8743edd630$var$Zv = "RTK_autoBatch", $914aec8743edd630$var$Jc = (e)=>(t)=>{
        setTimeout(t, e);
    }, $914aec8743edd630$var$Xv = (e = {
    type: "raf"
})=>(t)=>(...r)=>{
            const i = t(...r);
            let n = !0, o = !1, s = !1;
            const a = /* @__PURE__ */ new Set(), u = e.type === "tick" ? queueMicrotask : e.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window < "u" && window.requestAnimationFrame ? window.requestAnimationFrame : $914aec8743edd630$var$Jc(10) : e.type === "callback" ? e.queueNotification : $914aec8743edd630$var$Jc(e.timeout), l = ()=>{
                s = !1, o && (o = !1, a.forEach((c)=>c()));
            };
            return Object.assign({}, i, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (c) {
                    const d = ()=>n && c(), h = i.subscribe(d);
                    return a.add(c), ()=>{
                        h(), a.delete(c);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (c) {
                    var d;
                    try {
                        return n = !((d = c == null ? void 0 : c.meta) != null && d[$914aec8743edd630$var$Zv]), o = !n, o && (s || (s = !0, u(l))), i.dispatch(c);
                    } finally{
                        n = !0;
                    }
                }
            });
        }, $914aec8743edd630$var$ey = (e)=>function(r) {
        const { autoBatch: i = !0 } = r ?? {};
        let n = new $914aec8743edd630$var$jm(e);
        return i && n.push($914aec8743edd630$var$Xv(typeof i == "object" ? i : void 0)), n;
    };
function $914aec8743edd630$var$ty(e) {
    const t = $914aec8743edd630$var$Jv(), { reducer: r, middleware: i, devTools: n = !0, duplicateMiddlewareCheck: o = !0, preloadedState: s, enhancers: a } = e || {};
    let u;
    if (typeof r == "function") u = r;
    else if ($914aec8743edd630$var$nn(r)) u = $914aec8743edd630$var$wm(r);
    else throw new Error($914aec8743edd630$var$Ce(1));
    let l;
    if (typeof i == "function") l = i(t);
    else l = t();
    var w;
    let c = $914aec8743edd630$var$jn;
    n && (c = $914aec8743edd630$var$Uv({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false,
        ...typeof n == "object" && n
    }));
    const d = $914aec8743edd630$var$Sv(...l), h = $914aec8743edd630$var$ey(d);
    let f = typeof a == "function" ? a(h) : h();
    const p = c(...f);
    return $914aec8743edd630$var$ym(u, s, p);
}
function $914aec8743edd630$var$Bm(e) {
    const t = {}, r = [];
    let i;
    const n = {
        addCase (o, s) {
            const a = typeof o == "string" ? o : o.type;
            if (!a) throw new Error($914aec8743edd630$var$Ce(28));
            if (a in t) throw new Error($914aec8743edd630$var$Ce(29));
            return t[a] = s, n;
        },
        addAsyncThunk (o, s) {
            return s.pending && (t[o.pending.type] = s.pending), s.rejected && (t[o.rejected.type] = s.rejected), s.fulfilled && (t[o.fulfilled.type] = s.fulfilled), s.settled && r.push({
                matcher: o.settled,
                reducer: s.settled
            }), n;
        },
        addMatcher (o, s) {
            return r.push({
                matcher: o,
                reducer: s
            }), n;
        },
        addDefaultCase (o) {
            return i = o, n;
        }
    };
    return e(n), [
        t,
        r,
        i
    ];
}
function $914aec8743edd630$var$ry(e) {
    return typeof e == "function";
}
function $914aec8743edd630$var$ny(e, t) {
    let [r, i, n] = $914aec8743edd630$var$Bm(t), o;
    if ($914aec8743edd630$var$ry(e)) o = ()=>$914aec8743edd630$var$Yc(e());
    else {
        const a = $914aec8743edd630$var$Yc(e);
        o = ()=>a;
    }
    function s(a = o(), u) {
        let l = [
            r[u.type],
            ...i.filter(({ matcher: c })=>c(u)).map(({ reducer: c })=>c)
        ];
        return l.filter((c)=>!!c).length === 0 && (l = [
            n
        ]), l.reduce((c, d)=>{
            if (d) {
                if ($914aec8743edd630$var$pt(c)) {
                    const f = d(c, u);
                    return f === void 0 ? c : f;
                } else {
                    if ($914aec8743edd630$var$Ze(c)) return $914aec8743edd630$var$Dm(c, (h)=>d(h, u));
                    {
                        const h = d(c, u);
                        if (h === void 0) {
                            if (c === null) return c;
                            throw Error("A case reducer on a non-draftable value must not return undefined");
                        }
                        return h;
                    }
                }
            }
            return c;
        }, a);
    }
    return s.getInitialState = o, s;
}
var $914aec8743edd630$var$iy = (e, t)=>$914aec8743edd630$var$Im(e) ? e.match(t) : e(t);
function $914aec8743edd630$var$oy(...e) {
    return (t)=>e.some((r)=>$914aec8743edd630$var$iy(r, t));
}
var $914aec8743edd630$var$ay = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", $914aec8743edd630$var$sy = (e = 21)=>{
    let t = "", r = e;
    for(; r--;)t += $914aec8743edd630$var$ay[Math.random() * 64 | 0];
    return t;
}, $914aec8743edd630$var$uy = [
    "name",
    "message",
    "stack",
    "code"
], $914aec8743edd630$var$wi = class {
    constructor(e, t){
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $914aec8743edd630$var$gi(this, "_type");
        this.payload = e, this.meta = t;
    }
}, $914aec8743edd630$var$Zc = class {
    constructor(e, t){
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $914aec8743edd630$var$gi(this, "_type");
        this.payload = e, this.meta = t;
    }
}, $914aec8743edd630$var$cy = (e)=>{
    if (typeof e == "object" && e !== null) {
        const t = {};
        for (const r of $914aec8743edd630$var$uy)typeof e[r] == "string" && (t[r] = e[r]);
        return t;
    }
    return {
        message: String(e)
    };
}, $914aec8743edd630$var$Xc = "External signal was aborted", $914aec8743edd630$var$Ae = /* @__PURE__ */ (()=>{
    function e(t, r, i) {
        const n = $914aec8743edd630$var$Wr(t + "/fulfilled", (u, l, c, d)=>({
                payload: u,
                meta: {
                    ...d || {},
                    arg: c,
                    requestId: l,
                    requestStatus: "fulfilled"
                }
            })), o = $914aec8743edd630$var$Wr(t + "/pending", (u, l, c)=>({
                payload: void 0,
                meta: {
                    ...c || {},
                    arg: l,
                    requestId: u,
                    requestStatus: "pending"
                }
            })), s = $914aec8743edd630$var$Wr(t + "/rejected", (u, l, c, d, h)=>({
                payload: d,
                error: (i && i.serializeError || $914aec8743edd630$var$cy)(u || "Rejected"),
                meta: {
                    ...h || {},
                    arg: c,
                    requestId: l,
                    rejectedWithValue: !!d,
                    requestStatus: "rejected",
                    aborted: (u == null ? void 0 : u.name) === "AbortError",
                    condition: (u == null ? void 0 : u.name) === "ConditionError"
                }
            }));
        function a(u, { signal: l } = {}) {
            return (c, d, h)=>{
                const f = i != null && i.idGenerator ? i.idGenerator(u) : $914aec8743edd630$var$sy(), p = new AbortController();
                let m, w;
                function v(A) {
                    w = A, p.abort();
                }
                l && (l.aborted ? v($914aec8743edd630$var$Xc) : l.addEventListener("abort", ()=>v($914aec8743edd630$var$Xc), {
                    once: !0
                }));
                const g = async function() {
                    var k, y;
                    let A;
                    try {
                        let x = (k = i == null ? void 0 : i.condition) == null ? void 0 : k.call(i, u, {
                            getState: d,
                            extra: h
                        });
                        if ($914aec8743edd630$var$dy(x) && (x = await x), x === !1 || p.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const C = new Promise((I, M)=>{
                            m = ()=>{
                                M({
                                    name: "AbortError",
                                    message: w || "Aborted"
                                });
                            }, p.signal.addEventListener("abort", m, {
                                once: !0
                            });
                        });
                        c(o(f, u, (y = i == null ? void 0 : i.getPendingMeta) == null ? void 0 : y.call(i, {
                            requestId: f,
                            arg: u
                        }, {
                            getState: d,
                            extra: h
                        }))), A = await Promise.race([
                            C,
                            Promise.resolve(r(u, {
                                dispatch: c,
                                getState: d,
                                extra: h,
                                requestId: f,
                                signal: p.signal,
                                abort: v,
                                rejectWithValue: (I, M)=>new $914aec8743edd630$var$wi(I, M),
                                fulfillWithValue: (I, M)=>new $914aec8743edd630$var$Zc(I, M)
                            })).then((I)=>{
                                if (I instanceof $914aec8743edd630$var$wi) throw I;
                                return I instanceof $914aec8743edd630$var$Zc ? n(I.payload, f, u, I.meta) : n(I, f, u);
                            })
                        ]);
                    } catch (x) {
                        A = x instanceof $914aec8743edd630$var$wi ? s(null, f, u, x.payload, x.meta) : s(x, f, u);
                    } finally{
                        m && p.signal.removeEventListener("abort", m);
                    }
                    return i && !i.dispatchConditionRejection && s.match(A) && A.meta.condition || c(A), A;
                }();
                return Object.assign(g, {
                    abort: v,
                    requestId: f,
                    arg: u,
                    unwrap () {
                        return g.then($914aec8743edd630$var$ly);
                    }
                });
            };
        }
        return Object.assign(a, {
            pending: o,
            rejected: s,
            fulfilled: n,
            settled: $914aec8743edd630$var$oy(s, n),
            typePrefix: t
        });
    }
    return e.withTypes = ()=>e, e;
})();
function $914aec8743edd630$var$ly(e) {
    if (e.meta && e.meta.rejectedWithValue) throw e.payload;
    if (e.error) throw e.error;
    return e.payload;
}
function $914aec8743edd630$var$dy(e) {
    return e !== null && typeof e == "object" && typeof e.then == "function";
}
var $914aec8743edd630$var$fy = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function $914aec8743edd630$var$hy(e, t) {
    return `${e}/${t}`;
}
function $914aec8743edd630$var$py({ creators: e } = {}) {
    var r;
    const t = (r = e == null ? void 0 : e.asyncThunk) == null ? void 0 : r[$914aec8743edd630$var$fy];
    return function(n) {
        const { name: o, reducerPath: s = o } = n;
        if (!o) throw new Error($914aec8743edd630$var$Ce(11));
        const a = (typeof n.reducers == "function" ? n.reducers($914aec8743edd630$var$gy()) : n.reducers) || {}, u = Object.keys(a), l = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        }, c = {
            addCase (b, k) {
                const y = typeof b == "string" ? b : b.type;
                if (!y) throw new Error($914aec8743edd630$var$Ce(12));
                if (y in l.sliceCaseReducersByType) throw new Error($914aec8743edd630$var$Ce(13));
                return l.sliceCaseReducersByType[y] = k, c;
            },
            addMatcher (b, k) {
                return l.sliceMatchers.push({
                    matcher: b,
                    reducer: k
                }), c;
            },
            exposeAction (b, k) {
                return l.actionCreators[b] = k, c;
            },
            exposeCaseReducer (b, k) {
                return l.sliceCaseReducersByName[b] = k, c;
            }
        };
        u.forEach((b)=>{
            const k = a[b], y = {
                reducerName: b,
                type: $914aec8743edd630$var$hy(o, b),
                createNotation: typeof n.reducers == "function"
            };
            $914aec8743edd630$var$vy(k) ? $914aec8743edd630$var$wy(y, k, c, t) : $914aec8743edd630$var$by(y, k, c);
        });
        function d() {
            const [b = {}, k = [], y] = typeof n.extraReducers == "function" ? $914aec8743edd630$var$Bm(n.extraReducers) : [
                n.extraReducers
            ], x = {
                ...b,
                ...l.sliceCaseReducersByType
            };
            return $914aec8743edd630$var$ny(n.initialState, (C)=>{
                for(let I in x)C.addCase(I, x[I]);
                for (let I of l.sliceMatchers)C.addMatcher(I.matcher, I.reducer);
                for (let I of k)C.addMatcher(I.matcher, I.reducer);
                y && C.addDefaultCase(y);
            });
        }
        const h = (b)=>b, f = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new WeakMap();
        let m;
        function w(b, k) {
            return m || (m = d()), m(b, k);
        }
        function v() {
            return m || (m = d()), m.getInitialState();
        }
        function g(b, k = !1) {
            function y(C) {
                let I = C[b];
                if (typeof I > "u") {
                    if (k) I = $914aec8743edd630$var$yn(p, y, v);
                }
                return I;
            }
            function x(C = h) {
                const I = $914aec8743edd630$var$yn(f, k, ()=>/* @__PURE__ */ new WeakMap());
                return $914aec8743edd630$var$yn(I, C, ()=>{
                    const M = {};
                    for (const [Q, H] of Object.entries(n.selectors ?? {}))M[Q] = $914aec8743edd630$var$my(H, C, ()=>$914aec8743edd630$var$yn(p, C, v), k);
                    return M;
                });
            }
            return {
                reducerPath: b,
                getSelectors: x,
                get selectors () {
                    return x(y);
                },
                selectSlice: y
            };
        }
        const A = {
            name: o,
            reducer: w,
            actions: l.actionCreators,
            caseReducers: l.sliceCaseReducersByName,
            getInitialState: v,
            ...g(s),
            injectInto (b, { reducerPath: k, ...y } = {}) {
                const x = k ?? s;
                return b.inject({
                    reducerPath: x,
                    reducer: w
                }, y), {
                    ...A,
                    ...g(x, !0)
                };
            }
        };
        return A;
    };
}
function $914aec8743edd630$var$my(e, t, r, i) {
    function n(o, ...s) {
        let a = t(o);
        if (typeof a > "u") {
            if (i) a = r();
        }
        return e(a, ...s);
    }
    return n.unwrapped = e, n;
}
var $914aec8743edd630$var$mt = /* @__PURE__ */ $914aec8743edd630$var$py();
function $914aec8743edd630$var$gy() {
    function e(t, r) {
        return {
            _reducerDefinitionType: "asyncThunk",
            payloadCreator: t,
            ...r
        };
    }
    return e.withTypes = ()=>e, {
        reducer (t) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [t.name] (...r) {
                    return t(...r);
                }
            }[t.name], {
                _reducerDefinitionType: "reducer"
            });
        },
        preparedReducer (t, r) {
            return {
                _reducerDefinitionType: "reducerWithPrepare",
                prepare: t,
                reducer: r
            };
        },
        asyncThunk: e
    };
}
function $914aec8743edd630$var$by({ type: e, reducerName: t, createNotation: r }, i, n) {
    let o, s;
    if ("reducer" in i) {
        if (r && !$914aec8743edd630$var$yy(i)) throw new Error($914aec8743edd630$var$Ce(17));
        o = i.reducer, s = i.prepare;
    } else o = i;
    n.addCase(e, o).exposeCaseReducer(t, o).exposeAction(t, s ? $914aec8743edd630$var$Wr(e, s) : $914aec8743edd630$var$Wr(e));
}
function $914aec8743edd630$var$vy(e) {
    return e._reducerDefinitionType === "asyncThunk";
}
function $914aec8743edd630$var$yy(e) {
    return e._reducerDefinitionType === "reducerWithPrepare";
}
function $914aec8743edd630$var$wy({ type: e, reducerName: t }, r, i, n) {
    if (!n) throw new Error($914aec8743edd630$var$Ce(18));
    const { payloadCreator: o, fulfilled: s, pending: a, rejected: u, settled: l, options: c } = r, d = n(e, o, c);
    i.exposeAction(t, d), s && i.addCase(d.fulfilled, s), a && i.addCase(d.pending, a), u && i.addCase(d.rejected, u), l && i.addMatcher(d.settled, l), i.exposeCaseReducer(t, {
        fulfilled: s || $914aec8743edd630$var$_n,
        pending: a || $914aec8743edd630$var$_n,
        rejected: u || $914aec8743edd630$var$_n,
        settled: l || $914aec8743edd630$var$_n
    });
}
function $914aec8743edd630$var$_n() {}
function $914aec8743edd630$var$Ce(e) {
    return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var $914aec8743edd630$var$Ne = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $914aec8743edd630$var$_y(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $914aec8743edd630$var$ky(e) {
    if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
    var t = e.default;
    if (typeof t == "function") {
        var r = function i() {
            return this instanceof i ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
        };
        r.prototype = t.prototype;
    } else r = {};
    return Object.defineProperty(r, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(i) {
        var n = Object.getOwnPropertyDescriptor(e, i);
        Object.defineProperty(r, i, n.get ? n : {
            enumerable: !0,
            get: function() {
                return e[i];
            }
        });
    }), r;
}
var $914aec8743edd630$var$_i = {}, $914aec8743edd630$var$ki = {
    exports: {}
}, $914aec8743edd630$var$el;
function $914aec8743edd630$var$sn() {
    return $914aec8743edd630$var$el || ($914aec8743edd630$var$el = 1, function(e) {
        function t(r) {
            return r && r.__esModule ? r : {
                default: r
            };
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$ki)), $914aec8743edd630$var$ki.exports;
}
var $914aec8743edd630$var$xi = {
    exports: {}
}, $914aec8743edd630$var$tl;
function $914aec8743edd630$var$nr() {
    return $914aec8743edd630$var$tl || ($914aec8743edd630$var$tl = 1, function(e) {
        function t(r) {
            "@babel/helpers - typeof";
            return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
                return typeof i;
            } : function(i) {
                return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
            }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$xi)), $914aec8743edd630$var$xi.exports;
}
var $914aec8743edd630$var$Si = {
    exports: {}
}, $914aec8743edd630$var$Ei = {
    exports: {}
}, $914aec8743edd630$var$rl;
function $914aec8743edd630$var$xy() {
    return $914aec8743edd630$var$rl || ($914aec8743edd630$var$rl = 1, function(e) {
        function t(r, i) {
            if (r == null) return {};
            var n = {};
            for(var o in r)if (({}).hasOwnProperty.call(r, o)) {
                if (i.indexOf(o) !== -1) continue;
                n[o] = r[o];
            }
            return n;
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Ei)), $914aec8743edd630$var$Ei.exports;
}
var $914aec8743edd630$var$nl;
function $914aec8743edd630$var$qm() {
    return $914aec8743edd630$var$nl || ($914aec8743edd630$var$nl = 1, function(e) {
        var t = $914aec8743edd630$var$xy();
        function r(i, n) {
            if (i == null) return {};
            var o, s, a = t(i, n);
            if (Object.getOwnPropertySymbols) {
                var u = Object.getOwnPropertySymbols(i);
                for(s = 0; s < u.length; s++)o = u[s], n.indexOf(o) === -1 && ({}).propertyIsEnumerable.call(i, o) && (a[o] = i[o]);
            }
            return a;
        }
        e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Si)), $914aec8743edd630$var$Si.exports;
}
var $914aec8743edd630$var$Ai = {
    exports: {}
}, $914aec8743edd630$var$il;
function $914aec8743edd630$var$Vu() {
    return $914aec8743edd630$var$il || ($914aec8743edd630$var$il = 1, function(e) {
        function t(r, i) {
            if (!(r instanceof i)) throw new TypeError("Cannot call a class as a function");
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Ai)), $914aec8743edd630$var$Ai.exports;
}
var $914aec8743edd630$var$Ti = {
    exports: {}
}, $914aec8743edd630$var$Ci = {
    exports: {}
}, $914aec8743edd630$var$Ri = {
    exports: {}
}, $914aec8743edd630$var$ol;
function $914aec8743edd630$var$Sy() {
    return $914aec8743edd630$var$ol || ($914aec8743edd630$var$ol = 1, function(e) {
        var t = $914aec8743edd630$var$nr().default;
        function r(i, n) {
            if (t(i) != "object" || !i) return i;
            var o = i[Symbol.toPrimitive];
            if (o !== void 0) {
                var s = o.call(i, n || "default");
                if (t(s) != "object") return s;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return (n === "string" ? String : Number)(i);
        }
        e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Ri)), $914aec8743edd630$var$Ri.exports;
}
var $914aec8743edd630$var$al;
function $914aec8743edd630$var$zm() {
    return $914aec8743edd630$var$al || ($914aec8743edd630$var$al = 1, function(e) {
        var t = $914aec8743edd630$var$nr().default, r = $914aec8743edd630$var$Sy();
        function i(n) {
            var o = r(n, "string");
            return t(o) == "symbol" ? o : o + "";
        }
        e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Ci)), $914aec8743edd630$var$Ci.exports;
}
var $914aec8743edd630$var$sl;
function $914aec8743edd630$var$Gu() {
    return $914aec8743edd630$var$sl || ($914aec8743edd630$var$sl = 1, function(e) {
        var t = $914aec8743edd630$var$zm();
        function r(n, o) {
            for(var s = 0; s < o.length; s++){
                var a = o[s];
                a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, t(a.key), a);
            }
        }
        function i(n, o, s) {
            return o && r(n.prototype, o), s && r(n, s), Object.defineProperty(n, "prototype", {
                writable: !1
            }), n;
        }
        e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Ti)), $914aec8743edd630$var$Ti.exports;
}
var $914aec8743edd630$var$Oi = {
    exports: {}
}, $914aec8743edd630$var$ul;
function $914aec8743edd630$var$Um() {
    return $914aec8743edd630$var$ul || ($914aec8743edd630$var$ul = 1, function(e) {
        var t = $914aec8743edd630$var$zm();
        function r(i, n, o) {
            return (n = t(n)) in i ? Object.defineProperty(i, n, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : i[n] = o, i;
        }
        e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Oi)), $914aec8743edd630$var$Oi.exports;
}
var $914aec8743edd630$var$cl = {}, $914aec8743edd630$var$Di, $914aec8743edd630$var$ll;
function $914aec8743edd630$var$$e() {
    if ($914aec8743edd630$var$ll) return $914aec8743edd630$var$Di;
    $914aec8743edd630$var$ll = 1;
    var e = function(t) {
        return t && t.Math == Math && t;
    };
    return $914aec8743edd630$var$Di = e(typeof globalThis == "object" && globalThis) || e(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
    e(typeof self == "object" && self) || e(typeof $914aec8743edd630$var$Ne == "object" && $914aec8743edd630$var$Ne) || // eslint-disable-next-line no-new-func -- fallback
    /* @__PURE__ */ function() {
        return this;
    }() || Function("return this")(), $914aec8743edd630$var$Di;
}
var $914aec8743edd630$var$Pi = {}, $914aec8743edd630$var$Ii, $914aec8743edd630$var$dl;
function $914aec8743edd630$var$gt() {
    return $914aec8743edd630$var$dl || ($914aec8743edd630$var$dl = 1, $914aec8743edd630$var$Ii = function(e) {
        try {
            return !!e();
        } catch  {
            return !0;
        }
    }), $914aec8743edd630$var$Ii;
}
var $914aec8743edd630$var$Mi, $914aec8743edd630$var$fl;
function $914aec8743edd630$var$ir() {
    if ($914aec8743edd630$var$fl) return $914aec8743edd630$var$Mi;
    $914aec8743edd630$var$fl = 1;
    var e = $914aec8743edd630$var$gt();
    return $914aec8743edd630$var$Mi = !e(function() {
        return Object.defineProperty({}, 1, {
            get: function() {
                return 7;
            }
        })[1] != 7;
    }), $914aec8743edd630$var$Mi;
}
var $914aec8743edd630$var$ji = {}, $914aec8743edd630$var$hl;
function $914aec8743edd630$var$Ey() {
    if ($914aec8743edd630$var$hl) return $914aec8743edd630$var$ji;
    $914aec8743edd630$var$hl = 1;
    var e = {}.propertyIsEnumerable, t = Object.getOwnPropertyDescriptor, r = t && !e.call({
        1: 2
    }, 1);
    return $914aec8743edd630$var$ji.f = r ? function(n) {
        var o = t(this, n);
        return !!o && o.enumerable;
    } : e, $914aec8743edd630$var$ji;
}
var $914aec8743edd630$var$Fi, $914aec8743edd630$var$pl;
function $914aec8743edd630$var$Jn() {
    return $914aec8743edd630$var$pl || ($914aec8743edd630$var$pl = 1, $914aec8743edd630$var$Fi = function(e, t) {
        return {
            enumerable: !(e & 1),
            configurable: !(e & 2),
            writable: !(e & 4),
            value: t
        };
    }), $914aec8743edd630$var$Fi;
}
var $914aec8743edd630$var$$i, $914aec8743edd630$var$ml;
function $914aec8743edd630$var$Wu() {
    if ($914aec8743edd630$var$ml) return $914aec8743edd630$var$$i;
    $914aec8743edd630$var$ml = 1;
    var e = {}.toString;
    return $914aec8743edd630$var$$i = function(t) {
        return e.call(t).slice(8, -1);
    }, $914aec8743edd630$var$$i;
}
var $914aec8743edd630$var$Li, $914aec8743edd630$var$gl;
function $914aec8743edd630$var$Ay() {
    if ($914aec8743edd630$var$gl) return $914aec8743edd630$var$Li;
    $914aec8743edd630$var$gl = 1;
    var e = $914aec8743edd630$var$gt(), t = $914aec8743edd630$var$Wu(), r = "".split;
    return $914aec8743edd630$var$Li = e(function() {
        return !Object("z").propertyIsEnumerable(0);
    }) ? function(i) {
        return t(i) == "String" ? r.call(i, "") : Object(i);
    } : Object, $914aec8743edd630$var$Li;
}
var $914aec8743edd630$var$Ni, $914aec8743edd630$var$bl;
function $914aec8743edd630$var$Hu() {
    return $914aec8743edd630$var$bl || ($914aec8743edd630$var$bl = 1, $914aec8743edd630$var$Ni = function(e) {
        if (e == null) throw TypeError("Can't call method on " + e);
        return e;
    }), $914aec8743edd630$var$Ni;
}
var $914aec8743edd630$var$Bi, $914aec8743edd630$var$vl;
function $914aec8743edd630$var$Zn() {
    if ($914aec8743edd630$var$vl) return $914aec8743edd630$var$Bi;
    $914aec8743edd630$var$vl = 1;
    var e = $914aec8743edd630$var$Ay(), t = $914aec8743edd630$var$Hu();
    return $914aec8743edd630$var$Bi = function(r) {
        return e(t(r));
    }, $914aec8743edd630$var$Bi;
}
var $914aec8743edd630$var$qi, $914aec8743edd630$var$yl;
function $914aec8743edd630$var$$t() {
    return $914aec8743edd630$var$yl || ($914aec8743edd630$var$yl = 1, $914aec8743edd630$var$qi = function(e) {
        return typeof e == "object" ? e !== null : typeof e == "function";
    }), $914aec8743edd630$var$qi;
}
var $914aec8743edd630$var$zi, $914aec8743edd630$var$wl;
function $914aec8743edd630$var$Vm() {
    if ($914aec8743edd630$var$wl) return $914aec8743edd630$var$zi;
    $914aec8743edd630$var$wl = 1;
    var e = $914aec8743edd630$var$$t();
    return $914aec8743edd630$var$zi = function(t, r) {
        if (!e(t)) return t;
        var i, n;
        if (r && typeof (i = t.toString) == "function" && !e(n = i.call(t)) || typeof (i = t.valueOf) == "function" && !e(n = i.call(t)) || !r && typeof (i = t.toString) == "function" && !e(n = i.call(t))) return n;
        throw TypeError("Can't convert object to primitive value");
    }, $914aec8743edd630$var$zi;
}
var $914aec8743edd630$var$Ui, $914aec8743edd630$var$_l;
function $914aec8743edd630$var$Gm() {
    if ($914aec8743edd630$var$_l) return $914aec8743edd630$var$Ui;
    $914aec8743edd630$var$_l = 1;
    var e = $914aec8743edd630$var$Hu();
    return $914aec8743edd630$var$Ui = function(t) {
        return Object(e(t));
    }, $914aec8743edd630$var$Ui;
}
var $914aec8743edd630$var$Vi, $914aec8743edd630$var$kl;
function $914aec8743edd630$var$bt() {
    if ($914aec8743edd630$var$kl) return $914aec8743edd630$var$Vi;
    $914aec8743edd630$var$kl = 1;
    var e = $914aec8743edd630$var$Gm(), t = {}.hasOwnProperty;
    return $914aec8743edd630$var$Vi = Object.hasOwn || function(i, n) {
        return t.call(e(i), n);
    }, $914aec8743edd630$var$Vi;
}
var $914aec8743edd630$var$Gi, $914aec8743edd630$var$xl;
function $914aec8743edd630$var$Ku() {
    if ($914aec8743edd630$var$xl) return $914aec8743edd630$var$Gi;
    $914aec8743edd630$var$xl = 1;
    var e = $914aec8743edd630$var$$e(), t = $914aec8743edd630$var$$t(), r = e.document, i = t(r) && t(r.createElement);
    return $914aec8743edd630$var$Gi = function(n) {
        return i ? r.createElement(n) : {};
    }, $914aec8743edd630$var$Gi;
}
var $914aec8743edd630$var$Wi, $914aec8743edd630$var$Sl;
function $914aec8743edd630$var$Wm() {
    if ($914aec8743edd630$var$Sl) return $914aec8743edd630$var$Wi;
    $914aec8743edd630$var$Sl = 1;
    var e = $914aec8743edd630$var$ir(), t = $914aec8743edd630$var$gt(), r = $914aec8743edd630$var$Ku();
    return $914aec8743edd630$var$Wi = !e && !t(function() {
        return Object.defineProperty(r("div"), "a", {
            get: function() {
                return 7;
            }
        }).a != 7;
    }), $914aec8743edd630$var$Wi;
}
var $914aec8743edd630$var$El;
function $914aec8743edd630$var$Qu() {
    if ($914aec8743edd630$var$El) return $914aec8743edd630$var$Pi;
    $914aec8743edd630$var$El = 1;
    var e = $914aec8743edd630$var$ir(), t = $914aec8743edd630$var$Ey(), r = $914aec8743edd630$var$Jn(), i = $914aec8743edd630$var$Zn(), n = $914aec8743edd630$var$Vm(), o = $914aec8743edd630$var$bt(), s = $914aec8743edd630$var$Wm(), a = Object.getOwnPropertyDescriptor;
    return $914aec8743edd630$var$Pi.f = e ? a : function(l, c) {
        if (l = i(l), c = n(c, !0), s) try {
            return a(l, c);
        } catch  {}
        if (o(l, c)) return r(!t.f.call(l, c), l[c]);
    }, $914aec8743edd630$var$Pi;
}
var $914aec8743edd630$var$Hi = {}, $914aec8743edd630$var$Ki, $914aec8743edd630$var$Al;
function $914aec8743edd630$var$vt() {
    if ($914aec8743edd630$var$Al) return $914aec8743edd630$var$Ki;
    $914aec8743edd630$var$Al = 1;
    var e = $914aec8743edd630$var$$t();
    return $914aec8743edd630$var$Ki = function(t) {
        if (!e(t)) throw TypeError(String(t) + " is not an object");
        return t;
    }, $914aec8743edd630$var$Ki;
}
var $914aec8743edd630$var$Tl;
function $914aec8743edd630$var$or() {
    if ($914aec8743edd630$var$Tl) return $914aec8743edd630$var$Hi;
    $914aec8743edd630$var$Tl = 1;
    var e = $914aec8743edd630$var$ir(), t = $914aec8743edd630$var$Wm(), r = $914aec8743edd630$var$vt(), i = $914aec8743edd630$var$Vm(), n = Object.defineProperty;
    return $914aec8743edd630$var$Hi.f = e ? n : function(s, a, u) {
        if (r(s), a = i(a, !0), r(u), t) try {
            return n(s, a, u);
        } catch  {}
        if ("get" in u || "set" in u) throw TypeError("Accessors not supported");
        return "value" in u && (s[a] = u.value), s;
    }, $914aec8743edd630$var$Hi;
}
var $914aec8743edd630$var$Qi, $914aec8743edd630$var$Cl;
function $914aec8743edd630$var$Ct() {
    if ($914aec8743edd630$var$Cl) return $914aec8743edd630$var$Qi;
    $914aec8743edd630$var$Cl = 1;
    var e = $914aec8743edd630$var$ir(), t = $914aec8743edd630$var$or(), r = $914aec8743edd630$var$Jn();
    return $914aec8743edd630$var$Qi = e ? function(i, n, o) {
        return t.f(i, n, r(1, o));
    } : function(i, n, o) {
        return i[n] = o, i;
    }, $914aec8743edd630$var$Qi;
}
var $914aec8743edd630$var$Yi = {
    exports: {}
}, $914aec8743edd630$var$Ji, $914aec8743edd630$var$Rl;
function $914aec8743edd630$var$Yu() {
    if ($914aec8743edd630$var$Rl) return $914aec8743edd630$var$Ji;
    $914aec8743edd630$var$Rl = 1;
    var e = $914aec8743edd630$var$$e(), t = $914aec8743edd630$var$Ct();
    return $914aec8743edd630$var$Ji = function(r, i) {
        try {
            t(e, r, i);
        } catch  {
            e[r] = i;
        }
        return i;
    }, $914aec8743edd630$var$Ji;
}
var $914aec8743edd630$var$Zi, $914aec8743edd630$var$Ol;
function $914aec8743edd630$var$Ju() {
    if ($914aec8743edd630$var$Ol) return $914aec8743edd630$var$Zi;
    $914aec8743edd630$var$Ol = 1;
    var e = $914aec8743edd630$var$$e(), t = $914aec8743edd630$var$Yu(), r = "__core-js_shared__", i = e[r] || t(r, {});
    return $914aec8743edd630$var$Zi = i, $914aec8743edd630$var$Zi;
}
var $914aec8743edd630$var$Xi, $914aec8743edd630$var$Dl;
function $914aec8743edd630$var$Zu() {
    if ($914aec8743edd630$var$Dl) return $914aec8743edd630$var$Xi;
    $914aec8743edd630$var$Dl = 1;
    var e = $914aec8743edd630$var$Ju(), t = Function.toString;
    return typeof e.inspectSource != "function" && (e.inspectSource = function(r) {
        return t.call(r);
    }), $914aec8743edd630$var$Xi = e.inspectSource, $914aec8743edd630$var$Xi;
}
var $914aec8743edd630$var$eo, $914aec8743edd630$var$Pl;
function $914aec8743edd630$var$Ty() {
    if ($914aec8743edd630$var$Pl) return $914aec8743edd630$var$eo;
    $914aec8743edd630$var$Pl = 1;
    var e = $914aec8743edd630$var$$e(), t = $914aec8743edd630$var$Zu(), r = e.WeakMap;
    return $914aec8743edd630$var$eo = typeof r == "function" && /native code/.test(t(r)), $914aec8743edd630$var$eo;
}
var $914aec8743edd630$var$to = {
    exports: {}
}, $914aec8743edd630$var$ro, $914aec8743edd630$var$Il;
function $914aec8743edd630$var$un() {
    return $914aec8743edd630$var$Il || ($914aec8743edd630$var$Il = 1, $914aec8743edd630$var$ro = !1), $914aec8743edd630$var$ro;
}
var $914aec8743edd630$var$Ml;
function $914aec8743edd630$var$Hm() {
    if ($914aec8743edd630$var$Ml) return $914aec8743edd630$var$to.exports;
    $914aec8743edd630$var$Ml = 1;
    var e = $914aec8743edd630$var$un(), t = $914aec8743edd630$var$Ju();
    return ($914aec8743edd630$var$to.exports = function(r, i) {
        return t[r] || (t[r] = i !== void 0 ? i : {});
    })("versions", []).push({
        version: "3.15.2",
        mode: e ? "pure" : "global",
        copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
    }), $914aec8743edd630$var$to.exports;
}
var $914aec8743edd630$var$no, $914aec8743edd630$var$jl;
function $914aec8743edd630$var$Km() {
    if ($914aec8743edd630$var$jl) return $914aec8743edd630$var$no;
    $914aec8743edd630$var$jl = 1;
    var e = 0, t = Math.random();
    return $914aec8743edd630$var$no = function(r) {
        return "Symbol(" + String(r === void 0 ? "" : r) + ")_" + (++e + t).toString(36);
    }, $914aec8743edd630$var$no;
}
var $914aec8743edd630$var$io, $914aec8743edd630$var$Fl;
function $914aec8743edd630$var$Xu() {
    if ($914aec8743edd630$var$Fl) return $914aec8743edd630$var$io;
    $914aec8743edd630$var$Fl = 1;
    var e = $914aec8743edd630$var$Hm(), t = $914aec8743edd630$var$Km(), r = e("keys");
    return $914aec8743edd630$var$io = function(i) {
        return r[i] || (r[i] = t(i));
    }, $914aec8743edd630$var$io;
}
var $914aec8743edd630$var$oo, $914aec8743edd630$var$$l;
function $914aec8743edd630$var$ec() {
    return $914aec8743edd630$var$$l || ($914aec8743edd630$var$$l = 1, $914aec8743edd630$var$oo = {}), $914aec8743edd630$var$oo;
}
var $914aec8743edd630$var$ao, $914aec8743edd630$var$Ll;
function $914aec8743edd630$var$Xn() {
    if ($914aec8743edd630$var$Ll) return $914aec8743edd630$var$ao;
    $914aec8743edd630$var$Ll = 1;
    var e = $914aec8743edd630$var$Ty(), t = $914aec8743edd630$var$$e(), r = $914aec8743edd630$var$$t(), i = $914aec8743edd630$var$Ct(), n = $914aec8743edd630$var$bt(), o = $914aec8743edd630$var$Ju(), s = $914aec8743edd630$var$Xu(), a = $914aec8743edd630$var$ec(), u = "Object already initialized", l = t.WeakMap, c, d, h, f = function(b) {
        return h(b) ? d(b) : c(b, {});
    }, p = function(b) {
        return function(k) {
            var y;
            if (!r(k) || (y = d(k)).type !== b) throw TypeError("Incompatible receiver, " + b + " required");
            return y;
        };
    };
    if (e || o.state) {
        var m = o.state || (o.state = new l()), w = m.get, v = m.has, g = m.set;
        c = function(b, k) {
            if (v.call(m, b)) throw new TypeError(u);
            return k.facade = b, g.call(m, b, k), k;
        }, d = function(b) {
            return w.call(m, b) || {};
        }, h = function(b) {
            return v.call(m, b);
        };
    } else {
        var A = s("state");
        a[A] = !0, c = function(b, k) {
            if (n(b, A)) throw new TypeError(u);
            return k.facade = b, i(b, A, k), k;
        }, d = function(b) {
            return n(b, A) ? b[A] : {};
        }, h = function(b) {
            return n(b, A);
        };
    }
    return $914aec8743edd630$var$ao = {
        set: c,
        get: d,
        has: h,
        enforce: f,
        getterFor: p
    }, $914aec8743edd630$var$ao;
}
var $914aec8743edd630$var$Nl;
function $914aec8743edd630$var$ar() {
    if ($914aec8743edd630$var$Nl) return $914aec8743edd630$var$Yi.exports;
    $914aec8743edd630$var$Nl = 1;
    var e = $914aec8743edd630$var$$e(), t = $914aec8743edd630$var$Ct(), r = $914aec8743edd630$var$bt(), i = $914aec8743edd630$var$Yu(), n = $914aec8743edd630$var$Zu(), o = $914aec8743edd630$var$Xn(), s = o.get, a = o.enforce, u = String(String).split("String");
    return ($914aec8743edd630$var$Yi.exports = function(l, c, d, h) {
        var f = h ? !!h.unsafe : !1, p = h ? !!h.enumerable : !1, m = h ? !!h.noTargetGet : !1, w;
        if (typeof d == "function" && (typeof c == "string" && !r(d, "name") && t(d, "name", c), w = a(d), w.source || (w.source = u.join(typeof c == "string" ? c : ""))), l === e) {
            p ? l[c] = d : i(c, d);
            return;
        } else f ? !m && l[c] && (p = !0) : delete l[c];
        p ? l[c] = d : t(l, c, d);
    })(Function.prototype, "toString", function() {
        return typeof this == "function" && s(this).source || n(this);
    }), $914aec8743edd630$var$Yi.exports;
}
var $914aec8743edd630$var$so, $914aec8743edd630$var$Bl;
function $914aec8743edd630$var$Qm() {
    if ($914aec8743edd630$var$Bl) return $914aec8743edd630$var$so;
    $914aec8743edd630$var$Bl = 1;
    var e = $914aec8743edd630$var$$e();
    return $914aec8743edd630$var$so = e, $914aec8743edd630$var$so;
}
var $914aec8743edd630$var$uo, $914aec8743edd630$var$ql;
function $914aec8743edd630$var$Lt() {
    if ($914aec8743edd630$var$ql) return $914aec8743edd630$var$uo;
    $914aec8743edd630$var$ql = 1;
    var e = $914aec8743edd630$var$Qm(), t = $914aec8743edd630$var$$e(), r = function(i) {
        return typeof i == "function" ? i : void 0;
    };
    return $914aec8743edd630$var$uo = function(i, n) {
        return arguments.length < 2 ? r(e[i]) || r(t[i]) : e[i] && e[i][n] || t[i] && t[i][n];
    }, $914aec8743edd630$var$uo;
}
var $914aec8743edd630$var$co = {}, $914aec8743edd630$var$lo, $914aec8743edd630$var$zl;
function $914aec8743edd630$var$tc() {
    if ($914aec8743edd630$var$zl) return $914aec8743edd630$var$lo;
    $914aec8743edd630$var$zl = 1;
    var e = Math.ceil, t = Math.floor;
    return $914aec8743edd630$var$lo = function(r) {
        return isNaN(r = +r) ? 0 : (r > 0 ? t : e)(r);
    }, $914aec8743edd630$var$lo;
}
var $914aec8743edd630$var$fo, $914aec8743edd630$var$Ul;
function $914aec8743edd630$var$Ym() {
    if ($914aec8743edd630$var$Ul) return $914aec8743edd630$var$fo;
    $914aec8743edd630$var$Ul = 1;
    var e = $914aec8743edd630$var$tc(), t = Math.min;
    return $914aec8743edd630$var$fo = function(r) {
        return r > 0 ? t(e(r), 9007199254740991) : 0;
    }, $914aec8743edd630$var$fo;
}
var $914aec8743edd630$var$ho, $914aec8743edd630$var$Vl;
function $914aec8743edd630$var$Cy() {
    if ($914aec8743edd630$var$Vl) return $914aec8743edd630$var$ho;
    $914aec8743edd630$var$Vl = 1;
    var e = $914aec8743edd630$var$tc(), t = Math.max, r = Math.min;
    return $914aec8743edd630$var$ho = function(i, n) {
        var o = e(i);
        return o < 0 ? t(o + n, 0) : r(o, n);
    }, $914aec8743edd630$var$ho;
}
var $914aec8743edd630$var$po, $914aec8743edd630$var$Gl;
function $914aec8743edd630$var$Ry() {
    if ($914aec8743edd630$var$Gl) return $914aec8743edd630$var$po;
    $914aec8743edd630$var$Gl = 1;
    var e = $914aec8743edd630$var$Zn(), t = $914aec8743edd630$var$Ym(), r = $914aec8743edd630$var$Cy(), i = function(n) {
        return function(o, s, a) {
            var u = e(o), l = t(u.length), c = r(a, l), d;
            if (n && s != s) {
                for(; l > c;)if (d = u[c++], d != d) return !0;
            } else for(; l > c; c++)if ((n || c in u) && u[c] === s) return n || c || 0;
            return !n && -1;
        };
    };
    return $914aec8743edd630$var$po = {
        // `Array.prototype.includes` method
        // https://tc39.es/ecma262/#sec-array.prototype.includes
        includes: i(!0),
        // `Array.prototype.indexOf` method
        // https://tc39.es/ecma262/#sec-array.prototype.indexof
        indexOf: i(!1)
    }, $914aec8743edd630$var$po;
}
var $914aec8743edd630$var$mo, $914aec8743edd630$var$Wl;
function $914aec8743edd630$var$Jm() {
    if ($914aec8743edd630$var$Wl) return $914aec8743edd630$var$mo;
    $914aec8743edd630$var$Wl = 1;
    var e = $914aec8743edd630$var$bt(), t = $914aec8743edd630$var$Zn(), r = $914aec8743edd630$var$Ry().indexOf, i = $914aec8743edd630$var$ec();
    return $914aec8743edd630$var$mo = function(n, o) {
        var s = t(n), a = 0, u = [], l;
        for(l in s)!e(i, l) && e(s, l) && u.push(l);
        for(; o.length > a;)e(s, l = o[a++]) && (~r(u, l) || u.push(l));
        return u;
    }, $914aec8743edd630$var$mo;
}
var $914aec8743edd630$var$go, $914aec8743edd630$var$Hl;
function $914aec8743edd630$var$rc() {
    return $914aec8743edd630$var$Hl || ($914aec8743edd630$var$Hl = 1, $914aec8743edd630$var$go = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf"
    ]), $914aec8743edd630$var$go;
}
var $914aec8743edd630$var$Kl;
function $914aec8743edd630$var$Oy() {
    if ($914aec8743edd630$var$Kl) return $914aec8743edd630$var$co;
    $914aec8743edd630$var$Kl = 1;
    var e = $914aec8743edd630$var$Jm(), t = $914aec8743edd630$var$rc(), r = t.concat("length", "prototype");
    return $914aec8743edd630$var$co.f = Object.getOwnPropertyNames || function(n) {
        return e(n, r);
    }, $914aec8743edd630$var$co;
}
var $914aec8743edd630$var$bo = {}, $914aec8743edd630$var$Ql;
function $914aec8743edd630$var$Dy() {
    return $914aec8743edd630$var$Ql || ($914aec8743edd630$var$Ql = 1, $914aec8743edd630$var$bo.f = Object.getOwnPropertySymbols), $914aec8743edd630$var$bo;
}
var $914aec8743edd630$var$vo, $914aec8743edd630$var$Yl;
function $914aec8743edd630$var$Py() {
    if ($914aec8743edd630$var$Yl) return $914aec8743edd630$var$vo;
    $914aec8743edd630$var$Yl = 1;
    var e = $914aec8743edd630$var$Lt(), t = $914aec8743edd630$var$Oy(), r = $914aec8743edd630$var$Dy(), i = $914aec8743edd630$var$vt();
    return $914aec8743edd630$var$vo = e("Reflect", "ownKeys") || function(o) {
        var s = t.f(i(o)), a = r.f;
        return a ? s.concat(a(o)) : s;
    }, $914aec8743edd630$var$vo;
}
var $914aec8743edd630$var$yo, $914aec8743edd630$var$Jl;
function $914aec8743edd630$var$Iy() {
    if ($914aec8743edd630$var$Jl) return $914aec8743edd630$var$yo;
    $914aec8743edd630$var$Jl = 1;
    var e = $914aec8743edd630$var$bt(), t = $914aec8743edd630$var$Py(), r = $914aec8743edd630$var$Qu(), i = $914aec8743edd630$var$or();
    return $914aec8743edd630$var$yo = function(n, o) {
        for(var s = t(o), a = i.f, u = r.f, l = 0; l < s.length; l++){
            var c = s[l];
            e(n, c) || a(n, c, u(o, c));
        }
    }, $914aec8743edd630$var$yo;
}
var $914aec8743edd630$var$wo, $914aec8743edd630$var$Zl;
function $914aec8743edd630$var$Zm() {
    if ($914aec8743edd630$var$Zl) return $914aec8743edd630$var$wo;
    $914aec8743edd630$var$Zl = 1;
    var e = $914aec8743edd630$var$gt(), t = /#|\.prototype\./, r = function(a, u) {
        var l = n[i(a)];
        return l == s ? !0 : l == o ? !1 : typeof u == "function" ? e(u) : !!u;
    }, i = r.normalize = function(a) {
        return String(a).replace(t, ".").toLowerCase();
    }, n = r.data = {}, o = r.NATIVE = "N", s = r.POLYFILL = "P";
    return $914aec8743edd630$var$wo = r, $914aec8743edd630$var$wo;
}
var $914aec8743edd630$var$_o, $914aec8743edd630$var$Xl;
function $914aec8743edd630$var$Nt() {
    if ($914aec8743edd630$var$Xl) return $914aec8743edd630$var$_o;
    $914aec8743edd630$var$Xl = 1;
    var e = $914aec8743edd630$var$$e(), t = $914aec8743edd630$var$Qu().f, r = $914aec8743edd630$var$Ct(), i = $914aec8743edd630$var$ar(), n = $914aec8743edd630$var$Yu(), o = $914aec8743edd630$var$Iy(), s = $914aec8743edd630$var$Zm();
    return $914aec8743edd630$var$_o = function(a, u) {
        var l = a.target, c = a.global, d = a.stat, h, f, p, m, w, v;
        if (c ? f = e : d ? f = e[l] || n(l, {}) : f = (e[l] || {}).prototype, f) for(p in u){
            if (w = u[p], a.noTargetGet ? (v = t(f, p), m = v && v.value) : m = f[p], h = s(c ? p : l + (d ? "." : "#") + p, a.forced), !h && m !== void 0) {
                if (typeof w == typeof m) continue;
                o(w, m);
            }
            (a.sham || m && m.sham) && r(w, "sham", !0), i(f, p, w, a);
        }
    }, $914aec8743edd630$var$_o;
}
var $914aec8743edd630$var$ko, $914aec8743edd630$var$ed;
function $914aec8743edd630$var$My() {
    if ($914aec8743edd630$var$ed) return $914aec8743edd630$var$ko;
    $914aec8743edd630$var$ed = 1;
    var e = $914aec8743edd630$var$gt();
    return $914aec8743edd630$var$ko = !e(function() {
        function t() {}
        return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
    }), $914aec8743edd630$var$ko;
}
var $914aec8743edd630$var$xo, $914aec8743edd630$var$td;
function $914aec8743edd630$var$nc() {
    if ($914aec8743edd630$var$td) return $914aec8743edd630$var$xo;
    $914aec8743edd630$var$td = 1;
    var e = $914aec8743edd630$var$bt(), t = $914aec8743edd630$var$Gm(), r = $914aec8743edd630$var$Xu(), i = $914aec8743edd630$var$My(), n = r("IE_PROTO"), o = Object.prototype;
    return $914aec8743edd630$var$xo = i ? Object.getPrototypeOf : function(s) {
        return s = t(s), e(s, n) ? s[n] : typeof s.constructor == "function" && s instanceof s.constructor ? s.constructor.prototype : s instanceof Object ? o : null;
    }, $914aec8743edd630$var$xo;
}
var $914aec8743edd630$var$So, $914aec8743edd630$var$rd;
function $914aec8743edd630$var$jy() {
    if ($914aec8743edd630$var$rd) return $914aec8743edd630$var$So;
    $914aec8743edd630$var$rd = 1;
    var e = $914aec8743edd630$var$$t();
    return $914aec8743edd630$var$So = function(t) {
        if (!e(t) && t !== null) throw TypeError("Can't set " + String(t) + " as a prototype");
        return t;
    }, $914aec8743edd630$var$So;
}
var $914aec8743edd630$var$Eo, $914aec8743edd630$var$nd;
function $914aec8743edd630$var$ic() {
    if ($914aec8743edd630$var$nd) return $914aec8743edd630$var$Eo;
    $914aec8743edd630$var$nd = 1;
    var e = $914aec8743edd630$var$vt(), t = $914aec8743edd630$var$jy();
    return $914aec8743edd630$var$Eo = Object.setPrototypeOf || ("__proto__" in {} ? function() {
        var r = !1, i = {}, n;
        try {
            n = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set, n.call(i, []), r = i instanceof Array;
        } catch  {}
        return function(s, a) {
            return e(s), t(a), r ? n.call(s, a) : s.__proto__ = a, s;
        };
    }() : void 0), $914aec8743edd630$var$Eo;
}
var $914aec8743edd630$var$Ao, $914aec8743edd630$var$id;
function $914aec8743edd630$var$Fy() {
    if ($914aec8743edd630$var$id) return $914aec8743edd630$var$Ao;
    $914aec8743edd630$var$id = 1;
    var e = $914aec8743edd630$var$Jm(), t = $914aec8743edd630$var$rc();
    return $914aec8743edd630$var$Ao = Object.keys || function(i) {
        return e(i, t);
    }, $914aec8743edd630$var$Ao;
}
var $914aec8743edd630$var$To, $914aec8743edd630$var$od;
function $914aec8743edd630$var$$y() {
    if ($914aec8743edd630$var$od) return $914aec8743edd630$var$To;
    $914aec8743edd630$var$od = 1;
    var e = $914aec8743edd630$var$ir(), t = $914aec8743edd630$var$or(), r = $914aec8743edd630$var$vt(), i = $914aec8743edd630$var$Fy();
    return $914aec8743edd630$var$To = e ? Object.defineProperties : function(o, s) {
        r(o);
        for(var a = i(s), u = a.length, l = 0, c; u > l;)t.f(o, c = a[l++], s[c]);
        return o;
    }, $914aec8743edd630$var$To;
}
var $914aec8743edd630$var$Co, $914aec8743edd630$var$ad;
function $914aec8743edd630$var$Xm() {
    if ($914aec8743edd630$var$ad) return $914aec8743edd630$var$Co;
    $914aec8743edd630$var$ad = 1;
    var e = $914aec8743edd630$var$Lt();
    return $914aec8743edd630$var$Co = e("document", "documentElement"), $914aec8743edd630$var$Co;
}
var $914aec8743edd630$var$Ro, $914aec8743edd630$var$sd;
function $914aec8743edd630$var$oc() {
    if ($914aec8743edd630$var$sd) return $914aec8743edd630$var$Ro;
    $914aec8743edd630$var$sd = 1;
    var e = $914aec8743edd630$var$vt(), t = $914aec8743edd630$var$$y(), r = $914aec8743edd630$var$rc(), i = $914aec8743edd630$var$ec(), n = $914aec8743edd630$var$Xm(), o = $914aec8743edd630$var$Ku(), s = $914aec8743edd630$var$Xu(), a = ">", u = "<", l = "prototype", c = "script", d = s("IE_PROTO"), h = function() {}, f = function(g) {
        return u + c + a + g + u + "/" + c + a;
    }, p = function(g) {
        g.write(f("")), g.close();
        var A = g.parentWindow.Object;
        return g = null, A;
    }, m = function() {
        var g = o("iframe"), A = "java" + c + ":", b;
        return g.style.display = "none", n.appendChild(g), g.src = String(A), b = g.contentWindow.document, b.open(), b.write(f("document.F=Object")), b.close(), b.F;
    }, w, v = function() {
        try {
            w = document.domain && new ActiveXObject("htmlfile");
        } catch  {}
        v = w ? p(w) : m();
        for(var g = r.length; g--;)delete v[l][r[g]];
        return v();
    };
    return i[d] = !0, $914aec8743edd630$var$Ro = Object.create || function(A, b) {
        var k;
        return A !== null ? (h[l] = e(A), k = new h(), h[l] = null, k[d] = A) : k = v(), b === void 0 ? k : t(k, b);
    }, $914aec8743edd630$var$Ro;
}
var $914aec8743edd630$var$Oo, $914aec8743edd630$var$ud;
function $914aec8743edd630$var$ac() {
    if ($914aec8743edd630$var$ud) return $914aec8743edd630$var$Oo;
    $914aec8743edd630$var$ud = 1;
    var e = $914aec8743edd630$var$Lt();
    return $914aec8743edd630$var$Oo = e("navigator", "userAgent") || "", $914aec8743edd630$var$Oo;
}
var $914aec8743edd630$var$Do, $914aec8743edd630$var$cd;
function $914aec8743edd630$var$eg() {
    if ($914aec8743edd630$var$cd) return $914aec8743edd630$var$Do;
    $914aec8743edd630$var$cd = 1;
    var e = $914aec8743edd630$var$$e(), t = $914aec8743edd630$var$ac(), r = e.process, i = r && r.versions, n = i && i.v8, o, s;
    return n ? (o = n.split("."), s = o[0] < 4 ? 1 : o[0] + o[1]) : t && (o = t.match(/Edge\/(\d+)/), (!o || o[1] >= 74) && (o = t.match(/Chrome\/(\d+)/), o && (s = o[1]))), $914aec8743edd630$var$Do = s && +s, $914aec8743edd630$var$Do;
}
var $914aec8743edd630$var$Po, $914aec8743edd630$var$ld;
function $914aec8743edd630$var$tg() {
    if ($914aec8743edd630$var$ld) return $914aec8743edd630$var$Po;
    $914aec8743edd630$var$ld = 1;
    var e = $914aec8743edd630$var$eg(), t = $914aec8743edd630$var$gt();
    return $914aec8743edd630$var$Po = !!Object.getOwnPropertySymbols && !t(function() {
        var r = Symbol();
        return !String(r) || !(Object(r) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
        !Symbol.sham && e && e < 41;
    }), $914aec8743edd630$var$Po;
}
var $914aec8743edd630$var$Io, $914aec8743edd630$var$dd;
function $914aec8743edd630$var$Ly() {
    if ($914aec8743edd630$var$dd) return $914aec8743edd630$var$Io;
    $914aec8743edd630$var$dd = 1;
    var e = $914aec8743edd630$var$tg();
    return $914aec8743edd630$var$Io = e && !Symbol.sham && typeof Symbol.iterator == "symbol", $914aec8743edd630$var$Io;
}
var $914aec8743edd630$var$Mo, $914aec8743edd630$var$fd;
function $914aec8743edd630$var$Ye() {
    if ($914aec8743edd630$var$fd) return $914aec8743edd630$var$Mo;
    $914aec8743edd630$var$fd = 1;
    var e = $914aec8743edd630$var$$e(), t = $914aec8743edd630$var$Hm(), r = $914aec8743edd630$var$bt(), i = $914aec8743edd630$var$Km(), n = $914aec8743edd630$var$tg(), o = $914aec8743edd630$var$Ly(), s = t("wks"), a = e.Symbol, u = o ? a : a && a.withoutSetter || i;
    return $914aec8743edd630$var$Mo = function(l) {
        return (!r(s, l) || !(n || typeof s[l] == "string")) && (n && r(a, l) ? s[l] = a[l] : s[l] = u("Symbol." + l)), s[l];
    }, $914aec8743edd630$var$Mo;
}
var $914aec8743edd630$var$jo, $914aec8743edd630$var$hd;
function $914aec8743edd630$var$cn() {
    return $914aec8743edd630$var$hd || ($914aec8743edd630$var$hd = 1, $914aec8743edd630$var$jo = {}), $914aec8743edd630$var$jo;
}
var $914aec8743edd630$var$Fo, $914aec8743edd630$var$pd;
function $914aec8743edd630$var$Ny() {
    if ($914aec8743edd630$var$pd) return $914aec8743edd630$var$Fo;
    $914aec8743edd630$var$pd = 1;
    var e = $914aec8743edd630$var$Ye(), t = $914aec8743edd630$var$cn(), r = e("iterator"), i = Array.prototype;
    return $914aec8743edd630$var$Fo = function(n) {
        return n !== void 0 && (t.Array === n || i[r] === n);
    }, $914aec8743edd630$var$Fo;
}
var $914aec8743edd630$var$$o, $914aec8743edd630$var$md;
function $914aec8743edd630$var$sr() {
    return $914aec8743edd630$var$md || ($914aec8743edd630$var$md = 1, $914aec8743edd630$var$$o = function(e) {
        if (typeof e != "function") throw TypeError(String(e) + " is not a function");
        return e;
    }), $914aec8743edd630$var$$o;
}
var $914aec8743edd630$var$Lo, $914aec8743edd630$var$gd;
function $914aec8743edd630$var$rg() {
    if ($914aec8743edd630$var$gd) return $914aec8743edd630$var$Lo;
    $914aec8743edd630$var$gd = 1;
    var e = $914aec8743edd630$var$sr();
    return $914aec8743edd630$var$Lo = function(t, r, i) {
        if (e(t), r === void 0) return t;
        switch(i){
            case 0:
                return function() {
                    return t.call(r);
                };
            case 1:
                return function(n) {
                    return t.call(r, n);
                };
            case 2:
                return function(n, o) {
                    return t.call(r, n, o);
                };
            case 3:
                return function(n, o, s) {
                    return t.call(r, n, o, s);
                };
        }
        return function() {
            return t.apply(r, arguments);
        };
    }, $914aec8743edd630$var$Lo;
}
var $914aec8743edd630$var$No, $914aec8743edd630$var$bd;
function $914aec8743edd630$var$sc() {
    if ($914aec8743edd630$var$bd) return $914aec8743edd630$var$No;
    $914aec8743edd630$var$bd = 1;
    var e = $914aec8743edd630$var$Ye(), t = e("toStringTag"), r = {};
    return r[t] = "z", $914aec8743edd630$var$No = String(r) === "[object z]", $914aec8743edd630$var$No;
}
var $914aec8743edd630$var$Bo, $914aec8743edd630$var$vd;
function $914aec8743edd630$var$ng() {
    if ($914aec8743edd630$var$vd) return $914aec8743edd630$var$Bo;
    $914aec8743edd630$var$vd = 1;
    var e = $914aec8743edd630$var$sc(), t = $914aec8743edd630$var$Wu(), r = $914aec8743edd630$var$Ye(), i = r("toStringTag"), n = t(/* @__PURE__ */ function() {
        return arguments;
    }()) == "Arguments", o = function(s, a) {
        try {
            return s[a];
        } catch  {}
    };
    return $914aec8743edd630$var$Bo = e ? t : function(s) {
        var a, u, l;
        return s === void 0 ? "Undefined" : s === null ? "Null" : typeof (u = o(a = Object(s), i)) == "string" ? u : n ? t(a) : (l = t(a)) == "Object" && typeof a.callee == "function" ? "Arguments" : l;
    }, $914aec8743edd630$var$Bo;
}
var $914aec8743edd630$var$qo, $914aec8743edd630$var$yd;
function $914aec8743edd630$var$By() {
    if ($914aec8743edd630$var$yd) return $914aec8743edd630$var$qo;
    $914aec8743edd630$var$yd = 1;
    var e = $914aec8743edd630$var$ng(), t = $914aec8743edd630$var$cn(), r = $914aec8743edd630$var$Ye(), i = r("iterator");
    return $914aec8743edd630$var$qo = function(n) {
        if (n != null) return n[i] || n["@@iterator"] || t[e(n)];
    }, $914aec8743edd630$var$qo;
}
var $914aec8743edd630$var$zo, $914aec8743edd630$var$wd;
function $914aec8743edd630$var$qy() {
    if ($914aec8743edd630$var$wd) return $914aec8743edd630$var$zo;
    $914aec8743edd630$var$wd = 1;
    var e = $914aec8743edd630$var$vt();
    return $914aec8743edd630$var$zo = function(t) {
        var r = t.return;
        if (r !== void 0) return e(r.call(t)).value;
    }, $914aec8743edd630$var$zo;
}
var $914aec8743edd630$var$Uo, $914aec8743edd630$var$_d;
function $914aec8743edd630$var$ei() {
    if ($914aec8743edd630$var$_d) return $914aec8743edd630$var$Uo;
    $914aec8743edd630$var$_d = 1;
    var e = $914aec8743edd630$var$vt(), t = $914aec8743edd630$var$Ny(), r = $914aec8743edd630$var$Ym(), i = $914aec8743edd630$var$rg(), n = $914aec8743edd630$var$By(), o = $914aec8743edd630$var$qy(), s = function(a, u) {
        this.stopped = a, this.result = u;
    };
    return $914aec8743edd630$var$Uo = function(a, u, l) {
        var c = l && l.that, d = !!(l && l.AS_ENTRIES), h = !!(l && l.IS_ITERATOR), f = !!(l && l.INTERRUPTED), p = i(u, c, 1 + d + f), m, w, v, g, A, b, k, y = function(C) {
            return m && o(m), new s(!0, C);
        }, x = function(C) {
            return d ? (e(C), f ? p(C[0], C[1], y) : p(C[0], C[1])) : f ? p(C, y) : p(C);
        };
        if (h) m = a;
        else {
            if (w = n(a), typeof w != "function") throw TypeError("Target is not iterable");
            if (t(w)) {
                for(v = 0, g = r(a.length); g > v; v++)if (A = x(a[v]), A && A instanceof s) return A;
                return new s(!1);
            }
            m = w.call(a);
        }
        for(b = m.next; !(k = b.call(m)).done;){
            try {
                A = x(k.value);
            } catch (C) {
                throw o(m), C;
            }
            if (typeof A == "object" && A && A instanceof s) return A;
        }
        return new s(!1);
    }, $914aec8743edd630$var$Uo;
}
var $914aec8743edd630$var$kd;
function $914aec8743edd630$var$ig() {
    if ($914aec8743edd630$var$kd) return $914aec8743edd630$var$cl;
    $914aec8743edd630$var$kd = 1;
    var e = $914aec8743edd630$var$Nt(), t = $914aec8743edd630$var$nc(), r = $914aec8743edd630$var$ic(), i = $914aec8743edd630$var$oc(), n = $914aec8743edd630$var$Ct(), o = $914aec8743edd630$var$Jn(), s = $914aec8743edd630$var$ei(), a = function(l, c) {
        var d = this;
        if (!(d instanceof a)) return new a(l, c);
        r && (d = r(new Error(void 0), t(d))), c !== void 0 && n(d, "message", String(c));
        var h = [];
        return s(l, h.push, {
            that: h
        }), n(d, "errors", h), d;
    };
    return a.prototype = i(Error.prototype, {
        constructor: o(5, a),
        message: o(5, ""),
        name: o(5, "AggregateError")
    }), e({
        global: !0
    }, {
        AggregateError: a
    }), $914aec8743edd630$var$cl;
}
var $914aec8743edd630$var$xd = {}, $914aec8743edd630$var$Vo, $914aec8743edd630$var$Sd;
function $914aec8743edd630$var$zy() {
    if ($914aec8743edd630$var$Sd) return $914aec8743edd630$var$Vo;
    $914aec8743edd630$var$Sd = 1;
    var e = $914aec8743edd630$var$sc(), t = $914aec8743edd630$var$ng();
    return $914aec8743edd630$var$Vo = e ? ({}).toString : function() {
        return "[object " + t(this) + "]";
    }, $914aec8743edd630$var$Vo;
}
var $914aec8743edd630$var$Ed;
function $914aec8743edd630$var$Uy() {
    if ($914aec8743edd630$var$Ed) return $914aec8743edd630$var$xd;
    $914aec8743edd630$var$Ed = 1;
    var e = $914aec8743edd630$var$sc(), t = $914aec8743edd630$var$ar(), r = $914aec8743edd630$var$zy();
    return e || t(Object.prototype, "toString", r, {
        unsafe: !0
    }), $914aec8743edd630$var$xd;
}
var $914aec8743edd630$var$Ad = {}, $914aec8743edd630$var$Go, $914aec8743edd630$var$Td;
function $914aec8743edd630$var$og() {
    if ($914aec8743edd630$var$Td) return $914aec8743edd630$var$Go;
    $914aec8743edd630$var$Td = 1;
    var e = $914aec8743edd630$var$$e();
    return $914aec8743edd630$var$Go = e.Promise, $914aec8743edd630$var$Go;
}
var $914aec8743edd630$var$Wo, $914aec8743edd630$var$Cd;
function $914aec8743edd630$var$Vy() {
    if ($914aec8743edd630$var$Cd) return $914aec8743edd630$var$Wo;
    $914aec8743edd630$var$Cd = 1;
    var e = $914aec8743edd630$var$ar();
    return $914aec8743edd630$var$Wo = function(t, r, i) {
        for(var n in r)e(t, n, r[n], i);
        return t;
    }, $914aec8743edd630$var$Wo;
}
var $914aec8743edd630$var$Ho, $914aec8743edd630$var$Rd;
function $914aec8743edd630$var$uc() {
    if ($914aec8743edd630$var$Rd) return $914aec8743edd630$var$Ho;
    $914aec8743edd630$var$Rd = 1;
    var e = $914aec8743edd630$var$or().f, t = $914aec8743edd630$var$bt(), r = $914aec8743edd630$var$Ye(), i = r("toStringTag");
    return $914aec8743edd630$var$Ho = function(n, o, s) {
        n && !t(n = s ? n : n.prototype, i) && e(n, i, {
            configurable: !0,
            value: o
        });
    }, $914aec8743edd630$var$Ho;
}
var $914aec8743edd630$var$Ko, $914aec8743edd630$var$Od;
function $914aec8743edd630$var$Gy() {
    if ($914aec8743edd630$var$Od) return $914aec8743edd630$var$Ko;
    $914aec8743edd630$var$Od = 1;
    var e = $914aec8743edd630$var$Lt(), t = $914aec8743edd630$var$or(), r = $914aec8743edd630$var$Ye(), i = $914aec8743edd630$var$ir(), n = r("species");
    return $914aec8743edd630$var$Ko = function(o) {
        var s = e(o), a = t.f;
        i && s && !s[n] && a(s, n, {
            configurable: !0,
            get: function() {
                return this;
            }
        });
    }, $914aec8743edd630$var$Ko;
}
var $914aec8743edd630$var$Qo, $914aec8743edd630$var$Dd;
function $914aec8743edd630$var$Wy() {
    return $914aec8743edd630$var$Dd || ($914aec8743edd630$var$Dd = 1, $914aec8743edd630$var$Qo = function(e, t, r) {
        if (!(e instanceof t)) throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
        return e;
    }), $914aec8743edd630$var$Qo;
}
var $914aec8743edd630$var$Yo, $914aec8743edd630$var$Pd;
function $914aec8743edd630$var$Hy() {
    if ($914aec8743edd630$var$Pd) return $914aec8743edd630$var$Yo;
    $914aec8743edd630$var$Pd = 1;
    var e = $914aec8743edd630$var$Ye(), t = e("iterator"), r = !1;
    try {
        var i = 0, n = {
            next: function() {
                return {
                    done: !!i++
                };
            },
            return: function() {
                r = !0;
            }
        };
        n[t] = function() {
            return this;
        }, Array.from(n, function() {
            throw 2;
        });
    } catch  {}
    return $914aec8743edd630$var$Yo = function(o, s) {
        if (!s && !r) return !1;
        var a = !1;
        try {
            var u = {};
            u[t] = function() {
                return {
                    next: function() {
                        return {
                            done: a = !0
                        };
                    }
                };
            }, o(u);
        } catch  {}
        return a;
    }, $914aec8743edd630$var$Yo;
}
var $914aec8743edd630$var$Jo, $914aec8743edd630$var$Id;
function $914aec8743edd630$var$ag() {
    if ($914aec8743edd630$var$Id) return $914aec8743edd630$var$Jo;
    $914aec8743edd630$var$Id = 1;
    var e = $914aec8743edd630$var$vt(), t = $914aec8743edd630$var$sr(), r = $914aec8743edd630$var$Ye(), i = r("species");
    return $914aec8743edd630$var$Jo = function(n, o) {
        var s = e(n).constructor, a;
        return s === void 0 || (a = e(s)[i]) == null ? o : t(a);
    }, $914aec8743edd630$var$Jo;
}
var $914aec8743edd630$var$Zo, $914aec8743edd630$var$Md;
function $914aec8743edd630$var$sg() {
    if ($914aec8743edd630$var$Md) return $914aec8743edd630$var$Zo;
    $914aec8743edd630$var$Md = 1;
    var e = $914aec8743edd630$var$ac();
    return $914aec8743edd630$var$Zo = /(?:iphone|ipod|ipad).*applewebkit/i.test(e), $914aec8743edd630$var$Zo;
}
var $914aec8743edd630$var$Xo, $914aec8743edd630$var$jd;
function $914aec8743edd630$var$cc() {
    if ($914aec8743edd630$var$jd) return $914aec8743edd630$var$Xo;
    $914aec8743edd630$var$jd = 1;
    var e = $914aec8743edd630$var$Wu(), t = $914aec8743edd630$var$$e();
    return $914aec8743edd630$var$Xo = e(t.process) == "process", $914aec8743edd630$var$Xo;
}
var $914aec8743edd630$var$ea, $914aec8743edd630$var$Fd;
function $914aec8743edd630$var$ug() {
    if ($914aec8743edd630$var$Fd) return $914aec8743edd630$var$ea;
    $914aec8743edd630$var$Fd = 1;
    var e = $914aec8743edd630$var$$e(), t = $914aec8743edd630$var$gt(), r = $914aec8743edd630$var$rg(), i = $914aec8743edd630$var$Xm(), n = $914aec8743edd630$var$Ku(), o = $914aec8743edd630$var$sg(), s = $914aec8743edd630$var$cc(), a = e.location, u = e.setImmediate, l = e.clearImmediate, c = e.process, d = e.MessageChannel, h = e.Dispatch, f = 0, p = {}, m = "onreadystatechange", w, v, g, A = function(x) {
        if (p.hasOwnProperty(x)) {
            var C = p[x];
            delete p[x], C();
        }
    }, b = function(x) {
        return function() {
            A(x);
        };
    }, k = function(x) {
        A(x.data);
    }, y = function(x) {
        e.postMessage(x + "", a.protocol + "//" + a.host);
    };
    return (!u || !l) && (u = function(C) {
        for(var I = [], M = 1; arguments.length > M;)I.push(arguments[M++]);
        return p[++f] = function() {
            (typeof C == "function" ? C : Function(C)).apply(void 0, I);
        }, w(f), f;
    }, l = function(C) {
        delete p[C];
    }, s ? w = function(x) {
        c.nextTick(b(x));
    } : h && h.now ? w = function(x) {
        h.now(b(x));
    } : d && !o ? (v = new d(), g = v.port2, v.port1.onmessage = k, w = r(g.postMessage, g, 1)) : e.addEventListener && typeof postMessage == "function" && !e.importScripts && a && a.protocol !== "file:" && !t(y) ? (w = y, e.addEventListener("message", k, !1)) : m in n("script") ? w = function(x) {
        i.appendChild(n("script"))[m] = function() {
            i.removeChild(this), A(x);
        };
    } : w = function(x) {
        setTimeout(b(x), 0);
    }), $914aec8743edd630$var$ea = {
        set: u,
        clear: l
    }, $914aec8743edd630$var$ea;
}
var $914aec8743edd630$var$ta, $914aec8743edd630$var$$d;
function $914aec8743edd630$var$Ky() {
    if ($914aec8743edd630$var$$d) return $914aec8743edd630$var$ta;
    $914aec8743edd630$var$$d = 1;
    var e = $914aec8743edd630$var$ac();
    return $914aec8743edd630$var$ta = /web0s(?!.*chrome)/i.test(e), $914aec8743edd630$var$ta;
}
var $914aec8743edd630$var$ra, $914aec8743edd630$var$Ld;
function $914aec8743edd630$var$Qy() {
    if ($914aec8743edd630$var$Ld) return $914aec8743edd630$var$ra;
    $914aec8743edd630$var$Ld = 1;
    var e = $914aec8743edd630$var$$e(), t = $914aec8743edd630$var$Qu().f, r = $914aec8743edd630$var$ug().set, i = $914aec8743edd630$var$sg(), n = $914aec8743edd630$var$Ky(), o = $914aec8743edd630$var$cc(), s = e.MutationObserver || e.WebKitMutationObserver, a = e.document, u = e.process, l = e.Promise, c = t(e, "queueMicrotask"), d = c && c.value, h, f, p, m, w, v, g, A;
    return d || (h = function() {
        var b, k;
        for(o && (b = u.domain) && b.exit(); f;){
            k = f.fn, f = f.next;
            try {
                k();
            } catch (y) {
                throw f ? m() : p = void 0, y;
            }
        }
        p = void 0, b && b.enter();
    }, !i && !o && !n && s && a ? (w = !0, v = a.createTextNode(""), new s(h).observe(v, {
        characterData: !0
    }), m = function() {
        v.data = w = !w;
    }) : l && l.resolve ? (g = l.resolve(void 0), g.constructor = l, A = g.then, m = function() {
        A.call(g, h);
    }) : o ? m = function() {
        u.nextTick(h);
    } : m = function() {
        r.call(e, h);
    }), $914aec8743edd630$var$ra = d || function(b) {
        var k = {
            fn: b,
            next: void 0
        };
        p && (p.next = k), f || (f = k, m()), p = k;
    }, $914aec8743edd630$var$ra;
}
var $914aec8743edd630$var$na = {}, $914aec8743edd630$var$Nd;
function $914aec8743edd630$var$ln() {
    if ($914aec8743edd630$var$Nd) return $914aec8743edd630$var$na;
    $914aec8743edd630$var$Nd = 1;
    var e = $914aec8743edd630$var$sr(), t = function(r) {
        var i, n;
        this.promise = new r(function(o, s) {
            if (i !== void 0 || n !== void 0) throw TypeError("Bad Promise constructor");
            i = o, n = s;
        }), this.resolve = e(i), this.reject = e(n);
    };
    return $914aec8743edd630$var$na.f = function(r) {
        return new t(r);
    }, $914aec8743edd630$var$na;
}
var $914aec8743edd630$var$ia, $914aec8743edd630$var$Bd;
function $914aec8743edd630$var$cg() {
    if ($914aec8743edd630$var$Bd) return $914aec8743edd630$var$ia;
    $914aec8743edd630$var$Bd = 1;
    var e = $914aec8743edd630$var$vt(), t = $914aec8743edd630$var$$t(), r = $914aec8743edd630$var$ln();
    return $914aec8743edd630$var$ia = function(i, n) {
        if (e(i), t(n) && n.constructor === i) return n;
        var o = r.f(i), s = o.resolve;
        return s(n), o.promise;
    }, $914aec8743edd630$var$ia;
}
var $914aec8743edd630$var$oa, $914aec8743edd630$var$qd;
function $914aec8743edd630$var$Yy() {
    if ($914aec8743edd630$var$qd) return $914aec8743edd630$var$oa;
    $914aec8743edd630$var$qd = 1;
    var e = $914aec8743edd630$var$$e();
    return $914aec8743edd630$var$oa = function(t, r) {
        var i = e.console;
        i && i.error && (arguments.length === 1 ? i.error(t) : i.error(t, r));
    }, $914aec8743edd630$var$oa;
}
var $914aec8743edd630$var$aa, $914aec8743edd630$var$zd;
function $914aec8743edd630$var$ti() {
    return $914aec8743edd630$var$zd || ($914aec8743edd630$var$zd = 1, $914aec8743edd630$var$aa = function(e) {
        try {
            return {
                error: !1,
                value: e()
            };
        } catch (t) {
            return {
                error: !0,
                value: t
            };
        }
    }), $914aec8743edd630$var$aa;
}
var $914aec8743edd630$var$sa, $914aec8743edd630$var$Ud;
function $914aec8743edd630$var$Jy() {
    return $914aec8743edd630$var$Ud || ($914aec8743edd630$var$Ud = 1, $914aec8743edd630$var$sa = typeof window == "object"), $914aec8743edd630$var$sa;
}
var $914aec8743edd630$var$Vd;
function $914aec8743edd630$var$Zy() {
    if ($914aec8743edd630$var$Vd) return $914aec8743edd630$var$Ad;
    $914aec8743edd630$var$Vd = 1;
    var e = $914aec8743edd630$var$Nt(), t = $914aec8743edd630$var$un(), r = $914aec8743edd630$var$$e(), i = $914aec8743edd630$var$Lt(), n = $914aec8743edd630$var$og(), o = $914aec8743edd630$var$ar(), s = $914aec8743edd630$var$Vy(), a = $914aec8743edd630$var$ic(), u = $914aec8743edd630$var$uc(), l = $914aec8743edd630$var$Gy(), c = $914aec8743edd630$var$$t(), d = $914aec8743edd630$var$sr(), h = $914aec8743edd630$var$Wy(), f = $914aec8743edd630$var$Zu(), p = $914aec8743edd630$var$ei(), m = $914aec8743edd630$var$Hy(), w = $914aec8743edd630$var$ag(), v = $914aec8743edd630$var$ug().set, g = $914aec8743edd630$var$Qy(), A = $914aec8743edd630$var$cg(), b = $914aec8743edd630$var$Yy(), k = $914aec8743edd630$var$ln(), y = $914aec8743edd630$var$ti(), x = $914aec8743edd630$var$Xn(), C = $914aec8743edd630$var$Zm(), I = $914aec8743edd630$var$Ye(), M = $914aec8743edd630$var$Jy(), Q = $914aec8743edd630$var$cc(), H = $914aec8743edd630$var$eg(), J = I("species"), W = "Promise", P = x.get, R = x.set, V = x.getterFor(W), X = n && n.prototype, N = n, U = X, G = r.TypeError, re = r.document, oe = r.process, ie = k.f, le = ie, he = !!(re && re.createEvent && r.dispatchEvent), ye = typeof PromiseRejectionEvent == "function", be = "unhandledrejection", we = "rejectionhandled", ve = 0, Re = 1, De = 2, te = 1, Z = 2, ue = !1, pe, me, L, B, D = C(W, function() {
        var $ = f(N), K = $ !== String(N);
        if (!K && H === 66 || t && !U.finally) return !0;
        if (H >= 51 && /native code/.test($)) return !1;
        var ee = new N(function(ke) {
            ke(1);
        }), de = function(ke) {
            ke(function() {}, function() {});
        }, ge = ee.constructor = {};
        return ge[J] = de, ue = ee.then(function() {}) instanceof de, ue ? !K && M && !ye : !0;
    }), E = D || !m(function($) {
        N.all($).catch(function() {});
    }), T = function($) {
        var K;
        return c($) && typeof (K = $.then) == "function" ? K : !1;
    }, j = function($, K) {
        if (!$.notified) {
            $.notified = !0;
            var ee = $.reactions;
            g(function() {
                for(var de = $.value, ge = $.state == Re, ke = 0; ee.length > ke;){
                    var Ee = ee[ke++], xe = ge ? Ee.ok : Ee.fail, tt = Ee.resolve, rt = Ee.reject, We = Ee.domain, nt, Ut, Rt;
                    try {
                        xe ? (ge || ($.rejection === Z && O($), $.rejection = te), xe === !0 ? nt = de : (We && We.enter(), nt = xe(de), We && (We.exit(), Rt = !0)), nt === Ee.promise ? rt(G("Promise-chain cycle")) : (Ut = T(nt)) ? Ut.call(nt, tt, rt) : tt(nt)) : rt(de);
                    } catch (Vt) {
                        We && !Rt && We.exit(), rt(Vt);
                    }
                }
                $.reactions = [], $.notified = !1, K && !$.rejection && ae($);
            });
        }
    }, Y = function($, K, ee) {
        var de, ge;
        he ? (de = re.createEvent("Event"), de.promise = K, de.reason = ee, de.initEvent($, !1, !0), r.dispatchEvent(de)) : de = {
            promise: K,
            reason: ee
        }, !ye && (ge = r["on" + $]) ? ge(de) : $ === be && b("Unhandled promise rejection", ee);
    }, ae = function($) {
        v.call(r, function() {
            var K = $.facade, ee = $.value, de = se($), ge;
            if (de && (ge = y(function() {
                Q ? oe.emit("unhandledRejection", ee, K) : Y(be, K, ee);
            }), $.rejection = Q || se($) ? Z : te, ge.error)) throw ge.value;
        });
    }, se = function($) {
        return $.rejection !== te && !$.parent;
    }, O = function($) {
        v.call(r, function() {
            var K = $.facade;
            Q ? oe.emit("rejectionHandled", K) : Y(we, K, $.value);
        });
    }, _ = function($, K, ee) {
        return function(de) {
            $(K, de, ee);
        };
    }, S = function($, K, ee) {
        $.done || ($.done = !0, ee && ($ = ee), $.value = K, $.state = De, j($, !0));
    }, F = function($, K, ee) {
        if (!$.done) {
            $.done = !0, ee && ($ = ee);
            try {
                if ($.facade === K) throw G("Promise can't be resolved itself");
                var de = T(K);
                de ? g(function() {
                    var ge = {
                        done: !1
                    };
                    try {
                        de.call(K, _(F, ge, $), _(S, ge, $));
                    } catch (ke) {
                        S(ge, ke, $);
                    }
                }) : ($.value = K, $.state = Re, j($, !1));
            } catch (ge) {
                S({
                    done: !1
                }, ge, $);
            }
        }
    };
    if (D && (N = function(K) {
        h(this, N, W), d(K), pe.call(this);
        var ee = P(this);
        try {
            K(_(F, ee), _(S, ee));
        } catch (de) {
            S(ee, de);
        }
    }, U = N.prototype, pe = function(K) {
        R(this, {
            type: W,
            done: !1,
            notified: !1,
            parent: !1,
            reactions: [],
            rejection: !1,
            state: ve,
            value: void 0
        });
    }, pe.prototype = s(U, {
        // `Promise.prototype.then` method
        // https://tc39.es/ecma262/#sec-promise.prototype.then
        then: function(K, ee) {
            var de = V(this), ge = ie(w(this, N));
            return ge.ok = typeof K == "function" ? K : !0, ge.fail = typeof ee == "function" && ee, ge.domain = Q ? oe.domain : void 0, de.parent = !0, de.reactions.push(ge), de.state != ve && j(de, !1), ge.promise;
        },
        // `Promise.prototype.catch` method
        // https://tc39.es/ecma262/#sec-promise.prototype.catch
        catch: function($) {
            return this.then(void 0, $);
        }
    }), me = function() {
        var $ = new pe(), K = P($);
        this.promise = $, this.resolve = _(F, K), this.reject = _(S, K);
    }, k.f = ie = function($) {
        return $ === N || $ === L ? new me($) : le($);
    }, !t && typeof n == "function" && X !== Object.prototype)) {
        B = X.then, ue || (o(X, "then", function(K, ee) {
            var de = this;
            return new N(function(ge, ke) {
                B.call(de, ge, ke);
            }).then(K, ee);
        }, {
            unsafe: !0
        }), o(X, "catch", U.catch, {
            unsafe: !0
        }));
        try {
            delete X.constructor;
        } catch  {}
        a && a(X, U);
    }
    return e({
        global: !0,
        wrap: !0,
        forced: D
    }, {
        Promise: N
    }), u(N, W, !1, !0), l(W), L = i(W), e({
        target: W,
        stat: !0,
        forced: D
    }, {
        // `Promise.reject` method
        // https://tc39.es/ecma262/#sec-promise.reject
        reject: function(K) {
            var ee = ie(this);
            return ee.reject.call(void 0, K), ee.promise;
        }
    }), e({
        target: W,
        stat: !0,
        forced: t || D
    }, {
        // `Promise.resolve` method
        // https://tc39.es/ecma262/#sec-promise.resolve
        resolve: function(K) {
            return A(t && this === L ? N : this, K);
        }
    }), e({
        target: W,
        stat: !0,
        forced: E
    }, {
        // `Promise.all` method
        // https://tc39.es/ecma262/#sec-promise.all
        all: function(K) {
            var ee = this, de = ie(ee), ge = de.resolve, ke = de.reject, Ee = y(function() {
                var xe = d(ee.resolve), tt = [], rt = 0, We = 1;
                p(K, function(nt) {
                    var Ut = rt++, Rt = !1;
                    tt.push(void 0), We++, xe.call(ee, nt).then(function(Vt) {
                        Rt || (Rt = !0, tt[Ut] = Vt, --We || ge(tt));
                    }, ke);
                }), --We || ge(tt);
            });
            return Ee.error && ke(Ee.value), de.promise;
        },
        // `Promise.race` method
        // https://tc39.es/ecma262/#sec-promise.race
        race: function(K) {
            var ee = this, de = ie(ee), ge = de.reject, ke = y(function() {
                var Ee = d(ee.resolve);
                p(K, function(xe) {
                    Ee.call(ee, xe).then(de.resolve, ge);
                });
            });
            return ke.error && ge(ke.value), de.promise;
        }
    }), $914aec8743edd630$var$Ad;
}
var $914aec8743edd630$var$Gd = {}, $914aec8743edd630$var$Wd;
function $914aec8743edd630$var$lg() {
    if ($914aec8743edd630$var$Wd) return $914aec8743edd630$var$Gd;
    $914aec8743edd630$var$Wd = 1;
    var e = $914aec8743edd630$var$Nt(), t = $914aec8743edd630$var$sr(), r = $914aec8743edd630$var$ln(), i = $914aec8743edd630$var$ti(), n = $914aec8743edd630$var$ei();
    return e({
        target: "Promise",
        stat: !0
    }, {
        allSettled: function(s) {
            var a = this, u = r.f(a), l = u.resolve, c = u.reject, d = i(function() {
                var h = t(a.resolve), f = [], p = 0, m = 1;
                n(s, function(w) {
                    var v = p++, g = !1;
                    f.push(void 0), m++, h.call(a, w).then(function(A) {
                        g || (g = !0, f[v] = {
                            status: "fulfilled",
                            value: A
                        }, --m || l(f));
                    }, function(A) {
                        g || (g = !0, f[v] = {
                            status: "rejected",
                            reason: A
                        }, --m || l(f));
                    });
                }), --m || l(f);
            });
            return d.error && c(d.value), u.promise;
        }
    }), $914aec8743edd630$var$Gd;
}
var $914aec8743edd630$var$Hd = {}, $914aec8743edd630$var$Kd;
function $914aec8743edd630$var$dg() {
    if ($914aec8743edd630$var$Kd) return $914aec8743edd630$var$Hd;
    $914aec8743edd630$var$Kd = 1;
    var e = $914aec8743edd630$var$Nt(), t = $914aec8743edd630$var$sr(), r = $914aec8743edd630$var$Lt(), i = $914aec8743edd630$var$ln(), n = $914aec8743edd630$var$ti(), o = $914aec8743edd630$var$ei(), s = "No one promise resolved";
    return e({
        target: "Promise",
        stat: !0
    }, {
        any: function(u) {
            var l = this, c = i.f(l), d = c.resolve, h = c.reject, f = n(function() {
                var p = t(l.resolve), m = [], w = 0, v = 1, g = !1;
                o(u, function(A) {
                    var b = w++, k = !1;
                    m.push(void 0), v++, p.call(l, A).then(function(y) {
                        k || g || (g = !0, d(y));
                    }, function(y) {
                        k || g || (k = !0, m[b] = y, --v || h(new (r("AggregateError"))(m, s)));
                    });
                }), --v || h(new (r("AggregateError"))(m, s));
            });
            return f.error && h(f.value), c.promise;
        }
    }), $914aec8743edd630$var$Hd;
}
var $914aec8743edd630$var$Qd = {}, $914aec8743edd630$var$Yd;
function $914aec8743edd630$var$Xy() {
    if ($914aec8743edd630$var$Yd) return $914aec8743edd630$var$Qd;
    $914aec8743edd630$var$Yd = 1;
    var e = $914aec8743edd630$var$Nt(), t = $914aec8743edd630$var$un(), r = $914aec8743edd630$var$og(), i = $914aec8743edd630$var$gt(), n = $914aec8743edd630$var$Lt(), o = $914aec8743edd630$var$ag(), s = $914aec8743edd630$var$cg(), a = $914aec8743edd630$var$ar(), u = !!r && i(function() {
        r.prototype.finally.call({
            then: function() {}
        }, function() {});
    });
    if (e({
        target: "Promise",
        proto: !0,
        real: !0,
        forced: u
    }, {
        finally: function(c) {
            var d = o(this, n("Promise")), h = typeof c == "function";
            return this.then(h ? function(f) {
                return s(d, c()).then(function() {
                    return f;
                });
            } : c, h ? function(f) {
                return s(d, c()).then(function() {
                    throw f;
                });
            } : c);
        }
    }), !t && typeof r == "function") {
        var l = n("Promise").prototype.finally;
        r.prototype.finally !== l && a(r.prototype, "finally", l, {
            unsafe: !0
        });
    }
    return $914aec8743edd630$var$Qd;
}
var $914aec8743edd630$var$Jd = {}, $914aec8743edd630$var$ua, $914aec8743edd630$var$Zd;
function $914aec8743edd630$var$e1() {
    if ($914aec8743edd630$var$Zd) return $914aec8743edd630$var$ua;
    $914aec8743edd630$var$Zd = 1;
    var e = $914aec8743edd630$var$tc(), t = $914aec8743edd630$var$Hu(), r = function(i) {
        return function(n, o) {
            var s = String(t(n)), a = e(o), u = s.length, l, c;
            return a < 0 || a >= u ? i ? "" : void 0 : (l = s.charCodeAt(a), l < 55296 || l > 56319 || a + 1 === u || (c = s.charCodeAt(a + 1)) < 56320 || c > 57343 ? i ? s.charAt(a) : l : i ? s.slice(a, a + 2) : (l - 55296 << 10) + (c - 56320) + 65536);
        };
    };
    return $914aec8743edd630$var$ua = {
        // `String.prototype.codePointAt` method
        // https://tc39.es/ecma262/#sec-string.prototype.codepointat
        codeAt: r(!1),
        // `String.prototype.at` method
        // https://github.com/mathiasbynens/String.prototype.at
        charAt: r(!0)
    }, $914aec8743edd630$var$ua;
}
var $914aec8743edd630$var$ca, $914aec8743edd630$var$Xd;
function $914aec8743edd630$var$fg() {
    if ($914aec8743edd630$var$Xd) return $914aec8743edd630$var$ca;
    $914aec8743edd630$var$Xd = 1;
    var e = $914aec8743edd630$var$gt(), t = $914aec8743edd630$var$nc(), r = $914aec8743edd630$var$Ct(), i = $914aec8743edd630$var$bt(), n = $914aec8743edd630$var$Ye(), o = $914aec8743edd630$var$un(), s = n("iterator"), a = !1, u = function() {
        return this;
    }, l, c, d;
    [].keys && (d = [].keys(), "next" in d ? (c = t(t(d)), c !== Object.prototype && (l = c)) : a = !0);
    var h = l == null || e(function() {
        var f = {};
        return l[s].call(f) !== f;
    });
    return h && (l = {}), (!o || h) && !i(l, s) && r(l, s, u), $914aec8743edd630$var$ca = {
        IteratorPrototype: l,
        BUGGY_SAFARI_ITERATORS: a
    }, $914aec8743edd630$var$ca;
}
var $914aec8743edd630$var$la, $914aec8743edd630$var$ef;
function $914aec8743edd630$var$t1() {
    if ($914aec8743edd630$var$ef) return $914aec8743edd630$var$la;
    $914aec8743edd630$var$ef = 1;
    var e = $914aec8743edd630$var$fg().IteratorPrototype, t = $914aec8743edd630$var$oc(), r = $914aec8743edd630$var$Jn(), i = $914aec8743edd630$var$uc(), n = $914aec8743edd630$var$cn(), o = function() {
        return this;
    };
    return $914aec8743edd630$var$la = function(s, a, u) {
        var l = a + " Iterator";
        return s.prototype = t(e, {
            next: r(1, u)
        }), i(s, l, !1, !0), n[l] = o, s;
    }, $914aec8743edd630$var$la;
}
var $914aec8743edd630$var$da, $914aec8743edd630$var$tf;
function $914aec8743edd630$var$hg() {
    if ($914aec8743edd630$var$tf) return $914aec8743edd630$var$da;
    $914aec8743edd630$var$tf = 1;
    var e = $914aec8743edd630$var$Nt(), t = $914aec8743edd630$var$t1(), r = $914aec8743edd630$var$nc(), i = $914aec8743edd630$var$ic(), n = $914aec8743edd630$var$uc(), o = $914aec8743edd630$var$Ct(), s = $914aec8743edd630$var$ar(), a = $914aec8743edd630$var$Ye(), u = $914aec8743edd630$var$un(), l = $914aec8743edd630$var$cn(), c = $914aec8743edd630$var$fg(), d = c.IteratorPrototype, h = c.BUGGY_SAFARI_ITERATORS, f = a("iterator"), p = "keys", m = "values", w = "entries", v = function() {
        return this;
    };
    return $914aec8743edd630$var$da = function(g, A, b, k, y, x, C) {
        t(b, A, k);
        var I = function(N) {
            if (N === y && W) return W;
            if (!h && N in H) return H[N];
            switch(N){
                case p:
                    return function() {
                        return new b(this, N);
                    };
                case m:
                    return function() {
                        return new b(this, N);
                    };
                case w:
                    return function() {
                        return new b(this, N);
                    };
            }
            return function() {
                return new b(this);
            };
        }, M = A + " Iterator", Q = !1, H = g.prototype, J = H[f] || H["@@iterator"] || y && H[y], W = !h && J || I(y), P = A == "Array" && H.entries || J, R, V, X;
        if (P && (R = r(P.call(new g())), d !== Object.prototype && R.next && (!u && r(R) !== d && (i ? i(R, d) : typeof R[f] != "function" && o(R, f, v)), n(R, M, !0, !0), u && (l[M] = v))), y == m && J && J.name !== m && (Q = !0, W = function() {
            return J.call(this);
        }), (!u || C) && H[f] !== W && o(H, f, W), l[A] = W, y) {
            if (V = {
                values: I(m),
                keys: x ? W : I(p),
                entries: I(w)
            }, C) for(X in V)(h || Q || !(X in H)) && s(H, X, V[X]);
            else e({
                target: A,
                proto: !0,
                forced: h || Q
            }, V);
        }
        return V;
    }, $914aec8743edd630$var$da;
}
var $914aec8743edd630$var$rf;
function $914aec8743edd630$var$r1() {
    if ($914aec8743edd630$var$rf) return $914aec8743edd630$var$Jd;
    $914aec8743edd630$var$rf = 1;
    var e = $914aec8743edd630$var$e1().charAt, t = $914aec8743edd630$var$Xn(), r = $914aec8743edd630$var$hg(), i = "String Iterator", n = t.set, o = t.getterFor(i);
    return r(String, "String", function(s) {
        n(this, {
            type: i,
            string: String(s),
            index: 0
        });
    }, function() {
        var a = o(this), u = a.string, l = a.index, c;
        return l >= u.length ? {
            value: void 0,
            done: !0
        } : (c = e(u, l), a.index += c.length, {
            value: c,
            done: !1
        });
    }), $914aec8743edd630$var$Jd;
}
var $914aec8743edd630$var$nf = {}, $914aec8743edd630$var$fa, $914aec8743edd630$var$of;
function $914aec8743edd630$var$n1() {
    return $914aec8743edd630$var$of || ($914aec8743edd630$var$of = 1, $914aec8743edd630$var$fa = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    }), $914aec8743edd630$var$fa;
}
var $914aec8743edd630$var$ha, $914aec8743edd630$var$af;
function $914aec8743edd630$var$i1() {
    if ($914aec8743edd630$var$af) return $914aec8743edd630$var$ha;
    $914aec8743edd630$var$af = 1;
    var e = $914aec8743edd630$var$Ye(), t = $914aec8743edd630$var$oc(), r = $914aec8743edd630$var$or(), i = e("unscopables"), n = Array.prototype;
    return n[i] == null && r.f(n, i, {
        configurable: !0,
        value: t(null)
    }), $914aec8743edd630$var$ha = function(o) {
        n[i][o] = !0;
    }, $914aec8743edd630$var$ha;
}
var $914aec8743edd630$var$pa, $914aec8743edd630$var$sf;
function $914aec8743edd630$var$o1() {
    if ($914aec8743edd630$var$sf) return $914aec8743edd630$var$pa;
    $914aec8743edd630$var$sf = 1;
    var e = $914aec8743edd630$var$Zn(), t = $914aec8743edd630$var$i1(), r = $914aec8743edd630$var$cn(), i = $914aec8743edd630$var$Xn(), n = $914aec8743edd630$var$hg(), o = "Array Iterator", s = i.set, a = i.getterFor(o);
    return $914aec8743edd630$var$pa = n(Array, "Array", function(u, l) {
        s(this, {
            type: o,
            target: e(u),
            // target
            index: 0,
            // next index
            kind: l
        });
    }, function() {
        var u = a(this), l = u.target, c = u.kind, d = u.index++;
        return !l || d >= l.length ? (u.target = void 0, {
            value: void 0,
            done: !0
        }) : c == "keys" ? {
            value: d,
            done: !1
        } : c == "values" ? {
            value: l[d],
            done: !1
        } : {
            value: [
                d,
                l[d]
            ],
            done: !1
        };
    }, "values"), r.Arguments = r.Array, t("keys"), t("values"), t("entries"), $914aec8743edd630$var$pa;
}
var $914aec8743edd630$var$uf;
function $914aec8743edd630$var$a1() {
    if ($914aec8743edd630$var$uf) return $914aec8743edd630$var$nf;
    $914aec8743edd630$var$uf = 1;
    var e = $914aec8743edd630$var$$e(), t = $914aec8743edd630$var$n1(), r = $914aec8743edd630$var$o1(), i = $914aec8743edd630$var$Ct(), n = $914aec8743edd630$var$Ye(), o = n("iterator"), s = n("toStringTag"), a = r.values;
    for(var u in t){
        var l = e[u], c = l && l.prototype;
        if (c) {
            if (c[o] !== a) try {
                i(c, o, a);
            } catch  {
                c[o] = a;
            }
            if (c[s] || i(c, s, u), t[u]) {
                for(var d in r)if (c[d] !== r[d]) try {
                    i(c, d, r[d]);
                } catch  {
                    c[d] = r[d];
                }
            }
        }
    }
    return $914aec8743edd630$var$nf;
}
var $914aec8743edd630$var$ma, $914aec8743edd630$var$cf;
function $914aec8743edd630$var$s1() {
    if ($914aec8743edd630$var$cf) return $914aec8743edd630$var$ma;
    $914aec8743edd630$var$cf = 1, $914aec8743edd630$var$ig(), $914aec8743edd630$var$Uy(), $914aec8743edd630$var$Zy(), $914aec8743edd630$var$lg(), $914aec8743edd630$var$dg(), $914aec8743edd630$var$Xy(), $914aec8743edd630$var$r1(), $914aec8743edd630$var$a1();
    var e = $914aec8743edd630$var$Qm();
    return $914aec8743edd630$var$ma = e.Promise, $914aec8743edd630$var$ma;
}
var $914aec8743edd630$var$lf = {}, $914aec8743edd630$var$df;
function $914aec8743edd630$var$u1() {
    return $914aec8743edd630$var$df || ($914aec8743edd630$var$df = 1, $914aec8743edd630$var$ig()), $914aec8743edd630$var$lf;
}
var $914aec8743edd630$var$ff = {}, $914aec8743edd630$var$hf;
function $914aec8743edd630$var$c1() {
    return $914aec8743edd630$var$hf || ($914aec8743edd630$var$hf = 1, $914aec8743edd630$var$lg()), $914aec8743edd630$var$ff;
}
var $914aec8743edd630$var$pf = {}, $914aec8743edd630$var$mf;
function $914aec8743edd630$var$l1() {
    if ($914aec8743edd630$var$mf) return $914aec8743edd630$var$pf;
    $914aec8743edd630$var$mf = 1;
    var e = $914aec8743edd630$var$Nt(), t = $914aec8743edd630$var$ln(), r = $914aec8743edd630$var$ti();
    return e({
        target: "Promise",
        stat: !0
    }, {
        try: function(i) {
            var n = t.f(this), o = r(i);
            return (o.error ? n.reject : n.resolve)(o.value), n.promise;
        }
    }), $914aec8743edd630$var$pf;
}
var $914aec8743edd630$var$gf = {}, $914aec8743edd630$var$bf;
function $914aec8743edd630$var$d1() {
    return $914aec8743edd630$var$bf || ($914aec8743edd630$var$bf = 1, $914aec8743edd630$var$dg()), $914aec8743edd630$var$gf;
}
var $914aec8743edd630$var$ga, $914aec8743edd630$var$vf;
function $914aec8743edd630$var$f1() {
    if ($914aec8743edd630$var$vf) return $914aec8743edd630$var$ga;
    $914aec8743edd630$var$vf = 1;
    var e = $914aec8743edd630$var$s1();
    return $914aec8743edd630$var$u1(), $914aec8743edd630$var$c1(), $914aec8743edd630$var$l1(), $914aec8743edd630$var$d1(), $914aec8743edd630$var$ga = e, $914aec8743edd630$var$ga;
}
var $914aec8743edd630$var$ba = {}, $914aec8743edd630$var$yf;
function $914aec8743edd630$var$h1() {
    return $914aec8743edd630$var$yf || ($914aec8743edd630$var$yf = 1, function(e) {
        var t = function() {
            try {
                if (e.URLSearchParams && new e.URLSearchParams("foo=bar").get("foo") === "bar") return e.URLSearchParams;
            } catch  {}
            return null;
        }(), r = t && new t({
            a: 1
        }).toString() === "a=1", i = t && new t("s=%2B").get("s") === "+", n = "__URLSearchParams__", o = t ? function() {
            var b = new t();
            return b.append("s", " &"), b.toString() === "s=+%26";
        }() : !0, s = u.prototype, a = !!(e.Symbol && e.Symbol.iterator);
        if (t && r && i && o) return;
        function u(b) {
            b = b || "", (b instanceof URLSearchParams || b instanceof u) && (b = b.toString()), this[n] = w(b);
        }
        s.append = function(b, k) {
            v(this[n], b, k);
        }, s.delete = function(b) {
            delete this[n][b];
        }, s.get = function(b) {
            var k = this[n];
            return this.has(b) ? k[b][0] : null;
        }, s.getAll = function(b) {
            var k = this[n];
            return this.has(b) ? k[b].slice(0) : [];
        }, s.has = function(b) {
            return A(this[n], b);
        }, s.set = function(k, y) {
            this[n][k] = [
                "" + y
            ];
        }, s.toString = function() {
            var b = this[n], k = [], y, x, C, I;
            for(x in b)for(C = f(x), y = 0, I = b[x]; y < I.length; y++)k.push(C + "=" + f(I[y]));
            return k.join("&");
        };
        var l = !i, c = !l && t && !r && e.Proxy, d;
        c ? (d = new Proxy(t, {
            construct: function(b, k) {
                return new b(new u(k[0]).toString());
            }
        }), d.toString = Function.prototype.toString.bind(u)) : d = u, Object.defineProperty(e, "URLSearchParams", {
            value: d
        });
        var h = e.URLSearchParams.prototype;
        h.polyfill = !0, h.forEach = h.forEach || function(b, k) {
            var y = w(this.toString());
            Object.getOwnPropertyNames(y).forEach(function(x) {
                y[x].forEach(function(C) {
                    b.call(k, C, x, this);
                }, this);
            }, this);
        }, h.sort = h.sort || function() {
            var b = w(this.toString()), k = [], y, x, C;
            for(y in b)k.push(y);
            for(k.sort(), x = 0; x < k.length; x++)this.delete(k[x]);
            for(x = 0; x < k.length; x++){
                var I = k[x], M = b[I];
                for(C = 0; C < M.length; C++)this.append(I, M[C]);
            }
        }, h.keys = h.keys || function() {
            var b = [];
            return this.forEach(function(k, y) {
                b.push(y);
            }), m(b);
        }, h.values = h.values || function() {
            var b = [];
            return this.forEach(function(k) {
                b.push(k);
            }), m(b);
        }, h.entries = h.entries || function() {
            var b = [];
            return this.forEach(function(k, y) {
                b.push([
                    y,
                    k
                ]);
            }), m(b);
        }, a && (h[e.Symbol.iterator] = h[e.Symbol.iterator] || h.entries);
        function f(b) {
            var k = {
                "!": "%21",
                "'": "%27",
                "(": "%28",
                ")": "%29",
                "~": "%7E",
                "%20": "+",
                "%00": "\0"
            };
            return encodeURIComponent(b).replace(/[!'\(\)~]|%20|%00/g, function(y) {
                return k[y];
            });
        }
        function p(b) {
            return b.replace(/[ +]/g, "%20").replace(/(%[a-f0-9]{2})+/ig, function(k) {
                return decodeURIComponent(k);
            });
        }
        function m(b) {
            var k = {
                next: function() {
                    var y = b.shift();
                    return {
                        done: y === void 0,
                        value: y
                    };
                }
            };
            return a && (k[e.Symbol.iterator] = function() {
                return k;
            }), k;
        }
        function w(b) {
            var k = {};
            if (typeof b == "object") {
                if (g(b)) for(var y = 0; y < b.length; y++){
                    var x = b[y];
                    if (g(x) && x.length === 2) v(k, x[0], x[1]);
                    else throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
                }
                else for(var C in b)b.hasOwnProperty(C) && v(k, C, b[C]);
            } else {
                b.indexOf("?") === 0 && (b = b.slice(1));
                for(var I = b.split("&"), M = 0; M < I.length; M++){
                    var Q = I[M], H = Q.indexOf("=");
                    -1 < H ? v(k, p(Q.slice(0, H)), p(Q.slice(H + 1))) : Q && v(k, p(Q), "");
                }
            }
            return k;
        }
        function v(b, k, y) {
            var x = typeof y == "string" ? y : y != null && typeof y.toString == "function" ? y.toString() : JSON.stringify(y);
            A(b, k) ? b[k].push(x) : b[k] = [
                x
            ];
        }
        function g(b) {
            return !!b && Object.prototype.toString.call(b) === "[object Array]";
        }
        function A(b, k) {
            return Object.prototype.hasOwnProperty.call(b, k);
        }
    }(typeof $914aec8743edd630$var$Ne < "u" ? $914aec8743edd630$var$Ne : typeof window < "u" ? window : $914aec8743edd630$var$ba)), $914aec8743edd630$var$ba;
}
var $914aec8743edd630$var$lr = {}, $914aec8743edd630$var$Ot = {}, $914aec8743edd630$var$va = {}, $914aec8743edd630$var$ya = {}, $914aec8743edd630$var$wf;
function $914aec8743edd630$var$yt() {
    if ($914aec8743edd630$var$wf) return $914aec8743edd630$var$ya;
    $914aec8743edd630$var$wf = 1;
    var e = typeof window < "u" && window, t = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, r = typeof $914aec8743edd630$var$Ne < "u" && $914aec8743edd630$var$Ne, i = e || r || t;
    return $914aec8743edd630$var$ya.root = i, function() {
        if (!i) throw new Error("RxJS could not find any global context (window, self, global)");
    }(), $914aec8743edd630$var$ya;
}
var $914aec8743edd630$var$wa = {}, $914aec8743edd630$var$dr = {}, $914aec8743edd630$var$_a = {}, $914aec8743edd630$var$_f;
function $914aec8743edd630$var$pg() {
    if ($914aec8743edd630$var$_f) return $914aec8743edd630$var$_a;
    $914aec8743edd630$var$_f = 1;
    function e(t) {
        return typeof t == "function";
    }
    return $914aec8743edd630$var$_a.isFunction = e, $914aec8743edd630$var$_a;
}
var $914aec8743edd630$var$ka = {}, $914aec8743edd630$var$xa = {}, $914aec8743edd630$var$kf;
function $914aec8743edd630$var$ri() {
    return $914aec8743edd630$var$kf || ($914aec8743edd630$var$kf = 1, $914aec8743edd630$var$xa.isArray = Array.isArray || function(e) {
        return e && typeof e.length == "number";
    }), $914aec8743edd630$var$xa;
}
var $914aec8743edd630$var$Sa = {}, $914aec8743edd630$var$xf;
function $914aec8743edd630$var$mg() {
    if ($914aec8743edd630$var$xf) return $914aec8743edd630$var$Sa;
    $914aec8743edd630$var$xf = 1;
    function e(t) {
        return t != null && typeof t == "object";
    }
    return $914aec8743edd630$var$Sa.isObject = e, $914aec8743edd630$var$Sa;
}
var $914aec8743edd630$var$Ea = {}, $914aec8743edd630$var$Aa = {}, $914aec8743edd630$var$Sf;
function $914aec8743edd630$var$ni() {
    return $914aec8743edd630$var$Sf || ($914aec8743edd630$var$Sf = 1, $914aec8743edd630$var$Aa.errorObject = {
        e: {}
    }), $914aec8743edd630$var$Aa;
}
var $914aec8743edd630$var$Ef;
function $914aec8743edd630$var$lc() {
    if ($914aec8743edd630$var$Ef) return $914aec8743edd630$var$Ea;
    $914aec8743edd630$var$Ef = 1;
    var e = $914aec8743edd630$var$ni(), t;
    function r() {
        try {
            return t.apply(this, arguments);
        } catch (n) {
            return e.errorObject.e = n, e.errorObject;
        }
    }
    function i(n) {
        return t = n, r;
    }
    return $914aec8743edd630$var$Ea.tryCatch = i, $914aec8743edd630$var$Ea;
}
var $914aec8743edd630$var$fr = {}, $914aec8743edd630$var$Af;
function $914aec8743edd630$var$p1() {
    if ($914aec8743edd630$var$Af) return $914aec8743edd630$var$fr;
    $914aec8743edd630$var$Af = 1;
    var e = $914aec8743edd630$var$fr && $914aec8743edd630$var$fr.__extends || function(r, i) {
        for(var n in i)i.hasOwnProperty(n) && (r[n] = i[n]);
        function o() {
            this.constructor = r;
        }
        r.prototype = i === null ? Object.create(i) : (o.prototype = i.prototype, new o());
    }, t = function(r) {
        e(i, r);
        function i(n) {
            r.call(this), this.errors = n;
            var o = Error.call(this, n ? n.length + ` errors occurred during unsubscription:
  ` + n.map(function(s, a) {
                return a + 1 + ") " + s.toString();
            }).join(`
  `) : "");
            this.name = o.name = "UnsubscriptionError", this.stack = o.stack, this.message = o.message;
        }
        return i;
    }(Error);
    return $914aec8743edd630$var$fr.UnsubscriptionError = t, $914aec8743edd630$var$fr;
}
var $914aec8743edd630$var$Tf;
function $914aec8743edd630$var$dn() {
    if ($914aec8743edd630$var$Tf) return $914aec8743edd630$var$ka;
    $914aec8743edd630$var$Tf = 1;
    var e = $914aec8743edd630$var$ri(), t = $914aec8743edd630$var$mg(), r = $914aec8743edd630$var$pg(), i = $914aec8743edd630$var$lc(), n = $914aec8743edd630$var$ni(), o = $914aec8743edd630$var$p1(), s = function() {
        function u(l) {
            this.closed = !1, this._parent = null, this._parents = null, this._subscriptions = null, l && (this._unsubscribe = l);
        }
        return u.prototype.unsubscribe = function() {
            var l = !1, c;
            if (!this.closed) {
                var d = this, h = d._parent, f = d._parents, p = d._unsubscribe, m = d._subscriptions;
                this.closed = !0, this._parent = null, this._parents = null, this._subscriptions = null;
                for(var w = -1, v = f ? f.length : 0; h;)h.remove(this), h = ++w < v && f[w] || null;
                if (r.isFunction(p)) {
                    var g = i.tryCatch(p).call(this);
                    g === n.errorObject && (l = !0, c = c || (n.errorObject.e instanceof o.UnsubscriptionError ? a(n.errorObject.e.errors) : [
                        n.errorObject.e
                    ]));
                }
                if (e.isArray(m)) for(w = -1, v = m.length; ++w < v;){
                    var A = m[w];
                    if (t.isObject(A)) {
                        var g = i.tryCatch(A.unsubscribe).call(A);
                        if (g === n.errorObject) {
                            l = !0, c = c || [];
                            var b = n.errorObject.e;
                            b instanceof o.UnsubscriptionError ? c = c.concat(a(b.errors)) : c.push(b);
                        }
                    }
                }
                if (l) throw new o.UnsubscriptionError(c);
            }
        }, u.prototype.add = function(l) {
            if (!l || l === u.EMPTY) return u.EMPTY;
            if (l === this) return this;
            var c = l;
            switch(typeof l){
                case "function":
                    c = new u(l);
                case "object":
                    if (c.closed || typeof c.unsubscribe != "function") return c;
                    if (this.closed) return c.unsubscribe(), c;
                    if (typeof c._addParent != "function") {
                        var d = c;
                        c = new u(), c._subscriptions = [
                            d
                        ];
                    }
                    break;
                default:
                    throw new Error("unrecognized teardown " + l + " added to Subscription.");
            }
            var h = this._subscriptions || (this._subscriptions = []);
            return h.push(c), c._addParent(this), c;
        }, u.prototype.remove = function(l) {
            var c = this._subscriptions;
            if (c) {
                var d = c.indexOf(l);
                d !== -1 && c.splice(d, 1);
            }
        }, u.prototype._addParent = function(l) {
            var c = this, d = c._parent, h = c._parents;
            !d || d === l ? this._parent = l : h ? h.indexOf(l) === -1 && h.push(l) : this._parents = [
                l
            ];
        }, u.EMPTY = function(l) {
            return l.closed = !0, l;
        }(new u()), u;
    }();
    $914aec8743edd630$var$ka.Subscription = s;
    function a(u) {
        return u.reduce(function(l, c) {
            return l.concat(c instanceof o.UnsubscriptionError ? c.errors : c);
        }, []);
    }
    return $914aec8743edd630$var$ka;
}
var $914aec8743edd630$var$Ta = {}, $914aec8743edd630$var$Cf;
function $914aec8743edd630$var$gg() {
    return $914aec8743edd630$var$Cf || ($914aec8743edd630$var$Cf = 1, $914aec8743edd630$var$Ta.empty = {
        closed: !0,
        next: function(e) {},
        error: function(e) {
            throw e;
        },
        complete: function() {}
    }), $914aec8743edd630$var$Ta;
}
var $914aec8743edd630$var$Ca = {}, $914aec8743edd630$var$Rf;
function $914aec8743edd630$var$dc() {
    return $914aec8743edd630$var$Rf || ($914aec8743edd630$var$Rf = 1, function(e) {
        var t = $914aec8743edd630$var$yt(), r = t.root.Symbol;
        e.rxSubscriber = typeof r == "function" && typeof r.for == "function" ? r.for("rxSubscriber") : "@@rxSubscriber", e.$$rxSubscriber = e.rxSubscriber;
    }($914aec8743edd630$var$Ca)), $914aec8743edd630$var$Ca;
}
var $914aec8743edd630$var$Of;
function $914aec8743edd630$var$Ge() {
    if ($914aec8743edd630$var$Of) return $914aec8743edd630$var$dr;
    $914aec8743edd630$var$Of = 1;
    var e = $914aec8743edd630$var$dr && $914aec8743edd630$var$dr.__extends || function(u, l) {
        for(var c in l)l.hasOwnProperty(c) && (u[c] = l[c]);
        function d() {
            this.constructor = u;
        }
        u.prototype = l === null ? Object.create(l) : (d.prototype = l.prototype, new d());
    }, t = $914aec8743edd630$var$pg(), r = $914aec8743edd630$var$dn(), i = $914aec8743edd630$var$gg(), n = $914aec8743edd630$var$dc(), o = function(u) {
        e(l, u);
        function l(c, d, h) {
            switch(u.call(this), this.syncErrorValue = null, this.syncErrorThrown = !1, this.syncErrorThrowable = !1, this.isStopped = !1, arguments.length){
                case 0:
                    this.destination = i.empty;
                    break;
                case 1:
                    if (!c) {
                        this.destination = i.empty;
                        break;
                    }
                    if (typeof c == "object") {
                        if (a(c)) {
                            var f = c[n.rxSubscriber]();
                            this.syncErrorThrowable = f.syncErrorThrowable, this.destination = f, f.add(this);
                        } else this.syncErrorThrowable = !0, this.destination = new s(this, c);
                        break;
                    }
                default:
                    this.syncErrorThrowable = !0, this.destination = new s(this, c, d, h);
                    break;
            }
        }
        return l.prototype[n.rxSubscriber] = function() {
            return this;
        }, l.create = function(c, d, h) {
            var f = new l(c, d, h);
            return f.syncErrorThrowable = !1, f;
        }, l.prototype.next = function(c) {
            this.isStopped || this._next(c);
        }, l.prototype.error = function(c) {
            this.isStopped || (this.isStopped = !0, this._error(c));
        }, l.prototype.complete = function() {
            this.isStopped || (this.isStopped = !0, this._complete());
        }, l.prototype.unsubscribe = function() {
            this.closed || (this.isStopped = !0, u.prototype.unsubscribe.call(this));
        }, l.prototype._next = function(c) {
            this.destination.next(c);
        }, l.prototype._error = function(c) {
            this.destination.error(c), this.unsubscribe();
        }, l.prototype._complete = function() {
            this.destination.complete(), this.unsubscribe();
        }, l.prototype._unsubscribeAndRecycle = function() {
            var c = this, d = c._parent, h = c._parents;
            return this._parent = null, this._parents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parent = d, this._parents = h, this;
        }, l;
    }(r.Subscription);
    $914aec8743edd630$var$dr.Subscriber = o;
    var s = function(u) {
        e(l, u);
        function l(c, d, h, f) {
            u.call(this), this._parentSubscriber = c;
            var p, m = this;
            t.isFunction(d) ? p = d : d && (p = d.next, h = d.error, f = d.complete, d !== i.empty && (m = Object.create(d), t.isFunction(m.unsubscribe) && this.add(m.unsubscribe.bind(m)), m.unsubscribe = this.unsubscribe.bind(this))), this._context = m, this._next = p, this._error = h, this._complete = f;
        }
        return l.prototype.next = function(c) {
            if (!this.isStopped && this._next) {
                var d = this._parentSubscriber;
                d.syncErrorThrowable ? this.__tryOrSetError(d, this._next, c) && this.unsubscribe() : this.__tryOrUnsub(this._next, c);
            }
        }, l.prototype.error = function(c) {
            if (!this.isStopped) {
                var d = this._parentSubscriber;
                if (this._error) d.syncErrorThrowable ? (this.__tryOrSetError(d, this._error, c), this.unsubscribe()) : (this.__tryOrUnsub(this._error, c), this.unsubscribe());
                else if (d.syncErrorThrowable) d.syncErrorValue = c, d.syncErrorThrown = !0, this.unsubscribe();
                else throw this.unsubscribe(), c;
            }
        }, l.prototype.complete = function() {
            var c = this;
            if (!this.isStopped) {
                var d = this._parentSubscriber;
                if (this._complete) {
                    var h = function() {
                        return c._complete.call(c._context);
                    };
                    d.syncErrorThrowable ? (this.__tryOrSetError(d, h), this.unsubscribe()) : (this.__tryOrUnsub(h), this.unsubscribe());
                } else this.unsubscribe();
            }
        }, l.prototype.__tryOrUnsub = function(c, d) {
            try {
                c.call(this._context, d);
            } catch (h) {
                throw this.unsubscribe(), h;
            }
        }, l.prototype.__tryOrSetError = function(c, d, h) {
            try {
                d.call(this._context, h);
            } catch (f) {
                return c.syncErrorValue = f, c.syncErrorThrown = !0, !0;
            }
            return !1;
        }, l.prototype._unsubscribe = function() {
            var c = this._parentSubscriber;
            this._context = null, this._parentSubscriber = null, c.unsubscribe();
        }, l;
    }(o);
    function a(u) {
        return u instanceof o || "syncErrorThrowable" in u && u[n.rxSubscriber];
    }
    return $914aec8743edd630$var$dr;
}
var $914aec8743edd630$var$Df;
function $914aec8743edd630$var$m1() {
    if ($914aec8743edd630$var$Df) return $914aec8743edd630$var$wa;
    $914aec8743edd630$var$Df = 1;
    var e = $914aec8743edd630$var$Ge(), t = $914aec8743edd630$var$dc(), r = $914aec8743edd630$var$gg();
    function i(n, o, s) {
        if (n) {
            if (n instanceof e.Subscriber) return n;
            if (n[t.rxSubscriber]) return n[t.rxSubscriber]();
        }
        return !n && !o && !s ? new e.Subscriber(r.empty) : new e.Subscriber(n, o, s);
    }
    return $914aec8743edd630$var$wa.toSubscriber = i, $914aec8743edd630$var$wa;
}
var $914aec8743edd630$var$Ra = {}, $914aec8743edd630$var$Pf;
function $914aec8743edd630$var$fc() {
    return $914aec8743edd630$var$Pf || ($914aec8743edd630$var$Pf = 1, function(e) {
        var t = $914aec8743edd630$var$yt();
        function r(i) {
            var n, o = i.Symbol;
            return typeof o == "function" ? o.observable ? n = o.observable : (n = o("observable"), o.observable = n) : n = "@@observable", n;
        }
        e.getSymbolObservable = r, e.observable = r(t.root), e.$$observable = e.observable;
    }($914aec8743edd630$var$Ra)), $914aec8743edd630$var$Ra;
}
var $914aec8743edd630$var$kn = {}, $914aec8743edd630$var$Oa = {}, $914aec8743edd630$var$If;
function $914aec8743edd630$var$g1() {
    if ($914aec8743edd630$var$If) return $914aec8743edd630$var$Oa;
    $914aec8743edd630$var$If = 1;
    function e() {}
    return $914aec8743edd630$var$Oa.noop = e, $914aec8743edd630$var$Oa;
}
var $914aec8743edd630$var$Mf;
function $914aec8743edd630$var$b1() {
    if ($914aec8743edd630$var$Mf) return $914aec8743edd630$var$kn;
    $914aec8743edd630$var$Mf = 1;
    var e = $914aec8743edd630$var$g1();
    function t() {
        for(var i = [], n = 0; n < arguments.length; n++)i[n - 0] = arguments[n];
        return r(i);
    }
    $914aec8743edd630$var$kn.pipe = t;
    function r(i) {
        return i ? i.length === 1 ? i[0] : function(o) {
            return i.reduce(function(s, a) {
                return a(s);
            }, o);
        } : e.noop;
    }
    return $914aec8743edd630$var$kn.pipeFromArray = r, $914aec8743edd630$var$kn;
}
var $914aec8743edd630$var$jf;
function $914aec8743edd630$var$Te() {
    if ($914aec8743edd630$var$jf) return $914aec8743edd630$var$va;
    $914aec8743edd630$var$jf = 1;
    var e = $914aec8743edd630$var$yt(), t = $914aec8743edd630$var$m1(), r = $914aec8743edd630$var$fc(), i = $914aec8743edd630$var$b1(), n = function() {
        function o(s) {
            this._isScalar = !1, s && (this._subscribe = s);
        }
        return o.prototype.lift = function(s) {
            var a = new o();
            return a.source = this, a.operator = s, a;
        }, o.prototype.subscribe = function(s, a, u) {
            var l = this.operator, c = t.toSubscriber(s, a, u);
            if (l ? l.call(c, this.source) : c.add(this.source || !c.syncErrorThrowable ? this._subscribe(c) : this._trySubscribe(c)), c.syncErrorThrowable && (c.syncErrorThrowable = !1, c.syncErrorThrown)) throw c.syncErrorValue;
            return c;
        }, o.prototype._trySubscribe = function(s) {
            try {
                return this._subscribe(s);
            } catch (a) {
                s.syncErrorThrown = !0, s.syncErrorValue = a, s.error(a);
            }
        }, o.prototype.forEach = function(s, a) {
            var u = this;
            if (a || (e.root.Rx && e.root.Rx.config && e.root.Rx.config.Promise ? a = e.root.Rx.config.Promise : e.root.Promise && (a = e.root.Promise)), !a) throw new Error("no Promise impl found");
            return new a(function(l, c) {
                var d;
                d = u.subscribe(function(h) {
                    if (d) try {
                        s(h);
                    } catch (f) {
                        c(f), d.unsubscribe();
                    }
                    else s(h);
                }, c, l);
            });
        }, o.prototype._subscribe = function(s) {
            return this.source.subscribe(s);
        }, o.prototype[r.observable] = function() {
            return this;
        }, o.prototype.pipe = function() {
            for(var s = [], a = 0; a < arguments.length; a++)s[a - 0] = arguments[a];
            return s.length === 0 ? this : i.pipeFromArray(s)(this);
        }, o.prototype.toPromise = function(s) {
            var a = this;
            if (s || (e.root.Rx && e.root.Rx.config && e.root.Rx.config.Promise ? s = e.root.Rx.config.Promise : e.root.Promise && (s = e.root.Promise)), !s) throw new Error("no Promise impl found");
            return new s(function(u, l) {
                var c;
                a.subscribe(function(d) {
                    return c = d;
                }, function(d) {
                    return l(d);
                }, function() {
                    return u(c);
                });
            });
        }, o.create = function(s) {
            return new o(s);
        }, o;
    }();
    return $914aec8743edd630$var$va.Observable = n, $914aec8743edd630$var$va;
}
var $914aec8743edd630$var$hr = {}, $914aec8743edd630$var$Ff;
function $914aec8743edd630$var$bg() {
    if ($914aec8743edd630$var$Ff) return $914aec8743edd630$var$hr;
    $914aec8743edd630$var$Ff = 1;
    var e = $914aec8743edd630$var$hr && $914aec8743edd630$var$hr.__extends || function(r, i) {
        for(var n in i)i.hasOwnProperty(n) && (r[n] = i[n]);
        function o() {
            this.constructor = r;
        }
        r.prototype = i === null ? Object.create(i) : (o.prototype = i.prototype, new o());
    }, t = function(r) {
        e(i, r);
        function i() {
            var n = r.call(this, "object unsubscribed");
            this.name = n.name = "ObjectUnsubscribedError", this.stack = n.stack, this.message = n.message;
        }
        return i;
    }(Error);
    return $914aec8743edd630$var$hr.ObjectUnsubscribedError = t, $914aec8743edd630$var$hr;
}
var $914aec8743edd630$var$pr = {}, $914aec8743edd630$var$$f;
function $914aec8743edd630$var$v1() {
    if ($914aec8743edd630$var$$f) return $914aec8743edd630$var$pr;
    $914aec8743edd630$var$$f = 1;
    var e = $914aec8743edd630$var$pr && $914aec8743edd630$var$pr.__extends || function(i, n) {
        for(var o in n)n.hasOwnProperty(o) && (i[o] = n[o]);
        function s() {
            this.constructor = i;
        }
        i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
    }, t = $914aec8743edd630$var$dn(), r = function(i) {
        e(n, i);
        function n(o, s) {
            i.call(this), this.subject = o, this.subscriber = s, this.closed = !1;
        }
        return n.prototype.unsubscribe = function() {
            if (!this.closed) {
                this.closed = !0;
                var o = this.subject, s = o.observers;
                if (this.subject = null, !(!s || s.length === 0 || o.isStopped || o.closed)) {
                    var a = s.indexOf(this.subscriber);
                    a !== -1 && s.splice(a, 1);
                }
            }
        }, n;
    }(t.Subscription);
    return $914aec8743edd630$var$pr.SubjectSubscription = r, $914aec8743edd630$var$pr;
}
var $914aec8743edd630$var$Lf;
function $914aec8743edd630$var$ii() {
    if ($914aec8743edd630$var$Lf) return $914aec8743edd630$var$Ot;
    $914aec8743edd630$var$Lf = 1;
    var e = $914aec8743edd630$var$Ot && $914aec8743edd630$var$Ot.__extends || function(c, d) {
        for(var h in d)d.hasOwnProperty(h) && (c[h] = d[h]);
        function f() {
            this.constructor = c;
        }
        c.prototype = d === null ? Object.create(d) : (f.prototype = d.prototype, new f());
    }, t = $914aec8743edd630$var$Te(), r = $914aec8743edd630$var$Ge(), i = $914aec8743edd630$var$dn(), n = $914aec8743edd630$var$bg(), o = $914aec8743edd630$var$v1(), s = $914aec8743edd630$var$dc(), a = function(c) {
        e(d, c);
        function d(h) {
            c.call(this, h), this.destination = h;
        }
        return d;
    }(r.Subscriber);
    $914aec8743edd630$var$Ot.SubjectSubscriber = a;
    var u = function(c) {
        e(d, c);
        function d() {
            c.call(this), this.observers = [], this.closed = !1, this.isStopped = !1, this.hasError = !1, this.thrownError = null;
        }
        return d.prototype[s.rxSubscriber] = function() {
            return new a(this);
        }, d.prototype.lift = function(h) {
            var f = new l(this, this);
            return f.operator = h, f;
        }, d.prototype.next = function(h) {
            if (this.closed) throw new n.ObjectUnsubscribedError();
            if (!this.isStopped) for(var f = this.observers, p = f.length, m = f.slice(), w = 0; w < p; w++)m[w].next(h);
        }, d.prototype.error = function(h) {
            if (this.closed) throw new n.ObjectUnsubscribedError();
            this.hasError = !0, this.thrownError = h, this.isStopped = !0;
            for(var f = this.observers, p = f.length, m = f.slice(), w = 0; w < p; w++)m[w].error(h);
            this.observers.length = 0;
        }, d.prototype.complete = function() {
            if (this.closed) throw new n.ObjectUnsubscribedError();
            this.isStopped = !0;
            for(var h = this.observers, f = h.length, p = h.slice(), m = 0; m < f; m++)p[m].complete();
            this.observers.length = 0;
        }, d.prototype.unsubscribe = function() {
            this.isStopped = !0, this.closed = !0, this.observers = null;
        }, d.prototype._trySubscribe = function(h) {
            if (this.closed) throw new n.ObjectUnsubscribedError();
            return c.prototype._trySubscribe.call(this, h);
        }, d.prototype._subscribe = function(h) {
            if (this.closed) throw new n.ObjectUnsubscribedError();
            return this.hasError ? (h.error(this.thrownError), i.Subscription.EMPTY) : this.isStopped ? (h.complete(), i.Subscription.EMPTY) : (this.observers.push(h), new o.SubjectSubscription(this, h));
        }, d.prototype.asObservable = function() {
            var h = new t.Observable();
            return h.source = this, h;
        }, d.create = function(h, f) {
            return new l(h, f);
        }, d;
    }(t.Observable);
    $914aec8743edd630$var$Ot.Subject = u;
    var l = function(c) {
        e(d, c);
        function d(h, f) {
            c.call(this), this.destination = h, this.source = f;
        }
        return d.prototype.next = function(h) {
            var f = this.destination;
            f && f.next && f.next(h);
        }, d.prototype.error = function(h) {
            var f = this.destination;
            f && f.error && this.destination.error(h);
        }, d.prototype.complete = function() {
            var h = this.destination;
            h && h.complete && this.destination.complete();
        }, d.prototype._subscribe = function(h) {
            var f = this.source;
            return f ? this.source.subscribe(h) : i.Subscription.EMPTY;
        }, d;
    }(u);
    return $914aec8743edd630$var$Ot.AnonymousSubject = l, $914aec8743edd630$var$Ot;
}
var $914aec8743edd630$var$Nf;
function $914aec8743edd630$var$vg() {
    if ($914aec8743edd630$var$Nf) return $914aec8743edd630$var$lr;
    $914aec8743edd630$var$Nf = 1;
    var e = $914aec8743edd630$var$lr && $914aec8743edd630$var$lr.__extends || function(n, o) {
        for(var s in o)o.hasOwnProperty(s) && (n[s] = o[s]);
        function a() {
            this.constructor = n;
        }
        n.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    }, t = $914aec8743edd630$var$ii(), r = $914aec8743edd630$var$bg(), i = function(n) {
        e(o, n);
        function o(s) {
            n.call(this), this._value = s;
        }
        return Object.defineProperty(o.prototype, "value", {
            get: function() {
                return this.getValue();
            },
            enumerable: !0,
            configurable: !0
        }), o.prototype._subscribe = function(s) {
            var a = n.prototype._subscribe.call(this, s);
            return a && !a.closed && s.next(this._value), a;
        }, o.prototype.getValue = function() {
            if (this.hasError) throw this.thrownError;
            if (this.closed) throw new r.ObjectUnsubscribedError();
            return this._value;
        }, o.prototype.next = function(s) {
            n.prototype.next.call(this, this._value = s);
        }, o;
    }(t.Subject);
    return $914aec8743edd630$var$lr.BehaviorSubject = i, $914aec8743edd630$var$lr;
}
var $914aec8743edd630$var$Da = {}, $914aec8743edd630$var$mr = {}, $914aec8743edd630$var$gr = {}, $914aec8743edd630$var$Bf;
function $914aec8743edd630$var$y1() {
    if ($914aec8743edd630$var$Bf) return $914aec8743edd630$var$gr;
    $914aec8743edd630$var$Bf = 1;
    var e = $914aec8743edd630$var$gr && $914aec8743edd630$var$gr.__extends || function(i, n) {
        for(var o in n)n.hasOwnProperty(o) && (i[o] = n[o]);
        function s() {
            this.constructor = i;
        }
        i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
    }, t = $914aec8743edd630$var$dn(), r = function(i) {
        e(n, i);
        function n(o, s) {
            i.call(this);
        }
        return n.prototype.schedule = function(o, s) {
            return this;
        }, n;
    }(t.Subscription);
    return $914aec8743edd630$var$gr.Action = r, $914aec8743edd630$var$gr;
}
var $914aec8743edd630$var$qf;
function $914aec8743edd630$var$w1() {
    if ($914aec8743edd630$var$qf) return $914aec8743edd630$var$mr;
    $914aec8743edd630$var$qf = 1;
    var e = $914aec8743edd630$var$mr && $914aec8743edd630$var$mr.__extends || function(n, o) {
        for(var s in o)o.hasOwnProperty(s) && (n[s] = o[s]);
        function a() {
            this.constructor = n;
        }
        n.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    }, t = $914aec8743edd630$var$yt(), r = $914aec8743edd630$var$y1(), i = function(n) {
        e(o, n);
        function o(s, a) {
            n.call(this, s, a), this.scheduler = s, this.pending = !1, this.work = a;
        }
        return o.prototype.schedule = function(s, a) {
            if (a === void 0 && (a = 0), this.closed) return this;
            this.state = s, this.pending = !0;
            var u = this.id, l = this.scheduler;
            return u != null && (this.id = this.recycleAsyncId(l, u, a)), this.delay = a, this.id = this.id || this.requestAsyncId(l, this.id, a), this;
        }, o.prototype.requestAsyncId = function(s, a, u) {
            return u === void 0 && (u = 0), t.root.setInterval(s.flush.bind(s, this), u);
        }, o.prototype.recycleAsyncId = function(s, a, u) {
            return u === void 0 && (u = 0), u !== null && this.delay === u && this.pending === !1 ? a : (t.root.clearInterval(a), void 0);
        }, o.prototype.execute = function(s, a) {
            if (this.closed) return new Error("executing a cancelled action");
            this.pending = !1;
            var u = this._execute(s, a);
            if (u) return u;
            this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
        }, o.prototype._execute = function(s, a) {
            var u = !1, l = void 0;
            try {
                this.work(s);
            } catch (c) {
                u = !0, l = !!c && c || new Error(c);
            }
            if (u) return this.unsubscribe(), l;
        }, o.prototype._unsubscribe = function() {
            var s = this.id, a = this.scheduler, u = a.actions, l = u.indexOf(this);
            this.work = null, this.state = null, this.pending = !1, this.scheduler = null, l !== -1 && u.splice(l, 1), s != null && (this.id = this.recycleAsyncId(a, s, null)), this.delay = null;
        }, o;
    }(r.Action);
    return $914aec8743edd630$var$mr.AsyncAction = i, $914aec8743edd630$var$mr;
}
var $914aec8743edd630$var$br = {}, $914aec8743edd630$var$Pa = {}, $914aec8743edd630$var$zf;
function $914aec8743edd630$var$_1() {
    if ($914aec8743edd630$var$zf) return $914aec8743edd630$var$Pa;
    $914aec8743edd630$var$zf = 1;
    var e = function() {
        function t(r, i) {
            i === void 0 && (i = t.now), this.SchedulerAction = r, this.now = i;
        }
        return t.prototype.schedule = function(r, i, n) {
            return i === void 0 && (i = 0), new this.SchedulerAction(this, r).schedule(n, i);
        }, t.now = Date.now ? Date.now : function() {
            return +/* @__PURE__ */ new Date();
        }, t;
    }();
    return $914aec8743edd630$var$Pa.Scheduler = e, $914aec8743edd630$var$Pa;
}
var $914aec8743edd630$var$Uf;
function $914aec8743edd630$var$k1() {
    if ($914aec8743edd630$var$Uf) return $914aec8743edd630$var$br;
    $914aec8743edd630$var$Uf = 1;
    var e = $914aec8743edd630$var$br && $914aec8743edd630$var$br.__extends || function(i, n) {
        for(var o in n)n.hasOwnProperty(o) && (i[o] = n[o]);
        function s() {
            this.constructor = i;
        }
        i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
    }, t = $914aec8743edd630$var$_1(), r = function(i) {
        e(n, i);
        function n() {
            i.apply(this, arguments), this.actions = [], this.active = !1, this.scheduled = void 0;
        }
        return n.prototype.flush = function(o) {
            var s = this.actions;
            if (this.active) {
                s.push(o);
                return;
            }
            var a;
            this.active = !0;
            do if (a = o.execute(o.state, o.delay)) break;
            while (o = s.shift());
            if (this.active = !1, a) {
                for(; o = s.shift();)o.unsubscribe();
                throw a;
            }
        }, n;
    }(t.Scheduler);
    return $914aec8743edd630$var$br.AsyncScheduler = r, $914aec8743edd630$var$br;
}
var $914aec8743edd630$var$Vf;
function $914aec8743edd630$var$oi() {
    if ($914aec8743edd630$var$Vf) return $914aec8743edd630$var$Da;
    $914aec8743edd630$var$Vf = 1;
    var e = $914aec8743edd630$var$w1(), t = $914aec8743edd630$var$k1();
    return $914aec8743edd630$var$Da.async = new t.AsyncScheduler(e.AsyncAction), $914aec8743edd630$var$Da;
}
function $914aec8743edd630$var$Cu(e) {
    this.message = e;
}
$914aec8743edd630$var$Cu.prototype = new Error(), $914aec8743edd630$var$Cu.prototype.name = "InvalidCharacterError";
var $914aec8743edd630$var$Gf = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
    var t = String(e).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $914aec8743edd630$var$Cu("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var r, i, n = 0, o = 0, s = ""; i = t.charAt(o++); ~i && (r = n % 4 ? 64 * r + i : i, n++ % 4) && (s += String.fromCharCode(255 & r >> (-2 * n & 6))))i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(i);
    return s;
};
function $914aec8743edd630$var$x1(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(r) {
            return decodeURIComponent($914aec8743edd630$var$Gf(r).replace(/(.)/g, function(i, n) {
                var o = n.charCodeAt(0).toString(16).toUpperCase();
                return o.length < 2 && (o = "0" + o), "%" + o;
            }));
        }(t);
    } catch  {
        return $914aec8743edd630$var$Gf(t);
    }
}
function $914aec8743edd630$var$Jr(e) {
    this.message = e;
}
function $914aec8743edd630$var$S1(e, t) {
    if (typeof e != "string") throw new $914aec8743edd630$var$Jr("Invalid token specified");
    var r = (t = t || {}).header === !0 ? 0 : 1;
    try {
        return JSON.parse($914aec8743edd630$var$x1(e.split(".")[r]));
    } catch (i) {
        throw new $914aec8743edd630$var$Jr("Invalid token specified: " + i.message);
    }
}
$914aec8743edd630$var$Jr.prototype = new Error(), $914aec8743edd630$var$Jr.prototype.name = "InvalidTokenError";
const $914aec8743edd630$var$E1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    InvalidTokenError: $914aec8743edd630$var$Jr,
    default: $914aec8743edd630$var$S1
}, Symbol.toStringTag, {
    value: "Module"
})), $914aec8743edd630$var$A1 = /* @__PURE__ */ $914aec8743edd630$var$ky($914aec8743edd630$var$E1);
var $914aec8743edd630$var$Wf = {}, $914aec8743edd630$var$Ia = {}, $914aec8743edd630$var$vr = {}, $914aec8743edd630$var$yr = {}, $914aec8743edd630$var$Hf;
function $914aec8743edd630$var$ai() {
    if ($914aec8743edd630$var$Hf) return $914aec8743edd630$var$yr;
    $914aec8743edd630$var$Hf = 1;
    var e = $914aec8743edd630$var$yr && $914aec8743edd630$var$yr.__extends || function(i, n) {
        for(var o in n)n.hasOwnProperty(o) && (i[o] = n[o]);
        function s() {
            this.constructor = i;
        }
        i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
    }, t = $914aec8743edd630$var$Ge(), r = function(i) {
        e(n, i);
        function n() {
            i.apply(this, arguments);
        }
        return n.prototype.notifyNext = function(o, s, a, u, l) {
            this.destination.next(s);
        }, n.prototype.notifyError = function(o, s) {
            this.destination.error(o);
        }, n.prototype.notifyComplete = function(o) {
            this.destination.complete();
        }, n;
    }(t.Subscriber);
    return $914aec8743edd630$var$yr.OuterSubscriber = r, $914aec8743edd630$var$yr;
}
var $914aec8743edd630$var$Ma = {}, $914aec8743edd630$var$ja = {}, $914aec8743edd630$var$Kf;
function $914aec8743edd630$var$yg() {
    return $914aec8743edd630$var$Kf || ($914aec8743edd630$var$Kf = 1, $914aec8743edd630$var$ja.isArrayLike = function(e) {
        return e && typeof e.length == "number";
    }), $914aec8743edd630$var$ja;
}
var $914aec8743edd630$var$Fa = {}, $914aec8743edd630$var$Qf;
function $914aec8743edd630$var$wg() {
    if ($914aec8743edd630$var$Qf) return $914aec8743edd630$var$Fa;
    $914aec8743edd630$var$Qf = 1;
    function e(t) {
        return t && typeof t.subscribe != "function" && typeof t.then == "function";
    }
    return $914aec8743edd630$var$Fa.isPromise = e, $914aec8743edd630$var$Fa;
}
var $914aec8743edd630$var$$a = {}, $914aec8743edd630$var$Yf;
function $914aec8743edd630$var$hc() {
    return $914aec8743edd630$var$Yf || ($914aec8743edd630$var$Yf = 1, function(e) {
        var t = $914aec8743edd630$var$yt();
        function r(i) {
            var n = i.Symbol;
            if (typeof n == "function") return n.iterator || (n.iterator = n("iterator polyfill")), n.iterator;
            var o = i.Set;
            if (o && typeof new o()["@@iterator"] == "function") return "@@iterator";
            var s = i.Map;
            if (s) for(var a = Object.getOwnPropertyNames(s.prototype), u = 0; u < a.length; ++u){
                var l = a[u];
                if (l !== "entries" && l !== "size" && s.prototype[l] === s.prototype.entries) return l;
            }
            return "@@iterator";
        }
        e.symbolIteratorPonyfill = r, e.iterator = r(t.root), e.$$iterator = e.iterator;
    }($914aec8743edd630$var$$a)), $914aec8743edd630$var$$a;
}
var $914aec8743edd630$var$wr = {}, $914aec8743edd630$var$Jf;
function $914aec8743edd630$var$T1() {
    if ($914aec8743edd630$var$Jf) return $914aec8743edd630$var$wr;
    $914aec8743edd630$var$Jf = 1;
    var e = $914aec8743edd630$var$wr && $914aec8743edd630$var$wr.__extends || function(i, n) {
        for(var o in n)n.hasOwnProperty(o) && (i[o] = n[o]);
        function s() {
            this.constructor = i;
        }
        i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
    }, t = $914aec8743edd630$var$Ge(), r = function(i) {
        e(n, i);
        function n(o, s, a) {
            i.call(this), this.parent = o, this.outerValue = s, this.outerIndex = a, this.index = 0;
        }
        return n.prototype._next = function(o) {
            this.parent.notifyNext(this.outerValue, o, this.outerIndex, this.index++, this);
        }, n.prototype._error = function(o) {
            this.parent.notifyError(o, this), this.unsubscribe();
        }, n.prototype._complete = function() {
            this.parent.notifyComplete(this), this.unsubscribe();
        }, n;
    }(t.Subscriber);
    return $914aec8743edd630$var$wr.InnerSubscriber = r, $914aec8743edd630$var$wr;
}
var $914aec8743edd630$var$Zf;
function $914aec8743edd630$var$si() {
    if ($914aec8743edd630$var$Zf) return $914aec8743edd630$var$Ma;
    $914aec8743edd630$var$Zf = 1;
    var e = $914aec8743edd630$var$yt(), t = $914aec8743edd630$var$yg(), r = $914aec8743edd630$var$wg(), i = $914aec8743edd630$var$mg(), n = $914aec8743edd630$var$Te(), o = $914aec8743edd630$var$hc(), s = $914aec8743edd630$var$T1(), a = $914aec8743edd630$var$fc();
    function u(l, c, d, h) {
        var f = new s.InnerSubscriber(l, d, h);
        if (f.closed) return null;
        if (c instanceof n.Observable) return c._isScalar ? (f.next(c.value), f.complete(), null) : (f.syncErrorThrowable = !0, c.subscribe(f));
        if (t.isArrayLike(c)) {
            for(var p = 0, m = c.length; p < m && !f.closed; p++)f.next(c[p]);
            f.closed || f.complete();
        } else {
            if (r.isPromise(c)) return c.then(function(k) {
                f.closed || (f.next(k), f.complete());
            }, function(k) {
                return f.error(k);
            }).then(null, function(k) {
                e.root.setTimeout(function() {
                    throw k;
                });
            }), f;
            if (c && typeof c[o.iterator] == "function") {
                var w = c[o.iterator]();
                do {
                    var v = w.next();
                    if (v.done) {
                        f.complete();
                        break;
                    }
                    if (f.next(v.value), f.closed) break;
                }while (!0);
            } else if (c && typeof c[a.observable] == "function") {
                var g = c[a.observable]();
                if (typeof g.subscribe != "function") f.error(new TypeError("Provided object does not correctly implement Symbol.observable"));
                else return g.subscribe(new s.InnerSubscriber(l, d, h));
            } else {
                var A = i.isObject(c) ? "an invalid object" : "'" + c + "'", b = "You provided " + A + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";
                f.error(new TypeError(b));
            }
        }
        return null;
    }
    return $914aec8743edd630$var$Ma.subscribeToResult = u, $914aec8743edd630$var$Ma;
}
var $914aec8743edd630$var$Xf;
function $914aec8743edd630$var$C1() {
    if ($914aec8743edd630$var$Xf) return $914aec8743edd630$var$vr;
    $914aec8743edd630$var$Xf = 1;
    var e = $914aec8743edd630$var$vr && $914aec8743edd630$var$vr.__extends || function(s, a) {
        for(var u in a)a.hasOwnProperty(u) && (s[u] = a[u]);
        function l() {
            this.constructor = s;
        }
        s.prototype = a === null ? Object.create(a) : (l.prototype = a.prototype, new l());
    }, t = $914aec8743edd630$var$ai(), r = $914aec8743edd630$var$si();
    function i(s) {
        return function(u) {
            var l = new n(s), c = u.lift(l);
            return l.caught = c;
        };
    }
    $914aec8743edd630$var$vr.catchError = i;
    var n = function() {
        function s(a) {
            this.selector = a;
        }
        return s.prototype.call = function(a, u) {
            return u.subscribe(new o(a, this.selector, this.caught));
        }, s;
    }(), o = function(s) {
        e(a, s);
        function a(u, l, c) {
            s.call(this, u), this.selector = l, this.caught = c;
        }
        return a.prototype.error = function(u) {
            if (!this.isStopped) {
                var l = void 0;
                try {
                    l = this.selector(u, this.caught);
                } catch (c) {
                    s.prototype.error.call(this, c);
                    return;
                }
                this._unsubscribeAndRecycle(), this.add(r.subscribeToResult(this, l));
            }
        }, a;
    }(t.OuterSubscriber);
    return $914aec8743edd630$var$vr;
}
var $914aec8743edd630$var$eh;
function $914aec8743edd630$var$R1() {
    if ($914aec8743edd630$var$eh) return $914aec8743edd630$var$Ia;
    $914aec8743edd630$var$eh = 1;
    var e = $914aec8743edd630$var$C1();
    function t(r) {
        return e.catchError(r)(this);
    }
    return $914aec8743edd630$var$Ia._catch = t, $914aec8743edd630$var$Ia;
}
var $914aec8743edd630$var$th;
function $914aec8743edd630$var$O1() {
    if ($914aec8743edd630$var$th) return $914aec8743edd630$var$Wf;
    $914aec8743edd630$var$th = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$R1();
    return e.Observable.prototype.catch = t._catch, e.Observable.prototype._catch = t._catch, $914aec8743edd630$var$Wf;
}
var $914aec8743edd630$var$rh = {}, $914aec8743edd630$var$La = {}, $914aec8743edd630$var$Dt = {}, $914aec8743edd630$var$_r = {}, $914aec8743edd630$var$kr = {}, $914aec8743edd630$var$nh;
function $914aec8743edd630$var$_g() {
    if ($914aec8743edd630$var$nh) return $914aec8743edd630$var$kr;
    $914aec8743edd630$var$nh = 1;
    var e = $914aec8743edd630$var$kr && $914aec8743edd630$var$kr.__extends || function(i, n) {
        for(var o in n)n.hasOwnProperty(o) && (i[o] = n[o]);
        function s() {
            this.constructor = i;
        }
        i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
    }, t = $914aec8743edd630$var$Te(), r = function(i) {
        e(n, i);
        function n(o, s) {
            i.call(this), this.value = o, this.scheduler = s, this._isScalar = !0, s && (this._isScalar = !1);
        }
        return n.create = function(o, s) {
            return new n(o, s);
        }, n.dispatch = function(o) {
            var s = o.done, a = o.value, u = o.subscriber;
            if (s) {
                u.complete();
                return;
            }
            u.next(a), !u.closed && (o.done = !0, this.schedule(o));
        }, n.prototype._subscribe = function(o) {
            var s = this.value, a = this.scheduler;
            if (a) return a.schedule(n.dispatch, 0, {
                done: !1,
                value: s,
                subscriber: o
            });
            o.next(s), o.closed || o.complete();
        }, n;
    }(t.Observable);
    return $914aec8743edd630$var$kr.ScalarObservable = r, $914aec8743edd630$var$kr;
}
var $914aec8743edd630$var$xr = {}, $914aec8743edd630$var$ih;
function $914aec8743edd630$var$ui() {
    if ($914aec8743edd630$var$ih) return $914aec8743edd630$var$xr;
    $914aec8743edd630$var$ih = 1;
    var e = $914aec8743edd630$var$xr && $914aec8743edd630$var$xr.__extends || function(i, n) {
        for(var o in n)n.hasOwnProperty(o) && (i[o] = n[o]);
        function s() {
            this.constructor = i;
        }
        i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
    }, t = $914aec8743edd630$var$Te(), r = function(i) {
        e(n, i);
        function n(o) {
            i.call(this), this.scheduler = o;
        }
        return n.create = function(o) {
            return new n(o);
        }, n.dispatch = function(o) {
            var s = o.subscriber;
            s.complete();
        }, n.prototype._subscribe = function(o) {
            var s = this.scheduler;
            if (s) return s.schedule(n.dispatch, 0, {
                subscriber: o
            });
            o.complete();
        }, n;
    }(t.Observable);
    return $914aec8743edd630$var$xr.EmptyObservable = r, $914aec8743edd630$var$xr;
}
var $914aec8743edd630$var$Na = {}, $914aec8743edd630$var$oh;
function $914aec8743edd630$var$D1() {
    if ($914aec8743edd630$var$oh) return $914aec8743edd630$var$Na;
    $914aec8743edd630$var$oh = 1;
    function e(t) {
        return t && typeof t.schedule == "function";
    }
    return $914aec8743edd630$var$Na.isScheduler = e, $914aec8743edd630$var$Na;
}
var $914aec8743edd630$var$ah;
function $914aec8743edd630$var$pc() {
    if ($914aec8743edd630$var$ah) return $914aec8743edd630$var$_r;
    $914aec8743edd630$var$ah = 1;
    var e = $914aec8743edd630$var$_r && $914aec8743edd630$var$_r.__extends || function(s, a) {
        for(var u in a)a.hasOwnProperty(u) && (s[u] = a[u]);
        function l() {
            this.constructor = s;
        }
        s.prototype = a === null ? Object.create(a) : (l.prototype = a.prototype, new l());
    }, t = $914aec8743edd630$var$Te(), r = $914aec8743edd630$var$_g(), i = $914aec8743edd630$var$ui(), n = $914aec8743edd630$var$D1(), o = function(s) {
        e(a, s);
        function a(u, l) {
            s.call(this), this.array = u, this.scheduler = l, !l && u.length === 1 && (this._isScalar = !0, this.value = u[0]);
        }
        return a.create = function(u, l) {
            return new a(u, l);
        }, a.of = function() {
            for(var u = [], l = 0; l < arguments.length; l++)u[l - 0] = arguments[l];
            var c = u[u.length - 1];
            n.isScheduler(c) ? u.pop() : c = null;
            var d = u.length;
            return d > 1 ? new a(u, c) : d === 1 ? new r.ScalarObservable(u[0], c) : new i.EmptyObservable(c);
        }, a.dispatch = function(u) {
            var l = u.array, c = u.index, d = u.count, h = u.subscriber;
            if (c >= d) {
                h.complete();
                return;
            }
            h.next(l[c]), !h.closed && (u.index = c + 1, this.schedule(u));
        }, a.prototype._subscribe = function(u) {
            var l = 0, c = this.array, d = c.length, h = this.scheduler;
            if (h) return h.schedule(a.dispatch, 0, {
                array: c,
                index: l,
                count: d,
                subscriber: u
            });
            for(var f = 0; f < d && !u.closed; f++)u.next(c[f]);
            u.complete();
        }, a;
    }(t.Observable);
    return $914aec8743edd630$var$_r.ArrayObservable = o, $914aec8743edd630$var$_r;
}
var $914aec8743edd630$var$sh;
function $914aec8743edd630$var$P1() {
    if ($914aec8743edd630$var$sh) return $914aec8743edd630$var$Dt;
    $914aec8743edd630$var$sh = 1;
    var e = $914aec8743edd630$var$Dt && $914aec8743edd630$var$Dt.__extends || function(l, c) {
        for(var d in c)c.hasOwnProperty(d) && (l[d] = c[d]);
        function h() {
            this.constructor = l;
        }
        l.prototype = c === null ? Object.create(c) : (h.prototype = c.prototype, new h());
    }, t = $914aec8743edd630$var$pc(), r = $914aec8743edd630$var$ri(), i = $914aec8743edd630$var$ai(), n = $914aec8743edd630$var$si(), o = {};
    function s() {
        for(var l = [], c = 0; c < arguments.length; c++)l[c - 0] = arguments[c];
        var d = null;
        return typeof l[l.length - 1] == "function" && (d = l.pop()), l.length === 1 && r.isArray(l[0]) && (l = l[0].slice()), function(h) {
            return h.lift.call(new t.ArrayObservable([
                h
            ].concat(l)), new a(d));
        };
    }
    $914aec8743edd630$var$Dt.combineLatest = s;
    var a = function() {
        function l(c) {
            this.project = c;
        }
        return l.prototype.call = function(c, d) {
            return d.subscribe(new u(c, this.project));
        }, l;
    }();
    $914aec8743edd630$var$Dt.CombineLatestOperator = a;
    var u = function(l) {
        e(c, l);
        function c(d, h) {
            l.call(this, d), this.project = h, this.active = 0, this.values = [], this.observables = [];
        }
        return c.prototype._next = function(d) {
            this.values.push(o), this.observables.push(d);
        }, c.prototype._complete = function() {
            var d = this.observables, h = d.length;
            if (h === 0) this.destination.complete();
            else {
                this.active = h, this.toRespond = h;
                for(var f = 0; f < h; f++){
                    var p = d[f];
                    this.add(n.subscribeToResult(this, p, p, f));
                }
            }
        }, c.prototype.notifyComplete = function(d) {
            (this.active -= 1) === 0 && this.destination.complete();
        }, c.prototype.notifyNext = function(d, h, f, p, m) {
            var w = this.values, v = w[f], g = this.toRespond ? v === o ? --this.toRespond : this.toRespond : 0;
            w[f] = h, g === 0 && (this.project ? this._tryProject(w) : this.destination.next(w.slice()));
        }, c.prototype._tryProject = function(d) {
            var h;
            try {
                h = this.project.apply(this, d);
            } catch (f) {
                this.destination.error(f);
                return;
            }
            this.destination.next(h);
        }, c;
    }(i.OuterSubscriber);
    return $914aec8743edd630$var$Dt.CombineLatestSubscriber = u, $914aec8743edd630$var$Dt;
}
var $914aec8743edd630$var$uh;
function $914aec8743edd630$var$I1() {
    if ($914aec8743edd630$var$uh) return $914aec8743edd630$var$La;
    $914aec8743edd630$var$uh = 1;
    var e = $914aec8743edd630$var$P1();
    function t() {
        for(var r = [], i = 0; i < arguments.length; i++)r[i - 0] = arguments[i];
        return e.combineLatest.apply(void 0, r)(this);
    }
    return $914aec8743edd630$var$La.combineLatest = t, $914aec8743edd630$var$La;
}
var $914aec8743edd630$var$ch;
function $914aec8743edd630$var$M1() {
    if ($914aec8743edd630$var$ch) return $914aec8743edd630$var$rh;
    $914aec8743edd630$var$ch = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$I1();
    return e.Observable.prototype.combineLatest = t.combineLatest, $914aec8743edd630$var$rh;
}
var $914aec8743edd630$var$lh = {}, $914aec8743edd630$var$Ba = {}, $914aec8743edd630$var$Sr = {}, $914aec8743edd630$var$dh;
function $914aec8743edd630$var$j1() {
    if ($914aec8743edd630$var$dh) return $914aec8743edd630$var$Sr;
    $914aec8743edd630$var$dh = 1;
    var e = $914aec8743edd630$var$Sr && $914aec8743edd630$var$Sr.__extends || function(o, s) {
        for(var a in s)s.hasOwnProperty(a) && (o[a] = s[a]);
        function u() {
            this.constructor = o;
        }
        o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
    }, t = $914aec8743edd630$var$Ge();
    function r(o) {
        return function(s) {
            return s.lift(new i(o, s));
        };
    }
    $914aec8743edd630$var$Sr.count = r;
    var i = function() {
        function o(s, a) {
            this.predicate = s, this.source = a;
        }
        return o.prototype.call = function(s, a) {
            return a.subscribe(new n(s, this.predicate, this.source));
        }, o;
    }(), n = function(o) {
        e(s, o);
        function s(a, u, l) {
            o.call(this, a), this.predicate = u, this.source = l, this.count = 0, this.index = 0;
        }
        return s.prototype._next = function(a) {
            this.predicate ? this._tryPredicate(a) : this.count++;
        }, s.prototype._tryPredicate = function(a) {
            var u;
            try {
                u = this.predicate(a, this.index++, this.source);
            } catch (l) {
                this.destination.error(l);
                return;
            }
            u && this.count++;
        }, s.prototype._complete = function() {
            this.destination.next(this.count), this.destination.complete();
        }, s;
    }(t.Subscriber);
    return $914aec8743edd630$var$Sr;
}
var $914aec8743edd630$var$fh;
function $914aec8743edd630$var$F1() {
    if ($914aec8743edd630$var$fh) return $914aec8743edd630$var$Ba;
    $914aec8743edd630$var$fh = 1;
    var e = $914aec8743edd630$var$j1();
    function t(r) {
        return e.count(r)(this);
    }
    return $914aec8743edd630$var$Ba.count = t, $914aec8743edd630$var$Ba;
}
var $914aec8743edd630$var$hh;
function $914aec8743edd630$var$$1() {
    if ($914aec8743edd630$var$hh) return $914aec8743edd630$var$lh;
    $914aec8743edd630$var$hh = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$F1();
    return e.Observable.prototype.count = t.count, $914aec8743edd630$var$lh;
}
var $914aec8743edd630$var$ph = {}, $914aec8743edd630$var$qa = {}, $914aec8743edd630$var$Er = {}, $914aec8743edd630$var$za = {}, $914aec8743edd630$var$mh;
function $914aec8743edd630$var$L1() {
    if ($914aec8743edd630$var$mh) return $914aec8743edd630$var$za;
    $914aec8743edd630$var$mh = 1;
    function e(t) {
        return t instanceof Date && !isNaN(+t);
    }
    return $914aec8743edd630$var$za.isDate = e, $914aec8743edd630$var$za;
}
var $914aec8743edd630$var$Ua = {}, $914aec8743edd630$var$gh;
function $914aec8743edd630$var$kg() {
    if ($914aec8743edd630$var$gh) return $914aec8743edd630$var$Ua;
    $914aec8743edd630$var$gh = 1;
    var e = $914aec8743edd630$var$Te(), t = function() {
        function r(i, n, o) {
            this.kind = i, this.value = n, this.error = o, this.hasValue = i === "N";
        }
        return r.prototype.observe = function(i) {
            switch(this.kind){
                case "N":
                    return i.next && i.next(this.value);
                case "E":
                    return i.error && i.error(this.error);
                case "C":
                    return i.complete && i.complete();
            }
        }, r.prototype.do = function(i, n, o) {
            var s = this.kind;
            switch(s){
                case "N":
                    return i && i(this.value);
                case "E":
                    return n && n(this.error);
                case "C":
                    return o && o();
            }
        }, r.prototype.accept = function(i, n, o) {
            return i && typeof i.next == "function" ? this.observe(i) : this.do(i, n, o);
        }, r.prototype.toObservable = function() {
            var i = this.kind;
            switch(i){
                case "N":
                    return e.Observable.of(this.value);
                case "E":
                    return e.Observable.throw(this.error);
                case "C":
                    return e.Observable.empty();
            }
            throw new Error("unexpected notification kind value");
        }, r.createNext = function(i) {
            return typeof i < "u" ? new r("N", i) : r.undefinedValueNotification;
        }, r.createError = function(i) {
            return new r("E", void 0, i);
        }, r.createComplete = function() {
            return r.completeNotification;
        }, r.completeNotification = new r("C"), r.undefinedValueNotification = new r("N", void 0), r;
    }();
    return $914aec8743edd630$var$Ua.Notification = t, $914aec8743edd630$var$Ua;
}
var $914aec8743edd630$var$bh;
function $914aec8743edd630$var$N1() {
    if ($914aec8743edd630$var$bh) return $914aec8743edd630$var$Er;
    $914aec8743edd630$var$bh = 1;
    var e = $914aec8743edd630$var$Er && $914aec8743edd630$var$Er.__extends || function(l, c) {
        for(var d in c)c.hasOwnProperty(d) && (l[d] = c[d]);
        function h() {
            this.constructor = l;
        }
        l.prototype = c === null ? Object.create(c) : (h.prototype = c.prototype, new h());
    }, t = $914aec8743edd630$var$oi(), r = $914aec8743edd630$var$L1(), i = $914aec8743edd630$var$Ge(), n = $914aec8743edd630$var$kg();
    function o(l, c) {
        c === void 0 && (c = t.async);
        var d = r.isDate(l), h = d ? +l - c.now() : Math.abs(l);
        return function(f) {
            return f.lift(new s(h, c));
        };
    }
    $914aec8743edd630$var$Er.delay = o;
    var s = function() {
        function l(c, d) {
            this.delay = c, this.scheduler = d;
        }
        return l.prototype.call = function(c, d) {
            return d.subscribe(new a(c, this.delay, this.scheduler));
        }, l;
    }(), a = function(l) {
        e(c, l);
        function c(d, h, f) {
            l.call(this, d), this.delay = h, this.scheduler = f, this.queue = [], this.active = !1, this.errored = !1;
        }
        return c.dispatch = function(d) {
            for(var h = d.source, f = h.queue, p = d.scheduler, m = d.destination; f.length > 0 && f[0].time - p.now() <= 0;)f.shift().notification.observe(m);
            if (f.length > 0) {
                var w = Math.max(0, f[0].time - p.now());
                this.schedule(d, w);
            } else this.unsubscribe(), h.active = !1;
        }, c.prototype._schedule = function(d) {
            this.active = !0, this.add(d.schedule(c.dispatch, this.delay, {
                source: this,
                destination: this.destination,
                scheduler: d
            }));
        }, c.prototype.scheduleNotification = function(d) {
            if (this.errored !== !0) {
                var h = this.scheduler, f = new u(h.now() + this.delay, d);
                this.queue.push(f), this.active === !1 && this._schedule(h);
            }
        }, c.prototype._next = function(d) {
            this.scheduleNotification(n.Notification.createNext(d));
        }, c.prototype._error = function(d) {
            this.errored = !0, this.queue = [], this.destination.error(d);
        }, c.prototype._complete = function() {
            this.scheduleNotification(n.Notification.createComplete());
        }, c;
    }(i.Subscriber), u = /* @__PURE__ */ function() {
        function l(c, d) {
            this.time = c, this.notification = d;
        }
        return l;
    }();
    return $914aec8743edd630$var$Er;
}
var $914aec8743edd630$var$vh;
function $914aec8743edd630$var$B1() {
    if ($914aec8743edd630$var$vh) return $914aec8743edd630$var$qa;
    $914aec8743edd630$var$vh = 1;
    var e = $914aec8743edd630$var$oi(), t = $914aec8743edd630$var$N1();
    function r(i, n) {
        return n === void 0 && (n = e.async), t.delay(i, n)(this);
    }
    return $914aec8743edd630$var$qa.delay = r, $914aec8743edd630$var$qa;
}
var $914aec8743edd630$var$yh;
function $914aec8743edd630$var$q1() {
    if ($914aec8743edd630$var$yh) return $914aec8743edd630$var$ph;
    $914aec8743edd630$var$yh = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$B1();
    return e.Observable.prototype.delay = t.delay, $914aec8743edd630$var$ph;
}
var $914aec8743edd630$var$wh = {}, $914aec8743edd630$var$Va = {}, $914aec8743edd630$var$Ar = {}, $914aec8743edd630$var$_h;
function $914aec8743edd630$var$z1() {
    if ($914aec8743edd630$var$_h) return $914aec8743edd630$var$Ar;
    $914aec8743edd630$var$_h = 1;
    var e = $914aec8743edd630$var$Ar && $914aec8743edd630$var$Ar.__extends || function(o, s) {
        for(var a in s)s.hasOwnProperty(a) && (o[a] = s[a]);
        function u() {
            this.constructor = o;
        }
        o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
    }, t = $914aec8743edd630$var$Ge();
    function r(o, s, a) {
        return function(l) {
            return l.lift(new i(o, s, a));
        };
    }
    $914aec8743edd630$var$Ar.tap = r;
    var i = function() {
        function o(s, a, u) {
            this.nextOrObserver = s, this.error = a, this.complete = u;
        }
        return o.prototype.call = function(s, a) {
            return a.subscribe(new n(s, this.nextOrObserver, this.error, this.complete));
        }, o;
    }(), n = function(o) {
        e(s, o);
        function s(a, u, l, c) {
            o.call(this, a);
            var d = new t.Subscriber(u, l, c);
            d.syncErrorThrowable = !0, this.add(d), this.safeSubscriber = d;
        }
        return s.prototype._next = function(a) {
            var u = this.safeSubscriber;
            u.next(a), u.syncErrorThrown ? this.destination.error(u.syncErrorValue) : this.destination.next(a);
        }, s.prototype._error = function(a) {
            var u = this.safeSubscriber;
            u.error(a), u.syncErrorThrown ? this.destination.error(u.syncErrorValue) : this.destination.error(a);
        }, s.prototype._complete = function() {
            var a = this.safeSubscriber;
            a.complete(), a.syncErrorThrown ? this.destination.error(a.syncErrorValue) : this.destination.complete();
        }, s;
    }(t.Subscriber);
    return $914aec8743edd630$var$Ar;
}
var $914aec8743edd630$var$kh;
function $914aec8743edd630$var$U1() {
    if ($914aec8743edd630$var$kh) return $914aec8743edd630$var$Va;
    $914aec8743edd630$var$kh = 1;
    var e = $914aec8743edd630$var$z1();
    function t(r, i, n) {
        return e.tap(r, i, n)(this);
    }
    return $914aec8743edd630$var$Va._do = t, $914aec8743edd630$var$Va;
}
var $914aec8743edd630$var$xh;
function $914aec8743edd630$var$V1() {
    if ($914aec8743edd630$var$xh) return $914aec8743edd630$var$wh;
    $914aec8743edd630$var$xh = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$U1();
    return e.Observable.prototype.do = t._do, e.Observable.prototype._do = t._do, $914aec8743edd630$var$wh;
}
var $914aec8743edd630$var$Sh = {}, $914aec8743edd630$var$Ga = {}, $914aec8743edd630$var$Tr = {}, $914aec8743edd630$var$Eh;
function $914aec8743edd630$var$G1() {
    if ($914aec8743edd630$var$Eh) return $914aec8743edd630$var$Tr;
    $914aec8743edd630$var$Eh = 1;
    var e = $914aec8743edd630$var$Tr && $914aec8743edd630$var$Tr.__extends || function(o, s) {
        for(var a in s)s.hasOwnProperty(a) && (o[a] = s[a]);
        function u() {
            this.constructor = o;
        }
        o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
    }, t = $914aec8743edd630$var$Ge();
    function r(o, s) {
        return function(u) {
            return u.lift(new i(o, s));
        };
    }
    $914aec8743edd630$var$Tr.filter = r;
    var i = function() {
        function o(s, a) {
            this.predicate = s, this.thisArg = a;
        }
        return o.prototype.call = function(s, a) {
            return a.subscribe(new n(s, this.predicate, this.thisArg));
        }, o;
    }(), n = function(o) {
        e(s, o);
        function s(a, u, l) {
            o.call(this, a), this.predicate = u, this.thisArg = l, this.count = 0;
        }
        return s.prototype._next = function(a) {
            var u;
            try {
                u = this.predicate.call(this.thisArg, a, this.count++);
            } catch (l) {
                this.destination.error(l);
                return;
            }
            u && this.destination.next(a);
        }, s;
    }(t.Subscriber);
    return $914aec8743edd630$var$Tr;
}
var $914aec8743edd630$var$Ah;
function $914aec8743edd630$var$W1() {
    if ($914aec8743edd630$var$Ah) return $914aec8743edd630$var$Ga;
    $914aec8743edd630$var$Ah = 1;
    var e = $914aec8743edd630$var$G1();
    function t(r, i) {
        return e.filter(r, i)(this);
    }
    return $914aec8743edd630$var$Ga.filter = t, $914aec8743edd630$var$Ga;
}
var $914aec8743edd630$var$Th;
function $914aec8743edd630$var$H1() {
    if ($914aec8743edd630$var$Th) return $914aec8743edd630$var$Sh;
    $914aec8743edd630$var$Th = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$W1();
    return e.Observable.prototype.filter = t.filter, $914aec8743edd630$var$Sh;
}
var $914aec8743edd630$var$Ch = {}, $914aec8743edd630$var$Wa = {}, $914aec8743edd630$var$Gt = {}, $914aec8743edd630$var$Rh;
function $914aec8743edd630$var$xg() {
    if ($914aec8743edd630$var$Rh) return $914aec8743edd630$var$Gt;
    $914aec8743edd630$var$Rh = 1;
    var e = $914aec8743edd630$var$Gt && $914aec8743edd630$var$Gt.__extends || function(o, s) {
        for(var a in s)s.hasOwnProperty(a) && (o[a] = s[a]);
        function u() {
            this.constructor = o;
        }
        o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
    }, t = $914aec8743edd630$var$Ge();
    function r(o, s) {
        return function(u) {
            if (typeof o != "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
            return u.lift(new i(o, s));
        };
    }
    $914aec8743edd630$var$Gt.map = r;
    var i = function() {
        function o(s, a) {
            this.project = s, this.thisArg = a;
        }
        return o.prototype.call = function(s, a) {
            return a.subscribe(new n(s, this.project, this.thisArg));
        }, o;
    }();
    $914aec8743edd630$var$Gt.MapOperator = i;
    var n = function(o) {
        e(s, o);
        function s(a, u, l) {
            o.call(this, a), this.project = u, this.count = 0, this.thisArg = l || this;
        }
        return s.prototype._next = function(a) {
            var u;
            try {
                u = this.project.call(this.thisArg, a, this.count++);
            } catch (l) {
                this.destination.error(l);
                return;
            }
            this.destination.next(u);
        }, s;
    }(t.Subscriber);
    return $914aec8743edd630$var$Gt;
}
var $914aec8743edd630$var$Oh;
function $914aec8743edd630$var$K1() {
    if ($914aec8743edd630$var$Oh) return $914aec8743edd630$var$Wa;
    $914aec8743edd630$var$Oh = 1;
    var e = $914aec8743edd630$var$xg();
    function t(r, i) {
        return e.map(r, i)(this);
    }
    return $914aec8743edd630$var$Wa.map = t, $914aec8743edd630$var$Wa;
}
var $914aec8743edd630$var$Dh;
function $914aec8743edd630$var$Q1() {
    if ($914aec8743edd630$var$Dh) return $914aec8743edd630$var$Ch;
    $914aec8743edd630$var$Dh = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$K1();
    return e.Observable.prototype.map = t.map, $914aec8743edd630$var$Ch;
}
var $914aec8743edd630$var$Ph = {}, $914aec8743edd630$var$Ha = {}, $914aec8743edd630$var$Pt = {}, $914aec8743edd630$var$Ih;
function $914aec8743edd630$var$Sg() {
    if ($914aec8743edd630$var$Ih) return $914aec8743edd630$var$Pt;
    $914aec8743edd630$var$Ih = 1;
    var e = $914aec8743edd630$var$Pt && $914aec8743edd630$var$Pt.__extends || function(s, a) {
        for(var u in a)a.hasOwnProperty(u) && (s[u] = a[u]);
        function l() {
            this.constructor = s;
        }
        s.prototype = a === null ? Object.create(a) : (l.prototype = a.prototype, new l());
    }, t = $914aec8743edd630$var$si(), r = $914aec8743edd630$var$ai();
    function i(s, a, u) {
        return u === void 0 && (u = Number.POSITIVE_INFINITY), function(c) {
            return typeof a == "number" && (u = a, a = null), c.lift(new n(s, a, u));
        };
    }
    $914aec8743edd630$var$Pt.mergeMap = i;
    var n = function() {
        function s(a, u, l) {
            l === void 0 && (l = Number.POSITIVE_INFINITY), this.project = a, this.resultSelector = u, this.concurrent = l;
        }
        return s.prototype.call = function(a, u) {
            return u.subscribe(new o(a, this.project, this.resultSelector, this.concurrent));
        }, s;
    }();
    $914aec8743edd630$var$Pt.MergeMapOperator = n;
    var o = function(s) {
        e(a, s);
        function a(u, l, c, d) {
            d === void 0 && (d = Number.POSITIVE_INFINITY), s.call(this, u), this.project = l, this.resultSelector = c, this.concurrent = d, this.hasCompleted = !1, this.buffer = [], this.active = 0, this.index = 0;
        }
        return a.prototype._next = function(u) {
            this.active < this.concurrent ? this._tryNext(u) : this.buffer.push(u);
        }, a.prototype._tryNext = function(u) {
            var l, c = this.index++;
            try {
                l = this.project(u, c);
            } catch (d) {
                this.destination.error(d);
                return;
            }
            this.active++, this._innerSub(l, u, c);
        }, a.prototype._innerSub = function(u, l, c) {
            this.add(t.subscribeToResult(this, u, l, c));
        }, a.prototype._complete = function() {
            this.hasCompleted = !0, this.active === 0 && this.buffer.length === 0 && this.destination.complete();
        }, a.prototype.notifyNext = function(u, l, c, d, h) {
            this.resultSelector ? this._notifyResultSelector(u, l, c, d) : this.destination.next(l);
        }, a.prototype._notifyResultSelector = function(u, l, c, d) {
            var h;
            try {
                h = this.resultSelector(u, l, c, d);
            } catch (f) {
                this.destination.error(f);
                return;
            }
            this.destination.next(h);
        }, a.prototype.notifyComplete = function(u) {
            var l = this.buffer;
            this.remove(u), this.active--, l.length > 0 ? this._next(l.shift()) : this.active === 0 && this.hasCompleted && this.destination.complete();
        }, a;
    }(r.OuterSubscriber);
    return $914aec8743edd630$var$Pt.MergeMapSubscriber = o, $914aec8743edd630$var$Pt;
}
var $914aec8743edd630$var$Mh;
function $914aec8743edd630$var$Y1() {
    if ($914aec8743edd630$var$Mh) return $914aec8743edd630$var$Ha;
    $914aec8743edd630$var$Mh = 1;
    var e = $914aec8743edd630$var$Sg();
    function t(r, i, n) {
        return n === void 0 && (n = Number.POSITIVE_INFINITY), e.mergeMap(r, i, n)(this);
    }
    return $914aec8743edd630$var$Ha.mergeMap = t, $914aec8743edd630$var$Ha;
}
var $914aec8743edd630$var$jh;
function $914aec8743edd630$var$J1() {
    if ($914aec8743edd630$var$jh) return $914aec8743edd630$var$Ph;
    $914aec8743edd630$var$jh = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$Y1();
    return e.Observable.prototype.mergeMap = t.mergeMap, e.Observable.prototype.flatMap = t.mergeMap, $914aec8743edd630$var$Ph;
}
var $914aec8743edd630$var$Fh = {}, $914aec8743edd630$var$Ka = {}, $914aec8743edd630$var$Qa = {}, $914aec8743edd630$var$$h;
function $914aec8743edd630$var$Z1() {
    if ($914aec8743edd630$var$$h) return $914aec8743edd630$var$Qa;
    $914aec8743edd630$var$$h = 1;
    var e = $914aec8743edd630$var$Sg();
    function t(r, i) {
        return e.mergeMap(r, i, 1);
    }
    return $914aec8743edd630$var$Qa.concatMap = t, $914aec8743edd630$var$Qa;
}
var $914aec8743edd630$var$Lh;
function $914aec8743edd630$var$X1() {
    if ($914aec8743edd630$var$Lh) return $914aec8743edd630$var$Ka;
    $914aec8743edd630$var$Lh = 1;
    var e = $914aec8743edd630$var$Z1();
    function t(r, i) {
        return e.concatMap(r, i)(this);
    }
    return $914aec8743edd630$var$Ka.concatMap = t, $914aec8743edd630$var$Ka;
}
var $914aec8743edd630$var$Nh;
function $914aec8743edd630$var$ew() {
    if ($914aec8743edd630$var$Nh) return $914aec8743edd630$var$Fh;
    $914aec8743edd630$var$Nh = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$X1();
    return e.Observable.prototype.concatMap = t.concatMap, $914aec8743edd630$var$Fh;
}
var $914aec8743edd630$var$Bh = {}, $914aec8743edd630$var$Ya = {}, $914aec8743edd630$var$Cr = {}, $914aec8743edd630$var$qh;
function $914aec8743edd630$var$tw() {
    if ($914aec8743edd630$var$qh) return $914aec8743edd630$var$Cr;
    $914aec8743edd630$var$qh = 1;
    var e = $914aec8743edd630$var$Cr && $914aec8743edd630$var$Cr.__extends || function(l, c) {
        for(var d in c)c.hasOwnProperty(d) && (l[d] = c[d]);
        function h() {
            this.constructor = l;
        }
        l.prototype = c === null ? Object.create(c) : (h.prototype = c.prototype, new h());
    }, t = $914aec8743edd630$var$ii(), r = $914aec8743edd630$var$lc(), i = $914aec8743edd630$var$ni(), n = $914aec8743edd630$var$ai(), o = $914aec8743edd630$var$si();
    function s(l) {
        return function(c) {
            return c.lift(new a(l, c));
        };
    }
    $914aec8743edd630$var$Cr.retryWhen = s;
    var a = function() {
        function l(c, d) {
            this.notifier = c, this.source = d;
        }
        return l.prototype.call = function(c, d) {
            return d.subscribe(new u(c, this.notifier, this.source));
        }, l;
    }(), u = function(l) {
        e(c, l);
        function c(d, h, f) {
            l.call(this, d), this.notifier = h, this.source = f;
        }
        return c.prototype.error = function(d) {
            if (!this.isStopped) {
                var h = this.errors, f = this.retries, p = this.retriesSubscription;
                if (f) this.errors = null, this.retriesSubscription = null;
                else {
                    if (h = new t.Subject(), f = r.tryCatch(this.notifier)(h), f === i.errorObject) return l.prototype.error.call(this, i.errorObject.e);
                    p = o.subscribeToResult(this, f);
                }
                this._unsubscribeAndRecycle(), this.errors = h, this.retries = f, this.retriesSubscription = p, h.next(d);
            }
        }, c.prototype._unsubscribe = function() {
            var d = this, h = d.errors, f = d.retriesSubscription;
            h && (h.unsubscribe(), this.errors = null), f && (f.unsubscribe(), this.retriesSubscription = null), this.retries = null;
        }, c.prototype.notifyNext = function(d, h, f, p, m) {
            var w = this, v = w.errors, g = w.retries, A = w.retriesSubscription;
            this.errors = null, this.retries = null, this.retriesSubscription = null, this._unsubscribeAndRecycle(), this.errors = v, this.retries = g, this.retriesSubscription = A, this.source.subscribe(this);
        }, c;
    }(n.OuterSubscriber);
    return $914aec8743edd630$var$Cr;
}
var $914aec8743edd630$var$zh;
function $914aec8743edd630$var$rw() {
    if ($914aec8743edd630$var$zh) return $914aec8743edd630$var$Ya;
    $914aec8743edd630$var$zh = 1;
    var e = $914aec8743edd630$var$tw();
    function t(r) {
        return e.retryWhen(r)(this);
    }
    return $914aec8743edd630$var$Ya.retryWhen = t, $914aec8743edd630$var$Ya;
}
var $914aec8743edd630$var$Uh;
function $914aec8743edd630$var$nw() {
    if ($914aec8743edd630$var$Uh) return $914aec8743edd630$var$Bh;
    $914aec8743edd630$var$Uh = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$rw();
    return e.Observable.prototype.retryWhen = t.retryWhen, $914aec8743edd630$var$Bh;
}
var $914aec8743edd630$var$Vh = {}, $914aec8743edd630$var$Ja = {}, $914aec8743edd630$var$Za = {}, $914aec8743edd630$var$xn = {}, $914aec8743edd630$var$Wt = {}, $914aec8743edd630$var$Rr = {}, $914aec8743edd630$var$Gh;
function $914aec8743edd630$var$Eg() {
    if ($914aec8743edd630$var$Gh) return $914aec8743edd630$var$Rr;
    $914aec8743edd630$var$Gh = 1;
    var e = $914aec8743edd630$var$Rr && $914aec8743edd630$var$Rr.__extends || function(o, s) {
        for(var a in s)s.hasOwnProperty(a) && (o[a] = s[a]);
        function u() {
            this.constructor = o;
        }
        o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
    }, t = $914aec8743edd630$var$Ge();
    function r() {
        return function(s) {
            return s.lift(new i(s));
        };
    }
    $914aec8743edd630$var$Rr.refCount = r;
    var i = function() {
        function o(s) {
            this.connectable = s;
        }
        return o.prototype.call = function(s, a) {
            var u = this.connectable;
            u._refCount++;
            var l = new n(s, u), c = a.subscribe(l);
            return l.closed || (l.connection = u.connect()), c;
        }, o;
    }(), n = function(o) {
        e(s, o);
        function s(a, u) {
            o.call(this, a), this.connectable = u;
        }
        return s.prototype._unsubscribe = function() {
            var a = this.connectable;
            if (!a) {
                this.connection = null;
                return;
            }
            this.connectable = null;
            var u = a._refCount;
            if (u <= 0) {
                this.connection = null;
                return;
            }
            if (a._refCount = u - 1, u > 1) {
                this.connection = null;
                return;
            }
            var l = this.connection, c = a._connection;
            this.connection = null, c && (!l || c === l) && c.unsubscribe();
        }, s;
    }(t.Subscriber);
    return $914aec8743edd630$var$Rr;
}
var $914aec8743edd630$var$Wh;
function $914aec8743edd630$var$iw() {
    if ($914aec8743edd630$var$Wh) return $914aec8743edd630$var$Wt;
    $914aec8743edd630$var$Wh = 1;
    var e = $914aec8743edd630$var$Wt && $914aec8743edd630$var$Wt.__extends || function(l, c) {
        for(var d in c)c.hasOwnProperty(d) && (l[d] = c[d]);
        function h() {
            this.constructor = l;
        }
        l.prototype = c === null ? Object.create(c) : (h.prototype = c.prototype, new h());
    }, t = $914aec8743edd630$var$ii(), r = $914aec8743edd630$var$Te(), i = $914aec8743edd630$var$Ge(), n = $914aec8743edd630$var$dn(), o = $914aec8743edd630$var$Eg(), s = function(l) {
        e(c, l);
        function c(d, h) {
            l.call(this), this.source = d, this.subjectFactory = h, this._refCount = 0, this._isComplete = !1;
        }
        return c.prototype._subscribe = function(d) {
            return this.getSubject().subscribe(d);
        }, c.prototype.getSubject = function() {
            var d = this._subject;
            return (!d || d.isStopped) && (this._subject = this.subjectFactory()), this._subject;
        }, c.prototype.connect = function() {
            var d = this._connection;
            return d || (this._isComplete = !1, d = this._connection = new n.Subscription(), d.add(this.source.subscribe(new u(this.getSubject(), this))), d.closed ? (this._connection = null, d = n.Subscription.EMPTY) : this._connection = d), d;
        }, c.prototype.refCount = function() {
            return o.refCount()(this);
        }, c;
    }(r.Observable);
    $914aec8743edd630$var$Wt.ConnectableObservable = s;
    var a = s.prototype;
    $914aec8743edd630$var$Wt.connectableObservableDescriptor = {
        operator: {
            value: null
        },
        _refCount: {
            value: 0,
            writable: !0
        },
        _subject: {
            value: null,
            writable: !0
        },
        _connection: {
            value: null,
            writable: !0
        },
        _subscribe: {
            value: a._subscribe
        },
        _isComplete: {
            value: a._isComplete,
            writable: !0
        },
        getSubject: {
            value: a.getSubject
        },
        connect: {
            value: a.connect
        },
        refCount: {
            value: a.refCount
        }
    };
    var u = function(l) {
        e(c, l);
        function c(d, h) {
            l.call(this, d), this.connectable = h;
        }
        return c.prototype._error = function(d) {
            this._unsubscribe(), l.prototype._error.call(this, d);
        }, c.prototype._complete = function() {
            this.connectable._isComplete = !0, this._unsubscribe(), l.prototype._complete.call(this);
        }, c.prototype._unsubscribe = function() {
            var d = this.connectable;
            if (d) {
                this.connectable = null;
                var h = d._connection;
                d._refCount = 0, d._subject = null, d._connection = null, h && h.unsubscribe();
            }
        }, c;
    }(t.SubjectSubscriber);
    return function(l) {
        e(c, l);
        function c(d, h) {
            l.call(this, d), this.connectable = h;
        }
        return c.prototype._unsubscribe = function() {
            var d = this.connectable;
            if (!d) {
                this.connection = null;
                return;
            }
            this.connectable = null;
            var h = d._refCount;
            if (h <= 0) {
                this.connection = null;
                return;
            }
            if (d._refCount = h - 1, h > 1) {
                this.connection = null;
                return;
            }
            var f = this.connection, p = d._connection;
            this.connection = null, p && (!f || p === f) && p.unsubscribe();
        }, c;
    }(i.Subscriber), $914aec8743edd630$var$Wt;
}
var $914aec8743edd630$var$Hh;
function $914aec8743edd630$var$ow() {
    if ($914aec8743edd630$var$Hh) return $914aec8743edd630$var$xn;
    $914aec8743edd630$var$Hh = 1;
    var e = $914aec8743edd630$var$iw();
    function t(i, n) {
        return function(s) {
            var a;
            if (typeof i == "function" ? a = i : a = function() {
                return i;
            }, typeof n == "function") return s.lift(new r(a, n));
            var u = Object.create(s, e.connectableObservableDescriptor);
            return u.source = s, u.subjectFactory = a, u;
        };
    }
    $914aec8743edd630$var$xn.multicast = t;
    var r = function() {
        function i(n, o) {
            this.subjectFactory = n, this.selector = o;
        }
        return i.prototype.call = function(n, o) {
            var s = this.selector, a = this.subjectFactory(), u = s(a).subscribe(n);
            return u.add(o.subscribe(a)), u;
        }, i;
    }();
    return $914aec8743edd630$var$xn.MulticastOperator = r, $914aec8743edd630$var$xn;
}
var $914aec8743edd630$var$Kh;
function $914aec8743edd630$var$aw() {
    if ($914aec8743edd630$var$Kh) return $914aec8743edd630$var$Za;
    $914aec8743edd630$var$Kh = 1;
    var e = $914aec8743edd630$var$ow(), t = $914aec8743edd630$var$Eg(), r = $914aec8743edd630$var$ii();
    function i() {
        return new r.Subject();
    }
    function n() {
        return function(o) {
            return t.refCount()(e.multicast(i)(o));
        };
    }
    return $914aec8743edd630$var$Za.share = n, $914aec8743edd630$var$Za;
}
var $914aec8743edd630$var$Qh;
function $914aec8743edd630$var$sw() {
    if ($914aec8743edd630$var$Qh) return $914aec8743edd630$var$Ja;
    $914aec8743edd630$var$Qh = 1;
    var e = $914aec8743edd630$var$aw();
    function t() {
        return e.share()(this);
    }
    return $914aec8743edd630$var$Ja.share = t, $914aec8743edd630$var$Ja;
}
var $914aec8743edd630$var$Yh;
function $914aec8743edd630$var$uw() {
    if ($914aec8743edd630$var$Yh) return $914aec8743edd630$var$Vh;
    $914aec8743edd630$var$Yh = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$sw();
    return e.Observable.prototype.share = t.share, $914aec8743edd630$var$Vh;
}
var $914aec8743edd630$var$Jh = {}, $914aec8743edd630$var$Xa = {}, $914aec8743edd630$var$Or = {}, $914aec8743edd630$var$Dr = {}, $914aec8743edd630$var$Zh;
function $914aec8743edd630$var$cw() {
    if ($914aec8743edd630$var$Zh) return $914aec8743edd630$var$Dr;
    $914aec8743edd630$var$Zh = 1;
    var e = $914aec8743edd630$var$Dr && $914aec8743edd630$var$Dr.__extends || function(r, i) {
        for(var n in i)i.hasOwnProperty(n) && (r[n] = i[n]);
        function o() {
            this.constructor = r;
        }
        r.prototype = i === null ? Object.create(i) : (o.prototype = i.prototype, new o());
    }, t = function(r) {
        e(i, r);
        function i() {
            var n = r.call(this, "argument out of range");
            this.name = n.name = "ArgumentOutOfRangeError", this.stack = n.stack, this.message = n.message;
        }
        return i;
    }(Error);
    return $914aec8743edd630$var$Dr.ArgumentOutOfRangeError = t, $914aec8743edd630$var$Dr;
}
var $914aec8743edd630$var$Xh;
function $914aec8743edd630$var$lw() {
    if ($914aec8743edd630$var$Xh) return $914aec8743edd630$var$Or;
    $914aec8743edd630$var$Xh = 1;
    var e = $914aec8743edd630$var$Or && $914aec8743edd630$var$Or.__extends || function(a, u) {
        for(var l in u)u.hasOwnProperty(l) && (a[l] = u[l]);
        function c() {
            this.constructor = a;
        }
        a.prototype = u === null ? Object.create(u) : (c.prototype = u.prototype, new c());
    }, t = $914aec8743edd630$var$Ge(), r = $914aec8743edd630$var$cw(), i = $914aec8743edd630$var$ui();
    function n(a) {
        return function(u) {
            return a === 0 ? new i.EmptyObservable() : u.lift(new o(a));
        };
    }
    $914aec8743edd630$var$Or.take = n;
    var o = function() {
        function a(u) {
            if (this.total = u, this.total < 0) throw new r.ArgumentOutOfRangeError();
        }
        return a.prototype.call = function(u, l) {
            return l.subscribe(new s(u, this.total));
        }, a;
    }(), s = function(a) {
        e(u, a);
        function u(l, c) {
            a.call(this, l), this.total = c, this.count = 0;
        }
        return u.prototype._next = function(l) {
            var c = this.total, d = ++this.count;
            d <= c && (this.destination.next(l), d === c && (this.destination.complete(), this.unsubscribe()));
        }, u;
    }(t.Subscriber);
    return $914aec8743edd630$var$Or;
}
var $914aec8743edd630$var$ep;
function $914aec8743edd630$var$dw() {
    if ($914aec8743edd630$var$ep) return $914aec8743edd630$var$Xa;
    $914aec8743edd630$var$ep = 1;
    var e = $914aec8743edd630$var$lw();
    function t(r) {
        return e.take(r)(this);
    }
    return $914aec8743edd630$var$Xa.take = t, $914aec8743edd630$var$Xa;
}
var $914aec8743edd630$var$tp;
function $914aec8743edd630$var$fw() {
    if ($914aec8743edd630$var$tp) return $914aec8743edd630$var$Jh;
    $914aec8743edd630$var$tp = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$dw();
    return e.Observable.prototype.take = t.take, $914aec8743edd630$var$Jh;
}
var $914aec8743edd630$var$rp = {}, $914aec8743edd630$var$es = {}, $914aec8743edd630$var$Be = {}, $914aec8743edd630$var$np;
function $914aec8743edd630$var$hw() {
    if ($914aec8743edd630$var$np) return $914aec8743edd630$var$Be;
    $914aec8743edd630$var$np = 1;
    var e = $914aec8743edd630$var$Be && $914aec8743edd630$var$Be.__extends || function(y, x) {
        for(var C in x)x.hasOwnProperty(C) && (y[C] = x[C]);
        function I() {
            this.constructor = y;
        }
        y.prototype = x === null ? Object.create(x) : (I.prototype = x.prototype, new I());
    }, t = $914aec8743edd630$var$yt(), r = $914aec8743edd630$var$lc(), i = $914aec8743edd630$var$ni(), n = $914aec8743edd630$var$Te(), o = $914aec8743edd630$var$Ge(), s = $914aec8743edd630$var$xg();
    function a() {
        if (t.root.XMLHttpRequest) return new t.root.XMLHttpRequest();
        if (t.root.XDomainRequest) return new t.root.XDomainRequest();
        throw new Error("CORS is not supported by your browser");
    }
    function u() {
        if (t.root.XMLHttpRequest) return new t.root.XMLHttpRequest();
        var y = void 0;
        try {
            for(var x = [
                "Msxml2.XMLHTTP",
                "Microsoft.XMLHTTP",
                "Msxml2.XMLHTTP.4.0"
            ], C = 0; C < 3; C++)try {
                y = x[C], new t.root.ActiveXObject(y);
                break;
            } catch  {}
            return new t.root.ActiveXObject(y);
        } catch  {
            throw new Error("XMLHttpRequest is not supported by your browser");
        }
    }
    function l(y, x) {
        return x === void 0 && (x = null), new w({
            method: "GET",
            url: y,
            headers: x
        });
    }
    $914aec8743edd630$var$Be.ajaxGet = l;
    function c(y, x, C) {
        return new w({
            method: "POST",
            url: y,
            body: x,
            headers: C
        });
    }
    $914aec8743edd630$var$Be.ajaxPost = c;
    function d(y, x) {
        return new w({
            method: "DELETE",
            url: y,
            headers: x
        });
    }
    $914aec8743edd630$var$Be.ajaxDelete = d;
    function h(y, x, C) {
        return new w({
            method: "PUT",
            url: y,
            body: x,
            headers: C
        });
    }
    $914aec8743edd630$var$Be.ajaxPut = h;
    function f(y, x, C) {
        return new w({
            method: "PATCH",
            url: y,
            body: x,
            headers: C
        });
    }
    $914aec8743edd630$var$Be.ajaxPatch = f;
    var p = s.map(function(y, x) {
        return y.response;
    });
    function m(y, x) {
        return p(new w({
            method: "GET",
            url: y,
            responseType: "json",
            headers: x
        }));
    }
    $914aec8743edd630$var$Be.ajaxGetJSON = m;
    var w = function(y) {
        e(x, y);
        function x(C) {
            y.call(this);
            var I = {
                async: !0,
                createXHR: function() {
                    return this.crossDomain ? a.call(this) : u();
                },
                crossDomain: !1,
                withCredentials: !1,
                headers: {},
                method: "GET",
                responseType: "json",
                timeout: 0
            };
            if (typeof C == "string") I.url = C;
            else for(var M in C)C.hasOwnProperty(M) && (I[M] = C[M]);
            this.request = I;
        }
        return x.prototype._subscribe = function(C) {
            return new v(C, this.request);
        }, x.create = function() {
            var C = function(I) {
                return new x(I);
            };
            return C.get = l, C.post = c, C.delete = d, C.put = h, C.patch = f, C.getJSON = m, C;
        }(), x;
    }(n.Observable);
    $914aec8743edd630$var$Be.AjaxObservable = w;
    var v = function(y) {
        e(x, y);
        function x(C, I) {
            y.call(this, C), this.request = I, this.done = !1;
            var M = I.headers = I.headers || {};
            !I.crossDomain && !M["X-Requested-With"] && (M["X-Requested-With"] = "XMLHttpRequest"), !("Content-Type" in M) && !(t.root.FormData && I.body instanceof t.root.FormData) && typeof I.body < "u" && (M["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8"), I.body = this.serializeBody(I.body, I.headers["Content-Type"]), this.send();
        }
        return x.prototype.next = function(C) {
            this.done = !0;
            var I = this, M = I.xhr, Q = I.request, H = I.destination, J = new g(C, M, Q);
            H.next(J);
        }, x.prototype.send = function() {
            var C = this, I = C.request, M = C.request, Q = M.user, H = M.method, J = M.url, W = M.async, P = M.password, R = M.headers, V = M.body, X = I.createXHR, N = r.tryCatch(X).call(I);
            if (N === i.errorObject) this.error(i.errorObject.e);
            else {
                this.xhr = N, this.setupEvents(N, I);
                var U = void 0;
                if (Q ? U = r.tryCatch(N.open).call(N, H, J, W, Q, P) : U = r.tryCatch(N.open).call(N, H, J, W), U === i.errorObject) return this.error(i.errorObject.e), null;
                if (W && (N.timeout = I.timeout, N.responseType = I.responseType), "withCredentials" in N && (N.withCredentials = !!I.withCredentials), this.setHeaders(N, R), U = V ? r.tryCatch(N.send).call(N, V) : r.tryCatch(N.send).call(N), U === i.errorObject) return this.error(i.errorObject.e), null;
            }
            return N;
        }, x.prototype.serializeBody = function(C, I) {
            if (!C || typeof C == "string") return C;
            if (t.root.FormData && C instanceof t.root.FormData) return C;
            if (I) {
                var M = I.indexOf(";");
                M !== -1 && (I = I.substring(0, M));
            }
            switch(I){
                case "application/x-www-form-urlencoded":
                    return Object.keys(C).map(function(Q) {
                        return encodeURIComponent(Q) + "=" + encodeURIComponent(C[Q]);
                    }).join("&");
                case "application/json":
                    return JSON.stringify(C);
                default:
                    return C;
            }
        }, x.prototype.setHeaders = function(C, I) {
            for(var M in I)I.hasOwnProperty(M) && C.setRequestHeader(M, I[M]);
        }, x.prototype.setupEvents = function(C, I) {
            var M = I.progressSubscriber;
            function Q(P) {
                var R = Q, V = R.subscriber, X = R.progressSubscriber, N = R.request;
                X && X.error(P), V.error(new k(this, N));
            }
            if (C.ontimeout = Q, Q.request = I, Q.subscriber = this, Q.progressSubscriber = M, C.upload && "withCredentials" in C) {
                if (M) {
                    var H;
                    H = function(P) {
                        var R = H.progressSubscriber;
                        R.next(P);
                    }, t.root.XDomainRequest ? C.onprogress = H : C.upload.onprogress = H, H.progressSubscriber = M;
                }
                var J;
                J = function(P) {
                    var R = J, V = R.progressSubscriber, X = R.subscriber, N = R.request;
                    V && V.error(P), X.error(new A("ajax error", this, N));
                }, C.onerror = J, J.request = I, J.subscriber = this, J.progressSubscriber = M;
            }
            function W(P) {
                var R = W, V = R.subscriber, X = R.progressSubscriber, N = R.request;
                if (this.readyState === 4) {
                    var U = this.status === 1223 ? 204 : this.status, G = this.responseType === "text" ? this.response || this.responseText : this.response;
                    U === 0 && (U = G ? 200 : 0), 200 <= U && U < 300 ? (X && X.complete(), V.next(P), V.complete()) : (X && X.error(P), V.error(new A("ajax error " + U, this, N)));
                }
            }
            C.onreadystatechange = W, W.subscriber = this, W.progressSubscriber = M, W.request = I;
        }, x.prototype.unsubscribe = function() {
            var C = this, I = C.done, M = C.xhr;
            !I && M && M.readyState !== 4 && typeof M.abort == "function" && M.abort(), y.prototype.unsubscribe.call(this);
        }, x;
    }(o.Subscriber);
    $914aec8743edd630$var$Be.AjaxSubscriber = v;
    var g = /* @__PURE__ */ function() {
        function y(x, C, I) {
            this.originalEvent = x, this.xhr = C, this.request = I, this.status = C.status, this.responseType = C.responseType || I.responseType, this.response = b(this.responseType, C);
        }
        return y;
    }();
    $914aec8743edd630$var$Be.AjaxResponse = g;
    var A = function(y) {
        e(x, y);
        function x(C, I, M) {
            y.call(this, C), this.message = C, this.xhr = I, this.request = M, this.status = I.status, this.responseType = I.responseType || M.responseType, this.response = b(this.responseType, I);
        }
        return x;
    }(Error);
    $914aec8743edd630$var$Be.AjaxError = A;
    function b(y, x) {
        switch(y){
            case "json":
                return "response" in x ? x.responseType ? x.response : JSON.parse(x.response || x.responseText || "null") : JSON.parse(x.responseText || "null");
            case "xml":
                return x.responseXML;
            case "text":
            default:
                return "response" in x ? x.response : x.responseText;
        }
    }
    var k = function(y) {
        e(x, y);
        function x(C, I) {
            y.call(this, "ajax timeout", C, I);
        }
        return x;
    }(A);
    return $914aec8743edd630$var$Be.AjaxTimeoutError = k, $914aec8743edd630$var$Be;
}
var $914aec8743edd630$var$ip;
function $914aec8743edd630$var$pw() {
    if ($914aec8743edd630$var$ip) return $914aec8743edd630$var$es;
    $914aec8743edd630$var$ip = 1;
    var e = $914aec8743edd630$var$hw();
    return $914aec8743edd630$var$es.ajax = e.AjaxObservable.create, $914aec8743edd630$var$es;
}
var $914aec8743edd630$var$op;
function $914aec8743edd630$var$mw() {
    if ($914aec8743edd630$var$op) return $914aec8743edd630$var$rp;
    $914aec8743edd630$var$op = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$pw();
    return e.Observable.ajax = t.ajax, $914aec8743edd630$var$rp;
}
var $914aec8743edd630$var$ap = {}, $914aec8743edd630$var$ts = {}, $914aec8743edd630$var$sp;
function $914aec8743edd630$var$gw() {
    if ($914aec8743edd630$var$sp) return $914aec8743edd630$var$ts;
    $914aec8743edd630$var$sp = 1;
    var e = $914aec8743edd630$var$ui();
    return $914aec8743edd630$var$ts.empty = e.EmptyObservable.create, $914aec8743edd630$var$ts;
}
var $914aec8743edd630$var$up;
function $914aec8743edd630$var$bw() {
    if ($914aec8743edd630$var$up) return $914aec8743edd630$var$ap;
    $914aec8743edd630$var$up = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$gw();
    return e.Observable.empty = t.empty, $914aec8743edd630$var$ap;
}
var $914aec8743edd630$var$cp = {}, $914aec8743edd630$var$rs = {}, $914aec8743edd630$var$Pr = {}, $914aec8743edd630$var$Ir = {}, $914aec8743edd630$var$lp;
function $914aec8743edd630$var$vw() {
    if ($914aec8743edd630$var$lp) return $914aec8743edd630$var$Ir;
    $914aec8743edd630$var$lp = 1;
    var e = $914aec8743edd630$var$Ir && $914aec8743edd630$var$Ir.__extends || function(s, a) {
        for(var u in a)a.hasOwnProperty(u) && (s[u] = a[u]);
        function l() {
            this.constructor = s;
        }
        s.prototype = a === null ? Object.create(a) : (l.prototype = a.prototype, new l());
    }, t = $914aec8743edd630$var$yt(), r = $914aec8743edd630$var$Te(), i = function(s) {
        e(a, s);
        function a(u, l) {
            s.call(this), this.promise = u, this.scheduler = l;
        }
        return a.create = function(u, l) {
            return new a(u, l);
        }, a.prototype._subscribe = function(u) {
            var l = this, c = this.promise, d = this.scheduler;
            if (d == null) this._isScalar ? u.closed || (u.next(this.value), u.complete()) : c.then(function(h) {
                l.value = h, l._isScalar = !0, u.closed || (u.next(h), u.complete());
            }, function(h) {
                u.closed || u.error(h);
            }).then(null, function(h) {
                t.root.setTimeout(function() {
                    throw h;
                });
            });
            else if (this._isScalar) {
                if (!u.closed) return d.schedule(n, 0, {
                    value: this.value,
                    subscriber: u
                });
            } else c.then(function(h) {
                l.value = h, l._isScalar = !0, u.closed || u.add(d.schedule(n, 0, {
                    value: h,
                    subscriber: u
                }));
            }, function(h) {
                u.closed || u.add(d.schedule(o, 0, {
                    err: h,
                    subscriber: u
                }));
            }).then(null, function(h) {
                t.root.setTimeout(function() {
                    throw h;
                });
            });
        }, a;
    }(r.Observable);
    $914aec8743edd630$var$Ir.PromiseObservable = i;
    function n(s) {
        var a = s.value, u = s.subscriber;
        u.closed || (u.next(a), u.complete());
    }
    function o(s) {
        var a = s.err, u = s.subscriber;
        u.closed || u.error(a);
    }
    return $914aec8743edd630$var$Ir;
}
var $914aec8743edd630$var$Mr = {}, $914aec8743edd630$var$dp;
function $914aec8743edd630$var$yw() {
    if ($914aec8743edd630$var$dp) return $914aec8743edd630$var$Mr;
    $914aec8743edd630$var$dp = 1;
    var e = $914aec8743edd630$var$Mr && $914aec8743edd630$var$Mr.__extends || function(h, f) {
        for(var p in f)f.hasOwnProperty(p) && (h[p] = f[p]);
        function m() {
            this.constructor = h;
        }
        h.prototype = f === null ? Object.create(f) : (m.prototype = f.prototype, new m());
    }, t = $914aec8743edd630$var$yt(), r = $914aec8743edd630$var$Te(), i = $914aec8743edd630$var$hc(), n = function(h) {
        e(f, h);
        function f(p, m) {
            if (h.call(this), this.scheduler = m, p == null) throw new Error("iterator cannot be null.");
            this.iterator = a(p);
        }
        return f.create = function(p, m) {
            return new f(p, m);
        }, f.dispatch = function(p) {
            var m = p.index, w = p.hasError, v = p.iterator, g = p.subscriber;
            if (w) {
                g.error(p.error);
                return;
            }
            var A = v.next();
            if (A.done) {
                g.complete();
                return;
            }
            if (g.next(A.value), p.index = m + 1, g.closed) {
                typeof v.return == "function" && v.return();
                return;
            }
            this.schedule(p);
        }, f.prototype._subscribe = function(p) {
            var m = 0, w = this, v = w.iterator, g = w.scheduler;
            if (g) return g.schedule(f.dispatch, 0, {
                index: m,
                iterator: v,
                subscriber: p
            });
            do {
                var A = v.next();
                if (A.done) {
                    p.complete();
                    break;
                } else p.next(A.value);
                if (p.closed) {
                    typeof v.return == "function" && v.return();
                    break;
                }
            }while (!0);
        }, f;
    }(r.Observable);
    $914aec8743edd630$var$Mr.IteratorObservable = n;
    var o = function() {
        function h(f, p, m) {
            p === void 0 && (p = 0), m === void 0 && (m = f.length), this.str = f, this.idx = p, this.len = m;
        }
        return h.prototype[i.iterator] = function() {
            return this;
        }, h.prototype.next = function() {
            return this.idx < this.len ? {
                done: !1,
                value: this.str.charAt(this.idx++)
            } : {
                done: !0,
                value: void 0
            };
        }, h;
    }(), s = function() {
        function h(f, p, m) {
            p === void 0 && (p = 0), m === void 0 && (m = l(f)), this.arr = f, this.idx = p, this.len = m;
        }
        return h.prototype[i.iterator] = function() {
            return this;
        }, h.prototype.next = function() {
            return this.idx < this.len ? {
                done: !1,
                value: this.arr[this.idx++]
            } : {
                done: !0,
                value: void 0
            };
        }, h;
    }();
    function a(h) {
        var f = h[i.iterator];
        if (!f && typeof h == "string") return new o(h);
        if (!f && h.length !== void 0) return new s(h);
        if (!f) throw new TypeError("object is not iterable");
        return h[i.iterator]();
    }
    var u = Math.pow(2, 53) - 1;
    function l(h) {
        var f = +h.length;
        return isNaN(f) ? 0 : f === 0 || !c(f) ? f : (f = d(f) * Math.floor(Math.abs(f)), f <= 0 ? 0 : f > u ? u : f);
    }
    function c(h) {
        return typeof h == "number" && t.root.isFinite(h);
    }
    function d(h) {
        var f = +h;
        return f === 0 || isNaN(f) ? f : f < 0 ? -1 : 1;
    }
    return $914aec8743edd630$var$Mr;
}
var $914aec8743edd630$var$jr = {}, $914aec8743edd630$var$fp;
function $914aec8743edd630$var$ww() {
    if ($914aec8743edd630$var$fp) return $914aec8743edd630$var$jr;
    $914aec8743edd630$var$fp = 1;
    var e = $914aec8743edd630$var$jr && $914aec8743edd630$var$jr.__extends || function(o, s) {
        for(var a in s)s.hasOwnProperty(a) && (o[a] = s[a]);
        function u() {
            this.constructor = o;
        }
        o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
    }, t = $914aec8743edd630$var$Te(), r = $914aec8743edd630$var$_g(), i = $914aec8743edd630$var$ui(), n = function(o) {
        e(s, o);
        function s(a, u) {
            o.call(this), this.arrayLike = a, this.scheduler = u, !u && a.length === 1 && (this._isScalar = !0, this.value = a[0]);
        }
        return s.create = function(a, u) {
            var l = a.length;
            return l === 0 ? new i.EmptyObservable() : l === 1 ? new r.ScalarObservable(a[0], u) : new s(a, u);
        }, s.dispatch = function(a) {
            var u = a.arrayLike, l = a.index, c = a.length, d = a.subscriber;
            if (!d.closed) {
                if (l >= c) {
                    d.complete();
                    return;
                }
                d.next(u[l]), a.index = l + 1, this.schedule(a);
            }
        }, s.prototype._subscribe = function(a) {
            var u = 0, l = this, c = l.arrayLike, d = l.scheduler, h = c.length;
            if (d) return d.schedule(s.dispatch, 0, {
                arrayLike: c,
                index: u,
                length: h,
                subscriber: a
            });
            for(var f = 0; f < h && !a.closed; f++)a.next(c[f]);
            a.complete();
        }, s;
    }(t.Observable);
    return $914aec8743edd630$var$jr.ArrayLikeObservable = n, $914aec8743edd630$var$jr;
}
var $914aec8743edd630$var$_t = {}, $914aec8743edd630$var$hp;
function $914aec8743edd630$var$_w() {
    if ($914aec8743edd630$var$hp) return $914aec8743edd630$var$_t;
    $914aec8743edd630$var$hp = 1;
    var e = $914aec8743edd630$var$_t && $914aec8743edd630$var$_t.__extends || function(a, u) {
        for(var l in u)u.hasOwnProperty(l) && (a[l] = u[l]);
        function c() {
            this.constructor = a;
        }
        a.prototype = u === null ? Object.create(u) : (c.prototype = u.prototype, new c());
    }, t = $914aec8743edd630$var$Ge(), r = $914aec8743edd630$var$kg();
    function i(a, u) {
        return u === void 0 && (u = 0), function(c) {
            return c.lift(new n(a, u));
        };
    }
    $914aec8743edd630$var$_t.observeOn = i;
    var n = function() {
        function a(u, l) {
            l === void 0 && (l = 0), this.scheduler = u, this.delay = l;
        }
        return a.prototype.call = function(u, l) {
            return l.subscribe(new o(u, this.scheduler, this.delay));
        }, a;
    }();
    $914aec8743edd630$var$_t.ObserveOnOperator = n;
    var o = function(a) {
        e(u, a);
        function u(l, c, d) {
            d === void 0 && (d = 0), a.call(this, l), this.scheduler = c, this.delay = d;
        }
        return u.dispatch = function(l) {
            var c = l.notification, d = l.destination;
            c.observe(d), this.unsubscribe();
        }, u.prototype.scheduleMessage = function(l) {
            this.add(this.scheduler.schedule(u.dispatch, this.delay, new s(l, this.destination)));
        }, u.prototype._next = function(l) {
            this.scheduleMessage(r.Notification.createNext(l));
        }, u.prototype._error = function(l) {
            this.scheduleMessage(r.Notification.createError(l));
        }, u.prototype._complete = function() {
            this.scheduleMessage(r.Notification.createComplete());
        }, u;
    }(t.Subscriber);
    $914aec8743edd630$var$_t.ObserveOnSubscriber = o;
    var s = /* @__PURE__ */ function() {
        function a(u, l) {
            this.notification = u, this.destination = l;
        }
        return a;
    }();
    return $914aec8743edd630$var$_t.ObserveOnMessage = s, $914aec8743edd630$var$_t;
}
var $914aec8743edd630$var$pp;
function $914aec8743edd630$var$kw() {
    if ($914aec8743edd630$var$pp) return $914aec8743edd630$var$Pr;
    $914aec8743edd630$var$pp = 1;
    var e = $914aec8743edd630$var$Pr && $914aec8743edd630$var$Pr.__extends || function(f, p) {
        for(var m in p)p.hasOwnProperty(m) && (f[m] = p[m]);
        function w() {
            this.constructor = f;
        }
        f.prototype = p === null ? Object.create(p) : (w.prototype = p.prototype, new w());
    }, t = $914aec8743edd630$var$ri(), r = $914aec8743edd630$var$yg(), i = $914aec8743edd630$var$wg(), n = $914aec8743edd630$var$vw(), o = $914aec8743edd630$var$yw(), s = $914aec8743edd630$var$pc(), a = $914aec8743edd630$var$ww(), u = $914aec8743edd630$var$hc(), l = $914aec8743edd630$var$Te(), c = $914aec8743edd630$var$_w(), d = $914aec8743edd630$var$fc(), h = function(f) {
        e(p, f);
        function p(m, w) {
            f.call(this, null), this.ish = m, this.scheduler = w;
        }
        return p.create = function(m, w) {
            if (m != null) {
                if (typeof m[d.observable] == "function") return m instanceof l.Observable && !w ? m : new p(m, w);
                if (t.isArray(m)) return new s.ArrayObservable(m, w);
                if (i.isPromise(m)) return new n.PromiseObservable(m, w);
                if (typeof m[u.iterator] == "function" || typeof m == "string") return new o.IteratorObservable(m, w);
                if (r.isArrayLike(m)) return new a.ArrayLikeObservable(m, w);
            }
            throw new TypeError((m !== null && typeof m || m) + " is not observable");
        }, p.prototype._subscribe = function(m) {
            var w = this.ish, v = this.scheduler;
            return v == null ? w[d.observable]().subscribe(m) : w[d.observable]().subscribe(new c.ObserveOnSubscriber(m, v, 0));
        }, p;
    }(l.Observable);
    return $914aec8743edd630$var$Pr.FromObservable = h, $914aec8743edd630$var$Pr;
}
var $914aec8743edd630$var$mp;
function $914aec8743edd630$var$xw() {
    if ($914aec8743edd630$var$mp) return $914aec8743edd630$var$rs;
    $914aec8743edd630$var$mp = 1;
    var e = $914aec8743edd630$var$kw();
    return $914aec8743edd630$var$rs.from = e.FromObservable.create, $914aec8743edd630$var$rs;
}
var $914aec8743edd630$var$gp;
function $914aec8743edd630$var$Sw() {
    if ($914aec8743edd630$var$gp) return $914aec8743edd630$var$cp;
    $914aec8743edd630$var$gp = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$xw();
    return e.Observable.from = t.from, $914aec8743edd630$var$cp;
}
var $914aec8743edd630$var$bp = {}, $914aec8743edd630$var$ns = {}, $914aec8743edd630$var$Fr = {}, $914aec8743edd630$var$is = {}, $914aec8743edd630$var$vp;
function $914aec8743edd630$var$Ew() {
    if ($914aec8743edd630$var$vp) return $914aec8743edd630$var$is;
    $914aec8743edd630$var$vp = 1;
    var e = $914aec8743edd630$var$ri();
    function t(r) {
        return !e.isArray(r) && r - parseFloat(r) + 1 >= 0;
    }
    return $914aec8743edd630$var$is.isNumeric = t, $914aec8743edd630$var$is;
}
var $914aec8743edd630$var$yp;
function $914aec8743edd630$var$Aw() {
    if ($914aec8743edd630$var$yp) return $914aec8743edd630$var$Fr;
    $914aec8743edd630$var$yp = 1;
    var e = $914aec8743edd630$var$Fr && $914aec8743edd630$var$Fr.__extends || function(o, s) {
        for(var a in s)s.hasOwnProperty(a) && (o[a] = s[a]);
        function u() {
            this.constructor = o;
        }
        o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
    }, t = $914aec8743edd630$var$Ew(), r = $914aec8743edd630$var$Te(), i = $914aec8743edd630$var$oi(), n = function(o) {
        e(s, o);
        function s(a, u) {
            a === void 0 && (a = 0), u === void 0 && (u = i.async), o.call(this), this.period = a, this.scheduler = u, (!t.isNumeric(a) || a < 0) && (this.period = 0), (!u || typeof u.schedule != "function") && (this.scheduler = i.async);
        }
        return s.create = function(a, u) {
            return a === void 0 && (a = 0), u === void 0 && (u = i.async), new s(a, u);
        }, s.dispatch = function(a) {
            var u = a.index, l = a.subscriber, c = a.period;
            l.next(u), !l.closed && (a.index += 1, this.schedule(a, c));
        }, s.prototype._subscribe = function(a) {
            var u = 0, l = this.period, c = this.scheduler;
            a.add(c.schedule(s.dispatch, l, {
                index: u,
                subscriber: a,
                period: l
            }));
        }, s;
    }(r.Observable);
    return $914aec8743edd630$var$Fr.IntervalObservable = n, $914aec8743edd630$var$Fr;
}
var $914aec8743edd630$var$wp;
function $914aec8743edd630$var$Tw() {
    if ($914aec8743edd630$var$wp) return $914aec8743edd630$var$ns;
    $914aec8743edd630$var$wp = 1;
    var e = $914aec8743edd630$var$Aw();
    return $914aec8743edd630$var$ns.interval = e.IntervalObservable.create, $914aec8743edd630$var$ns;
}
var $914aec8743edd630$var$_p;
function $914aec8743edd630$var$Cw() {
    if ($914aec8743edd630$var$_p) return $914aec8743edd630$var$bp;
    $914aec8743edd630$var$_p = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$Tw();
    return e.Observable.interval = t.interval, $914aec8743edd630$var$bp;
}
var $914aec8743edd630$var$kp = {}, $914aec8743edd630$var$os = {}, $914aec8743edd630$var$xp;
function $914aec8743edd630$var$Rw() {
    if ($914aec8743edd630$var$xp) return $914aec8743edd630$var$os;
    $914aec8743edd630$var$xp = 1;
    var e = $914aec8743edd630$var$pc();
    return $914aec8743edd630$var$os.of = e.ArrayObservable.of, $914aec8743edd630$var$os;
}
var $914aec8743edd630$var$Sp;
function $914aec8743edd630$var$Ow() {
    if ($914aec8743edd630$var$Sp) return $914aec8743edd630$var$kp;
    $914aec8743edd630$var$Sp = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$Rw();
    return e.Observable.of = t.of, $914aec8743edd630$var$kp;
}
var $914aec8743edd630$var$Ep = {}, $914aec8743edd630$var$as = {}, $914aec8743edd630$var$$r = {}, $914aec8743edd630$var$Ap;
function $914aec8743edd630$var$Dw() {
    if ($914aec8743edd630$var$Ap) return $914aec8743edd630$var$$r;
    $914aec8743edd630$var$Ap = 1;
    var e = $914aec8743edd630$var$$r && $914aec8743edd630$var$$r.__extends || function(i, n) {
        for(var o in n)n.hasOwnProperty(o) && (i[o] = n[o]);
        function s() {
            this.constructor = i;
        }
        i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
    }, t = $914aec8743edd630$var$Te(), r = function(i) {
        e(n, i);
        function n(o, s) {
            i.call(this), this.error = o, this.scheduler = s;
        }
        return n.create = function(o, s) {
            return new n(o, s);
        }, n.dispatch = function(o) {
            var s = o.error, a = o.subscriber;
            a.error(s);
        }, n.prototype._subscribe = function(o) {
            var s = this.error, a = this.scheduler;
            if (o.syncErrorThrowable = !0, a) return a.schedule(n.dispatch, 0, {
                error: s,
                subscriber: o
            });
            o.error(s);
        }, n;
    }(t.Observable);
    return $914aec8743edd630$var$$r.ErrorObservable = r, $914aec8743edd630$var$$r;
}
var $914aec8743edd630$var$Tp;
function $914aec8743edd630$var$Pw() {
    if ($914aec8743edd630$var$Tp) return $914aec8743edd630$var$as;
    $914aec8743edd630$var$Tp = 1;
    var e = $914aec8743edd630$var$Dw();
    return $914aec8743edd630$var$as._throw = e.ErrorObservable.create, $914aec8743edd630$var$as;
}
var $914aec8743edd630$var$Cp;
function $914aec8743edd630$var$Iw() {
    if ($914aec8743edd630$var$Cp) return $914aec8743edd630$var$Ep;
    $914aec8743edd630$var$Cp = 1;
    var e = $914aec8743edd630$var$Te(), t = $914aec8743edd630$var$Pw();
    return e.Observable.throw = t._throw, $914aec8743edd630$var$Ep;
}
var $914aec8743edd630$var$ss = {}, $914aec8743edd630$var$us = {}, $914aec8743edd630$var$cs = {
    exports: {}
}, $914aec8743edd630$var$ls = {
    exports: {}
}, $914aec8743edd630$var$Rp;
function $914aec8743edd630$var$Mw() {
    return $914aec8743edd630$var$Rp || ($914aec8743edd630$var$Rp = 1, function(e) {
        function t(r) {
            if (Array.isArray(r)) return r;
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$ls)), $914aec8743edd630$var$ls.exports;
}
var $914aec8743edd630$var$ds = {
    exports: {}
}, $914aec8743edd630$var$Op;
function $914aec8743edd630$var$Ag() {
    return $914aec8743edd630$var$Op || ($914aec8743edd630$var$Op = 1, function(e) {
        function t(r) {
            if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$ds)), $914aec8743edd630$var$ds.exports;
}
var $914aec8743edd630$var$fs = {
    exports: {}
}, $914aec8743edd630$var$hs = {
    exports: {}
}, $914aec8743edd630$var$Dp;
function $914aec8743edd630$var$Tg() {
    return $914aec8743edd630$var$Dp || ($914aec8743edd630$var$Dp = 1, function(e) {
        function t(r, i) {
            (i == null || i > r.length) && (i = r.length);
            for(var n = 0, o = Array(i); n < i; n++)o[n] = r[n];
            return o;
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$hs)), $914aec8743edd630$var$hs.exports;
}
var $914aec8743edd630$var$Pp;
function $914aec8743edd630$var$Cg() {
    return $914aec8743edd630$var$Pp || ($914aec8743edd630$var$Pp = 1, function(e) {
        var t = $914aec8743edd630$var$Tg();
        function r(i, n) {
            if (i) {
                if (typeof i == "string") return t(i, n);
                var o = ({}).toString.call(i).slice(8, -1);
                return o === "Object" && i.constructor && (o = i.constructor.name), o === "Map" || o === "Set" ? Array.from(i) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? t(i, n) : void 0;
            }
        }
        e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$fs)), $914aec8743edd630$var$fs.exports;
}
var $914aec8743edd630$var$ps = {
    exports: {}
}, $914aec8743edd630$var$Ip;
function $914aec8743edd630$var$jw() {
    return $914aec8743edd630$var$Ip || ($914aec8743edd630$var$Ip = 1, function(e) {
        function t() {
            throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$ps)), $914aec8743edd630$var$ps.exports;
}
var $914aec8743edd630$var$Mp;
function $914aec8743edd630$var$Fw() {
    return $914aec8743edd630$var$Mp || ($914aec8743edd630$var$Mp = 1, function(e) {
        var t = $914aec8743edd630$var$Mw(), r = $914aec8743edd630$var$Ag(), i = $914aec8743edd630$var$Cg(), n = $914aec8743edd630$var$jw();
        function o(s) {
            return t(s) || r(s) || i(s) || n();
        }
        e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$cs)), $914aec8743edd630$var$cs.exports;
}
var $914aec8743edd630$var$jp;
function $914aec8743edd630$var$$w() {
    return $914aec8743edd630$var$jp || ($914aec8743edd630$var$jp = 1, function(e) {
        var t = $914aec8743edd630$var$sn();
        Object.defineProperty(e, "__esModule", {
            value: !0
        }), e.default = i;
        var r = t($914aec8743edd630$var$Fw());
        function i(n) {
            if (n) {
                if (~n.indexOf(".")) {
                    var o = n.split(".").reverse(), s = (0, r.default)(o), a = s[0], u = s.slice(1);
                    return {
                        extname: "." + a,
                        name: u.reverse().join(".")
                    };
                } else return {
                    extname: "",
                    name: n
                };
            } else return {
                extname: "",
                name: ""
            };
        }
    }($914aec8743edd630$var$us)), $914aec8743edd630$var$us;
}
var $914aec8743edd630$var$Fp;
function $914aec8743edd630$var$Lw() {
    return $914aec8743edd630$var$Fp || ($914aec8743edd630$var$Fp = 1, function(e) {
        var t = $914aec8743edd630$var$sn();
        Object.defineProperty(e, "__esModule", {
            value: !0
        }), e.default = i;
        var r = t($914aec8743edd630$var$$w());
        function i(n) {
            var o = [];
            return n.forEach(function(s) {
                for(var a = (0, r.default)(s), u = a.extname, l = a.name, c = 0, d = s; o.includes(d);)d = [
                    l,
                    "(".concat(++c, ")")
                ].filter(function(h) {
                    return h;
                }).join(" ") + u;
                o.push(d);
            }), o;
        }
    }($914aec8743edd630$var$ss)), $914aec8743edd630$var$ss;
}
var $914aec8743edd630$var$Lr = {}, $914aec8743edd630$var$ms = {
    exports: {}
}, $914aec8743edd630$var$$p;
function $914aec8743edd630$var$Nw() {
    return $914aec8743edd630$var$$p || ($914aec8743edd630$var$$p = 1, function(e) {
        var t = $914aec8743edd630$var$nr().default;
        function r() {
            e.exports = r = function() {
                return n;
            }, e.exports.__esModule = !0, e.exports.default = e.exports;
            var i, n = {}, o = Object.prototype, s = o.hasOwnProperty, a = Object.defineProperty || function(N, U, G) {
                N[U] = G.value;
            }, u = typeof Symbol == "function" ? Symbol : {}, l = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", d = u.toStringTag || "@@toStringTag";
            function h(N, U, G) {
                return Object.defineProperty(N, U, {
                    value: G,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), N[U];
            }
            try {
                h({}, "");
            } catch  {
                h = function(G, re, oe) {
                    return G[re] = oe;
                };
            }
            function f(N, U, G, re) {
                var oe = U && U.prototype instanceof b ? U : b, ie = Object.create(oe.prototype), le = new V(re || []);
                return a(ie, "_invoke", {
                    value: J(N, G, le)
                }), ie;
            }
            function p(N, U, G) {
                try {
                    return {
                        type: "normal",
                        arg: N.call(U, G)
                    };
                } catch (re) {
                    return {
                        type: "throw",
                        arg: re
                    };
                }
            }
            n.wrap = f;
            var m = "suspendedStart", w = "suspendedYield", v = "executing", g = "completed", A = {};
            function b() {}
            function k() {}
            function y() {}
            var x = {};
            h(x, l, function() {
                return this;
            });
            var C = Object.getPrototypeOf, I = C && C(C(X([])));
            I && I !== o && s.call(I, l) && (x = I);
            var M = y.prototype = b.prototype = Object.create(x);
            function Q(N) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(U) {
                    h(N, U, function(G) {
                        return this._invoke(U, G);
                    });
                });
            }
            function H(N, U) {
                function G(oe, ie, le, he) {
                    var ye = p(N[oe], N, ie);
                    if (ye.type !== "throw") {
                        var be = ye.arg, we = be.value;
                        return we && t(we) == "object" && s.call(we, "__await") ? U.resolve(we.__await).then(function(ve) {
                            G("next", ve, le, he);
                        }, function(ve) {
                            G("throw", ve, le, he);
                        }) : U.resolve(we).then(function(ve) {
                            be.value = ve, le(be);
                        }, function(ve) {
                            return G("throw", ve, le, he);
                        });
                    }
                    he(ye.arg);
                }
                var re;
                a(this, "_invoke", {
                    value: function(ie, le) {
                        function he() {
                            return new U(function(ye, be) {
                                G(ie, le, ye, be);
                            });
                        }
                        return re = re ? re.then(he, he) : he();
                    }
                });
            }
            function J(N, U, G) {
                var re = m;
                return function(oe, ie) {
                    if (re === v) throw Error("Generator is already running");
                    if (re === g) {
                        if (oe === "throw") throw ie;
                        return {
                            value: i,
                            done: !0
                        };
                    }
                    for(G.method = oe, G.arg = ie;;){
                        var le = G.delegate;
                        if (le) {
                            var he = W(le, G);
                            if (he) {
                                if (he === A) continue;
                                return he;
                            }
                        }
                        if (G.method === "next") G.sent = G._sent = G.arg;
                        else if (G.method === "throw") {
                            if (re === m) throw re = g, G.arg;
                            G.dispatchException(G.arg);
                        } else G.method === "return" && G.abrupt("return", G.arg);
                        re = v;
                        var ye = p(N, U, G);
                        if (ye.type === "normal") {
                            if (re = G.done ? g : w, ye.arg === A) continue;
                            return {
                                value: ye.arg,
                                done: G.done
                            };
                        }
                        ye.type === "throw" && (re = g, G.method = "throw", G.arg = ye.arg);
                    }
                };
            }
            function W(N, U) {
                var G = U.method, re = N.iterator[G];
                if (re === i) return U.delegate = null, G === "throw" && N.iterator.return && (U.method = "return", U.arg = i, W(N, U), U.method === "throw") || G !== "return" && (U.method = "throw", U.arg = new TypeError("The iterator does not provide a '" + G + "' method")), A;
                var oe = p(re, N.iterator, U.arg);
                if (oe.type === "throw") return U.method = "throw", U.arg = oe.arg, U.delegate = null, A;
                var ie = oe.arg;
                return ie ? ie.done ? (U[N.resultName] = ie.value, U.next = N.nextLoc, U.method !== "return" && (U.method = "next", U.arg = i), U.delegate = null, A) : ie : (U.method = "throw", U.arg = new TypeError("iterator result is not an object"), U.delegate = null, A);
            }
            function P(N) {
                var U = {
                    tryLoc: N[0]
                };
                1 in N && (U.catchLoc = N[1]), 2 in N && (U.finallyLoc = N[2], U.afterLoc = N[3]), this.tryEntries.push(U);
            }
            function R(N) {
                var U = N.completion || {};
                U.type = "normal", delete U.arg, N.completion = U;
            }
            function V(N) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], N.forEach(P, this), this.reset(!0);
            }
            function X(N) {
                if (N || N === "") {
                    var U = N[l];
                    if (U) return U.call(N);
                    if (typeof N.next == "function") return N;
                    if (!isNaN(N.length)) {
                        var G = -1, re = function oe() {
                            for(; ++G < N.length;)if (s.call(N, G)) return oe.value = N[G], oe.done = !1, oe;
                            return oe.value = i, oe.done = !0, oe;
                        };
                        return re.next = re;
                    }
                }
                throw new TypeError(t(N) + " is not iterable");
            }
            return k.prototype = y, a(M, "constructor", {
                value: y,
                configurable: !0
            }), a(y, "constructor", {
                value: k,
                configurable: !0
            }), k.displayName = h(y, d, "GeneratorFunction"), n.isGeneratorFunction = function(N) {
                var U = typeof N == "function" && N.constructor;
                return !!U && (U === k || (U.displayName || U.name) === "GeneratorFunction");
            }, n.mark = function(N) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(N, y) : (N.__proto__ = y, h(N, d, "GeneratorFunction")), N.prototype = Object.create(M), N;
            }, n.awrap = function(N) {
                return {
                    __await: N
                };
            }, Q(H.prototype), h(H.prototype, c, function() {
                return this;
            }), n.AsyncIterator = H, n.async = function(N, U, G, re, oe) {
                oe === void 0 && (oe = Promise);
                var ie = new H(f(N, U, G, re), oe);
                return n.isGeneratorFunction(U) ? ie : ie.next().then(function(le) {
                    return le.done ? le.value : ie.next();
                });
            }, Q(M), h(M, d, "Generator"), h(M, l, function() {
                return this;
            }), h(M, "toString", function() {
                return "[object Generator]";
            }), n.keys = function(N) {
                var U = Object(N), G = [];
                for(var re in U)G.push(re);
                return G.reverse(), function oe() {
                    for(; G.length;){
                        var ie = G.pop();
                        if (ie in U) return oe.value = ie, oe.done = !1, oe;
                    }
                    return oe.done = !0, oe;
                };
            }, n.values = X, V.prototype = {
                constructor: V,
                reset: function(U) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = i, this.done = !1, this.delegate = null, this.method = "next", this.arg = i, this.tryEntries.forEach(R), !U) for(var G in this)G.charAt(0) === "t" && s.call(this, G) && !isNaN(+G.slice(1)) && (this[G] = i);
                },
                stop: function() {
                    this.done = !0;
                    var U = this.tryEntries[0].completion;
                    if (U.type === "throw") throw U.arg;
                    return this.rval;
                },
                dispatchException: function(U) {
                    if (this.done) throw U;
                    var G = this;
                    function re(be, we) {
                        return le.type = "throw", le.arg = U, G.next = be, we && (G.method = "next", G.arg = i), !!we;
                    }
                    for(var oe = this.tryEntries.length - 1; oe >= 0; --oe){
                        var ie = this.tryEntries[oe], le = ie.completion;
                        if (ie.tryLoc === "root") return re("end");
                        if (ie.tryLoc <= this.prev) {
                            var he = s.call(ie, "catchLoc"), ye = s.call(ie, "finallyLoc");
                            if (he && ye) {
                                if (this.prev < ie.catchLoc) return re(ie.catchLoc, !0);
                                if (this.prev < ie.finallyLoc) return re(ie.finallyLoc);
                            } else if (he) {
                                if (this.prev < ie.catchLoc) return re(ie.catchLoc, !0);
                            } else {
                                if (!ye) throw Error("try statement without catch or finally");
                                if (this.prev < ie.finallyLoc) return re(ie.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function(U, G) {
                    for(var re = this.tryEntries.length - 1; re >= 0; --re){
                        var oe = this.tryEntries[re];
                        if (oe.tryLoc <= this.prev && s.call(oe, "finallyLoc") && this.prev < oe.finallyLoc) {
                            var ie = oe;
                            break;
                        }
                    }
                    ie && (U === "break" || U === "continue") && ie.tryLoc <= G && G <= ie.finallyLoc && (ie = null);
                    var le = ie ? ie.completion : {};
                    return le.type = U, le.arg = G, ie ? (this.method = "next", this.next = ie.finallyLoc, A) : this.complete(le);
                },
                complete: function(U, G) {
                    if (U.type === "throw") throw U.arg;
                    return U.type === "break" || U.type === "continue" ? this.next = U.arg : U.type === "return" ? (this.rval = this.arg = U.arg, this.method = "return", this.next = "end") : U.type === "normal" && G && (this.next = G), A;
                },
                finish: function(U) {
                    for(var G = this.tryEntries.length - 1; G >= 0; --G){
                        var re = this.tryEntries[G];
                        if (re.finallyLoc === U) return this.complete(re.completion, re.afterLoc), R(re), A;
                    }
                },
                catch: function(U) {
                    for(var G = this.tryEntries.length - 1; G >= 0; --G){
                        var re = this.tryEntries[G];
                        if (re.tryLoc === U) {
                            var oe = re.completion;
                            if (oe.type === "throw") {
                                var ie = oe.arg;
                                R(re);
                            }
                            return ie;
                        }
                    }
                    throw Error("illegal catch attempt");
                },
                delegateYield: function(U, G, re) {
                    return this.delegate = {
                        iterator: X(U),
                        resultName: G,
                        nextLoc: re
                    }, this.method === "next" && (this.arg = i), A;
                }
            }, n;
        }
        e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$ms)), $914aec8743edd630$var$ms.exports;
}
var $914aec8743edd630$var$gs, $914aec8743edd630$var$Lp;
function $914aec8743edd630$var$Bw() {
    if ($914aec8743edd630$var$Lp) return $914aec8743edd630$var$gs;
    $914aec8743edd630$var$Lp = 1;
    var e = $914aec8743edd630$var$Nw()();
    $914aec8743edd630$var$gs = e;
    try {
        regeneratorRuntime = e;
    } catch  {
        typeof globalThis == "object" ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
    }
    return $914aec8743edd630$var$gs;
}
var $914aec8743edd630$var$bs = {
    exports: {}
}, $914aec8743edd630$var$vs = {
    exports: {}
}, $914aec8743edd630$var$Np;
function $914aec8743edd630$var$qw() {
    return $914aec8743edd630$var$Np || ($914aec8743edd630$var$Np = 1, function(e) {
        function t(r, i) {
            return i.get ? i.get.call(r) : i.value;
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$vs)), $914aec8743edd630$var$vs.exports;
}
var $914aec8743edd630$var$ys = {
    exports: {}
}, $914aec8743edd630$var$ws = {
    exports: {}
}, $914aec8743edd630$var$Bp;
function $914aec8743edd630$var$zw() {
    return $914aec8743edd630$var$Bp || ($914aec8743edd630$var$Bp = 1, function(e) {
        function t(r, i, n) {
            if (typeof r == "function" ? r === i : r.has(i)) return arguments.length < 3 ? i : n;
            throw new TypeError("Private element is not present on this object");
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$ws)), $914aec8743edd630$var$ws.exports;
}
var $914aec8743edd630$var$qp;
function $914aec8743edd630$var$Rg() {
    return $914aec8743edd630$var$qp || ($914aec8743edd630$var$qp = 1, function(e) {
        var t = $914aec8743edd630$var$zw();
        function r(i, n) {
            return i.get(t(i, n));
        }
        e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$ys)), $914aec8743edd630$var$ys.exports;
}
var $914aec8743edd630$var$zp;
function $914aec8743edd630$var$Og() {
    return $914aec8743edd630$var$zp || ($914aec8743edd630$var$zp = 1, function(e) {
        var t = $914aec8743edd630$var$qw(), r = $914aec8743edd630$var$Rg();
        function i(n, o) {
            var s = r(o, n);
            return t(n, s);
        }
        e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$bs)), $914aec8743edd630$var$bs.exports;
}
var $914aec8743edd630$var$_s = {
    exports: {}
}, $914aec8743edd630$var$ks = {
    exports: {}
}, $914aec8743edd630$var$Up;
function $914aec8743edd630$var$Uw() {
    return $914aec8743edd630$var$Up || ($914aec8743edd630$var$Up = 1, function(e) {
        function t(r, i, n) {
            if (i.set) i.set.call(r, n);
            else {
                if (!i.writable) throw new TypeError("attempted to set read only private field");
                i.value = n;
            }
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$ks)), $914aec8743edd630$var$ks.exports;
}
var $914aec8743edd630$var$Vp;
function $914aec8743edd630$var$Dg() {
    return $914aec8743edd630$var$Vp || ($914aec8743edd630$var$Vp = 1, function(e) {
        var t = $914aec8743edd630$var$Uw(), r = $914aec8743edd630$var$Rg();
        function i(n, o, s) {
            var a = r(o, n);
            return t(n, a, s), s;
        }
        e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$_s)), $914aec8743edd630$var$_s.exports;
}
var $914aec8743edd630$var$xs = {
    exports: {}
}, $914aec8743edd630$var$Ss = {
    exports: {}
}, $914aec8743edd630$var$Gp;
function $914aec8743edd630$var$Vw() {
    return $914aec8743edd630$var$Gp || ($914aec8743edd630$var$Gp = 1, function(e) {
        var t = $914aec8743edd630$var$Tg();
        function r(i) {
            if (Array.isArray(i)) return t(i);
        }
        e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Ss)), $914aec8743edd630$var$Ss.exports;
}
var $914aec8743edd630$var$Es = {
    exports: {}
}, $914aec8743edd630$var$Wp;
function $914aec8743edd630$var$Gw() {
    return $914aec8743edd630$var$Wp || ($914aec8743edd630$var$Wp = 1, function(e) {
        function t() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Es)), $914aec8743edd630$var$Es.exports;
}
var $914aec8743edd630$var$Hp;
function $914aec8743edd630$var$Ww() {
    return $914aec8743edd630$var$Hp || ($914aec8743edd630$var$Hp = 1, function(e) {
        var t = $914aec8743edd630$var$Vw(), r = $914aec8743edd630$var$Ag(), i = $914aec8743edd630$var$Cg(), n = $914aec8743edd630$var$Gw();
        function o(s) {
            return t(s) || r(s) || i(s) || n();
        }
        e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$xs)), $914aec8743edd630$var$xs.exports;
}
var $914aec8743edd630$var$As = {
    exports: {}
}, $914aec8743edd630$var$Kp;
function $914aec8743edd630$var$Hw() {
    return $914aec8743edd630$var$Kp || ($914aec8743edd630$var$Kp = 1, function(e) {
        function t(i, n, o, s, a, u, l) {
            try {
                var c = i[u](l), d = c.value;
            } catch (h) {
                return void o(h);
            }
            c.done ? n(d) : Promise.resolve(d).then(s, a);
        }
        function r(i) {
            return function() {
                var n = this, o = arguments;
                return new Promise(function(s, a) {
                    var u = i.apply(n, o);
                    function l(d) {
                        t(u, s, a, l, c, "next", d);
                    }
                    function c(d) {
                        t(u, s, a, l, c, "throw", d);
                    }
                    l(void 0);
                });
            };
        }
        e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$As)), $914aec8743edd630$var$As.exports;
}
var $914aec8743edd630$var$Ts = {}, $914aec8743edd630$var$Nr = {}, $914aec8743edd630$var$Qp;
function $914aec8743edd630$var$Kw() {
    if ($914aec8743edd630$var$Qp) return $914aec8743edd630$var$Nr;
    $914aec8743edd630$var$Qp = 1, $914aec8743edd630$var$Nr.byteLength = a, $914aec8743edd630$var$Nr.toByteArray = l, $914aec8743edd630$var$Nr.fromByteArray = h;
    for(var e = [], t = [], r = typeof Uint8Array < "u" ? Uint8Array : Array, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = 0, o = i.length; n < o; ++n)e[n] = i[n], t[i.charCodeAt(n)] = n;
    t[45] = 62, t[95] = 63;
    function s(f) {
        var p = f.length;
        if (p % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var m = f.indexOf("=");
        m === -1 && (m = p);
        var w = m === p ? 0 : 4 - m % 4;
        return [
            m,
            w
        ];
    }
    function a(f) {
        var p = s(f), m = p[0], w = p[1];
        return (m + w) * 3 / 4 - w;
    }
    function u(f, p, m) {
        return (p + m) * 3 / 4 - m;
    }
    function l(f) {
        var p, m = s(f), w = m[0], v = m[1], g = new r(u(f, w, v)), A = 0, b = v > 0 ? w - 4 : w, k;
        for(k = 0; k < b; k += 4)p = t[f.charCodeAt(k)] << 18 | t[f.charCodeAt(k + 1)] << 12 | t[f.charCodeAt(k + 2)] << 6 | t[f.charCodeAt(k + 3)], g[A++] = p >> 16 & 255, g[A++] = p >> 8 & 255, g[A++] = p & 255;
        return v === 2 && (p = t[f.charCodeAt(k)] << 2 | t[f.charCodeAt(k + 1)] >> 4, g[A++] = p & 255), v === 1 && (p = t[f.charCodeAt(k)] << 10 | t[f.charCodeAt(k + 1)] << 4 | t[f.charCodeAt(k + 2)] >> 2, g[A++] = p >> 8 & 255, g[A++] = p & 255), g;
    }
    function c(f) {
        return e[f >> 18 & 63] + e[f >> 12 & 63] + e[f >> 6 & 63] + e[f & 63];
    }
    function d(f, p, m) {
        for(var w, v = [], g = p; g < m; g += 3)w = (f[g] << 16 & 16711680) + (f[g + 1] << 8 & 65280) + (f[g + 2] & 255), v.push(c(w));
        return v.join("");
    }
    function h(f) {
        for(var p, m = f.length, w = m % 3, v = [], g = 16383, A = 0, b = m - w; A < b; A += g)v.push(d(f, A, A + g > b ? b : A + g));
        return w === 1 ? (p = f[m - 1], v.push(e[p >> 2] + e[p << 4 & 63] + "==")) : w === 2 && (p = (f[m - 2] << 8) + f[m - 1], v.push(e[p >> 10] + e[p >> 4 & 63] + e[p << 2 & 63] + "=")), v.join("");
    }
    return $914aec8743edd630$var$Nr;
}
var $914aec8743edd630$var$Sn = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $914aec8743edd630$var$Yp;
function $914aec8743edd630$var$Qw() {
    return $914aec8743edd630$var$Yp || ($914aec8743edd630$var$Yp = 1, $914aec8743edd630$var$Sn.read = function(e, t, r, i, n) {
        var o, s, a = n * 8 - i - 1, u = (1 << a) - 1, l = u >> 1, c = -7, d = r ? n - 1 : 0, h = r ? -1 : 1, f = e[t + d];
        for(d += h, o = f & (1 << -c) - 1, f >>= -c, c += a; c > 0; o = o * 256 + e[t + d], d += h, c -= 8);
        for(s = o & (1 << -c) - 1, o >>= -c, c += i; c > 0; s = s * 256 + e[t + d], d += h, c -= 8);
        if (o === 0) o = 1 - l;
        else {
            if (o === u) return s ? NaN : (f ? -1 : 1) * (1 / 0);
            s = s + Math.pow(2, i), o = o - l;
        }
        return (f ? -1 : 1) * s * Math.pow(2, o - i);
    }, $914aec8743edd630$var$Sn.write = function(e, t, r, i, n, o) {
        var s, a, u, l = o * 8 - n - 1, c = (1 << l) - 1, d = c >> 1, h = n === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = i ? 0 : o - 1, p = i ? 1 : -1, m = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
        for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = c) : (s = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), s + d >= 1 ? t += h / u : t += h * Math.pow(2, 1 - d), t * u >= 2 && (s++, u /= 2), s + d >= c ? (a = 0, s = c) : s + d >= 1 ? (a = (t * u - 1) * Math.pow(2, n), s = s + d) : (a = t * Math.pow(2, d - 1) * Math.pow(2, n), s = 0)); n >= 8; e[r + f] = a & 255, f += p, a /= 256, n -= 8);
        for(s = s << n | a, l += n; l > 0; e[r + f] = s & 255, f += p, s /= 256, l -= 8);
        e[r + f - p] |= m * 128;
    }), $914aec8743edd630$var$Sn;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ var $914aec8743edd630$var$Jp;
function $914aec8743edd630$var$Yw() {
    return $914aec8743edd630$var$Jp || ($914aec8743edd630$var$Jp = 1, function(e) {
        const t = $914aec8743edd630$var$Kw(), r = $914aec8743edd630$var$Qw(), i = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
        e.Buffer = a, e.SlowBuffer = g, e.INSPECT_MAX_BYTES = 50;
        const n = 2147483647;
        e.kMaxLength = n, a.TYPED_ARRAY_SUPPORT = o(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
        function o() {
            try {
                const O = new Uint8Array(1), _ = {
                    foo: function() {
                        return 42;
                    }
                };
                return Object.setPrototypeOf(_, Uint8Array.prototype), Object.setPrototypeOf(O, _), O.foo() === 42;
            } catch  {
                return !1;
            }
        }
        Object.defineProperty(a.prototype, "parent", {
            enumerable: !0,
            get: function() {
                if (a.isBuffer(this)) return this.buffer;
            }
        }), Object.defineProperty(a.prototype, "offset", {
            enumerable: !0,
            get: function() {
                if (a.isBuffer(this)) return this.byteOffset;
            }
        });
        function s(O) {
            if (O > n) throw new RangeError('The value "' + O + '" is invalid for option "size"');
            const _ = new Uint8Array(O);
            return Object.setPrototypeOf(_, a.prototype), _;
        }
        function a(O, _, S) {
            if (typeof O == "number") {
                if (typeof _ == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
                return d(O);
            }
            return u(O, _, S);
        }
        a.poolSize = 8192;
        function u(O, _, S) {
            if (typeof O == "string") return h(O, _);
            if (ArrayBuffer.isView(O)) return p(O);
            if (O == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof O);
            if (T(O, ArrayBuffer) || O && T(O.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (T(O, SharedArrayBuffer) || O && T(O.buffer, SharedArrayBuffer))) return m(O, _, S);
            if (typeof O == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
            const F = O.valueOf && O.valueOf();
            if (F != null && F !== O) return a.from(F, _, S);
            const $ = w(O);
            if ($) return $;
            if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof O[Symbol.toPrimitive] == "function") return a.from(O[Symbol.toPrimitive]("string"), _, S);
            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof O);
        }
        a.from = function(O, _, S) {
            return u(O, _, S);
        }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
        function l(O) {
            if (typeof O != "number") throw new TypeError('"size" argument must be of type number');
            if (O < 0) throw new RangeError('The value "' + O + '" is invalid for option "size"');
        }
        function c(O, _, S) {
            return l(O), O <= 0 ? s(O) : _ !== void 0 ? typeof S == "string" ? s(O).fill(_, S) : s(O).fill(_) : s(O);
        }
        a.alloc = function(O, _, S) {
            return c(O, _, S);
        };
        function d(O) {
            return l(O), s(O < 0 ? 0 : v(O) | 0);
        }
        a.allocUnsafe = function(O) {
            return d(O);
        }, a.allocUnsafeSlow = function(O) {
            return d(O);
        };
        function h(O, _) {
            if ((typeof _ != "string" || _ === "") && (_ = "utf8"), !a.isEncoding(_)) throw new TypeError("Unknown encoding: " + _);
            const S = A(O, _) | 0;
            let F = s(S);
            const $ = F.write(O, _);
            return $ !== S && (F = F.slice(0, $)), F;
        }
        function f(O) {
            const _ = O.length < 0 ? 0 : v(O.length) | 0, S = s(_);
            for(let F = 0; F < _; F += 1)S[F] = O[F] & 255;
            return S;
        }
        function p(O) {
            if (T(O, Uint8Array)) {
                const _ = new Uint8Array(O);
                return m(_.buffer, _.byteOffset, _.byteLength);
            }
            return f(O);
        }
        function m(O, _, S) {
            if (_ < 0 || O.byteLength < _) throw new RangeError('"offset" is outside of buffer bounds');
            if (O.byteLength < _ + (S || 0)) throw new RangeError('"length" is outside of buffer bounds');
            let F;
            return _ === void 0 && S === void 0 ? F = new Uint8Array(O) : S === void 0 ? F = new Uint8Array(O, _) : F = new Uint8Array(O, _, S), Object.setPrototypeOf(F, a.prototype), F;
        }
        function w(O) {
            if (a.isBuffer(O)) {
                const _ = v(O.length) | 0, S = s(_);
                return S.length === 0 || O.copy(S, 0, 0, _), S;
            }
            if (O.length !== void 0) return typeof O.length != "number" || j(O.length) ? s(0) : f(O);
            if (O.type === "Buffer" && Array.isArray(O.data)) return f(O.data);
        }
        function v(O) {
            if (O >= n) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + n.toString(16) + " bytes");
            return O | 0;
        }
        function g(O) {
            return +O != O && (O = 0), a.alloc(+O);
        }
        a.isBuffer = function(_) {
            return _ != null && _._isBuffer === !0 && _ !== a.prototype;
        }, a.compare = function(_, S) {
            if (T(_, Uint8Array) && (_ = a.from(_, _.offset, _.byteLength)), T(S, Uint8Array) && (S = a.from(S, S.offset, S.byteLength)), !a.isBuffer(_) || !a.isBuffer(S)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
            if (_ === S) return 0;
            let F = _.length, $ = S.length;
            for(let K = 0, ee = Math.min(F, $); K < ee; ++K)if (_[K] !== S[K]) {
                F = _[K], $ = S[K];
                break;
            }
            return F < $ ? -1 : $ < F ? 1 : 0;
        }, a.isEncoding = function(_) {
            switch(String(_).toLowerCase()){
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return !0;
                default:
                    return !1;
            }
        }, a.concat = function(_, S) {
            if (!Array.isArray(_)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (_.length === 0) return a.alloc(0);
            let F;
            if (S === void 0) for(S = 0, F = 0; F < _.length; ++F)S += _[F].length;
            const $ = a.allocUnsafe(S);
            let K = 0;
            for(F = 0; F < _.length; ++F){
                let ee = _[F];
                if (T(ee, Uint8Array)) K + ee.length > $.length ? (a.isBuffer(ee) || (ee = a.from(ee)), ee.copy($, K)) : Uint8Array.prototype.set.call($, ee, K);
                else if (a.isBuffer(ee)) ee.copy($, K);
                else throw new TypeError('"list" argument must be an Array of Buffers');
                K += ee.length;
            }
            return $;
        };
        function A(O, _) {
            if (a.isBuffer(O)) return O.length;
            if (ArrayBuffer.isView(O) || T(O, ArrayBuffer)) return O.byteLength;
            if (typeof O != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof O);
            const S = O.length, F = arguments.length > 2 && arguments[2] === !0;
            if (!F && S === 0) return 0;
            let $ = !1;
            for(;;)switch(_){
                case "ascii":
                case "latin1":
                case "binary":
                    return S;
                case "utf8":
                case "utf-8":
                    return me(O).length;
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return S * 2;
                case "hex":
                    return S >>> 1;
                case "base64":
                    return D(O).length;
                default:
                    if ($) return F ? -1 : me(O).length;
                    _ = ("" + _).toLowerCase(), $ = !0;
            }
        }
        a.byteLength = A;
        function b(O, _, S) {
            let F = !1;
            if ((_ === void 0 || _ < 0) && (_ = 0), _ > this.length || ((S === void 0 || S > this.length) && (S = this.length), S <= 0) || (S >>>= 0, _ >>>= 0, S <= _)) return "";
            for(O || (O = "utf8");;)switch(O){
                case "hex":
                    return N(this, _, S);
                case "utf8":
                case "utf-8":
                    return W(this, _, S);
                case "ascii":
                    return V(this, _, S);
                case "latin1":
                case "binary":
                    return X(this, _, S);
                case "base64":
                    return J(this, _, S);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return U(this, _, S);
                default:
                    if (F) throw new TypeError("Unknown encoding: " + O);
                    O = (O + "").toLowerCase(), F = !0;
            }
        }
        a.prototype._isBuffer = !0;
        function k(O, _, S) {
            const F = O[_];
            O[_] = O[S], O[S] = F;
        }
        a.prototype.swap16 = function() {
            const _ = this.length;
            if (_ % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
            for(let S = 0; S < _; S += 2)k(this, S, S + 1);
            return this;
        }, a.prototype.swap32 = function() {
            const _ = this.length;
            if (_ % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
            for(let S = 0; S < _; S += 4)k(this, S, S + 3), k(this, S + 1, S + 2);
            return this;
        }, a.prototype.swap64 = function() {
            const _ = this.length;
            if (_ % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
            for(let S = 0; S < _; S += 8)k(this, S, S + 7), k(this, S + 1, S + 6), k(this, S + 2, S + 5), k(this, S + 3, S + 4);
            return this;
        }, a.prototype.toString = function() {
            const _ = this.length;
            return _ === 0 ? "" : arguments.length === 0 ? W(this, 0, _) : b.apply(this, arguments);
        }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(_) {
            if (!a.isBuffer(_)) throw new TypeError("Argument must be a Buffer");
            return this === _ ? !0 : a.compare(this, _) === 0;
        }, a.prototype.inspect = function() {
            let _ = "";
            const S = e.INSPECT_MAX_BYTES;
            return _ = this.toString("hex", 0, S).replace(/(.{2})/g, "$1 ").trim(), this.length > S && (_ += " ... "), "<Buffer " + _ + ">";
        }, i && (a.prototype[i] = a.prototype.inspect), a.prototype.compare = function(_, S, F, $, K) {
            if (T(_, Uint8Array) && (_ = a.from(_, _.offset, _.byteLength)), !a.isBuffer(_)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof _);
            if (S === void 0 && (S = 0), F === void 0 && (F = _ ? _.length : 0), $ === void 0 && ($ = 0), K === void 0 && (K = this.length), S < 0 || F > _.length || $ < 0 || K > this.length) throw new RangeError("out of range index");
            if ($ >= K && S >= F) return 0;
            if ($ >= K) return -1;
            if (S >= F) return 1;
            if (S >>>= 0, F >>>= 0, $ >>>= 0, K >>>= 0, this === _) return 0;
            let ee = K - $, de = F - S;
            const ge = Math.min(ee, de), ke = this.slice($, K), Ee = _.slice(S, F);
            for(let xe = 0; xe < ge; ++xe)if (ke[xe] !== Ee[xe]) {
                ee = ke[xe], de = Ee[xe];
                break;
            }
            return ee < de ? -1 : de < ee ? 1 : 0;
        };
        function y(O, _, S, F, $) {
            if (O.length === 0) return -1;
            if (typeof S == "string" ? (F = S, S = 0) : S > 2147483647 ? S = 2147483647 : S < -2147483648 && (S = -2147483648), S = +S, j(S) && (S = $ ? 0 : O.length - 1), S < 0 && (S = O.length + S), S >= O.length) {
                if ($) return -1;
                S = O.length - 1;
            } else if (S < 0) {
                if ($) S = 0;
                else return -1;
            }
            if (typeof _ == "string" && (_ = a.from(_, F)), a.isBuffer(_)) return _.length === 0 ? -1 : x(O, _, S, F, $);
            if (typeof _ == "number") return _ = _ & 255, typeof Uint8Array.prototype.indexOf == "function" ? $ ? Uint8Array.prototype.indexOf.call(O, _, S) : Uint8Array.prototype.lastIndexOf.call(O, _, S) : x(O, [
                _
            ], S, F, $);
            throw new TypeError("val must be string, number or Buffer");
        }
        function x(O, _, S, F, $) {
            let K = 1, ee = O.length, de = _.length;
            if (F !== void 0 && (F = String(F).toLowerCase(), F === "ucs2" || F === "ucs-2" || F === "utf16le" || F === "utf-16le")) {
                if (O.length < 2 || _.length < 2) return -1;
                K = 2, ee /= 2, de /= 2, S /= 2;
            }
            function ge(Ee, xe) {
                return K === 1 ? Ee[xe] : Ee.readUInt16BE(xe * K);
            }
            let ke;
            if ($) {
                let Ee = -1;
                for(ke = S; ke < ee; ke++)if (ge(O, ke) === ge(_, Ee === -1 ? 0 : ke - Ee)) {
                    if (Ee === -1 && (Ee = ke), ke - Ee + 1 === de) return Ee * K;
                } else Ee !== -1 && (ke -= ke - Ee), Ee = -1;
            } else for(S + de > ee && (S = ee - de), ke = S; ke >= 0; ke--){
                let Ee = !0;
                for(let xe = 0; xe < de; xe++)if (ge(O, ke + xe) !== ge(_, xe)) {
                    Ee = !1;
                    break;
                }
                if (Ee) return ke;
            }
            return -1;
        }
        a.prototype.includes = function(_, S, F) {
            return this.indexOf(_, S, F) !== -1;
        }, a.prototype.indexOf = function(_, S, F) {
            return y(this, _, S, F, !0);
        }, a.prototype.lastIndexOf = function(_, S, F) {
            return y(this, _, S, F, !1);
        };
        function C(O, _, S, F) {
            S = Number(S) || 0;
            const $ = O.length - S;
            F ? (F = Number(F), F > $ && (F = $)) : F = $;
            const K = _.length;
            F > K / 2 && (F = K / 2);
            let ee;
            for(ee = 0; ee < F; ++ee){
                const de = parseInt(_.substr(ee * 2, 2), 16);
                if (j(de)) return ee;
                O[S + ee] = de;
            }
            return ee;
        }
        function I(O, _, S, F) {
            return E(me(_, O.length - S), O, S, F);
        }
        function M(O, _, S, F) {
            return E(L(_), O, S, F);
        }
        function Q(O, _, S, F) {
            return E(D(_), O, S, F);
        }
        function H(O, _, S, F) {
            return E(B(_, O.length - S), O, S, F);
        }
        a.prototype.write = function(_, S, F, $) {
            if (S === void 0) $ = "utf8", F = this.length, S = 0;
            else if (F === void 0 && typeof S == "string") $ = S, F = this.length, S = 0;
            else if (isFinite(S)) S = S >>> 0, isFinite(F) ? (F = F >>> 0, $ === void 0 && ($ = "utf8")) : ($ = F, F = void 0);
            else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            const K = this.length - S;
            if ((F === void 0 || F > K) && (F = K), _.length > 0 && (F < 0 || S < 0) || S > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            $ || ($ = "utf8");
            let ee = !1;
            for(;;)switch($){
                case "hex":
                    return C(this, _, S, F);
                case "utf8":
                case "utf-8":
                    return I(this, _, S, F);
                case "ascii":
                case "latin1":
                case "binary":
                    return M(this, _, S, F);
                case "base64":
                    return Q(this, _, S, F);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return H(this, _, S, F);
                default:
                    if (ee) throw new TypeError("Unknown encoding: " + $);
                    $ = ("" + $).toLowerCase(), ee = !0;
            }
        }, a.prototype.toJSON = function() {
            return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
            };
        };
        function J(O, _, S) {
            return _ === 0 && S === O.length ? t.fromByteArray(O) : t.fromByteArray(O.slice(_, S));
        }
        function W(O, _, S) {
            S = Math.min(O.length, S);
            const F = [];
            let $ = _;
            for(; $ < S;){
                const K = O[$];
                let ee = null, de = K > 239 ? 4 : K > 223 ? 3 : K > 191 ? 2 : 1;
                if ($ + de <= S) {
                    let ge, ke, Ee, xe;
                    switch(de){
                        case 1:
                            K < 128 && (ee = K);
                            break;
                        case 2:
                            ge = O[$ + 1], (ge & 192) === 128 && (xe = (K & 31) << 6 | ge & 63, xe > 127 && (ee = xe));
                            break;
                        case 3:
                            ge = O[$ + 1], ke = O[$ + 2], (ge & 192) === 128 && (ke & 192) === 128 && (xe = (K & 15) << 12 | (ge & 63) << 6 | ke & 63, xe > 2047 && (xe < 55296 || xe > 57343) && (ee = xe));
                            break;
                        case 4:
                            ge = O[$ + 1], ke = O[$ + 2], Ee = O[$ + 3], (ge & 192) === 128 && (ke & 192) === 128 && (Ee & 192) === 128 && (xe = (K & 15) << 18 | (ge & 63) << 12 | (ke & 63) << 6 | Ee & 63, xe > 65535 && xe < 1114112 && (ee = xe));
                    }
                }
                ee === null ? (ee = 65533, de = 1) : ee > 65535 && (ee -= 65536, F.push(ee >>> 10 & 1023 | 55296), ee = 56320 | ee & 1023), F.push(ee), $ += de;
            }
            return R(F);
        }
        const P = 4096;
        function R(O) {
            const _ = O.length;
            if (_ <= P) return String.fromCharCode.apply(String, O);
            let S = "", F = 0;
            for(; F < _;)S += String.fromCharCode.apply(String, O.slice(F, F += P));
            return S;
        }
        function V(O, _, S) {
            let F = "";
            S = Math.min(O.length, S);
            for(let $ = _; $ < S; ++$)F += String.fromCharCode(O[$] & 127);
            return F;
        }
        function X(O, _, S) {
            let F = "";
            S = Math.min(O.length, S);
            for(let $ = _; $ < S; ++$)F += String.fromCharCode(O[$]);
            return F;
        }
        function N(O, _, S) {
            const F = O.length;
            (!_ || _ < 0) && (_ = 0), (!S || S < 0 || S > F) && (S = F);
            let $ = "";
            for(let K = _; K < S; ++K)$ += Y[O[K]];
            return $;
        }
        function U(O, _, S) {
            const F = O.slice(_, S);
            let $ = "";
            for(let K = 0; K < F.length - 1; K += 2)$ += String.fromCharCode(F[K] + F[K + 1] * 256);
            return $;
        }
        a.prototype.slice = function(_, S) {
            const F = this.length;
            _ = ~~_, S = S === void 0 ? F : ~~S, _ < 0 ? (_ += F, _ < 0 && (_ = 0)) : _ > F && (_ = F), S < 0 ? (S += F, S < 0 && (S = 0)) : S > F && (S = F), S < _ && (S = _);
            const $ = this.subarray(_, S);
            return Object.setPrototypeOf($, a.prototype), $;
        };
        function G(O, _, S) {
            if (O % 1 !== 0 || O < 0) throw new RangeError("offset is not uint");
            if (O + _ > S) throw new RangeError("Trying to access beyond buffer length");
        }
        a.prototype.readUintLE = a.prototype.readUIntLE = function(_, S, F) {
            _ = _ >>> 0, S = S >>> 0, F || G(_, S, this.length);
            let $ = this[_], K = 1, ee = 0;
            for(; ++ee < S && (K *= 256);)$ += this[_ + ee] * K;
            return $;
        }, a.prototype.readUintBE = a.prototype.readUIntBE = function(_, S, F) {
            _ = _ >>> 0, S = S >>> 0, F || G(_, S, this.length);
            let $ = this[_ + --S], K = 1;
            for(; S > 0 && (K *= 256);)$ += this[_ + --S] * K;
            return $;
        }, a.prototype.readUint8 = a.prototype.readUInt8 = function(_, S) {
            return _ = _ >>> 0, S || G(_, 1, this.length), this[_];
        }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(_, S) {
            return _ = _ >>> 0, S || G(_, 2, this.length), this[_] | this[_ + 1] << 8;
        }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(_, S) {
            return _ = _ >>> 0, S || G(_, 2, this.length), this[_] << 8 | this[_ + 1];
        }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(_, S) {
            return _ = _ >>> 0, S || G(_, 4, this.length), (this[_] | this[_ + 1] << 8 | this[_ + 2] << 16) + this[_ + 3] * 16777216;
        }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(_, S) {
            return _ = _ >>> 0, S || G(_, 4, this.length), this[_] * 16777216 + (this[_ + 1] << 16 | this[_ + 2] << 8 | this[_ + 3]);
        }, a.prototype.readBigUInt64LE = ae(function(_) {
            _ = _ >>> 0, te(_, "offset");
            const S = this[_], F = this[_ + 7];
            (S === void 0 || F === void 0) && Z(_, this.length - 8);
            const $ = S + this[++_] * 256 + this[++_] * 2 ** 16 + this[++_] * 2 ** 24, K = this[++_] + this[++_] * 256 + this[++_] * 2 ** 16 + F * 2 ** 24;
            return BigInt($) + (BigInt(K) << BigInt(32));
        }), a.prototype.readBigUInt64BE = ae(function(_) {
            _ = _ >>> 0, te(_, "offset");
            const S = this[_], F = this[_ + 7];
            (S === void 0 || F === void 0) && Z(_, this.length - 8);
            const $ = S * 2 ** 24 + this[++_] * 2 ** 16 + this[++_] * 256 + this[++_], K = this[++_] * 2 ** 24 + this[++_] * 2 ** 16 + this[++_] * 256 + F;
            return (BigInt($) << BigInt(32)) + BigInt(K);
        }), a.prototype.readIntLE = function(_, S, F) {
            _ = _ >>> 0, S = S >>> 0, F || G(_, S, this.length);
            let $ = this[_], K = 1, ee = 0;
            for(; ++ee < S && (K *= 256);)$ += this[_ + ee] * K;
            return K *= 128, $ >= K && ($ -= Math.pow(2, 8 * S)), $;
        }, a.prototype.readIntBE = function(_, S, F) {
            _ = _ >>> 0, S = S >>> 0, F || G(_, S, this.length);
            let $ = S, K = 1, ee = this[_ + --$];
            for(; $ > 0 && (K *= 256);)ee += this[_ + --$] * K;
            return K *= 128, ee >= K && (ee -= Math.pow(2, 8 * S)), ee;
        }, a.prototype.readInt8 = function(_, S) {
            return _ = _ >>> 0, S || G(_, 1, this.length), this[_] & 128 ? (255 - this[_] + 1) * -1 : this[_];
        }, a.prototype.readInt16LE = function(_, S) {
            _ = _ >>> 0, S || G(_, 2, this.length);
            const F = this[_] | this[_ + 1] << 8;
            return F & 32768 ? F | 4294901760 : F;
        }, a.prototype.readInt16BE = function(_, S) {
            _ = _ >>> 0, S || G(_, 2, this.length);
            const F = this[_ + 1] | this[_] << 8;
            return F & 32768 ? F | 4294901760 : F;
        }, a.prototype.readInt32LE = function(_, S) {
            return _ = _ >>> 0, S || G(_, 4, this.length), this[_] | this[_ + 1] << 8 | this[_ + 2] << 16 | this[_ + 3] << 24;
        }, a.prototype.readInt32BE = function(_, S) {
            return _ = _ >>> 0, S || G(_, 4, this.length), this[_] << 24 | this[_ + 1] << 16 | this[_ + 2] << 8 | this[_ + 3];
        }, a.prototype.readBigInt64LE = ae(function(_) {
            _ = _ >>> 0, te(_, "offset");
            const S = this[_], F = this[_ + 7];
            (S === void 0 || F === void 0) && Z(_, this.length - 8);
            const $ = this[_ + 4] + this[_ + 5] * 256 + this[_ + 6] * 2 ** 16 + (F << 24);
            return (BigInt($) << BigInt(32)) + BigInt(S + this[++_] * 256 + this[++_] * 2 ** 16 + this[++_] * 2 ** 24);
        }), a.prototype.readBigInt64BE = ae(function(_) {
            _ = _ >>> 0, te(_, "offset");
            const S = this[_], F = this[_ + 7];
            (S === void 0 || F === void 0) && Z(_, this.length - 8);
            const $ = (S << 24) + // Overflow
            this[++_] * 2 ** 16 + this[++_] * 256 + this[++_];
            return (BigInt($) << BigInt(32)) + BigInt(this[++_] * 2 ** 24 + this[++_] * 2 ** 16 + this[++_] * 256 + F);
        }), a.prototype.readFloatLE = function(_, S) {
            return _ = _ >>> 0, S || G(_, 4, this.length), r.read(this, _, !0, 23, 4);
        }, a.prototype.readFloatBE = function(_, S) {
            return _ = _ >>> 0, S || G(_, 4, this.length), r.read(this, _, !1, 23, 4);
        }, a.prototype.readDoubleLE = function(_, S) {
            return _ = _ >>> 0, S || G(_, 8, this.length), r.read(this, _, !0, 52, 8);
        }, a.prototype.readDoubleBE = function(_, S) {
            return _ = _ >>> 0, S || G(_, 8, this.length), r.read(this, _, !1, 52, 8);
        };
        function re(O, _, S, F, $, K) {
            if (!a.isBuffer(O)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (_ > $ || _ < K) throw new RangeError('"value" argument is out of bounds');
            if (S + F > O.length) throw new RangeError("Index out of range");
        }
        a.prototype.writeUintLE = a.prototype.writeUIntLE = function(_, S, F, $) {
            if (_ = +_, S = S >>> 0, F = F >>> 0, !$) {
                const de = Math.pow(2, 8 * F) - 1;
                re(this, _, S, F, de, 0);
            }
            let K = 1, ee = 0;
            for(this[S] = _ & 255; ++ee < F && (K *= 256);)this[S + ee] = _ / K & 255;
            return S + F;
        }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(_, S, F, $) {
            if (_ = +_, S = S >>> 0, F = F >>> 0, !$) {
                const de = Math.pow(2, 8 * F) - 1;
                re(this, _, S, F, de, 0);
            }
            let K = F - 1, ee = 1;
            for(this[S + K] = _ & 255; --K >= 0 && (ee *= 256);)this[S + K] = _ / ee & 255;
            return S + F;
        }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(_, S, F) {
            return _ = +_, S = S >>> 0, F || re(this, _, S, 1, 255, 0), this[S] = _ & 255, S + 1;
        }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(_, S, F) {
            return _ = +_, S = S >>> 0, F || re(this, _, S, 2, 65535, 0), this[S] = _ & 255, this[S + 1] = _ >>> 8, S + 2;
        }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(_, S, F) {
            return _ = +_, S = S >>> 0, F || re(this, _, S, 2, 65535, 0), this[S] = _ >>> 8, this[S + 1] = _ & 255, S + 2;
        }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(_, S, F) {
            return _ = +_, S = S >>> 0, F || re(this, _, S, 4, 4294967295, 0), this[S + 3] = _ >>> 24, this[S + 2] = _ >>> 16, this[S + 1] = _ >>> 8, this[S] = _ & 255, S + 4;
        }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(_, S, F) {
            return _ = +_, S = S >>> 0, F || re(this, _, S, 4, 4294967295, 0), this[S] = _ >>> 24, this[S + 1] = _ >>> 16, this[S + 2] = _ >>> 8, this[S + 3] = _ & 255, S + 4;
        };
        function oe(O, _, S, F, $) {
            De(_, F, $, O, S, 7);
            let K = Number(_ & BigInt(4294967295));
            O[S++] = K, K = K >> 8, O[S++] = K, K = K >> 8, O[S++] = K, K = K >> 8, O[S++] = K;
            let ee = Number(_ >> BigInt(32) & BigInt(4294967295));
            return O[S++] = ee, ee = ee >> 8, O[S++] = ee, ee = ee >> 8, O[S++] = ee, ee = ee >> 8, O[S++] = ee, S;
        }
        function ie(O, _, S, F, $) {
            De(_, F, $, O, S, 7);
            let K = Number(_ & BigInt(4294967295));
            O[S + 7] = K, K = K >> 8, O[S + 6] = K, K = K >> 8, O[S + 5] = K, K = K >> 8, O[S + 4] = K;
            let ee = Number(_ >> BigInt(32) & BigInt(4294967295));
            return O[S + 3] = ee, ee = ee >> 8, O[S + 2] = ee, ee = ee >> 8, O[S + 1] = ee, ee = ee >> 8, O[S] = ee, S + 8;
        }
        a.prototype.writeBigUInt64LE = ae(function(_, S = 0) {
            return oe(this, _, S, BigInt(0), BigInt("0xffffffffffffffff"));
        }), a.prototype.writeBigUInt64BE = ae(function(_, S = 0) {
            return ie(this, _, S, BigInt(0), BigInt("0xffffffffffffffff"));
        }), a.prototype.writeIntLE = function(_, S, F, $) {
            if (_ = +_, S = S >>> 0, !$) {
                const ge = Math.pow(2, 8 * F - 1);
                re(this, _, S, F, ge - 1, -ge);
            }
            let K = 0, ee = 1, de = 0;
            for(this[S] = _ & 255; ++K < F && (ee *= 256);)_ < 0 && de === 0 && this[S + K - 1] !== 0 && (de = 1), this[S + K] = (_ / ee >> 0) - de & 255;
            return S + F;
        }, a.prototype.writeIntBE = function(_, S, F, $) {
            if (_ = +_, S = S >>> 0, !$) {
                const ge = Math.pow(2, 8 * F - 1);
                re(this, _, S, F, ge - 1, -ge);
            }
            let K = F - 1, ee = 1, de = 0;
            for(this[S + K] = _ & 255; --K >= 0 && (ee *= 256);)_ < 0 && de === 0 && this[S + K + 1] !== 0 && (de = 1), this[S + K] = (_ / ee >> 0) - de & 255;
            return S + F;
        }, a.prototype.writeInt8 = function(_, S, F) {
            return _ = +_, S = S >>> 0, F || re(this, _, S, 1, 127, -128), _ < 0 && (_ = 255 + _ + 1), this[S] = _ & 255, S + 1;
        }, a.prototype.writeInt16LE = function(_, S, F) {
            return _ = +_, S = S >>> 0, F || re(this, _, S, 2, 32767, -32768), this[S] = _ & 255, this[S + 1] = _ >>> 8, S + 2;
        }, a.prototype.writeInt16BE = function(_, S, F) {
            return _ = +_, S = S >>> 0, F || re(this, _, S, 2, 32767, -32768), this[S] = _ >>> 8, this[S + 1] = _ & 255, S + 2;
        }, a.prototype.writeInt32LE = function(_, S, F) {
            return _ = +_, S = S >>> 0, F || re(this, _, S, 4, 2147483647, -2147483648), this[S] = _ & 255, this[S + 1] = _ >>> 8, this[S + 2] = _ >>> 16, this[S + 3] = _ >>> 24, S + 4;
        }, a.prototype.writeInt32BE = function(_, S, F) {
            return _ = +_, S = S >>> 0, F || re(this, _, S, 4, 2147483647, -2147483648), _ < 0 && (_ = 4294967295 + _ + 1), this[S] = _ >>> 24, this[S + 1] = _ >>> 16, this[S + 2] = _ >>> 8, this[S + 3] = _ & 255, S + 4;
        }, a.prototype.writeBigInt64LE = ae(function(_, S = 0) {
            return oe(this, _, S, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
        }), a.prototype.writeBigInt64BE = ae(function(_, S = 0) {
            return ie(this, _, S, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
        });
        function le(O, _, S, F, $, K) {
            if (S + F > O.length) throw new RangeError("Index out of range");
            if (S < 0) throw new RangeError("Index out of range");
        }
        function he(O, _, S, F, $) {
            return _ = +_, S = S >>> 0, $ || le(O, _, S, 4), r.write(O, _, S, F, 23, 4), S + 4;
        }
        a.prototype.writeFloatLE = function(_, S, F) {
            return he(this, _, S, !0, F);
        }, a.prototype.writeFloatBE = function(_, S, F) {
            return he(this, _, S, !1, F);
        };
        function ye(O, _, S, F, $) {
            return _ = +_, S = S >>> 0, $ || le(O, _, S, 8), r.write(O, _, S, F, 52, 8), S + 8;
        }
        a.prototype.writeDoubleLE = function(_, S, F) {
            return ye(this, _, S, !0, F);
        }, a.prototype.writeDoubleBE = function(_, S, F) {
            return ye(this, _, S, !1, F);
        }, a.prototype.copy = function(_, S, F, $) {
            if (!a.isBuffer(_)) throw new TypeError("argument should be a Buffer");
            if (F || (F = 0), !$ && $ !== 0 && ($ = this.length), S >= _.length && (S = _.length), S || (S = 0), $ > 0 && $ < F && ($ = F), $ === F || _.length === 0 || this.length === 0) return 0;
            if (S < 0) throw new RangeError("targetStart out of bounds");
            if (F < 0 || F >= this.length) throw new RangeError("Index out of range");
            if ($ < 0) throw new RangeError("sourceEnd out of bounds");
            $ > this.length && ($ = this.length), _.length - S < $ - F && ($ = _.length - S + F);
            const K = $ - F;
            return this === _ && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(S, F, $) : Uint8Array.prototype.set.call(_, this.subarray(F, $), S), K;
        }, a.prototype.fill = function(_, S, F, $) {
            if (typeof _ == "string") {
                if (typeof S == "string" ? ($ = S, S = 0, F = this.length) : typeof F == "string" && ($ = F, F = this.length), $ !== void 0 && typeof $ != "string") throw new TypeError("encoding must be a string");
                if (typeof $ == "string" && !a.isEncoding($)) throw new TypeError("Unknown encoding: " + $);
                if (_.length === 1) {
                    const ee = _.charCodeAt(0);
                    ($ === "utf8" && ee < 128 || $ === "latin1") && (_ = ee);
                }
            } else typeof _ == "number" ? _ = _ & 255 : typeof _ == "boolean" && (_ = Number(_));
            if (S < 0 || this.length < S || this.length < F) throw new RangeError("Out of range index");
            if (F <= S) return this;
            S = S >>> 0, F = F === void 0 ? this.length : F >>> 0, _ || (_ = 0);
            let K;
            if (typeof _ == "number") for(K = S; K < F; ++K)this[K] = _;
            else {
                const ee = a.isBuffer(_) ? _ : a.from(_, $), de = ee.length;
                if (de === 0) throw new TypeError('The value "' + _ + '" is invalid for argument "value"');
                for(K = 0; K < F - S; ++K)this[K + S] = ee[K % de];
            }
            return this;
        };
        const be = {};
        function we(O, _, S) {
            be[O] = class extends S {
                constructor(){
                    super(), Object.defineProperty(this, "message", {
                        value: _.apply(this, arguments),
                        writable: !0,
                        configurable: !0
                    }), this.name = `${this.name} [${O}]`, this.stack, delete this.name;
                }
                get code() {
                    return O;
                }
                set code($) {
                    Object.defineProperty(this, "code", {
                        configurable: !0,
                        enumerable: !0,
                        value: $,
                        writable: !0
                    });
                }
                toString() {
                    return `${this.name} [${O}]: ${this.message}`;
                }
            };
        }
        we("ERR_BUFFER_OUT_OF_BOUNDS", function(O) {
            return O ? `${O} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
        }, RangeError), we("ERR_INVALID_ARG_TYPE", function(O, _) {
            return `The "${O}" argument must be of type number. Received type ${typeof _}`;
        }, TypeError), we("ERR_OUT_OF_RANGE", function(O, _, S) {
            let F = `The value of "${O}" is out of range.`, $ = S;
            return Number.isInteger(S) && Math.abs(S) > 2 ** 32 ? $ = ve(String(S)) : typeof S == "bigint" && ($ = String(S), (S > BigInt(2) ** BigInt(32) || S < -(BigInt(2) ** BigInt(32))) && ($ = ve($)), $ += "n"), F += ` It must be ${_}. Received ${$}`, F;
        }, RangeError);
        function ve(O) {
            let _ = "", S = O.length;
            const F = O[0] === "-" ? 1 : 0;
            for(; S >= F + 4; S -= 3)_ = `_${O.slice(S - 3, S)}${_}`;
            return `${O.slice(0, S)}${_}`;
        }
        function Re(O, _, S) {
            te(_, "offset"), (O[_] === void 0 || O[_ + S] === void 0) && Z(_, O.length - (S + 1));
        }
        function De(O, _, S, F, $, K) {
            if (O > S || O < _) {
                const ee = typeof _ == "bigint" ? "n" : "";
                let de;
                throw _ === 0 || _ === BigInt(0) ? de = `>= 0${ee} and < 2${ee} ** ${(K + 1) * 8}${ee}` : de = `>= -(2${ee} ** ${(K + 1) * 8 - 1}${ee}) and < 2 ** ${(K + 1) * 8 - 1}${ee}`, new be.ERR_OUT_OF_RANGE("value", de, O);
            }
            Re(F, $, K);
        }
        function te(O, _) {
            if (typeof O != "number") throw new be.ERR_INVALID_ARG_TYPE(_, "number", O);
        }
        function Z(O, _, S) {
            throw Math.floor(O) !== O ? (te(O, S), new be.ERR_OUT_OF_RANGE("offset", "an integer", O)) : _ < 0 ? new be.ERR_BUFFER_OUT_OF_BOUNDS() : new be.ERR_OUT_OF_RANGE("offset", `>= 0 and <= ${_}`, O);
        }
        const ue = /[^+/0-9A-Za-z-_]/g;
        function pe(O) {
            if (O = O.split("=")[0], O = O.trim().replace(ue, ""), O.length < 2) return "";
            for(; O.length % 4 !== 0;)O = O + "=";
            return O;
        }
        function me(O, _) {
            _ = _ || 1 / 0;
            let S;
            const F = O.length;
            let $ = null;
            const K = [];
            for(let ee = 0; ee < F; ++ee){
                if (S = O.charCodeAt(ee), S > 55295 && S < 57344) {
                    if (!$) {
                        if (S > 56319) {
                            (_ -= 3) > -1 && K.push(239, 191, 189);
                            continue;
                        } else if (ee + 1 === F) {
                            (_ -= 3) > -1 && K.push(239, 191, 189);
                            continue;
                        }
                        $ = S;
                        continue;
                    }
                    if (S < 56320) {
                        (_ -= 3) > -1 && K.push(239, 191, 189), $ = S;
                        continue;
                    }
                    S = ($ - 55296 << 10 | S - 56320) + 65536;
                } else $ && (_ -= 3) > -1 && K.push(239, 191, 189);
                if ($ = null, S < 128) {
                    if ((_ -= 1) < 0) break;
                    K.push(S);
                } else if (S < 2048) {
                    if ((_ -= 2) < 0) break;
                    K.push(S >> 6 | 192, S & 63 | 128);
                } else if (S < 65536) {
                    if ((_ -= 3) < 0) break;
                    K.push(S >> 12 | 224, S >> 6 & 63 | 128, S & 63 | 128);
                } else if (S < 1114112) {
                    if ((_ -= 4) < 0) break;
                    K.push(S >> 18 | 240, S >> 12 & 63 | 128, S >> 6 & 63 | 128, S & 63 | 128);
                } else throw new Error("Invalid code point");
            }
            return K;
        }
        function L(O) {
            const _ = [];
            for(let S = 0; S < O.length; ++S)_.push(O.charCodeAt(S) & 255);
            return _;
        }
        function B(O, _) {
            let S, F, $;
            const K = [];
            for(let ee = 0; ee < O.length && !((_ -= 2) < 0); ++ee)S = O.charCodeAt(ee), F = S >> 8, $ = S % 256, K.push($), K.push(F);
            return K;
        }
        function D(O) {
            return t.toByteArray(pe(O));
        }
        function E(O, _, S, F) {
            let $;
            for($ = 0; $ < F && !($ + S >= _.length || $ >= O.length); ++$)_[$ + S] = O[$];
            return $;
        }
        function T(O, _) {
            return O instanceof _ || O != null && O.constructor != null && O.constructor.name != null && O.constructor.name === _.name;
        }
        function j(O) {
            return O !== O;
        }
        const Y = function() {
            const O = "0123456789abcdef", _ = new Array(256);
            for(let S = 0; S < 16; ++S){
                const F = S * 16;
                for(let $ = 0; $ < 16; ++$)_[F + $] = O[S] + O[$];
            }
            return _;
        }();
        function ae(O) {
            return typeof BigInt > "u" ? se : O;
        }
        function se() {
            throw new Error("BigInt not supported");
        }
    }($914aec8743edd630$var$Ts)), $914aec8743edd630$var$Ts;
}
function $914aec8743edd630$var$En(e) {
    throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $914aec8743edd630$var$Cs = {
    exports: {}
}, $914aec8743edd630$var$Zp;
function $914aec8743edd630$var$Pg() {
    return $914aec8743edd630$var$Zp || ($914aec8743edd630$var$Zp = 1, function(e, t) {
        (function(r) {
            e.exports = r();
        })(function() {
            return /* @__PURE__ */ (function() {
                function r(i, n, o) {
                    function s(l, c) {
                        if (!n[l]) {
                            if (!i[l]) {
                                var d = typeof $914aec8743edd630$var$En == "function" && $914aec8743edd630$var$En;
                                if (!c && d) return d(l, !0);
                                if (a) return a(l, !0);
                                var h = new Error("Cannot find module '" + l + "'");
                                throw h.code = "MODULE_NOT_FOUND", h;
                            }
                            var f = n[l] = {
                                exports: {}
                            };
                            i[l][0].call(f.exports, function(p) {
                                var m = i[l][1][p];
                                return s(m || p);
                            }, f, f.exports, r, i, n, o);
                        }
                        return n[l].exports;
                    }
                    for(var a = typeof $914aec8743edd630$var$En == "function" && $914aec8743edd630$var$En, u = 0; u < o.length; u++)s(o[u]);
                    return s;
                }
                return r;
            })()({
                1: [
                    function(r, i, n) {
                        var o = this && this.__awaiter || function(d, h, f, p) {
                            function m(w) {
                                return w instanceof f ? w : new f(function(v) {
                                    v(w);
                                });
                            }
                            return new (f || (f = Promise))(function(w, v) {
                                function g(k) {
                                    try {
                                        b(p.next(k));
                                    } catch (y) {
                                        v(y);
                                    }
                                }
                                function A(k) {
                                    try {
                                        b(p.throw(k));
                                    } catch (y) {
                                        v(y);
                                    }
                                }
                                function b(k) {
                                    k.done ? w(k.value) : m(k.value).then(g, A);
                                }
                                b((p = p.apply(d, h || [])).next());
                            });
                        }, s = this && this.__generator || function(d, h) {
                            var f = {
                                label: 0,
                                sent: function() {
                                    if (w[0] & 1) throw w[1];
                                    return w[1];
                                },
                                trys: [],
                                ops: []
                            }, p, m, w, v;
                            return v = {
                                next: g(0),
                                throw: g(1),
                                return: g(2)
                            }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
                                return this;
                            }), v;
                            function g(b) {
                                return function(k) {
                                    return A([
                                        b,
                                        k
                                    ]);
                                };
                            }
                            function A(b) {
                                if (p) throw new TypeError("Generator is already executing.");
                                for(; v && (v = 0, b[0] && (f = 0)), f;)try {
                                    if (p = 1, m && (w = b[0] & 2 ? m.return : b[0] ? m.throw || ((w = m.return) && w.call(m), 0) : m.next) && !(w = w.call(m, b[1])).done) return w;
                                    switch(m = 0, w && (b = [
                                        b[0] & 2,
                                        w.value
                                    ]), b[0]){
                                        case 0:
                                        case 1:
                                            w = b;
                                            break;
                                        case 4:
                                            return f.label++, {
                                                value: b[1],
                                                done: !1
                                            };
                                        case 5:
                                            f.label++, m = b[1], b = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            b = f.ops.pop(), f.trys.pop();
                                            continue;
                                        default:
                                            if (w = f.trys, !(w = w.length > 0 && w[w.length - 1]) && (b[0] === 6 || b[0] === 2)) {
                                                f = 0;
                                                continue;
                                            }
                                            if (b[0] === 3 && (!w || b[1] > w[0] && b[1] < w[3])) {
                                                f.label = b[1];
                                                break;
                                            }
                                            if (b[0] === 6 && f.label < w[1]) {
                                                f.label = w[1], w = b;
                                                break;
                                            }
                                            if (w && f.label < w[2]) {
                                                f.label = w[2], f.ops.push(b);
                                                break;
                                            }
                                            w[2] && f.ops.pop(), f.trys.pop();
                                            continue;
                                    }
                                    b = h.call(d, f);
                                } catch (k) {
                                    b = [
                                        6,
                                        k
                                    ], m = 0;
                                } finally{
                                    p = w = 0;
                                }
                                if (b[0] & 5) throw b[1];
                                return {
                                    value: b[0] ? b[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.PayloadAssembler = void 0;
                        var a = r("../subscribableStream"), u = r("../payloads"), l = r("../contentStream"), c = /** @class */ function() {
                            function d(h, f) {
                                if (this.streamManager = h, this._byteOrderMark = 65279, this._utf = "utf8", f.header ? (this.id = f.header.id, this.payloadType = f.header.payloadType, this.contentLength = f.header.payloadLength, this.end = f.header.end) : this.id = f.id, !this.id) throw Error("An ID must be supplied when creating an assembler.");
                                this._onCompleted = f.onCompleted;
                            }
                            return d.prototype.getPayloadStream = function() {
                                return this.stream || (this.stream = this.createPayloadStream()), this.stream;
                            }, d.prototype.onReceive = function(h, f, p) {
                                this.end = h.end, h.payloadType === u.PayloadTypes.response || h.payloadType === u.PayloadTypes.request ? this.process(f).then().catch() : h.end && f.end();
                            }, d.prototype.close = function() {
                                this.streamManager.closeStream(this.id);
                            }, d.prototype.createPayloadStream = function() {
                                return new a.SubscribableStream();
                            }, d.prototype.payloadFromJson = function(h) {
                                return JSON.parse(h.charCodeAt(0) === this._byteOrderMark ? h.slice(1) : h);
                            }, d.prototype.stripBOM = function(h) {
                                return h.charCodeAt(0) === this._byteOrderMark ? h.slice(1) : h;
                            }, d.prototype.process = function(h) {
                                return o(this, void 0, void 0, function() {
                                    var f, p;
                                    return s(this, function(m) {
                                        switch(m.label){
                                            case 0:
                                                return f = h.read(h.length), f ? (p = f.toString(this._utf), this.payloadType !== u.PayloadTypes.request ? [
                                                    3,
                                                    2
                                                ] : [
                                                    4,
                                                    this.processRequest(p)
                                                ]) : [
                                                    2
                                                ];
                                            case 1:
                                                return m.sent(), [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                return this.payloadType !== u.PayloadTypes.response ? [
                                                    3,
                                                    4
                                                ] : [
                                                    4,
                                                    this.processResponse(p)
                                                ];
                                            case 3:
                                                m.sent(), m.label = 4;
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, d.prototype.processResponse = function(h) {
                                return o(this, void 0, void 0, function() {
                                    var f, p;
                                    return s(this, function(m) {
                                        switch(m.label){
                                            case 0:
                                                return f = this.payloadFromJson(this.stripBOM(h)), p = {
                                                    streams: [],
                                                    statusCode: f.statusCode
                                                }, [
                                                    4,
                                                    this.processStreams(f, p)
                                                ];
                                            case 1:
                                                return m.sent(), [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, d.prototype.processRequest = function(h) {
                                return o(this, void 0, void 0, function() {
                                    var f, p;
                                    return s(this, function(m) {
                                        switch(m.label){
                                            case 0:
                                                return f = this.payloadFromJson(h), p = {
                                                    streams: [],
                                                    path: f.path,
                                                    verb: f.verb
                                                }, [
                                                    4,
                                                    this.processStreams(f, p)
                                                ];
                                            case 1:
                                                return m.sent(), [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, d.prototype.processStreams = function(h, f) {
                                var p;
                                return o(this, void 0, void 0, function() {
                                    var m = this;
                                    return s(this, function(w) {
                                        switch(w.label){
                                            case 0:
                                                return (p = h.streams) === null || p === void 0 || p.forEach(function(v) {
                                                    var g, A = (g = v.type) !== null && g !== void 0 ? g : v.contentType, b = m.streamManager.getPayloadAssembler(v.id);
                                                    b.payloadType = A, b.contentLength = v.length, f.streams.push(new l.ContentStream(v.id, b));
                                                }), [
                                                    4,
                                                    this._onCompleted(this.id, f)
                                                ];
                                            case 1:
                                                return w.sent(), [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, d;
                        }();
                        n.PayloadAssembler = c;
                    },
                    {
                        "../contentStream": 2,
                        "../payloads": 16,
                        "../subscribableStream": 27
                    }
                ],
                2: [
                    function(r, i, n) {
                        var o = this && this.__awaiter || function(u, l, c, d) {
                            function h(f) {
                                return f instanceof c ? f : new c(function(p) {
                                    p(f);
                                });
                            }
                            return new (c || (c = Promise))(function(f, p) {
                                function m(g) {
                                    try {
                                        v(d.next(g));
                                    } catch (A) {
                                        p(A);
                                    }
                                }
                                function w(g) {
                                    try {
                                        v(d.throw(g));
                                    } catch (A) {
                                        p(A);
                                    }
                                }
                                function v(g) {
                                    g.done ? f(g.value) : h(g.value).then(m, w);
                                }
                                v((d = d.apply(u, l || [])).next());
                            });
                        }, s = this && this.__generator || function(u, l) {
                            var c = {
                                label: 0,
                                sent: function() {
                                    if (f[0] & 1) throw f[1];
                                    return f[1];
                                },
                                trys: [],
                                ops: []
                            }, d, h, f, p;
                            return p = {
                                next: m(0),
                                throw: m(1),
                                return: m(2)
                            }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
                                return this;
                            }), p;
                            function m(v) {
                                return function(g) {
                                    return w([
                                        v,
                                        g
                                    ]);
                                };
                            }
                            function w(v) {
                                if (d) throw new TypeError("Generator is already executing.");
                                for(; p && (p = 0, v[0] && (c = 0)), c;)try {
                                    if (d = 1, h && (f = v[0] & 2 ? h.return : v[0] ? h.throw || ((f = h.return) && f.call(h), 0) : h.next) && !(f = f.call(h, v[1])).done) return f;
                                    switch(h = 0, f && (v = [
                                        v[0] & 2,
                                        f.value
                                    ]), v[0]){
                                        case 0:
                                        case 1:
                                            f = v;
                                            break;
                                        case 4:
                                            return c.label++, {
                                                value: v[1],
                                                done: !1
                                            };
                                        case 5:
                                            c.label++, h = v[1], v = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            v = c.ops.pop(), c.trys.pop();
                                            continue;
                                        default:
                                            if (f = c.trys, !(f = f.length > 0 && f[f.length - 1]) && (v[0] === 6 || v[0] === 2)) {
                                                c = 0;
                                                continue;
                                            }
                                            if (v[0] === 3 && (!f || v[1] > f[0] && v[1] < f[3])) {
                                                c.label = v[1];
                                                break;
                                            }
                                            if (v[0] === 6 && c.label < f[1]) {
                                                c.label = f[1], f = v;
                                                break;
                                            }
                                            if (f && c.label < f[2]) {
                                                c.label = f[2], c.ops.push(v);
                                                break;
                                            }
                                            f[2] && c.ops.pop(), c.trys.pop();
                                            continue;
                                    }
                                    v = l.call(u, c);
                                } catch (g) {
                                    v = [
                                        6,
                                        g
                                    ], h = 0;
                                } finally{
                                    d = f = 0;
                                }
                                if (v[0] & 5) throw v[1];
                                return {
                                    value: v[0] ? v[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.ContentStream = void 0;
                        var a = /** @class */ function() {
                            function u(l, c) {
                                if (!c) throw Error("Null Argument Exception");
                                this.id = l, this.assembler = c;
                            }
                            return Object.defineProperty(u.prototype, "contentType", {
                                /**
               * Gets the name of the type of the object contained within this [ContentStream](xref:botframework-streaming.ContentStream).
               *
               * @returns The [PayloadType](xref:botframework-streaming.PayloadType) of this [ContentStream](xref:botframework-streaming.ContentStream).
               */ get: function() {
                                    return this.assembler.payloadType;
                                },
                                enumerable: !1,
                                configurable: !0
                            }), Object.defineProperty(u.prototype, "length", {
                                /**
               * Gets the length of this [ContentStream](xref:botframework-streaming.ContentStream).
               *
               * @returns A number representing the length of this [ContentStream](xref:botframework-streaming.ContentStream).
               */ get: function() {
                                    return this.assembler.contentLength;
                                },
                                enumerable: !1,
                                configurable: !0
                            }), u.prototype.getStream = function() {
                                return this.stream || (this.stream = this.assembler.getPayloadStream()), this.stream;
                            }, u.prototype.cancel = function() {
                                this.assembler.close();
                            }, u.prototype.readAsString = function() {
                                return o(this, void 0, void 0, function() {
                                    var l;
                                    return s(this, function(c) {
                                        switch(c.label){
                                            case 0:
                                                return [
                                                    4,
                                                    this.readAll()
                                                ];
                                            case 1:
                                                return l = c.sent().bufferArray, [
                                                    2,
                                                    (l || []).map(function(d) {
                                                        return d.toString("utf8");
                                                    }).join("")
                                                ];
                                        }
                                    });
                                });
                            }, u.prototype.readAsJson = function() {
                                return o(this, void 0, void 0, function() {
                                    var l;
                                    return s(this, function(c) {
                                        switch(c.label){
                                            case 0:
                                                return [
                                                    4,
                                                    this.readAsString()
                                                ];
                                            case 1:
                                                return l = c.sent(), [
                                                    2,
                                                    JSON.parse(l)
                                                ];
                                        }
                                    });
                                });
                            }, u.prototype.readAll = function() {
                                return o(this, void 0, void 0, function() {
                                    var l, c, d, h, f, p = this;
                                    return s(this, function(m) {
                                        switch(m.label){
                                            case 0:
                                                for(l = [], c = 0, d = this.getStream(); c < d.length;)h = d.read(d.length), l.push(h), c += h.length;
                                                return c < this.length ? (f = new Promise(function(w) {
                                                    var v = function(g) {
                                                        return function(A) {
                                                            l.push(A), c += A.length, c === g.length && w(!0);
                                                        };
                                                    };
                                                    d.subscribe(v(p));
                                                }), [
                                                    4,
                                                    f
                                                ]) : [
                                                    3,
                                                    2
                                                ];
                                            case 1:
                                                m.sent(), m.label = 2;
                                            case 2:
                                                return [
                                                    2,
                                                    {
                                                        bufferArray: l,
                                                        size: c
                                                    }
                                                ];
                                        }
                                    });
                                });
                            }, u;
                        }();
                        n.ContentStream = a;
                    },
                    {}
                ],
                3: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.CancelDisassembler = void 0;
                        var o = /** @class */ function() {
                            function s(a, u, l) {
                                this.sender = a, this.id = u, this.payloadType = l;
                            }
                            return s.prototype.disassemble = function() {
                                var a = {
                                    payloadType: this.payloadType,
                                    payloadLength: 0,
                                    id: this.id,
                                    end: !0
                                };
                                this.sender.sendPayload(a);
                            }, s;
                        }();
                        n.CancelDisassembler = o;
                    },
                    {}
                ],
                4: [
                    function(r, i, n) {
                        var o = this && this.__extends || /* @__PURE__ */ function() {
                            var d = function(h, f) {
                                return d = Object.setPrototypeOf || ({
                                    __proto__: []
                                }) instanceof Array && function(p, m) {
                                    p.__proto__ = m;
                                } || function(p, m) {
                                    for(var w in m)Object.prototype.hasOwnProperty.call(m, w) && (p[w] = m[w]);
                                }, d(h, f);
                            };
                            return function(h, f) {
                                if (typeof f != "function" && f !== null) throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
                                d(h, f);
                                function p() {
                                    this.constructor = h;
                                }
                                h.prototype = f === null ? Object.create(f) : (p.prototype = f.prototype, new p());
                            };
                        }(), s = this && this.__awaiter || function(d, h, f, p) {
                            function m(w) {
                                return w instanceof f ? w : new f(function(v) {
                                    v(w);
                                });
                            }
                            return new (f || (f = Promise))(function(w, v) {
                                function g(k) {
                                    try {
                                        b(p.next(k));
                                    } catch (y) {
                                        v(y);
                                    }
                                }
                                function A(k) {
                                    try {
                                        b(p.throw(k));
                                    } catch (y) {
                                        v(y);
                                    }
                                }
                                function b(k) {
                                    k.done ? w(k.value) : m(k.value).then(g, A);
                                }
                                b((p = p.apply(d, h || [])).next());
                            });
                        }, a = this && this.__generator || function(d, h) {
                            var f = {
                                label: 0,
                                sent: function() {
                                    if (w[0] & 1) throw w[1];
                                    return w[1];
                                },
                                trys: [],
                                ops: []
                            }, p, m, w, v;
                            return v = {
                                next: g(0),
                                throw: g(1),
                                return: g(2)
                            }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
                                return this;
                            }), v;
                            function g(b) {
                                return function(k) {
                                    return A([
                                        b,
                                        k
                                    ]);
                                };
                            }
                            function A(b) {
                                if (p) throw new TypeError("Generator is already executing.");
                                for(; v && (v = 0, b[0] && (f = 0)), f;)try {
                                    if (p = 1, m && (w = b[0] & 2 ? m.return : b[0] ? m.throw || ((w = m.return) && w.call(m), 0) : m.next) && !(w = w.call(m, b[1])).done) return w;
                                    switch(m = 0, w && (b = [
                                        b[0] & 2,
                                        w.value
                                    ]), b[0]){
                                        case 0:
                                        case 1:
                                            w = b;
                                            break;
                                        case 4:
                                            return f.label++, {
                                                value: b[1],
                                                done: !1
                                            };
                                        case 5:
                                            f.label++, m = b[1], b = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            b = f.ops.pop(), f.trys.pop();
                                            continue;
                                        default:
                                            if (w = f.trys, !(w = w.length > 0 && w[w.length - 1]) && (b[0] === 6 || b[0] === 2)) {
                                                f = 0;
                                                continue;
                                            }
                                            if (b[0] === 3 && (!w || b[1] > w[0] && b[1] < w[3])) {
                                                f.label = b[1];
                                                break;
                                            }
                                            if (b[0] === 6 && f.label < w[1]) {
                                                f.label = w[1], w = b;
                                                break;
                                            }
                                            if (w && f.label < w[2]) {
                                                f.label = w[2], f.ops.push(b);
                                                break;
                                            }
                                            w[2] && f.ops.pop(), f.trys.pop();
                                            continue;
                                    }
                                    b = h.call(d, f);
                                } catch (k) {
                                    b = [
                                        6,
                                        k
                                    ], m = 0;
                                } finally{
                                    p = w = 0;
                                }
                                if (b[0] & 5) throw b[1];
                                return {
                                    value: b[0] ? b[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.HttpContentStreamDisassembler = void 0;
                        var u = r("./payloadDisassembler"), l = r("../payloads"), c = /** @class */ function(d) {
                            o(h, d);
                            function h(f, p) {
                                var m = d.call(this, f, p.id) || this;
                                return m.payloadType = l.PayloadTypes.stream, m.contentStream = p, m;
                            }
                            return h.prototype.getStream = function() {
                                return s(this, void 0, void 0, function() {
                                    var f;
                                    return a(this, function(p) {
                                        return f = this.contentStream.content.getStream(), [
                                            2,
                                            {
                                                stream: f,
                                                streamLength: f.length
                                            }
                                        ];
                                    });
                                });
                            }, h;
                        }(u.PayloadDisassembler);
                        n.HttpContentStreamDisassembler = c;
                    },
                    {
                        "../payloads": 16,
                        "./payloadDisassembler": 5
                    }
                ],
                5: [
                    function(r, i, n) {
                        var o = this && this.__awaiter || function(l, c, d, h) {
                            function f(p) {
                                return p instanceof d ? p : new d(function(m) {
                                    m(p);
                                });
                            }
                            return new (d || (d = Promise))(function(p, m) {
                                function w(A) {
                                    try {
                                        g(h.next(A));
                                    } catch (b) {
                                        m(b);
                                    }
                                }
                                function v(A) {
                                    try {
                                        g(h.throw(A));
                                    } catch (b) {
                                        m(b);
                                    }
                                }
                                function g(A) {
                                    A.done ? p(A.value) : f(A.value).then(w, v);
                                }
                                g((h = h.apply(l, c || [])).next());
                            });
                        }, s = this && this.__generator || function(l, c) {
                            var d = {
                                label: 0,
                                sent: function() {
                                    if (p[0] & 1) throw p[1];
                                    return p[1];
                                },
                                trys: [],
                                ops: []
                            }, h, f, p, m;
                            return m = {
                                next: w(0),
                                throw: w(1),
                                return: w(2)
                            }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
                                return this;
                            }), m;
                            function w(g) {
                                return function(A) {
                                    return v([
                                        g,
                                        A
                                    ]);
                                };
                            }
                            function v(g) {
                                if (h) throw new TypeError("Generator is already executing.");
                                for(; m && (m = 0, g[0] && (d = 0)), d;)try {
                                    if (h = 1, f && (p = g[0] & 2 ? f.return : g[0] ? f.throw || ((p = f.return) && p.call(f), 0) : f.next) && !(p = p.call(f, g[1])).done) return p;
                                    switch(f = 0, p && (g = [
                                        g[0] & 2,
                                        p.value
                                    ]), g[0]){
                                        case 0:
                                        case 1:
                                            p = g;
                                            break;
                                        case 4:
                                            return d.label++, {
                                                value: g[1],
                                                done: !1
                                            };
                                        case 5:
                                            d.label++, f = g[1], g = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            g = d.ops.pop(), d.trys.pop();
                                            continue;
                                        default:
                                            if (p = d.trys, !(p = p.length > 0 && p[p.length - 1]) && (g[0] === 6 || g[0] === 2)) {
                                                d = 0;
                                                continue;
                                            }
                                            if (g[0] === 3 && (!p || g[1] > p[0] && g[1] < p[3])) {
                                                d.label = g[1];
                                                break;
                                            }
                                            if (g[0] === 6 && d.label < p[1]) {
                                                d.label = p[1], p = g;
                                                break;
                                            }
                                            if (p && d.label < p[2]) {
                                                d.label = p[2], d.ops.push(g);
                                                break;
                                            }
                                            p[2] && d.ops.pop(), d.trys.pop();
                                            continue;
                                    }
                                    g = c.call(l, d);
                                } catch (A) {
                                    g = [
                                        6,
                                        A
                                    ], f = 0;
                                } finally{
                                    h = p = 0;
                                }
                                if (g[0] & 5) throw g[1];
                                return {
                                    value: g[0] ? g[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.PayloadDisassembler = void 0;
                        var a = r("../subscribableStream"), u = /** @class */ function() {
                            function l(c, d) {
                                this.sender = c, this.id = d;
                            }
                            return l.serialize = function(c) {
                                var d = new a.SubscribableStream();
                                return d.write(JSON.stringify(c)), d.end(), {
                                    stream: d,
                                    streamLength: d.length
                                };
                            }, l.prototype.disassemble = function() {
                                return o(this, void 0, void 0, function() {
                                    var c, d, h;
                                    return s(this, function(f) {
                                        switch(f.label){
                                            case 0:
                                                return [
                                                    4,
                                                    this.getStream()
                                                ];
                                            case 1:
                                                return c = f.sent(), d = c.stream, h = c.streamLength, this.stream = d, this.streamLength = h, [
                                                    2,
                                                    this.send()
                                                ];
                                        }
                                    });
                                });
                            }, l.prototype.send = function() {
                                return o(this, void 0, void 0, function() {
                                    var c;
                                    return s(this, function(d) {
                                        return c = {
                                            payloadType: this.payloadType,
                                            payloadLength: this.streamLength,
                                            id: this.id,
                                            end: !0
                                        }, this.sender.sendPayload(c, this.stream), [
                                            2
                                        ];
                                    });
                                });
                            }, l;
                        }();
                        n.PayloadDisassembler = u;
                    },
                    {
                        "../subscribableStream": 27
                    }
                ],
                6: [
                    function(r, i, n) {
                        var o = this && this.__extends || /* @__PURE__ */ function() {
                            var d = function(h, f) {
                                return d = Object.setPrototypeOf || ({
                                    __proto__: []
                                }) instanceof Array && function(p, m) {
                                    p.__proto__ = m;
                                } || function(p, m) {
                                    for(var w in m)Object.prototype.hasOwnProperty.call(m, w) && (p[w] = m[w]);
                                }, d(h, f);
                            };
                            return function(h, f) {
                                if (typeof f != "function" && f !== null) throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
                                d(h, f);
                                function p() {
                                    this.constructor = h;
                                }
                                h.prototype = f === null ? Object.create(f) : (p.prototype = f.prototype, new p());
                            };
                        }(), s = this && this.__awaiter || function(d, h, f, p) {
                            function m(w) {
                                return w instanceof f ? w : new f(function(v) {
                                    v(w);
                                });
                            }
                            return new (f || (f = Promise))(function(w, v) {
                                function g(k) {
                                    try {
                                        b(p.next(k));
                                    } catch (y) {
                                        v(y);
                                    }
                                }
                                function A(k) {
                                    try {
                                        b(p.throw(k));
                                    } catch (y) {
                                        v(y);
                                    }
                                }
                                function b(k) {
                                    k.done ? w(k.value) : m(k.value).then(g, A);
                                }
                                b((p = p.apply(d, h || [])).next());
                            });
                        }, a = this && this.__generator || function(d, h) {
                            var f = {
                                label: 0,
                                sent: function() {
                                    if (w[0] & 1) throw w[1];
                                    return w[1];
                                },
                                trys: [],
                                ops: []
                            }, p, m, w, v;
                            return v = {
                                next: g(0),
                                throw: g(1),
                                return: g(2)
                            }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
                                return this;
                            }), v;
                            function g(b) {
                                return function(k) {
                                    return A([
                                        b,
                                        k
                                    ]);
                                };
                            }
                            function A(b) {
                                if (p) throw new TypeError("Generator is already executing.");
                                for(; v && (v = 0, b[0] && (f = 0)), f;)try {
                                    if (p = 1, m && (w = b[0] & 2 ? m.return : b[0] ? m.throw || ((w = m.return) && w.call(m), 0) : m.next) && !(w = w.call(m, b[1])).done) return w;
                                    switch(m = 0, w && (b = [
                                        b[0] & 2,
                                        w.value
                                    ]), b[0]){
                                        case 0:
                                        case 1:
                                            w = b;
                                            break;
                                        case 4:
                                            return f.label++, {
                                                value: b[1],
                                                done: !1
                                            };
                                        case 5:
                                            f.label++, m = b[1], b = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            b = f.ops.pop(), f.trys.pop();
                                            continue;
                                        default:
                                            if (w = f.trys, !(w = w.length > 0 && w[w.length - 1]) && (b[0] === 6 || b[0] === 2)) {
                                                f = 0;
                                                continue;
                                            }
                                            if (b[0] === 3 && (!w || b[1] > w[0] && b[1] < w[3])) {
                                                f.label = b[1];
                                                break;
                                            }
                                            if (b[0] === 6 && f.label < w[1]) {
                                                f.label = w[1], w = b;
                                                break;
                                            }
                                            if (w && f.label < w[2]) {
                                                f.label = w[2], f.ops.push(b);
                                                break;
                                            }
                                            w[2] && f.ops.pop(), f.trys.pop();
                                            continue;
                                    }
                                    b = h.call(d, f);
                                } catch (k) {
                                    b = [
                                        6,
                                        k
                                    ], m = 0;
                                } finally{
                                    p = w = 0;
                                }
                                if (b[0] & 5) throw b[1];
                                return {
                                    value: b[0] ? b[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.RequestDisassembler = void 0;
                        var u = r("../payloads/payloadTypes"), l = r("./payloadDisassembler"), c = /** @class */ function(d) {
                            o(h, d);
                            function h(f, p, m) {
                                var w = d.call(this, f, p) || this;
                                return w.request = m, w.payloadType = u.PayloadTypes.request, w;
                            }
                            return h.prototype.getStream = function() {
                                var f, p, m, w;
                                return s(this, void 0, void 0, function() {
                                    var v;
                                    return a(this, function(g) {
                                        return v = {
                                            verb: (f = this.request) === null || f === void 0 ? void 0 : f.verb,
                                            path: (p = this.request) === null || p === void 0 ? void 0 : p.path,
                                            streams: []
                                        }, (w = (m = this.request) === null || m === void 0 ? void 0 : m.streams) === null || w === void 0 || w.forEach(function(A) {
                                            v.streams.push(A.description);
                                        }), [
                                            2,
                                            l.PayloadDisassembler.serialize(v)
                                        ];
                                    });
                                });
                            }, h;
                        }(l.PayloadDisassembler);
                        n.RequestDisassembler = c;
                    },
                    {
                        "../payloads/payloadTypes": 19,
                        "./payloadDisassembler": 5
                    }
                ],
                7: [
                    function(r, i, n) {
                        var o = this && this.__extends || /* @__PURE__ */ function() {
                            var d = function(h, f) {
                                return d = Object.setPrototypeOf || ({
                                    __proto__: []
                                }) instanceof Array && function(p, m) {
                                    p.__proto__ = m;
                                } || function(p, m) {
                                    for(var w in m)Object.prototype.hasOwnProperty.call(m, w) && (p[w] = m[w]);
                                }, d(h, f);
                            };
                            return function(h, f) {
                                if (typeof f != "function" && f !== null) throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
                                d(h, f);
                                function p() {
                                    this.constructor = h;
                                }
                                h.prototype = f === null ? Object.create(f) : (p.prototype = f.prototype, new p());
                            };
                        }(), s = this && this.__awaiter || function(d, h, f, p) {
                            function m(w) {
                                return w instanceof f ? w : new f(function(v) {
                                    v(w);
                                });
                            }
                            return new (f || (f = Promise))(function(w, v) {
                                function g(k) {
                                    try {
                                        b(p.next(k));
                                    } catch (y) {
                                        v(y);
                                    }
                                }
                                function A(k) {
                                    try {
                                        b(p.throw(k));
                                    } catch (y) {
                                        v(y);
                                    }
                                }
                                function b(k) {
                                    k.done ? w(k.value) : m(k.value).then(g, A);
                                }
                                b((p = p.apply(d, h || [])).next());
                            });
                        }, a = this && this.__generator || function(d, h) {
                            var f = {
                                label: 0,
                                sent: function() {
                                    if (w[0] & 1) throw w[1];
                                    return w[1];
                                },
                                trys: [],
                                ops: []
                            }, p, m, w, v;
                            return v = {
                                next: g(0),
                                throw: g(1),
                                return: g(2)
                            }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
                                return this;
                            }), v;
                            function g(b) {
                                return function(k) {
                                    return A([
                                        b,
                                        k
                                    ]);
                                };
                            }
                            function A(b) {
                                if (p) throw new TypeError("Generator is already executing.");
                                for(; v && (v = 0, b[0] && (f = 0)), f;)try {
                                    if (p = 1, m && (w = b[0] & 2 ? m.return : b[0] ? m.throw || ((w = m.return) && w.call(m), 0) : m.next) && !(w = w.call(m, b[1])).done) return w;
                                    switch(m = 0, w && (b = [
                                        b[0] & 2,
                                        w.value
                                    ]), b[0]){
                                        case 0:
                                        case 1:
                                            w = b;
                                            break;
                                        case 4:
                                            return f.label++, {
                                                value: b[1],
                                                done: !1
                                            };
                                        case 5:
                                            f.label++, m = b[1], b = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            b = f.ops.pop(), f.trys.pop();
                                            continue;
                                        default:
                                            if (w = f.trys, !(w = w.length > 0 && w[w.length - 1]) && (b[0] === 6 || b[0] === 2)) {
                                                f = 0;
                                                continue;
                                            }
                                            if (b[0] === 3 && (!w || b[1] > w[0] && b[1] < w[3])) {
                                                f.label = b[1];
                                                break;
                                            }
                                            if (b[0] === 6 && f.label < w[1]) {
                                                f.label = w[1], w = b;
                                                break;
                                            }
                                            if (w && f.label < w[2]) {
                                                f.label = w[2], f.ops.push(b);
                                                break;
                                            }
                                            w[2] && f.ops.pop(), f.trys.pop();
                                            continue;
                                    }
                                    b = h.call(d, f);
                                } catch (k) {
                                    b = [
                                        6,
                                        k
                                    ], m = 0;
                                } finally{
                                    p = w = 0;
                                }
                                if (b[0] & 5) throw b[1];
                                return {
                                    value: b[0] ? b[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.ResponseDisassembler = void 0;
                        var u = r("../payloads/payloadTypes"), l = r("./payloadDisassembler"), c = /** @class */ function(d) {
                            o(h, d);
                            function h(f, p, m) {
                                var w = d.call(this, f, p) || this;
                                return w.payloadType = u.PayloadTypes.response, w.response = m, w;
                            }
                            return h.prototype.getStream = function() {
                                var f;
                                return s(this, void 0, void 0, function() {
                                    var p;
                                    return a(this, function(m) {
                                        return p = {
                                            statusCode: this.response.statusCode,
                                            streams: []
                                        }, (f = this.response.streams) === null || f === void 0 || f.forEach(function(w) {
                                            var v = w.description;
                                            p.streams.push({
                                                id: v.id,
                                                contentType: v.type,
                                                length: v.length
                                            });
                                        }), [
                                            2,
                                            l.PayloadDisassembler.serialize(p)
                                        ];
                                    });
                                });
                            }, h;
                        }(l.PayloadDisassembler);
                        n.ResponseDisassembler = c;
                    },
                    {
                        "../payloads/payloadTypes": 19,
                        "./payloadDisassembler": 5
                    }
                ],
                8: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.HttpContent = n.HttpContentStream = void 0;
                        var o = r("./utilities/protocol-base"), s = /** @class */ /* @__PURE__ */ function() {
                            function u(l) {
                                var c, d, h, f, p, m;
                                this.content = l, this.id = (0, o.generateGuid)(), this.description = {
                                    id: this.id,
                                    type: (h = (d = (c = this.content) === null || c === void 0 ? void 0 : c.headers) === null || d === void 0 ? void 0 : d.type) !== null && h !== void 0 ? h : "unknown",
                                    length: (m = (p = (f = this.content) === null || f === void 0 ? void 0 : f.headers) === null || p === void 0 ? void 0 : p.contentLength) !== null && m !== void 0 ? m : 0
                                };
                            }
                            return u;
                        }();
                        n.HttpContentStream = s;
                        var a = /** @class */ function() {
                            function u(l, c) {
                                this.headers = l, this.stream = c;
                            }
                            return u.prototype.getStream = function() {
                                return this.stream;
                            }, u;
                        }();
                        n.HttpContent = a;
                    },
                    {
                        "./utilities/protocol-base": 28
                    }
                ],
                9: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.WebSocketClient = n.BrowserWebSocket = n.SubscribableStream = n.StreamingResponse = n.StreamingRequest = n.RequestHandler = n.HttpContent = n.ContentStream = void 0;
                        var o = r("./contentStream");
                        Object.defineProperty(n, "ContentStream", {
                            enumerable: !0,
                            get: function() {
                                return o.ContentStream;
                            }
                        });
                        var s = r("./httpContentStream");
                        Object.defineProperty(n, "HttpContent", {
                            enumerable: !0,
                            get: function() {
                                return s.HttpContent;
                            }
                        });
                        var a = r("./requestHandler");
                        Object.defineProperty(n, "RequestHandler", {
                            enumerable: !0,
                            get: function() {
                                return a.RequestHandler;
                            }
                        });
                        var u = r("./streamingRequest");
                        Object.defineProperty(n, "StreamingRequest", {
                            enumerable: !0,
                            get: function() {
                                return u.StreamingRequest;
                            }
                        });
                        var l = r("./streamingResponse");
                        Object.defineProperty(n, "StreamingResponse", {
                            enumerable: !0,
                            get: function() {
                                return l.StreamingResponse;
                            }
                        });
                        var c = r("./subscribableStream");
                        Object.defineProperty(n, "SubscribableStream", {
                            enumerable: !0,
                            get: function() {
                                return c.SubscribableStream;
                            }
                        });
                        var d = r("./webSocket/index-browser");
                        Object.defineProperty(n, "BrowserWebSocket", {
                            enumerable: !0,
                            get: function() {
                                return d.BrowserWebSocket;
                            }
                        }), Object.defineProperty(n, "WebSocketClient", {
                            enumerable: !0,
                            get: function() {
                                return d.WebSocketClient;
                            }
                        });
                    },
                    {
                        "./contentStream": 2,
                        "./httpContentStream": 8,
                        "./requestHandler": 24,
                        "./streamingRequest": 25,
                        "./streamingResponse": 26,
                        "./subscribableStream": 27,
                        "./webSocket/index-browser": 31
                    }
                ],
                10: [
                    function(r, i, n) {
                        var o = this && this.__createBinding || (Object.create ? function(a, u, l, c) {
                            c === void 0 && (c = l);
                            var d = Object.getOwnPropertyDescriptor(u, l);
                            (!d || ("get" in d ? !u.__esModule : d.writable || d.configurable)) && (d = {
                                enumerable: !0,
                                get: function() {
                                    return u[l];
                                }
                            }), Object.defineProperty(a, c, d);
                        } : function(a, u, l, c) {
                            c === void 0 && (c = l), a[c] = u[l];
                        }), s = this && this.__exportStar || function(a, u) {
                            for(var l in a)l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && o(u, a, l);
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), s(r("./payloadReceiver"), n), s(r("./payloadSender"), n), s(r("./transportDisconnectedEvent"), n), s(r("./transportDisconnectedEventHandler"), n);
                    },
                    {
                        "./payloadReceiver": 11,
                        "./payloadSender": 12,
                        "./transportDisconnectedEvent": 13,
                        "./transportDisconnectedEventHandler": 14
                    }
                ],
                11: [
                    function(r, i, n) {
                        var o = this && this.__awaiter || function(h, f, p, m) {
                            function w(v) {
                                return v instanceof p ? v : new p(function(g) {
                                    g(v);
                                });
                            }
                            return new (p || (p = Promise))(function(v, g) {
                                function A(y) {
                                    try {
                                        k(m.next(y));
                                    } catch (x) {
                                        g(x);
                                    }
                                }
                                function b(y) {
                                    try {
                                        k(m.throw(y));
                                    } catch (x) {
                                        g(x);
                                    }
                                }
                                function k(y) {
                                    y.done ? v(y.value) : w(y.value).then(A, b);
                                }
                                k((m = m.apply(h, f || [])).next());
                            });
                        }, s = this && this.__generator || function(h, f) {
                            var p = {
                                label: 0,
                                sent: function() {
                                    if (v[0] & 1) throw v[1];
                                    return v[1];
                                },
                                trys: [],
                                ops: []
                            }, m, w, v, g;
                            return g = {
                                next: A(0),
                                throw: A(1),
                                return: A(2)
                            }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
                                return this;
                            }), g;
                            function A(k) {
                                return function(y) {
                                    return b([
                                        k,
                                        y
                                    ]);
                                };
                            }
                            function b(k) {
                                if (m) throw new TypeError("Generator is already executing.");
                                for(; g && (g = 0, k[0] && (p = 0)), p;)try {
                                    if (m = 1, w && (v = k[0] & 2 ? w.return : k[0] ? w.throw || ((v = w.return) && v.call(w), 0) : w.next) && !(v = v.call(w, k[1])).done) return v;
                                    switch(w = 0, v && (k = [
                                        k[0] & 2,
                                        v.value
                                    ]), k[0]){
                                        case 0:
                                        case 1:
                                            v = k;
                                            break;
                                        case 4:
                                            return p.label++, {
                                                value: k[1],
                                                done: !1
                                            };
                                        case 5:
                                            p.label++, w = k[1], k = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            k = p.ops.pop(), p.trys.pop();
                                            continue;
                                        default:
                                            if (v = p.trys, !(v = v.length > 0 && v[v.length - 1]) && (k[0] === 6 || k[0] === 2)) {
                                                p = 0;
                                                continue;
                                            }
                                            if (k[0] === 3 && (!v || k[1] > v[0] && k[1] < v[3])) {
                                                p.label = k[1];
                                                break;
                                            }
                                            if (k[0] === 6 && p.label < v[1]) {
                                                p.label = v[1], v = k;
                                                break;
                                            }
                                            if (v && p.label < v[2]) {
                                                p.label = v[2], p.ops.push(k);
                                                break;
                                            }
                                            v[2] && p.ops.pop(), p.trys.pop();
                                            continue;
                                    }
                                    k = f.call(h, p);
                                } catch (y) {
                                    k = [
                                        6,
                                        y
                                    ], w = 0;
                                } finally{
                                    m = v = 0;
                                }
                                if (k[0] & 5) throw k[1];
                                return {
                                    value: k[0] ? k[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.PayloadReceiver = void 0;
                        var a = r("../payloads/payloadTypes"), u = r("../payloads/headerSerializer"), l = r("../payloads/payloadConstants"), c = r("./transportDisconnectedEvent"), d = /** @class */ function() {
                            function h() {}
                            return Object.defineProperty(h.prototype, "isConnected", {
                                /**
               * Get current connected state
               *
               * @returns true if connected to a transport sender.
               */ get: function() {
                                    return this._receiver != null;
                                },
                                enumerable: !1,
                                configurable: !0
                            }), h.prototype.connect = function(f) {
                                return this._receiver = f, this.receivePackets();
                            }, h.prototype.subscribe = function(f, p) {
                                this._getStream = f, this._receiveAction = p;
                            }, h.prototype.disconnect = function(f) {
                                var p, m;
                                if (f === void 0 && (f = c.TransportDisconnectedEvent.Empty), !!this.isConnected) try {
                                    this._receiver.close(), (p = this.disconnected) === null || p === void 0 || p.call(this, this, f);
                                } catch (w) {
                                    (m = this.disconnected) === null || m === void 0 || m.call(this, this, new c.TransportDisconnectedEvent(w.message));
                                } finally{
                                    this._receiver = null;
                                }
                            }, h.prototype.receivePackets = function() {
                                return o(this, void 0, void 0, function() {
                                    var f, p, m, w, v, g, A, b, k;
                                    return s(this, function(y) {
                                        switch(y.label){
                                            case 0:
                                                if (!this.isConnected) return [
                                                    3,
                                                    11
                                                ];
                                                y.label = 1;
                                            case 1:
                                                y.trys.push([
                                                    1,
                                                    9,
                                                    ,
                                                    10
                                                ]), f = 0, y.label = 2;
                                            case 2:
                                                return f < l.PayloadConstants.MaxHeaderLength ? (p = this, [
                                                    4,
                                                    this._receiver.receive(l.PayloadConstants.MaxHeaderLength - f)
                                                ]) : [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                return p._receiveHeaderBuffer = y.sent(), this._receiveHeaderBuffer && (f += this._receiveHeaderBuffer.length), [
                                                    3,
                                                    2
                                                ];
                                            case 4:
                                                if (m = u.HeaderSerializer.deserialize(this._receiveHeaderBuffer), w = m.payloadType === a.PayloadTypes.stream, !(m.payloadLength > 0)) return [
                                                    3,
                                                    8
                                                ];
                                                v = 0, g = this._getStream(m), y.label = 5;
                                            case 5:
                                                return v < m.payloadLength && v < l.PayloadConstants.MaxPayloadLength ? (A = Math.min(m.payloadLength - v, l.PayloadConstants.MaxPayloadLength), b = this, [
                                                    4,
                                                    this._receiver.receive(A)
                                                ]) : [
                                                    3,
                                                    7
                                                ];
                                            case 6:
                                                return b._receivePayloadBuffer = y.sent(), v += this._receivePayloadBuffer.byteLength, g.write(this._receivePayloadBuffer), w && this._receiveAction(m, g, v), [
                                                    3,
                                                    5
                                                ];
                                            case 7:
                                                w || this._receiveAction(m, g, v), y.label = 8;
                                            case 8:
                                                return [
                                                    3,
                                                    10
                                                ];
                                            case 9:
                                                return k = y.sent(), this.disconnect(new c.TransportDisconnectedEvent(k.message)), [
                                                    3,
                                                    10
                                                ];
                                            case 10:
                                                return [
                                                    3,
                                                    0
                                                ];
                                            case 11:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, h;
                        }();
                        n.PayloadReceiver = d;
                    },
                    {
                        "../payloads/headerSerializer": 15,
                        "../payloads/payloadConstants": 18,
                        "../payloads/payloadTypes": 19,
                        "./transportDisconnectedEvent": 13
                    }
                ],
                12: [
                    function(r, i, n) {
                        (function(o) {
                            (function() {
                                Object.defineProperty(n, "__esModule", {
                                    value: !0
                                }), n.PayloadSender = void 0;
                                var s = r("../payloads/headerSerializer"), a = r("../payloads/payloadConstants"), u = r("./transportDisconnectedEvent"), l = /** @class */ function() {
                                    function c() {}
                                    return Object.defineProperty(c.prototype, "isConnected", {
                                        /**
                   * Get current connected state
                   *
                   * @returns true if connected to a transport sender.
                   */ get: function() {
                                            return this._sender != null;
                                        },
                                        enumerable: !1,
                                        configurable: !0
                                    }), c.prototype.connect = function(d) {
                                        this._sender = d;
                                    }, c.prototype.sendPayload = function(d, h, f) {
                                        var p = {
                                            header: d,
                                            payload: h,
                                            sentCallback: f
                                        };
                                        this.writePacket(p);
                                    }, c.prototype.disconnect = function(d) {
                                        var h, f;
                                        if (d === void 0 && (d = u.TransportDisconnectedEvent.Empty), !!this.isConnected) try {
                                            this._sender.close(), (h = this.disconnected) === null || h === void 0 || h.call(this, this, d);
                                        } catch (p) {
                                            (f = this.disconnected) === null || f === void 0 || f.call(this, this, new u.TransportDisconnectedEvent(p.message));
                                        } finally{
                                            this._sender = null;
                                        }
                                    }, c.prototype.writePacket = function(d) {
                                        try {
                                            if (d.header.payloadLength > 0 && d.payload) {
                                                for(var h = d.header.payloadLength; h > 0;){
                                                    var f = h <= a.PayloadConstants.MaxPayloadLength ? h : a.PayloadConstants.MaxPayloadLength, p = d.payload.read(f), m = d.header;
                                                    m.payloadLength = f, m.end = h <= a.PayloadConstants.MaxPayloadLength;
                                                    var w = o.alloc(a.PayloadConstants.MaxHeaderLength);
                                                    s.HeaderSerializer.serialize(m, w), this._sender.send(w), this._sender.send(p), h -= p.length;
                                                }
                                                d.sentCallback && d.sentCallback();
                                            }
                                        } catch (v) {
                                            this.disconnect(new u.TransportDisconnectedEvent(v.message));
                                        }
                                    }, c;
                                }();
                                n.PayloadSender = l;
                            }).call(this);
                        }).call(this, r("buffer").Buffer);
                    },
                    {
                        "../payloads/headerSerializer": 15,
                        "../payloads/payloadConstants": 18,
                        "./transportDisconnectedEvent": 13,
                        buffer: 35
                    }
                ],
                13: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.TransportDisconnectedEvent = void 0;
                        var o = /** @class */ function() {
                            function s(a) {
                                this.reason = a;
                            }
                            return s.Empty = new s(), s;
                        }();
                        n.TransportDisconnectedEvent = o;
                    },
                    {}
                ],
                14: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        });
                    },
                    {}
                ],
                15: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.HeaderSerializer = void 0;
                        var o = r("./payloadConstants"), s = /** @class */ function() {
                            function a() {}
                            return a.serialize = function(u, l) {
                                l.write(u.payloadType, this.TypeOffset, 1, this.Encoding), l.write(this.Delimiter, this.TypeDelimiterOffset, 1, this.Encoding), l.write(this.headerLengthPadder(u.payloadLength, this.LengthLength, "0"), this.LengthOffset, this.LengthLength, this.Encoding), l.write(this.Delimiter, this.LengthDelimeterOffset, 1, this.Encoding), l.write(u.id, this.IdOffset), l.write(this.Delimiter, this.IdDelimeterOffset, 1, this.Encoding), l.write(u.end ? this.End : this.NotEnd, this.EndOffset), l.write(this.Terminator, this.TerminatorOffset);
                            }, a.deserialize = function(u) {
                                var l = u.toString(this.Encoding), c = l.split(this.Delimiter);
                                if (c.length !== 4) throw Error("Cannot parse header, header is malformed. Header: ".concat(l));
                                var d = c[0], h = c[1], f = c[2], p = c[3], m = p === `1
`, w = Number(h), v = {
                                    end: m,
                                    payloadLength: w,
                                    payloadType: d,
                                    id: f
                                };
                                if (!(v.payloadLength <= o.PayloadConstants.MaxPayloadLength && v.payloadLength >= o.PayloadConstants.MinLength)) throw Error("Header length of ".concat(v.payloadLength, " is missing or malformed"));
                                if (v.payloadType.length !== this.TypeDelimiterOffset) throw Error("Header type '".concat(v.payloadType.length, "' is missing or malformed."));
                                if (!v.id || !v.id.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i) || v.id.length !== this.IdLength) throw Error("Header ID '".concat(v.id, "' is missing or malformed."));
                                if (!(p === `0
` || p === `1
`)) throw Error("Header End is missing or not a valid value. Header end: '".concat(p, "'"));
                                return v;
                            }, a.headerLengthPadder = function(u, l, c) {
                                var d = Array(l + 1).join(c), h = u.toString();
                                return (d + h).slice(h.length);
                            }, a.Delimiter = ".", a.Terminator = `
`, a.End = "1", a.NotEnd = "0", a.TypeOffset = 0, a.TypeDelimiterOffset = 1, a.LengthOffset = 2, a.LengthLength = 6, a.LengthDelimeterOffset = 8, a.IdOffset = 9, a.IdLength = 36, a.IdDelimeterOffset = 45, a.EndOffset = 46, a.TerminatorOffset = 47, a.Encoding = "utf8", a;
                        }();
                        n.HeaderSerializer = s;
                    },
                    {
                        "./payloadConstants": 18
                    }
                ],
                16: [
                    function(r, i, n) {
                        var o = this && this.__createBinding || (Object.create ? function(a, u, l, c) {
                            c === void 0 && (c = l);
                            var d = Object.getOwnPropertyDescriptor(u, l);
                            (!d || ("get" in d ? !u.__esModule : d.writable || d.configurable)) && (d = {
                                enumerable: !0,
                                get: function() {
                                    return u[l];
                                }
                            }), Object.defineProperty(a, c, d);
                        } : function(a, u, l, c) {
                            c === void 0 && (c = l), a[c] = u[l];
                        }), s = this && this.__exportStar || function(a, u) {
                            for(var l in a)l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && o(u, a, l);
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), s(r("./headerSerializer"), n), s(r("./streamManager"), n), s(r("./payloadAssemblerManager"), n), s(r("./payloadTypes"), n), s(r("./requestManager"), n), s(r("./sendOperations"), n), s(r("./streamManager"), n);
                    },
                    {
                        "./headerSerializer": 15,
                        "./payloadAssemblerManager": 17,
                        "./payloadTypes": 19,
                        "./requestManager": 20,
                        "./sendOperations": 21,
                        "./streamManager": 22
                    }
                ],
                17: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.PayloadAssemblerManager = void 0;
                        var o = r("../assemblers/payloadAssembler"), s = r("./payloadTypes"), a = /** @class */ function() {
                            function u(l, c, d) {
                                this.streamManager = l, this.onReceiveResponse = c, this.onReceiveRequest = d, this.activeAssemblers = {};
                            }
                            return u.prototype.getPayloadStream = function(l) {
                                if (l.payloadType === s.PayloadTypes.stream) return this.streamManager.getPayloadStream(l);
                                if (!this.activeAssemblers[l.id]) {
                                    var c = this.createPayloadAssembler(l);
                                    if (c) return this.activeAssemblers[l.id] = c, c.getPayloadStream();
                                }
                            }, u.prototype.onReceive = function(l, c, d) {
                                if (l.payloadType === s.PayloadTypes.stream) this.streamManager.onReceive(l, c, d);
                                else {
                                    if (this.activeAssemblers && this.activeAssemblers[l.id]) {
                                        var h = this.activeAssemblers[l.id];
                                        h.onReceive(l, c, d);
                                    }
                                    l.end && delete this.activeAssemblers[l.id];
                                }
                            }, u.prototype.createPayloadAssembler = function(l) {
                                if (l.payloadType === s.PayloadTypes.request) return new o.PayloadAssembler(this.streamManager, {
                                    header: l,
                                    onCompleted: this.onReceiveRequest
                                });
                                if (l.payloadType === s.PayloadTypes.response) return new o.PayloadAssembler(this.streamManager, {
                                    header: l,
                                    onCompleted: this.onReceiveResponse
                                });
                            }, u;
                        }();
                        n.PayloadAssemblerManager = a;
                    },
                    {
                        "../assemblers/payloadAssembler": 1,
                        "./payloadTypes": 19
                    }
                ],
                18: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.PayloadConstants = void 0, function(o) {
                            o[o.MaxPayloadLength = 4096] = "MaxPayloadLength", o[o.MaxHeaderLength = 48] = "MaxHeaderLength", o[o.MaxLength = 999999] = "MaxLength", o[o.MinLength = 0] = "MinLength";
                        }(n.PayloadConstants || (n.PayloadConstants = {}));
                    },
                    {}
                ],
                19: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.PayloadTypes = void 0, function(o) {
                            o.request = "A", o.response = "B", o.stream = "S", o.cancelAll = "X", o.cancelStream = "C";
                        }(n.PayloadTypes || (n.PayloadTypes = {}));
                    },
                    {}
                ],
                20: [
                    function(r, i, n) {
                        var o = this && this.__awaiter || function(l, c, d, h) {
                            function f(p) {
                                return p instanceof d ? p : new d(function(m) {
                                    m(p);
                                });
                            }
                            return new (d || (d = Promise))(function(p, m) {
                                function w(A) {
                                    try {
                                        g(h.next(A));
                                    } catch (b) {
                                        m(b);
                                    }
                                }
                                function v(A) {
                                    try {
                                        g(h.throw(A));
                                    } catch (b) {
                                        m(b);
                                    }
                                }
                                function g(A) {
                                    A.done ? p(A.value) : f(A.value).then(w, v);
                                }
                                g((h = h.apply(l, c || [])).next());
                            });
                        }, s = this && this.__generator || function(l, c) {
                            var d = {
                                label: 0,
                                sent: function() {
                                    if (p[0] & 1) throw p[1];
                                    return p[1];
                                },
                                trys: [],
                                ops: []
                            }, h, f, p, m;
                            return m = {
                                next: w(0),
                                throw: w(1),
                                return: w(2)
                            }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
                                return this;
                            }), m;
                            function w(g) {
                                return function(A) {
                                    return v([
                                        g,
                                        A
                                    ]);
                                };
                            }
                            function v(g) {
                                if (h) throw new TypeError("Generator is already executing.");
                                for(; m && (m = 0, g[0] && (d = 0)), d;)try {
                                    if (h = 1, f && (p = g[0] & 2 ? f.return : g[0] ? f.throw || ((p = f.return) && p.call(f), 0) : f.next) && !(p = p.call(f, g[1])).done) return p;
                                    switch(f = 0, p && (g = [
                                        g[0] & 2,
                                        p.value
                                    ]), g[0]){
                                        case 0:
                                        case 1:
                                            p = g;
                                            break;
                                        case 4:
                                            return d.label++, {
                                                value: g[1],
                                                done: !1
                                            };
                                        case 5:
                                            d.label++, f = g[1], g = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            g = d.ops.pop(), d.trys.pop();
                                            continue;
                                        default:
                                            if (p = d.trys, !(p = p.length > 0 && p[p.length - 1]) && (g[0] === 6 || g[0] === 2)) {
                                                d = 0;
                                                continue;
                                            }
                                            if (g[0] === 3 && (!p || g[1] > p[0] && g[1] < p[3])) {
                                                d.label = g[1];
                                                break;
                                            }
                                            if (g[0] === 6 && d.label < p[1]) {
                                                d.label = p[1], p = g;
                                                break;
                                            }
                                            if (p && d.label < p[2]) {
                                                d.label = p[2], d.ops.push(g);
                                                break;
                                            }
                                            p[2] && d.ops.pop(), d.trys.pop();
                                            continue;
                                    }
                                    g = c.call(l, d);
                                } catch (A) {
                                    g = [
                                        6,
                                        A
                                    ], f = 0;
                                } finally{
                                    h = p = 0;
                                }
                                if (g[0] & 5) throw g[1];
                                return {
                                    value: g[0] ? g[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.RequestManager = void 0;
                        var a = /** @class */ /* @__PURE__ */ function() {
                            function l() {}
                            return l;
                        }(), u = /** @class */ function() {
                            function l() {
                                this._pendingRequests = {};
                            }
                            return l.prototype.pendingRequestCount = function() {
                                return Object.keys(this._pendingRequests).length;
                            }, l.prototype.signalResponse = function(c, d) {
                                return o(this, void 0, void 0, function() {
                                    var h;
                                    return s(this, function(f) {
                                        return h = this._pendingRequests[c], h ? (h.resolve(d), delete this._pendingRequests[c], [
                                            2,
                                            !0
                                        ]) : [
                                            2,
                                            !1
                                        ];
                                    });
                                });
                            }, l.prototype.getResponse = function(c) {
                                var d = this._pendingRequests[c];
                                if (d) return Promise.reject("requestId '".concat(c, "' already exists in RequestManager"));
                                d = new a(), d.requestId = c;
                                var h = new Promise(function(f, p) {
                                    d.resolve = f, d.reject = p;
                                });
                                return this._pendingRequests[c] = d, h;
                            }, l.prototype.rejectAllResponses = function(c) {
                                var d = this;
                                Object.entries(this._pendingRequests).forEach(function(h) {
                                    var f = h[0], p = h[1].reject;
                                    p(c), delete d._pendingRequests[f];
                                });
                            }, l;
                        }();
                        n.RequestManager = u;
                    },
                    {}
                ],
                21: [
                    function(r, i, n) {
                        var o = this && this.__awaiter || function(f, p, m, w) {
                            function v(g) {
                                return g instanceof m ? g : new m(function(A) {
                                    A(g);
                                });
                            }
                            return new (m || (m = Promise))(function(g, A) {
                                function b(x) {
                                    try {
                                        y(w.next(x));
                                    } catch (C) {
                                        A(C);
                                    }
                                }
                                function k(x) {
                                    try {
                                        y(w.throw(x));
                                    } catch (C) {
                                        A(C);
                                    }
                                }
                                function y(x) {
                                    x.done ? g(x.value) : v(x.value).then(b, k);
                                }
                                y((w = w.apply(f, p || [])).next());
                            });
                        }, s = this && this.__generator || function(f, p) {
                            var m = {
                                label: 0,
                                sent: function() {
                                    if (g[0] & 1) throw g[1];
                                    return g[1];
                                },
                                trys: [],
                                ops: []
                            }, w, v, g, A;
                            return A = {
                                next: b(0),
                                throw: b(1),
                                return: b(2)
                            }, typeof Symbol == "function" && (A[Symbol.iterator] = function() {
                                return this;
                            }), A;
                            function b(y) {
                                return function(x) {
                                    return k([
                                        y,
                                        x
                                    ]);
                                };
                            }
                            function k(y) {
                                if (w) throw new TypeError("Generator is already executing.");
                                for(; A && (A = 0, y[0] && (m = 0)), m;)try {
                                    if (w = 1, v && (g = y[0] & 2 ? v.return : y[0] ? v.throw || ((g = v.return) && g.call(v), 0) : v.next) && !(g = g.call(v, y[1])).done) return g;
                                    switch(v = 0, g && (y = [
                                        y[0] & 2,
                                        g.value
                                    ]), y[0]){
                                        case 0:
                                        case 1:
                                            g = y;
                                            break;
                                        case 4:
                                            return m.label++, {
                                                value: y[1],
                                                done: !1
                                            };
                                        case 5:
                                            m.label++, v = y[1], y = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            y = m.ops.pop(), m.trys.pop();
                                            continue;
                                        default:
                                            if (g = m.trys, !(g = g.length > 0 && g[g.length - 1]) && (y[0] === 6 || y[0] === 2)) {
                                                m = 0;
                                                continue;
                                            }
                                            if (y[0] === 3 && (!g || y[1] > g[0] && y[1] < g[3])) {
                                                m.label = y[1];
                                                break;
                                            }
                                            if (y[0] === 6 && m.label < g[1]) {
                                                m.label = g[1], g = y;
                                                break;
                                            }
                                            if (g && m.label < g[2]) {
                                                m.label = g[2], m.ops.push(y);
                                                break;
                                            }
                                            g[2] && m.ops.pop(), m.trys.pop();
                                            continue;
                                    }
                                    y = p.call(f, m);
                                } catch (x) {
                                    y = [
                                        6,
                                        x
                                    ], v = 0;
                                } finally{
                                    w = g = 0;
                                }
                                if (y[0] & 5) throw y[1];
                                return {
                                    value: y[0] ? y[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.SendOperations = void 0;
                        var a = r("../disassemblers/cancelDisassembler"), u = r("../disassemblers/httpContentStreamDisassembler"), l = r("../disassemblers/requestDisassembler"), c = r("../disassemblers/responseDisassembler"), d = r("./payloadTypes"), h = /** @class */ function() {
                            function f(p) {
                                this.payloadSender = p;
                            }
                            return f.prototype.sendRequest = function(p, m) {
                                return o(this, void 0, void 0, function() {
                                    var w, v = this;
                                    return s(this, function(g) {
                                        switch(g.label){
                                            case 0:
                                                return w = new l.RequestDisassembler(this.payloadSender, p, m), [
                                                    4,
                                                    w.disassemble()
                                                ];
                                            case 1:
                                                return g.sent(), m.streams && m.streams.forEach(function(A) {
                                                    return o(v, void 0, void 0, function() {
                                                        return s(this, function(b) {
                                                            switch(b.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        new u.HttpContentStreamDisassembler(this.payloadSender, A).disassemble()
                                                                    ];
                                                                case 1:
                                                                    return b.sent(), [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                }), [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, f.prototype.sendResponse = function(p, m) {
                                return o(this, void 0, void 0, function() {
                                    var w, v = this;
                                    return s(this, function(g) {
                                        switch(g.label){
                                            case 0:
                                                return w = new c.ResponseDisassembler(this.payloadSender, p, m), [
                                                    4,
                                                    w.disassemble()
                                                ];
                                            case 1:
                                                return g.sent(), m.streams && m.streams.forEach(function(A) {
                                                    return o(v, void 0, void 0, function() {
                                                        return s(this, function(b) {
                                                            switch(b.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        new u.HttpContentStreamDisassembler(this.payloadSender, A).disassemble()
                                                                    ];
                                                                case 1:
                                                                    return b.sent(), [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                }), [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, f.prototype.sendCancelStream = function(p) {
                                return o(this, void 0, void 0, function() {
                                    var m;
                                    return s(this, function(w) {
                                        return m = new a.CancelDisassembler(this.payloadSender, p, d.PayloadTypes.cancelStream), m.disassemble(), [
                                            2
                                        ];
                                    });
                                });
                            }, f;
                        }();
                        n.SendOperations = h;
                    },
                    {
                        "../disassemblers/cancelDisassembler": 3,
                        "../disassemblers/httpContentStreamDisassembler": 4,
                        "../disassemblers/requestDisassembler": 6,
                        "../disassemblers/responseDisassembler": 7,
                        "./payloadTypes": 19
                    }
                ],
                22: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.StreamManager = void 0;
                        var o = r("../assemblers/payloadAssembler"), s = /** @class */ function() {
                            function a(u) {
                                this.onCancelStream = u, this.activeAssemblers = [];
                            }
                            return a.prototype.getPayloadAssembler = function(u) {
                                if (this.activeAssemblers[u]) return this.activeAssemblers[u];
                                var l = new o.PayloadAssembler(this, {
                                    id: u
                                });
                                return this.activeAssemblers[u] = l, l;
                            }, a.prototype.getPayloadStream = function(u) {
                                var l = this.getPayloadAssembler(u.id);
                                return l.getPayloadStream();
                            }, a.prototype.onReceive = function(u, l, c) {
                                this.activeAssemblers[u.id] && this.activeAssemblers[u.id].onReceive(u, l, c);
                            }, a.prototype.closeStream = function(u) {
                                if (this.activeAssemblers[u]) {
                                    var l = this.activeAssemblers[u];
                                    this.activeAssemblers.splice(this.activeAssemblers.indexOf(u), 1);
                                    var c = l.getPayloadStream();
                                    (l.contentLength && c.length < l.contentLength || !l.end) && this.onCancelStream(l);
                                } else return;
                            }, a;
                        }();
                        n.StreamManager = s;
                    },
                    {
                        "../assemblers/payloadAssembler": 1
                    }
                ],
                23: [
                    function(r, i, n) {
                        var o = this && this.__awaiter || function(h, f, p, m) {
                            function w(v) {
                                return v instanceof p ? v : new p(function(g) {
                                    g(v);
                                });
                            }
                            return new (p || (p = Promise))(function(v, g) {
                                function A(y) {
                                    try {
                                        k(m.next(y));
                                    } catch (x) {
                                        g(x);
                                    }
                                }
                                function b(y) {
                                    try {
                                        k(m.throw(y));
                                    } catch (x) {
                                        g(x);
                                    }
                                }
                                function k(y) {
                                    y.done ? v(y.value) : w(y.value).then(A, b);
                                }
                                k((m = m.apply(h, f || [])).next());
                            });
                        }, s = this && this.__generator || function(h, f) {
                            var p = {
                                label: 0,
                                sent: function() {
                                    if (v[0] & 1) throw v[1];
                                    return v[1];
                                },
                                trys: [],
                                ops: []
                            }, m, w, v, g;
                            return g = {
                                next: A(0),
                                throw: A(1),
                                return: A(2)
                            }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
                                return this;
                            }), g;
                            function A(k) {
                                return function(y) {
                                    return b([
                                        k,
                                        y
                                    ]);
                                };
                            }
                            function b(k) {
                                if (m) throw new TypeError("Generator is already executing.");
                                for(; g && (g = 0, k[0] && (p = 0)), p;)try {
                                    if (m = 1, w && (v = k[0] & 2 ? w.return : k[0] ? w.throw || ((v = w.return) && v.call(w), 0) : w.next) && !(v = v.call(w, k[1])).done) return v;
                                    switch(w = 0, v && (k = [
                                        k[0] & 2,
                                        v.value
                                    ]), k[0]){
                                        case 0:
                                        case 1:
                                            v = k;
                                            break;
                                        case 4:
                                            return p.label++, {
                                                value: k[1],
                                                done: !1
                                            };
                                        case 5:
                                            p.label++, w = k[1], k = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            k = p.ops.pop(), p.trys.pop();
                                            continue;
                                        default:
                                            if (v = p.trys, !(v = v.length > 0 && v[v.length - 1]) && (k[0] === 6 || k[0] === 2)) {
                                                p = 0;
                                                continue;
                                            }
                                            if (k[0] === 3 && (!v || k[1] > v[0] && k[1] < v[3])) {
                                                p.label = k[1];
                                                break;
                                            }
                                            if (k[0] === 6 && p.label < v[1]) {
                                                p.label = v[1], v = k;
                                                break;
                                            }
                                            if (v && p.label < v[2]) {
                                                p.label = v[2], p.ops.push(k);
                                                break;
                                            }
                                            v[2] && p.ops.pop(), p.trys.pop();
                                            continue;
                                    }
                                    k = f.call(h, p);
                                } catch (y) {
                                    k = [
                                        6,
                                        y
                                    ], w = 0;
                                } finally{
                                    m = v = 0;
                                }
                                if (k[0] & 5) throw k[1];
                                return {
                                    value: k[0] ? k[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.ProtocolAdapter = void 0;
                        var a = r("./payloads/payloadAssemblerManager"), u = r("./payloads/sendOperations"), l = r("./payloads/streamManager"), c = r("./utilities/protocol-base"), d = /** @class */ function() {
                            function h(f, p, m, w) {
                                var v = this;
                                this.requestHandler = f, this.requestManager = p, this.payloadSender = m, this.payloadReceiver = w, this.sendOperations = new u.SendOperations(this.payloadSender), this.streamManager = new l.StreamManager(this.onCancelStream), this.assemblerManager = new a.PayloadAssemblerManager(this.streamManager, function(g, A) {
                                    return v.onReceiveResponse(g, A);
                                }, function(g, A) {
                                    return v.onReceiveRequest(g, A);
                                }), this.payloadReceiver.subscribe(function(g) {
                                    return v.assemblerManager.getPayloadStream(g);
                                }, function(g, A, b) {
                                    return v.assemblerManager.onReceive(g, A, b);
                                });
                            }
                            return h.prototype.sendRequest = function(f) {
                                return o(this, void 0, void 0, function() {
                                    var p, m;
                                    return s(this, function(w) {
                                        switch(w.label){
                                            case 0:
                                                return p = (0, c.generateGuid)(), m = this.requestManager.getResponse(p), [
                                                    4,
                                                    this.sendOperations.sendRequest(p, f)
                                                ];
                                            case 1:
                                                return w.sent(), [
                                                    2,
                                                    m
                                                ];
                                        }
                                    });
                                });
                            }, h.prototype.onReceiveRequest = function(f, p) {
                                return o(this, void 0, void 0, function() {
                                    var m;
                                    return s(this, function(w) {
                                        switch(w.label){
                                            case 0:
                                                return this.requestHandler ? [
                                                    4,
                                                    this.requestHandler.processRequest(p)
                                                ] : [
                                                    3,
                                                    3
                                                ];
                                            case 1:
                                                return m = w.sent(), m ? [
                                                    4,
                                                    this.sendOperations.sendResponse(f, m)
                                                ] : [
                                                    3,
                                                    3
                                                ];
                                            case 2:
                                                w.sent(), w.label = 3;
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, h.prototype.onReceiveResponse = function(f, p) {
                                return o(this, void 0, void 0, function() {
                                    return s(this, function(m) {
                                        switch(m.label){
                                            case 0:
                                                return [
                                                    4,
                                                    this.requestManager.signalResponse(f, p)
                                                ];
                                            case 1:
                                                return m.sent(), [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, h.prototype.onCancelStream = function(f) {
                                this.sendOperations.sendCancelStream(f.id).catch();
                            }, h;
                        }();
                        n.ProtocolAdapter = d;
                    },
                    {
                        "./payloads/payloadAssemblerManager": 17,
                        "./payloads/sendOperations": 21,
                        "./payloads/streamManager": 22,
                        "./utilities/protocol-base": 28
                    }
                ],
                24: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.RequestHandler = void 0;
                        var o = /** @class */ /* @__PURE__ */ function() {
                            function s() {}
                            return s;
                        }();
                        n.RequestHandler = o;
                    },
                    {}
                ],
                25: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.StreamingRequest = void 0;
                        var o = r("./httpContentStream"), s = r("./subscribableStream"), a = /** @class */ function() {
                            function u() {
                                this.streams = [];
                            }
                            return u.create = function(l, c, d) {
                                var h = new u();
                                return h.verb = l, h.path = c, d && h.setBody(d), h;
                            }, u.prototype.addStream = function(l) {
                                if (!l) throw new Error("Argument Undefined Exception: content undefined.");
                                this.streams.push(new o.HttpContentStream(l));
                            }, u.prototype.setBody = function(l) {
                                if (typeof l == "string") {
                                    var c = new s.SubscribableStream();
                                    c.write(l, "utf8"), this.addStream(new o.HttpContent({
                                        type: "application/json; charset=utf-8",
                                        contentLength: c.length
                                    }, c));
                                } else typeof l == "object" && this.addStream(l);
                            }, u;
                        }();
                        n.StreamingRequest = a;
                    },
                    {
                        "./httpContentStream": 8,
                        "./subscribableStream": 27
                    }
                ],
                26: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.StreamingResponse = void 0;
                        var o = r("./httpContentStream"), s = r("./subscribableStream"), a = /** @class */ function() {
                            function u() {
                                this.streams = [];
                            }
                            return u.create = function(l, c) {
                                var d = new u();
                                return d.statusCode = l, c && d.addStream(c), d;
                            }, u.prototype.addStream = function(l) {
                                this.streams.push(new o.HttpContentStream(l));
                            }, u.prototype.setBody = function(l) {
                                var c = new s.SubscribableStream();
                                c.write(JSON.stringify(l), "utf8"), this.addStream(new o.HttpContent({
                                    type: "application/json; charset=utf-8",
                                    contentLength: c.length
                                }, c));
                            }, u;
                        }();
                        n.StreamingResponse = a;
                    },
                    {
                        "./httpContentStream": 8,
                        "./subscribableStream": 27
                    }
                ],
                27: [
                    function(r, i, n) {
                        (function(o) {
                            (function() {
                                var s = this && this.__extends || /* @__PURE__ */ function() {
                                    var l = function(c, d) {
                                        return l = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(h, f) {
                                            h.__proto__ = f;
                                        } || function(h, f) {
                                            for(var p in f)Object.prototype.hasOwnProperty.call(f, p) && (h[p] = f[p]);
                                        }, l(c, d);
                                    };
                                    return function(c, d) {
                                        if (typeof d != "function" && d !== null) throw new TypeError("Class extends value " + String(d) + " is not a constructor or null");
                                        l(c, d);
                                        function h() {
                                            this.constructor = c;
                                        }
                                        c.prototype = d === null ? Object.create(d) : (h.prototype = d.prototype, new h());
                                    };
                                }();
                                Object.defineProperty(n, "__esModule", {
                                    value: !0
                                }), n.SubscribableStream = void 0;
                                var a = r("stream"), u = /** @class */ function(l) {
                                    s(c, l);
                                    function c(d) {
                                        var h = l.call(this, d) || this;
                                        return h.length = 0, h.bufferList = [], h;
                                    }
                                    return c.prototype._write = function(d, h, f) {
                                        var p = o.from(d);
                                        this.bufferList.push(p), this.length += d.length, this._onData && this._onData(p), f();
                                    }, c.prototype._read = function(d) {
                                        if (this.bufferList.length === 0) this.push(null);
                                        else for(var h = 0; h < d && this.bufferList.length > 0;){
                                            var f = this.bufferList[0];
                                            this.push(f), this.bufferList.splice(0, 1), h += f.length;
                                        }
                                    }, c.prototype.subscribe = function(d) {
                                        this._onData = d;
                                    }, c;
                                }(a.Duplex);
                                n.SubscribableStream = u;
                            }).call(this);
                        }).call(this, r("buffer").Buffer);
                    },
                    {
                        buffer: 35,
                        stream: 41
                    }
                ],
                28: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.generateGuid = void 0;
                        var o = r("uuid");
                        function s() {
                            return (0, o.v4)();
                        }
                        n.generateGuid = s;
                    },
                    {
                        uuid: 58
                    }
                ],
                29: [
                    function(r, i, n) {
                        var o = this && this.__awaiter || function(u, l, c, d) {
                            function h(f) {
                                return f instanceof c ? f : new c(function(p) {
                                    p(f);
                                });
                            }
                            return new (c || (c = Promise))(function(f, p) {
                                function m(g) {
                                    try {
                                        v(d.next(g));
                                    } catch (A) {
                                        p(A);
                                    }
                                }
                                function w(g) {
                                    try {
                                        v(d.throw(g));
                                    } catch (A) {
                                        p(A);
                                    }
                                }
                                function v(g) {
                                    g.done ? f(g.value) : h(g.value).then(m, w);
                                }
                                v((d = d.apply(u, l || [])).next());
                            });
                        }, s = this && this.__generator || function(u, l) {
                            var c = {
                                label: 0,
                                sent: function() {
                                    if (f[0] & 1) throw f[1];
                                    return f[1];
                                },
                                trys: [],
                                ops: []
                            }, d, h, f, p;
                            return p = {
                                next: m(0),
                                throw: m(1),
                                return: m(2)
                            }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
                                return this;
                            }), p;
                            function m(v) {
                                return function(g) {
                                    return w([
                                        v,
                                        g
                                    ]);
                                };
                            }
                            function w(v) {
                                if (d) throw new TypeError("Generator is already executing.");
                                for(; p && (p = 0, v[0] && (c = 0)), c;)try {
                                    if (d = 1, h && (f = v[0] & 2 ? h.return : v[0] ? h.throw || ((f = h.return) && f.call(h), 0) : h.next) && !(f = f.call(h, v[1])).done) return f;
                                    switch(h = 0, f && (v = [
                                        v[0] & 2,
                                        f.value
                                    ]), v[0]){
                                        case 0:
                                        case 1:
                                            f = v;
                                            break;
                                        case 4:
                                            return c.label++, {
                                                value: v[1],
                                                done: !1
                                            };
                                        case 5:
                                            c.label++, h = v[1], v = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            v = c.ops.pop(), c.trys.pop();
                                            continue;
                                        default:
                                            if (f = c.trys, !(f = f.length > 0 && f[f.length - 1]) && (v[0] === 6 || v[0] === 2)) {
                                                c = 0;
                                                continue;
                                            }
                                            if (v[0] === 3 && (!f || v[1] > f[0] && v[1] < f[3])) {
                                                c.label = v[1];
                                                break;
                                            }
                                            if (v[0] === 6 && c.label < f[1]) {
                                                c.label = f[1], f = v;
                                                break;
                                            }
                                            if (f && c.label < f[2]) {
                                                c.label = f[2], c.ops.push(v);
                                                break;
                                            }
                                            f[2] && c.ops.pop(), c.trys.pop();
                                            continue;
                                    }
                                    v = l.call(u, c);
                                } catch (g) {
                                    v = [
                                        6,
                                        g
                                    ], h = 0;
                                } finally{
                                    d = f = 0;
                                }
                                if (v[0] & 5) throw v[1];
                                return {
                                    value: v[0] ? v[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.BrowserWebSocket = void 0;
                        var a = /** @class */ function() {
                            function u(l) {
                                l && (this.webSocket = l);
                            }
                            return u.prototype.connect = function(l) {
                                return o(this, void 0, void 0, function() {
                                    var c, d;
                                    return s(this, function(h) {
                                        return this.webSocket || (this.webSocket = new WebSocket(l)), this.webSocket.onerror = function(f) {
                                            d(f);
                                        }, this.webSocket.onopen = function(f) {
                                            c(f);
                                        }, [
                                            2,
                                            new Promise(function(f, p) {
                                                c = f, d = p;
                                            })
                                        ];
                                    });
                                });
                            }, Object.defineProperty(u.prototype, "isConnected", {
                                /**
               * Indicates if the [BrowserWebSocket's](xref:botframework-streaming.BrowserWebSocket) underlying websocket is currently connected.
               *
               * @returns `true` if the underlying websocket is ready and availble to send messages, otherwise `false`.
               */ get: function() {
                                    return this.webSocket.readyState === 1;
                                },
                                enumerable: !1,
                                configurable: !0
                            }), u.prototype.write = function(l) {
                                this.webSocket.send(l);
                            }, u.prototype.close = function() {
                                this.webSocket.close();
                            }, u.prototype.setOnMessageHandler = function(l) {
                                var c = "buffer", d = [];
                                this.webSocket.onmessage = function(h) {
                                    var f = new FileReader(), p = {
                                        buffer: null
                                    };
                                    d.push(p), f.onload = function(m) {
                                        var w = m.target;
                                        if (p[c] = w.result, d[0] === p) for(; 0 < d.length && d[0][c];)l(d[0][c]), d.splice(0, 1);
                                    }, f.readAsArrayBuffer(h.data);
                                };
                            }, u.prototype.setOnErrorHandler = function(l) {
                                this.webSocket.onerror = function(c) {
                                    c && l(c);
                                };
                            }, u.prototype.setOnCloseHandler = function(l) {
                                this.webSocket.onclose = l;
                            }, u;
                        }();
                        n.BrowserWebSocket = a;
                    },
                    {}
                ],
                30: [
                    function(r, i, n) {
                        var o = this && this.__awaiter || function(f, p, m, w) {
                            function v(g) {
                                return g instanceof m ? g : new m(function(A) {
                                    A(g);
                                });
                            }
                            return new (m || (m = Promise))(function(g, A) {
                                function b(x) {
                                    try {
                                        y(w.next(x));
                                    } catch (C) {
                                        A(C);
                                    }
                                }
                                function k(x) {
                                    try {
                                        y(w.throw(x));
                                    } catch (C) {
                                        A(C);
                                    }
                                }
                                function y(x) {
                                    x.done ? g(x.value) : v(x.value).then(b, k);
                                }
                                y((w = w.apply(f, p || [])).next());
                            });
                        }, s = this && this.__generator || function(f, p) {
                            var m = {
                                label: 0,
                                sent: function() {
                                    if (g[0] & 1) throw g[1];
                                    return g[1];
                                },
                                trys: [],
                                ops: []
                            }, w, v, g, A;
                            return A = {
                                next: b(0),
                                throw: b(1),
                                return: b(2)
                            }, typeof Symbol == "function" && (A[Symbol.iterator] = function() {
                                return this;
                            }), A;
                            function b(y) {
                                return function(x) {
                                    return k([
                                        y,
                                        x
                                    ]);
                                };
                            }
                            function k(y) {
                                if (w) throw new TypeError("Generator is already executing.");
                                for(; A && (A = 0, y[0] && (m = 0)), m;)try {
                                    if (w = 1, v && (g = y[0] & 2 ? v.return : y[0] ? v.throw || ((g = v.return) && g.call(v), 0) : v.next) && !(g = g.call(v, y[1])).done) return g;
                                    switch(v = 0, g && (y = [
                                        y[0] & 2,
                                        g.value
                                    ]), y[0]){
                                        case 0:
                                        case 1:
                                            g = y;
                                            break;
                                        case 4:
                                            return m.label++, {
                                                value: y[1],
                                                done: !1
                                            };
                                        case 5:
                                            m.label++, v = y[1], y = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            y = m.ops.pop(), m.trys.pop();
                                            continue;
                                        default:
                                            if (g = m.trys, !(g = g.length > 0 && g[g.length - 1]) && (y[0] === 6 || y[0] === 2)) {
                                                m = 0;
                                                continue;
                                            }
                                            if (y[0] === 3 && (!g || y[1] > g[0] && y[1] < g[3])) {
                                                m.label = y[1];
                                                break;
                                            }
                                            if (y[0] === 6 && m.label < g[1]) {
                                                m.label = g[1], g = y;
                                                break;
                                            }
                                            if (g && m.label < g[2]) {
                                                m.label = g[2], m.ops.push(y);
                                                break;
                                            }
                                            g[2] && m.ops.pop(), m.trys.pop();
                                            continue;
                                    }
                                    y = p.call(f, m);
                                } catch (x) {
                                    y = [
                                        6,
                                        x
                                    ], v = 0;
                                } finally{
                                    w = g = 0;
                                }
                                if (y[0] & 5) throw y[1];
                                return {
                                    value: y[0] ? y[1] : void 0,
                                    done: !0
                                };
                            }
                        };
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.WebSocketClient = void 0;
                        var a = r("./browserWebSocket"), u = r("../payloadTransport"), l = r("../protocolAdapter"), c = r("../payloads"), d = r("./webSocketTransport"), h = /** @class */ function() {
                            function f(p) {
                                var m = p.url, w = p.requestHandler, v = p.disconnectionHandler, g = v === void 0 ? null : v;
                                this._url = m, this._requestHandler = w, this._disconnectionHandler = g, this._requestManager = new c.RequestManager(), this._sender = new u.PayloadSender(), this._sender.disconnected = this.onConnectionDisconnected.bind(this), this._receiver = new u.PayloadReceiver(), this._receiver.disconnected = this.onConnectionDisconnected.bind(this), this._protocolAdapter = new l.ProtocolAdapter(this._requestHandler, this._requestManager, this._sender, this._receiver);
                            }
                            return f.prototype.connect = function() {
                                return o(this, void 0, void 0, function() {
                                    var p, m;
                                    return s(this, function(w) {
                                        switch(w.label){
                                            case 0:
                                                return p = new a.BrowserWebSocket(), [
                                                    4,
                                                    p.connect(this._url)
                                                ];
                                            case 1:
                                                return w.sent(), m = new d.WebSocketTransport(p), this._sender.connect(m), this._receiver.connect(m), [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, f.prototype.disconnect = function() {
                                this._sender.disconnect(new u.TransportDisconnectedEvent("Disconnect was called.")), this._receiver.disconnect(new u.TransportDisconnectedEvent("Disconnect was called."));
                            }, f.prototype.send = function(p) {
                                return o(this, void 0, void 0, function() {
                                    return s(this, function(m) {
                                        return [
                                            2,
                                            this._protocolAdapter.sendRequest(p)
                                        ];
                                    });
                                });
                            }, f.prototype.onConnectionDisconnected = function(p, m) {
                                if (this._requestManager.rejectAllResponses(new Error("Disconnect was called.")), this._disconnectionHandler != null) {
                                    this._disconnectionHandler("Disconnected");
                                    return;
                                }
                                throw new Error("Unable to re-connect client to transport for url ".concat(this._url, ". Sender: '").concat(JSON.stringify(p), "'. Args:' ").concat(JSON.stringify(m)));
                            }, f;
                        }();
                        n.WebSocketClient = h;
                    },
                    {
                        "../payloadTransport": 10,
                        "../payloads": 16,
                        "../protocolAdapter": 23,
                        "./browserWebSocket": 29,
                        "./webSocketTransport": 32
                    }
                ],
                31: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.WebSocketTransport = n.WebSocketClient = n.BrowserWebSocket = void 0;
                        var o = r("./browserWebSocket");
                        Object.defineProperty(n, "BrowserWebSocket", {
                            enumerable: !0,
                            get: function() {
                                return o.BrowserWebSocket;
                            }
                        });
                        var s = r("./browserWebSocketClient");
                        Object.defineProperty(n, "WebSocketClient", {
                            enumerable: !0,
                            get: function() {
                                return s.WebSocketClient;
                            }
                        });
                        var a = r("./webSocketTransport");
                        Object.defineProperty(n, "WebSocketTransport", {
                            enumerable: !0,
                            get: function() {
                                return a.WebSocketTransport;
                            }
                        });
                    },
                    {
                        "./browserWebSocket": 29,
                        "./browserWebSocketClient": 30,
                        "./webSocketTransport": 32
                    }
                ],
                32: [
                    function(r, i, n) {
                        (function(o) {
                            (function() {
                                var s = this && this.__awaiter || function(l, c, d, h) {
                                    function f(p) {
                                        return p instanceof d ? p : new d(function(m) {
                                            m(p);
                                        });
                                    }
                                    return new (d || (d = Promise))(function(p, m) {
                                        function w(A) {
                                            try {
                                                g(h.next(A));
                                            } catch (b) {
                                                m(b);
                                            }
                                        }
                                        function v(A) {
                                            try {
                                                g(h.throw(A));
                                            } catch (b) {
                                                m(b);
                                            }
                                        }
                                        function g(A) {
                                            A.done ? p(A.value) : f(A.value).then(w, v);
                                        }
                                        g((h = h.apply(l, c || [])).next());
                                    });
                                }, a = this && this.__generator || function(l, c) {
                                    var d = {
                                        label: 0,
                                        sent: function() {
                                            if (p[0] & 1) throw p[1];
                                            return p[1];
                                        },
                                        trys: [],
                                        ops: []
                                    }, h, f, p, m;
                                    return m = {
                                        next: w(0),
                                        throw: w(1),
                                        return: w(2)
                                    }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
                                        return this;
                                    }), m;
                                    function w(g) {
                                        return function(A) {
                                            return v([
                                                g,
                                                A
                                            ]);
                                        };
                                    }
                                    function v(g) {
                                        if (h) throw new TypeError("Generator is already executing.");
                                        for(; m && (m = 0, g[0] && (d = 0)), d;)try {
                                            if (h = 1, f && (p = g[0] & 2 ? f.return : g[0] ? f.throw || ((p = f.return) && p.call(f), 0) : f.next) && !(p = p.call(f, g[1])).done) return p;
                                            switch(f = 0, p && (g = [
                                                g[0] & 2,
                                                p.value
                                            ]), g[0]){
                                                case 0:
                                                case 1:
                                                    p = g;
                                                    break;
                                                case 4:
                                                    return d.label++, {
                                                        value: g[1],
                                                        done: !1
                                                    };
                                                case 5:
                                                    d.label++, f = g[1], g = [
                                                        0
                                                    ];
                                                    continue;
                                                case 7:
                                                    g = d.ops.pop(), d.trys.pop();
                                                    continue;
                                                default:
                                                    if (p = d.trys, !(p = p.length > 0 && p[p.length - 1]) && (g[0] === 6 || g[0] === 2)) {
                                                        d = 0;
                                                        continue;
                                                    }
                                                    if (g[0] === 3 && (!p || g[1] > p[0] && g[1] < p[3])) {
                                                        d.label = g[1];
                                                        break;
                                                    }
                                                    if (g[0] === 6 && d.label < p[1]) {
                                                        d.label = p[1], p = g;
                                                        break;
                                                    }
                                                    if (p && d.label < p[2]) {
                                                        d.label = p[2], d.ops.push(g);
                                                        break;
                                                    }
                                                    p[2] && d.ops.pop(), d.trys.pop();
                                                    continue;
                                            }
                                            g = c.call(l, d);
                                        } catch (A) {
                                            g = [
                                                6,
                                                A
                                            ], f = 0;
                                        } finally{
                                            h = p = 0;
                                        }
                                        if (g[0] & 5) throw g[1];
                                        return {
                                            value: g[0] ? g[1] : void 0,
                                            done: !0
                                        };
                                    }
                                };
                                Object.defineProperty(n, "__esModule", {
                                    value: !0
                                }), n.WebSocketTransport = void 0;
                                var u = /** @class */ function() {
                                    function l(c) {
                                        var d = this;
                                        this.ws = c, this._queue = [], this._activeOffset = 0, this._activeReceiveCount = 0, this.ws.setOnMessageHandler(function(h) {
                                            d.onReceive(h);
                                        }), this.ws.setOnErrorHandler(function(h) {
                                            d.onError(h);
                                        }), this.ws.setOnCloseHandler(function() {
                                            d.onClose();
                                        });
                                    }
                                    return l.prototype.send = function(c) {
                                        var d;
                                        return !((d = this.ws) === null || d === void 0) && d.isConnected ? (this.ws.write(c), c.length) : 0;
                                    }, Object.defineProperty(l.prototype, "isConnected", {
                                        /**
                   * Returns true if the transport is connected to a socket.
                   *
                   * @returns `true` if the the transport is connected and ready to send data, `false` otherwise.
                   */ get: function() {
                                            var c;
                                            return !!(!((c = this.ws) === null || c === void 0) && c.isConnected);
                                        },
                                        enumerable: !1,
                                        configurable: !0
                                    }), l.prototype.close = function() {
                                        var c;
                                        !((c = this.ws) === null || c === void 0) && c.isConnected && this.ws.close();
                                    }, l.prototype.receive = function(c) {
                                        return s(this, void 0, void 0, function() {
                                            var d, h = this;
                                            return a(this, function(f) {
                                                if (this._activeReceiveResolve) throw new Error("Cannot call receive more than once before it has returned.");
                                                return this._activeReceiveCount = c, d = new Promise(function(p, m) {
                                                    h._activeReceiveResolve = p, h._activeReceiveReject = m;
                                                }), this.trySignalData(), [
                                                    2,
                                                    d
                                                ];
                                            });
                                        });
                                    }, l.prototype.onReceive = function(c) {
                                        this._queue && c && c.byteLength > 0 && (this._queue.push(o.from(c)), this.trySignalData());
                                    }, l.prototype.onClose = function() {
                                        this._activeReceiveReject && this._activeReceiveReject(new Error("Socket was closed.")), this._active = null, this._activeOffset = 0, this._activeReceiveResolve = null, this._activeReceiveReject = null, this._activeReceiveCount = 0, this.ws = null;
                                    }, l.prototype.onError = function(c) {
                                        this._activeReceiveReject && this._activeReceiveReject(c), this.onClose();
                                    }, l.prototype.trySignalData = function() {
                                        if (this._activeReceiveResolve && (!this._active && this._queue.length > 0 && (this._active = this._queue.shift(), this._activeOffset = 0), this._active)) {
                                            if (this._activeOffset === 0 && this._active.length === this._activeReceiveCount) {
                                                var c = this._active;
                                                this._active = null, this._activeReceiveResolve(c);
                                            } else {
                                                var d = Math.min(this._activeReceiveCount, this._active.length - this._activeOffset), c = o.alloc(d);
                                                this._active.copy(c, 0, this._activeOffset, this._activeOffset + d), this._activeOffset += d, this._activeOffset >= this._active.length && (this._active = null, this._activeOffset = 0), this._activeReceiveResolve(c);
                                            }
                                            this._activeReceiveCount = 0, this._activeReceiveReject = null, this._activeReceiveResolve = null;
                                        }
                                    }, l;
                                }();
                                n.WebSocketTransport = u;
                            }).call(this);
                        }).call(this, r("buffer").Buffer);
                    },
                    {
                        buffer: 35
                    }
                ],
                33: [
                    function(r, i, n) {},
                    {}
                ],
                34: [
                    function(r, i, n) {
                        n.byteLength = h, n.toByteArray = p, n.fromByteArray = v;
                        for(var o = [], s = [], a = typeof Uint8Array < "u" ? Uint8Array : Array, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", l = 0, c = u.length; l < c; ++l)o[l] = u[l], s[u.charCodeAt(l)] = l;
                        s[45] = 62, s[95] = 63;
                        function d(g) {
                            var A = g.length;
                            if (A % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                            var b = g.indexOf("=");
                            b === -1 && (b = A);
                            var k = b === A ? 0 : 4 - b % 4;
                            return [
                                b,
                                k
                            ];
                        }
                        function h(g) {
                            var A = d(g), b = A[0], k = A[1];
                            return (b + k) * 3 / 4 - k;
                        }
                        function f(g, A, b) {
                            return (A + b) * 3 / 4 - b;
                        }
                        function p(g) {
                            var A, b = d(g), k = b[0], y = b[1], x = new a(f(g, k, y)), C = 0, I = y > 0 ? k - 4 : k, M;
                            for(M = 0; M < I; M += 4)A = s[g.charCodeAt(M)] << 18 | s[g.charCodeAt(M + 1)] << 12 | s[g.charCodeAt(M + 2)] << 6 | s[g.charCodeAt(M + 3)], x[C++] = A >> 16 & 255, x[C++] = A >> 8 & 255, x[C++] = A & 255;
                            return y === 2 && (A = s[g.charCodeAt(M)] << 2 | s[g.charCodeAt(M + 1)] >> 4, x[C++] = A & 255), y === 1 && (A = s[g.charCodeAt(M)] << 10 | s[g.charCodeAt(M + 1)] << 4 | s[g.charCodeAt(M + 2)] >> 2, x[C++] = A >> 8 & 255, x[C++] = A & 255), x;
                        }
                        function m(g) {
                            return o[g >> 18 & 63] + o[g >> 12 & 63] + o[g >> 6 & 63] + o[g & 63];
                        }
                        function w(g, A, b) {
                            for(var k, y = [], x = A; x < b; x += 3)k = (g[x] << 16 & 16711680) + (g[x + 1] << 8 & 65280) + (g[x + 2] & 255), y.push(m(k));
                            return y.join("");
                        }
                        function v(g) {
                            for(var A, b = g.length, k = b % 3, y = [], x = 16383, C = 0, I = b - k; C < I; C += x)y.push(w(g, C, C + x > I ? I : C + x));
                            return k === 1 ? (A = g[b - 1], y.push(o[A >> 2] + o[A << 4 & 63] + "==")) : k === 2 && (A = (g[b - 2] << 8) + g[b - 1], y.push(o[A >> 10] + o[A >> 4 & 63] + o[A << 2 & 63] + "=")), y.join("");
                        }
                    },
                    {}
                ],
                35: [
                    function(r, i, n) {
                        (function(o) {
                            (function() {
                                var s = r("base64-js"), a = r("ieee754");
                                n.Buffer = d, n.SlowBuffer = k, n.INSPECT_MAX_BYTES = 50;
                                var u = 2147483647;
                                n.kMaxLength = u, d.TYPED_ARRAY_SUPPORT = l(), !d.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
                                function l() {
                                    try {
                                        var D = new Uint8Array(1);
                                        return D.__proto__ = {
                                            __proto__: Uint8Array.prototype,
                                            foo: function() {
                                                return 42;
                                            }
                                        }, D.foo() === 42;
                                    } catch  {
                                        return !1;
                                    }
                                }
                                Object.defineProperty(d.prototype, "parent", {
                                    enumerable: !0,
                                    get: function() {
                                        if (d.isBuffer(this)) return this.buffer;
                                    }
                                }), Object.defineProperty(d.prototype, "offset", {
                                    enumerable: !0,
                                    get: function() {
                                        if (d.isBuffer(this)) return this.byteOffset;
                                    }
                                });
                                function c(D) {
                                    if (D > u) throw new RangeError('The value "' + D + '" is invalid for option "size"');
                                    var E = new Uint8Array(D);
                                    return E.__proto__ = d.prototype, E;
                                }
                                function d(D, E, T) {
                                    if (typeof D == "number") {
                                        if (typeof E == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
                                        return m(D);
                                    }
                                    return h(D, E, T);
                                }
                                typeof Symbol < "u" && Symbol.species != null && d[Symbol.species] === d && Object.defineProperty(d, Symbol.species, {
                                    value: null,
                                    configurable: !0,
                                    enumerable: !1,
                                    writable: !1
                                }), d.poolSize = 8192;
                                function h(D, E, T) {
                                    if (typeof D == "string") return w(D, E);
                                    if (ArrayBuffer.isView(D)) return v(D);
                                    if (D == null) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof D);
                                    if (L(D, ArrayBuffer) || D && L(D.buffer, ArrayBuffer)) return g(D, E, T);
                                    if (typeof D == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
                                    var j = D.valueOf && D.valueOf();
                                    if (j != null && j !== D) return d.from(j, E, T);
                                    var Y = A(D);
                                    if (Y) return Y;
                                    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof D[Symbol.toPrimitive] == "function") return d.from(D[Symbol.toPrimitive]("string"), E, T);
                                    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof D);
                                }
                                d.from = function(D, E, T) {
                                    return h(D, E, T);
                                }, d.prototype.__proto__ = Uint8Array.prototype, d.__proto__ = Uint8Array;
                                function f(D) {
                                    if (typeof D != "number") throw new TypeError('"size" argument must be of type number');
                                    if (D < 0) throw new RangeError('The value "' + D + '" is invalid for option "size"');
                                }
                                function p(D, E, T) {
                                    return f(D), D <= 0 ? c(D) : E !== void 0 ? typeof T == "string" ? c(D).fill(E, T) : c(D).fill(E) : c(D);
                                }
                                d.alloc = function(D, E, T) {
                                    return p(D, E, T);
                                };
                                function m(D) {
                                    return f(D), c(D < 0 ? 0 : b(D) | 0);
                                }
                                d.allocUnsafe = function(D) {
                                    return m(D);
                                }, d.allocUnsafeSlow = function(D) {
                                    return m(D);
                                };
                                function w(D, E) {
                                    if ((typeof E != "string" || E === "") && (E = "utf8"), !d.isEncoding(E)) throw new TypeError("Unknown encoding: " + E);
                                    var T = y(D, E) | 0, j = c(T), Y = j.write(D, E);
                                    return Y !== T && (j = j.slice(0, Y)), j;
                                }
                                function v(D) {
                                    for(var E = D.length < 0 ? 0 : b(D.length) | 0, T = c(E), j = 0; j < E; j += 1)T[j] = D[j] & 255;
                                    return T;
                                }
                                function g(D, E, T) {
                                    if (E < 0 || D.byteLength < E) throw new RangeError('"offset" is outside of buffer bounds');
                                    if (D.byteLength < E + (T || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                    var j;
                                    return E === void 0 && T === void 0 ? j = new Uint8Array(D) : T === void 0 ? j = new Uint8Array(D, E) : j = new Uint8Array(D, E, T), j.__proto__ = d.prototype, j;
                                }
                                function A(D) {
                                    if (d.isBuffer(D)) {
                                        var E = b(D.length) | 0, T = c(E);
                                        return T.length === 0 || D.copy(T, 0, 0, E), T;
                                    }
                                    if (D.length !== void 0) return typeof D.length != "number" || B(D.length) ? c(0) : v(D);
                                    if (D.type === "Buffer" && Array.isArray(D.data)) return v(D.data);
                                }
                                function b(D) {
                                    if (D >= u) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + u.toString(16) + " bytes");
                                    return D | 0;
                                }
                                function k(D) {
                                    return +D != D && (D = 0), d.alloc(+D);
                                }
                                d.isBuffer = function(E) {
                                    return E != null && E._isBuffer === !0 && E !== d.prototype;
                                }, d.compare = function(E, T) {
                                    if (L(E, Uint8Array) && (E = d.from(E, E.offset, E.byteLength)), L(T, Uint8Array) && (T = d.from(T, T.offset, T.byteLength)), !d.isBuffer(E) || !d.isBuffer(T)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                                    if (E === T) return 0;
                                    for(var j = E.length, Y = T.length, ae = 0, se = Math.min(j, Y); ae < se; ++ae)if (E[ae] !== T[ae]) {
                                        j = E[ae], Y = T[ae];
                                        break;
                                    }
                                    return j < Y ? -1 : Y < j ? 1 : 0;
                                }, d.isEncoding = function(E) {
                                    switch(String(E).toLowerCase()){
                                        case "hex":
                                        case "utf8":
                                        case "utf-8":
                                        case "ascii":
                                        case "latin1":
                                        case "binary":
                                        case "base64":
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return !0;
                                        default:
                                            return !1;
                                    }
                                }, d.concat = function(E, T) {
                                    if (!Array.isArray(E)) throw new TypeError('"list" argument must be an Array of Buffers');
                                    if (E.length === 0) return d.alloc(0);
                                    var j;
                                    if (T === void 0) for(T = 0, j = 0; j < E.length; ++j)T += E[j].length;
                                    var Y = d.allocUnsafe(T), ae = 0;
                                    for(j = 0; j < E.length; ++j){
                                        var se = E[j];
                                        if (L(se, Uint8Array) && (se = d.from(se)), !d.isBuffer(se)) throw new TypeError('"list" argument must be an Array of Buffers');
                                        se.copy(Y, ae), ae += se.length;
                                    }
                                    return Y;
                                };
                                function y(D, E) {
                                    if (d.isBuffer(D)) return D.length;
                                    if (ArrayBuffer.isView(D) || L(D, ArrayBuffer)) return D.byteLength;
                                    if (typeof D != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof D);
                                    var T = D.length, j = arguments.length > 2 && arguments[2] === !0;
                                    if (!j && T === 0) return 0;
                                    for(var Y = !1;;)switch(E){
                                        case "ascii":
                                        case "latin1":
                                        case "binary":
                                            return T;
                                        case "utf8":
                                        case "utf-8":
                                            return te(D).length;
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return T * 2;
                                        case "hex":
                                            return T >>> 1;
                                        case "base64":
                                            return pe(D).length;
                                        default:
                                            if (Y) return j ? -1 : te(D).length;
                                            E = ("" + E).toLowerCase(), Y = !0;
                                    }
                                }
                                d.byteLength = y;
                                function x(D, E, T) {
                                    var j = !1;
                                    if ((E === void 0 || E < 0) && (E = 0), E > this.length || ((T === void 0 || T > this.length) && (T = this.length), T <= 0) || (T >>>= 0, E >>>= 0, T <= E)) return "";
                                    for(D || (D = "utf8");;)switch(D){
                                        case "hex":
                                            return oe(this, E, T);
                                        case "utf8":
                                        case "utf-8":
                                            return X(this, E, T);
                                        case "ascii":
                                            return G(this, E, T);
                                        case "latin1":
                                        case "binary":
                                            return re(this, E, T);
                                        case "base64":
                                            return V(this, E, T);
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return ie(this, E, T);
                                        default:
                                            if (j) throw new TypeError("Unknown encoding: " + D);
                                            D = (D + "").toLowerCase(), j = !0;
                                    }
                                }
                                d.prototype._isBuffer = !0;
                                function C(D, E, T) {
                                    var j = D[E];
                                    D[E] = D[T], D[T] = j;
                                }
                                d.prototype.swap16 = function() {
                                    var E = this.length;
                                    if (E % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                                    for(var T = 0; T < E; T += 2)C(this, T, T + 1);
                                    return this;
                                }, d.prototype.swap32 = function() {
                                    var E = this.length;
                                    if (E % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                                    for(var T = 0; T < E; T += 4)C(this, T, T + 3), C(this, T + 1, T + 2);
                                    return this;
                                }, d.prototype.swap64 = function() {
                                    var E = this.length;
                                    if (E % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                                    for(var T = 0; T < E; T += 8)C(this, T, T + 7), C(this, T + 1, T + 6), C(this, T + 2, T + 5), C(this, T + 3, T + 4);
                                    return this;
                                }, d.prototype.toString = function() {
                                    var E = this.length;
                                    return E === 0 ? "" : arguments.length === 0 ? X(this, 0, E) : x.apply(this, arguments);
                                }, d.prototype.toLocaleString = d.prototype.toString, d.prototype.equals = function(E) {
                                    if (!d.isBuffer(E)) throw new TypeError("Argument must be a Buffer");
                                    return this === E ? !0 : d.compare(this, E) === 0;
                                }, d.prototype.inspect = function() {
                                    var E = "", T = n.INSPECT_MAX_BYTES;
                                    return E = this.toString("hex", 0, T).replace(/(.{2})/g, "$1 ").trim(), this.length > T && (E += " ... "), "<Buffer " + E + ">";
                                }, d.prototype.compare = function(E, T, j, Y, ae) {
                                    if (L(E, Uint8Array) && (E = d.from(E, E.offset, E.byteLength)), !d.isBuffer(E)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof E);
                                    if (T === void 0 && (T = 0), j === void 0 && (j = E ? E.length : 0), Y === void 0 && (Y = 0), ae === void 0 && (ae = this.length), T < 0 || j > E.length || Y < 0 || ae > this.length) throw new RangeError("out of range index");
                                    if (Y >= ae && T >= j) return 0;
                                    if (Y >= ae) return -1;
                                    if (T >= j) return 1;
                                    if (T >>>= 0, j >>>= 0, Y >>>= 0, ae >>>= 0, this === E) return 0;
                                    for(var se = ae - Y, O = j - T, _ = Math.min(se, O), S = this.slice(Y, ae), F = E.slice(T, j), $ = 0; $ < _; ++$)if (S[$] !== F[$]) {
                                        se = S[$], O = F[$];
                                        break;
                                    }
                                    return se < O ? -1 : O < se ? 1 : 0;
                                };
                                function I(D, E, T, j, Y) {
                                    if (D.length === 0) return -1;
                                    if (typeof T == "string" ? (j = T, T = 0) : T > 2147483647 ? T = 2147483647 : T < -2147483648 && (T = -2147483648), T = +T, B(T) && (T = Y ? 0 : D.length - 1), T < 0 && (T = D.length + T), T >= D.length) {
                                        if (Y) return -1;
                                        T = D.length - 1;
                                    } else if (T < 0) {
                                        if (Y) T = 0;
                                        else return -1;
                                    }
                                    if (typeof E == "string" && (E = d.from(E, j)), d.isBuffer(E)) return E.length === 0 ? -1 : M(D, E, T, j, Y);
                                    if (typeof E == "number") return E = E & 255, typeof Uint8Array.prototype.indexOf == "function" ? Y ? Uint8Array.prototype.indexOf.call(D, E, T) : Uint8Array.prototype.lastIndexOf.call(D, E, T) : M(D, [
                                        E
                                    ], T, j, Y);
                                    throw new TypeError("val must be string, number or Buffer");
                                }
                                function M(D, E, T, j, Y) {
                                    var ae = 1, se = D.length, O = E.length;
                                    if (j !== void 0 && (j = String(j).toLowerCase(), j === "ucs2" || j === "ucs-2" || j === "utf16le" || j === "utf-16le")) {
                                        if (D.length < 2 || E.length < 2) return -1;
                                        ae = 2, se /= 2, O /= 2, T /= 2;
                                    }
                                    function _(ee, de) {
                                        return ae === 1 ? ee[de] : ee.readUInt16BE(de * ae);
                                    }
                                    var S;
                                    if (Y) {
                                        var F = -1;
                                        for(S = T; S < se; S++)if (_(D, S) === _(E, F === -1 ? 0 : S - F)) {
                                            if (F === -1 && (F = S), S - F + 1 === O) return F * ae;
                                        } else F !== -1 && (S -= S - F), F = -1;
                                    } else for(T + O > se && (T = se - O), S = T; S >= 0; S--){
                                        for(var $ = !0, K = 0; K < O; K++)if (_(D, S + K) !== _(E, K)) {
                                            $ = !1;
                                            break;
                                        }
                                        if ($) return S;
                                    }
                                    return -1;
                                }
                                d.prototype.includes = function(E, T, j) {
                                    return this.indexOf(E, T, j) !== -1;
                                }, d.prototype.indexOf = function(E, T, j) {
                                    return I(this, E, T, j, !0);
                                }, d.prototype.lastIndexOf = function(E, T, j) {
                                    return I(this, E, T, j, !1);
                                };
                                function Q(D, E, T, j) {
                                    T = Number(T) || 0;
                                    var Y = D.length - T;
                                    j ? (j = Number(j), j > Y && (j = Y)) : j = Y;
                                    var ae = E.length;
                                    j > ae / 2 && (j = ae / 2);
                                    for(var se = 0; se < j; ++se){
                                        var O = parseInt(E.substr(se * 2, 2), 16);
                                        if (B(O)) return se;
                                        D[T + se] = O;
                                    }
                                    return se;
                                }
                                function H(D, E, T, j) {
                                    return me(te(E, D.length - T), D, T, j);
                                }
                                function J(D, E, T, j) {
                                    return me(Z(E), D, T, j);
                                }
                                function W(D, E, T, j) {
                                    return J(D, E, T, j);
                                }
                                function P(D, E, T, j) {
                                    return me(pe(E), D, T, j);
                                }
                                function R(D, E, T, j) {
                                    return me(ue(E, D.length - T), D, T, j);
                                }
                                d.prototype.write = function(E, T, j, Y) {
                                    if (T === void 0) Y = "utf8", j = this.length, T = 0;
                                    else if (j === void 0 && typeof T == "string") Y = T, j = this.length, T = 0;
                                    else if (isFinite(T)) T = T >>> 0, isFinite(j) ? (j = j >>> 0, Y === void 0 && (Y = "utf8")) : (Y = j, j = void 0);
                                    else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                    var ae = this.length - T;
                                    if ((j === void 0 || j > ae) && (j = ae), E.length > 0 && (j < 0 || T < 0) || T > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                                    Y || (Y = "utf8");
                                    for(var se = !1;;)switch(Y){
                                        case "hex":
                                            return Q(this, E, T, j);
                                        case "utf8":
                                        case "utf-8":
                                            return H(this, E, T, j);
                                        case "ascii":
                                            return J(this, E, T, j);
                                        case "latin1":
                                        case "binary":
                                            return W(this, E, T, j);
                                        case "base64":
                                            return P(this, E, T, j);
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return R(this, E, T, j);
                                        default:
                                            if (se) throw new TypeError("Unknown encoding: " + Y);
                                            Y = ("" + Y).toLowerCase(), se = !0;
                                    }
                                }, d.prototype.toJSON = function() {
                                    return {
                                        type: "Buffer",
                                        data: Array.prototype.slice.call(this._arr || this, 0)
                                    };
                                };
                                function V(D, E, T) {
                                    return E === 0 && T === D.length ? s.fromByteArray(D) : s.fromByteArray(D.slice(E, T));
                                }
                                function X(D, E, T) {
                                    T = Math.min(D.length, T);
                                    for(var j = [], Y = E; Y < T;){
                                        var ae = D[Y], se = null, O = ae > 239 ? 4 : ae > 223 ? 3 : ae > 191 ? 2 : 1;
                                        if (Y + O <= T) {
                                            var _, S, F, $;
                                            switch(O){
                                                case 1:
                                                    ae < 128 && (se = ae);
                                                    break;
                                                case 2:
                                                    _ = D[Y + 1], (_ & 192) === 128 && ($ = (ae & 31) << 6 | _ & 63, $ > 127 && (se = $));
                                                    break;
                                                case 3:
                                                    _ = D[Y + 1], S = D[Y + 2], (_ & 192) === 128 && (S & 192) === 128 && ($ = (ae & 15) << 12 | (_ & 63) << 6 | S & 63, $ > 2047 && ($ < 55296 || $ > 57343) && (se = $));
                                                    break;
                                                case 4:
                                                    _ = D[Y + 1], S = D[Y + 2], F = D[Y + 3], (_ & 192) === 128 && (S & 192) === 128 && (F & 192) === 128 && ($ = (ae & 15) << 18 | (_ & 63) << 12 | (S & 63) << 6 | F & 63, $ > 65535 && $ < 1114112 && (se = $));
                                            }
                                        }
                                        se === null ? (se = 65533, O = 1) : se > 65535 && (se -= 65536, j.push(se >>> 10 & 1023 | 55296), se = 56320 | se & 1023), j.push(se), Y += O;
                                    }
                                    return U(j);
                                }
                                var N = 4096;
                                function U(D) {
                                    var E = D.length;
                                    if (E <= N) return String.fromCharCode.apply(String, D);
                                    for(var T = "", j = 0; j < E;)T += String.fromCharCode.apply(String, D.slice(j, j += N));
                                    return T;
                                }
                                function G(D, E, T) {
                                    var j = "";
                                    T = Math.min(D.length, T);
                                    for(var Y = E; Y < T; ++Y)j += String.fromCharCode(D[Y] & 127);
                                    return j;
                                }
                                function re(D, E, T) {
                                    var j = "";
                                    T = Math.min(D.length, T);
                                    for(var Y = E; Y < T; ++Y)j += String.fromCharCode(D[Y]);
                                    return j;
                                }
                                function oe(D, E, T) {
                                    var j = D.length;
                                    (!E || E < 0) && (E = 0), (!T || T < 0 || T > j) && (T = j);
                                    for(var Y = "", ae = E; ae < T; ++ae)Y += De(D[ae]);
                                    return Y;
                                }
                                function ie(D, E, T) {
                                    for(var j = D.slice(E, T), Y = "", ae = 0; ae < j.length; ae += 2)Y += String.fromCharCode(j[ae] + j[ae + 1] * 256);
                                    return Y;
                                }
                                d.prototype.slice = function(E, T) {
                                    var j = this.length;
                                    E = ~~E, T = T === void 0 ? j : ~~T, E < 0 ? (E += j, E < 0 && (E = 0)) : E > j && (E = j), T < 0 ? (T += j, T < 0 && (T = 0)) : T > j && (T = j), T < E && (T = E);
                                    var Y = this.subarray(E, T);
                                    return Y.__proto__ = d.prototype, Y;
                                };
                                function le(D, E, T) {
                                    if (D % 1 !== 0 || D < 0) throw new RangeError("offset is not uint");
                                    if (D + E > T) throw new RangeError("Trying to access beyond buffer length");
                                }
                                d.prototype.readUIntLE = function(E, T, j) {
                                    E = E >>> 0, T = T >>> 0, j || le(E, T, this.length);
                                    for(var Y = this[E], ae = 1, se = 0; ++se < T && (ae *= 256);)Y += this[E + se] * ae;
                                    return Y;
                                }, d.prototype.readUIntBE = function(E, T, j) {
                                    E = E >>> 0, T = T >>> 0, j || le(E, T, this.length);
                                    for(var Y = this[E + --T], ae = 1; T > 0 && (ae *= 256);)Y += this[E + --T] * ae;
                                    return Y;
                                }, d.prototype.readUInt8 = function(E, T) {
                                    return E = E >>> 0, T || le(E, 1, this.length), this[E];
                                }, d.prototype.readUInt16LE = function(E, T) {
                                    return E = E >>> 0, T || le(E, 2, this.length), this[E] | this[E + 1] << 8;
                                }, d.prototype.readUInt16BE = function(E, T) {
                                    return E = E >>> 0, T || le(E, 2, this.length), this[E] << 8 | this[E + 1];
                                }, d.prototype.readUInt32LE = function(E, T) {
                                    return E = E >>> 0, T || le(E, 4, this.length), (this[E] | this[E + 1] << 8 | this[E + 2] << 16) + this[E + 3] * 16777216;
                                }, d.prototype.readUInt32BE = function(E, T) {
                                    return E = E >>> 0, T || le(E, 4, this.length), this[E] * 16777216 + (this[E + 1] << 16 | this[E + 2] << 8 | this[E + 3]);
                                }, d.prototype.readIntLE = function(E, T, j) {
                                    E = E >>> 0, T = T >>> 0, j || le(E, T, this.length);
                                    for(var Y = this[E], ae = 1, se = 0; ++se < T && (ae *= 256);)Y += this[E + se] * ae;
                                    return ae *= 128, Y >= ae && (Y -= Math.pow(2, 8 * T)), Y;
                                }, d.prototype.readIntBE = function(E, T, j) {
                                    E = E >>> 0, T = T >>> 0, j || le(E, T, this.length);
                                    for(var Y = T, ae = 1, se = this[E + --Y]; Y > 0 && (ae *= 256);)se += this[E + --Y] * ae;
                                    return ae *= 128, se >= ae && (se -= Math.pow(2, 8 * T)), se;
                                }, d.prototype.readInt8 = function(E, T) {
                                    return E = E >>> 0, T || le(E, 1, this.length), this[E] & 128 ? (255 - this[E] + 1) * -1 : this[E];
                                }, d.prototype.readInt16LE = function(E, T) {
                                    E = E >>> 0, T || le(E, 2, this.length);
                                    var j = this[E] | this[E + 1] << 8;
                                    return j & 32768 ? j | 4294901760 : j;
                                }, d.prototype.readInt16BE = function(E, T) {
                                    E = E >>> 0, T || le(E, 2, this.length);
                                    var j = this[E + 1] | this[E] << 8;
                                    return j & 32768 ? j | 4294901760 : j;
                                }, d.prototype.readInt32LE = function(E, T) {
                                    return E = E >>> 0, T || le(E, 4, this.length), this[E] | this[E + 1] << 8 | this[E + 2] << 16 | this[E + 3] << 24;
                                }, d.prototype.readInt32BE = function(E, T) {
                                    return E = E >>> 0, T || le(E, 4, this.length), this[E] << 24 | this[E + 1] << 16 | this[E + 2] << 8 | this[E + 3];
                                }, d.prototype.readFloatLE = function(E, T) {
                                    return E = E >>> 0, T || le(E, 4, this.length), a.read(this, E, !0, 23, 4);
                                }, d.prototype.readFloatBE = function(E, T) {
                                    return E = E >>> 0, T || le(E, 4, this.length), a.read(this, E, !1, 23, 4);
                                }, d.prototype.readDoubleLE = function(E, T) {
                                    return E = E >>> 0, T || le(E, 8, this.length), a.read(this, E, !0, 52, 8);
                                }, d.prototype.readDoubleBE = function(E, T) {
                                    return E = E >>> 0, T || le(E, 8, this.length), a.read(this, E, !1, 52, 8);
                                };
                                function he(D, E, T, j, Y, ae) {
                                    if (!d.isBuffer(D)) throw new TypeError('"buffer" argument must be a Buffer instance');
                                    if (E > Y || E < ae) throw new RangeError('"value" argument is out of bounds');
                                    if (T + j > D.length) throw new RangeError("Index out of range");
                                }
                                d.prototype.writeUIntLE = function(E, T, j, Y) {
                                    if (E = +E, T = T >>> 0, j = j >>> 0, !Y) {
                                        var ae = Math.pow(2, 8 * j) - 1;
                                        he(this, E, T, j, ae, 0);
                                    }
                                    var se = 1, O = 0;
                                    for(this[T] = E & 255; ++O < j && (se *= 256);)this[T + O] = E / se & 255;
                                    return T + j;
                                }, d.prototype.writeUIntBE = function(E, T, j, Y) {
                                    if (E = +E, T = T >>> 0, j = j >>> 0, !Y) {
                                        var ae = Math.pow(2, 8 * j) - 1;
                                        he(this, E, T, j, ae, 0);
                                    }
                                    var se = j - 1, O = 1;
                                    for(this[T + se] = E & 255; --se >= 0 && (O *= 256);)this[T + se] = E / O & 255;
                                    return T + j;
                                }, d.prototype.writeUInt8 = function(E, T, j) {
                                    return E = +E, T = T >>> 0, j || he(this, E, T, 1, 255, 0), this[T] = E & 255, T + 1;
                                }, d.prototype.writeUInt16LE = function(E, T, j) {
                                    return E = +E, T = T >>> 0, j || he(this, E, T, 2, 65535, 0), this[T] = E & 255, this[T + 1] = E >>> 8, T + 2;
                                }, d.prototype.writeUInt16BE = function(E, T, j) {
                                    return E = +E, T = T >>> 0, j || he(this, E, T, 2, 65535, 0), this[T] = E >>> 8, this[T + 1] = E & 255, T + 2;
                                }, d.prototype.writeUInt32LE = function(E, T, j) {
                                    return E = +E, T = T >>> 0, j || he(this, E, T, 4, 4294967295, 0), this[T + 3] = E >>> 24, this[T + 2] = E >>> 16, this[T + 1] = E >>> 8, this[T] = E & 255, T + 4;
                                }, d.prototype.writeUInt32BE = function(E, T, j) {
                                    return E = +E, T = T >>> 0, j || he(this, E, T, 4, 4294967295, 0), this[T] = E >>> 24, this[T + 1] = E >>> 16, this[T + 2] = E >>> 8, this[T + 3] = E & 255, T + 4;
                                }, d.prototype.writeIntLE = function(E, T, j, Y) {
                                    if (E = +E, T = T >>> 0, !Y) {
                                        var ae = Math.pow(2, 8 * j - 1);
                                        he(this, E, T, j, ae - 1, -ae);
                                    }
                                    var se = 0, O = 1, _ = 0;
                                    for(this[T] = E & 255; ++se < j && (O *= 256);)E < 0 && _ === 0 && this[T + se - 1] !== 0 && (_ = 1), this[T + se] = (E / O >> 0) - _ & 255;
                                    return T + j;
                                }, d.prototype.writeIntBE = function(E, T, j, Y) {
                                    if (E = +E, T = T >>> 0, !Y) {
                                        var ae = Math.pow(2, 8 * j - 1);
                                        he(this, E, T, j, ae - 1, -ae);
                                    }
                                    var se = j - 1, O = 1, _ = 0;
                                    for(this[T + se] = E & 255; --se >= 0 && (O *= 256);)E < 0 && _ === 0 && this[T + se + 1] !== 0 && (_ = 1), this[T + se] = (E / O >> 0) - _ & 255;
                                    return T + j;
                                }, d.prototype.writeInt8 = function(E, T, j) {
                                    return E = +E, T = T >>> 0, j || he(this, E, T, 1, 127, -128), E < 0 && (E = 255 + E + 1), this[T] = E & 255, T + 1;
                                }, d.prototype.writeInt16LE = function(E, T, j) {
                                    return E = +E, T = T >>> 0, j || he(this, E, T, 2, 32767, -32768), this[T] = E & 255, this[T + 1] = E >>> 8, T + 2;
                                }, d.prototype.writeInt16BE = function(E, T, j) {
                                    return E = +E, T = T >>> 0, j || he(this, E, T, 2, 32767, -32768), this[T] = E >>> 8, this[T + 1] = E & 255, T + 2;
                                }, d.prototype.writeInt32LE = function(E, T, j) {
                                    return E = +E, T = T >>> 0, j || he(this, E, T, 4, 2147483647, -2147483648), this[T] = E & 255, this[T + 1] = E >>> 8, this[T + 2] = E >>> 16, this[T + 3] = E >>> 24, T + 4;
                                }, d.prototype.writeInt32BE = function(E, T, j) {
                                    return E = +E, T = T >>> 0, j || he(this, E, T, 4, 2147483647, -2147483648), E < 0 && (E = 4294967295 + E + 1), this[T] = E >>> 24, this[T + 1] = E >>> 16, this[T + 2] = E >>> 8, this[T + 3] = E & 255, T + 4;
                                };
                                function ye(D, E, T, j, Y, ae) {
                                    if (T + j > D.length) throw new RangeError("Index out of range");
                                    if (T < 0) throw new RangeError("Index out of range");
                                }
                                function be(D, E, T, j, Y) {
                                    return E = +E, T = T >>> 0, Y || ye(D, E, T, 4), a.write(D, E, T, j, 23, 4), T + 4;
                                }
                                d.prototype.writeFloatLE = function(E, T, j) {
                                    return be(this, E, T, !0, j);
                                }, d.prototype.writeFloatBE = function(E, T, j) {
                                    return be(this, E, T, !1, j);
                                };
                                function we(D, E, T, j, Y) {
                                    return E = +E, T = T >>> 0, Y || ye(D, E, T, 8), a.write(D, E, T, j, 52, 8), T + 8;
                                }
                                d.prototype.writeDoubleLE = function(E, T, j) {
                                    return we(this, E, T, !0, j);
                                }, d.prototype.writeDoubleBE = function(E, T, j) {
                                    return we(this, E, T, !1, j);
                                }, d.prototype.copy = function(E, T, j, Y) {
                                    if (!d.isBuffer(E)) throw new TypeError("argument should be a Buffer");
                                    if (j || (j = 0), !Y && Y !== 0 && (Y = this.length), T >= E.length && (T = E.length), T || (T = 0), Y > 0 && Y < j && (Y = j), Y === j || E.length === 0 || this.length === 0) return 0;
                                    if (T < 0) throw new RangeError("targetStart out of bounds");
                                    if (j < 0 || j >= this.length) throw new RangeError("Index out of range");
                                    if (Y < 0) throw new RangeError("sourceEnd out of bounds");
                                    Y > this.length && (Y = this.length), E.length - T < Y - j && (Y = E.length - T + j);
                                    var ae = Y - j;
                                    if (this === E && typeof Uint8Array.prototype.copyWithin == "function") this.copyWithin(T, j, Y);
                                    else if (this === E && j < T && T < Y) for(var se = ae - 1; se >= 0; --se)E[se + T] = this[se + j];
                                    else Uint8Array.prototype.set.call(E, this.subarray(j, Y), T);
                                    return ae;
                                }, d.prototype.fill = function(E, T, j, Y) {
                                    if (typeof E == "string") {
                                        if (typeof T == "string" ? (Y = T, T = 0, j = this.length) : typeof j == "string" && (Y = j, j = this.length), Y !== void 0 && typeof Y != "string") throw new TypeError("encoding must be a string");
                                        if (typeof Y == "string" && !d.isEncoding(Y)) throw new TypeError("Unknown encoding: " + Y);
                                        if (E.length === 1) {
                                            var ae = E.charCodeAt(0);
                                            (Y === "utf8" && ae < 128 || Y === "latin1") && (E = ae);
                                        }
                                    } else typeof E == "number" && (E = E & 255);
                                    if (T < 0 || this.length < T || this.length < j) throw new RangeError("Out of range index");
                                    if (j <= T) return this;
                                    T = T >>> 0, j = j === void 0 ? this.length : j >>> 0, E || (E = 0);
                                    var se;
                                    if (typeof E == "number") for(se = T; se < j; ++se)this[se] = E;
                                    else {
                                        var O = d.isBuffer(E) ? E : d.from(E, Y), _ = O.length;
                                        if (_ === 0) throw new TypeError('The value "' + E + '" is invalid for argument "value"');
                                        for(se = 0; se < j - T; ++se)this[se + T] = O[se % _];
                                    }
                                    return this;
                                };
                                var ve = /[^+/0-9A-Za-z-_]/g;
                                function Re(D) {
                                    if (D = D.split("=")[0], D = D.trim().replace(ve, ""), D.length < 2) return "";
                                    for(; D.length % 4 !== 0;)D = D + "=";
                                    return D;
                                }
                                function De(D) {
                                    return D < 16 ? "0" + D.toString(16) : D.toString(16);
                                }
                                function te(D, E) {
                                    E = E || 1 / 0;
                                    for(var T, j = D.length, Y = null, ae = [], se = 0; se < j; ++se){
                                        if (T = D.charCodeAt(se), T > 55295 && T < 57344) {
                                            if (!Y) {
                                                if (T > 56319) {
                                                    (E -= 3) > -1 && ae.push(239, 191, 189);
                                                    continue;
                                                } else if (se + 1 === j) {
                                                    (E -= 3) > -1 && ae.push(239, 191, 189);
                                                    continue;
                                                }
                                                Y = T;
                                                continue;
                                            }
                                            if (T < 56320) {
                                                (E -= 3) > -1 && ae.push(239, 191, 189), Y = T;
                                                continue;
                                            }
                                            T = (Y - 55296 << 10 | T - 56320) + 65536;
                                        } else Y && (E -= 3) > -1 && ae.push(239, 191, 189);
                                        if (Y = null, T < 128) {
                                            if ((E -= 1) < 0) break;
                                            ae.push(T);
                                        } else if (T < 2048) {
                                            if ((E -= 2) < 0) break;
                                            ae.push(T >> 6 | 192, T & 63 | 128);
                                        } else if (T < 65536) {
                                            if ((E -= 3) < 0) break;
                                            ae.push(T >> 12 | 224, T >> 6 & 63 | 128, T & 63 | 128);
                                        } else if (T < 1114112) {
                                            if ((E -= 4) < 0) break;
                                            ae.push(T >> 18 | 240, T >> 12 & 63 | 128, T >> 6 & 63 | 128, T & 63 | 128);
                                        } else throw new Error("Invalid code point");
                                    }
                                    return ae;
                                }
                                function Z(D) {
                                    for(var E = [], T = 0; T < D.length; ++T)E.push(D.charCodeAt(T) & 255);
                                    return E;
                                }
                                function ue(D, E) {
                                    for(var T, j, Y, ae = [], se = 0; se < D.length && !((E -= 2) < 0); ++se)T = D.charCodeAt(se), j = T >> 8, Y = T % 256, ae.push(Y), ae.push(j);
                                    return ae;
                                }
                                function pe(D) {
                                    return s.toByteArray(Re(D));
                                }
                                function me(D, E, T, j) {
                                    for(var Y = 0; Y < j && !(Y + T >= E.length || Y >= D.length); ++Y)E[Y + T] = D[Y];
                                    return Y;
                                }
                                function L(D, E) {
                                    return D instanceof E || D != null && D.constructor != null && D.constructor.name != null && D.constructor.name === E.name;
                                }
                                function B(D) {
                                    return D !== D;
                                }
                            }).call(this);
                        }).call(this, r("buffer").Buffer);
                    },
                    {
                        "base64-js": 34,
                        buffer: 35,
                        ieee754: 37
                    }
                ],
                36: [
                    function(r, i, n) {
                        var o = typeof Reflect == "object" ? Reflect : null, s = o && typeof o.apply == "function" ? o.apply : function(C, I, M) {
                            return Function.prototype.apply.call(C, I, M);
                        }, a;
                        o && typeof o.ownKeys == "function" ? a = o.ownKeys : Object.getOwnPropertySymbols ? a = function(C) {
                            return Object.getOwnPropertyNames(C).concat(Object.getOwnPropertySymbols(C));
                        } : a = function(C) {
                            return Object.getOwnPropertyNames(C);
                        };
                        function u(x) {
                            console && console.warn && console.warn(x);
                        }
                        var l = Number.isNaN || function(C) {
                            return C !== C;
                        };
                        function c() {
                            c.init.call(this);
                        }
                        i.exports = c, i.exports.once = y, c.EventEmitter = c, c.prototype._events = void 0, c.prototype._eventsCount = 0, c.prototype._maxListeners = void 0;
                        var d = 10;
                        function h(x) {
                            if (typeof x != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof x);
                        }
                        Object.defineProperty(c, "defaultMaxListeners", {
                            enumerable: !0,
                            get: function() {
                                return d;
                            },
                            set: function(x) {
                                if (typeof x != "number" || x < 0 || l(x)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + x + ".");
                                d = x;
                            }
                        }), c.init = function() {
                            (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                        }, c.prototype.setMaxListeners = function(C) {
                            if (typeof C != "number" || C < 0 || l(C)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + C + ".");
                            return this._maxListeners = C, this;
                        };
                        function f(x) {
                            return x._maxListeners === void 0 ? c.defaultMaxListeners : x._maxListeners;
                        }
                        c.prototype.getMaxListeners = function() {
                            return f(this);
                        }, c.prototype.emit = function(C) {
                            for(var I = [], M = 1; M < arguments.length; M++)I.push(arguments[M]);
                            var Q = C === "error", H = this._events;
                            if (H !== void 0) Q = Q && H.error === void 0;
                            else if (!Q) return !1;
                            if (Q) {
                                var J;
                                if (I.length > 0 && (J = I[0]), J instanceof Error) throw J;
                                var W = new Error("Unhandled error." + (J ? " (" + J.message + ")" : ""));
                                throw W.context = J, W;
                            }
                            var P = H[C];
                            if (P === void 0) return !1;
                            if (typeof P == "function") s(P, this, I);
                            else for(var R = P.length, V = A(P, R), M = 0; M < R; ++M)s(V[M], this, I);
                            return !0;
                        };
                        function p(x, C, I, M) {
                            var Q, H, J;
                            if (h(I), H = x._events, H === void 0 ? (H = x._events = /* @__PURE__ */ Object.create(null), x._eventsCount = 0) : (H.newListener !== void 0 && (x.emit("newListener", C, I.listener ? I.listener : I), H = x._events), J = H[C]), J === void 0) J = H[C] = I, ++x._eventsCount;
                            else if (typeof J == "function" ? J = H[C] = M ? [
                                I,
                                J
                            ] : [
                                J,
                                I
                            ] : M ? J.unshift(I) : J.push(I), Q = f(x), Q > 0 && J.length > Q && !J.warned) {
                                J.warned = !0;
                                var W = new Error("Possible EventEmitter memory leak detected. " + J.length + " " + String(C) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                                W.name = "MaxListenersExceededWarning", W.emitter = x, W.type = C, W.count = J.length, u(W);
                            }
                            return x;
                        }
                        c.prototype.addListener = function(C, I) {
                            return p(this, C, I, !1);
                        }, c.prototype.on = c.prototype.addListener, c.prototype.prependListener = function(C, I) {
                            return p(this, C, I, !0);
                        };
                        function m() {
                            if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                        }
                        function w(x, C, I) {
                            var M = {
                                fired: !1,
                                wrapFn: void 0,
                                target: x,
                                type: C,
                                listener: I
                            }, Q = m.bind(M);
                            return Q.listener = I, M.wrapFn = Q, Q;
                        }
                        c.prototype.once = function(C, I) {
                            return h(I), this.on(C, w(this, C, I)), this;
                        }, c.prototype.prependOnceListener = function(C, I) {
                            return h(I), this.prependListener(C, w(this, C, I)), this;
                        }, c.prototype.removeListener = function(C, I) {
                            var M, Q, H, J, W;
                            if (h(I), Q = this._events, Q === void 0) return this;
                            if (M = Q[C], M === void 0) return this;
                            if (M === I || M.listener === I) --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Q[C], Q.removeListener && this.emit("removeListener", C, M.listener || I));
                            else if (typeof M != "function") {
                                for(H = -1, J = M.length - 1; J >= 0; J--)if (M[J] === I || M[J].listener === I) {
                                    W = M[J].listener, H = J;
                                    break;
                                }
                                if (H < 0) return this;
                                H === 0 ? M.shift() : b(M, H), M.length === 1 && (Q[C] = M[0]), Q.removeListener !== void 0 && this.emit("removeListener", C, W || I);
                            }
                            return this;
                        }, c.prototype.off = c.prototype.removeListener, c.prototype.removeAllListeners = function(C) {
                            var I, M, Q;
                            if (M = this._events, M === void 0) return this;
                            if (M.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : M[C] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete M[C]), this;
                            if (arguments.length === 0) {
                                var H = Object.keys(M), J;
                                for(Q = 0; Q < H.length; ++Q)J = H[Q], J !== "removeListener" && this.removeAllListeners(J);
                                return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
                            }
                            if (I = M[C], typeof I == "function") this.removeListener(C, I);
                            else if (I !== void 0) for(Q = I.length - 1; Q >= 0; Q--)this.removeListener(C, I[Q]);
                            return this;
                        };
                        function v(x, C, I) {
                            var M = x._events;
                            if (M === void 0) return [];
                            var Q = M[C];
                            return Q === void 0 ? [] : typeof Q == "function" ? I ? [
                                Q.listener || Q
                            ] : [
                                Q
                            ] : I ? k(Q) : A(Q, Q.length);
                        }
                        c.prototype.listeners = function(C) {
                            return v(this, C, !0);
                        }, c.prototype.rawListeners = function(C) {
                            return v(this, C, !1);
                        }, c.listenerCount = function(x, C) {
                            return typeof x.listenerCount == "function" ? x.listenerCount(C) : g.call(x, C);
                        }, c.prototype.listenerCount = g;
                        function g(x) {
                            var C = this._events;
                            if (C !== void 0) {
                                var I = C[x];
                                if (typeof I == "function") return 1;
                                if (I !== void 0) return I.length;
                            }
                            return 0;
                        }
                        c.prototype.eventNames = function() {
                            return this._eventsCount > 0 ? a(this._events) : [];
                        };
                        function A(x, C) {
                            for(var I = new Array(C), M = 0; M < C; ++M)I[M] = x[M];
                            return I;
                        }
                        function b(x, C) {
                            for(; C + 1 < x.length; C++)x[C] = x[C + 1];
                            x.pop();
                        }
                        function k(x) {
                            for(var C = new Array(x.length), I = 0; I < C.length; ++I)C[I] = x[I].listener || x[I];
                            return C;
                        }
                        function y(x, C) {
                            return new Promise(function(I, M) {
                                function Q() {
                                    H !== void 0 && x.removeListener("error", H), I([].slice.call(arguments));
                                }
                                var H;
                                C !== "error" && (H = function(W) {
                                    x.removeListener(C, Q), M(W);
                                }, x.once("error", H)), x.once(C, Q);
                            });
                        }
                    },
                    {}
                ],
                37: [
                    function(r, i, n) {
                        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ n.read = function(o, s, a, u, l) {
                            var c, d, h = l * 8 - u - 1, f = (1 << h) - 1, p = f >> 1, m = -7, w = a ? l - 1 : 0, v = a ? -1 : 1, g = o[s + w];
                            for(w += v, c = g & (1 << -m) - 1, g >>= -m, m += h; m > 0; c = c * 256 + o[s + w], w += v, m -= 8);
                            for(d = c & (1 << -m) - 1, c >>= -m, m += u; m > 0; d = d * 256 + o[s + w], w += v, m -= 8);
                            if (c === 0) c = 1 - p;
                            else {
                                if (c === f) return d ? NaN : (g ? -1 : 1) * (1 / 0);
                                d = d + Math.pow(2, u), c = c - p;
                            }
                            return (g ? -1 : 1) * d * Math.pow(2, c - u);
                        }, n.write = function(o, s, a, u, l, c) {
                            var d, h, f, p = c * 8 - l - 1, m = (1 << p) - 1, w = m >> 1, v = l === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, g = u ? 0 : c - 1, A = u ? 1 : -1, b = s < 0 || s === 0 && 1 / s < 0 ? 1 : 0;
                            for(s = Math.abs(s), isNaN(s) || s === 1 / 0 ? (h = isNaN(s) ? 1 : 0, d = m) : (d = Math.floor(Math.log(s) / Math.LN2), s * (f = Math.pow(2, -d)) < 1 && (d--, f *= 2), d + w >= 1 ? s += v / f : s += v * Math.pow(2, 1 - w), s * f >= 2 && (d++, f /= 2), d + w >= m ? (h = 0, d = m) : d + w >= 1 ? (h = (s * f - 1) * Math.pow(2, l), d = d + w) : (h = s * Math.pow(2, w - 1) * Math.pow(2, l), d = 0)); l >= 8; o[a + g] = h & 255, g += A, h /= 256, l -= 8);
                            for(d = d << l | h, p += l; p > 0; o[a + g] = d & 255, g += A, d /= 256, p -= 8);
                            o[a + g - A] |= b * 128;
                        };
                    },
                    {}
                ],
                38: [
                    function(r, i, n) {
                        typeof Object.create == "function" ? i.exports = function(s, a) {
                            a && (s.super_ = a, s.prototype = Object.create(a.prototype, {
                                constructor: {
                                    value: s,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }));
                        } : i.exports = function(s, a) {
                            if (a) {
                                s.super_ = a;
                                var u = function() {};
                                u.prototype = a.prototype, s.prototype = new u(), s.prototype.constructor = s;
                            }
                        };
                    },
                    {}
                ],
                39: [
                    function(r, i, n) {
                        var o = i.exports = {}, s, a;
                        function u() {
                            throw new Error("setTimeout has not been defined");
                        }
                        function l() {
                            throw new Error("clearTimeout has not been defined");
                        }
                        (function() {
                            try {
                                typeof setTimeout == "function" ? s = setTimeout : s = u;
                            } catch  {
                                s = u;
                            }
                            try {
                                typeof clearTimeout == "function" ? a = clearTimeout : a = l;
                            } catch  {
                                a = l;
                            }
                        })();
                        function c(b) {
                            if (s === setTimeout) return setTimeout(b, 0);
                            if ((s === u || !s) && setTimeout) return s = setTimeout, setTimeout(b, 0);
                            try {
                                return s(b, 0);
                            } catch  {
                                try {
                                    return s.call(null, b, 0);
                                } catch  {
                                    return s.call(this, b, 0);
                                }
                            }
                        }
                        function d(b) {
                            if (a === clearTimeout) return clearTimeout(b);
                            if ((a === l || !a) && clearTimeout) return a = clearTimeout, clearTimeout(b);
                            try {
                                return a(b);
                            } catch  {
                                try {
                                    return a.call(null, b);
                                } catch  {
                                    return a.call(this, b);
                                }
                            }
                        }
                        var h = [], f = !1, p, m = -1;
                        function w() {
                            !f || !p || (f = !1, p.length ? h = p.concat(h) : m = -1, h.length && v());
                        }
                        function v() {
                            if (!f) {
                                var b = c(w);
                                f = !0;
                                for(var k = h.length; k;){
                                    for(p = h, h = []; ++m < k;)p && p[m].run();
                                    m = -1, k = h.length;
                                }
                                p = null, f = !1, d(b);
                            }
                        }
                        o.nextTick = function(b) {
                            var k = new Array(arguments.length - 1);
                            if (arguments.length > 1) for(var y = 1; y < arguments.length; y++)k[y - 1] = arguments[y];
                            h.push(new g(b, k)), h.length === 1 && !f && c(v);
                        };
                        function g(b, k) {
                            this.fun = b, this.array = k;
                        }
                        g.prototype.run = function() {
                            this.fun.apply(null, this.array);
                        }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {};
                        function A() {}
                        o.on = A, o.addListener = A, o.once = A, o.off = A, o.removeListener = A, o.removeAllListeners = A, o.emit = A, o.prependListener = A, o.prependOnceListener = A, o.listeners = function(b) {
                            return [];
                        }, o.binding = function(b) {
                            throw new Error("process.binding is not supported");
                        }, o.cwd = function() {
                            return "/";
                        }, o.chdir = function(b) {
                            throw new Error("process.chdir is not supported");
                        }, o.umask = function() {
                            return 0;
                        };
                    },
                    {}
                ],
                40: [
                    function(r, i, n) {
                        /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ var o = r("buffer"), s = o.Buffer;
                        function a(l, c) {
                            for(var d in l)c[d] = l[d];
                        }
                        s.from && s.alloc && s.allocUnsafe && s.allocUnsafeSlow ? i.exports = o : (a(o, n), n.Buffer = u);
                        function u(l, c, d) {
                            return s(l, c, d);
                        }
                        u.prototype = Object.create(s.prototype), a(s, u), u.from = function(l, c, d) {
                            if (typeof l == "number") throw new TypeError("Argument must not be a number");
                            return s(l, c, d);
                        }, u.alloc = function(l, c, d) {
                            if (typeof l != "number") throw new TypeError("Argument must be a number");
                            var h = s(l);
                            return c !== void 0 ? typeof d == "string" ? h.fill(c, d) : h.fill(c) : h.fill(0), h;
                        }, u.allocUnsafe = function(l) {
                            if (typeof l != "number") throw new TypeError("Argument must be a number");
                            return s(l);
                        }, u.allocUnsafeSlow = function(l) {
                            if (typeof l != "number") throw new TypeError("Argument must be a number");
                            return o.SlowBuffer(l);
                        };
                    },
                    {
                        buffer: 35
                    }
                ],
                41: [
                    function(r, i, n) {
                        i.exports = a;
                        var o = r("events").EventEmitter, s = r("inherits");
                        s(a, o), a.Readable = r("readable-stream/lib/_stream_readable.js"), a.Writable = r("readable-stream/lib/_stream_writable.js"), a.Duplex = r("readable-stream/lib/_stream_duplex.js"), a.Transform = r("readable-stream/lib/_stream_transform.js"), a.PassThrough = r("readable-stream/lib/_stream_passthrough.js"), a.finished = r("readable-stream/lib/internal/streams/end-of-stream.js"), a.pipeline = r("readable-stream/lib/internal/streams/pipeline.js"), a.Stream = a;
                        function a() {
                            o.call(this);
                        }
                        a.prototype.pipe = function(u, l) {
                            var c = this;
                            function d(g) {
                                u.writable && u.write(g) === !1 && c.pause && c.pause();
                            }
                            c.on("data", d);
                            function h() {
                                c.readable && c.resume && c.resume();
                            }
                            u.on("drain", h), !u._isStdio && (!l || l.end !== !1) && (c.on("end", p), c.on("close", m));
                            var f = !1;
                            function p() {
                                f || (f = !0, u.end());
                            }
                            function m() {
                                f || (f = !0, typeof u.destroy == "function" && u.destroy());
                            }
                            function w(g) {
                                if (v(), o.listenerCount(this, "error") === 0) throw g;
                            }
                            c.on("error", w), u.on("error", w);
                            function v() {
                                c.removeListener("data", d), u.removeListener("drain", h), c.removeListener("end", p), c.removeListener("close", m), c.removeListener("error", w), u.removeListener("error", w), c.removeListener("end", v), c.removeListener("close", v), u.removeListener("close", v);
                            }
                            return c.on("end", v), c.on("close", v), u.on("close", v), u.emit("pipe", c), u;
                        };
                    },
                    {
                        events: 36,
                        inherits: 38,
                        "readable-stream/lib/_stream_duplex.js": 43,
                        "readable-stream/lib/_stream_passthrough.js": 44,
                        "readable-stream/lib/_stream_readable.js": 45,
                        "readable-stream/lib/_stream_transform.js": 46,
                        "readable-stream/lib/_stream_writable.js": 47,
                        "readable-stream/lib/internal/streams/end-of-stream.js": 51,
                        "readable-stream/lib/internal/streams/pipeline.js": 53
                    }
                ],
                42: [
                    function(r, i, n) {
                        function o(h, f) {
                            h.prototype = Object.create(f.prototype), h.prototype.constructor = h, h.__proto__ = f;
                        }
                        var s = {};
                        function a(h, f, p) {
                            p || (p = Error);
                            function m(v, g, A) {
                                return typeof f == "string" ? f : f(v, g, A);
                            }
                            var w = /* @__PURE__ */ function(v) {
                                o(g, v);
                                function g(A, b, k) {
                                    return v.call(this, m(A, b, k)) || this;
                                }
                                return g;
                            }(p);
                            w.prototype.name = p.name, w.prototype.code = h, s[h] = w;
                        }
                        function u(h, f) {
                            if (Array.isArray(h)) {
                                var p = h.length;
                                return h = h.map(function(m) {
                                    return String(m);
                                }), p > 2 ? "one of ".concat(f, " ").concat(h.slice(0, p - 1).join(", "), ", or ") + h[p - 1] : p === 2 ? "one of ".concat(f, " ").concat(h[0], " or ").concat(h[1]) : "of ".concat(f, " ").concat(h[0]);
                            } else return "of ".concat(f, " ").concat(String(h));
                        }
                        function l(h, f, p) {
                            return h.substr(0, f.length) === f;
                        }
                        function c(h, f, p) {
                            return (p === void 0 || p > h.length) && (p = h.length), h.substring(p - f.length, p) === f;
                        }
                        function d(h, f, p) {
                            return typeof p != "number" && (p = 0), p + f.length > h.length ? !1 : h.indexOf(f, p) !== -1;
                        }
                        a("ERR_INVALID_OPT_VALUE", function(h, f) {
                            return 'The value "' + f + '" is invalid for option "' + h + '"';
                        }, TypeError), a("ERR_INVALID_ARG_TYPE", function(h, f, p) {
                            var m;
                            typeof f == "string" && l(f, "not ") ? (m = "must not be", f = f.replace(/^not /, "")) : m = "must be";
                            var w;
                            if (c(h, " argument")) w = "The ".concat(h, " ").concat(m, " ").concat(u(f, "type"));
                            else {
                                var v = d(h, ".") ? "property" : "argument";
                                w = 'The "'.concat(h, '" ').concat(v, " ").concat(m, " ").concat(u(f, "type"));
                            }
                            return w += ". Received type ".concat(typeof p), w;
                        }, TypeError), a("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), a("ERR_METHOD_NOT_IMPLEMENTED", function(h) {
                            return "The " + h + " method is not implemented";
                        }), a("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), a("ERR_STREAM_DESTROYED", function(h) {
                            return "Cannot call " + h + " after a stream was destroyed";
                        }), a("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), a("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), a("ERR_STREAM_WRITE_AFTER_END", "write after end"), a("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), a("ERR_UNKNOWN_ENCODING", function(h) {
                            return "Unknown encoding: " + h;
                        }, TypeError), a("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), i.exports.codes = s;
                    },
                    {}
                ],
                43: [
                    function(r, i, n) {
                        (function(o) {
                            (function() {
                                var s = Object.keys || function(m) {
                                    var w = [];
                                    for(var v in m)w.push(v);
                                    return w;
                                };
                                i.exports = h;
                                var a = r("./_stream_readable"), u = r("./_stream_writable");
                                r("inherits")(h, a);
                                for(var l = s(u.prototype), c = 0; c < l.length; c++){
                                    var d = l[c];
                                    h.prototype[d] || (h.prototype[d] = u.prototype[d]);
                                }
                                function h(m) {
                                    if (!(this instanceof h)) return new h(m);
                                    a.call(this, m), u.call(this, m), this.allowHalfOpen = !0, m && (m.readable === !1 && (this.readable = !1), m.writable === !1 && (this.writable = !1), m.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", f)));
                                }
                                Object.defineProperty(h.prototype, "writableHighWaterMark", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._writableState.highWaterMark;
                                    }
                                }), Object.defineProperty(h.prototype, "writableBuffer", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._writableState && this._writableState.getBuffer();
                                    }
                                }), Object.defineProperty(h.prototype, "writableLength", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._writableState.length;
                                    }
                                });
                                function f() {
                                    this._writableState.ended || o.nextTick(p, this);
                                }
                                function p(m) {
                                    m.end();
                                }
                                Object.defineProperty(h.prototype, "destroyed", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
                                    },
                                    set: function(w) {
                                        this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = w, this._writableState.destroyed = w);
                                    }
                                });
                            }).call(this);
                        }).call(this, r("_process"));
                    },
                    {
                        "./_stream_readable": 45,
                        "./_stream_writable": 47,
                        _process: 39,
                        inherits: 38
                    }
                ],
                44: [
                    function(r, i, n) {
                        i.exports = s;
                        var o = r("./_stream_transform");
                        r("inherits")(s, o);
                        function s(a) {
                            if (!(this instanceof s)) return new s(a);
                            o.call(this, a);
                        }
                        s.prototype._transform = function(a, u, l) {
                            l(null, a);
                        };
                    },
                    {
                        "./_stream_transform": 46,
                        inherits: 38
                    }
                ],
                45: [
                    function(r, i, n) {
                        (function(o, s) {
                            (function() {
                                i.exports = R;
                                var a;
                                R.ReadableState = P, r("events").EventEmitter;
                                var u = function(B, D) {
                                    return B.listeners(D).length;
                                }, l = r("./internal/streams/stream"), c = r("buffer").Buffer, d = s.Uint8Array || function() {};
                                function h(L) {
                                    return c.from(L);
                                }
                                function f(L) {
                                    return c.isBuffer(L) || L instanceof d;
                                }
                                var p = r("util"), m;
                                p && p.debuglog ? m = p.debuglog("stream") : m = function() {};
                                var w = r("./internal/streams/buffer_list"), v = r("./internal/streams/destroy"), g = r("./internal/streams/state"), A = g.getHighWaterMark, b = r("../errors").codes, k = b.ERR_INVALID_ARG_TYPE, y = b.ERR_STREAM_PUSH_AFTER_EOF, x = b.ERR_METHOD_NOT_IMPLEMENTED, C = b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, I, M, Q;
                                r("inherits")(R, l);
                                var H = v.errorOrDestroy, J = [
                                    "error",
                                    "close",
                                    "destroy",
                                    "pause",
                                    "resume"
                                ];
                                function W(L, B, D) {
                                    if (typeof L.prependListener == "function") return L.prependListener(B, D);
                                    !L._events || !L._events[B] ? L.on(B, D) : Array.isArray(L._events[B]) ? L._events[B].unshift(D) : L._events[B] = [
                                        D,
                                        L._events[B]
                                    ];
                                }
                                function P(L, B, D) {
                                    a = a || r("./_stream_duplex"), L = L || {}, typeof D != "boolean" && (D = B instanceof a), this.objectMode = !!L.objectMode, D && (this.objectMode = this.objectMode || !!L.readableObjectMode), this.highWaterMark = A(this, L, "readableHighWaterMark", D), this.buffer = new w(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = L.emitClose !== !1, this.autoDestroy = !!L.autoDestroy, this.destroyed = !1, this.defaultEncoding = L.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, L.encoding && (I || (I = r("string_decoder/").StringDecoder), this.decoder = new I(L.encoding), this.encoding = L.encoding);
                                }
                                function R(L) {
                                    if (a = a || r("./_stream_duplex"), !(this instanceof R)) return new R(L);
                                    var B = this instanceof a;
                                    this._readableState = new P(L, this, B), this.readable = !0, L && (typeof L.read == "function" && (this._read = L.read), typeof L.destroy == "function" && (this._destroy = L.destroy)), l.call(this);
                                }
                                Object.defineProperty(R.prototype, "destroyed", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._readableState === void 0 ? !1 : this._readableState.destroyed;
                                    },
                                    set: function(B) {
                                        this._readableState && (this._readableState.destroyed = B);
                                    }
                                }), R.prototype.destroy = v.destroy, R.prototype._undestroy = v.undestroy, R.prototype._destroy = function(L, B) {
                                    B(L);
                                }, R.prototype.push = function(L, B) {
                                    var D = this._readableState, E;
                                    return D.objectMode ? E = !0 : typeof L == "string" && (B = B || D.defaultEncoding, B !== D.encoding && (L = c.from(L, B), B = ""), E = !0), V(this, L, B, !1, E);
                                }, R.prototype.unshift = function(L) {
                                    return V(this, L, null, !0, !1);
                                };
                                function V(L, B, D, E, T) {
                                    m("readableAddChunk", B);
                                    var j = L._readableState;
                                    if (B === null) j.reading = !1, oe(L, j);
                                    else {
                                        var Y;
                                        if (T || (Y = N(j, B)), Y) H(L, Y);
                                        else if (j.objectMode || B && B.length > 0) {
                                            if (typeof B != "string" && !j.objectMode && Object.getPrototypeOf(B) !== c.prototype && (B = h(B)), E) j.endEmitted ? H(L, new C()) : X(L, j, B, !0);
                                            else if (j.ended) H(L, new y());
                                            else {
                                                if (j.destroyed) return !1;
                                                j.reading = !1, j.decoder && !D ? (B = j.decoder.write(B), j.objectMode || B.length !== 0 ? X(L, j, B, !1) : he(L, j)) : X(L, j, B, !1);
                                            }
                                        } else E || (j.reading = !1, he(L, j));
                                    }
                                    return !j.ended && (j.length < j.highWaterMark || j.length === 0);
                                }
                                function X(L, B, D, E) {
                                    B.flowing && B.length === 0 && !B.sync ? (B.awaitDrain = 0, L.emit("data", D)) : (B.length += B.objectMode ? 1 : D.length, E ? B.buffer.unshift(D) : B.buffer.push(D), B.needReadable && ie(L)), he(L, B);
                                }
                                function N(L, B) {
                                    var D;
                                    return !f(B) && typeof B != "string" && B !== void 0 && !L.objectMode && (D = new k("chunk", [
                                        "string",
                                        "Buffer",
                                        "Uint8Array"
                                    ], B)), D;
                                }
                                R.prototype.isPaused = function() {
                                    return this._readableState.flowing === !1;
                                }, R.prototype.setEncoding = function(L) {
                                    I || (I = r("string_decoder/").StringDecoder);
                                    var B = new I(L);
                                    this._readableState.decoder = B, this._readableState.encoding = this._readableState.decoder.encoding;
                                    for(var D = this._readableState.buffer.head, E = ""; D !== null;)E += B.write(D.data), D = D.next;
                                    return this._readableState.buffer.clear(), E !== "" && this._readableState.buffer.push(E), this._readableState.length = E.length, this;
                                };
                                var U = 1073741824;
                                function G(L) {
                                    return L >= U ? L = U : (L--, L |= L >>> 1, L |= L >>> 2, L |= L >>> 4, L |= L >>> 8, L |= L >>> 16, L++), L;
                                }
                                function re(L, B) {
                                    return L <= 0 || B.length === 0 && B.ended ? 0 : B.objectMode ? 1 : L !== L ? B.flowing && B.length ? B.buffer.head.data.length : B.length : (L > B.highWaterMark && (B.highWaterMark = G(L)), L <= B.length ? L : B.ended ? B.length : (B.needReadable = !0, 0));
                                }
                                R.prototype.read = function(L) {
                                    m("read", L), L = parseInt(L, 10);
                                    var B = this._readableState, D = L;
                                    if (L !== 0 && (B.emittedReadable = !1), L === 0 && B.needReadable && ((B.highWaterMark !== 0 ? B.length >= B.highWaterMark : B.length > 0) || B.ended)) return m("read: emitReadable", B.length, B.ended), B.length === 0 && B.ended ? ue(this) : ie(this), null;
                                    if (L = re(L, B), L === 0 && B.ended) return B.length === 0 && ue(this), null;
                                    var E = B.needReadable;
                                    m("need readable", E), (B.length === 0 || B.length - L < B.highWaterMark) && (E = !0, m("length less than watermark", E)), B.ended || B.reading ? (E = !1, m("reading or ended", E)) : E && (m("do read"), B.reading = !0, B.sync = !0, B.length === 0 && (B.needReadable = !0), this._read(B.highWaterMark), B.sync = !1, B.reading || (L = re(D, B)));
                                    var T;
                                    return L > 0 ? T = Z(L, B) : T = null, T === null ? (B.needReadable = B.length <= B.highWaterMark, L = 0) : (B.length -= L, B.awaitDrain = 0), B.length === 0 && (B.ended || (B.needReadable = !0), D !== L && B.ended && ue(this)), T !== null && this.emit("data", T), T;
                                };
                                function oe(L, B) {
                                    if (m("onEofChunk"), !B.ended) {
                                        if (B.decoder) {
                                            var D = B.decoder.end();
                                            D && D.length && (B.buffer.push(D), B.length += B.objectMode ? 1 : D.length);
                                        }
                                        B.ended = !0, B.sync ? ie(L) : (B.needReadable = !1, B.emittedReadable || (B.emittedReadable = !0, le(L)));
                                    }
                                }
                                function ie(L) {
                                    var B = L._readableState;
                                    m("emitReadable", B.needReadable, B.emittedReadable), B.needReadable = !1, B.emittedReadable || (m("emitReadable", B.flowing), B.emittedReadable = !0, o.nextTick(le, L));
                                }
                                function le(L) {
                                    var B = L._readableState;
                                    m("emitReadable_", B.destroyed, B.length, B.ended), !B.destroyed && (B.length || B.ended) && (L.emit("readable"), B.emittedReadable = !1), B.needReadable = !B.flowing && !B.ended && B.length <= B.highWaterMark, te(L);
                                }
                                function he(L, B) {
                                    B.readingMore || (B.readingMore = !0, o.nextTick(ye, L, B));
                                }
                                function ye(L, B) {
                                    for(; !B.reading && !B.ended && (B.length < B.highWaterMark || B.flowing && B.length === 0);){
                                        var D = B.length;
                                        if (m("maybeReadMore read 0"), L.read(0), D === B.length) break;
                                    }
                                    B.readingMore = !1;
                                }
                                R.prototype._read = function(L) {
                                    H(this, new x("_read()"));
                                }, R.prototype.pipe = function(L, B) {
                                    var D = this, E = this._readableState;
                                    switch(E.pipesCount){
                                        case 0:
                                            E.pipes = L;
                                            break;
                                        case 1:
                                            E.pipes = [
                                                E.pipes,
                                                L
                                            ];
                                            break;
                                        default:
                                            E.pipes.push(L);
                                            break;
                                    }
                                    E.pipesCount += 1, m("pipe count=%d opts=%j", E.pipesCount, B);
                                    var T = (!B || B.end !== !1) && L !== o.stdout && L !== o.stderr, j = T ? ae : ee;
                                    E.endEmitted ? o.nextTick(j) : D.once("end", j), L.on("unpipe", Y);
                                    function Y(de, ge) {
                                        m("onunpipe"), de === D && ge && ge.hasUnpiped === !1 && (ge.hasUnpiped = !0, _());
                                    }
                                    function ae() {
                                        m("onend"), L.end();
                                    }
                                    var se = be(D);
                                    L.on("drain", se);
                                    var O = !1;
                                    function _() {
                                        m("cleanup"), L.removeListener("close", $), L.removeListener("finish", K), L.removeListener("drain", se), L.removeListener("error", F), L.removeListener("unpipe", Y), D.removeListener("end", ae), D.removeListener("end", ee), D.removeListener("data", S), O = !0, E.awaitDrain && (!L._writableState || L._writableState.needDrain) && se();
                                    }
                                    D.on("data", S);
                                    function S(de) {
                                        m("ondata");
                                        var ge = L.write(de);
                                        m("dest.write", ge), ge === !1 && ((E.pipesCount === 1 && E.pipes === L || E.pipesCount > 1 && me(E.pipes, L) !== -1) && !O && (m("false write response, pause", E.awaitDrain), E.awaitDrain++), D.pause());
                                    }
                                    function F(de) {
                                        m("onerror", de), ee(), L.removeListener("error", F), u(L, "error") === 0 && H(L, de);
                                    }
                                    W(L, "error", F);
                                    function $() {
                                        L.removeListener("finish", K), ee();
                                    }
                                    L.once("close", $);
                                    function K() {
                                        m("onfinish"), L.removeListener("close", $), ee();
                                    }
                                    L.once("finish", K);
                                    function ee() {
                                        m("unpipe"), D.unpipe(L);
                                    }
                                    return L.emit("pipe", D), E.flowing || (m("pipe resume"), D.resume()), L;
                                };
                                function be(L) {
                                    return function() {
                                        var D = L._readableState;
                                        m("pipeOnDrain", D.awaitDrain), D.awaitDrain && D.awaitDrain--, D.awaitDrain === 0 && u(L, "data") && (D.flowing = !0, te(L));
                                    };
                                }
                                R.prototype.unpipe = function(L) {
                                    var B = this._readableState, D = {
                                        hasUnpiped: !1
                                    };
                                    if (B.pipesCount === 0) return this;
                                    if (B.pipesCount === 1) return L && L !== B.pipes ? this : (L || (L = B.pipes), B.pipes = null, B.pipesCount = 0, B.flowing = !1, L && L.emit("unpipe", this, D), this);
                                    if (!L) {
                                        var E = B.pipes, T = B.pipesCount;
                                        B.pipes = null, B.pipesCount = 0, B.flowing = !1;
                                        for(var j = 0; j < T; j++)E[j].emit("unpipe", this, {
                                            hasUnpiped: !1
                                        });
                                        return this;
                                    }
                                    var Y = me(B.pipes, L);
                                    return Y === -1 ? this : (B.pipes.splice(Y, 1), B.pipesCount -= 1, B.pipesCount === 1 && (B.pipes = B.pipes[0]), L.emit("unpipe", this, D), this);
                                }, R.prototype.on = function(L, B) {
                                    var D = l.prototype.on.call(this, L, B), E = this._readableState;
                                    return L === "data" ? (E.readableListening = this.listenerCount("readable") > 0, E.flowing !== !1 && this.resume()) : L === "readable" && !E.endEmitted && !E.readableListening && (E.readableListening = E.needReadable = !0, E.flowing = !1, E.emittedReadable = !1, m("on readable", E.length, E.reading), E.length ? ie(this) : E.reading || o.nextTick(ve, this)), D;
                                }, R.prototype.addListener = R.prototype.on, R.prototype.removeListener = function(L, B) {
                                    var D = l.prototype.removeListener.call(this, L, B);
                                    return L === "readable" && o.nextTick(we, this), D;
                                }, R.prototype.removeAllListeners = function(L) {
                                    var B = l.prototype.removeAllListeners.apply(this, arguments);
                                    return (L === "readable" || L === void 0) && o.nextTick(we, this), B;
                                };
                                function we(L) {
                                    var B = L._readableState;
                                    B.readableListening = L.listenerCount("readable") > 0, B.resumeScheduled && !B.paused ? B.flowing = !0 : L.listenerCount("data") > 0 && L.resume();
                                }
                                function ve(L) {
                                    m("readable nexttick read 0"), L.read(0);
                                }
                                R.prototype.resume = function() {
                                    var L = this._readableState;
                                    return L.flowing || (m("resume"), L.flowing = !L.readableListening, Re(this, L)), L.paused = !1, this;
                                };
                                function Re(L, B) {
                                    B.resumeScheduled || (B.resumeScheduled = !0, o.nextTick(De, L, B));
                                }
                                function De(L, B) {
                                    m("resume", B.reading), B.reading || L.read(0), B.resumeScheduled = !1, L.emit("resume"), te(L), B.flowing && !B.reading && L.read(0);
                                }
                                R.prototype.pause = function() {
                                    return m("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (m("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                                };
                                function te(L) {
                                    var B = L._readableState;
                                    for(m("flow", B.flowing); B.flowing && L.read() !== null;);
                                }
                                R.prototype.wrap = function(L) {
                                    var B = this, D = this._readableState, E = !1;
                                    L.on("end", function() {
                                        if (m("wrapped end"), D.decoder && !D.ended) {
                                            var Y = D.decoder.end();
                                            Y && Y.length && B.push(Y);
                                        }
                                        B.push(null);
                                    }), L.on("data", function(Y) {
                                        if (m("wrapped data"), D.decoder && (Y = D.decoder.write(Y)), !(D.objectMode && Y == null) && !(!D.objectMode && (!Y || !Y.length))) {
                                            var ae = B.push(Y);
                                            ae || (E = !0, L.pause());
                                        }
                                    });
                                    for(var T in L)this[T] === void 0 && typeof L[T] == "function" && (this[T] = /* @__PURE__ */ function(ae) {
                                        return function() {
                                            return L[ae].apply(L, arguments);
                                        };
                                    }(T));
                                    for(var j = 0; j < J.length; j++)L.on(J[j], this.emit.bind(this, J[j]));
                                    return this._read = function(Y) {
                                        m("wrapped _read", Y), E && (E = !1, L.resume());
                                    }, this;
                                }, typeof Symbol == "function" && (R.prototype[Symbol.asyncIterator] = function() {
                                    return M === void 0 && (M = r("./internal/streams/async_iterator")), M(this);
                                }), Object.defineProperty(R.prototype, "readableHighWaterMark", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._readableState.highWaterMark;
                                    }
                                }), Object.defineProperty(R.prototype, "readableBuffer", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._readableState && this._readableState.buffer;
                                    }
                                }), Object.defineProperty(R.prototype, "readableFlowing", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._readableState.flowing;
                                    },
                                    set: function(B) {
                                        this._readableState && (this._readableState.flowing = B);
                                    }
                                }), R._fromList = Z, Object.defineProperty(R.prototype, "readableLength", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._readableState.length;
                                    }
                                });
                                function Z(L, B) {
                                    if (B.length === 0) return null;
                                    var D;
                                    return B.objectMode ? D = B.buffer.shift() : !L || L >= B.length ? (B.decoder ? D = B.buffer.join("") : B.buffer.length === 1 ? D = B.buffer.first() : D = B.buffer.concat(B.length), B.buffer.clear()) : D = B.buffer.consume(L, B.decoder), D;
                                }
                                function ue(L) {
                                    var B = L._readableState;
                                    m("endReadable", B.endEmitted), B.endEmitted || (B.ended = !0, o.nextTick(pe, B, L));
                                }
                                function pe(L, B) {
                                    if (m("endReadableNT", L.endEmitted, L.length), !L.endEmitted && L.length === 0 && (L.endEmitted = !0, B.readable = !1, B.emit("end"), L.autoDestroy)) {
                                        var D = B._writableState;
                                        (!D || D.autoDestroy && D.finished) && B.destroy();
                                    }
                                }
                                typeof Symbol == "function" && (R.from = function(L, B) {
                                    return Q === void 0 && (Q = r("./internal/streams/from")), Q(R, L, B);
                                });
                                function me(L, B) {
                                    for(var D = 0, E = L.length; D < E; D++)if (L[D] === B) return D;
                                    return -1;
                                }
                            }).call(this);
                        }).call(this, r("_process"), typeof $914aec8743edd630$var$Ne < "u" ? $914aec8743edd630$var$Ne : typeof self < "u" ? self : typeof window < "u" ? window : {});
                    },
                    {
                        "../errors": 42,
                        "./_stream_duplex": 43,
                        "./internal/streams/async_iterator": 48,
                        "./internal/streams/buffer_list": 49,
                        "./internal/streams/destroy": 50,
                        "./internal/streams/from": 52,
                        "./internal/streams/state": 54,
                        "./internal/streams/stream": 55,
                        _process: 39,
                        buffer: 35,
                        events: 36,
                        inherits: 38,
                        "string_decoder/": 56,
                        util: 33
                    }
                ],
                46: [
                    function(r, i, n) {
                        i.exports = h;
                        var o = r("../errors").codes, s = o.ERR_METHOD_NOT_IMPLEMENTED, a = o.ERR_MULTIPLE_CALLBACK, u = o.ERR_TRANSFORM_ALREADY_TRANSFORMING, l = o.ERR_TRANSFORM_WITH_LENGTH_0, c = r("./_stream_duplex");
                        r("inherits")(h, c);
                        function d(m, w) {
                            var v = this._transformState;
                            v.transforming = !1;
                            var g = v.writecb;
                            if (g === null) return this.emit("error", new a());
                            v.writechunk = null, v.writecb = null, w != null && this.push(w), g(m);
                            var A = this._readableState;
                            A.reading = !1, (A.needReadable || A.length < A.highWaterMark) && this._read(A.highWaterMark);
                        }
                        function h(m) {
                            if (!(this instanceof h)) return new h(m);
                            c.call(this, m), this._transformState = {
                                afterTransform: d.bind(this),
                                needTransform: !1,
                                transforming: !1,
                                writecb: null,
                                writechunk: null,
                                writeencoding: null
                            }, this._readableState.needReadable = !0, this._readableState.sync = !1, m && (typeof m.transform == "function" && (this._transform = m.transform), typeof m.flush == "function" && (this._flush = m.flush)), this.on("prefinish", f);
                        }
                        function f() {
                            var m = this;
                            typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(w, v) {
                                p(m, w, v);
                            }) : p(this, null, null);
                        }
                        h.prototype.push = function(m, w) {
                            return this._transformState.needTransform = !1, c.prototype.push.call(this, m, w);
                        }, h.prototype._transform = function(m, w, v) {
                            v(new s("_transform()"));
                        }, h.prototype._write = function(m, w, v) {
                            var g = this._transformState;
                            if (g.writecb = v, g.writechunk = m, g.writeencoding = w, !g.transforming) {
                                var A = this._readableState;
                                (g.needTransform || A.needReadable || A.length < A.highWaterMark) && this._read(A.highWaterMark);
                            }
                        }, h.prototype._read = function(m) {
                            var w = this._transformState;
                            w.writechunk !== null && !w.transforming ? (w.transforming = !0, this._transform(w.writechunk, w.writeencoding, w.afterTransform)) : w.needTransform = !0;
                        }, h.prototype._destroy = function(m, w) {
                            c.prototype._destroy.call(this, m, function(v) {
                                w(v);
                            });
                        };
                        function p(m, w, v) {
                            if (w) return m.emit("error", w);
                            if (v != null && m.push(v), m._writableState.length) throw new l();
                            if (m._transformState.transforming) throw new u();
                            return m.push(null);
                        }
                    },
                    {
                        "../errors": 42,
                        "./_stream_duplex": 43,
                        inherits: 38
                    }
                ],
                47: [
                    function(r, i, n) {
                        (function(o, s) {
                            (function() {
                                i.exports = P;
                                function a(te) {
                                    var Z = this;
                                    this.next = null, this.entry = null, this.finish = function() {
                                        De(Z, te);
                                    };
                                }
                                var u;
                                P.WritableState = J;
                                var l = {
                                    deprecate: r("util-deprecate")
                                }, c = r("./internal/streams/stream"), d = r("buffer").Buffer, h = s.Uint8Array || function() {};
                                function f(te) {
                                    return d.from(te);
                                }
                                function p(te) {
                                    return d.isBuffer(te) || te instanceof h;
                                }
                                var m = r("./internal/streams/destroy"), w = r("./internal/streams/state"), v = w.getHighWaterMark, g = r("../errors").codes, A = g.ERR_INVALID_ARG_TYPE, b = g.ERR_METHOD_NOT_IMPLEMENTED, k = g.ERR_MULTIPLE_CALLBACK, y = g.ERR_STREAM_CANNOT_PIPE, x = g.ERR_STREAM_DESTROYED, C = g.ERR_STREAM_NULL_VALUES, I = g.ERR_STREAM_WRITE_AFTER_END, M = g.ERR_UNKNOWN_ENCODING, Q = m.errorOrDestroy;
                                r("inherits")(P, c);
                                function H() {}
                                function J(te, Z, ue) {
                                    u = u || r("./_stream_duplex"), te = te || {}, typeof ue != "boolean" && (ue = Z instanceof u), this.objectMode = !!te.objectMode, ue && (this.objectMode = this.objectMode || !!te.writableObjectMode), this.highWaterMark = v(this, te, "writableHighWaterMark", ue), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                                    var pe = te.decodeStrings === !1;
                                    this.decodeStrings = !pe, this.defaultEncoding = te.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(me) {
                                        oe(Z, me);
                                    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = te.emitClose !== !1, this.autoDestroy = !!te.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
                                }
                                J.prototype.getBuffer = function() {
                                    for(var Z = this.bufferedRequest, ue = []; Z;)ue.push(Z), Z = Z.next;
                                    return ue;
                                }, function() {
                                    try {
                                        Object.defineProperty(J.prototype, "buffer", {
                                            get: l.deprecate(function() {
                                                return this.getBuffer();
                                            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                        });
                                    } catch  {}
                                }();
                                var W;
                                typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (W = Function.prototype[Symbol.hasInstance], Object.defineProperty(P, Symbol.hasInstance, {
                                    value: function(Z) {
                                        return W.call(this, Z) ? !0 : this !== P ? !1 : Z && Z._writableState instanceof J;
                                    }
                                })) : W = function(Z) {
                                    return Z instanceof this;
                                };
                                function P(te) {
                                    u = u || r("./_stream_duplex");
                                    var Z = this instanceof u;
                                    if (!Z && !W.call(P, this)) return new P(te);
                                    this._writableState = new J(te, this, Z), this.writable = !0, te && (typeof te.write == "function" && (this._write = te.write), typeof te.writev == "function" && (this._writev = te.writev), typeof te.destroy == "function" && (this._destroy = te.destroy), typeof te.final == "function" && (this._final = te.final)), c.call(this);
                                }
                                P.prototype.pipe = function() {
                                    Q(this, new y());
                                };
                                function R(te, Z) {
                                    var ue = new I();
                                    Q(te, ue), o.nextTick(Z, ue);
                                }
                                function V(te, Z, ue, pe) {
                                    var me;
                                    return ue === null ? me = new C() : typeof ue != "string" && !Z.objectMode && (me = new A("chunk", [
                                        "string",
                                        "Buffer"
                                    ], ue)), me ? (Q(te, me), o.nextTick(pe, me), !1) : !0;
                                }
                                P.prototype.write = function(te, Z, ue) {
                                    var pe = this._writableState, me = !1, L = !pe.objectMode && p(te);
                                    return L && !d.isBuffer(te) && (te = f(te)), typeof Z == "function" && (ue = Z, Z = null), L ? Z = "buffer" : Z || (Z = pe.defaultEncoding), typeof ue != "function" && (ue = H), pe.ending ? R(this, ue) : (L || V(this, pe, te, ue)) && (pe.pendingcb++, me = N(this, pe, L, te, Z, ue)), me;
                                }, P.prototype.cork = function() {
                                    this._writableState.corked++;
                                }, P.prototype.uncork = function() {
                                    var te = this._writableState;
                                    te.corked && (te.corked--, !te.writing && !te.corked && !te.bufferProcessing && te.bufferedRequest && he(this, te));
                                }, P.prototype.setDefaultEncoding = function(Z) {
                                    if (typeof Z == "string" && (Z = Z.toLowerCase()), !([
                                        "hex",
                                        "utf8",
                                        "utf-8",
                                        "ascii",
                                        "binary",
                                        "base64",
                                        "ucs2",
                                        "ucs-2",
                                        "utf16le",
                                        "utf-16le",
                                        "raw"
                                    ].indexOf((Z + "").toLowerCase()) > -1)) throw new M(Z);
                                    return this._writableState.defaultEncoding = Z, this;
                                }, Object.defineProperty(P.prototype, "writableBuffer", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._writableState && this._writableState.getBuffer();
                                    }
                                });
                                function X(te, Z, ue) {
                                    return !te.objectMode && te.decodeStrings !== !1 && typeof Z == "string" && (Z = d.from(Z, ue)), Z;
                                }
                                Object.defineProperty(P.prototype, "writableHighWaterMark", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._writableState.highWaterMark;
                                    }
                                });
                                function N(te, Z, ue, pe, me, L) {
                                    if (!ue) {
                                        var B = X(Z, pe, me);
                                        pe !== B && (ue = !0, me = "buffer", pe = B);
                                    }
                                    var D = Z.objectMode ? 1 : pe.length;
                                    Z.length += D;
                                    var E = Z.length < Z.highWaterMark;
                                    if (E || (Z.needDrain = !0), Z.writing || Z.corked) {
                                        var T = Z.lastBufferedRequest;
                                        Z.lastBufferedRequest = {
                                            chunk: pe,
                                            encoding: me,
                                            isBuf: ue,
                                            callback: L,
                                            next: null
                                        }, T ? T.next = Z.lastBufferedRequest : Z.bufferedRequest = Z.lastBufferedRequest, Z.bufferedRequestCount += 1;
                                    } else U(te, Z, !1, D, pe, me, L);
                                    return E;
                                }
                                function U(te, Z, ue, pe, me, L, B) {
                                    Z.writelen = pe, Z.writecb = B, Z.writing = !0, Z.sync = !0, Z.destroyed ? Z.onwrite(new x("write")) : ue ? te._writev(me, Z.onwrite) : te._write(me, L, Z.onwrite), Z.sync = !1;
                                }
                                function G(te, Z, ue, pe, me) {
                                    --Z.pendingcb, ue ? (o.nextTick(me, pe), o.nextTick(ve, te, Z), te._writableState.errorEmitted = !0, Q(te, pe)) : (me(pe), te._writableState.errorEmitted = !0, Q(te, pe), ve(te, Z));
                                }
                                function re(te) {
                                    te.writing = !1, te.writecb = null, te.length -= te.writelen, te.writelen = 0;
                                }
                                function oe(te, Z) {
                                    var ue = te._writableState, pe = ue.sync, me = ue.writecb;
                                    if (typeof me != "function") throw new k();
                                    if (re(ue), Z) G(te, ue, pe, Z, me);
                                    else {
                                        var L = ye(ue) || te.destroyed;
                                        !L && !ue.corked && !ue.bufferProcessing && ue.bufferedRequest && he(te, ue), pe ? o.nextTick(ie, te, ue, L, me) : ie(te, ue, L, me);
                                    }
                                }
                                function ie(te, Z, ue, pe) {
                                    ue || le(te, Z), Z.pendingcb--, pe(), ve(te, Z);
                                }
                                function le(te, Z) {
                                    Z.length === 0 && Z.needDrain && (Z.needDrain = !1, te.emit("drain"));
                                }
                                function he(te, Z) {
                                    Z.bufferProcessing = !0;
                                    var ue = Z.bufferedRequest;
                                    if (te._writev && ue && ue.next) {
                                        var pe = Z.bufferedRequestCount, me = new Array(pe), L = Z.corkedRequestsFree;
                                        L.entry = ue;
                                        for(var B = 0, D = !0; ue;)me[B] = ue, ue.isBuf || (D = !1), ue = ue.next, B += 1;
                                        me.allBuffers = D, U(te, Z, !0, Z.length, me, "", L.finish), Z.pendingcb++, Z.lastBufferedRequest = null, L.next ? (Z.corkedRequestsFree = L.next, L.next = null) : Z.corkedRequestsFree = new a(Z), Z.bufferedRequestCount = 0;
                                    } else {
                                        for(; ue;){
                                            var E = ue.chunk, T = ue.encoding, j = ue.callback, Y = Z.objectMode ? 1 : E.length;
                                            if (U(te, Z, !1, Y, E, T, j), ue = ue.next, Z.bufferedRequestCount--, Z.writing) break;
                                        }
                                        ue === null && (Z.lastBufferedRequest = null);
                                    }
                                    Z.bufferedRequest = ue, Z.bufferProcessing = !1;
                                }
                                P.prototype._write = function(te, Z, ue) {
                                    ue(new b("_write()"));
                                }, P.prototype._writev = null, P.prototype.end = function(te, Z, ue) {
                                    var pe = this._writableState;
                                    return typeof te == "function" ? (ue = te, te = null, Z = null) : typeof Z == "function" && (ue = Z, Z = null), te != null && this.write(te, Z), pe.corked && (pe.corked = 1, this.uncork()), pe.ending || Re(this, pe, ue), this;
                                }, Object.defineProperty(P.prototype, "writableLength", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._writableState.length;
                                    }
                                });
                                function ye(te) {
                                    return te.ending && te.length === 0 && te.bufferedRequest === null && !te.finished && !te.writing;
                                }
                                function be(te, Z) {
                                    te._final(function(ue) {
                                        Z.pendingcb--, ue && Q(te, ue), Z.prefinished = !0, te.emit("prefinish"), ve(te, Z);
                                    });
                                }
                                function we(te, Z) {
                                    !Z.prefinished && !Z.finalCalled && (typeof te._final == "function" && !Z.destroyed ? (Z.pendingcb++, Z.finalCalled = !0, o.nextTick(be, te, Z)) : (Z.prefinished = !0, te.emit("prefinish")));
                                }
                                function ve(te, Z) {
                                    var ue = ye(Z);
                                    if (ue && (we(te, Z), Z.pendingcb === 0 && (Z.finished = !0, te.emit("finish"), Z.autoDestroy))) {
                                        var pe = te._readableState;
                                        (!pe || pe.autoDestroy && pe.endEmitted) && te.destroy();
                                    }
                                    return ue;
                                }
                                function Re(te, Z, ue) {
                                    Z.ending = !0, ve(te, Z), ue && (Z.finished ? o.nextTick(ue) : te.once("finish", ue)), Z.ended = !0, te.writable = !1;
                                }
                                function De(te, Z, ue) {
                                    var pe = te.entry;
                                    for(te.entry = null; pe;){
                                        var me = pe.callback;
                                        Z.pendingcb--, me(ue), pe = pe.next;
                                    }
                                    Z.corkedRequestsFree.next = te;
                                }
                                Object.defineProperty(P.prototype, "destroyed", {
                                    // making it explicit this property is not enumerable
                                    // because otherwise some prototype manipulation in
                                    // userland will fail
                                    enumerable: !1,
                                    get: function() {
                                        return this._writableState === void 0 ? !1 : this._writableState.destroyed;
                                    },
                                    set: function(Z) {
                                        this._writableState && (this._writableState.destroyed = Z);
                                    }
                                }), P.prototype.destroy = m.destroy, P.prototype._undestroy = m.undestroy, P.prototype._destroy = function(te, Z) {
                                    Z(te);
                                };
                            }).call(this);
                        }).call(this, r("_process"), typeof $914aec8743edd630$var$Ne < "u" ? $914aec8743edd630$var$Ne : typeof self < "u" ? self : typeof window < "u" ? window : {});
                    },
                    {
                        "../errors": 42,
                        "./_stream_duplex": 43,
                        "./internal/streams/destroy": 50,
                        "./internal/streams/state": 54,
                        "./internal/streams/stream": 55,
                        _process: 39,
                        buffer: 35,
                        inherits: 38,
                        "util-deprecate": 57
                    }
                ],
                48: [
                    function(r, i, n) {
                        (function(o) {
                            (function() {
                                var s;
                                function a(x, C, I) {
                                    return C in x ? Object.defineProperty(x, C, {
                                        value: I,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }) : x[C] = I, x;
                                }
                                var u = r("./end-of-stream"), l = Symbol("lastResolve"), c = Symbol("lastReject"), d = Symbol("error"), h = Symbol("ended"), f = Symbol("lastPromise"), p = Symbol("handlePromise"), m = Symbol("stream");
                                function w(x, C) {
                                    return {
                                        value: x,
                                        done: C
                                    };
                                }
                                function v(x) {
                                    var C = x[l];
                                    if (C !== null) {
                                        var I = x[m].read();
                                        I !== null && (x[f] = null, x[l] = null, x[c] = null, C(w(I, !1)));
                                    }
                                }
                                function g(x) {
                                    o.nextTick(v, x);
                                }
                                function A(x, C) {
                                    return function(I, M) {
                                        x.then(function() {
                                            if (C[h]) {
                                                I(w(void 0, !0));
                                                return;
                                            }
                                            C[p](I, M);
                                        }, M);
                                    };
                                }
                                var b = Object.getPrototypeOf(function() {}), k = Object.setPrototypeOf((s = {
                                    get stream () {
                                        return this[m];
                                    },
                                    next: function() {
                                        var C = this, I = this[d];
                                        if (I !== null) return Promise.reject(I);
                                        if (this[h]) return Promise.resolve(w(void 0, !0));
                                        if (this[m].destroyed) return new Promise(function(J, W) {
                                            o.nextTick(function() {
                                                C[d] ? W(C[d]) : J(w(void 0, !0));
                                            });
                                        });
                                        var M = this[f], Q;
                                        if (M) Q = new Promise(A(M, this));
                                        else {
                                            var H = this[m].read();
                                            if (H !== null) return Promise.resolve(w(H, !1));
                                            Q = new Promise(this[p]);
                                        }
                                        return this[f] = Q, Q;
                                    }
                                }, a(s, Symbol.asyncIterator, function() {
                                    return this;
                                }), a(s, "return", function() {
                                    var C = this;
                                    return new Promise(function(I, M) {
                                        C[m].destroy(null, function(Q) {
                                            if (Q) {
                                                M(Q);
                                                return;
                                            }
                                            I(w(void 0, !0));
                                        });
                                    });
                                }), s), b), y = function(C) {
                                    var I, M = Object.create(k, (I = {}, a(I, m, {
                                        value: C,
                                        writable: !0
                                    }), a(I, l, {
                                        value: null,
                                        writable: !0
                                    }), a(I, c, {
                                        value: null,
                                        writable: !0
                                    }), a(I, d, {
                                        value: null,
                                        writable: !0
                                    }), a(I, h, {
                                        value: C._readableState.endEmitted,
                                        writable: !0
                                    }), a(I, p, {
                                        value: function(H, J) {
                                            var W = M[m].read();
                                            W ? (M[f] = null, M[l] = null, M[c] = null, H(w(W, !1))) : (M[l] = H, M[c] = J);
                                        },
                                        writable: !0
                                    }), I));
                                    return M[f] = null, u(C, function(Q) {
                                        if (Q && Q.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                                            var H = M[c];
                                            H !== null && (M[f] = null, M[l] = null, M[c] = null, H(Q)), M[d] = Q;
                                            return;
                                        }
                                        var J = M[l];
                                        J !== null && (M[f] = null, M[l] = null, M[c] = null, J(w(void 0, !0))), M[h] = !0;
                                    }), C.on("readable", g.bind(null, M)), M;
                                };
                                i.exports = y;
                            }).call(this);
                        }).call(this, r("_process"));
                    },
                    {
                        "./end-of-stream": 51,
                        _process: 39
                    }
                ],
                49: [
                    function(r, i, n) {
                        function o(v, g) {
                            var A = Object.keys(v);
                            if (Object.getOwnPropertySymbols) {
                                var b = Object.getOwnPropertySymbols(v);
                                g && (b = b.filter(function(k) {
                                    return Object.getOwnPropertyDescriptor(v, k).enumerable;
                                })), A.push.apply(A, b);
                            }
                            return A;
                        }
                        function s(v) {
                            for(var g = 1; g < arguments.length; g++){
                                var A = arguments[g] != null ? arguments[g] : {};
                                g % 2 ? o(Object(A), !0).forEach(function(b) {
                                    a(v, b, A[b]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(A)) : o(Object(A)).forEach(function(b) {
                                    Object.defineProperty(v, b, Object.getOwnPropertyDescriptor(A, b));
                                });
                            }
                            return v;
                        }
                        function a(v, g, A) {
                            return g in v ? Object.defineProperty(v, g, {
                                value: A,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : v[g] = A, v;
                        }
                        function u(v, g) {
                            if (!(v instanceof g)) throw new TypeError("Cannot call a class as a function");
                        }
                        function l(v, g) {
                            for(var A = 0; A < g.length; A++){
                                var b = g[A];
                                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(v, b.key, b);
                            }
                        }
                        function c(v, g, A) {
                            return g && l(v.prototype, g), v;
                        }
                        var d = r("buffer"), h = d.Buffer, f = r("util"), p = f.inspect, m = p && p.custom || "inspect";
                        function w(v, g, A) {
                            h.prototype.copy.call(v, g, A);
                        }
                        i.exports = /* @__PURE__ */ function() {
                            function v() {
                                u(this, v), this.head = null, this.tail = null, this.length = 0;
                            }
                            return c(v, [
                                {
                                    key: "push",
                                    value: function(A) {
                                        var b = {
                                            data: A,
                                            next: null
                                        };
                                        this.length > 0 ? this.tail.next = b : this.head = b, this.tail = b, ++this.length;
                                    }
                                },
                                {
                                    key: "unshift",
                                    value: function(A) {
                                        var b = {
                                            data: A,
                                            next: this.head
                                        };
                                        this.length === 0 && (this.tail = b), this.head = b, ++this.length;
                                    }
                                },
                                {
                                    key: "shift",
                                    value: function() {
                                        if (this.length !== 0) {
                                            var A = this.head.data;
                                            return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, A;
                                        }
                                    }
                                },
                                {
                                    key: "clear",
                                    value: function() {
                                        this.head = this.tail = null, this.length = 0;
                                    }
                                },
                                {
                                    key: "join",
                                    value: function(A) {
                                        if (this.length === 0) return "";
                                        for(var b = this.head, k = "" + b.data; b = b.next;)k += A + b.data;
                                        return k;
                                    }
                                },
                                {
                                    key: "concat",
                                    value: function(A) {
                                        if (this.length === 0) return h.alloc(0);
                                        for(var b = h.allocUnsafe(A >>> 0), k = this.head, y = 0; k;)w(k.data, b, y), y += k.data.length, k = k.next;
                                        return b;
                                    }
                                },
                                {
                                    key: "consume",
                                    value: function(A, b) {
                                        var k;
                                        return A < this.head.data.length ? (k = this.head.data.slice(0, A), this.head.data = this.head.data.slice(A)) : A === this.head.data.length ? k = this.shift() : k = b ? this._getString(A) : this._getBuffer(A), k;
                                    }
                                },
                                {
                                    key: "first",
                                    value: function() {
                                        return this.head.data;
                                    }
                                },
                                {
                                    key: "_getString",
                                    value: function(A) {
                                        var b = this.head, k = 1, y = b.data;
                                        for(A -= y.length; b = b.next;){
                                            var x = b.data, C = A > x.length ? x.length : A;
                                            if (C === x.length ? y += x : y += x.slice(0, A), A -= C, A === 0) {
                                                C === x.length ? (++k, b.next ? this.head = b.next : this.head = this.tail = null) : (this.head = b, b.data = x.slice(C));
                                                break;
                                            }
                                            ++k;
                                        }
                                        return this.length -= k, y;
                                    }
                                },
                                {
                                    key: "_getBuffer",
                                    value: function(A) {
                                        var b = h.allocUnsafe(A), k = this.head, y = 1;
                                        for(k.data.copy(b), A -= k.data.length; k = k.next;){
                                            var x = k.data, C = A > x.length ? x.length : A;
                                            if (x.copy(b, b.length - A, 0, C), A -= C, A === 0) {
                                                C === x.length ? (++y, k.next ? this.head = k.next : this.head = this.tail = null) : (this.head = k, k.data = x.slice(C));
                                                break;
                                            }
                                            ++y;
                                        }
                                        return this.length -= y, b;
                                    }
                                },
                                {
                                    key: m,
                                    value: function(A, b) {
                                        return p(this, s({}, b, {
                                            // Only inspect one level.
                                            depth: 0,
                                            // It should not recurse.
                                            customInspect: !1
                                        }));
                                    }
                                }
                            ]), v;
                        }();
                    },
                    {
                        buffer: 35,
                        util: 33
                    }
                ],
                50: [
                    function(r, i, n) {
                        (function(o) {
                            (function() {
                                function s(h, f) {
                                    var p = this, m = this._readableState && this._readableState.destroyed, w = this._writableState && this._writableState.destroyed;
                                    return m || w ? (f ? f(h) : h && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, o.nextTick(c, this, h)) : o.nextTick(c, this, h)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(h || null, function(v) {
                                        !f && v ? p._writableState ? p._writableState.errorEmitted ? o.nextTick(u, p) : (p._writableState.errorEmitted = !0, o.nextTick(a, p, v)) : o.nextTick(a, p, v) : f ? (o.nextTick(u, p), f(v)) : o.nextTick(u, p);
                                    }), this);
                                }
                                function a(h, f) {
                                    c(h, f), u(h);
                                }
                                function u(h) {
                                    h._writableState && !h._writableState.emitClose || h._readableState && !h._readableState.emitClose || h.emit("close");
                                }
                                function l() {
                                    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                                }
                                function c(h, f) {
                                    h.emit("error", f);
                                }
                                function d(h, f) {
                                    var p = h._readableState, m = h._writableState;
                                    p && p.autoDestroy || m && m.autoDestroy ? h.destroy(f) : h.emit("error", f);
                                }
                                i.exports = {
                                    destroy: s,
                                    undestroy: l,
                                    errorOrDestroy: d
                                };
                            }).call(this);
                        }).call(this, r("_process"));
                    },
                    {
                        _process: 39
                    }
                ],
                51: [
                    function(r, i, n) {
                        var o = r("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
                        function s(c) {
                            var d = !1;
                            return function() {
                                if (!d) {
                                    d = !0;
                                    for(var h = arguments.length, f = new Array(h), p = 0; p < h; p++)f[p] = arguments[p];
                                    c.apply(this, f);
                                }
                            };
                        }
                        function a() {}
                        function u(c) {
                            return c.setHeader && typeof c.abort == "function";
                        }
                        function l(c, d, h) {
                            if (typeof d == "function") return l(c, null, d);
                            d || (d = {}), h = s(h || a);
                            var f = d.readable || d.readable !== !1 && c.readable, p = d.writable || d.writable !== !1 && c.writable, m = function() {
                                c.writable || v();
                            }, w = c._writableState && c._writableState.finished, v = function() {
                                p = !1, w = !0, f || h.call(c);
                            }, g = c._readableState && c._readableState.endEmitted, A = function() {
                                f = !1, g = !0, p || h.call(c);
                            }, b = function(C) {
                                h.call(c, C);
                            }, k = function() {
                                var C;
                                if (f && !g) return (!c._readableState || !c._readableState.ended) && (C = new o()), h.call(c, C);
                                if (p && !w) return (!c._writableState || !c._writableState.ended) && (C = new o()), h.call(c, C);
                            }, y = function() {
                                c.req.on("finish", v);
                            };
                            return u(c) ? (c.on("complete", v), c.on("abort", k), c.req ? y() : c.on("request", y)) : p && !c._writableState && (c.on("end", m), c.on("close", m)), c.on("end", A), c.on("finish", v), d.error !== !1 && c.on("error", b), c.on("close", k), function() {
                                c.removeListener("complete", v), c.removeListener("abort", k), c.removeListener("request", y), c.req && c.req.removeListener("finish", v), c.removeListener("end", m), c.removeListener("close", m), c.removeListener("finish", v), c.removeListener("end", A), c.removeListener("error", b), c.removeListener("close", k);
                            };
                        }
                        i.exports = l;
                    },
                    {
                        "../../../errors": 42
                    }
                ],
                52: [
                    function(r, i, n) {
                        i.exports = function() {
                            throw new Error("Readable.from is not available in the browser");
                        };
                    },
                    {}
                ],
                53: [
                    function(r, i, n) {
                        var o;
                        function s(v) {
                            var g = !1;
                            return function() {
                                g || (g = !0, v.apply(void 0, arguments));
                            };
                        }
                        var a = r("../../../errors").codes, u = a.ERR_MISSING_ARGS, l = a.ERR_STREAM_DESTROYED;
                        function c(v) {
                            if (v) throw v;
                        }
                        function d(v) {
                            return v.setHeader && typeof v.abort == "function";
                        }
                        function h(v, g, A, b) {
                            b = s(b);
                            var k = !1;
                            v.on("close", function() {
                                k = !0;
                            }), o === void 0 && (o = r("./end-of-stream")), o(v, {
                                readable: g,
                                writable: A
                            }, function(x) {
                                if (x) return b(x);
                                k = !0, b();
                            });
                            var y = !1;
                            return function(x) {
                                if (!k && !y) {
                                    if (y = !0, d(v)) return v.abort();
                                    if (typeof v.destroy == "function") return v.destroy();
                                    b(x || new l("pipe"));
                                }
                            };
                        }
                        function f(v) {
                            v();
                        }
                        function p(v, g) {
                            return v.pipe(g);
                        }
                        function m(v) {
                            return !v.length || typeof v[v.length - 1] != "function" ? c : v.pop();
                        }
                        function w() {
                            for(var v = arguments.length, g = new Array(v), A = 0; A < v; A++)g[A] = arguments[A];
                            var b = m(g);
                            if (Array.isArray(g[0]) && (g = g[0]), g.length < 2) throw new u("streams");
                            var k, y = g.map(function(x, C) {
                                var I = C < g.length - 1, M = C > 0;
                                return h(x, I, M, function(Q) {
                                    k || (k = Q), Q && y.forEach(f), !I && (y.forEach(f), b(k));
                                });
                            });
                            return g.reduce(p);
                        }
                        i.exports = w;
                    },
                    {
                        "../../../errors": 42,
                        "./end-of-stream": 51
                    }
                ],
                54: [
                    function(r, i, n) {
                        var o = r("../../../errors").codes.ERR_INVALID_OPT_VALUE;
                        function s(u, l, c) {
                            return u.highWaterMark != null ? u.highWaterMark : l ? u[c] : null;
                        }
                        function a(u, l, c, d) {
                            var h = s(l, d, c);
                            if (h != null) {
                                if (!(isFinite(h) && Math.floor(h) === h) || h < 0) {
                                    var f = d ? c : "highWaterMark";
                                    throw new o(f, h);
                                }
                                return Math.floor(h);
                            }
                            return u.objectMode ? 16 : 16384;
                        }
                        i.exports = {
                            getHighWaterMark: a
                        };
                    },
                    {
                        "../../../errors": 42
                    }
                ],
                55: [
                    function(r, i, n) {
                        i.exports = r("events").EventEmitter;
                    },
                    {
                        events: 36
                    }
                ],
                56: [
                    function(r, i, n) {
                        var o = r("safe-buffer").Buffer, s = o.isEncoding || function(y) {
                            switch(y = "" + y, y && y.toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                case "raw":
                                    return !0;
                                default:
                                    return !1;
                            }
                        };
                        function a(y) {
                            if (!y) return "utf8";
                            for(var x;;)switch(y){
                                case "utf8":
                                case "utf-8":
                                    return "utf8";
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return "utf16le";
                                case "latin1":
                                case "binary":
                                    return "latin1";
                                case "base64":
                                case "ascii":
                                case "hex":
                                    return y;
                                default:
                                    if (x) return;
                                    y = ("" + y).toLowerCase(), x = !0;
                            }
                        }
                        function u(y) {
                            var x = a(y);
                            if (typeof x != "string" && (o.isEncoding === s || !s(y))) throw new Error("Unknown encoding: " + y);
                            return x || y;
                        }
                        n.StringDecoder = l;
                        function l(y) {
                            this.encoding = u(y);
                            var x;
                            switch(this.encoding){
                                case "utf16le":
                                    this.text = w, this.end = v, x = 4;
                                    break;
                                case "utf8":
                                    this.fillLast = f, x = 4;
                                    break;
                                case "base64":
                                    this.text = g, this.end = A, x = 3;
                                    break;
                                default:
                                    this.write = b, this.end = k;
                                    return;
                            }
                            this.lastNeed = 0, this.lastTotal = 0, this.lastChar = o.allocUnsafe(x);
                        }
                        l.prototype.write = function(y) {
                            if (y.length === 0) return "";
                            var x, C;
                            if (this.lastNeed) {
                                if (x = this.fillLast(y), x === void 0) return "";
                                C = this.lastNeed, this.lastNeed = 0;
                            } else C = 0;
                            return C < y.length ? x ? x + this.text(y, C) : this.text(y, C) : x || "";
                        }, l.prototype.end = m, l.prototype.text = p, l.prototype.fillLast = function(y) {
                            if (this.lastNeed <= y.length) return y.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                            y.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, y.length), this.lastNeed -= y.length;
                        };
                        function c(y) {
                            return y <= 127 ? 0 : y >> 5 === 6 ? 2 : y >> 4 === 14 ? 3 : y >> 3 === 30 ? 4 : y >> 6 === 2 ? -1 : -2;
                        }
                        function d(y, x, C) {
                            var I = x.length - 1;
                            if (I < C) return 0;
                            var M = c(x[I]);
                            return M >= 0 ? (M > 0 && (y.lastNeed = M - 1), M) : --I < C || M === -2 ? 0 : (M = c(x[I]), M >= 0 ? (M > 0 && (y.lastNeed = M - 2), M) : --I < C || M === -2 ? 0 : (M = c(x[I]), M >= 0 ? (M > 0 && (M === 2 ? M = 0 : y.lastNeed = M - 3), M) : 0));
                        }
                        function h(y, x, C) {
                            if ((x[0] & 192) !== 128) return y.lastNeed = 0, "\uFFFD";
                            if (y.lastNeed > 1 && x.length > 1) {
                                if ((x[1] & 192) !== 128) return y.lastNeed = 1, "\uFFFD";
                                if (y.lastNeed > 2 && x.length > 2 && (x[2] & 192) !== 128) return y.lastNeed = 2, "\uFFFD";
                            }
                        }
                        function f(y) {
                            var x = this.lastTotal - this.lastNeed, C = h(this, y);
                            if (C !== void 0) return C;
                            if (this.lastNeed <= y.length) return y.copy(this.lastChar, x, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                            y.copy(this.lastChar, x, 0, y.length), this.lastNeed -= y.length;
                        }
                        function p(y, x) {
                            var C = d(this, y, x);
                            if (!this.lastNeed) return y.toString("utf8", x);
                            this.lastTotal = C;
                            var I = y.length - (C - this.lastNeed);
                            return y.copy(this.lastChar, 0, I), y.toString("utf8", x, I);
                        }
                        function m(y) {
                            var x = y && y.length ? this.write(y) : "";
                            return this.lastNeed ? x + "\uFFFD" : x;
                        }
                        function w(y, x) {
                            if ((y.length - x) % 2 === 0) {
                                var C = y.toString("utf16le", x);
                                if (C) {
                                    var I = C.charCodeAt(C.length - 1);
                                    if (I >= 55296 && I <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = y[y.length - 2], this.lastChar[1] = y[y.length - 1], C.slice(0, -1);
                                }
                                return C;
                            }
                            return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = y[y.length - 1], y.toString("utf16le", x, y.length - 1);
                        }
                        function v(y) {
                            var x = y && y.length ? this.write(y) : "";
                            if (this.lastNeed) {
                                var C = this.lastTotal - this.lastNeed;
                                return x + this.lastChar.toString("utf16le", 0, C);
                            }
                            return x;
                        }
                        function g(y, x) {
                            var C = (y.length - x) % 3;
                            return C === 0 ? y.toString("base64", x) : (this.lastNeed = 3 - C, this.lastTotal = 3, C === 1 ? this.lastChar[0] = y[y.length - 1] : (this.lastChar[0] = y[y.length - 2], this.lastChar[1] = y[y.length - 1]), y.toString("base64", x, y.length - C));
                        }
                        function A(y) {
                            var x = y && y.length ? this.write(y) : "";
                            return this.lastNeed ? x + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : x;
                        }
                        function b(y) {
                            return y.toString(this.encoding);
                        }
                        function k(y) {
                            return y && y.length ? this.write(y) : "";
                        }
                    },
                    {
                        "safe-buffer": 40
                    }
                ],
                57: [
                    function(r, i, n) {
                        (function(o) {
                            (function() {
                                i.exports = s;
                                function s(u, l) {
                                    if (a("noDeprecation")) return u;
                                    var c = !1;
                                    function d() {
                                        if (!c) {
                                            if (a("throwDeprecation")) throw new Error(l);
                                            a("traceDeprecation") ? console.trace(l) : console.warn(l), c = !0;
                                        }
                                        return u.apply(this, arguments);
                                    }
                                    return d;
                                }
                                function a(u) {
                                    try {
                                        if (!o.localStorage) return !1;
                                    } catch  {
                                        return !1;
                                    }
                                    var l = o.localStorage[u];
                                    return l == null ? !1 : String(l).toLowerCase() === "true";
                                }
                            }).call(this);
                        }).call(this, typeof $914aec8743edd630$var$Ne < "u" ? $914aec8743edd630$var$Ne : typeof self < "u" ? self : typeof window < "u" ? window : {});
                    },
                    {}
                ],
                58: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), Object.defineProperty(n, "v1", {
                            enumerable: !0,
                            get: function() {
                                return o.default;
                            }
                        }), Object.defineProperty(n, "v3", {
                            enumerable: !0,
                            get: function() {
                                return s.default;
                            }
                        }), Object.defineProperty(n, "v4", {
                            enumerable: !0,
                            get: function() {
                                return a.default;
                            }
                        }), Object.defineProperty(n, "v5", {
                            enumerable: !0,
                            get: function() {
                                return u.default;
                            }
                        }), Object.defineProperty(n, "NIL", {
                            enumerable: !0,
                            get: function() {
                                return l.default;
                            }
                        }), Object.defineProperty(n, "version", {
                            enumerable: !0,
                            get: function() {
                                return c.default;
                            }
                        }), Object.defineProperty(n, "validate", {
                            enumerable: !0,
                            get: function() {
                                return d.default;
                            }
                        }), Object.defineProperty(n, "stringify", {
                            enumerable: !0,
                            get: function() {
                                return h.default;
                            }
                        }), Object.defineProperty(n, "parse", {
                            enumerable: !0,
                            get: function() {
                                return f.default;
                            }
                        });
                        var o = p(r("./v1.js")), s = p(r("./v3.js")), a = p(r("./v4.js")), u = p(r("./v5.js")), l = p(r("./nil.js")), c = p(r("./version.js")), d = p(r("./validate.js")), h = p(r("./stringify.js")), f = p(r("./parse.js"));
                        function p(m) {
                            return m && m.__esModule ? m : {
                                default: m
                            };
                        }
                    },
                    {
                        "./nil.js": 60,
                        "./parse.js": 61,
                        "./stringify.js": 65,
                        "./v1.js": 66,
                        "./v3.js": 67,
                        "./v4.js": 69,
                        "./v5.js": 70,
                        "./validate.js": 71,
                        "./version.js": 72
                    }
                ],
                59: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        function o(g) {
                            if (typeof g == "string") {
                                const A = unescape(encodeURIComponent(g));
                                g = new Uint8Array(A.length);
                                for(let b = 0; b < A.length; ++b)g[b] = A.charCodeAt(b);
                            }
                            return s(u(l(g), g.length * 8));
                        }
                        function s(g) {
                            const A = [], b = g.length * 32, k = "0123456789abcdef";
                            for(let y = 0; y < b; y += 8){
                                const x = g[y >> 5] >>> y % 32 & 255, C = parseInt(k.charAt(x >>> 4 & 15) + k.charAt(x & 15), 16);
                                A.push(C);
                            }
                            return A;
                        }
                        function a(g) {
                            return (g + 64 >>> 9 << 4) + 14 + 1;
                        }
                        function u(g, A) {
                            g[A >> 5] |= 128 << A % 32, g[a(A) - 1] = A;
                            let b = 1732584193, k = -271733879, y = -1732584194, x = 271733878;
                            for(let C = 0; C < g.length; C += 16){
                                const I = b, M = k, Q = y, H = x;
                                b = f(b, k, y, x, g[C], 7, -680876936), x = f(x, b, k, y, g[C + 1], 12, -389564586), y = f(y, x, b, k, g[C + 2], 17, 606105819), k = f(k, y, x, b, g[C + 3], 22, -1044525330), b = f(b, k, y, x, g[C + 4], 7, -176418897), x = f(x, b, k, y, g[C + 5], 12, 1200080426), y = f(y, x, b, k, g[C + 6], 17, -1473231341), k = f(k, y, x, b, g[C + 7], 22, -45705983), b = f(b, k, y, x, g[C + 8], 7, 1770035416), x = f(x, b, k, y, g[C + 9], 12, -1958414417), y = f(y, x, b, k, g[C + 10], 17, -42063), k = f(k, y, x, b, g[C + 11], 22, -1990404162), b = f(b, k, y, x, g[C + 12], 7, 1804603682), x = f(x, b, k, y, g[C + 13], 12, -40341101), y = f(y, x, b, k, g[C + 14], 17, -1502002290), k = f(k, y, x, b, g[C + 15], 22, 1236535329), b = p(b, k, y, x, g[C + 1], 5, -165796510), x = p(x, b, k, y, g[C + 6], 9, -1069501632), y = p(y, x, b, k, g[C + 11], 14, 643717713), k = p(k, y, x, b, g[C], 20, -373897302), b = p(b, k, y, x, g[C + 5], 5, -701558691), x = p(x, b, k, y, g[C + 10], 9, 38016083), y = p(y, x, b, k, g[C + 15], 14, -660478335), k = p(k, y, x, b, g[C + 4], 20, -405537848), b = p(b, k, y, x, g[C + 9], 5, 568446438), x = p(x, b, k, y, g[C + 14], 9, -1019803690), y = p(y, x, b, k, g[C + 3], 14, -187363961), k = p(k, y, x, b, g[C + 8], 20, 1163531501), b = p(b, k, y, x, g[C + 13], 5, -1444681467), x = p(x, b, k, y, g[C + 2], 9, -51403784), y = p(y, x, b, k, g[C + 7], 14, 1735328473), k = p(k, y, x, b, g[C + 12], 20, -1926607734), b = m(b, k, y, x, g[C + 5], 4, -378558), x = m(x, b, k, y, g[C + 8], 11, -2022574463), y = m(y, x, b, k, g[C + 11], 16, 1839030562), k = m(k, y, x, b, g[C + 14], 23, -35309556), b = m(b, k, y, x, g[C + 1], 4, -1530992060), x = m(x, b, k, y, g[C + 4], 11, 1272893353), y = m(y, x, b, k, g[C + 7], 16, -155497632), k = m(k, y, x, b, g[C + 10], 23, -1094730640), b = m(b, k, y, x, g[C + 13], 4, 681279174), x = m(x, b, k, y, g[C], 11, -358537222), y = m(y, x, b, k, g[C + 3], 16, -722521979), k = m(k, y, x, b, g[C + 6], 23, 76029189), b = m(b, k, y, x, g[C + 9], 4, -640364487), x = m(x, b, k, y, g[C + 12], 11, -421815835), y = m(y, x, b, k, g[C + 15], 16, 530742520), k = m(k, y, x, b, g[C + 2], 23, -995338651), b = w(b, k, y, x, g[C], 6, -198630844), x = w(x, b, k, y, g[C + 7], 10, 1126891415), y = w(y, x, b, k, g[C + 14], 15, -1416354905), k = w(k, y, x, b, g[C + 5], 21, -57434055), b = w(b, k, y, x, g[C + 12], 6, 1700485571), x = w(x, b, k, y, g[C + 3], 10, -1894986606), y = w(y, x, b, k, g[C + 10], 15, -1051523), k = w(k, y, x, b, g[C + 1], 21, -2054922799), b = w(b, k, y, x, g[C + 8], 6, 1873313359), x = w(x, b, k, y, g[C + 15], 10, -30611744), y = w(y, x, b, k, g[C + 6], 15, -1560198380), k = w(k, y, x, b, g[C + 13], 21, 1309151649), b = w(b, k, y, x, g[C + 4], 6, -145523070), x = w(x, b, k, y, g[C + 11], 10, -1120210379), y = w(y, x, b, k, g[C + 2], 15, 718787259), k = w(k, y, x, b, g[C + 9], 21, -343485551), b = c(b, I), k = c(k, M), y = c(y, Q), x = c(x, H);
                            }
                            return [
                                b,
                                k,
                                y,
                                x
                            ];
                        }
                        function l(g) {
                            if (g.length === 0) return [];
                            const A = g.length * 8, b = new Uint32Array(a(A));
                            for(let k = 0; k < A; k += 8)b[k >> 5] |= (g[k / 8] & 255) << k % 32;
                            return b;
                        }
                        function c(g, A) {
                            const b = (g & 65535) + (A & 65535);
                            return (g >> 16) + (A >> 16) + (b >> 16) << 16 | b & 65535;
                        }
                        function d(g, A) {
                            return g << A | g >>> 32 - A;
                        }
                        function h(g, A, b, k, y, x) {
                            return c(d(c(c(A, g), c(k, x)), y), b);
                        }
                        function f(g, A, b, k, y, x, C) {
                            return h(A & b | ~A & k, g, A, y, x, C);
                        }
                        function p(g, A, b, k, y, x, C) {
                            return h(A & k | b & ~k, g, A, y, x, C);
                        }
                        function m(g, A, b, k, y, x, C) {
                            return h(A ^ b ^ k, g, A, y, x, C);
                        }
                        function w(g, A, b, k, y, x, C) {
                            return h(b ^ (A | ~k), g, A, y, x, C);
                        }
                        var v = o;
                        n.default = v;
                    },
                    {}
                ],
                60: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        var o = "00000000-0000-0000-0000-000000000000";
                        n.default = o;
                    },
                    {}
                ],
                61: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        var o = s(r("./validate.js"));
                        function s(l) {
                            return l && l.__esModule ? l : {
                                default: l
                            };
                        }
                        function a(l) {
                            if (!(0, o.default)(l)) throw TypeError("Invalid UUID");
                            let c;
                            const d = new Uint8Array(16);
                            return d[0] = (c = parseInt(l.slice(0, 8), 16)) >>> 24, d[1] = c >>> 16 & 255, d[2] = c >>> 8 & 255, d[3] = c & 255, d[4] = (c = parseInt(l.slice(9, 13), 16)) >>> 8, d[5] = c & 255, d[6] = (c = parseInt(l.slice(14, 18), 16)) >>> 8, d[7] = c & 255, d[8] = (c = parseInt(l.slice(19, 23), 16)) >>> 8, d[9] = c & 255, d[10] = (c = parseInt(l.slice(24, 36), 16)) / 1099511627776 & 255, d[11] = c / 4294967296 & 255, d[12] = c >>> 24 & 255, d[13] = c >>> 16 & 255, d[14] = c >>> 8 & 255, d[15] = c & 255, d;
                        }
                        var u = a;
                        n.default = u;
                    },
                    {
                        "./validate.js": 71
                    }
                ],
                62: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        var o = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
                        n.default = o;
                    },
                    {}
                ],
                63: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = a;
                        let o;
                        const s = new Uint8Array(16);
                        function a() {
                            if (!o && (o = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !o)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                            return o(s);
                        }
                    },
                    {}
                ],
                64: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        function o(l, c, d, h) {
                            switch(l){
                                case 0:
                                    return c & d ^ ~c & h;
                                case 1:
                                    return c ^ d ^ h;
                                case 2:
                                    return c & d ^ c & h ^ d & h;
                                case 3:
                                    return c ^ d ^ h;
                            }
                        }
                        function s(l, c) {
                            return l << c | l >>> 32 - c;
                        }
                        function a(l) {
                            const c = [
                                1518500249,
                                1859775393,
                                2400959708,
                                3395469782
                            ], d = [
                                1732584193,
                                4023233417,
                                2562383102,
                                271733878,
                                3285377520
                            ];
                            if (typeof l == "string") {
                                const m = unescape(encodeURIComponent(l));
                                l = [];
                                for(let w = 0; w < m.length; ++w)l.push(m.charCodeAt(w));
                            } else Array.isArray(l) || (l = Array.prototype.slice.call(l));
                            l.push(128);
                            const h = l.length / 4 + 2, f = Math.ceil(h / 16), p = new Array(f);
                            for(let m = 0; m < f; ++m){
                                const w = new Uint32Array(16);
                                for(let v = 0; v < 16; ++v)w[v] = l[m * 64 + v * 4] << 24 | l[m * 64 + v * 4 + 1] << 16 | l[m * 64 + v * 4 + 2] << 8 | l[m * 64 + v * 4 + 3];
                                p[m] = w;
                            }
                            p[f - 1][14] = (l.length - 1) * 8 / Math.pow(2, 32), p[f - 1][14] = Math.floor(p[f - 1][14]), p[f - 1][15] = (l.length - 1) * 8 & 4294967295;
                            for(let m = 0; m < f; ++m){
                                const w = new Uint32Array(80);
                                for(let y = 0; y < 16; ++y)w[y] = p[m][y];
                                for(let y = 16; y < 80; ++y)w[y] = s(w[y - 3] ^ w[y - 8] ^ w[y - 14] ^ w[y - 16], 1);
                                let v = d[0], g = d[1], A = d[2], b = d[3], k = d[4];
                                for(let y = 0; y < 80; ++y){
                                    const x = Math.floor(y / 20), C = s(v, 5) + o(x, g, A, b) + k + c[x] + w[y] >>> 0;
                                    k = b, b = A, A = s(g, 30) >>> 0, g = v, v = C;
                                }
                                d[0] = d[0] + v >>> 0, d[1] = d[1] + g >>> 0, d[2] = d[2] + A >>> 0, d[3] = d[3] + b >>> 0, d[4] = d[4] + k >>> 0;
                            }
                            return [
                                d[0] >> 24 & 255,
                                d[0] >> 16 & 255,
                                d[0] >> 8 & 255,
                                d[0] & 255,
                                d[1] >> 24 & 255,
                                d[1] >> 16 & 255,
                                d[1] >> 8 & 255,
                                d[1] & 255,
                                d[2] >> 24 & 255,
                                d[2] >> 16 & 255,
                                d[2] >> 8 & 255,
                                d[2] & 255,
                                d[3] >> 24 & 255,
                                d[3] >> 16 & 255,
                                d[3] >> 8 & 255,
                                d[3] & 255,
                                d[4] >> 24 & 255,
                                d[4] >> 16 & 255,
                                d[4] >> 8 & 255,
                                d[4] & 255
                            ];
                        }
                        var u = a;
                        n.default = u;
                    },
                    {}
                ],
                65: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        var o = s(r("./validate.js"));
                        function s(c) {
                            return c && c.__esModule ? c : {
                                default: c
                            };
                        }
                        const a = [];
                        for(let c = 0; c < 256; ++c)a.push((c + 256).toString(16).substr(1));
                        function u(c, d = 0) {
                            const h = (a[c[d + 0]] + a[c[d + 1]] + a[c[d + 2]] + a[c[d + 3]] + "-" + a[c[d + 4]] + a[c[d + 5]] + "-" + a[c[d + 6]] + a[c[d + 7]] + "-" + a[c[d + 8]] + a[c[d + 9]] + "-" + a[c[d + 10]] + a[c[d + 11]] + a[c[d + 12]] + a[c[d + 13]] + a[c[d + 14]] + a[c[d + 15]]).toLowerCase();
                            if (!(0, o.default)(h)) throw TypeError("Stringified UUID is invalid");
                            return h;
                        }
                        var l = u;
                        n.default = l;
                    },
                    {
                        "./validate.js": 71
                    }
                ],
                66: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        var o = a(r("./rng.js")), s = a(r("./stringify.js"));
                        function a(p) {
                            return p && p.__esModule ? p : {
                                default: p
                            };
                        }
                        let u, l, c = 0, d = 0;
                        function h(p, m, w) {
                            let v = m && w || 0;
                            const g = m || new Array(16);
                            p = p || {};
                            let A = p.node || u, b = p.clockseq !== void 0 ? p.clockseq : l;
                            if (A == null || b == null) {
                                const M = p.random || (p.rng || o.default)();
                                A == null && (A = u = [
                                    M[0] | 1,
                                    M[1],
                                    M[2],
                                    M[3],
                                    M[4],
                                    M[5]
                                ]), b == null && (b = l = (M[6] << 8 | M[7]) & 16383);
                            }
                            let k = p.msecs !== void 0 ? p.msecs : Date.now(), y = p.nsecs !== void 0 ? p.nsecs : d + 1;
                            const x = k - c + (y - d) / 1e4;
                            if (x < 0 && p.clockseq === void 0 && (b = b + 1 & 16383), (x < 0 || k > c) && p.nsecs === void 0 && (y = 0), y >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                            c = k, d = y, l = b, k += 122192928e5;
                            const C = ((k & 268435455) * 1e4 + y) % 4294967296;
                            g[v++] = C >>> 24 & 255, g[v++] = C >>> 16 & 255, g[v++] = C >>> 8 & 255, g[v++] = C & 255;
                            const I = k / 4294967296 * 1e4 & 268435455;
                            g[v++] = I >>> 8 & 255, g[v++] = I & 255, g[v++] = I >>> 24 & 15 | 16, g[v++] = I >>> 16 & 255, g[v++] = b >>> 8 | 128, g[v++] = b & 255;
                            for(let M = 0; M < 6; ++M)g[v + M] = A[M];
                            return m || (0, s.default)(g);
                        }
                        var f = h;
                        n.default = f;
                    },
                    {
                        "./rng.js": 63,
                        "./stringify.js": 65
                    }
                ],
                67: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        var o = a(r("./v35.js")), s = a(r("./md5.js"));
                        function a(c) {
                            return c && c.__esModule ? c : {
                                default: c
                            };
                        }
                        var l = (0, o.default)("v3", 48, s.default);
                        n.default = l;
                    },
                    {
                        "./md5.js": 59,
                        "./v35.js": 68
                    }
                ],
                68: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = d, n.URL = n.DNS = void 0;
                        var o = a(r("./stringify.js")), s = a(r("./parse.js"));
                        function a(h) {
                            return h && h.__esModule ? h : {
                                default: h
                            };
                        }
                        function u(h) {
                            h = unescape(encodeURIComponent(h));
                            const f = [];
                            for(let p = 0; p < h.length; ++p)f.push(h.charCodeAt(p));
                            return f;
                        }
                        const l = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
                        n.DNS = l;
                        const c = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
                        n.URL = c;
                        function d(h, f, p) {
                            function m(w, v, g, A) {
                                if (typeof w == "string" && (w = u(w)), typeof v == "string" && (v = (0, s.default)(v)), v.length !== 16) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                                let b = new Uint8Array(16 + w.length);
                                if (b.set(v), b.set(w, v.length), b = p(b), b[6] = b[6] & 15 | f, b[8] = b[8] & 63 | 128, g) {
                                    A = A || 0;
                                    for(let k = 0; k < 16; ++k)g[A + k] = b[k];
                                    return g;
                                }
                                return (0, o.default)(b);
                            }
                            try {
                                m.name = h;
                            } catch  {}
                            return m.DNS = l, m.URL = c, m;
                        }
                    },
                    {
                        "./parse.js": 61,
                        "./stringify.js": 65
                    }
                ],
                69: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        var o = a(r("./rng.js")), s = a(r("./stringify.js"));
                        function a(c) {
                            return c && c.__esModule ? c : {
                                default: c
                            };
                        }
                        function u(c, d, h) {
                            c = c || {};
                            const f = c.random || (c.rng || o.default)();
                            if (f[6] = f[6] & 15 | 64, f[8] = f[8] & 63 | 128, d) {
                                h = h || 0;
                                for(let p = 0; p < 16; ++p)d[h + p] = f[p];
                                return d;
                            }
                            return (0, s.default)(f);
                        }
                        var l = u;
                        n.default = l;
                    },
                    {
                        "./rng.js": 63,
                        "./stringify.js": 65
                    }
                ],
                70: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        var o = a(r("./v35.js")), s = a(r("./sha1.js"));
                        function a(c) {
                            return c && c.__esModule ? c : {
                                default: c
                            };
                        }
                        var l = (0, o.default)("v5", 80, s.default);
                        n.default = l;
                    },
                    {
                        "./sha1.js": 64,
                        "./v35.js": 68
                    }
                ],
                71: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        var o = s(r("./regex.js"));
                        function s(l) {
                            return l && l.__esModule ? l : {
                                default: l
                            };
                        }
                        function a(l) {
                            return typeof l == "string" && o.default.test(l);
                        }
                        var u = a;
                        n.default = u;
                    },
                    {
                        "./regex.js": 62
                    }
                ],
                72: [
                    function(r, i, n) {
                        Object.defineProperty(n, "__esModule", {
                            value: !0
                        }), n.default = void 0;
                        var o = s(r("./validate.js"));
                        function s(l) {
                            return l && l.__esModule ? l : {
                                default: l
                            };
                        }
                        function a(l) {
                            if (!(0, o.default)(l)) throw TypeError("Invalid UUID");
                            return parseInt(l.substr(14, 1), 16);
                        }
                        var u = a;
                        n.default = u;
                    },
                    {
                        "./validate.js": 71
                    }
                ]
            }, {}, [
                9
            ])(9);
        });
    }($914aec8743edd630$var$Cs)), $914aec8743edd630$var$Cs.exports;
}
var $914aec8743edd630$var$Rs = {}, $914aec8743edd630$var$Xp;
function $914aec8743edd630$var$Jw() {
    return $914aec8743edd630$var$Xp || ($914aec8743edd630$var$Xp = 1, function(e) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        }), e.default = void 0;
        function t() {
            var i = {};
            return i.promise = new Promise(function(n, o) {
                i.reject = o, i.resolve = n;
            }), i;
        }
        var r = t;
        e.default = r;
    }($914aec8743edd630$var$Rs)), $914aec8743edd630$var$Rs;
}
var $914aec8743edd630$var$An = {
    exports: {}
}, $914aec8743edd630$var$e0;
function $914aec8743edd630$var$Zw() {
    return $914aec8743edd630$var$e0 || ($914aec8743edd630$var$e0 = 1, function(e, t) {
        var r = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof $914aec8743edd630$var$Ne < "u" && $914aec8743edd630$var$Ne, i = function() {
            function o() {
                this.fetch = !1, this.DOMException = r.DOMException;
            }
            return o.prototype = r, new o();
        }();
        (function(o) {
            (function(s) {
                var a = typeof o < "u" && o || typeof self < "u" && self || // eslint-disable-next-line no-undef
                typeof $914aec8743edd630$var$Ne < "u" && $914aec8743edd630$var$Ne || {}, u = {
                    searchParams: "URLSearchParams" in a,
                    iterable: "Symbol" in a && "iterator" in Symbol,
                    blob: "FileReader" in a && "Blob" in a && function() {
                        try {
                            return new Blob(), !0;
                        } catch  {
                            return !1;
                        }
                    }(),
                    formData: "FormData" in a,
                    arrayBuffer: "ArrayBuffer" in a
                };
                function l(P) {
                    return P && DataView.prototype.isPrototypeOf(P);
                }
                if (u.arrayBuffer) var c = [
                    "[object Int8Array]",
                    "[object Uint8Array]",
                    "[object Uint8ClampedArray]",
                    "[object Int16Array]",
                    "[object Uint16Array]",
                    "[object Int32Array]",
                    "[object Uint32Array]",
                    "[object Float32Array]",
                    "[object Float64Array]"
                ], d = ArrayBuffer.isView || function(P) {
                    return P && c.indexOf(Object.prototype.toString.call(P)) > -1;
                };
                function h(P) {
                    if (typeof P != "string" && (P = String(P)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(P) || P === "") throw new TypeError('Invalid character in header field name: "' + P + '"');
                    return P.toLowerCase();
                }
                function f(P) {
                    return typeof P != "string" && (P = String(P)), P;
                }
                function p(P) {
                    var R = {
                        next: function() {
                            var V = P.shift();
                            return {
                                done: V === void 0,
                                value: V
                            };
                        }
                    };
                    return u.iterable && (R[Symbol.iterator] = function() {
                        return R;
                    }), R;
                }
                function m(P) {
                    this.map = {}, P instanceof m ? P.forEach(function(R, V) {
                        this.append(V, R);
                    }, this) : Array.isArray(P) ? P.forEach(function(R) {
                        if (R.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + R.length);
                        this.append(R[0], R[1]);
                    }, this) : P && Object.getOwnPropertyNames(P).forEach(function(R) {
                        this.append(R, P[R]);
                    }, this);
                }
                m.prototype.append = function(P, R) {
                    P = h(P), R = f(R);
                    var V = this.map[P];
                    this.map[P] = V ? V + ", " + R : R;
                }, m.prototype.delete = function(P) {
                    delete this.map[h(P)];
                }, m.prototype.get = function(P) {
                    return P = h(P), this.has(P) ? this.map[P] : null;
                }, m.prototype.has = function(P) {
                    return this.map.hasOwnProperty(h(P));
                }, m.prototype.set = function(P, R) {
                    this.map[h(P)] = f(R);
                }, m.prototype.forEach = function(P, R) {
                    for(var V in this.map)this.map.hasOwnProperty(V) && P.call(R, this.map[V], V, this);
                }, m.prototype.keys = function() {
                    var P = [];
                    return this.forEach(function(R, V) {
                        P.push(V);
                    }), p(P);
                }, m.prototype.values = function() {
                    var P = [];
                    return this.forEach(function(R) {
                        P.push(R);
                    }), p(P);
                }, m.prototype.entries = function() {
                    var P = [];
                    return this.forEach(function(R, V) {
                        P.push([
                            V,
                            R
                        ]);
                    }), p(P);
                }, u.iterable && (m.prototype[Symbol.iterator] = m.prototype.entries);
                function w(P) {
                    if (!P._noBody) {
                        if (P.bodyUsed) return Promise.reject(new TypeError("Already read"));
                        P.bodyUsed = !0;
                    }
                }
                function v(P) {
                    return new Promise(function(R, V) {
                        P.onload = function() {
                            R(P.result);
                        }, P.onerror = function() {
                            V(P.error);
                        };
                    });
                }
                function g(P) {
                    var R = new FileReader(), V = v(R);
                    return R.readAsArrayBuffer(P), V;
                }
                function A(P) {
                    var R = new FileReader(), V = v(R), X = /charset=([A-Za-z0-9_-]+)/.exec(P.type), N = X ? X[1] : "utf-8";
                    return R.readAsText(P, N), V;
                }
                function b(P) {
                    for(var R = new Uint8Array(P), V = new Array(R.length), X = 0; X < R.length; X++)V[X] = String.fromCharCode(R[X]);
                    return V.join("");
                }
                function k(P) {
                    if (P.slice) return P.slice(0);
                    var R = new Uint8Array(P.byteLength);
                    return R.set(new Uint8Array(P)), R.buffer;
                }
                function y() {
                    return this.bodyUsed = !1, this._initBody = function(P) {
                        this.bodyUsed = this.bodyUsed, this._bodyInit = P, P ? typeof P == "string" ? this._bodyText = P : u.blob && Blob.prototype.isPrototypeOf(P) ? this._bodyBlob = P : u.formData && FormData.prototype.isPrototypeOf(P) ? this._bodyFormData = P : u.searchParams && URLSearchParams.prototype.isPrototypeOf(P) ? this._bodyText = P.toString() : u.arrayBuffer && u.blob && l(P) ? (this._bodyArrayBuffer = k(P.buffer), this._bodyInit = new Blob([
                            this._bodyArrayBuffer
                        ])) : u.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(P) || d(P)) ? this._bodyArrayBuffer = k(P) : this._bodyText = P = Object.prototype.toString.call(P) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof P == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : u.searchParams && URLSearchParams.prototype.isPrototypeOf(P) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                    }, u.blob && (this.blob = function() {
                        var P = w(this);
                        if (P) return P;
                        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                        if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                            this._bodyArrayBuffer
                        ]));
                        if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                        return Promise.resolve(new Blob([
                            this._bodyText
                        ]));
                    }), this.arrayBuffer = function() {
                        if (this._bodyArrayBuffer) {
                            var P = w(this);
                            return P || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer));
                        } else {
                            if (u.blob) return this.blob().then(g);
                            throw new Error("could not read as ArrayBuffer");
                        }
                    }, this.text = function() {
                        var P = w(this);
                        if (P) return P;
                        if (this._bodyBlob) return A(this._bodyBlob);
                        if (this._bodyArrayBuffer) return Promise.resolve(b(this._bodyArrayBuffer));
                        if (this._bodyFormData) throw new Error("could not read FormData body as text");
                        return Promise.resolve(this._bodyText);
                    }, u.formData && (this.formData = function() {
                        return this.text().then(M);
                    }), this.json = function() {
                        return this.text().then(JSON.parse);
                    }, this;
                }
                var x = [
                    "CONNECT",
                    "DELETE",
                    "GET",
                    "HEAD",
                    "OPTIONS",
                    "PATCH",
                    "POST",
                    "PUT",
                    "TRACE"
                ];
                function C(P) {
                    var R = P.toUpperCase();
                    return x.indexOf(R) > -1 ? R : P;
                }
                function I(P, R) {
                    if (!(this instanceof I)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    R = R || {};
                    var V = R.body;
                    if (P instanceof I) {
                        if (P.bodyUsed) throw new TypeError("Already read");
                        this.url = P.url, this.credentials = P.credentials, R.headers || (this.headers = new m(P.headers)), this.method = P.method, this.mode = P.mode, this.signal = P.signal, !V && P._bodyInit != null && (V = P._bodyInit, P.bodyUsed = !0);
                    } else this.url = String(P);
                    if (this.credentials = R.credentials || this.credentials || "same-origin", (R.headers || !this.headers) && (this.headers = new m(R.headers)), this.method = C(R.method || this.method || "GET"), this.mode = R.mode || this.mode || null, this.signal = R.signal || this.signal || function() {
                        if ("AbortController" in a) {
                            var U = new AbortController();
                            return U.signal;
                        }
                    }(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && V) throw new TypeError("Body not allowed for GET or HEAD requests");
                    if (this._initBody(V), (this.method === "GET" || this.method === "HEAD") && (R.cache === "no-store" || R.cache === "no-cache")) {
                        var X = /([?&])_=[^&]*/;
                        if (X.test(this.url)) this.url = this.url.replace(X, "$1_=" + /* @__PURE__ */ new Date().getTime());
                        else {
                            var N = /\?/;
                            this.url += (N.test(this.url) ? "&" : "?") + "_=" + /* @__PURE__ */ new Date().getTime();
                        }
                    }
                }
                I.prototype.clone = function() {
                    return new I(this, {
                        body: this._bodyInit
                    });
                };
                function M(P) {
                    var R = new FormData();
                    return P.trim().split("&").forEach(function(V) {
                        if (V) {
                            var X = V.split("="), N = X.shift().replace(/\+/g, " "), U = X.join("=").replace(/\+/g, " ");
                            R.append(decodeURIComponent(N), decodeURIComponent(U));
                        }
                    }), R;
                }
                function Q(P) {
                    var R = new m(), V = P.replace(/\r?\n[\t ]+/g, " ");
                    return V.split("\r").map(function(X) {
                        return X.indexOf(`
`) === 0 ? X.substr(1, X.length) : X;
                    }).forEach(function(X) {
                        var N = X.split(":"), U = N.shift().trim();
                        if (U) {
                            var G = N.join(":").trim();
                            try {
                                R.append(U, G);
                            } catch (re) {
                                console.warn("Response " + re.message);
                            }
                        }
                    }), R;
                }
                y.call(I.prototype);
                function H(P, R) {
                    if (!(this instanceof H)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    if (R || (R = {}), this.type = "default", this.status = R.status === void 0 ? 200 : R.status, this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
                    this.ok = this.status >= 200 && this.status < 300, this.statusText = R.statusText === void 0 ? "" : "" + R.statusText, this.headers = new m(R.headers), this.url = R.url || "", this._initBody(P);
                }
                y.call(H.prototype), H.prototype.clone = function() {
                    return new H(this._bodyInit, {
                        status: this.status,
                        statusText: this.statusText,
                        headers: new m(this.headers),
                        url: this.url
                    });
                }, H.error = function() {
                    var P = new H(null, {
                        status: 200,
                        statusText: ""
                    });
                    return P.ok = !1, P.status = 0, P.type = "error", P;
                };
                var J = [
                    301,
                    302,
                    303,
                    307,
                    308
                ];
                H.redirect = function(P, R) {
                    if (J.indexOf(R) === -1) throw new RangeError("Invalid status code");
                    return new H(null, {
                        status: R,
                        headers: {
                            location: P
                        }
                    });
                }, s.DOMException = a.DOMException;
                try {
                    new s.DOMException();
                } catch  {
                    s.DOMException = function(R, V) {
                        this.message = R, this.name = V;
                        var X = Error(R);
                        this.stack = X.stack;
                    }, s.DOMException.prototype = Object.create(Error.prototype), s.DOMException.prototype.constructor = s.DOMException;
                }
                function W(P, R) {
                    return new Promise(function(V, X) {
                        var N = new I(P, R);
                        if (N.signal && N.signal.aborted) return X(new s.DOMException("Aborted", "AbortError"));
                        var U = new XMLHttpRequest();
                        function G() {
                            U.abort();
                        }
                        U.onload = function() {
                            var ie = {
                                statusText: U.statusText,
                                headers: Q(U.getAllResponseHeaders() || "")
                            };
                            N.url.indexOf("file://") === 0 && (U.status < 200 || U.status > 599) ? ie.status = 200 : ie.status = U.status, ie.url = "responseURL" in U ? U.responseURL : ie.headers.get("X-Request-URL");
                            var le = "response" in U ? U.response : U.responseText;
                            setTimeout(function() {
                                V(new H(le, ie));
                            }, 0);
                        }, U.onerror = function() {
                            setTimeout(function() {
                                X(new TypeError("Network request failed"));
                            }, 0);
                        }, U.ontimeout = function() {
                            setTimeout(function() {
                                X(new TypeError("Network request timed out"));
                            }, 0);
                        }, U.onabort = function() {
                            setTimeout(function() {
                                X(new s.DOMException("Aborted", "AbortError"));
                            }, 0);
                        };
                        function re(ie) {
                            try {
                                return ie === "" && a.location.href ? a.location.href : ie;
                            } catch  {
                                return ie;
                            }
                        }
                        if (U.open(N.method, re(N.url), !0), N.credentials === "include" ? U.withCredentials = !0 : N.credentials === "omit" && (U.withCredentials = !1), "responseType" in U && (u.blob ? U.responseType = "blob" : u.arrayBuffer && (U.responseType = "arraybuffer")), R && typeof R.headers == "object" && !(R.headers instanceof m || a.Headers && R.headers instanceof a.Headers)) {
                            var oe = [];
                            Object.getOwnPropertyNames(R.headers).forEach(function(ie) {
                                oe.push(h(ie)), U.setRequestHeader(ie, f(R.headers[ie]));
                            }), N.headers.forEach(function(ie, le) {
                                oe.indexOf(le) === -1 && U.setRequestHeader(le, ie);
                            });
                        } else N.headers.forEach(function(ie, le) {
                            U.setRequestHeader(le, ie);
                        });
                        N.signal && (N.signal.addEventListener("abort", G), U.onreadystatechange = function() {
                            U.readyState === 4 && N.signal.removeEventListener("abort", G);
                        }), U.send(typeof N._bodyInit > "u" ? null : N._bodyInit);
                    });
                }
                return W.polyfill = !0, a.fetch || (a.fetch = W, a.Headers = m, a.Request = I, a.Response = H), s.Headers = m, s.Request = I, s.Response = H, s.fetch = W, Object.defineProperty(s, "__esModule", {
                    value: !0
                }), s;
            })({});
        })(i), i.fetch.ponyfill = !0, delete i.fetch.polyfill;
        var n = r.fetch ? r : i;
        t = n.fetch, t.default = n.fetch, t.fetch = n.fetch, t.Headers = n.Headers, t.Request = n.Request, t.Response = n.Response, e.exports = t;
    }($914aec8743edd630$var$An, $914aec8743edd630$var$An.exports)), $914aec8743edd630$var$An.exports;
}
var $914aec8743edd630$var$Os = {}, $914aec8743edd630$var$Ds = {
    exports: {}
}, $914aec8743edd630$var$t0;
function $914aec8743edd630$var$Ig() {
    return $914aec8743edd630$var$t0 || ($914aec8743edd630$var$t0 = 1, function(e) {
        function t(r) {
            if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return r;
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Ds)), $914aec8743edd630$var$Ds.exports;
}
var $914aec8743edd630$var$Ps = {
    exports: {}
}, $914aec8743edd630$var$Is = {
    exports: {}
}, $914aec8743edd630$var$Ms = {
    exports: {}
}, $914aec8743edd630$var$r0;
function $914aec8743edd630$var$Mg() {
    return $914aec8743edd630$var$r0 || ($914aec8743edd630$var$r0 = 1, function(e) {
        function t(r) {
            return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
                return i.__proto__ || Object.getPrototypeOf(i);
            }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Ms)), $914aec8743edd630$var$Ms.exports;
}
var $914aec8743edd630$var$n0;
function $914aec8743edd630$var$Xw() {
    return $914aec8743edd630$var$n0 || ($914aec8743edd630$var$n0 = 1, function(e) {
        var t = $914aec8743edd630$var$Mg();
        function r(i, n) {
            for(; !({}).hasOwnProperty.call(i, n) && (i = t(i)) !== null;);
            return i;
        }
        e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Is)), $914aec8743edd630$var$Is.exports;
}
var $914aec8743edd630$var$i0;
function $914aec8743edd630$var$e2() {
    return $914aec8743edd630$var$i0 || ($914aec8743edd630$var$i0 = 1, function(e) {
        var t = $914aec8743edd630$var$Xw();
        function r() {
            return e.exports = r = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(i, n, o) {
                var s = t(i, n);
                if (s) {
                    var a = Object.getOwnPropertyDescriptor(s, n);
                    return a.get ? a.get.call(arguments.length < 3 ? i : o) : a.value;
                }
            }, e.exports.__esModule = !0, e.exports.default = e.exports, r.apply(null, arguments);
        }
        e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Ps)), $914aec8743edd630$var$Ps.exports;
}
var $914aec8743edd630$var$js = {
    exports: {}
}, $914aec8743edd630$var$Fs = {
    exports: {}
}, $914aec8743edd630$var$o0;
function $914aec8743edd630$var$t2() {
    return $914aec8743edd630$var$o0 || ($914aec8743edd630$var$o0 = 1, function(e) {
        function t(r, i) {
            return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                return n.__proto__ = o, n;
            }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r, i);
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$Fs)), $914aec8743edd630$var$Fs.exports;
}
var $914aec8743edd630$var$a0;
function $914aec8743edd630$var$r2() {
    return $914aec8743edd630$var$a0 || ($914aec8743edd630$var$a0 = 1, function(e) {
        var t = $914aec8743edd630$var$t2();
        function r(i, n) {
            if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
            i.prototype = Object.create(n && n.prototype, {
                constructor: {
                    value: i,
                    writable: !0,
                    configurable: !0
                }
            }), Object.defineProperty(i, "prototype", {
                writable: !1
            }), n && t(i, n);
        }
        e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$js)), $914aec8743edd630$var$js.exports;
}
var $914aec8743edd630$var$$s = {
    exports: {}
}, $914aec8743edd630$var$s0;
function $914aec8743edd630$var$n2() {
    return $914aec8743edd630$var$s0 || ($914aec8743edd630$var$s0 = 1, function(e) {
        var t = $914aec8743edd630$var$nr().default, r = $914aec8743edd630$var$Ig();
        function i(n, o) {
            if (o && (t(o) == "object" || typeof o == "function")) return o;
            if (o !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
            return r(n);
        }
        e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($914aec8743edd630$var$$s)), $914aec8743edd630$var$$s.exports;
}
var $914aec8743edd630$var$u0;
function $914aec8743edd630$var$i2() {
    return $914aec8743edd630$var$u0 || ($914aec8743edd630$var$u0 = 1, function(e) {
        var t = $914aec8743edd630$var$sn();
        Object.defineProperty(e, "__esModule", {
            value: !0
        }), e.default = void 0;
        var r = t($914aec8743edd630$var$Vu()), i = t($914aec8743edd630$var$Gu()), n = t($914aec8743edd630$var$Ig()), o = t($914aec8743edd630$var$e2()), s = t($914aec8743edd630$var$r2()), a = t($914aec8743edd630$var$n2()), u = t($914aec8743edd630$var$Mg()), l = t($914aec8743edd630$var$Og()), c = t($914aec8743edd630$var$Dg()), d = $914aec8743edd630$var$Pg();
        function h(A) {
            var b = f();
            return function() {
                var y = (0, u.default)(A), x;
                if (b) {
                    var C = (0, u.default)(this).constructor;
                    x = Reflect.construct(y, arguments, C);
                } else x = y.apply(this, arguments);
                return (0, a.default)(this, x);
            };
        }
        function f() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch  {
                return !1;
            }
        }
        var p = /* @__PURE__ */ new WeakMap(), m = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ function(A) {
            (0, s.default)(k, A);
            var b = h(k);
            function k(y) {
                var x, C = y.disconnectionHandler, I = y.networkInformation, M = y.requestHandler, Q = y.url;
                return (0, r.default)(this, k), x = b.call(this, {
                    disconnectionHandler: C,
                    requestHandler: M,
                    url: Q
                }), p.set((0, n.default)(x), {
                    writable: !0,
                    value: !1
                }), m.set((0, n.default)(x), {
                    writable: !0,
                    value: function() {
                        return (0, l.default)((0, n.default)(x), w) === (0, l.default)((0, n.default)(x), v).type || x.disconnect();
                    }
                }), w.set((0, n.default)(x), {
                    writable: !0,
                    value: void 0
                }), v.set((0, n.default)(x), {
                    writable: !0,
                    value: void 0
                }), (0, c.default)((0, n.default)(x), v, I), x;
            }
            return (0, i.default)(k, [
                {
                    key: "connect",
                    value: // TODO: Better, the `NetworkInformation` instance should be passed to `BrowserWebSocketClient` -> `BrowserWebSocket`.
                    //       `BrowserWebSocket` is where it creates `WebSocket` object.
                    //       The `NetworkInformation` instance should accompany `WebSocket` and forcibly close it on abort.
                    //       Maybe `botframework-streaming` should accept ponyfills.
                    function() {
                        if ((0, l.default)(this, p)) return console.warn("botframework-directlinejs: connect() can only be called once."), Promise.resolve();
                        if ((0, c.default)(this, p, !0), (0, l.default)(this, v)) {
                            var x = (0, l.default)(this, v), C = x.type;
                            if ((0, c.default)(this, w, C), C === "none") return console.warn("botframework-directlinejs: Failed to connect while offline."), Promise.reject(new Error("botframework-directlinejs: Failed to connect while offline."));
                            (0, l.default)(this, v).addEventListener("change", (0, l.default)(this, m));
                        }
                        return (0, o.default)((0, u.default)(k.prototype), "connect", this).call(this);
                    }
                },
                {
                    key: "disconnect",
                    value: function() {
                        var x;
                        (x = (0, l.default)(this, v)) === null || x === void 0 || x.removeEventListener("change", (0, l.default)(this, m)), (0, o.default)((0, u.default)(k.prototype), "disconnect", this).call(this);
                    }
                }
            ]), k;
        }(d.WebSocketClient);
        e.default = g;
    }($914aec8743edd630$var$Os)), $914aec8743edd630$var$Os;
}
var $914aec8743edd630$var$c0;
function $914aec8743edd630$var$o2() {
    if ($914aec8743edd630$var$c0) return $914aec8743edd630$var$Lr;
    $914aec8743edd630$var$c0 = 1;
    var e = $914aec8743edd630$var$sn(), t = $914aec8743edd630$var$nr();
    Object.defineProperty($914aec8743edd630$var$Lr, "__esModule", {
        value: !0
    }), $914aec8743edd630$var$Lr.DirectLineStreaming = void 0;
    var r = e($914aec8743edd630$var$qm()), i = e($914aec8743edd630$var$Bw()), n = e($914aec8743edd630$var$Og()), o = e($914aec8743edd630$var$Dg()), s = e($914aec8743edd630$var$Ww()), a = e($914aec8743edd630$var$Hw()), u = e($914aec8743edd630$var$Vu()), l = e($914aec8743edd630$var$Gu()), c = e($914aec8743edd630$var$Um()), d = $914aec8743edd630$var$vg(), h = $914aec8743edd630$var$Yw(), f = $914aec8743edd630$var$Te(), p = k($914aec8743edd630$var$Pg()), m = e($914aec8743edd630$var$Jw()), w = e($914aec8743edd630$var$Zw()), v = $914aec8743edd630$var$jg(), g = e($914aec8743edd630$var$i2()), A = [
        "attachments"
    ];
    function b(J) {
        if (typeof WeakMap != "function") return null;
        var W = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap();
        return (b = function(V) {
            return V ? P : W;
        })(J);
    }
    function k(J, W) {
        if (J && J.__esModule) return J;
        if (J === null || t(J) !== "object" && typeof J != "function") return {
            default: J
        };
        var P = b(W);
        if (P && P.has(J)) return P.get(J);
        var R = {}, V = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var X in J)if (X !== "default" && Object.prototype.hasOwnProperty.call(J, X)) {
            var N = V ? Object.getOwnPropertyDescriptor(J, X) : null;
            N && (N.get || N.set) ? Object.defineProperty(R, X, N) : R[X] = J[X];
        }
        return R.default = J, P && P.set(J, R), R;
    }
    var y = "DirectLine/3.0", x = 3, C = 1800000, I = C / 2, M = /* @__PURE__ */ function() {
        function J(W, P, R) {
            (0, u.default)(this, J), (0, c.default)(this, "activityQueue", []), this.subscriber = W, this.connectionStatus$ = P, this.shouldQueue = R;
        }
        return (0, l.default)(J, [
            {
                key: "setSubscriber",
                value: function(P) {
                    this.subscriber = P;
                }
            },
            {
                key: "processRequest",
                value: function() {
                    var W = (0, a.default)(/* @__PURE__ */ i.default.mark(function R(V, X) {
                        var N, U, G, re, oe, ie, le, he, ye;
                        return i.default.wrap(function(we) {
                            for(;;)switch(we.prev = we.next){
                                case 0:
                                    return N = (0, s.default)(V.streams), U = N.shift(), we.next = 4, U.readAsString();
                                case 4:
                                    if (G = we.sent, re = JSON.parse(G), re.activities.length === 1) {
                                        we.next = 9;
                                        break;
                                    }
                                    return this.subscriber.error(new Error("there should be exactly one activity")), we.abrupt("return", p.StreamingResponse.create(500));
                                case 9:
                                    if (oe = re.activities[0], !(N.length > 0)) {
                                        we.next = 21;
                                        break;
                                    }
                                    ie = (0, s.default)(oe.attachments);
                                case 12:
                                    if (!(le = N.shift())) {
                                        we.next = 20;
                                        break;
                                    }
                                    return we.next = 15, le.readAsString();
                                case 15:
                                    he = we.sent, ye = "data:text/plain;base64," + he, ie.push({
                                        contentType: le.contentType,
                                        contentUrl: ye
                                    }), we.next = 12;
                                    break;
                                case 20:
                                    oe.attachments = ie;
                                case 21:
                                    return this.shouldQueue() ? this.activityQueue.push(oe) : this.subscriber.next(oe), we.abrupt("return", p.StreamingResponse.create(200));
                                case 23:
                                case "end":
                                    return we.stop();
                            }
                        }, R, this);
                    }));
                    function P(R, V) {
                        return W.apply(this, arguments);
                    }
                    return P;
                }()
            },
            {
                key: "flush",
                value: function() {
                    var P = this;
                    this.connectionStatus$.subscribe(function() {}), this.activityQueue.forEach(function(R) {
                        return P.subscriber.next(R);
                    }), this.activityQueue = [];
                }
            },
            {
                key: "end",
                value: function() {
                    this.subscriber.complete();
                }
            }
        ]), J;
    }(), Q = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ function() {
        function J(W) {
            var P = this;
            (0, u.default)(this, J), (0, c.default)(this, "connectionStatus$", new d.BehaviorSubject(v.ConnectionStatus.Uninitialized)), (0, c.default)(this, "_botAgent", ""), Q.set(this, {
                writable: !0,
                value: void 0
            });
            var R = W == null ? void 0 : W.networkInformation;
            typeof R > "u" || typeof R.addEventListener == "function" && typeof R.removeEventListener == "function" && typeof R.type == "string" ? (0, o.default)(this, Q, R) : console.warn('botframework-directlinejs: "networkInformation" option specified must be a `NetworkInformation`-like instance extending `EventTarget` interface with a `type` property returning a string.'), this.token = W.token, this.refreshToken().catch(function() {
                P.connectionStatus$.next(v.ConnectionStatus.ExpiredToken);
            }), this.domain = W.domain, W.conversationId && (this.conversationId = W.conversationId), this._botAgent = this.getBotAgent(W.botAgent), this.queueActivities = !0, this.activity$ = f.Observable.create(/* @__PURE__ */ function() {
                var V = (0, a.default)(/* @__PURE__ */ i.default.mark(function X(N) {
                    return i.default.wrap(function(G) {
                        for(;;)switch(G.prev = G.next){
                            case 0:
                                P.activitySubscriber = N, P.theStreamHandler = new M(N, P.connectionStatus$, function() {
                                    return P.queueActivities;
                                }), P.connectDeferred.resolve();
                            case 3:
                            case "end":
                                return G.stop();
                        }
                    }, X);
                }));
                return function(X) {
                    return V.apply(this, arguments);
                };
            }()).share(), this.connectWithRetryAsync();
        }
        return (0, l.default)(J, [
            {
                key: "reconnect",
                value: function(P) {
                    var R = P.conversationId, V = P.token;
                    if (this.connectionStatus$.getValue() === v.ConnectionStatus.Ended) throw new Error("Connection has ended.");
                    this.conversationId = R, this.token = V, this.connectDeferred.resolve();
                }
            },
            {
                key: "end",
                value: function() {
                    this.activitySubscriber.complete(), this.connectionStatus$.next(v.ConnectionStatus.Ended), this.connectionStatus$.complete(), this.streamConnection.disconnect();
                }
            },
            {
                key: "commonHeaders",
                value: function() {
                    return {
                        Authorization: "Bearer ".concat(this.token),
                        "x-ms-bot-agent": this._botAgent
                    };
                }
            },
            {
                key: "getBotAgent",
                value: function() {
                    var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", R = "directlineStreaming";
                    return P && (R += "; ".concat(P)), "".concat(y, " (").concat(R, ")");
                }
            },
            {
                key: "refreshToken",
                value: function() {
                    var W = (0, a.default)(/* @__PURE__ */ i.default.mark(function R() {
                        var V, X, N, U;
                        return i.default.wrap(function(re) {
                            for(;;)switch(re.prev = re.next){
                                case 0:
                                    return re.next = 4, this.waitUntilOnline();
                                case 4:
                                    V = 0;
                                case 5:
                                    if (!(V < x)) {
                                        re.next = 30;
                                        break;
                                    }
                                    return V++, re.next = 9, new Promise(function(oe) {
                                        return setTimeout(oe, I);
                                    });
                                case 9:
                                    return re.prev = 9, re.next = 12, (0, w.default)("".concat(this.domain, "/tokens/refresh"), {
                                        method: "POST",
                                        headers: this.commonHeaders()
                                    });
                                case 12:
                                    if (X = re.sent, !X.ok) {
                                        re.next = 22;
                                        break;
                                    }
                                    return V = 0, re.next = 17, X.json();
                                case 17:
                                    N = re.sent, U = N.token, this.token = U, re.next = 23;
                                    break;
                                case 22:
                                    X.status === 403 || X.status === 403 ? (console.error("Fatal error while refreshing the token: ".concat(X.status, " ").concat(X.statusText)), this.streamConnection.disconnect()) : console.warn("Refresh attempt #".concat(V, " failed: ").concat(X.status, " ").concat(X.statusText));
                                case 23:
                                    re.next = 28;
                                    break;
                                case 25:
                                    re.prev = 25, re.t0 = re.catch(9), console.warn("Refresh attempt #".concat(V, " threw an exception: ").concat(re.t0));
                                case 28:
                                    re.next = 5;
                                    break;
                                case 30:
                                    console.error("Retries exhausted"), this.streamConnection.disconnect();
                                case 32:
                                case "end":
                                    return re.stop();
                            }
                        }, R, this, [
                            [
                                9,
                                25
                            ]
                        ]);
                    }));
                    function P() {
                        return W.apply(this, arguments);
                    }
                    return P;
                }()
            },
            {
                key: "postActivity",
                value: function(P) {
                    var R = this;
                    if (this.connectionStatus$.value === v.ConnectionStatus.Ended || this.connectionStatus$.value === v.ConnectionStatus.FailedToConnect) return f.Observable.throw(new Error("Connection is closed"));
                    if (P.type === "message" && P.attachments && P.attachments.length > 0) return this.postMessageWithAttachments(P);
                    var V = f.Observable.create(/* @__PURE__ */ function() {
                        var X = (0, a.default)(/* @__PURE__ */ i.default.mark(function N(U) {
                            var G, re, oe, ie, le, he;
                            return i.default.wrap(function(be) {
                                for(;;)switch(be.prev = be.next){
                                    case 0:
                                        return G = p.StreamingRequest.create("POST", "/v3/directline/conversations/" + R.conversationId + "/activities"), G.setBody(JSON.stringify(P)), be.prev = 2, be.next = 5, R.streamConnection.send(G);
                                    case 5:
                                        if (re = be.sent, re.statusCode === 200) {
                                            be.next = 8;
                                            break;
                                        }
                                        throw new Error("PostActivity returned " + re.statusCode);
                                    case 8:
                                        if (oe = re.streams.length, oe === 1) {
                                            be.next = 11;
                                            break;
                                        }
                                        throw new Error("Expected one stream but got " + oe);
                                    case 11:
                                        return be.next = 13, re.streams[0].readAsString();
                                    case 13:
                                        return ie = be.sent, le = JSON.parse(ie), he = le.Id, U.next(he), be.abrupt("return", U.complete());
                                    case 19:
                                        return be.prev = 19, be.t0 = be.catch(2), console.warn(be.t0), R.streamConnection.disconnect(), be.abrupt("return", U.error(be.t0));
                                    case 24:
                                    case "end":
                                        return be.stop();
                                }
                            }, N, null, [
                                [
                                    2,
                                    19
                                ]
                            ]);
                        }));
                        return function(N) {
                            return X.apply(this, arguments);
                        };
                    }());
                    return V;
                }
            },
            {
                key: "postMessageWithAttachments",
                value: function(P) {
                    var R = this, V = P.attachments, X = (0, r.default)(P, A);
                    return f.Observable.create(function(N) {
                        var U = [];
                        (0, a.default)(/* @__PURE__ */ i.default.mark(function G() {
                            var re, oe, ie, le, he, ye, be;
                            return i.default.wrap(function(ve) {
                                for(;;)switch(ve.prev = ve.next){
                                    case 0:
                                        return ve.prev = 0, ve.next = 3, Promise.all(V.map(/* @__PURE__ */ function() {
                                            var Re = (0, a.default)(/* @__PURE__ */ i.default.mark(function De(te) {
                                                var Z, ue;
                                                return i.default.wrap(function(me) {
                                                    for(;;)switch(me.prev = me.next){
                                                        case 0:
                                                            return Z = te, me.next = 3, (0, w.default)(Z.contentUrl);
                                                        case 3:
                                                            if (ue = me.sent, !ue.ok) {
                                                                me.next = 12;
                                                                break;
                                                            }
                                                            return me.next = 7, ue.arrayBuffer();
                                                        case 7:
                                                            return me.t0 = me.sent, me.t1 = Z, me.abrupt("return", {
                                                                arrayBuffer: me.t0,
                                                                media: me.t1
                                                            });
                                                        case 12:
                                                            throw new Error("...");
                                                        case 13:
                                                        case "end":
                                                            return me.stop();
                                                    }
                                                }, De);
                                            }));
                                            return function(De) {
                                                return Re.apply(this, arguments);
                                            };
                                        }()));
                                    case 3:
                                        return re = ve.sent, re.forEach(function(Re) {
                                            var De = Re.arrayBuffer, te = Re.media, Z = h.Buffer.from(De), ue = new p.SubscribableStream();
                                            ue.write(Z);
                                            var pe = new p.HttpContent({
                                                type: te.contentType,
                                                contentLength: Z.length
                                            }, ue);
                                            U.push(pe);
                                        }), oe = "/v3/directline/conversations/".concat(R.conversationId, "/users/").concat(X.from.id, "/upload"), ie = p.StreamingRequest.create("PUT", oe), le = new p.SubscribableStream(), le.write(JSON.stringify(X), "utf-8"), ie.addStream(new p.HttpContent({
                                            type: "application/vnd.microsoft.activity",
                                            contentLength: le.length
                                        }, le)), U.forEach(function(Re) {
                                            return ie.addStream(Re);
                                        }), ve.next = 13, R.streamConnection.send(ie);
                                    case 13:
                                        if (he = ve.sent, !(he.streams && he.streams.length !== 1)) {
                                            ve.next = 18;
                                            break;
                                        }
                                        N.error(new Error("Invalid stream count ".concat(he.streams.length))), ve.next = 24;
                                        break;
                                    case 18:
                                        return ve.next = 20, he.streams[0].readAsJson();
                                    case 20:
                                        ye = ve.sent, be = ye.Id, N.next(be), N.complete();
                                    case 24:
                                        ve.next = 29;
                                        break;
                                    case 26:
                                        ve.prev = 26, ve.t0 = ve.catch(0), N.error(ve.t0);
                                    case 29:
                                    case "end":
                                        return ve.stop();
                                }
                            }, G, null, [
                                [
                                    0,
                                    26
                                ]
                            ]);
                        }))();
                    });
                }
            },
            {
                key: "waitUntilOnline",
                value: function() {
                    var W = (0, a.default)(/* @__PURE__ */ i.default.mark(function R() {
                        var V = this;
                        return i.default.wrap(function(N) {
                            for(;;)switch(N.prev = N.next){
                                case 0:
                                    return N.abrupt("return", new Promise(function(U, G) {
                                        V.connectionStatus$.subscribe(function(re) {
                                            if (re === v.ConnectionStatus.Online) return U();
                                        }, function(re) {
                                            return G(re);
                                        });
                                    }));
                                case 1:
                                case "end":
                                    return N.stop();
                            }
                        }, R);
                    }));
                    function P() {
                        return W.apply(this, arguments);
                    }
                    return P;
                }()
            },
            {
                key: "connectAsync",
                value: function() {
                    var W = (0, a.default)(/* @__PURE__ */ i.default.mark(function R() {
                        var V = this, X, N, U, G, re;
                        return i.default.wrap(function(ie) {
                            for(;;)switch(ie.prev = ie.next){
                                case 0:
                                    if (X = new RegExp("^http(s?)"), X.test(this.domain)) {
                                        ie.next = 3;
                                        break;
                                    }
                                    throw "Domain must begin with http or https";
                                case 3:
                                    return N = {
                                        token: this.token
                                    }, this.conversationId && (N.conversationId = this.conversationId), U = new AbortController(), G = new URLSearchParams(N).toString(), re = "".concat(this.domain.replace(X, "ws$1"), "/conversations/connect?").concat(G), ie.abrupt("return", new Promise(/* @__PURE__ */ function() {
                                        var le = (0, a.default)(/* @__PURE__ */ i.default.mark(function he(ye, be) {
                                            var we, ve, Re, De;
                                            return i.default.wrap(function(Z) {
                                                for(;;)switch(Z.prev = Z.next){
                                                    case 0:
                                                        return Z.prev = 0, V.streamConnection = new g.default({
                                                            disconnectionHandler: ye,
                                                            networkInformation: (0, n.default)(V, Q),
                                                            requestHandler: {
                                                                processRequest: function(pe) {
                                                                    if (U.signal.aborted) throw new Error("Cannot process streaming request, `streamingConnection` should be disconnected.");
                                                                    return V.theStreamHandler.processRequest(pe);
                                                                }
                                                            },
                                                            url: re
                                                        }), V.queueActivities = !0, Z.next = 5, V.streamConnection.connect();
                                                    case 5:
                                                        return we = p.StreamingRequest.create("POST", "/v3/directline/conversations"), Z.next = 8, V.streamConnection.send(we);
                                                    case 8:
                                                        if (ve = Z.sent, ve.statusCode === 200) {
                                                            Z.next = 11;
                                                            break;
                                                        }
                                                        throw new Error("Connection response code " + ve.statusCode);
                                                    case 11:
                                                        if (ve.streams.length === 1) {
                                                            Z.next = 13;
                                                            break;
                                                        }
                                                        throw new Error("Expected 1 stream but got " + ve.streams.length);
                                                    case 13:
                                                        return Z.next = 15, ve.streams[0].readAsString();
                                                    case 15:
                                                        return Re = Z.sent, De = JSON.parse(Re), V.conversationId = De.conversationId, V.connectionStatus$.next(v.ConnectionStatus.Online), Z.next = 21, V.waitUntilOnline();
                                                    case 21:
                                                        V.theStreamHandler.flush(), V.queueActivities = !1, Z.next = 28;
                                                        break;
                                                    case 25:
                                                        Z.prev = 25, Z.t0 = Z.catch(0), be(Z.t0);
                                                    case 28:
                                                    case "end":
                                                        return Z.stop();
                                                }
                                            }, he, null, [
                                                [
                                                    0,
                                                    25
                                                ]
                                            ]);
                                        }));
                                        return function(he, ye) {
                                            return le.apply(this, arguments);
                                        };
                                    }()).finally(function() {
                                        return U.abort();
                                    }));
                                case 9:
                                case "end":
                                    return ie.stop();
                            }
                        }, R, this);
                    }));
                    function P() {
                        return W.apply(this, arguments);
                    }
                    return P;
                }()
            },
            {
                key: "connectWithRetryAsync",
                value: function() {
                    var W = (0, a.default)(/* @__PURE__ */ i.default.mark(function R() {
                        var V = this, X, N;
                        return i.default.wrap(function(G) {
                            for(;;)switch(G.prev = G.next){
                                case 0:
                                    return G.next = 2, (this.connectDeferred = (0, m.default)()).promise;
                                case 2:
                                    X = x, this.connectionStatus$.next(v.ConnectionStatus.Connecting);
                                case 4:
                                    if (!(X > 0)) {
                                        G.next = 27;
                                        break;
                                    }
                                    return X--, N = Date.now(), G.prev = 7, G.next = 10, this.connectAsync();
                                case 10:
                                    G.next = 15;
                                    break;
                                case 12:
                                    G.prev = 12, G.t0 = G.catch(7), console.error(G.t0);
                                case 15:
                                    if (this.connectionStatus$.getValue() !== v.ConnectionStatus.Ended) {
                                        G.next = 17;
                                        break;
                                    }
                                    return G.abrupt("return");
                                case 17:
                                    if (this.connectionStatus$.getValue() !== v.ConnectionStatus.Connecting && this.connectionStatus$.next(v.ConnectionStatus.Connecting), !(6e4 < Date.now() - N)) {
                                        G.next = 22;
                                        break;
                                    }
                                    X = x, G.next = 25;
                                    break;
                                case 22:
                                    if (!(X > 0)) {
                                        G.next = 25;
                                        break;
                                    }
                                    return G.next = 25, new Promise(function(re) {
                                        return setTimeout(re, V.getRetryDelay());
                                    });
                                case 25:
                                    G.next = 4;
                                    break;
                                case 27:
                                    this.connectionStatus$.next(v.ConnectionStatus.FailedToConnect);
                                case 28:
                                    G.next = 0;
                                    break;
                                case 30:
                                case "end":
                                    return G.stop();
                            }
                        }, R, this, [
                            [
                                7,
                                12
                            ]
                        ]);
                    }));
                    function P() {
                        return W.apply(this, arguments);
                    }
                    return P;
                }()
            },
            {
                key: "getRetryDelay",
                value: function() {
                    return Math.floor(3e3 + Math.random() * 12e3);
                }
            }
        ]), J;
    }();
    return $914aec8743edd630$var$Lr.DirectLineStreaming = H, $914aec8743edd630$var$Lr;
}
var $914aec8743edd630$var$l0;
function $914aec8743edd630$var$jg() {
    return $914aec8743edd630$var$l0 || ($914aec8743edd630$var$l0 = 1, function(e) {
        var t = $914aec8743edd630$var$sn(), r = $914aec8743edd630$var$nr();
        Object.defineProperty(e, "__esModule", {
            value: !0
        }), Object.defineProperty(e, "DirectLineStreaming", {
            enumerable: !0,
            get: function() {
                return h.DirectLineStreaming;
            }
        }), e.DirectLine = e.ConnectionStatus = void 0;
        var i = t($914aec8743edd630$var$qm()), n = t($914aec8743edd630$var$Vu()), o = t($914aec8743edd630$var$Gu()), s = t($914aec8743edd630$var$Um());
        $914aec8743edd630$var$f1(), $914aec8743edd630$var$h1();
        var a = $914aec8743edd630$var$vg(), u = $914aec8743edd630$var$Te(), l = $914aec8743edd630$var$oi(), c = m($914aec8743edd630$var$A1);
        $914aec8743edd630$var$O1(), $914aec8743edd630$var$M1(), $914aec8743edd630$var$$1(), $914aec8743edd630$var$q1(), $914aec8743edd630$var$V1(), $914aec8743edd630$var$H1(), $914aec8743edd630$var$Q1(), $914aec8743edd630$var$J1(), $914aec8743edd630$var$ew(), $914aec8743edd630$var$nw(), $914aec8743edd630$var$uw(), $914aec8743edd630$var$fw(), $914aec8743edd630$var$mw(), $914aec8743edd630$var$bw(), $914aec8743edd630$var$Sw(), $914aec8743edd630$var$Cw(), $914aec8743edd630$var$Ow(), $914aec8743edd630$var$Iw();
        var d = t($914aec8743edd630$var$Lw()), h = $914aec8743edd630$var$o2(), f = [
            "contentUrl"
        ];
        function p(W) {
            if (typeof WeakMap != "function") return null;
            var P = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap();
            return (p = function(X) {
                return X ? R : P;
            })(W);
        }
        function m(W, P) {
            if (W && W.__esModule) return W;
            if (W === null || r(W) !== "object" && typeof W != "function") return {
                default: W
            };
            var R = p(P);
            if (R && R.has(W)) return R.get(W);
            var V = {}, X = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var N in W)if (N !== "default" && Object.prototype.hasOwnProperty.call(W, N)) {
                var U = X ? Object.getOwnPropertyDescriptor(W, N) : null;
                U && (U.get || U.set) ? Object.defineProperty(V, N, U) : V[N] = W[N];
            }
            return V.default = W, R && R.set(W, V), V;
        }
        function w(W, P) {
            var R = Object.keys(W);
            if (Object.getOwnPropertySymbols) {
                var V = Object.getOwnPropertySymbols(W);
                P && (V = V.filter(function(X) {
                    return Object.getOwnPropertyDescriptor(W, X).enumerable;
                })), R.push.apply(R, V);
            }
            return R;
        }
        function v(W) {
            for(var P = 1; P < arguments.length; P++){
                var R = arguments[P] != null ? arguments[P] : {};
                P % 2 ? w(Object(R), !0).forEach(function(V) {
                    (0, s.default)(W, V, R[V]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(W, Object.getOwnPropertyDescriptors(R)) : w(Object(R)).forEach(function(V) {
                    Object.defineProperty(W, V, Object.getOwnPropertyDescriptor(R, V));
                });
            }
            return W;
        }
        var g = "DirectLine/3.0", A;
        e.ConnectionStatus = A, function(W) {
            W[W.Uninitialized = 0] = "Uninitialized", W[W.Connecting = 1] = "Connecting", W[W.Online = 2] = "Online", W[W.ExpiredToken = 3] = "ExpiredToken", W[W.FailedToConnect = 4] = "FailedToConnect", W[W.Ended = 5] = "Ended";
        }(A || (e.ConnectionStatus = A = {}));
        var b = function(P, R) {
            var V = function() {
                throw new Error("not implemented");
            }, X = function(G) {
                return G.catch(function(re) {
                    if (re.status === 429) {
                        var oe = re.xhr.getResponseHeader("Retry-After"), ie = Number(oe);
                        if (!isNaN(ie)) return u.Observable.timer(ie, R).flatMap(function(le) {
                            return u.Observable.throw(re, R);
                        });
                    }
                    return u.Observable.throw(re, R);
                });
            }, N = function(G) {
                return X(P(G));
            };
            return Object.assign(N, {
                get: function(G, re) {
                    return V();
                },
                post: function(G, re, oe) {
                    return V();
                },
                put: function(G, re, oe) {
                    return V();
                },
                patch: function(G, re, oe) {
                    return V();
                },
                delete: function(G, re) {
                    return V();
                },
                getJSON: function(G, re) {
                    return V();
                }
            });
        }, k = function(P) {
            var R = P.scheduler || l.async;
            return {
                scheduler: R,
                ajax: b(P.ajax || u.Observable.ajax, R),
                WebSocket: P.WebSocket || WebSocket,
                random: P.random || Math.random
            };
        }, y = 1800000, x = y / 2, C = 200, I = new Error("expired token"), M = new Error("conversation ended"), Q = new Error("failed to connect"), H = {
            log: function(P) {
                for(var R, V = arguments.length, X = new Array(V > 1 ? V - 1 : 0), N = 1; N < V; N++)X[N - 1] = arguments[N];
                typeof window < "u" && window.botchatDebug && P && (R = console).log.apply(R, [
                    P
                ].concat(X));
            }
        }, J = /* @__PURE__ */ function() {
            function W(P) {
                (0, n.default)(this, W), (0, s.default)(this, "connectionStatus$", new a.BehaviorSubject(A.Uninitialized)), (0, s.default)(this, "domain", "https://directline.botframework.com/v3/directline"), (0, s.default)(this, "watermark", ""), (0, s.default)(this, "_botAgent", ""), (0, s.default)(this, "timeout", 20000), (0, s.default)(this, "pollingInterval", 1e3), this.secret = P.secret, this.token = P.secret || P.token, this.webSocket = (P.webSocket === void 0 ? !0 : P.webSocket) && typeof WebSocket < "u" && WebSocket !== void 0, P.streaming && (this.streaming = P.streaming), P.conversationStartProperties && P.conversationStartProperties.locale && (Object.prototype.toString.call(P.conversationStartProperties.locale) === "[object String]" ? this.localeOnStartConversation = P.conversationStartProperties.locale : console.warn("DirectLineJS: conversationStartProperties.locale was ignored: the locale name may be a BCP 47 language tag")), P.domain && (this.domain = P.domain), P.conversationId && (this.conversationId = P.conversationId), P.watermark && (this.watermark = P.watermark), P.streamUrl && (P.token && P.conversationId ? this.streamUrl = P.streamUrl : console.warn("DirectLineJS: streamUrl was ignored: you need to provide a token and a conversationid")), P.timeout !== void 0 && (this.timeout = P.timeout), this.retries = (y - x) / this.timeout, this._botAgent = this.getBotAgent(P.botAgent), this.services = k(P);
                var R = ~~P.pollingInterval;
                R < C ? typeof P.pollingInterval < "u" && console.warn("DirectLineJS: provided pollingInterval (".concat(P.pollingInterval, ") is under lower bound (200ms), using default of 1000ms")) : this.pollingInterval = R, this.expiredTokenExhaustion = this.setConnectionStatusFallback(A.ExpiredToken, A.FailedToConnect, 5), this.activity$ = (this.webSocket ? this.webSocketActivity$() : this.pollingGetActivity$()).share();
            }
            return (0, o.default)(W, [
                {
                    key: "checkConnection",
                    value: function() {
                        var R = this, V = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, X = this.connectionStatus$.flatMap(function(N) {
                            return N === A.Uninitialized ? (R.connectionStatus$.next(A.Connecting), R.token && R.streamUrl ? (R.connectionStatus$.next(A.Online), u.Observable.of(N, R.services.scheduler)) : R.startConversation().do(function(U) {
                                R.conversationId = U.conversationId, R.token = R.secret || U.token, R.streamUrl = U.streamUrl, R.referenceGrammarId = U.referenceGrammarId, R.secret || R.refreshTokenLoop(), R.connectionStatus$.next(A.Online);
                            }, function(U) {
                                R.connectionStatus$.next(A.FailedToConnect);
                            }).map(function(U) {
                                return N;
                            })) : u.Observable.of(N, R.services.scheduler);
                        }).filter(function(N) {
                            return N != A.Uninitialized && N != A.Connecting;
                        }).flatMap(function(N) {
                            switch(N){
                                case A.Ended:
                                    return u.Observable.throw(M, R.services.scheduler);
                                case A.FailedToConnect:
                                    return u.Observable.throw(Q, R.services.scheduler);
                                case A.ExpiredToken:
                                    return u.Observable.of(N, R.services.scheduler);
                                default:
                                    return u.Observable.of(N, R.services.scheduler);
                            }
                        });
                        return V ? X.take(1) : X;
                    }
                },
                {
                    key: "setConnectionStatusFallback",
                    value: function(R, V) {
                        var X = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
                        X--;
                        var N = 0, U = null;
                        return function(G) {
                            return G === R && U === G && N >= X ? (N = 0, V) : (N++, U = G, G);
                        };
                    }
                },
                {
                    key: "expiredToken",
                    value: function() {
                        var R = this.connectionStatus$.getValue();
                        R != A.Ended && R != A.FailedToConnect && this.connectionStatus$.next(A.ExpiredToken);
                        var V = this.expiredTokenExhaustion(this.connectionStatus$.getValue());
                        this.connectionStatus$.next(V);
                    }
                },
                {
                    key: "startConversation",
                    value: function() {
                        var R = this, V = this.conversationId ? "".concat(this.domain, "/conversations/").concat(this.conversationId, "?watermark=").concat(this.watermark) : "".concat(this.domain, "/conversations"), X = this.conversationId ? "GET" : "POST", N = this.conversationId ? void 0 : {
                            user: {
                                id: this.userIdOnStartConversation
                            },
                            locale: this.localeOnStartConversation
                        };
                        return this.services.ajax({
                            method: X,
                            url: V,
                            body: N,
                            timeout: this.timeout,
                            headers: v({
                                Accept: "application/json",
                                "Content-Type": "application/json"
                            }, this.commonHeaders())
                        }).map(function(U) {
                            return U.response;
                        }).retryWhen(function(U) {
                            return(// for now we deem 4xx and 5xx errors as unrecoverable
                            // for everything else (timeouts), retry for a while
                            U.mergeMap(function(G) {
                                return G.status >= 400 && G.status < 600 ? u.Observable.throw(G, R.services.scheduler) : u.Observable.of(G, R.services.scheduler);
                            }).delay(R.timeout, R.services.scheduler).take(R.retries));
                        });
                    }
                },
                {
                    key: "refreshTokenLoop",
                    value: function() {
                        var R = this;
                        this.tokenRefreshSubscription = u.Observable.interval(x, this.services.scheduler).flatMap(function(V) {
                            return R.refreshToken();
                        }).subscribe(function(V) {
                            H.log("refreshing token", V, "at", /* @__PURE__ */ new Date()), R.token = V;
                        });
                    }
                },
                {
                    key: "refreshToken",
                    value: function() {
                        var R = this;
                        return this.checkConnection(!0).flatMap(function(V) {
                            return R.services.ajax({
                                method: "POST",
                                url: "".concat(R.domain, "/tokens/refresh"),
                                timeout: R.timeout,
                                headers: v({}, R.commonHeaders())
                            }).map(function(X) {
                                return X.response.token;
                            }).retryWhen(function(X) {
                                return X.mergeMap(function(N) {
                                    return N.status === 403 ? (R.expiredToken(), u.Observable.throw(N, R.services.scheduler)) : N.status === 404 ? u.Observable.throw(N, R.services.scheduler) : u.Observable.of(N, R.services.scheduler);
                                }).delay(R.timeout, R.services.scheduler).take(R.retries);
                            });
                        });
                    }
                },
                {
                    key: "reconnect",
                    value: function(R) {
                        this.token = R.token, this.streamUrl = R.streamUrl, this.connectionStatus$.getValue() === A.ExpiredToken && this.connectionStatus$.next(A.Online);
                    }
                },
                {
                    key: "end",
                    value: function() {
                        this.tokenRefreshSubscription && this.tokenRefreshSubscription.unsubscribe();
                        try {
                            this.connectionStatus$.next(A.Ended);
                        } catch (R) {
                            if (R === M) return;
                            throw R;
                        }
                    }
                },
                {
                    key: "getSessionId",
                    value: function() {
                        var R = this;
                        return H.log("getSessionId"), this.checkConnection(!0).flatMap(function(V) {
                            return R.services.ajax({
                                method: "GET",
                                url: "".concat(R.domain, "/session/getsessionid"),
                                withCredentials: !0,
                                timeout: R.timeout,
                                headers: v({
                                    "Content-Type": "application/json"
                                }, R.commonHeaders())
                            }).map(function(X) {
                                return X && X.response && X.response.sessionId ? (H.log("getSessionId response: " + X.response.sessionId), X.response.sessionId) : "";
                            }).catch(function(X) {
                                return H.log("getSessionId error: " + X.status), u.Observable.of("", R.services.scheduler);
                            });
                        }).catch(function(V) {
                            return R.catchExpiredToken(V);
                        });
                    }
                },
                {
                    key: "postActivity",
                    value: function(R) {
                        var V = this;
                        return this.streaming && (R.deliveryMode = "stream"), this.userIdOnStartConversation && R.from && R.from.id !== this.userIdOnStartConversation && (console.warn("DirectLineJS: Activity.from.id does not match with user id, ignoring activity.from.id"), R.from.id = this.userIdOnStartConversation), R.type === "message" && R.attachments && R.attachments.length > 0 ? this.postMessageWithAttachments(R) : (H.log("postActivity", R), this.checkConnection(!0).flatMap(function(X) {
                            return V.services.ajax({
                                method: "POST",
                                url: "".concat(V.domain, "/conversations/").concat(V.conversationId, "/activities"),
                                body: R,
                                timeout: V.timeout,
                                headers: v({
                                    "Content-Type": "application/json"
                                }, V.commonHeaders())
                            }).map(function(N) {
                                return N.response.id;
                            }).catch(function(N) {
                                return V.catchPostError(N);
                            });
                        }).catch(function(X) {
                            return V.catchExpiredToken(X);
                        }));
                    }
                },
                {
                    key: "postMessageWithAttachments",
                    value: function(R) {
                        var V = this, X = R.attachments, N = (0, d.default)(X.map(function(re) {
                            return re.name || "blob";
                        })), U = X.map(function(re, oe) {
                            return v(v({}, re), {}, {
                                name: N[oe]
                            });
                        }), G;
                        return this.checkConnection(!0).flatMap(function(re) {
                            return G = new FormData(), G.append("activity", new Blob([
                                JSON.stringify(v(v({}, R), {}, {
                                    // Removing contentUrl from attachment, we will send it via multipart
                                    attachments: U.map(function(oe) {
                                        oe.contentUrl;
                                        var ie = (0, i.default)(oe, f);
                                        return v({}, ie);
                                    })
                                }))
                            ], {
                                type: "application/vnd.microsoft.activity"
                            })), u.Observable.from(U, V.services.scheduler).flatMap(function(oe) {
                                return V.services.ajax({
                                    method: "GET",
                                    url: oe.contentUrl,
                                    responseType: "arraybuffer"
                                }).do(function(ie) {
                                    return G.append("file", new Blob([
                                        ie.response
                                    ], {
                                        type: oe.contentType
                                    }), oe.name);
                                });
                            }).count();
                        }).flatMap(function(re) {
                            return V.services.ajax({
                                method: "POST",
                                url: "".concat(V.domain, "/conversations/").concat(V.conversationId, "/upload?userId=").concat(R.from.id),
                                body: G,
                                timeout: V.timeout,
                                headers: v({}, V.commonHeaders())
                            }).map(function(oe) {
                                return oe.response.id;
                            }).catch(function(oe) {
                                return V.catchPostError(oe);
                            });
                        }).catch(function(re) {
                            return V.catchPostError(re);
                        });
                    }
                },
                {
                    key: "catchPostError",
                    value: function(R) {
                        if (R.status === 403) this.expiredToken();
                        else if (R.status >= 400 && R.status < 500) return u.Observable.throw(R, this.services.scheduler);
                        return u.Observable.of("retry", this.services.scheduler);
                    }
                },
                {
                    key: "catchExpiredToken",
                    value: function(R) {
                        return R === I ? u.Observable.of("retry", this.services.scheduler) : u.Observable.throw(R, this.services.scheduler);
                    }
                },
                {
                    key: "pollingGetActivity$",
                    value: function() {
                        var R = this, V = u.Observable.create(function(X) {
                            var N = new a.BehaviorSubject({});
                            N.subscribe(function() {
                                if (R.connectionStatus$.getValue() === A.Online) {
                                    var U = Date.now();
                                    R.services.ajax({
                                        headers: v({
                                            Accept: "application/json"
                                        }, R.commonHeaders()),
                                        method: "GET",
                                        url: "".concat(R.domain, "/conversations/").concat(R.conversationId, "/activities?watermark=").concat(R.watermark),
                                        timeout: R.timeout
                                    }).subscribe(function(G) {
                                        X.next(G), setTimeout(function() {
                                            return N.next(null);
                                        }, Math.max(0, R.pollingInterval - Date.now() + U));
                                    }, function(G) {
                                        switch(G.status){
                                            case 403:
                                                R.connectionStatus$.next(A.ExpiredToken), setTimeout(function() {
                                                    return N.next(null);
                                                }, R.pollingInterval);
                                                break;
                                            case 404:
                                                R.connectionStatus$.next(A.Ended);
                                                break;
                                            default:
                                                X.error(G);
                                                break;
                                        }
                                    });
                                }
                            });
                        });
                        return this.checkConnection().flatMap(function(X) {
                            return V.catch(function() {
                                return u.Observable.empty();
                            }).map(function(N) {
                                return N.response;
                            }).flatMap(function(N) {
                                return R.observableFromActivityGroup(N);
                            });
                        });
                    }
                },
                {
                    key: "observableFromActivityGroup",
                    value: function(R) {
                        return R.watermark && (this.watermark = R.watermark), u.Observable.from(R.activities, this.services.scheduler);
                    }
                },
                {
                    key: "webSocketActivity$",
                    value: function() {
                        var R = this;
                        return this.checkConnection().flatMap(function(V) {
                            return R.observableWebSocket().retryWhen(function(X) {
                                return X.delay(R.getRetryDelay(), R.services.scheduler).mergeMap(function(N) {
                                    return R.reconnectToConversation();
                                });
                            });
                        }).flatMap(function(V) {
                            return R.observableFromActivityGroup(V);
                        });
                    }
                },
                {
                    key: "getRetryDelay",
                    value: function() {
                        return Math.floor(3e3 + this.services.random() * 12e3);
                    }
                },
                {
                    key: "observableWebSocket",
                    value: function() {
                        var R = this;
                        return u.Observable.create(function(V) {
                            H.log("creating WebSocket", R.streamUrl);
                            var X = new R.services.WebSocket(R.streamUrl), N, U;
                            return X.onopen = function(G) {
                                H.log("WebSocket open", G), N = u.Observable.interval(R.timeout, R.services.scheduler).subscribe(function(re) {
                                    try {
                                        X.send("");
                                    } catch (oe) {
                                        H.log("Ping error", oe);
                                    }
                                });
                            }, X.onclose = function(G) {
                                H.log("WebSocket close", G), N && N.unsubscribe(), U || V.error(G), U = !0;
                            }, X.onerror = function(G) {
                                H.log("WebSocket error", G), N && N.unsubscribe(), U || V.error(G), U = !0;
                            }, X.onmessage = function(G) {
                                return G.data && V.next(JSON.parse(G.data));
                            }, function() {
                                (X.readyState === 0 || X.readyState === 1) && X.close();
                            };
                        });
                    }
                },
                {
                    key: "reconnectToConversation",
                    value: function() {
                        var R = this;
                        return this.checkConnection(!0).flatMap(function(V) {
                            return R.services.ajax({
                                method: "GET",
                                url: "".concat(R.domain, "/conversations/").concat(R.conversationId, "?watermark=").concat(R.watermark),
                                timeout: R.timeout,
                                headers: v({
                                    Accept: "application/json"
                                }, R.commonHeaders())
                            }).do(function(X) {
                                R.secret || (R.token = X.response.token), R.streamUrl = X.response.streamUrl;
                            }).map(function(X) {
                                return null;
                            }).retryWhen(function(X) {
                                return X.mergeMap(function(N) {
                                    if (N.status === 403) R.expiredToken();
                                    else if (N.status === 404) return u.Observable.throw(M, R.services.scheduler);
                                    return u.Observable.of(N, R.services.scheduler);
                                }).delay(R.timeout, R.services.scheduler).take(R.retries);
                            });
                        });
                    }
                },
                {
                    key: "commonHeaders",
                    value: function() {
                        return {
                            Authorization: "Bearer ".concat(this.token),
                            "x-ms-bot-agent": this._botAgent
                        };
                    }
                },
                {
                    key: "getBotAgent",
                    value: function() {
                        var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", V = "directlinejs";
                        return R && (V += "; ".concat(R)), "".concat(g, " (").concat(V, " ").concat("0.15.8", ")");
                    }
                },
                {
                    key: "setUserId",
                    value: function(R) {
                        if (this.connectionStatus$.getValue() === A.Online) throw new Error("DirectLineJS: It is connected, we cannot set user id.");
                        var V = this.parseToken(this.token);
                        if (V) return console.warn("DirectLineJS: user id is already set in token, will ignore this user id.");
                        if (/^dl_/.test(R)) return console.warn('DirectLineJS: user id prefixed with "dl_" is reserved and must be embedded into the Direct Line token to prevent forgery.');
                        this.userIdOnStartConversation = R;
                    }
                },
                {
                    key: "parseToken",
                    value: function(R) {
                        try {
                            var V = (0, c.default)(R), X = V.user;
                            return X;
                        } catch (N) {
                            if (N instanceof c.InvalidTokenError) return;
                        }
                    }
                }
            ]), W;
        }();
        e.DirectLine = J;
    }($914aec8743edd630$var$_i)), $914aec8743edd630$var$_i;
}
var $914aec8743edd630$var$Zt = $914aec8743edd630$var$jg();
const $914aec8743edd630$var$a2 = {
    widgetDisplayType: "large",
    open: !1,
    loaded: !1
}, $914aec8743edd630$var$Fg = $914aec8743edd630$var$mt({
    name: "widget",
    initialState: $914aec8743edd630$var$a2,
    reducers: {
        openWidget: (e)=>{
            e.open = !0, e.loaded = !0;
        },
        closeWidget: (e)=>{
            e.open = !1, e.loaded = !0;
        },
        toggleWidget: (e)=>{
            e.open = !e.open, e.loaded = !0;
        },
        toggleDisplay: (e)=>{
            e.widgetDisplayType = e.widgetDisplayType === "large" ? "thumbnail" : "large";
        }
    }
}), $914aec8743edd630$var$s2 = $914aec8743edd630$var$Fg.reducer, { openWidget: $914aec8743edd630$var$u2, closeWidget: $914aec8743edd630$var$c2, toggleWidget: $914aec8743edd630$var$l2, toggleDisplay: $914aec8743edd630$var$d2 } = $914aec8743edd630$var$Fg.actions;
var $914aec8743edd630$var$$g = /* @__PURE__ */ ((e)=>(e[e.agent = 1] = "agent", e[e.widget = 2] = "widget", e[e.news = 3] = "news", e))($914aec8743edd630$var$$g || {}), $914aec8743edd630$var$mc = /* @__PURE__ */ ((e)=>(e[e.none = 1] = "none", e[e.history = 2] = "history", e[e.languages = 3] = "languages", e[e.weather = 4] = "weather", e[e.emergency = 5] = "emergency", e[e.map = 6] = "map", e[e.custom = 7] = "custom", e))($914aec8743edd630$var$mc || {}), $914aec8743edd630$var$je = /* @__PURE__ */ ((e)=>(e[e.mobile = 1] = "mobile", e[e.borne = 2] = "borne", e[e.landscape = 3] = "landscape", e[e.widget = 4] = "widget", e[e.widgetLandscape = 5] = "widgetLandscape", e[e.widgetBorne = 6] = "widgetBorne", e))($914aec8743edd630$var$je || {}), $914aec8743edd630$var$Vr = /* @__PURE__ */ ((e)=>(e.auto = "auto", e.always = "always", e.never = "never", e.ignore = "ignore", e))($914aec8743edd630$var$Vr || {}), $914aec8743edd630$var$Bn = /* @__PURE__ */ ((e)=>(e[e.available = 1] = "available", e[e.opened = 2] = "opened", e[e.closing = 3] = "closing", e[e.closed = 4] = "closed", e))($914aec8743edd630$var$Bn || {}), $914aec8743edd630$var$Ft = /* @__PURE__ */ ((e)=>(e[e.vocal = 1] = "vocal", e[e.text = 2] = "text", e[e.dashboard = 3] = "dashboard", e))($914aec8743edd630$var$Ft || {}), $914aec8743edd630$var$ht = /* @__PURE__ */ ((e)=>(e[e.waiting = 1] = "waiting", e[e.allowed = 2] = "allowed", e[e.refused = 3] = "refused", e[e.error = 4] = "error", e))($914aec8743edd630$var$ht || {}), $914aec8743edd630$var$Ru = /* @__PURE__ */ ((e)=>(e[e.DetailViewOpen = 1] = "DetailViewOpen", e[e.DetailViewClose = 2] = "DetailViewClose", e[e.SpeechStarted = 3] = "SpeechStarted", e[e.SpeechEnded = 4] = "SpeechEnded", e))($914aec8743edd630$var$Ru || {}), $914aec8743edd630$var$at = /* @__PURE__ */ ((e)=>(e[e.Initializing = 1] = "Initializing", e[e.Listening = 2] = "Listening", e[e.Closing = 3] = "Closing", e[e.ForceClosing = 4] = "ForceClosing", e[e.Closed = 5] = "Closed", e))($914aec8743edd630$var$at || {}), $914aec8743edd630$var$gc = /* @__PURE__ */ ((e)=>(e[e.Home = 1] = "Home", e[e.News = 2] = "News", e[e.EmptyVeille = 3] = "EmptyVeille", e[e.ScreenSaver = 4] = "ScreenSaver", e[e.SlideShow = 5] = "SlideShow", e[e.NewsInVeille = 6] = "NewsInVeille", e))($914aec8743edd630$var$gc || {}), $914aec8743edd630$var$bc = /* @__PURE__ */ ((e)=>(e[e.none = 1] = "none", e[e.agent = 2] = "agent", e[e.background = 3] = "background", e[e.remote = 4] = "remote", e[e.languages = 5] = "languages", e[e.card = 6] = "card", e[e.qroverlay = 7] = "qroverlay", e))($914aec8743edd630$var$bc || {}), $914aec8743edd630$var$Lg = /* @__PURE__ */ ((e)=>(e.dark = "dark", e.light = "light", e.auto = "auto", e))($914aec8743edd630$var$Lg || {});
const $914aec8743edd630$var$d0 = {
    fullScreenImage: void 0,
    lastListActivity: void 0,
    listStatus: $914aec8743edd630$var$Bn.available,
    currentSubView: $914aec8743edd630$var$mc.none,
    currentCustomView: void 0,
    retorikEvent: void 0,
    displayAgent: !0,
    activityToSend: void 0,
    retorikNewsEnded: !1,
    userIsTyping: !1,
    userIsSwiping: !1,
    askedForKioskParametersOpening: 0,
    detailedAttachmentTriggers: [
        {
            type: "event",
            name: "hospitality.ShowPointOfInterest",
            linkedComponent: null
        },
        {
            type: "event",
            name: "hospitality.ShowContentItem",
            linkedComponent: null
        }
    ],
    modalFullscreenContent: null,
    modalFullscreenContentNoDisplayId: void 0,
    GDPRDisplay: !0,
    GDPRWindowData: void 0,
    GDPRUserConsent: !1,
    unlockClickedButton: !1,
    dashboardOpened: !1,
    clickedOnUI: $914aec8743edd630$var$bc.none,
    closeDetailedPOI: !1,
    closeList: 0
}, $914aec8743edd630$var$Ng = $914aec8743edd630$var$mt({
    name: "utils",
    initialState: $914aec8743edd630$var$d0,
    reducers: {
        setFullScreenImage: (e, t)=>{
            e.fullScreenImage = t.payload;
        },
        setLastListActivity: (e, t)=>{
            e.lastListActivity = t.payload;
        },
        setListStatus: (e, t)=>{
            e.listStatus = t.payload;
        },
        setCloseList: (e, t)=>{
            e.closeList = t.payload;
        },
        setCurrentSubView: (e, t)=>{
            e.currentSubView = t.payload;
        },
        setCurrentCustomView: (e, t)=>{
            e.currentCustomView = t.payload;
        },
        setRetorikEvent: (e, t)=>{
            e.retorikEvent = t.payload;
        },
        showAgent: (e)=>{
            e.displayAgent = !0;
        },
        hideAgent: (e)=>{
            e.displayAgent = !1;
        },
        setRetorikNewsEnded: (e, t)=>{
            e.retorikNewsEnded = t.payload;
        },
        setUserTyping: (e, t)=>{
            e.userIsTyping = t.payload;
        },
        setUserSwiping: (e, t)=>{
            e.userIsSwiping = t.payload;
        },
        askForKioskParametersOpening: (e)=>{
            e.askedForKioskParametersOpening = e.askedForKioskParametersOpening + 1;
        },
        addDetailedAttachmentTrigger: (e, t)=>{
            e.detailedAttachmentTriggers = [
                ...e.detailedAttachmentTriggers,
                t.payload
            ];
        },
        setModalFullscreenContent: (e, t)=>{
            e.modalFullscreenContent = t.payload;
        },
        setModalFullscreenContentFromActivity: (e, t)=>{
            t.payload.fromActivity !== e.modalFullscreenContentNoDisplayId && (e.modalFullscreenContent = t.payload.value, e.modalFullscreenContentNoDisplayId = t.payload.fromActivity);
        },
        setGDPRDisplay: (e, t)=>{
            e.GDPRDisplay = t.payload;
        },
        setGDPRWindowData: (e, t)=>{
            e.GDPRWindowData = t.payload;
        },
        setGDPRUserConsent: (e, t)=>{
            e.GDPRUserConsent = t.payload;
        },
        lockClickedButton: (e)=>{
            e.unlockClickedButton = !1;
        },
        unlockClickedButton: (e)=>{
            e.unlockClickedButton = !0;
        },
        setDashboardOpened: (e, t)=>{
            e.dashboardOpened = t.payload;
        },
        toggleDashboard: (e, t)=>{
            t != null && t.payload || (e.currentSubView = $914aec8743edd630$var$mc.none), e.dashboardOpened = !e.dashboardOpened;
        },
        setClickedUIPart: (e, t)=>{
            e.clickedOnUI = t.payload;
        },
        resetClickedOnUI: (e)=>{
            e.clickedOnUI = $914aec8743edd630$var$bc.none;
        },
        setCloseDetailedPOI: (e, t)=>{
            e.closeDetailedPOI = t.payload;
        },
        resetUtilsStore: ()=>({
                ...$914aec8743edd630$var$d0
            })
    }
}), $914aec8743edd630$var$f2 = $914aec8743edd630$var$Ae("utils/setClickedOnUI", async (e, t)=>{
    t.dispatch($914aec8743edd630$var$P2(e)), setTimeout(()=>{
        t.dispatch($914aec8743edd630$var$I2());
    }, 50);
}), $914aec8743edd630$var$h2 = $914aec8743edd630$var$Ng.reducer, { setFullScreenImage: $914aec8743edd630$var$p2, setLastListActivity: $914aec8743edd630$var$Bg, setListStatus: $914aec8743edd630$var$qg, setCloseList: $914aec8743edd630$var$m2, setCurrentSubView: $914aec8743edd630$var$g2, setCurrentCustomView: $914aec8743edd630$var$b2, setRetorikEvent: $914aec8743edd630$var$zg, showAgent: $914aec8743edd630$var$v2, hideAgent: $914aec8743edd630$var$y2, setRetorikNewsEnded: $914aec8743edd630$var$w2, setUserTyping: $914aec8743edd630$var$Ug, setUserSwiping: $914aec8743edd630$var$_2, askForKioskParametersOpening: $914aec8743edd630$var$k2, addDetailedAttachmentTrigger: $914aec8743edd630$var$x2, setModalFullscreenContent: $914aec8743edd630$var$S2, setModalFullscreenContentFromActivity: $914aec8743edd630$var$E2, setGDPRDisplay: $914aec8743edd630$var$A2, setGDPRWindowData: $914aec8743edd630$var$T2, setGDPRUserConsent: $914aec8743edd630$var$C2, lockClickedButton: $914aec8743edd630$var$R2, unlockClickedButton: $914aec8743edd630$var$fn, setDashboardOpened: $914aec8743edd630$var$O2, toggleDashboard: $914aec8743edd630$var$D2, setClickedUIPart: $914aec8743edd630$var$P2, resetClickedOnUI: $914aec8743edd630$var$I2, setCloseDetailedPOI: $914aec8743edd630$var$M2, resetUtilsStore: $914aec8743edd630$var$j2 } = $914aec8743edd630$var$Ng.actions, $914aec8743edd630$var$F2 = 1300, $914aec8743edd630$var$Vg = "https://cdn.retorik.ai", $914aec8743edd630$var$Gg = `${$914aec8743edd630$var$Vg}/spiritenginehtml5/characters`, $914aec8743edd630$var$$2 = `${$914aec8743edd630$var$Vg}/retorik-framework/imagefiles`, $914aec8743edd630$var$f0 = {
    default: "fr-FR",
    all: [
        "fr-FR"
    ]
}, $914aec8743edd630$var$L2 = [
    $914aec8743edd630$var$je.mobile,
    $914aec8743edd630$var$je.widget
], $914aec8743edd630$var$N2 = [
    $914aec8743edd630$var$je.widget,
    $914aec8743edd630$var$je.widgetBorne,
    $914aec8743edd630$var$je.widgetLandscape
], $914aec8743edd630$var$B2 = [
    $914aec8743edd630$var$je.landscape,
    $914aec8743edd630$var$je.widgetLandscape
], $914aec8743edd630$var$q2 = [
    $914aec8743edd630$var$je.borne,
    $914aec8743edd630$var$je.widgetBorne
], $914aec8743edd630$var$Ue = {
    primary: "#00D7FF",
    secondary: "#1999B1",
    black: "#101219",
    whereToEatColor: "#FC952E",
    whereToSleepColor: "#9F007D",
    tobeSeenColor: "#76AB2A",
    tobeDoneColor: "#E23C2A",
    localProductsColor: "#AFB942",
    servicesColor: "#00C8BC",
    agendaColor: "#865DA2",
    occupantColor: "#6DEDBC"
}, $914aec8743edd630$var$z2 = [
    "davi.closewindow",
    "setuser",
    "davi.gdprconsent"
], $914aec8743edd630$var$U2 = [
    "ar",
    "fa",
    "he",
    "ps",
    "ur"
], $914aec8743edd630$var$V2 = [
    "af-ZA",
    "am-ET",
    "ar-AE",
    "ar-BH",
    "ar-DZ",
    "ar-EG",
    "ar-IQ",
    "ar-JO",
    "ar-KW",
    "ar-LB",
    "ar-LY",
    "ar-MA",
    "ar-OM",
    "ar-QA",
    "ar-SA",
    "ar-SY",
    "ar-TN",
    "ar-YE",
    "as-IN",
    "az-AZ",
    "bg-BG",
    "bn-BD",
    "bn-IN",
    "bs-BA",
    "ca-ES",
    "cs-CZ",
    "cy-GB",
    "da-DK",
    "de-AT",
    "de-CH",
    "de-DE",
    "el-GR",
    "en-AU",
    "en-CA",
    "en-GB",
    "en-HK",
    "en-IE",
    "en-IN",
    "en-KE",
    "en-NG",
    "en-NZ",
    "en-PH",
    "en-SG",
    "en-TZ",
    "en-US",
    "en-ZA",
    "es-AR",
    "es-BO",
    "es-CL",
    "es-CO",
    "es-CR",
    "es-CU",
    "es-DO",
    "es-EC",
    "es-ES",
    "es-GQ",
    "es-GT",
    "es-HN",
    "es-MX",
    "es-NI",
    "es-PA",
    "es-PE",
    "es-PR",
    "es-PY",
    "es-SV",
    "es-US",
    "es-UY",
    "es-VE",
    "et-EE",
    "eu-ES",
    "fa-IR",
    "fi-FI",
    "fil-PH",
    "fr-BE",
    "fr-CA",
    "fr-CH",
    "fr-FR",
    "ga-IE",
    "gl-ES",
    "gu-IN",
    "he-IL",
    "hi-IN",
    "hr-HR",
    "hu-HU",
    "hy-AM",
    "id-ID",
    "is-IS",
    "it-IT",
    "iu-CANS-CA",
    "iu-LATN-CA",
    "ja-JP",
    "jv-ID",
    "ka-GE",
    "kk-KZ",
    "km-KH",
    "kn-IN",
    "ko-KR",
    "lo-LA",
    "lt-LT",
    "lv-LV",
    "mk-MK",
    "ml-IN",
    "mn-MN",
    "mr-IN",
    "ms-MY",
    "mt-MT",
    "my-MM",
    "nb-NO",
    "ne-NP",
    "nl-BE",
    "nl-NL",
    "or-IN",
    "pa-IN",
    "pl-PL",
    "ps-AF",
    "pt-BR",
    "pt-PT",
    "ro-RO",
    "ru-RU",
    "si-LK",
    "sk-SK",
    "sl-SI",
    "so-SO",
    "sq-AL",
    "sr-LATN-RS",
    "sr-RS",
    "su-ID",
    "sv-SE",
    "sw-KE",
    "sw-TZ",
    "ta-IN",
    "ta-LK",
    "ta-MY",
    "ta-SG",
    "te-IN",
    "th-TH",
    "tr-TR",
    "uk-UA",
    "ur-IN",
    "ur-PK",
    "uz-UZ",
    "vi-VN",
    "wuu-CN",
    "yue-CN",
    "zh-CN",
    "zh-CN-GUANGXI",
    "zh-CN-henan",
    "zh-CN-liaoning",
    "zh-CN-shaanxi",
    "zh-CN-shandong",
    "zh-CN-sichuan",
    "zh-HK",
    "zh-TW",
    "zu-ZA"
], $914aec8743edd630$var$G2 = [
    "ar-AE",
    "ar-EG",
    "ar-SA",
    "ca-ES",
    "cs-CZ",
    "da-DK",
    "de-AT",
    "de-CH",
    "de-DE",
    "en-CA",
    "en-GB",
    "en-HK",
    "en-IE",
    "en-IN",
    "en-US",
    "es-ES",
    "es-MX",
    "fi-FI",
    "fr-BE",
    "fr-CA",
    "fr-CH",
    "fr-FR",
    "hi-IN",
    "hu-HU",
    "id-ID",
    "it-IT",
    "ja-JP",
    "ko-KR",
    "nb-NO",
    "nl-BE",
    "nl-NL",
    "pl-PL",
    "pt-BR",
    "pt-PT",
    "ru-RU",
    "sv-SE",
    "th-TH",
    "tr-TR",
    "zh-CN",
    "zh-HK",
    "zh-TW"
], $914aec8743edd630$var$W2 = async (e, t)=>{
    const r = `${e}api/graphql?query={siteCultures{culture,default}}`;
    return await fetch(r).then((n)=>n.json()).then((n)=>{
        var a, u, l;
        if (!((u = (a = n.data) == null ? void 0 : a.siteCultures) != null && u.length)) return $914aec8743edd630$var$f0;
        const { processedDefaultLanguage: o, processedSupported: s } = $914aec8743edd630$var$H2(((l = n.data.siteCultures.find((c)=>c.default)) == null ? void 0 : l.culture) || n.data.siteCultures[0].culture, n.data.siteCultures.map((c)=>c.culture));
        return {
            all: s,
            default: o
        };
    }).catch((n)=>(console.log(n), $914aec8743edd630$var$f0));
}, $914aec8743edd630$var$H2 = (e, t, r)=>{
    const i = $914aec8743edd630$var$V2;
    let n = i.includes(e) ? e : "fr-FR";
    const o = [];
    return t.forEach((s)=>{
        if (i.includes(s)) o.push(s);
        else {
            const { dispatch: a } = $914aec8743edd630$export$2e2bcd8739ae039, u = s.split("-")[0], l = t.filter((c)=>c.startsWith(`${u}-`)).find((c)=>i.includes(c));
            if (l) s === e && (n = l), a($914aec8743edd630$export$8b3bc28eb06c49b6.locale.addReplacementLocale({
                key: s,
                value: l
            })), console.log(`Retorik Framework > invalid locale "${s}" was dumped because an existing locale for this language was found ("${l}").`);
            else {
                const c = i.find((d)=>d.startsWith(`${u}-`));
                c ? (o.push(c), s === e && (n = c), a($914aec8743edd630$export$8b3bc28eb06c49b6.locale.addDumpedLanguageFallback({
                    key: c,
                    value: s
                })), a($914aec8743edd630$export$8b3bc28eb06c49b6.locale.addReplacementLocale({
                    key: s,
                    value: c
                })), console.log(`Retorik Framework > invalid locale "${s}" was replaced by "${c}".`)) : console.log(`Retorik Framework > invalid locale "${s}" was dumped and no replacement was found for this language.`);
            }
        }
    }), {
        processedDefaultLanguage: n,
        processedSupported: o
    };
}, $914aec8743edd630$var$K2 = {
    abort: "\u0625\u0644\u063A\u0627\u0621",
    all: "\u0627\u0644\u062C\u0645\u064A\u0639",
    back: "\u062E\u0644\u0641",
    close: "\u0627\u063A\u0644\u0627\u0642",
    continue: "\u064A\u0643\u0645\u0644",
    download: "\u062A\u062D\u0645\u064A\u0644",
    downloadsheet: "\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629",
    downloadsheetmobile: "\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A",
    filter: "\u0645\u0646\u0642\u064A",
    history: "\u062A\u0627\u0631\u064A\u062E\u064A",
    knowmore: "\u0627\u0639\u0631\u0641 \u0627\u0644\u0645\u0632\u064A\u062F",
    lang: "\u0627\u0644\u0644\u063A\u0627\u062A",
    menu: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629",
    mode: "\u0645\u0648\u0636\u0629",
    needhelp: "\u062A\u062D\u062A\u0627\u062C \u0645\u0633\u0627\u0639\u062F\u0629\u061F",
    parameters: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
    print: "\u0645\u0637\u0628\u0639\u0629",
    printsheet: "\u0627\u0637\u0628\u0639 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629",
    result: "\u0646\u062A\u064A\u062C\u0629",
    results: "\u0646\u062A\u0627\u0626\u062C",
    singleLang: "\u0644\u063A\u0629",
    sound: "\u0647\u0627",
    submit: "\u064A\u064F\u0642\u062F\u0651\u0650\u0645",
    subtitle: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0631\u0639\u064A",
    tutorial: "\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A",
    validate: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629"
}, $914aec8743edd630$var$Q2 = {
    shorttitle: "\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0637\u0648\u0627\u0631\u0626",
    samu: ".S.A.M.U",
    police: "\u0634\u0631\u0637\u0629",
    firefighter: "\u0631\u062C\u0627\u0644 \u0627\u0644\u0627\u0637\u0641\u0627\u0621",
    general: "\u0639\u0627\u0645",
    citypolice: "\u0627\u0644\u0634\u0631\u0637\u0629 \u0627\u0644\u0645\u062D\u0644\u064A\u0629",
    hospital: "\u0645\u0633\u062A\u0634\u0641\u0649",
    homeless: "\u0628\u0644\u0627 \u0645\u0623\u0648\u0649 (\u0645\u0643\u0627\u0644\u0645\u0629 \u0645\u062C\u0627\u0646\u064A\u0629)",
    poison: "\u0645\u0631\u0643\u0632 \u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u0633\u0645\u0648\u0645",
    emergency: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0637\u0648\u0627\u0631\u0626 \u0627\u0644\u0623\u0648\u0631\u0648\u0628\u064A\u0629"
}, $914aec8743edd630$var$Y2 = {
    title: "\u062D\u062F\u062B \u062E\u0637\u0623",
    button: "\u0623\u0639\u062F \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642"
}, $914aec8743edd630$var$J2 = {
    shorttitle: "\u062A\u0627\u0631\u064A\u062E\u064A",
    title: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629"
}, $914aec8743edd630$var$Z2 = {
    shorttitle: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629"
}, $914aec8743edd630$var$X2 = {
    choose: "\u0627\u062E\u062A\u0631 \u0625\u062C\u0627\u0628\u0629",
    noaction: "\u0625\u062C\u0631\u0627\u0621 \u0645\u062A\u0648\u0642\u0639"
}, $914aec8743edd630$var$e_ = {
    change: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0644\u063A\u0629",
    select: "\u062D\u062F\u062F \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627"
}, $914aec8743edd630$var$t_ = {
    buttontext: "\u0639\u0631\u0636 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    goto: "\u0627\u0630\u0647\u0628 \u0625\u0644\u0649 \u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    click: "\u0627\u0646\u0642\u0631 \u0647\u0646\u0627",
    scanQR: "\u0639\u0646 \u0637\u0631\u064A\u0642 \u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629",
    scanQRTile: "\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0644\u0627\u0643\u062A\u0634\u0627\u0641"
}, $914aec8743edd630$var$r_ = {
    loader: {
        optimal: "\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C",
        classic: "\u0644\u062A\u062C\u0631\u0628\u0629 \u0623\u0643\u062B\u0631 \u0643\u0644\u0627\u0633\u064A\u0643\u064A\u0629\u060C",
        vocal: "\u0623\u0646\u0627 \u0623\u062A\u062D\u062F\u062B \u0648\u062C\u0647\u0627 \u0644\u0648\u062C\u0647 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644.",
        text: "\u0623\u062A\u0648\u0627\u0635\u0644 \u0643\u062A\u0627\u0628\u064A\u064B\u0627 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644."
    },
    modes: {
        vocal: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A",
        text: "\u0648\u0636\u0639 \u0627\u0644\u0646\u0635"
    },
    loaderValidation: "\u0627\u0628\u062F\u0623 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    locale: "\u0641\u062D\u0635 \u0627\u0644\u0644\u063A\u0629",
    supported: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0644\u063A\u0627\u062A \u0627\u0644\u0645\u062F\u0639\u0648\u0645\u0629",
    addressdata: "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A"
}, $914aec8743edd630$var$n_ = {
    message: "\u0623\u062F\u062E\u0644 \u0631\u0633\u0627\u0644\u062A\u0643",
    backconversation: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    answer: " \u064A\u062C\u064A\u0628 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643"
}, $914aec8743edd630$var$i_ = {
    firstline: "\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C",
    secondline: "\u0627\u0642\u0644\u0628 \u0634\u0627\u0634\u062A\u0643"
}, $914aec8743edd630$var$o_ = {
    shorttitle: "\u0642\u0646\u0627\u0629 \u0627\u062E\u0628\u0627\u0631\u064A\u0629 \u062D\u064A\u0629",
    warningtext: "\u0633\u062A\u062F\u062E\u0644 \u0625\u0644\u0649 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u0625\u062E\u0628\u0627\u0631\u064A\u0629\u060C \u0648\u0633\u064A\u062A\u0645 \u062A\u0646\u0634\u064A\u0637 \u0627\u0644\u0635\u0648\u062A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643",
    live: "\u0645\u0628\u0627\u0634\u0631",
    continuous: "\u0644\u0646\u0643\u0645\u0644"
}, $914aec8743edd630$var$a_ = {
    comment: "\u0631\u0623\u064A \u0627\u0644\u0639\u0645\u064A\u0644",
    route: "\u0637\u0631\u064A\u0642",
    nodata: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649 \u064A\u0637\u0627\u0628\u0642 \u0628\u062D\u062B\u0643",
    openinghours: "\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644",
    prices: "\u0627\u0644\u0623\u0633\u0639\u0627\u0631",
    paymentmethods: "\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639",
    numberofplaces: "\u0639\u062F\u062F \u0627\u0644\u0623\u0645\u0627\u0643\u0646",
    openroutemobile: "\u0627\u0641\u062A\u062D \u0637\u0631\u064A\u0642 \u062E\u0631\u064A\u0637\u0629 \u062C\u0648\u062C\u0644 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A",
    FoodEstablishment: "\u0623\u064A\u0646 \u062A\u0623\u0643\u0644",
    LodgingBusiness: "\u0623\u064A\u0646 \u062A\u0646\u0627\u0645",
    TouristDestination: "\u0645\u0627\u0630\u0627 \u062A\u0631\u0649",
    TouristAttraction: "\u0645\u0627 \u064A\u062C\u0628 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0647",
    Product: "\u0645\u0646\u062A\u062C\u0627\u062A \u0645\u062D\u0644\u064A\u0629",
    Service: "\u062E\u062F\u0645\u0627\u062A",
    Event: "\u0627\u0644\u0623\u062D\u062F\u0627\u062B",
    City: "\u0645\u062F\u0646",
    Wine: "\u0627\u0644\u0646\u0628\u064A\u0630"
}, $914aec8743edd630$var$s_ = {
    consult: "\u0627\u0644\u062F\u0641\u0639",
    thetutorial: "\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u064A"
}, $914aec8743edd630$var$u_ = {
    reset: "\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u062C\u0645\u064A\u0639",
    showresults: "\u0639\u0631\u0636 \u0627\u0644\u0646\u062A\u0627\u0626\u062C",
    suggestiontitle: "\u0627\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u0627\u0644\u0628\u062D\u062B",
    reminder: `\u{644}\u{627} \u{62A}\u{646}\u{633}\u{649} 
 \u{623}\u{633}\u{62A}\u{637}\u{64A}\u{639} \u{627}\u{644}\u{625}\u{62C}\u{627}\u{628}\u{629} \u{639}\u{644}\u{649} \u{623}\u{633}\u{626}\u{644}\u{62A}\u{643}.`
}, $914aec8743edd630$var$c_ = {
    listening: "\u0623\u0646\u062A \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631\u0643\u060C \u0623\u0646\u0627 \u0623\u0633\u062A\u0645\u0639...",
    correct: "\u062A\u0635\u062D\u064A\u062D",
    dontknow: "\u0644\u0627 \u0623\u0639\u0631\u0641"
}, $914aec8743edd630$var$l_ = {
    allow: "\u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0644\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631.",
    rejected: "\u0644\u0642\u062F \u0631\u0641\u0636\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.",
    instructions: "\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.",
    listening: "\u0623\u0646\u0627 \u0623\u0633\u0645\u0639\u0643",
    trigger: "\u0627\u0636\u063A\u0637 \u0623\u0648 \u0642\u0644",
    triggerwithoutname: "\u0627\u0636\u063A\u0637 \u0644\u0644\u062A\u062D\u062F\u062B"
}, $914aec8743edd630$var$d_ = {
    rejected: "\u0644\u0642\u062F \u0631\u0641\u0636\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0645\u0648\u0642\u0639\u0643 \u0627\u0644\u062C\u063A\u0631\u0627\u0641\u064A.",
    instructions: "\u0110\u1EC3 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062C\u0648\u064A\u0629 \u0623\u0648 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0627\u0644\u062A\u0641\u0627\u0639\u0644\u064A\u0629\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0645\u0648\u0642\u0639\u0643 \u0627\u0644\u062C\u063A\u0631\u0627\u0641\u064A."
}, $914aec8743edd630$var$f_ = {
    calltoaction: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0644\u0644\u0628\u062F\u0621",
    emptyveille: "\u0627\u0646\u0642\u0631 \u0623\u0648 \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629..."
}, $914aec8743edd630$var$h_ = {
    shorttitle: "\u062A\u0642\u0631\u064A\u0631 \u062D\u0627\u0644\u0629 \u0623\u0644\u0637\u0642\u0633",
    attribution: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0637\u0642\u0633 \u0645\u0642\u062F\u0645\u0629 \u0645\u0646 Open-Meteo.com"
}, $914aec8743edd630$var$p_ = {
    title: "\u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u0631\u0648\u0628\u0648\u062A",
    message: `\u{628}\u{642}\u{628}\u{648}\u{644} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62D}\u{648}\u{627}\u{631}\u{60C} \u{641}\u{625}\u{646}\u{643} \u{62A}\u{648}\u{627}\u{641}\u{642} \u{639}\u{644}\u{649} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{631}\u{633}\u{644}\u{629} \u{625}\u{644}\u{649} \u{631}\u{648}\u{628}\u{648}\u{62A} \u{627}\u{644}\u{62F}\u{631}\u{62F}\u{634}\u{629} \u{644}\u{623}\u{63A}\u{631}\u{627}\u{636} \u{62A}\u{62D}\u{644}\u{64A}\u{644} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{623}\u{62F}\u{627}\u{629} \u{648}\u{62A}\u{62D}\u{633}\u{64A}\u{646} \u{642}\u{627}\u{639}\u{62F}\u{629} \u{627}\u{644}\u{645}\u{639}\u{631}\u{641}\u{629}.

\u{62A}\u{64F}\u{62D}\u{641}\u{638} \u{645}\u{62D}\u{627}\u{62F}\u{62B}\u{627}\u{62A}\u{643} \u{644}\u{645}\u{62F}\u{629} 6 \u{623}\u{634}\u{647}\u{631} \u{642}\u{628}\u{644} \u{62D}\u{630}\u{641}\u{647}\u{627}.`,
    link: "\u0631\u0627\u0628\u0637 \u0644\u0639\u0631\u0636 \u0633\u064A\u0627\u0633\u0627\u062A \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
    buttonAccept: "\u0644\u0642\u062F \u0641\u0647\u0645\u062A \u0648\u0623\u0648\u0627\u0641\u0642",
    buttonRefuse: "\u0623\u0631\u0641\u0636",
    messageAccepted: "\u062A\u0645 \u0623\u062E\u0630 \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0628\u0639\u064A\u0646 \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631",
    messageRefused: "\u062A\u0645 \u0623\u062E\u0630 \u0631\u0641\u0636\u0643 \u0628\u0639\u064A\u0646 \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631"
}, $914aec8743edd630$var$m_ = {
    1: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
    2: "\u0642\u0646\u0627\u0629 \u0627\u062E\u0628\u0627\u0631\u064A\u0629 \u062D\u064A\u0629",
    3: "\u062A\u0642\u0631\u064A\u0631 \u062D\u0627\u0644\u0629 \u0623\u0644\u0637\u0642\u0633",
    4: "\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0637\u0648\u0627\u0631\u0626",
    1e3: "\u062A\u0627\u0631\u064A\u062E\u064A",
    1001: "\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A",
    common: $914aec8743edd630$var$K2,
    emergency: $914aec8743edd630$var$Q2,
    error: $914aec8743edd630$var$Y2,
    history: $914aec8743edd630$var$J2,
    home: $914aec8743edd630$var$Z2,
    inputs: $914aec8743edd630$var$X2,
    language: $914aec8743edd630$var$e_,
    link: $914aec8743edd630$var$t_,
    loader: $914aec8743edd630$var$r_,
    menu: $914aec8743edd630$var$n_,
    mobileLandscapePreventer: $914aec8743edd630$var$i_,
    news: $914aec8743edd630$var$o_,
    poi: $914aec8743edd630$var$a_,
    suggestion: $914aec8743edd630$var$s_,
    template: $914aec8743edd630$var$u_,
    anghello: $914aec8743edd630$var$c_,
    microphone: $914aec8743edd630$var$l_,
    position: $914aec8743edd630$var$d_,
    veille: $914aec8743edd630$var$f_,
    weather: $914aec8743edd630$var$h_,
    GDPR: $914aec8743edd630$var$p_
}, $914aec8743edd630$var$g_ = {
    abort: "\u0625\u0644\u063A\u0627\u0621",
    all: "\u0627\u0644\u062C\u0645\u064A\u0639",
    back: "\u062E\u0644\u0641",
    close: "\u0627\u063A\u0644\u0627\u0642",
    continue: "\u064A\u0643\u0645\u0644",
    download: "\u062A\u062D\u0645\u064A\u0644",
    downloadsheet: "\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629",
    downloadsheetmobile: "\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A",
    filter: "\u0645\u0646\u0642\u064A",
    history: "\u062A\u0627\u0631\u064A\u062E\u064A",
    knowmore: "\u0627\u0639\u0631\u0641 \u0627\u0644\u0645\u0632\u064A\u062F",
    lang: "\u0627\u0644\u0644\u063A\u0627\u062A",
    menu: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629",
    mode: "\u0645\u0648\u0636\u0629",
    needhelp: "\u062A\u062D\u062A\u0627\u062C \u0645\u0633\u0627\u0639\u062F\u0629\u061F",
    parameters: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
    print: "\u0645\u0637\u0628\u0639\u0629",
    printsheet: "\u0627\u0637\u0628\u0639 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629",
    result: "\u0646\u062A\u064A\u062C\u0629",
    results: "\u0646\u062A\u0627\u0626\u062C",
    singleLang: "\u0644\u063A\u0629",
    sound: "\u0647\u0627",
    submit: "\u064A\u064F\u0642\u062F\u0651\u0650\u0645",
    subtitle: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0631\u0639\u064A",
    tutorial: "\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A",
    validate: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629"
}, $914aec8743edd630$var$b_ = {
    shorttitle: "\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0637\u0648\u0627\u0631\u0626",
    samu: ".S.A.M.U",
    police: "\u0634\u0631\u0637\u0629",
    firefighter: "\u0631\u062C\u0627\u0644 \u0627\u0644\u0627\u0637\u0641\u0627\u0621",
    general: "\u0639\u0627\u0645",
    citypolice: "\u0627\u0644\u0634\u0631\u0637\u0629 \u0627\u0644\u0645\u062D\u0644\u064A\u0629",
    hospital: "\u0645\u0633\u062A\u0634\u0641\u0649",
    homeless: "\u0628\u0644\u0627 \u0645\u0623\u0648\u0649 (\u0645\u0643\u0627\u0644\u0645\u0629 \u0645\u062C\u0627\u0646\u064A\u0629)",
    poison: "\u0645\u0631\u0643\u0632 \u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u0633\u0645\u0648\u0645",
    emergency: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0637\u0648\u0627\u0631\u0626 \u0627\u0644\u0623\u0648\u0631\u0648\u0628\u064A\u0629"
}, $914aec8743edd630$var$v_ = {
    title: "\u062D\u062F\u062B \u062E\u0637\u0623",
    button: "\u0623\u0639\u062F \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642"
}, $914aec8743edd630$var$y_ = {
    shorttitle: "\u062A\u0627\u0631\u064A\u062E\u064A",
    title: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629"
}, $914aec8743edd630$var$w_ = {
    shorttitle: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629"
}, $914aec8743edd630$var$__ = {
    choose: "\u0627\u062E\u062A\u0631 \u0625\u062C\u0627\u0628\u0629",
    noaction: "\u0625\u062C\u0631\u0627\u0621 \u0645\u062A\u0648\u0642\u0639"
}, $914aec8743edd630$var$k_ = {
    change: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0644\u063A\u0629",
    select: "\u062D\u062F\u062F \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627"
}, $914aec8743edd630$var$x_ = {
    buttontext: "\u0639\u0631\u0636 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    goto: "\u0627\u0630\u0647\u0628 \u0625\u0644\u0649 \u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    click: "\u0627\u0646\u0642\u0631 \u0647\u0646\u0627",
    scanQR: "\u0639\u0646 \u0637\u0631\u064A\u0642 \u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629",
    scanQRTile: "\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0644\u0627\u0643\u062A\u0634\u0627\u0641"
}, $914aec8743edd630$var$S_ = {
    loader: {
        optimal: "\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C",
        classic: "\u0644\u062A\u062C\u0631\u0628\u0629 \u0623\u0643\u062B\u0631 \u0643\u0644\u0627\u0633\u064A\u0643\u064A\u0629\u060C",
        vocal: "\u0623\u0646\u0627 \u0623\u062A\u062D\u062F\u062B \u0648\u062C\u0647\u0627 \u0644\u0648\u062C\u0647 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644.",
        text: "\u0623\u062A\u0648\u0627\u0635\u0644 \u0643\u062A\u0627\u0628\u064A\u064B\u0627 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644."
    },
    modes: {
        vocal: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A",
        text: "\u0648\u0636\u0639 \u0627\u0644\u0646\u0635"
    },
    loaderValidation: "\u0627\u0628\u062F\u0623 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    locale: "\u0641\u062D\u0635 \u0627\u0644\u0644\u063A\u0629",
    supported: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0644\u063A\u0627\u062A \u0627\u0644\u0645\u062F\u0639\u0648\u0645\u0629",
    addressdata: "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A"
}, $914aec8743edd630$var$E_ = {
    message: "\u0623\u062F\u062E\u0644 \u0631\u0633\u0627\u0644\u062A\u0643",
    backconversation: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    answer: " \u064A\u062C\u064A\u0628 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643"
}, $914aec8743edd630$var$A_ = {
    firstline: "\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C",
    secondline: "\u0627\u0642\u0644\u0628 \u0634\u0627\u0634\u062A\u0643"
}, $914aec8743edd630$var$T_ = {
    shorttitle: "\u0642\u0646\u0627\u0629 \u0627\u062E\u0628\u0627\u0631\u064A\u0629 \u062D\u064A\u0629",
    warningtext: "\u0633\u062A\u062F\u062E\u0644 \u0625\u0644\u0649 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u0625\u062E\u0628\u0627\u0631\u064A\u0629\u060C \u0648\u0633\u064A\u062A\u0645 \u062A\u0646\u0634\u064A\u0637 \u0627\u0644\u0635\u0648\u062A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643",
    live: "\u0645\u0628\u0627\u0634\u0631",
    continuous: "\u0644\u0646\u0643\u0645\u0644"
}, $914aec8743edd630$var$C_ = {
    comment: "\u0631\u0623\u064A \u0627\u0644\u0639\u0645\u064A\u0644",
    route: "\u0637\u0631\u064A\u0642",
    nodata: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649 \u064A\u0637\u0627\u0628\u0642 \u0628\u062D\u062B\u0643",
    openinghours: "\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644",
    prices: "\u0627\u0644\u0623\u0633\u0639\u0627\u0631",
    paymentmethods: "\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639",
    numberofplaces: "\u0639\u062F\u062F \u0627\u0644\u0623\u0645\u0627\u0643\u0646",
    openroutemobile: "\u0627\u0641\u062A\u062D \u0637\u0631\u064A\u0642 \u062E\u0631\u064A\u0637\u0629 \u062C\u0648\u062C\u0644 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A",
    FoodEstablishment: "\u0623\u064A\u0646 \u062A\u0623\u0643\u0644",
    LodgingBusiness: "\u0623\u064A\u0646 \u062A\u0646\u0627\u0645",
    TouristDestination: "\u0645\u0627\u0630\u0627 \u062A\u0631\u0649",
    TouristAttraction: "\u0645\u0627 \u064A\u062C\u0628 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0647",
    Product: "\u0645\u0646\u062A\u062C\u0627\u062A \u0645\u062D\u0644\u064A\u0629",
    Service: "\u062E\u062F\u0645\u0627\u062A",
    Event: "\u0627\u0644\u0623\u062D\u062F\u0627\u062B",
    City: "\u0645\u062F\u0646",
    Wine: "\u0627\u0644\u0646\u0628\u064A\u0630"
}, $914aec8743edd630$var$R_ = {
    consult: "\u0627\u0644\u062F\u0641\u0639",
    thetutorial: "\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u064A"
}, $914aec8743edd630$var$O_ = {
    reset: "\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u062C\u0645\u064A\u0639",
    showresults: "\u0639\u0631\u0636 \u0627\u0644\u0646\u062A\u0627\u0626\u062C",
    suggestiontitle: "\u0627\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u0627\u0644\u0628\u062D\u062B",
    reminder: `\u{644}\u{627} \u{62A}\u{646}\u{633}\u{649} 
 \u{623}\u{633}\u{62A}\u{637}\u{64A}\u{639} \u{627}\u{644}\u{625}\u{62C}\u{627}\u{628}\u{629} \u{639}\u{644}\u{649} \u{623}\u{633}\u{626}\u{644}\u{62A}\u{643}.`
}, $914aec8743edd630$var$D_ = {
    listening: "\u0623\u0646\u062A \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631\u0643\u060C \u0623\u0646\u0627 \u0623\u0633\u062A\u0645\u0639...",
    correct: "\u062A\u0635\u062D\u064A\u062D",
    dontknow: "\u0644\u0627 \u0623\u0639\u0631\u0641"
}, $914aec8743edd630$var$P_ = {
    allow: "\u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0644\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631.",
    rejected: "\u0644\u0642\u062F \u0631\u0641\u0636\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.",
    instructions: "\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.",
    listening: "\u0623\u0646\u0627 \u0623\u0633\u0645\u0639\u0643",
    trigger: "\u0627\u0636\u063A\u0637 \u0623\u0648 \u0642\u0644",
    triggerwithoutname: "\u0627\u0636\u063A\u0637 \u0644\u0644\u062A\u062D\u062F\u062B"
}, $914aec8743edd630$var$I_ = {
    rejected: "\u0644\u0642\u062F \u0631\u0641\u0636\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0645\u0648\u0642\u0639\u0643 \u0627\u0644\u062C\u063A\u0631\u0627\u0641\u064A.",
    instructions: "\u0110\u1EC3 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062C\u0648\u064A\u0629 \u0623\u0648 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0627\u0644\u062A\u0641\u0627\u0639\u0644\u064A\u0629\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0645\u0648\u0642\u0639\u0643 \u0627\u0644\u062C\u063A\u0631\u0627\u0641\u064A."
}, $914aec8743edd630$var$M_ = {
    calltoaction: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0644\u0644\u0628\u062F\u0621",
    emptyveille: "\u0627\u0646\u0642\u0631 \u0623\u0648 \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629..."
}, $914aec8743edd630$var$j_ = {
    shorttitle: "\u062A\u0642\u0631\u064A\u0631 \u062D\u0627\u0644\u0629 \u0623\u0644\u0637\u0642\u0633",
    attribution: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0637\u0642\u0633 \u0645\u0642\u062F\u0645\u0629 \u0645\u0646 Open-Meteo.com"
}, $914aec8743edd630$var$F_ = {
    title: "\u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u0631\u0648\u0628\u0648\u062A",
    message: `\u{628}\u{642}\u{628}\u{648}\u{644} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62D}\u{648}\u{627}\u{631}\u{60C} \u{641}\u{625}\u{646}\u{643} \u{62A}\u{648}\u{627}\u{641}\u{642} \u{639}\u{644}\u{649} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{631}\u{633}\u{644}\u{629} \u{625}\u{644}\u{649} \u{631}\u{648}\u{628}\u{648}\u{62A} \u{627}\u{644}\u{62F}\u{631}\u{62F}\u{634}\u{629} \u{644}\u{623}\u{63A}\u{631}\u{627}\u{636} \u{62A}\u{62D}\u{644}\u{64A}\u{644} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{623}\u{62F}\u{627}\u{629} \u{648}\u{62A}\u{62D}\u{633}\u{64A}\u{646} \u{642}\u{627}\u{639}\u{62F}\u{629} \u{627}\u{644}\u{645}\u{639}\u{631}\u{641}\u{629}.

\u{62A}\u{64F}\u{62D}\u{641}\u{638} \u{645}\u{62D}\u{627}\u{62F}\u{62B}\u{627}\u{62A}\u{643} \u{644}\u{645}\u{62F}\u{629} 6 \u{623}\u{634}\u{647}\u{631} \u{642}\u{628}\u{644} \u{62D}\u{630}\u{641}\u{647}\u{627}.`,
    link: "\u0631\u0627\u0628\u0637 \u0644\u0639\u0631\u0636 \u0633\u064A\u0627\u0633\u0627\u062A \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
    buttonAccept: "\u0644\u0642\u062F \u0641\u0647\u0645\u062A \u0648\u0623\u0648\u0627\u0641\u0642",
    buttonRefuse: "\u0623\u0631\u0641\u0636",
    messageAccepted: "\u062A\u0645 \u0623\u062E\u0630 \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0628\u0639\u064A\u0646 \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631",
    messageRefused: "\u062A\u0645 \u0623\u062E\u0630 \u0631\u0641\u0636\u0643 \u0628\u0639\u064A\u0646 \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631"
}, $914aec8743edd630$var$$_ = {
    1: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
    2: "\u0642\u0646\u0627\u0629 \u0627\u062E\u0628\u0627\u0631\u064A\u0629 \u062D\u064A\u0629",
    3: "\u062A\u0642\u0631\u064A\u0631 \u062D\u0627\u0644\u0629 \u0623\u0644\u0637\u0642\u0633",
    4: "\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0637\u0648\u0627\u0631\u0626",
    1e3: "\u062A\u0627\u0631\u064A\u062E\u064A",
    1001: "\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A",
    common: $914aec8743edd630$var$g_,
    emergency: $914aec8743edd630$var$b_,
    error: $914aec8743edd630$var$v_,
    history: $914aec8743edd630$var$y_,
    home: $914aec8743edd630$var$w_,
    inputs: $914aec8743edd630$var$__,
    language: $914aec8743edd630$var$k_,
    link: $914aec8743edd630$var$x_,
    loader: $914aec8743edd630$var$S_,
    menu: $914aec8743edd630$var$E_,
    mobileLandscapePreventer: $914aec8743edd630$var$A_,
    news: $914aec8743edd630$var$T_,
    poi: $914aec8743edd630$var$C_,
    suggestion: $914aec8743edd630$var$R_,
    template: $914aec8743edd630$var$O_,
    anghello: $914aec8743edd630$var$D_,
    microphone: $914aec8743edd630$var$P_,
    position: $914aec8743edd630$var$I_,
    veille: $914aec8743edd630$var$M_,
    weather: $914aec8743edd630$var$j_,
    GDPR: $914aec8743edd630$var$F_
}, $914aec8743edd630$var$L_ = {
    abort: "\u0625\u0644\u063A\u0627\u0621",
    all: "\u0627\u0644\u062C\u0645\u064A\u0639",
    back: "\u062E\u0644\u0641",
    close: "\u0627\u063A\u0644\u0627\u0642",
    continue: "\u064A\u0643\u0645\u0644",
    download: "\u062A\u062D\u0645\u064A\u0644",
    downloadsheet: "\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629",
    downloadsheetmobile: "\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A",
    filter: "\u0645\u0646\u0642\u064A",
    history: "\u062A\u0627\u0631\u064A\u062E\u064A",
    knowmore: "\u0627\u0639\u0631\u0641 \u0627\u0644\u0645\u0632\u064A\u062F",
    lang: "\u0627\u0644\u0644\u063A\u0627\u062A",
    menu: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629",
    mode: "\u0645\u0648\u0636\u0629",
    needhelp: "\u062A\u062D\u062A\u0627\u062C \u0645\u0633\u0627\u0639\u062F\u0629\u061F",
    parameters: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
    print: "\u0645\u0637\u0628\u0639\u0629",
    printsheet: "\u0627\u0637\u0628\u0639 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629",
    result: "\u0646\u062A\u064A\u062C\u0629",
    results: "\u0646\u062A\u0627\u0626\u062C",
    singleLang: "\u0644\u063A\u0629",
    sound: "\u0647\u0627",
    submit: "\u064A\u064F\u0642\u062F\u0651\u0650\u0645",
    subtitle: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0631\u0639\u064A",
    tutorial: "\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A",
    validate: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629"
}, $914aec8743edd630$var$N_ = {
    shorttitle: "\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0637\u0648\u0627\u0631\u0626",
    samu: ".S.A.M.U",
    police: "\u0634\u0631\u0637\u0629",
    firefighter: "\u0631\u062C\u0627\u0644 \u0627\u0644\u0627\u0637\u0641\u0627\u0621",
    general: "\u0639\u0627\u0645",
    citypolice: "\u0627\u0644\u0634\u0631\u0637\u0629 \u0627\u0644\u0645\u062D\u0644\u064A\u0629",
    hospital: "\u0645\u0633\u062A\u0634\u0641\u0649",
    homeless: "\u0628\u0644\u0627 \u0645\u0623\u0648\u0649 (\u0645\u0643\u0627\u0644\u0645\u0629 \u0645\u062C\u0627\u0646\u064A\u0629)",
    poison: "\u0645\u0631\u0643\u0632 \u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u0633\u0645\u0648\u0645",
    emergency: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0637\u0648\u0627\u0631\u0626 \u0627\u0644\u0623\u0648\u0631\u0648\u0628\u064A\u0629"
}, $914aec8743edd630$var$B_ = {
    title: "\u062D\u062F\u062B \u062E\u0637\u0623",
    button: "\u0623\u0639\u062F \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642"
}, $914aec8743edd630$var$q_ = {
    shorttitle: "\u062A\u0627\u0631\u064A\u062E\u064A",
    title: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629"
}, $914aec8743edd630$var$z_ = {
    shorttitle: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629"
}, $914aec8743edd630$var$U_ = {
    choose: "\u0627\u062E\u062A\u0631 \u0625\u062C\u0627\u0628\u0629",
    noaction: "\u0625\u062C\u0631\u0627\u0621 \u0645\u062A\u0648\u0642\u0639"
}, $914aec8743edd630$var$V_ = {
    change: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0644\u063A\u0629",
    select: "\u062D\u062F\u062F \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627"
}, $914aec8743edd630$var$G_ = {
    buttontext: "\u0639\u0631\u0636 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    goto: "\u0627\u0630\u0647\u0628 \u0625\u0644\u0649 \u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    click: "\u0627\u0646\u0642\u0631 \u0647\u0646\u0627",
    scanQR: "\u0639\u0646 \u0637\u0631\u064A\u0642 \u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629",
    scanQRTile: "\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0644\u0627\u0643\u062A\u0634\u0627\u0641"
}, $914aec8743edd630$var$W_ = {
    loader: {
        optimal: "\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C",
        classic: "\u0644\u062A\u062C\u0631\u0628\u0629 \u0623\u0643\u062B\u0631 \u0643\u0644\u0627\u0633\u064A\u0643\u064A\u0629\u060C",
        vocal: "\u0623\u0646\u0627 \u0623\u062A\u062D\u062F\u062B \u0648\u062C\u0647\u0627 \u0644\u0648\u062C\u0647 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644.",
        text: "\u0623\u062A\u0648\u0627\u0635\u0644 \u0643\u062A\u0627\u0628\u064A\u064B\u0627 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644."
    },
    modes: {
        vocal: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A",
        text: "\u0648\u0636\u0639 \u0627\u0644\u0646\u0635"
    },
    loaderValidation: "\u0627\u0628\u062F\u0623 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    locale: "\u0641\u062D\u0635 \u0627\u0644\u0644\u063A\u0629",
    supported: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0644\u063A\u0627\u062A \u0627\u0644\u0645\u062F\u0639\u0648\u0645\u0629",
    addressdata: "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A"
}, $914aec8743edd630$var$H_ = {
    message: "\u0623\u062F\u062E\u0644 \u0631\u0633\u0627\u0644\u062A\u0643",
    backconversation: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    answer: " \u064A\u062C\u064A\u0628 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643"
}, $914aec8743edd630$var$K_ = {
    firstline: "\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C",
    secondline: "\u0627\u0642\u0644\u0628 \u0634\u0627\u0634\u062A\u0643"
}, $914aec8743edd630$var$Q_ = {
    shorttitle: "\u0642\u0646\u0627\u0629 \u0627\u062E\u0628\u0627\u0631\u064A\u0629 \u062D\u064A\u0629",
    warningtext: "\u0633\u062A\u062F\u062E\u0644 \u0625\u0644\u0649 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u0625\u062E\u0628\u0627\u0631\u064A\u0629\u060C \u0648\u0633\u064A\u062A\u0645 \u062A\u0646\u0634\u064A\u0637 \u0627\u0644\u0635\u0648\u062A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643",
    live: "\u0645\u0628\u0627\u0634\u0631",
    continuous: "\u0644\u0646\u0643\u0645\u0644"
}, $914aec8743edd630$var$Y_ = {
    comment: "\u0631\u0623\u064A \u0627\u0644\u0639\u0645\u064A\u0644",
    route: "\u0637\u0631\u064A\u0642",
    nodata: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649 \u064A\u0637\u0627\u0628\u0642 \u0628\u062D\u062B\u0643",
    openinghours: "\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644",
    prices: "\u0627\u0644\u0623\u0633\u0639\u0627\u0631",
    paymentmethods: "\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639",
    numberofplaces: "\u0639\u062F\u062F \u0627\u0644\u0623\u0645\u0627\u0643\u0646",
    openroutemobile: "\u0627\u0641\u062A\u062D \u0637\u0631\u064A\u0642 \u062E\u0631\u064A\u0637\u0629 \u062C\u0648\u062C\u0644 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A",
    FoodEstablishment: "\u0623\u064A\u0646 \u062A\u0623\u0643\u0644",
    LodgingBusiness: "\u0623\u064A\u0646 \u062A\u0646\u0627\u0645",
    TouristDestination: "\u0645\u0627\u0630\u0627 \u062A\u0631\u0649",
    TouristAttraction: "\u0645\u0627 \u064A\u062C\u0628 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0647",
    Product: "\u0645\u0646\u062A\u062C\u0627\u062A \u0645\u062D\u0644\u064A\u0629",
    Service: "\u062E\u062F\u0645\u0627\u062A",
    Event: "\u0627\u0644\u0623\u062D\u062F\u0627\u062B",
    City: "\u0645\u062F\u0646",
    Wine: "\u0627\u0644\u0646\u0628\u064A\u0630"
}, $914aec8743edd630$var$J_ = {
    consult: "\u0627\u0644\u062F\u0641\u0639",
    thetutorial: "\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u064A"
}, $914aec8743edd630$var$Z_ = {
    reset: "\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u062C\u0645\u064A\u0639",
    showresults: "\u0639\u0631\u0636 \u0627\u0644\u0646\u062A\u0627\u0626\u062C",
    suggestiontitle: "\u0627\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u0627\u0644\u0628\u062D\u062B",
    reminder: `\u{644}\u{627} \u{62A}\u{646}\u{633}\u{649} 
 \u{623}\u{633}\u{62A}\u{637}\u{64A}\u{639} \u{627}\u{644}\u{625}\u{62C}\u{627}\u{628}\u{629} \u{639}\u{644}\u{649} \u{623}\u{633}\u{626}\u{644}\u{62A}\u{643}.`
}, $914aec8743edd630$var$X_ = {
    listening: "\u0623\u0646\u062A \u0623\u0645\u0627\u0645\u064A\u060C \u0623\u0646\u0627 \u0623\u0633\u062A\u0645\u0639...",
    correct: "\u062A\u0635\u062D\u064A\u062D",
    dontknow: "\u0644\u0627 \u0623\u0639\u0631\u0641"
}, $914aec8743edd630$var$ek = {
    allow: "\u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0644\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631.",
    rejected: "\u0644\u0642\u062F \u0631\u0641\u0636\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.",
    instructions: "\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.",
    listening: "\u0623\u0646\u0627 \u0623\u0633\u0645\u0639\u0643",
    trigger: "\u0627\u0636\u063A\u0637 \u0623\u0648 \u0642\u0644",
    triggerwithoutname: "\u0627\u0636\u063A\u0637 \u0644\u0644\u062A\u062D\u062F\u062B"
}, $914aec8743edd630$var$tk = {
    rejected: "\u0644\u0642\u062F \u0631\u0641\u0636\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0645\u0648\u0642\u0639\u0643 \u0627\u0644\u062C\u063A\u0631\u0627\u0641\u064A.",
    instructions: "\u0110\u1EC3 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062C\u0648\u064A\u0629 \u0623\u0648 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0627\u0644\u062A\u0641\u0627\u0639\u0644\u064A\u0629\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0645\u0648\u0642\u0639\u0643 \u0627\u0644\u062C\u063A\u0631\u0627\u0641\u064A."
}, $914aec8743edd630$var$rk = {
    calltoaction: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0644\u0644\u0628\u062F\u0621",
    emptyveille: "\u0627\u0646\u0642\u0631 \u0623\u0648 \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629..."
}, $914aec8743edd630$var$nk = {
    shorttitle: "\u062A\u0642\u0631\u064A\u0631 \u062D\u0627\u0644\u0629 \u0623\u0644\u0637\u0642\u0633",
    attribution: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0637\u0642\u0633 \u0645\u0642\u062F\u0645\u0629 \u0645\u0646 Open-Meteo.com"
}, $914aec8743edd630$var$ik = {
    title: "\u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u0631\u0648\u0628\u0648\u062A",
    message: `\u{628}\u{642}\u{628}\u{648}\u{644} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62D}\u{648}\u{627}\u{631}\u{60C} \u{641}\u{625}\u{646}\u{643} \u{62A}\u{648}\u{627}\u{641}\u{642} \u{639}\u{644}\u{649} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{631}\u{633}\u{644}\u{629} \u{625}\u{644}\u{649} \u{631}\u{648}\u{628}\u{648}\u{62A} \u{627}\u{644}\u{62F}\u{631}\u{62F}\u{634}\u{629} \u{644}\u{623}\u{63A}\u{631}\u{627}\u{636} \u{62A}\u{62D}\u{644}\u{64A}\u{644} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{623}\u{62F}\u{627}\u{629} \u{648}\u{62A}\u{62D}\u{633}\u{64A}\u{646} \u{642}\u{627}\u{639}\u{62F}\u{629} \u{627}\u{644}\u{645}\u{639}\u{631}\u{641}\u{629}.

\u{62A}\u{64F}\u{62D}\u{641}\u{638} \u{645}\u{62D}\u{627}\u{62F}\u{62B}\u{627}\u{62A}\u{643} \u{644}\u{645}\u{62F}\u{629} 6 \u{623}\u{634}\u{647}\u{631} \u{642}\u{628}\u{644} \u{62D}\u{630}\u{641}\u{647}\u{627}.`,
    link: "\u0631\u0627\u0628\u0637 \u0644\u0639\u0631\u0636 \u0633\u064A\u0627\u0633\u0627\u062A \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
    buttonAccept: "\u0644\u0642\u062F \u0641\u0647\u0645\u062A \u0648\u0623\u0648\u0627\u0641\u0642",
    buttonRefuse: "\u0623\u0631\u0641\u0636",
    messageAccepted: "\u062A\u0645 \u0623\u062E\u0630 \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0628\u0639\u064A\u0646 \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631",
    messageRefused: "\u062A\u0645 \u0623\u062E\u0630 \u0631\u0641\u0636\u0643 \u0628\u0639\u064A\u0646 \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631"
}, $914aec8743edd630$var$ok = {
    1: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
    2: "\u0642\u0646\u0627\u0629 \u0627\u062E\u0628\u0627\u0631\u064A\u0629 \u062D\u064A\u0629",
    3: "\u062A\u0642\u0631\u064A\u0631 \u062D\u0627\u0644\u0629 \u0623\u0644\u0637\u0642\u0633",
    4: "\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0637\u0648\u0627\u0631\u0626",
    1e3: "\u062A\u0627\u0631\u064A\u062E\u064A",
    1001: "\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A",
    common: $914aec8743edd630$var$L_,
    emergency: $914aec8743edd630$var$N_,
    error: $914aec8743edd630$var$B_,
    history: $914aec8743edd630$var$q_,
    home: $914aec8743edd630$var$z_,
    inputs: $914aec8743edd630$var$U_,
    language: $914aec8743edd630$var$V_,
    link: $914aec8743edd630$var$G_,
    loader: $914aec8743edd630$var$W_,
    menu: $914aec8743edd630$var$H_,
    mobileLandscapePreventer: $914aec8743edd630$var$K_,
    news: $914aec8743edd630$var$Q_,
    poi: $914aec8743edd630$var$Y_,
    suggestion: $914aec8743edd630$var$J_,
    template: $914aec8743edd630$var$Z_,
    anghello: $914aec8743edd630$var$X_,
    microphone: $914aec8743edd630$var$ek,
    position: $914aec8743edd630$var$tk,
    veille: $914aec8743edd630$var$rk,
    weather: $914aec8743edd630$var$nk,
    GDPR: $914aec8743edd630$var$ik
}, $914aec8743edd630$var$ak = {
    abort: "cancel\xb7lar",
    all: "tots",
    back: "esquena",
    close: "tanca",
    continue: "continua",
    download: "descarregar",
    downloadsheet: "descarregar aquest full",
    downloadsheetmobile: "descarregueu aquest full al tel\xe8fon intel\xb7ligent",
    filter: "filtre",
    history: "hist\xf2ric",
    knowmore: "M\xe9s informaci\xf3",
    lang: "idiomes",
    menu: "men\xfa",
    mode: "moda",
    needhelp: "necessitar ajuda?",
    parameters: "configuracions",
    print: "imprimir",
    printsheet: "imprimeix aquest full",
    result: "resultat",
    results: "resultats",
    singleLang: "llenguatge",
    sound: "ella",
    subtitle: "subt\xedtol",
    submit: "presentar",
    tutorial: "tutorial",
    validate: "validar"
}, $914aec8743edd630$var$sk = {
    shorttitle: "N\xfameros d'emerg\xe8ncia",
    samu: "S.A.M.U.",
    police: "policia",
    firefighter: "bombers",
    general: "general",
    citypolice: "Policia local",
    hospital: "Hospital",
    homeless: "Sense llar (trucada gratu\xefta)",
    poison: "Centre de control de ver\xed",
    emergency: "emerg\xe8ncies europees"
}, $914aec8743edd630$var$uk = {
    title: "S'ha produ\xeft un error",
    button: "Reinicieu l'aplicaci\xf3"
}, $914aec8743edd630$var$ck = {
    shorttitle: "hist\xf2ric",
    title: "historial de converses"
}, $914aec8743edd630$var$lk = {
    shorttitle: "p\xe0gina d'inici"
}, $914aec8743edd630$var$dk = {
    choose: "Tria una resposta",
    noaction: "S'espera una acci\xf3"
}, $914aec8743edd630$var$fk = {
    change: "canviar l'idioma",
    select: "seleccioneu l'idioma que voleu utilitzar"
}, $914aec8743edd630$var$hk = {
    buttontext: "Visualitza el document",
    goto: "V\xe9s a l'adre\xe7a",
    click: "Clica aqu\xed",
    scanQR: "escanejant el QrCode",
    scanQRTile: "Escaneja el codi QR per descobrir"
}, $914aec8743edd630$var$pk = {
    loader: {
        optimal: "Per a una experi\xe8ncia \xf2ptima,",
        classic: "Per a una experi\xe8ncia m\xe9s cl\xe0ssica,",
        vocal: "Parlo cara a cara amb l'agent.",
        text: "Em comunico per escrit amb l'agent."
    },
    modes: {
        vocal: "manera vocal",
        text: "mode text"
    },
    loaderValidation: "Inicia la conversa",
    locale: "comprovant el llenguatge",
    supported: "comprovant els idiomes compatibles",
    addressdata: "recuperant dades"
}, $914aec8743edd630$var$mk = {
    message: "Introdu\xefu el vostre missatge",
    backconversation: "tornar a la conversa",
    answer: " respon les teves preguntes"
}, $914aec8743edd630$var$gk = {
    firstline: "Per a una experi\xe8ncia \xf2ptima,",
    secondline: "gira la pantalla"
}, $914aec8743edd630$var$bk = {
    shorttitle: "canal de not\xedcies en directe",
    warningtext: "Accedeix al canal de not\xedcies, s'activar\xe0 el so del teu dispositiu",
    live: "viu",
    continuous: "cont\xednuament"
}, $914aec8743edd630$var$vk = {
    comment: "revisi\xf3 del client",
    route: "carretera",
    nodata: "Cap contingut coincideix amb la teva cerca",
    openinghours: "Horari d'obertura",
    prices: "Preus",
    paymentmethods: "M\xe8todes de Pagament",
    numberofplaces: "nombre de places",
    openroutemobile: "obre la ruta de Google Maps al tel\xe8fon intel\xb7ligent",
    FoodEstablishment: "On menjar",
    LodgingBusiness: "On dormir",
    TouristDestination: "Qu\xe8 veure",
    TouristAttraction: "Qu\xe8 fer",
    Product: "Productes locals",
    Service: "Serveis",
    Event: "Esdeveniments",
    City: "Ciutats",
    Wine: "Vins"
}, $914aec8743edd630$var$yk = {
    consult: "Fes una ullada",
    thetutorial: "el tutorial"
}, $914aec8743edd630$var$wk = {
    reset: "restablir tot",
    showresults: "Mostra els resultats",
    suggestiontitle: "Cerca suggeriments",
    reminder: `No oblidis, 
 puc respondre les teves preguntes.`
}, $914aec8743edd630$var$_k = {
    listening: "\xc9s el teu torn, t'escolto...",
    correct: "Corregir",
    dontknow: "No ho s\xe9"
}, $914aec8743edd630$var$kk = {
    allow: "Si us plau, autoritzeu que el vostre navegador accedeixi al micr\xf2fon per continuar.",
    rejected: "Heu refusat l'acc\xe9s al micr\xf2fon.",
    instructions: "Per utilitzar el mode de veu, si us plau, autoritzeu que el vostre navegador accedeixi al micr\xf2fon.",
    listening: "Et estant",
    trigger: "Toca o diu",
    triggerwithoutname: "Toca per parlar"
}, $914aec8743edd630$var$xk = {
    rejected: "Has rebutjat l'acc\xe9s a la teva posici\xf3 GPS.",
    instructions: "Per accedir als dades meteorol\xf2giques o al mapa interactiu, si us plau, autoritza el navegador per accedir a la teva posici\xf3 GPS."
}, $914aec8743edd630$var$Sk = {
    calltoaction: "Premeu la pantalla per comen\xe7ar",
    emptyveille: "Feu clic o premeu la pantalla..."
}, $914aec8743edd630$var$Ek = {
    shorttitle: "informe del temps",
    attribution: "Dades meteorol\xf2giques proporcionades per Open-Meteo.com"
}, $914aec8743edd630$var$Ak = {
    title: "tractament de les dades personals transmeses al bot",
    message: `en acceptar aquest di\xe0leg, consentiu que totes les dades transmeses al chatbot s'utilitzin per a l'an\xe0lisi de l'\xfas de l'eina i per millorar la base de coneixement.

Les vostres converses es conserven 6 mesos abans de ser eliminades.`,
    link: "enlla\xe7 per consultar les pol\xedtiques de privadesa",
    buttonAccept: "ho he ent\xe8s i accepto",
    buttonRefuse: "rebutjo",
    messageAccepted: "el vostre consentiment ha estat pres en compte",
    messageRefused: "el vostre rebuig ha estat pres en compte"
}, $914aec8743edd630$var$Tk = {
    1: "p\xe0gina d'inici",
    2: "canal de not\xedcies en directe",
    3: "informe del temps",
    4: "N\xfameros d'emerg\xe8ncia",
    1e3: "hist\xf2ric",
    1001: "tutorial",
    common: $914aec8743edd630$var$ak,
    emergency: $914aec8743edd630$var$sk,
    error: $914aec8743edd630$var$uk,
    history: $914aec8743edd630$var$ck,
    home: $914aec8743edd630$var$lk,
    inputs: $914aec8743edd630$var$dk,
    language: $914aec8743edd630$var$fk,
    link: $914aec8743edd630$var$hk,
    loader: $914aec8743edd630$var$pk,
    menu: $914aec8743edd630$var$mk,
    mobileLandscapePreventer: $914aec8743edd630$var$gk,
    news: $914aec8743edd630$var$bk,
    poi: $914aec8743edd630$var$vk,
    suggestion: $914aec8743edd630$var$yk,
    template: $914aec8743edd630$var$wk,
    anghello: $914aec8743edd630$var$_k,
    microphone: $914aec8743edd630$var$kk,
    position: $914aec8743edd630$var$xk,
    veille: $914aec8743edd630$var$Sk,
    weather: $914aec8743edd630$var$Ek,
    GDPR: $914aec8743edd630$var$Ak
}, $914aec8743edd630$var$Ck = {
    abort: "zru\u0161it",
    all: "v\u0161echno",
    back: "zadn\xed",
    close: "zav\u0159\xedt",
    continue: "pokra\u010Dovat",
    download: "sta\u017Een\xed",
    downloadsheet: "st\xe1hn\u011Bte si tento list",
    downloadsheetmobile: "st\xe1hn\u011Bte si tento list na smartphone",
    filter: "filtr",
    history: "historick\xfd",
    knowmore: "Zjistit v\xedce",
    lang: "jazyky",
    menu: "j\xeddeln\xed l\xedstek",
    mode: "m\xf3da",
    needhelp: "pot\u0159ebovat pomoc?",
    parameters: "nastaven\xed",
    print: "tisk",
    printsheet: "tytiskn\u011Bte tento list",
    result: "v\xfdsledek",
    results: "v\xfdsledek",
    singleLang: "jazyk",
    sound: "jej\xed",
    submit: "p\u0159edlo\u017Eit",
    subtitle: "podtitulek",
    tutorial: "tutorial",
    validate: "ov\u011B\u0159it"
}, $914aec8743edd630$var$Rk = {
    shorttitle: "T\xeds\u0148ov\xe1 \u010D\xedsla",
    samu: "S.A.M.U.",
    police: "POLICIE",
    firefighter: "hasi\u010Di",
    general: "v\u0161eobecn\xfd",
    citypolice: "M\xedstn\xed policie",
    hospital: "Nemocnice",
    homeless: "Bezdomovci (vol\xe1n\xed zdarma)",
    poison: "Poison Control Center",
    emergency: "evropsk\xe9 mimo\u0159\xe1dn\xe9 ud\xe1losti"
}, $914aec8743edd630$var$Ok = {
    title: "Do\u0161lo k chyb\u011B",
    button: "Znovu spus\u0165te aplikaci"
}, $914aec8743edd630$var$Dk = {
    shorttitle: "historick\xfd",
    title: "historie konverzace"
}, $914aec8743edd630$var$Pk = {
    shorttitle: "domovsk\xe1 str\xe1nka"
}, $914aec8743edd630$var$Ik = {
    choose: "Vyberte odpov\u011B\u010F",
    noaction: "O\u010Dek\xe1v\xe1 se akce"
}, $914aec8743edd630$var$Mk = {
    change: "zm\u011Bnit jazyk",
    select: "vyberte jazyk, kter\xfd chcete pou\u017E\xedvat"
}, $914aec8743edd630$var$jk = {
    buttontext: "Zobrazit dokument",
    goto: "P\u0159ejd\u011Bte na adresu",
    click: "Klikn\u011Bte zde",
    scanQR: "skenov\xe1n\xedm QrCode",
    scanQRTile: "Naskenujte QR k\xf3d a objevte"
}, $914aec8743edd630$var$Fk = {
    loader: {
        optimal: "Pro optim\xe1ln\xed z\xe1\u017Eitek,",
        classic: "Pro klasi\u010Dt\u011Bj\u0161\xed z\xe1\u017Eitek,",
        vocal: "Mluv\xedm tv\xe1\u0159\xed v tv\xe1\u0159 s agentem.",
        text: "S jednatelem komunikuji p\xedsemn\u011B."
    },
    modes: {
        vocal: "hlasov\xfd re\u017Eim",
        text: "textov\xfd re\u017Eim"
    },
    loaderValidation: "Zahajte konverzaci",
    locale: "kontrola jazyka",
    supported: "kontrola podporovan\xfdch jazyk\u016F",
    addressdata: "na\u010D\xedt\xe1n\xed dat"
}, $914aec8743edd630$var$$k = {
    message: "Zadejte svou zpr\xe1vu",
    backconversation: "zp\u011Bt k rozhovoru",
    answer: " odpov\xedd\xe1 na va\u0161e ot\xe1zky"
}, $914aec8743edd630$var$Lk = {
    firstline: "Pro optim\xe1ln\xed z\xe1\u017Eitek,",
    secondline: "oto\u010Dte obrazovku"
}, $914aec8743edd630$var$Nk = {
    shorttitle: "\u017Eiv\xfd zpravodajsk\xfd kan\xe1l",
    warningtext: "Vstoup\xedte do zpravodajsk\xe9ho kan\xe1lu, zvuk na va\u0161em za\u0159\xedzen\xed bude aktivov\xe1n",
    live: "\u017E\xedt",
    continuous: "nep\u0159etr\u017Eit\u011B"
}, $914aec8743edd630$var$Bk = {
    comment: "z\xe1kaznick\xe1 recenze",
    route: "silnice",
    nodata: "Va\u0161emu vyhled\xe1v\xe1n\xed neodpov\xedd\xe1 \u017E\xe1dn\xfd obsah",
    openinghours: "Otev\xedrac\xed doba",
    prices: "Ceny",
    paymentmethods: "Platebn\xed metody",
    numberofplaces: "po\u010Det m\xedst",
    openroutemobile: "otev\u0159ete trasu Google Maps na smartphonu",
    FoodEstablishment: "Kde j\xedst",
    LodgingBusiness: "Kde sp\xe1t",
    TouristDestination: "Co vid\u011Bt",
    TouristAttraction: "Co d\u011Blat",
    Product: "M\xedstn\xed produkty",
    Service: "Slu\u017Eby",
    Event: "Ud\xe1losti",
    City: "M\u011Bsta",
    Wine: "V\xedna"
}, $914aec8743edd630$var$qk = {
    consult: "P\u0159ekontrolovat",
    thetutorial: "tutori\xe1l"
}, $914aec8743edd630$var$zk = {
    reset: "resetovat v\u0161e",
    showresults: "Uka\u017E v\xfdsledky",
    suggestiontitle: "N\xe1vrhy vyhled\xe1v\xe1n\xed",
    reminder: `Nezapome\u{148}te, 
 mohu odpov\u{11B}d\u{11B}t na va\u{161}e ot\xe1zky.`
}, $914aec8743edd630$var$Uk = {
    listening: "Je to na v\xe1s, poslouch\xe1m...",
    correct: "Opravit",
    dontknow: "Nev\xedm"
}, $914aec8743edd630$var$Vk = {
    allow: "Povolte pros\xedm prohl\xed\u017Ee\u010Di p\u0159\xedstup k mikrofonu pro pokra\u010Dov\xe1n\xed.",
    rejected: "Odm\xedtli jste p\u0159\xedstup k mikrofonu.",
    instructions: "Pro pou\u017Eit\xed hlasov\xe9ho re\u017Eimu pros\xedm povolte prohl\xed\u017Ee\u010Di p\u0159\xedstup k mikrofonu.",
    listening: "Sly\u0161\xedm",
    trigger: "Stiskn\u011Bte nebo \u0159ekn\u011Bte",
    triggerwithoutname: "Klepnut\xedm mluv\xedte"
}, $914aec8743edd630$var$Gk = {
    rejected: "Odm\xedtl jste p\u0159\xedstup k va\u0161\xed poloze GPS.",
    instructions: "Chcete-li z\xedskat p\u0159\xedstup k meteorologick\xfdm \xfadaj\u016Fm nebo interaktivn\xed map\u011B, povolte pros\xedm prohl\xed\u017Ee\u010Di p\u0159\xedstup k va\u0161\xed poloze GPS."
}, $914aec8743edd630$var$Wk = {
    calltoaction: "Stiskn\u011Bte obrazovku pro zah\xe1jen\xed",
    emptyveille: "Klikn\u011Bte nebo stiskn\u011Bte obrazovku..."
}, $914aec8743edd630$var$Hk = {
    shorttitle: "zpr\xe1va o po\u010Das\xed",
    attribution: "Meteorologick\xe1 data poskytov\xe1na spole\u010Dnost\xed Open-Meteo.com"
}, $914aec8743edd630$var$Kk = {
    title: "zpracov\xe1n\xed osobn\xedch \xfadaj\u016F p\u0159edan\xfdch botovi",
    message: `p\u{159}ijet\xedm tohoto dialogu souhlas\xedte s t\xedm, aby v\u{161}echna data p\u{159}edan\xe1 chatbotu byla vyu\u{17E}ita pro anal\xfdzu pou\u{17E}\xedv\xe1n\xed n\xe1stroje a obohacen\xed znalostn\xed b\xe1ze.

Va\u{161}e konverzace jsou uchov\xe1v\xe1ny 6 m\u{11B}s\xedc\u{16F} p\u{159}ed smaz\xe1n\xedm.`,
    link: "odkaz pro zobrazen\xed z\xe1sad ochrany soukrom\xed",
    buttonAccept: "rozum\xedm a souhlas\xedm",
    buttonRefuse: "odm\xedt\xe1m",
    messageAccepted: "v\xe1\u0161 souhlas byl zohledn\u011Bn",
    messageRefused: "va\u0161e odm\xedtnut\xed bylo zohledn\u011Bno"
}, $914aec8743edd630$var$Qk = {
    1: "domovsk\xe1 str\xe1nka",
    2: "\u017Eiv\xfd zpravodajsk\xfd kan\xe1l",
    3: "zpr\xe1va o po\u010Das\xed",
    4: "T\xeds\u0148ov\xe1 \u010D\xedsla",
    1e3: "historick\xfd",
    1001: "tutorial",
    common: $914aec8743edd630$var$Ck,
    emergency: $914aec8743edd630$var$Rk,
    error: $914aec8743edd630$var$Ok,
    history: $914aec8743edd630$var$Dk,
    home: $914aec8743edd630$var$Pk,
    inputs: $914aec8743edd630$var$Ik,
    language: $914aec8743edd630$var$Mk,
    link: $914aec8743edd630$var$jk,
    loader: $914aec8743edd630$var$Fk,
    menu: $914aec8743edd630$var$$k,
    mobileLandscapePreventer: $914aec8743edd630$var$Lk,
    news: $914aec8743edd630$var$Nk,
    poi: $914aec8743edd630$var$Bk,
    suggestion: $914aec8743edd630$var$qk,
    template: $914aec8743edd630$var$zk,
    anghello: $914aec8743edd630$var$Uk,
    microphone: $914aec8743edd630$var$Vk,
    position: $914aec8743edd630$var$Gk,
    veille: $914aec8743edd630$var$Wk,
    weather: $914aec8743edd630$var$Hk,
    GDPR: $914aec8743edd630$var$Kk
}, $914aec8743edd630$var$Yk = {
    all: "alle",
    back: "tilbage",
    close: "t\xe6t",
    continue: "Blive ved",
    download: "Hent",
    downloadsheet: "download dette ark",
    downloadsheetmobile: "download dette ark p\xe5 smartphone",
    filter: "Filter",
    history: "historisk",
    knowmore: "L\xe6s mere",
    lang: "SPROG",
    menu: "menu",
    mode: "mode",
    needhelp: "Brug for hj\xe6lp?",
    parameters: "indstillinger",
    print: "Print",
    printsheet: "Udskriv dette ark",
    result: "resultat",
    results: "resultater",
    singleLang: "Sprog",
    sound: "hende",
    submit: "indsend",
    subtitle: "undertekst",
    tutorial: "tutorial",
    validate: "validere",
    abort: "afbryd"
}, $914aec8743edd630$var$Jk = {
    shorttitle: "N\xf8dnumre",
    samu: "S.A.M.U.",
    police: "politi",
    firefighter: "brandm\xe6nd",
    general: "generel",
    citypolice: "Lokalt politi",
    hospital: "Hospital",
    homeless: "Hjeml\xf8s (gratis opkald)",
    poison: "Giftkontrolcenter",
    emergency: "europ\xe6iske n\xf8dsituationer"
}, $914aec8743edd630$var$Zk = {
    title: "Der opstod en fejl",
    button: "Genstart applikationen"
}, $914aec8743edd630$var$Xk = {
    shorttitle: "historisk",
    title: "samtale historie"
}, $914aec8743edd630$var$ex = {
    shorttitle: "hjemmeside"
}, $914aec8743edd630$var$tx = {
    choose: "V\xe6lg et svar",
    noaction: "Afventer handling"
}, $914aec8743edd630$var$rx = {
    change: "\xe6ndre sproget",
    select: "v\xe6lg det sprog, du vil bruge"
}, $914aec8743edd630$var$nx = {
    buttontext: "Se dokumentet",
    goto: "G\xe5 til adressen",
    click: "Klik her",
    scanQR: "ved at scanne QRCoden",
    scanQRTile: "Scan QR-koden for at opdage"
}, $914aec8743edd630$var$ix = {
    loader: {
        optimal: "For en optimal oplevelse,",
        classic: "For en mere klassisk oplevelse,",
        vocal: "Jeg taler ansigt til ansigt med agenten.",
        text: "Jeg kommunikerer skriftligt med agenten."
    },
    modes: {
        vocal: "vokal tilstand",
        text: "teksttilstand"
    },
    loaderValidation: "Start samtale",
    locale: "kontrol af sprog",
    supported: "kontrol af underst\xf8ttede sprog",
    addressdata: "hente data"
}, $914aec8743edd630$var$ox = {
    message: "Indtast din besked",
    backconversation: "tilbage til samtalen",
    answer: " svarer p\xe5 dine sp\xf8rgsm\xe5l"
}, $914aec8743edd630$var$ax = {
    firstline: "For en optimal oplevelse,",
    secondline: "vend din sk\xe6rm"
}, $914aec8743edd630$var$sx = {
    warningtext: "Du f\xe5r adgang til nyhedskanalen, lyden p\xe5 din enhed aktiveres",
    live: "Direkte",
    continuous: "l\xf8bende",
    shorttitle: "live nyhedskanal"
}, $914aec8743edd630$var$ux = {
    comment: "kundeanmeldelse",
    route: "vej",
    nodata: "Intet indhold matcher din s\xf8gning",
    openinghours: "\xc5bningstider",
    prices: "Priser",
    paymentmethods: "Betalingsmetoder",
    numberofplaces: "antal pladser",
    openroutemobile: "\xe5ben Google Map-rute p\xe5 smartphone",
    FoodEstablishment: "Hvor skal man spise",
    LodgingBusiness: "Hvor skal man sove",
    TouristDestination: "Hvad at se",
    TouristAttraction: "Hvad skal man g\xf8re",
    Product: "Lokale produkter",
    Service: "Tjenester",
    Event: "Begivenheder",
    City: "Byer",
    Wine: "Vine"
}, $914aec8743edd630$var$cx = {
    consult: "Tjek ud",
    thetutorial: "tutorialen"
}, $914aec8743edd630$var$lx = {
    reset: "genstart alt",
    showresults: "Vis resultaterne",
    suggestiontitle: "S\xf8geforslag",
    reminder: `Glem ikke, 
 jeg kan svare p\xe5 dine sp\xf8rgsm\xe5l.`
}, $914aec8743edd630$var$dx = {
    listening: "Det er op til dig, jeg lytter...",
    correct: "Korrigere",
    dontknow: "Jeg ved det ikke"
}, $914aec8743edd630$var$fx = {
    allow: "Venligst giv din browser tilladelse til at f\xe5 adgang til mikrofonen for at forts\xe6tte.",
    rejected: "Du har n\xe6gtet adgangen til mikrofonen.",
    instructions: "For at bruge stemmetilstand, venligst giv din browser tilladelse til at f\xe5 adgang til mikrofonen.",
    listening: "Jeg lytter",
    trigger: "Tryk eller siger",
    triggerwithoutname: "Tryk for at tale"
}, $914aec8743edd630$var$hx = {
    rejected: "Du har afvist adgang til din GPS-position.",
    instructions: "For at f\xe5 adgang til vejret eller interaktivt kort, skal du venligst give din browser adgang til din GPS-position."
}, $914aec8743edd630$var$px = {
    calltoaction: "Tryk p\xe5 sk\xe6rmen for at starte",
    emptyveille: "Klik eller tryk p\xe5 sk\xe6rmen..."
}, $914aec8743edd630$var$mx = {
    shorttitle: "vejrudsigt",
    attribution: "Vejrdata leveret af Open-Meteo.com"
}, $914aec8743edd630$var$gx = {
    title: "behandling af personoplysninger transmitteret til botten",
    message: `ved at acceptere denne dialog giver du dit samtykke til, at alle data transmitteret til chatbotten kan bruges til analyse af brugen af v\xe6rkt\xf8jet og forbedring af vidensbasen.

Dine samtaler opbevares i 6 m\xe5neder inden sletning.`,
    link: "link til at se privatlivspolitikker",
    buttonAccept: "jeg forst\xe5r og accepterer",
    buttonRefuse: "jeg afviser",
    messageAccepted: "dit samtykke er taget til efterretning",
    messageRefused: "dit afslag er taget til efterretning"
}, $914aec8743edd630$var$bx = {
    1: "hjemmeside",
    2: "live nyhedskanal",
    3: "vejrudsigt",
    4: "N\xf8dnumre",
    1e3: "historisk",
    1001: "tutorial",
    common: $914aec8743edd630$var$Yk,
    emergency: $914aec8743edd630$var$Jk,
    error: $914aec8743edd630$var$Zk,
    history: $914aec8743edd630$var$Xk,
    home: $914aec8743edd630$var$ex,
    inputs: $914aec8743edd630$var$tx,
    language: $914aec8743edd630$var$rx,
    link: $914aec8743edd630$var$nx,
    loader: $914aec8743edd630$var$ix,
    menu: $914aec8743edd630$var$ox,
    mobileLandscapePreventer: $914aec8743edd630$var$ax,
    news: $914aec8743edd630$var$sx,
    poi: $914aec8743edd630$var$ux,
    suggestion: $914aec8743edd630$var$cx,
    template: $914aec8743edd630$var$lx,
    anghello: $914aec8743edd630$var$dx,
    microphone: $914aec8743edd630$var$fx,
    position: $914aec8743edd630$var$hx,
    veille: $914aec8743edd630$var$px,
    weather: $914aec8743edd630$var$mx,
    GDPR: $914aec8743edd630$var$gx
}, $914aec8743edd630$var$vx = {
    all: "alle",
    back: "zur\xfcck",
    close: "schlie\xdfen",
    continue: "Weiter",
    download: "herunterladen",
    downloadsheet: "Dieses Blatt herunterladen",
    downloadsheetmobile: "Laden Sie dieses Blatt auf Ihr Smartphone herunter",
    filter: "filter",
    history: "Verlauf",
    knowmore: "Mehr erfahren",
    lang: "Sprachen",
    menu: "Men\xfc",
    mode: "Modus",
    needhelp: "Brauche Hilfe ?",
    parameters: "Parameter",
    print: "Ausdrucken",
    printsheet: "Blat ausdrucken",
    result: "Ergebnis",
    results: "Ergebnisse",
    singleLang: "Sprache",
    sound: "Ton",
    subtitle: "Untertitel",
    submit: "einreichen",
    tutorial: "Lernprogramm",
    validate: "validieren",
    abort: "Abbrechen"
}, $914aec8743edd630$var$yx = {
    shorttitle: "Notrufnummern",
    samu: "samu",
    police: "polizei",
    firefighter: "feuerwehrleute",
    general: "allgemein",
    citypolice: "Lokale Polizeibeh\xf6rde",
    hospital: "Krankenhaus",
    homeless: "Obdachlos (kostenloser Anruf)",
    poison: "Giftkontrollzentrum",
    emergency: "Europ\xe4ische Notf\xe4lle"
}, $914aec8743edd630$var$wx = {
    title: "Es ist ein Fehler aufgetreten",
    button: "Starten Sie die Anwendung erneut"
}, $914aec8743edd630$var$_x = {
    shorttitle: "Geschichte",
    title: "Chat-Verlauf"
}, $914aec8743edd630$var$kx = {
    shorttitle: "Startseite"
}, $914aec8743edd630$var$xx = {
    choose: "W\xe4hlen Sie eine Antwort",
    noaction: "Aktion erwartet"
}, $914aec8743edd630$var$Sx = {
    change: "die Sprache \xe4ndern",
    select: "W\xe4hlen Sie die gew\xfcnschte Sprache"
}, $914aec8743edd630$var$Ex = {
    buttontext: "Sehen Sie sich das Dokument an",
    goto: "Zur Adresse gehen",
    click: "klicken Sie hier",
    scanQR: "durch Scannen des QrCodes",
    scanQRTile: "Scannen Sie den QR-Code, um zu entdecken"
}, $914aec8743edd630$var$Ax = {
    loader: {
        optimal: "F\xfcr ein optimales Erlebnis,",
        classic: "F\xfcr ein eher klassisches Erlebnis,",
        vocal: "Ich kommuniziere durch Sprechen mit dem Agenten.",
        text: "Ich kommuniziere per Text mit dem Agenten."
    },
    modes: {
        vocal: "Vokal-Modus",
        text: "Textmodus"
    },
    loaderValidation: "Gespr\xe4ch beginnen",
    locale: "Gebietsschema pr\xfcfen",
    supported: "Pr\xfcfung der unterst\xfctzten Gebietsschemata",
    store: "Speicher erstellen",
    directline: "Direktleitung verbinden",
    ponyfill: "ponyfilling",
    addressdata: "Abrufen von Daten"
}, $914aec8743edd630$var$Tx = {
    message: "Geben Sie Ihre Nachricht ein",
    backconversation: "zur\xfcck zum Gespr\xe4ch",
    answer: " beantwortet Ihre Fragen"
}, $914aec8743edd630$var$Cx = {
    firstline: "F\xfcr ein optimales Erlebnis,",
    secondline: "drehen Sie Ihren Bildschirm um"
}, $914aec8743edd630$var$Rx = {
    warningtext: "Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Ger\xe4ts wird aktiviert",
    live: "live",
    continuous: "fortlaufend",
    shorttitle: "Live-Infokanal"
}, $914aec8743edd630$var$Ox = {
    comment: "Kundenbewertung",
    route: "Route",
    nodata: "Kein Inhalt entspricht Ihrer Suche",
    openinghours: "\xd6ffnungszeiten",
    prices: "Preise",
    paymentmethods: "Zahlungsarten",
    numberofplaces: "Anzahl der Pl\xe4tze",
    openroutemobile: "\xd6ffnen Sie die Google Map-Route auf dem Smartphone",
    FoodEstablishment: "Wo sollen wir essen",
    LodgingBusiness: "Wo schlafen",
    TouristDestination: "Was zu sehen",
    TouristAttraction: "Was zu tun",
    Product: "Lokale Produkte",
    Service: "Dienstleistungen",
    Event: "Veranstaltungen",
    City: "St\xe4dte",
    Wine: "Weine"
}, $914aec8743edd630$var$Dx = {
    consult: "Schauen Sie sich",
    thetutorial: "das Tutorial an"
}, $914aec8743edd630$var$Px = {
    reset: "Filter zur\xfccksetzen",
    showresults: "Ergebnisse anzeigen",
    suggestiontitle: "Forschungsvorschl\xe4ge",
    reminder: `Vergessen Sie nicht :
 Ich kann Ihre Fragen beantworten.`
}, $914aec8743edd630$var$Ix = {
    listening: "Es liegt an dir, ich h\xf6re...",
    correct: "Korrigieren",
    dontknow: "Ich wei\xdf es nicht"
}, $914aec8743edd630$var$Mx = {
    allow: "Bitte erlauben Sie Ihrem Browser den Zugriff auf das Mikrofon, um fortzufahren.",
    rejected: "Sie haben den Zugriff auf das Mikrofon abgelehnt.",
    instructions: "Um den Sprachmodus zu verwenden, erlauben Sie bitte Ihrem Browser den Zugriff auf das Mikrofon.",
    listening: "Ich h\xf6re",
    trigger: "Dr\xfccken Sie oder sagen Sie",
    triggerwithoutname: "Zum Sprechen tippen"
}, $914aec8743edd630$var$jx = {
    rejected: "Sie haben den Zugriff auf Ihren GPS-Standort abgelehnt.",
    instructions: "Um auf die Wetterdaten oder die interaktive Karte zuzugreifen, autorisieren Sie bitte Ihren Browser, auf Ihren GPS-Standort zuzugreifen."
}, $914aec8743edd630$var$Fx = {
    calltoaction: "Dr\xfccken Sie den Bildschirm, um zu beginnen",
    emptyveille: "Klicken oder tippen Sie auf den Bildschirm..."
}, $914aec8743edd630$var$$x = {
    shorttitle: "Wetter",
    attribution: "Wetterdaten bereitgestellt von Open-Meteo.com"
}, $914aec8743edd630$var$Lx = {
    title: "Verarbeitung pers\xf6nlicher Daten, die an den Bot \xfcbermittelt werden",
    message: `Durch die Annahme dieses Dialogs stimmen Sie zu, dass alle an den Chatbot \xfcbermittelten Daten f\xfcr die Analyse der Nutzung des Tools und die Verbesserung der Wissensbasis verwendet werden k\xf6nnen.

Ihre Gespr\xe4che werden 6 Monate lang aufbewahrt, bevor sie gel\xf6scht werden.`,
    link: "Link zur Ansicht der Datenschutzrichtlinien",
    buttonAccept: "Ich verstehe und akzeptiere",
    buttonRefuse: "Ich lehne ab",
    messageAccepted: "Ihre Zustimmung wurde ber\xfccksichtigt",
    messageRefused: "Ihre Ablehnung wurde ber\xfccksichtigt"
}, $914aec8743edd630$var$Nx = {
    1: "Startseite",
    2: "Live-Infokanal",
    3: "Wetter",
    4: "Notrufnummern",
    1e3: "Geschichte",
    1001: "anleitung",
    common: $914aec8743edd630$var$vx,
    emergency: $914aec8743edd630$var$yx,
    error: $914aec8743edd630$var$wx,
    history: $914aec8743edd630$var$_x,
    home: $914aec8743edd630$var$kx,
    inputs: $914aec8743edd630$var$xx,
    language: $914aec8743edd630$var$Sx,
    link: $914aec8743edd630$var$Ex,
    loader: $914aec8743edd630$var$Ax,
    menu: $914aec8743edd630$var$Tx,
    mobileLandscapePreventer: $914aec8743edd630$var$Cx,
    news: $914aec8743edd630$var$Rx,
    poi: $914aec8743edd630$var$Ox,
    suggestion: $914aec8743edd630$var$Dx,
    template: $914aec8743edd630$var$Px,
    anghello: $914aec8743edd630$var$Ix,
    microphone: $914aec8743edd630$var$Mx,
    position: $914aec8743edd630$var$jx,
    veille: $914aec8743edd630$var$Fx,
    weather: $914aec8743edd630$var$$x,
    GDPR: $914aec8743edd630$var$Lx
}, $914aec8743edd630$var$Bx = {
    all: "alle",
    back: "zur\xfcck",
    close: "schlie\xdfen",
    continue: "Weiter",
    download: "herunterladen",
    downloadsheet: "Dieses Blatt herunterladen",
    downloadsheetmobile: "Laden Sie dieses Blatt auf Ihr Smartphone herunter",
    filter: "filter",
    history: "Verlauf",
    knowmore: "Mehr erfahren",
    lang: "Sprachen",
    menu: "Men\xfc",
    mode: "Modus",
    needhelp: "Brauche Hilfe ?",
    parameters: "Parameter",
    print: "Ausdrucken",
    printsheet: "Blat ausdrucken",
    result: "Ergebnis",
    results: "Ergebnisse",
    singleLang: "Sprache",
    sound: "Ton",
    subtitle: "Untertitel",
    submit: "einreichen",
    tutorial: "Lernprogramm",
    validate: "validieren",
    abort: "Abbrechen"
}, $914aec8743edd630$var$qx = {
    shorttitle: "Notrufnummern",
    samu: "samu",
    police: "polizei",
    firefighter: "feuerwehrleute",
    general: "allgemein",
    citypolice: "Lokale Polizeibeh\xf6rde",
    hospital: "Krankenhaus",
    homeless: "Obdachlos (kostenloser Anruf)",
    poison: "Giftkontrollzentrum",
    emergency: "Europ\xe4ische Notf\xe4lle"
}, $914aec8743edd630$var$zx = {
    title: "Es ist ein Fehler aufgetreten",
    button: "Starten Sie die Anwendung erneut"
}, $914aec8743edd630$var$Ux = {
    shorttitle: "Geschichte",
    title: "Chat-Verlauf"
}, $914aec8743edd630$var$Vx = {
    shorttitle: "Startseite"
}, $914aec8743edd630$var$Gx = {
    choose: "W\xe4hlen Sie eine Antwort",
    noaction: "Aktion erwartet"
}, $914aec8743edd630$var$Wx = {
    change: "die Sprache \xe4ndern",
    select: "W\xe4hlen Sie die gew\xfcnschte Sprache"
}, $914aec8743edd630$var$Hx = {
    buttontext: "Sehen Sie sich das Dokument an",
    goto: "Zur Adresse gehen",
    click: "klicken Sie hier",
    scanQR: "durch Scannen des QrCodes",
    scanQRTile: "Scannen Sie den QR-Code, um zu entdecken"
}, $914aec8743edd630$var$Kx = {
    loader: {
        optimal: "F\xfcr ein optimales Erlebnis,",
        classic: "F\xfcr ein eher klassisches Erlebnis,",
        vocal: "Ich kommuniziere durch Sprechen mit dem Agenten.",
        text: "Ich kommuniziere per Text mit dem Agenten."
    },
    modes: {
        vocal: "Vokal-Modus",
        text: "Textmodus"
    },
    loaderValidation: "Gespr\xe4ch beginnen",
    locale: "Gebietsschema pr\xfcfen",
    supported: "Pr\xfcfung der unterst\xfctzten Gebietsschemata",
    store: "Speicher erstellen",
    directline: "Direktleitung verbinden",
    ponyfill: "ponyfilling",
    addressdata: "Abrufen von Daten"
}, $914aec8743edd630$var$Qx = {
    message: "Geben Sie Ihre Nachricht ein",
    backconversation: "zur\xfcck zum Gespr\xe4ch",
    answer: " beantwortet Ihre Fragen"
}, $914aec8743edd630$var$Yx = {
    firstline: "F\xfcr ein optimales Erlebnis,",
    secondline: "drehen Sie Ihren Bildschirm um"
}, $914aec8743edd630$var$Jx = {
    warningtext: "Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Ger\xe4ts wird aktiviert",
    live: "live",
    continuous: "fortlaufend",
    shorttitle: "Live-Infokanal"
}, $914aec8743edd630$var$Zx = {
    comment: "Kundenbewertung",
    route: "Route",
    nodata: "Kein Inhalt entspricht Ihrer Suche",
    openinghours: "\xd6ffnungszeiten",
    prices: "Preise",
    paymentmethods: "Zahlungsarten",
    numberofplaces: "Anzahl der Pl\xe4tze",
    openroutemobile: "\xd6ffnen Sie die Google Map-Route auf dem Smartphone",
    FoodEstablishment: "Wo sollen wir essen",
    LodgingBusiness: "Wo schlafen",
    TouristDestination: "Was zu sehen",
    TouristAttraction: "Was zu tun",
    Product: "Lokale Produkte",
    Service: "Dienstleistungen",
    Event: "Veranstaltungen",
    City: "St\xe4dte",
    Wine: "Weine"
}, $914aec8743edd630$var$Xx = {
    consult: "Schauen Sie sich",
    thetutorial: "das Tutorial an"
}, $914aec8743edd630$var$eS = {
    reset: "Filter zur\xfccksetzen",
    showresults: "Ergebnisse anzeigen",
    suggestiontitle: "Forschungsvorschl\xe4ge",
    reminder: `Vergessen Sie nicht :
 Ich kann Ihre Fragen beantworten.`
}, $914aec8743edd630$var$tS = {
    listening: "Es liegt an dir, ich h\xf6re...",
    correct: "Korrigieren",
    dontknow: "Ich wei\xdf es nicht"
}, $914aec8743edd630$var$rS = {
    allow: "Bitte erlauben Sie Ihrem Browser den Zugriff auf das Mikrofon, um fortzufahren.",
    rejected: "Sie haben den Zugriff auf das Mikrofon abgelehnt.",
    instructions: "Um den Sprachmodus zu verwenden, erlauben Sie bitte Ihrem Browser den Zugriff auf das Mikrofon.",
    listening: "Ich h\xf6re",
    trigger: "Dr\xfccken Sie oder sagen Sie",
    triggerwithoutname: "Zum Sprechen tippen"
}, $914aec8743edd630$var$nS = {
    rejected: "Sie haben den Zugriff auf Ihren GPS-Standort abgelehnt.",
    instructions: "Um auf die Wetterdaten oder die interaktive Karte zuzugreifen, autorisieren Sie bitte Ihren Browser, auf Ihren GPS-Standort zuzugreifen."
}, $914aec8743edd630$var$iS = {
    calltoaction: "Dr\xfccken Sie den Bildschirm, um zu beginnen",
    emptyveille: "Klicken oder tippen Sie auf den Bildschirm..."
}, $914aec8743edd630$var$oS = {
    shorttitle: "Wetter",
    attribution: "Wetterdaten bereitgestellt von Open-Meteo.com"
}, $914aec8743edd630$var$aS = {
    title: "Verarbeitung pers\xf6nlicher Daten, die an den Bot \xfcbermittelt werden",
    message: `Durch die Annahme dieses Dialogs stimmen Sie zu, dass alle an den Chatbot \xfcbermittelten Daten f\xfcr die Analyse der Nutzung des Tools und die Verbesserung der Wissensbasis verwendet werden k\xf6nnen.

Ihre Gespr\xe4che werden 6 Monate lang aufbewahrt, bevor sie gel\xf6scht werden.`,
    link: "Link zur Ansicht der Datenschutzrichtlinien",
    buttonAccept: "Ich verstehe und akzeptiere",
    buttonRefuse: "Ich lehne ab",
    messageAccepted: "Ihre Zustimmung wurde ber\xfccksichtigt",
    messageRefused: "Ihre Ablehnung wurde ber\xfccksichtigt"
}, $914aec8743edd630$var$sS = {
    1: "Startseite",
    2: "Live-Infokanal",
    3: "Wetter",
    4: "Notrufnummern",
    1e3: "Geschichte",
    1001: "anleitung",
    common: $914aec8743edd630$var$Bx,
    emergency: $914aec8743edd630$var$qx,
    error: $914aec8743edd630$var$zx,
    history: $914aec8743edd630$var$Ux,
    home: $914aec8743edd630$var$Vx,
    inputs: $914aec8743edd630$var$Gx,
    language: $914aec8743edd630$var$Wx,
    link: $914aec8743edd630$var$Hx,
    loader: $914aec8743edd630$var$Kx,
    menu: $914aec8743edd630$var$Qx,
    mobileLandscapePreventer: $914aec8743edd630$var$Yx,
    news: $914aec8743edd630$var$Jx,
    poi: $914aec8743edd630$var$Zx,
    suggestion: $914aec8743edd630$var$Xx,
    template: $914aec8743edd630$var$eS,
    anghello: $914aec8743edd630$var$tS,
    microphone: $914aec8743edd630$var$rS,
    position: $914aec8743edd630$var$nS,
    veille: $914aec8743edd630$var$iS,
    weather: $914aec8743edd630$var$oS,
    GDPR: $914aec8743edd630$var$aS
}, $914aec8743edd630$var$uS = {
    all: "alle",
    back: "zur\xfcck",
    close: "schlie\xdfen",
    continue: "Weiter",
    download: "herunterladen",
    downloadsheet: "Dieses Blatt herunterladen",
    downloadsheetmobile: "Laden Sie dieses Blatt auf Ihr Smartphone herunter",
    filter: "filter",
    history: "Verlauf",
    knowmore: "Mehr erfahren",
    lang: "Sprachen",
    menu: "Men\xfc",
    mode: "Modus",
    needhelp: "Brauche Hilfe ?",
    parameters: "Parameter",
    print: "Ausdrucken",
    printsheet: "Blat ausdrucken",
    result: "Ergebnis",
    results: "Ergebnisse",
    singleLang: "Sprache",
    sound: "Ton",
    subtitle: "Untertitel",
    submit: "einreichen",
    tutorial: "Lernprogramm",
    validate: "validieren",
    abort: "Abbrechen"
}, $914aec8743edd630$var$cS = {
    shorttitle: "Notrufnummern",
    samu: "samu",
    police: "polizei",
    firefighter: "feuerwehrleute",
    general: "allgemein",
    citypolice: "Lokale Polizeibeh\xf6rde",
    hospital: "Krankenhaus",
    homeless: "Obdachlos (kostenloser Anruf)",
    poison: "Giftkontrollzentrum",
    emergency: "Europ\xe4ische Notf\xe4lle"
}, $914aec8743edd630$var$lS = {
    title: "Es ist ein Fehler aufgetreten",
    button: "Starten Sie die Anwendung erneut"
}, $914aec8743edd630$var$dS = {
    shorttitle: "Geschichte",
    title: "Chat-Verlauf"
}, $914aec8743edd630$var$fS = {
    shorttitle: "Startseite"
}, $914aec8743edd630$var$hS = {
    choose: "W\xe4hlen Sie eine Antwort",
    noaction: "Aktion erwartet"
}, $914aec8743edd630$var$pS = {
    change: "die Sprache \xe4ndern",
    select: "W\xe4hlen Sie die gew\xfcnschte Sprache"
}, $914aec8743edd630$var$mS = {
    buttontext: "Sehen Sie sich das Dokument an",
    goto: "Zur Adresse gehen",
    click: "klicken Sie hier",
    scanQR: "durch Scannen des QrCodes",
    scanQRTile: "Scannen Sie den QR-Code, um zu entdecken"
}, $914aec8743edd630$var$gS = {
    loader: {
        optimal: "F\xfcr ein optimales Erlebnis,",
        classic: "F\xfcr ein eher klassisches Erlebnis,",
        vocal: "Ich kommuniziere durch Sprechen mit dem Agenten.",
        text: "Ich kommuniziere per Text mit dem Agenten."
    },
    modes: {
        vocal: "Vokal-Modus",
        text: "Textmodus"
    },
    loaderValidation: "Gespr\xe4ch beginnen",
    locale: "Gebietsschema pr\xfcfen",
    supported: "Pr\xfcfung der unterst\xfctzten Gebietsschemata",
    store: "Speicher erstellen",
    directline: "Direktleitung verbinden",
    ponyfill: "ponyfilling",
    addressdata: "Abrufen von Daten"
}, $914aec8743edd630$var$bS = {
    message: "Geben Sie Ihre Nachricht ein",
    backconversation: "zur\xfcck zum Gespr\xe4ch",
    answer: " beantwortet Ihre Fragen"
}, $914aec8743edd630$var$vS = {
    firstline: "F\xfcr ein optimales Erlebnis,",
    secondline: "drehen Sie Ihren Bildschirm um"
}, $914aec8743edd630$var$yS = {
    warningtext: "Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Ger\xe4ts wird aktiviert",
    live: "live",
    continuous: "fortlaufend",
    shorttitle: "Live-Infokanal"
}, $914aec8743edd630$var$wS = {
    comment: "Kundenbewertung",
    route: "Route",
    nodata: "Kein Inhalt entspricht Ihrer Suche",
    openinghours: "\xd6ffnungszeiten",
    prices: "Preise",
    paymentmethods: "Zahlungsarten",
    numberofplaces: "Anzahl der Pl\xe4tze",
    openroutemobile: "\xd6ffnen Sie die Google Map-Route auf dem Smartphone",
    FoodEstablishment: "Wo sollen wir essen",
    LodgingBusiness: "Wo schlafen",
    TouristDestination: "Was zu sehen",
    TouristAttraction: "Was zu tun",
    Product: "Lokale Produkte",
    Service: "Dienstleistungen",
    Event: "Veranstaltungen",
    City: "St\xe4dte",
    Wine: "Weine"
}, $914aec8743edd630$var$_S = {
    consult: "Schauen Sie sich",
    thetutorial: "das Tutorial an"
}, $914aec8743edd630$var$kS = {
    reset: "Filter zur\xfccksetzen",
    showresults: "Ergebnisse anzeigen",
    suggestiontitle: "Forschungsvorschl\xe4ge",
    reminder: `Vergessen Sie nicht :
 Ich kann Ihre Fragen beantworten.`
}, $914aec8743edd630$var$xS = {
    listening: "Es liegt an dir, ich h\xf6re...",
    correct: "Korrigieren",
    dontknow: "Ich wei\xdf es nicht"
}, $914aec8743edd630$var$SS = {
    allow: "Bitte erlauben Sie Ihrem Browser den Zugriff auf das Mikrofon, um fortzufahren.",
    rejected: "Sie haben den Zugriff auf das Mikrofon abgelehnt.",
    instructions: "Um den Sprachmodus zu verwenden, erlauben Sie bitte Ihrem Browser den Zugriff auf das Mikrofon.",
    listening: "Ich h\xf6re",
    trigger: "Dr\xfccken Sie oder sagen Sie",
    triggerwithoutname: "Zum Sprechen tippen"
}, $914aec8743edd630$var$ES = {
    rejected: "Sie haben den Zugriff auf Ihren GPS-Standort abgelehnt.",
    instructions: "Um auf die Wetterdaten oder die interaktive Karte zuzugreifen, autorisieren Sie bitte Ihren Browser, auf Ihren GPS-Standort zuzugreifen."
}, $914aec8743edd630$var$AS = {
    calltoaction: "Dr\xfccken Sie den Bildschirm, um zu beginnen",
    emptyveille: "Klicken oder tippen Sie auf den Bildschirm..."
}, $914aec8743edd630$var$TS = {
    shorttitle: "Wetter",
    attribution: "Wetterdaten bereitgestellt von Open-Meteo.com"
}, $914aec8743edd630$var$CS = {
    title: "Verarbeitung pers\xf6nlicher Daten, die an den Bot \xfcbermittelt werden",
    message: `Durch die Annahme dieses Dialogs stimmen Sie zu, dass alle an den Chatbot \xfcbermittelten Daten f\xfcr die Analyse der Nutzung des Tools und die Verbesserung der Wissensbasis verwendet werden k\xf6nnen.

Ihre Gespr\xe4che werden 6 Monate lang aufbewahrt, bevor sie gel\xf6scht werden.`,
    link: "Link zur Ansicht der Datenschutzrichtlinien",
    buttonAccept: "Ich verstehe und akzeptiere",
    buttonRefuse: "Ich lehne ab",
    messageAccepted: "Ihre Zustimmung wurde ber\xfccksichtigt",
    messageRefused: "Ihre Ablehnung wurde ber\xfccksichtigt"
}, $914aec8743edd630$var$RS = {
    1: "Startseite",
    2: "Live-Infokanal",
    3: "Wetter",
    4: "Notrufnummern",
    1e3: "Geschichte",
    1001: "anleitung",
    common: $914aec8743edd630$var$uS,
    emergency: $914aec8743edd630$var$cS,
    error: $914aec8743edd630$var$lS,
    history: $914aec8743edd630$var$dS,
    home: $914aec8743edd630$var$fS,
    inputs: $914aec8743edd630$var$hS,
    language: $914aec8743edd630$var$pS,
    link: $914aec8743edd630$var$mS,
    loader: $914aec8743edd630$var$gS,
    menu: $914aec8743edd630$var$bS,
    mobileLandscapePreventer: $914aec8743edd630$var$vS,
    news: $914aec8743edd630$var$yS,
    poi: $914aec8743edd630$var$wS,
    suggestion: $914aec8743edd630$var$_S,
    template: $914aec8743edd630$var$kS,
    anghello: $914aec8743edd630$var$xS,
    microphone: $914aec8743edd630$var$SS,
    position: $914aec8743edd630$var$ES,
    veille: $914aec8743edd630$var$AS,
    weather: $914aec8743edd630$var$TS,
    GDPR: $914aec8743edd630$var$CS
}, $914aec8743edd630$var$OS = {
    abort: "abort",
    all: "all",
    back: "back",
    close: "close",
    continue: "continue",
    download: "download",
    downloadsheet: "download this sheet",
    downloadsheetmobile: "download this sheet on smartphone",
    filter: "filter",
    history: "history",
    knowmore: "Learn more",
    lang: "languages",
    menu: "menu",
    mode: "mode",
    needhelp: "Need help ?",
    parameters: "parameters",
    print: "print",
    printsheet: "print this sheet",
    result: "result",
    results: "results",
    singleLang: "language",
    sound: "sound",
    submit: "submit",
    subtitle: "subtitle",
    tutorial: "tutorial",
    validate: "validate"
}, $914aec8743edd630$var$DS = {
    shorttitle: "emergency numbers",
    samu: "maeu",
    police: "police",
    firefighter: "firefighters",
    general: "general",
    citypolice: "Local police",
    hospital: "Hospital",
    homeless: "Homeless (free call)",
    poison: "Poison Control Center",
    emergency: "European emergencies"
}, $914aec8743edd630$var$PS = {
    title: "An error occurred",
    button: "Launch the application again"
}, $914aec8743edd630$var$IS = {
    title: "chat history",
    shorttitle: "history"
}, $914aec8743edd630$var$MS = {
    shorttitle: "home"
}, $914aec8743edd630$var$jS = {
    choose: "Choose an answer",
    noaction: "Awaiting action"
}, $914aec8743edd630$var$FS = {
    change: "change the language",
    select: "select the language you want to use"
}, $914aec8743edd630$var$$S = {
    buttontext: "View the document",
    goto: "Go to address",
    click: "Click here",
    scanQR: "by scanning the QrCode",
    scanQRTile: "Scan the QR Code to discover"
}, $914aec8743edd630$var$LS = {
    loader: {
        optimal: "For an optimal experience,",
        classic: "For a more classical experience,",
        vocal: "I communicate by speaking with the agent.",
        text: "I communicate by text with the agent."
    },
    modes: {
        vocal: "vocal mode",
        text: "text mode"
    },
    loaderValidation: "Start conversation",
    locale: "checking language",
    supported: "checking supported languages",
    addressdata: "retrieving data",
    store: "store",
    directline: "directline",
    ponyfill: "ponyfill"
}, $914aec8743edd630$var$NS = {
    message: "Enter your message",
    backconversation: "back to the conversation",
    answer: " answers your questions"
}, $914aec8743edd630$var$BS = {
    firstline: "For an optimal experience,",
    secondline: "flip your screen"
}, $914aec8743edd630$var$qS = {
    warningtext: "You are about to access the information channel, the sound of your device will be activated",
    live: "live",
    continuous: "continuous",
    shorttitle: "live info channel"
}, $914aec8743edd630$var$zS = {
    comment: "customer review",
    route: "route",
    nodata: "No content corresponds to your search",
    openinghours: "Opening hours",
    prices: "Prices",
    paymentmethods: "Payment methods",
    numberofplaces: "number of places",
    openroutemobile: "open Google Maps route on smartphone",
    FoodEstablishment: "Where to eat",
    LodgingBusiness: "Where to sleep",
    TouristDestination: "What to see",
    TouristAttraction: "What to do",
    Product: "Local products",
    Service: "Services",
    Event: "Events",
    City: "Cities",
    Wine: "Wines"
}, $914aec8743edd630$var$US = {
    consult: "Check out",
    thetutorial: "the tutorial"
}, $914aec8743edd630$var$VS = {
    reset: "reset filters",
    showresults: "Show results",
    suggestiontitle: "Research suggestions",
    reminder: `Don't forget,
 I can answer your questions.`
}, $914aec8743edd630$var$GS = {
    title: "processing personal data transmitted to the bot",
    message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`,
    link: "open confidency policy",
    buttonAccept: "I understand and I accept",
    buttonRefuse: "I refuse",
    messageAccepted: "your acceptation has been saved",
    messageRefused: "your refusal has been saved"
}, $914aec8743edd630$var$WS = {
    listening: "It's up to you, I'm listening...",
    correct: "Correct",
    dontknow: "I don't know"
}, $914aec8743edd630$var$HS = {
    allow: "Please allow your browser to access the microphone to continue.",
    rejected: "You have denied access to the microphone.",
    instructions: "To use voice mode, please allow your browser to access the microphone.",
    listening: "I'm listening",
    trigger: "Press or say",
    triggerwithoutname: "Tap to talk"
}, $914aec8743edd630$var$KS = {
    rejected: "You have denied access to your GPS location.",
    instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location."
}, $914aec8743edd630$var$QS = {
    calltoaction: "Press the screen to start",
    emptyveille: "Click or press the screen..."
}, $914aec8743edd630$var$YS = {
    attribution: "Weather data provided by Open-Meteo.com",
    shorttitle: "weather"
}, $914aec8743edd630$var$JS = {
    shorttitle: "tutorial"
}, $914aec8743edd630$var$ZS = {
    1: "home",
    2: "live info channel",
    3: "weather",
    4: "emergency numbers",
    1e3: "history",
    1001: "tutorial",
    common: $914aec8743edd630$var$OS,
    emergency: $914aec8743edd630$var$DS,
    error: $914aec8743edd630$var$PS,
    history: $914aec8743edd630$var$IS,
    home: $914aec8743edd630$var$MS,
    inputs: $914aec8743edd630$var$jS,
    language: $914aec8743edd630$var$FS,
    link: $914aec8743edd630$var$$S,
    loader: $914aec8743edd630$var$LS,
    menu: $914aec8743edd630$var$NS,
    mobileLandscapePreventer: $914aec8743edd630$var$BS,
    news: $914aec8743edd630$var$qS,
    poi: $914aec8743edd630$var$zS,
    suggestion: $914aec8743edd630$var$US,
    template: $914aec8743edd630$var$VS,
    GDPR: $914aec8743edd630$var$GS,
    anghello: $914aec8743edd630$var$WS,
    microphone: $914aec8743edd630$var$HS,
    position: $914aec8743edd630$var$KS,
    veille: $914aec8743edd630$var$QS,
    weather: $914aec8743edd630$var$YS,
    tutorial: $914aec8743edd630$var$JS
}, $914aec8743edd630$var$XS = {
    abort: "abort",
    all: "all",
    back: "back",
    close: "close",
    continue: "continue",
    download: "download",
    downloadsheet: "download this sheet",
    downloadsheetmobile: "download this sheet on smartphone",
    filter: "filter",
    history: "history",
    knowmore: "Learn more",
    lang: "languages",
    menu: "menu",
    mode: "mode",
    needhelp: "Need help ?",
    parameters: "parameters",
    print: "print",
    printsheet: "print this sheet",
    result: "result",
    results: "results",
    singleLang: "language",
    sound: "sound",
    submit: "submit",
    subtitle: "subtitle",
    tutorial: "tutorial",
    validate: "validate"
}, $914aec8743edd630$var$e3 = {
    shorttitle: "emergency numbers",
    samu: "maeu",
    police: "police",
    firefighter: "firefighters",
    general: "general",
    citypolice: "Local police",
    hospital: "Hospital",
    homeless: "Homeless (free call)",
    poison: "Poison Control Center",
    emergency: "European emergencies"
}, $914aec8743edd630$var$t3 = {
    title: "An error occurred",
    button: "Launch the application again"
}, $914aec8743edd630$var$r3 = {
    title: "chat history",
    shorttitle: "history"
}, $914aec8743edd630$var$n3 = {
    choose: "Choose an answer",
    noaction: "Awaiting action"
}, $914aec8743edd630$var$i3 = {
    change: "change the language",
    select: "select the language you want to use"
}, $914aec8743edd630$var$o3 = {
    buttontext: "View the document",
    goto: "Go to address",
    click: "Click here",
    scanQR: "by scanning the QrCode",
    scanQRTile: "Scan the QR Code to discover"
}, $914aec8743edd630$var$a3 = {
    loader: {
        optimal: "For an optimal experience,",
        classic: "For a more classical experience,",
        vocal: "I communicate by speaking with the agent.",
        text: "I communicate by text with the agent."
    },
    modes: {
        vocal: "vocal mode",
        text: "text mode"
    },
    loaderValidation: "Start conversation",
    locale: "checking language",
    supported: "checking supported languages",
    addressdata: "retrieving data",
    store: "store",
    directline: "directline",
    ponyfill: "ponyfill"
}, $914aec8743edd630$var$s3 = {
    message: "Enter your message",
    backconversation: "back to the conversation",
    answer: " answers your questions"
}, $914aec8743edd630$var$u3 = {
    firstline: "For an optimal experience,",
    secondline: "flip your screen"
}, $914aec8743edd630$var$c3 = {
    warningtext: "You are about to access the information channel, the sound of your device will be activated",
    live: "live",
    continuous: "continuous",
    shorttitle: "live info channel"
}, $914aec8743edd630$var$l3 = {
    comment: "customer review",
    route: "route",
    nodata: "No content corresponds to your search",
    openinghours: "Opening hours",
    prices: "Prices",
    paymentmethods: "Payment methods",
    numberofplaces: "number of places",
    openroutemobile: "open Google Maps route on smartphone",
    FoodEstablishment: "Where to eat",
    LodgingBusiness: "Where to sleep",
    TouristDestination: "What to see",
    TouristAttraction: "What to do",
    Product: "Local products",
    Service: "Services",
    Event: "Events",
    City: "Cities",
    Wine: "Wines"
}, $914aec8743edd630$var$d3 = {
    consult: "Check out",
    thetutorial: "the tutorial"
}, $914aec8743edd630$var$f3 = {
    reset: "reset filters",
    showresults: "Show results",
    suggestiontitle: "Research suggestions",
    reminder: `Don't forget,
 I can answer your questions.`
}, $914aec8743edd630$var$h3 = {
    title: "processing personal data transmitted to the bot",
    message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`,
    link: "open confidency policy",
    buttonAccept: "I understand and I accept",
    buttonRefuse: "I refuse",
    messageAccepted: "your acceptation has been saved",
    messageRefused: "your refusal has been saved"
}, $914aec8743edd630$var$p3 = {
    listening: "It's up to you, I'm listening...",
    correct: "Correct",
    dontknow: "I don't know"
}, $914aec8743edd630$var$m3 = {
    allow: "Please allow your browser to access the microphone to continue.",
    rejected: "You have denied access to the microphone.",
    instructions: "To use voice mode, please allow your browser to access the microphone.",
    listening: "I'm listening",
    trigger: "Press or say",
    triggerwithoutname: "Tap to talk"
}, $914aec8743edd630$var$g3 = {
    rejected: "You have denied access to your GPS location.",
    instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location."
}, $914aec8743edd630$var$b3 = {
    calltoaction: "Press the screen to start",
    emptyveille: "Click or press the screen..."
}, $914aec8743edd630$var$v3 = {
    attribution: "Weather data provided by Open-Meteo.com",
    shorttitle: "weather"
}, $914aec8743edd630$var$y3 = {
    shorttitle: "tutorial"
}, $914aec8743edd630$var$w3 = {
    1: "home",
    2: "live info channel",
    3: "weather",
    4: "emergency numbers",
    1e3: "history",
    1001: "tutorial",
    common: $914aec8743edd630$var$XS,
    emergency: $914aec8743edd630$var$e3,
    error: $914aec8743edd630$var$t3,
    history: $914aec8743edd630$var$r3,
    inputs: $914aec8743edd630$var$n3,
    language: $914aec8743edd630$var$i3,
    link: $914aec8743edd630$var$o3,
    loader: $914aec8743edd630$var$a3,
    menu: $914aec8743edd630$var$s3,
    mobileLandscapePreventer: $914aec8743edd630$var$u3,
    news: $914aec8743edd630$var$c3,
    poi: $914aec8743edd630$var$l3,
    suggestion: $914aec8743edd630$var$d3,
    template: $914aec8743edd630$var$f3,
    GDPR: $914aec8743edd630$var$h3,
    anghello: $914aec8743edd630$var$p3,
    microphone: $914aec8743edd630$var$m3,
    position: $914aec8743edd630$var$g3,
    veille: $914aec8743edd630$var$b3,
    weather: $914aec8743edd630$var$v3,
    tutorial: $914aec8743edd630$var$y3
}, $914aec8743edd630$var$_3 = {
    abort: "abort",
    all: "all",
    back: "back",
    close: "close",
    continue: "continue",
    download: "download",
    downloadsheet: "download this sheet",
    downloadsheetmobile: "download this sheet on smartphone",
    filter: "filter",
    history: "history",
    knowmore: "Learn more",
    lang: "languages",
    menu: "menu",
    mode: "mode",
    needhelp: "Need help ?",
    parameters: "parameters",
    print: "print",
    printsheet: "print this sheet",
    result: "result",
    results: "results",
    singleLang: "language",
    sound: "sound",
    submit: "submit",
    subtitle: "subtitle",
    tutorial: "tutorial",
    validate: "validate"
}, $914aec8743edd630$var$k3 = {
    shorttitle: "emergency numbers",
    samu: "maeu",
    police: "police",
    firefighter: "firefighters",
    general: "general",
    citypolice: "Local police",
    hospital: "Hospital",
    homeless: "Homeless (free call)",
    poison: "Poison Control Center",
    emergency: "European emergencies"
}, $914aec8743edd630$var$x3 = {
    title: "An error occurred",
    button: "Launch the application again"
}, $914aec8743edd630$var$S3 = {
    title: "chat history",
    shorttitle: "history"
}, $914aec8743edd630$var$E3 = {
    shorttitle: "home"
}, $914aec8743edd630$var$A3 = {
    choose: "Choose an answer",
    noaction: "Awaiting action"
}, $914aec8743edd630$var$T3 = {
    change: "change the language",
    select: "select the language you want to use"
}, $914aec8743edd630$var$C3 = {
    buttontext: "View the document",
    goto: "Go to address",
    click: "Click here",
    scanQR: "by scanning the QrCode",
    scanQRTile: "Scan the QR Code to discover"
}, $914aec8743edd630$var$R3 = {
    loader: {
        optimal: "For an optimal experience,",
        classic: "For a more classical experience,",
        vocal: "I communicate by speaking with the agent.",
        text: "I communicate by text with the agent."
    },
    modes: {
        vocal: "vocal mode",
        text: "text mode"
    },
    loaderValidation: "Start conversation",
    locale: "checking language",
    supported: "checking supported languages",
    addressdata: "retrieving data",
    store: "store",
    directline: "directline",
    ponyfill: "ponyfill"
}, $914aec8743edd630$var$O3 = {
    message: "Enter your message",
    backconversation: "back to the conversation",
    answer: " answers your questions"
}, $914aec8743edd630$var$D3 = {
    firstline: "For an optimal experience,",
    secondline: "flip your screen"
}, $914aec8743edd630$var$P3 = {
    warningtext: "You are about to access the information channel, the sound of your device will be activated",
    live: "live",
    continuous: "continuous",
    shorttitle: "live info channel"
}, $914aec8743edd630$var$I3 = {
    comment: "customer review",
    route: "route",
    nodata: "No content corresponds to your search",
    openinghours: "Opening hours",
    prices: "Prices",
    paymentmethods: "Payment methods",
    numberofplaces: "number of places",
    openroutemobile: "open Google Maps route on smartphone",
    FoodEstablishment: "Where to eat",
    LodgingBusiness: "Where to sleep",
    TouristDestination: "What to see",
    TouristAttraction: "What to do",
    Product: "Local products",
    Service: "Services",
    Event: "Events",
    City: "Cities",
    Wine: "Wines"
}, $914aec8743edd630$var$M3 = {
    consult: "Check out",
    thetutorial: "the tutorial"
}, $914aec8743edd630$var$j3 = {
    reset: "reset filters",
    showresults: "Show results",
    suggestiontitle: "Research suggestions",
    reminder: `Don't forget,
 I can answer your questions.`
}, $914aec8743edd630$var$F3 = {
    title: "processing personal data transmitted to the bot",
    message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`,
    link: "open confidency policy",
    buttonAccept: "I understand and I accept",
    buttonRefuse: "I refuse",
    messageAccepted: "your acceptation has been saved",
    messageRefused: "your refusal has been saved"
}, $914aec8743edd630$var$$3 = {
    listening: "It's up to you, I'm listening...",
    correct: "Correct",
    dontknow: "I don't know"
}, $914aec8743edd630$var$L3 = {
    allow: "Please allow your browser to access the microphone to continue.",
    rejected: "You have denied access to the microphone.",
    instructions: "To use voice mode, please allow your browser to access the microphone.",
    listening: "I'm listening",
    trigger: "Press or say",
    triggerwithoutname: "Tap to talk"
}, $914aec8743edd630$var$N3 = {
    rejected: "You have denied access to your GPS location.",
    instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location."
}, $914aec8743edd630$var$B3 = {
    calltoaction: "Press the screen to start",
    emptyveille: "Click or press the screen..."
}, $914aec8743edd630$var$q3 = {
    attribution: "Weather data provided by Open-Meteo.com",
    shorttitle: "weather"
}, $914aec8743edd630$var$z3 = {
    shorttitle: "tutorial"
}, $914aec8743edd630$var$U3 = {
    1: "home",
    2: "live info channel",
    3: "weather",
    4: "emergency numbers",
    1e3: "history",
    1001: "tutorial",
    common: $914aec8743edd630$var$_3,
    emergency: $914aec8743edd630$var$k3,
    error: $914aec8743edd630$var$x3,
    history: $914aec8743edd630$var$S3,
    home: $914aec8743edd630$var$E3,
    inputs: $914aec8743edd630$var$A3,
    language: $914aec8743edd630$var$T3,
    link: $914aec8743edd630$var$C3,
    loader: $914aec8743edd630$var$R3,
    menu: $914aec8743edd630$var$O3,
    mobileLandscapePreventer: $914aec8743edd630$var$D3,
    news: $914aec8743edd630$var$P3,
    poi: $914aec8743edd630$var$I3,
    suggestion: $914aec8743edd630$var$M3,
    template: $914aec8743edd630$var$j3,
    GDPR: $914aec8743edd630$var$F3,
    anghello: $914aec8743edd630$var$$3,
    microphone: $914aec8743edd630$var$L3,
    position: $914aec8743edd630$var$N3,
    veille: $914aec8743edd630$var$B3,
    weather: $914aec8743edd630$var$q3,
    tutorial: $914aec8743edd630$var$z3
}, $914aec8743edd630$var$V3 = {
    abort: "abort",
    all: "all",
    back: "back",
    close: "close",
    continue: "continue",
    download: "download",
    downloadsheet: "download this sheet",
    downloadsheetmobile: "download this sheet on smartphone",
    filter: "filter",
    history: "history",
    knowmore: "Learn more",
    lang: "languages",
    menu: "menu",
    mode: "mode",
    needhelp: "Need help ?",
    parameters: "parameters",
    print: "print",
    printsheet: "print this sheet",
    result: "result",
    results: "results",
    singleLang: "language",
    sound: "sound",
    submit: "submit",
    subtitle: "subtitle",
    tutorial: "tutorial",
    validate: "validate"
}, $914aec8743edd630$var$G3 = {
    shorttitle: "emergency numbers",
    samu: "maeu",
    police: "police",
    firefighter: "firefighters",
    general: "general",
    citypolice: "Local police",
    hospital: "Hospital",
    homeless: "Homeless (free call)",
    poison: "Poison Control Center",
    emergency: "European emergencies"
}, $914aec8743edd630$var$W3 = {
    title: "An error occurred",
    button: "Launch the application again"
}, $914aec8743edd630$var$H3 = {
    title: "chat history",
    shorttitle: "history"
}, $914aec8743edd630$var$K3 = {
    shorttitle: "home"
}, $914aec8743edd630$var$Q3 = {
    choose: "Choose an answer",
    noaction: "Awaiting action"
}, $914aec8743edd630$var$Y3 = {
    change: "change the language",
    select: "select the language you want to use"
}, $914aec8743edd630$var$J3 = {
    buttontext: "View the document",
    goto: "Go to address",
    click: "Click here",
    scanQR: "by scanning the QrCode",
    scanQRTile: "Scan the QR Code to discover"
}, $914aec8743edd630$var$Z3 = {
    loader: {
        optimal: "For an optimal experience,",
        classic: "For a more classical experience,",
        vocal: "I communicate by speaking with the agent.",
        text: "I communicate by text with the agent."
    },
    modes: {
        vocal: "vocal mode",
        text: "text mode"
    },
    loaderValidation: "Start conversation",
    locale: "checking language",
    supported: "checking supported languages",
    addressdata: "retrieving data",
    store: "store",
    directline: "directline",
    ponyfill: "ponyfill"
}, $914aec8743edd630$var$X3 = {
    message: "Enter your message",
    backconversation: "back to the conversation",
    answer: " answers your questions"
}, $914aec8743edd630$var$eE = {
    firstline: "For an optimal experience,",
    secondline: "flip your screen"
}, $914aec8743edd630$var$tE = {
    warningtext: "You are about to access the information channel, the sound of your device will be activated",
    live: "live",
    continuous: "continuous",
    shorttitle: "live info channel"
}, $914aec8743edd630$var$rE = {
    comment: "customer review",
    route: "route",
    nodata: "No content corresponds to your search",
    openinghours: "Opening hours",
    prices: "Prices",
    paymentmethods: "Payment methods",
    numberofplaces: "number of places",
    openroutemobile: "open Google Maps route on smartphone",
    FoodEstablishment: "Where to eat",
    LodgingBusiness: "Where to sleep",
    TouristDestination: "What to see",
    TouristAttraction: "What to do",
    Product: "Local products",
    Service: "Services",
    Event: "Events",
    City: "Cities",
    Wine: "Wines"
}, $914aec8743edd630$var$nE = {
    consult: "Check out",
    thetutorial: "the tutorial"
}, $914aec8743edd630$var$iE = {
    reset: "reset filters",
    showresults: "Show results",
    suggestiontitle: "Research suggestions",
    reminder: `Don't forget,
 I can answer your questions.`
}, $914aec8743edd630$var$oE = {
    title: "processing personal data transmitted to the bot",
    message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`,
    link: "open confidency policy",
    buttonAccept: "I understand and I accept",
    buttonRefuse: "I refuse",
    messageAccepted: "your acceptation has been saved",
    messageRefused: "your refusal has been saved"
}, $914aec8743edd630$var$aE = {
    listening: "It's up to you, I'm listening...",
    correct: "Correct",
    dontknow: "I don't know"
}, $914aec8743edd630$var$sE = {
    allow: "Please allow your browser to access the microphone to continue.",
    rejected: "You have denied access to the microphone.",
    instructions: "To use voice mode, please allow your browser to access the microphone.",
    listening: "I'm listening",
    trigger: "Press or say",
    triggerwithoutname: "Tap to talk"
}, $914aec8743edd630$var$uE = {
    rejected: "You have denied access to your GPS location.",
    instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location."
}, $914aec8743edd630$var$cE = {
    calltoaction: "Press the screen to start",
    emptyveille: "Click or press the screen..."
}, $914aec8743edd630$var$lE = {
    attribution: "Weather data provided by Open-Meteo.com",
    shorttitle: "weather"
}, $914aec8743edd630$var$dE = {
    shorttitle: "tutorial"
}, $914aec8743edd630$var$fE = {
    1: "home",
    2: "live info channel",
    3: "weather",
    4: "emergency numbers",
    1e3: "history",
    1001: "tutorial",
    common: $914aec8743edd630$var$V3,
    emergency: $914aec8743edd630$var$G3,
    error: $914aec8743edd630$var$W3,
    history: $914aec8743edd630$var$H3,
    home: $914aec8743edd630$var$K3,
    inputs: $914aec8743edd630$var$Q3,
    language: $914aec8743edd630$var$Y3,
    link: $914aec8743edd630$var$J3,
    loader: $914aec8743edd630$var$Z3,
    menu: $914aec8743edd630$var$X3,
    mobileLandscapePreventer: $914aec8743edd630$var$eE,
    news: $914aec8743edd630$var$tE,
    poi: $914aec8743edd630$var$rE,
    suggestion: $914aec8743edd630$var$nE,
    template: $914aec8743edd630$var$iE,
    GDPR: $914aec8743edd630$var$oE,
    anghello: $914aec8743edd630$var$aE,
    microphone: $914aec8743edd630$var$sE,
    position: $914aec8743edd630$var$uE,
    veille: $914aec8743edd630$var$cE,
    weather: $914aec8743edd630$var$lE,
    tutorial: $914aec8743edd630$var$dE
}, $914aec8743edd630$var$hE = {
    abort: "abort",
    all: "all",
    back: "back",
    close: "close",
    continue: "continue",
    download: "download",
    downloadsheet: "download this sheet",
    downloadsheetmobile: "download this sheet on smartphone",
    filter: "filter",
    history: "history",
    knowmore: "Learn more",
    lang: "languages",
    menu: "menu",
    mode: "mode",
    needhelp: "Need help ?",
    parameters: "parameters",
    print: "print",
    printsheet: "print this sheet",
    result: "result",
    results: "results",
    singleLang: "language",
    sound: "sound",
    submit: "submit",
    subtitle: "subtitle",
    tutorial: "tutorial",
    validate: "validate"
}, $914aec8743edd630$var$pE = {
    shorttitle: "emergency numbers",
    samu: "maeu",
    police: "police",
    firefighter: "firefighters",
    general: "general",
    citypolice: "Local police",
    hospital: "Hospital",
    homeless: "Homeless (free call)",
    poison: "Poison Control Center",
    emergency: "European emergencies"
}, $914aec8743edd630$var$mE = {
    title: "An error occurred",
    button: "Launch the application again"
}, $914aec8743edd630$var$gE = {
    title: "chat history",
    shorttitle: "history"
}, $914aec8743edd630$var$bE = {
    shorttitle: "home"
}, $914aec8743edd630$var$vE = {
    choose: "Choose an answer",
    noaction: "Awaiting action"
}, $914aec8743edd630$var$yE = {
    change: "change the language",
    select: "select the language you want to use"
}, $914aec8743edd630$var$wE = {
    buttontext: "View the document",
    goto: "Go to address",
    click: "Click here",
    scanQR: "by scanning the QrCode",
    scanQRTile: "Scan the QR Code to discover"
}, $914aec8743edd630$var$_E = {
    loader: {
        optimal: "For an optimal experience,",
        classic: "For a more classical experience,",
        vocal: "I communicate by speaking with the agent.",
        text: "I communicate by text with the agent."
    },
    modes: {
        vocal: "vocal mode",
        text: "text mode"
    },
    loaderValidation: "Start conversation",
    locale: "checking language",
    supported: "checking supported languages",
    addressdata: "retrieving data",
    store: "store",
    directline: "directline",
    ponyfill: "ponyfill"
}, $914aec8743edd630$var$kE = {
    message: "Enter your message",
    backconversation: "back to the conversation",
    answer: " answers your questions"
}, $914aec8743edd630$var$xE = {
    firstline: "For an optimal experience,",
    secondline: "flip your screen"
}, $914aec8743edd630$var$SE = {
    warningtext: "You are about to access the information channel, the sound of your device will be activated",
    live: "live",
    continuous: "continuous",
    shorttitle: "live info channel"
}, $914aec8743edd630$var$EE = {
    comment: "customer review",
    route: "route",
    nodata: "No content corresponds to your search",
    openinghours: "Opening hours",
    prices: "Prices",
    paymentmethods: "Payment methods",
    numberofplaces: "number of places",
    openroutemobile: "open Google Maps route on smartphone",
    FoodEstablishment: "Where to eat",
    LodgingBusiness: "Where to sleep",
    TouristDestination: "What to see",
    TouristAttraction: "What to do",
    Product: "Local products",
    Service: "Services",
    Event: "Events",
    City: "Cities",
    Wine: "Wines"
}, $914aec8743edd630$var$AE = {
    consult: "Check out",
    thetutorial: "the tutorial"
}, $914aec8743edd630$var$TE = {
    reset: "reset filters",
    showresults: "Show results",
    suggestiontitle: "Research suggestions",
    reminder: `Don't forget,
 I can answer your questions.`
}, $914aec8743edd630$var$CE = {
    title: "processing personal data transmitted to the bot",
    message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`,
    link: "open confidency policy",
    buttonAccept: "I understand and I accept",
    buttonRefuse: "I refuse",
    messageAccepted: "your acceptation has been saved",
    messageRefused: "your refusal has been saved"
}, $914aec8743edd630$var$RE = {
    listening: "It's up to you, I'm listening...",
    correct: "Correct",
    dontknow: "I don't know"
}, $914aec8743edd630$var$OE = {
    allow: "Please allow your browser to access the microphone to continue.",
    rejected: "You have denied access to the microphone.",
    instructions: "To use voice mode, please allow your browser to access the microphone.",
    listening: "I'm listening",
    trigger: "Press or say",
    triggerwithoutname: "Tap to talk"
}, $914aec8743edd630$var$DE = {
    rejected: "You have denied access to your GPS location.",
    instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location."
}, $914aec8743edd630$var$PE = {
    calltoaction: "Press the screen to start",
    emptyveille: "Click or press the screen..."
}, $914aec8743edd630$var$IE = {
    attribution: "Weather data provided by Open-Meteo.com",
    shorttitle: "weather"
}, $914aec8743edd630$var$ME = {
    shorttitle: "tutorial"
}, $914aec8743edd630$var$jE = {
    1: "home",
    2: "live info channel",
    3: "weather",
    4: "emergency numbers",
    1e3: "history",
    1001: "tutorial",
    common: $914aec8743edd630$var$hE,
    emergency: $914aec8743edd630$var$pE,
    error: $914aec8743edd630$var$mE,
    history: $914aec8743edd630$var$gE,
    home: $914aec8743edd630$var$bE,
    inputs: $914aec8743edd630$var$vE,
    language: $914aec8743edd630$var$yE,
    link: $914aec8743edd630$var$wE,
    loader: $914aec8743edd630$var$_E,
    menu: $914aec8743edd630$var$kE,
    mobileLandscapePreventer: $914aec8743edd630$var$xE,
    news: $914aec8743edd630$var$SE,
    poi: $914aec8743edd630$var$EE,
    suggestion: $914aec8743edd630$var$AE,
    template: $914aec8743edd630$var$TE,
    GDPR: $914aec8743edd630$var$CE,
    anghello: $914aec8743edd630$var$RE,
    microphone: $914aec8743edd630$var$OE,
    position: $914aec8743edd630$var$DE,
    veille: $914aec8743edd630$var$PE,
    weather: $914aec8743edd630$var$IE,
    tutorial: $914aec8743edd630$var$ME
}, $914aec8743edd630$var$FE = {
    abort: "abort",
    all: "all",
    back: "back",
    close: "close",
    continue: "continue",
    download: "download",
    downloadsheet: "download this sheet",
    downloadsheetmobile: "download this sheet on smartphone",
    filter: "filter",
    history: "history",
    knowmore: "Learn more",
    lang: "languages",
    menu: "menu",
    mode: "mode",
    needhelp: "Need help ?",
    parameters: "parameters",
    print: "print",
    printsheet: "print this sheet",
    result: "result",
    results: "results",
    singleLang: "language",
    sound: "sound",
    submit: "submit",
    subtitle: "subtitle",
    tutorial: "tutorial",
    validate: "validate"
}, $914aec8743edd630$var$$E = {
    shorttitle: "emergency numbers",
    samu: "maeu",
    police: "police",
    firefighter: "firefighters",
    general: "general",
    citypolice: "Local police",
    hospital: "Hospital",
    homeless: "Homeless (free call)",
    poison: "Poison Control Center",
    emergency: "European emergencies"
}, $914aec8743edd630$var$LE = {
    title: "An error occurred",
    button: "Launch the application again"
}, $914aec8743edd630$var$NE = {
    title: "chat history",
    shorttitle: "history"
}, $914aec8743edd630$var$BE = {
    shorttitle: "home"
}, $914aec8743edd630$var$qE = {
    choose: "Choose an answer",
    noaction: "Awaiting action"
}, $914aec8743edd630$var$zE = {
    change: "change the language",
    select: "select the language you want to use"
}, $914aec8743edd630$var$UE = {
    buttontext: "View the document",
    goto: "Go to address",
    click: "Click here",
    scanQR: "by scanning the QrCode",
    scanQRTile: "Scan the QR Code to discover"
}, $914aec8743edd630$var$VE = {
    loader: {
        optimal: "For an optimal experience,",
        classic: "For a more classical experience,",
        vocal: "I communicate by speaking with the agent.",
        text: "I communicate by text with the agent."
    },
    modes: {
        vocal: "vocal mode",
        text: "text mode"
    },
    loaderValidation: "Start conversation",
    locale: "checking language",
    supported: "checking supported languages",
    addressdata: "retrieving data",
    store: "store",
    directline: "directline",
    ponyfill: "ponyfill"
}, $914aec8743edd630$var$GE = {
    message: "Enter your message",
    backconversation: "back to the conversation",
    answer: " answers your questions"
}, $914aec8743edd630$var$WE = {
    firstline: "For an optimal experience,",
    secondline: "flip your screen"
}, $914aec8743edd630$var$HE = {
    warningtext: "You are about to access the information channel, the sound of your device will be activated",
    live: "live",
    continuous: "continuous",
    shorttitle: "live info channel"
}, $914aec8743edd630$var$KE = {
    comment: "customer review",
    route: "route",
    nodata: "No content corresponds to your search",
    openinghours: "Opening hours",
    prices: "Prices",
    paymentmethods: "Payment methods",
    numberofplaces: "number of places",
    openroutemobile: "open Google Maps route on smartphone",
    FoodEstablishment: "Where to eat",
    LodgingBusiness: "Where to sleep",
    TouristDestination: "What to see",
    TouristAttraction: "What to do",
    Product: "Local products",
    Service: "Services",
    Event: "Events",
    City: "Cities",
    Wine: "Wines"
}, $914aec8743edd630$var$QE = {
    consult: "Check out",
    thetutorial: "the tutorial"
}, $914aec8743edd630$var$YE = {
    reset: "reset filters",
    showresults: "Show results",
    suggestiontitle: "Research suggestions",
    reminder: `Don't forget,
 I can answer your questions.`
}, $914aec8743edd630$var$JE = {
    title: "processing personal data transmitted to the bot",
    message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`,
    link: "open confidency policy",
    buttonAccept: "I understand and I accept",
    buttonRefuse: "I refuse",
    messageAccepted: "your acceptation has been saved",
    messageRefused: "your refusal has been saved"
}, $914aec8743edd630$var$ZE = {
    listening: "It's up to you, I'm listening...",
    correct: "Correct",
    dontknow: "I don't know"
}, $914aec8743edd630$var$XE = {
    allow: "Please allow your browser to access the microphone to continue.",
    rejected: "You have denied access to the microphone.",
    instructions: "To use voice mode, please allow your browser to access the microphone.",
    listening: "I'm listening",
    trigger: "Press or say",
    triggerwithoutname: "Tap to talk"
}, $914aec8743edd630$var$e6 = {
    rejected: "You have denied access to your GPS location.",
    instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location."
}, $914aec8743edd630$var$t6 = {
    calltoaction: "Press the screen to start",
    emptyveille: "Click or press the screen..."
}, $914aec8743edd630$var$r6 = {
    attribution: "Weather data provided by Open-Meteo.com",
    shorttitle: "weather"
}, $914aec8743edd630$var$n6 = {
    shorttitle: "tutorial"
}, $914aec8743edd630$var$i6 = {
    1: "home",
    2: "live info channel",
    3: "weather",
    4: "emergency numbers",
    1e3: "history",
    1001: "tutorial",
    common: $914aec8743edd630$var$FE,
    emergency: $914aec8743edd630$var$$E,
    error: $914aec8743edd630$var$LE,
    history: $914aec8743edd630$var$NE,
    home: $914aec8743edd630$var$BE,
    inputs: $914aec8743edd630$var$qE,
    language: $914aec8743edd630$var$zE,
    link: $914aec8743edd630$var$UE,
    loader: $914aec8743edd630$var$VE,
    menu: $914aec8743edd630$var$GE,
    mobileLandscapePreventer: $914aec8743edd630$var$WE,
    news: $914aec8743edd630$var$HE,
    poi: $914aec8743edd630$var$KE,
    suggestion: $914aec8743edd630$var$QE,
    template: $914aec8743edd630$var$YE,
    GDPR: $914aec8743edd630$var$JE,
    anghello: $914aec8743edd630$var$ZE,
    microphone: $914aec8743edd630$var$XE,
    position: $914aec8743edd630$var$e6,
    veille: $914aec8743edd630$var$t6,
    weather: $914aec8743edd630$var$r6,
    tutorial: $914aec8743edd630$var$n6
}, $914aec8743edd630$var$o6 = {
    abort: "cancelar",
    all: "todos",
    back: "volver",
    close: "cerrar",
    continue: "continuar",
    download: "descargar",
    downloadsheet: "descargar esta hoja",
    downloadsheetmobile: "descargar esta hoja en el tel\xe9fono inteligente",
    filter: "filtrar",
    history: "historia",
    knowmore: "Saber m\xe1s",
    lang: "idiomas",
    menu: "men\xfa",
    mode: "modo",
    needhelp: "necesitar ayuda ?",
    parameters: "par\xe1metros",
    print: "imprime",
    printsheet: "imprime esta hoja",
    result: "resultado",
    results: "resultados",
    singleLang: "idioma",
    sound: "sonido",
    submit: "enviar",
    subtitle: "subt\xedtulos",
    tutorial: "tutorial",
    validate: "valide"
}, $914aec8743edd630$var$a6 = {
    shorttitle: "n\xfameros de emergencia",
    samu: "samu",
    police: "polic\xeda",
    firefighter: "bomberos",
    general: "general",
    citypolice: "Polic\xeda Local",
    hospital: "Hospital",
    homeless: "Personas sin hogar (llamada gratuita)",
    poison: "Centro de control de venenos",
    emergency: "Emergencias europeas"
}, $914aec8743edd630$var$s6 = {
    title: "Se ha producido un error",
    button: "Vuelva a iniciar la aplicaci\xf3n"
}, $914aec8743edd630$var$u6 = {
    shorttitle: "historia",
    title: "historial de chat"
}, $914aec8743edd630$var$c6 = {
    shorttitle: "inicio"
}, $914aec8743edd630$var$l6 = {
    choose: "Elija una respuesta",
    noaction: "Se espera una acci\xf3n"
}, $914aec8743edd630$var$d6 = {
    change: "cambiar el idioma",
    select: "seleccione la lengua que desea utilizar"
}, $914aec8743edd630$var$f6 = {
    buttontext: "Ver el documento",
    goto: "Ir a la direcci\xf3n",
    click: "Haga clic aqu\xed",
    scanQR: "escaneando el QrCode",
    scanQRTile: "Escanea el c\xf3digo QR para descubrir"
}, $914aec8743edd630$var$h6 = {
    loader: {
        optimal: "Para una experiencia \xf3ptima,",
        classic: "Para una experiencia m\xe1s cl\xe1sica,",
        vocal: "Me comunico hablando con el agente.",
        text: "Me comunico por SMS con el agente."
    },
    modes: {
        vocal: "modo vocal",
        text: "modo texto"
    },
    loaderValidation: "Iniciar conversaci\xf3n",
    locale: "comprobar configuraci\xf3n regional",
    supported: "comprobaci\xf3n de las configuraciones regionales admitidas",
    store: "crear tienda",
    directline: "conexi\xf3n directline",
    ponyfill: "creaci\xf3n del ponyfill",
    addressdata: "recuperar datos"
}, $914aec8743edd630$var$p6 = {
    message: "Escriba su mensaje",
    backconversation: "volver a la conversaci\xf3n",
    answer: " responde a tus preguntas"
}, $914aec8743edd630$var$m6 = {
    firstline: "Para una experiencia \xf3ptima",
    secondline: "voltea la pantalla"
}, $914aec8743edd630$var$g6 = {
    shorttitle: "canal de informaci\xf3n en directo",
    warningtext: "Est\xe1 a punto de acceder al canal de informaci\xf3n, el sonido de su dispositivo se activar\xe1",
    live: "en directo",
    continuous: "continuo"
}, $914aec8743edd630$var$b6 = {
    comment: "revisi\xf3n del cliente",
    route: "ruta",
    nodata: "Ning\xfan contenido corresponde a su b\xfasqueda",
    openinghours: "Horario de apertura",
    prices: "Precios",
    paymentmethods: "M\xe9todos de pago",
    numberofplaces: "numero de lugares",
    openroutemobile: "abrir la ruta de Google Maps en el tel\xe9fono inteligente",
    FoodEstablishment: "D\xf3nde comer",
    LodgingBusiness: "D\xf3nde dormir",
    TouristDestination: "Qu\xe9 ver",
    TouristAttraction: "Qu\xe9 hacer",
    Product: "Productos locales",
    Service: "Servicios",
    Event: "Eventos",
    City: "Ciudades",
    Wine: "Vinos"
}, $914aec8743edd630$var$v6 = {
    consult: "Mira",
    thetutorial: "el tutorial"
}, $914aec8743edd630$var$y6 = {
    reset: "restablecer filtros",
    showresults: "Mostrar resultados",
    suggestiontitle: "Sugerencias de investigaci\xf3n",
    reminder: `No olvide :
 puedo responder a sus preguntas.`
}, $914aec8743edd630$var$w6 = {
    listening: "Te toca a ti, te escucho...",
    correct: "Corregir",
    dontknow: "No lo s\xe9"
}, $914aec8743edd630$var$_6 = {
    allow: "Por favor, autorice a su navegador para acceder al micr\xf3fono para continuar.",
    rejected: "Ha denegado el acceso al micr\xf3fono.",
    instructions: "Para usar el modo de voz, por favor, autorice a su navegador para acceder al micr\xf3fono.",
    listening: "Estoy escuchando",
    trigger: "Pulsa o di",
    triggerwithoutname: "Toca para hablar"
}, $914aec8743edd630$var$k6 = {
    rejected: "Has rechazado el acceso a tu ubicaci\xf3n GPS.",
    instructions: "Para acceder a los datos meteorol\xf3gicos o al mapa interactivo, por favor permita que su navegador acceda a su ubicaci\xf3n GPS."
}, $914aec8743edd630$var$x6 = {
    calltoaction: "Pulse la pantalla para empezar",
    emptyveille: "Haga clic o pulse la pantalla..."
}, $914aec8743edd630$var$S6 = {
    shorttitle: "tiempo",
    attribution: "Datos meteorol\xf3gicos proporcionados por Open-Meteo.com"
}, $914aec8743edd630$var$E6 = {
    title: "tratamiento de datos personales transmitidos al bot",
    message: `al aceptar este di\xe1logo, usted consiente que todos los datos transmitidos al chatbot sean utilizados para analizar el uso de la herramienta y enriquecer la base de conocimiento.

Sus conversaciones se conservan 6 meses antes de ser eliminadas.`,
    link: "enlace para consultar las pol\xedticas de privacidad",
    buttonAccept: "entendido y acepto",
    buttonRefuse: "rechazo",
    messageAccepted: "su consentimiento ha sido tenido en cuenta",
    messageRefused: "su rechazo ha sido tenido en cuenta"
}, $914aec8743edd630$var$A6 = {
    1: "inicio",
    2: "canal de informaci\xf3n en directo",
    3: "tiempo",
    4: "n\xfameros de emergencia",
    1e3: "historia",
    1001: "tutorial",
    common: $914aec8743edd630$var$o6,
    emergency: $914aec8743edd630$var$a6,
    error: $914aec8743edd630$var$s6,
    history: $914aec8743edd630$var$u6,
    home: $914aec8743edd630$var$c6,
    inputs: $914aec8743edd630$var$l6,
    language: $914aec8743edd630$var$d6,
    link: $914aec8743edd630$var$f6,
    loader: $914aec8743edd630$var$h6,
    menu: $914aec8743edd630$var$p6,
    mobileLandscapePreventer: $914aec8743edd630$var$m6,
    news: $914aec8743edd630$var$g6,
    poi: $914aec8743edd630$var$b6,
    suggestion: $914aec8743edd630$var$v6,
    template: $914aec8743edd630$var$y6,
    anghello: $914aec8743edd630$var$w6,
    microphone: $914aec8743edd630$var$_6,
    position: $914aec8743edd630$var$k6,
    veille: $914aec8743edd630$var$x6,
    weather: $914aec8743edd630$var$S6,
    GDPR: $914aec8743edd630$var$E6
}, $914aec8743edd630$var$T6 = {
    abort: "cancelar",
    all: "todos",
    back: "volver",
    close: "cerrar",
    continue: "continuar",
    download: "descargar",
    downloadsheet: "descargar esta hoja",
    downloadsheetmobile: "descargar esta hoja en el tel\xe9fono inteligente",
    filter: "filtrar",
    history: "historia",
    knowmore: "Saber m\xe1s",
    lang: "idiomas",
    menu: "men\xfa",
    mode: "modo",
    needhelp: "necesitar ayuda ?",
    parameters: "par\xe1metros",
    print: "imprime",
    printsheet: "imprime esta hoja",
    result: "resultado",
    results: "resultados",
    singleLang: "idioma",
    sound: "sonido",
    submit: "enviar",
    subtitle: "subt\xedtulos",
    tutorial: "tutorial",
    validate: "valide"
}, $914aec8743edd630$var$C6 = {
    shorttitle: "n\xfameros de emergencia",
    samu: "samu",
    police: "polic\xeda",
    firefighter: "bomberos",
    general: "general",
    citypolice: "Polic\xeda Local",
    hospital: "Hospital",
    homeless: "Personas sin hogar (llamada gratuita)",
    poison: "Centro de control de venenos",
    emergency: "Emergencias europeas"
}, $914aec8743edd630$var$R6 = {
    title: "Se ha producido un error",
    button: "Vuelva a iniciar la aplicaci\xf3n"
}, $914aec8743edd630$var$O6 = {
    shorttitle: "historia",
    title: "historial de chat"
}, $914aec8743edd630$var$D6 = {
    shorttitle: "inicio"
}, $914aec8743edd630$var$P6 = {
    choose: "Elija una respuesta",
    noaction: "Se espera una acci\xf3n"
}, $914aec8743edd630$var$I6 = {
    change: "cambiar el idioma",
    select: "seleccione la lengua que desea utilizar"
}, $914aec8743edd630$var$M6 = {
    buttontext: "Ver el documento",
    goto: "Ir a la direcci\xf3n",
    click: "Haga clic aqu\xed",
    scanQR: "escaneando el QrCode",
    scanQRTile: "Escanea el c\xf3digo QR para descubrir"
}, $914aec8743edd630$var$j6 = {
    loader: {
        optimal: "Para una experiencia \xf3ptima,",
        classic: "Para una experiencia m\xe1s cl\xe1sica,",
        vocal: "Me comunico hablando con el agente.",
        text: "Me comunico por SMS con el agente."
    },
    modes: {
        vocal: "modo vocal",
        text: "modo texto"
    },
    loaderValidation: "Iniciar conversaci\xf3n",
    locale: "comprobar configuraci\xf3n regional",
    supported: "comprobaci\xf3n de las configuraciones regionales admitidas",
    store: "crear tienda",
    directline: "conexi\xf3n directline",
    ponyfill: "creaci\xf3n del ponyfill",
    addressdata: "recuperar datos"
}, $914aec8743edd630$var$F6 = {
    message: "Escriba su mensaje",
    backconversation: "volver a la conversaci\xf3n",
    answer: " responde a tus preguntas"
}, $914aec8743edd630$var$$6 = {
    firstline: "Para una experiencia \xf3ptima",
    secondline: "voltea la pantalla"
}, $914aec8743edd630$var$L6 = {
    shorttitle: "canal de informaci\xf3n en directo",
    warningtext: "Est\xe1 a punto de acceder al canal de informaci\xf3n, el sonido de su dispositivo se activar\xe1",
    live: "en directo",
    continuous: "continuo"
}, $914aec8743edd630$var$N6 = {
    comment: "revisi\xf3n del cliente",
    route: "ruta",
    nodata: "Ning\xfan contenido corresponde a su b\xfasqueda",
    openinghours: "Horario de apertura",
    prices: "Precios",
    paymentmethods: "M\xe9todos de pago",
    numberofplaces: "numero de lugares",
    openroutemobile: "abrir la ruta de Google Maps en el tel\xe9fono inteligente",
    FoodEstablishment: "D\xf3nde comer",
    LodgingBusiness: "D\xf3nde dormir",
    TouristDestination: "Qu\xe9 ver",
    TouristAttraction: "Qu\xe9 hacer",
    Product: "Productos locales",
    Service: "Servicios",
    Event: "Eventos",
    City: "Ciudades",
    Wine: "Vinos"
}, $914aec8743edd630$var$B6 = {
    consult: "Mira",
    thetutorial: "el tutorial"
}, $914aec8743edd630$var$q6 = {
    reset: "restablecer filtros",
    showresults: "Mostrar resultados",
    suggestiontitle: "Sugerencias de investigaci\xf3n",
    reminder: `No olvide :
 puedo responder a sus preguntas.`
}, $914aec8743edd630$var$z6 = {
    listening: "Te toca a ti, te escucho...",
    correct: "Corregir",
    dontknow: "No lo s\xe9"
}, $914aec8743edd630$var$U6 = {
    allow: "Por favor, autorice a su navegador para acceder al micr\xf3fono para continuar.",
    rejected: "Ha denegado el acceso al micr\xf3fono.",
    instructions: "Para usar el modo de voz, por favor, autorice a su navegador para acceder al micr\xf3fono.",
    listening: "Estoy escuchando",
    trigger: "Pulsa o di",
    triggerwithoutname: "Toca para hablar"
}, $914aec8743edd630$var$V6 = {
    rejected: "Has rechazado el acceso a tu ubicaci\xf3n GPS.",
    instructions: "Para acceder a los datos meteorol\xf3gicos o al mapa interactivo, por favor permita que su navegador acceda a su ubicaci\xf3n GPS."
}, $914aec8743edd630$var$G6 = {
    calltoaction: "Pulse la pantalla para empezar",
    emptyveille: "Haga clic o pulse la pantalla..."
}, $914aec8743edd630$var$W6 = {
    shorttitle: "tiempo",
    attribution: "Datos meteorol\xf3gicos proporcionados por Open-Meteo.com"
}, $914aec8743edd630$var$H6 = {
    title: "tratamiento de datos personales transmitidos al bot",
    message: `al aceptar este di\xe1logo, usted consiente que todos los datos transmitidos al chatbot sean utilizados para analizar el uso de la herramienta y enriquecer la base de conocimiento.

Sus conversaciones se conservan 6 meses antes de ser eliminadas.`,
    link: "enlace para consultar las pol\xedticas de privacidad",
    buttonAccept: "entendido y acepto",
    buttonRefuse: "rechazo",
    messageAccepted: "su consentimiento ha sido tenido en cuenta",
    messageRefused: "su rechazo ha sido tenido en cuenta"
}, $914aec8743edd630$var$K6 = {
    1: "inicio",
    2: "canal de informaci\xf3n en directo",
    3: "tiempo",
    4: "n\xfameros de emergencia",
    1e3: "historia",
    1001: "tutorial",
    common: $914aec8743edd630$var$T6,
    emergency: $914aec8743edd630$var$C6,
    error: $914aec8743edd630$var$R6,
    history: $914aec8743edd630$var$O6,
    home: $914aec8743edd630$var$D6,
    inputs: $914aec8743edd630$var$P6,
    language: $914aec8743edd630$var$I6,
    link: $914aec8743edd630$var$M6,
    loader: $914aec8743edd630$var$j6,
    menu: $914aec8743edd630$var$F6,
    mobileLandscapePreventer: $914aec8743edd630$var$$6,
    news: $914aec8743edd630$var$L6,
    poi: $914aec8743edd630$var$N6,
    suggestion: $914aec8743edd630$var$B6,
    template: $914aec8743edd630$var$q6,
    anghello: $914aec8743edd630$var$z6,
    microphone: $914aec8743edd630$var$U6,
    position: $914aec8743edd630$var$V6,
    veille: $914aec8743edd630$var$G6,
    weather: $914aec8743edd630$var$W6,
    GDPR: $914aec8743edd630$var$H6
}, $914aec8743edd630$var$Q6 = {
    abort: "peruuta",
    all: "kaikki",
    back: "takaisin",
    close: "kiinni",
    continue: "Jatkaa",
    download: "ladata",
    downloadsheet: "lataa t\xe4m\xe4 taulukko",
    downloadsheetmobile: "lataa t\xe4m\xe4 taulukko \xe4lypuhelimeen",
    filter: "Suodattaa",
    history: "historiallinen",
    knowmore: "Lue lis\xe4\xe4",
    lang: "KIELET",
    menu: "valikosta",
    mode: "muoti",
    needhelp: "Tarvitsetko apua?",
    parameters: "asetukset",
    print: "Tulosta",
    printsheet: "Tulosta t\xe4m\xe4 arkki",
    result: "tulos",
    results: "tuloksia",
    singleLang: "Kieli",
    sound: "h\xe4nen",
    submit: "L\xe4het\xe4",
    subtitle: "alaotsikko",
    tutorial: "opetusohjelma",
    validate: "vahvistaa"
}, $914aec8743edd630$var$Y6 = {
    shorttitle: "H\xe4t\xe4numerot",
    samu: "S.A.M.U.",
    police: "Poliisi",
    firefighter: "palomiehi\xe4",
    general: "yleist\xe4",
    citypolice: "Paikallinen poliisi",
    hospital: "Sairaala",
    homeless: "Asunnoton (ilmainen puhelu)",
    poison: "Poison Control Center",
    emergency: "Euroopan h\xe4t\xe4tilanteita"
}, $914aec8743edd630$var$J6 = {
    title: "Tapahtui virhe",
    button: "K\xe4ynnist\xe4 sovellus uudelleen"
}, $914aec8743edd630$var$Z6 = {
    shorttitle: "historiallinen",
    title: "keskusteluhistoria"
}, $914aec8743edd630$var$X6 = {
    shorttitle: "kotisivu"
}, $914aec8743edd630$var$eA = {
    choose: "Valitse vastaus",
    noaction: "Odottaa toimintoa"
}, $914aec8743edd630$var$tA = {
    change: "vaihtaa kielt\xe4",
    select: "valitse kieli, jota haluat k\xe4ytt\xe4\xe4"
}, $914aec8743edd630$var$rA = {
    buttontext: "N\xe4yt\xe4 asiakirja",
    goto: "Mene osoitteeseen",
    click: "Klikkaa t\xe4st\xe4",
    scanQR: "skannaamalla QR-koodin",
    scanQRTile: "Skannaa QR-koodi saadaksesi selville"
}, $914aec8743edd630$var$nA = {
    loader: {
        optimal: "Optimaalisen kokemuksen saamiseksi",
        classic: "Klassisemman kokemuksen saamiseksi",
        vocal: "Puhun kasvotusten agentin kanssa.",
        text: "Olen yhteydess\xe4 v\xe4litt\xe4j\xe4\xe4n kirjallisesti."
    },
    modes: {
        vocal: "laulutila",
        text: "tekstitila"
    },
    loaderValidation: "Aloita keskustelu",
    locale: "kielen tarkistaminen",
    supported: "tuettujen kielten tarkistaminen",
    addressdata: "tietojen hakeminen"
}, $914aec8743edd630$var$iA = {
    message: "Kirjoita viestisi",
    backconversation: "takaisin keskusteluun",
    answer: " vastaa kysymyksiisi"
}, $914aec8743edd630$var$oA = {
    firstline: "Optimaalisen kokemuksen saamiseksi",
    secondline: "k\xe4\xe4nn\xe4 n\xe4ytt\xf6\xe4si"
}, $914aec8743edd630$var$aA = {
    shorttitle: "live-uutiskanava",
    warningtext: "P\xe4\xe4set uutiskanavalle, laitteesi \xe4\xe4ni aktivoituu",
    live: "el\xe4\xe4",
    continuous: "jatkuvasti"
}, $914aec8743edd630$var$sA = {
    comment: "Asiakaspalaute",
    route: "tie",
    nodata: "Mik\xe4\xe4n sis\xe4lt\xf6 ei vastaa hakuasi",
    openinghours: "Aukioloajat",
    prices: "hinnat",
    paymentmethods: "Maksutavat",
    numberofplaces: "paikkojen m\xe4\xe4r\xe4",
    openroutemobile: "avaa Google Maps -reitti \xe4lypuhelimella",
    FoodEstablishment: "Miss\xe4 sy\xf6d\xe4",
    LodgingBusiness: "Miss\xe4 nukkua",
    TouristDestination: "Mit\xe4 n\xe4hd\xe4",
    TouristAttraction: "Mit\xe4 tehd\xe4",
    Product: "Paikalliset tuotteet",
    Service: "Palvelut",
    Event: "Tapahtumat",
    City: "kaupungit",
    Wine: "Viinit"
}, $914aec8743edd630$var$uA = {
    consult: "Tarkista",
    thetutorial: "opetusohjelma"
}, $914aec8743edd630$var$cA = {
    reset: "nollaa kaikki",
    showresults: "N\xe4yt\xe4 tulokset",
    suggestiontitle: "Hakuehdotukset",
    reminder: `\xc4l\xe4 unohda, 
 voin vastata kysymyksiisi.`
}, $914aec8743edd630$var$lA = {
    listening: "Se on sinusta kiinni, kuuntelen...",
    correct: "Korjata",
    dontknow: "En tied\xe4"
}, $914aec8743edd630$var$dA = {
    allow: "Salli selaimesi k\xe4ytt\xe4\xe4 mikrofonia jatkaaksesi.",
    rejected: "Olet kielt\xe4nyt p\xe4\xe4syn mikrofonille.",
    instructions: "\xc4\xe4nitilassa k\xe4ytt\xe4mist\xe4 varten salli selaimesi k\xe4ytt\xe4\xe4 mikrofonia.",
    listening: "Min\xe4 kuuntelen",
    trigger: "Napsauta tai sano",
    triggerwithoutname: "Napauta puhuaksesi"
}, $914aec8743edd630$var$fA = {
    rejected: "Olet hyl\xe4nnyt p\xe4\xe4syn sijaintiisi.",
    instructions: "Jotta voit k\xe4ytt\xe4\xe4 s\xe4\xe4dataa tai interaktiivista karttaa, anna selaimelle lupa p\xe4\xe4st\xe4 sijaintiisi."
}, $914aec8743edd630$var$hA = {
    calltoaction: "Paina n\xe4ytt\xf6\xe4 aloittaaksesi",
    emptyveille: "Napsauta tai paina n\xe4ytt\xf6\xe4..."
}, $914aec8743edd630$var$pA = {
    shorttitle: "S\xe4\xe4tiedotus",
    attribution: "S\xe4\xe4tiedot toimittanut Open-Meteo.com"
}, $914aec8743edd630$var$mA = {
    title: "botille l\xe4hetettyjen henkil\xf6tietojen k\xe4sittely",
    message: `hyv\xe4ksym\xe4ll\xe4 t\xe4m\xe4n dialogin suostut siihen, ett\xe4 kaikki chatbotille l\xe4hetetyt tiedot voidaan k\xe4ytt\xe4\xe4 ty\xf6kalun k\xe4yt\xf6n analysointiin ja tietopohjan rikastamiseen.

Keskustelusi s\xe4ilytet\xe4\xe4n 6 kuukautta ennen poistamista.`,
    link: "linkki tietosuojak\xe4yt\xe4nt\xf6jen tarkasteluun",
    buttonAccept: "ymm\xe4rr\xe4n ja hyv\xe4ksyn",
    buttonRefuse: "kielt\xe4ydyn",
    messageAccepted: "suostumuksesi on otettu huomioon",
    messageRefused: "kielt\xe4ytymisesi on otettu huomioon"
}, $914aec8743edd630$var$gA = {
    1: "kotisivu",
    2: "live-uutiskanava",
    3: "S\xe4\xe4tiedotus",
    4: "H\xe4t\xe4numerot",
    1e3: "historiallinen",
    1001: "opetusohjelma",
    common: $914aec8743edd630$var$Q6,
    emergency: $914aec8743edd630$var$Y6,
    error: $914aec8743edd630$var$J6,
    history: $914aec8743edd630$var$Z6,
    home: $914aec8743edd630$var$X6,
    inputs: $914aec8743edd630$var$eA,
    language: $914aec8743edd630$var$tA,
    link: $914aec8743edd630$var$rA,
    loader: $914aec8743edd630$var$nA,
    menu: $914aec8743edd630$var$iA,
    mobileLandscapePreventer: $914aec8743edd630$var$oA,
    news: $914aec8743edd630$var$aA,
    poi: $914aec8743edd630$var$sA,
    suggestion: $914aec8743edd630$var$uA,
    template: $914aec8743edd630$var$cA,
    anghello: $914aec8743edd630$var$lA,
    microphone: $914aec8743edd630$var$dA,
    position: $914aec8743edd630$var$fA,
    veille: $914aec8743edd630$var$hA,
    weather: $914aec8743edd630$var$pA,
    GDPR: $914aec8743edd630$var$mA
}, $914aec8743edd630$var$bA = {
    abort: "annuler",
    all: "tous",
    back: "retour",
    close: "fermer",
    continue: "continuer",
    download: "t\xe9l\xe9charger",
    downloadsheet: "t\xe9l\xe9charger cette fiche",
    downloadsheetmobile: "t\xe9l\xe9charger cette fiche sur mobile",
    filter: "filtrer",
    history: "historique",
    knowmore: "En savoir +",
    lang: "langues",
    menu: "menu",
    mode: "mode",
    needhelp: "Besoin d'aide ?",
    parameters: "param\xe8tres",
    print: "imprimer",
    printsheet: "imprimer cette fiche",
    result: "r\xe9sultat",
    results: "r\xe9sultats",
    singleLang: "langue",
    sound: "son",
    submit: "valider",
    subtitle: "sous-titre",
    tutorial: "tutoriel",
    validate: "valider"
}, $914aec8743edd630$var$vA = {
    shorttitle: "num\xe9ros d'urgence",
    samu: "samu",
    police: "police",
    firefighter: "pompiers",
    general: "g\xe9n\xe9ral",
    citypolice: "Police municipale",
    hospital: "H\xf4pital",
    homeless: "Sans abris (appel gratuit)",
    poison: "Centre anti-poison",
    emergency: "Urgences europ\xe9ennes"
}, $914aec8743edd630$var$yA = {
    title: "une erreur est survenue",
    button: "Relancer l'application"
}, $914aec8743edd630$var$wA = {
    shorttitle: "historique",
    title: "historique de conversation"
}, $914aec8743edd630$var$_A = {
    shorttitle: "accueil"
}, $914aec8743edd630$var$kA = {
    choose: "Choisissez une r\xe9ponse",
    noaction: "Une action est attendue"
}, $914aec8743edd630$var$xA = {
    change: "changer la langue",
    select: "s\xe9lectionnez la langue de votre choix"
}, $914aec8743edd630$var$SA = {
    buttontext: "Voir le document",
    goto: "Acc\xe9der \xe0 l'adresse",
    click: "Cliquez-ici",
    scanQR: "en scannant le QrCode",
    scanQRTile: "Scanner le QR Code pour d\xe9couvrir"
}, $914aec8743edd630$var$EA = {
    loader: {
        optimal: "Pour une exp\xe9rience optimale,",
        classic: "Pour une exp\xe9rience plus classique,",
        vocal: "j'\xe9change de vive voix avec l'agent.",
        text: "j'\xe9change \xe0 l'\xe9crit avec l'agent."
    },
    modes: {
        vocal: "mode vocal",
        text: "mode texte"
    },
    loaderValidation: "D\xe9marrer la conversation",
    locale: "v\xe9rification de la langue",
    supported: "v\xe9rification des langues disponibles",
    store: "cr\xe9ation du store",
    directline: "connection au directline",
    ponyfill: "cr\xe9ation du ponyfill",
    addressdata: "r\xe9cup\xe9ration des donn\xe9es"
}, $914aec8743edd630$var$AA = {
    message: "Saisissez votre message",
    backconversation: "retour \xe0 la conversation",
    answer: " r\xe9pond \xe0 vos questions"
}, $914aec8743edd630$var$TA = {
    firstline: "Pour une exp\xe9rience optimale,",
    secondline: "basculez votre \xe9cran"
}, $914aec8743edd630$var$CA = {
    warningtext: "Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9",
    live: "direct",
    continuous: "en continu",
    shorttitle: "cha\xeene info live"
}, $914aec8743edd630$var$RA = {
    comment: "avis clients",
    route: "y Aller",
    nodata: "Aucun contenu ne correspond \xe0 votre recherche",
    openinghours: "Horaires",
    prices: "Tarifs",
    paymentmethods: "Modes de paiement",
    numberofplaces: "nombre de couverts",
    openroutemobile: "ouvrir l'itin\xe9raire Google Maps sur mobile",
    FoodEstablishment: "O\xf9 manger",
    LodgingBusiness: "O\xf9 dormir",
    TouristDestination: "A voir",
    TouristAttraction: "A faire",
    Product: "Produits locaux",
    Service: "Services",
    Event: "Ev\xe8nements",
    City: "Villes",
    Wine: "Vins"
}, $914aec8743edd630$var$OA = {
    consult: "Consultez",
    thetutorial: "le tutoriel"
}, $914aec8743edd630$var$DA = {
    reset: "effacer tout",
    showresults: "Afficher les r\xe9sultats",
    suggestiontitle: "Suggestions de recherches",
    reminder: `N'oubliez pas,
 je peux r\xe9pondre \xe0 vos questions.`
}, $914aec8743edd630$var$PA = {
    title: "traitement des donn\xe9es personnelles transmises au bot",
    message: `en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d'analyse de l'utilisation de l'outil et d'enrichissement de la base de connaissance.

Vos conversations sont conserv\xe9es 6 mois avant de faire l'objet d'une suppression.`,
    link: "lien pour consulter les politiques de confidentialit\xe9",
    buttonAccept: "j'ai compris et j'accepte",
    buttonRefuse: "je refuse",
    messageAccepted: "votre consentement est bien pris en compte",
    messageRefused: "votre refus est bien pris en compte"
}, $914aec8743edd630$var$IA = {
    listening: "C'est \xe0 vous, je vous \xe9coute...",
    correct: "Corriger",
    dontknow: "Je ne sais pas"
}, $914aec8743edd630$var$MA = {
    allow: "Veuillez autoriser votre navigateur \xe0 acc\xe9der au micro pour continuer.",
    rejected: "Vous avez refus\xe9 l'acc\xe8s au micro.",
    instructions: "Pour utiliser le mode vocal, veuillez autoriser votre navigateur \xe0 acc\xe9der au micro.",
    listening: "Je vous \xe9coute",
    trigger: "Appuyez ou dites",
    triggerwithoutname: "Appuyez pour parler"
}, $914aec8743edd630$var$jA = {
    rejected: "Vous avez refus\xe9 l'acc\xe8s \xe0 votre position GPS.",
    instructions: "Pour acc\xe9der aux donn\xe9es m\xe9t\xe9orologiques ou \xe0 la carte interactive, veuillez autoriser votre navigateur \xe0 acc\xe9der \xe0 votre position GPS."
}, $914aec8743edd630$var$FA = {
    calltoaction: "Appuyez sur l'\xe9cran pour commencer",
    emptyveille: "Cliquez ou appuyez sur l'\xe9cran..."
}, $914aec8743edd630$var$$A = {
    attribution: "Donn\xe9es m\xe9t\xe9orologiques fournies par Open-Meteo.com",
    shorttitle: "m\xe9t\xe9o"
}, $914aec8743edd630$var$LA = {
    shorttitle: "tutoriel"
}, $914aec8743edd630$var$NA = {
    1: "accueil",
    2: "cha\xeene info live",
    3: "m\xe9t\xe9o",
    4: "num\xe9ros d'urgence",
    1e3: "historique",
    1001: "tutoriel",
    common: $914aec8743edd630$var$bA,
    emergency: $914aec8743edd630$var$vA,
    error: $914aec8743edd630$var$yA,
    history: $914aec8743edd630$var$wA,
    home: $914aec8743edd630$var$_A,
    inputs: $914aec8743edd630$var$kA,
    language: $914aec8743edd630$var$xA,
    link: $914aec8743edd630$var$SA,
    loader: $914aec8743edd630$var$EA,
    menu: $914aec8743edd630$var$AA,
    mobileLandscapePreventer: $914aec8743edd630$var$TA,
    news: $914aec8743edd630$var$CA,
    poi: $914aec8743edd630$var$RA,
    suggestion: $914aec8743edd630$var$OA,
    template: $914aec8743edd630$var$DA,
    GDPR: $914aec8743edd630$var$PA,
    anghello: $914aec8743edd630$var$IA,
    microphone: $914aec8743edd630$var$MA,
    position: $914aec8743edd630$var$jA,
    veille: $914aec8743edd630$var$FA,
    weather: $914aec8743edd630$var$$A,
    tutorial: $914aec8743edd630$var$LA
}, $914aec8743edd630$var$BA = {
    abort: "annuler",
    all: "tous",
    back: "retour",
    close: "fermer",
    continue: "continuer",
    download: "t\xe9l\xe9charger",
    downloadsheet: "t\xe9l\xe9charger cette fiche",
    downloadsheetmobile: "t\xe9l\xe9charger cette fiche sur mobile",
    filter: "filtrer",
    history: "historique",
    knowmore: "En savoir +",
    lang: "langues",
    menu: "menu",
    mode: "mode",
    needhelp: "Besoin d'aide ?",
    parameters: "param\xe8tres",
    print: "imprimer",
    printsheet: "imprimer cette fiche",
    result: "r\xe9sultat",
    results: "r\xe9sultats",
    singleLang: "langue",
    sound: "son",
    submit: "valider",
    subtitle: "sous-titre",
    tutorial: "tutoriel",
    validate: "valider"
}, $914aec8743edd630$var$qA = {
    shorttitle: "num\xe9ros d'urgence",
    samu: "samu",
    police: "police",
    firefighter: "pompiers",
    general: "g\xe9n\xe9ral",
    citypolice: "Police municipale",
    hospital: "H\xf4pital",
    homeless: "Sans abris (appel gratuit)",
    poison: "Centre anti-poison",
    emergency: "Urgences europ\xe9ennes"
}, $914aec8743edd630$var$zA = {
    title: "une erreur est survenue",
    button: "Relancer l'application"
}, $914aec8743edd630$var$UA = {
    shorttitle: "historique",
    title: "historique de conversation"
}, $914aec8743edd630$var$VA = {
    shorttitle: "accueil"
}, $914aec8743edd630$var$GA = {
    choose: "Choisissez une r\xe9ponse",
    noaction: "Une action est attendue"
}, $914aec8743edd630$var$WA = {
    change: "changer la langue",
    select: "s\xe9lectionnez la langue de votre choix"
}, $914aec8743edd630$var$HA = {
    buttontext: "Voir le document",
    goto: "Acc\xe9der \xe0 l'adresse",
    click: "Cliquez-ici",
    scanQR: "en scannant le QrCode",
    scanQRTile: "Scanner le QR Code pour d\xe9couvrir"
}, $914aec8743edd630$var$KA = {
    loader: {
        optimal: "Pour une exp\xe9rience optimale,",
        classic: "Pour une exp\xe9rience plus classique,",
        vocal: "j'\xe9change de vive voix avec l'agent.",
        text: "j'\xe9change \xe0 l'\xe9crit avec l'agent."
    },
    modes: {
        vocal: "mode vocal",
        text: "mode texte"
    },
    loaderValidation: "D\xe9marrer la conversation",
    locale: "v\xe9rification de la langue",
    supported: "v\xe9rification des langues disponibles",
    store: "cr\xe9ation du store",
    directline: "connection au directline",
    ponyfill: "cr\xe9ation du ponyfill",
    addressdata: "r\xe9cup\xe9ration des donn\xe9es"
}, $914aec8743edd630$var$QA = {
    message: "Saisissez votre message",
    backconversation: "retour \xe0 la conversation",
    answer: " r\xe9pond \xe0 vos questions"
}, $914aec8743edd630$var$YA = {
    firstline: "Pour une exp\xe9rience optimale,",
    secondline: "basculez votre \xe9cran"
}, $914aec8743edd630$var$JA = {
    warningtext: "Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9",
    live: "direct",
    continuous: "en continu",
    shorttitle: "cha\xeene info live"
}, $914aec8743edd630$var$ZA = {
    comment: "avis clients",
    route: "y Aller",
    nodata: "Aucun contenu ne correspond \xe0 votre recherche",
    openinghours: "Horaires",
    prices: "Tarifs",
    paymentmethods: "Modes de paiement",
    numberofplaces: "nombre de couverts",
    openroutemobile: "ouvrir l'itin\xe9raire Google Maps sur mobile",
    FoodEstablishment: "O\xf9 manger",
    LodgingBusiness: "O\xf9 dormir",
    TouristDestination: "A voir",
    TouristAttraction: "A faire",
    Product: "Produits locaux",
    Service: "Services",
    Event: "Ev\xe8nements",
    City: "Villes",
    Wine: "Vins"
}, $914aec8743edd630$var$XA = {
    consult: "Consultez",
    thetutorial: "le tutoriel"
}, $914aec8743edd630$var$eT = {
    reset: "effacer tout",
    showresults: "Afficher les r\xe9sultats",
    suggestiontitle: "Suggestions de recherches",
    reminder: `N'oubliez pas,
 je peux r\xe9pondre \xe0 vos questions.`
}, $914aec8743edd630$var$tT = {
    title: "traitement des donn\xe9es personnelles transmises au bot",
    message: `en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d'analyse de l'utilisation de l'outil et d'enrichissement de la base de connaissance.

Vos conversations sont conserv\xe9es 6 mois avant de faire l'objet d'une suppression.`,
    link: "lien pour consulter les politiques de confidentialit\xe9",
    buttonAccept: "j'ai compris et j'accepte",
    buttonRefuse: "je refuse",
    messageAccepted: "votre consentement est bien pris en compte",
    messageRefused: "votre refus est bien pris en compte"
}, $914aec8743edd630$var$rT = {
    listening: "C'est \xe0 vous, je vous \xe9coute...",
    correct: "Corriger",
    dontknow: "Je ne sais pas"
}, $914aec8743edd630$var$nT = {
    allow: "Veuillez autoriser votre navigateur \xe0 acc\xe9der au micro pour continuer.",
    rejected: "Vous avez refus\xe9 l'acc\xe8s au micro.",
    instructions: "Pour utiliser le mode vocal, veuillez autoriser votre navigateur \xe0 acc\xe9der au micro.",
    listening: "Je vous \xe9coute",
    trigger: "Appuyez ou dites",
    triggerwithoutname: "Appuyez pour parler"
}, $914aec8743edd630$var$iT = {
    rejected: "Vous avez refus\xe9 l'acc\xe8s \xe0 votre position GPS.",
    instructions: "Pour acc\xe9der aux donn\xe9es m\xe9t\xe9orologiques ou \xe0 la carte interactive, veuillez autoriser votre navigateur \xe0 acc\xe9der \xe0 votre position GPS."
}, $914aec8743edd630$var$oT = {
    calltoaction: "Appuyez sur l'\xe9cran pour commencer",
    emptyveille: "Cliquez ou appuyez sur l'\xe9cran..."
}, $914aec8743edd630$var$aT = {
    attribution: "Donn\xe9es m\xe9t\xe9orologiques fournies par Open-Meteo.com",
    shorttitle: "m\xe9t\xe9o"
}, $914aec8743edd630$var$sT = {
    shorttitle: "tutoriel"
}, $914aec8743edd630$var$uT = {
    1: "accueil",
    2: "cha\xeene info live",
    3: "m\xe9t\xe9o",
    4: "num\xe9ros d'urgence",
    1e3: "historique",
    1001: "tutoriel",
    common: $914aec8743edd630$var$BA,
    emergency: $914aec8743edd630$var$qA,
    error: $914aec8743edd630$var$zA,
    history: $914aec8743edd630$var$UA,
    home: $914aec8743edd630$var$VA,
    inputs: $914aec8743edd630$var$GA,
    language: $914aec8743edd630$var$WA,
    link: $914aec8743edd630$var$HA,
    loader: $914aec8743edd630$var$KA,
    menu: $914aec8743edd630$var$QA,
    mobileLandscapePreventer: $914aec8743edd630$var$YA,
    news: $914aec8743edd630$var$JA,
    poi: $914aec8743edd630$var$ZA,
    suggestion: $914aec8743edd630$var$XA,
    template: $914aec8743edd630$var$eT,
    GDPR: $914aec8743edd630$var$tT,
    anghello: $914aec8743edd630$var$rT,
    microphone: $914aec8743edd630$var$nT,
    position: $914aec8743edd630$var$iT,
    veille: $914aec8743edd630$var$oT,
    weather: $914aec8743edd630$var$aT,
    tutorial: $914aec8743edd630$var$sT
}, $914aec8743edd630$var$cT = {
    abort: "annuler",
    all: "tous",
    back: "retour",
    close: "fermer",
    continue: "continuer",
    download: "t\xe9l\xe9charger",
    downloadsheet: "t\xe9l\xe9charger cette fiche",
    downloadsheetmobile: "t\xe9l\xe9charger cette fiche sur mobile",
    filter: "filtrer",
    history: "historique",
    knowmore: "En savoir +",
    lang: "langues",
    menu: "menu",
    mode: "mode",
    needhelp: "Besoin d'aide ?",
    parameters: "param\xe8tres",
    print: "imprimer",
    printsheet: "imprimer cette fiche",
    result: "r\xe9sultat",
    results: "r\xe9sultats",
    singleLang: "langue",
    sound: "son",
    submit: "valider",
    subtitle: "sous-titre",
    tutorial: "tutoriel",
    validate: "valider"
}, $914aec8743edd630$var$lT = {
    shorttitle: "num\xe9ros d'urgence",
    samu: "samu",
    police: "police",
    firefighter: "pompiers",
    general: "g\xe9n\xe9ral",
    citypolice: "Police municipale",
    hospital: "H\xf4pital",
    homeless: "Sans abris (appel gratuit)",
    poison: "Centre anti-poison",
    emergency: "Urgences europ\xe9ennes"
}, $914aec8743edd630$var$dT = {
    title: "une erreur est survenue",
    button: "Relancer l'application"
}, $914aec8743edd630$var$fT = {
    shorttitle: "historique",
    title: "historique de conversation"
}, $914aec8743edd630$var$hT = {
    shorttitle: "accueil"
}, $914aec8743edd630$var$pT = {
    choose: "Choisissez une r\xe9ponse",
    noaction: "Une action est attendue"
}, $914aec8743edd630$var$mT = {
    change: "changer la langue",
    select: "s\xe9lectionnez la langue de votre choix"
}, $914aec8743edd630$var$gT = {
    buttontext: "Voir le document",
    goto: "Acc\xe9der \xe0 l'adresse",
    click: "Cliquez-ici",
    scanQR: "en scannant le QrCode",
    scanQRTile: "Scanner le QR Code pour d\xe9couvrir"
}, $914aec8743edd630$var$bT = {
    loader: {
        optimal: "Pour une exp\xe9rience optimale,",
        classic: "Pour une exp\xe9rience plus classique,",
        vocal: "j'\xe9change de vive voix avec l'agent.",
        text: "j'\xe9change \xe0 l'\xe9crit avec l'agent."
    },
    modes: {
        vocal: "mode vocal",
        text: "mode texte"
    },
    loaderValidation: "D\xe9marrer la conversation",
    locale: "v\xe9rification de la langue",
    supported: "v\xe9rification des langues disponibles",
    store: "cr\xe9ation du store",
    directline: "connection au directline",
    ponyfill: "cr\xe9ation du ponyfill",
    addressdata: "r\xe9cup\xe9ration des donn\xe9es"
}, $914aec8743edd630$var$vT = {
    message: "Saisissez votre message",
    backconversation: "retour \xe0 la conversation",
    answer: " r\xe9pond \xe0 vos questions"
}, $914aec8743edd630$var$yT = {
    firstline: "Pour une exp\xe9rience optimale,",
    secondline: "basculez votre \xe9cran"
}, $914aec8743edd630$var$wT = {
    warningtext: "Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9",
    live: "direct",
    continuous: "en continu",
    shorttitle: "cha\xeene info live"
}, $914aec8743edd630$var$_T = {
    comment: "avis clients",
    route: "y Aller",
    nodata: "Aucun contenu ne correspond \xe0 votre recherche",
    openinghours: "Horaires",
    prices: "Tarifs",
    paymentmethods: "Modes de paiement",
    numberofplaces: "nombre de couverts",
    openroutemobile: "ouvrir l'itin\xe9raire Google Maps sur mobile",
    FoodEstablishment: "O\xf9 manger",
    LodgingBusiness: "O\xf9 dormir",
    TouristDestination: "A voir",
    TouristAttraction: "A faire",
    Product: "Produits locaux",
    Service: "Services",
    Event: "Ev\xe8nements",
    City: "Villes",
    Wine: "Vins"
}, $914aec8743edd630$var$kT = {
    consult: "Consultez",
    thetutorial: "le tutoriel"
}, $914aec8743edd630$var$xT = {
    reset: "effacer tout",
    showresults: "Afficher les r\xe9sultats",
    suggestiontitle: "Suggestions de recherches",
    reminder: `N'oubliez pas,
 je peux r\xe9pondre \xe0 vos questions.`
}, $914aec8743edd630$var$ST = {
    title: "traitement des donn\xe9es personnelles transmises au bot",
    message: `en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d'analyse de l'utilisation de l'outil et d'enrichissement de la base de connaissance.

Vos conversations sont conserv\xe9es 6 mois avant de faire l'objet d'une suppression.`,
    link: "lien pour consulter les politiques de confidentialit\xe9",
    buttonAccept: "j'ai compris et j'accepte",
    buttonRefuse: "je refuse",
    messageAccepted: "votre consentement est bien pris en compte",
    messageRefused: "votre refus est bien pris en compte"
}, $914aec8743edd630$var$ET = {
    listening: "C'est \xe0 vous, je vous \xe9coute...",
    correct: "Corriger",
    dontknow: "Je ne sais pas"
}, $914aec8743edd630$var$AT = {
    allow: "Veuillez autoriser votre navigateur \xe0 acc\xe9der au micro pour continuer.",
    rejected: "Vous avez refus\xe9 l'acc\xe8s au micro.",
    instructions: "Pour utiliser le mode vocal, veuillez autoriser votre navigateur \xe0 acc\xe9der au micro.",
    listening: "Je vous \xe9coute",
    trigger: "Appuyez ou dites",
    triggerwithoutname: "Appuyez pour parler"
}, $914aec8743edd630$var$TT = {
    rejected: "Vous avez refus\xe9 l'acc\xe8s \xe0 votre position GPS.",
    instructions: "Pour acc\xe9der aux donn\xe9es m\xe9t\xe9orologiques ou \xe0 la carte interactive, veuillez autoriser votre navigateur \xe0 acc\xe9der \xe0 votre position GPS."
}, $914aec8743edd630$var$CT = {
    calltoaction: "Appuyez sur l'\xe9cran pour commencer",
    emptyveille: "Cliquez ou appuyez sur l'\xe9cran..."
}, $914aec8743edd630$var$RT = {
    attribution: "Donn\xe9es m\xe9t\xe9orologiques fournies par Open-Meteo.com",
    shorttitle: "m\xe9t\xe9o"
}, $914aec8743edd630$var$OT = {
    shorttitle: "tutoriel"
}, $914aec8743edd630$var$DT = {
    1: "accueil",
    2: "cha\xeene info live",
    3: "m\xe9t\xe9o",
    4: "num\xe9ros d'urgence",
    1e3: "historique",
    1001: "tutoriel",
    common: $914aec8743edd630$var$cT,
    emergency: $914aec8743edd630$var$lT,
    error: $914aec8743edd630$var$dT,
    history: $914aec8743edd630$var$fT,
    home: $914aec8743edd630$var$hT,
    inputs: $914aec8743edd630$var$pT,
    language: $914aec8743edd630$var$mT,
    link: $914aec8743edd630$var$gT,
    loader: $914aec8743edd630$var$bT,
    menu: $914aec8743edd630$var$vT,
    mobileLandscapePreventer: $914aec8743edd630$var$yT,
    news: $914aec8743edd630$var$wT,
    poi: $914aec8743edd630$var$_T,
    suggestion: $914aec8743edd630$var$kT,
    template: $914aec8743edd630$var$xT,
    GDPR: $914aec8743edd630$var$ST,
    anghello: $914aec8743edd630$var$ET,
    microphone: $914aec8743edd630$var$AT,
    position: $914aec8743edd630$var$TT,
    veille: $914aec8743edd630$var$CT,
    weather: $914aec8743edd630$var$RT,
    tutorial: $914aec8743edd630$var$OT
}, $914aec8743edd630$var$PT = {
    abort: "annuler",
    all: "tous",
    back: "retour",
    close: "fermer",
    continue: "continuer",
    download: "t\xe9l\xe9charger",
    downloadsheet: "t\xe9l\xe9charger cette fiche",
    downloadsheetmobile: "t\xe9l\xe9charger cette fiche sur mobile",
    filter: "filtrer",
    history: "historique",
    knowmore: "En savoir +",
    lang: "langues",
    menu: "menu",
    mode: "mode",
    needhelp: "Besoin d'aide ?",
    parameters: "param\xe8tres",
    print: "imprimer",
    printsheet: "imprimer cette fiche",
    result: "r\xe9sultat",
    results: "r\xe9sultats",
    singleLang: "langue",
    sound: "son",
    submit: "valider",
    subtitle: "sous-titre",
    tutorial: "tutoriel",
    validate: "valider"
}, $914aec8743edd630$var$IT = {
    shorttitle: "num\xe9ros d'urgence",
    samu: "samu",
    police: "police",
    firefighter: "pompiers",
    general: "g\xe9n\xe9ral",
    citypolice: "Police municipale",
    hospital: "H\xf4pital",
    homeless: "Sans abris (appel gratuit)",
    poison: "Centre anti-poison",
    emergency: "Urgences europ\xe9ennes"
}, $914aec8743edd630$var$MT = {
    title: "une erreur est survenue",
    button: "Relancer l'application"
}, $914aec8743edd630$var$jT = {
    shorttitle: "historique",
    title: "historique de conversation"
}, $914aec8743edd630$var$FT = {
    shorttitle: "accueil"
}, $914aec8743edd630$var$$T = {
    choose: "Choisissez une r\xe9ponse",
    noaction: "Une action est attendue"
}, $914aec8743edd630$var$LT = {
    change: "changer la langue",
    select: "s\xe9lectionnez la langue de votre choix"
}, $914aec8743edd630$var$NT = {
    buttontext: "Voir le document",
    goto: "Acc\xe9der \xe0 l'adresse",
    click: "Cliquez-ici",
    scanQR: "en scannant le QrCode",
    scanQRTile: "Scanner le QR Code pour d\xe9couvrir"
}, $914aec8743edd630$var$BT = {
    loader: {
        optimal: "Pour une exp\xe9rience optimale,",
        classic: "Pour une exp\xe9rience plus classique,",
        vocal: "j'\xe9change de vive voix avec l'agent.",
        text: "j'\xe9change \xe0 l'\xe9crit avec l'agent."
    },
    modes: {
        vocal: "mode vocal",
        text: "mode texte"
    },
    loaderValidation: "D\xe9marrer la conversation",
    locale: "v\xe9rification de la langue",
    supported: "v\xe9rification des langues disponibles",
    store: "cr\xe9ation du store",
    directline: "connection au directline",
    ponyfill: "cr\xe9ation du ponyfill",
    addressdata: "r\xe9cup\xe9ration des donn\xe9es"
}, $914aec8743edd630$var$qT = {
    message: "Saisissez votre message",
    backconversation: "retour \xe0 la conversation",
    answer: " r\xe9pond \xe0 vos questions"
}, $914aec8743edd630$var$zT = {
    firstline: "Pour une exp\xe9rience optimale,",
    secondline: "basculez votre \xe9cran"
}, $914aec8743edd630$var$UT = {
    shorttitle: "cha\xeene info live",
    warningtext: "Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9",
    live: "direct",
    continuous: "en continu"
}, $914aec8743edd630$var$VT = {
    comment: "avis clients",
    route: "y Aller",
    nodata: "Aucun contenu ne correspond \xe0 votre recherche",
    openinghours: "Horaires",
    prices: "Tarifs",
    paymentmethods: "Modes de paiement",
    numberofplaces: "nombre de couverts",
    openroutemobile: "ouvrir l'itin\xe9raire Google Maps sur mobile",
    FoodEstablishment: "O\xf9 manger",
    LodgingBusiness: "O\xf9 dormir",
    TouristDestination: "A voir",
    TouristAttraction: "A faire",
    Product: "Produits locaux",
    Service: "Services",
    Event: "Ev\xe8nements",
    City: "Villes",
    Wine: "Vins"
}, $914aec8743edd630$var$GT = {
    consult: "Consultez",
    thetutorial: "le tutoriel"
}, $914aec8743edd630$var$WT = {
    reset: "effacer tout",
    showresults: "Afficher les r\xe9sultats",
    suggestiontitle: "Suggestions de recherches",
    reminder: `N'oubliez pas,
 je peux r\xe9pondre \xe0 vos questions.`
}, $914aec8743edd630$var$HT = {
    shorttitle: "tutoriel"
}, $914aec8743edd630$var$KT = {
    title: "traitement des donn\xe9es personnelles transmises au bot",
    message: `en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d'analyse de l'utilisation de l'outil et d'enrichissement de la base de connaissance.

Vos conversations sont conserv\xe9es 6 mois avant de faire l'objet d'une suppression.`,
    link: "lien pour consulter les politiques de confidentialit\xe9",
    buttonAccept: "j'ai compris et j'accepte",
    buttonRefuse: "je refuse",
    messageAccepted: "votre consentement est bien pris en compte",
    messageRefused: "votre refus est bien pris en compte"
}, $914aec8743edd630$var$QT = {
    listening: "C'est \xe0 vous, je vous \xe9coute...",
    correct: "Corriger",
    dontknow: "Je ne sais pas"
}, $914aec8743edd630$var$YT = {
    allow: "Veuillez autoriser votre navigateur \xe0 acc\xe9der au micro pour continuer.",
    rejected: "Vous avez refus\xe9 l'acc\xe8s au micro.",
    instructions: "Pour utiliser le mode vocal, veuillez autoriser votre navigateur \xe0 acc\xe9der au micro.",
    listening: "Je vous \xe9coute",
    trigger: "Appuyez ou dites",
    triggerwithoutname: "Appuyez pour parler"
}, $914aec8743edd630$var$JT = {
    rejected: "Vous avez refus\xe9 l'acc\xe8s \xe0 votre position GPS.",
    instructions: "Pour acc\xe9der aux donn\xe9es m\xe9t\xe9orologiques ou \xe0 la carte interactive, veuillez autoriser votre navigateur \xe0 acc\xe9der \xe0 votre position GPS."
}, $914aec8743edd630$var$ZT = {
    calltoaction: "Appuyez sur l'\xe9cran pour commencer",
    emptyveille: "Cliquez ou appuyez sur l'\xe9cran..."
}, $914aec8743edd630$var$XT = {
    shorttitle: "m\xe9t\xe9o",
    attribution: "Donn\xe9es m\xe9t\xe9orologiques fournies par Open-Meteo.com"
}, $914aec8743edd630$var$Hr = {
    1: "accueil",
    2: "cha\xeene info live",
    3: "m\xe9t\xe9o",
    4: "num\xe9ros d'urgence",
    1e3: "historique",
    1001: "tutoriel",
    common: $914aec8743edd630$var$PT,
    emergency: $914aec8743edd630$var$IT,
    error: $914aec8743edd630$var$MT,
    history: $914aec8743edd630$var$jT,
    home: $914aec8743edd630$var$FT,
    inputs: $914aec8743edd630$var$$T,
    language: $914aec8743edd630$var$LT,
    link: $914aec8743edd630$var$NT,
    loader: $914aec8743edd630$var$BT,
    menu: $914aec8743edd630$var$qT,
    mobileLandscapePreventer: $914aec8743edd630$var$zT,
    news: $914aec8743edd630$var$UT,
    poi: $914aec8743edd630$var$VT,
    suggestion: $914aec8743edd630$var$GT,
    template: $914aec8743edd630$var$WT,
    tutorial: $914aec8743edd630$var$HT,
    GDPR: $914aec8743edd630$var$KT,
    anghello: $914aec8743edd630$var$QT,
    microphone: $914aec8743edd630$var$YT,
    position: $914aec8743edd630$var$JT,
    veille: $914aec8743edd630$var$ZT,
    weather: $914aec8743edd630$var$XT
}, $914aec8743edd630$var$eC = {
    abort: "\u0930\u0926\u094D\u0926 \u0915\u0930\u0947\u0902",
    all: "\u0938\u092D\u0940",
    back: "\u092A\u0940\u091B\u0947",
    close: "\u092C\u0902\u0926 \u0915\u0930\u0928\u093E",
    continue: "\u091C\u093E\u0930\u0940 \u0930\u0916\u0928\u093E",
    download: "\u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0930\u0928\u093E",
    downloadsheet: "\u0907\u0938 \u0936\u0940\u091F \u0915\u094B \u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0930\u0947\u0902",
    downloadsheetmobile: "\u0907\u0938 \u0936\u0940\u091F \u0915\u094B \u0938\u094D\u092E\u093E\u0930\u094D\u091F\u092B\u094B\u0928 \u092A\u0930 \u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0930\u0947\u0902",
    filter: "\u092B\u093C\u093F\u0932\u094D\u091F\u0930",
    history: "\u0910\u0924\u093F\u0939\u093E\u0938\u093F\u0915",
    knowmore: "\u0905\u0927\u093F\u0915 \u091C\u093E\u0928\u0947\u0902",
    lang: "\u092C\u094B\u0932\u0940",
    menu: "\u092E\u0947\u0928\u094D\u092F\u0942",
    mode: "\u092A\u0939\u0928\u093E\u0935\u093E",
    needhelp: "\u092E\u0926\u0926 \u0915\u0940 \u091C\u093C\u0930\u0942\u0930\u0924 \u0939\u0948?",
    parameters: "\u0938\u092E\u093E\u092F\u094B\u091C\u0928",
    print: "\u091B\u093E\u092A",
    printsheet: "\u0907\u0938 \u0936\u0940\u091F \u0915\u094B \u092A\u094D\u0930\u093F\u0902\u091F \u0915\u0930\u0947\u0902",
    result: "\u092A\u0930\u093F\u0923\u093E\u092E",
    results: "\u092A\u0930\u093F\u0923\u093E\u092E",
    singleLang: "\u092D\u093E\u0937\u093E",
    sound: "\u0909\u0938\u0915\u0940",
    submit: "\u091C\u092E\u093E \u0915\u0930\u0928\u093E",
    subtitle: "\u0909\u092A\u0936\u0940\u0930\u094D\u0937\u0915",
    tutorial: "\u091F\u094D\u092F\u0942\u091F\u094B\u0930\u093F\u092F\u0932",
    validate: "\u092E\u093E\u0928\u094D\u092F"
}, $914aec8743edd630$var$tC = {
    shorttitle: "\u0906\u092A\u093E\u0924\u0915\u093E\u0932\u0940\u0928 \u0928\u0902\u092C\u0930",
    samu: "\u090F\u0938.\u090F.\u090F\u092E.\u092F\u0942.",
    police: "\u092A\u0941\u0932\u093F\u0938",
    firefighter: "\u0905\u0917\u094D\u0928\u093F\u0936\u092E\u0928 \u0915\u0930\u094D\u092E\u0940",
    general: "\u091C\u0928\u0930\u0932",
    citypolice: "\u0938\u094D\u0925\u093E\u0928\u0940\u092F \u092A\u0941\u0932\u093F\u0938",
    hospital: "\u0905\u0938\u094D\u092A\u0924\u093E\u0932",
    homeless: "\u092C\u0947\u0918\u0930 (\u0928\u093F\u0903\u0936\u0941\u0932\u094D\u0915 \u0915\u0949\u0932)",
    poison: "\u091C\u093C\u0939\u0930 \u0928\u093F\u092F\u0902\u0924\u094D\u0930\u0923 \u0915\u0947\u0902\u0926\u094D\u0930",
    emergency: "\u092F\u0942\u0930\u094B\u092A\u0940\u092F \u0906\u092A\u093E\u0924\u0915\u093E\u0932"
}, $914aec8743edd630$var$rC = {
    title: "\u090F\u0915 \u0917\u0932\u0924\u0940 \u0939\u0941\u0908 \u0939\u0948",
    button: "\u090F\u092A\u094D\u0932\u093F\u0915\u0947\u0936\u0928 \u0915\u094B \u092A\u0941\u0928\u0903 \u0932\u0949\u0928\u094D\u091A \u0915\u0930\u0947\u0902"
}, $914aec8743edd630$var$nC = {
    shorttitle: "\u0910\u0924\u093F\u0939\u093E\u0938\u093F\u0915",
    title: "\u092C\u093E\u0924\u091A\u0940\u0924 \u0915\u093E \u0907\u0924\u093F\u0939\u093E\u0938"
}, $914aec8743edd630$var$iC = {
    shorttitle: "\u0939\u094B\u092E \u092A\u0947\u091C"
}, $914aec8743edd630$var$oC = {
    choose: "\u090F\u0915 \u0909\u0924\u094D\u0924\u0930 \u091A\u0941\u0928\u0947\u0902",
    noaction: "\u0915\u093E\u0930\u094D\u0930\u0935\u093E\u0908 \u0915\u0940 \u092A\u094D\u0930\u0924\u0940\u0915\u094D\u0937\u093E \u0939\u0948"
}, $914aec8743edd630$var$aC = {
    change: "\u092D\u093E\u0937\u093E \u092C\u0926\u0932\u094B",
    select: "\u0935\u0939 \u092D\u093E\u0937\u093E \u091A\u0941\u0928\u0947\u0902 \u091C\u093F\u0938\u0915\u093E \u0906\u092A \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902"
}, $914aec8743edd630$var$sC = {
    buttontext: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0926\u0947\u0916\u0947\u0902",
    goto: "\u092A\u0924\u0947 \u092A\u0930 \u091C\u093E\u090F\u0902",
    click: "\u092F\u0939\u093E\u0901 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902",
    scanQR: "QrCode \u0915\u094B \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0915\u0947",
    scanQRTile: "\u0915\u094D\u092F\u0942\u0906\u0930 \u0915\u094B\u0921 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902 \u0914\u0930 \u091C\u093E\u0928\u0947\u0902"
}, $914aec8743edd630$var$uC = {
    loader: {
        optimal: "\u0938\u0930\u094D\u0935\u094B\u0924\u094D\u0924\u092E \u0905\u0928\u0941\u092D\u0935 \u0915\u0947 \u0932\u093F\u090F,",
        classic: "\u0905\u0927\u093F\u0915 \u0915\u094D\u0932\u093E\u0938\u093F\u0915 \u0905\u0928\u0941\u092D\u0935 \u0915\u0947 \u0932\u093F\u090F,",
        vocal: "\u092E\u0948\u0902 \u090F\u091C\u0947\u0902\u091F \u0938\u0947 \u0906\u092E\u0928\u0947-\u0938\u093E\u092E\u0928\u0947 \u092C\u093E\u0924 \u0915\u0930\u0924\u093E \u0939\u0942\u0902\u0964",
        text: "\u092E\u0948\u0902 \u090F\u091C\u0947\u0902\u091F \u0915\u0947 \u0938\u093E\u0925 \u0932\u093F\u0916\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u0938\u0902\u0935\u093E\u0926 \u0915\u0930\u0924\u093E \u0939\u0942\u0902\u0964"
    },
    modes: {
        vocal: "\u0938\u094D\u0935\u0930 \u0935\u093F\u0927\u093E",
        text: "\u092A\u093E\u0920 \u092E\u094B\u0921"
    },
    loaderValidation: "\u092C\u093E\u0924\u091A\u0940\u0924 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902",
    locale: "\u092D\u093E\u0937\u093E \u0915\u0940 \u091C\u093E\u0901\u091A \u0915\u0930\u0928\u093E",
    supported: "\u0938\u092E\u0930\u094D\u0925\u093F\u0924 \u092D\u093E\u0937\u093E\u0913\u0902 \u0915\u0940 \u091C\u093E\u0901\u091A \u0915\u0930\u0928\u093E",
    addressdata: "\u092A\u0941\u0928: \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0921\u0947\u091F\u093E"
}, $914aec8743edd630$var$cC = {
    message: "\u0905\u092A\u0928\u093E \u0938\u0902\u0926\u0947\u0936 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902",
    backconversation: "\u092C\u093E\u0924\u091A\u0940\u0924 \u092A\u0930 \u0935\u093E\u092A\u0938",
    answer: " \u0906\u092A\u0915\u0947 \u092A\u094D\u0930\u0936\u094D\u0928\u094B\u0902 \u0915\u093E \u0909\u0924\u094D\u0924\u0930 \u0926\u0947\u0924\u093E \u0939\u0948"
}, $914aec8743edd630$var$lC = {
    firstline: "\u0938\u0930\u094D\u0935\u094B\u0924\u094D\u0924\u092E \u0905\u0928\u0941\u092D\u0935 \u0915\u0947 \u0932\u093F\u090F,",
    secondline: "\u0905\u092A\u0928\u0940 \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0932\u091F\u0947\u0902"
}, $914aec8743edd630$var$dC = {
    shorttitle: "\u0932\u093E\u0907\u0935 \u0928\u094D\u092F\u0942\u091C\u093C \u091A\u0948\u0928\u0932",
    warningtext: "\u0906\u092A \u0938\u092E\u093E\u091A\u093E\u0930 \u091A\u0948\u0928\u0932 \u0924\u0915 \u092A\u0939\u0941\u0902\u091A \u092A\u093E\u090F\u0902\u0917\u0947, \u0906\u092A\u0915\u0947 \u0921\u093F\u0935\u093E\u0907\u0938 \u092A\u0930 \u0927\u094D\u0935\u0928\u093F \u0938\u0915\u094D\u0930\u093F\u092F \u0939\u094B \u091C\u093E\u090F\u0917\u0940",
    live: "\u0930\u0939\u0928\u093E",
    continuous: "\u0932\u0917\u093E\u0924\u093E\u0930"
}, $914aec8743edd630$var$fC = {
    comment: "\u0917\u094D\u0930\u093E\u0939\u0915 \u0938\u092E\u0940\u0915\u094D\u0937\u093E",
    route: "\u0938\u0921\u093C\u0915",
    nodata: "\u0915\u094B\u0908 \u092D\u0940 \u0938\u093E\u092E\u0917\u094D\u0930\u0940 \u0906\u092A\u0915\u0940 \u0916\u094B\u091C \u0938\u0947 \u092E\u0947\u0932 \u0928\u0939\u0940\u0902 \u0916\u093E\u0924\u0940",
    openinghours: "\u0916\u0941\u0932\u0928\u0947 \u0915\u093E \u0938\u092E\u092F",
    prices: "\u0915\u0940\u092E\u0924\u094B\u0902",
    paymentmethods: "\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0940 \u0935\u093F\u0927\u093F",
    numberofplaces: "\u0938\u094D\u0925\u093E\u0928\u094B\u0902 \u0915\u0940 \u0938\u0902\u0916\u094D\u092F\u093E",
    openroutemobile: "\u0938\u094D\u092E\u093E\u0930\u094D\u091F\u092B\u094B\u0928 \u092A\u0930 \u0917\u0942\u0917\u0932 \u092E\u0948\u092A \u0930\u0942\u091F \u0916\u094B\u0932\u0947\u0902",
    FoodEstablishment: "\u0915\u0939\u093E\u0901 \u0916\u093E\u0928\u093E \u0939\u0948",
    LodgingBusiness: "\u0915\u0939\u093E\u0901 \u0938\u094B\u0928\u093E \u0939\u0948",
    TouristDestination: "\u0915\u094D\u092F\u093E \u0926\u0947\u0916\u0947\u0902",
    TouristAttraction: "\u0915\u094D\u092F\u093E \u0915\u0930\u0947\u0902",
    Product: "\u0938\u094D\u0925\u093E\u0928\u0940\u092F \u0909\u0924\u094D\u092A\u093E\u0926",
    Service: "\u0938\u0947\u0935\u093E\u090F\u0902",
    Event: "\u0906\u092F\u094B\u091C\u0928",
    City: "\u0936\u0939\u0930\u094B\u0902",
    Wine: "\u0935\u093E\u0907\u0928"
}, $914aec8743edd630$var$hC = {
    consult: "\u091A\u0947\u0915 \u0906\u0909\u091F",
    thetutorial: "\u091F\u094D\u092F\u0942\u091F\u094B\u0930\u093F\u092F\u0932"
}, $914aec8743edd630$var$pC = {
    reset: "\u0938\u092D\u0940 \u0915\u094B \u092A\u0941\u0928\u0903 \u0924\u0948\u092F\u093E\u0930 \u0915\u0930\u0928\u093E",
    showresults: "\u092A\u0930\u093F\u0923\u093E\u092E \u0926\u093F\u0916\u093E\u090F\u0901",
    suggestiontitle: "\u0938\u0941\u091D\u093E\u0935 \u0916\u094B\u091C\u0947\u0902",
    reminder: `\u{92E}\u{924} \u{92D}\u{942}\u{932}\u{93F}\u{90F}, 
 \u{92E}\u{948}\u{902} \u{906}\u{92A}\u{915}\u{947} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{94B}\u{902} \u{915}\u{93E} \u{909}\u{924}\u{94D}\u{924}\u{930} \u{926}\u{947} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{942}\u{901}\u{964}`
}, $914aec8743edd630$var$mC = {
    listening: "\u092F\u0939 \u0906\u092A \u092A\u0930 \u0939\u0948, \u092E\u0948\u0902 \u0938\u0941\u0928 \u0930\u0939\u093E \u0939\u0942\u0902...",
    correct: "\u0938\u0941\u0927\u093E\u0930\u0947\u0902",
    dontknow: "\u092E\u0941\u091D\u0947 \u0928\u0939\u0940\u0902 \u092A\u0924\u093E"
}, $914aec8743edd630$var$gC = {
    allow: "\u0915\u0943\u092A\u092F\u093E \u0906\u0917\u0947 \u092C\u0922\u093C\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u092E\u093E\u0907\u0915\u094D\u0930\u094B\u092B\u094B\u0928 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0905\u0928\u0941\u092E\u0924\u093F \u0926\u0947\u0902\u0964",
    rejected: "\u0906\u092A\u0928\u0947 \u092E\u093E\u0907\u0915\u094D\u0930\u094B\u092B\u094B\u0928 \u0924\u0915 \u092A\u0939\u0941\u0902\u091A \u0915\u094B \u0905\u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0930 \u0926\u093F\u092F\u093E \u0939\u0948\u0964",
    instructions: "\u0935\u0949\u092F\u0938 \u092E\u094B\u0921 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u092E\u093E\u0907\u0915\u094D\u0930\u094B\u092B\u094B\u0928 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0905\u0928\u0941\u092E\u0924\u093F \u0926\u0947\u0902\u0964",
    listening: "\u092E\u0948\u0902 \u0938\u0941\u0928 \u0930\u0939\u093E \u0939\u0942\u0901",
    trigger: "\u092A\u094D\u0930\u0947\u0938 \u092F\u093E \u092C\u094B\u0932\u0947",
    triggerwithoutname: "\u092C\u093E\u0924 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u091F\u0948\u092A \u0915\u0930\u0947\u0902"
}, $914aec8743edd630$var$bC = {
    rejected: "\u0906\u092A\u0928\u0947 \u0905\u092A\u0928\u0947 \u091C\u0940\u092A\u0940\u090F\u0938 \u0938\u094D\u0925\u093E\u0928 \u0924\u0915 \u092A\u0939\u0941\u0902\u091A \u0938\u0947 \u0907\u0928\u0915\u093E\u0930 \u0915\u0930 \u0926\u093F\u092F\u093E \u0939\u0948\u0964",
    instructions: "\u092E\u094C\u0938\u092E \u0921\u0947\u091F\u093E \u092F\u093E \u0907\u0902\u091F\u0930\u090F\u0915\u094D\u091F\u093F\u0935 \u092E\u0948\u092A \u0924\u0915 \u092A\u0939\u0941\u0902\u091A\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F, \u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0905\u092A\u0928\u0947 \u091C\u0940\u092A\u0940\u090F\u0938 \u0938\u094D\u0925\u093E\u0928 \u0924\u0915 \u092A\u0939\u0941\u0902\u091A \u0915\u0940 \u0905\u0928\u0941\u092E\u0924\u093F \u0926\u0947\u0902\u0964"
}, $914aec8743edd630$var$vC = {
    calltoaction: "\u0936\u0941\u0930\u0942 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u0926\u092C\u093E\u090F\u0902",
    emptyveille: "\u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u0915\u094D\u0932\u093F\u0915 \u092F\u093E \u0926\u092C\u093E\u090F\u0902..."
}, $914aec8743edd630$var$yC = {
    shorttitle: "\u092E\u094C\u0938\u092E \u0915\u0940 \u0930\u093F\u092A\u094B\u0930\u094D\u091F",
    attribution: "\u092E\u094C\u0938\u092E \u0921\u0947\u091F\u093E Open-Meteo.com \u0926\u094D\u0935\u093E\u0930\u093E \u092A\u094D\u0930\u0926\u093E\u0928 \u0915\u093F\u092F\u093E \u0917\u092F\u093E"
}, $914aec8743edd630$var$wC = {
    title: "\u092C\u0949\u091F \u0915\u094B \u092D\u0947\u091C\u0947 \u0917\u090F \u0935\u094D\u092F\u0915\u094D\u0924\u093F\u0917\u0924 \u0921\u0947\u091F\u093E \u0915\u093E \u092A\u094D\u0930\u0938\u0902\u0938\u094D\u0915\u0930\u0923",
    message: `\u{907}\u{938} \u{938}\u{902}\u{935}\u{93E}\u{926} \u{915}\u{94B} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{915}\u{930}\u{915}\u{947}, \u{906}\u{92A} \u{938}\u{939}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{924}\u{947} \u{939}\u{948}\u{902} \u{915}\u{93F} \u{91A}\u{948}\u{91F}\u{92C}\u{949}\u{91F} \u{915}\u{94B} \u{92D}\u{947}\u{91C}\u{947} \u{917}\u{90F} \u{938}\u{92D}\u{940} \u{921}\u{947}\u{91F}\u{93E} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{909}\u{92A}\u{915}\u{930}\u{923} \u{915}\u{947} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{947} \u{935}\u{93F}\u{936}\u{94D}\u{932}\u{947}\u{937}\u{923} \u{914}\u{930} \u{91C}\u{94D}\u{91E}\u{93E}\u{928} \u{906}\u{927}\u{93E}\u{930} \u{915}\u{94B} \u{938}\u{92E}\u{943}\u{926}\u{94D}\u{927} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}

\u{906}\u{92A}\u{915}\u{940} \u{92C}\u{93E}\u{924}\u{91A}\u{940}\u{924} \u{939}\u{91F}\u{93E}\u{928}\u{947} \u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} 6 \u{92E}\u{939}\u{940}\u{928}\u{947} \u{924}\u{915} \u{938}\u{902}\u{917}\u{94D}\u{930}\u{939}\u{940}\u{924} \u{915}\u{940} \u{91C}\u{93E}\u{924}\u{940} \u{939}\u{948}\u{964}`,
    link: "\u0917\u094B\u092A\u0928\u0940\u092F\u0924\u093E \u0928\u0940\u0924\u093F\u092F\u093E\u0902 \u0926\u0947\u0916\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0932\u093F\u0902\u0915",
    buttonAccept: "\u092E\u0948\u0902 \u0938\u092E\u091D \u0917\u092F\u093E \u0914\u0930 \u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0930\u0924\u093E \u0939\u0942\u0902",
    buttonRefuse: "\u092E\u0948\u0902 \u0905\u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0930\u0924\u093E \u0939\u0942\u0902",
    messageAccepted: "\u0906\u092A\u0915\u0940 \u0938\u0939\u092E\u0924\u093F \u0915\u094B \u0927\u094D\u092F\u093E\u0928 \u092E\u0947\u0902 \u0930\u0916\u093E \u0917\u092F\u093E \u0939\u0948",
    messageRefused: "\u0906\u092A\u0915\u093E \u0905\u0938\u094D\u0935\u0940\u0915\u0930\u0923 \u0927\u094D\u092F\u093E\u0928 \u092E\u0947\u0902 \u0930\u0916\u093E \u0917\u092F\u093E \u0939\u0948"
}, $914aec8743edd630$var$_C = {
    1: "\u0939\u094B\u092E \u092A\u0947\u091C",
    2: "\u0932\u093E\u0907\u0935 \u0928\u094D\u092F\u0942\u091C\u093C \u091A\u0948\u0928\u0932",
    3: "\u092E\u094C\u0938\u092E \u0915\u0940 \u0930\u093F\u092A\u094B\u0930\u094D\u091F",
    4: "\u0906\u092A\u093E\u0924\u0915\u093E\u0932\u0940\u0928 \u0928\u0902\u092C\u0930",
    1e3: "\u0910\u0924\u093F\u0939\u093E\u0938\u093F\u0915",
    1001: "\u091F\u094D\u092F\u0942\u091F\u094B\u0930\u093F\u092F\u0932",
    common: $914aec8743edd630$var$eC,
    emergency: $914aec8743edd630$var$tC,
    error: $914aec8743edd630$var$rC,
    history: $914aec8743edd630$var$nC,
    home: $914aec8743edd630$var$iC,
    inputs: $914aec8743edd630$var$oC,
    language: $914aec8743edd630$var$aC,
    link: $914aec8743edd630$var$sC,
    loader: $914aec8743edd630$var$uC,
    menu: $914aec8743edd630$var$cC,
    mobileLandscapePreventer: $914aec8743edd630$var$lC,
    news: $914aec8743edd630$var$dC,
    poi: $914aec8743edd630$var$fC,
    suggestion: $914aec8743edd630$var$hC,
    template: $914aec8743edd630$var$pC,
    anghello: $914aec8743edd630$var$mC,
    microphone: $914aec8743edd630$var$gC,
    position: $914aec8743edd630$var$bC,
    veille: $914aec8743edd630$var$vC,
    weather: $914aec8743edd630$var$yC,
    GDPR: $914aec8743edd630$var$wC
}, $914aec8743edd630$var$kC = {
    abort: "megszak\xedt",
    all: "minden",
    back: "vissza",
    close: "Bez\xe1r\xe1s",
    continue: "Folytatni",
    download: "Let\xf6lt\xe9s",
    downloadsheet: "T\xf6ltse le ezt a lapot",
    downloadsheetmobile: "t\xf6ltse le ezt a lapot okostelefonra",
    filter: "Sz\u0171r\u0151",
    history: "t\xf6rt\xe9nelmi",
    knowmore: "Tudj meg t\xf6bbet",
    lang: "NYELVEK",
    menu: "men\xfc",
    mode: "divat",
    needhelp: "Kell seg\xedts\xe9g?",
    parameters: "be\xe1ll\xedt\xe1sok",
    print: "Nyomtat\xe1s",
    printsheet: "Nyomtassa ki ezt a lapot",
    result: "eredm\xe9ny",
    results: "eredm\xe9nyek",
    singleLang: "nyelv",
    sound: "neki",
    submit: "Bek\xfcld\xe9s",
    subtitle: "felirat",
    tutorial: "oktat\xf3anyag",
    validate: "\xe9rv\xe9nyes\xedt"
}, $914aec8743edd630$var$xC = {
    shorttitle: "Seg\xe9lyh\xedv\xf3 sz\xe1mok",
    samu: "S.A.M.U.",
    police: "rend\u0151rs\xe9g",
    firefighter: "t\u0171zolt\xf3k",
    general: "t\xe1bornoki",
    citypolice: "Helyi rend\u0151rs\xe9g",
    hospital: "K\xf3rh\xe1z",
    homeless: "Hajl\xe9ktalanok (ingyenes h\xedv\xe1s)",
    poison: "M\xe9regellen\u0151rz\u0151 K\xf6zpont",
    emergency: "eur\xf3pai v\xe9szhelyzetek"
}, $914aec8743edd630$var$SC = {
    title: "Hiba t\xf6rt\xe9nt",
    button: "Ind\xedtsa \xfajra az alkalmaz\xe1st"
}, $914aec8743edd630$var$EC = {
    shorttitle: "t\xf6rt\xe9nelmi",
    title: "besz\xe9lget\xe9s el\u0151zm\xe9nyei"
}, $914aec8743edd630$var$AC = {
    shorttitle: "kezd\u0151lap"
}, $914aec8743edd630$var$TC = {
    choose: "V\xe1lasszon egy v\xe1laszt",
    noaction: "M\u0171veletre v\xe1r"
}, $914aec8743edd630$var$CC = {
    change: "v\xe1ltoztassa meg a nyelvet",
    select: "v\xe1lassza ki a haszn\xe1lni k\xedv\xe1nt nyelvet"
}, $914aec8743edd630$var$RC = {
    buttontext: "Tekintse meg a dokumentumot",
    goto: "Menjen a c\xedmre",
    click: "Kattints ide",
    scanQR: "a QR-k\xf3d beolvas\xe1s\xe1val",
    scanQRTile: "Olvassa be a QR-k\xf3dot a felfedez\xe9shez"
}, $914aec8743edd630$var$OC = {
    loader: {
        optimal: "Az optim\xe1lis \xe9lm\xe9ny \xe9rdek\xe9ben",
        classic: "A klasszikusabb \xe9lm\xe9ny \xe9rdek\xe9ben",
        vocal: "N\xe9gyszemk\xf6zt besz\xe9lek az \xfcgyn\xf6kkel.",
        text: "\xcdr\xe1sban kommunik\xe1lok az \xfcgyn\xf6kkel."
    },
    modes: {
        vocal: "vok\xe1lis m\xf3d",
        text: "sz\xf6veges m\xf3d"
    },
    loaderValidation: "Ind\xedtsa el a besz\xe9lget\xe9st",
    locale: "nyelv ellen\u0151rz\xe9se",
    supported: "t\xe1mogatott nyelvek ellen\u0151rz\xe9se",
    addressdata: "adatok lek\xe9r\xe9se"
}, $914aec8743edd630$var$DC = {
    message: "\xcdrja be \xfczenet\xe9t",
    back: "vissza",
    backconversation: "vissza a besz\xe9lget\xe9shez",
    close: "Bez\xe1r\xe1s",
    answer: " v\xe1laszol a k\xe9rd\xe9seidre"
}, $914aec8743edd630$var$PC = {
    firstline: "Az optim\xe1lis \xe9lm\xe9ny \xe9rdek\xe9ben",
    secondline: "ford\xedtsa meg a k\xe9perny\u0151t"
}, $914aec8743edd630$var$IC = {
    shorttitle: "\xe9l\u0151 h\xedrcsatorna",
    warningtext: "Hozz\xe1f\xe9r a h\xedrcsatorn\xe1hoz, \xe9s a k\xe9sz\xfcl\xe9k hangja aktiv\xe1l\xf3dik",
    live: "\xe9l\u0151",
    continuous: "folyamatosan"
}, $914aec8743edd630$var$MC = {
    comment: "felhaszn\xe1l\xf3i \xe9rt\xe9kel\xe9s",
    route: "\xfat",
    nodata: "Egyetlen tartalom sem felel meg a keres\xe9snek",
    openinghours: "Nyitvatart\xe1si id\u0151",
    prices: "\xc1rak",
    paymentmethods: "Fizet\xe9si m\xf3dok",
    numberofplaces: "helyek sz\xe1ma",
    openroutemobile: "nyissa meg a Google Maps \xfatvonalat az okostelefonon",
    FoodEstablishment: "Hol tudok enni",
    LodgingBusiness: "Hol kell aludni",
    TouristDestination: "Mit kell l\xe1tni",
    TouristAttraction: "Mit kell tenni",
    Product: "Helyi term\xe9kek",
    Service: "Szolg\xe1ltat\xe1sok",
    Event: "Esem\xe9nyek",
    City: "V\xe1rosok",
    Wine: "Borok"
}, $914aec8743edd630$var$jC = {
    consult: "N\xe9zze meg",
    thetutorial: "az oktat\xf3anyag"
}, $914aec8743edd630$var$FC = {
    reset: "minden vissza\xe1ll\xedt\xe1sa",
    showresults: "Mutasd meg az eredm\xe9nyeket",
    suggestiontitle: "Keres\xe9si javaslatok",
    reminder: `Ne felejtsd el, 
 tudok v\xe1laszolni a k\xe9rd\xe9seidre.`
}, $914aec8743edd630$var$$C = {
    listening: "\xd6n\xf6n m\xfalik, hallgatok...",
    correct: "Korrig\xe1lni",
    dontknow: "Nem tudom"
}, $914aec8743edd630$var$LC = {
    allow: "K\xe9rj\xfck, enged\xe9lyezze a b\xf6ng\xe9sz\u0151 sz\xe1m\xe1ra a mikrofonhoz val\xf3 hozz\xe1f\xe9r\xe9st a folytat\xe1shoz.",
    rejected: "Elutas\xedtotta a mikrofonhoz val\xf3 hozz\xe1f\xe9r\xe9st.",
    instructions: "A hang m\xf3d haszn\xe1lat\xe1hoz k\xe9rj\xfck, enged\xe9lyezze a b\xf6ng\xe9sz\u0151 sz\xe1m\xe1ra a mikrofonhoz val\xf3 hozz\xe1f\xe9r\xe9st.",
    listening: "Hallgatlak",
    trigger: "Nyomja vagy mondja",
    triggerwithoutname: "\xc9rintse meg a besz\xe9ldhez"
}, $914aec8743edd630$var$NC = {
    rejected: "Elutas\xedtotta a hozz\xe1f\xe9r\xe9st a GPS-hely\xe9hez.",
    instructions: "Az id\u0151j\xe1r\xe1si adatokhoz vagy az interakt\xedv t\xe9rk\xe9phez val\xf3 hozz\xe1f\xe9r\xe9shez enged\xe9lyezze a b\xf6ng\xe9sz\u0151 sz\xe1m\xe1ra a hozz\xe1f\xe9r\xe9st a GPS-hely\xe9hez."
}, $914aec8743edd630$var$BC = {
    calltoaction: "Nyomja meg a k\xe9perny\u0151t a kezd\xe9shez",
    emptyveille: "Kattintson vagy nyomja meg a k\xe9perny\u0151t..."
}, $914aec8743edd630$var$qC = {
    shorttitle: "id\u0151j\xe1r\xe1s jelent\xe9s",
    attribution: "Id\u0151j\xe1r\xe1si adatokat az Open-Meteo.com biztos\xedtja"
}, $914aec8743edd630$var$zC = {
    title: "a botnak tov\xe1bb\xedtott szem\xe9lyes adatok kezel\xe9se",
    message: `a p\xe1rbesz\xe9d elfogad\xe1s\xe1val hozz\xe1j\xe1rul ahhoz, hogy a chatbotnak tov\xe1bb\xedtott \xf6sszes adatot felhaszn\xe1lj\xe1k az eszk\xf6z haszn\xe1lat\xe1nak elemz\xe9s\xe9re \xe9s a tud\xe1sb\xe1zis gazdag\xedt\xe1s\xe1ra.

Besz\xe9lget\xe9seit 6 h\xf3napig t\xe1roljuk t\xf6rl\xe9s el\u{151}tt.`,
    link: "link az adatv\xe9delmi ir\xe1nyelvek megtekint\xe9s\xe9hez",
    buttonAccept: "meg\xe9rtettem \xe9s elfogadom",
    buttonRefuse: "elutas\xedtom",
    messageAccepted: "hozz\xe1j\xe1rul\xe1sa figyelembe lett v\xe9ve",
    messageRefused: "elutas\xedt\xe1sa figyelembe lett v\xe9ve"
}, $914aec8743edd630$var$UC = {
    1: "kezd\u0151lap",
    2: "\xe9l\u0151 h\xedrcsatorna",
    3: "id\u0151j\xe1r\xe1s jelent\xe9s",
    4: "Seg\xe9lyh\xedv\xf3 sz\xe1mok",
    1e3: "t\xf6rt\xe9nelmi",
    1001: "oktat\xf3anyag",
    common: $914aec8743edd630$var$kC,
    emergency: $914aec8743edd630$var$xC,
    error: $914aec8743edd630$var$SC,
    history: $914aec8743edd630$var$EC,
    home: $914aec8743edd630$var$AC,
    inputs: $914aec8743edd630$var$TC,
    language: $914aec8743edd630$var$CC,
    link: $914aec8743edd630$var$RC,
    loader: $914aec8743edd630$var$OC,
    menu: $914aec8743edd630$var$DC,
    mobileLandscapePreventer: $914aec8743edd630$var$PC,
    news: $914aec8743edd630$var$IC,
    poi: $914aec8743edd630$var$MC,
    suggestion: $914aec8743edd630$var$jC,
    template: $914aec8743edd630$var$FC,
    anghello: $914aec8743edd630$var$$C,
    microphone: $914aec8743edd630$var$LC,
    position: $914aec8743edd630$var$NC,
    veille: $914aec8743edd630$var$BC,
    weather: $914aec8743edd630$var$qC,
    GDPR: $914aec8743edd630$var$zC
}, $914aec8743edd630$var$VC = {
    all: "semua",
    continue: "Melanjutkan",
    download: "unduh",
    downloadsheet: "unduh lembar ini",
    downloadsheetmobile: "unduh lembar ini di ponsel pintar",
    filter: "Saring",
    history: "historis",
    knowmore: "Ketahui lebih lanjut",
    lang: "BAHASA",
    menu: "menu",
    mode: "mode",
    needhelp: "Butuh bantuan?",
    parameters: "pengaturan",
    print: "Mencetak",
    printsheet: "Cetak lembar ini",
    result: "hasil",
    results: "hasil",
    singleLang: "bahasa",
    sound: "dia",
    submit: "kirim",
    subtitle: "subjudul",
    tutorial: "tutorial",
    validate: "mengesahkan",
    abort: "batalkan"
}, $914aec8743edd630$var$GC = {
    shorttitle: "Nomor darurat",
    samu: "S.A.M.U.",
    police: "POLISI",
    firefighter: "petugas pemadam kebakaran",
    general: "umum",
    citypolice: "Polisi setempat",
    hospital: "RSUD",
    homeless: "Tunawisma (panggilan gratis)",
    poison: "Pusat Pengendalian Racun",
    emergency: "keadaan darurat Eropa"
}, $914aec8743edd630$var$WC = {
    title: "Sebuah kesalahan telah terjadi",
    button: "Luncurkan kembali aplikasi"
}, $914aec8743edd630$var$HC = {
    shorttitle: "historis",
    title: "riwayat percakapan"
}, $914aec8743edd630$var$KC = {
    shorttitle: "halaman rumah"
}, $914aec8743edd630$var$QC = {
    choose: "Pilih jawaban",
    noaction: "Menunggu tindakan"
}, $914aec8743edd630$var$YC = {
    change: "mengubah bahasa",
    select: "pilih bahasa yang ingin Anda gunakan"
}, $914aec8743edd630$var$JC = {
    buttontext: "Lihat dokumennya",
    goto: "Pergi ke alamat",
    click: "klik disini",
    scanQR: "dengan memindai QrCode",
    scanQRTile: "Pindai Kode QR untuk menemukan"
}, $914aec8743edd630$var$ZC = {
    loader: {
        optimal: "Untuk pengalaman optimal,",
        classic: "Untuk pengalaman yang lebih klasik,",
        vocal: "Saya berbicara tatap muka dengan agen.",
        text: "Saya berkomunikasi secara tertulis dengan agen."
    },
    modes: {
        vocal: "modus vokal",
        text: "modus teks"
    },
    loaderValidation: "Mulai percakapan",
    locale: "memeriksa bahasa",
    supported: "memeriksa bahasa yang didukung",
    addressdata: "mengambil data"
}, $914aec8743edd630$var$XC = {
    message: "Masukkan pesan Anda",
    back: "kembali",
    backconversation: "kembali ke percakapan",
    close: "menutup",
    answer: " menjawab pertanyaan Anda"
}, $914aec8743edd630$var$e4 = {
    firstline: "Untuk pengalaman optimal,",
    secondline: "balik layar Anda"
}, $914aec8743edd630$var$t4 = {
    shorttitle: "saluran berita langsung",
    warningtext: "Anda akan mengakses saluran berita, suara di perangkat Anda akan diaktifkan",
    live: "hidup",
    continuous: "terus menerus"
}, $914aec8743edd630$var$r4 = {
    comment: "ulasan pelanggan",
    route: "jalan",
    nodata: "Tidak ada konten yang cocok dengan pencarian Anda",
    openinghours: "Jam buka",
    prices: "Harga",
    paymentmethods: "Cara Pembayaran",
    numberofplaces: "sejumlah tempat",
    openroutemobile: "buka rute Google Maps di smartphone",
    FoodEstablishment: "Tempat makan",
    LodgingBusiness: "Tempat tidur",
    TouristDestination: "Apa yang dilihat",
    TouristAttraction: "Apa yang harus dilakukan",
    Product: "Produk lokal",
    Service: "Jasa",
    Event: "Acara",
    City: "kota",
    Wine: "Anggur"
}, $914aec8743edd630$var$n4 = {
    consult: "Periksa",
    thetutorial: "tutorialnya"
}, $914aec8743edd630$var$i4 = {
    reset: "atur ulang semua",
    showresults: "Tunjukkan hasilnya",
    suggestiontitle: "Saran pencarian",
    reminder: `Jangan lupa, 
 saya bisa menjawab pertanyaan Anda.`
}, $914aec8743edd630$var$o4 = {
    listening: "Terserah Anda, saya mendengarkan...",
    correct: "Perbaiki",
    dontknow: "Saya tidak tahu"
}, $914aec8743edd630$var$a4 = {
    allow: "Silakan izinkan browser Anda mengakses mikrofon untuk melanjutkan.",
    rejected: "Anda telah menolak akses ke mikrofon.",
    instructions: "Untuk menggunakan mode suara, silakan izinkan browser Anda mengakses mikrofon.",
    listening: "Saya mendengar",
    trigger: "Tekan atau katakan",
    triggerwithoutname: "Ketuk untuk berbicara"
}, $914aec8743edd630$var$s4 = {
    rejected: "Anda telah menolak akses ke lokasi GPS Anda.",
    instructions: "Untuk mengakses data cuaca atau peta interaktif, silakan izinkan browser Anda untuk mengakses lokasi GPS Anda."
}, $914aec8743edd630$var$u4 = {
    calltoaction: "Tekan layar untuk memulai",
    emptyveille: "Klik atau tekan layar..."
}, $914aec8743edd630$var$c4 = {
    shorttitle: "laporan cuaca",
    attribution: "Data cuaca disediakan oleh Open-Meteo.com"
}, $914aec8743edd630$var$l4 = {
    title: "pemrosesan data pribadi yang dikirimkan ke bot",
    message: `dengan menerima dialog ini, Anda menyetujui bahwa semua data yang dikirimkan ke chatbot dapat digunakan untuk menganalisis penggunaan alat dan memperkaya basis pengetahuan.

Percakapan Anda disimpan selama 6 bulan sebelum dihapus.`,
    link: "tautan untuk melihat kebijakan privasi",
    buttonAccept: "saya mengerti dan menerima",
    buttonRefuse: "saya menolak",
    messageAccepted: "persetujuan Anda telah dicatat",
    messageRefused: "penolakan Anda telah dicatat"
}, $914aec8743edd630$var$d4 = {
    1: "halaman rumah",
    2: "saluran berita langsung",
    3: "laporan cuaca",
    4: "Nomor darurat",
    1e3: "historis",
    1001: "tutorial",
    common: $914aec8743edd630$var$VC,
    emergency: $914aec8743edd630$var$GC,
    error: $914aec8743edd630$var$WC,
    history: $914aec8743edd630$var$HC,
    home: $914aec8743edd630$var$KC,
    inputs: $914aec8743edd630$var$QC,
    language: $914aec8743edd630$var$YC,
    link: $914aec8743edd630$var$JC,
    loader: $914aec8743edd630$var$ZC,
    menu: $914aec8743edd630$var$XC,
    mobileLandscapePreventer: $914aec8743edd630$var$e4,
    news: $914aec8743edd630$var$t4,
    poi: $914aec8743edd630$var$r4,
    suggestion: $914aec8743edd630$var$n4,
    template: $914aec8743edd630$var$i4,
    anghello: $914aec8743edd630$var$o4,
    microphone: $914aec8743edd630$var$a4,
    position: $914aec8743edd630$var$s4,
    veille: $914aec8743edd630$var$u4,
    weather: $914aec8743edd630$var$c4,
    GDPR: $914aec8743edd630$var$l4
}, $914aec8743edd630$var$f4 = {
    abort: "annulla",
    all: "tutti",
    back: "Indietro",
    close: "chiudere",
    continue: "continuare",
    download: "scaricamento",
    downloadsheet: "scarica questa scheda",
    downloadsheetmobile: "scarica questa scheda sullo smartphone",
    filter: "Filtro",
    history: "storico",
    knowmore: "Scopri di pi\xf9",
    lang: "lingua",
    menu: "men\xf9",
    mode: "moda",
    needhelp: "Ho bisogno di aiuto?",
    parameters: "impostazioni",
    print: "Stampa",
    printsheet: "Stampa questo foglio",
    result: "risultato",
    results: "risultati",
    singleLang: "Lingua",
    sound: "suo",
    submit: "invia",
    subtitle: "sottotitolo",
    tutorial: "tutorial",
    validate: "convalidare"
}, $914aec8743edd630$var$h4 = {
    shorttitle: "Numeri di emergenza",
    samu: "S.A.M.U.",
    police: "Polizia Stradale",
    firefighter: "vigili del fuoco",
    general: "generale",
    citypolice: "Polizia locale",
    hospital: "Ospedale",
    homeless: "Senzatetto (chiamata gratuita)",
    poison: "Centro antiveleni",
    emergency: "Emergenze europee"
}, $914aec8743edd630$var$p4 = {
    title: "C'\xe8 stato un errore",
    button: "Riavviare l'applicazione"
}, $914aec8743edd630$var$m4 = {
    shorttitle: "storico",
    title: "cronologia delle conversazioni"
}, $914aec8743edd630$var$g4 = {
    shorttitle: "pagina iniziale"
}, $914aec8743edd630$var$b4 = {
    choose: "Scegli una risposta",
    noaction: "Attesa di un'azione"
}, $914aec8743edd630$var$v4 = {
    change: "cambiare la lingua",
    select: "seleziona la lingua che desideri utilizzare"
}, $914aec8743edd630$var$y4 = {
    buttontext: "Visualizza il documento",
    goto: "Vai all'indirizzo",
    click: "clicca qui",
    scanQR: "scansionando il QrCode",
    scanQRTile: "Scansiona il QR Code per scoprire"
}, $914aec8743edd630$var$w4 = {
    loader: {
        optimal: "Per un'esperienza ottimale,",
        classic: "Per un'esperienza pi\xf9 classica,",
        vocal: "Parlo faccia a faccia con l'agente.",
        text: "Comunico per iscritto con l'agente."
    },
    modes: {
        vocal: "modalit\xe0 vocale",
        text: "modalit\xe0 testo"
    },
    loaderValidation: "Inizia la conversazione",
    locale: "controllo della lingua",
    supported: "verifica delle lingue supportate",
    addressdata: "recupero dati"
}, $914aec8743edd630$var$_4 = {
    message: "Inserisci il tuo messaggio",
    backconversation: "torniamo alla conversazione",
    answer: " risponde alle tue domande"
}, $914aec8743edd630$var$k4 = {
    firstline: "Per un'esperienza ottimale,",
    secondline: "capovolgi lo schermo"
}, $914aec8743edd630$var$x4 = {
    shorttitle: "canale di notizie in diretta",
    warningtext: "Accederai al canale delle notizie, l'audio sul tuo dispositivo verr\xe0 attivato",
    live: "vivere",
    continuous: "continuamente"
}, $914aec8743edd630$var$S4 = {
    comment: "recensione del cliente",
    route: "strada",
    nodata: "Nessun contenuto corrisponde alla tua ricerca",
    openinghours: "Orari di apertura",
    prices: "Prezzi",
    paymentmethods: "Modalit\xe0 di pagamento",
    numberofplaces: "numero di posti",
    openroutemobile: "apri il percorso di Google Maps sullo smartphone",
    FoodEstablishment: "Dove mangiare",
    LodgingBusiness: "Dove dormire",
    TouristDestination: "Cosa guardare",
    TouristAttraction: "Cosa fare",
    Product: "Prodotti locali",
    Service: "Servizi",
    Event: "Eventi",
    City: "Citt\xe0",
    Wine: "Vini"
}, $914aec8743edd630$var$E4 = {
    consult: "Guardare",
    thetutorial: "il tutorial"
}, $914aec8743edd630$var$A4 = {
    reset: "resetta tutto",
    showresults: "Mostra i risultati",
    suggestiontitle: "Suggerimenti per la ricerca",
    reminder: `Non dimenticare, 
 posso rispondere alle tue domande.`
}, $914aec8743edd630$var$T4 = {
    listening: "Dipende da te, ti ascolto...",
    correct: "Correggere",
    dontknow: "Non lo so"
}, $914aec8743edd630$var$C4 = {
    allow: "Si prega di consentire al browser di accedere al microfono per continuare.",
    rejected: "Hai rifiutato l'accesso al microfono.",
    instructions: "Per utilizzare la modalit\xe0 vocale, si prega di consentire al browser di accedere al microfono.",
    listening: "Sto ascoltando",
    trigger: "Premi o dica",
    triggerwithoutname: "Tocca per parlare"
}, $914aec8743edd630$var$R4 = {
    rejected: "Hai rifiutato l'accesso alla tua posizione GPS.",
    instructions: "Per accedere ai dati meteorologici o alla mappa interattiva, si prega di autorizzare il browser a accedere alla tua posizione GPS."
}, $914aec8743edd630$var$O4 = {
    calltoaction: "Premi lo schermo per iniziare",
    emptyveille: "Fai clic o premi lo schermo..."
}, $914aec8743edd630$var$D4 = {
    shorttitle: "bollettino meteorologico",
    attribution: "Dati meteorologici forniti da Open-Meteo.com"
}, $914aec8743edd630$var$P4 = {
    title: "trattamento dei dati personali trasmessi al bot",
    message: `accettando questo dialogo, acconsenti che tutti i dati trasmessi al chatbot vengano utilizzati per analizzare l'uso dello strumento e arricchire la base di conoscenza.

Le tue conversazioni vengono conservate 6 mesi prima di essere eliminate.`,
    link: "link per consultare le politiche sulla privacy",
    buttonAccept: "ho capito e accetto",
    buttonRefuse: "rifiuto",
    messageAccepted: "il tuo consenso \xe8 stato preso in considerazione",
    messageRefused: "il tuo rifiuto \xe8 stato preso in considerazione"
}, $914aec8743edd630$var$I4 = {
    1: "pagina iniziale",
    2: "canale di notizie in diretta",
    3: "bollettino meteorologico",
    4: "Numeri di emergenza",
    1e3: "storico",
    1001: "tutorial",
    common: $914aec8743edd630$var$f4,
    emergency: $914aec8743edd630$var$h4,
    error: $914aec8743edd630$var$p4,
    history: $914aec8743edd630$var$m4,
    home: $914aec8743edd630$var$g4,
    inputs: $914aec8743edd630$var$b4,
    language: $914aec8743edd630$var$v4,
    link: $914aec8743edd630$var$y4,
    loader: $914aec8743edd630$var$w4,
    menu: $914aec8743edd630$var$_4,
    mobileLandscapePreventer: $914aec8743edd630$var$k4,
    news: $914aec8743edd630$var$x4,
    poi: $914aec8743edd630$var$S4,
    suggestion: $914aec8743edd630$var$E4,
    template: $914aec8743edd630$var$A4,
    anghello: $914aec8743edd630$var$T4,
    microphone: $914aec8743edd630$var$C4,
    position: $914aec8743edd630$var$R4,
    veille: $914aec8743edd630$var$O4,
    weather: $914aec8743edd630$var$D4,
    GDPR: $914aec8743edd630$var$P4
}, $914aec8743edd630$var$M4 = {
    abort: "\u30AD\u30E3\u30F3\u30BB\u30EB",
    all: "\u5168\u3066",
    back: "\u623B\u308B",
    close: "\u8FD1\u3044",
    continue: "\u7D9A\u304F",
    download: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    downloadsheet: "\u3053\u306E\u30B7\u30FC\u30C8\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    downloadsheetmobile: "\u3053\u306E\u30B7\u30FC\u30C8\u3092\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    filter: "\u30D5\u30A3\u30EB\u30BF\u30FC",
    history: "\u6B74\u53F2\u7684\u306A",
    knowmore: "\u3082\u3063\u3068\u77E5\u308B",
    lang: "\u8A00\u8A9E",
    menu: "\u30E1\u30CB\u30E5\u30FC",
    mode: "\u30D5\u30A1\u30C3\u30B7\u30E7\u30F3",
    needhelp: "\u52A9\u3051\u304C\u5FC5\u8981\uFF1F",
    parameters: "\u8A2D\u5B9A",
    print: "\u5370\u5237\u3059\u308B",
    printsheet: "\u3053\u306E\u30B7\u30FC\u30C8\u3092\u5370\u5237\u3059\u308B",
    result: "\u7D50\u679C",
    results: "\u7D50\u679C",
    singleLang: "\u8A00\u8A9E",
    sound: "\u5F7C\u5973",
    submit: "\u63D0\u51FA\u3059\u308B",
    subtitle: "\u5B57\u5E55",
    tutorial: "\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB",
    validate: "\u691C\u8A3C"
}, $914aec8743edd630$var$j4 = {
    shorttitle: "\u7DCA\u6025\u96FB\u8A71\u756A\u53F7",
    samu: "S.A.M.U",
    police: "\u8B66\u5BDF",
    firefighter: "\u6D88\u9632\u58EB",
    general: "\u4E00\u822C\u7684\u306A",
    citypolice: "\u5730\u5143\u8B66\u5BDF",
    hospital: "\u75C5\u9662",
    homeless: "\u30DB\u30FC\u30E0\u30EC\u30B9\uFF08\u7121\u6599\u901A\u8A71\uFF09",
    poison: "\u6BD2\u7269\u7BA1\u7406\u30BB\u30F3\u30BF\u30FC",
    emergency: "\u30E8\u30FC\u30ED\u30C3\u30D1\u306E\u7DCA\u6025\u4E8B\u614B"
}, $914aec8743edd630$var$F4 = {
    title: "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
    button: "\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u518D\u8D77\u52D5\u3059\u308B"
}, $914aec8743edd630$var$$4 = {
    shorttitle: "\u6B74\u53F2\u7684\u306A",
    title: "\u4F1A\u8A71\u5C65\u6B74"
}, $914aec8743edd630$var$L4 = {
    shorttitle: "\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8"
}, $914aec8743edd630$var$N4 = {
    choose: "\u7B54\u3048\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    noaction: "\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5F85\u3063\u3066\u3044\u307E\u3059"
}, $914aec8743edd630$var$B4 = {
    change: "\u8A00\u8A9E\u3092\u5909\u3048\u308B",
    select: "\u4F7F\u7528\u3057\u305F\u3044\u8A00\u8A9E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"
}, $914aec8743edd630$var$q4 = {
    buttontext: "\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u898B\u308B",
    goto: "\u4F4F\u6240\u306B\u79FB\u52D5",
    click: "\u3053\u3053\u3092\u30AF\u30EA\u30C3\u30AF",
    scanQR: "QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3059\u308B\u3053\u3068\u3067",
    scanQRTile: "QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u767A\u898B\u3059\u308B"
}, $914aec8743edd630$var$z4 = {
    loader: {
        optimal: "\u6700\u9069\u306A\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u306B\u3001",
        classic: "\u3088\u308A\u30AF\u30E9\u30B7\u30C3\u30AF\u306A\u4F53\u9A13\u3092\u3059\u308B\u306B\u306F\u3001",
        vocal: "\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3068\u5BFE\u9762\u3067\u8A71\u3057\u307E\u3059\u3002",
        text: "\u79C1\u306F\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3068\u66F8\u9762\u3067\u3084\u308A\u53D6\u308A\u3057\u307E\u3059\u3002"
    },
    modes: {
        vocal: "\u30DC\u30FC\u30AB\u30EB\u30E2\u30FC\u30C9",
        text: "\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9"
    },
    loaderValidation: "\u4F1A\u8A71\u3092\u958B\u59CB\u3059\u308B",
    locale: "\u8A00\u8A9E\u3092\u30C1\u30A7\u30C3\u30AF\u3059\u308B",
    supported: "\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u8A00\u8A9E\u3092\u78BA\u8A8D\u3059\u308B",
    addressdata: "\u30C7\u30FC\u30BF\u306E\u53D6\u5F97"
}, $914aec8743edd630$var$U4 = {
    message: "\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    backconversation: "\u4F1A\u8A71\u306B\u623B\u308A\u307E\u3059",
    answer: " \u3042\u306A\u305F\u306E\u8CEA\u554F\u306B\u7B54\u3048\u307E\u3059"
}, $914aec8743edd630$var$V4 = {
    firstline: "\u6700\u9069\u306A\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u306B\u3001",
    secondline: "\u753B\u9762\u3092\u53CD\u8EE2\u3057\u3066\u304F\u3060\u3055\u3044"
}, $914aec8743edd630$var$G4 = {
    shorttitle: "\u30E9\u30A4\u30D6\u30CB\u30E5\u30FC\u30B9\u30C1\u30E3\u30F3\u30CD\u30EB",
    warningtext: "\u30CB\u30E5\u30FC\u30B9\u30C1\u30E3\u30F3\u30CD\u30EB\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u3068\u3001\u30C7\u30D0\u30A4\u30B9\u306E\u30B5\u30A6\u30F3\u30C9\u304C\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u306A\u308A\u307E\u3059",
    live: "\u30E9\u30A4\u30D6",
    continuous: "\u7D99\u7D9A\u7684\u306B"
}, $914aec8743edd630$var$W4 = {
    comment: "\u30AB\u30B9\u30BF\u30DE\u30FC\u30EC\u30D3\u30E5\u30FC",
    route: "\u9053",
    nodata: "\u691C\u7D22\u306B\u4E00\u81F4\u3059\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u306F\u3042\u308A\u307E\u305B\u3093",
    openinghours: "\u55B6\u696D\u6642\u9593",
    prices: "\u4FA1\u683C",
    paymentmethods: "\u304A\u652F\u6255\u3044\u65B9\u6CD5",
    numberofplaces: "\u5834\u6240\u306E\u6570",
    openroutemobile: "\u30B9\u30DE\u30DB\u3067Google\u30DE\u30C3\u30D7\u306E\u30EB\u30FC\u30C8\u3092\u958B\u304F",
    FoodEstablishment: "\u3069\u3053\u3067\u98DF\u3079\u307E\u3059",
    LodgingBusiness: "\u3069\u3053\u3067\u5BDD\u308B\u304B",
    TouristDestination: "\u898B\u308B\u3079\u304D\u3082\u306E",
    TouristAttraction: "\u4F55\u3092\u3059\u308B\u304B",
    Product: "\u5730\u5143\u306E\u7279\u7523\u54C1",
    Service: "\u30B5\u30FC\u30D3\u30B9",
    Event: "\u30A4\u30D9\u30F3\u30C8",
    City: "\u90FD\u5E02",
    Wine: "\u30EF\u30A4\u30F3"
}, $914aec8743edd630$var$H4 = {
    consult: "\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8",
    thetutorial: "\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB"
}, $914aec8743edd630$var$K4 = {
    reset: "\u3059\u3079\u3066\u30EA\u30BB\u30C3\u30C8",
    showresults: "\u7D50\u679C\u3092\u8868\u793A\u3059\u308B",
    suggestiontitle: "\u691C\u7D22\u5019\u88DC",
    reminder: `\u{5FD8}\u{308C}\u{306A}\u{3044}\u{3067}\u{304F}\u{3060}\u{3055}\u{3044}\u{3001}
 \u{3042}\u{306A}\u{305F}\u{306E}\u{8CEA}\u{554F}\u{306B}\u{7B54}\u{3048}\u{307E}\u{3059}\u{3002}`
}, $914aec8743edd630$var$Q4 = {
    listening: "\u3042\u306A\u305F\u6B21\u7B2C\u3067\u3059\u3001\u79C1\u306F\u805E\u3044\u3066\u3044\u307E\u3059...",
    correct: "\u4FEE\u6B63\u3059\u308B",
    dontknow: "\u308F\u304B\u308A\u307E\u305B\u3093"
}, $914aec8743edd630$var$Y4 = {
    allow: "\u7D9A\u884C\u3059\u308B\u306B\u306F\u3001\u30D6\u30E9\u30A6\u30B6\u306B\u30DE\u30A4\u30AF\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    rejected: "\u30DE\u30A4\u30AF\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u62D2\u5426\u3057\u307E\u3057\u305F\u3002",
    instructions: "\u97F3\u58F0\u30E2\u30FC\u30C9\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001\u30D6\u30E9\u30A6\u30B6\u306B\u30DE\u30A4\u30AF\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    listening: "\u805E\u3044\u3066\u307E\u3059\u3088",
    trigger: "\u62BC\u3059\u304B\u8A00\u3063\u3066\u304F\u3060\u3055\u3044",
    triggerwithoutname: "\u8A71\u3059\u306B\u306F\u30BF\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044"
}, $914aec8743edd630$var$J4 = {
    rejected: "\u3042\u306A\u305F\u306FGPS\u4F4D\u7F6E\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u62D2\u5426\u3057\u307E\u3057\u305F\u3002",
    instructions: "\u5929\u6C17\u30C7\u30FC\u30BF\u3084\u30A4\u30F3\u30BF\u30E9\u30AF\u30C6\u30A3\u30D6\u30DE\u30C3\u30D7\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u306B\u306F\u3001\u30D6\u30E9\u30A6\u30B6\u304C\u3042\u306A\u305F\u306EGPS\u4F4D\u7F6E\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u3053\u3068\u3092\u8A31\u53EF\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
}, $914aec8743edd630$var$Z4 = {
    calltoaction: "\u958B\u59CB\u3059\u308B\u306B\u306F\u753B\u9762\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044",
    emptyveille: "\u753B\u9762\u3092\u30AF\u30EA\u30C3\u30AF\u307E\u305F\u306F\u62BC\u3057\u3066\u304F\u3060\u3055\u3044..."
}, $914aec8743edd630$var$X4 = {
    shorttitle: "\u5929\u6C17\u4E88\u5831",
    attribution: "\u6C17\u8C61\u30C7\u30FC\u30BF\u306FOpen-Meteo.com\u306B\u3088\u308A\u63D0\u4F9B\u3055\u308C\u3066\u3044\u307E\u3059"
}, $914aec8743edd630$var$e8 = {
    title: "\u30DC\u30C3\u30C8\u306B\u9001\u4FE1\u3055\u308C\u305F\u500B\u4EBA\u30C7\u30FC\u30BF\u306E\u51E6\u7406",
    message: `\u{3053}\u{306E}\u{30C0}\u{30A4}\u{30A2}\u{30ED}\u{30B0}\u{3092}\u{53D7}\u{3051}\u{5165}\u{308C}\u{308B}\u{3053}\u{3068}\u{3067}\u{3001}\u{30C1}\u{30E3}\u{30C3}\u{30C8}\u{30DC}\u{30C3}\u{30C8}\u{306B}\u{9001}\u{4FE1}\u{3055}\u{308C}\u{305F}\u{3059}\u{3079}\u{3066}\u{306E}\u{30C7}\u{30FC}\u{30BF}\u{3092}\u{30C4}\u{30FC}\u{30EB}\u{306E}\u{4F7F}\u{7528}\u{5206}\u{6790}\u{3068}\u{30CA}\u{30EC}\u{30C3}\u{30B8}\u{30D9}\u{30FC}\u{30B9}\u{306E}\u{5F37}\u{5316}\u{306B}\u{4F7F}\u{7528}\u{3059}\u{308B}\u{3053}\u{3068}\u{306B}\u{540C}\u{610F}\u{3057}\u{307E}\u{3059}\u{3002}

\u{4F1A}\u{8A71}\u{306F}\u{524A}\u{9664}\u{524D}6\u{30F6}\u{6708}\u{9593}\u{4FDD}\u{5B58}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    link: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC\u3092\u8868\u793A\u3059\u308B\u30EA\u30F3\u30AF",
    buttonAccept: "\u7406\u89E3\u3057\u3066\u540C\u610F\u3057\u307E\u3059",
    buttonRefuse: "\u62D2\u5426\u3057\u307E\u3059",
    messageAccepted: "\u540C\u610F\u304C\u8003\u616E\u3055\u308C\u307E\u3057\u305F",
    messageRefused: "\u62D2\u5426\u304C\u8003\u616E\u3055\u308C\u307E\u3057\u305F"
}, $914aec8743edd630$var$t8 = {
    1: "\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8",
    2: "\u30E9\u30A4\u30D6\u30CB\u30E5\u30FC\u30B9\u30C1\u30E3\u30F3\u30CD\u30EB",
    3: "\u5929\u6C17\u4E88\u5831",
    4: "\u7DCA\u6025\u96FB\u8A71\u756A\u53F7",
    1e3: "\u6B74\u53F2\u7684\u306A",
    1001: "\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB",
    common: $914aec8743edd630$var$M4,
    emergency: $914aec8743edd630$var$j4,
    error: $914aec8743edd630$var$F4,
    history: $914aec8743edd630$var$$4,
    home: $914aec8743edd630$var$L4,
    inputs: $914aec8743edd630$var$N4,
    language: $914aec8743edd630$var$B4,
    link: $914aec8743edd630$var$q4,
    loader: $914aec8743edd630$var$z4,
    menu: $914aec8743edd630$var$U4,
    mobileLandscapePreventer: $914aec8743edd630$var$V4,
    news: $914aec8743edd630$var$G4,
    poi: $914aec8743edd630$var$W4,
    suggestion: $914aec8743edd630$var$H4,
    template: $914aec8743edd630$var$K4,
    anghello: $914aec8743edd630$var$Q4,
    microphone: $914aec8743edd630$var$Y4,
    position: $914aec8743edd630$var$J4,
    veille: $914aec8743edd630$var$Z4,
    weather: $914aec8743edd630$var$X4,
    GDPR: $914aec8743edd630$var$e8
}, $914aec8743edd630$var$r8 = {
    abort: "\uCDE8\uC18C",
    all: "\uBAA8\uB450",
    back: "\uB4A4\uCABD\uC5D0",
    close: "\uB2EB\uB2E4",
    continue: "\uACC4\uC18D\uD558\uB2E4",
    download: "\uB2E4\uC6B4\uB85C\uB4DC",
    downloadsheet: "\uC774 \uC2DC\uD2B8 \uB2E4\uC6B4\uB85C\uB4DC",
    downloadsheetmobile: "\uC774 \uC2DC\uD2B8\uB97C \uC2A4\uB9C8\uD2B8\uD3F0\uC5D0 \uB2E4\uC6B4\uB85C\uB4DC\uD558\uC138\uC694",
    filter: "\uD544\uD130",
    history: "\uC5ED\uC0AC\uC801\uC778",
    knowmore: "\uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30",
    lang: "\uC5B8\uC5B4",
    menu: "\uBA54\uB274",
    mode: "\uD328\uC158",
    needhelp: "\uB3C4\uC6C0\uC774 \uD544\uC694\uD558\uB2E4?",
    parameters: "\uC124\uC815",
    print: "\uC778\uC1C4",
    printsheet: "\uC774 \uC2DC\uD2B8\uB97C \uC778\uC1C4\uD558\uC138\uC694",
    result: "\uACB0\uACFC",
    results: "\uACB0\uACFC",
    singleLang: "\uC5B8\uC5B4",
    sound: "\uADF8\uB140\uC758",
    submit: "\uC81C\uCD9C\uD558\uB2E4",
    subtitle: "\uBD80\uC81C",
    tutorial: "\uC9C0\uB3C4 \uC2DC\uAC04",
    validate: "\uD655\uC778"
}, $914aec8743edd630$var$n8 = {
    shorttitle: "\uAE34\uAE09 \uC804\uD654\uBC88\uD638",
    samu: "S.A.M.U.",
    police: "\uACBD\uCC30",
    firefighter: "\uC18C\uBC29\uAD00",
    general: "\uC77C\uBC18\uC801\uC778",
    hospital: "\uBCD1\uC6D0",
    homeless: "\uB178\uC219\uC790",
    poison: "\uB3C5\uADF9\uBB3C \uAD00\uB9AC \uC13C\uD130",
    emergency: "\uAE34\uAE09 \uC0C1\uD669"
}, $914aec8743edd630$var$i8 = {
    title: "\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4",
    button: "\uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC744 \uB2E4\uC2DC \uC2DC\uC791\uD558\uC138\uC694."
}, $914aec8743edd630$var$o8 = {
    shorttitle: "\uC5ED\uC0AC\uC801\uC778",
    title: "\uB300\uD654 \uAE30\uB85D"
}, $914aec8743edd630$var$a8 = {
    shorttitle: "\uD648\uD398\uC774\uC9C0"
}, $914aec8743edd630$var$s8 = {
    choose: "\uB2F5\uBCC0\uC744 \uC120\uD0DD\uD558\uC138\uC694",
    noaction: "\uC791\uC5C5\uC744 \uAE30\uB2E4\uB9AC\uB294 \uC911"
}, $914aec8743edd630$var$u8 = {
    change: "\uC5B8\uC5B4\uB97C \uBC14\uAFD4\uB77C",
    select: "\uC0AC\uC6A9\uD558\uACE0 \uC2F6\uC740 \uC5B8\uC5B4\uB97C \uC120\uD0DD\uD558\uC138\uC694"
}, $914aec8743edd630$var$c8 = {
    buttontext: "\uBB38\uC11C \uBCF4\uAE30",
    goto: "\uC8FC\uC18C\uB85C \uC774\uB3D9",
    click: "\uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC138\uC694",
    scanQR: "QrCode\uB97C \uC2A4\uCE94\uD558\uC5EC",
    scanQRTile: "QR \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uC5EC \uBC1C\uACAC\uD558\uB2E4"
}, $914aec8743edd630$var$l8 = {
    loader: {
        optimal: "\uCD5C\uC801\uC758 \uACBD\uD5D8\uC744 \uC704\uD574,",
        classic: "\uC880 \uB354 \uD074\uB798\uC2DD\uD55C \uACBD\uD5D8\uC744 \uC6D0\uD558\uC2E0\uB2E4\uBA74,",
        vocal: "\uC800\uB294 \uC0C1\uB2F4\uC6D0\uACFC \uC9C1\uC811 \uB300\uBA74\uD558\uC5EC \uC774\uC57C\uAE30\uD569\uB2C8\uB2E4.",
        text: "\uB098\uB294 \uB300\uB9AC\uC778\uACFC \uC11C\uBA74\uC73C\uB85C \uC758\uC0AC\uC18C\uD1B5\uD569\uB2C8\uB2E4."
    },
    modes: {
        vocal: "\uBCF4\uCEEC \uBAA8\uB4DC",
        text: "\uD14D\uC2A4\uD2B8 \uBAA8\uB4DC"
    },
    loaderValidation: "\uB300\uD654 \uC2DC\uC791",
    locale: "\uC5B8\uC5B4 \uD655\uC778",
    supported: "\uC9C0\uC6D0\uB418\uB294 \uC5B8\uC5B4 \uD655\uC778",
    addressdata: "\uB370\uC774\uD130 \uAC80\uC0C9"
}, $914aec8743edd630$var$d8 = {
    message: "\uBA54\uC2DC\uC9C0\uB97C \uC785\uB825\uD558\uC138\uC694",
    backconversation: "\uB300\uD654\uB85C \uB3CC\uC544\uAC00\uC11C",
    answer: " \uADC0\uD558\uC758 \uC9C8\uBB38\uC5D0 \uB2F5\uBCC0"
}, $914aec8743edd630$var$f8 = {
    firstline: "\uCD5C\uC801\uC758 \uACBD\uD5D8\uC744 \uC704\uD574,",
    secondline: "\uD654\uBA74\uC744 \uB4A4\uC9D1\uC5B4"
}, $914aec8743edd630$var$h8 = {
    shorttitle: "\uB77C\uC774\uBE0C \uB274\uC2A4 \uCC44\uB110",
    warningtext: "\uB274\uC2A4 \uCC44\uB110\uC5D0 \uC811\uC18D\uD558\uAC8C \uB418\uBA70 \uAE30\uAE30\uC758 \uC18C\uB9AC\uAC00 \uD65C\uC131\uD654\uB429\uB2C8\uB2E4.",
    live: "\uC0B4\uB2E4",
    continuous: "\uACC4\uC18D\uD574\uC11C"
}, $914aec8743edd630$var$p8 = {
    comment: "\uACE0\uAC1D \uB9AC\uBDF0",
    route: "\uB3C4\uB85C",
    nodata: "\uAC80\uC0C9\uC5B4\uC640 \uC77C\uCE58\uD558\uB294 \uCF58\uD150\uCE20\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
    openinghours: "\uAC1C\uAD00 \uC2DC\uAC04",
    prices: "\uBB3C\uAC00",
    paymentmethods: "\uACB0\uC81C \uBC29\uBC95",
    numberofplaces: "\uC7A5\uC18C\uC758 \uC218",
    openroutemobile: "\uC2A4\uB9C8\uD2B8\uD3F0\uC5D0\uC11C Google \uC9C0\uB3C4 \uACBD\uB85C \uC5F4\uAE30",
    FoodEstablishment: "\uBA39\uC744 \uACF3",
    LodgingBusiness: "\uC7A0\uC744 \uC798 \uACF3",
    TouristDestination: "\uBB34\uC5C7\uC744 \uBCFC \uAC83\uC778\uAC00",
    TouristAttraction: "\uD574\uC57C \uD560 \uC77C",
    Product: "\uC9C0\uC5ED\uC0C1\uD488",
    Service: "\uC11C\uBE44\uC2A4",
    Event: "\uC774\uBCA4\uD2B8",
    City: "\uB3C4\uC2DC",
    Wine: "\uC640\uC778"
}, $914aec8743edd630$var$m8 = {
    consult: "\uD655\uC778\uD574 \uBCF4\uC138\uC694",
    thetutorial: "\uD29C\uD1A0\uB9AC\uC5BC"
}, $914aec8743edd630$var$g8 = {
    reset: "\uBAA8\uB450 \uCD08\uAE30\uD654",
    showresults: "\uACB0\uACFC \uD45C\uC2DC",
    suggestiontitle: "\uAC80\uC0C9 \uC81C\uC548",
    reminder: `\u{C78A}\u{C9C0} \u{B9C8}\u{C138}\u{C694}. 
 \u{C81C}\u{AC00} \u{ADC0}\u{D558}\u{C758} \u{C9C8}\u{BB38}\u{C5D0} \u{B2F5}\u{BCC0}\u{D574}\u{B4DC}\u{B9B4} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`
}, $914aec8743edd630$var$b8 = {
    listening: "\uB2F9\uC2E0 \uCC28\uB840\uC785\uB2C8\uB2E4, \uC800\uB294 \uB4E3\uACE0 \uC788\uC2B5\uB2C8\uB2E4...",
    correct: "\uC218\uC815",
    dontknow: "\uBAA8\uB974\uACA0\uC2B5\uB2C8\uB2E4"
}, $914aec8743edd630$var$v8 = {
    allow: "\uACC4\uC18D\uD558\uB824\uBA74 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uB9C8\uC774\uD06C\uC5D0 \uC811\uADFC\uD560 \uC218 \uC788\uB3C4\uB85D \uD5C8\uC6A9\uD574\uC8FC\uC138\uC694.",
    rejected: "\uB9C8\uC774\uD06C \uC811\uADFC\uC744 \uAC70\uBD80\uD588\uC2B5\uB2C8\uB2E4.",
    instructions: "\uC74C\uC131 \uBAA8\uB4DC\uB97C \uC0AC\uC6A9\uD558\uB824\uBA74 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uB9C8\uC774\uD06C\uC5D0 \uC811\uADFC\uD560 \uC218 \uC788\uB3C4\uB85D \uD5C8\uC6A9\uD574\uC8FC\uC138\uC694.",
    listening: "\uB098\uB294 \uB2F9\uC2E0\uC758 \uB9D0\uC744 \uB4E3\uACE0 \uC788\uC5B4\uC694",
    trigger: "\uB204\uB974\uAC70\uB098 \uB9D0\uD558\uC138\uC694",
    triggerwithoutname: "\uB9D0\uD558\uB824\uBA74 \uD0ED\uD558\uC138\uC694"
}, $914aec8743edd630$var$y8 = {
    rejected: "GPS \uC704\uCE58\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4\uB97C \uAC70\uBD80\uD588\uC2B5\uB2C8\uB2E4.",
    instructions: "\uB0A0\uC528 \uB370\uC774\uD130\uB098 \uC778\uD130\uB799\uD2F0\uBE0C \uB9F5\uC5D0 \uC561\uC138\uC2A4\uD558\uB824\uBA74 \uBE0C\uB77C\uC6B0\uC800\uAC00 GPS \uC704\uCE58\uC5D0 \uC561\uC138\uC2A4\uD558\uB3C4\uB85D \uD5C8\uC6A9\uD558\uC2ED\uC2DC\uC624."
}, $914aec8743edd630$var$w8 = {
    calltoaction: "\uC2DC\uC791\uD558\uB824\uBA74 \uD654\uBA74\uC744 \uB204\uB974\uC138\uC694",
    emptyveille: "\uD654\uBA74\uC744 \uD074\uB9AD\uD558\uAC70\uB098 \uB204\uB974\uC138\uC694..."
}, $914aec8743edd630$var$_8 = {
    shorttitle: "\uC77C\uAE30 \uC608\uBCF4",
    attribution: "\uB0A0\uC528 \uB370\uC774\uD130\uB294 Open-Meteo.com\uC5D0\uC11C \uC81C\uACF5\uD569\uB2C8\uB2E4"
}, $914aec8743edd630$var$k8 = {
    title: "\uBD07\uC5D0 \uC804\uC1A1\uB41C \uAC1C\uC778 \uB370\uC774\uD130 \uCC98\uB9AC",
    message: `\u{C774} \u{B300}\u{D654}\u{B97C} \u{C218}\u{B77D}\u{D568}\u{C73C}\u{B85C}\u{C368} \u{CC57}\u{BD07}\u{C5D0} \u{C804}\u{C1A1}\u{B41C} \u{BAA8}\u{B4E0} \u{B370}\u{C774}\u{D130}\u{AC00} \u{B3C4}\u{AD6C} \u{C0AC}\u{C6A9} \u{BD84}\u{C11D} \u{BC0F} \u{C9C0}\u{C2DD} \u{AE30}\u{BC18} \u{AC15}\u{D654}\u{B97C} \u{C704}\u{D574} \u{C0AC}\u{C6A9}\u{B420} \u{C218} \u{C788}\u{B2E4}\u{B294} \u{B370} \u{B3D9}\u{C758}\u{D569}\u{B2C8}\u{B2E4}.

\u{B300}\u{D654}\u{B294} \u{C0AD}\u{C81C} \u{C804} 6\u{AC1C}\u{C6D4}\u{AC04} \u{BCF4}\u{AD00}\u{B429}\u{B2C8}\u{B2E4}.`,
    link: "\uAC1C\uC778\uC815\uBCF4 \uBCF4\uD638\uC815\uCC45 \uBCF4\uAE30 \uB9C1\uD06C",
    buttonAccept: "\uC774\uD574\uD558\uACE0 \uB3D9\uC758\uD569\uB2C8\uB2E4",
    buttonRefuse: "\uAC70\uBD80\uD569\uB2C8\uB2E4",
    messageAccepted: "\uB3D9\uC758\uAC00 \uAE30\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
    messageRefused: "\uAC70\uBD80\uAC00 \uAE30\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4"
}, $914aec8743edd630$var$x8 = {
    1: "\uD648\uD398\uC774\uC9C0",
    2: "\uB77C\uC774\uBE0C \uB274\uC2A4 \uCC44\uB110",
    3: "\uC77C\uAE30 \uC608\uBCF4",
    4: "\uAE34\uAE09 \uC804\uD654\uBC88\uD638",
    1e3: "\uC5ED\uC0AC\uC801\uC778",
    1001: "\uC9C0\uB3C4 \uC2DC\uAC04",
    common: $914aec8743edd630$var$r8,
    emergency: $914aec8743edd630$var$n8,
    error: $914aec8743edd630$var$i8,
    history: $914aec8743edd630$var$o8,
    home: $914aec8743edd630$var$a8,
    inputs: $914aec8743edd630$var$s8,
    language: $914aec8743edd630$var$u8,
    link: $914aec8743edd630$var$c8,
    loader: $914aec8743edd630$var$l8,
    menu: $914aec8743edd630$var$d8,
    mobileLandscapePreventer: $914aec8743edd630$var$f8,
    news: $914aec8743edd630$var$h8,
    poi: $914aec8743edd630$var$p8,
    suggestion: $914aec8743edd630$var$m8,
    template: $914aec8743edd630$var$g8,
    anghello: $914aec8743edd630$var$b8,
    microphone: $914aec8743edd630$var$v8,
    position: $914aec8743edd630$var$y8,
    veille: $914aec8743edd630$var$w8,
    weather: $914aec8743edd630$var$_8,
    GDPR: $914aec8743edd630$var$k8
}, $914aec8743edd630$var$S8 = {
    all: "alle",
    back: "tilbake",
    close: "Lukk",
    continue: "Fortsette",
    download: "nedlasting",
    downloadsheet: "last ned dette arket",
    downloadsheetmobile: "last ned dette arket p\xe5 smarttelefonen",
    filter: "Filter",
    history: "historisk",
    knowmore: "Les mer",
    lang: "spr\xe5kene",
    menu: "Meny",
    mode: "mote",
    needhelp: "Trenger hjelp?",
    parameters: "innstillinger",
    print: "Skrive ut",
    printsheet: "Skriv ut dette arket",
    result: "resultat",
    results: "resultater",
    singleLang: "spr\xe5k",
    sound: "henne",
    submit: "sende inn",
    subtitle: "undertekst",
    tutorial: "oppl\xe6ringen",
    validate: "\xe5 validere",
    abort: "avbryt"
}, $914aec8743edd630$var$E8 = {
    shorttitle: "N\xf8dnumre",
    samu: "S.A.M.U.",
    police: "politiet",
    firefighter: "brannmenn",
    general: "generell",
    hospital: "Sykehus",
    homeless: "Hjeml\xf8s",
    poison: "Giftkontrollsenter",
    emergency: "N\xf8dhjelp"
}, $914aec8743edd630$var$A8 = {
    title: "Det har oppst\xe5tt en feil",
    button: "Start applikasjonen p\xe5 nytt"
}, $914aec8743edd630$var$T8 = {
    shorttitle: "historisk",
    title: "samtalehistorikk"
}, $914aec8743edd630$var$C8 = {
    shorttitle: "hjemmeside"
}, $914aec8743edd630$var$R8 = {
    choose: "Velg et svar",
    noaction: "Venter p\xe5 handling"
}, $914aec8743edd630$var$O8 = {
    change: "endre spr\xe5ket",
    select: "velg spr\xe5ket du \xf8nsker"
}, $914aec8743edd630$var$D8 = {
    buttontext: "Se dokumentet",
    goto: "G\xe5 til adressen",
    click: "Klikk her",
    scanQR: "ved \xe5 skanne QRCode",
    scanQRTile: "Skann QR-koden for \xe5 oppdage"
}, $914aec8743edd630$var$P8 = {
    loader: {
        optimal: "For en optimal opplevelse,",
        classic: "For en mer klassisk opplevelse,",
        vocal: "Jeg snakker ansikt til ansikt med agenten.",
        text: "Jeg kommuniserer skriftlig med agenten."
    },
    modes: {
        vocal: "vokalmodus",
        text: "tekstmodus"
    },
    loaderValidation: "Start samtale",
    locale: "sjekke spr\xe5k",
    supported: "sjekke st\xf8ttede spr\xe5k",
    addressdata: "henter data"
}, $914aec8743edd630$var$I8 = {
    message: "Skriv inn meldingen din",
    backconversation: "tilbake til samtalen",
    answer: " svarer p\xe5 sp\xf8rsm\xe5lene dine"
}, $914aec8743edd630$var$M8 = {
    firstline: "For en optimal opplevelse,",
    secondline: "snu skjermen"
}, $914aec8743edd630$var$j8 = {
    shorttitle: "direktesendt nyhetskanal",
    warningtext: "Du f\xe5r tilgang til nyhetskanalen, lyden p\xe5 enheten din aktiveres",
    live: "bo",
    continuous: "kontinuerlig"
}, $914aec8743edd630$var$F8 = {
    comment: "kundeanmeldelse",
    route: "vei",
    nodata: "Ingen innhold samsvarer med s\xf8ket ditt",
    openinghours: "\xc5pningstider",
    prices: "Priser",
    paymentmethods: "Betalingsmetoder",
    numberofplaces: "antall plasser",
    openroutemobile: "\xe5pne Google Maps-ruten p\xe5 smarttelefonen",
    FoodEstablishment: "Hvor skal vi spise",
    LodgingBusiness: "Hvor skal man sove",
    TouristDestination: "Hva er det \xe5 se",
    TouristAttraction: "Hva \xe5 gj\xf8re",
    Product: "Lokale produkter",
    Service: "Tjenester",
    Event: "arrangementer",
    City: "Byer",
    Wine: "Viner"
}, $914aec8743edd630$var$$8 = {
    consult: "Sjekk ut",
    thetutorial: "oppl\xe6ringen"
}, $914aec8743edd630$var$L8 = {
    reset: "Tilbakestill alt",
    showresults: "Vis resultatene",
    suggestiontitle: "S\xf8keforslag",
    reminder: `Ikke glem, 
 jeg kan svare p\xe5 sp\xf8rsm\xe5lene dine.`
}, $914aec8743edd630$var$N8 = {
    listening: "Det er opp til deg, jeg lytter...",
    correct: "Korrigere",
    dontknow: "Jeg vet ikke"
}, $914aec8743edd630$var$B8 = {
    allow: "Vennligst tillat nettleseren din \xe5 f\xe5 tilgang til mikrofonen for \xe5 fortsette.",
    rejected: "Du har nektet tilgang til mikrofonen.",
    instructions: "For \xe5 bruke talemodus, vennligst tillat nettleseren din \xe5 f\xe5 tilgang til mikrofonen.",
    listening: "Jeg lytter",
    trigger: "Trykk eller si",
    triggerwithoutname: "Trykk for \xe5 snakke"
}, $914aec8743edd630$var$q8 = {
    rejected: "Du har avvist tilgang til din GPS-posisjon.",
    instructions: "For \xe5 f\xe5 tilgang til v\xe6rdata eller interaktivt kart, vennligst gi din nettleser tilgang til din GPS-posisjon."
}, $914aec8743edd630$var$z8 = {
    calltoaction: "Trykk p\xe5 skjermen for \xe5 starte",
    emptyveille: "Klikk eller trykk p\xe5 skjermen..."
}, $914aec8743edd630$var$U8 = {
    shorttitle: "V\xe6rmelding",
    attribution: "V\xe6rdata levert av Open-Meteo.com"
}, $914aec8743edd630$var$V8 = {
    title: "behandling av personopplysninger sendt til boten",
    message: `ved \xe5 akseptere denne dialogen samtykker du til at alle data sendt til chatboten kan brukes til analyse av bruken av verkt\xf8yet og berikelse av kunnskapsbasen.

Samtalene dine oppbevares i 6 m\xe5neder f\xf8r sletting.`,
    link: "lenke for \xe5 se personvernregler",
    buttonAccept: "jeg forst\xe5r og aksepterer",
    buttonRefuse: "jeg avsl\xe5r",
    messageAccepted: "ditt samtykke er tatt til etterretning",
    messageRefused: "ditt avslag er tatt til etterretning"
}, $914aec8743edd630$var$G8 = {
    1: "hjemmeside",
    2: "direktesendt nyhetskanal",
    3: "V\xe6rmelding",
    4: "N\xf8dnumre",
    1e3: "historisk",
    1001: "oppl\xe6ringen",
    common: $914aec8743edd630$var$S8,
    emergency: $914aec8743edd630$var$E8,
    error: $914aec8743edd630$var$A8,
    history: $914aec8743edd630$var$T8,
    home: $914aec8743edd630$var$C8,
    inputs: $914aec8743edd630$var$R8,
    language: $914aec8743edd630$var$O8,
    link: $914aec8743edd630$var$D8,
    loader: $914aec8743edd630$var$P8,
    menu: $914aec8743edd630$var$I8,
    mobileLandscapePreventer: $914aec8743edd630$var$M8,
    news: $914aec8743edd630$var$j8,
    poi: $914aec8743edd630$var$F8,
    suggestion: $914aec8743edd630$var$$8,
    template: $914aec8743edd630$var$L8,
    anghello: $914aec8743edd630$var$N8,
    microphone: $914aec8743edd630$var$B8,
    position: $914aec8743edd630$var$q8,
    veille: $914aec8743edd630$var$z8,
    weather: $914aec8743edd630$var$U8,
    GDPR: $914aec8743edd630$var$V8
}, $914aec8743edd630$var$W8 = {
    all: "alle",
    back: "rug",
    close: "sluiten",
    continue: "doorgaan",
    download: "downloaden",
    downloadsheet: "download dit blad",
    downloadsheetmobile: "download dit blad op uw smartphone",
    filter: "Filter",
    history: "historisch",
    knowmore: "Lees meer",
    lang: "TALEN",
    menu: "menu",
    mode: "mode",
    needhelp: "Hulp nodig?",
    parameters: "instellingen",
    print: "Afdrukken",
    printsheet: "Druk dit blad af",
    result: "resultaat",
    results: "resultaten",
    singleLang: "taal",
    sound: "zijn",
    submit: "indienen",
    subtitle: "ondertitel",
    tutorial: "zelfstudie",
    validate: "bevestigen",
    abort: "annuleren"
}, $914aec8743edd630$var$H8 = {
    shorttitle: "N\xf8dnumre",
    samu: "S.A.M.U.",
    police: "politie",
    firefighter: "brandweerlieden",
    general: "algemeen",
    hospital: "Ziekenhuis",
    homeless: "Dakloos",
    poison: "Vergifcontrolecentrum",
    emergency: "Hulpdiensten"
}, $914aec8743edd630$var$K8 = {
    title: "er is een fout opgetreden",
    button: "Start de applicatie opnieuw"
}, $914aec8743edd630$var$Q8 = {
    shorttitle: "historisch",
    title: "gespreksgeschiedenis"
}, $914aec8743edd630$var$Y8 = {
    shorttitle: "hjemmeside"
}, $914aec8743edd630$var$J8 = {
    choose: "Kies een antwoord",
    noaction: "Wacht op actie"
}, $914aec8743edd630$var$Z8 = {
    change: "verander de taal",
    select: "selecteer de taal van uw keuze"
}, $914aec8743edd630$var$X8 = {
    buttontext: "Bekijk het document",
    goto: "Ga naar adres",
    click: "Klik hier",
    scanQR: "door de QRCode te scannen",
    scanQRTile: "Scan de QR-code om te ontdekken"
}, $914aec8743edd630$var$eR = {
    loader: {
        optimal: "Voor een optimale ervaring,",
        classic: "Voor een meer klassieke ervaring,",
        vocal: "Ik spreek oog in oog met de agent.",
        text: "Ik communiceer schriftelijk met de makelaar."
    },
    modes: {
        vocal: "vocale modus",
        text: "tekstmodus"
    },
    loaderValidation: "Begin een gesprek",
    locale: "taal controleren",
    supported: "ondersteunde talen controleren",
    addressdata: "het ophalen van gegevens"
}, $914aec8743edd630$var$tR = {
    message: "Voer uw bericht in",
    backconversation: "terug naar het gesprek",
    answer: " beantwoordt uw vragen"
}, $914aec8743edd630$var$rR = {
    firstline: "Voor een optimale ervaring,",
    secondline: "draai je scherm om"
}, $914aec8743edd630$var$nR = {
    shorttitle: "direktesendt nyhetskanal",
    warningtext: "U krijgt toegang tot de nieuwszender, het geluid op uw apparaat wordt geactiveerd",
    live: "live",
    continuous: "doorlopend"
}, $914aec8743edd630$var$iR = {
    comment: "klant beoordeling",
    route: "weg",
    nodata: "Er is geen inhoud die overeenkomt met uw zoekopdracht",
    openinghours: "Openingstijden",
    prices: "Prijzen",
    paymentmethods: "Betaalmethoden",
    numberofplaces: "aantal plaatsen",
    openroutemobile: "open Google Maps-route op smartphone",
    FoodEstablishment: "Waar te eten",
    LodgingBusiness: "Waar te slapen",
    TouristDestination: "Wat te zien",
    TouristAttraction: "Wat moeten we doen",
    Product: "Regionale producten",
    Service: "Diensten",
    Event: "Evenementen",
    City: "Steden",
    Wine: "Wijnen"
}, $914aec8743edd630$var$oR = {
    consult: "Uitchecken",
    thetutorial: "de tutorial"
}, $914aec8743edd630$var$aR = {
    reset: "alles resetten",
    showresults: "Laat de resultaten zien",
    suggestiontitle: "Zoeksuggesties",
    reminder: "Vergeet niet dat ik je vragen kan beantwoorden."
}, $914aec8743edd630$var$sR = {
    listening: "Het is aan jou, ik luister...",
    correct: "Corrigeren",
    dontknow: "Ik weet het niet"
}, $914aec8743edd630$var$uR = {
    allow: "Sta uw browser toe om toegang te krijgen tot de microfoon om door te gaan.",
    rejected: "U hebt toegang tot de microfoon geweigerd.",
    instructions: "Om de spraakmodus te gebruiken, staat u uw browser toe toegang te krijgen tot de microfoon.",
    listening: "Ik luister",
    trigger: "Druk of zeg",
    triggerwithoutname: "Tik om te praten"
}, $914aec8743edd630$var$cR = {
    rejected: "U hebt toegang tot uw GPS-locatie geweigerd.",
    instructions: "Om toegang te krijgen tot weergegevens of de interactieve kaart, staat u uw browser alstublieft toe om toegang te krijgen tot uw GPS-locatie."
}, $914aec8743edd630$var$lR = {
    calltoaction: "Druk op het scherm om te beginnen",
    emptyveille: "Klik of druk op het scherm..."
}, $914aec8743edd630$var$dR = {
    shorttitle: "V\xe6rmelding",
    attribution: "Weergegevens verstrekt door Open-Meteo.com"
}, $914aec8743edd630$var$fR = {
    title: "verwerking van persoonlijke gegevens verzonden naar de bot",
    message: `door dit dialoogvenster te accepteren, stemt u ermee in dat alle gegevens die aan de chatbot worden verzonden, kunnen worden gebruikt voor analyse van het gebruik van het hulpmiddel en verrijking van de kennisbasis.

Uw gesprekken worden 6 maanden bewaard voor verwijdering.`,
    link: "koppeling om het privacybeleid te bekijken",
    buttonAccept: "ik begrijp het en accepteer",
    buttonRefuse: "ik weiger",
    messageAccepted: "uw toestemming is in aanmerking genomen",
    messageRefused: "uw weigering is in aanmerking genomen"
}, $914aec8743edd630$var$hR = {
    1: "hjemmeside",
    2: "direktesendt nyhetskanal",
    3: "V\xe6rmelding",
    4: "N\xf8dnumre",
    1e3: "historisk",
    1001: "tutorial",
    common: $914aec8743edd630$var$W8,
    emergency: $914aec8743edd630$var$H8,
    error: $914aec8743edd630$var$K8,
    history: $914aec8743edd630$var$Q8,
    home: $914aec8743edd630$var$Y8,
    inputs: $914aec8743edd630$var$J8,
    language: $914aec8743edd630$var$Z8,
    link: $914aec8743edd630$var$X8,
    loader: $914aec8743edd630$var$eR,
    menu: $914aec8743edd630$var$tR,
    mobileLandscapePreventer: $914aec8743edd630$var$rR,
    news: $914aec8743edd630$var$nR,
    poi: $914aec8743edd630$var$iR,
    suggestion: $914aec8743edd630$var$oR,
    template: $914aec8743edd630$var$aR,
    anghello: $914aec8743edd630$var$sR,
    microphone: $914aec8743edd630$var$uR,
    position: $914aec8743edd630$var$cR,
    veille: $914aec8743edd630$var$lR,
    weather: $914aec8743edd630$var$dR,
    GDPR: $914aec8743edd630$var$fR
}, $914aec8743edd630$var$pR = {
    all: "alle",
    back: "rug",
    close: "sluiten",
    continue: "doorgaan",
    download: "downloaden",
    downloadsheet: "download dit blad",
    downloadsheetmobile: "download dit blad op uw smartphone",
    filter: "Filter",
    history: "historisch",
    knowmore: "Lees meer",
    lang: "TALEN",
    menu: "menu",
    mode: "mode",
    needhelp: "Hulp nodig?",
    parameters: "instellingen",
    print: "Afdrukken",
    printsheet: "Druk dit blad af",
    result: "resultaat",
    results: "resultaten",
    singleLang: "taal",
    sound: "zijn",
    submit: "indienen",
    subtitle: "ondertitel",
    tutorial: "zelfstudie",
    validate: "bevestigen",
    abort: "annuleren"
}, $914aec8743edd630$var$mR = {
    shorttitle: "N\xf8dnumre",
    samu: "S.A.M.U.",
    police: "politie",
    firefighter: "brandweerlieden",
    general: "algemeen",
    hospital: "Ziekenhuis",
    homeless: "Dakloos",
    poison: "Vergifcontrolecentrum",
    emergency: "Hulpdiensten"
}, $914aec8743edd630$var$gR = {
    title: "er is een fout opgetreden",
    button: "Start de applicatie opnieuw"
}, $914aec8743edd630$var$bR = {
    shorttitle: "historisch",
    title: "gespreksgeschiedenis"
}, $914aec8743edd630$var$vR = {
    shorttitle: "hjemmeside"
}, $914aec8743edd630$var$yR = {
    choose: "Kies een antwoord",
    noaction: "Wacht op actie"
}, $914aec8743edd630$var$wR = {
    change: "verander de taal",
    select: "selecteer de taal van uw keuze"
}, $914aec8743edd630$var$_R = {
    buttontext: "Bekijk het document",
    goto: "Ga naar adres",
    click: "Klik hier",
    scanQR: "door de QRCode te scannen",
    scanQRTile: "Scan de QR-code om te ontdekken"
}, $914aec8743edd630$var$kR = {
    loader: {
        optimal: "Voor een optimale ervaring,",
        classic: "Voor een meer klassieke ervaring,",
        vocal: "Ik spreek oog in oog met de agent.",
        text: "Ik communiceer schriftelijk met de makelaar."
    },
    modes: {
        vocal: "vocale modus",
        text: "tekstmodus"
    },
    loaderValidation: "Begin een gesprek",
    locale: "taal controleren",
    supported: "ondersteunde talen controleren",
    addressdata: "het ophalen van gegevens"
}, $914aec8743edd630$var$xR = {
    message: "Voer uw bericht in",
    backconversation: "terug naar het gesprek",
    answer: " beantwoordt uw vragen"
}, $914aec8743edd630$var$SR = {
    firstline: "Voor een optimale ervaring,",
    secondline: "draai je scherm om"
}, $914aec8743edd630$var$ER = {
    shorttitle: "direktesendt nyhetskanal",
    warningtext: "U krijgt toegang tot de nieuwszender, het geluid op uw apparaat wordt geactiveerd",
    live: "live",
    continuous: "doorlopend"
}, $914aec8743edd630$var$AR = {
    comment: "klant beoordeling",
    route: "weg",
    nodata: "Er is geen inhoud die overeenkomt met uw zoekopdracht",
    openinghours: "Openingstijden",
    prices: "Prijzen",
    paymentmethods: "Betaalmethoden",
    numberofplaces: "aantal plaatsen",
    openroutemobile: "open Google Maps-route op smartphone",
    FoodEstablishment: "Waar te eten",
    LodgingBusiness: "Waar te slapen",
    TouristDestination: "Wat te zien",
    TouristAttraction: "Wat moeten we doen",
    Product: "Regionale producten",
    Service: "Diensten",
    Event: "Evenementen",
    City: "Steden",
    Wine: "Wijnen"
}, $914aec8743edd630$var$TR = {
    consult: "Uitchecken",
    thetutorial: "de tutorial"
}, $914aec8743edd630$var$CR = {
    reset: "alles resetten",
    showresults: "Laat de resultaten zien",
    suggestiontitle: "Zoeksuggesties",
    reminder: "Vergeet niet dat ik je vragen kan beantwoorden."
}, $914aec8743edd630$var$RR = {
    listening: "Het is aan jou, ik luister...",
    correct: "Corrigeren",
    dontknow: "Ik weet het niet"
}, $914aec8743edd630$var$OR = {
    allow: "Sta uw browser toe om toegang te krijgen tot de microfoon om door te gaan.",
    rejected: "U hebt toegang tot de microfoon geweigerd.",
    instructions: "Om de spraakmodus te gebruiken, staat u uw browser toe toegang te krijgen tot de microfoon.",
    listening: "Ik luister",
    trigger: "Druk of zeg",
    triggerwithoutname: "Tik om te praten"
}, $914aec8743edd630$var$DR = {
    rejected: "U hebt toegang tot uw GPS-locatie geweigerd.",
    instructions: "Om toegang te krijgen tot weergegevens of de interactieve kaart, staat u uw browser alstublieft toe om toegang te krijgen tot uw GPS-locatie."
}, $914aec8743edd630$var$PR = {
    calltoaction: "Druk op het scherm om te beginnen",
    emptyveille: "Klik of druk op het scherm..."
}, $914aec8743edd630$var$IR = {
    shorttitle: "V\xe6rmelding",
    attribution: "Weergegevens verstrekt door Open-Meteo.com"
}, $914aec8743edd630$var$MR = {
    title: "verwerking van persoonlijke gegevens verzonden naar de bot",
    message: `door dit dialoogvenster te accepteren, stemt u ermee in dat alle gegevens die aan de chatbot worden verzonden, kunnen worden gebruikt voor analyse van het gebruik van het hulpmiddel en verrijking van de kennisbasis.

Uw gesprekken worden 6 maanden bewaard voor verwijdering.`,
    link: "koppeling om het privacybeleid te bekijken",
    buttonAccept: "ik begrijp het en accepteer",
    buttonRefuse: "ik weiger",
    messageAccepted: "uw toestemming is in aanmerking genomen",
    messageRefused: "uw weigering is in aanmerking genomen"
}, $914aec8743edd630$var$jR = {
    1: "hjemmeside",
    2: "direktesendt nyhetskanal",
    3: "V\xe6rmelding",
    4: "N\xf8dnumre",
    1e3: "historisk",
    1001: "tutorial",
    common: $914aec8743edd630$var$pR,
    emergency: $914aec8743edd630$var$mR,
    error: $914aec8743edd630$var$gR,
    history: $914aec8743edd630$var$bR,
    home: $914aec8743edd630$var$vR,
    inputs: $914aec8743edd630$var$yR,
    language: $914aec8743edd630$var$wR,
    link: $914aec8743edd630$var$_R,
    loader: $914aec8743edd630$var$kR,
    menu: $914aec8743edd630$var$xR,
    mobileLandscapePreventer: $914aec8743edd630$var$SR,
    news: $914aec8743edd630$var$ER,
    poi: $914aec8743edd630$var$AR,
    suggestion: $914aec8743edd630$var$TR,
    template: $914aec8743edd630$var$CR,
    anghello: $914aec8743edd630$var$RR,
    microphone: $914aec8743edd630$var$OR,
    position: $914aec8743edd630$var$DR,
    veille: $914aec8743edd630$var$PR,
    weather: $914aec8743edd630$var$IR,
    GDPR: $914aec8743edd630$var$MR
}, $914aec8743edd630$var$FR = {
    abort: "anuluj",
    all: "Wszystko",
    back: "z powrotem",
    close: "zamkn\u0105\u0107",
    continue: "Kontynuowa\u0107",
    download: "pobiera\u0107",
    downloadsheet: "pobierz ten arkusz",
    downloadsheetmobile: "pobierz ten arkusz na smartfonie",
    filter: "Filtr",
    history: "historyczny",
    knowmore: "Dowiedz si\u0119 wi\u0119cej",
    lang: "J\u0119zyki",
    menu: "menu",
    mode: "moda",
    needhelp: "Potrzebuj\u0119 pomocy?",
    parameters: "ustawienia",
    print: "Wydrukowa\u0107",
    printsheet: "Wydrukuj ten arkusz",
    result: "wynik",
    results: "wyniki",
    singleLang: "j\u0119zyk",
    sound: "jej",
    submit: "sk\u0142ada\u0107",
    subtitle: "podtytu\u0142",
    tutorial: "instrukta\u017C",
    validate: "potwierdzi\u0107"
}, $914aec8743edd630$var$$R = {
    shorttitle: "numery alarmowe",
    samu: "S.A.M.U.",
    police: "Policja",
    firefighter: "stra\u017Cacy",
    general: "og\xf3lny",
    hospital: "Szpital",
    homeless: "Bezdomny",
    poison: "Centrum Kontroli Trucizn",
    emergency: "S\u0142u\u017Cby ratunkowe"
}, $914aec8743edd630$var$LR = {
    title: "Wyst\u0105pi\u0142 b\u0142\u0105d",
    button: "Uruchom ponownie aplikacj\u0119"
}, $914aec8743edd630$var$NR = {
    shorttitle: "historia",
    title: "Historia konwersacji"
}, $914aec8743edd630$var$BR = {
    shorttitle: "strona g\u0142\xf3wna"
}, $914aec8743edd630$var$qR = {
    choose: "Wybierz odpowied\u017A",
    noaction: "Oczekuje na dzia\u0142anie"
}, $914aec8743edd630$var$zR = {
    change: "zmieni\u0107 j\u0119zyk",
    select: "wybierz wybrany j\u0119zyk"
}, $914aec8743edd630$var$UR = {
    buttontext: "Obejrzyj dokument",
    goto: "Przejd\u017A do adresu",
    click: "Kliknij tutaj",
    scanQR: "poprzez zeskanowanie kodu QR",
    scanQRTile: "Zeskanuj kod QR, aby odkry\u0107"
}, $914aec8743edd630$var$VR = {
    loader: {
        optimal: "Aby uzyska\u0107 optymalne wra\u017Cenia,",
        classic: "Aby uzyska\u0107 bardziej klasyczne wra\u017Cenia,",
        vocal: "Rozmawiam twarz\u0105 w twarz z agentem.",
        text: "Komunikuj\u0119 si\u0119 pisemnie z agentem."
    },
    modes: {
        vocal: "tryb wokalny",
        text: "tryb tekstowy"
    },
    loaderValidation: "Rozpocznij rozmow\u0119",
    locale: "sprawdzanie j\u0119zyka",
    supported: "sprawdzanie obs\u0142ugiwanych j\u0119zyk\xf3w",
    addressdata: "pobieranie danych"
}, $914aec8743edd630$var$GR = {
    message: "Wpisz swoj\u0105 wiadomo\u015B\u0107",
    backconversation: "wr\xf3\u0107 do rozmowy",
    answer: " odpowiada na Twoje pytania"
}, $914aec8743edd630$var$WR = {
    firstline: "Aby uzyska\u0107 optymalne wra\u017Cenia,",
    secondline: "obr\xf3\u0107 ekran"
}, $914aec8743edd630$var$HR = {
    shorttitle: "kana\u0142 informacyjny na \u017Cywo",
    warningtext: "Uzyskasz dost\u0119p do kana\u0142u informacyjnego, d\u017Awi\u0119k na Twoim urz\u0105dzeniu zostanie aktywowany",
    live: "na \u017Cywo",
    continuous: "bez przerwy"
}, $914aec8743edd630$var$KR = {
    comment: "Recenzja klienta",
    route: "droga",
    nodata: "\u017Badna tre\u015B\u0107 nie pasuje do Twojego wyszukiwania",
    openinghours: "Godziny otwarcia",
    prices: "Ceny",
    paymentmethods: "Metody P\u0142atno\u015Bci",
    numberofplaces: "liczba miejsc",
    openroutemobile: "otw\xf3rz tras\u0119 Map Google na smartfonie",
    FoodEstablishment: "Gdzie zje\u015B\u0107",
    LodgingBusiness: "Gdzie spa\u0107",
    TouristDestination: "Co zobaczy\u0107",
    TouristAttraction: "Co robi\u0107",
    Product: "Lokalne produkty",
    Service: "Us\u0142ugi",
    Event: "Wydarzenia",
    City: "Miasta",
    Wine: "Wina"
}, $914aec8743edd630$var$QR = {
    consult: "Wymeldowa\u0107 si\u0119",
    thetutorial: "samouczek"
}, $914aec8743edd630$var$YR = {
    reset: "Zresetowa\u0107 wszystko",
    showresults: "Poka\u017C wyniki",
    suggestiontitle: "Wyszukaj sugestie",
    reminder: `Nie zapomnij, 
, \u{17C}e mog\u{119} odpowiedzie\u{107} na Twoje pytania.`
}, $914aec8743edd630$var$JR = {
    listening: "To zale\u017Cy od ciebie, s\u0142ucham...",
    correct: "Poprawi\u0107",
    dontknow: "Nie wiem"
}, $914aec8743edd630$var$ZR = {
    allow: "Prosz\u0119 pozwoli\u0107 swojej przegl\u0105darce na dost\u0119p do mikrofonu, aby kontynuowa\u0107.",
    rejected: "Odm\xf3wi\u0142e\u015B dost\u0119pu do mikrofonu.",
    instructions: "Aby u\u017Cywa\u0107 trybu g\u0142osowego, prosz\u0119 pozwoli\u0107 swojej przegl\u0105darce na dost\u0119p do mikrofonu.",
    listening: "S\u0142ucham",
    trigger: "Naci\u015Bnij lub powiedz",
    triggerwithoutname: "Dotknij, aby m\xf3wi\u0107"
}, $914aec8743edd630$var$XR = {
    rejected: "Odrzuci\u0142e\u015B dost\u0119p do Twojej lokalizacji GPS.",
    instructions: "Aby uzyska\u0107 dost\u0119p do danych pogodowych lub mapy interaktywnej, prosz\u0119 pozw\xf3l przegl\u0105darce uzyska\u0107 dost\u0119p do Twojej lokalizacji GPS."
}, $914aec8743edd630$var$eO = {
    calltoaction: "Naci\u015Bnij ekran, aby rozpocz\u0105\u0107",
    emptyveille: "Kliknij lub naci\u015Bnij ekran..."
}, $914aec8743edd630$var$tO = {
    shorttitle: "pogoda",
    attribution: "Dane pogodowe dostarczone przez Open-Meteo.com"
}, $914aec8743edd630$var$rO = {
    title: "przetwarzanie danych osobowych przes\u0142anych do bota",
    message: `akceptuj\u{105}c ten dialog, wyra\u{17C}asz zgod\u{119} na to, \u{17C}e wszystkie dane przes\u{142}ane do chatbota mog\u{105} by\u{107} wykorzystywane do analizy korzystania z narz\u{119}dzia i wzbogacania bazy wiedzy.

Twoje rozmowy s\u{105} przechowywane przez 6 miesi\u{119}cy przed usuni\u{119}ciem.`,
    link: "link do przegl\u0105dania zasad prywatno\u015Bci",
    buttonAccept: "rozumiem i akceptuj\u0119",
    buttonRefuse: "odmawiam",
    messageAccepted: "twoja zgoda zosta\u0142a uwzgl\u0119dniona",
    messageRefused: "twoja odmowa zosta\u0142a uwzgl\u0119dniona"
}, $914aec8743edd630$var$nO = {
    1: "strona g\u0142\xf3wna",
    2: "kana\u0142 informacyjny na \u017Cywo",
    3: "pogoda",
    4: "numery alarmowe",
    1e3: "historia",
    1001: "instrukta\u017C",
    common: $914aec8743edd630$var$FR,
    emergency: $914aec8743edd630$var$$R,
    error: $914aec8743edd630$var$LR,
    history: $914aec8743edd630$var$NR,
    home: $914aec8743edd630$var$BR,
    inputs: $914aec8743edd630$var$qR,
    language: $914aec8743edd630$var$zR,
    link: $914aec8743edd630$var$UR,
    loader: $914aec8743edd630$var$VR,
    menu: $914aec8743edd630$var$GR,
    mobileLandscapePreventer: $914aec8743edd630$var$WR,
    news: $914aec8743edd630$var$HR,
    poi: $914aec8743edd630$var$KR,
    suggestion: $914aec8743edd630$var$QR,
    template: $914aec8743edd630$var$YR,
    anghello: $914aec8743edd630$var$JR,
    microphone: $914aec8743edd630$var$ZR,
    position: $914aec8743edd630$var$XR,
    veille: $914aec8743edd630$var$eO,
    weather: $914aec8743edd630$var$tO,
    GDPR: $914aec8743edd630$var$rO
}, $914aec8743edd630$var$iO = {
    abort: "cancelar",
    all: "todos",
    back: "voltar",
    close: "fechar",
    continue: "continuar",
    download: "download",
    downloadsheet: "baixe esta planilha",
    downloadsheetmobile: "baixe esta planilha no smartphone",
    filter: "filtro",
    history: "hist\xf3rico",
    knowmore: "Saiba mais",
    lang: "l\xednguas",
    menu: "card\xe1pio",
    mode: "moda",
    needhelp: "Preciso de ajuda?",
    parameters: "configura\xe7\xf5es",
    print: "Imprimir",
    printsheet: "Imprima esta folha",
    result: "resultado",
    results: "resultados",
    singleLang: "linguagem",
    sound: "dela",
    submit: "enviar",
    subtitle: "legenda",
    tutorial: "tutorial",
    validate: "validar"
}, $914aec8743edd630$var$oO = {
    shorttitle: "N\xfameros de emerg\xeancia",
    samu: "S.A.M.U.",
    police: "pol\xedcia",
    firefighter: "bombeiros",
    general: "general",
    hospital: "Hospital",
    homeless: "Morador de rua",
    poison: "Centro de Controle de Venenos",
    emergency: "Servi\xe7os de emerg\xeancia"
}, $914aec8743edd630$var$aO = {
    title: "ocorreu um erro",
    button: "Reinicie o aplicativo"
}, $914aec8743edd630$var$sO = {
    shorttitle: "hist\xf3ria",
    title: "hist\xf3rico de conversas"
}, $914aec8743edd630$var$uO = {
    shorttitle: "pagina inicial"
}, $914aec8743edd630$var$cO = {
    choose: "Escolha uma resposta",
    noaction: "Aguardando a\xe7\xe3o"
}, $914aec8743edd630$var$lO = {
    change: "alterar o idioma",
    select: "selecione o idioma de sua prefer\xeancia"
}, $914aec8743edd630$var$dO = {
    buttontext: "Veja o documento",
    goto: "Ir para o endere\xe7o",
    click: "Clique aqui",
    scanQR: "digitalizando o QrCode",
    scanQRTile: "Escaneie o c\xf3digo QR para descobrir"
}, $914aec8743edd630$var$fO = {
    loader: {
        optimal: "Para uma experi\xeancia ideal,",
        classic: "Para uma experi\xeancia mais cl\xe1ssica,",
        vocal: "Falo cara a cara com o agente.",
        text: "Eu me comunico por escrito com o agente."
    },
    modes: {
        vocal: "modo vocal",
        text: "modo de texto"
    },
    loaderValidation: "Iniciar conversa",
    locale: "verificando o idioma",
    supported: "verificando idiomas suportados",
    addressdata: "recuperando dados"
}, $914aec8743edd630$var$hO = {
    message: "Digite sua mensagem",
    backconversation: "de volta \xe0 conversa",
    answer: " responde \xe0s suas perguntas"
}, $914aec8743edd630$var$pO = {
    firstline: "Para uma experi\xeancia ideal,",
    secondline: "vire sua tela"
}, $914aec8743edd630$var$mO = {
    shorttitle: "canal de informa\xe7\xf5es ao vivo",
    warningtext: "Voc\xea acessar\xe1 o canal de not\xedcias, o som do seu aparelho ser\xe1 ativado",
    live: "ao vivo",
    continuous: "continuamente"
}, $914aec8743edd630$var$gO = {
    comment: "avalia\xe7\xe3o do cliente",
    route: "estrada",
    nodata: "Nenhum conte\xfado corresponde \xe0 sua pesquisa",
    openinghours: "Hor\xe1rio de funcionamento",
    prices: "Pre\xe7os",
    paymentmethods: "M\xe9todos de Pagamento",
    numberofplaces: "n\xfamero de lugares",
    openroutemobile: "abra a rota do Google Maps no smartphone",
    FoodEstablishment: "Onde comer",
    LodgingBusiness: "Onde dormir",
    TouristDestination: "O que ver",
    TouristAttraction: "O que fazer",
    Product: "Produtos locais",
    Service: "Servi\xe7os",
    Event: "Eventos",
    City: "Cidades",
    Wine: "Vinhos"
}, $914aec8743edd630$var$bO = {
    consult: "Confira",
    thetutorial: "o tutorial"
}, $914aec8743edd630$var$vO = {
    reset: "reiniciar tudo",
    showresults: "Mostrar os resultados",
    suggestiontitle: "Sugest\xf5es de pesquisa",
    reminder: `N\xe3o se esque\xe7a, 
, posso responder \xe0s suas perguntas.`
}, $914aec8743edd630$var$yO = {
    listening: "Est\xe1 com voc\xea, estou ouvindo...",
    correct: "Corrigir",
    dontknow: "Eu n\xe3o sei"
}, $914aec8743edd630$var$wO = {
    allow: "Por favor, permita que seu navegador acesse o microfone para continuar.",
    rejected: "Voc\xea negou o acesso ao microfone.",
    instructions: "Para usar o modo de voz, por favor, permita que seu navegador acesse o microfone.",
    listening: "Estou ouvindo",
    trigger: "Clique ou diga",
    triggerwithoutname: "Toque para falar"
}, $914aec8743edd630$var$_O = {
    rejected: "Voc\xea recusou o acesso \xe0 sua localiza\xe7\xe3o GPS.",
    instructions: "Para acessar os dados meteorol\xf3gicos ou o mapa interativo, por favor permita que o seu navegador acesse sua localiza\xe7\xe3o GPS."
}, $914aec8743edd630$var$kO = {
    calltoaction: "Pressione a tela para come\xe7ar",
    emptyveille: "Clique ou pressione a tela..."
}, $914aec8743edd630$var$xO = {
    shorttitle: "clima",
    attribution: "Dados meteorol\xf3gicos fornecidos por Open-Meteo.com"
}, $914aec8743edd630$var$SO = {
    title: "processamento de dados pessoais transmitidos ao bot",
    message: `ao aceitar este di\xe1logo, voc\xea consente que todos os dados transmitidos ao chatbot sejam usados para an\xe1lise do uso da ferramenta e enriquecimento da base de conhecimento.

Suas conversas s\xe3o mantidas por 6 meses antes de serem exclu\xeddas.`,
    link: "link para consultar as pol\xedticas de privacidade",
    buttonAccept: "entendi e aceito",
    buttonRefuse: "recuso",
    messageAccepted: "seu consentimento foi registrado",
    messageRefused: "sua recusa foi registrada"
}, $914aec8743edd630$var$EO = {
    1: "pagina inicial",
    2: "canal de informa\xe7\xf5es ao vivo",
    3: "clima",
    4: "N\xfameros de emerg\xeancia",
    1e3: "hist\xf3ria",
    1001: "tutorial",
    common: $914aec8743edd630$var$iO,
    emergency: $914aec8743edd630$var$oO,
    error: $914aec8743edd630$var$aO,
    history: $914aec8743edd630$var$sO,
    home: $914aec8743edd630$var$uO,
    inputs: $914aec8743edd630$var$cO,
    language: $914aec8743edd630$var$lO,
    link: $914aec8743edd630$var$dO,
    loader: $914aec8743edd630$var$fO,
    menu: $914aec8743edd630$var$hO,
    mobileLandscapePreventer: $914aec8743edd630$var$pO,
    news: $914aec8743edd630$var$mO,
    poi: $914aec8743edd630$var$gO,
    suggestion: $914aec8743edd630$var$bO,
    template: $914aec8743edd630$var$vO,
    anghello: $914aec8743edd630$var$yO,
    microphone: $914aec8743edd630$var$wO,
    position: $914aec8743edd630$var$_O,
    veille: $914aec8743edd630$var$kO,
    weather: $914aec8743edd630$var$xO,
    GDPR: $914aec8743edd630$var$SO
}, $914aec8743edd630$var$AO = {
    abort: "cancelar",
    all: "todos",
    back: "voltar",
    close: "fechar",
    continue: "continuar",
    download: "download",
    downloadsheet: "baixe esta planilha",
    downloadsheetmobile: "baixe esta planilha no smartphone",
    filter: "filtro",
    history: "hist\xf3rico",
    knowmore: "Saiba mais",
    lang: "l\xednguas",
    menu: "card\xe1pio",
    mode: "moda",
    needhelp: "Preciso de ajuda?",
    parameters: "configura\xe7\xf5es",
    print: "Imprimir",
    printsheet: "Imprima esta folha",
    result: "resultado",
    results: "resultados",
    singleLang: "linguagem",
    sound: "dela",
    submit: "enviar",
    subtitle: "legenda",
    tutorial: "tutorial",
    validate: "validar"
}, $914aec8743edd630$var$TO = {
    shorttitle: "N\xfameros de emerg\xeancia",
    samu: "S.A.M.U.",
    police: "pol\xedcia",
    firefighter: "bombeiros",
    general: "general",
    hospital: "Hospital",
    homeless: "Morador de rua",
    poison: "Centro de Controle de Venenos",
    emergency: "Servi\xe7os de emerg\xeancia"
}, $914aec8743edd630$var$CO = {
    title: "ocorreu um erro",
    button: "Reinicie o aplicativo"
}, $914aec8743edd630$var$RO = {
    shorttitle: "hist\xf3ria",
    title: "hist\xf3rico de conversas"
}, $914aec8743edd630$var$OO = {
    shorttitle: "pagina inicial"
}, $914aec8743edd630$var$DO = {
    choose: "Escolha uma resposta",
    noaction: "Aguardando a\xe7\xe3o"
}, $914aec8743edd630$var$PO = {
    change: "alterar o idioma",
    select: "selecione o idioma de sua prefer\xeancia"
}, $914aec8743edd630$var$IO = {
    buttontext: "Veja o documento",
    goto: "Ir para o endere\xe7o",
    click: "Clique aqui",
    scanQR: "digitalizando o QrCode",
    scanQRTile: "Escaneie o c\xf3digo QR para descobrir"
}, $914aec8743edd630$var$MO = {
    loader: {
        optimal: "Para uma experi\xeancia ideal,",
        classic: "Para uma experi\xeancia mais cl\xe1ssica,",
        vocal: "Falo cara a cara com o agente.",
        text: "Eu me comunico por escrito com o agente."
    },
    modes: {
        vocal: "modo vocal",
        text: "modo de texto"
    },
    loaderValidation: "Iniciar conversa",
    locale: "verificando o idioma",
    supported: "verificando idiomas suportados",
    addressdata: "recuperando dados"
}, $914aec8743edd630$var$jO = {
    message: "Digite sua mensagem",
    backconversation: "de volta \xe0 conversa",
    answer: " responde \xe0s suas perguntas"
}, $914aec8743edd630$var$FO = {
    firstline: "Para uma experi\xeancia ideal,",
    secondline: "vire sua tela"
}, $914aec8743edd630$var$$O = {
    shorttitle: "canal de informa\xe7\xf5es ao vivo",
    warningtext: "Voc\xea acessar\xe1 o canal de not\xedcias, o som do seu aparelho ser\xe1 ativado",
    live: "ao vivo",
    continuous: "continuamente"
}, $914aec8743edd630$var$LO = {
    comment: "avalia\xe7\xe3o do cliente",
    route: "estrada",
    nodata: "Nenhum conte\xfado corresponde \xe0 sua pesquisa",
    openinghours: "Hor\xe1rio de funcionamento",
    prices: "Pre\xe7os",
    paymentmethods: "M\xe9todos de Pagamento",
    numberofplaces: "n\xfamero de lugares",
    openroutemobile: "abra a rota do Google Maps no smartphone",
    FoodEstablishment: "Onde comer",
    LodgingBusiness: "Onde dormir",
    TouristDestination: "O que ver",
    TouristAttraction: "O que fazer",
    Product: "Produtos locais",
    Service: "Servi\xe7os",
    Event: "Eventos",
    City: "Cidades",
    Wine: "Vinhos"
}, $914aec8743edd630$var$NO = {
    consult: "Confira",
    thetutorial: "o tutorial"
}, $914aec8743edd630$var$BO = {
    reset: "reiniciar tudo",
    showresults: "Mostrar os resultados",
    suggestiontitle: "Sugest\xf5es de pesquisa",
    reminder: `N\xe3o se esque\xe7a, 
, posso responder \xe0s suas perguntas.`
}, $914aec8743edd630$var$qO = {
    listening: "Est\xe1 com voc\xea, estou ouvindo...",
    correct: "Corrigir",
    dontknow: "Eu n\xe3o sei"
}, $914aec8743edd630$var$zO = {
    allow: "Por favor, permita que o seu navegador aceda ao microfone para continuar.",
    rejected: "Negou o acesso ao microfone.",
    instructions: "Para usar o modo de voz, por favor, permita que o seu navegador aceda ao microfone.",
    listening: "Estou ouvindo",
    trigger: "Clique ou diga",
    triggerwithoutname: "Toque para falar"
}, $914aec8743edd630$var$UO = {
    rejected: "Voc\xea recusou o acesso \xe0 sua localiza\xe7\xe3o GPS.",
    instructions: "Para acessar os dados meteorol\xf3gicos ou o mapa interativo, por favor permita que o seu navegador acesse sua localiza\xe7\xe3o GPS."
}, $914aec8743edd630$var$VO = {
    calltoaction: "Prima o ecr\xe3 para come\xe7ar",
    emptyveille: "Clique ou prima o ecr\xe3..."
}, $914aec8743edd630$var$GO = {
    shorttitle: "clima",
    attribution: "Dados meteorol\xf3gicos fornecidos por Open-Meteo.com"
}, $914aec8743edd630$var$WO = {
    title: "processamento de dados pessoais transmitidos ao bot",
    message: `ao aceitar este di\xe1logo, voc\xea consente que todos os dados transmitidos ao chatbot sejam usados para an\xe1lise do uso da ferramenta e enriquecimento da base de conhecimento.

Suas conversas s\xe3o mantidas por 6 meses antes de serem exclu\xeddas.`,
    link: "link para consultar as pol\xedticas de privacidade",
    buttonAccept: "entendi e aceito",
    buttonRefuse: "recuso",
    messageAccepted: "seu consentimento foi registrado",
    messageRefused: "sua recusa foi registrada"
}, $914aec8743edd630$var$HO = {
    1: "pagina inicial",
    2: "canal de informa\xe7\xf5es ao vivo",
    3: "clima",
    4: "N\xfameros de emerg\xeancia",
    1e3: "hist\xf3ria",
    1001: "tutorial",
    common: $914aec8743edd630$var$AO,
    emergency: $914aec8743edd630$var$TO,
    error: $914aec8743edd630$var$CO,
    history: $914aec8743edd630$var$RO,
    home: $914aec8743edd630$var$OO,
    inputs: $914aec8743edd630$var$DO,
    language: $914aec8743edd630$var$PO,
    link: $914aec8743edd630$var$IO,
    loader: $914aec8743edd630$var$MO,
    menu: $914aec8743edd630$var$jO,
    mobileLandscapePreventer: $914aec8743edd630$var$FO,
    news: $914aec8743edd630$var$$O,
    poi: $914aec8743edd630$var$LO,
    suggestion: $914aec8743edd630$var$NO,
    template: $914aec8743edd630$var$BO,
    anghello: $914aec8743edd630$var$qO,
    microphone: $914aec8743edd630$var$zO,
    position: $914aec8743edd630$var$UO,
    veille: $914aec8743edd630$var$VO,
    weather: $914aec8743edd630$var$GO,
    GDPR: $914aec8743edd630$var$WO
}, $914aec8743edd630$var$KO = {
    all: "\u0432\u0441\u0435",
    back: "\u043D\u0430\u0437\u0430\u0434",
    close: "\u0437\u0430\u043A\u0440\u044B\u0432\u0430\u0442\u044C",
    continue: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0442\u044C",
    download: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C",
    downloadsheet: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u044D\u0442\u043E\u0442 \u043B\u0438\u0441\u0442",
    downloadsheetmobile: "\u0441\u043A\u0430\u0447\u0430\u0442\u044C \u044D\u0442\u043E\u0442 \u043B\u0438\u0441\u0442 \u043D\u0430 \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D",
    filter: "\u0424\u0438\u043B\u044C\u0442\u0440",
    history: "\u0438\u0441\u0442\u043E\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0439",
    knowmore: "\u0423\u0437\u043D\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435",
    lang: "\u042F\u0417\u042B\u041A\u0418",
    menu: "\u043C\u0435\u043D\u044E",
    mode: "\u043C\u043E\u0434\u0430",
    needhelp: "\u041D\u0443\u0436\u043D\u0430 \u043F\u043E\u043C\u043E\u0449\u044C?",
    parameters: "\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
    print: "\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C",
    printsheet: "\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C \u044D\u0442\u043E\u0442 \u043B\u0438\u0441\u0442",
    result: "\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442",
    results: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B",
    singleLang: "\u044F\u0437\u044B\u043A",
    sound: "\u0437\u0432\u0443\u043A",
    submit: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    subtitle: "\u0441\u0443\u0431\u0442\u0438\u0442\u0440\u044B",
    tutorial: "\u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E",
    validate: "\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
    abort: "\u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
}, $914aec8743edd630$var$QO = {
    shorttitle: "\u043D\u043E\u043C\u0435\u0440\u0430 \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0441\u043B\u0443\u0436\u0431",
    samu: "\u0421.\u0410.\u041C.\u0423.",
    police: "\u043F\u043E\u043B\u0438\u0446\u0438\u044F",
    firefighter: "\u043F\u043E\u0436\u0430\u0440\u043D\u044B\u0435",
    general: "\u043E\u0431\u0449\u0438\u0439",
    hospital: "\u0411\u043E\u043B\u044C\u043D\u0438\u0446\u0430",
    homeless: "\u0411\u0435\u0437\u0434\u043E\u043C\u043D\u044B\u0439",
    poison: "\u0422\u043E\u043A\u0441\u0438\u043A\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0446\u0435\u043D\u0442\u0440",
    emergency: "\u0410\u0432\u0430\u0440\u0438\u0439\u043D\u044B\u0435 \u0441\u043B\u0443\u0436\u0431\u044B"
}, $914aec8743edd630$var$YO = {
    title: "\u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
    button: "\u041F\u0435\u0440\u0435\u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435"
}, $914aec8743edd630$var$JO = {
    shorttitle: "\u0438\u0441\u0442\u043E\u0440\u0438\u044F",
    title: "\u0438\u0441\u0442\u043E\u0440\u0438\u044F \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440\u043E\u0432"
}, $914aec8743edd630$var$ZO = {
    shorttitle: "\u0434\u043E\u043C\u0430\u0448\u043D\u044F\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
}, $914aec8743edd630$var$XO = {
    choose: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0442\u0432\u0435\u0442",
    noaction: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442\u0441\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435"
}, $914aec8743edd630$var$eD = {
    change: "\u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u044F\u0437\u044B\u043A",
    select: "\u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u044F\u0437\u044B\u043A \u043F\u043E \u0432\u0430\u0448\u0435\u043C\u0443 \u0432\u044B\u0431\u043E\u0440\u0443"
}, $914aec8743edd630$var$tD = {
    buttontext: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
    goto: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443",
    click: "\u043A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u0441\u044E\u0434\u0430",
    scanQR: "\u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0432 QrCode",
    scanQRTile: "\u0421\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434, \u0447\u0442\u043E\u0431\u044B \u0443\u0437\u043D\u0430\u0442\u044C"
}, $914aec8743edd630$var$rD = {
    loader: {
        optimal: "\u0414\u043B\u044F \u043E\u043F\u0442\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043E\u043F\u044B\u0442\u0430,",
        classic: "\u0414\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u043A\u043B\u0430\u0441\u0441\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043E\u043F\u044B\u0442\u0430,",
        vocal: "\u042F \u043E\u0431\u0449\u0430\u044E\u0441\u044C, \u0440\u0430\u0437\u0433\u043E\u0432\u0430\u0440\u0438\u0432\u0430\u044F \u0441 \u0430\u0433\u0435\u043D\u0442\u043E\u043C.",
        text: "\u042F \u043E\u0431\u0449\u0430\u044E\u0441\u044C \u043F\u043E \u0442\u0435\u043A\u0441\u0442\u0443 \u0441 \u0430\u0433\u0435\u043D\u0442\u043E\u043C."
    },
    modes: {
        vocal: "\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u043E\u0439 \u0440\u0435\u0436\u0438\u043C",
        text: "\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439 \u0440\u0435\u0436\u0438\u043C"
    },
    loaderValidation: "\u041D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440",
    locale: "\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u044F\u0437\u044B\u043A\u0430",
    supported: "\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u044B\u0445 \u044F\u0437\u044B\u043A\u043E\u0432",
    addressdata: "\u0418\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445"
}, $914aec8743edd630$var$nD = {
    message: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    backconversation: "\u0432\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440\u0443",
    answer: " \u043E\u0442\u0432\u0435\u0447\u0430\u0435\u0442 \u043D\u0430 \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B"
}, $914aec8743edd630$var$iD = {
    firstline: "\u0414\u043B\u044F \u043E\u043F\u0442\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043E\u043F\u044B\u0442\u0430,",
    secondline: "\u043F\u0435\u0440\u0435\u0432\u0435\u0440\u043D\u0438\u0442\u0435 \u044D\u043A\u0440\u0430\u043D"
}, $914aec8743edd630$var$oD = {
    shorttitle: "\u043F\u0440\u044F\u043C\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B",
    warningtext: "\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043D\u043E\u0432\u043E\u0441\u0442\u043D\u043E\u043C\u0443 \u043A\u0430\u043D\u0430\u043B\u0443, \u0437\u0432\u0443\u043A \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435 \u0431\u0443\u0434\u0435\u0442 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D.",
    live: "\u0436\u0438\u0442\u044C",
    continuous: "\u043D\u0435\u043F\u0440\u0435\u0440\u044B\u0432\u043D\u043E"
}, $914aec8743edd630$var$aD = {
    comment: "\u043E\u0442\u0437\u044B\u0432 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
    route: "\u0434\u043E\u0440\u043E\u0433\u0430",
    nodata: "\u041D\u0435\u0442 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0432\u0430\u0448\u0435\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443",
    openinghours: "\u0427\u0430\u0441\u044B \u0440\u0430\u0431\u043E\u0442\u044B",
    prices: "\u0426\u0435\u043D\u044B",
    paymentmethods: "\u0421\u043F\u043E\u0441\u043E\u0431\u044B \u043E\u043F\u043B\u0430\u0442\u044B",
    numberofplaces: "\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043C\u0435\u0441\u0442",
    openroutemobile: "\u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442 Google Maps \u043D\u0430 \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D\u0435",
    FoodEstablishment: "\u0413\u0434\u0435 \u043F\u043E\u0435\u0441\u0442\u044C",
    LodgingBusiness: "\u0413\u0434\u0435 \u0441\u043F\u0430\u0442\u044C",
    TouristDestination: "\u0427\u0442\u043E \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C",
    TouristAttraction: "\u0427\u0442\u043E \u0434\u0435\u043B\u0430\u0442\u044C",
    Product: "\u041C\u0435\u0441\u0442\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u044B",
    Service: "\u0423\u0441\u043B\u0443\u0433\u0438",
    Event: "\u0421\u043E\u0431\u044B\u0442\u0438\u044F",
    City: "\u0413\u043E\u0440\u043E\u0434\u0430",
    Wine: "\u0412\u0438\u043D\u0430"
}, $914aec8743edd630$var$sD = {
    consult: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C",
    thetutorial: "\u0443\u0447\u0435\u0431\u043D\u0438\u043A"
}, $914aec8743edd630$var$uD = {
    reset: "\u0441\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0441\u0435",
    showresults: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B",
    suggestiontitle: "\u041F\u043E\u0438\u0441\u043A\u043E\u0432\u044B\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
    reminder: `\u{41D}\u{435} \u{437}\u{430}\u{431}\u{44B}\u{432}\u{430}\u{439}, 
 \u{42F} \u{43C}\u{43E}\u{433}\u{443} \u{43E}\u{442}\u{432}\u{435}\u{442}\u{438}\u{442}\u{44C} \u{43D}\u{430} \u{442}\u{432}\u{43E}\u{438} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{44B}.`
}, $914aec8743edd630$var$cD = {
    listening: "\u042D\u0442\u043E \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0432\u0430\u0441, \u044F \u0441\u043B\u0443\u0448\u0430\u044E...",
    correct: "\u0418\u0441\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    dontknow: "\u042F \u043D\u0435 \u0437\u043D\u0430\u044E"
}, $914aec8743edd630$var$lD = {
    allow: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0432\u0430\u0448\u0435\u043C\u0443 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0443 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443 \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F.",
    rejected: "\u0412\u044B \u043E\u0442\u043A\u0430\u0437\u0430\u043B\u0438 \u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u0435 \u043A \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443.",
    instructions: "\u0427\u0442\u043E\u0431\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u043E\u0439 \u0440\u0435\u0436\u0438\u043C, \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0443 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443.",
    listening: "\u042F \u0441\u043B\u0443\u0448\u0430\u044E",
    trigger: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0438\u043B\u0438 \u0441\u043A\u0430\u0437\u0430\u0439\u0442\u0435",
    triggerwithoutname: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0433\u043E\u0432\u043E\u0440\u0438\u0442\u044C"
}, $914aec8743edd630$var$dD = {
    rejected: "\u0412\u044B \u043E\u0442\u043A\u0430\u0437\u0430\u043B\u0438\u0441\u044C \u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u0435 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044E GPS.",
    instructions: "\u0427\u0442\u043E\u0431\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043F\u043E\u0433\u043E\u0434\u043D\u044B\u043C \u0434\u0430\u043D\u043D\u044B\u043C \u0438\u043B\u0438 \u0438\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0432\u0430\u0448\u0435\u043C\u0443 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0443 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044E GPS."
}, $914aec8743edd630$var$fD = {
    calltoaction: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u044D\u043A\u0440\u0430\u043D, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C",
    emptyveille: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0438\u043B\u0438 \u043A\u043E\u0441\u043D\u0438\u0442\u0435\u0441\u044C \u044D\u043A\u0440\u0430\u043D\u0430..."
}, $914aec8743edd630$var$hD = {
    shorttitle: "\u043F\u043E\u0433\u043E\u0434\u0430",
    attribution: "\u041C\u0435\u0442\u0435\u043E\u0440\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u044B Open-Meteo.com"
}, $914aec8743edd630$var$pD = {
    title: "\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u043E\u0442\u0443",
    message: `\u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44F} \u{44D}\u{442}\u{43E}\u{442} \u{434}\u{438}\u{430}\u{43B}\u{43E}\u{433}, \u{432}\u{44B} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{448}\u{430}\u{435}\u{442}\u{435}\u{441}\u{44C} \u{43D}\u{430} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{432}\u{441}\u{435}\u{445} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}, \u{43F}\u{435}\u{440}\u{435}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{447}\u{430}\u{442}-\u{431}\u{43E}\u{442}\u{443}, \u{434}\u{43B}\u{44F} \u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{438}\u{43D}\u{441}\u{442}\u{440}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{438} \u{43E}\u{431}\u{43E}\u{433}\u{430}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{431}\u{430}\u{437}\u{44B} \u{437}\u{43D}\u{430}\u{43D}\u{438}\u{439}.

\u{412}\u{430}\u{448}\u{438} \u{440}\u{430}\u{437}\u{433}\u{43E}\u{432}\u{43E}\u{440}\u{44B} \u{445}\u{440}\u{430}\u{43D}\u{44F}\u{442}\u{441}\u{44F} 6 \u{43C}\u{435}\u{441}\u{44F}\u{446}\u{435}\u{432} \u{434}\u{43E} \u{443}\u{434}\u{430}\u{43B}\u{435}\u{43D}\u{438}\u{44F}.`,
    link: "\u0441\u0441\u044B\u043B\u043A\u0430 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u043F\u043E\u043B\u0438\u0442\u0438\u043A \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
    buttonAccept: "\u044F \u043F\u043E\u043D\u044F\u043B \u0438 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u044E",
    buttonRefuse: "\u043E\u0442\u043A\u0430\u0437\u044B\u0432\u0430\u044E\u0441\u044C",
    messageAccepted: "\u0432\u0430\u0448\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043F\u0440\u0438\u043D\u044F\u0442\u043E \u0432\u043E \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435",
    messageRefused: "\u0432\u0430\u0448 \u043E\u0442\u043A\u0430\u0437 \u043F\u0440\u0438\u043D\u044F\u0442 \u0432\u043E \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435"
}, $914aec8743edd630$var$mD = {
    1: "\u0434\u043E\u043C\u0430\u0448\u043D\u044F\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
    2: "\u043F\u0440\u044F\u043C\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B",
    3: "\u043F\u043E\u0433\u043E\u0434\u0430",
    4: "\u043D\u043E\u043C\u0435\u0440\u0430 \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0441\u043B\u0443\u0436\u0431",
    1e3: "\u0438\u0441\u0442\u043E\u0440\u0438\u044F",
    1001: "\u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E",
    common: $914aec8743edd630$var$KO,
    emergency: $914aec8743edd630$var$QO,
    error: $914aec8743edd630$var$YO,
    history: $914aec8743edd630$var$JO,
    home: $914aec8743edd630$var$ZO,
    inputs: $914aec8743edd630$var$XO,
    language: $914aec8743edd630$var$eD,
    link: $914aec8743edd630$var$tD,
    loader: $914aec8743edd630$var$rD,
    menu: $914aec8743edd630$var$nD,
    mobileLandscapePreventer: $914aec8743edd630$var$iD,
    news: $914aec8743edd630$var$oD,
    poi: $914aec8743edd630$var$aD,
    suggestion: $914aec8743edd630$var$sD,
    template: $914aec8743edd630$var$uD,
    anghello: $914aec8743edd630$var$cD,
    microphone: $914aec8743edd630$var$lD,
    position: $914aec8743edd630$var$dD,
    veille: $914aec8743edd630$var$fD,
    weather: $914aec8743edd630$var$hD,
    GDPR: $914aec8743edd630$var$pD
}, $914aec8743edd630$var$gD = {
    all: "vse",
    close: "blizu",
    back: "nazaj",
    continue: "Nadaljuj",
    download: "prenesi",
    downloadsheet: "prenesite ta list",
    downloadsheetmobile: "prenesite ta list na pametni telefon",
    filter: "Filter",
    history: "zgodovinski",
    knowmore: "L\xe4s mer",
    lang: "jezikov",
    menu: "meni",
    mode: "moda",
    needhelp: "Rabim pomo\u010D?",
    parameters: "nastavitve",
    print: "Tiskanje",
    printsheet: "Natisnite ta list",
    result: "rezultat",
    results: "rezultate",
    singleLang: "jezik",
    sound: "njo",
    submit: "Skicka in",
    subtitle: "podnaslov",
    tutorial: "vadnica",
    validate: "potrditi",
    abort: "avbryt"
}, $914aec8743edd630$var$bD = {
    shorttitle: "N\xf8dnumre",
    samu: "S.A.M.U.",
    police: "polis",
    firefighter: "brandm\xe4n",
    general: "allm\xe4n",
    hospital: "Sjukhus",
    homeless: "Heml\xf6s",
    poison: "Giftkontrollcenter",
    emergency: "Akuttj\xe4nster"
}, $914aec8743edd630$var$vD = {
    title: "Ett fel har uppst\xe5tt",
    button: "Starta om programmet"
}, $914aec8743edd630$var$yD = {
    shorttitle: "zgodovina",
    title: "zgodovino pogovorov"
}, $914aec8743edd630$var$wD = {
    shorttitle: "doma\u010Da stran"
}, $914aec8743edd630$var$_D = {
    choose: "V\xe4lj ett svar",
    noaction: "V\xe4ntar p\xe5 \xe5tg\xe4rd"
}, $914aec8743edd630$var$kD = {
    change: "spremenite jezik",
    select: "izberite jezik po va\u0161i izbiri"
}, $914aec8743edd630$var$xD = {
    buttontext: "Oglejte si dokument",
    goto: "Pojdi na naslov",
    click: "Klikni tukaj",
    scanQR: "s skeniranjem QrCode",
    scanQRTile: "Skanna QR-koden f\xf6r att uppt\xe4cka"
}, $914aec8743edd630$var$SD = {
    loader: {
        optimal: "Za optimalno izku\u0161njo,",
        classic: "Za bolj klasi\u010Dno izku\u0161njo,",
        vocal: "Z agentom se pogovarjam iz o\u010Di v o\u010Di.",
        text: "Pisno komuniciram z agentom."
    },
    modes: {
        vocal: "vokalni na\u010Din",
        text: "besedilni na\u010Din"
    },
    loaderValidation: "Za\u010Dni pogovor",
    locale: "preverjanje jezika",
    supported: "preverjanje podprtih jezikov",
    addressdata: "pridobivanje podatkov"
}, $914aec8743edd630$var$ED = {
    message: "Vnesite svoje sporo\u010Dilo",
    backconversation: "nazaj k pogovoru",
    answer: " odgovarja na va\u0161a vpra\u0161anja"
}, $914aec8743edd630$var$AD = {
    firstline: "Za optimalno izku\u0161njo,",
    secondline: "obrnite zaslon"
}, $914aec8743edd630$var$TD = {
    shorttitle: "info kanal v \u017Eivo",
    warningtext: "Dostopili boste do kanala z novicami, zvok na va\u0161i napravi bo aktiviran",
    live: "v \u017Eivo",
    continuous: "neprekinjeno"
}, $914aec8743edd630$var$CD = {
    comment: "pregled strank",
    route: "cesta",
    nodata: "Nobena vsebina se ne ujema z va\u0161im iskanjem",
    openinghours: "Odpiralni \u010Das",
    prices: "Cene",
    paymentmethods: "Na\u010Dini pla\u010Dila",
    numberofplaces: "\u0161tevilo mest",
    openroutemobile: "odprite Google Maps route na pametnem telefonu",
    FoodEstablishment: "Kje jesti",
    LodgingBusiness: "Kje spati",
    TouristDestination: "Kaj videti",
    TouristAttraction: "Kaj storiti",
    Product: "Lokalni izdelki",
    Service: "Storitve",
    Event: "Dogodki",
    City: "Mesta",
    Wine: "Vina"
}, $914aec8743edd630$var$RD = {
    consult: "Preveri",
    thetutorial: "vadnica"
}, $914aec8743edd630$var$OD = {
    reset: "ponastavi vse",
    showresults: "Poka\u017Ei rezultate",
    suggestiontitle: "Predlogi za iskanje",
    reminder: `Ne pozabite, 
 lahko odgovorim na va\u{161}a vpra\u{161}anja.`
}, $914aec8743edd630$var$DD = {
    listening: "Det \xe4r upp till dig, jag lyssnar...",
    correct: "Korrigera",
    dontknow: "Jag vet inte"
}, $914aec8743edd630$var$PD = {
    allow: "V\xe4nligen till\xe5t din webbl\xe4sare att f\xe5 \xe5tkomst till mikrofonen f\xf6r att forts\xe4tta.",
    rejected: "Du har nekad \xe5tkomst till mikrofonen.",
    instructions: "F\xf6r att anv\xe4nda r\xf6stl\xe4ge, v\xe4nligen till\xe5t din webbl\xe4sare att f\xe5 \xe5tkomst till mikrofonen.",
    listening: "Jag lyssnar",
    trigger: "Tryck eller s\xe4g",
    triggerwithoutname: "Tryck f\xf6r att prata"
}, $914aec8743edd630$var$ID = {
    rejected: "Du har avvisat \xe5tkomst till din GPS-position.",
    instructions: "F\xf6r att f\xe5 tillg\xe5ng till v\xe4derdata eller interaktiv karta, v\xe4nligen ge din webbl\xe4sare tillg\xe5ng till din GPS-position."
}, $914aec8743edd630$var$MD = {
    calltoaction: "Tryck p\xe5 sk\xe4rmen f\xf6r att b\xf6rja",
    emptyveille: "Klicka eller tryck p\xe5 sk\xe4rmen..."
}, $914aec8743edd630$var$jD = {
    shorttitle: "vreme",
    attribution: "V\xe4derdata tillhandah\xe5llen av Open-Meteo.com"
}, $914aec8743edd630$var$FD = {
    title: "behandling av personuppgifter som skickas till boten",
    message: `genom att acceptera denna dialog samtycker du till att alla data som skickas till chatboten kan anv\xe4ndas f\xf6r analys av anv\xe4ndningen av verktyget och berikande av kunskapsbasen.

Dina konversationer lagras i 6 m\xe5nader innan de raderas.`,
    link: "l\xe4nk f\xf6r att se sekretesspolicyer",
    buttonAccept: "jag f\xf6rst\xe5r och accepterar",
    buttonRefuse: "jag avb\xf6jer",
    messageAccepted: "ditt samtycke har beaktats",
    messageRefused: "ditt avslag har beaktats"
}, $914aec8743edd630$var$$D = {
    1: "doma\u010Da stran",
    2: "info kanal v \u017Eivo",
    3: "vreme",
    4: "\u0161tevilke za klic v sili",
    1e3: "zgodovina",
    1001: "vadnica",
    common: $914aec8743edd630$var$gD,
    emergency: $914aec8743edd630$var$bD,
    error: $914aec8743edd630$var$vD,
    history: $914aec8743edd630$var$yD,
    home: $914aec8743edd630$var$wD,
    inputs: $914aec8743edd630$var$_D,
    language: $914aec8743edd630$var$kD,
    link: $914aec8743edd630$var$xD,
    loader: $914aec8743edd630$var$SD,
    menu: $914aec8743edd630$var$ED,
    mobileLandscapePreventer: $914aec8743edd630$var$AD,
    news: $914aec8743edd630$var$TD,
    poi: $914aec8743edd630$var$CD,
    suggestion: $914aec8743edd630$var$RD,
    template: $914aec8743edd630$var$OD,
    anghello: $914aec8743edd630$var$DD,
    microphone: $914aec8743edd630$var$PD,
    position: $914aec8743edd630$var$ID,
    veille: $914aec8743edd630$var$MD,
    weather: $914aec8743edd630$var$jD,
    GDPR: $914aec8743edd630$var$FD
}, $914aec8743edd630$var$LD = {
    abort: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    all: "\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
    back: "\u0E01\u0E25\u0E31\u0E1A",
    close: "\u0E1B\u0E34\u0E14",
    continue: "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
    download: "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14",
    downloadsheet: "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E19\u0E35\u0E49",
    downloadsheetmobile: "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E19\u0E35\u0E49\u0E1A\u0E19\u0E2A\u0E21\u0E32\u0E23\u0E4C\u0E17\u0E42\u0E1F\u0E19",
    filter: "\u0E01\u0E23\u0E2D\u0E07",
    history: "\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E28\u0E32\u0E2A\u0E15\u0E23\u0E4C",
    knowmore: "\u0E2D\u0E48\u0E32\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    lang: "\u0E20\u0E32\u0E29\u0E32",
    menu: "\u0E40\u0E21\u0E19\u0E39",
    mode: "\u0E41\u0E1F\u0E0A\u0E31\u0E48\u0E19",
    needhelp: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D?",
    parameters: "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32",
    print: "\u0E1E\u0E34\u0E21\u0E1E\u0E4C",
    printsheet: "\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E41\u0E1C\u0E48\u0E19\u0E19\u0E35\u0E49",
    result: "\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C",
    results: "\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C",
    singleLang: "\u0E20\u0E32\u0E29\u0E32",
    sound: "\u0E02\u0E2D\u0E07\u0E40\u0E18\u0E2D",
    submit: "\u0E2A\u0E48\u0E07",
    subtitle: "\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22",
    tutorial: "\u0E01\u0E27\u0E14\u0E27\u0E34\u0E0A\u0E32",
    validate: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A"
}, $914aec8743edd630$var$ND = {
    shorttitle: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E09\u0E38\u0E01\u0E40\u0E09\u0E34\u0E19",
    samu: "S.A.M.U.",
    police: "\u0E15\u0E33\u0E23\u0E27\u0E08",
    firefighter: "\u0E19\u0E31\u0E01\u0E14\u0E31\u0E1A\u0E40\u0E1E\u0E25\u0E34\u0E07",
    general: "\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B",
    hospital: "\u0E42\u0E23\u0E07\u0E1E\u0E22\u0E32\u0E1A\u0E32\u0E25",
    homeless: "\u0E04\u0E19\u0E44\u0E23\u0E49\u0E1A\u0E49\u0E32\u0E19",
    poison: "\u0E28\u0E39\u0E19\u0E22\u0E4C\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E1E\u0E34\u0E29",
    emergency: "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E09\u0E38\u0E01\u0E40\u0E09\u0E34\u0E19"
}, $914aec8743edd630$var$BD = {
    title: "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
    button: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07"
}, $914aec8743edd630$var$qD = {
    shorttitle: "\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E28\u0E32\u0E2A\u0E15\u0E23\u0E4C",
    title: "\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32"
}, $914aec8743edd630$var$zD = {
    shorttitle: "\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E23\u0E01"
}, $914aec8743edd630$var$UD = {
    choose: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E33\u0E15\u0E2D\u0E1A",
    noaction: "\u0E23\u0E2D\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23"
}, $914aec8743edd630$var$VD = {
    change: "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E20\u0E32\u0E29\u0E32",
    select: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E20\u0E32\u0E29\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23"
}, $914aec8743edd630$var$GD = {
    buttontext: "\u0E14\u0E39\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23",
    goto: "\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48",
    click: "\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
    scanQR: "\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E41\u0E01\u0E19 QrCode",
    scanQRTile: "\u0E2A\u0E41\u0E01\u0E19\u0E23\u0E2B\u0E31\u0E2A QR \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E49\u0E19\u0E1E\u0E1A"
}, $914aec8743edd630$var$WD = {
    loader: {
        optimal: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E14\u0E35\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14",
        classic: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E04\u0E25\u0E32\u0E2A\u0E2A\u0E34\u0E01\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19",
        vocal: "\u0E09\u0E31\u0E19\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E1E\u0E39\u0E14\u0E04\u0E38\u0E22\u0E01\u0E31\u0E1A\u0E15\u0E31\u0E27\u0E41\u0E17\u0E19",
        text: "\u0E09\u0E31\u0E19\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E17\u0E32\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E01\u0E31\u0E1A\u0E15\u0E31\u0E27\u0E41\u0E17\u0E19"
    },
    modes: {
        vocal: "\u0E42\u0E2B\u0E21\u0E14\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E1E\u0E39\u0E14",
        text: "\u0E42\u0E2B\u0E21\u0E14\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21"
    },
    loaderValidation: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32",
    locale: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E20\u0E32\u0E29\u0E32",
    supported: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E20\u0E32\u0E29\u0E32\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A",
    addressdata: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E36\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25"
}, $914aec8743edd630$var$HD = {
    message: "\u0E1B\u0E49\u0E2D\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    backconversation: "\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32",
    answer: " \u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
}, $914aec8743edd630$var$KD = {
    firstline: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E14\u0E35\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14",
    secondline: "\u0E1E\u0E25\u0E34\u0E01\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
}, $914aec8743edd630$var$QD = {
    shorttitle: "\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E14",
    warningtext: "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E02\u0E48\u0E32\u0E27\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E1A\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
    live: "\u0E2A\u0E14",
    continuous: "\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E15\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07"
}, $914aec8743edd630$var$YD = {
    comment: "\u0E23\u0E35\u0E27\u0E34\u0E27\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
    route: "\u0E16\u0E19\u0E19",
    nodata: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    openinghours: "\u0E40\u0E27\u0E25\u0E32\u0E17\u0E33\u0E01\u0E32\u0E23",
    prices: "\u0E23\u0E32\u0E04\u0E32",
    paymentmethods: "\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
    numberofplaces: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E17\u0E35\u0E48",
    openroutemobile: "\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07 Google Maps \u0E1A\u0E19\u0E2A\u0E21\u0E32\u0E23\u0E4C\u0E17\u0E42\u0E1F\u0E19",
    FoodEstablishment: "\u0E01\u0E34\u0E19\u0E17\u0E35\u0E48\u0E44\u0E2B\u0E19\u0E14\u0E35",
    LodgingBusiness: "\u0E19\u0E2D\u0E19\u0E44\u0E2B\u0E19.",
    TouristDestination: "\u0E21\u0E35\u0E2D\u0E30\u0E44\u0E23\u0E43\u0E2B\u0E49\u0E14\u0E39\u0E1A\u0E49\u0E32\u0E07",
    TouristAttraction: "\u0E08\u0E30\u0E17\u0E33\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23",
    Product: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
    Service: "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23",
    Event: "\u0E01\u0E34\u0E08\u0E01\u0E23\u0E23\u0E21",
    City: "\u0E40\u0E21\u0E37\u0E2D\u0E07",
    Wine: "\u0E44\u0E27\u0E19\u0E4C"
}, $914aec8743edd630$var$JD = {
    consult: "\u0E40\u0E0A\u0E47\u0E04\u0E40\u0E2D\u0E32\u0E17\u0E4C",
    thetutorial: "\u0E1A\u0E17\u0E0A\u0E48\u0E27\u0E22\u0E2A\u0E2D\u0E19"
}, $914aec8743edd630$var$ZD = {
    reset: "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
    showresults: "\u0E41\u0E2A\u0E14\u0E07\u0E1C\u0E25",
    suggestiontitle: "\u0E04\u0E33\u0E41\u0E19\u0E30\u0E19\u0E33\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32",
    reminder: `\u{E2D}\u{E22}\u{E48}\u{E32}\u{E25}\u{E37}\u{E21} 
 \u{E09}\u{E31}\u{E19}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E15}\u{E2D}\u{E1A}\u{E04}\u{E33}\u{E16}\u{E32}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}`
}, $914aec8743edd630$var$XD = {
    listening: "\u0E02\u0E36\u0E49\u0E19\u0E2D\u0E22\u0E39\u0E48\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13, \u0E09\u0E31\u0E19\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1F\u0E31\u0E07...",
    correct: "\u0E41\u0E01\u0E49\u0E44\u0E02",
    dontknow: "\u0E09\u0E31\u0E19\u0E44\u0E21\u0E48\u0E23\u0E39\u0E49"
}, $914aec8743edd630$var$e5 = {
    allow: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E21\u0E42\u0E04\u0E23\u0E42\u0E1F\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
    rejected: "\u0E04\u0E38\u0E13\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E21\u0E42\u0E04\u0E23\u0E42\u0E1F\u0E19",
    instructions: "\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E42\u0E2B\u0E21\u0E14\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E21\u0E42\u0E04\u0E23\u0E42\u0E1F\u0E19",
    listening: "\u0E09\u0E31\u0E19\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1F\u0E31\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E22\u0E39\u0E48",
    trigger: "\u0E01\u0E14\u0E2B\u0E23\u0E37\u0E2D\u0E1E\u0E39\u0E14",
    triggerwithoutname: "\u0E41\u0E15\u0E30\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1E\u0E39\u0E14"
}, $914aec8743edd630$var$t5 = {
    rejected: "\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07 GPS \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    instructions: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E20\u0E32\u0E1E\u0E2D\u0E32\u0E01\u0E32\u0E28\u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E1C\u0E19\u0E17\u0E35\u0E48\u0E41\u0E1A\u0E1A\u0E42\u0E15\u0E49\u0E15\u0E2D\u0E1A \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07 GPS \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
}, $914aec8743edd630$var$r5 = {
    calltoaction: "\u0E01\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19",
    emptyveille: "\u0E04\u0E25\u0E34\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D..."
}, $914aec8743edd630$var$n5 = {
    shorttitle: "\u0E2A\u0E20\u0E32\u0E1E\u0E2D\u0E32\u0E01\u0E32\u0E28",
    attribution: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E20\u0E32\u0E1E\u0E2D\u0E32\u0E01\u0E32\u0E28\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2B\u0E32\u0E42\u0E14\u0E22 Open-Meteo.com"
}, $914aec8743edd630$var$i5 = {
    title: "\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E21\u0E27\u0E25\u0E1C\u0E25\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1A\u0E2D\u0E17",
    message: `\u{E42}\u{E14}\u{E22}\u{E01}\u{E32}\u{E23}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E25}\u{E48}\u{E2D}\u{E07}\u{E42}\u{E15}\u{E49}\u{E15}\u{E2D}\u{E1A}\u{E19}\u{E35}\u{E49} \u{E04}\u{E38}\u{E13}\u{E22}\u{E34}\u{E19}\u{E22}\u{E2D}\u{E21}\u{E43}\u{E2B}\u{E49}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E48}\u{E07}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E41}\u{E0A}\u{E17}\u{E1A}\u{E2D}\u{E17}\u{E16}\u{E39}\u{E01}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E27}\u{E34}\u{E40}\u{E04}\u{E23}\u{E32}\u{E30}\u{E2B}\u{E4C}\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E40}\u{E04}\u{E23}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E21}\u{E37}\u{E2D}\u{E41}\u{E25}\u{E30}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E04}\u{E27}\u{E32}\u{E21}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E10}\u{E32}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E23}\u{E39}\u{E49}\u{3002}

\u{E01}\u{E32}\u{E23}\u{E2A}\u{E19}\u{E17}\u{E19}\u{E32}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E40}\u{E01}\u{E47}\u{E1A}\u{E44}\u{E27}\u{E49} 6 \u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E25}\u{E1A}`,
    link: "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E14\u0E39\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27",
    buttonAccept: "\u0E09\u0E31\u0E19\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E41\u0E25\u0E30\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A",
    buttonRefuse: "\u0E09\u0E31\u0E19\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18",
    messageAccepted: "\u0E04\u0E27\u0E32\u0E21\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E41\u0E25\u0E49\u0E27",
    messageRefused: "\u0E01\u0E32\u0E23\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E41\u0E25\u0E49\u0E27"
}, $914aec8743edd630$var$o5 = {
    1: "\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E23\u0E01",
    2: "\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E14",
    3: "\u0E2A\u0E20\u0E32\u0E1E\u0E2D\u0E32\u0E01\u0E32\u0E28",
    4: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E09\u0E38\u0E01\u0E40\u0E09\u0E34\u0E19",
    1e3: "\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E28\u0E32\u0E2A\u0E15\u0E23\u0E4C",
    1001: "\u0E01\u0E27\u0E14\u0E27\u0E34\u0E0A\u0E32",
    common: $914aec8743edd630$var$LD,
    emergency: $914aec8743edd630$var$ND,
    error: $914aec8743edd630$var$BD,
    history: $914aec8743edd630$var$qD,
    home: $914aec8743edd630$var$zD,
    inputs: $914aec8743edd630$var$UD,
    language: $914aec8743edd630$var$VD,
    link: $914aec8743edd630$var$GD,
    loader: $914aec8743edd630$var$WD,
    menu: $914aec8743edd630$var$HD,
    mobileLandscapePreventer: $914aec8743edd630$var$KD,
    news: $914aec8743edd630$var$QD,
    poi: $914aec8743edd630$var$YD,
    suggestion: $914aec8743edd630$var$JD,
    template: $914aec8743edd630$var$ZD,
    anghello: $914aec8743edd630$var$XD,
    microphone: $914aec8743edd630$var$e5,
    position: $914aec8743edd630$var$t5,
    veille: $914aec8743edd630$var$r5,
    weather: $914aec8743edd630$var$n5,
    GDPR: $914aec8743edd630$var$i5
}, $914aec8743edd630$var$a5 = {
    abort: "iptal",
    all: "T\xfcm\xfc",
    back: "geri",
    close: "kapal\u0131",
    continue: "Devam etmek",
    download: "\u0130ndirmek",
    downloadsheet: "bu sayfay\u0131 indir",
    downloadsheetmobile: "bu sayfay\u0131 ak\u0131ll\u0131 telefonunuza indirin",
    filter: "Filtre",
    history: "tarihi",
    knowmore: "Daha fazla bilgi",
    lang: "Diller",
    menu: "Men\xfc",
    mode: "moda",
    needhelp: "Yard\u0131ma m\u0131 ihtiyac\u0131n\u0131z var?",
    parameters: "ayarlar",
    print: "Yazd\u0131r",
    printsheet: "Bu sayfay\u0131 yazd\u0131r",
    result: "sonu\xe7",
    results: "sonu\xe7lar",
    singleLang: "dil",
    sound: "ses",
    submit: "g\xf6ndermek",
    subtitle: "alt yaz\u0131",
    tutorial: "\xf6\u011Fretici",
    validate: "Do\u011Frulamak"
}, $914aec8743edd630$var$s5 = {
    shorttitle: "Acil durum numaralar\u0131",
    samu: "S.A.M.U.",
    police: "polis",
    firefighter: "itfaiyeciler",
    general: "genel",
    hospital: "Hastane",
    homeless: "Evsiz",
    poison: "Zehir kontrol Merkezi",
    emergency: "Acil servisler"
}, $914aec8743edd630$var$u5 = {
    title: "bir hata olu\u015Ftu",
    button: "Uygulamay\u0131 yeniden ba\u015Flat\u0131n"
}, $914aec8743edd630$var$c5 = {
    shorttitle: "tarih",
    title: "konu\u015Fma ge\xe7mi\u015Fi"
}, $914aec8743edd630$var$l5 = {
    shorttitle: "ana sayfa"
}, $914aec8743edd630$var$d5 = {
    choose: "Bir cevap se\xe7in",
    noaction: "Eylem bekleniyor"
}, $914aec8743edd630$var$f5 = {
    change: "dili de\u011Fi\u015Ftir",
    select: "istedi\u011Finiz dili se\xe7in"
}, $914aec8743edd630$var$h5 = {
    buttontext: "Belgeyi g\xf6r\xfcnt\xfcle",
    goto: "Adrese git",
    click: "buraya t\u0131klay\u0131n",
    scanQR: "QrCode'u tarayarak",
    scanQRTile: "Ke\u015Ffetmek i\xe7in QR Kodu\u2019nu tara"
}, $914aec8743edd630$var$p5 = {
    loader: {
        optimal: "Optimum bir deneyim i\xe7in,",
        classic: "Daha klasik bir deneyim i\xe7in,",
        vocal: "Temsilciyle konu\u015Farak ileti\u015Fim kuruyorum.",
        text: "Temsilciyle mesaj yoluyla ileti\u015Fim kuruyorum."
    },
    modes: {
        vocal: "vokal modu",
        text: "metin modu"
    },
    loaderValidation: "Konu\u015Fmay\u0131 ba\u015Flat",
    locale: "dili kontrol etme",
    supported: "desteklenen dilleri kontrol etme",
    addressdata: "veri alma"
}, $914aec8743edd630$var$m5 = {
    message: "Mesaj\u0131n\u0131z\u0131 girin",
    backconversation: "konu\u015Fmaya geri d\xf6n",
    answer: " sorular\u0131n\u0131z\u0131 yan\u0131tl\u0131yor"
}, $914aec8743edd630$var$g5 = {
    firstline: "Optimum bir deneyim i\xe7in,",
    secondline: "ekran\u0131n\u0131 \xe7evir"
}, $914aec8743edd630$var$b5 = {
    shorttitle: "canl\u0131 bilgi kanal\u0131",
    warningtext: "Haber kanal\u0131na ula\u015Facaks\u0131n\u0131z, cihaz\u0131n\u0131zdaki ses aktif hale gelecektir",
    live: "canl\u0131",
    continuous: "devaml\u0131 olarak"
}, $914aec8743edd630$var$v5 = {
    comment: "m\xfc\u015Fteri yorumu",
    route: "yol",
    nodata: "Araman\u0131zla e\u015Fle\u015Fen i\xe7erik yok",
    openinghours: "A\xe7\u0131l\u0131\u015F saatleri",
    prices: "Fiyat:% s",
    paymentmethods: "\xd6deme metodlar\u0131",
    numberofplaces: "yer say\u0131s\u0131",
    openroutemobile: "ak\u0131ll\u0131 telefonda Google Haritalar rotas\u0131n\u0131 a\xe7",
    FoodEstablishment: "Nerede yenir",
    LodgingBusiness: "Nerede uyumal\u0131",
    TouristDestination: "Ne g\xf6rmeli",
    TouristAttraction: "Ne yapal\u0131m",
    Product: "Yerel \xfcr\xfcnler",
    Service: "Hizmetler",
    Event: "Olaylar",
    City: "\u015Eehirler",
    Wine: "\u015Earaplar"
}, $914aec8743edd630$var$y5 = {
    consult: "\xc7\u0131k\u0131\u015F yapmak",
    thetutorial: "\xf6\u011Fretici"
}, $914aec8743edd630$var$w5 = {
    reset: "hepsini s\u0131f\u0131rla",
    showresults: "Sonu\xe7lar\u0131 g\xf6ster",
    suggestiontitle: "\xd6nerileri ara",
    reminder: `Unutmay\u{131}n, 
 sorular\u{131}n\u{131}z\u{131} cevaplayabilirim.`
}, $914aec8743edd630$var$_5 = {
    listening: "S\u0131ra sizde, dinliyorum...",
    correct: "D\xfczelt",
    dontknow: "Bilmiyorum"
}, $914aec8743edd630$var$k5 = {
    allow: "Devam etmek i\xe7in l\xfctfen taray\u0131c\u0131n\u0131z\u0131n mikrofonunuza eri\u015Fmesine izin verin.",
    rejected: "Mikrofon eri\u015Fimini reddettiniz.",
    instructions: "Ses modunu kullanmak i\xe7in l\xfctfen taray\u0131c\u0131n\u0131z\u0131n mikrofonunuza eri\u015Fmesine izin verin.",
    listening: "S\xf6yl\xfcyorum",
    trigger: "Basma veya s\xf6yle",
    triggerwithoutname: "Konu\u015Fmak i\xe7in dokunun"
}, $914aec8743edd630$var$x5 = {
    rejected: "GPS konumunuza eri\u015Fim reddetti.",
    instructions: "Hava durumu verilerine veya etkile\u015Fimli haritaya eri\u015Fmek i\xe7in l\xfctfen taray\u0131c\u0131n\u0131za GPS konumunuza eri\u015Fim izni verin."
}, $914aec8743edd630$var$S5 = {
    calltoaction: "Ba\u015Flamak i\xe7in ekrana bas\u0131n",
    emptyveille: "Ekrana t\u0131klay\u0131n veya bas\u0131n..."
}, $914aec8743edd630$var$E5 = {
    shorttitle: "hava durumu",
    attribution: "Hava durumu verileri Open-Meteo.com taraf\u0131ndan sa\u011Flanmaktad\u0131r"
}, $914aec8743edd630$var$A5 = {
    title: "bota iletilen ki\u015Fisel verilerin i\u015Flenmesi",
    message: `bu diyalogu kabul ederek, chatbota iletilen t\xfcm verilerin arac\u{131}n kullan\u{131}m analizi ve bilgi taban\u{131}n\u{131}n zenginle\u{15F}tirilmesi amac\u{131}yla kullan\u{131}lmas\u{131}na izin vermi\u{15F} olursunuz.

Konu\u{15F}malar\u{131}n\u{131}z silinmeden \xf6nce 6 ay saklan\u{131}r.`,
    link: "gizlilik politikalar\u0131n\u0131 g\xf6r\xfcnt\xfclemek i\xe7in ba\u011Flant\u0131",
    buttonAccept: "anlad\u0131m ve kabul ediyorum",
    buttonRefuse: "reddediyorum",
    messageAccepted: "onay\u0131n\u0131z dikkate al\u0131nd\u0131",
    messageRefused: "reddiniz dikkate al\u0131nd\u0131"
}, $914aec8743edd630$var$T5 = {
    1: "ana sayfa",
    2: "canl\u0131 bilgi kanal\u0131",
    3: "hava durumu",
    4: "Acil durum numaralar\u0131",
    1e3: "tarih",
    1001: "\xf6\u011Fretici",
    common: $914aec8743edd630$var$a5,
    emergency: $914aec8743edd630$var$s5,
    error: $914aec8743edd630$var$u5,
    history: $914aec8743edd630$var$c5,
    home: $914aec8743edd630$var$l5,
    inputs: $914aec8743edd630$var$d5,
    language: $914aec8743edd630$var$f5,
    link: $914aec8743edd630$var$h5,
    loader: $914aec8743edd630$var$p5,
    menu: $914aec8743edd630$var$m5,
    mobileLandscapePreventer: $914aec8743edd630$var$g5,
    news: $914aec8743edd630$var$b5,
    poi: $914aec8743edd630$var$v5,
    suggestion: $914aec8743edd630$var$y5,
    template: $914aec8743edd630$var$w5,
    anghello: $914aec8743edd630$var$_5,
    microphone: $914aec8743edd630$var$k5,
    position: $914aec8743edd630$var$x5,
    veille: $914aec8743edd630$var$S5,
    weather: $914aec8743edd630$var$E5,
    GDPR: $914aec8743edd630$var$A5
}, $914aec8743edd630$var$C5 = {
    abort: "\u53D6\u6D88",
    all: "\u5168\u90E8",
    back: "\u540E\u9000",
    close: "\u5173\u95ED",
    continue: "\u7EE7\u7EED",
    download: "\u4E0B\u8F7D",
    downloadsheet: "\u4E0B\u8F7D\u6B64\u8868",
    downloadsheetmobile: "\u5728\u667A\u80FD\u624B\u673A\u4E0A\u4E0B\u8F7D\u6B64\u8868",
    filter: "\u7B5B\u9009",
    history: "\u5386\u53F2\u7684",
    knowmore: "\u4E86\u89E3\u66F4\u591A",
    lang: "\u8BED\u8A00",
    menu: "\u83DC\u5355",
    mode: "\u65F6\u5C1A",
    needhelp: "\u9700\u8981\u5E2E\u5FD9\uFF1F",
    parameters: "\u8BBE\u7F6E",
    print: "\u6253\u5370",
    printsheet: "\u6253\u5370\u6B64\u8868",
    result: "\u7ED3\u679C",
    results: "\u7ED3\u679C",
    singleLang: "\u8BED\u8A00",
    sound: "\u5979",
    submit: "\u63D0\u4EA4",
    subtitle: "\u5B57\u5E55",
    tutorial: "\u6559\u7A0B",
    validate: "\u8BC1\u5B9E"
}, $914aec8743edd630$var$R5 = {
    shorttitle: "\u7D27\u6025\u7535\u8BDD\u53F7\u7801",
    samu: "S.A.M.U.",
    police: "\u8B66\u5BDF",
    firefighter: "\u6D88\u9632\u5458",
    general: "\u5C06\u519B",
    hospital: "\u533B\u9662",
    homeless: "\u65E0\u5BB6\u53EF\u5F52",
    poison: "\u6BD2\u7269\u63A7\u5236\u4E2D\u5FC3",
    emergency: "\u7D27\u6025\u670D\u52A1"
}, $914aec8743edd630$var$O5 = {
    title: "\u53D1\u751F\u4E86\u9519\u8BEF",
    button: "\u91CD\u65B0\u542F\u52A8\u5E94\u7528\u7A0B\u5E8F"
}, $914aec8743edd630$var$D5 = {
    shorttitle: "\u5386\u53F2",
    title: "\u5BF9\u8BDD\u5386\u53F2"
}, $914aec8743edd630$var$P5 = {
    shorttitle: "\u4E3B\u9875"
}, $914aec8743edd630$var$I5 = {
    choose: "\u9009\u62E9\u4E00\u4E2A\u7B54\u6848",
    noaction: "\u7B49\u5F85\u64CD\u4F5C"
}, $914aec8743edd630$var$M5 = {
    change: "\u66F4\u6539\u8BED\u8A00",
    select: "\u9009\u62E9\u60A8\u8981\u4F7F\u7528\u7684\u8BED\u8A00"
}, $914aec8743edd630$var$j5 = {
    buttontext: "\u67E5\u770B\u6587\u6863",
    goto: "\u524D\u5F80\u5730\u5740",
    click: "\u70B9\u51FB\u8FD9\u91CC",
    scanQR: "\u626B\u63CF\u4E8C\u7EF4\u7801",
    scanQRTile: "\u626B\u63CF\u4E8C\u7EF4\u7801\u4EE5\u53D1\u73B0"
}, $914aec8743edd630$var$F5 = {
    loader: {
        optimal: "\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C",
        classic: "\u60F3\u8981\u66F4\u7ECF\u5178\u7684\u4F53\u9A8C\uFF0C",
        vocal: "\u6211\u901A\u8FC7\u4E0E\u4EE3\u7406\u4EBA\u4EA4\u8C08\u6765\u6C9F\u901A\u3002",
        text: "\u6211\u901A\u8FC7\u77ED\u4FE1\u4E0E\u4EE3\u7406\u4EBA\u6C9F\u901A\u3002"
    },
    modes: {
        vocal: "\u58F0\u97F3\u6A21\u5F0F",
        text: "\u6587\u672C\u6A21\u5F0F"
    },
    loaderValidation: "\u5F00\u59CB\u5BF9\u8BDD",
    locale: "\u68C0\u67E5\u8BED\u8A00",
    supported: "\u68C0\u67E5\u652F\u6301\u7684\u8BED\u8A00",
    addressdata: "\u68C0\u7D22\u6570\u636E"
}, $914aec8743edd630$var$$5 = {
    message: "\u8F93\u5165\u60A8\u7684\u7559\u8A00",
    backconversation: "\u56DE\u5230\u5BF9\u8BDD",
    answer: " \u56DE\u7B54\u4F60\u7684\u95EE\u9898"
}, $914aec8743edd630$var$L5 = {
    firstline: "\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C",
    secondline: "\u7FFB\u8F6C\u4F60\u7684\u5C4F\u5E55"
}, $914aec8743edd630$var$N5 = {
    shorttitle: "\u5B9E\u65F6\u4FE1\u606F\u9891\u9053",
    warningtext: "\u60A8\u5C06\u8BBF\u95EE\u65B0\u95FB\u9891\u9053\uFF0C\u8BBE\u5907\u4E0A\u7684\u58F0\u97F3\u5C06\u88AB\u6FC0\u6D3B",
    live: "\u5C45\u4F4F",
    continuous: "\u4E0D\u65AD\u5730"
}, $914aec8743edd630$var$B5 = {
    comment: "\u5BA2\u6237\u8BC4\u8BBA",
    route: "\u8DEF",
    nodata: "\u6CA1\u6709\u5185\u5BB9\u7B26\u5408\u60A8\u7684\u641C\u7D22",
    openinghours: "\u8425\u4E1A\u65F6\u95F4",
    prices: "\u4EF7\u683C",
    paymentmethods: "\u652F\u4ED8\u65B9\u5F0F",
    numberofplaces: "\u540D\u989D",
    openroutemobile: "\u5728\u667A\u80FD\u624B\u673A\u4E0A\u6253\u5F00 Google \u5730\u56FE\u8DEF\u7EBF",
    FoodEstablishment: "\u53BB\u54EA\u91CC\u5403\u996D",
    LodgingBusiness: "\u7761\u89C9\u7684\u5730\u65B9",
    TouristDestination: "\u8BE5\u770B\u4EC0\u4E48",
    TouristAttraction: "\u8BE5\u600E\u4E48\u529E",
    Product: "\u571F\u7279\u4EA7",
    Service: "\u670D\u52A1",
    Event: "\u6D3B\u52A8",
    City: "\u57CE\u5E02",
    Wine: "\u8461\u8404\u9152"
}, $914aec8743edd630$var$q5 = {
    consult: "\u67E5\u770B",
    thetutorial: "\u6559\u7A0B"
}, $914aec8743edd630$var$z5 = {
    reset: "\u91CD\u7F6E\u5168\u90E8",
    showresults: "\u663E\u793A\u7ED3\u679C",
    suggestiontitle: "\u641C\u7D22\u5EFA\u8BAE",
    reminder: `\u{522B}\u{5FD8}\u{4E86}\u{FF0C}
\u{6211}\u{53EF}\u{4EE5}\u{56DE}\u{7B54}\u{4F60}\u{7684}\u{95EE}\u{9898}\u{3002}`
}, $914aec8743edd630$var$U5 = {
    listening: "\u7531\u4F60\u51B3\u5B9A\uFF0C\u6211\u5728\u542C...",
    correct: "\u7EA0\u6B63",
    dontknow: "\u6211\u4E0D\u77E5\u9053"
}, $914aec8743edd630$var$V5 = {
    allow: "\u8BF7\u5141\u8BB8\u60A8\u7684\u6D4F\u89C8\u5668\u8BBF\u95EE\u9EA6\u514B\u98CE\u4EE5\u7EE7\u7EED\u3002",
    rejected: "\u60A8\u5DF2\u62D2\u7EDD\u9EA6\u514B\u98CE\u8BBF\u95EE\u3002",
    instructions: "\u8981\u4F7F\u7528\u8BED\u97F3\u6A21\u5F0F\uFF0C\u8BF7\u5141\u8BB8\u60A8\u7684\u6D4F\u89C8\u5668\u8BBF\u95EE\u9EA6\u514B\u98CE\u3002",
    listening: "\u6211\u5728\u542C\u4F60\u8BF4\u8BDD",
    trigger: "\u6309\u6216\u8BF4",
    triggerwithoutname: "\u70B9\u51FB\u8BF4\u8BDD"
}, $914aec8743edd630$var$G5 = {
    rejected: "\u60A8\u5DF2\u62D2\u7EDD\u8BBF\u95EE\u60A8\u7684GPS\u4F4D\u7F6E\u3002",
    instructions: "\u8981\u8BBF\u95EE\u5929\u6C14\u6570\u636E\u6216\u4EA4\u4E92\u5F0F\u5730\u56FE\uFF0C\u8BF7\u5141\u8BB8\u60A8\u7684\u6D4F\u89C8\u5668\u8BBF\u95EE\u60A8\u7684GPS\u4F4D\u7F6E\u3002"
}, $914aec8743edd630$var$W5 = {
    calltoaction: "\u6309\u4E0B\u5C4F\u5E55\u5F00\u59CB",
    emptyveille: "\u70B9\u51FB\u6216\u6309\u4E0B\u5C4F\u5E55..."
}, $914aec8743edd630$var$H5 = {
    shorttitle: "\u5929\u6C14",
    attribution: "\u5929\u6C14\u6570\u636E\u7531 Open-Meteo.com \u63D0\u4F9B"
}, $914aec8743edd630$var$K5 = {
    title: "\u5904\u7406\u4F20\u8F93\u7ED9\u673A\u5668\u4EBA\u7684\u4E2A\u4EBA\u6570\u636E",
    message: `\u{901A}\u{8FC7}\u{63A5}\u{53D7}\u{6B64}\u{5BF9}\u{8BDD}\u{FF0C}\u{60A8}\u{540C}\u{610F}\u{5C06}\u{4F20}\u{8F93}\u{7ED9}\u{804A}\u{5929}\u{673A}\u{5668}\u{4EBA}\u{7684}\u{6240}\u{6709}\u{6570}\u{636E}\u{7528}\u{4E8E}\u{5206}\u{6790}\u{5DE5}\u{5177}\u{4F7F}\u{7528}\u{60C5}\u{51B5}\u{548C}\u{4E30}\u{5BCC}\u{77E5}\u{8BC6}\u{5E93}\u{3002}

\u{60A8}\u{7684}\u{5BF9}\u{8BDD}\u{5C06}\u{4FDD}\u{5B58}6\u{4E2A}\u{6708}\u{540E}\u{5220}\u{9664}\u{3002}`,
    link: "\u67E5\u770B\u9690\u79C1\u653F\u7B56\u7684\u94FE\u63A5",
    buttonAccept: "\u6211\u7406\u89E3\u5E76\u63A5\u53D7",
    buttonRefuse: "\u6211\u62D2\u7EDD",
    messageAccepted: "\u60A8\u7684\u540C\u610F\u5DF2\u88AB\u8BB0\u5F55",
    messageRefused: "\u60A8\u7684\u62D2\u7EDD\u5DF2\u88AB\u8BB0\u5F55"
}, $914aec8743edd630$var$Q5 = {
    1: "\u4E3B\u9875",
    2: "\u5B9E\u65F6\u4FE1\u606F\u9891\u9053",
    3: "\u5929\u6C14",
    4: "\u7D27\u6025\u7535\u8BDD\u53F7\u7801",
    1e3: "\u5386\u53F2",
    1001: "\u6559\u7A0B",
    common: $914aec8743edd630$var$C5,
    emergency: $914aec8743edd630$var$R5,
    error: $914aec8743edd630$var$O5,
    history: $914aec8743edd630$var$D5,
    home: $914aec8743edd630$var$P5,
    inputs: $914aec8743edd630$var$I5,
    language: $914aec8743edd630$var$M5,
    link: $914aec8743edd630$var$j5,
    loader: $914aec8743edd630$var$F5,
    menu: $914aec8743edd630$var$$5,
    mobileLandscapePreventer: $914aec8743edd630$var$L5,
    news: $914aec8743edd630$var$N5,
    poi: $914aec8743edd630$var$B5,
    suggestion: $914aec8743edd630$var$q5,
    template: $914aec8743edd630$var$z5,
    anghello: $914aec8743edd630$var$U5,
    microphone: $914aec8743edd630$var$V5,
    position: $914aec8743edd630$var$G5,
    veille: $914aec8743edd630$var$W5,
    weather: $914aec8743edd630$var$H5,
    GDPR: $914aec8743edd630$var$K5
}, $914aec8743edd630$var$Y5 = {
    abort: "\u53D6\u6D88",
    all: "\u5168\u90E8",
    back: "\u540E\u9000",
    close: "\u5173\u95ED",
    continue: "\u7EE7\u7EED",
    download: "\u4E0B\u8F7D",
    downloadsheet: "\u4E0B\u8F7D\u6B64\u8868",
    downloadsheetmobile: "\u5728\u667A\u80FD\u624B\u673A\u4E0A\u4E0B\u8F7D\u6B64\u8868",
    filter: "\u7B5B\u9009",
    history: "\u5386\u53F2\u7684",
    knowmore: "\u4E86\u89E3\u66F4\u591A",
    lang: "\u8BED\u8A00",
    menu: "\u83DC\u5355",
    mode: "\u65F6\u5C1A",
    needhelp: "\u9700\u8981\u5E2E\u5FD9\uFF1F",
    parameters: "\u8BBE\u7F6E",
    print: "\u6253\u5370",
    printsheet: "\u6253\u5370\u6B64\u8868",
    result: "\u7ED3\u679C",
    results: "\u7ED3\u679C",
    singleLang: "\u8BED\u8A00",
    sound: "\u5979",
    submit: "\u63D0\u4EA4",
    subtitle: "\u5B57\u5E55",
    tutorial: "\u6559\u7A0B",
    validate: "\u8BC1\u5B9E"
}, $914aec8743edd630$var$J5 = {
    shorttitle: "\u7D27\u6025\u7535\u8BDD\u53F7\u7801",
    samu: "S.A.M.U.",
    police: "\u8B66\u5BDF",
    firefighter: "\u6D88\u9632\u5458",
    general: "\u5C06\u519B",
    hospital: "\u533B\u9662",
    homeless: "\u65E0\u5BB6\u53EF\u5F52",
    poison: "\u6BD2\u7269\u63A7\u5236\u4E2D\u5FC3",
    emergency: "\u7D27\u6025\u670D\u52A1"
}, $914aec8743edd630$var$Z5 = {
    title: "\u53D1\u751F\u4E86\u9519\u8BEF",
    button: "\u91CD\u65B0\u542F\u52A8\u5E94\u7528\u7A0B\u5E8F"
}, $914aec8743edd630$var$X5 = {
    shorttitle: "\u5386\u53F2",
    title: "\u5BF9\u8BDD\u5386\u53F2"
}, $914aec8743edd630$var$eP = {
    shorttitle: "\u4E3B\u9875"
}, $914aec8743edd630$var$tP = {
    choose: "\u9009\u62E9\u4E00\u4E2A\u7B54\u6848",
    noaction: "\u7B49\u5F85\u64CD\u4F5C"
}, $914aec8743edd630$var$rP = {
    change: "\u66F4\u6539\u8BED\u8A00",
    select: "\u9009\u62E9\u60A8\u8981\u4F7F\u7528\u7684\u8BED\u8A00"
}, $914aec8743edd630$var$nP = {
    buttontext: "\u67E5\u770B\u6587\u6863",
    goto: "\u524D\u5F80\u5730\u5740",
    click: "\u70B9\u51FB\u8FD9\u91CC",
    scanQR: "\u626B\u63CF\u4E8C\u7EF4\u7801",
    scanQRTile: "\u6383\u63CF QR \u78BC\u4EE5\u767C\u73FE"
}, $914aec8743edd630$var$iP = {
    loader: {
        optimal: "\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C",
        classic: "\u60F3\u8981\u66F4\u7ECF\u5178\u7684\u4F53\u9A8C\uFF0C",
        vocal: "\u6211\u901A\u8FC7\u4E0E\u4EE3\u7406\u4EBA\u4EA4\u8C08\u6765\u6C9F\u901A\u3002",
        text: "\u6211\u901A\u8FC7\u77ED\u4FE1\u4E0E\u4EE3\u7406\u4EBA\u6C9F\u901A\u3002"
    },
    modes: {
        vocal: "\u58F0\u97F3\u6A21\u5F0F",
        text: "\u6587\u672C\u6A21\u5F0F"
    },
    loaderValidation: "\u5F00\u59CB\u5BF9\u8BDD",
    locale: "\u68C0\u67E5\u8BED\u8A00",
    supported: "\u68C0\u67E5\u652F\u6301\u7684\u8BED\u8A00",
    addressdata: "\u68C0\u7D22\u6570\u636E"
}, $914aec8743edd630$var$oP = {
    message: "\u8F93\u5165\u60A8\u7684\u7559\u8A00",
    backconversation: "\u56DE\u5230\u5BF9\u8BDD",
    answer: " \u56DE\u7B54\u4F60\u7684\u95EE\u9898"
}, $914aec8743edd630$var$aP = {
    firstline: "\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C",
    secondline: "\u7FFB\u8F6C\u4F60\u7684\u5C4F\u5E55"
}, $914aec8743edd630$var$sP = {
    shorttitle: "\u5B9E\u65F6\u4FE1\u606F\u9891\u9053",
    warningtext: "\u60A8\u5C06\u8BBF\u95EE\u65B0\u95FB\u9891\u9053\uFF0C\u8BBE\u5907\u4E0A\u7684\u58F0\u97F3\u5C06\u88AB\u6FC0\u6D3B",
    live: "\u5C45\u4F4F",
    continuous: "\u4E0D\u65AD\u5730"
}, $914aec8743edd630$var$uP = {
    comment: "\u5BA2\u6237\u8BC4\u8BBA",
    route: "\u8DEF",
    nodata: "\u6CA1\u6709\u5185\u5BB9\u7B26\u5408\u60A8\u7684\u641C\u7D22",
    openinghours: "\u8425\u4E1A\u65F6\u95F4",
    prices: "\u4EF7\u683C",
    paymentmethods: "\u652F\u4ED8\u65B9\u5F0F",
    numberofplaces: "\u540D\u989D",
    openroutemobile: "\u5728\u667A\u80FD\u624B\u673A\u4E0A\u6253\u5F00 Google \u5730\u56FE\u8DEF\u7EBF",
    FoodEstablishment: "\u53BB\u54EA\u91CC\u5403\u996D",
    LodgingBusiness: "\u7761\u89C9\u7684\u5730\u65B9",
    TouristDestination: "\u8BE5\u770B\u4EC0\u4E48",
    TouristAttraction: "\u8BE5\u600E\u4E48\u529E",
    Product: "\u571F\u7279\u4EA7",
    Service: "\u670D\u52A1",
    Event: "\u6D3B\u52A8",
    City: "\u57CE\u5E02",
    Wine: "\u8461\u8404\u9152"
}, $914aec8743edd630$var$cP = {
    consult: "\u67E5\u770B",
    thetutorial: "\u6559\u7A0B"
}, $914aec8743edd630$var$lP = {
    reset: "\u91CD\u7F6E\u5168\u90E8",
    showresults: "\u663E\u793A\u7ED3\u679C",
    suggestiontitle: "\u641C\u7D22\u5EFA\u8BAE",
    reminder: `\u{522B}\u{5FD8}\u{4E86}\u{FF0C}
\u{6211}\u{53EF}\u{4EE5}\u{56DE}\u{7B54}\u{4F60}\u{7684}\u{95EE}\u{9898}\u{3002}`
}, $914aec8743edd630$var$dP = {
    listening: "\u7531\u4F60\u6C7A\u5B9A\uFF0C\u6211\u5728\u807D...",
    correct: "\u66F4\u6B63",
    dontknow: "\u6211\u4E0D\u77E5\u9053"
}, $914aec8743edd630$var$fP = {
    allow: "\u8ACB\u5141\u8A31\u60A8\u7684\u700F\u89BD\u5668\u8A2A\u554F\u9EA5\u514B\u98A8\u4EE5\u7E7C\u7E8C\u3002",
    rejected: "\u60A8\u5DF2\u62D2\u7D55\u9EA5\u514B\u98A8\u8A2A\u554F\u3002",
    instructions: "\u8981\u4F7F\u7528\u8A9E\u97F3\u6A21\u5F0F\uFF0C\u8ACB\u5141\u8A31\u60A8\u7684\u700F\u89BD\u5668\u8A2A\u554F\u9EA5\u514B\u98A8\u3002",
    listening: "\u6211\u5728\u542C\u4F60\u8BF4\u8BDD",
    trigger: "\u6309\u6216\u8BF4",
    triggerwithoutname: "\u9EDE\u64CA\u4EE5\u8AAA\u8A71"
}, $914aec8743edd630$var$hP = {
    rejected: "\u60A8\u5DF2\u62D2\u7EDD\u8BBF\u95EE\u60A8\u7684GPS\u4F4D\u7F6E\u3002",
    instructions: "\u8981\u8BBF\u95EE\u5929\u6C14\u6570\u636E\u6216\u4EA4\u4E92\u5F0F\u5730\u56FE\uFF0C\u8BF7\u5141\u8BB8\u60A8\u7684\u6D4F\u89C8\u5668\u8BBF\u95EE\u60A8\u7684GPS\u4F4D\u7F6E\u3002"
}, $914aec8743edd630$var$pP = {
    calltoaction: "\u6309\u4E0B\u87A2\u5E55\u958B\u59CB",
    emptyveille: "\u9EDE\u64CA\u6216\u6309\u4E0B\u87A2\u5E55..."
}, $914aec8743edd630$var$mP = {
    shorttitle: "\u5929\u6C14",
    attribution: "\u5929\u6C23\u6578\u64DA\u7531 Open-Meteo.com \u63D0\u4F9B"
}, $914aec8743edd630$var$gP = {
    title: "\u8655\u7406\u50B3\u8F38\u7D66\u6A5F\u5668\u4EBA\u7684\u500B\u4EBA\u6578\u64DA",
    message: `\u{901A}\u{904E}\u{63A5}\u{53D7}\u{6B64}\u{5C0D}\u{8A71}\u{FF0C}\u{60A8}\u{540C}\u{610F}\u{5C07}\u{50B3}\u{8F38}\u{7D66}\u{804A}\u{5929}\u{6A5F}\u{5668}\u{4EBA}\u{7684}\u{6240}\u{6709}\u{6578}\u{64DA}\u{7528}\u{65BC}\u{5206}\u{6790}\u{5DE5}\u{5177}\u{4F7F}\u{7528}\u{60C5}\u{6CC1}\u{548C}\u{8C50}\u{5BCC}\u{77E5}\u{8B58}\u{5EAB}\u{3002}

\u{60A8}\u{7684}\u{5C0D}\u{8A71}\u{5C07}\u{4FDD}\u{5B58}6\u{500B}\u{6708}\u{5F8C}\u{522A}\u{9664}\u{3002}`,
    link: "\u67E5\u770B\u96B1\u79C1\u653F\u7B56\u7684\u93C8\u63A5",
    buttonAccept: "\u6211\u7406\u89E3\u4E26\u63A5\u53D7",
    buttonRefuse: "\u6211\u62D2\u7D55",
    messageAccepted: "\u60A8\u7684\u540C\u610F\u5DF2\u88AB\u8A18\u9304",
    messageRefused: "\u60A8\u7684\u62D2\u7D55\u5DF2\u88AB\u8A18\u9304"
}, $914aec8743edd630$var$bP = {
    1: "\u4E3B\u9875",
    2: "\u5B9E\u65F6\u4FE1\u606F\u9891\u9053",
    3: "\u5929\u6C14",
    4: "\u7D27\u6025\u7535\u8BDD\u53F7\u7801",
    1e3: "\u5386\u53F2",
    1001: "\u6559\u7A0B",
    common: $914aec8743edd630$var$Y5,
    emergency: $914aec8743edd630$var$J5,
    error: $914aec8743edd630$var$Z5,
    history: $914aec8743edd630$var$X5,
    home: $914aec8743edd630$var$eP,
    inputs: $914aec8743edd630$var$tP,
    language: $914aec8743edd630$var$rP,
    link: $914aec8743edd630$var$nP,
    loader: $914aec8743edd630$var$iP,
    menu: $914aec8743edd630$var$oP,
    mobileLandscapePreventer: $914aec8743edd630$var$aP,
    news: $914aec8743edd630$var$sP,
    poi: $914aec8743edd630$var$uP,
    suggestion: $914aec8743edd630$var$cP,
    template: $914aec8743edd630$var$lP,
    anghello: $914aec8743edd630$var$dP,
    microphone: $914aec8743edd630$var$fP,
    position: $914aec8743edd630$var$hP,
    veille: $914aec8743edd630$var$pP,
    weather: $914aec8743edd630$var$mP,
    GDPR: $914aec8743edd630$var$gP
}, $914aec8743edd630$var$vP = {
    abort: "\u53D6\u6D88",
    all: "\u5168\u90E8",
    back: "\u540E\u9000",
    close: "\u5173\u95ED",
    continue: "\u7EE7\u7EED",
    download: "\u4E0B\u8F7D",
    downloadsheet: "\u4E0B\u8F7D\u6B64\u8868",
    downloadsheetmobile: "\u5728\u667A\u80FD\u624B\u673A\u4E0A\u4E0B\u8F7D\u6B64\u8868",
    filter: "\u7B5B\u9009",
    history: "\u5386\u53F2\u7684",
    knowmore: "\u4E86\u89E3\u66F4\u591A",
    lang: "\u8BED\u8A00",
    menu: "\u83DC\u5355",
    mode: "\u65F6\u5C1A",
    needhelp: "\u9700\u8981\u5E2E\u5FD9\uFF1F",
    parameters: "\u8BBE\u7F6E",
    print: "\u6253\u5370",
    printsheet: "\u6253\u5370\u6B64\u8868",
    result: "\u7ED3\u679C",
    results: "\u7ED3\u679C",
    singleLang: "\u8BED\u8A00",
    sound: "\u5979",
    submit: "\u63D0\u4EA4",
    subtitle: "\u5B57\u5E55",
    tutorial: "\u6559\u7A0B",
    validate: "\u8BC1\u5B9E"
}, $914aec8743edd630$var$yP = {
    shorttitle: "\u7D27\u6025\u7535\u8BDD\u53F7\u7801",
    samu: "S.A.M.U.",
    police: "\u8B66\u5BDF",
    firefighter: "\u6D88\u9632\u5458",
    general: "\u5C06\u519B",
    hospital: "\u533B\u9662",
    homeless: "\u65E0\u5BB6\u53EF\u5F52",
    poison: "\u6BD2\u7269\u63A7\u5236\u4E2D\u5FC3",
    emergency: "\u7D27\u6025\u670D\u52A1"
}, $914aec8743edd630$var$wP = {
    title: "\u53D1\u751F\u4E86\u9519\u8BEF",
    button: "\u91CD\u65B0\u542F\u52A8\u5E94\u7528\u7A0B\u5E8F"
}, $914aec8743edd630$var$_P = {
    shorttitle: "\u5386\u53F2",
    title: "\u5BF9\u8BDD\u5386\u53F2"
}, $914aec8743edd630$var$kP = {
    shorttitle: "\u4E3B\u9875"
}, $914aec8743edd630$var$xP = {
    choose: "\u9009\u62E9\u4E00\u4E2A\u7B54\u6848",
    noaction: "\u7B49\u5F85\u64CD\u4F5C"
}, $914aec8743edd630$var$SP = {
    change: "\u66F4\u6539\u8BED\u8A00",
    select: "\u9009\u62E9\u60A8\u8981\u4F7F\u7528\u7684\u8BED\u8A00"
}, $914aec8743edd630$var$EP = {
    buttontext: "\u67E5\u770B\u6587\u6863",
    goto: "\u524D\u5F80\u5730\u5740",
    click: "\u70B9\u51FB\u8FD9\u91CC",
    scanQR: "\u626B\u63CF\u4E8C\u7EF4\u7801",
    scanQRTile: "\u6383\u63CF QR \u78BC\u4EE5\u767C\u73FE"
}, $914aec8743edd630$var$AP = {
    loader: {
        optimal: "\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C",
        classic: "\u60F3\u8981\u66F4\u7ECF\u5178\u7684\u4F53\u9A8C\uFF0C",
        vocal: "\u6211\u901A\u8FC7\u4E0E\u4EE3\u7406\u4EBA\u4EA4\u8C08\u6765\u6C9F\u901A\u3002",
        text: "\u6211\u901A\u8FC7\u77ED\u4FE1\u4E0E\u4EE3\u7406\u4EBA\u6C9F\u901A\u3002"
    },
    modes: {
        vocal: "\u58F0\u97F3\u6A21\u5F0F",
        text: "\u6587\u672C\u6A21\u5F0F"
    },
    loaderValidation: "\u5F00\u59CB\u5BF9\u8BDD",
    locale: "\u68C0\u67E5\u8BED\u8A00",
    supported: "\u68C0\u67E5\u652F\u6301\u7684\u8BED\u8A00",
    addressdata: "\u68C0\u7D22\u6570\u636E"
}, $914aec8743edd630$var$TP = {
    message: "\u8F93\u5165\u60A8\u7684\u7559\u8A00",
    backconversation: "\u56DE\u5230\u5BF9\u8BDD",
    answer: " \u56DE\u7B54\u4F60\u7684\u95EE\u9898"
}, $914aec8743edd630$var$CP = {
    firstline: "\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C",
    secondline: "\u7FFB\u8F6C\u4F60\u7684\u5C4F\u5E55"
}, $914aec8743edd630$var$RP = {
    shorttitle: "\u5B9E\u65F6\u4FE1\u606F\u9891\u9053",
    warningtext: "\u60A8\u5C06\u8BBF\u95EE\u65B0\u95FB\u9891\u9053\uFF0C\u8BBE\u5907\u4E0A\u7684\u58F0\u97F3\u5C06\u88AB\u6FC0\u6D3B",
    live: "\u5C45\u4F4F",
    continuous: "\u4E0D\u65AD\u5730"
}, $914aec8743edd630$var$OP = {
    comment: "\u5BA2\u6237\u8BC4\u8BBA",
    route: "\u8DEF",
    nodata: "\u6CA1\u6709\u5185\u5BB9\u7B26\u5408\u60A8\u7684\u641C\u7D22",
    openinghours: "\u8425\u4E1A\u65F6\u95F4",
    prices: "\u4EF7\u683C",
    paymentmethods: "\u652F\u4ED8\u65B9\u5F0F",
    numberofplaces: "\u540D\u989D",
    openroutemobile: "\u5728\u667A\u80FD\u624B\u673A\u4E0A\u6253\u5F00 Google \u5730\u56FE\u8DEF\u7EBF",
    FoodEstablishment: "\u53BB\u54EA\u91CC\u5403\u996D",
    LodgingBusiness: "\u7761\u89C9\u7684\u5730\u65B9",
    TouristDestination: "\u8BE5\u770B\u4EC0\u4E48",
    TouristAttraction: "\u8BE5\u600E\u4E48\u529E",
    Product: "\u571F\u7279\u4EA7",
    Service: "\u670D\u52A1",
    Event: "\u6D3B\u52A8",
    City: "\u57CE\u5E02",
    Wine: "\u8461\u8404\u9152"
}, $914aec8743edd630$var$DP = {
    consult: "\u67E5\u770B",
    thetutorial: "\u6559\u7A0B"
}, $914aec8743edd630$var$PP = {
    reset: "\u91CD\u7F6E\u5168\u90E8",
    showresults: "\u663E\u793A\u7ED3\u679C",
    suggestiontitle: "\u641C\u7D22\u5EFA\u8BAE",
    reminder: `\u{522B}\u{5FD8}\u{4E86}\u{FF0C}
\u{6211}\u{53EF}\u{4EE5}\u{56DE}\u{7B54}\u{4F60}\u{7684}\u{95EE}\u{9898}\u{3002}`
}, $914aec8743edd630$var$IP = {
    listening: "\u7531\u4F60\u6C7A\u5B9A\uFF0C\u6211\u5728\u807D...",
    correct: "\u66F4\u6B63",
    dontknow: "\u6211\u4E0D\u77E5\u9053"
}, $914aec8743edd630$var$MP = {
    allow: "\u8ACB\u5141\u8A31\u60A8\u7684\u700F\u89BD\u5668\u8A2A\u554F\u9EA5\u514B\u98A8\u4EE5\u7E7C\u7E8C\u3002",
    rejected: "\u60A8\u5DF2\u62D2\u7D55\u9EA5\u514B\u98A8\u8A2A\u554F\u3002",
    instructions: "\u8981\u4F7F\u7528\u8A9E\u97F3\u6A21\u5F0F\uFF0C\u8ACB\u5141\u8A31\u60A8\u7684\u700F\u89BD\u5668\u8A2A\u554F\u9EA5\u514B\u98A8\u3002",
    listening: "\u6211\u5728\u542C\u4F60\u8BF4\u8BDD",
    trigger: "\u6309\u6216\u8BF4",
    triggerwithoutname: "\u9EDE\u64CA\u4EE5\u8AAA\u8A71"
}, $914aec8743edd630$var$jP = {
    rejected: "\u60A8\u5DF2\u62D2\u7EDD\u8BBF\u95EE\u60A8\u7684GPS\u4F4D\u7F6E\u3002",
    instructions: "\u8981\u8BBF\u95EE\u5929\u6C14\u6570\u636E\u6216\u4EA4\u4E92\u5F0F\u5730\u56FE\uFF0C\u8BF7\u5141\u8BB8\u60A8\u7684\u6D4F\u89C8\u5668\u8BBF\u95EE\u60A8\u7684GPS\u4F4D\u7F6E\u3002"
}, $914aec8743edd630$var$FP = {
    calltoaction: "\u6309\u4E0B\u87A2\u5E55\u958B\u59CB",
    emptyveille: "\u9EDE\u64CA\u6216\u6309\u4E0B\u87A2\u5E55..."
}, $914aec8743edd630$var$$P = {
    shorttitle: "\u5929\u6C14",
    attribution: "\u5929\u6C23\u6578\u64DA\u7531 Open-Meteo.com \u63D0\u4F9B"
}, $914aec8743edd630$var$LP = {
    title: "\u8655\u7406\u50B3\u8F38\u7D66\u6A5F\u5668\u4EBA\u7684\u500B\u4EBA\u6578\u64DA",
    message: `\u{901A}\u{904E}\u{63A5}\u{53D7}\u{6B64}\u{5C0D}\u{8A71}\u{FF0C}\u{60A8}\u{540C}\u{610F}\u{5C07}\u{50B3}\u{8F38}\u{7D66}\u{804A}\u{5929}\u{6A5F}\u{5668}\u{4EBA}\u{7684}\u{6240}\u{6709}\u{6578}\u{64DA}\u{7528}\u{65BC}\u{5206}\u{6790}\u{5DE5}\u{5177}\u{4F7F}\u{7528}\u{60C5}\u{6CC1}\u{548C}\u{8C50}\u{5BCC}\u{77E5}\u{8B58}\u{5EAB}\u{3002}

\u{60A8}\u{7684}\u{5C0D}\u{8A71}\u{5C07}\u{4FDD}\u{5B58}6\u{500B}\u{6708}\u{5F8C}\u{522A}\u{9664}\u{3002}`,
    link: "\u67E5\u770B\u96B1\u79C1\u653F\u7B56\u7684\u93C8\u63A5",
    buttonAccept: "\u6211\u7406\u89E3\u4E26\u63A5\u53D7",
    buttonRefuse: "\u6211\u62D2\u7D55",
    messageAccepted: "\u60A8\u7684\u540C\u610F\u5DF2\u88AB\u8A18\u9304",
    messageRefused: "\u60A8\u7684\u62D2\u7D55\u5DF2\u88AB\u8A18\u9304"
}, $914aec8743edd630$var$NP = {
    1: "\u4E3B\u9875",
    2: "\u5B9E\u65F6\u4FE1\u606F\u9891\u9053",
    3: "\u5929\u6C14",
    4: "\u7D27\u6025\u7535\u8BDD\u53F7\u7801",
    1e3: "\u5386\u53F2",
    1001: "\u6559\u7A0B",
    common: $914aec8743edd630$var$vP,
    emergency: $914aec8743edd630$var$yP,
    error: $914aec8743edd630$var$wP,
    history: $914aec8743edd630$var$_P,
    home: $914aec8743edd630$var$kP,
    inputs: $914aec8743edd630$var$xP,
    language: $914aec8743edd630$var$SP,
    link: $914aec8743edd630$var$EP,
    loader: $914aec8743edd630$var$AP,
    menu: $914aec8743edd630$var$TP,
    mobileLandscapePreventer: $914aec8743edd630$var$CP,
    news: $914aec8743edd630$var$RP,
    poi: $914aec8743edd630$var$OP,
    suggestion: $914aec8743edd630$var$DP,
    template: $914aec8743edd630$var$PP,
    anghello: $914aec8743edd630$var$IP,
    microphone: $914aec8743edd630$var$MP,
    position: $914aec8743edd630$var$jP,
    veille: $914aec8743edd630$var$FP,
    weather: $914aec8743edd630$var$$P,
    GDPR: $914aec8743edd630$var$LP
}, $914aec8743edd630$var$h0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    ar_AE: $914aec8743edd630$var$m_,
    ar_EG: $914aec8743edd630$var$$_,
    ar_SA: $914aec8743edd630$var$ok,
    ca_ES: $914aec8743edd630$var$Tk,
    cs_CZ: $914aec8743edd630$var$Qk,
    da_DK: $914aec8743edd630$var$bx,
    de_AT: $914aec8743edd630$var$Nx,
    de_CH: $914aec8743edd630$var$sS,
    de_DE: $914aec8743edd630$var$RS,
    en_CA: $914aec8743edd630$var$ZS,
    en_GB: $914aec8743edd630$var$w3,
    en_HK: $914aec8743edd630$var$U3,
    en_IE: $914aec8743edd630$var$fE,
    en_IN: $914aec8743edd630$var$jE,
    en_US: $914aec8743edd630$var$i6,
    es_ES: $914aec8743edd630$var$A6,
    es_MX: $914aec8743edd630$var$K6,
    fi_FI: $914aec8743edd630$var$gA,
    fr_BE: $914aec8743edd630$var$NA,
    fr_CA: $914aec8743edd630$var$uT,
    fr_CH: $914aec8743edd630$var$DT,
    fr_FR: $914aec8743edd630$var$Hr,
    hi_IN: $914aec8743edd630$var$_C,
    hu_HU: $914aec8743edd630$var$UC,
    id_ID: $914aec8743edd630$var$d4,
    it_IT: $914aec8743edd630$var$I4,
    ja_JP: $914aec8743edd630$var$t8,
    ko_KR: $914aec8743edd630$var$x8,
    nb_NO: $914aec8743edd630$var$G8,
    nl_BE: $914aec8743edd630$var$hR,
    nl_NL: $914aec8743edd630$var$jR,
    pl_PL: $914aec8743edd630$var$nO,
    pt_BR: $914aec8743edd630$var$EO,
    pt_PT: $914aec8743edd630$var$HO,
    ru_RU: $914aec8743edd630$var$mD,
    sv_SE: $914aec8743edd630$var$$D,
    th_TH: $914aec8743edd630$var$o5,
    tr_TR: $914aec8743edd630$var$T5,
    zh_CN: $914aec8743edd630$var$Q5,
    zh_HK: $914aec8743edd630$var$bP,
    zh_TW: $914aec8743edd630$var$NP
}, Symbol.toStringTag, {
    value: "Module"
})), $914aec8743edd630$var$BP = {
    ...$914aec8743edd630$var$Ue,
    companyName: "#000",
    loader: {
        animation: $914aec8743edd630$var$Ue.primary,
        background: "rgba(18,18,18,0.7)",
        text: "#FFF",
        toggle: {
            text: "#000",
            background: $914aec8743edd630$var$Ue.primary
        },
        button: {
            background: {
                default: "transparent",
                hover: "transparent"
            },
            border: {
                default: $914aec8743edd630$var$Ue.primary,
                hover: "#FFF"
            },
            text: {
                default: $914aec8743edd630$var$Ue.primary,
                hover: "#FFF"
            }
        }
    },
    card: {
        frame: {
            background: "#2B2B2B",
            border: "transparent",
            text: "#F7F3F6"
        },
        button: {
            background: {
                default: "transparent",
                hover: "transparent"
            },
            border: {
                default: $914aec8743edd630$var$Ue.primary,
                hover: "#FFF"
            },
            text: {
                default: $914aec8743edd630$var$Ue.primary,
                hover: "#FFF"
            }
        },
        discoverButton: {
            background: {
                default: "#eaebf0",
                hover: "transparent"
            },
            border: {
                default: "transparent",
                hover: "#FFF"
            },
            text: {
                default: "#575F6B",
                hover: "#FFF"
            }
        }
    },
    textMode: {
        panel: {
            background: "rgba(255, 255, 255, 0.9)",
            border: "transparent",
            conversationUser: "#FFF",
            conversationBot: "#2C2C2C",
            backgroundUser: $914aec8743edd630$var$Ue.secondary,
            backgroundBot: "#F0F0F0"
        }
    },
    vocalMode: {
        subtitles: {
            text: "#FFF",
            background: "#000"
        }
    },
    formInput: {
        text: {
            default: $914aec8743edd630$var$Ue.secondary,
            hover: "#FFF"
        },
        inputRadioCheckbox: {
            unchecked: {
                background: "#434141",
                border: "#818181"
            },
            checked: {
                background: $914aec8743edd630$var$Ue.primary,
                border: $914aec8743edd630$var$Ue.primary,
                item: "#000"
            }
        },
        inputButton: {
            background: {
                default: $914aec8743edd630$var$Ue.black,
                hover: $914aec8743edd630$var$Ue.primary
            },
            border: {
                default: $914aec8743edd630$var$Ue.primary,
                hover: "#FFF"
            },
            text: {
                default: "#FFF",
                hover: "#FFF"
            }
        },
        likert: {
            default: "transparent",
            hover: "#E8B712"
        }
    }
}, $914aec8743edd630$var$Ou = (e, t)=>{
    const r = (n)=>n && typeof n == "object";
    if (!r(e) || !r(t)) return t;
    const i = structuredClone(t);
    return Object.keys(i).forEach((n)=>{
        const o = e[n], s = i[n];
        (o || o === !1) && (Array.isArray(o) && Array.isArray(s) ? i[n] = [
            .../* @__PURE__ */ new Set([
                ...o,
                ...s
            ])
        ] : r(o) && r(s) ? i[n] = $914aec8743edd630$var$Ou(o, s) : i[n] = o);
    }), i;
}, $914aec8743edd630$var$qP = async (e, t)=>{
    const r = `${e}api/integration/framework?culture=${t}`;
    return await fetch(r).then((n)=>n.json()).then((n)=>{
        var o, s, a, u, l, c;
        return {
            localizedCompanyName: n.companyName,
            localizedSubCompanyMessage: n.subCompanyMessage,
            localizedBannerTitle: (a = (s = (o = n.viewsConfig) == null ? void 0 : o.views) == null ? void 0 : s.news) == null ? void 0 : a.bannerTitle,
            localizedMenus: (u = n.menu) == null ? void 0 : u.categories,
            localizedMapItems: (c = (l = n.mapConfig) == null ? void 0 : l.settings) == null ? void 0 : c.hospitalityCategories
        };
    }).catch(()=>null);
}, $914aec8743edd630$var$p0 = {
    baseAddress: "",
    locale: "",
    defaultLocale: "fr-FR",
    supported: [],
    dumpedLanguagesFallback: {},
    replacementLocales: {},
    currentTranslations: structuredClone($914aec8743edd630$var$Hr),
    isRTL: !1,
    localeForRetorikStudioContent: "",
    localizedCompanyName: void 0,
    localizedSubCompanyMessage: void 0,
    localizedBannerTitle: void 0,
    localizedMenus: []
}, $914aec8743edd630$var$Wg = $914aec8743edd630$var$mt({
    name: "locale",
    initialState: $914aec8743edd630$var$p0,
    reducers: {
        setBaseAddress: (e, t)=>{
            e.baseAddress = t.payload;
        },
        setLanguageData: (e, t)=>({
                ...e,
                defaultLocale: t.payload.defaultLocale,
                supported: t.payload.supported
            }),
        addDumpedLanguageFallback: (e, t)=>{
            e.dumpedLanguagesFallback = {
                ...e.dumpedLanguagesFallback,
                [t.payload.key]: t.payload.value
            };
        },
        addReplacementLocale: (e, t)=>{
            e.replacementLocales[t.payload.key] = t.payload.value;
        },
        resetLocaleStore: ()=>({
                ...$914aec8743edd630$var$p0
            })
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (e)=>{
        e.addCase($914aec8743edd630$var$Hg.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            })).addCase($914aec8743edd630$var$Kg.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            }));
    }
}), $914aec8743edd630$var$Hg = $914aec8743edd630$var$Ae("locale/setLocale", async (e, t)=>{
    var a, u;
    const r = t.getState().localeReducer, i = await $914aec8743edd630$var$qP(r.baseAddress, ((a = r.dumpedLanguagesFallback) == null ? void 0 : a[e]) || e), n = e.split("-")[0], o = structuredClone($914aec8743edd630$var$h0[e.replace("-", "_")]);
    let s = structuredClone($914aec8743edd630$var$Hr);
    if (o) s = $914aec8743edd630$var$Ou(o, structuredClone($914aec8743edd630$var$Hr));
    else {
        const l = $914aec8743edd630$var$G2.find((c)=>c.split("-")[0] === n);
        l && (s = $914aec8743edd630$var$Ou(structuredClone($914aec8743edd630$var$h0[l.replace("-", "_")]), structuredClone($914aec8743edd630$var$Hr)));
    }
    return {
        locale: e,
        isRTL: $914aec8743edd630$var$U2.includes(n),
        localeForRetorikStudioContent: ((u = r.dumpedLanguagesFallback) == null ? void 0 : u[e]) || e,
        currentTranslations: {
            ...s
        },
        localizedCompanyName: i == null ? void 0 : i.localizedCompanyName,
        localizedSubCompanyMessage: i == null ? void 0 : i.localizedSubCompanyMessage,
        localizedBannerTitle: i == null ? void 0 : i.localizedBannerTitle,
        localizedMenus: (i == null ? void 0 : i.localizedMenus) || []
    };
}), $914aec8743edd630$var$Kg = $914aec8743edd630$var$Ae("locale/fetchSupportedLanguages", async (e)=>await $914aec8743edd630$var$W2(e).then((t)=>({
            defaultLocale: t.default,
            supported: t.all
        }))), $914aec8743edd630$var$Qg = $914aec8743edd630$var$Ae("locale/checkDumpedLocaleFallback", async (e, t)=>{
    var i;
    const r = t.getState().localeReducer;
    return ((i = r.dumpedLanguagesFallback) == null ? void 0 : i[r.locale]) || r.locale;
}), $914aec8743edd630$var$zP = $914aec8743edd630$var$Wg.reducer, { setBaseAddress: $914aec8743edd630$var$UP, setLanguageData: $914aec8743edd630$var$VP, addDumpedLanguageFallback: $914aec8743edd630$var$GP, addReplacementLocale: $914aec8743edd630$var$WP, resetLocaleStore: $914aec8743edd630$var$HP } = $914aec8743edd630$var$Wg.actions, $914aec8743edd630$var$m0 = {
    restoreInputsState: !1,
    values: {},
    currentId: void 0,
    currentToggleIds: [],
    currentValue: void 0
}, $914aec8743edd630$var$Yg = $914aec8743edd630$var$mt({
    name: "adaptiveCard",
    initialState: $914aec8743edd630$var$m0,
    reducers: {
        setValue: (e, t)=>{
            if (t.payload.id === e.currentId) {
                const r = e.values;
                e.restoreInputsState && (r[t.payload.id] = t.payload.value), e.values = r, e.currentValue = {
                    [t.payload.id]: t.payload.value
                };
            }
        },
        setToggleValue: (e, t)=>{
            if (e.currentToggleIds.includes(t.payload.id)) {
                const r = e.values;
                e.restoreInputsState && (r[t.payload.id] = t.payload.value);
                const i = e.currentValue || {};
                e.currentToggleIds.forEach((n)=>{
                    var o;
                    if (n === t.payload.id) i[n] = t.payload.value;
                    else {
                        const s = ((o = e.currentValue) == null ? void 0 : o[n]) || !1;
                        i[n] = Array.isArray(s) ? !1 : s;
                    }
                }), e.values = r, e.currentValue = i;
            }
        },
        setCurrentId: (e, t)=>({
                ...e,
                currentId: t.payload,
                currentValue: void 0,
                currentToggleIds: []
            }),
        addCurrentToggleId: (e, t)=>{
            const r = e.values, i = e.currentToggleIds;
            r[t.payload.id] = t.payload.defaultValue, e.values = r, e.currentToggleIds = [
                ...i,
                t.payload.id
            ];
        },
        setRestoreInputsState: (e, t)=>{
            e.restoreInputsState = t.payload;
        },
        resetAdaptiveCardStore: ()=>({
                ...$914aec8743edd630$var$m0
            })
    }
}), $914aec8743edd630$var$KP = $914aec8743edd630$var$Yg.reducer, { setValue: $914aec8743edd630$var$QP, setToggleValue: $914aec8743edd630$var$YP, setCurrentId: $914aec8743edd630$var$Jg, addCurrentToggleId: $914aec8743edd630$var$JP, setRestoreInputsState: $914aec8743edd630$var$Zg, resetAdaptiveCardStore: $914aec8743edd630$var$ZP } = $914aec8743edd630$var$Yg.actions;
async function $914aec8743edd630$var$XP(e) {
    return await fetch(e).then((r)=>r.json()).catch((r)=>console.warn(`Retorik Framework > error fetching directline token : ${r}`));
}
var $914aec8743edd630$var$Ie = /* @__PURE__ */ ((e)=>(e.UNKNOWN = "DIRECT_LINE/UNKNOWN", e.INCOMING_ACTIVITY = "DIRECT_LINE/INCOMING_ACTIVITY", e.POST_ACTIVITY = "DIRECT_LINE/POST_ACTIVITY", e.POST_ACTIVITY_FULFILLED = "DIRECT_LINE/POST_ACTIVITY_FULFILLED", e.SEND_MESSAGE = "WEB_CHAT/SEND_MESSAGE", e.SEND_EVENT = "WEB_CHAT/SEND_EVENT", e.TYPING = "WEB_CHAT/EMIT_TYPING_INDICATOR", e.MARK = "WEB_CHAT/MARK_ACTIVITY", e.SET_LANGUAGE = "WEB_CHAT/SET_LANGUAGE", e))($914aec8743edd630$var$Ie || {});
const $914aec8743edd630$var$vc = {
    0: "DIRECT_LINE/CONNECT",
    1: "DIRECT_LINE/CONNECT_PENDING",
    2: "DIRECT_LINE/CONNECT_FULFILLED",
    3: "DIRECT_LINE/EXPIRED_TOKEN",
    4: "DIRECT_LINE/CONNECT_FAILED",
    5: "DIRECT_LINE/CONNECT_ENDED"
}, $914aec8743edd630$var$eI = (e)=>{
    var t, r, i;
    return (e == null ? void 0 : e.type) === "message" && (t = e.attachments) != null && t.length && e.attachments[0].contentType === "application/vnd.davi.retorik.card.suggestedaction" && ((i = (r = e.attachments[0].content) == null ? void 0 : r.title) == null ? void 0 : i.indexOf(e.text)) > -1 && (e.text = "", e.htmlText = ""), e;
};
function $914aec8743edd630$var$Ls(e, t, r, i) {
    return new (r || (r = Promise))(function(n, o) {
        function s(l) {
            try {
                u(i.next(l));
            } catch (c) {
                o(c);
            }
        }
        function a(l) {
            try {
                u(i.throw(l));
            } catch (c) {
                o(c);
            }
        }
        function u(l) {
            var c;
            l.done ? n(l.value) : (c = l.value, c instanceof r ? c : new r(function(d) {
                d(c);
            })).then(s, a);
        }
        u((i = i.apply(e, [])).next());
    });
}
const $914aec8743edd630$var$tI = [
    "geforce 320m",
    "geforce 8600",
    "geforce 8600m gt",
    "geforce 8800 gs",
    "geforce 8800 gt",
    "geforce 9400",
    "geforce 9400m g",
    "geforce 9400m",
    "geforce 9600m gt",
    "geforce 9600m",
    "geforce fx go5200",
    "geforce gt 120",
    "geforce gt 130",
    "geforce gt 330m",
    "geforce gtx 285",
    "google swiftshader",
    "intel g41",
    "intel g45",
    "intel gma 4500mhd",
    "intel gma x3100",
    "intel hd 3000",
    "intel q45",
    "legacy",
    "mali-2",
    "mali-3",
    "mali-4",
    "quadro fx 1500",
    "quadro fx 4",
    "quadro fx 5",
    "radeon hd 2400",
    "radeon hd 2600",
    "radeon hd 4670",
    "radeon hd 4850",
    "radeon hd 4870",
    "radeon hd 5670",
    "radeon hd 5750",
    "radeon hd 6290",
    "radeon hd 6300",
    "radeon hd 6310",
    "radeon hd 6320",
    "radeon hd 6490m",
    "radeon hd 6630m",
    "radeon hd 6750m",
    "radeon hd 6770m",
    "radeon hd 6970m",
    "sgx 543",
    "sgx543"
];
function $914aec8743edd630$var$g0(e) {
    return e = e.toLowerCase().replace(/.*angle ?\((.+)\)(?: on vulkan [0-9.]+)?$/i, "$1").replace(/\s(\d{1,2}gb|direct3d.+$)|\(r\)| \([^)]+\)$/g, "").replace(/(?:vulkan|opengl) \d+\.\d+(?:\.\d+)?(?: \((.*)\))?/, "$1");
}
const $914aec8743edd630$var$Xg = typeof window > "u", $914aec8743edd630$var$ot = (()=>{
    if ($914aec8743edd630$var$Xg) return;
    const { userAgent: e, platform: t, maxTouchPoints: r } = window.navigator, i = /(iphone|ipod|ipad)/i.test(e), n = t === "iPad" || t === "MacIntel" && r > 0 && !window.MSStream;
    return {
        isIpad: n,
        isMobile: /android/i.test(e) || i || n,
        isSafari12: /Version\/12.+Safari/.test(e),
        isFirefox: /Firefox/.test(e)
    };
})();
function $914aec8743edd630$var$rI(e, t, r) {
    if (!r) return [
        t
    ];
    const i = function(l) {
        const c = `
    precision highp float;
    attribute vec3 aPosition;
    varying float vvv;
    void main() {
      vvv = 0.31622776601683794;
      gl_Position = vec4(aPosition, 1.0);
    }
  `, d = `
    precision highp float;
    varying float vvv;
    void main() {
      vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * vvv;
      enc = fract(enc);
      enc -= enc.yzww * vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 0.0);
      gl_FragColor = enc;
    }
  `, h = l.createShader(35633), f = l.createShader(35632), p = l.createProgram();
        if (!(f && h && p)) return;
        l.shaderSource(h, c), l.shaderSource(f, d), l.compileShader(h), l.compileShader(f), l.attachShader(p, h), l.attachShader(p, f), l.linkProgram(p), l.detachShader(p, h), l.detachShader(p, f), l.deleteShader(h), l.deleteShader(f), l.useProgram(p);
        const m = l.createBuffer();
        l.bindBuffer(34962, m), l.bufferData(34962, new Float32Array([
            -1,
            -1,
            0,
            3,
            -1,
            0,
            -1,
            3,
            0
        ]), 35044);
        const w = l.getAttribLocation(p, "aPosition");
        l.vertexAttribPointer(w, 3, 5126, !1, 0, 0), l.enableVertexAttribArray(w), l.clearColor(1, 1, 1, 1), l.clear(16384), l.viewport(0, 0, 1, 1), l.drawArrays(4, 0, 3);
        const v = new Uint8Array(4);
        return l.readPixels(0, 0, 1, 1, 6408, 5121, v), l.deleteProgram(p), l.deleteBuffer(m), v.join("");
    }(e), n = "801621810", o = "8016218135", s = "80162181161", a = $914aec8743edd630$var$ot != null && $914aec8743edd630$var$ot.isIpad ? [
        [
            "a7",
            s,
            12
        ],
        [
            "a8",
            o,
            15
        ],
        [
            "a8x",
            o,
            15
        ],
        [
            "a9",
            o,
            15
        ],
        [
            "a9x",
            o,
            15
        ],
        [
            "a10",
            o,
            15
        ],
        [
            "a10x",
            o,
            15
        ],
        [
            "a12",
            n,
            15
        ],
        [
            "a12x",
            n,
            15
        ],
        [
            "a12z",
            n,
            15
        ],
        [
            "a14",
            n,
            15
        ],
        [
            "a15",
            n,
            15
        ],
        [
            "m1",
            n,
            15
        ],
        [
            "m2",
            n,
            15
        ]
    ] : [
        [
            "a7",
            s,
            12
        ],
        [
            "a8",
            o,
            12
        ],
        [
            "a9",
            o,
            15
        ],
        [
            "a10",
            o,
            15
        ],
        [
            "a11",
            n,
            15
        ],
        [
            "a12",
            n,
            15
        ],
        [
            "a13",
            n,
            15
        ],
        [
            "a14",
            n,
            15
        ],
        [
            "a15",
            n,
            15
        ],
        [
            "a16",
            n,
            15
        ],
        [
            "a17",
            n,
            15
        ]
    ];
    let u;
    return i === "80162181255" ? u = a.filter(([, , l])=>l >= 14) : (u = a.filter(([, l])=>l === i), u.length || (u = a)), u.map(([l])=>`apple ${l} gpu`);
}
class $914aec8743edd630$var$b0 extends Error {
    constructor(t){
        super(t), Object.setPrototypeOf(this, new.target.prototype);
    }
}
const $914aec8743edd630$var$Ns = [], $914aec8743edd630$var$v0 = [];
function $914aec8743edd630$var$nI(e, t) {
    if (e === t) return 0;
    const r = e;
    e.length > t.length && (e = t, t = r);
    let i = e.length, n = t.length;
    for(; i > 0 && e.charCodeAt(~-i) === t.charCodeAt(~-n);)i--, n--;
    let o, s = 0;
    for(; s < i && e.charCodeAt(s) === t.charCodeAt(s);)s++;
    if (i -= s, n -= s, i === 0) return n;
    let a, u, l = 0, c = 0, d = 0;
    for(; c < i;)$914aec8743edd630$var$v0[c] = e.charCodeAt(s + c), $914aec8743edd630$var$Ns[c] = ++c;
    for(; d < n;)for(o = t.charCodeAt(s + d), a = d++, l = d, c = 0; c < i; c++)u = o === $914aec8743edd630$var$v0[c] ? a : a + 1, a = $914aec8743edd630$var$Ns[c], l = $914aec8743edd630$var$Ns[c] = a > l ? u > l ? l + 1 : u : u > a ? a + 1 : u;
    return l;
}
function $914aec8743edd630$var$iI(e) {
    return e != null;
}
const $914aec8743edd630$var$oI = ({ mobileTiers: e = [
    0,
    15,
    30,
    60
], desktopTiers: t = [
    0,
    15,
    30,
    60
], override: r = {}, glContext: i, failIfMajorPerformanceCaveat: n = !1, benchmarksURL: o = "https://unpkg.com/detect-gpu@5.0.70/dist/benchmarks" } = {})=>$914aec8743edd630$var$Ls(void 0, void 0, void 0, function*() {
        const s = {};
        if ($914aec8743edd630$var$Xg) return {
            tier: 0,
            type: "SSR"
        };
        const { isIpad: a = !!($914aec8743edd630$var$ot != null && $914aec8743edd630$var$ot.isIpad), isMobile: u = !!($914aec8743edd630$var$ot != null && $914aec8743edd630$var$ot.isMobile), screenSize: l = window.screen, loadBenchmarks: c = (k)=>$914aec8743edd630$var$Ls(void 0, void 0, void 0, function*() {
                const y = yield fetch(`${o}/${k}`).then((x)=>x.json());
                if (parseInt(y.shift().split(".")[0], 10) < 4) throw new $914aec8743edd630$var$b0("Detect GPU benchmark data is out of date. Please update to version 4x");
                return y;
            }) } = r;
        let { renderer: d } = r;
        const h = (k, y, x, C, I)=>({
                device: I,
                fps: C,
                gpu: x,
                isMobile: u,
                tier: k,
                type: y
            });
        let f, p = "";
        if (d) d = $914aec8743edd630$var$g0(d), f = [
            d
        ];
        else {
            const k = i || function(x, C = !1) {
                const I = {
                    alpha: !1,
                    antialias: !1,
                    depth: !1,
                    failIfMajorPerformanceCaveat: C,
                    powerPreference: "high-performance",
                    stencil: !1
                };
                x && delete I.powerPreference;
                const M = window.document.createElement("canvas"), Q = M.getContext("webgl", I) || M.getContext("experimental-webgl", I);
                return Q ?? void 0;
            }($914aec8743edd630$var$ot == null ? void 0 : $914aec8743edd630$var$ot.isSafari12, n);
            if (!k) return h(0, "WEBGL_UNSUPPORTED");
            const y = $914aec8743edd630$var$ot != null && $914aec8743edd630$var$ot.isFirefox ? null : k.getExtension("WEBGL_debug_renderer_info");
            if (d = y ? k.getParameter(y.UNMASKED_RENDERER_WEBGL) : k.getParameter(k.RENDERER), !d) return h(1, "FALLBACK");
            p = d, d = $914aec8743edd630$var$g0(d), f = function(x, C, I) {
                return C === "apple gpu" ? $914aec8743edd630$var$rI(x, C, I) : [
                    C
                ];
            }(k, d, u);
        }
        const m = (yield Promise.all(f.map(function(k) {
            var y;
            return $914aec8743edd630$var$Ls(this, void 0, void 0, function*() {
                const x = ((oe)=>{
                    const ie = u ? [
                        "adreno",
                        "apple",
                        "mali-t",
                        "mali",
                        "nvidia",
                        "powervr",
                        "samsung"
                    ] : [
                        "intel",
                        "apple",
                        "amd",
                        "radeon",
                        "nvidia",
                        "geforce",
                        "adreno"
                    ];
                    for (const le of ie)if (oe.includes(le)) return le;
                })(k);
                if (!x) return;
                const C = `${u ? "m" : "d"}-${x}${a ? "-ipad" : ""}.json`, I = s[C] = (y = s[C]) !== null && y !== void 0 ? y : c(C);
                let M;
                try {
                    M = yield I;
                } catch (oe) {
                    if (oe instanceof $914aec8743edd630$var$b0) throw oe;
                    return;
                }
                const Q = function(oe) {
                    var ie;
                    const le = (oe = oe.replace(/\([^)]+\)/, "")).match(/\d+/) || oe.match(/(\W|^)([A-Za-z]{1,3})(\W|$)/g);
                    return (ie = le == null ? void 0 : le.join("").replace(/\W|amd/g, "")) !== null && ie !== void 0 ? ie : "";
                }(k);
                let H = M.filter(([, oe])=>oe === Q);
                H.length || (H = M.filter(([oe])=>oe.includes(k)));
                const J = H.length;
                if (J === 0) return;
                const W = k.split(/[.,()\[\]/\s]/g).sort().filter((oe, ie, le)=>ie === 0 || oe !== le[ie - 1]).join(" ");
                let P, [R, , , , V] = J > 1 ? H.map((oe)=>[
                        oe,
                        $914aec8743edd630$var$nI(W, oe[2])
                    ]).sort(([, oe], [, ie])=>oe - ie)[0][0] : H[0], X = Number.MAX_VALUE;
                const { devicePixelRatio: N } = window, U = l.width * N * l.height * N;
                for (const oe of V){
                    const [ie, le] = oe, he = ie * le, ye = Math.abs(U - he);
                    ye < X && (X = ye, P = oe);
                }
                if (!P) return;
                const [, , G, re] = P;
                return [
                    X,
                    G,
                    R,
                    re
                ];
            });
        }))).filter($914aec8743edd630$var$iI).sort(([k = Number.MAX_VALUE, y], [x = Number.MAX_VALUE, C])=>k === x ? y - C : k - x);
        if (!m.length) {
            const k = $914aec8743edd630$var$tI.find((y)=>d.includes(y));
            return k ? h(0, "BLOCKLISTED", k) : h(1, "FALLBACK", `${d} (${p})`);
        }
        const [, w, v, g] = m[0];
        if (w === -1) return h(0, "BLOCKLISTED", v, w, g);
        const A = u ? e : t;
        let b = 0;
        for(let k = 0; k < A.length; k++)w >= A[k] && (b = k);
        return h(b, "BENCHMARK", v, w, g);
    }), $914aec8743edd630$var$y0 = async (e)=>{
    const t = await fetch(`${e}/manifest.json?v=${Date.now()}`).then((r)=>r.json()).then((r)=>r).catch((r)=>(console.log(r), null));
    return t !== null && (t.url = t.character ? `${e}/${t.character}` : e, t.portrait = e + "/" + t.portrait, t.useBodyEngineThree = !!t.character), t;
}, $914aec8743edd630$var$w0 = {
    configuration: {
        subtitles: !1
    },
    addressData: {},
    canFocusSendBox: !1,
    sendBoxPlaceHolder: void 0,
    fromTextToVocal: !1,
    subtitlesInConfiguration: !1,
    displaySubtitles: !1,
    agentData: void 0,
    gpuData: void 0,
    loaderClosed: !1,
    appAvailable: !1,
    currentLayout: $914aec8743edd630$var$$g.agent,
    userAlreadySet: !1,
    isWaitingForResponse: !1,
    instantIsWaitingForResponse: !1,
    skipLoader: !1,
    displayAgentInNews: !0,
    submitDelayBeforeSendingMessage: void 0,
    environmentPreset: "apartment",
    customScripts: [],
    customCSS: [],
    enabledFeatures: [],
    showPositionModal: !1
};
let $914aec8743edd630$var$Br = setTimeout(()=>!0, 1e3);
const $914aec8743edd630$var$aI = `${$914aec8743edd630$var$Gg}/long-shot/zahra`, $914aec8743edd630$var$sI = `${$914aec8743edd630$var$Gg}/long-shot/rowan`, $914aec8743edd630$var$eb = $914aec8743edd630$var$mt({
    name: "retorik",
    initialState: $914aec8743edd630$var$w0,
    reducers: {
        setConfiguration: (e, t)=>{
            e.configuration = t.payload;
        },
        setAddressData: (e, t)=>{
            e.addressData = t.payload;
        },
        focusSendBox: ()=>{
            var t;
            const e = document.getElementById("retorik-framework-send-textbox-textarea");
            e && ((t = document.activeElement) == null ? void 0 : t.id) !== e.id && e.focus();
        },
        setCanFocusSendBox: (e, t)=>{
            e.canFocusSendBox = t.payload;
        },
        setSendBoxPlaceHolder: (e, t)=>{
            e.sendBoxPlaceHolder = t.payload;
        },
        setLayout: (e, t)=>{
            e.currentLayout = t.payload;
        },
        setUserAlreadySet: (e, t)=>{
            e.userAlreadySet = t.payload;
        },
        setEnvironmentPreset: (e, t)=>{
            e.environmentPreset = t.payload;
        },
        setFromTextToVocal: (e, t)=>{
            e.fromTextToVocal = t.payload;
        },
        setLoaderClosed: (e, t)=>{
            e.loaderClosed = t.payload;
        },
        setAppAvailable: (e, t)=>{
            e.appAvailable = t.payload;
        },
        setSubtitlesInConfiguration: (e, t)=>{
            e.subtitlesInConfiguration = t.payload, e.displaySubtitles = t.payload;
        },
        setDisplaySubtitles: (e, t)=>{
            e.displaySubtitles = t.payload;
        },
        toggleSubtitles: (e)=>{
            e.displaySubtitles = !e.displaySubtitles;
        },
        setInternalIsWaitingForResponse: (e, t)=>{
            e.isWaitingForResponse = t.payload;
        },
        setInstantIsWaitingForResponse: (e, t)=>{
            e.instantIsWaitingForResponse = t.payload;
        },
        setSkipLoader: (e, t)=>{
            e.skipLoader = t.payload;
        },
        setDisplayAgentInNews: (e, t)=>{
            e.displayAgentInNews = t.payload;
        },
        setSubmitDelayBeforeSendingMessage: (e, t)=>{
            e.submitDelayBeforeSendingMessage = t.payload;
        },
        setCustomScripts: (e, t)=>{
            e.customScripts = t.payload;
        },
        setCustomCSS: (e, t)=>{
            e.customCSS = t.payload;
        },
        setEnabledFeatures: (e, t)=>{
            e.enabledFeatures = t.payload;
        },
        setShowPositionModal: (e, t)=>{
            e.showPositionModal = t.payload;
        },
        resetRetorikStore: ()=>({
                ...$914aec8743edd630$var$w0
            })
    },
    extraReducers: (e)=>{
        e.addCase($914aec8743edd630$var$tb.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            }));
    }
}), $914aec8743edd630$var$tb = $914aec8743edd630$var$Ae("retorik/setAgentData", async (e)=>{
    const t = await $914aec8743edd630$var$oI();
    let r = !1;
    t.tier > 0 && (t.type === "FALLBACK" ? r = !0 : r = t.tier > 1);
    const i = typeof e == "string" ? e : e.url;
    let n = await $914aec8743edd630$var$y0(i);
    return n != null && n.useBodyEngineThree && !r && (console.log("Retorik Framework > graphic capacity too low to use bodyengine, the application will switch to spiritengine"), n = await $914aec8743edd630$var$y0((n == null ? void 0 : n.gender) === "female" ? $914aec8743edd630$var$aI : $914aec8743edd630$var$sI)), n && typeof e != "string" && (e.name && (n.name = e.name), e.animationsUrl && (n.animationsUrl = e.animationsUrl), e.portrait && (n.portrait = e.portrait)), {
        gpuData: t,
        agentData: n
    };
}), $914aec8743edd630$var$Bt = $914aec8743edd630$var$Ae("retorik/setIsWaitingForResponse", async (e, t)=>{
    e ? ($914aec8743edd630$var$Br = setTimeout(()=>{
        t.dispatch($914aec8743edd630$var$_0(!0)), $914aec8743edd630$var$Br = null;
    }, 1e3), t.dispatch($914aec8743edd630$var$k0(!0))) : ($914aec8743edd630$var$Br && clearTimeout($914aec8743edd630$var$Br), $914aec8743edd630$var$Br = null, t.dispatch($914aec8743edd630$var$k0(!1)), t.dispatch($914aec8743edd630$var$_0(!1)));
}), $914aec8743edd630$var$uI = $914aec8743edd630$var$eb.reducer, { setConfiguration: $914aec8743edd630$var$cI, setAddressData: $914aec8743edd630$var$lI, focusSendBox: $914aec8743edd630$var$dI, setCanFocusSendBox: $914aec8743edd630$var$fI, setSendBoxPlaceHolder: $914aec8743edd630$var$rb, setLayout: $914aec8743edd630$var$hI, setUserAlreadySet: $914aec8743edd630$var$pI, setEnvironmentPreset: $914aec8743edd630$var$mI, setFromTextToVocal: $914aec8743edd630$var$gI, setLoaderClosed: $914aec8743edd630$var$bI, setAppAvailable: $914aec8743edd630$var$vI, setSubtitlesInConfiguration: $914aec8743edd630$var$yI, setDisplaySubtitles: $914aec8743edd630$var$wI, toggleSubtitles: $914aec8743edd630$var$_I, setInternalIsWaitingForResponse: $914aec8743edd630$var$_0, setInstantIsWaitingForResponse: $914aec8743edd630$var$k0, setSkipLoader: $914aec8743edd630$var$kI, setDisplayAgentInNews: $914aec8743edd630$var$xI, setSubmitDelayBeforeSendingMessage: $914aec8743edd630$var$nb, setCustomScripts: $914aec8743edd630$var$SI, setCustomCSS: $914aec8743edd630$var$EI, setEnabledFeatures: $914aec8743edd630$var$AI, setShowPositionModal: $914aec8743edd630$var$TI, resetRetorikStore: $914aec8743edd630$var$CI } = $914aec8743edd630$var$eb.actions, $914aec8743edd630$var$RI = "application/vnd.microsoft.card.adaptive", $914aec8743edd630$var$OI = "application/vnd.microsoft.card.hero", $914aec8743edd630$var$DI = "application/vnd.davi.retorik.card.image", $914aec8743edd630$var$yc = "application/vnd.davi.retorik.card.link", $914aec8743edd630$var$PI = "application/vnd.davi.retorik.card.suggestion", $914aec8743edd630$var$II = "application/vnd.davi.retorik.card.suggestedaction", $914aec8743edd630$var$MI = "application/vnd.davi.retorik.card.counter", $914aec8743edd630$var$jI = "application/vnd.davi.retorik.card.namedlistitem", $914aec8743edd630$var$x0 = {};
function $914aec8743edd630$var$FI(e) {
    let t = $914aec8743edd630$var$x0[e];
    if (t) return t;
    t = $914aec8743edd630$var$x0[e] = [];
    for(let r = 0; r < 128; r++){
        const i = String.fromCharCode(r);
        t.push(i);
    }
    for(let r = 0; r < e.length; r++){
        const i = e.charCodeAt(r);
        t[i] = "%" + ("0" + i.toString(16).toUpperCase()).slice(-2);
    }
    return t;
}
function $914aec8743edd630$var$Xt(e, t) {
    typeof t != "string" && (t = $914aec8743edd630$var$Xt.defaultChars);
    const r = $914aec8743edd630$var$FI(t);
    return e.replace(/(%[a-f0-9]{2})+/gi, function(i) {
        let n = "";
        for(let o = 0, s = i.length; o < s; o += 3){
            const a = parseInt(i.slice(o + 1, o + 3), 16);
            if (a < 128) {
                n += r[a];
                continue;
            }
            if ((a & 224) === 192 && o + 3 < s) {
                const u = parseInt(i.slice(o + 4, o + 6), 16);
                if ((u & 192) === 128) {
                    const l = a << 6 & 1984 | u & 63;
                    l < 128 ? n += "\uFFFD\uFFFD" : n += String.fromCharCode(l), o += 3;
                    continue;
                }
            }
            if ((a & 240) === 224 && o + 6 < s) {
                const u = parseInt(i.slice(o + 4, o + 6), 16), l = parseInt(i.slice(o + 7, o + 9), 16);
                if ((u & 192) === 128 && (l & 192) === 128) {
                    const c = a << 12 & 61440 | u << 6 & 4032 | l & 63;
                    c < 2048 || c >= 55296 && c <= 57343 ? n += "\uFFFD\uFFFD\uFFFD" : n += String.fromCharCode(c), o += 6;
                    continue;
                }
            }
            if ((a & 248) === 240 && o + 9 < s) {
                const u = parseInt(i.slice(o + 4, o + 6), 16), l = parseInt(i.slice(o + 7, o + 9), 16), c = parseInt(i.slice(o + 10, o + 12), 16);
                if ((u & 192) === 128 && (l & 192) === 128 && (c & 192) === 128) {
                    let d = a << 18 & 1835008 | u << 12 & 258048 | l << 6 & 4032 | c & 63;
                    d < 65536 || d > 1114111 ? n += "\uFFFD\uFFFD\uFFFD\uFFFD" : (d -= 65536, n += String.fromCharCode(55296 + (d >> 10), 56320 + (d & 1023))), o += 9;
                    continue;
                }
            }
            n += "\uFFFD";
        }
        return n;
    });
}
$914aec8743edd630$var$Xt.defaultChars = ";/?:@&=+$,#";
$914aec8743edd630$var$Xt.componentChars = "";
const $914aec8743edd630$var$S0 = {};
function $914aec8743edd630$var$$I(e) {
    let t = $914aec8743edd630$var$S0[e];
    if (t) return t;
    t = $914aec8743edd630$var$S0[e] = [];
    for(let r = 0; r < 128; r++){
        const i = String.fromCharCode(r);
        /^[0-9a-z]$/i.test(i) ? t.push(i) : t.push("%" + ("0" + r.toString(16).toUpperCase()).slice(-2));
    }
    for(let r = 0; r < e.length; r++)t[e.charCodeAt(r)] = e[r];
    return t;
}
function $914aec8743edd630$var$hn(e, t, r) {
    typeof t != "string" && (r = t, t = $914aec8743edd630$var$hn.defaultChars), typeof r > "u" && (r = !0);
    const i = $914aec8743edd630$var$$I(t);
    let n = "";
    for(let o = 0, s = e.length; o < s; o++){
        const a = e.charCodeAt(o);
        if (r && a === 37 && o + 2 < s && /^[0-9a-f]{2}$/i.test(e.slice(o + 1, o + 3))) {
            n += e.slice(o, o + 3), o += 2;
            continue;
        }
        if (a < 128) {
            n += i[a];
            continue;
        }
        if (a >= 55296 && a <= 57343) {
            if (a >= 55296 && a <= 56319 && o + 1 < s) {
                const u = e.charCodeAt(o + 1);
                if (u >= 56320 && u <= 57343) {
                    n += encodeURIComponent(e[o] + e[o + 1]), o++;
                    continue;
                }
            }
            n += "%EF%BF%BD";
            continue;
        }
        n += encodeURIComponent(e[o]);
    }
    return n;
}
$914aec8743edd630$var$hn.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$914aec8743edd630$var$hn.componentChars = "-_.!~*'()";
function $914aec8743edd630$var$wc(e) {
    let t = "";
    return t += e.protocol || "", t += e.slashes ? "//" : "", t += e.auth ? e.auth + "@" : "", e.hostname && e.hostname.indexOf(":") !== -1 ? t += "[" + e.hostname + "]" : t += e.hostname || "", t += e.port ? ":" + e.port : "", t += e.pathname || "", t += e.search || "", t += e.hash || "", t;
}
function $914aec8743edd630$var$qn() {
    this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
const $914aec8743edd630$var$LI = /^([a-z0-9.+-]+:)/i, $914aec8743edd630$var$NI = /:[0-9]*$/, $914aec8743edd630$var$BI = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, $914aec8743edd630$var$qI = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    `
`,
    "	"
], $914aec8743edd630$var$zI = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($914aec8743edd630$var$qI), $914aec8743edd630$var$UI = [
    "'"
].concat($914aec8743edd630$var$zI), $914aec8743edd630$var$E0 = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($914aec8743edd630$var$UI), $914aec8743edd630$var$A0 = [
    "/",
    "?",
    "#"
], $914aec8743edd630$var$VI = 255, $914aec8743edd630$var$T0 = /^[+a-z0-9A-Z_-]{0,63}$/, $914aec8743edd630$var$GI = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, $914aec8743edd630$var$C0 = {
    javascript: !0,
    "javascript:": !0
}, $914aec8743edd630$var$R0 = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
};
function $914aec8743edd630$var$_c(e, t) {
    if (e && e instanceof $914aec8743edd630$var$qn) return e;
    const r = new $914aec8743edd630$var$qn();
    return r.parse(e, t), r;
}
$914aec8743edd630$var$qn.prototype.parse = function(e, t) {
    let r, i, n, o = e;
    if (o = o.trim(), !t && e.split("#").length === 1) {
        const l = $914aec8743edd630$var$BI.exec(o);
        if (l) return this.pathname = l[1], l[2] && (this.search = l[2]), this;
    }
    let s = $914aec8743edd630$var$LI.exec(o);
    if (s && (s = s[0], r = s.toLowerCase(), this.protocol = s, o = o.substr(s.length)), (t || s || o.match(/^\/\/[^@\/]+@[^@\/]+/)) && (n = o.substr(0, 2) === "//", n && !(s && $914aec8743edd630$var$C0[s]) && (o = o.substr(2), this.slashes = !0)), !$914aec8743edd630$var$C0[s] && (n || s && !$914aec8743edd630$var$R0[s])) {
        let l = -1;
        for(let p = 0; p < $914aec8743edd630$var$A0.length; p++)i = o.indexOf($914aec8743edd630$var$A0[p]), i !== -1 && (l === -1 || i < l) && (l = i);
        let c, d;
        l === -1 ? d = o.lastIndexOf("@") : d = o.lastIndexOf("@", l), d !== -1 && (c = o.slice(0, d), o = o.slice(d + 1), this.auth = c), l = -1;
        for(let p = 0; p < $914aec8743edd630$var$E0.length; p++)i = o.indexOf($914aec8743edd630$var$E0[p]), i !== -1 && (l === -1 || i < l) && (l = i);
        l === -1 && (l = o.length), o[l - 1] === ":" && l--;
        const h = o.slice(0, l);
        o = o.slice(l), this.parseHost(h), this.hostname = this.hostname || "";
        const f = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        if (!f) {
            const p = this.hostname.split(/\./);
            for(let m = 0, w = p.length; m < w; m++){
                const v = p[m];
                if (v && !v.match($914aec8743edd630$var$T0)) {
                    let g = "";
                    for(let A = 0, b = v.length; A < b; A++)v.charCodeAt(A) > 127 ? g += "x" : g += v[A];
                    if (!g.match($914aec8743edd630$var$T0)) {
                        const A = p.slice(0, m), b = p.slice(m + 1), k = v.match($914aec8743edd630$var$GI);
                        k && (A.push(k[1]), b.unshift(k[2])), b.length && (o = b.join(".") + o), this.hostname = A.join(".");
                        break;
                    }
                }
            }
        }
        this.hostname.length > $914aec8743edd630$var$VI && (this.hostname = ""), f && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
    }
    const a = o.indexOf("#");
    a !== -1 && (this.hash = o.substr(a), o = o.slice(0, a));
    const u = o.indexOf("?");
    return u !== -1 && (this.search = o.substr(u), o = o.slice(0, u)), o && (this.pathname = o), $914aec8743edd630$var$R0[r] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
$914aec8743edd630$var$qn.prototype.parseHost = function(e) {
    let t = $914aec8743edd630$var$NI.exec(e);
    t && (t = t[0], t !== ":" && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
};
const $914aec8743edd630$var$WI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    decode: $914aec8743edd630$var$Xt,
    encode: $914aec8743edd630$var$hn,
    format: $914aec8743edd630$var$wc,
    parse: $914aec8743edd630$var$_c
}, Symbol.toStringTag, {
    value: "Module"
})), $914aec8743edd630$var$ib = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, $914aec8743edd630$var$ob = /[\0-\x1F\x7F-\x9F]/, $914aec8743edd630$var$HI = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/, $914aec8743edd630$var$kc = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, $914aec8743edd630$var$ab = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/, $914aec8743edd630$var$sb = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/, $914aec8743edd630$var$KI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    Any: $914aec8743edd630$var$ib,
    Cc: $914aec8743edd630$var$ob,
    Cf: $914aec8743edd630$var$HI,
    P: $914aec8743edd630$var$kc,
    S: $914aec8743edd630$var$ab,
    Z: $914aec8743edd630$var$sb
}, Symbol.toStringTag, {
    value: "Module"
})), $914aec8743edd630$var$QI = new Uint16Array(// prettier-ignore
'\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\uD835\uDD04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\uD835\uDD38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\uD835\uDC9Cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\uD835\uDD05pf;\uC000\uD835\uDD39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\uD835\uDC9Ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\uD835\uDD07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\uD835\uDD3B\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\uD835\uDC9Frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\uD835\uDD08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\uD835\uDD3Csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\uD835\uDD09lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\uD835\uDD3DAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\uD835\uDD0A;\u62D9pf;\uC000\uD835\uDD3Eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\uD835\uDCA2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\uD835\uDD40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\uD835\uDD0Dpf;\uC000\uD835\uDD41\u01E3\u07C7\0\u07CCr;\uC000\uD835\uDCA5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\uD835\uDD0Epf;\uC000\uD835\uDD42cr;\uC000\uD835\uDCA6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\uD835\uDD0F\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\uD835\uDD43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\uD835\uDD10nusPlus;\u6213pf;\uC000\uD835\uDD44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\uD835\uDD11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\uD835\uDCA9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\uD835\uDD12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\uD835\uDD46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\uD835\uDCAAash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\uD835\uDD13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\uD835\uDCAB;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\uD835\uDD14pf;\u611Acr;\uC000\uD835\uDCAC\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\uD835\uDD16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\uD835\uDD4A\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\uD835\uDCAEar;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\uD835\uDD17\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\uD835\uDD4BipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\uD835\uDCAFrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\uD835\uDD18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\uD835\uDD4C\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\uD835\uDCB0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\uD835\uDD19pf;\uC000\uD835\uDD4Dcr;\uC000\uD835\uDCB1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\uD835\uDD1Apf;\uC000\uD835\uDD4Ecr;\uC000\uD835\uDCB2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\uD835\uDD1B;\u439Epf;\uC000\uD835\uDD4Fcr;\uC000\uD835\uDCB3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\uD835\uDD1Cpf;\uC000\uD835\uDD50cr;\uC000\uD835\uDCB4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\uD835\uDCB5\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\uD835\uDD1Erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\uD835\uDD52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\uD835\uDCB6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\uD835\uDD1Fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\uD835\uDD53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\uD835\uDCB7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\uD835\uDD20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\uD835\uDD54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\uD835\uDCB8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\uD835\uDD21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\uD835\uDD55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\uD835\uDCB9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\uD835\uDD22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\uD835\uDD56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\0\0\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\uD835\uDD23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\uD835\uDD57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\uD835\uDCBB\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\uD835\uDD24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\uD835\uDD58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\uD835\uDD25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\uD835\uDD59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\uD835\uDCBDas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\uD835\uDD26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\uD835\uDD5Aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\uD835\uDCBEn\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\uD835\uDD27ath;\u4237pf;\uC000\uD835\uDD5B\u01E3\u23EC\0\u23F1r;\uC000\uD835\uDCBFrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\uD835\uDD28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\uD835\uDD5Ccr;\uC000\uD835\uDCC0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\uD835\uDD29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\uD835\uDD5Dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\uD835\uDCC1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\uD835\uDD2Ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\uD835\uDD5E\u0100ct\u28F8\u28FDr;\uC000\uD835\uDCC2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\uD835\uDD2B\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\uD835\uDD5F\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\uD835\uDCC3ort\u026D\u2B05\0\0\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\uD835\uDD2C\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\uD835\uDD60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\uD835\uDD2D\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\uD835\uDD61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\uD835\uDCC5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\uD835\uDD2Epf;\uC000\uD835\uDD62rime;\u6057cr;\uC000\uD835\uDCC6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\uD835\uDD2F\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\uD835\uDD63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\uD835\uDCC7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\uD835\uDD30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\uD835\uDD64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\uD835\uDCC8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\uD835\uDD31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\uD835\uDD65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\uD835\uDCC9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\uD835\uDD32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\uD835\uDD66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\uD835\uDCCA\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\uD835\uDD33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\uD835\uDD67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\uD835\uDCCB\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\uD835\uDD34pf;\uC000\uD835\uDD68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\uD835\uDCCC\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\uD835\uDD35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\uD835\uDD69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\uD835\uDCCD\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\uD835\uDD36cy;\u4457pf;\uC000\uD835\uDD6Acr;\uC000\uD835\uDCCE\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\uD835\uDD37cy;\u4436grarr;\u61DDpf;\uC000\uD835\uDD6Bcr;\uC000\uD835\uDCCF\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map((e)=>e.charCodeAt(0))), $914aec8743edd630$var$YI = new Uint16Array(// prettier-ignore
"\u0200aglq	\x15\x18\x1b\u026D\x0f\0\0\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map((e)=>e.charCodeAt(0)));
var $914aec8743edd630$var$Bs;
const $914aec8743edd630$var$JI = /* @__PURE__ */ new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]), $914aec8743edd630$var$ZI = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($914aec8743edd630$var$Bs = String.fromCodePoint) !== null && $914aec8743edd630$var$Bs !== void 0 ? $914aec8743edd630$var$Bs : function(e) {
    let t = "";
    return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e), t;
};
function $914aec8743edd630$var$XI(e) {
    var t;
    return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = $914aec8743edd630$var$JI.get(e)) !== null && t !== void 0 ? t : e;
}
var $914aec8743edd630$var$Fe;
(function(e) {
    e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})($914aec8743edd630$var$Fe || ($914aec8743edd630$var$Fe = {}));
const $914aec8743edd630$var$eM = 32;
var $914aec8743edd630$var$At;
(function(e) {
    e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})($914aec8743edd630$var$At || ($914aec8743edd630$var$At = {}));
function $914aec8743edd630$var$Du(e) {
    return e >= $914aec8743edd630$var$Fe.ZERO && e <= $914aec8743edd630$var$Fe.NINE;
}
function $914aec8743edd630$var$tM(e) {
    return e >= $914aec8743edd630$var$Fe.UPPER_A && e <= $914aec8743edd630$var$Fe.UPPER_F || e >= $914aec8743edd630$var$Fe.LOWER_A && e <= $914aec8743edd630$var$Fe.LOWER_F;
}
function $914aec8743edd630$var$rM(e) {
    return e >= $914aec8743edd630$var$Fe.UPPER_A && e <= $914aec8743edd630$var$Fe.UPPER_Z || e >= $914aec8743edd630$var$Fe.LOWER_A && e <= $914aec8743edd630$var$Fe.LOWER_Z || $914aec8743edd630$var$Du(e);
}
function $914aec8743edd630$var$nM(e) {
    return e === $914aec8743edd630$var$Fe.EQUALS || $914aec8743edd630$var$rM(e);
}
var $914aec8743edd630$var$Me;
(function(e) {
    e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})($914aec8743edd630$var$Me || ($914aec8743edd630$var$Me = {}));
var $914aec8743edd630$var$Et;
(function(e) {
    e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})($914aec8743edd630$var$Et || ($914aec8743edd630$var$Et = {}));
class $914aec8743edd630$var$iM {
    constructor(t, r, i){
        this.decodeTree = t, this.emitCodePoint = r, this.errors = i, this.state = $914aec8743edd630$var$Me.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = $914aec8743edd630$var$Et.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(t) {
        this.decodeMode = t, this.state = $914aec8743edd630$var$Me.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
    }
    /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */ write(t, r) {
        switch(this.state){
            case $914aec8743edd630$var$Me.EntityStart:
                return t.charCodeAt(r) === $914aec8743edd630$var$Fe.NUM ? (this.state = $914aec8743edd630$var$Me.NumericStart, this.consumed += 1, this.stateNumericStart(t, r + 1)) : (this.state = $914aec8743edd630$var$Me.NamedEntity, this.stateNamedEntity(t, r));
            case $914aec8743edd630$var$Me.NumericStart:
                return this.stateNumericStart(t, r);
            case $914aec8743edd630$var$Me.NumericDecimal:
                return this.stateNumericDecimal(t, r);
            case $914aec8743edd630$var$Me.NumericHex:
                return this.stateNumericHex(t, r);
            case $914aec8743edd630$var$Me.NamedEntity:
                return this.stateNamedEntity(t, r);
        }
    }
    /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */ stateNumericStart(t, r) {
        return r >= t.length ? -1 : (t.charCodeAt(r) | $914aec8743edd630$var$eM) === $914aec8743edd630$var$Fe.LOWER_X ? (this.state = $914aec8743edd630$var$Me.NumericHex, this.consumed += 1, this.stateNumericHex(t, r + 1)) : (this.state = $914aec8743edd630$var$Me.NumericDecimal, this.stateNumericDecimal(t, r));
    }
    addToNumericResult(t, r, i, n) {
        if (r !== i) {
            const o = i - r;
            this.result = this.result * Math.pow(n, o) + parseInt(t.substr(r, o), n), this.consumed += o;
        }
    }
    /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */ stateNumericHex(t, r) {
        const i = r;
        for(; r < t.length;){
            const n = t.charCodeAt(r);
            if ($914aec8743edd630$var$Du(n) || $914aec8743edd630$var$tM(n)) r += 1;
            else return this.addToNumericResult(t, i, r, 16), this.emitNumericEntity(n, 3);
        }
        return this.addToNumericResult(t, i, r, 16), -1;
    }
    /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */ stateNumericDecimal(t, r) {
        const i = r;
        for(; r < t.length;){
            const n = t.charCodeAt(r);
            if ($914aec8743edd630$var$Du(n)) r += 1;
            else return this.addToNumericResult(t, i, r, 10), this.emitNumericEntity(n, 2);
        }
        return this.addToNumericResult(t, i, r, 10), -1;
    }
    /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */ emitNumericEntity(t, r) {
        var i;
        if (this.consumed <= r) return (i = this.errors) === null || i === void 0 || i.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (t === $914aec8743edd630$var$Fe.SEMI) this.consumed += 1;
        else if (this.decodeMode === $914aec8743edd630$var$Et.Strict) return 0;
        return this.emitCodePoint($914aec8743edd630$var$XI(this.result), this.consumed), this.errors && (t !== $914aec8743edd630$var$Fe.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
    }
    /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */ stateNamedEntity(t, r) {
        const { decodeTree: i } = this;
        let n = i[this.treeIndex], o = (n & $914aec8743edd630$var$At.VALUE_LENGTH) >> 14;
        for(; r < t.length; r++, this.excess++){
            const s = t.charCodeAt(r);
            if (this.treeIndex = $914aec8743edd630$var$oM(i, n, this.treeIndex + Math.max(1, o), s), this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $914aec8743edd630$var$Et.Attribute && // We shouldn't have consumed any characters after the entity,
            (o === 0 || // And there should be no invalid characters.
            $914aec8743edd630$var$nM(s)) ? 0 : this.emitNotTerminatedNamedEntity();
            if (n = i[this.treeIndex], o = (n & $914aec8743edd630$var$At.VALUE_LENGTH) >> 14, o !== 0) {
                if (s === $914aec8743edd630$var$Fe.SEMI) return this.emitNamedEntityData(this.treeIndex, o, this.consumed + this.excess);
                this.decodeMode !== $914aec8743edd630$var$Et.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
            }
        }
        return -1;
    }
    /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */ emitNotTerminatedNamedEntity() {
        var t;
        const { result: r, decodeTree: i } = this, n = (i[r] & $914aec8743edd630$var$At.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(r, n, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
    }
    /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */ emitNamedEntityData(t, r, i) {
        const { decodeTree: n } = this;
        return this.emitCodePoint(r === 1 ? n[t] & ~$914aec8743edd630$var$At.VALUE_LENGTH : n[t + 1], i), r === 3 && this.emitCodePoint(n[t + 2], i), i;
    }
    /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */ end() {
        var t;
        switch(this.state){
            case $914aec8743edd630$var$Me.NamedEntity:
                return this.result !== 0 && (this.decodeMode !== $914aec8743edd630$var$Et.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $914aec8743edd630$var$Me.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $914aec8743edd630$var$Me.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $914aec8743edd630$var$Me.NumericStart:
                return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            case $914aec8743edd630$var$Me.EntityStart:
                return 0;
        }
    }
}
function $914aec8743edd630$var$ub(e) {
    let t = "";
    const r = new $914aec8743edd630$var$iM(e, (i)=>t += $914aec8743edd630$var$ZI(i));
    return function(n, o) {
        let s = 0, a = 0;
        for(; (a = n.indexOf("&", a)) >= 0;){
            t += n.slice(s, a), r.startEntity(o);
            const l = r.write(n, // Skip the "&"
            a + 1);
            if (l < 0) {
                s = a + r.end();
                break;
            }
            s = a + l, a = l === 0 ? s + 1 : s;
        }
        const u = t + n.slice(s);
        return t = "", u;
    };
}
function $914aec8743edd630$var$oM(e, t, r, i) {
    const n = (t & $914aec8743edd630$var$At.BRANCH_LENGTH) >> 7, o = t & $914aec8743edd630$var$At.JUMP_TABLE;
    if (n === 0) return o !== 0 && i === o ? r : -1;
    if (o) {
        const u = i - o;
        return u < 0 || u >= n ? -1 : e[r + u] - 1;
    }
    let s = r, a = s + n - 1;
    for(; s <= a;){
        const u = s + a >>> 1, l = e[u];
        if (l < i) s = u + 1;
        else if (l > i) a = u - 1;
        else return e[u + n];
    }
    return -1;
}
const $914aec8743edd630$var$aM = $914aec8743edd630$var$ub($914aec8743edd630$var$QI);
$914aec8743edd630$var$ub($914aec8743edd630$var$YI);
function $914aec8743edd630$var$cb(e, t = $914aec8743edd630$var$Et.Legacy) {
    return $914aec8743edd630$var$aM(e, t);
}
function $914aec8743edd630$var$sM(e) {
    return Object.prototype.toString.call(e);
}
function $914aec8743edd630$var$xc(e) {
    return $914aec8743edd630$var$sM(e) === "[object String]";
}
const $914aec8743edd630$var$uM = Object.prototype.hasOwnProperty;
function $914aec8743edd630$var$cM(e, t) {
    return $914aec8743edd630$var$uM.call(e, t);
}
function $914aec8743edd630$var$ci(e) {
    return Array.prototype.slice.call(arguments, 1).forEach(function(r) {
        if (r) {
            if (typeof r != "object") throw new TypeError(r + "must be object");
            Object.keys(r).forEach(function(i) {
                e[i] = r[i];
            });
        }
    }), e;
}
function $914aec8743edd630$var$lb(e, t, r) {
    return [].concat(e.slice(0, t), r, e.slice(t + 1));
}
function $914aec8743edd630$var$Sc(e) {
    return !(e >= 55296 && e <= 57343 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534 || e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e >= 127 && e <= 159 || e > 1114111);
}
function $914aec8743edd630$var$zn(e) {
    if (e > 65535) {
        e -= 65536;
        const t = 55296 + (e >> 10), r = 56320 + (e & 1023);
        return String.fromCharCode(t, r);
    }
    return String.fromCharCode(e);
}
const $914aec8743edd630$var$db = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, $914aec8743edd630$var$lM = /&([a-z#][a-z0-9]{1,31});/gi, $914aec8743edd630$var$dM = new RegExp($914aec8743edd630$var$db.source + "|" + $914aec8743edd630$var$lM.source, "gi"), $914aec8743edd630$var$fM = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $914aec8743edd630$var$hM(e, t) {
    if (t.charCodeAt(0) === 35 && $914aec8743edd630$var$fM.test(t)) {
        const i = t[1].toLowerCase() === "x" ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10);
        return $914aec8743edd630$var$Sc(i) ? $914aec8743edd630$var$zn(i) : e;
    }
    const r = $914aec8743edd630$var$cb(e);
    return r !== e ? r : e;
}
function $914aec8743edd630$var$pM(e) {
    return e.indexOf("\\") < 0 ? e : e.replace($914aec8743edd630$var$db, "$1");
}
function $914aec8743edd630$var$er(e) {
    return e.indexOf("\\") < 0 && e.indexOf("&") < 0 ? e : e.replace($914aec8743edd630$var$dM, function(t, r, i) {
        return r || $914aec8743edd630$var$hM(t, i);
    });
}
const $914aec8743edd630$var$mM = /[&<>"]/, $914aec8743edd630$var$gM = /[&<>"]/g, $914aec8743edd630$var$bM = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $914aec8743edd630$var$vM(e) {
    return $914aec8743edd630$var$bM[e];
}
function $914aec8743edd630$var$Tt(e) {
    return $914aec8743edd630$var$mM.test(e) ? e.replace($914aec8743edd630$var$gM, $914aec8743edd630$var$vM) : e;
}
const $914aec8743edd630$var$yM = /[.?*+^$[\]\\(){}|-]/g;
function $914aec8743edd630$var$wM(e) {
    return e.replace($914aec8743edd630$var$yM, "\\$&");
}
function $914aec8743edd630$var$Oe(e) {
    switch(e){
        case 9:
        case 32:
            return !0;
    }
    return !1;
}
function $914aec8743edd630$var$Zr(e) {
    if (e >= 8192 && e <= 8202) return !0;
    switch(e){
        case 9:
        // \t
        case 10:
        // \n
        case 11:
        // \v
        case 12:
        // \f
        case 13:
        // \r
        case 32:
        case 160:
        case 5760:
        case 8239:
        case 8287:
        case 12288:
            return !0;
    }
    return !1;
}
function $914aec8743edd630$var$Xr(e) {
    return $914aec8743edd630$var$kc.test(e) || $914aec8743edd630$var$ab.test(e);
}
function $914aec8743edd630$var$en(e) {
    switch(e){
        case 33:
        case 34:
        case 35:
        case 36:
        case 37:
        case 38:
        case 39:
        case 40:
        case 41:
        case 42:
        case 43:
        case 44:
        case 45:
        case 46:
        case 47:
        case 58:
        case 59:
        case 60:
        case 61:
        case 62:
        case 63:
        case 64:
        case 91:
        case 92:
        case 93:
        case 94:
        case 95:
        case 96:
        case 123:
        case 124:
        case 125:
        case 126:
            return !0;
        default:
            return !1;
    }
}
function $914aec8743edd630$var$li(e) {
    return e = e.trim().replace(/\s+/g, " "), "\u1E9E".toLowerCase() === "\u1E7E" && (e = e.replace(/ẞ/g, "\xdf")), e.toLowerCase().toUpperCase();
}
const $914aec8743edd630$var$_M = {
    mdurl: $914aec8743edd630$var$WI,
    ucmicro: $914aec8743edd630$var$KI
}, $914aec8743edd630$var$kM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    arrayReplaceAt: $914aec8743edd630$var$lb,
    assign: $914aec8743edd630$var$ci,
    escapeHtml: $914aec8743edd630$var$Tt,
    escapeRE: $914aec8743edd630$var$wM,
    fromCodePoint: $914aec8743edd630$var$zn,
    has: $914aec8743edd630$var$cM,
    isMdAsciiPunct: $914aec8743edd630$var$en,
    isPunctChar: $914aec8743edd630$var$Xr,
    isSpace: $914aec8743edd630$var$Oe,
    isString: $914aec8743edd630$var$xc,
    isValidEntityCode: $914aec8743edd630$var$Sc,
    isWhiteSpace: $914aec8743edd630$var$Zr,
    lib: $914aec8743edd630$var$_M,
    normalizeReference: $914aec8743edd630$var$li,
    unescapeAll: $914aec8743edd630$var$er,
    unescapeMd: $914aec8743edd630$var$pM
}, Symbol.toStringTag, {
    value: "Module"
}));
function $914aec8743edd630$var$xM(e, t, r) {
    let i, n, o, s;
    const a = e.posMax, u = e.pos;
    for(e.pos = t + 1, i = 1; e.pos < a;){
        if (o = e.src.charCodeAt(e.pos), o === 93 && (i--, i === 0)) {
            n = !0;
            break;
        }
        if (s = e.pos, e.md.inline.skipToken(e), o === 91) {
            if (s === e.pos - 1) i++;
            else if (r) return e.pos = u, -1;
        }
    }
    let l = -1;
    return n && (l = e.pos), e.pos = u, l;
}
function $914aec8743edd630$var$SM(e, t, r) {
    let i, n = t;
    const o = {
        ok: !1,
        pos: 0,
        str: ""
    };
    if (e.charCodeAt(n) === 60) {
        for(n++; n < r;){
            if (i = e.charCodeAt(n), i === 10 || i === 60) return o;
            if (i === 62) return o.pos = n + 1, o.str = $914aec8743edd630$var$er(e.slice(t + 1, n)), o.ok = !0, o;
            if (i === 92 && n + 1 < r) {
                n += 2;
                continue;
            }
            n++;
        }
        return o;
    }
    let s = 0;
    for(; n < r && (i = e.charCodeAt(n), !(i === 32 || i < 32 || i === 127));){
        if (i === 92 && n + 1 < r) {
            if (e.charCodeAt(n + 1) === 32) break;
            n += 2;
            continue;
        }
        if (i === 40 && (s++, s > 32)) return o;
        if (i === 41) {
            if (s === 0) break;
            s--;
        }
        n++;
    }
    return t === n || s !== 0 || (o.str = $914aec8743edd630$var$er(e.slice(t, n)), o.pos = n, o.ok = !0), o;
}
function $914aec8743edd630$var$EM(e, t, r, i) {
    let n, o = t;
    const s = {
        // if `true`, this is a valid link title
        ok: !1,
        // if `true`, this link can be continued on the next line
        can_continue: !1,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: "",
        // expected closing marker character code
        marker: 0
    };
    if (i) s.str = i.str, s.marker = i.marker;
    else {
        if (o >= r) return s;
        let a = e.charCodeAt(o);
        if (a !== 34 && a !== 39 && a !== 40) return s;
        t++, o++, a === 40 && (a = 41), s.marker = a;
    }
    for(; o < r;){
        if (n = e.charCodeAt(o), n === s.marker) return s.pos = o + 1, s.str += $914aec8743edd630$var$er(e.slice(t, o)), s.ok = !0, s;
        if (n === 40 && s.marker === 41) return s;
        n === 92 && o + 1 < r && o++, o++;
    }
    return s.can_continue = !0, s.str += $914aec8743edd630$var$er(e.slice(t, o)), s;
}
const $914aec8743edd630$var$AM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    parseLinkDestination: $914aec8743edd630$var$SM,
    parseLinkLabel: $914aec8743edd630$var$xM,
    parseLinkTitle: $914aec8743edd630$var$EM
}, Symbol.toStringTag, {
    value: "Module"
})), $914aec8743edd630$var$ct = {};
$914aec8743edd630$var$ct.code_inline = function(e, t, r, i, n) {
    const o = e[t];
    return "<code" + n.renderAttrs(o) + ">" + $914aec8743edd630$var$Tt(o.content) + "</code>";
};
$914aec8743edd630$var$ct.code_block = function(e, t, r, i, n) {
    const o = e[t];
    return "<pre" + n.renderAttrs(o) + "><code>" + $914aec8743edd630$var$Tt(e[t].content) + `</code></pre>
`;
};
$914aec8743edd630$var$ct.fence = function(e, t, r, i, n) {
    const o = e[t], s = o.info ? $914aec8743edd630$var$er(o.info).trim() : "";
    let a = "", u = "";
    if (s) {
        const c = s.split(/(\s+)/g);
        a = c[0], u = c.slice(2).join("");
    }
    let l;
    if (r.highlight ? l = r.highlight(o.content, a, u) || $914aec8743edd630$var$Tt(o.content) : l = $914aec8743edd630$var$Tt(o.content), l.indexOf("<pre") === 0) return l + `
`;
    if (s) {
        const c = o.attrIndex("class"), d = o.attrs ? o.attrs.slice() : [];
        c < 0 ? d.push([
            "class",
            r.langPrefix + a
        ]) : (d[c] = d[c].slice(), d[c][1] += " " + r.langPrefix + a);
        const h = {
            attrs: d
        };
        return `<pre><code${n.renderAttrs(h)}>${l}</code></pre>
`;
    }
    return `<pre><code${n.renderAttrs(o)}>${l}</code></pre>
`;
};
$914aec8743edd630$var$ct.image = function(e, t, r, i, n) {
    const o = e[t];
    return o.attrs[o.attrIndex("alt")][1] = n.renderInlineAsText(o.children, r, i), n.renderToken(e, t, r);
};
$914aec8743edd630$var$ct.hardbreak = function(e, t, r) {
    return r.xhtmlOut ? `<br />
` : `<br>
`;
};
$914aec8743edd630$var$ct.softbreak = function(e, t, r) {
    return r.breaks ? r.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
$914aec8743edd630$var$ct.text = function(e, t) {
    return $914aec8743edd630$var$Tt(e[t].content);
};
$914aec8743edd630$var$ct.html_block = function(e, t) {
    return e[t].content;
};
$914aec8743edd630$var$ct.html_inline = function(e, t) {
    return e[t].content;
};
function $914aec8743edd630$var$ur() {
    this.rules = $914aec8743edd630$var$ci({}, $914aec8743edd630$var$ct);
}
$914aec8743edd630$var$ur.prototype.renderAttrs = function(t) {
    let r, i, n;
    if (!t.attrs) return "";
    for(n = "", r = 0, i = t.attrs.length; r < i; r++)n += " " + $914aec8743edd630$var$Tt(t.attrs[r][0]) + '="' + $914aec8743edd630$var$Tt(t.attrs[r][1]) + '"';
    return n;
};
$914aec8743edd630$var$ur.prototype.renderToken = function(t, r, i) {
    const n = t[r];
    let o = "";
    if (n.hidden) return "";
    n.block && n.nesting !== -1 && r && t[r - 1].hidden && (o += `
`), o += (n.nesting === -1 ? "</" : "<") + n.tag, o += this.renderAttrs(n), n.nesting === 0 && i.xhtmlOut && (o += " /");
    let s = !1;
    if (n.block && (s = !0, n.nesting === 1 && r + 1 < t.length)) {
        const a = t[r + 1];
        (a.type === "inline" || a.hidden || a.nesting === -1 && a.tag === n.tag) && (s = !1);
    }
    return o += s ? `>
` : ">", o;
};
$914aec8743edd630$var$ur.prototype.renderInline = function(e, t, r) {
    let i = "";
    const n = this.rules;
    for(let o = 0, s = e.length; o < s; o++){
        const a = e[o].type;
        typeof n[a] < "u" ? i += n[a](e, o, t, r, this) : i += this.renderToken(e, o, t);
    }
    return i;
};
$914aec8743edd630$var$ur.prototype.renderInlineAsText = function(e, t, r) {
    let i = "";
    for(let n = 0, o = e.length; n < o; n++)switch(e[n].type){
        case "text":
            i += e[n].content;
            break;
        case "image":
            i += this.renderInlineAsText(e[n].children, t, r);
            break;
        case "html_inline":
        case "html_block":
            i += e[n].content;
            break;
        case "softbreak":
        case "hardbreak":
            i += `
`;
            break;
    }
    return i;
};
$914aec8743edd630$var$ur.prototype.render = function(e, t, r) {
    let i = "";
    const n = this.rules;
    for(let o = 0, s = e.length; o < s; o++){
        const a = e[o].type;
        a === "inline" ? i += this.renderInline(e[o].children, t, r) : typeof n[a] < "u" ? i += n[a](e, o, t, r, this) : i += this.renderToken(e, o, t, r);
    }
    return i;
};
function $914aec8743edd630$var$Ve() {
    this.__rules__ = [], this.__cache__ = null;
}
$914aec8743edd630$var$Ve.prototype.__find__ = function(e) {
    for(let t = 0; t < this.__rules__.length; t++)if (this.__rules__[t].name === e) return t;
    return -1;
};
$914aec8743edd630$var$Ve.prototype.__compile__ = function() {
    const e = this, t = [
        ""
    ];
    e.__rules__.forEach(function(r) {
        r.enabled && r.alt.forEach(function(i) {
            t.indexOf(i) < 0 && t.push(i);
        });
    }), e.__cache__ = {}, t.forEach(function(r) {
        e.__cache__[r] = [], e.__rules__.forEach(function(i) {
            i.enabled && (r && i.alt.indexOf(r) < 0 || e.__cache__[r].push(i.fn));
        });
    });
};
$914aec8743edd630$var$Ve.prototype.at = function(e, t, r) {
    const i = this.__find__(e), n = r || {};
    if (i === -1) throw new Error("Parser rule not found: " + e);
    this.__rules__[i].fn = t, this.__rules__[i].alt = n.alt || [], this.__cache__ = null;
};
$914aec8743edd630$var$Ve.prototype.before = function(e, t, r, i) {
    const n = this.__find__(e), o = i || {};
    if (n === -1) throw new Error("Parser rule not found: " + e);
    this.__rules__.splice(n, 0, {
        name: t,
        enabled: !0,
        fn: r,
        alt: o.alt || []
    }), this.__cache__ = null;
};
$914aec8743edd630$var$Ve.prototype.after = function(e, t, r, i) {
    const n = this.__find__(e), o = i || {};
    if (n === -1) throw new Error("Parser rule not found: " + e);
    this.__rules__.splice(n + 1, 0, {
        name: t,
        enabled: !0,
        fn: r,
        alt: o.alt || []
    }), this.__cache__ = null;
};
$914aec8743edd630$var$Ve.prototype.push = function(e, t, r) {
    const i = r || {};
    this.__rules__.push({
        name: e,
        enabled: !0,
        fn: t,
        alt: i.alt || []
    }), this.__cache__ = null;
};
$914aec8743edd630$var$Ve.prototype.enable = function(e, t) {
    Array.isArray(e) || (e = [
        e
    ]);
    const r = [];
    return e.forEach(function(i) {
        const n = this.__find__(i);
        if (n < 0) {
            if (t) return;
            throw new Error("Rules manager: invalid rule name " + i);
        }
        this.__rules__[n].enabled = !0, r.push(i);
    }, this), this.__cache__ = null, r;
};
$914aec8743edd630$var$Ve.prototype.enableOnly = function(e, t) {
    Array.isArray(e) || (e = [
        e
    ]), this.__rules__.forEach(function(r) {
        r.enabled = !1;
    }), this.enable(e, t);
};
$914aec8743edd630$var$Ve.prototype.disable = function(e, t) {
    Array.isArray(e) || (e = [
        e
    ]);
    const r = [];
    return e.forEach(function(i) {
        const n = this.__find__(i);
        if (n < 0) {
            if (t) return;
            throw new Error("Rules manager: invalid rule name " + i);
        }
        this.__rules__[n].enabled = !1, r.push(i);
    }, this), this.__cache__ = null, r;
};
$914aec8743edd630$var$Ve.prototype.getRules = function(e) {
    return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
function $914aec8743edd630$var$et(e, t, r) {
    this.type = e, this.tag = t, this.attrs = null, this.map = null, this.nesting = r, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
$914aec8743edd630$var$et.prototype.attrIndex = function(t) {
    if (!this.attrs) return -1;
    const r = this.attrs;
    for(let i = 0, n = r.length; i < n; i++)if (r[i][0] === t) return i;
    return -1;
};
$914aec8743edd630$var$et.prototype.attrPush = function(t) {
    this.attrs ? this.attrs.push(t) : this.attrs = [
        t
    ];
};
$914aec8743edd630$var$et.prototype.attrSet = function(t, r) {
    const i = this.attrIndex(t), n = [
        t,
        r
    ];
    i < 0 ? this.attrPush(n) : this.attrs[i] = n;
};
$914aec8743edd630$var$et.prototype.attrGet = function(t) {
    const r = this.attrIndex(t);
    let i = null;
    return r >= 0 && (i = this.attrs[r][1]), i;
};
$914aec8743edd630$var$et.prototype.attrJoin = function(t, r) {
    const i = this.attrIndex(t);
    i < 0 ? this.attrPush([
        t,
        r
    ]) : this.attrs[i][1] = this.attrs[i][1] + " " + r;
};
function $914aec8743edd630$var$fb(e, t, r) {
    this.src = e, this.env = r, this.tokens = [], this.inlineMode = !1, this.md = t;
}
$914aec8743edd630$var$fb.prototype.Token = $914aec8743edd630$var$et;
const $914aec8743edd630$var$TM = /\r\n?|\n/g, $914aec8743edd630$var$CM = /\0/g;
function $914aec8743edd630$var$RM(e) {
    let t;
    t = e.src.replace($914aec8743edd630$var$TM, `
`), t = t.replace($914aec8743edd630$var$CM, "\uFFFD"), e.src = t;
}
function $914aec8743edd630$var$OM(e) {
    let t;
    e.inlineMode ? (t = new e.Token("inline", "", 0), t.content = e.src, t.map = [
        0,
        1
    ], t.children = [], e.tokens.push(t)) : e.md.block.parse(e.src, e.md, e.env, e.tokens);
}
function $914aec8743edd630$var$DM(e) {
    const t = e.tokens;
    for(let r = 0, i = t.length; r < i; r++){
        const n = t[r];
        n.type === "inline" && e.md.inline.parse(n.content, e.md, e.env, n.children);
    }
}
function $914aec8743edd630$var$PM(e) {
    return /^<a[>\s]/i.test(e);
}
function $914aec8743edd630$var$IM(e) {
    return /^<\/a\s*>/i.test(e);
}
function $914aec8743edd630$var$MM(e) {
    const t = e.tokens;
    if (e.md.options.linkify) for(let r = 0, i = t.length; r < i; r++){
        if (t[r].type !== "inline" || !e.md.linkify.pretest(t[r].content)) continue;
        let n = t[r].children, o = 0;
        for(let s = n.length - 1; s >= 0; s--){
            const a = n[s];
            if (a.type === "link_close") {
                for(s--; n[s].level !== a.level && n[s].type !== "link_open";)s--;
                continue;
            }
            if (a.type === "html_inline" && ($914aec8743edd630$var$PM(a.content) && o > 0 && o--, $914aec8743edd630$var$IM(a.content) && o++), !(o > 0) && a.type === "text" && e.md.linkify.test(a.content)) {
                const u = a.content;
                let l = e.md.linkify.match(u);
                const c = [];
                let d = a.level, h = 0;
                l.length > 0 && l[0].index === 0 && s > 0 && n[s - 1].type === "text_special" && (l = l.slice(1));
                for(let f = 0; f < l.length; f++){
                    const p = l[f].url, m = e.md.normalizeLink(p);
                    if (!e.md.validateLink(m)) continue;
                    let w = l[f].text;
                    l[f].schema ? l[f].schema === "mailto:" && !/^mailto:/i.test(w) ? w = e.md.normalizeLinkText("mailto:" + w).replace(/^mailto:/, "") : w = e.md.normalizeLinkText(w) : w = e.md.normalizeLinkText("http://" + w).replace(/^http:\/\//, "");
                    const v = l[f].index;
                    if (v > h) {
                        const k = new e.Token("text", "", 0);
                        k.content = u.slice(h, v), k.level = d, c.push(k);
                    }
                    const g = new e.Token("link_open", "a", 1);
                    g.attrs = [
                        [
                            "href",
                            m
                        ]
                    ], g.level = d++, g.markup = "linkify", g.info = "auto", c.push(g);
                    const A = new e.Token("text", "", 0);
                    A.content = w, A.level = d, c.push(A);
                    const b = new e.Token("link_close", "a", -1);
                    b.level = --d, b.markup = "linkify", b.info = "auto", c.push(b), h = l[f].lastIndex;
                }
                if (h < u.length) {
                    const f = new e.Token("text", "", 0);
                    f.content = u.slice(h), f.level = d, c.push(f);
                }
                t[r].children = n = $914aec8743edd630$var$lb(n, s, c);
            }
        }
    }
}
const $914aec8743edd630$var$hb = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, $914aec8743edd630$var$jM = /\((c|tm|r)\)/i, $914aec8743edd630$var$FM = /\((c|tm|r)\)/ig, $914aec8743edd630$var$$M = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $914aec8743edd630$var$LM(e, t) {
    return $914aec8743edd630$var$$M[t.toLowerCase()];
}
function $914aec8743edd630$var$NM(e) {
    let t = 0;
    for(let r = e.length - 1; r >= 0; r--){
        const i = e[r];
        i.type === "text" && !t && (i.content = i.content.replace($914aec8743edd630$var$FM, $914aec8743edd630$var$LM)), i.type === "link_open" && i.info === "auto" && t--, i.type === "link_close" && i.info === "auto" && t++;
    }
}
function $914aec8743edd630$var$BM(e) {
    let t = 0;
    for(let r = e.length - 1; r >= 0; r--){
        const i = e[r];
        i.type === "text" && !t && $914aec8743edd630$var$hb.test(i.content) && (i.content = i.content.replace(/\+-/g, "\xb1").replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014").replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013")), i.type === "link_open" && i.info === "auto" && t--, i.type === "link_close" && i.info === "auto" && t++;
    }
}
function $914aec8743edd630$var$qM(e) {
    let t;
    if (e.md.options.typographer) for(t = e.tokens.length - 1; t >= 0; t--)e.tokens[t].type === "inline" && ($914aec8743edd630$var$jM.test(e.tokens[t].content) && $914aec8743edd630$var$NM(e.tokens[t].children), $914aec8743edd630$var$hb.test(e.tokens[t].content) && $914aec8743edd630$var$BM(e.tokens[t].children));
}
const $914aec8743edd630$var$zM = /['"]/, $914aec8743edd630$var$O0 = /['"]/g, $914aec8743edd630$var$D0 = "\u2019";
function $914aec8743edd630$var$Tn(e, t, r) {
    return e.slice(0, t) + r + e.slice(t + 1);
}
function $914aec8743edd630$var$UM(e, t) {
    let r;
    const i = [];
    for(let n = 0; n < e.length; n++){
        const o = e[n], s = e[n].level;
        for(r = i.length - 1; r >= 0 && !(i[r].level <= s); r--);
        if (i.length = r + 1, o.type !== "text") continue;
        let a = o.content, u = 0, l = a.length;
        e: for(; u < l;){
            $914aec8743edd630$var$O0.lastIndex = u;
            const c = $914aec8743edd630$var$O0.exec(a);
            if (!c) break;
            let d = !0, h = !0;
            u = c.index + 1;
            const f = c[0] === "'";
            let p = 32;
            if (c.index - 1 >= 0) p = a.charCodeAt(c.index - 1);
            else for(r = n - 1; r >= 0 && !(e[r].type === "softbreak" || e[r].type === "hardbreak"); r--)if (e[r].content) {
                p = e[r].content.charCodeAt(e[r].content.length - 1);
                break;
            }
            let m = 32;
            if (u < l) m = a.charCodeAt(u);
            else for(r = n + 1; r < e.length && !(e[r].type === "softbreak" || e[r].type === "hardbreak"); r++)if (e[r].content) {
                m = e[r].content.charCodeAt(0);
                break;
            }
            const w = $914aec8743edd630$var$en(p) || $914aec8743edd630$var$Xr(String.fromCharCode(p)), v = $914aec8743edd630$var$en(m) || $914aec8743edd630$var$Xr(String.fromCharCode(m)), g = $914aec8743edd630$var$Zr(p), A = $914aec8743edd630$var$Zr(m);
            if (A ? d = !1 : v && (g || w || (d = !1)), g ? h = !1 : w && (A || v || (h = !1)), m === 34 && c[0] === '"' && p >= 48 && p <= 57 && (h = d = !1), d && h && (d = w, h = v), !d && !h) {
                f && (o.content = $914aec8743edd630$var$Tn(o.content, c.index, $914aec8743edd630$var$D0));
                continue;
            }
            if (h) for(r = i.length - 1; r >= 0; r--){
                let b = i[r];
                if (i[r].level < s) break;
                if (b.single === f && i[r].level === s) {
                    b = i[r];
                    let k, y;
                    f ? (k = t.md.options.quotes[2], y = t.md.options.quotes[3]) : (k = t.md.options.quotes[0], y = t.md.options.quotes[1]), o.content = $914aec8743edd630$var$Tn(o.content, c.index, y), e[b.token].content = $914aec8743edd630$var$Tn(e[b.token].content, b.pos, k), u += y.length - 1, b.token === n && (u += k.length - 1), a = o.content, l = a.length, i.length = r;
                    continue e;
                }
            }
            d ? i.push({
                token: n,
                pos: c.index,
                single: f,
                level: s
            }) : h && f && (o.content = $914aec8743edd630$var$Tn(o.content, c.index, $914aec8743edd630$var$D0));
        }
    }
}
function $914aec8743edd630$var$VM(e) {
    if (e.md.options.typographer) for(let t = e.tokens.length - 1; t >= 0; t--)e.tokens[t].type !== "inline" || !$914aec8743edd630$var$zM.test(e.tokens[t].content) || $914aec8743edd630$var$UM(e.tokens[t].children, e);
}
function $914aec8743edd630$var$GM(e) {
    let t, r;
    const i = e.tokens, n = i.length;
    for(let o = 0; o < n; o++){
        if (i[o].type !== "inline") continue;
        const s = i[o].children, a = s.length;
        for(t = 0; t < a; t++)s[t].type === "text_special" && (s[t].type = "text");
        for(t = r = 0; t < a; t++)s[t].type === "text" && t + 1 < a && s[t + 1].type === "text" ? s[t + 1].content = s[t].content + s[t + 1].content : (t !== r && (s[r] = s[t]), r++);
        t !== r && (s.length = r);
    }
}
const $914aec8743edd630$var$qs = [
    [
        "normalize",
        $914aec8743edd630$var$RM
    ],
    [
        "block",
        $914aec8743edd630$var$OM
    ],
    [
        "inline",
        $914aec8743edd630$var$DM
    ],
    [
        "linkify",
        $914aec8743edd630$var$MM
    ],
    [
        "replacements",
        $914aec8743edd630$var$qM
    ],
    [
        "smartquotes",
        $914aec8743edd630$var$VM
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        "text_join",
        $914aec8743edd630$var$GM
    ]
];
function $914aec8743edd630$var$Ec() {
    this.ruler = new $914aec8743edd630$var$Ve();
    for(let e = 0; e < $914aec8743edd630$var$qs.length; e++)this.ruler.push($914aec8743edd630$var$qs[e][0], $914aec8743edd630$var$qs[e][1]);
}
$914aec8743edd630$var$Ec.prototype.process = function(e) {
    const t = this.ruler.getRules("");
    for(let r = 0, i = t.length; r < i; r++)t[r](e);
};
$914aec8743edd630$var$Ec.prototype.State = $914aec8743edd630$var$fb;
function $914aec8743edd630$var$lt(e, t, r, i) {
    this.src = e, this.md = t, this.env = r, this.tokens = i, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
    const n = this.src;
    for(let o = 0, s = 0, a = 0, u = 0, l = n.length, c = !1; s < l; s++){
        const d = n.charCodeAt(s);
        if (!c) {
            if ($914aec8743edd630$var$Oe(d)) {
                a++, d === 9 ? u += 4 - u % 4 : u++;
                continue;
            } else c = !0;
        }
        (d === 10 || s === l - 1) && (d !== 10 && s++, this.bMarks.push(o), this.eMarks.push(s), this.tShift.push(a), this.sCount.push(u), this.bsCount.push(0), c = !1, a = 0, u = 0, o = s + 1);
    }
    this.bMarks.push(n.length), this.eMarks.push(n.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
$914aec8743edd630$var$lt.prototype.push = function(e, t, r) {
    const i = new $914aec8743edd630$var$et(e, t, r);
    return i.block = !0, r < 0 && this.level--, i.level = this.level, r > 0 && this.level++, this.tokens.push(i), i;
};
$914aec8743edd630$var$lt.prototype.isEmpty = function(t) {
    return this.bMarks[t] + this.tShift[t] >= this.eMarks[t];
};
$914aec8743edd630$var$lt.prototype.skipEmptyLines = function(t) {
    for(let r = this.lineMax; t < r && !(this.bMarks[t] + this.tShift[t] < this.eMarks[t]); t++);
    return t;
};
$914aec8743edd630$var$lt.prototype.skipSpaces = function(t) {
    for(let r = this.src.length; t < r; t++){
        const i = this.src.charCodeAt(t);
        if (!$914aec8743edd630$var$Oe(i)) break;
    }
    return t;
};
$914aec8743edd630$var$lt.prototype.skipSpacesBack = function(t, r) {
    if (t <= r) return t;
    for(; t > r;)if (!$914aec8743edd630$var$Oe(this.src.charCodeAt(--t))) return t + 1;
    return t;
};
$914aec8743edd630$var$lt.prototype.skipChars = function(t, r) {
    for(let i = this.src.length; t < i && this.src.charCodeAt(t) === r; t++);
    return t;
};
$914aec8743edd630$var$lt.prototype.skipCharsBack = function(t, r, i) {
    if (t <= i) return t;
    for(; t > i;)if (r !== this.src.charCodeAt(--t)) return t + 1;
    return t;
};
$914aec8743edd630$var$lt.prototype.getLines = function(t, r, i, n) {
    if (t >= r) return "";
    const o = new Array(r - t);
    for(let s = 0, a = t; a < r; a++, s++){
        let u = 0;
        const l = this.bMarks[a];
        let c = l, d;
        for(a + 1 < r || n ? d = this.eMarks[a] + 1 : d = this.eMarks[a]; c < d && u < i;){
            const h = this.src.charCodeAt(c);
            if ($914aec8743edd630$var$Oe(h)) h === 9 ? u += 4 - (u + this.bsCount[a]) % 4 : u++;
            else if (c - l < this.tShift[a]) u++;
            else break;
            c++;
        }
        u > i ? o[s] = new Array(u - i + 1).join(" ") + this.src.slice(c, d) : o[s] = this.src.slice(c, d);
    }
    return o.join("");
};
$914aec8743edd630$var$lt.prototype.Token = $914aec8743edd630$var$et;
const $914aec8743edd630$var$WM = 65536;
function $914aec8743edd630$var$zs(e, t) {
    const r = e.bMarks[t] + e.tShift[t], i = e.eMarks[t];
    return e.src.slice(r, i);
}
function $914aec8743edd630$var$P0(e) {
    const t = [], r = e.length;
    let i = 0, n = e.charCodeAt(i), o = !1, s = 0, a = "";
    for(; i < r;)n === 124 && (o ? (a += e.substring(s, i - 1), s = i) : (t.push(a + e.substring(s, i)), a = "", s = i + 1)), o = n === 92, i++, n = e.charCodeAt(i);
    return t.push(a + e.substring(s)), t;
}
function $914aec8743edd630$var$HM(e, t, r, i) {
    if (t + 2 > r) return !1;
    let n = t + 1;
    if (e.sCount[n] < e.blkIndent || e.sCount[n] - e.blkIndent >= 4) return !1;
    let o = e.bMarks[n] + e.tShift[n];
    if (o >= e.eMarks[n]) return !1;
    const s = e.src.charCodeAt(o++);
    if (s !== 124 && s !== 45 && s !== 58 || o >= e.eMarks[n]) return !1;
    const a = e.src.charCodeAt(o++);
    if (a !== 124 && a !== 45 && a !== 58 && !$914aec8743edd630$var$Oe(a) || s === 45 && $914aec8743edd630$var$Oe(a)) return !1;
    for(; o < e.eMarks[n];){
        const b = e.src.charCodeAt(o);
        if (b !== 124 && b !== 45 && b !== 58 && !$914aec8743edd630$var$Oe(b)) return !1;
        o++;
    }
    let u = $914aec8743edd630$var$zs(e, t + 1), l = u.split("|");
    const c = [];
    for(let b = 0; b < l.length; b++){
        const k = l[b].trim();
        if (!k) {
            if (b === 0 || b === l.length - 1) continue;
            return !1;
        }
        if (!/^:?-+:?$/.test(k)) return !1;
        k.charCodeAt(k.length - 1) === 58 ? c.push(k.charCodeAt(0) === 58 ? "center" : "right") : k.charCodeAt(0) === 58 ? c.push("left") : c.push("");
    }
    if (u = $914aec8743edd630$var$zs(e, t).trim(), u.indexOf("|") === -1 || e.sCount[t] - e.blkIndent >= 4) return !1;
    l = $914aec8743edd630$var$P0(u), l.length && l[0] === "" && l.shift(), l.length && l[l.length - 1] === "" && l.pop();
    const d = l.length;
    if (d === 0 || d !== c.length) return !1;
    if (i) return !0;
    const h = e.parentType;
    e.parentType = "table";
    const f = e.md.block.ruler.getRules("blockquote"), p = e.push("table_open", "table", 1), m = [
        t,
        0
    ];
    p.map = m;
    const w = e.push("thead_open", "thead", 1);
    w.map = [
        t,
        t + 1
    ];
    const v = e.push("tr_open", "tr", 1);
    v.map = [
        t,
        t + 1
    ];
    for(let b = 0; b < l.length; b++){
        const k = e.push("th_open", "th", 1);
        c[b] && (k.attrs = [
            [
                "style",
                "text-align:" + c[b]
            ]
        ]);
        const y = e.push("inline", "", 0);
        y.content = l[b].trim(), y.children = [], e.push("th_close", "th", -1);
    }
    e.push("tr_close", "tr", -1), e.push("thead_close", "thead", -1);
    let g, A = 0;
    for(n = t + 2; n < r && !(e.sCount[n] < e.blkIndent); n++){
        let b = !1;
        for(let y = 0, x = f.length; y < x; y++)if (f[y](e, n, r, !0)) {
            b = !0;
            break;
        }
        if (b || (u = $914aec8743edd630$var$zs(e, n).trim(), !u) || e.sCount[n] - e.blkIndent >= 4 || (l = $914aec8743edd630$var$P0(u), l.length && l[0] === "" && l.shift(), l.length && l[l.length - 1] === "" && l.pop(), A += d - l.length, A > $914aec8743edd630$var$WM)) break;
        if (n === t + 2) {
            const y = e.push("tbody_open", "tbody", 1);
            y.map = g = [
                t + 2,
                0
            ];
        }
        const k = e.push("tr_open", "tr", 1);
        k.map = [
            n,
            n + 1
        ];
        for(let y = 0; y < d; y++){
            const x = e.push("td_open", "td", 1);
            c[y] && (x.attrs = [
                [
                    "style",
                    "text-align:" + c[y]
                ]
            ]);
            const C = e.push("inline", "", 0);
            C.content = l[y] ? l[y].trim() : "", C.children = [], e.push("td_close", "td", -1);
        }
        e.push("tr_close", "tr", -1);
    }
    return g && (e.push("tbody_close", "tbody", -1), g[1] = n), e.push("table_close", "table", -1), m[1] = n, e.parentType = h, e.line = n, !0;
}
function $914aec8743edd630$var$KM(e, t, r) {
    if (e.sCount[t] - e.blkIndent < 4) return !1;
    let i = t + 1, n = i;
    for(; i < r;){
        if (e.isEmpty(i)) {
            i++;
            continue;
        }
        if (e.sCount[i] - e.blkIndent >= 4) {
            i++, n = i;
            continue;
        }
        break;
    }
    e.line = n;
    const o = e.push("code_block", "code", 0);
    return o.content = e.getLines(t, n, 4 + e.blkIndent, !1) + `
`, o.map = [
        t,
        e.line
    ], !0;
}
function $914aec8743edd630$var$QM(e, t, r, i) {
    let n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4 || n + 3 > o) return !1;
    const s = e.src.charCodeAt(n);
    if (s !== 126 && s !== 96) return !1;
    let a = n;
    n = e.skipChars(n, s);
    let u = n - a;
    if (u < 3) return !1;
    const l = e.src.slice(a, n), c = e.src.slice(n, o);
    if (s === 96 && c.indexOf(String.fromCharCode(s)) >= 0) return !1;
    if (i) return !0;
    let d = t, h = !1;
    for(; d++, !(d >= r || (n = a = e.bMarks[d] + e.tShift[d], o = e.eMarks[d], n < o && e.sCount[d] < e.blkIndent));)if (e.src.charCodeAt(n) === s && !(e.sCount[d] - e.blkIndent >= 4) && (n = e.skipChars(n, s), !(n - a < u) && (n = e.skipSpaces(n), !(n < o)))) {
        h = !0;
        break;
    }
    u = e.sCount[t], e.line = d + (h ? 1 : 0);
    const f = e.push("fence", "code", 0);
    return f.info = c, f.content = e.getLines(t + 1, d, u, !0), f.markup = l, f.map = [
        t,
        e.line
    ], !0;
}
function $914aec8743edd630$var$YM(e, t, r, i) {
    let n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
    const s = e.lineMax;
    if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(n) !== 62) return !1;
    if (i) return !0;
    const a = [], u = [], l = [], c = [], d = e.md.block.ruler.getRules("blockquote"), h = e.parentType;
    e.parentType = "blockquote";
    let f = !1, p;
    for(p = t; p < r; p++){
        const A = e.sCount[p] < e.blkIndent;
        if (n = e.bMarks[p] + e.tShift[p], o = e.eMarks[p], n >= o) break;
        if (e.src.charCodeAt(n++) === 62 && !A) {
            let k = e.sCount[p] + 1, y, x;
            e.src.charCodeAt(n) === 32 ? (n++, k++, x = !1, y = !0) : e.src.charCodeAt(n) === 9 ? (y = !0, (e.bsCount[p] + k) % 4 === 3 ? (n++, k++, x = !1) : x = !0) : y = !1;
            let C = k;
            for(a.push(e.bMarks[p]), e.bMarks[p] = n; n < o;){
                const I = e.src.charCodeAt(n);
                if ($914aec8743edd630$var$Oe(I)) I === 9 ? C += 4 - (C + e.bsCount[p] + (x ? 1 : 0)) % 4 : C++;
                else break;
                n++;
            }
            f = n >= o, u.push(e.bsCount[p]), e.bsCount[p] = e.sCount[p] + 1 + (y ? 1 : 0), l.push(e.sCount[p]), e.sCount[p] = C - k, c.push(e.tShift[p]), e.tShift[p] = n - e.bMarks[p];
            continue;
        }
        if (f) break;
        let b = !1;
        for(let k = 0, y = d.length; k < y; k++)if (d[k](e, p, r, !0)) {
            b = !0;
            break;
        }
        if (b) {
            e.lineMax = p, e.blkIndent !== 0 && (a.push(e.bMarks[p]), u.push(e.bsCount[p]), c.push(e.tShift[p]), l.push(e.sCount[p]), e.sCount[p] -= e.blkIndent);
            break;
        }
        a.push(e.bMarks[p]), u.push(e.bsCount[p]), c.push(e.tShift[p]), l.push(e.sCount[p]), e.sCount[p] = -1;
    }
    const m = e.blkIndent;
    e.blkIndent = 0;
    const w = e.push("blockquote_open", "blockquote", 1);
    w.markup = ">";
    const v = [
        t,
        0
    ];
    w.map = v, e.md.block.tokenize(e, t, p);
    const g = e.push("blockquote_close", "blockquote", -1);
    g.markup = ">", e.lineMax = s, e.parentType = h, v[1] = e.line;
    for(let A = 0; A < c.length; A++)e.bMarks[A + t] = a[A], e.tShift[A + t] = c[A], e.sCount[A + t] = l[A], e.bsCount[A + t] = u[A];
    return e.blkIndent = m, !0;
}
function $914aec8743edd630$var$JM(e, t, r, i) {
    const n = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    let o = e.bMarks[t] + e.tShift[t];
    const s = e.src.charCodeAt(o++);
    if (s !== 42 && s !== 45 && s !== 95) return !1;
    let a = 1;
    for(; o < n;){
        const l = e.src.charCodeAt(o++);
        if (l !== s && !$914aec8743edd630$var$Oe(l)) return !1;
        l === s && a++;
    }
    if (a < 3) return !1;
    if (i) return !0;
    e.line = t + 1;
    const u = e.push("hr", "hr", 0);
    return u.map = [
        t,
        e.line
    ], u.markup = Array(a + 1).join(String.fromCharCode(s)), !0;
}
function $914aec8743edd630$var$I0(e, t) {
    const r = e.eMarks[t];
    let i = e.bMarks[t] + e.tShift[t];
    const n = e.src.charCodeAt(i++);
    if (n !== 42 && n !== 45 && n !== 43) return -1;
    if (i < r) {
        const o = e.src.charCodeAt(i);
        if (!$914aec8743edd630$var$Oe(o)) return -1;
    }
    return i;
}
function $914aec8743edd630$var$M0(e, t) {
    const r = e.bMarks[t] + e.tShift[t], i = e.eMarks[t];
    let n = r;
    if (n + 1 >= i) return -1;
    let o = e.src.charCodeAt(n++);
    if (o < 48 || o > 57) return -1;
    for(;;){
        if (n >= i) return -1;
        if (o = e.src.charCodeAt(n++), o >= 48 && o <= 57) {
            if (n - r >= 10) return -1;
            continue;
        }
        if (o === 41 || o === 46) break;
        return -1;
    }
    return n < i && (o = e.src.charCodeAt(n), !$914aec8743edd630$var$Oe(o)) ? -1 : n;
}
function $914aec8743edd630$var$ZM(e, t) {
    const r = e.level + 2;
    for(let i = t + 2, n = e.tokens.length - 2; i < n; i++)e.tokens[i].level === r && e.tokens[i].type === "paragraph_open" && (e.tokens[i + 2].hidden = !0, e.tokens[i].hidden = !0, i += 2);
}
function $914aec8743edd630$var$XM(e, t, r, i) {
    let n, o, s, a, u = t, l = !0;
    if (e.sCount[u] - e.blkIndent >= 4 || e.listIndent >= 0 && e.sCount[u] - e.listIndent >= 4 && e.sCount[u] < e.blkIndent) return !1;
    let c = !1;
    i && e.parentType === "paragraph" && e.sCount[u] >= e.blkIndent && (c = !0);
    let d, h, f;
    if ((f = $914aec8743edd630$var$M0(e, u)) >= 0) {
        if (d = !0, s = e.bMarks[u] + e.tShift[u], h = Number(e.src.slice(s, f - 1)), c && h !== 1) return !1;
    } else if ((f = $914aec8743edd630$var$I0(e, u)) >= 0) d = !1;
    else return !1;
    if (c && e.skipSpaces(f) >= e.eMarks[u]) return !1;
    if (i) return !0;
    const p = e.src.charCodeAt(f - 1), m = e.tokens.length;
    d ? (a = e.push("ordered_list_open", "ol", 1), h !== 1 && (a.attrs = [
        [
            "start",
            h
        ]
    ])) : a = e.push("bullet_list_open", "ul", 1);
    const w = [
        u,
        0
    ];
    a.map = w, a.markup = String.fromCharCode(p);
    let v = !1;
    const g = e.md.block.ruler.getRules("list"), A = e.parentType;
    for(e.parentType = "list"; u < r;){
        o = f, n = e.eMarks[u];
        const b = e.sCount[u] + f - (e.bMarks[u] + e.tShift[u]);
        let k = b;
        for(; o < n;){
            const P = e.src.charCodeAt(o);
            if (P === 9) k += 4 - (k + e.bsCount[u]) % 4;
            else if (P === 32) k++;
            else break;
            o++;
        }
        const y = o;
        let x;
        y >= n ? x = 1 : x = k - b, x > 4 && (x = 1);
        const C = b + x;
        a = e.push("list_item_open", "li", 1), a.markup = String.fromCharCode(p);
        const I = [
            u,
            0
        ];
        a.map = I, d && (a.info = e.src.slice(s, f - 1));
        const M = e.tight, Q = e.tShift[u], H = e.sCount[u], J = e.listIndent;
        if (e.listIndent = e.blkIndent, e.blkIndent = C, e.tight = !0, e.tShift[u] = y - e.bMarks[u], e.sCount[u] = k, y >= n && e.isEmpty(u + 1) ? e.line = Math.min(e.line + 2, r) : e.md.block.tokenize(e, u, r, !0), (!e.tight || v) && (l = !1), v = e.line - u > 1 && e.isEmpty(e.line - 1), e.blkIndent = e.listIndent, e.listIndent = J, e.tShift[u] = Q, e.sCount[u] = H, e.tight = M, a = e.push("list_item_close", "li", -1), a.markup = String.fromCharCode(p), u = e.line, I[1] = u, u >= r || e.sCount[u] < e.blkIndent || e.sCount[u] - e.blkIndent >= 4) break;
        let W = !1;
        for(let P = 0, R = g.length; P < R; P++)if (g[P](e, u, r, !0)) {
            W = !0;
            break;
        }
        if (W) break;
        if (d) {
            if (f = $914aec8743edd630$var$M0(e, u), f < 0) break;
            s = e.bMarks[u] + e.tShift[u];
        } else if (f = $914aec8743edd630$var$I0(e, u), f < 0) break;
        if (p !== e.src.charCodeAt(f - 1)) break;
    }
    return d ? a = e.push("ordered_list_close", "ol", -1) : a = e.push("bullet_list_close", "ul", -1), a.markup = String.fromCharCode(p), w[1] = u, e.line = u, e.parentType = A, l && $914aec8743edd630$var$ZM(e, m), !0;
}
function $914aec8743edd630$var$ej(e, t, r, i) {
    let n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t], s = t + 1;
    if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(n) !== 91) return !1;
    function a(g) {
        const A = e.lineMax;
        if (g >= A || e.isEmpty(g)) return null;
        let b = !1;
        if (e.sCount[g] - e.blkIndent > 3 && (b = !0), e.sCount[g] < 0 && (b = !0), !b) {
            const x = e.md.block.ruler.getRules("reference"), C = e.parentType;
            e.parentType = "reference";
            let I = !1;
            for(let M = 0, Q = x.length; M < Q; M++)if (x[M](e, g, A, !0)) {
                I = !0;
                break;
            }
            if (e.parentType = C, I) return null;
        }
        const k = e.bMarks[g] + e.tShift[g], y = e.eMarks[g];
        return e.src.slice(k, y + 1);
    }
    let u = e.src.slice(n, o + 1);
    o = u.length;
    let l = -1;
    for(n = 1; n < o; n++){
        const g = u.charCodeAt(n);
        if (g === 91) return !1;
        if (g === 93) {
            l = n;
            break;
        } else if (g === 10) {
            const A = a(s);
            A !== null && (u += A, o = u.length, s++);
        } else if (g === 92 && (n++, n < o && u.charCodeAt(n) === 10)) {
            const A = a(s);
            A !== null && (u += A, o = u.length, s++);
        }
    }
    if (l < 0 || u.charCodeAt(l + 1) !== 58) return !1;
    for(n = l + 2; n < o; n++){
        const g = u.charCodeAt(n);
        if (g === 10) {
            const A = a(s);
            A !== null && (u += A, o = u.length, s++);
        } else if (!$914aec8743edd630$var$Oe(g)) break;
    }
    const c = e.md.helpers.parseLinkDestination(u, n, o);
    if (!c.ok) return !1;
    const d = e.md.normalizeLink(c.str);
    if (!e.md.validateLink(d)) return !1;
    n = c.pos;
    const h = n, f = s, p = n;
    for(; n < o; n++){
        const g = u.charCodeAt(n);
        if (g === 10) {
            const A = a(s);
            A !== null && (u += A, o = u.length, s++);
        } else if (!$914aec8743edd630$var$Oe(g)) break;
    }
    let m = e.md.helpers.parseLinkTitle(u, n, o);
    for(; m.can_continue;){
        const g = a(s);
        if (g === null) break;
        u += g, n = o, o = u.length, s++, m = e.md.helpers.parseLinkTitle(u, n, o, m);
    }
    let w;
    for(n < o && p !== n && m.ok ? (w = m.str, n = m.pos) : (w = "", n = h, s = f); n < o;){
        const g = u.charCodeAt(n);
        if (!$914aec8743edd630$var$Oe(g)) break;
        n++;
    }
    if (n < o && u.charCodeAt(n) !== 10 && w) for(w = "", n = h, s = f; n < o;){
        const g = u.charCodeAt(n);
        if (!$914aec8743edd630$var$Oe(g)) break;
        n++;
    }
    if (n < o && u.charCodeAt(n) !== 10) return !1;
    const v = $914aec8743edd630$var$li(u.slice(1, l));
    return v ? (i || (typeof e.env.references > "u" && (e.env.references = {}), typeof e.env.references[v] > "u" && (e.env.references[v] = {
        title: w,
        href: d
    }), e.line = s), !0) : !1;
}
const $914aec8743edd630$var$tj = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
], $914aec8743edd630$var$rj = "[a-zA-Z_:][a-zA-Z0-9:._-]*", $914aec8743edd630$var$nj = "[^\"'=<>`\\x00-\\x20]+", $914aec8743edd630$var$ij = "'[^']*'", $914aec8743edd630$var$oj = '"[^"]*"', $914aec8743edd630$var$aj = "(?:" + $914aec8743edd630$var$nj + "|" + $914aec8743edd630$var$ij + "|" + $914aec8743edd630$var$oj + ")", $914aec8743edd630$var$sj = "(?:\\s+" + $914aec8743edd630$var$rj + "(?:\\s*=\\s*" + $914aec8743edd630$var$aj + ")?)", $914aec8743edd630$var$pb = "<[A-Za-z][A-Za-z0-9\\-]*" + $914aec8743edd630$var$sj + "*\\s*\\/?>", $914aec8743edd630$var$mb = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", $914aec8743edd630$var$uj = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", $914aec8743edd630$var$cj = "<[?][\\s\\S]*?[?]>", $914aec8743edd630$var$lj = "<![A-Za-z][^>]*>", $914aec8743edd630$var$dj = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", $914aec8743edd630$var$fj = new RegExp("^(?:" + $914aec8743edd630$var$pb + "|" + $914aec8743edd630$var$mb + "|" + $914aec8743edd630$var$uj + "|" + $914aec8743edd630$var$cj + "|" + $914aec8743edd630$var$lj + "|" + $914aec8743edd630$var$dj + ")"), $914aec8743edd630$var$hj = new RegExp("^(?:" + $914aec8743edd630$var$pb + "|" + $914aec8743edd630$var$mb + ")"), $914aec8743edd630$var$Ht = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        !0
    ],
    [
        /^<!--/,
        /-->/,
        !0
    ],
    [
        /^<\?/,
        /\?>/,
        !0
    ],
    [
        /^<![A-Z]/,
        />/,
        !0
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        !0
    ],
    [
        new RegExp("^</?(" + $914aec8743edd630$var$tj.join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        !0
    ],
    [
        new RegExp($914aec8743edd630$var$hj.source + "\\s*$"),
        /^$/,
        !1
    ]
];
function $914aec8743edd630$var$pj(e, t, r, i) {
    let n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4 || !e.md.options.html || e.src.charCodeAt(n) !== 60) return !1;
    let s = e.src.slice(n, o), a = 0;
    for(; a < $914aec8743edd630$var$Ht.length && !$914aec8743edd630$var$Ht[a][0].test(s); a++);
    if (a === $914aec8743edd630$var$Ht.length) return !1;
    if (i) return $914aec8743edd630$var$Ht[a][2];
    let u = t + 1;
    if (!$914aec8743edd630$var$Ht[a][1].test(s)) {
        for(; u < r && !(e.sCount[u] < e.blkIndent); u++)if (n = e.bMarks[u] + e.tShift[u], o = e.eMarks[u], s = e.src.slice(n, o), $914aec8743edd630$var$Ht[a][1].test(s)) {
            s.length !== 0 && u++;
            break;
        }
    }
    e.line = u;
    const l = e.push("html_block", "", 0);
    return l.map = [
        t,
        u
    ], l.content = e.getLines(t, u, e.blkIndent, !0), !0;
}
function $914aec8743edd630$var$mj(e, t, r, i) {
    let n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    let s = e.src.charCodeAt(n);
    if (s !== 35 || n >= o) return !1;
    let a = 1;
    for(s = e.src.charCodeAt(++n); s === 35 && n < o && a <= 6;)a++, s = e.src.charCodeAt(++n);
    if (a > 6 || n < o && !$914aec8743edd630$var$Oe(s)) return !1;
    if (i) return !0;
    o = e.skipSpacesBack(o, n);
    const u = e.skipCharsBack(o, 35, n);
    u > n && $914aec8743edd630$var$Oe(e.src.charCodeAt(u - 1)) && (o = u), e.line = t + 1;
    const l = e.push("heading_open", "h" + String(a), 1);
    l.markup = "########".slice(0, a), l.map = [
        t,
        e.line
    ];
    const c = e.push("inline", "", 0);
    c.content = e.src.slice(n, o).trim(), c.map = [
        t,
        e.line
    ], c.children = [];
    const d = e.push("heading_close", "h" + String(a), -1);
    return d.markup = "########".slice(0, a), !0;
}
function $914aec8743edd630$var$gj(e, t, r) {
    const i = e.md.block.ruler.getRules("paragraph");
    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    const n = e.parentType;
    e.parentType = "paragraph";
    let o = 0, s, a = t + 1;
    for(; a < r && !e.isEmpty(a); a++){
        if (e.sCount[a] - e.blkIndent > 3) continue;
        if (e.sCount[a] >= e.blkIndent) {
            let f = e.bMarks[a] + e.tShift[a];
            const p = e.eMarks[a];
            if (f < p && (s = e.src.charCodeAt(f), (s === 45 || s === 61) && (f = e.skipChars(f, s), f = e.skipSpaces(f), f >= p))) {
                o = s === 61 ? 1 : 2;
                break;
            }
        }
        if (e.sCount[a] < 0) continue;
        let h = !1;
        for(let f = 0, p = i.length; f < p; f++)if (i[f](e, a, r, !0)) {
            h = !0;
            break;
        }
        if (h) break;
    }
    if (!o) return !1;
    const u = e.getLines(t, a, e.blkIndent, !1).trim();
    e.line = a + 1;
    const l = e.push("heading_open", "h" + String(o), 1);
    l.markup = String.fromCharCode(s), l.map = [
        t,
        e.line
    ];
    const c = e.push("inline", "", 0);
    c.content = u, c.map = [
        t,
        e.line - 1
    ], c.children = [];
    const d = e.push("heading_close", "h" + String(o), -1);
    return d.markup = String.fromCharCode(s), e.parentType = n, !0;
}
function $914aec8743edd630$var$bj(e, t, r) {
    const i = e.md.block.ruler.getRules("paragraph"), n = e.parentType;
    let o = t + 1;
    for(e.parentType = "paragraph"; o < r && !e.isEmpty(o); o++){
        if (e.sCount[o] - e.blkIndent > 3 || e.sCount[o] < 0) continue;
        let l = !1;
        for(let c = 0, d = i.length; c < d; c++)if (i[c](e, o, r, !0)) {
            l = !0;
            break;
        }
        if (l) break;
    }
    const s = e.getLines(t, o, e.blkIndent, !1).trim();
    e.line = o;
    const a = e.push("paragraph_open", "p", 1);
    a.map = [
        t,
        e.line
    ];
    const u = e.push("inline", "", 0);
    return u.content = s, u.map = [
        t,
        e.line
    ], u.children = [], e.push("paragraph_close", "p", -1), e.parentType = n, !0;
}
const $914aec8743edd630$var$Cn = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        $914aec8743edd630$var$HM,
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        $914aec8743edd630$var$KM
    ],
    [
        "fence",
        $914aec8743edd630$var$QM,
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        $914aec8743edd630$var$YM,
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        $914aec8743edd630$var$JM,
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        $914aec8743edd630$var$XM,
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        $914aec8743edd630$var$ej
    ],
    [
        "html_block",
        $914aec8743edd630$var$pj,
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        $914aec8743edd630$var$mj,
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        $914aec8743edd630$var$gj
    ],
    [
        "paragraph",
        $914aec8743edd630$var$bj
    ]
];
function $914aec8743edd630$var$di() {
    this.ruler = new $914aec8743edd630$var$Ve();
    for(let e = 0; e < $914aec8743edd630$var$Cn.length; e++)this.ruler.push($914aec8743edd630$var$Cn[e][0], $914aec8743edd630$var$Cn[e][1], {
        alt: ($914aec8743edd630$var$Cn[e][2] || []).slice()
    });
}
$914aec8743edd630$var$di.prototype.tokenize = function(e, t, r) {
    const i = this.ruler.getRules(""), n = i.length, o = e.md.options.maxNesting;
    let s = t, a = !1;
    for(; s < r && (e.line = s = e.skipEmptyLines(s), !(s >= r || e.sCount[s] < e.blkIndent));){
        if (e.level >= o) {
            e.line = r;
            break;
        }
        const u = e.line;
        let l = !1;
        for(let c = 0; c < n; c++)if (l = i[c](e, s, r, !1), l) {
            if (u >= e.line) throw new Error("block rule didn't increment state.line");
            break;
        }
        if (!l) throw new Error("none of the block rules matched");
        e.tight = !a, e.isEmpty(e.line - 1) && (a = !0), s = e.line, s < r && e.isEmpty(s) && (a = !0, s++, e.line = s);
    }
};
$914aec8743edd630$var$di.prototype.parse = function(e, t, r, i) {
    if (!e) return;
    const n = new this.State(e, t, r, i);
    this.tokenize(n, n.line, n.lineMax);
};
$914aec8743edd630$var$di.prototype.State = $914aec8743edd630$var$lt;
function $914aec8743edd630$var$pn(e, t, r, i) {
    this.src = e, this.env = r, this.md = t, this.tokens = i, this.tokens_meta = Array(i.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
$914aec8743edd630$var$pn.prototype.pushPending = function() {
    const e = new $914aec8743edd630$var$et("text", "", 0);
    return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
};
$914aec8743edd630$var$pn.prototype.push = function(e, t, r) {
    this.pending && this.pushPending();
    const i = new $914aec8743edd630$var$et(e, t, r);
    let n = null;
    return r < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), i.level = this.level, r > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], n = {
        delimiters: this.delimiters
    }), this.pendingLevel = this.level, this.tokens.push(i), this.tokens_meta.push(n), i;
};
$914aec8743edd630$var$pn.prototype.scanDelims = function(e, t) {
    const r = this.posMax, i = this.src.charCodeAt(e), n = e > 0 ? this.src.charCodeAt(e - 1) : 32;
    let o = e;
    for(; o < r && this.src.charCodeAt(o) === i;)o++;
    const s = o - e, a = o < r ? this.src.charCodeAt(o) : 32, u = $914aec8743edd630$var$en(n) || $914aec8743edd630$var$Xr(String.fromCharCode(n)), l = $914aec8743edd630$var$en(a) || $914aec8743edd630$var$Xr(String.fromCharCode(a)), c = $914aec8743edd630$var$Zr(n), d = $914aec8743edd630$var$Zr(a), h = !d && (!l || c || u), f = !c && (!u || d || l);
    return {
        can_open: h && (t || !f || u),
        can_close: f && (t || !h || l),
        length: s
    };
};
$914aec8743edd630$var$pn.prototype.Token = $914aec8743edd630$var$et;
function $914aec8743edd630$var$vj(e) {
    switch(e){
        case 10:
        case 33:
        case 35:
        case 36:
        case 37:
        case 38:
        case 42:
        case 43:
        case 45:
        case 58:
        case 60:
        case 61:
        case 62:
        case 64:
        case 91:
        case 92:
        case 93:
        case 94:
        case 95:
        case 96:
        case 123:
        case 125:
        case 126:
            return !0;
        default:
            return !1;
    }
}
function $914aec8743edd630$var$yj(e, t) {
    let r = e.pos;
    for(; r < e.posMax && !$914aec8743edd630$var$vj(e.src.charCodeAt(r));)r++;
    return r === e.pos ? !1 : (t || (e.pending += e.src.slice(e.pos, r)), e.pos = r, !0);
}
const $914aec8743edd630$var$wj = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function $914aec8743edd630$var$_j(e, t) {
    if (!e.md.options.linkify || e.linkLevel > 0) return !1;
    const r = e.pos, i = e.posMax;
    if (r + 3 > i || e.src.charCodeAt(r) !== 58 || e.src.charCodeAt(r + 1) !== 47 || e.src.charCodeAt(r + 2) !== 47) return !1;
    const n = e.pending.match($914aec8743edd630$var$wj);
    if (!n) return !1;
    const o = n[1], s = e.md.linkify.matchAtStart(e.src.slice(r - o.length));
    if (!s) return !1;
    let a = s.url;
    if (a.length <= o.length) return !1;
    let u = a.length;
    for(; u > 0 && a.charCodeAt(u - 1) === 42;)u--;
    u !== a.length && (a = a.slice(0, u));
    const l = e.md.normalizeLink(a);
    if (!e.md.validateLink(l)) return !1;
    if (!t) {
        e.pending = e.pending.slice(0, -o.length);
        const c = e.push("link_open", "a", 1);
        c.attrs = [
            [
                "href",
                l
            ]
        ], c.markup = "linkify", c.info = "auto";
        const d = e.push("text", "", 0);
        d.content = e.md.normalizeLinkText(a);
        const h = e.push("link_close", "a", -1);
        h.markup = "linkify", h.info = "auto";
    }
    return e.pos += a.length - o.length, !0;
}
function $914aec8743edd630$var$kj(e, t) {
    let r = e.pos;
    if (e.src.charCodeAt(r) !== 10) return !1;
    const i = e.pending.length - 1, n = e.posMax;
    if (!t) {
        if (i >= 0 && e.pending.charCodeAt(i) === 32) {
            if (i >= 1 && e.pending.charCodeAt(i - 1) === 32) {
                let o = i - 1;
                for(; o >= 1 && e.pending.charCodeAt(o - 1) === 32;)o--;
                e.pending = e.pending.slice(0, o), e.push("hardbreak", "br", 0);
            } else e.pending = e.pending.slice(0, -1), e.push("softbreak", "br", 0);
        } else e.push("softbreak", "br", 0);
    }
    for(r++; r < n && $914aec8743edd630$var$Oe(e.src.charCodeAt(r));)r++;
    return e.pos = r, !0;
}
const $914aec8743edd630$var$Ac = [];
for(let e = 0; e < 256; e++)$914aec8743edd630$var$Ac.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
    $914aec8743edd630$var$Ac[e.charCodeAt(0)] = 1;
});
function $914aec8743edd630$var$xj(e, t) {
    let r = e.pos;
    const i = e.posMax;
    if (e.src.charCodeAt(r) !== 92 || (r++, r >= i)) return !1;
    let n = e.src.charCodeAt(r);
    if (n === 10) {
        for(t || e.push("hardbreak", "br", 0), r++; r < i && (n = e.src.charCodeAt(r), !!$914aec8743edd630$var$Oe(n));)r++;
        return e.pos = r, !0;
    }
    let o = e.src[r];
    if (n >= 55296 && n <= 56319 && r + 1 < i) {
        const a = e.src.charCodeAt(r + 1);
        a >= 56320 && a <= 57343 && (o += e.src[r + 1], r++);
    }
    const s = "\\" + o;
    if (!t) {
        const a = e.push("text_special", "", 0);
        n < 256 && $914aec8743edd630$var$Ac[n] !== 0 ? a.content = o : a.content = s, a.markup = s, a.info = "escape";
    }
    return e.pos = r + 1, !0;
}
function $914aec8743edd630$var$Sj(e, t) {
    let r = e.pos;
    if (e.src.charCodeAt(r) !== 96) return !1;
    const n = r;
    r++;
    const o = e.posMax;
    for(; r < o && e.src.charCodeAt(r) === 96;)r++;
    const s = e.src.slice(n, r), a = s.length;
    if (e.backticksScanned && (e.backticks[a] || 0) <= n) return t || (e.pending += s), e.pos += a, !0;
    let u = r, l;
    for(; (l = e.src.indexOf("`", u)) !== -1;){
        for(u = l + 1; u < o && e.src.charCodeAt(u) === 96;)u++;
        const c = u - l;
        if (c === a) {
            if (!t) {
                const d = e.push("code_inline", "code", 0);
                d.markup = s, d.content = e.src.slice(r, l).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
            }
            return e.pos = u, !0;
        }
        e.backticks[c] = l;
    }
    return e.backticksScanned = !0, t || (e.pending += s), e.pos += a, !0;
}
function $914aec8743edd630$var$Ej(e, t) {
    const r = e.pos, i = e.src.charCodeAt(r);
    if (t || i !== 126) return !1;
    const n = e.scanDelims(e.pos, !0);
    let o = n.length;
    const s = String.fromCharCode(i);
    if (o < 2) return !1;
    let a;
    o % 2 && (a = e.push("text", "", 0), a.content = s, o--);
    for(let u = 0; u < o; u += 2)a = e.push("text", "", 0), a.content = s + s, e.delimiters.push({
        marker: i,
        length: 0,
        // disable "rule of 3" length checks meant for emphasis
        token: e.tokens.length - 1,
        end: -1,
        open: n.can_open,
        close: n.can_close
    });
    return e.pos += n.length, !0;
}
function $914aec8743edd630$var$j0(e, t) {
    let r;
    const i = [], n = t.length;
    for(let o = 0; o < n; o++){
        const s = t[o];
        if (s.marker !== 126 || s.end === -1) continue;
        const a = t[s.end];
        r = e.tokens[s.token], r.type = "s_open", r.tag = "s", r.nesting = 1, r.markup = "~~", r.content = "", r = e.tokens[a.token], r.type = "s_close", r.tag = "s", r.nesting = -1, r.markup = "~~", r.content = "", e.tokens[a.token - 1].type === "text" && e.tokens[a.token - 1].content === "~" && i.push(a.token - 1);
    }
    for(; i.length;){
        const o = i.pop();
        let s = o + 1;
        for(; s < e.tokens.length && e.tokens[s].type === "s_close";)s++;
        s--, o !== s && (r = e.tokens[s], e.tokens[s] = e.tokens[o], e.tokens[o] = r);
    }
}
function $914aec8743edd630$var$Aj(e) {
    const t = e.tokens_meta, r = e.tokens_meta.length;
    $914aec8743edd630$var$j0(e, e.delimiters);
    for(let i = 0; i < r; i++)t[i] && t[i].delimiters && $914aec8743edd630$var$j0(e, t[i].delimiters);
}
const $914aec8743edd630$var$gb = {
    tokenize: $914aec8743edd630$var$Ej,
    postProcess: $914aec8743edd630$var$Aj
};
function $914aec8743edd630$var$Tj(e, t) {
    const r = e.pos, i = e.src.charCodeAt(r);
    if (t || i !== 95 && i !== 42) return !1;
    const n = e.scanDelims(e.pos, i === 42);
    for(let o = 0; o < n.length; o++){
        const s = e.push("text", "", 0);
        s.content = String.fromCharCode(i), e.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: i,
            // Total length of these series of delimiters.
            //
            length: n.length,
            // A position of the token this delimiter corresponds to.
            //
            token: e.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: n.can_open,
            close: n.can_close
        });
    }
    return e.pos += n.length, !0;
}
function $914aec8743edd630$var$F0(e, t) {
    const r = t.length;
    for(let i = r - 1; i >= 0; i--){
        const n = t[i];
        if (n.marker !== 95 && n.marker !== 42 || n.end === -1) continue;
        const o = t[n.end], s = i > 0 && t[i - 1].end === n.end + 1 && // check that first two markers match and adjacent
        t[i - 1].marker === n.marker && t[i - 1].token === n.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        t[n.end + 1].token === o.token + 1, a = String.fromCharCode(n.marker), u = e.tokens[n.token];
        u.type = s ? "strong_open" : "em_open", u.tag = s ? "strong" : "em", u.nesting = 1, u.markup = s ? a + a : a, u.content = "";
        const l = e.tokens[o.token];
        l.type = s ? "strong_close" : "em_close", l.tag = s ? "strong" : "em", l.nesting = -1, l.markup = s ? a + a : a, l.content = "", s && (e.tokens[t[i - 1].token].content = "", e.tokens[t[n.end + 1].token].content = "", i--);
    }
}
function $914aec8743edd630$var$Cj(e) {
    const t = e.tokens_meta, r = e.tokens_meta.length;
    $914aec8743edd630$var$F0(e, e.delimiters);
    for(let i = 0; i < r; i++)t[i] && t[i].delimiters && $914aec8743edd630$var$F0(e, t[i].delimiters);
}
const $914aec8743edd630$var$bb = {
    tokenize: $914aec8743edd630$var$Tj,
    postProcess: $914aec8743edd630$var$Cj
};
function $914aec8743edd630$var$Rj(e, t) {
    let r, i, n, o, s = "", a = "", u = e.pos, l = !0;
    if (e.src.charCodeAt(e.pos) !== 91) return !1;
    const c = e.pos, d = e.posMax, h = e.pos + 1, f = e.md.helpers.parseLinkLabel(e, e.pos, !0);
    if (f < 0) return !1;
    let p = f + 1;
    if (p < d && e.src.charCodeAt(p) === 40) {
        for(l = !1, p++; p < d && (r = e.src.charCodeAt(p), !(!$914aec8743edd630$var$Oe(r) && r !== 10)); p++);
        if (p >= d) return !1;
        if (u = p, n = e.md.helpers.parseLinkDestination(e.src, p, e.posMax), n.ok) {
            for(s = e.md.normalizeLink(n.str), e.md.validateLink(s) ? p = n.pos : s = "", u = p; p < d && (r = e.src.charCodeAt(p), !(!$914aec8743edd630$var$Oe(r) && r !== 10)); p++);
            if (n = e.md.helpers.parseLinkTitle(e.src, p, e.posMax), p < d && u !== p && n.ok) for(a = n.str, p = n.pos; p < d && (r = e.src.charCodeAt(p), !(!$914aec8743edd630$var$Oe(r) && r !== 10)); p++);
        }
        (p >= d || e.src.charCodeAt(p) !== 41) && (l = !0), p++;
    }
    if (l) {
        if (typeof e.env.references > "u") return !1;
        if (p < d && e.src.charCodeAt(p) === 91 ? (u = p + 1, p = e.md.helpers.parseLinkLabel(e, p), p >= 0 ? i = e.src.slice(u, p++) : p = f + 1) : p = f + 1, i || (i = e.src.slice(h, f)), o = e.env.references[$914aec8743edd630$var$li(i)], !o) return e.pos = c, !1;
        s = o.href, a = o.title;
    }
    if (!t) {
        e.pos = h, e.posMax = f;
        const m = e.push("link_open", "a", 1), w = [
            [
                "href",
                s
            ]
        ];
        m.attrs = w, a && w.push([
            "title",
            a
        ]), e.linkLevel++, e.md.inline.tokenize(e), e.linkLevel--, e.push("link_close", "a", -1);
    }
    return e.pos = p, e.posMax = d, !0;
}
function $914aec8743edd630$var$Oj(e, t) {
    let r, i, n, o, s, a, u, l, c = "";
    const d = e.pos, h = e.posMax;
    if (e.src.charCodeAt(e.pos) !== 33 || e.src.charCodeAt(e.pos + 1) !== 91) return !1;
    const f = e.pos + 2, p = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1);
    if (p < 0) return !1;
    if (o = p + 1, o < h && e.src.charCodeAt(o) === 40) {
        for(o++; o < h && (r = e.src.charCodeAt(o), !(!$914aec8743edd630$var$Oe(r) && r !== 10)); o++);
        if (o >= h) return !1;
        for(l = o, a = e.md.helpers.parseLinkDestination(e.src, o, e.posMax), a.ok && (c = e.md.normalizeLink(a.str), e.md.validateLink(c) ? o = a.pos : c = ""), l = o; o < h && (r = e.src.charCodeAt(o), !(!$914aec8743edd630$var$Oe(r) && r !== 10)); o++);
        if (a = e.md.helpers.parseLinkTitle(e.src, o, e.posMax), o < h && l !== o && a.ok) for(u = a.str, o = a.pos; o < h && (r = e.src.charCodeAt(o), !(!$914aec8743edd630$var$Oe(r) && r !== 10)); o++);
        else u = "";
        if (o >= h || e.src.charCodeAt(o) !== 41) return e.pos = d, !1;
        o++;
    } else {
        if (typeof e.env.references > "u") return !1;
        if (o < h && e.src.charCodeAt(o) === 91 ? (l = o + 1, o = e.md.helpers.parseLinkLabel(e, o), o >= 0 ? n = e.src.slice(l, o++) : o = p + 1) : o = p + 1, n || (n = e.src.slice(f, p)), s = e.env.references[$914aec8743edd630$var$li(n)], !s) return e.pos = d, !1;
        c = s.href, u = s.title;
    }
    if (!t) {
        i = e.src.slice(f, p);
        const m = [];
        e.md.inline.parse(i, e.md, e.env, m);
        const w = e.push("image", "img", 0), v = [
            [
                "src",
                c
            ],
            [
                "alt",
                ""
            ]
        ];
        w.attrs = v, w.children = m, w.content = i, u && v.push([
            "title",
            u
        ]);
    }
    return e.pos = o, e.posMax = h, !0;
}
const $914aec8743edd630$var$Dj = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, $914aec8743edd630$var$Pj = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $914aec8743edd630$var$Ij(e, t) {
    let r = e.pos;
    if (e.src.charCodeAt(r) !== 60) return !1;
    const i = e.pos, n = e.posMax;
    for(;;){
        if (++r >= n) return !1;
        const s = e.src.charCodeAt(r);
        if (s === 60) return !1;
        if (s === 62) break;
    }
    const o = e.src.slice(i + 1, r);
    if ($914aec8743edd630$var$Pj.test(o)) {
        const s = e.md.normalizeLink(o);
        if (!e.md.validateLink(s)) return !1;
        if (!t) {
            const a = e.push("link_open", "a", 1);
            a.attrs = [
                [
                    "href",
                    s
                ]
            ], a.markup = "autolink", a.info = "auto";
            const u = e.push("text", "", 0);
            u.content = e.md.normalizeLinkText(o);
            const l = e.push("link_close", "a", -1);
            l.markup = "autolink", l.info = "auto";
        }
        return e.pos += o.length + 2, !0;
    }
    if ($914aec8743edd630$var$Dj.test(o)) {
        const s = e.md.normalizeLink("mailto:" + o);
        if (!e.md.validateLink(s)) return !1;
        if (!t) {
            const a = e.push("link_open", "a", 1);
            a.attrs = [
                [
                    "href",
                    s
                ]
            ], a.markup = "autolink", a.info = "auto";
            const u = e.push("text", "", 0);
            u.content = e.md.normalizeLinkText(o);
            const l = e.push("link_close", "a", -1);
            l.markup = "autolink", l.info = "auto";
        }
        return e.pos += o.length + 2, !0;
    }
    return !1;
}
function $914aec8743edd630$var$Mj(e) {
    return /^<a[>\s]/i.test(e);
}
function $914aec8743edd630$var$jj(e) {
    return /^<\/a\s*>/i.test(e);
}
function $914aec8743edd630$var$Fj(e) {
    const t = e | 32;
    return t >= 97 && t <= 122;
}
function $914aec8743edd630$var$$j(e, t) {
    if (!e.md.options.html) return !1;
    const r = e.posMax, i = e.pos;
    if (e.src.charCodeAt(i) !== 60 || i + 2 >= r) return !1;
    const n = e.src.charCodeAt(i + 1);
    if (n !== 33 && n !== 63 && n !== 47 && !$914aec8743edd630$var$Fj(n)) return !1;
    const o = e.src.slice(i).match($914aec8743edd630$var$fj);
    if (!o) return !1;
    if (!t) {
        const s = e.push("html_inline", "", 0);
        s.content = o[0], $914aec8743edd630$var$Mj(s.content) && e.linkLevel++, $914aec8743edd630$var$jj(s.content) && e.linkLevel--;
    }
    return e.pos += o[0].length, !0;
}
const $914aec8743edd630$var$Lj = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, $914aec8743edd630$var$Nj = /^&([a-z][a-z0-9]{1,31});/i;
function $914aec8743edd630$var$Bj(e, t) {
    const r = e.pos, i = e.posMax;
    if (e.src.charCodeAt(r) !== 38 || r + 1 >= i) return !1;
    if (e.src.charCodeAt(r + 1) === 35) {
        const o = e.src.slice(r).match($914aec8743edd630$var$Lj);
        if (o) {
            if (!t) {
                const s = o[1][0].toLowerCase() === "x" ? parseInt(o[1].slice(1), 16) : parseInt(o[1], 10), a = e.push("text_special", "", 0);
                a.content = $914aec8743edd630$var$Sc(s) ? $914aec8743edd630$var$zn(s) : $914aec8743edd630$var$zn(65533), a.markup = o[0], a.info = "entity";
            }
            return e.pos += o[0].length, !0;
        }
    } else {
        const o = e.src.slice(r).match($914aec8743edd630$var$Nj);
        if (o) {
            const s = $914aec8743edd630$var$cb(o[0]);
            if (s !== o[0]) {
                if (!t) {
                    const a = e.push("text_special", "", 0);
                    a.content = s, a.markup = o[0], a.info = "entity";
                }
                return e.pos += o[0].length, !0;
            }
        }
    }
    return !1;
}
function $914aec8743edd630$var$$0(e) {
    const t = {}, r = e.length;
    if (!r) return;
    let i = 0, n = -2;
    const o = [];
    for(let s = 0; s < r; s++){
        const a = e[s];
        if (o.push(0), (e[i].marker !== a.marker || n !== a.token - 1) && (i = s), n = a.token, a.length = a.length || 0, !a.close) continue;
        t.hasOwnProperty(a.marker) || (t[a.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]);
        const u = t[a.marker][(a.open ? 3 : 0) + a.length % 3];
        let l = i - o[i] - 1, c = l;
        for(; l > u; l -= o[l] + 1){
            const d = e[l];
            if (d.marker === a.marker && d.open && d.end < 0) {
                let h = !1;
                if ((d.close || a.open) && (d.length + a.length) % 3 === 0 && (d.length % 3 !== 0 || a.length % 3 !== 0) && (h = !0), !h) {
                    const f = l > 0 && !e[l - 1].open ? o[l - 1] + 1 : 0;
                    o[s] = s - l + f, o[l] = f, a.open = !1, d.end = s, d.close = !1, c = -1, n = -2;
                    break;
                }
            }
        }
        c !== -1 && (t[a.marker][(a.open ? 3 : 0) + (a.length || 0) % 3] = c);
    }
}
function $914aec8743edd630$var$qj(e) {
    const t = e.tokens_meta, r = e.tokens_meta.length;
    $914aec8743edd630$var$$0(e.delimiters);
    for(let i = 0; i < r; i++)t[i] && t[i].delimiters && $914aec8743edd630$var$$0(t[i].delimiters);
}
function $914aec8743edd630$var$zj(e) {
    let t, r, i = 0;
    const n = e.tokens, o = e.tokens.length;
    for(t = r = 0; t < o; t++)n[t].nesting < 0 && i--, n[t].level = i, n[t].nesting > 0 && i++, n[t].type === "text" && t + 1 < o && n[t + 1].type === "text" ? n[t + 1].content = n[t].content + n[t + 1].content : (t !== r && (n[r] = n[t]), r++);
    t !== r && (n.length = r);
}
const $914aec8743edd630$var$Us = [
    [
        "text",
        $914aec8743edd630$var$yj
    ],
    [
        "linkify",
        $914aec8743edd630$var$_j
    ],
    [
        "newline",
        $914aec8743edd630$var$kj
    ],
    [
        "escape",
        $914aec8743edd630$var$xj
    ],
    [
        "backticks",
        $914aec8743edd630$var$Sj
    ],
    [
        "strikethrough",
        $914aec8743edd630$var$gb.tokenize
    ],
    [
        "emphasis",
        $914aec8743edd630$var$bb.tokenize
    ],
    [
        "link",
        $914aec8743edd630$var$Rj
    ],
    [
        "image",
        $914aec8743edd630$var$Oj
    ],
    [
        "autolink",
        $914aec8743edd630$var$Ij
    ],
    [
        "html_inline",
        $914aec8743edd630$var$$j
    ],
    [
        "entity",
        $914aec8743edd630$var$Bj
    ]
], $914aec8743edd630$var$Vs = [
    [
        "balance_pairs",
        $914aec8743edd630$var$qj
    ],
    [
        "strikethrough",
        $914aec8743edd630$var$gb.postProcess
    ],
    [
        "emphasis",
        $914aec8743edd630$var$bb.postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        "fragments_join",
        $914aec8743edd630$var$zj
    ]
];
function $914aec8743edd630$var$mn() {
    this.ruler = new $914aec8743edd630$var$Ve();
    for(let e = 0; e < $914aec8743edd630$var$Us.length; e++)this.ruler.push($914aec8743edd630$var$Us[e][0], $914aec8743edd630$var$Us[e][1]);
    this.ruler2 = new $914aec8743edd630$var$Ve();
    for(let e = 0; e < $914aec8743edd630$var$Vs.length; e++)this.ruler2.push($914aec8743edd630$var$Vs[e][0], $914aec8743edd630$var$Vs[e][1]);
}
$914aec8743edd630$var$mn.prototype.skipToken = function(e) {
    const t = e.pos, r = this.ruler.getRules(""), i = r.length, n = e.md.options.maxNesting, o = e.cache;
    if (typeof o[t] < "u") {
        e.pos = o[t];
        return;
    }
    let s = !1;
    if (e.level < n) {
        for(let a = 0; a < i; a++)if (e.level++, s = r[a](e, !0), e.level--, s) {
            if (t >= e.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    } else e.pos = e.posMax;
    s || e.pos++, o[t] = e.pos;
};
$914aec8743edd630$var$mn.prototype.tokenize = function(e) {
    const t = this.ruler.getRules(""), r = t.length, i = e.posMax, n = e.md.options.maxNesting;
    for(; e.pos < i;){
        const o = e.pos;
        let s = !1;
        if (e.level < n) {
            for(let a = 0; a < r; a++)if (s = t[a](e, !1), s) {
                if (o >= e.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (s) {
            if (e.pos >= i) break;
            continue;
        }
        e.pending += e.src[e.pos++];
    }
    e.pending && e.pushPending();
};
$914aec8743edd630$var$mn.prototype.parse = function(e, t, r, i) {
    const n = new this.State(e, t, r, i);
    this.tokenize(n);
    const o = this.ruler2.getRules(""), s = o.length;
    for(let a = 0; a < s; a++)o[a](n);
};
$914aec8743edd630$var$mn.prototype.State = $914aec8743edd630$var$pn;
function $914aec8743edd630$var$Uj(e) {
    const t = {};
    e = e || {}, t.src_Any = $914aec8743edd630$var$ib.source, t.src_Cc = $914aec8743edd630$var$ob.source, t.src_Z = $914aec8743edd630$var$sb.source, t.src_P = $914aec8743edd630$var$kc.source, t.src_ZPCc = [
        t.src_Z,
        t.src_P,
        t.src_Cc
    ].join("|"), t.src_ZCc = [
        t.src_Z,
        t.src_Cc
    ].join("|");
    const r = "[><\uFF5C]";
    return t.src_pseudo_letter = "(?:(?!" + r + "|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|" + r + "|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + r + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
    ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|" + r + '|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + t.src_ZPCc + "))((?![$+<=>^`|\uFF5C])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + t.src_ZPCc + "))((?![$+<=>^`|\uFF5C])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
}
function $914aec8743edd630$var$Pu(e) {
    return Array.prototype.slice.call(arguments, 1).forEach(function(r) {
        r && Object.keys(r).forEach(function(i) {
            e[i] = r[i];
        });
    }), e;
}
function $914aec8743edd630$var$fi(e) {
    return Object.prototype.toString.call(e);
}
function $914aec8743edd630$var$Vj(e) {
    return $914aec8743edd630$var$fi(e) === "[object String]";
}
function $914aec8743edd630$var$Gj(e) {
    return $914aec8743edd630$var$fi(e) === "[object Object]";
}
function $914aec8743edd630$var$Wj(e) {
    return $914aec8743edd630$var$fi(e) === "[object RegExp]";
}
function $914aec8743edd630$var$L0(e) {
    return $914aec8743edd630$var$fi(e) === "[object Function]";
}
function $914aec8743edd630$var$Hj(e) {
    return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const $914aec8743edd630$var$vb = {
    fuzzyLink: !0,
    fuzzyEmail: !0,
    fuzzyIP: !1
};
function $914aec8743edd630$var$Kj(e) {
    return Object.keys(e || {}).reduce(function(t, r) {
        return t || $914aec8743edd630$var$vb.hasOwnProperty(r);
    }, !1);
}
const $914aec8743edd630$var$Qj = {
    "http:": {
        validate: function(e, t, r) {
            const i = e.slice(t);
            return r.re.http || (r.re.http = new RegExp("^\\/\\/" + r.re.src_auth + r.re.src_host_port_strict + r.re.src_path, "i")), r.re.http.test(i) ? i.match(r.re.http)[0].length : 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(e, t, r) {
            const i = e.slice(t);
            return r.re.no_http || (r.re.no_http = new RegExp("^" + r.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + r.re.src_domain + ")\\.)+" + r.re.src_domain_root + ")" + r.re.src_port + r.re.src_host_terminator + r.re.src_path, "i")), r.re.no_http.test(i) ? t >= 3 && e[t - 3] === ":" || t >= 3 && e[t - 3] === "/" ? 0 : i.match(r.re.no_http)[0].length : 0;
        }
    },
    "mailto:": {
        validate: function(e, t, r) {
            const i = e.slice(t);
            return r.re.mailto || (r.re.mailto = new RegExp("^" + r.re.src_email_name + "@" + r.re.src_host_strict, "i")), r.re.mailto.test(i) ? i.match(r.re.mailto)[0].length : 0;
        }
    }
}, $914aec8743edd630$var$Yj = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", $914aec8743edd630$var$Jj = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
function $914aec8743edd630$var$Zj(e) {
    e.__index__ = -1, e.__text_cache__ = "";
}
function $914aec8743edd630$var$Xj(e) {
    return function(t, r) {
        const i = t.slice(r);
        return e.test(i) ? i.match(e)[0].length : 0;
    };
}
function $914aec8743edd630$var$N0() {
    return function(e, t) {
        t.normalize(e);
    };
}
function $914aec8743edd630$var$Un(e) {
    const t = e.re = $914aec8743edd630$var$Uj(e.__opts__), r = e.__tlds__.slice();
    e.onCompile(), e.__tlds_replaced__ || r.push($914aec8743edd630$var$Yj), r.push(t.src_xn), t.src_tlds = r.join("|");
    function i(a) {
        return a.replace("%TLDS%", t.src_tlds);
    }
    t.email_fuzzy = RegExp(i(t.tpl_email_fuzzy), "i"), t.link_fuzzy = RegExp(i(t.tpl_link_fuzzy), "i"), t.link_no_ip_fuzzy = RegExp(i(t.tpl_link_no_ip_fuzzy), "i"), t.host_fuzzy_test = RegExp(i(t.tpl_host_fuzzy_test), "i");
    const n = [];
    e.__compiled__ = {};
    function o(a, u) {
        throw new Error('(LinkifyIt) Invalid schema "' + a + '": ' + u);
    }
    Object.keys(e.__schemas__).forEach(function(a) {
        const u = e.__schemas__[a];
        if (u === null) return;
        const l = {
            validate: null,
            link: null
        };
        if (e.__compiled__[a] = l, $914aec8743edd630$var$Gj(u)) {
            $914aec8743edd630$var$Wj(u.validate) ? l.validate = $914aec8743edd630$var$Xj(u.validate) : $914aec8743edd630$var$L0(u.validate) ? l.validate = u.validate : o(a, u), $914aec8743edd630$var$L0(u.normalize) ? l.normalize = u.normalize : u.normalize ? o(a, u) : l.normalize = $914aec8743edd630$var$N0();
            return;
        }
        if ($914aec8743edd630$var$Vj(u)) {
            n.push(a);
            return;
        }
        o(a, u);
    }), n.forEach(function(a) {
        e.__compiled__[e.__schemas__[a]] && (e.__compiled__[a].validate = e.__compiled__[e.__schemas__[a]].validate, e.__compiled__[a].normalize = e.__compiled__[e.__schemas__[a]].normalize);
    }), e.__compiled__[""] = {
        validate: null,
        normalize: $914aec8743edd630$var$N0()
    };
    const s = Object.keys(e.__compiled__).filter(function(a) {
        return a.length > 0 && e.__compiled__[a];
    }).map($914aec8743edd630$var$Hj).join("|");
    e.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + t.src_ZPCc + "))(" + s + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + t.src_ZPCc + "))(" + s + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp("(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@", "i"), $914aec8743edd630$var$Zj(e);
}
function $914aec8743edd630$var$e9(e, t) {
    const r = e.__index__, i = e.__last_index__, n = e.__text_cache__.slice(r, i);
    this.schema = e.__schema__.toLowerCase(), this.index = r + t, this.lastIndex = i + t, this.raw = n, this.text = n, this.url = n;
}
function $914aec8743edd630$var$Iu(e, t) {
    const r = new $914aec8743edd630$var$e9(e, t);
    return e.__compiled__[r.schema].normalize(r, e), r;
}
function $914aec8743edd630$var$Qe(e, t) {
    if (!(this instanceof $914aec8743edd630$var$Qe)) return new $914aec8743edd630$var$Qe(e, t);
    t || $914aec8743edd630$var$Kj(e) && (t = e, e = {}), this.__opts__ = $914aec8743edd630$var$Pu({}, $914aec8743edd630$var$vb, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = $914aec8743edd630$var$Pu({}, $914aec8743edd630$var$Qj, e), this.__compiled__ = {}, this.__tlds__ = $914aec8743edd630$var$Jj, this.__tlds_replaced__ = !1, this.re = {}, $914aec8743edd630$var$Un(this);
}
$914aec8743edd630$var$Qe.prototype.add = function(t, r) {
    return this.__schemas__[t] = r, $914aec8743edd630$var$Un(this), this;
};
$914aec8743edd630$var$Qe.prototype.set = function(t) {
    return this.__opts__ = $914aec8743edd630$var$Pu(this.__opts__, t), this;
};
$914aec8743edd630$var$Qe.prototype.test = function(t) {
    if (this.__text_cache__ = t, this.__index__ = -1, !t.length) return !1;
    let r, i, n, o, s, a, u, l, c;
    if (this.re.schema_test.test(t)) {
        for(u = this.re.schema_search, u.lastIndex = 0; (r = u.exec(t)) !== null;)if (o = this.testSchemaAt(t, r[2], u.lastIndex), o) {
            this.__schema__ = r[2], this.__index__ = r.index + r[1].length, this.__last_index__ = r.index + r[0].length + o;
            break;
        }
    }
    return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (l = t.search(this.re.host_fuzzy_test), l >= 0 && (this.__index__ < 0 || l < this.__index__) && (i = t.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (s = i.index + i[1].length, (this.__index__ < 0 || s < this.__index__) && (this.__schema__ = "", this.__index__ = s, this.__last_index__ = i.index + i[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (c = t.indexOf("@"), c >= 0 && (n = t.match(this.re.email_fuzzy)) !== null && (s = n.index + n[1].length, a = n.index + n[0].length, (this.__index__ < 0 || s < this.__index__ || s === this.__index__ && a > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = s, this.__last_index__ = a))), this.__index__ >= 0;
};
$914aec8743edd630$var$Qe.prototype.pretest = function(t) {
    return this.re.pretest.test(t);
};
$914aec8743edd630$var$Qe.prototype.testSchemaAt = function(t, r, i) {
    return this.__compiled__[r.toLowerCase()] ? this.__compiled__[r.toLowerCase()].validate(t, i, this) : 0;
};
$914aec8743edd630$var$Qe.prototype.match = function(t) {
    const r = [];
    let i = 0;
    this.__index__ >= 0 && this.__text_cache__ === t && (r.push($914aec8743edd630$var$Iu(this, i)), i = this.__last_index__);
    let n = i ? t.slice(i) : t;
    for(; this.test(n);)r.push($914aec8743edd630$var$Iu(this, i)), n = n.slice(this.__last_index__), i += this.__last_index__;
    return r.length ? r : null;
};
$914aec8743edd630$var$Qe.prototype.matchAtStart = function(t) {
    if (this.__text_cache__ = t, this.__index__ = -1, !t.length) return null;
    const r = this.re.schema_at_start.exec(t);
    if (!r) return null;
    const i = this.testSchemaAt(t, r[2], r[0].length);
    return i ? (this.__schema__ = r[2], this.__index__ = r.index + r[1].length, this.__last_index__ = r.index + r[0].length + i, $914aec8743edd630$var$Iu(this, 0)) : null;
};
$914aec8743edd630$var$Qe.prototype.tlds = function(t, r) {
    return t = Array.isArray(t) ? t : [
        t
    ], r ? (this.__tlds__ = this.__tlds__.concat(t).sort().filter(function(i, n, o) {
        return i !== o[n - 1];
    }).reverse(), $914aec8743edd630$var$Un(this), this) : (this.__tlds__ = t.slice(), this.__tlds_replaced__ = !0, $914aec8743edd630$var$Un(this), this);
};
$914aec8743edd630$var$Qe.prototype.normalize = function(t) {
    t.schema || (t.url = "http://" + t.url), t.schema === "mailto:" && !/^mailto:/i.test(t.url) && (t.url = "mailto:" + t.url);
};
$914aec8743edd630$var$Qe.prototype.onCompile = function() {};
const $914aec8743edd630$var$Qt = 2147483647, $914aec8743edd630$var$st = 36, $914aec8743edd630$var$Tc = 1, $914aec8743edd630$var$tn = 26, $914aec8743edd630$var$t9 = 38, $914aec8743edd630$var$r9 = 700, $914aec8743edd630$var$yb = 72, $914aec8743edd630$var$wb = 128, $914aec8743edd630$var$_b = "-", $914aec8743edd630$var$n9 = /^xn--/, $914aec8743edd630$var$i9 = /[^\0-\x7F]/, $914aec8743edd630$var$o9 = /[\x2E\u3002\uFF0E\uFF61]/g, $914aec8743edd630$var$a9 = {
    overflow: "Overflow: input needs wider integers to process",
    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
    "invalid-input": "Invalid input"
}, $914aec8743edd630$var$Gs = $914aec8743edd630$var$st - $914aec8743edd630$var$Tc, $914aec8743edd630$var$ut = Math.floor, $914aec8743edd630$var$Ws = String.fromCharCode;
function $914aec8743edd630$var$St(e) {
    throw new RangeError($914aec8743edd630$var$a9[e]);
}
function $914aec8743edd630$var$s9(e, t) {
    const r = [];
    let i = e.length;
    for(; i--;)r[i] = t(e[i]);
    return r;
}
function $914aec8743edd630$var$kb(e, t) {
    const r = e.split("@");
    let i = "";
    r.length > 1 && (i = r[0] + "@", e = r[1]), e = e.replace($914aec8743edd630$var$o9, ".");
    const n = e.split("."), o = $914aec8743edd630$var$s9(n, t).join(".");
    return i + o;
}
function $914aec8743edd630$var$xb(e) {
    const t = [];
    let r = 0;
    const i = e.length;
    for(; r < i;){
        const n = e.charCodeAt(r++);
        if (n >= 55296 && n <= 56319 && r < i) {
            const o = e.charCodeAt(r++);
            (o & 64512) == 56320 ? t.push(((n & 1023) << 10) + (o & 1023) + 65536) : (t.push(n), r--);
        } else t.push(n);
    }
    return t;
}
const $914aec8743edd630$var$u9 = (e)=>String.fromCodePoint(...e), $914aec8743edd630$var$c9 = function(e) {
    return e >= 48 && e < 58 ? 26 + (e - 48) : e >= 65 && e < 91 ? e - 65 : e >= 97 && e < 123 ? e - 97 : $914aec8743edd630$var$st;
}, $914aec8743edd630$var$B0 = function(e, t) {
    return e + 22 + 75 * (e < 26) - ((t != 0) << 5);
}, $914aec8743edd630$var$Sb = function(e, t, r) {
    let i = 0;
    for(e = r ? $914aec8743edd630$var$ut(e / $914aec8743edd630$var$r9) : e >> 1, e += $914aec8743edd630$var$ut(e / t); e > $914aec8743edd630$var$Gs * $914aec8743edd630$var$tn >> 1; i += $914aec8743edd630$var$st)e = $914aec8743edd630$var$ut(e / $914aec8743edd630$var$Gs);
    return $914aec8743edd630$var$ut(i + ($914aec8743edd630$var$Gs + 1) * e / (e + $914aec8743edd630$var$t9));
}, $914aec8743edd630$var$Eb = function(e) {
    const t = [], r = e.length;
    let i = 0, n = $914aec8743edd630$var$wb, o = $914aec8743edd630$var$yb, s = e.lastIndexOf($914aec8743edd630$var$_b);
    s < 0 && (s = 0);
    for(let a = 0; a < s; ++a)e.charCodeAt(a) >= 128 && $914aec8743edd630$var$St("not-basic"), t.push(e.charCodeAt(a));
    for(let a = s > 0 ? s + 1 : 0; a < r;){
        const u = i;
        for(let c = 1, d = $914aec8743edd630$var$st;; d += $914aec8743edd630$var$st){
            a >= r && $914aec8743edd630$var$St("invalid-input");
            const h = $914aec8743edd630$var$c9(e.charCodeAt(a++));
            h >= $914aec8743edd630$var$st && $914aec8743edd630$var$St("invalid-input"), h > $914aec8743edd630$var$ut(($914aec8743edd630$var$Qt - i) / c) && $914aec8743edd630$var$St("overflow"), i += h * c;
            const f = d <= o ? $914aec8743edd630$var$Tc : d >= o + $914aec8743edd630$var$tn ? $914aec8743edd630$var$tn : d - o;
            if (h < f) break;
            const p = $914aec8743edd630$var$st - f;
            c > $914aec8743edd630$var$ut($914aec8743edd630$var$Qt / p) && $914aec8743edd630$var$St("overflow"), c *= p;
        }
        const l = t.length + 1;
        o = $914aec8743edd630$var$Sb(i - u, l, u == 0), $914aec8743edd630$var$ut(i / l) > $914aec8743edd630$var$Qt - n && $914aec8743edd630$var$St("overflow"), n += $914aec8743edd630$var$ut(i / l), i %= l, t.splice(i++, 0, n);
    }
    return String.fromCodePoint(...t);
}, $914aec8743edd630$var$Ab = function(e) {
    const t = [];
    e = $914aec8743edd630$var$xb(e);
    const r = e.length;
    let i = $914aec8743edd630$var$wb, n = 0, o = $914aec8743edd630$var$yb;
    for (const u of e)u < 128 && t.push($914aec8743edd630$var$Ws(u));
    const s = t.length;
    let a = s;
    for(s && t.push($914aec8743edd630$var$_b); a < r;){
        let u = $914aec8743edd630$var$Qt;
        for (const c of e)c >= i && c < u && (u = c);
        const l = a + 1;
        u - i > $914aec8743edd630$var$ut(($914aec8743edd630$var$Qt - n) / l) && $914aec8743edd630$var$St("overflow"), n += (u - i) * l, i = u;
        for (const c of e)if (c < i && ++n > $914aec8743edd630$var$Qt && $914aec8743edd630$var$St("overflow"), c === i) {
            let d = n;
            for(let h = $914aec8743edd630$var$st;; h += $914aec8743edd630$var$st){
                const f = h <= o ? $914aec8743edd630$var$Tc : h >= o + $914aec8743edd630$var$tn ? $914aec8743edd630$var$tn : h - o;
                if (d < f) break;
                const p = d - f, m = $914aec8743edd630$var$st - f;
                t.push($914aec8743edd630$var$Ws($914aec8743edd630$var$B0(f + p % m, 0))), d = $914aec8743edd630$var$ut(p / m);
            }
            t.push($914aec8743edd630$var$Ws($914aec8743edd630$var$B0(d, 0))), o = $914aec8743edd630$var$Sb(n, l, a === s), n = 0, ++a;
        }
        ++n, ++i;
    }
    return t.join("");
}, $914aec8743edd630$var$l9 = function(e) {
    return $914aec8743edd630$var$kb(e, function(t) {
        return $914aec8743edd630$var$n9.test(t) ? $914aec8743edd630$var$Eb(t.slice(4).toLowerCase()) : t;
    });
}, $914aec8743edd630$var$d9 = function(e) {
    return $914aec8743edd630$var$kb(e, function(t) {
        return $914aec8743edd630$var$i9.test(t) ? "xn--" + $914aec8743edd630$var$Ab(t) : t;
    });
}, $914aec8743edd630$var$Tb = {
    /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */ version: "2.3.1",
    /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */ ucs2: {
        decode: $914aec8743edd630$var$xb,
        encode: $914aec8743edd630$var$u9
    },
    decode: $914aec8743edd630$var$Eb,
    encode: $914aec8743edd630$var$Ab,
    toASCII: $914aec8743edd630$var$d9,
    toUnicode: $914aec8743edd630$var$l9
}, $914aec8743edd630$var$f9 = {
    options: {
        // Enable HTML tags in source
        html: !1,
        // Use '/' to close single tags (<br />)
        xhtmlOut: !1,
        // Convert '\n' in paragraphs into <br>
        breaks: !1,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: !1,
        // Enable some language-neutral replacements + quotes beautification
        typographer: !1,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
}, $914aec8743edd630$var$h9 = {
    options: {
        // Enable HTML tags in source
        html: !1,
        // Use '/' to close single tags (<br />)
        xhtmlOut: !1,
        // Convert '\n' in paragraphs into <br>
        breaks: !1,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: !1,
        // Enable some language-neutral replacements + quotes beautification
        typographer: !1,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "fragments_join"
            ]
        }
    }
}, $914aec8743edd630$var$p9 = {
    options: {
        // Enable HTML tags in source
        html: !0,
        // Use '/' to close single tags (<br />)
        xhtmlOut: !0,
        // Convert '\n' in paragraphs into <br>
        breaks: !1,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: !1,
        // Enable some language-neutral replacements + quotes beautification
        typographer: !1,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "fragments_join"
            ]
        }
    }
}, $914aec8743edd630$var$m9 = {
    default: $914aec8743edd630$var$f9,
    zero: $914aec8743edd630$var$h9,
    commonmark: $914aec8743edd630$var$p9
}, $914aec8743edd630$var$g9 = /^(vbscript|javascript|file|data):/, $914aec8743edd630$var$b9 = /^data:image\/(gif|png|jpeg|webp);/;
function $914aec8743edd630$var$v9(e) {
    const t = e.trim().toLowerCase();
    return $914aec8743edd630$var$g9.test(t) ? $914aec8743edd630$var$b9.test(t) : !0;
}
const $914aec8743edd630$var$Cb = [
    "http:",
    "https:",
    "mailto:"
];
function $914aec8743edd630$var$y9(e) {
    const t = $914aec8743edd630$var$_c(e, !0);
    if (t.hostname && (!t.protocol || $914aec8743edd630$var$Cb.indexOf(t.protocol) >= 0)) try {
        t.hostname = $914aec8743edd630$var$Tb.toASCII(t.hostname);
    } catch  {}
    return $914aec8743edd630$var$hn($914aec8743edd630$var$wc(t));
}
function $914aec8743edd630$var$w9(e) {
    const t = $914aec8743edd630$var$_c(e, !0);
    if (t.hostname && (!t.protocol || $914aec8743edd630$var$Cb.indexOf(t.protocol) >= 0)) try {
        t.hostname = $914aec8743edd630$var$Tb.toUnicode(t.hostname);
    } catch  {}
    return $914aec8743edd630$var$Xt($914aec8743edd630$var$wc(t), $914aec8743edd630$var$Xt.defaultChars + "%");
}
function $914aec8743edd630$var$Je(e, t) {
    if (!(this instanceof $914aec8743edd630$var$Je)) return new $914aec8743edd630$var$Je(e, t);
    t || $914aec8743edd630$var$xc(e) || (t = e || {}, e = "default"), this.inline = new $914aec8743edd630$var$mn(), this.block = new $914aec8743edd630$var$di(), this.core = new $914aec8743edd630$var$Ec(), this.renderer = new $914aec8743edd630$var$ur(), this.linkify = new $914aec8743edd630$var$Qe(), this.validateLink = $914aec8743edd630$var$v9, this.normalizeLink = $914aec8743edd630$var$y9, this.normalizeLinkText = $914aec8743edd630$var$w9, this.utils = $914aec8743edd630$var$kM, this.helpers = $914aec8743edd630$var$ci({}, $914aec8743edd630$var$AM), this.options = {}, this.configure(e), t && this.set(t);
}
$914aec8743edd630$var$Je.prototype.set = function(e) {
    return $914aec8743edd630$var$ci(this.options, e), this;
};
$914aec8743edd630$var$Je.prototype.configure = function(e) {
    const t = this;
    if ($914aec8743edd630$var$xc(e)) {
        const r = e;
        if (e = $914aec8743edd630$var$m9[r], !e) throw new Error('Wrong `markdown-it` preset "' + r + '", check name');
    }
    if (!e) throw new Error("Wrong `markdown-it` preset, can't be empty");
    return e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function(r) {
        e.components[r].rules && t[r].ruler.enableOnly(e.components[r].rules), e.components[r].rules2 && t[r].ruler2.enableOnly(e.components[r].rules2);
    }), this;
};
$914aec8743edd630$var$Je.prototype.enable = function(e, t) {
    let r = [];
    Array.isArray(e) || (e = [
        e
    ]), [
        "core",
        "block",
        "inline"
    ].forEach(function(n) {
        r = r.concat(this[n].ruler.enable(e, !0));
    }, this), r = r.concat(this.inline.ruler2.enable(e, !0));
    const i = e.filter(function(n) {
        return r.indexOf(n) < 0;
    });
    if (i.length && !t) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + i);
    return this;
};
$914aec8743edd630$var$Je.prototype.disable = function(e, t) {
    let r = [];
    Array.isArray(e) || (e = [
        e
    ]), [
        "core",
        "block",
        "inline"
    ].forEach(function(n) {
        r = r.concat(this[n].ruler.disable(e, !0));
    }, this), r = r.concat(this.inline.ruler2.disable(e, !0));
    const i = e.filter(function(n) {
        return r.indexOf(n) < 0;
    });
    if (i.length && !t) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + i);
    return this;
};
$914aec8743edd630$var$Je.prototype.use = function(e) {
    const t = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    return e.apply(e, t), this;
};
$914aec8743edd630$var$Je.prototype.parse = function(e, t) {
    if (typeof e != "string") throw new Error("Input data should be a String");
    const r = new this.core.State(e, this, t);
    return this.core.process(r), r.tokens;
};
$914aec8743edd630$var$Je.prototype.render = function(e, t) {
    return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
};
$914aec8743edd630$var$Je.prototype.parseInline = function(e, t) {
    const r = new this.core.State(e, this, t);
    return r.inlineMode = !0, this.core.process(r), r.tokens;
};
$914aec8743edd630$var$Je.prototype.renderInline = function(e, t) {
    return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
};
class $914aec8743edd630$var$Rb {
    constructor(t){
        this.options = t, this.options = t;
    }
    // Adds each element of the array as markdown
    addArray(t, r) {
        for (const i of t)this.formatFromAst(i, r);
        return r;
    }
    processAst(t, r) {
        t instanceof Array ? this.addArray(t, r) : this.formatFromAst(t, r);
    }
}
class $914aec8743edd630$var$Ob extends $914aec8743edd630$var$Rb {
    constructor(t){
        super(t), this.options = t;
    }
    format(t) {
        let r = this.formatFromAst(t, []).join("").trim();
        return r = r.replace(/  +/g, " "), r;
    }
    formatFromAst(t, r = []) {
        switch(t.name){
            case "document":
                return this.processAst(t.children, r), r;
            case "paragraph":
                return this.processAst(t.children, r), r;
            case "simpleLine":
                return this.processAst(t.children, r), r;
            case "lineEnd":
                return r.push(t.allText), r;
            case "emptyLine":
                return this.options.preserveEmptyLines && r.push(t.allText), r;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                return r.push(t.allText), r;
            default:
                return this.processAst(t.children, r), r;
        }
    }
}
class $914aec8743edd630$var$Xe {
    constructor(t){
        this.base = t, this.tags = {}, this.text = "";
    }
    tag(t, r, i = !1, n = this.base.ssmlTagSortOrder) {
        const o = n.indexOf(t);
        this.tags[t] || (this.tags[t] = {
            sortId: o,
            attrs: null
        }), i ? this.tags[t].attrs = {
            ...this.tags[t].attrs,
            ...r
        } : this.tags[t].attrs = r;
    }
    voiceTagNamed(t, r) {
        let i = t && t[r];
        return i ? (typeof i != "object" && (i = {
            voice: {
                name: r
            }
        }), Object.keys(i).forEach((n)=>{
            const o = i[n];
            this.tag(n, o);
        }), !0) : !1;
    }
    voiceTag(t, r) {
        const i = this.base.sentenceCase(r || "device");
        this.voiceTagNamed(this.base.options && this.base.options.voices, i) || this.voiceTagNamed(this.base.validVoices, i);
    }
}
const $914aec8743edd630$var$Pn = class Gr extends $914aec8743edd630$var$Rb {
    constructor(t){
        super(t), this.options = t, this.sectionTags = [], this.modifierKeyMappings = {
            chars: "characters",
            cardinal: "number",
            digits: "characters",
            bleep: "expletive",
            phone: "telephone",
            vol: "volume"
        }, this.ssmlTagSortOrder = [
            "emphasis",
            "say-as",
            "prosody",
            "amazon:domain",
            "amazon:effect",
            "amazon:emotion",
            "voice",
            "lang",
            "sub",
            "phoneme"
        ], this.modifierKeyToSsmlTagMappings = {
            emphasis: "emphasis",
            address: "say-as",
            number: "say-as",
            characters: "say-as",
            expletive: "say-as",
            fraction: "say-as",
            interjection: "say-as",
            ordinal: "say-as",
            telephone: "say-as",
            unit: "say-as",
            time: "say-as",
            date: "say-as",
            whisper: null,
            sub: "sub",
            ipa: "phoneme",
            rate: "prosody",
            pitch: "prosody",
            volume: "prosody",
            drc: null,
            timbre: null,
            lang: null,
            voice: null,
            dj: null,
            defaults: null,
            newscaster: null,
            excited: null,
            disappointed: null
        };
    }
    format(t) {
        return this.formatFromAst(t, []).join("");
    }
    addSectionStartTag(t, r, i) {
        this.sectionTags = [
            ...t
        ].reverse();
        for(let n = 0; n < t.length; n++){
            const o = t[n], s = r.tags[o].attrs;
            i.push(`
`), i.push(this.startTag(o, s, !1));
        }
    }
    addSectionEndTag(t) {
        if (this.sectionTags.length > 0) for(let r = 0; r < this.sectionTags.length; r++){
            const i = this.sectionTags[r];
            t.push(this.endTag(i, !1)), t.push(`
`);
        }
    }
    // Adds tagged content
    addTag(t, r, i, n, o, s) {
        return s.push(this.startTag(t, o, i)), this.processAst(r, s), s.push(this.endTag(t, i)), n && s.push(`
`), s;
    }
    addSpeakTag(t, r, i, n, o) {
        return o.push(this.startTag("speak", n, r)), this.processAst(t, o), this.addSectionEndTag(o), o.push(this.endTag("speak", r)), i && o.push(`
`), o;
    }
    addComment(t, r) {
        return r.push(`<!-- ${t} -->
`), r;
    }
    // Returns the SSML for a start tag
    startTag(t, r, i = !1) {
        let n = "";
        return r && (n = " " + Object.keys(r).map((o)=>o + '="' + r[o] + '"').join(" ")), "<" + t + n + ">" + (i ? `
` : "");
    }
    // Returns the SSML for an end tag
    endTag(t, r = !1) {
        return (r ? `
` : "") + "</" + t + ">";
    }
    voidTag(t, r) {
        let i = "";
        return r && (i = " " + Object.keys(r).map((n)=>n + '="' + r[n] + '"').join(" ")), "<" + t + i + "/>";
    }
    addTagWithAttrs(t, r, i, n, o = !1) {
        return r || o ? (t.push(this.startTag(i, n)), r && t.push(r), t.push(this.endTag(i, !1))) : t.push(this.voidTag(i, n)), t;
    }
    getTagWithAttrs(t, r, i) {
        let n = [];
        return t ? (n.push(this.startTag(r, i)), n.push(t), n.push(this.endTag(r, !1))) : n.push(this.voidTag(r, i)), n.join("");
    }
    sentenceCase(t) {
        return t.replace(/[a-z]/i, (r)=>r.toUpperCase()).trim();
    }
    escapeXmlCharacters(t) {
        let r = `${Object.keys(Gr.XML_UNESCAPE_MAPPING).join("|")}]`, i = t.replace(new RegExp(r, "g"), (o)=>Gr.XML_UNESCAPE_MAPPING[o]), n = `[${Object.keys(Gr.XML_ESCAPE_MAPPING).join("")}]`;
        return i.replace(new RegExp(n, "g"), (o)=>Gr.XML_ESCAPE_MAPPING[o]);
    }
};
$914aec8743edd630$var$Pn.XML_ESCAPE_MAPPING = {
    "<": "&lt;",
    ">": "&gt;",
    "&": "&amp;",
    '"': "&quot;",
    "'": "&apos;"
}, $914aec8743edd630$var$Pn.XML_UNESCAPE_MAPPING = function(e) {
    return Object.keys(e).reduce((t, r)=>(t[e[r]] = r, t), {});
}($914aec8743edd630$var$Pn.XML_ESCAPE_MAPPING);
let $914aec8743edd630$var$cr = $914aec8743edd630$var$Pn;
class $914aec8743edd630$var$_9 extends $914aec8743edd630$var$cr {
    constructor(t){
        super(t), this.options = t, this.validVoices = {
            Ivy: "en-US",
            Joanna: "en-US",
            Joey: "en-US",
            Justin: "en-US",
            Kendra: "en-US",
            Kimberly: "en-US",
            Matthew: "en-US",
            Salli: "en-US",
            Nicole: "en-AU",
            Russell: "en-AU",
            Amy: "en-GB",
            Brian: "en-GB",
            Emma: "en-GB",
            Aditi: "en-IN",
            Raveena: "en-IN",
            Hans: "de-DE",
            Marlene: "de-DE",
            Vicki: "de-DE",
            Conchita: "es-ES",
            Enrique: "es-ES",
            Carla: "it-IT",
            Giorgio: "it-IT",
            Mizuki: "ja-JP",
            Takumi: "ja-JP",
            Celine: "fr-FR",
            Lea: "fr-FR",
            Mathieu: "fr-FR"
        }, this.validEmotionIntensity = [
            "low",
            "medium",
            "high"
        ], this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.voice = "voice", this.modifierKeyToSsmlTagMappings.dj = "amazon:domain", this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain", this.modifierKeyToSsmlTagMappings.excited = "amazon:emotion", this.modifierKeyToSsmlTagMappings.disappointed = "amazon:emotion";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(t) {
        let r = new $914aec8743edd630$var$Xe(this);
        for(let i = 0; i < t.children.length; i++){
            const n = t.children[i];
            switch(n.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    r.text = n.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let o = n.children[0].allText;
                        o = this.modifierKeyMappings[o] || o;
                        const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
                        switch(o){
                            case "emphasis":
                                r.tag(a, {
                                    level: s || "moderate"
                                });
                                break;
                            case "address":
                            case "characters":
                            case "expletive":
                            case "fraction":
                            case "interjection":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                r.tag(a, {
                                    "interpret-as": o
                                });
                                break;
                            case "date":
                                r.tag(a, {
                                    "interpret-as": o,
                                    format: s || "ymd"
                                });
                                break;
                            case "time":
                                r.tag(a, {
                                    "interpret-as": o,
                                    format: s || "hms12"
                                });
                                break;
                            case "whisper":
                                r.tag(a, {
                                    name: "whispered"
                                });
                                break;
                            case "ipa":
                                r.tag(a, {
                                    alphabet: o,
                                    ph: s
                                });
                                break;
                            case "sub":
                                r.tag(a, {
                                    alias: s
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const u = {};
                                    u[o] = s || "medium", r.tag(a, u, !0);
                                    break;
                                }
                            case "lang":
                                r.tag(a, {
                                    "xml:lang": s
                                });
                                break;
                            case "voice":
                                r.voiceTag(o, s);
                                break;
                            case "excited":
                            case "disappointed":
                                {
                                    const u = (s || "medium").toLowerCase();
                                    if (this.validEmotionIntensity.includes(u)) {
                                        r.tag(a, {
                                            name: o,
                                            intensity: u
                                        });
                                        break;
                                    }
                                    break;
                                }
                        }
                        break;
                    }
            }
        }
        return r;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(t) {
        let r = new $914aec8743edd630$var$Xe(this);
        for(let i = 0; i < t.children.length; i++){
            const n = t.children[i];
            if (n.name === "sectionModifierKeyOptionalValue") {
                let o = n.children[0].allText;
                const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
                switch(o){
                    case "lang":
                        r.tag(a, {
                            "xml:lang": s
                        });
                        break;
                    case "voice":
                        r.voiceTag(o, s);
                        break;
                    case "dj":
                        r.tag(a, {
                            name: "music"
                        });
                        break;
                    case "newscaster":
                        r.tag(a, {
                            name: "news"
                        });
                        break;
                    case "defaults":
                        break;
                    case "excited":
                    case "disappointed":
                        {
                            const u = (s || "medium").toLowerCase();
                            if (this.validEmotionIntensity.includes(u)) {
                                r.tag(a, {
                                    name: o,
                                    intensity: u
                                });
                                break;
                            }
                            break;
                        }
                }
            }
        }
        return r;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(t, r = []) {
        switch(t.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", r), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "shortBreak":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = t.children[0].allText;
                    let n = {};
                    switch(t.children[0].children[0].name){
                        case "breakStrengthValue":
                            n = {
                                strength: i
                            };
                            break;
                        case "time":
                            n = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(r, null, "break", n);
                }
            case "shortEmphasisModerate":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "moderate"
                    });
                }
            case "shortEmphasisStrong":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "strong"
                    });
                }
            case "shortEmphasisNone":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "none"
                    });
                }
            case "shortEmphasisReduced":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "reduced"
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(t), n = Object.keys(i.tags).sort((s, a)=>i.tags[a].sortId - i.tags[s].sortId);
                    let o = i.text;
                    for(let s = 0; s < n.length; s++){
                        const a = n[s], u = i.tags[a].attrs;
                        o = this.getTagWithAttrs(o, a, u);
                    }
                    return r.push(o), r;
                }
            case "section":
                {
                    const i = this.getSectionObject(t), n = Object.keys(i.tags).sort((o, s)=>i.tags[o].sortId - i.tags[s].sortId);
                    return this.addSectionEndTag(r), this.addSectionStartTag(n, i, r), r;
                }
            case "audio":
                {
                    const i = t.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(r, null, "audio", {
                        src: i
                    });
                }
            case "simpleLine":
                return this.processAst(t.children, r), r;
            case "lineEnd":
                return r.push(t.allText), r;
            case "emptyLine":
                return this.options.preserveEmptyLines && r.push(t.allText), r;
            case "plainText":
            case "plainTextSpecialChars":
                {
                    let i = this.options.escapeXmlSymbols ? this.escapeXmlCharacters(t.allText) : t.allText;
                    return r.push(i), r;
                }
            default:
                return this.processAst(t.children, r), r;
        }
    }
}
class $914aec8743edd630$var$k9 extends $914aec8743edd630$var$cr {
    constructor(t){
        super(t), this.options = t, this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect", this.modifierKeyToSsmlTagMappings.timbre = "amazon:effect", this.modifierKeyToSsmlTagMappings.cardinal = "say-as", this.modifierKeyToSsmlTagMappings.digits = "say-as", this.modifierKeyToSsmlTagMappings.drc = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyMappings.digits = "digits", this.modifierKeyMappings.cardinal = "cardinal";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(t) {
        let r = new $914aec8743edd630$var$Xe(this);
        for(let i = 0; i < t.children.length; i++){
            const n = t.children[i];
            switch(n.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    r.text = n.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let o = n.children[0].allText;
                        o = this.modifierKeyMappings[o] || o;
                        const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
                        switch(o){
                            case "emphasis":
                                r.tag(a, {
                                    level: s || "moderate"
                                });
                                break;
                            case "address":
                            case "cardinal":
                            case "characters":
                            case "digits":
                            case "expletive":
                            case "fraction":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                r.tag(a, {
                                    "interpret-as": o
                                });
                                break;
                            case "date":
                                r.tag(a, {
                                    "interpret-as": o,
                                    format: s || "ymd"
                                });
                                break;
                            case "time":
                                r.tag(a, {
                                    "interpret-as": o,
                                    format: s || "hms12"
                                });
                                break;
                            case "whisper":
                                r.tag(a, {
                                    name: "whispered"
                                });
                                break;
                            case "ipa":
                                r.tag(a, {
                                    alphabet: o,
                                    ph: s
                                });
                                break;
                            case "sub":
                                r.tag(a, {
                                    alias: s
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const u = {};
                                    u[o] = s || "medium", r.tag(a, u, !0);
                                    break;
                                }
                            case "timbre":
                                r.tag(a, {
                                    "vocal-tract-length": s
                                });
                                break;
                            case "lang":
                                r.tag(a, {
                                    "xml:lang": s
                                });
                                break;
                            case "drc":
                                r.tag(a, {
                                    name: o
                                });
                                break;
                        }
                        break;
                    }
            }
        }
        return r;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(t) {
        let r = new $914aec8743edd630$var$Xe(this);
        for(let i = 0; i < t.children.length; i++){
            const n = t.children[i];
            if (n.name === "sectionModifierKeyOptionalValue") {
                let o = n.children[0].allText;
                const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
                switch(o){
                    case "lang":
                        r.tag(a, {
                            "xml:lang": s
                        });
                        break;
                }
            }
        }
        return r;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(t, r = []) {
        switch(t.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", r), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "shortBreak":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = t.children[0].allText;
                    let n = {};
                    switch(t.children[0].children[0].name){
                        case "breakStrengthValue":
                            n = {
                                strength: i
                            };
                            break;
                        case "time":
                            n = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(r, null, "break", n);
                }
            case "markTag":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, null, "mark", {
                        name: i
                    });
                }
            case "shortEmphasisModerate":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "moderate"
                    });
                }
            case "shortEmphasisStrong":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "strong"
                    });
                }
            case "shortEmphasisNone":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "none"
                    });
                }
            case "shortEmphasisReduced":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "reduced"
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(t), n = Object.keys(i.tags).sort((s, a)=>i.tags[a].sortId - i.tags[s].sortId);
                    let o = i.text;
                    for(let s = 0; s < n.length; s++){
                        const a = n[s], u = i.tags[a].attrs;
                        o = this.getTagWithAttrs(o, a, u);
                    }
                    return r.push(o), r;
                }
            case "section":
                {
                    const i = this.getSectionObject(t), n = Object.keys(i.tags).sort((o, s)=>i.tags[o].sortId - i.tags[s].sortId);
                    return this.addSectionEndTag(r), this.addSectionStartTag(n, i, r), r;
                }
            case "simpleLine":
                return this.processAst(t.children, r), r;
            case "lineEnd":
                return r.push(t.allText), r;
            case "emptyLine":
                return this.options.preserveEmptyLines && r.push(t.allText), r;
            case "plainText":
            case "plainTextSpecialChars":
                return r.push(t.allText), r;
            default:
                return this.processAst(t.children, r), r;
        }
    }
}
class $914aec8743edd630$var$x9 extends $914aec8743edd630$var$cr {
    constructor(t){
        super(t), this.options = t, this.modifierKeyToSsmlTagMappings.cardinal = "say-as", this.modifierKeyToSsmlTagMappings.digits = "say-as", this.modifierKeyToSsmlTagMappings.drc = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain", this.modifierKeyMappings.digits = "digits", this.modifierKeyMappings.cardinal = "cardinal";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(t) {
        let r = new $914aec8743edd630$var$Xe(this);
        for(let i = 0; i < t.children.length; i++){
            const n = t.children[i];
            switch(n.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    r.text = n.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let o = n.children[0].allText;
                        o = this.modifierKeyMappings[o] || o;
                        const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
                        switch(o){
                            case "address":
                            case "cardinal":
                            case "characters":
                            case "digits":
                            case "expletive":
                            case "fraction":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                r.tag(a, {
                                    "interpret-as": o
                                });
                                break;
                            case "date":
                                r.tag(a, {
                                    "interpret-as": o,
                                    format: s || "ymd"
                                });
                                break;
                            case "time":
                                r.tag(a, {
                                    "interpret-as": o,
                                    format: s || "hms12"
                                });
                                break;
                            case "ipa":
                                r.tag(a, {
                                    alphabet: o,
                                    ph: s
                                });
                                break;
                            case "sub":
                                r.tag(a, {
                                    alias: s
                                });
                                break;
                            case "volume":
                            case "rate":
                                {
                                    const u = {};
                                    u[o] = s || "medium", r.tag(a, u, !0);
                                    break;
                                }
                            case "lang":
                                r.tag(a, {
                                    "xml:lang": s
                                });
                                break;
                            case "drc":
                                r.tag(a, {
                                    name: o
                                });
                                break;
                        }
                        break;
                    }
            }
        }
        return r;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(t) {
        let r = new $914aec8743edd630$var$Xe(this);
        for(let i = 0; i < t.children.length; i++){
            const n = t.children[i];
            if (n.name === "sectionModifierKeyOptionalValue") {
                let o = n.children[0].allText;
                const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
                switch(o){
                    case "lang":
                        r.tag(a, {
                            "xml:lang": s
                        });
                        break;
                    case "newscaster":
                        r.tag(a, {
                            name: "news"
                        });
                        break;
                }
            }
        }
        return r;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(t, r = []) {
        switch(t.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Polly", r), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "shortBreak":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = t.children[0].allText;
                    let n = {};
                    switch(t.children[0].children[0].name){
                        case "breakStrengthValue":
                            n = {
                                strength: i
                            };
                            break;
                        case "time":
                            n = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(r, null, "break", n);
                }
            case "markTag":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, null, "mark", {
                        name: i
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(t), n = Object.keys(i.tags).sort((s, a)=>i.tags[a].sortId - i.tags[s].sortId);
                    let o = i.text;
                    for(let s = 0; s < n.length; s++){
                        const a = n[s], u = i.tags[a].attrs;
                        o = this.getTagWithAttrs(o, a, u);
                    }
                    return r.push(o), r;
                }
            case "section":
                {
                    const i = this.getSectionObject(t), n = Object.keys(i.tags).sort((o, s)=>i.tags[o].sortId - i.tags[s].sortId);
                    return this.addSectionEndTag(r), this.addSectionStartTag(n, i, r), r;
                }
            case "simpleLine":
                return this.processAst(t.children, r), r;
            case "lineEnd":
                return r.push(t.allText), r;
            case "emptyLine":
                return this.options.preserveEmptyLines && r.push(t.allText), r;
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                return r.push(t.allText.replace(/\+/g, "")), r;
            case "plainText":
            case "plainTextSpecialChars":
                return r.push(t.allText), r;
            default:
                return this.processAst(t.children, r), r;
        }
    }
}
class $914aec8743edd630$var$S9 extends $914aec8743edd630$var$cr {
    constructor(t){
        super(t), this.options = t, this.validVoices = {
            Ivy: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-US"
                }
            },
            Joanna: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-US"
                }
            },
            Joey: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-US"
                }
            },
            Justin: {
                voice: {
                    gender: "male",
                    variant: 2,
                    language: "en-US"
                }
            },
            Kendra: {
                voice: {
                    gender: "female",
                    variant: 3,
                    language: "en-US"
                }
            },
            Kimberly: {
                voice: {
                    gender: "female",
                    variant: 4,
                    language: "en-US"
                }
            },
            Matthew: {
                voice: {
                    gender: "male",
                    variant: 3,
                    language: "en-US"
                }
            },
            Salli: {
                voice: {
                    gender: "male",
                    variant: 4,
                    language: "en-US"
                }
            },
            Nicole: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-AU"
                }
            },
            Russell: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-AU"
                }
            },
            Amy: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-GB"
                }
            },
            Brian: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-GB"
                }
            },
            Emma: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-GB"
                }
            },
            Aditi: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-IN"
                }
            },
            Raveena: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-IN"
                }
            },
            Hans: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "de-DE"
                }
            },
            Marlene: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "de-DE"
                }
            },
            Vicki: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "de-DE"
                }
            },
            Conchita: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "es-ES"
                }
            },
            Enrique: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "es-ES"
                }
            },
            Carla: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "it-IT"
                }
            },
            Giorgio: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "it-IT"
                }
            },
            Mizuki: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "ja-JP"
                }
            },
            Takumi: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "ja-JP"
                }
            },
            Celine: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "fr-FR"
                }
            },
            Lea: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "fr-FR"
                }
            },
            Mathieu: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "fr-FR"
                }
            }
        }, this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.whisper = "prosody", this.modifierKeyToSsmlTagMappings.lang = "lang";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(t) {
        let r = new $914aec8743edd630$var$Xe(this);
        for(let i = 0; i < t.children.length; i++){
            const n = t.children[i];
            switch(n.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    r.text = n.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let o = n.children[0].allText;
                        o = this.modifierKeyMappings[o] || o;
                        const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
                        switch(o){
                            case "emphasis":
                                r.tag(a, {
                                    level: s || "moderate"
                                });
                                break;
                            case "address":
                            case "characters":
                            case "expletive":
                            case "fraction":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                r.tag(a, {
                                    "interpret-as": o
                                });
                                break;
                            case "date":
                                r.tag(a, {
                                    "interpret-as": o,
                                    format: s || "ymd"
                                });
                                break;
                            case "time":
                                r.tag(a, {
                                    "interpret-as": o,
                                    format: s || "hms12"
                                });
                                break;
                            case "whisper":
                                r.tag(a, {
                                    volume: "x-soft",
                                    rate: "slow"
                                });
                                break;
                            case "ipa":
                                r.tag(a, {
                                    alphabet: o,
                                    ph: s
                                });
                                break;
                            case "sub":
                                r.tag(a, {
                                    alias: s
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const u = {};
                                    u[o] = s || "medium", r.tag(a, u, !0);
                                    break;
                                }
                            case "lang":
                                r.tag(a, {
                                    "xml:lang": s
                                });
                                break;
                            case "voice":
                                r.voiceTag(o, s);
                                break;
                        }
                        break;
                    }
            }
        }
        return r;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(t) {
        let r = new $914aec8743edd630$var$Xe(this);
        for(let i = 0; i < t.children.length; i++){
            const n = t.children[i];
            if (n.name === "sectionModifierKeyOptionalValue") {
                let o = n.children[0].allText;
                const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
                switch(o){
                    case "lang":
                        r.tag(a, {
                            "xml:lang": s
                        });
                        break;
                    case "voice":
                        r.voiceTag(o, s);
                        break;
                }
            }
        }
        return r;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(t, r = []) {
        switch(t.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Google Assistant", r), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "shortBreak":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = t.children[0].allText;
                    let n = {};
                    switch(t.children[0].children[0].name){
                        case "breakStrengthValue":
                            n = {
                                strength: i
                            };
                            break;
                        case "time":
                            n = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(r, null, "break", n);
                }
            case "markTag":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, null, "mark", {
                        name: i
                    });
                }
            case "shortEmphasisModerate":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "moderate"
                    });
                }
            case "shortEmphasisStrong":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "strong"
                    });
                }
            case "shortEmphasisNone":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "none"
                    });
                }
            case "shortEmphasisReduced":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, i, "emphasis", {
                        level: "reduced"
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(t);
                    if (i.textOnly) return r.push(i.text), r;
                    const n = Object.keys(i.tags).sort((s, a)=>i.tags[a].sortId - i.tags[s].sortId);
                    let o = i.text;
                    for(let s = 0; s < n.length; s++){
                        const a = n[s], u = i.tags[a].attrs;
                        o = this.getTagWithAttrs(o, a, u);
                    }
                    return r.push(o), r;
                }
            case "section":
                {
                    const i = this.getSectionObject(t), n = Object.keys(i.tags).sort((o, s)=>i.tags[o].sortId - i.tags[s].sortId);
                    return this.addSectionEndTag(r), this.addSectionStartTag(n, i, r), r;
                }
            case "audio":
                {
                    const i = t.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(r, null, "audio", {
                        src: i
                    });
                }
            case "simpleLine":
                return this.processAst(t.children, r), r;
            case "lineEnd":
                return r.push(t.allText), r;
            case "emptyLine":
                return this.options.preserveEmptyLines && r.push(t.allText), r;
            case "plainText":
            case "plainTextSpecialChars":
                return r.push(t.allText), r;
            default:
                return this.processAst(t.children, r), r;
        }
    }
}
class $914aec8743edd630$var$E9 extends $914aec8743edd630$var$cr {
    constructor(t){
        super(t), this.options = t, this.modifierKeyToSsmlTagMappings.emphasis = null, this.modifierKeyToSsmlTagMappings.address = null, this.modifierKeyToSsmlTagMappings.number = "say-as", this.modifierKeyToSsmlTagMappings.characters = "say-as", this.modifierKeyToSsmlTagMappings.expletive = null, this.modifierKeyToSsmlTagMappings.fraction = "say-as", this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.ordinal = "say-as", this.modifierKeyToSsmlTagMappings.telephone = null, this.modifierKeyToSsmlTagMappings.unit = null, this.modifierKeyToSsmlTagMappings.time = null, this.modifierKeyToSsmlTagMappings.date = null, this.modifierKeyToSsmlTagMappings.sub = "sub", this.modifierKeyToSsmlTagMappings.ipa = null, this.modifierKeyToSsmlTagMappings.rate = "prosody", this.modifierKeyToSsmlTagMappings.pitch = "prosody", this.modifierKeyToSsmlTagMappings.volume = "prosody", this.modifierKeyToSsmlTagMappings.whisper = "prosody";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(t) {
        let r = new $914aec8743edd630$var$Xe(this);
        for(let i = 0; i < t.children.length; i++){
            const n = t.children[i];
            switch(n.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    r.text = n.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let o = n.children[0].allText;
                        o = this.modifierKeyMappings[o] || o;
                        const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
                        switch(o){
                            // case 'emphasis': {
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject.tags[ssmlTag].attrs = { level: value || 'moderate' };
                            //   break;
                            // }
                            // case 'address':
                            // case 'expletive':
                            // case 'telephone':
                            // case 'unit':
                            case "fraction":
                            case "ordinal":
                                r.tag(a, {
                                    "interpret-as": o
                                });
                                break;
                            case "number":
                                r.tag(a, {
                                    "interpret-as": "cardinal"
                                });
                                break;
                            case "characters":
                                {
                                    let u = "digits";
                                    isNaN(r.text) && (u = "spell-out"), r.tag(a, {
                                        "interpret-as": u
                                    });
                                    break;
                                }
                            // case 'date': {
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'ymd' };
                            //   break;
                            // }
                            // case 'time': {
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'hms12' };
                            //   break;
                            // }
                            case "whisper":
                                r.tag(a, {
                                    volume: "x-soft",
                                    rate: "slow"
                                });
                                break;
                            // case 'ipa': {
                            //   // Google Assistant does not support <phoneme> tag
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject['textOnly'] = true;
                            //   break;
                            // }
                            case "sub":
                                r.tag(a, {
                                    alias: s
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const u = {};
                                    u[o] = s || "medium", r.tag(a, u, !0);
                                    break;
                                }
                        }
                        break;
                    }
            }
        }
        return r;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(t, r = []) {
        switch(t.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Samsung Bixby", r), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "shortBreak":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = t.children[0].allText;
                    let n = {};
                    switch(t.children[0].children[0].name){
                        case "breakStrengthValue":
                            n = {
                                strength: i
                            };
                            break;
                        case "time":
                            n = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(r, null, "break", n);
                }
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                {
                    const i = t.children[0].allText;
                    return i && r.push(i), r;
                }
            // case 'shortEmphasisStrong': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'strong' });
            // }
            // case 'shortEmphasisNone': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'none' });
            // }
            // case 'shortEmphasisReduced': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'reduced' });
            // }
            // case 'textModifier': {
            //   const tmo = this.getTextModifierObject(ast);
            //   if (tmo.textOnly) {
            //     // Quick return if tag is not supported
            //     lines.push(tmo.text)
            //     return lines
            //   }
            //   const tagsSortedDesc = Object.keys(tmo.tags).sort((a: any, b: any) => { return tmo.tags[b].sortId - tmo.tags[a].sortId });
            //   let inner = tmo.text;
            //   for (let index = 0; index < tagsSortedDesc.length; index++) {
            //     const tag = tagsSortedDesc[index];
            //     const attrs = tmo.tags[tag].attrs;
            //     inner = this.getTagWithAttrs(inner, tag, attrs);
            //   }
            //   lines.push(inner);
            //   return lines;
            // }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(t);
                    if (i.textOnly) return r.push(i.text), r;
                    const n = Object.keys(i.tags).sort((s, a)=>i.tags[a].sortId - i.tags[s].sortId);
                    let o = i.text;
                    for(let s = 0; s < n.length; s++){
                        const a = n[s], u = i.tags[a].attrs;
                        o = this.getTagWithAttrs(o, a, u);
                    }
                    return r.push(o), r;
                }
            case "audio":
                {
                    const i = t.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(r, null, "audio", {
                        src: i
                    }, !0);
                }
            case "simpleLine":
                return this.processAst(t.children, r), r;
            case "lineEnd":
                return r.push(t.allText), r;
            case "emptyLine":
                return this.options.preserveEmptyLines && r.push(t.allText), r;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                return r.push(t.allText), r;
            default:
                return this.processAst(t.children, r), r;
        }
    }
}
class $914aec8743edd630$var$A9 extends $914aec8743edd630$var$cr {
    constructor(t){
        super(t), this.options = t, this.modifierKeyToSsmlTagMappings.emphasis = "emphasis", this.modifierKeyToSsmlTagMappings.address = "say-as", this.modifierKeyToSsmlTagMappings.number = "say-as", this.modifierKeyToSsmlTagMappings.characters = "say-as", this.modifierKeyToSsmlTagMappings.expletive = null, this.modifierKeyToSsmlTagMappings.fraction = "say-as", this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.ordinal = "say-as", this.modifierKeyToSsmlTagMappings.telephone = "say-as", this.modifierKeyToSsmlTagMappings.unit = null, this.modifierKeyToSsmlTagMappings.time = "say-as", this.modifierKeyToSsmlTagMappings.date = "say-as", this.modifierKeyToSsmlTagMappings.sub = "sub", this.modifierKeyToSsmlTagMappings.paragraph = "p", this.modifierKeyToSsmlTagMappings.sentence = "s", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.voice = "voice", this.modifierKeyToSsmlTagMappings.ipa = "phoneme", this.modifierKeyToSsmlTagMappings.sapi = "phoneme", this.modifierKeyToSsmlTagMappings.ups = "phoneme", this.modifierKeyToSsmlTagMappings.pitch = "prosody", this.modifierKeyToSsmlTagMappings.contour = "prosody", this.modifierKeyToSsmlTagMappings.range = "prosody", this.modifierKeyToSsmlTagMappings.rate = "prosody", this.modifierKeyToSsmlTagMappings.volume = "prosody", this.modifierKeyToSsmlTagMappings.whisper = "prosody", this.modifierKeyToSsmlTagMappings.emotion = "mstts:express-as", this.ssmlTagSortOrder = [
            "voice",
            "lang",
            "p",
            "s",
            "emphasis",
            "say-as",
            "mstts:express-as",
            "prosody",
            "sub",
            "phoneme"
        ];
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(t) {
        let r = new $914aec8743edd630$var$Xe(this);
        for(let i = 0; i < t.children.length; i++){
            const n = t.children[i];
            switch(n.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    r.text = n.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let o = n.children[0].allText;
                        o = this.modifierKeyMappings[o] || o;
                        const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
                        switch(o){
                            case "address":
                            case "fraction":
                            case "ordinal":
                            case "telephone":
                                r.tag(a, {
                                    "interpret-as": o
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "number":
                                r.tag(a, {
                                    "interpret-as": "cardinal"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "characters":
                                {
                                    let u = "digits";
                                    isNaN(r.text) && (u = "characters"), r.tag(a, {
                                        "interpret-as": u
                                    }, !1, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "date":
                                r.tag(a, {
                                    "interpret-as": o,
                                    format: s || "ymd"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "time":
                                r.tag(a, {
                                    "interpret-as": o,
                                    format: s || "hms12"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "whisper":
                                r.tag(a, {
                                    volume: "x-soft",
                                    rate: "slow"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "ipa":
                            case "sapi":
                            case "ups":
                                r.tag(a, {
                                    alphabet: o,
                                    ph: s
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "sub":
                                r.tag(a, {
                                    alias: s
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const u = {};
                                    u[o] = s || "medium", r.tag(a, u, !0, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "lang":
                                r.tag(a, {
                                    "xml:lang": s
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "voice":
                                {
                                    const u = this.sentenceCase(s || "device");
                                    u != "Device" && r.tag(a, {
                                        name: u
                                    }, !1, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "emotion":
                                {
                                    const u = s.split(" "), l = {};
                                    switch(u.length){
                                        case 2:
                                            const c = parseInt(u[1]);
                                            isNaN(c) ? l.role = u[1] : l.styledegree = u[1];
                                        case 1:
                                            l.style = u[0];
                                            break;
                                    }
                                    r.tag(a, l, !0, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "emphasis":
                                r.tag(a, {
                                    level: s
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "paragraph":
                                r.tag(a, null, !1, this.ssmlTagSortOrder);
                                break;
                            case "sentence":
                                r.tag(a, null, !1, this.ssmlTagSortOrder);
                                break;
                        }
                        break;
                    }
            }
        }
        return r;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(t) {
        let r = new $914aec8743edd630$var$Xe(this);
        for(let i = 0; i < t.children.length; i++){
            const n = t.children[i];
            if (n.name === "sectionModifierKeyOptionalValue") {
                let o = n.children[0].allText;
                const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
                switch(o){
                    case "voice":
                        {
                            const u = this.sentenceCase(s || "device");
                            u != "Device" && r.tag(a, {
                                name: u
                            }, !1, this.ssmlTagSortOrder);
                            break;
                        }
                    case "defaults":
                        break;
                    case "emotion":
                        r.tag(a, {
                            style: s
                        }, !1, this.ssmlTagSortOrder);
                        break;
                }
            }
        }
        return r;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(t, r = []) {
        switch(t.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Microsoft Azure", r), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
            case "shortBreak":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = t.children[0].allText;
                    let n = {};
                    switch(t.children[0].children[0].name){
                        case "breakStrengthValue":
                            n = {
                                strength: i
                            };
                            break;
                        case "time":
                            n = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(r, null, "break", n);
                }
            case "silence":
                {
                    const i = t.children[0].allText.split(" "), n = {
                        type: i[0],
                        value: i[1]
                    };
                    return this.addTagWithAttrs(r, null, "mstts:silence", n);
                }
            case "backgroundAudio":
                {
                    const i = t.children[0].allText.split(" ");
                    let n = {};
                    const o = [
                        "src",
                        "volume",
                        "fadein",
                        "fadeout"
                    ];
                    for(let s = 0; s < i.length; s++)n[o[s]] = i[s];
                    return this.addTagWithAttrs(r, null, "mstts:backgroundaudio", n);
                }
            case "lexicon":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, null, "lexicon", {
                        uri: i
                    });
                }
            case "bookmark":
                {
                    const i = t.children[0].allText;
                    return this.addTagWithAttrs(r, null, "bookmark", {
                        mark: i
                    });
                }
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                {
                    const i = t.children[0].allText;
                    return i && r.push(i), r;
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(t), n = Object.keys(i.tags).sort((s, a)=>i.tags[a].sortId - i.tags[s].sortId);
                    let o = i.text;
                    for(let s = 0; s < n.length; s++){
                        const a = n[s], u = i.tags[a].attrs;
                        if (a === "voice" || a === "lang") {
                            const l = s < n.length - 1 ? n[s + 1] : "";
                            o = this.getVoiceOrLangTagWithAttrs(o, a, u, l);
                        } else o = this.getTagWithAttrs(o, a, u);
                    }
                    return r.push(o), r;
                }
            case "audio":
                {
                    const i = t.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(r, null, "audio", {
                        src: i
                    }, !1);
                }
            case "simpleLine":
                return this.processAst(t.children, r), r;
            case "lineEnd":
                return r.push(t.allText), r;
            case "emptyLine":
                return this.options.preserveEmptyLines && r.push(t.allText), r;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                return r.push(t.allText), r;
            case "section":
                {
                    const i = this.getSectionObject(t), n = Object.keys(i.tags).sort((o, s)=>i.tags[o].sortId - i.tags[s].sortId);
                    return this.addSectionEndTag(r), this.addSectionStartTag(n, i, r), r;
                }
            default:
                return this.processAst(t.children, r), r;
        }
    }
    getVoiceOrLangTagWithAttrs(t, r, i, n) {
        let o = [];
        return t ? (o.push(this.startVoiceOrLangTag(r, i, n)), o.push(t), o.push(this.endVoiceOrLangTag(r, !1, n))) : o.push(this.voidTag(r, i)), o.join("");
    }
    // Returns the SSML for a start tag
    startVoiceOrLangTag(t, r, i, n = !1) {
        let o = "", s = "";
        switch(t){
            case "voice":
                this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice && (s = "</voice>", this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (s = "</lang>" + s));
                break;
            case "lang":
                i && i === "voice" || this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (s = "</lang>");
                break;
        }
        return r && (o = " " + Object.keys(r).map((a)=>a + '="' + r[a] + '"').join(" ")), s + "<" + t + o + ">" + (n ? `
` : "");
    }
    // Returns the SSML for an end tag
    endVoiceOrLangTag(t, r = !1, i) {
        let n = "";
        switch(t){
            case "voice":
                this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice && (n = `<voice name="${this.options.globalVoiceAndLang.voice}">`, this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (n += `<lang xml:lang="${this.options.globalVoiceAndLang.lang}">`));
                break;
            case "lang":
                i && i === "voice" || this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && t === "lang" && (n = `<lang xml:lang="${this.options.globalVoiceAndLang.lang}">`);
                break;
        }
        return (r ? `
` : "") + "</" + t + ">" + n;
    }
}
function $914aec8743edd630$var$T9(e) {
    switch(e.platform){
        case "amazon-alexa":
            return new $914aec8743edd630$var$_9(e);
        case "amazon-polly":
            return new $914aec8743edd630$var$k9(e);
        case "amazon-polly-neural":
            return new $914aec8743edd630$var$x9(e);
        case "google-assistant":
            return new $914aec8743edd630$var$S9(e);
        case "samsung-bixby":
            return new $914aec8743edd630$var$E9(e);
        case "microsoft-azure":
            return new $914aec8743edd630$var$A9(e);
        default:
            return new $914aec8743edd630$var$Ob(e);
    }
}
function $914aec8743edd630$var$C9(e) {
    return new $914aec8743edd630$var$Ob(e);
}
var $914aec8743edd630$var$In = {
    exports: {}
}, $914aec8743edd630$var$q0 = $914aec8743edd630$var$In.exports, $914aec8743edd630$var$z0;
function $914aec8743edd630$var$R9() {
    return $914aec8743edd630$var$z0 || ($914aec8743edd630$var$z0 = 1, function(e, t) {
        var r = $914aec8743edd630$var$q0 && $914aec8743edd630$var$q0.__extends || function(n, o) {
            for(var s in o)o.hasOwnProperty(s) && (n[s] = o[s]);
            function a() {
                this.constructor = n;
            }
            n.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
        }, i;
        (function(n) {
            var o = function(q) {
                r(z, q);
                function z(ne) {
                    q.call(this, ne), this.type = "ParserError";
                }
                return z;
            }(Error);
            n.ParserError = o, n.grammars = {}, n.allRules = {}, n.parsers = {};
            var s = function() {
                function q(z, ne) {
                    this.input = z, this.index = ne, this.lineNum = 0, this.colNum = 0, this.lineStart = 0, this.lineEnd = 0;
                    for(var fe = 0, ce = 1, _e = 0; _e < this.index; ++_e)this.input.charCodeAt(_e) == 13 && (this.lineStart = _e, fe++), this.input.charCodeAt(_e) == 10 && (this.lineStart = _e, ce++);
                    for(this.lineEnd = this.index; this.lineEnd < this.input.length && !(this.input.charCodeAt(this.lineEnd) == 13 || this.input.charCodeAt(this.lineEnd) == 10); ++this.lineEnd);
                    this.lineNum = fe > ce ? fe : ce, this.colNum = this.index - this.lineStart, this.lineText = this.input.substring(this.lineStart, this.lineEnd), this.pointerText = Array(this.colNum).join(" ") + "^";
                }
                return q.prototype.toString = function() {
                    return "Index " + this.index + ", Line " + this.lineNum + ", Column " + this.colNum + `
` + this.lineText + `
` + this.pointerText;
                }, q;
            }();
            n.ParseLocation = s;
            var a = function() {
                function q(z, ne, fe) {
                    this.input = z, this.index = ne, this.nodes = fe, this.length = 0, this.rules = [], this.length = this.input.length;
                }
                return Object.defineProperty(q.prototype, "location", {
                    // Returns an object that representation of the location. 
                    get: function() {
                        return new s(this.input, this.index);
                    },
                    enumerable: !0,
                    configurable: !0
                }), q;
            }();
            n.ParseState = a;
            var u = function() {
                function q(z, ne, fe, ce) {
                    fe === void 0 && (fe = 0), ce === void 0 && (ce = -1), this.rule = z, this.input = ne, this.start = fe, this.end = ce, this.children = null;
                }
                return Object.defineProperty(q.prototype, "name", {
                    // Returns the name of the rule associated with this node
                    get: function() {
                        return this.rule != null ? this.rule.name : "unnamed";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "fullName", {
                    // Returns the name of the rule, preceded by the grammar name, associated with this node
                    get: function() {
                        return this.rule != null ? this.rule.fullName : "unnamed";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "allText", {
                    // Returns the parsed text associated with this node's start and end locations  
                    get: function() {
                        return this.input.slice(this.start, this.end);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "isLeaf", {
                    // Returns true if this node has no children
                    get: function() {
                        return this.children == null || this.children.length == 0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), q.prototype.child = function(z) {
                    if (this.children) for(var ne = 0, fe = this.children; ne < fe.length; ne++){
                        var ce = fe[ne];
                        if (ce.name == z) return ce;
                    }
                    return null;
                }, Object.defineProperty(q.prototype, "_firstChildStart", {
                    // The position of the first child, or the end position for the entire node if no children 
                    get: function() {
                        return this.isLeaf ? this.end : this.children[0].start;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "_lastChildEnd", {
                    // The end position of the last child, or the end position for the entire node if no children 
                    get: function() {
                        return this.isLeaf ? this.end : this.children[0].end;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "beforeChildrenText", {
                    // Returns the text before the children, or if no children returns the entire text. 
                    get: function() {
                        return this.input.slice(this.start, this._firstChildStart);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "afterChildrenText", {
                    // Returns the text after the children, or if no children returns the empty string.
                    get: function() {
                        return this.input.slice(this._lastChildEnd, this.end);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "allChildrenText", {
                    // Returns the text from the beginning of the first child to the end of the last child.
                    get: function() {
                        return this.input.slice(this._firstChildStart, this._lastChildEnd);
                    },
                    enumerable: !0,
                    configurable: !0
                }), q.prototype.toString = function() {
                    var z = this.isLeaf ? this.allText : this.children.map(function(ne) {
                        return ne.toString();
                    }).join(" ");
                    return "(" + this.rule.name + ": " + z + ")";
                }, q;
            }();
            n.AstNode = u;
            var l = function() {
                function q(z) {
                    this.rules = z, this.name = "", this.grammarName = "", this.type = "", this.className = "Rule", this._createAstNode = !1, this.parser = null, this.lexer = null;
                }
                return q.prototype.node = function(z) {
                    z === void 0 && (z = "");
                    for(var ne = [], fe = 1; fe < arguments.length; fe++)ne[fe - 1] = arguments[fe];
                    var ce = new u(this, z, 0, z.length);
                    return ce.children = ne, ce;
                }, q.prototype.parse = function(z) {
                    return n.parse(this, z);
                }, q.prototype.setName = function(z, ne) {
                    return this.grammarName = z, this.name = ne, this;
                }, Object.defineProperty(q.prototype, "definition", {
                    // Returns a default definition of the rule
                    get: function() {
                        return this.className + "(" + this.rules.map(function(z) {
                            return z.toString();
                        }).join(", ") + ")";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "fullName", {
                    // Returns the name of the rule preceded by the grammar name and a "."
                    get: function() {
                        return this.grammarName + "." + this.name;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "nameOrDefinition", {
                    // Returns either the name of the rule, or it's definition
                    get: function() {
                        return this.name ? this.fullName : this.definition;
                    },
                    enumerable: !0,
                    configurable: !0
                }), q.prototype.toString = function() {
                    return this.nameOrDefinition;
                }, Object.defineProperty(q.prototype, "firstChild", {
                    // Returns the first child rule
                    get: function() {
                        return this.rules[0];
                    },
                    enumerable: !0,
                    configurable: !0
                }), q.prototype.setType = function(z) {
                    return this.type = z, this;
                }, q.prototype.cloneImplementation = function() {
                    throw new Error("Missing override for cloneImplementation");
                }, Object.defineProperty(q.prototype, "copy", {
                    // Returns a copy of this rule with all fields copied.  
                    get: function() {
                        var z = this.cloneImplementation();
                        if (typeof z != typeof this) throw new Error("Error in implementation of cloneImplementation: not returning object of correct type");
                        return z.name = this.name, z.grammarName = this.grammarName, z._createAstNode = this._createAstNode, z;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "hasAstChildRule", {
                    // Returns true if any of the child rules are "ast rules" meaning they create nodes in the parse tree.
                    get: function() {
                        return this.rules.filter(function(z) {
                            return z.createsAstNode;
                        }).length > 0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "createsAstNode", {
                    // Returns true if this rule when parsed successfully will create a node in the parse tree. 
                    // Some rules will override this function. 
                    get: function() {
                        return this._createAstNode;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "nonAdvancing", {
                    // Returns true if this rule doesn't advance the input
                    get: function() {
                        return !1;
                    },
                    enumerable: !0,
                    configurable: !0
                }), q.prototype.astRuleDefn = function(z, ne) {
                    z === void 0 && (z = !1), ne === void 0 && (ne = !1);
                    var fe = this.rules.filter(function(Se) {
                        return Se.createsAstNode;
                    });
                    if (!fe.length) return this.name;
                    if (fe.length == 1) {
                        var ce = fe[0].astRuleNameOrDefn(z, ne);
                        return this instanceof f && (ce += "[" + this.min + "," + this.max + "]"), ce;
                    }
                    if (this instanceof d) {
                        var _e = fe.map(function(Se) {
                            return Se.astRuleNameOrDefn(!0, !1);
                        }).join(",");
                        return z ? _e : "seq(" + _e + ")";
                    }
                    if (this instanceof h) {
                        var _e = fe.map(function(Pe) {
                            return Pe.astRuleNameOrDefn(!1, !0);
                        }).join(",");
                        return ne ? _e : "choice(" + _e + ")";
                    }
                    throw new Error("Internal error: not a valid AST rule");
                }, q.prototype.astRuleNameOrDefn = function(z, ne) {
                    return z === void 0 && (z = !1), ne === void 0 && (ne = !1), this._createAstNode ? this.name : this.astRuleDefn(z, ne);
                }, Object.defineProperty(q.prototype, "opt", {
                    //======================================================
                    // Extensions to support method/property chaining. 
                    // This is also known as a fluent API syntax
                    get: function() {
                        return U(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "zeroOrMore", {
                    get: function() {
                        return X(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "oneOrMore", {
                    get: function() {
                        return N(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "at", {
                    get: function() {
                        return R(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "not", {
                    get: function() {
                        return P(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "advance", {
                    get: function() {
                        return this.then(n.advance);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "ws", {
                    get: function() {
                        return this.then(n.ws);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "all", {
                    get: function() {
                        return this.then(n.all);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "end", {
                    get: function() {
                        return this.then(n.end);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "assert", {
                    get: function() {
                        return Y(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(q.prototype, "ast", {
                    get: function() {
                        return new c(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), q.prototype.then = function(z) {
                    return H(this, z);
                }, q.prototype.thenAt = function(z) {
                    return this.then(R(z));
                }, q.prototype.thenNot = function(z) {
                    return this.then(P(z));
                }, q.prototype.or = function(z) {
                    return J(this, z);
                }, q.prototype.until = function(z) {
                    return Re(this, z);
                }, q.prototype.untilPast = function(z) {
                    return te(this, z);
                }, q.prototype.repeat = function(z) {
                    return G(this, z);
                }, q.prototype.quantified = function(z, ne) {
                    return V(this, z, ne);
                }, q.prototype.delimited = function(z) {
                    return we(this, z);
                }, q.prototype.unless = function(z) {
                    return ve(this, z);
                }, q;
            }();
            n.Rule = l;
            var c = function(q) {
                r(z, q);
                function z(ne) {
                    var fe = this;
                    q.call(this, [
                        ne
                    ]), this.r = ne, this.type = "ast", this.className = "AstRule", this._createAstNode = !0, this.parser = function(ce) {
                        var _e = ce.index, Se = ce.nodes;
                        if (ce.nodes = [], ce.rules.push(fe), ne.parser(ce)) {
                            ce.rules.pop();
                            var Pe = new u(fe, ce.input, _e, ce.index);
                            return Pe.children = ce.nodes, ce.nodes = Se, ce.nodes.push(Pe), !0;
                        } else return ce.rules.pop(), ce.nodes = Se, ce.index = _e, !1;
                    }, this.lexer = ne.lexer;
                }
                return z;
            }(l);
            n.AstRule = c;
            var d = function(q) {
                r(z, q);
                function z(ne, fe) {
                    q.call(this, [
                        ne,
                        fe
                    ]), this.rule1 = ne, this.rule2 = fe, this.type = "seq", this.className = "Sequence", this.parser = function(ce) {
                        var _e = ce.nodes.length, Se = ce.index;
                        return ne.parser(ce) === !1 ? !1 : fe.parser(ce) === !1 ? (ce.nodes.length !== _e && ce.nodes.splice(-1, ce.nodes.length - _e), ce.index = Se, !1) : !0;
                    }, this.lexer = function(ce) {
                        var _e = ce.index;
                        return ne.lexer(ce) === !1 ? !1 : fe.lexer(ce) === !1 ? (ce.index = _e, !1) : !0;
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        var ne = this.rules.map(function(fe) {
                            return fe.toString();
                        }).join(" ");
                        return this.rules.length > 1 && (ne = "(" + ne + ")"), ne;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(z.prototype, "nonAdvancing", {
                    get: function() {
                        return this.rules.every(function(ne) {
                            return ne.nonAdvancing;
                        });
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(z.prototype, "createsAstNode", {
                    get: function() {
                        return this._createAstNode || this.hasAstChildRule;
                    },
                    enumerable: !0,
                    configurable: !0
                }), z.prototype.cloneImplementation = function() {
                    return new z(this.rule1, this.rule2);
                }, z;
            }(l);
            n.Sequence = d;
            var h = function(q) {
                r(z, q);
                function z(ne, fe) {
                    q.call(this, [
                        ne,
                        fe
                    ]), this.rule1 = ne, this.rule2 = fe, this.type = "choice", this.className = "Choice", this.parser = function(ce) {
                        return ne.parser(ce) || fe.parser(ce);
                    }, this.lexer = function(ce) {
                        return ne.lexer(ce) || fe.lexer(ce);
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        var ne = this.rules.map(function(fe) {
                            return fe.toString();
                        }).join(" / ");
                        return this.rules.length > 1 && (ne = "(" + ne + ")"), ne;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(z.prototype, "nonAdvancing", {
                    get: function() {
                        return this.rules.every(function(ne) {
                            return ne.nonAdvancing;
                        });
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(z.prototype, "createsAstNode", {
                    get: function() {
                        return this._createAstNode || this.hasAstChildRule;
                    },
                    enumerable: !0,
                    configurable: !0
                }), z.prototype.cloneImplementation = function() {
                    return new z(this.rule1, this.rule2);
                }, z;
            }(l);
            n.Choice = h;
            var f = function(q) {
                r(z, q);
                function z(ne, fe, ce) {
                    var _e = this;
                    if (fe === void 0 && (fe = 0), ce === void 0 && (ce = 1 / 0), q.call(this, [
                        ne
                    ]), this.min = fe, this.max = ce, this.type = "quantified", this.className = "Quantified", ce === 1 / 0 && ne.nonAdvancing) throw new Error("Rule would create an infinite loop");
                    this.parser = function(Se) {
                        for(var Pe = Se.nodes.length, ze = Se.index, dt = 0; dt < ce; ++dt){
                            if (ne.parser(Se) === !1) return dt >= fe ? !0 : (Se.nodes.length !== Pe && Se.nodes.splice(-1, Se.nodes.length - Pe), Se.index = ze, !1);
                            pi(ce !== 1 / 0 || Se.index !== ze, _e);
                        }
                        return !0;
                    }, this.lexer = function(Se) {
                        for(var Pe = Se.index, ze = 0; ze < ce; ++ze){
                            if (ne.lexer(Se) === !1) return ze >= fe ? !0 : (Se.index = Pe, !1);
                            pi(ce !== 1 / 0 || Se.index !== Pe, _e, "Infinite loop");
                        }
                        return !0;
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(z.prototype, "definition", {
                    // Used for creating a human readable definition of the grammar.
                    get: function() {
                        return this.min == 0 && this.max == 1 ? this.firstChild.toString() + "?" : this.min == 0 && this.max == 1 / 0 ? this.firstChild.toString() + "*" : this.min == 1 && this.max == 1 / 0 ? this.firstChild.toString() + "+" : this.firstChild.toString() + "{" + this.min + "," + this.max + "}";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(z.prototype, "createsAstNode", {
                    get: function() {
                        return this._createAstNode || this.hasAstChildRule;
                    },
                    enumerable: !0,
                    configurable: !0
                }), z.prototype.cloneImplementation = function() {
                    return new z(this.firstChild, this.min, this.max);
                }, z;
            }(l);
            n.Quantified = f;
            var p = function(q) {
                r(z, q);
                function z(ne) {
                    q.call(this, ne, 0, 1), this.type = "optional", this.className = "Optional", this.parser = function(fe) {
                        return ne.parser(fe), !0;
                    }, this.lexer = function(fe) {
                        return ne.lexer(fe), !0;
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(z.prototype, "definition", {
                    // Used for creating a human readable definition of the grammar.
                    get: function() {
                        return this.firstChild.toString() + "?";
                    },
                    enumerable: !0,
                    configurable: !0
                }), z.prototype.cloneImplementation = function() {
                    return new z(this.firstChild);
                }, z;
            }(f);
            n.Optional = p;
            var m = function(q) {
                r(z, q);
                function z() {
                    q.call(this, []), this.type = "advance", this.className = "Advance", this.lexer = function(ne) {
                        return ne.index < ne.length ? ++ne.index >= 0 : !1;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        return "<advance>";
                    },
                    enumerable: !0,
                    configurable: !0
                }), z.prototype.cloneImplementation = function() {
                    return new z();
                }, z;
            }(l);
            n.Advance = m;
            var w = function(q) {
                r(z, q);
                function z(ne) {
                    q.call(this, [
                        ne
                    ]), this.type = "advanceIf", this.className = "AdvanceIf", this.lexer = function(fe) {
                        return ne.lexer(fe) && fe.index < fe.length ? ++fe.index !== 0 : !1;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        return "advanceIf(" + this.firstChild.toString() + ")";
                    },
                    enumerable: !0,
                    configurable: !0
                }), z.prototype.cloneImplementation = function() {
                    return new z(this.firstChild);
                }, z;
            }(l);
            n.AdvanceIf = w;
            var v = function(q) {
                r(z, q);
                function z(ne) {
                    q.call(this, []), this.text = ne, this.type = "text", this.className = "Text";
                    for(var fe = ne.length, ce = [], _e = 0; _e < fe; ++_e)ce.push(ne.charCodeAt(_e));
                    this.lexer = function(Se) {
                        var Pe = Se.index;
                        if (Pe + ce.length > Se.input.length) return !1;
                        for(var ze = 0, dt = ce; ze < dt.length; ze++){
                            var mi = dt[ze];
                            if (Se.input.charCodeAt(Pe++) !== mi) return !1;
                        }
                        return Se.index = Pe, !0;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        return '"' + bn(this.text) + '"';
                    },
                    enumerable: !0,
                    configurable: !0
                }), z.prototype.cloneImplementation = function() {
                    return new z(this.text);
                }, z;
            }(l);
            n.Text = v;
            var g = function(q) {
                r(z, q);
                function z(ne) {
                    q.call(this, []), this.text = ne, this.type = "anyCaseText", this.className = "AnyCaseText", ne = ne.toLowerCase(), this.text = ne;
                    for(var fe = ne.length, ce = [], _e = 0; _e < fe; ++_e)ce.push(ne[_e]);
                    this.lexer = function(Se) {
                        var Pe = Se.index;
                        if (Pe + ce.length > Se.input.length) return !1;
                        for(var ze = 0, dt = ce; ze < dt.length; ze++){
                            var mi = dt[ze];
                            if (Se.input[Pe++].toLowerCase() !== mi) return !1;
                        }
                        return Se.index = Pe, !0;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        return 'AnyCase("' + bn(this.text) + '")';
                    },
                    enumerable: !0,
                    configurable: !0
                }), z.prototype.cloneImplementation = function() {
                    return new z(this.text);
                }, z;
            }(l);
            n.AnyCaseText = g;
            var A = function(q) {
                r(z, q);
                function z(ne) {
                    q.call(this, []), this.fn = ne, this.type = "delay", this.className = "Delay";
                    var fe = null;
                    this.parser = function(_e) {
                        return (fe || (fe = ne().parser))(_e);
                    };
                    var ce = null;
                    this.lexer = function(_e) {
                        return (ce || (ce = ne().lexer))(_e);
                    };
                }
                return z.prototype.cloneImplementation = function() {
                    return new z(this.fn);
                }, Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        return "<delay>";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(z.prototype, "createsAstNode", {
                    // It is assumed that a delay function creates an AST node,
                    get: function() {
                        return !0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), z;
            }(l);
            n.Delay = A;
            var b = function(q) {
                r(z, q);
                function z(ne) {
                    q.call(this, ne), this.type = "charSet";
                }
                return Object.defineProperty(z.prototype, "nonAdvancing", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), z;
            }(l);
            n.NonAdvancingRule = b;
            var k = function(q) {
                r(z, q);
                function z(ne) {
                    q.call(this, []), this.chars = ne, this.type = "charSet", this.className = "CharSet";
                    for(var fe = [], ce = ne.length, _e = 0; _e < ce; ++_e)fe[_e] = ne.charCodeAt(_e);
                    this.lexer = function(Se) {
                        return fe.indexOf(Se.input.charCodeAt(Se.index)) >= 0;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        return "[" + bn(this.chars) + "]";
                    },
                    enumerable: !0,
                    configurable: !0
                }), z.prototype.cloneImplementation = function() {
                    return new z(this.chars);
                }, z;
            }(b);
            n.CharSet = k;
            var y = function(q) {
                r(z, q);
                function z(ne, fe) {
                    q.call(this, []), this.min = ne, this.max = fe, this.type = "charRange", this.className = "CharRange";
                    var ce = ne.charCodeAt(0), _e = fe.charCodeAt(0);
                    this.lexer = function(Se) {
                        var Pe = Se.input.charCodeAt(Se.index);
                        return Pe >= ce && Pe <= _e;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        return "[" + this.min + ".." + this.max + "]";
                    },
                    enumerable: !0,
                    configurable: !0
                }), z.prototype.cloneImplementation = function() {
                    return new z(this.min, this.max);
                }, z;
            }(b);
            n.CharRange = y;
            var x = function(q) {
                r(z, q);
                function z(ne) {
                    q.call(this, [
                        ne
                    ]), this.type = "not", this.className = "Not";
                    var fe = ne.lexer;
                    this.lexer = function(ce) {
                        if (ce.index >= ce.length) return !0;
                        var _e = ce.index;
                        return fe(ce) === !1 ? !0 : (ce.index = _e, !1);
                    }, this.parser = this.lexer;
                }
                return z.prototype.cloneImplementation = function() {
                    return new z(this.firstChild);
                }, Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        return "!" + this.firstChild.toString();
                    },
                    enumerable: !0,
                    configurable: !0
                }), z;
            }(b);
            n.Not = x;
            var C = function(q) {
                r(z, q);
                function z(ne) {
                    q.call(this, [
                        ne
                    ]), this.type = "at", this.className = "At";
                    var fe = ne.lexer;
                    this.lexer = function(ce) {
                        var _e = ce.index;
                        return fe(ce) === !1 ? !1 : (ce.index = _e, !0);
                    }, this.parser = this.lexer;
                }
                return z.prototype.cloneImplementation = function() {
                    return new z(this.firstChild);
                }, Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        return "&" + this.firstChild.toString();
                    },
                    enumerable: !0,
                    configurable: !0
                }), z;
            }(b);
            n.At = C;
            var I = function(q) {
                r(z, q);
                function z(ne) {
                    q.call(this, []), this.fn = ne, this.type = "predicate", this.className = "Predicate", this.lexer = ne, this.parser = this.lexer;
                }
                return z.prototype.cloneImplementation = function() {
                    return new z(this.fn);
                }, Object.defineProperty(z.prototype, "definition", {
                    get: function() {
                        return "<predicate>";
                    },
                    enumerable: !0,
                    configurable: !0
                }), z;
            }(b);
            n.Predicate = I;
            function M(q) {
                return new v(q);
            }
            n.text = M;
            function Q(q) {
                return new g(q);
            }
            n.textAnyCase = Q;
            function H() {
                for(var q = [], z = 0; z < arguments.length; z++)q[z - 0] = arguments[z];
                var ne = q.map(wt);
                if (ne.length == 0) throw new Error("At least one rule is expected when calling `seq`");
                if (ne.length == 1) return ne[0];
                var fe = ne[0], ce = H.apply(void 0, ne.slice(1));
                return fe.nonAdvancing && ce instanceof m ? new w(fe) : new d(fe, ce);
            }
            n.seq = H;
            function J() {
                for(var q = [], z = 0; z < arguments.length; z++)q[z - 0] = arguments[z];
                var ne = q.map(wt);
                if (ne.length == 0) throw new Error("At least one rule is expected when calling `choice`");
                if (ne.length == 1) return ne[0];
                var fe = ne[0], ce = J.apply(void 0, ne.slice(1));
                return fe instanceof w && ce instanceof w ? new w(J(fe.firstChild, ce.firstChild)) : new h(fe, ce);
            }
            n.choice = J;
            function W(q) {
                return new A(q);
            }
            n.delay = W;
            function P(q) {
                return new x(wt(q));
            }
            n.not = P;
            function R(q) {
                return new C(wt(q));
            }
            n.at = R;
            function V(q, z, ne) {
                return z === void 0 && (z = 0), ne === void 0 && (ne = 1 / 0), z === 0 && ne === 1 ? new p(wt(q)) : new f(wt(q), z, ne);
            }
            n.quantified = V;
            function X(q) {
                return V(q).setType("zeroOrMore");
            }
            n.zeroOrMore = X;
            function N(q) {
                return V(q, 1).setType("oneOrMore");
            }
            n.oneOrMore = N;
            function U(q) {
                return V(q, 0, 1).setType("optional");
            }
            n.opt = U;
            function G(q, z) {
                return V(q, z, z).setType("repeat");
            }
            n.repeat = G;
            function re(q) {
                return new k(q);
            }
            n.atChar = re;
            function oe(q) {
                return re(q).not;
            }
            n.notAtChar = oe;
            function ie(q) {
                return re(q).advance;
            }
            n.char = ie;
            function le(q) {
                return oe(q).advance;
            }
            n.notChar = le;
            function he(q, z) {
                return new y(q, z);
            }
            n.atRange = he;
            function ye(q, z) {
                return he(q, z).advance;
            }
            n.range = ye;
            function be(q, z) {
                return ye(q, z).not;
            }
            n.notRange = be;
            function we(q, z) {
                return U(H(q, H(z, q).zeroOrMore)).setType("delimitedList");
            }
            n.delimited = we;
            function ve(q, z) {
                return H(P(z), q).setType("unless");
            }
            n.unless = ve;
            function Re(q, z) {
                return ve(q, z).zeroOrMore.setType("repeatWhileNot");
            }
            n.repeatWhileNot = Re;
            function De(q, z) {
                return P(z).then(q).then(Re(q, z)).setType("repeatOneOrMoreWhileNot");
            }
            n.repeatOneOrMoreWhileNot = De;
            function te(q, z) {
                return Re(q, z).then(z).setType("repeatUntilPast");
            }
            n.repeatUntilPast = te;
            function Z(q, z) {
                return P(z).then(q).then(te(q, z)).setType("repeatOneOrMoreUntilPast");
            }
            n.repeatOneOrMoreUntilPast = Z;
            function ue(q) {
                return Re(n.advance, q).setType("advanceWhileNot");
            }
            n.advanceWhileNot = ue;
            function pe(q) {
                return De(n.advance, q).setType("advanceOneOrMoreWhileNot");
            }
            n.advanceOneOrMoreWhileNot = pe;
            function me(q) {
                return te(n.advance, q).setType("advanceUntilPast");
            }
            n.advanceUntilPast = me;
            function L(q) {
                return Z(n.advance, q).setType("advanceOneOrMoreUntilPast");
            }
            n.advanceOneOrMoreUntilPast = L;
            function B(q) {
                return n.advance.unless(q).setType("advanceUnless");
            }
            n.advanceUnless = B;
            function D(q) {
                return new I(q);
            }
            n.predicate = D;
            function E(q) {
                return D(function(z) {
                    return q(z), !0;
                }).setType("action");
            }
            n.action = E;
            function T(q) {
                return q === void 0 && (q = ""), E(function(z) {
                    console.log(q);
                }).setType("log");
            }
            n.log = T;
            function j(q) {
                return E(function(z) {
                    var ne = new o(q + `
` + z.location.toString());
                    throw ne;
                }).setType("err");
            }
            n.err = j;
            function Y(q) {
                return J(q, j("Expected: " + wt(q)));
            }
            n.assert = Y;
            function ae(q) {
                for(var z = [], ne = 1; ne < arguments.length; ne++)z[ne - 1] = arguments[ne];
                return H(q, H.apply(void 0, z.map(function(fe) {
                    return Y(fe);
                }))).setType("guardedSeq");
            }
            n.guardedSeq = ae;
            function se(q) {
                return ae('"', q, Y('"')).setType("doubleQuoted");
            }
            n.doubleQuoted = se;
            function O(q) {
                return se(J(q, le('"').zeroOrMore)).setType("doubleQuotedString");
            }
            n.doubleQuotedString = O;
            function _(q) {
                return ae("'", q, Y("'")).setType("singleQuoted");
            }
            n.singleQuoted = _;
            function S(q) {
                return _(J(q, le("'").zeroOrMore)).setType("singleQuotedString");
            }
            n.singleQuotedString = S;
            function F(q) {
                return ae("(", n.ws, q, n.ws, ")").setType("parenthesized");
            }
            n.parenthesized = F;
            function $(q) {
                return ae("{", n.ws, q, n.ws, "}").setType("braced");
            }
            n.braced = $;
            function K(q) {
                return ae("[", n.ws, q, n.ws, "]").setType("bracketed");
            }
            n.bracketed = K;
            function ee(q) {
                return ae("<", n.ws, q, n.ws, ">").setType("tagged");
            }
            n.tagged = ee;
            function de(q) {
                return H(q, P(n.identifierNext)).setType("keyword");
            }
            n.keyword = de;
            function ge(q) {
                return H(Q(q), P(n.identifierNext)).setType("keywordAnyCase");
            }
            n.keywordAnyCase = ge;
            function ke() {
                for(var q = [], z = 0; z < arguments.length; z++)q[z - 0] = arguments[z];
                return J.apply(void 0, q.map(de));
            }
            n.keywords = ke, n.truePredicate = new I(function(q) {
                return !0;
            }), n.falsePredicate = new I(function(q) {
                return !1;
            }), n.end = new I(function(q) {
                return q.index >= q.length;
            }), n.notEnd = new I(function(q) {
                return q.index < q.length;
            }), n.advance = new m(), n.all = n.advance.zeroOrMore, n.atLetterLower = he("a", "z"), n.atLetterUpper = he("A", "Z"), n.atLetter = J(n.atLetterLower, n.atLetterUpper), n.atDigit = he("0", "9"), n.atDigitNonZero = he("1", "9"), n.atHexDigit = J(n.atDigit, he("a", "f"), he("A", "F")), n.atBinaryDigit = re("01"), n.atOctalDigit = he("0", "7"), n.atAlphaNumeric = J(n.atLetter, n.atDigit), n.atUnderscore = re("_"), n.atSpace = re(" "), n.atTab = re("	"), n.atWs = re(` 	\r
\xa0\uFEFF`), n.atIdentifierNext = J(n.atAlphaNumeric, n.atUnderscore), n.letterLower = n.atLetterLower.advance, n.letterUpper = n.atLetterUpper.advance, n.letter = n.atLetter.advance, n.letters = n.letter.oneOrMore, n.digit = n.atDigit.advance, n.digitNonZero = n.atDigitNonZero.advance, n.digits = n.digit.oneOrMore, n.integer = ie("0").or(n.digits), n.hexDigit = n.atHexDigit.advance, n.binaryDigit = n.atBinaryDigit.advance, n.octalDigit = n.atOctalDigit.advance, n.alphaNumeric = n.atAlphaNumeric.advance, n.underscore = n.atUnderscore.advance, n.identifierFirst = J(n.atLetter, n.atUnderscore).advance, n.identifierNext = J(n.atAlphaNumeric, n.atUnderscore).advance, n.identifier = H(n.identifierFirst, n.identifierNext.zeroOrMore), n.hyphen = M("-"), n.crlf = M(`\r
`), n.newLine = J(n.crlf, `
`), n.space = M(" "), n.tab = M("	"), n.ws = n.atWs.advance.zeroOrMore;
            function Ee(q, z) {
                var ne = this.parse(q.ast.zeroOrMore, z);
                return ne ? ne.children : [];
            }
            n.tokenize = Ee;
            function xe(q, z) {
                var ne = new a(z, 0, []);
                return q instanceof c || (q = q.ast), q.parser(ne) && ne && ne.nodes ? ne.nodes[0] : null;
            }
            n.parse = xe;
            function tt(q) {
                return rt(q).filter(function(z) {
                    return z._createAstNode;
                });
            }
            n.grammarAstRules = tt;
            function rt(q) {
                return We().filter(function(z) {
                    return z.grammarName == q;
                });
            }
            n.grammarRules = rt;
            function We() {
                return Object.keys(n.allRules).sort().map(function(q) {
                    return n.allRules[q];
                });
            }
            n.allGrammarRules = We;
            function nt() {
                return Object.keys(n.grammars).sort();
            }
            n.grammarNames = nt;
            function Ut(q) {
                return rt(q).map(function(z) {
                    return z.fullName + " <- " + z.definition;
                }).join(`
`);
            }
            n.grammarToString = Ut;
            function Rt(q) {
                return tt(q).map(function(z) {
                    return z.name + " <- " + z.astRuleDefn();
                }).join(`
`);
            }
            n.astSchemaToString = Rt;
            function Vt(q, z, ne) {
                for(var fe in z)if (z[fe] instanceof l) {
                    var ce = z[fe];
                    ce.setName(q, fe), n.allRules[ce.fullName] = ce;
                }
                return n.grammars[q] = z, ne && (n.parsers[q] = function(_e) {
                    return xe(ne, _e);
                }), z;
            }
            n.registerGrammar = Vt;
            function bn(q) {
                var z = JSON.stringify(q);
                return z.slice(1, z.length - 1);
            }
            n.escapeChars = bn;
            function wt(q) {
                if (q instanceof l) return q;
                if (typeof q == "string") return M(q);
                if (typeof q == "boolean") return q ? n.truePredicate : n.falsePredicate;
                throw new Error("Invalid rule type: " + q);
            }
            n.RuleTypeToRule = wt;
            function pi(q, z, ne) {
                if (!q) throw new Error("Error occured while parsing rule: " + z.fullName + " " + (ne || ""));
            }
            n.debugAssert = pi, Vt("core", n, null);
        })(i = t.Myna || (t.Myna = {})), e.exports && (e.exports = i, e.exports.Myna = i);
    }($914aec8743edd630$var$In, $914aec8743edd630$var$In.exports)), $914aec8743edd630$var$In.exports;
}
var $914aec8743edd630$var$O9 = $914aec8743edd630$var$R9();
function $914aec8743edd630$var$D9(e) {
    const t = e;
    t.parenthesized = (i)=>t.seq("(", t.ws, i, t.ws, ")").setType("parenthesized");
    const r = new function() {
        const i = "[]()", n = "[]()*~`@#\\_!+-", o = t.char(" 	").oneOrMore;
        o.opt, o.or(t.newLine);
        const s = t.notChar(n).unless(t.newLine), a = t.notChar(i).unless(t.newLine);
        t.notChar('"'), this.xsdToken = t.choice(t.digits, t.letters, t.char(n)).oneOrMore.ast, this.plainText = t.choice(t.digits, t.letters, o, s).oneOrMore.ast, this.plainTextEmphasis = t.choice(t.digits, t.letters, o, s).oneOrMore.ast;
        const u = t.choice(t.digits, t.letters, o, a);
        this.plainTextModifier = u.oneOrMore.ast, this.plainTextPhone = t.seq(t.parenthesized(t.digits), u.oneOrMore).ast, this.plainTextSpecialChars = t.choice(t.seq("(", u, ") "), t.seq("[", u, "] "), t.choice(...n.split("")).oneOrMore).oneOrMore.ast, this.urlSpecialChar = t.char(":/.-_~?#[]@!+,;%=()&"), this.url = t.choice(t.digit, t.letter, this.urlSpecialChar).oneOrMore.ast, this.audio = t.seq("![", t.choice(t.singleQuoted(this.url), t.doubleQuoted(this.url)), "]").ast, this.timeUnit = t.choice("s", "ms").ast, this.fraction = t.seq(".", t.digit.zeroOrMore), this.number = t.seq(t.integer, this.fraction.opt).ast, this.time = t.seq(this.number, this.timeUnit).ast, this.shortBreak = t.seq("[", this.time, "]").ast, this.silenceTypeValue = t.choice("Leading", "Tailing", "Sentenceboundary").ast, this.silenceData = t.seq(this.silenceTypeValue, " ", this.time).ast, this.silence = t.seq("[", "silence", ":", t.choice(t.singleQuoted(this.silenceData), t.doubleQuoted(this.silenceData)), "]").ast, this.backgroundData = t.seq(" ", this.url), this.backgroundAudio = t.seq("[", "backgroundaudio", ":", t.choice(t.singleQuoted(t.seq(this.url, this.backgroundData.zeroOrMore).ast), t.doubleQuoted(t.seq(this.url, this.backgroundData.zeroOrMore).ast)), "]").ast, this.lexicon = t.seq("[", "lexicon", ":", t.choice(t.singleQuoted(this.url), t.doubleQuoted(this.url)), "]").ast, this.bookmarkChar = t.char(".-_"), this.bookmarkString = t.choice(t.digit, t.letter, this.bookmarkChar).oneOrMore.ast, this.bookmark = t.seq("[", "bookmark", ":", t.choice(t.singleQuoted(this.bookmarkString), t.doubleQuoted(this.bookmarkString)), "]").ast;
        const l = t.not(t.letters);
        this.shortEmphasisModerate = t.seq(l, "+", this.plainTextEmphasis, "+", l).ast, this.shortEmphasisStrong = t.seq(l, "++", this.plainTextEmphasis, "++", l).ast, this.shortEmphasisNone = t.seq(l, "~", this.plainTextEmphasis, "~", l).ast, this.shortEmphasisReduced = t.seq(l, "-", this.plainTextEmphasis, "-", l).ast, this.emphasis = t.choice(this.shortEmphasisModerate, this.shortEmphasisStrong, this.shortEmphasisNone, this.shortEmphasisReduced);
        const c = t.char(":").ws, d = t.char(";").ws;
        this.textModifierKey = t.keywords("emphasis", "address", "number", "cardinal", "characters", "chars", "digits", "drc", "expletive", "bleep", "fraction", "interjection", "ordinal", "telephone", "phone", "unit", "time", "date", "whisper", "ipa", "sapi", "ups", "sub", "vol", "volume", "rate", "pitch", "contour", "range", "timbre", "lang", "voice", "excited", "disappointed", "emotion", "paragraph", "sentence").ast;
        const h = [
            // Plosive
            "p",
            "b",
            "t",
            "d",
            "\u0288",
            "\u0256",
            "c",
            "\u025F",
            "k",
            "\u0261",
            "g",
            "q",
            "\u0262",
            "\u0294",
            // Nasal
            "m",
            "\u0271",
            "n",
            "\u0273",
            "\u0272",
            "\u014B",
            "\u0274",
            // Trill
            "\u0299",
            "r",
            "\u0280",
            // Tap or Flap
            "\u2C71",
            "\u027E",
            "\u027D",
            // Fricative
            "\u0278",
            "\u03B2",
            "f",
            "v",
            "\u03B8",
            "\xf0",
            "s",
            "z",
            "\u0283",
            "\u0292",
            "\u0282",
            "\u0290",
            "\xe7",
            "\u029D",
            "x",
            "\u0263",
            "\u03C7",
            "\u0281",
            "\u0127",
            "\u0295",
            "h",
            "\u0266",
            // Lateral fricative
            "\u026C",
            "\u026E",
            // Approximant
            "\u028B",
            "\u0279",
            "\u027B",
            "j",
            "\u0270",
            // Lateral approximant
            "l",
            "\u026D",
            "\u028E",
            "\u029F"
        ], f = [
            // Clicks
            "\u0298",
            "\u01C0",
            "\u01C3",
            "\u01C2",
            "\u01C1",
            // Voiced implosive
            "\u0253",
            "\u0257",
            "\u0284",
            "\u0260",
            "\u029B",
            // Ejectives (already existing chars + unicode char \u02BC)
            "\u02BC"
        ], p = [
            // Close
            "i",
            "y",
            "\u0268",
            "\u0289",
            "\u026F",
            "u",
            "\u026A",
            "\u028F",
            "\u028A",
            // Close-mid
            "e",
            "\xf8",
            "\u0258",
            "\u025A",
            "\u0275",
            "\u0264",
            "o",
            "\u0259",
            // Open-mid
            "\u025B",
            "\u0153",
            "\u025C",
            "\u025D",
            "\u025E",
            "\u028C",
            "\u0254",
            "\xe6",
            "\u0250",
            // Open
            "a",
            "\u0276",
            "\u0251",
            "\u0252"
        ], m = [
            "\u028D",
            "w",
            "\u0265",
            "\u029C",
            "\u02A2",
            "\u02A1",
            "\u0255",
            "\u0291",
            "\u027A",
            "\u0267",
            "\u0361",
            // char ͡
            "\u035C"
        ], w = [
            "\u0325",
            // char ̥
            "\u030A",
            // char ̊
            "\u032C",
            // char ̬
            "\u02B0",
            "\u0339",
            // char ̹
            "\u031C",
            // char ̜
            "\u031F",
            // char ̟
            "\u0320",
            // char ̠
            "\u0308",
            // char ̈
            "\u033D",
            // char ̽
            "\u0329",
            // char ̩
            "\u032F",
            // char ̯
            "\u02DE",
            // char ˞
            "\u0324",
            // char ̤
            "\u0330",
            // char ̰
            "\u033C",
            // char ̼
            "\u02B7",
            "\u02B2",
            "\u02E0",
            "\u02E4",
            "\u0334",
            // char ̴
            "\u031D",
            // char ̝
            "\u031E",
            // char ̞
            "\u0318",
            // char ̘
            "\u0319",
            // char ̙
            "\u032A",
            // char ̪
            "\u033A",
            // char ̺
            "\u033B",
            // char ̻
            "\u0303",
            //char ̃
            "\u207F",
            "\u02E1",
            "\u031A"
        ], v = [
            "\u02C8",
            "\u02CC",
            "\u02D0",
            "\u02D1",
            "\u0306",
            // char ̆
            "|",
            "\u2016",
            ".",
            "\u203F"
        ], g = [
            "\u030B",
            "\u0301",
            "\u0304",
            "\u0300",
            "\u030F",
            "\u2193",
            "\u2191",
            "\u2197",
            "\u2198",
            "\u030C",
            "\u0302"
        ], A = [
            "\xe0",
            "\xe8",
            "\xec",
            "\xf2",
            "\xf9",
            "\xc0",
            "\xc8",
            "\xcc",
            "\xd2",
            "\xd9",
            "\xe1",
            "\xe9",
            "\xed",
            "\xf3",
            "\xfa",
            "\xfd",
            "\xc1",
            "\xc9",
            "\xcd",
            "\xd3",
            "\xda",
            "\xdd",
            "\xe2",
            "\xea",
            "\xee",
            "\xf4",
            "\xfb",
            "\xc2",
            "\xca",
            "\xce",
            "\xd4",
            "\xdb",
            "\xe4",
            "\xeb",
            "\xef",
            "\xf6",
            "\xfc",
            "\xff",
            "\xc4",
            "\xcb",
            "\xcf",
            "\xd6",
            "\xdc",
            "\u0178",
            "\xe3",
            "\xf1",
            "\xf5",
            "\xc3",
            "\xd1",
            "\xd5",
            "\xe5",
            "\xc5"
        ], b = [
            "\u0269",
            "\u026B",
            "\u0277",
            "\u027C",
            "\u027F",
            "\u0285",
            "\u0286",
            "\u0287",
            "\u0293",
            "\u0296",
            "\u0297",
            "\u029A",
            "\u029E",
            "\u02A0",
            "\u02A3",
            "\u02A4",
            "\u02A5",
            "\u02A6",
            "\u02A7",
            "\u02A8",
            "\u02A9",
            "\u02AA",
            "\u02AB",
            "\u02AC",
            "\u02AD",
            "\u02AE",
            "\u02AF"
        ], k = [
            ...h,
            ...f,
            ...p,
            ...m,
            ...w,
            ...v,
            ...g,
            ...A,
            ...b
        ], y = [
            "+",
            t.hyphen,
            t.digit,
            "%"
        ];
        this.textModifierText = t.choice(t.digit, t.letter, t.hyphen, t.space, ...k, ...y).oneOrMore.ast, this.textModifierTextDoubleQuote = t.choice(t.digit, t.letter, t.hyphen, t.space, ...k, ...y, "'").oneOrMore.ast, this.textModifierValue = t.seq(c, t.choice(t.singleQuoted(this.textModifierText), t.doubleQuoted(this.textModifierTextDoubleQuote))), this.textModifierKeyOptionalValue = t.seq(this.textModifierKey, this.textModifierValue.opt).ast, this.modifier = t.bracketed(t.delimited(this.textModifierKeyOptionalValue.ws, d));
        const x = t.parenthesized(this.plainTextModifier), C = t.parenthesized(this.plainTextPhone);
        this.textModifier = t.seq(t.choice(x, C), this.modifier).ast, this.sectionModifierKey = t.keywords("lang", "voice", "defaults", "dj", "newscaster", "excited", "disappointed").ast, this.sectionModifierText = t.choice(t.digit, t.letter, t.hyphen).oneOrMore.ast, this.sectionModifierValue = t.seq(c, t.choice(t.singleQuoted(this.sectionModifierText), t.doubleQuoted(this.sectionModifierText))), this.sectionModifierKeyOptionalValue = t.seq(this.sectionModifierKey, this.sectionModifierValue.opt).ast, this.sectionModifier = t.bracketed(t.delimited(this.sectionModifierKeyOptionalValue.ws, d)), this.section = t.seq("#", this.sectionModifier).ast, this.valueNone = "none", this.valueXWeak = "x-weak", this.valueWeak = "weak", this.valueMedium = "medium", this.valueStrong = "strong", this.valueXStrong = "x-strong", this.breakStrengthValue = t.keywords(this.valueNone, this.valueXWeak, this.valueWeak, this.valueMedium, this.valueStrong, this.valueXStrong).ast, this.breakValue = t.choice(this.breakStrengthValue, this.time).ast, this.break = t.seq("[", "break", ":", t.choice(t.singleQuoted(this.breakValue), t.doubleQuoted(this.breakValue)), "]").ast, this.markTag = t.seq("[", "mark", ":", t.choice(t.singleQuoted(this.xsdToken), t.doubleQuoted(this.xsdToken)), "]").ast, this.any = t.advance, this.inline = t.choice(this.backgroundAudio, this.lexicon, this.bookmark, this.textModifier, this.emphasis, this.shortBreak, this.silence, this.break, this.audio, this.markTag, this.plainTextSpecialChars, this.plainText, this.any).unless(t.newLine), this.lineEnd = t.newLine.or(t.assert(t.end)).ast, this.emptyLine = t.char(" 	").zeroOrMore.then(t.newLine).ast, this.restOfLine = t.seq(this.inline.zeroOrMore).then(this.lineEnd), this.simpleLine = t.seq(this.emptyLine.not, t.notEnd, this.restOfLine).ast, this.paragraph = this.simpleLine.oneOrMore.ast, this.content = t.choice(this.section, this.paragraph, this.emptyLine), this.document = this.content.zeroOrMore.ast;
    }();
    return t.registerGrammar("speechmarkdown", r, r.document);
}
class $914aec8743edd630$var$P9 {
    constructor(){
        this.myna = $914aec8743edd630$var$O9.Myna, $914aec8743edd630$var$D9(this.myna), this.parser = this.myna.parsers.speechmarkdown;
    }
    parse(t) {
        return this.parser(t);
    }
}
class $914aec8743edd630$var$I9 {
    constructor(t){
        this.options = t, this.defaults = {
            includeFormatterComment: !1,
            includeParagraphTag: !1,
            includeSpeakTag: !0,
            platform: "",
            // default - text formatter
            preserveEmptyLines: !0
        }, this.options = {
            ...this.defaults,
            ...t
        };
    }
    get Parser() {
        return this.parser || (this.parser = new $914aec8743edd630$var$P9()), this.parser;
    }
    toText(t, r) {
        const i = {
            ...this.options,
            ...r
        }, n = this.Parser.parse(t);
        return $914aec8743edd630$var$C9(i).format(n);
    }
    toSSML(t, r) {
        const i = {
            ...this.options,
            ...r
        };
        let n = t;
        try {
            do {
                const c = this.Parser.parse(n);
                n = $914aec8743edd630$var$T9(i).format(c);
            }while (n.includes(")["));
            let o = "";
            if (n.includes("<mstts:backgroundaudio")) {
                const c = n.indexOf("<mstts:backgroundaudio"), d = n.substring(c).indexOf("/>") + 2;
                o = n.substring(c, d), n = n.replace(o, "");
            }
            let s = "", a = "";
            i.globalVoiceAndLang && i.globalVoiceAndLang.voice && (s = `<voice name="${i.globalVoiceAndLang.voice}">`, a = "</voice>");
            let u = "", l = "";
            return i.globalVoiceAndLang && i.globalVoiceAndLang.lang && (u = `<lang xml:lang="${i.globalVoiceAndLang.lang}">`, l = "</lang>"), `${o + s + u + n + l + a}`;
        } catch (o) {
            return console.log("Error : ", o), n;
        }
    }
    toAST(t) {
        return this.Parser.parse(t);
    }
    toASTString(t) {
        return this.Parser.parse(t).toString();
    }
}
const $914aec8743edd630$var$U0 = new $914aec8743edd630$var$I9(), $914aec8743edd630$var$Db = (e, t = [])=>{
    let r = "";
    if (e.indexOf("-") !== -1) {
        const i = [];
        for(let o = 0; o < e.length; o++)if (e[o] === "-") {
            let s = !0;
            t.forEach((a)=>{
                (o === a[0] || o === a[1] || o > a[0] && o < a[1]) && (s = !1);
            }), s && i.push(o);
        }
        let n = "";
        if (i.length > 0) {
            for(let o = 0; o < i.length; o++)n += o === 0 ? e.substring(0, i[o]) : e.substring(i[o - 1] + 1, i[o]), n += "1xx1";
            n += e.substring(i[i.length - 1] + 1);
        }
        r = $914aec8743edd630$var$U0.toText(n), r = r.replaceAll("1xx1", "-");
    } else r = $914aec8743edd630$var$U0.toText(e);
    return r = r.replaceAll(/<\/?phoneme?[^>]+>|$/g, ""), r;
}, $914aec8743edd630$var$M9 = (e)=>{
    const t = [];
    let r = e, i = [], n = e.indexOf(")[");
    for(; n !== -1;)i.push(n), n = e.indexOf(")[", n + 1);
    if (i.length > 0) for(let s = 0; s < i.length; s++){
        const a = $914aec8743edd630$var$j9(e, i[s]), u = e.substring(i[s]).indexOf("]") + i[s], l = {
            // Use string for replacement as : 'replacement1x1'
            replacementString: `replacement${s}x${s}`,
            speechMarkdown: e.substring(a, u + 1)
        };
        t.push(l), r = r.replace(l.speechMarkdown, l.replacementString);
    }
    i = [];
    const o = r;
    for(n = o.indexOf("]"); n !== -1;)i.push(n), n = o.indexOf("]", n + 1);
    if (i.length > 0) {
        for(let s = 0; s < i.length; s++)if (i[s] === o.length - 1 || o.charAt(i[s] + 1) !== "(") {
            const a = o.substring(0, i[s]).lastIndexOf("["), u = {
                // Use string for replacement as : 'pause1x1'
                replacementString: `pause${s}x${s}`,
                speechMarkdown: o.substring(a, i[s] + 1)
            };
            t.push(u), r = r.replace(u.speechMarkdown, u.replacementString);
        }
    }
    return {
        text: r,
        replacements: t
    };
}, $914aec8743edd630$var$j9 = (e, t)=>{
    let r = 0, i = 0;
    for(let n = t; n > 0; n--)if (e.charAt(n) === ")") i++;
    else if (e.charAt(n) === "(" && (r++, i === r)) return n;
    return 0;
}, $914aec8743edd630$var$F9 = /<\/?a([^>])+>/g, $914aec8743edd630$var$$9 = /<\/?img([^>])+>/g, $914aec8743edd630$var$Mu = (e, t)=>{
    const r = new $914aec8743edd630$var$Je({
        breaks: !0,
        html: !0,
        xhtmlOut: !0,
        typographer: !0,
        quotes: `""''`
    });
    let i = {
        images: [],
        urls: []
    };
    const n = $914aec8743edd630$var$M9(e);
    if (!t) {
        const u = r.parseInline(n.text);
        u.length && (i = $914aec8743edd630$var$B9(u[0].children));
    }
    const o = r.render(e), s = $914aec8743edd630$var$N9(o), a = [];
    return n.replacements.forEach((u)=>{
        const l = e.indexOf(u.speechMarkdown);
        a.push([
            l,
            l + u.speechMarkdown.length
        ]);
    }), {
        ...i,
        text: s,
        htmlText: $914aec8743edd630$var$L9(o, a)
    };
}, $914aec8743edd630$var$L9 = (e, t)=>{
    let r = e.replaceAll("&quot;", '"');
    return r = r.replaceAll("&lt;", "<"), r = r.replaceAll("&gt;", ">"), r = $914aec8743edd630$var$Db(r, t).replaceAll($914aec8743edd630$var$F9, ""), r = r.replaceAll($914aec8743edd630$var$$9, ""), r;
}, $914aec8743edd630$var$N9 = (e)=>{
    const t = document.createElement("div");
    return t.innerHTML = e, t.textContent && t.textContent !== "" ? t.textContent : "";
}, $914aec8743edd630$var$qr = (e, t)=>{
    const r = e == null ? void 0 : e.find((i)=>i.length > 1 && i[0] === t && i[1] !== "");
    return r && r.length > 1 ? r[1] : t === "href" ? void 0 : "";
}, $914aec8743edd630$var$B9 = (e)=>{
    var i;
    const t = [], r = [];
    if (e != null && e.length) for(let n = 0; n < e.length; n++){
        const o = e[n].attrs;
        switch(e[n].type){
            case "link_open":
                {
                    const s = $914aec8743edd630$var$qr(o, "href");
                    if (s && !r.find((a)=>a.url === s)) {
                        const a = $914aec8743edd630$var$qr(o, "title") || ((i = e[n + 1]) == null ? void 0 : i.content);
                        r.push({
                            url: s,
                            title: a
                        });
                    }
                    break;
                }
            case "image":
                {
                    const s = $914aec8743edd630$var$qr(o, "src");
                    s && !t.find((a)=>a.url === s) && t.push({
                        url: s,
                        title: $914aec8743edd630$var$qr(o, "title"),
                        alt: $914aec8743edd630$var$qr(o, "alt")
                    });
                    break;
                }
        }
    }
    return {
        images: t,
        urls: r
    };
}, $914aec8743edd630$var$Hs = (e, t)=>{
    const r = {
        type: "TextBlock",
        text: e,
        size: void 0,
        horizontalAlignment: void 0,
        wrap: !0,
        maxLines: void 0
    };
    switch(t){
        case "title":
            r.size = "large";
            break;
        case "subtitle":
            r.size = "medium";
            break;
    }
    return r;
}, $914aec8743edd630$var$q9 = (e)=>{
    const t = {
        type: "Image",
        url: "",
        size: "Large",
        altText: void 0,
        selectAction: void 0,
        horizontalAlignment: "Center"
    };
    return t.url = e.url, t.altText = e.alt || "image", t.selectAction = e.tap && $914aec8743edd630$var$ju(e.tap), {
        ...t
    };
}, $914aec8743edd630$var$ju = (e, t)=>{
    const r = {
        type: "Action.Submit",
        title: void 0,
        url: void 0,
        data: void 0,
        fullWidth: void 0,
        position: void 0,
        display: void 0
    };
    for(const n in e)e[n] && typeof e[n] == "string" && (e[n] = $914aec8743edd630$var$Db(e[n]));
    e.type === "imBack" || e.type === "messageBack" || e.type === "postBack" || e.type === "signin" && t ? (r.type = "Action.Submit", r.data = e.value || e.title || null, r.title = e.title || "") : (r.type = "Action.OpenUrl", r.title = e.title || "", r.url = e.type === "call" ? `tel:${e.value}` : e.value);
    const i = e.channelData;
    return i && (r.fullWidth = i.fullWidth, r.position = i.position, r.display = i.display), {
        ...r
    };
}, $914aec8743edd630$var$z9 = (e)=>{
    const t = {
        contentType: $914aec8743edd630$var$RI,
        content: {
            type: "AdaptiveCard",
            $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
            version: "1.5",
            body: [],
            text: void 0,
            speak: void 0,
            selectAction: void 0
        }
    };
    let r = [];
    if (e.title) {
        const o = $914aec8743edd630$var$Hs(e.title, "title");
        r = [
            ...r,
            {
                ...o
            }
        ];
    }
    if (e.subtitle) {
        const o = $914aec8743edd630$var$Hs(e.subtitle, "subtitle");
        r = [
            ...r,
            {
                ...o
            }
        ];
    }
    if (e.text) {
        const o = $914aec8743edd630$var$Hs(e.text, "text");
        r = [
            ...r,
            {
                ...o
            }
        ], t.content.text = e.text;
    }
    (e.speak || e.text) && (t.content.speak = e.speak || e.text), t.content.body = [
        {
            type: "Container",
            items: []
        }
    ], r.length > 0 && (t.content.body[0].items = [
        ...r
    ]);
    let i = [];
    e.images && e.images.forEach((o)=>{
        const s = $914aec8743edd630$var$q9(o);
        i = [
            ...i,
            {
                ...s
            }
        ];
    }), i.length > 0 && (t.content.body[0].items = [
        ...t.content.body[0].items,
        ...i
    ]);
    let n = [];
    if (e.buttons && e.buttons.forEach((o)=>{
        const s = $914aec8743edd630$var$ju(o);
        n = [
            ...n,
            {
                ...s
            }
        ];
    }), n.length > 0) {
        const o = {
            type: "ActionSet",
            actions: [
                ...n
            ]
        };
        t.content.body[0].items = [
            ...t.content.body[0].items,
            {
                ...o
            }
        ];
    }
    if (e.tap) {
        const o = $914aec8743edd630$var$ju(e.tap);
        t.content.selectAction = {
            ...o
        };
    }
    return {
        ...t
    };
}, $914aec8743edd630$var$U9 = (e)=>{
    if (e && e.length > 0) {
        let t = [];
        return e.forEach((r)=>{
            if (r.contentType === $914aec8743edd630$var$OI) {
                const i = $914aec8743edd630$var$z9({
                    ...r.content
                });
                t = [
                    ...t,
                    {
                        ...i
                    }
                ];
            } else t = [
                ...t,
                {
                    ...r
                }
            ];
        }), t;
    }
};
var $914aec8743edd630$var$Kt = {}, $914aec8743edd630$var$Ks, $914aec8743edd630$var$V0;
function $914aec8743edd630$var$V9() {
    return $914aec8743edd630$var$V0 || ($914aec8743edd630$var$V0 = 1, $914aec8743edd630$var$Ks = function() {
        return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
    }), $914aec8743edd630$var$Ks;
}
var $914aec8743edd630$var$Qs = {}, $914aec8743edd630$var$kt = {}, $914aec8743edd630$var$G0;
function $914aec8743edd630$var$qt() {
    if ($914aec8743edd630$var$G0) return $914aec8743edd630$var$kt;
    $914aec8743edd630$var$G0 = 1;
    let e;
    const t = [
        0,
        // Not used
        26,
        44,
        70,
        100,
        134,
        172,
        196,
        242,
        292,
        346,
        404,
        466,
        532,
        581,
        655,
        733,
        815,
        901,
        991,
        1085,
        1156,
        1258,
        1364,
        1474,
        1588,
        1706,
        1828,
        1921,
        2051,
        2185,
        2323,
        2465,
        2611,
        2761,
        2876,
        3034,
        3196,
        3362,
        3532,
        3706
    ];
    return $914aec8743edd630$var$kt.getSymbolSize = function(i) {
        if (!i) throw new Error('"version" cannot be null or undefined');
        if (i < 1 || i > 40) throw new Error('"version" should be in range from 1 to 40');
        return i * 4 + 17;
    }, $914aec8743edd630$var$kt.getSymbolTotalCodewords = function(i) {
        return t[i];
    }, $914aec8743edd630$var$kt.getBCHDigit = function(r) {
        let i = 0;
        for(; r !== 0;)i++, r >>>= 1;
        return i;
    }, $914aec8743edd630$var$kt.setToSJISFunction = function(i) {
        if (typeof i != "function") throw new Error('"toSJISFunc" is not a valid function.');
        e = i;
    }, $914aec8743edd630$var$kt.isKanjiModeEnabled = function() {
        return typeof e < "u";
    }, $914aec8743edd630$var$kt.toSJIS = function(i) {
        return e(i);
    }, $914aec8743edd630$var$kt;
}
var $914aec8743edd630$var$Ys = {}, $914aec8743edd630$var$W0;
function $914aec8743edd630$var$Cc() {
    return $914aec8743edd630$var$W0 || ($914aec8743edd630$var$W0 = 1, function(e) {
        e.L = {
            bit: 1
        }, e.M = {
            bit: 0
        }, e.Q = {
            bit: 3
        }, e.H = {
            bit: 2
        };
        function t(r) {
            if (typeof r != "string") throw new Error("Param is not a string");
            switch(r.toLowerCase()){
                case "l":
                case "low":
                    return e.L;
                case "m":
                case "medium":
                    return e.M;
                case "q":
                case "quartile":
                    return e.Q;
                case "h":
                case "high":
                    return e.H;
                default:
                    throw new Error("Unknown EC Level: " + r);
            }
        }
        e.isValid = function(i) {
            return i && typeof i.bit < "u" && i.bit >= 0 && i.bit < 4;
        }, e.from = function(i, n) {
            if (e.isValid(i)) return i;
            try {
                return t(i);
            } catch  {
                return n;
            }
        };
    }($914aec8743edd630$var$Ys)), $914aec8743edd630$var$Ys;
}
var $914aec8743edd630$var$Js, $914aec8743edd630$var$H0;
function $914aec8743edd630$var$G9() {
    if ($914aec8743edd630$var$H0) return $914aec8743edd630$var$Js;
    $914aec8743edd630$var$H0 = 1;
    function e() {
        this.buffer = [], this.length = 0;
    }
    return e.prototype = {
        get: function(t) {
            const r = Math.floor(t / 8);
            return (this.buffer[r] >>> 7 - t % 8 & 1) === 1;
        },
        put: function(t, r) {
            for(let i = 0; i < r; i++)this.putBit((t >>> r - i - 1 & 1) === 1);
        },
        getLengthInBits: function() {
            return this.length;
        },
        putBit: function(t) {
            const r = Math.floor(this.length / 8);
            this.buffer.length <= r && this.buffer.push(0), t && (this.buffer[r] |= 128 >>> this.length % 8), this.length++;
        }
    }, $914aec8743edd630$var$Js = e, $914aec8743edd630$var$Js;
}
var $914aec8743edd630$var$Zs, $914aec8743edd630$var$K0;
function $914aec8743edd630$var$W9() {
    if ($914aec8743edd630$var$K0) return $914aec8743edd630$var$Zs;
    $914aec8743edd630$var$K0 = 1;
    function e(t) {
        if (!t || t < 1) throw new Error("BitMatrix size must be defined and greater than 0");
        this.size = t, this.data = new Uint8Array(t * t), this.reservedBit = new Uint8Array(t * t);
    }
    return e.prototype.set = function(t, r, i, n) {
        const o = t * this.size + r;
        this.data[o] = i, n && (this.reservedBit[o] = !0);
    }, e.prototype.get = function(t, r) {
        return this.data[t * this.size + r];
    }, e.prototype.xor = function(t, r, i) {
        this.data[t * this.size + r] ^= i;
    }, e.prototype.isReserved = function(t, r) {
        return this.reservedBit[t * this.size + r];
    }, $914aec8743edd630$var$Zs = e, $914aec8743edd630$var$Zs;
}
var $914aec8743edd630$var$Xs = {}, $914aec8743edd630$var$Q0;
function $914aec8743edd630$var$H9() {
    return $914aec8743edd630$var$Q0 || ($914aec8743edd630$var$Q0 = 1, function(e) {
        const t = $914aec8743edd630$var$qt().getSymbolSize;
        e.getRowColCoords = function(i) {
            if (i === 1) return [];
            const n = Math.floor(i / 7) + 2, o = t(i), s = o === 145 ? 26 : Math.ceil((o - 13) / (2 * n - 2)) * 2, a = [
                o - 7
            ];
            for(let u = 1; u < n - 1; u++)a[u] = a[u - 1] - s;
            return a.push(6), a.reverse();
        }, e.getPositions = function(i) {
            const n = [], o = e.getRowColCoords(i), s = o.length;
            for(let a = 0; a < s; a++)for(let u = 0; u < s; u++)a === 0 && u === 0 || // top-left
            a === 0 && u === s - 1 || // bottom-left
            a === s - 1 && u === 0 || n.push([
                o[a],
                o[u]
            ]);
            return n;
        };
    }($914aec8743edd630$var$Xs)), $914aec8743edd630$var$Xs;
}
var $914aec8743edd630$var$eu = {}, $914aec8743edd630$var$Y0;
function $914aec8743edd630$var$K9() {
    if ($914aec8743edd630$var$Y0) return $914aec8743edd630$var$eu;
    $914aec8743edd630$var$Y0 = 1;
    const e = $914aec8743edd630$var$qt().getSymbolSize, t = 7;
    return $914aec8743edd630$var$eu.getPositions = function(i) {
        const n = e(i);
        return [
            // top-left
            [
                0,
                0
            ],
            // top-right
            [
                n - t,
                0
            ],
            // bottom-left
            [
                0,
                n - t
            ]
        ];
    }, $914aec8743edd630$var$eu;
}
var $914aec8743edd630$var$tu = {}, $914aec8743edd630$var$J0;
function $914aec8743edd630$var$Q9() {
    return $914aec8743edd630$var$J0 || ($914aec8743edd630$var$J0 = 1, function(e) {
        e.Patterns = {
            PATTERN000: 0,
            PATTERN001: 1,
            PATTERN010: 2,
            PATTERN011: 3,
            PATTERN100: 4,
            PATTERN101: 5,
            PATTERN110: 6,
            PATTERN111: 7
        };
        const t = {
            N1: 3,
            N2: 3,
            N3: 40,
            N4: 10
        };
        e.isValid = function(n) {
            return n != null && n !== "" && !isNaN(n) && n >= 0 && n <= 7;
        }, e.from = function(n) {
            return e.isValid(n) ? parseInt(n, 10) : void 0;
        }, e.getPenaltyN1 = function(n) {
            const o = n.size;
            let s = 0, a = 0, u = 0, l = null, c = null;
            for(let d = 0; d < o; d++){
                a = u = 0, l = c = null;
                for(let h = 0; h < o; h++){
                    let f = n.get(d, h);
                    f === l ? a++ : (a >= 5 && (s += t.N1 + (a - 5)), l = f, a = 1), f = n.get(h, d), f === c ? u++ : (u >= 5 && (s += t.N1 + (u - 5)), c = f, u = 1);
                }
                a >= 5 && (s += t.N1 + (a - 5)), u >= 5 && (s += t.N1 + (u - 5));
            }
            return s;
        }, e.getPenaltyN2 = function(n) {
            const o = n.size;
            let s = 0;
            for(let a = 0; a < o - 1; a++)for(let u = 0; u < o - 1; u++){
                const l = n.get(a, u) + n.get(a, u + 1) + n.get(a + 1, u) + n.get(a + 1, u + 1);
                (l === 4 || l === 0) && s++;
            }
            return s * t.N2;
        }, e.getPenaltyN3 = function(n) {
            const o = n.size;
            let s = 0, a = 0, u = 0;
            for(let l = 0; l < o; l++){
                a = u = 0;
                for(let c = 0; c < o; c++)a = a << 1 & 2047 | n.get(l, c), c >= 10 && (a === 1488 || a === 93) && s++, u = u << 1 & 2047 | n.get(c, l), c >= 10 && (u === 1488 || u === 93) && s++;
            }
            return s * t.N3;
        }, e.getPenaltyN4 = function(n) {
            let o = 0;
            const s = n.data.length;
            for(let u = 0; u < s; u++)o += n.data[u];
            return Math.abs(Math.ceil(o * 100 / s / 5) - 10) * t.N4;
        };
        function r(i, n, o) {
            switch(i){
                case e.Patterns.PATTERN000:
                    return (n + o) % 2 === 0;
                case e.Patterns.PATTERN001:
                    return n % 2 === 0;
                case e.Patterns.PATTERN010:
                    return o % 3 === 0;
                case e.Patterns.PATTERN011:
                    return (n + o) % 3 === 0;
                case e.Patterns.PATTERN100:
                    return (Math.floor(n / 2) + Math.floor(o / 3)) % 2 === 0;
                case e.Patterns.PATTERN101:
                    return n * o % 2 + n * o % 3 === 0;
                case e.Patterns.PATTERN110:
                    return (n * o % 2 + n * o % 3) % 2 === 0;
                case e.Patterns.PATTERN111:
                    return (n * o % 3 + (n + o) % 2) % 2 === 0;
                default:
                    throw new Error("bad maskPattern:" + i);
            }
        }
        e.applyMask = function(n, o) {
            const s = o.size;
            for(let a = 0; a < s; a++)for(let u = 0; u < s; u++)o.isReserved(u, a) || o.xor(u, a, r(n, u, a));
        }, e.getBestMask = function(n, o) {
            const s = Object.keys(e.Patterns).length;
            let a = 0, u = 1 / 0;
            for(let l = 0; l < s; l++){
                o(l), e.applyMask(l, n);
                const c = e.getPenaltyN1(n) + e.getPenaltyN2(n) + e.getPenaltyN3(n) + e.getPenaltyN4(n);
                e.applyMask(l, n), c < u && (u = c, a = l);
            }
            return a;
        };
    }($914aec8743edd630$var$tu)), $914aec8743edd630$var$tu;
}
var $914aec8743edd630$var$Rn = {}, $914aec8743edd630$var$Z0;
function $914aec8743edd630$var$Pb() {
    if ($914aec8743edd630$var$Z0) return $914aec8743edd630$var$Rn;
    $914aec8743edd630$var$Z0 = 1;
    const e = $914aec8743edd630$var$Cc(), t = [
        // L  M  Q  H
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        2,
        2,
        1,
        2,
        2,
        4,
        1,
        2,
        4,
        4,
        2,
        4,
        4,
        4,
        2,
        4,
        6,
        5,
        2,
        4,
        6,
        6,
        2,
        5,
        8,
        8,
        4,
        5,
        8,
        8,
        4,
        5,
        8,
        11,
        4,
        8,
        10,
        11,
        4,
        9,
        12,
        16,
        4,
        9,
        16,
        16,
        6,
        10,
        12,
        18,
        6,
        10,
        17,
        16,
        6,
        11,
        16,
        19,
        6,
        13,
        18,
        21,
        7,
        14,
        21,
        25,
        8,
        16,
        20,
        25,
        8,
        17,
        23,
        25,
        9,
        17,
        23,
        34,
        9,
        18,
        25,
        30,
        10,
        20,
        27,
        32,
        12,
        21,
        29,
        35,
        12,
        23,
        34,
        37,
        12,
        25,
        34,
        40,
        13,
        26,
        35,
        42,
        14,
        28,
        38,
        45,
        15,
        29,
        40,
        48,
        16,
        31,
        43,
        51,
        17,
        33,
        45,
        54,
        18,
        35,
        48,
        57,
        19,
        37,
        51,
        60,
        19,
        38,
        53,
        63,
        20,
        40,
        56,
        66,
        21,
        43,
        59,
        70,
        22,
        45,
        62,
        74,
        24,
        47,
        65,
        77,
        25,
        49,
        68,
        81
    ], r = [
        // L  M  Q  H
        7,
        10,
        13,
        17,
        10,
        16,
        22,
        28,
        15,
        26,
        36,
        44,
        20,
        36,
        52,
        64,
        26,
        48,
        72,
        88,
        36,
        64,
        96,
        112,
        40,
        72,
        108,
        130,
        48,
        88,
        132,
        156,
        60,
        110,
        160,
        192,
        72,
        130,
        192,
        224,
        80,
        150,
        224,
        264,
        96,
        176,
        260,
        308,
        104,
        198,
        288,
        352,
        120,
        216,
        320,
        384,
        132,
        240,
        360,
        432,
        144,
        280,
        408,
        480,
        168,
        308,
        448,
        532,
        180,
        338,
        504,
        588,
        196,
        364,
        546,
        650,
        224,
        416,
        600,
        700,
        224,
        442,
        644,
        750,
        252,
        476,
        690,
        816,
        270,
        504,
        750,
        900,
        300,
        560,
        810,
        960,
        312,
        588,
        870,
        1050,
        336,
        644,
        952,
        1110,
        360,
        700,
        1020,
        1200,
        390,
        728,
        1050,
        1260,
        420,
        784,
        1140,
        1350,
        450,
        812,
        1200,
        1440,
        480,
        868,
        1290,
        1530,
        510,
        924,
        1350,
        1620,
        540,
        980,
        1440,
        1710,
        570,
        1036,
        1530,
        1800,
        570,
        1064,
        1590,
        1890,
        600,
        1120,
        1680,
        1980,
        630,
        1204,
        1770,
        2100,
        660,
        1260,
        1860,
        2220,
        720,
        1316,
        1950,
        2310,
        750,
        1372,
        2040,
        2430
    ];
    return $914aec8743edd630$var$Rn.getBlocksCount = function(n, o) {
        switch(o){
            case e.L:
                return t[(n - 1) * 4 + 0];
            case e.M:
                return t[(n - 1) * 4 + 1];
            case e.Q:
                return t[(n - 1) * 4 + 2];
            case e.H:
                return t[(n - 1) * 4 + 3];
            default:
                return;
        }
    }, $914aec8743edd630$var$Rn.getTotalCodewordsCount = function(n, o) {
        switch(o){
            case e.L:
                return r[(n - 1) * 4 + 0];
            case e.M:
                return r[(n - 1) * 4 + 1];
            case e.Q:
                return r[(n - 1) * 4 + 2];
            case e.H:
                return r[(n - 1) * 4 + 3];
            default:
                return;
        }
    }, $914aec8743edd630$var$Rn;
}
var $914aec8743edd630$var$ru = {}, $914aec8743edd630$var$zr = {}, $914aec8743edd630$var$X0;
function $914aec8743edd630$var$Y9() {
    if ($914aec8743edd630$var$X0) return $914aec8743edd630$var$zr;
    $914aec8743edd630$var$X0 = 1;
    const e = new Uint8Array(512), t = new Uint8Array(256);
    return function() {
        let i = 1;
        for(let n = 0; n < 255; n++)e[n] = i, t[i] = n, i <<= 1, i & 256 && (i ^= 285);
        for(let n = 255; n < 512; n++)e[n] = e[n - 255];
    }(), $914aec8743edd630$var$zr.log = function(i) {
        if (i < 1) throw new Error("log(" + i + ")");
        return t[i];
    }, $914aec8743edd630$var$zr.exp = function(i) {
        return e[i];
    }, $914aec8743edd630$var$zr.mul = function(i, n) {
        return i === 0 || n === 0 ? 0 : e[t[i] + t[n]];
    }, $914aec8743edd630$var$zr;
}
var $914aec8743edd630$var$em;
function $914aec8743edd630$var$J9() {
    return $914aec8743edd630$var$em || ($914aec8743edd630$var$em = 1, function(e) {
        const t = $914aec8743edd630$var$Y9();
        e.mul = function(i, n) {
            const o = new Uint8Array(i.length + n.length - 1);
            for(let s = 0; s < i.length; s++)for(let a = 0; a < n.length; a++)o[s + a] ^= t.mul(i[s], n[a]);
            return o;
        }, e.mod = function(i, n) {
            let o = new Uint8Array(i);
            for(; o.length - n.length >= 0;){
                const s = o[0];
                for(let u = 0; u < n.length; u++)o[u] ^= t.mul(n[u], s);
                let a = 0;
                for(; a < o.length && o[a] === 0;)a++;
                o = o.slice(a);
            }
            return o;
        }, e.generateECPolynomial = function(i) {
            let n = new Uint8Array([
                1
            ]);
            for(let o = 0; o < i; o++)n = e.mul(n, new Uint8Array([
                1,
                t.exp(o)
            ]));
            return n;
        };
    }($914aec8743edd630$var$ru)), $914aec8743edd630$var$ru;
}
var $914aec8743edd630$var$nu, $914aec8743edd630$var$tm;
function $914aec8743edd630$var$Z9() {
    if ($914aec8743edd630$var$tm) return $914aec8743edd630$var$nu;
    $914aec8743edd630$var$tm = 1;
    const e = $914aec8743edd630$var$J9();
    function t(r) {
        this.genPoly = void 0, this.degree = r, this.degree && this.initialize(this.degree);
    }
    return t.prototype.initialize = function(i) {
        this.degree = i, this.genPoly = e.generateECPolynomial(this.degree);
    }, t.prototype.encode = function(i) {
        if (!this.genPoly) throw new Error("Encoder not initialized");
        const n = new Uint8Array(i.length + this.degree);
        n.set(i);
        const o = e.mod(n, this.genPoly), s = this.degree - o.length;
        if (s > 0) {
            const a = new Uint8Array(this.degree);
            return a.set(o, s), a;
        }
        return o;
    }, $914aec8743edd630$var$nu = t, $914aec8743edd630$var$nu;
}
var $914aec8743edd630$var$iu = {}, $914aec8743edd630$var$ou = {}, $914aec8743edd630$var$au = {}, $914aec8743edd630$var$rm;
function $914aec8743edd630$var$Ib() {
    return $914aec8743edd630$var$rm || ($914aec8743edd630$var$rm = 1, $914aec8743edd630$var$au.isValid = function(t) {
        return !isNaN(t) && t >= 1 && t <= 40;
    }), $914aec8743edd630$var$au;
}
var $914aec8743edd630$var$it = {}, $914aec8743edd630$var$nm;
function $914aec8743edd630$var$Mb() {
    if ($914aec8743edd630$var$nm) return $914aec8743edd630$var$it;
    $914aec8743edd630$var$nm = 1;
    const e = "[0-9]+", t = "[A-Z $%*+\\-./:]+";
    let r = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
    r = r.replace(/u/g, "\\u");
    const i = "(?:(?![A-Z0-9 $%*+\\-./:]|" + r + `)(?:.|[\r
]))+`;
    $914aec8743edd630$var$it.KANJI = new RegExp(r, "g"), $914aec8743edd630$var$it.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g"), $914aec8743edd630$var$it.BYTE = new RegExp(i, "g"), $914aec8743edd630$var$it.NUMERIC = new RegExp(e, "g"), $914aec8743edd630$var$it.ALPHANUMERIC = new RegExp(t, "g");
    const n = new RegExp("^" + r + "$"), o = new RegExp("^" + e + "$"), s = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
    return $914aec8743edd630$var$it.testKanji = function(u) {
        return n.test(u);
    }, $914aec8743edd630$var$it.testNumeric = function(u) {
        return o.test(u);
    }, $914aec8743edd630$var$it.testAlphanumeric = function(u) {
        return s.test(u);
    }, $914aec8743edd630$var$it;
}
var $914aec8743edd630$var$im;
function $914aec8743edd630$var$zt() {
    return $914aec8743edd630$var$im || ($914aec8743edd630$var$im = 1, function(e) {
        const t = $914aec8743edd630$var$Ib(), r = $914aec8743edd630$var$Mb();
        e.NUMERIC = {
            id: "Numeric",
            bit: 1,
            ccBits: [
                10,
                12,
                14
            ]
        }, e.ALPHANUMERIC = {
            id: "Alphanumeric",
            bit: 2,
            ccBits: [
                9,
                11,
                13
            ]
        }, e.BYTE = {
            id: "Byte",
            bit: 4,
            ccBits: [
                8,
                16,
                16
            ]
        }, e.KANJI = {
            id: "Kanji",
            bit: 8,
            ccBits: [
                8,
                10,
                12
            ]
        }, e.MIXED = {
            bit: -1
        }, e.getCharCountIndicator = function(o, s) {
            if (!o.ccBits) throw new Error("Invalid mode: " + o);
            if (!t.isValid(s)) throw new Error("Invalid version: " + s);
            return s >= 1 && s < 10 ? o.ccBits[0] : s < 27 ? o.ccBits[1] : o.ccBits[2];
        }, e.getBestModeForData = function(o) {
            return r.testNumeric(o) ? e.NUMERIC : r.testAlphanumeric(o) ? e.ALPHANUMERIC : r.testKanji(o) ? e.KANJI : e.BYTE;
        }, e.toString = function(o) {
            if (o && o.id) return o.id;
            throw new Error("Invalid mode");
        }, e.isValid = function(o) {
            return o && o.bit && o.ccBits;
        };
        function i(n) {
            if (typeof n != "string") throw new Error("Param is not a string");
            switch(n.toLowerCase()){
                case "numeric":
                    return e.NUMERIC;
                case "alphanumeric":
                    return e.ALPHANUMERIC;
                case "kanji":
                    return e.KANJI;
                case "byte":
                    return e.BYTE;
                default:
                    throw new Error("Unknown mode: " + n);
            }
        }
        e.from = function(o, s) {
            if (e.isValid(o)) return o;
            try {
                return i(o);
            } catch  {
                return s;
            }
        };
    }($914aec8743edd630$var$ou)), $914aec8743edd630$var$ou;
}
var $914aec8743edd630$var$om;
function $914aec8743edd630$var$X9() {
    return $914aec8743edd630$var$om || ($914aec8743edd630$var$om = 1, function(e) {
        const t = $914aec8743edd630$var$qt(), r = $914aec8743edd630$var$Pb(), i = $914aec8743edd630$var$Cc(), n = $914aec8743edd630$var$zt(), o = $914aec8743edd630$var$Ib(), s = 7973, a = t.getBCHDigit(s);
        function u(h, f, p) {
            for(let m = 1; m <= 40; m++)if (f <= e.getCapacity(m, p, h)) return m;
        }
        function l(h, f) {
            return n.getCharCountIndicator(h, f) + 4;
        }
        function c(h, f) {
            let p = 0;
            return h.forEach(function(m) {
                const w = l(m.mode, f);
                p += w + m.getBitsLength();
            }), p;
        }
        function d(h, f) {
            for(let p = 1; p <= 40; p++)if (c(h, p) <= e.getCapacity(p, f, n.MIXED)) return p;
        }
        e.from = function(f, p) {
            return o.isValid(f) ? parseInt(f, 10) : p;
        }, e.getCapacity = function(f, p, m) {
            if (!o.isValid(f)) throw new Error("Invalid QR Code version");
            typeof m > "u" && (m = n.BYTE);
            const w = t.getSymbolTotalCodewords(f), v = r.getTotalCodewordsCount(f, p), g = (w - v) * 8;
            if (m === n.MIXED) return g;
            const A = g - l(m, f);
            switch(m){
                case n.NUMERIC:
                    return Math.floor(A / 10 * 3);
                case n.ALPHANUMERIC:
                    return Math.floor(A / 11 * 2);
                case n.KANJI:
                    return Math.floor(A / 13);
                case n.BYTE:
                default:
                    return Math.floor(A / 8);
            }
        }, e.getBestVersionForData = function(f, p) {
            let m;
            const w = i.from(p, i.M);
            if (Array.isArray(f)) {
                if (f.length > 1) return d(f, w);
                if (f.length === 0) return 1;
                m = f[0];
            } else m = f;
            return u(m.mode, m.getLength(), w);
        }, e.getEncodedBits = function(f) {
            if (!o.isValid(f) || f < 7) throw new Error("Invalid QR Code version");
            let p = f << 12;
            for(; t.getBCHDigit(p) - a >= 0;)p ^= s << t.getBCHDigit(p) - a;
            return f << 12 | p;
        };
    }($914aec8743edd630$var$iu)), $914aec8743edd630$var$iu;
}
var $914aec8743edd630$var$su = {}, $914aec8743edd630$var$am;
function $914aec8743edd630$var$eF() {
    if ($914aec8743edd630$var$am) return $914aec8743edd630$var$su;
    $914aec8743edd630$var$am = 1;
    const e = $914aec8743edd630$var$qt(), t = 1335, r = 21522, i = e.getBCHDigit(t);
    return $914aec8743edd630$var$su.getEncodedBits = function(o, s) {
        const a = o.bit << 3 | s;
        let u = a << 10;
        for(; e.getBCHDigit(u) - i >= 0;)u ^= t << e.getBCHDigit(u) - i;
        return (a << 10 | u) ^ r;
    }, $914aec8743edd630$var$su;
}
var $914aec8743edd630$var$uu = {}, $914aec8743edd630$var$cu, $914aec8743edd630$var$sm;
function $914aec8743edd630$var$tF() {
    if ($914aec8743edd630$var$sm) return $914aec8743edd630$var$cu;
    $914aec8743edd630$var$sm = 1;
    const e = $914aec8743edd630$var$zt();
    function t(r) {
        this.mode = e.NUMERIC, this.data = r.toString();
    }
    return t.getBitsLength = function(i) {
        return 10 * Math.floor(i / 3) + (i % 3 ? i % 3 * 3 + 1 : 0);
    }, t.prototype.getLength = function() {
        return this.data.length;
    }, t.prototype.getBitsLength = function() {
        return t.getBitsLength(this.data.length);
    }, t.prototype.write = function(i) {
        let n, o, s;
        for(n = 0; n + 3 <= this.data.length; n += 3)o = this.data.substr(n, 3), s = parseInt(o, 10), i.put(s, 10);
        const a = this.data.length - n;
        a > 0 && (o = this.data.substr(n), s = parseInt(o, 10), i.put(s, a * 3 + 1));
    }, $914aec8743edd630$var$cu = t, $914aec8743edd630$var$cu;
}
var $914aec8743edd630$var$lu, $914aec8743edd630$var$um;
function $914aec8743edd630$var$rF() {
    if ($914aec8743edd630$var$um) return $914aec8743edd630$var$lu;
    $914aec8743edd630$var$um = 1;
    const e = $914aec8743edd630$var$zt(), t = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        " ",
        "$",
        "%",
        "*",
        "+",
        "-",
        ".",
        "/",
        ":"
    ];
    function r(i) {
        this.mode = e.ALPHANUMERIC, this.data = i;
    }
    return r.getBitsLength = function(n) {
        return 11 * Math.floor(n / 2) + 6 * (n % 2);
    }, r.prototype.getLength = function() {
        return this.data.length;
    }, r.prototype.getBitsLength = function() {
        return r.getBitsLength(this.data.length);
    }, r.prototype.write = function(n) {
        let o;
        for(o = 0; o + 2 <= this.data.length; o += 2){
            let s = t.indexOf(this.data[o]) * 45;
            s += t.indexOf(this.data[o + 1]), n.put(s, 11);
        }
        this.data.length % 2 && n.put(t.indexOf(this.data[o]), 6);
    }, $914aec8743edd630$var$lu = r, $914aec8743edd630$var$lu;
}
var $914aec8743edd630$var$du, $914aec8743edd630$var$cm;
function $914aec8743edd630$var$nF() {
    if ($914aec8743edd630$var$cm) return $914aec8743edd630$var$du;
    $914aec8743edd630$var$cm = 1;
    const e = $914aec8743edd630$var$zt();
    function t(r) {
        this.mode = e.BYTE, typeof r == "string" ? this.data = new TextEncoder().encode(r) : this.data = new Uint8Array(r);
    }
    return t.getBitsLength = function(i) {
        return i * 8;
    }, t.prototype.getLength = function() {
        return this.data.length;
    }, t.prototype.getBitsLength = function() {
        return t.getBitsLength(this.data.length);
    }, t.prototype.write = function(r) {
        for(let i = 0, n = this.data.length; i < n; i++)r.put(this.data[i], 8);
    }, $914aec8743edd630$var$du = t, $914aec8743edd630$var$du;
}
var $914aec8743edd630$var$fu, $914aec8743edd630$var$lm;
function $914aec8743edd630$var$iF() {
    if ($914aec8743edd630$var$lm) return $914aec8743edd630$var$fu;
    $914aec8743edd630$var$lm = 1;
    const e = $914aec8743edd630$var$zt(), t = $914aec8743edd630$var$qt();
    function r(i) {
        this.mode = e.KANJI, this.data = i;
    }
    return r.getBitsLength = function(n) {
        return n * 13;
    }, r.prototype.getLength = function() {
        return this.data.length;
    }, r.prototype.getBitsLength = function() {
        return r.getBitsLength(this.data.length);
    }, r.prototype.write = function(i) {
        let n;
        for(n = 0; n < this.data.length; n++){
            let o = t.toSJIS(this.data[n]);
            if (o >= 33088 && o <= 40956) o -= 33088;
            else if (o >= 57408 && o <= 60351) o -= 49472;
            else throw new Error("Invalid SJIS character: " + this.data[n] + `
Make sure your charset is UTF-8`);
            o = (o >>> 8 & 255) * 192 + (o & 255), i.put(o, 13);
        }
    }, $914aec8743edd630$var$fu = r, $914aec8743edd630$var$fu;
}
var $914aec8743edd630$var$hu = {
    exports: {}
}, $914aec8743edd630$var$dm;
function $914aec8743edd630$var$oF() {
    return $914aec8743edd630$var$dm || ($914aec8743edd630$var$dm = 1, function(e) {
        var t = {
            single_source_shortest_paths: function(r, i, n) {
                var o = {}, s = {};
                s[i] = 0;
                var a = t.PriorityQueue.make();
                a.push(i, 0);
                for(var u, l, c, d, h, f, p, m, w; !a.empty();){
                    u = a.pop(), l = u.value, d = u.cost, h = r[l] || {};
                    for(c in h)h.hasOwnProperty(c) && (f = h[c], p = d + f, m = s[c], w = typeof s[c] > "u", (w || m > p) && (s[c] = p, a.push(c, p), o[c] = l));
                }
                if (typeof n < "u" && typeof s[n] > "u") {
                    var v = [
                        "Could not find a path from ",
                        i,
                        " to ",
                        n,
                        "."
                    ].join("");
                    throw new Error(v);
                }
                return o;
            },
            extract_shortest_path_from_predecessor_list: function(r, i) {
                for(var n = [], o = i; o;)n.push(o), r[o], o = r[o];
                return n.reverse(), n;
            },
            find_path: function(r, i, n) {
                var o = t.single_source_shortest_paths(r, i, n);
                return t.extract_shortest_path_from_predecessor_list(o, n);
            },
            /**
       * A very naive priority queue implementation.
       */ PriorityQueue: {
                make: function(r) {
                    var i = t.PriorityQueue, n = {}, o;
                    r = r || {};
                    for(o in i)i.hasOwnProperty(o) && (n[o] = i[o]);
                    return n.queue = [], n.sorter = r.sorter || i.default_sorter, n;
                },
                default_sorter: function(r, i) {
                    return r.cost - i.cost;
                },
                /**
         * Add a new item to the queue and ensure the highest priority element
         * is at the front of the queue.
         */ push: function(r, i) {
                    var n = {
                        value: r,
                        cost: i
                    };
                    this.queue.push(n), this.queue.sort(this.sorter);
                },
                /**
         * Return the highest priority element in the queue.
         */ pop: function() {
                    return this.queue.shift();
                },
                empty: function() {
                    return this.queue.length === 0;
                }
            }
        };
        e.exports = t;
    }($914aec8743edd630$var$hu)), $914aec8743edd630$var$hu.exports;
}
var $914aec8743edd630$var$fm;
function $914aec8743edd630$var$aF() {
    return $914aec8743edd630$var$fm || ($914aec8743edd630$var$fm = 1, function(e) {
        const t = $914aec8743edd630$var$zt(), r = $914aec8743edd630$var$tF(), i = $914aec8743edd630$var$rF(), n = $914aec8743edd630$var$nF(), o = $914aec8743edd630$var$iF(), s = $914aec8743edd630$var$Mb(), a = $914aec8743edd630$var$qt(), u = $914aec8743edd630$var$oF();
        function l(v) {
            return unescape(encodeURIComponent(v)).length;
        }
        function c(v, g, A) {
            const b = [];
            let k;
            for(; (k = v.exec(A)) !== null;)b.push({
                data: k[0],
                index: k.index,
                mode: g,
                length: k[0].length
            });
            return b;
        }
        function d(v) {
            const g = c(s.NUMERIC, t.NUMERIC, v), A = c(s.ALPHANUMERIC, t.ALPHANUMERIC, v);
            let b, k;
            return a.isKanjiModeEnabled() ? (b = c(s.BYTE, t.BYTE, v), k = c(s.KANJI, t.KANJI, v)) : (b = c(s.BYTE_KANJI, t.BYTE, v), k = []), g.concat(A, b, k).sort(function(x, C) {
                return x.index - C.index;
            }).map(function(x) {
                return {
                    data: x.data,
                    mode: x.mode,
                    length: x.length
                };
            });
        }
        function h(v, g) {
            switch(g){
                case t.NUMERIC:
                    return r.getBitsLength(v);
                case t.ALPHANUMERIC:
                    return i.getBitsLength(v);
                case t.KANJI:
                    return o.getBitsLength(v);
                case t.BYTE:
                    return n.getBitsLength(v);
            }
        }
        function f(v) {
            return v.reduce(function(g, A) {
                const b = g.length - 1 >= 0 ? g[g.length - 1] : null;
                return b && b.mode === A.mode ? (g[g.length - 1].data += A.data, g) : (g.push(A), g);
            }, []);
        }
        function p(v) {
            const g = [];
            for(let A = 0; A < v.length; A++){
                const b = v[A];
                switch(b.mode){
                    case t.NUMERIC:
                        g.push([
                            b,
                            {
                                data: b.data,
                                mode: t.ALPHANUMERIC,
                                length: b.length
                            },
                            {
                                data: b.data,
                                mode: t.BYTE,
                                length: b.length
                            }
                        ]);
                        break;
                    case t.ALPHANUMERIC:
                        g.push([
                            b,
                            {
                                data: b.data,
                                mode: t.BYTE,
                                length: b.length
                            }
                        ]);
                        break;
                    case t.KANJI:
                        g.push([
                            b,
                            {
                                data: b.data,
                                mode: t.BYTE,
                                length: l(b.data)
                            }
                        ]);
                        break;
                    case t.BYTE:
                        g.push([
                            {
                                data: b.data,
                                mode: t.BYTE,
                                length: l(b.data)
                            }
                        ]);
                }
            }
            return g;
        }
        function m(v, g) {
            const A = {}, b = {
                start: {}
            };
            let k = [
                "start"
            ];
            for(let y = 0; y < v.length; y++){
                const x = v[y], C = [];
                for(let I = 0; I < x.length; I++){
                    const M = x[I], Q = "" + y + I;
                    C.push(Q), A[Q] = {
                        node: M,
                        lastCount: 0
                    }, b[Q] = {};
                    for(let H = 0; H < k.length; H++){
                        const J = k[H];
                        A[J] && A[J].node.mode === M.mode ? (b[J][Q] = h(A[J].lastCount + M.length, M.mode) - h(A[J].lastCount, M.mode), A[J].lastCount += M.length) : (A[J] && (A[J].lastCount = M.length), b[J][Q] = h(M.length, M.mode) + 4 + t.getCharCountIndicator(M.mode, g));
                    }
                }
                k = C;
            }
            for(let y = 0; y < k.length; y++)b[k[y]].end = 0;
            return {
                map: b,
                table: A
            };
        }
        function w(v, g) {
            let A;
            const b = t.getBestModeForData(v);
            if (A = t.from(g, b), A !== t.BYTE && A.bit < b.bit) throw new Error('"' + v + '" cannot be encoded with mode ' + t.toString(A) + `.
 Suggested mode is: ` + t.toString(b));
            switch(A === t.KANJI && !a.isKanjiModeEnabled() && (A = t.BYTE), A){
                case t.NUMERIC:
                    return new r(v);
                case t.ALPHANUMERIC:
                    return new i(v);
                case t.KANJI:
                    return new o(v);
                case t.BYTE:
                    return new n(v);
            }
        }
        e.fromArray = function(g) {
            return g.reduce(function(A, b) {
                return typeof b == "string" ? A.push(w(b, null)) : b.data && A.push(w(b.data, b.mode)), A;
            }, []);
        }, e.fromString = function(g, A) {
            const b = d(g, a.isKanjiModeEnabled()), k = p(b), y = m(k, A), x = u.find_path(y.map, "start", "end"), C = [];
            for(let I = 1; I < x.length - 1; I++)C.push(y.table[x[I]].node);
            return e.fromArray(f(C));
        }, e.rawSplit = function(g) {
            return e.fromArray(d(g, a.isKanjiModeEnabled()));
        };
    }($914aec8743edd630$var$uu)), $914aec8743edd630$var$uu;
}
var $914aec8743edd630$var$hm;
function $914aec8743edd630$var$sF() {
    if ($914aec8743edd630$var$hm) return $914aec8743edd630$var$Qs;
    $914aec8743edd630$var$hm = 1;
    const e = $914aec8743edd630$var$qt(), t = $914aec8743edd630$var$Cc(), r = $914aec8743edd630$var$G9(), i = $914aec8743edd630$var$W9(), n = $914aec8743edd630$var$H9(), o = $914aec8743edd630$var$K9(), s = $914aec8743edd630$var$Q9(), a = $914aec8743edd630$var$Pb(), u = $914aec8743edd630$var$Z9(), l = $914aec8743edd630$var$X9(), c = $914aec8743edd630$var$eF(), d = $914aec8743edd630$var$zt(), h = $914aec8743edd630$var$aF();
    function f(y, x) {
        const C = y.size, I = o.getPositions(x);
        for(let M = 0; M < I.length; M++){
            const Q = I[M][0], H = I[M][1];
            for(let J = -1; J <= 7; J++)if (!(Q + J <= -1 || C <= Q + J)) for(let W = -1; W <= 7; W++)H + W <= -1 || C <= H + W || (J >= 0 && J <= 6 && (W === 0 || W === 6) || W >= 0 && W <= 6 && (J === 0 || J === 6) || J >= 2 && J <= 4 && W >= 2 && W <= 4 ? y.set(Q + J, H + W, !0, !0) : y.set(Q + J, H + W, !1, !0));
        }
    }
    function p(y) {
        const x = y.size;
        for(let C = 8; C < x - 8; C++){
            const I = C % 2 === 0;
            y.set(C, 6, I, !0), y.set(6, C, I, !0);
        }
    }
    function m(y, x) {
        const C = n.getPositions(x);
        for(let I = 0; I < C.length; I++){
            const M = C[I][0], Q = C[I][1];
            for(let H = -2; H <= 2; H++)for(let J = -2; J <= 2; J++)H === -2 || H === 2 || J === -2 || J === 2 || H === 0 && J === 0 ? y.set(M + H, Q + J, !0, !0) : y.set(M + H, Q + J, !1, !0);
        }
    }
    function w(y, x) {
        const C = y.size, I = l.getEncodedBits(x);
        let M, Q, H;
        for(let J = 0; J < 18; J++)M = Math.floor(J / 3), Q = J % 3 + C - 8 - 3, H = (I >> J & 1) === 1, y.set(M, Q, H, !0), y.set(Q, M, H, !0);
    }
    function v(y, x, C) {
        const I = y.size, M = c.getEncodedBits(x, C);
        let Q, H;
        for(Q = 0; Q < 15; Q++)H = (M >> Q & 1) === 1, Q < 6 ? y.set(Q, 8, H, !0) : Q < 8 ? y.set(Q + 1, 8, H, !0) : y.set(I - 15 + Q, 8, H, !0), Q < 8 ? y.set(8, I - Q - 1, H, !0) : Q < 9 ? y.set(8, 15 - Q - 1 + 1, H, !0) : y.set(8, 15 - Q - 1, H, !0);
        y.set(I - 8, 8, 1, !0);
    }
    function g(y, x) {
        const C = y.size;
        let I = -1, M = C - 1, Q = 7, H = 0;
        for(let J = C - 1; J > 0; J -= 2)for(J === 6 && J--;;){
            for(let W = 0; W < 2; W++)if (!y.isReserved(M, J - W)) {
                let P = !1;
                H < x.length && (P = (x[H] >>> Q & 1) === 1), y.set(M, J - W, P), Q--, Q === -1 && (H++, Q = 7);
            }
            if (M += I, M < 0 || C <= M) {
                M -= I, I = -I;
                break;
            }
        }
    }
    function A(y, x, C) {
        const I = new r();
        C.forEach(function(W) {
            I.put(W.mode.bit, 4), I.put(W.getLength(), d.getCharCountIndicator(W.mode, y)), W.write(I);
        });
        const M = e.getSymbolTotalCodewords(y), Q = a.getTotalCodewordsCount(y, x), H = (M - Q) * 8;
        for(I.getLengthInBits() + 4 <= H && I.put(0, 4); I.getLengthInBits() % 8 !== 0;)I.putBit(0);
        const J = (H - I.getLengthInBits()) / 8;
        for(let W = 0; W < J; W++)I.put(W % 2 ? 17 : 236, 8);
        return b(I, y, x);
    }
    function b(y, x, C) {
        const I = e.getSymbolTotalCodewords(x), M = a.getTotalCodewordsCount(x, C), Q = I - M, H = a.getBlocksCount(x, C), J = I % H, W = H - J, P = Math.floor(I / H), R = Math.floor(Q / H), V = R + 1, X = P - R, N = new u(X);
        let U = 0;
        const G = new Array(H), re = new Array(H);
        let oe = 0;
        const ie = new Uint8Array(y.buffer);
        for(let we = 0; we < H; we++){
            const ve = we < W ? R : V;
            G[we] = ie.slice(U, U + ve), re[we] = N.encode(G[we]), U += ve, oe = Math.max(oe, ve);
        }
        const le = new Uint8Array(I);
        let he = 0, ye, be;
        for(ye = 0; ye < oe; ye++)for(be = 0; be < H; be++)ye < G[be].length && (le[he++] = G[be][ye]);
        for(ye = 0; ye < X; ye++)for(be = 0; be < H; be++)le[he++] = re[be][ye];
        return le;
    }
    function k(y, x, C, I) {
        let M;
        if (Array.isArray(y)) M = h.fromArray(y);
        else if (typeof y == "string") {
            let P = x;
            if (!P) {
                const R = h.rawSplit(y);
                P = l.getBestVersionForData(R, C);
            }
            M = h.fromString(y, P || 40);
        } else throw new Error("Invalid data");
        const Q = l.getBestVersionForData(M, C);
        if (!Q) throw new Error("The amount of data is too big to be stored in a QR Code");
        if (!x) x = Q;
        else if (x < Q) throw new Error(`
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + Q + `.
`);
        const H = A(x, C, M), J = e.getSymbolSize(x), W = new i(J);
        return f(W, x), p(W), m(W, x), v(W, C, 0), x >= 7 && w(W, x), g(W, H), isNaN(I) && (I = s.getBestMask(W, v.bind(null, W, C))), s.applyMask(I, W), v(W, C, I), {
            modules: W,
            version: x,
            errorCorrectionLevel: C,
            maskPattern: I,
            segments: M
        };
    }
    return $914aec8743edd630$var$Qs.create = function(x, C) {
        if (typeof x > "u" || x === "") throw new Error("No input text");
        let I = t.M, M, Q;
        return typeof C < "u" && (I = t.from(C.errorCorrectionLevel, t.M), M = l.from(C.version), Q = s.from(C.maskPattern), C.toSJISFunc && e.setToSJISFunction(C.toSJISFunc)), k(x, M, I, Q);
    }, $914aec8743edd630$var$Qs;
}
var $914aec8743edd630$var$pu = {}, $914aec8743edd630$var$mu = {}, $914aec8743edd630$var$pm;
function $914aec8743edd630$var$jb() {
    return $914aec8743edd630$var$pm || ($914aec8743edd630$var$pm = 1, function(e) {
        function t(r) {
            if (typeof r == "number" && (r = r.toString()), typeof r != "string") throw new Error("Color should be defined as hex string");
            let i = r.slice().replace("#", "").split("");
            if (i.length < 3 || i.length === 5 || i.length > 8) throw new Error("Invalid hex color: " + r);
            (i.length === 3 || i.length === 4) && (i = Array.prototype.concat.apply([], i.map(function(o) {
                return [
                    o,
                    o
                ];
            }))), i.length === 6 && i.push("F", "F");
            const n = parseInt(i.join(""), 16);
            return {
                r: n >> 24 & 255,
                g: n >> 16 & 255,
                b: n >> 8 & 255,
                a: n & 255,
                hex: "#" + i.slice(0, 6).join("")
            };
        }
        e.getOptions = function(i) {
            i || (i = {}), i.color || (i.color = {});
            const n = typeof i.margin > "u" || i.margin === null || i.margin < 0 ? 4 : i.margin, o = i.width && i.width >= 21 ? i.width : void 0, s = i.scale || 4;
            return {
                width: o,
                scale: o ? 4 : s,
                margin: n,
                color: {
                    dark: t(i.color.dark || "#000000ff"),
                    light: t(i.color.light || "#ffffffff")
                },
                type: i.type,
                rendererOpts: i.rendererOpts || {}
            };
        }, e.getScale = function(i, n) {
            return n.width && n.width >= i + n.margin * 2 ? n.width / (i + n.margin * 2) : n.scale;
        }, e.getImageWidth = function(i, n) {
            const o = e.getScale(i, n);
            return Math.floor((i + n.margin * 2) * o);
        }, e.qrToImageData = function(i, n, o) {
            const s = n.modules.size, a = n.modules.data, u = e.getScale(s, o), l = Math.floor((s + o.margin * 2) * u), c = o.margin * u, d = [
                o.color.light,
                o.color.dark
            ];
            for(let h = 0; h < l; h++)for(let f = 0; f < l; f++){
                let p = (h * l + f) * 4, m = o.color.light;
                if (h >= c && f >= c && h < l - c && f < l - c) {
                    const w = Math.floor((h - c) / u), v = Math.floor((f - c) / u);
                    m = d[a[w * s + v] ? 1 : 0];
                }
                i[p++] = m.r, i[p++] = m.g, i[p++] = m.b, i[p] = m.a;
            }
        };
    }($914aec8743edd630$var$mu)), $914aec8743edd630$var$mu;
}
var $914aec8743edd630$var$mm;
function $914aec8743edd630$var$uF() {
    return $914aec8743edd630$var$mm || ($914aec8743edd630$var$mm = 1, function(e) {
        const t = $914aec8743edd630$var$jb();
        function r(n, o, s) {
            n.clearRect(0, 0, o.width, o.height), o.style || (o.style = {}), o.height = s, o.width = s, o.style.height = s + "px", o.style.width = s + "px";
        }
        function i() {
            try {
                return document.createElement("canvas");
            } catch  {
                throw new Error("You need to specify a canvas element");
            }
        }
        e.render = function(o, s, a) {
            let u = a, l = s;
            typeof u > "u" && (!s || !s.getContext) && (u = s, s = void 0), s || (l = i()), u = t.getOptions(u);
            const c = t.getImageWidth(o.modules.size, u), d = l.getContext("2d"), h = d.createImageData(c, c);
            return t.qrToImageData(h.data, o, u), r(d, l, c), d.putImageData(h, 0, 0), l;
        }, e.renderToDataURL = function(o, s, a) {
            let u = a;
            typeof u > "u" && (!s || !s.getContext) && (u = s, s = void 0), u || (u = {});
            const l = e.render(o, s, u), c = u.type || "image/png", d = u.rendererOpts || {};
            return l.toDataURL(c, d.quality);
        };
    }($914aec8743edd630$var$pu)), $914aec8743edd630$var$pu;
}
var $914aec8743edd630$var$gu = {}, $914aec8743edd630$var$gm;
function $914aec8743edd630$var$cF() {
    if ($914aec8743edd630$var$gm) return $914aec8743edd630$var$gu;
    $914aec8743edd630$var$gm = 1;
    const e = $914aec8743edd630$var$jb();
    function t(n, o) {
        const s = n.a / 255, a = o + '="' + n.hex + '"';
        return s < 1 ? a + " " + o + '-opacity="' + s.toFixed(2).slice(1) + '"' : a;
    }
    function r(n, o, s) {
        let a = n + o;
        return typeof s < "u" && (a += " " + s), a;
    }
    function i(n, o, s) {
        let a = "", u = 0, l = !1, c = 0;
        for(let d = 0; d < n.length; d++){
            const h = Math.floor(d % o), f = Math.floor(d / o);
            !h && !l && (l = !0), n[d] ? (c++, d > 0 && h > 0 && n[d - 1] || (a += l ? r("M", h + s, 0.5 + f + s) : r("m", u, 0), u = 0, l = !1), h + 1 < o && n[d + 1] || (a += r("h", c), c = 0)) : u++;
        }
        return a;
    }
    return $914aec8743edd630$var$gu.render = function(o, s, a) {
        const u = e.getOptions(s), l = o.modules.size, c = o.modules.data, d = l + u.margin * 2, h = u.color.light.a ? "<path " + t(u.color.light, "fill") + ' d="M0 0h' + d + "v" + d + 'H0z"/>' : "", f = "<path " + t(u.color.dark, "stroke") + ' d="' + i(c, l, u.margin) + '"/>', p = 'viewBox="0 0 ' + d + " " + d + '"', w = '<svg xmlns="http://www.w3.org/2000/svg" ' + (u.width ? 'width="' + u.width + '" height="' + u.width + '" ' : "") + p + ' shape-rendering="crispEdges">' + h + f + `</svg>
`;
        return typeof a == "function" && a(null, w), w;
    }, $914aec8743edd630$var$gu;
}
var $914aec8743edd630$var$bm;
function $914aec8743edd630$var$lF() {
    if ($914aec8743edd630$var$bm) return $914aec8743edd630$var$Kt;
    $914aec8743edd630$var$bm = 1;
    const e = $914aec8743edd630$var$V9(), t = $914aec8743edd630$var$sF(), r = $914aec8743edd630$var$uF(), i = $914aec8743edd630$var$cF();
    function n(o, s, a, u, l) {
        const c = [].slice.call(arguments, 1), d = c.length, h = typeof c[d - 1] == "function";
        if (!h && !e()) throw new Error("Callback required as last argument");
        if (h) {
            if (d < 2) throw new Error("Too few arguments provided");
            d === 2 ? (l = a, a = s, s = u = void 0) : d === 3 && (s.getContext && typeof l > "u" ? (l = u, u = void 0) : (l = u, u = a, a = s, s = void 0));
        } else {
            if (d < 1) throw new Error("Too few arguments provided");
            return d === 1 ? (a = s, s = u = void 0) : d === 2 && !s.getContext && (u = a, a = s, s = void 0), new Promise(function(f, p) {
                try {
                    const m = t.create(a, u);
                    f(o(m, s, u));
                } catch (m) {
                    p(m);
                }
            });
        }
        try {
            const f = t.create(a, u);
            l(null, o(f, s, u));
        } catch (f) {
            l(f);
        }
    }
    return $914aec8743edd630$var$Kt.create = t.create, $914aec8743edd630$var$Kt.toCanvas = n.bind(null, r.render), $914aec8743edd630$var$Kt.toDataURL = n.bind(null, r.renderToDataURL), $914aec8743edd630$var$Kt.toString = n.bind(null, function(o, s, a) {
        return i.render(o, a);
    }), $914aec8743edd630$var$Kt;
}
var $914aec8743edd630$var$dF = $914aec8743edd630$var$lF();
const $914aec8743edd630$var$Fb = /* @__PURE__ */ $914aec8743edd630$var$_y($914aec8743edd630$var$dF), $914aec8743edd630$var$fF = async ({ url: e, title: t, download: r })=>{
    const i = await $914aec8743edd630$var$Fb.toDataURL(e), n = t && !t.includes("pause0x0") && !t.includes("pause1x1") && !t.includes("pause2x2");
    return {
        contentType: $914aec8743edd630$var$yc,
        content: {
            urlData: {
                url: e,
                title: n ? t : void 0,
                download: r
            },
            qrCode: i
        }
    };
}, $914aec8743edd630$var$hF = async (e)=>{
    const t = [];
    for (const r of e){
        const i = await $914aec8743edd630$var$Fb.toDataURL(r.url), n = {
            contentType: $914aec8743edd630$var$yc,
            content: {
                urlData: {
                    url: r.url,
                    title: r.title,
                    download: r.download
                },
                qrCode: i
            }
        };
        t.push(n);
    }
    return t;
}, $914aec8743edd630$var$pF = async (e)=>{
    const t = await $914aec8743edd630$var$mF(e.url);
    let r = !1;
    return t.width === 0 && t.height === 0 ? e = {
        url: `${$914aec8743edd630$var$$2}/no-image.png`,
        alt: "Image no found"
    } : r = t.width < 400 && t.height < 300, {
        contentType: $914aec8743edd630$var$DI,
        content: {
            ...e,
            isMiniature: r
        }
    };
}, $914aec8743edd630$var$mF = async (e)=>new Promise((t)=>{
        const r = new Image();
        r.onload = ()=>t({
                width: r.naturalWidth,
                height: r.naturalHeight
            }), r.onerror = ()=>{
            t({
                width: 0,
                height: 0
            });
        }, r.src = e;
    }), $914aec8743edd630$var$gF = (e)=>{
    const t = {
        speak: void 0,
        text: void 0,
        htmlText: void 0,
        images: [],
        urls: []
    }, r = [], i = [];
    if (e != null && e.speak) {
        const n = $914aec8743edd630$var$Mu(e.speak);
        t.speak = n.text, t.images = n.images, t.urls = n.urls, n.images.forEach((o)=>{
            r.push(o.url);
        }), n.urls.forEach((o)=>{
            i.push(o.url);
        });
    }
    if (e != null && e.text) {
        const n = $914aec8743edd630$var$Mu(e.text);
        t.text = n.text, t.htmlText = n.htmlText, n.images.forEach((o)=>{
            !r.includes(o.url) && t.images.push(o);
        }), n.urls.forEach((o)=>{
            !i.includes(o.url) && t.urls.push(o);
        });
    }
    return t;
}, $914aec8743edd630$var$Fu = {
    activities: [],
    endedActivities: [],
    lastActivity: void 0,
    lastBotActivity: void 0,
    messageActivities: [],
    lastMessageActivity: void 0,
    eventActivities: [],
    lastEventActivity: void 0,
    botMessageActivities: [],
    lastBotMessageActivity: void 0,
    botEventActivities: [],
    lastBotEventActivity: void 0,
    botStreamingActivities: {},
    processedActivity: void 0,
    userMessageActivities: [],
    lastUserMessageActivity: void 0,
    conversationId: null,
    watermark: 0,
    retrievingConversation: !1,
    addRetorikNewsConversationIdInLocalStorage: void 0,
    cookies: [],
    queue: [],
    queueLock: !1
}, $914aec8743edd630$var$bu = /(\{data-command=")[\p{L}\p{N}\p{Po}\p{Pd}\p{Pc}\s\u0027\u2019]+("\})(<br\s\/>)?/gu, $914aec8743edd630$var$$b = $914aec8743edd630$var$mt({
    name: "activity",
    initialState: $914aec8743edd630$var$Fu,
    reducers: {
        addCookie: (e, t)=>{
            t.payload && (e.cookies = [
                ...e.cookies,
                t.payload
            ]);
        },
        setCookiesInBrowser: (e, t)=>{
            const r = e.cookies;
            r.length && (r.forEach((i)=>{
                if (i.indexOf("<conversationId>") > -1) {
                    if (t.payload) {
                        const n = i.replace("<conversationId>", t.payload);
                        document.cookie = n;
                    }
                } else document.cookie = i;
            }), e.cookies = []);
        },
        setCurrentQueue: (e, t)=>{
            e.queue = t.payload;
        },
        setQueueLock: (e, t)=>{
            e.queueLock = t.payload;
        },
        addUserEvent: (e, t)=>e.conversationId && t.payload.id.includes(e.conversationId) ? (!$914aec8743edd630$var$z2.find((r)=>{
                var i;
                return (i = t.payload.name) == null ? void 0 : i.toLowerCase().includes(r);
            }) && $914aec8743edd630$var$Bt(!0), {
                ...e,
                activities: [
                    ...e.activities,
                    t.payload
                ],
                lastActivity: t.payload,
                lastEventActivity: t.payload,
                eventActivities: [
                    ...e.eventActivities,
                    t.payload
                ],
                watermark: e.watermark + 1
            }) : {
                ...e
            },
        addEndedActivity: (e, t)=>{
            e.endedActivities.includes(t.payload) || (e.endedActivities = [
                ...e.endedActivities,
                t.payload
            ]);
        },
        setRetrievingConversation: (e, t)=>{
            e.retrievingConversation = t.payload;
        },
        setAddRetorikNewsConversationIdInLocalStorage: (e, t)=>{
            e.addRetorikNewsConversationIdInLocalStorage = t.payload;
        },
        resetProcessedActivity: (e)=>{
            e.processedActivity = void 0;
        },
        resetActivityStore: ()=>({
                ...$914aec8743edd630$var$Fu
            })
    },
    extraReducers: (e)=>{
        e.addCase($914aec8743edd630$var$Rc.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            })).addCase($914aec8743edd630$var$gn.fulfilled, (t, r)=>r.payload ? {
                ...t,
                ...r.payload
            } : {
                ...t
            }).addCase($914aec8743edd630$var$Oc.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            })).addCase($914aec8743edd630$var$Dc.fulfilled, (t, r)=>r.payload ? {
                ...t,
                ...r.payload
            } : {
                ...t
            }).addCase($914aec8743edd630$var$Pc.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            })).addCase($914aec8743edd630$var$Ic.fulfilled, (t, r)=>r.payload ? {
                ...t,
                ...r.payload
            } : {
                ...t
            }).addCase($914aec8743edd630$var$Mc.fulfilled, (t, r)=>r.payload ? {
                ...t,
                ...r.payload
            } : {
                ...t
            }).addCase($914aec8743edd630$var$Lb.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            }));
    }
}), $914aec8743edd630$var$Rc = $914aec8743edd630$var$Ae("activity/checkConversationId", async (e, t)=>{
    const r = t.getState().activityReducer;
    let i = {};
    if (r.addRetorikNewsConversationIdInLocalStorage) {
        const n = {
            conversationId: e,
            startedAt: Date.now()
        };
        localStorage.setItem(`Retorik.News.Conversation.${r.addRetorikNewsConversationIdInLocalStorage}`, JSON.stringify(n)), i.addRetorikNewsConversationIdInLocalStorage = void 0;
    }
    return e && e !== r.conversationId && (r.conversationId === null ? i.conversationId = e : i = {
        ...$914aec8743edd630$var$Fu,
        conversationId: e
    }, t.dispatch($914aec8743edd630$var$Nb(e))), i;
}), $914aec8743edd630$var$gn = $914aec8743edd630$var$Ae("activity/processQueue", async (e, t)=>{
    const r = t.getState().activityReducer;
    if (r.queue.length) {
        const i = r.queue[0];
        i.type === "message" ? await t.dispatch($914aec8743edd630$var$Oc(i)) : await t.dispatch($914aec8743edd630$var$Pc(i)), t.dispatch($914aec8743edd630$var$Bb(r.queue.slice(1))), await t.dispatch($914aec8743edd630$var$gn());
        return;
    } else return {
        queueLock: !1
    };
}), $914aec8743edd630$var$Oc = $914aec8743edd630$var$Ae("activity/processAddBotMessage", async (e, t)=>{
    t.dispatch($914aec8743edd630$var$Jg(void 0)), await t.dispatch($914aec8743edd630$var$Lb(e));
    const r = t.getState().activityReducer, i = structuredClone(r.processedActivity), n = r.retrievingConversation ? void 0 : i;
    return !r.retrievingConversation && i && t.dispatch($914aec8743edd630$var$Bc(i)), i ? {
        activities: [
            ...r.activities,
            i
        ],
        lastActivity: n,
        lastBotActivity: n,
        messageActivities: [
            ...r.messageActivities,
            i
        ],
        botMessageActivities: [
            ...r.botMessageActivities,
            i
        ],
        lastMessageActivity: n,
        lastBotMessageActivity: n,
        processedActivity: void 0,
        watermark: r.watermark + 1
    } : {
        lastActivity: n,
        lastBotActivity: n,
        lastMessageActivity: n,
        lastBotMessageActivity: n,
        watermark: r.watermark + 1
    };
}), $914aec8743edd630$var$Dc = $914aec8743edd630$var$Ae("activity/addBotMessage", async (e, t)=>{
    const r = t.getState().activityReducer;
    if (r.conversationId && e.id.includes(r.conversationId)) {
        if (r.queueLock) return {
            queue: [
                ...r.queue,
                e
            ]
        };
        t.dispatch($914aec8743edd630$var$jc(!0)), await t.dispatch($914aec8743edd630$var$Oc(e)), t.dispatch($914aec8743edd630$var$fn()), t.dispatch($914aec8743edd630$var$Bt(!1)), await t.dispatch($914aec8743edd630$var$gn());
        return;
    }
}), $914aec8743edd630$var$Pc = $914aec8743edd630$var$Ae("activity/processAddBotEvent", async (e, t)=>{
    var n, o;
    const r = t.getState().activityReducer, i = structuredClone(r.botStreamingActivities);
    if (((n = e.name) == null ? void 0 : n.toLowerCase()) === "davi.streammessageactivity" && (o = e.text) != null && o.trim().length && !r.retrievingConversation) {
        const s = $914aec8743edd630$var$Mu(e.text, !0);
        if (e.speak = s.text, e.htmlText = s.htmlText, t.dispatch($914aec8743edd630$var$Bc(e)), e.replyToId) {
            const a = i[e.replyToId];
            i[e.replyToId] = a ? [
                ...a,
                e
            ] : [
                e
            ];
        }
    }
    return {
        activities: [
            ...r.activities,
            e
        ],
        lastActivity: r.retrievingConversation ? void 0 : e,
        lastBotActivity: r.retrievingConversation ? void 0 : e,
        eventActivities: [
            ...r.eventActivities,
            e
        ],
        botEventActivities: [
            ...r.botEventActivities,
            e
        ],
        lastBotEventActivity: e,
        lastEventActivity: e,
        botStreamingActivities: i,
        watermark: r.watermark + 1
    };
}), $914aec8743edd630$var$Ic = $914aec8743edd630$var$Ae("activity/addBotEvent", async (e, t)=>{
    var i;
    const r = t.getState().activityReducer;
    if (r.conversationId && e.id.includes(r.conversationId)) {
        if (((i = e.name) == null ? void 0 : i.toLowerCase()) === "switchtotextmode") return t.dispatch($914aec8743edd630$var$Lc($914aec8743edd630$var$Ft.text)), {
            watermark: r.watermark + 1
        };
        if (r.queueLock) return {
            queue: [
                ...r.queue,
                e
            ]
        };
        t.dispatch($914aec8743edd630$var$jc(!0)), await t.dispatch($914aec8743edd630$var$Pc(e)), t.dispatch($914aec8743edd630$var$fn()), t.dispatch($914aec8743edd630$var$Bt(!1)), t.dispatch($914aec8743edd630$var$gn());
        return;
    }
}), $914aec8743edd630$var$Mc = $914aec8743edd630$var$Ae("activity/addUserMessage", async (e, t)=>{
    const r = t.getState().activityReducer;
    if (r.conversationId && e.id.includes(r.conversationId)) return t.dispatch($914aec8743edd630$var$Bt(!0)), {
        activities: [
            ...r.activities,
            e
        ],
        lastActivity: e,
        messageActivities: [
            ...r.messageActivities,
            e
        ],
        userMessageActivities: [
            ...r.userMessageActivities,
            e
        ],
        lastMessageActivity: e,
        lastUserMessageActivity: e,
        watermark: r.watermark + 1
    };
}), $914aec8743edd630$var$Lb = $914aec8743edd630$var$Ae("activity/processBotMessageActivity", async (e, t)=>{
    var o, s, a, u, l, c, d, h, f, p, m, w, v, g, A, b, k, y, x, C, I;
    const r = t.getState();
    if (t.dispatch($914aec8743edd630$var$Zg(!!((o = e == null ? void 0 : e.channelData) != null && o.restoreInputsState))), t.dispatch($914aec8743edd630$var$rb(((a = (s = e.value) == null ? void 0 : s.retorik) == null ? void 0 : a.placeHolder) || void 0)), t.dispatch($914aec8743edd630$var$nb((l = (u = e.value) == null ? void 0 : u.retorik) == null ? void 0 : l.submitDelay)), ((c = e.attachmentLayout) == null ? void 0 : c.toLowerCase()) === "namedlist" && (d = e.attachments) != null && d.length) {
        const M = (h = e.attachments[0].content) == null ? void 0 : h.value;
        if (Array.isArray(M) && M.length > 12) {
            const Q = (f = e.attachments[0].content) == null ? void 0 : f.title, H = M.pop(), J = Math.ceil(M.length / 11), W = [], P = r.localeReducer.locale || "fr-FR";
            M.forEach((R)=>{
                if (R.text) {
                    const V = R.text.split(" ");
                    V.length > 1 ? R.group = V[1].charAt(0).toLocaleUpperCase(P) : R.group = V[0].charAt(0).toLocaleUpperCase(P);
                }
            });
            for(let R = 0; R < J; R++)W.push({
                contentType: $914aec8743edd630$var$jI,
                content: {
                    title: Q,
                    value: [
                        ...M.slice(R * 11, R * 11 + 11),
                        H
                    ]
                }
            });
            e.attachments = W;
        }
    }
    if (r.retorikReducer.configuration.isUsedOnBorne && (p = e.attachments) != null && p.length) {
        let M = 0;
        const Q = [];
        for (const H of e.attachments)if (H.contentType === $914aec8743edd630$var$yc && Array.isArray((m = H.content) == null ? void 0 : m.urlData)) {
            M++;
            const J = await $914aec8743edd630$var$hF(H.content.urlData);
            Q.push(...J);
        } else Q.push(H);
        M && (e.attachments = Q), M && e.attachments.length > 1 && (e.attachmentLayout = "carousel");
    }
    const i = $914aec8743edd630$var$gF(e);
    if (i.speak && (e.speak = i.speak), i.text && (e.text = i.text), i.htmlText && (e.htmlText = i.htmlText), i.images.length) {
        e.attachments === void 0 && (e.attachments = []);
        for (const M of i.images){
            const Q = await $914aec8743edd630$var$pF(M);
            e.attachments.push(Q);
        }
        e.attachments.length > 1 && (e.attachmentLayout = "carousel");
    }
    if (i.urls.length) {
        e.attachments === void 0 && (e.attachments = []);
        for (const M of i.urls){
            const Q = await $914aec8743edd630$var$fF(M);
            e.attachments.push(Q);
        }
        e.attachments.length > 1 && (e.attachmentLayout = "carousel");
    }
    const n = $914aec8743edd630$var$U9(e.attachments);
    if (n && (e.attachments = [
        ...n
    ]), (w = e.suggestedActions) != null && w.actions && ((v = e.attachmentLayout) == null ? void 0 : v.toLowerCase()) !== "davilist") {
        let M = [];
        e.suggestedActions.actions.forEach((H)=>{
            const J = {
                title: H.title,
                action: H.value
            };
            M = [
                ...M,
                J
            ];
        });
        const Q = {
            contentType: $914aec8743edd630$var$II,
            content: {
                title: e.text || "",
                actions: M
            }
        };
        e.attachments === void 0 ? e.attachments = [
            Q
        ] : e.attachments.push(Q);
    }
    if (e != null && e.text && e.text.includes("{data-command=")) {
        const M = e.text.split("{data-command="), Q = [];
        for(let H = 1; H < M.length; H++){
            const J = M[H - 1].substring(M[H - 1].lastIndexOf(`
`) ? M[H - 1].lastIndexOf(`
`) + 1 : 0).trim(), W = M[H].substring(0, M[H].indexOf("}")).replaceAll('"', "");
            Q.push({
                text: J,
                differentTextToSend: W
            }), e.speak && (e.speak = e.speak.replace(J, "")), e.text = e.text.replace(J, ""), e.htmlText = (g = e.htmlText) == null ? void 0 : g.replace(J, "");
        }
        if (Q.length > 0) {
            const H = {
                contentType: $914aec8743edd630$var$PI,
                content: {
                    suggestions: Q,
                    showTutorial: !1
                }
            };
            e.attachments === void 0 ? e.attachments = [
                H
            ] : e.attachments.push(H);
        }
        e.speak && (e.speak = e.speak.replaceAll($914aec8743edd630$var$bu, "")), e.text = e.text.replaceAll($914aec8743edd630$var$bu, ""), e.htmlText = (A = e.htmlText) == null ? void 0 : A.replaceAll($914aec8743edd630$var$bu, "");
    }
    if (((k = (b = e.value) == null ? void 0 : b.retorik) != null && k.placeHolder || (x = (y = e.value) == null ? void 0 : y.retorik) != null && x.submitDelay) && !((C = e.attachments) != null && C.length) && (e.attachments = [
        {
            contentType: $914aec8743edd630$var$MI
        }
    ]), (I = r.retorikReducer.configuration.speechRecognitionOptions) != null && I.inputHintBehaviour) switch(r.retorikReducer.configuration.speechRecognitionOptions.inputHintBehaviour.toLowerCase()){
        case $914aec8743edd630$var$Vr.always:
            e.inputHint = "expectingInput";
            break;
        case $914aec8743edd630$var$Vr.ignore:
        case $914aec8743edd630$var$Vr.never:
            e.inputHint = "ignoreInput";
            break;
        case $914aec8743edd630$var$Vr.auto:
    }
    return {
        processedActivity: e
    };
}), $914aec8743edd630$var$bF = $914aec8743edd630$var$$b.reducer, { addCookie: $914aec8743edd630$var$vF, setCookiesInBrowser: $914aec8743edd630$var$Nb, setCurrentQueue: $914aec8743edd630$var$Bb, setQueueLock: $914aec8743edd630$var$jc, addUserEvent: $914aec8743edd630$var$qb, addEndedActivity: $914aec8743edd630$var$yF, setRetrievingConversation: $914aec8743edd630$var$zb, setAddRetorikNewsConversationIdInLocalStorage: $914aec8743edd630$var$wF, resetProcessedActivity: $914aec8743edd630$var$_F, resetActivityStore: $914aec8743edd630$var$Ub } = $914aec8743edd630$var$$b.actions, $914aec8743edd630$var$Vb = {
    directLine: null,
    directLineStatus: $914aec8743edd630$var$Zt.ConnectionStatus.Uninitialized,
    connectionStatusSubscription: null,
    activitySubscription: null,
    userId: "",
    externalActivityHandlers: [],
    paginationToSend: 10,
    positionToSend: void 0,
    activityWatermark: 0,
    conversationPaused: !1,
    typingCount: 0,
    storedVeilleConversationData: void 0,
    version: void 0,
    applicationIsBusy: !1
}, $914aec8743edd630$var$kF = [
    $914aec8743edd630$var$Ie.SEND_MESSAGE,
    $914aec8743edd630$var$Ie.SEND_EVENT
], $914aec8743edd630$var$xF = [
    "setuser",
    "davi.gdprconsent"
], $914aec8743edd630$var$It = (e)=>(e < 10 ? "0" : "") + e, $914aec8743edd630$var$Gb = (e = /* @__PURE__ */ new Date())=>{
    const t = -e.getTimezoneOffset(), r = t >= 0 ? "+" : "-";
    return e.getFullYear() + "-" + $914aec8743edd630$var$It(e.getMonth() + 1) + "-" + $914aec8743edd630$var$It(e.getDate()) + "T" + $914aec8743edd630$var$It(e.getHours()) + ":" + $914aec8743edd630$var$It(e.getMinutes()) + ":" + $914aec8743edd630$var$It(e.getSeconds()) + r + $914aec8743edd630$var$It(Math.floor(Math.abs(t) / 60)) + ":" + $914aec8743edd630$var$It(Math.abs(t) % 60);
}, $914aec8743edd630$var$SF = (e, t)=>{
    const r = e;
    return e.from ? e.from.role || (e.from.id === t ? r.from = {
        ...r.from,
        role: "user"
    } : e.from.id ? r.from = {
        ...r.from,
        role: "bot"
    } : r.from = {
        ...r.from,
        role: "channel"
    }) : r.from = {
        ...r.from,
        role: "channel"
    }, r;
}, $914aec8743edd630$var$tr = (e, t, r)=>{
    if (r.length) {
        const i = {
            type: e,
            payload: {
                activity: t
            }
        };
        for(let n = 0; n < r.length; n++){
            const o = r[n];
            if (o(i)) return console.log("Retorik Framework > aborted activity"), !0;
        }
    }
    return !1;
}, $914aec8743edd630$var$Wb = (e, t, r, i)=>{
    const n = {
        pageSize: e || 10,
        version: r
    };
    return t != null && t.latitude && t.longitude && (n.location = {
        latitude: t.latitude,
        longitude: t.longitude
    }, n.position = {
        latitude: t.latitude,
        longitude: t.longitude
    }), i ? {
        ...n,
        ...i
    } : n;
}, $914aec8743edd630$var$Hb = $914aec8743edd630$var$mt({
    name: "directline",
    initialState: $914aec8743edd630$var$Vb,
    reducers: {
        dispatchStatus: (e, t)=>{
            e.directLineStatus = t.payload, e.externalActivityHandlers.forEach((r)=>{
                r({
                    type: $914aec8743edd630$var$vc[t.payload]
                }), t.payload === $914aec8743edd630$var$Zt.ConnectionStatus.Online && r({
                    type: $914aec8743edd630$var$Ie.SET_LANGUAGE
                });
            });
        },
        setActivityWatermark: (e, t)=>{
            e.activityWatermark = t.payload;
        },
        unsubscribe: (e)=>{
            var t, r;
            (t = e.connectionStatusSubscription) == null || t.unsubscribe(), (r = e.activitySubscription) == null || r.unsubscribe();
        },
        sendTyping: (e)=>{
            var t;
            e.conversationPaused || ((t = e.directLine) == null || t.postActivity({
                from: {
                    id: e.userId
                },
                type: "typing"
            }).subscribe(), e.typingCount = e.typingCount + 1);
        },
        setPaginationToSend: (e, t)=>{
            e.paginationToSend = t.payload;
        },
        addExternalActivityHandler: (e, t)=>{
            e.externalActivityHandlers = [
                ...e.externalActivityHandlers,
                t.payload
            ];
        },
        setExternalActivityHandlers: (e, t)=>{
            e.externalActivityHandlers = t.payload;
        },
        setPositionToSend: (e, t)=>{
            e.positionToSend = t.payload;
        },
        dispatchMarkActivity: (e, t)=>{
            const r = {
                type: $914aec8743edd630$var$Ie.MARK,
                payload: {
                    activityID: t.payload.id,
                    name: "speak",
                    value: t.payload.speaking
                }
            };
            e.externalActivityHandlers.forEach((i)=>{
                i(r);
            });
        },
        pauseConversation: (e)=>{
            e.conversationPaused = !0;
        },
        resumeConversation: (e)=>{
            e.conversationPaused = !1;
        },
        setVersion: (e, t)=>{
            e.version = t.payload;
        },
        setStoredVeilleConversationData: (e, t)=>{
            e.storedVeilleConversationData = t.payload ? {
                ...e.storedVeilleConversationData,
                id: t.payload
            } : void 0;
        },
        setApplicationIsBusy: (e, t)=>{
            e.applicationIsBusy = t.payload;
        }
    },
    extraReducers: (e)=>{
        e.addCase($914aec8743edd630$var$rn.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            })).addCase($914aec8743edd630$var$Kb.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            })).addCase($914aec8743edd630$var$Qb.fulfilled, (t, r)=>r.payload ? {
                ...t,
                ...r.payload
            } : {
                ...t
            }).addCase($914aec8743edd630$var$Zb.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            }));
    }
}), $914aec8743edd630$var$Fc = $914aec8743edd630$var$Ae("directline/dispatchActivity", async (e, t)=>{
    var o, s, a, u, l, c;
    const r = t.getState();
    if (r.directlineReducer.conversationPaused) return;
    if (r.activityReducer.retrievingConversation) {
        const d = (o = r.directlineReducer.directLine) == null ? void 0 : o.watermark;
        if (!isNaN(parseInt(d))) {
            const h = r.directlineReducer.activityWatermark + 1;
            h === parseInt(d) ? t.dispatch($914aec8743edd630$var$zb(!1)) : t.dispatch($914aec8743edd630$var$ev(h));
        }
    }
    e.conversation && t.dispatch($914aec8743edd630$var$Rc(e.conversation.id));
    const i = $914aec8743edd630$var$eI($914aec8743edd630$var$SF(e, r.directlineReducer.userId));
    let n = $914aec8743edd630$var$Ie.UNKNOWN;
    switch(i.type){
        case "message":
            n = i.from.role === "user" ? $914aec8743edd630$var$Ie.SEND_MESSAGE : $914aec8743edd630$var$Ie.INCOMING_ACTIVITY;
            break;
        case "event":
            n = i.from.role === "user" ? $914aec8743edd630$var$Ie.SEND_EVENT : $914aec8743edd630$var$Ie.INCOMING_ACTIVITY;
            break;
        case "typing":
            n = $914aec8743edd630$var$Ie.TYPING;
            break;
    }
    switch(t.dispatch($914aec8743edd630$var$iv(i.replyToId)), n){
        case $914aec8743edd630$var$Ie.SEND_EVENT:
            t.dispatch($914aec8743edd630$var$qb(i));
            break;
        case $914aec8743edd630$var$Ie.SEND_MESSAGE:
            t.dispatch($914aec8743edd630$var$Mc(i));
            break;
        case $914aec8743edd630$var$Ie.INCOMING_ACTIVITY:
            {
                let d = !0;
                $914aec8743edd630$var$tr(n, e, r.directlineReducer.externalActivityHandlers) ? (t.dispatch($914aec8743edd630$var$Bt(!1)), t.dispatch($914aec8743edd630$var$fn()), d = !1) : ((s = i.channelData) != null && s.speechRecognitionGrammars && t.dispatch($914aec8743edd630$var$uv((a = i.channelData) == null ? void 0 : a.speechRecognitionGrammars)), i.type === "event" ? t.dispatch($914aec8743edd630$var$Ic(i)) : i.type === "message" && (((u = i.label) == null ? void 0 : u.toLowerCase()) === "davi.bringupmessage" && r.directlineReducer.applicationIsBusy ? d = !1 : t.dispatch($914aec8743edd630$var$Dc(i))), d && ((l = navigator.virtualKeyboard) == null || l.hide(), r.viewReducer.isTactile && ((c = document.getElementById("retorik-framework-send-textbox-textarea")) == null || c.blur())));
                break;
            }
    }
    $914aec8743edd630$var$kF.includes(n) && $914aec8743edd630$var$tr($914aec8743edd630$var$Ie.POST_ACTIVITY_FULFILLED, e, r.directlineReducer.externalActivityHandlers);
}), $914aec8743edd630$var$rn = $914aec8743edd630$var$Ae("directline/subscribe", async (e, t)=>{
    const r = e ? e.connectionStatus$.subscribe((n)=>{
        t.dispatch($914aec8743edd630$var$Xb(n));
    }) : null, i = e ? e.activity$.subscribe((n)=>{
        n.type !== "typing" && t.dispatch($914aec8743edd630$var$Fc(n));
    }) : null;
    return {
        directLine: e,
        connectionStatusSubscription: r,
        activitySubscription: i
    };
}), $914aec8743edd630$var$Kb = $914aec8743edd630$var$Ae("directline/createDirectline", async (e, t)=>{
    const i = t.getState().directlineReducer.externalActivityHandlers, n = i.length ? i : e.externalActivityHandler ? [
        e.externalActivityHandler
    ] : [];
    n.forEach((s)=>{
        s({
            type: $914aec8743edd630$var$vc[0]
        });
    });
    const o = new $914aec8743edd630$var$Zt.DirectLine({
        webSocket: !0,
        ...e
    });
    return t.dispatch($914aec8743edd630$var$rr()), t.dispatch($914aec8743edd630$var$rn(o)), {
        userId: e.userId || "userId",
        externalActivityHandlers: n
    };
}), $914aec8743edd630$var$Qb = $914aec8743edd630$var$Ae("directline/recreateDirectline", async (e, t)=>{
    var i, n, o, s, a, u;
    const r = t.getState().directlineReducer;
    if ((i = e.addressData) != null && i.directline) {
        if ((n = e.userId) != null && n.includes("veille_") && (o = r.storedVeilleConversationData) != null && o.userId && (s = r.storedVeilleConversationData) != null && s.id && (a = r.storedVeilleConversationData) != null && a.token) {
            const l = r.storedVeilleConversationData, c = new $914aec8743edd630$var$Zt.DirectLine({
                token: l.token,
                domain: e.addressData.directline.address,
                conversationId: l.id
            });
            return await t.dispatch($914aec8743edd630$var$rr()), await t.dispatch($914aec8743edd630$var$rn(c)), {
                userId: e.userId
            };
        } else {
            const l = await $914aec8743edd630$var$XP(e.addressData.directline.tokenEndpoint);
            if (l) {
                const c = e.userId || `defaultId_${Date.now()}`;
                await t.dispatch($914aec8743edd630$var$Ub()), r.externalActivityHandlers.forEach((h)=>{
                    h({
                        type: $914aec8743edd630$var$vc[0]
                    });
                });
                const d = new $914aec8743edd630$var$Zt.DirectLine({
                    token: l,
                    domain: e.addressData.directline.address
                });
                return await t.dispatch($914aec8743edd630$var$rr()), await t.dispatch($914aec8743edd630$var$rn(d)), await t.dispatch($914aec8743edd630$var$$u({
                    name: "Davi.GDPRConsent",
                    value: {
                        userConsent: !0
                    },
                    callback: ()=>t.dispatch($914aec8743edd630$var$$u({
                            name: "setUser",
                            value: {
                                user: {
                                    name: "default",
                                    id: c,
                                    username: "default",
                                    nom: "defaultName",
                                    prenom: "\xe0 vous",
                                    email: "",
                                    token: "",
                                    referrer: "",
                                    ipaddress: "",
                                    gdprConsent: !0
                                },
                                skipWelcome: !!e.skipWelcome
                            }
                        }))
                })), (u = e.userId) != null && u.includes("veille_") ? {
                    userId: c,
                    storedVeilleConversationData: {
                        userId: e.userId,
                        token: l
                    }
                } : {
                    userId: c
                };
            }
        }
    }
}), $914aec8743edd630$var$$c = $914aec8743edd630$var$Ae("directline/checkMicrophoneAndCancel", async (e, t)=>{
    const r = t.getState();
    r.speechReducer.mode === $914aec8743edd630$var$Ft.vocal && r.speechReducer.activeRecognitionState === $914aec8743edd630$var$at.Listening ? t.dispatch($914aec8743edd630$var$Nc(void 0)) : t.dispatch($914aec8743edd630$var$Vn());
}), $914aec8743edd630$var$Yb = $914aec8743edd630$var$Ae("directline/sendMessage", async (e, t)=>{
    var o;
    const r = t.getState();
    if (r.directlineReducer.conversationPaused) return;
    t.dispatch($914aec8743edd630$var$$c());
    const i = await t.dispatch($914aec8743edd630$var$Qg()), n = {
        from: {
            id: r.directlineReducer.userId
        },
        type: "message",
        channelData: $914aec8743edd630$var$Wb(r.directlineReducer.paginationToSend, r.directlineReducer.positionToSend, r.directlineReducer.version, r.retorikReducer.configuration.channelData),
        localTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        localTimestamp: $914aec8743edd630$var$Gb(),
        locale: i.payload
    };
    e.text && (n.text = e.text), e.value && (n.value = e.value), $914aec8743edd630$var$tr($914aec8743edd630$var$Ie.POST_ACTIVITY, n, r.directlineReducer.externalActivityHandlers) || $914aec8743edd630$var$tr($914aec8743edd630$var$Ie.SEND_MESSAGE, n, r.directlineReducer.externalActivityHandlers) ? (t.dispatch($914aec8743edd630$var$Bt(!1)), t.dispatch($914aec8743edd630$var$fn())) : (o = r.directlineReducer.directLine) == null || o.postActivity(n).subscribe();
}), $914aec8743edd630$var$$u = $914aec8743edd630$var$Ae("directline/sendEvent", async (e, t)=>{
    var o;
    const r = t.getState();
    if (r.directlineReducer.conversationPaused) return;
    !e.name.toLowerCase().includes("davi.closewindow") && !$914aec8743edd630$var$xF.includes(e.name.toLowerCase()) && t.dispatch($914aec8743edd630$var$$c());
    const i = await t.dispatch($914aec8743edd630$var$Qg()), n = {
        from: {
            id: r.directlineReducer.userId
        },
        type: "event",
        channelData: $914aec8743edd630$var$Wb(r.directlineReducer.paginationToSend, r.directlineReducer.positionToSend, r.directlineReducer.version, r.retorikReducer.configuration.channelData),
        locale: i.payload,
        localTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        localTimestamp: $914aec8743edd630$var$Gb(),
        name: e.name,
        value: e.value
    };
    $914aec8743edd630$var$tr($914aec8743edd630$var$Ie.POST_ACTIVITY, n, r.directlineReducer.externalActivityHandlers) || $914aec8743edd630$var$tr($914aec8743edd630$var$Ie.SEND_EVENT, n, r.directlineReducer.externalActivityHandlers) || (o = r.directlineReducer.directLine) == null || o.postActivity(n).subscribe({
        error: (s)=>console.log("Retorik Framework > error while sending event : ", s),
        complete: ()=>{
            var s;
            return (s = e.callback) == null ? void 0 : s.call(e);
        }
    });
}), $914aec8743edd630$var$Jb = $914aec8743edd630$var$Ae("directline/endConversation", async (e, t)=>{
    var i;
    t.dispatch($914aec8743edd630$var$rr()), (i = t.getState().directlineReducer.directLine) == null || i.end();
}), $914aec8743edd630$var$Zb = $914aec8743edd630$var$Ae("directline/resetDirectlineStore", async (e, t)=>(t.dispatch($914aec8743edd630$var$rr()), await t.dispatch($914aec8743edd630$var$Jb()), {
        ...$914aec8743edd630$var$Vb
    })), $914aec8743edd630$var$EF = $914aec8743edd630$var$Ae("directline/sendMessageToChatbot", async (e, t)=>{
    const r = t.getState();
    if (e && r.activityReducer.conversationId && r.localeReducer.locale) {
        const i = {
            type: "message",
            conversation: {
                id: r.activityReducer.conversationId
            },
            id: `fake-bot-${r.activityReducer.conversationId}`,
            from: {
                id: "fake-bot-id"
            },
            locale: r.localeReducer.locale,
            text: e,
            speak: e
        };
        t.dispatch($914aec8743edd630$var$Fc(i));
    }
}), $914aec8743edd630$var$AF = $914aec8743edd630$var$Hb.reducer, { dispatchStatus: $914aec8743edd630$var$Xb, setActivityWatermark: $914aec8743edd630$var$ev, unsubscribe: $914aec8743edd630$var$rr, sendTyping: $914aec8743edd630$var$TF, setPaginationToSend: $914aec8743edd630$var$CF, addExternalActivityHandler: $914aec8743edd630$var$RF, setExternalActivityHandlers: $914aec8743edd630$var$OF, setPositionToSend: $914aec8743edd630$var$DF, dispatchMarkActivity: $914aec8743edd630$var$PF, pauseConversation: $914aec8743edd630$var$IF, resumeConversation: $914aec8743edd630$var$MF, setStoredVeilleConversationData: $914aec8743edd630$var$jF, setApplicationIsBusy: $914aec8743edd630$var$FF } = $914aec8743edd630$var$Hb.actions, $914aec8743edd630$var$$F = async ()=>{
    try {
        return navigator.mediaDevices.getUserMedia({
            audio: !0
        }).then((e)=>e ? $914aec8743edd630$var$ht.allowed : $914aec8743edd630$var$ht.refused, (e)=>(console.log("Retorik Framework > microphone permission refused : ", e), $914aec8743edd630$var$ht.refused)).catch((e)=>(console.log("Retorik Framework > microphone permission refused : ", e), $914aec8743edd630$var$ht.error));
    } catch (e) {
        return console.log("Retorik Framework > microphone permission refused : ", e), $914aec8743edd630$var$ht.error;
    }
}, $914aec8743edd630$var$vm = {
    ponyfillCredentials: void 0,
    useContinuousRecognition: !1,
    customVoice: void 0,
    voice: null,
    mode: $914aec8743edd630$var$Ft.text,
    disableSound: !1,
    speaking: !1,
    muted: !1,
    cancel: !1,
    boundaryData: [],
    visemeData: [],
    singleVisemeAdded: null,
    multiVisemesAdded: [],
    streamingReplyToId: null,
    streamingQueue: [],
    streamingReplyToIdToIgnore: null,
    currentOrLastPlayedActivity: void 0,
    isMicrophoneAllowed: !1,
    showMicrophoneModal: !1,
    permissionStatus: $914aec8743edd630$var$ht.waiting,
    activeRecognitionState: $914aec8743edd630$var$at.Closed,
    lastRecognitionInterim: "",
    speechRecognitionDynamicGrammars: [],
    externalTextToSpeech: void 0
}, $914aec8743edd630$var$tv = $914aec8743edd630$var$mt({
    name: "speech",
    initialState: $914aec8743edd630$var$vm,
    reducers: {
        setPonyfillFactoryCredentials: (e, t)=>{
            e.ponyfillCredentials = t.payload;
        },
        setUseContinuousRecognition: (e, t)=>{
            var r, i;
            if ((r = t.payload.options) != null && r.enableContinuousRecognitionOnAllDevices) e.useContinuousRecognition = !0;
            else if ((i = t.payload.options) != null && i.enableContinuousRecognitionOn) switch(t.payload.deviceType){
                case $914aec8743edd630$var$je.mobile:
                    e.useContinuousRecognition = !!t.payload.options.enableContinuousRecognitionOn.mobile;
                    break;
                case $914aec8743edd630$var$je.widget:
                case $914aec8743edd630$var$je.widgetLandscape:
                case $914aec8743edd630$var$je.widgetBorne:
                    e.useContinuousRecognition = !!t.payload.options.enableContinuousRecognitionOn.widget;
                    break;
                case $914aec8743edd630$var$je.landscape:
                    e.useContinuousRecognition = !!t.payload.options.enableContinuousRecognitionOn.desktop;
                    break;
                case $914aec8743edd630$var$je.borne:
                    e.useContinuousRecognition = !!t.payload.options.enableContinuousRecognitionOn.borne;
                    break;
                default:
                    e.useContinuousRecognition = !1;
                    break;
            }
            else e.useContinuousRecognition = !1;
        },
        setCustomVoice: (e, t)=>{
            e.customVoice = t.payload;
        },
        setVoice: (e, t)=>{
            e.voice = t.payload;
        },
        setDisableSound: (e, t)=>{
            e.disableSound = t.payload;
        },
        setMuted: (e, t)=>{
            e.muted = t.payload;
        },
        toggleMuted: (e)=>{
            e.muted = !e.muted;
        },
        cancelCurrentUtterance: (e)=>{
            e.cancel = !0;
        },
        resetCancelCurrentUtterance: (e)=>{
            e.cancel = !1;
        },
        setBoundaryData: (e, t)=>{
            e.boundaryData = t.payload;
        },
        setVisemeData: (e, t)=>{
            e.visemeData = t.payload, e.multiVisemesAdded = t.payload;
        },
        addViseme: (e, t)=>{
            e.visemeData = [
                ...e.visemeData,
                t.payload
            ], e.singleVisemeAdded = t.payload;
        },
        setIsMicrophoneAllowed: (e, t)=>{
            e.isMicrophoneAllowed = t.payload;
        },
        setShowMicrophoneModal: (e, t)=>{
            e.showMicrophoneModal = t.payload;
        },
        setActiveRecognitionState: (e, t)=>{
            e.activeRecognitionState = t.payload;
        },
        setLastRecognitionInterim: (e, t)=>{
            e.lastRecognitionInterim = t.payload;
        },
        setStreamingReplyToId: (e, t)=>{
            e.streamingReplyToId = t.payload;
        },
        addToStreamingQueue: (e, t)=>{
            t.payload.replyToId ? t.payload.replyToId !== e.streamingReplyToIdToIgnore && (e.streamingReplyToId !== t.payload.replyToId ? (e.streamingReplyToId = t.payload.replyToId, e.streamingQueue = [
                t.payload
            ]) : e.streamingQueue = [
                ...e.streamingQueue,
                t.payload
            ]) : e.streamingQueue = [
                ...e.streamingQueue,
                t.payload
            ];
        },
        // If "twice" parameter is true, let's remove 2 elements instead of one (used with the message at the end of a streaming that should not be spoken)
        removeFirstFromStreamingQueue: (e, t)=>{
            e.streamingQueue = e.streamingQueue.slice(t.payload ? 2 : 1);
        },
        killCurrentStreaming: (e)=>{
            e.streamingReplyToIdToIgnore = e.streamingReplyToId, e.streamingQueue = [];
        },
        addSpeechRecognitionDynamicGrammar: (e, t)=>{
            const r = e.speechRecognitionDynamicGrammars;
            if (Array.isArray(t.payload)) {
                const i = [];
                t.payload.forEach((n)=>{
                    !r.includes(n) && i.push(n);
                }), i.length && (e.speechRecognitionDynamicGrammars = [
                    ...r,
                    ...i
                ]);
            } else !r.includes(t.payload) && (e.speechRecognitionDynamicGrammars = [
                ...r,
                t.payload
            ]);
        },
        playExternalSynthesis: (e, t)=>{
            e.externalTextToSpeech = t.payload;
        },
        resetSpeechStore: ()=>({
                ...$914aec8743edd630$var$vm
            })
    },
    extraReducers: (e)=>{
        e.addCase($914aec8743edd630$var$Lc.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            })).addCase($914aec8743edd630$var$rv.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            })).addCase($914aec8743edd630$var$Lu.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            })).addCase($914aec8743edd630$var$Lu.rejected, (t)=>({
                ...t,
                permissionStatus: $914aec8743edd630$var$ht.error,
                isMicrophoneAllowed: !1
            })).addCase($914aec8743edd630$var$nv.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            }));
    }
}), $914aec8743edd630$var$Lc = $914aec8743edd630$var$Ae("speech/setMode", async (e, t)=>{
    const r = t.getState();
    return t.dispatch($914aec8743edd630$var$Bg(void 0)), e !== $914aec8743edd630$var$Ft.text && t.dispatch($914aec8743edd630$var$Ug(!1)), !r.speechReducer.disableSound && t.dispatch($914aec8743edd630$var$ov(e === $914aec8743edd630$var$Ft.text)), {
        mode: e
    };
}), $914aec8743edd630$var$rv = $914aec8743edd630$var$Ae("speech/setSpeaking", async (e, t)=>(t.dispatch($914aec8743edd630$var$zg(e ? $914aec8743edd630$var$Ru.SpeechStarted : $914aec8743edd630$var$Ru.SpeechEnded)), e === !1 ? {
        speaking: e,
        visemeData: [],
        singleVisemeAdded: null,
        multiVisemesAdded: []
    } : {
        speaking: e
    })), $914aec8743edd630$var$Nc = $914aec8743edd630$var$Ae("speech/toggleMicrophone", async (e, t)=>{
    var i, n;
    const r = t.getState();
    if (r.speechReducer.mode === $914aec8743edd630$var$Ft.text) t.dispatch($914aec8743edd630$var$Mn($914aec8743edd630$var$at.Closed));
    else switch(r.speechReducer.activeRecognitionState){
        // Do nothing if we are in a transition state
        case $914aec8743edd630$var$at.Initializing:
        case $914aec8743edd630$var$at.Closing:
            return;
        case $914aec8743edd630$var$at.Listening:
            {
                const o = r.speechReducer.lastRecognitionInterim;
                t.dispatch($914aec8743edd630$var$Mn($914aec8743edd630$var$at.ForceClosing)), (n = (i = r.retorikReducer.configuration) == null ? void 0 : i.speechRecognitionOptions) != null && n.enableSendMessageOnMicrophoneClose && o ? t.dispatch($914aec8743edd630$var$Yb({
                    text: o
                })) : t.dispatch($914aec8743edd630$var$Vn());
                break;
            }
        case $914aec8743edd630$var$at.Closed:
            t.dispatch($914aec8743edd630$var$Mn($914aec8743edd630$var$at.Initializing)), !e && t.dispatch($914aec8743edd630$var$Vn());
            break;
    }
}), $914aec8743edd630$var$Lu = $914aec8743edd630$var$Ae("speech/askPermission", async (e, t)=>{
    t.dispatch($914aec8743edd630$var$av(!0));
    const r = await $914aec8743edd630$var$$F();
    return r === $914aec8743edd630$var$ht.allowed ? (t.dispatch($914aec8743edd630$var$Nc(void 0)), {
        permissionStatus: r,
        isMicrophoneAllowed: !0,
        showMicrophoneModal: !1
    }) : {
        permissionStatus: r,
        isMicrophoneAllowed: !1
    };
}), $914aec8743edd630$var$nv = $914aec8743edd630$var$Ae("speech/setCurrentOrLastPlayedActivity", async (e, t)=>{
    var i;
    const r = t.getState();
    return ((i = e == null ? void 0 : e.attachmentLayout) == null ? void 0 : i.toLowerCase()) === "davilist" && r.utilsReducer.listStatus !== $914aec8743edd630$var$Bn.opened && t.dispatch($914aec8743edd630$var$qg($914aec8743edd630$var$Bn.available)), {
        currentOrLastPlayedActivity: e
    };
}), $914aec8743edd630$var$iv = $914aec8743edd630$var$Ae("speech/checkActivityReplyToId", async (e, t)=>{
    t.getState().speechReducer.streamingReplyToId !== e && t.dispatch($914aec8743edd630$var$sv());
}), $914aec8743edd630$var$LF = $914aec8743edd630$var$tv.reducer, { setPonyfillFactoryCredentials: $914aec8743edd630$var$NF, setUseContinuousRecognition: $914aec8743edd630$var$BF, setCustomVoice: $914aec8743edd630$var$qF, setVoice: $914aec8743edd630$var$zF, setDisableSound: $914aec8743edd630$var$UF, setMuted: $914aec8743edd630$var$ov, toggleMuted: $914aec8743edd630$var$VF, cancelCurrentUtterance: $914aec8743edd630$var$Vn, resetCancelCurrentUtterance: $914aec8743edd630$var$GF, setBoundaryData: $914aec8743edd630$var$WF, setVisemeData: $914aec8743edd630$var$HF, addViseme: $914aec8743edd630$var$KF, setIsMicrophoneAllowed: $914aec8743edd630$var$QF, setShowMicrophoneModal: $914aec8743edd630$var$av, setActiveRecognitionState: $914aec8743edd630$var$Mn, setLastRecognitionInterim: $914aec8743edd630$var$YF, setStreamingReplyToId: $914aec8743edd630$var$JF, addToStreamingQueue: $914aec8743edd630$var$Bc, removeFirstFromStreamingQueue: $914aec8743edd630$var$ZF, killCurrentStreaming: $914aec8743edd630$var$sv, addSpeechRecognitionDynamicGrammar: $914aec8743edd630$var$uv, playExternalSynthesis: $914aec8743edd630$var$XF, resetSpeechStore: $914aec8743edd630$var$e$ } = $914aec8743edd630$var$tv.actions, $914aec8743edd630$var$t$ = {
    visibility: "visible",
    currentDeviceType: $914aec8743edd630$var$je.landscape,
    isMobile: !1,
    isWidget: !1,
    isLandscape: !0,
    isBorne: !1,
    themeColors: $914aec8743edd630$var$BP,
    theme: $914aec8743edd630$var$Lg.light,
    configurations: {
        homeRoute: "home",
        views: {
            home: {
                background: {
                    image: "",
                    style: "image"
                }
            }
        }
    },
    veilleConfiguration: {
        enabled: !1
    },
    mapConfiguration: {
        settings: void 0
    },
    route: $914aec8743edd630$var$gc.Home,
    currentHeight: 1080,
    currentWidth: 1920,
    isTactile: window.matchMedia("(any-pointer: coarse)").matches,
    isMobileLandscape: !1,
    displayControls: !0,
    mediumLandscape: !1,
    characterLoaded: !1,
    calibrationCompleted: !1
}, $914aec8743edd630$var$cv = $914aec8743edd630$var$mt({
    name: "view",
    initialState: $914aec8743edd630$var$t$,
    reducers: {
        setVisibility: (e, t)=>{
            e.visibility = t.payload;
        },
        toggleVisibility: (e)=>{
            e.visibility = e.visibility === "visible" ? "hidden" : "visible";
        },
        checkMobileLandscape: (e)=>{
            e.isMobileLandscape = e.currentDeviceType === $914aec8743edd630$var$je.mobile && e.currentHeight < e.currentWidth;
        },
        setTheme: (e, t)=>{
            e.theme = t.payload;
        },
        setThemeColors: (e, t)=>{
            e.themeColors = t.payload;
        },
        setViewsConfiguration: (e, t)=>{
            e.configurations = t.payload;
        },
        setVeilleConfiguration: (e, t)=>{
            e.veilleConfiguration = t.payload;
        },
        setMapConfiguration: (e, t)=>{
            e.mapConfiguration = t.payload;
        },
        setDisplayControls: (e, t)=>{
            e.displayControls = t.payload;
        },
        setCharacterLoaded: (e, t)=>{
            e.characterLoaded = t.payload;
        },
        setCalibrationCompleted: (e, t)=>{
            e.calibrationCompleted = t.payload;
        }
    },
    extraReducers: (e)=>{
        e.addCase($914aec8743edd630$var$lv.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            })).addCase($914aec8743edd630$var$dv.fulfilled, (t, r)=>r.payload ? {
                ...t,
                ...r.payload
            } : {
                ...t
            }).addCase($914aec8743edd630$var$fv.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            })).addCase($914aec8743edd630$var$hv.fulfilled, (t, r)=>({
                ...t,
                ...r.payload
            }));
    }
}), $914aec8743edd630$var$lv = $914aec8743edd630$var$Ae("view/setCurrentDeviceType", async (e, t)=>(t.dispatch($914aec8743edd630$var$hi()), {
        currentDeviceType: e,
        isMobile: $914aec8743edd630$var$L2.includes(e),
        isWidget: $914aec8743edd630$var$N2.includes(e),
        isLandscape: $914aec8743edd630$var$B2.includes(e),
        isBorne: $914aec8743edd630$var$q2.includes(e)
    })), $914aec8743edd630$var$dv = $914aec8743edd630$var$Ae("view/setRoute", async (e, t)=>{
    let r = !1;
    return e === $914aec8743edd630$var$gc.News ? t.getState().retorikReducer.enabledFeatures.includes("news") ? r = !0 : console.log("Retorik Framework > tried to switch to the news while the feature is not activated in Retorik Studio") : r = !0, r ? {
        route: e
    } : void 0;
}), $914aec8743edd630$var$fv = $914aec8743edd630$var$Ae("view/setCurrentHeight", async (e, t)=>(t.dispatch($914aec8743edd630$var$hi()), {
        currentHeight: e
    })), $914aec8743edd630$var$hv = $914aec8743edd630$var$Ae("view/setCurrentWidth", async (e, t)=>(t.dispatch($914aec8743edd630$var$hi()), {
        currentWidth: e,
        mediumLandscape: e < $914aec8743edd630$var$F2
    })), $914aec8743edd630$var$r$ = $914aec8743edd630$var$cv.reducer, { setVisibility: $914aec8743edd630$var$n$, toggleVisibility: $914aec8743edd630$var$i$, checkMobileLandscape: $914aec8743edd630$var$hi, setTheme: $914aec8743edd630$var$o$, setThemeColors: $914aec8743edd630$var$a$, setViewsConfiguration: $914aec8743edd630$var$s$, setVeilleConfiguration: $914aec8743edd630$var$u$, setMapConfiguration: $914aec8743edd630$var$c$, setDisplayControls: $914aec8743edd630$var$l$, setCharacterLoaded: $914aec8743edd630$var$d$, setCalibrationCompleted: $914aec8743edd630$var$f$ } = $914aec8743edd630$var$cv.actions, $914aec8743edd630$var$h$ = $914aec8743edd630$var$wm({
    widgetReducer: $914aec8743edd630$var$s2,
    utilsReducer: $914aec8743edd630$var$h2,
    localeReducer: $914aec8743edd630$var$zP,
    adaptiveCardReducer: $914aec8743edd630$var$KP,
    speechReducer: $914aec8743edd630$var$LF,
    retorikReducer: $914aec8743edd630$var$uI,
    viewReducer: $914aec8743edd630$var$r$,
    activityReducer: $914aec8743edd630$var$bF,
    directlineReducer: $914aec8743edd630$var$AF
}), $914aec8743edd630$export$2e2bcd8739ae039 = $914aec8743edd630$var$ty({
    middleware: (e)=>e({
            serializableCheck: !1
        }),
    reducer: $914aec8743edd630$var$h$
}), $914aec8743edd630$export$8b3bc28eb06c49b6 = {
    widget: {
        closeWidget: $914aec8743edd630$var$c2,
        openWidget: $914aec8743edd630$var$u2,
        toggleDisplay: $914aec8743edd630$var$d2,
        toggleWidget: $914aec8743edd630$var$l2
    },
    utils: {
        setFullScreenImage: $914aec8743edd630$var$p2,
        setLastListActivity: $914aec8743edd630$var$Bg,
        setListStatus: $914aec8743edd630$var$qg,
        setCloseList: $914aec8743edd630$var$m2,
        setCurrentSubView: $914aec8743edd630$var$g2,
        setCurrentCustomView: $914aec8743edd630$var$b2,
        setRetorikEvent: $914aec8743edd630$var$zg,
        showAgent: $914aec8743edd630$var$v2,
        hideAgent: $914aec8743edd630$var$y2,
        setRetorikNewsEnded: $914aec8743edd630$var$w2,
        setUserTyping: $914aec8743edd630$var$Ug,
        setUserSwiping: $914aec8743edd630$var$_2,
        askForKioskParametersOpening: $914aec8743edd630$var$k2,
        addDetailedAttachmentTrigger: $914aec8743edd630$var$x2,
        setModalFullscreenContent: $914aec8743edd630$var$S2,
        setModalFullscreenContentFromActivity: $914aec8743edd630$var$E2,
        setGDPRDisplay: $914aec8743edd630$var$A2,
        setGDPRWindowData: $914aec8743edd630$var$T2,
        setGDPRUserConsent: $914aec8743edd630$var$C2,
        lockClickedButton: $914aec8743edd630$var$R2,
        unlockClickedButton: $914aec8743edd630$var$fn,
        setDashboardOpened: $914aec8743edd630$var$O2,
        toggleDashboard: $914aec8743edd630$var$D2,
        setClickedOnUI: $914aec8743edd630$var$f2,
        setCloseDetailedPOI: $914aec8743edd630$var$M2,
        resetUtilsStore: $914aec8743edd630$var$j2
    },
    locale: {
        addDumpedLanguageFallback: $914aec8743edd630$var$GP,
        addReplacementLocale: $914aec8743edd630$var$WP,
        fetchSupportedLanguages: $914aec8743edd630$var$Kg,
        resetLocaleStore: $914aec8743edd630$var$HP,
        setBaseAddress: $914aec8743edd630$var$UP,
        setLanguageData: $914aec8743edd630$var$VP,
        setLocale: $914aec8743edd630$var$Hg
    },
    adaptiveCard: {
        setValue: $914aec8743edd630$var$QP,
        setToggleValue: $914aec8743edd630$var$YP,
        setCurrentId: $914aec8743edd630$var$Jg,
        addCurrentToggleId: $914aec8743edd630$var$JP,
        setRestoreInputsState: $914aec8743edd630$var$Zg,
        resetAdaptiveCardStore: $914aec8743edd630$var$ZP
    },
    speech: {
        setPonyfillFactoryCredentials: $914aec8743edd630$var$NF,
        setUseContinuousRecognition: $914aec8743edd630$var$BF,
        setCustomVoice: $914aec8743edd630$var$qF,
        setVoice: $914aec8743edd630$var$zF,
        setDisableSound: $914aec8743edd630$var$UF,
        setMuted: $914aec8743edd630$var$ov,
        toggleMuted: $914aec8743edd630$var$VF,
        cancelCurrentUtterance: $914aec8743edd630$var$Vn,
        resetCancelCurrentUtterance: $914aec8743edd630$var$GF,
        setBoundaryData: $914aec8743edd630$var$WF,
        setVisemeData: $914aec8743edd630$var$HF,
        addViseme: $914aec8743edd630$var$KF,
        setIsMicrophoneAllowed: $914aec8743edd630$var$QF,
        setShowMicrophoneModal: $914aec8743edd630$var$av,
        setActiveRecognitionState: $914aec8743edd630$var$Mn,
        setLastRecognitionInterim: $914aec8743edd630$var$YF,
        setStreamingReplyToId: $914aec8743edd630$var$JF,
        addToStreamingQueue: $914aec8743edd630$var$Bc,
        removeFirstFromStreamingQueue: $914aec8743edd630$var$ZF,
        killCurrentStreaming: $914aec8743edd630$var$sv,
        addSpeechRecognitionDynamicGrammar: $914aec8743edd630$var$uv,
        playExternalSynthesis: $914aec8743edd630$var$XF,
        resetSpeechStore: $914aec8743edd630$var$e$,
        setMode: $914aec8743edd630$var$Lc,
        setSpeaking: $914aec8743edd630$var$rv,
        toggleMicrophone: $914aec8743edd630$var$Nc,
        askPermission: $914aec8743edd630$var$Lu,
        setCurrentOrLastPlayedActivity: $914aec8743edd630$var$nv,
        checkActivityReplyToId: $914aec8743edd630$var$iv
    },
    retorik: {
        setConfiguration: $914aec8743edd630$var$cI,
        setAddressData: $914aec8743edd630$var$lI,
        focusSendBox: $914aec8743edd630$var$dI,
        setCanFocusSendBox: $914aec8743edd630$var$fI,
        setSendBoxPlaceHolder: $914aec8743edd630$var$rb,
        setLayout: $914aec8743edd630$var$hI,
        setUserAlreadySet: $914aec8743edd630$var$pI,
        setEnvironmentPreset: $914aec8743edd630$var$mI,
        setFromTextToVocal: $914aec8743edd630$var$gI,
        setLoaderClosed: $914aec8743edd630$var$bI,
        setAppAvailable: $914aec8743edd630$var$vI,
        setSubtitlesInConfiguration: $914aec8743edd630$var$yI,
        setDisplaySubtitles: $914aec8743edd630$var$wI,
        toggleSubtitles: $914aec8743edd630$var$_I,
        setSkipLoader: $914aec8743edd630$var$kI,
        setDisplayAgentInNews: $914aec8743edd630$var$xI,
        setSubmitDelayBeforeSendingMessage: $914aec8743edd630$var$nb,
        setCustomScripts: $914aec8743edd630$var$SI,
        setCustomCSS: $914aec8743edd630$var$EI,
        setEnabledFeatures: $914aec8743edd630$var$AI,
        setShowPositionModal: $914aec8743edd630$var$TI,
        resetRetorikStore: $914aec8743edd630$var$CI,
        setAgentData: $914aec8743edd630$var$tb,
        setIsWaitingForResponse: $914aec8743edd630$var$Bt
    },
    view: {
        setVisibility: $914aec8743edd630$var$n$,
        toggleVisibility: $914aec8743edd630$var$i$,
        checkMobileLandscape: $914aec8743edd630$var$hi,
        setTheme: $914aec8743edd630$var$o$,
        setViewsConfiguration: $914aec8743edd630$var$s$,
        setVeilleConfiguration: $914aec8743edd630$var$u$,
        setMapConfiguration: $914aec8743edd630$var$c$,
        setDisplayControls: $914aec8743edd630$var$l$,
        setCharacterLoaded: $914aec8743edd630$var$d$,
        setCalibrationCompleted: $914aec8743edd630$var$f$,
        setCurrentDeviceType: $914aec8743edd630$var$lv,
        setThemeColors: $914aec8743edd630$var$a$,
        setRoute: $914aec8743edd630$var$dv,
        setCurrentHeight: $914aec8743edd630$var$fv,
        setCurrentWidth: $914aec8743edd630$var$hv
    },
    activity: {
        addCookie: $914aec8743edd630$var$vF,
        setCookiesInBrowser: $914aec8743edd630$var$Nb,
        setCurrentQueue: $914aec8743edd630$var$Bb,
        setQueueLock: $914aec8743edd630$var$jc,
        addUserEvent: $914aec8743edd630$var$qb,
        addEndedActivity: $914aec8743edd630$var$yF,
        setRetrievingConversation: $914aec8743edd630$var$zb,
        setAddRetorikNewsConversationIdInLocalStorage: $914aec8743edd630$var$wF,
        resetProcessedActivity: $914aec8743edd630$var$_F,
        resetActivityStore: $914aec8743edd630$var$Ub,
        checkConversationId: $914aec8743edd630$var$Rc,
        processQueue: $914aec8743edd630$var$gn,
        addBotMessage: $914aec8743edd630$var$Dc,
        addBotEvent: $914aec8743edd630$var$Ic,
        addUserMessage: $914aec8743edd630$var$Mc
    },
    directline: {
        dispatchStatus: $914aec8743edd630$var$Xb,
        setActivityWatermark: $914aec8743edd630$var$ev,
        unsubscribe: $914aec8743edd630$var$rr,
        sendTyping: $914aec8743edd630$var$TF,
        setPaginationToSend: $914aec8743edd630$var$CF,
        addExternalActivityHandler: $914aec8743edd630$var$RF,
        setExternalActivityHandlers: $914aec8743edd630$var$OF,
        setPositionToSend: $914aec8743edd630$var$DF,
        dispatchMarkActivity: $914aec8743edd630$var$PF,
        pauseConversation: $914aec8743edd630$var$IF,
        resumeConversation: $914aec8743edd630$var$MF,
        setStoredVeilleConversationData: $914aec8743edd630$var$jF,
        setApplicationIsBusy: $914aec8743edd630$var$FF,
        dispatchActivity: $914aec8743edd630$var$Fc,
        subscribe: $914aec8743edd630$var$rn,
        createDirectline: $914aec8743edd630$var$Kb,
        recreateDirectline: $914aec8743edd630$var$Qb,
        checkMicrophoneAndCancel: $914aec8743edd630$var$$c,
        sendMessage: $914aec8743edd630$var$Yb,
        sendEvent: $914aec8743edd630$var$$u,
        endConversation: $914aec8743edd630$var$Jb,
        sendMessageToChatbot: $914aec8743edd630$var$EF,
        resetDirectlineStore: $914aec8743edd630$var$Zb
    }
}, $914aec8743edd630$export$7516420eb880ab68 = $914aec8743edd630$var$Zt.ConnectionStatus;

});

parcelRegister("i2BIy", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $d225abd390b33787$export$307591e98609eddd, (v) => $d225abd390b33787$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $d225abd390b33787$export$eb3a06aef9e6ee51, (v) => $d225abd390b33787$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $d225abd390b33787$export$b23711c915539651, (v) => $d225abd390b33787$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $d225abd390b33787$export$80e7718417253a51, (v) => $d225abd390b33787$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $d225abd390b33787$export$83d89fbfd8236492, (v) => $d225abd390b33787$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d225abd390b33787$export$307591e98609eddd;
var $d225abd390b33787$export$eb3a06aef9e6ee51;
var $d225abd390b33787$export$b23711c915539651;
var $d225abd390b33787$export$80e7718417253a51;
var $d225abd390b33787$export$83d89fbfd8236492;
'use strict';

var $bxRTa = parcelRequire("bxRTa");
function $d225abd390b33787$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $d225abd390b33787$var$p = Object.prototype.hasOwnProperty, $d225abd390b33787$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $d225abd390b33787$var$ha = {}, $d225abd390b33787$var$ia = {};
function $d225abd390b33787$var$ja(a) {
    if ($d225abd390b33787$var$p.call($d225abd390b33787$var$ia, a)) return !0;
    if ($d225abd390b33787$var$p.call($d225abd390b33787$var$ha, a)) return !1;
    if ($d225abd390b33787$var$fa.test(a)) return $d225abd390b33787$var$ia[a] = !0;
    $d225abd390b33787$var$ha[a] = !0;
    return !1;
}
function $d225abd390b33787$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $d225abd390b33787$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $d225abd390b33787$var$t[b] = new $d225abd390b33787$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $d225abd390b33787$var$ka = /[\-:]([a-z])/g;
function $d225abd390b33787$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($d225abd390b33787$var$ka, $d225abd390b33787$var$la);
    $d225abd390b33787$var$t[b] = new $d225abd390b33787$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($d225abd390b33787$var$ka, $d225abd390b33787$var$la);
    $d225abd390b33787$var$t[b] = new $d225abd390b33787$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($d225abd390b33787$var$ka, $d225abd390b33787$var$la);
    $d225abd390b33787$var$t[b] = new $d225abd390b33787$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$d225abd390b33787$var$t.xlinkHref = new $d225abd390b33787$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $d225abd390b33787$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $d225abd390b33787$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($d225abd390b33787$var$u).forEach(function(a) {
    $d225abd390b33787$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $d225abd390b33787$var$u[b] = $d225abd390b33787$var$u[a];
    });
});
var $d225abd390b33787$var$na = /["'&<>]/;
function $d225abd390b33787$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $d225abd390b33787$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $d225abd390b33787$var$oa = /([A-Z])/g, $d225abd390b33787$var$pa = /^ms-/, $d225abd390b33787$var$qa = Array.isArray;
function $d225abd390b33787$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $d225abd390b33787$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $d225abd390b33787$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $d225abd390b33787$var$w(2, null);
        case "math":
            return $d225abd390b33787$var$w(3, null);
        case "foreignObject":
            return $d225abd390b33787$var$w(1, null);
        case "table":
            return $d225abd390b33787$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $d225abd390b33787$var$w(5, null);
        case "colgroup":
            return $d225abd390b33787$var$w(7, null);
        case "tr":
            return $d225abd390b33787$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $d225abd390b33787$var$w(1, null) : a;
}
var $d225abd390b33787$var$sa = new Map;
function $d225abd390b33787$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($d225abd390b33787$var$l(62));
    b = !0;
    for(var d in c)if ($d225abd390b33787$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $d225abd390b33787$var$v(d);
                f = $d225abd390b33787$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $d225abd390b33787$var$sa.get(e);
                void 0 !== g ? e = g : (g = $d225abd390b33787$var$v(e.replace($d225abd390b33787$var$oa, "-$1").toLowerCase().replace($d225abd390b33787$var$pa, "-ms-")), $d225abd390b33787$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $d225abd390b33787$var$p.call($d225abd390b33787$var$u, d) ? "" + f : f + "px" : $d225abd390b33787$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $d225abd390b33787$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $d225abd390b33787$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $d225abd390b33787$var$t.hasOwnProperty(c) ? $d225abd390b33787$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $d225abd390b33787$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $d225abd390b33787$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $d225abd390b33787$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $d225abd390b33787$var$v(d), '"');
            }
        } else if ($d225abd390b33787$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $d225abd390b33787$var$v(d), '"');
        }
    }
}
function $d225abd390b33787$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($d225abd390b33787$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($d225abd390b33787$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $d225abd390b33787$var$ua(a) {
    var b = "";
    $bxRTa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $d225abd390b33787$var$va(a, b, c, d) {
    a.push($d225abd390b33787$var$A(c));
    var f = c = null, e;
    for(e in b)if ($d225abd390b33787$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $d225abd390b33787$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $d225abd390b33787$var$y(a, f, c);
    return "string" === typeof c ? (a.push($d225abd390b33787$var$v(c)), null) : c;
}
var $d225abd390b33787$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $d225abd390b33787$var$xa = new Map;
function $d225abd390b33787$var$A(a) {
    var b = $d225abd390b33787$var$xa.get(a);
    if (void 0 === b) {
        if (!$d225abd390b33787$var$wa.test(a)) throw Error($d225abd390b33787$var$l(65, a));
        b = "<" + a;
        $d225abd390b33787$var$xa.set(a, b);
    }
    return b;
}
function $d225abd390b33787$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($d225abd390b33787$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($d225abd390b33787$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $d225abd390b33787$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $d225abd390b33787$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($d225abd390b33787$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($d225abd390b33787$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $d225abd390b33787$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $d225abd390b33787$var$ua(h), $d225abd390b33787$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $d225abd390b33787$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($d225abd390b33787$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($d225abd390b33787$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($d225abd390b33787$var$l(91));
                default:
                    $d225abd390b33787$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($d225abd390b33787$var$l(92));
                if ($d225abd390b33787$var$qa(n) && 1 < n.length) throw Error($d225abd390b33787$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($d225abd390b33787$var$v("" + e));
            return null;
        case "input":
            a.push($d225abd390b33787$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($d225abd390b33787$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($d225abd390b33787$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $d225abd390b33787$var$x(a, d, g, m);
            }
            null !== n ? $d225abd390b33787$var$x(a, d, "checked", n) : null !== k && $d225abd390b33787$var$x(a, d, "checked", k);
            null !== e ? $d225abd390b33787$var$x(a, d, "value", e) : null !== h && $d225abd390b33787$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($d225abd390b33787$var$A("menuitem"));
            for(var C in c)if ($d225abd390b33787$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($d225abd390b33787$var$l(400));
                default:
                    $d225abd390b33787$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($d225abd390b33787$var$A("title"));
            e = null;
            for(q in c)if ($d225abd390b33787$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($d225abd390b33787$var$l(434));
                default:
                    $d225abd390b33787$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($d225abd390b33787$var$A(b));
            g = e = null;
            for(k in c)if ($d225abd390b33787$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $d225abd390b33787$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($d225abd390b33787$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($d225abd390b33787$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($d225abd390b33787$var$A(b));
            for(var D in c)if ($d225abd390b33787$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($d225abd390b33787$var$l(399, b));
                default:
                    $d225abd390b33787$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $d225abd390b33787$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $d225abd390b33787$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $d225abd390b33787$var$va(a, c, b, d);
            a.push($d225abd390b33787$var$A(b));
            g = e = null;
            for(m in c)if ($d225abd390b33787$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $d225abd390b33787$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $d225abd390b33787$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $d225abd390b33787$var$v(h), '"');
            }
            a.push(">");
            $d225abd390b33787$var$y(a, g, e);
            return e;
    }
}
function $d225abd390b33787$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($d225abd390b33787$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $d225abd390b33787$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($d225abd390b33787$var$l(397));
    }
}
function $d225abd390b33787$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($d225abd390b33787$var$l(397));
    }
}
var $d225abd390b33787$var$Ca = /[<\u2028\u2029]/g;
function $d225abd390b33787$var$Da(a) {
    return JSON.stringify(a).replace($d225abd390b33787$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $d225abd390b33787$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $d225abd390b33787$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($d225abd390b33787$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($d225abd390b33787$var$v(b)), a = !0);
    return a;
}
var $d225abd390b33787$var$B = Object.assign, $d225abd390b33787$var$Ga = Symbol.for("react.element"), $d225abd390b33787$var$Ha = Symbol.for("react.portal"), $d225abd390b33787$var$Ia = Symbol.for("react.fragment"), $d225abd390b33787$var$Ja = Symbol.for("react.strict_mode"), $d225abd390b33787$var$Ka = Symbol.for("react.profiler"), $d225abd390b33787$var$La = Symbol.for("react.provider"), $d225abd390b33787$var$Ma = Symbol.for("react.context"), $d225abd390b33787$var$Na = Symbol.for("react.forward_ref"), $d225abd390b33787$var$Oa = Symbol.for("react.suspense"), $d225abd390b33787$var$Pa = Symbol.for("react.suspense_list"), $d225abd390b33787$var$Qa = Symbol.for("react.memo"), $d225abd390b33787$var$Ra = Symbol.for("react.lazy"), $d225abd390b33787$var$Sa = Symbol.for("react.scope"), $d225abd390b33787$var$Ta = Symbol.for("react.debug_trace_mode"), $d225abd390b33787$var$Ua = Symbol.for("react.legacy_hidden"), $d225abd390b33787$var$Va = Symbol.for("react.default_value"), $d225abd390b33787$var$Wa = Symbol.iterator;
function $d225abd390b33787$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $d225abd390b33787$var$Ia:
            return "Fragment";
        case $d225abd390b33787$var$Ha:
            return "Portal";
        case $d225abd390b33787$var$Ka:
            return "Profiler";
        case $d225abd390b33787$var$Ja:
            return "StrictMode";
        case $d225abd390b33787$var$Oa:
            return "Suspense";
        case $d225abd390b33787$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $d225abd390b33787$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $d225abd390b33787$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $d225abd390b33787$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $d225abd390b33787$var$Qa:
            return b = a.displayName || null, null !== b ? b : $d225abd390b33787$var$Xa(a.type) || "Memo";
        case $d225abd390b33787$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $d225abd390b33787$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $d225abd390b33787$var$Ya = {};
function $d225abd390b33787$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $d225abd390b33787$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $d225abd390b33787$var$E = null;
function $d225abd390b33787$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($d225abd390b33787$var$l(401));
        } else {
            if (null === c) throw Error($d225abd390b33787$var$l(401));
            $d225abd390b33787$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $d225abd390b33787$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $d225abd390b33787$var$$a(a);
}
function $d225abd390b33787$var$ab(a) {
    var b = a.parent;
    null !== b && $d225abd390b33787$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $d225abd390b33787$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($d225abd390b33787$var$l(402));
    a.depth === b.depth ? $d225abd390b33787$var$F(a, b) : $d225abd390b33787$var$bb(a, b);
}
function $d225abd390b33787$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($d225abd390b33787$var$l(402));
    a.depth === c.depth ? $d225abd390b33787$var$F(a, c) : $d225abd390b33787$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $d225abd390b33787$var$G(a) {
    var b = $d225abd390b33787$var$E;
    b !== a && (null === b ? $d225abd390b33787$var$ab(a) : null === a ? $d225abd390b33787$var$$a(b) : b.depth === a.depth ? $d225abd390b33787$var$F(b, a) : b.depth > a.depth ? $d225abd390b33787$var$bb(b, a) : $d225abd390b33787$var$cb(b, a), $d225abd390b33787$var$E = a);
}
var $d225abd390b33787$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $d225abd390b33787$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $d225abd390b33787$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $d225abd390b33787$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $d225abd390b33787$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $d225abd390b33787$var$B({}, e, h)) : $d225abd390b33787$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $d225abd390b33787$var$fb = {
    id: 1,
    overflow: ""
};
function $d225abd390b33787$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $d225abd390b33787$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $d225abd390b33787$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $d225abd390b33787$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $d225abd390b33787$var$H = Math.clz32 ? Math.clz32 : $d225abd390b33787$var$hb, $d225abd390b33787$var$ib = Math.log, $d225abd390b33787$var$jb = Math.LN2;
function $d225abd390b33787$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($d225abd390b33787$var$ib(a) / $d225abd390b33787$var$jb | 0) | 0;
}
function $d225abd390b33787$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d225abd390b33787$var$lb = "function" === typeof Object.is ? Object.is : $d225abd390b33787$var$kb, $d225abd390b33787$var$I = null, $d225abd390b33787$var$ob = null, $d225abd390b33787$var$J = null, $d225abd390b33787$var$K = null, $d225abd390b33787$var$L = !1, $d225abd390b33787$var$M = !1, $d225abd390b33787$var$N = 0, $d225abd390b33787$var$O = null, $d225abd390b33787$var$P = 0;
function $d225abd390b33787$var$Q() {
    if (null === $d225abd390b33787$var$I) throw Error($d225abd390b33787$var$l(321));
    return $d225abd390b33787$var$I;
}
function $d225abd390b33787$var$pb() {
    if (0 < $d225abd390b33787$var$P) throw Error($d225abd390b33787$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $d225abd390b33787$var$qb() {
    null === $d225abd390b33787$var$K ? null === $d225abd390b33787$var$J ? ($d225abd390b33787$var$L = !1, $d225abd390b33787$var$J = $d225abd390b33787$var$K = $d225abd390b33787$var$pb()) : ($d225abd390b33787$var$L = !0, $d225abd390b33787$var$K = $d225abd390b33787$var$J) : null === $d225abd390b33787$var$K.next ? ($d225abd390b33787$var$L = !1, $d225abd390b33787$var$K = $d225abd390b33787$var$K.next = $d225abd390b33787$var$pb()) : ($d225abd390b33787$var$L = !0, $d225abd390b33787$var$K = $d225abd390b33787$var$K.next);
    return $d225abd390b33787$var$K;
}
function $d225abd390b33787$var$rb() {
    $d225abd390b33787$var$ob = $d225abd390b33787$var$I = null;
    $d225abd390b33787$var$M = !1;
    $d225abd390b33787$var$J = null;
    $d225abd390b33787$var$P = 0;
    $d225abd390b33787$var$K = $d225abd390b33787$var$O = null;
}
function $d225abd390b33787$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $d225abd390b33787$var$tb(a, b, c) {
    $d225abd390b33787$var$I = $d225abd390b33787$var$Q();
    $d225abd390b33787$var$K = $d225abd390b33787$var$qb();
    if ($d225abd390b33787$var$L) {
        var d = $d225abd390b33787$var$K.queue;
        b = d.dispatch;
        if (null !== $d225abd390b33787$var$O && (c = $d225abd390b33787$var$O.get(d), void 0 !== c)) {
            $d225abd390b33787$var$O.delete(d);
            d = $d225abd390b33787$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $d225abd390b33787$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $d225abd390b33787$var$K.memoizedState,
            b
        ];
    }
    a = a === $d225abd390b33787$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $d225abd390b33787$var$K.memoizedState = a;
    a = $d225abd390b33787$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $d225abd390b33787$var$ub.bind(null, $d225abd390b33787$var$I, a);
    return [
        $d225abd390b33787$var$K.memoizedState,
        a
    ];
}
function $d225abd390b33787$var$vb(a, b) {
    $d225abd390b33787$var$I = $d225abd390b33787$var$Q();
    $d225abd390b33787$var$K = $d225abd390b33787$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $d225abd390b33787$var$K) {
        var c = $d225abd390b33787$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$d225abd390b33787$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $d225abd390b33787$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $d225abd390b33787$var$ub(a, b, c) {
    if (25 <= $d225abd390b33787$var$P) throw Error($d225abd390b33787$var$l(301));
    if (a === $d225abd390b33787$var$I) {
        if ($d225abd390b33787$var$M = !0, a = {
            action: c,
            next: null
        }, null === $d225abd390b33787$var$O && ($d225abd390b33787$var$O = new Map), c = $d225abd390b33787$var$O.get(b), void 0 === c) $d225abd390b33787$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $d225abd390b33787$var$wb() {
    throw Error($d225abd390b33787$var$l(394));
}
function $d225abd390b33787$var$R() {}
var $d225abd390b33787$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $d225abd390b33787$var$Q();
        return a._currentValue2;
    },
    useMemo: $d225abd390b33787$var$vb,
    useReducer: $d225abd390b33787$var$tb,
    useRef: function(a) {
        $d225abd390b33787$var$I = $d225abd390b33787$var$Q();
        $d225abd390b33787$var$K = $d225abd390b33787$var$qb();
        var b = $d225abd390b33787$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $d225abd390b33787$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $d225abd390b33787$var$tb($d225abd390b33787$var$sb, a);
    },
    useInsertionEffect: $d225abd390b33787$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $d225abd390b33787$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $d225abd390b33787$var$R,
    useEffect: $d225abd390b33787$var$R,
    useDebugValue: $d225abd390b33787$var$R,
    useDeferredValue: function(a) {
        $d225abd390b33787$var$Q();
        return a;
    },
    useTransition: function() {
        $d225abd390b33787$var$Q();
        return [
            !1,
            $d225abd390b33787$var$wb
        ];
    },
    useId: function() {
        var a = $d225abd390b33787$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $d225abd390b33787$var$H(a) - 1)).toString(32) + b;
        var c = $d225abd390b33787$var$S;
        if (null === c) throw Error($d225abd390b33787$var$l(404));
        b = $d225abd390b33787$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $d225abd390b33787$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($d225abd390b33787$var$l(407));
        return c();
    }
}, $d225abd390b33787$var$S = null, $d225abd390b33787$var$yb = $bxRTa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $d225abd390b33787$var$zb(a) {
    console.error(a);
    return null;
}
function $d225abd390b33787$var$T() {}
function $d225abd390b33787$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $d225abd390b33787$var$zb : f,
        onAllReady: void 0 === e ? $d225abd390b33787$var$T : e,
        onShellReady: void 0 === g ? $d225abd390b33787$var$T : g,
        onShellError: void 0 === h ? $d225abd390b33787$var$T : h,
        onFatalError: void 0 === k ? $d225abd390b33787$var$T : k
    };
    c = $d225abd390b33787$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $d225abd390b33787$var$Bb(b, a, null, c, n, $d225abd390b33787$var$Ya, null, $d225abd390b33787$var$fb);
    m.push(a);
    return b;
}
function $d225abd390b33787$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $d225abd390b33787$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $d225abd390b33787$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $d225abd390b33787$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $d225abd390b33787$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $d225abd390b33787$var$Db(a, b, c, d, f) {
    $d225abd390b33787$var$I = {};
    $d225abd390b33787$var$ob = b;
    $d225abd390b33787$var$N = 0;
    for(a = c(d, f); $d225abd390b33787$var$M;)$d225abd390b33787$var$M = !1, $d225abd390b33787$var$N = 0, $d225abd390b33787$var$P += 1, $d225abd390b33787$var$K = null, a = c(d, f);
    $d225abd390b33787$var$rb();
    return a;
}
function $d225abd390b33787$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($d225abd390b33787$var$l(108, $d225abd390b33787$var$Xa(d) || "Unknown", h));
            d = $d225abd390b33787$var$B({}, g, c);
        }
        b.legacyContext = d;
        $d225abd390b33787$var$X(a, b, f);
        b.legacyContext = g;
    } else $d225abd390b33787$var$X(a, b, f);
}
function $d225abd390b33787$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $d225abd390b33787$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $d225abd390b33787$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $d225abd390b33787$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $d225abd390b33787$var$eb(e, c, d, f);
            $d225abd390b33787$var$Eb(a, b, e, c);
        } else {
            e = $d225abd390b33787$var$Za(c, b.legacyContext);
            f = $d225abd390b33787$var$Db(a, b, c, d, e);
            var g = 0 !== $d225abd390b33787$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $d225abd390b33787$var$eb(f, c, d, e), $d225abd390b33787$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $d225abd390b33787$var$gb(d, 1, 0);
                try {
                    $d225abd390b33787$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $d225abd390b33787$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $d225abd390b33787$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $d225abd390b33787$var$ra(g, c, d);
        $d225abd390b33787$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $d225abd390b33787$var$Ua:
            case $d225abd390b33787$var$Ta:
            case $d225abd390b33787$var$Ja:
            case $d225abd390b33787$var$Ka:
            case $d225abd390b33787$var$Ia:
                $d225abd390b33787$var$X(a, b, d.children);
                return;
            case $d225abd390b33787$var$Pa:
                $d225abd390b33787$var$X(a, b, d.children);
                return;
            case $d225abd390b33787$var$Sa:
                throw Error($d225abd390b33787$var$l(343));
            case $d225abd390b33787$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $d225abd390b33787$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $d225abd390b33787$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($d225abd390b33787$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $d225abd390b33787$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $d225abd390b33787$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $d225abd390b33787$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $d225abd390b33787$var$Na:
                d = $d225abd390b33787$var$Db(a, b, c.render, d, f);
                if (0 !== $d225abd390b33787$var$N) {
                    c = b.treeContext;
                    b.treeContext = $d225abd390b33787$var$gb(c, 1, 0);
                    try {
                        $d225abd390b33787$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $d225abd390b33787$var$X(a, b, d);
                return;
            case $d225abd390b33787$var$Qa:
                c = c.type;
                d = $d225abd390b33787$var$Fb(c, d);
                $d225abd390b33787$var$Gb(a, b, c, d, f);
                return;
            case $d225abd390b33787$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $d225abd390b33787$var$E;
                $d225abd390b33787$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $d225abd390b33787$var$X(a, b, f);
                a = $d225abd390b33787$var$E;
                if (null === a) throw Error($d225abd390b33787$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $d225abd390b33787$var$Va ? a.context._defaultValue : d;
                a = $d225abd390b33787$var$E = a.parent;
                b.context = a;
                return;
            case $d225abd390b33787$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $d225abd390b33787$var$X(a, b, d);
                return;
            case $d225abd390b33787$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $d225abd390b33787$var$Fb(c, d);
                $d225abd390b33787$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($d225abd390b33787$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $d225abd390b33787$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $d225abd390b33787$var$Ga:
                $d225abd390b33787$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $d225abd390b33787$var$Ha:
                throw Error($d225abd390b33787$var$l(257));
            case $d225abd390b33787$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $d225abd390b33787$var$X(a, b, c);
                return;
        }
        if ($d225abd390b33787$var$qa(c)) {
            $d225abd390b33787$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $d225abd390b33787$var$Wa && c[$d225abd390b33787$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $d225abd390b33787$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($d225abd390b33787$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $d225abd390b33787$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $d225abd390b33787$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $d225abd390b33787$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $d225abd390b33787$var$gb(e, d, f);
        try {
            $d225abd390b33787$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $d225abd390b33787$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $d225abd390b33787$var$X(a, b, c);
    } catch (k) {
        if ($d225abd390b33787$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $d225abd390b33787$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $d225abd390b33787$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $d225abd390b33787$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $d225abd390b33787$var$G(e), k;
    }
}
function $d225abd390b33787$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $d225abd390b33787$var$Kb(this, b, a);
}
function $d225abd390b33787$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($d225abd390b33787$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $d225abd390b33787$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $d225abd390b33787$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $d225abd390b33787$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $d225abd390b33787$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($d225abd390b33787$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $d225abd390b33787$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $d225abd390b33787$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($d225abd390b33787$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($d225abd390b33787$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $d225abd390b33787$var$Cb(a) {
    if (2 !== a.status) {
        var b = $d225abd390b33787$var$E, c = $d225abd390b33787$var$yb.current;
        $d225abd390b33787$var$yb.current = $d225abd390b33787$var$xb;
        var d = $d225abd390b33787$var$S;
        $d225abd390b33787$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $d225abd390b33787$var$G(g.context);
                    try {
                        $d225abd390b33787$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $d225abd390b33787$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($d225abd390b33787$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $d225abd390b33787$var$V(h, q);
                            null === n ? $d225abd390b33787$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $d225abd390b33787$var$Mb(a, a.destination);
        } catch (z) {
            $d225abd390b33787$var$V(a, z), $d225abd390b33787$var$W(a, z);
        } finally{
            $d225abd390b33787$var$S = d, $d225abd390b33787$var$yb.current = c, c === $d225abd390b33787$var$xb && $d225abd390b33787$var$G(b);
        }
    }
}
function $d225abd390b33787$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $d225abd390b33787$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($d225abd390b33787$var$l(390));
    }
}
function $d225abd390b33787$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $d225abd390b33787$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $d225abd390b33787$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $d225abd390b33787$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $d225abd390b33787$var$za(b, a.responseState, d);
        $d225abd390b33787$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $d225abd390b33787$var$za(b, a.responseState, d.id), $d225abd390b33787$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($d225abd390b33787$var$l(391));
    $d225abd390b33787$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $d225abd390b33787$var$Ob(a, b, c) {
    $d225abd390b33787$var$Aa(b, a.responseState, c.formatContext, c.id);
    $d225abd390b33787$var$Nb(a, b, c);
    return $d225abd390b33787$var$Ba(b, c.formatContext);
}
function $d225abd390b33787$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$d225abd390b33787$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($d225abd390b33787$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $d225abd390b33787$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($d225abd390b33787$var$l(392));
        return $d225abd390b33787$var$Ob(a, b, d);
    }
    $d225abd390b33787$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $d225abd390b33787$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $d225abd390b33787$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($d225abd390b33787$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $d225abd390b33787$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $d225abd390b33787$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $d225abd390b33787$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$d225abd390b33787$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$d225abd390b33787$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$d225abd390b33787$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $d225abd390b33787$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $d225abd390b33787$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $d225abd390b33787$var$Mb(a, a.destination);
    } catch (d) {
        $d225abd390b33787$var$V(a, d), $d225abd390b33787$var$W(a, d);
    }
}
function $d225abd390b33787$var$Sb() {}
function $d225abd390b33787$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $d225abd390b33787$var$Ab(a, $d225abd390b33787$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $d225abd390b33787$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $d225abd390b33787$var$Cb(a);
    $d225abd390b33787$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $d225abd390b33787$var$Mb(a, h);
        } catch (m) {
            $d225abd390b33787$var$V(a, m), $d225abd390b33787$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($d225abd390b33787$var$l(426));
    return g;
}
$d225abd390b33787$export$307591e98609eddd = function() {
    throw Error($d225abd390b33787$var$l(207));
};
$d225abd390b33787$export$eb3a06aef9e6ee51 = function(a, b) {
    return $d225abd390b33787$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$d225abd390b33787$export$b23711c915539651 = function() {
    throw Error($d225abd390b33787$var$l(208));
};
$d225abd390b33787$export$80e7718417253a51 = function(a, b) {
    return $d225abd390b33787$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$d225abd390b33787$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("3TORS", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $2d6df7737cf21851$export$7020a3240b287705, (v) => $2d6df7737cf21851$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $2d6df7737cf21851$export$83d89fbfd8236492, (v) => $2d6df7737cf21851$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2d6df7737cf21851$export$7020a3240b287705;
var $2d6df7737cf21851$export$83d89fbfd8236492;
'use strict';

var $bxRTa = parcelRequire("bxRTa");
function $2d6df7737cf21851$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $2d6df7737cf21851$var$l = null, $2d6df7737cf21851$var$n = 0;
function $2d6df7737cf21851$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $2d6df7737cf21851$var$n && (a.enqueue(new Uint8Array($2d6df7737cf21851$var$l.buffer, 0, $2d6df7737cf21851$var$n)), $2d6df7737cf21851$var$l = new Uint8Array(512), $2d6df7737cf21851$var$n = 0), a.enqueue(b);
        else {
            var c = $2d6df7737cf21851$var$l.length - $2d6df7737cf21851$var$n;
            c < b.length && (0 === c ? a.enqueue($2d6df7737cf21851$var$l) : ($2d6df7737cf21851$var$l.set(b.subarray(0, c), $2d6df7737cf21851$var$n), a.enqueue($2d6df7737cf21851$var$l), b = b.subarray(c)), $2d6df7737cf21851$var$l = new Uint8Array(512), $2d6df7737cf21851$var$n = 0);
            $2d6df7737cf21851$var$l.set(b, $2d6df7737cf21851$var$n);
            $2d6df7737cf21851$var$n += b.length;
        }
    }
}
function $2d6df7737cf21851$var$t(a, b) {
    $2d6df7737cf21851$var$p(a, b);
    return !0;
}
function $2d6df7737cf21851$var$ba(a) {
    $2d6df7737cf21851$var$l && 0 < $2d6df7737cf21851$var$n && (a.enqueue(new Uint8Array($2d6df7737cf21851$var$l.buffer, 0, $2d6df7737cf21851$var$n)), $2d6df7737cf21851$var$l = null, $2d6df7737cf21851$var$n = 0);
}
var $2d6df7737cf21851$var$ca = new TextEncoder;
function $2d6df7737cf21851$var$u(a) {
    return $2d6df7737cf21851$var$ca.encode(a);
}
function $2d6df7737cf21851$var$w(a) {
    return $2d6df7737cf21851$var$ca.encode(a);
}
function $2d6df7737cf21851$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $2d6df7737cf21851$var$x = Object.prototype.hasOwnProperty, $2d6df7737cf21851$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $2d6df7737cf21851$var$fa = {}, $2d6df7737cf21851$var$ha = {};
function $2d6df7737cf21851$var$ia(a) {
    if ($2d6df7737cf21851$var$x.call($2d6df7737cf21851$var$ha, a)) return !0;
    if ($2d6df7737cf21851$var$x.call($2d6df7737cf21851$var$fa, a)) return !1;
    if ($2d6df7737cf21851$var$ea.test(a)) return $2d6df7737cf21851$var$ha[a] = !0;
    $2d6df7737cf21851$var$fa[a] = !0;
    return !1;
}
function $2d6df7737cf21851$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $2d6df7737cf21851$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $2d6df7737cf21851$var$z[b] = new $2d6df7737cf21851$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $2d6df7737cf21851$var$ja = /[\-:]([a-z])/g;
function $2d6df7737cf21851$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($2d6df7737cf21851$var$ja, $2d6df7737cf21851$var$ka);
    $2d6df7737cf21851$var$z[b] = new $2d6df7737cf21851$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($2d6df7737cf21851$var$ja, $2d6df7737cf21851$var$ka);
    $2d6df7737cf21851$var$z[b] = new $2d6df7737cf21851$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($2d6df7737cf21851$var$ja, $2d6df7737cf21851$var$ka);
    $2d6df7737cf21851$var$z[b] = new $2d6df7737cf21851$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$2d6df7737cf21851$var$z.xlinkHref = new $2d6df7737cf21851$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $2d6df7737cf21851$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $2d6df7737cf21851$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($2d6df7737cf21851$var$B).forEach(function(a) {
    $2d6df7737cf21851$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $2d6df7737cf21851$var$B[b] = $2d6df7737cf21851$var$B[a];
    });
});
var $2d6df7737cf21851$var$oa = /["'&<>]/;
function $2d6df7737cf21851$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $2d6df7737cf21851$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $2d6df7737cf21851$var$pa = /([A-Z])/g, $2d6df7737cf21851$var$qa = /^ms-/, $2d6df7737cf21851$var$ra = Array.isArray, $2d6df7737cf21851$var$sa = $2d6df7737cf21851$var$w("<script>"), $2d6df7737cf21851$var$ta = $2d6df7737cf21851$var$w("\x3c/script>"), $2d6df7737cf21851$var$ua = $2d6df7737cf21851$var$w('<script src="'), $2d6df7737cf21851$var$va = $2d6df7737cf21851$var$w('<script type="module" src="'), $2d6df7737cf21851$var$wa = $2d6df7737cf21851$var$w('" async="">\x3c/script>'), $2d6df7737cf21851$var$xa = /(<\/|<)(s)(cript)/gi;
function $2d6df7737cf21851$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $2d6df7737cf21851$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $2d6df7737cf21851$var$sa : $2d6df7737cf21851$var$w('<script nonce="' + $2d6df7737cf21851$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $2d6df7737cf21851$var$u(("" + c).replace($2d6df7737cf21851$var$xa, $2d6df7737cf21851$var$ya)), $2d6df7737cf21851$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($2d6df7737cf21851$var$ua, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d[c])), $2d6df7737cf21851$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($2d6df7737cf21851$var$va, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(f[d])), $2d6df7737cf21851$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $2d6df7737cf21851$var$w(a + "P:"),
        segmentPrefix: $2d6df7737cf21851$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $2d6df7737cf21851$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $2d6df7737cf21851$var$Aa(a) {
    return $2d6df7737cf21851$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $2d6df7737cf21851$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $2d6df7737cf21851$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $2d6df7737cf21851$var$D(2, null);
        case "math":
            return $2d6df7737cf21851$var$D(3, null);
        case "foreignObject":
            return $2d6df7737cf21851$var$D(1, null);
        case "table":
            return $2d6df7737cf21851$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $2d6df7737cf21851$var$D(5, null);
        case "colgroup":
            return $2d6df7737cf21851$var$D(7, null);
        case "tr":
            return $2d6df7737cf21851$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $2d6df7737cf21851$var$D(1, null) : a;
}
var $2d6df7737cf21851$var$Ca = $2d6df7737cf21851$var$w("\x3c!-- --\x3e");
function $2d6df7737cf21851$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($2d6df7737cf21851$var$Ca);
    a.push($2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(b)));
    return !0;
}
var $2d6df7737cf21851$var$Ea = new Map, $2d6df7737cf21851$var$Fa = $2d6df7737cf21851$var$w(' style="'), $2d6df7737cf21851$var$Ga = $2d6df7737cf21851$var$w(":"), $2d6df7737cf21851$var$Ha = $2d6df7737cf21851$var$w(";");
function $2d6df7737cf21851$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($2d6df7737cf21851$var$k(62));
    b = !0;
    for(var d in c)if ($2d6df7737cf21851$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d));
                f = $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $2d6df7737cf21851$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $2d6df7737cf21851$var$w($2d6df7737cf21851$var$C(e.replace($2d6df7737cf21851$var$pa, "-$1").toLowerCase().replace($2d6df7737cf21851$var$qa, "-ms-"))), $2d6df7737cf21851$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $2d6df7737cf21851$var$x.call($2d6df7737cf21851$var$B, d) ? $2d6df7737cf21851$var$u("" + f) : $2d6df7737cf21851$var$u(f + "px") : $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($2d6df7737cf21851$var$Fa, e, $2d6df7737cf21851$var$Ga, f)) : a.push($2d6df7737cf21851$var$Ha, e, $2d6df7737cf21851$var$Ga, f);
        }
    }
    b || a.push($2d6df7737cf21851$var$E);
}
var $2d6df7737cf21851$var$H = $2d6df7737cf21851$var$w(" "), $2d6df7737cf21851$var$I = $2d6df7737cf21851$var$w('="'), $2d6df7737cf21851$var$E = $2d6df7737cf21851$var$w('"'), $2d6df7737cf21851$var$Ja = $2d6df7737cf21851$var$w('=""');
function $2d6df7737cf21851$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $2d6df7737cf21851$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $2d6df7737cf21851$var$z.hasOwnProperty(c) ? $2d6df7737cf21851$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $2d6df7737cf21851$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$Ja) : !1 !== d && a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d)), $2d6df7737cf21851$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d)), $2d6df7737cf21851$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d)), $2d6df7737cf21851$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d)), $2d6df7737cf21851$var$E);
            }
        } else if ($2d6df7737cf21851$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($2d6df7737cf21851$var$H, $2d6df7737cf21851$var$u(c), $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d)), $2d6df7737cf21851$var$E);
        }
    }
}
var $2d6df7737cf21851$var$K = $2d6df7737cf21851$var$w(">"), $2d6df7737cf21851$var$Ka = $2d6df7737cf21851$var$w("/>");
function $2d6df7737cf21851$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($2d6df7737cf21851$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($2d6df7737cf21851$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($2d6df7737cf21851$var$u("" + b));
    }
}
function $2d6df7737cf21851$var$La(a) {
    var b = "";
    $bxRTa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $2d6df7737cf21851$var$Ma = $2d6df7737cf21851$var$w(' selected=""');
function $2d6df7737cf21851$var$Na(a, b, c, d) {
    a.push($2d6df7737cf21851$var$M(c));
    var f = c = null, e;
    for(e in b)if ($2d6df7737cf21851$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $2d6df7737cf21851$var$J(a, d, e, g);
        }
    }
    a.push($2d6df7737cf21851$var$K);
    $2d6df7737cf21851$var$L(a, f, c);
    return "string" === typeof c ? (a.push($2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(c))), null) : c;
}
var $2d6df7737cf21851$var$Oa = $2d6df7737cf21851$var$w("\n"), $2d6df7737cf21851$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $2d6df7737cf21851$var$Qa = new Map;
function $2d6df7737cf21851$var$M(a) {
    var b = $2d6df7737cf21851$var$Qa.get(a);
    if (void 0 === b) {
        if (!$2d6df7737cf21851$var$Pa.test(a)) throw Error($2d6df7737cf21851$var$k(65, a));
        b = $2d6df7737cf21851$var$w("<" + a);
        $2d6df7737cf21851$var$Qa.set(a, b);
    }
    return b;
}
var $2d6df7737cf21851$var$Ra = $2d6df7737cf21851$var$w("<!DOCTYPE html>");
function $2d6df7737cf21851$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($2d6df7737cf21851$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($2d6df7737cf21851$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $2d6df7737cf21851$var$J(a, d, r, h);
                }
            }
            a.push($2d6df7737cf21851$var$K);
            $2d6df7737cf21851$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($2d6df7737cf21851$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($2d6df7737cf21851$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $2d6df7737cf21851$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $2d6df7737cf21851$var$La(h), $2d6df7737cf21851$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($2d6df7737cf21851$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($2d6df7737cf21851$var$Ma);
            } else q && a.push($2d6df7737cf21851$var$Ma);
            a.push($2d6df7737cf21851$var$K);
            $2d6df7737cf21851$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($2d6df7737cf21851$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($2d6df7737cf21851$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($2d6df7737cf21851$var$k(91));
                default:
                    $2d6df7737cf21851$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($2d6df7737cf21851$var$K);
            if (null != r) {
                if (null != e) throw Error($2d6df7737cf21851$var$k(92));
                if ($2d6df7737cf21851$var$ra(r) && 1 < r.length) throw Error($2d6df7737cf21851$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($2d6df7737cf21851$var$Oa);
            null !== e && a.push($2d6df7737cf21851$var$u($2d6df7737cf21851$var$C("" + e)));
            return null;
        case "input":
            a.push($2d6df7737cf21851$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($2d6df7737cf21851$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($2d6df7737cf21851$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $2d6df7737cf21851$var$J(a, d, g, q);
            }
            null !== r ? $2d6df7737cf21851$var$J(a, d, "checked", r) : null !== m && $2d6df7737cf21851$var$J(a, d, "checked", m);
            null !== e ? $2d6df7737cf21851$var$J(a, d, "value", e) : null !== h && $2d6df7737cf21851$var$J(a, d, "value", h);
            a.push($2d6df7737cf21851$var$Ka);
            return null;
        case "menuitem":
            a.push($2d6df7737cf21851$var$M("menuitem"));
            for(var A in c)if ($2d6df7737cf21851$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($2d6df7737cf21851$var$k(400));
                default:
                    $2d6df7737cf21851$var$J(a, d, A, e);
            }
            a.push($2d6df7737cf21851$var$K);
            return null;
        case "title":
            a.push($2d6df7737cf21851$var$M("title"));
            e = null;
            for(v in c)if ($2d6df7737cf21851$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($2d6df7737cf21851$var$k(434));
                default:
                    $2d6df7737cf21851$var$J(a, d, v, g);
            }
            a.push($2d6df7737cf21851$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($2d6df7737cf21851$var$M(b));
            g = e = null;
            for(m in c)if ($2d6df7737cf21851$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $2d6df7737cf21851$var$J(a, d, m, h);
            }
            a.push($2d6df7737cf21851$var$K);
            if (null != g) {
                if (null != e) throw Error($2d6df7737cf21851$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($2d6df7737cf21851$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($2d6df7737cf21851$var$Oa, $2d6df7737cf21851$var$u(c)) : a.push($2d6df7737cf21851$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($2d6df7737cf21851$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($2d6df7737cf21851$var$M(b));
            for(var F in c)if ($2d6df7737cf21851$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($2d6df7737cf21851$var$k(399, b));
                default:
                    $2d6df7737cf21851$var$J(a, d, F, e);
            }
            a.push($2d6df7737cf21851$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $2d6df7737cf21851$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($2d6df7737cf21851$var$Ra), $2d6df7737cf21851$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $2d6df7737cf21851$var$Na(a, c, b, d);
            a.push($2d6df7737cf21851$var$M(b));
            g = e = null;
            for(q in c)if ($2d6df7737cf21851$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $2d6df7737cf21851$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $2d6df7737cf21851$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($2d6df7737cf21851$var$H, $2d6df7737cf21851$var$u(q), $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(h)), $2d6df7737cf21851$var$E);
            }
            a.push($2d6df7737cf21851$var$K);
            $2d6df7737cf21851$var$L(a, g, e);
            return e;
    }
}
var $2d6df7737cf21851$var$Ta = $2d6df7737cf21851$var$w("</"), $2d6df7737cf21851$var$Ua = $2d6df7737cf21851$var$w(">"), $2d6df7737cf21851$var$Va = $2d6df7737cf21851$var$w('<template id="'), $2d6df7737cf21851$var$Wa = $2d6df7737cf21851$var$w('"></template>'), $2d6df7737cf21851$var$Xa = $2d6df7737cf21851$var$w("\x3c!--$--\x3e"), $2d6df7737cf21851$var$Ya = $2d6df7737cf21851$var$w('\x3c!--$?--\x3e<template id="'), $2d6df7737cf21851$var$Za = $2d6df7737cf21851$var$w('"></template>'), $2d6df7737cf21851$var$$a = $2d6df7737cf21851$var$w("\x3c!--$!--\x3e"), $2d6df7737cf21851$var$ab = $2d6df7737cf21851$var$w("\x3c!--/$--\x3e"), $2d6df7737cf21851$var$bb = $2d6df7737cf21851$var$w("<template"), $2d6df7737cf21851$var$cb = $2d6df7737cf21851$var$w('"'), $2d6df7737cf21851$var$db = $2d6df7737cf21851$var$w(' data-dgst="');
$2d6df7737cf21851$var$w(' data-msg="');
$2d6df7737cf21851$var$w(' data-stck="');
var $2d6df7737cf21851$var$eb = $2d6df7737cf21851$var$w("></template>");
function $2d6df7737cf21851$var$fb(a, b, c) {
    $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$Ya);
    if (null === c) throw Error($2d6df7737cf21851$var$k(395));
    $2d6df7737cf21851$var$p(a, c);
    return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$Za);
}
var $2d6df7737cf21851$var$gb = $2d6df7737cf21851$var$w('<div hidden id="'), $2d6df7737cf21851$var$hb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$ib = $2d6df7737cf21851$var$w("</div>"), $2d6df7737cf21851$var$jb = $2d6df7737cf21851$var$w('<svg aria-hidden="true" style="display:none" id="'), $2d6df7737cf21851$var$kb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$lb = $2d6df7737cf21851$var$w("</svg>"), $2d6df7737cf21851$var$mb = $2d6df7737cf21851$var$w('<math aria-hidden="true" style="display:none" id="'), $2d6df7737cf21851$var$nb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$ob = $2d6df7737cf21851$var$w("</math>"), $2d6df7737cf21851$var$pb = $2d6df7737cf21851$var$w('<table hidden id="'), $2d6df7737cf21851$var$qb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$rb = $2d6df7737cf21851$var$w("</table>"), $2d6df7737cf21851$var$sb = $2d6df7737cf21851$var$w('<table hidden><tbody id="'), $2d6df7737cf21851$var$tb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$ub = $2d6df7737cf21851$var$w("</tbody></table>"), $2d6df7737cf21851$var$vb = $2d6df7737cf21851$var$w('<table hidden><tr id="'), $2d6df7737cf21851$var$wb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$xb = $2d6df7737cf21851$var$w("</tr></table>"), $2d6df7737cf21851$var$yb = $2d6df7737cf21851$var$w('<table hidden><colgroup id="'), $2d6df7737cf21851$var$zb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$Ab = $2d6df7737cf21851$var$w("</colgroup></table>");
function $2d6df7737cf21851$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$gb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$hb);
        case 2:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$jb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$kb);
        case 3:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$mb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$nb);
        case 4:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$pb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$qb);
        case 5:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$sb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$tb);
        case 6:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$vb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$wb);
        case 7:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$yb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$zb);
        default:
            throw Error($2d6df7737cf21851$var$k(397));
    }
}
function $2d6df7737cf21851$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$ib);
        case 2:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$lb);
        case 3:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$ob);
        case 4:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$rb);
        case 5:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$ub);
        case 6:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$xb);
        case 7:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$Ab);
        default:
            throw Error($2d6df7737cf21851$var$k(397));
    }
}
var $2d6df7737cf21851$var$Db = $2d6df7737cf21851$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $2d6df7737cf21851$var$Eb = $2d6df7737cf21851$var$w('$RS("'), $2d6df7737cf21851$var$Gb = $2d6df7737cf21851$var$w('","'), $2d6df7737cf21851$var$Hb = $2d6df7737cf21851$var$w('")\x3c/script>'), $2d6df7737cf21851$var$Ib = $2d6df7737cf21851$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $2d6df7737cf21851$var$Jb = $2d6df7737cf21851$var$w('$RC("'), $2d6df7737cf21851$var$Kb = $2d6df7737cf21851$var$w('","'), $2d6df7737cf21851$var$Lb = $2d6df7737cf21851$var$w('")\x3c/script>'), $2d6df7737cf21851$var$Mb = $2d6df7737cf21851$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $2d6df7737cf21851$var$Nb = $2d6df7737cf21851$var$w('$RX("'), $2d6df7737cf21851$var$Ob = $2d6df7737cf21851$var$w('"'), $2d6df7737cf21851$var$Pb = $2d6df7737cf21851$var$w(")\x3c/script>"), $2d6df7737cf21851$var$Qb = $2d6df7737cf21851$var$w(","), $2d6df7737cf21851$var$Rb = /[<\u2028\u2029]/g;
function $2d6df7737cf21851$var$Sb(a) {
    return JSON.stringify(a).replace($2d6df7737cf21851$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $2d6df7737cf21851$var$N = Object.assign, $2d6df7737cf21851$var$Tb = Symbol.for("react.element"), $2d6df7737cf21851$var$Ub = Symbol.for("react.portal"), $2d6df7737cf21851$var$Vb = Symbol.for("react.fragment"), $2d6df7737cf21851$var$Wb = Symbol.for("react.strict_mode"), $2d6df7737cf21851$var$Xb = Symbol.for("react.profiler"), $2d6df7737cf21851$var$Yb = Symbol.for("react.provider"), $2d6df7737cf21851$var$Zb = Symbol.for("react.context"), $2d6df7737cf21851$var$$b = Symbol.for("react.forward_ref"), $2d6df7737cf21851$var$ac = Symbol.for("react.suspense"), $2d6df7737cf21851$var$bc = Symbol.for("react.suspense_list"), $2d6df7737cf21851$var$cc = Symbol.for("react.memo"), $2d6df7737cf21851$var$dc = Symbol.for("react.lazy"), $2d6df7737cf21851$var$ec = Symbol.for("react.scope"), $2d6df7737cf21851$var$fc = Symbol.for("react.debug_trace_mode"), $2d6df7737cf21851$var$gc = Symbol.for("react.legacy_hidden"), $2d6df7737cf21851$var$hc = Symbol.for("react.default_value"), $2d6df7737cf21851$var$ic = Symbol.iterator;
function $2d6df7737cf21851$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $2d6df7737cf21851$var$Vb:
            return "Fragment";
        case $2d6df7737cf21851$var$Ub:
            return "Portal";
        case $2d6df7737cf21851$var$Xb:
            return "Profiler";
        case $2d6df7737cf21851$var$Wb:
            return "StrictMode";
        case $2d6df7737cf21851$var$ac:
            return "Suspense";
        case $2d6df7737cf21851$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $2d6df7737cf21851$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $2d6df7737cf21851$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $2d6df7737cf21851$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $2d6df7737cf21851$var$cc:
            return b = a.displayName || null, null !== b ? b : $2d6df7737cf21851$var$jc(a.type) || "Memo";
        case $2d6df7737cf21851$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $2d6df7737cf21851$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $2d6df7737cf21851$var$kc = {};
function $2d6df7737cf21851$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $2d6df7737cf21851$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $2d6df7737cf21851$var$O = null;
function $2d6df7737cf21851$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($2d6df7737cf21851$var$k(401));
        } else {
            if (null === c) throw Error($2d6df7737cf21851$var$k(401));
            $2d6df7737cf21851$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $2d6df7737cf21851$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $2d6df7737cf21851$var$mc(a);
}
function $2d6df7737cf21851$var$nc(a) {
    var b = a.parent;
    null !== b && $2d6df7737cf21851$var$nc(b);
    a.context._currentValue = a.value;
}
function $2d6df7737cf21851$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($2d6df7737cf21851$var$k(402));
    a.depth === b.depth ? $2d6df7737cf21851$var$P(a, b) : $2d6df7737cf21851$var$oc(a, b);
}
function $2d6df7737cf21851$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($2d6df7737cf21851$var$k(402));
    a.depth === c.depth ? $2d6df7737cf21851$var$P(a, c) : $2d6df7737cf21851$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $2d6df7737cf21851$var$Q(a) {
    var b = $2d6df7737cf21851$var$O;
    b !== a && (null === b ? $2d6df7737cf21851$var$nc(a) : null === a ? $2d6df7737cf21851$var$mc(b) : b.depth === a.depth ? $2d6df7737cf21851$var$P(b, a) : b.depth > a.depth ? $2d6df7737cf21851$var$oc(b, a) : $2d6df7737cf21851$var$pc(b, a), $2d6df7737cf21851$var$O = a);
}
var $2d6df7737cf21851$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $2d6df7737cf21851$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $2d6df7737cf21851$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $2d6df7737cf21851$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $2d6df7737cf21851$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $2d6df7737cf21851$var$N({}, e, h)) : $2d6df7737cf21851$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $2d6df7737cf21851$var$sc = {
    id: 1,
    overflow: ""
};
function $2d6df7737cf21851$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $2d6df7737cf21851$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $2d6df7737cf21851$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $2d6df7737cf21851$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $2d6df7737cf21851$var$uc = Math.clz32 ? Math.clz32 : $2d6df7737cf21851$var$vc, $2d6df7737cf21851$var$wc = Math.log, $2d6df7737cf21851$var$xc = Math.LN2;
function $2d6df7737cf21851$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($2d6df7737cf21851$var$wc(a) / $2d6df7737cf21851$var$xc | 0) | 0;
}
function $2d6df7737cf21851$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2d6df7737cf21851$var$zc = "function" === typeof Object.is ? Object.is : $2d6df7737cf21851$var$yc, $2d6df7737cf21851$var$R = null, $2d6df7737cf21851$var$Ac = null, $2d6df7737cf21851$var$Bc = null, $2d6df7737cf21851$var$S = null, $2d6df7737cf21851$var$T = !1, $2d6df7737cf21851$var$Cc = !1, $2d6df7737cf21851$var$U = 0, $2d6df7737cf21851$var$V = null, $2d6df7737cf21851$var$Dc = 0;
function $2d6df7737cf21851$var$W() {
    if (null === $2d6df7737cf21851$var$R) throw Error($2d6df7737cf21851$var$k(321));
    return $2d6df7737cf21851$var$R;
}
function $2d6df7737cf21851$var$Ec() {
    if (0 < $2d6df7737cf21851$var$Dc) throw Error($2d6df7737cf21851$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $2d6df7737cf21851$var$Fc() {
    null === $2d6df7737cf21851$var$S ? null === $2d6df7737cf21851$var$Bc ? ($2d6df7737cf21851$var$T = !1, $2d6df7737cf21851$var$Bc = $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$Ec()) : ($2d6df7737cf21851$var$T = !0, $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$Bc) : null === $2d6df7737cf21851$var$S.next ? ($2d6df7737cf21851$var$T = !1, $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$S.next = $2d6df7737cf21851$var$Ec()) : ($2d6df7737cf21851$var$T = !0, $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$S.next);
    return $2d6df7737cf21851$var$S;
}
function $2d6df7737cf21851$var$Gc() {
    $2d6df7737cf21851$var$Ac = $2d6df7737cf21851$var$R = null;
    $2d6df7737cf21851$var$Cc = !1;
    $2d6df7737cf21851$var$Bc = null;
    $2d6df7737cf21851$var$Dc = 0;
    $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$V = null;
}
function $2d6df7737cf21851$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $2d6df7737cf21851$var$Ic(a, b, c) {
    $2d6df7737cf21851$var$R = $2d6df7737cf21851$var$W();
    $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$Fc();
    if ($2d6df7737cf21851$var$T) {
        var d = $2d6df7737cf21851$var$S.queue;
        b = d.dispatch;
        if (null !== $2d6df7737cf21851$var$V && (c = $2d6df7737cf21851$var$V.get(d), void 0 !== c)) {
            $2d6df7737cf21851$var$V.delete(d);
            d = $2d6df7737cf21851$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $2d6df7737cf21851$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $2d6df7737cf21851$var$S.memoizedState,
            b
        ];
    }
    a = a === $2d6df7737cf21851$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $2d6df7737cf21851$var$S.memoizedState = a;
    a = $2d6df7737cf21851$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $2d6df7737cf21851$var$Jc.bind(null, $2d6df7737cf21851$var$R, a);
    return [
        $2d6df7737cf21851$var$S.memoizedState,
        a
    ];
}
function $2d6df7737cf21851$var$Kc(a, b) {
    $2d6df7737cf21851$var$R = $2d6df7737cf21851$var$W();
    $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $2d6df7737cf21851$var$S) {
        var c = $2d6df7737cf21851$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$2d6df7737cf21851$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $2d6df7737cf21851$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2d6df7737cf21851$var$Jc(a, b, c) {
    if (25 <= $2d6df7737cf21851$var$Dc) throw Error($2d6df7737cf21851$var$k(301));
    if (a === $2d6df7737cf21851$var$R) {
        if ($2d6df7737cf21851$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $2d6df7737cf21851$var$V && ($2d6df7737cf21851$var$V = new Map), c = $2d6df7737cf21851$var$V.get(b), void 0 === c) $2d6df7737cf21851$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $2d6df7737cf21851$var$Lc() {
    throw Error($2d6df7737cf21851$var$k(394));
}
function $2d6df7737cf21851$var$Mc() {}
var $2d6df7737cf21851$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $2d6df7737cf21851$var$W();
        return a._currentValue;
    },
    useMemo: $2d6df7737cf21851$var$Kc,
    useReducer: $2d6df7737cf21851$var$Ic,
    useRef: function(a) {
        $2d6df7737cf21851$var$R = $2d6df7737cf21851$var$W();
        $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$Fc();
        var b = $2d6df7737cf21851$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $2d6df7737cf21851$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $2d6df7737cf21851$var$Ic($2d6df7737cf21851$var$Hc, a);
    },
    useInsertionEffect: $2d6df7737cf21851$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $2d6df7737cf21851$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $2d6df7737cf21851$var$Mc,
    useEffect: $2d6df7737cf21851$var$Mc,
    useDebugValue: $2d6df7737cf21851$var$Mc,
    useDeferredValue: function(a) {
        $2d6df7737cf21851$var$W();
        return a;
    },
    useTransition: function() {
        $2d6df7737cf21851$var$W();
        return [
            !1,
            $2d6df7737cf21851$var$Lc
        ];
    },
    useId: function() {
        var a = $2d6df7737cf21851$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $2d6df7737cf21851$var$uc(a) - 1)).toString(32) + b;
        var c = $2d6df7737cf21851$var$Nc;
        if (null === c) throw Error($2d6df7737cf21851$var$k(404));
        b = $2d6df7737cf21851$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $2d6df7737cf21851$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($2d6df7737cf21851$var$k(407));
        return c();
    }
}, $2d6df7737cf21851$var$Nc = null, $2d6df7737cf21851$var$Pc = $bxRTa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $2d6df7737cf21851$var$Qc(a) {
    console.error(a);
    return null;
}
function $2d6df7737cf21851$var$X() {}
function $2d6df7737cf21851$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $2d6df7737cf21851$var$Qc : f,
        onAllReady: void 0 === e ? $2d6df7737cf21851$var$X : e,
        onShellReady: void 0 === g ? $2d6df7737cf21851$var$X : g,
        onShellError: void 0 === h ? $2d6df7737cf21851$var$X : h,
        onFatalError: void 0 === m ? $2d6df7737cf21851$var$X : m
    };
    c = $2d6df7737cf21851$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $2d6df7737cf21851$var$Tc(b, a, null, c, r, $2d6df7737cf21851$var$kc, null, $2d6df7737cf21851$var$sc);
    q.push(a);
    return b;
}
function $2d6df7737cf21851$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $2d6df7737cf21851$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $2d6df7737cf21851$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $2d6df7737cf21851$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $2d6df7737cf21851$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $2d6df7737cf21851$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $2d6df7737cf21851$var$Wc(a, b, c, d, f) {
    $2d6df7737cf21851$var$R = {};
    $2d6df7737cf21851$var$Ac = b;
    $2d6df7737cf21851$var$U = 0;
    for(a = c(d, f); $2d6df7737cf21851$var$Cc;)$2d6df7737cf21851$var$Cc = !1, $2d6df7737cf21851$var$U = 0, $2d6df7737cf21851$var$Dc += 1, $2d6df7737cf21851$var$S = null, a = c(d, f);
    $2d6df7737cf21851$var$Gc();
    return a;
}
function $2d6df7737cf21851$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($2d6df7737cf21851$var$k(108, $2d6df7737cf21851$var$jc(d) || "Unknown", h));
            d = $2d6df7737cf21851$var$N({}, g, c);
        }
        b.legacyContext = d;
        $2d6df7737cf21851$var$Z(a, b, f);
        b.legacyContext = g;
    } else $2d6df7737cf21851$var$Z(a, b, f);
}
function $2d6df7737cf21851$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $2d6df7737cf21851$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $2d6df7737cf21851$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $2d6df7737cf21851$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $2d6df7737cf21851$var$rc(e, c, d, f);
            $2d6df7737cf21851$var$Xc(a, b, e, c);
        } else {
            e = $2d6df7737cf21851$var$lc(c, b.legacyContext);
            f = $2d6df7737cf21851$var$Wc(a, b, c, d, e);
            var g = 0 !== $2d6df7737cf21851$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $2d6df7737cf21851$var$rc(f, c, d, e), $2d6df7737cf21851$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $2d6df7737cf21851$var$tc(d, 1, 0);
                try {
                    $2d6df7737cf21851$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $2d6df7737cf21851$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $2d6df7737cf21851$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $2d6df7737cf21851$var$Ba(g, c, d);
        $2d6df7737cf21851$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($2d6df7737cf21851$var$Ta, $2d6df7737cf21851$var$u(c), $2d6df7737cf21851$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $2d6df7737cf21851$var$gc:
            case $2d6df7737cf21851$var$fc:
            case $2d6df7737cf21851$var$Wb:
            case $2d6df7737cf21851$var$Xb:
            case $2d6df7737cf21851$var$Vb:
                $2d6df7737cf21851$var$Z(a, b, d.children);
                return;
            case $2d6df7737cf21851$var$bc:
                $2d6df7737cf21851$var$Z(a, b, d.children);
                return;
            case $2d6df7737cf21851$var$ec:
                throw Error($2d6df7737cf21851$var$k(343));
            case $2d6df7737cf21851$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $2d6df7737cf21851$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $2d6df7737cf21851$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($2d6df7737cf21851$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($2d6df7737cf21851$var$Ca), q.status = 1, $2d6df7737cf21851$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $2d6df7737cf21851$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $2d6df7737cf21851$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $2d6df7737cf21851$var$$b:
                d = $2d6df7737cf21851$var$Wc(a, b, c.render, d, f);
                if (0 !== $2d6df7737cf21851$var$U) {
                    c = b.treeContext;
                    b.treeContext = $2d6df7737cf21851$var$tc(c, 1, 0);
                    try {
                        $2d6df7737cf21851$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $2d6df7737cf21851$var$Z(a, b, d);
                return;
            case $2d6df7737cf21851$var$cc:
                c = c.type;
                d = $2d6df7737cf21851$var$Yc(c, d);
                $2d6df7737cf21851$var$Zc(a, b, c, d, f);
                return;
            case $2d6df7737cf21851$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $2d6df7737cf21851$var$O;
                $2d6df7737cf21851$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $2d6df7737cf21851$var$Z(a, b, f);
                a = $2d6df7737cf21851$var$O;
                if (null === a) throw Error($2d6df7737cf21851$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $2d6df7737cf21851$var$hc ? a.context._defaultValue : d;
                a = $2d6df7737cf21851$var$O = a.parent;
                b.context = a;
                return;
            case $2d6df7737cf21851$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $2d6df7737cf21851$var$Z(a, b, d);
                return;
            case $2d6df7737cf21851$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $2d6df7737cf21851$var$Yc(c, d);
                $2d6df7737cf21851$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($2d6df7737cf21851$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $2d6df7737cf21851$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $2d6df7737cf21851$var$Tb:
                $2d6df7737cf21851$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $2d6df7737cf21851$var$Ub:
                throw Error($2d6df7737cf21851$var$k(257));
            case $2d6df7737cf21851$var$dc:
                var d = c._init;
                c = d(c._payload);
                $2d6df7737cf21851$var$Z(a, b, c);
                return;
        }
        if ($2d6df7737cf21851$var$ra(c)) {
            $2d6df7737cf21851$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $2d6df7737cf21851$var$ic && c[$2d6df7737cf21851$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $2d6df7737cf21851$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($2d6df7737cf21851$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $2d6df7737cf21851$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $2d6df7737cf21851$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $2d6df7737cf21851$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $2d6df7737cf21851$var$tc(e, d, f);
        try {
            $2d6df7737cf21851$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $2d6df7737cf21851$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $2d6df7737cf21851$var$Z(a, b, c);
    } catch (m) {
        if ($2d6df7737cf21851$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $2d6df7737cf21851$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $2d6df7737cf21851$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $2d6df7737cf21851$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $2d6df7737cf21851$var$Q(e), m;
    }
}
function $2d6df7737cf21851$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $2d6df7737cf21851$var$dd(this, b, a);
}
function $2d6df7737cf21851$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($2d6df7737cf21851$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $2d6df7737cf21851$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $2d6df7737cf21851$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $2d6df7737cf21851$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $2d6df7737cf21851$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($2d6df7737cf21851$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $2d6df7737cf21851$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $2d6df7737cf21851$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($2d6df7737cf21851$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($2d6df7737cf21851$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $2d6df7737cf21851$var$Uc(a) {
    if (2 !== a.status) {
        var b = $2d6df7737cf21851$var$O, c = $2d6df7737cf21851$var$Pc.current;
        $2d6df7737cf21851$var$Pc.current = $2d6df7737cf21851$var$Oc;
        var d = $2d6df7737cf21851$var$Nc;
        $2d6df7737cf21851$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $2d6df7737cf21851$var$Q(g.context);
                    try {
                        $2d6df7737cf21851$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($2d6df7737cf21851$var$Ca), g.abortSet.delete(g), m.status = 1, $2d6df7737cf21851$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($2d6df7737cf21851$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $2d6df7737cf21851$var$Y(h, v);
                            null === r ? $2d6df7737cf21851$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $2d6df7737cf21851$var$fd(a, a.destination);
        } catch (G) {
            $2d6df7737cf21851$var$Y(a, G), $2d6df7737cf21851$var$Vc(a, G);
        } finally{
            $2d6df7737cf21851$var$Nc = d, $2d6df7737cf21851$var$Pc.current = c, c === $2d6df7737cf21851$var$Oc && $2d6df7737cf21851$var$Q(b);
        }
    }
}
function $2d6df7737cf21851$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Va);
            $2d6df7737cf21851$var$p(b, a.placeholderPrefix);
            a = $2d6df7737cf21851$var$u(d.toString(16));
            $2d6df7737cf21851$var$p(b, a);
            return $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$2d6df7737cf21851$var$p(b, d[e]);
                f = $2d6df7737cf21851$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$2d6df7737cf21851$var$p(b, d[e]);
            e < d.length && (f = $2d6df7737cf21851$var$t(b, d[e]));
            return f;
        default:
            throw Error($2d6df7737cf21851$var$k(390));
    }
}
function $2d6df7737cf21851$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $2d6df7737cf21851$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$$a), $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$bb), d && ($2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$db), $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d))), $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$cb)), $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$eb), $2d6df7737cf21851$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $2d6df7737cf21851$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $2d6df7737cf21851$var$fb(b, a.responseState, d);
        $2d6df7737cf21851$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $2d6df7737cf21851$var$fb(b, a.responseState, d.id), $2d6df7737cf21851$var$gd(a, b, c);
    else {
        $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($2d6df7737cf21851$var$k(391));
        $2d6df7737cf21851$var$hd(a, b, c[0]);
    }
    return $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$ab);
}
function $2d6df7737cf21851$var$id(a, b, c) {
    $2d6df7737cf21851$var$Bb(b, a.responseState, c.formatContext, c.id);
    $2d6df7737cf21851$var$hd(a, b, c);
    return $2d6df7737cf21851$var$Cb(b, c.formatContext);
}
function $2d6df7737cf21851$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$2d6df7737cf21851$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $2d6df7737cf21851$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Ib));
    if (null === d) throw Error($2d6df7737cf21851$var$k(395));
    c = $2d6df7737cf21851$var$u(c.toString(16));
    $2d6df7737cf21851$var$p(b, d);
    $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Kb);
    $2d6df7737cf21851$var$p(b, a.segmentPrefix);
    $2d6df7737cf21851$var$p(b, c);
    return $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$Lb);
}
function $2d6df7737cf21851$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($2d6df7737cf21851$var$k(392));
        return $2d6df7737cf21851$var$id(a, b, d);
    }
    $2d6df7737cf21851$var$id(a, b, d);
    a = a.responseState;
    $2d6df7737cf21851$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Eb) : (a.sentCompleteSegmentFunction = !0, $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Db));
    $2d6df7737cf21851$var$p(b, a.segmentPrefix);
    f = $2d6df7737cf21851$var$u(f.toString(16));
    $2d6df7737cf21851$var$p(b, f);
    $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Gb);
    $2d6df7737cf21851$var$p(b, a.placeholderPrefix);
    $2d6df7737cf21851$var$p(b, f);
    return $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$Hb);
}
function $2d6df7737cf21851$var$fd(a, b) {
    $2d6df7737cf21851$var$l = new Uint8Array(512);
    $2d6df7737cf21851$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $2d6df7737cf21851$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$2d6df7737cf21851$var$p(b, d[c]);
            c < d.length && $2d6df7737cf21851$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $2d6df7737cf21851$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Nb) : (h.sentClientRenderFunction = !0, $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Mb));
            if (null === m) throw Error($2d6df7737cf21851$var$k(395));
            $2d6df7737cf21851$var$p(d, m);
            $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Ob);
            if (q || r || v) $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Qb), $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$Sb(q || "")));
            if (r || v) $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Qb), $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$Sb(r || "")));
            v && ($2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Qb), $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$Sb(v))));
            if (!$2d6df7737cf21851$var$t(d, $2d6df7737cf21851$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$2d6df7737cf21851$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $2d6df7737cf21851$var$ba(b);
        $2d6df7737cf21851$var$l = new Uint8Array(512);
        $2d6df7737cf21851$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$2d6df7737cf21851$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$2d6df7737cf21851$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $2d6df7737cf21851$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $2d6df7737cf21851$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $2d6df7737cf21851$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $2d6df7737cf21851$var$fd(a, a.destination);
    } catch (d) {
        $2d6df7737cf21851$var$Y(a, d), $2d6df7737cf21851$var$Vc(a, d);
    }
}
$2d6df7737cf21851$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $2d6df7737cf21851$var$Rc(a, $2d6df7737cf21851$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $2d6df7737cf21851$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $2d6df7737cf21851$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $2d6df7737cf21851$var$fd(h, a);
                        } catch (A) {
                            $2d6df7737cf21851$var$Y(h, A), $2d6df7737cf21851$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $2d6df7737cf21851$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $2d6df7737cf21851$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $2d6df7737cf21851$var$Uc(h);
    });
};
$2d6df7737cf21851$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("2ARZ1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1e38d185da9648c7$var$ReactIs, $1e38d185da9648c7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("7vU9M"))();

});
parcelRegister("7vU9M", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $03NNS = parcelRequire("03NNS");
function $5786fd365fe07671$var$emptyFunction() {}
function $5786fd365fe07671$var$emptyFunctionWithReset() {}
$5786fd365fe07671$var$emptyFunctionWithReset.resetWarningCache = $5786fd365fe07671$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $03NNS) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $5786fd365fe07671$var$emptyFunctionWithReset,
        resetWarningCache: $5786fd365fe07671$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("03NNS", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $00b6e9dcd1ec46b4$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $00b6e9dcd1ec46b4$var$ReactPropTypesSecret;

});



parcelRegister("717Zc", function(module, exports) {

$parcel$export(module.exports, "imageFiles", () => $1294548a0e615367$export$e56d88b19b5c9fbf);

var $kdMEA = parcelRequire("kdMEA");
const $1294548a0e615367$export$e56d88b19b5c9fbf = {
    noimage: `${(0, $kdMEA.CDNImagesAddress)}/no-image.png`,
    logoRetorikBlack: `${(0, $kdMEA.CDNImagesAddress)}/logo_RETORIK_black.png`,
    logoRetorikWhite: `${(0, $kdMEA.CDNImagesAddress)}/logo_RETORIK_white.png`,
    mapDeparture: `${(0, $kdMEA.CDNImagesAddress)}/Leaflet/map_departure.png`,
    mapArrival: `${(0, $kdMEA.CDNImagesAddress)}/Leaflet/map_arrival.png`,
    leaMini: `${(0, $kdMEA.CDNImagesAddress)}/lea_mini.png`
};

});

parcelRegister("2jBaP", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

parcelRegister("eyNRs", function(module, exports) {

$parcel$export(module.exports, "rotatingPhoneFromVerticalToHorizontalPosition", () => $7d5b83b0df58ea28$export$ad7b40b81d5409c);
$parcel$export(module.exports, "markerShadow", () => $7d5b83b0df58ea28$export$1524746c49eeef2b);
const $7d5b83b0df58ea28$export$ad7b40b81d5409c = 'data:image/png;base64,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';
const $7d5b83b0df58ea28$export$1524746c49eeef2b = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC';

});

parcelRegister("24F6S", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Strings = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $182bd8154b9f9aad$var$Strings = /** @class */ function() {
    function Strings() {}
    Strings.errors = {
        unknownElementType: function(typeName) {
            return "Unknown element type \"".concat(typeName, "\". Fallback will be used if present.");
        },
        unknownActionType: function(typeName) {
            return "Unknown action type \"".concat(typeName, "\". Fallback will be used if present.");
        },
        elementTypeNotAllowed: function(typeName) {
            return "Element type \"".concat(typeName, "\" is not allowed in this context.");
        },
        actionTypeNotAllowed: function(typeName) {
            return "Action type \"".concat(typeName, "\" is not allowed in this context.");
        },
        invalidPropertyValue: function(value, propertyName) {
            return "Invalid value \"".concat(value, "\" for property \"").concat(propertyName, "\".");
        },
        showCardMustHaveCard: function() {
            return "\"An Action.ShowCard must have its \"card\" property set to a valid AdaptiveCard object.";
        },
        invalidColumnWidth: function(invalidWidth) {
            return "Invalid column width \"".concat(invalidWidth, "\" - defaulting to \"auto\".");
        },
        invalidCardVersion: function(defaultingToVersion) {
            return "Invalid card version. Defaulting to \"".concat(defaultingToVersion, "\".");
        },
        invalidVersionString: function(versionString) {
            return "Invalid version string \"".concat(versionString, "\".");
        },
        propertyValueNotSupported: function(value, propertyName, supportedInVersion, versionUsed) {
            return "Value \"".concat(value, "\" for property \"").concat(propertyName, "\" is supported in version ").concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
        },
        propertyNotSupported: function(propertyName, supportedInVersion, versionUsed) {
            return "Property \"".concat(propertyName, "\" is supported in version ").concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
        },
        indexOutOfRange: function(index) {
            return "Index out of range (".concat(index, ").");
        },
        elementCannotBeUsedAsInline: function() {
            return "RichTextBlock.addInline: the specified card element cannot be used as a RichTextBlock inline.";
        },
        inlineAlreadyParented: function() {
            return "RichTextBlock.addInline: the specified inline already belongs to another RichTextBlock.";
        },
        interactivityNotAllowed: function() {
            return "Interactivity is not allowed.";
        },
        inputsMustHaveUniqueId: function() {
            return "All inputs must have a unique Id.";
        },
        choiceSetMustHaveAtLeastOneChoice: function() {
            return "An Input.ChoiceSet must have at least one choice defined.";
        },
        choiceSetChoicesMustHaveTitleAndValue: function() {
            return "All choices in an Input.ChoiceSet must have their title and value properties set.";
        },
        propertyMustBeSet: function(propertyName) {
            return "Property \"".concat(propertyName, "\" must be set.");
        },
        actionHttpHeadersMustHaveNameAndValue: function() {
            return "All headers of an Action.Http must have their name and value properties set.";
        },
        tooManyActions: function(maximumActions) {
            return "Maximum number of actions exceeded (".concat(maximumActions, ").");
        },
        tooLittleTimeDelay: function(minAutoplayDelay) {
            return "Autoplay Delay is too short (".concat(minAutoplayDelay, ").");
        },
        tooManyCarouselPages: function(maxCarouselPages) {
            return "Maximum number of Carousel pages exceeded (".concat(maxCarouselPages, ").");
        },
        invalidInitialPageIndex: function(initialPageIndex) {
            return "InitialPage for carousel is invalid (".concat(initialPageIndex, ").");
        },
        columnAlreadyBelongsToAnotherSet: function() {
            return "This column already belongs to another ColumnSet.";
        },
        invalidCardType: function() {
            return "Invalid or missing card type. Make sure the card's type property is set to \"AdaptiveCard\".";
        },
        unsupportedCardVersion: function(version, maxSupportedVersion) {
            return "The specified card version (".concat(version, ") is not supported or still in preview. The latest released card version is ").concat(maxSupportedVersion, ".");
        },
        duplicateId: function(id) {
            return "Duplicate Id \"".concat(id, "\".");
        },
        markdownProcessingNotEnabled: function() {
            return "Markdown processing isn't enabled. Please see https://www.npmjs.com/package/adaptivecards#supporting-markdown";
        },
        processMarkdownEventRemoved: function() {
            return "The processMarkdown event has been removed. Please update your code and set onProcessMarkdown instead.";
        },
        elementAlreadyParented: function() {
            return "The element already belongs to another container.";
        },
        actionAlreadyParented: function() {
            return "The action already belongs to another element.";
        },
        elementTypeNotStandalone: function(typeName) {
            return "Elements of type ".concat(typeName, " cannot be used as standalone elements.");
        },
        invalidInputLabelWidth: function() {
            return "Invalid input label width. Defaulting to label width from host config.";
        }
    };
    Strings.magicCodeInputCard = {
        tryAgain: function() {
            return "That didn't work... let's try again.";
        },
        pleaseLogin: function() {
            return 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"';
        },
        enterMagicCode: function() {
            return "Enter magic code";
        },
        pleaseEnterMagicCodeYouReceived: function() {
            return "Please enter the magic code you received.";
        },
        submit: function() {
            return "Submit";
        },
        cancel: function() {
            return "Cancel";
        },
        somethingWentWrong: function() {
            return "Something went wrong. This action can't be handled.";
        },
        authenticationFailed: function() {
            return "Authentication failed.";
        }
    };
    Strings.runtime = {
        automaticRefreshPaused: function() {
            return "Automatic refresh paused.";
        },
        clckToRestartAutomaticRefresh: function() {
            return "Click to restart.";
        },
        refreshThisCard: function() {
            return "Refresh this card";
        }
    };
    Strings.hints = {
        dontUseWeightedAndStrecthedColumnsInSameSet: function() {
            return "It is not recommended to use weighted and stretched columns in the same ColumnSet, because in such a situation stretched columns will always get the minimum amount of space.";
        }
    };
    Strings.defaults = {
        inlineActionTitle: function() {
            return "Inline Action";
        },
        overflowButtonText: function() {
            return "...";
        },
        overflowButtonTooltip: function() {
            return "More options";
        },
        emptyElementText: function(elementType) {
            return "Empty ".concat(elementType);
        },
        mediaPlayerAriaLabel: function() {
            return "Media content";
        },
        mediaPlayerPlayMedia: function() {
            return "Play media";
        },
        youTubeVideoPlayer: function() {
            return "YouTube video player";
        },
        vimeoVideoPlayer: function() {
            return "Vimeo video player";
        },
        dailymotionVideoPlayer: function() {
            return "Dailymotion video player";
        },
        carouselNavigationPreviousTooltip: function() {
            return "Previous carousel page";
        },
        carouselNavigationNextTooltip: function() {
            return "Next carousel page";
        }
    };
    return Strings;
}();
module.exports.Strings = $182bd8154b9f9aad$var$Strings;

});

parcelRegister("gIXBn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionRole = module.exports.CarouselInteractionEvent = module.exports.LogLevel = module.exports.RefreshMode = module.exports.TypeErrorType = module.exports.ContainerFitStatus = module.exports.ValidationEvent = module.exports.ValidationPhase = module.exports.InputLabelPosition = module.exports.InputTextStyle = module.exports.ActionIconPlacement = module.exports.FillMode = module.exports.Orientation = module.exports.ShowCardActionMode = module.exports.ImageStyle = module.exports.ActionAlignment = module.exports.VerticalAlignment = module.exports.HorizontalAlignment = module.exports.TextColor = module.exports.Spacing = module.exports.FontType = module.exports.TextWeight = module.exports.InputStyle = module.exports.TextSize = module.exports.SizeUnit = module.exports.ImageSetPresentationStyle = module.exports.ImageSize = module.exports.Size = module.exports.ActionMode = module.exports.ActionStyle = module.exports.ContainerStyle = void 0;
/*
    This should really be a string enum, e.g.

        export enum ContainerStyle {
            Default = "default",
            Emphasis = "emphasis"
        }

    However, some hosts do not use a version of TypeScript
    recent enough to understand string enums. This is
    a compatible construct that does not require using
    a more recent version of TypeScript.

    Also note the "weird" way these readonly fields are declared is to work around
    a breaking change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    and adopt this syntax for all other static readonly fields.
*/ /* eslint-disable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention */ var $c2cefd104394690b$var$ContainerStyle = /** @class */ function() {
    function ContainerStyle() {}
    ContainerStyle.Default = "default";
    ContainerStyle.Emphasis = "emphasis";
    ContainerStyle.Accent = "accent";
    ContainerStyle.Good = "good";
    ContainerStyle.Attention = "attention";
    ContainerStyle.Warning = "warning";
    return ContainerStyle;
}();
module.exports.ContainerStyle = $c2cefd104394690b$var$ContainerStyle;
var $c2cefd104394690b$var$ActionStyle = /** @class */ function() {
    function ActionStyle() {}
    ActionStyle.Default = "default";
    ActionStyle.Positive = "positive";
    ActionStyle.Destructive = "destructive";
    return ActionStyle;
}();
module.exports.ActionStyle = $c2cefd104394690b$var$ActionStyle;
var $c2cefd104394690b$var$ActionMode = /** @class */ function() {
    function ActionMode() {}
    ActionMode.Primary = "primary";
    ActionMode.Secondary = "secondary";
    return ActionMode;
}();
module.exports.ActionMode = $c2cefd104394690b$var$ActionMode;
/* eslint-enable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention */ var $c2cefd104394690b$var$Size;
(function(Size) {
    Size[Size["Auto"] = 0] = "Auto";
    Size[Size["Stretch"] = 1] = "Stretch";
    Size[Size["Small"] = 2] = "Small";
    Size[Size["Medium"] = 3] = "Medium";
    Size[Size["Large"] = 4] = "Large";
})($c2cefd104394690b$var$Size = module.exports.Size || (module.exports.Size = {}));
var $c2cefd104394690b$var$ImageSize;
(function(ImageSize) {
    ImageSize[ImageSize["Small"] = 0] = "Small";
    ImageSize[ImageSize["Medium"] = 1] = "Medium";
    ImageSize[ImageSize["Large"] = 2] = "Large";
})($c2cefd104394690b$var$ImageSize = module.exports.ImageSize || (module.exports.ImageSize = {}));
var $c2cefd104394690b$var$ImageSetPresentationStyle;
(function(ImageSetPresentationStyle) {
    ImageSetPresentationStyle[ImageSetPresentationStyle["Default"] = 0] = "Default";
    ImageSetPresentationStyle[ImageSetPresentationStyle["Stacked"] = 1] = "Stacked";
})($c2cefd104394690b$var$ImageSetPresentationStyle = module.exports.ImageSetPresentationStyle || (module.exports.ImageSetPresentationStyle = {}));
var $c2cefd104394690b$var$SizeUnit;
(function(SizeUnit) {
    SizeUnit[SizeUnit["Weight"] = 0] = "Weight";
    SizeUnit[SizeUnit["Pixel"] = 1] = "Pixel";
})($c2cefd104394690b$var$SizeUnit = module.exports.SizeUnit || (module.exports.SizeUnit = {}));
var $c2cefd104394690b$var$TextSize;
(function(TextSize) {
    TextSize[TextSize["Small"] = 0] = "Small";
    TextSize[TextSize["Default"] = 1] = "Default";
    TextSize[TextSize["Medium"] = 2] = "Medium";
    TextSize[TextSize["Large"] = 3] = "Large";
    TextSize[TextSize["ExtraLarge"] = 4] = "ExtraLarge";
})($c2cefd104394690b$var$TextSize = module.exports.TextSize || (module.exports.TextSize = {}));
var $c2cefd104394690b$var$InputStyle;
(function(InputStyle) {
    InputStyle[InputStyle["RevealOnHover"] = 0] = "RevealOnHover";
    InputStyle[InputStyle["Default"] = 1] = "Default";
})($c2cefd104394690b$var$InputStyle = module.exports.InputStyle || (module.exports.InputStyle = {}));
var $c2cefd104394690b$var$TextWeight;
(function(TextWeight) {
    TextWeight[TextWeight["Lighter"] = 0] = "Lighter";
    TextWeight[TextWeight["Default"] = 1] = "Default";
    TextWeight[TextWeight["Bolder"] = 2] = "Bolder";
})($c2cefd104394690b$var$TextWeight = module.exports.TextWeight || (module.exports.TextWeight = {}));
var $c2cefd104394690b$var$FontType;
(function(FontType) {
    FontType[FontType["Default"] = 0] = "Default";
    FontType[FontType["Monospace"] = 1] = "Monospace";
})($c2cefd104394690b$var$FontType = module.exports.FontType || (module.exports.FontType = {}));
var $c2cefd104394690b$var$Spacing;
(function(Spacing) {
    Spacing[Spacing["None"] = 0] = "None";
    Spacing[Spacing["Small"] = 1] = "Small";
    Spacing[Spacing["Default"] = 2] = "Default";
    Spacing[Spacing["Medium"] = 3] = "Medium";
    Spacing[Spacing["Large"] = 4] = "Large";
    Spacing[Spacing["ExtraLarge"] = 5] = "ExtraLarge";
    Spacing[Spacing["Padding"] = 6] = "Padding";
})($c2cefd104394690b$var$Spacing = module.exports.Spacing || (module.exports.Spacing = {}));
var $c2cefd104394690b$var$TextColor;
(function(TextColor) {
    TextColor[TextColor["Default"] = 0] = "Default";
    TextColor[TextColor["Dark"] = 1] = "Dark";
    TextColor[TextColor["Light"] = 2] = "Light";
    TextColor[TextColor["Accent"] = 3] = "Accent";
    TextColor[TextColor["Good"] = 4] = "Good";
    TextColor[TextColor["Warning"] = 5] = "Warning";
    TextColor[TextColor["Attention"] = 6] = "Attention";
})($c2cefd104394690b$var$TextColor = module.exports.TextColor || (module.exports.TextColor = {}));
var $c2cefd104394690b$var$HorizontalAlignment;
(function(HorizontalAlignment) {
    HorizontalAlignment[HorizontalAlignment["Left"] = 0] = "Left";
    HorizontalAlignment[HorizontalAlignment["Center"] = 1] = "Center";
    HorizontalAlignment[HorizontalAlignment["Right"] = 2] = "Right";
})($c2cefd104394690b$var$HorizontalAlignment = module.exports.HorizontalAlignment || (module.exports.HorizontalAlignment = {}));
var $c2cefd104394690b$var$VerticalAlignment;
(function(VerticalAlignment) {
    VerticalAlignment[VerticalAlignment["Top"] = 0] = "Top";
    VerticalAlignment[VerticalAlignment["Center"] = 1] = "Center";
    VerticalAlignment[VerticalAlignment["Bottom"] = 2] = "Bottom";
})($c2cefd104394690b$var$VerticalAlignment = module.exports.VerticalAlignment || (module.exports.VerticalAlignment = {}));
var $c2cefd104394690b$var$ActionAlignment;
(function(ActionAlignment) {
    ActionAlignment[ActionAlignment["Left"] = 0] = "Left";
    ActionAlignment[ActionAlignment["Center"] = 1] = "Center";
    ActionAlignment[ActionAlignment["Right"] = 2] = "Right";
    ActionAlignment[ActionAlignment["Stretch"] = 3] = "Stretch";
})($c2cefd104394690b$var$ActionAlignment = module.exports.ActionAlignment || (module.exports.ActionAlignment = {}));
var $c2cefd104394690b$var$ImageStyle;
(function(ImageStyle) {
    ImageStyle[ImageStyle["Default"] = 0] = "Default";
    ImageStyle[ImageStyle["Person"] = 1] = "Person";
})($c2cefd104394690b$var$ImageStyle = module.exports.ImageStyle || (module.exports.ImageStyle = {}));
var $c2cefd104394690b$var$ShowCardActionMode;
(function(ShowCardActionMode) {
    ShowCardActionMode[ShowCardActionMode["Inline"] = 0] = "Inline";
    ShowCardActionMode[ShowCardActionMode["Popup"] = 1] = "Popup";
})($c2cefd104394690b$var$ShowCardActionMode = module.exports.ShowCardActionMode || (module.exports.ShowCardActionMode = {}));
var $c2cefd104394690b$var$Orientation;
(function(Orientation) {
    Orientation[Orientation["Horizontal"] = 0] = "Horizontal";
    Orientation[Orientation["Vertical"] = 1] = "Vertical";
})($c2cefd104394690b$var$Orientation = module.exports.Orientation || (module.exports.Orientation = {}));
var $c2cefd104394690b$var$FillMode;
(function(FillMode) {
    FillMode[FillMode["Cover"] = 0] = "Cover";
    FillMode[FillMode["RepeatHorizontally"] = 1] = "RepeatHorizontally";
    FillMode[FillMode["RepeatVertically"] = 2] = "RepeatVertically";
    FillMode[FillMode["Repeat"] = 3] = "Repeat";
})($c2cefd104394690b$var$FillMode = module.exports.FillMode || (module.exports.FillMode = {}));
var $c2cefd104394690b$var$ActionIconPlacement;
(function(ActionIconPlacement) {
    ActionIconPlacement[ActionIconPlacement["LeftOfTitle"] = 0] = "LeftOfTitle";
    ActionIconPlacement[ActionIconPlacement["AboveTitle"] = 1] = "AboveTitle";
})($c2cefd104394690b$var$ActionIconPlacement = module.exports.ActionIconPlacement || (module.exports.ActionIconPlacement = {}));
var $c2cefd104394690b$var$InputTextStyle;
(function(InputTextStyle) {
    InputTextStyle[InputTextStyle["Text"] = 0] = "Text";
    InputTextStyle[InputTextStyle["Tel"] = 1] = "Tel";
    InputTextStyle[InputTextStyle["Url"] = 2] = "Url";
    InputTextStyle[InputTextStyle["Email"] = 3] = "Email";
    InputTextStyle[InputTextStyle["Password"] = 4] = "Password";
})($c2cefd104394690b$var$InputTextStyle = module.exports.InputTextStyle || (module.exports.InputTextStyle = {}));
var $c2cefd104394690b$var$InputLabelPosition;
(function(InputLabelPosition) {
    InputLabelPosition[InputLabelPosition["Inline"] = 0] = "Inline";
    InputLabelPosition[InputLabelPosition["Above"] = 1] = "Above";
})($c2cefd104394690b$var$InputLabelPosition = module.exports.InputLabelPosition || (module.exports.InputLabelPosition = {}));
var $c2cefd104394690b$var$ValidationPhase;
(function(ValidationPhase) {
    ValidationPhase[ValidationPhase["Parse"] = 0] = "Parse";
    ValidationPhase[ValidationPhase["ToJSON"] = 1] = "ToJSON";
    ValidationPhase[ValidationPhase["Validation"] = 2] = "Validation";
})($c2cefd104394690b$var$ValidationPhase = module.exports.ValidationPhase || (module.exports.ValidationPhase = {}));
var $c2cefd104394690b$var$ValidationEvent;
(function(ValidationEvent) {
    ValidationEvent[ValidationEvent["Hint"] = 0] = "Hint";
    ValidationEvent[ValidationEvent["ActionTypeNotAllowed"] = 1] = "ActionTypeNotAllowed";
    ValidationEvent[ValidationEvent["CollectionCantBeEmpty"] = 2] = "CollectionCantBeEmpty";
    ValidationEvent[ValidationEvent["Deprecated"] = 3] = "Deprecated";
    ValidationEvent[ValidationEvent["ElementTypeNotAllowed"] = 4] = "ElementTypeNotAllowed";
    ValidationEvent[ValidationEvent["InteractivityNotAllowed"] = 5] = "InteractivityNotAllowed";
    ValidationEvent[ValidationEvent["InvalidPropertyValue"] = 6] = "InvalidPropertyValue";
    ValidationEvent[ValidationEvent["MissingCardType"] = 7] = "MissingCardType";
    ValidationEvent[ValidationEvent["PropertyCantBeNull"] = 8] = "PropertyCantBeNull";
    ValidationEvent[ValidationEvent["TooManyActions"] = 9] = "TooManyActions";
    ValidationEvent[ValidationEvent["UnknownActionType"] = 10] = "UnknownActionType";
    ValidationEvent[ValidationEvent["UnknownElementType"] = 11] = "UnknownElementType";
    ValidationEvent[ValidationEvent["UnsupportedCardVersion"] = 12] = "UnsupportedCardVersion";
    ValidationEvent[ValidationEvent["DuplicateId"] = 13] = "DuplicateId";
    ValidationEvent[ValidationEvent["UnsupportedProperty"] = 14] = "UnsupportedProperty";
    ValidationEvent[ValidationEvent["RequiredInputsShouldHaveLabel"] = 15] = "RequiredInputsShouldHaveLabel";
    ValidationEvent[ValidationEvent["RequiredInputsShouldHaveErrorMessage"] = 16] = "RequiredInputsShouldHaveErrorMessage";
    ValidationEvent[ValidationEvent["Other"] = 17] = "Other";
})($c2cefd104394690b$var$ValidationEvent = module.exports.ValidationEvent || (module.exports.ValidationEvent = {}));
var $c2cefd104394690b$var$ContainerFitStatus;
(function(ContainerFitStatus) {
    ContainerFitStatus[ContainerFitStatus["FullyInContainer"] = 0] = "FullyInContainer";
    ContainerFitStatus[ContainerFitStatus["Overflowing"] = 1] = "Overflowing";
    ContainerFitStatus[ContainerFitStatus["FullyOutOfContainer"] = 2] = "FullyOutOfContainer";
})($c2cefd104394690b$var$ContainerFitStatus = module.exports.ContainerFitStatus || (module.exports.ContainerFitStatus = {}));
var $c2cefd104394690b$var$TypeErrorType;
(function(TypeErrorType) {
    TypeErrorType[TypeErrorType["UnknownType"] = 0] = "UnknownType";
    TypeErrorType[TypeErrorType["ForbiddenType"] = 1] = "ForbiddenType";
})($c2cefd104394690b$var$TypeErrorType = module.exports.TypeErrorType || (module.exports.TypeErrorType = {}));
var $c2cefd104394690b$var$RefreshMode;
(function(RefreshMode) {
    RefreshMode[RefreshMode["Disabled"] = 0] = "Disabled";
    RefreshMode[RefreshMode["Manual"] = 1] = "Manual";
    RefreshMode[RefreshMode["Automatic"] = 2] = "Automatic";
})($c2cefd104394690b$var$RefreshMode = module.exports.RefreshMode || (module.exports.RefreshMode = {}));
var $c2cefd104394690b$var$LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["Info"] = 0] = "Info";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Error"] = 2] = "Error";
})($c2cefd104394690b$var$LogLevel = module.exports.LogLevel || (module.exports.LogLevel = {}));
var $c2cefd104394690b$var$CarouselInteractionEvent;
(function(CarouselInteractionEvent) {
    CarouselInteractionEvent[CarouselInteractionEvent["NavigationNext"] = 0] = "NavigationNext";
    CarouselInteractionEvent[CarouselInteractionEvent["NavigationPrevious"] = 1] = "NavigationPrevious";
    CarouselInteractionEvent[CarouselInteractionEvent["Pagination"] = 2] = "Pagination";
    CarouselInteractionEvent[CarouselInteractionEvent["Autoplay"] = 3] = "Autoplay";
})($c2cefd104394690b$var$CarouselInteractionEvent = module.exports.CarouselInteractionEvent || (module.exports.CarouselInteractionEvent = {}));
var $c2cefd104394690b$var$ActionRole;
(function(ActionRole) {
    ActionRole[ActionRole["Button"] = 0] = "Button";
    ActionRole[ActionRole["Link"] = 1] = "Link";
    ActionRole[ActionRole["Tab"] = 2] = "Tab";
    ActionRole[ActionRole["Menu"] = 3] = "Menu";
    ActionRole[ActionRole["MenuItem"] = 4] = "MenuItem";
})($c2cefd104394690b$var$ActionRole = module.exports.ActionRole || (module.exports.ActionRole = {}));

});

parcelRegister("6BHj7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = module.exports.SizeAndUnit = module.exports.PaddingDefinition = module.exports.SpacingDefinition = module.exports.StringWithSubstitutions = module.exports.ContentTypes = module.exports.GlobalSettings = void 0;

var $gIXBn = parcelRequire("gIXBn");
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $4cf7cab40de2f538$var$GlobalSettings = /** @class */ function() {
    function GlobalSettings() {}
    GlobalSettings.useAdvancedTextBlockTruncation = true;
    GlobalSettings.useAdvancedCardBottomTruncation = false;
    GlobalSettings.useMarkdownInRadioButtonAndCheckbox = true;
    GlobalSettings.allowMarkForTextHighlighting = false;
    GlobalSettings.alwaysBleedSeparators = false;
    GlobalSettings.enableFullJsonRoundTrip = false;
    GlobalSettings.displayInputValidationErrors = true;
    GlobalSettings.allowPreProcessingPropertyValues = false;
    GlobalSettings.setTabIndexAtCardRoot = true;
    GlobalSettings.enableFallback = true;
    GlobalSettings.useWebkitLineClamp = true;
    GlobalSettings.allowMoreThanMaxActionsInOverflowMenu = false;
    GlobalSettings.removePaddingFromContainersWithBackgroundImage = false;
    GlobalSettings.resetInputsDirtyStateAfterActionExecution = true;
    GlobalSettings.applets = {
        logEnabled: true,
        logLevel: $gIXBn.LogLevel.Error,
        maximumRetryAttempts: 3,
        defaultTimeBetweenRetryAttempts: 3000,
        authPromptWidth: 400,
        authPromptHeight: 600,
        refresh: {
            mode: $gIXBn.RefreshMode.Manual,
            timeBetweenAutomaticRefreshes: 3000,
            maximumConsecutiveAutomaticRefreshes: 3,
            allowManualRefreshesAfterAutomaticRefreshes: true
        }
    };
    return GlobalSettings;
}();
module.exports.GlobalSettings = $4cf7cab40de2f538$var$GlobalSettings;
module.exports.ContentTypes = {
    applicationJson: "application/json",
    applicationXWwwFormUrlencoded: "application/x-www-form-urlencoded"
};
var $4cf7cab40de2f538$var$StringWithSubstitutions = /** @class */ function() {
    function StringWithSubstitutions() {
        this._isProcessed = false;
    }
    StringWithSubstitutions.prototype.getReferencedInputs = function(inputs, referencedInputs) {
        if (!referencedInputs) throw new Error("The referencedInputs parameter cannot be null.");
        if (this._original) for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
            var input = inputs_1[_i];
            var matches = new RegExp("\\{{2}(" + input.id + ").value\\}{2}", "gi").exec(this._original);
            if (matches != null && input.id) referencedInputs[input.id] = input;
        }
    };
    StringWithSubstitutions.prototype.substituteInputValues = function(inputs, contentType) {
        this._processed = this._original;
        if (this._original) {
            var regEx = /\{{2}([a-z0-9_$@]+).value\}{2}/gi;
            var matches = void 0;
            while((matches = regEx.exec(this._original)) !== null && this._processed)for(var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++){
                var key = _a[_i];
                if (key.toLowerCase() === matches[1].toLowerCase()) {
                    var matchedInput = inputs[key];
                    var valueForReplace = "";
                    if (matchedInput.value) valueForReplace = matchedInput.value;
                    if (contentType === module.exports.ContentTypes.applicationJson) {
                        valueForReplace = JSON.stringify(valueForReplace);
                        valueForReplace = valueForReplace.slice(1, -1);
                    } else if (contentType === module.exports.ContentTypes.applicationXWwwFormUrlencoded) valueForReplace = encodeURIComponent(valueForReplace);
                    this._processed = this._processed.replace(matches[0], valueForReplace);
                    break;
                }
            }
        }
        this._isProcessed = true;
    };
    StringWithSubstitutions.prototype.getOriginal = function() {
        return this._original;
    };
    StringWithSubstitutions.prototype.get = function() {
        if (!this._isProcessed) return this._original;
        else return this._processed;
    };
    StringWithSubstitutions.prototype.set = function(value) {
        this._original = value;
        this._isProcessed = false;
    };
    return StringWithSubstitutions;
}();
module.exports.StringWithSubstitutions = $4cf7cab40de2f538$var$StringWithSubstitutions;
var $4cf7cab40de2f538$var$SpacingDefinition = /** @class */ function() {
    function SpacingDefinition(top, right, bottom, left) {
        if (top === void 0) top = 0;
        if (right === void 0) right = 0;
        if (bottom === void 0) bottom = 0;
        if (left === void 0) left = 0;
        this.left = 0;
        this.top = 0;
        this.right = 0;
        this.bottom = 0;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    return SpacingDefinition;
}();
module.exports.SpacingDefinition = $4cf7cab40de2f538$var$SpacingDefinition;
var $4cf7cab40de2f538$var$PaddingDefinition = /** @class */ function() {
    function PaddingDefinition(top, right, bottom, left) {
        if (top === void 0) top = $gIXBn.Spacing.None;
        if (right === void 0) right = $gIXBn.Spacing.None;
        if (bottom === void 0) bottom = $gIXBn.Spacing.None;
        if (left === void 0) left = $gIXBn.Spacing.None;
        this.top = $gIXBn.Spacing.None;
        this.right = $gIXBn.Spacing.None;
        this.bottom = $gIXBn.Spacing.None;
        this.left = $gIXBn.Spacing.None;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    return PaddingDefinition;
}();
module.exports.PaddingDefinition = $4cf7cab40de2f538$var$PaddingDefinition;
var $4cf7cab40de2f538$var$SizeAndUnit = /** @class */ function() {
    function SizeAndUnit(physicalSize, unit) {
        this.physicalSize = physicalSize;
        this.unit = unit;
    }
    SizeAndUnit.parse = function(input, requireUnitSpecifier) {
        if (requireUnitSpecifier === void 0) requireUnitSpecifier = false;
        var result = new SizeAndUnit(0, $gIXBn.SizeUnit.Weight);
        if (typeof input === "number") {
            result.physicalSize = input;
            return result;
        } else if (typeof input === "string") {
            var regExp = /^([0-9]+)(px|\*)?$/g;
            var matches = regExp.exec(input);
            var expectedMatchCount = requireUnitSpecifier ? 3 : 2;
            if (matches && matches.length >= expectedMatchCount) {
                result.physicalSize = parseInt(matches[1]);
                if (matches.length === 3) {
                    if (matches[2] === "px") result.unit = $gIXBn.SizeUnit.Pixel;
                }
                return result;
            }
        }
        throw new Error("Invalid size: " + input);
    };
    return SizeAndUnit;
}();
module.exports.SizeAndUnit = $4cf7cab40de2f538$var$SizeAndUnit;
/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 **/ /* eslint-disable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention, no-bitwise */ var $4cf7cab40de2f538$var$UUID = /** @class */ function() {
    function UUID() {}
    UUID.generate = function() {
        var d0 = Math.random() * 0xffffffff | 0;
        var d1 = Math.random() * 0xffffffff | 0;
        var d2 = Math.random() * 0xffffffff | 0;
        var d3 = Math.random() * 0xffffffff | 0;
        return UUID.lut[d0 & 0xff] + UUID.lut[d0 >> 8 & 0xff] + UUID.lut[d0 >> 16 & 0xff] + UUID.lut[d0 >> 24 & 0xff] + "-" + UUID.lut[d1 & 0xff] + UUID.lut[d1 >> 8 & 0xff] + "-" + UUID.lut[d1 >> 16 & 0x0f | 0x40] + UUID.lut[d1 >> 24 & 0xff] + "-" + UUID.lut[d2 & 0x3f | 0x80] + UUID.lut[d2 >> 8 & 0xff] + "-" + UUID.lut[d2 >> 16 & 0xff] + UUID.lut[d2 >> 24 & 0xff] + UUID.lut[d3 & 0xff] + UUID.lut[d3 >> 8 & 0xff] + UUID.lut[d3 >> 16 & 0xff] + UUID.lut[d3 >> 24 & 0xff];
    };
    UUID.initialize = function() {
        for(var i = 0; i < 256; i++)UUID.lut[i] = (i < 16 ? "0" : "") + i.toString(16);
    };
    UUID.lut = [];
    return UUID;
}();
module.exports.UUID = $4cf7cab40de2f538$var$UUID;
$4cf7cab40de2f538$var$UUID.initialize(); /* eslint-enable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention, no-bitwise */ 

});

parcelRegister("F6YrP", function(module, exports) {
"use strict";
var $07b93d55839f4030$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.debounce = module.exports.addCancelSelectActionEventHandler = module.exports.clearElementChildren = module.exports.getScrollY = module.exports.getScrollX = module.exports.getFitStatus = module.exports.truncate = module.exports.truncateText = module.exports.stringToCssColor = module.exports.parseEnum = module.exports.getEnumValueByName = module.exports.parseBool = module.exports.parseNumber = module.exports.parseString = module.exports.appendChild = module.exports.generateUniqueId = module.exports.isMobileOS = module.exports.isInternetExplorer = void 0;

var $gIXBn = parcelRequire("gIXBn");

var $6BHj7 = parcelRequire("6BHj7");
function $07b93d55839f4030$var$isInternetExplorer() {
    // The documentMode property only exists in IE
    return window.document.documentMode !== undefined;
}
module.exports.isInternetExplorer = $07b93d55839f4030$var$isInternetExplorer;
function $07b93d55839f4030$var$isMobileOS() {
    var userAgent = window.navigator.userAgent;
    return !!userAgent.match(/Android/i) || !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i);
}
module.exports.isMobileOS = $07b93d55839f4030$var$isMobileOS;
/**
 * Generate a UUID prepended with "__ac-"
 */ function $07b93d55839f4030$var$generateUniqueId() {
    return "__ac-" + $6BHj7.UUID.generate();
}
module.exports.generateUniqueId = $07b93d55839f4030$var$generateUniqueId;
function $07b93d55839f4030$var$appendChild(node, child) {
    if (child) node.appendChild(child);
}
module.exports.appendChild = $07b93d55839f4030$var$appendChild;
function $07b93d55839f4030$var$parseString(obj, defaultValue) {
    return typeof obj === "string" ? obj : defaultValue;
}
module.exports.parseString = $07b93d55839f4030$var$parseString;
function $07b93d55839f4030$var$parseNumber(obj, defaultValue) {
    return typeof obj === "number" ? obj : defaultValue;
}
module.exports.parseNumber = $07b93d55839f4030$var$parseNumber;
function $07b93d55839f4030$var$parseBool(value, defaultValue) {
    if (typeof value === "boolean") return value;
    else if (typeof value === "string") switch(value.toLowerCase()){
        case "true":
            return true;
        case "false":
            return false;
        default:
            return defaultValue;
    }
    return defaultValue;
}
module.exports.parseBool = $07b93d55839f4030$var$parseBool;
function $07b93d55839f4030$var$getEnumValueByName(enumType, name) {
    // eslint-disable-next-line guard-for-in
    for(var key in enumType){
        var keyAsNumber = parseInt(key, 10);
        if (keyAsNumber >= 0) {
            var value = enumType[key];
            if (value && typeof value === "string" && value.toLowerCase() === name.toLowerCase()) return keyAsNumber;
        }
    }
    return undefined;
}
module.exports.getEnumValueByName = $07b93d55839f4030$var$getEnumValueByName;
function $07b93d55839f4030$var$parseEnum(enumType, name, defaultValue) {
    if (!name) return defaultValue;
    var enumValue = $07b93d55839f4030$var$getEnumValueByName(enumType, name);
    return enumValue !== undefined ? enumValue : defaultValue;
}
module.exports.parseEnum = $07b93d55839f4030$var$parseEnum;
function $07b93d55839f4030$var$stringToCssColor(color) {
    if (color) {
        var regEx = /#([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})?/gi;
        var matches = regEx.exec(color);
        if (matches && matches[4]) {
            var a = parseInt(matches[1], 16) / 255;
            var r = parseInt(matches[2], 16);
            var g = parseInt(matches[3], 16);
            var b = parseInt(matches[4], 16);
            return "rgba(" + r + "," + g + "," + b + "," + a + ")";
        }
    }
    return color;
}
module.exports.stringToCssColor = $07b93d55839f4030$var$stringToCssColor;
function $07b93d55839f4030$var$truncateWorker(element, maxHeight, fullText, truncateAt, lineHeight) {
    var fits = function() {
        // Allow a one pixel overflow to account for rounding differences
        // between browsers
        return maxHeight - element.scrollHeight >= -1;
    };
    if (fits()) return;
    var breakableIndices = $07b93d55839f4030$var$findBreakableIndices(fullText);
    var lo = 0;
    var hi = breakableIndices.length;
    var bestBreakIdx = 0;
    // Do a binary search for the longest string that fits
    while(lo < hi){
        var mid = Math.floor((lo + hi) / 2);
        truncateAt(fullText, breakableIndices[mid]);
        if (fits()) {
            bestBreakIdx = breakableIndices[mid];
            lo = mid + 1;
        } else hi = mid;
    }
    truncateAt(fullText, bestBreakIdx);
    // If we have extra room, try to expand the string letter by letter
    // (covers the case where we have to break in the middle of a long word)
    if (lineHeight && maxHeight - element.scrollHeight >= lineHeight - 1.0) {
        var idx = $07b93d55839f4030$var$findNextCharacter(fullText, bestBreakIdx);
        while(idx < fullText.length){
            truncateAt(fullText, idx);
            if (fits()) {
                bestBreakIdx = idx;
                idx = $07b93d55839f4030$var$findNextCharacter(fullText, idx);
            } else break;
        }
        truncateAt(fullText, bestBreakIdx);
    }
}
function $07b93d55839f4030$var$truncateText(element, maxHeight, lineHeight) {
    $07b93d55839f4030$var$truncateWorker(element, maxHeight, element.innerText, function(text, idx) {
        element.innerText = text.substring(0, idx) + "...";
    }, lineHeight);
}
module.exports.truncateText = $07b93d55839f4030$var$truncateText;
/**
 * {@link truncate} has been deprecated and is no longer in use internally. This policy passes
 * content through as it always has, which is _supposed_ to be dealing with text only (see {@link
 * TextBlock.truncateIfSupported}), but had a bug where it might actually pass through an element
 * for which innerHTML yielded actual HTML (since fixed).
 */ var $07b93d55839f4030$var$ttDeprecatedPolicy = typeof window === 'undefined' ? undefined : ($07b93d55839f4030$var$_a = window.trustedTypes) === null || $07b93d55839f4030$var$_a === void 0 ? void 0 : $07b93d55839f4030$var$_a.createPolicy("adaptivecards#deprecatedExportedFunctionPolicy", {
    createHTML: function(value) {
        return value;
    }
});
/** @deprecated Use {@link truncateText} instead. */ function $07b93d55839f4030$var$truncate(element, maxHeight, lineHeight) {
    $07b93d55839f4030$var$truncateWorker(element, maxHeight, element.innerHTML, function(text, idx) {
        var _a;
        var truncatedString = text.substring(0, idx) + "...";
        var truncatedHTML = (_a = $07b93d55839f4030$var$ttDeprecatedPolicy === null || $07b93d55839f4030$var$ttDeprecatedPolicy === void 0 ? void 0 : $07b93d55839f4030$var$ttDeprecatedPolicy.createHTML(truncatedString)) !== null && _a !== void 0 ? _a : truncatedString;
        element.innerHTML = truncatedHTML;
    }, lineHeight);
}
module.exports.truncate = $07b93d55839f4030$var$truncate;
function $07b93d55839f4030$var$findBreakableIndices(html) {
    var results = [];
    var idx = $07b93d55839f4030$var$findNextCharacter(html, -1);
    while(idx < html.length){
        if (html[idx] === " ") results.push(idx);
        idx = $07b93d55839f4030$var$findNextCharacter(html, idx);
    }
    return results;
}
function $07b93d55839f4030$var$findNextCharacter(html, currIdx) {
    currIdx += 1;
    // If we found the start of an HTML tag, keep advancing until we get
    // past it, so we don't end up truncating in the middle of the tag
    while(currIdx < html.length && html[currIdx] === "<"){
        while(currIdx < html.length && html[currIdx++] !== ">")continue;
    }
    return currIdx;
}
function $07b93d55839f4030$var$getFitStatus(element, containerEnd) {
    var start = element.offsetTop;
    var end = start + element.clientHeight;
    if (end <= containerEnd) return $gIXBn.ContainerFitStatus.FullyInContainer;
    else if (start < containerEnd) return $gIXBn.ContainerFitStatus.Overflowing;
    else return $gIXBn.ContainerFitStatus.FullyOutOfContainer;
}
module.exports.getFitStatus = $07b93d55839f4030$var$getFitStatus;
function $07b93d55839f4030$var$getScrollX() {
    return window.pageXOffset;
}
module.exports.getScrollX = $07b93d55839f4030$var$getScrollX;
function $07b93d55839f4030$var$getScrollY() {
    return window.pageYOffset;
}
module.exports.getScrollY = $07b93d55839f4030$var$getScrollY;
function $07b93d55839f4030$var$clearElementChildren(element) {
    while(element.firstChild)element.removeChild(element.firstChild);
}
module.exports.clearElementChildren = $07b93d55839f4030$var$clearElementChildren;
function $07b93d55839f4030$var$addCancelSelectActionEventHandler(element) {
    element.onclick = function(e) {
        e.preventDefault();
        e.cancelBubble = true;
    };
}
module.exports.addCancelSelectActionEventHandler = $07b93d55839f4030$var$addCancelSelectActionEventHandler;
function $07b93d55839f4030$var$debounce(fn, delay) {
    var timer;
    function debouncedFn() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (timer) clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(void 0, args);
        }, delay);
    }
    return debouncedFn;
}
module.exports.debounce = $07b93d55839f4030$var$debounce;

});

parcelRegister("5Ougt", function(module, exports) {
"use strict";
var $43b9193123441548$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SerializableObject = module.exports.property = module.exports.SerializableObjectSchema = module.exports.CustomProperty = module.exports.SerializableObjectCollectionProperty = module.exports.SerializableObjectProperty = module.exports.EnumProperty = module.exports.ValueSetProperty = module.exports.StringArrayProperty = module.exports.PixelSizeProperty = module.exports.NumProperty = module.exports.BoolProperty = module.exports.StringProperty = module.exports.PropertyDefinition = module.exports.BaseSerializationContext = module.exports.isVersionLessOrEqual = module.exports.Versions = module.exports.Version = void 0;

var $6BHj7 = parcelRequire("6BHj7");

var $F6YrP = parcelRequire("F6YrP");

var $gIXBn = parcelRequire("gIXBn");

var $24F6S = parcelRequire("24F6S");
var $43b9193123441548$var$Version = /** @class */ function() {
    function Version(major, minor, label) {
        if (major === void 0) major = 1;
        if (minor === void 0) minor = 1;
        this._isValid = true;
        this._major = major;
        this._minor = minor;
        this._label = label;
    }
    Version.parse = function(versionString, context) {
        if (!versionString) return undefined;
        var result = new Version();
        result._versionString = versionString;
        var regEx = /(\d+).(\d+)/gi;
        var matches = regEx.exec(versionString);
        if (matches != null && matches.length === 3) {
            result._major = parseInt(matches[1]);
            result._minor = parseInt(matches[2]);
        } else result._isValid = false;
        if (!result._isValid) context.logParseEvent(undefined, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidVersionString(result._versionString));
        return result;
    };
    Version.prototype.toString = function() {
        return !this._isValid ? this._versionString : this._major + "." + this._minor;
    };
    Version.prototype.toJSON = function() {
        return this.toString();
    };
    Version.prototype.compareTo = function(otherVersion) {
        if (!this.isValid || !otherVersion.isValid) throw new Error("Cannot compare invalid version.");
        if (this.major > otherVersion.major) return 1;
        else if (this.major < otherVersion.major) return -1;
        else if (this.minor > otherVersion.minor) return 1;
        else if (this.minor < otherVersion.minor) return -1;
        return 0;
    };
    Object.defineProperty(Version.prototype, "label", {
        get: function() {
            return this._label ? this._label : this.toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "major", {
        get: function() {
            return this._major;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "minor", {
        get: function() {
            return this._minor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "isValid", {
        get: function() {
            return this._isValid;
        },
        enumerable: false,
        configurable: true
    });
    return Version;
}();
module.exports.Version = $43b9193123441548$var$Version;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $43b9193123441548$var$Versions = /** @class */ function() {
    function Versions() {}
    // If preview tag is added/removed from any version,
    // don't forget to update .ac-schema-version-1-?::after too in adaptivecards-site\themes\adaptivecards\source\css\style.css
    /* eslint-enable @typescript-eslint/naming-convention */ Versions.getAllDeclaredVersions = function() {
        var ctor = Versions;
        var properties = [];
        for(var propertyName in ctor){
            if (propertyName.match(/^v[0-9_]*$/)) // filter latest
            try {
                var propertyValue = ctor[propertyName];
                if (propertyValue instanceof $43b9193123441548$var$Version) properties.push(propertyValue);
            } catch (_a) {
            // If a property happens to have a getter function and
            // it throws an exception, we need to catch it here
            }
        }
        return properties.sort(function(v1, v2) {
            return v1.compareTo(v2);
        });
    };
    /* eslint-disable @typescript-eslint/naming-convention */ Versions.v1_0 = new $43b9193123441548$var$Version(1, 0);
    Versions.v1_1 = new $43b9193123441548$var$Version(1, 1);
    Versions.v1_2 = new $43b9193123441548$var$Version(1, 2);
    Versions.v1_3 = new $43b9193123441548$var$Version(1, 3);
    Versions.v1_4 = new $43b9193123441548$var$Version(1, 4);
    Versions.v1_5 = new $43b9193123441548$var$Version(1, 5);
    Versions.v1_6 = new $43b9193123441548$var$Version(1, 6);
    Versions.latest = Versions.v1_6;
    return Versions;
}();
module.exports.Versions = $43b9193123441548$var$Versions;
function $43b9193123441548$var$isVersionLessOrEqual(version, targetVersion) {
    if (version instanceof $43b9193123441548$var$Version) {
        if (targetVersion instanceof $43b9193123441548$var$Version) return targetVersion.compareTo(version) >= 0;
        else // Target version is *
        return true;
    } else // Version is *
    return true;
}
module.exports.isVersionLessOrEqual = $43b9193123441548$var$isVersionLessOrEqual;
var $43b9193123441548$var$BaseSerializationContext = /** @class */ function() {
    function BaseSerializationContext(targetVersion) {
        if (targetVersion === void 0) targetVersion = $43b9193123441548$var$Versions.latest;
        this._validationEvents = [];
        this.targetVersion = targetVersion;
    }
    BaseSerializationContext.prototype.isTemplateString = function(value) {
        if (typeof value === "string") return value.startsWith("${");
        else return false;
    };
    BaseSerializationContext.prototype.tryDeleteValue = function(target, propertyName) {
        if (!$6BHj7.GlobalSettings.enableFullJsonRoundTrip) delete target[propertyName];
    };
    BaseSerializationContext.prototype.tryDeleteDefaultValue = function(target, propertyName) {
        if (!$6BHj7.GlobalSettings.enableFullJsonRoundTrip || !this.isTemplateString(target[propertyName])) delete target[propertyName];
    };
    BaseSerializationContext.prototype.serializeValue = function(target, propertyName, propertyValue, defaultValue, forceDeleteIfNullOrDefault) {
        if (defaultValue === void 0) defaultValue = undefined;
        if (forceDeleteIfNullOrDefault === void 0) forceDeleteIfNullOrDefault = false;
        if (propertyValue === null || propertyValue === undefined) {
            if (!$6BHj7.GlobalSettings.enableFullJsonRoundTrip || forceDeleteIfNullOrDefault) delete target[propertyName];
        } else if (propertyValue === defaultValue) {
            if (!$6BHj7.GlobalSettings.enableFullJsonRoundTrip || forceDeleteIfNullOrDefault || !this.isTemplateString(target[propertyName])) delete target[propertyName];
        } else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeString = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeBool = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeNumber = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined || isNaN(propertyValue)) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeEnum = function(enumType, target, propertyName, propertyValue, defaultValue) {
        if (defaultValue === void 0) defaultValue = undefined;
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = enumType[propertyValue];
    };
    BaseSerializationContext.prototype.serializeArray = function(target, propertyName, propertyValue) {
        var items = [];
        if (propertyValue) for(var _i = 0, propertyValue_1 = propertyValue; _i < propertyValue_1.length; _i++){
            var item = propertyValue_1[_i];
            var serializedItem = undefined;
            if (item instanceof $43b9193123441548$var$SerializableObject) serializedItem = item.toJSON(this);
            else if (item.toJSON) serializedItem = item.toJSON();
            else serializedItem = item;
            if (serializedItem !== undefined) items.push(serializedItem);
        }
        if (items.length === 0) {
            if (target.hasOwnProperty(propertyName) && Array.isArray(target[propertyName])) delete target[propertyName];
        } else this.serializeValue(target, propertyName, items);
    };
    BaseSerializationContext.prototype.clearEvents = function() {
        this._validationEvents = [];
    };
    BaseSerializationContext.prototype.logEvent = function(source, phase, event, message) {
        this._validationEvents.push({
            source: source,
            phase: phase,
            event: event,
            message: message
        });
    };
    BaseSerializationContext.prototype.logParseEvent = function(source, event, message) {
        this.logEvent(source, $gIXBn.ValidationPhase.Parse, event, message);
    };
    BaseSerializationContext.prototype.getEventAt = function(index) {
        return this._validationEvents[index];
    };
    Object.defineProperty(BaseSerializationContext.prototype, "eventCount", {
        get: function() {
            return this._validationEvents.length;
        },
        enumerable: false,
        configurable: true
    });
    return BaseSerializationContext;
}();
module.exports.BaseSerializationContext = $43b9193123441548$var$BaseSerializationContext;
var $43b9193123441548$var$SimpleSerializationContext = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(SimpleSerializationContext, _super);
    function SimpleSerializationContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SimpleSerializationContext;
}($43b9193123441548$var$BaseSerializationContext);
var $43b9193123441548$var$PropertyDefinition = /** @class */ function() {
    function PropertyDefinition(targetVersion, name, defaultValue, onGetInitialValue) {
        this.targetVersion = targetVersion;
        this.name = name;
        this.defaultValue = defaultValue;
        this.onGetInitialValue = onGetInitialValue;
        this.isSerializationEnabled = true;
        this.sequentialNumber = PropertyDefinition._sequentialNumber;
        PropertyDefinition._sequentialNumber++;
    }
    PropertyDefinition.prototype.getInternalName = function() {
        return this.name;
    };
    PropertyDefinition.prototype.parse = function(sender, source, context) {
        return source[this.name];
    };
    PropertyDefinition.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value, this.defaultValue);
    };
    PropertyDefinition._sequentialNumber = 0;
    return PropertyDefinition;
}();
module.exports.PropertyDefinition = $43b9193123441548$var$PropertyDefinition;
var $43b9193123441548$var$StringProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(StringProperty, _super);
    function StringProperty(targetVersion, name, treatEmptyAsUndefined, regEx, defaultValue, onGetInitialValue) {
        if (treatEmptyAsUndefined === void 0) treatEmptyAsUndefined = true;
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.treatEmptyAsUndefined = treatEmptyAsUndefined;
        _this.regEx = regEx;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    StringProperty.prototype.parse = function(sender, source, context) {
        var parsedValue = $F6YrP.parseString(source[this.name], this.defaultValue);
        var isUndefined = parsedValue === undefined || parsedValue === "" && this.treatEmptyAsUndefined;
        if (!isUndefined && this.regEx !== undefined) {
            var matches = this.regEx.exec(parsedValue);
            if (!matches) {
                context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(parsedValue, this.name));
                return undefined;
            }
        }
        return parsedValue;
    };
    StringProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeString(target, this.name, value === "" && this.treatEmptyAsUndefined ? undefined : value, this.defaultValue);
    };
    return StringProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.StringProperty = $43b9193123441548$var$StringProperty;
var $43b9193123441548$var$BoolProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(BoolProperty, _super);
    function BoolProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    BoolProperty.prototype.parse = function(sender, source, context) {
        return $F6YrP.parseBool(source[this.name], this.defaultValue);
    };
    BoolProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeBool(target, this.name, value, this.defaultValue);
    };
    return BoolProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.BoolProperty = $43b9193123441548$var$BoolProperty;
var $43b9193123441548$var$NumProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(NumProperty, _super);
    function NumProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    NumProperty.prototype.parse = function(sender, source, context) {
        return $F6YrP.parseNumber(source[this.name], this.defaultValue);
    };
    NumProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeNumber(target, this.name, value, this.defaultValue);
    };
    return NumProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.NumProperty = $43b9193123441548$var$NumProperty;
var $43b9193123441548$var$PixelSizeProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(PixelSizeProperty, _super);
    function PixelSizeProperty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PixelSizeProperty.prototype.parse = function(sender, source, context) {
        var result = undefined;
        var value = source[this.name];
        if (typeof value === "string") {
            var isValid = false;
            try {
                var size = $6BHj7.SizeAndUnit.parse(value, true);
                if (size.unit === $gIXBn.SizeUnit.Pixel) {
                    result = size.physicalSize;
                    isValid = true;
                }
            } catch (_a) {
            // Do nothing. A parse error is emitted below
            }
            if (!isValid) context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(source[this.name], this.name));
        }
        return result;
    };
    PixelSizeProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, typeof value === "number" && !isNaN(value) ? value + "px" : undefined);
    };
    return PixelSizeProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.PixelSizeProperty = $43b9193123441548$var$PixelSizeProperty;
var $43b9193123441548$var$StringArrayProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(StringArrayProperty, _super);
    function StringArrayProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    StringArrayProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined || !Array.isArray(sourceValue)) return this.defaultValue;
        var result = [];
        for(var _i = 0, sourceValue_1 = sourceValue; _i < sourceValue_1.length; _i++){
            var value = sourceValue_1[_i];
            if (typeof value === "string") result.push(value);
            else context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, "Invalid array value \"".concat(JSON.stringify(value), "\" of type \"").concat(typeof value, "\" ignored for \"").concat(this.name, "\"."));
        }
        return result;
    };
    StringArrayProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeArray(target, this.name, value);
    };
    return StringArrayProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.StringArrayProperty = $43b9193123441548$var$StringArrayProperty;
var $43b9193123441548$var$ValueSetProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(ValueSetProperty, _super);
    function ValueSetProperty(targetVersion, name, values, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.values = values;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    ValueSetProperty.prototype.isValidValue = function(value, context) {
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (value.toLowerCase() === versionedValue.value.toLowerCase()) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                return targetVersion.compareTo(context.targetVersion) <= 0;
            }
        }
        return false;
    };
    ValueSetProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.defaultValue;
        if (typeof sourceValue === "string") for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (sourceValue.toLowerCase() === versionedValue.value.toLowerCase()) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                if (targetVersion.compareTo(context.targetVersion) <= 0) return versionedValue.value;
                else {
                    context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.propertyValueNotSupported(sourceValue, this.name, targetVersion.toString(), context.targetVersion.toString()));
                    return this.defaultValue;
                }
            }
        }
        context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return this.defaultValue;
    };
    ValueSetProperty.prototype.toJSON = function(sender, target, value, context) {
        var invalidValue = false;
        if (value !== undefined) {
            invalidValue = true;
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var versionedValue = _a[_i];
                if (versionedValue.value === value) {
                    var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                    if (targetVersion.compareTo(context.targetVersion) <= 0) {
                        invalidValue = false;
                        break;
                    } else context.logEvent(sender, $gIXBn.ValidationPhase.ToJSON, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.propertyValueNotSupported(value, this.name, targetVersion.toString(), context.targetVersion.toString()));
                }
            }
        }
        if (!invalidValue) context.serializeValue(target, this.name, value, this.defaultValue, true);
    };
    return ValueSetProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.ValueSetProperty = $43b9193123441548$var$ValueSetProperty;
var $43b9193123441548$var$EnumProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(EnumProperty, _super);
    function EnumProperty(targetVersion, name, enumType, defaultValue, values, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.enumType = enumType;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        _this._values = [];
        if (!values) // eslint-disable-next-line guard-for-in
        for(var key in enumType){
            var keyAsNumber = parseInt(key, 10);
            if (keyAsNumber >= 0) _this._values.push({
                value: keyAsNumber
            });
        }
        else _this._values = values;
        return _this;
    }
    EnumProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (typeof sourceValue !== "string") return this.defaultValue;
        var enumValue = $F6YrP.getEnumValueByName(this.enumType, sourceValue);
        if (enumValue !== undefined) for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (versionedValue.value === enumValue) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                if (targetVersion.compareTo(context.targetVersion) <= 0) return enumValue;
                else {
                    context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.propertyValueNotSupported(sourceValue, this.name, targetVersion.toString(), context.targetVersion.toString()));
                    return this.defaultValue;
                }
            }
        }
        context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return this.defaultValue;
    };
    EnumProperty.prototype.toJSON = function(sender, target, value, context) {
        var invalidValue = false;
        if (value !== undefined) {
            invalidValue = true;
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var versionedValue = _a[_i];
                if (versionedValue.value === value) {
                    var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                    if (targetVersion.compareTo(context.targetVersion) <= 0) {
                        invalidValue = false;
                        break;
                    } else context.logEvent(sender, $gIXBn.ValidationPhase.ToJSON, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(value, this.name));
                }
            }
        }
        if (!invalidValue) context.serializeEnum(this.enumType, target, this.name, value, this.defaultValue);
    };
    Object.defineProperty(EnumProperty.prototype, "values", {
        get: function() {
            return this._values;
        },
        enumerable: false,
        configurable: true
    });
    return EnumProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.EnumProperty = $43b9193123441548$var$EnumProperty;
var $43b9193123441548$var$SerializableObjectProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(SerializableObjectProperty, _super);
    function SerializableObjectProperty(targetVersion, name, objectType, nullable, defaultValue) {
        if (nullable === void 0) nullable = false;
        var _this = _super.call(this, targetVersion, name, defaultValue, function(sender) {
            return _this.nullable ? undefined : new _this.objectType();
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.objectType = objectType;
        _this.nullable = nullable;
        return _this;
    }
    SerializableObjectProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.onGetInitialValue ? this.onGetInitialValue(sender) : this.defaultValue;
        var result = new this.objectType();
        result.parse(sourceValue, context);
        return result;
    };
    SerializableObjectProperty.prototype.toJSON = function(sender, target, value, context) {
        var serializedValue = undefined;
        if (value !== undefined && !value.hasAllDefaultValues()) serializedValue = value.toJSON(context);
        if (typeof serializedValue === "object" && Object.keys(serializedValue).length === 0) serializedValue = undefined;
        context.serializeValue(target, this.name, serializedValue, this.defaultValue, true);
    };
    return SerializableObjectProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.SerializableObjectProperty = $43b9193123441548$var$SerializableObjectProperty;
var $43b9193123441548$var$SerializableObjectCollectionProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(SerializableObjectCollectionProperty, _super);
    function SerializableObjectCollectionProperty(targetVersion, name, objectType, onItemAdded) {
        var _this = _super.call(this, targetVersion, name, undefined, function(sender) {
            return [];
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.objectType = objectType;
        _this.onItemAdded = onItemAdded;
        return _this;
    }
    SerializableObjectCollectionProperty.prototype.parse = function(sender, source, context) {
        var result = [];
        var sourceCollection = source[this.name];
        if (Array.isArray(sourceCollection)) for(var _i = 0, sourceCollection_1 = sourceCollection; _i < sourceCollection_1.length; _i++){
            var sourceItem = sourceCollection_1[_i];
            var item = new this.objectType();
            item.parse(sourceItem, context);
            result.push(item);
            if (this.onItemAdded) this.onItemAdded(sender, item);
        }
        return result.length > 0 ? result : this.onGetInitialValue ? this.onGetInitialValue(sender) : undefined;
    };
    SerializableObjectCollectionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeArray(target, this.name, value);
    };
    return SerializableObjectCollectionProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.SerializableObjectCollectionProperty = $43b9193123441548$var$SerializableObjectCollectionProperty;
var $43b9193123441548$var$CustomProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(CustomProperty, _super);
    function CustomProperty(targetVersion, name, onParse, onToJSON, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.onParse = onParse;
        _this.onToJSON = onToJSON;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        if (!_this.onParse) throw new Error("CustomPropertyDefinition instances must have an onParse handler.");
        if (!_this.onToJSON) throw new Error("CustomPropertyDefinition instances must have an onToJSON handler.");
        return _this;
    }
    CustomProperty.prototype.parse = function(sender, source, context) {
        return this.onParse(sender, this, source, context);
    };
    CustomProperty.prototype.toJSON = function(sender, target, value, context) {
        this.onToJSON(sender, this, target, value, context);
    };
    return CustomProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.CustomProperty = $43b9193123441548$var$CustomProperty;
var $43b9193123441548$var$SerializableObjectSchema = /** @class */ function() {
    function SerializableObjectSchema() {
        this._properties = [];
    }
    SerializableObjectSchema.prototype.indexOf = function(prop) {
        for(var i = 0; i < this._properties.length; i++){
            if (this._properties[i] === prop) return i;
        }
        return -1;
    };
    SerializableObjectSchema.prototype.add = function() {
        var properties = [];
        for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
        for(var _a = 0, properties_1 = properties; _a < properties_1.length; _a++){
            var prop = properties_1[_a];
            if (this.indexOf(prop) === -1) this._properties.push(prop);
        }
    };
    SerializableObjectSchema.prototype.remove = function() {
        var properties = [];
        for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
        for(var _a = 0, properties_2 = properties; _a < properties_2.length; _a++){
            var prop = properties_2[_a];
            while(true){
                var index = this.indexOf(prop);
                if (index >= 0) this._properties.splice(index, 1);
                else break;
            }
        }
    };
    SerializableObjectSchema.prototype.getItemAt = function(index) {
        return this._properties[index];
    };
    SerializableObjectSchema.prototype.getCount = function() {
        return this._properties.length;
    };
    return SerializableObjectSchema;
}();
module.exports.SerializableObjectSchema = $43b9193123441548$var$SerializableObjectSchema;
// This is a decorator function, used to map SerializableObject descendant class members to
// schema properties
function $43b9193123441548$var$property(prop) {
    return function(target, propertyKey) {
        var descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) || {};
        if (!descriptor.get && !descriptor.set) {
            descriptor.get = function() {
                return this.getValue(prop);
            };
            descriptor.set = function(value) {
                this.setValue(prop, value);
            };
            Object.defineProperty(target, propertyKey, descriptor);
        }
    };
}
module.exports.property = $43b9193123441548$var$property;
var $43b9193123441548$var$SerializableObject = /** @class */ function() {
    function SerializableObject() {
        this._propertyBag = {};
        this._rawProperties = {};
        this.maxVersion = SerializableObject.defaultMaxVersion;
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            if (prop.onGetInitialValue) this.setValue(prop, prop.onGetInitialValue(this));
        }
    }
    SerializableObject.prototype.getDefaultSerializationContext = function() {
        return new $43b9193123441548$var$SimpleSerializationContext();
    };
    SerializableObject.prototype.populateSchema = function(schema) {
        var ctor = this.constructor;
        var properties = [];
        // eslint-disable-next-line guard-for-in
        for(var propertyName in ctor)try {
            var propertyValue = ctor[propertyName];
            if (propertyValue instanceof $43b9193123441548$var$PropertyDefinition) properties.push(propertyValue);
        } catch (_a) {
        // If a property happens to have a getter function and
        // it throws an exception, we need to catch it here
        }
        if (properties.length > 0) {
            var sortedProperties = properties.sort(function(p1, p2) {
                if (p1.sequentialNumber > p2.sequentialNumber) return 1;
                else if (p1.sequentialNumber < p2.sequentialNumber) return -1;
                return 0;
            });
            schema.add.apply(schema, sortedProperties);
        }
        if (SerializableObject.onRegisterCustomProperties) SerializableObject.onRegisterCustomProperties(this, schema);
    };
    SerializableObject.prototype.getValue = function(prop) {
        return this._propertyBag.hasOwnProperty(prop.getInternalName()) ? this._propertyBag[prop.getInternalName()] : prop.defaultValue;
    };
    SerializableObject.prototype.setValue = function(prop, value) {
        if (value === undefined || value === null) delete this._propertyBag[prop.getInternalName()];
        else this._propertyBag[prop.getInternalName()] = value;
    };
    SerializableObject.prototype.internalParse = function(source, context) {
        this._propertyBag = {};
        this._rawProperties = $6BHj7.GlobalSettings.enableFullJsonRoundTrip ? source ? source : {} : {};
        if (source) {
            var s = this.getSchema();
            for(var i = 0; i < s.getCount(); i++){
                var prop = s.getItemAt(i);
                if (prop.isSerializationEnabled) {
                    var propertyValue = prop.onGetInitialValue ? prop.onGetInitialValue(this) : undefined;
                    if (source.hasOwnProperty(prop.name)) {
                        if (prop.targetVersion.compareTo(context.targetVersion) <= 0) propertyValue = prop.parse(this, source, context);
                        else context.logParseEvent(this, $gIXBn.ValidationEvent.UnsupportedProperty, $24F6S.Strings.errors.propertyNotSupported(prop.name, prop.targetVersion.toString(), context.targetVersion.toString()));
                    }
                    this.setValue(prop, propertyValue);
                }
            }
        } else this.resetDefaultValues();
    };
    SerializableObject.prototype.internalToJSON = function(target, context) {
        var s = this.getSchema();
        var serializedProperties = [];
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            // Avoid serializing the same property multiple times. This is necessary
            // because some property definitions map to the same underlying schema
            // property
            if (prop.isSerializationEnabled && prop.targetVersion.compareTo(context.targetVersion) <= 0 && serializedProperties.indexOf(prop.name) === -1) {
                prop.toJSON(this, target, this.getValue(prop), context);
                serializedProperties.push(prop.name);
            }
        }
    };
    SerializableObject.prototype.shouldSerialize = function(_context) {
        return true;
    };
    SerializableObject.prototype.parse = function(source, context) {
        this.internalParse(source, context ? context : new $43b9193123441548$var$SimpleSerializationContext());
    };
    SerializableObject.prototype.toJSON = function(context) {
        var effectiveContext;
        if (context && context instanceof $43b9193123441548$var$BaseSerializationContext) effectiveContext = context;
        else {
            effectiveContext = this.getDefaultSerializationContext();
            effectiveContext.toJSONOriginalParam = context;
        }
        if (this.shouldSerialize(effectiveContext)) {
            var result = void 0;
            if ($6BHj7.GlobalSettings.enableFullJsonRoundTrip && this._rawProperties && typeof this._rawProperties === "object") result = this._rawProperties;
            else result = {};
            this.internalToJSON(result, effectiveContext);
            return result;
        } else return undefined;
    };
    SerializableObject.prototype.hasDefaultValue = function(prop) {
        return this.getValue(prop) === prop.defaultValue;
    };
    SerializableObject.prototype.hasAllDefaultValues = function() {
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            if (!this.hasDefaultValue(prop)) return false;
        }
        return true;
    };
    SerializableObject.prototype.resetDefaultValues = function() {
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            this.setValue(prop, prop.defaultValue);
        }
    };
    SerializableObject.prototype.setCustomProperty = function(name, value) {
        var shouldDeleteProperty = typeof value === "string" && !value || value === undefined || value === null;
        if (shouldDeleteProperty) delete this._rawProperties[name];
        else this._rawProperties[name] = value;
    };
    SerializableObject.prototype.getCustomProperty = function(name) {
        return this._rawProperties[name];
    };
    SerializableObject.prototype.getSchema = function() {
        var schema = SerializableObject._schemaCache[this.getSchemaKey()];
        if (!schema) {
            schema = new $43b9193123441548$var$SerializableObjectSchema();
            this.populateSchema(schema);
            SerializableObject._schemaCache[this.getSchemaKey()] = schema;
        }
        return schema;
    };
    SerializableObject.defaultMaxVersion = $43b9193123441548$var$Versions.latest;
    SerializableObject._schemaCache = {};
    return SerializableObject;
}();
module.exports.SerializableObject = $43b9193123441548$var$SerializableObject;

});

parcelRegister("7Lc5Q", function(module, exports) {
"use strict";
var $5a664dafacbee1f9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HostCapabilities = void 0;

var $5Ougt = parcelRequire("5Ougt");
var $5a664dafacbee1f9$var$HostCapabilities = /** @class */ function(_super) {
    $5a664dafacbee1f9$var$__extends(HostCapabilities, _super);
    function HostCapabilities() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._capabilities = {};
        return _this;
    }
    HostCapabilities.prototype.getSchemaKey = function() {
        return "HostCapabilities";
    };
    HostCapabilities.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        if (source) // eslint-disable-next-line guard-for-in
        for(var name_1 in source){
            var jsonVersion = source[name_1];
            if (typeof jsonVersion === "string") {
                if (jsonVersion === "*") this.addCapability(name_1, "*");
                else {
                    var version = $5Ougt.Version.parse(jsonVersion, context);
                    if (version === null || version === void 0 ? void 0 : version.isValid) this.addCapability(name_1, version);
                }
            }
        }
    };
    HostCapabilities.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        // eslint-disable-next-line guard-for-in
        for(var key in this._capabilities)target[key] = this._capabilities[key];
    };
    HostCapabilities.prototype.addCapability = function(name, version) {
        this._capabilities[name] = version;
    };
    HostCapabilities.prototype.removeCapability = function(name) {
        delete this._capabilities[name];
    };
    HostCapabilities.prototype.clear = function() {
        this._capabilities = {};
    };
    HostCapabilities.prototype.hasCapability = function(name, version) {
        if (this._capabilities.hasOwnProperty(name)) {
            if (version === "*" || this._capabilities[name] === "*") return true;
            return version.compareTo(this._capabilities[name]) <= 0;
        }
        return false;
    };
    HostCapabilities.prototype.areAllMet = function(hostCapabilities) {
        for(var capabilityName in this._capabilities){
            if (!hostCapabilities.hasCapability(capabilityName, this._capabilities[capabilityName])) return false;
        }
        return true;
    };
    return HostCapabilities;
}($5Ougt.SerializableObject);
module.exports.HostCapabilities = $5a664dafacbee1f9$var$HostCapabilities;

});

parcelRegister("8kDQQ", function(module, exports) {
"use strict";
var $610f1a9c13915db5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultHostConfig = module.exports.HostConfig = module.exports.CarouselConfig = module.exports.FontTypeSet = module.exports.FontTypeDefinition = module.exports.ContainerStyleSet = module.exports.ContainerStyleDefinition = module.exports.ColorSetDefinition = module.exports.ActionsConfig = module.exports.ShowCardActionConfig = module.exports.FactSetConfig = module.exports.FactTitleDefinition = module.exports.FactTextDefinition = module.exports.InputConfig = module.exports.InputLabelConfig = module.exports.RequiredInputLabelTextDefinition = module.exports.TextBlockConfig = module.exports.TextStyleSet = module.exports.TextStyleDefinition = module.exports.BaseTextDefinition = module.exports.TableConfig = module.exports.MediaConfig = module.exports.ImageSetConfig = module.exports.AdaptiveCardConfig = module.exports.TextColorDefinition = module.exports.ColorDefinition = void 0;

var $gIXBn = parcelRequire("gIXBn");

var $F6YrP = parcelRequire("F6YrP");

var $6BHj7 = parcelRequire("6BHj7");

var $7Lc5Q = parcelRequire("7Lc5Q");
function $610f1a9c13915db5$var$parseHostConfigEnum(targetEnum, value, defaultValue) {
    if (typeof value === "string") {
        var parsedValue = $F6YrP.parseEnum(targetEnum, value, defaultValue);
        return parsedValue !== undefined ? parsedValue : defaultValue;
    } else if (typeof value === "number") return value;
    else return defaultValue;
}
var $610f1a9c13915db5$var$ColorDefinition = /** @class */ function() {
    function ColorDefinition(defaultColor, subtleColor) {
        this.default = "#000000";
        this.subtle = "#666666";
        if (defaultColor) this.default = defaultColor;
        if (subtleColor) this.subtle = subtleColor;
    }
    ColorDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.default = obj["default"] || this.default;
            this.subtle = obj["subtle"] || this.subtle;
        }
    };
    return ColorDefinition;
}();
module.exports.ColorDefinition = $610f1a9c13915db5$var$ColorDefinition;
var $610f1a9c13915db5$var$TextColorDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(TextColorDefinition, _super);
    function TextColorDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.highlightColors = new $610f1a9c13915db5$var$ColorDefinition("#22000000", "#11000000");
        return _this;
    }
    TextColorDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.highlightColors.parse(obj["highlightColors"]);
    };
    return TextColorDefinition;
}($610f1a9c13915db5$var$ColorDefinition);
module.exports.TextColorDefinition = $610f1a9c13915db5$var$TextColorDefinition;
var $610f1a9c13915db5$var$AdaptiveCardConfig = /** @class */ function() {
    function AdaptiveCardConfig(obj) {
        this.allowCustomStyle = false;
        if (obj) this.allowCustomStyle = obj["allowCustomStyle"] || this.allowCustomStyle;
    }
    return AdaptiveCardConfig;
}();
module.exports.AdaptiveCardConfig = $610f1a9c13915db5$var$AdaptiveCardConfig;
var $610f1a9c13915db5$var$ImageSetConfig = /** @class */ function() {
    function ImageSetConfig(obj) {
        this.imageSize = $gIXBn.Size.Medium;
        this.maxImageHeight = 100;
        if (obj) {
            this.imageSize = obj["imageSize"] != null ? obj["imageSize"] : this.imageSize;
            this.maxImageHeight = $F6YrP.parseNumber(obj["maxImageHeight"], 100);
        }
    }
    ImageSetConfig.prototype.toJSON = function() {
        return {
            imageSize: $gIXBn.Size[this.imageSize],
            maxImageHeight: this.maxImageHeight
        };
    };
    return ImageSetConfig;
}();
module.exports.ImageSetConfig = $610f1a9c13915db5$var$ImageSetConfig;
var $610f1a9c13915db5$var$MediaConfig = /** @class */ function() {
    function MediaConfig(obj) {
        this.allowInlinePlayback = true;
        if (obj) {
            this.defaultPoster = obj["defaultPoster"];
            this.allowInlinePlayback = obj["allowInlinePlayback"] || this.allowInlinePlayback;
        }
    }
    MediaConfig.prototype.toJSON = function() {
        return {
            defaultPoster: this.defaultPoster,
            allowInlinePlayback: this.allowInlinePlayback
        };
    };
    return MediaConfig;
}();
module.exports.MediaConfig = $610f1a9c13915db5$var$MediaConfig;
var $610f1a9c13915db5$var$TableConfig = /** @class */ function() {
    function TableConfig(obj) {
        this.cellSpacing = 8;
        if (obj) this.cellSpacing = obj.cellSpacing && typeof obj.cellSpacing === "number" ? obj.cellSpacing : this.cellSpacing;
    }
    TableConfig.prototype.toJSON = function() {
        return {
            cellSpacing: this.cellSpacing
        };
    };
    return TableConfig;
}();
module.exports.TableConfig = $610f1a9c13915db5$var$TableConfig;
var $610f1a9c13915db5$var$BaseTextDefinition = /** @class */ function() {
    function BaseTextDefinition(obj) {
        this.size = $gIXBn.TextSize.Default;
        this.color = $gIXBn.TextColor.Default;
        this.isSubtle = false;
        this.weight = $gIXBn.TextWeight.Default;
        this.parse(obj);
    }
    BaseTextDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.size = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.TextSize, obj["size"], this.size);
            this.color = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.TextColor, obj["color"], this.color);
            this.isSubtle = obj.isSubtle !== undefined && typeof obj.isSubtle === "boolean" ? obj.isSubtle : this.isSubtle;
            this.weight = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.TextWeight, obj["weight"], this.getDefaultWeight());
        }
    };
    BaseTextDefinition.prototype.getDefaultWeight = function() {
        return $gIXBn.TextWeight.Default;
    };
    BaseTextDefinition.prototype.toJSON = function() {
        return {
            size: $gIXBn.TextSize[this.size],
            color: $gIXBn.TextColor[this.color],
            isSubtle: this.isSubtle,
            weight: $gIXBn.TextWeight[this.weight]
        };
    };
    return BaseTextDefinition;
}();
module.exports.BaseTextDefinition = $610f1a9c13915db5$var$BaseTextDefinition;
var $610f1a9c13915db5$var$TextStyleDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(TextStyleDefinition, _super);
    function TextStyleDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fontType = $gIXBn.FontType.Default;
        return _this;
    }
    TextStyleDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.fontType = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.FontType, obj.fontType, this.fontType);
    };
    return TextStyleDefinition;
}($610f1a9c13915db5$var$BaseTextDefinition);
module.exports.TextStyleDefinition = $610f1a9c13915db5$var$TextStyleDefinition;
var $610f1a9c13915db5$var$TextStyleSet = /** @class */ function() {
    function TextStyleSet(obj) {
        this.default = new $610f1a9c13915db5$var$TextStyleDefinition();
        this.heading = new $610f1a9c13915db5$var$TextStyleDefinition({
            size: "Large",
            weight: "Bolder"
        });
        this.columnHeader = new $610f1a9c13915db5$var$TextStyleDefinition({
            weight: "Bolder"
        });
        if (obj) {
            this.heading.parse(obj.heading);
            this.columnHeader.parse(obj.columnHeader);
        }
    }
    TextStyleSet.prototype.getStyleByName = function(name) {
        switch(name.toLowerCase()){
            case "heading":
                return this.heading;
            case "columnHeader":
                return this.columnHeader;
            default:
                return this.default;
        }
    };
    return TextStyleSet;
}();
module.exports.TextStyleSet = $610f1a9c13915db5$var$TextStyleSet;
var $610f1a9c13915db5$var$TextBlockConfig = /** @class */ function() {
    function TextBlockConfig(obj) {
        if (obj) this.headingLevel = $F6YrP.parseNumber(obj.headingLevel);
    }
    return TextBlockConfig;
}();
module.exports.TextBlockConfig = $610f1a9c13915db5$var$TextBlockConfig;
var $610f1a9c13915db5$var$RequiredInputLabelTextDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(RequiredInputLabelTextDefinition, _super);
    function RequiredInputLabelTextDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suffix = " *";
        _this.suffixColor = $gIXBn.TextColor.Attention;
        return _this;
    }
    RequiredInputLabelTextDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) {
            this.suffix = obj["suffix"] || this.suffix;
            this.suffixColor = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.TextColor, obj["suffixColor"], this.suffixColor);
        }
    };
    RequiredInputLabelTextDefinition.prototype.toJSON = function() {
        var result = _super.prototype.toJSON.call(this);
        result["suffix"] = this.suffix;
        result["suffixColor"] = $gIXBn.TextColor[this.suffixColor];
        return result;
    };
    return RequiredInputLabelTextDefinition;
}($610f1a9c13915db5$var$BaseTextDefinition);
module.exports.RequiredInputLabelTextDefinition = $610f1a9c13915db5$var$RequiredInputLabelTextDefinition;
var $610f1a9c13915db5$var$InputLabelConfig = /** @class */ function() {
    function InputLabelConfig(obj) {
        this.inputSpacing = $gIXBn.Spacing.Small;
        this.width = 30;
        this.requiredInputs = new $610f1a9c13915db5$var$RequiredInputLabelTextDefinition();
        this.optionalInputs = new $610f1a9c13915db5$var$BaseTextDefinition();
        if (obj) {
            this.inputSpacing = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.Spacing, obj["inputSpacing"], this.inputSpacing);
            this.requiredInputs = new $610f1a9c13915db5$var$RequiredInputLabelTextDefinition(obj["requiredInputs"]);
            this.optionalInputs = new $610f1a9c13915db5$var$BaseTextDefinition(obj["optionalInputs"]);
            this.width = obj["width"] != null ? obj["width"] : this.width;
        }
    }
    return InputLabelConfig;
}();
module.exports.InputLabelConfig = $610f1a9c13915db5$var$InputLabelConfig;
var $610f1a9c13915db5$var$InputConfig = /** @class */ function() {
    function InputConfig(obj) {
        this.label = new $610f1a9c13915db5$var$InputLabelConfig();
        this.errorMessage = new $610f1a9c13915db5$var$BaseTextDefinition({
            color: $gIXBn.TextColor.Attention
        });
        this.debounceTimeInMilliSeconds = 0;
        this.allowDynamicallyFilteredChoiceSet = true;
        this.allowRevealOnHoverStyle = false;
        if (obj) {
            this.label = new $610f1a9c13915db5$var$InputLabelConfig(obj["label"]);
            this.errorMessage = new $610f1a9c13915db5$var$BaseTextDefinition(obj["errorMessage"]);
            this.allowRevealOnHoverStyle = obj["allowRevealOnHoverStyle"] || this.allowRevealOnHoverStyle;
            this.allowDynamicallyFilteredChoiceSet = obj["allowDynamicallyFilteredChoiceSet"] || this.allowDynamicallyFilteredChoiceSet;
            this.debounceTimeInMilliSeconds = obj["debounceTimeInMilliSeconds"] || this.debounceTimeInMilliSeconds;
        }
    }
    return InputConfig;
}();
module.exports.InputConfig = $610f1a9c13915db5$var$InputConfig;
var $610f1a9c13915db5$var$FactTextDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(FactTextDefinition, _super);
    function FactTextDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrap = true;
        return _this;
    }
    FactTextDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.wrap = obj["wrap"] != null ? obj["wrap"] : this.wrap;
    };
    FactTextDefinition.prototype.toJSON = function() {
        var result = _super.prototype.toJSON.call(this);
        result["wrap"] = this.wrap;
        return result;
    };
    return FactTextDefinition;
}($610f1a9c13915db5$var$BaseTextDefinition);
module.exports.FactTextDefinition = $610f1a9c13915db5$var$FactTextDefinition;
var $610f1a9c13915db5$var$FactTitleDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(FactTitleDefinition, _super);
    function FactTitleDefinition(obj) {
        var _this = _super.call(this, obj) || this;
        _this.maxWidth = 150;
        _this.weight = $gIXBn.TextWeight.Bolder;
        if (obj) {
            _this.maxWidth = obj["maxWidth"] != null ? obj["maxWidth"] : _this.maxWidth;
            _this.weight = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.TextWeight, obj["weight"], $gIXBn.TextWeight.Bolder);
        }
        return _this;
    }
    FactTitleDefinition.prototype.getDefaultWeight = function() {
        return $gIXBn.TextWeight.Bolder;
    };
    return FactTitleDefinition;
}($610f1a9c13915db5$var$FactTextDefinition);
module.exports.FactTitleDefinition = $610f1a9c13915db5$var$FactTitleDefinition;
var $610f1a9c13915db5$var$FactSetConfig = /** @class */ function() {
    function FactSetConfig(obj) {
        this.title = new $610f1a9c13915db5$var$FactTitleDefinition();
        this.value = new $610f1a9c13915db5$var$FactTextDefinition();
        this.spacing = 10;
        if (obj) {
            this.title = new $610f1a9c13915db5$var$FactTitleDefinition(obj["title"]);
            this.value = new $610f1a9c13915db5$var$FactTextDefinition(obj["value"]);
            this.spacing = obj.spacing && obj.spacing != null ? obj.spacing && obj.spacing : this.spacing;
        }
    }
    return FactSetConfig;
}();
module.exports.FactSetConfig = $610f1a9c13915db5$var$FactSetConfig;
var $610f1a9c13915db5$var$ShowCardActionConfig = /** @class */ function() {
    function ShowCardActionConfig(obj) {
        this.actionMode = $gIXBn.ShowCardActionMode.Inline;
        this.inlineTopMargin = 16;
        this.style = $gIXBn.ContainerStyle.Emphasis;
        if (obj) {
            this.actionMode = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.ShowCardActionMode, obj["actionMode"], $gIXBn.ShowCardActionMode.Inline);
            this.inlineTopMargin = obj["inlineTopMargin"] != null ? obj["inlineTopMargin"] : this.inlineTopMargin;
            this.style = obj["style"] && typeof obj["style"] === "string" ? obj["style"] : $gIXBn.ContainerStyle.Emphasis;
        }
    }
    ShowCardActionConfig.prototype.toJSON = function() {
        return {
            actionMode: $gIXBn.ShowCardActionMode[this.actionMode],
            inlineTopMargin: this.inlineTopMargin,
            style: this.style
        };
    };
    return ShowCardActionConfig;
}();
module.exports.ShowCardActionConfig = $610f1a9c13915db5$var$ShowCardActionConfig;
var $610f1a9c13915db5$var$ActionsConfig = /** @class */ function() {
    function ActionsConfig(obj) {
        this.maxActions = 5;
        this.spacing = $gIXBn.Spacing.Default;
        this.buttonSpacing = 20;
        this.showCard = new $610f1a9c13915db5$var$ShowCardActionConfig();
        this.preExpandSingleShowCardAction = false;
        this.actionsOrientation = $gIXBn.Orientation.Horizontal;
        this.actionAlignment = $gIXBn.ActionAlignment.Left;
        this.iconPlacement = $gIXBn.ActionIconPlacement.LeftOfTitle;
        this.allowTitleToWrap = false;
        this.iconSize = 16;
        if (obj) {
            this.maxActions = obj["maxActions"] != null ? obj["maxActions"] : this.maxActions;
            this.spacing = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.Spacing, obj.spacing && obj.spacing, $gIXBn.Spacing.Default);
            this.buttonSpacing = obj["buttonSpacing"] != null ? obj["buttonSpacing"] : this.buttonSpacing;
            this.showCard = new $610f1a9c13915db5$var$ShowCardActionConfig(obj["showCard"]);
            this.preExpandSingleShowCardAction = $F6YrP.parseBool(obj["preExpandSingleShowCardAction"], false);
            this.actionsOrientation = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.Orientation, obj["actionsOrientation"], $gIXBn.Orientation.Horizontal);
            this.actionAlignment = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.ActionAlignment, obj["actionAlignment"], $gIXBn.ActionAlignment.Left);
            this.iconPlacement = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.ActionIconPlacement, obj["iconPlacement"], $gIXBn.ActionIconPlacement.LeftOfTitle);
            this.allowTitleToWrap = obj["allowTitleToWrap"] != null ? obj["allowTitleToWrap"] : this.allowTitleToWrap;
            try {
                var sizeAndUnit = $6BHj7.SizeAndUnit.parse(obj["iconSize"]);
                if (sizeAndUnit.unit === $gIXBn.SizeUnit.Pixel) this.iconSize = sizeAndUnit.physicalSize;
            } catch (e) {
            // Swallow this, keep default icon size
            }
        }
    }
    ActionsConfig.prototype.toJSON = function() {
        return {
            maxActions: this.maxActions,
            spacing: $gIXBn.Spacing[this.spacing],
            buttonSpacing: this.buttonSpacing,
            showCard: this.showCard,
            preExpandSingleShowCardAction: this.preExpandSingleShowCardAction,
            actionsOrientation: $gIXBn.Orientation[this.actionsOrientation],
            actionAlignment: $gIXBn.ActionAlignment[this.actionAlignment]
        };
    };
    return ActionsConfig;
}();
module.exports.ActionsConfig = $610f1a9c13915db5$var$ActionsConfig;
var $610f1a9c13915db5$var$ColorSetDefinition = /** @class */ function() {
    function ColorSetDefinition(obj) {
        this.default = new $610f1a9c13915db5$var$TextColorDefinition();
        this.dark = new $610f1a9c13915db5$var$TextColorDefinition();
        this.light = new $610f1a9c13915db5$var$TextColorDefinition();
        this.accent = new $610f1a9c13915db5$var$TextColorDefinition();
        this.good = new $610f1a9c13915db5$var$TextColorDefinition();
        this.warning = new $610f1a9c13915db5$var$TextColorDefinition();
        this.attention = new $610f1a9c13915db5$var$TextColorDefinition();
        this.parse(obj);
    }
    ColorSetDefinition.prototype.parseSingleColor = function(obj, propertyName) {
        if (obj) this[propertyName].parse(obj[propertyName]);
    };
    ColorSetDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.parseSingleColor(obj, "default");
            this.parseSingleColor(obj, "dark");
            this.parseSingleColor(obj, "light");
            this.parseSingleColor(obj, "accent");
            this.parseSingleColor(obj, "good");
            this.parseSingleColor(obj, "warning");
            this.parseSingleColor(obj, "attention");
        }
    };
    return ColorSetDefinition;
}();
module.exports.ColorSetDefinition = $610f1a9c13915db5$var$ColorSetDefinition;
var $610f1a9c13915db5$var$ContainerStyleDefinition = /** @class */ function() {
    function ContainerStyleDefinition(obj) {
        this.foregroundColors = new $610f1a9c13915db5$var$ColorSetDefinition({
            "default": {
                default: "#333333",
                subtle: "#EE333333"
            },
            "dark": {
                default: "#000000",
                subtle: "#66000000"
            },
            "light": {
                default: "#FFFFFF",
                subtle: "#33000000"
            },
            "accent": {
                default: "#2E89FC",
                subtle: "#882E89FC"
            },
            "good": {
                default: "#028A02",
                subtle: "#DD027502"
            },
            "warning": {
                default: "#E69500",
                subtle: "#DDE69500"
            },
            "attention": {
                default: "#CC3300",
                subtle: "#DDCC3300"
            }
        });
        this.parse(obj);
    }
    ContainerStyleDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.backgroundColor = obj["backgroundColor"];
            this.foregroundColors.parse(obj["foregroundColors"]);
            this.highlightBackgroundColor = obj["highlightBackgroundColor"];
            this.highlightForegroundColor = obj["highlightForegroundColor"];
            this.borderColor = obj["borderColor"];
        }
    };
    Object.defineProperty(ContainerStyleDefinition.prototype, "isBuiltIn", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return ContainerStyleDefinition;
}();
module.exports.ContainerStyleDefinition = $610f1a9c13915db5$var$ContainerStyleDefinition;
var $610f1a9c13915db5$var$BuiltInContainerStyleDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(BuiltInContainerStyleDefinition, _super);
    function BuiltInContainerStyleDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BuiltInContainerStyleDefinition.prototype, "isBuiltIn", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return BuiltInContainerStyleDefinition;
}($610f1a9c13915db5$var$ContainerStyleDefinition);
var $610f1a9c13915db5$var$ContainerStyleSet = /** @class */ function() {
    function ContainerStyleSet(obj) {
        this._allStyles = {};
        this._allStyles[$gIXBn.ContainerStyle.Default] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        this._allStyles[$gIXBn.ContainerStyle.Emphasis] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        this._allStyles[$gIXBn.ContainerStyle.Accent] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        this._allStyles[$gIXBn.ContainerStyle.Good] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        this._allStyles[$gIXBn.ContainerStyle.Attention] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        this._allStyles[$gIXBn.ContainerStyle.Warning] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        if (obj) {
            this._allStyles[$gIXBn.ContainerStyle.Default].parse(obj[$gIXBn.ContainerStyle.Default]);
            this._allStyles[$gIXBn.ContainerStyle.Emphasis].parse(obj[$gIXBn.ContainerStyle.Emphasis]);
            this._allStyles[$gIXBn.ContainerStyle.Accent].parse(obj[$gIXBn.ContainerStyle.Accent]);
            this._allStyles[$gIXBn.ContainerStyle.Good].parse(obj[$gIXBn.ContainerStyle.Good]);
            this._allStyles[$gIXBn.ContainerStyle.Attention].parse(obj[$gIXBn.ContainerStyle.Attention]);
            this._allStyles[$gIXBn.ContainerStyle.Warning].parse(obj[$gIXBn.ContainerStyle.Warning]);
            var customStyleArray = obj["customStyles"];
            if (customStyleArray && Array.isArray(customStyleArray)) for(var _i = 0, customStyleArray_1 = customStyleArray; _i < customStyleArray_1.length; _i++){
                var customStyle = customStyleArray_1[_i];
                if (customStyle) {
                    var styleName = customStyle["name"];
                    if (styleName && typeof styleName === "string") {
                        if (this._allStyles.hasOwnProperty(styleName)) this._allStyles[styleName].parse(customStyle["style"]);
                        else this._allStyles[styleName] = new $610f1a9c13915db5$var$ContainerStyleDefinition(customStyle["style"]);
                    }
                }
            }
        }
    }
    ContainerStyleSet.prototype.toJSON = function() {
        var _this = this;
        var customStyleArray = [];
        Object.keys(this._allStyles).forEach(function(key) {
            if (!_this._allStyles[key].isBuiltIn) customStyleArray.push({
                name: key,
                style: _this._allStyles[key]
            });
        });
        var result = {
            default: this.default,
            emphasis: this.emphasis
        };
        if (customStyleArray.length > 0) result.customStyles = customStyleArray;
        return result;
    };
    ContainerStyleSet.prototype.getStyleByName = function(name, defaultValue) {
        if (name && this._allStyles.hasOwnProperty(name)) return this._allStyles[name];
        else return defaultValue ? defaultValue : this._allStyles[$gIXBn.ContainerStyle.Default];
    };
    Object.defineProperty(ContainerStyleSet.prototype, "default", {
        get: function() {
            return this._allStyles[$gIXBn.ContainerStyle.Default];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContainerStyleSet.prototype, "emphasis", {
        get: function() {
            return this._allStyles[$gIXBn.ContainerStyle.Emphasis];
        },
        enumerable: false,
        configurable: true
    });
    return ContainerStyleSet;
}();
module.exports.ContainerStyleSet = $610f1a9c13915db5$var$ContainerStyleSet;
var $610f1a9c13915db5$var$FontTypeDefinition = /** @class */ function() {
    function FontTypeDefinition(fontFamily) {
        this.fontFamily = "Segoe UI,Segoe,Segoe WP,Helvetica Neue,Helvetica,sans-serif";
        this.fontSizes = {
            small: 12,
            default: 14,
            medium: 17,
            large: 21,
            extraLarge: 26
        };
        this.fontWeights = {
            lighter: 200,
            default: 400,
            bolder: 600
        };
        if (fontFamily) this.fontFamily = fontFamily;
    }
    FontTypeDefinition.prototype.parse = function(obj) {
        this.fontFamily = obj["fontFamily"] || this.fontFamily;
        this.fontSizes = {
            small: obj.fontSizes && obj.fontSizes["small"] || this.fontSizes.small,
            default: obj.fontSizes && obj.fontSizes["default"] || this.fontSizes.default,
            medium: obj.fontSizes && obj.fontSizes["medium"] || this.fontSizes.medium,
            large: obj.fontSizes && obj.fontSizes["large"] || this.fontSizes.large,
            extraLarge: obj.fontSizes && obj.fontSizes["extraLarge"] || this.fontSizes.extraLarge
        };
        this.fontWeights = {
            lighter: obj.fontWeights && obj.fontWeights["lighter"] || this.fontWeights.lighter,
            default: obj.fontWeights && obj.fontWeights["default"] || this.fontWeights.default,
            bolder: obj.fontWeights && obj.fontWeights["bolder"] || this.fontWeights.bolder
        };
    };
    FontTypeDefinition.monospace = new FontTypeDefinition("'Courier New', Courier, monospace");
    return FontTypeDefinition;
}();
module.exports.FontTypeDefinition = $610f1a9c13915db5$var$FontTypeDefinition;
var $610f1a9c13915db5$var$FontTypeSet = /** @class */ function() {
    function FontTypeSet(obj) {
        this.default = new $610f1a9c13915db5$var$FontTypeDefinition();
        this.monospace = new $610f1a9c13915db5$var$FontTypeDefinition("'Courier New', Courier, monospace");
        if (obj) {
            this.default.parse(obj["default"]);
            this.monospace.parse(obj["monospace"]);
        }
    }
    FontTypeSet.prototype.getStyleDefinition = function(style) {
        switch(style){
            case $gIXBn.FontType.Monospace:
                return this.monospace;
            case $gIXBn.FontType.Default:
            default:
                return this.default;
        }
    };
    return FontTypeSet;
}();
module.exports.FontTypeSet = $610f1a9c13915db5$var$FontTypeSet;
var $610f1a9c13915db5$var$CarouselConfig = /** @class */ function() {
    function CarouselConfig(obj) {
        this.maxCarouselPages = 10;
        this.minAutoplayDelay = 5000.0;
        if (obj) {
            this.maxCarouselPages = obj["maxCarouselPages"] != null ? obj["maxCarouselPages"] : this.maxCarouselPages;
            this.minAutoplayDelay = obj["minAutoplayDelay"] != null ? obj["minAutoplayDelay"] : this.minAutoplayDelay;
        }
    }
    CarouselConfig.prototype.toJSON = function() {
        return {
            maxCarouselPages: this.maxCarouselPages,
            minAutoplayDelay: this.minAutoplayDelay
        };
    };
    return CarouselConfig;
}();
module.exports.CarouselConfig = $610f1a9c13915db5$var$CarouselConfig;
var $610f1a9c13915db5$var$HostConfig = /** @class */ function() {
    function HostConfig(obj) {
        this.hostCapabilities = new $7Lc5Q.HostCapabilities();
        this.choiceSetInputValueSeparator = ",";
        this.supportsInteractivity = true;
        this.spacing = {
            small: 3,
            default: 8,
            medium: 20,
            large: 30,
            extraLarge: 40,
            padding: 15
        };
        this.separator = {
            lineThickness: 1,
            lineColor: "#EEEEEE"
        };
        this.imageSizes = {
            small: 40,
            medium: 80,
            large: 160
        };
        this.containerStyles = new $610f1a9c13915db5$var$ContainerStyleSet();
        this.inputs = new $610f1a9c13915db5$var$InputConfig();
        this.actions = new $610f1a9c13915db5$var$ActionsConfig();
        this.adaptiveCard = new $610f1a9c13915db5$var$AdaptiveCardConfig();
        this.imageSet = new $610f1a9c13915db5$var$ImageSetConfig();
        this.media = new $610f1a9c13915db5$var$MediaConfig();
        this.factSet = new $610f1a9c13915db5$var$FactSetConfig();
        this.table = new $610f1a9c13915db5$var$TableConfig();
        this.textStyles = new $610f1a9c13915db5$var$TextStyleSet();
        this.textBlock = new $610f1a9c13915db5$var$TextBlockConfig();
        this.carousel = new $610f1a9c13915db5$var$CarouselConfig();
        this.alwaysAllowBleed = false;
        if (obj) {
            if (typeof obj === "string" || obj instanceof String) obj = JSON.parse(obj);
            this.choiceSetInputValueSeparator = obj && typeof obj["choiceSetInputValueSeparator"] === "string" ? obj["choiceSetInputValueSeparator"] : this.choiceSetInputValueSeparator;
            this.supportsInteractivity = obj && typeof obj["supportsInteractivity"] === "boolean" ? obj["supportsInteractivity"] : this.supportsInteractivity;
            this._legacyFontType = new $610f1a9c13915db5$var$FontTypeDefinition();
            this._legacyFontType.parse(obj);
            if (obj.fontTypes) this.fontTypes = new $610f1a9c13915db5$var$FontTypeSet(obj.fontTypes);
            if (obj.lineHeights) this.lineHeights = {
                small: obj.lineHeights["small"],
                default: obj.lineHeights["default"],
                medium: obj.lineHeights["medium"],
                large: obj.lineHeights["large"],
                extraLarge: obj.lineHeights["extraLarge"]
            };
            this.imageSizes = {
                small: obj.imageSizes && obj.imageSizes["small"] || this.imageSizes.small,
                medium: obj.imageSizes && obj.imageSizes["medium"] || this.imageSizes.medium,
                large: obj.imageSizes && obj.imageSizes["large"] || this.imageSizes.large
            };
            this.containerStyles = new $610f1a9c13915db5$var$ContainerStyleSet(obj["containerStyles"]);
            this.spacing = {
                small: obj.spacing && obj.spacing["small"] || this.spacing.small,
                default: obj.spacing && obj.spacing["default"] || this.spacing.default,
                medium: obj.spacing && obj.spacing["medium"] || this.spacing.medium,
                large: obj.spacing && obj.spacing["large"] || this.spacing.large,
                extraLarge: obj.spacing && obj.spacing["extraLarge"] || this.spacing.extraLarge,
                padding: obj.spacing && obj.spacing["padding"] || this.spacing.padding
            };
            this.separator = {
                lineThickness: obj.separator && obj.separator["lineThickness"] || this.separator.lineThickness,
                lineColor: obj.separator && obj.separator["lineColor"] || this.separator.lineColor
            };
            this.inputs = new $610f1a9c13915db5$var$InputConfig(obj.inputs || this.inputs);
            this.actions = new $610f1a9c13915db5$var$ActionsConfig(obj.actions || this.actions);
            this.adaptiveCard = new $610f1a9c13915db5$var$AdaptiveCardConfig(obj.adaptiveCard || this.adaptiveCard);
            this.imageSet = new $610f1a9c13915db5$var$ImageSetConfig(obj["imageSet"]);
            this.factSet = new $610f1a9c13915db5$var$FactSetConfig(obj["factSet"]);
            this.textStyles = new $610f1a9c13915db5$var$TextStyleSet(obj["textStyles"]);
            this.textBlock = new $610f1a9c13915db5$var$TextBlockConfig(obj["textBlock"]);
            this.carousel = new $610f1a9c13915db5$var$CarouselConfig(obj["carousel"]);
        }
    }
    HostConfig.prototype.getFontTypeDefinition = function(style) {
        if (this.fontTypes) return this.fontTypes.getStyleDefinition(style);
        else return style === $gIXBn.FontType.Monospace ? $610f1a9c13915db5$var$FontTypeDefinition.monospace : this._legacyFontType;
    };
    HostConfig.prototype.getEffectiveSpacing = function(spacing) {
        switch(spacing){
            case $gIXBn.Spacing.Small:
                return this.spacing.small;
            case $gIXBn.Spacing.Default:
                return this.spacing.default;
            case $gIXBn.Spacing.Medium:
                return this.spacing.medium;
            case $gIXBn.Spacing.Large:
                return this.spacing.large;
            case $gIXBn.Spacing.ExtraLarge:
                return this.spacing.extraLarge;
            case $gIXBn.Spacing.Padding:
                return this.spacing.padding;
            default:
                return 0;
        }
    };
    HostConfig.prototype.paddingDefinitionToSpacingDefinition = function(paddingDefinition) {
        return new $6BHj7.SpacingDefinition(this.getEffectiveSpacing(paddingDefinition.top), this.getEffectiveSpacing(paddingDefinition.right), this.getEffectiveSpacing(paddingDefinition.bottom), this.getEffectiveSpacing(paddingDefinition.left));
    };
    HostConfig.prototype.makeCssClassNames = function() {
        var classNames = [];
        for(var _i = 0; _i < arguments.length; _i++)classNames[_i] = arguments[_i];
        var result = [];
        for(var _a = 0, classNames_1 = classNames; _a < classNames_1.length; _a++){
            var className = classNames_1[_a];
            result.push((this.cssClassNamePrefix ? this.cssClassNamePrefix + "-" : "") + className);
        }
        return result;
    };
    HostConfig.prototype.makeCssClassName = function() {
        var classNames = [];
        for(var _i = 0; _i < arguments.length; _i++)classNames[_i] = arguments[_i];
        var result = this.makeCssClassNames.apply(this, classNames).join(" ");
        return result ? result : "";
    };
    Object.defineProperty(HostConfig.prototype, "fontFamily", {
        get: function() {
            return this._legacyFontType.fontFamily;
        },
        set: function(value) {
            this._legacyFontType.fontFamily = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HostConfig.prototype, "fontSizes", {
        get: function() {
            return this._legacyFontType.fontSizes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HostConfig.prototype, "fontWeights", {
        get: function() {
            return this._legacyFontType.fontWeights;
        },
        enumerable: false,
        configurable: true
    });
    return HostConfig;
}();
module.exports.HostConfig = $610f1a9c13915db5$var$HostConfig;
// eslint-disable-next-line @typescript-eslint/naming-convention
module.exports.defaultHostConfig = new $610f1a9c13915db5$var$HostConfig({
    supportsInteractivity: true,
    spacing: {
        small: 10,
        default: 20,
        medium: 30,
        large: 40,
        extraLarge: 50,
        padding: 20
    },
    separator: {
        lineThickness: 1,
        lineColor: "#EEEEEE"
    },
    fontTypes: {
        default: {
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 17,
                large: 21,
                extraLarge: 26
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600
            }
        },
        monospace: {
            fontFamily: "'Courier New', Courier, monospace",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 17,
                large: 21,
                extraLarge: 26
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600
            }
        }
    },
    imageSizes: {
        small: 40,
        medium: 80,
        large: 160
    },
    containerStyles: {
        default: {
            backgroundColor: "#FFFFFF",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        emphasis: {
            backgroundColor: "#08000000",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        accent: {
            backgroundColor: "#C7DEF9",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        good: {
            backgroundColor: "#CCFFCC",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        attention: {
            backgroundColor: "#FFC5B2",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        warning: {
            backgroundColor: "#FFE2B2",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        }
    },
    inputs: {
        label: {
            requiredInputs: {
                weight: $gIXBn.TextWeight.Bolder,
                suffix: " *",
                suffixColor: $gIXBn.TextColor.Attention
            },
            optionalInputs: {
                weight: $gIXBn.TextWeight.Bolder
            }
        },
        errorMessage: {
            color: $gIXBn.TextColor.Attention,
            weight: $gIXBn.TextWeight.Bolder
        },
        debounceTimeInMilliSeconds: 250
    },
    actions: {
        maxActions: 5,
        spacing: $gIXBn.Spacing.Default,
        buttonSpacing: 10,
        showCard: {
            actionMode: $gIXBn.ShowCardActionMode.Inline,
            inlineTopMargin: 16
        },
        actionsOrientation: $gIXBn.Orientation.Horizontal,
        actionAlignment: $gIXBn.ActionAlignment.Left
    },
    adaptiveCard: {
        allowCustomStyle: false
    },
    imageSet: {
        imageSize: $gIXBn.Size.Medium,
        maxImageHeight: 100
    },
    factSet: {
        title: {
            color: $gIXBn.TextColor.Default,
            size: $gIXBn.TextSize.Default,
            isSubtle: false,
            weight: $gIXBn.TextWeight.Bolder,
            wrap: true,
            maxWidth: 150
        },
        value: {
            color: $gIXBn.TextColor.Default,
            size: $gIXBn.TextSize.Default,
            isSubtle: false,
            weight: $gIXBn.TextWeight.Default,
            wrap: true
        },
        spacing: 10
    },
    carousel: {
        maxCarouselPages: 10,
        minAutoplayDuration: 5000
    },
    textBlock: {
        headingLevel: 2
    }
});

});

parcelRegister("2Zn2I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GlobalRegistry = module.exports.CardObjectRegistry = void 0;

var $5Ougt = parcelRequire("5Ougt");
var $22d3271605b452a3$var$CardObjectRegistry = /** @class */ function() {
    function CardObjectRegistry() {
        this._items = {};
    }
    CardObjectRegistry.prototype.findByName = function(typeName) {
        return this._items.hasOwnProperty(typeName) ? this._items[typeName] : undefined;
    };
    CardObjectRegistry.prototype.clear = function() {
        this._items = {};
    };
    CardObjectRegistry.prototype.copyTo = function(target) {
        var keys = Object.keys(this._items);
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            var typeRegistration = this._items[key];
            target.register(typeRegistration.typeName, typeRegistration.objectType, typeRegistration.schemaVersion);
        }
    };
    CardObjectRegistry.prototype.register = function(typeName, objectType, schemaVersion) {
        if (schemaVersion === void 0) schemaVersion = $5Ougt.Versions.v1_0;
        var registrationInfo = this.findByName(typeName);
        if (registrationInfo !== undefined) registrationInfo.objectType = objectType;
        else registrationInfo = {
            typeName: typeName,
            objectType: objectType,
            schemaVersion: schemaVersion
        };
        this._items[typeName] = registrationInfo;
    };
    CardObjectRegistry.prototype.unregister = function(typeName) {
        delete this._items[typeName];
    };
    CardObjectRegistry.prototype.createInstance = function(typeName, targetVersion) {
        var registrationInfo = this.findByName(typeName);
        return registrationInfo && registrationInfo.schemaVersion.compareTo(targetVersion) <= 0 ? new registrationInfo.objectType() : undefined;
    };
    CardObjectRegistry.prototype.getItemCount = function() {
        return Object.keys(this._items).length;
    };
    CardObjectRegistry.prototype.getItemAt = function(index) {
        var _this = this;
        return Object.keys(this._items).map(function(e) {
            return _this._items[e];
        })[index];
    };
    return CardObjectRegistry;
}();
module.exports.CardObjectRegistry = $22d3271605b452a3$var$CardObjectRegistry;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $22d3271605b452a3$var$GlobalRegistry = /** @class */ function() {
    function GlobalRegistry() {}
    GlobalRegistry.populateWithDefaultElements = function(registry) {
        registry.clear();
        GlobalRegistry.defaultElements.copyTo(registry);
    };
    GlobalRegistry.populateWithDefaultActions = function(registry) {
        registry.clear();
        GlobalRegistry.defaultActions.copyTo(registry);
    };
    Object.defineProperty(GlobalRegistry, "elements", {
        get: function() {
            if (!GlobalRegistry._elements) {
                GlobalRegistry._elements = new $22d3271605b452a3$var$CardObjectRegistry();
                GlobalRegistry.populateWithDefaultElements(GlobalRegistry._elements);
            }
            return GlobalRegistry._elements;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalRegistry, "actions", {
        get: function() {
            if (!GlobalRegistry._actions) {
                GlobalRegistry._actions = new $22d3271605b452a3$var$CardObjectRegistry();
                GlobalRegistry.populateWithDefaultActions(GlobalRegistry._actions);
            }
            return GlobalRegistry._actions;
        },
        enumerable: false,
        configurable: true
    });
    GlobalRegistry.reset = function() {
        GlobalRegistry._elements = undefined;
        GlobalRegistry._actions = undefined;
    };
    GlobalRegistry.defaultElements = new $22d3271605b452a3$var$CardObjectRegistry();
    GlobalRegistry.defaultActions = new $22d3271605b452a3$var$CardObjectRegistry();
    return GlobalRegistry;
}();
module.exports.GlobalRegistry = $22d3271605b452a3$var$GlobalRegistry;

});

parcelRegister("dUjDB", function(module, exports) {
"use strict";
var $a1ffbcf9ace7d47a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a1ffbcf9ace7d47a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardObject = module.exports.ValidationResults = void 0;

var $gIXBn = parcelRequire("gIXBn");

var $24F6S = parcelRequire("24F6S");

var $6BHj7 = parcelRequire("6BHj7");

var $7Lc5Q = parcelRequire("7Lc5Q");

var $5Ougt = parcelRequire("5Ougt");
var $a1ffbcf9ace7d47a$var$ValidationResults = /** @class */ function() {
    function ValidationResults() {
        this.allIds = {};
        this.validationEvents = [];
    }
    ValidationResults.prototype.addFailure = function(cardObject, event, message) {
        this.validationEvents.push({
            phase: $gIXBn.ValidationPhase.Validation,
            source: cardObject,
            event: event,
            message: message
        });
    };
    return ValidationResults;
}();
module.exports.ValidationResults = $a1ffbcf9ace7d47a$var$ValidationResults;
var $a1ffbcf9ace7d47a$var$CardObject = /** @class */ function(_super) {
    $a1ffbcf9ace7d47a$var$__extends(CardObject, _super);
    function CardObject() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        _this._shouldFallback = false;
        return _this;
    }
    CardObject.prototype.getSchemaKey = function() {
        return this.getJsonTypeName();
    };
    Object.defineProperty(CardObject.prototype, "requires", {
        get: function() {
            return this.getValue(CardObject.requiresProperty);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Checks if this CardObject contains the given DOM Node.
     * @param node The DOM Node to look for.
     * @returns `true` if the DOM Node was found, `false` otherwise.
     */ CardObject.prototype.contains = function(node) {
        if (this._renderedElement) return this._renderedElement.contains(node);
        return false;
    };
    CardObject.prototype.preProcessPropertyValue = function(prop, propertyValue) {
        var value = propertyValue === undefined ? this.getValue(prop) : propertyValue;
        if ($6BHj7.GlobalSettings.allowPreProcessingPropertyValues) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var currentObject = this;
            while(currentObject && !currentObject.onPreProcessPropertyValue)currentObject = currentObject.parent;
            if (currentObject && currentObject.onPreProcessPropertyValue) return currentObject.onPreProcessPropertyValue(this, prop, value);
        }
        return value;
    };
    CardObject.prototype.setParent = function(value) {
        this._parent = value;
    };
    CardObject.prototype.setShouldFallback = function(value) {
        this._shouldFallback = value;
    };
    CardObject.prototype.shouldFallback = function() {
        return this._shouldFallback || !this.requires.areAllMet(this.hostConfig.hostCapabilities);
    };
    CardObject.prototype.getRootObject = function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var currentObject = this;
        while(currentObject.parent)currentObject = currentObject.parent;
        return currentObject;
    };
    CardObject.prototype.internalValidateProperties = function(context) {
        if (this.id) {
            if (context.allIds.hasOwnProperty(this.id)) {
                if (context.allIds[this.id] === 1) context.addFailure(this, $gIXBn.ValidationEvent.DuplicateId, $24F6S.Strings.errors.duplicateId(this.id));
                context.allIds[this.id] += 1;
            } else context.allIds[this.id] = 1;
        }
    };
    CardObject.prototype.validateProperties = function() {
        var result = new $a1ffbcf9ace7d47a$var$ValidationResults();
        this.internalValidateProperties(result);
        return result;
    };
    /**
     * Recursively searches this CardObject and any children to find the
     * innermost CardObject that owns the given DOM Node.
     *
     * @param node The DOM Node to look for.
     *
     * @returns The owner of the given DOM Node, or `undefined` if no owner was found.
     */ CardObject.prototype.findDOMNodeOwner = function(node) {
        // default implementation for CardObjects with no associated children
        return this.contains(node) ? this : undefined;
    };
    CardObject.prototype.releaseDOMResources = function() {
    // Do nothing in base implementation
    };
    Object.defineProperty(CardObject.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardObject.prototype, "renderedElement", {
        get: function() {
            return this._renderedElement;
        },
        enumerable: false,
        configurable: true
    });
    CardObject.typeNameProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "type", undefined, undefined, undefined, function(sender) {
        return sender.getJsonTypeName();
    });
    CardObject.idProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "id");
    CardObject.requiresProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_2, "requires", $7Lc5Q.HostCapabilities, false, new $7Lc5Q.HostCapabilities());
    $a1ffbcf9ace7d47a$var$__decorate([
        (0, $5Ougt.property)(CardObject.idProperty)
    ], CardObject.prototype, "id", void 0);
    $a1ffbcf9ace7d47a$var$__decorate([
        (0, $5Ougt.property)(CardObject.requiresProperty)
    ], CardObject.prototype, "requires", null);
    return CardObject;
}($5Ougt.SerializableObject);
module.exports.CardObject = $a1ffbcf9ace7d47a$var$CardObject;

});

parcelRegister("6XfIC", function(module, exports) {
"use strict";
var $5104722604b983cb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5104722604b983cb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5104722604b983cb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5104722604b983cb$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5104722604b983cb$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackgroundImage = module.exports.ContainerBase = module.exports.StylableCardElementContainer = module.exports.ContainerStyleProperty = module.exports.ActionSet = module.exports.ShowCardAction = module.exports.HttpAction = module.exports.HttpHeader = module.exports.ToggleVisibilityAction = module.exports.OpenUrlAction = module.exports.DataQuery = module.exports.ExecuteAction = module.exports.UniversalAction = module.exports.SubmitAction = module.exports.SubmitActionBase = module.exports.Action = module.exports.TimeInput = module.exports.TimeProperty = module.exports.DateInput = module.exports.NumberInput = module.exports.FilteredChoiceSet = module.exports.ChoiceSetInput = module.exports.ChoiceSetInputDataQuery = module.exports.Choice = module.exports.ToggleInput = module.exports.TextInput = module.exports.Input = module.exports.Media = module.exports.YouTubePlayer = module.exports.DailymotionPlayer = module.exports.VimeoPlayer = module.exports.IFrameMediaMediaPlayer = module.exports.CustomMediaPlayer = module.exports.HTML5MediaPlayer = module.exports.MediaPlayer = module.exports.MediaSource = module.exports.CaptionSource = module.exports.ContentSource = module.exports.ImageSet = module.exports.CardElementContainer = module.exports.Image = module.exports.FactSet = module.exports.Fact = module.exports.RichTextBlock = module.exports.TextRun = module.exports.TextBlock = module.exports.BaseTextBlock = module.exports.ActionProperty = module.exports.CardElement = module.exports.renderSeparation = void 0;
module.exports.SerializationContext = module.exports.AdaptiveCard = module.exports.Authentication = module.exports.TokenExchangeResource = module.exports.AuthCardButton = module.exports.RefreshDefinition = module.exports.RefreshActionProperty = module.exports.ContainerWithActions = module.exports.ColumnSet = module.exports.Column = module.exports.Container = void 0;

var $gIXBn = parcelRequire("gIXBn");

var $6BHj7 = parcelRequire("6BHj7");

var $F6YrP = parcelRequire("F6YrP");

var $8kDQQ = parcelRequire("8kDQQ");

var $fuLKQ = parcelRequire("fuLKQ");

var $dUjDB = parcelRequire("dUjDB");

var $5Ougt = parcelRequire("5Ougt");

var $2Zn2I = parcelRequire("2Zn2I");

var $24F6S = parcelRequire("24F6S");

var $iX2Kh = parcelRequire("iX2Kh");
function $5104722604b983cb$var$clearElement(element) {
    var _a, _b;
    var trustedHtml = typeof window === 'undefined' ? "" : (_b = (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.emptyHTML) !== null && _b !== void 0 ? _b : "";
    element.innerHTML = trustedHtml;
}
function $5104722604b983cb$var$renderSeparation(hostConfig, separationDefinition, orientation) {
    if (separationDefinition.spacing > 0 || separationDefinition.lineThickness && separationDefinition.lineThickness > 0) {
        var separator = document.createElement("div");
        separator.className = hostConfig.makeCssClassName("ac-" + (orientation === $gIXBn.Orientation.Horizontal ? "horizontal" : "vertical") + "-separator");
        separator.setAttribute("aria-hidden", "true");
        var color = separationDefinition.lineColor ? $F6YrP.stringToCssColor(separationDefinition.lineColor) : "";
        if (orientation === $gIXBn.Orientation.Horizontal) {
            if (separationDefinition.lineThickness) {
                separator.style.paddingTop = separationDefinition.spacing / 2 + "px";
                separator.style.marginBottom = separationDefinition.spacing / 2 + "px";
                separator.style.borderBottom = separationDefinition.lineThickness + "px solid " + color;
            } else separator.style.height = separationDefinition.spacing + "px";
        } else if (separationDefinition.lineThickness) {
            separator.style.paddingLeft = separationDefinition.spacing / 2 + "px";
            separator.style.marginRight = separationDefinition.spacing / 2 + "px";
            separator.style.borderRight = separationDefinition.lineThickness + "px solid " + color;
        } else separator.style.width = separationDefinition.spacing + "px";
        separator.style.overflow = "hidden";
        separator.style.flex = "0 0 auto";
        return separator;
    } else return undefined;
}
module.exports.renderSeparation = $5104722604b983cb$var$renderSeparation;
var $5104722604b983cb$var$CardElement = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(CardElement, _super);
    function CardElement() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._truncatedDueToOverflow = false;
        return _this;
    }
    Object.defineProperty(CardElement.prototype, "lang", {
        get: function() {
            var lang = this.getValue(CardElement.langProperty);
            if (lang) return lang;
            else {
                if (this.parent) return this.parent.lang;
                else return undefined;
            }
        },
        set: function(value) {
            this.setValue(CardElement.langProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isVisible", {
        get: function() {
            return this.getValue(CardElement.isVisibleProperty);
        },
        set: function(value) {
            // If the element is going to be hidden, reset any changes that were due
            // to overflow truncation (this ensures that if the element is later
            // un-hidden it has the right content)
            if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation && !value) this.undoOverflowTruncation();
            if (this.isVisible !== value) {
                this.setValue(CardElement.isVisibleProperty, value);
                this.updateRenderedElementVisibility();
                if (this._renderedElement) $5104722604b983cb$var$raiseElementVisibilityChangedEvent(this);
            }
            if (this._renderedElement) this._renderedElement.setAttribute("aria-expanded", value.toString());
        },
        enumerable: false,
        configurable: true
    });
    CardElement.prototype.internalRenderSeparator = function() {
        var renderedSeparator = $5104722604b983cb$var$renderSeparation(this.hostConfig, {
            spacing: this.hostConfig.getEffectiveSpacing(this.spacing),
            lineThickness: this.separator ? this.hostConfig.separator.lineThickness : undefined,
            lineColor: this.separator ? this.hostConfig.separator.lineColor : undefined
        }, this.separatorOrientation);
        if ($6BHj7.GlobalSettings.alwaysBleedSeparators && renderedSeparator && this.separatorOrientation === $gIXBn.Orientation.Horizontal) {
            // Adjust separator's margins if the option to always bleed separators is turned on
            var parentContainer = this.getParentContainer();
            if (parentContainer && parentContainer.getEffectivePadding()) {
                var parentPhysicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(parentContainer.getEffectivePadding());
                renderedSeparator.style.marginLeft = "-" + parentPhysicalPadding.left + "px";
                renderedSeparator.style.marginRight = "-" + parentPhysicalPadding.right + "px";
            }
        }
        return renderedSeparator;
    };
    CardElement.prototype.updateRenderedElementVisibility = function() {
        var displayMode = this.isDesignMode() || this.isVisible ? this._defaultRenderedElementDisplayMode : "none";
        if (this._renderedElement) {
            if (displayMode) this._renderedElement.style.display = displayMode;
            else this._renderedElement.style.removeProperty("display");
        }
        if (this._separatorElement) {
            if (this.parent && this.parent.isFirstElement(this)) this._separatorElement.style.display = "none";
            else if (displayMode) this._separatorElement.style.display = displayMode;
            else this._separatorElement.style.removeProperty("display");
        }
    };
    CardElement.prototype.hideElementDueToOverflow = function() {
        if (this._renderedElement && this.isVisible) {
            this._renderedElement.style.visibility = "hidden";
            this.isVisible = false;
            $5104722604b983cb$var$raiseElementVisibilityChangedEvent(this, false);
        }
    };
    CardElement.prototype.showElementHiddenDueToOverflow = function() {
        if (this._renderedElement && !this.isVisible) {
            this._renderedElement.style.removeProperty("visibility");
            this.isVisible = true;
            $5104722604b983cb$var$raiseElementVisibilityChangedEvent(this, false);
        }
    };
    // Marked private to emulate internal access
    CardElement.prototype.handleOverflow = function(maxHeight) {
        if (this.isVisible || this.isHiddenDueToOverflow()) {
            var handled = this.truncateOverflow(maxHeight);
            // Even if we were unable to truncate the element to fit this time,
            // it still could have been previously truncated
            this._truncatedDueToOverflow = handled || this._truncatedDueToOverflow;
            if (!handled) this.hideElementDueToOverflow();
            else if (handled && !this.isVisible) this.showElementHiddenDueToOverflow();
        }
    };
    // Marked private to emulate internal access
    CardElement.prototype.resetOverflow = function() {
        var sizeChanged = false;
        if (this._truncatedDueToOverflow) {
            this.undoOverflowTruncation();
            this._truncatedDueToOverflow = false;
            sizeChanged = true;
        }
        if (this.isHiddenDueToOverflow()) this.showElementHiddenDueToOverflow();
        return sizeChanged;
    };
    CardElement.prototype.getDefaultSerializationContext = function() {
        return new $5104722604b983cb$var$SerializationContext();
    };
    CardElement.prototype.createPlaceholderElement = function() {
        var styleDefinition = this.getEffectiveStyleDefinition();
        var foregroundCssColor = $F6YrP.stringToCssColor(styleDefinition.foregroundColors.default.subtle);
        var element = document.createElement("div");
        element.style.border = "1px dashed " + foregroundCssColor;
        element.style.padding = "4px";
        element.style.minHeight = "32px";
        element.style.fontSize = "10px";
        if (foregroundCssColor) element.style.color = foregroundCssColor;
        element.innerText = $24F6S.Strings.defaults.emptyElementText(this.getJsonTypeName());
        return element;
    };
    CardElement.prototype.adjustRenderedElementSize = function(renderedElement) {
        if (this.height === "auto") renderedElement.style.flex = "0 0 auto";
        else renderedElement.style.flex = "1 1 auto";
    };
    /*
     * Called when mouse enters or leaves the card.
     * Inputs elements need to update their visual state in such events like showing or hiding borders etc.
     * It calls Input.updateVisualState(eventType) for all inputs.
     * This method on input (updateVisualState) is supposed to be called from card level on mouse events.
     */ CardElement.prototype.updateInputsVisualState = function(hover) {
        var allInputs = this.getAllInputs();
        var inputEventType = !!hover ? $5104722604b983cb$var$InputEventType.MouseEnterOnCard : $5104722604b983cb$var$InputEventType.MouseLeaveOnCard;
        allInputs.forEach(function(input) {
            return input.updateVisualState(inputEventType);
        });
    };
    CardElement.prototype.isDisplayed = function() {
        return this._renderedElement !== undefined && this.isVisible && this._renderedElement.offsetHeight > 0;
    };
    CardElement.prototype.overrideInternalRender = function() {
        return this.internalRender();
    };
    CardElement.prototype.applyPadding = function() {
        if (this.separatorElement && this.separatorOrientation === $gIXBn.Orientation.Horizontal) {
            if ($6BHj7.GlobalSettings.alwaysBleedSeparators && !this.isBleeding()) {
                var padding = new $6BHj7.PaddingDefinition();
                this.getImmediateSurroundingPadding(padding);
                var physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
                this.separatorElement.style.marginLeft = "-" + physicalPadding.left + "px";
                this.separatorElement.style.marginRight = "-" + physicalPadding.right + "px";
            } else {
                this.separatorElement.style.marginRight = "0";
                this.separatorElement.style.marginLeft = "0";
            }
        }
    };
    /*
     * Called when this element overflows the bottom of the card.
     * maxHeight will be the amount of space still available on the card (0 if
     * the element is fully off the card).
     */ CardElement.prototype.truncateOverflow = function(_maxHeight) {
        // Child implementations should return true if the element handled
        // the truncation request such that its content fits within maxHeight,
        // false if the element should fall back to being hidden
        return false;
    };
    /*
     * This should reverse any changes performed in truncateOverflow().
     */ CardElement.prototype.undoOverflowTruncation = function() {
        return;
    };
    CardElement.prototype.getDefaultPadding = function() {
        return new $6BHj7.PaddingDefinition();
    };
    CardElement.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        return false;
    };
    CardElement.prototype.getHasBorder = function() {
        return false;
    };
    CardElement.prototype.getPadding = function() {
        return this._padding;
    };
    CardElement.prototype.setPadding = function(value) {
        this._padding = value;
    };
    CardElement.prototype.shouldSerialize = function(context) {
        return context.elementRegistry.findByName(this.getJsonTypeName()) !== undefined;
    };
    Object.defineProperty(CardElement.prototype, "useDefaultSizing", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "separatorOrientation", {
        get: function() {
            return $gIXBn.Orientation.Horizontal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "defaultStyle", {
        get: function() {
            return $gIXBn.ContainerStyle.Default;
        },
        enumerable: false,
        configurable: true
    });
    CardElement.prototype.parse = function(source, context) {
        _super.prototype.parse.call(this, source, context ? context : new $5104722604b983cb$var$SerializationContext());
    };
    CardElement.prototype.asString = function() {
        return "";
    };
    CardElement.prototype.isBleeding = function() {
        return false;
    };
    CardElement.prototype.getEffectiveStyle = function() {
        if (this.parent) return this.parent.getEffectiveStyle();
        return this.defaultStyle;
    };
    CardElement.prototype.getEffectiveStyleDefinition = function() {
        return this.hostConfig.containerStyles.getStyleByName(this.getEffectiveStyle());
    };
    CardElement.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.parent) return this.parent.getEffectiveTextStyleDefinition();
        return this.hostConfig.textStyles.default;
    };
    CardElement.prototype.getForbiddenActionTypes = function() {
        return [];
    };
    CardElement.prototype.getImmediateSurroundingPadding = function(result, processTop, processRight, processBottom, processLeft) {
        if (processTop === void 0) processTop = true;
        if (processRight === void 0) processRight = true;
        if (processBottom === void 0) processBottom = true;
        if (processLeft === void 0) processLeft = true;
        if (this.parent) {
            var doProcessTop = processTop && this.parent.isTopElement(this);
            var doProcessRight = processRight && this.parent.isRightMostElement(this);
            var doProcessBottom = processBottom && this.parent.isBottomElement(this);
            var doProcessLeft = processLeft && this.parent.isLeftMostElement(this);
            var effectivePadding = this.parent.getEffectivePadding();
            if (effectivePadding) {
                if (doProcessTop && effectivePadding.top !== $gIXBn.Spacing.None) {
                    result.top = effectivePadding.top;
                    doProcessTop = false;
                }
                if (doProcessRight && effectivePadding.right !== $gIXBn.Spacing.None) {
                    result.right = effectivePadding.right;
                    doProcessRight = false;
                }
                if (doProcessBottom && effectivePadding.bottom !== $gIXBn.Spacing.None) {
                    result.bottom = effectivePadding.bottom;
                    doProcessBottom = false;
                }
                if (doProcessLeft && effectivePadding.left !== $gIXBn.Spacing.None) {
                    result.left = effectivePadding.left;
                    doProcessLeft = false;
                }
            }
            if (doProcessTop || doProcessRight || doProcessBottom || doProcessLeft) this.parent.getImmediateSurroundingPadding(result, doProcessTop, doProcessRight, doProcessBottom, doProcessLeft);
        }
    };
    CardElement.prototype.getActionCount = function() {
        return 0;
    };
    CardElement.prototype.getActionAt = function(index) {
        throw new Error($24F6S.Strings.errors.indexOutOfRange(index));
    };
    CardElement.prototype.indexOfAction = function(action) {
        for(var i = 0; i < this.getActionCount(); i++){
            if (this.getActionAt(i) === action) return i;
        }
        return -1;
    };
    CardElement.prototype.remove = function() {
        if (this.parent && this.parent instanceof $5104722604b983cb$var$CardElementContainer) return this.parent.removeItem(this);
        return false;
    };
    CardElement.prototype.render = function() {
        this._renderedElement = this.overrideInternalRender();
        this._separatorElement = this.internalRenderSeparator();
        if (this._renderedElement) {
            if (this.id) this._renderedElement.id = this.id;
            if (this.customCssSelector) this._renderedElement.classList.add(this.customCssSelector);
            this._renderedElement.style.boxSizing = "border-box";
            this._defaultRenderedElementDisplayMode = this._renderedElement.style.display ? this._renderedElement.style.display : undefined;
            this.adjustRenderedElementSize(this._renderedElement);
            this.updateLayout(false);
        } else if (this.isDesignMode()) this._renderedElement = this.createPlaceholderElement();
        return this._renderedElement;
    };
    CardElement.prototype.updateLayout = function(_processChildren) {
        if (_processChildren === void 0) _processChildren = true;
        this.updateRenderedElementVisibility();
        this.applyPadding();
    };
    CardElement.prototype.updateActionsEnabledState = function() {
        var allActions = this.getRootElement().getAllActions();
        for(var _i = 0, allActions_1 = allActions; _i < allActions_1.length; _i++){
            var action = allActions_1[_i];
            action.updateEnabledState();
        }
    };
    CardElement.prototype.indexOf = function(_cardElement) {
        return -1;
    };
    CardElement.prototype.isDesignMode = function() {
        var rootElement = this.getRootElement();
        return rootElement instanceof $5104722604b983cb$var$AdaptiveCard && rootElement.designMode;
    };
    CardElement.prototype.isFirstElement = function(_element) {
        return true;
    };
    CardElement.prototype.isLastElement = function(_element) {
        return true;
    };
    CardElement.prototype.isAtTheVeryLeft = function() {
        return this.parent ? this.parent.isLeftMostElement(this) && this.parent.isAtTheVeryLeft() : true;
    };
    CardElement.prototype.isAtTheVeryRight = function() {
        return this.parent ? this.parent.isRightMostElement(this) && this.parent.isAtTheVeryRight() : true;
    };
    CardElement.prototype.isAtTheVeryTop = function() {
        return this.parent ? this.parent.isFirstElement(this) && this.parent.isAtTheVeryTop() : true;
    };
    CardElement.prototype.isAtTheVeryBottom = function() {
        return this.parent ? this.parent.isLastElement(this) && this.parent.isAtTheVeryBottom() : true;
    };
    CardElement.prototype.isBleedingAtTop = function() {
        return false;
    };
    CardElement.prototype.isBleedingAtBottom = function() {
        return false;
    };
    CardElement.prototype.isLeftMostElement = function(_element) {
        return true;
    };
    CardElement.prototype.isRightMostElement = function(_element) {
        return true;
    };
    CardElement.prototype.isTopElement = function(element) {
        return this.isFirstElement(element);
    };
    CardElement.prototype.isBottomElement = function(element) {
        return this.isLastElement(element);
    };
    CardElement.prototype.isHiddenDueToOverflow = function() {
        return this._renderedElement !== undefined && this._renderedElement.style.visibility === "hidden";
    };
    CardElement.prototype.getRootElement = function() {
        return this.getRootObject();
    };
    CardElement.prototype.getParentContainer = function() {
        var currentElement = this.parent;
        while(currentElement){
            if (currentElement instanceof $5104722604b983cb$var$Container) return currentElement;
            currentElement = currentElement.parent;
        }
        return undefined;
    };
    CardElement.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [];
    };
    CardElement.prototype.getAllActions = function() {
        var result = [];
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) result.push(action);
        }
        return result;
    };
    CardElement.prototype.getResourceInformation = function() {
        return [];
    };
    CardElement.prototype.getElementById = function(id) {
        return this.id === id ? this : undefined;
    };
    CardElement.prototype.getActionById = function(_id) {
        return undefined;
    };
    CardElement.prototype.getElementByIdFromAction = function(id) {
        var result = undefined;
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action instanceof $5104722604b983cb$var$ShowCardAction) {
                result = action.card.getElementById(id);
                if (result) break;
            }
        }
        return result;
    };
    CardElement.prototype.getEffectivePadding = function() {
        var padding = this.getPadding();
        return padding ? padding : this.getDefaultPadding();
    };
    CardElement.prototype.getEffectiveHorizontalAlignment = function() {
        if (this.horizontalAlignment !== undefined) return this.horizontalAlignment;
        if (this.parent) return this.parent.getEffectiveHorizontalAlignment();
        return $gIXBn.HorizontalAlignment.Left;
    };
    Object.defineProperty(CardElement.prototype, "hostConfig", {
        get: function() {
            if (this._hostConfig) return this._hostConfig;
            else {
                if (this.parent) return this.parent.hostConfig;
                else return $8kDQQ.defaultHostConfig;
            }
        },
        set: function(value) {
            this._hostConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "index", {
        get: function() {
            if (this.parent) return this.parent.indexOf(this);
            else return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isInteractive", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isStandalone", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isInline", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "hasVisibleSeparator", {
        get: function() {
            if (this.parent && this.separatorElement) return !this.parent.isFirstElement(this) && (this.isVisible || this.isDesignMode());
            else return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "separatorElement", {
        get: function() {
            return this._separatorElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    CardElement.langProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "lang", true, /^[a-z]{2,3}$/gi);
    CardElement.isVisibleProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "isVisible", true);
    CardElement.separatorProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "separator", false);
    CardElement.heightProperty = new $5Ougt.ValueSetProperty($5Ougt.Versions.v1_1, "height", [
        {
            value: "auto"
        },
        {
            value: "stretch"
        }
    ], "auto");
    CardElement.horizontalAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "horizontalAlignment", $gIXBn.HorizontalAlignment);
    CardElement.spacingProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "spacing", $gIXBn.Spacing, $gIXBn.Spacing.Default);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.horizontalAlignmentProperty)
    ], CardElement.prototype, "horizontalAlignment", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.spacingProperty)
    ], CardElement.prototype, "spacing", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.separatorProperty)
    ], CardElement.prototype, "separator", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.heightProperty)
    ], CardElement.prototype, "height", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.langProperty)
    ], CardElement.prototype, "lang", null);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.isVisibleProperty)
    ], CardElement.prototype, "isVisible", null);
    return CardElement;
}($dUjDB.CardObject);
module.exports.CardElement = $5104722604b983cb$var$CardElement;
var $5104722604b983cb$var$ActionProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ActionProperty, _super);
    function ActionProperty(targetVersion, name, forbiddenActionTypes) {
        if (forbiddenActionTypes === void 0) forbiddenActionTypes = [];
        var _this = _super.call(this, targetVersion, name, undefined) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.forbiddenActionTypes = forbiddenActionTypes;
        return _this;
    }
    ActionProperty.prototype.parse = function(sender, source, context) {
        var parent = sender;
        return context.parseAction(parent, source[this.name], this.forbiddenActionTypes, parent.isDesignMode());
    };
    ActionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
    };
    return ActionProperty;
}($5Ougt.PropertyDefinition);
module.exports.ActionProperty = $5104722604b983cb$var$ActionProperty;
var $5104722604b983cb$var$BaseTextBlock = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(BaseTextBlock, _super);
    function BaseTextBlock(text) {
        var _this = _super.call(this) || this;
        _this.ariaHidden = false;
        if (text) _this.text = text;
        return _this;
    }
    BaseTextBlock.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // selectAction is declared on BaseTextBlock but is only exposed on TextRun,
        // so the property is removed from the BaseTextBlock schema.
        schema.remove(BaseTextBlock.selectActionProperty);
    };
    Object.defineProperty(BaseTextBlock.prototype, "text", {
        get: function() {
            return this.getValue(BaseTextBlock.textProperty);
        },
        set: function(value) {
            this.setText(value);
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    BaseTextBlock.prototype.getFontSize = function(fontType) {
        switch(this.effectiveSize){
            case $gIXBn.TextSize.Small:
                return fontType.fontSizes.small;
            case $gIXBn.TextSize.Medium:
                return fontType.fontSizes.medium;
            case $gIXBn.TextSize.Large:
                return fontType.fontSizes.large;
            case $gIXBn.TextSize.ExtraLarge:
                return fontType.fontSizes.extraLarge;
            default:
                return fontType.fontSizes.default;
        }
    };
    BaseTextBlock.prototype.getColorDefinition = function(colorSet, color) {
        switch(color){
            case $gIXBn.TextColor.Accent:
                return colorSet.accent;
            case $gIXBn.TextColor.Dark:
                return colorSet.dark;
            case $gIXBn.TextColor.Light:
                return colorSet.light;
            case $gIXBn.TextColor.Good:
                return colorSet.good;
            case $gIXBn.TextColor.Warning:
                return colorSet.warning;
            case $gIXBn.TextColor.Attention:
                return colorSet.attention;
            default:
                return colorSet.default;
        }
    };
    BaseTextBlock.prototype.setText = function(value) {
        this.setValue(BaseTextBlock.textProperty, value);
    };
    BaseTextBlock.prototype.init = function(textDefinition) {
        this.size = textDefinition.size;
        this.weight = textDefinition.weight;
        this.color = textDefinition.color;
        this.isSubtle = textDefinition.isSubtle;
    };
    BaseTextBlock.prototype.asString = function() {
        return this.text;
    };
    BaseTextBlock.prototype.applyStylesTo = function(targetElement) {
        var fontType = this.hostConfig.getFontTypeDefinition(this.effectiveFontType);
        if (fontType.fontFamily) targetElement.style.fontFamily = fontType.fontFamily;
        var fontSize;
        switch(this.effectiveSize){
            case $gIXBn.TextSize.Small:
                fontSize = fontType.fontSizes.small;
                break;
            case $gIXBn.TextSize.Medium:
                fontSize = fontType.fontSizes.medium;
                break;
            case $gIXBn.TextSize.Large:
                fontSize = fontType.fontSizes.large;
                break;
            case $gIXBn.TextSize.ExtraLarge:
                fontSize = fontType.fontSizes.extraLarge;
                break;
            default:
                fontSize = fontType.fontSizes.default;
                break;
        }
        targetElement.style.fontSize = fontSize + "px";
        var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
        var targetColor = $F6YrP.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.subtle : colorDefinition.default);
        if (targetColor) targetElement.style.color = targetColor;
        var fontWeight;
        switch(this.effectiveWeight){
            case $gIXBn.TextWeight.Lighter:
                fontWeight = fontType.fontWeights.lighter;
                break;
            case $gIXBn.TextWeight.Bolder:
                fontWeight = fontType.fontWeights.bolder;
                break;
            default:
                fontWeight = fontType.fontWeights.default;
                break;
        }
        targetElement.style.fontWeight = fontWeight.toString();
        if (this.ariaHidden) targetElement.setAttribute("aria-hidden", "true");
    };
    BaseTextBlock.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.selectAction) result.push(this.selectAction);
        return result;
    };
    Object.defineProperty(BaseTextBlock.prototype, "effectiveColor", {
        get: function() {
            return this.color !== undefined ? this.color : this.getEffectiveTextStyleDefinition().color;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveFontType", {
        get: function() {
            return this.fontType !== undefined ? this.fontType : this.getEffectiveTextStyleDefinition().fontType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveIsSubtle", {
        get: function() {
            return this.isSubtle !== undefined ? this.isSubtle : this.getEffectiveTextStyleDefinition().isSubtle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveSize", {
        get: function() {
            return this.size !== undefined ? this.size : this.getEffectiveTextStyleDefinition().size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveWeight", {
        get: function() {
            return this.weight !== undefined ? this.weight : this.getEffectiveTextStyleDefinition().weight;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    BaseTextBlock.textProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "text", true);
    BaseTextBlock.sizeProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "size", $gIXBn.TextSize);
    BaseTextBlock.weightProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "weight", $gIXBn.TextWeight);
    BaseTextBlock.colorProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "color", $gIXBn.TextColor);
    BaseTextBlock.isSubtleProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "isSubtle");
    BaseTextBlock.fontTypeProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_2, "fontType", $gIXBn.FontType);
    BaseTextBlock.selectActionProperty = new $5104722604b983cb$var$ActionProperty($5Ougt.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.sizeProperty)
    ], BaseTextBlock.prototype, "size", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.weightProperty)
    ], BaseTextBlock.prototype, "weight", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.colorProperty)
    ], BaseTextBlock.prototype, "color", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.fontTypeProperty)
    ], BaseTextBlock.prototype, "fontType", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.isSubtleProperty)
    ], BaseTextBlock.prototype, "isSubtle", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.textProperty)
    ], BaseTextBlock.prototype, "text", null);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.selectActionProperty)
    ], BaseTextBlock.prototype, "selectAction", void 0);
    return BaseTextBlock;
}($5104722604b983cb$var$CardElement);
module.exports.BaseTextBlock = $5104722604b983cb$var$BaseTextBlock;
var $5104722604b983cb$var$TextBlock = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TextBlock, _super);
    function TextBlock() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrap = false;
        _this._treatAsPlainText = true;
        _this.useMarkdown = true;
        return _this;
    }
    TextBlock.prototype.restoreOriginalContent = function() {
        var _a, _b;
        if (this.renderedElement !== undefined) {
            if (this.maxLines && this.maxLines > 0) this.renderedElement.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
            var originalHtml = (_b = (_a = TextBlock._ttRoundtripPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._originalInnerHtml)) !== null && _b !== void 0 ? _b : this._originalInnerHtml;
            this.renderedElement.innerHTML = originalHtml;
        }
    };
    TextBlock.prototype.truncateIfSupported = function(maxHeight) {
        if (this.renderedElement !== undefined) {
            // For now, only truncate TextBlocks that contain just a single
            // paragraph -- since the maxLines calculation doesn't take into
            // account Markdown lists
            var children = this.renderedElement.children;
            var isTextOnly = !children.length;
            var truncationSupported = isTextOnly || children.length === 1 && children[0].tagName.toLowerCase() === "p" && !children[0].children.length;
            if (truncationSupported) {
                var element = isTextOnly ? this.renderedElement : children[0];
                $F6YrP.truncateText(element, maxHeight, this._computedLineHeight);
                return true;
            }
        }
        return false;
    };
    TextBlock.prototype.setText = function(value) {
        _super.prototype.setText.call(this, value);
        this._processedText = undefined;
    };
    TextBlock.prototype.internalRender = function() {
        var _this = this;
        var _a, _b;
        this._processedText = undefined;
        if (this.text) {
            var preProcessedText = this.preProcessPropertyValue($5104722604b983cb$var$BaseTextBlock.textProperty);
            var hostConfig = this.hostConfig;
            var element = void 0;
            if (this.forElementId) {
                var labelElement = document.createElement("label");
                labelElement.htmlFor = this.forElementId;
                element = labelElement;
            } else element = document.createElement("div");
            element.classList.add(hostConfig.makeCssClassName("ac-textBlock"));
            element.style.overflow = "hidden";
            this.applyStylesTo(element);
            if (this.style === "heading") {
                element.setAttribute("role", "heading");
                var headingLevel = this.hostConfig.textBlock.headingLevel;
                if (headingLevel !== undefined && headingLevel > 0) element.setAttribute("aria-level", headingLevel.toString());
            }
            if (this.selectAction && hostConfig.supportsInteractivity) {
                element.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(element);
                if (this.selectAction.isEffectivelyEnabled()) element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
            if (!this._processedText) {
                this._treatAsPlainText = true;
                var formattedText = $fuLKQ.formatText(this.lang, preProcessedText);
                if (this.useMarkdown && formattedText) {
                    if ($6BHj7.GlobalSettings.allowMarkForTextHighlighting) formattedText = formattedText.replace(/<mark>/g, "===").replace(/<\/mark>/g, "/==/");
                    var markdownProcessingResult = $5104722604b983cb$var$AdaptiveCard.applyMarkdown(formattedText);
                    if (markdownProcessingResult.didProcess && markdownProcessingResult.outputHtml) {
                        this._processedText = markdownProcessingResult.outputHtml;
                        this._treatAsPlainText = false;
                        // Only process <mark> tag if markdown processing was applied because
                        // markdown processing is also responsible for sanitizing the input string
                        if ($6BHj7.GlobalSettings.allowMarkForTextHighlighting && this._processedText) {
                            var markStyle = "";
                            var effectiveStyle = this.getEffectiveStyleDefinition();
                            if (effectiveStyle.highlightBackgroundColor) markStyle += "background-color: " + effectiveStyle.highlightBackgroundColor + ";";
                            if (effectiveStyle.highlightForegroundColor) markStyle += "color: " + effectiveStyle.highlightForegroundColor + ";";
                            if (markStyle) markStyle = 'style="' + markStyle + '"';
                            this._processedText = this._processedText.replace(/===/g, "<mark " + markStyle + ">").replace(/\/==\//g, "</mark>");
                        }
                    } else {
                        this._processedText = formattedText;
                        this._treatAsPlainText = true;
                    }
                } else {
                    this._processedText = formattedText;
                    this._treatAsPlainText = true;
                }
            }
            if (!this._processedText) this._processedText = "";
            if (this._treatAsPlainText) element.innerText = this._processedText;
            else {
                var processedHtml = (_b = (_a = TextBlock._ttMarkdownPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._processedText)) !== null && _b !== void 0 ? _b : this._processedText;
                element.innerHTML = processedHtml;
            }
            if (element.firstElementChild instanceof HTMLElement) {
                var firstElementChild = element.firstElementChild;
                firstElementChild.style.marginTop = "0px";
                firstElementChild.style.width = "100%";
                if (!this.wrap) {
                    firstElementChild.style.overflow = "hidden";
                    firstElementChild.style.textOverflow = "ellipsis";
                }
            }
            if (element.lastElementChild instanceof HTMLElement) element.lastElementChild.style.marginBottom = "0px";
            var anchors = element.getElementsByTagName("a");
            var _loop_1 = function(anchor) {
                anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
                anchor.target = "_blank";
                anchor.onclick = function(e) {
                    if ($5104722604b983cb$var$raiseAnchorClickedEvent(_this, anchor, e)) {
                        e.preventDefault();
                        e.cancelBubble = true;
                    }
                };
                anchor.oncontextmenu = function(e) {
                    if ($5104722604b983cb$var$raiseAnchorClickedEvent(_this, anchor, e)) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        return false;
                    }
                    return true;
                };
            };
            for(var _i = 0, _c = Array.from(anchors); _i < _c.length; _i++){
                var anchor = _c[_i];
                _loop_1(anchor);
            }
            if (this.wrap) {
                element.style.wordWrap = "break-word";
                if (this.maxLines && this.maxLines > 0) {
                    element.style.overflow = "hidden";
                    if ($F6YrP.isInternetExplorer() || !$6BHj7.GlobalSettings.useWebkitLineClamp) element.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
                    else {
                        // While non standard, --webkit-line-clamp works in every browser (except IE)
                        // and is a great solution to support the maxLines feature with ellipsis
                        // truncation. With --webkit-line-clamp there is need to use explicit line heights
                        element.style.removeProperty("line-height");
                        element.style.display = "-webkit-box";
                        element.style.webkitBoxOrient = "vertical";
                        element.style.webkitLineClamp = this.maxLines.toString();
                    }
                }
            } else {
                element.style.whiteSpace = "nowrap";
                element.style.textOverflow = "ellipsis";
            }
            if ($6BHj7.GlobalSettings.useAdvancedTextBlockTruncation || $6BHj7.GlobalSettings.useAdvancedCardBottomTruncation) this._originalInnerHtml = element.innerHTML;
            return element;
        } else return undefined;
    };
    TextBlock.prototype.truncateOverflow = function(maxHeight) {
        if (maxHeight >= this._computedLineHeight) return this.truncateIfSupported(maxHeight);
        return false;
    };
    TextBlock.prototype.undoOverflowTruncation = function() {
        this.restoreOriginalContent();
        if ($6BHj7.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines) {
            var maxHeight = this._computedLineHeight * this.maxLines;
            this.truncateIfSupported(maxHeight);
        }
    };
    TextBlock.prototype.applyStylesTo = function(targetElement) {
        _super.prototype.applyStylesTo.call(this, targetElement);
        switch(this.getEffectiveHorizontalAlignment()){
            case $gIXBn.HorizontalAlignment.Center:
                targetElement.style.textAlign = "center";
                break;
            case $gIXBn.HorizontalAlignment.Right:
                targetElement.style.textAlign = "end";
                break;
            default:
                targetElement.style.textAlign = "start";
                break;
        }
        var lineHeights = this.hostConfig.lineHeights;
        if (lineHeights) switch(this.effectiveSize){
            case $gIXBn.TextSize.Small:
                this._computedLineHeight = lineHeights.small;
                break;
            case $gIXBn.TextSize.Medium:
                this._computedLineHeight = lineHeights.medium;
                break;
            case $gIXBn.TextSize.Large:
                this._computedLineHeight = lineHeights.large;
                break;
            case $gIXBn.TextSize.ExtraLarge:
                this._computedLineHeight = lineHeights.extraLarge;
                break;
            default:
                this._computedLineHeight = lineHeights.default;
                break;
        }
        else // Looks like 1.33 is the magic number to compute line-height
        // from font size.
        this._computedLineHeight = this.getFontSize(this.hostConfig.getFontTypeDefinition(this.effectiveFontType)) * 1.33;
        targetElement.style.lineHeight = this._computedLineHeight + "px";
    };
    TextBlock.prototype.getJsonTypeName = function() {
        return "TextBlock";
    };
    TextBlock.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.style) return this.hostConfig.textStyles.getStyleByName(this.style);
        return _super.prototype.getEffectiveTextStyleDefinition.call(this);
    };
    TextBlock.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = false;
        _super.prototype.updateLayout.call(this, processChildren);
        if ($6BHj7.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines && this.isDisplayed()) {
            // Reset the element's innerHTML in case the available room for
            // content has increased
            this.restoreOriginalContent();
            this.truncateIfSupported(this._computedLineHeight * this.maxLines);
        }
    };
    var _a, _b;
    TextBlock.wrapProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "wrap", false);
    TextBlock.maxLinesProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_0, "maxLines");
    TextBlock.styleProperty = new $5Ougt.ValueSetProperty($5Ougt.Versions.v1_5, "style", [
        {
            value: "default"
        },
        {
            value: "columnHeader"
        },
        {
            value: "heading"
        }
    ]);
    // Markdown processing is handled outside of Adaptive Cards. It's up to the host to ensure that markdown is safely
    // processed.
    TextBlock._ttMarkdownPolicy = typeof window === 'undefined' ? undefined : (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.createPolicy("adaptivecards#markdownPassthroughPolicy", {
        createHTML: function(value) {
            return value;
        }
    });
    // When "advanced" truncation is enabled (see GlobalSettings.useAdvancedCardBottomTruncation and
    // GlobalSettings.useAdvancedTextBlockTruncation), we store the original pre-truncation content in
    // _originalInnerHtml so that we can restore/recalculate truncation later if space availability has changed (see
    // TextBlock.restoreOriginalContent())
    TextBlock._ttRoundtripPolicy = typeof window === 'undefined' ? undefined : (_b = window.trustedTypes) === null || _b === void 0 ? void 0 : _b.createPolicy("adaptivecards#restoreContentsPolicy", {
        createHTML: function(value) {
            return value;
        }
    });
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextBlock.wrapProperty)
    ], TextBlock.prototype, "wrap", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextBlock.maxLinesProperty)
    ], TextBlock.prototype, "maxLines", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextBlock.styleProperty)
    ], TextBlock.prototype, "style", void 0);
    return TextBlock;
}($5104722604b983cb$var$BaseTextBlock);
module.exports.TextBlock = $5104722604b983cb$var$TextBlock;
var $5104722604b983cb$var$TextRun = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TextRun, _super);
    function TextRun() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.italic = false;
        _this.strikethrough = false;
        _this.highlight = false;
        _this.underline = false;
        return _this;
    }
    TextRun.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.add($5104722604b983cb$var$BaseTextBlock.selectActionProperty);
    };
    //#endregion
    TextRun.prototype.internalRender = function() {
        var _this = this;
        if (this.text) {
            var preProcessedText = this.preProcessPropertyValue($5104722604b983cb$var$BaseTextBlock.textProperty);
            var hostConfig = this.hostConfig;
            var formattedText = $fuLKQ.formatText(this.lang, preProcessedText);
            if (!formattedText) formattedText = "";
            var element = document.createElement("span");
            element.classList.add(hostConfig.makeCssClassName("ac-textRun"));
            this.applyStylesTo(element);
            if (this.selectAction && hostConfig.supportsInteractivity) {
                var anchor = document.createElement("a");
                anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
                var href = this.selectAction.getHref();
                anchor.href = href ? href : "";
                anchor.target = "_blank";
                anchor.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(anchor);
                anchor.innerText = formattedText;
                element.appendChild(anchor);
            } else element.innerText = formattedText;
            return element;
        } else return undefined;
    };
    TextRun.prototype.applyStylesTo = function(targetElement) {
        _super.prototype.applyStylesTo.call(this, targetElement);
        if (this.italic) targetElement.style.fontStyle = "italic";
        if (this.strikethrough) targetElement.style.textDecoration = "line-through";
        if (this.highlight) {
            var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
            var backgroundColor = $F6YrP.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.highlightColors.subtle : colorDefinition.highlightColors.default);
            if (backgroundColor) targetElement.style.backgroundColor = backgroundColor;
        }
        if (this.underline) targetElement.style.textDecoration = "underline";
    };
    TextRun.prototype.getJsonTypeName = function() {
        return "TextRun";
    };
    Object.defineProperty(TextRun.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextRun.prototype, "isInline", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    TextRun.italicProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "italic", false);
    TextRun.strikethroughProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "strikethrough", false);
    TextRun.highlightProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "highlight", false);
    TextRun.underlineProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_3, "underline", false);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextRun.italicProperty)
    ], TextRun.prototype, "italic", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextRun.strikethroughProperty)
    ], TextRun.prototype, "strikethrough", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextRun.highlightProperty)
    ], TextRun.prototype, "highlight", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextRun.underlineProperty)
    ], TextRun.prototype, "underline", void 0);
    return TextRun;
}($5104722604b983cb$var$BaseTextBlock);
module.exports.TextRun = $5104722604b983cb$var$TextRun;
var $5104722604b983cb$var$RichTextBlock = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(RichTextBlock, _super);
    function RichTextBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._inlines = [];
        return _this;
    }
    RichTextBlock.prototype.internalAddInline = function(inline, forceAdd) {
        if (forceAdd === void 0) forceAdd = false;
        if (!inline.isInline) throw new Error($24F6S.Strings.errors.elementCannotBeUsedAsInline());
        var doAdd = inline.parent === undefined || forceAdd;
        if (!doAdd && inline.parent !== this) throw new Error($24F6S.Strings.errors.inlineAlreadyParented());
        else {
            inline.setParent(this);
            this._inlines.push(inline);
        }
    };
    RichTextBlock.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._inlines = [];
        if (Array.isArray(source["inlines"])) for(var _i = 0, _a = source["inlines"]; _i < _a.length; _i++){
            var jsonInline = _a[_i];
            var inline = void 0;
            if (typeof jsonInline === "string") {
                var textRun = new $5104722604b983cb$var$TextRun();
                textRun.text = jsonInline;
                inline = textRun;
            } else // No fallback for inlines in 1.2
            inline = context.parseElement(this, jsonInline, [], false);
            if (inline) this.internalAddInline(inline, true);
        }
    };
    RichTextBlock.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        if (this._inlines.length > 0) {
            var jsonInlines = [];
            for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
                var inline = _a[_i];
                jsonInlines.push(inline.toJSON(context));
            }
            context.serializeValue(target, "inlines", jsonInlines);
        }
    };
    RichTextBlock.prototype.internalRender = function() {
        if (this._inlines.length > 0) {
            var element = void 0;
            if (this.forElementId) {
                var labelElement = document.createElement("label");
                labelElement.htmlFor = this.forElementId;
                element = labelElement;
            } else element = document.createElement("div");
            element.className = this.hostConfig.makeCssClassName("ac-richTextBlock");
            switch(this.getEffectiveHorizontalAlignment()){
                case $gIXBn.HorizontalAlignment.Center:
                    element.style.textAlign = "center";
                    break;
                case $gIXBn.HorizontalAlignment.Right:
                    element.style.textAlign = "end";
                    break;
                default:
                    element.style.textAlign = "start";
                    break;
            }
            var renderedInlines = 0;
            for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
                var inline = _a[_i];
                var renderedInline = inline.render();
                if (renderedInline) {
                    element.appendChild(renderedInline);
                    renderedInlines++;
                }
            }
            if (renderedInlines > 0) return element;
        }
        return undefined;
    };
    RichTextBlock.prototype.asString = function() {
        var result = "";
        for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
            var inline = _a[_i];
            result += inline.asString();
        }
        return result;
    };
    RichTextBlock.prototype.getJsonTypeName = function() {
        return "RichTextBlock";
    };
    RichTextBlock.prototype.getInlineCount = function() {
        return this._inlines.length;
    };
    RichTextBlock.prototype.getInlineAt = function(index) {
        if (index >= 0 && index < this._inlines.length) return this._inlines[index];
        else throw new Error($24F6S.Strings.errors.indexOutOfRange(index));
    };
    RichTextBlock.prototype.addInline = function(inline) {
        if (typeof inline === "string") this.internalAddInline(new $5104722604b983cb$var$TextRun(inline));
        else this.internalAddInline(inline);
    };
    RichTextBlock.prototype.removeInline = function(inline) {
        var index = this._inlines.indexOf(inline);
        if (index >= 0) {
            this._inlines[index].setParent(undefined);
            this._inlines.splice(index, 1);
            return true;
        }
        return false;
    };
    return RichTextBlock;
}($5104722604b983cb$var$CardElement);
module.exports.RichTextBlock = $5104722604b983cb$var$RichTextBlock;
var $5104722604b983cb$var$Fact = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Fact, _super);
    function Fact(name, value) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    //#endregion
    Fact.prototype.getSchemaKey = function() {
        return "Fact";
    };
    //#region Schema
    Fact.titleProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "title");
    Fact.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Fact.titleProperty)
    ], Fact.prototype, "name", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Fact.valueProperty)
    ], Fact.prototype, "value", void 0);
    return Fact;
}($5Ougt.SerializableObject);
module.exports.Fact = $5104722604b983cb$var$Fact;
var $5104722604b983cb$var$FactSet = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(FactSet, _super);
    function FactSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FactSet.prototype, "useDefaultSizing", {
        //#endregion
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    FactSet.prototype.internalRender = function() {
        var element = undefined;
        var hostConfig = this.hostConfig;
        if (this.facts.length > 0) {
            element = document.createElement("table");
            element.style.borderWidth = "0px";
            element.style.borderSpacing = "0px";
            element.style.borderStyle = "none";
            element.style.borderCollapse = "collapse";
            element.style.display = "block";
            element.style.overflow = "hidden";
            element.classList.add(hostConfig.makeCssClassName("ac-factset"));
            element.setAttribute("role", "presentation");
            for(var i = 0; i < this.facts.length; i++){
                var trElement = document.createElement("tr");
                if (i > 0) trElement.style.marginTop = hostConfig.factSet.spacing + "px";
                // Title column
                var tdElement = document.createElement("td");
                tdElement.style.padding = "0";
                tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-title"));
                if (hostConfig.factSet.title.maxWidth) tdElement.style.maxWidth = hostConfig.factSet.title.maxWidth + "px";
                tdElement.style.verticalAlign = "top";
                var textBlock = new $5104722604b983cb$var$TextBlock();
                textBlock.setParent(this);
                textBlock.text = !this.facts[i].name && this.isDesignMode() ? "Title" : this.facts[i].name;
                textBlock.size = hostConfig.factSet.title.size;
                textBlock.color = hostConfig.factSet.title.color;
                textBlock.isSubtle = hostConfig.factSet.title.isSubtle;
                textBlock.weight = hostConfig.factSet.title.weight;
                textBlock.wrap = hostConfig.factSet.title.wrap;
                textBlock.spacing = $gIXBn.Spacing.None;
                $F6YrP.appendChild(tdElement, textBlock.render());
                $F6YrP.appendChild(trElement, tdElement);
                // Spacer column
                tdElement = document.createElement("td");
                tdElement.style.width = "10px";
                $F6YrP.appendChild(trElement, tdElement);
                // Value column
                tdElement = document.createElement("td");
                tdElement.style.padding = "0";
                tdElement.style.verticalAlign = "top";
                tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-value"));
                textBlock = new $5104722604b983cb$var$TextBlock();
                textBlock.setParent(this);
                textBlock.text = this.facts[i].value;
                textBlock.size = hostConfig.factSet.value.size;
                textBlock.color = hostConfig.factSet.value.color;
                textBlock.isSubtle = hostConfig.factSet.value.isSubtle;
                textBlock.weight = hostConfig.factSet.value.weight;
                textBlock.wrap = hostConfig.factSet.value.wrap;
                textBlock.spacing = $gIXBn.Spacing.None;
                $F6YrP.appendChild(tdElement, textBlock.render());
                $F6YrP.appendChild(trElement, tdElement);
                $F6YrP.appendChild(element, trElement);
            }
        }
        return element;
    };
    FactSet.prototype.getJsonTypeName = function() {
        return "FactSet";
    };
    //#region Schema
    FactSet.factsProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_0, "facts", $5104722604b983cb$var$Fact);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(FactSet.factsProperty)
    ], FactSet.prototype, "facts", void 0);
    return FactSet;
}($5104722604b983cb$var$CardElement);
module.exports.FactSet = $5104722604b983cb$var$FactSet;
var $5104722604b983cb$var$ImageDimensionProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ImageDimensionProperty, _super);
    function ImageDimensionProperty(targetVersion, name, internalName, fallbackProperty) {
        var _this = _super.call(this, targetVersion, name) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.internalName = internalName;
        _this.fallbackProperty = fallbackProperty;
        return _this;
    }
    ImageDimensionProperty.prototype.getInternalName = function() {
        return this.internalName;
    };
    ImageDimensionProperty.prototype.parse = function(sender, source, context) {
        var result = undefined;
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.defaultValue;
        var isValid = false;
        if (typeof sourceValue === "string") {
            try {
                var size = $6BHj7.SizeAndUnit.parse(sourceValue, true);
                if (size.unit === $gIXBn.SizeUnit.Pixel) {
                    result = size.physicalSize;
                    isValid = true;
                }
            } catch (_a) {
            // Swallow the exception
            }
            // If the source value isn't valid per this property definition,
            // check its validity per the fallback property, if specified
            if (!isValid && this.fallbackProperty) isValid = this.fallbackProperty.isValidValue(sourceValue, context);
        }
        if (!isValid) context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return result;
    };
    ImageDimensionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, typeof value === "number" && !isNaN(value) ? value + "px" : undefined);
    };
    return ImageDimensionProperty;
}($5Ougt.PropertyDefinition);
var $5104722604b983cb$var$Image = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Image, _super);
    function Image() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.size = $gIXBn.Size.Auto;
        _this.style = $gIXBn.ImageStyle.Default;
        return _this;
    }
    Image.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.remove($5104722604b983cb$var$CardElement.heightProperty);
    };
    //#endregion
    Image.prototype.applySize = function(element) {
        if (this.pixelWidth || this.pixelHeight) {
            if (this.pixelWidth) element.style.width = this.pixelWidth + "px";
            if (this.pixelHeight) element.style.height = this.pixelHeight + "px";
        } else if (this.maxHeight) {
            // If the image is constrained in height, we set its height property and
            // auto and stretch are ignored (default to medium). THis is necessary for
            // ImageSet which uses a maximum image height as opposed to the cards width
            // as a constraining dimension
            switch(this.size){
                case $gIXBn.Size.Small:
                    element.style.height = this.hostConfig.imageSizes.small + "px";
                    break;
                case $gIXBn.Size.Large:
                    element.style.height = this.hostConfig.imageSizes.large + "px";
                    break;
                default:
                    element.style.height = this.hostConfig.imageSizes.medium + "px";
                    break;
            }
            element.style.maxHeight = this.maxHeight + "px";
        } else {
            switch(this.size){
                case $gIXBn.Size.Stretch:
                    element.style.width = "100%";
                    break;
                case $gIXBn.Size.Auto:
                    element.style.maxWidth = "100%";
                    break;
                case $gIXBn.Size.Small:
                    element.style.width = this.hostConfig.imageSizes.small + "px";
                    break;
                case $gIXBn.Size.Large:
                    element.style.width = this.hostConfig.imageSizes.large + "px";
                    break;
                case $gIXBn.Size.Medium:
                    element.style.width = this.hostConfig.imageSizes.medium + "px";
                    break;
            }
            element.style.maxHeight = "100%";
        }
    };
    Object.defineProperty(Image.prototype, "useDefaultSizing", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Image.prototype.internalRender = function() {
        var _this = this;
        var element = undefined;
        if (this.url) {
            element = document.createElement("div");
            element.style.display = "flex";
            element.style.alignItems = "flex-start";
            // Cache hostConfig to avoid walking the parent hierarchy multiple times
            var hostConfig = this.hostConfig;
            switch(this.getEffectiveHorizontalAlignment()){
                case $gIXBn.HorizontalAlignment.Center:
                    element.style.justifyContent = "center";
                    break;
                case $gIXBn.HorizontalAlignment.Right:
                    element.style.justifyContent = "flex-end";
                    break;
                default:
                    element.style.justifyContent = "flex-start";
                    break;
            }
            var imageElement = document.createElement("img");
            this.renderedImageElement = imageElement;
            imageElement.onload = function(_e) {
                $5104722604b983cb$var$raiseImageLoadedEvent(_this);
            };
            imageElement.onerror = function(_e) {
                if (_this.renderedElement) {
                    var card = _this.getRootElement();
                    $5104722604b983cb$var$clearElement(_this.renderedElement);
                    if (card && card.designMode) {
                        var errorElement = document.createElement("div");
                        errorElement.style.display = "flex";
                        errorElement.style.alignItems = "center";
                        errorElement.style.justifyContent = "center";
                        errorElement.style.backgroundColor = "#EEEEEE";
                        errorElement.style.color = "black";
                        errorElement.innerText = ":-(";
                        errorElement.style.padding = "10px";
                        _this.applySize(errorElement);
                        _this.renderedElement.appendChild(errorElement);
                    }
                }
                $5104722604b983cb$var$raiseImageLoadedEvent(_this);
            };
            imageElement.style.minWidth = "0";
            imageElement.classList.add(hostConfig.makeCssClassName("ac-image"));
            if (this.selectAction && hostConfig.supportsInteractivity) {
                imageElement.onkeypress = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
                        // enter or space pressed
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                imageElement.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(imageElement);
                if (this.selectAction.isEffectivelyEnabled()) imageElement.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
            this.applySize(imageElement);
            if (this.style === $gIXBn.ImageStyle.Person) {
                imageElement.style.borderRadius = "50%";
                imageElement.style.backgroundPosition = "50% 50%";
                imageElement.style.backgroundRepeat = "no-repeat";
            }
            var backgroundColor = $F6YrP.stringToCssColor(this.backgroundColor);
            if (backgroundColor) imageElement.style.backgroundColor = backgroundColor;
            this.setImageSource(imageElement);
            var altTextProperty = this.preProcessPropertyValue(Image.altTextProperty);
            if (altTextProperty) imageElement.alt = altTextProperty;
            element.appendChild(imageElement);
        }
        return element;
    };
    Image.prototype.getJsonTypeName = function() {
        return "Image";
    };
    Image.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.selectAction) result.push(this.selectAction);
        return result;
    };
    Image.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result && this.selectAction) result = this.selectAction.getActionById(id);
        return result;
    };
    Image.prototype.getResourceInformation = function() {
        return this.url ? [
            {
                url: this.url,
                mimeType: "image"
            }
        ] : [];
    };
    Image.prototype.setImageSource = function(imageElement) {
        var imageForceLoader = new $5104722604b983cb$var$ImageForceLoader(this.forceLoad, this.url);
        imageForceLoader.configureImage(this);
        imageElement.src = this.preProcessPropertyValue(Image.urlProperty);
        imageForceLoader.resetImage(this);
    };
    Image.urlProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "url");
    Image.altTextProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "altText");
    Image.backgroundColorProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "backgroundColor");
    Image.styleProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "style", $gIXBn.ImageStyle, $gIXBn.ImageStyle.Default);
    Image.sizeProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "size", $gIXBn.Size, $gIXBn.Size.Auto);
    Image.pixelWidthProperty = new $5104722604b983cb$var$ImageDimensionProperty($5Ougt.Versions.v1_1, "width", "pixelWidth");
    Image.pixelHeightProperty = new $5104722604b983cb$var$ImageDimensionProperty($5Ougt.Versions.v1_1, "height", "pixelHeight", $5104722604b983cb$var$CardElement.heightProperty);
    Image.selectActionProperty = new $5104722604b983cb$var$ActionProperty($5Ougt.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    Image.shouldForceLoadProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_6, "forceLoad", false);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.urlProperty)
    ], Image.prototype, "url", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.altTextProperty)
    ], Image.prototype, "altText", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.backgroundColorProperty)
    ], Image.prototype, "backgroundColor", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.sizeProperty)
    ], Image.prototype, "size", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.styleProperty)
    ], Image.prototype, "style", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.pixelWidthProperty)
    ], Image.prototype, "pixelWidth", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.pixelHeightProperty)
    ], Image.prototype, "pixelHeight", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.selectActionProperty)
    ], Image.prototype, "selectAction", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.shouldForceLoadProperty)
    ], Image.prototype, "forceLoad", void 0);
    return Image;
}($5104722604b983cb$var$CardElement);
module.exports.Image = $5104722604b983cb$var$Image;
// configures Image element to fetch a new image data from url source instead of relying on cache
// currently rudimentary refreshing scheme is used
// by attaching unique query string to url, we bypass the cache usage
var $5104722604b983cb$var$ImageForceLoader = /** @class */ function() {
    function ImageForceLoader(doForceLoad, url) {
        this.doForceLoad = doForceLoad;
        this.url = url;
        if (url && url.length && doForceLoad) {
            // we can do better by appending unique key such as uuid instead of epoch
            // however the current usage is for front-end ui and networking,  
            // since ui is running in single main thread, this is sufficient mechanism
            // without needing to depend on external library for our small use cases.
            this.uniqueHash = '?' + Date.now();
            this.urlWithForceLoadOption = url + this.uniqueHash;
        }
    }
    ImageForceLoader.prototype.configureImage = function(image) {
        if (this.urlWithForceLoadOption && this.urlWithForceLoadOption.length) image.url = this.urlWithForceLoadOption;
    };
    ImageForceLoader.prototype.resetImage = function(image) {
        image.url = this.url;
    };
    return ImageForceLoader;
}();
var $5104722604b983cb$var$CardElementContainer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(CardElementContainer, _super);
    function CardElementContainer() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowVerticalOverflow = false;
        return _this;
    }
    CardElementContainer.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        if (!this.isSelectable) schema.remove(CardElementContainer.selectActionProperty);
    };
    //#endregion
    CardElementContainer.prototype.isElementAllowed = function(element) {
        return this.hostConfig.supportsInteractivity || !element.isInteractive;
    };
    CardElementContainer.prototype.applyPadding = function() {
        _super.prototype.applyPadding.call(this);
        if (!this.renderedElement) return;
        var physicalPadding = new $6BHj7.SpacingDefinition();
        if (this.getEffectivePadding()) physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
        this.renderedElement.style.paddingTop = physicalPadding.top + "px";
        this.renderedElement.style.paddingRight = physicalPadding.right + "px";
        this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
        this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
        this.renderedElement.style.marginRight = "0";
        this.renderedElement.style.marginLeft = "0";
    };
    Object.defineProperty(CardElementContainer.prototype, "isSelectable", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CardElementContainer.prototype.forbiddenChildElements = function() {
        return [];
    };
    CardElementContainer.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).releaseDOMResources();
    };
    CardElementContainer.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        for(var i = 0; i < this.getItemCount(); i++){
            var item = this.getItemAt(i);
            if (!this.hostConfig.supportsInteractivity && item.isInteractive) context.addFailure(this, $gIXBn.ValidationEvent.InteractivityNotAllowed, $24F6S.Strings.errors.interactivityNotAllowed());
            if (!this.isElementAllowed(item)) context.addFailure(this, $gIXBn.ValidationEvent.InteractivityNotAllowed, $24F6S.Strings.errors.elementTypeNotAllowed(item.getJsonTypeName()));
            item.internalValidateProperties(context);
        }
        if (this._selectAction) this._selectAction.internalValidateProperties(context);
    };
    CardElementContainer.prototype.render = function() {
        var _this = this;
        var element = _super.prototype.render.call(this);
        if (element) {
            var hostConfig = this.hostConfig;
            if (this.allowVerticalOverflow) {
                element.style.overflowX = "hidden";
                element.style.overflowY = "auto";
            }
            if (element && this.isSelectable && this._selectAction && hostConfig.supportsInteractivity) {
                element.onclick = function(e) {
                    if (_this._selectAction && _this._selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this._selectAction.execute();
                    }
                };
                element.onkeypress = function(e) {
                    if (_this._selectAction && _this._selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
                        // Enter or space pressed
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this._selectAction.execute();
                    }
                };
                this._selectAction.setupElementForAccessibility(element);
                if (this._selectAction.isEffectivelyEnabled()) element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
        }
        return element;
    };
    CardElementContainer.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = true;
        _super.prototype.updateLayout.call(this, processChildren);
        if (processChildren) for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).updateLayout();
    };
    CardElementContainer.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = [];
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getAllInputs(processActions));
        return result;
    };
    CardElementContainer.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getAllActions());
        if (this._selectAction) result.push(this._selectAction);
        return result;
    };
    CardElementContainer.prototype.getResourceInformation = function() {
        var result = [];
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getResourceInformation());
        return result;
    };
    CardElementContainer.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) for(var i = 0; i < this.getItemCount(); i++){
            result = this.getItemAt(i).getElementById(id);
            if (result) break;
        }
        return result;
    };
    /**
     * @inheritdoc
     */ CardElementContainer.prototype.findDOMNodeOwner = function(node) {
        var _a;
        var target = undefined;
        for(var i = 0; i < this.getItemCount(); i++){
            // recur through child elements
            target = this.getItemAt(i).findDOMNodeOwner(node);
            if (target) return target;
        }
        // If not found in children, check the actions
        for(var i = 0; i < this.getActionCount(); i++){
            target = (_a = this.getActionAt(i)) === null || _a === void 0 ? void 0 : _a.findDOMNodeOwner(node);
            if (target) return target;
        }
        // if not found in children or actions, defer to parent implementation
        return _super.prototype.findDOMNodeOwner.call(this, node);
    };
    CardElementContainer.selectActionProperty = new $5104722604b983cb$var$ActionProperty($5Ougt.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElementContainer.selectActionProperty)
    ], CardElementContainer.prototype, "_selectAction", void 0);
    return CardElementContainer;
}($5104722604b983cb$var$CardElement);
module.exports.CardElementContainer = $5104722604b983cb$var$CardElementContainer;
var $5104722604b983cb$var$ImageSet = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ImageSet, _super);
    function ImageSet() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._images = [];
        _this.imageSize = $gIXBn.ImageSize.Medium;
        _this.presentationStyle = $gIXBn.ImageSetPresentationStyle.Default;
        _this.pixelOffset = 0;
        return _this;
    }
    //#endregion
    ImageSet.prototype.internalRender = function() {
        var element = undefined;
        if (this._images.length > 0) {
            element = document.createElement("div");
            element.style.display = "flex";
            element.style.flexWrap = "wrap";
            for(var _i = 0, _a = this._images; _i < _a.length; _i++){
                var image = _a[_i];
                switch(this.imageSize){
                    case $gIXBn.ImageSize.Small:
                        image.size = $gIXBn.Size.Small;
                        break;
                    case $gIXBn.ImageSize.Large:
                        image.size = $gIXBn.Size.Large;
                        break;
                    default:
                        image.size = $gIXBn.Size.Medium;
                        break;
                }
                image.maxHeight = this.hostConfig.imageSet.maxImageHeight;
                var renderedImage = image.render();
                if (renderedImage) {
                    renderedImage.style.display = "inline-flex";
                    renderedImage.style.margin = "0px";
                    if (this.presentationStyle == $gIXBn.ImageSetPresentationStyle.Default) renderedImage.style.marginRight = "10px";
                    $F6YrP.appendChild(element, renderedImage);
                }
            }
            if (this.presentationStyle == $gIXBn.ImageSetPresentationStyle.Stacked) this.applyStackedPresentationStyle();
        }
        return element;
    };
    ImageSet.prototype.applyStackedPresentationStyle = function() {
        if (this._images[0].renderedImageElement) {
            var dimension = $5104722604b983cb$var$StackedImageConfigurator.parseNumericPixelDimension(this._images[0].renderedImageElement.style.height);
            var bgColor = this.getEffectiveBackgroundColor();
            if (dimension) {
                var stackedImageConfigurator = new $5104722604b983cb$var$StackedImageConfigurator(this.pixelOffset, dimension, bgColor);
                stackedImageConfigurator.configureImagesArrayAsStackedLayout(this._images);
            }
        }
    };
    ImageSet.prototype.getEffectiveBackgroundColor = function() {
        var parentContainer = this.getParentContainer();
        var style = parentContainer === null || parentContainer === void 0 ? void 0 : parentContainer.getEffectiveStyle();
        var styleDefinition = this.hostConfig.containerStyles.getStyleByName(style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
        return $F6YrP.stringToCssColor(styleDefinition.backgroundColor);
    };
    ImageSet.prototype.getItemCount = function() {
        return this._images.length;
    };
    ImageSet.prototype.getItemAt = function(index) {
        return this._images[index];
    };
    ImageSet.prototype.getFirstVisibleRenderedItem = function() {
        return this._images && this._images.length > 0 ? this._images[0] : undefined;
    };
    ImageSet.prototype.getLastVisibleRenderedItem = function() {
        return this._images && this._images.length > 0 ? this._images[this._images.length - 1] : undefined;
    };
    ImageSet.prototype.removeItem = function(item) {
        if (item instanceof $5104722604b983cb$var$Image) {
            var itemIndex = this._images.indexOf(item);
            if (itemIndex >= 0) {
                this._images.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    ImageSet.prototype.getJsonTypeName = function() {
        return "ImageSet";
    };
    ImageSet.prototype.addImage = function(image) {
        if (!image.parent) {
            this._images.push(image);
            image.setParent(this);
        } else throw new Error("This image already belongs to another ImageSet");
    };
    ImageSet.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $5104722604b983cb$var$Image ? this._images.indexOf(cardElement) : -1;
    };
    ImageSet.imagesProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_0, "images", $5104722604b983cb$var$Image, function(sender, item) {
        item.setParent(sender);
    });
    ImageSet.imageSizeProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "imageSize", $gIXBn.ImageSize, $gIXBn.ImageSize.Medium);
    ImageSet.imagePresentationStyle = new $5Ougt.EnumProperty($5Ougt.Versions.v1_6, "style", $gIXBn.ImageSetPresentationStyle, $gIXBn.ImageSetPresentationStyle.Default);
    ImageSet.pixelOffset = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "offset", 0, undefined);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ImageSet.imagesProperty)
    ], ImageSet.prototype, "_images", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ImageSet.imageSizeProperty)
    ], ImageSet.prototype, "imageSize", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ImageSet.imagePresentationStyle)
    ], ImageSet.prototype, "presentationStyle", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ImageSet.pixelOffset)
    ], ImageSet.prototype, "pixelOffset", void 0);
    return ImageSet;
}($5104722604b983cb$var$CardElementContainer);
module.exports.ImageSet = $5104722604b983cb$var$ImageSet;
var $5104722604b983cb$var$StackedImageConfigurator = /** @class */ function() {
    function StackedImageConfigurator(offset, dimension, style) {
        this.sign45 = 0.7071;
        this.maxImageCounts = 2;
        this.offset = 0;
        this.normalizationConstant = 0;
        this.border = 5;
        this.dimension = 0;
        this.dimension = dimension;
        this.normalizationConstant = (dimension * this.sign45 - 0.5 * dimension) * 2;
        // offset determines how far images are placed from each other
        // at zero, images are separated only by the border
        // there is no restriction on how far they are apart in positive values, their actual
        // positioning is limited by maximum size imposed by Image renderer
        // a negative value can decrease upto the diameter of the image since a value less than the diameter
        // put the images past each other, and the use of such value is not reasonable request
        // users should change image positions in such case.
        this.offset = this.sign45 * (Math.max(offset, -dimension) - this.normalizationConstant);
        this.style = style ? style : "";
    }
    StackedImageConfigurator.prototype.moveImageRight = function(element) {
        element.style.marginLeft = this.offset + "px";
    };
    StackedImageConfigurator.prototype.moveImageUp = function(element) {
        element.style.marginBottom = this.offset + this.dimension + "px";
    };
    StackedImageConfigurator.prototype.moveImageDown = function(element) {
        element.style.marginTop = this.offset + this.dimension + "px";
    };
    StackedImageConfigurator.prototype.makeImageRound = function(element) {
        element.style.borderRadius = "50%";
        element.style.backgroundPosition = "50% 50%";
        element.style.backgroundRepeat = "no-repeat";
    };
    StackedImageConfigurator.prototype.applyBorder = function(element) {
        element.style.height = this.dimension + this.border * 2 + "px";
        element.style.border = this.border + "px" + " solid " + this.style;
    };
    StackedImageConfigurator.prototype.configureImageForBottomLeft = function(element) {
        this.moveImageDown(element);
        this.makeImageRound(element);
        this.applyBorder(element);
        element.style.zIndex = "2";
    };
    StackedImageConfigurator.prototype.configureImageForTopRight = function(element) {
        this.moveImageUp(element);
        this.moveImageRight(element);
        this.makeImageRound(element);
        element.style.zIndex = "1";
    };
    // stacked layout is applied when there are two images in ImageSet,
    // first image in the ImageSet is put bottom left of ImageSet,
    // second image is placed top right diagonally to the first image at 45 angle
    // first image is placed over the second image should the overlap to occur.
    StackedImageConfigurator.prototype.configureImagesArrayAsStackedLayout = function(elements) {
        if (elements.length == 1) {
            if (elements[0].renderedImageElement) this.makeImageRound(elements[0].renderedImageElement);
        } else if (elements.length <= this.maxImageCounts) {
            if (elements[0].renderedImageElement && elements[1].renderedImageElement) {
                this.configureImageForBottomLeft(elements[0].renderedImageElement);
                this.configureImageForTopRight(elements[1].renderedImageElement);
            }
        }
    };
    StackedImageConfigurator.parseNumericPixelDimension = function(dimension) {
        if ((dimension === null || dimension === void 0 ? void 0 : dimension.substring(dimension.length - 2)) == 'px') return parseInt(dimension.substring(0, dimension.length - 2));
        return undefined;
    };
    return StackedImageConfigurator;
}();
var $5104722604b983cb$var$ContentSource = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ContentSource, _super);
    //#endregion
    function ContentSource(url, mimeType) {
        var _this = _super.call(this) || this;
        _this.url = url;
        _this.mimeType = mimeType;
        return _this;
    }
    ContentSource.prototype.isValid = function() {
        return this.mimeType && this.url ? true : false;
    };
    //#region Schema
    ContentSource.mimeTypeProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "mimeType");
    ContentSource.urlProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "url");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ContentSource.mimeTypeProperty)
    ], ContentSource.prototype, "mimeType", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ContentSource.urlProperty)
    ], ContentSource.prototype, "url", void 0);
    return ContentSource;
}($5Ougt.SerializableObject);
module.exports.ContentSource = $5104722604b983cb$var$ContentSource;
var $5104722604b983cb$var$CaptionSource = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(CaptionSource, _super);
    //#endregion
    function CaptionSource(url, mimeType, label) {
        var _this = _super.call(this, url, mimeType) || this;
        _this.label = label;
        return _this;
    }
    CaptionSource.prototype.getSchemaKey = function() {
        return "CaptionSource";
    };
    CaptionSource.prototype.render = function() {
        var result = undefined;
        if (this.isValid()) {
            result = document.createElement("track");
            result.src = this.url;
            result.kind = "captions";
            result.label = this.label;
        }
        return result;
    };
    //#region Schema
    CaptionSource.labelProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_6, "label");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CaptionSource.labelProperty)
    ], CaptionSource.prototype, "label", void 0);
    return CaptionSource;
}($5104722604b983cb$var$ContentSource);
module.exports.CaptionSource = $5104722604b983cb$var$CaptionSource;
var $5104722604b983cb$var$MediaSource = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(MediaSource, _super);
    function MediaSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaSource.prototype.getSchemaKey = function() {
        return "MediaSource";
    };
    MediaSource.prototype.render = function() {
        var result = undefined;
        if (this.isValid()) {
            result = document.createElement("source");
            result.src = this.url;
            result.type = this.mimeType;
        }
        return result;
    };
    return MediaSource;
}($5104722604b983cb$var$ContentSource);
module.exports.MediaSource = $5104722604b983cb$var$MediaSource;
var $5104722604b983cb$var$MediaPlayer = /** @class */ function() {
    function MediaPlayer() {}
    MediaPlayer.prototype.play = function() {
    // Do nothing in base implementation
    };
    Object.defineProperty(MediaPlayer.prototype, "posterUrl", {
        get: function() {
            return this._posterUrl;
        },
        set: function(value) {
            this._posterUrl = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaPlayer.prototype, "selectedMediaType", {
        get: function() {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    return MediaPlayer;
}();
module.exports.MediaPlayer = $5104722604b983cb$var$MediaPlayer;
var $5104722604b983cb$var$HTML5MediaPlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(HTML5MediaPlayer, _super);
    function HTML5MediaPlayer(owner) {
        var _this = _super.call(this) || this;
        _this.owner = owner;
        _this._selectedSources = [];
        _this._captionSources = [];
        _this.processSources();
        return _this;
    }
    HTML5MediaPlayer.prototype.processSources = function() {
        var _a;
        this._selectedSources = [];
        this._captionSources = [];
        this._selectedMediaType = undefined;
        for(var _i = 0, _b = this.owner.sources; _i < _b.length; _i++){
            var source = _b[_i];
            var mimeComponents = source.mimeType ? source.mimeType.split("/") : [];
            if (mimeComponents.length === 2) {
                if (!this._selectedMediaType) {
                    var index = HTML5MediaPlayer.supportedMediaTypes.indexOf(mimeComponents[0]);
                    if (index >= 0) this._selectedMediaType = HTML5MediaPlayer.supportedMediaTypes[index];
                }
                if (mimeComponents[0] === this._selectedMediaType) this._selectedSources.push(source);
            }
        }
        (_a = this._captionSources).push.apply(_a, this.owner.captionSources);
    };
    HTML5MediaPlayer.prototype.canPlay = function() {
        return this._selectedSources.length > 0;
    };
    HTML5MediaPlayer.prototype.fetchVideoDetails = function() {
        return $5104722604b983cb$var$__awaiter(this, void 0, void 0, function() {
            return $5104722604b983cb$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    HTML5MediaPlayer.prototype.render = function() {
        if (this._selectedMediaType === "video") this._mediaElement = document.createElement("video");
        else this._mediaElement = document.createElement("audio");
        this._mediaElement.setAttribute("aria-label", this.owner.altText ? this.owner.altText : $24F6S.Strings.defaults.mediaPlayerAriaLabel());
        this._mediaElement.setAttribute("webkit-playsinline", "");
        this._mediaElement.setAttribute("playsinline", "");
        // We enable crossorigin for cases where the caption file has a different domain than
        // the video file. If the caption file lives in a different domain than the video file
        // and crossorigin is not set, then the caption file will fail to load.
        this._mediaElement.setAttribute("crossorigin", "");
        this._mediaElement.autoplay = true;
        this._mediaElement.controls = true;
        if ($F6YrP.isMobileOS()) this._mediaElement.muted = true;
        this._mediaElement.preload = "none";
        this._mediaElement.style.width = "100%";
        for(var _i = 0, _a = this.owner.sources; _i < _a.length; _i++){
            var source = _a[_i];
            var renderedSource = source.render();
            $F6YrP.appendChild(this._mediaElement, renderedSource);
        }
        for(var _b = 0, _c = this.owner.captionSources; _b < _c.length; _b++){
            var captionSource = _c[_b];
            if (captionSource.mimeType == "vtt") {
                var renderedCaptionSource = captionSource.render();
                $F6YrP.appendChild(this._mediaElement, renderedCaptionSource);
            }
        }
        return this._mediaElement;
    };
    HTML5MediaPlayer.prototype.play = function() {
        if (this._mediaElement) this._mediaElement.play();
    };
    Object.defineProperty(HTML5MediaPlayer.prototype, "selectedMediaType", {
        get: function() {
            return this._selectedMediaType;
        },
        enumerable: false,
        configurable: true
    });
    HTML5MediaPlayer.supportedMediaTypes = [
        "audio",
        "video"
    ];
    return HTML5MediaPlayer;
}($5104722604b983cb$var$MediaPlayer);
module.exports.HTML5MediaPlayer = $5104722604b983cb$var$HTML5MediaPlayer;
var $5104722604b983cb$var$CustomMediaPlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(CustomMediaPlayer, _super);
    function CustomMediaPlayer(matches) {
        return _super.call(this) || this;
    }
    return CustomMediaPlayer;
}($5104722604b983cb$var$MediaPlayer);
module.exports.CustomMediaPlayer = $5104722604b983cb$var$CustomMediaPlayer;
var $5104722604b983cb$var$IFrameMediaMediaPlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(IFrameMediaMediaPlayer, _super);
    function IFrameMediaMediaPlayer(matches, iFrameTitle) {
        var _this = _super.call(this, matches) || this;
        _this.iFrameTitle = iFrameTitle;
        if (matches.length >= 2) _this._videoId = matches[1];
        return _this;
    }
    IFrameMediaMediaPlayer.prototype.canPlay = function() {
        return this._videoId !== undefined;
    };
    IFrameMediaMediaPlayer.prototype.render = function() {
        var container = document.createElement("div");
        container.style.position = "relative";
        container.style.width = "100%";
        container.style.height = "0";
        container.style.paddingBottom = "56.25%";
        var iFrame = document.createElement("iframe");
        iFrame.style.position = "absolute";
        iFrame.style.top = "0";
        iFrame.style.left = "0";
        iFrame.style.width = "100%";
        iFrame.style.height = "100%";
        iFrame.src = this.getEmbedVideoUrl();
        iFrame.frameBorder = "0";
        if (this.iFrameTitle) iFrame.title = this.iFrameTitle;
        iFrame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iFrame.allowFullscreen = true;
        container.appendChild(iFrame);
        return container;
    };
    Object.defineProperty(IFrameMediaMediaPlayer.prototype, "videoId", {
        get: function() {
            return this._videoId;
        },
        enumerable: false,
        configurable: true
    });
    return IFrameMediaMediaPlayer;
}($5104722604b983cb$var$CustomMediaPlayer);
module.exports.IFrameMediaMediaPlayer = $5104722604b983cb$var$IFrameMediaMediaPlayer;
var $5104722604b983cb$var$VimeoPlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(VimeoPlayer, _super);
    function VimeoPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VimeoPlayer.prototype.fetchVideoDetails = function() {
        return $5104722604b983cb$var$__awaiter(this, void 0, void 0, function() {
            var oEmbedUrl, response, json;
            return $5104722604b983cb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        oEmbedUrl = "https://vimeo.com/api/oembed.json?url=".concat(this.getEmbedVideoUrl());
                        return [
                            4 /*yield*/ ,
                            fetch(oEmbedUrl)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 2:
                        json = _a.sent();
                        this.posterUrl = json["thumbnail_url"];
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    VimeoPlayer.prototype.getEmbedVideoUrl = function() {
        return "https://player.vimeo.com/video/".concat(this.videoId, "?autoplay=1");
    };
    return VimeoPlayer;
}($5104722604b983cb$var$IFrameMediaMediaPlayer);
module.exports.VimeoPlayer = $5104722604b983cb$var$VimeoPlayer;
var $5104722604b983cb$var$DailymotionPlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(DailymotionPlayer, _super);
    function DailymotionPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DailymotionPlayer.prototype.fetchVideoDetails = function() {
        return $5104722604b983cb$var$__awaiter(this, void 0, void 0, function() {
            var apiUrl, response, json;
            return $5104722604b983cb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        apiUrl = "https://api.dailymotion.com/video/".concat(this.videoId, "?fields=thumbnail_720_url");
                        return [
                            4 /*yield*/ ,
                            fetch(apiUrl)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 2:
                        json = _a.sent();
                        this.posterUrl = json["thumbnail_720_url"];
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DailymotionPlayer.prototype.getEmbedVideoUrl = function() {
        return "https://www.dailymotion.com/embed/video/".concat(this.videoId, "?autoplay=1");
    };
    return DailymotionPlayer;
}($5104722604b983cb$var$IFrameMediaMediaPlayer);
module.exports.DailymotionPlayer = $5104722604b983cb$var$DailymotionPlayer;
var $5104722604b983cb$var$YouTubePlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(YouTubePlayer, _super);
    function YouTubePlayer(matches, iFrameTitle) {
        var _this = _super.call(this, matches, iFrameTitle) || this;
        _this.iFrameTitle = iFrameTitle;
        if (matches.length >= 3 && matches[2] !== undefined) _this._startTimeIndex = parseInt(matches[2]);
        return _this;
    }
    YouTubePlayer.prototype.fetchVideoDetails = function() {
        return $5104722604b983cb$var$__awaiter(this, void 0, void 0, function() {
            return $5104722604b983cb$var$__generator(this, function(_a) {
                this.posterUrl = this.videoId ? "https://img.youtube.com/vi/".concat(this.videoId, "/maxresdefault.jpg") : undefined;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    YouTubePlayer.prototype.getEmbedVideoUrl = function() {
        var url = "https://www.youtube.com/embed/".concat(this.videoId, "?autoplay=1");
        if (this._startTimeIndex !== undefined) url += "&start=".concat(this._startTimeIndex);
        return url;
    };
    return YouTubePlayer;
}($5104722604b983cb$var$IFrameMediaMediaPlayer);
module.exports.YouTubePlayer = $5104722604b983cb$var$YouTubePlayer;
var $5104722604b983cb$var$Media = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Media, _super);
    function Media() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sources = [];
        _this.captionSources = [];
        return _this;
    }
    Media.prototype.createMediaPlayer = function() {
        for(var _i = 0, _a = Media.customMediaPlayers; _i < _a.length; _i++){
            var provider = _a[_i];
            for(var _b = 0, _c = this.sources; _b < _c.length; _b++){
                var source = _c[_b];
                if (source.url) for(var _d = 0, _f = provider.urlPatterns; _d < _f.length; _d++){
                    var pattern = _f[_d];
                    var matches = pattern.exec(source.url);
                    if (matches !== null) return provider.createMediaPlayer(matches);
                }
            }
        }
        return new $5104722604b983cb$var$HTML5MediaPlayer(this);
    };
    Media.prototype.handlePlayButtonInvoke = function(event) {
        if (this.hostConfig.media.allowInlinePlayback) {
            event.preventDefault();
            event.cancelBubble = true;
            if (this.renderedElement) {
                var mediaPlayerElement = this._mediaPlayer.render();
                $5104722604b983cb$var$clearElement(this.renderedElement);
                this.renderedElement.appendChild(mediaPlayerElement);
                this._mediaPlayer.play();
                mediaPlayerElement.focus();
            }
        } else if (Media.onPlay) {
            event.preventDefault();
            event.cancelBubble = true;
            Media.onPlay(this);
        }
    };
    Media.prototype.displayPoster = function() {
        return $5104722604b983cb$var$__awaiter(this, void 0, void 0, function() {
            var playButtonArrowWidth, playButtonArrowHeight, posterRootElement_1, posterUrl, posterImageElement_1, playButtonOuterElement, playButtonInnerElement, playButtonContainer;
            var _this = this;
            return $5104722604b983cb$var$__generator(this, function(_a) {
                if (this.renderedElement) {
                    playButtonArrowWidth = 12;
                    playButtonArrowHeight = 15;
                    posterRootElement_1 = document.createElement("div");
                    posterRootElement_1.className = this.hostConfig.makeCssClassName("ac-media-poster");
                    posterRootElement_1.setAttribute("role", "contentinfo");
                    posterRootElement_1.setAttribute("aria-label", this.altText ? this.altText : $24F6S.Strings.defaults.mediaPlayerAriaLabel());
                    posterRootElement_1.style.position = "relative";
                    posterRootElement_1.style.display = "flex";
                    posterUrl = this.poster ? this.poster : this._mediaPlayer.posterUrl;
                    if (!posterUrl) posterUrl = this.hostConfig.media.defaultPoster;
                    if (posterUrl) {
                        posterImageElement_1 = document.createElement("img");
                        posterImageElement_1.style.width = "100%";
                        posterImageElement_1.style.height = "100%";
                        posterImageElement_1.setAttribute("role", "presentation");
                        posterImageElement_1.onerror = function(_e) {
                            if (posterImageElement_1.parentNode) posterImageElement_1.parentNode.removeChild(posterImageElement_1);
                            posterRootElement_1.classList.add("empty");
                            posterRootElement_1.style.minHeight = "150px";
                        };
                        posterImageElement_1.src = posterUrl;
                        posterRootElement_1.appendChild(posterImageElement_1);
                    } else {
                        posterRootElement_1.classList.add("empty");
                        posterRootElement_1.style.minHeight = "150px";
                    }
                    if (this.hostConfig.supportsInteractivity && this._mediaPlayer.canPlay()) {
                        playButtonOuterElement = document.createElement("div");
                        playButtonOuterElement.tabIndex = 0;
                        playButtonOuterElement.setAttribute("role", "button");
                        playButtonOuterElement.setAttribute("aria-label", $24F6S.Strings.defaults.mediaPlayerPlayMedia());
                        playButtonOuterElement.className = this.hostConfig.makeCssClassName("ac-media-playButton");
                        playButtonOuterElement.style.display = "flex";
                        playButtonOuterElement.style.alignItems = "center";
                        playButtonOuterElement.style.justifyContent = "center";
                        playButtonOuterElement.onclick = function(e) {
                            _this.handlePlayButtonInvoke(e);
                        };
                        playButtonOuterElement.onkeypress = function(e) {
                            if (e.code === "Enter" || e.code === "Space") // space or enter
                            _this.handlePlayButtonInvoke(e);
                        };
                        playButtonInnerElement = document.createElement("div");
                        playButtonInnerElement.className = this.hostConfig.makeCssClassName("ac-media-playButton-arrow");
                        playButtonInnerElement.style.width = playButtonArrowWidth + "px";
                        playButtonInnerElement.style.height = playButtonArrowHeight + "px";
                        playButtonInnerElement.style.borderTopWidth = playButtonArrowHeight / 2 + "px";
                        playButtonInnerElement.style.borderBottomWidth = playButtonArrowHeight / 2 + "px";
                        playButtonInnerElement.style.borderLeftWidth = playButtonArrowWidth + "px";
                        playButtonInnerElement.style.borderRightWidth = "0";
                        playButtonInnerElement.style.borderStyle = "solid";
                        playButtonInnerElement.style.borderTopColor = "transparent";
                        playButtonInnerElement.style.borderRightColor = "transparent";
                        playButtonInnerElement.style.borderBottomColor = "transparent";
                        playButtonInnerElement.style.transform = "translate(" + playButtonArrowWidth / 10 + "px,0px)";
                        playButtonOuterElement.appendChild(playButtonInnerElement);
                        playButtonContainer = document.createElement("div");
                        playButtonContainer.style.position = "absolute";
                        playButtonContainer.style.left = "0";
                        playButtonContainer.style.top = "0";
                        playButtonContainer.style.width = "100%";
                        playButtonContainer.style.height = "100%";
                        playButtonContainer.style.display = "flex";
                        playButtonContainer.style.justifyContent = "center";
                        playButtonContainer.style.alignItems = "center";
                        playButtonContainer.appendChild(playButtonOuterElement);
                        posterRootElement_1.appendChild(playButtonContainer);
                    }
                    $5104722604b983cb$var$clearElement(this.renderedElement);
                    this.renderedElement.appendChild(posterRootElement_1);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    Media.prototype.internalRender = function() {
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-media");
        return element;
    };
    Media.prototype.render = function() {
        var _this = this;
        var result = _super.prototype.render.call(this);
        if (result) {
            this._mediaPlayer = this.createMediaPlayer();
            this._mediaPlayer.fetchVideoDetails().then(function() {
                return _this.displayPoster();
            });
        }
        return result;
    };
    Media.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this.displayPoster();
    };
    Media.prototype.getJsonTypeName = function() {
        return "Media";
    };
    Media.prototype.getResourceInformation = function() {
        var result = [];
        if (this._mediaPlayer) {
            var posterUrl = this.poster ? this.poster : this.hostConfig.media.defaultPoster;
            if (posterUrl) result.push({
                url: posterUrl,
                mimeType: "image"
            });
        }
        for(var _i = 0, _a = this.sources; _i < _a.length; _i++){
            var mediaSource = _a[_i];
            if (mediaSource.isValid()) result.push({
                /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `mediaSource.url` is of type `string | undefined`, but is validated by `isValid()` call */ url: mediaSource.url,
                mimeType: mediaSource.mimeType
            });
        }
        for(var _b = 0, _c = this.captionSources; _b < _c.length; _b++){
            var captionSource = _c[_b];
            if (captionSource.isValid()) result.push({
                /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `captionSource.url` is of type `string | undefined`, but is validated by `isValid()` call */ url: captionSource.url,
                mimeType: captionSource.mimeType
            });
        }
        return result;
    };
    Object.defineProperty(Media.prototype, "selectedMediaType", {
        get: function() {
            return this._mediaPlayer.selectedMediaType;
        },
        enumerable: false,
        configurable: true
    });
    Media.customMediaPlayers = [
        {
            urlPatterns: [
                /^(?:https?:\/\/)?(?:www.)?youtube.com\/watch\?(?=.*v=([\w\d-_]+))(?=(?:.*t=(\d+))?).*/gi,
                /^(?:https?:\/\/)?youtu.be\/([\w\d-_]+)(?:\?t=(\d+))?/gi
            ],
            createMediaPlayer: function(matches) {
                return new $5104722604b983cb$var$YouTubePlayer(matches, $24F6S.Strings.defaults.youTubeVideoPlayer());
            }
        },
        {
            urlPatterns: [
                /^(?:https?:\/\/)?vimeo.com\/([\w\d-_]+).*/gi
            ],
            createMediaPlayer: function(matches) {
                return new $5104722604b983cb$var$VimeoPlayer(matches, $24F6S.Strings.defaults.vimeoVideoPlayer());
            }
        },
        {
            urlPatterns: [
                /^(?:https?:\/\/)?(?:www.)?dailymotion.com\/video\/([\w\d-_]+).*/gi
            ],
            createMediaPlayer: function(matches) {
                return new $5104722604b983cb$var$DailymotionPlayer(matches, $24F6S.Strings.defaults.dailymotionVideoPlayer());
            }
        }
    ];
    //#region Schema
    Media.sourcesProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_1, "sources", $5104722604b983cb$var$MediaSource);
    Media.captionSourcesProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_6, "captionSources", $5104722604b983cb$var$CaptionSource);
    Media.posterProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "poster");
    Media.altTextProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "altText");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Media.sourcesProperty)
    ], Media.prototype, "sources", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Media.captionSourcesProperty)
    ], Media.prototype, "captionSources", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Media.posterProperty)
    ], Media.prototype, "poster", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Media.altTextProperty)
    ], Media.prototype, "altText", void 0);
    return Media;
}($5104722604b983cb$var$CardElement);
module.exports.Media = $5104722604b983cb$var$Media;
var $5104722604b983cb$var$InputEventType;
(function(InputEventType) {
    InputEventType[InputEventType["InitialRender"] = 0] = "InitialRender";
    InputEventType[InputEventType["MouseEnterOnCard"] = 1] = "MouseEnterOnCard";
    InputEventType[InputEventType["MouseLeaveOnCard"] = 2] = "MouseLeaveOnCard";
    InputEventType[InputEventType["FocusLeave"] = 3] = "FocusLeave";
})($5104722604b983cb$var$InputEventType || ($5104722604b983cb$var$InputEventType = {}));
var $5104722604b983cb$var$Input = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputStyle = $gIXBn.InputStyle.Default;
        return _this;
    }
    Input.prototype.getAllLabelIds = function() {
        var labelIds = [];
        if (this.labelledBy) labelIds.push(this.labelledBy);
        if (this._renderedLabelElement) labelIds.push(this._renderedLabelElement.id);
        if (this._renderedErrorMessageElement) labelIds.push(this._renderedErrorMessageElement.id);
        return labelIds;
    };
    Input.prototype.updateInputControlAriaLabelledBy = function() {
        if (this._renderedInputControlElement) {
            var labelIds = this.getAllLabelIds();
            if (labelIds.length > 0) this._renderedInputControlElement.setAttribute("aria-labelledby", labelIds.join(" "));
            else this._renderedInputControlElement.removeAttribute("aria-labelledby");
        }
    };
    Object.defineProperty(Input.prototype, "isNullable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "renderedInputControlElement", {
        get: function() {
            return this._renderedInputControlElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "inputControlContainerElement", {
        get: function() {
            return this._inputControlContainerElement;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.overrideInternalRender = function() {
        var _this = this;
        var hostConfig = this.hostConfig;
        this._outerContainerElement = document.createElement("div");
        this._outerContainerElement.style.display = "flex";
        if (this.labelPosition === $gIXBn.InputLabelPosition.Inline) this._outerContainerElement.style.flexDirection = "row";
        else this._outerContainerElement.style.flexDirection = "column";
        var renderedInputControlId = $F6YrP.generateUniqueId();
        if (this.label) {
            var labelRichTextBlock = new $5104722604b983cb$var$RichTextBlock();
            labelRichTextBlock.setParent(this);
            labelRichTextBlock.forElementId = renderedInputControlId;
            var labelInline = new $5104722604b983cb$var$TextRun(this.label);
            labelRichTextBlock.addInline(labelInline);
            if (this.isRequired) {
                labelInline.init(hostConfig.inputs.label.requiredInputs);
                var isRequiredCueInline = new $5104722604b983cb$var$TextRun(hostConfig.inputs.label.requiredInputs.suffix);
                isRequiredCueInline.color = hostConfig.inputs.label.requiredInputs.suffixColor;
                isRequiredCueInline.ariaHidden = true;
                labelRichTextBlock.addInline(isRequiredCueInline);
            } else labelInline.init(hostConfig.inputs.label.optionalInputs);
            this._renderedLabelElement = labelRichTextBlock.render();
            if (this._renderedLabelElement) {
                this._renderedLabelElement.id = $F6YrP.generateUniqueId();
                if (this.labelPosition === $gIXBn.InputLabelPosition.Inline) // For inline label position: label should be in center of the div and no extra spacing needed
                this._renderedLabelElement.style.alignSelf = "center";
                else this._renderedLabelElement.style.marginBottom = hostConfig.getEffectiveSpacing(hostConfig.inputs.label.inputSpacing) + "px";
                this._outerContainerElement.appendChild(this._renderedLabelElement);
            }
        }
        this._inputControlContainerElement = document.createElement("div");
        this._inputControlContainerElement.className = hostConfig.makeCssClassName("ac-input-container");
        this._inputControlContainerElement.style.display = "flex";
        if (this.height === "stretch") {
            this._inputControlContainerElement.style.alignItems = "stretch";
            this._inputControlContainerElement.style.flex = "1 1 auto";
        }
        this._renderedInputControlElement = this.internalRender();
        if (this._renderedInputControlElement) {
            this._renderedInputControlElement.id = renderedInputControlId;
            this._renderedInputControlElement.style.minWidth = "0px";
            if (this.isNullable && this.isRequired) {
                this._renderedInputControlElement.setAttribute("aria-required", "true");
                this._renderedInputControlElement.classList.add(hostConfig.makeCssClassName("ac-input-required"));
            }
            this._inputControlContainerElement.appendChild(this._renderedInputControlElement);
            this._outerContainerElement.appendChild(this._inputControlContainerElement);
            if (this._renderedLabelElement && this.labelPosition === $gIXBn.InputLabelPosition.Inline) {
                if (!this.labelWidth) {
                    var defaultLabelWidth = hostConfig.inputs.label.width;
                    this._renderedLabelElement.style.width = defaultLabelWidth.toString() + "%";
                    this._inputControlContainerElement.style.width = 100 - defaultLabelWidth + "%";
                } else if (this.labelWidth.unit == $gIXBn.SizeUnit.Weight) {
                    var labelWidthInPercent = this.labelWidth.physicalSize;
                    this._renderedLabelElement.style.width = labelWidthInPercent.toString() + "%";
                    this._inputControlContainerElement.style.width = (100 - labelWidthInPercent).toString() + "%";
                } else if (this.labelWidth.unit == $gIXBn.SizeUnit.Pixel) {
                    var labelWidthInPixel = this.labelWidth.physicalSize;
                    this._renderedLabelElement.style.width = labelWidthInPixel.toString() + "px";
                }
            }
            this.updateVisualState($5104722604b983cb$var$InputEventType.InitialRender);
            if (this._renderedInputControlElement) this._renderedInputControlElement.onblur = function(ev) {
                _this.updateVisualState($5104722604b983cb$var$InputEventType.FocusLeave);
            };
            this.updateInputControlAriaLabelledBy();
            return this._outerContainerElement;
        }
        this.resetDirtyState();
        return undefined;
    };
    Input.prototype.valueChanged = function() {
        this.getRootElement().updateActionsEnabledState();
        if (this.isValid()) this.resetValidationFailureCue();
        if (this.onValueChanged) this.onValueChanged(this);
        $5104722604b983cb$var$raiseInputValueChangedEvent(this);
    };
    Input.prototype.resetValidationFailureCue = function() {
        if (this.renderedInputControlElement) {
            if (this instanceof $5104722604b983cb$var$ChoiceSetInput && this.isDynamicTypeahead()) this.removeValidationFailureCue();
            else this.renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
            this.updateInputControlAriaLabelledBy();
            if (this._renderedErrorMessageElement) {
                this._outerContainerElement.removeChild(this._renderedErrorMessageElement);
                this._renderedErrorMessageElement = undefined;
            }
        }
    };
    Input.prototype.showValidationErrorMessage = function() {
        if (this.renderedElement && this.errorMessage && $6BHj7.GlobalSettings.displayInputValidationErrors) {
            var errorMessageTextBlock = new $5104722604b983cb$var$TextBlock();
            errorMessageTextBlock.setParent(this);
            errorMessageTextBlock.text = this.errorMessage;
            errorMessageTextBlock.wrap = true;
            errorMessageTextBlock.init(this.hostConfig.inputs.errorMessage);
            this._renderedErrorMessageElement = errorMessageTextBlock.render();
            if (this._renderedErrorMessageElement) {
                this._renderedErrorMessageElement.id = $F6YrP.generateUniqueId();
                this._outerContainerElement.appendChild(this._renderedErrorMessageElement);
                this.updateInputControlAriaLabelledBy();
            }
        }
    };
    Object.defineProperty(Input.prototype, "allowRevealOnHoverStyle", {
        get: function() {
            return this.hostConfig.inputs && this.hostConfig.inputs.allowRevealOnHoverStyle;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.shouldHideInputAdornersForRevealOnHover = function(input, eventType) {
        // show/hide input adorners (date picker, time picker, select dropdown picker) with inputStyle RevealOnHover
        // 1. intial render of card: hide input adorners
        // 2. mouse hover on the card: show input adorners
        // 3. mouse hover outside the card: hide input adorners unless input is still in focus state
        // 4. input loses focus: hide the input adorners unless mouse is still hovering on the card
        // check if input still has the focus
        var isInputInFocus = input === document.activeElement;
        // check if mouse is still on the card
        var inputHoverClassName = this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover");
        var isMouseOverCard = input.classList.contains(inputHoverClassName);
        var hideInputAdorners = eventType === $5104722604b983cb$var$InputEventType.InitialRender || eventType === $5104722604b983cb$var$InputEventType.FocusLeave && !isMouseOverCard || eventType === $5104722604b983cb$var$InputEventType.MouseLeaveOnCard && !isInputInFocus;
        return hideInputAdorners;
    };
    Input.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle || !this._renderedInputControlElement || this.inputStyle !== $gIXBn.InputStyle.RevealOnHover) return;
        if (eventType === $5104722604b983cb$var$InputEventType.InitialRender) // on initial render, we will show input fields as read only view
        this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onrender"));
        else if (eventType === $5104722604b983cb$var$InputEventType.MouseEnterOnCard) // on hover on the card, we will reveal the inputs by showing borders etc
        // ac-inputStyle-revealOnHover-onhover class is also used to identify if mouse is hovering on the card
        this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover"));
        else if (eventType === $5104722604b983cb$var$InputEventType.MouseLeaveOnCard) this._renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover"));
    };
    Input.prototype.focus = function() {
        if (this._renderedInputControlElement) this._renderedInputControlElement.focus();
    };
    Input.prototype.isValid = function() {
        return true;
    };
    Input.prototype.isDirty = function() {
        return this.value !== this._oldValue;
    };
    Input.prototype.resetDirtyState = function() {
        this._oldValue = this.value;
    };
    Input.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.id) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.inputsMustHaveUniqueId());
        if (this.isRequired) {
            if (!this.label) context.addFailure(this, $gIXBn.ValidationEvent.RequiredInputsShouldHaveLabel, "Required inputs should have a label");
            if (!this.errorMessage) context.addFailure(this, $gIXBn.ValidationEvent.RequiredInputsShouldHaveErrorMessage, "Required inputs should have an error message");
        }
    };
    Input.prototype.validateValue = function() {
        this.resetValidationFailureCue();
        var result = this.isRequired ? this.isSet() && this.isValid() : this.isValid();
        if (!result && this.renderedInputControlElement) {
            if (this instanceof $5104722604b983cb$var$ChoiceSetInput && this.isDynamicTypeahead()) this.showValidationFailureCue();
            else this.renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
            this.showValidationErrorMessage();
        }
        return result;
    };
    Input.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [
            this
        ];
    };
    Input.prototype.render = function() {
        var result = _super.prototype.render.call(this);
        this.resetDirtyState();
        return result;
    };
    Object.defineProperty(Input.prototype, "isInteractive", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Input.labelProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_3, "label", true);
    Input.isRequiredProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_3, "isRequired", false);
    Input.errorMessageProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_3, "errorMessage", true);
    Input.inputStyleProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_6, "inputStyle", $gIXBn.InputStyle, $gIXBn.InputStyle.Default, [
        {
            value: $gIXBn.InputStyle.RevealOnHover
        },
        {
            value: $gIXBn.InputStyle.Default
        }
    ]);
    Input.labelWidthProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_6, "labelWidth", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidLabelWidth = false;
        if (typeof value === "number" && !isNaN(value)) {
            result = new $6BHj7.SizeAndUnit(value, $gIXBn.SizeUnit.Weight);
            if (result.physicalSize < 0 || result.physicalSize > 100) invalidLabelWidth = true;
        } else if (typeof value === "string") try {
            result = $6BHj7.SizeAndUnit.parse(value);
        } catch (e) {
            invalidLabelWidth = true;
        }
        else invalidLabelWidth = true;
        if (invalidLabelWidth) {
            context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidInputLabelWidth());
            result = undefined;
        }
        return result;
    }, function(sender, property, target, value, context) {
        if (value instanceof $6BHj7.SizeAndUnit) {
            if (value.unit === $gIXBn.SizeUnit.Pixel) context.serializeValue(target, "labelWidth", value.physicalSize + "px");
            else context.serializeNumber(target, "labelWidth", value.physicalSize);
        }
    }, undefined);
    Input.labelPositionProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_6, "labelPosition", $gIXBn.InputLabelPosition, $gIXBn.InputLabelPosition.Above, [
        {
            value: $gIXBn.InputLabelPosition.Inline
        },
        {
            value: $gIXBn.InputLabelPosition.Above
        }
    ]);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.labelProperty)
    ], Input.prototype, "label", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.isRequiredProperty)
    ], Input.prototype, "isRequired", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.errorMessageProperty)
    ], Input.prototype, "errorMessage", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.inputStyleProperty)
    ], Input.prototype, "inputStyle", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.labelWidthProperty)
    ], Input.prototype, "labelWidth", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.labelPositionProperty)
    ], Input.prototype, "labelPosition", void 0);
    return Input;
}($5104722604b983cb$var$CardElement);
module.exports.Input = $5104722604b983cb$var$Input;
var $5104722604b983cb$var$TextInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TextInput, _super);
    function TextInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiline = false;
        _this.style = $gIXBn.InputTextStyle.Text;
        return _this;
    }
    //#endregion
    TextInput.prototype.setupInput = function(input) {
        var _this = this;
        input.style.flex = "1 1 auto";
        input.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.placeholder) {
            input.placeholder = this.placeholder;
            input.setAttribute("aria-label", this.placeholder);
        }
        if (this.defaultValue) input.value = this.defaultValue;
        if (this.maxLength && this.maxLength > 0) input.maxLength = this.maxLength;
        input.oninput = function() {
            _this.valueChanged();
        };
        input.onkeypress = function(e) {
            // Ctrl+Enter pressed
            if (e.ctrlKey && e.code === "Enter" && _this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) _this.inlineAction.execute();
        };
    };
    TextInput.prototype.internalRender = function() {
        var result;
        if (this.isMultiline && this.style !== $gIXBn.InputTextStyle.Password) {
            result = document.createElement("textarea");
            result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput", "ac-multiline");
            if (this.height === "stretch") result.style.height = "initial";
        } else {
            result = document.createElement("input");
            result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput");
            result.type = $gIXBn.InputTextStyle[this.style].toLowerCase();
        }
        this.setupInput(result);
        return result;
    };
    TextInput.prototype.overrideInternalRender = function() {
        var _this = this;
        var renderedInputControl = _super.prototype.overrideInternalRender.call(this);
        if (this.inlineAction) {
            var button_1 = document.createElement("button");
            button_1.className = this.hostConfig.makeCssClassName(this.inlineAction.isEffectivelyEnabled() ? "ac-inlineActionButton" : "ac-inlineActionButton-disabled");
            button_1.onclick = function(e) {
                if (_this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) {
                    e.preventDefault();
                    e.cancelBubble = true;
                    _this.inlineAction.execute();
                }
            };
            if (this.inlineAction.iconUrl) {
                button_1.classList.add("iconOnly");
                var icon_1 = document.createElement("img");
                icon_1.style.height = "100%";
                icon_1.setAttribute("role", "presentation");
                // The below trick is necessary as a workaround in Chrome where the icon is initially displayed
                // at its native size then resized to 100% of the button's height. This cfreates an unpleasant
                // flicker. On top of that, Chrome's flex implementation fails to prperly re-layout the button
                // after the image has loaded and been gicven its final size. The below trick also fixes that.
                icon_1.style.display = "none";
                icon_1.onload = function() {
                    icon_1.style.removeProperty("display");
                };
                icon_1.onerror = function() {
                    button_1.removeChild(icon_1);
                    button_1.classList.remove("iconOnly");
                    button_1.classList.add("textOnly");
                    button_1.textContent = _this.inlineAction && _this.inlineAction.title ? _this.inlineAction.title : $24F6S.Strings.defaults.inlineActionTitle();
                };
                icon_1.src = this.inlineAction.iconUrl;
                button_1.appendChild(icon_1);
                button_1.title = this.inlineAction.title ? this.inlineAction.title : $24F6S.Strings.defaults.inlineActionTitle();
            } else {
                button_1.classList.add("textOnly");
                button_1.textContent = this.inlineAction.title ? this.inlineAction.title : $24F6S.Strings.defaults.inlineActionTitle();
            }
            this.inlineAction.setupElementForAccessibility(button_1, true);
            button_1.style.marginLeft = "8px";
            this.inputControlContainerElement.appendChild(button_1);
        }
        return renderedInputControl;
    };
    TextInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        if (!(this.inlineAction || this.isMultiline)) _super.prototype.updateVisualState.call(this, eventType);
    };
    TextInput.prototype.getJsonTypeName = function() {
        return "Input.Text";
    };
    TextInput.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.inlineAction) result.push(this.inlineAction);
        return result;
    };
    TextInput.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result && this.inlineAction) result = this.inlineAction.getActionById(id);
        return result;
    };
    TextInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    TextInput.prototype.isValid = function() {
        if (!this.value) return true;
        if (this.regex) return new RegExp(this.regex, "g").test(this.value);
        return true;
    };
    Object.defineProperty(TextInput.prototype, "value", {
        get: function() {
            if (this.renderedInputControlElement) {
                if (this.isMultiline) return this.renderedInputControlElement.value;
                else return this.renderedInputControlElement.value;
            } else return undefined;
        },
        enumerable: false,
        configurable: true
    });
    TextInput.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    TextInput.maxLengthProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_0, "maxLength");
    TextInput.isMultilineProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "isMultiline", false);
    TextInput.placeholderProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "placeholder");
    TextInput.styleProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "style", $gIXBn.InputTextStyle, $gIXBn.InputTextStyle.Text, [
        {
            value: $gIXBn.InputTextStyle.Text
        },
        {
            value: $gIXBn.InputTextStyle.Tel
        },
        {
            value: $gIXBn.InputTextStyle.Url
        },
        {
            value: $gIXBn.InputTextStyle.Email
        },
        {
            value: $gIXBn.InputTextStyle.Password,
            targetVersion: $5Ougt.Versions.v1_5
        }
    ]);
    TextInput.inlineActionProperty = new $5104722604b983cb$var$ActionProperty($5Ougt.Versions.v1_0, "inlineAction", [
        "Action.ShowCard"
    ]);
    TextInput.regexProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_3, "regex", true);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.valueProperty)
    ], TextInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.maxLengthProperty)
    ], TextInput.prototype, "maxLength", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.isMultilineProperty)
    ], TextInput.prototype, "isMultiline", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.placeholderProperty)
    ], TextInput.prototype, "placeholder", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.styleProperty)
    ], TextInput.prototype, "style", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.inlineActionProperty)
    ], TextInput.prototype, "inlineAction", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.regexProperty)
    ], TextInput.prototype, "regex", void 0);
    return TextInput;
}($5104722604b983cb$var$Input);
module.exports.TextInput = $5104722604b983cb$var$TextInput;
var $5104722604b983cb$var$ToggleInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ToggleInput, _super);
    function ToggleInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.valueOn = "true";
        _this.valueOff = "false";
        _this.wrap = false;
        return _this;
    }
    ToggleInput.prototype.updateInputControlAriaLabelledBy = function() {
        if (this._checkboxInputElement) {
            var joinedLabelIds = this.getAllLabelIds().join(" ");
            if (this._checkboxInputLabelElement && this._checkboxInputLabelElement.id) joinedLabelIds += " " + this._checkboxInputLabelElement.id;
            if (joinedLabelIds) this._checkboxInputElement.setAttribute("aria-labelledby", joinedLabelIds);
            else this._checkboxInputElement.removeAttribute("aria-labelledby");
        }
    };
    ToggleInput.prototype.internalRender = function() {
        var _this = this;
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-input", "ac-toggleInput");
        element.style.width = "100%";
        element.style.display = "flex";
        element.style.alignItems = "center";
        this._checkboxInputElement = document.createElement("input");
        this._checkboxInputElement.id = $F6YrP.generateUniqueId();
        this._checkboxInputElement.type = "checkbox";
        this._checkboxInputElement.style.display = "inline-block";
        this._checkboxInputElement.style.verticalAlign = "middle";
        this._checkboxInputElement.style.margin = "0";
        this._checkboxInputElement.style.flex = "0 0 auto";
        if (this.title) this._checkboxInputElement.setAttribute("aria-label", this.title);
        if (this.isRequired) this._checkboxInputElement.setAttribute("aria-required", "true");
        this._checkboxInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue === this.valueOn) this._checkboxInputElement.checked = true;
        this._oldCheckboxValue = this._checkboxInputElement.checked;
        this._checkboxInputElement.onchange = function() {
            _this.valueChanged();
        };
        $F6YrP.appendChild(element, this._checkboxInputElement);
        if (this.title || this.isDesignMode()) {
            var label = new $5104722604b983cb$var$TextBlock();
            label.setParent(this);
            label.forElementId = this._checkboxInputElement.id;
            label.hostConfig = this.hostConfig;
            label.text = !this.title ? this.getJsonTypeName() : this.title;
            label.useMarkdown = $6BHj7.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
            label.wrap = this.wrap;
            this._checkboxInputLabelElement = label.render();
            if (this._checkboxInputLabelElement) {
                this._checkboxInputLabelElement.id = $F6YrP.generateUniqueId();
                this._checkboxInputLabelElement.style.display = "inline-block";
                this._checkboxInputLabelElement.style.flex = "1 1 auto";
                this._checkboxInputLabelElement.style.marginLeft = "6px";
                this._checkboxInputLabelElement.style.verticalAlign = "middle";
                var spacerElement = document.createElement("div");
                spacerElement.style.width = "6px";
                $F6YrP.appendChild(element, spacerElement);
                $F6YrP.appendChild(element, this._checkboxInputLabelElement);
            }
        }
        return element;
    };
    Object.defineProperty(ToggleInput.prototype, "isNullable", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ToggleInput.prototype.updateVisualState = function(eventType) {};
    ToggleInput.prototype.getJsonTypeName = function() {
        return "Input.Toggle";
    };
    ToggleInput.prototype.focus = function() {
        if (this._checkboxInputElement) this._checkboxInputElement.focus();
    };
    ToggleInput.prototype.isSet = function() {
        if (this.isRequired) return this.value === this.valueOn;
        return this.value ? true : false;
    };
    ToggleInput.prototype.isDirty = function() {
        return this._checkboxInputElement ? this._checkboxInputElement.checked !== this._oldCheckboxValue : false;
    };
    Object.defineProperty(ToggleInput.prototype, "value", {
        get: function() {
            if (this._checkboxInputElement) return this._checkboxInputElement.checked ? this.valueOn : this.valueOff;
            else return undefined;
        },
        enumerable: false,
        configurable: true
    });
    ToggleInput.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    ToggleInput.titleProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "title");
    ToggleInput.valueOnProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "valueOn", true, undefined, "true", function(sender) {
        return "true";
    });
    ToggleInput.valueOffProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "valueOff", true, undefined, "false", function(sender) {
        return "false";
    });
    ToggleInput.wrapProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "wrap", false);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleInput.valueProperty)
    ], ToggleInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleInput.titleProperty)
    ], ToggleInput.prototype, "title", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleInput.valueOnProperty)
    ], ToggleInput.prototype, "valueOn", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleInput.valueOffProperty)
    ], ToggleInput.prototype, "valueOff", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleInput.wrapProperty)
    ], ToggleInput.prototype, "wrap", void 0);
    return ToggleInput;
}($5104722604b983cb$var$Input);
module.exports.ToggleInput = $5104722604b983cb$var$ToggleInput;
var $5104722604b983cb$var$Choice = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Choice, _super);
    function Choice(title, value) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.value = value;
        return _this;
    }
    //#endregion
    Choice.prototype.getSchemaKey = function() {
        return "Choice";
    };
    //#region Schema
    Choice.titleProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "title");
    Choice.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Choice.titleProperty)
    ], Choice.prototype, "title", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Choice.valueProperty)
    ], Choice.prototype, "value", void 0);
    return Choice;
}($5Ougt.SerializableObject);
module.exports.Choice = $5104722604b983cb$var$Choice;
/**
 * DataQuery class is declared later in the file and derives from subsequent base classes
 * Hence, it cannot be used in ChoiceSetInput.
 * Refactor is needed to separate elements and actions in separate files.
 */ var $5104722604b983cb$var$ChoiceSetInputDataQuery = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ChoiceSetInputDataQuery, _super);
    function ChoiceSetInputDataQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    ChoiceSetInputDataQuery.prototype.getSchemaKey = function() {
        return "choices.data";
    };
    //#region Schema
    ChoiceSetInputDataQuery.typeProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_6, "type", true, new RegExp("^Data.Query$"));
    ChoiceSetInputDataQuery.datasetProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_6, "dataset");
    ChoiceSetInputDataQuery.countProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "count");
    ChoiceSetInputDataQuery.skipProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "skip");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInputDataQuery.typeProperty)
    ], ChoiceSetInputDataQuery.prototype, "type", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInputDataQuery.datasetProperty)
    ], ChoiceSetInputDataQuery.prototype, "dataset", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInputDataQuery.countProperty)
    ], ChoiceSetInputDataQuery.prototype, "count", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInputDataQuery.skipProperty)
    ], ChoiceSetInputDataQuery.prototype, "skip", void 0);
    return ChoiceSetInputDataQuery;
}($5Ougt.SerializableObject);
module.exports.ChoiceSetInputDataQuery = $5104722604b983cb$var$ChoiceSetInputDataQuery;
var $5104722604b983cb$var$ChoiceSetInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ChoiceSetInput, _super);
    function ChoiceSetInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiSelect = false;
        _this.wrap = false;
        _this.choices = [];
        return _this;
    }
    Object.defineProperty(ChoiceSetInput.prototype, "isCompact", {
        get: function() {
            return !this.style || this.style === "compact";
        },
        set: function(value) {
            this.style = value ? undefined : "expanded";
        },
        enumerable: false,
        configurable: true
    });
    ChoiceSetInput.getUniqueCategoryName = function() {
        var uniqueCategoryName = "__ac-category" + ChoiceSetInput._uniqueCategoryCounter;
        ChoiceSetInput._uniqueCategoryCounter++;
        return uniqueCategoryName;
    };
    ChoiceSetInput.prototype.isDynamicTypeahead = function() {
        return this.hostConfig.inputs.allowDynamicallyFilteredChoiceSet && !!this.choicesData && !!this.choicesData.dataset && this.choicesData.type === "Data.Query";
    };
    ChoiceSetInput.prototype.getFilterForDynamicSearch = function() {
        var _a;
        return (_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value;
    };
    ChoiceSetInput.prototype.getDropdownElement = function() {
        var _a;
        return (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.dropdown;
    };
    ChoiceSetInput.prototype.renderChoices = function(filter, fetchedChoices) {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.processResponse(filter, fetchedChoices);
    };
    ChoiceSetInput.prototype.showLoadingIndicator = function() {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.showLoadingIndicator();
    };
    ChoiceSetInput.prototype.removeLoadingIndicator = function() {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.removeLoadingIndicator();
    };
    ChoiceSetInput.prototype.showErrorIndicator = function(filter, error) {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.showErrorIndicator(filter, error);
    };
    ChoiceSetInput.prototype.showValidationFailureCue = function() {
        var _a;
        (_a = this._textInput) === null || _a === void 0 || _a.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
    };
    ChoiceSetInput.prototype.removeValidationFailureCue = function() {
        var _a;
        (_a = this._textInput) === null || _a === void 0 || _a.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
    };
    ChoiceSetInput.prototype.createPlaceholderOptionWhenValueDoesNotExist = function() {
        if (!this.value) {
            var placeholderOption = document.createElement("option");
            placeholderOption.selected = true;
            placeholderOption.disabled = true;
            placeholderOption.hidden = true;
            placeholderOption.value = "";
            if (this.placeholder) placeholderOption.text = this.placeholder;
            return placeholderOption;
        }
        return undefined;
    };
    // Make sure `aria-current` is applied to the currently-selected item
    ChoiceSetInput.prototype.internalApplyAriaCurrent = function() {
        if (this._selectElement) {
            var options = this._selectElement.options;
            if (options) for(var _i = 0, _a = Array.from(options); _i < _a.length; _i++){
                var option = _a[_i];
                if (option.selected) option.setAttribute("aria-current", "true");
                else option.removeAttribute("aria-current");
            }
        }
    };
    ChoiceSetInput.prototype.renderCompoundInput = function(cssClassName, type, defaultValues) {
        var _this = this;
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-input", cssClassName);
        element.style.width = "100%";
        element.tabIndex = this.isDesignMode() ? -1 : 0;
        this._toggleInputs = [];
        this._labels = [];
        for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
            var choice = _a[_i];
            var input = document.createElement("input");
            input.id = $F6YrP.generateUniqueId();
            input.type = type;
            input.style.margin = "0";
            input.style.display = "inline-block";
            input.style.verticalAlign = "middle";
            input.style.flex = "0 0 auto";
            input.name = this.id ? this.id : this._uniqueCategoryName;
            if (this.isRequired) input.setAttribute("aria-required", "true");
            input.tabIndex = this.isDesignMode() ? -1 : 0;
            if (choice.value) input.value = choice.value;
            if (choice.title) input.setAttribute("aria-label", choice.title);
            if (defaultValues && choice.value) {
                if (defaultValues.indexOf(choice.value) >= 0) input.checked = true;
            }
            input.onchange = function() {
                _this.valueChanged();
            };
            this._toggleInputs.push(input);
            var compoundInput = document.createElement("div");
            compoundInput.style.display = "flex";
            compoundInput.style.alignItems = "center";
            $F6YrP.appendChild(compoundInput, input);
            var label = new $5104722604b983cb$var$TextBlock();
            label.setParent(this);
            label.forElementId = input.id;
            label.hostConfig = this.hostConfig;
            label.text = choice.title ? choice.title : "Choice " + this._toggleInputs.length;
            label.useMarkdown = $6BHj7.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
            label.wrap = this.wrap;
            var labelElement = label.render();
            this._labels.push(labelElement);
            if (labelElement) {
                labelElement.id = $F6YrP.generateUniqueId();
                labelElement.style.display = "inline-block";
                labelElement.style.flex = "1 1 auto";
                labelElement.style.marginLeft = "6px";
                labelElement.style.verticalAlign = "middle";
                var spacerElement = document.createElement("div");
                spacerElement.style.width = "6px";
                $F6YrP.appendChild(compoundInput, spacerElement);
                $F6YrP.appendChild(compoundInput, labelElement);
            }
            $F6YrP.appendChild(element, compoundInput);
        }
        return element;
    };
    ChoiceSetInput.prototype.updateInputControlAriaLabelledBy = function() {
        if ((this.isMultiSelect || this.style === "expanded") && this._toggleInputs && this._labels) {
            var labelIds = this.getAllLabelIds();
            for(var i = 0; i < this._toggleInputs.length; i++){
                var joinedLabelIds = labelIds.join(" ");
                var label = this._labels[i];
                if (label && label.id) joinedLabelIds += " " + label.id;
                if (joinedLabelIds) this._toggleInputs[i].setAttribute("aria-labelledby", joinedLabelIds);
                else this._toggleInputs[i].removeAttribute("aria-labelledby");
            }
        } else _super.prototype.updateInputControlAriaLabelledBy.call(this);
    };
    ChoiceSetInput.prototype.internalRender = function() {
        var _this = this;
        this._uniqueCategoryName = ChoiceSetInput.getUniqueCategoryName();
        if (this.isDynamicTypeahead()) {
            var filteredChoiceSet_1 = new $5104722604b983cb$var$FilteredChoiceSet(ChoiceSetInput._uniqueCategoryCounter, this.choices, this.hostConfig);
            filteredChoiceSet_1.render();
            if (filteredChoiceSet_1.textInput) {
                this._textInput = filteredChoiceSet_1.textInput;
                if (this.defaultValue) this._textInput.value = this.defaultValue;
                if (this.placeholder && !this._textInput.value) {
                    this._textInput.placeholder = this.placeholder;
                    this._textInput.setAttribute("aria-label", this.placeholder);
                }
                this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
                var onInputChangeEventHandler = $F6YrP.debounce(function() {
                    filteredChoiceSet_1.processChoices();
                    _this.valueChanged();
                    if (_this._textInput) {
                        // Remove aria-label when value is not empty so narration software doesn't
                        // read the placeholder
                        if (_this.value) {
                            _this._textInput.removeAttribute("placeholder");
                            _this._textInput.removeAttribute("aria-label");
                        } else if (_this.placeholder) {
                            _this._textInput.placeholder = _this.placeholder;
                            _this._textInput.setAttribute("aria-label", _this.placeholder);
                        }
                    }
                }, this.hostConfig.inputs.debounceTimeInMilliSeconds);
                this._textInput.onclick = onInputChangeEventHandler;
                this._textInput.oninput = onInputChangeEventHandler;
            }
            filteredChoiceSet_1.parent = this;
            this._filteredChoiceSet = filteredChoiceSet_1;
            return filteredChoiceSet_1.renderedElement;
        } else if (this.isMultiSelect) // Render as a list of toggle inputs
        return this.renderCompoundInput("ac-choiceSetInput-multiSelect", "checkbox", this.defaultValue ? this.defaultValue.split(this.hostConfig.choiceSetInputValueSeparator) : undefined);
        else {
            if (this.style === "expanded") // Render as a series of radio buttons
            return this.renderCompoundInput("ac-choiceSetInput-expanded", "radio", this.defaultValue ? [
                this.defaultValue
            ] : undefined);
            else if (this.style === "filtered") {
                // Render as a text input coupled with a datalist
                var inputContainer = document.createElement("div");
                inputContainer.style.width = "100%";
                this._textInput = document.createElement("input");
                this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-filtered");
                this._textInput.type = "text";
                this._textInput.style.width = "100%";
                this._textInput.oninput = function() {
                    _this.valueChanged();
                    if (_this._textInput) {
                        // Remove aria-label when value is not empty so narration software doesn't
                        // read the placeholder
                        if (_this.value) {
                            _this._textInput.removeAttribute("placeholder");
                            _this._textInput.removeAttribute("aria-label");
                        } else if (_this.placeholder) {
                            _this._textInput.placeholder = _this.placeholder;
                            _this._textInput.setAttribute("aria-label", _this.placeholder);
                        }
                    }
                };
                if (this.defaultValue) this._textInput.value = this.defaultValue;
                if (this.placeholder && !this._textInput.value) {
                    this._textInput.placeholder = this.placeholder;
                    this._textInput.setAttribute("aria-label", this.placeholder);
                }
                this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
                var dataList = document.createElement("datalist");
                dataList.id = $F6YrP.generateUniqueId();
                for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                    var choice = _a[_i];
                    var option = document.createElement("option");
                    // To fix https://stackoverflow.com/questions/29882361/show-datalist-labels-but-submit-the-actual-value
                    // value is mapped to choice.title other than choice.value
                    if (choice.title) {
                        option.value = choice.title;
                        option.setAttribute("aria-label", choice.title);
                    }
                    option.tabIndex = this.isDesignMode() ? -1 : 0;
                    dataList.appendChild(option);
                }
                this._textInput.setAttribute("list", dataList.id);
                inputContainer.append(this._textInput, dataList);
                return inputContainer;
            } else {
                // Render as a combo box
                this._selectElement = document.createElement("select");
                this._selectElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-compact");
                this._selectElement.style.width = "100%";
                this._selectElement.tabIndex = this.isDesignMode() ? -1 : 0;
                var placeholderOption = this.createPlaceholderOptionWhenValueDoesNotExist();
                $F6YrP.appendChild(this._selectElement, placeholderOption);
                for(var _b = 0, _c = this.choices; _b < _c.length; _b++){
                    var choice = _c[_b];
                    var option = document.createElement("option");
                    option.value = choice.value;
                    if (choice.title) {
                        option.text = choice.title;
                        option.setAttribute("aria-label", choice.title);
                    }
                    option.tabIndex = this.isDesignMode() ? -1 : 0;
                    if (choice.value === this.defaultValue) option.selected = true;
                    $F6YrP.appendChild(this._selectElement, option);
                }
                this._selectElement.onchange = function() {
                    _this.internalApplyAriaCurrent();
                    _this.valueChanged();
                };
                this.internalApplyAriaCurrent();
                return this._selectElement;
            }
        }
    };
    ChoiceSetInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        if (!this.isMultiSelect && this.isCompact) {
            _super.prototype.updateVisualState.call(this, eventType);
            if (this._selectElement && this.inputStyle === $gIXBn.InputStyle.RevealOnHover) {
                var hideDropDownPicker = this.shouldHideInputAdornersForRevealOnHover(this._selectElement, eventType);
                if (hideDropDownPicker) {
                    this._selectElement.style.appearance = "none";
                    this._selectElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
                } else {
                    this._selectElement.style.appearance = "auto";
                    this._selectElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
                }
            }
        }
    };
    ChoiceSetInput.prototype.getJsonTypeName = function() {
        return "Input.ChoiceSet";
    };
    ChoiceSetInput.prototype.focus = function() {
        if (this._toggleInputs && (this.isMultiSelect || this.style === "expanded")) {
            if (this._toggleInputs.length > 0) this._toggleInputs[0].focus();
        } else if (this._textInput) this._textInput.focus();
        else _super.prototype.focus.call(this);
    };
    ChoiceSetInput.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this.choices.length === 0) context.addFailure(this, $gIXBn.ValidationEvent.CollectionCantBeEmpty, $24F6S.Strings.errors.choiceSetMustHaveAtLeastOneChoice());
        for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
            var choice = _a[_i];
            if (!choice.title || !choice.value) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.choiceSetChoicesMustHaveTitleAndValue());
        }
    };
    ChoiceSetInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    ChoiceSetInput.prototype.isValid = function() {
        if (this._textInput) {
            if (this.value === "" || this.value === this.placeholder) return true;
            for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                var choice = _a[_i];
                if (this.value === choice.value) return true;
            }
            if (this.dynamicChoices) for(var _b = 0, _c = this.dynamicChoices; _b < _c.length; _b++){
                var choice = _c[_b];
                if (this.value === choice) return true;
            }
            return false;
        }
        return _super.prototype.isValid.call(this);
    };
    Object.defineProperty(ChoiceSetInput.prototype, "value", {
        get: function() {
            if (!this.isMultiSelect) {
                if (this._selectElement) return this._selectElement.selectedIndex > 0 ? this._selectElement.value : undefined;
                else if (this._textInput) {
                    for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                        var choice = _a[_i];
                        if (choice.title && this._textInput.value === choice.title) return choice.value;
                    }
                    return this._textInput.value;
                } else if (this._toggleInputs && this._toggleInputs.length > 0) for(var _b = 0, _c = this._toggleInputs; _b < _c.length; _b++){
                    var toggleInput = _c[_b];
                    if (toggleInput.checked) return toggleInput.value;
                }
                return undefined;
            } else {
                if (!this._toggleInputs || this._toggleInputs.length === 0) return undefined;
                var result = "";
                for(var _d = 0, _f = this._toggleInputs; _d < _f.length; _d++){
                    var toggleInput = _f[_d];
                    if (toggleInput.checked) {
                        if (result !== "") result += this.hostConfig.choiceSetInputValueSeparator;
                        result += toggleInput.value;
                    }
                }
                return result ? result : undefined;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChoiceSetInput.prototype, "dynamicChoices", {
        get: function() {
            var _a;
            return (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.dynamicChoices;
        },
        enumerable: false,
        configurable: true
    });
    ChoiceSetInput.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    ChoiceSetInput.choicesProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_0, "choices", $5104722604b983cb$var$Choice);
    ChoiceSetInput.choicesDataProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_6, "choices.data", $5104722604b983cb$var$ChoiceSetInputDataQuery);
    ChoiceSetInput.styleProperty = new $5Ougt.ValueSetProperty($5Ougt.Versions.v1_0, "style", [
        {
            value: "compact"
        },
        {
            value: "expanded"
        },
        {
            value: "filtered",
            targetVersion: $5Ougt.Versions.v1_5
        }
    ], "compact");
    ChoiceSetInput.isMultiSelectProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "isMultiSelect", false);
    ChoiceSetInput.placeholderProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "placeholder");
    ChoiceSetInput.wrapProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "wrap", false);
    //#endregion
    ChoiceSetInput._uniqueCategoryCounter = 0;
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.valueProperty)
    ], ChoiceSetInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.styleProperty)
    ], ChoiceSetInput.prototype, "style", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.isMultiSelectProperty)
    ], ChoiceSetInput.prototype, "isMultiSelect", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.placeholderProperty)
    ], ChoiceSetInput.prototype, "placeholder", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.wrapProperty)
    ], ChoiceSetInput.prototype, "wrap", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.choicesProperty)
    ], ChoiceSetInput.prototype, "choices", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.choicesDataProperty)
    ], ChoiceSetInput.prototype, "choicesData", void 0);
    return ChoiceSetInput;
}($5104722604b983cb$var$Input);
module.exports.ChoiceSetInput = $5104722604b983cb$var$ChoiceSetInput;
var $5104722604b983cb$var$FilteredChoiceSet = /** @class */ function() {
    function FilteredChoiceSet(choiceSetId, choices, hostConfig) {
        this._choiceSetId = choiceSetId;
        this._choices = choices;
        this._dynamicChoices = [];
        this._visibleChoiceCount = 0;
        this._highlightedChoiceId = -1;
        this._hostConfig = hostConfig;
    }
    FilteredChoiceSet.prototype.render = function() {
        var _this = this;
        var choiceSetContainer = document.createElement("div");
        choiceSetContainer.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-container");
        this._textInput = document.createElement("input");
        this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-textbox");
        this._textInput.type = "text";
        this._textInput.onkeydown = function(event) {
            if (event.key === "ArrowDown") {
                event.preventDefault();
                _this.highlightChoice(_this._highlightedChoiceId + 1);
            } else if (event.key === "ArrowUp") {
                event.preventDefault();
                _this.highlightChoice(_this._highlightedChoiceId - 1);
            } else if (event.key === "Enter") {
                var choice = document.getElementById("ac-choiceSetInput-".concat(_this._choiceSetId, "-choice-").concat(_this._highlightedChoiceId));
                choice === null || choice === void 0 || choice.click();
            }
        };
        this._dropdown = document.createElement("div");
        this._dropdown.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-dropdown");
        choiceSetContainer.append(this._textInput, this._dropdown);
        this._renderedElement = choiceSetContainer;
    };
    FilteredChoiceSet.prototype.createChoice = function(value, filter, id) {
        var _this = this;
        var choice = document.createElement("span");
        choice.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-choice");
        choice.id = "ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(id);
        choice.innerHTML = value.replace(filter, "<b>".concat(filter, "</b>"));
        choice.tabIndex = -1;
        choice.onclick = function() {
            choice.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
            _this._highlightedChoiceId = -1;
            if (_this._textInput) {
                _this._textInput.value = choice.innerText;
                _this._textInput.focus();
            }
            if (_this._dropdown) _this._dropdown.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
        };
        choice.onmousemove = function() {
            if (_this._highlightedChoiceId !== id) _this.highlightChoice(id, false);
        };
        return choice;
    };
    FilteredChoiceSet.prototype.highlightChoice = function(id, scrollIntoView) {
        if (scrollIntoView === void 0) scrollIntoView = true;
        if (this._visibleChoiceCount > 0) {
            var currentHighlightedChoice = document.getElementById("ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(this._highlightedChoiceId));
            var nextHighlightedChoice = document.getElementById("ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(id));
            if (nextHighlightedChoice) {
                currentHighlightedChoice === null || currentHighlightedChoice === void 0 || currentHighlightedChoice.classList.remove(this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
                nextHighlightedChoice.classList.add(this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
                if (scrollIntoView) nextHighlightedChoice.scrollIntoView();
                this._highlightedChoiceId = id;
            } else if (currentHighlightedChoice && this._highlightedChoiceId !== 0) this.highlightChoice(0);
            else this.highlightChoice(this._visibleChoiceCount - 1);
        }
    };
    FilteredChoiceSet.prototype.filterChoices = function() {
        var _a, _b;
        var filter = ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value.toLowerCase().trim()) || "";
        var choices = $5104722604b983cb$var$__spreadArray($5104722604b983cb$var$__spreadArray([], this._choices, true), this._dynamicChoices, true);
        for(var _i = 0, choices_1 = choices; _i < choices_1.length; _i++){
            var choice = choices_1[_i];
            if (choice.title) {
                var matchIndex = choice.title.toLowerCase().indexOf(filter);
                if (matchIndex !== -1) {
                    var matchedText = choice.title.substring(matchIndex, matchIndex + filter.length);
                    var choiceContainer = this.createChoice(choice.title, matchedText, this._visibleChoiceCount++);
                    (_b = this._dropdown) === null || _b === void 0 || _b.appendChild(choiceContainer);
                }
            }
        }
    };
    FilteredChoiceSet.prototype.getStatusIndicator = function(error) {
        if (error) {
            if (!this._errorIndicator) {
                var errorIndicator = document.createElement("div");
                errorIndicator.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator", "ac-choiceSetInput-errorIndicator");
                this._errorIndicator = errorIndicator;
            }
            this._errorIndicator.innerText = error;
            return this._errorIndicator;
        } else {
            if (!this._loadingIndicator) {
                var loadingIndicator = document.createElement("div");
                loadingIndicator.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator");
                this._loadingIndicator = loadingIndicator;
            }
            this._loadingIndicator.innerText = this._visibleChoiceCount === 0 ? "Loading..." : "Loading more...";
            return this._loadingIndicator;
        }
    };
    FilteredChoiceSet.prototype.resetDropdown = function() {
        if (this._dropdown) {
            $F6YrP.clearElementChildren(this._dropdown);
            this._visibleChoiceCount = 0;
            this._highlightedChoiceId = -1;
        }
    };
    FilteredChoiceSet.prototype.showDropdown = function() {
        var _a;
        if ((_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.hasChildNodes()) this._dropdown.classList.add(this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
    };
    FilteredChoiceSet.prototype.processChoices = function() {
        this.resetDropdown();
        this.filterChoices();
        this.showDropdown();
    };
    FilteredChoiceSet.prototype.processResponse = function(filter, fetchedChoices) {
        var _a;
        if (filter === ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value)) {
            this.resetDropdown();
            this._dynamicChoices = fetchedChoices;
            this.filterChoices();
            if (this._visibleChoiceCount === 0) this.showErrorIndicator(filter, "No results found");
        }
    };
    FilteredChoiceSet.prototype.showLoadingIndicator = function() {
        var _a;
        var loadingIndicator = this.getStatusIndicator();
        (_a = this._dropdown) === null || _a === void 0 || _a.appendChild(loadingIndicator);
        this.showDropdown();
    };
    FilteredChoiceSet.prototype.removeLoadingIndicator = function() {
        var _a, _b;
        if (this._loadingIndicator && ((_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.contains(this._loadingIndicator))) (_b = this._dropdown) === null || _b === void 0 || _b.removeChild(this._loadingIndicator);
    };
    FilteredChoiceSet.prototype.showErrorIndicator = function(filter, error) {
        var _a, _b;
        if (filter === ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value)) {
            this.processChoices();
            var errorIndicator = this.getStatusIndicator(error);
            (_b = this._dropdown) === null || _b === void 0 || _b.appendChild(errorIndicator);
            errorIndicator.scrollIntoView();
        }
    };
    Object.defineProperty(FilteredChoiceSet.prototype, "dynamicChoices", {
        get: function() {
            var _a;
            return (_a = this._dynamicChoices) === null || _a === void 0 ? void 0 : _a.map(function(choice) {
                return choice.title;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "hostConfig", {
        get: function() {
            if (this._hostConfig) return this._hostConfig;
            else {
                if (this.parent) return this.parent.hostConfig;
                else return $8kDQQ.defaultHostConfig;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        set: function(value) {
            this._parent = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "renderedElement", {
        get: function() {
            return this._renderedElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "textInput", {
        get: function() {
            return this._textInput;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "dropdown", {
        get: function() {
            return this._dropdown;
        },
        enumerable: false,
        configurable: true
    });
    return FilteredChoiceSet;
}();
module.exports.FilteredChoiceSet = $5104722604b983cb$var$FilteredChoiceSet;
var $5104722604b983cb$var$NumberInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(NumberInput, _super);
    function NumberInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberInput.prototype.internalRender = function() {
        var _this = this;
        this._numberInputElement = document.createElement("input");
        this._numberInputElement.setAttribute("type", "number");
        if (this.min !== undefined) this._numberInputElement.setAttribute("min", this.min.toString());
        if (this.max !== undefined) this._numberInputElement.setAttribute("max", this.max.toString());
        this._numberInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-numberInput");
        this._numberInputElement.style.width = "100%";
        this._numberInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue !== undefined) this._numberInputElement.valueAsNumber = this.defaultValue;
        if (this.placeholder) {
            this._numberInputElement.placeholder = this.placeholder;
            this._numberInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._numberInputElement.oninput = function() {
            _this.valueChanged();
        };
        return this._numberInputElement;
    };
    NumberInput.prototype.getJsonTypeName = function() {
        return "Input.Number";
    };
    NumberInput.prototype.isSet = function() {
        return this.value !== undefined && !isNaN(this.value);
    };
    NumberInput.prototype.isValid = function() {
        if (this.value === undefined) return !this.isRequired;
        var result = true;
        if (this.min !== undefined) result = result && this.value >= this.min;
        if (this.max !== undefined) result = result && this.value <= this.max;
        return result;
    };
    Object.defineProperty(NumberInput.prototype, "value", {
        get: function() {
            return this._numberInputElement ? this._numberInputElement.valueAsNumber : undefined;
        },
        set: function(value) {
            if (value && this._numberInputElement) this._numberInputElement.value = value.toString();
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    NumberInput.valueProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_0, "value");
    NumberInput.placeholderProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "placeholder");
    NumberInput.minProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_0, "min");
    NumberInput.maxProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_0, "max");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(NumberInput.valueProperty)
    ], NumberInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(NumberInput.minProperty)
    ], NumberInput.prototype, "min", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(NumberInput.maxProperty)
    ], NumberInput.prototype, "max", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(NumberInput.placeholderProperty)
    ], NumberInput.prototype, "placeholder", void 0);
    return NumberInput;
}($5104722604b983cb$var$Input);
module.exports.NumberInput = $5104722604b983cb$var$NumberInput;
var $5104722604b983cb$var$DateInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(DateInput, _super);
    function DateInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateInput.prototype.internalRender = function() {
        var _this = this;
        this._dateInputElement = document.createElement("input");
        this._dateInputElement.setAttribute("type", "date");
        if (this.min) this._dateInputElement.setAttribute("min", this.min);
        if (this.max) this._dateInputElement.setAttribute("max", this.max);
        if (this.placeholder) {
            this._dateInputElement.placeholder = this.placeholder;
            this._dateInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._dateInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        this._dateInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-dateInput");
        this._dateInputElement.style.width = "100%";
        this._dateInputElement.oninput = function() {
            _this.valueChanged();
        };
        if (this.defaultValue) this._dateInputElement.value = this.defaultValue;
        return this._dateInputElement;
    };
    DateInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        _super.prototype.updateVisualState.call(this, eventType);
        if (this._dateInputElement && this.inputStyle === $gIXBn.InputStyle.RevealOnHover) {
            var hideDatePicker = this.shouldHideInputAdornersForRevealOnHover(this._dateInputElement, eventType);
            if (hideDatePicker) this._dateInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            else this._dateInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            $5104722604b983cb$var$updateInputAdornersVisibility(this._dateInputElement, hideDatePicker /*hide*/ );
        }
    };
    DateInput.prototype.getJsonTypeName = function() {
        return "Input.Date";
    };
    DateInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    DateInput.prototype.isValid = function() {
        if (!this.value) return !this.isRequired;
        var valueAsDate = new Date(this.value);
        var result = true;
        if (this.min) {
            var minDate = new Date(this.min);
            result = result && valueAsDate >= minDate;
        }
        if (this.max) {
            var maxDate = new Date(this.max);
            result = result && valueAsDate <= maxDate;
        }
        return result;
    };
    Object.defineProperty(DateInput.prototype, "value", {
        get: function() {
            return this._dateInputElement ? this._dateInputElement.value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    DateInput.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    DateInput.placeholderProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "placeholder");
    DateInput.minProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "min");
    DateInput.maxProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "max");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DateInput.valueProperty)
    ], DateInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DateInput.minProperty)
    ], DateInput.prototype, "min", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DateInput.maxProperty)
    ], DateInput.prototype, "max", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DateInput.placeholderProperty)
    ], DateInput.prototype, "placeholder", void 0);
    return DateInput;
}($5104722604b983cb$var$Input);
module.exports.DateInput = $5104722604b983cb$var$DateInput;
var $5104722604b983cb$var$TimeProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TimeProperty, _super);
    function TimeProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, function(sender, prop, source, context) {
            var value = source[prop.name];
            if (typeof value === "string" && value && /^[0-9]{2}:[0-9]{2}$/.test(value)) return value;
            return undefined;
        }, function(sender, prop, target, value, context) {
            context.serializeValue(target, prop.name, value);
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    return TimeProperty;
}($5Ougt.CustomProperty);
module.exports.TimeProperty = $5104722604b983cb$var$TimeProperty;
var $5104722604b983cb$var$TimeInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TimeInput, _super);
    function TimeInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeInput.convertTimeStringToDate = function(timeString) {
        return new Date("1973-09-04T" + timeString + ":00Z");
    };
    TimeInput.prototype.internalRender = function() {
        var _this = this;
        this._timeInputElement = document.createElement("input");
        this._timeInputElement.setAttribute("type", "time");
        if (this.min) this._timeInputElement.setAttribute("min", this.min);
        if (this.max) this._timeInputElement.setAttribute("max", this.max);
        this._timeInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-timeInput");
        this._timeInputElement.style.width = "100%";
        this._timeInputElement.oninput = function() {
            _this.valueChanged();
        };
        if (this.placeholder) {
            this._timeInputElement.placeholder = this.placeholder;
            this._timeInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._timeInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue) this._timeInputElement.value = this.defaultValue;
        return this._timeInputElement;
    };
    TimeInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        _super.prototype.updateVisualState.call(this, eventType);
        if (this._timeInputElement && this.inputStyle === $gIXBn.InputStyle.RevealOnHover) {
            var hideTimePicker = this.shouldHideInputAdornersForRevealOnHover(this._timeInputElement, eventType);
            if (hideTimePicker) this._timeInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            else this._timeInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            $5104722604b983cb$var$updateInputAdornersVisibility(this._timeInputElement, hideTimePicker /*hide*/ );
        }
    };
    TimeInput.prototype.getJsonTypeName = function() {
        return "Input.Time";
    };
    TimeInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    TimeInput.prototype.isValid = function() {
        if (!this.value) return !this.isRequired;
        var valueAsDate = TimeInput.convertTimeStringToDate(this.value);
        var result = true;
        if (this.min) {
            var minDate = TimeInput.convertTimeStringToDate(this.min);
            result = result && valueAsDate >= minDate;
        }
        if (this.max) {
            var maxDate = TimeInput.convertTimeStringToDate(this.max);
            result = result && valueAsDate <= maxDate;
        }
        return result;
    };
    Object.defineProperty(TimeInput.prototype, "value", {
        get: function() {
            return this._timeInputElement ? this._timeInputElement.value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    TimeInput.valueProperty = new $5104722604b983cb$var$TimeProperty($5Ougt.Versions.v1_0, "value");
    TimeInput.placeholderProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "placeholder");
    TimeInput.minProperty = new $5104722604b983cb$var$TimeProperty($5Ougt.Versions.v1_0, "min");
    TimeInput.maxProperty = new $5104722604b983cb$var$TimeProperty($5Ougt.Versions.v1_0, "max");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TimeInput.valueProperty)
    ], TimeInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TimeInput.minProperty)
    ], TimeInput.prototype, "min", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TimeInput.maxProperty)
    ], TimeInput.prototype, "max", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TimeInput.placeholderProperty)
    ], TimeInput.prototype, "placeholder", void 0);
    return TimeInput;
}($5104722604b983cb$var$Input);
module.exports.TimeInput = $5104722604b983cb$var$TimeInput;
var $5104722604b983cb$var$Action = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Action, _super);
    function Action() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = $gIXBn.ActionStyle.Default;
        _this.mode = $gIXBn.ActionMode.Primary;
        _this._state = 0 /* Normal */ ;
        _this._isFocusable = true;
        return _this;
    }
    //#endregion
    Action.prototype.renderButtonContent = function() {
        if (this.renderedElement) {
            // Cache hostConfig for perf
            var hostConfig = this.hostConfig;
            var titleElement = document.createElement("div");
            titleElement.style.overflow = "hidden";
            titleElement.style.textOverflow = "ellipsis";
            if (!(hostConfig.actions.iconPlacement === $gIXBn.ActionIconPlacement.AboveTitle || hostConfig.actions.allowTitleToWrap)) titleElement.style.whiteSpace = "nowrap";
            if (this.title) titleElement.innerText = this.title;
            if (!this.iconUrl) {
                this.renderedElement.classList.add("noIcon");
                this.renderedElement.appendChild(titleElement);
            } else {
                var iconElement = document.createElement("img");
                iconElement.src = this.iconUrl;
                iconElement.style.width = hostConfig.actions.iconSize + "px";
                iconElement.style.height = hostConfig.actions.iconSize + "px";
                iconElement.style.flex = "0 0 auto";
                if (hostConfig.actions.iconPlacement === $gIXBn.ActionIconPlacement.AboveTitle) {
                    this.renderedElement.classList.add("iconAbove");
                    this.renderedElement.style.flexDirection = "column";
                    if (this.title) iconElement.style.marginBottom = "6px";
                } else {
                    this.renderedElement.classList.add("iconLeft");
                    iconElement.style.maxHeight = "100%";
                    if (this.title) iconElement.style.marginRight = "6px";
                }
                this.renderedElement.appendChild(iconElement);
                this.renderedElement.appendChild(titleElement);
            }
        }
    };
    Action.prototype.getParentContainer = function() {
        if (this.parent instanceof $5104722604b983cb$var$Container) return this.parent;
        return this.parent ? this.parent.getParentContainer() : undefined;
    };
    Action.prototype.isDesignMode = function() {
        var rootElement = this.getRootObject();
        return rootElement instanceof $5104722604b983cb$var$CardElement && rootElement.isDesignMode();
    };
    Action.prototype.updateCssClasses = function() {
        var _a, _b;
        if (this.parent && this.renderedElement) {
            var hostConfig = this.parent.hostConfig;
            this.renderedElement.className = hostConfig.makeCssClassName(this.isEffectivelyEnabled() ? "ac-pushButton" : "ac-pushButton-disabled");
            var parentContainer = this.getParentContainer();
            if (parentContainer) {
                var parentContainerStyle = parentContainer.getEffectiveStyle();
                if (parentContainerStyle) this.renderedElement.classList.add("style-" + parentContainerStyle);
            }
            this.renderedElement.tabIndex = !this.isDesignMode() && this.isFocusable ? 0 : -1;
            switch(this._state){
                case 0 /* Normal */ :
                    break;
                case 1 /* Expanded */ :
                    this.renderedElement.classList.add(hostConfig.makeCssClassName("expanded"));
                    break;
                case 2 /* Subdued */ :
                    this.renderedElement.classList.add(hostConfig.makeCssClassName("subdued"));
                    break;
            }
            if (this.style && this.isEffectivelyEnabled()) {
                if (this.style === $gIXBn.ActionStyle.Positive) (_a = this.renderedElement.classList).add.apply(_a, hostConfig.makeCssClassNames("primary", "style-positive"));
                else (_b = this.renderedElement.classList).add.apply(_b, hostConfig.makeCssClassNames("style-" + this.style.toLowerCase()));
            }
        }
    };
    Action.prototype.getDefaultSerializationContext = function() {
        return new $5104722604b983cb$var$SerializationContext();
    };
    Action.prototype.internalGetReferencedInputs = function() {
        return {};
    };
    Action.prototype.internalPrepareForExecution = function(_inputs) {
    // Do nothing in base implementation
    };
    Action.prototype.internalValidateInputs = function(referencedInputs) {
        var result = [];
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            if (!input.validateValue()) result.push(input);
        }
        return result;
    };
    Action.prototype.shouldSerialize = function(context) {
        return context.actionRegistry.findByName(this.getJsonTypeName()) !== undefined;
    };
    Action.prototype.raiseExecuteActionEvent = function() {
        if (this.onExecute) this.onExecute(this);
        $5104722604b983cb$var$raiseExecuteActionEvent(this);
    };
    Action.prototype.internalAfterExecute = function() {
        var rootObject = this.getRootObject();
        if (rootObject instanceof $5104722604b983cb$var$CardElement) rootObject.updateActionsEnabledState();
    };
    Action.prototype.getHref = function() {
        return "";
    };
    Action.prototype.getAriaRole = function() {
        var ariaRole = this.getAriaRoleFromEnum();
        return ariaRole !== null && ariaRole !== void 0 ? ariaRole : "button";
    };
    Action.prototype.getAriaRoleFromEnum = function() {
        switch(this.role){
            case $gIXBn.ActionRole.Button:
                return "button";
            case $gIXBn.ActionRole.Link:
                return "link";
            case $gIXBn.ActionRole.Menu:
                return "menu";
            case $gIXBn.ActionRole.MenuItem:
                return "menuitem";
            case $gIXBn.ActionRole.Tab:
                return "tab";
            default:
                return undefined;
        }
    };
    Action.prototype.setupElementForAccessibility = function(element, promoteTooltipToLabel) {
        if (promoteTooltipToLabel === void 0) promoteTooltipToLabel = false;
        element.tabIndex = this.isEffectivelyEnabled() && !this.isDesignMode() ? 0 : -1;
        element.setAttribute("role", this.getAriaRole());
        if (element instanceof HTMLButtonElement) element.disabled = !this.isEffectivelyEnabled();
        if (!this.isEffectivelyEnabled()) element.setAttribute("aria-disabled", "true");
        else {
            element.removeAttribute("aria-disabled");
            element.classList.add(this.hostConfig.makeCssClassName("ac-selectable"));
        }
        if (this.title) {
            element.setAttribute("aria-label", this.title);
            element.title = this.title;
        } else {
            element.removeAttribute("aria-label");
            element.removeAttribute("title");
        }
        if (this.tooltip) {
            if (promoteTooltipToLabel && !this.title) element.setAttribute("aria-label", this.tooltip);
            element.title = this.tooltip;
        }
    };
    Action.prototype.parse = function(source, context) {
        return _super.prototype.parse.call(this, source, context ? context : new $5104722604b983cb$var$SerializationContext());
    };
    Action.prototype.render = function() {
        var _this = this;
        var buttonElement = document.createElement("button");
        buttonElement.type = "button";
        buttonElement.style.display = "flex";
        buttonElement.style.alignItems = "center";
        buttonElement.style.justifyContent = "center";
        buttonElement.onclick = function(e) {
            if (_this.isEffectivelyEnabled()) {
                e.preventDefault();
                e.cancelBubble = true;
                _this.execute();
            }
        };
        this._renderedElement = buttonElement;
        this.renderButtonContent();
        this.updateCssClasses();
        this.setupElementForAccessibility(buttonElement);
    };
    Action.prototype.execute = function() {
        if (this._actionCollection) this._actionCollection.actionExecuted(this);
        this.raiseExecuteActionEvent();
        this.internalAfterExecute();
    };
    Action.prototype.prepareForExecution = function() {
        var referencedInputs = this.getReferencedInputs();
        var invalidInputs = this.internalValidateInputs(referencedInputs);
        if (invalidInputs.length > 0) {
            invalidInputs[0].focus();
            return false;
        }
        this.internalPrepareForExecution(referencedInputs);
        return true;
    };
    Action.prototype.remove = function() {
        if (this._actionCollection) return this._actionCollection.removeAction(this);
        return false;
    };
    Action.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [];
    };
    Action.prototype.getAllActions = function() {
        return [
            this
        ];
    };
    Action.prototype.getResourceInformation = function() {
        return this.iconUrl ? [
            {
                url: this.iconUrl,
                mimeType: "image"
            }
        ] : [];
    };
    Action.prototype.getActionById = function(id) {
        return this.id === id ? this : undefined;
    };
    Action.prototype.getReferencedInputs = function() {
        return this.internalGetReferencedInputs();
    };
    /**
     * Validates the inputs associated with this action.
     *
     * @returns A list of inputs that failed validation, or an empty array if no input failed validation.
     */ Action.prototype.validateInputs = function() {
        return this.internalValidateInputs(this.getReferencedInputs());
    };
    Action.prototype.updateEnabledState = function() {
    // Do nothing in base implementation
    };
    Action.prototype.isEffectivelyEnabled = function() {
        return this.isEnabled;
    };
    Object.defineProperty(Action.prototype, "isPrimary", {
        get: function() {
            return this.style === $gIXBn.ActionStyle.Positive;
        },
        set: function(value) {
            if (value) this.style = $gIXBn.ActionStyle.Positive;
            else if (this.style === $gIXBn.ActionStyle.Positive) this.style = $gIXBn.ActionStyle.Default;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "hostConfig", {
        get: function() {
            return this.parent ? this.parent.hostConfig : $8kDQQ.defaultHostConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "state", {
        get: function() {
            return this._state;
        },
        set: function(value) {
            if (this._state !== value) {
                this._state = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "isFocusable", {
        get: function() {
            return this._isFocusable;
        },
        set: function(value) {
            if (this._isFocusable !== value) {
                this._isFocusable = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    Action.titleProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "title");
    Action.iconUrlProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "iconUrl");
    Action.styleProperty = new $5Ougt.ValueSetProperty($5Ougt.Versions.v1_2, "style", [
        {
            value: $gIXBn.ActionStyle.Default
        },
        {
            value: $gIXBn.ActionStyle.Positive
        },
        {
            value: $gIXBn.ActionStyle.Destructive
        }
    ], $gIXBn.ActionStyle.Default);
    Action.modeProperty = new $5Ougt.ValueSetProperty($5Ougt.Versions.v1_5, "mode", [
        {
            value: $gIXBn.ActionMode.Primary
        },
        {
            value: $gIXBn.ActionMode.Secondary
        }
    ], $gIXBn.ActionMode.Primary);
    Action.tooltipProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_5, "tooltip");
    Action.isEnabledProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_5, "isEnabled", true);
    Action.roleProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_6, "role", $gIXBn.ActionRole);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.titleProperty)
    ], Action.prototype, "title", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.iconUrlProperty)
    ], Action.prototype, "iconUrl", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.styleProperty)
    ], Action.prototype, "style", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.modeProperty)
    ], Action.prototype, "mode", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.tooltipProperty)
    ], Action.prototype, "tooltip", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.isEnabledProperty)
    ], Action.prototype, "isEnabled", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.roleProperty)
    ], Action.prototype, "role", void 0);
    return Action;
}($dUjDB.CardObject);
module.exports.Action = $5104722604b983cb$var$Action;
var $5104722604b983cb$var$SubmitActionBase = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(SubmitActionBase, _super);
    function SubmitActionBase() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disabledUnlessAssociatedInputsChange = false;
        //#endregion
        _this._isPrepared = false;
        _this._areReferencedInputsDirty = false;
        return _this;
    }
    SubmitActionBase.prototype.internalGetReferencedInputs = function() {
        var result = {};
        if (this.associatedInputs !== "none") {
            var current = this.parent;
            var inputs = [];
            while(current){
                inputs.push.apply(inputs, current.getAllInputs(false));
                current = current.parent;
            }
            for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
                var input = inputs_1[_i];
                if (input.id) result[input.id] = input;
            }
        }
        return result;
    };
    SubmitActionBase.prototype.internalPrepareForExecution = function(inputs) {
        if (this._originalData) this._processedData = JSON.parse(JSON.stringify(this._originalData));
        else this._processedData = {};
        if (this._processedData && inputs) for(var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = inputs[key];
            if (input.id && input.isSet()) this._processedData[input.id] = typeof input.value === "string" ? input.value : input.value.toString();
        }
        this._isPrepared = true;
    };
    SubmitActionBase.prototype.internalAfterExecute = function() {
        if ($6BHj7.GlobalSettings.resetInputsDirtyStateAfterActionExecution) this.resetReferencedInputsDirtyState();
    };
    SubmitActionBase.prototype.resetReferencedInputsDirtyState = function() {
        var referencedInputs = this.getReferencedInputs();
        this._areReferencedInputsDirty = false;
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            input.resetDirtyState();
        }
    };
    SubmitActionBase.prototype.updateEnabledState = function() {
        this._areReferencedInputsDirty = false;
        var referencedInputs = this.getReferencedInputs();
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            if (input.isDirty()) {
                this._areReferencedInputsDirty = true;
                break;
            }
        }
        this.updateCssClasses();
        if (this._renderedElement) this.setupElementForAccessibility(this._renderedElement);
    };
    SubmitActionBase.prototype.isEffectivelyEnabled = function() {
        var result = _super.prototype.isEffectivelyEnabled.call(this);
        return this.disabledUnlessAssociatedInputsChange ? result && this._areReferencedInputsDirty : result;
    };
    Object.defineProperty(SubmitActionBase.prototype, "data", {
        get: function() {
            return this._isPrepared ? this._processedData : this._originalData;
        },
        set: function(value) {
            this._originalData = value;
            this._isPrepared = false;
        },
        enumerable: false,
        configurable: true
    });
    SubmitActionBase.dataProperty = new $5Ougt.PropertyDefinition($5Ougt.Versions.v1_0, "data");
    SubmitActionBase.associatedInputsProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_3, "associatedInputs", function(sender, prop, source, context) {
        var value = source[prop.name];
        if (value !== undefined && typeof value === "string") return value.toLowerCase() === "none" ? "none" : "auto";
        return undefined;
    }, function(sender, prop, target, value, context) {
        context.serializeValue(target, prop.name, value);
    });
    SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_6, "disabledUnlessAssociatedInputsChange", false);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(SubmitActionBase.dataProperty)
    ], SubmitActionBase.prototype, "_originalData", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(SubmitActionBase.associatedInputsProperty)
    ], SubmitActionBase.prototype, "associatedInputs", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty)
    ], SubmitActionBase.prototype, "disabledUnlessAssociatedInputsChange", void 0);
    return SubmitActionBase;
}($5104722604b983cb$var$Action);
module.exports.SubmitActionBase = $5104722604b983cb$var$SubmitActionBase;
var $5104722604b983cb$var$SubmitAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(SubmitAction, _super);
    function SubmitAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubmitAction.prototype.getJsonTypeName = function() {
        return SubmitAction.JsonTypeName;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    SubmitAction.JsonTypeName = "Action.Submit";
    return SubmitAction;
}($5104722604b983cb$var$SubmitActionBase);
module.exports.SubmitAction = $5104722604b983cb$var$SubmitAction;
var $5104722604b983cb$var$UniversalAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(UniversalAction, _super);
    function UniversalAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UniversalAction;
}($5104722604b983cb$var$SubmitActionBase);
module.exports.UniversalAction = $5104722604b983cb$var$UniversalAction;
var $5104722604b983cb$var$ExecuteAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ExecuteAction, _super);
    function ExecuteAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    ExecuteAction.prototype.getJsonTypeName = function() {
        return ExecuteAction.JsonTypeName;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ExecuteAction.JsonTypeName = "Action.Execute";
    //#region Schema
    ExecuteAction.verbProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "verb");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ExecuteAction.verbProperty)
    ], ExecuteAction.prototype, "verb", void 0);
    return ExecuteAction;
}($5104722604b983cb$var$UniversalAction);
module.exports.ExecuteAction = $5104722604b983cb$var$ExecuteAction;
var $5104722604b983cb$var$DataQuery = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(DataQuery, _super);
    function DataQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    DataQuery.prototype.getJsonTypeName = function() {
        return DataQuery.JsonTypeName;
    };
    Object.defineProperty(DataQuery.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    DataQuery.JsonTypeName = "Data.Query";
    //#region Schema
    DataQuery.datasetProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_6, "dataset");
    DataQuery.filterProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_6, "filter");
    DataQuery.countProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "count");
    DataQuery.skipProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "skip");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DataQuery.datasetProperty)
    ], DataQuery.prototype, "dataset", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DataQuery.filterProperty)
    ], DataQuery.prototype, "filter", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DataQuery.countProperty)
    ], DataQuery.prototype, "count", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DataQuery.skipProperty)
    ], DataQuery.prototype, "skip", void 0);
    return DataQuery;
}($5104722604b983cb$var$UniversalAction);
module.exports.DataQuery = $5104722604b983cb$var$DataQuery;
var $5104722604b983cb$var$OpenUrlAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(OpenUrlAction, _super);
    function OpenUrlAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenUrlAction.prototype.getJsonTypeName = function() {
        return OpenUrlAction.JsonTypeName;
    };
    OpenUrlAction.prototype.getAriaRole = function() {
        var ariaRole = this.getAriaRoleFromEnum();
        return ariaRole !== null && ariaRole !== void 0 ? ariaRole : "link";
    };
    OpenUrlAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.url) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.propertyMustBeSet("url"));
    };
    OpenUrlAction.prototype.getHref = function() {
        return this.url;
    };
    //#region Schema
    OpenUrlAction.urlProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "url");
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    OpenUrlAction.JsonTypeName = "Action.OpenUrl";
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(OpenUrlAction.urlProperty)
    ], OpenUrlAction.prototype, "url", void 0);
    return OpenUrlAction;
}($5104722604b983cb$var$Action);
module.exports.OpenUrlAction = $5104722604b983cb$var$OpenUrlAction;
var $5104722604b983cb$var$ToggleVisibilityAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ToggleVisibilityAction, _super);
    function ToggleVisibilityAction() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.targetElements = {};
        return _this;
    }
    ToggleVisibilityAction.prototype.updateAriaControlsAttribute = function() {
        // apply aria labels to make it clear which elements this action will toggle
        if (this.targetElements) {
            var elementIds = Object.keys(this.targetElements);
            if (this._renderedElement) {
                if (elementIds.length > 0) this._renderedElement.setAttribute("aria-controls", elementIds.join(" "));
                else this._renderedElement.removeAttribute("aria-controls");
            }
        }
    };
    ToggleVisibilityAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.targetElements) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.propertyMustBeSet("targetElements"));
    };
    ToggleVisibilityAction.prototype.getJsonTypeName = function() {
        return ToggleVisibilityAction.JsonTypeName;
    };
    ToggleVisibilityAction.prototype.render = function() {
        _super.prototype.render.call(this);
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.prototype.execute = function() {
        _super.prototype.execute.call(this);
        if (this.parent) for(var _i = 0, _a = Object.keys(this.targetElements); _i < _a.length; _i++){
            var elementId = _a[_i];
            var targetElement = this.parent.getRootElement().getElementById(elementId);
            if (targetElement) {
                if (typeof this.targetElements[elementId] === "boolean") targetElement.isVisible = this.targetElements[elementId];
                else targetElement.isVisible = !targetElement.isVisible;
            }
        }
    };
    ToggleVisibilityAction.prototype.addTargetElement = function(elementId, isVisible) {
        if (isVisible === void 0) isVisible = undefined;
        this.targetElements[elementId] = isVisible;
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.prototype.removeTargetElement = function(elementId) {
        delete this.targetElements[elementId];
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.targetElementsProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_2, "targetElements", function(sender, prop, source, context) {
        var result = {};
        if (Array.isArray(source[prop.name])) for(var _i = 0, _a = source[prop.name]; _i < _a.length; _i++){
            var item = _a[_i];
            if (typeof item === "string") result[item] = undefined;
            else if (typeof item === "object") {
                var elementId = item["elementId"];
                if (typeof elementId === "string") result[elementId] = $F6YrP.parseBool(item["isVisible"]);
            }
        }
        return result;
    }, function(sender, prop, target, value, context) {
        var targetElements = [];
        for(var _i = 0, _a = Object.keys(value); _i < _a.length; _i++){
            var id = _a[_i];
            if (typeof value[id] === "boolean") targetElements.push({
                elementId: id,
                isVisible: value[id]
            });
            else targetElements.push(id);
        }
        context.serializeArray(target, prop.name, targetElements);
    }, {}, function(sender) {
        return {};
    });
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ToggleVisibilityAction.JsonTypeName = "Action.ToggleVisibility";
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleVisibilityAction.targetElementsProperty)
    ], ToggleVisibilityAction.prototype, "targetElements", void 0);
    return ToggleVisibilityAction;
}($5104722604b983cb$var$Action);
module.exports.ToggleVisibilityAction = $5104722604b983cb$var$ToggleVisibilityAction;
var $5104722604b983cb$var$StringWithSubstitutionProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(StringWithSubstitutionProperty, _super);
    function StringWithSubstitutionProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, undefined, function() {
            return new $6BHj7.StringWithSubstitutions();
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    StringWithSubstitutionProperty.prototype.parse = function(sender, source, context) {
        var result = new $6BHj7.StringWithSubstitutions();
        result.set($F6YrP.parseString(source[this.name]));
        return result;
    };
    StringWithSubstitutionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value.getOriginal());
    };
    return StringWithSubstitutionProperty;
}($5Ougt.PropertyDefinition);
var $5104722604b983cb$var$HttpHeader = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(HttpHeader, _super);
    //#endregion
    function HttpHeader(name, value) {
        if (name === void 0) name = "";
        if (value === void 0) value = "";
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    HttpHeader.prototype.getSchemaKey = function() {
        return "HttpHeader";
    };
    HttpHeader.prototype.getReferencedInputs = function(inputs, referencedInputs) {
        this._value.getReferencedInputs(inputs, referencedInputs);
    };
    HttpHeader.prototype.prepareForExecution = function(inputs) {
        this._value.substituteInputValues(inputs, $6BHj7.ContentTypes.applicationXWwwFormUrlencoded);
    };
    Object.defineProperty(HttpHeader.prototype, "value", {
        get: function() {
            return this._value.get();
        },
        set: function(newValue) {
            this._value.set(newValue);
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    HttpHeader.nameProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "name");
    HttpHeader.valueProperty = new $5104722604b983cb$var$StringWithSubstitutionProperty($5Ougt.Versions.v1_0, "value");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpHeader.nameProperty)
    ], HttpHeader.prototype, "name", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpHeader.valueProperty)
    ], HttpHeader.prototype, "_value", void 0);
    return HttpHeader;
}($5Ougt.SerializableObject);
module.exports.HttpHeader = $5104722604b983cb$var$HttpHeader;
var $5104722604b983cb$var$HttpAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(HttpAction, _super);
    function HttpAction() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._ignoreInputValidation = false;
        return _this;
    }
    HttpAction.prototype.internalGetReferencedInputs = function() {
        var allInputs = this.parent ? this.parent.getRootElement().getAllInputs() : [];
        var result = {};
        this._url.getReferencedInputs(allInputs, result);
        for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
            var header = _a[_i];
            header.getReferencedInputs(allInputs, result);
        }
        this._body.getReferencedInputs(allInputs, result);
        return result;
    };
    HttpAction.prototype.internalPrepareForExecution = function(inputs) {
        if (inputs) {
            this._url.substituteInputValues(inputs, $6BHj7.ContentTypes.applicationXWwwFormUrlencoded);
            var contentType = $6BHj7.ContentTypes.applicationJson;
            for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
                var header = _a[_i];
                header.prepareForExecution(inputs);
                if (header.name && header.name.toLowerCase() === "content-type") contentType = header.value;
            }
            this._body.substituteInputValues(inputs, contentType);
        }
    };
    HttpAction.prototype.getJsonTypeName = function() {
        return HttpAction.JsonTypeName;
    };
    HttpAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.url) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.propertyMustBeSet("url"));
        if (this.headers.length > 0) for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
            var header = _a[_i];
            if (!header.name) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.actionHttpHeadersMustHaveNameAndValue());
        }
    };
    Object.defineProperty(HttpAction.prototype, "ignoreInputValidation", {
        get: function() {
            return this._ignoreInputValidation;
        },
        set: function(value) {
            this._ignoreInputValidation = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpAction.prototype, "url", {
        get: function() {
            return this._url.get();
        },
        set: function(value) {
            this._url.set(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpAction.prototype, "body", {
        get: function() {
            return this._body.get();
        },
        set: function(value) {
            this._body.set(value);
        },
        enumerable: false,
        configurable: true
    });
    HttpAction.urlProperty = new $5104722604b983cb$var$StringWithSubstitutionProperty($5Ougt.Versions.v1_0, "url");
    HttpAction.bodyProperty = new $5104722604b983cb$var$StringWithSubstitutionProperty($5Ougt.Versions.v1_0, "body");
    HttpAction.methodProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "method");
    HttpAction.headersProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_0, "headers", $5104722604b983cb$var$HttpHeader);
    HttpAction.ignoreInputValidationProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_3, "ignoreInputValidation", false);
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    HttpAction.JsonTypeName = "Action.Http";
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpAction.urlProperty)
    ], HttpAction.prototype, "_url", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpAction.bodyProperty)
    ], HttpAction.prototype, "_body", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpAction.methodProperty)
    ], HttpAction.prototype, "method", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpAction.headersProperty)
    ], HttpAction.prototype, "headers", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpAction.ignoreInputValidationProperty)
    ], HttpAction.prototype, "_ignoreInputValidation", void 0);
    return HttpAction;
}($5104722604b983cb$var$Action);
module.exports.HttpAction = $5104722604b983cb$var$HttpAction;
var $5104722604b983cb$var$ShowCardAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ShowCardAction, _super);
    function ShowCardAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.card = new $5104722604b983cb$var$InlineAdaptiveCard();
        return _this;
    }
    ShowCardAction.prototype.updateCssClasses = function() {
        _super.prototype.updateCssClasses.call(this);
        if (this.renderedElement) {
            var effectiveHostConfig = this.parent ? this.parent.hostConfig : $8kDQQ.defaultHostConfig;
            this.renderedElement.classList.add(effectiveHostConfig.makeCssClassName("expandable"));
            this.renderedElement.setAttribute("aria-expanded", (this.state === 1 /* Expanded */ ).toString());
        }
    };
    ShowCardAction.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        var jsonCard = source["card"];
        if (jsonCard) this.card.parse(jsonCard, context);
        else context.logParseEvent(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.showCardMustHaveCard());
    };
    ShowCardAction.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        if (this.card) context.serializeValue(target, "card", this.card.toJSON(context));
    };
    ShowCardAction.prototype.raiseExecuteActionEvent = function() {
        if (this.hostConfig.actions.showCard.actionMode === $gIXBn.ShowCardActionMode.Popup) // Only raise the event in Popup mode.
        _super.prototype.raiseExecuteActionEvent.call(this);
    };
    ShowCardAction.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this.card.releaseDOMResources();
    };
    ShowCardAction.prototype.getJsonTypeName = function() {
        return ShowCardAction.JsonTypeName;
    };
    ShowCardAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        this.card.internalValidateProperties(context);
    };
    ShowCardAction.prototype.setParent = function(value) {
        _super.prototype.setParent.call(this, value);
        this.card.setParent(value);
    };
    ShowCardAction.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return this.card.getAllInputs(processActions);
    };
    ShowCardAction.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        result.push.apply(result, this.card.getAllActions());
        return result;
    };
    ShowCardAction.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        result.push.apply(result, this.card.getResourceInformation());
        return result;
    };
    ShowCardAction.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result) result = this.card.getActionById(id);
        return result;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ShowCardAction.JsonTypeName = "Action.ShowCard";
    return ShowCardAction;
}($5104722604b983cb$var$Action);
module.exports.ShowCardAction = $5104722604b983cb$var$ShowCardAction;
var $5104722604b983cb$var$OverflowAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(OverflowAction, _super);
    function OverflowAction(actions) {
        var _this = _super.call(this) || this;
        _this._actions = actions;
        _this.title = $24F6S.Strings.defaults.overflowButtonText();
        _this.tooltip = $24F6S.Strings.defaults.overflowButtonTooltip();
        return _this;
    }
    OverflowAction.prototype.getActions = function() {
        return this._actions;
    };
    OverflowAction.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        result.push.apply(result, this._actions);
        return result;
    };
    OverflowAction.prototype.getJsonTypeName = function() {
        return $5104722604b983cb$var$ShowCardAction.JsonTypeName;
    };
    OverflowAction.prototype.execute = function() {
        var _this = this;
        var _a;
        var shouldDisplayPopupMenu = !$5104722604b983cb$var$raiseDisplayOverflowActionMenuEvent(this, this.renderedElement);
        if (shouldDisplayPopupMenu && this.renderedElement) {
            var contextMenu_1 = new $iX2Kh.PopupMenu();
            contextMenu_1.hostConfig = this.hostConfig;
            var _loop_2 = function(i) {
                var menuItem = new $iX2Kh.MenuItem(i.toString(), (_a = this_1._actions[i].title) !== null && _a !== void 0 ? _a : "");
                menuItem.isEnabled = this_1._actions[i].isEnabled;
                menuItem.onClick = function() {
                    var actionToExecute = _this._actions[i];
                    contextMenu_1.closePopup(false);
                    if (actionToExecute.isEnabled) actionToExecute.execute();
                };
                contextMenu_1.items.add(menuItem);
            };
            var this_1 = this;
            for(var i = 0; i < this._actions.length; i++)_loop_2(i);
            contextMenu_1.onClose = function() {
                var _a;
                (_a = _this.renderedElement) === null || _a === void 0 || _a.setAttribute("aria-expanded", "false");
            };
            this.renderedElement.setAttribute("aria-expanded", "true");
            contextMenu_1.popup(this.renderedElement);
        }
    };
    OverflowAction.prototype.setupElementForAccessibility = function(element, promoteTooltipToLabel) {
        if (promoteTooltipToLabel === void 0) promoteTooltipToLabel = false;
        _super.prototype.setupElementForAccessibility.call(this, element, promoteTooltipToLabel);
        element.setAttribute("aria-label", $24F6S.Strings.defaults.overflowButtonTooltip());
        element.setAttribute("aria-expanded", "false");
    };
    OverflowAction.JsonTypeName = "Action.Overflow";
    return OverflowAction;
}($5104722604b983cb$var$Action);
var $5104722604b983cb$var$ActionCollection = /** @class */ function() {
    function ActionCollection(owner) {
        this._items = [];
        this._renderedActions = [];
        this._owner = owner;
    }
    ActionCollection.prototype.isActionAllowed = function(action) {
        var forbiddenTypes = this._owner.getForbiddenActionTypes();
        if (forbiddenTypes) for(var _i = 0, forbiddenTypes_1 = forbiddenTypes; _i < forbiddenTypes_1.length; _i++){
            var forbiddenType = forbiddenTypes_1[_i];
            if (action.constructor === forbiddenType) return false;
        }
        return true;
    };
    ActionCollection.prototype.refreshContainer = function() {
        $5104722604b983cb$var$clearElement(this._actionCardContainer);
        if (!this._actionCard) {
            this._actionCardContainer.style.marginTop = "0px";
            return;
        }
        this._actionCardContainer.style.marginTop = this.renderedActionCount > 0 ? this._owner.hostConfig.actions.showCard.inlineTopMargin + "px" : "0px";
        var padding = this._owner.getEffectivePadding();
        this._owner.getImmediateSurroundingPadding(padding);
        var physicalPadding = this._owner.hostConfig.paddingDefinitionToSpacingDefinition(padding);
        if (this._actionCard) {
            this._actionCard.style.paddingLeft = physicalPadding.left + "px";
            this._actionCard.style.paddingRight = physicalPadding.right + "px";
            this._actionCard.style.marginLeft = "-" + physicalPadding.left + "px";
            this._actionCard.style.marginRight = "-" + physicalPadding.right + "px";
            if (physicalPadding.bottom !== 0 && !this._owner.isDesignMode()) {
                this._actionCard.style.paddingBottom = physicalPadding.bottom + "px";
                this._actionCard.style.marginBottom = "-" + physicalPadding.bottom + "px";
            }
            $F6YrP.appendChild(this._actionCardContainer, this._actionCard);
        }
    };
    ActionCollection.prototype.layoutChanged = function() {
        this._owner.getRootElement().updateLayout();
    };
    ActionCollection.prototype.showActionCard = function(action, suppressStyle, raiseEvent) {
        if (suppressStyle === void 0) suppressStyle = false;
        if (raiseEvent === void 0) raiseEvent = true;
        action.card.suppressStyle = suppressStyle;
        // Always re-render a ShowCard action in design mode; reuse already rendered ShowCard (if available) otherwise
        var renderedCard = action.card.renderedElement && !this._owner.isDesignMode() ? action.card.renderedElement : action.card.render();
        this._actionCard = renderedCard;
        this._expandedAction = action;
        this.refreshContainer();
        if (raiseEvent) {
            this.layoutChanged();
            $5104722604b983cb$var$raiseInlineCardExpandedEvent(action, true);
        }
    };
    ActionCollection.prototype.collapseExpandedAction = function() {
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var action = _a[_i];
            action.state = 0 /* Normal */ ;
        }
        var previouslyExpandedAction = this._expandedAction;
        this._expandedAction = undefined;
        this._actionCard = undefined;
        this.refreshContainer();
        if (previouslyExpandedAction) {
            this.layoutChanged();
            $5104722604b983cb$var$raiseInlineCardExpandedEvent(previouslyExpandedAction, false);
        }
    };
    ActionCollection.prototype.expandShowCardAction = function(action, raiseEvent) {
        var _this = this;
        var afterSelectedAction = false;
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var renderedAction = _a[_i];
            // Remove actions after selected action from tabOrder if the actions are oriented horizontally, to skip focus directly to expanded card
            if (this._owner.hostConfig.actions.actionsOrientation == $gIXBn.Orientation.Horizontal && afterSelectedAction) renderedAction.isFocusable = false;
            if (renderedAction !== action) renderedAction.state = 2 /* Subdued */ ;
            else {
                renderedAction.state = 1 /* Expanded */ ;
                afterSelectedAction = true;
                if (renderedAction.renderedElement) renderedAction.renderedElement.onblur = function(_e) {
                    for(var _i = 0, _a = _this._renderedActions; _i < _a.length; _i++){
                        var ra = _a[_i];
                        ra.isFocusable = true;
                    }
                };
            }
        }
        this.showActionCard(action, !(this._owner.isAtTheVeryLeft() && this._owner.isAtTheVeryRight()), raiseEvent);
    };
    ActionCollection.prototype.releaseDOMResources = function() {
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var action = _a[_i];
            action.releaseDOMResources();
        }
    };
    ActionCollection.prototype.actionExecuted = function(action) {
        if (!(action instanceof $5104722604b983cb$var$ShowCardAction)) this.collapseExpandedAction();
        else {
            if (action === this._expandedAction) this.collapseExpandedAction();
            else if (this._owner.hostConfig.actions.showCard.actionMode === $gIXBn.ShowCardActionMode.Inline) this.expandShowCardAction(action, true);
        }
    };
    ActionCollection.prototype.parse = function(source, context) {
        this.clear();
        if (Array.isArray(source)) for(var _i = 0, source_1 = source; _i < source_1.length; _i++){
            var jsonAction = source_1[_i];
            var forbiddenActions = [];
            // If the action owner is a ContainerWithActions, we should check for forbidden actions
            if (this._owner instanceof $5104722604b983cb$var$ContainerWithActions) forbiddenActions = this._owner.getForbiddenActionNames();
            var action = context.parseAction(this._owner, jsonAction, forbiddenActions, !this._owner.isDesignMode());
            if (action) this.addAction(action);
        }
    };
    ActionCollection.prototype.toJSON = function(target, propertyName, context) {
        context.serializeArray(target, propertyName, this._items);
    };
    ActionCollection.prototype.getActionAt = function(id) {
        return this._items[id];
    };
    ActionCollection.prototype.getActionCount = function() {
        return this._items.length;
    };
    ActionCollection.prototype.getActionById = function(id) {
        var result = undefined;
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            result = item.getActionById(id);
            if (result) break;
        }
        return result;
    };
    ActionCollection.prototype.validateProperties = function(context) {
        if (this._owner.hostConfig.actions.maxActions && this._items.length > this._owner.hostConfig.actions.maxActions) context.addFailure(this._owner, $gIXBn.ValidationEvent.TooManyActions, $24F6S.Strings.errors.tooManyActions(this._owner.hostConfig.actions.maxActions));
        if (this._items.length > 0 && !this._owner.hostConfig.supportsInteractivity) context.addFailure(this._owner, $gIXBn.ValidationEvent.InteractivityNotAllowed, $24F6S.Strings.errors.interactivityNotAllowed());
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            if (!this.isActionAllowed(item)) context.addFailure(this._owner, $gIXBn.ValidationEvent.ActionTypeNotAllowed, $24F6S.Strings.errors.actionTypeNotAllowed(item.getJsonTypeName()));
            item.internalValidateProperties(context);
        }
    };
    ActionCollection.prototype.render = function(orientation) {
        // Cache hostConfig for better perf
        var hostConfig = this._owner.hostConfig;
        if (!hostConfig.supportsInteractivity) return undefined;
        var element = document.createElement("div");
        var maxActions = hostConfig.actions.maxActions ? Math.min(hostConfig.actions.maxActions, this._items.length) : this._items.length;
        this._actionCardContainer = document.createElement("div");
        this._renderedActions = [];
        if (hostConfig.actions.preExpandSingleShowCardAction && maxActions === 1 && this._items[0] instanceof $5104722604b983cb$var$ShowCardAction && this.isActionAllowed(this._items[0])) {
            this.showActionCard(this._items[0], true);
            this._renderedActions.push(this._items[0]);
        } else {
            var buttonStrip = document.createElement("div");
            buttonStrip.className = hostConfig.makeCssClassName("ac-actionSet");
            buttonStrip.style.display = "flex";
            if (orientation === $gIXBn.Orientation.Horizontal) {
                buttonStrip.style.flexDirection = "row";
                if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== $gIXBn.ActionAlignment.Stretch) switch(this._owner.horizontalAlignment){
                    case $gIXBn.HorizontalAlignment.Center:
                        buttonStrip.style.justifyContent = "center";
                        break;
                    case $gIXBn.HorizontalAlignment.Right:
                        buttonStrip.style.justifyContent = "flex-end";
                        break;
                    default:
                        buttonStrip.style.justifyContent = "flex-start";
                        break;
                }
                else switch(hostConfig.actions.actionAlignment){
                    case $gIXBn.ActionAlignment.Center:
                        buttonStrip.style.justifyContent = "center";
                        break;
                    case $gIXBn.ActionAlignment.Right:
                        buttonStrip.style.justifyContent = "flex-end";
                        break;
                    default:
                        buttonStrip.style.justifyContent = "flex-start";
                        break;
                }
            } else {
                buttonStrip.style.flexDirection = "column";
                if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== $gIXBn.ActionAlignment.Stretch) switch(this._owner.horizontalAlignment){
                    case $gIXBn.HorizontalAlignment.Center:
                        buttonStrip.style.alignItems = "center";
                        break;
                    case $gIXBn.HorizontalAlignment.Right:
                        buttonStrip.style.alignItems = "flex-end";
                        break;
                    default:
                        buttonStrip.style.alignItems = "flex-start";
                        break;
                }
                else switch(hostConfig.actions.actionAlignment){
                    case $gIXBn.ActionAlignment.Center:
                        buttonStrip.style.alignItems = "center";
                        break;
                    case $gIXBn.ActionAlignment.Right:
                        buttonStrip.style.alignItems = "flex-end";
                        break;
                    case $gIXBn.ActionAlignment.Stretch:
                        buttonStrip.style.alignItems = "stretch";
                        break;
                    default:
                        buttonStrip.style.alignItems = "flex-start";
                        break;
                }
            }
            var allowedActions = this._items.filter(this.isActionAllowed.bind(this));
            var primaryActions_1 = [];
            var secondaryActions_1 = [];
            if (!this._owner.isDesignMode()) {
                allowedActions.forEach(function(action) {
                    return action.mode === $gIXBn.ActionMode.Secondary ? secondaryActions_1.push(action) : primaryActions_1.push(action);
                });
                // If primaryActions.length > maxActions, extra actions are moved to overflow
                var overflowPrimaryActions = primaryActions_1.splice(hostConfig.actions.maxActions);
                if ($6BHj7.GlobalSettings.allowMoreThanMaxActionsInOverflowMenu) secondaryActions_1.push.apply(secondaryActions_1, overflowPrimaryActions);
                var shouldRenderOverflowActionButton = true;
                if (secondaryActions_1.length > 0) {
                    if (!this._overflowAction) {
                        this._overflowAction = new $5104722604b983cb$var$OverflowAction(secondaryActions_1);
                        this._overflowAction.setParent(this._owner);
                        this._overflowAction["_actionCollection"] = this;
                    }
                    var isRootAction = this._owner instanceof $5104722604b983cb$var$AdaptiveCard && !this._owner.parent;
                    shouldRenderOverflowActionButton = !$5104722604b983cb$var$raiseRenderOverflowActionsEvent(this._overflowAction, isRootAction);
                }
                if (this._overflowAction && shouldRenderOverflowActionButton) primaryActions_1.push(this._overflowAction);
            } else primaryActions_1 = allowedActions;
            for(var i = 0; i < primaryActions_1.length; i++){
                var action = primaryActions_1[i];
                action.render();
                if (action.renderedElement) {
                    if (hostConfig.actions.actionsOrientation === $gIXBn.Orientation.Horizontal && hostConfig.actions.actionAlignment === $gIXBn.ActionAlignment.Stretch) action.renderedElement.style.flex = "0 1 100%";
                    else action.renderedElement.style.flex = "0 1 auto";
                    buttonStrip.appendChild(action.renderedElement);
                    this._renderedActions.push(action);
                    if (i < primaryActions_1.length - 1 && hostConfig.actions.buttonSpacing > 0) {
                        var spacer = document.createElement("div");
                        if (orientation === $gIXBn.Orientation.Horizontal) {
                            spacer.style.flex = "0 0 auto";
                            spacer.style.width = hostConfig.actions.buttonSpacing + "px";
                        } else spacer.style.height = hostConfig.actions.buttonSpacing + "px";
                        $F6YrP.appendChild(buttonStrip, spacer);
                    }
                }
            }
            var buttonStripContainer = document.createElement("div");
            buttonStripContainer.style.overflow = "hidden";
            buttonStripContainer.appendChild(buttonStrip);
            $F6YrP.appendChild(element, buttonStripContainer);
        }
        $F6YrP.appendChild(element, this._actionCardContainer);
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var renderedAction = _a[_i];
            if (renderedAction.state === 1 /* Expanded */ ) {
                this.expandShowCardAction(renderedAction, false);
                break;
            }
        }
        return this._renderedActions.length > 0 ? element : undefined;
    };
    ActionCollection.prototype.addAction = function(action) {
        if (!action) throw new Error("The action parameter cannot be null.");
        if ((!action.parent || action.parent === this._owner) && this._items.indexOf(action) < 0) {
            this._items.push(action);
            if (!action.parent) action.setParent(this._owner);
            action["_actionCollection"] = this;
        } else throw new Error($24F6S.Strings.errors.actionAlreadyParented());
    };
    ActionCollection.prototype.removeAction = function(action) {
        if (this.expandedAction && this._expandedAction === action) this.collapseExpandedAction();
        var actionIndex = this._items.indexOf(action);
        if (actionIndex >= 0) {
            this._items.splice(actionIndex, 1);
            action.setParent(undefined);
            action["_actionCollection"] = undefined;
            for(var i = 0; i < this._renderedActions.length; i++)if (this._renderedActions[i] === action) {
                this._renderedActions.splice(i, 1);
                break;
            }
            return true;
        }
        return false;
    };
    ActionCollection.prototype.clear = function() {
        this._items = [];
        this._renderedActions = [];
        this._expandedAction = undefined;
    };
    ActionCollection.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = [];
        if (processActions) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var action = _a[_i];
            result.push.apply(result, action.getAllInputs());
        }
        return result;
    };
    ActionCollection.prototype.getResourceInformation = function() {
        var result = [];
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var action = _a[_i];
            result.push.apply(result, action.getResourceInformation());
        }
        return result;
    };
    Object.defineProperty(ActionCollection.prototype, "renderedActionCount", {
        get: function() {
            return this._renderedActions.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionCollection.prototype, "expandedAction", {
        get: function() {
            return this._expandedAction;
        },
        enumerable: false,
        configurable: true
    });
    return ActionCollection;
}();
var $5104722604b983cb$var$ActionSet = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ActionSet, _super);
    function ActionSet() {
        var _this = _super.call(this) || this;
        _this._actionCollection = new $5104722604b983cb$var$ActionCollection(_this);
        return _this;
    }
    ActionSet.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._actionCollection.parse(source["actions"], context);
    };
    ActionSet.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        this._actionCollection.toJSON(target, "actions", context);
    };
    ActionSet.prototype.internalRender = function() {
        return this._actionCollection.render(this.orientation !== undefined ? this.orientation : this.hostConfig.actions.actionsOrientation);
    };
    ActionSet.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this._actionCollection.releaseDOMResources();
    };
    ActionSet.prototype.isBleedingAtBottom = function() {
        if (this._actionCollection.renderedActionCount === 0) return _super.prototype.isBleedingAtBottom.call(this);
        else {
            if (this._actionCollection.getActionCount() === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
            else return this._actionCollection.expandedAction !== undefined;
        }
    };
    ActionSet.prototype.getJsonTypeName = function() {
        return "ActionSet";
    };
    ActionSet.prototype.getActionCount = function() {
        return this._actionCollection.getActionCount();
    };
    ActionSet.prototype.getActionAt = function(index) {
        if (index >= 0 && index < this.getActionCount()) return this._actionCollection.getActionAt(index);
        else return _super.prototype.getActionAt.call(this, index);
    };
    ActionSet.prototype.getActionById = function(id) {
        var result = this._actionCollection.getActionById(id);
        return result ? result : _super.prototype.getActionById.call(this, id);
    };
    ActionSet.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) result.push(action);
        }
        return result;
    };
    ActionSet.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        this._actionCollection.validateProperties(context);
    };
    ActionSet.prototype.addAction = function(action) {
        this._actionCollection.addAction(action);
    };
    ActionSet.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return processActions ? this._actionCollection.getAllInputs() : [];
    };
    ActionSet.prototype.getResourceInformation = function() {
        return this._actionCollection.getResourceInformation();
    };
    /**
     * @inheritdoc
     */ ActionSet.prototype.findDOMNodeOwner = function(node) {
        var target = undefined;
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) {
                // recur through each Action
                target = action.findDOMNodeOwner(node);
                if (target) return target;
            }
        }
        // if not found in any Action, defer to parent implementation
        return _super.prototype.findDOMNodeOwner.call(this, node);
    };
    ActionSet.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) result = this.getElementByIdFromAction(id);
        return result;
    };
    Object.defineProperty(ActionSet.prototype, "isInteractive", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    ActionSet.orientationProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_1, "orientation", $gIXBn.Orientation);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ActionSet.orientationProperty)
    ], ActionSet.prototype, "orientation", void 0);
    return ActionSet;
}($5104722604b983cb$var$CardElement);
module.exports.ActionSet = $5104722604b983cb$var$ActionSet;
var $5104722604b983cb$var$ContainerStyleProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ContainerStyleProperty, _super);
    function ContainerStyleProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, [
            {
                value: $gIXBn.ContainerStyle.Default
            },
            {
                value: $gIXBn.ContainerStyle.Emphasis
            },
            {
                targetVersion: $5Ougt.Versions.v1_2,
                value: $gIXBn.ContainerStyle.Accent
            },
            {
                targetVersion: $5Ougt.Versions.v1_2,
                value: $gIXBn.ContainerStyle.Good
            },
            {
                targetVersion: $5Ougt.Versions.v1_2,
                value: $gIXBn.ContainerStyle.Attention
            },
            {
                targetVersion: $5Ougt.Versions.v1_2,
                value: $gIXBn.ContainerStyle.Warning
            }
        ], defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    return ContainerStyleProperty;
}($5Ougt.ValueSetProperty);
module.exports.ContainerStyleProperty = $5104722604b983cb$var$ContainerStyleProperty;
var $5104722604b983cb$var$StylableCardElementContainer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(StylableCardElementContainer, _super);
    function StylableCardElementContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StylableCardElementContainer.prototype, "style", {
        get: function() {
            if (this.allowCustomStyle) {
                var style = this.getValue(StylableCardElementContainer.styleProperty);
                if (style && this.hostConfig.containerStyles.getStyleByName(style)) return style;
            }
            return undefined;
        },
        set: function(value) {
            this.setValue(StylableCardElementContainer.styleProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylableCardElementContainer.prototype, "allowCustomStyle", {
        //#endregion
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylableCardElementContainer.prototype, "hasExplicitStyle", {
        get: function() {
            return this.getValue(StylableCardElementContainer.styleProperty) !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    StylableCardElementContainer.prototype.applyBorder = function() {
    // No border in base implementation
    };
    StylableCardElementContainer.prototype.applyBackground = function() {
        if (this.renderedElement) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
            if (styleDefinition.backgroundColor) {
                var bgColor = $F6YrP.stringToCssColor(styleDefinition.backgroundColor);
                if (bgColor) this.renderedElement.style.backgroundColor = bgColor;
            }
        }
    };
    StylableCardElementContainer.prototype.applyPadding = function() {
        _super.prototype.applyPadding.call(this);
        if (!this.renderedElement) return;
        var physicalPadding = new $6BHj7.SpacingDefinition();
        if (this.getEffectivePadding()) physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
        this.renderedElement.style.paddingTop = physicalPadding.top + "px";
        this.renderedElement.style.paddingRight = physicalPadding.right + "px";
        this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
        this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
        if (this.isBleeding()) {
            // Bleed into the first parent that does have padding
            var padding = new $6BHj7.PaddingDefinition();
            this.getImmediateSurroundingPadding(padding);
            var surroundingPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
            this.renderedElement.style.marginRight = "-" + surroundingPadding.right + "px";
            this.renderedElement.style.marginLeft = "-" + surroundingPadding.left + "px";
            if (!this.isDesignMode()) {
                this.renderedElement.style.marginTop = "-" + surroundingPadding.top + "px";
                this.renderedElement.style.marginBottom = "-" + surroundingPadding.bottom + "px";
            }
            if (this.separatorElement && this.separatorOrientation === $gIXBn.Orientation.Horizontal) {
                this.separatorElement.style.marginLeft = "-" + surroundingPadding.left + "px";
                this.separatorElement.style.marginRight = "-" + surroundingPadding.right + "px";
            }
        } else {
            this.renderedElement.style.marginRight = "0";
            this.renderedElement.style.marginLeft = "0";
            this.renderedElement.style.marginTop = "0";
            this.renderedElement.style.marginBottom = "0";
            if (this.separatorElement && this.separatorOrientation === $gIXBn.Orientation.Horizontal) {
                this.separatorElement.style.marginRight = "0";
                this.separatorElement.style.marginLeft = "0";
            }
        }
    };
    StylableCardElementContainer.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        var currentElement = this.parent;
        while(currentElement){
            var currentElementHasBackgroundImage = false;
            if (ignoreBackgroundImages) currentElementHasBackgroundImage = false;
            else currentElementHasBackgroundImage = currentElement instanceof $5104722604b983cb$var$Container ? currentElement.backgroundImage.isValid() : false;
            if (currentElement instanceof StylableCardElementContainer) {
                if (this.hasExplicitStyle && (currentElement.getEffectiveStyle() !== this.getEffectiveStyle() || currentElementHasBackgroundImage)) return true;
            }
            currentElement = currentElement.parent;
        }
        return false;
    };
    StylableCardElementContainer.prototype.getDefaultPadding = function() {
        return this.getHasBackground() || this.getHasBorder() ? new $6BHj7.PaddingDefinition($gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding) : _super.prototype.getDefaultPadding.call(this);
    };
    StylableCardElementContainer.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        var explicitStyle = this.getValue(StylableCardElementContainer.styleProperty);
        if (explicitStyle !== undefined) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(explicitStyle);
            if (!styleDefinition) context.addFailure(this, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(explicitStyle, "style"));
        }
    };
    StylableCardElementContainer.prototype.render = function() {
        var renderedElement = _super.prototype.render.call(this);
        if (renderedElement && this.getHasBackground()) this.applyBackground();
        this.applyBorder();
        return renderedElement;
    };
    StylableCardElementContainer.prototype.getEffectiveStyle = function() {
        var effectiveStyle = this.style;
        return effectiveStyle ? effectiveStyle : _super.prototype.getEffectiveStyle.call(this);
    };
    //#region Schema
    StylableCardElementContainer.styleProperty = new $5104722604b983cb$var$ContainerStyleProperty($5Ougt.Versions.v1_0, "style");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(StylableCardElementContainer.styleProperty)
    ], StylableCardElementContainer.prototype, "style", null);
    return StylableCardElementContainer;
}($5104722604b983cb$var$CardElementContainer);
module.exports.StylableCardElementContainer = $5104722604b983cb$var$StylableCardElementContainer;
var $5104722604b983cb$var$ContainerBase = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ContainerBase, _super);
    function ContainerBase() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._bleed = false;
        return _this;
    }
    //#endregion
    ContainerBase.prototype.adjustRenderedElementSize = function(renderedElement) {
        _super.prototype.adjustRenderedElementSize.call(this, renderedElement);
        if (this.minPixelHeight) renderedElement.style.minHeight = this.minPixelHeight + "px";
    };
    ContainerBase.prototype.getHasExpandedAction = function() {
        return false;
    };
    ContainerBase.prototype.getBleed = function() {
        return this._bleed;
    };
    ContainerBase.prototype.setBleed = function(value) {
        this._bleed = value;
    };
    Object.defineProperty(ContainerBase.prototype, "renderedActionCount", {
        get: function() {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    ContainerBase.prototype.isBleeding = function() {
        return (this.getHasBackground() || this.hostConfig.alwaysAllowBleed) && this.getBleed();
    };
    ContainerBase.bleedProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "bleed", false);
    ContainerBase.minHeightProperty = new $5Ougt.PixelSizeProperty($5Ougt.Versions.v1_2, "minHeight");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ContainerBase.bleedProperty)
    ], ContainerBase.prototype, "_bleed", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ContainerBase.minHeightProperty)
    ], ContainerBase.prototype, "minPixelHeight", void 0);
    return ContainerBase;
}($5104722604b983cb$var$StylableCardElementContainer);
module.exports.ContainerBase = $5104722604b983cb$var$ContainerBase;
var $5104722604b983cb$var$BackgroundImage = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(BackgroundImage, _super);
    function BackgroundImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    BackgroundImage.prototype.getSchemaKey = function() {
        return "BackgroundImage";
    };
    BackgroundImage.prototype.internalParse = function(source, context) {
        if (typeof source === "string") {
            this.resetDefaultValues();
            this.url = source;
        } else return _super.prototype.internalParse.call(this, source, context);
    };
    BackgroundImage.prototype.apply = function(element) {
        if (this.url && element.renderedElement) {
            element.renderedElement.style.backgroundImage = "url('" + element.preProcessPropertyValue(BackgroundImage.urlProperty, this.url) + "')";
            switch(this.fillMode){
                case $gIXBn.FillMode.Repeat:
                    element.renderedElement.style.backgroundRepeat = "repeat";
                    break;
                case $gIXBn.FillMode.RepeatHorizontally:
                    element.renderedElement.style.backgroundRepeat = "repeat-x";
                    break;
                case $gIXBn.FillMode.RepeatVertically:
                    element.renderedElement.style.backgroundRepeat = "repeat-y";
                    break;
                case $gIXBn.FillMode.Cover:
                default:
                    element.renderedElement.style.backgroundRepeat = "no-repeat";
                    element.renderedElement.style.backgroundSize = "cover";
                    break;
            }
            switch(this.horizontalAlignment){
                case $gIXBn.HorizontalAlignment.Left:
                    break;
                case $gIXBn.HorizontalAlignment.Center:
                    element.renderedElement.style.backgroundPositionX = "center";
                    break;
                case $gIXBn.HorizontalAlignment.Right:
                    element.renderedElement.style.backgroundPositionX = "right";
                    break;
            }
            switch(this.verticalAlignment){
                case $gIXBn.VerticalAlignment.Top:
                    break;
                case $gIXBn.VerticalAlignment.Center:
                    element.renderedElement.style.backgroundPositionY = "center";
                    break;
                case $gIXBn.VerticalAlignment.Bottom:
                    element.renderedElement.style.backgroundPositionY = "bottom";
                    break;
            }
        }
    };
    BackgroundImage.prototype.isValid = function() {
        return this.url ? true : false;
    };
    //#region Schema
    BackgroundImage.urlProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "url");
    BackgroundImage.fillModeProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_2, "fillMode", $gIXBn.FillMode, $gIXBn.FillMode.Cover);
    BackgroundImage.horizontalAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_2, "horizontalAlignment", $gIXBn.HorizontalAlignment, $gIXBn.HorizontalAlignment.Left);
    BackgroundImage.verticalAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_2, "verticalAlignment", $gIXBn.VerticalAlignment, $gIXBn.VerticalAlignment.Top);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BackgroundImage.urlProperty)
    ], BackgroundImage.prototype, "url", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BackgroundImage.fillModeProperty)
    ], BackgroundImage.prototype, "fillMode", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BackgroundImage.horizontalAlignmentProperty)
    ], BackgroundImage.prototype, "horizontalAlignment", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BackgroundImage.verticalAlignmentProperty)
    ], BackgroundImage.prototype, "verticalAlignment", void 0);
    return BackgroundImage;
}($5Ougt.SerializableObject);
module.exports.BackgroundImage = $5104722604b983cb$var$BackgroundImage;
var $5104722604b983cb$var$Container = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Container, _super);
    function Container() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        _this._items = [];
        _this._renderedItems = [];
        return _this;
    }
    Object.defineProperty(Container.prototype, "backgroundImage", {
        get: function() {
            return this.getValue(Container.backgroundImageProperty);
        },
        enumerable: false,
        configurable: true
    });
    Container.prototype.insertItemAt = function(item, index, forceInsert) {
        if (!item.parent || forceInsert) {
            if (item.isStandalone) {
                if (index < 0 || index >= this._items.length) this._items.push(item);
                else this._items.splice(index, 0, item);
                item.setParent(this);
            } else throw new Error($24F6S.Strings.errors.elementTypeNotStandalone(item.getJsonTypeName()));
        } else throw new Error($24F6S.Strings.errors.elementAlreadyParented());
    };
    Container.prototype.getItemsCollectionPropertyName = function() {
        return "items";
    };
    Container.prototype.applyBackground = function() {
        if (this.backgroundImage.isValid() && this.renderedElement) this.backgroundImage.apply(this);
        _super.prototype.applyBackground.call(this);
    };
    Container.prototype.applyRTL = function(element) {
        if (this.rtl !== undefined) element.dir = this.rtl ? "rtl" : "ltr";
    };
    Container.prototype.internalRender = function() {
        this._renderedItems = [];
        // Cache hostConfig to avoid walking the parent hierarchy several times
        var hostConfig = this.hostConfig;
        var element = document.createElement("div");
        this.applyRTL(element);
        element.classList.add(hostConfig.makeCssClassName("ac-container"));
        element.style.display = "flex";
        element.style.flexDirection = "column";
        if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation) // Forces the container to be at least as tall as its content.
        //
        // Fixes a quirk in Chrome where, for nested flex elements, the
        // inner element's height would never exceed the outer element's
        // height. This caused overflow truncation to break -- containers
        // would always be measured as not overflowing, since their heights
        // were constrained by their parents as opposed to truly reflecting
        // the height of their content.
        //
        // See the "Browser Rendering Notes" section of this answer:
        // https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
        element.style.minHeight = "-webkit-min-content";
        switch(this.getEffectiveVerticalContentAlignment()){
            case $gIXBn.VerticalAlignment.Center:
                element.style.justifyContent = "center";
                break;
            case $gIXBn.VerticalAlignment.Bottom:
                element.style.justifyContent = "flex-end";
                break;
            default:
                element.style.justifyContent = "flex-start";
                break;
        }
        if (this._items.length > 0) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            var renderedItem = this.isElementAllowed(item) ? item.render() : undefined;
            if (renderedItem) {
                if (this._renderedItems.length > 0 && item.separatorElement) {
                    item.separatorElement.style.flex = "0 0 auto";
                    $F6YrP.appendChild(element, item.separatorElement);
                }
                $F6YrP.appendChild(element, renderedItem);
                this._renderedItems.push(item);
            }
        }
        else if (this.isDesignMode()) {
            var placeholderElement = this.createPlaceholderElement();
            placeholderElement.style.width = "100%";
            placeholderElement.style.height = "100%";
            element.appendChild(placeholderElement);
        }
        return element;
    };
    Container.prototype.truncateOverflow = function(maxHeight) {
        if (this.renderedElement) {
            // Add 1 to account for rounding differences between browsers
            var boundary_1 = this.renderedElement.offsetTop + maxHeight + 1;
            var handleElement_1 = function(cardElement) {
                var elt = cardElement.renderedElement;
                if (elt) switch($F6YrP.getFitStatus(elt, boundary_1)){
                    case $gIXBn.ContainerFitStatus.FullyInContainer:
                        var sizeChanged = cardElement["resetOverflow"]();
                        // If the element's size changed after resetting content,
                        // we have to check if it still fits fully in the card
                        if (sizeChanged) handleElement_1(cardElement);
                        break;
                    case $gIXBn.ContainerFitStatus.Overflowing:
                        var containerMaxHeight = boundary_1 - elt.offsetTop;
                        cardElement["handleOverflow"](containerMaxHeight);
                        break;
                    case $gIXBn.ContainerFitStatus.FullyOutOfContainer:
                        cardElement["handleOverflow"](0);
                        break;
                }
            };
            for(var _i = 0, _a = this._items; _i < _a.length; _i++){
                var item = _a[_i];
                handleElement_1(item);
            }
            return true;
        }
        return false;
    };
    Container.prototype.undoOverflowTruncation = function() {
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            item["resetOverflow"]();
        }
    };
    Container.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        var result = ignoreBackgroundImages ? false : this.backgroundImage.isValid();
        return result || _super.prototype.getHasBackground.call(this, ignoreBackgroundImages);
    };
    Container.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.clear();
        this.setShouldFallback(false);
        var jsonItems = source[this.getItemsCollectionPropertyName()];
        if (Array.isArray(jsonItems)) for(var _i = 0, jsonItems_1 = jsonItems; _i < jsonItems_1.length; _i++){
            var item = jsonItems_1[_i];
            var element = context.parseElement(this, item, this.forbiddenChildElements(), !this.isDesignMode());
            if (element) this.insertItemAt(element, -1, true);
        }
    };
    Container.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        var collectionPropertyName = this.getItemsCollectionPropertyName();
        context.serializeArray(target, collectionPropertyName, this._items);
    };
    Object.defineProperty(Container.prototype, "isSelectable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Container.prototype.getEffectivePadding = function() {
        if ($6BHj7.GlobalSettings.removePaddingFromContainersWithBackgroundImage && !this.getHasBackground(true)) return new $6BHj7.PaddingDefinition();
        return _super.prototype.getEffectivePadding.call(this);
    };
    Container.prototype.getEffectiveVerticalContentAlignment = function() {
        if (this.verticalContentAlignment !== undefined) return this.verticalContentAlignment;
        var parentContainer = this.getParentContainer();
        return parentContainer ? parentContainer.getEffectiveVerticalContentAlignment() : $gIXBn.VerticalAlignment.Top;
    };
    Container.prototype.getItemCount = function() {
        return this._items.length;
    };
    Container.prototype.getItemAt = function(index) {
        return this._items[index];
    };
    Container.prototype.getFirstVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) for(var _i = 0, _a = this._renderedItems; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.isVisible) return item;
        }
        return undefined;
    };
    Container.prototype.getLastVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) for(var i = this._renderedItems.length - 1; i >= 0; i--){
            if (this._renderedItems[i].isVisible) return this._renderedItems[i];
        }
        return undefined;
    };
    Container.prototype.getJsonTypeName = function() {
        return "Container";
    };
    Container.prototype.isFirstElement = function(element) {
        var designMode = this.isDesignMode();
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.isVisible || designMode) return item === element;
        }
        return false;
    };
    Container.prototype.isLastElement = function(element) {
        var designMode = this.isDesignMode();
        for(var i = this._items.length - 1; i >= 0; i--){
            if (this._items[i].isVisible || designMode) return this._items[i] === element;
        }
        return false;
    };
    Container.prototype.isRtl = function() {
        if (this.rtl !== undefined) return this.rtl;
        else {
            var parentContainer = this.getParentContainer();
            return parentContainer ? parentContainer.isRtl() : false;
        }
    };
    Container.prototype.isBleedingAtTop = function() {
        var firstRenderedItem = this.getFirstVisibleRenderedItem();
        return this.isBleeding() || (firstRenderedItem ? firstRenderedItem.isBleedingAtTop() : false);
    };
    Container.prototype.isBleedingAtBottom = function() {
        var lastRenderedItem = this.getLastVisibleRenderedItem();
        return this.isBleeding() || (lastRenderedItem ? lastRenderedItem.isBleedingAtBottom() && lastRenderedItem.getEffectiveStyle() === this.getEffectiveStyle() : false);
    };
    Container.prototype.indexOf = function(cardElement) {
        return this._items.indexOf(cardElement);
    };
    Container.prototype.addItem = function(item) {
        this.insertItemAt(item, -1, false);
    };
    Container.prototype.insertItemBefore = function(item, insertBefore) {
        this.insertItemAt(item, this._items.indexOf(insertBefore), false);
    };
    Container.prototype.insertItemAfter = function(item, insertAfter) {
        this.insertItemAt(item, this._items.indexOf(insertAfter) + 1, false);
    };
    Container.prototype.removeItem = function(item) {
        var itemIndex = this._items.indexOf(item);
        if (itemIndex >= 0) {
            this._items.splice(itemIndex, 1);
            item.setParent(undefined);
            this.updateLayout();
            return true;
        }
        return false;
    };
    Container.prototype.clear = function() {
        this._items = [];
        this._renderedItems = [];
    };
    Container.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        if (this.backgroundImage.isValid()) result.push({
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- validated by `isValid()`
            url: this.backgroundImage.url,
            mimeType: "image"
        });
        return result;
    };
    Container.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result) {
            if (this.selectAction) result = this.selectAction.getActionById(id);
            if (!result) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
                var item = _a[_i];
                result = item.getActionById(id);
                if (result) break;
            }
        }
        return result;
    };
    Object.defineProperty(Container.prototype, "padding", {
        get: function() {
            return this.getPadding();
        },
        set: function(value) {
            this.setPadding(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "selectAction", {
        get: function() {
            return this._selectAction;
        },
        set: function(value) {
            this._selectAction = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "bleed", {
        get: function() {
            return this.getBleed();
        },
        set: function(value) {
            this.setBleed(value);
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Container.backgroundImageProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_0, "backgroundImage", $5104722604b983cb$var$BackgroundImage);
    Container.verticalContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_1, "verticalContentAlignment", $gIXBn.VerticalAlignment);
    Container.rtlProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "rtl");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Container.backgroundImageProperty)
    ], Container.prototype, "backgroundImage", null);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Container.verticalContentAlignmentProperty)
    ], Container.prototype, "verticalContentAlignment", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Container.rtlProperty)
    ], Container.prototype, "rtl", void 0);
    return Container;
}($5104722604b983cb$var$ContainerBase);
module.exports.Container = $5104722604b983cb$var$Container;
var $5104722604b983cb$var$Column = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Column, _super);
    function Column(width) {
        if (width === void 0) width = "stretch";
        var _this = _super.call(this) || this;
        _this.width = "stretch";
        //#endregion
        _this._computedWeight = 0;
        _this.width = width;
        return _this;
    }
    Column.prototype.adjustRenderedElementSize = function(renderedElement) {
        var minDesignTimeColumnHeight = 20;
        if (this.isDesignMode()) {
            renderedElement.style.minWidth = "20px";
            renderedElement.style.minHeight = (!this.minPixelHeight ? minDesignTimeColumnHeight : Math.max(this.minPixelHeight, minDesignTimeColumnHeight)) + "px";
        } else {
            renderedElement.style.minWidth = "0";
            if (this.minPixelHeight) renderedElement.style.minHeight = this.minPixelHeight + "px";
        }
        if (this.width === "auto") renderedElement.style.flex = "0 1 auto";
        else if (this.width === "stretch") renderedElement.style.flex = "1 1 50px";
        else if (this.width instanceof $6BHj7.SizeAndUnit) {
            if (this.width.unit === $gIXBn.SizeUnit.Pixel) {
                renderedElement.style.flex = "0 0 auto";
                renderedElement.style.width = this.width.physicalSize + "px";
            } else renderedElement.style.flex = "1 1 " + (this._computedWeight > 0 ? this._computedWeight : this.width.physicalSize) + "%";
        }
    };
    Column.prototype.shouldSerialize = function(_context) {
        return true;
    };
    Object.defineProperty(Column.prototype, "separatorOrientation", {
        get: function() {
            return $gIXBn.Orientation.Vertical;
        },
        enumerable: false,
        configurable: true
    });
    Column.prototype.getJsonTypeName = function() {
        return "Column";
    };
    Object.defineProperty(Column.prototype, "hasVisibleSeparator", {
        get: function() {
            if (this.parent && this.parent instanceof $5104722604b983cb$var$ColumnSet) return this.separatorElement !== undefined && !this.parent.isLeftMostElement(this);
            else return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Column.widthProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_0, "width", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidWidth = false;
        if (typeof value === "number" && !isNaN(value)) result = new $6BHj7.SizeAndUnit(value, $gIXBn.SizeUnit.Weight);
        else if (value === "auto" || value === "stretch") result = value;
        else if (typeof value === "string") try {
            result = $6BHj7.SizeAndUnit.parse(value);
            if (result.unit === $gIXBn.SizeUnit.Pixel && prop.targetVersion.compareTo(context.targetVersion) > 0) invalidWidth = true;
        } catch (e) {
            invalidWidth = true;
        }
        else invalidWidth = true;
        if (invalidWidth) {
            context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidColumnWidth(value));
            result = "auto";
        }
        return result;
    }, function(sender, property, target, value, context) {
        if (value instanceof $6BHj7.SizeAndUnit) {
            if (value.unit === $gIXBn.SizeUnit.Pixel) context.serializeValue(target, "width", value.physicalSize + "px");
            else context.serializeNumber(target, "width", value.physicalSize);
        } else context.serializeValue(target, "width", value);
    }, "stretch");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Column.widthProperty)
    ], Column.prototype, "width", void 0);
    return Column;
}($5104722604b983cb$var$Container);
module.exports.Column = $5104722604b983cb$var$Column;
var $5104722604b983cb$var$ColumnSet = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ColumnSet, _super);
    function ColumnSet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = [];
        return _this;
    }
    ColumnSet.prototype.createColumnInstance = function(source, context) {
        return context.parseCardObject(this, source, [], !this.isDesignMode(), function(typeName) {
            return !typeName || typeName === "Column" ? new $5104722604b983cb$var$Column() : undefined;
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $gIXBn.ValidationEvent.ElementTypeNotAllowed, $24F6S.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    ColumnSet.prototype.internalRender = function() {
        this._renderedColumns = [];
        if (this._columns.length > 0) {
            // Cache hostConfig to avoid walking the parent hierarchy several times
            var hostConfig = this.hostConfig;
            var element = document.createElement("div");
            element.className = hostConfig.makeCssClassName("ac-columnSet");
            element.style.display = "flex";
            if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation) // See comment in Container.internalRender()
            element.style.minHeight = "-webkit-min-content";
            switch(this.getEffectiveHorizontalAlignment()){
                case $gIXBn.HorizontalAlignment.Center:
                    element.style.justifyContent = "center";
                    break;
                case $gIXBn.HorizontalAlignment.Right:
                    element.style.justifyContent = "flex-end";
                    break;
                default:
                    element.style.justifyContent = "flex-start";
                    break;
            }
            var totalWeight = 0;
            for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
                var column = _a[_i];
                if (column.width instanceof $6BHj7.SizeAndUnit && column.width.unit === $gIXBn.SizeUnit.Weight) totalWeight += column.width.physicalSize;
            }
            for(var _b = 0, _c = this._columns; _b < _c.length; _b++){
                var column = _c[_b];
                if (column.width instanceof $6BHj7.SizeAndUnit && column.width.unit === $gIXBn.SizeUnit.Weight && totalWeight > 0) {
                    var computedWeight = 100 / totalWeight * column.width.physicalSize;
                    // Best way to emulate "internal" access I know of
                    column["_computedWeight"] = computedWeight;
                }
                var renderedColumn = column.render();
                if (renderedColumn) {
                    if (this._renderedColumns.length > 0 && column.separatorElement) {
                        column.separatorElement.style.flex = "0 0 auto";
                        $F6YrP.appendChild(element, column.separatorElement);
                    }
                    $F6YrP.appendChild(element, renderedColumn);
                    this._renderedColumns.push(column);
                }
            }
            return this._renderedColumns.length > 0 ? element : undefined;
        } else return undefined;
    };
    ColumnSet.prototype.truncateOverflow = function(maxHeight) {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            column["handleOverflow"](maxHeight);
        }
        return true;
    };
    ColumnSet.prototype.undoOverflowTruncation = function() {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            column["resetOverflow"]();
        }
    };
    Object.defineProperty(ColumnSet.prototype, "isSelectable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    ColumnSet.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._columns = [];
        this._renderedColumns = [];
        var jsonColumns = source["columns"];
        if (Array.isArray(jsonColumns)) for(var _i = 0, jsonColumns_1 = jsonColumns; _i < jsonColumns_1.length; _i++){
            var item = jsonColumns_1[_i];
            var column = this.createColumnInstance(item, context);
            if (column) this._columns.push(column);
        }
    };
    ColumnSet.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, "columns", this._columns);
    };
    ColumnSet.prototype.isFirstElement = function(element) {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isVisible) return column === element;
        }
        return false;
    };
    ColumnSet.prototype.isBleedingAtTop = function() {
        if (this.isBleeding()) return true;
        if (this._renderedColumns && this._renderedColumns.length > 0) for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isBleedingAtTop()) return true;
        }
        return false;
    };
    ColumnSet.prototype.isBleedingAtBottom = function() {
        if (this.isBleeding()) return true;
        if (this._renderedColumns && this._renderedColumns.length > 0) for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isBleedingAtBottom()) return true;
        }
        return false;
    };
    ColumnSet.prototype.getItemCount = function() {
        return this._columns.length;
    };
    ColumnSet.prototype.getFirstVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) return this._renderedColumns[0];
        else return undefined;
    };
    ColumnSet.prototype.getLastVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) return this._renderedColumns[this._renderedColumns.length - 1];
        else return undefined;
    };
    ColumnSet.prototype.getColumnAt = function(index) {
        return this._columns[index];
    };
    ColumnSet.prototype.getItemAt = function(index) {
        return this.getColumnAt(index);
    };
    ColumnSet.prototype.getJsonTypeName = function() {
        return "ColumnSet";
    };
    ColumnSet.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        var weightedColumns = 0;
        var stretchedColumns = 0;
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (typeof column.width === "number") weightedColumns++;
            else if (column.width === "stretch") stretchedColumns++;
        }
        if (weightedColumns > 0 && stretchedColumns > 0) context.addFailure(this, $gIXBn.ValidationEvent.Hint, $24F6S.Strings.hints.dontUseWeightedAndStrecthedColumnsInSameSet());
    };
    ColumnSet.prototype.addColumn = function(column) {
        if (!column.parent) {
            this._columns.push(column);
            column.setParent(this);
        } else throw new Error($24F6S.Strings.errors.columnAlreadyBelongsToAnotherSet());
    };
    ColumnSet.prototype.removeItem = function(item) {
        if (item instanceof $5104722604b983cb$var$Column) {
            var itemIndex = this._columns.indexOf(item);
            if (itemIndex >= 0) {
                this._columns.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    ColumnSet.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $5104722604b983cb$var$Column ? this._columns.indexOf(cardElement) : -1;
    };
    ColumnSet.prototype.isLeftMostElement = function(element) {
        return this._columns.indexOf(element) === 0;
    };
    ColumnSet.prototype.isRightMostElement = function(element) {
        return this._columns.indexOf(element) === this._columns.length - 1;
    };
    ColumnSet.prototype.isTopElement = function(element) {
        return this._columns.indexOf(element) >= 0;
    };
    ColumnSet.prototype.isBottomElement = function(element) {
        return this._columns.indexOf(element) >= 0;
    };
    ColumnSet.prototype.getActionById = function(id) {
        var result = undefined;
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            result = column.getActionById(id);
            if (result) break;
        }
        return result;
    };
    Object.defineProperty(ColumnSet.prototype, "bleed", {
        get: function() {
            return this.getBleed();
        },
        set: function(value) {
            this.setBleed(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColumnSet.prototype, "padding", {
        get: function() {
            return this.getPadding();
        },
        set: function(value) {
            this.setPadding(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColumnSet.prototype, "selectAction", {
        get: function() {
            return this._selectAction;
        },
        set: function(value) {
            this._selectAction = value;
        },
        enumerable: false,
        configurable: true
    });
    return ColumnSet;
}($5104722604b983cb$var$ContainerBase);
module.exports.ColumnSet = $5104722604b983cb$var$ColumnSet;
function $5104722604b983cb$var$raiseImageLoadedEvent(image) {
    var card = image.getRootElement();
    var onImageLoadedHandler = card && card.onImageLoaded ? card.onImageLoaded : $5104722604b983cb$var$AdaptiveCard.onImageLoaded;
    if (onImageLoadedHandler) onImageLoadedHandler(image);
}
function $5104722604b983cb$var$raiseAnchorClickedEvent(element, anchor, ev) {
    var card = element.getRootElement();
    var onAnchorClickedHandler = card && card.onAnchorClicked ? card.onAnchorClicked : $5104722604b983cb$var$AdaptiveCard.onAnchorClicked;
    return onAnchorClickedHandler !== undefined ? onAnchorClickedHandler(element, anchor, ev) : false;
}
function $5104722604b983cb$var$raiseExecuteActionEvent(action) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onExecuteActionHandler = card && card.onExecuteAction ? card.onExecuteAction : $5104722604b983cb$var$AdaptiveCard.onExecuteAction;
    if (action.prepareForExecution() && onExecuteActionHandler) onExecuteActionHandler(action);
}
function $5104722604b983cb$var$raiseInlineCardExpandedEvent(action, isExpanded) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onInlineCardExpandedHandler = card && card.onInlineCardExpanded ? card.onInlineCardExpanded : $5104722604b983cb$var$AdaptiveCard.onInlineCardExpanded;
    if (onInlineCardExpandedHandler) onInlineCardExpandedHandler(action, isExpanded);
}
function $5104722604b983cb$var$raiseInputValueChangedEvent(input) {
    var card = input.getRootElement();
    var onInputValueChangedHandler = card && card.onInputValueChanged ? card.onInputValueChanged : $5104722604b983cb$var$AdaptiveCard.onInputValueChanged;
    if (onInputValueChangedHandler) onInputValueChangedHandler(input);
}
function $5104722604b983cb$var$raiseElementVisibilityChangedEvent(element, shouldUpdateLayout) {
    if (shouldUpdateLayout === void 0) shouldUpdateLayout = true;
    var rootElement = element.getRootElement();
    if (shouldUpdateLayout) rootElement.updateLayout();
    var card = rootElement;
    var onElementVisibilityChangedHandler = card && card.onElementVisibilityChanged ? card.onElementVisibilityChanged : $5104722604b983cb$var$AdaptiveCard.onElementVisibilityChanged;
    if (onElementVisibilityChangedHandler !== undefined) onElementVisibilityChangedHandler(element);
}
function $5104722604b983cb$var$updateInputAdornersVisibility(input, hide) {
    if (!!hide) {
        // hides the time/date picker icon
        input.readOnly = true;
        // hides the cross button icon
        input.required = true;
    } else {
        // shows the time/date picker icon
        input.readOnly = false;
        // shows the cross button icon
        input.required = false;
    }
}
/**
 * @returns return false to continue with default context menu; return true to skip SDK default context menu
 */ function $5104722604b983cb$var$raiseDisplayOverflowActionMenuEvent(action, target) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onDisplayOverflowActionMenuHandler = card && card.onDisplayOverflowActionMenu ? card.onDisplayOverflowActionMenu : $5104722604b983cb$var$AdaptiveCard.onDisplayOverflowActionMenu;
    return onDisplayOverflowActionMenuHandler !== undefined ? onDisplayOverflowActionMenuHandler(action.getActions(), target) : false;
}
/**
 * @returns return false to continue with default action button; return true to skip SDK default action button
 */ function $5104722604b983cb$var$raiseRenderOverflowActionsEvent(action, isAtRootLevelActions) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onRenderOverflowActionsHandler = card && card.onRenderOverflowActions ? card.onRenderOverflowActions : $5104722604b983cb$var$AdaptiveCard.onRenderOverflowActions;
    return onRenderOverflowActionsHandler !== undefined ? onRenderOverflowActionsHandler(action.getActions(), isAtRootLevelActions) : false;
}
var $5104722604b983cb$var$ContainerWithActions = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ContainerWithActions, _super);
    function ContainerWithActions() {
        var _this = _super.call(this) || this;
        _this._actionCollection = new $5104722604b983cb$var$ActionCollection(_this);
        return _this;
    }
    ContainerWithActions.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.parseActions(source, context);
    };
    ContainerWithActions.prototype.parseActions = function(source, context) {
        this._actionCollection.parse(source["actions"], context);
    };
    ContainerWithActions.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        this._actionCollection.toJSON(target, "actions", context);
    };
    ContainerWithActions.prototype.internalRender = function() {
        var element = _super.prototype.internalRender.call(this);
        if (element) {
            var renderedActions = this._actionCollection.render(this.hostConfig.actions.actionsOrientation);
            if (renderedActions) {
                $F6YrP.appendChild(element, $5104722604b983cb$var$renderSeparation(this.hostConfig, {
                    spacing: this.hostConfig.getEffectiveSpacing(this.hostConfig.actions.spacing)
                }, $gIXBn.Orientation.Horizontal));
                $F6YrP.appendChild(element, renderedActions);
            }
            if (this.renderIfEmpty) return element;
            else return element.children.length > 0 ? element : undefined;
        } else return undefined;
    };
    ContainerWithActions.prototype.getHasExpandedAction = function() {
        if (this.renderedActionCount === 0) return false;
        else if (this.renderedActionCount === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
        else return this._actionCollection.expandedAction !== undefined;
    };
    Object.defineProperty(ContainerWithActions.prototype, "renderedActionCount", {
        get: function() {
            return this._actionCollection.renderedActionCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContainerWithActions.prototype, "renderIfEmpty", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ContainerWithActions.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this._actionCollection.releaseDOMResources();
    };
    ContainerWithActions.prototype.getActionCount = function() {
        return this._actionCollection.getActionCount();
    };
    ContainerWithActions.prototype.getActionAt = function(index) {
        if (index >= 0 && index < this.getActionCount()) return this._actionCollection.getActionAt(index);
        else return _super.prototype.getActionAt.call(this, index);
    };
    ContainerWithActions.prototype.getActionById = function(id) {
        var result = this._actionCollection.getActionById(id);
        return result ? result : _super.prototype.getActionById.call(this, id);
    };
    ContainerWithActions.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this._actionCollection) this._actionCollection.validateProperties(context);
    };
    ContainerWithActions.prototype.isLastElement = function(element) {
        return _super.prototype.isLastElement.call(this, element) && this._actionCollection.getActionCount() === 0;
    };
    ContainerWithActions.prototype.addAction = function(action) {
        this._actionCollection.addAction(action);
    };
    ContainerWithActions.prototype.clear = function() {
        _super.prototype.clear.call(this);
        this._actionCollection.clear();
    };
    ContainerWithActions.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = _super.prototype.getAllInputs.call(this, processActions);
        if (processActions) result.push.apply(result, this._actionCollection.getAllInputs(processActions));
        return result;
    };
    ContainerWithActions.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        result.push.apply(result, this._actionCollection.getResourceInformation());
        return result;
    };
    ContainerWithActions.prototype.isBleedingAtBottom = function() {
        if (this._actionCollection.renderedActionCount === 0) return _super.prototype.isBleedingAtBottom.call(this);
        else {
            if (this._actionCollection.getActionCount() === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
            else return this._actionCollection.expandedAction !== undefined;
        }
    };
    ContainerWithActions.prototype.getForbiddenActionNames = function() {
        return [];
    };
    ContainerWithActions.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) result = this.getElementByIdFromAction(id);
        return result;
    };
    Object.defineProperty(ContainerWithActions.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return ContainerWithActions;
}($5104722604b983cb$var$Container);
module.exports.ContainerWithActions = $5104722604b983cb$var$ContainerWithActions;
var $5104722604b983cb$var$RefreshActionProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(RefreshActionProperty, _super);
    function RefreshActionProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, undefined) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    RefreshActionProperty.prototype.parse = function(sender, source, context) {
        var action = context.parseAction(sender.parent, source[this.name], [], false);
        if (action !== undefined) {
            if (action instanceof $5104722604b983cb$var$ExecuteAction) return action;
            context.logParseEvent(sender, $gIXBn.ValidationEvent.ActionTypeNotAllowed, $24F6S.Strings.errors.actionTypeNotAllowed(action.getJsonTypeName()));
        }
        context.logParseEvent(sender, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.propertyMustBeSet("action"));
        return undefined;
    };
    RefreshActionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
    };
    return RefreshActionProperty;
}($5Ougt.PropertyDefinition);
module.exports.RefreshActionProperty = $5104722604b983cb$var$RefreshActionProperty;
var $5104722604b983cb$var$RefreshDefinition = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(RefreshDefinition, _super);
    function RefreshDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RefreshDefinition.prototype, "action", {
        get: function() {
            return this.getValue(RefreshDefinition.actionProperty);
        },
        set: function(value) {
            this.setValue(RefreshDefinition.actionProperty, value);
            if (value) value.setParent(this.parent);
        },
        enumerable: false,
        configurable: true
    });
    RefreshDefinition.prototype.getSchemaKey = function() {
        return "RefreshDefinition";
    };
    //#region Schema
    RefreshDefinition.actionProperty = new $5104722604b983cb$var$RefreshActionProperty($5Ougt.Versions.v1_4, "action");
    RefreshDefinition.userIdsProperty = new $5Ougt.StringArrayProperty($5Ougt.Versions.v1_4, "userIds");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(RefreshDefinition.actionProperty)
    ], RefreshDefinition.prototype, "action", null);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(RefreshDefinition.userIdsProperty)
    ], RefreshDefinition.prototype, "userIds", void 0);
    return RefreshDefinition;
}($5Ougt.SerializableObject);
module.exports.RefreshDefinition = $5104722604b983cb$var$RefreshDefinition;
var $5104722604b983cb$var$AuthCardButton = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(AuthCardButton, _super);
    function AuthCardButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthCardButton.prototype.getSchemaKey = function() {
        return "AuthCardButton";
    };
    //#region Schema
    AuthCardButton.typeProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "type");
    AuthCardButton.titleProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "title");
    AuthCardButton.imageProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "image");
    AuthCardButton.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "value");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AuthCardButton.typeProperty)
    ], AuthCardButton.prototype, "type", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AuthCardButton.titleProperty)
    ], AuthCardButton.prototype, "title", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AuthCardButton.imageProperty)
    ], AuthCardButton.prototype, "image", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AuthCardButton.valueProperty)
    ], AuthCardButton.prototype, "value", void 0);
    return AuthCardButton;
}($5Ougt.SerializableObject);
module.exports.AuthCardButton = $5104722604b983cb$var$AuthCardButton;
var $5104722604b983cb$var$TokenExchangeResource = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TokenExchangeResource, _super);
    function TokenExchangeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenExchangeResource.prototype.getSchemaKey = function() {
        return "TokenExchangeResource";
    };
    //#region Schema
    TokenExchangeResource.idProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "id");
    TokenExchangeResource.uriProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "uri");
    TokenExchangeResource.providerIdProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "providerId");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TokenExchangeResource.idProperty)
    ], TokenExchangeResource.prototype, "id", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TokenExchangeResource.uriProperty)
    ], TokenExchangeResource.prototype, "uri", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TokenExchangeResource.providerIdProperty)
    ], TokenExchangeResource.prototype, "providerId", void 0);
    return TokenExchangeResource;
}($5Ougt.SerializableObject);
module.exports.TokenExchangeResource = $5104722604b983cb$var$TokenExchangeResource;
var $5104722604b983cb$var$Authentication = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Authentication, _super);
    function Authentication() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Authentication.prototype.getSchemaKey = function() {
        return "Authentication";
    };
    //#region Schema
    Authentication.textProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "text");
    Authentication.connectionNameProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "connectionName");
    Authentication.buttonsProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_4, "buttons", $5104722604b983cb$var$AuthCardButton);
    Authentication.tokenExchangeResourceProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_4, "tokenExchangeResource", $5104722604b983cb$var$TokenExchangeResource, true);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Authentication.textProperty)
    ], Authentication.prototype, "text", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Authentication.connectionNameProperty)
    ], Authentication.prototype, "connectionName", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Authentication.buttonsProperty)
    ], Authentication.prototype, "buttons", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Authentication.tokenExchangeResourceProperty)
    ], Authentication.prototype, "tokenExchangeResource", void 0);
    return Authentication;
}($5Ougt.SerializableObject);
module.exports.Authentication = $5104722604b983cb$var$Authentication;
// @dynamic
var $5104722604b983cb$var$AdaptiveCard = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(AdaptiveCard, _super);
    function AdaptiveCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.designMode = false;
        return _this;
    }
    Object.defineProperty(AdaptiveCard.prototype, "refresh", {
        get: function() {
            return this.getValue(AdaptiveCard.refreshProperty);
        },
        set: function(value) {
            this.setValue(AdaptiveCard.refreshProperty, value);
            if (value) value.parent = this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard, "processMarkdown", {
        get: function() {
            throw new Error($24F6S.Strings.errors.processMarkdownEventRemoved());
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        set: function(_value) {
            throw new Error($24F6S.Strings.errors.processMarkdownEventRemoved());
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.applyMarkdown = function(text) {
        var result = {
            didProcess: false
        };
        if (AdaptiveCard.onProcessMarkdown) AdaptiveCard.onProcessMarkdown(text, result);
        else if (window.markdownit) {
            // Check for markdownit
            var markdownIt = window.markdownit;
            result.outputHtml = markdownIt().render(text);
            result.didProcess = true;
        } else if (!AdaptiveCard._haveWarnedAboutNoMarkdownProcessing) {
            // eslint-disable-next-line no-console
            console.warn($24F6S.Strings.errors.markdownProcessingNotEnabled);
            AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = true;
        }
        return result;
    };
    AdaptiveCard.prototype.isVersionSupported = function() {
        if (this.bypassVersionCheck) return true;
        else {
            var unsupportedVersion = !this.version || !this.version.isValid || this.maxVersion.major < this.version.major || this.maxVersion.major === this.version.major && this.maxVersion.minor < this.version.minor;
            return !unsupportedVersion;
        }
    };
    AdaptiveCard.prototype.getDefaultSerializationContext = function() {
        return new $5104722604b983cb$var$SerializationContext(this.version);
    };
    AdaptiveCard.prototype.getItemsCollectionPropertyName = function() {
        return "body";
    };
    AdaptiveCard.prototype.internalParse = function(source, context) {
        this._fallbackCard = undefined;
        var fallbackElement = context.parseElement(undefined, source["fallback"], this.forbiddenChildElements(), !this.isDesignMode());
        if (fallbackElement) {
            this._fallbackCard = new AdaptiveCard();
            this._fallbackCard.addItem(fallbackElement);
        }
        _super.prototype.internalParse.call(this, source, context);
    };
    AdaptiveCard.prototype.internalToJSON = function(target, context) {
        this.setValue(AdaptiveCard.versionProperty, context.targetVersion);
        _super.prototype.internalToJSON.call(this, target, context);
    };
    AdaptiveCard.prototype.internalRender = function() {
        var renderedElement = _super.prototype.internalRender.call(this);
        if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation && renderedElement) // Unlike containers, the root card element should be allowed to
        // be shorter than its content (otherwise the overflow truncation
        // logic would never get triggered)
        renderedElement.style.removeProperty("minHeight");
        return renderedElement;
    };
    AdaptiveCard.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        return true;
    };
    AdaptiveCard.prototype.getDefaultPadding = function() {
        return new $6BHj7.PaddingDefinition($gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding);
    };
    AdaptiveCard.prototype.shouldSerialize = function(_context) {
        return true;
    };
    Object.defineProperty(AdaptiveCard.prototype, "renderIfEmpty", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "bypassVersionCheck", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "allowCustomStyle", {
        get: function() {
            return this.hostConfig.adaptiveCard && this.hostConfig.adaptiveCard.allowCustomStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "hasBackground", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.prototype.getJsonTypeName = function() {
        return "AdaptiveCard";
    };
    AdaptiveCard.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this.getValue($5104722604b983cb$var$CardElement.typeNameProperty) !== "AdaptiveCard") context.addFailure(this, $gIXBn.ValidationEvent.MissingCardType, $24F6S.Strings.errors.invalidCardType());
        if (!this.bypassVersionCheck && !this.version) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.propertyMustBeSet("version"));
        else if (!this.isVersionSupported()) context.addFailure(this, $gIXBn.ValidationEvent.UnsupportedCardVersion, $24F6S.Strings.errors.unsupportedCardVersion(this.version.toString(), this.maxVersion.toString()));
    };
    AdaptiveCard.prototype.render = function(target) {
        var _this = this;
        var renderedCard;
        if (this.shouldFallback() && this._fallbackCard) {
            this._fallbackCard.hostConfig = this.hostConfig;
            renderedCard = this._fallbackCard.render();
        } else {
            renderedCard = _super.prototype.render.call(this);
            if (renderedCard) {
                renderedCard.classList.add(this.hostConfig.makeCssClassName("ac-adaptiveCard"));
                // Having a tabIndex on the root container for a card can mess up accessibility in some scenarios.
                // However, we've shipped this behavior before, and so can't just turn it off in a point release. For
                // now, to unblock accessibility scenarios for our customers, we've got an option to turn it off. In a
                // future release, we should strongly consider flipping the default such that we *don't* emit a tabIndex
                // by default.
                if ($6BHj7.GlobalSettings.setTabIndexAtCardRoot) renderedCard.tabIndex = 0;
                if (this.speak) renderedCard.setAttribute("aria-label", this.speak);
                renderedCard.onmouseenter = function(ev) {
                    _this.updateInputsVisualState(true);
                };
                renderedCard.onmouseleave = function(ev) {
                    _this.updateInputsVisualState(false);
                };
                this.getRootElement().updateActionsEnabledState();
            }
        }
        if (target) {
            $F6YrP.appendChild(target, renderedCard);
            this.updateLayout();
        }
        var inputElements = this.getAllInputs();
        document.onclick = function(event) {
            inputElements.forEach(function(input) {
                var _a, _b;
                if (input instanceof $5104722604b983cb$var$ChoiceSetInput && !((_a = input.renderedElement) === null || _a === void 0 ? void 0 : _a.contains(event.target))) (_b = input.getDropdownElement()) === null || _b === void 0 || _b.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
            });
        };
        return renderedCard;
    };
    AdaptiveCard.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = true;
        _super.prototype.updateLayout.call(this, processChildren);
        if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation && this.isDisplayed()) {
            var padding = this.hostConfig.getEffectiveSpacing($gIXBn.Spacing.Default);
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            this["handleOverflow"](this.renderedElement.offsetHeight - padding);
        }
    };
    AdaptiveCard.prototype.shouldFallback = function() {
        return _super.prototype.shouldFallback.call(this) || !this.isVersionSupported();
    };
    Object.defineProperty(AdaptiveCard.prototype, "hasVisibleSeparator", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.schemaUrl = "http://adaptivecards.io/schemas/adaptive-card.json";
    //#region Schema
    // eslint-disable-next-line @typescript-eslint/naming-convention
    AdaptiveCard.$schemaProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_0, "$schema", function(sender, property, source, context) {
        return AdaptiveCard.schemaUrl;
    }, function(sender, prop, target, value, context) {
        context.serializeValue(target, prop.name, AdaptiveCard.schemaUrl);
    });
    AdaptiveCard.versionProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_0, "version", function(sender, prop, source, context) {
        var version = $5Ougt.Version.parse(source[prop.name], context);
        if (version === undefined) {
            version = $5Ougt.Versions.latest;
            context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidCardVersion(version.toString()));
        }
        return version;
    }, function(sender, prop, target, value, context) {
        if (value !== undefined) context.serializeValue(target, prop.name, value.toString());
    }, $5Ougt.Versions.v1_0);
    AdaptiveCard.fallbackTextProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "fallbackText");
    AdaptiveCard.speakProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "speak");
    AdaptiveCard.refreshProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_4, "refresh", $5104722604b983cb$var$RefreshDefinition, true);
    AdaptiveCard.authenticationProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_4, "authentication", $5104722604b983cb$var$Authentication, true);
    //#endregion
    AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = false;
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AdaptiveCard.versionProperty)
    ], AdaptiveCard.prototype, "version", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AdaptiveCard.fallbackTextProperty)
    ], AdaptiveCard.prototype, "fallbackText", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AdaptiveCard.speakProperty)
    ], AdaptiveCard.prototype, "speak", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AdaptiveCard.refreshProperty)
    ], AdaptiveCard.prototype, "refresh", null);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AdaptiveCard.authenticationProperty)
    ], AdaptiveCard.prototype, "authentication", void 0);
    return AdaptiveCard;
}($5104722604b983cb$var$ContainerWithActions);
module.exports.AdaptiveCard = $5104722604b983cb$var$AdaptiveCard;
var $5104722604b983cb$var$InlineAdaptiveCard = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(InlineAdaptiveCard, _super);
    function InlineAdaptiveCard() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suppressStyle = false;
        return _this;
    }
    InlineAdaptiveCard.prototype.getSchemaKey = function() {
        return "InlineAdaptiveCard";
    };
    InlineAdaptiveCard.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.remove($5104722604b983cb$var$AdaptiveCard.$schemaProperty, $5104722604b983cb$var$AdaptiveCard.versionProperty);
    };
    //#endregion
    InlineAdaptiveCard.prototype.getDefaultPadding = function() {
        return new $6BHj7.PaddingDefinition(this.suppressStyle ? $gIXBn.Spacing.None : $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding, this.suppressStyle ? $gIXBn.Spacing.None : $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding);
    };
    Object.defineProperty(InlineAdaptiveCard.prototype, "bypassVersionCheck", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InlineAdaptiveCard.prototype, "defaultStyle", {
        get: function() {
            if (this.suppressStyle) return $gIXBn.ContainerStyle.Default;
            else return this.hostConfig.actions.showCard.style ? this.hostConfig.actions.showCard.style : $gIXBn.ContainerStyle.Emphasis;
        },
        enumerable: false,
        configurable: true
    });
    InlineAdaptiveCard.prototype.render = function(target) {
        var renderedCard = _super.prototype.render.call(this, target);
        if (renderedCard) {
            renderedCard.setAttribute("aria-live", "polite");
            renderedCard.removeAttribute("tabindex");
        }
        return renderedCard;
    };
    return InlineAdaptiveCard;
}($5104722604b983cb$var$AdaptiveCard);
var $5104722604b983cb$var$SerializationContext = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(SerializationContext, _super);
    function SerializationContext() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._forbiddenTypes = new Set();
        return _this;
    }
    SerializationContext.prototype.internalParseCardObject = function(parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent) {
        var _this = this;
        var result = undefined;
        if (source && typeof source === "object") {
            var oldForbiddenTypes_1 = new Set();
            this._forbiddenTypes.forEach(function(type) {
                oldForbiddenTypes_1.add(type);
            });
            forbiddenTypes.forEach(function(type) {
                _this._forbiddenTypes.add(type);
            });
            var typeName = $F6YrP.parseString(source["type"]);
            if (typeName && this._forbiddenTypes.has(typeName)) logParseEvent(typeName, $gIXBn.TypeErrorType.ForbiddenType);
            else {
                var tryToFallback = false;
                result = createInstanceCallback(typeName);
                if (!result) {
                    tryToFallback = $6BHj7.GlobalSettings.enableFallback && allowFallback;
                    logParseEvent(typeName, $gIXBn.TypeErrorType.UnknownType);
                } else {
                    result.setParent(parent);
                    result.parse(source, this);
                    tryToFallback = $6BHj7.GlobalSettings.enableFallback && allowFallback && result.shouldFallback();
                }
                if (tryToFallback) {
                    var fallback = source["fallback"];
                    if (!fallback && parent) parent.setShouldFallback(true);
                    if (typeof fallback === "string" && fallback.toLowerCase() === "drop") result = undefined;
                    else if (typeof fallback === "object") result = this.internalParseCardObject(parent, fallback, forbiddenTypes, true, createInstanceCallback, logParseEvent);
                }
            }
            this._forbiddenTypes = oldForbiddenTypes_1;
        }
        return result;
    };
    SerializationContext.prototype.cardObjectParsed = function(o, source) {
        if (o instanceof $5104722604b983cb$var$Action && this.onParseAction) this.onParseAction(o, source, this);
        else if (o instanceof $5104722604b983cb$var$CardElement && this.onParseElement) this.onParseElement(o, source, this);
    };
    SerializationContext.prototype.shouldSerialize = function(o) {
        if (o instanceof $5104722604b983cb$var$Action) return this.actionRegistry.findByName(o.getJsonTypeName()) !== undefined;
        else if (o instanceof $5104722604b983cb$var$CardElement) return this.elementRegistry.findByName(o.getJsonTypeName()) !== undefined;
        else return true;
    };
    SerializationContext.prototype.parseCardObject = function(parent, source, forbiddenTypeNames, allowFallback, createInstanceCallback, logParseEvent) {
        var forbiddenTypes = new Set(forbiddenTypeNames);
        var result = this.internalParseCardObject(parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent);
        if (result !== undefined) this.cardObjectParsed(result, source);
        return result;
    };
    SerializationContext.prototype.parseElement = function(parent, source, forbiddenTypes, allowFallback) {
        var _this = this;
        return this.parseCardObject(parent, source, forbiddenTypes, allowFallback, function(typeName) {
            return _this.elementRegistry.createInstance(typeName, _this.targetVersion);
        }, function(typeName, errorType) {
            if (errorType === $gIXBn.TypeErrorType.UnknownType) _this.logParseEvent(undefined, $gIXBn.ValidationEvent.UnknownElementType, $24F6S.Strings.errors.unknownElementType(typeName));
            else _this.logParseEvent(undefined, $gIXBn.ValidationEvent.ElementTypeNotAllowed, $24F6S.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    SerializationContext.prototype.parseAction = function(parent, source, forbiddenActionTypes, allowFallback) {
        var _this = this;
        return this.parseCardObject(parent, source, forbiddenActionTypes, allowFallback, function(typeName) {
            return _this.actionRegistry.createInstance(typeName, _this.targetVersion);
        }, function(typeName, errorType) {
            if (errorType === $gIXBn.TypeErrorType.UnknownType) _this.logParseEvent(undefined, $gIXBn.ValidationEvent.UnknownActionType, $24F6S.Strings.errors.unknownActionType(typeName));
            else _this.logParseEvent(undefined, $gIXBn.ValidationEvent.ActionTypeNotAllowed, $24F6S.Strings.errors.actionTypeNotAllowed(typeName));
        });
    };
    Object.defineProperty(SerializationContext.prototype, "elementRegistry", {
        get: function() {
            var _a;
            return (_a = this._elementRegistry) !== null && _a !== void 0 ? _a : $2Zn2I.GlobalRegistry.elements;
        },
        enumerable: false,
        configurable: true
    });
    // Not using a property setter here because the setter should accept "undefined"
    // whereas the getter should never return undefined.
    SerializationContext.prototype.setElementRegistry = function(value) {
        this._elementRegistry = value;
    };
    Object.defineProperty(SerializationContext.prototype, "actionRegistry", {
        get: function() {
            var _a;
            return (_a = this._actionRegistry) !== null && _a !== void 0 ? _a : $2Zn2I.GlobalRegistry.actions;
        },
        enumerable: false,
        configurable: true
    });
    // Not using a property setter here because the setter should accept "undefined"
    // whereas the getter should never return undefined.
    SerializationContext.prototype.setActionRegistry = function(value) {
        this._actionRegistry = value;
    };
    return SerializationContext;
}($5Ougt.BaseSerializationContext);
module.exports.SerializationContext = $5104722604b983cb$var$SerializationContext;
$2Zn2I.GlobalRegistry.defaultElements.register("Container", $5104722604b983cb$var$Container);
$2Zn2I.GlobalRegistry.defaultElements.register("TextBlock", $5104722604b983cb$var$TextBlock);
$2Zn2I.GlobalRegistry.defaultElements.register("RichTextBlock", $5104722604b983cb$var$RichTextBlock, $5Ougt.Versions.v1_2);
$2Zn2I.GlobalRegistry.defaultElements.register("TextRun", $5104722604b983cb$var$TextRun, $5Ougt.Versions.v1_2);
$2Zn2I.GlobalRegistry.defaultElements.register("Image", $5104722604b983cb$var$Image);
$2Zn2I.GlobalRegistry.defaultElements.register("ImageSet", $5104722604b983cb$var$ImageSet);
$2Zn2I.GlobalRegistry.defaultElements.register("Media", $5104722604b983cb$var$Media, $5Ougt.Versions.v1_1);
$2Zn2I.GlobalRegistry.defaultElements.register("FactSet", $5104722604b983cb$var$FactSet);
$2Zn2I.GlobalRegistry.defaultElements.register("ColumnSet", $5104722604b983cb$var$ColumnSet);
$2Zn2I.GlobalRegistry.defaultElements.register("ActionSet", $5104722604b983cb$var$ActionSet, $5Ougt.Versions.v1_2);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.Text", $5104722604b983cb$var$TextInput);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.Date", $5104722604b983cb$var$DateInput);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.Time", $5104722604b983cb$var$TimeInput);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.Number", $5104722604b983cb$var$NumberInput);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.ChoiceSet", $5104722604b983cb$var$ChoiceSetInput);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.Toggle", $5104722604b983cb$var$ToggleInput);
$2Zn2I.GlobalRegistry.defaultActions.register($5104722604b983cb$var$OpenUrlAction.JsonTypeName, $5104722604b983cb$var$OpenUrlAction);
$2Zn2I.GlobalRegistry.defaultActions.register($5104722604b983cb$var$SubmitAction.JsonTypeName, $5104722604b983cb$var$SubmitAction);
$2Zn2I.GlobalRegistry.defaultActions.register($5104722604b983cb$var$ShowCardAction.JsonTypeName, $5104722604b983cb$var$ShowCardAction);
$2Zn2I.GlobalRegistry.defaultActions.register($5104722604b983cb$var$ToggleVisibilityAction.JsonTypeName, $5104722604b983cb$var$ToggleVisibilityAction, $5Ougt.Versions.v1_2);
$2Zn2I.GlobalRegistry.defaultActions.register($5104722604b983cb$var$ExecuteAction.JsonTypeName, $5104722604b983cb$var$ExecuteAction, $5Ougt.Versions.v1_4);

});
parcelRegister("fuLKQ", function(module, exports) {
"use strict";
var $b47eb36aa0a8babf$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatText = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $b47eb36aa0a8babf$var$AbstractTextFormatter = /** @class */ function() {
    function AbstractTextFormatter(regularExpression) {
        this._regularExpression = regularExpression;
    }
    AbstractTextFormatter.prototype.format = function(lang, input) {
        var matches;
        if (input) {
            var result = input;
            while((matches = this._regularExpression.exec(input)) != null)result = result.replace(matches[0], this.internalFormat(lang, matches));
            return result;
        } else return input;
    };
    return AbstractTextFormatter;
}();
var $b47eb36aa0a8babf$var$DateFormatter = /** @class */ function(_super) {
    $b47eb36aa0a8babf$var$__extends(DateFormatter, _super);
    function DateFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateFormatter.prototype.internalFormat = function(lang, matches) {
        var date = new Date(Date.parse(matches[1]));
        var format = matches[2] !== undefined ? matches[2].toLowerCase() : "compact";
        if (format !== "compact") return date.toLocaleDateString(lang, {
            day: "numeric",
            weekday: format,
            month: format,
            year: "numeric"
        });
        else return date.toLocaleDateString();
    };
    return DateFormatter;
}($b47eb36aa0a8babf$var$AbstractTextFormatter);
var $b47eb36aa0a8babf$var$TimeFormatter = /** @class */ function(_super) {
    $b47eb36aa0a8babf$var$__extends(TimeFormatter, _super);
    function TimeFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeFormatter.prototype.internalFormat = function(lang, matches) {
        var date = new Date(Date.parse(matches[1]));
        return date.toLocaleTimeString(lang, {
            hour: "numeric",
            minute: "2-digit"
        });
    };
    return TimeFormatter;
}($b47eb36aa0a8babf$var$AbstractTextFormatter);
function $b47eb36aa0a8babf$var$formatText(lang, text) {
    var formatters = [
        new $b47eb36aa0a8babf$var$DateFormatter(/\{{2}DATE\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))(?:, ?(COMPACT|LONG|SHORT))?\)\}{2}/g),
        new $b47eb36aa0a8babf$var$TimeFormatter(/\{{2}TIME\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))\)\}{2}/g)
    ];
    var result = text;
    for(var _i = 0, formatters_1 = formatters; _i < formatters_1.length; _i++){
        var formatter = formatters_1[_i];
        result = formatter.format(lang, result);
    }
    return result;
}
module.exports.formatText = $b47eb36aa0a8babf$var$formatText;

});

parcelRegister("iX2Kh", function(module, exports) {
"use strict";
var $dcbfddda8c2cbff8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dcbfddda8c2cbff8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dcbfddda8c2cbff8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// Copyright (C) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
$dcbfddda8c2cbff8$var$__exportStar((parcelRequire("eFbX8")), module.exports);

$dcbfddda8c2cbff8$var$__exportStar((parcelRequire("cCKyr")), module.exports);

});
parcelRegister("eFbX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MenuItem = void 0;

var $8kDQQ = parcelRequire("8kDQQ");

var $birwC = parcelRequire("birwC");
var $aace2a9f550c2003$var$MenuItem = /** @class */ function() {
    function MenuItem(key, value) {
        this._isEnabled = true;
        this.key = key;
        this._value = value;
    }
    MenuItem.prototype.click = function() {
        if (this.isEnabled && this.onClick) this.onClick(this);
    };
    MenuItem.prototype.updateCssClasses = function() {
        if (this._element) {
            var effectiveHostConfig = this._hostConfig ? this._hostConfig : $8kDQQ.defaultHostConfig;
            this._element.className = effectiveHostConfig.makeCssClassName("ac-ctrl");
            this._element.classList.add(effectiveHostConfig.makeCssClassName(this.isEnabled ? "ac-ctrl-dropdown-item" : "ac-ctrl-dropdown-item-disabled"));
            if (!this.isEnabled) this._element.classList.add(effectiveHostConfig.makeCssClassName("ac-disabled"));
        }
    };
    MenuItem.prototype.toString = function() {
        return this.value;
    };
    MenuItem.prototype.render = function(hostConfig) {
        var _this = this;
        this._hostConfig = hostConfig;
        if (!this._element) {
            this._element = document.createElement("span");
            this._element.innerText = this.value;
            this._element.setAttribute("role", "menuitem");
            if (!this.isEnabled) this._element.setAttribute("aria-disabled", "true");
            this._element.setAttribute("aria-current", "false");
            this._element.onmouseup = function(_e) {
                _this.click();
            };
            this._element.onkeydown = function(e) {
                if (e.key === $birwC.Constants.keys.enter) {
                    e.cancelBubble = true;
                    _this.click();
                }
            };
            this.updateCssClasses();
        }
        return this._element;
    };
    Object.defineProperty(MenuItem.prototype, "value", {
        get: function() {
            return this._value;
        },
        set: function(newValue) {
            this._value = newValue;
            if (this._element) this._element.innerText = newValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItem.prototype, "isEnabled", {
        get: function() {
            return this._isEnabled;
        },
        set: function(value) {
            if (this._isEnabled !== value) {
                this._isEnabled = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    return MenuItem;
}();
module.exports.MenuItem = $aace2a9f550c2003$var$MenuItem;

});
parcelRegister("birwC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Constants = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $8396ba0fcb145065$var$Constants = /** @class */ function() {
    function Constants() {}
    Constants.keys = {
        tab: "Tab",
        enter: "Enter",
        escape: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        delete: "Delete"
    };
    return Constants;
}();
module.exports.Constants = $8396ba0fcb145065$var$Constants;

});


parcelRegister("cCKyr", function(module, exports) {
"use strict";
var $930d256c60becd73$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupMenu = void 0;

var $birwC = parcelRequire("birwC");

var $927hd = parcelRequire("927hd");

var $dcULZ = parcelRequire("dcULZ");
var $930d256c60becd73$var$PopupMenu = /** @class */ function(_super) {
    $930d256c60becd73$var$__extends(PopupMenu, _super);
    function PopupMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._items = new $927hd.Collection();
        _this._renderedItems = [];
        _this._selectedIndex = -1;
        return _this;
    }
    PopupMenu.prototype.renderContent = function() {
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-ctrl ac-popup");
        element.setAttribute("role", "listbox");
        for(var i = 0; i < this._items.length; i++){
            var renderedItem = this._items.get(i).render(this.hostConfig);
            renderedItem.tabIndex = 0;
            element.appendChild(renderedItem);
            if (i === this.selectedIndex) renderedItem.focus();
            this._renderedItems.push(renderedItem);
        }
        return element;
    };
    PopupMenu.prototype.keyDown = function(e) {
        _super.prototype.keyDown.call(this, e);
        var selectedItemIndex = this._selectedIndex;
        switch(e.key){
            case $birwC.Constants.keys.tab:
                this.closePopup(true);
                break;
            /*
            case Constants.keys.enter:
                if (this.selectedIndex >= 0) {
                    this.selectedIndex = this.selectedIndex;

                    this.close();
                }

                break;
            */ case $birwC.Constants.keys.up:
                if (selectedItemIndex <= 0) selectedItemIndex = this._renderedItems.length - 1;
                else {
                    selectedItemIndex--;
                    if (selectedItemIndex < 0) selectedItemIndex = this._renderedItems.length - 1;
                }
                this.selectedIndex = selectedItemIndex;
                e.cancelBubble = true;
                break;
            case $birwC.Constants.keys.down:
                if (selectedItemIndex < 0) selectedItemIndex = 0;
                else {
                    selectedItemIndex++;
                    if (selectedItemIndex >= this._renderedItems.length) selectedItemIndex = 0;
                }
                this.selectedIndex = selectedItemIndex;
                e.cancelBubble = true;
                break;
        }
    };
    Object.defineProperty(PopupMenu.prototype, "items", {
        get: function() {
            return this._items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PopupMenu.prototype, "selectedIndex", {
        get: function() {
            return this._selectedIndex;
        },
        set: function(index) {
            if (index >= 0 && index < this._renderedItems.length) {
                this._renderedItems[index].focus();
                this._selectedIndex = index;
            }
        },
        enumerable: false,
        configurable: true
    });
    return PopupMenu;
}($dcULZ.PopupControl);
module.exports.PopupMenu = $930d256c60becd73$var$PopupMenu;

});
parcelRegister("927hd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collection = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $6939f1f1a0878d0d$var$Collection = /** @class */ function() {
    function Collection() {
        this._items = [];
    }
    Collection.prototype.get = function(index) {
        return this._items[index];
    };
    Collection.prototype.add = function(item) {
        this._items.push(item);
        if (this.onItemAdded) this.onItemAdded(item);
    };
    Collection.prototype.remove = function(item) {
        var i = this._items.indexOf(item);
        if (i >= 0) {
            this._items = this._items.splice(i, 1);
            if (this.onItemRemoved) this.onItemRemoved(item);
        }
    };
    Collection.prototype.indexOf = function(item) {
        return this._items.indexOf(item);
    };
    Object.defineProperty(Collection.prototype, "length", {
        get: function() {
            return this._items.length;
        },
        enumerable: false,
        configurable: true
    });
    return Collection;
}();
module.exports.Collection = $6939f1f1a0878d0d$var$Collection;

});

parcelRegister("dcULZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupControl = void 0;

var $birwC = parcelRequire("birwC");

var $F6YrP = parcelRequire("F6YrP");

var $8kDQQ = parcelRequire("8kDQQ");
var $99d86f4d549db4ad$var$PopupControl = /** @class */ function() {
    function PopupControl() {
        this._isOpen = false;
    }
    PopupControl.prototype.keyDown = function(e) {
        switch(e.key){
            case $birwC.Constants.keys.escape:
                this.closePopup(true);
                break;
        }
    };
    PopupControl.prototype.render = function(_rootElementBounds) {
        var _this = this;
        var element = document.createElement("div");
        element.tabIndex = 0;
        element.className = this.hostConfig.makeCssClassName("ac-ctrl", "ac-ctrl-popup-container");
        element.setAttribute("role", "dialog");
        element.setAttribute("aria-modal", "true");
        element.onkeydown = function(e) {
            _this.keyDown(e);
            return !e.cancelBubble;
        };
        element.appendChild(this.renderContent());
        return element;
    };
    PopupControl.prototype.focus = function() {
        if (this._popupElement) this._popupElement.firstElementChild.focus();
    };
    PopupControl.prototype.popup = function(rootElement) {
        var _a, _b, _c, _d, _f;
        var _this = this;
        if (!this._isOpen) {
            this._overlayElement = document.createElement("div");
            this._overlayElement.className = this.hostConfig.makeCssClassName("ac-ctrl-overlay");
            this._overlayElement.tabIndex = 0;
            this._overlayElement.style.width = document.documentElement.scrollWidth + "px";
            this._overlayElement.style.height = document.documentElement.scrollHeight + "px";
            this._overlayElement.onfocus = function(_e) {
                _this.closePopup(true);
            };
            document.body.appendChild(this._overlayElement);
            var rootElementBounds = rootElement.getBoundingClientRect();
            this._popupElement = this.render(rootElementBounds);
            (_a = this._popupElement.classList).remove.apply(_a, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight", "ac-ctrl-slideRightToLeft", "ac-ctrl-slideTopToBottom", "ac-ctrl-slideRightToLeft"));
            window.addEventListener("resize", function(_e) {
                _this.closePopup(true);
            });
            var rootElementLabel = rootElement.getAttribute("aria-label");
            if (rootElementLabel) this._popupElement.setAttribute("aria-label", rootElementLabel);
            this._overlayElement.appendChild(this._popupElement);
            var popupElementBounds = this._popupElement.getBoundingClientRect();
            var availableSpaceBelow = window.innerHeight - rootElementBounds.bottom;
            var availableSpaceAbove = rootElementBounds.top;
            var availableSpaceRight = window.innerWidth - rootElementBounds.right;
            var availableSpaceLeft = rootElementBounds.left;
            var left = rootElementBounds.left + $F6YrP.getScrollX();
            var top_1;
            if (availableSpaceAbove < popupElementBounds.height && availableSpaceBelow < popupElementBounds.height) {
                // Not enough space above or below root element
                var actualPopupHeight = Math.min(popupElementBounds.height, window.innerHeight);
                this._popupElement.style.maxHeight = actualPopupHeight + "px";
                if (actualPopupHeight < popupElementBounds.height) top_1 = $F6YrP.getScrollY();
                else top_1 = $F6YrP.getScrollY() + rootElementBounds.top + (rootElementBounds.height - actualPopupHeight) / 2;
                if (availableSpaceLeft < popupElementBounds.width && availableSpaceRight < popupElementBounds.width) {
                    // Not enough space left or right of root element
                    var actualPopupWidth = Math.min(popupElementBounds.width, window.innerWidth);
                    this._popupElement.style.maxWidth = actualPopupWidth + "px";
                    if (actualPopupWidth < popupElementBounds.width) left = $F6YrP.getScrollX();
                    else left = $F6YrP.getScrollX() + rootElementBounds.left + (rootElementBounds.width - actualPopupWidth) / 2;
                } else // Enough space on the left or right of the root element
                if (availableSpaceRight >= popupElementBounds.width) {
                    left = $F6YrP.getScrollX() + rootElementBounds.right;
                    (_b = this._popupElement.classList).add.apply(_b, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight"));
                } else {
                    left = $F6YrP.getScrollX() + rootElementBounds.left - popupElementBounds.width;
                    (_c = this._popupElement.classList).add.apply(_c, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideRightToLeft"));
                }
            } else {
                // Enough space above or below root element
                if (availableSpaceBelow >= popupElementBounds.height) {
                    top_1 = $F6YrP.getScrollY() + rootElementBounds.bottom;
                    (_d = this._popupElement.classList).add.apply(_d, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideTopToBottom"));
                } else {
                    top_1 = $F6YrP.getScrollY() + rootElementBounds.top - popupElementBounds.height;
                    (_f = this._popupElement.classList).add.apply(_f, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideBottomToTop"));
                }
                if (availableSpaceRight < popupElementBounds.width) left = $F6YrP.getScrollX() + rootElementBounds.right - popupElementBounds.width;
            }
            this._popupElement.style.left = left + "px";
            this._popupElement.style.top = top_1 + "px";
            this._popupElement.focus();
            this._isOpen = true;
        }
    };
    PopupControl.prototype.closePopup = function(wasCancelled) {
        if (this._isOpen) {
            document.body.removeChild(this._overlayElement);
            this._isOpen = false;
            if (this.onClose) this.onClose(this, wasCancelled);
        }
    };
    Object.defineProperty(PopupControl.prototype, "hostConfig", {
        get: function() {
            return this._hostConfig ? this._hostConfig : $8kDQQ.defaultHostConfig;
        },
        set: function(value) {
            this._hostConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PopupControl.prototype, "isOpen", {
        get: function() {
            return this._isOpen;
        },
        enumerable: false,
        configurable: true
    });
    return PopupControl;
}();
module.exports.PopupControl = $99d86f4d549db4ad$var$PopupControl;

});




parcelRegister("99lCx", function(module, exports) {
"use strict";
var $6a95b9bcd8d58230$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6a95b9bcd8d58230$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6a95b9bcd8d58230$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CarouselEvent = module.exports.Carousel = module.exports.CarouselPage = void 0;

var $6XfIC = parcelRequire("6XfIC");

var $gIXBn = parcelRequire("gIXBn");

var $5Ougt = parcelRequire("5Ougt");

var $2Zn2I = parcelRequire("2Zn2I");

var $gIXBn = parcelRequire("gIXBn");

var $24F6S = parcelRequire("24F6S");
parcelRequire("b6mvZ");
var $jITlg = parcelRequire("jITlg");
var $j1U9P = parcelRequire("j1U9P");
var $PP3xB = parcelRequire("PP3xB");
var $8Q03I = parcelRequire("8Q03I");
var $awlOA = parcelRequire("awlOA");
var $deIcY = parcelRequire("deIcY");
var $4648Z = parcelRequire("4648Z");
var $dQfLu = parcelRequire("dQfLu");

var $F6YrP = parcelRequire("F6YrP");

var $6BHj7 = parcelRequire("6BHj7");
// Note: to function correctly, consumers need to have CSS from swiper/css, swiper/css/pagination, and
// swiper/css/navigation
var $6a95b9bcd8d58230$var$CarouselPage = /** @class */ function(_super) {
    $6a95b9bcd8d58230$var$__extends(CarouselPage, _super);
    function CarouselPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#region Schema
    CarouselPage.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // `style`, `bleed`, `isVisible` are not supported in CarouselPage
        schema.remove($6XfIC.Container.styleProperty);
        schema.remove($6XfIC.Container.bleedProperty);
        schema.remove($6XfIC.Container.isVisibleProperty);
    };
    //#endregion
    CarouselPage.prototype.internalRender = function() {
        var carouselSlide = document.createElement("div");
        carouselSlide.className = this.hostConfig.makeCssClassName("swiper-slide");
        // `isRtl()` will set the correct value of rtl by reading the value from the parents
        this.rtl = this.isRtl();
        var renderedElement = _super.prototype.internalRender.call(this);
        $F6YrP.appendChild(carouselSlide, renderedElement);
        return carouselSlide;
    };
    CarouselPage.prototype.getForbiddenActionTypes = function() {
        return [
            $6XfIC.ShowCardAction,
            $6XfIC.ToggleVisibilityAction
        ];
    };
    CarouselPage.prototype.getForbiddenChildElements = function() {
        return this.forbiddenChildElements();
    };
    CarouselPage.prototype.forbiddenChildElements = function() {
        return $6a95b9bcd8d58230$var$__spreadArray([
            $6XfIC.ToggleVisibilityAction.JsonTypeName,
            $6XfIC.ShowCardAction.JsonTypeName,
            "Media",
            "ActionSet",
            "Input.Text",
            "Input.Date",
            "Input.Time",
            "Input.Number",
            "Input.ChoiceSet",
            "Input.Toggle",
            "Carousel"
        ], _super.prototype.forbiddenChildElements.call(this), true);
    };
    CarouselPage.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.setShouldFallback(false);
    };
    CarouselPage.prototype.shouldSerialize = function(_context) {
        return true;
    };
    CarouselPage.prototype.getJsonTypeName = function() {
        return "CarouselPage";
    };
    Object.defineProperty(CarouselPage.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarouselPage.prototype, "hasVisibleSeparator", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return CarouselPage;
}($6XfIC.Container);
module.exports.CarouselPage = $6a95b9bcd8d58230$var$CarouselPage;
var $6a95b9bcd8d58230$var$Carousel = /** @class */ function(_super) {
    $6a95b9bcd8d58230$var$__extends(Carousel, _super);
    function Carousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.carouselLoop = true;
        _this.carouselOrientation = $gIXBn.Orientation.Horizontal;
        _this._pages = [];
        _this._currentIndex = 0;
        _this._previousEventType = $gIXBn.CarouselInteractionEvent.Pagination;
        return _this;
    }
    //#region Schema
    Carousel.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // `style`, `bleed`, `isVisible` are not supported in Carousel
        schema.remove($6XfIC.Container.styleProperty);
        schema.remove($6XfIC.Container.bleedProperty);
        schema.remove($6XfIC.Container.isVisibleProperty);
    };
    Object.defineProperty(Carousel.prototype, "timer", {
        get: function() {
            var timer = this.getValue(Carousel.timerProperty);
            if (timer && timer < this.hostConfig.carousel.minAutoplayDelay) {
                console.warn($24F6S.Strings.errors.tooLittleTimeDelay);
                timer = this.hostConfig.carousel.minAutoplayDelay;
            }
            return timer;
        },
        set: function(value) {
            if (value && value < this.hostConfig.carousel.minAutoplayDelay) {
                console.warn($24F6S.Strings.errors.tooLittleTimeDelay);
                this.setValue(Carousel.timerProperty, this.hostConfig.carousel.minAutoplayDelay);
            } else this.setValue(Carousel.timerProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "initialPageIndex", {
        get: function() {
            return this.getValue(Carousel.initialPageProperty);
        },
        set: function(value) {
            if (this.isValidParsedPageIndex(value)) this.setValue(Carousel.initialPageProperty, value);
            else {
                console.warn($24F6S.Strings.errors.invalidInitialPageIndex(value));
                this.setValue(Carousel.initialPageProperty, 0);
            }
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.isValidParsedPageIndex = function(index) {
        return this._pages ? this.isValidPageIndex(index, this._pages.length) : false;
    };
    Carousel.prototype.isValidRenderedPageIndex = function(index) {
        return this._renderedPages ? this.isValidPageIndex(index, this._renderedPages.length) : false;
    };
    Carousel.prototype.isValidPageIndex = function(index, collectionSize) {
        return collectionSize > 0 && 0 <= index && index < collectionSize;
    };
    Object.defineProperty(Carousel.prototype, "previousEventType", {
        //#endregion
        get: function() {
            return this._previousEventType;
        },
        set: function(eventType) {
            this._previousEventType = eventType;
        },
        enumerable: false,
        configurable: true
    });
    // Question: Why do we place this on the Carousel instead of the CarouselPage?
    Carousel.prototype.forbiddenChildElements = function() {
        return $6a95b9bcd8d58230$var$__spreadArray([
            $6XfIC.ToggleVisibilityAction.JsonTypeName,
            $6XfIC.ShowCardAction.JsonTypeName,
            "Media",
            "ActionSet",
            "Input.Text",
            "Input.Date",
            "Input.Time",
            "Input.Number",
            "Input.ChoiceSet",
            "Input.Toggle"
        ], _super.prototype.forbiddenChildElements.call(this), true);
    };
    Carousel.prototype.adjustRenderedElementSize = function(renderedElement) {
        _super.prototype.adjustRenderedElementSize.call(this, renderedElement);
        if (this.height == "stretch" && this._containerForAdorners !== undefined) this._containerForAdorners.style.height = "100%";
        // Assign the explicit height to carouselPageContainer if given
        if (this.carouselHeight) this._carouselPageContainer.style.height = this.carouselHeight + "px";
    };
    Carousel.prototype.getJsonTypeName = function() {
        return "Carousel";
    };
    Carousel.prototype.getItemCount = function() {
        return this._pages.length;
    };
    Carousel.prototype.getItemAt = function(index) {
        return this._pages[index];
    };
    Carousel.prototype.addPage = function(page) {
        this._pages.push(page);
        page.setParent(this);
    };
    Carousel.prototype.removeItem = function(item) {
        if (item instanceof $6a95b9bcd8d58230$var$CarouselPage) {
            var itemIndex = this._pages.indexOf(item);
            if (itemIndex >= 0) {
                this._pages.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    Carousel.prototype.getFirstVisibleRenderedItem = function() {
        var _a;
        if (this.renderedElement && ((_a = this._renderedPages) === null || _a === void 0 ? void 0 : _a.length) > 0) return this._renderedPages[0];
        else return undefined;
    };
    Carousel.prototype.getLastVisibleRenderedItem = function() {
        var _a;
        if (this.renderedElement && ((_a = this._renderedPages) === null || _a === void 0 ? void 0 : _a.length) > 0) return this._renderedPages[this._renderedPages.length - 1];
        else return undefined;
    };
    Object.defineProperty(Carousel.prototype, "currentPageId", {
        get: function() {
            var _a, _b;
            if ((_b = (_a = this._carousel) === null || _a === void 0 ? void 0 : _a.slides) === null || _b === void 0 ? void 0 : _b.length) {
                var activeSlide = this._carousel.slides[this._carousel.activeIndex];
                return activeSlide.id;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "currentPageIndex", {
        get: function() {
            var _a;
            return (_a = this._carousel) === null || _a === void 0 ? void 0 : _a.realIndex;
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._pages = [];
        var jsonPages = source["pages"];
        if (Array.isArray(jsonPages)) for(var _i = 0, jsonPages_1 = jsonPages; _i < jsonPages_1.length; _i++){
            var item = jsonPages_1[_i];
            var page = this.createCarouselPageInstance(item, context);
            if (page) this._pages.push(page);
        }
        // everything is parsed do validate on initial page index
        this.validateParsing(context);
    };
    Carousel.prototype.validateParsing = function(context) {
        if (!this.isValidParsedPageIndex(this.initialPageIndex)) context.logParseEvent(this, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidInitialPageIndex(this.initialPageIndex));
    };
    Carousel.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, "pages", this._pages);
    };
    Carousel.prototype.internalRender = function() {
        var _a;
        this._renderedPages = [];
        if (this._pages.length <= 0) return undefined;
        this.validateOrientationProperties();
        var cardLevelContainer = document.createElement("div");
        cardLevelContainer.className = this.hostConfig.makeCssClassName("ac-carousel-card-level-container");
        var carouselContainer = document.createElement("div");
        carouselContainer.className = this.hostConfig.makeCssClassName("swiper", "ac-carousel");
        this._carouselPageContainer = carouselContainer;
        var containerForAdorners = document.createElement("div");
        containerForAdorners.className = this.hostConfig.makeCssClassName("ac-carousel-container");
        this._containerForAdorners = containerForAdorners;
        cardLevelContainer.appendChild(containerForAdorners);
        var navigationContainer = document.createElement("div");
        navigationContainer.className = this.hostConfig.makeCssClassName("ac-carousel-navigation");
        containerForAdorners.appendChild(navigationContainer);
        var carouselWrapper = document.createElement("div");
        carouselWrapper.className = this.hostConfig.makeCssClassName("swiper-wrapper", "ac-carousel-card-container");
        carouselWrapper.style.display = "flex";
        switch(this.getEffectiveVerticalContentAlignment()){
            case $gIXBn.VerticalAlignment.Top:
                carouselWrapper.style.alignItems = "flex-start";
                break;
            case $gIXBn.VerticalAlignment.Bottom:
                carouselWrapper.style.alignItems = "flex-end";
                break;
            default:
                carouselWrapper.style.alignItems = "center";
                break;
        }
        if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation) // Forces the container to be at least as tall as its content.
        //
        // Fixes a quirk in Chrome where, for nested flex elements, the
        // inner element's height would never exceed the outer element's
        // height. This caused overflow truncation to break -- containers
        // would always be measured as not overflowing, since their heights
        // were constrained by their parents as opposed to truly reflecting
        // the height of their content.
        //
        // See the "Browser Rendering Notes" section of this answer:
        // https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
        carouselWrapper.style.minHeight = "-webkit-min-content";
        var prevElementDiv = document.createElement("div");
        prevElementDiv.className = this.hostConfig.makeCssClassName("swiper-button-prev");
        var nextElementDiv = document.createElement("div");
        nextElementDiv.className = this.hostConfig.makeCssClassName("swiper-button-next");
        if (this.carouselOrientation === $gIXBn.Orientation.Horizontal) this.updateCssForHorizontalCarousel(prevElementDiv, nextElementDiv);
        else this.updateCssForVerticalCarousel(navigationContainer, prevElementDiv, nextElementDiv);
        var pagination = document.createElement("div");
        pagination.className = this.hostConfig.makeCssClassName("swiper-pagination", "ac-carousel-pagination");
        navigationContainer.appendChild(prevElementDiv);
        $F6YrP.addCancelSelectActionEventHandler(prevElementDiv);
        navigationContainer.appendChild(pagination);
        $F6YrP.addCancelSelectActionEventHandler(pagination);
        navigationContainer.appendChild(nextElementDiv);
        $F6YrP.addCancelSelectActionEventHandler(nextElementDiv);
        if (this.isDesignMode()) {
            // If we are in design mode, we need to ensure these elements are in front of the peers
            prevElementDiv.style.zIndex = "20";
            nextElementDiv.style.zIndex = "20";
            pagination.style.zIndex = "20";
        }
        var requestedNumberOfPages = Math.min(this._pages.length, this.hostConfig.carousel.maxCarouselPages);
        if (this._pages.length > this.hostConfig.carousel.maxCarouselPages) console.warn($24F6S.Strings.errors.tooManyCarouselPages);
        if (this._pages.length > 0) for(var i = 0; i < requestedNumberOfPages; i++){
            var page = this._pages[i];
            var renderedItem = this.isElementAllowed(page) ? page.render() : undefined;
            renderedItem === null || renderedItem === void 0 || renderedItem.classList.add("ac-carousel-page");
            (_a = renderedItem === null || renderedItem === void 0 ? void 0 : renderedItem.children[0]) === null || _a === void 0 || _a.classList.add("ac-carousel-page-container");
            if (renderedItem) {
                $F6YrP.appendChild(carouselWrapper, renderedItem);
                this._renderedPages.push(page);
            }
        }
        carouselContainer.appendChild(carouselWrapper);
        carouselContainer.tabIndex = this.isDesignMode() ? -1 : 0;
        containerForAdorners.appendChild(carouselContainer);
        // `isRtl()` will set the correct value of rtl by reading the value from the parents
        this.rtl = this.isRtl();
        this.applyRTL(pagination);
        if (!this.isDesignMode()) {
            if (this.isValidRenderedPageIndex(this.initialPageIndex)) this._currentIndex = this.initialPageIndex;
            else {
                console.warn($24F6S.Strings.errors.invalidInitialPageIndex(this.initialPageIndex));
                this._currentIndex = 0;
            }
        }
        this.initializeCarouselControl(carouselContainer, nextElementDiv, prevElementDiv, pagination, this.rtl);
        return this._renderedPages.length > 0 ? cardLevelContainer : undefined;
    };
    Carousel.prototype.applyRTL = function(pagination) {
        _super.prototype.applyRTL.call(this, this._carouselPageContainer);
        if (this.rtl) pagination.classList.add(this.hostConfig.makeCssClassName("ac-carousel-pagination-rtl"));
    };
    Carousel.prototype.validateOrientationProperties = function() {
        if (!this.carouselHeight) this.carouselOrientation = $gIXBn.Orientation.Horizontal;
    };
    Carousel.prototype.updateCssForHorizontalCarousel = function(prevElementDiv, nextElementDiv) {
        prevElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-left"));
        nextElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-right"));
    };
    Carousel.prototype.updateCssForVerticalCarousel = function(navigationContainer, prevElementDiv, nextElementDiv) {
        this._containerForAdorners.classList.add(this.hostConfig.makeCssClassName("ac-carousel-container-vertical"));
        navigationContainer.classList.add(this.hostConfig.makeCssClassName("ac-carousel-navigation-vertical"));
        prevElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-up"));
        nextElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-down"));
    };
    Carousel.prototype.initializeCarouselControl = function(carouselContainer, nextElement, prevElement, paginationElement, rtl) {
        var _this = this;
        var _a, _b, _c;
        var nextElementAdjustedForRtl = rtl === undefined || !rtl ? nextElement : prevElement;
        var prevElementAdjustedForRtl = rtl === undefined || !rtl ? prevElement : nextElement;
        var prevElementAdjustedForOrientation = $gIXBn.Orientation.Horizontal === this.carouselOrientation ? prevElementAdjustedForRtl : prevElement;
        var nextElementAdjustedForOrientation = $gIXBn.Orientation.Horizontal === this.carouselOrientation ? nextElementAdjustedForRtl : nextElement;
        var swiperOptions = {
            loop: !this.isDesignMode() && this.carouselLoop,
            modules: [
                $awlOA.default,
                $deIcY.default,
                $4648Z.default,
                $jITlg.default,
                $PP3xB.default,
                $8Q03I.default
            ],
            pagination: {
                el: paginationElement,
                clickable: true
            },
            navigation: {
                prevEl: prevElementAdjustedForOrientation,
                nextEl: nextElementAdjustedForOrientation
            },
            a11y: {
                enabled: true
            },
            keyboard: {
                enabled: false,
                onlyInViewport: true
            },
            direction: this.carouselOrientation === $gIXBn.Orientation.Horizontal ? "horizontal" : "vertical",
            resizeObserver: false,
            initialSlide: this._currentIndex
        };
        if (this.timer && !this.isDesignMode()) {
            (_a = swiperOptions.modules) === null || _a === void 0 || _a.push($j1U9P.default);
            swiperOptions.autoplay = {
                delay: this.timer,
                pauseOnMouseEnter: true
            };
        }
        var carousel = new $dQfLu.default(carouselContainer, swiperOptions);
        // While the 'pauseOnMouseEnter' option should resume autoplay on
        // mouse exit it doesn't do it, so adding custom events to handle it
        carouselContainer.addEventListener("mouseenter", function(_event) {
            var _a;
            (_a = carousel.autoplay) === null || _a === void 0 || _a.stop();
        });
        carouselContainer.addEventListener("mouseleave", function(_event) {
            var _a;
            (_a = carousel.autoplay) === null || _a === void 0 || _a.start();
        });
        carousel.on('navigationNext', function(swiper) {
            _this.raiseCarouselEvent($gIXBn.CarouselInteractionEvent.NavigationNext);
        });
        carousel.on('navigationPrev', function(swiper) {
            _this.raiseCarouselEvent($gIXBn.CarouselInteractionEvent.NavigationPrevious);
        });
        carousel.on('slideChangeTransitionEnd', function(swiper) {
            _this.currentIndex = swiper.realIndex;
            _this.raiseCarouselEvent($gIXBn.CarouselInteractionEvent.Pagination);
        });
        carousel.on('autoplay', function() {
            _this.raiseCarouselEvent($gIXBn.CarouselInteractionEvent.Autoplay);
        });
        carousel.on('paginationRender', function(swiper, paginationEl) {
            swiper.pagination.bullets.forEach(function(bullet, index) {
                bullet.addEventListener("keypress", function(event) {
                    if (event.key == "Enter") {
                        event.preventDefault();
                        swiper.slideTo(index + 1);
                    }
                });
            });
        });
        carousel.on('destroy', function() {
            _this.destroyResizeObserver();
        });
        prevElement.title = (_b = prevElement.ariaLabel) !== null && _b !== void 0 ? _b : $24F6S.Strings.defaults.carouselNavigationPreviousTooltip();
        nextElement.title = (_c = nextElement.ariaLabel) !== null && _c !== void 0 ? _c : $24F6S.Strings.defaults.carouselNavigationNextTooltip();
        this._carousel = carousel;
        this.createResizeObserver();
    };
    Carousel.prototype.createCarouselPageInstance = function(source, context) {
        return context.parseCardObject(this, source, this.forbiddenChildElements(), !this.isDesignMode(), function(typeName) {
            return !typeName || typeName === "CarouselPage" ? new $6a95b9bcd8d58230$var$CarouselPage() : undefined;
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $gIXBn.ValidationEvent.ElementTypeNotAllowed, $24F6S.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    Carousel.prototype.slideTo = function(index) {
        var _a;
        (_a = this._carousel) === null || _a === void 0 || _a.slideTo(index);
    };
    Object.defineProperty(Carousel.prototype, "carouselPageContainer", {
        get: function() {
            return this._carouselPageContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "currentIndex", {
        get: function() {
            return this._currentIndex;
        },
        set: function(currentIndex) {
            this._currentIndex = currentIndex;
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.createCarouselEvent = function(type) {
        var currentPageId;
        if (this.currentPageIndex != undefined) currentPageId = this.getItemAt(this.currentPageIndex).id;
        return new $6a95b9bcd8d58230$var$CarouselEvent(type, this.id, currentPageId, this.currentPageIndex);
    };
    Carousel.prototype.raiseCarouselEvent = function(eventType) {
        var card = this.parent ? this.parent.getRootElement() : undefined;
        var onCarouselEventHandler = card && card.onCarouselEvent ? card.onCarouselEvent : $6XfIC.AdaptiveCard.onCarouselEvent;
        // pagination event is triggered on slide transition end event 
        if (onCarouselEventHandler && eventType == $gIXBn.CarouselInteractionEvent.Pagination) // returns the event type that causes slide transition
        onCarouselEventHandler(this.createCarouselEvent(this.previousEventType));
        this.previousEventType = eventType;
    };
    /// Swiper version 8 added requestAnimationFrame() call in its resize observer code
    /// The new call causes flickering issue,
    /// We've copied resize observer code from Swiper version 7 with some modifications
    Carousel.prototype.createResizeObserver = function() {
        var _this = this;
        var _a;
        if (!this.checkIfCarouselInValidStateForResizeEvent()) return;
        this._observer = new ResizeObserver(function(entries) {
            var _a, _b, _c, _d;
            var width = (_a = _this._carousel) === null || _a === void 0 ? void 0 : _a.width;
            var height = (_b = _this._carousel) === null || _b === void 0 ? void 0 : _b.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function(_a) {
                var _b;
                var contentBoxSize = _a.contentBoxSize, contentRect = _a.contentRect, target = _a.target;
                if (target && target !== ((_b = _this._carousel) === null || _b === void 0 ? void 0 : _b.el)) return;
                newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });
            if (newWidth !== width || newHeight !== height) {
                if (_this.checkIfCarouselInValidStateForResizeEvent()) {
                    (_c = _this._carousel) === null || _c === void 0 || _c.emit('beforeResize');
                    (_d = _this._carousel) === null || _d === void 0 || _d.emit('resize');
                }
            }
        });
        this._observer.observe((_a = this._carousel) === null || _a === void 0 ? void 0 : _a.el);
    };
    Carousel.prototype.destroyResizeObserver = function() {
        var _a;
        if (this._observer && this._observer.unobserve && ((_a = this._carousel) === null || _a === void 0 ? void 0 : _a.el)) {
            this._observer.unobserve(this._carousel.el);
            this._observer = null;
        }
    };
    Carousel.prototype.checkIfCarouselInValidStateForResizeEvent = function() {
        return this._carousel && !this._carousel.destroyed;
    };
    Carousel.timerProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "timer", undefined);
    Carousel.initialPageProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "initialPage", 0);
    Carousel.loopProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_6, "loop", true);
    Carousel.orientationProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_6, "orientation", $gIXBn.Orientation, $gIXBn.Orientation.Horizontal);
    Carousel.carouselHeightProperty = new $5Ougt.PixelSizeProperty($5Ougt.Versions.v1_6, "heightInPixels");
    $6a95b9bcd8d58230$var$__decorate([
        (0, $5Ougt.property)(Carousel.timerProperty)
    ], Carousel.prototype, "timer", null);
    $6a95b9bcd8d58230$var$__decorate([
        (0, $5Ougt.property)(Carousel.initialPageProperty)
    ], Carousel.prototype, "initialPageIndex", null);
    $6a95b9bcd8d58230$var$__decorate([
        (0, $5Ougt.property)(Carousel.loopProperty)
    ], Carousel.prototype, "carouselLoop", void 0);
    $6a95b9bcd8d58230$var$__decorate([
        (0, $5Ougt.property)(Carousel.orientationProperty)
    ], Carousel.prototype, "carouselOrientation", void 0);
    $6a95b9bcd8d58230$var$__decorate([
        (0, $5Ougt.property)(Carousel.carouselHeightProperty)
    ], Carousel.prototype, "carouselHeight", void 0);
    return Carousel;
}($6XfIC.Container);
module.exports.Carousel = $6a95b9bcd8d58230$var$Carousel;
var $6a95b9bcd8d58230$var$CarouselEvent = /** @class */ function() {
    function CarouselEvent(type, carouselId, activeCarouselPageId, activeCarouselPageIndex) {
        this.type = type;
        this.carouselId = carouselId;
        this.activeCarouselPageId = activeCarouselPageId;
        this.activeCarouselPageIndex = activeCarouselPageIndex;
    }
    return CarouselEvent;
}();
module.exports.CarouselEvent = $6a95b9bcd8d58230$var$CarouselEvent;
$2Zn2I.GlobalRegistry.defaultElements.register("Carousel", $6a95b9bcd8d58230$var$Carousel, $5Ougt.Versions.v1_6);

});
parcelRegister("b6mvZ", function(module, exports) {

$parcel$export(module.exports, "Swiper", () => (parcelRequire("dQfLu")).default);
$parcel$export(module.exports, "Keyboard", () => (parcelRequire("8Q03I")).default);
$parcel$export(module.exports, "Navigation", () => (parcelRequire("awlOA")).default);
$parcel$export(module.exports, "Pagination", () => (parcelRequire("deIcY")).default);
$parcel$export(module.exports, "Scrollbar", () => (parcelRequire("4648Z")).default);
$parcel$export(module.exports, "A11y", () => (parcelRequire("jITlg")).default);
$parcel$export(module.exports, "History", () => (parcelRequire("PP3xB")).default);
$parcel$export(module.exports, "Autoplay", () => (parcelRequire("j1U9P")).default);
/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ 
var $dQfLu = parcelRequire("dQfLu");

var $4qE3U = parcelRequire("4qE3U");

var $8Q03I = parcelRequire("8Q03I");

var $5nU4l = parcelRequire("5nU4l");

var $awlOA = parcelRequire("awlOA");

var $deIcY = parcelRequire("deIcY");

var $4648Z = parcelRequire("4648Z");

var $em541 = parcelRequire("em541");

var $chcb1 = parcelRequire("chcb1");

var $cmf7N = parcelRequire("cmf7N");

var $6P4A4 = parcelRequire("6P4A4");

var $jITlg = parcelRequire("jITlg");

var $PP3xB = parcelRequire("PP3xB");

var $8MXvy = parcelRequire("8MXvy");

var $j1U9P = parcelRequire("j1U9P");

var $1zOwu = parcelRequire("1zOwu");

var $i1zC2 = parcelRequire("i1zC2");

var $5RFYN = parcelRequire("5RFYN");

var $8okVo = parcelRequire("8okVo");

var $6SK5Z = parcelRequire("6SK5Z");

var $4ORyx = parcelRequire("4ORyx");

var $4lZfa = parcelRequire("4lZfa");

var $4abV7 = parcelRequire("4abV7");

var $cNzyd = parcelRequire("cNzyd");

var $gdzc7 = parcelRequire("gdzc7");

});
parcelRegister("dQfLu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a13c5c430bd4eedc$export$2e2bcd8739ae039);
/* eslint no-param-reassign: "off" */ 
var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");

var $1mfhi = parcelRequire("1mfhi");

var $a4AaA = parcelRequire("a4AaA");

var $c7sep = parcelRequire("c7sep");

var $9ds5j = parcelRequire("9ds5j");

var $cLreg = parcelRequire("cLreg");

var $fRG22 = parcelRequire("fRG22");

var $htB5L = parcelRequire("htB5L");

var $btAdb = parcelRequire("btAdb");

var $lOBx6 = parcelRequire("lOBx6");

var $2mxRy = parcelRequire("2mxRy");

var $lRvCK = parcelRequire("lRvCK");

var $l71cV = parcelRequire("l71cV");

var $i0518 = parcelRequire("i0518");

var $54oKQ = parcelRequire("54oKQ");

var $6ZMCi = parcelRequire("6ZMCi");

var $3JPaV = parcelRequire("3JPaV");

var $avmYP = parcelRequire("avmYP");

var $jnHEu = parcelRequire("jnHEu");

var $604MY = parcelRequire("604MY");
const $a13c5c430bd4eedc$var$prototypes = {
    eventsEmitter: $fRG22.default,
    update: $htB5L.default,
    translate: $btAdb.default,
    transition: $lOBx6.default,
    slide: $2mxRy.default,
    loop: $lRvCK.default,
    grabCursor: $l71cV.default,
    events: $i0518.default,
    breakpoints: $54oKQ.default,
    checkOverflow: $avmYP.default,
    classes: $6ZMCi.default,
    images: $3JPaV.default
};
const $a13c5c430bd4eedc$var$extendedDefaults = {};
class $a13c5c430bd4eedc$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $7XrMI.extend)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $diCnN.default)(params.el).length > 1) {
            const swipers = [];
            (0, $diCnN.default)(params.el).each((containerEl)=>{
                const newParams = (0, $7XrMI.extend)({}, params, {
                    el: containerEl
                });
                swipers.push(new $a13c5c430bd4eedc$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $1mfhi.getSupport)();
        swiper.device = (0, $a4AaA.getDevice)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $c7sep.getBrowser)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $604MY.default)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $7XrMI.extend)({}, (0, $jnHEu.default), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $7XrMI.extend)({}, swiperParams, $a13c5c430bd4eedc$var$extendedDefaults, params);
        swiper.originalParams = (0, $7XrMI.extend)({}, swiper.params);
        swiper.passedParams = (0, $7XrMI.extend)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $diCnN.default); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $diCnN.default)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    'touchstart',
                    'touchmove',
                    'touchend',
                    'touchcancel'
                ];
                const desktop = [
                    'pointerdown',
                    'pointermove',
                    'pointerup'
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $7XrMI.now)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper'); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $diCnN.default)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $diCnN.default)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $diCnN.default)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $d1zq2.getDocument)();
            const wrapper = document.createElement('div');
            $wrapperEl = (0, $diCnN.default)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
            wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit'); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy'); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr('style');
            $wrapperEl.removeAttr('style');
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
        swiper.emit('destroy'); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $7XrMI.deleteProps)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $7XrMI.extend)($a13c5c430bd4eedc$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $a13c5c430bd4eedc$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $jnHEu.default;
    }
    static installModule(mod) {
        if (!$a13c5c430bd4eedc$var$Swiper.prototype.__modules__) $a13c5c430bd4eedc$var$Swiper.prototype.__modules__ = [];
        const modules = $a13c5c430bd4eedc$var$Swiper.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$a13c5c430bd4eedc$var$Swiper.installModule(m));
            return $a13c5c430bd4eedc$var$Swiper;
        }
        $a13c5c430bd4eedc$var$Swiper.installModule(module);
        return $a13c5c430bd4eedc$var$Swiper;
    }
}
Object.keys($a13c5c430bd4eedc$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($a13c5c430bd4eedc$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $a13c5c430bd4eedc$var$Swiper.prototype[protoMethod] = $a13c5c430bd4eedc$var$prototypes[prototypeGroup][protoMethod];
    });
});
$a13c5c430bd4eedc$var$Swiper.use([
    (0, $9ds5j.default),
    (0, $cLreg.default)
]);
var $a13c5c430bd4eedc$export$2e2bcd8739ae039 = $a13c5c430bd4eedc$var$Swiper;

});
parcelRegister("d1zq2", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $97b6d7d0165eea06$export$f65ca476c09acec0);
$parcel$export(module.exports, "getWindow", () => $97b6d7d0165eea06$export$38b2d434cce3ea22);
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $97b6d7d0165eea06$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $97b6d7d0165eea06$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($97b6d7d0165eea06$var$isObject(src[key]) && $97b6d7d0165eea06$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $97b6d7d0165eea06$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $97b6d7d0165eea06$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $97b6d7d0165eea06$export$f65ca476c09acec0() {
    const doc = typeof document !== 'undefined' ? document : {};
    $97b6d7d0165eea06$export$8b58be045bf06082(doc, $97b6d7d0165eea06$export$3fdcb9b4d81368d8);
    return doc;
}
const $97b6d7d0165eea06$export$8582633f185c62bb = {
    document: $97b6d7d0165eea06$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $97b6d7d0165eea06$export$38b2d434cce3ea22() {
    const win = typeof window !== 'undefined' ? window : {};
    $97b6d7d0165eea06$export$8b58be045bf06082(win, $97b6d7d0165eea06$export$8582633f185c62bb);
    return win;
}

});

parcelRegister("diCnN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aeabad7b7a7973d$export$2e2bcd8739ae039);

var $juGff = parcelRequire("juGff");
const $9aeabad7b7a7973d$var$Methods = {
    addClass: $juGff.addClass,
    removeClass: $juGff.removeClass,
    hasClass: $juGff.hasClass,
    toggleClass: $juGff.toggleClass,
    attr: $juGff.attr,
    removeAttr: $juGff.removeAttr,
    transform: $juGff.transform,
    transition: $juGff.transition,
    on: $juGff.on,
    off: $juGff.off,
    trigger: $juGff.trigger,
    transitionEnd: $juGff.transitionEnd,
    outerWidth: $juGff.outerWidth,
    outerHeight: $juGff.outerHeight,
    styles: $juGff.styles,
    offset: $juGff.offset,
    css: $juGff.css,
    each: $juGff.each,
    html: $juGff.html,
    text: $juGff.text,
    is: $juGff.is,
    index: $juGff.index,
    eq: $juGff.eq,
    append: $juGff.append,
    prepend: $juGff.prepend,
    next: $juGff.next,
    nextAll: $juGff.nextAll,
    prev: $juGff.prev,
    prevAll: $juGff.prevAll,
    parent: $juGff.parent,
    parents: $juGff.parents,
    closest: $juGff.closest,
    find: $juGff.find,
    children: $juGff.children,
    filter: $juGff.filter,
    remove: $juGff.remove
};
Object.keys($9aeabad7b7a7973d$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $juGff.$).fn, methodName, {
        value: $9aeabad7b7a7973d$var$Methods[methodName],
        writable: true
    });
});
var $9aeabad7b7a7973d$export$2e2bcd8739ae039 = (0, $juGff.$);

});
parcelRegister("juGff", function(module, exports) {

$parcel$export(module.exports, "$", () => $);
$parcel$export(module.exports, "addClass", () => addClass);
$parcel$export(module.exports, "removeClass", () => removeClass);
$parcel$export(module.exports, "toggleClass", () => toggleClass);
$parcel$export(module.exports, "hasClass", () => hasClass);
$parcel$export(module.exports, "attr", () => attr);
$parcel$export(module.exports, "removeAttr", () => removeAttr);
$parcel$export(module.exports, "transform", () => transform);
$parcel$export(module.exports, "transition", () => transition);
$parcel$export(module.exports, "on", () => on);
$parcel$export(module.exports, "off", () => off);
$parcel$export(module.exports, "trigger", () => trigger);
$parcel$export(module.exports, "transitionEnd", () => transitionEnd);
$parcel$export(module.exports, "outerWidth", () => outerWidth);
$parcel$export(module.exports, "outerHeight", () => outerHeight);
$parcel$export(module.exports, "offset", () => offset);
$parcel$export(module.exports, "styles", () => styles);
$parcel$export(module.exports, "css", () => css);
$parcel$export(module.exports, "each", () => each);
$parcel$export(module.exports, "filter", () => filter);
$parcel$export(module.exports, "html", () => html);
$parcel$export(module.exports, "text", () => text);
$parcel$export(module.exports, "is", () => is);
$parcel$export(module.exports, "index", () => index);
$parcel$export(module.exports, "eq", () => eq);
$parcel$export(module.exports, "append", () => append);
$parcel$export(module.exports, "prepend", () => prepend);
$parcel$export(module.exports, "next", () => next);
$parcel$export(module.exports, "nextAll", () => nextAll);
$parcel$export(module.exports, "prev", () => prev);
$parcel$export(module.exports, "prevAll", () => prevAll);
$parcel$export(module.exports, "parent", () => parent);
$parcel$export(module.exports, "parents", () => parents);
$parcel$export(module.exports, "closest", () => closest);
$parcel$export(module.exports, "find", () => find);
$parcel$export(module.exports, "children", () => children);
$parcel$export(module.exports, "remove", () => remove);
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $d1zq2 = parcelRequire("d1zq2");
/* eslint-disable no-proto */ function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class Dom7 extends Array {
    constructor(items){
        if (typeof items === 'number') super(items);
        else {
            super(...items || []);
            makeReactive(this);
        }
    }
}
function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== 'string') return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    const window = (0, $d1zq2.getWindow)();
    const document = (0, $d1zq2.getDocument)();
    let arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === 'string') {
        const html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            let toCreate = 'div';
            if (html.indexOf('<li') === 0) toCreate = 'ul';
            if (html.indexOf('<tr') === 0) toCreate = 'tbody';
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
            if (html.indexOf('<tbody') === 0) toCreate = 'table';
            if (html.indexOf('<option') === 0) toCreate = 'select';
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    return arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === 'string') {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    let el;
    if (typeof value === 'undefined') {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf('data-') >= 0) dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === 'false') dataset[key] = false;
        else if (dataset[key] === 'true') dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === 'undefined') {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === 'select') {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
    return this;
}
function on(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(' ');
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(' ');
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
    const window = (0, $d1zq2.getWindow)();
    const events = args[0].split(' ');
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionstart', fireCallBack);
    }
    if (callback) dom.on('transitionstart', fireCallBack);
    return this;
}
function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
    }
    if (callback) dom.on('transitionend', fireCallBack);
    return this;
}
function animationEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('animationend', fireCallBack);
    }
    if (callback) dom.on('animationend', fireCallBack);
    return this;
}
function width() {
    const window = (0, $d1zq2.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css('width'));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    const window = (0, $d1zq2.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css('height'));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        const window = (0, $d1zq2.getWindow)();
        const document = (0, $d1zq2.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = 'none';
    return this;
}
function show() {
    const window = (0, $d1zq2.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === 'none') el.style.display = '';
        if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') // Still not visible
        el.style.display = 'block';
    }
    return this;
}
function styles() {
    const window = (0, $d1zq2.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    const window = (0, $d1zq2.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === 'string') {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    const result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === 'undefined') return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === 'undefined') return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    const window = (0, $d1zq2.getWindow)();
    const document = (0, $d1zq2.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === 'undefined') return this;
    const length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append(...els) {
    let newChild;
    const document = (0, $d1zq2.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === 'string') {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    const document = (0, $d1zq2.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === 'string') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    const before = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    const after = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = '';
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo(...args) {
    const window = (0, $d1zq2.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === 'function') {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === 'undefined') easing = 'swing';
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === 'undefined') easing = 'swing';
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === 'undefined') {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === 'undefined') {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    const window = (0, $d1zq2.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: 'swing' // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === 'swing') return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === 'function') return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, '');
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue, finalValue, unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === 'stop') animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const noTrigger = 'resize scroll'.split(' ');
function shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === 'undefined') {
            for(let i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const click = shortcut('click');
const blur = shortcut('blur');
const focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const scroll = shortcut('scroll');
var $e31196a498af4f21$export$2e2bcd8739ae039 = $;

});


parcelRegister("7XrMI", function(module, exports) {

$parcel$export(module.exports, "deleteProps", () => $5cb3988f52077c60$export$8694e5c03a4df8e6);
$parcel$export(module.exports, "nextTick", () => $5cb3988f52077c60$export$bdd553fddd433dcb);
$parcel$export(module.exports, "now", () => $5cb3988f52077c60$export$461939dd4422153);
$parcel$export(module.exports, "getTranslate", () => $5cb3988f52077c60$export$5ec402b7fcf74398);
$parcel$export(module.exports, "isObject", () => $5cb3988f52077c60$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "extend", () => $5cb3988f52077c60$export$8b58be045bf06082);
$parcel$export(module.exports, "setCSSProperty", () => $5cb3988f52077c60$export$a607267f322101fd);
$parcel$export(module.exports, "animateCSSModeScroll", () => $5cb3988f52077c60$export$a5dd2b4b1a116d6d);

var $d1zq2 = parcelRequire("d1zq2");
function $5cb3988f52077c60$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $5cb3988f52077c60$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $5cb3988f52077c60$export$461939dd4422153() {
    return Date.now();
}
function $5cb3988f52077c60$export$3735103072e4a80(el) {
    const window1 = (0, $d1zq2.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $5cb3988f52077c60$export$5ec402b7fcf74398(el, axis = 'x') {
    const window1 = (0, $d1zq2.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $5cb3988f52077c60$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $5cb3988f52077c60$export$a6cdc56e425d0d0a(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $5cb3988f52077c60$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $5cb3988f52077c60$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$5cb3988f52077c60$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($5cb3988f52077c60$export$a6cdc56e425d0d0a(to[nextKey]) && $5cb3988f52077c60$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $5cb3988f52077c60$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$5cb3988f52077c60$export$a6cdc56e425d0d0a(to[nextKey]) && $5cb3988f52077c60$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $5cb3988f52077c60$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $5cb3988f52077c60$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $5cb3988f52077c60$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $d1zq2.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}

});

parcelRegister("1mfhi", function(module, exports) {

$parcel$export(module.exports, "getSupport", () => $0fd3b2685b7b465b$export$d61c7b85ff180578);

var $d1zq2 = parcelRequire("d1zq2");
let $0fd3b2685b7b465b$var$support;
function $0fd3b2685b7b465b$var$calcSupport() {
    const window = (0, $d1zq2.getWindow)();
    const document = (0, $d1zq2.getDocument)();
    return {
        smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener('testPassiveListener', null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return 'ongesturestart' in window;
        }()
    };
}
function $0fd3b2685b7b465b$export$d61c7b85ff180578() {
    if (!$0fd3b2685b7b465b$var$support) $0fd3b2685b7b465b$var$support = $0fd3b2685b7b465b$var$calcSupport();
    return $0fd3b2685b7b465b$var$support;
}

});

parcelRegister("a4AaA", function(module, exports) {

$parcel$export(module.exports, "getDevice", () => $755655a3649a303b$export$30c823bc834d6ab4);

var $d1zq2 = parcelRequire("d1zq2");

var $1mfhi = parcelRequire("1mfhi");
let $755655a3649a303b$var$deviceCached;
function $755655a3649a303b$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $1mfhi.getSupport)();
    const window = (0, $d1zq2.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel'; // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    } // Export object
    return device;
}
function $755655a3649a303b$export$30c823bc834d6ab4(overrides = {}) {
    if (!$755655a3649a303b$var$deviceCached) $755655a3649a303b$var$deviceCached = $755655a3649a303b$var$calcDevice(overrides);
    return $755655a3649a303b$var$deviceCached;
}

});

parcelRegister("c7sep", function(module, exports) {

$parcel$export(module.exports, "getBrowser", () => $8d2c09a154c94fb0$export$89e15fc796a4a429);

var $d1zq2 = parcelRequire("d1zq2");
let $8d2c09a154c94fb0$var$browser;
function $8d2c09a154c94fb0$var$calcBrowser() {
    const window = (0, $d1zq2.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $8d2c09a154c94fb0$export$89e15fc796a4a429() {
    if (!$8d2c09a154c94fb0$var$browser) $8d2c09a154c94fb0$var$browser = $8d2c09a154c94fb0$var$calcBrowser();
    return $8d2c09a154c94fb0$var$browser;
}

});

parcelRegister("9ds5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b5b1cf83f516a8f$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");
function $6b5b1cf83f516a8f$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $d1zq2.getWindow)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
}

});

parcelRegister("cLreg", function(module, exports) {

$parcel$export(module.exports, "default", () => $94aefef3f61bdaa4$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");
function $94aefef3f61bdaa4$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $d1zq2.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: typeof options.childList === 'undefined' ? true : options.childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}

});

parcelRegister("fRG22", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8cc68e19e08afc2$export$2e2bcd8739ae039);
/* eslint-disable no-underscore-dangle */ var $b8cc68e19e08afc2$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};

});

parcelRegister("htB5L", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb91eaca9de20e96$export$2e2bcd8739ae039);

var $eTgqb = parcelRequire("eTgqb");

var $1TFQ7 = parcelRequire("1TFQ7");

var $cJm1s = parcelRequire("cJm1s");

var $1ymZz = parcelRequire("1ymZz");

var $7w1gy = parcelRequire("7w1gy");

var $7aUF8 = parcelRequire("7aUF8");

var $eCbgU = parcelRequire("eCbgU");

var $ifTqA = parcelRequire("ifTqA");

var $39WX8 = parcelRequire("39WX8");
var $cb91eaca9de20e96$export$2e2bcd8739ae039 = {
    updateSize: $eTgqb.default,
    updateSlides: $1TFQ7.default,
    updateAutoHeight: $cJm1s.default,
    updateSlidesOffset: $1ymZz.default,
    updateSlidesProgress: $7w1gy.default,
    updateProgress: $7aUF8.default,
    updateSlidesClasses: $eCbgU.default,
    updateActiveIndex: $ifTqA.default,
    updateClickedSlide: $39WX8.default
};

});
parcelRegister("eTgqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad72f0b20284c27d$export$2e2bcd8739ae039);
function $ad72f0b20284c27d$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}

});

parcelRegister("1TFQ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $161b61f4b9a58a65$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $161b61f4b9a58a65$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
    });
    else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $7XrMI.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-before', '');
        (0, $7XrMI.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css('display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = 'none';
            if (currentWebKitTransform) slide[0].style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $7XrMI.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $7XrMI.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}

});

parcelRegister("cJm1s", function(module, exports) {

$parcel$export(module.exports, "default", () => $944ac532c60ecaf3$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");
function $944ac532c60ecaf3$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $diCnN.default)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}

});

parcelRegister("1ymZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $121acd2f593ea6c6$export$2e2bcd8739ae039);
function $121acd2f593ea6c6$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}

});

parcelRegister("7w1gy", function(module, exports) {

$parcel$export(module.exports, "default", () => $578c80f3d9963634$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");
function $578c80f3d9963634$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $diCnN.default)(swiper.visibleSlides);
}

});

parcelRegister("7aUF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $53956b89e3712b61$export$2e2bcd8739ae039);
function $53956b89e3712b61$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}

});

parcelRegister("eCbgU", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa3d5b9c9656698b$export$2e2bcd8739ae039);
function $aa3d5b9c9656698b$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}

});

parcelRegister("ifTqA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a49f82b66da990$export$2e2bcd8739ae039);
function $d4a49f82b66da990$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === 'undefined') {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit('slideChange');
}

});

parcelRegister("39WX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $24cff12a3882e474$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");
function $24cff12a3882e474$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $diCnN.default)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $diCnN.default)(slide).attr('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}

});


parcelRegister("btAdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ae7e05440bb5df$export$2e2bcd8739ae039);

var $smOwM = parcelRequire("smOwM");

var $8lZy6 = parcelRequire("8lZy6");

var $boKRy = parcelRequire("boKRy");

var $9Dun6 = parcelRequire("9Dun6");

var $bXnJp = parcelRequire("bXnJp");
var $85ae7e05440bb5df$export$2e2bcd8739ae039 = {
    getTranslate: $smOwM.default,
    setTranslate: $8lZy6.default,
    minTranslate: $boKRy.default,
    maxTranslate: $9Dun6.default,
    translateTo: $bXnJp.default
};

});
parcelRegister("smOwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $055450046e4698cd$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $055450046e4698cd$export$2e2bcd8739ae039(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $7XrMI.getTranslate)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}

});

parcelRegister("8lZy6", function(module, exports) {

$parcel$export(module.exports, "default", () => $61500742c901f0f5$export$2e2bcd8739ae039);
function $61500742c901f0f5$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}

});

parcelRegister("boKRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $84c64996406e568d$export$2e2bcd8739ae039);
function $84c64996406e568d$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}

});

parcelRegister("9Dun6", function(module, exports) {

$parcel$export(module.exports, "default", () => $703f50c31e565a1d$export$2e2bcd8739ae039);
function $703f50c31e565a1d$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}

});

parcelRegister("bXnJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b479cf4bda6936d$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $8b479cf4bda6936d$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $7XrMI.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}

});


parcelRegister("lOBx6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe1b61c321437e48$export$2e2bcd8739ae039);

var $59zek = parcelRequire("59zek");

var $hpASV = parcelRequire("hpASV");

var $chuxE = parcelRequire("chuxE");
var $fe1b61c321437e48$export$2e2bcd8739ae039 = {
    setTransition: $59zek.default,
    transitionStart: $hpASV.default,
    transitionEnd: $chuxE.default
};

});
parcelRegister("59zek", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c091efdadc3c71a$export$2e2bcd8739ae039);
function $3c091efdadc3c71a$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit('setTransition', duration, byController);
}

});

parcelRegister("hpASV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad16206409b0957$export$2e2bcd8739ae039);

var $86f2w = parcelRequire("86f2w");
function $cad16206409b0957$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $86f2w.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}

});
parcelRegister("86f2w", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5a8cd309859a6c$export$2e2bcd8739ae039);
function $5e5a8cd309859a6c$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}

});


parcelRegister("chuxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f0ec38906b8c141$export$2e2bcd8739ae039);

var $86f2w = parcelRequire("86f2w");
function $8f0ec38906b8c141$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $86f2w.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}

});


parcelRegister("2mxRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b87e743e7ead7c6$export$2e2bcd8739ae039);

var $k3KuU = parcelRequire("k3KuU");

var $fXSr2 = parcelRequire("fXSr2");

var $ehhOe = parcelRequire("ehhOe");

var $ej3AS = parcelRequire("ej3AS");

var $9FqR6 = parcelRequire("9FqR6");

var $3VIFz = parcelRequire("3VIFz");

var $3SsfN = parcelRequire("3SsfN");
var $1b87e743e7ead7c6$export$2e2bcd8739ae039 = {
    slideTo: $k3KuU.default,
    slideToLoop: $fXSr2.default,
    slideNext: $ehhOe.default,
    slidePrev: $ej3AS.default,
    slideReset: $9FqR6.default,
    slideToClosest: $3VIFz.default,
    slideToClickedSlide: $3SsfN.default
};

});
parcelRegister("k3KuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9a827ec34e0dc2e$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $e9a827ec34e0dc2e$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== 'number' && typeof index !== 'string') throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset'; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $7XrMI.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}

});

parcelRegister("fXSr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9f697654e552d5d$export$2e2bcd8739ae039);
function $b9f697654e552d5d$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

});

parcelRegister("ehhOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a65077c2d527a347$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $a65077c2d527a347$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

});

parcelRegister("ej3AS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6a5a0b5eba97a1e$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $a6a5a0b5eba97a1e$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

});

parcelRegister("9FqR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $709cc64ef9602464$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $709cc64ef9602464$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

});

parcelRegister("3VIFz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dc9586134ba9a0f$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $2dc9586134ba9a0f$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}

});

parcelRegister("3SsfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d2c54e0696c1809$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $2d2c54e0696c1809$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $diCnN.default)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $7XrMI.nextTick)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $7XrMI.nextTick)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}

});


parcelRegister("lRvCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fea7140ca1a6dd40$export$2e2bcd8739ae039);

var $lAzGI = parcelRequire("lAzGI");

var $1rqvj = parcelRequire("1rqvj");

var $5nNGT = parcelRequire("5nNGT");
var $fea7140ca1a6dd40$export$2e2bcd8739ae039 = {
    loopCreate: $lAzGI.default,
    loopFix: $1rqvj.default,
    loopDestroy: $5nNGT.default
};

});
parcelRegister("lAzGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb78a4a7feba37e5$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");
function $fb78a4a7feba37e5$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $d1zq2.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $diCnN.default)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $diCnN.default)(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $diCnN.default)(el);
        slide.attr('data-swiper-slide-index', index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $diCnN.default)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $diCnN.default)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}

});

parcelRegister("1rqvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $10ccdf3837023031$export$2e2bcd8739ae039);
function $10ccdf3837023031$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit('beforeLoopFix');
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
}

});

parcelRegister("5nNGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb5a5494b15f128$export$2e2bcd8739ae039);
function $3eb5a5494b15f128$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr('data-swiper-slide-index');
}

});


parcelRegister("l71cV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5eb303010685450$export$2e2bcd8739ae039);

var $jfK8n = parcelRequire("jfK8n");

var $8LU4Y = parcelRequire("8LU4Y");
var $f5eb303010685450$export$2e2bcd8739ae039 = {
    setGrabCursor: $jfK8n.default,
    unsetGrabCursor: $8LU4Y.default
};

});
parcelRegister("jfK8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0433455a3d4258c$export$2e2bcd8739ae039);
function $e0433455a3d4258c$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
}

});

parcelRegister("8LU4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $662e36ae4c9fe3ff$export$2e2bcd8739ae039);
function $662e36ae4c9fe3ff$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}

});


parcelRegister("i0518", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1ac1e69f48928d0$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $3z83Q = parcelRequire("3z83Q");

var $kBLP4 = parcelRequire("kBLP4");

var $gNYUo = parcelRequire("gNYUo");

var $h4iS9 = parcelRequire("h4iS9");

var $lUNYV = parcelRequire("lUNYV");

var $1gmp9 = parcelRequire("1gmp9");
let $d1ac1e69f48928d0$var$dummyEventAttached = false;
function $d1ac1e69f48928d0$var$dummyEventListener() {}
const $d1ac1e69f48928d0$var$events = (swiper, method)=>{
    const document = (0, $d1zq2.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $h4iS9.default), true);
    else swiper[swiperMethod]('observerUpdate', (0, $h4iS9.default), true);
};
function $d1ac1e69f48928d0$var$attachEvents() {
    const swiper = this;
    const document = (0, $d1zq2.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $3z83Q.default).bind(swiper);
    swiper.onTouchMove = (0, $kBLP4.default).bind(swiper);
    swiper.onTouchEnd = (0, $gNYUo.default).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $1gmp9.default).bind(swiper);
    swiper.onClick = (0, $lUNYV.default).bind(swiper);
    if (support.touch && !$d1ac1e69f48928d0$var$dummyEventAttached) {
        document.addEventListener('touchstart', $d1ac1e69f48928d0$var$dummyEventListener);
        $d1ac1e69f48928d0$var$dummyEventAttached = true;
    }
    $d1ac1e69f48928d0$var$events(swiper, 'on');
}
function $d1ac1e69f48928d0$var$detachEvents() {
    const swiper = this;
    $d1ac1e69f48928d0$var$events(swiper, 'off');
}
var $d1ac1e69f48928d0$export$2e2bcd8739ae039 = {
    attachEvents: $d1ac1e69f48928d0$var$attachEvents,
    detachEvents: $d1ac1e69f48928d0$var$detachEvents
};

});
parcelRegister("3z83Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $298ae4b6816188f8$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $298ae4b6816188f8$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $d1zq2.getDocument)() || el === (0, $d1zq2.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $298ae4b6816188f8$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $d1zq2.getDocument)();
    const window = (0, $d1zq2.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $diCnN.default)(e.target);
    if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $diCnN.default)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $298ae4b6816188f8$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $7XrMI.now)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === 'SELECT') data.isTouched = false;
        }
        if (document.activeElement && (0, $diCnN.default)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}

});

parcelRegister("kBLP4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f00c5bedfedc8a94$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $f00c5bedfedc8a94$export$2e2bcd8739ae039(event) {
    const document = (0, $d1zq2.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $diCnN.default)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $7XrMI.now)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $diCnN.default)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}

});

parcelRegister("gNYUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3c07819907689a9$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $c3c07819907689a9$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $7XrMI.now)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $7XrMI.now)();
    (0, $7XrMI.nextTick)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}

});

parcelRegister("h4iS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6d173118330172b$export$2e2bcd8739ae039);
function $c6d173118330172b$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}

});

parcelRegister("lUNYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff45993fdc966e91$export$2e2bcd8739ae039);
function $ff45993fdc966e91$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}

});

parcelRegister("1gmp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb8aa2c0f224c8d$export$2e2bcd8739ae039);
function $0eb8aa2c0f224c8d$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}

});


parcelRegister("54oKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b10873badb9fe7a$export$2e2bcd8739ae039);

var $8HGoa = parcelRequire("8HGoa");

var $gWhU5 = parcelRequire("gWhU5");
var $3b10873badb9fe7a$export$2e2bcd8739ae039 = {
    setBreakpoint: $8HGoa.default,
    getBreakpoint: $gWhU5.default
};

});
parcelRegister("8HGoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $65633865cc209c59$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
const $65633865cc209c59$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $65633865cc209c59$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $65633865cc209c59$var$isGridEnabled(swiper, params);
    const isMultiRow = $65633865cc209c59$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $7XrMI.extend)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakpointParams);
}

});

parcelRegister("gWhU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c54ff367fda7fe4c$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");
function $c54ff367fda7fe4c$export$2e2bcd8739ae039(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $d1zq2.getWindow)();
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}

});


parcelRegister("6ZMCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $517e26dd5ba0a5eb$export$2e2bcd8739ae039);

var $fEGg7 = parcelRequire("fEGg7");

var $crzJO = parcelRequire("crzJO");
var $517e26dd5ba0a5eb$export$2e2bcd8739ae039 = {
    addClasses: $fEGg7.default,
    removeClasses: $crzJO.default
};

});
parcelRegister("fEGg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65b5f367e9b61a6$export$2e2bcd8739ae039);
function $b65b5f367e9b61a6$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $b65b5f367e9b61a6$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $b65b5f367e9b61a6$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'pointer-events': !support.touch
        },
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(' '));
    swiper.emitContainerClasses();
}

});

parcelRegister("crzJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f3ba735cc74ac7$export$2e2bcd8739ae039);
function $90f3ba735cc74ac7$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
}

});


parcelRegister("3JPaV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8d45647d2e7329$export$2e2bcd8739ae039);

var $cwoSt = parcelRequire("cwoSt");

var $fqMST = parcelRequire("fqMST");
var $2b8d45647d2e7329$export$2e2bcd8739ae039 = {
    loadImage: $cwoSt.default,
    preloadImages: $fqMST.default
};

});
parcelRegister("cwoSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $91dbc56336164767$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");
function $91dbc56336164767$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $d1zq2.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $diCnN.default)(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}

});

parcelRegister("fqMST", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3bf3428b3616c22$export$2e2bcd8739ae039);
function $b3bf3428b3616c22$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit('imagesReady');
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
}

});


parcelRegister("avmYP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a5e9fffa3772a51$export$2e2bcd8739ae039);
function $7a5e9fffa3772a51$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $7a5e9fffa3772a51$export$2e2bcd8739ae039 = {
    checkOverflow: $7a5e9fffa3772a51$var$checkOverflow
};

});

parcelRegister("jnHEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c206ae04cf20e6$export$2e2bcd8739ae039);
var $e1c206ae04cf20e6$export$2e2bcd8739ae039 = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};

});

parcelRegister("604MY", function(module, exports) {

$parcel$export(module.exports, "default", () => $45e6751f444d0888$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $45e6751f444d0888$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $7XrMI.extend)(allModulesParams, obj);
            return;
        }
        if ([
            'navigation',
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $7XrMI.extend)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $7XrMI.extend)(allModulesParams, obj);
    };
}

});


parcelRegister("4qE3U", function(module, exports) {

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $3398aa9a88cda661$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $diCnN.default)(params.renderSlide.call(swiper, slide, index)) : (0, $diCnN.default)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
                if (cachedElIndex) $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $7XrMI.setCSSProperty)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}

});

parcelRegister("8Q03I", function(module, exports) {

$parcel$export(module.exports, "default", () => $66f339c047af0ca3$export$2e2bcd8739ae039);
/* eslint-disable consistent-return */ 
var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");
function $66f339c047af0ca3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $d1zq2.getDocument)();
    const window = (0, $d1zq2.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $diCnN.default)(document).on('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $diCnN.default)(document).off('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}

});

parcelRegister("5nU4l", function(module, exports) {
/* eslint-disable consistent-return */ 
var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $3eba97dc8ce69d05$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $d1zq2.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $7XrMI.now)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $7XrMI.now)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $7XrMI.now)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $diCnN.default)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $7XrMI.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $7XrMI.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $7XrMI.nextTick)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $7XrMI.nextTick)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $diCnN.default)(swiper.params.mousewheel.eventsTarget);
        target[method]('mouseenter', handleMouseEnter);
        target[method]('mouseleave', handleMouseLeave);
        target[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('on');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('off');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}

});

parcelRegister("awlOA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8dd08c709bfac3$export$2e2bcd8739ae039);

var $dvPmG = parcelRequire("dvPmG");

var $diCnN = parcelRequire("diCnN");
function $7a8dd08c709bfac3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $diCnN.default)(el);
            if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
            if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $dvPmG.default)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on('click', onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on('click', onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off('click', onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off('click', onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    });
    on('click', (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $diCnN.default)(targetEl).is($prevEl) && !(0, $diCnN.default)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRegister("dvPmG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d660396a7030d20$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");
function $9d660396a7030d20$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $d1zq2.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement('div');
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}

});


parcelRegister("deIcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a2ee00583712409$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");

var $5lps1 = parcelRequire("5lps1");

var $dvPmG = parcelRequire("dvPmG");
function $9a2ee00583712409$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                '',
                '-next',
                '-next-next',
                '-prev',
                '-prev-prev',
                '-main'
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(' '));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $diCnN.default)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets($bullet, 'next');
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, 'prev');
                            setSideBullets($lastDisplayedBullet, 'next');
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, 'prev');
                        setSideBullets($lastDisplayedBullet, 'next');
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
            }
        }
        if (params.type === 'fraction') {
            $el.find((0, $5lps1.default)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $5lps1.default)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === 'horizontal') scaleX = scale;
            else scaleY = scale;
            $el.find((0, $5lps1.default)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit('paginationRender', $el[0]);
        } else emit('paginationUpdate', $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $5lps1.default)(params.bulletClass));
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== 'custom') emit('paginationRender', swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $dvPmG.default)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $diCnN.default)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $diCnN.default)(el).parents('.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === 'bullets' && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === 'bullets' && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on('click', (0, $5lps1.default)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $diCnN.default)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off('click', (0, $5lps1.default)(params.bulletClass));
    }
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        if (!swiper.params.loop) update();
    });
    on('slidesLengthChange', ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on('snapGridLengthChange', ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $diCnN.default)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRegister("5lps1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e42a7f54a829de6$export$2e2bcd8739ae039);
function $3e42a7f54a829de6$export$2e2bcd8739ae039(classes = '') {
    return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}

});


parcelRegister("4648Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbaefe040bb0fa0$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");

var $dvPmG = parcelRequire("dvPmG");
function $2fbaefe040bb0fa0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $d1zq2.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = 'none';
        else $el[0].style.display = '';
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css('opacity', 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css('scroll-snap-type', 'none');
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css('scroll-snap-type', '');
            $wrapperEl.transition('');
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $7XrMI.nextTick)(()=>{
                $el.css('opacity', 0);
                $el.transition(400);
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $dvPmG.default)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $diCnN.default)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $diCnN.default)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}

});

parcelRegister("em541", function(module, exports) {

var $diCnN = parcelRequire("diCnN");
function $a7370c5a9c9596a1$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $diCnN.default)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr('data-swiper-parallax') || '0';
        let x = $el.attr('data-swiper-parallax-x');
        let y = $el.attr('data-swiper-parallax-y');
        const scale = $el.attr('data-swiper-parallax-scale');
        const opacity = $el.attr('data-swiper-parallax-opacity');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === 'undefined' || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $diCnN.default)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((parallaxEl)=>{
            const $parallaxEl = (0, $diCnN.default)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}

});

parcelRegister("chcb1", function(module, exports) {

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $8f0084a45e083870$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $d1zq2.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $diCnN.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === 'gesturechange') onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $7XrMI.getTranslate)(gesture.$imageWrapEl[0], 'x') || 0;
            image.startY = (0, $7XrMI.getTranslate)(gesture.$imageWrapEl[0], 'y') || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform('translate3d(0,0,0)');
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $diCnN.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures('on');
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures('off');
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}

});

parcelRegister("cmf7N", function(module, exports) {

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");
function $8ff3459092631854$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: '',
            elementClass: 'swiper-lazy',
            loadingClass: 'swiper-lazy-loading',
            loadedClass: 'swiper-lazy-loaded',
            preloaderClass: 'swiper-lazy-preloader'
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === 'undefined') return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $diCnN.default)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr('data-background');
            const src = $imageEl.attr('data-src');
            const srcset = $imageEl.attr('data-srcset');
            const sizes = $imageEl.attr('data-sizes');
            const $pictureEl = $imageEl.parent('picture');
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css('background-image', `url("${background}")`);
                    $imageEl.removeAttr('data-background');
                } else {
                    if (srcset) {
                        $imageEl.attr('srcset', srcset);
                        $imageEl.removeAttr('data-srcset');
                    }
                    if (sizes) {
                        $imageEl.attr('sizes', sizes);
                        $imageEl.removeAttr('data-sizes');
                    }
                    if ($pictureEl.length) $pictureEl.children('source').each((sourceEl)=>{
                        const $source = (0, $diCnN.default)(sourceEl);
                        if ($source.attr('data-srcset')) {
                            $source.attr('srcset', $source.attr('data-srcset'));
                            $source.removeAttr('data-srcset');
                        }
                    });
                    if (src) {
                        $imageEl.attr('src', src);
                        $imageEl.removeAttr('data-src');
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit('lazyImageReady', $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === 'auto') slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $diCnN.default)(slideEl).attr('data-swiper-slide-index');
            return (0, $diCnN.default)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $diCnN.default)(slideEl).attr('data-swiper-slide-index') : (0, $diCnN.default)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $d1zq2.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $diCnN.default)(swiper.params.lazy.scrollingElement) : (0, $diCnN.default)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
        }
    }
    on('beforeInit', ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on('init', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('scroll', ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on('scrollbarDragMove resize _freeModeNoMomentumRelease', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('transitionStart', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on('transitionEnd', ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('slideChange', ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on('destroy', ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}

});

parcelRegister("6P4A4", function(module, exports) {
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
var $7XrMI = parcelRequire("7XrMI");
function $4f7b0f1f7788628e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $7XrMI.nextTick)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === 'slide') c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}

});

parcelRegister("jITlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $03b49900aaad77d8$export$2e2bcd8739ae039);

var $5lps1 = parcelRequire("5lps1");

var $diCnN = parcelRequire("diCnN");
function $03b49900aaad77d8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
    }
    function makeElNotFocusable($el) {
        $el.attr('tabIndex', '-1');
    }
    function addElRole($el, role) {
        $el.attr('role', role);
    }
    function addElRoleDescription($el, description) {
        $el.attr('aria-roledescription', description);
    }
    function addElControls($el, controls) {
        $el.attr('aria-controls', controls);
    }
    function addElLabel($el, label) {
        $el.attr('aria-label', label);
    }
    function addElId($el, id) {
        $el.attr('id', id);
    }
    function addElLive($el, live) {
        $el.attr('aria-live', live);
    }
    function disableEl($el) {
        $el.attr('aria-disabled', true);
    }
    function enableEl($el) {
        $el.attr('aria-disabled', false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $diCnN.default)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $5lps1.default)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $diCnN.default)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, 'button');
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr('aria-current', 'true');
            else $bulletEl.removeAttr('aria-current');
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== 'BUTTON') {
            addElRole($el, 'button');
            $el.on('keydown', onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $diCnN.default)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $diCnN.default)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $diCnN.default)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on('keydown', (0, $5lps1.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on('focus', handleFocus, true);
        swiper.$el.on('pointerdown', handlePointerDown, true);
        swiper.$el.on('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off('keydown', onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off('keydown', onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off('keydown', (0, $5lps1.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off('focus', handleFocus, true);
        swiper.$el.off('pointerdown', handlePointerDown, true);
        swiper.$el.off('pointerup', handlePointerUp, true);
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $diCnN.default)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}

});

parcelRegister("PP3xB", function(module, exports) {

$parcel$export(module.exports, "default", () => $09bc5e372596a3ae$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");
function $09bc5e372596a3ae$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $d1zq2.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $d1zq2.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr('data-history'));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $d1zq2.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $d1zq2.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}

});

parcelRegister("8MXvy", function(module, exports) {

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");
function $6660f77297e2649d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $d1zq2.getDocument)();
    const window = (0, $d1zq2.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === 'undefined') return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
            emit('hashSet');
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr('data-hash') || slide.attr('data-history');
            document.location.hash = hash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr('data-hash') || slide.attr('data-history');
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $diCnN.default)(window).on('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $diCnN.default)(window).off('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}

});

parcelRegister("j1U9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $dda9ac0e7bbec1b6$export$2e2bcd8739ae039);
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $d1zq2 = parcelRequire("d1zq2");

var $7XrMI = parcelRequire("7XrMI");
function $dda9ac0e7bbec1b6$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $7XrMI.nextTick)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit('autoplay');
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit('autoplay');
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit('autoplayStart');
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === 'undefined') return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit('autoplayStop');
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $d1zq2.getDocument)();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) pause();
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit('autoplayPause');
            pause();
        }
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit('autoplayResume');
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on('mouseenter', onMouseEnter);
            swiper.$el.on('mouseleave', onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off('mouseenter', onMouseEnter);
        swiper.$el.off('mouseleave', onMouseLeave);
    }
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $d1zq2.getDocument)();
            document.addEventListener('visibilitychange', onVisibilityChange);
            attachMouseEvents();
        }
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on('sliderFirstMove', ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on('touchEnd', ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on('destroy', ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $d1zq2.getDocument)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}

});

parcelRegister("1zOwu", function(module, exports) {

var $7XrMI = parcelRequire("7XrMI");

var $diCnN = parcelRequire("diCnN");
function $1260402135f6c3cd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $diCnN.default)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $diCnN.default)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
            else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $7XrMI.isObject)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}

});

parcelRegister("i1zC2", function(module, exports) {

var $7XrMI = parcelRequire("7XrMI");
function $d1f3f1e65b27884e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $7XrMI.now)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $7XrMI.now)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $7XrMI.now)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}

});

parcelRegister("5RFYN", function(module, exports) {
function $4452773fb1998b29$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                '-webkit-order': newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel('margin-top'), row !== 0 ? spaceBetween && `${spaceBetween}px` : '');
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel('width')]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}

});

parcelRegister("8okVo", function(module, exports) {

var $khY8L = parcelRequire("khY8L");

var $6F8iQ = parcelRequire("6F8iQ");

var $f7QgY = parcelRequire("f7QgY");

var $583Xd = parcelRequire("583Xd");

var $j9SDI = parcelRequire("j9SDI");
function $61c0cbd63045e691$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $khY8L.default).bind(swiper),
        prependSlide: (0, $6F8iQ.default).bind(swiper),
        addSlide: (0, $f7QgY.default).bind(swiper),
        removeSlide: (0, $583Xd.default).bind(swiper),
        removeAllSlides: (0, $j9SDI.default).bind(swiper)
    });
}

});
parcelRegister("khY8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec540bcaaac9d4ac$export$2e2bcd8739ae039);
function $ec540bcaaac9d4ac$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}

});

parcelRegister("6F8iQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9d0333ba430acb$export$2e2bcd8739ae039);
function $4d9d0333ba430acb$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("f7QgY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0300eb8aafe18da$export$2e2bcd8739ae039);
function $b0300eb8aafe18da$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("583Xd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc0c44b612a6f9f$export$2e2bcd8739ae039);
function $3bc0c44b612a6f9f$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("j9SDI", function(module, exports) {

$parcel$export(module.exports, "default", () => $df293dddd08596e8$export$2e2bcd8739ae039);
function $df293dddd08596e8$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}

});


parcelRegister("6SK5Z", function(module, exports) {

var $7NMrF = parcelRequire("7NMrF");

var $lm88n = parcelRequire("lm88n");

var $MAw0s = parcelRequire("MAw0s");
function $502b8adb6cb4a4dc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $lm88n.default)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $MAw0s.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $7NMrF.default)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRegister("7NMrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae2b03c299fbe65$export$2e2bcd8739ae039);
function $5ae2b03c299fbe65$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}

});

parcelRegister("lm88n", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8c1f65604c48eed$export$2e2bcd8739ae039);
function $f8c1f65604c48eed$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        'backface-visibility': 'hidden',
        '-webkit-backface-visibility': 'hidden'
    });
    return $slideEl;
}

});

parcelRegister("MAw0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $0920cef94b5a2000$export$2e2bcd8739ae039);
function $0920cef94b5a2000$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                'webkitTransitionEnd',
                'transitionend'
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}

});


parcelRegister("4ORyx", function(module, exports) {

var $diCnN = parcelRequire("diCnN");

var $7NMrF = parcelRequire("7NMrF");
function $3825600eca4a6a65$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $diCnN.default)(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $diCnN.default)(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $diCnN.default)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $diCnN.default)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $diCnN.default)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
            'transform-origin': `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find('.swiper-cube-shadow').transition(duration);
    };
    (0, $7NMrF.default)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}

});

parcelRegister("4lZfa", function(module, exports) {

var $diCnN = parcelRequire("diCnN");

var $h5Soo = parcelRequire("h5Soo");

var $7NMrF = parcelRequire("7NMrF");

var $lm88n = parcelRequire("lm88n");

var $MAw0s = parcelRequire("MAw0s");
function $32b8a14866ddc825$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) shadowBefore = (0, $h5Soo.default)(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (shadowAfter.length === 0) shadowAfter = (0, $h5Soo.default)(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $diCnN.default)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $lm88n.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        (0, $MAw0s.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $7NMrF.default)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRegister("h5Soo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c71d1880b27f3920$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");
function $c71d1880b27f3920$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $diCnN.default)(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}

});


parcelRegister("4abV7", function(module, exports) {

var $h5Soo = parcelRequire("h5Soo");

var $7NMrF = parcelRequire("7NMrF");

var $lm88n = parcelRequire("lm88n");
function $308157bca6d3ac93$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $lm88n.default)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $h5Soo.default)(params, $slideEl, isHorizontal ? 'left' : 'top');
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $h5Soo.default)(params, $slideEl, isHorizontal ? 'right' : 'bottom');
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    };
    (0, $7NMrF.default)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}

});

parcelRegister("cNzyd", function(module, exports) {

var $h5Soo = parcelRequire("h5Soo");

var $7NMrF = parcelRequire("7NMrF");

var $lm88n = parcelRequire("lm88n");

var $MAw0s = parcelRequire("MAw0s");
function $9515a35076d2b369$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children('.swiper-slide-shadow');
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $h5Soo.default)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $lm88n.default)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css('transform-origin', data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $MAw0s.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $7NMrF.default)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});

parcelRegister("gdzc7", function(module, exports) {

var $h5Soo = parcelRequire("h5Soo");

var $7NMrF = parcelRequire("7NMrF");

var $lm88n = parcelRequire("lm88n");

var $MAw0s = parcelRequire("MAw0s");
function $bce9292623373c10$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find('.swiper-slide-shadow');
                if ($shadowEl.length === 0) $shadowEl = (0, $h5Soo.default)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $lm88n.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $MAw0s.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $7NMrF.default)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});



parcelRegister("bPIqH", function(module, exports) {
"use strict";
var $89d6ebee591fa135$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $89d6ebee591fa135$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Table = module.exports.TableRow = module.exports.TableCell = module.exports.StylableContainer = module.exports.TableColumnDefinition = void 0;

var $6XfIC = parcelRequire("6XfIC");

var $gIXBn = parcelRequire("gIXBn");

var $2Zn2I = parcelRequire("2Zn2I");

var $5Ougt = parcelRequire("5Ougt");

var $6BHj7 = parcelRequire("6BHj7");

var $24F6S = parcelRequire("24F6S");

var $F6YrP = parcelRequire("F6YrP");
var $89d6ebee591fa135$var$TableColumnDefinition = /** @class */ function(_super) {
    $89d6ebee591fa135$var$__extends(TableColumnDefinition, _super);
    function TableColumnDefinition() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.width = new $6BHj7.SizeAndUnit(1, $gIXBn.SizeUnit.Weight);
        return _this;
    }
    TableColumnDefinition.prototype.getSchemaKey = function() {
        return "ColumnDefinition";
    };
    TableColumnDefinition.horizontalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "horizontalCellContentAlignment", $gIXBn.HorizontalAlignment);
    TableColumnDefinition.verticalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "verticalCellContentAlignment", $gIXBn.VerticalAlignment);
    TableColumnDefinition.widthProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_5, "width", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidWidth = false;
        if (typeof value === "number" && !isNaN(value)) result = new $6BHj7.SizeAndUnit(value, $gIXBn.SizeUnit.Weight);
        else if (typeof value === "string") try {
            result = $6BHj7.SizeAndUnit.parse(value);
        } catch (e) {
            invalidWidth = true;
        }
        else invalidWidth = true;
        if (invalidWidth) context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidColumnWidth(value));
        return result;
    }, function(sender, property, target, value, context) {
        if (value.unit === $gIXBn.SizeUnit.Pixel) context.serializeValue(target, "width", value.physicalSize + "px");
        else context.serializeNumber(target, "width", value.physicalSize);
    }, new $6BHj7.SizeAndUnit(1, $gIXBn.SizeUnit.Weight));
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(TableColumnDefinition.horizontalCellContentAlignmentProperty)
    ], TableColumnDefinition.prototype, "horizontalCellContentAlignment", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(TableColumnDefinition.verticalCellContentAlignmentProperty)
    ], TableColumnDefinition.prototype, "verticalCellContentAlignment", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(TableColumnDefinition.widthProperty)
    ], TableColumnDefinition.prototype, "width", void 0);
    return TableColumnDefinition;
}($5Ougt.SerializableObject);
module.exports.TableColumnDefinition = $89d6ebee591fa135$var$TableColumnDefinition;
var $89d6ebee591fa135$var$StylableContainer = /** @class */ function(_super) {
    $89d6ebee591fa135$var$__extends(StylableContainer, _super);
    function StylableContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._items = [];
        return _this;
    }
    StylableContainer.prototype.parseItem = function(source, context) {
        var _this = this;
        return context.parseCardObject(this, source, [], !this.isDesignMode(), function(typeName) {
            return _this.createItemInstance(typeName);
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $gIXBn.ValidationEvent.ElementTypeNotAllowed, $24F6S.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    StylableContainer.prototype.internalAddItem = function(item) {
        if (!item.parent) {
            this._items.push(item);
            item.setParent(this);
        } else throw new Error($24F6S.Strings.errors.elementAlreadyParented());
    };
    StylableContainer.prototype.internalRemoveItem = function(item) {
        var itemIndex = this._items.indexOf(item);
        if (itemIndex >= 0) {
            this._items.splice(itemIndex, 1);
            item.setParent(undefined);
            this.updateLayout();
            return true;
        }
        return false;
    };
    StylableContainer.prototype.internalIndexOf = function(item) {
        return this._items.indexOf(item);
    };
    StylableContainer.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._items = [];
        var items = source[this.getCollectionPropertyName()];
        if (Array.isArray(items)) for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            var instance = this.parseItem(item, context);
            if (instance) this._items.push(instance);
        }
    };
    StylableContainer.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, this.getCollectionPropertyName(), this._items);
    };
    StylableContainer.prototype.removeItem = function(item) {
        return this.internalRemoveItem(item);
    };
    StylableContainer.prototype.getItemCount = function() {
        return this._items.length;
    };
    StylableContainer.prototype.getItemAt = function(index) {
        return this._items[index];
    };
    StylableContainer.prototype.getFirstVisibleRenderedItem = function() {
        return this.getItemCount() > 0 ? this.getItemAt(0) : undefined;
    };
    StylableContainer.prototype.getLastVisibleRenderedItem = function() {
        return this.getItemCount() > 0 ? this.getItemAt(this.getItemCount() - 1) : undefined;
    };
    return StylableContainer;
}($6XfIC.StylableCardElementContainer);
module.exports.StylableContainer = $89d6ebee591fa135$var$StylableContainer;
var $89d6ebee591fa135$var$TableCell = /** @class */ function(_super) {
    $89d6ebee591fa135$var$__extends(TableCell, _super);
    function TableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columnIndex = -1;
        _this._cellType = "data";
        return _this;
    }
    TableCell.prototype.getHasBorder = function() {
        return this.parentRow.parentTable.showGridLines;
    };
    TableCell.prototype.applyBorder = function() {
        if (this.renderedElement && this.getHasBorder()) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.parentRow.parentTable.gridStyle);
            if (styleDefinition.borderColor) {
                var borderColor = (0, $F6YrP.stringToCssColor)(styleDefinition.borderColor);
                if (borderColor) {
                    this.renderedElement.style.borderRight = "1px solid " + borderColor;
                    this.renderedElement.style.borderBottom = "1px solid " + borderColor;
                }
            }
        }
    };
    TableCell.prototype.getDefaultPadding = function() {
        return this.getHasBackground() || this.getHasBorder() ? new $6BHj7.PaddingDefinition($gIXBn.Spacing.Small, $gIXBn.Spacing.Small, $gIXBn.Spacing.Small, $gIXBn.Spacing.Small) : _super.prototype.getDefaultPadding.call(this);
    };
    TableCell.prototype.internalRender = function() {
        var cellElement = _super.prototype.internalRender.call(this);
        if (cellElement) {
            cellElement.setAttribute("role", this.cellType === "data" ? "cell" : "columnheader");
            cellElement.style.minWidth = "0";
            if (this.cellType === "header") cellElement.setAttribute("scope", "col");
        }
        return cellElement;
    };
    TableCell.prototype.shouldSerialize = function(_context) {
        return true;
    };
    TableCell.prototype.getJsonTypeName = function() {
        return "TableCell";
    };
    TableCell.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.cellType === "header") return this.hostConfig.textStyles.columnHeader;
        return _super.prototype.getEffectiveTextStyleDefinition.call(this);
    };
    TableCell.prototype.getEffectiveHorizontalAlignment = function() {
        if (this.horizontalAlignment !== undefined) return this.horizontalAlignment;
        if (this.parentRow.horizontalCellContentAlignment !== undefined) return this.parentRow.horizontalCellContentAlignment;
        if (this.columnIndex >= 0) {
            var horizontalAlignment = this.parentRow.parentTable.getColumnAt(this.columnIndex).horizontalCellContentAlignment;
            if (horizontalAlignment !== undefined) return horizontalAlignment;
        }
        if (this.parentRow.parentTable.horizontalCellContentAlignment !== undefined) return this.parentRow.parentTable.horizontalCellContentAlignment;
        return _super.prototype.getEffectiveHorizontalAlignment.call(this);
    };
    TableCell.prototype.getEffectiveVerticalContentAlignment = function() {
        if (this.verticalContentAlignment !== undefined) return this.verticalContentAlignment;
        if (this.parentRow.verticalCellContentAlignment !== undefined) return this.parentRow.verticalCellContentAlignment;
        if (this.columnIndex >= 0) {
            var verticalAlignment = this.parentRow.parentTable.getColumnAt(this.columnIndex).verticalCellContentAlignment;
            if (verticalAlignment !== undefined) return verticalAlignment;
        }
        if (this.parentRow.parentTable.verticalCellContentAlignment !== undefined) return this.parentRow.parentTable.verticalCellContentAlignment;
        return _super.prototype.getEffectiveVerticalContentAlignment.call(this);
    };
    Object.defineProperty(TableCell.prototype, "columnIndex", {
        get: function() {
            return this._columnIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "cellType", {
        get: function() {
            return this._cellType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "parentRow", {
        get: function() {
            return this.parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return TableCell;
}($6XfIC.Container);
module.exports.TableCell = $89d6ebee591fa135$var$TableCell;
var $89d6ebee591fa135$var$TableRow = /** @class */ function(_super) {
    $89d6ebee591fa135$var$__extends(TableRow, _super);
    function TableRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    TableRow.prototype.getDefaultPadding = function() {
        return new $6BHj7.PaddingDefinition($gIXBn.Spacing.None, $gIXBn.Spacing.None, $gIXBn.Spacing.None, $gIXBn.Spacing.None);
    };
    TableRow.prototype.applyBackground = function() {
        if (this.renderedElement) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
            if (styleDefinition.backgroundColor) {
                var bgColor = (0, $F6YrP.stringToCssColor)(styleDefinition.backgroundColor);
                if (bgColor) this.renderedElement.style.backgroundColor = bgColor;
            }
        }
    };
    TableRow.prototype.getCollectionPropertyName = function() {
        return "cells";
    };
    TableRow.prototype.createItemInstance = function(typeName) {
        return !typeName || typeName === "TableCell" ? new $89d6ebee591fa135$var$TableCell() : undefined;
    };
    TableRow.prototype.internalRender = function() {
        var isFirstRow = this.getIsFirstRow();
        var cellSpacing = this.hostConfig.table.cellSpacing;
        var rowElement = document.createElement("div");
        rowElement.setAttribute("role", "row");
        rowElement.style.display = "flex";
        rowElement.style.flexDirection = "row";
        for(var i = 0; i < Math.min(this.getItemCount(), this.parentTable.getColumnCount()); i++){
            var cell = this.getItemAt(i);
            // Cheating a bit in order to keep cellType read-only
            cell["_columnIndex"] = i;
            cell["_cellType"] = this.parentTable.firstRowAsHeaders && isFirstRow ? "header" : "data";
            var renderedCell = cell.render();
            if (renderedCell) {
                var column = this.parentTable.getColumnAt(i);
                if (column.computedWidth.unit === $gIXBn.SizeUnit.Pixel) renderedCell.style.flex = "0 0 " + column.computedWidth.physicalSize + "px";
                else renderedCell.style.flex = "1 1 " + column.computedWidth.physicalSize + "%";
                if (i > 0 && !this.parentTable.showGridLines && cellSpacing > 0) renderedCell.style.marginLeft = cellSpacing + "px";
                rowElement.appendChild(renderedCell);
            }
        }
        return rowElement.children.length > 0 ? rowElement : undefined;
    };
    TableRow.prototype.shouldSerialize = function(_context) {
        return true;
    };
    TableRow.prototype.addCell = function(cell) {
        this.internalAddItem(cell);
    };
    TableRow.prototype.removeCellAt = function(columnIndex) {
        if (columnIndex >= 0 && columnIndex < this.getItemCount()) return this.removeItem(this.getItemAt(columnIndex));
        return false;
    };
    TableRow.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $89d6ebee591fa135$var$TableCell ? this.internalIndexOf(cardElement) : -1;
    };
    TableRow.prototype.ensureHasEnoughCells = function(cellCount) {
        while(this.getItemCount() < cellCount)this.addCell(new $89d6ebee591fa135$var$TableCell());
    };
    TableRow.prototype.getJsonTypeName = function() {
        return "TableRow";
    };
    TableRow.prototype.getIsFirstRow = function() {
        return this.parentTable.getItemAt(0) === this;
    };
    Object.defineProperty(TableRow.prototype, "parentTable", {
        get: function() {
            return this.parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableRow.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    TableRow.styleProperty = new $6XfIC.ContainerStyleProperty($5Ougt.Versions.v1_5, "style");
    TableRow.horizontalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "horizontalCellContentAlignment", $gIXBn.HorizontalAlignment);
    TableRow.verticalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "verticalCellContentAlignment", $gIXBn.VerticalAlignment);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(TableRow.horizontalCellContentAlignmentProperty)
    ], TableRow.prototype, "horizontalCellContentAlignment", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(TableRow.verticalCellContentAlignmentProperty)
    ], TableRow.prototype, "verticalCellContentAlignment", void 0);
    return TableRow;
}($89d6ebee591fa135$var$StylableContainer);
module.exports.TableRow = $89d6ebee591fa135$var$TableRow;
var $89d6ebee591fa135$var$Table = /** @class */ function(_super) {
    $89d6ebee591fa135$var$__extends(Table, _super);
    function Table() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = [];
        _this.firstRowAsHeaders = true;
        _this.showGridLines = true;
        return _this;
    }
    Object.defineProperty(Table.prototype, "gridStyle", {
        get: function() {
            var style = this.getValue(Table.gridStyleProperty);
            if (style && this.hostConfig.containerStyles.getStyleByName(style)) return style;
            return undefined;
        },
        set: function(value) {
            this.setValue(Table.gridStyleProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    Table.prototype.ensureRowsHaveEnoughCells = function() {
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).ensureHasEnoughCells(this.getColumnCount());
    };
    Table.prototype.removeCellsFromColumn = function(columnIndex) {
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).removeCellAt(columnIndex);
    };
    Table.prototype.getCollectionPropertyName = function() {
        return "rows";
    };
    Table.prototype.createItemInstance = function(typeName) {
        return !typeName || typeName === "TableRow" ? new $89d6ebee591fa135$var$TableRow() : undefined;
    };
    Table.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.ensureRowsHaveEnoughCells();
    };
    Table.prototype.internalRender = function() {
        if (this.getItemCount() > 0) {
            var totalWeights = 0;
            for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
                var column = _a[_i];
                if (column.width.unit === $gIXBn.SizeUnit.Weight) totalWeights += column.width.physicalSize;
            }
            for(var _b = 0, _c = this._columns; _b < _c.length; _b++){
                var column = _c[_b];
                if (column.width.unit === $gIXBn.SizeUnit.Pixel) column.computedWidth = new $6BHj7.SizeAndUnit(column.width.physicalSize, $gIXBn.SizeUnit.Pixel);
                else column.computedWidth = new $6BHj7.SizeAndUnit(100 / totalWeights * column.width.physicalSize, $gIXBn.SizeUnit.Weight);
            }
            var tableElement = document.createElement("div");
            tableElement.setAttribute("role", "table");
            tableElement.style.display = "flex";
            tableElement.style.flexDirection = "column";
            if (this.showGridLines) {
                var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.gridStyle);
                if (styleDefinition.borderColor) {
                    var borderColor = (0, $F6YrP.stringToCssColor)(styleDefinition.borderColor);
                    if (borderColor) {
                        tableElement.style.borderTop = "1px solid " + borderColor;
                        tableElement.style.borderLeft = "1px solid " + borderColor;
                    }
                }
            }
            var cellSpacing = this.hostConfig.table.cellSpacing;
            for(var i = 0; i < this.getItemCount(); i++){
                var renderedRow = this.getItemAt(i).render();
                if (renderedRow) {
                    if (i > 0 && !this.showGridLines && cellSpacing > 0) {
                        var separatorRow = document.createElement("div");
                        separatorRow.setAttribute("aria-hidden", "true");
                        separatorRow.style.height = cellSpacing + "px";
                        tableElement.appendChild(separatorRow);
                    }
                    tableElement.appendChild(renderedRow);
                }
            }
            return tableElement;
        }
        return undefined;
    };
    Table.prototype.addColumn = function(column) {
        this._columns.push(column);
        this.ensureRowsHaveEnoughCells();
    };
    Table.prototype.removeColumn = function(column) {
        var index = this._columns.indexOf(column);
        if (index >= 0) {
            this.removeCellsFromColumn(index);
            this._columns.splice(index, 1);
        }
    };
    Table.prototype.getColumnCount = function() {
        return this._columns.length;
    };
    Table.prototype.getColumnAt = function(index) {
        return this._columns[index];
    };
    Table.prototype.addRow = function(row) {
        this.internalAddItem(row);
        row.ensureHasEnoughCells(this.getColumnCount());
    };
    Table.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $89d6ebee591fa135$var$TableRow ? this.internalIndexOf(cardElement) : -1;
    };
    Table.prototype.getJsonTypeName = function() {
        return "Table";
    };
    Table._columnsProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_5, "columns", $89d6ebee591fa135$var$TableColumnDefinition);
    Table.firstRowAsHeadersProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_5, "firstRowAsHeaders", true);
    Table.showGridLinesProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_5, "showGridLines", true);
    Table.gridStyleProperty = new $6XfIC.ContainerStyleProperty($5Ougt.Versions.v1_5, "gridStyle");
    Table.horizontalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "horizontalCellContentAlignment", $gIXBn.HorizontalAlignment);
    Table.verticalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "verticalCellContentAlignment", $gIXBn.VerticalAlignment);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table._columnsProperty)
    ], Table.prototype, "_columns", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table.firstRowAsHeadersProperty)
    ], Table.prototype, "firstRowAsHeaders", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table.showGridLinesProperty)
    ], Table.prototype, "showGridLines", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table.gridStyleProperty)
    ], Table.prototype, "gridStyle", null);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table.horizontalCellContentAlignmentProperty)
    ], Table.prototype, "horizontalCellContentAlignment", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table.verticalCellContentAlignmentProperty)
    ], Table.prototype, "verticalCellContentAlignment", void 0);
    return Table;
}($89d6ebee591fa135$var$StylableContainer);
module.exports.Table = $89d6ebee591fa135$var$Table;
$2Zn2I.GlobalRegistry.defaultElements.register("Table", $89d6ebee591fa135$var$Table, $5Ougt.Versions.v1_5);

});

parcelRegister("krFBf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChannelAdapter = void 0;
var $ee2699185d93bab8$var$ChannelAdapter = /** @class */ function() {
    function ChannelAdapter() {}
    return ChannelAdapter;
}();
module.exports.ChannelAdapter = $ee2699185d93bab8$var$ChannelAdapter;

});

parcelRegister("kBxrI", function(module, exports) {
"use strict";
var $f001350ddb668616$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoginRequestResponse = module.exports.ErrorResponse = module.exports.SuccessResponse = module.exports.ActivityResponse = module.exports.ActivityRequestError = module.exports.ActivityRequestTrigger = void 0;
var $f001350ddb668616$var$ActivityRequestTrigger;
(function(ActivityRequestTrigger) {
    ActivityRequestTrigger["Automatic"] = "automatic";
    ActivityRequestTrigger["Manual"] = "manual";
})($f001350ddb668616$var$ActivityRequestTrigger = module.exports.ActivityRequestTrigger || (module.exports.ActivityRequestTrigger = {}));
var $f001350ddb668616$var$ActivityRequestError = /** @class */ function() {
    function ActivityRequestError(code, message) {
        this.code = code;
        this.message = message;
    }
    return ActivityRequestError;
}();
module.exports.ActivityRequestError = $f001350ddb668616$var$ActivityRequestError;
var $f001350ddb668616$var$ActivityResponse = /** @class */ function() {
    function ActivityResponse(request) {
        this.request = request;
    }
    return ActivityResponse;
}();
module.exports.ActivityResponse = $f001350ddb668616$var$ActivityResponse;
var $f001350ddb668616$var$SuccessResponse = /** @class */ function(_super) {
    $f001350ddb668616$var$__extends(SuccessResponse, _super);
    function SuccessResponse(request, rawContent) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this.rawContent = rawContent;
        return _this;
    }
    return SuccessResponse;
}($f001350ddb668616$var$ActivityResponse);
module.exports.SuccessResponse = $f001350ddb668616$var$SuccessResponse;
var $f001350ddb668616$var$ErrorResponse = /** @class */ function(_super) {
    $f001350ddb668616$var$__extends(ErrorResponse, _super);
    function ErrorResponse(request, error) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this.error = error;
        return _this;
    }
    return ErrorResponse;
}($f001350ddb668616$var$ActivityResponse);
module.exports.ErrorResponse = $f001350ddb668616$var$ErrorResponse;
var $f001350ddb668616$var$LoginRequestResponse = /** @class */ function(_super) {
    $f001350ddb668616$var$__extends(LoginRequestResponse, _super);
    function LoginRequestResponse(request, auth) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this._auth = auth;
        for(var _i = 0, _a = _this._auth.buttons; _i < _a.length; _i++){
            var button = _a[_i];
            if (button.type === "signin" && button.value !== undefined) try {
                new URL(button.value);
                _this.signinButton = button;
                break;
            } catch (e) {
            // Ignore parsing error
            }
        }
        return _this;
    }
    Object.defineProperty(LoginRequestResponse.prototype, "tokenExchangeResource", {
        get: function() {
            return this._auth.tokenExchangeResource;
        },
        enumerable: false,
        configurable: true
    });
    return LoginRequestResponse;
}($f001350ddb668616$var$ActivityResponse);
module.exports.LoginRequestResponse = $f001350ddb668616$var$LoginRequestResponse;

});

parcelRegister("5PICj", function(module, exports) {
"use strict";
var $43f4532456519116$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $43f4532456519116$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdaptiveApplet = void 0;

var $gIXBn = parcelRequire("gIXBn");

var $F6YrP = parcelRequire("F6YrP");

var $6BHj7 = parcelRequire("6BHj7");

var $kBxrI = parcelRequire("kBxrI");

var $24F6S = parcelRequire("24F6S");

var $6XfIC = parcelRequire("6XfIC");

var $5Ougt = parcelRequire("5Ougt");
function $43f4532456519116$var$logEvent(level, message) {
    var optionalParams = [];
    for(var _i = 2; _i < arguments.length; _i++)optionalParams[_i - 2] = arguments[_i];
    if ($6BHj7.GlobalSettings.applets.logEnabled) {
        if ($6BHj7.GlobalSettings.applets.onLogEvent) $6BHj7.GlobalSettings.applets.onLogEvent(level, message, optionalParams);
        else /* eslint-disable no-console */ switch(level){
            case $gIXBn.LogLevel.Warning:
                console.warn(message, optionalParams);
                break;
            case $gIXBn.LogLevel.Error:
                console.error(message, optionalParams);
                break;
            default:
                console.log(message, optionalParams);
                break;
        }
    }
}
var $43f4532456519116$var$ActivityRequest = /** @class */ function() {
    function ActivityRequest(action, trigger, consecutiveActions) {
        this.action = action;
        this.trigger = trigger;
        this.consecutiveActions = consecutiveActions;
        this.attemptNumber = 0;
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    ActivityRequest.prototype.retryAsync = function() {
        return $43f4532456519116$var$__awaiter(this, void 0, void 0, function() {
            return $43f4532456519116$var$__generator(this, function(_a) {
                if (this.onSend) this.onSend(this);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return ActivityRequest;
}();
var $43f4532456519116$var$AdaptiveApplet = /** @class */ function() {
    function AdaptiveApplet() {
        this._allowAutomaticCardUpdate = false;
        this.renderedElement = document.createElement("div");
        this.renderedElement.className = "aaf-cardHost";
        this.renderedElement.style.position = "relative";
        this.renderedElement.style.display = "flex";
        this.renderedElement.style.flexDirection = "column";
        this._cardHostElement = document.createElement("div");
        this._refreshButtonHostElement = document.createElement("div");
        this._refreshButtonHostElement.className = "aaf-refreshButtonHost";
        this._refreshButtonHostElement.style.display = "none";
        this.renderedElement.appendChild(this._cardHostElement);
        this.renderedElement.appendChild(this._refreshButtonHostElement);
    }
    AdaptiveApplet.prototype.displayCard = function(card) {
        if (card.renderedElement) {
            $F6YrP.clearElementChildren(this._cardHostElement);
            this._refreshButtonHostElement.style.display = "none";
            this._cardHostElement.appendChild(card.renderedElement);
        } else throw new Error("displayCard: undefined card.");
    };
    AdaptiveApplet.prototype.showManualRefreshButton = function(refreshAction) {
        var _this = this;
        var displayBuiltInManualRefreshButton = this.onShowManualRefreshButton ? this.onShowManualRefreshButton(this) : true;
        if (displayBuiltInManualRefreshButton) {
            this._refreshButtonHostElement.style.display = "none";
            var renderedRefreshButton = undefined;
            if (this.onRenderManualRefreshButton) renderedRefreshButton = this.onRenderManualRefreshButton(this);
            else {
                var message = $24F6S.Strings.runtime.refreshThisCard();
                if ($6BHj7.GlobalSettings.applets.refresh.mode === $gIXBn.RefreshMode.Automatic) {
                    var autoRefreshPausedMessage = $24F6S.Strings.runtime.automaticRefreshPaused();
                    if (autoRefreshPausedMessage[autoRefreshPausedMessage.length - 1] !== " ") autoRefreshPausedMessage += " ";
                    message = $24F6S.Strings.runtime.clckToRestartAutomaticRefresh();
                }
                var cardPayload = {
                    type: "AdaptiveCard",
                    version: "1.2",
                    body: [
                        {
                            type: "RichTextBlock",
                            horizontalAlignment: "right",
                            inlines: [
                                {
                                    type: "TextRun",
                                    text: message,
                                    selectAction: {
                                        type: "Action.Submit",
                                        id: "refreshCard"
                                    }
                                }
                            ]
                        }
                    ]
                };
                var card = new $6XfIC.AdaptiveCard();
                card.parse(cardPayload, new $6XfIC.SerializationContext($5Ougt.Versions.v1_2));
                card.onExecuteAction = function(action) {
                    if (action.id === "refreshCard") {
                        $F6YrP.clearElementChildren(_this._refreshButtonHostElement);
                        _this.internalExecuteAction(refreshAction, $kBxrI.ActivityRequestTrigger.Automatic, 0);
                    }
                };
                renderedRefreshButton = card.render();
            }
            if (renderedRefreshButton) {
                $F6YrP.clearElementChildren(this._refreshButtonHostElement);
                this._refreshButtonHostElement.appendChild(renderedRefreshButton);
                this._refreshButtonHostElement.style.removeProperty("display");
            }
        }
    };
    AdaptiveApplet.prototype.createActivityRequest = function(action, trigger, consecutiveActions) {
        var _this = this;
        if (this.card) {
            var request_1 = new $43f4532456519116$var$ActivityRequest(action, trigger, consecutiveActions);
            request_1.onSend = function(sender) {
                sender.attemptNumber++;
                _this.internalSendActivityRequestAsync(request_1);
            };
            var cancel = this.onPrepareActivityRequest ? !this.onPrepareActivityRequest(this, request_1, action) : false;
            return cancel ? undefined : request_1;
        } else throw new Error("createActivityRequest: no card has been set.");
    };
    AdaptiveApplet.prototype.createMagicCodeInputCard = function(attemptNumber) {
        var payload = {
            type: "AdaptiveCard",
            version: "1.0",
            body: [
                {
                    type: "TextBlock",
                    color: "attention",
                    text: attemptNumber === 1 ? undefined : "That didn't work... let's try again.",
                    wrap: true,
                    horizontalAlignment: "center"
                },
                {
                    type: "TextBlock",
                    text: 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"',
                    wrap: true,
                    horizontalAlignment: "center"
                },
                {
                    type: "Input.Text",
                    id: "magicCode",
                    placeholder: "Enter magic code"
                },
                {
                    type: "ActionSet",
                    horizontalAlignment: "center",
                    actions: [
                        {
                            type: "Action.Submit",
                            id: AdaptiveApplet._submitMagicCodeActionId,
                            title: "Submit"
                        },
                        {
                            type: "Action.Submit",
                            id: AdaptiveApplet._cancelMagicCodeAuthActionId,
                            title: "Cancel"
                        }
                    ]
                }
            ]
        };
        var card = new $6XfIC.AdaptiveCard();
        card.parse(payload);
        return card;
    };
    AdaptiveApplet.prototype.cancelAutomaticRefresh = function() {
        if (this._allowAutomaticCardUpdate) $43f4532456519116$var$logEvent($gIXBn.LogLevel.Warning, "Automatic card refresh has been cancelled as a result of the user interacting with the card.");
        this._allowAutomaticCardUpdate = false;
    };
    AdaptiveApplet.prototype.createSerializationContext = function() {
        return this.onCreateSerializationContext ? this.onCreateSerializationContext(this) : new $6XfIC.SerializationContext();
    };
    AdaptiveApplet.prototype.internalSetCard = function(payload, consecutiveActions) {
        var _this = this;
        if (typeof payload === "object" && payload["type"] === "AdaptiveCard") this._cardPayload = payload;
        if (this._cardPayload) try {
            var card = new $6XfIC.AdaptiveCard();
            if (this.hostConfig) card.hostConfig = this.hostConfig;
            var serializationContext = this.createSerializationContext();
            card.parse(this._cardPayload, serializationContext);
            var doChangeCard = this.onCardChanging ? this.onCardChanging(this, this._cardPayload) : true;
            if (doChangeCard) {
                this._card = card;
                if (this._card.authentication && this._card.authentication.tokenExchangeResource && this.onPrefetchSSOToken) this.onPrefetchSSOToken(this, this._card.authentication.tokenExchangeResource);
                this._card.onExecuteAction = function(action) {
                    // If the user takes an action, cancel any pending automatic refresh
                    _this.cancelAutomaticRefresh();
                    _this.internalExecuteAction(action, $kBxrI.ActivityRequestTrigger.Manual, 0);
                };
                this._card.onInputValueChanged = function(input) {
                    var _a, _b, _c;
                    // If the user modifies an input, cancel any pending automatic refresh
                    _this.cancelAutomaticRefresh();
                    if (input instanceof $6XfIC.ChoiceSetInput && input.isDynamicTypeahead()) {
                        var filter = input.getFilterForDynamicSearch();
                        if (filter) {
                            var dataQueryAction = new $6XfIC.DataQuery();
                            dataQueryAction.filter = filter;
                            dataQueryAction.dataset = ((_a = input.choicesData) === null || _a === void 0 ? void 0 : _a.dataset) || "";
                            dataQueryAction.count = (_b = input.choicesData) === null || _b === void 0 ? void 0 : _b.count;
                            dataQueryAction.skip = (_c = input.choicesData) === null || _c === void 0 ? void 0 : _c.skip;
                            _this._choiceSet = input;
                            _this.internalExecuteAction(dataQueryAction, $kBxrI.ActivityRequestTrigger.Manual, 0 // consecutiveActions
                            );
                        }
                    }
                };
                this._card.render();
                if (this._card.renderedElement) {
                    this.displayCard(this._card);
                    if (this.onCardChanged) this.onCardChanged(this);
                    if (this._card.refresh) {
                        if ($6BHj7.GlobalSettings.applets.refresh.mode === $gIXBn.RefreshMode.Automatic && consecutiveActions < $6BHj7.GlobalSettings.applets.refresh.maximumConsecutiveAutomaticRefreshes) {
                            if ($6BHj7.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes <= 0) {
                                $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Triggering automatic card refresh number " + (consecutiveActions + 1));
                                this.internalExecuteAction(this._card.refresh.action, $kBxrI.ActivityRequestTrigger.Automatic, consecutiveActions + 1);
                            } else {
                                $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Scheduling automatic card refresh number " + (consecutiveActions + 1) + " in " + $6BHj7.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes + "ms");
                                var action_1 = this._card.refresh.action;
                                this._allowAutomaticCardUpdate = true;
                                window.setTimeout(function() {
                                    if (_this._allowAutomaticCardUpdate) _this.internalExecuteAction(action_1, $kBxrI.ActivityRequestTrigger.Automatic, consecutiveActions + 1);
                                }, $6BHj7.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes);
                            }
                        } else if ($6BHj7.GlobalSettings.applets.refresh.mode !== $gIXBn.RefreshMode.Disabled) {
                            if (consecutiveActions > 0) $43f4532456519116$var$logEvent($gIXBn.LogLevel.Warning, "Stopping automatic refreshes after " + consecutiveActions + " consecutive refreshes.");
                            else $43f4532456519116$var$logEvent($gIXBn.LogLevel.Warning, "The card has a refresh section, but automatic refreshes are disabled.");
                            if ($6BHj7.GlobalSettings.applets.refresh.allowManualRefreshesAfterAutomaticRefreshes || $6BHj7.GlobalSettings.applets.refresh.mode === $gIXBn.RefreshMode.Manual) {
                                $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Showing manual refresh button.");
                                this.showManualRefreshButton(this._card.refresh.action);
                            }
                        }
                    }
                }
            }
        } catch (error) {
            // Ignore all errors
            $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "setCard: " + error);
        }
    };
    AdaptiveApplet.prototype.internalExecuteAction = function(action, trigger, consecutiveActions) {
        if (action instanceof $6XfIC.UniversalAction) {
            if (this.channelAdapter) {
                var request = this.createActivityRequest(action, trigger, consecutiveActions);
                if (request) request.retryAsync();
            } else throw new Error("internalExecuteAction: No channel adapter set.");
        }
        if (this.onAction) this.onAction(this, action);
    };
    AdaptiveApplet.prototype.createProgressOverlay = function(request) {
        if (!this._progressOverlay) {
            if (this.onCreateProgressOverlay) this._progressOverlay = this.onCreateProgressOverlay(this, request);
            else {
                this._progressOverlay = document.createElement("div");
                this._progressOverlay.className = "aaf-progress-overlay";
                var spinner = document.createElement("div");
                spinner.className = "aaf-spinner";
                spinner.style.width = "28px";
                spinner.style.height = "28px";
                this._progressOverlay.appendChild(spinner);
            }
        }
        return this._progressOverlay;
    };
    AdaptiveApplet.prototype.removeProgressOverlay = function(request) {
        if (this.onRemoveProgressOverlay) this.onRemoveProgressOverlay(this, request);
        if (this._progressOverlay !== undefined) {
            this.renderedElement.removeChild(this._progressOverlay);
            this._progressOverlay = undefined;
        }
    };
    AdaptiveApplet.prototype.activityRequestSucceeded = function(response, parsedContent) {
        if (this.onActivityRequestSucceeded) this.onActivityRequestSucceeded(this, response, parsedContent);
    };
    AdaptiveApplet.prototype.activityRequestFailed = function(response) {
        return this.onActivityRequestFailed ? this.onActivityRequestFailed(this, response) : $6BHj7.GlobalSettings.applets.defaultTimeBetweenRetryAttempts;
    };
    AdaptiveApplet.prototype.showAuthCodeInputDialog = function(request) {
        var _this = this;
        var showBuiltInAuthCodeInputCard = this.onShowAuthCodeInputDialog ? this.onShowAuthCodeInputDialog(this, request) : true;
        if (showBuiltInAuthCodeInputCard) {
            var authCodeInputCard = this.createMagicCodeInputCard(request.attemptNumber);
            authCodeInputCard.render();
            authCodeInputCard.onExecuteAction = function(submitMagicCodeAction) {
                if (_this.card && submitMagicCodeAction instanceof $6XfIC.SubmitAction) switch(submitMagicCodeAction.id){
                    case AdaptiveApplet._submitMagicCodeActionId:
                        var authCode = undefined;
                        if (submitMagicCodeAction.data && typeof submitMagicCodeAction.data["magicCode"] === "string") authCode = submitMagicCodeAction.data["magicCode"];
                        if (authCode) {
                            _this.displayCard(_this.card);
                            request.authCode = authCode;
                            request.retryAsync();
                        } else alert("Please enter the magic code you received.");
                        break;
                    case AdaptiveApplet._cancelMagicCodeAuthActionId:
                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Warning, "Authentication cancelled by user.");
                        _this.displayCard(_this.card);
                        break;
                    default:
                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Unexpected action taken from magic code input card (id = " + submitMagicCodeAction.id + ")");
                        alert($24F6S.Strings.magicCodeInputCard.somethingWentWrong());
                        break;
                }
            };
            this.displayCard(authCodeInputCard);
        }
    };
    AdaptiveApplet.prototype.internalSendActivityRequestAsync = function(request) {
        return $43f4532456519116$var$__awaiter(this, void 0, void 0, function() {
            var action;
            return $43f4532456519116$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendActivityRequestAsync: channelAdapter is not set.");
                        action = request.action;
                        if (!(action instanceof $6XfIC.ExecuteAction)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.internalSendExecuteRequestAsync(request)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        if (!(action instanceof $6XfIC.DataQuery)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.internalSendDataQueryRequestAsync(request)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        throw new Error("internalSendActivityRequestAsync: Unhandled Action Type");
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.internalSendExecuteRequestAsync = function(request) {
        return $43f4532456519116$var$__awaiter(this, void 0, void 0, function() {
            var overlay, done, _loop_1, this_1, state_1;
            return $43f4532456519116$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendExecuteRequestAsync: channelAdapter is not set.");
                        overlay = this.createProgressOverlay(request);
                        if (overlay !== undefined) this.renderedElement.appendChild(overlay);
                        done = false;
                        _loop_1 = function() {
                            var response, error_1, parsedContent, retryIn_1, attemptOAuth, left, top_1;
                            return $43f4532456519116$var$__generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        response = undefined;
                                        if (request.attemptNumber === 1) $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Sending activity request to channel (attempt " + request.attemptNumber + ")");
                                        else $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Re-sending activity request to channel (attempt " + request.attemptNumber + ")");
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this_1.channelAdapter.sendRequestAsync(request)
                                        ];
                                    case 2:
                                        response = _b.sent();
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 3:
                                        error_1 = _b.sent();
                                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Activity request failed: " + error_1);
                                        this_1.removeProgressOverlay(request);
                                        done = true;
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 4:
                                        if (!response) return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                        if (!(response instanceof $kBxrI.SuccessResponse)) return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                        this_1.removeProgressOverlay(request);
                                        if (response.rawContent === undefined) throw new Error("internalSendExecuteRequestAsync: Action.Execute result is undefined");
                                        parsedContent = response.rawContent;
                                        try {
                                            parsedContent = JSON.parse(response.rawContent);
                                        } catch (_c) {
                                        // Leave parseContent as is
                                        }
                                        if (typeof parsedContent === "string") {
                                            $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "The activity request returned a string after " + request.attemptNumber + " attempt(s).");
                                            this_1.activityRequestSucceeded(response, parsedContent);
                                        } else if (typeof parsedContent === "object" && parsedContent["type"] === "AdaptiveCard") {
                                            $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "The activity request returned an Adaptive Card after " + request.attemptNumber + " attempt(s).");
                                            this_1.internalSetCard(parsedContent, request.consecutiveActions);
                                            this_1.activityRequestSucceeded(response, this_1.card);
                                        } else throw new Error("internalSendExecuteRequestAsync: Action.Execute result is of unsupported type (" + typeof response.rawContent + ")");
                                        done = true;
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 5:
                                        if (!(response instanceof $kBxrI.ErrorResponse)) return [
                                            3 /*break*/ ,
                                            9
                                        ];
                                        retryIn_1 = this_1.activityRequestFailed(response);
                                        if (!(retryIn_1 >= 0 && request.attemptNumber < $6BHj7.GlobalSettings.applets.maximumRetryAttempts)) return [
                                            3 /*break*/ ,
                                            7
                                        ];
                                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Warning, "Activity request failed: ".concat(response.error.message, ". Retrying in ").concat(retryIn_1, "ms"));
                                        request.attemptNumber++;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve, _reject) {
                                                window.setTimeout(function() {
                                                    resolve();
                                                }, retryIn_1);
                                            })
                                        ];
                                    case 6:
                                        _b.sent();
                                        return [
                                            3 /*break*/ ,
                                            8
                                        ];
                                    case 7:
                                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Activity request failed: ".concat(response.error.message, ". Giving up after ").concat(request.attemptNumber, " attempt(s)"));
                                        this_1.removeProgressOverlay(request);
                                        done = true;
                                        _b.label = 8;
                                    case 8:
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 9:
                                        if (response instanceof $kBxrI.LoginRequestResponse) {
                                            $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "The activity request returned a LoginRequestResponse after " + request.attemptNumber + " attempt(s).");
                                            if (request.attemptNumber <= $6BHj7.GlobalSettings.applets.maximumRetryAttempts) {
                                                attemptOAuth = true;
                                                if (response.tokenExchangeResource && this_1.onSSOTokenNeeded) // Attempt to use SSO. The host will return true if it can handle SSO, in which case
                                                // we bypass OAuth
                                                attemptOAuth = !this_1.onSSOTokenNeeded(this_1, request, response.tokenExchangeResource);
                                                if (attemptOAuth) {
                                                    // Attempt to use OAuth
                                                    this_1.removeProgressOverlay(request);
                                                    if (response.signinButton === undefined) throw new Error("internalSendExecuteRequestAsync: the login request doesn't contain a valid signin URL.");
                                                    $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Login required at " + response.signinButton.value);
                                                    if (this_1.onShowSigninPrompt) // Bypass the built-in auth prompt if the host app handles it
                                                    this_1.onShowSigninPrompt(this_1, request, response.signinButton);
                                                    else {
                                                        this_1.showAuthCodeInputDialog(request);
                                                        left = window.screenX + (window.outerWidth - $6BHj7.GlobalSettings.applets.authPromptWidth) / 2;
                                                        top_1 = window.screenY + (window.outerHeight - $6BHj7.GlobalSettings.applets.authPromptHeight) / 2;
                                                        window.open(response.signinButton.value, response.signinButton.title ? response.signinButton.title : "Sign in", "width=".concat($6BHj7.GlobalSettings.applets.authPromptWidth, ",height=").concat($6BHj7.GlobalSettings.applets.authPromptHeight, ",left=").concat(left, ",top=").concat(top_1));
                                                    }
                                                }
                                            } else {
                                                $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Authentication failed. Giving up after " + request.attemptNumber + " attempt(s)");
                                                alert($24F6S.Strings.magicCodeInputCard.authenticationFailed());
                                            }
                                            return [
                                                2 /*return*/ ,
                                                "break"
                                            ];
                                        } else throw new Error("Unhandled response type: " + JSON.stringify(response));
                                        _b.label = 10;
                                    case 10:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 1;
                    case 1:
                        if (!!done) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 2:
                        state_1 = _a.sent();
                        if (state_1 === "break") return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.internalSendDataQueryRequestAsync = function(request) {
        return $43f4532456519116$var$__awaiter(this, void 0, void 0, function() {
            var filter, response, error_2, rawResponse, parsedResponse;
            return $43f4532456519116$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendDataQueryRequestAsync: channel adapter not set");
                        filter = request.action.filter;
                        if (!this._choiceSet) return [
                            3 /*break*/ ,
                            5
                        ];
                        this._choiceSet.showLoadingIndicator();
                        response = undefined;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.channelAdapter.sendRequestAsync(request)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        this._choiceSet.showErrorIndicator(filter, "Unable to load");
                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Activity request failed: " + error_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (response) {
                            if (response instanceof $kBxrI.SuccessResponse) {
                                rawResponse = response.rawContent;
                                if (rawResponse) {
                                    parsedResponse = void 0;
                                    try {
                                        parsedResponse = JSON.parse(rawResponse);
                                    } catch (error) {
                                        this._choiceSet.showErrorIndicator(filter, "Unable to load");
                                        throw new Error("internalSendDataQueryRequestAsync: Cannot parse response object: " + rawResponse);
                                    }
                                    if (typeof parsedResponse === "object") {
                                        this._choiceSet.renderChoices(filter, parsedResponse);
                                        this.activityRequestSucceeded(response, rawResponse);
                                    } else {
                                        this._choiceSet.showErrorIndicator(filter, "Error loading results");
                                        throw new Error("internalSendDataQueryRequestAsync: Data.Query result is of unsupported type (" + typeof rawResponse + ")");
                                    }
                                } else {
                                    this._choiceSet.showErrorIndicator(filter, "Unable to load");
                                    throw new Error("internalSendDataQueryRequestAsync: Data.Query result is undefined");
                                }
                            } else if (response instanceof $kBxrI.ErrorResponse) {
                                this._choiceSet.showErrorIndicator(filter, response.error.message || "Error loading results");
                                $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Activity request failed: ".concat(response.error.message, "."));
                                this.activityRequestFailed(response);
                            } else {
                                this._choiceSet.showErrorIndicator(filter, "Unable to load");
                                throw new Error("Unhandled response type: " + JSON.stringify(response));
                            }
                        } else this._choiceSet.removeLoadingIndicator();
                        _a.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.refreshCard = function() {
        if (this._card && this._card.refresh) this.internalExecuteAction(this._card.refresh.action, $kBxrI.ActivityRequestTrigger.Manual, 0);
    };
    AdaptiveApplet.prototype.setCard = function(payload) {
        this.internalSetCard(payload, 0);
    };
    Object.defineProperty(AdaptiveApplet.prototype, "card", {
        get: function() {
            return this._card;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveApplet._submitMagicCodeActionId = "submitMagicCode";
    AdaptiveApplet._cancelMagicCodeAuthActionId = "cancelMagicCodeAuth";
    return AdaptiveApplet;
}();
module.exports.AdaptiveApplet = $43f4532456519116$var$AdaptiveApplet;

});

parcelRegister("eO5xw", function(module, exports) {

$parcel$export(module.exports, "capitalizeFirstLetter", () => $6ab59bee0c56cc7a$export$d07f57595c356899);
const $6ab59bee0c56cc7a$export$d07f57595c356899 = (text, locale = 'fr-FR')=>{
    if (text && text.length > 0) {
        const first = text.charAt(0);
        const rest = text.slice(1);
        return first.toLocaleUpperCase(locale) + rest;
    }
    return '';
};

});

parcelRegister("l9TTE", function(module, exports) {

$parcel$export(module.exports, "Carousel", () => (parcelRequire("bQTDb")).default);
$parcel$export(module.exports, "Radio", () => (parcelRequire("k0gIL")).default);
$parcel$export(module.exports, "Swiper", () => (parcelRequire("o9qp2")).default);
$parcel$export(module.exports, "Toggle", () => (parcelRequire("66rUF")).default);
$parcel$export(module.exports, "Wheeler", () => (parcelRequire("fEfdX")).default);

var $bQTDb = parcelRequire("bQTDb");

var $k0gIL = parcelRequire("k0gIL");

var $7c6BL = parcelRequire("7c6BL");

var $o9qp2 = parcelRequire("o9qp2");

var $66rUF = parcelRequire("66rUF");

var $6aH4h = parcelRequire("6aH4h");

var $fEfdX = parcelRequire("fEfdX");

});
parcelRegister("bQTDb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3b92d705caaa237$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("7Jjoy");
var $3kuIS = parcelRequire("3kuIS");
var $iyJo4 = parcelRequire("iyJo4");
/**
 * Media types enum
 */ var $a3b92d705caaa237$var$MediaTypes = /*#__PURE__*/ function(MediaTypes) {
    MediaTypes[MediaTypes["image"] = 1] = "image";
    MediaTypes[MediaTypes["video"] = 2] = "video";
    return MediaTypes;
}($a3b92d705caaa237$var$MediaTypes || {});
const $a3b92d705caaa237$var$images = [
    'png',
    'gif',
    'jpg',
    'jpeg'
];
const $a3b92d705caaa237$var$videos = [
    'mp4',
    'webm',
    '3gp',
    'ogg'
];
const $a3b92d705caaa237$var$Carousel = ({ className: className, medias: medias, controls: controls, timer: timer, color: color, maxHeight: maxHeight })=>{
    const [currentIndex, setCurrentIndex] = (0, $bxRTa.useState)(0);
    const [currentMedia, setCurrentMedia] = (0, $bxRTa.useState)();
    const timerRef = (0, $bxRTa.useRef)(null);
    const startTimer = ()=>{
        if (medias.length > 1 && timer !== 0) {
            timerRef.current && clearTimeout(timerRef.current);
            timerRef.current = setTimeout(handleMore, timer || 3000);
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        // Clear timeout
        timerRef.current && clearTimeout(timerRef.current);
        // Call the reset function to set currentIndex and currentMedia states
        startNewMedias();
        // Launch timer only if there are more than 1 media
        startTimer();
        return ()=>{
            timerRef?.current && clearTimeout(timerRef.current);
        };
    }, [
        medias
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (currentIndex !== undefined) {
            const index = currentIndex % medias.length;
            const type = checkType(medias[index].url);
            if (type) {
                setCurrentMedia({
                    ...medias[index],
                    type: type
                });
                // Reset timer only if there are more than 1 media
                if (medias.length > 1 && timer !== 0) startTimer();
            }
        }
    }, [
        currentIndex
    ]);
    const startNewMedias = ()=>{
        if (currentIndex === 0) {
            const type = checkType(medias[0].url);
            type && setCurrentMedia({
                ...medias[0],
                type: type
            });
        } else setCurrentIndex(0);
    };
    /**
   *  Retrieve the extension of the media and return if it's either an image, a video, or null
   * @param src : string
   * @returns number | null
   */ const checkType = (src)=>{
        const url = src.split('?')[0];
        const extension = url.split('.').slice(-1)[0].toLowerCase();
        return $a3b92d705caaa237$var$images.includes(extension.toLowerCase()) ? 1 : $a3b92d705caaa237$var$videos.includes(extension.toLowerCase()) ? 2 : null;
    };
    const handleChoice = (choice)=>{
        setCurrentIndex(choice);
    };
    const handleLess = ()=>{
        if (medias.length > 1) currentIndex === 0 ? setCurrentIndex(medias.length - 1) : setCurrentIndex((currentIndex)=>currentIndex - 1);
    };
    const handleMore = ()=>{
        if (medias.length > 1) setCurrentIndex((prev)=>prev === medias.length - 1 ? 0 : prev + 1);
    };
    return currentMedia?.type ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            currentMedia.type === 1 ? /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                className: className,
                src: currentMedia.url,
                alt: currentMedia.alt || 'image',
                style: {
                    maxHeight: maxHeight
                }
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("video", {
                className: className,
                style: {
                    maxHeight: maxHeight
                },
                autoPlay: true,
                muted: true,
                loop: medias.length === 1,
                onEnded: handleMore,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("source", {
                    src: currentMedia.url
                })
            }),
            controls && medias.length > 1 && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-absolute rf-bottom-4 rf-left-1/2 -rf-translate-x-1/2 rf-flex rf-flex-row rf-items-center rf-gap-2",
                        children: medias.map((media, key)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-h-3 rf-w-3 rf-rounded-half rf-border rf-border-truewhite rf-cursor-pointer",
                                onClick: ()=>handleChoice(key),
                                style: {
                                    backgroundColor: currentIndex === key ? color : 'transparent'
                                }
                            }, `${media.url}${key}`);
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        "aria-label": "Previous",
                        className: "rf-absolute rf-left-4 rf-top-1/2 -rf-translate-y-1/2 rf-cursor-pointer",
                        onClick: handleLess,
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3kuIS.default), {
                            className: "rf-h-6 large:rf-h-8",
                            color: "#FFF"
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        "aria-label": "Next",
                        className: "rf-absolute rf-right-4 rf-top-1/2 -rf-translate-y-1/2 rf-cursor-pointer",
                        onClick: handleMore,
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iyJo4.default), {
                            className: "rf-h-6 large:rf-h-8",
                            color: "#FFF"
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $a3b92d705caaa237$export$2e2bcd8739ae039 = $a3b92d705caaa237$var$Carousel;

});
parcelRegister("7Jjoy", function(module, exports) {

$parcel$export(module.exports, "ChevronLeftIcon", () => (parcelRequire("3kuIS")).default);
$parcel$export(module.exports, "ChevronRightIcon", () => (parcelRequire("iyJo4")).default);

var $3kuIS = parcelRequire("3kuIS");

var $iyJo4 = parcelRequire("iyJo4");

var $fEqFQ = parcelRequire("fEqFQ");

});
parcelRegister("3kuIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $29977ff6d48b8474$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $29977ff6d48b8474$var$ChevronLeftIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-4',
        viewBox: "0 0 7.414 12.828",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M1429.081,2861.407l5-5-5-5",
            transform: "translate(1435.081 2862.822) rotate(180)",
            fill: "none",
            stroke: color || '#fff',
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
var $29977ff6d48b8474$export$2e2bcd8739ae039 = $29977ff6d48b8474$var$ChevronLeftIcon;

});

parcelRegister("iyJo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92eeef5002581ed$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $f92eeef5002581ed$var$ChevronRightIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-4',
        viewBox: "0 0 10.131 17.719",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M8.863,7.077l6.7-6.705a1.261,1.261,0,0,1,1.788,0,1.277,1.277,0,0,1,0,1.794L9.76,9.762A1.264,1.264,0,0,1,8.014,9.8L.369,2.171A1.266,1.266,0,0,1,2.158.377Z",
            transform: "translate(0 17.719) rotate(-90)",
            fill: color || '#818181'
        })
    });
};
var $f92eeef5002581ed$export$2e2bcd8739ae039 = $f92eeef5002581ed$var$ChevronRightIcon;

});

parcelRegister("fEqFQ", function(module, exports) {

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $3a23468e72ecffca$var$ChevronUpIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || 'currentColor',
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M14 4.83 3.4 15.43a2 2 0 0 1-2.82 0 2.02 2.02 0 0 1 0-2.84l12-12a2 2 0 0 1 2.76-.06l12.08 12.05a2 2 0 0 1-2.83 2.83Z"
        })
    });
};
var $3a23468e72ecffca$export$2e2bcd8739ae039 = $3a23468e72ecffca$var$ChevronUpIcon;

});



parcelRegister("k0gIL", function(module, exports) {

$parcel$export(module.exports, "default", () => $96de6b7836aa192d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $96de6b7836aa192d$var$Radio = ({ className: className, title: title, handleChange: handleChange, checked: checked })=>{
    const [transition, setTransition] = (0, $bxRTa.useState)(checked ? 'rf-scale-1' : 'rf-scale-0');
    const handleToggle = ()=>{
        setTransition(checked ? 'rf-scale-0' : 'rf-scale-1');
        handleChange(title);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-flex rf-flex-row rf-items-center rf-justify-between hover:rf-cursor-pointer ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-capitalize",
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: `rf-relative rf-w-7 large:rf-w-8 large-vertical:rf-w-14 rf-min-w-7 large:rf-min-w-8 large-vertical:rf-min-w-14 rf-h-7 large:rf-h-8 large-vertical:rf-h-14 ${!checked && 'rf-border rf-border-[#9FA2AA]'} rf-rounded-half`,
                style: {
                    background: checked ? 'linear-gradient(to right, #1999B1, #0a4652)' : '#FFFFFF',
                    boxShadow: checked ? '-3px 3px 6px #00000029' : ''
                },
                onClick: handleToggle,
                "aria-label": title,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `rf-absolute rf-top-2 large-vertical:rf-top-4 rf-left-2 large-vertical:rf-left-4 rf-w-3 large:rf-w-4 large-vertical:rf-w-6 rf-h-3 large:rf-h-4 large-vertical:rf-h-6 rf-rounded-half rf-bg-[#F8F8F8] rf-transition-all ${transition}`
                })
            })
        ]
    });
};
var $96de6b7836aa192d$export$2e2bcd8739ae039 = $96de6b7836aa192d$var$Radio;

});

parcelRegister("7c6BL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e8c2248156e4a90$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");
const $7e8c2248156e4a90$var$SendActivityEventListener = ({ isRetorikNews: isRetorikNews, hasConversationCookie: hasConversationCookie, userData: userData })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const displayGDPR = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.GDPRDisplay);
    const userConsent = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.GDPRUserConsent);
    const loaderClosed = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.loaderClosed);
    const appAvailable = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.appAvailable);
    const skipWelcome = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.skipWelcome);
    const userAlreadySet = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.userAlreadySet);
    const characterLoaded = (0, $5FZWK.useSelector)((state)=>state.viewReducer.characterLoaded);
    /**
   * Send mandatory events : Davi.GDPRConsent for GDPR module then setUser to start conversation
   */ const sendMandatoryEvents = async ()=>{
        dispatch((0, $cto9a.storeActions).directline.sendEvent({
            name: 'Davi.GDPRConsent',
            value: {
                userConsent: userConsent
            },
            callback: ()=>dispatch((0, $cto9a.storeActions).directline.sendEvent({
                    name: 'setUser',
                    value: {
                        user: {
                            ...userData,
                            gdprConsent: true
                        },
                        skipWelcome: !!skipWelcome
                    }
                }))
        }));
    };
    (0, $bxRTa.useEffect)(()=>{
        if (isRetorikNews || hasConversationCookie) dispatch((0, $cto9a.storeActions).retorik.setUserAlreadySet(true));
        else if (!userAlreadySet && appAvailable && !displayGDPR && characterLoaded) {
            dispatch((0, $cto9a.storeActions).retorik.setUserAlreadySet(true));
            sendMandatoryEvents();
        }
    }, [
        appAvailable,
        loaderClosed,
        displayGDPR,
        characterLoaded
    ]);
    return null;
};
var $7e8c2248156e4a90$export$2e2bcd8739ae039 = $7e8c2248156e4a90$var$SendActivityEventListener;

});

parcelRegister("o9qp2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f717076b62aa1fd7$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
// The required distance between touchStart and touchEnd to be detected as a swipe
const $f717076b62aa1fd7$var$minSwipeDistance = 30;
const $f717076b62aa1fd7$var$Swiper = ({ direction: direction, onSwiping: onSwiping, onSwipeLeft: onSwipeLeft, onSwipeRight: onSwipeRight, onSwipeTop: onSwipeTop, onSwipeBottom: onSwipeBottom, className: className, children: children })=>{
    const [moveStart, setMoveStart] = (0, $bxRTa.useState)(null);
    const [moveEnd, setMoveEnd] = (0, $bxRTa.useState)(null);
    const [timeStart, setTimeStart] = (0, $bxRTa.useState)(0);
    /**
   * On moveEnd state change :
   *  - set swiping distance to moveStart - moveEnd
   */ (0, $bxRTa.useEffect)(()=>{
        if (moveStart && moveEnd) {
            const distance = moveStart - moveEnd;
            onSwiping(distance);
        }
    }, [
        moveEnd
    ]);
    /**
   * On PointerDown event fire :
   *  - set timeStart state to current timestamp
   *  - reset moveEnd state to null to prevent activation on single touch
   *  - set moveStart state with the current X or Y position depending on the direction prop
   * @param e : React.PointerEvent
   */ const onPointerDown = (e)=>{
        setTimeStart(Date.now());
        setMoveEnd(null);
        setMoveStart(direction === 'horizontal' ? e.clientX : e.clientY);
    };
    /**
   * On PointerMove event fire :
   *  - set moveEnd state with the current X or Y position depending on the direction prop
   * @param e : React.PointerEvent
   */ const onPointerMove = (e)=>{
        setMoveEnd(direction === 'horizontal' ? e.clientX : e.clientY);
    };
    /**
   * On PointerUp event fire :
   *  - calculate the distance between move start and end
   *  - prevent default behaviour and propagation of the event if the distance is large enough (prevent unwanted touch/click at the end of a slide)
   *  - call the parent method depending on the distance and the direction, or reset position if the distance is too small
   *  - reset moveStart state to null
   */ const onPointerUp = (e)=>{
        if (moveStart && moveEnd) {
            const elapsedTime = Date.now() - timeStart;
            const distance = moveStart - moveEnd;
            if (distance > $f717076b62aa1fd7$var$minSwipeDistance) {
                e.preventDefault();
                e.stopPropagation();
                direction === 'horizontal' ? onSwipeLeft(distance, elapsedTime) : onSwipeTop(distance, elapsedTime);
            } else if (distance < -$f717076b62aa1fd7$var$minSwipeDistance) {
                e.preventDefault();
                e.stopPropagation();
                direction === 'horizontal' ? onSwipeRight(distance, elapsedTime) : onSwipeBottom(distance, elapsedTime);
            } else onSwiping(0);
        }
        setMoveStart(null);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-relative rf-w-full rf-overflow-hidden ${className}`,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerUp,
        children: children
    });
};
var $f717076b62aa1fd7$export$2e2bcd8739ae039 = $f717076b62aa1fd7$var$Swiper;

});

parcelRegister("66rUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d941fb14a0f8c8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");
const $55d941fb14a0f8c8$var$Toggle = ({ className: className, title: title, handleChange: handleChange, defaultChecked: defaultChecked, lockInTextMode: lockInTextMode })=>{
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const [on, setOn] = (0, $bxRTa.useState)(!!defaultChecked);
    const [transition, setTransition] = (0, $bxRTa.useState)(on ? 'rf-right-1' : 'rf-left-1');
    (0, $bxRTa.useEffect)(()=>{
        setOn(!!defaultChecked);
        setTransition(defaultChecked ? 'rf-right-1' : 'rf-left-1');
    }, [
        defaultChecked
    ]);
    const handleToggle = ()=>{
        if (!(lockInTextMode && mode === (0, $2rYkD.Mode).text)) {
            setTransition(on ? 'rf-translate-x-1' : 'rf-translate-x-5');
            handleChange(!on);
            setOn(!on);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-flex rf-flex-row large:rf-flex-col rf-items-center rf-justify-between large:rf-justify-start large:rf-gap-1 hover:rf-cursor-pointer ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-capitalize large:rf-uppercase",
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-relative rf-w-12 rf-min-w-12 rf-h-6 rf-rounded-6",
                style: {
                    background: 'linear-gradient(to left, #E5E6EC, #F2F3F6)',
                    boxShadow: 'inset 3px 3px 6px #00000029'
                },
                onClick: handleToggle,
                "aria-label": title,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `rf-absolute rf-top-1 rf-w-4 rf-h-4 rf-rounded-half ${on ? 'rf-bg-secondary' : 'rf-bg-[#F8F8F8]'} rf-transition-all ${transition}`,
                    style: {
                        boxShadow: on ? '-3px -3px 3px #00000029' : '3px 3px 3px #00000029'
                    }
                })
            })
        ]
    });
};
var $55d941fb14a0f8c8$export$2e2bcd8739ae039 = $55d941fb14a0f8c8$var$Toggle;

});

parcelRegister("6aH4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $80e8a675a6b3dfd3$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $80e8a675a6b3dfd3$var$ToggleWithTexts = ({ texts: texts, colors: colors, handleChange: handleChange, defaultChecked: defaultChecked, showLeft: showLeft, showRight: showRight })=>{
    const [left, setLeft] = (0, $bxRTa.useState)(!defaultChecked || defaultChecked === texts.leftId);
    /**
   * On call :
   *  - call parent method with either leftId or rightId depending on the leftSide parameter
   *  - set left state
   * @param leftSide : boolean
   */ const handleToggle = (leftSide)=>{
        handleChange(leftSide ? texts.leftId : texts.rightId);
        setLeft(leftSide);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-flex rf-flex-row rf-justify-between rf-text-size-auto rf-rounded-8 rf-cursor-pointer rf-select-none rf-shadow-[inset_0_12px_12px_-12px_#00000029,inset_0_-12px_12px_-12px_#00000029]",
        style: {
            background: 'linear-gradient(to left, #CBCBCB 0%, #9A9797 50%, #4E4C4C 100%)',
            color: colors.text
        },
        children: [
            showLeft && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-px-4 rf-py-2 rf-uppercase rf-font-bold rf-border rf-rounded-8 ${left && 'rf-shadow-[0_0_3px_6px_#00000029]'} `,
                style: {
                    background: left ? colors.background : 'transparent',
                    borderColor: left ? colors.background : 'transparent'
                },
                onClick: ()=>handleToggle(true),
                children: texts.left
            }),
            showRight && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-px-4 rf-py-2 rf-uppercase rf-font-bold rf-border rf-rounded-8 ${!left && 'rf-shadow-[0_0_3px_6px_#00000029]'}`,
                style: {
                    background: left ? 'transparent' : colors.background,
                    borderColor: left ? 'transparent' : colors.background
                },
                onClick: ()=>handleToggle(false),
                children: texts.right
            })
        ]
    });
};
var $80e8a675a6b3dfd3$export$2e2bcd8739ae039 = $80e8a675a6b3dfd3$var$ToggleWithTexts;

});

parcelRegister("fEfdX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7227dfa768fc141b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $7227dfa768fc141b$var$Wheeler = ({ className: className, handleWheel: handleWheel, paramInHandle: paramInHandle, handleBoth: handleBoth, xAxisOnly: xAxisOnly, children: children })=>{
    const ref = (0, $bxRTa.useRef)(null);
    /**
   * On mouse wheel :
   *  - check if the event has to be taken in account
   *  - if  yes, retrieve the wanted data
   *  - prevent event default
   *  - stop event propagation
   *  - call parent function with delta value and paramInHandle from props if defined
   * @param e : WheelEvent
   */ const internalHandleWheel = (e)=>{
        if (xAxisOnly && e.deltaY) return;
        const delta = handleBoth ? {
            x: e.deltaX,
            y: e.deltaY
        } : xAxisOnly ? e.deltaX : e.deltaY;
        e.preventDefault();
        e.stopImmediatePropagation();
        paramInHandle ? handleWheel(delta, paramInHandle) : handleWheel(delta);
    };
    /**
   * On ref change :
   *  - add wheel event listener, with passive = false to allow preventDefault in processing
   * On component unmount :
   *  - unbind wheel event listener
   */ (0, $bxRTa.useEffect)(()=>{
        if (ref.current) ref.current.addEventListener('wheel', (e)=>internalHandleWheel(e), {
            passive: false
        });
        return ()=>{
            ref.current && ref.current.removeEventListener('wheel', (e)=>internalHandleWheel(e));
        };
    }, [
        ref.current
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: className,
        ref: ref,
        children: children
    });
};
var $7227dfa768fc141b$export$2e2bcd8739ae039 = $7227dfa768fc141b$var$Wheeler;

});


parcelRegister("kMAJU", function(module, exports) {

$parcel$export(module.exports, "CloseIcon", () => (parcelRequire("04Syy")).default);
$parcel$export(module.exports, "DownloadIcon", () => (parcelRequire("9oAhU")).default);
$parcel$export(module.exports, "FeatherCheckIcon", () => (parcelRequire("kA2rN")).default);
$parcel$export(module.exports, "FeatherFilterIcon", () => (parcelRequire("cxD1i")).default);
$parcel$export(module.exports, "InfoWithCircleIcon", () => (parcelRequire("d5ZYc")).default);
$parcel$export(module.exports, "MicrophoneAllowedIcon", () => (parcelRequire("f3SD2")).default);
$parcel$export(module.exports, "MicrophoneRefusedIcon", () => (parcelRequire("iNZRc")).default);
$parcel$export(module.exports, "SendMessageIcon", () => (parcelRequire("byrzf")).default);
$parcel$export(module.exports, "SendMessageIconReversed", () => (parcelRequire("lvWyY")).default);
$parcel$export(module.exports, "ZoomOutIcon", () => (parcelRequire("7bOgw")).default);
$parcel$export(module.exports, "RetorikLogoIcon", () => (parcelRequire("lHTuW")).default);
$parcel$export(module.exports, "FileIcon", () => (parcelRequire("av28T")).default);

var $04Syy = parcelRequire("04Syy");

var $9oAhU = parcelRequire("9oAhU");

var $kA2rN = parcelRequire("kA2rN");

var $cxD1i = parcelRequire("cxD1i");

var $d5ZYc = parcelRequire("d5ZYc");

var $f3SD2 = parcelRequire("f3SD2");

var $iNZRc = parcelRequire("iNZRc");

var $byrzf = parcelRequire("byrzf");

var $lvWyY = parcelRequire("lvWyY");

var $7bOgw = parcelRequire("7bOgw");

var $lHTuW = parcelRequire("lHTuW");

var $av28T = parcelRequire("av28T");

});
parcelRegister("04Syy", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ae80c2a7e55409$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $35ae80c2a7e55409$var$CloseIcon = ({ className: className, color: color, strokeWidth: strokeWidth })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || 'currentColor',
        strokeWidth: strokeWidth || 2,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 18L18 6M6 6l12 12"
        })
    });
};
var $35ae80c2a7e55409$export$2e2bcd8739ae039 = $35ae80c2a7e55409$var$CloseIcon;

});

parcelRegister("9oAhU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b5aaac005f59ffb$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $7b5aaac005f59ffb$var$DownloadIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30",
        className: className || 'rf-h-6 rf-w-6',
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                d: "M20.75 14.38H16V.96c0-.53-.45-.96-1-.96s-1 .43-1 .96v13.42H9.25c-.19 0-.32.2-.22.36l5.75 9.52c.1.16.34.16.44 0l5.75-9.52c.09-.16-.03-.36-.22-.36z",
                fill: color || 'currentColor'
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                d: "M29 19.76V27c0 1.1-.86 2-1.93 2H2.93C1.86 29 1 28.1 1 27v-7.24",
                fill: "none",
                stroke: color || 'currentColor'
            })
        ]
    });
};
var $7b5aaac005f59ffb$export$2e2bcd8739ae039 = $7b5aaac005f59ffb$var$DownloadIcon;

});

parcelRegister("kA2rN", function(module, exports) {

$parcel$export(module.exports, "default", () => $21517659bdeb3e43$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $21517659bdeb3e43$var$FeatherCheckIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28.676",
        height: "20.419",
        viewBox: "0 0 28.676 20.419",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M30.434,9l-16.8,16.8L6,18.163",
            transform: "translate(-3.879 -6.879)",
            fill: "none",
            stroke: color || '#fff',
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "3"
        })
    });
};
var $21517659bdeb3e43$export$2e2bcd8739ae039 = $21517659bdeb3e43$var$FeatherCheckIcon;

});

parcelRegister("cxD1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9847270020efa43$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $b9847270020efa43$var$FeatherFilterIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14.333",
        height: "13",
        viewBox: "0 0 14.333 13",
        className: className || 'rf-w-6 rf-h-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M16.333,4.5H3l5.333,6.307v4.36L11,16.5V10.807Z",
            transform: "translate(-2.5 -4)",
            fill: "none",
            stroke: color || '#000',
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1"
        })
    });
};
var $b9847270020efa43$export$2e2bcd8739ae039 = $b9847270020efa43$var$FeatherFilterIcon;

});

parcelRegister("d5ZYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $84cfe305a0ebc914$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $84cfe305a0ebc914$var$InfoWithCircleIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: className || 'rf-h-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 33 33",
            className: "rf-h-full",
            children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                transform: "translate(-1.5 -1.5)",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M33,18A15,15,0,1,1,18,3,15,15,0,0,1,33,18Z",
                        fill: "none",
                        stroke: color || '#00d7ff',
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M18,24V18",
                        fill: "none",
                        stroke: color || '#00d7ff',
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M18,12h0",
                        fill: "none",
                        stroke: color || '#00d7ff',
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    })
                ]
            })
        })
    });
};
var $84cfe305a0ebc914$export$2e2bcd8739ae039 = $84cfe305a0ebc914$var$InfoWithCircleIcon;

});

parcelRegister("f3SD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c60a2a87a4615b74$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $c60a2a87a4615b74$var$MicrophoneAllowedIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 28.5 41.453",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-374.543 -230)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M401.748,280.386h-1.3a1.3,1.3,0,0,0-1.3,1.3v3.887a10.375,10.375,0,0,1-10.387,10.364q-.507,0-1.013-.051a10.679,10.679,0,0,1-9.328-10.775v-3.425a1.3,1.3,0,0,0-1.3-1.3h-1.3a1.3,1.3,0,0,0-1.3,1.3v3.252c0,7.258,5.176,13.728,12.307,14.711v2.765h-4.534a1.3,1.3,0,0,0-1.3,1.3V305a1.3,1.3,0,0,0,1.3,1.3H395.27a1.3,1.3,0,0,0,1.3-1.3v-1.3a1.3,1.3,0,0,0-1.3-1.3h-4.534v-2.735a14.264,14.264,0,0,0,12.307-14.107v-3.887A1.3,1.3,0,0,0,401.748,280.386Z",
                    transform: "translate(0 -34.842)",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M406.719,248.348a2.769,2.769,0,0,1-1.969-.815l-5.251-5.25a2.786,2.786,0,0,1,0-3.938l1.145-1.148a2.786,2.786,0,0,1,3.941,0l2.138,2.139,3.98-3.981a7.773,7.773,0,0,0-15.16,2.416v12.955a7.773,7.773,0,0,0,15.546,0v-5.591l-2.393,2.393A2.767,2.767,0,0,1,406.719,248.348Z",
                    transform: "translate(-14.519)",
                    fill: color || '#FFF'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M428.061,245.381l-1.142-1.145h0a.808.808,0,0,0-1.142,0l-3.211,3.212-4.365,4.366-3.537-3.539h0a.808.808,0,0,0-1.142,0l-1.142,1.146h0a.808.808,0,0,0,0,1.142l5.251,5.251h0a.808.808,0,0,0,1.142,0l3.794-3.794,5.5-5.5h0A.808.808,0,0,0,428.061,245.381Z",
                    transform: "translate(-25.999 -9.681)",
                    fill: color || '#FFF'
                })
            ]
        })
    });
};
var $c60a2a87a4615b74$export$2e2bcd8739ae039 = $c60a2a87a4615b74$var$MicrophoneAllowedIcon;

});

parcelRegister("iNZRc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a39f0d26f73bbe1$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $8a39f0d26f73bbe1$var$MicrophoneRefusedIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 28.99 42.159",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-527.589 -229.523)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M556.489,258.506h0a7.9,7.9,0,0,0,7.9-7.9v-8.817l-.07-.07-2.065,2.063a2.079,2.079,0,0,1-2.936,0l-1.557-1.557a2.084,2.084,0,0,1,0-2.936l2.06-2.06-2.063-2.063a2.084,2.084,0,0,1,0-2.936l1.557-1.557a2.073,2.073,0,0,1,.541-.387,7.906,7.906,0,0,0-11.283,7.147V250.6A7.9,7.9,0,0,0,556.489,258.506Z",
                    transform: "translate(-14.411 0)",
                    fill: color || '#FFF'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M555.259,279.916h-1.322a1.318,1.318,0,0,0-1.318,1.318v3.952a10.551,10.551,0,0,1-10.564,10.539q-.515,0-1.028-.051a10.859,10.859,0,0,1-9.487-10.957v-3.483a1.318,1.318,0,0,0-1.318-1.318h-1.314a1.318,1.318,0,0,0-1.318,1.318v3.307A14.945,14.945,0,0,0,540.105,299.5v2.813h-4.621a1.318,1.318,0,0,0-1.318,1.318v1.318a1.318,1.318,0,0,0,1.318,1.318h13.173a1.318,1.318,0,0,0,1.318-1.318v-1.318a1.318,1.318,0,0,0-1.318-1.318h-4.593v-2.78a14.505,14.505,0,0,0,12.514-14.345v-3.954A1.318,1.318,0,0,0,555.259,279.916Z",
                    transform: "translate(0 -34.583)",
                    fill: color || '#FFF'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M592.216,245.5h0l-3.29-3.29,3.29-3.29a.34.34,0,0,0,0-.479l-1.554-1.554a.34.34,0,0,0-.479,0l-3.288,3.29-.374-.374-2.918-2.916a.34.34,0,0,0-.479,0l-1.555,1.554a.34.34,0,0,0,0,.479l3.29,3.29-3.29,3.29a.34.34,0,0,0,0,.479l1.554,1.554a.34.34,0,0,0,.479,0l3.292-3.29.07.07,3.22,3.22a.339.339,0,0,0,.479,0l1.554-1.554A.339.339,0,0,0,592.216,245.5Z",
                    transform: "translate(-36.977 -4.985)",
                    fill: color || '#FFF'
                })
            ]
        })
    });
};
var $8a39f0d26f73bbe1$export$2e2bcd8739ae039 = $8a39f0d26f73bbe1$var$MicrophoneRefusedIcon;

});

parcelRegister("byrzf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0cc0e1aabe9e77f$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $f0cc0e1aabe9e77f$var$SendMessageIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-w-6',
        viewBox: "0 0 23.207 23.207",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(0.5 0.707)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M28.6,3,16.5,15.1",
                    transform: "translate(-6.6 -3)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M25,3,17.3,25l-4.4-9.9L3,10.7Z",
                    transform: "translate(-3 -3)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                })
            ]
        })
    });
};
var $f0cc0e1aabe9e77f$export$2e2bcd8739ae039 = $f0cc0e1aabe9e77f$var$SendMessageIcon;

});

parcelRegister("lvWyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $95383ea446068ca2$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $95383ea446068ca2$var$SendMessageIconReversed = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-w-6',
        viewBox: "0 0 23.207 23.207",
        style: {
            transform: 'scaleX(-1)',
            transformOrigin: '11.6px 11.6px'
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(0.5 0.707)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M28.6,3,16.5,15.1",
                    transform: "translate(-6.6 -3)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M25,3,17.3,25l-4.4-9.9L3,10.7Z",
                    transform: "translate(-3 -3)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                })
            ]
        })
    });
};
var $95383ea446068ca2$export$2e2bcd8739ae039 = $95383ea446068ca2$var$SendMessageIconReversed;

});

parcelRegister("7bOgw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c80aa348110a43b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $1c80aa348110a43b$var$ZoomOutIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 37.91 37.91",
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M29.773,4.5l4.844,4.844-6.087,6.044,2.991,2.991,6.044-6.087,4.844,4.844V4.5ZM4.5,17.137l4.844-4.844,6.044,6.087,2.991-2.991L12.293,9.344,17.137,4.5H4.5ZM17.137,42.41l-4.844-4.844,6.087-6.044-2.991-2.991L9.344,34.617,4.5,29.773V42.41ZM42.41,29.773l-4.844,4.844-6.044-6.087-2.991,2.991,6.087,6.044L29.773,42.41H42.41Z",
            transform: "translate(-4.5 -4.5)",
            fill: color || '#00d7ff'
        })
    });
};
var $1c80aa348110a43b$export$2e2bcd8739ae039 = $1c80aa348110a43b$var$ZoomOutIcon;

});

parcelRegister("lHTuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e6fbe4f0234d6e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $d5e6fbe4f0234d6e$var$RetorikLogoIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 325 135",
        className: className || 'rf-h-6 rf-w-6',
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("rect", {
                x: "0",
                y: "-6",
                width: "325",
                height: "143",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M93.6,70.9V50.8c0-14.2-11.5-25.7-25.7-25.7h0c-14.2,0-25.7,11.5-25.7,25.7v20.1c0,14.2,11.5,25.7,25.7,25.7v0   h25.7l-13.3-3.2C88.2,89,93.6,80.6,93.6,70.9z M67.9,89.8C57.5,89.8,49,81.3,49,70.9V50.8c0-10.4,8.5-18.9,18.9-18.9   c10.4,0,18.9,8.5,18.9,18.9v20.1C86.8,81.3,78.3,89.8,67.9,89.8z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            fill: color || '#FFF',
                            d: "M67.9,82.6c-2.3,0-4.5-0.9-6.1-2.5c-0.7-0.7-0.7-1.9,0-2.6c0.7-0.7,1.9-0.7,2.6,0c0.9,0.9,2.2,1.4,3.5,1.4    c1.3,0,2.6-0.5,3.5-1.4c0.7-0.7,1.9-0.7,2.6,0c0.7,0.7,0.7,1.9,0,2.6C72.4,81.7,70.2,82.6,67.9,82.6z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M117.1,61.6V34.9h11.1c1.1,0,2.2,0.2,3.1,0.7c1,0.5,1.8,1.1,2.5,1.9c0.7,0.8,1.2,1.7,1.6,2.7   c0.4,1,0.6,2,0.6,3c0,1-0.2,1.9-0.5,2.8c-0.3,0.9-0.7,1.7-1.3,2.5c-0.6,0.7-1.2,1.3-2,1.8c-0.8,0.5-1.6,0.8-2.6,0.9l6.7,10.4h-2.2   l-6.5-10.1H119v10.1H117.1z M119,49.7h9.4c0.9,0,1.6-0.2,2.3-0.6c0.7-0.4,1.3-0.9,1.8-1.5c0.5-0.6,0.9-1.3,1.1-2.1   c0.3-0.8,0.4-1.6,0.4-2.4c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.7-1.5-1.3-2.1c-0.5-0.6-1.2-1.1-1.9-1.4c-0.7-0.4-1.5-0.5-2.3-0.5H119   V49.7z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M161.6,59.9v1.7h-17.8V34.9h17.5v1.7h-15.5v10.5h13.6v1.7h-13.6v11.1H161.6z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M187.8,36.6H178v25h-1.9v-25h-9.8v-1.7h21.5V36.6z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M203.7,61.8c-1.9,0-3.5-0.4-5.1-1.2c-1.5-0.8-2.8-1.8-4-3c-1.1-1.3-2-2.7-2.6-4.3c-0.6-1.6-0.9-3.3-0.9-5   c0-1.8,0.3-3.5,1-5.1c0.6-1.6,1.5-3.1,2.6-4.3c1.1-1.3,2.4-2.3,4-3c1.5-0.7,3.2-1.1,5-1.1c1.9,0,3.6,0.4,5.1,1.2   c1.5,0.8,2.9,1.8,4,3.1c1.1,1.3,1.9,2.7,2.5,4.3s0.9,3.3,0.9,4.9c0,1.8-0.3,3.5-1,5.2c-0.6,1.6-1.5,3.1-2.6,4.3   c-1.1,1.2-2.4,2.2-4,3C207.1,61.4,205.5,61.8,203.7,61.8z M193.1,48.2c0,1.5,0.3,3,0.8,4.4c0.5,1.4,1.2,2.7,2.2,3.8   c0.9,1.1,2.1,2,3.4,2.6c1.3,0.7,2.7,1,4.3,1c1.6,0,3.1-0.3,4.3-1c1.3-0.7,2.4-1.6,3.3-2.7c0.9-1.1,1.6-2.4,2.1-3.8   c0.5-1.4,0.8-2.8,0.8-4.3c0-1.5-0.3-3-0.8-4.4c-0.5-1.4-1.3-2.7-2.2-3.8c-0.9-1.1-2-2-3.3-2.6c-1.3-0.7-2.7-1-4.2-1   c-1.6,0-3.1,0.3-4.4,1S197,39,196,40.2c-0.9,1.1-1.6,2.4-2.1,3.8C193.4,45.4,193.1,46.8,193.1,48.2z",
                        id: "path19"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M223.7,61.6V34.9h11.1c1.1,0,2.2,0.2,3.1,0.7c1,0.5,1.8,1.1,2.5,1.9c0.7,0.8,1.2,1.7,1.6,2.7   c0.4,1,0.6,2,0.6,3c0,1-0.2,1.9-0.5,2.8c-0.3,0.9-0.7,1.7-1.3,2.5c-0.6,0.7-1.2,1.3-2,1.8c-0.8,0.5-1.6,0.8-2.6,0.9l6.7,10.4h-2.2   l-6.5-10.1h-8.7v10.1H223.7z M225.6,49.7h9.4c0.9,0,1.6-0.2,2.3-0.6c0.7-0.4,1.3-0.9,1.8-1.5c0.5-0.6,0.9-1.3,1.1-2.1   c0.3-0.8,0.4-1.6,0.4-2.4c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.7-1.5-1.3-2.1c-0.5-0.6-1.2-1.1-1.9-1.4c-0.7-0.4-1.5-0.5-2.3-0.5h-9.1   V49.7z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M250.5,61.6V34.9h1.9v26.7H250.5z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M261.7,61.6V34.9h1.9v16.2l15.6-16.2h2.2l-11.1,11.7l11.7,15h-2.2l-10.7-13.8l-5.5,5.6v8.2H261.7z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                                        fill: color || '#FFF',
                                        d: "M122.9,96.1c-1,0-1.9-0.3-2.7-0.8c-0.8-0.5-1.5-1.2-2-2v2.5h-1.1V78.4h1.2v7.7c0.6-0.9,1.3-1.6,2.1-2.1      c0.8-0.5,1.7-0.8,2.8-0.8c0.9,0,1.7,0.2,2.4,0.6c0.7,0.4,1.3,0.9,1.8,1.5c0.5,0.6,0.9,1.3,1.1,2.1c0.3,0.8,0.4,1.6,0.4,2.4      c0,0.9-0.2,1.7-0.5,2.4s-0.7,1.4-1.3,2c-0.5,0.6-1.2,1-1.9,1.4C124.5,95.9,123.7,96.1,122.9,96.1z M122.6,95      c0.7,0,1.4-0.2,2-0.5c0.6-0.3,1.1-0.7,1.6-1.2c0.4-0.5,0.8-1.1,1-1.7c0.2-0.6,0.4-1.3,0.4-2c0-0.7-0.1-1.4-0.3-2      c-0.2-0.6-0.6-1.2-1-1.7c-0.4-0.5-0.9-0.9-1.5-1.2c-0.6-0.3-1.2-0.5-1.9-0.5c-0.5,0-1,0.1-1.5,0.3c-0.5,0.2-0.9,0.4-1.3,0.7      c-0.4,0.3-0.7,0.7-1.1,1.1c-0.3,0.4-0.6,0.8-0.8,1.2v4.1c0,0.5,0.2,0.9,0.5,1.3c0.3,0.4,0.7,0.8,1.1,1.1      c0.4,0.3,0.9,0.5,1.4,0.7C121.7,95,122.2,95,122.6,95z"
                                    })
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                                        fill: color || '#FFF',
                                        d: "M133.3,100.1c0.1,0,0.2,0,0.4,0c0.2,0,0.3,0,0.4,0c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.2-0.1,0.3-0.2      c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.3,0.3-0.7,0.5-1.2c0.2-0.5,0.5-1.2,0.9-2.1L131,83.5h1.2l4.9,11.3l4.6-11.3h1.2l-6.8,16.3      c-0.2,0.4-0.5,0.8-0.8,1c-0.4,0.2-0.9,0.4-1.6,0.4c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0V100.1z"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            fill: color || '#FFF',
                            d: "M213.9,95.9l0.4-0.3c1.4-1.2,2.1-2.7,2.1-4.6l0-8h-2.5V95.9z"
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("polygon", {
                            fill: color || '#FFF',
                            points: "202.9,93.3 196.9,83 193.9,83 201.4,95.9 201.4,95.9 204.4,95.9 204.4,95.9 212,83 208.9,83   "
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            fill: color || '#FFF',
                            d: "M174.1,87.5v3.9c0,2.5,2,4.5,4.5,4.5h8.9c0.7,0,1.4-0.2,2-0.5v0.4h2.5V83l-13.4,0    C176.1,83,174.1,85,174.1,87.5z M189.4,85.5v5.7c-0.1,1.2-1,2.1-2.2,2.1h-8.6c-1.2,0-2.2-1-2.2-2.3v-3.4c0-1.2,1-2.2,2.2-2.2    H189.4z"
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            fill: color || '#FFF',
                            d: "M171.3,75.2l-2.5-0.8v9.1c-0.6-0.3-1.3-0.5-2-0.5H158c-2.5,0-4.5,2-4.5,4.5v3.9c0,2.5,2,4.5,4.5,4.5l13.2,0    h1.4h0.3c-1-1.2-1.6-2.8-1.6-4.5L171.3,75.2z M168.8,93.4h-10.7c-1.2,0-2.2-1-2.2-2.2v-3.4c0-1.2,1-2.2,2.2-2.2h8.5    c1.1,0,2.1,0.9,2.1,2.1V93.4z"
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            fill: color || '#FFF',
                            d: "M215.1,80.6c0.3,0,0.6-0.1,0.9-0.4c0.3-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.3-0.6-0.4-0.9-0.4    c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.2-0.4,0.5-0.4,0.9c0,0.4,0.1,0.7,0.4,0.9C214.5,80.5,214.8,80.6,215.1,80.6z"
                        })
                    })
                ]
            })
        ]
    });
};
var $d5e6fbe4f0234d6e$export$2e2bcd8739ae039 = $d5e6fbe4f0234d6e$var$RetorikLogoIcon;

});

parcelRegister("av28T", function(module, exports) {

$parcel$export(module.exports, "default", () => $662532ad3923967c$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $662532ad3923967c$var$FileIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 19.908 23.226",
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M21.6,7.129a3.016,3.016,0,0,1,.622.985,2.991,2.991,0,0,1,.259,1.141V24.185a1.239,1.239,0,0,1-1.244,1.244H3.815a1.239,1.239,0,0,1-1.244-1.244V3.448A1.239,1.239,0,0,1,3.815,2.2H15.428a2.992,2.992,0,0,1,1.141.259,3.016,3.016,0,0,1,.985.622ZM15.843,3.966V8.839h4.873a1.416,1.416,0,0,0-.285-.531L16.374,4.251a1.416,1.416,0,0,0-.531-.285Zm4.977,19.8V10.5H15.428a1.239,1.239,0,0,1-1.244-1.244V3.862H4.23V23.77H20.82Z",
            transform: "translate(-2.571 -2.203)",
            fill: color || '#00d7ff'
        })
    });
};
var $662532ad3923967c$export$2e2bcd8739ae039 = $662532ad3923967c$var$FileIcon;

});


parcelRegister("7QU6k", function(module, exports) {

$parcel$export(module.exports, "create", () => $5b78e83ec8a66d05$export$185802fd694ee1f5, (v) => $5b78e83ec8a66d05$export$185802fd694ee1f5 = v);
$parcel$export(module.exports, "toCanvas", () => $5b78e83ec8a66d05$export$f87f6982d1fd4f81, (v) => $5b78e83ec8a66d05$export$f87f6982d1fd4f81 = v);
$parcel$export(module.exports, "toDataURL", () => $5b78e83ec8a66d05$export$723e4939e5a27c8, (v) => $5b78e83ec8a66d05$export$723e4939e5a27c8 = v);
$parcel$export(module.exports, "toString", () => $5b78e83ec8a66d05$export$f84e8e69fd4488a5, (v) => $5b78e83ec8a66d05$export$f84e8e69fd4488a5 = v);
var $5b78e83ec8a66d05$export$185802fd694ee1f5;
var $5b78e83ec8a66d05$export$f87f6982d1fd4f81;
var $5b78e83ec8a66d05$export$723e4939e5a27c8;
// only svg for now.
var $5b78e83ec8a66d05$export$f84e8e69fd4488a5;

var $cy5px = parcelRequire("cy5px");

var $gzdAP = parcelRequire("gzdAP");

var $dsm43 = parcelRequire("dsm43");

var $dM4JI = parcelRequire("dM4JI");
function $5b78e83ec8a66d05$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$cy5px()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $gzdAP.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $gzdAP.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$5b78e83ec8a66d05$export$185802fd694ee1f5 = $gzdAP.create;
$5b78e83ec8a66d05$export$f87f6982d1fd4f81 = $5b78e83ec8a66d05$var$renderCanvas.bind(null, $dsm43.render);
$5b78e83ec8a66d05$export$723e4939e5a27c8 = $5b78e83ec8a66d05$var$renderCanvas.bind(null, $dsm43.renderToDataURL);
$5b78e83ec8a66d05$export$f84e8e69fd4488a5 = $5b78e83ec8a66d05$var$renderCanvas.bind(null, function(data, _, opts) {
    return $dM4JI.render(data, opts);
});

});
parcelRegister("cy5px", function(module, exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};

});

parcelRegister("gzdAP", function(module, exports) {

$parcel$export(module.exports, "create", () => $c0fa75802c08bb02$export$185802fd694ee1f5, (v) => $c0fa75802c08bb02$export$185802fd694ee1f5 = v);
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $c0fa75802c08bb02$export$185802fd694ee1f5;

var $j98yQ = parcelRequire("j98yQ");

var $k1tT4 = parcelRequire("k1tT4");

var $kRYYq = parcelRequire("kRYYq");

var $2LyZX = parcelRequire("2LyZX");

var $2TF8R = parcelRequire("2TF8R");

var $fapHe = parcelRequire("fapHe");

var $6dakX = parcelRequire("6dakX");

var $eN0fb = parcelRequire("eN0fb");

var $cQAO5 = parcelRequire("cQAO5");

var $gI0LP = parcelRequire("gI0LP");

var $kuXp2 = parcelRequire("kuXp2");

var $1jc42 = parcelRequire("1jc42");

var $ldDeC = parcelRequire("ldDeC");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c0fa75802c08bb02$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $fapHe.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $c0fa75802c08bb02$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c0fa75802c08bb02$var$setupAlignmentPattern(matrix, version) {
    const pos = $2TF8R.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c0fa75802c08bb02$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $gI0LP.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $c0fa75802c08bb02$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $kuXp2.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $c0fa75802c08bb02$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $c0fa75802c08bb02$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $kRYYq();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $1jc42.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $j98yQ.getSymbolTotalCodewords(version);
    const ecTotalCodewords = $eN0fb.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $c0fa75802c08bb02$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $c0fa75802c08bb02$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $j98yQ.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $eN0fb.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $eN0fb.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $cQAO5(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $c0fa75802c08bb02$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $ldDeC.fromArray(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $ldDeC.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $gI0LP.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $ldDeC.fromString(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $gI0LP.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $c0fa75802c08bb02$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $j98yQ.getSymbolSize(version);
    const modules = new $2LyZX(moduleCount);
    // Add function modules
    $c0fa75802c08bb02$var$setupFinderPattern(modules, version);
    $c0fa75802c08bb02$var$setupTimingPattern(modules);
    $c0fa75802c08bb02$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $c0fa75802c08bb02$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $c0fa75802c08bb02$var$setupVersionInfo(modules, version);
    // Add data codewords
    $c0fa75802c08bb02$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $6dakX.getBestMask(modules, $c0fa75802c08bb02$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $6dakX.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    $c0fa75802c08bb02$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$c0fa75802c08bb02$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $k1tT4.M;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $k1tT4.from(options.errorCorrectionLevel, $k1tT4.M);
        version = $gI0LP.from(options.version);
        mask = $6dakX.from(options.maskPattern);
        if (options.toSJISFunc) $j98yQ.setToSJISFunction(options.toSJISFunc);
    }
    return $c0fa75802c08bb02$var$createSymbol(data, version, errorCorrectionLevel, mask);
};

});
parcelRegister("j98yQ", function(module, exports) {

$parcel$export(module.exports, "getSymbolSize", () => $0398dce59eda23b6$export$8d4a06d3facd414b, (v) => $0398dce59eda23b6$export$8d4a06d3facd414b = v);
$parcel$export(module.exports, "getSymbolTotalCodewords", () => $0398dce59eda23b6$export$b05dac13c7a35c32, (v) => $0398dce59eda23b6$export$b05dac13c7a35c32 = v);
$parcel$export(module.exports, "getBCHDigit", () => $0398dce59eda23b6$export$ed1d66da50968976, (v) => $0398dce59eda23b6$export$ed1d66da50968976 = v);
$parcel$export(module.exports, "setToSJISFunction", () => $0398dce59eda23b6$export$6733b14783f975c2, (v) => $0398dce59eda23b6$export$6733b14783f975c2 = v);
$parcel$export(module.exports, "isKanjiModeEnabled", () => $0398dce59eda23b6$export$ce5b1274f8597fa0, (v) => $0398dce59eda23b6$export$ce5b1274f8597fa0 = v);
$parcel$export(module.exports, "toSJIS", () => $0398dce59eda23b6$export$43dd553ecded716d, (v) => $0398dce59eda23b6$export$43dd553ecded716d = v);
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $0398dce59eda23b6$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $0398dce59eda23b6$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $0398dce59eda23b6$export$ed1d66da50968976;
var $0398dce59eda23b6$export$6733b14783f975c2;
var $0398dce59eda23b6$export$ce5b1274f8597fa0;
var $0398dce59eda23b6$export$43dd553ecded716d;
let $0398dce59eda23b6$var$toSJISFunction;
const $0398dce59eda23b6$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$0398dce59eda23b6$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$0398dce59eda23b6$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $0398dce59eda23b6$var$CODEWORDS_COUNT[version];
};
$0398dce59eda23b6$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$0398dce59eda23b6$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $0398dce59eda23b6$var$toSJISFunction = f;
};
$0398dce59eda23b6$export$ce5b1274f8597fa0 = function() {
    return typeof $0398dce59eda23b6$var$toSJISFunction !== 'undefined';
};
$0398dce59eda23b6$export$43dd553ecded716d = function toSJIS(kanji) {
    return $0398dce59eda23b6$var$toSJISFunction(kanji);
};

});

parcelRegister("k1tT4", function(module, exports) {

$parcel$export(module.exports, "L", () => $e93b159af167de6a$export$61196ced6d74a310, (v) => $e93b159af167de6a$export$61196ced6d74a310 = v);
$parcel$export(module.exports, "M", () => $e93b159af167de6a$export$3a1a48c8f6ef640e, (v) => $e93b159af167de6a$export$3a1a48c8f6ef640e = v);
$parcel$export(module.exports, "Q", () => $e93b159af167de6a$export$3722cfe417b6ed86, (v) => $e93b159af167de6a$export$3722cfe417b6ed86 = v);
$parcel$export(module.exports, "H", () => $e93b159af167de6a$export$7f8ddf7c7c20b3cd, (v) => $e93b159af167de6a$export$7f8ddf7c7c20b3cd = v);
$parcel$export(module.exports, "isValid", () => $e93b159af167de6a$export$1ea939691cdc45b8, (v) => $e93b159af167de6a$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $e93b159af167de6a$export$6788812c4e6611e6, (v) => $e93b159af167de6a$export$6788812c4e6611e6 = v);
var $e93b159af167de6a$export$61196ced6d74a310;
var $e93b159af167de6a$export$3a1a48c8f6ef640e;
var $e93b159af167de6a$export$3722cfe417b6ed86;
var $e93b159af167de6a$export$7f8ddf7c7c20b3cd;
var $e93b159af167de6a$export$1ea939691cdc45b8;
var $e93b159af167de6a$export$6788812c4e6611e6;
$e93b159af167de6a$export$61196ced6d74a310 = {
    bit: 1
};
$e93b159af167de6a$export$3a1a48c8f6ef640e = {
    bit: 0
};
$e93b159af167de6a$export$3722cfe417b6ed86 = {
    bit: 3
};
$e93b159af167de6a$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $e93b159af167de6a$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $e93b159af167de6a$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $e93b159af167de6a$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $e93b159af167de6a$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $e93b159af167de6a$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$e93b159af167de6a$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$e93b159af167de6a$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($e93b159af167de6a$export$1ea939691cdc45b8(value)) return value;
    try {
        return $e93b159af167de6a$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});

parcelRegister("kRYYq", function(module, exports) {
function $f3180df86c0ceabb$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$f3180df86c0ceabb$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = $f3180df86c0ceabb$var$BitBuffer;

});

parcelRegister("2LyZX", function(module, exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $203b1e7b4160f407$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $203b1e7b4160f407$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $203b1e7b4160f407$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $203b1e7b4160f407$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $203b1e7b4160f407$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = $203b1e7b4160f407$var$BitMatrix;

});

parcelRegister("2TF8R", function(module, exports) {

$parcel$export(module.exports, "getRowColCoords", () => $21c0a1ba40f38d49$export$cb05537eb8e57a83, (v) => $21c0a1ba40f38d49$export$cb05537eb8e57a83 = v);
$parcel$export(module.exports, "getPositions", () => $21c0a1ba40f38d49$export$c39457c570f2b189, (v) => $21c0a1ba40f38d49$export$c39457c570f2b189 = v);
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $21c0a1ba40f38d49$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $21c0a1ba40f38d49$export$c39457c570f2b189;

var $j98yQ = parcelRequire("j98yQ");
var $21c0a1ba40f38d49$require$getSymbolSize = $j98yQ.getSymbolSize;
$21c0a1ba40f38d49$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $21c0a1ba40f38d49$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$21c0a1ba40f38d49$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $21c0a1ba40f38d49$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

});

parcelRegister("fapHe", function(module, exports) {

$parcel$export(module.exports, "getPositions", () => $b0abb8eaf11da0d6$export$c39457c570f2b189, (v) => $b0abb8eaf11da0d6$export$c39457c570f2b189 = v);
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b0abb8eaf11da0d6$export$c39457c570f2b189;

var $j98yQ = parcelRequire("j98yQ");
var $b0abb8eaf11da0d6$require$getSymbolSize = $j98yQ.getSymbolSize;
const $b0abb8eaf11da0d6$var$FINDER_PATTERN_SIZE = 7;
$b0abb8eaf11da0d6$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b0abb8eaf11da0d6$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b0abb8eaf11da0d6$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b0abb8eaf11da0d6$var$FINDER_PATTERN_SIZE
        ]
    ];
};

});

parcelRegister("6dakX", function(module, exports) {

$parcel$export(module.exports, "Patterns", () => $485bf9b125816a96$export$7ed115685df827af, (v) => $485bf9b125816a96$export$7ed115685df827af = v);
$parcel$export(module.exports, "isValid", () => $485bf9b125816a96$export$1ea939691cdc45b8, (v) => $485bf9b125816a96$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $485bf9b125816a96$export$6788812c4e6611e6, (v) => $485bf9b125816a96$export$6788812c4e6611e6 = v);
$parcel$export(module.exports, "getPenaltyN1", () => $485bf9b125816a96$export$a5fd3a02c14d0b3e, (v) => $485bf9b125816a96$export$a5fd3a02c14d0b3e = v);
$parcel$export(module.exports, "getPenaltyN2", () => $485bf9b125816a96$export$9a9385107a518e46, (v) => $485bf9b125816a96$export$9a9385107a518e46 = v);
$parcel$export(module.exports, "getPenaltyN3", () => $485bf9b125816a96$export$ade754353f0dc75e, (v) => $485bf9b125816a96$export$ade754353f0dc75e = v);
$parcel$export(module.exports, "getPenaltyN4", () => $485bf9b125816a96$export$3ff6f04d40d9962b, (v) => $485bf9b125816a96$export$3ff6f04d40d9962b = v);
$parcel$export(module.exports, "applyMask", () => $485bf9b125816a96$export$a1c9aa9c0e8ba394, (v) => $485bf9b125816a96$export$a1c9aa9c0e8ba394 = v);
$parcel$export(module.exports, "getBestMask", () => $485bf9b125816a96$export$fe9625aaceb0e563, (v) => $485bf9b125816a96$export$fe9625aaceb0e563 = v);
/**
 * Data mask pattern reference
 * @type {Object}
 */ var $485bf9b125816a96$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $485bf9b125816a96$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $485bf9b125816a96$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $485bf9b125816a96$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $485bf9b125816a96$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $485bf9b125816a96$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $485bf9b125816a96$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $485bf9b125816a96$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $485bf9b125816a96$export$fe9625aaceb0e563;
$485bf9b125816a96$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $485bf9b125816a96$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$485bf9b125816a96$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$485bf9b125816a96$export$6788812c4e6611e6 = function from(value) {
    return $485bf9b125816a96$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$485bf9b125816a96$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $485bf9b125816a96$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $485bf9b125816a96$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $485bf9b125816a96$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $485bf9b125816a96$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$485bf9b125816a96$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $485bf9b125816a96$var$PenaltyScores.N2;
};
$485bf9b125816a96$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $485bf9b125816a96$var$PenaltyScores.N3;
};
$485bf9b125816a96$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $485bf9b125816a96$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $485bf9b125816a96$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$485bf9b125816a96$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $485bf9b125816a96$var$getMaskAt(pattern, row, col));
    }
};
$485bf9b125816a96$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($485bf9b125816a96$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $485bf9b125816a96$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $485bf9b125816a96$export$a5fd3a02c14d0b3e(data) + $485bf9b125816a96$export$9a9385107a518e46(data) + $485bf9b125816a96$export$ade754353f0dc75e(data) + $485bf9b125816a96$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $485bf9b125816a96$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

});

parcelRegister("eN0fb", function(module, exports) {

$parcel$export(module.exports, "getBlocksCount", () => $ac45d4b63c43eb6c$export$41a1fc627aca72b9, (v) => $ac45d4b63c43eb6c$export$41a1fc627aca72b9 = v);
$parcel$export(module.exports, "getTotalCodewordsCount", () => $ac45d4b63c43eb6c$export$683d1b3e8a1a8438, (v) => $ac45d4b63c43eb6c$export$683d1b3e8a1a8438 = v);
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $ac45d4b63c43eb6c$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $ac45d4b63c43eb6c$export$683d1b3e8a1a8438;

var $k1tT4 = parcelRequire("k1tT4");
const $ac45d4b63c43eb6c$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $ac45d4b63c43eb6c$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$ac45d4b63c43eb6c$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $k1tT4.L:
            return $ac45d4b63c43eb6c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $k1tT4.M:
            return $ac45d4b63c43eb6c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $k1tT4.Q:
            return $ac45d4b63c43eb6c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $k1tT4.H:
            return $ac45d4b63c43eb6c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$ac45d4b63c43eb6c$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $k1tT4.L:
            return $ac45d4b63c43eb6c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $k1tT4.M:
            return $ac45d4b63c43eb6c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $k1tT4.Q:
            return $ac45d4b63c43eb6c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $k1tT4.H:
            return $ac45d4b63c43eb6c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

});

parcelRegister("cQAO5", function(module, exports) {

var $fVqx4 = parcelRequire("fVqx4");
function $95a6e47109151cdc$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $95a6e47109151cdc$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $fVqx4.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $95a6e47109151cdc$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $fVqx4.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = $95a6e47109151cdc$var$ReedSolomonEncoder;

});
parcelRegister("fVqx4", function(module, exports) {

$parcel$export(module.exports, "mul", () => $b980c2a582814d02$export$6e3a27864ab166fe, (v) => $b980c2a582814d02$export$6e3a27864ab166fe = v);
$parcel$export(module.exports, "mod", () => $b980c2a582814d02$export$842a2cf37af977e1, (v) => $b980c2a582814d02$export$842a2cf37af977e1 = v);
$parcel$export(module.exports, "generateECPolynomial", () => $b980c2a582814d02$export$7b8be06a973a9d05, (v) => $b980c2a582814d02$export$7b8be06a973a9d05 = v);
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $b980c2a582814d02$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $b980c2a582814d02$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $b980c2a582814d02$export$7b8be06a973a9d05;

var $9cX2v = parcelRequire("9cX2v");
$b980c2a582814d02$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $9cX2v.mul(p1[i], p2[j]);
    return coeff;
};
$b980c2a582814d02$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $9cX2v.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$b980c2a582814d02$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $b980c2a582814d02$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $9cX2v.exp(i)
    ]));
    return poly;
};

});
parcelRegister("9cX2v", function(module, exports) {

$parcel$export(module.exports, "exp", () => $6b43080ac02a0ec4$export$b310ec824aaee37f, (v) => $6b43080ac02a0ec4$export$b310ec824aaee37f = v);
$parcel$export(module.exports, "mul", () => $6b43080ac02a0ec4$export$6e3a27864ab166fe, (v) => $6b43080ac02a0ec4$export$6e3a27864ab166fe = v);
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $6b43080ac02a0ec4$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $6b43080ac02a0ec4$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $6b43080ac02a0ec4$export$6e3a27864ab166fe;
const $6b43080ac02a0ec4$var$EXP_TABLE = new Uint8Array(512);
const $6b43080ac02a0ec4$var$LOG_TABLE = new Uint8Array(256);
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $6b43080ac02a0ec4$var$EXP_TABLE[i] = x;
        $6b43080ac02a0ec4$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$6b43080ac02a0ec4$var$EXP_TABLE[i] = $6b43080ac02a0ec4$var$EXP_TABLE[i - 255];
})();
$6b43080ac02a0ec4$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $6b43080ac02a0ec4$var$LOG_TABLE[n];
};
$6b43080ac02a0ec4$export$b310ec824aaee37f = function exp(n) {
    return $6b43080ac02a0ec4$var$EXP_TABLE[n];
};
$6b43080ac02a0ec4$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $6b43080ac02a0ec4$var$EXP_TABLE[$6b43080ac02a0ec4$var$LOG_TABLE[x] + $6b43080ac02a0ec4$var$LOG_TABLE[y]];
};

});



parcelRegister("gI0LP", function(module, exports) {

$parcel$export(module.exports, "getCapacity", () => $c2a15a5f7cdacb92$export$55b283886ec2d3fb, (v) => $c2a15a5f7cdacb92$export$55b283886ec2d3fb = v);
$parcel$export(module.exports, "from", () => $c2a15a5f7cdacb92$export$6788812c4e6611e6, (v) => $c2a15a5f7cdacb92$export$6788812c4e6611e6 = v);
$parcel$export(module.exports, "getBestVersionForData", () => $c2a15a5f7cdacb92$export$264e969aa7a8ff7e, (v) => $c2a15a5f7cdacb92$export$264e969aa7a8ff7e = v);
$parcel$export(module.exports, "getEncodedBits", () => $c2a15a5f7cdacb92$export$eee5438974ef6f0e, (v) => $c2a15a5f7cdacb92$export$eee5438974ef6f0e = v);
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $c2a15a5f7cdacb92$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $c2a15a5f7cdacb92$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $c2a15a5f7cdacb92$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $c2a15a5f7cdacb92$export$eee5438974ef6f0e;

var $j98yQ = parcelRequire("j98yQ");

var $eN0fb = parcelRequire("eN0fb");

var $k1tT4 = parcelRequire("k1tT4");

var $1jc42 = parcelRequire("1jc42");

var $11n8D = parcelRequire("11n8D");
// Generator polynomial used to encode version information
const $c2a15a5f7cdacb92$var$G18 = 7973;
const $c2a15a5f7cdacb92$var$G18_BCH = $j98yQ.getBCHDigit($c2a15a5f7cdacb92$var$G18);
function $c2a15a5f7cdacb92$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $c2a15a5f7cdacb92$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $c2a15a5f7cdacb92$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $1jc42.getCharCountIndicator(mode, version) + 4;
}
function $c2a15a5f7cdacb92$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $c2a15a5f7cdacb92$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $c2a15a5f7cdacb92$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $c2a15a5f7cdacb92$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $c2a15a5f7cdacb92$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $1jc42.MIXED)) return currentVersion;
    }
    return undefined;
}
$c2a15a5f7cdacb92$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($11n8D.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
$c2a15a5f7cdacb92$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$11n8D.isValid(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $1jc42.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $j98yQ.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $eN0fb.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $1jc42.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $c2a15a5f7cdacb92$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $1jc42.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case $1jc42.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case $1jc42.KANJI:
            return Math.floor(usableBits / 13);
        case $1jc42.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
$c2a15a5f7cdacb92$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $k1tT4.from(errorCorrectionLevel, $k1tT4.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return $c2a15a5f7cdacb92$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $c2a15a5f7cdacb92$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$c2a15a5f7cdacb92$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$11n8D.isValid(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($j98yQ.getBCHDigit(d) - $c2a15a5f7cdacb92$var$G18_BCH >= 0)d ^= $c2a15a5f7cdacb92$var$G18 << $j98yQ.getBCHDigit(d) - $c2a15a5f7cdacb92$var$G18_BCH;
    return version << 12 | d;
};

});
parcelRegister("1jc42", function(module, exports) {

$parcel$export(module.exports, "NUMERIC", () => $0f40ec75b63781e9$export$4d318981b5a83836, (v) => $0f40ec75b63781e9$export$4d318981b5a83836 = v);
$parcel$export(module.exports, "ALPHANUMERIC", () => $0f40ec75b63781e9$export$376a9ed239d6c1c8, (v) => $0f40ec75b63781e9$export$376a9ed239d6c1c8 = v);
$parcel$export(module.exports, "BYTE", () => $0f40ec75b63781e9$export$8f4bf8f7eb581284, (v) => $0f40ec75b63781e9$export$8f4bf8f7eb581284 = v);
$parcel$export(module.exports, "KANJI", () => $0f40ec75b63781e9$export$a4d452c2363c8e12, (v) => $0f40ec75b63781e9$export$a4d452c2363c8e12 = v);
$parcel$export(module.exports, "MIXED", () => $0f40ec75b63781e9$export$bb410559a65d3418, (v) => $0f40ec75b63781e9$export$bb410559a65d3418 = v);
$parcel$export(module.exports, "getCharCountIndicator", () => $0f40ec75b63781e9$export$e79764af6ffaeb8d, (v) => $0f40ec75b63781e9$export$e79764af6ffaeb8d = v);
$parcel$export(module.exports, "getBestModeForData", () => $0f40ec75b63781e9$export$1bd4c93ffb42e55e, (v) => $0f40ec75b63781e9$export$1bd4c93ffb42e55e = v);
$parcel$export(module.exports, "toString", () => $0f40ec75b63781e9$export$f84e8e69fd4488a5, (v) => $0f40ec75b63781e9$export$f84e8e69fd4488a5 = v);
$parcel$export(module.exports, "isValid", () => $0f40ec75b63781e9$export$1ea939691cdc45b8, (v) => $0f40ec75b63781e9$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $0f40ec75b63781e9$export$6788812c4e6611e6, (v) => $0f40ec75b63781e9$export$6788812c4e6611e6 = v);
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $0f40ec75b63781e9$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $0f40ec75b63781e9$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $0f40ec75b63781e9$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $0f40ec75b63781e9$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $0f40ec75b63781e9$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $0f40ec75b63781e9$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $0f40ec75b63781e9$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $0f40ec75b63781e9$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $0f40ec75b63781e9$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $0f40ec75b63781e9$export$6788812c4e6611e6;

var $11n8D = parcelRequire("11n8D");

var $8gKF5 = parcelRequire("8gKF5");
$0f40ec75b63781e9$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$0f40ec75b63781e9$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$0f40ec75b63781e9$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$0f40ec75b63781e9$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$0f40ec75b63781e9$export$bb410559a65d3418 = {
    bit: -1
};
$0f40ec75b63781e9$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$11n8D.isValid(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$0f40ec75b63781e9$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($8gKF5.testNumeric(dataStr)) return $0f40ec75b63781e9$export$4d318981b5a83836;
    else if ($8gKF5.testAlphanumeric(dataStr)) return $0f40ec75b63781e9$export$376a9ed239d6c1c8;
    else if ($8gKF5.testKanji(dataStr)) return $0f40ec75b63781e9$export$a4d452c2363c8e12;
    else return $0f40ec75b63781e9$export$8f4bf8f7eb581284;
};
$0f40ec75b63781e9$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$0f40ec75b63781e9$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $0f40ec75b63781e9$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $0f40ec75b63781e9$export$4d318981b5a83836;
        case 'alphanumeric':
            return $0f40ec75b63781e9$export$376a9ed239d6c1c8;
        case 'kanji':
            return $0f40ec75b63781e9$export$a4d452c2363c8e12;
        case 'byte':
            return $0f40ec75b63781e9$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$0f40ec75b63781e9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($0f40ec75b63781e9$export$1ea939691cdc45b8(value)) return value;
    try {
        return $0f40ec75b63781e9$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});
parcelRegister("11n8D", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $0be7d5325bc34cbb$export$1ea939691cdc45b8, (v) => $0be7d5325bc34cbb$export$1ea939691cdc45b8 = v);
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $0be7d5325bc34cbb$export$1ea939691cdc45b8;
$0be7d5325bc34cbb$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

});

parcelRegister("8gKF5", function(module, exports) {

$parcel$export(module.exports, "KANJI", () => $605403682d036054$export$a4d452c2363c8e12, (v) => $605403682d036054$export$a4d452c2363c8e12 = v);
$parcel$export(module.exports, "BYTE_KANJI", () => $605403682d036054$export$9df7c29d562bab83, (v) => $605403682d036054$export$9df7c29d562bab83 = v);
$parcel$export(module.exports, "BYTE", () => $605403682d036054$export$8f4bf8f7eb581284, (v) => $605403682d036054$export$8f4bf8f7eb581284 = v);
$parcel$export(module.exports, "NUMERIC", () => $605403682d036054$export$4d318981b5a83836, (v) => $605403682d036054$export$4d318981b5a83836 = v);
$parcel$export(module.exports, "ALPHANUMERIC", () => $605403682d036054$export$376a9ed239d6c1c8, (v) => $605403682d036054$export$376a9ed239d6c1c8 = v);
$parcel$export(module.exports, "testKanji", () => $605403682d036054$export$175f16aef75a4569, (v) => $605403682d036054$export$175f16aef75a4569 = v);
$parcel$export(module.exports, "testNumeric", () => $605403682d036054$export$50b7f9bf92c74274, (v) => $605403682d036054$export$50b7f9bf92c74274 = v);
$parcel$export(module.exports, "testAlphanumeric", () => $605403682d036054$export$4ba5f52893b4ac97, (v) => $605403682d036054$export$4ba5f52893b4ac97 = v);
var $605403682d036054$export$a4d452c2363c8e12;
var $605403682d036054$export$9df7c29d562bab83;
var $605403682d036054$export$8f4bf8f7eb581284;
var $605403682d036054$export$4d318981b5a83836;
var $605403682d036054$export$376a9ed239d6c1c8;
var $605403682d036054$export$175f16aef75a4569;
var $605403682d036054$export$50b7f9bf92c74274;
var $605403682d036054$export$4ba5f52893b4ac97;
const $605403682d036054$var$numeric = '[0-9]+';
const $605403682d036054$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $605403682d036054$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$605403682d036054$var$kanji = $605403682d036054$var$kanji.replace(/u/g, '\\u');
const $605403682d036054$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $605403682d036054$var$kanji + ')(?:.|[\r\n]))+';
$605403682d036054$export$a4d452c2363c8e12 = new RegExp($605403682d036054$var$kanji, 'g');
$605403682d036054$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$605403682d036054$export$8f4bf8f7eb581284 = new RegExp($605403682d036054$var$byte, 'g');
$605403682d036054$export$4d318981b5a83836 = new RegExp($605403682d036054$var$numeric, 'g');
$605403682d036054$export$376a9ed239d6c1c8 = new RegExp($605403682d036054$var$alphanumeric, 'g');
const $605403682d036054$var$TEST_KANJI = new RegExp('^' + $605403682d036054$var$kanji + '$');
const $605403682d036054$var$TEST_NUMERIC = new RegExp('^' + $605403682d036054$var$numeric + '$');
const $605403682d036054$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$605403682d036054$export$175f16aef75a4569 = function testKanji(str) {
    return $605403682d036054$var$TEST_KANJI.test(str);
};
$605403682d036054$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $605403682d036054$var$TEST_NUMERIC.test(str);
};
$605403682d036054$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $605403682d036054$var$TEST_ALPHANUMERIC.test(str);
};

});



parcelRegister("kuXp2", function(module, exports) {

$parcel$export(module.exports, "getEncodedBits", () => $eec4b025674c15ee$export$eee5438974ef6f0e, (v) => $eec4b025674c15ee$export$eee5438974ef6f0e = v);
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $eec4b025674c15ee$export$eee5438974ef6f0e;

var $j98yQ = parcelRequire("j98yQ");
const $eec4b025674c15ee$var$G15 = 1335;
const $eec4b025674c15ee$var$G15_MASK = 21522;
const $eec4b025674c15ee$var$G15_BCH = $j98yQ.getBCHDigit($eec4b025674c15ee$var$G15);
$eec4b025674c15ee$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($j98yQ.getBCHDigit(d) - $eec4b025674c15ee$var$G15_BCH >= 0)d ^= $eec4b025674c15ee$var$G15 << $j98yQ.getBCHDigit(d) - $eec4b025674c15ee$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $eec4b025674c15ee$var$G15_MASK;
};

});

parcelRegister("ldDeC", function(module, exports) {

$parcel$export(module.exports, "fromArray", () => $f7293f1a856f5fa9$export$571d59b505e6bb4e, (v) => $f7293f1a856f5fa9$export$571d59b505e6bb4e = v);
$parcel$export(module.exports, "fromString", () => $f7293f1a856f5fa9$export$3004f64547af360e, (v) => $f7293f1a856f5fa9$export$3004f64547af360e = v);
$parcel$export(module.exports, "rawSplit", () => $f7293f1a856f5fa9$export$89ab1afb9839589b, (v) => $f7293f1a856f5fa9$export$89ab1afb9839589b = v);
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $f7293f1a856f5fa9$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $f7293f1a856f5fa9$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $f7293f1a856f5fa9$export$89ab1afb9839589b;

var $1jc42 = parcelRequire("1jc42");

var $gEPuf = parcelRequire("gEPuf");

var $cGIMD = parcelRequire("cGIMD");

var $5pKEd = parcelRequire("5pKEd");

var $ayZEe = parcelRequire("ayZEe");

var $8gKF5 = parcelRequire("8gKF5");

var $j98yQ = parcelRequire("j98yQ");

var $2xicJ = parcelRequire("2xicJ");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $f7293f1a856f5fa9$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $f7293f1a856f5fa9$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $f7293f1a856f5fa9$var$getSegmentsFromString(dataStr) {
    const numSegs = $f7293f1a856f5fa9$var$getSegments($8gKF5.NUMERIC, $1jc42.NUMERIC, dataStr);
    const alphaNumSegs = $f7293f1a856f5fa9$var$getSegments($8gKF5.ALPHANUMERIC, $1jc42.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($j98yQ.isKanjiModeEnabled()) {
        byteSegs = $f7293f1a856f5fa9$var$getSegments($8gKF5.BYTE, $1jc42.BYTE, dataStr);
        kanjiSegs = $f7293f1a856f5fa9$var$getSegments($8gKF5.KANJI, $1jc42.KANJI, dataStr);
    } else {
        byteSegs = $f7293f1a856f5fa9$var$getSegments($8gKF5.BYTE_KANJI, $1jc42.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $f7293f1a856f5fa9$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $1jc42.NUMERIC:
            return $gEPuf.getBitsLength(length);
        case $1jc42.ALPHANUMERIC:
            return $cGIMD.getBitsLength(length);
        case $1jc42.KANJI:
            return $ayZEe.getBitsLength(length);
        case $1jc42.BYTE:
            return $5pKEd.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $f7293f1a856f5fa9$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $f7293f1a856f5fa9$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $1jc42.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $1jc42.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $1jc42.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $1jc42.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $1jc42.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $1jc42.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $1jc42.BYTE,
                        length: $f7293f1a856f5fa9$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $1jc42.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $1jc42.BYTE,
                        length: $f7293f1a856f5fa9$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $f7293f1a856f5fa9$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $f7293f1a856f5fa9$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $f7293f1a856f5fa9$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $f7293f1a856f5fa9$var$getSegmentBitsLength(node.length, node.mode) + 4 + $1jc42.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $f7293f1a856f5fa9$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $1jc42.getBestModeForData(data);
    mode = $1jc42.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $1jc42.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $1jc42.toString(mode) + '.\n Suggested mode is: ' + $1jc42.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $1jc42.KANJI && !$j98yQ.isKanjiModeEnabled()) mode = $1jc42.BYTE;
    switch(mode){
        case $1jc42.NUMERIC:
            return new $gEPuf(data);
        case $1jc42.ALPHANUMERIC:
            return new $cGIMD(data);
        case $1jc42.KANJI:
            return new $ayZEe(data);
        case $1jc42.BYTE:
            return new $5pKEd(data);
    }
}
$f7293f1a856f5fa9$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($f7293f1a856f5fa9$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($f7293f1a856f5fa9$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$f7293f1a856f5fa9$export$3004f64547af360e = function fromString(data, version) {
    const segs = $f7293f1a856f5fa9$var$getSegmentsFromString(data, $j98yQ.isKanjiModeEnabled());
    const nodes = $f7293f1a856f5fa9$var$buildNodes(segs);
    const graph = $f7293f1a856f5fa9$var$buildGraph(nodes, version);
    const path = $2xicJ.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $f7293f1a856f5fa9$export$571d59b505e6bb4e($f7293f1a856f5fa9$var$mergeSegments(optimizedSegs));
};
$f7293f1a856f5fa9$export$89ab1afb9839589b = function rawSplit(data) {
    return $f7293f1a856f5fa9$export$571d59b505e6bb4e($f7293f1a856f5fa9$var$getSegmentsFromString(data, $j98yQ.isKanjiModeEnabled()));
};

});
parcelRegister("gEPuf", function(module, exports) {

var $1jc42 = parcelRequire("1jc42");
function $c20851f99b1b9cf4$var$NumericData(data) {
    this.mode = $1jc42.NUMERIC;
    this.data = data.toString();
}
$c20851f99b1b9cf4$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$c20851f99b1b9cf4$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$c20851f99b1b9cf4$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $c20851f99b1b9cf4$var$NumericData.getBitsLength(this.data.length);
};
$c20851f99b1b9cf4$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = $c20851f99b1b9cf4$var$NumericData;

});

parcelRegister("cGIMD", function(module, exports) {

var $1jc42 = parcelRequire("1jc42");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $93cc2552c8ebb01c$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $93cc2552c8ebb01c$var$AlphanumericData(data) {
    this.mode = $1jc42.ALPHANUMERIC;
    this.data = data;
}
$93cc2552c8ebb01c$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$93cc2552c8ebb01c$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$93cc2552c8ebb01c$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $93cc2552c8ebb01c$var$AlphanumericData.getBitsLength(this.data.length);
};
$93cc2552c8ebb01c$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $93cc2552c8ebb01c$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $93cc2552c8ebb01c$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($93cc2552c8ebb01c$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = $93cc2552c8ebb01c$var$AlphanumericData;

});

parcelRegister("5pKEd", function(module, exports) {

var $1jc42 = parcelRequire("1jc42");
function $3f1378cabd048ecd$var$ByteData(data) {
    this.mode = $1jc42.BYTE;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$3f1378cabd048ecd$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$3f1378cabd048ecd$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$3f1378cabd048ecd$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $3f1378cabd048ecd$var$ByteData.getBitsLength(this.data.length);
};
$3f1378cabd048ecd$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = $3f1378cabd048ecd$var$ByteData;

});

parcelRegister("ayZEe", function(module, exports) {

var $1jc42 = parcelRequire("1jc42");

var $j98yQ = parcelRequire("j98yQ");
function $7b0ce656f6dbf71c$var$KanjiData(data) {
    this.mode = $1jc42.KANJI;
    this.data = data;
}
$7b0ce656f6dbf71c$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$7b0ce656f6dbf71c$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7b0ce656f6dbf71c$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $7b0ce656f6dbf71c$var$KanjiData.getBitsLength(this.data.length);
};
$7b0ce656f6dbf71c$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $j98yQ.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = $7b0ce656f6dbf71c$var$KanjiData;

});

parcelRegister("2xicJ", function(module, exports) {
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $1d8cc8d2fa58fb5b$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $1d8cc8d2fa58fb5b$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $1d8cc8d2fa58fb5b$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $1d8cc8d2fa58fb5b$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $1d8cc8d2fa58fb5b$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = $1d8cc8d2fa58fb5b$var$dijkstra;

});



parcelRegister("dsm43", function(module, exports) {

$parcel$export(module.exports, "render", () => $9cbf01708baf91b3$export$b3890eb0ae9dca99, (v) => $9cbf01708baf91b3$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "renderToDataURL", () => $9cbf01708baf91b3$export$c3e5526bbaf70a25, (v) => $9cbf01708baf91b3$export$c3e5526bbaf70a25 = v);
var $9cbf01708baf91b3$export$b3890eb0ae9dca99;
var $9cbf01708baf91b3$export$c3e5526bbaf70a25;

var $4Qdpq = parcelRequire("4Qdpq");
function $9cbf01708baf91b3$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $9cbf01708baf91b3$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$9cbf01708baf91b3$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $9cbf01708baf91b3$var$getCanvasElement();
    opts = $4Qdpq.getOptions(opts);
    const size = $4Qdpq.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $4Qdpq.qrToImageData(image.data, qrData, opts);
    $9cbf01708baf91b3$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$9cbf01708baf91b3$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $9cbf01708baf91b3$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

});
parcelRegister("4Qdpq", function(module, exports) {

$parcel$export(module.exports, "getOptions", () => $38666b850b8546b7$export$d2312e68e1f5ad00, (v) => $38666b850b8546b7$export$d2312e68e1f5ad00 = v);
$parcel$export(module.exports, "getScale", () => $38666b850b8546b7$export$5cdac61cf538712e, (v) => $38666b850b8546b7$export$5cdac61cf538712e = v);
$parcel$export(module.exports, "getImageWidth", () => $38666b850b8546b7$export$c3a1a1f268a8142b, (v) => $38666b850b8546b7$export$c3a1a1f268a8142b = v);
$parcel$export(module.exports, "qrToImageData", () => $38666b850b8546b7$export$83136f57c739c5f3, (v) => $38666b850b8546b7$export$83136f57c739c5f3 = v);
var $38666b850b8546b7$export$d2312e68e1f5ad00;
var $38666b850b8546b7$export$5cdac61cf538712e;
var $38666b850b8546b7$export$c3a1a1f268a8142b;
var $38666b850b8546b7$export$83136f57c739c5f3;
function $38666b850b8546b7$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$38666b850b8546b7$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $38666b850b8546b7$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $38666b850b8546b7$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$38666b850b8546b7$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$38666b850b8546b7$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $38666b850b8546b7$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$38666b850b8546b7$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $38666b850b8546b7$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

});


parcelRegister("dM4JI", function(module, exports) {

$parcel$export(module.exports, "render", () => $a0736e989f732944$export$b3890eb0ae9dca99, (v) => $a0736e989f732944$export$b3890eb0ae9dca99 = v);
var $a0736e989f732944$export$b3890eb0ae9dca99;

var $4Qdpq = parcelRequire("4Qdpq");
function $a0736e989f732944$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $a0736e989f732944$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $a0736e989f732944$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $a0736e989f732944$var$svgCmd('M', col + margin, 0.5 + row + margin) : $a0736e989f732944$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $a0736e989f732944$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$a0736e989f732944$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $4Qdpq.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $a0736e989f732944$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $a0736e989f732944$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $a0736e989f732944$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};

});


parcelRegister("85RVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $218717c20dbad67e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $218717c20dbad67e$var$Animation2 = ({ color: color, loaderColor: loaderColor, backgroundColor: backgroundColor })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        "aria-hidden": "true",
        className: "rf-inline rf-w-8 rf-h-8 rf-mr-2 rf-animate-spin ",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            backgroundColor: backgroundColor
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "currentColor",
                style: {
                    fill: color
                }
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentFill",
                style: {
                    fill: loaderColor
                }
            })
        ]
    });
};
var $218717c20dbad67e$export$2e2bcd8739ae039 = $218717c20dbad67e$var$Animation2;

});

parcelRegister("8e5cw", function(module, exports) {

$parcel$export(module.exports, "default", () => $299cb4e81f4790c2$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $299cb4e81f4790c2$var$QRCodeComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).forwardRef(({ src: src, alt: alt, largeMaxHeight: largeMaxHeight }, ref)=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
        ref: ref,
        src: src,
        className: `rf-h-full ${largeMaxHeight ? 'rf-max-h-qrcodelarge' : 'rf-max-h-qrcode'}`,
        alt: alt || 'QR Code'
    });
});
var $299cb4e81f4790c2$export$2e2bcd8739ae039 = $299cb4e81f4790c2$var$QRCodeComponent;

});

parcelRegister("hiuUm", function(module, exports) {
module.exports = $parcel$import("9tXeG").then(()=>parcelRequire('7fviB'));

});

parcelRegister("VZzOq", function(module, exports) {

$parcel$export(module.exports, "default", () => $926afd8270ce2c83$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $lOuaH = parcelRequire("lOuaH");

var $5h4it = parcelRequire("5h4it");

var $gR5Co = parcelRequire("gR5Co");
const $926afd8270ce2c83$var$Background = ({ config: config, videoLoop: videoLoop, videoMuted: videoMuted, onVideoEnded: onVideoEnded, onVideoCanPlay: onVideoCanPlay })=>{
    const webcamRotation = (0, $5FZWK.useSelector)((state)=>state.viewReducer.configurations.webcamRotation);
    const imageRef = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(imageRef);
    const [videoDimensions, setVideoDimensions] = (0, $bxRTa.useState)(dimensions);
    const [webcamStyle, setWebcamStyle] = (0, $bxRTa.useState)({});
    (0, $bxRTa.useEffect)(()=>{
        if (config.style === 'webcam') {
            if (!webcamRotation || webcamRotation % 180 === 0) setVideoDimensions(dimensions);
            else setVideoDimensions({
                height: dimensions.width,
                width: dimensions.height
            });
        }
    }, [
        config.style,
        dimensions
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(webcamRotation){
            case 90:
                setWebcamStyle({
                    width: '100vh',
                    height: '100vw',
                    transform: 'rotate(90deg)'
                });
                break;
            case -90:
                setWebcamStyle({
                    width: '100vh',
                    height: '100vw',
                    transform: 'rotate(-90deg)'
                });
                break;
            case 180:
                setWebcamStyle({
                    transform: 'rotate(180deg)'
                });
                break;
            default:
                setWebcamStyle({});
                break;
        }
    }, [
        webcamRotation
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            config.style === 'image' && config.image && /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                ref: imageRef,
                src: config.image,
                alt: "background image",
                className: "rf-col-span-full rf-row-span-full rf-w-full rf-h-full rf-object-cover rf-filter rf-blur-background"
            }),
            config.style === 'video' && config.video && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5h4it.default), {
                source: config.video,
                loop: !!videoLoop,
                muted: !!videoMuted,
                onVideoEnded: onVideoEnded,
                onVideoCanPlay: onVideoCanPlay
            }),
            config.style === 'webcam' && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $gR5Co.default), {
                config: config.webcam,
                size: videoDimensions,
                style: webcamStyle
            })
        ]
    });
};
var $926afd8270ce2c83$export$2e2bcd8739ae039 = $926afd8270ce2c83$var$Background;

});
parcelRegister("lOuaH", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc1b66e17ac36733$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
/**
 * Use javascript ResizeOberver object to catch element's resize and return current size
 * @param {React.RefObject<HTMLElement>} ref element for which we want to get the size when resized
 * @returns {Dimensions} dimension data (width, height)
 */ const $dc1b66e17ac36733$var$useRefDimensions = (ref)=>{
    const [dimensions, setDimensions] = (0, $bxRTa.useState)({
        width: 1,
        height: 1
    });
    const [observer, setObserver] = (0, $bxRTa.useState)();
    const handleResizeObserverTick = (entries)=>{
        entries.length && entries[0].contentBoxSize.length && setDimensions({
            width: entries[0].contentBoxSize[0].inlineSize,
            height: entries[0].contentBoxSize[0].blockSize
        });
    };
    (0, $bxRTa.useLayoutEffect)(()=>{
        if (!observer) {
            const obs = new ResizeObserver(handleResizeObserverTick);
            if (ref?.current) {
                obs.observe(ref.current);
                setObserver(obs);
            }
        }
        return ()=>{
            observer?.disconnect();
        };
    }, []);
    return dimensions;
};
var $dc1b66e17ac36733$export$2e2bcd8739ae039 = $dc1b66e17ac36733$var$useRefDimensions;

});

parcelRegister("5h4it", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4cef58725b0107$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
const $7c4cef58725b0107$var$BackgroundVideo = ({ source: source, style: style, loop: loop, muted: muted, onVideoEnded: onVideoEnded, onVideoCanPlay: onVideoCanPlay })=>{
    const currentHeight = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentHeight);
    const currentWidth = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentWidth);
    const videoRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.load();
            videoRef.current.play().catch((e)=>console.warn(e));
        }
    }, [
        videoRef
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("video", {
        ref: videoRef,
        id: "retorik-background-video",
        className: "rf-relative rf-col-span-full rf-row-span-full rf-object-cover rf-overflow-hidden rf-filter rf-blur-background",
        onEnded: onVideoEnded,
        onError: onVideoEnded,
        onCanPlay: onVideoCanPlay,
        autoPlay: true,
        loop: loop,
        muted: muted,
        playsInline: true,
        style: {
            ...style,
            height: currentHeight,
            width: currentWidth
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("source", {
            src: source
        })
    });
};
var $7c4cef58725b0107$export$2e2bcd8739ae039 = $7c4cef58725b0107$var$BackgroundVideo;

});

parcelRegister("gR5Co", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f7f67914ca455d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $43f7f67914ca455d$var$BackgroundWebcam = ({ config: config, size: size, style: style })=>{
    const videoRef = (0, $bxRTa.useRef)(null);
    const setSource = (constraints)=>{
        navigator.mediaDevices.getUserMedia(constraints).then((stream)=>{
            if (videoRef.current) videoRef.current.srcObject = stream;
        }).catch((error)=>console.warn('Retorik Framework > an error occured when trying to use the webcam : ', error));
    };
    (0, $bxRTa.useEffect)(()=>{
        setSource({
            video: {
                facingMode: config === 'back' ? {
                    exact: 'environment'
                } : config === 'front' ? 'user' : undefined,
                deviceId: [
                    'back',
                    'front',
                    undefined
                ].includes(config) ? undefined : config,
                ...size
            }
        });
    }, [
        config,
        size
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("video", {
        ref: videoRef,
        id: "retorik-background-webcam",
        className: "rf-relative rf-col-span-full rf-row-span-full rf-overflow-hidden rf-max-w-none rf-w-screen rf-h-screen rf-filter rf-blur-background rf-border rf-self-center rf-justify-self-center rf-object-cover rf-origin-center",
        style: {
            ...style
        },
        autoPlay: true,
        muted: true,
        playsInline: true
    });
};
var $43f7f67914ca455d$export$2e2bcd8739ae039 = $43f7f67914ca455d$var$BackgroundWebcam;

});


parcelRegister("5bTjo", function(module, exports) {
$parcel$export(module.exports, "easings", () => (parcelRequire("2aMjv")).easings);
$parcel$export(module.exports, "Globals", () => (parcelRequire("2aMjv")).Globals);
$parcel$export(module.exports, "useSpring", () => (parcelRequire("hzlaD")).useSpring);

$parcel$export(module.exports, "animated", () => $5731f2f135da08c2$export$407448d2b89b1813);
// src/index.ts
parcelRequire("hzlaD");
var $2aMjv = parcelRequire("2aMjv");

var $aRBoq = parcelRequire("aRBoq");

var $2aMjv = parcelRequire("2aMjv");

var $b1Sgt = parcelRequire("b1Sgt");
// src/applyAnimatedValues.ts
var $5731f2f135da08c2$var$isCustomPropRE = /^--/;
function $5731f2f135da08c2$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$5731f2f135da08c2$var$isCustomPropRE.test(name) && !($5731f2f135da08c2$var$isUnitlessNumber.hasOwnProperty(name) && $5731f2f135da08c2$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $5731f2f135da08c2$var$attributeCache = {};
function $5731f2f135da08c2$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $5731f2f135da08c2$var$attributeCache[name] || ($5731f2f135da08c2$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $5731f2f135da08c2$var$dangerousStyleValue(name, style[name]);
        if ($5731f2f135da08c2$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $5731f2f135da08c2$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $5731f2f135da08c2$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $5731f2f135da08c2$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$5731f2f135da08c2$var$isUnitlessNumber = Object.keys($5731f2f135da08c2$var$isUnitlessNumber).reduce((acc, prop)=>{
    $5731f2f135da08c2$var$prefixes.forEach((prefix)=>acc[$5731f2f135da08c2$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $5731f2f135da08c2$var$isUnitlessNumber);
var $5731f2f135da08c2$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $5731f2f135da08c2$var$pxTransforms = /^(translate)/;
var $5731f2f135da08c2$var$degTransforms = /^(rotate|skew)/;
var $5731f2f135da08c2$var$addUnit = (value, unit)=>(0, $2aMjv.is).num(value) && value !== 0 ? value + unit : value;
var $5731f2f135da08c2$var$isValueIdentity = (value, id)=>(0, $2aMjv.is).arr(value) ? value.every((v)=>$5731f2f135da08c2$var$isValueIdentity(v, id)) : (0, $2aMjv.is).num(value) ? value === id : parseFloat(value) === id;
var $5731f2f135da08c2$var$AnimatedStyle = class extends (0, $b1Sgt.AnimatedObject) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$5731f2f135da08c2$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $5731f2f135da08c2$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $2aMjv.eachProp)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($5731f2f135da08c2$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $2aMjv.is).und(value)) return;
                const unit = $5731f2f135da08c2$var$pxTransforms.test(key) ? "px" : $5731f2f135da08c2$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $2aMjv.toArray)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$5731f2f135da08c2$var$addUnit(deg, unit)})`,
                        $5731f2f135da08c2$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$5731f2f135da08c2$var$addUnit(v, unit)).join(",")})`,
                        $5731f2f135da08c2$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $5731f2f135da08c2$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $5731f2f135da08c2$var$FluidTransform = class extends (0, $2aMjv.FluidValue) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $2aMjv.each)(this.inputs, (input, i)=>{
            const arg1 = (0, $2aMjv.getFluidValue)(input[0]);
            const [t, id] = this.transforms[i]((0, $2aMjv.is).arr(arg1) ? arg1 : input.map((0, $2aMjv.getFluidValue)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $2aMjv.each)(this.inputs, (input)=>(0, $2aMjv.each)(input, (value)=>(0, $2aMjv.hasFluidValue)(value) && (0, $2aMjv.addFluidObserver)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $2aMjv.each)(this.inputs, (input)=>(0, $2aMjv.each)(input, (value)=>(0, $2aMjv.hasFluidValue)(value) && (0, $2aMjv.removeFluidObserver)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $2aMjv.callFluidObservers)(this, event);
    }
};
// src/primitives.ts
var $5731f2f135da08c2$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $2aMjv.Globals).assign({
    batchedUpdates: (0, $aRBoq.unstable_batchedUpdates),
    createStringInterpolator: $2aMjv.createStringInterpolator,
    colors: $2aMjv.colors
});
var $5731f2f135da08c2$var$host = (0, $b1Sgt.createHost)($5731f2f135da08c2$var$primitives, {
    applyAnimatedValues: $5731f2f135da08c2$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $5731f2f135da08c2$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $5731f2f135da08c2$export$407448d2b89b1813 = $5731f2f135da08c2$var$host.animated;

});
parcelRegister("hzlaD", function(module, exports) {

$parcel$export(module.exports, "useSpring", () => $8197315a05dcadae$export$c4af9125706c4d30);
$parcel$export(module.exports, "Globals", () => (parcelRequire("2aMjv")).Globals);
$parcel$export(module.exports, "easings", () => (parcelRequire("2aMjv")).easings);
// src/hooks/useChain.ts

var $2aMjv = parcelRequire("2aMjv");
var $gtRA1 = parcelRequire("gtRA1");

var $bxRTa = parcelRequire("bxRTa");

var $b1Sgt = parcelRequire("b1Sgt");
parcelRequire("5od7d");
function $8197315a05dcadae$var$callProp(value, ...args) {
    return (0, $2aMjv.is).fun(value) ? value(...args) : value;
}
var $8197315a05dcadae$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $2aMjv.is).fun(value) ? value(key) : (0, $2aMjv.toArray)(value).includes(key)));
var $8197315a05dcadae$var$resolveProp = (prop, key)=>(0, $2aMjv.is).obj(prop) ? key && prop[key] : prop;
var $8197315a05dcadae$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $8197315a05dcadae$var$noopTransform = (value)=>value;
var $8197315a05dcadae$var$getDefaultProps = (props, transform = $8197315a05dcadae$var$noopTransform)=>{
    let keys = $8197315a05dcadae$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $2aMjv.is).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $8197315a05dcadae$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $8197315a05dcadae$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $8197315a05dcadae$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $2aMjv.eachProp)(props, (value, prop)=>{
        if (!$8197315a05dcadae$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $8197315a05dcadae$export$b971039a739bf227(props) {
    const to2 = $8197315a05dcadae$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $2aMjv.eachProp)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $8197315a05dcadae$var$computeGoal(value) {
    value = (0, $2aMjv.getFluidValue)(value);
    return (0, $2aMjv.is).arr(value) ? value.map($8197315a05dcadae$var$computeGoal) : (0, $2aMjv.isAnimatedString)(value) ? (0, $2aMjv.Globals).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $8197315a05dcadae$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $8197315a05dcadae$var$isAsyncTo(to2) {
    return (0, $2aMjv.is).fun(to2) || (0, $2aMjv.is).arr(to2) && (0, $2aMjv.is).obj(to2[0]);
}
function $8197315a05dcadae$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $8197315a05dcadae$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $8197315a05dcadae$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $2aMjv.each)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $2aMjv.each)(controllers, (ctrl)=>{
                        (0, $2aMjv.each)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $8197315a05dcadae$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $2aMjv.each)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $2aMjv.each)(controllers, (ctrl, i)=>(0, $2aMjv.each)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $8197315a05dcadae$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $8197315a05dcadae$var$defaults = {
    ...$8197315a05dcadae$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $2aMjv.easings).linear,
    clamp: false
};
var $8197315a05dcadae$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $8197315a05dcadae$var$defaults);
    }
};
function $8197315a05dcadae$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $8197315a05dcadae$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $8197315a05dcadae$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $8197315a05dcadae$var$defaults)if (config2[key] == null) config2[key] = $8197315a05dcadae$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $2aMjv.is).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $8197315a05dcadae$var$sanitizeConfig(config2, props) {
    if (!(0, $2aMjv.is).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $2aMjv.is).und(props.tension) || !(0, $2aMjv.is).und(props.friction);
        if (isTensionConfig || !(0, $2aMjv.is).und(props.frequency) || !(0, $2aMjv.is).und(props.damping) || !(0, $2aMjv.is).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $8197315a05dcadae$var$emptyArray = [];
var $8197315a05dcadae$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $8197315a05dcadae$var$emptyArray;
        this.toValues = null;
        this.fromValues = $8197315a05dcadae$var$emptyArray;
        this.config = new $8197315a05dcadae$var$AnimationConfig();
        this.immediate = false;
    }
};
function $8197315a05dcadae$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $8197315a05dcadae$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $2aMjv.is).und(props.pause)) state.paused = $8197315a05dcadae$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $8197315a05dcadae$var$matchProp(pause, key);
            delay = $8197315a05dcadae$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $gtRA1.raf).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $2aMjv.Globals).skipAnimation) {
                state.delayed = true;
                timeout = (0, $gtRA1.raf).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $8197315a05dcadae$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $8197315a05dcadae$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $8197315a05dcadae$var$getNoopResult(target.get()) : $8197315a05dcadae$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $8197315a05dcadae$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $8197315a05dcadae$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $8197315a05dcadae$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $8197315a05dcadae$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $8197315a05dcadae$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $8197315a05dcadae$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $8197315a05dcadae$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $8197315a05dcadae$export$d362d093fa99dc7();
            const skipAnimationSignal = new $8197315a05dcadae$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $2aMjv.Globals).skipAnimation) {
                    $8197315a05dcadae$var$stopAsync(state);
                    skipAnimationSignal.result = $8197315a05dcadae$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $2aMjv.is).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $2aMjv.eachProp)(defaultProps, (value, key)=>{
                    if ((0, $2aMjv.is).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $2aMjv.Globals).skipAnimation) {
            $8197315a05dcadae$var$stopAsync(state);
            return $8197315a05dcadae$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $2aMjv.is).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $8197315a05dcadae$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $8197315a05dcadae$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $8197315a05dcadae$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $2aMjv.is).fun(onRest)) (0, $gtRA1.raf).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $8197315a05dcadae$var$stopAsync(state, cancelId) {
    (0, $2aMjv.flush)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $8197315a05dcadae$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $8197315a05dcadae$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $8197315a05dcadae$var$isFrameValue = (value)=>value instanceof $8197315a05dcadae$export$8229896f80e2495e;
var $8197315a05dcadae$var$nextId = 1;
var $8197315a05dcadae$export$8229896f80e2495e = class extends (0, $2aMjv.FluidValue) {
    constructor(){
        super(...arguments);
        this.id = $8197315a05dcadae$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $b1Sgt.getAnimated)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $2aMjv.Globals).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $2aMjv.deprecateInterpolate)();
        return (0, $2aMjv.Globals).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $2aMjv.callFluidObservers)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $2aMjv.frameLoop).sort(this);
        (0, $2aMjv.callFluidObservers)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $8197315a05dcadae$var$$P = Symbol.for("SpringPhase");
var $8197315a05dcadae$var$HAS_ANIMATED = 1;
var $8197315a05dcadae$var$IS_ANIMATING = 2;
var $8197315a05dcadae$var$IS_PAUSED = 4;
var $8197315a05dcadae$var$hasAnimated = (target)=>(target[$8197315a05dcadae$var$$P] & $8197315a05dcadae$var$HAS_ANIMATED) > 0;
var $8197315a05dcadae$var$isAnimating = (target)=>(target[$8197315a05dcadae$var$$P] & $8197315a05dcadae$var$IS_ANIMATING) > 0;
var $8197315a05dcadae$var$isPaused = (target)=>(target[$8197315a05dcadae$var$$P] & $8197315a05dcadae$var$IS_PAUSED) > 0;
var $8197315a05dcadae$var$setActiveBit = (target, active)=>active ? target[$8197315a05dcadae$var$$P] |= $8197315a05dcadae$var$IS_ANIMATING | $8197315a05dcadae$var$HAS_ANIMATED : target[$8197315a05dcadae$var$$P] &= ~$8197315a05dcadae$var$IS_ANIMATING;
var $8197315a05dcadae$var$setPausedBit = (target, paused)=>paused ? target[$8197315a05dcadae$var$$P] |= $8197315a05dcadae$var$IS_PAUSED : target[$8197315a05dcadae$var$$P] &= ~$8197315a05dcadae$var$IS_PAUSED;
// src/SpringValue.ts
var $8197315a05dcadae$export$5854d13427d5a954 = class extends $8197315a05dcadae$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $8197315a05dcadae$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $2aMjv.is).und(arg1) || !(0, $2aMjv.is).und(arg2)) {
            const props = (0, $2aMjv.is).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $2aMjv.is).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($8197315a05dcadae$var$isAnimating(this) || this._state.asyncTo) || $8197315a05dcadae$var$isPaused(this);
    }
    get goal() {
        return (0, $2aMjv.getFluidValue)(this.animation.to);
    }
    get velocity() {
        const node = (0, $b1Sgt.getAnimated)(this);
        return node instanceof (0, $b1Sgt.AnimatedValue) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $8197315a05dcadae$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $8197315a05dcadae$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $8197315a05dcadae$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $b1Sgt.getPayload)(anim.to);
        if (!payload && (0, $2aMjv.hasFluidValue)(anim.to)) toValues = (0, $2aMjv.toArray)((0, $2aMjv.getFluidValue)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $b1Sgt.AnimatedString) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $2aMjv.is).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $2aMjv.is).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $2aMjv.is).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $b1Sgt.getAnimated)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $2aMjv.getFluidValue)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $gtRA1.raf).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($8197315a05dcadae$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $gtRA1.raf).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $2aMjv.is).und(to2)) queue = [
            (0, $2aMjv.is).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$8197315a05dcadae$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $8197315a05dcadae$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $gtRA1.raf).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $2aMjv.is).obj(to2) ? to2[key] : to2;
        if (to2 == null || $8197315a05dcadae$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $2aMjv.is).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$8197315a05dcadae$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $2aMjv.getFluidValue)(from);
            if (!(0, $2aMjv.is).und(from)) this._set(from);
            else if (!(0, $b1Sgt.getAnimated)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $8197315a05dcadae$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $8197315a05dcadae$var$resolveProp(value, key) : value));
        $8197315a05dcadae$var$mergeActiveFn(this, props, "onProps");
        $8197315a05dcadae$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $8197315a05dcadae$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$8197315a05dcadae$var$isPaused(this)) {
                        $8197315a05dcadae$var$setPausedBit(this, true);
                        (0, $2aMjv.flushCalls)(state.pauseQueue);
                        $8197315a05dcadae$var$sendEvent(this, "onPause", $8197315a05dcadae$var$getFinishedResult(this, $8197315a05dcadae$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($8197315a05dcadae$var$isPaused(this)) {
                        $8197315a05dcadae$var$setPausedBit(this, false);
                        if ($8197315a05dcadae$var$isAnimating(this)) this._resume();
                        (0, $2aMjv.flushCalls)(state.resumeQueue);
                        $8197315a05dcadae$var$sendEvent(this, "onResume", $8197315a05dcadae$var$getFinishedResult(this, $8197315a05dcadae$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $8197315a05dcadae$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($8197315a05dcadae$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $2aMjv.is).und(range.to);
        const hasFromProp = !(0, $2aMjv.is).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($8197315a05dcadae$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $2aMjv.is).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $2aMjv.isEqual)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $2aMjv.getFluidValue)(from);
        const hasToChanged = !(0, $2aMjv.isEqual)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $8197315a05dcadae$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $8197315a05dcadae$var$mergeConfig(config2, $8197315a05dcadae$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $8197315a05dcadae$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $b1Sgt.getAnimated)(this);
        if (!node || (0, $2aMjv.is).und(to2)) return resolve($8197315a05dcadae$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $2aMjv.is).und(props.reset) ? hasFromProp && !props.default : !(0, $2aMjv.is).und(from) && $8197315a05dcadae$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $8197315a05dcadae$var$computeGoal(to2);
        const isAnimatable = (0, $2aMjv.is).num(goal) || (0, $2aMjv.is).arr(goal) || (0, $2aMjv.isAnimatedString)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $8197315a05dcadae$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $b1Sgt.getAnimatedType)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $2aMjv.hasFluidValue)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$8197315a05dcadae$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $2aMjv.isEqual)($8197315a05dcadae$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $2aMjv.isEqual)(anim.immediate, immediate) && !immediate || !(0, $2aMjv.isEqual)(config2.decay, decay) || !(0, $2aMjv.isEqual)(config2.velocity, velocity)) started = true;
        }
        if (finished && $8197315a05dcadae$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $2aMjv.hasFluidValue)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $2aMjv.hasFluidValue)(to2) ? null : goalType == (0, $b1Sgt.AnimatedString) ? [
                    1
                ] : (0, $2aMjv.toArray)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $2aMjv.each)($8197315a05dcadae$var$ACTIVE_EVENTS, (type)=>$8197315a05dcadae$var$mergeActiveFn(this, props, type));
                const result = $8197315a05dcadae$var$getFinishedResult(this, $8197315a05dcadae$var$checkFinished(this, prevTo));
                (0, $2aMjv.flushCalls)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $gtRA1.raf).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $8197315a05dcadae$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($8197315a05dcadae$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($8197315a05dcadae$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($8197315a05dcadae$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $2aMjv.getFluidObservers)(this)) this._detach();
            anim.to = value;
            if ((0, $2aMjv.getFluidObservers)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $2aMjv.hasFluidValue)(to2)) {
            (0, $2aMjv.addFluidObserver)(to2, this);
            if ($8197315a05dcadae$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $2aMjv.hasFluidValue)(to2)) (0, $2aMjv.removeFluidObserver)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $2aMjv.getFluidValue)(arg);
        if (!(0, $2aMjv.is).und(value)) {
            const oldNode = (0, $b1Sgt.getAnimated)(this);
            if (!oldNode || !(0, $2aMjv.isEqual)(value, oldNode.getValue())) {
                const nodeType = (0, $b1Sgt.getAnimatedType)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $b1Sgt.setAnimated)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $gtRA1.raf).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $b1Sgt.getAnimated)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $8197315a05dcadae$var$sendEvent(this, "onStart", $8197315a05dcadae$var$getFinishedResult(this, $8197315a05dcadae$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $8197315a05dcadae$var$callProp(this.animation.onChange, value, this);
        }
        $8197315a05dcadae$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $b1Sgt.getAnimated)(this).reset((0, $2aMjv.getFluidValue)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$8197315a05dcadae$var$isAnimating(this)) {
            $8197315a05dcadae$var$setActiveBit(this, true);
            if (!$8197315a05dcadae$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $2aMjv.Globals).skipAnimation) this.finish();
        else (0, $2aMjv.frameLoop).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($8197315a05dcadae$var$isAnimating(this)) {
            $8197315a05dcadae$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $2aMjv.each)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $2aMjv.callFluidObservers)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $8197315a05dcadae$var$getCancelledResult(this.get()) : $8197315a05dcadae$var$getFinishedResult(this.get(), $8197315a05dcadae$var$checkFinished(this, goal ?? anim.to));
            (0, $2aMjv.flushCalls)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $8197315a05dcadae$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $8197315a05dcadae$var$checkFinished(target, to2) {
    const goal = $8197315a05dcadae$var$computeGoal(to2);
    const value = $8197315a05dcadae$var$computeGoal(target.get());
    return (0, $2aMjv.isEqual)(value, goal);
}
function $8197315a05dcadae$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $8197315a05dcadae$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $8197315a05dcadae$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $8197315a05dcadae$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $8197315a05dcadae$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $8197315a05dcadae$var$createUpdate(props) {
    const { to: to2, from: from } = props = $8197315a05dcadae$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $2aMjv.is).obj(to2)) $8197315a05dcadae$var$findDefined(to2, keys);
    if ((0, $2aMjv.is).obj(from)) $8197315a05dcadae$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $8197315a05dcadae$var$declareUpdate(props) {
    const update2 = $8197315a05dcadae$var$createUpdate(props);
    if ((0, $2aMjv.is).und(update2.default)) update2.default = $8197315a05dcadae$var$getDefaultProps(update2);
    return update2;
}
function $8197315a05dcadae$var$findDefined(values, keys) {
    (0, $2aMjv.eachProp)(values, (value, key)=>value != null && keys.add(key));
}
var $8197315a05dcadae$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $8197315a05dcadae$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $8197315a05dcadae$var$getDefaultProp(props, type) ? $8197315a05dcadae$var$resolveProp(props[type], target.key) : void 0;
}
function $8197315a05dcadae$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $8197315a05dcadae$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $8197315a05dcadae$var$nextId2 = 1;
var $8197315a05dcadae$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $8197315a05dcadae$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $2aMjv.is).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($8197315a05dcadae$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $2aMjv.toArray)(props).map($8197315a05dcadae$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $8197315a05dcadae$var$prepareKeys(this, queue);
        return $8197315a05dcadae$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $2aMjv.each)((0, $2aMjv.toArray)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $8197315a05dcadae$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $2aMjv.is).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $2aMjv.each)((0, $2aMjv.toArray)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $2aMjv.is).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $2aMjv.each)((0, $2aMjv.toArray)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $2aMjv.eachProp)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $2aMjv.flush)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $2aMjv.flush)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $2aMjv.flush)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $gtRA1.raf).onFrame(this._onFrame);
    }
};
function $8197315a05dcadae$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$8197315a05dcadae$var$flushUpdate(ctrl, props))).then((results)=>$8197315a05dcadae$var$getCombinedResult(ctrl, results));
}
async function $8197315a05dcadae$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $2aMjv.is).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $2aMjv.is).arr(to2) || (0, $2aMjv.is).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $2aMjv.each)($8197315a05dcadae$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $2aMjv.is).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $2aMjv.flushCalls)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $8197315a05dcadae$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($8197315a05dcadae$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $2aMjv.noop),
            resume: (0, $2aMjv.noop),
            start (props2, resolve) {
                if (cancel) {
                    $8197315a05dcadae$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($8197315a05dcadae$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($8197315a05dcadae$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $8197315a05dcadae$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $8197315a05dcadae$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $8197315a05dcadae$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $8197315a05dcadae$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $gtRA1.raf).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $8197315a05dcadae$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $2aMjv.each)((0, $2aMjv.toArray)(props), (props2)=>{
        if ((0, $2aMjv.is).und(props2.keys)) props2 = $8197315a05dcadae$var$createUpdate(props2);
        if (!(0, $2aMjv.is).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $8197315a05dcadae$var$prepareSprings(springs, props2, (key)=>{
            return $8197315a05dcadae$var$createSpring(key);
        });
    });
    $8197315a05dcadae$var$setSprings(ctrl, springs);
    return springs;
}
function $8197315a05dcadae$var$setSprings(ctrl, springs) {
    (0, $2aMjv.eachProp)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $2aMjv.addFluidObserver)(spring, ctrl);
        }
    });
}
function $8197315a05dcadae$var$createSpring(key, observer) {
    const spring = new $8197315a05dcadae$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $2aMjv.addFluidObserver)(spring, observer);
    return spring;
}
function $8197315a05dcadae$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $2aMjv.each)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $8197315a05dcadae$var$prepareKeys(ctrl, queue) {
    (0, $2aMjv.each)(queue, (props)=>{
        $8197315a05dcadae$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $8197315a05dcadae$var$createSpring(key, ctrl);
        });
    });
}
var $8197315a05dcadae$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $bxRTa.useContext)($8197315a05dcadae$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $2aMjv.useMemoOne)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $8197315a05dcadae$var$ctx;
    return /* @__PURE__ */ $bxRTa.createElement(Provider, {
        value: props
    }, children);
};
var $8197315a05dcadae$var$ctx = $8197315a05dcadae$var$makeContext($8197315a05dcadae$export$f12a216ec50d2cf1, {});
$8197315a05dcadae$export$f12a216ec50d2cf1.Provider = $8197315a05dcadae$var$ctx.Provider;
$8197315a05dcadae$export$f12a216ec50d2cf1.Consumer = $8197315a05dcadae$var$ctx.Consumer;
function $8197315a05dcadae$var$makeContext(target, init) {
    Object.assign(target, $bxRTa.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $8197315a05dcadae$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $2aMjv.deprecateDirectCall)();
        const results = [];
        (0, $2aMjv.each)(current, (ctrl, i)=>{
            if ((0, $2aMjv.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $2aMjv.each)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $2aMjv.each)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $2aMjv.each)(current, (ctrl, i)=>{
            const update2 = (0, $2aMjv.is).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $2aMjv.each)(current, (ctrl, i)=>{
            if ((0, $2aMjv.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $2aMjv.each)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $2aMjv.each)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $2aMjv.is).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $8197315a05dcadae$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $2aMjv.is).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $bxRTa.useMemo)(()=>propsFn || arguments.length == 3 ? $8197315a05dcadae$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $bxRTa.useRef)(0);
    const forceUpdate = (0, $2aMjv.useForceUpdate)();
    const state = (0, $bxRTa.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $8197315a05dcadae$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $8197315a05dcadae$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $8197315a05dcadae$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($8197315a05dcadae$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $bxRTa.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $2aMjv.usePrev)(length) || 0;
    (0, $bxRTa.useMemo)(()=>{
        (0, $2aMjv.each)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $8197315a05dcadae$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $bxRTa.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $8197315a05dcadae$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $8197315a05dcadae$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$8197315a05dcadae$var$getSprings(ctrl, updates[i]));
    const context = (0, $bxRTa.useContext)($8197315a05dcadae$export$f12a216ec50d2cf1);
    const prevContext = (0, $2aMjv.usePrev)(context);
    const hasContext = context !== prevContext && $8197315a05dcadae$var$hasProps(context);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $2aMjv.each)(queue, (cb)=>cb());
        }
        (0, $2aMjv.each)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $8197315a05dcadae$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $2aMjv.useOnce)(()=>()=>{
            (0, $2aMjv.each)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $8197315a05dcadae$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $2aMjv.is).fun(props);
    const [[values], ref] = $8197315a05dcadae$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $8197315a05dcadae$var$initSpringRef = ()=>$8197315a05dcadae$export$2471ae76e2946684();
var $8197315a05dcadae$export$564bff9c23cad2ca = ()=>(0, $bxRTa.useState)($8197315a05dcadae$var$initSpringRef)[0];
var $8197315a05dcadae$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $2aMjv.useConstant)(()=>new $8197315a05dcadae$export$5854d13427d5a954(initial, props));
    (0, $2aMjv.useOnce)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $8197315a05dcadae$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $2aMjv.is).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $8197315a05dcadae$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        (0, $2aMjv.each)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $8197315a05dcadae$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $2aMjv.is).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $8197315a05dcadae$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $2aMjv.is).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $bxRTa.useMemo)(()=>propsFn || arguments.length == 3 ? $8197315a05dcadae$export$2471ae76e2946684() : void 0, []);
    const items = (0, $2aMjv.toArray)(data);
    const transitions = [];
    const usedTransitions = (0, $bxRTa.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $2aMjv.useOnce)(()=>{
        (0, $2aMjv.each)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $2aMjv.each)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $8197315a05dcadae$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $8197315a05dcadae$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>(0, $2aMjv.each)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $8197315a05dcadae$var$detachRefs(ctrl, ref);
            $8197315a05dcadae$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $2aMjv.each)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $2aMjv.each)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $8197315a05dcadae$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $2aMjv.each)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $2aMjv.is).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $2aMjv.useForceUpdate)();
    const defaultProps = $8197315a05dcadae$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $bxRTa.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $bxRTa.useRef)(false);
    (0, $2aMjv.each)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $8197315a05dcadae$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $8197315a05dcadae$var$callProp(to2, t.item, i);
        to2 = (0, $2aMjv.is).obj(to2) ? $8197315a05dcadae$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $8197315a05dcadae$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $2aMjv.is).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $2aMjv.is).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $8197315a05dcadae$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $8197315a05dcadae$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $8197315a05dcadae$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $8197315a05dcadae$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $bxRTa.useContext)($8197315a05dcadae$export$f12a216ec50d2cf1);
    const prevContext = (0, $2aMjv.usePrev)(context);
    const hasContext = context !== prevContext && $8197315a05dcadae$var$hasProps(context);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        if (hasContext) (0, $2aMjv.each)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $2aMjv.each)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        (0, $2aMjv.each)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $8197315a05dcadae$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $bxRTa.createElement($bxRTa.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $bxRTa.createElement(elem.type, {
                ...elem.props,
                key: (0, $2aMjv.is).str(t.key) || (0, $2aMjv.is).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $8197315a05dcadae$var$nextKey = 1;
function $8197315a05dcadae$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $8197315a05dcadae$var$nextKey++;
        });
    }
    return (0, $2aMjv.is).und(keys) ? items : (0, $2aMjv.is).fun(keys) ? items.map(keys) : (0, $2aMjv.toArray)(keys);
}
var $8197315a05dcadae$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $8197315a05dcadae$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, $2aMjv.onScroll)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $2aMjv.each)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $8197315a05dcadae$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $8197315a05dcadae$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, $2aMjv.onResize)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $2aMjv.each)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $8197315a05dcadae$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $8197315a05dcadae$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $bxRTa.useState)(false);
    const ref = (0, $bxRTa.useRef)();
    const propsFn = (0, $2aMjv.is).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $8197315a05dcadae$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $2aMjv.is).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $8197315a05dcadae$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $8197315a05dcadae$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($8197315a05dcadae$export$c4af9125706c4d30(props));
}
function $8197315a05dcadae$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $8197315a05dcadae$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $2aMjv.is).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $8197315a05dcadae$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $8197315a05dcadae$export$7b286972b8d8ccbf(items, props)(children);
}
var $8197315a05dcadae$export$b0cc4f9860136880 = class extends $8197315a05dcadae$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $2aMjv.createInterpolator)(...args);
        const value = this._get();
        const nodeType = (0, $b1Sgt.getAnimatedType)(value);
        (0, $b1Sgt.setAnimated)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $2aMjv.isEqual)(value, oldValue)) {
            (0, $b1Sgt.getAnimated)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $8197315a05dcadae$var$checkIdle(this._active)) $8197315a05dcadae$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $2aMjv.is).arr(this.source) ? this.source.map((0, $2aMjv.getFluidValue)) : (0, $2aMjv.toArray)((0, $2aMjv.getFluidValue)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$8197315a05dcadae$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $2aMjv.each)((0, $b1Sgt.getPayload)(this), (node)=>{
                node.done = false;
            });
            if ((0, $2aMjv.Globals).skipAnimation) {
                (0, $gtRA1.raf).batchedUpdates(()=>this.advance());
                $8197315a05dcadae$var$becomeIdle(this);
            } else (0, $2aMjv.frameLoop).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $2aMjv.each)((0, $2aMjv.toArray)(this.source), (source)=>{
            if ((0, $2aMjv.hasFluidValue)(source)) (0, $2aMjv.addFluidObserver)(source, this);
            if ($8197315a05dcadae$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $2aMjv.each)((0, $2aMjv.toArray)(this.source), (source)=>{
            if ((0, $2aMjv.hasFluidValue)(source)) (0, $2aMjv.removeFluidObserver)(source, this);
        });
        this._active.clear();
        $8197315a05dcadae$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $2aMjv.toArray)(this.source).reduce((highest, parent)=>Math.max(highest, ($8197315a05dcadae$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $8197315a05dcadae$var$isIdle(source) {
    return source.idle !== false;
}
function $8197315a05dcadae$var$checkIdle(active) {
    return !active.size || Array.from(active).every($8197315a05dcadae$var$isIdle);
}
function $8197315a05dcadae$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $2aMjv.each)((0, $b1Sgt.getPayload)(self), (node)=>{
            node.done = true;
        });
        (0, $2aMjv.callFluidObservers)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $8197315a05dcadae$export$2c618a4308a30424 = (source, ...args)=>new $8197315a05dcadae$export$b0cc4f9860136880(source, args);
var $8197315a05dcadae$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $2aMjv.deprecateInterpolate)(), new $8197315a05dcadae$export$b0cc4f9860136880(source, args));
(0, $2aMjv.Globals).assign({
    createStringInterpolator: $2aMjv.createStringInterpolator,
    to: (source, args)=>new $8197315a05dcadae$export$b0cc4f9860136880(source, args)
});
var $8197315a05dcadae$export$722fbec263ad908a = (0, $2aMjv.frameLoop).advance;

});
parcelRegister("2aMjv", function(module, exports) {

$parcel$export(module.exports, "Globals", () => $05bd5b66d02a1a3f$export$cceeabf822b64fc0);
$parcel$export(module.exports, "noop", () => $05bd5b66d02a1a3f$export$8793edee2d425525);
$parcel$export(module.exports, "defineHidden", () => $05bd5b66d02a1a3f$export$5c74248ea0e35446);
$parcel$export(module.exports, "is", () => $05bd5b66d02a1a3f$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "isEqual", () => $05bd5b66d02a1a3f$export$248d38f6296296c5);
$parcel$export(module.exports, "each", () => $05bd5b66d02a1a3f$export$79b2f7037acddd43);
$parcel$export(module.exports, "eachProp", () => $05bd5b66d02a1a3f$export$f4c6fe153f5a944e);
$parcel$export(module.exports, "toArray", () => $05bd5b66d02a1a3f$export$45b10814cc054894);
$parcel$export(module.exports, "flush", () => $05bd5b66d02a1a3f$export$4909b86c8034bf73);
$parcel$export(module.exports, "flushCalls", () => $05bd5b66d02a1a3f$export$7ba486852759e806);
$parcel$export(module.exports, "frameLoop", () => $05bd5b66d02a1a3f$export$a57f5080a3bcc90a);
$parcel$export(module.exports, "colors", () => $05bd5b66d02a1a3f$export$8f45430ccf837300);
$parcel$export(module.exports, "createInterpolator", () => $05bd5b66d02a1a3f$export$b12af43b97697ef5);
$parcel$export(module.exports, "easings", () => $05bd5b66d02a1a3f$export$15a0bf1b4bbacad8);
$parcel$export(module.exports, "hasFluidValue", () => $05bd5b66d02a1a3f$export$57ea7e3a7f6280c7);
$parcel$export(module.exports, "getFluidValue", () => $05bd5b66d02a1a3f$export$e37b7520edd66839);
$parcel$export(module.exports, "getFluidObservers", () => $05bd5b66d02a1a3f$export$133f54e9f7cf1796);
$parcel$export(module.exports, "callFluidObservers", () => $05bd5b66d02a1a3f$export$31752c40a5fab62a);
$parcel$export(module.exports, "FluidValue", () => $05bd5b66d02a1a3f$export$aff8e1ac1a016a2);
$parcel$export(module.exports, "addFluidObserver", () => $05bd5b66d02a1a3f$export$72d604e3f8d000a5);
$parcel$export(module.exports, "removeFluidObserver", () => $05bd5b66d02a1a3f$export$7a0eb830d336339b);
$parcel$export(module.exports, "createStringInterpolator", () => $05bd5b66d02a1a3f$export$4759a013d387347a);
$parcel$export(module.exports, "deprecateInterpolate", () => $05bd5b66d02a1a3f$export$2abfcde8ae218ba8);
$parcel$export(module.exports, "deprecateDirectCall", () => $05bd5b66d02a1a3f$export$d99d974913ad3b12);
$parcel$export(module.exports, "isAnimatedString", () => $05bd5b66d02a1a3f$export$75bed621f62abfa9);
$parcel$export(module.exports, "onResize", () => $05bd5b66d02a1a3f$export$45b39e67d4ce4921);
$parcel$export(module.exports, "onScroll", () => $05bd5b66d02a1a3f$export$d4d89fd61e5416ee);
$parcel$export(module.exports, "useConstant", () => $05bd5b66d02a1a3f$export$fe4300aa8eebea86);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $05bd5b66d02a1a3f$export$700979bc83e7db82);
$parcel$export(module.exports, "useForceUpdate", () => $05bd5b66d02a1a3f$export$91db9bc4f8ac944a);
$parcel$export(module.exports, "useMemoOne", () => $05bd5b66d02a1a3f$export$b6feb8998cd9b342);
$parcel$export(module.exports, "useOnce", () => $05bd5b66d02a1a3f$export$392544347a18b6ea);
$parcel$export(module.exports, "usePrev", () => $05bd5b66d02a1a3f$export$ef7ad0c4e19d7fbf);
$parcel$export(module.exports, "raf", () => (parcelRequire("gtRA1")).raf);

var $gtRA1 = parcelRequire("gtRA1");

var $bxRTa = parcelRequire("bxRTa");
var $05bd5b66d02a1a3f$var$__defProp = Object.defineProperty;
var $05bd5b66d02a1a3f$var$__export = (target, all)=>{
    for(var name in all)$05bd5b66d02a1a3f$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $05bd5b66d02a1a3f$export$cceeabf822b64fc0 = {};
$05bd5b66d02a1a3f$var$__export($05bd5b66d02a1a3f$export$cceeabf822b64fc0, {
    assign: ()=>$05bd5b66d02a1a3f$var$assign,
    colors: ()=>$05bd5b66d02a1a3f$var$colors,
    createStringInterpolator: ()=>$05bd5b66d02a1a3f$var$createStringInterpolator,
    skipAnimation: ()=>$05bd5b66d02a1a3f$var$skipAnimation,
    to: ()=>$05bd5b66d02a1a3f$var$to,
    willAdvance: ()=>$05bd5b66d02a1a3f$var$willAdvance
});
// src/helpers.ts
function $05bd5b66d02a1a3f$export$8793edee2d425525() {}
var $05bd5b66d02a1a3f$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $05bd5b66d02a1a3f$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $05bd5b66d02a1a3f$export$248d38f6296296c5(a, b) {
    if ($05bd5b66d02a1a3f$export$226b3eccf92c9ed9.arr(a)) {
        if (!$05bd5b66d02a1a3f$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $05bd5b66d02a1a3f$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $05bd5b66d02a1a3f$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($05bd5b66d02a1a3f$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $05bd5b66d02a1a3f$export$45b10814cc054894 = (a)=>$05bd5b66d02a1a3f$export$226b3eccf92c9ed9.und(a) ? [] : $05bd5b66d02a1a3f$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $05bd5b66d02a1a3f$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $05bd5b66d02a1a3f$export$79b2f7037acddd43(items, iterator);
    }
}
var $05bd5b66d02a1a3f$export$7ba486852759e806 = (queue, ...args)=>$05bd5b66d02a1a3f$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $05bd5b66d02a1a3f$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $05bd5b66d02a1a3f$var$createStringInterpolator;
var $05bd5b66d02a1a3f$var$to;
var $05bd5b66d02a1a3f$var$colors = null;
var $05bd5b66d02a1a3f$var$skipAnimation = false;
var $05bd5b66d02a1a3f$var$willAdvance = $05bd5b66d02a1a3f$export$8793edee2d425525;
var $05bd5b66d02a1a3f$var$assign = (globals)=>{
    if (globals.to) $05bd5b66d02a1a3f$var$to = globals.to;
    if (globals.now) (0, $gtRA1.raf).now = globals.now;
    if (globals.colors !== void 0) $05bd5b66d02a1a3f$var$colors = globals.colors;
    if (globals.skipAnimation != null) $05bd5b66d02a1a3f$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $05bd5b66d02a1a3f$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $gtRA1.raf).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $gtRA1.raf).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $05bd5b66d02a1a3f$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $gtRA1.raf).frameLoop = globals.frameLoop;
};
var $05bd5b66d02a1a3f$var$startQueue = /* @__PURE__ */ new Set();
var $05bd5b66d02a1a3f$var$currentFrame = [];
var $05bd5b66d02a1a3f$var$prevFrame = [];
var $05bd5b66d02a1a3f$var$priority = 0;
var $05bd5b66d02a1a3f$export$a57f5080a3bcc90a = {
    get idle () {
        return !$05bd5b66d02a1a3f$var$startQueue.size && !$05bd5b66d02a1a3f$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($05bd5b66d02a1a3f$var$priority > animation.priority) {
            $05bd5b66d02a1a3f$var$startQueue.add(animation);
            (0, $gtRA1.raf).onStart($05bd5b66d02a1a3f$var$flushStartQueue);
        } else {
            $05bd5b66d02a1a3f$var$startSafely(animation);
            (0, $gtRA1.raf)($05bd5b66d02a1a3f$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $05bd5b66d02a1a3f$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($05bd5b66d02a1a3f$var$priority) (0, $gtRA1.raf).onFrame(()=>$05bd5b66d02a1a3f$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $05bd5b66d02a1a3f$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $05bd5b66d02a1a3f$var$currentFrame.splice(prevIndex, 1);
                $05bd5b66d02a1a3f$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $05bd5b66d02a1a3f$var$currentFrame = [];
        $05bd5b66d02a1a3f$var$startQueue.clear();
    }
};
function $05bd5b66d02a1a3f$var$flushStartQueue() {
    $05bd5b66d02a1a3f$var$startQueue.forEach($05bd5b66d02a1a3f$var$startSafely);
    $05bd5b66d02a1a3f$var$startQueue.clear();
    (0, $gtRA1.raf)($05bd5b66d02a1a3f$var$advance);
}
function $05bd5b66d02a1a3f$var$startSafely(animation) {
    if (!$05bd5b66d02a1a3f$var$currentFrame.includes(animation)) $05bd5b66d02a1a3f$var$startUnsafely(animation);
}
function $05bd5b66d02a1a3f$var$startUnsafely(animation) {
    $05bd5b66d02a1a3f$var$currentFrame.splice($05bd5b66d02a1a3f$var$findIndex($05bd5b66d02a1a3f$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $05bd5b66d02a1a3f$var$advance(dt) {
    const nextFrame = $05bd5b66d02a1a3f$var$prevFrame;
    for(let i = 0; i < $05bd5b66d02a1a3f$var$currentFrame.length; i++){
        const animation = $05bd5b66d02a1a3f$var$currentFrame[i];
        $05bd5b66d02a1a3f$var$priority = animation.priority;
        if (!animation.idle) {
            $05bd5b66d02a1a3f$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $05bd5b66d02a1a3f$var$priority = 0;
    $05bd5b66d02a1a3f$var$prevFrame = $05bd5b66d02a1a3f$var$currentFrame;
    $05bd5b66d02a1a3f$var$prevFrame.length = 0;
    $05bd5b66d02a1a3f$var$currentFrame = nextFrame;
    return $05bd5b66d02a1a3f$var$currentFrame.length > 0;
}
function $05bd5b66d02a1a3f$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $05bd5b66d02a1a3f$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $05bd5b66d02a1a3f$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $05bd5b66d02a1a3f$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $05bd5b66d02a1a3f$var$PERCENTAGE = $05bd5b66d02a1a3f$var$NUMBER + "%";
function $05bd5b66d02a1a3f$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $05bd5b66d02a1a3f$export$8972dc0e6ad9238f = new RegExp("rgb" + $05bd5b66d02a1a3f$var$call($05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$NUMBER));
var $05bd5b66d02a1a3f$export$4e46ac54fc82cf3b = new RegExp("rgba" + $05bd5b66d02a1a3f$var$call($05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$NUMBER));
var $05bd5b66d02a1a3f$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $05bd5b66d02a1a3f$var$call($05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$PERCENTAGE, $05bd5b66d02a1a3f$var$PERCENTAGE));
var $05bd5b66d02a1a3f$export$810b04175080204c = new RegExp("hsla" + $05bd5b66d02a1a3f$var$call($05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$PERCENTAGE, $05bd5b66d02a1a3f$var$PERCENTAGE, $05bd5b66d02a1a3f$var$NUMBER));
var $05bd5b66d02a1a3f$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $05bd5b66d02a1a3f$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $05bd5b66d02a1a3f$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $05bd5b66d02a1a3f$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $05bd5b66d02a1a3f$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $05bd5b66d02a1a3f$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($05bd5b66d02a1a3f$var$colors && $05bd5b66d02a1a3f$var$colors[color] !== void 0) return $05bd5b66d02a1a3f$var$colors[color];
    if (match = $05bd5b66d02a1a3f$export$8972dc0e6ad9238f.exec(color)) return ($05bd5b66d02a1a3f$var$parse255(match[1]) << 24 | // r
    $05bd5b66d02a1a3f$var$parse255(match[2]) << 16 | // g
    $05bd5b66d02a1a3f$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $05bd5b66d02a1a3f$export$4e46ac54fc82cf3b.exec(color)) return ($05bd5b66d02a1a3f$var$parse255(match[1]) << 24 | // r
    $05bd5b66d02a1a3f$var$parse255(match[2]) << 16 | // g
    $05bd5b66d02a1a3f$var$parse255(match[3]) << 8 | // b
    $05bd5b66d02a1a3f$var$parse1(match[4])) >>> // a
    0;
    if (match = $05bd5b66d02a1a3f$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $05bd5b66d02a1a3f$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $05bd5b66d02a1a3f$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $05bd5b66d02a1a3f$export$8f4a7c0bb78e6ea8.exec(color)) return ($05bd5b66d02a1a3f$var$hslToRgb($05bd5b66d02a1a3f$var$parse360(match[1]), // h
    $05bd5b66d02a1a3f$var$parsePercentage(match[2]), // s
    $05bd5b66d02a1a3f$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $05bd5b66d02a1a3f$export$810b04175080204c.exec(color)) return ($05bd5b66d02a1a3f$var$hslToRgb($05bd5b66d02a1a3f$var$parse360(match[1]), // h
    $05bd5b66d02a1a3f$var$parsePercentage(match[2]), // s
    $05bd5b66d02a1a3f$var$parsePercentage(match[3])) | $05bd5b66d02a1a3f$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $05bd5b66d02a1a3f$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $05bd5b66d02a1a3f$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $05bd5b66d02a1a3f$var$hue2rgb(p, q, h + 1 / 3);
    const g = $05bd5b66d02a1a3f$var$hue2rgb(p, q, h);
    const b = $05bd5b66d02a1a3f$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $05bd5b66d02a1a3f$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $05bd5b66d02a1a3f$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $05bd5b66d02a1a3f$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $05bd5b66d02a1a3f$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $05bd5b66d02a1a3f$export$61db176b839af1f(input) {
    let int32Color = $05bd5b66d02a1a3f$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $05bd5b66d02a1a3f$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($05bd5b66d02a1a3f$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($05bd5b66d02a1a3f$export$226b3eccf92c9ed9.arr(range)) return $05bd5b66d02a1a3f$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($05bd5b66d02a1a3f$export$226b3eccf92c9ed9.str(range.output[0])) return $05bd5b66d02a1a3f$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $05bd5b66d02a1a3f$var$findRange(input, inputRange);
        return $05bd5b66d02a1a3f$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $05bd5b66d02a1a3f$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $05bd5b66d02a1a3f$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $05bd5b66d02a1a3f$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $05bd5b66d02a1a3f$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $05bd5b66d02a1a3f$var$c1 = 1.70158;
var $05bd5b66d02a1a3f$var$c2 = $05bd5b66d02a1a3f$var$c1 * 1.525;
var $05bd5b66d02a1a3f$var$c3 = $05bd5b66d02a1a3f$var$c1 + 1;
var $05bd5b66d02a1a3f$var$c4 = 2 * Math.PI / 3;
var $05bd5b66d02a1a3f$var$c5 = 2 * Math.PI / 4.5;
var $05bd5b66d02a1a3f$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $05bd5b66d02a1a3f$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$05bd5b66d02a1a3f$var$c3 * x * x * x - $05bd5b66d02a1a3f$var$c1 * x * x,
    easeOutBack: (x)=>1 + $05bd5b66d02a1a3f$var$c3 * Math.pow(x - 1, 3) + $05bd5b66d02a1a3f$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($05bd5b66d02a1a3f$var$c2 + 1) * 2 * x - $05bd5b66d02a1a3f$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($05bd5b66d02a1a3f$var$c2 + 1) * (x * 2 - 2) + $05bd5b66d02a1a3f$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $05bd5b66d02a1a3f$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $05bd5b66d02a1a3f$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $05bd5b66d02a1a3f$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $05bd5b66d02a1a3f$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $05bd5b66d02a1a3f$var$bounceOut(1 - x),
    easeOutBounce: $05bd5b66d02a1a3f$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $05bd5b66d02a1a3f$var$bounceOut(1 - 2 * x)) / 2 : (1 + $05bd5b66d02a1a3f$var$bounceOut(2 * x - 1)) / 2,
    steps: $05bd5b66d02a1a3f$var$steps
};
// src/fluids.ts
var $05bd5b66d02a1a3f$var$$get = Symbol.for("FluidValue.get");
var $05bd5b66d02a1a3f$var$$observers = Symbol.for("FluidValue.observers");
var $05bd5b66d02a1a3f$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$05bd5b66d02a1a3f$var$$get]);
var $05bd5b66d02a1a3f$export$e37b7520edd66839 = (arg)=>arg && arg[$05bd5b66d02a1a3f$var$$get] ? arg[$05bd5b66d02a1a3f$var$$get]() : arg;
var $05bd5b66d02a1a3f$export$133f54e9f7cf1796 = (target)=>target[$05bd5b66d02a1a3f$var$$observers] || null;
function $05bd5b66d02a1a3f$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $05bd5b66d02a1a3f$export$31752c40a5fab62a(target, event) {
    const observers = target[$05bd5b66d02a1a3f$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $05bd5b66d02a1a3f$export$8cbca1207adce0c0(observer2, event);
    });
}
var $05bd5b66d02a1a3f$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $05bd5b66d02a1a3f$export$a3b4618659637aa3(this, get);
    }
};
$05bd5b66d02a1a3f$var$$get, $05bd5b66d02a1a3f$var$$observers;
var $05bd5b66d02a1a3f$export$a3b4618659637aa3 = (target, get)=>$05bd5b66d02a1a3f$var$setHidden(target, $05bd5b66d02a1a3f$var$$get, get);
function $05bd5b66d02a1a3f$export$72d604e3f8d000a5(target, observer2) {
    if (target[$05bd5b66d02a1a3f$var$$get]) {
        let observers = target[$05bd5b66d02a1a3f$var$$observers];
        if (!observers) $05bd5b66d02a1a3f$var$setHidden(target, $05bd5b66d02a1a3f$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $05bd5b66d02a1a3f$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$05bd5b66d02a1a3f$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$05bd5b66d02a1a3f$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $05bd5b66d02a1a3f$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $05bd5b66d02a1a3f$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $05bd5b66d02a1a3f$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $05bd5b66d02a1a3f$var$unitRegex = new RegExp(`(${$05bd5b66d02a1a3f$var$numberRegex.source})(%|[a-z]+)`, "i");
var $05bd5b66d02a1a3f$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $05bd5b66d02a1a3f$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $05bd5b66d02a1a3f$var$variableToRgba = (input)=>{
    const [token, fallback] = $05bd5b66d02a1a3f$var$parseCSSVariable(input);
    if (!token || $05bd5b66d02a1a3f$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $05bd5b66d02a1a3f$var$cssVariableRegex.test(fallback)) return $05bd5b66d02a1a3f$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $05bd5b66d02a1a3f$var$parseCSSVariable = (current)=>{
    const match = $05bd5b66d02a1a3f$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $05bd5b66d02a1a3f$var$namedColorRegex;
var $05bd5b66d02a1a3f$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $05bd5b66d02a1a3f$export$4759a013d387347a = (config)=>{
    if (!$05bd5b66d02a1a3f$var$namedColorRegex) $05bd5b66d02a1a3f$var$namedColorRegex = $05bd5b66d02a1a3f$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($05bd5b66d02a1a3f$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $05bd5b66d02a1a3f$export$e37b7520edd66839(value).replace($05bd5b66d02a1a3f$var$cssVariableRegex, $05bd5b66d02a1a3f$var$variableToRgba).replace($05bd5b66d02a1a3f$var$colorRegex, $05bd5b66d02a1a3f$export$61db176b839af1f).replace($05bd5b66d02a1a3f$var$namedColorRegex, $05bd5b66d02a1a3f$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($05bd5b66d02a1a3f$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$05bd5b66d02a1a3f$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$05bd5b66d02a1a3f$var$unitRegex.test(output[0]) && output.find((value)=>$05bd5b66d02a1a3f$var$unitRegex.test(value))?.replace($05bd5b66d02a1a3f$var$numberRegex, "");
        let i = 0;
        return output[0].replace($05bd5b66d02a1a3f$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($05bd5b66d02a1a3f$var$rgbaRegex, $05bd5b66d02a1a3f$var$rgbaRound);
    };
};
// src/deprecations.ts
var $05bd5b66d02a1a3f$export$82e9f45cca5ba907 = "react-spring: ";
var $05bd5b66d02a1a3f$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$05bd5b66d02a1a3f$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $05bd5b66d02a1a3f$var$warnInterpolate = $05bd5b66d02a1a3f$export$d2de3aaeafa91619(console.warn);
function $05bd5b66d02a1a3f$export$2abfcde8ae218ba8() {
    $05bd5b66d02a1a3f$var$warnInterpolate(`${$05bd5b66d02a1a3f$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $05bd5b66d02a1a3f$var$warnDirectCall = $05bd5b66d02a1a3f$export$d2de3aaeafa91619(console.warn);
function $05bd5b66d02a1a3f$export$d99d974913ad3b12() {
    $05bd5b66d02a1a3f$var$warnDirectCall(`${$05bd5b66d02a1a3f$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $05bd5b66d02a1a3f$export$75bed621f62abfa9(value) {
    return $05bd5b66d02a1a3f$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$05bd5b66d02a1a3f$export$48d7c418edadb60c() && $05bd5b66d02a1a3f$var$cssVariableRegex.test(value) || value in ($05bd5b66d02a1a3f$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $05bd5b66d02a1a3f$var$observer;
var $05bd5b66d02a1a3f$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $05bd5b66d02a1a3f$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $05bd5b66d02a1a3f$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $05bd5b66d02a1a3f$var$resizeElement(handler, target) {
    if (!$05bd5b66d02a1a3f$var$observer) {
        if (typeof ResizeObserver !== "undefined") $05bd5b66d02a1a3f$var$observer = new ResizeObserver($05bd5b66d02a1a3f$var$handleObservation);
    }
    let elementHandlers = $05bd5b66d02a1a3f$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $05bd5b66d02a1a3f$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($05bd5b66d02a1a3f$var$observer) $05bd5b66d02a1a3f$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $05bd5b66d02a1a3f$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $05bd5b66d02a1a3f$var$observer) $05bd5b66d02a1a3f$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $05bd5b66d02a1a3f$var$listeners = /* @__PURE__ */ new Set();
var $05bd5b66d02a1a3f$var$cleanupWindowResizeHandler;
var $05bd5b66d02a1a3f$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $05bd5b66d02a1a3f$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $05bd5b66d02a1a3f$var$resizeWindow = (callback)=>{
    $05bd5b66d02a1a3f$var$listeners.add(callback);
    if (!$05bd5b66d02a1a3f$var$cleanupWindowResizeHandler) $05bd5b66d02a1a3f$var$cleanupWindowResizeHandler = $05bd5b66d02a1a3f$var$createResizeHandler();
    return ()=>{
        $05bd5b66d02a1a3f$var$listeners.delete(callback);
        if (!$05bd5b66d02a1a3f$var$listeners.size && $05bd5b66d02a1a3f$var$cleanupWindowResizeHandler) {
            $05bd5b66d02a1a3f$var$cleanupWindowResizeHandler();
            $05bd5b66d02a1a3f$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $05bd5b66d02a1a3f$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $05bd5b66d02a1a3f$var$resizeWindow(callback);
    else return $05bd5b66d02a1a3f$var$resizeElement(callback, container);
};
// src/progress.ts
var $05bd5b66d02a1a3f$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $05bd5b66d02a1a3f$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $05bd5b66d02a1a3f$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $05bd5b66d02a1a3f$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $05bd5b66d02a1a3f$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $05bd5b66d02a1a3f$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $05bd5b66d02a1a3f$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $05bd5b66d02a1a3f$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $05bd5b66d02a1a3f$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $05bd5b66d02a1a3f$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $05bd5b66d02a1a3f$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $05bd5b66d02a1a3f$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $05bd5b66d02a1a3f$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$05bd5b66d02a1a3f$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $05bd5b66d02a1a3f$var$scrollListeners.set(container, listener);
        const target = $05bd5b66d02a1a3f$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $05bd5b66d02a1a3f$var$resizeListeners.set(container, $05bd5b66d02a1a3f$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $05bd5b66d02a1a3f$var$scrollListeners.get(container);
    (0, $gtRA1.raf)(animateScroll);
    return ()=>{
        (0, $gtRA1.raf).cancel(animateScroll);
        const containerHandlers2 = $05bd5b66d02a1a3f$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $05bd5b66d02a1a3f$var$scrollListeners.get(container);
        $05bd5b66d02a1a3f$var$scrollListeners.delete(container);
        if (listener) {
            $05bd5b66d02a1a3f$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $05bd5b66d02a1a3f$var$resizeListeners.get(container)?.();
        }
    };
};
function $05bd5b66d02a1a3f$export$fe4300aa8eebea86(init) {
    const ref = (0, $bxRTa.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $05bd5b66d02a1a3f$export$700979bc83e7db82 = $05bd5b66d02a1a3f$export$48d7c418edadb60c() ? (0, $bxRTa.useEffect) : (0, $bxRTa.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $05bd5b66d02a1a3f$var$useIsMounted = ()=>{
    const isMounted = (0, $bxRTa.useRef)(false);
    $05bd5b66d02a1a3f$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $05bd5b66d02a1a3f$export$91db9bc4f8ac944a() {
    const update = (0, $bxRTa.useState)()[1];
    const isMounted = $05bd5b66d02a1a3f$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $05bd5b66d02a1a3f$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $bxRTa.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $bxRTa.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $05bd5b66d02a1a3f$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $bxRTa.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $05bd5b66d02a1a3f$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $05bd5b66d02a1a3f$export$392544347a18b6ea = (effect)=>(0, $bxRTa.useEffect)(effect, $05bd5b66d02a1a3f$var$emptyDeps);
var $05bd5b66d02a1a3f$var$emptyDeps = [];
function $05bd5b66d02a1a3f$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $bxRTa.useRef)();
    (0, $bxRTa.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $05bd5b66d02a1a3f$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $bxRTa.useState)(null);
    $05bd5b66d02a1a3f$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $05bd5b66d02a1a3f$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};

});
parcelRegister("gtRA1", function(module, exports) {

$parcel$export(module.exports, "raf", () => $78610d1aca4f97bc$export$27f233d61a9e2fa4);
// src/index.ts
var $78610d1aca4f97bc$var$updateQueue = $78610d1aca4f97bc$var$makeQueue();
var $78610d1aca4f97bc$export$27f233d61a9e2fa4 = (fn)=>$78610d1aca4f97bc$var$schedule(fn, $78610d1aca4f97bc$var$updateQueue);
var $78610d1aca4f97bc$var$writeQueue = $78610d1aca4f97bc$var$makeQueue();
$78610d1aca4f97bc$export$27f233d61a9e2fa4.write = (fn)=>$78610d1aca4f97bc$var$schedule(fn, $78610d1aca4f97bc$var$writeQueue);
var $78610d1aca4f97bc$var$onStartQueue = $78610d1aca4f97bc$var$makeQueue();
$78610d1aca4f97bc$export$27f233d61a9e2fa4.onStart = (fn)=>$78610d1aca4f97bc$var$schedule(fn, $78610d1aca4f97bc$var$onStartQueue);
var $78610d1aca4f97bc$var$onFrameQueue = $78610d1aca4f97bc$var$makeQueue();
$78610d1aca4f97bc$export$27f233d61a9e2fa4.onFrame = (fn)=>$78610d1aca4f97bc$var$schedule(fn, $78610d1aca4f97bc$var$onFrameQueue);
var $78610d1aca4f97bc$var$onFinishQueue = $78610d1aca4f97bc$var$makeQueue();
$78610d1aca4f97bc$export$27f233d61a9e2fa4.onFinish = (fn)=>$78610d1aca4f97bc$var$schedule(fn, $78610d1aca4f97bc$var$onFinishQueue);
var $78610d1aca4f97bc$var$timeouts = [];
$78610d1aca4f97bc$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $78610d1aca4f97bc$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $78610d1aca4f97bc$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $78610d1aca4f97bc$var$timeouts.splice(i, 1);
        $78610d1aca4f97bc$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $78610d1aca4f97bc$var$timeouts.splice($78610d1aca4f97bc$var$findTimeout(time), 0, timeout);
    $78610d1aca4f97bc$var$pendingCount += 1;
    $78610d1aca4f97bc$var$start();
    return timeout;
};
var $78610d1aca4f97bc$var$findTimeout = (time)=>~(~$78610d1aca4f97bc$var$timeouts.findIndex((t)=>t.time > time) || ~$78610d1aca4f97bc$var$timeouts.length);
$78610d1aca4f97bc$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $78610d1aca4f97bc$var$onStartQueue.delete(fn);
    $78610d1aca4f97bc$var$onFrameQueue.delete(fn);
    $78610d1aca4f97bc$var$onFinishQueue.delete(fn);
    $78610d1aca4f97bc$var$updateQueue.delete(fn);
    $78610d1aca4f97bc$var$writeQueue.delete(fn);
};
$78610d1aca4f97bc$export$27f233d61a9e2fa4.sync = (fn)=>{
    $78610d1aca4f97bc$var$sync = true;
    $78610d1aca4f97bc$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $78610d1aca4f97bc$var$sync = false;
};
$78610d1aca4f97bc$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $78610d1aca4f97bc$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $78610d1aca4f97bc$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $78610d1aca4f97bc$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$78610d1aca4f97bc$export$27f233d61a9e2fa4.use = (impl)=>$78610d1aca4f97bc$var$nativeRaf = impl;
$78610d1aca4f97bc$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$78610d1aca4f97bc$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$78610d1aca4f97bc$export$27f233d61a9e2fa4.catch = console.error;
$78610d1aca4f97bc$export$27f233d61a9e2fa4.frameLoop = "always";
$78610d1aca4f97bc$export$27f233d61a9e2fa4.advance = ()=>{
    if ($78610d1aca4f97bc$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $78610d1aca4f97bc$var$update();
};
var $78610d1aca4f97bc$var$ts = -1;
var $78610d1aca4f97bc$var$pendingCount = 0;
var $78610d1aca4f97bc$var$sync = false;
function $78610d1aca4f97bc$var$schedule(fn, queue) {
    if ($78610d1aca4f97bc$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $78610d1aca4f97bc$var$start();
    }
}
function $78610d1aca4f97bc$var$start() {
    if ($78610d1aca4f97bc$var$ts < 0) {
        $78610d1aca4f97bc$var$ts = 0;
        if ($78610d1aca4f97bc$export$27f233d61a9e2fa4.frameLoop !== "demand") $78610d1aca4f97bc$var$nativeRaf($78610d1aca4f97bc$var$loop);
    }
}
function $78610d1aca4f97bc$var$stop() {
    $78610d1aca4f97bc$var$ts = -1;
}
function $78610d1aca4f97bc$var$loop() {
    if (~$78610d1aca4f97bc$var$ts) {
        $78610d1aca4f97bc$var$nativeRaf($78610d1aca4f97bc$var$loop);
        $78610d1aca4f97bc$export$27f233d61a9e2fa4.batchedUpdates($78610d1aca4f97bc$var$update);
    }
}
function $78610d1aca4f97bc$var$update() {
    const prevTs = $78610d1aca4f97bc$var$ts;
    $78610d1aca4f97bc$var$ts = $78610d1aca4f97bc$export$27f233d61a9e2fa4.now();
    const count = $78610d1aca4f97bc$var$findTimeout($78610d1aca4f97bc$var$ts);
    if (count) {
        $78610d1aca4f97bc$var$eachSafely($78610d1aca4f97bc$var$timeouts.splice(0, count), (t)=>t.handler());
        $78610d1aca4f97bc$var$pendingCount -= count;
    }
    if (!$78610d1aca4f97bc$var$pendingCount) {
        $78610d1aca4f97bc$var$stop();
        return;
    }
    $78610d1aca4f97bc$var$onStartQueue.flush();
    $78610d1aca4f97bc$var$updateQueue.flush(prevTs ? Math.min(64, $78610d1aca4f97bc$var$ts - prevTs) : 16.667);
    $78610d1aca4f97bc$var$onFrameQueue.flush();
    $78610d1aca4f97bc$var$writeQueue.flush();
    $78610d1aca4f97bc$var$onFinishQueue.flush();
}
function $78610d1aca4f97bc$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $78610d1aca4f97bc$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $78610d1aca4f97bc$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $78610d1aca4f97bc$var$pendingCount -= current.size;
                $78610d1aca4f97bc$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $78610d1aca4f97bc$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $78610d1aca4f97bc$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $78610d1aca4f97bc$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $78610d1aca4f97bc$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $78610d1aca4f97bc$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $78610d1aca4f97bc$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $78610d1aca4f97bc$var$ts = -1;
        $78610d1aca4f97bc$var$timeouts = [];
        $78610d1aca4f97bc$var$onStartQueue = $78610d1aca4f97bc$var$makeQueue();
        $78610d1aca4f97bc$var$updateQueue = $78610d1aca4f97bc$var$makeQueue();
        $78610d1aca4f97bc$var$onFrameQueue = $78610d1aca4f97bc$var$makeQueue();
        $78610d1aca4f97bc$var$writeQueue = $78610d1aca4f97bc$var$makeQueue();
        $78610d1aca4f97bc$var$onFinishQueue = $78610d1aca4f97bc$var$makeQueue();
        $78610d1aca4f97bc$var$pendingCount = 0;
    }
};

});


parcelRegister("b1Sgt", function(module, exports) {

$parcel$export(module.exports, "getAnimated", () => $f5c2412cc94227ab$export$6b63995194a3a9e4);
$parcel$export(module.exports, "setAnimated", () => $f5c2412cc94227ab$export$b553cb5b22b81b04);
$parcel$export(module.exports, "getPayload", () => $f5c2412cc94227ab$export$ccab2b64c5d440);
$parcel$export(module.exports, "AnimatedValue", () => $f5c2412cc94227ab$export$cb1e8f3c05d37ad5);
$parcel$export(module.exports, "AnimatedString", () => $f5c2412cc94227ab$export$f6c6c4cbd7fa5b93);
$parcel$export(module.exports, "AnimatedObject", () => $f5c2412cc94227ab$export$f1b0b9e366a6e2d4);
$parcel$export(module.exports, "getAnimatedType", () => $f5c2412cc94227ab$export$e6b77ddbe47b132e);
$parcel$export(module.exports, "createHost", () => $f5c2412cc94227ab$export$4ee5c78f6dcbcef);
// src/Animated.ts

var $2aMjv = parcelRequire("2aMjv");
var $gtRA1 = parcelRequire("gtRA1");

var $bxRTa = parcelRequire("bxRTa");
var $f5c2412cc94227ab$var$$node = Symbol.for("Animated:node");
var $f5c2412cc94227ab$export$3df5e165e801a70f = (value)=>!!value && value[$f5c2412cc94227ab$var$$node] === value;
var $f5c2412cc94227ab$export$6b63995194a3a9e4 = (owner)=>owner && owner[$f5c2412cc94227ab$var$$node];
var $f5c2412cc94227ab$export$b553cb5b22b81b04 = (owner, node)=>(0, $2aMjv.defineHidden)(owner, $f5c2412cc94227ab$var$$node, node);
var $f5c2412cc94227ab$export$ccab2b64c5d440 = (owner)=>owner && owner[$f5c2412cc94227ab$var$$node] && owner[$f5c2412cc94227ab$var$$node].getPayload();
var $f5c2412cc94227ab$export$31627395a3b18e54 = class {
    constructor(){
        $f5c2412cc94227ab$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $f5c2412cc94227ab$export$cb1e8f3c05d37ad5 = class extends $f5c2412cc94227ab$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $2aMjv.is).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $f5c2412cc94227ab$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $2aMjv.is).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $2aMjv.is).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $f5c2412cc94227ab$export$f6c6c4cbd7fa5b93 = class extends $f5c2412cc94227ab$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $2aMjv.createInterpolator)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $f5c2412cc94227ab$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $2aMjv.is).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $2aMjv.createInterpolator)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $f5c2412cc94227ab$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $f5c2412cc94227ab$export$f1b0b9e366a6e2d4 = class extends $f5c2412cc94227ab$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $2aMjv.eachProp)(this.source, (source, key)=>{
            if ($f5c2412cc94227ab$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $2aMjv.hasFluidValue)(source)) values[key] = (0, $2aMjv.getFluidValue)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $2aMjv.each)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $2aMjv.eachProp)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($f5c2412cc94227ab$var$TreeContext.dependencies && (0, $2aMjv.hasFluidValue)(source)) $f5c2412cc94227ab$var$TreeContext.dependencies.add(source);
        const payload = $f5c2412cc94227ab$export$ccab2b64c5d440(source);
        if (payload) (0, $2aMjv.each)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $f5c2412cc94227ab$export$ede394683406942d = class extends $f5c2412cc94227ab$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $f5c2412cc94227ab$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($f5c2412cc94227ab$var$makeAnimated));
        return true;
    }
};
function $f5c2412cc94227ab$var$makeAnimated(value) {
    const nodeType = (0, $2aMjv.isAnimatedString)(value) ? $f5c2412cc94227ab$export$f6c6c4cbd7fa5b93 : $f5c2412cc94227ab$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $f5c2412cc94227ab$export$e6b77ddbe47b132e(value) {
    const parentNode = $f5c2412cc94227ab$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $2aMjv.is).arr(value) ? $f5c2412cc94227ab$export$ede394683406942d : (0, $2aMjv.isAnimatedString)(value) ? $f5c2412cc94227ab$export$f6c6c4cbd7fa5b93 : $f5c2412cc94227ab$export$cb1e8f3c05d37ad5;
}
var $f5c2412cc94227ab$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $2aMjv.is).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $bxRTa.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $bxRTa.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $bxRTa.useCallback)((value)=>{
            instanceRef.current = $f5c2412cc94227ab$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $f5c2412cc94227ab$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $2aMjv.useForceUpdate)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $f5c2412cc94227ab$var$PropsObserver(callback, deps);
        const observerRef = (0, $bxRTa.useRef)();
        (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
            observerRef.current = observer;
            (0, $2aMjv.each)(deps, (dep)=>(0, $2aMjv.addFluidObserver)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $2aMjv.each)(observerRef.current.deps, (dep)=>(0, $2aMjv.removeFluidObserver)(dep, observerRef.current));
                    (0, $gtRA1.raf).cancel(observerRef.current.update);
                }
            };
        });
        (0, $bxRTa.useEffect)(callback, []);
        (0, $2aMjv.useOnce)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $2aMjv.each)(observer2.deps, (dep)=>(0, $2aMjv.removeFluidObserver)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $bxRTa.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $f5c2412cc94227ab$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $gtRA1.raf).write(this.update);
    }
};
function $f5c2412cc94227ab$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $f5c2412cc94227ab$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $f5c2412cc94227ab$export$f1b0b9e366a6e2d4(props);
    $f5c2412cc94227ab$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $f5c2412cc94227ab$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $2aMjv.is).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $f5c2412cc94227ab$var$cacheKey = Symbol.for("AnimatedComponent");
var $f5c2412cc94227ab$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $f5c2412cc94227ab$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $f5c2412cc94227ab$var$getDisplayName(Component) || "Anonymous";
        if ((0, $2aMjv.is).str(Component)) Component = animated[Component] || (animated[Component] = $f5c2412cc94227ab$var$withAnimated(Component, hostConfig));
        else Component = Component[$f5c2412cc94227ab$var$cacheKey] || (Component[$f5c2412cc94227ab$var$cacheKey] = $f5c2412cc94227ab$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $2aMjv.eachProp)(components, (Component, key)=>{
        if ((0, $2aMjv.is).arr(components)) key = $f5c2412cc94227ab$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $f5c2412cc94227ab$var$getDisplayName = (arg)=>(0, $2aMjv.is).str(arg) ? arg : arg && (0, $2aMjv.is).str(arg.displayName) ? arg.displayName : (0, $2aMjv.is).fun(arg) && arg.name || null;

});

parcelRegister("5od7d", function(module, exports) {
// src/utils.ts
var $d14fc60eedae7441$export$b24b633b1364b94b = class {
};

});



parcelRegister("kaFO8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6737f9caded417b5$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
const $6737f9caded417b5$var$useFullscreenImage = ()=>{
    const lastbotActivity = (0, $5FZWK.useSelector)((state)=>state.activityReducer.lastBotActivity);
    const fullScreenImage = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.fullScreenImage);
    const [image, setImage] = (0, $bxRTa.useState)(undefined);
    (0, $bxRTa.useEffect)(()=>{
        setImage(fullScreenImage);
    }, [
        fullScreenImage
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (lastbotActivity && lastbotActivity.type === 'event' && lastbotActivity.name === 'hospitality.ShowImage' && lastbotActivity.value) setImage(lastbotActivity.value);
        else setImage(undefined);
    }, [
        lastbotActivity
    ]);
    return image;
};
var $6737f9caded417b5$export$2e2bcd8739ae039 = $6737f9caded417b5$var$useFullscreenImage;

});

parcelRegister("aBDai", function(module, exports) {

$parcel$export(module.exports, "getColorWithTransparency", () => $b6ebd48cdf39835a$export$730331b97844b22d);
$parcel$export(module.exports, "hexToRgb", () => $b6ebd48cdf39835a$export$5a544e13ad4e1fa5);
const $b6ebd48cdf39835a$export$730331b97844b22d = (color, transparency)=>{
    let tempColorObject = null;
    try {
        tempColorObject = color.includes('rgb') ? $b6ebd48cdf39835a$var$rgbToObject(color) : $b6ebd48cdf39835a$export$5a544e13ad4e1fa5(color);
    } catch (error) {
        console.log(error);
    }
    if (tempColorObject) return `rgba(${tempColorObject.r}, ${tempColorObject.g}, ${tempColorObject.b}, ${transparency})`;
    return color;
};
const $b6ebd48cdf39835a$export$186ed2fadd5d0f9d = (color)=>{
    let tempColorObject = null;
    try {
        tempColorObject = color.includes('rgb') ? $b6ebd48cdf39835a$var$rgbToObject(color) : $b6ebd48cdf39835a$export$5a544e13ad4e1fa5(color);
    } catch (error) {
        console.log(error);
    }
    if (tempColorObject) return `rgba(${tempColorObject.r / 2}, ${tempColorObject.g / 2}, ${tempColorObject.b / 2})`;
    return color;
};
const $b6ebd48cdf39835a$var$rgbToObject = (rgb)=>{
    // Replace unwanted characters
    rgb = rgb.replace('rgb(', '');
    rgb = rgb.replace(')', '');
    rgb = rgb.replace(' ', '');
    const stringArray = rgb.split(',');
    return {
        r: parseInt(stringArray[0], 16),
        g: parseInt(stringArray[1], 16),
        b: parseInt(stringArray[2], 16)
    };
};
const $b6ebd48cdf39835a$export$5a544e13ad4e1fa5 = (hex)=>{
    // Remove '#' char if present
    if (hex.charAt(0) === '#') hex = hex.slice(1);
    // Transform if shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    return {
        r: parseInt(hex.slice(0, 2), 16),
        g: parseInt(hex.slice(2, 4), 16),
        b: parseInt(hex.slice(4), 16)
    };
};

});

parcelRegister("9TTQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $36ca07486db72ee2$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
parcelRequire("kMAJU");
var $04Syy = parcelRequire("04Syy");
const $36ca07486db72ee2$var$CloseButton = ({ onClick: onClick, label: label, showLabel: showLabel })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        "aria-label": label || translation.common.close,
        onClick: onClick,
        className: "rf-absolute rf-z-[2] rf-flex rf-flex-col rf-items-center rf-right-0 rf-top-0 rf-p-2",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $04Syy.default), {
                className: "rf-h-6 rf-w-6"
            }),
            showLabel && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-text-[0.5rem] rf-uppercase",
                children: label || translation.common.close
            })
        ]
    });
};
var $36ca07486db72ee2$export$2e2bcd8739ae039 = $36ca07486db72ee2$var$CloseButton;

});

parcelRegister("2roA1", function(module, exports) {
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.41", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HONOR = "Honor", HUAWEI = "Huawei", LENOVO = "Lenovo", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPERA = "Opera", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Maxthon"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI" + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "360"
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1Browser"
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1" + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /\b(links) \(([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        OnePlus: [
                            "304",
                            "403",
                            "203"
                        ],
                        "*": OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    "Nokia"
                ]
            ],
            [
                /(pixel (c|tablet))\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "TCL"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        tablet: [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Energizer"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Cat"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Smartfren"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nothing"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    "LibWeb"
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Touch"
                ],
                VERSION
            ],
            [
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("d72S7", function(module, exports) {

$parcel$export(module.exports, "CommentsPennantIcon", () => (parcelRequire("a0inq")).default);
$parcel$export(module.exports, "FavoriteIcon", () => (parcelRequire("1olzu")).default);
$parcel$export(module.exports, "FavoriteLightIcon", () => (parcelRequire("79eFo")).default);
$parcel$export(module.exports, "PhoneIcon", () => (parcelRequire("41UZV")).default);
$parcel$export(module.exports, "PhotoCameraIcon", () => (parcelRequire("epsYO")).default);
$parcel$export(module.exports, "PrintIcon", () => (parcelRequire("57bW7")).default);
$parcel$export(module.exports, "RoundIcon", () => (parcelRequire("cUlNP")).default);

var $a0inq = parcelRequire("a0inq");

var $1olzu = parcelRequire("1olzu");

var $79eFo = parcelRequire("79eFo");

var $41UZV = parcelRequire("41UZV");

var $epsYO = parcelRequire("epsYO");

var $57bW7 = parcelRequire("57bW7");

var $cUlNP = parcelRequire("cUlNP");

});
parcelRegister("a0inq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cceacee5cdad80cb$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $cceacee5cdad80cb$var$CommentsPennantIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 72.258 45",
        className: className || 'w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-2203.071 -428.34)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M11.129,3l2.512,5.089,5.617.821-4.064,3.959.959,5.593-5.024-2.642L6.105,18.461l.959-5.593L3,8.91l5.617-.821Z",
                    transform: "translate(2201.071 426.34)",
                    fill: "none",
                    stroke: color || '#ffffff',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M11.129,3l2.512,5.089,5.617.821-4.064,3.959.959,5.593-5.024-2.642L6.105,18.461l.959-5.593L3,8.91l5.617-.821Z",
                    transform: "translate(2255.071 426.34)",
                    fill: "none",
                    stroke: color || '#ffffff',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M28,11.225A5.775,5.775,0,1,1,22.225,17,5.774,5.774,0,0,1,28,11.225m0,24.75c8.167,0,16.775,4.015,16.775,5.775v3.025H11.225V41.75c0-1.76,8.608-5.775,16.775-5.775M28,6A11,11,0,1,0,39,17,11,11,0,0,0,28,6Zm0,24.75c-7.342,0-22,3.685-22,11V50H50V41.75C50,34.435,35.343,30.75,28,30.75Z",
                    transform: "translate(2211 423.34)",
                    fill: color || '#ffffff'
                })
            ]
        })
    });
};
var $cceacee5cdad80cb$export$2e2bcd8739ae039 = $cceacee5cdad80cb$var$CommentsPennantIcon;

});

parcelRegister("1olzu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2f8d34a582e0db4$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $b2f8d34a582e0db4$var$FavoriteIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: className || '',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 72 72",
            className: "rf-h-full",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M413.444,281.927a24.4,24.4,0,1,0,24.4,24.4A24.4,24.4,0,0,0,413.444,281.927Zm12.233,30.989a51.118,51.118,0,0,1-9.936,9.6l-2.3,1.654-2.3-1.654a51.118,51.118,0,0,1-9.936-9.6,17.7,17.7,0,0,1-3.462-9.826,10.357,10.357,0,0,1,10.227-10.321h.095a10.267,10.267,0,0,1,5.373,1.514,10.271,10.271,0,0,1,5.373-1.514h.095a10.357,10.357,0,0,1,10.226,10.321A17.7,17.7,0,0,1,425.677,312.916Z",
                    transform: "translate(-380.234 -271.942)",
                    fill: "#0c89a2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M428.741,308.235h-.057a6.436,6.436,0,0,0-5.373,2.941,6.435,6.435,0,0,0-5.373-2.941h-.057a6.394,6.394,0,0,0-6.335,6.391,13.766,13.766,0,0,0,2.7,7.505,47.374,47.374,0,0,0,9.06,8.727,47.369,47.369,0,0,0,9.061-8.727,13.765,13.765,0,0,0,2.7-7.505A6.394,6.394,0,0,0,428.741,308.235Z",
                    transform: "translate(-390.101 -283.478)",
                    fill: "#cb0038"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M379.123,306.092l.984-.568a3.667,3.667,0,1,1-4.851-1.228l.554,1a2.435,2.435,0,0,0-1.228,1.529,2.533,2.533,0,0,0,4.873,1.339A2.519,2.519,0,0,0,379.123,306.092Z",
                            transform: "translate(-373.354 -281.75)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M383.877,292.134a3.579,3.579,0,1,1-4.955,1.283A3.524,3.524,0,0,1,383.877,292.134Zm-.614,1.07a2.35,2.35,0,1,0,1.007,3.281A2.36,2.36,0,0,0,383.263,293.2Z",
                            transform: "translate(-375.577 -276.186)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M388.494,279.91l.851-.864,3.212,3.162a2.729,2.729,0,0,1-3.83,3.889l-3.211-3.163.85-.864,3.1,3.056a1.525,1.525,0,1,0,2.127-2.161Z",
                            transform: "translate(-378.687 -270.679)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M396.125,274.77l2.02-1.306a2.265,2.265,0,1,1,2.457,3.8l-1,.647,1.382,2.138-1.018.658Zm4.181-.008a1.092,1.092,0,0,0-1.664-.248l-.874.564,1.206,1.867.874-.565A1.092,1.092,0,0,0,400.306,274.762Z",
                            transform: "translate(-383.338 -268.046)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M418.982,268.841a3.387,3.387,0,0,1-2.494,4.305l-2.211.575-1.782-6.847,2.211-.576A3.387,3.387,0,0,1,418.982,268.841Zm-1.194.311a2.247,2.247,0,0,0-2.772-1.743l-1.056.275,1.2,4.617,1.057-.275A2.254,2.254,0,0,0,417.788,269.151Z",
                            transform: "translate(-390.516 -265.032)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M427.818,267.132l2.828-.109.044,1.151-2.827.11.073,1.9,3.132-.122.044,1.151-4.343.17-.275-7.07,4.282-.167.045,1.151-3.07.12Z",
                            transform: "translate(-396.655 -264.145)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M446.9,272.151l.56.988a3.666,3.666,0,1,1,1.268-4.839l-1.006.544a2.431,2.431,0,0,0-1.518-1.239,2.532,2.532,0,0,0-1.38,4.86A2.519,2.519,0,0,0,446.9,272.151Z",
                            transform: "translate(-403.416 -265.121)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M460.445,277.009a3.579,3.579,0,1,1-1.242-4.964A3.523,3.523,0,0,1,460.445,277.009Zm-1.064-.622a2.35,2.35,0,1,0-3.289.98A2.361,2.361,0,0,0,459.381,276.386Z",
                            transform: "translate(-408.594 -267.384)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M467.155,281.565l2.048,1.953-.8.834L466.36,282.4l-1.311,1.375,2.268,2.162-.8.834-3.145-3,4.882-5.12,3.1,2.957-.8.834-2.224-2.12Z",
                            transform: "translate(-412.827 -270.506)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M478.916,290.648l.678,1.006-3.737,2.52a2.729,2.729,0,0,1-3.052-4.525l3.738-2.521.678,1.006-3.612,2.435a1.525,1.525,0,1,0,1.7,2.514Z",
                            transform: "translate(-416.422 -274.223)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M482.854,299.49l.848,2.165a2.168,2.168,0,0,1-1.2,2.987,2.045,2.045,0,0,1-2.552-.694l-1.915,2.649-.516-1.317,1.873-2.535-.2-.518-2.485.973-.442-1.129Zm-.8,4c.649-.254.8-.835.518-1.56l-.351-.894-1.957.766.35.894C480.9,303.425,481.406,303.748,482.055,303.494Z",
                            transform: "translate(-418.479 -279.643)",
                            fill: "#161615"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    transform: "translate(4.89 51.981)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M384.888,365.352l-.9-1.038.58-.5a2.025,2.025,0,0,1-1.846-.74,3.084,3.084,0,0,1,4.657-4.019,2.09,2.09,0,0,1,.5,1.753l3.1-2.68.969,1.122Zm1.911-3.608a1.623,1.623,0,0,0-.294-1.589,1.695,1.695,0,0,0-2.562,2.211,1.621,1.621,0,0,0,1.529.524Z",
                            transform: "translate(-382.062 -357.324)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M397.773,372.316c-.066.09-.2.269-.337.442l-3.535-2.577a1.672,1.672,0,0,0,.629,1.927,2.359,2.359,0,0,0,1.648.467l-.057,1.335a3.75,3.75,0,0,1-2.392-.7,3.078,3.078,0,0,1-.733-4.342,2.949,2.949,0,1,1,4.777,3.452Zm-.893-1.293a1.481,1.481,0,0,0-2.346-1.71Z",
                            transform: "translate(-386.596 -361.465)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M412.418,369.575l1.391.51-3.215,8.768-1.391-.511Z",
                            transform: "translate(-393.963 -362.355)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M418.264,372.236l1.265.337-.784,2.936-1.265-.337Z",
                            transform: "translate(-397.592 -363.522)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M426.423,379.222c-.013.111-.039.331-.076.551l-4.344-.5a1.671,1.671,0,0,0,1.5,1.366,2.353,2.353,0,0,0,1.662-.407l.61,1.188a3.749,3.749,0,0,1-2.427.568,3.077,3.077,0,0,1-2.779-3.414,2.948,2.948,0,1,1,5.857.646Zm-1.414-.684a1.481,1.481,0,0,0-2.884-.33Zm.961-5.025-2.384,1.816-.842-1,2.343-1.895Z",
                            transform: "translate(-398.936 -363.608)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M438.911,378.258l.963,8.642-1.473.164-.382-3.425a2.092,2.092,0,0,1-1.561.933,3.084,3.084,0,0,1-.682-6.114,2.123,2.123,0,0,1,1.857.713l-.085-.761Zm-1.247,2.2a1.62,1.62,0,0,0-1.477-.655,1.694,1.694,0,0,0,.375,3.363,1.623,1.623,0,0,0,1.3-.965Z",
                            transform: "translate(-404.51 -366.163)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M447.021,379.887l-1.251-3.581,1.4-.489,1.117,3.2a1.053,1.053,0,0,0,1.5.783,1.442,1.442,0,0,0,.86-1.06l-1.288-3.686,1.4-.489,1.933,5.529-1.307.457-.281-.805a2.111,2.111,0,0,1-4.086.145Z",
                            transform: "translate(-409.996 -364.542)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M455.552,367.9a.976.976,0,1,1-.385,1.325A.97.97,0,0,1,455.552,367.9Zm.73,2.869,1.3-.714,2.819,5.132-1.3.714Z",
                            transform: "translate(-414.063 -361.567)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M463.272,367.506l.478.6a2.125,2.125,0,0,1,.809-1.818,3.086,3.086,0,0,1,3.842,4.807,2.089,2.089,0,0,1-1.764.445l2.152,2.694-1.159.926-5.43-6.8Zm2.462,2.9a1.625,1.625,0,0,0,1.6-.234,1.7,1.7,0,0,0-2.114-2.645,1.623,1.623,0,0,0-.582,1.509Z",
                            transform: "translate(-417.201 -360.651)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M478.073,357.422c.086.069.261.207.427.355l-2.719,3.423a1.67,1.67,0,0,0,1.95-.549,2.354,2.354,0,0,0,.535-1.626l1.332.111a3.751,3.751,0,0,1-.8,2.36,3.077,3.077,0,0,1-4.367.551,2.947,2.947,0,1,1,3.646-4.626Zm-1.327.837a1.481,1.481,0,0,0-1.806,2.273Z",
                            transform: "translate(-422.028 -356.717)",
                            fill: "#161615"
                        })
                    ]
                })
            ]
        })
    });
};
var $b2f8d34a582e0db4$export$2e2bcd8739ae039 = $b2f8d34a582e0db4$var$FavoriteIcon;

});

parcelRegister("79eFo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcae149a5ba7fe08$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $dcae149a5ba7fe08$var$FavoriteLightIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 56 55",
        className: className || 'rf-h-full',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(0.465 -0.307)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("ellipse", {
                    cx: "28",
                    cy: "27.5",
                    rx: "28",
                    ry: "27.5",
                    transform: "translate(-0.465 0.307)",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M449.065,485.074a24.475,24.475,0,1,0,24.476,24.476A24.475,24.475,0,0,0,449.065,485.074Zm12.272,31.086a51.307,51.307,0,0,1-9.969,9.625l-2.3,1.659-2.3-1.659a51.425,51.425,0,0,1-9.966-9.625,17.755,17.755,0,0,1-3.474-9.857,10.391,10.391,0,0,1,10.26-10.353h.1a10.28,10.28,0,0,1,5.387,1.52,10.291,10.291,0,0,1,5.39-1.52h.1A10.388,10.388,0,0,1,464.808,506.3,17.75,17.75,0,0,1,461.337,516.16Z",
                    transform: "translate(-421.48 -482.143)",
                    fill: "#0c89a2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M445.93,489.861h-.056a6.46,6.46,0,0,0-5.39,2.947,6.45,6.45,0,0,0-5.387-2.947h-.059a6.412,6.412,0,0,0-6.353,6.409A13.817,13.817,0,0,0,431.4,503.8a47.5,47.5,0,0,0,9.086,8.752,47.479,47.479,0,0,0,9.09-8.752,13.817,13.817,0,0,0,2.712-7.529A6.413,6.413,0,0,0,445.93,489.861Z",
                    transform: "translate(-412.899 -472.11)",
                    fill: "#cb0038"
                })
            ]
        })
    });
};
var $dcae149a5ba7fe08$export$2e2bcd8739ae039 = $dcae149a5ba7fe08$var$FavoriteLightIcon;

});

parcelRegister("41UZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a39ab1584f39e386$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $a39ab1584f39e386$var$PhoneIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 40",
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
            transform: "translate(-183.86 -57.462) rotate(-21)",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                d: "M162.1,156.952a2.852,2.852,0,0,0,2.91-2.915V127.8a2.851,2.851,0,0,0-2.91-2.915H151.91A2.851,2.851,0,0,0,149,127.8v26.233a2.852,2.852,0,0,0,2.91,2.915ZM157,155.738a1.455,1.455,0,1,1,1.455-1.455A1.456,1.456,0,0,1,157,155.738Zm-2.183-29.072c0-.18.086-.322.194-.322h3.978c.106,0,.194.144.194.322v.086c0,.18-.087.322-.194.322h-3.978c-.106,0-.194-.144-.194-.322Zm-4.365,1.861h13.1V151.81h-13.1Zm0,0"
            })
        })
    });
};
var $a39ab1584f39e386$export$2e2bcd8739ae039 = $a39ab1584f39e386$var$PhoneIcon;

});

parcelRegister("epsYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $47d4c11de8d3c839$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $47d4c11de8d3c839$var$PhotoCameraIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 67.258 60.532",
        className: className || 'rf-w-6 rf-h-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(15.629 13.766)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M34.722,23.961A10.761,10.761,0,1,1,23.961,13.2,10.761,10.761,0,0,1,34.722,23.961Z",
                    transform: "translate(-5.961 -4.098)",
                    fill: color || '#f1f1f1'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M26.54,3,20.386,9.726H9.726A6.746,6.746,0,0,0,3,16.452V56.806a6.746,6.746,0,0,0,6.726,6.726H63.532a6.746,6.746,0,0,0,6.726-6.726V16.452a6.746,6.746,0,0,0-6.726-6.726H52.872L46.718,3ZM36.629,53.443A16.814,16.814,0,1,1,53.443,36.629,16.821,16.821,0,0,1,36.629,53.443Z",
                    transform: "translate(-18.629 -16.766)",
                    fill: color || '#f1f1f1'
                })
            ]
        })
    });
};
var $47d4c11de8d3c839$export$2e2bcd8739ae039 = $47d4c11de8d3c839$var$PhotoCameraIcon;

});

parcelRegister("57bW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $11cbe1500ba239e9$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $11cbe1500ba239e9$var$PrintIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24.578 24.578",
        className: className || 'rf-h-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(0.5 0.5)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M9,11.252V3H23.147v8.252",
                    transform: "translate(-4.284 -3)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M7.716,24.11H5.358A2.358,2.358,0,0,1,3,21.752V15.858A2.358,2.358,0,0,1,5.358,13.5H24.221a2.358,2.358,0,0,1,2.358,2.358v5.895a2.358,2.358,0,0,1-2.358,2.358H21.863",
                    transform: "translate(-3 -5.248)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M9,21H23.147v9.431H9Z",
                    transform: "translate(-4.284 -6.853)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                })
            ]
        })
    });
};
var $11cbe1500ba239e9$export$2e2bcd8739ae039 = $11cbe1500ba239e9$var$PrintIcon;

});

parcelRegister("cUlNP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d540d7a8841cf7f$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $3d540d7a8841cf7f$var$RoundIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20.306 20.306",
        className: className || 'rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-2 -2)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M21.306,12.153A9.153,9.153,0,1,1,12.153,3a9.153,9.153,0,0,1,9.153,9.153Z",
                    transform: "translate(0 0)",
                    fill: "none",
                    stroke: color || '#000',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M18,21.661V18",
                    transform: "translate(-5.847 -5.847)",
                    fill: "none",
                    stroke: color || '#000',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M18,12h0",
                    transform: "translate(-5.847 -3.508)",
                    fill: "none",
                    stroke: color || '#000',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                })
            ]
        })
    });
};
var $3d540d7a8841cf7f$export$2e2bcd8739ae039 = $3d540d7a8841cf7f$var$RoundIcon;

});


parcelRegister("9Alju", function(module, exports) {

$parcel$export(module.exports, "getColorFromCategoryId", () => $2bce87916a747938$export$7c3e7489ecac4759);

var $2rYkD = parcelRequire("2rYkD");
const $2bce87916a747938$export$7c3e7489ecac4759 = (id, themeColors)=>{
    let color = themeColors.secondary;
    if (id) switch(id.toLowerCase()){
        case (0, $2rYkD.CategoryId).eat:
            color = themeColors.whereToEatColor;
            break;
        case (0, $2rYkD.CategoryId).sleep:
            color = themeColors.whereToSleepColor;
            break;
        case (0, $2rYkD.CategoryId).see:
            color = themeColors.tobeSeenColor;
            break;
        case (0, $2rYkD.CategoryId).do:
            color = themeColors.tobeDoneColor;
            break;
        case (0, $2rYkD.CategoryId).localproducts:
            color = themeColors.localProductsColor;
            break;
        case (0, $2rYkD.CategoryId).services:
            color = themeColors.servicesColor;
            break;
        case (0, $2rYkD.CategoryId).agenda:
            color = themeColors.agendaColor;
            break;
        case (0, $2rYkD.CategoryId).occupant:
            color = themeColors.occupantColor;
            break;
        default:
            color = themeColors.secondary;
            break;
    }
    return color;
};

});

parcelRegister("k4qlo", function(module, exports) {

$parcel$export(module.exports, "default", () => $45faa0a4bd982593$export$2e2bcd8739ae039);
// Check if we should let the event propagate. For example leaflet events should pass to allow map panning
const $45faa0a4bd982593$var$checkShouldPropagate = (e)=>{
    if (e.target) try {
        const className = e.target.className;
        return className && typeof className === 'string' ? className.includes('leaflet') : false;
    } catch  {
        return false;
    }
    else return false;
};
const $45faa0a4bd982593$var$handleStop = (e)=>{
    !$45faa0a4bd982593$var$checkShouldPropagate(e) && e.cancelable && e.preventDefault();
};
const $45faa0a4bd982593$var$handleRefStop = (e, ref, reversed)=>{
    if (!$45faa0a4bd982593$var$checkShouldPropagate(e) && e.cancelable && ref.current) {
        const scrollHeight = ref.current.scrollHeight;
        const scrollTop = ref.current.scrollTop;
        const clientHeight = ref.current.clientHeight;
        // If no overflow, prevent event default
        if (scrollHeight === clientHeight) e.preventDefault();
        else if (e.type === 'wheel') {
            if (reversed) scrollTop >= 0 ? e.deltaY > 0 && e.preventDefault() : -scrollTop + clientHeight >= scrollHeight - 5 && e.deltaY < 0 && e.preventDefault();
            else scrollTop === 0 ? e.deltaY < 0 && e.preventDefault() : scrollTop + clientHeight >= scrollHeight - 5 && e.deltaY > 0 && e.preventDefault();
        } else if (e.type === 'touchmove') {
            if (e.touches.length > 1) e.preventDefault();
            else {
                const positionInLocalStorage = localStorage.getItem('Retorik.Framework.TouchY');
                const origin = positionInLocalStorage ? parseInt(positionInLocalStorage) : null;
                if (origin && !isNaN(origin)) {
                    const currentY = e.touches.length > 0 ? e.touches[0].screenY : null;
                    if (currentY || currentY === 0) {
                        const deltaY = origin - currentY;
                        if (reversed) scrollTop >= 0 ? deltaY > 0 && e.preventDefault() : -scrollTop + clientHeight >= scrollHeight - 5 && deltaY < 0 && e.preventDefault();
                        else scrollTop === 0 ? deltaY < 0 && e.preventDefault() : scrollTop + clientHeight >= scrollHeight - 5 && deltaY > 0 && e.preventDefault();
                    } else e.preventDefault();
                } else e.preventDefault();
            }
        }
        e.stopImmediatePropagation();
    }
};
const $45faa0a4bd982593$var$handleTouch = (e)=>{
    localStorage.setItem('Retorik.Framework.TouchY', `${e.touches[0].screenY}`);
    e.touches.length > 1 && !$45faa0a4bd982593$var$checkShouldPropagate(e) && e.cancelable && e.preventDefault();
};
/**
 * Attach wheel | touch events on either a HTMLElement or a reference to a HTMLDivElement to prevent the propagation of this events to parent window.
 * @param {HTMLElement | null} element HTMLElement to which we will attach the events
 * @param {React.RefObject<HTMLDivElement>} ref reference to the HTMLDivElement to which we will attach the events
 * @param {AbortSignal} signal abort signal to remove events when needed
 */ const $45faa0a4bd982593$var$preventEvents = (element, ref, signal, reversed)=>{
    // Add abort signal to options if present
    const options = signal ? {
        passive: false,
        signal: signal
    } : {
        passive: false
    };
    if (ref?.current) {
        try {
            ref.current.removeEventListener('wheel', (e)=>$45faa0a4bd982593$var$handleRefStop(e, ref, !!reversed));
            ref.current.removeEventListener('touchstart', (e)=>$45faa0a4bd982593$var$handleTouch(e));
            ref.current.removeEventListener('touchmove', (e)=>$45faa0a4bd982593$var$handleRefStop(e, ref, !!reversed));
        } catch (err) {
            console.warn(err);
        }
        ref.current.addEventListener('wheel', (e)=>$45faa0a4bd982593$var$handleRefStop(e, ref, !!reversed), options);
        ref.current.addEventListener('touchstart', (e)=>$45faa0a4bd982593$var$handleTouch(e), options);
        ref.current.addEventListener('touchmove', (e)=>$45faa0a4bd982593$var$handleRefStop(e, ref, !!reversed), options);
    } else if (element) {
        element.addEventListener('wheel', (e)=>$45faa0a4bd982593$var$handleStop(e), options);
        element.addEventListener('touchstart', (e)=>$45faa0a4bd982593$var$handleTouch(e), options);
        element.addEventListener('touchmove', (e)=>$45faa0a4bd982593$var$handleStop(e), options);
    }
};
var $45faa0a4bd982593$export$2e2bcd8739ae039 = $45faa0a4bd982593$var$preventEvents;

});

parcelRegister("gPs3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa8790210aa8073e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");

var $iU6tk = parcelRequire("iU6tk");

var $9TTQJ = parcelRequire("9TTQJ");
var $aa8790210aa8073e$var$ClosingButton = /*#__PURE__*/ function(ClosingButton) {
    ClosingButton[ClosingButton["none"] = 1] = "none";
    ClosingButton[ClosingButton["cross"] = 2] = "cross";
    ClosingButton[ClosingButton["text"] = 3] = "text";
    ClosingButton[ClosingButton["mobileTextBack"] = 4] = "mobileTextBack";
    ClosingButton[ClosingButton["mobileTextBackConversation"] = 5] = "mobileTextBackConversation";
    return ClosingButton;
}($aa8790210aa8073e$var$ClosingButton || {});
const $aa8790210aa8073e$var$TemplateGlobal = ({ target: target, display: display, animation: animation, remote: remote, onClick: onClick, children: children })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const useOldRemote = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.useOldRemote);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const isLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isLandscape);
    const isBorne = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isBorne);
    const displayControls = (0, $5FZWK.useSelector)((state)=>state.viewReducer.displayControls);
    const route = (0, $5FZWK.useSelector)((state)=>state.viewReducer.route);
    const [colStart, setColStart] = (0, $bxRTa.useState)(1);
    const [zIndex, setZIndex] = (0, $bxRTa.useState)(30);
    const [justifySelf, setJustifySelf] = (0, $bxRTa.useState)('unset');
    const [background, setBackground] = (0, $bxRTa.useState)('linear-gradient(to right bottom, #F8F8FC , #E1E2E8)');
    const [marginBottom, setMarginBottom] = (0, $bxRTa.useState)(0);
    (0, $bxRTa.useEffect)(()=>{
        switch(target){
            case (0, $2rYkD.TemplateTarget).languages:
            case (0, $2rYkD.TemplateTarget).history:
                setColStart(isLandscape ? 5 : 1);
                setJustifySelf(isLandscape ? 'center' : 'unset');
                setBackground('#FFF');
                setMarginBottom(isMobile && displayControls ? '3rem' : 0);
                break;
            case (0, $2rYkD.TemplateTarget).map:
                setZIndex(20);
                break;
            case (0, $2rYkD.TemplateTarget).emergency:
            case (0, $2rYkD.TemplateTarget).weather:
                setBackground(isMobile ? '#FFF' : 'linear-gradient(to right bottom, #F2F8F8FC , #F2E1E2E8)');
                break;
            case (0, $2rYkD.TemplateTarget).mobileConversation:
                setZIndex(3);
                setJustifySelf('center');
                setBackground('#FFFFFFCC');
                break;
            case (0, $2rYkD.TemplateTarget).mobileOther:
                setBackground('#FFF');
                break;
            case (0, $2rYkD.TemplateTarget).modal:
                setZIndex(50);
                setBackground('#121212B3');
                break;
            default:
                setZIndex(30);
                setBackground('linear-gradient(to right bottom, #F8F8FC , #E1E2E8)');
                break;
        }
        setMarginBottom(isMobile && displayControls && target !== (0, $2rYkD.TemplateTarget).mobileConversation ? '3rem' : 0);
    }, [
        target,
        isLandscape,
        isMobile
    ]);
    const closingButton = (0, $bxRTa.useMemo)(()=>{
        if (isMobile) switch(target){
            case (0, $2rYkD.TemplateTarget).languages:
                return 4;
            case (0, $2rYkD.TemplateTarget).mobileConversation:
            case (0, $2rYkD.TemplateTarget).modal:
            case (0, $2rYkD.TemplateTarget).list:
            case (0, $2rYkD.TemplateTarget).detailedAttachment:
                return 1;
            case (0, $2rYkD.TemplateTarget).mobileOther:
            case (0, $2rYkD.TemplateTarget).weather:
                return 5;
            default:
                return 4;
        }
        else if (isLandscape) switch(target){
            case (0, $2rYkD.TemplateTarget).languages:
            case (0, $2rYkD.TemplateTarget).history:
                return 3;
            case (0, $2rYkD.TemplateTarget).list:
            case (0, $2rYkD.TemplateTarget).detailedAttachment:
                return 2;
            default:
                // TODO use TemplateGlobal in NewsView and change this condition
                return !useOldRemote && route !== (0, $2rYkD.Routes).News ? 2 : 1;
        }
        return 1;
    }, [
        target,
        isMobile,
        isLandscape,
        useOldRemote,
        route,
        displayControls
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
        id: `retorik-framework-template-${target}`,
        className: "rf-relative rf-max-h-full rf-col-span-full rf-row-start-1 rf-row-span-full rf-text-trueblack rf-flex rf-flex-col rf-items-center",
        style: {
            visibility: display === false ? 'hidden' : 'visible',
            width: isLandscape && (target === (0, $2rYkD.TemplateTarget).languages || target === (0, $2rYkD.TemplateTarget).history) ? '60%' : target === (0, $2rYkD.TemplateTarget).mobileConversation ? '100%' : 'unset',
            maxWidth: target === (0, $2rYkD.TemplateTarget).mobileConversation ? '100%' : 'unset',
            marginRight: !isMobile && remote && !(isLandscape && (target === (0, $2rYkD.TemplateTarget).languages || target === (0, $2rYkD.TemplateTarget).history)) ? '7.5rem' : 0,
            marginBottom: marginBottom,
            zIndex: zIndex,
            gridColumnStart: colStart,
            justifyContent: target === (0, $2rYkD.TemplateTarget).modal ? 'center' : undefined,
            justifySelf: justifySelf,
            background: background,
            ...animation
        },
        onClick: target === (0, $2rYkD.TemplateTarget).modal ? (event)=>onClick?.(event) : ()=>{},
        children: [
            closingButton === 1 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : closingButton === 2 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                onClick: ()=>onClick?.(),
                showLabel: true
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iU6tk.default), {
                title: closingButton === 4 ? translation.common.back : translation.menu.backconversation,
                handleBack: ()=>onClick?.()
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-h-full rf-flex rf-flex-col ${isBorne ? 'rf-text-size-auto' : ''} rf-scrollbar-hidden`,
                style: {
                    width: !isMobile && (target === (0, $2rYkD.TemplateTarget).languages || target === (0, $2rYkD.TemplateTarget).history) ? 'fit-content' : '100%',
                    maxWidth: isBorne && (target === (0, $2rYkD.TemplateTarget).languages || target === (0, $2rYkD.TemplateTarget).history) ? '66%' : '100%',
                    overflow: target === (0, $2rYkD.TemplateTarget).mobileConversation ? 'hidden' : 'scroll'
                },
                children: children
            })
        ]
    });
};
var $aa8790210aa8073e$export$2e2bcd8739ae039 = $aa8790210aa8073e$var$TemplateGlobal;

});
parcelRegister("iU6tk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a67c1e41002f9f1$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
const $1a67c1e41002f9f1$var$BackButton = ({ title: title, handleBack: handleBack })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-relative rf-w-full rf-flex rf-flex-row rf-items-center rf-pb-6 rf-pl-4 rf-pt-4 large:rf-pt-8",
        onClick: handleBack,
        "aria-label": title,
        "data-map": "fermer",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                className: "rf-w-8"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-1",
                children: (0, $eO5xw.capitalizeFirstLetter)(title)
            })
        ]
    });
};
var $1a67c1e41002f9f1$export$2e2bcd8739ae039 = $1a67c1e41002f9f1$var$BackButton;

});
parcelRegister("hNqlv", function(module, exports) {

$parcel$export(module.exports, "ArrowDownIcon", () => (parcelRequire("1NaGJ")).default);
$parcel$export(module.exports, "ArrowLeftIcon", () => (parcelRequire("4QFhT")).default);
$parcel$export(module.exports, "ArrowRightIcon", () => (parcelRequire("dH58k")).default);
$parcel$export(module.exports, "ArrowUpIcon", () => (parcelRequire("1dNUX")).default);

var $1NaGJ = parcelRequire("1NaGJ");

var $jSDhU = parcelRequire("jSDhU");

var $67LuN = parcelRequire("67LuN");

var $4QFhT = parcelRequire("4QFhT");

var $dH58k = parcelRequire("dH58k");

var $1dNUX = parcelRequire("1dNUX");

});
parcelRegister("1NaGJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a314903fe03abb5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $3a314903fe03abb5$var$ArrowDownIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || 'currentColor',
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M14 11.18 24.6.58a2 2 0 0 1 2.82 0 2.02 2.02 0 0 1 0 2.84l-12 12a2 2 0 0 1-2.76.05L.58 3.44A2 2 0 0 1 3.41.6Z"
        })
    });
};
var $3a314903fe03abb5$export$2e2bcd8739ae039 = $3a314903fe03abb5$var$ArrowDownIcon;

});

parcelRegister("jSDhU", function(module, exports) {

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $c86177602ef72c59$var$ArrowIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43.776 39.197",
        className: className || 'rf-h-6 rf-w-8',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(9.939 -0.321) rotate(17)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M28.156,0S31.392,28.156,0,28.156",
                    transform: "translate(5.721 0)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M0,0,8.8,8.8l8.8-8.8",
                    transform: "translate(8.688 18.779) rotate(81)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeWidth: "2"
                })
            ]
        })
    });
};
var $c86177602ef72c59$export$2e2bcd8739ae039 = $c86177602ef72c59$var$ArrowIcon;

});

parcelRegister("67LuN", function(module, exports) {

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $bc72cd2d205d9489$var$ArrowIconReversed = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43.776 39.197",
        className: className || 'rf-h-6 rf-w-8',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
            transform: "translate(21.888, 0) scale(-1, 1) translate(-21.888, 0)",
            children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                transform: "translate(9.939 -0.321) rotate(17)",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M28.156,0S31.392,28.156,0,28.156",
                        transform: "translate(5.721 0)",
                        fill: "none",
                        stroke: color || '#1999b1',
                        strokeLinecap: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M0,0,8.8,8.8l8.8-8.8",
                        transform: "translate(8.688 18.779) rotate(81)",
                        fill: "none",
                        stroke: color || '#1999b1',
                        strokeLinecap: "round",
                        strokeWidth: "2"
                    })
                ]
            })
        })
    });
};
var $bc72cd2d205d9489$export$2e2bcd8739ae039 = $bc72cd2d205d9489$var$ArrowIconReversed;

});

parcelRegister("4QFhT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1b69a12e8d41e5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $6c1b69a12e8d41e5$var$ArrowLeftIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || 'currentColor',
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 17l-5-5m0 0l5-5m-5 5h12"
        })
    });
};
var $6c1b69a12e8d41e5$export$2e2bcd8739ae039 = $6c1b69a12e8d41e5$var$ArrowLeftIcon;

});

parcelRegister("dH58k", function(module, exports) {

$parcel$export(module.exports, "default", () => $6467fe3ae78e93be$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $6467fe3ae78e93be$var$ArrowRightIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || 'currentColor',
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13 7l5 5m0 0l-5 5m5-5H6"
        })
    });
};
var $6467fe3ae78e93be$export$2e2bcd8739ae039 = $6467fe3ae78e93be$var$ArrowRightIcon;

});

parcelRegister("1dNUX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf7c557cd0b218f8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $bf7c557cd0b218f8$var$ArrowUpIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || 'currentColor',
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M14 4.83 3.4 15.43a2 2 0 0 1-2.82 0 2.02 2.02 0 0 1 0-2.84l12-12a2 2 0 0 1 2.76-.06l12.08 12.05a2 2 0 0 1-2.83 2.83Z"
        })
    });
};
var $bf7c557cd0b218f8$export$2e2bcd8739ae039 = $bf7c557cd0b218f8$var$ArrowUpIcon;

});




parcelRegister("9cEaH", function(module, exports) {

$parcel$export(module.exports, "BackButton", () => (parcelRequire("4kqtJ")).default);
$parcel$export(module.exports, "Dashboard", () => (parcelRequire("9UTGN")).default);
$parcel$export(module.exports, "HistoryButton", () => (parcelRequire("CgDXB")).default);
$parcel$export(module.exports, "LanguageButton", () => (parcelRequire("3o2AQ")).default);
$parcel$export(module.exports, "MicrophoneButton", () => (parcelRequire("iqpLV")).default);
$parcel$export(module.exports, "Parameters", () => (parcelRequire("91jIt")).default);
$parcel$export(module.exports, "TutorialButton", () => (parcelRequire("2aOO4")).default);

var $4kqtJ = parcelRequire("4kqtJ");

var $9UTGN = parcelRequire("9UTGN");

var $CgDXB = parcelRequire("CgDXB");

var $3o2AQ = parcelRequire("3o2AQ");

var $iqpLV = parcelRequire("iqpLV");

var $91jIt = parcelRequire("91jIt");

var $dLhbi = parcelRequire("dLhbi");

var $2aOO4 = parcelRequire("2aOO4");

var $lRvrG = parcelRequire("lRvrG");

});
parcelRegister("4kqtJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb04d93bb9fda115$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
const $cb04d93bb9fda115$var$BackButton = ({ title: title, className: className, handleBack: handleBack })=>{
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-flex rf-flex-row rf-items-center ${className}`,
        onClick: handleBack,
        "aria-label": title,
        "data-map": "fermer",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                className: "rf-w-8"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-1",
                children: (0, $eO5xw.capitalizeFirstLetter)(title, locale)
            })
        ]
    });
};
var $cb04d93bb9fda115$export$2e2bcd8739ae039 = $cb04d93bb9fda115$var$BackButton;

});

parcelRegister("9UTGN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b532675e9677f5b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $gPs3v = parcelRequire("gPs3v");

var $75jcl = parcelRequire("75jcl");

var $h0yA8 = parcelRequire("h0yA8");

var $g4PdG = parcelRequire("g4PdG");

var $f51Nf = parcelRequire("f51Nf");
parcelRequire("81HL8");
var $77wBI = parcelRequire("77wBI");

var $lRvrG = parcelRequire("lRvrG");
const $3b532675e9677f5b$var$Dashboard = ({ toggleDashboard: toggleDashboard })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const isUsedOnBorne = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.isUsedOnBorne);
    const hideParametersButtonInMenu = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.hideParametersButtonInMenu);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const handleClick = ()=>{
        toggleDashboard?.();
    };
    /**
   * Called in borne mode to open retorik kiosk parameters
   */ const handleClickParameters = ()=>{
        dispatch((0, $cto9a.storeActions).utils.askForKioskParametersOpening());
        toggleDashboard?.();
    };
    return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-px-5 rf-pt-4 rf-flex rf-flex-col rf-justify-start",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $g4PdG.default), {
            conditionalHandleClick: handleClick
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $gPs3v.default), {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-h-full rf-w-full rf-flex rf-justify-center rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $h0yA8.default), {}),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-relative rf-h-full rf-max-w-7/10 rf-flex rf-flex-col rf-items-start rf-gap-8",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-min-h-2/5 rf-py-4 rf-mt-auto rf-flex rf-flex-col rf-gap-8 rf-overflow-y-scroll rf-scrollbar-hidden",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $g4PdG.default), {
                                    handleClick: toggleDashboard
                                })
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-h-3/10 rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f51Nf.default), {
                                    handleClick: toggleDashboard
                                })
                            })
                        ]
                    }),
                    isUsedOnBorne && !hideParametersButtonInMenu ? /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                        // @ts-ignore
                        part: "retorik-framework-parameters",
                        className: "rf-absolute rf-left-4 rf-bottom-4 rf-h-8 rf-flex rf-flex-row rf-items-center",
                        onClick: handleClickParameters,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $77wBI.default), {
                                color: "#A4A7AF"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                className: "rf-uppercase rf-ml-1 rf-text-xsl rf-text-[#A4A7AF]",
                                children: translation.common.parameters
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lRvrG.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $75jcl.default), {
                dashboardVisible: true,
                onClick: handleClick
            })
        ]
    });
};
var $3b532675e9677f5b$export$2e2bcd8739ae039 = $3b532675e9677f5b$var$Dashboard;

});
parcelRegister("75jcl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f88c67cf473fabee$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $d9kWL = parcelRequire("d9kWL");

var $ijq12 = parcelRequire("ijq12");
const $f88c67cf473fabee$var$AbsoluteLargeClosingButton = ({ dashboardVisible: dashboardVisible, zIndexClassname: zIndexClassname, customComponent: customComponent, onClick: onClick })=>{
    const hideMenu = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.hideMenu);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const useOldRemote = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.useOldRemote);
    const top = (0, $d9kWL.default)();
    const [hidden, setHidden] = (0, $bxRTa.useState)(false);
    const handleHideAndClose = ()=>{
        dashboardVisible && !customComponent && setHidden(true);
        onClick();
    };
    return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : useOldRemote ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-absolute ${hidden && 'rf-hidden'} rf-w-24 rf-flex rf-justify-center rf-right-0 ${zIndexClassname || 'rf-z-ui'}`,
        style: {
            top: hideMenu ? `calc(${top} - 6rem)` : top
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ijq12.default), {
            dashboardVisible: dashboardVisible,
            onClick: handleHideAndClose
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $f88c67cf473fabee$export$2e2bcd8739ae039 = $f88c67cf473fabee$var$AbsoluteLargeClosingButton;

});
parcelRegister("d9kWL", function(module, exports) {

$parcel$export(module.exports, "default", () => $847d89e91d773caa$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");
const $847d89e91d773caa$var$useCloseButtonTop = ()=>{
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const isTactile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isTactile);
    const [top, setTop] = (0, $bxRTa.useState)(200);
    /**
   * On currentDeviceType change :
   *  - switch on currentDeviceType and check for tactile
   *  - set top state to the value in configuration if given, or a default one
   */ (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
                if (isTactile) setTop(configuration.remote?.desktopTactile || '9.75rem');
                else setTop(configuration.remote?.desktop || '9.75rem');
                break;
            case (0, $2rYkD.DeviceType).borne:
                setTop(configuration.remote?.verticalTactile || 'calc(50% - 11.25rem)');
                break;
            default:
                setTop(200);
                break;
        }
    }, [
        currentDeviceType
    ]);
    return top;
};
var $847d89e91d773caa$export$2e2bcd8739ae039 = $847d89e91d773caa$var$useCloseButtonTop;

});

parcelRegister("ijq12", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b80f4c7069c48f8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
parcelRequire("dikAc");
var $6Nt3V = parcelRequire("6Nt3V");
parcelRequire("kMAJU");
var $04Syy = parcelRequire("04Syy");
const $9b80f4c7069c48f8$var$DashboardButton = ({ dashboardVisible: dashboardVisible, onClick: onClick })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const [label, setLabel] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        setLabel(dashboardVisible ? translation.common.close : translation.common.menu);
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-w-18 rf-h-18 rf-mb-6 rf-flex rf-flex-col rf-justify-center rf-items-center rf-bg-truewhite ${isRTL ? 'rf-text-arabic' : 'rf-text-xsm'} rf-text-trueblack rf-border rf-border-menuBorder rf-rounded-half hover:rf-cursor-pointer rf-shadow-[0_3px_6px_#606267]`,
        "aria-label": label,
        // data-map used in interactive map to use this button externaly
        "data-map": dashboardVisible ? 'fermer' : 'dashboard',
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-uppercase",
                children: label
            }),
            dashboardVisible ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $04Syy.default), {
                className: "rf-h-6 rf-w-6"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6Nt3V.default), {
                className: "rf-h-6 rf-w-6"
            })
        ]
    });
};
var $9b80f4c7069c48f8$export$2e2bcd8739ae039 = $9b80f4c7069c48f8$var$DashboardButton;

});
parcelRegister("dikAc", function(module, exports) {

$parcel$export(module.exports, "DashboardIcon", () => (parcelRequire("6Nt3V")).default);
$parcel$export(module.exports, "KeyboardIcon", () => (parcelRequire("9f9kU")).default);
$parcel$export(module.exports, "MicrophoneIcon", () => (parcelRequire("jWbjz")).default);
$parcel$export(module.exports, "MicrophoneIconOn", () => (parcelRequire("9HRSd")).default);

var $6Nt3V = parcelRequire("6Nt3V");

var $9f9kU = parcelRequire("9f9kU");

var $jWbjz = parcelRequire("jWbjz");

var $9HRSd = parcelRequire("9HRSd");

});
parcelRegister("6Nt3V", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d7b99368b57a3c6$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $6d7b99368b57a3c6$var$DashboardIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: color || 'currentColor',
        className: className || 'w-6',
        viewBox: "0 0 27.93 16.72",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M1.23 2.46a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23ZM1.23 9.59a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23ZM1.23 16.72a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23Z"
        })
    });
};
var $6d7b99368b57a3c6$export$2e2bcd8739ae039 = $6d7b99368b57a3c6$var$DashboardIcon;

});

parcelRegister("9f9kU", function(module, exports) {

$parcel$export(module.exports, "default", () => $06d3cd23e7f10ba2$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $06d3cd23e7f10ba2$var$KeyboardIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 22.5 15",
        className: className || 'w-6',
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("filter", {
                    id: "Icon_awesome-keyboard",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M20.625,19.5H1.875A1.875,1.875,0,0,1,0,17.625V6.375A1.875,1.875,0,0,1,1.875,4.5h18.75A1.875,1.875,0,0,1,22.5,6.375v11.25A1.875,1.875,0,0,1,20.625,19.5ZM5,9.031V7.469A.469.469,0,0,0,4.531,7H2.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H4.531A.469.469,0,0,0,5,9.031Zm3.75,0V7.469A.469.469,0,0,0,8.281,7H6.719a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H8.281A.469.469,0,0,0,8.75,9.031Zm3.75,0V7.469A.469.469,0,0,0,12.031,7H10.469A.469.469,0,0,0,10,7.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,12.5,9.031Zm3.75,0V7.469A.469.469,0,0,0,15.781,7H14.219a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,16.25,9.031Zm3.75,0V7.469A.469.469,0,0,0,19.531,7H17.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,9.031ZM6.875,12.781V11.219a.469.469,0,0,0-.469-.469H4.844a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469H6.406A.469.469,0,0,0,6.875,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H8.594a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,10.625,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H12.344a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.562A.469.469,0,0,0,14.375,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H16.094a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,18.125,12.781ZM5,16.531V14.969a.469.469,0,0,0-.469-.469H2.969a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,2.969,17H4.531A.469.469,0,0,0,5,16.531Zm11.25,0V14.969a.469.469,0,0,0-.469-.469H6.719a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,6.719,17h9.063A.469.469,0,0,0,16.25,16.531Zm3.75,0V14.969a.469.469,0,0,0-.469-.469H17.969a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,16.531Z",
                        transform: "translate(0 -4.5)",
                        fill: color || '#a4a7af'
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-keyboard)",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M20.625,19.5H1.875A1.875,1.875,0,0,1,0,17.625V6.375A1.875,1.875,0,0,1,1.875,4.5h18.75A1.875,1.875,0,0,1,22.5,6.375v11.25A1.875,1.875,0,0,1,20.625,19.5ZM5,9.031V7.469A.469.469,0,0,0,4.531,7H2.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H4.531A.469.469,0,0,0,5,9.031Zm3.75,0V7.469A.469.469,0,0,0,8.281,7H6.719a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H8.281A.469.469,0,0,0,8.75,9.031Zm3.75,0V7.469A.469.469,0,0,0,12.031,7H10.469A.469.469,0,0,0,10,7.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,12.5,9.031Zm3.75,0V7.469A.469.469,0,0,0,15.781,7H14.219a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,16.25,9.031Zm3.75,0V7.469A.469.469,0,0,0,19.531,7H17.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,9.031ZM6.875,12.781V11.219a.469.469,0,0,0-.469-.469H4.844a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469H6.406A.469.469,0,0,0,6.875,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H8.594a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,10.625,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H12.344a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.562A.469.469,0,0,0,14.375,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H16.094a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,18.125,12.781ZM5,16.531V14.969a.469.469,0,0,0-.469-.469H2.969a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,2.969,17H4.531A.469.469,0,0,0,5,16.531Zm11.25,0V14.969a.469.469,0,0,0-.469-.469H6.719a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,6.719,17h9.063A.469.469,0,0,0,16.25,16.531Zm3.75,0V14.969a.469.469,0,0,0-.469-.469H17.969a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,16.531Z",
                            transform: "translate(0 -4.5)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $06d3cd23e7f10ba2$export$2e2bcd8739ae039 = $06d3cd23e7f10ba2$var$KeyboardIcon;

});

parcelRegister("jWbjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f252c8393a08d666$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $f252c8393a08d666$var$MicrophoneIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || 'rf-h-6',
        viewBox: "0 0 14.426 20.983",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("filter", {
                    id: "Icon_awesome-microphone",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M7.213,14.426a3.934,3.934,0,0,0,3.934-3.934V3.934a3.934,3.934,0,1,0-7.869,0v6.557A3.934,3.934,0,0,0,7.213,14.426ZM13.77,7.869h-.656a.656.656,0,0,0-.656.656v1.967a5.252,5.252,0,0,1-5.77,5.22,5.405,5.405,0,0,1-4.722-5.454V8.524a.656.656,0,0,0-.656-.656H.656A.656.656,0,0,0,0,8.524V10.17a7.439,7.439,0,0,0,6.229,7.446v1.4h-2.3a.656.656,0,0,0-.656.656v.656a.656.656,0,0,0,.656.656h6.557a.656.656,0,0,0,.656-.656v-.656a.656.656,0,0,0-.656-.656H8.2V17.632a7.22,7.22,0,0,0,6.229-7.14V8.524A.656.656,0,0,0,13.77,7.869Z",
                        fill: color || '#a4a7af'
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-microphone)",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M7.213,14.426a3.934,3.934,0,0,0,3.934-3.934V3.934a3.934,3.934,0,1,0-7.869,0v6.557A3.934,3.934,0,0,0,7.213,14.426ZM13.77,7.869h-.656a.656.656,0,0,0-.656.656v1.967a5.252,5.252,0,0,1-5.77,5.22,5.405,5.405,0,0,1-4.722-5.454V8.524a.656.656,0,0,0-.656-.656H.656A.656.656,0,0,0,0,8.524V10.17a7.439,7.439,0,0,0,6.229,7.446v1.4h-2.3a.656.656,0,0,0-.656.656v.656a.656.656,0,0,0,.656.656h6.557a.656.656,0,0,0,.656-.656v-.656a.656.656,0,0,0-.656-.656H8.2V17.632a7.22,7.22,0,0,0,6.229-7.14V8.524A.656.656,0,0,0,13.77,7.869Z",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $f252c8393a08d666$export$2e2bcd8739ae039 = $f252c8393a08d666$var$MicrophoneIcon;

});

parcelRegister("9HRSd", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdafa1307f3316ac$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $fdafa1307f3316ac$var$MicrophoneIconOn = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-8',
        viewBox: "0 0 21.055 18.479",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-44.181 -45.388)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("rect", {
                    width: "8.229",
                    height: "18.479",
                    rx: "2",
                    transform: "translate(44.181 45.388)",
                    fill: color || '#ff6462'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("rect", {
                    width: "8.229",
                    height: "18.479",
                    rx: "2",
                    transform: "translate(57.007 45.388)",
                    fill: color || '#ff6462'
                })
            ]
        })
    });
};
var $fdafa1307f3316ac$export$2e2bcd8739ae039 = $fdafa1307f3316ac$var$MicrophoneIconOn;

});




parcelRegister("h0yA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d1685fba6dad8d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
const $72d1685fba6dad8d$var$Logo = ({ className: className })=>{
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    return configuration.logo?.src ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-customer-logo",
        className: className || 'rf-absolute rf-m-4 large:rf-m-8 rf-top-0 rf-left-0',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
            src: configuration.logo.src,
            alt: "Logo",
            className: "rf-max-h-12 rf-max-w-16 large:rf-max-h-28 large:rf-max-w-[12rem] large-vertical:rf-max-h-36"
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $72d1685fba6dad8d$export$2e2bcd8739ae039 = $72d1685fba6dad8d$var$Logo;

});

parcelRegister("g4PdG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3a80b227c1ab5ab$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $kdMEA = parcelRequire("kdMEA");

var $7jXNO = parcelRequire("7jXNO");
const $c3a80b227c1ab5ab$var$DisplayViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const [finalMenu, setFinalMenu] = (0, $bxRTa.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseMenu
            if (Object.keys(currentMenu).includes('icon')) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $7jXNO.default), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined,
                    name: customCurrentMenu.name
                }));
            } else fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $7jXNO.default), {
                type: "BaseMenu",
                indice: currentMenu.indice,
                view: currentMenu.view,
                device: currentDeviceType,
                handleClick: handleClick,
                conditionalHandleClick: conditionalHandleClick
            }));
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $bxRTa.useEffect)(()=>{
        const tempFinalMenu = [];
        // Basic menu
        tempFinalMenu.push(buildMenu(configuration && configuration.baseMenu ? [
            ...configuration.baseMenu
        ] : [
            ...(0, $kdMEA.DEFAULT_VIEWS)
        ]));
        // Custom menus
        if (configuration && configuration.customMenu && configuration.customMenu.length > 0) {
            if (Array.isArray(configuration.customMenu[0])) configuration.customMenu.forEach((menuArray)=>{
                tempFinalMenu.push(buildMenu(menuArray));
            });
            else tempFinalMenu.push(buildMenu(configuration.customMenu));
        }
        setFinalMenu(tempFinalMenu);
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: finalMenu.map((line, key)=>{
            return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `${key === 0 && 'rf-pb-4'} rf-flex rf-flex-col rf-items-center`,
                children: [
                    key !== 0 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-h-6 -rf-mx-6 rf-width-fill-available rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                    }),
                    line.map((e, subkey)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                            children: e
                        }, subkey);
                    })
                ]
            }, key) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                children: line.map((e, subkey)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                        children: e
                    }, subkey);
                })
            }, key);
        })
    });
};
var $c3a80b227c1ab5ab$export$2e2bcd8739ae039 = $c3a80b227c1ab5ab$var$DisplayViews;

});
parcelRegister("7jXNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f44689844fae488$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $kdMEA = parcelRequire("kdMEA");

var $1ABKz = parcelRequire("1ABKz");
function $1f44689844fae488$var$instanceOfDisplayGeneratorProps(object) {
    return 'view' in object && object.type === 'BaseMenu';
}
function $1f44689844fae488$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return 'icon' in object && object.type === 'CustomMenu';
}
const $1f44689844fae488$var$DisplayGenerator = (props)=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const [label, setLabel] = (0, $bxRTa.useState)('');
    const [colorButtonHandle, setColorButtonHandle] = (0, $bxRTa.useState)('');
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $bxRTa.useEffect)(()=>{
        if ($1f44689844fae488$var$instanceOfDisplayGeneratorProps(props)) setLabel(translation[props.view.toString()]);
        else if ($1f44689844fae488$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === 'string') setLabel(props.label);
            else if (props.label && typeof props.label === 'object') setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        let colorButtonHandle = '';
        // Handle hospitality menu icon color
        if ($1f44689844fae488$var$instanceOfCustomMenuDisplayGeneratorProps(props) && props.name) {
            if (props.name.toString().indexOf('whatToDo') > -1) colorButtonHandle = themeColors.tobeDoneColor;
            else if (props.name.toString().indexOf('localProducts') > -1) colorButtonHandle = themeColors.localProductsColor;
            else if (props.name.toString().indexOf('whereToEat') > -1) colorButtonHandle = themeColors.whereToEatColor;
            else if (props.name.toString().indexOf('whereToSleep') > -1) colorButtonHandle = themeColors.whereToSleepColor;
            else if (props.name.toString().indexOf('whatToSee') > -1) colorButtonHandle = themeColors.tobeSeenColor;
            else if (props.name.toString().indexOf('agenda') > -1) colorButtonHandle = themeColors.agendaColor;
            else if (props.name.toString().indexOf('services') > -1) colorButtonHandle = themeColors.servicesColor;
        }
        setColorButtonHandle(colorButtonHandle);
    }, [
        label
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($1f44689844fae488$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $2rYkD.AvailableViews).home:
                isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
                dispatch((0, $cto9a.storeActions).directline.sendEvent({
                    name: 'showHome'
                }));
                break;
            case (0, $2rYkD.AvailableViews).news:
                dispatch((0, $cto9a.storeActions).view.setRoute((0, $2rYkD.Routes).News));
                break;
            case (0, $2rYkD.AvailableViews).weather:
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).weather));
                break;
            case (0, $2rYkD.AvailableViews).emergency:
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).emergency));
                break;
        }
        else if ($1f44689844fae488$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            // Display custom component if present
            if (props.customDisplay) dispatch((0, $cto9a.storeActions).utils.setCurrentCustomView({
                ...props
            }));
        }
        props.handleClick && props.handleClick();
    };
    return (0, $kdMEA.mobileDisplays).includes(props.device) ? /* On mobile / widget : display available views as lines */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && 'rf-border-t rf-border-t-menuBorder'}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $1f44689844fae488$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                view: props.view
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                icon: props.icon,
                className: "rf-max-h-6 rf-max-w-6 rf-flex rf-items-center",
                color: colorButtonHandle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-4 rf-font-bold",
                children: (0, $eO5xw.capitalizeFirstLetter)(label, locale)
            })
        ]
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-h-36 rf-w-36 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)'
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $1f44689844fae488$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                view: props.view,
                className: "rf-h-16"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                icon: props.icon,
                className: "rf-h-16 rf-w-16 rf-flex",
                color: colorButtonHandle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-uppercase rf-text-[#575F6B] ${isRTL ? 'rf-text-arabic' : 'rf-text-xs'} large-vertical:rf-text-basecustomuppercase`,
                children: label
            })
        ]
    });
};
var $1f44689844fae488$export$2e2bcd8739ae039 = $1f44689844fae488$var$DisplayGenerator;

});
parcelRegister("1ABKz", function(module, exports) {

$parcel$export(module.exports, "default", () => $759207c94e1c6964$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("2l6WH");
var $hCkUC = parcelRequire("hCkUC");
var $3sPnl = parcelRequire("3sPnl");
var $jGi9r = parcelRequire("jGi9r");
var $8LI0a = parcelRequire("8LI0a");
var $jzwsO = parcelRequire("jzwsO");
parcelRequire("81HL8");
var $2ogpH = parcelRequire("2ogpH");
var $3EchS = parcelRequire("3EchS");
const $759207c94e1c6964$var$DisplayIcon = ({ view: view, icon: icon, className: className, color: color = '' })=>{
    if (view) return view === (0, $2rYkD.AvailableViews).home ? /*#__PURE__*/ (0, $fl9nK.jsx)($3sPnl.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).news ? /*#__PURE__*/ (0, $fl9nK.jsx)($8LI0a.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).weather ? /*#__PURE__*/ (0, $fl9nK.jsx)($jzwsO.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).emergency ? /*#__PURE__*/ (0, $fl9nK.jsx)($hCkUC.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableSubViews).history ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ogpH.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableSubViews).tutorial ? /*#__PURE__*/ (0, $fl9nK.jsx)($3EchS.default, {
        className: className
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)($jGi9r.default, {
        className: className
    });
    else if (icon) return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `${className} ${color !== '' ? 'svgButtonMenu' : ''}`,
        style: color !== '' ? {
            '--fill': color
        } : {},
        children: icon
    });
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fl9nK.Fragment), {});
};
var $759207c94e1c6964$export$2e2bcd8739ae039 = $759207c94e1c6964$var$DisplayIcon;

});
parcelRegister("2l6WH", function(module, exports) {

$parcel$export(module.exports, "EmergencyIcon", () => (parcelRequire("hCkUC")).default);
$parcel$export(module.exports, "HomeIcon", () => (parcelRequire("3sPnl")).default);
$parcel$export(module.exports, "InteractiveMapIcon", () => (parcelRequire("jGi9r")).default);
$parcel$export(module.exports, "NewsChannelIcon", () => (parcelRequire("8LI0a")).default);
$parcel$export(module.exports, "WeatherIcon", () => (parcelRequire("jzwsO")).default);

var $hCkUC = parcelRequire("hCkUC");

var $3sPnl = parcelRequire("3sPnl");

var $jGi9r = parcelRequire("jGi9r");

var $8LI0a = parcelRequire("8LI0a");

var $jzwsO = parcelRequire("jzwsO");

});
parcelRegister("hCkUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5c0edcfeef079ee$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $c5c0edcfeef079ee$var$EmergencyIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            fill: color || '#1999B1',
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M294.4,182.4h34.1v34.1c0,3.9,3.1,7,7,7h47c3.9,0,7-3.1,7-7v-34.1h34.1c3.9,0,7-3.1,7-7v-47c0-3.9-3.1-7-7-7h-34.1V87.3     c0-3.9-3.1-7-7-7h-47c-3.9,0-7,3.1-7,7v34.1h-34.1c-3.9,0-7,3.1-7,7v47C287.4,179.3,290.6,182.4,294.4,182.4z M301.4,135.4h34.1     c3.9,0,7-3.1,7-7V94.3h33v34.1c0,3.9,3.1,7,7,7h34.1v33h-34.1c-3.9,0-7,3.1-7,7v34.1h-33v-34.1c0-3.9-3.1-7-7-7h-34.1V135.4z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M218.1,285.1c0.1,3.8,3.2,6.8,6.9,6.8c0.9,0,95.2,1.1,133.1,1.1c78.5,0,142.5-63.9,142.5-142.5S436.7,8.2,358.1,8.2     c-78.5,0-142.5,63.9-142.5,142.5C215.7,186.8,218.1,284.2,218.1,285.1z M358.1,22.2c70.8,0,128.5,57.6,128.5,128.5     S429,279.1,358.1,279.1c-31.9,0-103.8-0.8-126.2-1c-0.5-22.8-2.3-97-2.3-127.4C229.7,79.8,287.3,22.2,358.1,22.2z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M191.5,94c1,0.5,2,0.7,3,0.7c2.6,0,5.1-1.5,6.3-4c0.2-0.4,21.5-45.1,51-70.9c2.9-2.5,3.2-7,0.7-9.9c-2.5-2.9-7-3.2-9.9-0.7     c-31.8,27.7-53.6,73.5-54.5,75.5C186.5,88.2,188,92.3,191.5,94z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M176.6,60.1c1.1,0.6,2.2,0.8,3.3,0.8c2.5,0,4.9-1.3,6.2-3.7c0.1-0.2,13.2-24.6,27.9-36.4c3-2.4,3.5-6.8,1.1-9.8     c-2.4-3-6.8-3.5-9.8-1.1c-16.9,13.6-30.9,39.6-31.5,40.7C171.9,54.1,173.2,58.3,176.6,60.1z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M490.2,255.8c-0.3,0.4-34.6,36.1-70.7,51.3c-3.6,1.5-5.2,5.6-3.7,9.2c1.1,2.7,3.7,4.3,6.5,4.3c0.9,0,1.8-0.2,2.7-0.5     c38.9-16.3,73.9-53,75.4-54.6c2.7-2.8,2.5-7.2-0.3-9.9S492.8,253,490.2,255.8z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M503.6,292.4c-2.7-2.8-7.1-2.9-9.9-0.2c-0.2,0.2-20.3,19.2-37.9,25.8c-3.6,1.4-5.5,5.4-4.1,9c1.1,2.8,3.7,4.5,6.6,4.5     c0.8,0,1.6-0.1,2.5-0.4c20.3-7.6,41.8-27.9,42.7-28.8C506.2,299.6,506.3,295.2,503.6,292.4z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M490.2,372.5c-1.6-0.5-40.7-13.2-71.4,4c-16,9-26.7,24.2-31.6,45.4c-12.9,55-48.2,58-85.6,52l17.2-10     c18.4-10.7,24.7-34.4,14-52.8L302.5,359c-10.7-18.4-34.4-24.7-52.8-14l-36.7,21.3c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0-6.4,4-17.1,1.6     c-12.6-2.7-32.6-14.3-56.7-53.7c-22-39.9-22.4-62.9-18.8-75.2c3.1-10.5,9.4-14.3,10.1-14.7c0.2-0.1,0.2-0.1,0.4-0.2l36.7-21.3     c18.4-10.7,24.7-34.4,14-52.8L151,98.2c-10.7-18.4-34.4-24.7-52.8-14L60.8,106c-0.1,0-0.2,0.1-0.2,0.1c-1.5,1-38.1,24.6-48.6,67     C-4,237.2,63,350,65.9,354.7c0.3,0.6,0.8,1.1,1.2,1.5c0.1,0.6,0.4,1.2,0.7,1.8c2.7,4.8,67.5,118.9,131,136.8     c42.1,11.8,80.7-8.2,82.3-9c0.1,0,0.2-0.1,0.2-0.1l2.4-1.4c0.7,0.5,1.6,0.9,2.5,1c12.3,2.5,25.9,4.8,39.4,4.8     c8.5,0,17-0.9,25.2-3.4c25.4-7.6,42.2-28.3,50-61.7c4-17.1,12.3-29.3,24.8-36.3c25.3-14.2,59.9-3.1,60.2-3c3.7,1.2,7.6-0.8,8.8-4.4     C495.9,377.7,493.9,373.8,490.2,372.5z M256.8,357.2c11.7-6.8,26.8-2.8,33.7,8.9l30.3,52.1c6.8,11.7,2.8,26.8-8.9,33.7l-9.5,5.5     c-39.1-34.5-52.5-80.7-55.8-94.2L256.8,357.2z M202.6,481.4C144.7,465.1,80.7,352.3,80,351.2c-0.4-0.6-0.8-1.2-1.3-1.7     c-0.2-0.7-0.4-1.4-0.8-2c-0.7-1.1-66.9-112.5-52.4-171c8.9-35.9,40.5-57.3,42.4-58.5l14.6-8.5c1.8,7,5.2,18,10.9,30.9     c1.6,3.5,5.7,5.1,9.2,3.6c0.2-0.1,0.5-0.2,0.7-0.4c3-1.8,4.3-5.6,2.9-8.9c-6.6-14.8-9.8-27-11.1-32.6l10.1-5.9     c11.7-6.8,26.8-2.8,33.7,8.9l30.3,52.1c6.8,11.7,2.8,26.8-8.9,33.7l-9.6,5.6c-11.1-9.9-21-21.4-29.5-34.5c-2.1-3.2-6.4-4.1-9.7-2     c-3.2,2.1-4.1,6.5-2,9.7c8.3,12.7,17.9,24.2,28.6,34.2l-14.2,8.2c-2.2,1.1-12.1,7-16.9,22.3c-6.6,21-0.5,49.1,18,83.7     c0.2,0.5,0.4,1,0.6,1.4c0.4,0.7,0.8,1.3,1.2,2c0.4,0.7,0.7,1.3,1.1,2c0.3,0.5,0.6,0.9,0.9,1.3c20.9,33.2,42.3,52.4,63.8,57.1     c15.7,3.4,25.7-2.3,27.7-3.6l13.7-7.9c4.7,18.1,19,60.2,55.7,94.3l-15.1,8.8C272.4,474.6,238.4,491.5,202.6,481.4z"
                })
            ]
        })
    });
};
var $c5c0edcfeef079ee$export$2e2bcd8739ae039 = $c5c0edcfeef079ee$var$EmergencyIcon;

});

parcelRegister("3sPnl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2138c260f10ee542$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $2138c260f10ee542$var$HomeIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 25 25",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M39.908,31.05l-4.784-4.784V21.032a.312.312,0,0,0-.312-.312H31.887a.312.312,0,0,0-.312.312v1.685L27.72,18.861a.312.312,0,0,0-.441,0L15.091,31.05a.312.312,0,1,0,.441.441L17.925,29.1V42.483a.312.312,0,0,0,.312.312h6.825a.312.312,0,0,0,.312-.312V35.97h4.252v6.514a.312.312,0,0,0,.312.312h6.825a.312.312,0,0,0,.312-.312V29.1l2.393,2.393a.312.312,0,1,0,.441-.441ZM32.2,21.344h2.3v4.3l-2.3-2.3Zm4.252,20.827h-6.2V35.658a.312.312,0,0,0-.312-.312H25.062a.312.312,0,0,0-.312.312v6.514h-6.2v-13.7L27.5,19.523l4.167,4.167h0l2.925,2.925h0l1.859,1.859Z",
            transform: "translate(-15 -18.77)",
            fill: color || '#1999b1'
        })
    });
};
var $2138c260f10ee542$export$2e2bcd8739ae039 = $2138c260f10ee542$var$HomeIcon;

});

parcelRegister("jGi9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $470bea3d78e84fc8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $470bea3d78e84fc8$var$InteractiveMapIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                fill: color || '#1999B1',
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M256,93.297c-14.021,0-27.516,4.218-39.025,12.198c-3.402,2.359-4.262,7.05-1.921,10.478   c2.342,3.428,6.998,4.294,10.4,1.936c9.004-6.243,19.566-9.543,30.546-9.543c29.754,0,53.96,24.388,53.96,54.365   c0,29.977-24.206,54.366-53.96,54.366c-29.754,0-53.96-24.389-53.96-54.366c0-8.843,2.038-17.273,6.057-25.055   c1.906-3.692,0.482-8.241-3.182-10.161c-3.665-1.919-8.178-0.486-10.085,3.206c-5.067,9.812-7.746,20.881-7.746,32.01   C187.085,201.018,218,232.166,256,232.166s68.915-31.148,68.915-69.435C324.915,124.445,294,93.297,256,93.297z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                fill: color || '#1999B1',
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M511.426,501.571l-73.804-178.665c-1.16-2.809-3.883-4.639-6.903-4.639h-73.547   c14.305-19.498,26.212-38.919,35.511-57.988c16.48-33.794,24.835-66.613,24.835-97.547C417.517,73.001,345.061,0,256,0   S94.483,73.001,94.483,162.731c0,30.934,8.355,63.754,24.835,97.547c9.298,19.069,21.205,38.491,35.511,57.988H81.282   c-3.02,0-5.744,1.831-6.903,4.639L24.087,444.651c-1.587,3.842,0.217,8.252,4.03,9.85c0.94,0.394,1.912,0.581,2.87,0.581   c2.93,0,5.711-1.746,6.906-4.641l7.176-17.372h50.906l-26.38,63.862H18.69l7.647-18.513c1.587-3.842-0.217-8.252-4.03-9.85   c-3.815-1.601-8.191,0.219-9.777,4.06L0.575,501.571c-0.961,2.325-0.705,4.981,0.683,7.075c1.386,2.095,3.72,3.354,6.22,3.354   h497.044c2.499,0,4.834-1.259,6.221-3.354C512.13,506.552,512.387,503.896,511.426,501.571z M109.439,162.731   c0-81.422,65.747-147.663,146.561-147.663S402.561,81.31,402.561,162.731c0,34.143-11.775,88.703-66.245,158.231   c-0.055,0.065-0.104,0.134-0.156,0.201c-2.782,3.547-5.672,7.132-8.681,10.757c-29.932,36.062-60.222,62.395-71.48,71.751   c-11.225-9.324-41.372-35.525-71.283-71.518c-3.084-3.711-6.042-7.38-8.889-11.01c-0.046-0.058-0.089-0.118-0.137-0.175   C121.222,251.445,109.439,196.887,109.439,162.731z M86.269,333.335h50.907l-18.568,44.948H67.702L86.269,333.335z   M129.997,496.932l46.741-113.148l133.014,113.148H129.997z M332.935,496.932L332.935,496.932l-154.352-131.3   c-1.822-1.551-4.27-2.132-6.584-1.566c-2.316,0.565-4.228,2.21-5.143,4.427l-53.057,128.438H85.795l28.296-68.502   c0.961-2.325,0.705-4.98-0.683-7.075c-1.386-2.095-3.721-3.354-6.221-3.354H51.296l10.182-24.65h62.118   c3.02,0,5.744-1.831,6.903-4.639l22.876-55.377h12.978c2.253,2.83,4.543,5.661,6.894,8.491   c38.585,46.43,76.578,76.239,78.177,77.486c1.348,1.051,2.962,1.575,4.576,1.575s3.229-0.525,4.576-1.575   c0.879-0.685,12.757-10.009,29.673-25.96h84.681c4.13,0,7.478-3.373,7.478-7.534s-3.348-7.534-7.478-7.534h-69.269   c10.368-10.503,21.7-22.749,33.093-36.457c2.351-2.83,4.642-5.66,6.894-8.491h80.083l18.567,44.948h-39.457   c-4.13,0-7.478,3.373-7.478,7.534s3.347,7.534,7.478,7.534h45.681l10.182,24.65h-154.07c-3.121,0-5.913,1.952-7.006,4.898   c-1.091,2.946-0.253,6.265,2.104,8.326l75.133,65.707H332.935z M399.681,496.932l-73.024-63.862H466.93l26.381,63.862H399.681z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {})
        ]
    });
};
var $470bea3d78e84fc8$export$2e2bcd8739ae039 = $470bea3d78e84fc8$var$InteractiveMapIcon;

});

parcelRegister("8LI0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $87efea18457e1d13$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $87efea18457e1d13$var$NewsChannelIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 512 512",
        className: className || 'rf-h-6 rf-w-6',
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            fill: color || '#1999B1',
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M500.9,13.5H325.3c-3.9,0-7,3.1-7,7v142.4c0,3.9,3.1,7,7,7h39.6v41.4c0,2.7,1.6,5.2,4,6.3c0.9,0.4,2,0.7,3,0.7     c1.6,0,3.2-0.6,4.5-1.6l55.5-46.8h68.9c3.9,0,7-3.1,7-7V20.5C507.9,16.6,504.8,13.5,500.9,13.5z M493.9,155.9h-64.5     c-1.6,0-3.2,0.6-4.5,1.6l-46,38.7v-33.4c0-3.9-3.1-7-7-7h-39.6V27.5h161.6V155.9z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M386.2,66h28.2c3.9,0,7-3.1,7-7s-3.1-7-7-7h-28.2c-3.9,0-7,3.1-7,7S382.3,66,386.2,66z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M436.7,66h32.6c3.9,0,7-3.1,7-7s-3.1-7-7-7h-32.6c-3.9,0-7,3.1-7,7S432.8,66,436.7,66z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M355.6,98.5h113.7c3.9,0,7-3.1,7-7s-3.1-7-7-7H355.6c-3.9,0-7,3.1-7,7S351.7,98.5,355.6,98.5z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M355.6,130.8h113.7c3.9,0,7-3.1,7-7s-3.1-7-7-7H355.6c-3.9,0-7,3.1-7,7S351.7,130.8,355.6,130.8z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M335.4,277.7c-17-4.2-47.9-12.2-60.2-15.4c0.7-1.7,0.7-3.6-0.1-5.4c-0.9-2-2.6-3.5-4.7-4l-40.8-10.2v-12.9     c18.6-11.3,32.3-30.3,37-52.8h12.9c12.1,0,21.9-9.8,21.9-21.9s-9.8-21.9-21.9-21.9h-12c4.4-7.2,16.2-28.5,16.6-48.9     c0.4-26.5-29.5-49.5-37.6-53.3c-1.1-0.5-2.8-1.6-4.9-2.8c-10-5.9-28.6-16.9-50.6-16.9c-32.8,0.1-55.2,25-56.1,26.1     c-0.4,0.5-0.8,1-1,1.6C112,43.2,95.5,62.5,95.5,85.6c0,3.1,0.3,6.3,0.9,9.5c0.1,0.4,0.2,0.9,0.4,1.3l14.7,36.8h-9.8     c-12.1,0-21.9,9.8-21.9,21.9s9.8,21.9,21.9,21.9h12.9c4.7,22.5,18.4,41.5,36.9,52.8v12.9l-40.8,10.2c-2.1,0.5-3.9,2-4.7,4     c-0.8,1.8-0.8,3.8,0,5.5l-62.7,16.7c0,0-0.1,0-0.1,0c-1.1,0.3-26.8,8.1-26.8,42.2v140.6c0,0.3,0,0.6,0.1,0.8     c1.8,14.9,12.5,43,40.2,43h299.3c3.9,0,7-3.1,7-7l0-177.9C362.9,319.3,362.1,284.3,335.4,277.7z M258.1,264.3l-29.1,52l-25.1-27.9     c16.2-5.9,23.6-21.6,25.5-31.3L258.1,264.3z M287.4,155.1c0,4.4-3.5,7.9-7.9,7.9h-11.2c0-1,0.1-2.1,0.1-3.1c0-4.4-0.2-8.6-0.6-12.7     h11.7C283.9,147.2,287.4,150.7,287.4,155.1z M109.5,85.6c0-18.5,15.1-33.6,33.6-33.6c12.2,0,23.5,6.7,29.4,17.4     c1.9,3.4,6.1,4.6,9.5,2.7c3.4-1.9,4.6-6.1,2.7-9.5c-6.6-12-18-20.4-31.1-23.4c8-6.1,21.3-13.9,37.3-13.9c18.2,0,34,9.3,43.4,14.9     c2.5,1.5,4.4,2.6,6.1,3.4c5.1,2.4,29.8,21.3,29.6,40.4c-0.2,11.4-5.1,23.7-9.4,32.4c-2.6-6.8-5.8-13.6-9.8-20.7     c-1.1-2-3.1-3.3-5.4-3.5c-2.2-0.2-4.5,0.6-6,2.3c-0.2,0.2-20,22.1-49,22.2c-28.9-0.2-48.8-22-49-22.2c-1.5-1.7-3.7-2.6-6-2.3     c-2.3,0.2-4.3,1.5-5.4,3.5c-4.2,7.4-7.5,14.4-10.1,21.5l-10.1-25.4C109.7,89.8,109.5,87.6,109.5,85.6z M101.7,163     c-4.4,0-7.9-3.5-7.9-7.9s3.5-7.9,7.9-7.9h11.7c-0.4,4.1-0.6,8.3-0.6,12.7c0,1,0,2.1,0.1,3.1H101.7z M126.8,159.9     c0-17.8,3.5-33,11.5-49.3c9.5,7.9,27.7,19.9,51.7,20.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0     c24-0.3,42.3-12.3,51.7-20.2c8,16.3,11.5,31.5,11.5,49.3c0,36.8-28.6,66.8-63.8,67C155.4,226.7,126.8,196.7,126.8,159.9z     M189.5,240.9c0.2,0,0.5,0,0.7,0c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.3,0,0.5,0,0.7,0c8.3-0.2,16.3-1.7,23.9-4.4v17.8     c-0.8,3.5-5.8,22.1-25,22.3c-19.3-0.2-24.3-18.9-25.1-22.3v-17.9C173,239.2,181.1,240.7,189.5,240.9z M151.8,257.1     c1.9,9.7,9.3,25.4,25.5,31.3l-25.1,27.9l-29.1-52L151.8,257.1z M209.4,445.8c2.1,0.8,8.2,4.2,8.2,16.5v29.4h-53.8v-45.9H209.4z     M208.3,369.8h-34.6v-15.2c0-9.5,7.8-17.3,17.3-17.3s17.3,7.8,17.3,17.3V369.8z M219.9,383.8V403H159v-19.3H219.9z M199.9,417v14.8     h-18.8V417H199.9z M348.9,491.7h-56.1V381.6c0-3.9-3.1-7-7-7s-7,3.1-7,7v110.1h-47.2v-29.4c0-13-5.1-20.5-9.3-24.5     c-3.2-3-6.4-4.5-8.4-5.2V417h13c3.9,0,7-3.1,7-7v-33.3c0-3.9-3.1-7-7-7h-4.6v-15.2c0-17.3-14-31.3-31.3-31.3s-31.3,14-31.3,31.3     v15.2H152c-3.9,0-7,3.1-7,7V410c0,3.9,3.1,7,7,7h15.2v14.8h-65.8v-49.8c0-3.9-3.1-7-7-7s-7,3.1-7,7v56.8c0,3.9,3.1,7,7,7h55.5v45.9     H56.6c-21.1,0-25.7-26.6-26.3-30.3V321.3c0-23.1,15.7-28.4,16.6-28.7l66-17.5l31.7,56.6c1.1,2,3.1,3.3,5.3,3.5c0.3,0,0.5,0,0.8,0     c2,0,3.9-0.8,5.2-2.3l34.5-38.4l34.5,38.4c1.3,1.5,3.2,2.3,5.2,2.3c0.3,0,0.5,0,0.8,0c2.2-0.2,4.2-1.6,5.3-3.5l31.8-56.7     c8.6,2.2,44.9,11.7,63.9,16.4c15.9,3.9,16.8,28.5,16.8,29.6V491.7z"
                })
            ]
        })
    });
};
var $87efea18457e1d13$export$2e2bcd8739ae039 = $87efea18457e1d13$var$NewsChannelIcon;

});

parcelRegister("jzwsO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c9a4c7b4247af9c$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $5c9a4c7b4247af9c$var$WeatherIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
            fill: color || '#1999B1',
            children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M439.2,385.3c0.7-3.5,1-7,1-10.6c0-31.2-25.4-56.5-56.5-56.5c-6.5,0-13,1.1-19.1,3.3c-1.4-3.6-3-7.1-4.8-10.4      C392,287.3,411,249.8,411,209.6c0-69.5-56.5-126-126-126c-69.5,0-126,56.5-126,126c0,5.7,0.4,11.3,1.1,16.9      c-16.7,9.5-30,24.6-37.2,43c-5.5-1.9-11.4-2.9-17.3-2.9c-29.1,0-52.7,23.6-52.7,52.7c0,3.2,0.3,6.4,0.9,9.5      c-20.8,10.3-34.5,31.8-34.5,55.3c0,34,27.6,61.6,61.6,61.6c0.7,0.2,1.4,0.3,2.1,0.3h26.1c2.9,15.6,10.3,29.9,21.6,41.4      c14.2,14.4,33,22.8,53.2,23.7c0.8,0.3,1.6,0.4,2.5,0.4h221.5c0.8,0,1.5-0.1,2.2-0.3c0,0,0.1,0,0.1,0c36.5,0,66.2-29.7,66.2-66.2      C476.6,419.5,461.8,396.3,439.2,385.3z M173.1,209.6c0-61.7,50.2-112,112-112s112,50.2,112,112c0,35.4-16.7,68.5-44.8,89.6      c-17-22.6-44-36.7-73.4-36.7c-0.1,0-0.1,0-0.2,0c-14.3-28.8-43.8-47.2-76.2-47.2c-10,0-19.7,1.8-28.8,5.1      C173.3,216.7,173.1,213.2,173.1,209.6z M85.4,432c-0.8-0.3-1.7-0.4-2.5-0.4c-0.6,0-1.2,0-1.8,0c-26.3,0-47.6-21.4-47.6-47.6      c0-19.8,12.5-37.8,31.1-44.7c3.5-1.3,5.4-5.1,4.3-8.6c-1.1-3.7-1.7-7.6-1.7-11.5c0-21.3,17.4-38.7,38.7-38.7      c6.3,0,12.6,1.6,18.2,4.5c1.9,1,4.1,1.1,6,0.3c1.9-0.8,3.4-2.5,4-4.5c8.6-30.4,36.8-51.6,68.4-51.6c25.2,0,48.2,13.3,61,34.5      c-42.5,7.2-75.1,43.8-76.2,88c-43.7,0.3-79.2,35.9-79.2,79.7c0,0.2,0,0.4,0,0.6H85.4z M410.3,497.2c-0.7,0-1.3,0-2-0.1      c-0.9,0-1.8,0.1-2.6,0.4H188.9c-0.7-0.2-1.4-0.4-2.2-0.4c-17.4-0.3-33.6-7.2-45.8-19.6c-12.2-12.4-18.9-28.8-18.9-46.1      c0-36.2,29.5-65.7,65.7-65.7c1.9,0,3.9,0.1,6,0.3c2,0.2,4-0.5,5.5-1.9s2.2-3.4,2.1-5.4c-0.1-1.6-0.1-3.1-0.1-4.5      c0-42.8,34.8-77.7,77.7-77.7c34.6,0,65.3,23.2,74.7,56.4c0.6,2,2,3.7,4,4.5c1.9,0.8,4.2,0.7,6-0.3c6.1-3.3,13-5,20-5      c23.5,0,42.5,19.1,42.5,42.5c0,4.3-0.6,8.6-1.9,12.6c-1.1,3.6,0.8,7.3,4.3,8.6c20.4,7.6,34.1,27.2,34.1,49      C462.6,473.8,439.2,497.2,410.3,497.2z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M485.4,203.6H443c-3.9,0-7,3.1-7,7s3.1,7,7,7h42.4c3.9,0,7-3.1,7-7S489.3,203.6,485.4,203.6z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M84.6,217.6h42.4c3.9,0,7-3.1,7-7s-3.1-7-7-7H84.6c-3.9,0-7,3.1-7,7S80.7,217.6,84.6,217.6z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M284.7,58.9c3.9,0,7-3.1,7-7V9.5c0-3.9-3.1-7-7-7s-7,3.1-7,7v42.4C277.7,55.7,280.8,58.9,284.7,58.9z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M360,79.4c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5l21.2-36.7c1.9-3.3,0.8-7.6-2.6-9.6      s-7.6-0.8-9.6,2.6l-21.2,36.7C355.5,73.2,356.7,77.4,360,79.4z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M199.7,76.8c1.3,2.2,3.6,3.5,6.1,3.5c1.2,0,2.4-0.3,3.5-0.9c3.3-1.9,4.5-6.2,2.6-9.6l-21.2-36.7      c-1.9-3.3-6.2-4.5-9.6-2.6s-4.5,6.2-2.6,9.6L199.7,76.8z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M107.8,116.6l36.7,21.2c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5c1.9-3.3,0.8-7.6-2.6-9.6l-36.7-21.2      c-3.3-1.9-7.6-0.8-9.6,2.6S104.5,114.7,107.8,116.6z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M422.3,138.7c1.2,0,2.4-0.3,3.5-0.9l36.7-21.2c3.3-1.9,4.5-6.2,2.6-9.6c-1.9-3.3-6.2-4.5-9.6-2.6l-36.7,21.2      c-3.3,1.9-4.5,6.2-2.6,9.6C417.5,137.5,419.9,138.7,422.3,138.7z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M416.5,286.6c-1.9,3.3-0.8,7.6,2.6,9.6l36.7,21.2c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5      c1.9-3.3,0.8-7.6-2.6-9.6l-36.7-21.2C422.8,282.1,418.5,283.3,416.5,286.6z"
                    })
                ]
            })
        })
    });
};
var $5c9a4c7b4247af9c$export$2e2bcd8739ae039 = $5c9a4c7b4247af9c$var$WeatherIcon;

});


parcelRegister("81HL8", function(module, exports) {

$parcel$export(module.exports, "BorneParametersIcon", () => (parcelRequire("77wBI")).default);
$parcel$export(module.exports, "HistoryIcon", () => (parcelRequire("2ogpH")).default);
$parcel$export(module.exports, "LanguageIcon", () => (parcelRequire("k1ioo")).default);
$parcel$export(module.exports, "TutorialIcon", () => (parcelRequire("3EchS")).default);

var $77wBI = parcelRequire("77wBI");

var $2ogpH = parcelRequire("2ogpH");

var $k1ioo = parcelRequire("k1ioo");

var $ikTA6 = parcelRequire("ikTA6");

var $3EchS = parcelRequire("3EchS");

});
parcelRegister("77wBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $501757403cd6fe1d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $501757403cd6fe1d$var$BorneParametersIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M218.9,43.9l-2.6,13.3l-9.7,48.5c-15.6,6.1-29.6,14.7-42.3,25l-47.4-16.3l-12.8-4.1l-6.6,11.7L64.9,178   l-6.6,11.7l9.7,8.7l36.7,32.1c-1.3,8.4-3.1,16.7-3.1,25.5c0,8.8,1.7,17.1,3.1,25.5l-36.7,32.1l-9.7,8.7l6.6,11.7l32.6,56.1l6.6,11.7   l12.8-4.1l47.4-16.3c12.8,10.3,26.8,18.9,42.3,25l9.7,48.5l2.6,13.3h91.8l2.6-13.3l9.7-48.5c15.6-6.1,29.6-14.7,42.3-25l47.4,16.3   l12.8,4.1l6.6-11.7l32.6-56.1l6.6-11.7l-9.7-8.7l-36.7-32.1c1.3-8.4,3.1-16.7,3.1-25.5c0-8.8-1.7-17.1-3.1-25.5l36.7-32.1l9.7-8.7   l-6.6-11.7l-32.6-56.1l-6.6-11.7l-12.8,4.1l-47.4,16.3c-12.8-10.3-26.8-18.9-42.3-25l-9.7-48.5l-2.6-13.3H218.9z M245.4,76.5h38.8   l8.2,42.3l2,9.7l9.2,3.1c18.6,5.8,35.4,15.6,49.5,28.6l7.1,6.6l9.2-3.1l41.3-14.3l19.4,33.2l-32.6,29.1l-7.7,6.1l2.6,9.7   c2.1,9.3,3.1,18.8,3.1,28.6c0,9.8-1,19.3-3.1,28.6l-2,9.7l7.1,6.1l32.6,29.1l-19.4,33.2l-41.3-14.3l-9.2-3.1l-7.1,6.6   c-14.1,12.9-30.9,22.8-49.5,28.6l-9.2,3.1l-2,9.7l-8.2,42.3h-38.8l-8.2-42.3l-2-9.7l-9.2-3.1c-18.6-5.8-35.4-15.6-49.5-28.6   l-7.1-6.6l-9.2,3.1l-41.3,14.3l-19.4-33.2l32.6-29.1l7.7-6.1l-2.6-9.7c-2.1-9.3-3.1-18.8-3.1-28.6c0-9.8,1-19.3,3.1-28.6l2.6-9.7   l-7.7-6.1l-32.6-29.1l19.4-33.2l41.3,14.3l9.2,3.1l7.1-6.6c14.1-12.9,30.9-22.8,49.5-28.6l9.2-3.1l2-9.7L245.4,76.5z M264.8,174.4   c-44.9,0-81.6,36.7-81.6,81.6s36.7,81.6,81.6,81.6s81.6-36.7,81.6-81.6S309.7,174.4,264.8,174.4z M264.8,207.1c27.2,0,49,21.7,49,49   s-21.7,49-49,49c-27.2,0-49-21.7-49-49S237.6,207.1,264.8,207.1z",
            fill: color || '#95989E'
        })
    });
};
var $501757403cd6fe1d$export$2e2bcd8739ae039 = $501757403cd6fe1d$var$BorneParametersIcon;

});

parcelRegister("2ogpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ae2ca89bd3bc4a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $b9ae2ca89bd3bc4a$var$HistoryIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || 'rf-w-6 rf-flex-1',
        viewBox: "0 0 14 14",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("filter", {
                    id: "Icon_awesome-history",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M14.562,7.549A7,7,0,0,1,3.169,13.013a.677.677,0,0,1-.052-1.005l.318-.318a.679.679,0,0,1,.9-.056A5.194,5.194,0,1,0,4,3.778L5.437,5.211a.452.452,0,0,1-.319.771h-4.1A.452.452,0,0,1,.563,5.53v-4.1a.452.452,0,0,1,.771-.319L2.727,2.5A7,7,0,0,1,14.562,7.549ZM9.456,9.773l.277-.356a.677.677,0,0,0-.119-.951L8.466,7.572V4.627a.677.677,0,0,0-.677-.677H7.337a.677.677,0,0,0-.677.677V8.456L8.505,9.892A.677.677,0,0,0,9.456,9.773Z",
                        transform: "translate(-0.563 -0.563)",
                        fill: color || '#a4a7af'
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-history)",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M14.562,7.549A7,7,0,0,1,3.169,13.013a.677.677,0,0,1-.052-1.005l.318-.318a.679.679,0,0,1,.9-.056A5.194,5.194,0,1,0,4,3.778L5.437,5.211a.452.452,0,0,1-.319.771h-4.1A.452.452,0,0,1,.563,5.53v-4.1a.452.452,0,0,1,.771-.319L2.727,2.5A7,7,0,0,1,14.562,7.549ZM9.456,9.773l.277-.356a.677.677,0,0,0-.119-.951L8.466,7.572V4.627a.677.677,0,0,0-.677-.677H7.337a.677.677,0,0,0-.677.677V8.456L8.505,9.892A.677.677,0,0,0,9.456,9.773Z",
                            transform: "translate(-0.56 -0.56)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $b9ae2ca89bd3bc4a$export$2e2bcd8739ae039 = $b9ae2ca89bd3bc4a$var$HistoryIcon;

});

parcelRegister("k1ioo", function(module, exports) {

$parcel$export(module.exports, "default", () => $490a1fc41ac7f76d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $490a1fc41ac7f76d$var$LanguageIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'w-6',
        viewBox: "0 0 21 21",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M13.49,3A10.5,10.5,0,1,0,24,13.5,10.495,10.495,0,0,0,13.49,3Zm7.277,6.3h-3.1A16.432,16.432,0,0,0,16.22,5.562,8.431,8.431,0,0,1,20.766,9.3ZM13.5,5.142A14.791,14.791,0,0,1,15.505,9.3H11.494A14.791,14.791,0,0,1,13.5,5.142ZM5.373,15.6a8.213,8.213,0,0,1,0-4.2H8.922a17.341,17.341,0,0,0-.147,2.1,17.341,17.341,0,0,0,.147,2.1Zm.861,2.1h3.1a16.432,16.432,0,0,0,1.449,3.738A8.386,8.386,0,0,1,6.234,17.7Zm3.1-8.4h-3.1A8.386,8.386,0,0,1,10.78,5.562,16.432,16.432,0,0,0,9.331,9.3ZM13.5,21.858A14.791,14.791,0,0,1,11.494,17.7h4.011A14.791,14.791,0,0,1,13.5,21.858ZM15.957,15.6H11.043a15.448,15.448,0,0,1-.168-2.1,15.314,15.314,0,0,1,.168-2.1h4.914a15.314,15.314,0,0,1,.168,2.1A15.448,15.448,0,0,1,15.957,15.6Zm.262,5.838A16.431,16.431,0,0,0,17.668,17.7h3.1a8.431,8.431,0,0,1-4.546,3.738ZM18.078,15.6a17.341,17.341,0,0,0,.147-2.1,17.341,17.341,0,0,0-.147-2.1h3.549a8.213,8.213,0,0,1,0,4.2Z",
            transform: "translate(-3 -3)",
            fill: color || '#90939a'
        })
    });
};
var $490a1fc41ac7f76d$export$2e2bcd8739ae039 = $490a1fc41ac7f76d$var$LanguageIcon;

});

parcelRegister("ikTA6", function(module, exports) {

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $81a46a941b9f337b$var$ParametersIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 27.005 27.012",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("filter", {
                    id: "Icon_ionic-ios-settings",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M29.276,18a3.475,3.475,0,0,1,2.229-3.242,13.774,13.774,0,0,0-1.667-4.016,3.522,3.522,0,0,1-1.414.3,3.467,3.467,0,0,1-3.172-4.881A13.733,13.733,0,0,0,21.245,4.5a3.472,3.472,0,0,1-6.484,0,13.774,13.774,0,0,0-4.016,1.667,3.467,3.467,0,0,1-3.172,4.881,3.407,3.407,0,0,1-1.414-.3A14.079,14.079,0,0,0,4.5,14.768a3.474,3.474,0,0,1,.007,6.484,13.774,13.774,0,0,0,1.667,4.016,3.469,3.469,0,0,1,4.578,4.578,13.855,13.855,0,0,0,4.016,1.667,3.466,3.466,0,0,1,6.47,0,13.774,13.774,0,0,0,4.016-1.667,3.472,3.472,0,0,1,4.578-4.578A13.855,13.855,0,0,0,31.5,21.252,3.492,3.492,0,0,1,29.276,18Zm-11.21,5.619A5.626,5.626,0,1,1,23.692,18,5.625,5.625,0,0,1,18.066,23.622Z",
                        transform: "translate(-4.5 -4.5)",
                        fill: color || '#a4a7af'
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_ionic-ios-settings)",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M29.276,18a3.475,3.475,0,0,1,2.229-3.242,13.774,13.774,0,0,0-1.667-4.016,3.522,3.522,0,0,1-1.414.3,3.467,3.467,0,0,1-3.172-4.881A13.733,13.733,0,0,0,21.245,4.5a3.472,3.472,0,0,1-6.484,0,13.774,13.774,0,0,0-4.016,1.667,3.467,3.467,0,0,1-3.172,4.881,3.407,3.407,0,0,1-1.414-.3A14.079,14.079,0,0,0,4.5,14.768a3.474,3.474,0,0,1,.007,6.484,13.774,13.774,0,0,0,1.667,4.016,3.469,3.469,0,0,1,4.578,4.578,13.855,13.855,0,0,0,4.016,1.667,3.466,3.466,0,0,1,6.47,0,13.774,13.774,0,0,0,4.016-1.667,3.472,3.472,0,0,1,4.578-4.578A13.855,13.855,0,0,0,31.5,21.252,3.492,3.492,0,0,1,29.276,18Zm-11.21,5.619A5.626,5.626,0,1,1,23.692,18,5.625,5.625,0,0,1,18.066,23.622Z",
                            transform: "translate(-4.5 -4.5)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $81a46a941b9f337b$export$2e2bcd8739ae039 = $81a46a941b9f337b$var$ParametersIcon;

});

parcelRegister("3EchS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f924f4e5dbe76f9$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $5f924f4e5dbe76f9$var$TutorialIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 21.039 21.039",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("filter", {
                    id: "Icon_ionic-ios-help-buoy",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                "data-type": "innerShadowGroup",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        id: "Icon_ionic-ios-help-buoy-2",
                        "data-name": "Icon ionic-ios-help-buoy",
                        d: "M13.894,3.375A10.519,10.519,0,1,0,24.414,13.894,10.518,10.518,0,0,0,13.894,3.375Zm2.761,1.841a9.126,9.126,0,0,1,5.917,5.917l-4.491.3a4.856,4.856,0,0,0-1.714-1.72Zm-9.2,2.24a9.038,9.038,0,0,1,3.677-2.24l.288,4.5a4.968,4.968,0,0,0-1.714,1.714l-4.5-.3A9.139,9.139,0,0,1,7.456,7.456Zm3.677,15.117a9.126,9.126,0,0,1-5.917-5.917l4.5-.288a4.9,4.9,0,0,0,1.709,1.709Zm2.761-5.239a3.439,3.439,0,1,1,3.439-3.439A3.443,3.443,0,0,1,13.894,17.333Zm6.438,3a9.072,9.072,0,0,1-3.677,2.24l-.3-4.5a4.872,4.872,0,0,0,1.725-1.73l4.491.3A9.056,9.056,0,0,1,20.332,20.332Z",
                        transform: "translate(-3.375 -3.375)",
                        fill: color || '#a4a7af'
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_ionic-ios-help-buoy)",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M13.894,3.375A10.519,10.519,0,1,0,24.414,13.894,10.518,10.518,0,0,0,13.894,3.375Zm2.761,1.841a9.126,9.126,0,0,1,5.917,5.917l-4.491.3a4.856,4.856,0,0,0-1.714-1.72Zm-9.2,2.24a9.038,9.038,0,0,1,3.677-2.24l.288,4.5a4.968,4.968,0,0,0-1.714,1.714l-4.5-.3A9.139,9.139,0,0,1,7.456,7.456Zm3.677,15.117a9.126,9.126,0,0,1-5.917-5.917l4.5-.288a4.9,4.9,0,0,0,1.709,1.709Zm2.761-5.239a3.439,3.439,0,1,1,3.439-3.439A3.443,3.443,0,0,1,13.894,17.333Zm6.438,3a9.072,9.072,0,0,1-3.677,2.24l-.3-4.5a4.872,4.872,0,0,0,1.725-1.73l4.491.3A9.056,9.056,0,0,1,20.332,20.332Z",
                            transform: "translate(-3.38 -3.38)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $5f924f4e5dbe76f9$export$2e2bcd8739ae039 = $5f924f4e5dbe76f9$var$TutorialIcon;

});





parcelRegister("f51Nf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1687bb30467378aa$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $kdMEA = parcelRequire("kdMEA");

var $2rYkD = parcelRequire("2rYkD");

var $Q1lHs = parcelRequire("Q1lHs");
const $1687bb30467378aa$var$DisplaySubViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const [subMenu, setSubMenu] = (0, $bxRTa.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseSubMenu
            if (Object.keys(currentMenu).includes('icon')) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $Q1lHs.default), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined
                }));
            } else {
                // In mobile mode, we only push custom items, base items (history / tutorial) have their own render
                if (!isMobile) // Don't add "history" item if it is disabled
                {
                    if (!(configuration.disableHistory && configuration.isUsedOnBorne) || currentMenu.view !== (0, $2rYkD.AvailableSubViews).history) fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $Q1lHs.default), {
                        type: "BaseMenu",
                        indice: currentMenu.indice,
                        view: currentMenu.view,
                        device: currentDeviceType,
                        handleClick: handleClick
                    }));
                }
            }
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $bxRTa.useEffect)(()=>{
        // Handle custom submenus
        if (configuration?.subMenu) setSubMenu(buildMenu(configuration.subMenu));
        else setSubMenu(buildMenu((0, $kdMEA.DEFAULT_SUB_VIEWS)));
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: subMenu.map((e, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: e
            }, key);
        })
    });
};
var $1687bb30467378aa$export$2e2bcd8739ae039 = $1687bb30467378aa$var$DisplaySubViews;

});
parcelRegister("Q1lHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f0441594b75de7$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $kdMEA = parcelRequire("kdMEA");

var $1ABKz = parcelRequire("1ABKz");
function $32f0441594b75de7$var$instanceOfDisplayGeneratorProps(object) {
    return 'view' in object && object.type === 'BaseMenu';
}
function $32f0441594b75de7$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return 'icon' in object && object.type === 'CustomMenu';
}
const $32f0441594b75de7$var$DisplaySubGenerator = (props)=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const [label, setLabel] = (0, $bxRTa.useState)('');
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $bxRTa.useEffect)(()=>{
        if ($32f0441594b75de7$var$instanceOfDisplayGeneratorProps(props)) setLabel(translation[props.view.toString()]);
        else if ($32f0441594b75de7$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === 'string') setLabel(props.label);
            else if (props.label && typeof props.label === 'object') setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($32f0441594b75de7$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $2rYkD.AvailableSubViews).history:
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).history));
                break;
            case (0, $2rYkD.AvailableSubViews).tutorial:
                console.log('Tutorial');
                break;
        }
        else if ($32f0441594b75de7$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            if (props.customDisplay) dispatch((0, $cto9a.storeActions).utils.setCurrentCustomView({
                ...props
            }));
        }
        props.handleClick && props.handleClick();
    };
    return (0, $kdMEA.mobileDisplays).includes(props.device) ? /* On mobile / widget : display available views as lines, without icons */ /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && 'rf-border-t rf-border-t-menuBorder'}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: (0, $eO5xw.capitalizeFirstLetter)(label, locale)
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-h-24 rf-w-24 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)'
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $32f0441594b75de7$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                view: props.view,
                className: "rf-h-8"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                icon: props.icon,
                className: "rf-h-8 rf-w-8 rf-flex"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-uppercase rf-text-[#575F6B] ${isRTL ? 'rf-text-arabic' : 'rf-text-xs'}`,
                children: label
            })
        ]
    });
};
var $32f0441594b75de7$export$2e2bcd8739ae039 = $32f0441594b75de7$var$DisplaySubGenerator;

});


parcelRegister("lRvrG", function(module, exports) {

$parcel$export(module.exports, "default", () => $83d678f470f68632$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $3RB0m = parcelRequire("3RB0m");
const $83d678f470f68632$var$Version = ({ isMobile: isMobile })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `${isMobile ? 'rf-px-5 rf-pt-6 rf-text-xsm' : 'rf-absolute rf-left-8 rf-bottom-2 rf-text-sm'} rf-text-[#A4A7AF] rf-text-sm`,
        children: `v ${(0, $3RB0m.version)}`
    });
};
var $83d678f470f68632$export$2e2bcd8739ae039 = $83d678f470f68632$var$Version;

});
parcelRegister("3RB0m", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@davi-ai/retorik-framework\",\"version\":\"4.0.4\",\"homepage\":\".\",\"description\":\"Retorik Framework package\",\"author\":\"DAVI\",\"license\":\"MIT\",\"repository\":\"none\",\"main\":\"dist/index.js\",\"module\":\"dist/index.modern.js\",\"types\":\"dist/index.d.ts\",\"source\":\"src/index.tsx\",\"standalone\":\"standalone/index.js\",\"targets\":{\"standalone\":{\"context\":\"browser\",\"outputFormat\":\"esmodule\",\"distDir\":\"standalone\"},\"module\":{\"context\":\"browser\",\"outputFormat\":\"esmodule\",\"distDir\":\"dist\"}},\"engines\":{\"node\":\">=10\"},\"scripts\":{\"build\":\"parcel build\",\"start\":\"parcel watch\",\"test\":\"jest --env=jsdom --reporters=jest-junit\",\"test-console\":\"jest --env=jsdom\",\"test-update-snapshots\":\"jest --env=jsdom --updateSnapshot\",\"test-coverage-console\":\"jest --env=jsdom --reporters=jest-junit --coverage\",\"test-coverage\":\"jest --env=jsdom --reporters=jest-junit --coverage --coverageReporters=cobertura\",\"report\":\"npx parcel build src/index.tsx --reporter @parcel/reporter-bundle-analyzer\",\"credentials\":\"vsts-npm-auth -config .npmrc -force\"},\"peerDependencies\":{\"react\":\"18.3.1\",\"react-dom\":\"18.3.1\"},\"devDependencies\":{\"@babel/core\":\"^7.19.1\",\"@babel/plugin-proposal-decorators\":\"^7.24.7\",\"@babel/plugin-proposal-private-property-in-object\":\"^7.21.11\",\"@babel/preset-env\":\"^7.25.4\",\"@babel/preset-react\":\"^7.24.7\",\"@babel/preset-typescript\":\"^7.24.7\",\"@babel/runtime\":\"^7.23.8\",\"@parcel/packager-ts\":\"^2.13.2\",\"@parcel/reporter-bundle-analyzer\":\"^2.13.2\",\"@parcel/reporter-sourcemap-visualiser\":\"^2.13.2\",\"@parcel/transformer-inline-string\":\"^2.13.2\",\"@parcel/transformer-typescript-types\":\"^2.13.2\",\"@parcel/validator-eslint\":\"^2.13.2\",\"@parcel/validator-typescript\":\"^2.13.2\",\"@testing-library/dom\":\"^10.4.0\",\"@testing-library/jest-dom\":\"6.5.0\",\"@testing-library/react\":\"16.0.1\",\"@testing-library/react-hooks\":\"8.0.1\",\"@testing-library/user-event\":\"14.5.2\",\"@types/jest\":\"^27.5.1\",\"@types/leaflet\":\"^1.8.0\",\"@types/node\":\"^12.12.38\",\"@types/react\":\"18.3.12\",\"@types/react-dom\":\"18.3.1\",\"@types/testing-library__jest-dom\":\"^5.14.5\",\"@types/testing-library__react\":\"latest\",\"@typescript-eslint/eslint-plugin\":\"^8.19.0\",\"@typescript-eslint/parser\":\"^8.19.0\",\"autoprefixer\":\"^10.4.7\",\"babel-eslint\":\"^10.0.3\",\"babel-jest\":\"^29.7.0\",\"babel-loader\":\"^8.2.5\",\"buffer\":\"^5.7.1\",\"canvas\":\"^2.9.0\",\"cross-env\":\"^7.0.2\",\"crypto-browserify\":\"^3.12.0\",\"eslint\":\"^9.16.0\",\"eslint-config-prettier\":\"^9.1.0\",\"eslint-config-standard\":\"^17.1.0\",\"eslint-config-standard-react\":\"^13.0.0\",\"eslint-plugin-import\":\"^2.31.0\",\"eslint-plugin-node\":\"^11.1.0\",\"eslint-plugin-prettier\":\"^5.2.1\",\"eslint-plugin-promise\":\"^7.2.1\",\"eslint-plugin-react\":\"^7.37.2\",\"https-browserify\":\"^1.0.0\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"jest-junit\":\"16.0.0\",\"npm-run-all\":\"^4.1.5\",\"parcel\":\"^2.13.2\",\"postcss\":\"^8.4.14\",\"postcss-url\":\"^10.1.3\",\"prettier\":\"^2.0.4\",\"process\":\"^0.11.10\",\"punycode\":\"^1.4.1\",\"querystring-es3\":\"^0.2.1\",\"react\":\"^18\",\"react-docgen-typescript-plugin\":\"^1.0.5\",\"react-dom\":\"18.3.1\",\"react-test-renderer\":\"^18.3.1\",\"resize-observer-polyfill\":\"^1.5.1\",\"stream-browserify\":\"^3.0.0\",\"stream-http\":\"^3.2.0\",\"string_decoder\":\"^1.3.0\",\"tailwindcss\":\"^3.1.0\",\"typescript\":\"5.3.2\",\"url\":\"^0.11.0\",\"util\":\"^0.12.4\"},\"files\":[\"dist\"],\"dependencies\":{\"@davi-ai/body-engine-sprite\":\"3.0.1\",\"@davi-ai/react-bodyengine-three\":\"1.0.13\",\"@davi-ai/retorik-map\":\"4.0.2\",\"@davi-ai/retorik-weather\":\"2.0.0\",\"@davi-ai/speechmarkdown-davi-js\":\"2.0.1\",\"@davi-ai/virtual-keyboard\":\"1.0.1\",\"@davi-ai/web-speech-cognitive-services-davi\":\"3.0.0\",\"@lottiefiles/react-lottie-player\":\"^3.4.1\",\"@mediapipe/tasks-vision\":\"0.10.32\",\"@opentelemetry/api\":\"^1.9.0\",\"@opentelemetry/exporter-trace-otlp-http\":\"^0.200.0\",\"@opentelemetry/instrumentation\":\"^0.200.0\",\"@opentelemetry/instrumentation-document-load\":\"^0.45.0\",\"@opentelemetry/instrumentation-fetch\":\"^0.200.0\",\"@opentelemetry/resources\":\"^2.0.0\",\"@opentelemetry/sdk-trace-web\":\"^2.0.0\",\"@opentelemetry/semantic-conventions\":\"^1.32.0\",\"@react-spring/types\":\"^9.7.3\",\"@react-spring/web\":\"^9.7.3\",\"@swc/helpers\":\"^0.5.0\",\"@types/geojson\":\"^7946.0.10\",\"@types/jsdom\":\"^16.2.14\",\"@use-gesture/react\":\"^10.2.15\",\"adaptivecards\":\"3.0.1\",\"classnames\":\"^2.3.1\",\"leaflet\":\"^1.9.2\",\"markdown-it\":\"14.1.0\",\"pdfjs-dist\":\"3.11.174\",\"postcss-copy\":\"^7.1.0\",\"qrcode\":\"^1.5.1\",\"react-device-detect\":\"^2.2.3\",\"react-error-boundary\":\"^4.0.10\",\"react-leaflet\":\"^4.1.0\",\"react-pdf\":\"7.7.1\",\"react-redux\":\"^9.2.0\",\"react-shadow\":\"^20.5.0\",\"swiper\":\"^8.4.5\"},\"overrides\":{\"@davi-ai/web-speech-cognitive-services-davi\":\"$@davi-ai/web-speech-cognitive-services-davi\"},\"@parcel/resolver-default\":{\"packageExports\":true}}");

});



parcelRegister("CgDXB", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb354ba306826829$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $dLhbi = parcelRequire("dLhbi");
const $eb354ba306826829$var$HistoryButton = ({ handleBack: handleBack })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    /**
   * On call :
   *  - call parent's handleBack method if defined
   *  - change RetorikContext's currentSubView state
   */ const handleClick = ()=>{
        handleBack && handleBack();
        dispatch((0, $cto9a.storeActions).utils.setCurrentSubView(currentSubView === (0, $2rYkD.CurrentSubView).history ? (0, $2rYkD.CurrentSubView).none : (0, $2rYkD.CurrentSubView).history));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dLhbi.default), {
        title: translation.history.title,
        icon: "history",
        color: currentSubView === (0, $2rYkD.CurrentSubView).history ? themeColors.secondary : '#A4A7AF',
        onClick: handleClick
    });
};
var $eb354ba306826829$export$2e2bcd8739ae039 = $eb354ba306826829$var$HistoryButton;

});
parcelRegister("dLhbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7613824d9fccf2$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $13Gq4 = parcelRequire("13Gq4");
parcelRequire("81HL8");
var $2ogpH = parcelRequire("2ogpH");
var $k1ioo = parcelRequire("k1ioo");
var $3EchS = parcelRequire("3EchS");
parcelRequire("7Jjoy");
var $iyJo4 = parcelRequire("iyJo4");
const $8e7613824d9fccf2$var$ParameterButton = ({ title: title, color: color, icon: icon, onClick: onClick })=>{
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row ${icon === 'lang' ? 'rf-justify-between' : 'rf-justify-start'} rf-items-center rf-border-t rf-border-t-menuBorder rf-capitalize`,
        onClick: (e)=>onClick(e),
        "aria-label": title,
        children: [
            title,
            icon === 'lang' && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-flex rf-flex-row rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-mr-3 rf-text-lightgray rf-normal-case",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($13Gq4)))[locale]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iyJo4.default), {
                        className: "rf-h-4"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-width-fill-available rf-mx-3 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg",
        style: {
            color: color || '#A4A7AF',
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)',
            boxShadow: '2px 2px 6px #00000029'
        },
        onClick: (e)=>onClick(e),
        "aria-label": title,
        children: [
            icon === 'tutorial' ? /*#__PURE__*/ (0, $fl9nK.jsx)($3EchS.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === 'history' ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ogpH.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === 'lang' ? /*#__PURE__*/ (0, $fl9nK.jsx)($k1ioo.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-1 rf-uppercase",
                children: title
            })
        ]
    });
};
var $8e7613824d9fccf2$export$2e2bcd8739ae039 = $8e7613824d9fccf2$var$ParameterButton;

});
parcelRegister("13Gq4", function(module, exports) {
module.exports = JSON.parse('{"aa":"Qafar","aa-DJ":"Qafar (Yabuuti)","aa-ER":"Qafar (Eretria)","aa-ET":"Qafar (Otobbia)","af":"Afrikaans","af-NA":"Afrikaans (Namibi\xeb)","af-ZA":"Afrikaans (Suid-Afrika)","agq":"Aghem","agq-CM":"Aghem (K\xe0m\xe0l\xfb\u014B)","ak":"Akan","ak-GH":"Akan (Gaana)","am":"\u12A0\u121B\u122D\u129B","am-ET":"\u12A0\u121B\u122D\u129B (\u12A2\u1275\u12EE\u1335\u12EB)","ar":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629","ar-001":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0639\u0627\u0644\u0645)","ar-AE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629)","ar-BH":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0628\u062D\u0631\u064A\u0646)","ar-DJ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062C\u064A\u0628\u0648\u062A\u064A)","ar-DZ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u062C\u0632\u0627\u0626\u0631)","ar-EG":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0645\u0635\u0631)","ar-ER":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0625\u0631\u064A\u062A\u0631\u064A\u0627)","ar-IL":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0625\u0633\u0631\u0627\u0626\u064A\u0644)","ar-IQ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0639\u0631\u0627\u0642)","ar-JO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0623\u0631\u062F\u0646)","ar-KM":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631)","ar-KW":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0643\u0648\u064A\u062A)","ar-LB":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0644\u0628\u0646\u0627\u0646)","ar-LY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0644\u064A\u0628\u064A\u0627)","ar-MA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u063A\u0631\u0628\u064A\u0629)","ar-MR":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627)","arn":"Mapudungun","arn-CL":"Mapudungun (Chile)","ar-OM":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0639\u0645\u0627\u0646)","ar-PS":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0633\u0644\u0637\u0629 \u0627\u0644\u0641\u0644\u0633\u0637\u064A\u0646\u064A\u0629)","ar-QA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0642\u0637\u0631)","ar-SA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629)","ar-SD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0633\u0648\u062F\u0627\u0646)","ar-SO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0635\u0648\u0645\u0627\u0644)","ar-SS":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062C\u0646\u0648\u0628 \u0627\u0644\u0633\u0648\u062F\u0627\u0646)","ar-SY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0633\u0648\u0631\u064A\u0627)","ar-TD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062A\u0634\u0627\u062F)","ar-TN":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062A\u0648\u0646\u0633)","ar-YE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u064A\u0645\u0646)","as":"\u0985\u09B8\u09AE\u09C0\u09DF\u09BE","asa":"Kipare","asa-TZ":"Kipare (Tadhania)","as-IN":"\u0985\u09B8\u09AE\u09C0\u09DF\u09BE (\u09AD\u09BE\u09F0\u09A4)","ast":"asturianu","ast-ES":"asturianu (Espa\xf1a)","az":"az\u0259rbaycan","az-Cyrl":"\u0410\u0437\u04D9\u0440\u0431\u0430\u0458\u04B9\u0430\u043D \u0434\u0438\u043B\u0438","az-Cyrl-AZ":"\u0430\u0437\u04D9\u0440\u0431\u0430\u0458\u04B9\u0430\u043D (\u0410\u0437\u04D9\u0440\u0431\u0430\u0458\u04B9\u0430\u043D)","az-Latn":"az\u0259rbaycan","az-Latn-AZ":"az\u0259rbaycan (Az\u0259rbaycan)","ba":"\u0411\u0430\u0448\u04A1\u043E\u0440\u0442","ba-RU":"\u0411\u0430\u0448\u04A1\u043E\u0440\u0442 (\u0420\u04D9\u0441\u04D9\u0439)","bas":"\u0181\xe0s\xe0a","bas-CM":"\u0181\xe0s\xe0a (K\xe0m\u025B\u0300r\xfbn)","be":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F","be-BY":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)","bem":"Ichibemba","bem-ZM":"Ichibemba (Zambia)","bez":"Hibena","bez-TZ":"Hibena (Hutanzania)","bg":"\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438","bg-BG":"\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438 (\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F)","bin":"\u1EB8\u0300d\xf3","bin-NG":"\u1EB8\u0300d\xf3 (Nigeria)","bm":"bamanakan","bm-Latn":"bamanakan","bm-Latn-ML":"bamanakan (Mali)","bn":"\u09AC\u09BE\u0982\u09B2\u09BE","bn-BD":"\u09AC\u09BE\u0982\u09B2\u09BE (\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)","bn-IN":"\u09AC\u09BE\u0982\u09B2\u09BE (\u09AD\u09BE\u09B0\u09A4)","bo":"\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42","bo-CN":"\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42 (\u0F40\u0FB2\u0F74\u0F44\u0F0B\u0F67\u0FAD\u0F0B\u0F58\u0F72\u0F0B\u0F51\u0F58\u0F44\u0F66\u0F0B\u0F66\u0FA4\u0FB1\u0F72\u0F0B\u0F58\u0F50\u0F74\u0F53\u0F0B\u0F62\u0F92\u0FB1\u0F63\u0F0B\u0F41\u0F56\u0F0D)","bo-IN":"\u0F56\u0F7C\u0F51\u0F0B\u0F66\u0F90\u0F51\u0F0B (\u0F62\u0F92\u0FB1\u0F0B\u0F42\u0F62\u0F0B)","br":"brezhoneg","br-FR":"brezhoneg (Fra\xf1s)","brx":"\u092C\u0921\u093C\u094B","brx-IN":"\u092C\u0921\u093C\u094B (\u092D\u093E\u0930\u0924)","bs":"bosanski","bs-Cyrl":"\u0431\u043E\u0441\u0430\u043D\u0441\u043A\u0438","bs-Cyrl-BA":"\u0431\u043E\u0441\u0430\u043D\u0441\u043A\u0438 (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)","bs-Latn":"bosanski","bs-Latn-BA":"bosanski (Bosna i Hercegovina)","byn":"\u1265\u120A\u1295","byn-ER":"\u1265\u120A\u1295 (\u12A4\u122D\u1275\u122B)","ca":"catal\xe0","ca-AD":"catal\xe0 (Andorra)","ca-ES":"catal\xe0 (catal\xe0)","ca-ES-valencia":"valenci\xe0 (Espanya)","ca-FR":"catal\xe0 (Fran\xe7a)","ca-IT":"catal\xe0 (It\xe0lia)","ce":"\u043D\u043E\u0445\u0447\u0438\u0439\u043D","ce-RU":"\u043D\u043E\u0445\u0447\u0438\u0439\u043D (\u0420\u043E\u0441\u0441\u0438)","cgg":"Rukiga","cgg-UG":"Rukiga (Uganda)","chr":"\u13E3\u13B3\u13A9","chr-Cher":"\u13E3\u13B3\u13A9","chr-Cher-US":"\u13E3\u13B3\u13A9 (\u13CC\u13CA \u13A2\u13F3\u13BE\u13B5\u13CD\u13D4\u13C5 \u13CD\u13A6\u13DA\u13A9)","co":"Corsu","co-FR":"Corsu (Francia)","cs":"\u010De\u0161tina","cs-CZ":"\u010De\u0161tina (\u010Cesko)","cu":"\u0446\u0435\u0440\u043A\u043E\u0432\u043D\u043E\u0441\u043B\u043E\u0432\u0435\u0301\u043D\u0441\u043A\u0457\u0439","cu-RU":"\u0446\u0435\u0440\u043A\u043E\u0432\u043D\u043E\u0441\u043B\u043E\u0432\u0435\u0301\u043D\u0441\u043A\u0457\u0439 (\u0440\u0461\u0441\u0441\u0456\u0301\u0430)","cy":"Cymraeg","cy-GB":"Cymraeg (Y Deyrnas Unedig)","da":"dansk","da-DK":"dansk (Danmark)","da-GL":"dansk (Gr\xf8nland)","dav":"Kitaita","dav-KE":"Kitaita (Kenya)","de":"Deutsch","de-AT":"Deutsch (\xd6sterreich)","de-BE":"Deutsch (Belgien)","de-CH":"Deutsch (Schweiz)","de-DE":"Deutsch (Deutschland)","de-IT":"Deutsch (Italien)","de-LI":"Deutsch (Liechtenstein)","de-LU":"Deutsch (Luxemburg)","dje":"Zarmaciine","dje-NE":"Zarmaciine (Ni\u017Eer)","dsb":"dolnoserb\u0161\u0107ina","dsb-DE":"dolnoserb\u0161\u0107ina (Nimska)","dua":"du\xe1l\xe1","dua-CM":"du\xe1l\xe1 (Cameroun)","dv":"\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0784\u07A6\u0790\u07B0","dv-MV":"\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0784\u07A6\u0790\u07B0 (\u078B\u07A8\u0788\u07AC\u0780\u07A8 \u0783\u07A7\u0787\u07B0\u0796\u07AC)","dyo":"joola","dyo-SN":"joola (Senegal)","dz":"\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41","dz-BT":"\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41 (\u0F60\u0F56\u0FB2\u0F74\u0F42)","ebu":"K\u0129embu","ebu-KE":"K\u0129embu (Kenya)","ee":"E\u028Begbe","ee-GH":"E\u028Begbe (Ghana nutome)","ee-TG":"E\u028Begbe (Togo nutome)","el":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC","el-CY":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC (\u039A\u03CD\u03C0\u03C1\u03BF\u03C2)","el-GR":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC (\u0395\u03BB\u03BB\u03AC\u03B4\u03B1)","en":"English","en-001":"English (World)","en-029":"English (Caribbean)","en-150":"English (Europe)","en-AG":"English (Antigua and Barbuda)","en-AI":"English (Anguilla)","en-AS":"English (American Samoa)","en-AT":"English (Austria)","en-AU":"English (Australia)","en-BB":"English (Barbados)","en-BE":"English (Belgium)","en-BI":"English (Burundi)","en-BM":"English (Bermuda)","en-BS":"English (Bahamas)","en-BW":"English (Botswana)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-CC":"English (Cocos (Keeling) Islands)","en-CH":"English (Switzerland)","en-CK":"English (Cook Islands)","en-CM":"English (Cameroon)","en-CX":"English (Christmas Island)","en-CY":"English (Cyprus)","en-DE":"English (Germany)","en-DK":"English (Denmark)","en-DM":"English (Dominica)","en-ER":"English (Eritrea)","en-FI":"English (Finland)","en-FJ":"English (Fiji)","en-FK":"English (Falkland Islands)","en-FM":"English (Micronesia)","en-GB":"English (United Kingdom)","en-GD":"English (Grenada)","en-GG":"English (Guernsey)","en-GH":"English (Ghana)","en-GI":"English (Gibraltar)","en-GM":"English (Gambia)","en-GU":"English (Guam)","en-GY":"English (Guyana)","en-HK":"English (Hong Kong SAR)","en-ID":"English (Indonesia)","en-IE":"English (Ireland)","en-IL":"English (Israel)","en-IM":"English (Isle of Man)","en-IN":"English (India)","en-IO":"English (British Indian Ocean Territory)","en-JE":"English (Jersey)","en-JM":"English (Jamaica)","en-KE":"English (Kenya)","en-KI":"English (Kiribati)","en-KN":"English (Saint Kitts and Nevis)","en-KY":"English (Cayman Islands)","en-LC":"English (Saint Lucia)","en-LR":"English (Liberia)","en-LS":"English (Lesotho)","en-MG":"English (Madagascar)","en-MH":"English (Marshall Islands)","en-MO":"English (Macao SAR)","en-MP":"English (Northern Mariana Islands)","en-MS":"English (Montserrat)","en-MT":"English (Malta)","en-MU":"English (Mauritius)","en-MW":"English (Malawi)","en-MY":"English (Malaysia)","en-NA":"English (Namibia)","en-NF":"English (Norfolk Island)","en-NG":"English (Nigeria)","en-NL":"English (Netherlands)","en-NR":"English (Nauru)","en-NU":"English (Niue)","en-NZ":"English (New Zealand)","en-PG":"English (Papua New Guinea)","en-PH":"English (Philippines)","en-PK":"English (Pakistan)","en-PN":"English (Pitcairn Islands)","en-PR":"English (Puerto Rico)","en-PW":"English (Palau)","en-RW":"English (Rwanda)","en-SB":"English (Solomon Islands)","en-SC":"English (Seychelles)","en-SD":"English (Sudan)","en-SE":"English (Sweden)","en-SG":"English (Singapore)","en-SH":"English (St Helena, Ascension, Tristan da Cunha)","en-SI":"English (Slovenia)","en-SL":"English (Sierra Leone)","en-SS":"English (South Sudan)","en-SX":"English (Sint Maarten)","en-SZ":"English (Swaziland)","en-TC":"English (Turks and Caicos Islands)","en-TK":"English (Tokelau)","en-TO":"English (Tonga)","en-TT":"English (Trinidad and Tobago)","en-TV":"English (Tuvalu)","en-TZ":"English (Tanzania)","en-UG":"English (Uganda)","en-UM":"English (U.S. Outlying Islands)","en-US":"English (United States)","en-VC":"English (Saint Vincent and the Grenadines)","en-VG":"English (British Virgin Islands)","en-VI":"English (U.S. Virgin Islands)","en-VU":"English (Vanuatu)","en-WS":"English (Samoa)","en-ZA":"English (South Africa)","en-ZM":"English (Zambia)","en-ZW":"English (Zimbabwe)","eo":"esperanto","eo-001":"esperanto (World)","es":"espa\xf1ol","es-419":"espa\xf1ol (Latinoam\xe9rica)","es-AR":"espa\xf1ol (Argentina)","es-BO":"espa\xf1ol (Bolivia)","es-BR":"espa\xf1ol (Brasil)","es-BZ":"espa\xf1ol (Belice)","es-CL":"espa\xf1ol (Chile)","es-CO":"espa\xf1ol (Colombia)","es-CR":"espa\xf1ol (Costa Rica)","es-CU":"espa\xf1ol (Cuba)","es-DO":"espa\xf1ol (Rep\xfablica Dominicana)","es-EC":"espa\xf1ol (Ecuador)","es-ES":"espa\xf1ol (Espa\xf1a, alfabetizaci\xf3n internacional)","es-GQ":"espa\xf1ol (Guinea Ecuatorial)","es-GT":"espa\xf1ol (Guatemala)","es-HN":"espa\xf1ol (Honduras)","es-MX":"espa\xf1ol (M\xe9xico)","es-NI":"espa\xf1ol (Nicaragua)","es-PA":"espa\xf1ol (Panam\xe1)","es-PE":"espa\xf1ol (Per\xfa)","es-PH":"espa\xf1ol (Filipinas)","es-PR":"espa\xf1ol (Puerto Rico)","es-PY":"espa\xf1ol (Paraguay)","es-SV":"espa\xf1ol (El Salvador)","es-US":"espa\xf1ol (Estados Unidos)","es-UY":"espa\xf1ol (Uruguay)","es-VE":"espa\xf1ol (Venezuela)","et":"eesti","et-EE":"eesti (Eesti)","eu":"euskara","eu-ES":"euskara (euskara)","ewo":"ewondo","ewo-CM":"ewondo (Kam\u0259r\xfan)","fa":"\u0641\u0627\u0631\u0633\u06CC","fa-IR":"\u0641\u0627\u0631\u0633\u06CC (\u0627\u06CC\u0631\u0627\u0646)","ff":"Fulah","ff-CM":"Pulaar (Kameruun)","ff-GN":"Pulaar (Gine)","ff-Latn":"Fulah","ff-Latn-SN":"Fulah (S\xe9n\xe9gal)","ff-MR":"Pulaar (Muritani)","ff-NG":"Pulaar (Nigeria)","fi":"suomi","fi-FI":"suomi (Suomi)","fil":"Filipino","fil-PH":"Filipino (Pilipinas)","fo":"f\xf8royskt","fo-DK":"f\xf8royskt (Danmark)","fo-FO":"f\xf8royskt (F\xf8royar)","fr":"fran\xe7ais","fr-029":"fran\xe7ais (cara\xefbes)","fr-BE":"fran\xe7ais (Belgique)","fr-BF":"fran\xe7ais (Burkina Faso)","fr-BI":"fran\xe7ais (Burundi)","fr-BJ":"fran\xe7ais (B\xe9nin)","fr-BL":"fran\xe7ais (Saint-Barth\xe9lemy)","fr-CA":"fran\xe7ais (Canada)","fr-CD":"fran\xe7ais (Congo, R\xe9publique d\xe9mocratique du)","fr-CF":"fran\xe7ais (R\xe9publique centrafricaine)","fr-CG":"fran\xe7ais (Congo)","fr-CH":"fran\xe7ais (Suisse)","fr-CI":"fran\xe7ais (C\xf4te d\u2019Ivoire)","fr-CM":"fran\xe7ais (Cameroun)","fr-DJ":"fran\xe7ais (Djibouti)","fr-DZ":"fran\xe7ais (Alg\xe9rie)","fr-FR":"fran\xe7ais (France)","fr-GA":"fran\xe7ais (Gabon)","fr-GF":"fran\xe7ais (Guyane fran\xe7aise)","fr-GN":"fran\xe7ais (Guin\xe9e)","fr-GP":"fran\xe7ais (Guadeloupe)","fr-GQ":"fran\xe7ais (Guin\xe9e \xe9quatoriale)","fr-HT":"fran\xe7ais (Ha\xefti)","fr-KM":"fran\xe7ais (Comores)","fr-LU":"fran\xe7ais (Luxembourg)","fr-MA":"fran\xe7ais (Maroc)","fr-MC":"fran\xe7ais (Monaco)","fr-MF":"fran\xe7ais (Saint-Martin)","fr-MG":"fran\xe7ais (Madagascar)","fr-ML":"fran\xe7ais (Mali)","fr-MQ":"fran\xe7ais (Martinique)","fr-MR":"fran\xe7ais (Mauritanie)","fr-MU":"fran\xe7ais (Maurice)","fr-NC":"fran\xe7ais (Nouvelle-Cal\xe9donie)","fr-NE":"fran\xe7ais (Niger)","fr-PF":"fran\xe7ais (Polyn\xe9sie fran\xe7aise)","fr-PM":"fran\xe7ais (Saint-Pierre-et-Miquelon)","fr-RE":"fran\xe7ais (La R\xe9union)","fr-RW":"fran\xe7ais (Rwanda)","fr-SC":"fran\xe7ais (Seychelles)","fr-SN":"fran\xe7ais (S\xe9n\xe9gal)","fr-SY":"fran\xe7ais (Syrie)","fr-TD":"fran\xe7ais (Tchad)","fr-TG":"fran\xe7ais (Togo)","fr-TN":"fran\xe7ais (Tunisie)","fr-VU":"fran\xe7ais (Vanuatu)","fr-WF":"fran\xe7ais (Wallis-et-Futuna)","fr-YT":"fran\xe7ais (Mayotte)","fur":"furlan","fur-IT":"furlan (Italie)","fy":"Frysk","fy-NL":"Frysk (Nederl\xe2n)","ga":"Gaeilge","ga-IE":"Gaeilge (\xc9ire)","gd":"G\xe0idhlig","gd-GB":"G\xe0idhlig (An R\xecoghachd Aonaichte)","gl":"galego","gl-ES":"galego (galego)","gn":"Ava\xf1e\u2019\u1EBD","gn-PY":"Ava\xf1e\u2019\u1EBD (Paragu\xe1i)","gsw":"Schwiizert\xfc\xfctsch","gsw-CH":"Schwiizert\xfc\xfctsch (Schwiiz)","gsw-FR":"Els\xe4ssisch (Fr\xe0nkrisch)","gsw-LI":"Schwiizert\xfc\xfctsch (Li\xe4chtescht\xe4i)","gu":"\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0","gu-IN":"\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0 (\u0AAD\u0ABE\u0AB0\u0AA4)","guz":"Ekegusii","guz-KE":"Ekegusii (Kenya)","gv":"Gaelg","gv-IM":"Gaelg (Ellan Vannin)","ha":"Hausa","ha-Latn":"Hausa","ha-Latn-GH":"Hausa (Gana)","ha-Latn-NE":"Hausa (Nijar)","ha-Latn-NG":"Hausa (Najeriya)","haw":"\u02BB\u014Clelo Hawai\u02BBi","haw-US":"\u02BB\u014Clelo Hawai\u02BBi (\u02BBAmelika Hui P\u016B \u02BBIa)","he":"\u05E2\u05D1\u05E8\u05D9\u05EA","he-IL":"\u05E2\u05D1\u05E8\u05D9\u05EA (\u05D9\u05E9\u05E8\u05D0\u05DC)","hi":"\u0939\u093F\u0928\u094D\u0926\u0940","hi-IN":"\u0939\u093F\u0928\u094D\u0926\u0940 (\u092D\u093E\u0930\u0924)","hr":"hrvatski","hr-BA":"hrvatski (Bosna i Hercegovina)","hr-HR":"hrvatski (Hrvatska)","hsb":"hornjoserb\u0161\u0107ina","hsb-DE":"hornjoserb\u0161\u0107ina (N\u011Bmska)","hu":"magyar","hu-HU":"magyar (Magyarorsz\xe1g)","hy":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576","hy-AM":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576 (\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576)","ia":"interlingua","ia-001":"interlingua (World)","ia-FR":"interlingua (Francia)","ibb":"Ibibio-Efik","ibb-NG":"Ibibio-Efik (Nigeria)","id":"Indonesia","id-ID":"Indonesia (Indonesia)","ig":"Igbo","ig-NG":"Igbo (Na\u1ECBj\u1ECBr\u1ECBa)","ii":"\uA188\uA320\uA071\uA0B7","ii-CN":"\uA188\uA320\uA071\uA0B7 (\uA34F\uA278\uA3D3\uA0B1\uA1ED\uA27C\uA1E9)","is":"\xedslenska","is-IS":"\xedslenska (\xcdsland)","it":"italiano","it-CH":"italiano (Svizzera)","it-IT":"italiano (Italia)","it-SM":"italiano (San Marino)","it-VA":"italiano (Citt\xe0 del Vaticano)","iu":"Inuktitut","iu-Cans":"\u1403\u14C4\u1483\u144E\u1450\u1466","iu-Cans-CA":"\u1403\u14C4\u1483\u144E\u1450\u1466 (\u1472\u14C7\u1455\u14A5)","iu-Latn":"Inuktitut","iu-Latn-CA":"Inuktitut (Kanatami)","ja":"\u65E5\u672C\u8A9E","ja-JP":"\u65E5\u672C\u8A9E (\u65E5\u672C)","jgo":"Nda\uA78Ca","jgo-CM":"Nda\uA78Ca (Kam\u025Bl\xfbn)","jmc":"Kimachame","jmc-TZ":"Kimachame (Tanzania)","jv":"Basa Jawa","jv-Java":"\uA9A7\uA9B1\uA997\uA9AE","jv-Java-ID":"\uA9A7\uA9B1\uA997\uA9AE (Indonesia)","jv-Latn":"Basa Jawa","jv-Latn-ID":"Basa Jawa (Indonesia)","ka":"\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8","kab":"Taqbaylit","kab-DZ":"Taqbaylit (Lezzayer)","ka-GE":"\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 (\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD)","kam":"Kikamba","kam-KE":"Kikamba (Kenya)","kde":"Chimakonde","kde-TZ":"Chimakonde (Tanzania)","kea":"kabuverdianu","kea-CV":"kabuverdianu (Kabu Verdi)","khq":"Koyra ciini","khq-ML":"Koyra ciini (Maali)","ki":"Gikuyu","ki-KE":"Gikuyu (Kenya)","kk":"\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456","kkj":"kak\u0254","kkj-CM":"kak\u0254 (Kam\u025Brun)","kk-KZ":"\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456 (\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D)","kl":"kalaallisut","kl-GL":"kalaallisut (Kalaallit Nunaat)","kln":"Kalenjin","kln-KE":"Kalenjin (Emetab Kenya)","km":"\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A","km-KH":"\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A (\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6)","kn":"\u0C95\u0CA8\u0CCD\u0CA8\u0CA1","kn-IN":"\u0C95\u0CA8\u0CCD\u0CA8\u0CA1 (\u0CAD\u0CBE\u0CB0\u0CA4)","ko":"\uD55C\uAD6D\uC5B4","kok":"\u0915\u094B\u0902\u0915\u0923\u0940","kok-IN":"\u0915\u094B\u0902\u0915\u0923\u0940 (\u092D\u093E\u0930\u0924)","ko-KP":"\uD55C\uAD6D\uC5B4 (\uC870\uC120\uBBFC\uC8FC\uC8FC\uC758\uC778\uBBFC\uACF5\uD654\uAD6D)","ko-KR":"\uD55C\uAD6D\uC5B4(\uB300\uD55C\uBBFC\uAD6D)","kr":"Kanuri","kr-NG":"Kanuri (Nigeria)","ks":"\u06A9\u0672\u0634\u064F\u0631","ks-Arab":"\u06A9\u0672\u0634\u064F\u0631","ks-Arab-IN":"\u06A9\u0672\u0634\u064F\u0631 (\u0627\u064E\u0631\u0628\u06CC)","ksb":"Kishambaa","ksb-TZ":"Kishambaa (Tanzania)","ks-Deva":"\u0915\u0949\u0936\u0941\u0930","ks-Deva-IN":"\u0915\u0949\u0936\u0941\u0930","ksf":"rikpa","ksf-CM":"rikpa (kam\u025Br\xfan)","ksh":"K\xf6lsch","ksh-DE":"K\xf6lsch (Do\xfctschland)","ku":"\u06A9\u0648\u0631\u062F\u06CC\u06CC \u0646\u0627\u0648\u06D5\u0695\u0627\u0633\u062A","ku-Arab":"\u06A9\u0648\u0631\u062F\u06CC\u06CC \u0646\u0627\u0648\u06D5\u0695\u0627\u0633\u062A","ku-Arab-IQ":"\u06A9\u0648\u0631\u062F\u06CC\u06CC \u0646\u0627\u0648\u06D5\u0695\u0627\u0633\u062A (\u0639\u06CE\u0631\u0627\u0642)","ku-Arab-IR":"\u06A9\u0648\u0631\u062F\u06CC (\u0626\u06CE\u0631\u0627\u0646)","kw":"kernewek","kw-GB":"kernewek (Rywvaneth Unys)","ky":"\u041A\u044B\u0440\u0433\u044B\u0437","ky-KG":"\u041A\u044B\u0440\u0433\u044B\u0437 (\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D)","la":"lingua lat\u012Bna","la-001":"lingua lat\u012Bna (World)","lag":"K\u0268laangi","lag-TZ":"K\u0268laangi (Taansan\xeda)","lb":"L\xebtzebuergesch","lb-LU":"L\xebtzebuergesch (L\xebtzebuerg)","lg":"Luganda","lg-UG":"Luganda (Yuganda)","lkt":"Lak\u021F\xf3l\u02BCiyapi","lkt-US":"Lak\u021F\xf3l\u02BCiyapi (M\xedlaha\u014Bska T\u021Fam\xe1k\u021Fo\u010Dhe)","ln":"ling\xe1la","ln-AO":"ling\xe1la (Ang\xf3la)","ln-CD":"ling\xe1la (Republ\xedki ya Kong\xf3 Demokrat\xedki)","ln-CF":"ling\xe1la (Repibiki ya Afr\xedka ya K\xe1ti)","ln-CG":"ling\xe1la (Kongo)","lo":"\u0EA5\u0EB2\u0EA7","lo-LA":"\u0EA5\u0EB2\u0EA7 (\u0EA5\u0EB2\u0EA7)","lrc":"\u0644\u06CA\u0631\u06CC \u0634\u0648\u0645\u0627\u0644\u06CC","lrc-IQ":"\u0644\u06CA\u0631\u06CC \u0634\u0648\u0645\u0627\u0644\u06CC (Iraq)","lrc-IR":"\u0644\u06CA\u0631\u06CC \u0634\u0648\u0645\u0627\u0644\u06CC (Iran)","lt":"lietuvi\u0173","lt-LT":"lietuvi\u0173 (Lietuva)","lu":"Tshiluba","lu-CD":"Tshiluba (Ditunga wa Kongu)","luo":"Dholuo","luo-KE":"Dholuo (Kenya)","luy":"Luluhia","luy-KE":"Luluhia (Kenya)","lv":"latvie\u0161u","lv-LV":"latvie\u0161u (Latvija)","mas":"Maa","mas-KE":"Maa (Kenya)","mas-TZ":"Maa (Tansania)","mer":"K\u0129m\u0129r\u0169","mer-KE":"K\u0129m\u0129r\u0169 (Kenya)","mfe":"kreol morisien","mfe-MU":"kreol morisien (Moris)","mg":"Malagasy","mgh":"Makua","mgh-MZ":"Makua (Umozambiki)","mg-MG":"Malagasy (Madagasikara)","mgo":"meta\u02BC","mgo-CM":"meta\u02BC (Kamalun)","mi":"te reo M\u0101ori","mi-NZ":"te reo M\u0101ori (Aotearoa)","mk":"\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438","mk-MK":"\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 (\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430)","ml":"\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02","ml-IN":"\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02 (\u0D07\u0D28\u0D4D\u0D24\u0D4D\u0D2F)","mn":"\u043C\u043E\u043D\u0433\u043E\u043B","mn-Cyrl":"\u043C\u043E\u043D\u0433\u043E\u043B","mni":"\u09AE\u09C8\u09A4\u09C8\u09B2\u09CB\u09A8\u09CD","mni-IN":"\u09AE\u09C8\u09A4\u09C8\u09B2\u09CB\u09A8\u09CD (India)","mn-MN":"\u043C\u043E\u043D\u0433\u043E\u043B (\u041C\u043E\u043D\u0433\u043E\u043B)","mn-Mong":"\u182E\u1823\u1829\u182D\u1823\u1824\u182F \u182C\u1821\u182F\u1821","mn-Mong-CN":"\u182E\u1823\u1829\u182D\u1823\u1824\u182F \u182C\u1821\u182F\u1821 (\u182A\u1826\u182D\u1826\u1833\u1821 \u1828\u1820\u1822\u1837\u1820\u182E\u1833\u1820\u182C\u1824 \u1833\u1824\u182E\u1833\u1820\u1833\u1824 \u1820\u1837\u1820\u1833 \u1823\u182F\u1823\u1830)","mn-Mong-MN":"\u182E\u1823\u1829\u182D\u1823\u182F \u182C\u1821\u182F\u1821 (\u182E\u1823\u1829\u182D\u1823\u182F \u1823\u182F\u1823\u1830)","moh":"Kanien\u2019k\xe9ha","moh-CA":"Kanien\'k\xe9ha","mr":"\u092E\u0930\u093E\u0920\u0940","mr-IN":"\u092E\u0930\u093E\u0920\u0940 (\u092D\u093E\u0930\u0924)","ms":"Melayu","ms-BN":"Melayu (Brunei)","ms-MY":"Melayu (Malaysia)","ms-SG":"Melayu (Singapura)","mt":"Malti","mt-MT":"Malti (Malta)","mua":"MUNDA\u014A","mua-CM":"MUNDA\u014A (kameru\u014B)","my":"\u1017\u1019\u102C","my-MM":"\u1019\u103C\u1014\u103A\u1019\u102C (\u1019\u103C\u1014\u103A\u1019\u102C)","mzn":"\u0645\u0627\u0632\u0631\u0648\u0646\u06CC","mzn-IR":"\u0645\u0627\u0632\u0631\u0648\u0646\u06CC (\u0627\u06CC\u0631\u0627\u0646)","naq":"Khoekhoegowab","naq-NA":"Khoekhoegowab (Namibiab)","nb":"norsk bokm\xe5l","nb-NO":"norsk bokm\xe5l (Norge)","nb-SJ":"norsk bokm\xe5l (Svalbard og Jan Mayen)","nd":"isiNdebele","nds":"Neddersass\u2019sch","nds-DE":"Neddersass\u2019sch (D\xfc\xfctschland)","nds-NL":"Neddersass\u2019sch (Nedderlannen)","nd-ZW":"isiNdebele (Zimbabwe)","ne":"\u0928\u0947\u092A\u093E\u0932\u0940","ne-IN":"\u0928\u0947\u092A\u093E\u0932\u0940 (\u092D\u093E\u0930\u0924)","ne-NP":"\u0928\u0947\u092A\u093E\u0932\u0940 (\u0928\u0947\u092A\u093E\u0932)","nl":"Nederlands","nl-AW":"Nederlands (Aruba)","nl-BE":"Nederlands (Belgi\xeb)","nl-BQ":"Nederlands (Bonaire, Sint Eustatius en Saba)","nl-CW":"Nederlands (Cura\xe7ao)","nl-NL":"Nederlands (Nederland)","nl-SR":"Nederlands (Suriname)","nl-SX":"Nederlands (Sint-Maarten)","nmg":"Kwasio","nmg-CM":"Kwasio (Kamerun)","nn":"nynorsk","nnh":"Shw\xf3\u014B\xf2 ngiemb\u0254\u0254n","nnh-CM":"Shw\xf3\u014B\xf2 ngiemb\u0254\u0254n (K\xe0mal\xfbm)","nn-NO":"nynorsk (Noreg)","no":"norsk","nqo":"\u07D2\u07DE\u07CF","nqo-GN":"\u07D2\u07DE\u07CF (\u07D6\u07CC\u07EC\u07E3\u07CD\u07EC \u07DE\u07CA\u07F2\u07D3\u07CD\u07F2)","nr":"isiNdebele","nr-ZA":"isiNdebele (South Africa)","nso":"Sesotho sa Leboa","nso-ZA":"Sesotho sa Leboa (Afrika Borwa)","nus":"Thok Nath","nus-SS":"Thok Nath (South Sudan)","nyn":"Runyankore","nyn-UG":"Runyankore (Uganda)","oc":"Occitan","oc-FR":"Occitan (Fran\xe7a)","om":"Oromoo","om-ET":"Oromoo (Itoophiyaa)","om-KE":"Oromoo (Keeniyaa)","or":"\u0B13\u0B5C\u0B3F\u0B06","or-IN":"\u0B13\u0B5C\u0B3F\u0B06 (\u0B2D\u0B3E\u0B30\u0B24)","os":"\u0438\u0440\u043E\u043D","os-GE":"\u0438\u0440\u043E\u043D (\u0413\u0443\u044B\u0440\u0434\u0437\u044B\u0441\u0442\u043E\u043D)","os-RU":"\u0438\u0440\u043E\u043D (\u0423\u04D5\u0440\u04D5\u0441\u0435)","pa":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40","pa-Arab":"\u067E\u0646\u062C\u0627\u0628\u06CC","pa-Arab-PK":"\u067E\u0646\u062C\u0627\u0628\u06CC (\u067E\u0627\u06A9\u0633\u062A\u0627\u0646)","pa-Guru":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40","pa-IN":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40 (\u0A2D\u0A3E\u0A30\u0A24)","pap":"Papiamentu","pap-029":"Papiamentu (Caribbean)","pl":"polski","pl-PL":"polski (Polska)","prg":"pr\u016Bsiskan","prg-001":"pr\u016Bsiskan (sw\u012Btai)","prs":"\u062F\u0631\u0649","prs-AF":"\u062F\u0631\u0649 (\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646)","ps":"\u067E\u069A\u062A\u0648","ps-AF":"\u067E\u069A\u062A\u0648 (\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646)","pt":"portugu\xeas","pt-AO":"portugu\xeas (Angola)","pt-BR":"portugu\xeas (Brasil)","pt-CH":"portugu\xeas (Su\xed\xe7a)","pt-CV":"portugu\xeas (Cabo Verde)","pt-GQ":"portugu\xeas (Guin\xe9 Equatorial)","pt-GW":"portugu\xeas (Guin\xe9-Bissau)","pt-LU":"portugu\xeas (Luxemburgo)","pt-MO":"portugu\xeas (RAE de Macau)","pt-MZ":"portugu\xeas (Mo\xe7ambique)","pt-PT":"portugu\xeas (Portugal)","pt-ST":"portugu\xeas (S\xe3o Tom\xe9 e Pr\xedncipe)","pt-TL":"portugu\xeas (Timor-Leste)","quc":"K\'iche\'","quc-Latn":"K\'iche\'","quc-Latn-GT":"K\'iche\' (Guatemala)","quz":"Runasimi","quz-BO":"Runasimi (Bolivia)","quz-EC":"Runasimi (Ecuador)","quz-PE":"Runasimi (Per\xfa)","rm":"rumantsch","rm-CH":"rumantsch (Svizra)","rn":"Ikirundi","rn-BI":"Ikirundi (Uburundi)","ro":"rom\xe2n\u0103","rof":"Kihorombo","rof-TZ":"Kihorombo (Tanzania)","ro-MD":"rom\xe2n\u0103 (Republica Moldova)","ro-RO":"rom\xe2n\u0103 (Rom\xe2nia)","ru":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439","ru-BY":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)","ru-KG":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F)","ru-KZ":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D)","ru-MD":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u041C\u043E\u043B\u0434\u043E\u0432\u0430)","ru-RU":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u0420\u043E\u0441\u0441\u0438\u044F)","ru-UA":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u0423\u043A\u0440\u0430\u0438\u043D\u0430)","rw":"Kinyarwanda","rwk":"Kiruwa","rwk-TZ":"Kiruwa (Tanzania)","rw-RW":"Kinyarwanda (U Rwanda)","sa":"\u0938\u0902\u0938\u094D\u0915\u0943\u0924","sah":"\u0421\u0430\u0445\u0430","sah-RU":"\u0421\u0430\u0445\u0430 (\u0420\u043E\u0441\u0441\u0438\u044F)","sa-IN":"\u0938\u0902\u0938\u094D\u0915\u0943\u0924 (\u092D\u093E\u0930\u0924\u092E\u094D)","saq":"Kisampur","saq-KE":"Kisampur (Kenya)","sbp":"Ishisangu","sbp-TZ":"Ishisangu (Tansaniya)","sd":"\u0633\u0646\u068C\u064A","sd-Arab":"\u0633\u0646\u068C\u064A","sd-Arab-PK":"\u0633\u0646\u068C\u064A (\u067E\u0627\u06A9\u0633\u062A\u0627\u0646)","sd-Deva":"\u0938\u093F\u0928\u094D\u0927\u0940","sd-Deva-IN":"\u0938\u093F\u0928\u094D\u0927\u0940 (India)","se":"davvis\xe1megiella","se-FI":"davvis\xe1megiella (Suopma)","seh":"sena","seh-MZ":"sena (Mo\xe7ambique)","se-NO":"davvis\xe1megiella (Norga)","ses":"Koyraboro senni","se-SE":"davvis\xe1megiella (Ruo\u0167\u0167a)","ses-ML":"Koyraboro senni (Maali)","sg":"S\xe4ng\xf6","sg-CF":"S\xe4ng\xf6 (K\xf6d\xf6r\xf6s\xease t\xee B\xeaafr\xeeka)","shi":"\u2D5C\u2D30\u2D5B\u2D4D\u2D43\u2D49\u2D5C","shi-Latn":"Tashel\u1E25iyt","shi-Latn-MA":"Tashel\u1E25iyt (lm\u0263rib)","shi-Tfng":"\u2D5C\u2D30\u2D5B\u2D4D\u2D43\u2D49\u2D5C","shi-Tfng-MA":"\u2D5C\u2D30\u2D5B\u2D4D\u2D43\u2D49\u2D5C (\u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31)","si":"\u0DC3\u0DD2\u0D82\u0DC4\u0DBD","si-LK":"\u0DC3\u0DD2\u0D82\u0DC4\u0DBD (\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0)","sk":"sloven\u010Dina","sk-SK":"sloven\u010Dina (Slovensko)","sl":"sloven\u0161\u010Dina","sl-SI":"sloven\u0161\u010Dina (Slovenija)","sma":"\xe5arjelsaemieng\xefele","sma-NO":"\xe5arjelsaemieng\xefele (N\xf6\xf6rje)","sma-SE":"\xe5arjelsaemieng\xefele (Sveerje)","smj":"julevus\xe1megiella","smj-NO":"julevus\xe1megiella (Vuodna)","smj-SE":"julevus\xe1megiella (Svierik)","smn":"anar\xe2\u0161kiel\xe2","smn-FI":"anar\xe2\u0161kiel\xe2 (Suom\xe2)","sms":"s\xe4\xe4\xb4m\u01E9i\xf5ll","sms-FI":"s\xe4\xe4\xb4m\u01E9i\xf5ll (L\xe4\xe4\xb4ddj\xe2nnam)","sn":"chiShona","sn-Latn":"chiShona (Latin)","sn-Latn-ZW":"chiShona (Zimbabwe)","so":"Soomaali","so-DJ":"Soomaali (Jabuuti)","so-ET":"Soomaali (Itoobiya)","so-KE":"Soomaali (Kiiniya)","so-SO":"Soomaali (Soomaaliya)","sq":"shqip","sq-AL":"shqip (Shqip\xebri)","sq-MK":"shqip (Republika e Maqedonis\xeb)","sq-XK":"shqip (Kosov\xeb)","sr":"srpski","sr-Cyrl":"\u0441\u0440\u043F\u0441\u043A\u0438","sr-Cyrl-BA":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)","sr-Cyrl-ME":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430)","sr-Cyrl-RS":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u0421\u0440\u0431\u0438\u0458\u0430)","sr-Cyrl-XK":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u041A\u043E\u0441\u043E\u0432\u043E)","sr-Latn":"srpski","sr-Latn-BA":"srpski (Bosna i Hercegovina)","sr-Latn-ME":"srpski (Crna Gora)","sr-Latn-RS":"srpski (Srbija)","sr-Latn-XK":"srpski (Kosovo)","ss":"Siswati","ss-SZ":"siSwati (Swaziland)","ssy":"Saho","ssy-ER":"Saho (Eretria)","ss-ZA":"siSwati (South Africa)","st":"Sesotho","st-LS":"Sesotho (Lesotho)","st-ZA":"Sesotho (South Africa)","sv":"svenska","sv-AX":"svenska (\xc5land)","sv-FI":"svenska (Finland)","sv-SE":"svenska (Sverige)","sw":"Kiswahili","sw-CD":"Kiswahili (Jamhuri ya Kidemokrasia ya Kongo)","sw-KE":"Kiswahili (Kenya)","sw-TZ":"Kiswahili (Tanzania)","sw-UG":"Kiswahili (Uganda)","syr":"\u0723\u0718\u072A\u071D\u071D\u0710","syr-SY":"\u0723\u0718\u072A\u071D\u071D\u0710 (\u0723\u0718\u072A\u071D\u0710)","ta":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD","ta-IN":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE)","ta-LK":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8)","ta-MY":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0BAE\u0BB2\u0BC7\u0B9A\u0BBF\u0BAF\u0BBE)","ta-SG":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD)","te":"\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41","te-IN":"\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41 (\u0C2D\u0C3E\u0C30\u0C24 \u0C26\u0C47\u0C36\u0C02)","teo":"Kiteso","teo-KE":"Kiteso (Kenia)","teo-UG":"Kiteso (Uganda)","tg":"\u0422\u043E\u04B7\u0438\u043A\u04E3","tg-Cyrl":"\u0442\u043E\u04B7\u0438\u043A\u04E3","tg-Cyrl-TJ":"\u0442\u043E\u04B7\u0438\u043A\u04E3 (\u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D)","th":"\u0E44\u0E17\u0E22","th-TH":"\u0E44\u0E17\u0E22 (\u0E44\u0E17\u0E22)","ti":"\u1275\u130D\u122D\u129B","ti-ER":"\u1275\u130D\u122D\u129B (\u12A4\u122D\u1275\u122B)","ti-ET":"\u1275\u130D\u122D\u129B (\u12A2\u1275\u12EE\u1335\u12EB)","tig":"\u1275\u130D\u1228","tig-ER":"\u1275\u130D\u1228 (\u12A4\u122D\u1275\u122B)","tk":"T\xfcrkmen dili","tk-TM":"T\xfcrkmen dili (T\xfcrkmenistan)","tn":"Setswana","tn-BW":"Setswana (Botswana)","tn-ZA":"Setswana (Aforika Borwa)","to":"lea fakatonga","to-TO":"lea fakatonga (Tonga)","tr":"T\xfcrk\xe7e","tr-CY":"T\xfcrk\xe7e (K\u0131br\u0131s)","tr-TR":"T\xfcrk\xe7e (T\xfcrkiye)","ts":"Xitsonga","ts-ZA":"Xitsonga (South Africa)","tt":"\u0422\u0430\u0442\u0430\u0440","tt-RU":"\u0422\u0430\u0442\u0430\u0440 (\u0420\u043E\u0441\u0441\u0438\u044F)","twq":"Tasawaq senni","twq-NE":"Tasawaq senni (Ni\u017Eer)","tzm":"Tamazi\u0263t n la\u1E6Dla\u1E63","tzm-Arab":"\u0623\u0637\u0644\u0633 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629 \u0627\u0644\u062A\u0627\u0645\u0627\u0632\u064A\u062A\u064A\u0629","tzm-Arab-MA":"\u0623\u0637\u0644\u0633 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629 \u0627\u0644\u062A\u0627\u0645\u0627\u0632\u064A\u062A\u064A\u0629 (Morocco)","tzm-Latn":"Tamazi\u0263t n la\u1E6Dla\u1E63","tzm-Latn-DZ":"Tamazi\u0263t n la\u1E6Dla\u1E63 (Djaza\xefr)","tzm-Latn-MA":"Tamazi\u0263t n la\u1E6Dla\u1E63 (Me\u1E5B\u1E5Buk)","tzm-Tfng":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C","tzm-Tfng-MA":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C (\u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31)","ug":"\u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5","ug-CN":"\u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5 (\u062C\u06C7\u06AD\u062E\u06C7\u0627 \u062E\u06D5\u0644\u0642 \u062C\u06C7\u0645\u06BE\u06C7\u0631\u0649\u064A\u0649\u062A\u0649)","uk":"\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430","uk-UA":"\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430 (\u0423\u043A\u0440\u0430\u0457\u043D\u0430)","ur":"\u0627\u064F\u0631\u062F\u0648","ur-IN":"\u0627\u0631\u062F\u0648 (\u0628\u06BE\u0627\u0631\u062A)","ur-PK":"\u0627\u064F\u0631\u062F\u0648 (\u067E\u0627\u06A9\u0633\u062A\u0627\u0646)","uz":"o\u2018zbek","uz-Arab":"\u0627\u0648\u0632\u0628\u06CC\u06A9","uz-Arab-AF":"\u0627\u0648\u0632\u0628\u06CC\u06A9 (\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646)","uz-Cyrl":"\u045E\u0437\u0431\u0435\u043A\u0447\u0430","uz-Cyrl-UZ":"\u045E\u0437\u0431\u0435\u043A\u0447\u0430 (\u040E\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u043E\u043D)","uz-Latn":"o\u2018zbek","uz-Latn-UZ":"o\u2018zbek (O\u02BBzbekiston)","vai":"\uA559\uA524","vai-Latn":"Vai","vai-Latn-LR":"Vai (Laibhiya)","vai-Vaii":"\uA559\uA524","vai-Vaii-LR":"\uA559\uA524 (\uA55E\uA524\uA52B\uA569)","ve":"Tshiven\u1E13a","ve-ZA":"Tshiven\u1E13a (South Africa)","vi":"Ti\xea\u0301ng Vi\u1EC7t","vi-VN":"Ti\xea\u0301ng Vi\u1EC7t (Vi\u1EC7t Nam)","vo":"Volap\xfck","vo-001":"Volap\xfck (World)","vun":"Kyivunjo","vun-TZ":"Kyivunjo (Tanzania)","wae":"Walser","wae-CH":"Walser (Schwiz)","wal":"\u12C8\u120B\u12ED\u1273\u1271","wal-ET":"\u12C8\u120B\u12ED\u1273\u1271 (\u12A2\u1275\u12EE\u1335\u12EB)","wo":"Wolof","wo-SN":"Wolof (Senegaal)","xh":"isiXhosa","xh-ZA":"isiXhosa (eMzantsi Afrika)","xog":"Olusoga","xog-UG":"Olusoga (Yuganda)","yav":"nuasue","yav-CM":"nuasue (Kemel\xfan)","yi":"\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9","yi-001":"\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9 (\u05D5\u05D5\u05E2\u05DC\u05D8)","yo":"\xc8d\xe8 Yor\xf9b\xe1","yo-BJ":"\xc8d\xe8 Yor\xf9b\xe1 (Or\xedl\u025B\u0301\xe8de B\u025B\u0300n\u025B\u0300)","yo-NG":"\xc8d\xe8 Yor\xf9b\xe1 (Or\xedl\u1EB9\u0301\xe8de N\xe0\xecj\xedr\xed\xe0)","zgh":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C","zgh-Tfng":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C","zgh-Tfng-MA":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C (\u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31)","zh":"\u4E2D\u6587","zh-CHS":"\u4E2D\u6587(\u7B80\u4F53) \u65E7\u7248","zh-CHT":"\u4E2D\u6587(\u7E41\u9AD4) \u820A\u7248","zh-CN":"\u4E2D\u6587(\u4E2D\u56FD)","zh-Hans":"\u4E2D\u6587(\u7B80\u4F53)","zh-Hans-HK":"\u4E2D\u6587 (\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A)","zh-Hans-MO":"\u4E2D\u6587 (\u6FB3\u95E8\u7279\u522B\u884C\u653F\u533A)","zh-Hant":"\u4E2D\u6587(\u7E41\u9AD4)","zh-HK":"\u4E2D\u6587(\u9999\u6E2F\u7279\u5225\u884C\u653F\u5340)","zh-MO":"\u4E2D\u6587(\u6FB3\u9580\u7279\u5225\u884C\u653F\u5340)","zh-SG":"\u4E2D\u6587(\u65B0\u52A0\u5761)","zh-TW":"\u4E2D\u6587(\u53F0\u7063)","zu":"isiZulu","zu-ZA":"isiZulu (iNingizimu Afrika)"}');

});



parcelRegister("3o2AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe32ccb3f8998c9d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $13Gq4 = parcelRequire("13Gq4");

var $eO5xw = parcelRequire("eO5xw");

var $fzVhJ = parcelRequire("fzVhJ");

var $dLhbi = parcelRequire("dLhbi");
const $fe32ccb3f8998c9d$var$LanguageButton = ()=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const supported = (0, $5FZWK.useSelector)((state)=>state.localeReducer.supported);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const isTactile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isTactile);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const [mainLocale, setMainLocale] = (0, $bxRTa.useState)((0, $fzVhJ.getMainLocale)(locale).toUpperCase());
    const [bottom, setBottom] = (0, $bxRTa.useState)(undefined);
    (0, $bxRTa.useEffect)(()=>{
        setMainLocale((0, $fzVhJ.getMainLocale)(locale).toUpperCase());
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (configuration.languageChoiceBottom?.setUnderRemote) setBottom('-3rem');
        else switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
                if (isTactile) setBottom(configuration.languageChoiceBottom?.desktopTactile || '4rem');
                else setBottom(configuration.languageChoiceBottom?.desktop || '4rem');
                break;
            case (0, $2rYkD.DeviceType).borne:
                setBottom(configuration.languageChoiceBottom?.verticalTactile || '25vh');
                break;
        }
    }, [
        currentDeviceType
    ]);
    /**
   * On call :
   *  - change RetorikContext's currentSubView state
   */ const handleClick = (e)=>{
        dispatch((0, $cto9a.storeActions).utils.setClickedOnUI((0, $2rYkD.UIPart).languages));
        dispatch((0, $cto9a.storeActions).utils.setCurrentSubView(currentSubView === (0, $2rYkD.CurrentSubView).languages ? (0, $2rYkD.CurrentSubView).none : (0, $2rYkD.CurrentSubView).languages));
        e.stopPropagation();
        e.preventDefault();
    };
    return supported.length > 1 ? isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dLhbi.default), {
        title: translation.common.lang,
        icon: "lang",
        color: currentSubView === (0, $2rYkD.CurrentSubView).languages ? themeColors.secondary : '#A4A7AF',
        onClick: (e)=>handleClick(e)
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-absolute rf-z-ui rf-min-w-24 rf-right-0 rf-px-2 rf-flex rf-flex-row rf-items-center rf-rounded-l-lg",
        style: {
            bottom: bottom,
            background: 'linear-gradient(#F8F8FC, #EDEEF3)'
        },
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-8 rf-mr-2",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                    className: "rf-h-full",
                    src: `https://flagsapi.com/${mainLocale}/flat/64.png`
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-flex rf-flex-col rf-items-start ${isRTL ? 'rf-text-arabic' : 'rf-text-xsm'}`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-text-trueblack",
                        children: (0, $eO5xw.capitalizeFirstLetter)(translation.common.singleLang)
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-text-lightgray",
                        children: (0, $eO5xw.capitalizeFirstLetter)((0, (/*@__PURE__*/$parcel$interopDefault($13Gq4)))[locale.split('-')[0]])
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $fe32ccb3f8998c9d$export$2e2bcd8739ae039 = $fe32ccb3f8998c9d$var$LanguageButton;

});
parcelRegister("fzVhJ", function(module, exports) {

$parcel$export(module.exports, "checkLocale", () => $40aaf61b4fa53955$export$d64c0ac95bb7fd72);
$parcel$export(module.exports, "getMainLocale", () => $40aaf61b4fa53955$export$91fc93b93c368955);
const $40aaf61b4fa53955$var$checkResult = (lang, allLanguages)=>{
    let res;
    // Lang can be 2-chars
    if (lang.length === 2) res = allLanguages.find((language)=>{
        return language.split('-')[0]?.toLowerCase() === lang.toLowerCase();
    });
    else {
        res = allLanguages.find((language)=>{
            return language.toLowerCase() === lang.toLowerCase();
        });
        if (!res) res = allLanguages.find((language)=>{
            return language.startsWith(`${lang.split('-')[0].toLowerCase()}-`);
        });
    }
    return res;
};
// Check if the locale in the current browser is in the array of available locales
const $40aaf61b4fa53955$var$checkLocaleFromBrowser = (allLanguages)=>{
    const navLang = navigator?.language;
    if (navLang && allLanguages?.length) return $40aaf61b4fa53955$var$checkResult(navLang, allLanguages);
    return undefined;
};
const $40aaf61b4fa53955$export$d64c0ac95bb7fd72 = (languageData, localeConfig)=>{
    // Use browser locale if config doesn't prevent it
    if (localeConfig?.getDefaultFromBrowser !== false) {
        const browserLocale = $40aaf61b4fa53955$var$checkLocaleFromBrowser(languageData.all);
        if (browserLocale) return browserLocale;
    }
    // Else check the "lang" tag in the html element
    const htmlElements = document.getElementsByTagName('html');
    if (htmlElements.length && htmlElements[0].lang) {
        const htmlLocale = $40aaf61b4fa53955$var$checkResult(htmlElements[0].lang, languageData.all);
        if (htmlLocale) return htmlLocale;
    }
    // Else, use default from languageData
    return languageData.default;
};
const $40aaf61b4fa53955$export$91fc93b93c368955 = (locale)=>{
    const split = locale.split('-');
    return split.length ? split[1] : split[0];
};

});


parcelRegister("iqpLV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f2d90ce2054bc3e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $lqIBI = parcelRequire("lqIBI");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $hVO5T = parcelRequire("hVO5T");

var $6Iy5P = parcelRequire("6Iy5P");
parcelRequire("dikAc");
var $jWbjz = parcelRequire("jWbjz");
var $9HRSd = parcelRequire("9HRSd");

var $4ZEXS = parcelRequire("4ZEXS");

var $d7O2A = parcelRequire("d7O2A");

var $gpOhM = parcelRequire("gpOhM");
const $3f2d90ce2054bc3e$var$MicrophoneButton = ({ openMicrophone: openMicrophone })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isMicrophoneAllowed = (0, $5FZWK.useSelector)((state)=>state.speechReducer.isMicrophoneAllowed);
    const showMicrophoneModal = (0, $5FZWK.useSelector)((state)=>state.speechReducer.showMicrophoneModal);
    const microphonePermissionStatus = (0, $5FZWK.useSelector)((state)=>state.speechReducer.permissionStatus);
    const activeRecognitionState = (0, $5FZWK.useSelector)((state)=>state.speechReducer.activeRecognitionState);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const [playerRef, setPlayerRef] = (0, $bxRTa.useState)(null);
    const handleClick = ()=>{
        if (!isMicrophoneAllowed) dispatch((0, $cto9a.storeActions).speech.askPermission());
        else dispatch((0, $cto9a.storeActions).speech.toggleMicrophone(false));
    };
    (0, $bxRTa.useEffect)(()=>{
        console.log('openMicrophone : ', openMicrophone);
        openMicrophone && handleClick();
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).speech.setIsMicrophoneAllowed(microphonePermissionStatus === (0, $2rYkD.PermissionStatus).allowed));
        switch(microphonePermissionStatus){
            case (0, $2rYkD.PermissionStatus).allowed:
                dispatch((0, $cto9a.storeActions).speech.setShowMicrophoneModal(false));
                dispatch((0, $cto9a.storeActions).speech.toggleMicrophone(false));
                break;
            case (0, $2rYkD.PermissionStatus).waiting:
            case (0, $2rYkD.PermissionStatus).refused:
            case (0, $2rYkD.PermissionStatus).error:
                break;
        }
    }, [
        microphonePermissionStatus
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (playerRef) activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? playerRef.lottie.play() : playerRef.lottie.stop();
        dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).none));
        dispatch((0, $cto9a.storeActions).utils.setFullScreenImage(undefined));
    }, [
        activeRecognitionState,
        playerRef
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                className: `rf-relative large:rf-w-full large:rf-h-auto rf-aspect-square rf-flex rf-justify-center rf-items-center rf-border ${activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? isMobile ? 'rf-h-12 rf-border-[#00000029]' : 'rf-border-[#00000029]' : isMobile ? 'rf-h-8 rf-border-none' : 'rf-border-menuBorder'} rf-rounded-half rf-overflow-hidden`,
                onClick: handleClick,
                "aria-label": "microphone",
                style: {
                    boxShadow: activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? 'inset 0 0 6px 3px#00000029' : isMobile ? undefined : '0 0 20px 1px #A4A7AF80',
                    WebkitMaskImage: activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? '-webkit-radial-gradient(white, black)' : undefined
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-absolute rf-h-full rf-w-full rf-flex rf-justify-end",
                        children: activeRecognitionState === (0, $2rYkD.RecognitionState).Listening && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lqIBI.Player), {
                            lottieRef: (instance)=>{
                                setPlayerRef({
                                    lottie: instance
                                });
                            },
                            loop: true,
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($hVO5T))),
                            className: "rf-w-full"
                        })
                    }),
                    activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? /*#__PURE__*/ (0, $fl9nK.jsx)($9HRSd.default, {
                        className: "rf-h-3 rf-w-3 large:rf-h-4 large:rf-w-4"
                    }) : activeRecognitionState === (0, $2rYkD.RecognitionState).Closed ? /*#__PURE__*/ (0, $fl9nK.jsx)($jWbjz.default, {
                        className: "rf-h-5 rf-w-5",
                        color: themeColors.secondary
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4ZEXS.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $6Iy5P.default), {
                isOpened: showMicrophoneModal,
                onClose: ()=>dispatch((0, $cto9a.storeActions).speech.setShowMicrophoneModal(false)),
                children: [
                    microphonePermissionStatus === (0, $2rYkD.PermissionStatus).waiting && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d7O2A.default), {}),
                    microphonePermissionStatus === (0, $2rYkD.PermissionStatus).refused && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $gpOhM.default), {})
                ]
            })
        ]
    });
};
var $3f2d90ce2054bc3e$export$2e2bcd8739ae039 = $3f2d90ce2054bc3e$var$MicrophoneButton;

});
parcelRegister("lqIBI", function(module, exports) {

$parcel$export(module.exports, "Player", () => Player);

var $bxRTa = parcelRequire("bxRTa");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var extendStatics = function(t, e) {
    return (extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    })(t, e);
};
function __extends(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r() {
        this.constructor = t;
    }
    extendStatics(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}
var __assign = function() {
    return (__assign = Object.assign || function(t) {
        for(var e, r = 1, i = arguments.length; r < i; r++)for(var a in e = arguments[r])Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
        return t;
    }).apply(this, arguments);
};
function __rest(t, e) {
    var r = {};
    for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (r[i] = t[i]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;
        for(i = Object.getOwnPropertySymbols(t); a < i.length; a++)e.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[a]) && (r[i[a]] = t[i[a]]);
    }
    return r;
}
function __decorate(t, e, r, i) {
    var a, s = arguments.length, n = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, r) : i;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) n = Reflect.decorate(t, e, r, i);
    else for(var o = t.length - 1; o >= 0; o--)(a = t[o]) && (n = (s < 3 ? a(n) : s > 3 ? a(e, r, n) : a(e, r)) || n);
    return s > 3 && n && Object.defineProperty(e, r, n), n;
}
function __param(t, e) {
    return function(r, i) {
        e(r, i, t);
    };
}
function __metadata(t, e) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
}
function __awaiter(t, e, r, i) {
    return new (r || (r = Promise))(function(a, s) {
        function n(t) {
            try {
                h(i.next(t));
            } catch (t) {
                s(t);
            }
        }
        function o(t) {
            try {
                h(i.throw(t));
            } catch (t) {
                s(t);
            }
        }
        function h(t) {
            var e;
            t.done ? a(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(n, o);
        }
        h((i = i.apply(t, e || [])).next());
    });
}
function __generator(t, e) {
    var r, i, a, s, n = {
        label: 0,
        sent: function() {
            if (1 & a[0]) throw a[1];
            return a[1];
        },
        trys: [],
        ops: []
    };
    return s = {
        next: o(0),
        throw: o(1),
        return: o(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function() {
        return this;
    }), s;
    function o(s) {
        return function(o) {
            return function(s) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; n;)try {
                    if (r = 1, i && (a = 2 & s[0] ? i.return : s[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, s[1])).done) return a;
                    switch(i = 0, a && (s = [
                        2 & s[0],
                        a.value
                    ]), s[0]){
                        case 0:
                        case 1:
                            a = s;
                            break;
                        case 4:
                            return n.label++, {
                                value: s[1],
                                done: !1
                            };
                        case 5:
                            n.label++, i = s[1], s = [
                                0
                            ];
                            continue;
                        case 7:
                            s = n.ops.pop(), n.trys.pop();
                            continue;
                        default:
                            if (!(a = n.trys, (a = a.length > 0 && a[a.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                n = 0;
                                continue;
                            }
                            if (3 === s[0] && (!a || s[1] > a[0] && s[1] < a[3])) {
                                n.label = s[1];
                                break;
                            }
                            if (6 === s[0] && n.label < a[1]) {
                                n.label = a[1], a = s;
                                break;
                            }
                            if (a && n.label < a[2]) {
                                n.label = a[2], n.ops.push(s);
                                break;
                            }
                            a[2] && n.ops.pop(), n.trys.pop();
                            continue;
                    }
                    s = e.call(t, n);
                } catch (t) {
                    s = [
                        6,
                        t
                    ], i = 0;
                } finally{
                    r = a = 0;
                }
                if (5 & s[0]) throw s[1];
                return {
                    value: s[0] ? s[1] : void 0,
                    done: !0
                };
            }([
                s,
                o
            ]);
        };
    }
}
var __createBinding = Object.create ? function(t, e, r, i) {
    void 0 === i && (i = r), Object.defineProperty(t, i, {
        enumerable: !0,
        get: function() {
            return e[r];
        }
    });
} : function(t, e, r, i) {
    void 0 === i && (i = r), t[i] = e[r];
};
function __exportStar(t, e) {
    for(var r in t)"default" === r || Object.prototype.hasOwnProperty.call(e, r) || __createBinding(e, t, r);
}
function __values(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], i = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && i >= t.length && (t = void 0), {
                value: t && t[i++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(t, e) {
    var r = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r) return t;
    var i, a, s = r.call(t), n = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(i = s.next()).done;)n.push(i.value);
    } catch (t) {
        a = {
            error: t
        };
    } finally{
        try {
            i && !i.done && (r = s.return) && r.call(s);
        } finally{
            if (a) throw a.error;
        }
    }
    return n;
}
function __spread() {
    for(var t = [], e = 0; e < arguments.length; e++)t = t.concat(__read(arguments[e]));
    return t;
}
function __spreadArrays() {
    for(var t = 0, e = 0, r = arguments.length; e < r; e++)t += arguments[e].length;
    var i = Array(t), a = 0;
    for(e = 0; e < r; e++)for(var s = arguments[e], n = 0, o = s.length; n < o; n++, a++)i[a] = s[n];
    return i;
}
function __spreadArray(t, e, r) {
    if (r || 2 === arguments.length) for(var i, a = 0, s = e.length; a < s; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
    return t.concat(i || Array.prototype.slice.call(e));
}
function __await(t) {
    return this instanceof __await ? (this.v = t, this) : new __await(t);
}
function __asyncGenerator(t, e, r) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var i, a = r.apply(t, e || []), s = [];
    return i = {}, n("next"), n("throw"), n("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function n(t) {
        a[t] && (i[t] = function(e) {
            return new Promise(function(r, i) {
                s.push([
                    t,
                    e,
                    r,
                    i
                ]) > 1 || o(t, e);
            });
        });
    }
    function o(t, e) {
        try {
            (r = a[t](e)).value instanceof __await ? Promise.resolve(r.value.v).then(h, l) : p(s[0][2], r);
        } catch (t) {
            p(s[0][3], t);
        }
        var r;
    }
    function h(t) {
        o("next", t);
    }
    function l(t) {
        o("throw", t);
    }
    function p(t, e) {
        t(e), s.shift(), s.length && o(s[0][0], s[0][1]);
    }
}
function __asyncDelegator(t) {
    var e, r;
    return e = {}, i("next"), i("throw", function(t) {
        throw t;
    }), i("return"), e[Symbol.iterator] = function() {
        return this;
    }, e;
    function i(i, a) {
        e[i] = t[i] ? function(e) {
            return (r = !r) ? {
                value: __await(t[i](e)),
                done: "return" === i
            } : a ? a(e) : e;
        } : a;
    }
}
function __asyncValues(t) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var e, r = t[Symbol.asyncIterator];
    return r ? r.call(t) : (t = "function" == typeof __values ? __values(t) : t[Symbol.iterator](), e = {}, i("next"), i("throw"), i("return"), e[Symbol.asyncIterator] = function() {
        return this;
    }, e);
    function i(r) {
        e[r] = t[r] && function(e) {
            return new Promise(function(i, a) {
                (function(t, e, r, i) {
                    Promise.resolve(i).then(function(e) {
                        t({
                            value: e,
                            done: r
                        });
                    }, e);
                })(i, a, (e = t[r](e)).done, e.value);
            });
        };
    }
}
function __makeTemplateObject(t, e) {
    return Object.defineProperty ? Object.defineProperty(t, "raw", {
        value: e
    }) : t.raw = e, t;
}
var __setModuleDefault = Object.create ? function(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
};
function __importStar(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for(var r in t)"default" !== r && Object.prototype.hasOwnProperty.call(t, r) && __createBinding(e, t, r);
    return __setModuleDefault(e, t), e;
}
function __importDefault(t) {
    return t && t.__esModule ? t : {
        default: t
    };
}
function __classPrivateFieldGet(t, e, r, i) {
    if ("a" === r && !i) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof e ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? i : "a" === r ? i.call(t) : i ? i.value : e.get(t);
}
function __classPrivateFieldSet(t, e, r, i, a) {
    if ("m" === i) throw new TypeError("Private method is not writable");
    if ("a" === i && !a) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof e ? t !== e || !a : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === i ? a.call(t, r) : a ? a.value = r : e.set(t, r), r;
}
var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function unwrapExports(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function createCommonjsModule(t, e) {
    return t(e = {
        exports: {}
    }, e.exports), e.exports;
}
function getCjsExportFromNamespace(t) {
    return t && t.default || t;
}
function commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var lottie = createCommonjsModule(function(module, exports) {
    "undefined" != typeof navigator && function(t, e) {
        module.exports = e();
    }(0, function() {
        var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
            _useWebWorker = !!t;
        }, getWebWorker = function() {
            return _useWebWorker;
        }, setLocationHref = function(t) {
            locationHref = t;
        }, getLocationHref = function() {
            return locationHref;
        };
        function createTag(t) {
            return document.createElement(t);
        }
        function extendPrototype(t, e) {
            var r, i, a = t.length;
            for(r = 0; r < a; r += 1)for(var s in i = t[r].prototype)Object.prototype.hasOwnProperty.call(i, s) && (e.prototype[s] = i[s]);
        }
        function getDescriptor(t, e) {
            return Object.getOwnPropertyDescriptor(t, e);
        }
        function createProxyFunction(t) {
            function e() {}
            return e.prototype = t, e;
        }
        var audioControllerFactory = function() {
            function t(t) {
                this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
            }
            return t.prototype = {
                addAudio: function(t) {
                    this.audios.push(t);
                },
                pause: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].pause();
                },
                resume: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].resume();
                },
                setRate: function(t) {
                    var e, r = this.audios.length;
                    for(e = 0; e < r; e += 1)this.audios[e].setRate(t);
                },
                createAudio: function(t) {
                    return this.audioFactory ? this.audioFactory(t) : window.Howl ? new window.Howl({
                        src: [
                            t
                        ]
                    }) : {
                        isPlaying: !1,
                        play: function() {
                            this.isPlaying = !0;
                        },
                        seek: function() {
                            this.isPlaying = !1;
                        },
                        playing: function() {},
                        rate: function() {},
                        setVolume: function() {}
                    };
                },
                setAudioFactory: function(t) {
                    this.audioFactory = t;
                },
                setVolume: function(t) {
                    this._volume = t, this._updateVolume();
                },
                mute: function() {
                    this._isMuted = !0, this._updateVolume();
                },
                unmute: function() {
                    this._isMuted = !1, this._updateVolume();
                },
                getVolume: function() {
                    return this._volume;
                },
                _updateVolume: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
                }
            }, function() {
                return new t;
            };
        }(), createTypedArray = function() {
            function t(t, e) {
                var r, i = 0, a = [];
                switch(t){
                    case "int16":
                    case "uint8c":
                        r = 1;
                        break;
                    default:
                        r = 1.1;
                }
                for(i = 0; i < e; i += 1)a.push(r);
                return a;
            }
            return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function(e, r) {
                return "float32" === e ? new Float32Array(r) : "int16" === e ? new Int16Array(r) : "uint8c" === e ? new Uint8ClampedArray(r) : t(e, r);
            } : t;
        }();
        function createSizedArray(t) {
            return Array.apply(null, {
                length: t
            });
        }
        function _typeof$6(t) {
            return (_typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), _shouldRoundValues = !1, bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
        function ProjectInterface$1() {
            return {};
        }
        !function() {
            var t, e = [
                "abs",
                "acos",
                "acosh",
                "asin",
                "asinh",
                "atan",
                "atanh",
                "atan2",
                "ceil",
                "cbrt",
                "expm1",
                "clz32",
                "cos",
                "cosh",
                "exp",
                "floor",
                "fround",
                "hypot",
                "imul",
                "log",
                "log1p",
                "log2",
                "log10",
                "max",
                "min",
                "pow",
                "random",
                "round",
                "sign",
                "sin",
                "sinh",
                "sqrt",
                "tan",
                "tanh",
                "trunc",
                "E",
                "LN10",
                "LN2",
                "LOG10E",
                "LOG2E",
                "PI",
                "SQRT1_2",
                "SQRT2"
            ], r = e.length;
            for(t = 0; t < r; t += 1)BMMath[e[t]] = Math[e[t]];
        }(), BMMath.random = Math.random, BMMath.abs = function(t) {
            if ("object" === _typeof$6(t) && t.length) {
                var e, r = createSizedArray(t.length), i = t.length;
                for(e = 0; e < i; e += 1)r[e] = Math.abs(t[e]);
                return r;
            }
            return Math.abs(t);
        };
        var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = .5519;
        function roundValues(t) {
            _shouldRoundValues = !!t;
        }
        function bmRnd(t) {
            return _shouldRoundValues ? Math.round(t) : t;
        }
        function styleDiv(t) {
            t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t.style.display = "block", t.style.transformOrigin = "0 0", t.style.webkitTransformOrigin = "0 0", t.style.backfaceVisibility = "visible", t.style.webkitBackfaceVisibility = "visible", t.style.transformStyle = "preserve-3d", t.style.webkitTransformStyle = "preserve-3d", t.style.mozTransformStyle = "preserve-3d";
        }
        function BMEnterFrameEvent(t, e, r, i) {
            this.type = t, this.currentTime = e, this.totalTime = r, this.direction = i < 0 ? -1 : 1;
        }
        function BMCompleteEvent(t, e) {
            this.type = t, this.direction = e < 0 ? -1 : 1;
        }
        function BMCompleteLoopEvent(t, e, r, i) {
            this.type = t, this.currentLoop = r, this.totalLoops = e, this.direction = i < 0 ? -1 : 1;
        }
        function BMSegmentStartEvent(t, e, r) {
            this.type = t, this.firstFrame = e, this.totalFrames = r;
        }
        function BMDestroyEvent(t, e) {
            this.type = t, this.target = e;
        }
        function BMRenderFrameErrorEvent(t, e) {
            this.type = "renderFrameError", this.nativeError = t, this.currentTime = e;
        }
        function BMConfigErrorEvent(t) {
            this.type = "configError", this.nativeError = t;
        }
        function BMAnimationConfigErrorEvent(t, e) {
            this.type = t, this.nativeError = e;
        }
        var createElementID = (_count = 0, function() {
            return idPrefix$1 + "__lottie_element_" + (_count += 1);
        }), _count;
        function HSVtoRGB(t, e, r) {
            var i, a, s, n, o, h, l, p;
            switch(h = r * (1 - e), l = r * (1 - (o = 6 * t - (n = Math.floor(6 * t))) * e), p = r * (1 - (1 - o) * e), n % 6){
                case 0:
                    i = r, a = p, s = h;
                    break;
                case 1:
                    i = l, a = r, s = h;
                    break;
                case 2:
                    i = h, a = r, s = p;
                    break;
                case 3:
                    i = h, a = l, s = r;
                    break;
                case 4:
                    i = p, a = h, s = r;
                    break;
                case 5:
                    i = r, a = h, s = l;
            }
            return [
                i,
                a,
                s
            ];
        }
        function RGBtoHSV(t, e, r) {
            var i, a = Math.max(t, e, r), s = Math.min(t, e, r), n = a - s, o = 0 === a ? 0 : n / a, h = a / 255;
            switch(a){
                case s:
                    i = 0;
                    break;
                case t:
                    i = e - r + n * (e < r ? 6 : 0), i /= 6 * n;
                    break;
                case e:
                    i = r - t + 2 * n, i /= 6 * n;
                    break;
                case r:
                    i = t - e + 4 * n, i /= 6 * n;
            }
            return [
                i,
                o,
                h
            ];
        }
        function addSaturationToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[1] += e, r[1] > 1 ? r[1] = 1 : r[1] <= 0 && (r[1] = 0), HSVtoRGB(r[0], r[1], r[2]);
        }
        function addBrightnessToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[2] += e, r[2] > 1 ? r[2] = 1 : r[2] < 0 && (r[2] = 0), HSVtoRGB(r[0], r[1], r[2]);
        }
        function addHueToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[0] += e / 360, r[0] > 1 ? r[0] -= 1 : r[0] < 0 && (r[0] += 1), HSVtoRGB(r[0], r[1], r[2]);
        }
        var rgbToHex = function() {
            var t, e, r = [];
            for(t = 0; t < 256; t += 1)e = t.toString(16), r[t] = 1 === e.length ? "0" + e : e;
            return function(t, e, i) {
                return t < 0 && (t = 0), e < 0 && (e = 0), i < 0 && (i = 0), "#" + r[t] + r[e] + r[i];
            };
        }(), setSubframeEnabled = function(t) {
            subframeEnabled = !!t;
        }, getSubframeEnabled = function() {
            return subframeEnabled;
        }, setExpressionsPlugin = function(t) {
            expressionsPlugin = t;
        }, getExpressionsPlugin = function() {
            return expressionsPlugin;
        }, setExpressionInterfaces = function(t) {
            expressionsInterfaces = t;
        }, getExpressionInterfaces = function() {
            return expressionsInterfaces;
        }, setDefaultCurveSegments = function(t) {
            defaultCurveSegments = t;
        }, getDefaultCurveSegments = function() {
            return defaultCurveSegments;
        }, setIdPrefix = function(t) {
            idPrefix$1 = t;
        }, getIdPrefix = function() {
            return idPrefix$1;
        };
        function createNS(t) {
            return document.createElementNS(svgNS, t);
        }
        function _typeof$5(t) {
            return (_typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var dataManager = function() {
            var t, e, r = 1, i = [], a = {
                onmessage: function() {},
                postMessage: function(e) {
                    t({
                        data: e
                    });
                }
            }, s = {
                postMessage: function(t) {
                    a.onmessage({
                        data: t
                    });
                }
            };
            function n() {
                e || ((e = function(e) {
                    if (window.Worker && window.Blob && getWebWorker()) {
                        var r = new Blob([
                            "var _workerSelf = self; self.onmessage = ",
                            e.toString()
                        ], {
                            type: "text/javascript"
                        }), i = URL.createObjectURL(r);
                        return new Worker(i);
                    }
                    return t = e, a;
                }(function(t) {
                    if (s.dataManager || (s.dataManager = function() {
                        function t(a, s) {
                            var n, o, h, l, p, c, m = a.length;
                            for(o = 0; o < m; o += 1)if ("ks" in (n = a[o]) && !n.completed) {
                                if (n.completed = !0, n.hasMask) {
                                    var d = n.masksProperties;
                                    for(l = d.length, h = 0; h < l; h += 1)if (d[h].pt.k.i) i(d[h].pt.k);
                                    else for(c = d[h].pt.k.length, p = 0; p < c; p += 1)d[h].pt.k[p].s && i(d[h].pt.k[p].s[0]), d[h].pt.k[p].e && i(d[h].pt.k[p].e[0]);
                                }
                                0 === n.ty ? (n.layers = e(n.refId, s), t(n.layers, s)) : 4 === n.ty ? r(n.shapes) : 5 === n.ty && f(n);
                            }
                        }
                        function e(t, e) {
                            var r = function(t, e) {
                                for(var r = 0, i = e.length; r < i;){
                                    if (e[r].id === t) return e[r];
                                    r += 1;
                                }
                                return null;
                            }(t, e);
                            return r ? r.layers.__used ? JSON.parse(JSON.stringify(r.layers)) : (r.layers.__used = !0, r.layers) : null;
                        }
                        function r(t) {
                            var e, a, s;
                            for(e = t.length - 1; e >= 0; e -= 1)if ("sh" === t[e].ty) {
                                if (t[e].ks.k.i) i(t[e].ks.k);
                                else for(s = t[e].ks.k.length, a = 0; a < s; a += 1)t[e].ks.k[a].s && i(t[e].ks.k[a].s[0]), t[e].ks.k[a].e && i(t[e].ks.k[a].e[0]);
                            } else "gr" === t[e].ty && r(t[e].it);
                        }
                        function i(t) {
                            var e, r = t.i.length;
                            for(e = 0; e < r; e += 1)t.i[e][0] += t.v[e][0], t.i[e][1] += t.v[e][1], t.o[e][0] += t.v[e][0], t.o[e][1] += t.v[e][1];
                        }
                        function a(t, e) {
                            var r = e ? e.split(".") : [
                                100,
                                100,
                                100
                            ];
                            return t[0] > r[0] || !(r[0] > t[0]) && (t[1] > r[1] || !(r[1] > t[1]) && (t[2] > r[2] || !(r[2] > t[2]) && null));
                        }
                        var s, n = function() {
                            var t = [
                                4,
                                4,
                                14
                            ];
                            function e(t) {
                                var e, r, i, a = t.length;
                                for(e = 0; e < a; e += 1)5 === t[e].ty && (r = t[e], i = void 0, i = r.t.d, r.t.d = {
                                    k: [
                                        {
                                            s: i,
                                            t: 0
                                        }
                                    ]
                                });
                            }
                            return function(r) {
                                if (a(t, r.v) && (e(r.layers), r.assets)) {
                                    var i, s = r.assets.length;
                                    for(i = 0; i < s; i += 1)r.assets[i].layers && e(r.assets[i].layers);
                                }
                            };
                        }(), o = (s = [
                            4,
                            7,
                            99
                        ], function(t) {
                            if (t.chars && !a(s, t.v)) {
                                var e, i = t.chars.length;
                                for(e = 0; e < i; e += 1){
                                    var n = t.chars[e];
                                    n.data && n.data.shapes && (r(n.data.shapes), n.data.ip = 0, n.data.op = 99999, n.data.st = 0, n.data.sr = 1, n.data.ks = {
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        }
                                    }, t.chars[e].t || (n.data.shapes.push({
                                        ty: "no"
                                    }), n.data.shapes[0].it.push({
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        },
                                        sk: {
                                            k: 0,
                                            a: 0
                                        },
                                        sa: {
                                            k: 0,
                                            a: 0
                                        },
                                        ty: "tr"
                                    })));
                                }
                            }
                        }), h = function() {
                            var t = [
                                5,
                                7,
                                15
                            ];
                            function e(t) {
                                var e, r, i, a = t.length;
                                for(e = 0; e < a; e += 1)5 === t[e].ty && (r = t[e], i = void 0, "number" == typeof (i = r.t.p).a && (i.a = {
                                    a: 0,
                                    k: i.a
                                }), "number" == typeof i.p && (i.p = {
                                    a: 0,
                                    k: i.p
                                }), "number" == typeof i.r && (i.r = {
                                    a: 0,
                                    k: i.r
                                }));
                            }
                            return function(r) {
                                if (a(t, r.v) && (e(r.layers), r.assets)) {
                                    var i, s = r.assets.length;
                                    for(i = 0; i < s; i += 1)r.assets[i].layers && e(r.assets[i].layers);
                                }
                            };
                        }(), l = function() {
                            var t = [
                                4,
                                1,
                                9
                            ];
                            function e(t) {
                                var r, i, a, s = t.length;
                                for(r = 0; r < s; r += 1)if ("gr" === t[r].ty) e(t[r].it);
                                else if ("fl" === t[r].ty || "st" === t[r].ty) {
                                    if (t[r].c.k && t[r].c.k[0].i) for(a = t[r].c.k.length, i = 0; i < a; i += 1)t[r].c.k[i].s && (t[r].c.k[i].s[0] /= 255, t[r].c.k[i].s[1] /= 255, t[r].c.k[i].s[2] /= 255, t[r].c.k[i].s[3] /= 255), t[r].c.k[i].e && (t[r].c.k[i].e[0] /= 255, t[r].c.k[i].e[1] /= 255, t[r].c.k[i].e[2] /= 255, t[r].c.k[i].e[3] /= 255);
                                    else t[r].c.k[0] /= 255, t[r].c.k[1] /= 255, t[r].c.k[2] /= 255, t[r].c.k[3] /= 255;
                                }
                            }
                            function r(t) {
                                var r, i = t.length;
                                for(r = 0; r < i; r += 1)4 === t[r].ty && e(t[r].shapes);
                            }
                            return function(e) {
                                if (a(t, e.v) && (r(e.layers), e.assets)) {
                                    var i, s = e.assets.length;
                                    for(i = 0; i < s; i += 1)e.assets[i].layers && r(e.assets[i].layers);
                                }
                            };
                        }(), p = function() {
                            var t = [
                                4,
                                4,
                                18
                            ];
                            function e(t) {
                                var r, i, a;
                                for(r = t.length - 1; r >= 0; r -= 1)if ("sh" === t[r].ty) {
                                    if (t[r].ks.k.i) t[r].ks.k.c = t[r].closed;
                                    else for(a = t[r].ks.k.length, i = 0; i < a; i += 1)t[r].ks.k[i].s && (t[r].ks.k[i].s[0].c = t[r].closed), t[r].ks.k[i].e && (t[r].ks.k[i].e[0].c = t[r].closed);
                                } else "gr" === t[r].ty && e(t[r].it);
                            }
                            function r(t) {
                                var r, i, a, s, n, o, h = t.length;
                                for(i = 0; i < h; i += 1){
                                    if ((r = t[i]).hasMask) {
                                        var l = r.masksProperties;
                                        for(s = l.length, a = 0; a < s; a += 1)if (l[a].pt.k.i) l[a].pt.k.c = l[a].cl;
                                        else for(o = l[a].pt.k.length, n = 0; n < o; n += 1)l[a].pt.k[n].s && (l[a].pt.k[n].s[0].c = l[a].cl), l[a].pt.k[n].e && (l[a].pt.k[n].e[0].c = l[a].cl);
                                    }
                                    4 === r.ty && e(r.shapes);
                                }
                            }
                            return function(e) {
                                if (a(t, e.v) && (r(e.layers), e.assets)) {
                                    var i, s = e.assets.length;
                                    for(i = 0; i < s; i += 1)e.assets[i].layers && r(e.assets[i].layers);
                                }
                            };
                        }();
                        function f(t) {
                            0 === t.t.a.length && t.t.p;
                        }
                        var c = {
                            completeData: function(r) {
                                r.__complete || (l(r), n(r), o(r), h(r), p(r), t(r.layers, r.assets), function(r, i) {
                                    if (r) {
                                        var a = 0, s = r.length;
                                        for(a = 0; a < s; a += 1)1 === r[a].t && (r[a].data.layers = e(r[a].data.refId, i), t(r[a].data.layers, i));
                                    }
                                }(r.chars, r.assets), r.__complete = !0);
                            }
                        };
                        return c.checkColors = l, c.checkChars = o, c.checkPathProperties = h, c.checkShapes = p, c.completeLayers = t, c;
                    }()), s.assetLoader || (s.assetLoader = function() {
                        function t(t) {
                            var e = t.getResponseHeader("content-type");
                            return e && "json" === t.responseType && -1 !== e.indexOf("json") || t.response && "object" === _typeof$5(t.response) ? t.response : t.response && "string" == typeof t.response ? JSON.parse(t.response) : t.responseText ? JSON.parse(t.responseText) : null;
                        }
                        return {
                            load: function(e, r, i, a) {
                                var s, n = new XMLHttpRequest;
                                try {
                                    n.responseType = "json";
                                } catch (t) {}
                                n.onreadystatechange = function() {
                                    if (4 === n.readyState) {
                                        if (200 === n.status) s = t(n), i(s);
                                        else try {
                                            s = t(n), i(s);
                                        } catch (t) {
                                            a && a(t);
                                        }
                                    }
                                };
                                try {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), e, !0);
                                } catch (t) {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), r + "/" + e, !0);
                                }
                                n.send();
                            }
                        };
                    }()), "loadAnimation" === t.data.type) s.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        s.dataManager.completeData(e), s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        s.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                    else if ("complete" === t.data.type) {
                        var e = t.data.animation;
                        s.dataManager.completeData(e), s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    } else "loadData" === t.data.type && s.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        s.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                })).onmessage = function(t) {
                    var e = t.data, r = e.id, a = i[r];
                    i[r] = null, "success" === e.status ? a.onComplete(e.payload) : a.onError && a.onError();
                });
            }
            function o(t, e) {
                var a = "processId_" + (r += 1);
                return i[a] = {
                    onComplete: t,
                    onError: e
                }, a;
            }
            return {
                loadAnimation: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "loadAnimation",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: a
                    });
                },
                loadData: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "loadData",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: a
                    });
                },
                completeAnimation: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "complete",
                        animation: t,
                        id: a
                    });
                }
            };
        }(), ImagePreloader = function() {
            var t = function() {
                var t = createTag("canvas");
                t.width = 1, t.height = 1;
                var e = t.getContext("2d");
                return e.fillStyle = "rgba(0,0,0,0)", e.fillRect(0, 0, 1, 1), t;
            }();
            function e() {
                this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function r() {
                this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function i(t, e, r) {
                var i = "";
                if (t.e) i = t.p;
                else if (e) {
                    var a = t.p;
                    -1 !== a.indexOf("images/") && (a = a.split("/")[1]), i = e + a;
                } else i = r, i += t.u ? t.u : "", i += t.p;
                return i;
            }
            function a(t) {
                var e = 0, r = setInterval((function() {
                    (t.getBBox().width || e > 500) && (this._imageLoaded(), clearInterval(r)), e += 1;
                }).bind(this), 50);
            }
            function s(t) {
                var e = {
                    assetData: t
                }, r = i(t, this.assetsPath, this.path);
                return dataManager.loadData(r, (function(t) {
                    e.img = t, this._footageLoaded();
                }).bind(this), (function() {
                    e.img = {}, this._footageLoaded();
                }).bind(this)), e;
            }
            function n() {
                this._imageLoaded = e.bind(this), this._footageLoaded = r.bind(this), this.testImageLoaded = a.bind(this), this.createFootageData = s.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
            }
            return n.prototype = {
                loadAssets: function(t, e) {
                    var r;
                    this.imagesLoadedCb = e;
                    var i = t.length;
                    for(r = 0; r < i; r += 1)t[r].layers || (t[r].t && "seq" !== t[r].t ? 3 === t[r].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t[r]))) : (this.totalImages += 1, this.images.push(this._createImageData(t[r]))));
                },
                setAssetsPath: function(t) {
                    this.assetsPath = t || "";
                },
                setPath: function(t) {
                    this.path = t || "";
                },
                loadedImages: function() {
                    return this.totalImages === this.loadedAssets;
                },
                loadedFootages: function() {
                    return this.totalFootages === this.loadedFootagesCount;
                },
                destroy: function() {
                    this.imagesLoadedCb = null, this.images.length = 0;
                },
                getAsset: function(t) {
                    for(var e = 0, r = this.images.length; e < r;){
                        if (this.images[e].assetData === t) return this.images[e].img;
                        e += 1;
                    }
                    return null;
                },
                createImgData: function(e) {
                    var r = i(e, this.assetsPath, this.path), a = createTag("img");
                    a.crossOrigin = "anonymous", a.addEventListener("load", this._imageLoaded, !1), a.addEventListener("error", (function() {
                        s.img = t, this._imageLoaded();
                    }).bind(this), !1), a.src = r;
                    var s = {
                        img: a,
                        assetData: e
                    };
                    return s;
                },
                createImageData: function(e) {
                    var r = i(e, this.assetsPath, this.path), a = createNS("image");
                    isSafari ? this.testImageLoaded(a) : a.addEventListener("load", this._imageLoaded, !1), a.addEventListener("error", (function() {
                        s.img = t, this._imageLoaded();
                    }).bind(this), !1), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), this._elementHelper.append ? this._elementHelper.append(a) : this._elementHelper.appendChild(a);
                    var s = {
                        img: a,
                        assetData: e
                    };
                    return s;
                },
                imageLoaded: e,
                footageLoaded: r,
                setCacheType: function(t, e) {
                    "svg" === t ? (this._elementHelper = e, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
                }
            }, n;
        }();
        function BaseEvent() {}
        BaseEvent.prototype = {
            triggerEvent: function(t, e) {
                if (this._cbs[t]) for(var r = this._cbs[t], i = 0; i < r.length; i += 1)r[i](e);
            },
            addEventListener: function(t, e) {
                return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(e), (function() {
                    this.removeEventListener(t, e);
                }).bind(this);
            },
            removeEventListener: function(t, e) {
                if (e) {
                    if (this._cbs[t]) {
                        for(var r = 0, i = this._cbs[t].length; r < i;)this._cbs[t][r] === e && (this._cbs[t].splice(r, 1), r -= 1, i -= 1), r += 1;
                        this._cbs[t].length || (this._cbs[t] = null);
                    }
                } else this._cbs[t] = null;
            }
        };
        var markerParser = function() {
            function t(t) {
                for(var e, r = t.split("\r\n"), i = {}, a = 0, s = 0; s < r.length; s += 1)2 === (e = r[s].split(":")).length && (i[e[0]] = e[1].trim(), a += 1);
                if (0 === a) throw new Error;
                return i;
            }
            return function(e) {
                for(var r = [], i = 0; i < e.length; i += 1){
                    var a = e[i], s = {
                        time: a.tm,
                        duration: a.dr
                    };
                    try {
                        s.payload = JSON.parse(e[i].cm);
                    } catch (r) {
                        try {
                            s.payload = t(e[i].cm);
                        } catch (t) {
                            s.payload = {
                                name: e[i].cm
                            };
                        }
                    }
                    r.push(s);
                }
                return r;
            };
        }(), ProjectInterface = function() {
            function t(t) {
                this.compositions.push(t);
            }
            return function() {
                function e(t) {
                    for(var e = 0, r = this.compositions.length; e < r;){
                        if (this.compositions[e].data && this.compositions[e].data.nm === t) return this.compositions[e].prepareFrame && this.compositions[e].data.xt && this.compositions[e].prepareFrame(this.currentFrame), this.compositions[e].compInterface;
                        e += 1;
                    }
                    return null;
                }
                return e.compositions = [], e.currentFrame = 0, e.registerComposition = t, e;
            };
        }(), renderers = {}, registerRenderer = function(t, e) {
            renderers[t] = e;
        };
        function getRenderer(t) {
            return renderers[t];
        }
        function getRegisteredRenderer() {
            if (renderers.canvas) return "canvas";
            for(var t in renderers)if (renderers[t]) return t;
            return "";
        }
        function _typeof$4(t) {
            return (_typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var AnimationItem = function() {
            this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader, this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
        };
        extendPrototype([
            BaseEvent
        ], AnimationItem), AnimationItem.prototype.setParams = function(t) {
            (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
            var e = "svg";
            t.animType ? e = t.animType : t.renderer && (e = t.renderer);
            var r = getRenderer(e);
            this.renderer = new r(this, t.rendererSettings), this.imagePreloader.setCacheType(e, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e, "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? this.loop = !0 : !1 === t.loop ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = !("autoplay" in t) || t.autoplay, this.name = t.name ? t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (-1 !== t.path.lastIndexOf("\\") ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError));
        }, AnimationItem.prototype.onSetupError = function() {
            this.trigger("data_failed");
        }, AnimationItem.prototype.setupAnimation = function(t) {
            dataManager.completeAnimation(t, this.configAnimation);
        }, AnimationItem.prototype.setData = function(t, e) {
            e && "object" !== _typeof$4(e) && (e = JSON.parse(e));
            var r = {
                wrapper: t,
                animationData: e
            }, i = t.attributes;
            r.path = i.getNamedItem("data-animation-path") ? i.getNamedItem("data-animation-path").value : i.getNamedItem("data-bm-path") ? i.getNamedItem("data-bm-path").value : i.getNamedItem("bm-path") ? i.getNamedItem("bm-path").value : "", r.animType = i.getNamedItem("data-anim-type") ? i.getNamedItem("data-anim-type").value : i.getNamedItem("data-bm-type") ? i.getNamedItem("data-bm-type").value : i.getNamedItem("bm-type") ? i.getNamedItem("bm-type").value : i.getNamedItem("data-bm-renderer") ? i.getNamedItem("data-bm-renderer").value : i.getNamedItem("bm-renderer") ? i.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
            var a = i.getNamedItem("data-anim-loop") ? i.getNamedItem("data-anim-loop").value : i.getNamedItem("data-bm-loop") ? i.getNamedItem("data-bm-loop").value : i.getNamedItem("bm-loop") ? i.getNamedItem("bm-loop").value : "";
            "false" === a ? r.loop = !1 : "true" === a ? r.loop = !0 : "" !== a && (r.loop = parseInt(a, 10));
            var s = i.getNamedItem("data-anim-autoplay") ? i.getNamedItem("data-anim-autoplay").value : i.getNamedItem("data-bm-autoplay") ? i.getNamedItem("data-bm-autoplay").value : !i.getNamedItem("bm-autoplay") || i.getNamedItem("bm-autoplay").value;
            r.autoplay = "false" !== s, r.name = i.getNamedItem("data-name") ? i.getNamedItem("data-name").value : i.getNamedItem("data-bm-name") ? i.getNamedItem("data-bm-name").value : i.getNamedItem("bm-name") ? i.getNamedItem("bm-name").value : "", "false" === (i.getNamedItem("data-anim-prerender") ? i.getNamedItem("data-anim-prerender").value : i.getNamedItem("data-bm-prerender") ? i.getNamedItem("data-bm-prerender").value : i.getNamedItem("bm-prerender") ? i.getNamedItem("bm-prerender").value : "") && (r.prerender = !1), r.path ? this.setParams(r) : this.trigger("destroy");
        }, AnimationItem.prototype.includeLayers = function(t) {
            t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
            var e, r, i = this.animationData.layers, a = i.length, s = t.layers, n = s.length;
            for(r = 0; r < n; r += 1)for(e = 0; e < a;){
                if (i[e].id === s[r].id) {
                    i[e] = s[r];
                    break;
                }
                e += 1;
            }
            if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets) for(a = t.assets.length, e = 0; e < a; e += 1)this.animationData.assets.push(t.assets[e]);
            this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
        }, AnimationItem.prototype.onSegmentComplete = function(t) {
            this.animationData = t;
            var e = getExpressionsPlugin();
            e && e.initExpressions(this), this.loadNextSegment();
        }, AnimationItem.prototype.loadNextSegment = function() {
            var t = this.animationData.segments;
            if (!t || 0 === t.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
            var e = t.shift();
            this.timeCompleted = e.time * this.frameRate;
            var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
            this.segmentPos += 1, dataManager.loadData(r, this.includeLayers.bind(this), (function() {
                this.trigger("data_failed");
            }).bind(this));
        }, AnimationItem.prototype.loadSegments = function() {
            this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
        }, AnimationItem.prototype.imagesLoaded = function() {
            this.trigger("loaded_images"), this.checkLoaded();
        }, AnimationItem.prototype.preloadImages = function() {
            this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
        }, AnimationItem.prototype.configAnimation = function(t) {
            if (this.renderer) try {
                this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = markerParser(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
            } catch (t) {
                this.triggerConfigError(t);
            }
        }, AnimationItem.prototype.waitForFontsLoaded = function() {
            this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
        }, AnimationItem.prototype.checkLoaded = function() {
            if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
                this.isLoaded = !0;
                var t = getExpressionsPlugin();
                t && t.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
                    this.trigger("DOMLoaded");
                }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
            }
        }, AnimationItem.prototype.resize = function(t, e) {
            var r = "number" == typeof t ? t : void 0, i = "number" == typeof e ? e : void 0;
            this.renderer.updateContainerSize(r, i);
        }, AnimationItem.prototype.setSubframe = function(t) {
            this.isSubframeEnabled = !!t;
        }, AnimationItem.prototype.gotoFrame = function() {
            this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
        }, AnimationItem.prototype.renderFrame = function() {
            if (!1 !== this.isLoaded && this.renderer) try {
                this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
            } catch (t) {
                this.triggerRenderFrameError(t);
            }
        }, AnimationItem.prototype.play = function(t) {
            t && this.name !== t || !0 === this.isPaused && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
        }, AnimationItem.prototype.pause = function(t) {
            t && this.name !== t || !1 === this.isPaused && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
        }, AnimationItem.prototype.togglePause = function(t) {
            t && this.name !== t || (!0 === this.isPaused ? this.play() : this.pause());
        }, AnimationItem.prototype.stop = function(t) {
            t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
        }, AnimationItem.prototype.getMarkerData = function(t) {
            for(var e, r = 0; r < this.markers.length; r += 1)if ((e = this.markers[r]).payload && e.payload.name === t) return e;
            return null;
        }, AnimationItem.prototype.goToAndStop = function(t, e, r) {
            if (!r || this.name === r) {
                var i = Number(t);
                if (isNaN(i)) {
                    var a = this.getMarkerData(t);
                    a && this.goToAndStop(a.time, !0);
                } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
                this.pause();
            }
        }, AnimationItem.prototype.goToAndPlay = function(t, e, r) {
            if (!r || this.name === r) {
                var i = Number(t);
                if (isNaN(i)) {
                    var a = this.getMarkerData(t);
                    a && (a.duration ? this.playSegments([
                        a.time,
                        a.time + a.duration
                    ], !0) : this.goToAndStop(a.time, !0));
                } else this.goToAndStop(i, e, r);
                this.play();
            }
        }, AnimationItem.prototype.advanceTime = function(t) {
            if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                var e = this.currentRawFrame + t * this.frameModifier, r = !1;
                e >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? e >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || (r = !0, e = this.totalFrames - 1) : e < 0 ? this.checkSegments(e % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (r = !0, e = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e), r && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
            }
        }, AnimationItem.prototype.adjustSegment = function(t, e) {
            this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(.001 + e)), this.trigger("segmentStart");
        }, AnimationItem.prototype.setSegment = function(t, e) {
            var r = -1;
            this.isPaused && (this.currentRawFrame + this.firstFrame < t ? r = t : this.currentRawFrame + this.firstFrame > e && (r = e - t)), this.firstFrame = t, this.totalFrames = e - t, this.timeCompleted = this.totalFrames, -1 !== r && this.goToAndStop(r, !0);
        }, AnimationItem.prototype.playSegments = function(t, e) {
            if (e && (this.segments.length = 0), "object" === _typeof$4(t[0])) {
                var r, i = t.length;
                for(r = 0; r < i; r += 1)this.segments.push(t[r]);
            } else this.segments.push(t);
            this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
        }, AnimationItem.prototype.resetSegments = function(t) {
            this.segments.length = 0, this.segments.push([
                this.animationData.ip,
                this.animationData.op
            ]), t && this.checkSegments(0);
        }, AnimationItem.prototype.checkSegments = function(t) {
            return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
        }, AnimationItem.prototype.destroy = function(t) {
            t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
        }, AnimationItem.prototype.setCurrentRawFrameValue = function(t) {
            this.currentRawFrame = t, this.gotoFrame();
        }, AnimationItem.prototype.setSpeed = function(t) {
            this.playSpeed = t, this.updaFrameModifier();
        }, AnimationItem.prototype.setDirection = function(t) {
            this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
        }, AnimationItem.prototype.setLoop = function(t) {
            this.loop = t;
        }, AnimationItem.prototype.setVolume = function(t, e) {
            e && this.name !== e || this.audioController.setVolume(t);
        }, AnimationItem.prototype.getVolume = function() {
            return this.audioController.getVolume();
        }, AnimationItem.prototype.mute = function(t) {
            t && this.name !== t || this.audioController.mute();
        }, AnimationItem.prototype.unmute = function(t) {
            t && this.name !== t || this.audioController.unmute();
        }, AnimationItem.prototype.updaFrameModifier = function() {
            this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
        }, AnimationItem.prototype.getPath = function() {
            return this.path;
        }, AnimationItem.prototype.getAssetsPath = function(t) {
            var e = "";
            if (t.e) e = t.p;
            else if (this.assetsPath) {
                var r = t.p;
                -1 !== r.indexOf("images/") && (r = r.split("/")[1]), e = this.assetsPath + r;
            } else e = this.path, e += t.u ? t.u : "", e += t.p;
            return e;
        }, AnimationItem.prototype.getAssetData = function(t) {
            for(var e = 0, r = this.assets.length; e < r;){
                if (t === this.assets[e].id) return this.assets[e];
                e += 1;
            }
            return null;
        }, AnimationItem.prototype.hide = function() {
            this.renderer.hide();
        }, AnimationItem.prototype.show = function() {
            this.renderer.show();
        }, AnimationItem.prototype.getDuration = function(t) {
            return t ? this.totalFrames : this.totalFrames / this.frameRate;
        }, AnimationItem.prototype.updateDocumentData = function(t, e, r) {
            try {
                this.renderer.getElementByPath(t).updateDocumentData(e, r);
            } catch (t) {}
        }, AnimationItem.prototype.trigger = function(t) {
            if (this._cbs && this._cbs[t]) switch(t){
                case "enterFrame":
                    this.triggerEvent(t, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameModifier));
                    break;
                case "drawnFrame":
                    this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t, this.drawnFrameEvent);
                    break;
                case "loopComplete":
                    this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
                    break;
                case "complete":
                    this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
                    break;
                case "segmentStart":
                    this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
                    break;
                case "destroy":
                    this.triggerEvent(t, new BMDestroyEvent(t, this));
                    break;
                default:
                    this.triggerEvent(t);
            }
            "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)), "complete" === t && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)), "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)), "destroy" === t && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
        }, AnimationItem.prototype.triggerRenderFrameError = function(t) {
            var e = new BMRenderFrameErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        }, AnimationItem.prototype.triggerConfigError = function(t) {
            var e = new BMConfigErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        };
        var animationManager = function() {
            var t = {}, e = [], r = 0, i = 0, a = 0, s = !0, n = !1;
            function o(t) {
                for(var r = 0, a = t.target; r < i;)e[r].animation === a && (e.splice(r, 1), r -= 1, i -= 1, a.isPaused || p()), r += 1;
            }
            function h(t, r) {
                if (!t) return null;
                for(var a = 0; a < i;){
                    if (e[a].elem === t && null !== e[a].elem) return e[a].animation;
                    a += 1;
                }
                var s = new AnimationItem;
                return f(s, t), s.setData(t, r), s;
            }
            function l() {
                a += 1, d();
            }
            function p() {
                a -= 1;
            }
            function f(t, r) {
                t.addEventListener("destroy", o), t.addEventListener("_active", l), t.addEventListener("_idle", p), e.push({
                    elem: r,
                    animation: t
                }), i += 1;
            }
            function c(t) {
                var o, h = t - r;
                for(o = 0; o < i; o += 1)e[o].animation.advanceTime(h);
                r = t, a && !n ? window.requestAnimationFrame(c) : s = !0;
            }
            function m(t) {
                r = t, window.requestAnimationFrame(c);
            }
            function d() {
                !n && a && s && (window.requestAnimationFrame(m), s = !1);
            }
            return t.registerAnimation = h, t.loadAnimation = function(t) {
                var e = new AnimationItem;
                return f(e, null), e.setParams(t), e;
            }, t.setSpeed = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setSpeed(t, r);
            }, t.setDirection = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setDirection(t, r);
            }, t.play = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.play(t);
            }, t.pause = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.pause(t);
            }, t.stop = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.stop(t);
            }, t.togglePause = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.togglePause(t);
            }, t.searchAnimations = function(t, e, r) {
                var i, a = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), s = a.length;
                for(i = 0; i < s; i += 1)r && a[i].setAttribute("data-bm-type", r), h(a[i], t);
                if (e && 0 === s) {
                    r || (r = "svg");
                    var n = document.getElementsByTagName("body")[0];
                    n.innerText = "";
                    var o = createTag("div");
                    o.style.width = "100%", o.style.height = "100%", o.setAttribute("data-bm-type", r), n.appendChild(o), h(o, t);
                }
            }, t.resize = function() {
                var t;
                for(t = 0; t < i; t += 1)e[t].animation.resize();
            }, t.goToAndStop = function(t, r, a) {
                var s;
                for(s = 0; s < i; s += 1)e[s].animation.goToAndStop(t, r, a);
            }, t.destroy = function(t) {
                var r;
                for(r = i - 1; r >= 0; r -= 1)e[r].animation.destroy(t);
            }, t.freeze = function() {
                n = !0;
            }, t.unfreeze = function() {
                n = !1, d();
            }, t.setVolume = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setVolume(t, r);
            }, t.mute = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.mute(t);
            }, t.unmute = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.unmute(t);
            }, t.getRegisteredAnimations = function() {
                var t, r = e.length, i = [];
                for(t = 0; t < r; t += 1)i.push(e[t].animation);
                return i;
            }, t;
        }(), BezierFactory = function() {
            var t = {
                getBezierEasing: function(t, r, i, a, s) {
                    var n = s || ("bez_" + t + "_" + r + "_" + i + "_" + a).replace(/\./g, "p");
                    if (e[n]) return e[n];
                    var o = new h([
                        t,
                        r,
                        i,
                        a
                    ]);
                    return e[n] = o, o;
                }
            }, e = {};
            var r = "function" == typeof Float32Array;
            function i(t, e) {
                return 1 - 3 * e + 3 * t;
            }
            function a(t, e) {
                return 3 * e - 6 * t;
            }
            function s(t) {
                return 3 * t;
            }
            function n(t, e, r) {
                return ((i(e, r) * t + a(e, r)) * t + s(e)) * t;
            }
            function o(t, e, r) {
                return 3 * i(e, r) * t * t + 2 * a(e, r) * t + s(e);
            }
            function h(t) {
                this._p = t, this._mSampleValues = r ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
            }
            return h.prototype = {
                get: function(t) {
                    var e = this._p[0], r = this._p[1], i = this._p[2], a = this._p[3];
                    return this._precomputed || this._precompute(), e === r && i === a ? t : 0 === t ? 0 : 1 === t ? 1 : n(this._getTForX(t), r, a);
                },
                _precompute: function() {
                    var t = this._p[0], e = this._p[1], r = this._p[2], i = this._p[3];
                    this._precomputed = !0, t === e && r === i || this._calcSampleValues();
                },
                _calcSampleValues: function() {
                    for(var t = this._p[0], e = this._p[2], r = 0; r < 11; ++r)this._mSampleValues[r] = n(.1 * r, t, e);
                },
                _getTForX: function(t) {
                    for(var e = this._p[0], r = this._p[2], i = this._mSampleValues, a = 0, s = 1; 10 !== s && i[s] <= t; ++s)a += .1;
                    var h = a + .1 * ((t - i[--s]) / (i[s + 1] - i[s])), l = o(h, e, r);
                    return l >= .001 ? function(t, e, r, i) {
                        for(var a = 0; a < 4; ++a){
                            var s = o(e, r, i);
                            if (0 === s) return e;
                            e -= (n(e, r, i) - t) / s;
                        }
                        return e;
                    }(t, h, e, r) : 0 === l ? h : function(t, e, r, i, a) {
                        var s, o, h = 0;
                        do (s = n(o = e + (r - e) / 2, i, a) - t) > 0 ? r = o : e = o;
                        while (Math.abs(s) > 1e-7 && ++h < 10);
                        return o;
                    }(t, a, a + .1, e, r);
                }
            }, t;
        }(), pooling = {
            double: function(t) {
                return t.concat(createSizedArray(t.length));
            }
        }, poolFactory = function(t, e, r) {
            var i = 0, a = t, s = createSizedArray(a);
            return {
                newElement: function() {
                    return i ? s[i -= 1] : e();
                },
                release: function(t) {
                    i === a && (s = pooling.double(s), a *= 2), r && r(t), s[i] = t, i += 1;
                }
            };
        }, bezierLengthPool = poolFactory(8, function() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }), segmentsLengthPool = poolFactory(8, function() {
            return {
                lengths: [],
                totalLength: 0
            };
        }, function(t) {
            var e, r = t.lengths.length;
            for(e = 0; e < r; e += 1)bezierLengthPool.release(t.lengths[e]);
            t.lengths.length = 0;
        });
        function bezFunction() {
            var t = Math;
            function e(t, e, r, i, a, s) {
                var n = t * i + e * a + r * s - a * i - s * t - r * e;
                return n > -0.001 && n < .001;
            }
            var r = function(t, e, r, i) {
                var a, s, n, o, h, l, p = getDefaultCurveSegments(), f = 0, c = [], m = [], d = bezierLengthPool.newElement();
                for(n = r.length, a = 0; a < p; a += 1){
                    for(h = a / (p - 1), l = 0, s = 0; s < n; s += 1)o = bmPow(1 - h, 3) * t[s] + 3 * bmPow(1 - h, 2) * h * r[s] + 3 * (1 - h) * bmPow(h, 2) * i[s] + bmPow(h, 3) * e[s], c[s] = o, null !== m[s] && (l += bmPow(c[s] - m[s], 2)), m[s] = c[s];
                    l && (f += l = bmSqrt(l)), d.percents[a] = h, d.lengths[a] = f;
                }
                return d.addedLength = f, d;
            };
            function i(t) {
                this.segmentLength = 0, this.points = new Array(t);
            }
            function a(t, e) {
                this.partialLength = t, this.point = e;
            }
            var s, n = (s = {}, function(t, r, n, o) {
                var h = (t[0] + "_" + t[1] + "_" + r[0] + "_" + r[1] + "_" + n[0] + "_" + n[1] + "_" + o[0] + "_" + o[1]).replace(/\./g, "p");
                if (!s[h]) {
                    var l, p, f, c, m, d, u, y = getDefaultCurveSegments(), g = 0, v = null;
                    2 === t.length && (t[0] !== r[0] || t[1] !== r[1]) && e(t[0], t[1], r[0], r[1], t[0] + n[0], t[1] + n[1]) && e(t[0], t[1], r[0], r[1], r[0] + o[0], r[1] + o[1]) && (y = 2);
                    var b = new i(y);
                    for(f = n.length, l = 0; l < y; l += 1){
                        for(u = createSizedArray(f), m = l / (y - 1), d = 0, p = 0; p < f; p += 1)c = bmPow(1 - m, 3) * t[p] + 3 * bmPow(1 - m, 2) * m * (t[p] + n[p]) + 3 * (1 - m) * bmPow(m, 2) * (r[p] + o[p]) + bmPow(m, 3) * r[p], u[p] = c, null !== v && (d += bmPow(u[p] - v[p], 2));
                        g += d = bmSqrt(d), b.points[l] = new a(d, u), v = u;
                    }
                    b.segmentLength = g, s[h] = b;
                }
                return s[h];
            });
            function o(t, e) {
                var r = e.percents, i = e.lengths, a = r.length, s = bmFloor((a - 1) * t), n = t * e.addedLength, o = 0;
                if (s === a - 1 || 0 === s || n === i[s]) return r[s];
                for(var h = i[s] > n ? -1 : 1, l = !0; l;)if (i[s] <= n && i[s + 1] > n ? (o = (n - i[s]) / (i[s + 1] - i[s]), l = !1) : s += h, s < 0 || s >= a - 1) {
                    if (s === a - 1) return r[s];
                    l = !1;
                }
                return r[s] + (r[s + 1] - r[s]) * o;
            }
            var h = createTypedArray("float32", 8);
            return {
                getSegmentsLength: function(t) {
                    var e, i = segmentsLengthPool.newElement(), a = t.c, s = t.v, n = t.o, o = t.i, h = t._length, l = i.lengths, p = 0;
                    for(e = 0; e < h - 1; e += 1)l[e] = r(s[e], s[e + 1], n[e], o[e + 1]), p += l[e].addedLength;
                    return a && h && (l[e] = r(s[e], s[0], n[e], o[0]), p += l[e].addedLength), i.totalLength = p, i;
                },
                getNewSegment: function(e, r, i, a, s, n, l) {
                    s < 0 ? s = 0 : s > 1 && (s = 1);
                    var p, f = o(s, l), c = o(n = n > 1 ? 1 : n, l), m = e.length, d = 1 - f, u = 1 - c, y = d * d * d, g = f * d * d * 3, v = f * f * d * 3, b = f * f * f, x = d * d * u, E = f * d * u + d * f * u + d * d * c, S = f * f * u + d * f * c + f * d * c, P = f * f * c, C = d * u * u, _ = f * u * u + d * c * u + d * u * c, k = f * c * u + d * c * c + f * u * c, A = f * c * c, T = u * u * u, M = c * u * u + u * c * u + u * u * c, w = c * c * u + u * c * c + c * u * c, D = c * c * c;
                    for(p = 0; p < m; p += 1)h[4 * p] = t.round(1e3 * (y * e[p] + g * i[p] + v * a[p] + b * r[p])) / 1e3, h[4 * p + 1] = t.round(1e3 * (x * e[p] + E * i[p] + S * a[p] + P * r[p])) / 1e3, h[4 * p + 2] = t.round(1e3 * (C * e[p] + _ * i[p] + k * a[p] + A * r[p])) / 1e3, h[4 * p + 3] = t.round(1e3 * (T * e[p] + M * i[p] + w * a[p] + D * r[p])) / 1e3;
                    return h;
                },
                getPointInSegment: function(e, r, i, a, s, n) {
                    var h = o(s, n), l = 1 - h;
                    return [
                        t.round(1e3 * (l * l * l * e[0] + (h * l * l + l * h * l + l * l * h) * i[0] + (h * h * l + l * h * h + h * l * h) * a[0] + h * h * h * r[0])) / 1e3,
                        t.round(1e3 * (l * l * l * e[1] + (h * l * l + l * h * l + l * l * h) * i[1] + (h * h * l + l * h * h + h * l * h) * a[1] + h * h * h * r[1])) / 1e3
                    ];
                },
                buildBezierData: n,
                pointOnLine2D: e,
                pointOnLine3D: function(r, i, a, s, n, o, h, l, p) {
                    if (0 === a && 0 === o && 0 === p) return e(r, i, s, n, h, l);
                    var f, c = t.sqrt(t.pow(s - r, 2) + t.pow(n - i, 2) + t.pow(o - a, 2)), m = t.sqrt(t.pow(h - r, 2) + t.pow(l - i, 2) + t.pow(p - a, 2)), d = t.sqrt(t.pow(h - s, 2) + t.pow(l - n, 2) + t.pow(p - o, 2));
                    return (f = c > m ? c > d ? c - m - d : d - m - c : d > m ? d - m - c : m - c - d) > -0.0001 && f < 1e-4;
                }
            };
        }
        var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
        function interpolateValue(t, e) {
            var r, i = this.offsetTime;
            "multidimensional" === this.propType && (r = createTypedArray("float32", this.pv.length));
            for(var a, s, n, o, h, l, p, f, c, m = e.lastIndex, d = m, u = this.keyframes.length - 1, y = !0; y;){
                if (a = this.keyframes[d], s = this.keyframes[d + 1], d === u - 1 && t >= s.t - i) {
                    a.h && (a = s), m = 0;
                    break;
                }
                if (s.t - i > t) {
                    m = d;
                    break;
                }
                d < u - 1 ? d += 1 : (m = 0, y = !1);
            }
            n = this.keyframesMetadata[d] || {};
            var g, v = s.t - i, b = a.t - i;
            if (a.to) {
                n.bezierData || (n.bezierData = bez.buildBezierData(a.s, s.s || a.e, a.to, a.ti));
                var x = n.bezierData;
                if (t >= v || t < b) {
                    var E = t >= v ? x.points.length - 1 : 0;
                    for(h = x.points[E].point.length, o = 0; o < h; o += 1)r[o] = x.points[E].point[o];
                } else {
                    n.__fnct ? c = n.__fnct : (c = BezierFactory.getBezierEasing(a.o.x, a.o.y, a.i.x, a.i.y, a.n).get, n.__fnct = c), l = c((t - b) / (v - b));
                    var S, P = x.segmentLength * l, C = e.lastFrame < t && e._lastKeyframeIndex === d ? e._lastAddedLength : 0;
                    for(f = e.lastFrame < t && e._lastKeyframeIndex === d ? e._lastPoint : 0, y = !0, p = x.points.length; y;){
                        if (C += x.points[f].partialLength, 0 === P || 0 === l || f === x.points.length - 1) {
                            for(h = x.points[f].point.length, o = 0; o < h; o += 1)r[o] = x.points[f].point[o];
                            break;
                        }
                        if (P >= C && P < C + x.points[f + 1].partialLength) {
                            for(S = (P - C) / x.points[f + 1].partialLength, h = x.points[f].point.length, o = 0; o < h; o += 1)r[o] = x.points[f].point[o] + (x.points[f + 1].point[o] - x.points[f].point[o]) * S;
                            break;
                        }
                        f < p - 1 ? f += 1 : y = !1;
                    }
                    e._lastPoint = f, e._lastAddedLength = C - x.points[f].partialLength, e._lastKeyframeIndex = d;
                }
            } else {
                var _, k, A, T, M;
                if (u = a.s.length, g = s.s || a.e, this.sh && 1 !== a.h) {
                    if (t >= v) r[0] = g[0], r[1] = g[1], r[2] = g[2];
                    else if (t <= b) r[0] = a.s[0], r[1] = a.s[1], r[2] = a.s[2];
                    else quaternionToEuler(r, slerp(createQuaternion(a.s), createQuaternion(g), (t - b) / (v - b)));
                } else for(d = 0; d < u; d += 1)1 !== a.h && (t >= v ? l = 1 : t < b ? l = 0 : (a.o.x.constructor === Array ? (n.__fnct || (n.__fnct = []), n.__fnct[d] ? c = n.__fnct[d] : (_ = void 0 === a.o.x[d] ? a.o.x[0] : a.o.x[d], k = void 0 === a.o.y[d] ? a.o.y[0] : a.o.y[d], A = void 0 === a.i.x[d] ? a.i.x[0] : a.i.x[d], T = void 0 === a.i.y[d] ? a.i.y[0] : a.i.y[d], c = BezierFactory.getBezierEasing(_, k, A, T).get, n.__fnct[d] = c)) : n.__fnct ? c = n.__fnct : (_ = a.o.x, k = a.o.y, A = a.i.x, T = a.i.y, c = BezierFactory.getBezierEasing(_, k, A, T).get, a.keyframeMetadata = c), l = c((t - b) / (v - b)))), g = s.s || a.e, M = 1 === a.h ? a.s[d] : a.s[d] + (g[d] - a.s[d]) * l, "multidimensional" === this.propType ? r[d] = M : r = M;
            }
            return e.lastIndex = m, r;
        }
        function slerp(t, e, r) {
            var i, a, s, n, o, h = [], l = t[0], p = t[1], f = t[2], c = t[3], m = e[0], d = e[1], u = e[2], y = e[3];
            return (a = l * m + p * d + f * u + c * y) < 0 && (a = -a, m = -m, d = -d, u = -u, y = -y), 1 - a > 1e-6 ? (i = Math.acos(a), s = Math.sin(i), n = Math.sin((1 - r) * i) / s, o = Math.sin(r * i) / s) : (n = 1 - r, o = r), h[0] = n * l + o * m, h[1] = n * p + o * d, h[2] = n * f + o * u, h[3] = n * c + o * y, h;
        }
        function quaternionToEuler(t, e) {
            var r = e[0], i = e[1], a = e[2], s = e[3], n = Math.atan2(2 * i * s - 2 * r * a, 1 - 2 * i * i - 2 * a * a), o = Math.asin(2 * r * i + 2 * a * s), h = Math.atan2(2 * r * s - 2 * i * a, 1 - 2 * r * r - 2 * a * a);
            t[0] = n / degToRads, t[1] = o / degToRads, t[2] = h / degToRads;
        }
        function createQuaternion(t) {
            var e = t[0] * degToRads, r = t[1] * degToRads, i = t[2] * degToRads, a = Math.cos(e / 2), s = Math.cos(r / 2), n = Math.cos(i / 2), o = Math.sin(e / 2), h = Math.sin(r / 2), l = Math.sin(i / 2);
            return [
                o * h * n + a * s * l,
                o * s * n + a * h * l,
                a * h * n - o * s * l,
                a * s * n - o * h * l
            ];
        }
        function getValueAtCurrentTime() {
            var t = this.comp.renderedFrame - this.offsetTime, e = this.keyframes[0].t - this.offsetTime, r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            if (!(t === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= r && t >= r || this._caching.lastFrame < e && t < e))) {
                this._caching.lastFrame >= t && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
                var i = this.interpolateValue(t, this._caching);
                this.pv = i;
            }
            return this._caching.lastFrame = t, this.pv;
        }
        function setVValue(t) {
            var e;
            if ("unidimensional" === this.propType) e = t * this.mult, mathAbs(this.v - e) > 1e-5 && (this.v = e, this._mdf = !0);
            else for(var r = 0, i = this.v.length; r < i;)e = t[r] * this.mult, mathAbs(this.v[r] - e) > 1e-5 && (this.v[r] = e, this._mdf = !0), r += 1;
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) {
                if (this.lock) this.setVValue(this.pv);
                else {
                    var t;
                    this.lock = !0, this._mdf = this._isFirstFrame;
                    var e = this.effectsSequence.length, r = this.kf ? this.pv : this.data.k;
                    for(t = 0; t < e; t += 1)r = this.effectsSequence[t](r);
                    this.setVValue(r), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }
        function addEffect(t) {
            this.effectsSequence.push(t), this.container.addDynamicProperty(this);
        }
        function ValueProperty(t, e, r, i) {
            this.propType = "unidimensional", this.mult = r || 1, this.data = e, this.v = r ? e.k * r : e.k, this.pv = e.k, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
        }
        function MultiDimensionalProperty(t, e, r, i) {
            var a;
            this.propType = "multidimensional", this.mult = r || 1, this.data = e, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
            var s = e.k.length;
            for(this.v = createTypedArray("float32", s), this.pv = createTypedArray("float32", s), this.vel = createTypedArray("float32", s), a = 0; a < s; a += 1)this.v[a] = e.k[a] * this.mult, this.pv[a] = e.k[a];
            this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
        }
        function KeyframedValueProperty(t, e, r, i) {
            this.propType = "unidimensional", this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.frameId = -1, this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: 0,
                _lastKeyframeIndex: -1
            }, this.k = !0, this.kf = !0, this.data = e, this.mult = r || 1, this.elem = t, this.container = i, this.comp = t.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ], this.addEffect = addEffect;
        }
        function KeyframedMultidimensionalProperty(t, e, r, i) {
            var a;
            this.propType = "multidimensional";
            var s, n, o, h, l = e.k.length;
            for(a = 0; a < l - 1; a += 1)e.k[a].to && e.k[a].s && e.k[a + 1] && e.k[a + 1].s && (s = e.k[a].s, n = e.k[a + 1].s, o = e.k[a].to, h = e.k[a].ti, (2 === s.length && (s[0] !== n[0] || s[1] !== n[1]) && bez.pointOnLine2D(s[0], s[1], n[0], n[1], s[0] + o[0], s[1] + o[1]) && bez.pointOnLine2D(s[0], s[1], n[0], n[1], n[0] + h[0], n[1] + h[1]) || 3 === s.length && (s[0] !== n[0] || s[1] !== n[1] || s[2] !== n[2]) && bez.pointOnLine3D(s[0], s[1], s[2], n[0], n[1], n[2], s[0] + o[0], s[1] + o[1], s[2] + o[2]) && bez.pointOnLine3D(s[0], s[1], s[2], n[0], n[1], n[2], n[0] + h[0], n[1] + h[1], n[2] + h[2])) && (e.k[a].to = null, e.k[a].ti = null), s[0] === n[0] && s[1] === n[1] && 0 === o[0] && 0 === o[1] && 0 === h[0] && 0 === h[1] && (2 === s.length || s[2] === n[2] && 0 === o[2] && 0 === h[2]) && (e.k[a].to = null, e.k[a].ti = null));
            this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ], this.data = e, this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = r || 1, this.elem = t, this.container = i, this.comp = t.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
            var p = e.k[0].s.length;
            for(this.v = createTypedArray("float32", p), this.pv = createTypedArray("float32", p), a = 0; a < p; a += 1)this.v[a] = initFrame, this.pv[a] = initFrame;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: createTypedArray("float32", p)
            }, this.addEffect = addEffect;
        }
        var PropertyFactory = {
            getProp: function(t, e, r, i, a) {
                var s;
                if (e.sid && (e = t.globalData.slotManager.getProp(e)), e.k.length) {
                    if ("number" == typeof e.k[0]) s = new MultiDimensionalProperty(t, e, i, a);
                    else switch(r){
                        case 0:
                            s = new KeyframedValueProperty(t, e, i, a);
                            break;
                        case 1:
                            s = new KeyframedMultidimensionalProperty(t, e, i, a);
                    }
                } else s = new ValueProperty(t, e, i, a);
                return s.effectsSequence.length && a.addDynamicProperty(s), s;
            }
        };
        function DynamicPropertyContainer() {}
        DynamicPropertyContainer.prototype = {
            addDynamicProperty: function(t) {
                -1 === this.dynamicProperties.indexOf(t) && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
            },
            iterateDynamicProperties: function() {
                var t;
                this._mdf = !1;
                var e = this.dynamicProperties.length;
                for(t = 0; t < e; t += 1)this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
            },
            initDynamicPropertyContainer: function(t) {
                this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
            }
        };
        var pointPool = poolFactory(8, function() {
            return createTypedArray("float32", 2);
        });
        function ShapePath() {
            this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
        }
        ShapePath.prototype.setPathData = function(t, e) {
            this.c = t, this.setLength(e);
            for(var r = 0; r < e;)this.v[r] = pointPool.newElement(), this.o[r] = pointPool.newElement(), this.i[r] = pointPool.newElement(), r += 1;
        }, ShapePath.prototype.setLength = function(t) {
            for(; this._maxLength < t;)this.doubleArrayLength();
            this._length = t;
        }, ShapePath.prototype.doubleArrayLength = function() {
            this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
        }, ShapePath.prototype.setXYAt = function(t, e, r, i, a) {
            var s;
            switch(this._length = Math.max(this._length, i + 1), this._length >= this._maxLength && this.doubleArrayLength(), r){
                case "v":
                    s = this.v;
                    break;
                case "i":
                    s = this.i;
                    break;
                case "o":
                    s = this.o;
                    break;
                default:
                    s = [];
            }
            (!s[i] || s[i] && !a) && (s[i] = pointPool.newElement()), s[i][0] = t, s[i][1] = e;
        }, ShapePath.prototype.setTripleAt = function(t, e, r, i, a, s, n, o) {
            this.setXYAt(t, e, "v", n, o), this.setXYAt(r, i, "o", n, o), this.setXYAt(a, s, "i", n, o);
        }, ShapePath.prototype.reverse = function() {
            var t = new ShapePath;
            t.setPathData(this.c, this._length);
            var e = this.v, r = this.o, i = this.i, a = 0;
            this.c && (t.setTripleAt(e[0][0], e[0][1], i[0][0], i[0][1], r[0][0], r[0][1], 0, !1), a = 1);
            var s, n = this._length - 1, o = this._length;
            for(s = a; s < o; s += 1)t.setTripleAt(e[n][0], e[n][1], i[n][0], i[n][1], r[n][0], r[n][1], s, !1), n -= 1;
            return t;
        }, ShapePath.prototype.length = function() {
            return this._length;
        };
        var shapePool = (factory = poolFactory(4, function() {
            return new ShapePath;
        }, function(t) {
            var e, r = t._length;
            for(e = 0; e < r; e += 1)pointPool.release(t.v[e]), pointPool.release(t.i[e]), pointPool.release(t.o[e]), t.v[e] = null, t.i[e] = null, t.o[e] = null;
            t._length = 0, t.c = !1;
        }), factory.clone = function(t) {
            var e, r = factory.newElement(), i = void 0 === t._length ? t.v.length : t._length;
            for(r.setLength(i), r.c = t.c, e = 0; e < i; e += 1)r.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
            return r;
        }, factory), factory;
        function ShapeCollection() {
            this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
        }
        ShapeCollection.prototype.addShape = function(t) {
            this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
        }, ShapeCollection.prototype.releaseShapes = function() {
            var t;
            for(t = 0; t < this._length; t += 1)shapePool.release(this.shapes[t]);
            this._length = 0;
        };
        var shapeCollectionPool = (ob = {
            newShapeCollection: function() {
                return _length ? pool[_length -= 1] : new ShapeCollection;
            },
            release: function(t) {
                var e, r = t._length;
                for(e = 0; e < r; e += 1)shapePool.release(t.shapes[e]);
                t._length = 0, _length === _maxLength && (pool = pooling.double(pool), _maxLength *= 2), pool[_length] = t, _length += 1;
            }
        }, _length = 0, _maxLength = 4, pool = createSizedArray(_maxLength), ob), ob, _length, _maxLength, pool, ShapePropertyFactory = function() {
            function t(t, e, r) {
                var i, a, s, n, o, h, l, p, f, c = r.lastIndex, m = this.keyframes;
                if (t < m[0].t - this.offsetTime) i = m[0].s[0], s = !0, c = 0;
                else if (t >= m[m.length - 1].t - this.offsetTime) i = m[m.length - 1].s ? m[m.length - 1].s[0] : m[m.length - 2].e[0], s = !0;
                else {
                    for(var d, u, y, g = c, v = m.length - 1, b = !0; b && (d = m[g], !((u = m[g + 1]).t - this.offsetTime > t));)g < v - 1 ? g += 1 : b = !1;
                    if (y = this.keyframesMetadata[g] || {}, c = g, !(s = 1 === d.h)) {
                        if (t >= u.t - this.offsetTime) p = 1;
                        else if (t < d.t - this.offsetTime) p = 0;
                        else {
                            var x;
                            y.__fnct ? x = y.__fnct : (x = BezierFactory.getBezierEasing(d.o.x, d.o.y, d.i.x, d.i.y).get, y.__fnct = x), p = x((t - (d.t - this.offsetTime)) / (u.t - this.offsetTime - (d.t - this.offsetTime)));
                        }
                        a = u.s ? u.s[0] : d.e[0];
                    }
                    i = d.s[0];
                }
                for(h = e._length, l = i.i[0].length, r.lastIndex = c, n = 0; n < h; n += 1)for(o = 0; o < l; o += 1)f = s ? i.i[n][o] : i.i[n][o] + (a.i[n][o] - i.i[n][o]) * p, e.i[n][o] = f, f = s ? i.o[n][o] : i.o[n][o] + (a.o[n][o] - i.o[n][o]) * p, e.o[n][o] = f, f = s ? i.v[n][o] : i.v[n][o] + (a.v[n][o] - i.v[n][o]) * p, e.v[n][o] = f;
            }
            function e() {
                var t = this.comp.renderedFrame - this.offsetTime, e = this.keyframes[0].t - this.offsetTime, r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, i = this._caching.lastFrame;
                return -999999 !== i && (i < e && t < e || i > r && t > r) || (this._caching.lastIndex = i < t ? this._caching.lastIndex : 0, this.interpolateShape(t, this.pv, this._caching)), this._caching.lastFrame = t, this.pv;
            }
            function r() {
                this.paths = this.localShapeCollection;
            }
            function i(t) {
                (function(t, e) {
                    if (t._length !== e._length || t.c !== e.c) return !1;
                    var r, i = t._length;
                    for(r = 0; r < i; r += 1)if (t.v[r][0] !== e.v[r][0] || t.v[r][1] !== e.v[r][1] || t.o[r][0] !== e.o[r][0] || t.o[r][1] !== e.o[r][1] || t.i[r][0] !== e.i[r][0] || t.i[r][1] !== e.i[r][1]) return !1;
                    return !0;
                })(this.v, t) || (this.v = shapePool.clone(t), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
            }
            function a() {
                if (this.elem.globalData.frameId !== this.frameId) {
                    if (this.effectsSequence.length) {
                        if (this.lock) this.setVValue(this.pv);
                        else {
                            var t, e;
                            this.lock = !0, this._mdf = !1, t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
                            var r = this.effectsSequence.length;
                            for(e = 0; e < r; e += 1)t = this.effectsSequence[e](t);
                            this.setVValue(t), this.lock = !1, this.frameId = this.elem.globalData.frameId;
                        }
                    } else this._mdf = !1;
                }
            }
            function s(t, e, i) {
                this.propType = "shape", this.comp = t.comp, this.container = t, this.elem = t, this.data = e, this.k = !1, this.kf = !1, this._mdf = !1;
                var a = 3 === i ? e.pt.k : e.ks.k;
                this.v = shapePool.clone(a), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = r, this.effectsSequence = [];
            }
            function n(t) {
                this.effectsSequence.push(t), this.container.addDynamicProperty(this);
            }
            function o(t, i, a) {
                this.propType = "shape", this.comp = t.comp, this.elem = t, this.container = t, this.offsetTime = t.data.st, this.keyframes = 3 === a ? i.pt.k : i.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
                var s = this.keyframes[0].s[0].i.length;
                this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, s), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = -999999, this.reset = r, this._caching = {
                    lastFrame: -999999,
                    lastIndex: 0
                }, this.effectsSequence = [
                    e.bind(this)
                ];
            }
            s.prototype.interpolateShape = t, s.prototype.getValue = a, s.prototype.setVValue = i, s.prototype.addEffect = n, o.prototype.getValue = a, o.prototype.interpolateShape = t, o.prototype.setVValue = i, o.prototype.addEffect = n;
            var h = function() {
                var t = roundCorner;
                function e(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e.d, this.elem = t, this.comp = t.comp, this.frameId = -1, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
                }
                return e.prototype = {
                    reset: r,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                    },
                    convertEllToPath: function() {
                        var e = this.p.v[0], r = this.p.v[1], i = this.s.v[0] / 2, a = this.s.v[1] / 2, s = 3 !== this.d, n = this.v;
                        n.v[0][0] = e, n.v[0][1] = r - a, n.v[1][0] = s ? e + i : e - i, n.v[1][1] = r, n.v[2][0] = e, n.v[2][1] = r + a, n.v[3][0] = s ? e - i : e + i, n.v[3][1] = r, n.i[0][0] = s ? e - i * t : e + i * t, n.i[0][1] = r - a, n.i[1][0] = s ? e + i : e - i, n.i[1][1] = r - a * t, n.i[2][0] = s ? e + i * t : e - i * t, n.i[2][1] = r + a, n.i[3][0] = s ? e - i : e + i, n.i[3][1] = r + a * t, n.o[0][0] = s ? e + i * t : e - i * t, n.o[0][1] = r - a, n.o[1][0] = s ? e + i : e - i, n.o[1][1] = r + a * t, n.o[2][0] = s ? e - i * t : e + i * t, n.o[2][1] = r + a, n.o[3][0] = s ? e - i : e + i, n.o[3][1] = r - a * t;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], e), e;
            }(), l = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = t, this.comp = t.comp, this.data = e, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), 1 === e.sy ? (this.ir = PropertyFactory.getProp(t, e.ir, 0, 0, this), this.is = PropertyFactory.getProp(t, e.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(t, e.pt, 0, 0, this), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, degToRads, this), this.or = PropertyFactory.getProp(t, e.or, 0, 0, this), this.os = PropertyFactory.getProp(t, e.os, 0, .01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
                }
                return t.prototype = {
                    reset: r,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                    },
                    convertStarToPath: function() {
                        var t, e, r, i, a = 2 * Math.floor(this.pt.v), s = 2 * Math.PI / a, n = !0, o = this.or.v, h = this.ir.v, l = this.os.v, p = this.is.v, f = 2 * Math.PI * o / (2 * a), c = 2 * Math.PI * h / (2 * a), m = -Math.PI / 2;
                        m += this.r.v;
                        var d = 3 === this.data.d ? -1 : 1;
                        for(this.v._length = 0, t = 0; t < a; t += 1){
                            r = n ? l : p, i = n ? f : c;
                            var u = (e = n ? o : h) * Math.cos(m), y = e * Math.sin(m), g = 0 === u && 0 === y ? 0 : y / Math.sqrt(u * u + y * y), v = 0 === u && 0 === y ? 0 : -u / Math.sqrt(u * u + y * y);
                            u += +this.p.v[0], y += +this.p.v[1], this.v.setTripleAt(u, y, u - g * i * r * d, y - v * i * r * d, u + g * i * r * d, y + v * i * r * d, t, !0), n = !n, m += s * d;
                        }
                    },
                    convertPolygonToPath: function() {
                        var t, e = Math.floor(this.pt.v), r = 2 * Math.PI / e, i = this.or.v, a = this.os.v, s = 2 * Math.PI * i / (4 * e), n = .5 * -Math.PI, o = 3 === this.data.d ? -1 : 1;
                        for(n += this.r.v, this.v._length = 0, t = 0; t < e; t += 1){
                            var h = i * Math.cos(n), l = i * Math.sin(n), p = 0 === h && 0 === l ? 0 : l / Math.sqrt(h * h + l * l), f = 0 === h && 0 === l ? 0 : -h / Math.sqrt(h * h + l * l);
                            h += +this.p.v[0], l += +this.p.v[1], this.v.setTripleAt(h, l, h - p * s * a * o, l - f * s * a * o, h + p * s * a * o, l + f * s * a * o, t, !0), n += r * o;
                        }
                        this.paths.length = 0, this.paths[0] = this.v;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }(), p = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t, this.comp = t.comp, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
                }
                return t.prototype = {
                    convertRectToPath: function() {
                        var t = this.p.v[0], e = this.p.v[1], r = this.s.v[0] / 2, i = this.s.v[1] / 2, a = bmMin(r, i, this.r.v), s = a * (1 - roundCorner);
                        this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t + r, e - i + a, t + r, e - i + a, t + r, e - i + s, 0, !0), this.v.setTripleAt(t + r, e + i - a, t + r, e + i - s, t + r, e + i - a, 1, !0), 0 !== a ? (this.v.setTripleAt(t + r - a, e + i, t + r - a, e + i, t + r - s, e + i, 2, !0), this.v.setTripleAt(t - r + a, e + i, t - r + s, e + i, t - r + a, e + i, 3, !0), this.v.setTripleAt(t - r, e + i - a, t - r, e + i - a, t - r, e + i - s, 4, !0), this.v.setTripleAt(t - r, e - i + a, t - r, e - i + s, t - r, e - i + a, 5, !0), this.v.setTripleAt(t - r + a, e - i, t - r + a, e - i, t - r + s, e - i, 6, !0), this.v.setTripleAt(t + r - a, e - i, t + r - s, e - i, t + r - a, e - i, 7, !0)) : (this.v.setTripleAt(t - r, e + i, t - r + s, e + i, t - r, e + i, 2), this.v.setTripleAt(t - r, e - i, t - r, e - i + s, t - r, e - i, 3))) : (this.v.setTripleAt(t + r, e - i + a, t + r, e - i + s, t + r, e - i + a, 0, !0), 0 !== a ? (this.v.setTripleAt(t + r - a, e - i, t + r - a, e - i, t + r - s, e - i, 1, !0), this.v.setTripleAt(t - r + a, e - i, t - r + s, e - i, t - r + a, e - i, 2, !0), this.v.setTripleAt(t - r, e - i + a, t - r, e - i + a, t - r, e - i + s, 3, !0), this.v.setTripleAt(t - r, e + i - a, t - r, e + i - s, t - r, e + i - a, 4, !0), this.v.setTripleAt(t - r + a, e + i, t - r + a, e + i, t - r + s, e + i, 5, !0), this.v.setTripleAt(t + r - a, e + i, t + r - s, e + i, t + r - a, e + i, 6, !0), this.v.setTripleAt(t + r, e + i - a, t + r, e + i - a, t + r, e + i - s, 7, !0)) : (this.v.setTripleAt(t - r, e - i, t - r + s, e - i, t - r, e - i, 1, !0), this.v.setTripleAt(t - r, e + i, t - r, e + i - s, t - r, e + i, 2, !0), this.v.setTripleAt(t + r, e + i, t + r - s, e + i, t + r, e + i, 3, !0)));
                    },
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                    },
                    reset: r
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }();
            var f = {
                getShapeProp: function(t, e, r) {
                    var i;
                    return 3 === r || 4 === r ? i = (3 === r ? e.pt : e.ks).k.length ? new o(t, e, r) : new s(t, e, r) : 5 === r ? i = new p(t, e) : 6 === r ? i = new h(t, e) : 7 === r && (i = new l(t, e)), i.k && t.addDynamicProperty(i), i;
                },
                getConstructorFunction: function() {
                    return s;
                },
                getKeyframedConstructorFunction: function() {
                    return o;
                }
            };
            return f;
        }(), Matrix = function() {
            var t = Math.cos, e = Math.sin, r = Math.tan, i = Math.round;
            function a() {
                return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
            }
            function s(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, -a, 0, 0, a, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function n(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(1, 0, 0, 0, 0, i, -a, 0, 0, a, i, 0, 0, 0, 0, 1);
            }
            function o(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, 0, a, 0, 0, 1, 0, 0, -a, 0, i, 0, 0, 0, 0, 1);
            }
            function h(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, -a, 0, 0, a, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function l(t, e) {
                return this._t(1, e, t, 1, 0, 0);
            }
            function p(t, e) {
                return this.shear(r(t), r(e));
            }
            function f(i, a) {
                var s = t(a), n = e(a);
                return this._t(s, n, 0, 0, -n, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r(i), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(s, -n, 0, 0, n, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function c(t, e, r) {
                return r || 0 === r || (r = 1), 1 === t && 1 === e && 1 === r ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r, 0, 0, 0, 0, 1);
            }
            function m(t, e, r, i, a, s, n, o, h, l, p, f, c, m, d, u) {
                return this.props[0] = t, this.props[1] = e, this.props[2] = r, this.props[3] = i, this.props[4] = a, this.props[5] = s, this.props[6] = n, this.props[7] = o, this.props[8] = h, this.props[9] = l, this.props[10] = p, this.props[11] = f, this.props[12] = c, this.props[13] = m, this.props[14] = d, this.props[15] = u, this;
            }
            function d(t, e, r) {
                return r = r || 0, 0 !== t || 0 !== e || 0 !== r ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, r, 1) : this;
            }
            function u(t, e, r, i, a, s, n, o, h, l, p, f, c, m, d, u) {
                var y = this.props;
                if (1 === t && 0 === e && 0 === r && 0 === i && 0 === a && 1 === s && 0 === n && 0 === o && 0 === h && 0 === l && 1 === p && 0 === f) return y[12] = y[12] * t + y[15] * c, y[13] = y[13] * s + y[15] * m, y[14] = y[14] * p + y[15] * d, y[15] *= u, this._identityCalculated = !1, this;
                var g = y[0], v = y[1], b = y[2], x = y[3], E = y[4], S = y[5], P = y[6], C = y[7], _ = y[8], k = y[9], A = y[10], T = y[11], M = y[12], w = y[13], D = y[14], F = y[15];
                return y[0] = g * t + v * a + b * h + x * c, y[1] = g * e + v * s + b * l + x * m, y[2] = g * r + v * n + b * p + x * d, y[3] = g * i + v * o + b * f + x * u, y[4] = E * t + S * a + P * h + C * c, y[5] = E * e + S * s + P * l + C * m, y[6] = E * r + S * n + P * p + C * d, y[7] = E * i + S * o + P * f + C * u, y[8] = _ * t + k * a + A * h + T * c, y[9] = _ * e + k * s + A * l + T * m, y[10] = _ * r + k * n + A * p + T * d, y[11] = _ * i + k * o + A * f + T * u, y[12] = M * t + w * a + D * h + F * c, y[13] = M * e + w * s + D * l + F * m, y[14] = M * r + w * n + D * p + F * d, y[15] = M * i + w * o + D * f + F * u, this._identityCalculated = !1, this;
            }
            function y(t) {
                var e = t.props;
                return this.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]);
            }
            function g() {
                return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
            }
            function v(t) {
                for(var e = 0; e < 16;){
                    if (t.props[e] !== this.props[e]) return !1;
                    e += 1;
                }
                return !0;
            }
            function b(t) {
                var e;
                for(e = 0; e < 16; e += 1)t.props[e] = this.props[e];
                return t;
            }
            function x(t) {
                var e;
                for(e = 0; e < 16; e += 1)this.props[e] = t[e];
            }
            function E(t, e, r) {
                return {
                    x: t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                    y: t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                    z: t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14]
                };
            }
            function S(t, e, r) {
                return t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12];
            }
            function P(t, e, r) {
                return t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13];
            }
            function C(t, e, r) {
                return t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14];
            }
            function _() {
                var t = this.props[0] * this.props[5] - this.props[1] * this.props[4], e = this.props[5] / t, r = -this.props[1] / t, i = -this.props[4] / t, a = this.props[0] / t, s = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t, n = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t, o = new Matrix;
                return o.props[0] = e, o.props[1] = r, o.props[4] = i, o.props[5] = a, o.props[12] = s, o.props[13] = n, o;
            }
            function k(t) {
                return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
            }
            function A(t) {
                var e, r = t.length, i = [];
                for(e = 0; e < r; e += 1)i[e] = k(t[e]);
                return i;
            }
            function T(t, e, r) {
                var i = createTypedArray("float32", 6);
                if (this.isIdentity()) i[0] = t[0], i[1] = t[1], i[2] = e[0], i[3] = e[1], i[4] = r[0], i[5] = r[1];
                else {
                    var a = this.props[0], s = this.props[1], n = this.props[4], o = this.props[5], h = this.props[12], l = this.props[13];
                    i[0] = t[0] * a + t[1] * n + h, i[1] = t[0] * s + t[1] * o + l, i[2] = e[0] * a + e[1] * n + h, i[3] = e[0] * s + e[1] * o + l, i[4] = r[0] * a + r[1] * n + h, i[5] = r[0] * s + r[1] * o + l;
                }
                return i;
            }
            function M(t, e, r) {
                return this.isIdentity() ? [
                    t,
                    e,
                    r
                ] : [
                    t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                    t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                    t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14]
                ];
            }
            function w(t, e) {
                if (this.isIdentity()) return t + "," + e;
                var r = this.props;
                return Math.round(100 * (t * r[0] + e * r[4] + r[12])) / 100 + "," + Math.round(100 * (t * r[1] + e * r[5] + r[13])) / 100;
            }
            function D() {
                for(var t = 0, e = this.props, r = "matrix3d("; t < 16;)r += i(1e4 * e[t]) / 1e4, r += 15 === t ? ")" : ",", t += 1;
                return r;
            }
            function F(t) {
                return t < 1e-6 && t > 0 || t > -0.000001 && t < 0 ? i(1e4 * t) / 1e4 : t;
            }
            function I() {
                var t = this.props;
                return "matrix(" + F(t[0]) + "," + F(t[1]) + "," + F(t[4]) + "," + F(t[5]) + "," + F(t[12]) + "," + F(t[13]) + ")";
            }
            return function() {
                this.reset = a, this.rotate = s, this.rotateX = n, this.rotateY = o, this.rotateZ = h, this.skew = p, this.skewFromAxis = f, this.shear = l, this.scale = c, this.setTransform = m, this.translate = d, this.transform = u, this.multiply = y, this.applyToPoint = E, this.applyToX = S, this.applyToY = P, this.applyToZ = C, this.applyToPointArray = M, this.applyToTriplePoints = T, this.applyToPointStringified = w, this.toCSS = D, this.to2dCSS = I, this.clone = b, this.cloneFromProps = x, this.equals = v, this.inversePoints = A, this.inversePoint = k, this.getInverseMatrix = _, this._t = this.transform, this.isIdentity = g, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
            };
        }();
        function _typeof$3(t) {
            return (_typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var lottie = {}, standalone = "__[STANDALONE]__", animationData = "__[ANIMATIONDATA]__", renderer = "";
        function setLocation(t) {
            setLocationHref(t);
        }
        function searchAnimations() {
            !0 === standalone ? animationManager.searchAnimations(animationData, standalone, renderer) : animationManager.searchAnimations();
        }
        function setSubframeRendering(t) {
            setSubframeEnabled(t);
        }
        function setPrefix(t) {
            setIdPrefix(t);
        }
        function loadAnimation(t) {
            return !0 === standalone && (t.animationData = JSON.parse(animationData)), animationManager.loadAnimation(t);
        }
        function setQuality(t) {
            if ("string" == typeof t) switch(t){
                case "high":
                    setDefaultCurveSegments(200);
                    break;
                default:
                case "medium":
                    setDefaultCurveSegments(50);
                    break;
                case "low":
                    setDefaultCurveSegments(10);
            }
            else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
            getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
        }
        function inBrowser() {
            return "undefined" != typeof navigator;
        }
        function installPlugin(t, e) {
            "expressions" === t && setExpressionsPlugin(e);
        }
        function getFactory(t) {
            switch(t){
                case "propertyFactory":
                    return PropertyFactory;
                case "shapePropertyFactory":
                    return ShapePropertyFactory;
                case "matrix":
                    return Matrix;
                default:
                    return null;
            }
        }
        function checkReady() {
            "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
        }
        function getQueryVariable(t) {
            for(var e = queryString.split("&"), r = 0; r < e.length; r += 1){
                var i = e[r].split("=");
                if (decodeURIComponent(i[0]) == t) return decodeURIComponent(i[1]);
            }
            return null;
        }
        lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
        var queryString = "";
        if (standalone) {
            var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
                src: ""
            };
            queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", renderer = getQueryVariable("renderer");
        }
        var readyStateCheckInterval = setInterval(checkReady, 100);
        try {
            "object" !== _typeof$3(exports) && (window.bodymovin = lottie);
        } catch (t) {}
        var ShapeModifiers = function() {
            var t = {}, e = {};
            return t.registerModifier = function(t, r) {
                e[t] || (e[t] = r);
            }, t.getModifier = function(t, r, i) {
                return new e[t](r, i);
            }, t;
        }();
        function ShapeModifier() {}
        function TrimModifier() {}
        function PuckerAndBloatModifier() {}
        ShapeModifier.prototype.initModifierProperties = function() {}, ShapeModifier.prototype.addShapeToModifier = function() {}, ShapeModifier.prototype.addShape = function(t) {
            if (!this.closed) {
                t.sh.container.addDynamicProperty(t.sh);
                var e = {
                    shape: t.sh,
                    data: t,
                    localShapeCollection: shapeCollectionPool.newShapeCollection()
                };
                this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
            }
        }, ShapeModifier.prototype.init = function(t, e) {
            this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, ShapeModifier.prototype.processKeys = function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
        }, extendPrototype([
            DynamicPropertyContainer
        ], ShapeModifier), extendPrototype([
            ShapeModifier
        ], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t, e) {
            this.s = PropertyFactory.getProp(t, e.s, 0, .01, this), this.e = PropertyFactory.getProp(t, e.e, 0, .01, this), this.o = PropertyFactory.getProp(t, e.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
        }, TrimModifier.prototype.addShapeToModifier = function(t) {
            t.pathsData = [];
        }, TrimModifier.prototype.calculateShapeEdges = function(t, e, r, i, a) {
            var s = [];
            e <= 1 ? s.push({
                s: t,
                e: e
            }) : t >= 1 ? s.push({
                s: t - 1,
                e: e - 1
            }) : (s.push({
                s: t,
                e: 1
            }), s.push({
                s: 0,
                e: e - 1
            }));
            var n, o, h = [], l = s.length;
            for(n = 0; n < l; n += 1){
                var p, f;
                if (!((o = s[n]).e * a < i || o.s * a > i + r)) p = o.s * a <= i ? 0 : (o.s * a - i) / r, f = o.e * a >= i + r ? 1 : (o.e * a - i) / r, h.push([
                    p,
                    f
                ]);
            }
            return h.length || h.push([
                0,
                0
            ]), h;
        }, TrimModifier.prototype.releasePathsData = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)segmentsLengthPool.release(t[e]);
            return t.length = 0, t;
        }, TrimModifier.prototype.processShapes = function(t) {
            var e, r, i, a;
            if (this._mdf || t) {
                var s = this.o.v % 360 / 360;
                if (s < 0 && (s += 1), (e = this.s.v > 1 ? 1 + s : this.s.v < 0 ? 0 + s : this.s.v + s) > (r = this.e.v > 1 ? 1 + s : this.e.v < 0 ? 0 + s : this.e.v + s)) {
                    var n = e;
                    e = r, r = n;
                }
                e = 1e-4 * Math.round(1e4 * e), r = 1e-4 * Math.round(1e4 * r), this.sValue = e, this.eValue = r;
            } else e = this.sValue, r = this.eValue;
            var o, h, l, p, f, c = this.shapes.length, m = 0;
            if (r === e) for(a = 0; a < c; a += 1)this.shapes[a].localShapeCollection.releaseShapes(), this.shapes[a].shape._mdf = !0, this.shapes[a].shape.paths = this.shapes[a].localShapeCollection, this._mdf && (this.shapes[a].pathsData.length = 0);
            else if (1 === r && 0 === e || 0 === r && 1 === e) {
                if (this._mdf) for(a = 0; a < c; a += 1)this.shapes[a].pathsData.length = 0, this.shapes[a].shape._mdf = !0;
            } else {
                var d, u, y = [];
                for(a = 0; a < c; a += 1)if ((d = this.shapes[a]).shape._mdf || this._mdf || t || 2 === this.m) {
                    if (h = (i = d.shape.paths)._length, f = 0, !d.shape._mdf && d.pathsData.length) f = d.totalShapeLength;
                    else {
                        for(l = this.releasePathsData(d.pathsData), o = 0; o < h; o += 1)p = bez.getSegmentsLength(i.shapes[o]), l.push(p), f += p.totalLength;
                        d.totalShapeLength = f, d.pathsData = l;
                    }
                    m += f, d.shape._mdf = !0;
                } else d.shape.paths = d.localShapeCollection;
                var g, v = e, b = r, x = 0;
                for(a = c - 1; a >= 0; a -= 1)if ((d = this.shapes[a]).shape._mdf) {
                    for((u = d.localShapeCollection).releaseShapes(), 2 === this.m && c > 1 ? (g = this.calculateShapeEdges(e, r, d.totalShapeLength, x, m), x += d.totalShapeLength) : g = [
                        [
                            v,
                            b
                        ]
                    ], h = g.length, o = 0; o < h; o += 1){
                        v = g[o][0], b = g[o][1], y.length = 0, b <= 1 ? y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength * b
                        }) : v >= 1 ? y.push({
                            s: d.totalShapeLength * (v - 1),
                            e: d.totalShapeLength * (b - 1)
                        }) : (y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength
                        }), y.push({
                            s: 0,
                            e: d.totalShapeLength * (b - 1)
                        }));
                        var E = this.addShapes(d, y[0]);
                        if (y[0].s !== y[0].e) {
                            if (y.length > 1) {
                                if (d.shape.paths.shapes[d.shape.paths._length - 1].c) {
                                    var S = E.pop();
                                    this.addPaths(E, u), E = this.addShapes(d, y[1], S);
                                } else this.addPaths(E, u), E = this.addShapes(d, y[1]);
                            }
                            this.addPaths(E, u);
                        }
                    }
                    d.shape.paths = u;
                }
            }
        }, TrimModifier.prototype.addPaths = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)e.addShape(t[r]);
        }, TrimModifier.prototype.addSegment = function(t, e, r, i, a, s, n) {
            a.setXYAt(e[0], e[1], "o", s), a.setXYAt(r[0], r[1], "i", s + 1), n && a.setXYAt(t[0], t[1], "v", s), a.setXYAt(i[0], i[1], "v", s + 1);
        }, TrimModifier.prototype.addSegmentFromArray = function(t, e, r, i) {
            e.setXYAt(t[1], t[5], "o", r), e.setXYAt(t[2], t[6], "i", r + 1), i && e.setXYAt(t[0], t[4], "v", r), e.setXYAt(t[3], t[7], "v", r + 1);
        }, TrimModifier.prototype.addShapes = function(t, e, r) {
            var i, a, s, n, o, h, l, p, f = t.pathsData, c = t.shape.paths.shapes, m = t.shape.paths._length, d = 0, u = [], y = !0;
            for(r ? (o = r._length, p = r._length) : (r = shapePool.newElement(), o = 0, p = 0), u.push(r), i = 0; i < m; i += 1){
                for(h = f[i].lengths, r.c = c[i].c, s = c[i].c ? h.length : h.length + 1, a = 1; a < s; a += 1)if (d + (n = h[a - 1]).addedLength < e.s) d += n.addedLength, r.c = !1;
                else {
                    if (d > e.e) {
                        r.c = !1;
                        break;
                    }
                    e.s <= d && e.e >= d + n.addedLength ? (this.addSegment(c[i].v[a - 1], c[i].o[a - 1], c[i].i[a], c[i].v[a], r, o, y), y = !1) : (l = bez.getNewSegment(c[i].v[a - 1], c[i].v[a], c[i].o[a - 1], c[i].i[a], (e.s - d) / n.addedLength, (e.e - d) / n.addedLength, h[a - 1]), this.addSegmentFromArray(l, r, o, y), y = !1, r.c = !1), d += n.addedLength, o += 1;
                }
                if (c[i].c && h.length) {
                    if (n = h[a - 1], d <= e.e) {
                        var g = h[a - 1].addedLength;
                        e.s <= d && e.e >= d + g ? (this.addSegment(c[i].v[a - 1], c[i].o[a - 1], c[i].i[0], c[i].v[0], r, o, y), y = !1) : (l = bez.getNewSegment(c[i].v[a - 1], c[i].v[0], c[i].o[a - 1], c[i].i[0], (e.s - d) / g, (e.e - d) / g, h[a - 1]), this.addSegmentFromArray(l, r, o, y), y = !1, r.c = !1);
                    } else r.c = !1;
                    d += n.addedLength, o += 1;
                }
                if (r._length && (r.setXYAt(r.v[p][0], r.v[p][1], "i", p), r.setXYAt(r.v[r._length - 1][0], r.v[r._length - 1][1], "o", r._length - 1)), d > e.e) break;
                i < m - 1 && (r = shapePool.newElement(), y = !0, u.push(r), o = 0);
            }
            return u;
        }, extendPrototype([
            ShapeModifier
        ], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
        }, PuckerAndBloatModifier.prototype.processPath = function(t, e) {
            var r = e / 100, i = [
                0,
                0
            ], a = t._length, s = 0;
            for(s = 0; s < a; s += 1)i[0] += t.v[s][0], i[1] += t.v[s][1];
            i[0] /= a, i[1] /= a;
            var n, o, h, l, p, f, c = shapePool.newElement();
            for(c.c = t.c, s = 0; s < a; s += 1)n = t.v[s][0] + (i[0] - t.v[s][0]) * r, o = t.v[s][1] + (i[1] - t.v[s][1]) * r, h = t.o[s][0] + (i[0] - t.o[s][0]) * -r, l = t.o[s][1] + (i[1] - t.o[s][1]) * -r, p = t.i[s][0] + (i[0] - t.i[s][0]) * -r, f = t.i[s][1] + (i[1] - t.i[s][1]) * -r, c.setTripleAt(n, o, h, l, p, f, s);
            return c;
        }, PuckerAndBloatModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amount.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var TransformPropertyFactory = function() {
            var t = [
                0,
                0
            ];
            function e(t, e, r) {
                if (this.elem = t, this.frameId = -1, this.propType = "transform", this.data = e, this.v = new Matrix, this.pre = new Matrix, this.appliedTransformations = 0, this.initDynamicPropertyContainer(r || t), e.p && e.p.s ? (this.px = PropertyFactory.getProp(t, e.p.x, 0, 0, this), this.py = PropertyFactory.getProp(t, e.p.y, 0, 0, this), e.p.z && (this.pz = PropertyFactory.getProp(t, e.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(t, e.p || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), e.rx) {
                    if (this.rx = PropertyFactory.getProp(t, e.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(t, e.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(t, e.rz, 0, degToRads, this), e.or.k[0].ti) {
                        var i, a = e.or.k.length;
                        for(i = 0; i < a; i += 1)e.or.k[i].to = null, e.or.k[i].ti = null;
                    }
                    this.or = PropertyFactory.getProp(t, e.or, 1, degToRads, this), this.or.sh = !0;
                } else this.r = PropertyFactory.getProp(t, e.r || {
                    k: 0
                }, 0, degToRads, this);
                e.sk && (this.sk = PropertyFactory.getProp(t, e.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(t, e.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(t, e.a || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s || {
                    k: [
                        100,
                        100,
                        100
                    ]
                }, 1, .01, this), e.o ? this.o = PropertyFactory.getProp(t, e.o, 0, .01, t) : this.o = {
                    _mdf: !1,
                    v: 1
                }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
            }
            return e.prototype = {
                applyToMatrix: function(t) {
                    var e = this._mdf;
                    this.iterateDynamicProperties(), this._mdf = this._mdf || e, this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                },
                getValue: function(e) {
                    if (this.elem.globalData.frameId !== this.frameId) {
                        if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || e) {
                            var r;
                            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                                var i, a;
                                if (r = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (i = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / r, 0), a = this.p.getValueAtTime(this.p.keyframes[0].t / r, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (i = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / r, 0), a = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / r, 0)) : (i = this.p.pv, a = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / r, this.p.offsetTime));
                                else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                    i = [], a = [];
                                    var s = this.px, n = this.py;
                                    s._caching.lastFrame + s.offsetTime <= s.keyframes[0].t ? (i[0] = s.getValueAtTime((s.keyframes[0].t + .01) / r, 0), i[1] = n.getValueAtTime((n.keyframes[0].t + .01) / r, 0), a[0] = s.getValueAtTime(s.keyframes[0].t / r, 0), a[1] = n.getValueAtTime(n.keyframes[0].t / r, 0)) : s._caching.lastFrame + s.offsetTime >= s.keyframes[s.keyframes.length - 1].t ? (i[0] = s.getValueAtTime(s.keyframes[s.keyframes.length - 1].t / r, 0), i[1] = n.getValueAtTime(n.keyframes[n.keyframes.length - 1].t / r, 0), a[0] = s.getValueAtTime((s.keyframes[s.keyframes.length - 1].t - .01) / r, 0), a[1] = n.getValueAtTime((n.keyframes[n.keyframes.length - 1].t - .01) / r, 0)) : (i = [
                                        s.pv,
                                        n.pv
                                    ], a[0] = s.getValueAtTime((s._caching.lastFrame + s.offsetTime - .01) / r, s.offsetTime), a[1] = n.getValueAtTime((n._caching.lastFrame + n.offsetTime - .01) / r, n.offsetTime));
                                } else i = a = t;
                                this.v.rotate(-Math.atan2(i[1] - a[1], i[0] - a[0]));
                            }
                            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                        }
                        this.frameId = this.elem.globalData.frameId;
                    }
                },
                precalculateMatrix: function() {
                    if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
                        if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
                            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
                        }
                        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
                    }
                },
                autoOrient: function() {}
            }, extendPrototype([
                DynamicPropertyContainer
            ], e), e.prototype.addDynamicProperty = function(t) {
                this._addDynamicProperty(t), this.elem.addDynamicProperty(t), this._isDirty = !0;
            }, e.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, {
                getTransformProperty: function(t, r, i) {
                    return new e(t, r, i);
                }
            };
        }();
        function RepeaterModifier() {}
        function RoundCornersModifier() {}
        function floatEqual(t, e) {
            return 1e5 * Math.abs(t - e) <= Math.min(Math.abs(t), Math.abs(e));
        }
        function floatZero(t) {
            return Math.abs(t) <= 1e-5;
        }
        function lerp(t, e, r) {
            return t * (1 - r) + e * r;
        }
        function lerpPoint(t, e, r) {
            return [
                lerp(t[0], e[0], r),
                lerp(t[1], e[1], r)
            ];
        }
        function quadRoots(t, e, r) {
            if (0 === t) return [];
            var i = e * e - 4 * t * r;
            if (i < 0) return [];
            var a = -e / (2 * t);
            if (0 === i) return [
                a
            ];
            var s = Math.sqrt(i) / (2 * t);
            return [
                a - s,
                a + s
            ];
        }
        function polynomialCoefficients(t, e, r, i) {
            return [
                3 * e - t - 3 * r + i,
                3 * t - 6 * e + 3 * r,
                -3 * t + 3 * e,
                t
            ];
        }
        function singlePoint(t) {
            return new PolynomialBezier(t, t, t, t, !1);
        }
        function PolynomialBezier(t, e, r, i, a) {
            a && pointEqual(t, e) && (e = lerpPoint(t, i, 1 / 3)), a && pointEqual(r, i) && (r = lerpPoint(t, i, 2 / 3));
            var s = polynomialCoefficients(t[0], e[0], r[0], i[0]), n = polynomialCoefficients(t[1], e[1], r[1], i[1]);
            this.a = [
                s[0],
                n[0]
            ], this.b = [
                s[1],
                n[1]
            ], this.c = [
                s[2],
                n[2]
            ], this.d = [
                s[3],
                n[3]
            ], this.points = [
                t,
                e,
                r,
                i
            ];
        }
        function extrema(t, e) {
            var r = t.points[0][e], i = t.points[t.points.length - 1][e];
            if (r > i) {
                var a = i;
                i = r, r = a;
            }
            for(var s = quadRoots(3 * t.a[e], 2 * t.b[e], t.c[e]), n = 0; n < s.length; n += 1)if (s[n] > 0 && s[n] < 1) {
                var o = t.point(s[n])[e];
                o < r ? r = o : o > i && (i = o);
            }
            return {
                min: r,
                max: i
            };
        }
        function intersectData(t, e, r) {
            var i = t.boundingBox();
            return {
                cx: i.cx,
                cy: i.cy,
                width: i.width,
                height: i.height,
                bez: t,
                t: (e + r) / 2,
                t1: e,
                t2: r
            };
        }
        function splitData(t) {
            var e = t.bez.split(.5);
            return [
                intersectData(e[0], t.t1, t.t),
                intersectData(e[1], t.t, t.t2)
            ];
        }
        function boxIntersect(t, e) {
            return 2 * Math.abs(t.cx - e.cx) < t.width + e.width && 2 * Math.abs(t.cy - e.cy) < t.height + e.height;
        }
        function intersectsImpl(t, e, r, i, a, s) {
            if (boxIntersect(t, e)) {
                if (r >= s || t.width <= i && t.height <= i && e.width <= i && e.height <= i) a.push([
                    t.t,
                    e.t
                ]);
                else {
                    var n = splitData(t), o = splitData(e);
                    intersectsImpl(n[0], o[0], r + 1, i, a, s), intersectsImpl(n[0], o[1], r + 1, i, a, s), intersectsImpl(n[1], o[0], r + 1, i, a, s), intersectsImpl(n[1], o[1], r + 1, i, a, s);
                }
            }
        }
        function crossProduct(t, e) {
            return [
                t[1] * e[2] - t[2] * e[1],
                t[2] * e[0] - t[0] * e[2],
                t[0] * e[1] - t[1] * e[0]
            ];
        }
        function lineIntersection(t, e, r, i) {
            var a = [
                t[0],
                t[1],
                1
            ], s = [
                e[0],
                e[1],
                1
            ], n = [
                r[0],
                r[1],
                1
            ], o = [
                i[0],
                i[1],
                1
            ], h = crossProduct(crossProduct(a, s), crossProduct(n, o));
            return floatZero(h[2]) ? null : [
                h[0] / h[2],
                h[1] / h[2]
            ];
        }
        function polarOffset(t, e, r) {
            return [
                t[0] + Math.cos(e) * r,
                t[1] - Math.sin(e) * r
            ];
        }
        function pointDistance(t, e) {
            return Math.hypot(t[0] - e[0], t[1] - e[1]);
        }
        function pointEqual(t, e) {
            return floatEqual(t[0], e[0]) && floatEqual(t[1], e[1]);
        }
        function ZigZagModifier() {}
        function setPoint(t, e, r, i, a, s, n) {
            var o = r - Math.PI / 2, h = r + Math.PI / 2, l = e[0] + Math.cos(r) * i * a, p = e[1] - Math.sin(r) * i * a;
            t.setTripleAt(l, p, l + Math.cos(o) * s, p - Math.sin(o) * s, l + Math.cos(h) * n, p - Math.sin(h) * n, t.length());
        }
        function getPerpendicularVector(t, e) {
            var r = [
                e[0] - t[0],
                e[1] - t[1]
            ], i = .5 * -Math.PI;
            return [
                Math.cos(i) * r[0] - Math.sin(i) * r[1],
                Math.sin(i) * r[0] + Math.cos(i) * r[1]
            ];
        }
        function getProjectingAngle(t, e) {
            var r = 0 === e ? t.length() - 1 : e - 1, i = (e + 1) % t.length(), a = getPerpendicularVector(t.v[r], t.v[i]);
            return Math.atan2(0, 1) - Math.atan2(a[1], a[0]);
        }
        function zigZagCorner(t, e, r, i, a, s, n) {
            var o = getProjectingAngle(e, r), h = e.v[r % e._length], l = e.v[0 === r ? e._length - 1 : r - 1], p = e.v[(r + 1) % e._length], f = 2 === s ? Math.sqrt(Math.pow(h[0] - l[0], 2) + Math.pow(h[1] - l[1], 2)) : 0, c = 2 === s ? Math.sqrt(Math.pow(h[0] - p[0], 2) + Math.pow(h[1] - p[1], 2)) : 0;
            setPoint(t, e.v[r % e._length], o, n, i, c / (2 * (a + 1)), f / (2 * (a + 1)), s);
        }
        function zigZagSegment(t, e, r, i, a, s) {
            for(var n = 0; n < i; n += 1){
                var o = (n + 1) / (i + 1), h = 2 === a ? Math.sqrt(Math.pow(e.points[3][0] - e.points[0][0], 2) + Math.pow(e.points[3][1] - e.points[0][1], 2)) : 0, l = e.normalAngle(o);
                setPoint(t, e.point(o), l, s, r, h / (2 * (i + 1)), h / (2 * (i + 1)), a), s = -s;
            }
            return s;
        }
        function linearOffset(t, e, r) {
            var i = Math.atan2(e[0] - t[0], e[1] - t[1]);
            return [
                polarOffset(t, i, r),
                polarOffset(e, i, r)
            ];
        }
        function offsetSegment(t, e) {
            var r, i, a, s, n, o, h;
            r = (h = linearOffset(t.points[0], t.points[1], e))[0], i = h[1], a = (h = linearOffset(t.points[1], t.points[2], e))[0], s = h[1], n = (h = linearOffset(t.points[2], t.points[3], e))[0], o = h[1];
            var l = lineIntersection(r, i, a, s);
            null === l && (l = i);
            var p = lineIntersection(n, o, a, s);
            return null === p && (p = n), new PolynomialBezier(r, l, p, o);
        }
        function joinLines(t, e, r, i, a) {
            var s = e.points[3], n = r.points[0];
            if (3 === i) return s;
            if (pointEqual(s, n)) return s;
            if (2 === i) {
                var o = -e.tangentAngle(1), h = -r.tangentAngle(0) + Math.PI, l = lineIntersection(s, polarOffset(s, o + Math.PI / 2, 100), n, polarOffset(n, o + Math.PI / 2, 100)), p = l ? pointDistance(l, s) : pointDistance(s, n) / 2, f = polarOffset(s, o, 2 * p * roundCorner);
                return t.setXYAt(f[0], f[1], "o", t.length() - 1), f = polarOffset(n, h, 2 * p * roundCorner), t.setTripleAt(n[0], n[1], n[0], n[1], f[0], f[1], t.length()), n;
            }
            var c = lineIntersection(pointEqual(s, e.points[2]) ? e.points[0] : e.points[2], s, n, pointEqual(n, r.points[1]) ? r.points[3] : r.points[1]);
            return c && pointDistance(c, s) < a ? (t.setTripleAt(c[0], c[1], c[0], c[1], c[0], c[1], t.length()), c) : s;
        }
        function getIntersection(t, e) {
            var r = t.intersections(e);
            return r.length && floatEqual(r[0][0], 1) && r.shift(), r.length ? r[0] : null;
        }
        function pruneSegmentIntersection(t, e) {
            var r = t.slice(), i = e.slice(), a = getIntersection(t[t.length - 1], e[0]);
            return a && (r[t.length - 1] = t[t.length - 1].split(a[0])[0], i[0] = e[0].split(a[1])[1]), t.length > 1 && e.length > 1 && (a = getIntersection(t[0], e[e.length - 1])) ? [
                [
                    t[0].split(a[0])[0]
                ],
                [
                    e[e.length - 1].split(a[1])[1]
                ]
            ] : [
                r,
                i
            ];
        }
        function pruneIntersections(t) {
            for(var e, r = 1; r < t.length; r += 1)e = pruneSegmentIntersection(t[r - 1], t[r]), t[r - 1] = e[0], t[r] = e[1];
            return t.length > 1 && (e = pruneSegmentIntersection(t[t.length - 1], t[0]), t[t.length - 1] = e[0], t[0] = e[1]), t;
        }
        function offsetSegmentSplit(t, e) {
            var r, i, a, s, n = t.inflectionPoints();
            if (0 === n.length) return [
                offsetSegment(t, e)
            ];
            if (1 === n.length || floatEqual(n[1], 1)) return r = (a = t.split(n[0]))[0], i = a[1], [
                offsetSegment(r, e),
                offsetSegment(i, e)
            ];
            r = (a = t.split(n[0]))[0];
            var o = (n[1] - n[0]) / (1 - n[0]);
            return s = (a = a[1].split(o))[0], i = a[1], [
                offsetSegment(r, e),
                offsetSegment(s, e),
                offsetSegment(i, e)
            ];
        }
        function OffsetPathModifier() {}
        function getFontProperties(t) {
            for(var e = t.fStyle ? t.fStyle.split(" ") : [], r = "normal", i = "normal", a = e.length, s = 0; s < a; s += 1)switch(e[s].toLowerCase()){
                case "italic":
                    i = "italic";
                    break;
                case "bold":
                    r = "700";
                    break;
                case "black":
                    r = "900";
                    break;
                case "medium":
                    r = "500";
                    break;
                case "regular":
                case "normal":
                    r = "400";
                    break;
                case "light":
                case "thin":
                    r = "200";
            }
            return {
                style: i,
                weight: t.fWeight || r
            };
        }
        extendPrototype([
            ShapeModifier
        ], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t, e.c, 0, null, this), this.o = PropertyFactory.getProp(t, e.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t, e.tr, this), this.so = PropertyFactory.getProp(t, e.tr.so, 0, .01, this), this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, .01, this), this.data = e, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix, this.rMatrix = new Matrix, this.sMatrix = new Matrix, this.tMatrix = new Matrix, this.matrix = new Matrix;
        }, RepeaterModifier.prototype.applyTransforms = function(t, e, r, i, a, s) {
            var n = s ? -1 : 1, o = i.s.v[0] + (1 - i.s.v[0]) * (1 - a), h = i.s.v[1] + (1 - i.s.v[1]) * (1 - a);
            t.translate(i.p.v[0] * n * a, i.p.v[1] * n * a, i.p.v[2]), e.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), e.rotate(-i.r.v * n * a), e.translate(i.a.v[0], i.a.v[1], i.a.v[2]), r.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), r.scale(s ? 1 / o : o, s ? 1 / h : h), r.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
        }, RepeaterModifier.prototype.init = function(t, e, r, i) {
            for(this.elem = t, this.arr = e, this.pos = r, this.elemsData = i, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[r]); r > 0;)r -= 1, this._elements.unshift(e[r]);
            this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, RepeaterModifier.prototype.resetElements = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e]._processed = !1, "gr" === t[e].ty && this.resetElements(t[e].it);
        }, RepeaterModifier.prototype.cloneElements = function(t) {
            var e = JSON.parse(JSON.stringify(t));
            return this.resetElements(e), e;
        }, RepeaterModifier.prototype.changeGroupRender = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)t[r]._render = e, "gr" === t[r].ty && this.changeGroupRender(t[r].it, e);
        }, RepeaterModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n = !1;
            if (this._mdf || t) {
                var o, h = Math.ceil(this.c.v);
                if (this._groups.length < h) {
                    for(; this._groups.length < h;){
                        var l = {
                            it: this.cloneElements(this._elements),
                            ty: "gr"
                        };
                        l.it.push({
                            a: {
                                a: 0,
                                ix: 1,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            nm: "Transform",
                            o: {
                                a: 0,
                                ix: 7,
                                k: 100
                            },
                            p: {
                                a: 0,
                                ix: 2,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            r: {
                                a: 1,
                                ix: 6,
                                k: [
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 0
                                    },
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 1
                                    }
                                ]
                            },
                            s: {
                                a: 0,
                                ix: 3,
                                k: [
                                    100,
                                    100
                                ]
                            },
                            sa: {
                                a: 0,
                                ix: 5,
                                k: 0
                            },
                            sk: {
                                a: 0,
                                ix: 4,
                                k: 0
                            },
                            ty: "tr"
                        }), this.arr.splice(0, 0, l), this._groups.splice(0, 0, l), this._currentCopies += 1;
                    }
                    this.elem.reloadShapes(), n = !0;
                }
                for(s = 0, i = 0; i <= this._groups.length - 1; i += 1){
                    if (o = s < h, this._groups[i]._render = o, this.changeGroupRender(this._groups[i].it, o), !o) {
                        var p = this.elemsData[i].it, f = p[p.length - 1];
                        0 !== f.transform.op.v ? (f.transform.op._mdf = !0, f.transform.op.v = 0) : f.transform.op._mdf = !1;
                    }
                    s += 1;
                }
                this._currentCopies = h;
                var c = this.o.v, m = c % 1, d = c > 0 ? Math.floor(c) : Math.ceil(c), u = this.pMatrix.props, y = this.rMatrix.props, g = this.sMatrix.props;
                this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                var v, b, x = 0;
                if (c > 0) {
                    for(; x < d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), x += 1;
                    m && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, m, !1), x += m);
                } else if (c < 0) {
                    for(; x > d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), x -= 1;
                    m && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -m, !0), x -= m);
                }
                for(i = 1 === this.data.m ? 0 : this._currentCopies - 1, a = 1 === this.data.m ? 1 : -1, s = this._currentCopies; s;){
                    if (b = (r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props).length, e[e.length - 1].transform.mProps._mdf = !0, e[e.length - 1].transform.op._mdf = !0, e[e.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1)), 0 !== x) {
                        for((0 !== i && 1 === a || i !== this._currentCopies - 1 && -1 === a) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]), this.matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]), this.matrix.transform(u[0], u[1], u[2], u[3], u[4], u[5], u[6], u[7], u[8], u[9], u[10], u[11], u[12], u[13], u[14], u[15]), v = 0; v < b; v += 1)r[v] = this.matrix.props[v];
                        this.matrix.reset();
                    } else for(this.matrix.reset(), v = 0; v < b; v += 1)r[v] = this.matrix.props[v];
                    x += 1, s -= 1, i += a;
                }
            } else for(s = this._currentCopies, i = 0, a = 1; s;)r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props, e[e.length - 1].transform.mProps._mdf = !1, e[e.length - 1].transform.op._mdf = !1, s -= 1, i += a;
            return n;
        }, RepeaterModifier.prototype.addShape = function() {}, extendPrototype([
            ShapeModifier
        ], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t, e.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
        }, RoundCornersModifier.prototype.processPath = function(t, e) {
            var r, i = shapePool.newElement();
            i.c = t.c;
            var a, s, n, o, h, l, p, f, c, m, d, u, y = t._length, g = 0;
            for(r = 0; r < y; r += 1)a = t.v[r], n = t.o[r], s = t.i[r], a[0] === n[0] && a[1] === n[1] && a[0] === s[0] && a[1] === s[1] ? 0 !== r && r !== y - 1 || t.c ? (o = 0 === r ? t.v[y - 1] : t.v[r - 1], l = (h = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = d = a[0] + (o[0] - a[0]) * l, f = u = a[1] - (a[1] - o[1]) * l, c = p - (p - a[0]) * roundCorner, m = f - (f - a[1]) * roundCorner, i.setTripleAt(p, f, c, m, d, u, g), g += 1, o = r === y - 1 ? t.v[0] : t.v[r + 1], l = (h = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = c = a[0] + (o[0] - a[0]) * l, f = m = a[1] + (o[1] - a[1]) * l, d = p - (p - a[0]) * roundCorner, u = f - (f - a[1]) * roundCorner, i.setTripleAt(p, f, c, m, d, u, g), g += 1) : (i.setTripleAt(a[0], a[1], n[0], n[1], s[0], s[1], g), g += 1) : (i.setTripleAt(t.v[r][0], t.v[r][1], t.o[r][0], t.o[r][1], t.i[r][0], t.i[r][1], g), g += 1);
            return i;
        }, RoundCornersModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.rd.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, PolynomialBezier.prototype.point = function(t) {
            return [
                ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
                ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
            ];
        }, PolynomialBezier.prototype.derivative = function(t) {
            return [
                (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
                (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
            ];
        }, PolynomialBezier.prototype.tangentAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[1], e[0]);
        }, PolynomialBezier.prototype.normalAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[0], e[1]);
        }, PolynomialBezier.prototype.inflectionPoints = function() {
            var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
            if (floatZero(t)) return [];
            var e = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t, r = e * e - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t;
            if (r < 0) return [];
            var i = Math.sqrt(r);
            return floatZero(i) ? i > 0 && i < 1 ? [
                e
            ] : [] : [
                e - i,
                e + i
            ].filter(function(t) {
                return t > 0 && t < 1;
            });
        }, PolynomialBezier.prototype.split = function(t) {
            if (t <= 0) return [
                singlePoint(this.points[0]),
                this
            ];
            if (t >= 1) return [
                this,
                singlePoint(this.points[this.points.length - 1])
            ];
            var e = lerpPoint(this.points[0], this.points[1], t), r = lerpPoint(this.points[1], this.points[2], t), i = lerpPoint(this.points[2], this.points[3], t), a = lerpPoint(e, r, t), s = lerpPoint(r, i, t), n = lerpPoint(a, s, t);
            return [
                new PolynomialBezier(this.points[0], e, a, n, !0),
                new PolynomialBezier(n, s, i, this.points[3], !0)
            ];
        }, PolynomialBezier.prototype.bounds = function() {
            return {
                x: extrema(this, 0),
                y: extrema(this, 1)
            };
        }, PolynomialBezier.prototype.boundingBox = function() {
            var t = this.bounds();
            return {
                left: t.x.min,
                right: t.x.max,
                top: t.y.min,
                bottom: t.y.max,
                width: t.x.max - t.x.min,
                height: t.y.max - t.y.min,
                cx: (t.x.max + t.x.min) / 2,
                cy: (t.y.max + t.y.min) / 2
            };
        }, PolynomialBezier.prototype.intersections = function(t, e, r) {
            void 0 === e && (e = 2), void 0 === r && (r = 7);
            var i = [];
            return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, e, i, r), i;
        }, PolynomialBezier.shapeSegment = function(t, e) {
            var r = (e + 1) % t.length();
            return new PolynomialBezier(t.v[e], t.o[e], t.i[r], t.v[r], !0);
        }, PolynomialBezier.shapeSegmentInverted = function(t, e) {
            var r = (e + 1) % t.length();
            return new PolynomialBezier(t.v[r], t.i[r], t.o[e], t.v[e], !0);
        }, extendPrototype([
            ShapeModifier
        ], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t, e.s, 0, null, this), this.frequency = PropertyFactory.getProp(t, e.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t, e.pt, 0, null, this), this._isAnimated = 0 !== this.amplitude.effectsSequence.length || 0 !== this.frequency.effectsSequence.length || 0 !== this.pointsType.effectsSequence.length;
        }, ZigZagModifier.prototype.processPath = function(t, e, r, i) {
            var a = t._length, s = shapePool.newElement();
            if (s.c = t.c, t.c || (a -= 1), 0 === a) return s;
            var n = -1, o = PolynomialBezier.shapeSegment(t, 0);
            zigZagCorner(s, t, 0, e, r, i, n);
            for(var h = 0; h < a; h += 1)n = zigZagSegment(s, o, e, r, i, -n), o = h !== a - 1 || t.c ? PolynomialBezier.shapeSegment(t, (h + 1) % a) : null, zigZagCorner(s, t, h + 1, e, r, i, n);
            return s;
        }, ZigZagModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amplitude.v, l = Math.max(0, Math.round(this.frequency.v)), p = this.pointsType.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h, l, p));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, extendPrototype([
            ShapeModifier
        ], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t, e.ml, 0, null, this), this.lineJoin = e.lj, this._isAnimated = 0 !== this.amount.effectsSequence.length;
        }, OffsetPathModifier.prototype.processPath = function(t, e, r, i) {
            var a = shapePool.newElement();
            a.c = t.c;
            var s, n, o, h = t.length();
            t.c || (h -= 1);
            var l = [];
            for(s = 0; s < h; s += 1)o = PolynomialBezier.shapeSegment(t, s), l.push(offsetSegmentSplit(o, e));
            if (!t.c) for(s = h - 1; s >= 0; s -= 1)o = PolynomialBezier.shapeSegmentInverted(t, s), l.push(offsetSegmentSplit(o, e));
            l = pruneIntersections(l);
            var p = null, f = null;
            for(s = 0; s < l.length; s += 1){
                var c = l[s];
                for(f && (p = joinLines(a, f, c[0], r, i)), f = c[c.length - 1], n = 0; n < c.length; n += 1)o = c[n], p && pointEqual(o.points[0], p) ? a.setXYAt(o.points[1][0], o.points[1][1], "o", a.length() - 1) : a.setTripleAt(o.points[0][0], o.points[0][1], o.points[1][0], o.points[1][1], o.points[0][0], o.points[0][1], a.length()), a.setTripleAt(o.points[3][0], o.points[3][1], o.points[3][0], o.points[3][1], o.points[2][0], o.points[2][1], a.length()), p = o.points[3];
            }
            return l.length && joinLines(a, f, l[0][0], r, i), a;
        }, OffsetPathModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amount.v, l = this.miterLimit.v, p = this.lineJoin;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h, p, l));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var FontManager = function() {
            var t = {
                w: 0,
                size: 0,
                shapes: [],
                data: {
                    shapes: []
                }
            }, e = [];
            e = e.concat([
                2304,
                2305,
                2306,
                2307,
                2362,
                2363,
                2364,
                2364,
                2366,
                2367,
                2368,
                2369,
                2370,
                2371,
                2372,
                2373,
                2374,
                2375,
                2376,
                2377,
                2378,
                2379,
                2380,
                2381,
                2382,
                2383,
                2387,
                2388,
                2389,
                2390,
                2391,
                2402,
                2403
            ]);
            var r = [
                "d83cdffb",
                "d83cdffc",
                "d83cdffd",
                "d83cdffe",
                "d83cdfff"
            ];
            function i(t, e) {
                var r = createTag("span");
                r.setAttribute("aria-hidden", !0), r.style.fontFamily = e;
                var i = createTag("span");
                i.innerText = "giItT1WQy@!-/#", r.style.position = "absolute", r.style.left = "-10000px", r.style.top = "-10000px", r.style.fontSize = "300px", r.style.fontVariant = "normal", r.style.fontStyle = "normal", r.style.fontWeight = "normal", r.style.letterSpacing = "0", r.appendChild(i), document.body.appendChild(r);
                var a = i.offsetWidth;
                return i.style.fontFamily = function(t) {
                    var e, r = t.split(","), i = r.length, a = [];
                    for(e = 0; e < i; e += 1)"sans-serif" !== r[e] && "monospace" !== r[e] && a.push(r[e]);
                    return a.join(",");
                }(t) + ", " + e, {
                    node: i,
                    w: a,
                    parent: r
                };
            }
            function a(t, e) {
                var r, i = document.body && e ? "svg" : "canvas", a = getFontProperties(t);
                if ("svg" === i) {
                    var s = createNS("text");
                    s.style.fontSize = "100px", s.setAttribute("font-family", t.fFamily), s.setAttribute("font-style", a.style), s.setAttribute("font-weight", a.weight), s.textContent = "1", t.fClass ? (s.style.fontFamily = "inherit", s.setAttribute("class", t.fClass)) : s.style.fontFamily = t.fFamily, e.appendChild(s), r = s;
                } else {
                    var n = new OffscreenCanvas(500, 500).getContext("2d");
                    n.font = a.style + " " + a.weight + " 100px " + t.fFamily, r = n;
                }
                return {
                    measureText: function(t) {
                        return "svg" === i ? (r.textContent = t, r.getComputedTextLength()) : r.measureText(t).width;
                    }
                };
            }
            function s(t) {
                var e = 0, r = t.charCodeAt(0);
                if (r >= 55296 && r <= 56319) {
                    var i = t.charCodeAt(1);
                    i >= 56320 && i <= 57343 && (e = 1024 * (r - 55296) + i - 56320 + 65536);
                }
                return e;
            }
            function n(t) {
                var e = s(t);
                return e >= 127462 && e <= 127487;
            }
            var o = function() {
                this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
            };
            return o.isModifier = function(t, e) {
                var i = t.toString(16) + e.toString(16);
                return -1 !== r.indexOf(i);
            }, o.isZeroWidthJoiner = function(t) {
                return 8205 === t;
            }, o.isFlagEmoji = function(t) {
                return n(t.substr(0, 2)) && n(t.substr(2, 2));
            }, o.isRegionalCode = n, o.isCombinedCharacter = function(t) {
                return -1 !== e.indexOf(t);
            }, o.isRegionalFlag = function(t, e) {
                var r = s(t.substr(e, 2));
                if (127988 !== r) return !1;
                var i = 0;
                for(e += 2; i < 5;){
                    if ((r = s(t.substr(e, 2))) < 917601 || r > 917626) return !1;
                    i += 1, e += 2;
                }
                return 917631 === s(t.substr(e, 2));
            }, o.isVariationSelector = function(t) {
                return 65039 === t;
            }, o.BLACK_FLAG_CODE_POINT = 127988, o.prototype = {
                addChars: function(t) {
                    if (t) {
                        var e;
                        this.chars || (this.chars = []);
                        var r, i, a = t.length, s = this.chars.length;
                        for(e = 0; e < a; e += 1){
                            for(r = 0, i = !1; r < s;)this.chars[r].style === t[e].style && this.chars[r].fFamily === t[e].fFamily && this.chars[r].ch === t[e].ch && (i = !0), r += 1;
                            i || (this.chars.push(t[e]), s += 1);
                        }
                    }
                },
                addFonts: function(t, e) {
                    if (t) {
                        if (this.chars) return this.isLoaded = !0, void (this.fonts = t.list);
                        if (!document.body) return this.isLoaded = !0, t.list.forEach(function(t) {
                            t.helper = a(t), t.cache = {};
                        }), void (this.fonts = t.list);
                        var r, s = t.list, n = s.length, o = n;
                        for(r = 0; r < n; r += 1){
                            var h, l, p = !0;
                            if (s[r].loaded = !1, s[r].monoCase = i(s[r].fFamily, "monospace"), s[r].sansCase = i(s[r].fFamily, "sans-serif"), s[r].fPath) {
                                if ("p" === s[r].fOrigin || 3 === s[r].origin) {
                                    if ((h = document.querySelectorAll('style[f-forigin="p"][f-family="' + s[r].fFamily + '"], style[f-origin="3"][f-family="' + s[r].fFamily + '"]')).length > 0 && (p = !1), p) {
                                        var f = createTag("style");
                                        f.setAttribute("f-forigin", s[r].fOrigin), f.setAttribute("f-origin", s[r].origin), f.setAttribute("f-family", s[r].fFamily), f.type = "text/css", f.innerText = "@font-face {font-family: " + s[r].fFamily + "; font-style: normal; src: url('" + s[r].fPath + "');}", e.appendChild(f);
                                    }
                                } else if ("g" === s[r].fOrigin || 1 === s[r].origin) {
                                    for(h = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), l = 0; l < h.length; l += 1)-1 !== h[l].href.indexOf(s[r].fPath) && (p = !1);
                                    if (p) {
                                        var c = createTag("link");
                                        c.setAttribute("f-forigin", s[r].fOrigin), c.setAttribute("f-origin", s[r].origin), c.type = "text/css", c.rel = "stylesheet", c.href = s[r].fPath, document.body.appendChild(c);
                                    }
                                } else if ("t" === s[r].fOrigin || 2 === s[r].origin) {
                                    for(h = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), l = 0; l < h.length; l += 1)s[r].fPath === h[l].src && (p = !1);
                                    if (p) {
                                        var m = createTag("link");
                                        m.setAttribute("f-forigin", s[r].fOrigin), m.setAttribute("f-origin", s[r].origin), m.setAttribute("rel", "stylesheet"), m.setAttribute("href", s[r].fPath), e.appendChild(m);
                                    }
                                }
                            } else s[r].loaded = !0, o -= 1;
                            s[r].helper = a(s[r], e), s[r].cache = {}, this.fonts.push(s[r]);
                        }
                        0 === o ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
                    } else this.isLoaded = !0;
                },
                getCharData: function(e, r, i) {
                    for(var a = 0, s = this.chars.length; a < s;){
                        if (this.chars[a].ch === e && this.chars[a].style === r && this.chars[a].fFamily === i) return this.chars[a];
                        a += 1;
                    }
                    return ("string" == typeof e && 13 !== e.charCodeAt(0) || !e) && console && console.warn && !this._warned && (this._warned = !0), t;
                },
                getFontByName: function(t) {
                    for(var e = 0, r = this.fonts.length; e < r;){
                        if (this.fonts[e].fName === t) return this.fonts[e];
                        e += 1;
                    }
                    return this.fonts[0];
                },
                measureText: function(t, e, r) {
                    var i = this.getFontByName(e), a = t;
                    if (!i.cache[a]) {
                        var s = i.helper;
                        if (" " === t) {
                            var n = s.measureText("|" + t + "|"), o = s.measureText("||");
                            i.cache[a] = (n - o) / 100;
                        } else i.cache[a] = s.measureText(t) / 100;
                    }
                    return i.cache[a] * r;
                },
                checkLoadedFonts: function() {
                    var t, e, r, i = this.fonts.length, a = i;
                    for(t = 0; t < i; t += 1)this.fonts[t].loaded ? a -= 1 : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin ? this.fonts[t].loaded = !0 : (e = this.fonts[t].monoCase.node, r = this.fonts[t].monoCase.w, e.offsetWidth !== r ? (a -= 1, this.fonts[t].loaded = !0) : (e = this.fonts[t].sansCase.node, r = this.fonts[t].sansCase.w, e.offsetWidth !== r && (a -= 1, this.fonts[t].loaded = !0)), this.fonts[t].loaded && (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
                    0 !== a && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
                },
                setIsLoaded: function() {
                    this.isLoaded = !0;
                }
            }, o;
        }();
        function SlotManager(t) {
            this.animationData = t;
        }
        function slotFactory(t) {
            return new SlotManager(t);
        }
        function RenderableElement() {}
        SlotManager.prototype.getProp = function(t) {
            return this.animationData.slots && this.animationData.slots[t.sid] ? Object.assign(t, this.animationData.slots[t.sid].p) : t;
        }, RenderableElement.prototype = {
            initRenderable: function() {
                this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
            },
            addRenderableComponent: function(t) {
                -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
            },
            removeRenderableComponent: function(t) {
                -1 !== this.renderableComponents.indexOf(t) && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
            },
            prepareRenderableFrame: function(t) {
                this.checkLayerLimits(t);
            },
            checkTransparency: function() {
                this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
            },
            checkLayerLimits: function(t) {
                this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
            },
            renderRenderable: function() {
                var t, e = this.renderableComponents.length;
                for(t = 0; t < e; t += 1)this.renderableComponents[t].renderFrame(this._isFirstFrame);
            },
            sourceRectAtTime: function() {
                return {
                    top: 0,
                    left: 0,
                    width: 100,
                    height: 100
                };
            },
            getLayerSize: function() {
                return 5 === this.data.ty ? {
                    w: this.data.textData.width,
                    h: this.data.textData.height
                } : {
                    w: this.data.width,
                    h: this.data.height
                };
            }
        };
        var getBlendMode = (blendModeEnums = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        }, function(t) {
            return blendModeEnums[t] || "";
        }), blendModeEnums;
        function SliderEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function AngleEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function ColorEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
        }
        function PointEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
        }
        function LayerIndexEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function MaskIndexEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function CheckboxEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function NoValueEffect() {
            this.p = {};
        }
        function EffectsManager(t, e) {
            var r, i = t.ef || [];
            this.effectElements = [];
            var a, s = i.length;
            for(r = 0; r < s; r += 1)a = new GroupEffect(i[r], e), this.effectElements.push(a);
        }
        function GroupEffect(t, e) {
            this.init(t, e);
        }
        function BaseElement() {}
        function FrameElement() {}
        function FootageElement(t, e, r) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.footageData = e.imageLoader.getAsset(this.assetData), this.initBaseData(t, e, r);
        }
        function AudioElement(t, e, r) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.initBaseData(t, e, r), this._isPlaying = !1, this._canPlay = !1;
            var i = this.globalData.getAssetsPath(this.assetData);
            this.audio = this.globalData.audioController.createAudio(i), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            }, this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : {
                k: [
                    100
                ]
            }, 1, .01, this);
        }
        function BaseRenderer() {}
        extendPrototype([
            DynamicPropertyContainer
        ], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t, e) {
            var r;
            this.data = t, this.effectElements = [], this.initDynamicPropertyContainer(e);
            var i, a = this.data.ef.length, s = this.data.ef;
            for(r = 0; r < a; r += 1){
                switch(i = null, s[r].ty){
                    case 0:
                        i = new SliderEffect(s[r], e, this);
                        break;
                    case 1:
                        i = new AngleEffect(s[r], e, this);
                        break;
                    case 2:
                        i = new ColorEffect(s[r], e, this);
                        break;
                    case 3:
                        i = new PointEffect(s[r], e, this);
                        break;
                    case 4:
                    case 7:
                        i = new CheckboxEffect(s[r], e, this);
                        break;
                    case 10:
                        i = new LayerIndexEffect(s[r], e, this);
                        break;
                    case 11:
                        i = new MaskIndexEffect(s[r], e, this);
                        break;
                    case 5:
                        i = new EffectsManager(s[r], e, this);
                        break;
                    default:
                        i = new NoValueEffect(s[r], e, this);
                }
                i && this.effectElements.push(i);
            }
        }, BaseElement.prototype = {
            checkMasks: function() {
                if (!this.data.hasMask) return !1;
                for(var t = 0, e = this.data.masksProperties.length; t < e;){
                    if ("n" !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl) return !0;
                    t += 1;
                }
                return !1;
            },
            initExpressions: function() {
                var t = getExpressionInterfaces();
                if (t) {
                    var e = t("layer"), r = t("effects"), i = t("shape"), a = t("text"), s = t("comp");
                    this.layerInterface = e(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                    var n = r.createEffectsInterface(this, this.layerInterface);
                    this.layerInterface.registerEffectsInterface(n), 0 === this.data.ty || this.data.xt ? this.compInterface = s(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = i(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = a(this), this.layerInterface.text = this.layerInterface.textInterface);
                }
            },
            setBlendMode: function() {
                var t = getBlendMode(this.data.bm);
                (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
            },
            initBaseData: function(t, e, r) {
                this.globalData = e, this.comp = r, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
            },
            getType: function() {
                return this.type;
            },
            sourceRectAtTime: function() {}
        }, FrameElement.prototype = {
            initFrame: function() {
                this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
            },
            prepareProperties: function(t, e) {
                var r, i = this.dynamicProperties.length;
                for(r = 0; r < i; r += 1)(e || this._isParent && "transform" === this.dynamicProperties[r].propType) && (this.dynamicProperties[r].getValue(), this.dynamicProperties[r]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
            },
            addDynamicProperty: function(t) {
                -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
            }
        }, FootageElement.prototype.prepareFrame = function() {}, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], FootageElement), FootageElement.prototype.getBaseElement = function() {
            return null;
        }, FootageElement.prototype.renderFrame = function() {}, FootageElement.prototype.destroy = function() {}, FootageElement.prototype.initExpressions = function() {
            var t = getExpressionInterfaces();
            if (t) {
                var e = t("footage");
                this.layerInterface = e(this);
            }
        }, FootageElement.prototype.getFootageData = function() {
            return this.footageData;
        }, AudioElement.prototype.prepareFrame = function(t) {
            if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder) this._currentTime = t / this.data.sr;
            else {
                var e = this.tm.v;
                this._currentTime = e;
            }
            this._volume = this.lv.v[0];
            var r = this._volume * this._volumeMultiplier;
            this._previousVolume !== r && (this._previousVolume = r, this.audio.volume(r));
        }, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], AudioElement), AudioElement.prototype.renderFrame = function() {
            this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
        }, AudioElement.prototype.show = function() {}, AudioElement.prototype.hide = function() {
            this.audio.pause(), this._isPlaying = !1;
        }, AudioElement.prototype.pause = function() {
            this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
        }, AudioElement.prototype.resume = function() {
            this._canPlay = !0;
        }, AudioElement.prototype.setRate = function(t) {
            this.audio.rate(t);
        }, AudioElement.prototype.volume = function(t) {
            this._volumeMultiplier = t, this._previousVolume = t * this._volume, this.audio.volume(this._previousVolume);
        }, AudioElement.prototype.getBaseElement = function() {
            return null;
        }, AudioElement.prototype.destroy = function() {}, AudioElement.prototype.sourceRectAtTime = function() {}, AudioElement.prototype.initExpressions = function() {}, BaseRenderer.prototype.checkLayers = function(t) {
            var e, r, i = this.layers.length;
            for(this.completeLayers = !0, e = i - 1; e >= 0; e -= 1)this.elements[e] || (r = this.layers[e]).ip - r.st <= t - this.layers[e].st && r.op - r.st > t - this.layers[e].st && this.buildItem(e), this.completeLayers = !!this.elements[e] && this.completeLayers;
            this.checkPendingElements();
        }, BaseRenderer.prototype.createItem = function(t) {
            switch(t.ty){
                case 2:
                    return this.createImage(t);
                case 0:
                    return this.createComp(t);
                case 1:
                    return this.createSolid(t);
                case 3:
                    return this.createNull(t);
                case 4:
                    return this.createShape(t);
                case 5:
                    return this.createText(t);
                case 6:
                    return this.createAudio(t);
                case 13:
                    return this.createCamera(t);
                case 15:
                    return this.createFootage(t);
                default:
                    return this.createNull(t);
            }
        }, BaseRenderer.prototype.createCamera = function() {
            throw new Error("You're using a 3d camera. Try the html renderer.");
        }, BaseRenderer.prototype.createAudio = function(t) {
            return new AudioElement(t, this.globalData, this);
        }, BaseRenderer.prototype.createFootage = function(t) {
            return new FootageElement(t, this.globalData, this);
        }, BaseRenderer.prototype.buildAllItems = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.buildItem(t);
            this.checkPendingElements();
        }, BaseRenderer.prototype.includeLayers = function(t) {
            var e;
            this.completeLayers = !1;
            var r, i = t.length, a = this.layers.length;
            for(e = 0; e < i; e += 1)for(r = 0; r < a;){
                if (this.layers[r].id === t[e].id) {
                    this.layers[r] = t[e];
                    break;
                }
                r += 1;
            }
        }, BaseRenderer.prototype.setProjectInterface = function(t) {
            this.globalData.projectInterface = t;
        }, BaseRenderer.prototype.initItems = function() {
            this.globalData.progressiveLoad || this.buildAllItems();
        }, BaseRenderer.prototype.buildElementParenting = function(t, e, r) {
            for(var i = this.elements, a = this.layers, s = 0, n = a.length; s < n;)a[s].ind == e && (i[s] && !0 !== i[s] ? (r.push(i[s]), i[s].setAsParent(), void 0 !== a[s].parent ? this.buildElementParenting(t, a[s].parent, r) : t.setHierarchy(r)) : (this.buildItem(s), this.addPendingElement(t))), s += 1;
        }, BaseRenderer.prototype.addPendingElement = function(t) {
            this.pendingElements.push(t);
        }, BaseRenderer.prototype.searchExtraCompositions = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)if (t[e].xt) {
                var i = this.createComp(t[e]);
                i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
            }
        }, BaseRenderer.prototype.getElementById = function(t) {
            var e, r = this.elements.length;
            for(e = 0; e < r; e += 1)if (this.elements[e].data.ind === t) return this.elements[e];
            return null;
        }, BaseRenderer.prototype.getElementByPath = function(t) {
            var e, r = t.shift();
            if ("number" == typeof r) e = this.elements[r];
            else {
                var i, a = this.elements.length;
                for(i = 0; i < a; i += 1)if (this.elements[i].data.nm === r) {
                    e = this.elements[i];
                    break;
                }
            }
            return 0 === t.length ? e : e.getElementByPath(t);
        }, BaseRenderer.prototype.setupGlobalData = function(t, e) {
            this.globalData.fontManager = new FontManager, this.globalData.slotManager = slotFactory(t), this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, e), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = {
                w: t.w,
                h: t.h
            };
        };
        var effectTypes = {
            TRANSFORM_EFFECT: "transformEFfect"
        };
        function TransformElement() {}
        function MaskElement(t, e, r) {
            this.data = t, this.element = e, this.globalData = r, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
            var i, a, s = this.globalData.defs, n = this.masksProperties ? this.masksProperties.length : 0;
            this.viewData = createSizedArray(n), this.solidPath = "";
            var o, h, l, p, f, c, m = this.masksProperties, d = 0, u = [], y = createElementID(), g = "clipPath", v = "clip-path";
            for(i = 0; i < n; i += 1)if (("a" !== m[i].mode && "n" !== m[i].mode || m[i].inv || 100 !== m[i].o.k || m[i].o.x) && (g = "mask", v = "mask"), "s" !== m[i].mode && "i" !== m[i].mode || 0 !== d ? l = null : ((l = createNS("rect")).setAttribute("fill", "#ffffff"), l.setAttribute("width", this.element.comp.data.w || 0), l.setAttribute("height", this.element.comp.data.h || 0), u.push(l)), a = createNS("path"), "n" === m[i].mode) this.viewData[i] = {
                op: PropertyFactory.getProp(this.element, m[i].o, 0, .01, this.element),
                prop: ShapePropertyFactory.getShapeProp(this.element, m[i], 3),
                elem: a,
                lastPath: ""
            }, s.appendChild(a);
            else {
                var b;
                if (d += 1, a.setAttribute("fill", "s" === m[i].mode ? "#000000" : "#ffffff"), a.setAttribute("clip-rule", "nonzero"), 0 !== m[i].x.k ? (g = "mask", v = "mask", c = PropertyFactory.getProp(this.element, m[i].x, 0, null, this.element), b = createElementID(), (p = createNS("filter")).setAttribute("id", b), (f = createNS("feMorphology")).setAttribute("operator", "erode"), f.setAttribute("in", "SourceGraphic"), f.setAttribute("radius", "0"), p.appendChild(f), s.appendChild(p), a.setAttribute("stroke", "s" === m[i].mode ? "#000000" : "#ffffff")) : (f = null, c = null), this.storedData[i] = {
                    elem: a,
                    x: c,
                    expan: f,
                    lastPath: "",
                    lastOperator: "",
                    filterId: b,
                    lastRadius: 0
                }, "i" === m[i].mode) {
                    h = u.length;
                    var x = createNS("g");
                    for(o = 0; o < h; o += 1)x.appendChild(u[o]);
                    var E = createNS("mask");
                    E.setAttribute("mask-type", "alpha"), E.setAttribute("id", y + "_" + d), E.appendChild(a), s.appendChild(E), x.setAttribute("mask", "url(" + getLocationHref() + "#" + y + "_" + d + ")"), u.length = 0, u.push(x);
                } else u.push(a);
                m[i].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[i] = {
                    elem: a,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, m[i].o, 0, .01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, m[i], 3),
                    invRect: l
                }, this.viewData[i].prop.k || this.drawPath(m[i], this.viewData[i].prop.v, this.viewData[i]);
            }
            for(this.maskElement = createNS(g), n = u.length, i = 0; i < n; i += 1)this.maskElement.appendChild(u[i]);
            d > 0 && (this.maskElement.setAttribute("id", y), this.element.maskedElement.setAttribute(v, "url(" + getLocationHref() + "#" + y + ")"), s.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
        }
        TransformElement.prototype = {
            initTransform: function() {
                var t = new Matrix;
                this.finalTransform = {
                    mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                        o: 0
                    },
                    _matMdf: !1,
                    _localMatMdf: !1,
                    _opMdf: !1,
                    mat: t,
                    localMat: t,
                    localOpacity: 1
                }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
            },
            renderTransform: function() {
                if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
                    var t, e = this.finalTransform.mat, r = 0, i = this.hierarchy.length;
                    if (!this.finalTransform._matMdf) for(; r < i;){
                        if (this.hierarchy[r].finalTransform.mProp._mdf) {
                            this.finalTransform._matMdf = !0;
                            break;
                        }
                        r += 1;
                    }
                    if (this.finalTransform._matMdf) for(t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), r = 0; r < i; r += 1)e.multiply(this.hierarchy[r].finalTransform.mProp.v);
                }
                this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
            },
            renderLocalTransform: function() {
                if (this.localTransforms) {
                    var t = 0, e = this.localTransforms.length;
                    if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf) for(; t < e;)this.localTransforms[t]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[t]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), t += 1;
                    if (this.finalTransform._localMatMdf) {
                        var r = this.finalTransform.localMat;
                        for(this.localTransforms[0].matrix.clone(r), t = 1; t < e; t += 1){
                            var i = this.localTransforms[t].matrix;
                            r.multiply(i);
                        }
                        r.multiply(this.finalTransform.mat);
                    }
                    if (this.finalTransform._opMdf) {
                        var a = this.finalTransform.localOpacity;
                        for(t = 0; t < e; t += 1)a *= .01 * this.localTransforms[t].opacity;
                        this.finalTransform.localOpacity = a;
                    }
                }
            },
            searchEffectTransforms: function() {
                if (this.renderableEffectsManager) {
                    var t = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                    if (t.length) {
                        this.localTransforms = [], this.finalTransform.localMat = new Matrix;
                        var e = 0, r = t.length;
                        for(e = 0; e < r; e += 1)this.localTransforms.push(t[e]);
                    }
                }
            },
            globalToLocal: function(t) {
                var e = [];
                e.push(this.finalTransform);
                for(var r, i = !0, a = this.comp; i;)a.finalTransform ? (a.data.hasMask && e.splice(0, 0, a.finalTransform), a = a.comp) : i = !1;
                var s, n = e.length;
                for(r = 0; r < n; r += 1)s = e[r].mat.applyToPointArray(0, 0, 0), t = [
                    t[0] - s[0],
                    t[1] - s[1],
                    0
                ];
                return t;
            },
            mHelper: new Matrix
        }, MaskElement.prototype.getMaskProperty = function(t) {
            return this.viewData[t].prop;
        }, MaskElement.prototype.renderFrame = function(t) {
            var e, r = this.element.finalTransform.mat, i = this.masksProperties.length;
            for(e = 0; e < i; e += 1)if ((this.viewData[e].prop._mdf || t) && this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]), (this.viewData[e].op._mdf || t) && this.viewData[e].elem.setAttribute("fill-opacity", this.viewData[e].op.v), "n" !== this.masksProperties[e].mode && (this.viewData[e].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[e].invRect.setAttribute("transform", r.getInverseMatrix().to2dCSS()), this.storedData[e].x && (this.storedData[e].x._mdf || t))) {
                var a = this.storedData[e].expan;
                this.storedData[e].x.v < 0 ? ("erode" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "erode", this.storedData[e].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[e].filterId + ")")), a.setAttribute("radius", -this.storedData[e].x.v)) : ("dilate" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "dilate", this.storedData[e].elem.setAttribute("filter", null)), this.storedData[e].elem.setAttribute("stroke-width", 2 * this.storedData[e].x.v));
            }
        }, MaskElement.prototype.getMaskelement = function() {
            return this.maskElement;
        }, MaskElement.prototype.createLayerSolidPath = function() {
            var t = "M0,0 ";
            return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ";
        }, MaskElement.prototype.drawPath = function(t, e, r) {
            var i, a, s = " M" + e.v[0][0] + "," + e.v[0][1];
            for(a = e._length, i = 1; i < a; i += 1)s += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[i][0] + "," + e.i[i][1] + " " + e.v[i][0] + "," + e.v[i][1];
            if (e.c && a > 1 && (s += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), r.lastPath !== s) {
                var n = "";
                r.elem && (e.c && (n = t.inv ? this.solidPath + s : s), r.elem.setAttribute("d", n)), r.lastPath = s;
            }
        }, MaskElement.prototype.destroy = function() {
            this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
        };
        var filtersFactory = function() {
            var t = {};
            return t.createFilter = function(t, e) {
                var r = createNS("filter");
                r.setAttribute("id", t), !0 !== e && (r.setAttribute("filterUnits", "objectBoundingBox"), r.setAttribute("x", "0%"), r.setAttribute("y", "0%"), r.setAttribute("width", "100%"), r.setAttribute("height", "100%"));
                return r;
            }, t.createAlphaToLuminanceFilter = function() {
                var t = createNS("feColorMatrix");
                return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t;
            }, t;
        }(), featureSupport = function() {
            var t = {
                maskType: !0,
                svgLumaHidden: !0,
                offscreenCanvas: "undefined" != typeof OffscreenCanvas
            };
            return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1), t;
        }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
        function SVGEffects(t) {
            var e, r, i = "SourceGraphic", a = t.data.ef ? t.data.ef.length : 0, s = createElementID(), n = filtersFactory.createFilter(s, !0), o = 0;
            for(this.filters = [], e = 0; e < a; e += 1){
                r = null;
                var h = t.data.ef[e].ty;
                if (registeredEffects$1[h]) r = new registeredEffects$1[h].effect(n, t.effectsManager.effectElements[e], t, idPrefix + o, i), i = idPrefix + o, registeredEffects$1[h].countsAsEffect && (o += 1);
                r && this.filters.push(r);
            }
            o && (t.globalData.defs.appendChild(n), t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + s + ")")), this.filters.length && t.addRenderableComponent(this);
        }
        function registerEffect$1(t, e, r) {
            registeredEffects$1[t] = {
                effect: e,
                countsAsEffect: r
            };
        }
        function SVGBaseElement() {}
        function HierarchyElement() {}
        function RenderableDOMElement() {}
        function IImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.assetData && this.assetData.sid && (this.assetData = e.slotManager.getProp(this.assetData)), this.initElement(t, e, r), this.sourceRect = {
                top: 0,
                left: 0,
                width: this.assetData.w,
                height: this.assetData.h
            };
        }
        function ProcessedElement(t, e) {
            this.elem = t, this.pos = e;
        }
        function IShapeElement() {}
        SVGEffects.prototype.renderFrame = function(t) {
            var e, r = this.filters.length;
            for(e = 0; e < r; e += 1)this.filters[e].renderFrame(t);
        }, SVGEffects.prototype.getEffects = function(t) {
            var e, r = this.filters.length, i = [];
            for(e = 0; e < r; e += 1)this.filters[e].type === t && i.push(this.filters[e]);
            return i;
        }, SVGBaseElement.prototype = {
            initRendererElement: function() {
                this.layerElement = createNS("g");
            },
            createContainerElements: function() {
                this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
                var t = null;
                if (this.data.td) {
                    this.matteMasks = {};
                    var e = createNS("g");
                    e.setAttribute("id", this.layerId), e.appendChild(this.layerElement), t = e, this.globalData.defs.appendChild(e);
                } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
                if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
                    var r = createNS("clipPath"), i = createNS("path");
                    i.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                    var a = createElementID();
                    if (r.setAttribute("id", a), r.appendChild(i), this.globalData.defs.appendChild(r), this.checkMasks()) {
                        var s = createNS("g");
                        s.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), s.appendChild(this.layerElement), this.transformedElement = s, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
                    } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")");
                }
                0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
            },
            destroyBaseElement: function() {
                this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
            },
            getBaseElement: function() {
                return this.data.hd ? null : this.baseElement;
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
            },
            getMatte: function(t) {
                if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
                    var e, r, i, a, s = this.layerId + "_" + t;
                    if (1 === t || 3 === t) {
                        var n = createNS("mask");
                        n.setAttribute("id", s), n.setAttribute("mask-type", 3 === t ? "luminance" : "alpha"), (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), n.appendChild(i), this.globalData.defs.appendChild(n), featureSupport.maskType || 1 !== t || (n.setAttribute("mask-type", "luminance"), e = createElementID(), r = filtersFactory.createFilter(e), this.globalData.defs.appendChild(r), r.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (a = createNS("g")).appendChild(i), n.appendChild(a), a.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"));
                    } else if (2 === t) {
                        var o = createNS("mask");
                        o.setAttribute("id", s), o.setAttribute("mask-type", "alpha");
                        var h = createNS("g");
                        o.appendChild(h), e = createElementID(), r = filtersFactory.createFilter(e);
                        var l = createNS("feComponentTransfer");
                        l.setAttribute("in", "SourceGraphic"), r.appendChild(l);
                        var p = createNS("feFuncA");
                        p.setAttribute("type", "table"), p.setAttribute("tableValues", "1.0 0.0"), l.appendChild(p), this.globalData.defs.appendChild(r);
                        var f = createNS("rect");
                        f.setAttribute("width", this.comp.data.w), f.setAttribute("height", this.comp.data.h), f.setAttribute("x", "0"), f.setAttribute("y", "0"), f.setAttribute("fill", "#ffffff"), f.setAttribute("opacity", "0"), h.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"), h.appendChild(f), (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), h.appendChild(i), featureSupport.maskType || (o.setAttribute("mask-type", "luminance"), r.appendChild(filtersFactory.createAlphaToLuminanceFilter()), a = createNS("g"), h.appendChild(f), a.appendChild(this.layerElement), h.appendChild(a)), this.globalData.defs.appendChild(o);
                    }
                    this.matteMasks[t] = s;
                }
                return this.matteMasks[t];
            },
            setMatte: function(t) {
                this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
            }
        }, HierarchyElement.prototype = {
            initHierarchy: function() {
                this.hierarchy = [], this._isParent = !1, this.checkParenting();
            },
            setHierarchy: function(t) {
                this.hierarchy = t;
            },
            setAsParent: function() {
                this._isParent = !0;
            },
            checkParenting: function() {
                void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
            }
        }, extendPrototype([
            RenderableElement,
            createProxyFunction({
                initElement: function(t, e, r) {
                    this.initFrame(), this.initBaseData(t, e, r), this.initTransform(t, e, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
                },
                hide: function() {
                    this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
                },
                show: function() {
                    this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
                },
                renderFrame: function() {
                    this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                },
                renderInnerContent: function() {},
                prepareFrame: function(t) {
                    this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
                },
                destroy: function() {
                    this.innerElem = null, this.destroyBaseElement();
                }
            })
        ], RenderableDOMElement), extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], IImageElement), IImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData);
            this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
        }, IImageElement.prototype.sourceRectAtTime = function() {
            return this.sourceRect;
        }, IShapeElement.prototype = {
            addShapeToModifiers: function(t) {
                var e, r = this.shapeModifiers.length;
                for(e = 0; e < r; e += 1)this.shapeModifiers[e].addShape(t);
            },
            isShapeInAnimatedModifiers: function(t) {
                for(var e = this.shapeModifiers.length; 0 < e;)if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
                return !1;
            },
            renderModifiers: function() {
                if (this.shapeModifiers.length) {
                    var t, e = this.shapes.length;
                    for(t = 0; t < e; t += 1)this.shapes[t].sh.reset();
                    for(t = (e = this.shapeModifiers.length) - 1; t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1);
                }
            },
            searchProcessedElement: function(t) {
                for(var e = this.processedElements, r = 0, i = e.length; r < i;){
                    if (e[r].elem === t) return e[r].pos;
                    r += 1;
                }
                return 0;
            },
            addProcessedElement: function(t, e) {
                for(var r = this.processedElements, i = r.length; i;)if (r[i -= 1].elem === t) return void (r[i].pos = e);
                r.push(new ProcessedElement(t, e));
            },
            prepareFrame: function(t) {
                this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
            }
        };
        var lineCapEnum = {
            1: "butt",
            2: "round",
            3: "square"
        }, lineJoinEnum = {
            1: "miter",
            2: "round",
            3: "bevel"
        };
        function SVGShapeData(t, e, r) {
            this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = r, this.lvl = e, this._isAnimated = !!r.k;
            for(var i = 0, a = t.length; i < a;){
                if (t[i].mProps.dynamicProperties.length) {
                    this._isAnimated = !0;
                    break;
                }
                i += 1;
            }
        }
        function SVGStyleData(t, e) {
            this.data = t, this.type = t.ty, this.d = "", this.lvl = e, this._mdf = !1, this.closed = !0 === t.hd, this.pElem = createNS("path"), this.msElem = null;
        }
        function DashProperty(t, e, r, i) {
            var a;
            this.elem = t, this.frameId = -1, this.dataProps = createSizedArray(e.length), this.renderer = r, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", e.length ? e.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i);
            var s, n = e.length || 0;
            for(a = 0; a < n; a += 1)s = PropertyFactory.getProp(t, e[a].v, 0, 0, this), this.k = s.k || this.k, this.dataProps[a] = {
                n: e[a].n,
                p: s
            };
            this.k || this.getValue(!0), this._isAnimated = this.k;
        }
        function SVGStrokeStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r, this._isAnimated = !!this._isAnimated;
        }
        function SVGFillStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r;
        }
        function SVGNoStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.style = r;
        }
        function GradientProperty(t, e, r) {
            this.data = e, this.c = createTypedArray("uint8c", 4 * e.p);
            var i = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
            this.o = createTypedArray("float32", i), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i, this.initDynamicPropertyContainer(r), this.prop = PropertyFactory.getProp(t, e.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
        }
        function SVGGradientFillStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, e, r);
        }
        function SVGGradientStrokeStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.initGradientData(t, e, r), this._isAnimated = !!this._isAnimated;
        }
        function ShapeGroupData() {
            this.it = [], this.prevViewData = [], this.gr = createNS("g");
        }
        function SVGTransformData(t, e, r) {
            this.transform = {
                mProps: t,
                op: e,
                container: r
            }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
        }
        SVGShapeData.prototype.setAsAnimated = function() {
            this._isAnimated = !0;
        }, SVGStyleData.prototype.reset = function() {
            this.d = "", this._mdf = !1;
        }, DashProperty.prototype.getValue = function(t) {
            if ((this.elem.globalData.frameId !== this.frameId || t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
                var e = 0, r = this.dataProps.length;
                for("svg" === this.renderer && (this.dashStr = ""), e = 0; e < r; e += 1)"o" !== this.dataProps[e].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e].p.v : this.dashArray[e] = this.dataProps[e].p.v : this.dashoffset[0] = this.dataProps[e].p.v;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], DashProperty), extendPrototype([
            DynamicPropertyContainer
        ], SVGStrokeStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGFillStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(t, e) {
            for(var r = 0, i = this.o.length / 2; r < i;){
                if (Math.abs(t[4 * r] - t[4 * e + 2 * r]) > .01) return !1;
                r += 1;
            }
            return !0;
        }, GradientProperty.prototype.checkCollapsable = function() {
            if (this.o.length / 2 != this.c.length / 4) return !1;
            if (this.data.k.k[0].s) for(var t = 0, e = this.data.k.k.length; t < e;){
                if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
                t += 1;
            }
            else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
            return !0;
        }, GradientProperty.prototype.getValue = function(t) {
            if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
                var e, r, i, a = 4 * this.data.p;
                for(e = 0; e < a; e += 1)r = e % 4 == 0 ? 100 : 255, i = Math.round(this.prop.v[e] * r), this.c[e] !== i && (this.c[e] = i, this._cmdf = !t);
                if (this.o.length) for(a = this.prop.v.length, e = 4 * this.data.p; e < a; e += 1)r = e % 2 == 0 ? 100 : 1, i = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e], this.o[e - 4 * this.data.p] !== i && (this.o[e - 4 * this.data.p] = i, this._omdf = !t);
                this._mdf = !t;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(t, e, r) {
            this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.s = PropertyFactory.getProp(t, e.s, 1, null, this), this.e = PropertyFactory.getProp(t, e.e, 1, null, this), this.h = PropertyFactory.getProp(t, e.h || {
                k: 0
            }, 0, .01, this), this.a = PropertyFactory.getProp(t, e.a || {
                k: 0
            }, 0, degToRads, this), this.g = new GradientProperty(t, e.g, this), this.style = r, this.stops = [], this.setGradientData(r.pElem, e), this.setGradientOpacity(e, r), this._isAnimated = !!this._isAnimated;
        }, SVGGradientFillStyleData.prototype.setGradientData = function(t, e) {
            var r = createElementID(), i = createNS(1 === e.t ? "linearGradient" : "radialGradient");
            i.setAttribute("id", r), i.setAttribute("spreadMethod", "pad"), i.setAttribute("gradientUnits", "userSpaceOnUse");
            var a, s, n, o = [];
            for(n = 4 * e.g.p, s = 0; s < n; s += 4)a = createNS("stop"), i.appendChild(a), o.push(a);
            t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r + ")"), this.gf = i, this.cst = o;
        }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t, e) {
            if (this.g._hasOpacity && !this.g._collapsable) {
                var r, i, a, s = createNS("mask"), n = createNS("path");
                s.appendChild(n);
                var o = createElementID(), h = createElementID();
                s.setAttribute("id", h);
                var l = createNS(1 === t.t ? "linearGradient" : "radialGradient");
                l.setAttribute("id", o), l.setAttribute("spreadMethod", "pad"), l.setAttribute("gradientUnits", "userSpaceOnUse"), a = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
                var p = this.stops;
                for(i = 4 * t.g.p; i < a; i += 2)(r = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l.appendChild(r), p.push(r);
                n.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + o + ")"), "gs" === t.ty && (n.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), n.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), 1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)), this.of = l, this.ms = s, this.ost = p, this.maskId = h, e.msElem = n;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], SVGGradientFillStyleData), extendPrototype([
            SVGGradientFillStyleData,
            DynamicPropertyContainer
        ], SVGGradientStrokeStyleData);
        var buildShapeString = function(t, e, r, i) {
            if (0 === e) return "";
            var a, s = t.o, n = t.i, o = t.v, h = " M" + i.applyToPointStringified(o[0][0], o[0][1]);
            for(a = 1; a < e; a += 1)h += " C" + i.applyToPointStringified(s[a - 1][0], s[a - 1][1]) + " " + i.applyToPointStringified(n[a][0], n[a][1]) + " " + i.applyToPointStringified(o[a][0], o[a][1]);
            return r && e && (h += " C" + i.applyToPointStringified(s[a - 1][0], s[a - 1][1]) + " " + i.applyToPointStringified(n[0][0], n[0][1]) + " " + i.applyToPointStringified(o[0][0], o[0][1]), h += "z"), h;
        }, SVGElementsRenderer = function() {
            var t = new Matrix, e = new Matrix;
            function r(t, e, r) {
                (r || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v), (r || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS());
            }
            function i() {}
            function a(r, i, a) {
                var s, n, o, h, l, p, f, c, m, d, u = i.styles.length, y = i.lvl;
                for(p = 0; p < u; p += 1){
                    if (h = i.sh._mdf || a, i.styles[p].lvl < y) {
                        for(c = e.reset(), m = y - i.styles[p].lvl, d = i.transformers.length - 1; !h && m > 0;)h = i.transformers[d].mProps._mdf || h, m -= 1, d -= 1;
                        if (h) for(m = y - i.styles[p].lvl, d = i.transformers.length - 1; m > 0;)c.multiply(i.transformers[d].mProps.v), m -= 1, d -= 1;
                    } else c = t;
                    if (n = (f = i.sh.paths)._length, h) {
                        for(o = "", s = 0; s < n; s += 1)(l = f.shapes[s]) && l._length && (o += buildShapeString(l, l._length, l.c, c));
                        i.caches[p] = o;
                    } else o = i.caches[p];
                    i.styles[p].d += !0 === r.hd ? "" : o, i.styles[p]._mdf = h || i.styles[p]._mdf;
                }
            }
            function s(t, e, r) {
                var i = e.style;
                (e.c._mdf || r) && i.pElem.setAttribute("fill", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r) && i.pElem.setAttribute("fill-opacity", e.o.v);
            }
            function n(t, e, r) {
                o(t, e, r), h(t, e, r);
            }
            function o(t, e, r) {
                var i, a, s, n, o, h = e.gf, l = e.g._hasOpacity, p = e.s.v, f = e.e.v;
                if (e.o._mdf || r) {
                    var c = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
                    e.style.pElem.setAttribute(c, e.o.v);
                }
                if (e.s._mdf || r) {
                    var m = 1 === t.t ? "x1" : "cx", d = "x1" === m ? "y1" : "cy";
                    h.setAttribute(m, p[0]), h.setAttribute(d, p[1]), l && !e.g._collapsable && (e.of.setAttribute(m, p[0]), e.of.setAttribute(d, p[1]));
                }
                if (e.g._cmdf || r) {
                    i = e.cst;
                    var u = e.g.c;
                    for(s = i.length, a = 0; a < s; a += 1)(n = i[a]).setAttribute("offset", u[4 * a] + "%"), n.setAttribute("stop-color", "rgb(" + u[4 * a + 1] + "," + u[4 * a + 2] + "," + u[4 * a + 3] + ")");
                }
                if (l && (e.g._omdf || r)) {
                    var y = e.g.o;
                    for(s = (i = e.g._collapsable ? e.cst : e.ost).length, a = 0; a < s; a += 1)n = i[a], e.g._collapsable || n.setAttribute("offset", y[2 * a] + "%"), n.setAttribute("stop-opacity", y[2 * a + 1]);
                }
                if (1 === t.t) (e.e._mdf || r) && (h.setAttribute("x2", f[0]), h.setAttribute("y2", f[1]), l && !e.g._collapsable && (e.of.setAttribute("x2", f[0]), e.of.setAttribute("y2", f[1])));
                else if ((e.s._mdf || e.e._mdf || r) && (o = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)), h.setAttribute("r", o), l && !e.g._collapsable && e.of.setAttribute("r", o)), e.e._mdf || e.h._mdf || e.a._mdf || r) {
                    o || (o = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)));
                    var g = Math.atan2(f[1] - p[1], f[0] - p[0]), v = e.h.v;
                    v >= 1 ? v = .99 : v <= -1 && (v = -0.99);
                    var b = o * v, x = Math.cos(g + e.a.v) * b + p[0], E = Math.sin(g + e.a.v) * b + p[1];
                    h.setAttribute("fx", x), h.setAttribute("fy", E), l && !e.g._collapsable && (e.of.setAttribute("fx", x), e.of.setAttribute("fy", E));
                }
            }
            function h(t, e, r) {
                var i = e.style, a = e.d;
                a && (a._mdf || r) && a.dashStr && (i.pElem.setAttribute("stroke-dasharray", a.dashStr), i.pElem.setAttribute("stroke-dashoffset", a.dashoffset[0])), e.c && (e.c._mdf || r) && i.pElem.setAttribute("stroke", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r) && i.pElem.setAttribute("stroke-opacity", e.o.v), (e.w._mdf || r) && (i.pElem.setAttribute("stroke-width", e.w.v), i.msElem && i.msElem.setAttribute("stroke-width", e.w.v));
            }
            return {
                createRenderFunction: function(t) {
                    switch(t.ty){
                        case "fl":
                            return s;
                        case "gf":
                            return o;
                        case "gs":
                            return n;
                        case "st":
                            return h;
                        case "sh":
                        case "el":
                        case "rc":
                        case "sr":
                            return a;
                        case "tr":
                            return r;
                        case "no":
                            return i;
                        default:
                            return null;
                    }
                }
            };
        }();
        function SVGShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, e, r), this.prevViewData = [];
        }
        function LetterProps(t, e, r, i, a, s) {
            this.o = t, this.sw = e, this.sc = r, this.fc = i, this.m = a, this.p = s, this._mdf = {
                o: !0,
                sw: !!e,
                sc: !!r,
                fc: !!i,
                m: !0,
                p: !0
            };
        }
        function TextProperty(t, e) {
            this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, e.d && e.d.sid && (e.d = t.globalData.slotManager.getProp(e.d)), this.data = e, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
                ascent: 0,
                boxWidth: this.defaultBoxWidth,
                f: "",
                fStyle: "",
                fWeight: "",
                fc: "",
                j: "",
                justifyOffset: "",
                l: [],
                lh: 0,
                lineWidths: [],
                ls: "",
                of: "",
                s: "",
                sc: "",
                sw: 0,
                t: 0,
                tr: 0,
                sz: 0,
                ps: null,
                fillColorAnim: !1,
                strokeColorAnim: !1,
                strokeWidthAnim: !1,
                yOffset: 0,
                finalSize: 0,
                finalText: [],
                finalLineHeight: 0,
                __complete: !1
            }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {}, SVGShapeElement.prototype.identityMatrix = new Matrix, SVGShapeElement.prototype.buildExpressionInterface = function() {}, SVGShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
        }, SVGShapeElement.prototype.filterUniqueShapes = function() {
            var t, e, r, i, a = this.shapes.length, s = this.stylesList.length, n = [], o = !1;
            for(r = 0; r < s; r += 1){
                for(i = this.stylesList[r], o = !1, n.length = 0, t = 0; t < a; t += 1)-1 !== (e = this.shapes[t]).styles.indexOf(i) && (n.push(e), o = e._isAnimated || o);
                n.length > 1 && o && this.setShapesAsAnimated(n);
            }
        }, SVGShapeElement.prototype.setShapesAsAnimated = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e].setAsAnimated();
        }, SVGShapeElement.prototype.createStyleElement = function(t, e) {
            var r, i = new SVGStyleData(t, e), a = i.pElem;
            if ("st" === t.ty) r = new SVGStrokeStyleData(this, t, i);
            else if ("fl" === t.ty) r = new SVGFillStyleData(this, t, i);
            else if ("gf" === t.ty || "gs" === t.ty) r = new ("gf" === t.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t, i), this.globalData.defs.appendChild(r.gf), r.maskId && (this.globalData.defs.appendChild(r.ms), this.globalData.defs.appendChild(r.of), a.setAttribute("mask", "url(" + getLocationHref() + "#" + r.maskId + ")"));
            else "no" === t.ty && (r = new SVGNoStyleData(this, t, i));
            return "st" !== t.ty && "gs" !== t.ty || (a.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), a.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), a.setAttribute("fill-opacity", "0"), 1 === t.lj && a.setAttribute("stroke-miterlimit", t.ml)), 2 === t.r && a.setAttribute("fill-rule", "evenodd"), t.ln && a.setAttribute("id", t.ln), t.cl && a.setAttribute("class", t.cl), t.bm && (a.style["mix-blend-mode"] = getBlendMode(t.bm)), this.stylesList.push(i), this.addToAnimatedContents(t, r), r;
        }, SVGShapeElement.prototype.createGroupElement = function(t) {
            var e = new ShapeGroupData;
            return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = getBlendMode(t.bm)), e;
        }, SVGShapeElement.prototype.createTransformElement = function(t, e) {
            var r = TransformPropertyFactory.getTransformProperty(this, t, this), i = new SVGTransformData(r, r.o, e);
            return this.addToAnimatedContents(t, i), i;
        }, SVGShapeElement.prototype.createShapeElement = function(t, e, r) {
            var i = 4;
            "rc" === t.ty ? i = 5 : "el" === t.ty ? i = 6 : "sr" === t.ty && (i = 7);
            var a = new SVGShapeData(e, r, ShapePropertyFactory.getShapeProp(this, t, i, this));
            return this.shapes.push(a), this.addShapeToModifiers(a), this.addToAnimatedContents(t, a), a;
        }, SVGShapeElement.prototype.addToAnimatedContents = function(t, e) {
            for(var r = 0, i = this.animatedContents.length; r < i;){
                if (this.animatedContents[r].element === e) return;
                r += 1;
            }
            this.animatedContents.push({
                fn: SVGElementsRenderer.createRenderFunction(t),
                element: e,
                data: t
            });
        }, SVGShapeElement.prototype.setElementStyles = function(t) {
            var e, r = t.styles, i = this.stylesList.length;
            for(e = 0; e < i; e += 1)this.stylesList[e].closed || r.push(this.stylesList[e]);
        }, SVGShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers();
        }, SVGShapeElement.prototype.searchShapes = function(t, e, r, i, a, s, n) {
            var o, h, l, p, f, c, m = [].concat(s), d = t.length - 1, u = [], y = [];
            for(o = d; o >= 0; o -= 1){
                if ((c = this.searchProcessedElement(t[o])) ? e[o] = r[c - 1] : t[o]._render = n, "fl" === t[o].ty || "st" === t[o].ty || "gf" === t[o].ty || "gs" === t[o].ty || "no" === t[o].ty) c ? e[o].style.closed = !1 : e[o] = this.createStyleElement(t[o], a), t[o]._render && e[o].style.pElem.parentNode !== i && i.appendChild(e[o].style.pElem), u.push(e[o].style);
                else if ("gr" === t[o].ty) {
                    if (c) for(l = e[o].it.length, h = 0; h < l; h += 1)e[o].prevViewData[h] = e[o].it[h];
                    else e[o] = this.createGroupElement(t[o]);
                    this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, a + 1, m, n), t[o]._render && e[o].gr.parentNode !== i && i.appendChild(e[o].gr);
                } else "tr" === t[o].ty ? (c || (e[o] = this.createTransformElement(t[o], i)), p = e[o].transform, m.push(p)) : "sh" === t[o].ty || "rc" === t[o].ty || "el" === t[o].ty || "sr" === t[o].ty ? (c || (e[o] = this.createShapeElement(t[o], m, a)), this.setElementStyles(e[o])) : "tm" === t[o].ty || "rd" === t[o].ty || "ms" === t[o].ty || "pb" === t[o].ty || "zz" === t[o].ty || "op" === t[o].ty ? (c ? (f = e[o]).closed = !1 : ((f = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]), e[o] = f, this.shapeModifiers.push(f)), y.push(f)) : "rp" === t[o].ty && (c ? (f = e[o]).closed = !0 : (f = ShapeModifiers.getModifier(t[o].ty), e[o] = f, f.init(this, t, o, e), this.shapeModifiers.push(f), n = !1), y.push(f));
                this.addProcessedElement(t[o], o + 1);
            }
            for(d = u.length, o = 0; o < d; o += 1)u[o].closed = !0;
            for(d = y.length, o = 0; o < d; o += 1)y[o].closed = !0;
        }, SVGShapeElement.prototype.renderInnerContent = function() {
            var t;
            this.renderModifiers();
            var e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].reset();
            for(this.renderShape(), t = 0; t < e; t += 1)(this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
        }, SVGShapeElement.prototype.renderShape = function() {
            var t, e, r = this.animatedContents.length;
            for(t = 0; t < r; t += 1)e = this.animatedContents[t], (this._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, this._isFirstFrame);
        }, SVGShapeElement.prototype.destroy = function() {
            this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
        }, LetterProps.prototype.update = function(t, e, r, i, a, s) {
            this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
            var n = !1;
            return this.o !== t && (this.o = t, this._mdf.o = !0, n = !0), this.sw !== e && (this.sw = e, this._mdf.sw = !0, n = !0), this.sc !== r && (this.sc = r, this._mdf.sc = !0, n = !0), this.fc !== i && (this.fc = i, this._mdf.fc = !0, n = !0), this.m !== a && (this.m = a, this._mdf.m = !0, n = !0), !s.length || this.p[0] === s[0] && this.p[1] === s[1] && this.p[4] === s[4] && this.p[5] === s[5] && this.p[12] === s[12] && this.p[13] === s[13] || (this.p = s, this._mdf.p = !0, n = !0), n;
        }, TextProperty.prototype.defaultBoxWidth = [
            0,
            0
        ], TextProperty.prototype.copyData = function(t, e) {
            for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t;
        }, TextProperty.prototype.setCurrentData = function(t) {
            t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
        }, TextProperty.prototype.searchProperty = function() {
            return this.searchKeyframes();
        }, TextProperty.prototype.searchKeyframes = function() {
            return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
        }, TextProperty.prototype.addEffect = function(t) {
            this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.getValue = function(t) {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t) {
                this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                var e = this.currentData, r = this.keysIndex;
                if (this.lock) this.setCurrentData(this.currentData);
                else {
                    var i;
                    this.lock = !0, this._mdf = !1;
                    var a = this.effectsSequence.length, s = t || this.data.d.k[this.keysIndex].s;
                    for(i = 0; i < a; i += 1)s = r !== this.keysIndex ? this.effectsSequence[i](s, s.t) : this.effectsSequence[i](this.currentData, s.t);
                    e !== s && this.setCurrentData(s), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }, TextProperty.prototype.getKeyframeValue = function() {
            for(var t = this.data.d.k, e = this.elem.comp.renderedFrame, r = 0, i = t.length; r <= i - 1 && !(r === i - 1 || t[r + 1].t > e);)r += 1;
            return this.keysIndex !== r && (this.keysIndex = r), this.data.d.k[this.keysIndex].s;
        }, TextProperty.prototype.buildFinalText = function(t) {
            for(var e, r, i = [], a = 0, s = t.length, n = !1, o = !1, h = ""; a < s;)n = o, o = !1, e = t.charCodeAt(a), h = t.charAt(a), FontManager.isCombinedCharacter(e) ? n = !0 : e >= 55296 && e <= 56319 ? FontManager.isRegionalFlag(t, a) ? h = t.substr(a, 14) : (r = t.charCodeAt(a + 1)) >= 56320 && r <= 57343 && (FontManager.isModifier(e, r) ? (h = t.substr(a, 2), n = !0) : h = FontManager.isFlagEmoji(t.substr(a, 4)) ? t.substr(a, 4) : t.substr(a, 2)) : e > 56319 ? (r = t.charCodeAt(a + 1), FontManager.isVariationSelector(e) && (n = !0)) : FontManager.isZeroWidthJoiner(e) && (n = !0, o = !0), n ? (i[i.length - 1] += h, n = !1) : i.push(h), a += h.length;
            return i;
        }, TextProperty.prototype.completeTextData = function(t) {
            t.__complete = !0;
            var e, r, i, a, s, n, o, h = this.elem.globalData.fontManager, l = this.data, p = [], f = 0, c = l.m.g, m = 0, d = 0, u = 0, y = [], g = 0, v = 0, b = h.getFontByName(t.f), x = 0, E = getFontProperties(b);
            t.fWeight = E.weight, t.fStyle = E.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), r = t.finalText.length, t.finalLineHeight = t.lh;
            var S, P = t.tr / 1e3 * t.finalSize;
            if (t.sz) for(var C, _, k = !0, A = t.sz[0], T = t.sz[1]; k;){
                C = 0, g = 0, r = (_ = this.buildFinalText(t.t)).length, P = t.tr / 1e3 * t.finalSize;
                var M = -1;
                for(e = 0; e < r; e += 1)S = _[e].charCodeAt(0), i = !1, " " === _[e] ? M = e : 13 !== S && 3 !== S || (g = 0, i = !0, C += t.finalLineHeight || 1.2 * t.finalSize), h.chars ? (o = h.getCharData(_[e], b.fStyle, b.fFamily), x = i ? 0 : o.w * t.finalSize / 100) : x = h.measureText(_[e], t.f, t.finalSize), g + x > A && " " !== _[e] ? (-1 === M ? r += 1 : e = M, C += t.finalLineHeight || 1.2 * t.finalSize, _.splice(e, M === e ? 1 : 0, "\r"), M = -1, g = 0) : (g += x, g += P);
                C += b.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && T < C ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = _, r = t.finalText.length, k = !1);
            }
            g = -P, x = 0;
            var w, D = 0;
            for(e = 0; e < r; e += 1)if (i = !1, 13 === (S = (w = t.finalText[e]).charCodeAt(0)) || 3 === S ? (D = 0, y.push(g), v = g > v ? g : v, g = -2 * P, a = "", i = !0, u += 1) : a = w, h.chars ? (o = h.getCharData(w, b.fStyle, h.getFontByName(t.f).fFamily), x = i ? 0 : o.w * t.finalSize / 100) : x = h.measureText(a, t.f, t.finalSize), " " === w ? D += x + P : (g += x + P + D, D = 0), p.push({
                l: x,
                an: x,
                add: m,
                n: i,
                anIndexes: [],
                val: a,
                line: u,
                animatorJustifyOffset: 0
            }), 2 == c) {
                if (m += x, "" === a || " " === a || e === r - 1) {
                    for("" !== a && " " !== a || (m -= x); d <= e;)p[d].an = m, p[d].ind = f, p[d].extra = x, d += 1;
                    f += 1, m = 0;
                }
            } else if (3 == c) {
                if (m += x, "" === a || e === r - 1) {
                    for("" === a && (m -= x); d <= e;)p[d].an = m, p[d].ind = f, p[d].extra = x, d += 1;
                    m = 0, f += 1;
                }
            } else p[f].ind = f, p[f].extra = 0, f += 1;
            if (t.l = p, v = g > v ? g : v, y.push(g), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;
            else switch(t.boxWidth = v, t.j){
                case 1:
                    t.justifyOffset = -t.boxWidth;
                    break;
                case 2:
                    t.justifyOffset = -t.boxWidth / 2;
                    break;
                default:
                    t.justifyOffset = 0;
            }
            t.lineWidths = y;
            var F, I, R, V, B = l.a;
            n = B.length;
            var L = [];
            for(s = 0; s < n; s += 1){
                for((F = B[s]).a.sc && (t.strokeColorAnim = !0), F.a.sw && (t.strokeWidthAnim = !0), (F.a.fc || F.a.fh || F.a.fs || F.a.fb) && (t.fillColorAnim = !0), V = 0, R = F.s.b, e = 0; e < r; e += 1)(I = p[e]).anIndexes[s] = V, (1 == R && "" !== I.val || 2 == R && "" !== I.val && " " !== I.val || 3 == R && (I.n || " " == I.val || e == r - 1) || 4 == R && (I.n || e == r - 1)) && (1 === F.s.rn && L.push(V), V += 1);
                l.a[s].s.totalChars = V;
                var z, G = -1;
                if (1 === F.s.rn) for(e = 0; e < r; e += 1)G != (I = p[e]).anIndexes[s] && (G = I.anIndexes[s], z = L.splice(Math.floor(Math.random() * L.length), 1)[0]), I.anIndexes[s] = z;
            }
            t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = b.ascent * t.finalSize / 100;
        }, TextProperty.prototype.updateDocumentData = function(t, e) {
            e = void 0 === e ? this.keysIndex : e;
            var r = this.copyData({}, this.data.d.k[e].s);
            r = this.copyData(r, t), this.data.d.k[e].s = r, this.recalculate(e), this.setCurrentData(r), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.recalculate = function(t) {
            var e = this.data.d.k[t].s;
            e.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e);
        }, TextProperty.prototype.canResizeFont = function(t) {
            this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.setMinimumFontSize = function(t) {
            this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        };
        var TextSelectorProp = function() {
            var t = Math.max, e = Math.min, r = Math.floor;
            function i(t, e) {
                this._currentTextLength = -1, this.k = !1, this.data = e, this.elem = t, this.comp = t.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t), this.s = PropertyFactory.getProp(t, e.s || {
                    k: 0
                }, 0, 0, this), this.e = "e" in e ? PropertyFactory.getProp(t, e.e, 0, 0, this) : {
                    v: 100
                }, this.o = PropertyFactory.getProp(t, e.o || {
                    k: 0
                }, 0, 0, this), this.xe = PropertyFactory.getProp(t, e.xe || {
                    k: 0
                }, 0, 0, this), this.ne = PropertyFactory.getProp(t, e.ne || {
                    k: 0
                }, 0, 0, this), this.sm = PropertyFactory.getProp(t, e.sm || {
                    k: 100
                }, 0, 0, this), this.a = PropertyFactory.getProp(t, e.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
            }
            return i.prototype = {
                getMult: function(i) {
                    this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                    var a = 0, s = 0, n = 1, o = 1;
                    this.ne.v > 0 ? a = this.ne.v / 100 : s = -this.ne.v / 100, this.xe.v > 0 ? n = 1 - this.xe.v / 100 : o = 1 + this.xe.v / 100;
                    var h = BezierFactory.getBezierEasing(a, s, n, o).get, l = 0, p = this.finalS, f = this.finalE, c = this.data.sh;
                    if (2 === c) l = h(l = f === p ? i >= f ? 1 : 0 : t(0, e(.5 / (f - p) + (i - p) / (f - p), 1)));
                    else if (3 === c) l = h(l = f === p ? i >= f ? 0 : 1 : 1 - t(0, e(.5 / (f - p) + (i - p) / (f - p), 1)));
                    else if (4 === c) f === p ? l = 0 : (l = t(0, e(.5 / (f - p) + (i - p) / (f - p), 1))) < .5 ? l *= 2 : l = 1 - 2 * (l - .5), l = h(l);
                    else if (5 === c) {
                        if (f === p) l = 0;
                        else {
                            var m = f - p, d = -m / 2 + (i = e(t(0, i + .5 - p), f - p)), u = m / 2;
                            l = Math.sqrt(1 - d * d / (u * u));
                        }
                        l = h(l);
                    } else 6 === c ? (f === p ? l = 0 : (i = e(t(0, i + .5 - p), f - p), l = (1 + Math.cos(Math.PI + 2 * Math.PI * i / (f - p))) / 2), l = h(l)) : (i >= r(p) && (l = t(0, e(i - p < 0 ? e(f, 1) - (p - i) : f - i, 1))), l = h(l));
                    if (100 !== this.sm.v) {
                        var y = .01 * this.sm.v;
                        0 === y && (y = 1e-8);
                        var g = .5 - .5 * y;
                        l < g ? l = 0 : (l = (l - g) / y) > 1 && (l = 1);
                    }
                    return l * this.a.v;
                },
                getValue: function(t) {
                    this.iterateDynamicProperties(), this._mdf = t || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t && 2 === this.data.r && (this.e.v = this._currentTextLength);
                    var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars, r = this.o.v / e, i = this.s.v / e + r, a = this.e.v / e + r;
                    if (i > a) {
                        var s = i;
                        i = a, a = s;
                    }
                    this.finalS = i, this.finalE = a;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], i), {
                getTextSelectorProp: function(t, e, r) {
                    return new i(t, e, r);
                }
            };
        }();
        function TextAnimatorDataProperty(t, e, r) {
            var i = {
                propType: !1
            }, a = PropertyFactory.getProp, s = e.a;
            this.a = {
                r: s.r ? a(t, s.r, 0, degToRads, r) : i,
                rx: s.rx ? a(t, s.rx, 0, degToRads, r) : i,
                ry: s.ry ? a(t, s.ry, 0, degToRads, r) : i,
                sk: s.sk ? a(t, s.sk, 0, degToRads, r) : i,
                sa: s.sa ? a(t, s.sa, 0, degToRads, r) : i,
                s: s.s ? a(t, s.s, 1, .01, r) : i,
                a: s.a ? a(t, s.a, 1, 0, r) : i,
                o: s.o ? a(t, s.o, 0, .01, r) : i,
                p: s.p ? a(t, s.p, 1, 0, r) : i,
                sw: s.sw ? a(t, s.sw, 0, 0, r) : i,
                sc: s.sc ? a(t, s.sc, 1, 0, r) : i,
                fc: s.fc ? a(t, s.fc, 1, 0, r) : i,
                fh: s.fh ? a(t, s.fh, 0, 0, r) : i,
                fs: s.fs ? a(t, s.fs, 0, .01, r) : i,
                fb: s.fb ? a(t, s.fb, 0, .01, r) : i,
                t: s.t ? a(t, s.t, 0, 0, r) : i
            }, this.s = TextSelectorProp.getTextSelectorProp(t, e.s, r), this.s.t = e.s.t;
        }
        function TextAnimatorProperty(t, e, r) {
            this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = e, this._elem = r, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
                alignment: {}
            }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r);
        }
        function ITextElement() {}
        TextAnimatorProperty.prototype.searchProperties = function() {
            var t, e, r = this._textData.a.length, i = PropertyFactory.getProp;
            for(t = 0; t < r; t += 1)e = this._textData.a[t], this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, e, this);
            this._textData.p && "m" in this._textData.p ? (this._pathData = {
                a: i(this._elem, this._textData.p.a, 0, 0, this),
                f: i(this._elem, this._textData.p.f, 0, 0, this),
                l: i(this._elem, this._textData.p.l, 0, 0, this),
                r: i(this._elem, this._textData.p.r, 0, 0, this),
                p: i(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this);
        }, TextAnimatorProperty.prototype.getMeasures = function(t, e) {
            if (this.lettersChangedFlag = e, this._mdf || this._isFirstFrame || e || this._hasMaskedPath && this._pathData.m._mdf) {
                this._isFirstFrame = !1;
                var r, i, a, s, n, o, h, l, p, f, c, m, d, u, y, g, v, b, x, E = this._moreOptions.alignment.v, S = this._animatorsData, P = this._textData, C = this.mHelper, _ = this._renderType, k = this.renderedLetters.length, A = t.l;
                if (this._hasMaskedPath) {
                    if (x = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
                        var T, M = x.v;
                        for(this._pathData.r.v && (M = M.reverse()), n = {
                            tLength: 0,
                            segments: []
                        }, s = M._length - 1, g = 0, a = 0; a < s; a += 1)T = bez.buildBezierData(M.v[a], M.v[a + 1], [
                            M.o[a][0] - M.v[a][0],
                            M.o[a][1] - M.v[a][1]
                        ], [
                            M.i[a + 1][0] - M.v[a + 1][0],
                            M.i[a + 1][1] - M.v[a + 1][1]
                        ]), n.tLength += T.segmentLength, n.segments.push(T), g += T.segmentLength;
                        a = s, x.v.c && (T = bez.buildBezierData(M.v[a], M.v[0], [
                            M.o[a][0] - M.v[a][0],
                            M.o[a][1] - M.v[a][1]
                        ], [
                            M.i[0][0] - M.v[0][0],
                            M.i[0][1] - M.v[0][1]
                        ]), n.tLength += T.segmentLength, n.segments.push(T), g += T.segmentLength), this._pathData.pi = n;
                    }
                    if (n = this._pathData.pi, o = this._pathData.f.v, c = 0, f = 1, l = 0, p = !0, u = n.segments, o < 0 && x.v.c) for(n.tLength < Math.abs(o) && (o = -Math.abs(o) % n.tLength), f = (d = u[c = u.length - 1].points).length - 1; o < 0;)o += d[f].partialLength, (f -= 1) < 0 && (f = (d = u[c -= 1].points).length - 1);
                    m = (d = u[c].points)[f - 1], y = (h = d[f]).partialLength;
                }
                s = A.length, r = 0, i = 0;
                var w, D, F, I, R, V = 1.2 * t.finalSize * .714, B = !0;
                F = S.length;
                var L, z, G, O, N, H, j, q, W, $, Y, J, X = -1, Z = o, K = c, U = f, Q = -1, tt = "", et = this.defaultPropsArray;
                if (2 === t.j || 1 === t.j) {
                    var rt = 0, it = 0, at = 2 === t.j ? -0.5 : -1, st = 0, nt = !0;
                    for(a = 0; a < s; a += 1)if (A[a].n) {
                        for(rt && (rt += it); st < a;)A[st].animatorJustifyOffset = rt, st += 1;
                        rt = 0, nt = !0;
                    } else {
                        for(D = 0; D < F; D += 1)(w = S[D].a).t.propType && (nt && 2 === t.j && (it += w.t.v * at), (R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? rt += w.t.v * R[0] * at : rt += w.t.v * R * at);
                        nt = !1;
                    }
                    for(rt && (rt += it); st < a;)A[st].animatorJustifyOffset = rt, st += 1;
                }
                for(a = 0; a < s; a += 1){
                    if (C.reset(), O = 1, A[a].n) r = 0, i += t.yOffset, i += B ? 1 : 0, o = Z, B = !1, this._hasMaskedPath && (f = U, m = (d = u[c = K].points)[f - 1], y = (h = d[f]).partialLength, l = 0), tt = "", Y = "", W = "", J = "", et = this.defaultPropsArray;
                    else {
                        if (this._hasMaskedPath) {
                            if (Q !== A[a].line) {
                                switch(t.j){
                                    case 1:
                                        o += g - t.lineWidths[A[a].line];
                                        break;
                                    case 2:
                                        o += (g - t.lineWidths[A[a].line]) / 2;
                                }
                                Q = A[a].line;
                            }
                            X !== A[a].ind && (A[X] && (o += A[X].extra), o += A[a].an / 2, X = A[a].ind), o += E[0] * A[a].an * .005;
                            var ot = 0;
                            for(D = 0; D < F; D += 1)(w = S[D].a).p.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? ot += w.p.v[0] * R[0] : ot += w.p.v[0] * R), w.a.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? ot += w.a.v[0] * R[0] : ot += w.a.v[0] * R);
                            for(p = !0, this._pathData.a.v && (o = .5 * A[0].an + (g - this._pathData.f.v - .5 * A[0].an - .5 * A[A.length - 1].an) * X / (s - 1), o += this._pathData.f.v); p;)l + y >= o + ot || !d ? (v = (o + ot - l) / h.partialLength, z = m.point[0] + (h.point[0] - m.point[0]) * v, G = m.point[1] + (h.point[1] - m.point[1]) * v, C.translate(-E[0] * A[a].an * .005, -E[1] * V * .01), p = !1) : d && (l += h.partialLength, (f += 1) >= d.length && (f = 0, u[c += 1] ? d = u[c].points : x.v.c ? (f = 0, d = u[c = 0].points) : (l -= h.partialLength, d = null)), d && (m = h, y = (h = d[f]).partialLength));
                            L = A[a].an / 2 - A[a].add, C.translate(-L, 0, 0);
                        } else L = A[a].an / 2 - A[a].add, C.translate(-L, 0, 0), C.translate(-E[0] * A[a].an * .005, -E[1] * V * .01, 0);
                        for(D = 0; D < F; D += 1)(w = S[D].a).t.propType && (R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars), 0 === r && 0 === t.j || (this._hasMaskedPath ? R.length ? o += w.t.v * R[0] : o += w.t.v * R : R.length ? r += w.t.v * R[0] : r += w.t.v * R));
                        for(t.strokeWidthAnim && (H = t.sw || 0), t.strokeColorAnim && (N = t.sc ? [
                            t.sc[0],
                            t.sc[1],
                            t.sc[2]
                        ] : [
                            0,
                            0,
                            0
                        ]), t.fillColorAnim && t.fc && (j = [
                            t.fc[0],
                            t.fc[1],
                            t.fc[2]
                        ]), D = 0; D < F; D += 1)(w = S[D].a).a.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? C.translate(-w.a.v[0] * R[0], -w.a.v[1] * R[1], w.a.v[2] * R[2]) : C.translate(-w.a.v[0] * R, -w.a.v[1] * R, w.a.v[2] * R));
                        for(D = 0; D < F; D += 1)(w = S[D].a).s.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? C.scale(1 + (w.s.v[0] - 1) * R[0], 1 + (w.s.v[1] - 1) * R[1], 1) : C.scale(1 + (w.s.v[0] - 1) * R, 1 + (w.s.v[1] - 1) * R, 1));
                        for(D = 0; D < F; D += 1){
                            if (w = S[D].a, R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars), w.sk.propType && (R.length ? C.skewFromAxis(-w.sk.v * R[0], w.sa.v * R[1]) : C.skewFromAxis(-w.sk.v * R, w.sa.v * R)), w.r.propType && (R.length ? C.rotateZ(-w.r.v * R[2]) : C.rotateZ(-w.r.v * R)), w.ry.propType && (R.length ? C.rotateY(w.ry.v * R[1]) : C.rotateY(w.ry.v * R)), w.rx.propType && (R.length ? C.rotateX(w.rx.v * R[0]) : C.rotateX(w.rx.v * R)), w.o.propType && (R.length ? O += (w.o.v * R[0] - O) * R[0] : O += (w.o.v * R - O) * R), t.strokeWidthAnim && w.sw.propType && (R.length ? H += w.sw.v * R[0] : H += w.sw.v * R), t.strokeColorAnim && w.sc.propType) for(q = 0; q < 3; q += 1)R.length ? N[q] += (w.sc.v[q] - N[q]) * R[0] : N[q] += (w.sc.v[q] - N[q]) * R;
                            if (t.fillColorAnim && t.fc) {
                                if (w.fc.propType) for(q = 0; q < 3; q += 1)R.length ? j[q] += (w.fc.v[q] - j[q]) * R[0] : j[q] += (w.fc.v[q] - j[q]) * R;
                                w.fh.propType && (j = R.length ? addHueToRGB(j, w.fh.v * R[0]) : addHueToRGB(j, w.fh.v * R)), w.fs.propType && (j = R.length ? addSaturationToRGB(j, w.fs.v * R[0]) : addSaturationToRGB(j, w.fs.v * R)), w.fb.propType && (j = R.length ? addBrightnessToRGB(j, w.fb.v * R[0]) : addBrightnessToRGB(j, w.fb.v * R));
                            }
                        }
                        for(D = 0; D < F; D += 1)(w = S[D].a).p.propType && (R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars), this._hasMaskedPath ? R.length ? C.translate(0, w.p.v[1] * R[0], -w.p.v[2] * R[1]) : C.translate(0, w.p.v[1] * R, -w.p.v[2] * R) : R.length ? C.translate(w.p.v[0] * R[0], w.p.v[1] * R[1], -w.p.v[2] * R[2]) : C.translate(w.p.v[0] * R, w.p.v[1] * R, -w.p.v[2] * R));
                        if (t.strokeWidthAnim && (W = H < 0 ? 0 : H), t.strokeColorAnim && ($ = "rgb(" + Math.round(255 * N[0]) + "," + Math.round(255 * N[1]) + "," + Math.round(255 * N[2]) + ")"), t.fillColorAnim && t.fc && (Y = "rgb(" + Math.round(255 * j[0]) + "," + Math.round(255 * j[1]) + "," + Math.round(255 * j[2]) + ")"), this._hasMaskedPath) {
                            if (C.translate(0, -t.ls), C.translate(0, E[1] * V * .01 + i, 0), this._pathData.p.v) {
                                b = (h.point[1] - m.point[1]) / (h.point[0] - m.point[0]);
                                var ht = 180 * Math.atan(b) / Math.PI;
                                h.point[0] < m.point[0] && (ht += 180), C.rotate(-ht * Math.PI / 180);
                            }
                            C.translate(z, G, 0), o -= E[0] * A[a].an * .005, A[a + 1] && X !== A[a + 1].ind && (o += A[a].an / 2, o += .001 * t.tr * t.finalSize);
                        } else {
                            switch(C.translate(r, i, 0), t.ps && C.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j){
                                case 1:
                                    C.translate(A[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[A[a].line]), 0, 0);
                                    break;
                                case 2:
                                    C.translate(A[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[A[a].line]) / 2, 0, 0);
                            }
                            C.translate(0, -t.ls), C.translate(L, 0, 0), C.translate(E[0] * A[a].an * .005, E[1] * V * .01, 0), r += A[a].l + .001 * t.tr * t.finalSize;
                        }
                        "html" === _ ? tt = C.toCSS() : "svg" === _ ? tt = C.to2dCSS() : et = [
                            C.props[0],
                            C.props[1],
                            C.props[2],
                            C.props[3],
                            C.props[4],
                            C.props[5],
                            C.props[6],
                            C.props[7],
                            C.props[8],
                            C.props[9],
                            C.props[10],
                            C.props[11],
                            C.props[12],
                            C.props[13],
                            C.props[14],
                            C.props[15]
                        ], J = O;
                    }
                    k <= a ? (I = new LetterProps(J, W, $, Y, tt, et), this.renderedLetters.push(I), k += 1, this.lettersChangedFlag = !0) : (I = this.renderedLetters[a], this.lettersChangedFlag = I.update(J, W, $, Y, tt, et) || this.lettersChangedFlag);
                }
            }
        }, TextAnimatorProperty.prototype.getValue = function() {
            this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
        }, TextAnimatorProperty.prototype.mHelper = new Matrix, TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([
            DynamicPropertyContainer
        ], TextAnimatorProperty), ITextElement.prototype.initElement = function(t, e, r) {
            this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, e, r), this.textProperty = new TextProperty(this, t.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this), this.initTransform(t, e, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
        }, ITextElement.prototype.prepareFrame = function(t) {
            this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
        }, ITextElement.prototype.createPathShape = function(t, e) {
            var r, i, a = e.length, s = "";
            for(r = 0; r < a; r += 1)"sh" === e[r].ty && (i = e[r].ks.k, s += buildShapeString(i, i.i.length, !0, t));
            return s;
        }, ITextElement.prototype.updateDocumentData = function(t, e) {
            this.textProperty.updateDocumentData(t, e);
        }, ITextElement.prototype.canResizeFont = function(t) {
            this.textProperty.canResizeFont(t);
        }, ITextElement.prototype.setMinimumFontSize = function(t) {
            this.textProperty.setMinimumFontSize(t);
        }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t, e, r, i, a) {
            switch(t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j){
                case 1:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]), 0, 0);
                    break;
                case 2:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]) / 2, 0, 0);
            }
            e.translate(i, a, 0);
        }, ITextElement.prototype.buildColor = function(t) {
            return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
        }, ITextElement.prototype.emptyProp = new LetterProps, ITextElement.prototype.destroy = function() {}, ITextElement.prototype.validateText = function() {
            (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
        };
        var emptyShapeData = {
            shapes: []
        };
        function SVGTextLottieElement(t, e, r) {
            this.textSpans = [], this.renderType = "svg", this.initElement(t, e, r);
        }
        function ISolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function NullElement(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initFrame(), this.initTransform(t, e, r), this.initHierarchy();
        }
        function SVGRendererBase() {}
        function ICompElement() {}
        function SVGCompElement(t, e, r) {
            this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function SVGRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
            var r = "";
            if (e && e.title) {
                var i = createNS("title"), a = createElementID();
                i.setAttribute("id", a), i.textContent = e.title, this.svgElement.appendChild(i), r += a;
            }
            if (e && e.description) {
                var s = createNS("desc"), n = createElementID();
                s.setAttribute("id", n), s.textContent = e.description, this.svgElement.appendChild(s), r += " " + n;
            }
            r && this.svgElement.setAttribute("aria-labelledby", r);
            var o = createNS("defs");
            this.svgElement.appendChild(o);
            var h = createNS("g");
            this.svgElement.appendChild(h), this.layerElement = h, this.renderConfig = {
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                progressiveLoad: e && e.progressiveLoad || !1,
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                viewBoxOnly: e && e.viewBoxOnly || !1,
                viewBoxSize: e && e.viewBoxSize || !1,
                className: e && e.className || "",
                id: e && e.id || "",
                focusable: e && e.focusable,
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "100%",
                    height: e && e.filterSize && e.filterSize.height || "100%",
                    x: e && e.filterSize && e.filterSize.x || "0%",
                    y: e && e.filterSize && e.filterSize.y || "0%"
                },
                width: e && e.width,
                height: e && e.height,
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                defs: o,
                renderConfig: this.renderConfig
            }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
        }
        function ShapeTransformManager() {
            this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
            this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
        }, SVGTextLottieElement.prototype.buildTextContents = function(t) {
            for(var e = 0, r = t.length, i = [], a = ""; e < r;)t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (i.push(a), a = "") : a += t[e], e += 1;
            return i.push(a), i;
        }, SVGTextLottieElement.prototype.buildShapeData = function(t, e) {
            if (t.shapes && t.shapes.length) {
                var r = t.shapes[0];
                if (r.it) {
                    var i = r.it[r.it.length - 1];
                    i.s && (i.s.k[0] = e, i.s.k[1] = e);
                }
            }
            return t;
        }, SVGTextLottieElement.prototype.buildNewText = function() {
            var t, e;
            this.addDynamicProperty(this);
            var r = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(r ? r.l.length : 0), r.fc ? this.layerElement.setAttribute("fill", this.buildColor(r.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r.sc)), this.layerElement.setAttribute("stroke-width", r.sw)), this.layerElement.setAttribute("font-size", r.finalSize);
            var i = this.globalData.fontManager.getFontByName(r.f);
            if (i.fClass) this.layerElement.setAttribute("class", i.fClass);
            else {
                this.layerElement.setAttribute("font-family", i.fFamily);
                var a = r.fWeight, s = r.fStyle;
                this.layerElement.setAttribute("font-style", s), this.layerElement.setAttribute("font-weight", a);
            }
            this.layerElement.setAttribute("aria-label", r.t);
            var n, o = r.l || [], h = !!this.globalData.fontManager.chars;
            e = o.length;
            var l = this.mHelper, p = this.data.singleShape, f = 0, c = 0, m = !0, d = .001 * r.tr * r.finalSize;
            if (!p || h || r.sz) {
                var u, y = this.textSpans.length;
                for(t = 0; t < e; t += 1){
                    if (this.textSpans[t] || (this.textSpans[t] = {
                        span: null,
                        childSpan: null,
                        glyph: null
                    }), !h || !p || 0 === t) {
                        if (n = y > t ? this.textSpans[t].span : createNS(h ? "g" : "text"), y <= t) {
                            if (n.setAttribute("stroke-linecap", "butt"), n.setAttribute("stroke-linejoin", "round"), n.setAttribute("stroke-miterlimit", "4"), this.textSpans[t].span = n, h) {
                                var g = createNS("g");
                                n.appendChild(g), this.textSpans[t].childSpan = g;
                            }
                            this.textSpans[t].span = n, this.layerElement.appendChild(n);
                        }
                        n.style.display = "inherit";
                    }
                    if (l.reset(), p && (o[t].n && (f = -d, c += r.yOffset, c += m ? 1 : 0, m = !1), this.applyTextPropertiesToMatrix(r, l, o[t].line, f, c), f += o[t].l || 0, f += d), h) {
                        var v;
                        if (1 === (u = this.globalData.fontManager.getCharData(r.finalText[t], i.fStyle, this.globalData.fontManager.getFontByName(r.f).fFamily)).t) v = new SVGCompElement(u.data, this.globalData, this);
                        else {
                            var b = emptyShapeData;
                            u.data && u.data.shapes && (b = this.buildShapeData(u.data, r.finalSize)), v = new SVGShapeElement(b, this.globalData, this);
                        }
                        if (this.textSpans[t].glyph) {
                            var x = this.textSpans[t].glyph;
                            this.textSpans[t].childSpan.removeChild(x.layerElement), x.destroy();
                        }
                        this.textSpans[t].glyph = v, v._debug = !0, v.prepareFrame(0), v.renderFrame(), this.textSpans[t].childSpan.appendChild(v.layerElement), 1 === u.t && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + r.finalSize / 100 + "," + r.finalSize / 100 + ")");
                    } else p && n.setAttribute("transform", "translate(" + l.props[12] + "," + l.props[13] + ")"), n.textContent = o[t].val, n.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                }
                p && n && n.setAttribute("d", "");
            } else {
                var E = this.textContainer, S = "start";
                switch(r.j){
                    case 1:
                        S = "end";
                        break;
                    case 2:
                        S = "middle";
                        break;
                    default:
                        S = "start";
                }
                E.setAttribute("text-anchor", S), E.setAttribute("letter-spacing", d);
                var P = this.buildTextContents(r.finalText);
                for(e = P.length, c = r.ps ? r.ps[1] + r.ascent : 0, t = 0; t < e; t += 1)(n = this.textSpans[t].span || createNS("tspan")).textContent = P[t], n.setAttribute("x", 0), n.setAttribute("y", c), n.style.display = "inherit", E.appendChild(n), this.textSpans[t] || (this.textSpans[t] = {
                    span: null,
                    glyph: null
                }), this.textSpans[t].span = n, c += r.finalLineHeight;
                this.layerElement.appendChild(E);
            }
            for(; t < this.textSpans.length;)this.textSpans[t].span.style.display = "none", t += 1;
            this._sizeChanged = !0;
        }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
            if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
                this._sizeChanged = !1;
                var t = this.layerElement.getBBox();
                this.bbox = {
                    top: t.y,
                    left: t.x,
                    width: t.width,
                    height: t.height
                };
            }
            return this.bbox;
        }, SVGTextLottieElement.prototype.getValue = function() {
            var t, e, r = this.textSpans.length;
            for(this.renderedFrame = this.comp.renderedFrame, t = 0; t < r; t += 1)(e = this.textSpans[t].glyph) && (e.prepareFrame(this.comp.renderedFrame - this.data.st), e._mdf && (this._mdf = !0));
        }, SVGTextLottieElement.prototype.renderInnerContent = function() {
            if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                var t, e;
                this._sizeChanged = !0;
                var r, i, a, s = this.textAnimator.renderedLetters, n = this.textProperty.currentData.l;
                for(e = n.length, t = 0; t < e; t += 1)n[t].n || (r = s[t], i = this.textSpans[t].span, (a = this.textSpans[t].glyph) && a.renderFrame(), r._mdf.m && i.setAttribute("transform", r.m), r._mdf.o && i.setAttribute("opacity", r.o), r._mdf.sw && i.setAttribute("stroke-width", r.sw), r._mdf.sc && i.setAttribute("stroke", r.sc), r._mdf.fc && i.setAttribute("fill", r.fc));
            }
        }, extendPrototype([
            IImageElement
        ], ISolidElement), ISolidElement.prototype.createContent = function() {
            var t = createNS("rect");
            t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
        }, NullElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, NullElement.prototype.renderFrame = function() {}, NullElement.prototype.getBaseElement = function() {
            return null;
        }, NullElement.prototype.destroy = function() {}, NullElement.prototype.sourceRectAtTime = function() {}, NullElement.prototype.hide = function() {}, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement
        ], NullElement), extendPrototype([
            BaseRenderer
        ], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t) {
            return new NullElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createShape = function(t) {
            return new SVGShapeElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createText = function(t) {
            return new SVGTextLottieElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createImage = function(t) {
            return new IImageElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createSolid = function(t) {
            return new ISolidElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.configAnimation = function(t) {
            this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
            var e = this.globalData.defs;
            this.setupGlobalData(t, e), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
            var r = createNS("clipPath"), i = createNS("rect");
            i.setAttribute("width", t.w), i.setAttribute("height", t.h), i.setAttribute("x", 0), i.setAttribute("y", 0);
            var a = createElementID();
            r.setAttribute("id", a), r.appendChild(i), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), e.appendChild(r), this.layers = t.layers, this.elements = createSizedArray(t.layers.length);
        }, SVGRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, SVGRendererBase.prototype.updateContainerSize = function() {}, SVGRendererBase.prototype.findIndexByInd = function(t) {
            var e = 0, r = this.layers.length;
            for(e = 0; e < r; e += 1)if (this.layers[e].ind === t) return e;
            return -1;
        }, SVGRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                e[t] = !0;
                var r = this.createItem(this.layers[t]);
                if (e[t] = r, getExpressionsPlugin() && (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(r), r.initExpressions()), this.appendElementInPos(r, t), this.layers[t].tt) {
                    var i = "tp" in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
                    if (-1 === i) return;
                    if (this.elements[i] && !0 !== this.elements[i]) {
                        var a = e[i].getMatte(this.layers[t].tt);
                        r.setMatte(a);
                    } else this.buildItem(i), this.addPendingElement(r);
                }
            }
        }, SVGRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;){
                var t = this.pendingElements.pop();
                if (t.checkParenting(), t.data.tt) for(var e = 0, r = this.elements.length; e < r;){
                    if (this.elements[e] === t) {
                        var i = "tp" in t.data ? this.findIndexByInd(t.data.tp) : e - 1, a = this.elements[i].getMatte(this.layers[e].tt);
                        t.setMatte(a);
                        break;
                    }
                    e += 1;
                }
            }
        }, SVGRendererBase.prototype.renderFrame = function(t) {
            if (this.renderedFrame !== t && !this.destroyed) {
                var e;
                null === t ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
                var r = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), e = r - 1; e >= 0; e -= 1)(this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
                if (this.globalData._mdf) for(e = 0; e < r; e += 1)(this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
            }
        }, SVGRendererBase.prototype.appendElementInPos = function(t, e) {
            var r = t.getBaseElement();
            if (r) {
                for(var i, a = 0; a < e;)this.elements[a] && !0 !== this.elements[a] && this.elements[a].getBaseElement() && (i = this.elements[a].getBaseElement()), a += 1;
                i ? this.layerElement.insertBefore(r, i) : this.layerElement.appendChild(r);
            }
        }, SVGRendererBase.prototype.hide = function() {
            this.layerElement.style.display = "none";
        }, SVGRendererBase.prototype.show = function() {
            this.layerElement.style.display = "block";
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], ICompElement), ICompElement.prototype.initElement = function(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initTransform(t, e, r), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e.progressiveLoad || this.buildAllItems(), this.hide();
        }, ICompElement.prototype.prepareFrame = function(t) {
            if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt) {
                if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
                else {
                    var e = this.tm.v;
                    e === this.data.op && (e = this.data.op - 1), this.renderedFrame = e;
                }
                var r, i = this.elements.length;
                for(this.completeLayers || this.checkLayers(this.renderedFrame), r = i - 1; r >= 0; r -= 1)(this.completeLayers || this.elements[r]) && (this.elements[r].prepareFrame(this.renderedFrame - this.layers[r].st), this.elements[r]._mdf && (this._mdf = !0));
            }
        }, ICompElement.prototype.renderInnerContent = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, ICompElement.prototype.setElements = function(t) {
            this.elements = t;
        }, ICompElement.prototype.getElements = function() {
            return this.elements;
        }, ICompElement.prototype.destroyElements = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy();
        }, ICompElement.prototype.destroy = function() {
            this.destroyElements(), this.destroyBaseElement();
        }, extendPrototype([
            SVGRendererBase,
            ICompElement,
            SVGBaseElement
        ], SVGCompElement), SVGCompElement.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            SVGRendererBase
        ], SVGRenderer), SVGRenderer.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, ShapeTransformManager.prototype = {
            addTransformSequence: function(t) {
                var e, r = t.length, i = "_";
                for(e = 0; e < r; e += 1)i += t[e].transform.key + "_";
                var a = this.sequences[i];
                return a || (a = {
                    transforms: [].concat(t),
                    finalTransform: new Matrix,
                    _mdf: !1
                }, this.sequences[i] = a, this.sequenceList.push(a)), a;
            },
            processSequence: function(t, e) {
                for(var r = 0, i = t.transforms.length, a = e; r < i && !e;){
                    if (t.transforms[r].transform.mProps._mdf) {
                        a = !0;
                        break;
                    }
                    r += 1;
                }
                if (a) for(t.finalTransform.reset(), r = i - 1; r >= 0; r -= 1)t.finalTransform.multiply(t.transforms[r].transform.mProps.v);
                t._mdf = a;
            },
            processSequences: function(t) {
                var e, r = this.sequenceList.length;
                for(e = 0; e < r; e += 1)this.processSequence(this.sequenceList[e], t);
            },
            getNewKey: function() {
                return this.transform_key_count += 1, "_" + this.transform_key_count;
            }
        };
        var lumaLoader = function() {
            var t = "__lottie_element_luma_buffer", e = null, r = null, i = null;
            function a() {
                var a, s, n;
                e || (a = createNS("svg"), s = createNS("filter"), n = createNS("feColorMatrix"), s.setAttribute("id", t), n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), s.appendChild(n), a.appendChild(s), a.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (a.style.display = "none"), i = a, document.body.appendChild(i), e = createTag("canvas"), (r = e.getContext("2d")).filter = "url(#" + t + ")", r.fillStyle = "rgba(0,0,0,0)", r.fillRect(0, 0, 1, 1));
            }
            return {
                load: a,
                get: function(i) {
                    return e || a(), e.width = i.width, e.height = i.height, r.filter = "url(#" + t + ")", e;
                }
            };
        };
        function createCanvas(t, e) {
            if (featureSupport.offscreenCanvas) return new OffscreenCanvas(t, e);
            var r = createTag("canvas");
            return r.width = t, r.height = e, r;
        }
        var assetLoader = {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        }, registeredEffects = {};
        function CVEffects(t) {
            var e, r, i = t.data.ef ? t.data.ef.length : 0;
            for(this.filters = [], e = 0; e < i; e += 1){
                r = null;
                var a = t.data.ef[e].ty;
                if (registeredEffects[a]) r = new registeredEffects[a].effect(t.effectsManager.effectElements[e], t);
                r && this.filters.push(r);
            }
            this.filters.length && t.addRenderableComponent(this);
        }
        function registerEffect(t, e) {
            registeredEffects[t] = {
                effect: e
            };
        }
        function CVMaskElement(t, e) {
            var r;
            this.data = t, this.element = e, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
            var i = this.masksProperties.length, a = !1;
            for(r = 0; r < i; r += 1)"n" !== this.masksProperties[r].mode && (a = !0), this.viewData[r] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r], 3);
            this.hasMasks = a, a && this.element.addRenderableComponent(this);
        }
        function CVBaseElement() {}
        CVEffects.prototype.renderFrame = function(t) {
            var e, r = this.filters.length;
            for(e = 0; e < r; e += 1)this.filters[e].renderFrame(t);
        }, CVEffects.prototype.getEffects = function(t) {
            var e, r = this.filters.length, i = [];
            for(e = 0; e < r; e += 1)this.filters[e].type === t && i.push(this.filters[e]);
            return i;
        }, CVMaskElement.prototype.renderFrame = function() {
            if (this.hasMasks) {
                var t, e, r, i, a = this.element.finalTransform.mat, s = this.element.canvasContext, n = this.masksProperties.length;
                for(s.beginPath(), t = 0; t < n; t += 1)if ("n" !== this.masksProperties[t].mode) {
                    var o;
                    this.masksProperties[t].inv && (s.moveTo(0, 0), s.lineTo(this.element.globalData.compSize.w, 0), s.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), s.lineTo(0, this.element.globalData.compSize.h), s.lineTo(0, 0)), i = this.viewData[t].v, e = a.applyToPointArray(i.v[0][0], i.v[0][1], 0), s.moveTo(e[0], e[1]);
                    var h = i._length;
                    for(o = 1; o < h; o += 1)r = a.applyToTriplePoints(i.o[o - 1], i.i[o], i.v[o]), s.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                    r = a.applyToTriplePoints(i.o[o - 1], i.i[0], i.v[0]), s.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                }
                this.element.globalData.renderer.save(!0), s.clip();
            }
        }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
            this.element = null;
        };
        var operationsMap = {
            1: "source-in",
            2: "source-out",
            3: "source-in",
            4: "source-out"
        };
        function CVShapeData(t, e, r, i) {
            this.styledShapes = [], this.tr = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            var a, s = 4;
            "rc" === e.ty ? s = 5 : "el" === e.ty ? s = 6 : "sr" === e.ty && (s = 7), this.sh = ShapePropertyFactory.getShapeProp(t, e, s, t);
            var n, o = r.length;
            for(a = 0; a < o; a += 1)r[a].closed || (n = {
                transforms: i.addTransformSequence(r[a].transforms),
                trNodes: []
            }, this.styledShapes.push(n), r[a].elements.push(n));
        }
        function CVShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager, this.initElement(t, e, r);
        }
        function CVTextElement(t, e, r) {
            this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
                fill: "rgba(0,0,0,0)",
                stroke: "rgba(0,0,0,0)",
                sWidth: 0,
                fValue: ""
            }, this.initElement(t, e, r);
        }
        function CVImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.img = e.imageLoader.getAsset(this.assetData), this.initElement(t, e, r);
        }
        function CVSolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function CanvasRendererBase() {}
        function CanvasContext() {
            this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
        }
        function CVContextData() {
            var t;
            this.stack = [], this.cArrPos = 0, this.cTr = new Matrix;
            for(t = 0; t < 15; t += 1){
                var e = new CanvasContext;
                this.stack[t] = e;
            }
            this._length = 15, this.nativeContext = null, this.transformMat = new Matrix, this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
        }
        function CVCompElement(t, e, r) {
            this.completeLayers = !1, this.layers = t.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function CanvasRenderer(t, e) {
            this.animationItem = t, this.renderConfig = {
                clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                context: e && e.context || null,
                progressiveLoad: e && e.progressiveLoad || !1,
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                className: e && e.className || "",
                id: e && e.id || "",
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.renderConfig.dpr = e && e.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e && e.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
        }
        function HBaseElement() {}
        function HSolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function HShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t, e, r), this.prevViewData = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            };
        }
        function HTextElement(t, e, r) {
            this.textSpans = [], this.textPaths = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            }, this.renderType = "svg", this.isMasked = !1, this.initElement(t, e, r);
        }
        function HCameraElement(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initHierarchy();
            var i = PropertyFactory.getProp;
            if (this.pe = i(this, t.pe, 0, 0, this), t.ks.p.s ? (this.px = i(this, t.ks.p.x, 1, 0, this), this.py = i(this, t.ks.p.y, 1, 0, this), this.pz = i(this, t.ks.p.z, 1, 0, this)) : this.p = i(this, t.ks.p, 1, 0, this), t.ks.a && (this.a = i(this, t.ks.a, 1, 0, this)), t.ks.or.k.length && t.ks.or.k[0].to) {
                var a, s = t.ks.or.k.length;
                for(a = 0; a < s; a += 1)t.ks.or.k[a].to = null, t.ks.or.k[a].ti = null;
            }
            this.or = i(this, t.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = i(this, t.ks.rx, 0, degToRads, this), this.ry = i(this, t.ks.ry, 0, degToRads, this), this.rz = i(this, t.ks.rz, 0, degToRads, this), this.mat = new Matrix, this._prevMat = new Matrix, this._isFirstFrame = !0, this.finalTransform = {
                mProp: this
            };
        }
        function HImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.initElement(t, e, r);
        }
        function HybridRendererBase(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                }
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        function HCompElement(t, e, r) {
            this.layers = t.layers, this.supports3d = !t.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function HybridRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                },
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        CVBaseElement.prototype = {
            createElements: function() {},
            initRendererElement: function() {},
            createContainerElements: function() {
                if (this.data.tt >= 1) {
                    this.buffers = [];
                    var t = this.globalData.canvasContext, e = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(e);
                    var r = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(r), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
                }
                this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
            },
            createContent: function() {},
            setBlendMode: function() {
                var t = this.globalData;
                if (t.blendMode !== this.data.bm) {
                    t.blendMode = this.data.bm;
                    var e = getBlendMode(this.data.bm);
                    t.canvasContext.globalCompositeOperation = e;
                }
            },
            createRenderableComponents: function() {
                this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
            },
            hideElement: function() {
                this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
            },
            showElement: function() {
                this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
            },
            clearCanvas: function(t) {
                t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
            },
            prepareLayer: function() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[0].getContext("2d");
                    this.clearCanvas(t), t.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
                }
            },
            exitLayer: function() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[1], e = t.getContext("2d");
                    if (this.clearCanvas(e), e.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform), this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1).renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
                        var r = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                        r.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(r, 0, 0);
                    }
                    this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
                }
            },
            renderFrame: function(t) {
                if (!this.hidden && !this.data.hd && (1 !== this.data.td || t)) {
                    this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
                    var e = 0 === this.data.ty;
                    this.prepareLayer(), this.globalData.renderer.save(e), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(e), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
                }
            },
            destroy: function() {
                this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
            },
            mHelper: new Matrix
        }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
            opacity: 1,
            _opMdf: !1
        }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
        }, CVShapeElement.prototype.createStyleElement = function(t, e) {
            var r = {
                data: t,
                type: t.ty,
                preTransforms: this.transformsManager.addTransformSequence(e),
                transforms: [],
                elements: [],
                closed: !0 === t.hd
            }, i = {};
            if ("fl" === t.ty || "st" === t.ty ? (i.c = PropertyFactory.getProp(this, t.c, 1, 255, this), i.c.k || (r.co = "rgb(" + bmFloor(i.c.v[0]) + "," + bmFloor(i.c.v[1]) + "," + bmFloor(i.c.v[2]) + ")")) : "gf" !== t.ty && "gs" !== t.ty || (i.s = PropertyFactory.getProp(this, t.s, 1, null, this), i.e = PropertyFactory.getProp(this, t.e, 1, null, this), i.h = PropertyFactory.getProp(this, t.h || {
                k: 0
            }, 0, .01, this), i.a = PropertyFactory.getProp(this, t.a || {
                k: 0
            }, 0, degToRads, this), i.g = new GradientProperty(this, t.g, this)), i.o = PropertyFactory.getProp(this, t.o, 0, .01, this), "st" === t.ty || "gs" === t.ty) {
                if (r.lc = lineCapEnum[t.lc || 2], r.lj = lineJoinEnum[t.lj || 2], 1 == t.lj && (r.ml = t.ml), i.w = PropertyFactory.getProp(this, t.w, 0, null, this), i.w.k || (r.wi = i.w.v), t.d) {
                    var a = new DashProperty(this, t.d, "canvas", this);
                    i.d = a, i.d.k || (r.da = i.d.dashArray, r.do = i.d.dashoffset[0]);
                }
            } else r.r = 2 === t.r ? "evenodd" : "nonzero";
            return this.stylesList.push(r), i.style = r, i;
        }, CVShapeElement.prototype.createGroupElement = function() {
            return {
                it: [],
                prevViewData: []
            };
        }, CVShapeElement.prototype.createTransformElement = function(t) {
            return {
                transform: {
                    opacity: 1,
                    _opMdf: !1,
                    key: this.transformsManager.getNewKey(),
                    op: PropertyFactory.getProp(this, t.o, 0, .01, this),
                    mProps: TransformPropertyFactory.getTransformProperty(this, t, this)
                }
            };
        }, CVShapeElement.prototype.createShapeElement = function(t) {
            var e = new CVShapeData(this, t, this.stylesList, this.transformsManager);
            return this.shapes.push(e), this.addShapeToModifiers(e), e;
        }, CVShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
        }, CVShapeElement.prototype.addTransformToStyleList = function(t) {
            var e, r = this.stylesList.length;
            for(e = 0; e < r; e += 1)this.stylesList[e].closed || this.stylesList[e].transforms.push(t);
        }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
            var t, e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].closed || this.stylesList[t].transforms.pop();
        }, CVShapeElement.prototype.closeStyles = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e].closed = !0;
        }, CVShapeElement.prototype.searchShapes = function(t, e, r, i, a) {
            var s, n, o, h, l, p, f = t.length - 1, c = [], m = [], d = [].concat(a);
            for(s = f; s >= 0; s -= 1){
                if ((h = this.searchProcessedElement(t[s])) ? e[s] = r[h - 1] : t[s]._shouldRender = i, "fl" === t[s].ty || "st" === t[s].ty || "gf" === t[s].ty || "gs" === t[s].ty) h ? e[s].style.closed = !1 : e[s] = this.createStyleElement(t[s], d), c.push(e[s].style);
                else if ("gr" === t[s].ty) {
                    if (h) for(o = e[s].it.length, n = 0; n < o; n += 1)e[s].prevViewData[n] = e[s].it[n];
                    else e[s] = this.createGroupElement(t[s]);
                    this.searchShapes(t[s].it, e[s].it, e[s].prevViewData, i, d);
                } else "tr" === t[s].ty ? (h || (p = this.createTransformElement(t[s]), e[s] = p), d.push(e[s]), this.addTransformToStyleList(e[s])) : "sh" === t[s].ty || "rc" === t[s].ty || "el" === t[s].ty || "sr" === t[s].ty ? h || (e[s] = this.createShapeElement(t[s])) : "tm" === t[s].ty || "rd" === t[s].ty || "pb" === t[s].ty || "zz" === t[s].ty || "op" === t[s].ty ? (h ? (l = e[s]).closed = !1 : ((l = ShapeModifiers.getModifier(t[s].ty)).init(this, t[s]), e[s] = l, this.shapeModifiers.push(l)), m.push(l)) : "rp" === t[s].ty && (h ? (l = e[s]).closed = !0 : (l = ShapeModifiers.getModifier(t[s].ty), e[s] = l, l.init(this, t, s, e), this.shapeModifiers.push(l), i = !1), m.push(l));
                this.addProcessedElement(t[s], s + 1);
            }
            for(this.removeTransformFromStyleList(), this.closeStyles(c), f = m.length, s = 0; s < f; s += 1)m[s].closed = !0;
        }, CVShapeElement.prototype.renderInnerContent = function() {
            this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
        }, CVShapeElement.prototype.renderShapeTransform = function(t, e) {
            (t._opMdf || e.op._mdf || this._isFirstFrame) && (e.opacity = t.opacity, e.opacity *= e.op.v, e._opMdf = !0);
        }, CVShapeElement.prototype.drawLayer = function() {
            var t, e, r, i, a, s, n, o, h, l = this.stylesList.length, p = this.globalData.renderer, f = this.globalData.canvasContext;
            for(t = 0; t < l; t += 1)if (("st" !== (o = (h = this.stylesList[t]).type) && "gs" !== o || 0 !== h.wi) && h.data._shouldRender && 0 !== h.coOp && 0 !== this.globalData.currentGlobalAlpha) {
                for(p.save(), s = h.elements, "st" === o || "gs" === o ? (p.ctxStrokeStyle("st" === o ? h.co : h.grd), p.ctxLineWidth(h.wi), p.ctxLineCap(h.lc), p.ctxLineJoin(h.lj), p.ctxMiterLimit(h.ml || 0)) : p.ctxFillStyle("fl" === o ? h.co : h.grd), p.ctxOpacity(h.coOp), "st" !== o && "gs" !== o && f.beginPath(), p.ctxTransform(h.preTransforms.finalTransform.props), r = s.length, e = 0; e < r; e += 1){
                    for("st" !== o && "gs" !== o || (f.beginPath(), h.da && (f.setLineDash(h.da), f.lineDashOffset = h.do)), a = (n = s[e].trNodes).length, i = 0; i < a; i += 1)"m" === n[i].t ? f.moveTo(n[i].p[0], n[i].p[1]) : "c" === n[i].t ? f.bezierCurveTo(n[i].pts[0], n[i].pts[1], n[i].pts[2], n[i].pts[3], n[i].pts[4], n[i].pts[5]) : f.closePath();
                    "st" !== o && "gs" !== o || (p.ctxStroke(), h.da && f.setLineDash(this.dashResetter));
                }
                "st" !== o && "gs" !== o && this.globalData.renderer.ctxFill(h.r), p.restore();
            }
        }, CVShapeElement.prototype.renderShape = function(t, e, r, i) {
            var a, s;
            for(s = t, a = e.length - 1; a >= 0; a -= 1)"tr" === e[a].ty ? (s = r[a].transform, this.renderShapeTransform(t, s)) : "sh" === e[a].ty || "el" === e[a].ty || "rc" === e[a].ty || "sr" === e[a].ty ? this.renderPath(e[a], r[a]) : "fl" === e[a].ty ? this.renderFill(e[a], r[a], s) : "st" === e[a].ty ? this.renderStroke(e[a], r[a], s) : "gf" === e[a].ty || "gs" === e[a].ty ? this.renderGradientFill(e[a], r[a], s) : "gr" === e[a].ty ? this.renderShape(s, e[a].it, r[a].it) : e[a].ty;
            i && this.drawLayer();
        }, CVShapeElement.prototype.renderStyledShape = function(t, e) {
            if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
                var r, i, a, s = t.trNodes, n = e.paths, o = n._length;
                s.length = 0;
                var h = t.transforms.finalTransform;
                for(a = 0; a < o; a += 1){
                    var l = n.shapes[a];
                    if (l && l.v) {
                        for(i = l._length, r = 1; r < i; r += 1)1 === r && s.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), s.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r - 1], l.i[r], l.v[r])
                        });
                        1 === i && s.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), l.c && i && (s.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r - 1], l.i[0], l.v[0])
                        }), s.push({
                            t: "z"
                        }));
                    }
                }
                t.trNodes = s;
            }
        }, CVShapeElement.prototype.renderPath = function(t, e) {
            if (!0 !== t.hd && t._shouldRender) {
                var r, i = e.styledShapes.length;
                for(r = 0; r < i; r += 1)this.renderStyledShape(e.styledShapes[r], e.sh);
            }
        }, CVShapeElement.prototype.renderFill = function(t, e, r) {
            var i = e.style;
            (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity);
        }, CVShapeElement.prototype.renderGradientFill = function(t, e, r) {
            var i, a = e.style;
            if (!a.grd || e.g._mdf || e.s._mdf || e.e._mdf || 1 !== t.t && (e.h._mdf || e.a._mdf)) {
                var s, n = this.globalData.canvasContext, o = e.s.v, h = e.e.v;
                if (1 === t.t) i = n.createLinearGradient(o[0], o[1], h[0], h[1]);
                else {
                    var l = Math.sqrt(Math.pow(o[0] - h[0], 2) + Math.pow(o[1] - h[1], 2)), p = Math.atan2(h[1] - o[1], h[0] - o[0]), f = e.h.v;
                    f >= 1 ? f = .99 : f <= -1 && (f = -0.99);
                    var c = l * f, m = Math.cos(p + e.a.v) * c + o[0], d = Math.sin(p + e.a.v) * c + o[1];
                    i = n.createRadialGradient(m, d, 0, o[0], o[1], l);
                }
                var u = t.g.p, y = e.g.c, g = 1;
                for(s = 0; s < u; s += 1)e.g._hasOpacity && e.g._collapsable && (g = e.g.o[2 * s + 1]), i.addColorStop(y[4 * s] / 100, "rgba(" + y[4 * s + 1] + "," + y[4 * s + 2] + "," + y[4 * s + 3] + "," + g + ")");
                a.grd = i;
            }
            a.coOp = e.o.v * r.opacity;
        }, CVShapeElement.prototype.renderStroke = function(t, e, r) {
            var i = e.style, a = e.d;
            a && (a._mdf || this._isFirstFrame) && (i.da = a.dashArray, i.do = a.dashoffset[0]), (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity), (e.w._mdf || this._isFirstFrame) && (i.wi = e.w.v);
        }, CVShapeElement.prototype.destroy = function() {
            this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement,
            ITextElement
        ], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = !1;
            t.fc ? (e = !0, this.values.fill = this.buildColor(t.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = e;
            var r = !1;
            t.sc && (r = !0, this.values.stroke = this.buildColor(t.sc), this.values.sWidth = t.sw);
            var i, a, s, n, o, h, l, p, f, c, m, d, u = this.globalData.fontManager.getFontByName(t.f), y = t.l, g = this.mHelper;
            this.stroke = r, this.values.fValue = t.finalSize + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily, a = t.finalText.length;
            var v = this.data.singleShape, b = .001 * t.tr * t.finalSize, x = 0, E = 0, S = !0, P = 0;
            for(i = 0; i < a; i += 1){
                n = (s = this.globalData.fontManager.getCharData(t.finalText[i], u.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily)) && s.data || {}, g.reset(), v && y[i].n && (x = -b, E += t.yOffset, E += S ? 1 : 0, S = !1), f = (l = n.shapes ? n.shapes[0].it : []).length, g.scale(t.finalSize / 100, t.finalSize / 100), v && this.applyTextPropertiesToMatrix(t, g, y[i].line, x, E), m = createSizedArray(f - 1);
                var C = 0;
                for(p = 0; p < f; p += 1)if ("sh" === l[p].ty) {
                    for(h = l[p].ks.k.i.length, c = l[p].ks.k, d = [], o = 1; o < h; o += 1)1 === o && d.push(g.applyToX(c.v[0][0], c.v[0][1], 0), g.applyToY(c.v[0][0], c.v[0][1], 0)), d.push(g.applyToX(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToY(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToX(c.i[o][0], c.i[o][1], 0), g.applyToY(c.i[o][0], c.i[o][1], 0), g.applyToX(c.v[o][0], c.v[o][1], 0), g.applyToY(c.v[o][0], c.v[o][1], 0));
                    d.push(g.applyToX(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToY(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToX(c.i[0][0], c.i[0][1], 0), g.applyToY(c.i[0][0], c.i[0][1], 0), g.applyToX(c.v[0][0], c.v[0][1], 0), g.applyToY(c.v[0][0], c.v[0][1], 0)), m[C] = d, C += 1;
                }
                v && (x += y[i].l, x += b), this.textSpans[P] ? this.textSpans[P].elem = m : this.textSpans[P] = {
                    elem: m
                }, P += 1;
            }
        }, CVTextElement.prototype.renderInnerContent = function() {
            var t, e, r, i, a, s;
            this.validateText(), this.canvasContext.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            var n, o = this.textAnimator.renderedLetters, h = this.textProperty.currentData.l;
            e = h.length;
            var l, p, f = null, c = null, m = null, d = this.globalData.renderer;
            for(t = 0; t < e; t += 1)if (!h[t].n) {
                if ((n = o[t]) && (d.save(), d.ctxTransform(n.p), d.ctxOpacity(n.o)), this.fill) {
                    for(n && n.fc ? f !== n.fc && (d.ctxFillStyle(n.fc), f = n.fc) : f !== this.values.fill && (f = this.values.fill, d.ctxFillStyle(this.values.fill)), i = (l = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r = 0; r < i; r += 1)for(s = (p = l[r]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), a = 2; a < s; a += 6)this.globalData.canvasContext.bezierCurveTo(p[a], p[a + 1], p[a + 2], p[a + 3], p[a + 4], p[a + 5]);
                    this.globalData.canvasContext.closePath(), d.ctxFill();
                }
                if (this.stroke) {
                    for(n && n.sw ? m !== n.sw && (m = n.sw, d.ctxLineWidth(n.sw)) : m !== this.values.sWidth && (m = this.values.sWidth, d.ctxLineWidth(this.values.sWidth)), n && n.sc ? c !== n.sc && (c = n.sc, d.ctxStrokeStyle(n.sc)) : c !== this.values.stroke && (c = this.values.stroke, d.ctxStrokeStyle(this.values.stroke)), i = (l = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r = 0; r < i; r += 1)for(s = (p = l[r]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), a = 2; a < s; a += 6)this.globalData.canvasContext.bezierCurveTo(p[a], p[a + 1], p[a + 2], p[a + 3], p[a + 4], p[a + 5]);
                    this.globalData.canvasContext.closePath(), d.ctxStroke();
                }
                n && this.globalData.renderer.restore();
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
            if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                var t = createTag("canvas");
                t.width = this.assetData.w, t.height = this.assetData.h;
                var e, r, i = t.getContext("2d"), a = this.img.width, s = this.img.height, n = a / s, o = this.assetData.w / this.assetData.h, h = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                n > o && "xMidYMid slice" === h || n < o && "xMidYMid slice" !== h ? e = (r = s) * o : r = (e = a) / o, i.drawImage(this.img, (a - e) / 2, (s - r) / 2, e, r, 0, 0, this.assetData.w, this.assetData.h), this.img = t;
            }
        }, CVImageElement.prototype.renderInnerContent = function() {
            this.canvasContext.drawImage(this.img, 0, 0);
        }, CVImageElement.prototype.destroy = function() {
            this.img = null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
            this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
        }, extendPrototype([
            BaseRenderer
        ], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t) {
            return new CVShapeElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createText = function(t) {
            return new CVTextElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createImage = function(t) {
            return new CVImageElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createSolid = function(t) {
            return new CVSolidElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t) {
            1 === t[0] && 0 === t[1] && 0 === t[4] && 1 === t[5] && 0 === t[12] && 0 === t[13] || this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
        }, CanvasRendererBase.prototype.ctxOpacity = function(t) {
            this.canvasContext.globalAlpha *= t < 0 ? 0 : t;
        }, CanvasRendererBase.prototype.ctxFillStyle = function(t) {
            this.canvasContext.fillStyle = t;
        }, CanvasRendererBase.prototype.ctxStrokeStyle = function(t) {
            this.canvasContext.strokeStyle = t;
        }, CanvasRendererBase.prototype.ctxLineWidth = function(t) {
            this.canvasContext.lineWidth = t;
        }, CanvasRendererBase.prototype.ctxLineCap = function(t) {
            this.canvasContext.lineCap = t;
        }, CanvasRendererBase.prototype.ctxLineJoin = function(t) {
            this.canvasContext.lineJoin = t;
        }, CanvasRendererBase.prototype.ctxMiterLimit = function(t) {
            this.canvasContext.miterLimit = t;
        }, CanvasRendererBase.prototype.ctxFill = function(t) {
            this.canvasContext.fill(t);
        }, CanvasRendererBase.prototype.ctxFillRect = function(t, e, r, i) {
            this.canvasContext.fillRect(t, e, r, i);
        }, CanvasRendererBase.prototype.ctxStroke = function() {
            this.canvasContext.stroke();
        }, CanvasRendererBase.prototype.reset = function() {
            this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.save = function() {
            this.canvasContext.save();
        }, CanvasRendererBase.prototype.restore = function(t) {
            this.renderConfig.clearCanvas ? (t && (this.globalData.blendMode = "source-over"), this.contextData.restore(t)) : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.configAnimation = function(t) {
            if (this.animationItem.wrapper) {
                this.animationItem.container = createTag("canvas");
                var e = this.animationItem.container.style;
                e.width = "100%", e.height = "100%";
                var r = "0px 0px 0px";
                e.transformOrigin = r, e.mozTransformOrigin = r, e.webkitTransformOrigin = r, e["-webkit-transform"] = r, e.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
            } else this.canvasContext = this.renderConfig.context;
            this.contextData.setContext(this.canvasContext), this.data = t, this.layers = t.layers, this.transformCanvas = {
                w: t.w,
                h: t.h,
                sx: 0,
                sy: 0,
                tx: 0,
                ty: 0
            }, this.setupGlobalData(t, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t.layers.length), this.updateContainerSize();
        }, CanvasRendererBase.prototype.updateContainerSize = function(t, e) {
            var r, i, a, s;
            if (this.reset(), t ? (r = t, i = e, this.canvasContext.canvas.width = r, this.canvasContext.canvas.height = i) : (this.animationItem.wrapper && this.animationItem.container ? (r = this.animationItem.wrapper.offsetWidth, i = this.animationItem.wrapper.offsetHeight) : (r = this.canvasContext.canvas.width, i = this.canvasContext.canvas.height), this.canvasContext.canvas.width = r * this.renderConfig.dpr, this.canvasContext.canvas.height = i * this.renderConfig.dpr), -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice")) {
                var n = this.renderConfig.preserveAspectRatio.split(" "), o = n[1] || "meet", h = n[0] || "xMidYMid", l = h.substr(0, 4), p = h.substr(4);
                a = r / i, (s = this.transformCanvas.w / this.transformCanvas.h) > a && "meet" === o || s < a && "slice" === o ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = r / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = "xMid" === l && (s < a && "meet" === o || s > a && "slice" === o) ? (r - this.transformCanvas.w * (i / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : "xMax" === l && (s < a && "meet" === o || s > a && "slice" === o) ? (r - this.transformCanvas.w * (i / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = "YMid" === p && (s > a && "meet" === o || s < a && "slice" === o) ? (i - this.transformCanvas.h * (r / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : "YMax" === p && (s > a && "meet" === o || s < a && "slice" === o) ? (i - this.transformCanvas.h * (r / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
            } else "none" === this.renderConfig.preserveAspectRatio ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
            this.transformCanvas.props = [
                this.transformCanvas.sx,
                0,
                0,
                0,
                0,
                this.transformCanvas.sy,
                0,
                0,
                0,
                0,
                1,
                0,
                this.transformCanvas.tx,
                this.transformCanvas.ty,
                0,
                1
            ], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
        }, CanvasRendererBase.prototype.destroy = function() {
            var t;
            for(this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t = (this.layers ? this.layers.length : 0) - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
        }, CanvasRendererBase.prototype.renderFrame = function(t, e) {
            if ((this.renderedFrame !== t || !0 !== this.renderConfig.clearCanvas || e) && !this.destroyed && -1 !== t) {
                var r;
                this.renderedFrame = t, this.globalData.frameNum = t - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || e, this.globalData.projectInterface.currentFrame = t;
                var i = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), r = i - 1; r >= 0; r -= 1)(this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(t - this.layers[r].st);
                if (this.globalData._mdf) {
                    for(!0 === this.renderConfig.clearCanvas ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r = i - 1; r >= 0; r -= 1)(this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
                    !0 !== this.renderConfig.clearCanvas && this.restore();
                }
            }
        }, CanvasRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                var r = this.createItem(this.layers[t], this, this.globalData);
                e[t] = r, r.initExpressions();
            }
        }, CanvasRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, CanvasRendererBase.prototype.hide = function() {
            this.animationItem.container.style.display = "none";
        }, CanvasRendererBase.prototype.show = function() {
            this.animationItem.container.style.display = "block";
        }, CVContextData.prototype.duplicate = function() {
            var t = 2 * this._length, e = 0;
            for(e = this._length; e < t; e += 1)this.stack[e] = new CanvasContext;
            this._length = t;
        }, CVContextData.prototype.reset = function() {
            this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
        }, CVContextData.prototype.restore = function(t) {
            this.cArrPos -= 1;
            var e, r = this.stack[this.cArrPos], i = r.transform, a = this.cTr.props;
            for(e = 0; e < 16; e += 1)a[e] = i[e];
            if (t) {
                this.nativeContext.restore();
                var s = this.stack[this.cArrPos + 1];
                this.appliedFillStyle = s.fillStyle, this.appliedStrokeStyle = s.strokeStyle, this.appliedLineWidth = s.lineWidth, this.appliedLineCap = s.lineCap, this.appliedLineJoin = s.lineJoin, this.appliedMiterLimit = s.miterLimit;
            }
            this.nativeContext.setTransform(i[0], i[1], i[4], i[5], i[12], i[13]), (t || -1 !== r.opacity && this.currentOpacity !== r.opacity) && (this.nativeContext.globalAlpha = r.opacity, this.currentOpacity = r.opacity), this.currentFillStyle = r.fillStyle, this.currentStrokeStyle = r.strokeStyle, this.currentLineWidth = r.lineWidth, this.currentLineCap = r.lineCap, this.currentLineJoin = r.lineJoin, this.currentMiterLimit = r.miterLimit;
        }, CVContextData.prototype.save = function(t) {
            t && this.nativeContext.save();
            var e = this.cTr.props;
            this._length <= this.cArrPos && this.duplicate();
            var r, i = this.stack[this.cArrPos];
            for(r = 0; r < 16; r += 1)i.transform[r] = e[r];
            this.cArrPos += 1;
            var a = this.stack[this.cArrPos];
            a.opacity = i.opacity, a.fillStyle = i.fillStyle, a.strokeStyle = i.strokeStyle, a.lineWidth = i.lineWidth, a.lineCap = i.lineCap, a.lineJoin = i.lineJoin, a.miterLimit = i.miterLimit;
        }, CVContextData.prototype.setOpacity = function(t) {
            this.stack[this.cArrPos].opacity = t;
        }, CVContextData.prototype.setContext = function(t) {
            this.nativeContext = t;
        }, CVContextData.prototype.fillStyle = function(t) {
            this.stack[this.cArrPos].fillStyle !== t && (this.currentFillStyle = t, this.stack[this.cArrPos].fillStyle = t);
        }, CVContextData.prototype.strokeStyle = function(t) {
            this.stack[this.cArrPos].strokeStyle !== t && (this.currentStrokeStyle = t, this.stack[this.cArrPos].strokeStyle = t);
        }, CVContextData.prototype.lineWidth = function(t) {
            this.stack[this.cArrPos].lineWidth !== t && (this.currentLineWidth = t, this.stack[this.cArrPos].lineWidth = t);
        }, CVContextData.prototype.lineCap = function(t) {
            this.stack[this.cArrPos].lineCap !== t && (this.currentLineCap = t, this.stack[this.cArrPos].lineCap = t);
        }, CVContextData.prototype.lineJoin = function(t) {
            this.stack[this.cArrPos].lineJoin !== t && (this.currentLineJoin = t, this.stack[this.cArrPos].lineJoin = t);
        }, CVContextData.prototype.miterLimit = function(t) {
            this.stack[this.cArrPos].miterLimit !== t && (this.currentMiterLimit = t, this.stack[this.cArrPos].miterLimit = t);
        }, CVContextData.prototype.transform = function(t) {
            this.transformMat.cloneFromProps(t);
            var e = this.cTr;
            this.transformMat.multiply(e), e.cloneFromProps(this.transformMat.props);
            var r = e.props;
            this.nativeContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]);
        }, CVContextData.prototype.opacity = function(t) {
            var e = this.stack[this.cArrPos].opacity;
            e *= t < 0 ? 0 : t, this.stack[this.cArrPos].opacity !== e && (this.currentOpacity !== t && (this.nativeContext.globalAlpha = t, this.currentOpacity = t), this.stack[this.cArrPos].opacity = e);
        }, CVContextData.prototype.fill = function(t) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(t);
        }, CVContextData.prototype.fillRect = function(t, e, r, i) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(t, e, r, i);
        }, CVContextData.prototype.stroke = function() {
            this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
        }, extendPrototype([
            CanvasRendererBase,
            ICompElement,
            CVBaseElement
        ], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
            var t, e = this.canvasContext;
            for(e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip(), t = this.layers.length - 1; t >= 0; t -= 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, CVCompElement.prototype.destroy = function() {
            var t;
            for(t = this.layers.length - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy();
            this.layers = null, this.elements = null;
        }, CVCompElement.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, extendPrototype([
            CanvasRendererBase
        ], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, HBaseElement.prototype = {
            checkBlendMode: function() {},
            initRendererElement: function() {
                this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
            },
            createContainerElements: function() {
                this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                var t = this.transformedElement ? this.transformedElement.style : {};
                if (this.finalTransform._matMdf) {
                    var e = this.finalTransform.mat.toCSS();
                    t.transform = e, t.webkitTransform = e;
                }
                this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
            },
            renderFrame: function() {
                this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
            },
            destroy: function() {
                this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData);
            },
            addEffects: function() {},
            setMatte: function() {}
        }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], HSolidElement), HSolidElement.prototype.createContent = function() {
            var t;
            this.data.hasMask ? ((t = createNS("rect")).setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t = createTag("div")).style.width = this.data.sw + "px", t.style.height = this.data.sh + "px", t.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t);
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HSolidElement,
            SVGShapeElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
            var t;
            if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t = this.svgElement;
            else {
                t = createNS("svg");
                var e = this.comp.data ? this.comp.data : this.globalData.compSize;
                t.setAttribute("width", e.w), t.setAttribute("height", e.h), t.appendChild(this.shapesContainer), this.layerElement.appendChild(t);
            }
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t;
        }, HShapeElement.prototype.getTransformedPoint = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)e = t[r].mProps.v.applyToPointArray(e[0], e[1], 0);
            return e;
        }, HShapeElement.prototype.calculateShapeBoundingBox = function(t, e) {
            var r, i, a, s, n, o = t.sh.v, h = t.transformers, l = o._length;
            if (!(l <= 1)) {
                for(r = 0; r < l - 1; r += 1)i = this.getTransformedPoint(h, o.v[r]), a = this.getTransformedPoint(h, o.o[r]), s = this.getTransformedPoint(h, o.i[r + 1]), n = this.getTransformedPoint(h, o.v[r + 1]), this.checkBounds(i, a, s, n, e);
                o.c && (i = this.getTransformedPoint(h, o.v[r]), a = this.getTransformedPoint(h, o.o[r]), s = this.getTransformedPoint(h, o.i[0]), n = this.getTransformedPoint(h, o.v[0]), this.checkBounds(i, a, s, n, e));
            }
        }, HShapeElement.prototype.checkBounds = function(t, e, r, i, a) {
            this.getBoundsOfCurve(t, e, r, i);
            var s = this.shapeBoundingBox;
            a.x = bmMin(s.left, a.x), a.xMax = bmMax(s.right, a.xMax), a.y = bmMin(s.top, a.y), a.yMax = bmMax(s.bottom, a.yMax);
        }, HShapeElement.prototype.shapeBoundingBox = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, HShapeElement.prototype.tempBoundingBox = {
            x: 0,
            xMax: 0,
            y: 0,
            yMax: 0,
            width: 0,
            height: 0
        }, HShapeElement.prototype.getBoundsOfCurve = function(t, e, r, i) {
            for(var a, s, n, o, h, l, p, f = [
                [
                    t[0],
                    i[0]
                ],
                [
                    t[1],
                    i[1]
                ]
            ], c = 0; c < 2; ++c)s = 6 * t[c] - 12 * e[c] + 6 * r[c], a = -3 * t[c] + 9 * e[c] - 9 * r[c] + 3 * i[c], n = 3 * e[c] - 3 * t[c], s |= 0, n |= 0, 0 === (a |= 0) && 0 === s || (0 === a ? (o = -n / s) > 0 && o < 1 && f[c].push(this.calculateF(o, t, e, r, i, c)) : (h = s * s - 4 * n * a) >= 0 && ((l = (-s + bmSqrt(h)) / (2 * a)) > 0 && l < 1 && f[c].push(this.calculateF(l, t, e, r, i, c)), (p = (-s - bmSqrt(h)) / (2 * a)) > 0 && p < 1 && f[c].push(this.calculateF(p, t, e, r, i, c))));
            this.shapeBoundingBox.left = bmMin.apply(null, f[0]), this.shapeBoundingBox.top = bmMin.apply(null, f[1]), this.shapeBoundingBox.right = bmMax.apply(null, f[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, f[1]);
        }, HShapeElement.prototype.calculateF = function(t, e, r, i, a, s) {
            return bmPow(1 - t, 3) * e[s] + 3 * bmPow(1 - t, 2) * t * r[s] + 3 * (1 - t) * bmPow(t, 2) * i[s] + bmPow(t, 3) * a[s];
        }, HShapeElement.prototype.calculateBoundingBox = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)t[r] && t[r].sh ? this.calculateShapeBoundingBox(t[r], e) : t[r] && t[r].it ? this.calculateBoundingBox(t[r].it, e) : t[r] && t[r].style && t[r].w && this.expandStrokeBoundingBox(t[r].w, e);
        }, HShapeElement.prototype.expandStrokeBoundingBox = function(t, e) {
            var r = 0;
            if (t.keyframes) {
                for(var i = 0; i < t.keyframes.length; i += 1){
                    var a = t.keyframes[i].s;
                    a > r && (r = a);
                }
                r *= t.mult;
            } else r = t.v * t.mult;
            e.x -= r, e.xMax += r, e.y -= r, e.yMax += r;
        }, HShapeElement.prototype.currentBoxContains = function(t) {
            return this.currentBBox.x <= t.x && this.currentBBox.y <= t.y && this.currentBBox.width + this.currentBBox.x >= t.x + t.width && this.currentBBox.height + this.currentBBox.y >= t.y + t.height;
        }, HShapeElement.prototype.renderInnerContent = function() {
            if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
                var t = this.tempBoundingBox, e = 999999;
                if (t.x = e, t.xMax = -e, t.y = e, t.yMax = -e, this.calculateBoundingBox(this.itemsData, t), t.width = t.xMax < t.x ? 0 : t.xMax - t.x, t.height = t.yMax < t.y ? 0 : t.yMax - t.y, this.currentBoxContains(t)) return;
                var r = !1;
                if (this.currentBBox.w !== t.width && (this.currentBBox.w = t.width, this.shapeCont.setAttribute("width", t.width), r = !0), this.currentBBox.h !== t.height && (this.currentBBox.h = t.height, this.shapeCont.setAttribute("height", t.height), r = !0), r || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y) {
                    this.currentBBox.w = t.width, this.currentBBox.h = t.height, this.currentBBox.x = t.x, this.currentBBox.y = t.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                    var i = this.shapeCont.style, a = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                    i.transform = a, i.webkitTransform = a;
                }
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], HTextElement), HTextElement.prototype.createContent = function() {
            if (this.isMasked = this.checkMasks(), this.isMasked) {
                this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
                var t = createNS("g");
                this.maskedElement.appendChild(t), this.innerElem = t;
            } else this.renderType = "html", this.innerElem = this.layerElement;
            this.checkParenting();
        }, HTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = this.innerElem.style, r = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
            e.fill = r, e.color = r, t.sc && (e.stroke = this.buildColor(t.sc), e.strokeWidth = t.sw + "px");
            var i, a, s = this.globalData.fontManager.getFontByName(t.f);
            if (!this.globalData.fontManager.chars) {
                if (e.fontSize = t.finalSize + "px", e.lineHeight = t.finalSize + "px", s.fClass) this.innerElem.className = s.fClass;
                else {
                    e.fontFamily = s.fFamily;
                    var n = t.fWeight, o = t.fStyle;
                    e.fontStyle = o, e.fontWeight = n;
                }
            }
            var h, l, p, f = t.l;
            a = f.length;
            var c, m = this.mHelper, d = "", u = 0;
            for(i = 0; i < a; i += 1){
                if (this.globalData.fontManager.chars ? (this.textPaths[u] ? h = this.textPaths[u] : ((h = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), h.setAttribute("stroke-linejoin", lineJoinEnum[2]), h.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[u] ? p = (l = this.textSpans[u]).children[0] : ((l = createTag("div")).style.lineHeight = 0, (p = createNS("svg")).appendChild(h), styleDiv(l)))) : this.isMasked ? h = this.textPaths[u] ? this.textPaths[u] : createNS("text") : this.textSpans[u] ? (l = this.textSpans[u], h = this.textPaths[u]) : (styleDiv(l = createTag("span")), styleDiv(h = createTag("span")), l.appendChild(h)), this.globalData.fontManager.chars) {
                    var y, g = this.globalData.fontManager.getCharData(t.finalText[i], s.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
                    if (y = g ? g.data : null, m.reset(), y && y.shapes && y.shapes.length && (c = y.shapes[0].it, m.scale(t.finalSize / 100, t.finalSize / 100), d = this.createPathShape(m, c), h.setAttribute("d", d)), this.isMasked) this.innerElem.appendChild(h);
                    else {
                        if (this.innerElem.appendChild(l), y && y.shapes) {
                            document.body.appendChild(p);
                            var v = p.getBBox();
                            p.setAttribute("width", v.width + 2), p.setAttribute("height", v.height + 2), p.setAttribute("viewBox", v.x - 1 + " " + (v.y - 1) + " " + (v.width + 2) + " " + (v.height + 2));
                            var b = p.style, x = "translate(" + (v.x - 1) + "px," + (v.y - 1) + "px)";
                            b.transform = x, b.webkitTransform = x, f[i].yOffset = v.y - 1;
                        } else p.setAttribute("width", 1), p.setAttribute("height", 1);
                        l.appendChild(p);
                    }
                } else if (h.textContent = f[i].val, h.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(h);
                else {
                    this.innerElem.appendChild(l);
                    var E = h.style, S = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
                    E.transform = S, E.webkitTransform = S;
                }
                this.isMasked ? this.textSpans[u] = h : this.textSpans[u] = l, this.textSpans[u].style.display = "block", this.textPaths[u] = h, u += 1;
            }
            for(; u < this.textSpans.length;)this.textSpans[u].style.display = "none", u += 1;
        }, HTextElement.prototype.renderInnerContent = function() {
            var t;
            if (this.validateText(), this.data.singleShape) {
                if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                if (this.isMasked && this.finalTransform._matMdf) {
                    this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t = this.svgElement.style;
                    var e = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                    t.transform = e, t.webkitTransform = e;
                }
            }
            if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                var r, i, a, s, n, o = 0, h = this.textAnimator.renderedLetters, l = this.textProperty.currentData.l;
                for(i = l.length, r = 0; r < i; r += 1)l[r].n ? o += 1 : (s = this.textSpans[r], n = this.textPaths[r], a = h[o], o += 1, a._mdf.m && (this.isMasked ? s.setAttribute("transform", a.m) : (s.style.webkitTransform = a.m, s.style.transform = a.m)), s.style.opacity = a.o, a.sw && a._mdf.sw && n.setAttribute("stroke-width", a.sw), a.sc && a._mdf.sc && n.setAttribute("stroke", a.sc), a.fc && a._mdf.fc && (n.setAttribute("fill", a.fc), n.style.color = a.fc));
                if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                    var p = this.innerElem.getBBox();
                    this.currentBBox.w !== p.width && (this.currentBBox.w = p.width, this.svgElement.setAttribute("width", p.width)), this.currentBBox.h !== p.height && (this.currentBBox.h = p.height, this.svgElement.setAttribute("height", p.height));
                    if (this.currentBBox.w !== p.width + 2 || this.currentBBox.h !== p.height + 2 || this.currentBBox.x !== p.x - 1 || this.currentBBox.y !== p.y - 1) {
                        this.currentBBox.w = p.width + 2, this.currentBBox.h = p.height + 2, this.currentBBox.x = p.x - 1, this.currentBBox.y = p.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t = this.svgElement.style;
                        var f = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                        t.transform = f, t.webkitTransform = f;
                    }
                }
            }
        }, extendPrototype([
            BaseElement,
            FrameElement,
            HierarchyElement
        ], HCameraElement), HCameraElement.prototype.setup = function() {
            var t, e, r, i, a = this.comp.threeDElements.length;
            for(t = 0; t < a; t += 1)if ("3d" === (e = this.comp.threeDElements[t]).type) {
                r = e.perspectiveElem.style, i = e.container.style;
                var s = this.pe.v + "px", n = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                r.perspective = s, r.webkitPerspective = s, i.transformOrigin = "0px 0px 0px", i.mozTransformOrigin = "0px 0px 0px", i.webkitTransformOrigin = "0px 0px 0px", r.transform = n, r.webkitTransform = n;
            }
        }, HCameraElement.prototype.createElements = function() {}, HCameraElement.prototype.hide = function() {}, HCameraElement.prototype.renderFrame = function() {
            var t, e, r = this._isFirstFrame;
            if (this.hierarchy) for(e = this.hierarchy.length, t = 0; t < e; t += 1)r = this.hierarchy[t].finalTransform.mProp._mdf || r;
            if (r || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
                if (this.mat.reset(), this.hierarchy) for(t = e = this.hierarchy.length - 1; t >= 0; t -= 1){
                    var i = this.hierarchy[t].finalTransform.mProp;
                    this.mat.translate(-i.p.v[0], -i.p.v[1], i.p.v[2]), this.mat.rotateX(-i.or.v[0]).rotateY(-i.or.v[1]).rotateZ(i.or.v[2]), this.mat.rotateX(-i.rx.v).rotateY(-i.ry.v).rotateZ(i.rz.v), this.mat.scale(1 / i.s.v[0], 1 / i.s.v[1], 1 / i.s.v[2]), this.mat.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
                }
                if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
                    var a;
                    a = this.p ? [
                        this.p.v[0] - this.a.v[0],
                        this.p.v[1] - this.a.v[1],
                        this.p.v[2] - this.a.v[2]
                    ] : [
                        this.px.v - this.a.v[0],
                        this.py.v - this.a.v[1],
                        this.pz.v - this.a.v[2]
                    ];
                    var s = Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2)), n = [
                        a[0] / s,
                        a[1] / s,
                        a[2] / s
                    ], o = Math.sqrt(n[2] * n[2] + n[0] * n[0]), h = Math.atan2(n[1], o), l = Math.atan2(n[0], -n[2]);
                    this.mat.rotateY(l).rotateX(-h);
                }
                this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
                var p = !this._prevMat.equals(this.mat);
                if ((p || this.pe._mdf) && this.comp.threeDElements) {
                    var f, c, m;
                    for(e = this.comp.threeDElements.length, t = 0; t < e; t += 1)if ("3d" === (f = this.comp.threeDElements[t]).type) {
                        if (p) {
                            var d = this.mat.toCSS();
                            (m = f.container.style).transform = d, m.webkitTransform = d;
                        }
                        this.pe._mdf && ((c = f.perspectiveElem.style).perspective = this.pe.v + "px", c.webkitPerspective = this.pe.v + "px");
                    }
                    this.mat.clone(this._prevMat);
                }
            }
            this._isFirstFrame = !1;
        }, HCameraElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, HCameraElement.prototype.destroy = function() {}, HCameraElement.prototype.getBaseElement = function() {
            return null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HSolidElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HImageElement), HImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData), e = new Image;
            this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(e), e.crossOrigin = "anonymous", e.src = t, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
        }, extendPrototype([
            BaseRenderer
        ], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, HybridRendererBase.prototype.appendElementInPos = function(t, e) {
            var r = t.getBaseElement();
            if (r) {
                var i = this.layers[e];
                if (i.ddd && this.supports3d) this.addTo3dContainer(r, e);
                else if (this.threeDElements) this.addTo3dContainer(r, e);
                else {
                    for(var a, s, n = 0; n < e;)this.elements[n] && !0 !== this.elements[n] && this.elements[n].getBaseElement && (s = this.elements[n], a = (this.layers[n].ddd ? this.getThreeDContainerByPos(n) : s.getBaseElement()) || a), n += 1;
                    a ? i.ddd && this.supports3d || this.layerElement.insertBefore(r, a) : i.ddd && this.supports3d || this.layerElement.appendChild(r);
                }
            }
        }, HybridRendererBase.prototype.createShape = function(t) {
            return this.supports3d ? new HShapeElement(t, this.globalData, this) : new SVGShapeElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createText = function(t) {
            return this.supports3d ? new HTextElement(t, this.globalData, this) : new SVGTextLottieElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createCamera = function(t) {
            return this.camera = new HCameraElement(t, this.globalData, this), this.camera;
        }, HybridRendererBase.prototype.createImage = function(t) {
            return this.supports3d ? new HImageElement(t, this.globalData, this) : new IImageElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createSolid = function(t) {
            return this.supports3d ? new HSolidElement(t, this.globalData, this) : new ISolidElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t) {
            for(var e = 0, r = this.threeDElements.length; e < r;){
                if (this.threeDElements[e].startPos <= t && this.threeDElements[e].endPos >= t) return this.threeDElements[e].perspectiveElem;
                e += 1;
            }
            return null;
        }, HybridRendererBase.prototype.createThreeDContainer = function(t, e) {
            var r, i, a = createTag("div");
            styleDiv(a);
            var s = createTag("div");
            if (styleDiv(s), "3d" === e) {
                (r = a.style).width = this.globalData.compSize.w + "px", r.height = this.globalData.compSize.h + "px";
                r.webkitTransformOrigin = "50% 50%", r.mozTransformOrigin = "50% 50%", r.transformOrigin = "50% 50%";
                var n = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                (i = s.style).transform = n, i.webkitTransform = n;
            }
            a.appendChild(s);
            var o = {
                container: s,
                perspectiveElem: a,
                startPos: t,
                endPos: t,
                type: e
            };
            return this.threeDElements.push(o), o;
        }, HybridRendererBase.prototype.build3dContainers = function() {
            var t, e, r = this.layers.length, i = "";
            for(t = 0; t < r; t += 1)this.layers[t].ddd && 3 !== this.layers[t].ty ? ("3d" !== i && (i = "3d", e = this.createThreeDContainer(t, "3d")), e.endPos = Math.max(e.endPos, t)) : ("2d" !== i && (i = "2d", e = this.createThreeDContainer(t, "2d")), e.endPos = Math.max(e.endPos, t));
            for(t = (r = this.threeDElements.length) - 1; t >= 0; t -= 1)this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
        }, HybridRendererBase.prototype.addTo3dContainer = function(t, e) {
            for(var r = 0, i = this.threeDElements.length; r < i;){
                if (e <= this.threeDElements[r].endPos) {
                    for(var a, s = this.threeDElements[r].startPos; s < e;)this.elements[s] && this.elements[s].getBaseElement && (a = this.elements[s].getBaseElement()), s += 1;
                    a ? this.threeDElements[r].container.insertBefore(t, a) : this.threeDElements[r].container.appendChild(t);
                    break;
                }
                r += 1;
            }
        }, HybridRendererBase.prototype.configAnimation = function(t) {
            var e = createTag("div"), r = this.animationItem.wrapper, i = e.style;
            i.width = t.w + "px", i.height = t.h + "px", this.resizerElem = e, styleDiv(e), i.transformStyle = "flat", i.mozTransformStyle = "flat", i.webkitTransformStyle = "flat", this.renderConfig.className && e.setAttribute("class", this.renderConfig.className), r.appendChild(e), i.overflow = "hidden";
            var a = createNS("svg");
            a.setAttribute("width", "1"), a.setAttribute("height", "1"), styleDiv(a), this.resizerElem.appendChild(a);
            var s = createNS("defs");
            a.appendChild(s), this.data = t, this.setupGlobalData(t, a), this.globalData.defs = s, this.layers = t.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
        }, HybridRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, HybridRendererBase.prototype.updateContainerSize = function() {
            var t, e, r, i, a = this.animationItem.wrapper.offsetWidth, s = this.animationItem.wrapper.offsetHeight, n = a / s;
            this.globalData.compSize.w / this.globalData.compSize.h > n ? (t = a / this.globalData.compSize.w, e = a / this.globalData.compSize.w, r = 0, i = (s - this.globalData.compSize.h * (a / this.globalData.compSize.w)) / 2) : (t = s / this.globalData.compSize.h, e = s / this.globalData.compSize.h, r = (a - this.globalData.compSize.w * (s / this.globalData.compSize.h)) / 2, i = 0);
            var o = this.resizerElem.style;
            o.webkitTransform = "matrix3d(" + t + ",0,0,0,0," + e + ",0,0,0,0,1,0," + r + "," + i + ",0,1)", o.transform = o.webkitTransform;
        }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
            this.resizerElem.style.display = "none";
        }, HybridRendererBase.prototype.show = function() {
            this.resizerElem.style.display = "block";
        }, HybridRendererBase.prototype.initItems = function() {
            if (this.buildAllItems(), this.camera) this.camera.setup();
            else {
                var t, e = this.globalData.compSize.w, r = this.globalData.compSize.h, i = this.threeDElements.length;
                for(t = 0; t < i; t += 1){
                    var a = this.threeDElements[t].perspectiveElem.style;
                    a.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(r, 2)) + "px", a.perspective = a.webkitPerspective;
                }
            }
        }, HybridRendererBase.prototype.searchExtraCompositions = function(t) {
            var e, r = t.length, i = createTag("div");
            for(e = 0; e < r; e += 1)if (t[e].xt) {
                var a = this.createComp(t[e], i, this.globalData.comp, null);
                a.initExpressions(), this.globalData.projectInterface.registerComposition(a);
            }
        }, extendPrototype([
            HybridRendererBase,
            ICompElement,
            HBaseElement
        ], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
            this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
        }, HCompElement.prototype.addTo3dContainer = function(t, e) {
            for(var r, i = 0; i < e;)this.elements[i] && this.elements[i].getBaseElement && (r = this.elements[i].getBaseElement()), i += 1;
            r ? this.layerElement.insertBefore(t, r) : this.layerElement.appendChild(t);
        }, HCompElement.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            HybridRendererBase
        ], HybridRenderer), HybridRenderer.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        };
        var CompExpressionInterface = function(t) {
            function e(e) {
                for(var r = 0, i = t.layers.length; r < i;){
                    if (t.layers[r].nm === e || t.layers[r].ind === e) return t.elements[r].layerInterface;
                    r += 1;
                }
                return null;
            }
            return Object.defineProperty(e, "_name", {
                value: t.data.nm
            }), e.layer = e, e.pixelAspect = 1, e.height = t.data.h || t.globalData.compSize.h, e.width = t.data.w || t.globalData.compSize.w, e.pixelAspect = 1, e.frameDuration = 1 / t.globalData.frameRate, e.displayStartTime = 0, e.numLayers = t.layers.length, e;
        };
        function _typeof$2(t) {
            return (_typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        function seedRandom(t, e) {
            var r = this, i = e.pow(256, 6), a = e.pow(2, 52), s = 2 * a;
            function n(t) {
                var e, r = t.length, i = this, a = 0, s = i.i = i.j = 0, n = i.S = [];
                for(r || (t = [
                    r++
                ]); a < 256;)n[a] = a++;
                for(a = 0; a < 256; a++)n[a] = n[s = 255 & s + t[a % r] + (e = n[a])], n[s] = e;
                i.g = function(t) {
                    for(var e, r = 0, a = i.i, s = i.j, n = i.S; t--;)e = n[a = 255 & a + 1], r = 256 * r + n[255 & (n[a] = n[s = 255 & s + e]) + (n[s] = e)];
                    return i.i = a, i.j = s, r;
                };
            }
            function o(t, e) {
                return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
            }
            function h(t, e) {
                for(var r, i = t + "", a = 0; a < i.length;)e[255 & a] = 255 & (r ^= 19 * e[255 & a]) + i.charCodeAt(a++);
                return l(e);
            }
            function l(t) {
                return String.fromCharCode.apply(0, t);
            }
            e.seedrandom = function(p, f, c) {
                var m = [], d = h(function t(e, r) {
                    var i, a = [], s = _typeof$2(e);
                    if (r && "object" == s) for(i in e)try {
                        a.push(t(e[i], r - 1));
                    } catch (t) {}
                    return a.length ? a : "string" == s ? e : e + "\0";
                }((f = !0 === f ? {
                    entropy: !0
                } : f || {}).entropy ? [
                    p,
                    l(t)
                ] : null === p ? function() {
                    try {
                        var e = new Uint8Array(256);
                        return (r.crypto || r.msCrypto).getRandomValues(e), l(e);
                    } catch (e) {
                        var i = r.navigator, a = i && i.plugins;
                        return [
                            +new Date,
                            r,
                            a,
                            r.screen,
                            l(t)
                        ];
                    }
                }() : p, 3), m), u = new n(m), y = function() {
                    for(var t = u.g(6), e = i, r = 0; t < a;)t = 256 * (t + r), e *= 256, r = u.g(1);
                    for(; t >= s;)t /= 2, e /= 2, r >>>= 1;
                    return (t + r) / e;
                };
                return y.int32 = function() {
                    return 0 | u.g(4);
                }, y.quick = function() {
                    return u.g(4) / 4294967296;
                }, y.double = y, h(l(u.S), t), (f.pass || c || function(t, r, i, a) {
                    return a && (a.S && o(a, u), t.state = function() {
                        return o(u, {});
                    }), i ? (e.random = t, r) : t;
                })(y, d, "global" in f ? f.global : this == e, f.state);
            }, h(e.random(), t);
        }
        function initialize$2(t) {
            seedRandom([], t);
        }
        var propTypes = {
            SHAPE: "shape"
        };
        function _typeof$1(t) {
            return (_typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var ExpressionManager = function() {
            var ob = {}, Math1 = BMMath, window1 = null, document1 = null, XMLHttpRequest1 = null, fetch1 = null, frames = null, _lottieGlobal = {};
            function resetFrame() {
                _lottieGlobal = {};
            }
            function $bm_isInstanceOfArray(t) {
                return t.constructor === Array || t.constructor === Float32Array;
            }
            function isNumerable(t, e) {
                return "number" === t || e instanceof Number || "boolean" === t || "string" === t;
            }
            function $bm_neg(t) {
                var e = _typeof$1(t);
                if ("number" === e || t instanceof Number || "boolean" === e) return -t;
                if ($bm_isInstanceOfArray(t)) {
                    var r, i = t.length, a = [];
                    for(r = 0; r < i; r += 1)a[r] = -t[r];
                    return a;
                }
                return t.propType ? t.v : -t;
            }
            initialize$2(BMMath);
            var easeInBez = BezierFactory.getBezierEasing(.333, 0, .833, .833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(.167, .167, .667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(.33, 0, .667, 1, "easeInOut").get;
            function sum(t, e) {
                var r = _typeof$1(t), i = _typeof$1(e);
                if (isNumerable(r, t) && isNumerable(i, e) || "string" === r || "string" === i) return t + e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return (t = t.slice(0))[0] += e, t;
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t + e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var a = 0, s = t.length, n = e.length, o = []; a < s || a < n;)("number" == typeof t[a] || t[a] instanceof Number) && ("number" == typeof e[a] || e[a] instanceof Number) ? o[a] = t[a] + e[a] : o[a] = void 0 === e[a] ? t[a] : t[a] || e[a], a += 1;
                    return o;
                }
                return 0;
            }
            var add = sum;
            function sub(t, e) {
                var r = _typeof$1(t), i = _typeof$1(e);
                if (isNumerable(r, t) && isNumerable(i, e)) return "string" === r && (t = parseInt(t, 10)), "string" === i && (e = parseInt(e, 10)), t - e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return (t = t.slice(0))[0] -= e, t;
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t - e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var a = 0, s = t.length, n = e.length, o = []; a < s || a < n;)("number" == typeof t[a] || t[a] instanceof Number) && ("number" == typeof e[a] || e[a] instanceof Number) ? o[a] = t[a] - e[a] : o[a] = void 0 === e[a] ? t[a] : t[a] || e[a], a += 1;
                    return o;
                }
                return 0;
            }
            function mul(t, e) {
                var r, i, a, s = _typeof$1(t), n = _typeof$1(e);
                if (isNumerable(s, t) && isNumerable(n, e)) return t * e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(a = t.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t[i] * e;
                    return r;
                }
                if (isNumerable(s, t) && $bm_isInstanceOfArray(e)) {
                    for(a = e.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t * e[i];
                    return r;
                }
                return 0;
            }
            function div(t, e) {
                var r, i, a, s = _typeof$1(t), n = _typeof$1(e);
                if (isNumerable(s, t) && isNumerable(n, e)) return t / e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(a = t.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t[i] / e;
                    return r;
                }
                if (isNumerable(s, t) && $bm_isInstanceOfArray(e)) {
                    for(a = e.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t / e[i];
                    return r;
                }
                return 0;
            }
            function mod(t, e) {
                return "string" == typeof t && (t = parseInt(t, 10)), "string" == typeof e && (e = parseInt(e, 10)), t % e;
            }
            var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
            function clamp(t, e, r) {
                if (e > r) {
                    var i = r;
                    r = e, e = i;
                }
                return Math1.min(Math1.max(t, e), r);
            }
            function radiansToDegrees(t) {
                return t / degToRads;
            }
            var radians_to_degrees = radiansToDegrees;
            function degreesToRadians(t) {
                return t * degToRads;
            }
            var degrees_to_radians = radiansToDegrees, helperLengthArray = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            function length(t, e) {
                if ("number" == typeof t || t instanceof Number) return e = e || 0, Math1.abs(t - e);
                var r;
                e || (e = helperLengthArray);
                var i = Math1.min(t.length, e.length), a = 0;
                for(r = 0; r < i; r += 1)a += Math1.pow(e[r] - t[r], 2);
                return Math1.sqrt(a);
            }
            function normalize(t) {
                return div(t, length(t));
            }
            function rgbToHsl(t) {
                var e, r, i = t[0], a = t[1], s = t[2], n = Math1.max(i, a, s), o = Math1.min(i, a, s), h = (n + o) / 2;
                if (n === o) e = 0, r = 0;
                else {
                    var l = n - o;
                    switch(r = h > .5 ? l / (2 - n - o) : l / (n + o), n){
                        case i:
                            e = (a - s) / l + (a < s ? 6 : 0);
                            break;
                        case a:
                            e = (s - i) / l + 2;
                            break;
                        case s:
                            e = (i - a) / l + 4;
                    }
                    e /= 6;
                }
                return [
                    e,
                    r,
                    h,
                    t[3]
                ];
            }
            function hue2rgb(t, e, r) {
                return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
            }
            function hslToRgb(t) {
                var e, r, i, a = t[0], s = t[1], n = t[2];
                if (0 === s) e = n, i = n, r = n;
                else {
                    var o = n < .5 ? n * (1 + s) : n + s - n * s, h = 2 * n - o;
                    e = hue2rgb(h, o, a + 1 / 3), r = hue2rgb(h, o, a), i = hue2rgb(h, o, a - 1 / 3);
                }
                return [
                    e,
                    r,
                    i,
                    t[3]
                ];
            }
            function linear(t, e, r, i, a) {
                if (void 0 !== i && void 0 !== a || (i = e, a = r, e = 0, r = 1), r < e) {
                    var s = r;
                    r = e, e = s;
                }
                if (t <= e) return i;
                if (t >= r) return a;
                var n, o = r === e ? 0 : (t - e) / (r - e);
                if (!i.length) return i + (a - i) * o;
                var h = i.length, l = createTypedArray("float32", h);
                for(n = 0; n < h; n += 1)l[n] = i[n] + (a[n] - i[n]) * o;
                return l;
            }
            function random(t, e) {
                if (void 0 === e && (void 0 === t ? (t = 0, e = 1) : (e = t, t = void 0)), e.length) {
                    var r, i = e.length;
                    t || (t = createTypedArray("float32", i));
                    var a = createTypedArray("float32", i), s = BMMath.random();
                    for(r = 0; r < i; r += 1)a[r] = t[r] + s * (e[r] - t[r]);
                    return a;
                }
                return void 0 === t && (t = 0), t + BMMath.random() * (e - t);
            }
            function createPath(t, e, r, i) {
                var a, s = t.length, n = shapePool.newElement();
                n.setPathData(!!i, s);
                var o, h, l = [
                    0,
                    0
                ];
                for(a = 0; a < s; a += 1)o = e && e[a] ? e[a] : l, h = r && r[a] ? r[a] : l, n.setTripleAt(t[a][0], t[a][1], h[0] + t[a][0], h[1] + t[a][1], o[0] + t[a][0], o[1] + t[a][1], a, !0);
                return n;
            }
            function initiateExpression(elem, data, property) {
                function noOp(t) {
                    return t;
                }
                if (!elem.globalData.renderConfig.runExpressions) return noOp;
                var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = -1 !== val.indexOf("random"), elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
                thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
                    get: function() {
                        return thisProperty.v;
                    }
                }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
                var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || !0 !== this.data.hd, wiggle = (function(t, e) {
                    var r, i, a = this.pv.length ? this.pv.length : 1, s = createTypedArray("float32", a);
                    var n = Math1.floor(5 * time);
                    for(r = 0, i = 0; r < n;){
                        for(i = 0; i < a; i += 1)s[i] += -e + 2 * e * BMMath.random();
                        r += 1;
                    }
                    var o = 5 * time, h = o - Math1.floor(o), l = createTypedArray("float32", a);
                    if (a > 1) {
                        for(i = 0; i < a; i += 1)l[i] = this.pv[i] + s[i] + (-e + 2 * e * BMMath.random()) * h;
                        return l;
                    }
                    return this.pv + s[0] + (-e + 2 * e * BMMath.random()) * h;
                }).bind(this);
                function loopInDuration(t, e) {
                    return loopIn(t, e, !0);
                }
                function loopOutDuration(t, e) {
                    return loopOut(t, e, !0);
                }
                thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
                function lookAt(t, e) {
                    var r = [
                        e[0] - t[0],
                        e[1] - t[1],
                        e[2] - t[2]
                    ], i = Math1.atan2(r[0], Math1.sqrt(r[1] * r[1] + r[2] * r[2])) / degToRads;
                    return [
                        -Math1.atan2(r[1], r[2]) / degToRads,
                        i,
                        0
                    ];
                }
                function easeOut(t, e, r, i, a) {
                    return applyEase(easeOutBez, t, e, r, i, a);
                }
                function easeIn(t, e, r, i, a) {
                    return applyEase(easeInBez, t, e, r, i, a);
                }
                function ease(t, e, r, i, a) {
                    return applyEase(easeInOutBez, t, e, r, i, a);
                }
                function applyEase(t, e, r, i, a, s) {
                    void 0 === a ? (a = r, s = i) : e = (e - r) / (i - r), e > 1 ? e = 1 : e < 0 && (e = 0);
                    var n = t(e);
                    if ($bm_isInstanceOfArray(a)) {
                        var o, h = a.length, l = createTypedArray("float32", h);
                        for(o = 0; o < h; o += 1)l[o] = (s[o] - a[o]) * n + a[o];
                        return l;
                    }
                    return (s - a) * n + a;
                }
                function nearestKey(t) {
                    var e, r, i, a = data.k.length;
                    if (data.k.length && "number" != typeof data.k[0]) {
                        if (r = -1, (t *= elem.comp.globalData.frameRate) < data.k[0].t) r = 1, i = data.k[0].t;
                        else {
                            for(e = 0; e < a - 1; e += 1){
                                if (t === data.k[e].t) {
                                    r = e + 1, i = data.k[e].t;
                                    break;
                                }
                                if (t > data.k[e].t && t < data.k[e + 1].t) {
                                    t - data.k[e].t > data.k[e + 1].t - t ? (r = e + 2, i = data.k[e + 1].t) : (r = e + 1, i = data.k[e].t);
                                    break;
                                }
                            }
                            -1 === r && (r = e + 1, i = data.k[e].t);
                        }
                    } else r = 0, i = 0;
                    var s = {};
                    return s.index = r, s.time = i / elem.comp.globalData.frameRate, s;
                }
                function key(t) {
                    var e, r, i;
                    if (!data.k.length || "number" == typeof data.k[0]) throw new Error("The property has no keyframe at index " + t);
                    t -= 1, e = {
                        time: data.k[t].t / elem.comp.globalData.frameRate,
                        value: []
                    };
                    var a = Object.prototype.hasOwnProperty.call(data.k[t], "s") ? data.k[t].s : data.k[t - 1].e;
                    for(i = a.length, r = 0; r < i; r += 1)e[r] = a[r], e.value[r] = a[r];
                    return e;
                }
                function framesToTime(t, e) {
                    return e || (e = elem.comp.globalData.frameRate), t / e;
                }
                function timeToFrames(t, e) {
                    return t || 0 === t || (t = time), e || (e = elem.comp.globalData.frameRate), t * e;
                }
                function seedRandom(t) {
                    BMMath.seedrandom(randSeed + t);
                }
                function sourceRectAtTime() {
                    return elem.sourceRectAtTime();
                }
                function substring(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substring(t) : value.substring(t, e) : "";
                }
                function substr(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substr(t) : value.substr(t, e) : "";
                }
                function posterizeTime(t) {
                    time = 0 === t ? 0 : Math1.floor(time * t) / t, value = valueAtTime(time);
                }
                var index = elem.data.ind, hasParent = !(!elem.hierarchy || !elem.hierarchy.length), parent, randSeed = Math1.floor(1e6 * Math1.random()), globalData = elem.globalData;
                function executeExpression(t) {
                    return value = t, this.frameExpressionId === elem.globalData.frameId && "textSelector" !== this.propType ? value : ("textSelector" === this.propType && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), 4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
                }
                return executeExpression.__preventDeadCodeRemoval = [
                    $bm_transform,
                    anchorPoint,
                    time,
                    velocity,
                    inPoint,
                    outPoint,
                    width,
                    height,
                    name,
                    loop_in,
                    loop_out,
                    smooth,
                    toComp,
                    fromCompToSurface,
                    toWorld,
                    fromWorld,
                    mask,
                    position,
                    rotation,
                    scale,
                    thisComp,
                    numKeys,
                    active,
                    wiggle,
                    loopInDuration,
                    loopOutDuration,
                    comp,
                    lookAt,
                    easeOut,
                    easeIn,
                    ease,
                    nearestKey,
                    key,
                    text,
                    textIndex,
                    textTotal,
                    selectorValue,
                    framesToTime,
                    timeToFrames,
                    sourceRectAtTime,
                    substring,
                    substr,
                    posterizeTime,
                    index,
                    globalData
                ], executeExpression;
            }
            return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [
                window1,
                document1,
                XMLHttpRequest1,
                fetch1,
                frames,
                $bm_neg,
                add,
                $bm_sum,
                $bm_sub,
                $bm_mul,
                $bm_div,
                $bm_mod,
                clamp,
                radians_to_degrees,
                degreesToRadians,
                degrees_to_radians,
                normalize,
                rgbToHsl,
                hslToRgb,
                linear,
                random,
                createPath,
                _lottieGlobal
            ], ob.resetFrame = resetFrame, ob;
        }(), Expressions = function() {
            var t = {};
            return t.initExpressions = function(t) {
                var e = 0, r = [];
                t.renderer.compInterface = CompExpressionInterface(t.renderer), t.renderer.globalData.projectInterface.registerComposition(t.renderer), t.renderer.globalData.pushExpression = function() {
                    e += 1;
                }, t.renderer.globalData.popExpression = function() {
                    0 === (e -= 1) && function() {
                        var t, e = r.length;
                        for(t = 0; t < e; t += 1)r[t].release();
                        r.length = 0;
                    }();
                }, t.renderer.globalData.registerExpressionProperty = function(t) {
                    -1 === r.indexOf(t) && r.push(t);
                };
            }, t.resetFrame = ExpressionManager.resetFrame, t;
        }(), MaskManagerInterface = function() {
            function t(t, e) {
                this._mask = t, this._data = e;
            }
            Object.defineProperty(t.prototype, "maskPath", {
                get: function() {
                    return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                }
            }), Object.defineProperty(t.prototype, "maskOpacity", {
                get: function() {
                    return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
                }
            });
            return function(e) {
                var r, i = createSizedArray(e.viewData.length), a = e.viewData.length;
                for(r = 0; r < a; r += 1)i[r] = new t(e.viewData[r], e.masksProperties[r]);
                return function(t) {
                    for(r = 0; r < a;){
                        if (e.masksProperties[r].nm === t) return i[r];
                        r += 1;
                    }
                    return null;
                };
            };
        }(), ExpressionPropertyInterface = function() {
            var t = {
                pv: 0,
                v: 0,
                mult: 1
            }, e = {
                pv: [
                    0,
                    0,
                    0
                ],
                v: [
                    0,
                    0,
                    0
                ],
                mult: 1
            };
            function r(t, e, r) {
                Object.defineProperty(t, "velocity", {
                    get: function() {
                        return e.getVelocityAtTime(e.comp.currentFrame);
                    }
                }), t.numKeys = e.keyframes ? e.keyframes.length : 0, t.key = function(i) {
                    if (!t.numKeys) return 0;
                    var a = "";
                    a = "s" in e.keyframes[i - 1] ? e.keyframes[i - 1].s : "e" in e.keyframes[i - 2] ? e.keyframes[i - 2].e : e.keyframes[i - 2].s;
                    var s = "unidimensional" === r ? new Number(a) : Object.assign({}, a);
                    return s.time = e.keyframes[i - 1].t / e.elem.comp.globalData.frameRate, s.value = "unidimensional" === r ? a[0] : a, s;
                }, t.valueAtTime = e.getValueAtTime, t.speedAtTime = e.getSpeedAtTime, t.velocityAtTime = e.getVelocityAtTime, t.propertyGroup = e.propertyGroup;
            }
            function i() {
                return t;
            }
            return function(a) {
                return a ? "unidimensional" === a.propType ? function(e) {
                    e && "pv" in e || (e = t);
                    var i = 1 / e.mult, a = e.pv * i, s = new Number(a);
                    return s.value = a, r(s, e, "unidimensional"), function() {
                        return e.k && e.getValue(), a = e.v * i, s.value !== a && ((s = new Number(a)).value = a, r(s, e, "unidimensional")), s;
                    };
                }(a) : function(t) {
                    t && "pv" in t || (t = e);
                    var i = 1 / t.mult, a = t.data && t.data.l || t.pv.length, s = createTypedArray("float32", a), n = createTypedArray("float32", a);
                    return s.value = n, r(s, t, "multidimensional"), function() {
                        t.k && t.getValue();
                        for(var e = 0; e < a; e += 1)n[e] = t.v[e] * i, s[e] = n[e];
                        return s;
                    };
                }(a) : i;
            };
        }(), TransformExpressionInterface = function(t) {
            function e(t) {
                switch(t){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return e.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return e.rotation;
                    case "ADBE Rotate X":
                        return e.xRotation;
                    case "ADBE Rotate Y":
                        return e.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return e.position;
                    case "ADBE Position_0":
                        return e.xPosition;
                    case "ADBE Position_1":
                        return e.yPosition;
                    case "ADBE Position_2":
                        return e.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return e.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return e.opacity;
                    default:
                        return null;
                }
            }
            var r, i, a, s;
            return Object.defineProperty(e, "rotation", {
                get: ExpressionPropertyInterface(t.r || t.rz)
            }), Object.defineProperty(e, "zRotation", {
                get: ExpressionPropertyInterface(t.rz || t.r)
            }), Object.defineProperty(e, "xRotation", {
                get: ExpressionPropertyInterface(t.rx)
            }), Object.defineProperty(e, "yRotation", {
                get: ExpressionPropertyInterface(t.ry)
            }), Object.defineProperty(e, "scale", {
                get: ExpressionPropertyInterface(t.s)
            }), t.p ? s = ExpressionPropertyInterface(t.p) : (r = ExpressionPropertyInterface(t.px), i = ExpressionPropertyInterface(t.py), t.pz && (a = ExpressionPropertyInterface(t.pz))), Object.defineProperty(e, "position", {
                get: function() {
                    return t.p ? s() : [
                        r(),
                        i(),
                        a ? a() : 0
                    ];
                }
            }), Object.defineProperty(e, "xPosition", {
                get: ExpressionPropertyInterface(t.px)
            }), Object.defineProperty(e, "yPosition", {
                get: ExpressionPropertyInterface(t.py)
            }), Object.defineProperty(e, "zPosition", {
                get: ExpressionPropertyInterface(t.pz)
            }), Object.defineProperty(e, "anchorPoint", {
                get: ExpressionPropertyInterface(t.a)
            }), Object.defineProperty(e, "opacity", {
                get: ExpressionPropertyInterface(t.o)
            }), Object.defineProperty(e, "skew", {
                get: ExpressionPropertyInterface(t.sk)
            }), Object.defineProperty(e, "skewAxis", {
                get: ExpressionPropertyInterface(t.sa)
            }), Object.defineProperty(e, "orientation", {
                get: ExpressionPropertyInterface(t.or)
            }), e;
        }, LayerExpressionInterface = function() {
            function t(t) {
                var e = new Matrix;
                void 0 !== t ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e) : this._elem.finalTransform.mProp.applyToMatrix(e);
                return e;
            }
            function e(t, e) {
                var r = this.getMatrix(e);
                return r.props[12] = 0, r.props[13] = 0, r.props[14] = 0, this.applyPoint(r, t);
            }
            function r(t, e) {
                var r = this.getMatrix(e);
                return this.applyPoint(r, t);
            }
            function i(t, e) {
                var r = this.getMatrix(e);
                return r.props[12] = 0, r.props[13] = 0, r.props[14] = 0, this.invertPoint(r, t);
            }
            function a(t, e) {
                var r = this.getMatrix(e);
                return this.invertPoint(r, t);
            }
            function s(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                }
                return t.applyToPointArray(e[0], e[1], e[2] || 0);
            }
            function n(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                }
                return t.inversePoint(e);
            }
            function o(t) {
                var e = new Matrix;
                if (e.reset(), this._elem.finalTransform.mProp.applyToMatrix(e), this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(e);
                    return e.inversePoint(t);
                }
                return e.inversePoint(t);
            }
            function h() {
                return [
                    1,
                    1,
                    1,
                    1
                ];
            }
            return function(l) {
                var p;
                function f(t) {
                    switch(t){
                        case "ADBE Root Vectors Group":
                        case "Contents":
                        case 2:
                            return f.shapeInterface;
                        case 1:
                        case 6:
                        case "Transform":
                        case "transform":
                        case "ADBE Transform Group":
                            return p;
                        case 4:
                        case "ADBE Effect Parade":
                        case "effects":
                        case "Effects":
                            return f.effect;
                        case "ADBE Text Properties":
                            return f.textInterface;
                        default:
                            return null;
                    }
                }
                f.getMatrix = t, f.invertPoint = n, f.applyPoint = s, f.toWorld = r, f.toWorldVec = e, f.fromWorld = a, f.fromWorldVec = i, f.toComp = r, f.fromComp = o, f.sampleImage = h, f.sourceRectAtTime = l.sourceRectAtTime.bind(l), f._elem = l;
                var c = getDescriptor(p = TransformExpressionInterface(l.finalTransform.mProp), "anchorPoint");
                return Object.defineProperties(f, {
                    hasParent: {
                        get: function() {
                            return l.hierarchy.length;
                        }
                    },
                    parent: {
                        get: function() {
                            return l.hierarchy[0].layerInterface;
                        }
                    },
                    rotation: getDescriptor(p, "rotation"),
                    scale: getDescriptor(p, "scale"),
                    position: getDescriptor(p, "position"),
                    opacity: getDescriptor(p, "opacity"),
                    anchorPoint: c,
                    anchor_point: c,
                    transform: {
                        get: function() {
                            return p;
                        }
                    },
                    active: {
                        get: function() {
                            return l.isInRange;
                        }
                    }
                }), f.startTime = l.data.st, f.index = l.data.ind, f.source = l.data.refId, f.height = 0 === l.data.ty ? l.data.h : 100, f.width = 0 === l.data.ty ? l.data.w : 100, f.inPoint = l.data.ip / l.comp.globalData.frameRate, f.outPoint = l.data.op / l.comp.globalData.frameRate, f._name = l.data.nm, f.registerMaskInterface = function(t) {
                    f.mask = new MaskManagerInterface(t, l);
                }, f.registerEffectsInterface = function(t) {
                    f.effect = t;
                }, f;
            };
        }(), propertyGroupFactory = function(t, e) {
            return function(r) {
                return (r = void 0 === r ? 1 : r) <= 0 ? t : e(r - 1);
            };
        }, PropertyInterface = function(t, e) {
            var r = {
                _name: t
            };
            return function(t) {
                return (t = void 0 === t ? 1 : t) <= 0 ? r : e(t - 1);
            };
        }, EffectsExpressionInterface = function() {
            function t(r, i, a, s) {
                function n(t) {
                    for(var e = r.ef, i = 0, a = e.length; i < a;){
                        if (t === e[i].nm || t === e[i].mn || t === e[i].ix) return 5 === e[i].ty ? l[i] : l[i]();
                        i += 1;
                    }
                    throw new Error;
                }
                var o, h = propertyGroupFactory(n, a), l = [], p = r.ef.length;
                for(o = 0; o < p; o += 1)5 === r.ef[o].ty ? l.push(t(r.ef[o], i.effectElements[o], i.effectElements[o].propertyGroup, s)) : l.push(e(i.effectElements[o], r.ef[o].ty, s, h));
                return "ADBE Color Control" === r.mn && Object.defineProperty(n, "color", {
                    get: function() {
                        return l[0]();
                    }
                }), Object.defineProperties(n, {
                    numProperties: {
                        get: function() {
                            return r.np;
                        }
                    },
                    _name: {
                        value: r.nm
                    },
                    propertyGroup: {
                        value: h
                    }
                }), n.enabled = 0 !== r.en, n.active = n.enabled, n;
            }
            function e(t, e, r, i) {
                var a = ExpressionPropertyInterface(t.p);
                return t.p.setGroupProperty && t.p.setGroupProperty(PropertyInterface("", i)), function() {
                    return 10 === e ? r.comp.compInterface(t.p.v) : a();
                };
            }
            return {
                createEffectsInterface: function(e, r) {
                    if (e.effectsManager) {
                        var i, a = [], s = e.data.ef, n = e.effectsManager.effectElements.length;
                        for(i = 0; i < n; i += 1)a.push(t(s[i], e.effectsManager.effectElements[i], r, e));
                        var o = e.data.ef || [], h = function(t) {
                            for(i = 0, n = o.length; i < n;){
                                if (t === o[i].nm || t === o[i].mn || t === o[i].ix) return a[i];
                                i += 1;
                            }
                            return null;
                        };
                        return Object.defineProperty(h, "numProperties", {
                            get: function() {
                                return o.length;
                            }
                        }), h;
                    }
                    return null;
                }
            };
        }(), ShapePathInterface = function(t, e, r) {
            var i = e.sh;
            function a(t) {
                return "Shape" === t || "shape" === t || "Path" === t || "path" === t || "ADBE Vector Shape" === t || 2 === t ? a.path : null;
            }
            var s = propertyGroupFactory(a, r);
            return i.setGroupProperty(PropertyInterface("Path", s)), Object.defineProperties(a, {
                path: {
                    get: function() {
                        return i.k && i.getValue(), i;
                    }
                },
                shape: {
                    get: function() {
                        return i.k && i.getValue(), i;
                    }
                },
                _name: {
                    value: t.nm
                },
                ix: {
                    value: t.ix
                },
                propertyIndex: {
                    value: t.ix
                },
                mn: {
                    value: t.mn
                },
                propertyGroup: {
                    value: r
                }
            }), a;
        }, ShapeExpressionInterface = function() {
            function t(t, o, m) {
                var d, u = [], y = t ? t.length : 0;
                for(d = 0; d < y; d += 1)"gr" === t[d].ty ? u.push(e(t[d], o[d], m)) : "fl" === t[d].ty ? u.push(r(t[d], o[d], m)) : "st" === t[d].ty ? u.push(s(t[d], o[d], m)) : "tm" === t[d].ty ? u.push(n(t[d], o[d], m)) : "tr" === t[d].ty || ("el" === t[d].ty ? u.push(h(t[d], o[d], m)) : "sr" === t[d].ty ? u.push(l(t[d], o[d], m)) : "sh" === t[d].ty ? u.push(ShapePathInterface(t[d], o[d], m)) : "rc" === t[d].ty ? u.push(p(t[d], o[d], m)) : "rd" === t[d].ty ? u.push(f(t[d], o[d], m)) : "rp" === t[d].ty ? u.push(c(t[d], o[d], m)) : "gf" === t[d].ty ? u.push(i(t[d], o[d], m)) : u.push(a(t[d], o[d])));
                return u;
            }
            function e(e, r, i) {
                var a = function(t) {
                    switch(t){
                        case "ADBE Vectors Group":
                        case "Contents":
                        case 2:
                            return a.content;
                        default:
                            return a.transform;
                    }
                };
                a.propertyGroup = propertyGroupFactory(a, i);
                var s = function(e, r, i) {
                    var a, s = function(t) {
                        for(var e = 0, r = a.length; e < r;){
                            if (a[e]._name === t || a[e].mn === t || a[e].propertyIndex === t || a[e].ix === t || a[e].ind === t) return a[e];
                            e += 1;
                        }
                        return "number" == typeof t ? a[t - 1] : null;
                    };
                    s.propertyGroup = propertyGroupFactory(s, i), a = t(e.it, r.it, s.propertyGroup), s.numProperties = a.length;
                    var n = o(e.it[e.it.length - 1], r.it[r.it.length - 1], s.propertyGroup);
                    return s.transform = n, s.propertyIndex = e.cix, s._name = e.nm, s;
                }(e, r, a.propertyGroup), n = o(e.it[e.it.length - 1], r.it[r.it.length - 1], a.propertyGroup);
                return a.content = s, a.transform = n, Object.defineProperty(a, "_name", {
                    get: function() {
                        return e.nm;
                    }
                }), a.numProperties = e.np, a.propertyIndex = e.ix, a.nm = e.nm, a.mn = e.mn, a;
            }
            function r(t, e, r) {
                function i(t) {
                    return "Color" === t || "color" === t ? i.color : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", r)), e.o.setGroupProperty(PropertyInterface("Opacity", r)), i;
            }
            function i(t, e, r) {
                function i(t) {
                    return "Start Point" === t || "start point" === t ? i.startPoint : "End Point" === t || "end point" === t ? i.endPoint : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    startPoint: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    endPoint: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    type: {
                        get: function() {
                            return "a";
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.s.setGroupProperty(PropertyInterface("Start Point", r)), e.e.setGroupProperty(PropertyInterface("End Point", r)), e.o.setGroupProperty(PropertyInterface("Opacity", r)), i;
            }
            function a() {
                return function() {
                    return null;
                };
            }
            function s(t, e, r) {
                var i, a = propertyGroupFactory(l, r), s = propertyGroupFactory(h, a);
                function n(r) {
                    Object.defineProperty(h, t.d[r].nm, {
                        get: ExpressionPropertyInterface(e.d.dataProps[r].p)
                    });
                }
                var o = t.d ? t.d.length : 0, h = {};
                for(i = 0; i < o; i += 1)n(i), e.d.dataProps[i].p.setGroupProperty(s);
                function l(t) {
                    return "Color" === t || "color" === t ? l.color : "Opacity" === t || "opacity" === t ? l.opacity : "Stroke Width" === t || "stroke width" === t ? l.strokeWidth : null;
                }
                return Object.defineProperties(l, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    strokeWidth: {
                        get: ExpressionPropertyInterface(e.w)
                    },
                    dash: {
                        get: function() {
                            return h;
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", a)), e.o.setGroupProperty(PropertyInterface("Opacity", a)), e.w.setGroupProperty(PropertyInterface("Stroke Width", a)), l;
            }
            function n(t, e, r) {
                function i(e) {
                    return e === t.e.ix || "End" === e || "end" === e ? i.end : e === t.s.ix ? i.start : e === t.o.ix ? i.offset : null;
                }
                var a = propertyGroupFactory(i, r);
                return i.propertyIndex = t.ix, e.s.setGroupProperty(PropertyInterface("Start", a)), e.e.setGroupProperty(PropertyInterface("End", a)), e.o.setGroupProperty(PropertyInterface("Offset", a)), i.propertyIndex = t.ix, i.propertyGroup = r, Object.defineProperties(i, {
                    start: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    end: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function o(t, e, r) {
                function i(e) {
                    return t.a.ix === e || "Anchor Point" === e ? i.anchorPoint : t.o.ix === e || "Opacity" === e ? i.opacity : t.p.ix === e || "Position" === e ? i.position : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e ? i.rotation : t.s.ix === e || "Scale" === e ? i.scale : t.sk && t.sk.ix === e || "Skew" === e ? i.skew : t.sa && t.sa.ix === e || "Skew Axis" === e ? i.skewAxis : null;
                }
                var a = propertyGroupFactory(i, r);
                return e.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", a)), e.transform.mProps.p.setGroupProperty(PropertyInterface("Position", a)), e.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", a)), e.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", a)), e.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", a)), e.transform.mProps.sk && (e.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", a)), e.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", a))), e.transform.op.setGroupProperty(PropertyInterface("Opacity", a)), Object.defineProperties(i, {
                    opacity: {
                        get: ExpressionPropertyInterface(e.transform.mProps.o)
                    },
                    position: {
                        get: ExpressionPropertyInterface(e.transform.mProps.p)
                    },
                    anchorPoint: {
                        get: ExpressionPropertyInterface(e.transform.mProps.a)
                    },
                    scale: {
                        get: ExpressionPropertyInterface(e.transform.mProps.s)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(e.transform.mProps.r)
                    },
                    skew: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sk)
                    },
                    skewAxis: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sa)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.ty = "tr", i.mn = t.mn, i.propertyGroup = r, i;
            }
            function h(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.s.ix === e ? i.size : null;
                }
                var a = propertyGroupFactory(i, r);
                i.propertyIndex = t.ix;
                var s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return s.s.setGroupProperty(PropertyInterface("Size", a)), s.p.setGroupProperty(PropertyInterface("Position", a)), Object.defineProperties(i, {
                    size: {
                        get: ExpressionPropertyInterface(s.s)
                    },
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function l(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.rotation : t.pt.ix === e ? i.points : t.or.ix === e || "ADBE Vector Star Outer Radius" === e ? i.outerRadius : t.os.ix === e ? i.outerRoundness : !t.ir || t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e ? t.is && t.is.ix === e ? i.innerRoundness : null : i.innerRadius;
                }
                var a = propertyGroupFactory(i, r), s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, s.or.setGroupProperty(PropertyInterface("Outer Radius", a)), s.os.setGroupProperty(PropertyInterface("Outer Roundness", a)), s.pt.setGroupProperty(PropertyInterface("Points", a)), s.p.setGroupProperty(PropertyInterface("Position", a)), s.r.setGroupProperty(PropertyInterface("Rotation", a)), t.ir && (s.ir.setGroupProperty(PropertyInterface("Inner Radius", a)), s.is.setGroupProperty(PropertyInterface("Inner Roundness", a))), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(s.r)
                    },
                    points: {
                        get: ExpressionPropertyInterface(s.pt)
                    },
                    outerRadius: {
                        get: ExpressionPropertyInterface(s.or)
                    },
                    outerRoundness: {
                        get: ExpressionPropertyInterface(s.os)
                    },
                    innerRadius: {
                        get: ExpressionPropertyInterface(s.ir)
                    },
                    innerRoundness: {
                        get: ExpressionPropertyInterface(s.is)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function p(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.roundness : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e ? i.size : null;
                }
                var a = propertyGroupFactory(i, r), s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, s.p.setGroupProperty(PropertyInterface("Position", a)), s.s.setGroupProperty(PropertyInterface("Size", a)), s.r.setGroupProperty(PropertyInterface("Rotation", a)), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    roundness: {
                        get: ExpressionPropertyInterface(s.r)
                    },
                    size: {
                        get: ExpressionPropertyInterface(s.s)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function f(t, e, r) {
                function i(e) {
                    return t.r.ix === e || "Round Corners 1" === e ? i.radius : null;
                }
                var a = propertyGroupFactory(i, r), s = e;
                return i.propertyIndex = t.ix, s.rd.setGroupProperty(PropertyInterface("Radius", a)), Object.defineProperties(i, {
                    radius: {
                        get: ExpressionPropertyInterface(s.rd)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function c(t, e, r) {
                function i(e) {
                    return t.c.ix === e || "Copies" === e ? i.copies : t.o.ix === e || "Offset" === e ? i.offset : null;
                }
                var a = propertyGroupFactory(i, r), s = e;
                return i.propertyIndex = t.ix, s.c.setGroupProperty(PropertyInterface("Copies", a)), s.o.setGroupProperty(PropertyInterface("Offset", a)), Object.defineProperties(i, {
                    copies: {
                        get: ExpressionPropertyInterface(s.c)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(s.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            return function(e, r, i) {
                var a;
                function s(t) {
                    if ("number" == typeof t) return 0 === (t = void 0 === t ? 1 : t) ? i : a[t - 1];
                    for(var e = 0, r = a.length; e < r;){
                        if (a[e]._name === t) return a[e];
                        e += 1;
                    }
                    return null;
                }
                return s.propertyGroup = propertyGroupFactory(s, function() {
                    return i;
                }), a = t(e, r, s.propertyGroup), s.numProperties = a.length, s._name = "Contents", s;
            };
        }(), TextExpressionInterface = function(t) {
            var e;
            function r(t) {
                switch(t){
                    case "ADBE Text Document":
                        return r.sourceText;
                    default:
                        return null;
                }
            }
            return Object.defineProperty(r, "sourceText", {
                get: function() {
                    t.textProperty.getValue();
                    var r = t.textProperty.currentData.t;
                    return e && r === e.value || ((e = new String(r)).value = r || new String(r), Object.defineProperty(e, "style", {
                        get: function() {
                            return {
                                fillColor: t.textProperty.currentData.fc
                            };
                        }
                    })), e;
                }
            }), r;
        };
        function _typeof(t) {
            return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var FootageInterface = (dataInterfaceFactory = function(t) {
            function e(t) {
                return "Outline" === t ? e.outlineInterface() : null;
            }
            return e._name = "Outline", e.outlineInterface = function(t) {
                var e = "", r = t.getFootageData();
                function i(t) {
                    if (r[t]) return e = t, "object" === _typeof(r = r[t]) ? i : r;
                    var a = t.indexOf(e);
                    if (-1 !== a) {
                        var s = parseInt(t.substr(a + e.length), 10);
                        return "object" === _typeof(r = r[s]) ? i : r;
                    }
                    return "";
                }
                return function() {
                    return e = "", r = t.getFootageData(), i;
                };
            }(t), e;
        }, function(t) {
            function e(t) {
                return "Data" === t ? e.dataInterface : null;
            }
            return e._name = "Data", e.dataInterface = dataInterfaceFactory(t), e;
        }), dataInterfaceFactory, interfaces = {
            layer: LayerExpressionInterface,
            effects: EffectsExpressionInterface,
            comp: CompExpressionInterface,
            shape: ShapeExpressionInterface,
            text: TextExpressionInterface,
            footage: FootageInterface
        };
        function getInterface(t) {
            return interfaces[t] || null;
        }
        var expressionHelpers = {
            searchExpressions: function(t, e, r) {
                e.x && (r.k = !0, r.x = !0, r.initiateExpression = ExpressionManager.initiateExpression, r.effectsSequence.push(r.initiateExpression(t, e, r).bind(r)));
            },
            getSpeedAtTime: function(t) {
                var e = this.getValueAtTime(t), r = this.getValueAtTime(t + -0.01), i = 0;
                if (e.length) {
                    var a;
                    for(a = 0; a < e.length; a += 1)i += Math.pow(r[a] - e[a], 2);
                    i = 100 * Math.sqrt(i);
                } else i = 0;
                return i;
            },
            getVelocityAtTime: function(t) {
                if (void 0 !== this.vel) return this.vel;
                var e, r, i = this.getValueAtTime(t), a = this.getValueAtTime(t + -0.001);
                if (i.length) for(e = createTypedArray("float32", i.length), r = 0; r < i.length; r += 1)e[r] = (a[r] - i[r]) / -0.001;
                else e = (a - i) / -0.001;
                return e;
            },
            getValueAtTime: function(t) {
                return t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t, this._cachingAtTime), this._cachingAtTime.lastFrame = t), this._cachingAtTime.value;
            },
            getStaticValueAtTime: function() {
                return this.pv;
            },
            setGroupProperty: function(t) {
                this.propertyGroup = t;
            }
        };
        function addPropertyDecorator() {
            function t(t, e, r) {
                if (!this.k || !this.keyframes) return this.pv;
                t = t ? t.toLowerCase() : "";
                var i, a, s, n, o, h = this.comp.renderedFrame, l = this.keyframes, p = l[l.length - 1].t;
                if (h <= p) return this.pv;
                if (r ? a = p - (i = e ? Math.abs(p - this.elem.comp.globalData.frameRate * e) : Math.max(0, p - this.elem.data.ip)) : ((!e || e > l.length - 1) && (e = l.length - 1), i = p - (a = l[l.length - 1 - e].t)), "pingpong" === t) {
                    if (Math.floor((h - a) / i) % 2 != 0) return this.getValueAtTime((i - (h - a) % i + a) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var f = this.getValueAtTime(a / this.comp.globalData.frameRate, 0), c = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), m = this.getValueAtTime(((h - a) % i + a) / this.comp.globalData.frameRate, 0), d = Math.floor((h - a) / i);
                        if (this.pv.length) {
                            for(n = (o = new Array(f.length)).length, s = 0; s < n; s += 1)o[s] = (c[s] - f[s]) * d + m[s];
                            return o;
                        }
                        return (c - f) * d + m;
                    }
                    if ("continue" === t) {
                        var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p - .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(u.length)).length, s = 0; s < n; s += 1)o[s] = u[s] + (u[s] - y[s]) * ((h - p) / this.comp.globalData.frameRate) / 5e-4;
                            return o;
                        }
                        return u + (h - p) / .001 * (u - y);
                    }
                }
                return this.getValueAtTime(((h - a) % i + a) / this.comp.globalData.frameRate, 0);
            }
            function e(t, e, r) {
                if (!this.k) return this.pv;
                t = t ? t.toLowerCase() : "";
                var i, a, s, n, o, h = this.comp.renderedFrame, l = this.keyframes, p = l[0].t;
                if (h >= p) return this.pv;
                if (r ? a = p + (i = e ? Math.abs(this.elem.comp.globalData.frameRate * e) : Math.max(0, this.elem.data.op - p)) : ((!e || e > l.length - 1) && (e = l.length - 1), i = (a = l[e].t) - p), "pingpong" === t) {
                    if (Math.floor((p - h) / i) % 2 == 0) return this.getValueAtTime(((p - h) % i + p) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var f = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), c = this.getValueAtTime(a / this.comp.globalData.frameRate, 0), m = this.getValueAtTime((i - (p - h) % i + p) / this.comp.globalData.frameRate, 0), d = Math.floor((p - h) / i) + 1;
                        if (this.pv.length) {
                            for(n = (o = new Array(f.length)).length, s = 0; s < n; s += 1)o[s] = m[s] - (c[s] - f[s]) * d;
                            return o;
                        }
                        return m - (c - f) * d;
                    }
                    if ("continue" === t) {
                        var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p + .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(u.length)).length, s = 0; s < n; s += 1)o[s] = u[s] + (u[s] - y[s]) * (p - h) / .001;
                            return o;
                        }
                        return u + (u - y) * (p - h) / .001;
                    }
                }
                return this.getValueAtTime((i - ((p - h) % i + p)) / this.comp.globalData.frameRate, 0);
            }
            function r(t, e) {
                if (!this.k) return this.pv;
                if (t = .5 * (t || .4), (e = Math.floor(e || 5)) <= 1) return this.pv;
                var r, i, a = this.comp.renderedFrame / this.comp.globalData.frameRate, s = a - t, n = e > 1 ? (a + t - s) / (e - 1) : 1, o = 0, h = 0;
                for(r = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; o < e;){
                    if (i = this.getValueAtTime(s + o * n), this.pv.length) for(h = 0; h < this.pv.length; h += 1)r[h] += i[h];
                    else r += i;
                    o += 1;
                }
                if (this.pv.length) for(h = 0; h < this.pv.length; h += 1)r[h] /= e;
                else r /= e;
                return r;
            }
            function i(t) {
                this._transformCachingAtTime || (this._transformCachingAtTime = {
                    v: new Matrix
                });
                var e = this._transformCachingAtTime.v;
                if (e.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
                    var r = this.a.getValueAtTime(t);
                    e.translate(-r[0] * this.a.mult, -r[1] * this.a.mult, r[2] * this.a.mult);
                }
                if (this.appliedTransformations < 2) {
                    var i = this.s.getValueAtTime(t);
                    e.scale(i[0] * this.s.mult, i[1] * this.s.mult, i[2] * this.s.mult);
                }
                if (this.sk && this.appliedTransformations < 3) {
                    var a = this.sk.getValueAtTime(t), s = this.sa.getValueAtTime(t);
                    e.skewFromAxis(-a * this.sk.mult, s * this.sa.mult);
                }
                if (this.r && this.appliedTransformations < 4) {
                    var n = this.r.getValueAtTime(t);
                    e.rotate(-n * this.r.mult);
                } else if (!this.r && this.appliedTransformations < 4) {
                    var o = this.rz.getValueAtTime(t), h = this.ry.getValueAtTime(t), l = this.rx.getValueAtTime(t), p = this.or.getValueAtTime(t);
                    e.rotateZ(-o * this.rz.mult).rotateY(h * this.ry.mult).rotateX(l * this.rx.mult).rotateZ(-p[2] * this.or.mult).rotateY(p[1] * this.or.mult).rotateX(p[0] * this.or.mult);
                }
                if (this.data.p && this.data.p.s) {
                    var f = this.px.getValueAtTime(t), c = this.py.getValueAtTime(t);
                    if (this.data.p.z) {
                        var m = this.pz.getValueAtTime(t);
                        e.translate(f * this.px.mult, c * this.py.mult, -m * this.pz.mult);
                    } else e.translate(f * this.px.mult, c * this.py.mult, 0);
                } else {
                    var d = this.p.getValueAtTime(t);
                    e.translate(d[0] * this.p.mult, d[1] * this.p.mult, -d[2] * this.p.mult);
                }
                return e;
            }
            function a() {
                return this.v.clone(new Matrix);
            }
            var s = TransformPropertyFactory.getTransformProperty;
            TransformPropertyFactory.getTransformProperty = function(t, e, r) {
                var n = s(t, e, r);
                return n.dynamicProperties.length ? n.getValueAtTime = i.bind(n) : n.getValueAtTime = a.bind(n), n.setGroupProperty = expressionHelpers.setGroupProperty, n;
            };
            var n = PropertyFactory.getProp;
            PropertyFactory.getProp = function(i, a, s, o, h) {
                var l = n(i, a, s, o, h);
                l.kf ? l.getValueAtTime = expressionHelpers.getValueAtTime.bind(l) : l.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(l), l.setGroupProperty = expressionHelpers.setGroupProperty, l.loopOut = t, l.loopIn = e, l.smooth = r, l.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(l), l.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(l), l.numKeys = 1 === a.a ? a.k.length : 0, l.propertyIndex = a.ix;
                var p = 0;
                return 0 !== s && (p = createTypedArray("float32", 1 === a.a ? a.k[0].s.length : a.k.length)), l._cachingAtTime = {
                    lastFrame: initialDefaultFrame,
                    lastIndex: 0,
                    value: p
                }, expressionHelpers.searchExpressions(i, a, l), l.k && h.addDynamicProperty(l), l;
            };
            var o = ShapePropertyFactory.getConstructorFunction(), h = ShapePropertyFactory.getKeyframedConstructorFunction();
            function l() {}
            l.prototype = {
                vertices: function(t, e) {
                    this.k && this.getValue();
                    var r, i = this.v;
                    void 0 !== e && (i = this.getValueAtTime(e, 0));
                    var a = i._length, s = i[t], n = i.v, o = createSizedArray(a);
                    for(r = 0; r < a; r += 1)o[r] = "i" === t || "o" === t ? [
                        s[r][0] - n[r][0],
                        s[r][1] - n[r][1]
                    ] : [
                        s[r][0],
                        s[r][1]
                    ];
                    return o;
                },
                points: function(t) {
                    return this.vertices("v", t);
                },
                inTangents: function(t) {
                    return this.vertices("i", t);
                },
                outTangents: function(t) {
                    return this.vertices("o", t);
                },
                isClosed: function() {
                    return this.v.c;
                },
                pointOnPath: function(t, e) {
                    var r = this.v;
                    void 0 !== e && (r = this.getValueAtTime(e, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r));
                    for(var i, a = this._segmentsLength, s = a.lengths, n = a.totalLength * t, o = 0, h = s.length, l = 0; o < h;){
                        if (l + s[o].addedLength > n) {
                            var p = o, f = r.c && o === h - 1 ? 0 : o + 1, c = (n - l) / s[o].addedLength;
                            i = bez.getPointInSegment(r.v[p], r.v[f], r.o[p], r.i[f], c, s[o]);
                            break;
                        }
                        l += s[o].addedLength, o += 1;
                    }
                    return i || (i = r.c ? [
                        r.v[0][0],
                        r.v[0][1]
                    ] : [
                        r.v[r._length - 1][0],
                        r.v[r._length - 1][1]
                    ]), i;
                },
                vectorOnPath: function(t, e, r) {
                    1 == t ? t = this.v.c : 0 == t && (t = .999);
                    var i = this.pointOnPath(t, e), a = this.pointOnPath(t + .001, e), s = a[0] - i[0], n = a[1] - i[1], o = Math.sqrt(Math.pow(s, 2) + Math.pow(n, 2));
                    return 0 === o ? [
                        0,
                        0
                    ] : "tangent" === r ? [
                        s / o,
                        n / o
                    ] : [
                        -n / o,
                        s / o
                    ];
                },
                tangentOnPath: function(t, e) {
                    return this.vectorOnPath(t, e, "tangent");
                },
                normalOnPath: function(t, e) {
                    return this.vectorOnPath(t, e, "normal");
                },
                setGroupProperty: expressionHelpers.setGroupProperty,
                getValueAtTime: expressionHelpers.getStaticValueAtTime
            }, extendPrototype([
                l
            ], o), extendPrototype([
                l
            ], h), h.prototype.getValueAtTime = function(t) {
                return this._cachingAtTime || (this._cachingAtTime = {
                    shapeValue: shapePool.clone(this.pv),
                    lastIndex: 0,
                    lastTime: initialDefaultFrame
                }), t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < t ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = t, this.interpolateShape(t, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
            }, h.prototype.initiateExpression = ExpressionManager.initiateExpression;
            var p = ShapePropertyFactory.getShapeProp;
            ShapePropertyFactory.getShapeProp = function(t, e, r, i, a) {
                var s = p(t, e, r, i, a);
                return s.propertyIndex = e.ix, s.lock = !1, 3 === r ? expressionHelpers.searchExpressions(t, e.pt, s) : 4 === r && expressionHelpers.searchExpressions(t, e.ks, s), s.k && t.addDynamicProperty(s), s;
            };
        }
        function initialize$1() {
            addPropertyDecorator();
        }
        function addDecorator() {
            TextProperty.prototype.getExpressionValue = function(t, e) {
                var r = this.calculateExpression(e);
                if (t.t !== r) {
                    var i = {};
                    return this.copyData(i, t), i.t = r.toString(), i.__complete = !1, i;
                }
                return t;
            }, TextProperty.prototype.searchProperty = function() {
                var t = this.searchKeyframes(), e = this.searchExpressions();
                return this.kf = t || e, this.kf;
            }, TextProperty.prototype.searchExpressions = function() {
                return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
            };
        }
        function initialize() {
            addDecorator();
        }
        function SVGComposableEffect() {}
        SVGComposableEffect.prototype = {
            createMergeNode: function(t, e) {
                var r, i, a = createNS("feMerge");
                for(a.setAttribute("result", t), i = 0; i < e.length; i += 1)(r = createNS("feMergeNode")).setAttribute("in", e[i]), a.appendChild(r), a.appendChild(r);
                return a;
            }
        };
        var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
        function SVGTintFilter(t, e, r, i, a) {
            this.filterManager = e;
            var s = createNS("feColorMatrix");
            s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "linearRGB"), s.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = s, s.setAttribute("result", i + "_tint_1"), t.appendChild(s), (s = createNS("feColorMatrix")).setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s.setAttribute("result", i + "_tint_2"), t.appendChild(s), this.matrixFilter = s;
            var n = this.createMergeNode(i, [
                a,
                i + "_tint_1",
                i + "_tint_2"
            ]);
            t.appendChild(n);
        }
        function SVGFillFilter(t, e, r, i) {
            this.filterManager = e;
            var a = createNS("feColorMatrix");
            a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a.setAttribute("result", i), t.appendChild(a), this.matrixFilter = a;
        }
        function SVGStrokeEffect(t, e, r) {
            this.initialized = !1, this.filterManager = e, this.elem = r, this.paths = [];
        }
        function SVGTritoneFilter(t, e, r, i) {
            this.filterManager = e;
            var a = createNS("feColorMatrix");
            a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "linearRGB"), a.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t.appendChild(a);
            var s = createNS("feComponentTransfer");
            s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("result", i), this.matrixFilter = s;
            var n = createNS("feFuncR");
            n.setAttribute("type", "table"), s.appendChild(n), this.feFuncR = n;
            var o = createNS("feFuncG");
            o.setAttribute("type", "table"), s.appendChild(o), this.feFuncG = o;
            var h = createNS("feFuncB");
            h.setAttribute("type", "table"), s.appendChild(h), this.feFuncB = h, t.appendChild(s);
        }
        function SVGProLevelsFilter(t, e, r, i) {
            this.filterManager = e;
            var a = this.filterManager.effectElements, s = createNS("feComponentTransfer");
            (a[10].p.k || 0 !== a[10].p.v || a[11].p.k || 1 !== a[11].p.v || a[12].p.k || 1 !== a[12].p.v || a[13].p.k || 0 !== a[13].p.v || a[14].p.k || 1 !== a[14].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", s)), (a[17].p.k || 0 !== a[17].p.v || a[18].p.k || 1 !== a[18].p.v || a[19].p.k || 1 !== a[19].p.v || a[20].p.k || 0 !== a[20].p.v || a[21].p.k || 1 !== a[21].p.v) && (this.feFuncG = this.createFeFunc("feFuncG", s)), (a[24].p.k || 0 !== a[24].p.v || a[25].p.k || 1 !== a[25].p.v || a[26].p.k || 1 !== a[26].p.v || a[27].p.k || 0 !== a[27].p.v || a[28].p.k || 1 !== a[28].p.v) && (this.feFuncB = this.createFeFunc("feFuncB", s)), (a[31].p.k || 0 !== a[31].p.v || a[32].p.k || 1 !== a[32].p.v || a[33].p.k || 1 !== a[33].p.v || a[34].p.k || 0 !== a[34].p.v || a[35].p.k || 1 !== a[35].p.v) && (this.feFuncA = this.createFeFunc("feFuncA", s)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (s.setAttribute("color-interpolation-filters", "sRGB"), t.appendChild(s)), (a[3].p.k || 0 !== a[3].p.v || a[4].p.k || 1 !== a[4].p.v || a[5].p.k || 1 !== a[5].p.v || a[6].p.k || 0 !== a[6].p.v || a[7].p.k || 1 !== a[7].p.v) && ((s = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("result", i), t.appendChild(s), this.feFuncRComposed = this.createFeFunc("feFuncR", s), this.feFuncGComposed = this.createFeFunc("feFuncG", s), this.feFuncBComposed = this.createFeFunc("feFuncB", s));
        }
        function SVGDropShadowEffect(t, e, r, i, a) {
            var s = e.container.globalData.renderConfig.filterSize, n = e.data.fs || s;
            t.setAttribute("x", n.x || s.x), t.setAttribute("y", n.y || s.y), t.setAttribute("width", n.width || s.width), t.setAttribute("height", n.height || s.height), this.filterManager = e;
            var o = createNS("feGaussianBlur");
            o.setAttribute("in", "SourceAlpha"), o.setAttribute("result", i + "_drop_shadow_1"), o.setAttribute("stdDeviation", "0"), this.feGaussianBlur = o, t.appendChild(o);
            var h = createNS("feOffset");
            h.setAttribute("dx", "25"), h.setAttribute("dy", "0"), h.setAttribute("in", i + "_drop_shadow_1"), h.setAttribute("result", i + "_drop_shadow_2"), this.feOffset = h, t.appendChild(h);
            var l = createNS("feFlood");
            l.setAttribute("flood-color", "#00ff00"), l.setAttribute("flood-opacity", "1"), l.setAttribute("result", i + "_drop_shadow_3"), this.feFlood = l, t.appendChild(l);
            var p = createNS("feComposite");
            p.setAttribute("in", i + "_drop_shadow_3"), p.setAttribute("in2", i + "_drop_shadow_2"), p.setAttribute("operator", "in"), p.setAttribute("result", i + "_drop_shadow_4"), t.appendChild(p);
            var f = this.createMergeNode(i, [
                i + "_drop_shadow_4",
                a
            ]);
            t.appendChild(f);
        }
        extendPrototype([
            SVGComposableEffect
        ], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v / 100;
                this.linearFilter.setAttribute("values", linearFilterValue + " " + i + " 0"), this.matrixFilter.setAttribute("values", r[0] - e[0] + " 0 0 0 " + e[0] + " " + (r[1] - e[1]) + " 0 0 0 " + e[1] + " " + (r[2] - e[2]) + " 0 0 0 " + e[2] + " 0 0 0 1 0");
            }
        }, SVGFillFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[2].p.v, r = this.filterManager.effectElements[6].p.v;
                this.matrixFilter.setAttribute("values", "0 0 0 0 " + e[0] + " 0 0 0 0 " + e[1] + " 0 0 0 0 " + e[2] + " 0 0 0 " + r + " 0");
            }
        }, SVGStrokeEffect.prototype.initialize = function() {
            var t, e, r, i, a = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            for(1 === this.filterManager.effectElements[1].p.v ? (i = this.elem.maskManager.masksProperties.length, r = 0) : i = (r = this.filterManager.effectElements[0].p.v - 1) + 1, (e = createNS("g")).setAttribute("fill", "none"), e.setAttribute("stroke-linecap", "round"), e.setAttribute("stroke-dashoffset", 1); r < i; r += 1)t = createNS("path"), e.appendChild(t), this.paths.push({
                p: t,
                m: r
            });
            if (3 === this.filterManager.effectElements[10].p.v) {
                var s = createNS("mask"), n = createElementID();
                s.setAttribute("id", n), s.setAttribute("mask-type", "alpha"), s.appendChild(e), this.elem.globalData.defs.appendChild(s);
                var o = createNS("g");
                for(o.setAttribute("mask", "url(" + getLocationHref() + "#" + n + ")"); a[0];)o.appendChild(a[0]);
                this.elem.layerElement.appendChild(o), this.masker = s, e.setAttribute("stroke", "#fff");
            } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
                if (2 === this.filterManager.effectElements[10].p.v) for(a = this.elem.layerElement.children || this.elem.layerElement.childNodes; a.length;)this.elem.layerElement.removeChild(a[0]);
                this.elem.layerElement.appendChild(e), this.elem.layerElement.removeAttribute("mask"), e.setAttribute("stroke", "#fff");
            }
            this.initialized = !0, this.pathMasker = e;
        }, SVGStrokeEffect.prototype.renderFrame = function(t) {
            var e;
            this.initialized || this.initialize();
            var r, i, a = this.paths.length;
            for(e = 0; e < a; e += 1)if (-1 !== this.paths[e].m && (r = this.elem.maskManager.viewData[this.paths[e].m], i = this.paths[e].p, (t || this.filterManager._mdf || r.prop._mdf) && i.setAttribute("d", r.lastPath), t || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || r.prop._mdf)) {
                var s;
                if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
                    var n = .01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), o = .01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), h = i.getTotalLength();
                    s = "0 0 0 " + h * n + " ";
                    var l, p = h * (o - n), f = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01, c = Math.floor(p / f);
                    for(l = 0; l < c; l += 1)s += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01 + " ";
                    s += "0 " + 10 * h + " 0 0";
                } else s = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01;
                i.setAttribute("stroke-dasharray", s);
            }
            if ((t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (t || this.filterManager.effectElements[3].p._mdf)) {
                var m = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * m[0]) + "," + bmFloor(255 * m[1]) + "," + bmFloor(255 * m[2]) + ")");
            }
        }, SVGTritoneFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v, a = i[0] + " " + r[0] + " " + e[0], s = i[1] + " " + r[1] + " " + e[1], n = i[2] + " " + r[2] + " " + e[2];
                this.feFuncR.setAttribute("tableValues", a), this.feFuncG.setAttribute("tableValues", s), this.feFuncB.setAttribute("tableValues", n);
            }
        }, SVGProLevelsFilter.prototype.createFeFunc = function(t, e) {
            var r = createNS(t);
            return r.setAttribute("type", "table"), e.appendChild(r), r;
        }, SVGProLevelsFilter.prototype.getTableValue = function(t, e, r, i, a) {
            for(var s, n, o = 0, h = Math.min(t, e), l = Math.max(t, e), p = Array.call(null, {
                length: 256
            }), f = 0, c = a - i, m = e - t; o <= 256;)n = (s = o / 256) <= h ? m < 0 ? a : i : s >= l ? m < 0 ? i : a : i + c * Math.pow((s - t) / m, 1 / r), p[f] = n, f += 1, o += 256 / 255;
            return p.join(" ");
        }, SVGProLevelsFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e, r = this.filterManager.effectElements;
                this.feFuncRComposed && (t || r[3].p._mdf || r[4].p._mdf || r[5].p._mdf || r[6].p._mdf || r[7].p._mdf) && (e = this.getTableValue(r[3].p.v, r[4].p.v, r[5].p.v, r[6].p.v, r[7].p.v), this.feFuncRComposed.setAttribute("tableValues", e), this.feFuncGComposed.setAttribute("tableValues", e), this.feFuncBComposed.setAttribute("tableValues", e)), this.feFuncR && (t || r[10].p._mdf || r[11].p._mdf || r[12].p._mdf || r[13].p._mdf || r[14].p._mdf) && (e = this.getTableValue(r[10].p.v, r[11].p.v, r[12].p.v, r[13].p.v, r[14].p.v), this.feFuncR.setAttribute("tableValues", e)), this.feFuncG && (t || r[17].p._mdf || r[18].p._mdf || r[19].p._mdf || r[20].p._mdf || r[21].p._mdf) && (e = this.getTableValue(r[17].p.v, r[18].p.v, r[19].p.v, r[20].p.v, r[21].p.v), this.feFuncG.setAttribute("tableValues", e)), this.feFuncB && (t || r[24].p._mdf || r[25].p._mdf || r[26].p._mdf || r[27].p._mdf || r[28].p._mdf) && (e = this.getTableValue(r[24].p.v, r[25].p.v, r[26].p.v, r[27].p.v, r[28].p.v), this.feFuncB.setAttribute("tableValues", e)), this.feFuncA && (t || r[31].p._mdf || r[32].p._mdf || r[33].p._mdf || r[34].p._mdf || r[35].p._mdf) && (e = this.getTableValue(r[31].p.v, r[32].p.v, r[33].p.v, r[34].p.v, r[35].p.v), this.feFuncA.setAttribute("tableValues", e));
            }
        }, extendPrototype([
            SVGComposableEffect
        ], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                if ((t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t || this.filterManager.effectElements[0].p._mdf) {
                    var e = this.filterManager.effectElements[0].p.v;
                    this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * e[0]), Math.round(255 * e[1]), Math.round(255 * e[2])));
                }
                if ((t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                    var r = this.filterManager.effectElements[3].p.v, i = (this.filterManager.effectElements[2].p.v - 90) * degToRads, a = r * Math.cos(i), s = r * Math.sin(i);
                    this.feOffset.setAttribute("dx", a), this.feOffset.setAttribute("dy", s);
                }
            }
        };
        var _svgMatteSymbols = [];
        function SVGMatte3Effect(t, e, r) {
            this.initialized = !1, this.filterManager = e, this.filterElem = t, this.elem = r, r.matteElement = createNS("g"), r.matteElement.appendChild(r.layerElement), r.matteElement.appendChild(r.transformedElement), r.baseElement = r.matteElement;
        }
        function SVGGaussianBlurEffect(t, e, r, i) {
            t.setAttribute("x", "-100%"), t.setAttribute("y", "-100%"), t.setAttribute("width", "300%"), t.setAttribute("height", "300%"), this.filterManager = e;
            var a = createNS("feGaussianBlur");
            a.setAttribute("result", i), t.appendChild(a), this.feGaussianBlur = a;
        }
        function TransformEffect() {}
        function SVGTransformEffect(t, e) {
            this.init(e);
        }
        function CVTransformEffect(t) {
            this.init(t);
        }
        return SVGMatte3Effect.prototype.findSymbol = function(t) {
            for(var e = 0, r = _svgMatteSymbols.length; e < r;){
                if (_svgMatteSymbols[e] === t) return _svgMatteSymbols[e];
                e += 1;
            }
            return null;
        }, SVGMatte3Effect.prototype.replaceInParent = function(t, e) {
            var r = t.layerElement.parentNode;
            if (r) {
                for(var i, a = r.children, s = 0, n = a.length; s < n && a[s] !== t.layerElement;)s += 1;
                s <= n - 2 && (i = a[s + 1]);
                var o = createNS("use");
                o.setAttribute("href", "#" + e), i ? r.insertBefore(o, i) : r.appendChild(o);
            }
        }, SVGMatte3Effect.prototype.setElementAsMask = function(t, e) {
            if (!this.findSymbol(e)) {
                var r = createElementID(), i = createNS("mask");
                i.setAttribute("id", e.layerId), i.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(e);
                var a = t.globalData.defs;
                a.appendChild(i);
                var s = createNS("symbol");
                s.setAttribute("id", r), this.replaceInParent(e, r), s.appendChild(e.layerElement), a.appendChild(s);
                var n = createNS("use");
                n.setAttribute("href", "#" + r), i.appendChild(n), e.data.hd = !1, e.show();
            }
            t.setMatte(e.layerId);
        }, SVGMatte3Effect.prototype.initialize = function() {
            for(var t = this.filterManager.effectElements[0].p.v, e = this.elem.comp.elements, r = 0, i = e.length; r < i;)e[r] && e[r].data.ind === t && this.setElementAsMask(this.elem, e[r]), r += 1;
            this.initialized = !0;
        }, SVGMatte3Effect.prototype.renderFrame = function() {
            this.initialized || this.initialize();
        }, SVGGaussianBlurEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = .3 * this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = 3 == r ? 0 : e, a = 2 == r ? 0 : e;
                this.feGaussianBlur.setAttribute("stdDeviation", i + " " + a);
                var s = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
                this.feGaussianBlur.setAttribute("edgeMode", s);
            }
        }, TransformEffect.prototype.init = function(t) {
            this.effectsManager = t, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix, this.opacity = -1, this._mdf = !1, this._opMdf = !1;
        }, TransformEffect.prototype.renderFrame = function(t) {
            if (this._opMdf = !1, this._mdf = !1, t || this.effectsManager._mdf) {
                var e = this.effectsManager.effectElements, r = e[0].p.v, i = e[1].p.v, a = 1 === e[2].p.v, s = e[3].p.v, n = a ? s : e[4].p.v, o = e[5].p.v, h = e[6].p.v, l = e[7].p.v;
                this.matrix.reset(), this.matrix.translate(-r[0], -r[1], r[2]), this.matrix.scale(.01 * n, .01 * s, 1), this.matrix.rotate(-l * degToRads), this.matrix.skewFromAxis(-o * degToRads, (h + 90) * degToRads), this.matrix.translate(i[0], i[1], 0), this._mdf = !0, this.opacity !== e[8].p.v && (this.opacity = e[8].p.v, this._opMdf = !0);
            }
        }, extendPrototype([
            TransformEffect
        ], SVGTransformEffect), extendPrototype([
            TransformEffect
        ], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
    });
}), REACT_LOTTIE_PLAYER_VERSION = "3.6.0", LOTTIE_WEB_VERSION = "^5.12.2", PlayerState, PlayerEvent;
function parseSrc(t) {
    if ("object" == typeof t) return t;
    try {
        return JSON.parse(t);
    } catch (t) {}
    try {
        return new URL(t).toString();
    } catch (t) {}
    return t;
}
!function(t) {
    t.Loading = "loading", t.Playing = "playing", t.Paused = "paused", t.Stopped = "stopped", t.Frozen = "frozen", t.Error = "error";
}(PlayerState || (PlayerState = {})), function(t) {
    t.Load = "load", t.InstanceSaved = "instanceSaved", t.Error = "error", t.Ready = "ready", t.Play = "play", t.Pause = "pause", t.Stop = "stop", t.Freeze = "freeze", t.Loop = "loop", t.Complete = "complete", t.Frame = "frame";
}(PlayerEvent || (PlayerEvent = {}));
var defaultOptions = {
    clearCanvas: !1,
    hideOnTransparent: !0,
    progressiveLoad: !0
}, Player = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.container = null, r.unmounted = !1, r.handleBgChange = function(t) {
            r.setState({
                background: t
            });
        }, r.triggerDownload = function(t, e) {
            var r = document.createElement("a");
            r.href = t, r.download = e, document.body.appendChild(r), r.click(), document.body.removeChild(r);
        }, r.snapshot = function(t) {
            var e;
            void 0 === t && (t = !0);
            var i = r.props.id ? r.props.id : "lottie", a = document.getElementById(i);
            if ("svg" === r.props.renderer) {
                if (a) {
                    var s = a.querySelector("svg");
                    if (s) {
                        var n = (new XMLSerializer).serializeToString(s);
                        e = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(n);
                    }
                }
                t && r.triggerDownload(e, "snapshot.svg");
            } else if ("canvas" === r.props.renderer) {
                if (a) {
                    var o = a.querySelector("canvas");
                    o && (e = o.toDataURL("image/png"));
                }
                t && r.triggerDownload(e, "snapshot.png");
            }
            return e;
        }, "undefined" != typeof window && (window.lottie = lottie), r.state = {
            animationData: null,
            background: "transparent",
            containerRef: $bxRTa.createRef(),
            debug: !0,
            instance: null,
            playerState: PlayerState.Loading,
            seeker: 0
        }, r;
    }
    return __extends(e, t), e.getDerivedStateFromProps = function(t, e) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(r) {
                return t.background !== e.background ? [
                    2,
                    {
                        background: t.background
                    }
                ] : [
                    2,
                    null
                ];
            });
        });
    }, e.prototype.getVersions = function() {
        return {
            lottieWebVersion: LOTTIE_WEB_VERSION,
            lottiePlayerVersion: REACT_LOTTIE_PLAYER_VERSION
        };
    }, e.prototype.componentDidMount = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.unmounted ? [
                            3,
                            2
                        ] : [
                            4,
                            this.createLottie()
                        ];
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.componentWillUnmount = function() {
        this.unmounted = !0, this.state.instance && this.state.instance.destroy();
    }, e.prototype.componentDidUpdate = function(t) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.props.src === t.src ? [
                            3,
                            2
                        ] : (this.state.instance && this.state.instance.destroy(), [
                            4,
                            this.createLottie()
                        ]);
                    case 1:
                        e.sent(), e.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.render = function() {
        var t = this, e = this.props, r = e.children, i = e.loop, a = e.style, s = e.onBackgroundChange, n = e.className, o = this.state, h = o.animationData, l = o.instance, p = o.playerState, f = o.seeker, c = o.debug, m = o.background;
        return $bxRTa.createElement("div", {
            className: "lf-player-container"
        }, this.state.playerState === PlayerState.Error ? $bxRTa.createElement("div", {
            className: "lf-error"
        }, $bxRTa.createElement("span", {
            "aria-label": "error-symbol",
            role: "img"
        }, "\u26A0\uFE0F")) : $bxRTa.createElement("div", {
            id: this.props.id ? this.props.id : "lottie",
            ref: function(e) {
                return t.container = e;
            },
            style: __assign({
                background: m,
                margin: "0 auto",
                outline: "none",
                overflow: "hidden"
            }, a),
            className: n
        }), $bxRTa.Children.map(r, function(e) {
            return $bxRTa.isValidElement(e) ? $bxRTa.cloneElement(e, {
                animationData: h,
                background: m,
                debug: c,
                instance: l,
                loop: i,
                pause: function() {
                    return t.pause();
                },
                play: function() {
                    return t.play();
                },
                playerState: p,
                seeker: f,
                setBackground: function(e) {
                    t.setState({
                        background: e
                    }), "function" == typeof s && s(e);
                },
                setSeeker: function(e, r) {
                    return t.setSeeker(e, r);
                },
                stop: function() {
                    return t.stop();
                },
                toggleDebug: function() {
                    return t.toggleDebug();
                },
                setLoop: function(e) {
                    return t.setLoop(e);
                },
                colorChangedEvent: function(e) {
                    t.handleBgChange(e);
                },
                snapshot: function() {
                    t.snapshot();
                }
            }) : null;
        }));
    }, e.prototype.toggleDebug = function() {
        this.setState({
            debug: !this.state.debug
        });
    }, e.prototype.createLottie = function() {
        return __awaiter(this, void 0, void 0, function() {
            var t, e, r, i, a, s, n, o, h, l, p, f, c, m, d = this;
            return __generator(this, function(u) {
                switch(u.label){
                    case 0:
                        if (t = this.props, e = t.autoplay, r = t.direction, i = t.loop, a = t.lottieRef, s = t.renderer, n = t.speed, o = t.src, h = t.background, l = t.rendererSettings, p = t.hover, f = this.state.instance, !o || !this.container) return [
                            2
                        ];
                        u.label = 1;
                    case 1:
                        return u.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]), "string" != typeof (c = parseSrc(o)) ? [
                            3,
                            4
                        ] : [
                            4,
                            fetch(c).catch(function() {
                                throw d.setState({
                                    playerState: PlayerState.Error
                                }), d.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
                            })
                        ];
                    case 2:
                        return [
                            4,
                            u.sent().json().catch(function() {
                                throw d.setState({
                                    playerState: PlayerState.Error
                                }), d.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
                            })
                        ];
                    case 3:
                        c = u.sent(), u.label = 4;
                    case 4:
                        return f && f.destroy(), m = lottie.loadAnimation({
                            rendererSettings: l || defaultOptions,
                            animationData: c,
                            autoplay: e || !1,
                            container: this.container,
                            loop: i || !1,
                            renderer: s
                        }), n && m.setSpeed(n), this.setState({
                            animationData: c
                        }), this.setState({
                            instance: m
                        }, function() {
                            d.triggerEvent(PlayerEvent.InstanceSaved), "function" == typeof a && a(m), e && d.play();
                        }), m.addEventListener("enterFrame", function() {
                            d.triggerEvent(PlayerEvent.Frame), d.setState({
                                seeker: Math.floor(m.currentFrame)
                            });
                        }), m.addEventListener("DOMLoaded", function() {
                            d.triggerEvent(PlayerEvent.Load);
                        }), m.addEventListener("data_ready", function() {
                            d.triggerEvent(PlayerEvent.Ready);
                        }), m.addEventListener("data_failed", function() {
                            d.setState({
                                playerState: PlayerState.Error
                            }), d.triggerEvent(PlayerEvent.Error);
                        }), m.addEventListener("loopComplete", function() {
                            d.triggerEvent(PlayerEvent.Loop);
                        }), m.addEventListener("complete", function() {
                            d.triggerEvent(PlayerEvent.Complete), d.setState({
                                playerState: PlayerState.Paused
                            }), d.props.keepLastFrame && !d.props.loop || d.setSeeker(0);
                        }), this.container && (this.container.addEventListener("mouseenter", function() {
                            p && d.state.playerState !== PlayerState.Playing && (d.props.keepLastFrame && d.stop(), d.play());
                        }), this.container.addEventListener("mouseleave", function() {
                            p && d.state.playerState === PlayerState.Playing && d.stop();
                        })), n && this.setPlayerSpeed(n), r && this.setPlayerDirection(r), h && this.setState({
                            background: h
                        }), [
                            3,
                            6
                        ];
                    case 5:
                        return u.sent(), this.setState({
                            playerState: PlayerState.Error
                        }), this.triggerEvent(PlayerEvent.Error), [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.play = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Play), t.play(), this.setState({
            playerState: PlayerState.Playing
        }));
    }, e.prototype.pause = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Pause), t.pause(), this.setState({
            playerState: PlayerState.Paused
        }));
    }, e.prototype.stop = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Stop), t.stop(), this.setState({
            playerState: PlayerState.Stopped
        }));
    }, e.prototype.setPlayerSpeed = function(t) {
        var e = this.state.instance;
        e && e.setSpeed(t);
    }, e.prototype.setPlayerDirection = function(t) {
        var e = this.state.instance;
        e && e.setDirection(t);
    }, e.prototype.setSeeker = function(t, e) {
        void 0 === e && (e = !1);
        var r = this.state, i = r.instance, a = r.playerState;
        i && (e && a === PlayerState.Playing ? i.goToAndPlay(t, !0) : (i.goToAndStop(t, !0), this.triggerEvent(PlayerEvent.Pause), this.setState({
            playerState: PlayerState.Paused
        })));
    }, e.prototype.setLoop = function(t) {
        var e = this.state.instance;
        e && (e.loop = t, this.setState({
            instance: e
        }));
    }, e.prototype.triggerEvent = function(t) {
        var e = this.props.onEvent;
        e && e(t);
    }, e.defaultProps = {
        loop: !1
    }, e;
}($bxRTa.Component);
function styleInject(t, e) {
    void 0 === e && (e = {});
    var r = e.insertAt;
    if (t && "undefined" != typeof document) {
        var i = document.head || document.getElementsByTagName("head")[0], a = document.createElement("style");
        a.type = "text/css", "top" === r && i.firstChild ? i.insertBefore(a, i.firstChild) : i.appendChild(a), a.styleSheet ? a.styleSheet.cssText = t : a.appendChild(document.createTextNode(t));
    }
}
var css_248z = ".lf-progress {\n  -webkit-appearance: none;\n  -moz-apperance: none;\n  width: 100%;\n  /* margin: 0 10px; */\n  height: 4px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.lf-progress:focus {\n  outline: none;\n  border: none;\n}\n.lf-progress::-moz-range-track {\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n.lf-progress::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-moz-range-thumb {\n  -moz-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-ms-track {\n  width: 100%;\n  height: 3px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n.lf-progress::-ms-fill-lower {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-fill-upper {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-thumb {\n  border: 0;\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress:focus::-ms-fill-lower {\n  background: #ccc;\n}\n.lf-progress:focus::-ms-fill-upper {\n  background: #ccc;\n}\n.lf-player-container :focus {\n  outline: 0;\n}\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-player-btn-container {\n  display: flex;\n  align-items: center;\n}\n.lf-player-btn {\n  cursor: pointer;\n  fill: #999;\n  width: 14px;\n}\n\n.lf-player-btn.active {\n  fill: #555;\n}\n\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  background-color: #ffffff;\n  opacity: 1;\n\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n  padding: 10px;\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-arrow {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  bottom: -9px;\n  border-style: solid;\n  border-width: 10px 10px 0px 10px;\n}\n\n.lf-left-align,\n.lf-left-align .lfarrow {\n  left: 0;\n  right: unset;\n}\n\n.lf-right-align,\n.lf-right-align .lf-arrow {\n  right: 0;\n  left: unset;\n}\n\n.lf-text-input {\n  border: 1px #ccc solid;\n  border-radius: 5px;\n  padding: 3px;\n  width: 60px;\n  margin: 0;\n}\n\n.lf-color-picker {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 90px;\n}\n\n.lf-color-selectors {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.lf-color-component {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n}\n\n.lf-color-component strong {\n  width: 40px;\n}\n\n.lf-color-component input[type='range'] {\n  margin: 0 0 0 10px;\n}\n\n.lf-color-component input[type='number'] {\n  width: 50px;\n  margin: 0 0 0 10px;\n}\n\n.lf-color-preview {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 5px;\n}\n\n.lf-preview {\n  height: 60px;\n  width: 60px;\n}\n\n.lf-popover-snapshot {\n  width: 150px;\n}\n.lf-popover-snapshot h5 {\n  margin: 5px 0 10px 0;\n  font-size: 0.75rem;\n}\n.lf-popover-snapshot a {\n  display: block;\n  text-decoration: none;\n}\n.lf-popover-snapshot a:before {\n  content: '\u297C';\n  margin-right: 5px;\n}\n.lf-popover-snapshot .lf-note {\n  display: block;\n  margin-top: 10px;\n  color: #999;\n}\n.lf-player-controls > div {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.lf-player-controls > div:first-child {\n  margin-left: 0px;\n}\n.lf-player-controls > div:last-child {\n  margin-right: 0px;\n}\n", stylesheet = ".lf-progress {\n  -webkit-appearance: none;\n  -moz-apperance: none;\n  width: 100%;\n  /* margin: 0 10px; */\n  height: 4px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.lf-progress:focus {\n  outline: none;\n  border: none;\n}\n.lf-progress::-moz-range-track {\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n.lf-progress::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-moz-range-thumb {\n  -moz-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-ms-track {\n  width: 100%;\n  height: 3px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n.lf-progress::-ms-fill-lower {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-fill-upper {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-thumb {\n  border: 0;\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress:focus::-ms-fill-lower {\n  background: #ccc;\n}\n.lf-progress:focus::-ms-fill-upper {\n  background: #ccc;\n}\n.lf-player-container :focus {\n  outline: 0;\n}\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-player-btn-container {\n  display: flex;\n  align-items: center;\n}\n.lf-player-btn {\n  cursor: pointer;\n  fill: #999;\n  width: 14px;\n}\n\n.lf-player-btn.active {\n  fill: #555;\n}\n\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  background-color: #ffffff;\n  opacity: 1;\n\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n  padding: 10px;\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-arrow {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  bottom: -9px;\n  border-style: solid;\n  border-width: 10px 10px 0px 10px;\n}\n\n.lf-left-align,\n.lf-left-align .lfarrow {\n  left: 0;\n  right: unset;\n}\n\n.lf-right-align,\n.lf-right-align .lf-arrow {\n  right: 0;\n  left: unset;\n}\n\n.lf-text-input {\n  border: 1px #ccc solid;\n  border-radius: 5px;\n  padding: 3px;\n  width: 60px;\n  margin: 0;\n}\n\n.lf-color-picker {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 90px;\n}\n\n.lf-color-selectors {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.lf-color-component {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n}\n\n.lf-color-component strong {\n  width: 40px;\n}\n\n.lf-color-component input[type='range'] {\n  margin: 0 0 0 10px;\n}\n\n.lf-color-component input[type='number'] {\n  width: 50px;\n  margin: 0 0 0 10px;\n}\n\n.lf-color-preview {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 5px;\n}\n\n.lf-preview {\n  height: 60px;\n  width: 60px;\n}\n\n.lf-popover-snapshot {\n  width: 150px;\n}\n.lf-popover-snapshot h5 {\n  margin: 5px 0 10px 0;\n  font-size: 0.75rem;\n}\n.lf-popover-snapshot a {\n  display: block;\n  text-decoration: none;\n}\n.lf-popover-snapshot a:before {\n  content: '\u297C';\n  margin-right: 5px;\n}\n.lf-popover-snapshot .lf-note {\n  display: block;\n  margin-top: 10px;\n  color: #999;\n}\n.lf-player-controls > div {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.lf-player-controls > div:first-child {\n  margin-left: 0px;\n}\n.lf-player-controls > div:last-child {\n  margin-right: 0px;\n}\n";
styleInject(css_248z);
var ColorPicker = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.state = {
            red: 0,
            green: 0,
            blue: 0,
            rgba: null,
            hex: "#000000",
            colorComponents: []
        }, e.handleChange = function(t, r) {
            if ("r" === t) {
                var i = "#" + (256 | r).toString(16).slice(1) + (256 | e.state.green).toString(16).slice(1) + (256 | e.state.blue).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            } else if ("g" === t) {
                i = "#" + (256 | e.state.red).toString(16).slice(1) + (256 | r).toString(16).slice(1) + (256 | e.state.blue).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            } else if ("b" === t) {
                i = "#" + (256 | e.state.red).toString(16).slice(1) + (256 | e.state.green).toString(16).slice(1) + (256 | r).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            }
        }, e.parseColor = function(t) {
            var r;
            if ("string" == typeof t) {
                if ("#" === t[0]) {
                    var i = 4 === t.length ? [
                        t.slice(1, 2),
                        t.slice(2, 3),
                        t.slice(3, 4)
                    ].map(function(t) {
                        return parseInt("" + t + t, 16);
                    }) : [
                        t.slice(1, 3),
                        t.slice(3, 5),
                        t.slice(5, 7)
                    ].map(function(t) {
                        return parseInt(t, 16);
                    });
                    e.setState({
                        colorComponents: i
                    });
                } else if (t.startsWith("rgb")) void 0 !== (i = null === (r = t.match(/\d+/g)) || void 0 === r ? void 0 : r.map(function(t) {
                    return parseInt(t);
                })) && e.setState({
                    colorComponents: i
                });
                e.state.colorComponents.length && (e.setState({
                    red: e.state.colorComponents[0]
                }), e.setState({
                    green: e.state.colorComponents[1]
                }), e.setState({
                    blue: e.state.colorComponents[2]
                }));
            }
        }, e;
    }
    return __extends(e, t), e.prototype.componentDidUpdate = function(t, e) {
        return this.props.colorChangedEvent && this.state.hex !== e.hex && this.props.colorChangedEvent(this.state.hex), !0;
    }, e.prototype.render = function() {
        var t = this;
        return $bxRTa.createElement("div", {
            className: "lf-color-picker"
        }, $bxRTa.createElement("div", {
            className: "lf-color-selectors"
        }, $bxRTa.createElement("div", {
            className: "lf-color-component"
        }, $bxRTa.createElement("strong", null, "Red"), $bxRTa.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.red,
            onChange: function(e) {
                t.setState({
                    red: e.target.value
                }), t.handleChange("r", e.target.value);
            }
        }), $bxRTa.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.red,
            onChange: function(e) {
                t.setState({
                    red: e.target.value
                }), t.handleChange("r", e.target.value);
            }
        })), $bxRTa.createElement("div", {
            className: "lf-color-component"
        }, $bxRTa.createElement("strong", null, "Green"), $bxRTa.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.green,
            onChange: function(e) {
                t.setState({
                    green: e.target.value
                }), t.handleChange("g", e.target.value);
            }
        }), $bxRTa.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.green,
            onChange: function(e) {
                t.setState({
                    green: e.target.value
                }), t.handleChange("g", e.target.value);
            }
        })), $bxRTa.createElement("div", {
            className: "lf-color-component"
        }, $bxRTa.createElement("strong", null, "Blue"), $bxRTa.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.blue,
            onChange: function(e) {
                t.setState({
                    blue: e.target.value
                }), t.handleChange("b", e.target.value);
            }
        }), $bxRTa.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.blue,
            onChange: function(e) {
                t.setState({
                    blue: e.target.value
                }), t.handleChange("b", e.target.value);
            }
        }))), $bxRTa.createElement("div", {
            className: "lf-color-preview"
        }, $bxRTa.createElement("div", {
            className: "lf-preview",
            style: {
                background: "rgb(" + this.state.red + ", " + this.state.green + ", " + this.state.blue + ")"
            }
        }), $bxRTa.createElement("div", null, $bxRTa.createElement("input", {
            className: "lf-text-input",
            type: "text",
            value: this.state.hex,
            onChange: function(e) {
                t.setState({
                    hex: e.target.value
                }), t.parseColor(e.target.value);
            }
        }))));
    }, e;
}($bxRTa.Component), Popover = function(t) {
    var e = t.children, r = t.icon, i = (0, $bxRTa.useState)(null), a = i[0], s = i[1], n = (0, $bxRTa.useState)(null), o = n[0], h = n[1], l = (0, $bxRTa.useState)(null), p = l[0], f = l[1], c = (0, $bxRTa.useState)(!1), m = c[0], d = c[1];
    (0, $bxRTa.useEffect)(function() {
        if (a && o) {
            var t = a.getBoundingClientRect(), e = o.getBoundingClientRect(), r = t.left + e.width > window.innerWidth ? -1 : 0;
            f(r);
        }
    }, [
        p,
        o,
        a
    ]);
    return $bxRTa.createElement("div", {
        className: "lf-popover",
        onMouseOver: function() {
            d(!0);
        },
        onMouseLeave: function() {
            d(!1);
        },
        ref: function(t) {
            s(t);
        }
    }, $bxRTa.createElement("div", {
        className: " lf-player-btn"
    }, r), $bxRTa.createElement("div", {
        className: "lf-popover-content",
        ref: function(t) {
            h(t);
        },
        style: {
            bottom: "22px",
            right: "0px",
            zIndex: 2,
            visibility: m ? "visible" : "hidden"
        }
    }, e));
}, Seeker = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.inputRef = $bxRTa.createRef(), r.handleChange = function() {
            return function(t) {
                var e = t.target.value, i = Math.floor(e / 100 * r.props.max);
                r.props.onChange(i);
            };
        }, r.state = {
            value: 0
        }, r;
    }
    return __extends(e, t), e.prototype.render = function() {
        var t = this.props.value / this.props.max * 100, e = {
            backgroundImage: "-webkit-gradient(linear, left top, right top, color-stop(" + t + "%, rgba(15, 204, 206, 0.4)), color-stop(" + t + "%, #DAE1E7))"
        }, r = {
            position: "absolute",
            left: 0,
            marginTop: "8px",
            width: "20px",
            display: "block",
            border: "0px",
            backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)",
            color: this.props.darkTheme ? "#B9B9B9" : "#555",
            padding: "2px",
            textAlign: "center",
            borderRadius: "3px",
            fontSize: "8px",
            fontWeight: "bold"
        }, i = {
            position: "absolute",
            right: 0,
            marginTop: "8px",
            width: "20px",
            display: "block",
            border: "0px",
            backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)",
            color: this.props.darkTheme ? "#B9B9B9" : "#555",
            padding: "2px",
            textAlign: "center",
            borderRadius: "3px",
            fontSize: "8px",
            fontWeight: "bold"
        };
        return $bxRTa.createElement("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                marginRight: "5px",
                marginLeft: "5px",
                position: "relative"
            }
        }, $bxRTa.createElement("input", {
            ref: this.inputRef,
            id: "track",
            className: "lf-progress",
            name: "progress",
            "aria-label": "progress",
            type: "range",
            min: "0",
            max: "100",
            step: "0.1",
            value: t,
            onInput: this.handleChange(),
            onChange: this.handleChange(),
            style: e
        }), this.props.showLabels && $bxRTa.createElement("div", {
            style: {
                display: "flex",
                justifyContent: "space-between"
            }
        }, $bxRTa.createElement("div", {
            style: r
        }, this.props.min), $bxRTa.createElement("div", {
            style: i
        }, this.props.max)));
    }, e;
}($bxRTa.Component), ControlButtonStyle = {
    display: "inline-flex",
    cursor: "pointer"
}, Controls = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.state = {
            activeFrame: 0,
            mouseDown: !1
        }, r;
    }
    return __extends(e, t), e.prototype.render = function() {
        var t = this, e = this.props, r = e.instance, i = e.playerState, a = e.seeker, s = e.setLoop, n = e.setSeeker, o = e.play, h = e.pause, l = e.stop, p = e.visible, f = e.buttons;
        if (!r) return null;
        if (!p) return null;
        var c = !f || f.includes("play"), m = !f || f.includes("stop"), d = !f || f.includes("repeat"), u = !f || f.includes("frame"), y = !f || f.includes("background"), g = !f || f.includes("snapshot"), v = {
            width: 14,
            height: 14,
            viewBox: "0 0 24 24"
        }, b = Math.round(r.currentFrame);
        return $bxRTa.createElement("div", {
            className: "lf-player-controls",
            style: {
                display: "flex",
                justifyContent: "space-between",
                height: "60px",
                alignItems: "center",
                backgroundColor: this.props.transparentTheme ? "transparent" : this.props.darkTheme ? "#3C3C3C" : "#ffffff",
                paddingLeft: "10px",
                paddingRight: "10px"
            }
        }, c && $bxRTa.createElement("div", {
            role: "button",
            "aria-label": i === PlayerState.Playing ? PlayerEvent.Pause : PlayerEvent.Play,
            tabIndex: 0,
            onClick: function() {
                i === PlayerState.Playing ? "function" == typeof h && h() : "function" == typeof o && o();
            },
            onKeyDown: function() {
                i === PlayerState.Playing ? "function" == typeof h && h() : "function" == typeof o && o();
            },
            className: "lf-player-btn",
            style: ControlButtonStyle
        }, i === PlayerState.Playing ? $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("rect", {
            height: "22.9",
            rx: "1.9",
            width: "7.6",
            x: "14",
            y: ".5"
        }), $bxRTa.createElement("rect", {
            height: "22.9",
            rx: "1.9",
            width: "7.6",
            x: "2",
            y: ".5"
        })) : $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("path", {
            d: "M2 3.4C2 1.9 3.5 1 4.8 1.8l16.5 9.6c1.2.7 1.2 2.5 0 3.2L4.8 24.2C3.5 25 2 24.1 2 22.6V3.4z"
        }))), m && $bxRTa.createElement("div", {
            tabIndex: 0,
            role: "button",
            "aria-label": PlayerEvent.Stop,
            onClick: function() {
                return l && l();
            },
            onKeyDown: function() {
                return l && l();
            },
            className: i === PlayerState.Stopped ? "lf-player-btn active" : "lf-player-btn",
            style: ControlButtonStyle
        }, $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("path", {
            d: "M2 3.667A1.67 1.67 0 0 1 3.667 2h16.666A1.67 1.67 0 0 1 22 3.667v16.666A1.67 1.67 0 0 1 20.333\n            22H3.667A1.67 1.67 0 0 1 2 20.333z"
        }))), $bxRTa.createElement(Seeker, {
            min: 0,
            step: 1,
            max: r ? r.totalFrames : 1,
            value: a || 0,
            onChange: function(e) {
                n && t.setState({
                    activeFrame: e
                }, function() {
                    n(e, !1);
                });
            },
            onChangeEnd: function(e) {
                n && t.setState({
                    activeFrame: e
                }, function() {
                    n(e, !1);
                });
            },
            showLabels: this.props.showLabels,
            darkTheme: this.props.darkTheme
        }), u && $bxRTa.createElement("div", {
            role: "button",
            className: "lf-player-btn-container"
        }, $bxRTa.createElement("input", {
            style: {
                outline: "none",
                border: this.props.darkTheme ? "1px #505050 solid" : "1px #ccc solid",
                borderRadius: "3px",
                width: "40px",
                textAlign: "center",
                backgroundColor: this.props.darkTheme ? "#505050" : "#ffffff",
                color: this.props.darkTheme ? "#B9B9B9" : "#999",
                fontSize: "0.7rem",
                padding: "0",
                fontFamily: "inherit"
            },
            type: "text",
            value: b,
            readOnly: !0
        })), d && $bxRTa.createElement("div", {
            role: "button",
            "aria-label": PlayerEvent.Loop,
            tabIndex: 0,
            onClick: function() {
                r && s && s(!r.loop);
            },
            onKeyDown: function() {
                r && s && s(!r.loop);
            },
            className: r.loop ? "lf-player-btn active" : "lf-player-btn",
            style: ControlButtonStyle
        }, $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("path", {
            d: "M12.5 16.8137h-.13v1.8939h4.9696c3.6455 0 6.6113-2.9658 6.6113-6.6116\n            0-3.64549-2.9658-6.61131-6.6113-6.61131-.5231 0-.947.42391-.947.94696 0 .52304.4239.94696.947.94696 2.6011 0\n            4.7174 2.11634 4.7174 4.71739 0 2.6014-2.1166 4.7177-4.7174 4.7177H12.5zM13.6025\n            5.61469v-.13H7.48137C3.83582 5.48469.87 8.45051.87 12.096c0 3.6509 3.17269 6.6117 6.81304 6.6117.52304 0\n            .94696-.424.94696-.947 0-.5231-.42392-.947-.94696-.947-2.60804 0-4.91907-2.1231-4.91907-4.7176 0-2.60115\n            2.11634-4.71744 4.7174-4.71744h6.12113V5.61469z",
            stroke: "#8795A1",
            strokeWidth: ".26"
        }), $bxRTa.createElement("path", {
            d: "M11.1482\n            2.20355h0l-.001-.00116c-.3412-.40061-.9405-.44558-1.33668-.0996h-.00001c-.39526.34519-.43936.94795-.09898\n            1.34767l2.51487 3.03683-2.51894 3.06468c-.33872.40088-.29282 1.00363.10347\n            1.34723l.08517-.0982-.08517.0982c.17853.1549.39807.2308.61647.2308.2671 0 .5328-.114.72-.3347h0l.0011-.0014\n            3.0435-3.68655.0006-.00068c.3035-.35872.3025-.88754-.0019-1.24526l-3.0425-3.65786zM13.9453\n            21.7965h0l.001.0011c.3413.4006.9407.4456 1.337.0996h0c.3953-.3452.4395-.9479.099-1.3477l-2.5154-3.0368\n            2.5195-3.0647c.3388-.4008.2929-1.0036-.1035-1.3472l-.0852.0982.0852-.0982c-.1786-.1549-.3981-.2308-.6166-.2308-.2671\n            0-.5329.114-.7202.3347h0l-.0011.0014-3.0442\n            3.6865c-.0001.0003-.0003.0005-.0005.0007-.3036.3587-.3027.8876.0019 1.2453l3.0431 3.6579z",
            fill: "#8795A1",
            stroke: "#8795A1",
            strokeWidth: ".26"
        }))), y && $bxRTa.createElement(Popover, {
            icon: $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("path", {
                d: "M12 3.1L6.1 8.6a7.6 7.6 0 00-2.2 4 7.2 7.2 0 00.4 4.4 7.9 7.9 0 003 3.5 8.7 8.7 0 004.7 1.3c1.6 0\n            3.2-.5 4.6-1.3s2.4-2 3-3.5a7.2 7.2 0 00.5-4.5 7.6 7.6 0 00-2.2-4L12 3.2zM12 0l7.5 7a9.8 9.8 0 013 5.1\n            9.3 9.3 0 01-.6 5.8c-.9 1.8-2.2 3.3-4 4.4A11.2 11.2 0 0112 24a11.2 11.2 0\n            01-6-1.7c-1.7-1-3-2.6-3.9-4.4a9.3 9.3 0 01-.6-5.8c.4-2 1.5-3.7 3-5L12 0zM6 14h12c0 1.5-.7 3-1.8 4s-2.6\n            1.6-4.2 1.6S9 19 7.8 18s-1.7-2.5-1.7-4z"
            }))
        }, $bxRTa.createElement("div", {
            slot: "content",
            className: "lf-popover popover-background"
        }, $bxRTa.createElement(ColorPicker, {
            colorChangedEvent: this.props.colorChangedEvent
        }))), g && $bxRTa.createElement(Popover, {
            icon: $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("path", {
                clipRule: "evenodd",
                d: "M0 3.01A2.983 2.983 0 012.983.027H16.99a2.983 2.983 0 012.983 2.983v14.008a2.982 2.982 0 01-2.983\n              2.983H2.983A2.983 2.983 0 010 17.018zm2.983-.941a.941.941 0 00-.942.94v14.01c0\n              .52.422.94.942.94H16.99a.94.94 0 00.941-.94V3.008a.941.941 0 00-.94-.94H2.981z",
                fillRule: "evenodd"
            }), $bxRTa.createElement("path", {
                d: "M12.229 7.945l-2.07 4.598-2.586-2.605-2.414 2.758v2.146h9.656V11.93z"
            }), $bxRTa.createElement("circle", {
                cx: "7.444",
                cy: "6.513",
                r: "2.032"
            }), $bxRTa.createElement("path", {
                d: "M9.561 23.916h11.25a2.929 2.929 0 002.926-2.927V9.954a1.06 1.06 0 10-2.122 0v11.035a.805.805 0\n              01-.803.804H9.562a1.061 1.061 0 100 2.123z",
                stroke: "#8795a1",
                strokeWidth: ".215"
            }))
        }, $bxRTa.createElement("div", {
            slot: "content",
            className: "lf-popover lf-popover-snapshot",
            onWheel: function(t) {
                n && n(b + (t.deltaY > 0 ? -1 : 1), !1);
            }
        }, $bxRTa.createElement("h5", null, "Frame ", b), $bxRTa.createElement("div", {
            style: {
                cursor: "pointer",
                color: "#0FCCCE"
            },
            onClick: this.props.snapshot
        }, "Download SVG"), $bxRTa.createElement("div", {
            style: {
                cursor: "pointer",
                color: "#0FCCCE"
            },
            onClick: this.props.snapshot
        }, "Download PNG"), $bxRTa.createElement("i", {
            className: "lf-note"
        }, "Scroll with mousewheel to find exact frame"))));
    }, e;
}($bxRTa.Component);

});

parcelRegister("hVO5T", function(module, exports) {
module.exports = JSON.parse('{"v":"5.7.4","fr":29.9700012207031,"ip":0,"op":45.0000018328876,"w":256,"h":256,"nm":"vibe","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Calque de forme 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[128,128,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,-10.25],[-49.5,103],[-92.5,39],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,65.5],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,31.25],[-49.5,103],[-92.5,81],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,18],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":16,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.247,87.636],[-49.5,62.5],[-92.5,8.144],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,10.5],[100.25,84.403],[54.75,36.25]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":23,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,51.758],[-49.5,103],[-92.5,48.989],[-129,-22],[-129.5,167.5],[128.75,171.75],[129.75,19.75],[100.25,93.847],[54.75,-2]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":31,"s":[{"i":[[30.504,0],[26.498,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,-34.148],[-49.5,39.75],[-92.5,90.277],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,33.052],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":38,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,23.747],[-49.5,-21.5],[-92.5,115.754],[-129,62.5],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,90.836],[54.75,110]],"c":true}]},{"t":45.0000018328876,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,-10.25],[-49.5,103],[-92.5,39],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,65.5],[54.75,110]],"c":true}]}],"ix":2},"nm":"Trac\xe9 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":19,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Contour 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":19,"ix":5},"r":1,"bm":0,"nm":"Fond 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformer "}],"nm":"Forme 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":45.0000018328876,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Calque de forme 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[128,128,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.5,68.5],[-92.5,108.5],[-129,4.75],[-129.5,167.5],[128.75,171.75],[129.75,53],[100.25,110.5],[54.75,38.25]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,48.5],[-49.5,-11.5],[-92.5,44],[-129,116],[-129.5,167.5],[128.75,171.75],[129.75,125.5],[100.25,62.5],[54.749,95.5]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":16,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,27],[-49.502,94.547],[-92.5,55],[-129,-19.068],[-129.5,167.5],[128.75,171.75],[129.75,125],[100.25,110.5],[54.749,-63.236]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":23,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,70],[-49.501,1.079],[-92.5,120.5],[-129,57.802],[-129.5,167.5],[128.75,171.75],[129.75,-0.19],[100.25,65.5],[54.749,45.01]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":31,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,22.75],[-49.501,80.531],[-92.5,33],[-129,114.922],[-129.5,167.5],[128.75,171.75],[129.75,-17.129],[100.25,106.25],[54.747,69.109]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":38,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.501,68.115],[-92.5,106.017],[-129,129.414],[-129.5,167.5],[128.75,171.75],[129.75,63.44],[100.25,-1.2],[54.748,66.851]],"c":true}]},{"t":45.0000018328876,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.5,68.5],[-92.5,108.5],[-129,4.75],[-129.5,167.5],[128.75,171.75],[129.75,53],[100.25,110.5],[54.75,38.25]],"c":true}]}],"ix":2},"nm":"Trac\xe9 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":19,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Contour 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":19,"ix":5},"r":1,"bm":0,"nm":"Fond 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformer "}],"nm":"Forme 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":45.0000018328876,"st":0,"bm":0}],"markers":[]}');

});

parcelRegister("6Iy5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $28aa2270500a74e1$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $9TTQJ = parcelRequire("9TTQJ");
const $28aa2270500a74e1$var$Modal = ({ isOpened: isOpened, onClose: onClose, children: children })=>{
    const modalRef = (0, $bxRTa.useRef)(null);
    const isWidget = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isWidget);
    const currentWidth = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentWidth);
    const currentHeight = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentHeight);
    (0, $bxRTa.useEffect)(()=>{
        if (isOpened) modalRef.current?.showModal();
        else modalRef.current?.close();
    }, [
        isOpened
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("dialog", {
        ref: modalRef,
        className: "rf-absolute rf-m-0 rf-text-cardFrameText rf-bg-[#121212F2] rf-border rf-border-[#707070] rf-rounded-lg",
        style: {
            transform: isWidget ? `translate(calc(${window.innerWidth / 2}px - 50%), calc(${window.innerHeight / 2}px - 50%)` : `translate(calc(${currentWidth / 2}px - 50%), calc(${currentHeight / 2}px - 50%)`
        },
        onCancel: onClose,
        onClick: onClose,
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
            className: "rf-relative rf-flex rf-flex-col",
            onClick: (event)=>event?.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                    onClick: onClose
                }),
                children
            ]
        })
    });
};
var $28aa2270500a74e1$export$2e2bcd8739ae039 = $28aa2270500a74e1$var$Modal;

});

parcelRegister("4ZEXS", function(module, exports) {

$parcel$export(module.exports, "default", () => $92319df216410cd8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $92319df216410cd8$var$MicrophoneLoader = ({ color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-h-full rf-bg-transparent",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: `rf-w-full rf-h-full rf-relative rf-rounded-max rf-mx-0 rf-my-auto ${color === 'primary' ? 'rf-loader-microphone-primary' : color === 'secondary' ? 'rf-loader-microphone-secondary' : 'rf-loader-microphone'}`,
            style: {
                borderTopColor: color || '#FFF'
            }
        })
    });
};
var $92319df216410cd8$export$2e2bcd8739ae039 = $92319df216410cd8$var$MicrophoneLoader;

});

parcelRegister("d7O2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $542b0f253e181af0$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
parcelRequire("kMAJU");
var $f3SD2 = parcelRequire("f3SD2");
const $542b0f253e181af0$var$MicrophoneModalWaiting = ()=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-max-w-[500px] rf-px-16 rf-py-16 rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f3SD2.default), {
                className: "rf-h-10"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-text-size-auto rf-text-center",
                children: translation.microphone.allow
            })
        ]
    });
};
var $542b0f253e181af0$export$2e2bcd8739ae039 = $542b0f253e181af0$var$MicrophoneModalWaiting;

});

parcelRegister("gpOhM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c609267b6627dcdb$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7QU6k = parcelRequire("7QU6k");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $clSD3 = parcelRequire("clSD3");

var $5FZWK = parcelRequire("5FZWK");

var $kdMEA = parcelRequire("kdMEA");
parcelRequire("kMAJU");
var $iNZRc = parcelRequire("iNZRc");

var $8e5cw = parcelRequire("8e5cw");

var $9TTQJ = parcelRequire("9TTQJ");
parcelRequire("d72S7");
var $cUlNP = parcelRequire("cUlNP");
const $c609267b6627dcdb$var$springDuration = 500;
const $c609267b6627dcdb$var$MicrophoneModalRefused = ()=>{
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const isUsedOnBorne = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.isUsedOnBorne);
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)(undefined);
    const [redirectionUrl, setRedirectionUrl] = (0, $bxRTa.useState)();
    const fadeInTimerRef = (0, $bxRTa.useRef)(null);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        let tempUrl = `${(0, $kdMEA.docsRetorik)}${locale.split('-')[0] === 'fr' ? '' : '/en'}/docs/depannage-autorisations-acces-micro/`;
        switch(0, $clSD3.browserName){
            case (0, $clSD3.BrowserTypes).Chrome:
            case (0, $clSD3.BrowserTypes).Chromium:
                tempUrl += '#chrome-';
                break;
            case (0, $clSD3.BrowserTypes).Edge:
            case (0, $clSD3.BrowserTypes).EdgeChromium:
                tempUrl += '#edge-';
                break;
            case (0, $clSD3.BrowserTypes).Firefox:
                tempUrl += '#firefox-';
                break;
            case (0, $clSD3.BrowserTypes).Safari:
            case (0, $clSD3.BrowserTypes).MobileSafari:
                tempUrl += '#safari-';
                break;
            case (0, $clSD3.BrowserTypes).Opera:
                tempUrl += '#opera-';
                break;
            case (0, $clSD3.BrowserTypes).SamsungBrowser:
                setRedirectionUrl(`${tempUrl}#samsung-sur-mobile`);
                return;
            case (0, $clSD3.BrowserTypes).Ie:
            case (0, $clSD3.BrowserTypes).InternetExplorer:
            default:
                break;
        }
        switch(0, $clSD3.osName){
            case (0, $clSD3.OsTypes).Windows:
            case (0, $clSD3.OsTypes).MAC_OS:
                tempUrl += 'sur-ordinateur-de-bureau';
                break;
            default:
                tempUrl += 'sur-mobile-ou-tablette';
        }
        setRedirectionUrl(tempUrl);
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        qrCodeData && api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $c609267b6627dcdb$var$springDuration
            }
        });
        return ()=>{
            fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        };
    }, [
        qrCodeData
    ]);
    const handleCloseQrCode = ()=>{
        api.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $c609267b6627dcdb$var$springDuration
            }
        });
        fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        fadeInTimerRef.current = setTimeout(()=>{
            setQrCodeData(undefined);
        }, $c609267b6627dcdb$var$springDuration);
    };
    const setQrCodeDataAsync = async (url)=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(url);
        setQrCodeData(qrCodeString);
    };
    const handleRedirect = ()=>{
        if (redirectionUrl) isUsedOnBorne ? setQrCodeDataAsync(redirectionUrl) : window.open(redirectionUrl, '_blank', 'noopener noreferrer');
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-max-w-[500px] rf-px-8 rf-py-8 rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4 rf-text-size-auto",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iNZRc.default), {
                className: "rf-h-10"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-font-light",
                children: translation.microphone.rejected
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-text-center",
                children: translation.microphone.instructions
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-card-button",
                onClick: handleRedirect,
                children: translation.common.knowmore
            }),
            qrCodeData && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
                className: "rf-absolute rf-h-full rf-w-full rf-top-0 rf-left-0 rf-z-ui rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2 rf-p-2 rf-text-truewhite",
                style: {
                    background: 'rgba(18,18,18,0.7)',
                    ...spring
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                        onClick: handleCloseQrCode,
                        showLabel: false
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-px-8 rf-flex rf-flex-row rf-items-start rf-gap-1 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cUlNP.default), {
                                color: "#FFF"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-w-fit",
                                children: translation.link.scanQRTile
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                        src: qrCodeData
                    })
                ]
            })
        ]
    });
};
var $c609267b6627dcdb$export$2e2bcd8739ae039 = $c609267b6627dcdb$var$MicrophoneModalRefused;

});
parcelRegister("clSD3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $8fe1d25903380419$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $bxRTa = parcelRequire("bxRTa");
var $8fe1d25903380419$var$React__default = $8fe1d25903380419$var$_interopDefault($bxRTa);

var $2roA1 = parcelRequire("2roA1");
var $8fe1d25903380419$var$ClientUAInstance = new $2roA1();
var $8fe1d25903380419$var$browser = $8fe1d25903380419$var$ClientUAInstance.getBrowser();
var $8fe1d25903380419$var$cpu = $8fe1d25903380419$var$ClientUAInstance.getCPU();
var $8fe1d25903380419$var$device = $8fe1d25903380419$var$ClientUAInstance.getDevice();
var $8fe1d25903380419$var$engine = $8fe1d25903380419$var$ClientUAInstance.getEngine();
var $8fe1d25903380419$var$os = $8fe1d25903380419$var$ClientUAInstance.getOS();
var $8fe1d25903380419$var$ua = $8fe1d25903380419$var$ClientUAInstance.getUA();
var $8fe1d25903380419$var$setUa = function setUa(userAgentString) {
    return $8fe1d25903380419$var$ClientUAInstance.setUA(userAgentString);
};
var $8fe1d25903380419$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error('No userAgent string was provided');
        return;
    }
    var UserAgentInstance = new $2roA1(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $8fe1d25903380419$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $8fe1d25903380419$var$ClientUAInstance,
    browser: $8fe1d25903380419$var$browser,
    cpu: $8fe1d25903380419$var$cpu,
    device: $8fe1d25903380419$var$device,
    engine: $8fe1d25903380419$var$engine,
    os: $8fe1d25903380419$var$os,
    ua: $8fe1d25903380419$var$ua,
    setUa: $8fe1d25903380419$var$setUa,
    parseUserAgent: $8fe1d25903380419$var$parseUserAgent
});
function $8fe1d25903380419$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8fe1d25903380419$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8fe1d25903380419$var$ownKeys(Object(source), true).forEach(function(key) {
            $8fe1d25903380419$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8fe1d25903380419$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8fe1d25903380419$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8fe1d25903380419$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $8fe1d25903380419$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8fe1d25903380419$var$_typeof(obj);
}
function $8fe1d25903380419$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8fe1d25903380419$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8fe1d25903380419$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8fe1d25903380419$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8fe1d25903380419$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8fe1d25903380419$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8fe1d25903380419$var$_extends() {
    $8fe1d25903380419$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8fe1d25903380419$var$_extends.apply(this, arguments);
}
function $8fe1d25903380419$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8fe1d25903380419$var$_setPrototypeOf(subClass, superClass);
}
function $8fe1d25903380419$var$_getPrototypeOf(o) {
    $8fe1d25903380419$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8fe1d25903380419$var$_getPrototypeOf(o);
}
function $8fe1d25903380419$var$_setPrototypeOf(o, p) {
    $8fe1d25903380419$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8fe1d25903380419$var$_setPrototypeOf(o, p);
}
function $8fe1d25903380419$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8fe1d25903380419$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8fe1d25903380419$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8fe1d25903380419$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8fe1d25903380419$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8fe1d25903380419$var$_assertThisInitialized(self);
}
function $8fe1d25903380419$var$_slicedToArray(arr, i) {
    return $8fe1d25903380419$var$_arrayWithHoles(arr) || $8fe1d25903380419$var$_iterableToArrayLimit(arr, i) || $8fe1d25903380419$var$_unsupportedIterableToArray(arr, i) || $8fe1d25903380419$var$_nonIterableRest();
}
function $8fe1d25903380419$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8fe1d25903380419$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8fe1d25903380419$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8fe1d25903380419$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8fe1d25903380419$var$_arrayLikeToArray(o, minLen);
}
function $8fe1d25903380419$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8fe1d25903380419$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $8fe1d25903380419$var$DeviceTypes = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Embedded: 'embedded',
    Browser: undefined
};
var $8fe1d25903380419$var$BrowserTypes = {
    Chrome: 'Chrome',
    Firefox: 'Firefox',
    Opera: 'Opera',
    Yandex: 'Yandex',
    Safari: 'Safari',
    InternetExplorer: 'Internet Explorer',
    Edge: 'Edge',
    Chromium: 'Chromium',
    Ie: 'IE',
    MobileSafari: 'Mobile Safari',
    EdgeChromium: 'Edge Chromium',
    MIUI: 'MIUI Browser',
    SamsungBrowser: 'Samsung Browser'
};
var $8fe1d25903380419$var$OsTypes = {
    IOS: 'iOS',
    Android: 'Android',
    WindowsPhone: 'Windows Phone',
    Windows: 'Windows',
    MAC_OS: 'Mac OS'
};
var $8fe1d25903380419$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $8fe1d25903380419$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $8fe1d25903380419$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $8fe1d25903380419$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $8fe1d25903380419$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $8fe1d25903380419$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $8fe1d25903380419$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $8fe1d25903380419$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $8fe1d25903380419$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $8fe1d25903380419$var$InitialDeviceTypes;
    }
};
var $8fe1d25903380419$var$setUserAgent = function setUserAgent(userAgent) {
    return $8fe1d25903380419$var$setUa(userAgent);
};
var $8fe1d25903380419$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
};
var $8fe1d25903380419$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $8fe1d25903380419$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $8fe1d25903380419$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $8fe1d25903380419$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $8fe1d25903380419$var$setDefaults(browser.major),
        browserFullVersion: $8fe1d25903380419$var$setDefaults(browser.version),
        browserName: $8fe1d25903380419$var$setDefaults(browser.name),
        engineName: $8fe1d25903380419$var$setDefaults(engine.name),
        engineVersion: $8fe1d25903380419$var$setDefaults(engine.version),
        osName: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        userAgent: $8fe1d25903380419$var$setDefaults(ua)
    };
};
var $8fe1d25903380419$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $8fe1d25903380419$var$_objectSpread2({}, type, {
        vendor: $8fe1d25903380419$var$setDefaults(device.vendor),
        model: $8fe1d25903380419$var$setDefaults(device.model),
        os: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        ua: $8fe1d25903380419$var$setDefaults(ua)
    });
};
var $8fe1d25903380419$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $8fe1d25903380419$var$setDefaults(engine.name),
        engineVersion: $8fe1d25903380419$var$setDefaults(engine.version),
        osName: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        userAgent: $8fe1d25903380419$var$setDefaults(ua)
    };
};
var $8fe1d25903380419$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $8fe1d25903380419$var$setDefaults(engine.name),
        engineVersion: $8fe1d25903380419$var$setDefaults(engine.version),
        osName: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        userAgent: $8fe1d25903380419$var$setDefaults(ua)
    };
};
var $8fe1d25903380419$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $8fe1d25903380419$var$setDefaults(engine.name),
        engineVersion: $8fe1d25903380419$var$setDefaults(engine.version),
        osName: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        userAgent: $8fe1d25903380419$var$setDefaults(ua)
    };
};
var $8fe1d25903380419$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $8fe1d25903380419$var$setDefaults(device.vendor),
        model: $8fe1d25903380419$var$setDefaults(device.model),
        engineName: $8fe1d25903380419$var$setDefaults(engine.name),
        engineVersion: $8fe1d25903380419$var$setDefaults(engine.version),
        osName: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        userAgent: $8fe1d25903380419$var$setDefaults(ua)
    };
};
function $8fe1d25903380419$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $8fe1d25903380419$var$parseUserAgent(userAgent) : $8fe1d25903380419$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $8fe1d25903380419$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $8fe1d25903380419$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $8fe1d25903380419$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $8fe1d25903380419$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $8fe1d25903380419$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $8fe1d25903380419$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $8fe1d25903380419$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $8fe1d25903380419$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $8fe1d25903380419$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Mobile;
};
var $8fe1d25903380419$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Tablet;
};
var $8fe1d25903380419$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Mobile || type === $8fe1d25903380419$var$DeviceTypes.Tablet;
};
var $8fe1d25903380419$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $8fe1d25903380419$var$DeviceTypes.SmartTv;
};
var $8fe1d25903380419$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Browser;
};
var $8fe1d25903380419$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Wearable;
};
var $8fe1d25903380419$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Console;
};
var $8fe1d25903380419$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Embedded;
};
var $8fe1d25903380419$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $8fe1d25903380419$var$setDefaults(vendor);
};
var $8fe1d25903380419$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $8fe1d25903380419$var$setDefaults(model);
};
var $8fe1d25903380419$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $8fe1d25903380419$var$setDefaults(type, 'browser');
}; // os types
var $8fe1d25903380419$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $8fe1d25903380419$var$OsTypes.Android;
};
var $8fe1d25903380419$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $8fe1d25903380419$var$OsTypes.Windows;
};
var $8fe1d25903380419$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $8fe1d25903380419$var$OsTypes.MAC_OS;
};
var $8fe1d25903380419$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $8fe1d25903380419$var$OsTypes.WindowsPhone;
};
var $8fe1d25903380419$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $8fe1d25903380419$var$OsTypes.IOS;
};
var $8fe1d25903380419$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $8fe1d25903380419$var$setDefaults(version);
};
var $8fe1d25903380419$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $8fe1d25903380419$var$setDefaults(name);
}; // browser types
var $8fe1d25903380419$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Chrome;
};
var $8fe1d25903380419$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Firefox;
};
var $8fe1d25903380419$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Chromium;
};
var $8fe1d25903380419$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Edge;
};
var $8fe1d25903380419$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Yandex;
};
var $8fe1d25903380419$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Safari || name === $8fe1d25903380419$var$BrowserTypes.MobileSafari;
};
var $8fe1d25903380419$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $8fe1d25903380419$var$BrowserTypes.MobileSafari;
};
var $8fe1d25903380419$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Opera;
};
var $8fe1d25903380419$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $8fe1d25903380419$var$BrowserTypes.InternetExplorer || name === $8fe1d25903380419$var$BrowserTypes.Ie;
};
var $8fe1d25903380419$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $8fe1d25903380419$var$BrowserTypes.MIUI;
};
var $8fe1d25903380419$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $8fe1d25903380419$var$BrowserTypes.SamsungBrowser;
};
var $8fe1d25903380419$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $8fe1d25903380419$var$setDefaults(version);
};
var $8fe1d25903380419$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $8fe1d25903380419$var$setDefaults(major);
};
var $8fe1d25903380419$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $8fe1d25903380419$var$setDefaults(name);
}; // engine types
var $8fe1d25903380419$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $8fe1d25903380419$var$setDefaults(name);
};
var $8fe1d25903380419$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $8fe1d25903380419$var$setDefaults(version);
};
var $8fe1d25903380419$var$isElectronType = function isElectronType() {
    var nav = $8fe1d25903380419$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var $8fe1d25903380419$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var $8fe1d25903380419$var$getIOS13 = function getIOS13() {
    var nav = $8fe1d25903380419$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $8fe1d25903380419$var$getIPad13 = function getIPad13() {
    return $8fe1d25903380419$var$isIOS13Check('iPad');
};
var $8fe1d25903380419$var$getIphone13 = function getIphone13() {
    return $8fe1d25903380419$var$isIOS13Check('iPhone');
};
var $8fe1d25903380419$var$getIPod13 = function getIPod13() {
    return $8fe1d25903380419$var$isIOS13Check('iPod');
};
var $8fe1d25903380419$var$getUseragent = function getUseragent(userAg) {
    return $8fe1d25903380419$var$setDefaults(userAg);
};
function $8fe1d25903380419$var$buildSelectorsObject(options) {
    var _ref = options ? options : $8fe1d25903380419$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $8fe1d25903380419$var$isSmartTVType(device),
        isConsole: $8fe1d25903380419$var$isConsoleType(device),
        isWearable: $8fe1d25903380419$var$isWearableType(device),
        isEmbedded: $8fe1d25903380419$var$isEmbeddedType(device),
        isMobileSafari: $8fe1d25903380419$var$isMobileSafariType(browser) || $8fe1d25903380419$var$getIPad13(),
        isChromium: $8fe1d25903380419$var$isChromiumType(browser),
        isMobile: $8fe1d25903380419$var$isMobileAndTabletType(device) || $8fe1d25903380419$var$getIPad13(),
        isMobileOnly: $8fe1d25903380419$var$isMobileType(device),
        isTablet: $8fe1d25903380419$var$isTabletType(device) || $8fe1d25903380419$var$getIPad13(),
        isBrowser: $8fe1d25903380419$var$isBrowserType(device),
        isDesktop: $8fe1d25903380419$var$isBrowserType(device),
        isAndroid: $8fe1d25903380419$var$isAndroidType(os),
        isWinPhone: $8fe1d25903380419$var$isWinPhoneType(os),
        isIOS: $8fe1d25903380419$var$isIOSType(os) || $8fe1d25903380419$var$getIPad13(),
        isChrome: $8fe1d25903380419$var$isChromeType(browser),
        isFirefox: $8fe1d25903380419$var$isFirefoxType(browser),
        isSafari: $8fe1d25903380419$var$isSafariType(browser),
        isOpera: $8fe1d25903380419$var$isOperaType(browser),
        isIE: $8fe1d25903380419$var$isIEType(browser),
        osVersion: $8fe1d25903380419$var$getOsVersion(os),
        osName: $8fe1d25903380419$var$getOsName(os),
        fullBrowserVersion: $8fe1d25903380419$var$getBrowserFullVersion(browser),
        browserVersion: $8fe1d25903380419$var$getBrowserVersion(browser),
        browserName: $8fe1d25903380419$var$getBrowserName(browser),
        mobileVendor: $8fe1d25903380419$var$getMobileVendor(device),
        mobileModel: $8fe1d25903380419$var$getMobileModel(device),
        engineName: $8fe1d25903380419$var$getEngineName(engine),
        engineVersion: $8fe1d25903380419$var$getEngineVersion(engine),
        getUA: $8fe1d25903380419$var$getUseragent(ua),
        isEdge: $8fe1d25903380419$var$isEdgeType(browser) || $8fe1d25903380419$var$isEdgeChromiumType(ua),
        isYandex: $8fe1d25903380419$var$isYandexType(browser),
        deviceType: $8fe1d25903380419$var$getDeviceType(device),
        isIOS13: $8fe1d25903380419$var$getIOS13(),
        isIPad13: $8fe1d25903380419$var$getIPad13(),
        isIPhone13: $8fe1d25903380419$var$getIphone13(),
        isIPod13: $8fe1d25903380419$var$getIPod13(),
        isElectron: $8fe1d25903380419$var$isElectronType(),
        isEdgeChromium: $8fe1d25903380419$var$isEdgeChromiumType(ua),
        isLegacyEdge: $8fe1d25903380419$var$isEdgeType(browser) && !$8fe1d25903380419$var$isEdgeChromiumType(ua),
        isWindows: $8fe1d25903380419$var$isWindowsType(os),
        isMacOs: $8fe1d25903380419$var$isMacOsType(os),
        isMIUI: $8fe1d25903380419$var$isMIUIType(browser),
        isSamsungBrowser: $8fe1d25903380419$var$isSamsungBrowserType(browser)
    };
}
var $8fe1d25903380419$var$isSmartTV = $8fe1d25903380419$var$isSmartTVType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isConsole = $8fe1d25903380419$var$isConsoleType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isWearable = $8fe1d25903380419$var$isWearableType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isEmbedded = $8fe1d25903380419$var$isEmbeddedType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isMobileSafari = $8fe1d25903380419$var$isMobileSafariType($8fe1d25903380419$var$browser) || $8fe1d25903380419$var$getIPad13();
var $8fe1d25903380419$var$isChromium = $8fe1d25903380419$var$isChromiumType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isMobile = $8fe1d25903380419$var$isMobileAndTabletType($8fe1d25903380419$var$device) || $8fe1d25903380419$var$getIPad13();
var $8fe1d25903380419$var$isMobileOnly = $8fe1d25903380419$var$isMobileType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isTablet = $8fe1d25903380419$var$isTabletType($8fe1d25903380419$var$device) || $8fe1d25903380419$var$getIPad13();
var $8fe1d25903380419$var$isBrowser = $8fe1d25903380419$var$isBrowserType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isDesktop = $8fe1d25903380419$var$isBrowserType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isAndroid = $8fe1d25903380419$var$isAndroidType($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$isWinPhone = $8fe1d25903380419$var$isWinPhoneType($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$isIOS = $8fe1d25903380419$var$isIOSType($8fe1d25903380419$var$os) || $8fe1d25903380419$var$getIPad13();
var $8fe1d25903380419$var$isChrome = $8fe1d25903380419$var$isChromeType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isFirefox = $8fe1d25903380419$var$isFirefoxType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isSafari = $8fe1d25903380419$var$isSafariType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isOpera = $8fe1d25903380419$var$isOperaType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isIE = $8fe1d25903380419$var$isIEType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$osVersion = $8fe1d25903380419$var$getOsVersion($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$osName = $8fe1d25903380419$var$getOsName($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$fullBrowserVersion = $8fe1d25903380419$var$getBrowserFullVersion($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$browserVersion = $8fe1d25903380419$var$getBrowserVersion($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$browserName = $8fe1d25903380419$var$getBrowserName($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$mobileVendor = $8fe1d25903380419$var$getMobileVendor($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$mobileModel = $8fe1d25903380419$var$getMobileModel($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$engineName = $8fe1d25903380419$var$getEngineName($8fe1d25903380419$var$engine);
var $8fe1d25903380419$var$engineVersion = $8fe1d25903380419$var$getEngineVersion($8fe1d25903380419$var$engine);
var $8fe1d25903380419$var$getUA = $8fe1d25903380419$var$getUseragent($8fe1d25903380419$var$ua);
var $8fe1d25903380419$var$isEdge = $8fe1d25903380419$var$isEdgeType($8fe1d25903380419$var$browser) || $8fe1d25903380419$var$isEdgeChromiumType($8fe1d25903380419$var$ua);
var $8fe1d25903380419$var$isYandex = $8fe1d25903380419$var$isYandexType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$deviceType = $8fe1d25903380419$var$getDeviceType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isIOS13 = $8fe1d25903380419$var$getIOS13();
var $8fe1d25903380419$var$isIPad13 = $8fe1d25903380419$var$getIPad13();
var $8fe1d25903380419$var$isIPhone13 = $8fe1d25903380419$var$getIphone13();
var $8fe1d25903380419$var$isIPod13 = $8fe1d25903380419$var$getIPod13();
var $8fe1d25903380419$var$isElectron = $8fe1d25903380419$var$isElectronType();
var $8fe1d25903380419$var$isEdgeChromium = $8fe1d25903380419$var$isEdgeChromiumType($8fe1d25903380419$var$ua);
var $8fe1d25903380419$var$isLegacyEdge = $8fe1d25903380419$var$isEdgeType($8fe1d25903380419$var$browser) && !$8fe1d25903380419$var$isEdgeChromiumType($8fe1d25903380419$var$ua);
var $8fe1d25903380419$var$isWindows = $8fe1d25903380419$var$isWindowsType($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$isMacOs = $8fe1d25903380419$var$isMacOsType($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$isMIUI = $8fe1d25903380419$var$isMIUIType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isSamsungBrowser = $8fe1d25903380419$var$isSamsungBrowserType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== 'string') {
        console.error('No valid user agent string was provided');
        return;
    }
    var _UAHelper$parseUserAg = $8fe1d25903380419$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $8fe1d25903380419$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $8fe1d25903380419$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isAndroid ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isBrowser ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isIE ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isIOS ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isMobile ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isTablet ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isWinPhone ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $8fe1d25903380419$var$isMobileOnly ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isSmartTV ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isConsole ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isWearable ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
function $8fe1d25903380419$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $8fe1d25903380419$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $8fe1d25903380419$var$_classCallCheck(this, _class);
            _this = $8fe1d25903380419$var$_possibleConstructorReturn(this, $8fe1d25903380419$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($8fe1d25903380419$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($8fe1d25903380419$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($8fe1d25903380419$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $8fe1d25903380419$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $8fe1d25903380419$var$_typeof(window)) !== undefined && $8fe1d25903380419$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $8fe1d25903380419$var$React__default.createElement(WrappedComponent, $8fe1d25903380419$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($8fe1d25903380419$var$React__default.Component);
}
function $8fe1d25903380419$var$useMobileOrientation() {
    var _useState = $bxRTa.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
    }), _useState2 = $8fe1d25903380419$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $bxRTa.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $bxRTa.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $8fe1d25903380419$var$_typeof(window)) !== undefined && $8fe1d25903380419$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $8fe1d25903380419$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $8fe1d25903380419$var$parseUserAgent(hookUserAgent);
}
function $8fe1d25903380419$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $8fe1d25903380419$var$useDeviceData(hookUserAgent);
    var selectors = $8fe1d25903380419$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
module.exports.AndroidView = $8fe1d25903380419$var$AndroidView;
module.exports.BrowserTypes = $8fe1d25903380419$var$BrowserTypes;
module.exports.BrowserView = $8fe1d25903380419$var$BrowserView;
module.exports.ConsoleView = $8fe1d25903380419$var$ConsoleView;
module.exports.CustomView = $8fe1d25903380419$var$CustomView;
module.exports.IEView = $8fe1d25903380419$var$IEView;
module.exports.IOSView = $8fe1d25903380419$var$IOSView;
module.exports.MobileOnlyView = $8fe1d25903380419$var$MobileOnlyView;
module.exports.MobileView = $8fe1d25903380419$var$MobileView;
module.exports.OsTypes = $8fe1d25903380419$var$OsTypes;
module.exports.SmartTVView = $8fe1d25903380419$var$SmartTVView;
module.exports.TabletView = $8fe1d25903380419$var$TabletView;
module.exports.WearableView = $8fe1d25903380419$var$WearableView;
module.exports.WinPhoneView = $8fe1d25903380419$var$WinPhoneView;
module.exports.browserName = $8fe1d25903380419$var$browserName;
module.exports.browserVersion = $8fe1d25903380419$var$browserVersion;
module.exports.deviceDetect = $8fe1d25903380419$var$deviceDetect;
module.exports.deviceType = $8fe1d25903380419$var$deviceType;
module.exports.engineName = $8fe1d25903380419$var$engineName;
module.exports.engineVersion = $8fe1d25903380419$var$engineVersion;
module.exports.fullBrowserVersion = $8fe1d25903380419$var$fullBrowserVersion;
module.exports.getSelectorsByUserAgent = $8fe1d25903380419$var$getSelectorsByUserAgent;
module.exports.getUA = $8fe1d25903380419$var$getUA;
module.exports.isAndroid = $8fe1d25903380419$var$isAndroid;
module.exports.isBrowser = $8fe1d25903380419$var$isBrowser;
module.exports.isChrome = $8fe1d25903380419$var$isChrome;
module.exports.isChromium = $8fe1d25903380419$var$isChromium;
module.exports.isConsole = $8fe1d25903380419$var$isConsole;
module.exports.isDesktop = $8fe1d25903380419$var$isDesktop;
module.exports.isEdge = $8fe1d25903380419$var$isEdge;
module.exports.isEdgeChromium = $8fe1d25903380419$var$isEdgeChromium;
module.exports.isElectron = $8fe1d25903380419$var$isElectron;
module.exports.isEmbedded = $8fe1d25903380419$var$isEmbedded;
module.exports.isFirefox = $8fe1d25903380419$var$isFirefox;
module.exports.isIE = $8fe1d25903380419$var$isIE;
module.exports.isIOS = $8fe1d25903380419$var$isIOS;
module.exports.isIOS13 = $8fe1d25903380419$var$isIOS13;
module.exports.isIPad13 = $8fe1d25903380419$var$isIPad13;
module.exports.isIPhone13 = $8fe1d25903380419$var$isIPhone13;
module.exports.isIPod13 = $8fe1d25903380419$var$isIPod13;
module.exports.isLegacyEdge = $8fe1d25903380419$var$isLegacyEdge;
module.exports.isMIUI = $8fe1d25903380419$var$isMIUI;
module.exports.isMacOs = $8fe1d25903380419$var$isMacOs;
module.exports.isMobile = $8fe1d25903380419$var$isMobile;
module.exports.isMobileOnly = $8fe1d25903380419$var$isMobileOnly;
module.exports.isMobileSafari = $8fe1d25903380419$var$isMobileSafari;
module.exports.isOpera = $8fe1d25903380419$var$isOpera;
module.exports.isSafari = $8fe1d25903380419$var$isSafari;
module.exports.isSamsungBrowser = $8fe1d25903380419$var$isSamsungBrowser;
module.exports.isSmartTV = $8fe1d25903380419$var$isSmartTV;
module.exports.isTablet = $8fe1d25903380419$var$isTablet;
module.exports.isWearable = $8fe1d25903380419$var$isWearable;
module.exports.isWinPhone = $8fe1d25903380419$var$isWinPhone;
module.exports.isWindows = $8fe1d25903380419$var$isWindows;
module.exports.isYandex = $8fe1d25903380419$var$isYandex;
module.exports.mobileModel = $8fe1d25903380419$var$mobileModel;
module.exports.mobileVendor = $8fe1d25903380419$var$mobileVendor;
module.exports.osName = $8fe1d25903380419$var$osName;
module.exports.osVersion = $8fe1d25903380419$var$osVersion;
module.exports.parseUserAgent = $8fe1d25903380419$var$parseUserAgent;
module.exports.setUserAgent = $8fe1d25903380419$var$setUserAgent;
module.exports.useDeviceData = $8fe1d25903380419$var$useDeviceData;
module.exports.useDeviceSelectors = $8fe1d25903380419$var$useDeviceSelectors;
module.exports.useMobileOrientation = $8fe1d25903380419$var$useMobileOrientation;
module.exports.withOrientationChange = $8fe1d25903380419$var$withOrientationChange;

});



parcelRegister("91jIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2625bdeb54ab2b5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("9cEaH");
var $CgDXB = parcelRequire("CgDXB");
var $3o2AQ = parcelRequire("3o2AQ");
var $2aOO4 = parcelRequire("2aOO4");
parcelRequire("l9TTE");
var $66rUF = parcelRequire("66rUF");

var $f51Nf = parcelRequire("f51Nf");
const $d2625bdeb54ab2b5$var$Parameters = ({ handleBack: handleBack })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const displaySubtitles = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.displaySubtitles);
    const disableHistory = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableHistory);
    const disableSubtitles = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableSubtitles);
    const muted = (0, $5FZWK.useSelector)((state)=>state.speechReducer.muted);
    const disableSound = (0, $5FZWK.useSelector)((state)=>state.speechReducer.disableSound);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const handleSoundChange = (val)=>{
        dispatch((0, $cto9a.storeActions).speech.setMuted(!val));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            !disableSound && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $66rUF.default), {
                className: "rf-py-3 large:rf-py-0",
                title: translation.common.sound,
                handleChange: handleSoundChange,
                defaultChecked: !muted
            }),
            isMobile && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-0 rf-w-full rf-border-t rf-border-t-menuBorder"
            }),
            mode !== (0, $2rYkD.Mode).text && !disableSubtitles && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $66rUF.default), {
                className: "rf-py-3 large:rf-py-0",
                title: translation.common.subtitle,
                handleChange: (on)=>dispatch((0, $cto9a.storeActions).retorik.setDisplaySubtitles(on)),
                defaultChecked: displaySubtitles
            }),
            isMobile && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3o2AQ.default), {}),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2aOO4.default), {
                        handleBack: handleBack
                    }),
                    !disableHistory && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $CgDXB.default), {
                        handleBack: handleBack
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f51Nf.default), {
                        handleClick: handleBack
                    })
                ]
            })
        ]
    });
};
var $d2625bdeb54ab2b5$export$2e2bcd8739ae039 = $d2625bdeb54ab2b5$var$Parameters;

});

parcelRegister("2aOO4", function(module, exports) {

$parcel$export(module.exports, "default", () => $abec42842328198d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $dLhbi = parcelRequire("dLhbi");
const $abec42842328198d$var$TutorialButton = ({ handleBack: handleBack })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const handleClick = ()=>{
        handleBack && handleBack();
        console.log('Launch tutorial');
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dLhbi.default), {
        title: translation.tutorial.shorttitle,
        icon: "tutorial",
        onClick: handleClick
    });
};
var $abec42842328198d$export$2e2bcd8739ae039 = $abec42842328198d$var$TutorialButton;

});


parcelRegister("dHUeX", function(module, exports) {

$parcel$export(module.exports, "CONTENT_TYPE_NEWS", () => $61cb18f0f95eed1f$export$7ff82c027074e396);
$parcel$export(module.exports, "CONTENT_TYPE_POI", () => $61cb18f0f95eed1f$export$8c612ad42a82284);
$parcel$export(module.exports, "CONTENT_TYPE_EMPTY", () => $61cb18f0f95eed1f$export$9399f66a54c38cac);
$parcel$export(module.exports, "CONTENT_TYPE_IMAGE", () => $61cb18f0f95eed1f$export$c50891df8986f6d9);
$parcel$export(module.exports, "CONTENT_TYPE_LINK", () => $61cb18f0f95eed1f$export$cce25171fe980112);
$parcel$export(module.exports, "CONTENT_TYPE_DISCOVER", () => $61cb18f0f95eed1f$export$8ebd8d161896e63a);
$parcel$export(module.exports, "CONTENT_TYPE_SUGGESTION", () => $61cb18f0f95eed1f$export$a4f2f23a67537f78);
$parcel$export(module.exports, "CONTENT_TYPE_SUGGESTEDACTION", () => $61cb18f0f95eed1f$export$2730c89e9ebd0948);
$parcel$export(module.exports, "CONTENT_TYPE_GRID", () => $61cb18f0f95eed1f$export$25f48dcc671a4afe);
$parcel$export(module.exports, "CONTENT_TYPE_TILE", () => $61cb18f0f95eed1f$export$98515f55cf51a42d);
$parcel$export(module.exports, "CONTENT_TYPE_INTERNAL_COUNTER", () => $61cb18f0f95eed1f$export$148e350383f31950);
$parcel$export(module.exports, "CONTENT_TYPE_NAMED_LIST", () => $61cb18f0f95eed1f$export$aae5ca847b436674);
$parcel$export(module.exports, "CONTENT_TYPE_GRID_TITLE", () => $61cb18f0f95eed1f$export$8180494a68c87622);
$parcel$export(module.exports, "CONTENT_TYPE_MODAL_EXTERNALURI", () => $61cb18f0f95eed1f$export$a831f0b167e16113);
const $61cb18f0f95eed1f$export$bbfd0bb0baceb2f8 = 'application/vnd.microsoft.card.adaptive';
const $61cb18f0f95eed1f$export$264354e75632a3ba = 'application/vnd.microsoft.card.hero';
const $61cb18f0f95eed1f$export$7ff82c027074e396 = 'application/vnd.davi.retorik.card.news';
const $61cb18f0f95eed1f$export$8c612ad42a82284 = 'application/vnd.davi.retorik.card.poi';
const $61cb18f0f95eed1f$export$9399f66a54c38cac = 'application/vnd.davi.retorik.card.empty';
const $61cb18f0f95eed1f$export$c50891df8986f6d9 = 'application/vnd.davi.retorik.card.image';
const $61cb18f0f95eed1f$export$cce25171fe980112 = 'application/vnd.davi.retorik.card.link';
const $61cb18f0f95eed1f$export$8ebd8d161896e63a = 'application/vnd.davi.retorik.card.discover';
const $61cb18f0f95eed1f$export$a4f2f23a67537f78 = 'application/vnd.davi.retorik.card.suggestion';
const $61cb18f0f95eed1f$export$2730c89e9ebd0948 = 'application/vnd.davi.retorik.card.suggestedaction';
const $61cb18f0f95eed1f$export$25f48dcc671a4afe = 'application/vnd.davi.retorik.card.grid';
const $61cb18f0f95eed1f$export$98515f55cf51a42d = 'application/vnd.davi.retorik.card.tile';
const $61cb18f0f95eed1f$export$148e350383f31950 = 'application/vnd.davi.retorik.card.counter';
const $61cb18f0f95eed1f$export$aae5ca847b436674 = 'application/vnd.davi.retorik.card.namedlistitem';
const $61cb18f0f95eed1f$export$8180494a68c87622 = 'application/vnd.davi.retorik.grid.title';
const $61cb18f0f95eed1f$export$a831f0b167e16113 = 'application/vnd.davi.retorik.modal.externaluri';

});

parcelRegister("2nxul", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaab6ada7fdf6dbd$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $dHUeX = parcelRequire("dHUeX");

var $2rYkD = parcelRequire("2rYkD");

var $hITwk = parcelRequire("hITwk");

var $dd8py = parcelRequire("dd8py");

var $ejd1L = parcelRequire("ejd1L");
const $aaab6ada7fdf6dbd$var$Attachments = ({ activity: activity, display: display, history: history, triggerScroll: triggerScroll })=>{
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const attachments = (0, $bxRTa.useMemo)(()=>{
        return activity?.attachments?.filter((attachment)=>attachment.contentType !== (0, $dHUeX.CONTENT_TYPE_GRID_TITLE)) || [];
    }, [
        activity.id
    ]);
    const checkDisplay = (attachmentLayout)=>{
        if (!attachments?.length) return (0, $2rYkD.Displays).none;
        if (attachmentLayout) switch(attachmentLayout.toLowerCase()){
            case 'davilist':
                return (0, $2rYkD.Displays).none;
            case 'carousel':
            case 'namedlist':
                return attachments.length > 1 ? (0, $2rYkD.Displays).carousel : (0, $2rYkD.Displays).normal;
            case 'grid':
                // Grid display is not available in mobile mode
                return isMobile ? (0, $2rYkD.Displays).carouselgrid : (0, $2rYkD.Displays).grid;
        }
        // If we have no attachment layout but attachment(s), we use none display by default is there are several attachments
        return attachments.length > 1 ? (0, $2rYkD.Displays).none : (0, $2rYkD.Displays).normal;
    };
    const currentDisplay = (0, $bxRTa.useMemo)(()=>{
        return display || checkDisplay(activity.attachmentLayout);
    }, [
        attachments,
        display,
        isMobile
    ]);
    return currentDisplay === (0, $2rYkD.Displays).normal ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hITwk.default), {
        attachment: attachments[0],
        history: history,
        activityId: activity.id,
        triggerScroll: triggerScroll
    }) : currentDisplay === (0, $2rYkD.Displays).carousel || currentDisplay === (0, $2rYkD.Displays).carouselgrid ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dd8py.default), {
        title: activity.attachments?.find((attachment)=>attachment.contentType === (0, $dHUeX.CONTENT_TYPE_GRID_TITLE))?.content?.text,
        attachments: attachments,
        history: history,
        grid: currentDisplay === (0, $2rYkD.Displays).carouselgrid,
        showSearchBar: !!(activity.attachmentLayout?.toLowerCase() === 'namedlist' && attachments.length > 1),
        triggerScroll: triggerScroll
    }) : currentDisplay === (0, $2rYkD.Displays).grid ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ejd1L.default), {
        title: activity.attachments?.find((attachment)=>attachment.contentType === (0, $dHUeX.CONTENT_TYPE_GRID_TITLE))?.content?.text,
        attachments: attachments,
        history: history,
        triggerScroll: triggerScroll
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $aaab6ada7fdf6dbd$export$2e2bcd8739ae039 = $aaab6ada7fdf6dbd$var$Attachments;

});
parcelRegister("hITwk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f7269fe4cc92535$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $8HSQQ = parcelRequire("8HSQQ");

var $9GMhE = parcelRequire("9GMhE");
const $7f7269fe4cc92535$var$SingleCardContainer = ({ attachment: attachment, history: history, activityId: activityId, triggerScroll: triggerScroll })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    (0, $bxRTa.useEffect)(()=>{
        triggerScroll?.();
    }, []);
    return attachment.contentType.includes('.card') ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9GMhE.default), {
        className: history ? 'rf-w-full' : 'rf-w-full rf-min-w-full landscape-retorik:rf-w-[48%] landscape-retorik:rf-min-w-[48%] landscape-retorik:rf-ml-1/5 large-vertical:rf-w-3/5 large-vertical:rf-min-w-3/5 rf-max-h-full',
        children: (0, $8HSQQ.default)({
            attachment: attachment,
            history: history
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: (0, $8HSQQ.default)({
            attachment: attachment,
            history: history,
            activityId: activityId,
            setModalFullscreenContent: (value, activityId)=>dispatch((0, $cto9a.storeActions).utils.setModalFullscreenContentFromActivity({
                    value: value,
                    fromActivity: activityId
                }))
        })
    });
};
var $7f7269fe4cc92535$export$2e2bcd8739ae039 = $7f7269fe4cc92535$var$SingleCardContainer;

});
parcelRegister("8HSQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1205cbb49dfe016$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $dHUeX = parcelRequire("dHUeX");

var $7aiQ6 = parcelRequire("7aiQ6");

var $hGmDs = parcelRequire("hGmDs");

var $8fRqq = parcelRequire("8fRqq");

var $icqMW = parcelRequire("icqMW");

var $9rMVA = parcelRequire("9rMVA");

var $ck3iG = parcelRequire("ck3iG");

var $k60RP = parcelRequire("k60RP");

var $cZz3G = parcelRequire("cZz3G");

var $3B8pL = parcelRequire("3B8pL");

var $030Xj = parcelRequire("030Xj");

var $hRTgS = parcelRequire("hRTgS");

var $xEIv0 = parcelRequire("xEIv0");

var $exvww = parcelRequire("exvww");

var $beoxv = parcelRequire("beoxv");
const $d1205cbb49dfe016$var$renderAttachment = ({ attachment: attachment, history: history, activityId: activityId, height: height, setQrCodeData: setQrCodeData, setModalFullscreenContent: setModalFullscreenContent })=>{
    switch(attachment.contentType){
        case 0, $dHUeX.CONTENT_TYPE_NEWS:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7aiQ6.default), {
                ...attachment.content,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_POI:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hGmDs.default), {
                ...attachment.content
            });
        case 0, $dHUeX.CONTENT_TYPE_EMPTY:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8fRqq.default), {});
        case 0, $dHUeX.CONTENT_TYPE_IMAGE:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $icqMW.default), {
                ...attachment.content,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_LINK:
            return Array.isArray(attachment.content.urlData) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ck3iG.default), {
                ...attachment.content,
                height: height
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9rMVA.default), {
                ...attachment.content,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_SUGGESTEDACTION:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $k60RP.default), {
                ...attachment.content,
                history: history,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_DISCOVER:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cZz3G.default), {
                ...attachment.content,
                history: history,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_SUGGESTION:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3B8pL.default), {
                ...attachment.content,
                history: history,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_GRID:
        case 0, $dHUeX.CONTENT_TYPE_TILE:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $030Xj.default), {
                ...attachment.content,
                history: history,
                setQrCodeDataOverlay: setQrCodeData
            });
        case 0, $dHUeX.CONTENT_TYPE_MODAL_EXTERNALURI:
            if (!history) {
                const customComponent = /*#__PURE__*/ (0, $fl9nK.jsx)((0, $beoxv.default), {
                    ...attachment.content
                });
                setTimeout(()=>{
                    setModalFullscreenContent?.(customComponent, activityId || 'mock activityId');
                }, 250);
            }
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        case 0, $dHUeX.CONTENT_TYPE_INTERNAL_COUNTER:
            return history ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $xEIv0.default), {});
        case 0, $dHUeX.CONTENT_TYPE_NAMED_LIST:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $exvww.default), {
                ...attachment.content,
                history: history,
                height: height
            });
        default:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hRTgS.default), {
                content: attachment.content,
                height: height
            });
    }
};
var $d1205cbb49dfe016$export$2e2bcd8739ae039 = $d1205cbb49dfe016$var$renderAttachment;

});
parcelRegister("7aiQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e269216fbe0b81$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
parcelRequire("l9TTE");
var $bQTDb = parcelRequire("bQTDb");
const $87e269216fbe0b81$var$NewsAttachment = ({ title: title, subtitle: subtitle, text: text, media: media, height: height })=>{
    const medias = [];
    media && media.forEach((med)=>{
        medias.push({
            url: med.url,
            alt: med.profile || 'media'
        });
    });
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-col rf-gap-4 rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText",
        style: {
            height: height,
            touchAction: 'pan-y'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-fit rf-px-2 rf-py-1 large:rf-py-2 rf-small-size-auto rf-uppercase rf-border rf-border-black rf-bg-black rf-text-primary",
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-title-size-auto",
                children: subtitle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-gap-3",
                children: [
                    medias.length > 0 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-[45%] rf-min-w-[45%] rf-max-w-[45%] rf-flex rf-justify-center rf-aspect-square large:rf-aspect-video",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bQTDb.default), {
                            className: "rf-max-h-full rf-max-w-full rf-h-fit rf-w-fit",
                            medias: medias
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-line-clamp-7",
                        children: text
                    })
                ]
            })
        ]
    });
};
var $87e269216fbe0b81$export$2e2bcd8739ae039 = $87e269216fbe0b81$var$NewsAttachment;

});

parcelRegister("hGmDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $881bf6ededcd0d75$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");
parcelRequire("d72S7");
var $79eFo = parcelRequire("79eFo");
var $epsYO = parcelRequire("epsYO");

var $cZ7bt = parcelRequire("cZ7bt");
const $881bf6ededcd0d75$var$ReviewsAndFavorite = ({ reviews: reviews, favorite: favorite })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            reviews && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cZ7bt.default), {
                customerReviews: reviews,
                className: "rf-absolute rf-top-0 rf-right-2"
            }),
            favorite && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $79eFo.default), {
                className: "rf-absolute rf-h-6 large:rf-h-8 rf-bottom-2 rf-right-2"
            })
        ]
    });
};
const $881bf6ededcd0d75$var$POIAttachment = ({ media: media, title: title, subtitle: subtitle, favorite: favorite, customerReviews: customerReviews, tap: tap, distance: distance })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const handleClick = ()=>{
        tap && dispatch((0, $cto9a.storeActions).directline.sendMessage({
            value: tap
        }));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-rounded hover:rf-cursor-pointer",
        onClick: handleClick,
        children: [
            media && media[0]?.url ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-relative rf-w-full rf-rounded rf-aspect-video",
                style: {
                    backgroundImage: `url(${media[0].url.replaceAll("'", '%27')})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                },
                children: /*#__PURE__*/ (0, $fl9nK.jsx)($881bf6ededcd0d75$var$ReviewsAndFavorite, {
                    reviews: customerReviews,
                    favorite: favorite
                })
            }) : /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-relative rf-w-full rf-bg-silver rf-rounded rf-aspect-video",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $epsYO.default), {
                        className: "rf-absolute rf-h-1/3 rf-top-1/3 rf-left-1/2 rf-transform -rf-translate-x-1/2"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)($881bf6ededcd0d75$var$ReviewsAndFavorite, {
                        reviews: customerReviews,
                        favorite: favorite
                    })
                ]
            }),
            subtitle && /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-mt-2 rf-font-bold rf-line-clamp-2",
                style: {
                    color: themeColors.agendaColor
                },
                children: subtitle
            }),
            distance && /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-mt-2 rf-font-bold rf-text-gray",
                children: `${(distance / 1000).toFixed(1)} km`
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-my-2 rf-font-bold rf-line-clamp-2",
                children: title || ''
            })
        ]
    });
};
var $881bf6ededcd0d75$export$2e2bcd8739ae039 = $881bf6ededcd0d75$var$POIAttachment;

});
parcelRegister("cZ7bt", function(module, exports) {

$parcel$export(module.exports, "default", () => $30c32995d18448a1$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");
parcelRequire("d72S7");
var $a0inq = parcelRequire("a0inq");
const $30c32995d18448a1$var$CommentsPennant = ({ className: className, customerReviews: customerReviews })=>{
    const { color: color } = (0, $4mkhB.useList)();
    const [widthInPx, setWidthInPx] = (0, $bxRTa.useState)(0);
    const pennantRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (pennantRef.current) setWidthInPx(Math.ceil(pennantRef.current.offsetWidth / 2));
    }, [
        pennantRef
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `${className} rf-flex rf-flex-col rf-justify-center rf-text-white`,
        ref: pennantRef,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-items-center rf-p-1",
                style: {
                    backgroundColor: color
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a0inq.default), {
                        className: "rf-w-6 large:rf-w-8 rf-py-2 vertical:rf-py-1"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-font-bold rf-small-size-auto rf-text-center",
                        children: [
                            customerReviews,
                            "/10"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-0 rf-h-0 rf-border-t-0 rf-border-x-primary rf-border-b-transparent",
                style: {
                    borderLeftColor: color,
                    borderRightColor: color,
                    borderBottomWidth: widthInPx * 2 / 3,
                    borderLeftWidth: widthInPx,
                    borderRightWidth: widthInPx
                }
            })
        ]
    });
};
var $30c32995d18448a1$export$2e2bcd8739ae039 = $30c32995d18448a1$var$CommentsPennant;

});
parcelRegister("4mkhB", function(module, exports) {

$parcel$export(module.exports, "useList", () => $138ade36c671bdf6$export$f9763ecd339e95eb);
$parcel$export(module.exports, "ListProvider", () => $138ade36c671bdf6$export$9b0a72e5d41d62ec);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $9Alju = parcelRequire("9Alju");
const $138ade36c671bdf6$var$ListContextDefaultValues = {
    content: undefined,
    filters: [],
    selectedFilters: [],
    loadingData: false,
    color: '',
    setContent: ()=>{},
    setSelectedFilters: ()=>{},
    resetFilters: ()=>{},
    processFiltersOnChange: ()=>{},
    setSuggestedFilter: ()=>{},
    setLoadingData: ()=>{}
};
const $138ade36c671bdf6$export$52411773e0d6f15d = /*#__PURE__*/ (0, $bxRTa.createContext)($138ade36c671bdf6$var$ListContextDefaultValues);
function $138ade36c671bdf6$export$f9763ecd339e95eb() {
    return (0, $bxRTa.useContext)($138ade36c671bdf6$export$52411773e0d6f15d);
}
function $138ade36c671bdf6$export$9b0a72e5d41d62ec({ children: children }) {
    const dispatch = (0, $5FZWK.useDispatch)();
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const timerForFilterSelectionListMode = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.timerForFilterSelectionListMode);
    const [content, setContent] = (0, $bxRTa.useState)();
    const [filters, setFilters] = (0, $bxRTa.useState)([]);
    const [selectedFilters, setSelectedFilters] = (0, $bxRTa.useState)([]);
    const [loadingData, setLoadingData] = (0, $bxRTa.useState)(false);
    const color = (0, $bxRTa.useMemo)(()=>{
        return (0, $9Alju.getColorFromCategoryId)(content?.channelData?.category?.id, themeColors);
    }, [
        content
    ]);
    const timerRef = (0, $bxRTa.useRef)();
    const setSuggestedFilter = (filter)=>{
        setSelectedFilters([
            filter
        ]);
    };
    /**
   * On call :
   *  - set selectedFilters state to empty array
   *  - send postBack message with empty filters
   */ const resetFilters = ()=>{
        setSelectedFilters([]);
        dispatch((0, $cto9a.storeActions).directline.sendMessage({
            value: {
                filters: []
            }
        }));
    };
    /**
   * On call :
   *  - set selectedFilters and filters states to empty arrays
   */ const totalReset = ()=>{
        setSelectedFilters([]);
        setFilters([]);
    };
    const processFiltersOnChange = (data, full = false)=>{
        let tempFilters = [];
        timerRef?.current && clearTimeout(timerRef.current);
        if (selectedFilters.length > 0) {
            let remainingData = [
                ...data
            ];
            // Check on each selected filter to modify if necessary
            selectedFilters.forEach((selectedFilter)=>{
                let items = [
                    ...selectedFilter.filterItems
                ];
                data.forEach((filter)=>{
                    if (filter.id === selectedFilter.id) {
                        // Special treatment for calendar filter : only 1 value allowed
                        if (filter.id === 'Event.DateRange') {
                            if (items.length > 0 && filter.filterItems.length > 0 && items[0] === filter.filterItems[0]) items = [];
                            else items = [
                                ...filter.filterItems
                            ];
                        } else // If the chosen filter is a full one and has already at least one item chosen, let's choose all its items
                        if (full) items = selectedFilter.filterItems.length === filter.filterItems.length ? [] : [
                            ...filter.filterItems
                        ];
                        else items = [
                            ...selectedFilter.filterItems,
                            ...filter.filterItems
                        ].filter((item)=>!(selectedFilter.filterItems.find((filterItem)=>item.name === filterItem.name && item.value === filterItem.value) !== undefined && filter.filterItems.find((filterItem)=>item.name === filterItem.name && item.value === filterItem.value) !== undefined));
                        // Let's remove this filter from remainingData because it has been processed
                        remainingData = remainingData.filter((fil)=>fil.id !== filter.id);
                    }
                });
                items.length > 0 && (tempFilters = [
                    ...tempFilters,
                    {
                        id: selectedFilter.id,
                        title: selectedFilter.title,
                        filterItems: items
                    }
                ]);
            });
            // If some filters weren't in the selected filters, we add them to the selected filters
            remainingData.length > 0 && (tempFilters = [
                ...tempFilters,
                ...remainingData
            ]);
        } else data.length > 0 && (tempFilters = data);
        setSelectedFilters(tempFilters);
        timerRef.current = setTimeout(()=>{
            dispatch((0, $cto9a.storeActions).directline.sendMessage({
                value: {
                    filters: tempFilters
                }
            }));
            setLoadingData(true);
        }, timerForFilterSelectionListMode === undefined ? 1000 : timerForFilterSelectionListMode);
    };
    const value = (0, $bxRTa.useMemo)(()=>({
            content: content,
            filters: filters,
            selectedFilters: selectedFilters,
            loadingData: loadingData,
            color: color,
            setContent: setContent,
            setSelectedFilters: setSelectedFilters,
            resetFilters: resetFilters,
            processFiltersOnChange: processFiltersOnChange,
            setSuggestedFilter: setSuggestedFilter,
            setLoadingData: setLoadingData
        }), [
        content,
        filters,
        selectedFilters,
        loadingData,
        color,
        setContent,
        setSelectedFilters,
        resetFilters,
        processFiltersOnChange,
        setSuggestedFilter,
        setLoadingData
    ]);
    /**
   * On content state change :
   *  - if there is no content, reset all filters and selected filters
   *  - if there is some content, set filters state with the content received or an empty array, and selectedFilters state with received data if there are some
   */ (0, $bxRTa.useEffect)(()=>{
        if (content) {
            if (filters.length === 0 || content.channelData?.filters !== filters) setFilters(content.channelData?.filters || []);
            content.channelData?.selectedFilters && setSelectedFilters(content.channelData?.selectedFilters);
        } else totalReset();
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: /*#__PURE__*/ (0, $fl9nK.jsx)($138ade36c671bdf6$export$52411773e0d6f15d.Provider, {
            value: value,
            children: children
        })
    });
}

});



parcelRegister("8fRqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe9a3203d97d9b4$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $6fe9a3203d97d9b4$var$EmptyAttachment = ()=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-gap-2 rf-rounded",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-relative rf-w-full rf-bg-templateEmptyCard rf-rounded rf-aspect-video"
        })
    });
};
var $6fe9a3203d97d9b4$export$2e2bcd8739ae039 = $6fe9a3203d97d9b4$var$EmptyAttachment;

});

parcelRegister("icqMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $237d7ddb91c1b9e4$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");

var $1cxbd = parcelRequire("1cxbd");
const $237d7ddb91c1b9e4$var$ImageAttachment = ({ url: url, title: title, alt: alt, isMiniature: isMiniature, height: height })=>{
    const displaySubtitles = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.displaySubtitles);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const currentHeight = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentHeight);
    const [maxHeight, setMaxHeight] = (0, $bxRTa.useState)(0);
    (0, $bxRTa.useEffect)(()=>{
        if (currentHeight && currentDeviceType) switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                setMaxHeight(Math.floor(currentHeight * (displaySubtitles ? 0.34 : 0.5)));
                break;
            case (0, $2rYkD.DeviceType).landscape:
                // The container in BotResponse is 7 rows high on the main grid, with a total of 12 rows, so quite 59%.
                // We reduce a little 9% because 100% is whithout browser's interface.
                setMaxHeight(Math.floor(currentHeight * 0.5));
                break;
            case (0, $2rYkD.DeviceType).borne:
                // Same as landscape, but 5 rows high instead of 7
                setMaxHeight(Math.floor(currentHeight * 0.34));
                break;
            default:
                break;
        }
    }, [
        currentHeight,
        currentDeviceType,
        displaySubtitles
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-row rf-items-center rf-justify-center rf-rounded rf-bg-cardFrameBackground",
        style: {
            height: height,
            touchAction: 'pan-y'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1cxbd.default), {
                url: url
            }),
            isMiniature ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-1/4"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                        className: "rf-max-w-1/2",
                        src: url,
                        alt: alt || 'image',
                        style: {
                            maxHeight: `calc(${maxHeight}px - 3rem)`
                        }
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-1/4"
                    })
                ]
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                className: "rf-max-w-full",
                src: url,
                alt: alt || 'image',
                style: {
                    maxHeight: `calc(${maxHeight}px - 3rem)`
                }
            }),
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-absolute rf-bottom-0 rf-py-2 rf-text-center rf-text-sm large:rf-text-base rf-text-cardFrameText rf-bg-cardFrameBackground rf-bg-opacity-80 rf-rounded-b rf-w-full",
                children: title
            })
        ]
    });
};
var $237d7ddb91c1b9e4$export$2e2bcd8739ae039 = $237d7ddb91c1b9e4$var$ImageAttachment;

});
parcelRegister("1cxbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $188e3060064bd9c0$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");
parcelRequire("kMAJU");
var $7bOgw = parcelRequire("7bOgw");
const $188e3060064bd9c0$var$DisplayFullScreenButton = ({ url: url })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const handleClick = ()=>{
        dispatch((0, $cto9a.storeActions).utils.setFullScreenImage(url));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-absolute rf-right-2 rf-top-2 rf-p-2 rf-border rf-rounded-lg rf-bg-cardFrameBackground rf-bg-opacity-30 rf-border-cardButtonBorderDefault hover:rf-cursor-pointer",
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7bOgw.default), {
            className: "rf-h-4 rf-w-4 large:rf-h-6 large:rf-w-6",
            color: themeColors.card.button.text.default
        })
    });
};
var $188e3060064bd9c0$export$2e2bcd8739ae039 = $188e3060064bd9c0$var$DisplayFullScreenButton;

});


parcelRegister("9rMVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $216a7cf8d000b214$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7QU6k = parcelRequire("7QU6k");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $clTWB = parcelRequire("clTWB");

var $eO5xw = parcelRequire("eO5xw");

var $cDMN1 = parcelRequire("cDMN1");

var $cjZIW = parcelRequire("cjZIW");

var $8s4pt = parcelRequire("8s4pt");
parcelRequire("kMAJU");
var $av28T = parcelRequire("av28T");
var $d5ZYc = parcelRequire("d5ZYc");

var $8e5cw = parcelRequire("8e5cw");

const $216a7cf8d000b214$var$PrintingPreview = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("hiuUm")));
const $216a7cf8d000b214$var$LinkAttachment = ({ urlData: urlData, fileName: fileName, qrCode: qrCode, description: description, height: height })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const isUsedOnBorne = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.isUsedOnBorne);
    const enableDocumentPrinting = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.enableDocumentPrinting);
    !fileName && (fileName = (0, $cDMN1.checkFileNameInUrl)(urlData.url));
    const title = urlData.title || fileName;
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)(qrCode);
    const [textToDisplay, setTextToDisplay] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        setTextToDisplay((0, $clTWB.getTextToDisplayOnLink)({
            translation: translation,
            isUsedOnBorne: isUsedOnBorne,
            data: urlData,
            fileName: fileName
        }));
    }, [
        isUsedOnBorne,
        locale,
        urlData
    ]);
    /**
   * On component creation :
   *  - call setQrCodeDataAsync only if used on a borne
   */ (0, $bxRTa.useEffect)(()=>{
        !qrCode && isUsedOnBorne && setQrCodeDataAsync();
    }, []);
    /**
   * On call :
   *  - generate a qrcode as dataURL
   *  - set qrCodeData state with the data
   */ const setQrCodeDataAsync = async ()=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(urlData.url);
        setQrCodeData(qrCodeString);
    };
    const handleClick = ()=>{
        dispatch((0, $cto9a.storeActions).utils.setModalFullscreenContent(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $bxRTa.Suspense), {
            children: /*#__PURE__*/ (0, $fl9nK.jsx)($216a7cf8d000b214$var$PrintingPreview, {
                url: urlData.url,
                printingAllowed: !!enableDocumentPrinting
            })
        })));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-p-[25px] rf-flex rf-flex-col rf-items-center rf-gap-4 ${title || description ? 'rf-justify-between' : 'rf-justify-around'} rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin`,
        style: {
            height: height,
            touchAction: 'pan-y'
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full ${description ? 'rf-text-left' : 'rf-text-center'} rf-title-size-auto ${isUsedOnBorne ? 'rf-truncate' : 'rf-line-clamp-2'}`,
                children: (0, $eO5xw.capitalizeFirstLetter)(title)
            }),
            isUsedOnBorne ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    urlData.url.length > 4 && urlData.url.substring(urlData.url.length - 4) === '.pdf' && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-full rf-pb-10 rf-flex rf-items-center rf-justify-center",
                        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                            className: "rf-px-4 rf-py-1 rf-flex rf-flex-row rf-gap-2 rf-items-center rf-border-2 rf-text-primary rf-border-primary hover:rf-text-truewhite hover:rf-border-truewhite rf-rounded-lg rf-text-sm rf-font-bold",
                            onClick: handleClick,
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)((0, $av28T.default), {
                                    color: themeColors.primary
                                }),
                                translation.link.buttontext
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-center",
                        children: [
                            description && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: description
                            }),
                            qrCodeData && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                                src: qrCodeData
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-relative rf-text-center rf-mx-8 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d5ZYc.default), {
                                className: "rf-absolute rf-top-[0.125rem] -rf-left-6 rf-h-4"
                            }),
                            textToDisplay
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    description && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-mb-4",
                        children: description
                    }),
                    urlData.download && urlData.title && textToDisplay.length >= 40 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8s4pt.default), {
                        url: urlData.url,
                        text: textToDisplay,
                        download: true
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cjZIW.default), {
                        url: urlData.url,
                        text: textToDisplay,
                        description: !!description,
                        download: !!urlData.download
                    })
                ]
            })
        ]
    });
};
var $216a7cf8d000b214$export$2e2bcd8739ae039 = $216a7cf8d000b214$var$LinkAttachment;

});
parcelRegister("clTWB", function(module, exports) {

$parcel$export(module.exports, "getTextToDisplayOnLink", () => $aa22e2043600c016$export$2eb1c1cc4b12d451);
const $aa22e2043600c016$export$2eb1c1cc4b12d451 = ({ translation: translation, isUsedOnBorne: isUsedOnBorne, data: data, fileName: fileName })=>{
    let textToDisplay = '';
    if (isUsedOnBorne) {
        if (data.download) {
            if (data.title) textToDisplay = `${translation.common.download} \u00ab ${fileName} \u00bb`;
            else textToDisplay = translation.common.download;
        } else textToDisplay = translation.link.goto;
        textToDisplay += ` ${translation.link.scanQR}`;
    } else if (data.download) {
        if (data.title) textToDisplay = `${translation.common.download} ${fileName}`;
        else textToDisplay = translation.common.download;
    } else textToDisplay = translation.link.click;
    return textToDisplay;
};

});

parcelRegister("cDMN1", function(module, exports) {

$parcel$export(module.exports, "checkFileNameInUrl", () => $a3f4d9145cbf9524$export$a6f11fce0a840e6c);
const $a3f4d9145cbf9524$export$a6f11fce0a840e6c = (url)=>{
    const [lastPart] = url.split('/').slice(-1);
    if (lastPart && lastPart.length > 4 && lastPart.includes('.')) return lastPart;
    return undefined;
};

});

parcelRegister("cjZIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0099778562612303$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
var $dH58k = parcelRequire("dH58k");
parcelRequire("kMAJU");
var $9oAhU = parcelRequire("9oAhU");
const $0099778562612303$var$ClassicButton = ({ url: url, text: text, description: description, download: download })=>{
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-full rf-flex ${description ? 'rf-justify-start' : 'rf-justify-center'}`,
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "rf-card-button rf-flex rf-items-center",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-h-6 rf-w-6",
                    children: download ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9oAhU.default), {}) : isRTL ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dH58k.default), {})
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `${isRTL ? 'rf-mr-2' : 'rf-ml-2'} rf-truncate`,
                    children: text || ''
                })
            ]
        })
    });
};
var $0099778562612303$export$2e2bcd8739ae039 = $0099778562612303$var$ClassicButton;

});

parcelRegister("8s4pt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbe00e8f533f6539$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
var $dH58k = parcelRequire("dH58k");
parcelRequire("kMAJU");
var $9oAhU = parcelRequire("9oAhU");
const $bbe00e8f533f6539$var$BorderlessButton = ({ url: url, text: text, download: download })=>{
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const [hover, setHover] = (0, $bxRTa.useState)(false);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-flex rf-justify-start",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-start rf-text-cardButtonTextDefault",
            onPointerEnter: ()=>setHover(true),
            onPointerLeave: ()=>setHover(false),
            onClick: ()=>setHover(true),
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `rf-h-6 rf-w-6 rf-rounded ${hover ? 'rf-bg-cardButtonBackgroundHover' : 'rf-bg-cardButtonBackgroundDefault'}`,
                    children: download ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9oAhU.default), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    }) : isRTL ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dH58k.default), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `${isRTL ? 'rf-mr-4' : 'rf-ml-4'}`,
                    children: text || ''
                })
            ]
        })
    });
};
var $bbe00e8f533f6539$export$2e2bcd8739ae039 = $bbe00e8f533f6539$var$BorderlessButton;

});


parcelRegister("ck3iG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4733061cfa3e284c$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $eO5xw = parcelRequire("eO5xw");

var $cDMN1 = parcelRequire("cDMN1");

var $8s4pt = parcelRequire("8s4pt");
const $4733061cfa3e284c$var$MultiLinkAttachment = ({ urlData: urlData, title: title, description: description, height: height })=>{
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-p-[25px] rf-flex rf-flex-col rf-items-center rf-gap-2 ${title || description ? 'rf-justify-between' : 'rf-justify-around'} rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin`,
        style: {
            height: height,
            touchAction: 'pan-y'
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full rf-mb-4 ${description ? 'rf-text-left' : 'rf-text-center'} rf-title-size-auto ${configuration.isUsedOnBorne ? 'rf-truncate' : 'rf-line-clamp-2'}`,
                children: (0, $eO5xw.capitalizeFirstLetter)(title)
            }),
            description && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-mb-4",
                children: description
            }),
            urlData.map((data, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8s4pt.default), {
                    url: data.url,
                    text: data.title || (0, $cDMN1.checkFileNameInUrl)(data.url) || data.url,
                    download: !!data.download
                }, key);
            })
        ]
    });
};
var $4733061cfa3e284c$export$2e2bcd8739ae039 = $4733061cfa3e284c$var$MultiLinkAttachment;

});

parcelRegister("k60RP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4860cbee8d312bd0$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $iEJNQ = parcelRequire("iEJNQ");
const $4860cbee8d312bd0$var$SuggestedActionAttachment = ({ title: title, actions: actions, history: history, height: height })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const unlockClickedButton = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.unlockClickedButton);
    const [clicked, setClicked] = (0, $bxRTa.useState)(null);
    const animationColor = {
        '--rf-color-loader-animation': themeColors.card.button.text.default
    };
    (0, $bxRTa.useEffect)(()=>{
        unlockClickedButton && setClicked(null);
    }, [
        unlockClickedButton
    ]);
    const handleClick = (value, index)=>{
        dispatch((0, $cto9a.storeActions).utils.lockClickedButton());
        setClicked(index);
        dispatch((0, $cto9a.storeActions).directline.sendMessage({
            text: value
        }));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-center rf-rounded rf-bg-cardFrameBackground",
        style: {
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-pb-4 rf-text-center rf-text-cardFrameText rf-subtitle-size-auto",
                children: (0, $eO5xw.capitalizeFirstLetter)(title, locale)
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-pt-4 rf-flex rf-flex-row rf-justify-center rf-items-center rf-gap-4 rf-flex-wrap",
                children: actions.map((action, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        className: clicked === key ? 'rf-card-button-clicked' : 'rf-card-button',
                        onClick: history ? ()=>{} : ()=>handleClick(action.action, key),
                        children: clicked === key ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-w-full rf-h-[1.25rem] large:rf-h-[1.3rem] rf-flex rf-justify-center rf-items-center",
                            style: {
                                ...animationColor
                            },
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-w-2 rf-h-2 large:rf-w-4 large:rf-h-4",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                                    size: isMobile ? (0, $2rYkD.AnimationSize).small : (0, $2rYkD.AnimationSize).medium
                                })
                            })
                        }) : action.title || '?'
                    }, key);
                })
            })
        ]
    });
};
var $4860cbee8d312bd0$export$2e2bcd8739ae039 = $4860cbee8d312bd0$var$SuggestedActionAttachment;

});
parcelRegister("iEJNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42d00caebba42feb$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
const $42d00caebba42feb$var$Animation = ({ size: size })=>{
    const customClassName = (0, $bxRTa.useMemo)(()=>{
        switch(size){
            case (0, $2rYkD.AnimationSize).small:
                return 'rf-loader-mini rf-animate-loaderMini rf-h-2 -rf-top-2';
            case (0, $2rYkD.AnimationSize).medium:
                return 'rf-loader-medium rf-animate-loaderMedium rf-h-4 -rf-top-4';
            case (0, $2rYkD.AnimationSize).large:
            default:
                return 'rf-loader rf-animate-loader rf-h-6 -rf-top-6';
        }
    }, [
        size
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-relative ${customClassName} rf-rounded-half`
    });
};
var $42d00caebba42feb$export$2e2bcd8739ae039 = $42d00caebba42feb$var$Animation;

});


parcelRegister("cZz3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $c68744aac590de15$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $5JKxf = parcelRequire("5JKxf");

var $iEJNQ = parcelRequire("iEJNQ");
const $c68744aac590de15$var$DiscoverAttachment = ({ title: title, mainButtons: mainButtons, recommandationButton: recommandationButton, history: history, height: height })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const unlockClickedButton = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.unlockClickedButton);
    const displayLayout = (0, $bxRTa.useMemo)(()=>{
        if (mainButtons && mainButtons.length > 1) return `rf-w-full rf-grid rf-grid-cols-${mainButtons.length} rf-gap-2 large:rf-gap-4`;
        return 'rf-w-1/2 rf-justify-self-center';
    }, [
        mainButtons
    ]);
    const [clicked, setClicked] = (0, $bxRTa.useState)(false);
    const [discoverClicked, setDiscoverClicked] = (0, $bxRTa.useState)(null);
    const animationColor = {
        '--rf-color-loader-animation': themeColors.card.button.text.default
    };
    const handleClick = (data, index)=>{
        if (discoverClicked === null || discoverClicked !== index) {
            dispatch((0, $cto9a.storeActions).utils.lockClickedButton());
            let dataToSend = {};
            // @ts-ignore
            if (data.eventName) {
                const tempData = data;
                setClicked(true);
                dataToSend = {
                    type: 'event',
                    name: tempData.eventName,
                    recommendationId: tempData.recommendationId
                };
            } else if (index !== undefined) {
                setDiscoverClicked(index);
                const tempData = data;
                dataToSend = {
                    type: 'event',
                    name: tempData.EventName,
                    value: {
                        filterId: tempData.FilterId,
                        filterValue: tempData.FilterValue,
                        followingCardText: tempData.FollowingCardText,
                        identifier: tempData.Identifier
                    }
                };
            }
            dispatch((0, $cto9a.storeActions).directline.sendMessage({
                value: dataToSend
            }));
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        if (unlockClickedButton) {
            setClicked(false);
            setDiscoverClicked(null);
        }
    }, [
        unlockClickedButton
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-bg-cardFrameBackground large:rf-p-[25px] rf-p-4 ${history && 'rf-pointer-events-none'} `,
        style: {
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-title-size-auto rf-mb-3 rf-text-center",
                children: (0, $eO5xw.capitalizeFirstLetter)(title, locale)
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-h-full ${displayLayout}`,
                children: mainButtons && mainButtons.length > 0 ? mainButtons.map((button, i)=>{
                    let colorButtonHandle = '';
                    if (button.EventName.indexOf('TouristAttractions') > -1) colorButtonHandle = themeColors.tobeDoneColor;
                    else if (button.EventName.indexOf('Products') > -1) colorButtonHandle = themeColors.localProductsColor;
                    else if (button.EventName.indexOf('FoodEstablishments') > -1) colorButtonHandle = themeColors.whereToEatColor;
                    else if (button.EventName.indexOf('LodgingBusinesses') > -1) colorButtonHandle = themeColors.whereToSleepColor;
                    else if (button.EventName.indexOf('TouristDestinations') > -1) colorButtonHandle = themeColors.tobeSeenColor;
                    else if (button.EventName.indexOf('Event') > -1) colorButtonHandle = themeColors.agendaColor;
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-relative rf-w-full rf-card-button-discover rf-rounded rf-flex rf-flex-col rf-gap-2 large:rf-gap-3 rf-items-center rf-justify-self-center",
                        onClick: ()=>handleClick(button, i),
                        style: {
                            boxShadow: '0px 0px 13px #0000009c'
                        },
                        children: discoverClicked === i ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center",
                            style: {
                                ...animationColor
                            },
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                                    size: isMobile ? (0, $2rYkD.AnimationSize).medium : (0, $2rYkD.AnimationSize).large
                                })
                            })
                        }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                            children: [
                                button.MediaUrl.indexOf('svg') > -1 && colorButtonHandle !== '' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5JKxf.default), {
                                    svgUrl: button.MediaUrl,
                                    height: "50px",
                                    fillColor: colorButtonHandle
                                }) : /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                                    src: button.MediaUrl,
                                    alt: button.Text,
                                    style: {
                                        height: '50px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                    className: "rf-flex rf-items-center rf-text-center rf-uppercase rf-font-bold large:rf-text-basecustom rf-text-xsl rf-overflow-wrap",
                                    children: button.Text
                                })
                            ]
                        })
                    }, i);
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fl9nK.Fragment), {})
            }),
            recommandationButton && mainButtons && mainButtons.length > 1 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-mt-4 rf-font-bold ${clicked ? 'rf-card-button-clicked' : 'rf-card-button'} rf-text-center`,
                onClick: ()=>handleClick(recommandationButton),
                children: clicked ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-w-full rf-h-[1.25rem] large:rf-h-[1.3rem] rf-flex rf-justify-center rf-items-center",
                    style: {
                        ...animationColor
                    },
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                            size: isMobile ? (0, $2rYkD.AnimationSize).medium : (0, $2rYkD.AnimationSize).large
                        })
                    })
                }) : (0, $eO5xw.capitalizeFirstLetter)(recommandationButton.text, locale)
            })
        ]
    });
};
var $c68744aac590de15$export$2e2bcd8739ae039 = $c68744aac590de15$var$DiscoverAttachment;

});
parcelRegister("5JKxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $298f7d80b3eebe3e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $aBDai = parcelRequire("aBDai");

var $lOuaH = parcelRequire("lOuaH");
const $298f7d80b3eebe3e$var$SvgColorChanger = ({ svgUrl: svgUrl, fillColor: fillColor, height: height })=>{
    const [filter, setFilter] = (0, $bxRTa.useState)();
    const [hex, setHex] = (0, $bxRTa.useState)();
    const [ratio, setRatio] = (0, $bxRTa.useState)(1);
    const divRef = (0, $bxRTa.useRef)(null);
    const svgRef = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(divRef);
    const rgbToCssFilter = (r, g, b)=>{
        const hex = `${(r & 0xff).toString(16).padStart(2, '0')}${(g & 0xff).toString(16).padStart(2, '0')}${(b & 0xff).toString(16).padStart(2, '0')}`;
        setHex(hex);
        return /*#__PURE__*/ (0, $fl9nK.jsx)("filter", {
            id: hex,
            colorInterpolationFilters: "sRGB",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("feColorMatrix", {
                type: "matrix",
                values: `0 0 0 0 ${r / 255.0} 0 0 0 0 ${g / 255.0} 0 0 0 0 ${b / 255.0} 0 0 0 1 0`
            })
        });
    };
    (0, $bxRTa.useEffect)(()=>{
        if (fillColor) {
            const rgbColor = (0, $aBDai.hexToRgb)(fillColor);
            setFilter(rgbToCssFilter(rgbColor.r, rgbColor.g, rgbColor.b));
        }
    }, [
        fillColor
    ]);
    const handleLoaded = ()=>{
        if (svgRef.current) {
            const box = svgRef.current.getBBox();
            setRatio(box.width / box.height);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        ref: divRef,
        className: "rf-h-full",
        style: {
            width: dimensions.height * ratio
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
            ref: svgRef,
            className: "rf-filter rf-w-full",
            height: height || '100%',
            children: [
                filter && /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                    children: filter
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("image", {
                    filter: filter ? `url(#${hex})` : undefined,
                    onLoad: handleLoaded,
                    href: svgUrl,
                    x: "0",
                    y: "0",
                    height: height || dimensions.height
                })
            ]
        })
    });
};
var $298f7d80b3eebe3e$export$2e2bcd8739ae039 = $298f7d80b3eebe3e$var$SvgColorChanger;

});


parcelRegister("3B8pL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bbe0760b36a26aa$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("6hiCI");
var $28u6w = parcelRequire("28u6w");

var $5FZWK = parcelRequire("5FZWK");

var $eO5xw = parcelRequire("eO5xw");

var $BwWrg = parcelRequire("BwWrg");
parcelRequire("kMAJU");
var $d5ZYc = parcelRequire("d5ZYc");
const $7bbe0760b36a26aa$var$md = new (0, $28u6w.default)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    linkify: false,
    typographer: true,
    quotes: `""''`
});
const $7bbe0760b36a26aa$var$SuggestionAttachment = ({ suggestions: suggestions, title: title, description: description, height: height, history: history, showTutorial: showTutorial })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const processedDescription = (()=>{
        try {
            return $7bbe0760b36a26aa$var$md.render(description || '');
        } catch (e) {
            return description || '';
        }
    })();
    const onTutorialClick = ()=>{
        // TODO
        console.log('show tutorial');
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full large:rf-p-[25px] rf-p-4 rf-flex rf-flex-col rf-items-center rf-gap-2 ${title || description ? 'rf-justify-between' : 'rf-justify-around'} rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin ${history && 'rf-pointer-events-none'} `,
        style: {
            height: height,
            touchAction: 'pan-y'
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full ${description ? '' : 'rf-text-bannerlorcenter'} rf-title-size-auto ${configuration.isUsedOnBorne ? 'rf-truncate' : 'rf-line-clamp-2'}`,
                children: (0, $eO5xw.capitalizeFirstLetter)(title)
            }),
            description && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full",
                dangerouslySetInnerHTML: {
                    __html: (0, $eO5xw.capitalizeFirstLetter)(processedDescription)
                }
            }),
            suggestions?.map((data, key)=>{
                const text = typeof data === 'string' ? data : data.text;
                const differentTextTosend = typeof data === 'string' ? undefined : data.differentTextToSend || data.text;
                return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $BwWrg.default), {
                        text: text,
                        differentTextTosend: differentTextTosend
                    })
                }, key);
            }),
            showTutorial && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-flex rf-items-end rf-italic",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d5ZYc.default), {
                        className: `${isRTL ? 'rf-pl-2' : 'rf-pr-2'} rf-h-6`,
                        color: themeColors.card.button.text.default
                    }),
                    `${translation.common.needhelp} ${translation.suggestion.consult}`,
                    /*#__PURE__*/ (0, $fl9nK.jsx)("span", {
                        className: `${isRTL ? 'rf-pr-1' : 'rf-pl-1'} rf-underline rf-cursor-pointer`,
                        onClick: onTutorialClick,
                        children: translation.suggestion.thetutorial
                    })
                ]
            })
        ]
    });
};
var $7bbe0760b36a26aa$export$2e2bcd8739ae039 = $7bbe0760b36a26aa$var$SuggestionAttachment;

});
parcelRegister("6hiCI", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("28u6w")).default);

var $28u6w = parcelRequire("28u6w");

});
parcelRegister("28u6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f7f8a9103718fb$export$2e2bcd8739ae039);
// Main parser class

var $9Wt9S = parcelRequire("9Wt9S");

var $lOMx4 = parcelRequire("lOMx4");

var $8Dgzl = parcelRequire("8Dgzl");

var $0O45r = parcelRequire("0O45r");

var $cqhCq = parcelRequire("cqhCq");

var $2vOE9 = parcelRequire("2vOE9");

var $eGX2O = parcelRequire("eGX2O");
parcelRequire("kpV4t");
var $2SsKF = parcelRequire("2SsKF");
var $1SHpU = parcelRequire("1SHpU");
var $5CQ13 = parcelRequire("5CQ13");
var $6b7BW = parcelRequire("6b7BW");

var $ib0wl = parcelRequire("ib0wl");

var $5ZRUt = parcelRequire("5ZRUt");

var $gVArB = parcelRequire("gVArB");

var $r2Oyp = parcelRequire("r2Oyp");
const $93f7f8a9103718fb$var$config = {
    default: (0, $5ZRUt.default),
    zero: (0, $gVArB.default),
    commonmark: (0, $r2Oyp.default)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const $93f7f8a9103718fb$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const $93f7f8a9103718fb$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $93f7f8a9103718fb$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return $93f7f8a9103718fb$var$BAD_PROTO_RE.test(str) ? $93f7f8a9103718fb$var$GOOD_DATA_RE.test(str) : true;
}
const $93f7f8a9103718fb$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $93f7f8a9103718fb$var$normalizeLink(url) {
    const parsed = $6b7BW.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $93f7f8a9103718fb$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $ib0wl.default).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $1SHpU.default($5CQ13.default(parsed));
}
function $93f7f8a9103718fb$var$normalizeLinkText(url) {
    const parsed = $6b7BW.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $93f7f8a9103718fb$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $ib0wl.default).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $2SsKF.default($5CQ13.default(parsed), $2SsKF.default.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.mjs) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.mjs) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.mjs) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.mjs) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $93f7f8a9103718fb$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $93f7f8a9103718fb$var$MarkdownIt)) return new $93f7f8a9103718fb$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$9Wt9S.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, $2vOE9.default)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, $cqhCq.default)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, $0O45r.default)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs).
   **/ this.renderer = new (0, $8Dgzl.default)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.mjs)
   * rule.
   **/ this.linkify = new (0, $eGX2O.default)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $93f7f8a9103718fb$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $93f7f8a9103718fb$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $93f7f8a9103718fb$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = $9Wt9S;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $9Wt9S.assign({}, $lOMx4);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.set = function(options) {
    $9Wt9S.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if ($9Wt9S.isString(presets)) {
        const presetName = presets;
        presets = $93f7f8a9103718fb$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
var $93f7f8a9103718fb$export$2e2bcd8739ae039 = $93f7f8a9103718fb$var$MarkdownIt;

});
parcelRegister("9Wt9S", function(module, exports) {

$parcel$export(module.exports, "isString", () => $0c2ec6ccb12eeab2$export$844ec244b1367d54);
$parcel$export(module.exports, "has", () => $0c2ec6ccb12eeab2$export$a4f4bb6b1453fff5);
$parcel$export(module.exports, "assign", () => $0c2ec6ccb12eeab2$export$e6e34fd1f2686227);
$parcel$export(module.exports, "arrayReplaceAt", () => $0c2ec6ccb12eeab2$export$f78478f71955b6bc);
$parcel$export(module.exports, "isValidEntityCode", () => $0c2ec6ccb12eeab2$export$644a8f5b13b2a36d);
$parcel$export(module.exports, "fromCodePoint", () => $0c2ec6ccb12eeab2$export$73bfc63873071f74);
$parcel$export(module.exports, "unescapeMd", () => $0c2ec6ccb12eeab2$export$5ccde1ea0c14bb03);
$parcel$export(module.exports, "unescapeAll", () => $0c2ec6ccb12eeab2$export$db8a17c6655f7e2c);
$parcel$export(module.exports, "escapeHtml", () => $0c2ec6ccb12eeab2$export$4cf11838cdc2a8a8);
$parcel$export(module.exports, "escapeRE", () => $0c2ec6ccb12eeab2$export$bc616c8f7dc20d5d);
$parcel$export(module.exports, "isSpace", () => $0c2ec6ccb12eeab2$export$1d5ccafae59b4926);
$parcel$export(module.exports, "isWhiteSpace", () => $0c2ec6ccb12eeab2$export$3c52dd84024ae72c);
$parcel$export(module.exports, "isPunctChar", () => $0c2ec6ccb12eeab2$export$4888a643af800fc1);
$parcel$export(module.exports, "isMdAsciiPunct", () => $0c2ec6ccb12eeab2$export$829a0d33ae4e744);
$parcel$export(module.exports, "normalizeReference", () => $0c2ec6ccb12eeab2$export$20ef46802c8744b);
$parcel$export(module.exports, "lib", () => $0c2ec6ccb12eeab2$export$16c08b91f883959a);
// Utilities
//

var $kpV4t = parcelRequire("kpV4t");
parcelRequire("ih6Pl");
var $6qXSM = parcelRequire("6qXSM");
var $7pSxY = parcelRequire("7pSxY");
var $ih6Pl = parcelRequire("ih6Pl");
parcelRequire("4MNLB");
var $8qSbS = parcelRequire("8qSbS");
function $0c2ec6ccb12eeab2$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $0c2ec6ccb12eeab2$export$844ec244b1367d54(obj) {
    return $0c2ec6ccb12eeab2$var$_class(obj) === '[object String]';
}
const $0c2ec6ccb12eeab2$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $0c2ec6ccb12eeab2$export$a4f4bb6b1453fff5(object, key) {
    return $0c2ec6ccb12eeab2$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $0c2ec6ccb12eeab2$export$e6e34fd1f2686227(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $0c2ec6ccb12eeab2$export$f78478f71955b6bc(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function $0c2ec6ccb12eeab2$export$644a8f5b13b2a36d(c) {
    /* eslint no-bitwise:0 */ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $0c2ec6ccb12eeab2$export$73bfc63873071f74(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const $0c2ec6ccb12eeab2$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const $0c2ec6ccb12eeab2$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const $0c2ec6ccb12eeab2$var$UNESCAPE_ALL_RE = new RegExp($0c2ec6ccb12eeab2$var$UNESCAPE_MD_RE.source + '|' + $0c2ec6ccb12eeab2$var$ENTITY_RE.source, 'gi');
const $0c2ec6ccb12eeab2$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $0c2ec6ccb12eeab2$var$replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && $0c2ec6ccb12eeab2$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($0c2ec6ccb12eeab2$export$644a8f5b13b2a36d(code)) return $0c2ec6ccb12eeab2$export$73bfc63873071f74(code);
        return match;
    }
    const decoded = (0, $8qSbS.decodeHTML)(match);
    if (decoded !== match) return decoded;
    return match;
}
/* function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
} */ function $0c2ec6ccb12eeab2$export$5ccde1ea0c14bb03(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($0c2ec6ccb12eeab2$var$UNESCAPE_MD_RE, '$1');
}
function $0c2ec6ccb12eeab2$export$db8a17c6655f7e2c(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($0c2ec6ccb12eeab2$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $0c2ec6ccb12eeab2$var$replaceEntityPattern(match, entity);
    });
}
const $0c2ec6ccb12eeab2$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
const $0c2ec6ccb12eeab2$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const $0c2ec6ccb12eeab2$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $0c2ec6ccb12eeab2$var$replaceUnsafeChar(ch) {
    return $0c2ec6ccb12eeab2$var$HTML_REPLACEMENTS[ch];
}
function $0c2ec6ccb12eeab2$export$4cf11838cdc2a8a8(str) {
    if ($0c2ec6ccb12eeab2$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($0c2ec6ccb12eeab2$var$HTML_ESCAPE_REPLACE_RE, $0c2ec6ccb12eeab2$var$replaceUnsafeChar);
    return str;
}
const $0c2ec6ccb12eeab2$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $0c2ec6ccb12eeab2$export$bc616c8f7dc20d5d(str) {
    return str.replace($0c2ec6ccb12eeab2$var$REGEXP_ESCAPE_RE, '\\$&');
}
function $0c2ec6ccb12eeab2$export$1d5ccafae59b4926(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $0c2ec6ccb12eeab2$export$3c52dd84024ae72c(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
/* eslint-disable max-len */ // Currently without astral characters support.
function $0c2ec6ccb12eeab2$export$4888a643af800fc1(ch) {
    return $6qXSM.default.test(ch) || $7pSxY.default.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $0c2ec6ccb12eeab2$export$829a0d33ae4e744(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $0c2ec6ccb12eeab2$export$20ef46802c8744b(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const $0c2ec6ccb12eeab2$export$16c08b91f883959a = {
    mdurl: $kpV4t,
    ucmicro: $ih6Pl
};

});
parcelRegister("kpV4t", function(module, exports) {

$parcel$export(module.exports, "decode", () => (parcelRequire("2SsKF")).default);
$parcel$export(module.exports, "encode", () => (parcelRequire("1SHpU")).default);
$parcel$export(module.exports, "format", () => (parcelRequire("5CQ13")).default);
$parcel$export(module.exports, "parse", () => (parcelRequire("6b7BW")).default);

var $2SsKF = parcelRequire("2SsKF");

var $1SHpU = parcelRequire("1SHpU");

var $5CQ13 = parcelRequire("5CQ13");

var $6b7BW = parcelRequire("6b7BW");

});
parcelRegister("2SsKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9646d4e0a8dbef12$export$2e2bcd8739ae039);
/* eslint-disable no-bitwise */ const $9646d4e0a8dbef12$var$decodeCache = {};
function $9646d4e0a8dbef12$var$getDecodeCache(exclude) {
    let cache = $9646d4e0a8dbef12$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $9646d4e0a8dbef12$var$decodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(let i = 0; i < exclude.length; i++){
        const ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $9646d4e0a8dbef12$var$decode(string, exclude) {
    if (typeof exclude !== 'string') exclude = $9646d4e0a8dbef12$var$decode.defaultChars;
    const cache = $9646d4e0a8dbef12$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        let result = '';
        for(let i = 0, l = seq.length; i < l; i += 3){
            const b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    const chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    const chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                const b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    let chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$9646d4e0a8dbef12$var$decode.defaultChars = ';/?:@&=+$,#';
$9646d4e0a8dbef12$var$decode.componentChars = '';
var $9646d4e0a8dbef12$export$2e2bcd8739ae039 = $9646d4e0a8dbef12$var$decode;

});

parcelRegister("1SHpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb4b816fd68806d6$export$2e2bcd8739ae039);
const $cb4b816fd68806d6$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $cb4b816fd68806d6$var$getEncodeCache(exclude) {
    let cache = $cb4b816fd68806d6$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $cb4b816fd68806d6$var$encodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(let i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $cb4b816fd68806d6$var$encode(string, exclude, keepEscaped) {
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $cb4b816fd68806d6$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    const cache = $cb4b816fd68806d6$var$getEncodeCache(exclude);
    let result = '';
    for(let i = 0, l = string.length; i < l; i++){
        const code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                const nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$cb4b816fd68806d6$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$cb4b816fd68806d6$var$encode.componentChars = "-_.!~*'()";
var $cb4b816fd68806d6$export$2e2bcd8739ae039 = $cb4b816fd68806d6$var$encode;

});

parcelRegister("5CQ13", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc987d1a18604e3c$export$2e2bcd8739ae039);
function $fc987d1a18604e3c$export$2e2bcd8739ae039(url) {
    let result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
}

});

parcelRegister("6b7BW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d4e42cd7834d6f9$export$2e2bcd8739ae039);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $0d4e42cd7834d6f9$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
const $0d4e42cd7834d6f9$var$protocolPattern = /^([a-z0-9.+-]+:)/i;
const $0d4e42cd7834d6f9$var$portPattern = /:[0-9]*$/;
// Special case for a simple path URL
/* eslint-disable-next-line no-useless-escape */ const $0d4e42cd7834d6f9$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
const $0d4e42cd7834d6f9$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
];
// RFC 2396: characters not allowed for various reasons.
const $0d4e42cd7834d6f9$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($0d4e42cd7834d6f9$var$delims);
// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
const $0d4e42cd7834d6f9$var$autoEscape = [
    '\''
].concat($0d4e42cd7834d6f9$var$unwise);
// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
const $0d4e42cd7834d6f9$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($0d4e42cd7834d6f9$var$autoEscape);
const $0d4e42cd7834d6f9$var$hostEndingChars = [
    '/',
    '?',
    '#'
];
const $0d4e42cd7834d6f9$var$hostnameMaxLen = 255;
const $0d4e42cd7834d6f9$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
const $0d4e42cd7834d6f9$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
// protocols that can allow "unsafe" and "unwise" chars.
// protocols that never have a hostname.
const $0d4e42cd7834d6f9$var$hostlessProtocol = {
    javascript: true,
    'javascript:': true
};
// protocols that always contain a // bit.
const $0d4e42cd7834d6f9$var$slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
function $0d4e42cd7834d6f9$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $0d4e42cd7834d6f9$var$Url) return url;
    const u = new $0d4e42cd7834d6f9$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$0d4e42cd7834d6f9$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    let lowerProto, hec, slashes;
    let rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        const simplePath = $0d4e42cd7834d6f9$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    let proto = $0d4e42cd7834d6f9$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    /* eslint-disable-next-line no-useless-escape */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $0d4e42cd7834d6f9$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$0d4e42cd7834d6f9$var$hostlessProtocol[proto] && (slashes || proto && !$0d4e42cd7834d6f9$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        let hostEnd = -1;
        for(let i = 0; i < $0d4e42cd7834d6f9$var$hostEndingChars.length; i++){
            hec = rest.indexOf($0d4e42cd7834d6f9$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        let auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(let i = 0; i < $0d4e42cd7834d6f9$var$nonHostChars.length; i++){
            hec = rest.indexOf($0d4e42cd7834d6f9$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        const host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        const ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            const hostparts = this.hostname.split(/\./);
            for(let i = 0, l = hostparts.length; i < l; i++){
                const part = hostparts[i];
                if (!part) continue;
                if (!part.match($0d4e42cd7834d6f9$var$hostnamePartPattern)) {
                    let newpart = '';
                    for(let j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($0d4e42cd7834d6f9$var$hostnamePartPattern)) {
                        const validParts = hostparts.slice(0, i);
                        const notHost = hostparts.slice(i + 1);
                        const bit = part.match($0d4e42cd7834d6f9$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $0d4e42cd7834d6f9$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    const hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    const qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($0d4e42cd7834d6f9$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$0d4e42cd7834d6f9$var$Url.prototype.parseHost = function(host) {
    let port = $0d4e42cd7834d6f9$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
var $0d4e42cd7834d6f9$export$2e2bcd8739ae039 = $0d4e42cd7834d6f9$var$urlParse;

});


parcelRegister("ih6Pl", function(module, exports) {

$parcel$export(module.exports, "Any", () => (parcelRequire("6JWQo")).default);
$parcel$export(module.exports, "Cc", () => (parcelRequire("bzTP8")).default);
$parcel$export(module.exports, "Cf", () => (parcelRequire("8dK82")).default);
$parcel$export(module.exports, "P", () => (parcelRequire("6qXSM")).default);
$parcel$export(module.exports, "S", () => (parcelRequire("7pSxY")).default);
$parcel$export(module.exports, "Z", () => (parcelRequire("cINVi")).default);

var $6JWQo = parcelRequire("6JWQo");

var $bzTP8 = parcelRequire("bzTP8");

var $8dK82 = parcelRequire("8dK82");

var $6qXSM = parcelRequire("6qXSM");

var $7pSxY = parcelRequire("7pSxY");

var $cINVi = parcelRequire("cINVi");

});
parcelRegister("6JWQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $450f3f30b58a9426$export$2e2bcd8739ae039);
var $450f3f30b58a9426$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("bzTP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b77a0050499e3542$export$2e2bcd8739ae039);
var $b77a0050499e3542$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("8dK82", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6aa885bdc05f64e$export$2e2bcd8739ae039);
var $f6aa885bdc05f64e$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("6qXSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d86f17c959fe4fb8$export$2e2bcd8739ae039);
var $d86f17c959fe4fb8$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("7pSxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee37b9c1f125617d$export$2e2bcd8739ae039);
var $ee37b9c1f125617d$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("cINVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b068cce94db5a90f$export$2e2bcd8739ae039);
var $b068cce94db5a90f$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});


parcelRegister("4MNLB", function(module, exports) {

$parcel$export(module.exports, "decodeHTML", () => (parcelRequire("8qSbS")).decodeHTML);

var $8qSbS = parcelRequire("8qSbS");

var $hAVKH = parcelRequire("hAVKH");

var $jJd9f = parcelRequire("jJd9f");
var $37c23fc1c6faf5f4$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($37c23fc1c6faf5f4$export$b8c86583d9718b50 || ($37c23fc1c6faf5f4$export$b8c86583d9718b50 = {}));
var $37c23fc1c6faf5f4$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($37c23fc1c6faf5f4$export$1851b20d614eb756 || ($37c23fc1c6faf5f4$export$1851b20d614eb756 = {}));
function $37c23fc1c6faf5f4$export$2f872c0f2117be69(data, options = $37c23fc1c6faf5f4$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $37c23fc1c6faf5f4$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $8qSbS.decodeHTML)(data, mode);
    }
    return (0, $8qSbS.decodeXML)(data);
}
function $37c23fc1c6faf5f4$export$c94669f4c7d36be4(data, options = $37c23fc1c6faf5f4$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $8qSbS.DecodingMode).Strict;
    return $37c23fc1c6faf5f4$export$2f872c0f2117be69(data, opts);
}
function $37c23fc1c6faf5f4$export$c564cdbbe6da493(data, options = $37c23fc1c6faf5f4$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $37c23fc1c6faf5f4$export$1851b20d614eb756.UTF8) return (0, $jJd9f.escapeUTF8)(data);
    if (opts.mode === $37c23fc1c6faf5f4$export$1851b20d614eb756.Attribute) return (0, $jJd9f.escapeAttribute)(data);
    if (opts.mode === $37c23fc1c6faf5f4$export$1851b20d614eb756.Text) return (0, $jJd9f.escapeText)(data);
    if (opts.level === $37c23fc1c6faf5f4$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $37c23fc1c6faf5f4$export$1851b20d614eb756.ASCII) return (0, $hAVKH.encodeNonAsciiHTML)(data);
        return (0, $hAVKH.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $jJd9f.encodeXML)(data);
}

});
parcelRegister("8qSbS", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", () => $623ac987b90f204a$export$8c8f129ce60f53c);
$parcel$export(module.exports, "decodeHTML", () => $623ac987b90f204a$export$f045cb747ce77a19);
$parcel$export(module.exports, "decodeXML", () => $623ac987b90f204a$export$88e3b9643a8bd06e);

var $gHlnI = parcelRequire("gHlnI");

var $13OtZ = parcelRequire("13OtZ");

var $lI69q = parcelRequire("lI69q");
var $623ac987b90f204a$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($623ac987b90f204a$var$CharCodes || ($623ac987b90f204a$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $623ac987b90f204a$var$TO_LOWER_BIT = 32;
var $623ac987b90f204a$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($623ac987b90f204a$export$6a4325c613e0faec || ($623ac987b90f204a$export$6a4325c613e0faec = {}));
function $623ac987b90f204a$var$isNumber(code) {
    return code >= $623ac987b90f204a$var$CharCodes.ZERO && code <= $623ac987b90f204a$var$CharCodes.NINE;
}
function $623ac987b90f204a$var$isHexadecimalCharacter(code) {
    return code >= $623ac987b90f204a$var$CharCodes.UPPER_A && code <= $623ac987b90f204a$var$CharCodes.UPPER_F || code >= $623ac987b90f204a$var$CharCodes.LOWER_A && code <= $623ac987b90f204a$var$CharCodes.LOWER_F;
}
function $623ac987b90f204a$var$isAsciiAlphaNumeric(code) {
    return code >= $623ac987b90f204a$var$CharCodes.UPPER_A && code <= $623ac987b90f204a$var$CharCodes.UPPER_Z || code >= $623ac987b90f204a$var$CharCodes.LOWER_A && code <= $623ac987b90f204a$var$CharCodes.LOWER_Z || $623ac987b90f204a$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $623ac987b90f204a$var$isEntityInAttributeInvalidEnd(code) {
    return code === $623ac987b90f204a$var$CharCodes.EQUALS || $623ac987b90f204a$var$isAsciiAlphaNumeric(code);
}
var $623ac987b90f204a$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($623ac987b90f204a$var$EntityDecoderState || ($623ac987b90f204a$var$EntityDecoderState = {}));
var $623ac987b90f204a$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($623ac987b90f204a$export$8c8f129ce60f53c || ($623ac987b90f204a$export$8c8f129ce60f53c = {}));
class $623ac987b90f204a$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $623ac987b90f204a$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $623ac987b90f204a$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $623ac987b90f204a$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $623ac987b90f204a$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $623ac987b90f204a$var$CharCodes.NUM) {
                    this.state = $623ac987b90f204a$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $623ac987b90f204a$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $623ac987b90f204a$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $623ac987b90f204a$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $623ac987b90f204a$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $623ac987b90f204a$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $623ac987b90f204a$var$TO_LOWER_BIT) === $623ac987b90f204a$var$CharCodes.LOWER_X) {
            this.state = $623ac987b90f204a$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $623ac987b90f204a$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($623ac987b90f204a$var$isNumber(char) || $623ac987b90f204a$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($623ac987b90f204a$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $623ac987b90f204a$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $623ac987b90f204a$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $lI69q.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $623ac987b90f204a$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $623ac987b90f204a$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $623ac987b90f204a$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $623ac987b90f204a$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $623ac987b90f204a$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $623ac987b90f204a$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $623ac987b90f204a$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $623ac987b90f204a$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $623ac987b90f204a$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$623ac987b90f204a$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $623ac987b90f204a$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $623ac987b90f204a$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $623ac987b90f204a$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $623ac987b90f204a$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $623ac987b90f204a$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $623ac987b90f204a$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $623ac987b90f204a$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $623ac987b90f204a$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $lI69q.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $623ac987b90f204a$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $623ac987b90f204a$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $623ac987b90f204a$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $623ac987b90f204a$var$htmlDecoder = $623ac987b90f204a$var$getDecoder((0, $gHlnI.default));
const $623ac987b90f204a$var$xmlDecoder = $623ac987b90f204a$var$getDecoder((0, $13OtZ.default));
function $623ac987b90f204a$export$f045cb747ce77a19(str, mode = $623ac987b90f204a$export$8c8f129ce60f53c.Legacy) {
    return $623ac987b90f204a$var$htmlDecoder(str, mode);
}
function $623ac987b90f204a$export$49f5e8089adb006a(str) {
    return $623ac987b90f204a$var$htmlDecoder(str, $623ac987b90f204a$export$8c8f129ce60f53c.Attribute);
}
function $623ac987b90f204a$export$da52f4371b3f37de(str) {
    return $623ac987b90f204a$var$htmlDecoder(str, $623ac987b90f204a$export$8c8f129ce60f53c.Strict);
}
function $623ac987b90f204a$export$88e3b9643a8bd06e(str) {
    return $623ac987b90f204a$var$xmlDecoder(str, $623ac987b90f204a$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("gHlnI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2813f70f6891dc7$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $c2813f70f6891dc7$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("13OtZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5d3b13ad8a5e4d$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $0c5d3b13ad8a5e4d$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("lI69q", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", () => $fce27a7ff8e67907$export$73bfc63873071f74);
$parcel$export(module.exports, "replaceCodePoint", () => $fce27a7ff8e67907$export$b978ab756102108a);
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $fce27a7ff8e67907$var$_a;
const $fce27a7ff8e67907$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $fce27a7ff8e67907$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($fce27a7ff8e67907$var$_a = String.fromCodePoint) !== null && $fce27a7ff8e67907$var$_a !== void 0 ? $fce27a7ff8e67907$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $fce27a7ff8e67907$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $fce27a7ff8e67907$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $fce27a7ff8e67907$export$2e2bcd8739ae039(codePoint) {
    return $fce27a7ff8e67907$export$73bfc63873071f74($fce27a7ff8e67907$export$b978ab756102108a(codePoint));
}

});


parcelRegister("hAVKH", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", () => $ccf298d8b2959b47$export$f9d6449b9af28dc1);
$parcel$export(module.exports, "encodeNonAsciiHTML", () => $ccf298d8b2959b47$export$e6e86c76506f1190);

var $yiozl = parcelRequire("yiozl");

var $jJd9f = parcelRequire("jJd9f");
const $ccf298d8b2959b47$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $ccf298d8b2959b47$export$f9d6449b9af28dc1(data) {
    return $ccf298d8b2959b47$var$encodeHTMLTrieRe($ccf298d8b2959b47$var$htmlReplacer, data);
}
function $ccf298d8b2959b47$export$e6e86c76506f1190(data) {
    return $ccf298d8b2959b47$var$encodeHTMLTrieRe((0, $jJd9f.xmlReplacer), data);
}
function $ccf298d8b2959b47$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $yiozl.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $jJd9f.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("yiozl", function(module, exports) {

$parcel$export(module.exports, "default", () => $067172025a93bfdd$export$2e2bcd8739ae039);
// Generated using scripts/write-encode-map.ts
function $067172025a93bfdd$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$067172025a93bfdd$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $067172025a93bfdd$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $067172025a93bfdd$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $067172025a93bfdd$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $067172025a93bfdd$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("jJd9f", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", () => $e5cc6b37386efc7e$export$5699810ce3244ab8);
$parcel$export(module.exports, "getCodePoint", () => $e5cc6b37386efc7e$export$e02688b8085d016b);
$parcel$export(module.exports, "encodeXML", () => $e5cc6b37386efc7e$export$18855ec5be97da16);
$parcel$export(module.exports, "escapeUTF8", () => $e5cc6b37386efc7e$export$9e081872deefdcb0);
$parcel$export(module.exports, "escapeAttribute", () => $e5cc6b37386efc7e$export$30330f3d5eb70e11);
$parcel$export(module.exports, "escapeText", () => $e5cc6b37386efc7e$export$96e6fc3a139b2555);
const $e5cc6b37386efc7e$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $e5cc6b37386efc7e$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $e5cc6b37386efc7e$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $e5cc6b37386efc7e$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $e5cc6b37386efc7e$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $e5cc6b37386efc7e$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$e5cc6b37386efc7e$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $e5cc6b37386efc7e$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $e5cc6b37386efc7e$export$4e7f196112fea3c5 = $e5cc6b37386efc7e$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $e5cc6b37386efc7e$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $e5cc6b37386efc7e$export$9e081872deefdcb0 = $e5cc6b37386efc7e$var$getEscaper(/[&<>'"]/g, $e5cc6b37386efc7e$var$xmlCodeMap);
const $e5cc6b37386efc7e$export$30330f3d5eb70e11 = $e5cc6b37386efc7e$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $e5cc6b37386efc7e$export$96e6fc3a139b2555 = $e5cc6b37386efc7e$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});




parcelRegister("lOMx4", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => (parcelRequire("gP720")).default);
$parcel$export(module.exports, "parseLinkDestination", () => (parcelRequire("hEouy")).default);
$parcel$export(module.exports, "parseLinkTitle", () => (parcelRequire("2syDh")).default);
// Just a shortcut for bulk export

var $gP720 = parcelRequire("gP720");

var $hEouy = parcelRequire("hEouy");

var $2syDh = parcelRequire("2syDh");

});
parcelRegister("gP720", function(module, exports) {

$parcel$export(module.exports, "default", () => $256ef2605acee19f$export$2e2bcd8739ae039);
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
function $256ef2605acee19f$export$2e2bcd8739ae039(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}

});

parcelRegister("hEouy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4ac6dc8f61484e$export$2e2bcd8739ae039);
// Parse link destination
//

var $9Wt9S = parcelRequire("9Wt9S");
function $6a4ac6dc8f61484e$export$2e2bcd8739ae039(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, $9Wt9S.unescapeAll)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, $9Wt9S.unescapeAll)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}

});

parcelRegister("2syDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb29b0c2a2d02d5a$export$2e2bcd8739ae039);
// Parse link title
//

var $9Wt9S = parcelRequire("9Wt9S");
function $cb29b0c2a2d02d5a$export$2e2bcd8739ae039(str, start, max, prev_state) {
    let code;
    let pos = start;
    const state = {
        // if `true`, this is a valid link title
        ok: false,
        // if `true`, this link can be continued on the next line
        can_continue: false,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: '',
        // expected closing marker character code
        marker: 0
    };
    if (prev_state) {
        // this is a continuation of a previous parseLinkTitle call on the next line,
        // used in reference links only
        state.str = prev_state.str;
        state.marker = prev_state.marker;
    } else {
        if (pos >= max) return state;
        let marker = str.charCodeAt(pos);
        if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return state;
        start++;
        pos++;
        // if opening marker is "(", switch it to closing marker ")"
        if (marker === 0x28) marker = 0x29;
        state.marker = marker;
    }
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === state.marker) {
            state.pos = pos + 1;
            state.str += (0, $9Wt9S.unescapeAll)(str.slice(start, pos));
            state.ok = true;
            return state;
        } else if (code === 0x28 /* ( */  && state.marker === 0x29 /* ) */ ) return state;
        else if (code === 0x5C /* \ */  && pos + 1 < max) pos++;
        pos++;
    }
    // no closing marker found, but this link title may continue on the next line (for references)
    state.can_continue = true;
    state.str += (0, $9Wt9S.unescapeAll)(str.slice(start, pos));
    return state;
}

});


parcelRegister("8Dgzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f5ffcdf5357f963$export$2e2bcd8739ae039);
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 
var $9Wt9S = parcelRequire("9Wt9S");
const $2f5ffcdf5357f963$var$default_rules = {};
$2f5ffcdf5357f963$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + (0, $9Wt9S.escapeHtml)(token.content) + '</code>';
};
$2f5ffcdf5357f963$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + (0, $9Wt9S.escapeHtml)(tokens[idx].content) + '</code></pre>\n';
};
$2f5ffcdf5357f963$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, $9Wt9S.unescapeAll)(token.info).trim() : '';
    let langName = '';
    let langAttrs = '';
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, $9Wt9S.escapeHtml)(token.content);
    else highlighted = (0, $9Wt9S.escapeHtml)(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex('class');
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
$2f5ffcdf5357f963$var$default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$2f5ffcdf5357f963$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$2f5ffcdf5357f963$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$2f5ffcdf5357f963$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, $9Wt9S.escapeHtml)(tokens[idx].content);
};
$2f5ffcdf5357f963$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$2f5ffcdf5357f963$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $2f5ffcdf5357f963$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs)
   * for more details and examples.
   **/ this.rules = (0, $9Wt9S.assign)({}, $2f5ffcdf5357f963$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $2f5ffcdf5357f963$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + (0, $9Wt9S.escapeHtml)(token.attrs[i][0]) + '="' + (0, $9Wt9S.escapeHtml)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $2f5ffcdf5357f963$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = '';
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $2f5ffcdf5357f963$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $2f5ffcdf5357f963$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = '';
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case 'text':
            result += tokens[i].content;
            break;
        case 'image':
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case 'html_inline':
        case 'html_block':
            result += tokens[i].content;
            break;
        case 'softbreak':
        case 'hardbreak':
            result += '\n';
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $2f5ffcdf5357f963$var$Renderer.prototype.render = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
var $2f5ffcdf5357f963$export$2e2bcd8739ae039 = $2f5ffcdf5357f963$var$Renderer;

});

parcelRegister("0O45r", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8ee4ea6fa4999a7$export$2e2bcd8739ae039);
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 
var $at4l3 = parcelRequire("at4l3");

var $lFIix = parcelRequire("lFIix");

var $4wWHG = parcelRequire("4wWHG");

var $zKGz5 = parcelRequire("zKGz5");

var $gdzCr = parcelRequire("gdzCr");

var $hc3M5 = parcelRequire("hc3M5");

var $kVHcM = parcelRequire("kVHcM");

var $lwHgQ = parcelRequire("lwHgQ");

var $g8xuk = parcelRequire("g8xuk");
const $e8ee4ea6fa4999a7$var$_rules = [
    [
        'normalize',
        (0, $4wWHG.default)
    ],
    [
        'block',
        (0, $zKGz5.default)
    ],
    [
        'inline',
        (0, $gdzCr.default)
    ],
    [
        'linkify',
        (0, $hc3M5.default)
    ],
    [
        'replacements',
        (0, $kVHcM.default)
    ],
    [
        'smartquotes',
        (0, $lwHgQ.default)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (0, $g8xuk.default)
    ]
];
/**
 * new Core()
 **/ function $e8ee4ea6fa4999a7$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, $at4l3.default)();
    for(let i = 0; i < $e8ee4ea6fa4999a7$var$_rules.length; i++)this.ruler.push($e8ee4ea6fa4999a7$var$_rules[i][0], $e8ee4ea6fa4999a7$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $e8ee4ea6fa4999a7$var$Core.prototype.process = function(state) {
    const rules = this.ruler.getRules('');
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
$e8ee4ea6fa4999a7$var$Core.prototype.State = (0, $lFIix.default);
var $e8ee4ea6fa4999a7$export$2e2bcd8739ae039 = $e8ee4ea6fa4999a7$var$Core;

});
parcelRegister("at4l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $856d3eaa12c7d7ab$export$2e2bcd8739ae039);
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ function $856d3eaa12c7d7ab$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
$856d3eaa12c7d7ab$var$Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$856d3eaa12c7d7ab$var$Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
var $856d3eaa12c7d7ab$export$2e2bcd8739ae039 = $856d3eaa12c7d7ab$var$Ruler;

});

parcelRegister("lFIix", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ff43ee2b0d9b681$export$2e2bcd8739ae039);
// Core state object
//

var $6P50I = parcelRequire("6P50I");
function $5ff43ee2b0d9b681$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md // link to parser instance
    ;
}
// re-export Token class to use in core rules
$5ff43ee2b0d9b681$var$StateCore.prototype.Token = (0, $6P50I.default);
var $5ff43ee2b0d9b681$export$2e2bcd8739ae039 = $5ff43ee2b0d9b681$var$StateCore;

});
parcelRegister("6P50I", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21340cc7b36c75d$export$2e2bcd8739ae039);
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $d21340cc7b36c75d$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $d21340cc7b36c75d$var$Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $d21340cc7b36c75d$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $d21340cc7b36c75d$var$Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $d21340cc7b36c75d$var$Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $d21340cc7b36c75d$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
var $d21340cc7b36c75d$export$2e2bcd8739ae039 = $d21340cc7b36c75d$var$Token;

});


parcelRegister("4wWHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a74af09f2ba37fd$export$2e2bcd8739ae039);
// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
const $4a74af09f2ba37fd$var$NEWLINES_RE = /\r\n?|\n/g;
const $4a74af09f2ba37fd$var$NULL_RE = /\0/g;
function $4a74af09f2ba37fd$export$2e2bcd8739ae039(state) {
    let str;
    // Normalize newlines
    str = state.src.replace($4a74af09f2ba37fd$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($4a74af09f2ba37fd$var$NULL_RE, '\uFFFD');
    state.src = str;
}

});

parcelRegister("zKGz5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdc461a40ef0996c$export$2e2bcd8739ae039);
function $fdc461a40ef0996c$export$2e2bcd8739ae039(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}

});

parcelRegister("gdzCr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7bda804fe2c36e6$export$2e2bcd8739ae039);
function $d7bda804fe2c36e6$export$2e2bcd8739ae039(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}

});

parcelRegister("hc3M5", function(module, exports) {

$parcel$export(module.exports, "default", () => $500adbf0c8e76436$export$2e2bcd8739ae039);
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//

var $9Wt9S = parcelRequire("9Wt9S");
function $500adbf0c8e76436$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $500adbf0c8e76436$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $500adbf0c8e76436$export$2e2bcd8739ae039(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($500adbf0c8e76436$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($500adbf0c8e76436$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token('link_open', 'a', 1);
                    token_o.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = 'linkify';
                    token_o.info = 'auto';
                    nodes.push(token_o);
                    const token_t = new state.Token('text', '', 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token('link_close', 'a', -1);
                    token_c.level = --level;
                    token_c.markup = 'linkify';
                    token_c.info = 'auto';
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = (0, $9Wt9S.arrayReplaceAt)(tokens, i, nodes);
            }
        }
    }
}

});

parcelRegister("kVHcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4c38bbdc5f5f79$export$2e2bcd8739ae039);
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
const $6f4c38bbdc5f5f79$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const $6f4c38bbdc5f5f79$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const $6f4c38bbdc5f5f79$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const $6f4c38bbdc5f5f79$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $6f4c38bbdc5f5f79$var$replaceFn(match, name) {
    return $6f4c38bbdc5f5f79$var$SCOPED_ABBR[name.toLowerCase()];
}
function $6f4c38bbdc5f5f79$var$replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($6f4c38bbdc5f5f79$var$SCOPED_ABBR_RE, $6f4c38bbdc5f5f79$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $6f4c38bbdc5f5f79$var$replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($6f4c38bbdc5f5f79$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $6f4c38bbdc5f5f79$export$2e2bcd8739ae039(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($6f4c38bbdc5f5f79$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $6f4c38bbdc5f5f79$var$replace_scoped(state.tokens[blkIdx].children);
        if ($6f4c38bbdc5f5f79$var$RARE_RE.test(state.tokens[blkIdx].content)) $6f4c38bbdc5f5f79$var$replace_rare(state.tokens[blkIdx].children);
    }
}

});

parcelRegister("lwHgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ac4b11b288ec2d$export$2e2bcd8739ae039);
// Convert straight quotation marks to typographic ones
//

var $9Wt9S = parcelRequire("9Wt9S");
const $70ac4b11b288ec2d$var$QUOTE_TEST_RE = /['"]/;
const $70ac4b11b288ec2d$var$QUOTE_RE = /['"]/g;
const $70ac4b11b288ec2d$var$APOSTROPHE = '\u2019' /* ’ */ ;
function $70ac4b11b288ec2d$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $70ac4b11b288ec2d$var$process_inlines(tokens, state) {
    let j;
    const stack = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        let text = token.content;
        let pos = 0;
        let max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            $70ac4b11b288ec2d$var$QUOTE_RE.lastIndex = pos;
            const t = $70ac4b11b288ec2d$var$QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, $9Wt9S.isMdAsciiPunct)(lastChar) || (0, $9Wt9S.isPunctChar)(String.fromCharCode(lastChar));
            const isNextPunctChar = (0, $9Wt9S.isMdAsciiPunct)(nextChar) || (0, $9Wt9S.isPunctChar)(String.fromCharCode(nextChar));
            const isLastWhiteSpace = (0, $9Wt9S.isWhiteSpace)(lastChar);
            const isNextWhiteSpace = (0, $9Wt9S.isWhiteSpace)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $70ac4b11b288ec2d$var$replaceAt(token.content, t.index, $70ac4b11b288ec2d$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                let item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $70ac4b11b288ec2d$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $70ac4b11b288ec2d$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $70ac4b11b288ec2d$var$replaceAt(token.content, t.index, $70ac4b11b288ec2d$var$APOSTROPHE);
        }
    }
}
function $70ac4b11b288ec2d$export$2e2bcd8739ae039(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$70ac4b11b288ec2d$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $70ac4b11b288ec2d$var$process_inlines(state.tokens[blkIdx].children, state);
    }
}

});

parcelRegister("g8xuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $60323e9fe3e5750e$export$2e2bcd8739ae039);
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
function $60323e9fe3e5750e$export$2e2bcd8739ae039(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}

});


parcelRegister("cqhCq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b24bf10baac51cd$export$2e2bcd8739ae039);
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 
var $at4l3 = parcelRequire("at4l3");

var $g5XEx = parcelRequire("g5XEx");

var $7jA0X = parcelRequire("7jA0X");

var $aif0n = parcelRequire("aif0n");

var $3cVzU = parcelRequire("3cVzU");

var $6IVUy = parcelRequire("6IVUy");

var $aV7jx = parcelRequire("aV7jx");

var $1CL28 = parcelRequire("1CL28");

var $aMRwF = parcelRequire("aMRwF");

var $jKRoe = parcelRequire("jKRoe");

var $boNmx = parcelRequire("boNmx");

var $b9PIF = parcelRequire("b9PIF");

var $5Lg31 = parcelRequire("5Lg31");
const $1b24bf10baac51cd$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (0, $7jA0X.default),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (0, $aif0n.default)
    ],
    [
        'fence',
        (0, $3cVzU.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (0, $6IVUy.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (0, $aV7jx.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (0, $1CL28.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (0, $aMRwF.default)
    ],
    [
        'html_block',
        (0, $jKRoe.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (0, $boNmx.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (0, $b9PIF.default)
    ],
    [
        'paragraph',
        (0, $5Lg31.default)
    ]
];
/**
 * new ParserBlock()
 **/ function $1b24bf10baac51cd$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, $at4l3.default)();
    for(let i = 0; i < $1b24bf10baac51cd$var$_rules.length; i++)this.ruler.push($1b24bf10baac51cd$var$_rules[i][0], $1b24bf10baac51cd$var$_rules[i][1], {
        alt: ($1b24bf10baac51cd$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$1b24bf10baac51cd$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $1b24bf10baac51cd$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
$1b24bf10baac51cd$var$ParserBlock.prototype.State = (0, $g5XEx.default);
var $1b24bf10baac51cd$export$2e2bcd8739ae039 = $1b24bf10baac51cd$var$ParserBlock;

});
parcelRegister("g5XEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $791edc64da2f2aa4$export$2e2bcd8739ae039);
// Parser state class

var $6P50I = parcelRequire("6P50I");

var $9Wt9S = parcelRequire("9Wt9S");
function $791edc64da2f2aa4$var$StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = [] // line begin offsets for fast jumps
    ;
    this.eMarks = [] // line end offsets for fast jumps
    ;
    this.tShift = [] // offsets of the first non-space characters (tabs not expanded)
    ;
    this.sCount = [] // indents for each line (tabs expanded)
    ;
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0 // line index in src
    ;
    this.lineMax = 0 // lines count
    ;
    this.tight = false // loose/tight mode for lists
    ;
    this.ddIndent = -1 // indent of the current dd block (-1 if there isn't any)
    ;
    this.listIndent = -1 // indent of the current list block (-1 if there isn't any)
    ;
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, $9Wt9S.isSpace)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1 // don't count last fake line
    ;
}
// Push new token to "stream".
//
$791edc64da2f2aa4$var$StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, $6P50I.default)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level-- // closing tag
    ;
    token.level = this.level;
    if (nesting > 0) this.level++ // opening tag
    ;
    this.tokens.push(token);
    return token;
};
$791edc64da2f2aa4$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$791edc64da2f2aa4$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$791edc64da2f2aa4$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, $9Wt9S.isSpace)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$791edc64da2f2aa4$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, $9Wt9S.isSpace)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$791edc64da2f2aa4$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$791edc64da2f2aa4$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$791edc64da2f2aa4$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return '';
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, $9Wt9S.isSpace)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$791edc64da2f2aa4$var$StateBlock.prototype.Token = (0, $6P50I.default);
var $791edc64da2f2aa4$export$2e2bcd8739ae039 = $791edc64da2f2aa4$var$StateBlock;

});

parcelRegister("7jA0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee53d7d0bd34043$export$2e2bcd8739ae039);
// GFM table, https://github.github.com/gfm/#tables-extension-

var $9Wt9S = parcelRequire("9Wt9S");
// Limit the amount of empty autocompleted cells in a table,
// see https://github.com/markdown-it/markdown-it/issues/1000,
//
// Both pulldown-cmark and commonmark-hs limit the number of cells this way to ~200k.
// We set it to 65k, which can expand user input by a factor of x370
// (256x256 square is 1.8kB expanded into 650kB).
const $0ee53d7d0bd34043$var$MAX_AUTOCOMPLETED_CELLS = 0x10000;
function $0ee53d7d0bd34043$var$getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $0ee53d7d0bd34043$var$escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = '';
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function $0ee53d7d0bd34043$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, $9Wt9S.isSpace)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, $9Wt9S.isSpace)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, $9Wt9S.isSpace)(ch)) return false;
        pos++;
    }
    let lineText = $0ee53d7d0bd34043$var$getLine(state, startLine + 1);
    let columns = lineText.split('|');
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $0ee53d7d0bd34043$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $0ee53d7d0bd34043$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const token_to = state.push('table_open', 'table', 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push('thead_open', 'thead', 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push('tr_open', 'tr', 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push('th_open', 'th', 1);
        if (aligns[i]) token_ho.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        const token_il = state.push('inline', '', 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push('th_close', 'th', -1);
    }
    state.push('tr_close', 'tr', -1);
    state.push('thead_close', 'thead', -1);
    let tbodyLines;
    let autocompletedCells = 0;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $0ee53d7d0bd34043$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $0ee53d7d0bd34043$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        // note: autocomplete count can be negative if user specifies more columns than header,
        // but that does not affect intended use (which is limiting expansion)
        autocompletedCells += columnCount - columns.length;
        if (autocompletedCells > $0ee53d7d0bd34043$var$MAX_AUTOCOMPLETED_CELLS) break;
        if (nextLine === startLine + 2) {
            const token_tbo = state.push('tbody_open', 'tbody', 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push('tr_open', 'tr', 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push('td_open', 'td', 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            const token_il = state.push('inline', '', 0);
            token_il.content = columns[i] ? columns[i].trim() : '';
            token_il.children = [];
            state.push('td_close', 'td', -1);
        }
        state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}

});

parcelRegister("aif0n", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb785362ac575ef5$export$2e2bcd8739ae039);
// Code block (4 spaces padded)
function $cb785362ac575ef5$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("3cVzU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e00964fb4e951b60$export$2e2bcd8739ae039);
// fences (``` lang, ~~~ lang)
function $e00964fb4e951b60$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("6IVUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $eba237e7f41c2eed$export$2e2bcd8739ae039);
// Block quotes

var $9Wt9S = parcelRequire("9Wt9S");
function $eba237e7f41c2eed$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const oldParentType = state.parentType;
    state.parentType = 'blockquote';
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, $9Wt9S.isSpace)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push('blockquote_open', 'blockquote', 1);
    token_o.markup = '>';
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push('blockquote_close', 'blockquote', -1);
    token_c.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}

});

parcelRegister("aV7jx", function(module, exports) {

$parcel$export(module.exports, "default", () => $62f5e8f4e87d6064$export$2e2bcd8739ae039);
// Horizontal rule

var $9Wt9S = parcelRequire("9Wt9S");
function $62f5e8f4e87d6064$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, $9Wt9S.isSpace)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}

});

parcelRegister("1CL28", function(module, exports) {

$parcel$export(module.exports, "default", () => $a629c46eb78ec931$export$2e2bcd8739ae039);
// Lists

var $9Wt9S = parcelRequire("9Wt9S");
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $a629c46eb78ec931$var$skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, $9Wt9S.isSpace)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $a629c46eb78ec931$var$skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, $9Wt9S.isSpace)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $a629c46eb78ec931$var$markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function $a629c46eb78ec931$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = $a629c46eb78ec931$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $a629c46eb78ec931$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules('list');
    const oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $a629c46eb78ec931$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $a629c46eb78ec931$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $a629c46eb78ec931$var$markTightParagraphs(state, listTokIdx);
    return true;
}

});

parcelRegister("aMRwF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8852253d996ce648$export$2e2bcd8739ae039);

var $9Wt9S = parcelRequire("9Wt9S");
function $8852253d996ce648$export$2e2bcd8739ae039(state, startLine, _endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    function getNextLine(nextLine) {
        const endLine = state.lineMax;
        if (nextLine >= endLine || state.isEmpty(nextLine)) // empty line or end of input
        return null;
        let isContinuation = false;
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) isContinuation = true;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) isContinuation = true;
        if (!isContinuation) {
            const terminatorRules = state.md.block.ruler.getRules('reference');
            const oldParentType = state.parentType;
            state.parentType = 'reference';
            // Some tags can terminate paragraph without empty line.
            let terminate = false;
            for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            state.parentType = oldParentType;
            if (terminate) // terminated by another block
            return null;
        }
        const pos = state.bMarks[nextLine] + state.tShift[nextLine];
        const max = state.eMarks[nextLine];
        // max + 1 explicitly includes the newline
        return state.src.slice(pos, max + 1);
    }
    let str = state.src.slice(pos, max + 1);
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) {
                const lineContent = getNextLine(nextLine);
                if (lineContent !== null) {
                    str += lineContent;
                    max = str.length;
                    nextLine++;
                }
            }
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $9Wt9S.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = nextLine;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $9Wt9S.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    while(titleRes.can_continue){
        const lineContent = getNextLine(nextLine);
        if (lineContent === null) break;
        str += lineContent;
        pos = max;
        max = str.length;
        nextLine++;
        titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
    }
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
    } else {
        title = '';
        pos = destEndPos;
        nextLine = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, $9Wt9S.isSpace)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            nextLine = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, $9Wt9S.isSpace)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, $9Wt9S.normalizeReference)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.line = nextLine;
    return true;
}

});

parcelRegister("jKRoe", function(module, exports) {

$parcel$export(module.exports, "default", () => $77dd0bad82781cb3$export$2e2bcd8739ae039);
// HTML block

var $cYu8C = parcelRequire("cYu8C");

var $kAxEC = parcelRequire("kAxEC");
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const $77dd0bad82781cb3$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + (0, $cYu8C.default).join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp((0, $kAxEC.HTML_OPEN_CLOSE_TAG_RE).source + '\\s*$'),
        /^$/,
        false
    ]
];
function $77dd0bad82781cb3$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < $77dd0bad82781cb3$var$HTML_SEQUENCES.length; i++){
        if ($77dd0bad82781cb3$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $77dd0bad82781cb3$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $77dd0bad82781cb3$var$HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$77dd0bad82781cb3$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($77dd0bad82781cb3$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}

});
parcelRegister("cYu8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7482819406fa2c$export$2e2bcd8739ae039);
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var $8e7482819406fa2c$export$2e2bcd8739ae039 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("kAxEC", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $d81d76d23616b3fd$export$6db61d2c3a16e419);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $d81d76d23616b3fd$export$cd48660d06f74639);
// Regexps to match html elements
const $d81d76d23616b3fd$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
const $d81d76d23616b3fd$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
const $d81d76d23616b3fd$var$single_quoted = "'[^']*'";
const $d81d76d23616b3fd$var$double_quoted = '"[^"]*"';
const $d81d76d23616b3fd$var$attr_value = '(?:' + $d81d76d23616b3fd$var$unquoted + '|' + $d81d76d23616b3fd$var$single_quoted + '|' + $d81d76d23616b3fd$var$double_quoted + ')';
const $d81d76d23616b3fd$var$attribute = '(?:\\s+' + $d81d76d23616b3fd$var$attr_name + '(?:\\s*=\\s*' + $d81d76d23616b3fd$var$attr_value + ')?)';
const $d81d76d23616b3fd$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $d81d76d23616b3fd$var$attribute + '*\\s*\\/?>';
const $d81d76d23616b3fd$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
const $d81d76d23616b3fd$var$comment = '<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->';
const $d81d76d23616b3fd$var$processing = '<[?][\\s\\S]*?[?]>';
const $d81d76d23616b3fd$var$declaration = '<![A-Za-z][^>]*>';
const $d81d76d23616b3fd$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
const $d81d76d23616b3fd$export$6db61d2c3a16e419 = new RegExp('^(?:' + $d81d76d23616b3fd$var$open_tag + '|' + $d81d76d23616b3fd$var$close_tag + '|' + $d81d76d23616b3fd$var$comment + '|' + $d81d76d23616b3fd$var$processing + '|' + $d81d76d23616b3fd$var$declaration + '|' + $d81d76d23616b3fd$var$cdata + ')');
const $d81d76d23616b3fd$export$cd48660d06f74639 = new RegExp('^(?:' + $d81d76d23616b3fd$var$open_tag + '|' + $d81d76d23616b3fd$var$close_tag + ')');

});


parcelRegister("boNmx", function(module, exports) {

$parcel$export(module.exports, "default", () => $386a7bf10f825645$export$2e2bcd8739ae039);
// heading (#, ##, ...)

var $9Wt9S = parcelRequire("9Wt9S");
function $386a7bf10f825645$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, $9Wt9S.isSpace)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, $9Wt9S.isSpace)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = '########'.slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = state.src.slice(pos, max).trim();
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = '########'.slice(0, level);
    return true;
}

});

parcelRegister("b9PIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c68d720d14e3fcd$export$2e2bcd8739ae039);
// lheading (---, ===)
function $6c68d720d14e3fcd$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph' // use paragraph to match terminatorRules
    ;
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}

});

parcelRegister("5Lg31", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd7e7cbe73cebc09$export$2e2bcd8739ae039);
// Paragraph
function $dd7e7cbe73cebc09$export$2e2bcd8739ae039(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    const token_o = state.push('paragraph_open', 'p', 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
}

});


parcelRegister("2vOE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3178ab1d2766dc10$export$2e2bcd8739ae039);
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 
var $at4l3 = parcelRequire("at4l3");

var $h5Y0q = parcelRequire("h5Y0q");

var $9EsZP = parcelRequire("9EsZP");

var $7DwY4 = parcelRequire("7DwY4");

var $gH7Rn = parcelRequire("gH7Rn");

var $gzJoP = parcelRequire("gzJoP");

var $fOW9o = parcelRequire("fOW9o");

var $gUBjg = parcelRequire("gUBjg");

var $jsV0C = parcelRequire("jsV0C");

var $l96IW = parcelRequire("l96IW");

var $hUu3r = parcelRequire("hUu3r");

var $2cC3v = parcelRequire("2cC3v");

var $lssRK = parcelRequire("lssRK");

var $hGHP1 = parcelRequire("hGHP1");

var $9oRtg = parcelRequire("9oRtg");

var $kVKhK = parcelRequire("kVKhK");
// Parser rules
const $3178ab1d2766dc10$var$_rules = [
    [
        'text',
        (0, $9EsZP.default)
    ],
    [
        'linkify',
        (0, $7DwY4.default)
    ],
    [
        'newline',
        (0, $gH7Rn.default)
    ],
    [
        'escape',
        (0, $gzJoP.default)
    ],
    [
        'backticks',
        (0, $fOW9o.default)
    ],
    [
        'strikethrough',
        (0, $gUBjg.default).tokenize
    ],
    [
        'emphasis',
        (0, $jsV0C.default).tokenize
    ],
    [
        'link',
        (0, $l96IW.default)
    ],
    [
        'image',
        (0, $hUu3r.default)
    ],
    [
        'autolink',
        (0, $2cC3v.default)
    ],
    [
        'html_inline',
        (0, $lssRK.default)
    ],
    [
        'entity',
        (0, $hGHP1.default)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const $3178ab1d2766dc10$var$_rules2 = [
    [
        'balance_pairs',
        (0, $9oRtg.default)
    ],
    [
        'strikethrough',
        (0, $gUBjg.default).postProcess
    ],
    [
        'emphasis',
        (0, $jsV0C.default).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (0, $kVKhK.default)
    ]
];
/**
 * new ParserInline()
 **/ function $3178ab1d2766dc10$var$ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, $at4l3.default)();
    for(let i = 0; i < $3178ab1d2766dc10$var$_rules.length; i++)this.ruler.push($3178ab1d2766dc10$var$_rules[i][0], $3178ab1d2766dc10$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, $at4l3.default)();
    for(let i = 0; i < $3178ab1d2766dc10$var$_rules2.length; i++)this.ruler2.push($3178ab1d2766dc10$var$_rules2[i][0], $3178ab1d2766dc10$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$3178ab1d2766dc10$var$ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$3178ab1d2766dc10$var$ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $3178ab1d2766dc10$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules('');
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
$3178ab1d2766dc10$var$ParserInline.prototype.State = (0, $h5Y0q.default);
var $3178ab1d2766dc10$export$2e2bcd8739ae039 = $3178ab1d2766dc10$var$ParserInline;

});
parcelRegister("h5Y0q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2592a02f3d954285$export$2e2bcd8739ae039);
// Inline parser state

var $6P50I = parcelRequire("6P50I");

var $9Wt9S = parcelRequire("9Wt9S");
function $2592a02f3d954285$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$2592a02f3d954285$var$StateInline.prototype.pushPending = function() {
    const token = new (0, $6P50I.default)('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$2592a02f3d954285$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, $6P50I.default)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$2592a02f3d954285$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    const lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    const nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    const isLastPunctChar = (0, $9Wt9S.isMdAsciiPunct)(lastChar) || (0, $9Wt9S.isPunctChar)(String.fromCharCode(lastChar));
    const isNextPunctChar = (0, $9Wt9S.isMdAsciiPunct)(nextChar) || (0, $9Wt9S.isPunctChar)(String.fromCharCode(nextChar));
    const isLastWhiteSpace = (0, $9Wt9S.isWhiteSpace)(lastChar);
    const isNextWhiteSpace = (0, $9Wt9S.isWhiteSpace)(nextChar);
    const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
    const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
    const can_open = left_flanking && (canSplitWord || !right_flanking || isLastPunctChar);
    const can_close = right_flanking && (canSplitWord || !left_flanking || isNextPunctChar);
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$2592a02f3d954285$var$StateInline.prototype.Token = (0, $6P50I.default);
var $2592a02f3d954285$export$2e2bcd8739ae039 = $2592a02f3d954285$var$StateInline;

});

parcelRegister("9EsZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $db24db0eb5111e79$export$2e2bcd8739ae039);
// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $db24db0eb5111e79$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function $db24db0eb5111e79$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !$db24db0eb5111e79$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParserInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 

});

parcelRegister("7DwY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f78c4fb26d79f4$export$2e2bcd8739ae039);
// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
const $37f78c4fb26d79f4$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function $37f78c4fb26d79f4$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    const match = state.pending.match($37f78c4fb26d79f4$var$SCHEME_RE);
    if (!match) return false;
    const proto = match[1];
    const link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        const token_o = state.push('link_open', 'a', 1);
        token_o.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token_o.markup = 'linkify';
        token_o.info = 'auto';
        const token_t = state.push('text', '', 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push('link_close', 'a', -1);
        token_c.markup = 'linkify';
        token_c.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
}

});

parcelRegister("gH7Rn", function(module, exports) {

$parcel$export(module.exports, "default", () => $465f123239c78f9c$export$2e2bcd8739ae039);
// Proceess '\n'

var $9Wt9S = parcelRequire("9Wt9S");
function $465f123239c78f9c$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, $9Wt9S.isSpace)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}

});

parcelRegister("gzJoP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb9b12de4931b87$export$2e2bcd8739ae039);
// Process escaped chars and hardbreaks

var $9Wt9S = parcelRequire("9Wt9S");
const $ebb9b12de4931b87$var$ESCAPED = [];
for(let i = 0; i < 256; i++)$ebb9b12de4931b87$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $ebb9b12de4931b87$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
function $ebb9b12de4931b87$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, $9Wt9S.isSpace)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = '\\' + escapedStr;
    if (!silent) {
        const token = state.push('text_special', '', 0);
        if (ch1 < 256 && $ebb9b12de4931b87$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
}

});

parcelRegister("fOW9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $d19b7cb70ab1c423$export$2e2bcd8739ae039);
// Parse backticks
function $d19b7cb70ab1c423$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}

});

parcelRegister("gUBjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7da0667f6ea239a2$export$2e2bcd8739ae039);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $7da0667f6ea239a2$var$strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $7da0667f6ea239a2$var$postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $7da0667f6ea239a2$var$strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $7da0667f6ea239a2$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $7da0667f6ea239a2$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $7da0667f6ea239a2$export$2e2bcd8739ae039 = {
    tokenize: $7da0667f6ea239a2$var$strikethrough_tokenize,
    postProcess: $7da0667f6ea239a2$var$strikethrough_postProcess
};

});

parcelRegister("jsV0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d2eee1aeb284400$export$2e2bcd8739ae039);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $3d2eee1aeb284400$var$emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            marker: // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $3d2eee1aeb284400$var$postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? 'strong_open' : 'em_open';
        token_o.tag = isStrong ? 'strong' : 'em';
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = '';
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? 'strong_close' : 'em_close';
        token_c.tag = isStrong ? 'strong' : 'em';
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $3d2eee1aeb284400$var$emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $3d2eee1aeb284400$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $3d2eee1aeb284400$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $3d2eee1aeb284400$export$2e2bcd8739ae039 = {
    tokenize: $3d2eee1aeb284400$var$emphasis_tokenize,
    postProcess: $3d2eee1aeb284400$var$emphasis_post_process
};

});

parcelRegister("l96IW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d44413bc65f086b$export$2e2bcd8739ae039);
// Process [link](<to> "stuff")

var $9Wt9S = parcelRequire("9Wt9S");
function $0d44413bc65f086b$export$2e2bcd8739ae039(state, silent) {
    let code, label, res, ref;
    let href = '';
    let title = '';
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $9Wt9S.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push('link_open', 'a', 1);
        const attrs = [
            [
                'href',
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("hUu3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $6004b904447d9404$export$2e2bcd8739ae039);
// Process ![image](<src> "title")

var $9Wt9S = parcelRequire("9Wt9S");
function $6004b904447d9404$export$2e2bcd8739ae039(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = '';
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $9Wt9S.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push('image', 'img', 0);
        const attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("2cC3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e57dbd84036aa5$export$2e2bcd8739ae039);
// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ const $49e57dbd84036aa5$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const $49e57dbd84036aa5$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $49e57dbd84036aa5$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if ($49e57dbd84036aa5$var$AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($49e57dbd84036aa5$var$EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}

});

parcelRegister("lssRK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb34f601fe68ff08$export$2e2bcd8739ae039);
// Process html tags

var $kAxEC = parcelRequire("kAxEC");
function $bb34f601fe68ff08$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $bb34f601fe68ff08$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $bb34f601fe68ff08$var$isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function $bb34f601fe68ff08$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$bb34f601fe68ff08$var$isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, $kAxEC.HTML_TAG_RE));
    if (!match) return false;
    if (!silent) {
        const token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($bb34f601fe68ff08$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($bb34f601fe68ff08$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}

});

parcelRegister("hGHP1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f4fa5c84eaf65f$export$2e2bcd8739ae039);
// Process html entity - &#123;, &#xAF;, &quot;, ...
parcelRequire("4MNLB");
var $8qSbS = parcelRequire("8qSbS");

var $9Wt9S = parcelRequire("9Wt9S");
const $d5f4fa5c84eaf65f$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const $d5f4fa5c84eaf65f$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function $d5f4fa5c84eaf65f$export$2e2bcd8739ae039(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match($d5f4fa5c84eaf65f$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push('text_special', '', 0);
                token.content = (0, $9Wt9S.isValidEntityCode)(code) ? (0, $9Wt9S.fromCodePoint)(code) : (0, $9Wt9S.fromCodePoint)(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match($d5f4fa5c84eaf65f$var$NAMED_RE);
        if (match) {
            const decoded = (0, $8qSbS.decodeHTML)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push('text_special', '', 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}

});

parcelRegister("9oRtg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc6bea41754e8d9e$export$2e2bcd8739ae039);
// For each opening emphasis-like marker find a matching closing one
//
function $bc6bea41754e8d9e$var$processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function $bc6bea41754e8d9e$export$2e2bcd8739ae039(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $bc6bea41754e8d9e$var$processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $bc6bea41754e8d9e$var$processDelimiters(tokens_meta[curr].delimiters);
}

});

parcelRegister("kVKhK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c939aeb62d3c954c$export$2e2bcd8739ae039);
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
function $c939aeb62d3c954c$export$2e2bcd8739ae039(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level-- // closing tag
        ;
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++ // opening tag
        ;
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}

});


parcelRegister("eGX2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd1206f3765b534$export$2e2bcd8739ae039);

var $jmddV = parcelRequire("jmddV");
//
// Helpers
//
// Merge objects
//
function $bdd1206f3765b534$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $bdd1206f3765b534$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $bdd1206f3765b534$var$isString(obj) {
    return $bdd1206f3765b534$var$_class(obj) === '[object String]';
}
function $bdd1206f3765b534$var$isObject(obj) {
    return $bdd1206f3765b534$var$_class(obj) === '[object Object]';
}
function $bdd1206f3765b534$var$isRegExp(obj) {
    return $bdd1206f3765b534$var$_class(obj) === '[object RegExp]';
}
function $bdd1206f3765b534$var$isFunction(obj) {
    return $bdd1206f3765b534$var$_class(obj) === '[object Function]';
}
function $bdd1206f3765b534$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $bdd1206f3765b534$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $bdd1206f3765b534$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $bdd1206f3765b534$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $bdd1206f3765b534$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const $bdd1206f3765b534$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $bdd1206f3765b534$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $bdd1206f3765b534$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $bdd1206f3765b534$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $bdd1206f3765b534$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $bdd1206f3765b534$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $jmddV.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($bdd1206f3765b534$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {} // Reset compiled data
    ;
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($bdd1206f3765b534$var$isObject(val)) {
            if ($bdd1206f3765b534$var$isRegExp(val.validate)) compiled.validate = $bdd1206f3765b534$var$createValidator(val.validate);
            else if ($bdd1206f3765b534$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($bdd1206f3765b534$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $bdd1206f3765b534$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($bdd1206f3765b534$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $bdd1206f3765b534$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($bdd1206f3765b534$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $bdd1206f3765b534$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $bdd1206f3765b534$var$Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $bdd1206f3765b534$var$createMatch(self, shift) {
    const match = new $bdd1206f3765b534$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $bdd1206f3765b534$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $bdd1206f3765b534$var$LinkifyIt)) return new $bdd1206f3765b534$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($bdd1206f3765b534$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $bdd1206f3765b534$var$assign({}, $bdd1206f3765b534$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1 // Next scan position
    ;
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $bdd1206f3765b534$var$assign({}, $bdd1206f3765b534$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $bdd1206f3765b534$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $bdd1206f3765b534$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $bdd1206f3765b534$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $bdd1206f3765b534$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($bdd1206f3765b534$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($bdd1206f3765b534$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $bdd1206f3765b534$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $bdd1206f3765b534$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $bdd1206f3765b534$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $bdd1206f3765b534$export$2e2bcd8739ae039 = $bdd1206f3765b534$var$LinkifyIt;

});
parcelRegister("jmddV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7763c029038efc47$export$2e2bcd8739ae039);
parcelRequire("ih6Pl");
var $6JWQo = parcelRequire("6JWQo");
var $bzTP8 = parcelRequire("bzTP8");
var $6qXSM = parcelRequire("6qXSM");
var $cINVi = parcelRequire("cINVi");
function $7763c029038efc47$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $6JWQo.default).source;
    re.src_Cc = (0, $bzTP8.default).source;
    re.src_Z = (0, $cINVi.default).source;
    re.src_P = (0, $6qXSM.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
    "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    ',(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    ';(?!' + re.src_ZCc + '|$)|' + // allow `!!!` in paths, but not at the end
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /* _root */  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
}

});


parcelRegister("ib0wl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3b9a8767eb6cd3f$export$2e2bcd8739ae039);
'use strict';
/** Highest positive signed 32-bit float value */ const $d3b9a8767eb6cd3f$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $d3b9a8767eb6cd3f$var$base = 36;
const $d3b9a8767eb6cd3f$var$tMin = 1;
const $d3b9a8767eb6cd3f$var$tMax = 26;
const $d3b9a8767eb6cd3f$var$skew = 38;
const $d3b9a8767eb6cd3f$var$damp = 700;
const $d3b9a8767eb6cd3f$var$initialBias = 72;
const $d3b9a8767eb6cd3f$var$initialN = 128; // 0x80
const $d3b9a8767eb6cd3f$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $d3b9a8767eb6cd3f$var$regexPunycode = /^xn--/;
const $d3b9a8767eb6cd3f$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $d3b9a8767eb6cd3f$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $d3b9a8767eb6cd3f$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $d3b9a8767eb6cd3f$var$baseMinusTMin = $d3b9a8767eb6cd3f$var$base - $d3b9a8767eb6cd3f$var$tMin;
const $d3b9a8767eb6cd3f$var$floor = Math.floor;
const $d3b9a8767eb6cd3f$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $d3b9a8767eb6cd3f$var$error(type) {
    throw new RangeError($d3b9a8767eb6cd3f$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $d3b9a8767eb6cd3f$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $d3b9a8767eb6cd3f$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($d3b9a8767eb6cd3f$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $d3b9a8767eb6cd3f$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $d3b9a8767eb6cd3f$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $d3b9a8767eb6cd3f$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $d3b9a8767eb6cd3f$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $d3b9a8767eb6cd3f$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $d3b9a8767eb6cd3f$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $d3b9a8767eb6cd3f$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $d3b9a8767eb6cd3f$var$floor(delta / $d3b9a8767eb6cd3f$var$damp) : delta >> 1;
    delta += $d3b9a8767eb6cd3f$var$floor(delta / numPoints);
    for(; delta > $d3b9a8767eb6cd3f$var$baseMinusTMin * $d3b9a8767eb6cd3f$var$tMax >> 1; k += $d3b9a8767eb6cd3f$var$base)delta = $d3b9a8767eb6cd3f$var$floor(delta / $d3b9a8767eb6cd3f$var$baseMinusTMin);
    return $d3b9a8767eb6cd3f$var$floor(k + ($d3b9a8767eb6cd3f$var$baseMinusTMin + 1) * delta / (delta + $d3b9a8767eb6cd3f$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $d3b9a8767eb6cd3f$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $d3b9a8767eb6cd3f$var$initialN;
    let bias = $d3b9a8767eb6cd3f$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($d3b9a8767eb6cd3f$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $d3b9a8767eb6cd3f$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $d3b9a8767eb6cd3f$var$base;; k += $d3b9a8767eb6cd3f$var$base){
            if (index >= inputLength) $d3b9a8767eb6cd3f$var$error('invalid-input');
            const digit = $d3b9a8767eb6cd3f$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $d3b9a8767eb6cd3f$var$base) $d3b9a8767eb6cd3f$var$error('invalid-input');
            if (digit > $d3b9a8767eb6cd3f$var$floor(($d3b9a8767eb6cd3f$var$maxInt - i) / w)) $d3b9a8767eb6cd3f$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $d3b9a8767eb6cd3f$var$tMin : k >= bias + $d3b9a8767eb6cd3f$var$tMax ? $d3b9a8767eb6cd3f$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $d3b9a8767eb6cd3f$var$base - t;
            if (w > $d3b9a8767eb6cd3f$var$floor($d3b9a8767eb6cd3f$var$maxInt / baseMinusT)) $d3b9a8767eb6cd3f$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $d3b9a8767eb6cd3f$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($d3b9a8767eb6cd3f$var$floor(i / out) > $d3b9a8767eb6cd3f$var$maxInt - n) $d3b9a8767eb6cd3f$var$error('overflow');
        n += $d3b9a8767eb6cd3f$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $d3b9a8767eb6cd3f$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $d3b9a8767eb6cd3f$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $d3b9a8767eb6cd3f$var$initialN;
    let delta = 0;
    let bias = $d3b9a8767eb6cd3f$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($d3b9a8767eb6cd3f$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($d3b9a8767eb6cd3f$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $d3b9a8767eb6cd3f$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $d3b9a8767eb6cd3f$var$floor(($d3b9a8767eb6cd3f$var$maxInt - delta) / handledCPCountPlusOne)) $d3b9a8767eb6cd3f$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $d3b9a8767eb6cd3f$var$maxInt) $d3b9a8767eb6cd3f$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $d3b9a8767eb6cd3f$var$base;; k += $d3b9a8767eb6cd3f$var$base){
                    const t = k <= bias ? $d3b9a8767eb6cd3f$var$tMin : k >= bias + $d3b9a8767eb6cd3f$var$tMax ? $d3b9a8767eb6cd3f$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $d3b9a8767eb6cd3f$var$base - t;
                    output.push($d3b9a8767eb6cd3f$var$stringFromCharCode($d3b9a8767eb6cd3f$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $d3b9a8767eb6cd3f$var$floor(qMinusT / baseMinusT);
                }
                output.push($d3b9a8767eb6cd3f$var$stringFromCharCode($d3b9a8767eb6cd3f$var$digitToBasic(q, 0)));
                bias = $d3b9a8767eb6cd3f$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $d3b9a8767eb6cd3f$export$110c810e8727e62b = function(input) {
    return $d3b9a8767eb6cd3f$var$mapDomain(input, function(string) {
        return $d3b9a8767eb6cd3f$var$regexPunycode.test(string) ? $d3b9a8767eb6cd3f$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $d3b9a8767eb6cd3f$export$69111c4ea6e0c4a0 = function(input) {
    return $d3b9a8767eb6cd3f$var$mapDomain(input, function(string) {
        return $d3b9a8767eb6cd3f$var$regexNonASCII.test(string) ? 'xn--' + $d3b9a8767eb6cd3f$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $d3b9a8767eb6cd3f$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $d3b9a8767eb6cd3f$export$c1700176c90f250f,
        'encode': $d3b9a8767eb6cd3f$export$f999239d9b149395
    },
    'decode': $d3b9a8767eb6cd3f$export$2f872c0f2117be69,
    'encode': $d3b9a8767eb6cd3f$export$c564cdbbe6da493,
    'toASCII': $d3b9a8767eb6cd3f$export$69111c4ea6e0c4a0,
    'toUnicode': $d3b9a8767eb6cd3f$export$110c810e8727e62b
};
var $d3b9a8767eb6cd3f$export$2e2bcd8739ae039 = $d3b9a8767eb6cd3f$var$punycode;

});

parcelRegister("5ZRUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a5bde204b42db2$export$2e2bcd8739ae039);
// markdown-it default options
var $69a5bde204b42db2$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("gVArB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e78f92af3d2d267b$export$2e2bcd8739ae039);
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var $e78f92af3d2d267b$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("r2Oyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $51d3b87413be1462$export$2e2bcd8739ae039);
// Commonmark default options
var $51d3b87413be1462$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});



parcelRegister("BwWrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $15d670b578ce327d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
var $dH58k = parcelRequire("dH58k");

var $iEJNQ = parcelRequire("iEJNQ");
const $15d670b578ce327d$var$BorderlessButtonMessage = ({ text: text, differentTextTosend: differentTextTosend })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const unlockClickedButton = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.unlockClickedButton);
    const [hover, setHover] = (0, $bxRTa.useState)(false);
    const [clicked, setClicked] = (0, $bxRTa.useState)(false);
    const animationColor = {
        '--rf-color-loader-animation': themeColors.card.button.text.default
    };
    const onClick = (text)=>{
        setClicked(true);
        dispatch((0, $cto9a.storeActions).utils.lockClickedButton());
        dispatch((0, $cto9a.storeActions).directline.sendMessage({
            text: text
        }));
    };
    (0, $bxRTa.useEffect)(()=>{
        unlockClickedButton && setClicked(false);
    }, [
        unlockClickedButton
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-flex rf-justify-start rf-cursor-pointer",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
            className: "rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-start rf-text-cardButtonTextDefault",
            onPointerEnter: ()=>setHover(true),
            onPointerLeave: ()=>setHover(false),
            onClick: ()=>{
                setHover(true);
                onClick(differentTextTosend || text);
            },
            children: [
                clicked ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-h-6 rf-w-6 rf-flex rf-justify-center rf-items-center",
                    style: {
                        ...animationColor
                    },
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-2 rf-h-2",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                            size: (0, $2rYkD.AnimationSize).small
                        })
                    })
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `rf-h-6 rf-w-6 rf-rounded ${hover ? 'rf-bg-cardButtonBackgroundHover' : 'rf-bg-cardButtonBackgroundDefault'}`,
                    children: isRTL ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dH58k.default), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `${isRTL ? 'rf-mr-4' : 'rf-ml-4'}`,
                    children: text || ''
                })
            ]
        })
    });
};
var $15d670b578ce327d$export$2e2bcd8739ae039 = $15d670b578ce327d$var$BorderlessButtonMessage;

});


parcelRegister("030Xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2a59d276d0c21c5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $2aMjv = parcelRequire("2aMjv");
var $hzlaD = parcelRequire("hzlaD");
parcelRequire("6hiCI");
var $28u6w = parcelRequire("28u6w");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $lOuaH = parcelRequire("lOuaH");

var $2rYkD = parcelRequire("2rYkD");

var $5JKxf = parcelRequire("5JKxf");
const $c2a59d276d0c21c5$var$springEnterDuration = 1000;
const $c2a59d276d0c21c5$var$md = new (0, $28u6w.default)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    typographer: true,
    quotes: `""''`
});
const $c2a59d276d0c21c5$var$GridAttachment = ({ index: index, text: text, textColor: textColor, backgroundColor: backgroundColor, image: image, action: action, history: history, setQrCodeDataOverlay: setQrCodeDataOverlay })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isUsedOnBorne = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.isUsedOnBorne);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const divRef = (0, $bxRTa.useRef)(null);
    const tileDimensions = (0, $lOuaH.default)(divRef);
    const height = (0, $bxRTa.useMemo)(()=>{
        return tileDimensions.width * 0.75;
    }, [
        tileDimensions.width
    ]);
    const showImage = (0, $bxRTa.useMemo)(()=>{
        return !!(image?.url && height > 80);
    }, [
        height,
        image
    ]);
    const nbLines = (0, $bxRTa.useMemo)(()=>{
        if (!showImage) {
            const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const lineHeightInPx = remToPx * (isMobile ? 1 : 1.1);
            return Math.floor(height / lineHeightInPx);
        }
        return 2;
    }, [
        showImage,
        height
    ]);
    const lineClamp = (0, $bxRTa.useMemo)(()=>{
        return showImage ? 'rf-h-2/5 rf-line-clamp-2' : `rf-line-clamp-${nbLines}`;
    }, [
        nbLines,
        showImage
    ]);
    const maxHeight = (0, $bxRTa.useMemo)(()=>{
        return showImage ? 'rf-max-h-8 large:rf-max-h-[2.3rem]' : `rf-max-h-[${nbLines}rem] large:rf-max-h-[${nbLines * 1.1 + 0.1}rem]`;
    }, [
        nbLines,
        showImage
    ]);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                transform: 'translateX(0%)',
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        setTimeout(()=>{
            api.start({
                from: {
                    transform: 'translateX(100%)',
                    opacity: 0
                },
                to: {
                    transform: 'translateX(0%)',
                    opacity: 1
                },
                config: {
                    duration: $c2a59d276d0c21c5$var$springEnterDuration,
                    easing: (0, $2aMjv.easings).easeInBack
                }
            });
        }, index * 200);
    }, []);
    const handleInternalAction = (value)=>{
        if (value?.name) switch(value.name.toLowerCase()){
            case 'openmenu':
                dispatch((0, $cto9a.storeActions).utils.setDashboardOpened(true));
                break;
            case 'openlanguage':
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).languages));
                break;
            case 'openhistory':
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).history));
                break;
            case 'opentutorial':
                console.log('Open tutorial');
                break;
            case 'fullscreenimage':
                value.url && dispatch((0, $cto9a.storeActions).utils.setFullScreenImage(value.url));
                break;
        }
    };
    const handleClick = (e)=>{
        switch(action.type){
            case (0, $2rYkD.ActionType).message:
                action.value?.text && dispatch((0, $cto9a.storeActions).directline.sendMessage({
                    text: action.value.text
                }));
                break;
            case (0, $2rYkD.ActionType).event:
                action.value?.name && dispatch((0, $cto9a.storeActions).directline.sendEvent({
                    name: action.value.name,
                    value: action.value.value || null
                }));
                break;
            case (0, $2rYkD.ActionType).url:
                if (action.value?.url) // Generate QR-code data on borne, open the URL otherwise
                !isMobile && isUsedOnBorne ? setQrCodeDataOverlay?.(action.value.url) : window.open(action.value.url, '_blank', 'noopener noreferrer');
                break;
            case (0, $2rYkD.ActionType).internal:
                handleInternalAction(action.value);
                break;
        }
        dispatch((0, $cto9a.storeActions).utils.setClickedOnUI((0, $2rYkD.UIPart).card));
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
        ref: divRef,
        className: `rf-relative rf-w-full ${history ? 'rf-p-3 rf-pointer-events-none' : 'rf-p-4'} rf-flex rf-flex-col ${image?.url ? 'rf-justify-between' : 'rf-justify-end'} rf-items-start rf-gap-[10%] ${isMobile ? 'rf-border rf-border-[#F0F0F0]' : ''} hover:rf-shadow-[inset_0_0_12px_#00000029] hover:rf-cursor-pointer rf-rounded rf-shadow-[-3px_-3px_10px_#00000099] rf-overflow-hidden`,
        style: {
            height: `calc(${height}px + 1.5rem)`,
            color: textColor || '#575F6B',
            backgroundColor: backgroundColor || '#FFF',
            ...spring
        },
        onClick: (e)=>handleClick(e),
        children: [
            showImage && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-1/2",
                children: image?.url && image.url.indexOf('svg') > -1 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5JKxf.default), {
                    svgUrl: image.url,
                    height: "100%",
                    fillColor: image.color
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                    className: "rf-h-full",
                    src: image?.url
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-flex rf-min-h-8 large:rf-min-h-[2.3rem] ${lineClamp} rf-items-start rf-text-small-size-auto rf-overflow-y-hidden`,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                    className: `${maxHeight} rf-overflow-y-clip`,
                    dangerouslySetInnerHTML: {
                        __html: $c2a59d276d0c21c5$var$md.renderInline(text)
                    }
                })
            })
        ]
    });
};
var $c2a59d276d0c21c5$export$2e2bcd8739ae039 = $c2a59d276d0c21c5$var$GridAttachment;

});

parcelRegister("hRTgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d4969aabda7e97$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $drUL7 = parcelRequire("drUL7");

var $5FZWK = parcelRequire("5FZWK");

var $f74jF = parcelRequire("f74jF");
const $86d4969aabda7e97$var$adaptiveCard = new $drUL7.AdaptiveCard();
const $86d4969aabda7e97$var$AdaptiveCardAttachment = ({ content: content, height: height })=>{
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const divRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        const customAdaptiveCardHostConfig = (0, $f74jF.default)(themeColors.primary, themeColors.card.frame.background);
        $86d4969aabda7e97$var$adaptiveCard.hostConfig = new $drUL7.HostConfig(customAdaptiveCardHostConfig);
    }, [
        themeColors
    ]);
    (0, $bxRTa.useEffect)(()=>{
        const clonedContent = structuredClone(content);
        clonedContent.minHeight = height ? `${height}px` : '0px';
        clonedContent.verticalContentAlignment = 'Center';
        $86d4969aabda7e97$var$adaptiveCard.parse(clonedContent);
        const htmlValue = $86d4969aabda7e97$var$adaptiveCard.render();
        if (divRef.current) {
            divRef.current.firstChild?.remove();
            htmlValue && divRef.current.appendChild(htmlValue);
        }
    }, [
        content,
        height
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        ref: divRef
    });
};
var $86d4969aabda7e97$export$2e2bcd8739ae039 = $86d4969aabda7e97$var$AdaptiveCardAttachment;

});
parcelRegister("drUL7", function(module, exports) {
"use strict";
var $9ca9d31e6ae36725$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9ca9d31e6ae36725$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9ca9d31e6ae36725$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
$9ca9d31e6ae36725$var$__exportStar((parcelRequire("24F6S")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("gIXBn")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("6BHj7")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("F6YrP")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("5Ougt")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("7Lc5Q")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("8kDQQ")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("2Zn2I")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("dUjDB")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("6XfIC")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("99lCx")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("bPIqH")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("krFBf")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("kBxrI")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("5PICj")), module.exports);

});

parcelRegister("f74jF", function(module, exports) {

$parcel$export(module.exports, "default", () => $63e5c2a6b6784a3d$export$2e2bcd8739ae039);

var $aZ7dK = parcelRequire("aZ7dK");
const $63e5c2a6b6784a3d$var$createAdaptiveCardHostConfig = (primary, cardBackground)=>{
    const template = (0, $aZ7dK.adaptiveCardHostConfig);
    template.containerStyles.default.foregroundColors.default.default = primary;
    template.containerStyles.default.backgroundColor = cardBackground;
    return template;
};
var $63e5c2a6b6784a3d$export$2e2bcd8739ae039 = $63e5c2a6b6784a3d$var$createAdaptiveCardHostConfig;

});
parcelRegister("aZ7dK", function(module, exports) {

$parcel$export(module.exports, "adaptiveCardHostConfig", () => $b147a5a488fa3db3$export$d30af3ec38729f1);
const $b147a5a488fa3db3$var$color = '#00D7FF';
const $b147a5a488fa3db3$var$white = '#F7F3F6';
const $b147a5a488fa3db3$export$d30af3ec38729f1 = {
    hostCapabilities: {
        capabilities: null
    },
    choiceSetInputValueSeparator: ',',
    supportsInteractivity: true,
    fontTypes: {
        default: {
            fontFamily: '"Helvetica Neue", sans-serif',
            fontSizes: {
                small: 12,
                default: 16,
                medium: 20,
                large: 26,
                extraLarge: 33
            },
            fontWeights: {
                lighter: 200,
                default: 300,
                bolder: 400
            }
        },
        monospace: {
            fontFamily: '"Helvetica Neue", sans-serif',
            fontSizes: {
                small: 12,
                default: 16,
                medium: 20,
                large: 26,
                extraLarge: 33
            },
            fontWeights: {
                lighter: 200,
                default: 300,
                bolder: 400
            }
        }
    },
    spacing: {
        small: 8,
        default: 16,
        medium: 20,
        large: 30,
        extraLarge: 40,
        padding: 25
    },
    separator: {
        lineThickness: 1,
        lineColor: 'transparent'
    },
    imageSizes: {
        small: 40,
        medium: 100,
        large: 160
    },
    containerStyles: {
        default: {
            foregroundColors: {
                default: {
                    default: `${$b147a5a488fa3db3$var$white}`,
                    subtle: `${$b147a5a488fa3db3$var$color}`,
                    highlightColors: {
                        default: `${$b147a5a488fa3db3$var$color}`,
                        subtle: '#11000000'
                    }
                },
                dark: {
                    default: '#000000',
                    subtle: '#66000000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                light: {
                    default: '#FFFFFF',
                    subtle: '#33000000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                accent: {
                    default: '#0063B1',
                    subtle: '#0063B1',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                good: {
                    default: '#54a254',
                    subtle: '#DD54a254',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                warning: {
                    default: '#c3ab23',
                    subtle: '#DDc3ab23',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                attention: {
                    default: '#FF0000',
                    subtle: '#DDFF0000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                }
            },
            backgroundColor: 'transparent'
        },
        emphasis: {
            foregroundColors: {
                default: {
                    default: '#000000',
                    subtle: '#767676',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                dark: {
                    default: '#000000',
                    subtle: '#66000000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                light: {
                    default: '#FFFFFF',
                    subtle: '#33000000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                accent: {
                    default: '#2E89FC',
                    subtle: '#882E89FC',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                good: {
                    default: '#54a254',
                    subtle: '#DD54a254',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                warning: {
                    default: '#c3ab23',
                    subtle: '#DDc3ab23',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                attention: {
                    default: '#FF0000',
                    subtle: '#DDFF0000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                }
            },
            backgroundColor: '#F0F0F0'
        }
    },
    actions: {
        maxActions: 100,
        spacing: 'Default',
        buttonSpacing: 0,
        showCard: {
            actionMode: 'Inline',
            inlineTopMargin: 8,
            style: 'emphasis'
        },
        preExpandSingleShowCardAction: false,
        actionsOrientation: 'vertical',
        actionAlignment: 'left',
        wrap: true
    },
    adaptiveCard: {
        allowCustomStyle: true
    },
    imageSet: {
        maxImageHeight: 100
    },
    media: {
        allowInlinePlayback: true
    },
    factSet: {
        title: {
            size: 'Default',
            color: `${$b147a5a488fa3db3$var$color}`,
            isSubtle: false,
            weight: 'Bolder',
            wrap: true
        },
        value: {
            size: 'Default',
            color: `${$b147a5a488fa3db3$var$color}`,
            isSubtle: false,
            weight: 'Default',
            wrap: true
        },
        spacing: 1000
    },
    cssClassNamePrefix: null,
    _legacyFontType: {
        fontFamily: 'Helvetica Neue,sans-serif',
        fontSizes: {
            small: 12,
            default: 16,
            medium: 20,
            large: 26,
            extraLarge: 33
        },
        fontWeights: {
            lighter: 200,
            default: 400,
            bolder: 600
        }
    }
};

});



parcelRegister("xEIv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d11bb19506d161$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $fUXG2 = parcelRequire("fUXG2");
const $70d11bb19506d161$var$CounterAttachment = ()=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const placeHolder = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.sendBoxPlaceHolder);
    const delay = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.submitDelayBeforeSendingMessage);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const speechInterims = (0, $5FZWK.useSelector)((state)=>state.speechReducer.lastRecognitionInterim);
    const recognitionState = (0, $5FZWK.useSelector)((state)=>state.speechReducer.activeRecognitionState);
    const [displayCounter, setDisplayCounter] = (0, $bxRTa.useState)(false);
    const timerRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        setDisplayCounter(false);
    }, [
        placeHolder,
        delay
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (delay && recognitionState === (0, $2rYkD.RecognitionState).Closing && speechInterims) {
            setDisplayCounter(true);
            timerRef.current = setTimeout(()=>{
                dispatch((0, $cto9a.storeActions).directline.sendMessage({
                    text: speechInterims
                }));
                dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed));
            }, delay * 1000);
        }
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [
        delay,
        speechInterims,
        recognitionState
    ]);
    const handleButtonClick = ()=>{
        timerRef.current && clearTimeout(timerRef.current);
        dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed));
        dispatch((0, $cto9a.storeActions).speech.setMode((0, $2rYkD.Mode).text));
    };
    return mode === (0, $2rYkD.Mode).vocal && (recognitionState === (0, $2rYkD.RecognitionState).Closing || recognitionState === (0, $2rYkD.RecognitionState).Listening) ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-h-full rf-p-4 rf-pb-8 rf-flex rf-flex-col rf-items-center rf-bg-cardFrameBackground rf-gap-4 rf-rounded",
        children: [
            placeHolder && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-subtitle-size-auto rf-text-center rf-text-cardFrameText rf-font-bold",
                children: placeHolder
            }),
            displayCounter ? /* Counter + button */ /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    delay && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fUXG2.default), {
                        delay: delay
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        className: "rf-card-button",
                        onClick: handleButtonClick,
                        children: translation.anghello.correct
                    })
                ]
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-text-medium-size-auto rf-text-center rf-text-cardButtonTextDefault",
                children: translation.anghello.listening
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $70d11bb19506d161$export$2e2bcd8739ae039 = $70d11bb19506d161$var$CounterAttachment;

});
parcelRegister("fUXG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $210a7fe3ec90b247$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $210a7fe3ec90b247$var$Counter = ({ delay: delay })=>{
    const [counter, setCounter] = (0, $bxRTa.useState)(delay);
    const intervalRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        intervalRef.current = setInterval(()=>{
            setCounter((value)=>{
                return value ? value - 1 : 0;
            });
        }, 1000);
        return ()=>{
            intervalRef.current && clearInterval(intervalRef.current);
        };
    }, []);
    return counter ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-relative rf-h-32 rf-w-32 rf-flex rf-items-center rf-justify-center rf-text-6xl rf-text-primary rf-loader-counter",
        style: {
            '--duration': `${delay}s`
        },
        children: counter
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $210a7fe3ec90b247$export$2e2bcd8739ae039 = $210a7fe3ec90b247$var$Counter;

});


parcelRegister("exvww", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5e3e520daefcda3$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");
const $e5e3e520daefcda3$var$NamedListAttachment = ({ value: value, title: title, history: history, height: height })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const handleClick = (valueToSend)=>{
        dispatch((0, $cto9a.storeActions).directline.sendMessage({
            text: valueToSend
        }));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-pb-8 rf-flex rf-flex-col rf-items-center rf-bg-cardFrameBackground rf-gap-4 rf-rounded",
        style: {
            height: height
        },
        children: [
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-subtitle-size-auto rf-text-center rf-text-cardFrameText rf-font-bold",
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-justify-center rf-items-center rf-flex-wrap rf-gap-3 large:rf-gap-4",
                children: value.map((item, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        className: `${item.display === 'primary' ? 'rf-card-button-positive' : 'rf-card-button'}`,
                        onClick: history ? ()=>{} : ()=>handleClick(item.value),
                        children: item.text
                    }, key);
                })
            })
        ]
    });
};
var $e5e3e520daefcda3$export$2e2bcd8739ae039 = $e5e3e520daefcda3$var$NamedListAttachment;

});

parcelRegister("beoxv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e551f8aff398c01a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $lOuaH = parcelRequire("lOuaH");

var $4ZEXS = parcelRequire("4ZEXS");
const $e551f8aff398c01a$var$IFrame = ({ uri: uri, height: height, width: width, title: title, actions: actions })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const currentHeight = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentHeight);
    const currentWidth = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentWidth);
    const [documentLoaded, setDocumentLoaded] = (0, $bxRTa.useState)(false);
    const divRef = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(divRef);
    const processedHeight = (0, $bxRTa.useMemo)(()=>{
        if (currentHeight > currentWidth) return currentWidth > 960 ? '50%' : '100%';
        return '100%';
    }, [
        currentHeight,
        currentWidth
    ]);
    const processedWidth = (0, $bxRTa.useMemo)(()=>{
        return currentWidth > 960 ? 960 : '100%';
    }, [
        currentWidth
    ]);
    const handleClick = (value)=>{
        if (typeof value === 'string') dispatch((0, $cto9a.storeActions).directline.sendMessage({
            text: value
        }));
        else if (typeof value === 'object') dispatch((0, $cto9a.storeActions).directline.sendMessage({
            value: value
        }));
        dispatch((0, $cto9a.storeActions).utils.setModalFullscreenContent(null));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        ref: divRef,
        className: `${isMobile ? '' : 'rf-py-8'} rf-flex rf-flex-col rf-justify-center`,
        style: {
            height: height || processedHeight,
            width: width || processedWidth
        },
        children: [
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-py-4 rf-px-4 rf-flex rf-flex-row rf-justify-start rf-items-center rf-gap-4 rf-bg-truewhite rf-rounded-t-lg",
                children: title
            }),
            !documentLoaded && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-absolute rf-h-24 rf-w-24 rf-top-[calc(50%-3rem)] rf-left-[calc(50%-3rem)]",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4ZEXS.default), {
                    color: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("iframe", {
                src: uri,
                height: dimensions.height,
                width: dimensions.width,
                style: {
                    backgroundColor: '#FFF'
                },
                onLoad: ()=>setDocumentLoaded(true)
            }),
            actions?.length && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-py-4 rf-flex rf-flex-row rf-justify-center rf-items-center rf-gap-4 rf-bg-truewhite rf-rounded-b-lg",
                children: actions.map((action, key)=>{
                    return key === 0 ? /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        className: "rf-text-truewhite rf-border rf-border-[#1999B1] rf-bg-[#1999B1] hover:rf-text-[#1999B1] hover:rf-bg-transparent rf-rounded rf-py-1 large:rf-py-2 rf-px-2 large:rf-px-4 rf-text-size-auto",
                        onClick: ()=>handleClick(action.value),
                        children: action.title
                    }, key) : /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        className: "rf-text-[#1999B1] rf-border rf-border-[#1999B1] rf-bg-transparent hover:rf-text-truewhite hover:rf-bg-[#1999B1] rf-rounded rf-py-1 large:rf-py-2 rf-px-2 large:rf-px-4 rf-text-size-auto",
                        onClick: ()=>handleClick(action.value),
                        children: action.title
                    }, key);
                })
            })
        ]
    });
};
var $e551f8aff398c01a$export$2e2bcd8739ae039 = $e551f8aff398c01a$var$IFrame;

});


parcelRegister("9GMhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $035a2f2fdfdba85b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $hC8yR = parcelRequire("hC8yR");
const $035a2f2fdfdba85b$var$Card = ({ children: children, className: className, shadow: shadow = false })=>{
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const [scrollButtonDisplay, setScrollButtonDisplay] = (0, $bxRTa.useState)(false);
    const [scrollButtonDirection, setScrollButtonDirection] = (0, $bxRTa.useState)('bottom');
    const botEndRef = (0, $bxRTa.useRef)(null);
    const cardRef = (0, $bxRTa.useRef)(null);
    const scrollHandler = (to)=>{
        switch(to){
            case 'top':
                setScrollButtonDirection('bottom');
                cardRef.current?.children[1].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
                break;
            case 'bottom':
                setScrollButtonDirection('top');
                botEndRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
                break;
        }
        if (to === 'bottom') setScrollButtonDirection('top');
        else setScrollButtonDirection('bottom');
    };
    const handleScroll = ()=>{
        if (cardRef.current) {
            const parentHeight = cardRef.current.parentElement?.clientHeight;
            const scrollHeight = cardRef.current.scrollHeight;
            const scrollTop = cardRef.current.scrollTop;
            // const offsetHeight = (cardRef.current as HTMLDivElement).offsetHeight
            const clientHeight = cardRef.current.clientHeight;
            if (parentHeight && scrollHeight > parentHeight) {
                if (scrollHeight - scrollTop < clientHeight + 10) {
                    setScrollButtonDisplay(true);
                    setScrollButtonDirection('top');
                } else {
                    setScrollButtonDisplay(true);
                    setScrollButtonDirection('bottom');
                }
            } else setScrollButtonDisplay(false);
        }
    };
    /**
   * On DragStart event call :
   *  - prevent default behaviour and stop propagation of the event
   *  - this is to prevent image dragging while trying to swipe in a carousel
   * @param e : React.DragEvent
   */ const handleDragStart = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    // Check scroll at component first render
    (0, $bxRTa.useEffect)(()=>{
        const timer = setTimeout(()=>{
            handleScroll();
        }, 500);
        return ()=>timer && clearTimeout(timer);
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        dir: isRTL ? 'rtl' : 'ltr',
        className: `rf-relative rf-max-h-full rf-flex rf-flex-col rf-text-size-auto rf-unselectable ${className}`,
        draggable: true,
        onDragStart: handleDragStart,
        style: {
            pointerEvents: 'all'
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
            className: `rf-w-full rf-max-h-full rf-rounded rf-border rf-border-cardFrameBorder rf-flex rf-flex-col rf-content-around rf-justify-start ${!shadow && 'rf-overflow-y-auto rf-overflow-x-hidden'} rf-scrollbar-thin`,
            ref: cardRef,
            onScroll: ()=>handleScroll(),
            style: {
                touchAction: 'pan-y'
            },
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hC8yR.default), {
                    direction: scrollButtonDirection,
                    display: scrollButtonDisplay,
                    scrollHandler: scrollHandler,
                    className: "rf-absolute rf-z-ui rf-bottom-1 rf-right-6 rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
                }),
                children,
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    ref: botEndRef
                })
            ]
        })
    });
};
var $035a2f2fdfdba85b$export$2e2bcd8739ae039 = $035a2f2fdfdba85b$var$Card;

});
parcelRegister("hC8yR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2df9ed76ce0fc2c$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $kaFO8 = parcelRequire("kaFO8");

var $k4qlo = parcelRequire("k4qlo");

var $dMIx4 = parcelRequire("dMIx4");
const $c2df9ed76ce0fc2c$var$ScrollButton = ({ direction: direction, display: display, scrollHandler: scrollHandler, className: className })=>{
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const fullScreenImage = (0, $kaFO8.default)();
    const divRef = (0, $bxRTa.useRef)(null);
    const handleClick = ()=>{
        scrollHandler(direction);
    };
    (0, $bxRTa.useLayoutEffect)(()=>{
        divRef?.current && (0, $k4qlo.default)(divRef.current);
    });
    return display && !fullScreenImage ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "ScrollButton",
        ref: divRef,
        className: className,
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dMIx4.default), {
            className: `${direction === 'top' ? 'rf-rotate-0' : 'rf-rotate-180'}`,
            color: themeColors.primary
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fl9nK.Fragment), {});
};
var $c2df9ed76ce0fc2c$export$2e2bcd8739ae039 = $c2df9ed76ce0fc2c$var$ScrollButton;

});
parcelRegister("dMIx4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf7d1facde185da$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $ccf7d1facde185da$var$ScrollButtonIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        className: className,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            id: "Icon_ionic-ios-arrow-down",
            fill: color,
            className: "st0",
            d: "M 49.948 29.033 L 13.413 65.414 C 10.792 68.035 6.323 68.188 3.702 65.414 C 3.702 65.414 3.702 65.414 3.702 65.414 C 1.081 62.639 1.081 58.322 3.702 55.702 L 45.015 14.388 C 47.636 11.767 51.798 11.767 54.573 14.233 L 96.195 55.856 C 98.97 58.477 98.97 62.947 96.195 65.568 C 93.574 68.343 89.103 68.343 86.484 65.568 L 49.948 29.033 Z"
        })
    });
};
var $ccf7d1facde185da$export$2e2bcd8739ae039 = $ccf7d1facde185da$var$ScrollButtonIcon;

});




parcelRegister("dd8py", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff93508f46094968$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $8HSQQ = parcelRequire("8HSQQ");

var $eQecn = parcelRequire("eQecn");

var $9GMhE = parcelRequire("9GMhE");

var $bFo6t = parcelRequire("bFo6t");
const $ff93508f46094968$var$CarouselContainer = ({ title: title, attachments: attachments, history: history, grid: grid, showSearchBar: showSearchBar, triggerScroll: triggerScroll })=>{
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const [height, setHeight] = (0, $bxRTa.useState)(0);
    const [elements, setElements] = (0, $bxRTa.useState)([]);
    const [forcedCurrentCardInCarousel, setForcedCurrentCardInCarousel] = (0, $bxRTa.useState)(0);
    const [carouselCardWidth, setCarouselCardWidth] = (0, $bxRTa.useState)(0);
    const timerRef = (0, $bxRTa.useRef)();
    const carouselRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useLayoutEffect)(()=>{
        setHeight(0);
        if (attachments.length) {
            timerRef.current && clearTimeout(timerRef.current);
            timerRef.current = setTimeout(()=>{
                carouselRef.current && setHeight(carouselRef.current.clientHeight);
            }, 500);
        }
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [
        attachments,
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        triggerScroll?.();
    }, [
        height
    ]);
    (0, $bxRTa.useEffect)(()=>{
        const tempElements = [];
        if (showSearchBar) {
            attachments.forEach((attachment)=>{
                attachment.content?.value?.forEach((val)=>{
                    tempElements.push(val);
                });
            });
            setElements(tempElements);
        } else setElements([]);
    }, [
        attachments,
        showSearchBar
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $eQecn.default), {
                ref: carouselRef,
                history: history,
                draft: height === 0,
                grid: grid,
                gridTitle: title,
                forcedCurrentCard: forcedCurrentCardInCarousel,
                setForcedCurrentCardInCarousel: setForcedCurrentCardInCarousel,
                setCarouselCardWidth: setCarouselCardWidth,
                children: height === 0 ? attachments.map((attachment, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9GMhE.default), {
                        className: "rf-w-full",
                        children: (0, $8HSQQ.default)({
                            attachment: attachment,
                            history: history
                        })
                    }, key + 100);
                }) : attachments.map((attachment, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9GMhE.default), {
                        className: "rf-w-full",
                        children: (0, $8HSQQ.default)({
                            attachment: attachment,
                            history: history,
                            height: height
                        })
                    }, key);
                })
            }),
            showSearchBar && height !== 0 && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bFo6t.default), {
                elements: elements,
                elementsByCard: attachments[0].content?.value?.length,
                carouselCardWidth: carouselCardWidth,
                setCardToShow: setForcedCurrentCardInCarousel
            })
        ]
    });
};
var $ff93508f46094968$export$2e2bcd8739ae039 = $ff93508f46094968$var$CarouselContainer;

});
parcelRegister("eQecn", function(module, exports) {

$parcel$export(module.exports, "default", () => $122c41313e875e60$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $2aMjv = parcelRequire("2aMjv");
var $hzlaD = parcelRequire("hzlaD");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $lOuaH = parcelRequire("lOuaH");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("l9TTE");
var $o9qp2 = parcelRequire("o9qp2");
var $fEfdX = parcelRequire("fEfdX");
const $122c41313e875e60$var$springEnterDuration = 1000;
// Cards' width coefficients depending on the mode and display type
const $122c41313e875e60$var$widthCoefficients = {
    mobile: 0.9,
    mobileGrid: 0.45,
    desktop: 0.48,
    borne: 0.6
};
const $122c41313e875e60$var$defaultTransitionDuration = '300ms';
const $122c41313e875e60$var$velocityBreakpoint = 0.5;
const $122c41313e875e60$var$Carousel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).forwardRef(({ direction: direction, history: history, draft: draft, grid: grid, gridTitle: gridTitle, forcedCurrentCard: forcedCurrentCard, setCarouselCardWidth: setCarouselCardWidth, setForcedCurrentCardInCarousel: setForcedCurrentCardInCarousel, children: children }, ref)=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const forceMobileView = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.forceMobileView);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const currentOrLastPlayedActivity = (0, $5FZWK.useSelector)((state)=>state.speechReducer.currentOrLastPlayedActivity);
    const swipingTimerRef = (0, $bxRTa.useRef)();
    const nbCards = (0, $bxRTa.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Children.count(children);
    }, [
        children
    ]);
    const gap = (0, $bxRTa.useMemo)(()=>{
        return isMobile ? 0.3 : 1;
    }, [
        currentDeviceType
    ]);
    const coefficient = (0, $bxRTa.useMemo)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                return history ? $122c41313e875e60$var$widthCoefficients.mobile : $122c41313e875e60$var$widthCoefficients.desktop;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                return history ? $122c41313e875e60$var$widthCoefficients.desktop : $122c41313e875e60$var$widthCoefficients.borne;
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                return grid ? $122c41313e875e60$var$widthCoefficients.mobileGrid : $122c41313e875e60$var$widthCoefficients.mobile;
            default:
                return $122c41313e875e60$var$widthCoefficients.mobileGrid;
        }
    }, [
        mode,
        currentDeviceType,
        grid
    ]);
    const [cardWidth, setCardWidth] = (0, $bxRTa.useState)(currentDeviceType === (0, $2rYkD.DeviceType).widget || forceMobileView ? 400 * coefficient : window.innerWidth * coefficient);
    const [cardHeight, setCardHeight] = (0, $bxRTa.useState)();
    const [currentCard, setCurrentCard] = (0, $bxRTa.useState)(0);
    const [currentPadding, setCurrentPadding] = (0, $bxRTa.useState)();
    const [translation, setTranslation] = (0, $bxRTa.useState)('');
    const [transitionDuration, setTransitionDuration] = (0, $bxRTa.useState)('1ms');
    const [gridTemplateColumn, setGridTemplateColumn] = (0, $bxRTa.useState)(direction !== 'vertical' ? `repeat(${nbCards}, ${cardWidth}px)` : '');
    const [gridTemplateRow, setGridTemplateRow] = (0, $bxRTa.useState)(direction === 'vertical' ? `repeat(${nbCards}, ${cardWidth * 10 / 16}px)` : '');
    const [enableTranslation, setEnableTranslation] = (0, $bxRTa.useState)(true);
    const [wheeling, setWheeling] = (0, $bxRTa.useState)(0);
    const divRef = (0, $bxRTa.useRef)(null);
    const timerRef = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(divRef);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                transform: 'translateX(0%)'
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        !draft && api.start({
            from: {
                transform: 'translateX(100%)'
            },
            to: {
                transform: `translateX(${nbCards === 1 ? '25%' : '0%'})`
            },
            config: {
                duration: $122c41313e875e60$var$springEnterDuration,
                easing: (0, $2aMjv.easings).easeInBack
            }
        });
    }, [
        draft,
        nbCards
    ]);
    (0, $bxRTa.useEffect)(()=>{
        handleClick(forcedCurrentCard || 0);
    }, [
        forcedCurrentCard
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setForcedCurrentCardInCarousel?.(currentCard);
    }, [
        currentCard
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setCarouselCardWidth?.(cardWidth);
    }, [
        cardWidth
    ]);
    /**
     * On cards container reference, mode / currentDeviceType states change :
     *  - calculate the cards' width depending on the coefficient
     *  - calculate the cards' height depending on the width (use a 16/10 format). Only used in vertical disposition
     *  - set the currentPadding state to have centered cards in horizontal disposition
     *  - set cardWidth, cardHeight and gridTemplateRow / gridTemplateColumn (depending on direction) states
     * On component unmount :
     *  - clear timeout
     */ (0, $bxRTa.useEffect)(()=>{
        if (dimensions) {
            let newCardWidth = Math.floor(dimensions.width * coefficient);
            // Get the number of pixels contained in 1 rem multiplicated by the gap, used with grid elements
            const gapInPx = gap * parseFloat(getComputedStyle(document.documentElement).fontSize);
            if (forceMobileView && newCardWidth > 400) {
                newCardWidth = 400;
                setCurrentPadding(grid ? (dimensions.width - newCardWidth * 2 - gapInPx) / 2 : currentDeviceType === (0, $2rYkD.DeviceType).landscape || currentDeviceType === (0, $2rYkD.DeviceType).widgetLandscape ? dimensions.width / 5 : (dimensions.width - newCardWidth - 5 * (nbCards - 1)) / 2);
                if (nbCards * newCardWidth < dimensions.width) setEnableTranslation(false);
            } else setCurrentPadding(grid ? (dimensions.width - newCardWidth * 2 - gapInPx) / 2 : currentDeviceType === (0, $2rYkD.DeviceType).landscape || currentDeviceType === (0, $2rYkD.DeviceType).widgetLandscape ? dimensions.width / 5 : (1 - coefficient) * dimensions.width / 2);
            const newCardHeight = Math.ceil(newCardWidth * 10 / 16);
            // Space needed to center to cards
            // Cards' width (all dispositions) and height (only used in vertical disposition)
            setCardWidth(newCardWidth);
            setCardHeight(newCardHeight);
            direction === 'vertical' ? setGridTemplateRow(`repeat(${nbCards}, ${newCardHeight}px)`) : setGridTemplateColumn(`repeat(${nbCards}, ${newCardWidth}px)`);
            setCurrentCard(0);
        }
        return ()=>timerRef && clearTimeout(timerRef.current);
    }, [
        dimensions,
        coefficient,
        nbCards,
        currentDeviceType,
        currentOrLastPlayedActivity?.id
    ]);
    /**
     * On currentCard, cardWidth, cardHeight, currentPadding states change :
     *  - set translation state depending on the direction
     */ (0, $bxRTa.useEffect)(()=>{
        if (currentCard !== undefined && cardWidth !== undefined && cardHeight !== undefined && currentPadding !== undefined) direction === 'vertical' ? setTranslation(`translateY(calc(-${currentCard * cardHeight}px - ${currentCard * gap}rem))`) : setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px))`);
    }, [
        currentCard,
        cardWidth,
        cardHeight,
        currentPadding
    ]);
    /**
     * On wheeling state change :
     *  - call either onSwipeRight or onSwipeLeft (with high values to enter the right part of the if condition), depending on the wheeling value (positive or negative)
     */ (0, $bxRTa.useEffect)(()=>{
        if (wheeling) wheeling > 0 ? onSwipeLeft(1000, 1000) : onSwipeRight(1000, 1000);
    }, [
        wheeling
    ]);
    /**
     * On call :
     *  - set translation to its initial state
     */ const resetPosition = ()=>{
        if (cardWidth !== undefined && currentPadding !== undefined) setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px))`);
    };
    /**
     * On call :
     *  - simulate a bounce effect by translating 1/10 of the width of a card in a sense, and then back
     * @param left : boolean
     */ const bounce = (left)=>{
        if (!cardWidth || currentPadding === undefined) return;
        setTransitionDuration($122c41313e875e60$var$defaultTransitionDuration);
        const direction = left ? '-' : '+';
        setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px ${direction} ${cardWidth / 10}px))`);
        if (timerRef && timerRef.current !== null) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px))`);
        }, 300);
    };
    /**
     * On call :
     *  - check if the current card is not already the last one
     *  - check the distance of the swipe, if it's higher than half a card's width, add 1 to currentCard state
     *  - check the velocity of the swipe, if it's higher than the limit, add 1 to currentCard state by 0.1 velocity over the limit, otherwise add 1
     * @param distance : number
     * @param elpasedTime : number
     */ const onSwipeLeft = (distance, elapsedTime)=>{
        // Utils store util to show that the user is swiping
        handleSwipingState();
        const velocity = Math.abs(distance / elapsedTime);
        setTransitionDuration($122c41313e875e60$var$defaultTransitionDuration);
        if (currentCard !== nbCards - 1 && cardWidth) {
            if (Math.abs(distance) > cardWidth / 2) setCurrentCard((card)=>card + 1);
            else {
                const velocityDifference = Math.round((velocity - $122c41313e875e60$var$velocityBreakpoint) * 10);
                const nextCard = currentCard + (velocityDifference > 0 ? velocityDifference : 1);
                setCurrentCard(nextCard < nbCards ? nextCard : nbCards - 1);
            }
        } else distance === 1000 && elapsedTime === 1000 ? bounce(true) : resetPosition();
    };
    /**
     * On call :
     *  - check if the current card is not already the first one
     *  - check the distance of the swipe, if it's higher than half a card's width, substract 1 from currentCard state
     *  - check the velocity of the swipe, if it's higher than the limit, substract 1 to currentCard state by 0.1 velocity over the limit, otherwise substract 1
     * @param distance : number
     * @param elpasedTime : number
     */ const onSwipeRight = (distance, elapsedTime)=>{
        // Utils store util to show that the user is swiping
        handleSwipingState();
        const velocity = Math.abs(distance / elapsedTime);
        setTransitionDuration($122c41313e875e60$var$defaultTransitionDuration);
        if (currentCard !== 0 && cardWidth) {
            if (Math.abs(distance) > cardWidth / 2) setCurrentCard((card)=>card - 1);
            else {
                const velocityDifference = Math.round((velocity - $122c41313e875e60$var$velocityBreakpoint) * 10);
                const nextCard = currentCard - (velocityDifference > 0 ? velocityDifference : 1);
                setCurrentCard(nextCard >= 0 ? nextCard : 0);
            }
        } else distance === 1000 && elapsedTime === 1000 ? bounce() : resetPosition();
    };
    /**
     * On call :
     *  - check if the translation is available (inside allowed bounds)
     *  - if available, set transitionDuration state to '0ms' and then update translation state to the default distance - received distance param
     * @param distance : number
     */ const onSwiping = (distance)=>{
        const available = currentCard === 0 || currentCard === nbCards - 1 ? checkSwipingAvailable(distance, gap) : true;
        if (cardWidth !== undefined) {
            setTransitionDuration('0ms');
            if (available) {
                if (currentCard !== undefined && cardHeight !== undefined && currentPadding !== undefined) setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px - ${distance}px))`);
            } else {
                const bounceLimit = cardWidth / 3;
                if (Math.abs(distance) <= bounceLimit / 2) setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px - ${distance * (1 - Math.abs(distance) / bounceLimit)}px))`);
            }
        }
    };
    /**
     * On call :
     *  - calculate the max length allowed
     *  - calculate the future length depending on the distance
     *  - check if the future length is inside the available bounds and return a boolean
     * @param distance : number
     * @param gap : number
     * @returns boolean
     */ const checkSwipingAvailable = (distance, gap)=>{
        if (currentCard !== undefined && cardWidth && currentPadding) {
            const maxLength = (nbCards - 1) * cardWidth + (nbCards - 1) * gap + currentPadding;
            const currentLength = currentCard * cardWidth + currentCard * gap * parseFloat(getComputedStyle(document.documentElement).fontSize) + currentPadding + distance;
            return !(currentLength < currentPadding || currentLength > maxLength);
        }
        return false;
    };
    /**
     * On call :
     *  - call onSwipeLeft method
     * @param distance : number
     */ const onSwipeTop = (distance, elapsedTime)=>{
        onSwipeLeft(distance, elapsedTime);
    };
    /**
     * On call :
     *  - call onSwipeRight method
     * @param distance : number
     */ const onSwipeBottom = (distance, elapsedTime)=>{
        onSwipeRight(distance, elapsedTime);
    };
    /**
     * On click event fire :
     *  - set transitionDuration state to default value
     *  - update currentCard state with the key parameter
     * @param key : number
     */ const handleClick = (key)=>{
        // Utils store util to show that the user is swiping
        handleSwipingState();
        setTransitionDuration($122c41313e875e60$var$defaultTransitionDuration);
        setCurrentCard(key);
    };
    /**
     * On wheel event fire :
     *  - check which axis has been triggered (x or y) to get its value
     *  - set wheeling state to a positive or negative unique value (here Date.now() is used as unique)
     * @param delta : number
     */ const handleWheel = (delta)=>{
        if (delta !== undefined) {
            // Utils store util to show that the user is swiping
            handleSwipingState();
            setWheeling(delta > 0 ? Date.now() : -Date.now());
        }
    };
    const handleSwipingState = ()=>{
        swipingTimerRef.current && clearTimeout(swipingTimerRef.current);
        dispatch((0, $cto9a.storeActions).utils.setUserSwiping(true));
        swipingTimerRef.current = setTimeout(()=>{
            dispatch((0, $cto9a.storeActions).utils.setUserSwiping(false));
        }, 2500);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            gridTitle && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full rf-text-left rf-title-large-size-auto ${mode === (0, $2rYkD.Mode).vocal ? 'rf-text-truewhite rf-text-shadow-black' : 'rf-text-textModePanelConversationBot'}`,
                style: {
                    paddingLeft: currentPadding
                },
                children: gridTitle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
                ref: divRef,
                className: "rf-w-full rf-flex rf-flex-col",
                style: {
                    visibility: draft ? 'hidden' : 'visible',
                    pointerEvents: 'all',
                    ...spring
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fEfdX.default), {
                        className: "rf-w-full",
                        handleWheel: handleWheel,
                        xAxisOnly: true,
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $o9qp2.default), {
                            direction: direction || 'horizontal',
                            onSwiping: onSwiping,
                            onSwipeLeft: onSwipeLeft,
                            onSwipeRight: onSwipeRight,
                            onSwipeTop: onSwipeTop,
                            onSwipeBottom: onSwipeBottom,
                            className: direction === 'vertical' ? 'rf-flex rf-justify-center' : !isMobile ? history ? 'rf-opacity-gradient-l-thin' : 'rf-opacity-gradient-l' : '',
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                ref: ref,
                                className: `rf-relative ${direction === 'vertical' ? 'rf-h-max' : 'rf-w-max'} ${enableTranslation ? '' : 'rf-m-auto'} rf-transition-transform`,
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: direction === 'vertical' ? `${cardWidth}px` : gridTemplateColumn,
                                    gridTemplateRows: gridTemplateRow,
                                    gap: isMobile ? '0.3rem' : '1rem',
                                    transitionTimingFunction: 'linear',
                                    transitionDuration: transitionDuration,
                                    transform: enableTranslation ? translation : ''
                                },
                                children: children
                            })
                        })
                    }),
                    !draft && nbCards > 1 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-full rf-py-3 rf-flex rf-flex-row rf-justify-center rf-gap-1",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Children.map(children, (_child, key)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                                className: `rf-w-3 rf-h-3 rf-border rf-border-trueblack rf-rounded-half ${key === currentCard ? 'rf-bg-primary' : 'rf-bg-truewhite'}`,
                                onClick: ()=>handleClick(key)
                            }, key);
                        })
                    })
                ]
            })
        ]
    });
});
var $122c41313e875e60$export$2e2bcd8739ae039 = $122c41313e875e60$var$Carousel;

});

parcelRegister("bFo6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4903addc9e983b3$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
var $dH58k = parcelRequire("dH58k");
const $a4903addc9e983b3$var$remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
// Width of one item in the search bar plus the gap between items, smaller in mobile mode
const $a4903addc9e983b3$var$itemWidthForMobile = 2.5 * $a4903addc9e983b3$var$remToPx;
const $a4903addc9e983b3$var$itemWidthForLarge = 3.5 * $a4903addc9e983b3$var$remToPx;
const $a4903addc9e983b3$var$SearchBar = ({ elements: elements, elementsByCard: elementsByCard, carouselCardWidth: carouselCardWidth, setCardToShow: setCardToShow })=>{
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const [firstOfEachLetter, setFirstOfEachLetter] = (0, $bxRTa.useState)(new Map());
    const [initialsArray, setInitialsArray] = (0, $bxRTa.useState)([]);
    const [paginatedInitialsArray, setPaginatedInitialsArray] = (0, $bxRTa.useState)([]);
    const [paginationIndex, setPaginationIndex] = (0, $bxRTa.useState)(0);
    const [selectedInitial, setSelectedInitial] = (0, $bxRTa.useState)(undefined);
    const currentPaginatedInitialsArray = (0, $bxRTa.useMemo)(()=>{
        return paginatedInitialsArray[paginationIndex];
    }, [
        paginatedInitialsArray,
        paginationIndex
    ]);
    (0, $bxRTa.useEffect)(()=>{
        const tempFirstOfEachLetter = new Map();
        const tempInitialsArray = [];
        for(let i = 0; i < elements.length; i++){
            const initial = elements[i].group?.toLocaleUpperCase(locale);
            if (initial && tempFirstOfEachLetter.get(initial) === undefined) {
                tempFirstOfEachLetter.set(initial, Math.floor(i / elementsByCard));
                tempInitialsArray.push(initial);
            }
        }
        setFirstOfEachLetter(tempFirstOfEachLetter);
        setInitialsArray(tempInitialsArray);
    }, [
        elements
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (initialsArray.length && carouselCardWidth) {
            const nbMaxElements = carouselCardWidth / (isMobile ? $a4903addc9e983b3$var$itemWidthForMobile : $a4903addc9e983b3$var$itemWidthForLarge);
            if (nbMaxElements < initialsArray.length) {
                const tempArray = [];
                // Remove 2 from the length for previous / next items
                for(let i = 0; i < initialsArray.length; i += nbMaxElements - 2)tempArray.push(initialsArray.slice(i, Math.min(i + nbMaxElements - 2, initialsArray.length)));
                setPaginatedInitialsArray(tempArray);
            } else setPaginatedInitialsArray([
                initialsArray
            ]);
        }
    }, [
        initialsArray,
        carouselCardWidth,
        isMobile
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setCardToShow(selectedInitial ? firstOfEachLetter.get(selectedInitial) || 0 : 0);
    }, [
        selectedInitial
    ]);
    const handleChangePagination = (getBack)=>{
        getBack ? setPaginationIndex((value)=>value - 1) : setPaginationIndex((value)=>value + 1);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-h-7 large:rf-h-10 rf-px-4 rf-flex rf-flex-row rf-justify-center rf-items-center rf-gap-3",
        children: [
            paginatedInitialsArray.length > 1 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-h-full rf-aspect-square rf-flex rf-justify-center rf-items-center rf-bg-cardFrameBackground rf-border rf-rounded ${paginationIndex === 0 ? 'rf-border-lightgray' : 'rf-border-cardButtonBorderDefault'}`,
                onClick: paginationIndex === 0 ? ()=>{} : ()=>handleChangePagination(true),
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                    className: "rf-h-5 large:rf-h-6",
                    color: paginationIndex === 0 ? '#818181' : themeColors.card.button.text.default
                })
            }),
            currentPaginatedInitialsArray?.map((value, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                    className: `rf-h-full rf-aspect-square rf-flex rf-justify-center rf-items-center ${selectedInitial === value ? 'rf-card-button-mini-selected' : 'rf-card-button-mini'}`,
                    onClick: ()=>setSelectedInitial(selectedInitial === value ? undefined : value),
                    children: value
                }, key);
            }),
            paginatedInitialsArray.length > 1 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-h-full rf-aspect-square rf-flex rf-justify-center rf-items-center rf-bg-cardFrameBackground rf-border rf-rounded ${paginationIndex === paginatedInitialsArray.length - 1 ? 'rf-border-lightgray' : 'rf-border-cardButtonBorderDefault'}`,
                onClick: paginationIndex === paginatedInitialsArray.length - 1 ? ()=>{} : ()=>handleChangePagination(false),
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dH58k.default), {
                    className: "rf-h-5 large:rf-h-6",
                    color: paginationIndex === paginatedInitialsArray.length - 1 ? '#818181' : themeColors.card.button.text.default
                })
            })
        ]
    });
};
var $a4903addc9e983b3$export$2e2bcd8739ae039 = $a4903addc9e983b3$var$SearchBar;

});


parcelRegister("ejd1L", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b0d268fd72626a8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $8HSQQ = parcelRequire("8HSQQ");

var $9GMhE = parcelRequire("9GMhE");

var $faFQF = parcelRequire("faFQF");
const $3b0d268fd72626a8$var$TemplateGrid = ({ title: title, attachments: attachments, history: history, triggerScroll: triggerScroll })=>{
    const [qrCodeDataUrl, setQrCodeDataUrl] = (0, $bxRTa.useState)(undefined);
    const processedAttachments = (0, $bxRTa.useMemo)(()=>{
        let tempAttachments = [
            ...attachments
        ];
        tempAttachments = tempAttachments.sort((a, b)=>a.content.index - b.content.index);
        return tempAttachments;
    }, [
        attachments
    ]);
    (0, $bxRTa.useEffect)(()=>{
        triggerScroll?.();
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $faFQF.default), {
        title: title,
        history: history,
        qrCodeDataUrl: qrCodeDataUrl,
        setQrCodeDataUrl: setQrCodeDataUrl,
        children: processedAttachments.map((attachment, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9GMhE.default), {
                className: "rf-w-full",
                shadow: true,
                children: (0, $8HSQQ.default)({
                    attachment: attachment,
                    history: history,
                    setQrCodeData: setQrCodeDataUrl
                })
            }, key);
        })
    });
};
var $3b0d268fd72626a8$export$2e2bcd8739ae039 = $3b0d268fd72626a8$var$TemplateGrid;

});
parcelRegister("faFQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea60708ef658ee6$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $7QU6k = parcelRequire("7QU6k");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $lOuaH = parcelRequire("lOuaH");

var $2rYkD = parcelRequire("2rYkD");

var $8e5cw = parcelRequire("8e5cw");

var $9TTQJ = parcelRequire("9TTQJ");
parcelRequire("d72S7");
var $cUlNP = parcelRequire("cUlNP");
const $7ea60708ef658ee6$var$springQrCodeDuration = 500;
const $7ea60708ef658ee6$var$Grid = ({ title: title, history: history, qrCodeDataUrl: qrCodeDataUrl, setQrCodeDataUrl: setQrCodeDataUrl, children: children })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isLandscape);
    const mainWidth = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentWidth);
    const mainHeight = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentHeight);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const clickedOnUI = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.clickedOnUI);
    const useOldRemote = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.useOldRemote);
    const [classname, setClassname] = (0, $bxRTa.useState)('');
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)(undefined);
    const fadeInTimerRef = (0, $bxRTa.useRef)(null);
    const gridContainerRef = (0, $bxRTa.useRef)(null);
    const gridContainerDimensions = (0, $lOuaH.default)(gridContainerRef);
    const nbCards = (0, $bxRTa.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Children.count(children);
    }, [
        children
    ]);
    const rowGap = (0, $bxRTa.useMemo)(()=>{
        return gridContainerDimensions.width * 0.035;
    }, [
        gridContainerDimensions.width
    ]);
    const maxHeight = (0, $bxRTa.useMemo)(()=>{
        // 0.58 quite equals 7/12. This ratio prevents the container from overflowing vertically
        return mainHeight * 0.58;
    }, [
        mainHeight
    ]);
    const newMaxHeight = (0, $bxRTa.useMemo)(()=>{
        if (mode === (0, $2rYkD.Mode).vocal) {
            // Base positions of container on the grid are 3 -> 11 for landscape and 6 -> 11 for borne
            let start = isLandscape ? 3 : 6;
            let end = 11;
            if (typeof configuration.answerpanel === 'object') {
                start = isLandscape ? configuration.answerpanel.landscape?.containerRowStart || 3 : configuration.answerpanel.borne?.containerRowStart || 6;
                end = isLandscape ? configuration.answerpanel.landscape?.containerRowEnd || 11 : configuration.answerpanel.borne?.containerRowEnd || 11;
            }
            return 0.75 * mainHeight * (end - start) / 12;
        } else {
            // Base positions of container on the grid are 1 -> 11 for landscape and 6 -> 13 for borne
            let start = isLandscape ? 1 : 6;
            let end = isLandscape ? 11 : 13;
            if (typeof configuration.answerpanel === 'object') {
                start = isLandscape ? configuration.answerpanel.landscape?.containerRowStartText || 1 : configuration.answerpanel.borne?.containerRowStart || 6;
                end = isLandscape ? configuration.answerpanel.landscape?.containerRowEndText || 11 : configuration.answerpanel.borne?.containerRowEnd || 13;
            }
            return 0.75 * mainHeight * (end - start) / 12;
        }
    }, [
        mainHeight,
        isLandscape,
        mode,
        configuration.answerpanel
    ]);
    const [qrCodeSpring, qrCodeApi] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        qrCodeData && qrCodeApi.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $7ea60708ef658ee6$var$springQrCodeDuration
            }
        });
        return ()=>{
            fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        };
    }, [
        qrCodeData
    ]);
    const handleCloseQrCode = ()=>{
        qrCodeApi.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $7ea60708ef658ee6$var$springQrCodeDuration
            }
        });
        fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        fadeInTimerRef.current = setTimeout(()=>{
            setQrCodeDataUrl?.(undefined);
        }, $7ea60708ef658ee6$var$springQrCodeDuration);
    };
    const setQrCodeDataAsync = async (url)=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(url);
        setQrCodeData(qrCodeString);
    };
    (0, $bxRTa.useEffect)(()=>{
        qrCodeDataUrl ? setQrCodeDataAsync(qrCodeDataUrl) : setQrCodeData(undefined);
    }, [
        qrCodeDataUrl
    ]);
    (0, $bxRTa.useEffect)(()=>{
        // Close qrcode overlay if we click on another part of the UI
        if (clickedOnUI !== (0, $2rYkD.UIPart).none && clickedOnUI !== (0, $2rYkD.UIPart).card && clickedOnUI !== (0, $2rYkD.UIPart).qroverlay && qrCodeData) handleCloseQrCode();
    }, [
        clickedOnUI,
        qrCodeData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(nbCards){
            case 1:
            case 2:
                setClassname('rf-grid-cols-[repeat(2,30%)] rf-grid-rows-1');
                break;
            case 3:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? 'rf-grid-cols-[repeat(3,31%)] rf-grid-rows-1' : 'rf-grid-cols-[repeat(2,45%)] rf-grid-rows-2');
                break;
            case 4:
                setClassname('rf-grid-cols-[repeat(2,30%)] rf-grid-rows-2');
                break;
            case 5:
            case 6:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? 'rf-grid-cols-[repeat(3,31%)] rf-grid-rows-2' : 'rf-grid-cols-[repeat(2,45%)] rf-grid-rows-3');
                break;
            case 7:
            case 8:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? 'rf-grid-cols-[repeat(3,31%)] rf-grid-rows-3' : 'rf-grid-cols-[repeat(2,45%)] rf-grid-rows-4');
                break;
            case 9:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? 'rf-grid-cols-[repeat(3,31%)] rf-grid-rows-3' : 'rf-grid-cols-[repeat(2,45%)] rf-grid-rows-5');
                break;
            default:
                break;
        }
    }, [
        nbCards,
        mainWidth,
        mainHeight
    ]);
    const handleClick = (e)=>{
        dispatch((0, $cto9a.storeActions).utils.setClickedOnUI((0, $2rYkD.UIPart).qroverlay));
        e.stopPropagation();
        e.preventDefault();
    };
    return nbCards ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-grid",
        dir: isRTL ? 'rtl' : 'ltr',
        className: `rf-w-full rf-flex rf-flex-col rf-gap-4 vertical:rf-w-9/10 ${history ? 'large-vertical:rf-w-full' : 'landscape-retorik:rf-pr-40 landscape-retorik:rf-pl-1/5 large-vertical:rf-w-3/5'} vertical:rf-items-center`,
        children: [
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full ${isRTL ? 'rf-text-right' : 'rf-text-left'} rf-title-large-size-auto ${history ? 'rf-text-textModePanelConversationBot' : 'rf-text-truewhite rf-text-shadow-black'}`,
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                ref: gridContainerRef,
                className: `rf-relative rf-w-full rf-grid rf-justify-center rf-gap-x-[3.5%] ${classname}`,
                style: {
                    maxHeight: history || mainHeight > mainWidth ? 'none' : useOldRemote ? maxHeight : newMaxHeight,
                    rowGap: rowGap
                },
                children: [
                    children,
                    qrCodeData && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
                        className: "rf-absolute rf-h-full rf-w-full rf-top-0 rf-left-0 rf-z-ui rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2 rf-p-2 rf-text-truewhite",
                        style: {
                            background: 'rgba(18,18,18,0.7)',
                            ...qrCodeSpring
                        },
                        onClick: (e)=>handleClick(e),
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                                onClick: handleCloseQrCode,
                                showLabel: false
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                                className: "rf-px-8 rf-pb-4 rf-flex rf-flex-row rf-items-center rf-gap-1 rf-italic",
                                children: [
                                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cUlNP.default), {
                                        color: "#FFF"
                                    }),
                                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                        className: "rf-w-fit rf-text-medium-size-auto",
                                        children: translation.link.scanQRTile
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                                src: qrCodeData,
                                largeMaxHeight: true
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $7ea60708ef658ee6$export$2e2bcd8739ae039 = $7ea60708ef658ee6$var$Grid;

});



parcelRegister("b5pvk", function(module, exports) {
module.exports = $parcel$import("6NCfb").then(()=>parcelRequire('cyTMj'));

});

parcelRegister("5vqr0", function(module, exports) {
module.exports = $parcel$import("9GKrX").then(()=>parcelRequire('bukVV'));

});

parcelRegister("f4HPR", function(module, exports) {
module.exports = $parcel$import("k0VAd").then(()=>parcelRequire('7V9hq'));

});

parcelRegister("iFNHz", function(module, exports) {
module.exports = $parcel$import("iTlMv").then(()=>parcelRequire('j1wAI'));

});

parcelRegister("VHvle", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("hvc5r"),
    $parcel$import("aSHJY")
]).then(()=>parcelRequire('7JsuT'));

});

parcelRegister("6JZzf", function(module, exports) {
module.exports = $parcel$import("dqy4I").then(()=>parcelRequire('6C05u'));

});

parcelRegister("6BMly", function(module, exports) {
module.exports = $parcel$import("dDfpQ").then(()=>parcelRequire('hB7tv'));

});

parcelRegister("7EPOg", function(module, exports) {
module.exports = $parcel$import("7ySv0").then(()=>parcelRequire('kNS3B'));

});

parcelRegister("6hEoY", function(module, exports) {

$parcel$export(module.exports, "createNewQuestionForTimestamp", () => $ade47506c8567b6f$export$190bd3f548d0449);
const $ade47506c8567b6f$export$190bd3f548d0449 = (activity)=>{
    // Get answer's timestamp or create a new one if none present
    const timestamp = activity.localTimestamp || activity.timestamp || Date.now().toString();
    const newQuestion = {
        id: activity.replyToId || activity.id,
        type: 'message',
        text: '',
        channelData: {
            'webchat:sequence-id': 1
        },
        timestamp: timestamp,
        localTimestamp: timestamp,
        from: {
            id: 'user',
            role: 'user'
        }
    };
    return newQuestion;
};

});

parcelRegister("3Gcj3", function(module, exports) {

$parcel$export(module.exports, "getTextWithoutSpeechMarkdown", () => $d36b698e2bfea73e$export$d6c6ec86eedacfd9);
$parcel$export(module.exports, "replaceSpeechMarkdownTags", () => $d36b698e2bfea73e$export$f355fac925ad880f);

var $fb1tF = parcelRequire("fb1tF");
const $d36b698e2bfea73e$var$speechMarkdownParser = new (0, $fb1tF.SpeechMarkdown)();
const $d36b698e2bfea73e$export$d6c6ec86eedacfd9 = (text, speechMarkdownTagsPosition = [])=>{
    let res = '';
    // Myna parser used in speechmarkdown parsing can't deal with dashes which aren't in speechmarkdown tags properly.
    // Let's change them and put them back after treatment
    if (text.indexOf('-') !== -1) {
        const dashesOutsideSpeechmarkdown = [];
        for(let i = 0; i < text.length; i++)if (text[i] === '-') {
            let test = true;
            speechMarkdownTagsPosition.forEach((position)=>{
                if (i === position[0] || i === position[1] || i > position[0] && i < position[1]) test = false;
            });
            test && dashesOutsideSpeechmarkdown.push(i);
        }
        let textWithoutDashes = '';
        if (dashesOutsideSpeechmarkdown.length > 0) {
            for(let i = 0; i < dashesOutsideSpeechmarkdown.length; i++){
                textWithoutDashes += i === 0 ? text.substring(0, dashesOutsideSpeechmarkdown[i]) : text.substring(dashesOutsideSpeechmarkdown[i - 1] + 1, dashesOutsideSpeechmarkdown[i]);
                textWithoutDashes += '1xx1';
            }
            // Add the rest of the text (after the last dash)
            textWithoutDashes += text.substring(dashesOutsideSpeechmarkdown[dashesOutsideSpeechmarkdown.length - 1] + 1);
        }
        res = $d36b698e2bfea73e$var$speechMarkdownParser.toText(textWithoutDashes);
        res = res.replaceAll('1xx1', '-');
    } else res = $d36b698e2bfea73e$var$speechMarkdownParser.toText(text);
    // Remove phoneme tag
    res = res.replaceAll(/<\/?phoneme?[^>]+>|$/g, '');
    return res;
};
const $d36b698e2bfea73e$export$f355fac925ad880f = (text)=>{
    const replacements = [];
    let textWithReplacements = text;
    // Get the indexes of all the occurences of ')['
    let indexes = [];
    let position = text.indexOf(')[');
    while(position !== -1){
        indexes.push(position);
        position = text.indexOf(')[', position + 1);
    }
    // If at least one occurence has been found escape all characters related
    if (indexes.length > 0) // Loop on indexes to get all indexes
    for(let i = 0; i < indexes.length; i++){
        // Get the opening parenthesis related to the closing one from the expression
        const openingParenthesisIndex = $d36b698e2bfea73e$var$getOpeningParenthesis(text, indexes[i]);
        // Get the closing bracket related to the opening one from the expression
        const closingBracketIndex = text.substring(indexes[i]).indexOf(']') + indexes[i];
        const replacement = {
            // Use string for replacement as : 'replacement1x1'
            replacementString: `replacement${i}x${i}`,
            speechMarkdown: text.substring(openingParenthesisIndex, closingBracketIndex + 1)
        };
        replacements.push(replacement);
        textWithReplacements = textWithReplacements.replace(replacement.speechMarkdown, replacement.replacementString);
    }
    // In markdown links can be found as [...](...) so we need to find data between brackets without parentheses related to the closing bracket. Example : 'Hello. [1s] How are you ?'
    // Reset indexes array and set basic text to textWithReplacements to prevent searching again for brackets that have already been removed
    indexes = [];
    const tempText = textWithReplacements;
    position = tempText.indexOf(']');
    while(position !== -1){
        indexes.push(position);
        position = tempText.indexOf(']', position + 1);
    }
    if (indexes.length > 0) {
        for(let i = 0; i < indexes.length; i++)// If the index is the last character of the string, or if the next character isn't an opening parenthesis, it's ok
        if (indexes[i] === tempText.length - 1 || tempText.charAt(indexes[i] + 1) !== '(') {
            // Find the position of the previous opening bracket
            const openingBracketIndex = tempText.substring(0, indexes[i]).lastIndexOf('[');
            const replacement = {
                // Use string for replacement as : 'pause1x1'
                replacementString: `pause${i}x${i}`,
                speechMarkdown: tempText.substring(openingBracketIndex, indexes[i] + 1)
            };
            replacements.push(replacement);
            textWithReplacements = textWithReplacements.replace(replacement.speechMarkdown, replacement.replacementString);
        }
    }
    return {
        text: textWithReplacements,
        replacements: replacements
    };
};
const $d36b698e2bfea73e$var$getOpeningParenthesis = (text, index)=>{
    let nbOpeningParenthesis = 0;
    let nbClosingParenthesis = 0;
    // Search from the end of the string for an equivalence between opening and ending parenthesis, to prevent error if the text to be
    // spoken contains parenthesis.
    for(let i = index; i > 0; i--){
        if (text.charAt(i) === ')') nbClosingParenthesis++;
        else if (text.charAt(i) === '(') {
            nbOpeningParenthesis++;
            if (nbClosingParenthesis === nbOpeningParenthesis) return i;
        }
    }
    return 0;
};

});
parcelRegister("fb1tF", function(module, exports) {

$parcel$export(module.exports, "SpeechMarkdown", () => $b0c9077b7a60729e$export$fdd03b388331c324);
class $b0c9077b7a60729e$var$je {
    constructor(e){
        this.options = e, this.options = e;
    }
    // Adds each element of the array as markdown
    addArray(e, t) {
        for (const i of e)this.formatFromAst(i, t);
        return t;
    }
    processAst(e, t) {
        e instanceof Array ? this.addArray(e, t) : this.formatFromAst(e, t);
    }
}
class $b0c9077b7a60729e$var$Ne extends $b0c9077b7a60729e$var$je {
    constructor(e){
        super(e), this.options = e;
    }
    format(e) {
        let i = this.formatFromAst(e, []).join("").trim();
        return i = i.replace(/  +/g, " "), i;
    }
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.processAst(e.children, t), t;
            case "paragraph":
                return this.processAst(e.children, t), t;
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                return t.push(e.allText), t;
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$S {
    constructor(e){
        this.base = e, this.tags = {}, this.text = "";
    }
    tag(e, t, i = !1, r = this.base.ssmlTagSortOrder) {
        const s = r.indexOf(e);
        this.tags[e] || (this.tags[e] = {
            sortId: s,
            attrs: null
        }), i ? this.tags[e].attrs = {
            ...this.tags[e].attrs,
            ...t
        } : this.tags[e].attrs = t;
    }
    voiceTagNamed(e, t) {
        let i = e && e[t];
        return i ? (typeof i != "object" && (i = {
            voice: {
                name: t
            }
        }), Object.keys(i).forEach((r)=>{
            const s = i[r];
            this.tag(r, s);
        }), !0) : !1;
    }
    voiceTag(e, t) {
        const i = this.base.sentenceCase(t || "device");
        this.voiceTagNamed(this.base.options && this.base.options.voices, i) || this.voiceTagNamed(this.base.validVoices, i);
    }
}
const $b0c9077b7a60729e$var$w = class w extends $b0c9077b7a60729e$var$je {
    constructor(e){
        super(e), this.options = e, this.sectionTags = [], this.modifierKeyMappings = {
            chars: "characters",
            cardinal: "number",
            digits: "characters",
            bleep: "expletive",
            phone: "telephone",
            vol: "volume"
        }, this.ssmlTagSortOrder = [
            "emphasis",
            "say-as",
            "prosody",
            "amazon:domain",
            "amazon:effect",
            "amazon:emotion",
            "voice",
            "lang",
            "sub",
            "phoneme"
        ], this.modifierKeyToSsmlTagMappings = {
            emphasis: "emphasis",
            address: "say-as",
            number: "say-as",
            characters: "say-as",
            expletive: "say-as",
            fraction: "say-as",
            interjection: "say-as",
            ordinal: "say-as",
            telephone: "say-as",
            unit: "say-as",
            time: "say-as",
            date: "say-as",
            whisper: null,
            sub: "sub",
            ipa: "phoneme",
            rate: "prosody",
            pitch: "prosody",
            volume: "prosody",
            drc: null,
            timbre: null,
            lang: null,
            voice: null,
            dj: null,
            defaults: null,
            newscaster: null,
            excited: null,
            disappointed: null
        };
    }
    format(e) {
        return this.formatFromAst(e, []).join("");
    }
    addSectionStartTag(e, t, i) {
        this.sectionTags = [
            ...e
        ].reverse();
        for(let r = 0; r < e.length; r++){
            const s = e[r], o = t.tags[s].attrs;
            i.push(`
`), i.push(this.startTag(s, o, !1));
        }
    }
    addSectionEndTag(e) {
        if (this.sectionTags.length > 0) for(let t = 0; t < this.sectionTags.length; t++){
            const i = this.sectionTags[t];
            e.push(this.endTag(i, !1)), e.push(`
`);
        }
    }
    // Adds tagged content
    addTag(e, t, i, r, s, o) {
        return o.push(this.startTag(e, s, i)), this.processAst(t, o), o.push(this.endTag(e, i)), r && o.push(`
`), o;
    }
    addSpeakTag(e, t, i, r, s) {
        return s.push(this.startTag("speak", r, t)), this.processAst(e, s), this.addSectionEndTag(s), s.push(this.endTag("speak", t)), i && s.push(`
`), s;
    }
    addComment(e, t) {
        return t.push(`<!-- ${e} -->
`), t;
    }
    // Returns the SSML for a start tag
    startTag(e, t, i = !1) {
        let r = "";
        return t && (r = " " + Object.keys(t).map((s)=>s + '="' + t[s] + '"').join(" ")), "<" + e + r + ">" + (i ? `
` : "");
    }
    // Returns the SSML for an end tag
    endTag(e, t = !1) {
        return (t ? `
` : "") + "</" + e + ">";
    }
    voidTag(e, t) {
        let i = "";
        return t && (i = " " + Object.keys(t).map((r)=>r + '="' + t[r] + '"').join(" ")), "<" + e + i + "/>";
    }
    addTagWithAttrs(e, t, i, r, s = !1) {
        return t || s ? (e.push(this.startTag(i, r)), t && e.push(t), e.push(this.endTag(i, !1))) : e.push(this.voidTag(i, r)), e;
    }
    getTagWithAttrs(e, t, i) {
        let r = [];
        return e ? (r.push(this.startTag(t, i)), r.push(e), r.push(this.endTag(t, !1))) : r.push(this.voidTag(t, i)), r.join("");
    }
    sentenceCase(e) {
        return e.replace(/[a-z]/i, (t)=>t.toUpperCase()).trim();
    }
    escapeXmlCharacters(e) {
        let t = `${Object.keys(w.XML_UNESCAPE_MAPPING).join("|")}]`, i = e.replace(new RegExp(t, "g"), (o)=>w.XML_UNESCAPE_MAPPING[o]), r = `[${Object.keys(w.XML_ESCAPE_MAPPING).join("")}]`;
        return i.replace(new RegExp(r, "g"), (o)=>w.XML_ESCAPE_MAPPING[o]);
    }
};
$b0c9077b7a60729e$var$w.XML_ESCAPE_MAPPING = {
    "<": "&lt;",
    ">": "&gt;",
    "&": "&amp;",
    '"': "&quot;",
    "'": "&apos;"
}, $b0c9077b7a60729e$var$w.XML_UNESCAPE_MAPPING = function(t) {
    return Object.keys(t).reduce((i, r)=>(i[t[r]] = r, i), {});
}($b0c9077b7a60729e$var$w.XML_ESCAPE_MAPPING);
let $b0c9077b7a60729e$var$L = $b0c9077b7a60729e$var$w;
class $b0c9077b7a60729e$var$He extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.validVoices = {
            Ivy: "en-US",
            Joanna: "en-US",
            Joey: "en-US",
            Justin: "en-US",
            Kendra: "en-US",
            Kimberly: "en-US",
            Matthew: "en-US",
            Salli: "en-US",
            Nicole: "en-AU",
            Russell: "en-AU",
            Amy: "en-GB",
            Brian: "en-GB",
            Emma: "en-GB",
            Aditi: "en-IN",
            Raveena: "en-IN",
            Hans: "de-DE",
            Marlene: "de-DE",
            Vicki: "de-DE",
            Conchita: "es-ES",
            Enrique: "es-ES",
            Carla: "it-IT",
            Giorgio: "it-IT",
            Mizuki: "ja-JP",
            Takumi: "ja-JP",
            Celine: "fr-FR",
            Lea: "fr-FR",
            Mathieu: "fr-FR"
        }, this.validEmotionIntensity = [
            "low",
            "medium",
            "high"
        ], this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.voice = "voice", this.modifierKeyToSsmlTagMappings.dj = "amazon:domain", this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain", this.modifierKeyToSsmlTagMappings.excited = "amazon:emotion", this.modifierKeyToSsmlTagMappings.disappointed = "amazon:emotion";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            case "emphasis":
                                t.tag(l, {
                                    level: o || "moderate"
                                });
                                break;
                            case "address":
                            case "characters":
                            case "expletive":
                            case "fraction":
                            case "interjection":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                t.tag(l, {
                                    "interpret-as": s
                                });
                                break;
                            case "date":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "ymd"
                                });
                                break;
                            case "time":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "hms12"
                                });
                                break;
                            case "whisper":
                                t.tag(l, {
                                    name: "whispered"
                                });
                                break;
                            case "ipa":
                                t.tag(l, {
                                    alphabet: s,
                                    ph: o
                                });
                                break;
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0);
                                    break;
                                }
                            case "lang":
                                t.tag(l, {
                                    "xml:lang": o
                                });
                                break;
                            case "voice":
                                t.voiceTag(s, o);
                                break;
                            case "excited":
                            case "disappointed":
                                {
                                    const d = (o || "medium").toLowerCase();
                                    if (this.validEmotionIntensity.includes(d)) {
                                        t.tag(l, {
                                            name: s,
                                            intensity: d
                                        });
                                        break;
                                    }
                                    break;
                                }
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            if (r.name === "sectionModifierKeyOptionalValue") {
                let s = r.children[0].allText;
                const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                switch(s){
                    case "lang":
                        t.tag(l, {
                            "xml:lang": o
                        });
                        break;
                    case "voice":
                        t.voiceTag(s, o);
                        break;
                    case "dj":
                        t.tag(l, {
                            name: "music"
                        });
                        break;
                    case "newscaster":
                        t.tag(l, {
                            name: "news"
                        });
                        break;
                    case "defaults":
                        break;
                    case "excited":
                    case "disappointed":
                        {
                            const d = (o || "medium").toLowerCase();
                            if (this.validEmotionIntensity.includes(d)) {
                                t.tag(l, {
                                    name: s,
                                    intensity: d
                                });
                                break;
                            }
                            break;
                        }
                }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "shortEmphasisModerate":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "moderate"
                    });
                }
            case "shortEmphasisStrong":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "strong"
                    });
                }
            case "shortEmphasisNone":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "none"
                    });
                }
            case "shortEmphasisReduced":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "reduced"
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e), r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "section":
                {
                    const i = this.getSectionObject(e), r = Object.keys(i.tags).sort((s, o)=>i.tags[s].sortId - i.tags[o].sortId);
                    return this.addSectionEndTag(t), this.addSectionStartTag(r, i, t), t;
                }
            case "audio":
                {
                    const i = e.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(t, null, "audio", {
                        src: i
                    });
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
                {
                    let i = this.options.escapeXmlSymbols ? this.escapeXmlCharacters(e.allText) : e.allText;
                    return t.push(i), t;
                }
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$Ze extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect", this.modifierKeyToSsmlTagMappings.timbre = "amazon:effect", this.modifierKeyToSsmlTagMappings.cardinal = "say-as", this.modifierKeyToSsmlTagMappings.digits = "say-as", this.modifierKeyToSsmlTagMappings.drc = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyMappings.digits = "digits", this.modifierKeyMappings.cardinal = "cardinal";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            case "emphasis":
                                t.tag(l, {
                                    level: o || "moderate"
                                });
                                break;
                            case "address":
                            case "cardinal":
                            case "characters":
                            case "digits":
                            case "expletive":
                            case "fraction":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                t.tag(l, {
                                    "interpret-as": s
                                });
                                break;
                            case "date":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "ymd"
                                });
                                break;
                            case "time":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "hms12"
                                });
                                break;
                            case "whisper":
                                t.tag(l, {
                                    name: "whispered"
                                });
                                break;
                            case "ipa":
                                t.tag(l, {
                                    alphabet: s,
                                    ph: o
                                });
                                break;
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0);
                                    break;
                                }
                            case "timbre":
                                t.tag(l, {
                                    "vocal-tract-length": o
                                });
                                break;
                            case "lang":
                                t.tag(l, {
                                    "xml:lang": o
                                });
                                break;
                            case "drc":
                                t.tag(l, {
                                    name: s
                                });
                                break;
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            if (r.name === "sectionModifierKeyOptionalValue") {
                let s = r.children[0].allText;
                const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                switch(s){
                    case "lang":
                        t.tag(l, {
                            "xml:lang": o
                        });
                        break;
                }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "markTag":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "mark", {
                        name: i
                    });
                }
            case "shortEmphasisModerate":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "moderate"
                    });
                }
            case "shortEmphasisStrong":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "strong"
                    });
                }
            case "shortEmphasisNone":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "none"
                    });
                }
            case "shortEmphasisReduced":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "reduced"
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e), r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "section":
                {
                    const i = this.getSectionObject(e), r = Object.keys(i.tags).sort((s, o)=>i.tags[s].sortId - i.tags[o].sortId);
                    return this.addSectionEndTag(t), this.addSectionStartTag(r, i, t), t;
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
                return t.push(e.allText), t;
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$Ye extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.modifierKeyToSsmlTagMappings.cardinal = "say-as", this.modifierKeyToSsmlTagMappings.digits = "say-as", this.modifierKeyToSsmlTagMappings.drc = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain", this.modifierKeyMappings.digits = "digits", this.modifierKeyMappings.cardinal = "cardinal";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            case "address":
                            case "cardinal":
                            case "characters":
                            case "digits":
                            case "expletive":
                            case "fraction":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                t.tag(l, {
                                    "interpret-as": s
                                });
                                break;
                            case "date":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "ymd"
                                });
                                break;
                            case "time":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "hms12"
                                });
                                break;
                            case "ipa":
                                t.tag(l, {
                                    alphabet: s,
                                    ph: o
                                });
                                break;
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                });
                                break;
                            case "volume":
                            case "rate":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0);
                                    break;
                                }
                            case "lang":
                                t.tag(l, {
                                    "xml:lang": o
                                });
                                break;
                            case "drc":
                                t.tag(l, {
                                    name: s
                                });
                                break;
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            if (r.name === "sectionModifierKeyOptionalValue") {
                let s = r.children[0].allText;
                const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                switch(s){
                    case "lang":
                        t.tag(l, {
                            "xml:lang": o
                        });
                        break;
                    case "newscaster":
                        t.tag(l, {
                            name: "news"
                        });
                        break;
                }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Polly", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "markTag":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "mark", {
                        name: i
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e), r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "section":
                {
                    const i = this.getSectionObject(e), r = Object.keys(i.tags).sort((s, o)=>i.tags[s].sortId - i.tags[o].sortId);
                    return this.addSectionEndTag(t), this.addSectionStartTag(r, i, t), t;
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                return t.push(e.allText.replace(/\+/g, "")), t;
            case "plainText":
            case "plainTextSpecialChars":
                return t.push(e.allText), t;
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$_e extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.validVoices = {
            Ivy: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-US"
                }
            },
            Joanna: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-US"
                }
            },
            Joey: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-US"
                }
            },
            Justin: {
                voice: {
                    gender: "male",
                    variant: 2,
                    language: "en-US"
                }
            },
            Kendra: {
                voice: {
                    gender: "female",
                    variant: 3,
                    language: "en-US"
                }
            },
            Kimberly: {
                voice: {
                    gender: "female",
                    variant: 4,
                    language: "en-US"
                }
            },
            Matthew: {
                voice: {
                    gender: "male",
                    variant: 3,
                    language: "en-US"
                }
            },
            Salli: {
                voice: {
                    gender: "male",
                    variant: 4,
                    language: "en-US"
                }
            },
            Nicole: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-AU"
                }
            },
            Russell: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-AU"
                }
            },
            Amy: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-GB"
                }
            },
            Brian: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-GB"
                }
            },
            Emma: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-GB"
                }
            },
            Aditi: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-IN"
                }
            },
            Raveena: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-IN"
                }
            },
            Hans: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "de-DE"
                }
            },
            Marlene: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "de-DE"
                }
            },
            Vicki: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "de-DE"
                }
            },
            Conchita: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "es-ES"
                }
            },
            Enrique: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "es-ES"
                }
            },
            Carla: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "it-IT"
                }
            },
            Giorgio: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "it-IT"
                }
            },
            Mizuki: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "ja-JP"
                }
            },
            Takumi: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "ja-JP"
                }
            },
            Celine: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "fr-FR"
                }
            },
            Lea: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "fr-FR"
                }
            },
            Mathieu: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "fr-FR"
                }
            }
        }, this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.whisper = "prosody", this.modifierKeyToSsmlTagMappings.lang = "lang";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            case "emphasis":
                                t.tag(l, {
                                    level: o || "moderate"
                                });
                                break;
                            case "address":
                            case "characters":
                            case "expletive":
                            case "fraction":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                t.tag(l, {
                                    "interpret-as": s
                                });
                                break;
                            case "date":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "ymd"
                                });
                                break;
                            case "time":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "hms12"
                                });
                                break;
                            case "whisper":
                                t.tag(l, {
                                    volume: "x-soft",
                                    rate: "slow"
                                });
                                break;
                            case "ipa":
                                t.tag(l, {
                                    alphabet: s,
                                    ph: o
                                });
                                break;
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0);
                                    break;
                                }
                            case "lang":
                                t.tag(l, {
                                    "xml:lang": o
                                });
                                break;
                            case "voice":
                                t.voiceTag(s, o);
                                break;
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            if (r.name === "sectionModifierKeyOptionalValue") {
                let s = r.children[0].allText;
                const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                switch(s){
                    case "lang":
                        t.tag(l, {
                            "xml:lang": o
                        });
                        break;
                    case "voice":
                        t.voiceTag(s, o);
                        break;
                }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Google Assistant", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "markTag":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "mark", {
                        name: i
                    });
                }
            case "shortEmphasisModerate":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "moderate"
                    });
                }
            case "shortEmphasisStrong":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "strong"
                    });
                }
            case "shortEmphasisNone":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "none"
                    });
                }
            case "shortEmphasisReduced":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "reduced"
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e);
                    if (i.textOnly) return t.push(i.text), t;
                    const r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "section":
                {
                    const i = this.getSectionObject(e), r = Object.keys(i.tags).sort((s, o)=>i.tags[s].sortId - i.tags[o].sortId);
                    return this.addSectionEndTag(t), this.addSectionStartTag(r, i, t), t;
                }
            case "audio":
                {
                    const i = e.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(t, null, "audio", {
                        src: i
                    });
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
                return t.push(e.allText), t;
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$et extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.modifierKeyToSsmlTagMappings.emphasis = null, this.modifierKeyToSsmlTagMappings.address = null, this.modifierKeyToSsmlTagMappings.number = "say-as", this.modifierKeyToSsmlTagMappings.characters = "say-as", this.modifierKeyToSsmlTagMappings.expletive = null, this.modifierKeyToSsmlTagMappings.fraction = "say-as", this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.ordinal = "say-as", this.modifierKeyToSsmlTagMappings.telephone = null, this.modifierKeyToSsmlTagMappings.unit = null, this.modifierKeyToSsmlTagMappings.time = null, this.modifierKeyToSsmlTagMappings.date = null, this.modifierKeyToSsmlTagMappings.sub = "sub", this.modifierKeyToSsmlTagMappings.ipa = null, this.modifierKeyToSsmlTagMappings.rate = "prosody", this.modifierKeyToSsmlTagMappings.pitch = "prosody", this.modifierKeyToSsmlTagMappings.volume = "prosody", this.modifierKeyToSsmlTagMappings.whisper = "prosody";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            // case 'emphasis': {
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject.tags[ssmlTag].attrs = { level: value || 'moderate' };
                            //   break;
                            // }
                            // case 'address':
                            // case 'expletive':
                            // case 'telephone':
                            // case 'unit':
                            case "fraction":
                            case "ordinal":
                                t.tag(l, {
                                    "interpret-as": s
                                });
                                break;
                            case "number":
                                t.tag(l, {
                                    "interpret-as": "cardinal"
                                });
                                break;
                            case "characters":
                                {
                                    let d = "digits";
                                    isNaN(t.text) && (d = "spell-out"), t.tag(l, {
                                        "interpret-as": d
                                    });
                                    break;
                                }
                            // case 'date': {
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'ymd' };
                            //   break;
                            // }
                            // case 'time': {
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'hms12' };
                            //   break;
                            // }
                            case "whisper":
                                t.tag(l, {
                                    volume: "x-soft",
                                    rate: "slow"
                                });
                                break;
                            // case 'ipa': {
                            //   // Google Assistant does not support <phoneme> tag
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject['textOnly'] = true;
                            //   break;
                            // }
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0);
                                    break;
                                }
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Samsung Bixby", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                {
                    const i = e.children[0].allText;
                    return i && t.push(i), t;
                }
            // case 'shortEmphasisStrong': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'strong' });
            // }
            // case 'shortEmphasisNone': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'none' });
            // }
            // case 'shortEmphasisReduced': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'reduced' });
            // }
            // case 'textModifier': {
            //   const tmo = this.getTextModifierObject(ast);
            //   if (tmo.textOnly) {
            //     // Quick return if tag is not supported
            //     lines.push(tmo.text)
            //     return lines
            //   }
            //   const tagsSortedDesc = Object.keys(tmo.tags).sort((a: any, b: any) => { return tmo.tags[b].sortId - tmo.tags[a].sortId });
            //   let inner = tmo.text;
            //   for (let index = 0; index < tagsSortedDesc.length; index++) {
            //     const tag = tagsSortedDesc[index];
            //     const attrs = tmo.tags[tag].attrs;
            //     inner = this.getTagWithAttrs(inner, tag, attrs);
            //   }
            //   lines.push(inner);
            //   return lines;
            // }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e);
                    if (i.textOnly) return t.push(i.text), t;
                    const r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "audio":
                {
                    const i = e.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(t, null, "audio", {
                        src: i
                    }, !0);
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                return t.push(e.allText), t;
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$tt extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.modifierKeyToSsmlTagMappings.emphasis = "emphasis", this.modifierKeyToSsmlTagMappings.address = "say-as", this.modifierKeyToSsmlTagMappings.number = "say-as", this.modifierKeyToSsmlTagMappings.characters = "say-as", this.modifierKeyToSsmlTagMappings.expletive = null, this.modifierKeyToSsmlTagMappings.fraction = "say-as", this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.ordinal = "say-as", this.modifierKeyToSsmlTagMappings.telephone = "say-as", this.modifierKeyToSsmlTagMappings.unit = null, this.modifierKeyToSsmlTagMappings.time = "say-as", this.modifierKeyToSsmlTagMappings.date = "say-as", this.modifierKeyToSsmlTagMappings.sub = "sub", this.modifierKeyToSsmlTagMappings.paragraph = "p", this.modifierKeyToSsmlTagMappings.sentence = "s", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.voice = "voice", this.modifierKeyToSsmlTagMappings.ipa = "phoneme", this.modifierKeyToSsmlTagMappings.sapi = "phoneme", this.modifierKeyToSsmlTagMappings.ups = "phoneme", this.modifierKeyToSsmlTagMappings.pitch = "prosody", this.modifierKeyToSsmlTagMappings.contour = "prosody", this.modifierKeyToSsmlTagMappings.range = "prosody", this.modifierKeyToSsmlTagMappings.rate = "prosody", this.modifierKeyToSsmlTagMappings.volume = "prosody", this.modifierKeyToSsmlTagMappings.whisper = "prosody", this.modifierKeyToSsmlTagMappings.emotion = "mstts:express-as", this.ssmlTagSortOrder = [
            "voice",
            "lang",
            "p",
            "s",
            "emphasis",
            "say-as",
            "mstts:express-as",
            "prosody",
            "sub",
            "phoneme"
        ];
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            case "address":
                            case "fraction":
                            case "ordinal":
                            case "telephone":
                                t.tag(l, {
                                    "interpret-as": s
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "number":
                                t.tag(l, {
                                    "interpret-as": "cardinal"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "characters":
                                {
                                    let d = "digits";
                                    isNaN(t.text) && (d = "characters"), t.tag(l, {
                                        "interpret-as": d
                                    }, !1, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "date":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "ymd"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "time":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "hms12"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "whisper":
                                t.tag(l, {
                                    volume: "x-soft",
                                    rate: "slow"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "ipa":
                            case "sapi":
                            case "ups":
                                t.tag(l, {
                                    alphabet: s,
                                    ph: o
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "lang":
                                t.tag(l, {
                                    "xml:lang": o
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "voice":
                                {
                                    const d = this.sentenceCase(o || "device");
                                    d != "Device" && t.tag(l, {
                                        name: d
                                    }, !1, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "emotion":
                                {
                                    const d = o.split(" "), f = {};
                                    switch(d.length){
                                        case 2:
                                            const k = parseInt(d[1]);
                                            isNaN(k) ? f.role = d[1] : f.styledegree = d[1];
                                        case 1:
                                            f.style = d[0];
                                            break;
                                    }
                                    t.tag(l, f, !0, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "emphasis":
                                t.tag(l, {
                                    level: o
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "paragraph":
                                t.tag(l, null, !1, this.ssmlTagSortOrder);
                                break;
                            case "sentence":
                                t.tag(l, null, !1, this.ssmlTagSortOrder);
                                break;
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            if (r.name === "sectionModifierKeyOptionalValue") {
                let s = r.children[0].allText;
                const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                switch(s){
                    case "voice":
                        {
                            const d = this.sentenceCase(o || "device");
                            d != "Device" && t.tag(l, {
                                name: d
                            }, !1, this.ssmlTagSortOrder);
                            break;
                        }
                    case "defaults":
                        break;
                    case "emotion":
                        t.tag(l, {
                            style: o
                        }, !1, this.ssmlTagSortOrder);
                        break;
                }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Microsoft Azure", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "silence":
                {
                    const i = e.children[0].allText.split(" "), r = {
                        type: i[0],
                        value: i[1]
                    };
                    return this.addTagWithAttrs(t, null, "mstts:silence", r);
                }
            case "backgroundAudio":
                {
                    const i = e.children[0].allText.split(" ");
                    let r = {};
                    const s = [
                        "src",
                        "volume",
                        "fadein",
                        "fadeout"
                    ];
                    for(let o = 0; o < i.length; o++)r[s[o]] = i[o];
                    return this.addTagWithAttrs(t, null, "mstts:backgroundaudio", r);
                }
            case "lexicon":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "lexicon", {
                        uri: i
                    });
                }
            case "bookmark":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "bookmark", {
                        mark: i
                    });
                }
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                {
                    const i = e.children[0].allText;
                    return i && t.push(i), t;
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e), r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        if (l === "voice" || l === "lang") {
                            const f = o < r.length - 1 ? r[o + 1] : "";
                            s = this.getVoiceOrLangTagWithAttrs(s, l, d, f);
                        } else s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "audio":
                {
                    const i = e.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(t, null, "audio", {
                        src: i
                    }, !1);
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                return t.push(e.allText), t;
            case "section":
                {
                    const i = this.getSectionObject(e), r = Object.keys(i.tags).sort((s, o)=>i.tags[s].sortId - i.tags[o].sortId);
                    return this.addSectionEndTag(t), this.addSectionStartTag(r, i, t), t;
                }
            default:
                return this.processAst(e.children, t), t;
        }
    }
    getVoiceOrLangTagWithAttrs(e, t, i, r) {
        let s = [];
        return e ? (s.push(this.startVoiceOrLangTag(t, i, r)), s.push(e), s.push(this.endVoiceOrLangTag(t, !1, r))) : s.push(this.voidTag(t, i)), s.join("");
    }
    // Returns the SSML for a start tag
    startVoiceOrLangTag(e, t, i, r = !1) {
        let s = "", o = "";
        switch(e){
            case "voice":
                this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice && (o = "</voice>", this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (o = "</lang>" + o));
                break;
            case "lang":
                i && i === "voice" || this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (o = "</lang>");
                break;
        }
        return t && (s = " " + Object.keys(t).map((l)=>l + '="' + t[l] + '"').join(" ")), o + "<" + e + s + ">" + (r ? `
` : "");
    }
    // Returns the SSML for an end tag
    endVoiceOrLangTag(e, t = !1, i) {
        let r = "";
        switch(e){
            case "voice":
                this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice && (r = `<voice name="${this.options.globalVoiceAndLang.voice}">`, this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (r += `<lang xml:lang="${this.options.globalVoiceAndLang.lang}">`));
                break;
            case "lang":
                i && i === "voice" || this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && e === "lang" && (r = `<lang xml:lang="${this.options.globalVoiceAndLang.lang}">`);
                break;
        }
        return (t ? `
` : "") + "</" + e + ">" + r;
    }
}
function $b0c9077b7a60729e$var$rt(m) {
    switch(m.platform){
        case "amazon-alexa":
            return new $b0c9077b7a60729e$var$He(m);
        case "amazon-polly":
            return new $b0c9077b7a60729e$var$Ze(m);
        case "amazon-polly-neural":
            return new $b0c9077b7a60729e$var$Ye(m);
        case "google-assistant":
            return new $b0c9077b7a60729e$var$_e(m);
        case "samsung-bixby":
            return new $b0c9077b7a60729e$var$et(m);
        case "microsoft-azure":
            return new $b0c9077b7a60729e$var$tt(m);
        default:
            return new $b0c9077b7a60729e$var$Ne(m);
    }
}
function $b0c9077b7a60729e$var$it(m) {
    return new $b0c9077b7a60729e$var$Ne(m);
}
var $b0c9077b7a60729e$var$Q = {
    exports: {}
}, $b0c9077b7a60729e$var$we = $b0c9077b7a60729e$var$Q.exports, $b0c9077b7a60729e$var$Ce;
function $b0c9077b7a60729e$var$at() {
    return $b0c9077b7a60729e$var$Ce || ($b0c9077b7a60729e$var$Ce = 1, function(m, e) {
        var t = $b0c9077b7a60729e$var$we && $b0c9077b7a60729e$var$we.__extends || function(r, s) {
            for(var o in s)s.hasOwnProperty(o) && (r[o] = s[o]);
            function l() {
                this.constructor = r;
            }
            r.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
        }, i;
        (function(r) {
            var s = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, c), this.type = "ParserError";
                }
                return n;
            }(Error);
            r.ParserError = s, r.grammars = {}, r.allRules = {}, r.parsers = {};
            var o = function() {
                function a(n, c) {
                    this.input = n, this.index = c, this.lineNum = 0, this.colNum = 0, this.lineStart = 0, this.lineEnd = 0;
                    for(var u = 0, h = 1, p = 0; p < this.index; ++p)this.input.charCodeAt(p) == 13 && (this.lineStart = p, u++), this.input.charCodeAt(p) == 10 && (this.lineStart = p, h++);
                    for(this.lineEnd = this.index; this.lineEnd < this.input.length && !(this.input.charCodeAt(this.lineEnd) == 13 || this.input.charCodeAt(this.lineEnd) == 10); ++this.lineEnd);
                    this.lineNum = u > h ? u : h, this.colNum = this.index - this.lineStart, this.lineText = this.input.substring(this.lineStart, this.lineEnd), this.pointerText = Array(this.colNum).join(" ") + "^";
                }
                return a.prototype.toString = function() {
                    return "Index " + this.index + ", Line " + this.lineNum + ", Column " + this.colNum + `
` + this.lineText + `
` + this.pointerText;
                }, a;
            }();
            r.ParseLocation = o;
            var l = function() {
                function a(n, c, u) {
                    this.input = n, this.index = c, this.nodes = u, this.length = 0, this.rules = [], this.length = this.input.length;
                }
                return Object.defineProperty(a.prototype, "location", {
                    // Returns an object that representation of the location. 
                    get: function() {
                        return new o(this.input, this.index);
                    },
                    enumerable: !0,
                    configurable: !0
                }), a;
            }();
            r.ParseState = l;
            var d = function() {
                function a(n, c, u, h) {
                    u === void 0 && (u = 0), h === void 0 && (h = -1), this.rule = n, this.input = c, this.start = u, this.end = h, this.children = null;
                }
                return Object.defineProperty(a.prototype, "name", {
                    // Returns the name of the rule associated with this node
                    get: function() {
                        return this.rule != null ? this.rule.name : "unnamed";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "fullName", {
                    // Returns the name of the rule, preceded by the grammar name, associated with this node
                    get: function() {
                        return this.rule != null ? this.rule.fullName : "unnamed";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "allText", {
                    // Returns the parsed text associated with this node's start and end locations  
                    get: function() {
                        return this.input.slice(this.start, this.end);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "isLeaf", {
                    // Returns true if this node has no children
                    get: function() {
                        return this.children == null || this.children.length == 0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.child = function(n) {
                    if (this.children) for(var c = 0, u = this.children; c < u.length; c++){
                        var h = u[c];
                        if (h.name == n) return h;
                    }
                    return null;
                }, Object.defineProperty(a.prototype, "_firstChildStart", {
                    // The position of the first child, or the end position for the entire node if no children 
                    get: function() {
                        return this.isLeaf ? this.end : this.children[0].start;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "_lastChildEnd", {
                    // The end position of the last child, or the end position for the entire node if no children 
                    get: function() {
                        return this.isLeaf ? this.end : this.children[0].end;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "beforeChildrenText", {
                    // Returns the text before the children, or if no children returns the entire text. 
                    get: function() {
                        return this.input.slice(this.start, this._firstChildStart);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "afterChildrenText", {
                    // Returns the text after the children, or if no children returns the empty string.
                    get: function() {
                        return this.input.slice(this._lastChildEnd, this.end);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "allChildrenText", {
                    // Returns the text from the beginning of the first child to the end of the last child.
                    get: function() {
                        return this.input.slice(this._firstChildStart, this._lastChildEnd);
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.toString = function() {
                    var n = this.isLeaf ? this.allText : this.children.map(function(c) {
                        return c.toString();
                    }).join(" ");
                    return "(" + this.rule.name + ": " + n + ")";
                }, a;
            }();
            r.AstNode = d;
            var f = function() {
                function a(n) {
                    this.rules = n, this.name = "", this.grammarName = "", this.type = "", this.className = "Rule", this._createAstNode = !1, this.parser = null, this.lexer = null;
                }
                return a.prototype.node = function(n) {
                    n === void 0 && (n = "");
                    for(var c = [], u = 1; u < arguments.length; u++)c[u - 1] = arguments[u];
                    var h = new d(this, n, 0, n.length);
                    return h.children = c, h;
                }, a.prototype.parse = function(n) {
                    return r.parse(this, n);
                }, a.prototype.setName = function(n, c) {
                    return this.grammarName = n, this.name = c, this;
                }, Object.defineProperty(a.prototype, "definition", {
                    // Returns a default definition of the rule
                    get: function() {
                        return this.className + "(" + this.rules.map(function(n) {
                            return n.toString();
                        }).join(", ") + ")";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "fullName", {
                    // Returns the name of the rule preceded by the grammar name and a "."
                    get: function() {
                        return this.grammarName + "." + this.name;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "nameOrDefinition", {
                    // Returns either the name of the rule, or it's definition
                    get: function() {
                        return this.name ? this.fullName : this.definition;
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.toString = function() {
                    return this.nameOrDefinition;
                }, Object.defineProperty(a.prototype, "firstChild", {
                    // Returns the first child rule
                    get: function() {
                        return this.rules[0];
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.setType = function(n) {
                    return this.type = n, this;
                }, a.prototype.cloneImplementation = function() {
                    throw new Error("Missing override for cloneImplementation");
                }, Object.defineProperty(a.prototype, "copy", {
                    // Returns a copy of this rule with all fields copied.  
                    get: function() {
                        var n = this.cloneImplementation();
                        if (typeof n != typeof this) throw new Error("Error in implementation of cloneImplementation: not returning object of correct type");
                        return n.name = this.name, n.grammarName = this.grammarName, n._createAstNode = this._createAstNode, n;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "hasAstChildRule", {
                    // Returns true if any of the child rules are "ast rules" meaning they create nodes in the parse tree.
                    get: function() {
                        return this.rules.filter(function(n) {
                            return n.createsAstNode;
                        }).length > 0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "createsAstNode", {
                    // Returns true if this rule when parsed successfully will create a node in the parse tree. 
                    // Some rules will override this function. 
                    get: function() {
                        return this._createAstNode;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "nonAdvancing", {
                    // Returns true if this rule doesn't advance the input
                    get: function() {
                        return !1;
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.astRuleDefn = function(n, c) {
                    n === void 0 && (n = !1), c === void 0 && (c = !1);
                    var u = this.rules.filter(function(g) {
                        return g.createsAstNode;
                    });
                    if (!u.length) return this.name;
                    if (u.length == 1) {
                        var h = u[0].astRuleNameOrDefn(n, c);
                        return this instanceof I && (h += "[" + this.min + "," + this.max + "]"), h;
                    }
                    if (this instanceof v) {
                        var p = u.map(function(g) {
                            return g.astRuleNameOrDefn(!0, !1);
                        }).join(",");
                        return n ? p : "seq(" + p + ")";
                    }
                    if (this instanceof C) {
                        var p = u.map(function(T) {
                            return T.astRuleNameOrDefn(!1, !0);
                        }).join(",");
                        return c ? p : "choice(" + p + ")";
                    }
                    throw new Error("Internal error: not a valid AST rule");
                }, a.prototype.astRuleNameOrDefn = function(n, c) {
                    return n === void 0 && (n = !1), c === void 0 && (c = !1), this._createAstNode ? this.name : this.astRuleDefn(n, c);
                }, Object.defineProperty(a.prototype, "opt", {
                    //======================================================
                    // Extensions to support method/property chaining. 
                    // This is also known as a fluent API syntax
                    get: function() {
                        return ee(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "zeroOrMore", {
                    get: function() {
                        return ce(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "oneOrMore", {
                    get: function() {
                        return le(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "at", {
                    get: function() {
                        return _(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "not", {
                    get: function() {
                        return N(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "advance", {
                    get: function() {
                        return this.then(r.advance);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "ws", {
                    get: function() {
                        return this.then(r.ws);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "all", {
                    get: function() {
                        return this.then(r.all);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "end", {
                    get: function() {
                        return this.then(r.end);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "assert", {
                    get: function() {
                        return F(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "ast", {
                    get: function() {
                        return new k(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.then = function(n) {
                    return y(this, n);
                }, a.prototype.thenAt = function(n) {
                    return this.then(_(n));
                }, a.prototype.thenNot = function(n) {
                    return this.then(N(n));
                }, a.prototype.or = function(n) {
                    return b(this, n);
                }, a.prototype.until = function(n) {
                    return q(this, n);
                }, a.prototype.untilPast = function(n) {
                    return Z(this, n);
                }, a.prototype.repeat = function(n) {
                    return he(this, n);
                }, a.prototype.quantified = function(n, c) {
                    return W(this, n, c);
                }, a.prototype.delimited = function(n) {
                    return ge(this, n);
                }, a.prototype.unless = function(n) {
                    return re(this, n);
                }, a;
            }();
            r.Rule = f;
            var k = function(a) {
                t(n, a);
                function n(c) {
                    var u = this;
                    a.call(this, [
                        c
                    ]), this.r = c, this.type = "ast", this.className = "AstRule", this._createAstNode = !0, this.parser = function(h) {
                        var p = h.index, g = h.nodes;
                        if (h.nodes = [], h.rules.push(u), c.parser(h)) {
                            h.rules.pop();
                            var T = new d(u, h.input, p, h.index);
                            return T.children = h.nodes, h.nodes = g, h.nodes.push(T), !0;
                        } else return h.rules.pop(), h.nodes = g, h.index = p, !1;
                    }, this.lexer = c.lexer;
                }
                return n;
            }(f);
            r.AstRule = k;
            var v = function(a) {
                t(n, a);
                function n(c, u) {
                    a.call(this, [
                        c,
                        u
                    ]), this.rule1 = c, this.rule2 = u, this.type = "seq", this.className = "Sequence", this.parser = function(h) {
                        var p = h.nodes.length, g = h.index;
                        return c.parser(h) === !1 ? !1 : u.parser(h) === !1 ? (h.nodes.length !== p && h.nodes.splice(-1, h.nodes.length - p), h.index = g, !1) : !0;
                    }, this.lexer = function(h) {
                        var p = h.index;
                        return c.lexer(h) === !1 ? !1 : u.lexer(h) === !1 ? (h.index = p, !1) : !0;
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        var c = this.rules.map(function(u) {
                            return u.toString();
                        }).join(" ");
                        return this.rules.length > 1 && (c = "(" + c + ")"), c;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "nonAdvancing", {
                    get: function() {
                        return this.rules.every(function(c) {
                            return c.nonAdvancing;
                        });
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "createsAstNode", {
                    get: function() {
                        return this._createAstNode || this.hasAstChildRule;
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.rule1, this.rule2);
                }, n;
            }(f);
            r.Sequence = v;
            var C = function(a) {
                t(n, a);
                function n(c, u) {
                    a.call(this, [
                        c,
                        u
                    ]), this.rule1 = c, this.rule2 = u, this.type = "choice", this.className = "Choice", this.parser = function(h) {
                        return c.parser(h) || u.parser(h);
                    }, this.lexer = function(h) {
                        return c.lexer(h) || u.lexer(h);
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        var c = this.rules.map(function(u) {
                            return u.toString();
                        }).join(" / ");
                        return this.rules.length > 1 && (c = "(" + c + ")"), c;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "nonAdvancing", {
                    get: function() {
                        return this.rules.every(function(c) {
                            return c.nonAdvancing;
                        });
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "createsAstNode", {
                    get: function() {
                        return this._createAstNode || this.hasAstChildRule;
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.rule1, this.rule2);
                }, n;
            }(f);
            r.Choice = C;
            var I = function(a) {
                t(n, a);
                function n(c, u, h) {
                    var p = this;
                    if (u === void 0 && (u = 0), h === void 0 && (h = 1 / 0), a.call(this, [
                        c
                    ]), this.min = u, this.max = h, this.type = "quantified", this.className = "Quantified", h === 1 / 0 && c.nonAdvancing) throw new Error("Rule would create an infinite loop");
                    this.parser = function(g) {
                        for(var T = g.nodes.length, x = g.index, O = 0; O < h; ++O){
                            if (c.parser(g) === !1) return O >= u ? !0 : (g.nodes.length !== T && g.nodes.splice(-1, g.nodes.length - T), g.index = x, !1);
                            ne(h !== 1 / 0 || g.index !== x, p);
                        }
                        return !0;
                    }, this.lexer = function(g) {
                        for(var T = g.index, x = 0; x < h; ++x){
                            if (c.lexer(g) === !1) return x >= u ? !0 : (g.index = T, !1);
                            ne(h !== 1 / 0 || g.index !== T, p, "Infinite loop");
                        }
                        return !0;
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(n.prototype, "definition", {
                    // Used for creating a human readable definition of the grammar.
                    get: function() {
                        return this.min == 0 && this.max == 1 ? this.firstChild.toString() + "?" : this.min == 0 && this.max == 1 / 0 ? this.firstChild.toString() + "*" : this.min == 1 && this.max == 1 / 0 ? this.firstChild.toString() + "+" : this.firstChild.toString() + "{" + this.min + "," + this.max + "}";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "createsAstNode", {
                    get: function() {
                        return this._createAstNode || this.hasAstChildRule;
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.firstChild, this.min, this.max);
                }, n;
            }(f);
            r.Quantified = I;
            var G = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, c, 0, 1), this.type = "optional", this.className = "Optional", this.parser = function(u) {
                        return c.parser(u), !0;
                    }, this.lexer = function(u) {
                        return c.lexer(u), !0;
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(n.prototype, "definition", {
                    // Used for creating a human readable definition of the grammar.
                    get: function() {
                        return this.firstChild.toString() + "?";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.firstChild);
                }, n;
            }(I);
            r.Optional = G;
            var z = function(a) {
                t(n, a);
                function n() {
                    a.call(this, []), this.type = "advance", this.className = "Advance", this.lexer = function(c) {
                        return c.index < c.length ? ++c.index >= 0 : !1;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "<advance>";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n();
                }, n;
            }(f);
            r.Advance = z;
            var K = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, [
                        c
                    ]), this.type = "advanceIf", this.className = "AdvanceIf", this.lexer = function(u) {
                        return c.lexer(u) && u.index < u.length ? ++u.index !== 0 : !1;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "advanceIf(" + this.firstChild.toString() + ")";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.firstChild);
                }, n;
            }(f);
            r.AdvanceIf = K;
            var B = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, []), this.text = c, this.type = "text", this.className = "Text";
                    for(var u = c.length, h = [], p = 0; p < u; ++p)h.push(c.charCodeAt(p));
                    this.lexer = function(g) {
                        var T = g.index;
                        if (T + h.length > g.input.length) return !1;
                        for(var x = 0, O = h; x < O.length; x++){
                            var se = O[x];
                            if (g.input.charCodeAt(T++) !== se) return !1;
                        }
                        return g.index = T, !0;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return '"' + Y(this.text) + '"';
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.text);
                }, n;
            }(f);
            r.Text = B;
            var X = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, []), this.text = c, this.type = "anyCaseText", this.className = "AnyCaseText", c = c.toLowerCase(), this.text = c;
                    for(var u = c.length, h = [], p = 0; p < u; ++p)h.push(c[p]);
                    this.lexer = function(g) {
                        var T = g.index;
                        if (T + h.length > g.input.length) return !1;
                        for(var x = 0, O = h; x < O.length; x++){
                            var se = O[x];
                            if (g.input[T++].toLowerCase() !== se) return !1;
                        }
                        return g.index = T, !0;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return 'AnyCase("' + Y(this.text) + '")';
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.text);
                }, n;
            }(f);
            r.AnyCaseText = X;
            var J = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, []), this.fn = c, this.type = "delay", this.className = "Delay";
                    var u = null;
                    this.parser = function(p) {
                        return (u || (u = c().parser))(p);
                    };
                    var h = null;
                    this.lexer = function(p) {
                        return (h || (h = c().lexer))(p);
                    };
                }
                return n.prototype.cloneImplementation = function() {
                    return new n(this.fn);
                }, Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "<delay>";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "createsAstNode", {
                    // It is assumed that a delay function creates an AST node,
                    get: function() {
                        return !0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), n;
            }(f);
            r.Delay = J;
            var j = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, c), this.type = "charSet";
                }
                return Object.defineProperty(n.prototype, "nonAdvancing", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), n;
            }(f);
            r.NonAdvancingRule = j;
            var D = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, []), this.chars = c, this.type = "charSet", this.className = "CharSet";
                    for(var u = [], h = c.length, p = 0; p < h; ++p)u[p] = c.charCodeAt(p);
                    this.lexer = function(g) {
                        return u.indexOf(g.input.charCodeAt(g.index)) >= 0;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "[" + Y(this.chars) + "]";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.chars);
                }, n;
            }(j);
            r.CharSet = D;
            var U = function(a) {
                t(n, a);
                function n(c, u) {
                    a.call(this, []), this.min = c, this.max = u, this.type = "charRange", this.className = "CharRange";
                    var h = c.charCodeAt(0), p = u.charCodeAt(0);
                    this.lexer = function(g) {
                        var T = g.input.charCodeAt(g.index);
                        return T >= h && T <= p;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "[" + this.min + ".." + this.max + "]";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.min, this.max);
                }, n;
            }(j);
            r.CharRange = U;
            var $ = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, [
                        c
                    ]), this.type = "not", this.className = "Not";
                    var u = c.lexer;
                    this.lexer = function(h) {
                        if (h.index >= h.length) return !0;
                        var p = h.index;
                        return u(h) === !1 ? !0 : (h.index = p, !1);
                    }, this.parser = this.lexer;
                }
                return n.prototype.cloneImplementation = function() {
                    return new n(this.firstChild);
                }, Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "!" + this.firstChild.toString();
                    },
                    enumerable: !0,
                    configurable: !0
                }), n;
            }(j);
            r.Not = $;
            var H = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, [
                        c
                    ]), this.type = "at", this.className = "At";
                    var u = c.lexer;
                    this.lexer = function(h) {
                        var p = h.index;
                        return u(h) === !1 ? !1 : (h.index = p, !0);
                    }, this.parser = this.lexer;
                }
                return n.prototype.cloneImplementation = function() {
                    return new n(this.firstChild);
                }, Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "&" + this.firstChild.toString();
                    },
                    enumerable: !0,
                    configurable: !0
                }), n;
            }(j);
            r.At = H;
            var V = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, []), this.fn = c, this.type = "predicate", this.className = "Predicate", this.lexer = c, this.parser = this.lexer;
                }
                return n.prototype.cloneImplementation = function() {
                    return new n(this.fn);
                }, Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "<predicate>";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n;
            }(j);
            r.Predicate = V;
            function R(a) {
                return new B(a);
            }
            r.text = R;
            function oe(a) {
                return new X(a);
            }
            r.textAnyCase = oe;
            function y() {
                for(var a = [], n = 0; n < arguments.length; n++)a[n - 0] = arguments[n];
                var c = a.map(E);
                if (c.length == 0) throw new Error("At least one rule is expected when calling `seq`");
                if (c.length == 1) return c[0];
                var u = c[0], h = y.apply(void 0, c.slice(1));
                return u.nonAdvancing && h instanceof z ? new K(u) : new v(u, h);
            }
            r.seq = y;
            function b() {
                for(var a = [], n = 0; n < arguments.length; n++)a[n - 0] = arguments[n];
                var c = a.map(E);
                if (c.length == 0) throw new Error("At least one rule is expected when calling `choice`");
                if (c.length == 1) return c[0];
                var u = c[0], h = b.apply(void 0, c.slice(1));
                return u instanceof K && h instanceof K ? new K(b(u.firstChild, h.firstChild)) : new C(u, h);
            }
            r.choice = b;
            function Pe(a) {
                return new J(a);
            }
            r.delay = Pe;
            function N(a) {
                return new $(E(a));
            }
            r.not = N;
            function _(a) {
                return new H(E(a));
            }
            r.at = _;
            function W(a, n, c) {
                return n === void 0 && (n = 0), c === void 0 && (c = 1 / 0), n === 0 && c === 1 ? new G(E(a)) : new I(E(a), n, c);
            }
            r.quantified = W;
            function ce(a) {
                return W(a).setType("zeroOrMore");
            }
            r.zeroOrMore = ce;
            function le(a) {
                return W(a, 1).setType("oneOrMore");
            }
            r.oneOrMore = le;
            function ee(a) {
                return W(a, 0, 1).setType("optional");
            }
            r.opt = ee;
            function he(a, n) {
                return W(a, n, n).setType("repeat");
            }
            r.repeat = he;
            function P(a) {
                return new D(a);
            }
            r.atChar = P;
            function ue(a) {
                return P(a).not;
            }
            r.notAtChar = ue;
            function de(a) {
                return P(a).advance;
            }
            r.char = de;
            function te(a) {
                return ue(a).advance;
            }
            r.notChar = te;
            function A(a, n) {
                return new U(a, n);
            }
            r.atRange = A;
            function pe(a, n) {
                return A(a, n).advance;
            }
            r.range = pe;
            function Ee(a, n) {
                return pe(a, n).not;
            }
            r.notRange = Ee;
            function ge(a, n) {
                return ee(y(a, y(n, a).zeroOrMore)).setType("delimitedList");
            }
            r.delimited = ge;
            function re(a, n) {
                return y(N(n), a).setType("unless");
            }
            r.unless = re;
            function q(a, n) {
                return re(a, n).zeroOrMore.setType("repeatWhileNot");
            }
            r.repeatWhileNot = q;
            function fe(a, n) {
                return N(n).then(a).then(q(a, n)).setType("repeatOneOrMoreWhileNot");
            }
            r.repeatOneOrMoreWhileNot = fe;
            function Z(a, n) {
                return q(a, n).then(n).setType("repeatUntilPast");
            }
            r.repeatUntilPast = Z;
            function me(a, n) {
                return N(n).then(a).then(Z(a, n)).setType("repeatOneOrMoreUntilPast");
            }
            r.repeatOneOrMoreUntilPast = me;
            function Le(a) {
                return q(r.advance, a).setType("advanceWhileNot");
            }
            r.advanceWhileNot = Le;
            function Ke(a) {
                return fe(r.advance, a).setType("advanceOneOrMoreWhileNot");
            }
            r.advanceOneOrMoreWhileNot = Ke;
            function Me(a) {
                return Z(r.advance, a).setType("advanceUntilPast");
            }
            r.advanceUntilPast = Me;
            function Ie(a) {
                return me(r.advance, a).setType("advanceOneOrMoreUntilPast");
            }
            r.advanceOneOrMoreUntilPast = Ie;
            function Ve(a) {
                return r.advance.unless(a).setType("advanceUnless");
            }
            r.advanceUnless = Ve;
            function Te(a) {
                return new V(a);
            }
            r.predicate = Te;
            function ie(a) {
                return Te(function(n) {
                    return a(n), !0;
                }).setType("action");
            }
            r.action = ie;
            function Re(a) {
                return a === void 0 && (a = ""), ie(function(n) {
                    console.log(a);
                }).setType("log");
            }
            r.log = Re;
            function be(a) {
                return ie(function(n) {
                    var c = new s(a + `
` + n.location.toString());
                    throw c;
                }).setType("err");
            }
            r.err = be;
            function F(a) {
                return b(a, be("Expected: " + E(a)));
            }
            r.assert = F;
            function M(a) {
                for(var n = [], c = 1; c < arguments.length; c++)n[c - 1] = arguments[c];
                return y(a, y.apply(void 0, n.map(function(u) {
                    return F(u);
                }))).setType("guardedSeq");
            }
            r.guardedSeq = M;
            function xe(a) {
                return M('"', a, F('"')).setType("doubleQuoted");
            }
            r.doubleQuoted = xe;
            function We(a) {
                return xe(b(a, te('"').zeroOrMore)).setType("doubleQuotedString");
            }
            r.doubleQuotedString = We;
            function ve(a) {
                return M("'", a, F("'")).setType("singleQuoted");
            }
            r.singleQuoted = ve;
            function ze(a) {
                return ve(b(a, te("'").zeroOrMore)).setType("singleQuotedString");
            }
            r.singleQuotedString = ze;
            function De(a) {
                return M("(", r.ws, a, r.ws, ")").setType("parenthesized");
            }
            r.parenthesized = De;
            function Ue(a) {
                return M("{", r.ws, a, r.ws, "}").setType("braced");
            }
            r.braced = Ue;
            function qe(a) {
                return M("[", r.ws, a, r.ws, "]").setType("bracketed");
            }
            r.bracketed = qe;
            function Fe(a) {
                return M("<", r.ws, a, r.ws, ">").setType("tagged");
            }
            r.tagged = Fe;
            function ye(a) {
                return y(a, N(r.identifierNext)).setType("keyword");
            }
            r.keyword = ye;
            function Qe(a) {
                return y(oe(a), N(r.identifierNext)).setType("keywordAnyCase");
            }
            r.keywordAnyCase = Qe;
            function Ge() {
                for(var a = [], n = 0; n < arguments.length; n++)a[n - 0] = arguments[n];
                return b.apply(void 0, a.map(ye));
            }
            r.keywords = Ge, r.truePredicate = new V(function(a) {
                return !0;
            }), r.falsePredicate = new V(function(a) {
                return !1;
            }), r.end = new V(function(a) {
                return a.index >= a.length;
            }), r.notEnd = new V(function(a) {
                return a.index < a.length;
            }), r.advance = new z(), r.all = r.advance.zeroOrMore, r.atLetterLower = A("a", "z"), r.atLetterUpper = A("A", "Z"), r.atLetter = b(r.atLetterLower, r.atLetterUpper), r.atDigit = A("0", "9"), r.atDigitNonZero = A("1", "9"), r.atHexDigit = b(r.atDigit, A("a", "f"), A("A", "F")), r.atBinaryDigit = P("01"), r.atOctalDigit = A("0", "7"), r.atAlphaNumeric = b(r.atLetter, r.atDigit), r.atUnderscore = P("_"), r.atSpace = P(" "), r.atTab = P("	"), r.atWs = P(` 	\r
\xa0\uFEFF`), r.atIdentifierNext = b(r.atAlphaNumeric, r.atUnderscore), r.letterLower = r.atLetterLower.advance, r.letterUpper = r.atLetterUpper.advance, r.letter = r.atLetter.advance, r.letters = r.letter.oneOrMore, r.digit = r.atDigit.advance, r.digitNonZero = r.atDigitNonZero.advance, r.digits = r.digit.oneOrMore, r.integer = de("0").or(r.digits), r.hexDigit = r.atHexDigit.advance, r.binaryDigit = r.atBinaryDigit.advance, r.octalDigit = r.atOctalDigit.advance, r.alphaNumeric = r.atAlphaNumeric.advance, r.underscore = r.atUnderscore.advance, r.identifierFirst = b(r.atLetter, r.atUnderscore).advance, r.identifierNext = b(r.atAlphaNumeric, r.atUnderscore).advance, r.identifier = y(r.identifierFirst, r.identifierNext.zeroOrMore), r.hyphen = R("-"), r.crlf = R(`\r
`), r.newLine = b(r.crlf, `
`), r.space = R(" "), r.tab = R("	"), r.ws = r.atWs.advance.zeroOrMore;
            function Be(a, n) {
                var c = this.parse(a.ast.zeroOrMore, n);
                return c ? c.children : [];
            }
            r.tokenize = Be;
            function Se(a, n) {
                var c = new l(n, 0, []);
                return a instanceof k || (a = a.ast), a.parser(c) && c && c.nodes ? c.nodes[0] : null;
            }
            r.parse = Se;
            function ke(a) {
                return ae(a).filter(function(n) {
                    return n._createAstNode;
                });
            }
            r.grammarAstRules = ke;
            function ae(a) {
                return Ae().filter(function(n) {
                    return n.grammarName == a;
                });
            }
            r.grammarRules = ae;
            function Ae() {
                return Object.keys(r.allRules).sort().map(function(a) {
                    return r.allRules[a];
                });
            }
            r.allGrammarRules = Ae;
            function Xe() {
                return Object.keys(r.grammars).sort();
            }
            r.grammarNames = Xe;
            function Je(a) {
                return ae(a).map(function(n) {
                    return n.fullName + " <- " + n.definition;
                }).join(`
`);
            }
            r.grammarToString = Je;
            function $e(a) {
                return ke(a).map(function(n) {
                    return n.name + " <- " + n.astRuleDefn();
                }).join(`
`);
            }
            r.astSchemaToString = $e;
            function Oe(a, n, c) {
                for(var u in n)if (n[u] instanceof f) {
                    var h = n[u];
                    h.setName(a, u), r.allRules[h.fullName] = h;
                }
                return r.grammars[a] = n, c && (r.parsers[a] = function(p) {
                    return Se(c, p);
                }), n;
            }
            r.registerGrammar = Oe;
            function Y(a) {
                var n = JSON.stringify(a);
                return n.slice(1, n.length - 1);
            }
            r.escapeChars = Y;
            function E(a) {
                if (a instanceof f) return a;
                if (typeof a == "string") return R(a);
                if (typeof a == "boolean") return a ? r.truePredicate : r.falsePredicate;
                throw new Error("Invalid rule type: " + a);
            }
            r.RuleTypeToRule = E;
            function ne(a, n, c) {
                if (!a) throw new Error("Error occured while parsing rule: " + n.fullName + " " + (c || ""));
            }
            r.debugAssert = ne, Oe("core", r, null);
        })(i = e.Myna || (e.Myna = {})), m.exports && (m.exports = i, m.exports.Myna = i);
    }($b0c9077b7a60729e$var$Q, $b0c9077b7a60729e$var$Q.exports)), $b0c9077b7a60729e$var$Q.exports;
}
var $b0c9077b7a60729e$var$nt = $b0c9077b7a60729e$var$at();
function $b0c9077b7a60729e$var$st(m) {
    const e = m;
    e.parenthesized = (i)=>e.seq("(", e.ws, i, e.ws, ")").setType("parenthesized");
    const t = new function() {
        const i = "[]()", r = "[]()*~`@#\\_!+-", s = e.char(" 	").oneOrMore;
        s.opt, s.or(e.newLine);
        const o = e.notChar(r).unless(e.newLine), l = e.notChar(i).unless(e.newLine);
        e.notChar('"'), this.xsdToken = e.choice(e.digits, e.letters, e.char(r)).oneOrMore.ast, this.plainText = e.choice(e.digits, e.letters, s, o).oneOrMore.ast, this.plainTextEmphasis = e.choice(e.digits, e.letters, s, o).oneOrMore.ast;
        const d = e.choice(e.digits, e.letters, s, l);
        this.plainTextModifier = d.oneOrMore.ast, this.plainTextPhone = e.seq(e.parenthesized(e.digits), d.oneOrMore).ast, this.plainTextSpecialChars = e.choice(e.seq("(", d, ") "), e.seq("[", d, "] "), e.choice(...r.split("")).oneOrMore).oneOrMore.ast, this.urlSpecialChar = e.char(":/.-_~?#[]@!+,;%=()&"), this.url = e.choice(e.digit, e.letter, this.urlSpecialChar).oneOrMore.ast, this.audio = e.seq("![", e.choice(e.singleQuoted(this.url), e.doubleQuoted(this.url)), "]").ast, this.timeUnit = e.choice("s", "ms").ast, this.fraction = e.seq(".", e.digit.zeroOrMore), this.number = e.seq(e.integer, this.fraction.opt).ast, this.time = e.seq(this.number, this.timeUnit).ast, this.shortBreak = e.seq("[", this.time, "]").ast, this.silenceTypeValue = e.choice("Leading", "Tailing", "Sentenceboundary").ast, this.silenceData = e.seq(this.silenceTypeValue, " ", this.time).ast, this.silence = e.seq("[", "silence", ":", e.choice(e.singleQuoted(this.silenceData), e.doubleQuoted(this.silenceData)), "]").ast, this.backgroundData = e.seq(" ", this.url), this.backgroundAudio = e.seq("[", "backgroundaudio", ":", e.choice(e.singleQuoted(e.seq(this.url, this.backgroundData.zeroOrMore).ast), e.doubleQuoted(e.seq(this.url, this.backgroundData.zeroOrMore).ast)), "]").ast, this.lexicon = e.seq("[", "lexicon", ":", e.choice(e.singleQuoted(this.url), e.doubleQuoted(this.url)), "]").ast, this.bookmarkChar = e.char(".-_"), this.bookmarkString = e.choice(e.digit, e.letter, this.bookmarkChar).oneOrMore.ast, this.bookmark = e.seq("[", "bookmark", ":", e.choice(e.singleQuoted(this.bookmarkString), e.doubleQuoted(this.bookmarkString)), "]").ast;
        const f = e.not(e.letters);
        this.shortEmphasisModerate = e.seq(f, "+", this.plainTextEmphasis, "+", f).ast, this.shortEmphasisStrong = e.seq(f, "++", this.plainTextEmphasis, "++", f).ast, this.shortEmphasisNone = e.seq(f, "~", this.plainTextEmphasis, "~", f).ast, this.shortEmphasisReduced = e.seq(f, "-", this.plainTextEmphasis, "-", f).ast, this.emphasis = e.choice(this.shortEmphasisModerate, this.shortEmphasisStrong, this.shortEmphasisNone, this.shortEmphasisReduced);
        const k = e.char(":").ws, v = e.char(";").ws;
        this.textModifierKey = e.keywords("emphasis", "address", "number", "cardinal", "characters", "chars", "digits", "drc", "expletive", "bleep", "fraction", "interjection", "ordinal", "telephone", "phone", "unit", "time", "date", "whisper", "ipa", "sapi", "ups", "sub", "vol", "volume", "rate", "pitch", "contour", "range", "timbre", "lang", "voice", "excited", "disappointed", "emotion", "paragraph", "sentence").ast;
        const C = [
            // Plosive
            "p",
            "b",
            "t",
            "d",
            "\u0288",
            "\u0256",
            "c",
            "\u025F",
            "k",
            "\u0261",
            "g",
            "q",
            "\u0262",
            "\u0294",
            // Nasal
            "m",
            "\u0271",
            "n",
            "\u0273",
            "\u0272",
            "\u014B",
            "\u0274",
            // Trill
            "\u0299",
            "r",
            "\u0280",
            // Tap or Flap
            "\u2C71",
            "\u027E",
            "\u027D",
            // Fricative
            "\u0278",
            "\u03B2",
            "f",
            "v",
            "\u03B8",
            "\xf0",
            "s",
            "z",
            "\u0283",
            "\u0292",
            "\u0282",
            "\u0290",
            "\xe7",
            "\u029D",
            "x",
            "\u0263",
            "\u03C7",
            "\u0281",
            "\u0127",
            "\u0295",
            "h",
            "\u0266",
            // Lateral fricative
            "\u026C",
            "\u026E",
            // Approximant
            "\u028B",
            "\u0279",
            "\u027B",
            "j",
            "\u0270",
            // Lateral approximant
            "l",
            "\u026D",
            "\u028E",
            "\u029F"
        ], I = [
            // Clicks
            "\u0298",
            "\u01C0",
            "\u01C3",
            "\u01C2",
            "\u01C1",
            // Voiced implosive
            "\u0253",
            "\u0257",
            "\u0284",
            "\u0260",
            "\u029B",
            // Ejectives (already existing chars + unicode char \u02BC)
            "\u02BC"
        ], G = [
            // Close
            "i",
            "y",
            "\u0268",
            "\u0289",
            "\u026F",
            "u",
            "\u026A",
            "\u028F",
            "\u028A",
            // Close-mid
            "e",
            "\xf8",
            "\u0258",
            "\u025A",
            "\u0275",
            "\u0264",
            "o",
            "\u0259",
            // Open-mid
            "\u025B",
            "\u0153",
            "\u025C",
            "\u025D",
            "\u025E",
            "\u028C",
            "\u0254",
            "\xe6",
            "\u0250",
            // Open
            "a",
            "\u0276",
            "\u0251",
            "\u0252"
        ], z = [
            "\u028D",
            "w",
            "\u0265",
            "\u029C",
            "\u02A2",
            "\u02A1",
            "\u0255",
            "\u0291",
            "\u027A",
            "\u0267",
            "\u0361",
            // char ͡
            "\u035C"
        ], K = [
            "\u0325",
            // char ̥
            "\u030A",
            // char ̊
            "\u032C",
            // char ̬
            "\u02B0",
            "\u0339",
            // char ̹
            "\u031C",
            // char ̜
            "\u031F",
            // char ̟
            "\u0320",
            // char ̠
            "\u0308",
            // char ̈
            "\u033D",
            // char ̽
            "\u0329",
            // char ̩
            "\u032F",
            // char ̯
            "\u02DE",
            // char ˞
            "\u0324",
            // char ̤
            "\u0330",
            // char ̰
            "\u033C",
            // char ̼
            "\u02B7",
            "\u02B2",
            "\u02E0",
            "\u02E4",
            "\u0334",
            // char ̴
            "\u031D",
            // char ̝
            "\u031E",
            // char ̞
            "\u0318",
            // char ̘
            "\u0319",
            // char ̙
            "\u032A",
            // char ̪
            "\u033A",
            // char ̺
            "\u033B",
            // char ̻
            "\u0303",
            //char ̃
            "\u207F",
            "\u02E1",
            "\u031A"
        ], B = [
            "\u02C8",
            "\u02CC",
            "\u02D0",
            "\u02D1",
            "\u0306",
            // char ̆
            "|",
            "\u2016",
            ".",
            "\u203F"
        ], X = [
            "\u030B",
            "\u0301",
            "\u0304",
            "\u0300",
            "\u030F",
            "\u2193",
            "\u2191",
            "\u2197",
            "\u2198",
            "\u030C",
            "\u0302"
        ], J = [
            "\xe0",
            "\xe8",
            "\xec",
            "\xf2",
            "\xf9",
            "\xc0",
            "\xc8",
            "\xcc",
            "\xd2",
            "\xd9",
            "\xe1",
            "\xe9",
            "\xed",
            "\xf3",
            "\xfa",
            "\xfd",
            "\xc1",
            "\xc9",
            "\xcd",
            "\xd3",
            "\xda",
            "\xdd",
            "\xe2",
            "\xea",
            "\xee",
            "\xf4",
            "\xfb",
            "\xc2",
            "\xca",
            "\xce",
            "\xd4",
            "\xdb",
            "\xe4",
            "\xeb",
            "\xef",
            "\xf6",
            "\xfc",
            "\xff",
            "\xc4",
            "\xcb",
            "\xcf",
            "\xd6",
            "\xdc",
            "\u0178",
            "\xe3",
            "\xf1",
            "\xf5",
            "\xc3",
            "\xd1",
            "\xd5",
            "\xe5",
            "\xc5"
        ], j = [
            "\u0269",
            "\u026B",
            "\u0277",
            "\u027C",
            "\u027F",
            "\u0285",
            "\u0286",
            "\u0287",
            "\u0293",
            "\u0296",
            "\u0297",
            "\u029A",
            "\u029E",
            "\u02A0",
            "\u02A3",
            "\u02A4",
            "\u02A5",
            "\u02A6",
            "\u02A7",
            "\u02A8",
            "\u02A9",
            "\u02AA",
            "\u02AB",
            "\u02AC",
            "\u02AD",
            "\u02AE",
            "\u02AF"
        ], D = [
            ...C,
            ...I,
            ...G,
            ...z,
            ...K,
            ...B,
            ...X,
            ...J,
            ...j
        ], U = [
            "+",
            e.hyphen,
            e.digit,
            "%"
        ];
        this.textModifierText = e.choice(e.digit, e.letter, e.hyphen, e.space, ...D, ...U).oneOrMore.ast, this.textModifierTextDoubleQuote = e.choice(e.digit, e.letter, e.hyphen, e.space, ...D, ...U, "'").oneOrMore.ast, this.textModifierValue = e.seq(k, e.choice(e.singleQuoted(this.textModifierText), e.doubleQuoted(this.textModifierTextDoubleQuote))), this.textModifierKeyOptionalValue = e.seq(this.textModifierKey, this.textModifierValue.opt).ast, this.modifier = e.bracketed(e.delimited(this.textModifierKeyOptionalValue.ws, v));
        const $ = e.parenthesized(this.plainTextModifier), H = e.parenthesized(this.plainTextPhone);
        this.textModifier = e.seq(e.choice($, H), this.modifier).ast, this.sectionModifierKey = e.keywords("lang", "voice", "defaults", "dj", "newscaster", "excited", "disappointed").ast, this.sectionModifierText = e.choice(e.digit, e.letter, e.hyphen).oneOrMore.ast, this.sectionModifierValue = e.seq(k, e.choice(e.singleQuoted(this.sectionModifierText), e.doubleQuoted(this.sectionModifierText))), this.sectionModifierKeyOptionalValue = e.seq(this.sectionModifierKey, this.sectionModifierValue.opt).ast, this.sectionModifier = e.bracketed(e.delimited(this.sectionModifierKeyOptionalValue.ws, v)), this.section = e.seq("#", this.sectionModifier).ast, this.valueNone = "none", this.valueXWeak = "x-weak", this.valueWeak = "weak", this.valueMedium = "medium", this.valueStrong = "strong", this.valueXStrong = "x-strong", this.breakStrengthValue = e.keywords(this.valueNone, this.valueXWeak, this.valueWeak, this.valueMedium, this.valueStrong, this.valueXStrong).ast, this.breakValue = e.choice(this.breakStrengthValue, this.time).ast, this.break = e.seq("[", "break", ":", e.choice(e.singleQuoted(this.breakValue), e.doubleQuoted(this.breakValue)), "]").ast, this.markTag = e.seq("[", "mark", ":", e.choice(e.singleQuoted(this.xsdToken), e.doubleQuoted(this.xsdToken)), "]").ast, this.any = e.advance, this.inline = e.choice(this.backgroundAudio, this.lexicon, this.bookmark, this.textModifier, this.emphasis, this.shortBreak, this.silence, this.break, this.audio, this.markTag, this.plainTextSpecialChars, this.plainText, this.any).unless(e.newLine), this.lineEnd = e.newLine.or(e.assert(e.end)).ast, this.emptyLine = e.char(" 	").zeroOrMore.then(e.newLine).ast, this.restOfLine = e.seq(this.inline.zeroOrMore).then(this.lineEnd), this.simpleLine = e.seq(this.emptyLine.not, e.notEnd, this.restOfLine).ast, this.paragraph = this.simpleLine.oneOrMore.ast, this.content = e.choice(this.section, this.paragraph, this.emptyLine), this.document = this.content.zeroOrMore.ast;
    }();
    return e.registerGrammar("speechmarkdown", t, t.document);
}
class $b0c9077b7a60729e$var$ot {
    constructor(){
        this.myna = $b0c9077b7a60729e$var$nt.Myna, $b0c9077b7a60729e$var$st(this.myna), this.parser = this.myna.parsers.speechmarkdown;
    }
    parse(e) {
        return this.parser(e);
    }
}
class $b0c9077b7a60729e$export$fdd03b388331c324 {
    constructor(e){
        this.options = e, this.defaults = {
            includeFormatterComment: !1,
            includeParagraphTag: !1,
            includeSpeakTag: !0,
            platform: "",
            // default - text formatter
            preserveEmptyLines: !0
        }, this.options = {
            ...this.defaults,
            ...e
        };
    }
    get Parser() {
        return this.parser || (this.parser = new $b0c9077b7a60729e$var$ot()), this.parser;
    }
    toText(e, t) {
        const i = {
            ...this.options,
            ...t
        }, r = this.Parser.parse(e);
        return $b0c9077b7a60729e$var$it(i).format(r);
    }
    toSSML(e, t) {
        const i = {
            ...this.options,
            ...t
        };
        let r = e;
        try {
            do {
                const v = this.Parser.parse(r);
                r = $b0c9077b7a60729e$var$rt(i).format(v);
            }while (r.includes(")["));
            let s = "";
            if (r.includes("<mstts:backgroundaudio")) {
                const v = r.indexOf("<mstts:backgroundaudio"), C = r.substring(v).indexOf("/>") + 2;
                s = r.substring(v, C), r = r.replace(s, "");
            }
            let o = "", l = "";
            i.globalVoiceAndLang && i.globalVoiceAndLang.voice && (o = `<voice name="${i.globalVoiceAndLang.voice}">`, l = "</voice>");
            let d = "", f = "";
            return i.globalVoiceAndLang && i.globalVoiceAndLang.lang && (d = `<lang xml:lang="${i.globalVoiceAndLang.lang}">`, f = "</lang>"), `${s + o + d + r + f + l}`;
        } catch (s) {
            return console.log("Error : ", s), r;
        }
    }
    toAST(e) {
        return this.Parser.parse(e);
    }
    toASTString(e) {
        return this.Parser.parse(e).toString();
    }
}

});


parcelRegister("4Twm7", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("hvc5r"),
    $parcel$import("fboBS")
]).then(()=>parcelRequire('jG5jU'));

});

parcelRegister("3i7uv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2018eeb453c43d9e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $9lyYS = parcelRequire("9lyYS");

var $1U3dy = parcelRequire("1U3dy");

var $iLzAK = parcelRequire("iLzAK");

var $37abB = parcelRequire("37abB");

var $hRvNU = parcelRequire("hRvNU");
const $2018eeb453c43d9e$var$MenuDisplayer = ({ hideMenu: hideMenu })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const menu = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.menu);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const isBorne = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isBorne);
    const displayControls = (0, $5FZWK.useSelector)((state)=>state.viewReducer.displayControls);
    const dashboardOpened = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.dashboardOpened);
    const [topOfRemote, setTopOfRemote] = (0, $bxRTa.useState)();
    return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1U3dy.default), {
        hideMenu: !!hideMenu
    }) : displayControls ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            isBorne && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $37abB.default), {
                top: topOfRemote
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9lyYS.default), {
                hideMenu: !!hideMenu,
                setTopOfRemote: setTopOfRemote
            }),
            dashboardOpened && (menu?.categories?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iLzAK.default), {
                toggleDashboard: ()=>dispatch((0, $cto9a.storeActions).utils.toggleDashboard(true))
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hRvNU.default), {
                toggleDashboard: ()=>dispatch((0, $cto9a.storeActions).utils.toggleDashboard(true))
            }))
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $2018eeb453c43d9e$export$2e2bcd8739ae039 = $2018eeb453c43d9e$var$MenuDisplayer;

});
parcelRegister("9lyYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $12031e58728d33c5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $726gw = parcelRequire("726gw");
const $12031e58728d33c5$var$Remote = ({ hideMenu: hideMenu = false, setTopOfRemote: setTopOfRemote })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const disableHistory = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableHistory);
    const disableSubtitles = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableSubtitles);
    const remoteData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.remote);
    const menuData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.menu);
    const baseMenuData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.baseMenu);
    const customMenuData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.customMenu);
    const containerData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.answerpanel);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const currentHeight = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentHeight);
    const isTactile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isTactile);
    const theme = (0, $5FZWK.useSelector)((state)=>state.viewReducer.theme);
    const route = (0, $5FZWK.useSelector)((state)=>state.viewReducer.route);
    const supported = (0, $5FZWK.useSelector)((state)=>state.localeReducer.supported);
    const disableSound = (0, $5FZWK.useSelector)((state)=>state.speechReducer.disableSound);
    const [absoluteVerticalTop, setAbsoluteVerticalTop] = (0, $bxRTa.useState)(undefined);
    const [absoluteVerticalBottom, setAbsoluteVerticalBottom] = (0, $bxRTa.useState)(undefined);
    const [backgroundColor, setBackgroundColor] = (0, $bxRTa.useState)();
    (0, $bxRTa.useEffect)(()=>{
        const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
        switch(currentDeviceType){
            // In landscape mode, we set the default position from the bottom
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                if (isTactile) {
                    if (remoteData?.desktopTactile) {
                        setAbsoluteVerticalBottom(undefined);
                        setAbsoluteVerticalTop(remoteData.desktopTactile);
                    } else if (typeof containerData === 'object' && containerData.landscape?.containerRowStartText) {
                        setAbsoluteVerticalBottom(containerData.landscape.containerRowStartText * currentHeight / 12 - remToPx * 1.5);
                        setAbsoluteVerticalTop(undefined);
                    } else {
                        setAbsoluteVerticalBottom(currentHeight / 6 - remToPx * 1.5);
                        setAbsoluteVerticalTop(undefined);
                    }
                } else {
                    if (remoteData?.desktop) {
                        setAbsoluteVerticalBottom(undefined);
                        setAbsoluteVerticalTop(remoteData.desktop);
                    } else if (typeof containerData === 'object' && containerData.landscape?.containerRowStartText) {
                        setAbsoluteVerticalBottom(containerData.landscape.containerRowStartText * currentHeight / 12 - remToPx * 1.5);
                        setAbsoluteVerticalTop(undefined);
                    } else {
                        setAbsoluteVerticalBottom(currentHeight / 6 - remToPx * 1.5);
                        setAbsoluteVerticalTop(undefined);
                    }
                }
                break;
            // In borne mode, we set the default position from the top
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                let verticalTop = 0;
                if (remoteData?.verticalTactile) verticalTop = remoteData.verticalTactile;
                else if (typeof containerData === 'object' && containerData.borne?.containerRowStart) verticalTop = containerData.borne.containerRowStart * currentHeight / 12;
                else verticalTop = 5 * currentHeight / 12;
                setAbsoluteVerticalBottom(undefined);
                setAbsoluteVerticalTop(verticalTop);
                setTopOfRemote?.(verticalTop);
                break;
        }
    }, [
        remoteData,
        containerData,
        currentHeight,
        currentDeviceType,
        isTactile
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setBackgroundColor(theme === (0, $2rYkD.Theme).dark ? '#00000099' : '#FFFFFF99');
    }, [
        theme
    ]);
    const handleClick = (e)=>{
        dispatch((0, $cto9a.storeActions).utils.setClickedOnUI((0, $2rYkD.UIPart).remote));
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-framework-remote",
        className: "rf-absolute rf-z-[10] rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2 rf-right-6 large-vertical:rf-right-9",
        style: {
            top: absoluteVerticalTop,
            bottom: absoluteVerticalBottom
        },
        onClick: (e)=>handleClick(e),
        children: route === (0, $2rYkD.Routes).News ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).home,
                    backgroundColor: backgroundColor
                }),
                !hideMenu && (menuData?.categories?.length || customMenuData?.length || baseMenuData && baseMenuData.length > 1) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).menu,
                    backgroundColor: backgroundColor
                }),
                supported.length > 1 && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).language,
                    backgroundColor: backgroundColor
                }),
                mode === (0, $2rYkD.Mode).vocal && !disableSubtitles && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).subtitles,
                    backgroundColor: backgroundColor
                }),
                !disableSound && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).sound,
                    backgroundColor: backgroundColor
                }),
                !disableHistory && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).history,
                    backgroundColor: backgroundColor
                })
            ]
        })
    });
};
var $12031e58728d33c5$export$2e2bcd8739ae039 = $12031e58728d33c5$var$Remote;

});
parcelRegister("726gw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d4c52f4e003340$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("cMz42");
var $iJ1h5 = parcelRequire("iJ1h5");
var $hnSXC = parcelRequire("hnSXC");
var $gxLEu = parcelRequire("gxLEu");
var $6O1HN = parcelRequire("6O1HN");
var $l4nO8 = parcelRequire("l4nO8");
var $iqleb = parcelRequire("iqleb");
var $c5iXz = parcelRequire("c5iXz");
var $hpcDC = parcelRequire("hpcDC");
parcelRequire("dikAc");
var $9f9kU = parcelRequire("9f9kU");
parcelRequire("kMAJU");
var $04Syy = parcelRequire("04Syy");
const $d1d4c52f4e003340$var$RemoteButton = ({ type: type, backgroundColor: backgroundColor, cause: cause })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const theme = (0, $5FZWK.useSelector)((state)=>state.viewReducer.theme);
    const displaySubtitles = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.displaySubtitles);
    const muted = (0, $5FZWK.useSelector)((state)=>state.speechReducer.muted);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    const currentSubViewRef = (0, $bxRTa.useRef)((0, $2rYkD.CurrentSubView).none);
    const [icon, setIcon] = (0, $bxRTa.useState)();
    const [label, setLabel] = (0, $bxRTa.useState)();
    const [hover, setHover] = (0, $bxRTa.useState)(false);
    const [backgroundColorHover, setBackgroundColorHover] = (0, $bxRTa.useState)(undefined);
    (0, $bxRTa.useEffect)(()=>{
        currentSubViewRef.current = currentSubView;
    }, [
        currentSubView
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setBackgroundColorHover(backgroundColor?.replace('99', 'E6'));
    }, [
        backgroundColor
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(type){
            case (0, $2rYkD.RemoteButtonType).history:
                setLabel(translation.common.history);
                break;
            case (0, $2rYkD.RemoteButtonType).home:
                setLabel('home');
                break;
            case (0, $2rYkD.RemoteButtonType).language:
                setLabel(translation.common.lang);
                break;
            case (0, $2rYkD.RemoteButtonType).menu:
                setLabel(translation.common.menu);
                break;
            case (0, $2rYkD.RemoteButtonType).sound:
                setLabel(translation.common.sound);
                break;
            case (0, $2rYkD.RemoteButtonType).subtitles:
                setLabel(translation.common.subtitle);
                break;
            case (0, $2rYkD.RemoteButtonType).text:
                setLabel(translation.common.mode);
                break;
            case (0, $2rYkD.RemoteButtonType).close:
                setLabel(translation.common.close);
                break;
        }
    }, [
        type,
        translation
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(type){
            case (0, $2rYkD.RemoteButtonType).history:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)($iJ1h5.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).home:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)($hnSXC.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).language:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)($gxLEu.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).menu:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)($6O1HN.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).sound:
                setIcon(muted ? /*#__PURE__*/ (0, $fl9nK.jsx)($l4nO8.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)($iqleb.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).subtitles:
                setIcon(displaySubtitles ? /*#__PURE__*/ (0, $fl9nK.jsx)($hpcDC.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)($c5iXz.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).text:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $9f9kU.default), {
                    className: "rf-w-5",
                    color: "#A4A7AF"
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).close:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $04Syy.default), {
                    className: "rf-h-8 rf-w-8",
                    color: "#000",
                    strokeWidth: 1
                }));
                break;
        }
    }, [
        type,
        theme,
        displaySubtitles,
        muted
    ]);
    const handleClick = ()=>{
        switch(type){
            case (0, $2rYkD.RemoteButtonType).history:
                if (currentSubViewRef.current === (0, $2rYkD.CurrentSubView).history) {
                    dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).none));
                    dispatch((0, $cto9a.storeActions).directline.sendEvent({
                        name: 'Davi.CloseWindow',
                        callback: ()=>dispatch((0, $cto9a.storeActions).directline.sendEvent({
                                name: 'Davi.CloseWindowHistory'
                            }))
                    }));
                } else dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).history));
                break;
            case (0, $2rYkD.RemoteButtonType).home:
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).none));
                dispatch((0, $cto9a.storeActions).directline.sendEvent({
                    name: 'showHome'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).language:
                if (currentSubViewRef.current === (0, $2rYkD.CurrentSubView).languages) {
                    dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).none));
                    dispatch((0, $cto9a.storeActions).directline.sendEvent({
                        name: 'Davi.CloseWindow',
                        callback: ()=>dispatch((0, $cto9a.storeActions).directline.sendEvent({
                                name: 'Davi.CloseWindowLanguages'
                            }))
                    }));
                } else dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).languages));
                break;
            case (0, $2rYkD.RemoteButtonType).menu:
                dispatch((0, $cto9a.storeActions).utils.toggleDashboard());
                break;
            case (0, $2rYkD.RemoteButtonType).sound:
                dispatch((0, $cto9a.storeActions).speech.toggleMuted());
                break;
            case (0, $2rYkD.RemoteButtonType).subtitles:
                dispatch((0, $cto9a.storeActions).retorik.toggleSubtitles());
                break;
            case (0, $2rYkD.RemoteButtonType).text:
                dispatch((0, $cto9a.storeActions).retorik.setCanFocusSendBox(true));
                dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing));
                dispatch((0, $cto9a.storeActions).speech.setMode((0, $2rYkD.Mode).text));
                break;
            case (0, $2rYkD.RemoteButtonType).close:
                switch(cause){
                    case (0, $2rYkD.CloseButtonCause).dashboard:
                        dispatch((0, $cto9a.storeActions).utils.setDashboardOpened(false));
                        break;
                    case (0, $2rYkD.CloseButtonCause).detailedpoi:
                        dispatch((0, $cto9a.storeActions).utils.setCloseDetailedPOI(true));
                        break;
                    case (0, $2rYkD.CloseButtonCause).fullscreenimage:
                        dispatch((0, $cto9a.storeActions).utils.setFullScreenImage(undefined));
                        break;
                    case (0, $2rYkD.CloseButtonCause).list:
                        dispatch((0, $cto9a.storeActions).utils.setCloseList(Date.now()));
                        break;
                    case (0, $2rYkD.CloseButtonCause).emergency:
                    case (0, $2rYkD.CloseButtonCause).history:
                    case (0, $2rYkD.CloseButtonCause).languages:
                    case (0, $2rYkD.CloseButtonCause).weather:
                    case (0, $2rYkD.CloseButtonCause).map:
                        dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).none));
                        dispatch((0, $cto9a.storeActions).directline.sendEvent({
                            name: 'Davi.CloseWindow',
                            callback: ()=>dispatch((0, $cto9a.storeActions).directline.sendEvent({
                                    name: `Davi.CloseWindow${cause}`
                                }))
                        }));
                        break;
                    case (0, $2rYkD.CloseButtonCause).news:
                        dispatch((0, $cto9a.storeActions).view.setRoute((0, $2rYkD.Routes).Home));
                        break;
                    case (0, $2rYkD.CloseButtonCause).none:
                    default:
                        break;
                }
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: `retorik-framework-remote-${type}`,
        className: "rf-w-10 rf-h-10 rf-rounded-half rf-flex rf-justify-center rf-items-center rf-cursor-pointer",
        style: {
            zIndex: type === (0, $2rYkD.RemoteButtonType).close ? 60 : 5,
            backgroundColor: hover ? backgroundColorHover : backgroundColor,
            boxShadow: type === (0, $2rYkD.RemoteButtonType).text || type === (0, $2rYkD.RemoteButtonType).close ? '0px 0px 6px #1A1A1A80' : undefined
        },
        "aria-label": label,
        // data-map used in interactive map to use this button externaly
        "data-map": type === (0, $2rYkD.RemoteButtonType).close ? 'fermer' : 'other',
        onClick: handleClick,
        onPointerEnter: ()=>setHover(true),
        onPointerLeave: ()=>setHover(false),
        children: icon
    });
};
var $d1d4c52f4e003340$export$2e2bcd8739ae039 = $d1d4c52f4e003340$var$RemoteButton;

});
parcelRegister("cMz42", function(module, exports) {

$parcel$export(module.exports, "HistoryIcon", () => (parcelRequire("iJ1h5")).default);
$parcel$export(module.exports, "HomeIcon", () => (parcelRequire("hnSXC")).default);
$parcel$export(module.exports, "LanguageIcon", () => (parcelRequire("gxLEu")).default);
$parcel$export(module.exports, "MenuIcon", () => (parcelRequire("6O1HN")).default);
$parcel$export(module.exports, "SoundOffIcon", () => (parcelRequire("l4nO8")).default);
$parcel$export(module.exports, "SoundOnIcon", () => (parcelRequire("iqleb")).default);
$parcel$export(module.exports, "SubtitlesOffIcon", () => (parcelRequire("c5iXz")).default);
$parcel$export(module.exports, "SubtitlesOnIcon", () => (parcelRequire("hpcDC")).default);

var $iJ1h5 = parcelRequire("iJ1h5");

var $hnSXC = parcelRequire("hnSXC");

var $gxLEu = parcelRequire("gxLEu");

var $6O1HN = parcelRequire("6O1HN");

var $l4nO8 = parcelRequire("l4nO8");

var $iqleb = parcelRequire("iqleb");

var $c5iXz = parcelRequire("c5iXz");

var $hpcDC = parcelRequire("hpcDC");

});
parcelRegister("iJ1h5", function(module, exports) {

$parcel$export(module.exports, "default", () => $04141648ecd3fad1$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $04141648ecd3fad1$var$HistoryIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 19.4 19.401",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-77.528 -79.501)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M378.724,244.778a.614.614,0,0,0-1.227,0v3.891l2.453,2.453a.614.614,0,1,0,.868-.868l-2.093-2.093Z",
                    transform: "translate(-290.737 -159.395)",
                    fill: color || '#FFF'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M94.055,82.374A9.73,9.73,0,0,0,87.189,79.5a9.544,9.544,0,0,0-6.848,2.8l-.127.127,0-.93a.677.677,0,0,0-.677-.673h0a.677.677,0,0,0-.673.68l.013,2.552a.679.679,0,0,0,.673.673l2.552.013a.677.677,0,0,0,.007-1.354l-.93,0,.128-.128a8.2,8.2,0,0,1,5.884-2.408,8.457,8.457,0,0,1,8.392,8.4,8.238,8.238,0,0,1-8.3,8.3,8.44,8.44,0,0,1-8.318-9.575.678.678,0,0,0-.579-.762.688.688,0,0,0-.093-.006.677.677,0,0,0-.669.585A9.806,9.806,0,0,0,87.27,98.9h.051a9.591,9.591,0,0,0,9.607-9.658A9.73,9.73,0,0,0,94.055,82.374Z",
                    fill: color || '#FFF'
                })
            ]
        })
    });
};
var $04141648ecd3fad1$export$2e2bcd8739ae039 = $04141648ecd3fad1$var$HistoryIcon;

});

parcelRegister("hnSXC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e5d3ddaa1d3e5b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $f4e5d3ddaa1d3e5b$var$HomeIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17.875 17.044",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M13.721,3.5V4.9l1.663,1.33V3.5Zm2.91,3.733V3.289A1.039,1.039,0,0,0,15.592,2.25H13.513a1.039,1.039,0,0,0-1.039,1.039V3.9l-.339-.271a3.118,3.118,0,0,0-3.9,0l-6.756,5.4a.624.624,0,0,0,.779.974l.65-.52v8.555H1.874a.624.624,0,0,0,0,1.247H18.5a.624.624,0,1,0,0-1.247H17.462V9.492l.65.52a.624.624,0,0,0,.779-.974Zm-.416,1.265L11.356,4.607a1.871,1.871,0,0,0-2.337,0L4.16,8.494v9.552H7.07V14.472a11.466,11.466,0,0,1,.051-1.41,1.7,1.7,0,0,1,1.615-1.615,11.468,11.468,0,0,1,1.41-.051h.082a11.469,11.469,0,0,1,1.41.051,1.7,1.7,0,0,1,1.615,1.615,11.451,11.451,0,0,1,.051,1.41v3.574h2.91Zm-4.157,9.552V14.513a10.966,10.966,0,0,0-.04-1.285c-.036-.27-.1-.355-.143-.4s-.132-.106-.4-.143a10.966,10.966,0,0,0-1.285-.04,10.964,10.964,0,0,0-1.285.04c-.27.036-.355.1-.4.143s-.106.132-.143.4a10.957,10.957,0,0,0-.04,1.285v3.533ZM10.187,7.238a1.039,1.039,0,1,0,1.039,1.039A1.039,1.039,0,0,0,10.187,7.238ZM7.9,8.278a2.286,2.286,0,1,1,2.286,2.286A2.286,2.286,0,0,1,7.9,8.278Z",
            transform: "translate(-1.25 -2.25)",
            fill: color || "#FFF",
            fillRule: "evenodd"
        })
    });
};
var $f4e5d3ddaa1d3e5b$export$2e2bcd8739ae039 = $f4e5d3ddaa1d3e5b$var$HomeIcon;

});

parcelRegister("gxLEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8361783ffd12eac$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $d8361783ffd12eac$var$LanguageIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17.578 17.581",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(0)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M16.861,8.789V2.572A2.072,2.072,0,0,0,14.789.5H8.572A2.072,2.072,0,0,0,6.5,2.572V8.789a2.072,2.072,0,0,0,2.072,2.072h6.217A2.072,2.072,0,0,0,16.861,8.789Z",
                    transform: "translate(0.217)",
                    fill: "none",
                    stroke: color || '#FFF',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M4.645,6.5H2.572A2.072,2.072,0,0,0,.5,8.576v6.216a2.072,2.072,0,0,0,2.072,2.072h0l6.217-.011a2.072,2.072,0,0,0,2.069-2.072V12.717",
                    transform: "translate(0 0.217)",
                    fill: "none",
                    stroke: color || '#FFF',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    transform: "translate(2.572 10.864)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M3.106,1H0",
                            transform: "translate(0.002 -1.003)",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M4.625,2.5,3.589,3.536A11.99,11.99,0,0,1,1,5.09",
                            transform: "translate(0.038 -0.949)",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M1,1A4.739,4.739,0,0,0,2.553,3.592a17.063,17.063,0,0,0,2.59,1.553",
                            transform: "translate(0.038 -1.003)",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    transform: "translate(8.789 2.572)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M3.108,0,0,6.217",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M3,0,6.108,6.217",
                            transform: "translate(0.108)",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M0,0V4.145",
                            transform: "translate(5.181 4.145) rotate(90)",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        })
                    ]
                })
            ]
        })
    });
};
var $d8361783ffd12eac$export$2e2bcd8739ae039 = $d8361783ffd12eac$var$LanguageIcon;

});

parcelRegister("6O1HN", function(module, exports) {

$parcel$export(module.exports, "default", () => $74d1b4923df236f5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $74d1b4923df236f5$var$MenuIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17.2 11.2",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M4,17H20M4,12H20M4,7H20",
            transform: "translate(-3.4 -6.4)",
            fill: "none",
            stroke: color || '#FFF',
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.2"
        })
    });
};
var $74d1b4923df236f5$export$2e2bcd8739ae039 = $74d1b4923df236f5$var$MenuIcon;

});

parcelRegister("l4nO8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf7fe1e46a348d70$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $bf7fe1e46a348d70$var$SoundOffIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 15.106",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M4.069,12.039l.3-.5-.138-.083H4.069Zm0-6.972v.581H4.23l.138-.083ZM9.883,1.581h.581a.581.581,0,0,0-.88-.5Zm0,13.943-.3.5a.581.581,0,0,0,.88-.5ZM13.3,6.5l-.411-.411-.822.822.411.411Zm2.466,4.108.411.411L17,10.2l-.411-.411Zm.822-3.286L17,6.91l-.822-.822-.411.411Zm-4.11,2.464-.411.411.822.822.411-.411ZM4.069,11.457H1.744V12.62H4.069Zm-2.325,0a.58.58,0,0,1-.581-.581H0A1.743,1.743,0,0,0,1.744,12.62Zm-.581-.581V6.229H0v4.648Zm0-4.648a.58.58,0,0,1,.581-.58V4.486A1.743,1.743,0,0,0,0,6.229Zm.581-.58H4.069V4.486H1.744Zm2.624-.083L10.182,2.08l-.6-1L3.77,4.569ZM9.3,1.581V15.525h1.163V1.581Zm.88,13.445L4.368,11.54l-.6,1,5.813,3.486Zm2.3-7.7,3.288,3.286.822-.822L13.3,6.5ZM15.767,6.5,12.479,9.785l.822.822,3.288-3.286Z",
            transform: "translate(0 -1)",
            fill: color || '#FFF'
        })
    });
};
var $bf7fe1e46a348d70$export$2e2bcd8739ae039 = $bf7fe1e46a348d70$var$SoundOffIcon;

});

parcelRegister("iqleb", function(module, exports) {

$parcel$export(module.exports, "default", () => $36869e013bd47b79$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $36869e013bd47b79$var$SoundOnIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 14.724",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M3.967,11.76l.291-.486-.135-.081H3.967Zm0-6.8v.567h.157l.135-.081Zm5.667-3.4H10.2a.567.567,0,0,0-.858-.486Zm0,13.591-.291.486a.567.567,0,0,0,.858-.486ZM15.7,4.564l-.4-.4-.8.8.4.4Zm-.8,6.8-.4.4.8.8.4-.4ZM3.967,11.193H1.7v1.133H3.967Zm-2.267,0a.566.566,0,0,1-.567-.566H0a1.7,1.7,0,0,0,1.7,1.7Zm-.567-.566V6.1H0v4.53Zm0-4.53A.566.566,0,0,1,1.7,5.531V4.4A1.7,1.7,0,0,0,0,6.1ZM1.7,5.531H3.967V4.4H1.7ZM4.258,5.45l5.667-3.4-.583-.972-5.667,3.4ZM9.067,1.567V15.158H10.2V1.567Zm.858,13.105-5.667-3.4-.583.972,5.667,3.4ZM15.3,4.964l-.4.4h0l0,0,.023.025c.022.025.057.067.1.126a3.611,3.611,0,0,1,.336.55,5.086,5.086,0,0,1,.507,2.295H17a6.217,6.217,0,0,0-.627-2.8,4.757,4.757,0,0,0-.443-.724c-.062-.083-.115-.147-.155-.192l-.049-.054-.016-.017L15.7,4.568l0,0h0Zm.567,3.4a5.086,5.086,0,0,1-.507,2.295,3.609,3.609,0,0,1-.336.55c-.044.059-.079.1-.1.126l-.023.025,0,0h0l.4.4.4.4h0l0,0,.006-.006.016-.017.049-.054c.04-.045.093-.11.155-.192a4.764,4.764,0,0,0,.443-.724A6.216,6.216,0,0,0,17,8.362Z",
            transform: "translate(0 -1)",
            fill: color || '#FFF'
        })
    });
};
var $36869e013bd47b79$export$2e2bcd8739ae039 = $36869e013bd47b79$var$SoundOnIcon;

});

parcelRegister("c5iXz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd031e8c6745d61a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $cd031e8c6745d61a$var$SubtitlesOffIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17.088 17.088",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-41.7 -41.7)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M521.309,212.887v.016l.016-.016Z",
                    transform: "translate(-468.172 -167.105)",
                    fill: "none"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M42.892,52.629V47.859c0-1.866.355-3.089,1.116-3.851s1.985-1.116,3.851-1.116h4.769a7.124,7.124,0,0,1,2.926.488l.886-.886a7.6,7.6,0,0,0-3.812-.795H47.859c-2.2,0-3.694.466-4.694,1.466S41.7,45.657,41.7,47.859v4.769a7.6,7.6,0,0,0,.794,3.812l.886-.886A7.129,7.129,0,0,1,42.892,52.629Z",
                    transform: "translate(0 0)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M157.118,147.4v4.769c0,1.865-.355,3.088-1.116,3.85s-1.986,1.117-3.851,1.117h-4.769a7.333,7.333,0,0,1-2.835-.448l-.893.893a7.745,7.745,0,0,0,3.728.747h4.769c2.2,0,3.694-.466,4.694-1.467s1.466-2.491,1.466-4.693V147.4a7.741,7.741,0,0,0-.747-3.728l-.893.893A7.328,7.328,0,0,1,157.118,147.4Z",
                    transform: "translate(-99.522 -99.537)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M498.667,572.3H497.2a.6.6,0,1,0,0,1.192h1.471a.6.6,0,0,0,0-1.192Z",
                    transform: "translate(-444.052 -517.947)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M252.716,573.492a.6.6,0,1,0,0-1.192h-3.195l-1.192,1.192Z",
                    transform: "translate(-201.702 -517.947)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M375.711,464.192h4.395a.6.6,0,0,0,0-1.192h-4.189l-.775.775A.6.6,0,0,0,375.711,464.192Z",
                    transform: "translate(-325.491 -411.254)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M192.3,463a.6.6,0,1,0,0,1.192h.123L193.612,463Z",
                    transform: "translate(-146.423 -411.254)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M201.268,170.421a1.643,1.643,0,0,0-.113-.636,1.6,1.6,0,0,0-.3-.469,1.926,1.926,0,0,0-.418-.342,4.719,4.719,0,0,0-.479-.256q-.244-.113-.479-.213a3.17,3.17,0,0,1-.42-.216,1.057,1.057,0,0,1-.3-.263.568.568,0,0,1-.11-.35.683.683,0,0,1,.049-.258.537.537,0,0,1,.15-.209.728.728,0,0,1,.251-.136,1.131,1.131,0,0,1,.352-.049,1.679,1.679,0,0,1,.474.063,2.633,2.633,0,0,1,.38.141q.164.077.277.143a.391.391,0,0,0,.164.066.116.116,0,0,0,.082-.028.185.185,0,0,0,.047-.089.858.858,0,0,0,.023-.155q.007-.094.007-.23t0-.2a.906.906,0,0,0-.016-.136.378.378,0,0,0-.028-.087.342.342,0,0,0-.063-.08.784.784,0,0,0-.192-.117,2.258,2.258,0,0,0-.333-.127,2.956,2.956,0,0,0-.4-.089,2.873,2.873,0,0,0-.432-.033,2.832,2.832,0,0,0-.791.108,1.858,1.858,0,0,0-.647.326,1.573,1.573,0,0,0-.436.549,1.725,1.725,0,0,0-.162.767,1.7,1.7,0,0,0,.113.652,1.612,1.612,0,0,0,.293.472,1.916,1.916,0,0,0,.411.342,4.315,4.315,0,0,0,.474.256q.244.113.474.213a3.055,3.055,0,0,1,.41.216,1.118,1.118,0,0,1,.293.263.567.567,0,0,1,.113.354.778.778,0,0,1-.066.324.647.647,0,0,1-.19.244.9.9,0,0,1-.3.152,1.392,1.392,0,0,1-.4.054,2.12,2.12,0,0,1-.6-.077,2.773,2.773,0,0,1-.448-.171,3.253,3.253,0,0,1-.307-.171.39.39,0,0,0-.185-.077.135.135,0,0,0-.082.026.175.175,0,0,0-.056.087.7.7,0,0,0-.031.16q-.009.1-.009.244a1.606,1.606,0,0,0,.026.331.351.351,0,0,0,.087.176.992.992,0,0,0,.2.141,2.076,2.076,0,0,0,.345.152,3.319,3.319,0,0,0,.476.124,3.112,3.112,0,0,0,.584.052,3.033,3.033,0,0,0,.873-.122c.054-.016.107-.034.158-.054l1.123-1.123A2.02,2.02,0,0,0,201.268,170.421Z",
                    transform: "translate(-151.893 -121.397)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M400.9,171.6h.016l1.009-1.009h-3.783a.125.125,0,0,0-.08.026.2.2,0,0,0-.056.084.633.633,0,0,0-.035.157,2.07,2.07,0,0,0-.012.239,1.958,1.958,0,0,0,.012.232.627.627,0,0,0,.035.155.219.219,0,0,0,.056.087.118.118,0,0,0,.08.028h1.52v1.254l1.239-1.239Z",
                    transform: "translate(-347.759 -125.815)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M469.37,350.961a.13.13,0,0,0,.03.085.214.214,0,0,0,.1.061.991.991,0,0,0,.19.038,3.161,3.161,0,0,0,.6,0,.991.991,0,0,0,.19-.038.214.214,0,0,0,.1-.061.13.13,0,0,0,.03-.085v-1.64l-1.239,1.239Z",
                    transform: "translate(-417.472 -300.285)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M61.748,46.575a.6.6,0,0,0-.843,0l-.817.817-.855.855L57.983,49.5l-.873.873-.792.792L55.08,52.4l-3.934,3.934-1.192,1.192-3.114,3.114-.855.855-.851.851a.6.6,0,0,0,.843.843l.86-.86.859-.859,1.338-1.338,1.192-1.192,4.854-4.854,1.239-1.239L60.063,49.1l.859-.859.826-.826A.6.6,0,0,0,61.748,46.575Z",
                    transform: "translate(-3.181 -4.588)",
                    fill: color || "#FFF"
                })
            ]
        })
    });
};
var $cd031e8c6745d61a$export$2e2bcd8739ae039 = $cd031e8c6745d61a$var$SubtitlesOffIcon;

});

parcelRegister("hpcDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc63bf9d31d20a8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $fbc63bf9d31d20a8$var$SubtitlesOnIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 17",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-41.7 -41.7)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    transform: "translate(41.7 41.7)",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M52.572,58.7H47.828c-2.191,0-3.675-.463-4.67-1.458S41.7,54.763,41.7,52.572V47.828c0-2.191.463-3.675,1.458-4.67s2.479-1.458,4.67-1.458h4.745c2.19,0,3.674.463,4.669,1.458s1.459,2.479,1.459,4.67v4.745c0,2.19-.463,3.674-1.458,4.669S54.763,58.7,52.572,58.7ZM47.828,42.886c-1.856,0-3.073.353-3.831,1.111s-1.111,1.975-1.111,3.831v4.745c0,1.856.353,3.073,1.111,3.831s1.975,1.111,3.831,1.111h4.745c1.856,0,3.073-.353,3.831-1.111s1.111-1.975,1.111-3.83V47.828c0-1.856-.353-3.073-1.111-3.831s-1.975-1.111-3.83-1.111Z",
                        transform: "translate(-41.7 -41.7)",
                        fill: color || '#FFF'
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    transform: "translate(52.486 54.285)",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M498.663,573.49h-1.468a.595.595,0,0,1,0-1.19h1.468a.595.595,0,1,1,0,1.19Z",
                        transform: "translate(-496.6 -572.3)",
                        fill: color || '#FFF'
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    transform: "translate(45.252 54.285)",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M197.425,573.49h-5.13a.595.595,0,1,1,0-1.19h5.13a.595.595,0,1,1,0,1.19Z",
                        transform: "translate(-191.7 -572.3)",
                        fill: color || '#FFF'
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    transform: "translate(49.572 51.692)",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M378.98,464.19h-4.385a.595.595,0,1,1,0-1.19h4.385a.595.595,0,1,1,0,1.19Z",
                        transform: "translate(-374 -463)",
                        fill: color || '#FFF'
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    transform: "translate(45.256 51.692)",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M194.491,464.19h-2.2a.595.595,0,1,1,0-1.19h2.2a.595.595,0,1,1,0,1.19Z",
                        transform: "translate(-191.7 -463)",
                        fill: color || '#FFF'
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    transform: "translate(45.373 44.636)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                            transform: "translate(0 0)",
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                                d: "M201.06,170.057a1.863,1.863,0,0,1-.178.838,1.734,1.734,0,0,1-.483.6,2.072,2.072,0,0,1-.711.362,3.033,3.033,0,0,1-.871.121,2.983,2.983,0,0,1-.583-.052,3.353,3.353,0,0,1-.476-.124,2.089,2.089,0,0,1-.345-.152.958.958,0,0,1-.2-.14.35.35,0,0,1-.086-.176A1.631,1.631,0,0,1,197.1,171a2.307,2.307,0,0,1,.01-.243.725.725,0,0,1,.031-.159.169.169,0,0,1,.057-.086.137.137,0,0,1,.081-.026.411.411,0,0,1,.186.076,2.746,2.746,0,0,0,.307.171,2.851,2.851,0,0,0,.447.171,2.091,2.091,0,0,0,.6.076,1.393,1.393,0,0,0,.4-.055.88.88,0,0,0,.3-.152.675.675,0,0,0,.19-.243.8.8,0,0,0,.067-.324.578.578,0,0,0-.112-.355,1.085,1.085,0,0,0-.293-.262,3.438,3.438,0,0,0-.409-.217c-.152-.067-.312-.138-.474-.214a4.334,4.334,0,0,1-.474-.255,1.887,1.887,0,0,1-.409-.343,1.626,1.626,0,0,1-.293-.471,1.717,1.717,0,0,1-.112-.65,1.737,1.737,0,0,1,.162-.766,1.565,1.565,0,0,1,.435-.547,1.852,1.852,0,0,1,.645-.326,2.841,2.841,0,0,1,.79-.107,2.918,2.918,0,0,1,.431.033,3.135,3.135,0,0,1,.4.088,2.328,2.328,0,0,1,.333.126.8.8,0,0,1,.193.117.388.388,0,0,1,.064.079.3.3,0,0,1,.029.086.876.876,0,0,1,.017.136c0,.055,0,.121,0,.2s0,.167-.007.228a.787.787,0,0,1-.024.155.171.171,0,0,1-.048.088.116.116,0,0,1-.081.029.388.388,0,0,1-.164-.067c-.074-.043-.167-.09-.276-.143a2.642,2.642,0,0,0-.378-.14,1.651,1.651,0,0,0-.474-.064,1.123,1.123,0,0,0-.352.05.737.737,0,0,0-.25.136.53.53,0,0,0-.15.209.668.668,0,0,0-.05.257.572.572,0,0,0,.109.35,1.061,1.061,0,0,0,.3.262,3.117,3.117,0,0,0,.419.214c.157.067.314.138.478.214a4.631,4.631,0,0,1,.478.255,1.871,1.871,0,0,1,.416.343,1.619,1.619,0,0,1,.3.469A1.762,1.762,0,0,1,201.06,170.057Z",
                                transform: "translate(-197.1 -165.7)",
                                fill: color || '#FFF'
                            })
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                            transform: "translate(4.778 0.119)",
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                                d: "M402.535,171.2a2.054,2.054,0,0,1-.012.231.548.548,0,0,1-.036.155.2.2,0,0,1-.06.086.122.122,0,0,1-.076.029h-1.516v4.883a.121.121,0,0,1-.031.083.225.225,0,0,1-.1.062.918.918,0,0,1-.19.038,2.557,2.557,0,0,1-.3.014,2.588,2.588,0,0,1-.3-.014.917.917,0,0,1-.19-.038.2.2,0,0,1-.1-.062.121.121,0,0,1-.031-.083V171.7h-1.516a.114.114,0,0,1-.078-.029.244.244,0,0,1-.057-.086.648.648,0,0,1-.036-.155,2.1,2.1,0,0,1-.012-.231,2.211,2.211,0,0,1,.012-.238.569.569,0,0,1,.036-.157.19.19,0,0,1,.057-.083.125.125,0,0,1,.078-.026h4.269a.123.123,0,0,1,.076.026.193.193,0,0,1,.06.083.644.644,0,0,1,.036.157A1.683,1.683,0,0,1,402.535,171.2Z",
                                transform: "translate(-397.9 -170.7)",
                                fill: color || '#FFF'
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $fbc63bf9d31d20a8$export$2e2bcd8739ae039 = $fbc63bf9d31d20a8$var$SubtitlesOnIcon;

});




parcelRegister("1U3dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d10767699fc70d76$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $fQnPZ = parcelRequire("fQnPZ");

var $kq8jt = parcelRequire("kq8jt");
const $d10767699fc70d76$var$MobileContainer = ({ hideMenu: hideMenu })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const dashboardOpened = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.dashboardOpened);
    const toggleParameters = ()=>{
        dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).none));
        dispatch((0, $cto9a.storeActions).utils.setDashboardOpened(!dashboardOpened));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                id: "retorik-framework-mobile-menu-container",
                className: "rf-absolute rf-bottom-0 rf-w-full rf-h-fit rf-flex rf-flex-col-reverse rf-z-[4] rf-bg-transparent",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fQnPZ.default), {
                    parametersOpened: dashboardOpened,
                    toggleParameters: toggleParameters
                })
            }),
            dashboardOpened && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $kq8jt.default), {
                handleBack: toggleParameters,
                hideMenu: hideMenu
            })
        ]
    });
};
var $d10767699fc70d76$export$2e2bcd8739ae039 = $d10767699fc70d76$var$MobileContainer;

});
parcelRegister("fQnPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ae9aa21ccb925fe$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $dq6kU = parcelRequire("dq6kU");

var $hvWkK = parcelRequire("hvWkK");

var $4BCpK = parcelRequire("4BCpK");

var $2QZab = parcelRequire("2QZab");
const $9ae9aa21ccb925fe$var$Mobile = ({ parametersOpened: parametersOpened, toggleParameters: toggleParameters })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const hideMenu = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.hideMenu);
    const disabledSpeechMode = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableSpeechMode);
    const disabledTextMode = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableTextMode);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const appAvailable = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.appAvailable);
    const toggleMode = (newMode)=>{
        // If the parameters are opened, no action
        if (!parametersOpened) {
            if (newMode === (0, $2rYkD.Mode).text) {
                dispatch((0, $cto9a.storeActions).retorik.setCanFocusSendBox(true));
                dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing));
            } else dispatch((0, $cto9a.storeActions).retorik.setFromTextToVocal(true));
            dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).none));
            dispatch((0, $cto9a.storeActions).speech.setMode(newMode));
        }
    };
    const handleDashboardClick = ()=>{
        toggleParameters();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-framework-menu",
        className: "rf-w-full rf-h-fit rf-max-h-80 rf-flex rf-flex-col-reverse rf-border-t rf-border-t-menuBorder rf-pointer-events-auto",
        style: {
            background: 'linear-gradient(to right, #F8F8FC, #EDEEF3)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-w-full rf-grid rf-flex-1 rf-h-full ${!(disabledSpeechMode || disabledTextMode) ? hideMenu ? 'rf-grid-cols-2' : 'rf-grid-cols-3' : hideMenu ? 'rf-grid-cols-1' : 'rf-grid-cols-2'} rf-min-h-12 rf-grid-rows-1 rf-justify-center rf-items-end`,
                children: [
                    !disabledTextMode && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4BCpK.default), {
                        label: "text",
                        selected: parametersOpened ? false : mode === (0, $2rYkD.Mode).text,
                        onClick: toggleMode
                    }),
                    !disabledSpeechMode && (mode === (0, $2rYkD.Mode).vocal ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-py-2 rf-w-full rf-flex rf-justify-center",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2QZab.default), {})
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4BCpK.default), {
                        label: "vocal",
                        selected: false,
                        onClick: toggleMode
                    })),
                    !hideMenu && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4BCpK.default), {
                        label: "dashboard",
                        selected: parametersOpened,
                        onClick: handleDashboardClick
                    })
                ]
            }),
            !parametersOpened && mode === (0, $2rYkD.Mode).text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dq6kU.default), {
                className: "rf-mx-4 rf-mt-2"
            }),
            appAvailable && !parametersOpened && mode === (0, $2rYkD.Mode).vocal && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hvWkK.default), {
                className: "rf-w-full rf-px-6 rf-py-2 rf-text-center"
            })
        ]
    });
};
var $9ae9aa21ccb925fe$export$2e2bcd8739ae039 = $9ae9aa21ccb925fe$var$Mobile;

});
parcelRegister("dq6kU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f69347d44792da5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");
parcelRequire("kMAJU");
var $byrzf = parcelRequire("byrzf");
var $lvWyY = parcelRequire("lvWyY");
parcelRequire("dikAc");
var $jWbjz = parcelRequire("jWbjz");

var $2rYkD = parcelRequire("2rYkD");
const $0f69347d44792da5$var$SendTextBox = ({ className: className })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const disabledSpeechMode = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableSpeechMode);
    const canFocusSendBox = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.canFocusSendBox);
    const preventVirtualKeyboard = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.preventVirtualKeyboard);
    const sendBoxPlaceHolder = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.sendBoxPlaceHolder);
    const useOldRemote = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.useOldRemote);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const [height, setHeight] = (0, $bxRTa.useState)();
    const [message, setMessage] = (0, $bxRTa.useState)('');
    const timerRef = (0, $bxRTa.useRef)(null);
    const textareaRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (canFocusSendBox && textareaRef.current && document.activeElement !== textareaRef.current) textareaRef.current.focus();
    }, [
        textareaRef,
        canFocusSendBox
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (textareaRef.current) {
            // Add focusin event to open virtual keyboard if it isn't disabled
            !preventVirtualKeyboard && textareaRef.current.addEventListener('focusin', ()=>navigator.virtualKeyboard?.show());
            textareaRef.current.addEventListener('focusout', ()=>dispatch((0, $cto9a.storeActions).utils.setUserTyping(false)));
        }
        return ()=>{
            dispatch((0, $cto9a.storeActions).utils.setUserTyping(false));
            timerRef?.current && clearTimeout(timerRef.current);
        };
    }, [
        preventVirtualKeyboard,
        textareaRef
    ]);
    const handleMessageChange = ()=>{
        timerRef?.current && clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            dispatch((0, $cto9a.storeActions).utils.setUserTyping(false));
        }, 1000);
    };
    const handleChange = (e)=>{
        dispatch((0, $cto9a.storeActions).utils.setUserTyping(true));
        handleMessageChange();
        setMessage(e.currentTarget.value);
        textareaRef?.current && setHeight(`${textareaRef.current.scrollHeight}px`);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' || e.key === 'NumpadEnter') {
            e.preventDefault();
            e.stopPropagation();
            handleSend();
        }
    };
    const handleSend = ()=>{
        if (message?.length) {
            dispatch((0, $cto9a.storeActions).directline.sendMessage({
                text: message
            }));
            setMessage('');
            setHeight(undefined);
            timerRef?.current && clearTimeout(timerRef.current);
            dispatch((0, $cto9a.storeActions).utils.setUserTyping(false));
        }
    };
    const handleClick = ()=>{
        dispatch((0, $cto9a.storeActions).retorik.setFromTextToVocal(true));
        dispatch((0, $cto9a.storeActions).speech.setMode((0, $2rYkD.Mode).vocal));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-framework-send-textbox",
        dir: isRTL ? 'rtl' : 'ltr',
        className: `rf-relative rf-min-h-12 rf-px-4 rf-text-base rf-pt-3 rf-pb-3 rf-flex rf-items-center rf-border rf-border-textBoxBorder rf-rounded-8 rf-bg-truewhite rf-shadow-[inset_0_0_6px_#0000003B] ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("textarea", {
                id: "retorik-framework-send-textbox-textarea",
                ref: textareaRef,
                // @ts-ignore
                virtualkeyboardpolicy: "manual",
                className: `rf-input-hidden rf-outline-none rf-max-h-full rf-overflow-y-clip rf-bg-truewhite rf-w-[calc(100%-4rem)] rf-resize-none rf-scrollbar-hidden ${isMobile && 'placeholder:rf-text-black placeholder:rf-opacity-100'}`,
                value: message,
                placeholder: sendBoxPlaceHolder || translation.menu.message,
                onKeyDown: (e)=>handleKeyDown(e),
                onChange: (e)=>handleChange(e),
                style: {
                    height: height || '1.5rem'
                }
            }),
            !isMobile && !disabledSpeechMode && !useOldRemote && /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: `rf-absolute ${isRTL ? 'rf-left-12' : 'rf-right-12'} rf-h-full rf-w-8 rf-flex rf-justify-center rf-items-center`,
                onClick: handleClick,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jWbjz.default), {
                    className: "rf-h-4 large-vertical:rf-h-5",
                    color: '#00000080'
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: `rf-absolute ${isRTL ? 'rf-left-2' : 'rf-right-2'} rf-h-8 rf-w-8 rf-pt-1 rf-pr-1 rf-flex rf-justify-center rf-items-center rf-border rf-border-secondary rf-bg-secondary rf-rounded-half`,
                onClick: handleSend,
                children: isRTL ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lvWyY.default), {
                    className: "rf-w-5",
                    color: "#FFF"
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $byrzf.default), {
                    className: "rf-w-5",
                    color: "#FFF"
                })
            })
        ]
    });
};
var $0f69347d44792da5$export$2e2bcd8739ae039 = $0f69347d44792da5$var$SendTextBox;

});

parcelRegister("hvWkK", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b82f579358ff4d3$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");

var $gQoxd = parcelRequire("gQoxd");

var $37abB = parcelRequire("37abB");
const $9b82f579358ff4d3$var$springDuration = 1050;
// Unicode Spaces found here : https://www.fileformat.info/info/unicode/category/Zs/list.htm
const $9b82f579358ff4d3$var$spacingCharacters = [
    '\u0020',
    '\u00A0',
    '\u1680',
    '\u2000',
    '\u2001',
    '\u2002',
    '\u2003',
    '\u2004',
    '\u2005',
    '\u2006',
    '\u2007',
    '\u2008',
    '\u2009',
    '\u200A',
    '\u202F',
    '\u205F',
    '\u3000'
];
const $9b82f579358ff4d3$var$VoiceInput = ({ className: className })=>{
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const isLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isLandscape);
    const lastRecognitionInterim = (0, $5FZWK.useSelector)((state)=>state.speechReducer.lastRecognitionInterim);
    const isWaitingForResponse = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.isWaitingForResponse);
    const [remainingLastRecognitionInterim, setRemainingLastRecognitionInterim] = (0, $bxRTa.useState)(null);
    const animationTimerRef = (0, $bxRTa.useRef)();
    const divRef = (0, $bxRTa.useRef)(null);
    const lastSpaceRef = (0, $bxRTa.useRef)(0);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 1
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        return ()=>{
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
            lastSpaceRef.current = 0;
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        if (lastRecognitionInterim) {
            if (isLandscape && divRef?.current) {
                if (divRef.current.scrollHeight > divRef.current.clientHeight) {
                    let lastSpace = 0;
                    for(let i = lastRecognitionInterim.length - 1; i > 0; i--)if ($9b82f579358ff4d3$var$spacingCharacters.includes(lastRecognitionInterim[i])) {
                        switch(lastSpace){
                            case 0:
                                // First space found, let's wait for another one
                                lastSpace = 1;
                                break;
                            case 1:
                                // Second space found, the next one will be the good one
                                lastSpace = 2;
                                break;
                            case 2:
                                // Take this space as reference to display text
                                lastSpace = 3;
                                lastSpaceRef.current = i;
                                break;
                        }
                        if (lastSpace === 3) break;
                    }
                }
                setRemainingLastRecognitionInterim(`${lastSpaceRef.current ? '... ' : ''}${lastRecognitionInterim.substring(lastSpaceRef.current)}`);
            } else setRemainingLastRecognitionInterim(lastRecognitionInterim);
        } else if (remainingLastRecognitionInterim) {
            api.start({
                from: {
                    opacity: 1
                },
                to: {
                    opacity: 0
                },
                config: {
                    duration: $9b82f579358ff4d3$var$springDuration
                }
            });
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
            animationTimerRef.current = setTimeout(()=>{
                api.set({
                    opacity: 1
                });
                setRemainingLastRecognitionInterim(null);
                lastSpaceRef.current = 0;
            }, $9b82f579358ff4d3$var$springDuration);
        }
    }, [
        lastRecognitionInterim
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: isMobile ? isWaitingForResponse ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $gQoxd.default), {
            classname: "rf-flex rf-justify-center rf-py-3 rf-items-center",
            subClassname: "rf-w-4 rf-h-4",
            size: (0, $2rYkD.AnimationSize).medium,
            useTextColor: true
        }) : remainingLastRecognitionInterim ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bTjo.animated).p, {
            className: className,
            style: {
                ...spring
            },
            children: remainingLastRecognitionInterim
        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-justify-end landscape-retorik:rf-justify-start rf-gap-2",
            children: isLandscape ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $37abB.default), {}),
                    remainingLastRecognitionInterim && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bTjo.animated).div, {
                        ref: divRef,
                        className: "rf-w-full rf-max-h-16 rf-pt-2 rf-subtitle-size-auto rf-font-bold rf-text-truewhite rf-text-center rf-text-shadow-black rf-overflow-hidden",
                        style: {
                            ...spring
                        },
                        children: remainingLastRecognitionInterim
                    })
                ]
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: remainingLastRecognitionInterim && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bTjo.animated).div, {
                    className: "rf-w-full rf-py-3 rf-subtitle-size-auto rf-font-bold rf-text-truewhite rf-text-center rf-text-shadow-black",
                    style: {
                        ...spring
                    },
                    children: remainingLastRecognitionInterim
                })
            })
        })
    });
};
var $9b82f579358ff4d3$export$2e2bcd8739ae039 = $9b82f579358ff4d3$var$VoiceInput;

});
parcelRegister("gQoxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7804735915c02809$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");

var $iEJNQ = parcelRequire("iEJNQ");
const $7804735915c02809$var$AnimationContainer = ({ classname: classname, subClassname: subClassname, size: size, useTextColor: useTextColor, triggerScroll: triggerScroll })=>{
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const processedClassName = (0, $bxRTa.useMemo)(()=>{
        return classname || 'rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center';
    }, [
        classname
    ]);
    const processedSubClassName = (0, $bxRTa.useMemo)(()=>{
        return subClassname || 'rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6';
    }, [
        subClassname
    ]);
    const processedAnimationColor = (0, $bxRTa.useMemo)(()=>{
        return {
            '--rf-color-loader-animation': useTextColor ? themeColors.secondary : themeColors.card.frame.text
        };
    }, [
        themeColors,
        useTextColor
    ]);
    (0, $bxRTa.useEffect)(()=>{
        triggerScroll?.();
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: processedClassName,
        style: {
            ...processedAnimationColor
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: processedSubClassName,
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                size: size || (isMobile ? (0, $2rYkD.AnimationSize).medium : (0, $2rYkD.AnimationSize).large)
            })
        })
    });
};
var $7804735915c02809$export$2e2bcd8739ae039 = $7804735915c02809$var$AnimationContainer;

});

parcelRegister("37abB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e10b399800c34b4a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $kaFO8 = parcelRequire("kaFO8");

var $2rYkD = parcelRequire("2rYkD");

var $2QZab = parcelRequire("2QZab");

var $726gw = parcelRequire("726gw");
const $e10b399800c34b4a$var$MicrophoneAndSwitch = ({ top: top })=>{
    const fullScreenImage = (0, $kaFO8.default)();
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const isLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isLandscape);
    const route = (0, $5FZWK.useSelector)((state)=>state.viewReducer.route);
    const disabledTextMode = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableTextMode);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    const dashboardOpened = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.dashboardOpened);
    const retorikEvent = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.retorikEvent);
    const listStatus = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.listStatus);
    const [showCloseButton, setShowCloseButton] = (0, $bxRTa.useState)((0, $2rYkD.CloseButtonCause).none);
    const [bottomForBorne, setBottomForBorne] = (0, $bxRTa.useState)();
    (0, $bxRTa.useEffect)(()=>{
        if (!isLandscape && (currentSubView !== (0, $2rYkD.CurrentSubView).none || dashboardOpened || retorikEvent === (0, $2rYkD.RetorikEvent).DetailViewOpen || listStatus === (0, $2rYkD.ListStatus).opened || route === (0, $2rYkD.Routes).News || fullScreenImage)) {
            /**
       * Closing order :
       * dashboard -> subview but map -> fullscreen image -> detailed view -> map -> list -> news
       */ if (dashboardOpened) setShowCloseButton((0, $2rYkD.CloseButtonCause).dashboard);
            else if (currentSubView !== (0, $2rYkD.CurrentSubView).none && currentSubView !== (0, $2rYkD.CurrentSubView).map) switch(currentSubView){
                case (0, $2rYkD.CurrentSubView).emergency:
                    setShowCloseButton((0, $2rYkD.CloseButtonCause).emergency);
                    break;
                case (0, $2rYkD.CurrentSubView).history:
                    setShowCloseButton((0, $2rYkD.CloseButtonCause).history);
                    break;
                case (0, $2rYkD.CurrentSubView).languages:
                    setShowCloseButton((0, $2rYkD.CloseButtonCause).languages);
                    break;
                case (0, $2rYkD.CurrentSubView).weather:
                    setShowCloseButton((0, $2rYkD.CloseButtonCause).weather);
                    break;
            }
            else if (fullScreenImage) setShowCloseButton((0, $2rYkD.CloseButtonCause).fullscreenimage);
            else if (retorikEvent === (0, $2rYkD.RetorikEvent).DetailViewOpen) setShowCloseButton((0, $2rYkD.CloseButtonCause).detailedpoi);
            else if (currentSubView === (0, $2rYkD.CurrentSubView).map) setShowCloseButton((0, $2rYkD.CloseButtonCause).map);
            else if (listStatus === (0, $2rYkD.ListStatus).opened) setShowCloseButton((0, $2rYkD.CloseButtonCause).list);
            else if (route === (0, $2rYkD.Routes).News) setShowCloseButton((0, $2rYkD.CloseButtonCause).news);
        } else setShowCloseButton((0, $2rYkD.CloseButtonCause).none);
    }, [
        isLandscape,
        currentSubView,
        dashboardOpened,
        retorikEvent,
        listStatus,
        route,
        fullScreenImage
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (!top || isLandscape) setBottomForBorne(undefined);
        else setBottomForBorne(typeof top === 'number' ? `calc(100% - ${top}px + 0.5rem)` : `calc(100% - ${top} + 0.5rem)`);
    }, [
        isLandscape,
        top
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-microphone-container",
        className: `large-vertical:rf-absolute rf-w-fit ${showCloseButton !== (0, $2rYkD.CloseButtonCause).none ? 'rf-right-9' : 'rf-right-4'} landscape-retorik:-rf-mt-4 landscape-retorik:rf-pl-[calc(50%-2.5rem)] rf-flex rf-flex-row large-vertical:rf-flex-col rf-justify-center rf-items-center rf-gap-6 large-vertical:rf-gap-4`,
        style: {
            bottom: bottomForBorne
        },
        children: [
            mode === (0, $2rYkD.Mode).vocal && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2QZab.default), {
                hidden: showCloseButton !== (0, $2rYkD.CloseButtonCause).none
            }),
            (showCloseButton !== (0, $2rYkD.CloseButtonCause).none || mode === (0, $2rYkD.Mode).vocal) && (showCloseButton === (0, $2rYkD.CloseButtonCause).none ? /* If the button has no closing cause, it should be the one to switch to text mode. If disabledTextMode is true, then we show nothing */ disabledTextMode ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                type: (0, $2rYkD.RemoteButtonType).text,
                backgroundColor: "#FFF",
                cause: showCloseButton
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                type: (0, $2rYkD.RemoteButtonType).close,
                backgroundColor: "#FFF",
                cause: showCloseButton
            }))
        ]
    });
};
var $e10b399800c34b4a$export$2e2bcd8739ae039 = $e10b399800c34b4a$var$MicrophoneAndSwitch;

});
parcelRegister("2QZab", function(module, exports) {

$parcel$export(module.exports, "default", () => $89ec64be329ff6f6$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $aBDai = parcelRequire("aBDai");

var $6Iy5P = parcelRequire("6Iy5P");
parcelRequire("dikAc");
var $jWbjz = parcelRequire("jWbjz");

var $bNR9S = parcelRequire("bNR9S");

var $fEtid = parcelRequire("fEtid");

var $ePe83 = parcelRequire("ePe83");
const $89ec64be329ff6f6$var$MicrophoneButton = ({ hidden: hidden })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isMicrophoneAllowed = (0, $5FZWK.useSelector)((state)=>state.speechReducer.isMicrophoneAllowed);
    const showMicrophoneModal = (0, $5FZWK.useSelector)((state)=>state.speechReducer.showMicrophoneModal);
    const microphonePermissionStatus = (0, $5FZWK.useSelector)((state)=>state.speechReducer.permissionStatus);
    const activeRecognitionState = (0, $5FZWK.useSelector)((state)=>state.speechReducer.activeRecognitionState);
    const instantIsWaitingForResponse = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.instantIsWaitingForResponse);
    const fromTextToVocal = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.fromTextToVocal);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const [colorWithTransparency] = (0, $bxRTa.useState)((0, $aBDai.getColorWithTransparency)(themeColors.secondary, 0.8));
    const [microphoneButtonClassname, setMicrophoneButtonClassname] = (0, $bxRTa.useState)();
    const [backgroundColor, setBackgroundColor] = (0, $bxRTa.useState)();
    const [showLoader, setShowLoader] = (0, $bxRTa.useState)(false);
    const timerRef = (0, $bxRTa.useRef)(null);
    const instantIsWaitingForResponseRef = (0, $bxRTa.useRef)(false);
    (0, $bxRTa.useEffect)(()=>{
        instantIsWaitingForResponseRef.current = instantIsWaitingForResponse;
    }, [
        instantIsWaitingForResponse
    ]);
    (0, $bxRTa.useEffect)(()=>{
        let classname = 'rf-relative rf-z-[5] large:rf-h-20 rf-aspect-square rf-flex rf-justify-center rf-items-center rf-border rf-rounded-half ';
        timerRef?.current && clearTimeout(timerRef.current);
        switch(activeRecognitionState){
            case (0, $2rYkD.RecognitionState).Listening:
                setShowLoader(false);
                setBackgroundColor(themeColors.secondary);
                classname += `${isMobile && 'rf-h-12 rf-my-2'} rf-border-none rf-loader-pulsation`;
                break;
            case (0, $2rYkD.RecognitionState).Initializing:
            case (0, $2rYkD.RecognitionState).Closing:
            case (0, $2rYkD.RecognitionState).ForceClosing:
                setShowLoader(true);
                if (isMobile) {
                    setBackgroundColor('transparent');
                    classname += 'rf-h-8 rf-border-none';
                } else {
                    setBackgroundColor(colorWithTransparency);
                    classname += 'rf-border-truewhite';
                }
                break;
            case (0, $2rYkD.RecognitionState).Closed:
                if (isMobile) {
                    setBackgroundColor('transparent');
                    classname += 'rf-h-8 rf-border-none';
                } else {
                    setBackgroundColor(colorWithTransparency);
                    classname += 'rf-border-truewhite';
                }
                // Timeout before setting showLoader to hide the delay between closing state and message sending
                timerRef.current = setTimeout(()=>{
                    setShowLoader(instantIsWaitingForResponseRef.current);
                }, 250);
                break;
        }
        setMicrophoneButtonClassname(classname);
    }, [
        isMobile,
        activeRecognitionState,
        colorWithTransparency,
        instantIsWaitingForResponse
    ]);
    const handleClick = ()=>{
        if (!isMicrophoneAllowed) dispatch((0, $cto9a.storeActions).speech.askPermission());
        else dispatch((0, $cto9a.storeActions).speech.toggleMicrophone(false));
    };
    (0, $bxRTa.useEffect)(()=>{
        return ()=>{
            timerRef?.current && clearTimeout(timerRef.current);
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        if (fromTextToVocal) {
            handleClick();
            dispatch((0, $cto9a.storeActions).retorik.setFromTextToVocal(false));
        }
    }, [
        fromTextToVocal
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).none));
        dispatch((0, $cto9a.storeActions).utils.setFullScreenImage(undefined));
    }, [
        activeRecognitionState
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-relative rf-h-full rf-flex rf-justify-center rf-items-center ${hidden && 'rf-hidden'}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: microphoneButtonClassname,
                onClick: handleClick,
                "aria-label": "microphone",
                style: {
                    backgroundColor: backgroundColor,
                    boxShadow: isMobile ? undefined : '0 0 6px #00000080'
                },
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-absolute rf-h-full rf-w-full rf-flex rf-justify-center rf-items-center",
                    children: showLoader && !isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-8 rf-loader-bouncing-white"
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)($jWbjz.default, {
                        className: isMobile ? 'rf-h-5 rf-w-5' : 'rf-h-6 rf-w-6',
                        color: !isMobile || activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? '#FFF' : themeColors.secondary
                    })
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ePe83.default), {
                showLoader: showLoader
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $6Iy5P.default), {
                isOpened: showMicrophoneModal,
                onClose: ()=>dispatch((0, $cto9a.storeActions).speech.setShowMicrophoneModal(false)),
                children: [
                    microphonePermissionStatus === (0, $2rYkD.PermissionStatus).waiting && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bNR9S.default), {}),
                    microphonePermissionStatus === (0, $2rYkD.PermissionStatus).refused && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fEtid.default), {})
                ]
            })
        ]
    });
};
var $89ec64be329ff6f6$export$2e2bcd8739ae039 = $89ec64be329ff6f6$var$MicrophoneButton;

});
parcelRegister("bNR9S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c7bb8a07f85cf5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
parcelRequire("kMAJU");
var $f3SD2 = parcelRequire("f3SD2");
const $d1c7bb8a07f85cf5$var$MicrophoneModalWaiting = ()=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-max-w-[500px] rf-px-16 rf-py-16 rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f3SD2.default), {
                className: "rf-h-10"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-text-size-auto rf-text-center",
                children: translation.microphone.allow
            })
        ]
    });
};
var $d1c7bb8a07f85cf5$export$2e2bcd8739ae039 = $d1c7bb8a07f85cf5$var$MicrophoneModalWaiting;

});

parcelRegister("fEtid", function(module, exports) {

$parcel$export(module.exports, "default", () => $063d1e0c0a6e7c3e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7QU6k = parcelRequire("7QU6k");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $clSD3 = parcelRequire("clSD3");

var $5FZWK = parcelRequire("5FZWK");

var $kdMEA = parcelRequire("kdMEA");
parcelRequire("kMAJU");
var $iNZRc = parcelRequire("iNZRc");

var $8e5cw = parcelRequire("8e5cw");

var $9TTQJ = parcelRequire("9TTQJ");
parcelRequire("d72S7");
var $cUlNP = parcelRequire("cUlNP");
const $063d1e0c0a6e7c3e$var$springDuration = 500;
const $063d1e0c0a6e7c3e$var$MicrophoneModalRefused = ()=>{
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const isUsedOnBorne = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.isUsedOnBorne);
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)(undefined);
    const [redirectionUrl, setRedirectionUrl] = (0, $bxRTa.useState)();
    const fadeInTimerRef = (0, $bxRTa.useRef)(null);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        let tempUrl = `${(0, $kdMEA.docsRetorik)}${locale.split('-')[0] === 'fr' ? '' : '/en'}/docs/depannage-autorisations-acces-micro/`;
        switch(0, $clSD3.browserName){
            case (0, $clSD3.BrowserTypes).Chrome:
            case (0, $clSD3.BrowserTypes).Chromium:
                tempUrl += '#chrome-';
                break;
            case (0, $clSD3.BrowserTypes).Edge:
            case (0, $clSD3.BrowserTypes).EdgeChromium:
                tempUrl += '#edge-';
                break;
            case (0, $clSD3.BrowserTypes).Firefox:
                tempUrl += '#firefox-';
                break;
            case (0, $clSD3.BrowserTypes).Safari:
            case (0, $clSD3.BrowserTypes).MobileSafari:
                tempUrl += '#safari-';
                break;
            case (0, $clSD3.BrowserTypes).Opera:
                tempUrl += '#opera-';
                break;
            case (0, $clSD3.BrowserTypes).SamsungBrowser:
                setRedirectionUrl(`${tempUrl}#samsung-sur-mobile`);
                return;
            case (0, $clSD3.BrowserTypes).Ie:
            case (0, $clSD3.BrowserTypes).InternetExplorer:
            default:
                break;
        }
        switch(0, $clSD3.osName){
            case (0, $clSD3.OsTypes).Windows:
            case (0, $clSD3.OsTypes).MAC_OS:
                tempUrl += 'sur-ordinateur-de-bureau';
                break;
            default:
                tempUrl += 'sur-mobile-ou-tablette';
        }
        setRedirectionUrl(tempUrl);
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        qrCodeData && api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $063d1e0c0a6e7c3e$var$springDuration
            }
        });
        return ()=>{
            fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        };
    }, [
        qrCodeData
    ]);
    const handleCloseQrCode = ()=>{
        api.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $063d1e0c0a6e7c3e$var$springDuration
            }
        });
        fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        fadeInTimerRef.current = setTimeout(()=>{
            setQrCodeData(undefined);
        }, $063d1e0c0a6e7c3e$var$springDuration);
    };
    const setQrCodeDataAsync = async (url)=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(url);
        setQrCodeData(qrCodeString);
    };
    const handleRedirect = ()=>{
        if (redirectionUrl) isUsedOnBorne ? setQrCodeDataAsync(redirectionUrl) : window.open(redirectionUrl, '_blank', 'noopener noreferrer');
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-max-w-[500px] rf-px-8 rf-py-8 rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4 rf-text-size-auto",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iNZRc.default), {
                className: "rf-h-10"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-font-light",
                children: translation.microphone.rejected
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-text-center",
                children: translation.microphone.instructions
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-card-button",
                onClick: handleRedirect,
                children: translation.common.knowmore
            }),
            qrCodeData && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
                className: "rf-absolute rf-h-full rf-w-full rf-top-0 rf-left-0 rf-z-ui rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2 rf-p-2 rf-text-truewhite",
                style: {
                    background: 'rgba(18,18,18,0.7)',
                    ...spring
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                        onClick: handleCloseQrCode,
                        showLabel: false
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-px-8 rf-flex rf-flex-row rf-items-start rf-gap-1 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cUlNP.default), {
                                color: "#FFF"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-w-fit",
                                children: translation.link.scanQRTile
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                        src: qrCodeData
                    })
                ]
            })
        ]
    });
};
var $063d1e0c0a6e7c3e$export$2e2bcd8739ae039 = $063d1e0c0a6e7c3e$var$MicrophoneModalRefused;

});

parcelRegister("ePe83", function(module, exports) {

$parcel$export(module.exports, "default", () => $47acbf3e094ad379$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $8PG7f = parcelRequire("8PG7f");

var $2rYkD = parcelRequire("2rYkD");
const $47acbf3e094ad379$var$MicrophoneTextBubble = ({ showLoader: showLoader })=>{
    const botAnswerEnded = (0, $8PG7f.default)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const isLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isLandscape);
    const activeRecognitionState = (0, $5FZWK.useSelector)((state)=>state.speechReducer.activeRecognitionState);
    const lastRecognitionInterim = (0, $5FZWK.useSelector)((state)=>state.speechReducer.lastRecognitionInterim);
    const speaking = (0, $5FZWK.useSelector)((state)=>state.speechReducer.speaking);
    const useContinuousRecognition = (0, $5FZWK.useSelector)((state)=>state.speechReducer.useContinuousRecognition);
    const agentData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.agentData);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    const dashboardOpened = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.dashboardOpened);
    const retorikEvent = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.retorikEvent);
    const listStatus = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.listStatus);
    const [className, setClassName] = (0, $bxRTa.useState)();
    const [text, setText] = (0, $bxRTa.useState)();
    const [textUndefined, setTextUndefined] = (0, $bxRTa.useState)(false);
    const timerRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        setTextUndefined(speaking || showLoader || !botAnswerEnded || currentSubView !== (0, $2rYkD.CurrentSubView).none || dashboardOpened || retorikEvent === (0, $2rYkD.RetorikEvent).DetailViewOpen || listStatus === (0, $2rYkD.ListStatus).opened);
    }, [
        speaking,
        showLoader,
        botAnswerEnded,
        currentSubView,
        dashboardOpened,
        retorikEvent,
        listStatus
    ]);
    (0, $bxRTa.useEffect)(()=>{
        let tempClassName = 'rf-absolute rf-w-max rf-py-2 rf-px-4 rf-flex rf-flex-col rf-justify-center rf-items-center rf-bg-[#000000B3] rf-border rf-rounded-lg rf-text-truewhite rf-text-center rf-border-[#8B8888] rf-shadow-[inset_0_0_6px_#0000003B] ';
        if (isMobile) tempClassName += 'rf-bottom-[calc(100%+2rem)]';
        else if (isLandscape) tempClassName += 'rf-top-[calc(100%+1rem)]';
        else tempClassName += isRTL ? 'rf-left-[calc(100%+1rem)]' : 'rf-right-[calc(100%+1rem)]';
        setClassName(tempClassName);
    }, [
        isMobile,
        isLandscape,
        isRTL
    ]);
    (0, $bxRTa.useEffect)(()=>{
        timerRef.current && clearTimeout(timerRef.current);
        switch(activeRecognitionState){
            case (0, $2rYkD.RecognitionState).Listening:
                setText(isMobile || isLandscape && lastRecognitionInterim ? undefined : translation.microphone.listening);
                break;
            case (0, $2rYkD.RecognitionState).Closed:
                let text = undefined;
                if (!textUndefined) text = useContinuousRecognition ? `<p>${translation.microphone.trigger}${isMobile ? ' ' : '<br />'}<strong>\xab ${agentData?.name} \xbb</strong></p>` : `<p>${translation.microphone.triggerwithoutname}</p>`;
                // Show the button only 1.5s after, to prevents it from appearing à fraction of second between several texts
                timerRef.current = setTimeout(()=>{
                    setText(text);
                }, 1500);
                break;
            case (0, $2rYkD.RecognitionState).Initializing:
            case (0, $2rYkD.RecognitionState).Closing:
            case (0, $2rYkD.RecognitionState).ForceClosing:
            default:
                setText(undefined);
                break;
        }
    }, [
        isMobile,
        activeRecognitionState,
        agentData,
        lastRecognitionInterim,
        textUndefined,
        useContinuousRecognition
    ]);
    return text ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: className,
                style: {
                    clipPath: isMobile ? 'polygon(0% 0%, 0% 100%, calc(50% - 0.4rem) 100%, calc(50% - 0.4rem) calc(100% - 1px), calc(50% + 0.4rem) calc(100% - 1px), calc(50% + 0.4rem) 100%, 100% 100%, 100% 0%)' : isLandscape ? 'polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%, calc(50% + 0.4rem) 0%, calc(50% + 0.4rem) calc(0% + 1px), calc(50% - 0.4rem) calc(0% + 1px), calc(50% - 0.4rem) 0%)' : 'polygon(0% 0%, 0% 100%, 100% 100%, 100% calc(50% + 0.4rem), calc(100% - 1px) calc(50% + 0.4rem), calc(100% - 1px) calc(50% - 0.4rem), 100% calc(50% - 0.4rem), 100% 0%)'
                },
                dangerouslySetInnerHTML: {
                    __html: text
                }
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-absolute rf-w-3 rf-h-3 rf-bg-[#000000B3] rf-border-t rf-border-r rf-border-t-[#8B8888] rf-border-r-[#8B8888]",
                style: {
                    rotate: isMobile ? '135deg' : isLandscape ? '-45deg' : isRTL ? '-135deg' : '45deg',
                    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%)',
                    bottom: isMobile ? 'calc(100% + 1.7rem)' : undefined,
                    top: isLandscape ? 'calc(100% + 0.7rem)' : undefined,
                    right: isMobile || isLandscape || isRTL ? undefined : 'calc(100% + 0.7rem)',
                    left: isMobile || isLandscape || !isRTL ? undefined : 'calc(100% + 0.7rem)'
                }
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $47acbf3e094ad379$export$2e2bcd8739ae039 = $47acbf3e094ad379$var$MicrophoneTextBubble;

});
parcelRegister("8PG7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7a763a6f055cf6f$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $kdMEA = parcelRequire("kdMEA");
/**
 * Check if the last activity received/sent is used in the flow of the conversation and if so, if it's ended or not.
 * Used for text/loader display in vocal mode for example.
 * @returns {boolean}
 */ const $f7a763a6f055cf6f$var$useBotAnswerEnded = ()=>{
    const lastActivity = (0, $5FZWK.useSelector)((state)=>state.activityReducer.lastActivity);
    const endedActivities = (0, $5FZWK.useSelector)((state)=>state.activityReducer.endedActivities);
    const [ended, setEnded] = (0, $bxRTa.useState)(false);
    (0, $bxRTa.useEffect)(()=>{
        if (lastActivity) {
            // If the activity has a replyToId or if it's a bring-up message, it's a bot response.
            if (lastActivity.replyToId || lastActivity.label?.toLowerCase() === 'davi.bringupmessage') {
                if (lastActivity.type === 'message' || lastActivity.value?.name?.toLowerCase() === 'davi.streammessageactivity') setEnded(endedActivities.includes(lastActivity.id));
                else setEnded(true);
            } else if (lastActivity.type === 'message' || lastActivity.value?.name && !(0, $kdMEA.nonResponseInducingEvents).find((eventName)=>lastActivity.value.name.toLowerCase().includes(eventName))) setEnded(false);
            else setEnded(true);
        } else setEnded(true);
    }, [
        lastActivity,
        endedActivities
    ]);
    return ended;
};
var $f7a763a6f055cf6f$export$2e2bcd8739ae039 = $f7a763a6f055cf6f$var$useBotAnswerEnded;

});





parcelRegister("4BCpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $058ed3f0f77eab9a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("dikAc");
var $6Nt3V = parcelRequire("6Nt3V");
var $9f9kU = parcelRequire("9f9kU");
var $jWbjz = parcelRequire("jWbjz");
const $058ed3f0f77eab9a$var$ModeButton = ({ label: label, selected: selected, onClick: onClick })=>{
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
        className: "rf-grid rf-w-full rf-h-12 rf-pb-4 rf-justify-center rf-items-end",
        onClick: ()=>onClick((0, $2rYkD.Mode)[label]),
        "aria-label": label,
        children: label === 'vocal' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jWbjz.default), {
            className: "rf-h-5",
            color: "#A4A7AF"
        }) : label === 'text' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9f9kU.default), {
            className: "rf-h-4",
            color: selected ? themeColors.secondary : '#A4A7AF'
        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6Nt3V.default), {
            className: "rf-h-[0.875rem]",
            color: selected ? themeColors.secondary : '#A4A7AF'
        })
    });
};
var $058ed3f0f77eab9a$export$2e2bcd8739ae039 = $058ed3f0f77eab9a$var$ModeButton;

});


parcelRegister("kq8jt", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d590c2d5e524e8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $eO5xw = parcelRequire("eO5xw");

var $k4qlo = parcelRequire("k4qlo");

var $hRvNU = parcelRequire("hRvNU");

var $cxKWX = parcelRequire("cxKWX");

var $iBT6g = parcelRequire("iBT6g");

var $3KYvq = parcelRequire("3KYvq");

var $gPs3v = parcelRequire("gPs3v");

var $2rYkD = parcelRequire("2rYkD");
const $81d590c2d5e524e8$var$ParametersAndDashboardContainer = ({ handleBack: handleBack, hideMenu: hideMenu = false })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const menu = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.menu);
    const isWidget = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isWidget);
    const divRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        divRef?.current && isWidget && (0, $k4qlo.default)(null, divRef);
    }, [
        divRef.current
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $gPs3v.default), {
        onClick: handleBack,
        target: (0, $2rYkD.TemplateTarget).mobileOther,
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
            ref: divRef,
            className: "rf-w-full rf-flex-rf-flex-col rf-overflow-y-scroll rf-scrollbar-hidden rf-pointer-events-auto",
            children: [
                !hideMenu && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: [
                        menu?.categories?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3KYvq.default), {
                            toggleDashboard: handleBack
                        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hRvNU.default), {
                            toggleDashboard: handleBack
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-h-6 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                    className: "rf-w-full rf-px-5 rf-flex rf-flex-col rf-justify-start",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-py-4 rf-text-lightgray",
                            children: (0, $eO5xw.capitalizeFirstLetter)(translation.common.parameters, locale)
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cxKWX.default), {
                            handleBack: handleBack
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iBT6g.default), {
                    isMobile: true
                })
            ]
        })
    });
};
var $81d590c2d5e524e8$export$2e2bcd8739ae039 = $81d590c2d5e524e8$var$ParametersAndDashboardContainer;

});
parcelRegister("hRvNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $517a47f1eedd6a3b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $gPs3v = parcelRequire("gPs3v");

var $75jcl = parcelRequire("75jcl");

var $h0yA8 = parcelRequire("h0yA8");

var $jVVrN = parcelRequire("jVVrN");

var $dncba = parcelRequire("dncba");
parcelRequire("81HL8");
var $77wBI = parcelRequire("77wBI");

var $iBT6g = parcelRequire("iBT6g");
const $517a47f1eedd6a3b$var$OldDashboard = ({ toggleDashboard: toggleDashboard })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const isUsedOnBorne = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.isUsedOnBorne);
    const hideParametersButtonInMenu = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.hideParametersButtonInMenu);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const handleClick = ()=>{
        toggleDashboard?.();
    };
    /**
   * Called in borne mode to open retorik kiosk parameters
   */ const handleClickParameters = ()=>{
        dispatch((0, $cto9a.storeActions).utils.askForKioskParametersOpening());
        toggleDashboard?.();
    };
    return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-px-5 rf-pt-4 rf-flex rf-flex-col rf-justify-start",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jVVrN.default), {
            conditionalHandleClick: handleClick
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $gPs3v.default), {
        onClick: toggleDashboard,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-h-full rf-w-full rf-flex rf-justify-center rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $h0yA8.default), {}),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-relative rf-h-full rf-max-w-7/10 rf-flex rf-flex-col rf-items-start rf-gap-8",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-min-h-2/5 rf-py-4 rf-mt-auto rf-flex rf-flex-col rf-gap-8 rf-overflow-y-scroll rf-scrollbar-hidden",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jVVrN.default), {
                                    handleClick: toggleDashboard
                                })
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-h-3/10 rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dncba.default), {
                                    handleClick: toggleDashboard
                                })
                            })
                        ]
                    }),
                    isUsedOnBorne && !hideParametersButtonInMenu ? /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                        // @ts-ignore
                        part: "retorik-framework-parameters",
                        className: "rf-absolute rf-left-4 rf-bottom-4 rf-h-8 rf-flex rf-flex-row rf-items-center",
                        onClick: handleClickParameters,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $77wBI.default), {
                                color: "#A4A7AF"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                className: "rf-uppercase rf-ml-1 rf-text-xsl rf-text-[#A4A7AF]",
                                children: translation.common.parameters
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iBT6g.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $75jcl.default), {
                dashboardVisible: true,
                onClick: handleClick
            })
        ]
    });
};
var $517a47f1eedd6a3b$export$2e2bcd8739ae039 = $517a47f1eedd6a3b$var$OldDashboard;

});
parcelRegister("jVVrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7441469c8ba1113$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $kdMEA = parcelRequire("kdMEA");

var $41KEu = parcelRequire("41KEu");
const $d7441469c8ba1113$var$DisplayViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const [finalMenu, setFinalMenu] = (0, $bxRTa.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseMenu
            if (Object.keys(currentMenu).includes('icon')) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $41KEu.default), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined,
                    name: customCurrentMenu.name
                }));
            } else fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $41KEu.default), {
                type: "BaseMenu",
                indice: currentMenu.indice,
                view: currentMenu.view,
                device: currentDeviceType,
                handleClick: handleClick,
                conditionalHandleClick: conditionalHandleClick
            }));
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $bxRTa.useEffect)(()=>{
        const tempFinalMenu = [];
        // Basic menu
        tempFinalMenu.push(buildMenu(configuration && configuration.baseMenu ? [
            ...configuration.baseMenu
        ] : [
            ...(0, $kdMEA.DEFAULT_VIEWS)
        ]));
        // Custom menus
        if (configuration && configuration.customMenu && configuration.customMenu.length > 0) {
            if (Array.isArray(configuration.customMenu[0])) configuration.customMenu.forEach((menuArray)=>{
                tempFinalMenu.push(buildMenu(menuArray));
            });
            else tempFinalMenu.push(buildMenu(configuration.customMenu));
        }
        setFinalMenu(tempFinalMenu);
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: finalMenu.map((line, key)=>{
            return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `${key === 0 && 'rf-pb-4'} rf-flex rf-flex-col rf-items-center`,
                children: [
                    key !== 0 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-h-6 -rf-mx-6 rf-width-fill-available rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                    }),
                    line.map((e, subkey)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                            children: e
                        }, subkey);
                    })
                ]
            }, key) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                children: line.map((e, subkey)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                        children: e
                    }, subkey);
                })
            }, key);
        })
    });
};
var $d7441469c8ba1113$export$2e2bcd8739ae039 = $d7441469c8ba1113$var$DisplayViews;

});
parcelRegister("41KEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $de88e43f6a74bebb$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $kdMEA = parcelRequire("kdMEA");

var $3XSV8 = parcelRequire("3XSV8");
function $de88e43f6a74bebb$var$instanceOfDisplayGeneratorProps(object) {
    return 'view' in object && object.type === 'BaseMenu';
}
function $de88e43f6a74bebb$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return 'icon' in object && object.type === 'CustomMenu';
}
const $de88e43f6a74bebb$var$DisplayGenerator = (props)=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const [label, setLabel] = (0, $bxRTa.useState)('');
    const [colorButtonHandle, setColorButtonHandle] = (0, $bxRTa.useState)('');
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $bxRTa.useEffect)(()=>{
        if ($de88e43f6a74bebb$var$instanceOfDisplayGeneratorProps(props)) setLabel(translation[props.view.toString()]);
        else if ($de88e43f6a74bebb$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === 'string') setLabel(props.label);
            else if (props.label && typeof props.label === 'object') setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        let colorButtonHandle = '';
        // Handle hospitality menu icon color
        if ($de88e43f6a74bebb$var$instanceOfCustomMenuDisplayGeneratorProps(props) && props.name) {
            if (props.name.toString().indexOf('whatToDo') > -1) colorButtonHandle = themeColors.tobeDoneColor;
            else if (props.name.toString().indexOf('localProducts') > -1) colorButtonHandle = themeColors.localProductsColor;
            else if (props.name.toString().indexOf('whereToEat') > -1) colorButtonHandle = themeColors.whereToEatColor;
            else if (props.name.toString().indexOf('whereToSleep') > -1) colorButtonHandle = themeColors.whereToSleepColor;
            else if (props.name.toString().indexOf('whatToSee') > -1) colorButtonHandle = themeColors.tobeSeenColor;
            else if (props.name.toString().indexOf('agenda') > -1) colorButtonHandle = themeColors.agendaColor;
            else if (props.name.toString().indexOf('services') > -1) colorButtonHandle = themeColors.servicesColor;
        }
        setColorButtonHandle(colorButtonHandle);
    }, [
        label
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($de88e43f6a74bebb$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $2rYkD.AvailableViews).home:
                isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
                dispatch((0, $cto9a.storeActions).directline.sendEvent({
                    name: 'showHome'
                }));
                break;
            case (0, $2rYkD.AvailableViews).news:
                dispatch((0, $cto9a.storeActions).view.setRoute((0, $2rYkD.Routes).News));
                break;
            case (0, $2rYkD.AvailableViews).weather:
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).weather));
                break;
            case (0, $2rYkD.AvailableViews).emergency:
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).emergency));
                break;
        }
        else if ($de88e43f6a74bebb$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            // Display custom component if present
            if (props.customDisplay) dispatch((0, $cto9a.storeActions).utils.setCurrentCustomView({
                ...props
            }));
        }
        props.handleClick && props.handleClick();
    };
    return (0, $kdMEA.mobileDisplays).includes(props.device) ? /* On mobile / widget : display available views as lines */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && 'rf-border-t rf-border-t-menuBorder'}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $de88e43f6a74bebb$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                view: props.view
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                icon: props.icon,
                className: "rf-max-h-6 rf-max-w-6 rf-flex rf-items-center",
                color: colorButtonHandle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-4 rf-font-bold",
                children: (0, $eO5xw.capitalizeFirstLetter)(label, locale)
            })
        ]
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-h-36 rf-w-36 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)'
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $de88e43f6a74bebb$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                view: props.view,
                className: "rf-h-16"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                icon: props.icon,
                className: "rf-h-16 rf-w-16 rf-flex",
                color: colorButtonHandle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-uppercase rf-text-[#575F6B] ${isRTL ? 'rf-text-arabic' : 'rf-text-xs'} large-vertical:rf-text-basecustomuppercase`,
                children: label
            })
        ]
    });
};
var $de88e43f6a74bebb$export$2e2bcd8739ae039 = $de88e43f6a74bebb$var$DisplayGenerator;

});
parcelRegister("3XSV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ed40ff53afd6e0$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("2l6WH");
var $hCkUC = parcelRequire("hCkUC");
var $3sPnl = parcelRequire("3sPnl");
var $jGi9r = parcelRequire("jGi9r");
var $8LI0a = parcelRequire("8LI0a");
var $jzwsO = parcelRequire("jzwsO");
parcelRequire("81HL8");
var $2ogpH = parcelRequire("2ogpH");
var $3EchS = parcelRequire("3EchS");
const $72ed40ff53afd6e0$var$DisplayIcon = ({ view: view, icon: icon, className: className, color: color = '' })=>{
    if (view) return view === (0, $2rYkD.AvailableViews).home ? /*#__PURE__*/ (0, $fl9nK.jsx)($3sPnl.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).news ? /*#__PURE__*/ (0, $fl9nK.jsx)($8LI0a.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).weather ? /*#__PURE__*/ (0, $fl9nK.jsx)($jzwsO.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).emergency ? /*#__PURE__*/ (0, $fl9nK.jsx)($hCkUC.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableSubViews).history ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ogpH.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableSubViews).tutorial ? /*#__PURE__*/ (0, $fl9nK.jsx)($3EchS.default, {
        className: className
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)($jGi9r.default, {
        className: className
    });
    else if (icon) return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `${className} ${color !== '' ? 'svgButtonMenu' : ''}`,
        style: color !== '' ? {
            '--fill': color
        } : {},
        children: icon
    });
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fl9nK.Fragment), {});
};
var $72ed40ff53afd6e0$export$2e2bcd8739ae039 = $72ed40ff53afd6e0$var$DisplayIcon;

});



parcelRegister("dncba", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f2ab8ee6f2ca889$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $kdMEA = parcelRequire("kdMEA");

var $2rYkD = parcelRequire("2rYkD");

var $3u9RE = parcelRequire("3u9RE");
const $8f2ab8ee6f2ca889$var$DisplaySubViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const [subMenu, setSubMenu] = (0, $bxRTa.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseSubMenu
            if (Object.keys(currentMenu).includes('icon')) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $3u9RE.default), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined
                }));
            } else {
                // In mobile mode, we only push custom items, base items (history / tutorial) have their own render
                if (!isMobile) // Don't add "history" item if it is disabled
                {
                    if (!(configuration.disableHistory && configuration.isUsedOnBorne) || currentMenu.view !== (0, $2rYkD.AvailableSubViews).history) fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $3u9RE.default), {
                        type: "BaseMenu",
                        indice: currentMenu.indice,
                        view: currentMenu.view,
                        device: currentDeviceType,
                        handleClick: handleClick
                    }));
                }
            }
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $bxRTa.useEffect)(()=>{
        // Handle custom submenus
        if (configuration?.subMenu) setSubMenu(buildMenu(configuration.subMenu));
        else setSubMenu(buildMenu((0, $kdMEA.DEFAULT_SUB_VIEWS)));
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: subMenu.map((e, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: e
            }, key);
        })
    });
};
var $8f2ab8ee6f2ca889$export$2e2bcd8739ae039 = $8f2ab8ee6f2ca889$var$DisplaySubViews;

});
parcelRegister("3u9RE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d878087efb3c35ce$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $kdMEA = parcelRequire("kdMEA");

var $3XSV8 = parcelRequire("3XSV8");
function $d878087efb3c35ce$var$instanceOfDisplayGeneratorProps(object) {
    return 'view' in object && object.type === 'BaseMenu';
}
function $d878087efb3c35ce$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return 'icon' in object && object.type === 'CustomMenu';
}
const $d878087efb3c35ce$var$DisplaySubGenerator = (props)=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const [label, setLabel] = (0, $bxRTa.useState)('');
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $bxRTa.useEffect)(()=>{
        if ($d878087efb3c35ce$var$instanceOfDisplayGeneratorProps(props)) setLabel(translation[props.view.toString()]);
        else if ($d878087efb3c35ce$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === 'string') setLabel(props.label);
            else if (props.label && typeof props.label === 'object') setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($d878087efb3c35ce$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $2rYkD.AvailableSubViews).history:
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).history));
                break;
            case (0, $2rYkD.AvailableSubViews).tutorial:
                console.log('Tutorial');
                break;
        }
        else if ($d878087efb3c35ce$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            if (props.customDisplay) dispatch((0, $cto9a.storeActions).utils.setCurrentCustomView({
                ...props
            }));
        }
        props.handleClick && props.handleClick();
    };
    return (0, $kdMEA.mobileDisplays).includes(props.device) ? /* On mobile / widget : display available views as lines, without icons */ /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && 'rf-border-t rf-border-t-menuBorder'}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: (0, $eO5xw.capitalizeFirstLetter)(label, locale)
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-h-24 rf-w-24 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)'
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $d878087efb3c35ce$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                view: props.view,
                className: "rf-h-8"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                icon: props.icon,
                className: "rf-h-8 rf-w-8 rf-flex"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-uppercase rf-text-[#575F6B] ${isRTL ? 'rf-text-arabic' : 'rf-text-xs'}`,
                children: label
            })
        ]
    });
};
var $d878087efb3c35ce$export$2e2bcd8739ae039 = $d878087efb3c35ce$var$DisplaySubGenerator;

});


parcelRegister("iBT6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6845afb7ac8a9e4$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $3RB0m = parcelRequire("3RB0m");
const $a6845afb7ac8a9e4$var$Version = ({ isMobile: isMobile })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `${isMobile ? 'rf-px-5 rf-pt-6 rf-text-xsm' : 'rf-absolute rf-left-8 rf-bottom-2 rf-text-sm'} rf-text-[#A4A7AF] rf-text-sm`,
        children: `v ${(0, $3RB0m.version)}`
    });
};
var $a6845afb7ac8a9e4$export$2e2bcd8739ae039 = $a6845afb7ac8a9e4$var$Version;

});


parcelRegister("cxKWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed59ffb9b8bdca9f$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("l9TTE");
var $66rUF = parcelRequire("66rUF");

var $bt5PB = parcelRequire("bt5PB");

var $1HwbH = parcelRequire("1HwbH");

var $bAJ6O = parcelRequire("bAJ6O");

var $dncba = parcelRequire("dncba");
const $ed59ffb9b8bdca9f$var$Parameters = ({ handleBack: handleBack })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const displaySubtitles = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.displaySubtitles);
    const disableHistory = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableHistory);
    const disableSubtitles = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableSubtitles);
    const muted = (0, $5FZWK.useSelector)((state)=>state.speechReducer.muted);
    const disableSound = (0, $5FZWK.useSelector)((state)=>state.speechReducer.disableSound);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const handleSoundChange = (val)=>{
        dispatch((0, $cto9a.storeActions).speech.setMuted(!val));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            !disableSound && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $66rUF.default), {
                className: "rf-py-3 large:rf-py-0",
                title: translation.common.sound,
                handleChange: handleSoundChange,
                defaultChecked: !muted
            }),
            isMobile && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-0 rf-w-full rf-border-t rf-border-t-menuBorder"
            }),
            mode !== (0, $2rYkD.Mode).text && !disableSubtitles && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $66rUF.default), {
                className: "rf-py-3 large:rf-py-0",
                title: translation.common.subtitle,
                handleChange: (on)=>dispatch((0, $cto9a.storeActions).retorik.setDisplaySubtitles(on)),
                defaultChecked: displaySubtitles
            }),
            isMobile && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bt5PB.default), {}),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1HwbH.default), {
                        handleBack: handleBack
                    }),
                    !disableHistory && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bAJ6O.default), {
                        handleBack: handleBack
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dncba.default), {
                        handleClick: handleBack
                    })
                ]
            })
        ]
    });
};
var $ed59ffb9b8bdca9f$export$2e2bcd8739ae039 = $ed59ffb9b8bdca9f$var$Parameters;

});
parcelRegister("bt5PB", function(module, exports) {

$parcel$export(module.exports, "default", () => $43c1aad1002c044b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $hzhG4 = parcelRequire("hzhG4");
const $43c1aad1002c044b$var$LanguageButton = ()=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const supported = (0, $5FZWK.useSelector)((state)=>state.localeReducer.supported);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    /**
   * On call :
   *  - change RetorikContext's currentSubView state
   */ const handleClick = ()=>{
        dispatch((0, $cto9a.storeActions).utils.setCurrentSubView(currentSubView === (0, $2rYkD.CurrentSubView).languages ? (0, $2rYkD.CurrentSubView).none : (0, $2rYkD.CurrentSubView).languages));
    };
    return supported.length > 1 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hzhG4.default), {
        title: translation.common.lang,
        icon: "lang",
        color: currentSubView === (0, $2rYkD.CurrentSubView).languages ? themeColors.secondary : '#A4A7AF',
        onClick: handleClick
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $43c1aad1002c044b$export$2e2bcd8739ae039 = $43c1aad1002c044b$var$LanguageButton;

});
parcelRegister("hzhG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bba48756c4a0595$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $13Gq4 = parcelRequire("13Gq4");
parcelRequire("81HL8");
var $2ogpH = parcelRequire("2ogpH");
var $k1ioo = parcelRequire("k1ioo");
var $3EchS = parcelRequire("3EchS");
parcelRequire("7Jjoy");
var $iyJo4 = parcelRequire("iyJo4");
const $6bba48756c4a0595$var$ParameterButton = ({ title: title, color: color, icon: icon, onClick: onClick })=>{
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row ${icon === 'lang' ? 'rf-justify-between' : 'rf-justify-start'} rf-items-center rf-border-t rf-border-t-menuBorder rf-capitalize`,
        onClick: (e)=>onClick(e),
        "aria-label": title,
        children: [
            title,
            icon === 'lang' && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-flex rf-flex-row rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-mr-3 rf-text-lightgray rf-normal-case",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($13Gq4)))[locale]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iyJo4.default), {
                        className: "rf-h-4"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-width-fill-available rf-mx-3 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg",
        style: {
            color: color || '#A4A7AF',
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)',
            boxShadow: '2px 2px 6px #00000029'
        },
        onClick: (e)=>onClick(e),
        "aria-label": title,
        children: [
            icon === 'tutorial' ? /*#__PURE__*/ (0, $fl9nK.jsx)($3EchS.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === 'history' ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ogpH.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === 'lang' ? /*#__PURE__*/ (0, $fl9nK.jsx)($k1ioo.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-1 rf-uppercase",
                children: title
            })
        ]
    });
};
var $6bba48756c4a0595$export$2e2bcd8739ae039 = $6bba48756c4a0595$var$ParameterButton;

});


parcelRegister("1HwbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $684aa20548960f8b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $hzhG4 = parcelRequire("hzhG4");
const $684aa20548960f8b$var$TutorialButton = ({ handleBack: handleBack })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const handleClick = ()=>{
        handleBack?.();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hzhG4.default), {
        title: translation.tutorial.shorttitle,
        icon: "tutorial",
        onClick: handleClick
    });
};
var $684aa20548960f8b$export$2e2bcd8739ae039 = $684aa20548960f8b$var$TutorialButton;

});

parcelRegister("bAJ6O", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb13c235c769d16$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $hzhG4 = parcelRequire("hzhG4");
const $7bb13c235c769d16$var$HistoryButton = ({ handleBack: handleBack })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    const handleClick = ()=>{
        handleBack?.();
        dispatch((0, $cto9a.storeActions).utils.setCurrentSubView(currentSubView === (0, $2rYkD.CurrentSubView).history ? (0, $2rYkD.CurrentSubView).none : (0, $2rYkD.CurrentSubView).history));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hzhG4.default), {
        title: translation.history.title,
        icon: "history",
        color: currentSubView === (0, $2rYkD.CurrentSubView).history ? themeColors.secondary : '#A4A7AF',
        onClick: handleClick
    });
};
var $7bb13c235c769d16$export$2e2bcd8739ae039 = $7bb13c235c769d16$var$HistoryButton;

});


parcelRegister("3KYvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $48212c6720f5588b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $eO5xw = parcelRequire("eO5xw");

var $hnSXC = parcelRequire("hnSXC");

var $b0ztB = parcelRequire("b0ztB");
const $48212c6720f5588b$var$Dashboard = ({ toggleDashboard: toggleDashboard })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const localizedMenus = (0, $5FZWK.useSelector)((state)=>state.localeReducer.localizedMenus);
    const menus = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.menu);
    const processedMenus = (0, $bxRTa.useMemo)(()=>{
        return localizedMenus || menus?.categories;
    }, [
        localizedMenus,
        menus
    ]);
    const handleHome = ()=>{
        dispatch((0, $cto9a.storeActions).directline.sendEvent({
            name: 'showHome'
        }));
        toggleDashboard();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-px-5 rf-flex rf-flex-col rf-justify-start",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-relative rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center rf-flex-nowrap rf-gap-2 hover:rf-cursor-pointer rf-rounded rf-text-trueblack rf-overflow-hidden",
                onClick: handleHome,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hnSXC.default), {
                        className: "rf-h-6 rf-w-8",
                        color: "#1999B1"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        children: (0, $eO5xw.capitalizeFirstLetter)(translation.home.shorttitle, locale)
                    })
                ]
            }),
            processedMenus?.map((menu, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-h-6 -rf-mx-8 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b0ztB.default), {
                            ...menu,
                            onClick: toggleDashboard
                        })
                    ]
                }, key);
            })
        ]
    });
};
var $48212c6720f5588b$export$2e2bcd8739ae039 = $48212c6720f5588b$var$Dashboard;

});
parcelRegister("b0ztB", function(module, exports) {

$parcel$export(module.exports, "default", () => $80421e0bfdcb4c70$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $8Ibqy = parcelRequire("8Ibqy");
const $80421e0bfdcb4c70$var$DashboardColumn = ({ title: title, tiles: tiles, onClick: onClick })=>{
    const processedItems = (0, $bxRTa.useMemo)(()=>{
        return tiles.slice().sort((item1, item2)=>item1.index - item2.index);
    }, [
        tiles
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-pt-6 rf-pb-2 rf-flex rf-flex-col rf-justify-start",
        children: [
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-text-lgcustom rf-font-bold rf-pb-2",
                children: title
            }),
            processedItems.map((item, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `rf-w-full ${key && 'rf-border-t rf-border-t-menuBorder'}`,
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8Ibqy.default), {
                        ...item,
                        textColor: undefined,
                        onClick: onClick
                    })
                }, key);
            })
        ]
    });
};
var $80421e0bfdcb4c70$export$2e2bcd8739ae039 = $80421e0bfdcb4c70$var$DashboardColumn;

});
parcelRegister("8Ibqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cbbe61161f64952$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("6hiCI");
var $28u6w = parcelRequire("28u6w");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $5JKxf = parcelRequire("5JKxf");
const $0cbbe61161f64952$var$md = (0, $28u6w.default)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    typographer: true,
    quotes: `""''`
});
const $0cbbe61161f64952$var$DashboardItem = ({ text: text, textColor: textColor, image: image, action: action, onClick: onClick })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const handleInternalAction = (value)=>{
        if (value?.name) switch(value.name.toLowerCase()){
            case 'openlanguage':
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).languages));
                break;
            case 'openhistory':
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).history));
                break;
            case 'opentutorial':
                console.log('Open tutorial');
                break;
            case 'opennews':
                dispatch((0, $cto9a.storeActions).view.setRoute((0, $2rYkD.Routes).News));
                break;
            case 'openweather':
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).weather));
                break;
            case 'openemergency':
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).emergency));
                break;
            case 'fullscreenimage':
                value.url && dispatch((0, $cto9a.storeActions).utils.setFullScreenImage(value.url));
                break;
        }
    };
    const handleClick = (e)=>{
        switch(action.type){
            case (0, $2rYkD.ActionType).message:
                action.value?.text && dispatch((0, $cto9a.storeActions).directline.sendMessage({
                    text: action.value.text
                }));
                break;
            case (0, $2rYkD.ActionType).event:
                action.value?.name && dispatch((0, $cto9a.storeActions).directline.sendEvent({
                    name: action.value.name,
                    value: action.value.value || null
                }));
                break;
            case (0, $2rYkD.ActionType).url:
                action.value?.url && window.open(action.value.url, '_blank', 'noopener noreferrer');
                break;
            case (0, $2rYkD.ActionType).internal:
                handleInternalAction(action.value);
                break;
        }
        onClick();
        dispatch((0, $cto9a.storeActions).utils.setClickedOnUI((0, $2rYkD.UIPart).card));
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-relative rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center rf-flex-nowrap rf-gap-2 hover:rf-cursor-pointer rf-rounded rf-overflow-hidden",
        style: {
            color: textColor || '#000'
        },
        onClick: (e)=>handleClick(e),
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-6 rf-w-8",
                children: image?.url && /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: image.url.indexOf('svg') > -1 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5JKxf.default), {
                        svgUrl: image.url,
                        height: "100%",
                        fillColor: image.color
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                        className: "rf-h-full",
                        src: image.url
                    })
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: $0cbbe61161f64952$var$md.render(text)
                }
            })
        ]
    });
};
var $0cbbe61161f64952$export$2e2bcd8739ae039 = $0cbbe61161f64952$var$DashboardItem;

});





parcelRegister("iLzAK", function(module, exports) {

$parcel$export(module.exports, "default", () => $be6cc8c3888f2e35$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $gPs3v = parcelRequire("gPs3v");

var $h0yA8 = parcelRequire("h0yA8");

var $iBT6g = parcelRequire("iBT6g");

var $75jcl = parcelRequire("75jcl");

var $hnSXC = parcelRequire("hnSXC");
parcelRequire("81HL8");
var $77wBI = parcelRequire("77wBI");

var $8XlTw = parcelRequire("8XlTw");

const $be6cc8c3888f2e35$var$LittleWeather = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("4Twm7")));
const $be6cc8c3888f2e35$var$Dashboard = ({ toggleDashboard: toggleDashboard })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const localizedMenus = (0, $5FZWK.useSelector)((state)=>state.localeReducer.localizedMenus);
    const menus = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.menu);
    const isUsedOnBorne = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.isUsedOnBorne);
    const hideParametersButtonInMenu = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.hideParametersButtonInMenu);
    const [justify, setJustify] = (0, $bxRTa.useState)();
    const [opacityStyle, setOpacityStyle] = (0, $bxRTa.useState)('');
    const divRef = (0, $bxRTa.useRef)(null);
    const processedMenus = (0, $bxRTa.useMemo)(()=>{
        return localizedMenus || menus?.categories;
    }, [
        localizedMenus,
        menus
    ]);
    /**
   * Check if there is an overflow to adjust justify-content value on menu container
   */ (0, $bxRTa.useLayoutEffect)(()=>{
        setJustify(divRef?.current?.scrollHeight && divRef?.current?.scrollHeight > divRef?.current?.clientHeight ? 'flex-start' : 'center');
    }, [
        menus
    ]);
    const handleHome = ()=>{
        dispatch((0, $cto9a.storeActions).directline.sendEvent({
            name: 'showHome'
        }));
        toggleDashboard();
    };
    const handleScroll = ()=>{
        if (divRef.current) {
            const maxScroll = divRef.current.scrollHeight - divRef.current.offsetHeight;
            const percentage = Math.ceil(divRef.current.scrollTop / maxScroll * 20);
            setOpacityStyle(`linear-gradient(to top, black ${100 - percentage}%, transparent 100%)`);
        }
    };
    /**
   * Called in borne mode to open retorik kiosk parameters
   */ const handleClickParameters = ()=>{
        dispatch((0, $cto9a.storeActions).utils.askForKioskParametersOpening());
        toggleDashboard?.();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $gPs3v.default), {
        onClick: toggleDashboard,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-h-full rf-w-full rf-pt-40 large-vertical:rf-pt-48 rf-flex rf-justify-center rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $h0yA8.default), {}),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bxRTa.Suspense), {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)($be6cc8c3888f2e35$var$LittleWeather, {})
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        ref: divRef,
                        className: "rf-h-full rf-pt-4 rf-pb-24 rf-px-48 tablet:rf-pl-12 tablet:rf-pr-24 borne:rf-pl-32 borne:rf-pr-56 rf-flex rf-flex-col rf-items-start rf-gap-8 rf-overflow-y-scroll rf-scrollbar-hidden",
                        style: {
                            justifyContent: justify,
                            WebkitMaskImage: opacityStyle
                        },
                        onScroll: handleScroll,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                                className: "rf-h-14 rf-min-h-14 borne:rf-h-20 borne:rf-min-h-20 rf-px-4 rf-py-3 rf-flex rf-flex-row rf-justify-center rf-items-center rf-gap-4 hover:rf-shadow-[inset_0_0_12px_#00000029] hover:rf-cursor-pointer rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
                                style: {
                                    color: '#575F6B',
                                    background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)'
                                },
                                onClick: handleHome,
                                children: [
                                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hnSXC.default), {
                                        className: "rf-h-8 borne:rf-h-10",
                                        color: "#818181"
                                    }),
                                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                        className: "rf-uppercase",
                                        children: translation.home.shorttitle
                                    })
                                ]
                            }),
                            processedMenus?.map((menu, key)=>{
                                return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8XlTw.default), {
                                    ...menu,
                                    onClick: toggleDashboard
                                }, key);
                            })
                        ]
                    }),
                    isUsedOnBorne && !hideParametersButtonInMenu ? /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                        // @ts-ignore
                        part: "retorik-framework-parameters",
                        className: "rf-absolute rf-left-4 rf-bottom-4 rf-h-8 rf-flex rf-flex-row rf-items-center",
                        onClick: handleClickParameters,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $77wBI.default), {
                                color: "#A4A7AF"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                className: "rf-uppercase rf-ml-1 rf-text-xsl rf-text-[#A4A7AF]",
                                children: translation.common.parameters
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iBT6g.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $75jcl.default), {
                dashboardVisible: true,
                onClick: toggleDashboard
            })
        ]
    });
};
var $be6cc8c3888f2e35$export$2e2bcd8739ae039 = $be6cc8c3888f2e35$var$Dashboard;

});
parcelRegister("8XlTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $479db7a2cdc55e0a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $eP5yt = parcelRequire("eP5yt");
const $479db7a2cdc55e0a$var$DashboardLine = ({ title: title, tiles: tiles, onClick: onClick })=>{
    const processedItems = (0, $bxRTa.useMemo)(()=>{
        return tiles.slice().sort((item1, item2)=>item1.index - item2.index);
    }, [
        tiles
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-flex rf-flex-col rf-justify-start rf-gap-4",
        children: [
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-title-bold-size-auto",
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-gap-6 rf-flex-wrap",
                children: processedItems.map((item, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $eP5yt.default), {
                        ...item,
                        onClick: onClick
                    }, key);
                })
            })
        ]
    });
};
var $479db7a2cdc55e0a$export$2e2bcd8739ae039 = $479db7a2cdc55e0a$var$DashboardLine;

});
parcelRegister("eP5yt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0e2746b4da1d09a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $2aMjv = parcelRequire("2aMjv");
var $hzlaD = parcelRequire("hzlaD");

var $7QU6k = parcelRequire("7QU6k");
parcelRequire("6hiCI");
var $28u6w = parcelRequire("28u6w");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $5JKxf = parcelRequire("5JKxf");

var $9TTQJ = parcelRequire("9TTQJ");

var $8e5cw = parcelRequire("8e5cw");
const $d0e2746b4da1d09a$var$md = (0, $28u6w.default)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    typographer: true,
    quotes: `""''`
});
const $d0e2746b4da1d09a$var$springEnterDuration = 500;
const $d0e2746b4da1d09a$var$springQrcodeDuration = 500;
const $d0e2746b4da1d09a$var$DashboardItem = ({ index: index, text: text, textColor: textColor, backgroundColor: backgroundColor, image: image, action: action, onClick: onClick })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isUsedOnBorne = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.isUsedOnBorne);
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)(undefined);
    const divRef = (0, $bxRTa.useRef)(null);
    const fadeInTimerRef = (0, $bxRTa.useRef)(null);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                transform: 'translateX(0%)',
                opacity: 0
            }
        }));
    const [springQr, apiQr] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        setTimeout(()=>{
            api.start({
                from: {
                    transform: 'translateX(100%)',
                    opacity: 0
                },
                to: {
                    transform: 'translateX(0%)',
                    opacity: 1
                },
                config: {
                    duration: $d0e2746b4da1d09a$var$springEnterDuration,
                    easing: (0, $2aMjv.easings).easeInBack
                }
            });
        }, index * 150);
    }, []);
    const handleInternalAction = (value)=>{
        if (value?.name) switch(value.name.toLowerCase()){
            case 'openlanguage':
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).languages));
                break;
            case 'openhistory':
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).history));
                break;
            case 'opentutorial':
                console.log('Open tutorial');
                break;
            case 'opennews':
                dispatch((0, $cto9a.storeActions).view.setRoute((0, $2rYkD.Routes).News));
                break;
            case 'openweather':
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).weather));
                break;
            case 'openemergency':
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).emergency));
                break;
            case 'fullscreenimage':
                value.url && dispatch((0, $cto9a.storeActions).utils.setFullScreenImage(value.url));
                break;
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        qrCodeData && apiQr.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $d0e2746b4da1d09a$var$springQrcodeDuration
            }
        });
        return ()=>{
            fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        };
    }, [
        qrCodeData
    ]);
    const handleCloseQrCode = ()=>{
        apiQr.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $d0e2746b4da1d09a$var$springQrcodeDuration
            }
        });
        fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        fadeInTimerRef.current = setTimeout(()=>{
            setQrCodeData(undefined);
        }, $d0e2746b4da1d09a$var$springQrcodeDuration);
    };
    const setQrCodeDataOverlay = async (url)=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(url);
        setQrCodeData(qrCodeString);
    };
    const handleClick = (e)=>{
        switch(action.type){
            case (0, $2rYkD.ActionType).message:
                action.value?.text && dispatch((0, $cto9a.storeActions).directline.sendMessage({
                    text: action.value.text
                }));
                onClick();
                break;
            case (0, $2rYkD.ActionType).event:
                action.value?.name && dispatch((0, $cto9a.storeActions).directline.sendEvent({
                    name: action.value.name,
                    value: action.value.value || null
                }));
                onClick();
                break;
            case (0, $2rYkD.ActionType).url:
                if (action.value?.url) // Generate QR-code data on borne, open the URL otherwise
                isUsedOnBorne ? setQrCodeDataOverlay?.(action.value.url) : window.open(action.value.url, '_blank', 'noopener noreferrer');
                break;
            case (0, $2rYkD.ActionType).internal:
                handleInternalAction(action.value);
                onClick();
                break;
        }
        dispatch((0, $cto9a.storeActions).utils.setClickedOnUI((0, $2rYkD.UIPart).card));
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
        ref: divRef,
        className: "rf-relative rf-w-32 tablet:rf-w-28 borne:rf-w-40 rf-aspect-square rf-p-3 borne:rf-p-5 rf-flex rf-flex-col rf-justify-between rf-items-center hover:rf-shadow-[inset_0_0_12px_#00000029] hover:rf-cursor-pointer rf-rounded rf-shadow-[3px_3px_16px_#00000029] rf-overflow-hidden",
        style: {
            color: textColor || '#575F6B',
            background: backgroundColor || 'linear-gradient(to left top, #F2F3F6, #E5E6EC)',
            ...spring
        },
        onClick: (e)=>handleClick(e),
        children: [
            image?.url && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-[50%] rf-flex rf-justify-center rf-items-center",
                children: image.url.indexOf('svg') > -1 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5JKxf.default), {
                    svgUrl: image.url,
                    height: "100%",
                    fillColor: image.color
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                    className: "rf-h-full",
                    src: image.url
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-[35%] rf-w-full rf-flex rf-justify-center rf-items-center rf-text-center rf-text-extra-small-size-auto rf-overflow-y-hidden rf-scrollbar-thin",
                dangerouslySetInnerHTML: {
                    __html: $d0e2746b4da1d09a$var$md.render(text)
                }
            }),
            qrCodeData && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
                className: "rf-absolute rf-h-full rf-w-full rf-top-0 rf-left-0 rf-z-ui rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2 rf-p-2 rf-text-truewhite",
                style: {
                    background: 'rgba(18,18,18,0.7)',
                    ...springQr
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                        onClick: handleCloseQrCode,
                        showLabel: false
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                        src: qrCodeData
                    })
                ]
            })
        ]
    });
};
var $d0e2746b4da1d09a$export$2e2bcd8739ae039 = $d0e2746b4da1d09a$var$DashboardItem;

});




parcelRegister("fnPQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dabfd02933d4a59$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

const $0dabfd02933d4a59$var$NewsContainer = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("b7yy4")));
const $0dabfd02933d4a59$var$NewsView = ({ hideMenu: hideMenu, isRetorikNews: isRetorikNews, loop: loop, fromVeille: fromVeille, handleEndedWithoutloop: handleEndedWithoutloop })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bxRTa.Suspense), {
        children: /*#__PURE__*/ (0, $fl9nK.jsx)($0dabfd02933d4a59$var$NewsContainer, {
            hideMenu: hideMenu,
            isRetorikNews: isRetorikNews,
            loop: loop,
            handleEndedWithoutloop: handleEndedWithoutloop,
            fromVeille: fromVeille
        })
    });
};
var $0dabfd02933d4a59$export$2e2bcd8739ae039 = $0dabfd02933d4a59$var$NewsView;

});
parcelRegister("b7yy4", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("hvc5r"),
    $parcel$import("aSHJY"),
    $parcel$import("lBnLP")
]).then(()=>parcelRequire('8DLzn'));

});


parcelRegister("lo8xw", function(module, exports) {

var $1rrno = parcelRequire("1rrno");

var $kKnec = parcelRequire("kKnec");
function $f92276aae71962b2$var$$parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $f92276aae71962b2$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $f92276aae71962b2$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
$f92276aae71962b2$var$$parcel$defineInteropFlag(module.exports);
$f92276aae71962b2$var$$parcel$export(module.exports, "default", ()=>$f92276aae71962b2$var$$882b6d93070905b3$export$2e2bcd8739ae039);
$f92276aae71962b2$var$$parcel$export(module.exports, "createSpeechRecognitionPonyfill", ()=>$f92276aae71962b2$var$$87729c1c3277125d$export$7c06391dbd8298b0);
$f92276aae71962b2$var$$parcel$export(module.exports, "createSpeechSynthesisPonyfill", ()=>$f92276aae71962b2$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c);
$f92276aae71962b2$var$$parcel$export(module.exports, "fetchAuthorizationToken", ()=>$f92276aae71962b2$var$$3e54160c801e3614$export$2e2bcd8739ae039);
$f92276aae71962b2$var$$parcel$export(module.exports, "SpeechSynthesisUtterance", ()=>$f92276aae71962b2$var$$fd1e2557ea351c52$export$2e2bcd8739ae039);
$f92276aae71962b2$var$$parcel$export(module.exports, "SpeechSynthesis", ()=>$f92276aae71962b2$var$$0adf7fcdea541e7b$export$1268b12b5ca510be);
$f92276aae71962b2$var$$parcel$export(module.exports, "SpeechGrammarList", ()=>$f92276aae71962b2$var$$c213b3979e1323e8$export$2e2bcd8739ae039);
/* eslint class-methods-use-this: "off" */ /* eslint complexity: ["error", 70] */ /* eslint no-await-in-loop: "off" */ /* eslint no-empty-function: "off" */ /* eslint no-magic-numbers: ["error", { "ignore": [0, 100, 150] }] */ function $f92276aae71962b2$var$$e3680afa520905a3$export$2e2bcd8739ae039(array, extras) {
    const map = {
        // @ts-ignore
        ...[].reduce.call(array, (map, value, index)=>{
            // @ts-ignore
            map[index] = value;
            return map;
        }, {}),
        ...extras,
        length: array.length,
        [Symbol.iterator]: ()=>[].slice.call(map)[Symbol.iterator]()
    };
    return map;
}
var $f92276aae71962b2$var$$409c56140c6d134e$export$2e2bcd8739ae039 = {
    AudioConfig: $1rrno.AudioConfig,
    OutputFormat: $1rrno.OutputFormat,
    ResultReason: $1rrno.ResultReason,
    SpeechConfig: $1rrno.SpeechConfig,
    SpeechRecognizer: $1rrno.SpeechRecognizer,
    SpeechSynthesizer: $1rrno.SpeechSynthesizer
};
const { ResultReason: { RecognizingSpeech: $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizingSpeech, RecognizedSpeech: $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizedSpeech } } = $f92276aae71962b2$var$$409c56140c6d134e$export$2e2bcd8739ae039;
function $f92276aae71962b2$var$$4e800713d8cfc243$export$2e2bcd8739ae039(result, { maxAlternatives: maxAlternatives = Infinity, textNormalization: textNormalization = 'display' } = {}) {
    if (result.reason === $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizingSpeech || result.reason === $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizedSpeech && !result.json.NBest) {
        const resultList = [
            {
                confidence: 0.5,
                transcript: result.text
            }
        ];
        if (result.reason === $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizedSpeech) resultList.isFinal = true;
        return resultList;
    } else if (result.reason === $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizedSpeech) {
        const resultList = $f92276aae71962b2$var$$e3680afa520905a3$export$2e2bcd8739ae039((result.json.NBest || []).slice(0, maxAlternatives).map(({ Confidence: confidence, Display: display, ITN: itn, Lexical: lexical, MaskedITN: maskedITN })=>({
                confidence: confidence,
                transcript: textNormalization === 'itn' ? itn : textNormalization === 'lexical' ? lexical : textNormalization === 'maskeditn' ? maskedITN : display
            })), {
            isFinal: true
        });
        return resultList;
    }
    return [];
}
function $f92276aae71962b2$var$$521b485d0cd15790$export$2e2bcd8739ae039() {
    let shiftDeferred;
    const queue = [];
    const push = (value)=>{
        if (shiftDeferred) {
            const { resolve: resolve } = shiftDeferred;
            shiftDeferred = null;
            resolve(value);
        } else queue.push(value);
    };
    const shift = ()=>{
        if (queue.length) return Promise.resolve(queue.shift());
        return (shiftDeferred || (shiftDeferred = $f92276aae71962b2$var$$parcel$interopDefault($kKnec)())).promise;
    };
    return {
        push: push,
        shift: shift
    };
}
function $f92276aae71962b2$var$$e2af95d6aca72d87$export$2e2bcd8739ae039(fnOrValue) {
    return typeof fnOrValue === 'function' ? fnOrValue() : fnOrValue;
}
let $f92276aae71962b2$var$$cec424af042710dc$var$shouldWarnOnSubscriptionKey = true;
function $f92276aae71962b2$var$$cec424af042710dc$export$2e2bcd8739ae039({ credentials: credentials, looseEvents: looseEvents, ...otherOptions }) {
    if (!credentials) throw new Error('web-speech-cognitive-services: Credentials must be specified.');
    return {
        ...otherOptions,
        fetchCredentials: async ()=>{
            const { authorizationToken: authorizationToken, customVoiceHostname: customVoiceHostname, region: region, speechRecognitionHostname: speechRecognitionHostname, speechSynthesisHostname: speechSynthesisHostname, subscriptionKey: subscriptionKey } = await $f92276aae71962b2$var$$e2af95d6aca72d87$export$2e2bcd8739ae039(credentials);
            if (!authorizationToken && !subscriptionKey || authorizationToken && subscriptionKey) throw new Error('web-speech-cognitive-services: Either "authorizationToken" or "subscriptionKey" must be provided.');
            else if (!region && !(speechRecognitionHostname && speechSynthesisHostname)) throw new Error('web-speech-cognitive-services: Either "region" or "speechRecognitionHostname" and "speechSynthesisHostname" must be set.');
            else if (region && (customVoiceHostname || speechRecognitionHostname || speechSynthesisHostname)) throw new Error('web-speech-cognitive-services: Only either "region" or "customVoiceHostname", "speechRecognitionHostname" and "speechSynthesisHostname" can be set.');
            else if (authorizationToken) {
                if (typeof authorizationToken !== 'string') throw new Error('web-speech-cognitive-services: "authorizationToken" must be a string.');
            } else if (typeof subscriptionKey !== 'string') throw new Error('web-speech-cognitive-services: "subscriptionKey" must be a string.');
            if ($f92276aae71962b2$var$$cec424af042710dc$var$shouldWarnOnSubscriptionKey && subscriptionKey) {
                console.warn('web-speech-cognitive-services: In production environment, subscription key should not be used, authorization token should be used instead.');
                $f92276aae71962b2$var$$cec424af042710dc$var$shouldWarnOnSubscriptionKey = false;
            }
            const resolvedCredentials = {
                region: region,
                authorizationToken: authorizationToken,
                subscriptionKey: subscriptionKey,
                customVoiceHostname: customVoiceHostname,
                speechRecognitionHostname: speechRecognitionHostname,
                speechSynthesisHostname: speechSynthesisHostname
            };
            return resolvedCredentials;
        },
        looseEvents: looseEvents
    };
}
/* eslint class-methods-use-this: "off" */ class $f92276aae71962b2$var$$c213b3979e1323e8$export$2e2bcd8739ae039 {
    addFromString() {
        throw new Error('JSGF is not supported');
    }
    get phrases() {
        return this._phrases;
    }
    set phrases(value) {
        if (Array.isArray(value)) this._phrases = value;
        else if (typeof value === 'string') this._phrases = [
            value
        ];
        else throw new Error(`The provided value is not an array or of type 'string'`);
    }
    constructor(){
        this._phrases = [];
    }
}
// https://docs.microsoft.com/en-us/javascript/api/microsoft-cognitiveservices-speech-sdk/speechconfig?view=azure-node-latest#outputformat
// {
//   "RecognitionStatus": "Success",
//   "Offset": 900000,
//   "Duration": 49000000,
//   "NBest": [
//     {
//       "Confidence": 0.738919,
//       "Lexical": "second",
//       "ITN": "second",
//       "MaskedITN": "second",
//       "Display": "Second."
//     }
//   ]
// }
// {
//   "RecognitionStatus": "InitialSilenceTimeout",
//   "Offset": 50000000,
//   "Duration": 0
// }
// const { AudioConfig, OutputFormat, ResultReason, SpeechConfig, SpeechRecognizer } = SDK;
function $f92276aae71962b2$var$$87729c1c3277125d$var$serializeRecognitionResult({ duration: duration, errorDetails: errorDetails, json: json, offset: offset, properties: properties, reason: reason, resultId: resultId, text: text }) {
    return {
        duration: duration,
        errorDetails: errorDetails,
        json: JSON.parse(json),
        offset: offset,
        properties: properties,
        reason: reason,
        resultId: resultId,
        text: text
    };
}
function $f92276aae71962b2$var$$87729c1c3277125d$var$averageAmplitude(arrayBuffer) {
    const array = new Int16Array(arrayBuffer);
    return array.reduce((averageAmplitude, amplitude)=>averageAmplitude + Math.abs(amplitude), 0) / array.length;
}
function $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(fn) {
    return (...args)=>new Promise((resolve, reject)=>fn(...args, resolve, reject));
}
function $f92276aae71962b2$var$$87729c1c3277125d$var$prepareAudioConfig(audioConfig) {
    const originalAttach = audioConfig.attach;
    const boundOriginalAttach = audioConfig.attach.bind(audioConfig);
    let firstChunk = false;
    let muted = false;
    // We modify "attach" function and detect when audible chunk is read.
    // We will only modify "attach" function once.
    audioConfig.attach = async ()=>{
        const reader = await boundOriginalAttach();
        return {
            ...reader,
            read: async ()=>{
                const chunk = await reader.read();
                // The magic number 150 is measured by:
                // 1. Set microphone volume to 0
                // 2. Observe the amplitude (100-110) for the first few chunks
                //    (There is a short static caught when turning on the microphone)
                // 3. Set the number a bit higher than the observation
                if (!firstChunk && $f92276aae71962b2$var$$87729c1c3277125d$var$averageAmplitude(chunk.buffer) > 150) {
                    audioConfig.events.onEvent({
                        name: 'FirstAudibleChunk'
                    });
                    firstChunk = true;
                }
                if (muted) return {
                    buffer: new ArrayBuffer(0),
                    isEnd: true,
                    timeReceived: Date.now()
                };
                return chunk;
            }
        };
    };
    return {
        audioConfig: audioConfig,
        pause: ()=>{
            muted = true;
        },
        unprepare: ()=>{
            audioConfig.attach = originalAttach;
        }
    };
}
class $f92276aae71962b2$var$$87729c1c3277125d$export$7a5e8c1807e6b8ee {
    constructor(options, data){
        this.audioConfig = null;
        this.speechConfig = null;
        this.recognizer = null;
        this.enableTelemetry = true;
        this.looseEvents = false;
        this.textNormalization = 'display';
        this.started = false;
        this._autoStart = false;
        this._passive = false;
        this._continuous = false;
        this._interimResults = true;
        this._grammars = new $f92276aae71962b2$var$$c213b3979e1323e8$export$2e2bcd8739ae039();
        this._maxAlternatives = 1;
        this._debug = false;
        this.onstart = ()=>{};
        this.onend = ()=>{};
        this.onpassivestart = ()=>{};
        this.onpassiveend = ()=>{};
        this.onaudiostart = ()=>{};
        this.onaudioend = ()=>{};
        this.onsoundstart = ()=>{};
        this.onsoundend = ()=>{};
        this.onspeechstart = ()=>{};
        this.onspeechend = ()=>{};
        this.onerror = (value)=>{
            console.log('Error : ', value);
        };
        this.onabort = ()=>{
            this._debug && console.log('Recognition aborted');
        };
        this.onresult = (value)=>{
            this._debug && console.log('Result : ', value);
        };
        this.onpassiveresult = (value)=>{
            this._debug && console.log('Passive Result : ', value);
        };
        this.onwakeup = ()=>{
            this._debug && console.log('Wake up !');
        };
        this.start = ()=>{
            this._startOnce().catch((err)=>{
                new Error(`error : ${err.message}\ncallstack : ${err.stack}`);
            });
        };
        this.abort = undefined;
        this.stop = undefined;
        /**
   * Retrieval of credentials, initialization of speechConfig and start recognizing
   * @param fetchCredentials Function
   * @param speechRecognitionEndpointId string | undefined
   */ this.initRecognizer = async (fetchCredentials, speechRecognitionEndpointId, timerBeforeSpeechEnd)=>{
            const { authorizationToken: authorizationToken, region: region = 'westus', speechRecognitionHostname: speechRecognitionHostname, subscriptionKey: subscriptionKey } = await fetchCredentials();
            if (speechRecognitionHostname) {
                // Process host name to add 'wss' if no protocol is given
                const processedHostName = speechRecognitionHostname.startsWith('ws://') || speechRecognitionHostname.startsWith('wss://') ? speechRecognitionHostname : `wss://${speechRecognitionHostname}`;
                if (authorizationToken) {
                    this.speechConfig = $1rrno.SpeechConfig.fromHost(new URL(processedHostName));
                    this.speechConfig.authorizationToken = authorizationToken;
                } else this.speechConfig = $1rrno.SpeechConfig.fromHost(new URL(processedHostName), subscriptionKey);
            } else if (region && (authorizationToken || subscriptionKey)) this.speechConfig = authorizationToken ? $1rrno.SpeechConfig.fromAuthorizationToken(authorizationToken, region) : subscriptionKey ? $1rrno.SpeechConfig.fromSubscription(subscriptionKey, region) : null;
            if (this.speechConfig) {
                if (speechRecognitionEndpointId && this.speechConfig) this.speechConfig.endpointId = speechRecognitionEndpointId;
                this.speechConfig.outputFormat = $1rrno.OutputFormat.Detailed;
                this.speechConfig.speechRecognitionLanguage = this._lang || 'en-US';
                // Update timer before speech end if provided (values allowed 100 to 5000ms)
                timerBeforeSpeechEnd && this.speechConfig.setProperty($1rrno.PropertyId[$1rrno.PropertyId.Speech_SegmentationSilenceTimeoutMs], `${timerBeforeSpeechEnd}`);
                // Set max segmentation time to 60s to allow long speech recognitions in continuous mode (values allowed 20000 to 70000ms)
                this.speechConfig.setProperty($1rrno.PropertyId[$1rrno.PropertyId.Speech_SegmentationMaximumTimeMs], '60000');
                this._autoStart && this.start();
            }
        };
        /**
   * Create a new Synthesizer from audioConfig / speechConfig / lang
   * @param lang string
   */ this.createRecognizer = async ()=>{
            if (this.audioConfig && this.speechConfig) {
                this.speechConfig.speechRecognitionLanguage = this._lang;
                this.recognizer = new $1rrno.SpeechRecognizer(this.speechConfig, this.audioConfig);
                // Add grammars
                const { dynamicGrammar: dynamicGrammar } = this.recognizer.internalData;
                this.referenceGrammars && this.referenceGrammars.length && dynamicGrammar.addReferenceGrammar(this.referenceGrammars);
                // Add phrases
                const { phrases: phrases } = this._grammars;
                if (phrases && phrases.length) {
                    const phraseList = $1rrno.PhraseListGrammar.fromRecognizer(this.recognizer);
                    phrases.forEach((phrase)=>{
                        phraseList.addPhrase(phrase);
                    });
                }
            } else this.recognizer = null;
        };
        /**
   * Stop current recognizer, change language and start a new recognition
   * @param lang string
   */ this.changeLanguage = async (lang)=>{
            if (this.recognizer && this.audioConfig && this.speechConfig && lang && lang !== this._lang) {
                // Stop current recognition and start a new one
                await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                this._lang = lang;
                this._continuous && this.start();
            } else this.recognizer = null;
        };
        /**
   * In continuous mode, toggle from passive to active mode by stopping current recognition and starting a new one to prevent
   * receiving results from a current passive speech recognition.
   * If you don't care about having existing results in active recognition, just set recognition's 'passive' variable to 'false' instead
   * of using this method.
   */ this.toggleContinuousPassiveToActive = async ()=>{
            if (this._continuous && this.recognizer && this.audioConfig && this.speechConfig) {
                // Stop current recognition and start a new one
                if (this.started) await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                this._continuous = false;
                this._passive = false;
                this.start();
            }
        };
        /**
   * In continuous mode, toggle from passive to active mode by stopping current recognition and starting a new one to prevent
   * receiving results from a current passive speech recognition.
   * If you don't care about having existing results in active recognition, just set recognition's 'passive' variable to 'false' instead
   * of using this method.
   */ this.toggleContinuousActiveToPassive = async ()=>{
            if (!this._continuous && this.recognizer && this.audioConfig && this.speechConfig) {
                // Stop current recognition and start a new one
                if (this.started) await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                this._continuous = true;
                this._passive = true;
                this.start();
            }
        };
        this.processSendEvent = (type, data)=>{
            this._debug && console.log('Speech Recognizer Event : type = ', type, '\n, data = ', data);
            switch(type){
                case 'start':
                    if (this._passive) this.onpassivestart && this.onpassivestart();
                    else this.onstart && this.onstart();
                    this.started = true;
                    break;
                case 'end':
                    if (this._passive) this.onpassiveend && this.onpassiveend();
                    else this.onend && this.onend();
                    this.started = false;
                    break;
                case 'audiostart':
                    this.onaudiostart && this.onaudiostart();
                    break;
                case 'audioend':
                    this.onaudioend && this.onaudioend();
                    break;
                case 'soundstart':
                    this.onsoundstart && this.onsoundstart();
                    break;
                case 'soundend':
                    this.onsoundend && this.onsoundend();
                    break;
                case 'speechstart':
                    this.onspeechstart && this.onspeechstart();
                    break;
                case 'speechend':
                    this.onspeechend && this.onspeechend();
                    break;
                case 'error':
                    this.onerror && this.onerror(data);
                    this.started = false;
                    break;
                case 'abort':
                    this.onabort && this.onabort();
                    this.started = false;
                    break;
                case 'result':
                    this.onresult && this.onresult(data.results);
                    break;
                case 'passiveresult':
                    this.onpassiveresult && this.onpassiveresult(data.results);
                    break;
                case 'wakeup':
                    this.onwakeup && this.onwakeup();
                    break;
            }
        };
        this._autoStart = !!data?.autoStart;
        this._passive = !!data?.passive;
        this._wakeWords = data?.wakeWords || [];
        this._continuous = !!data?.continuous;
        this._interimResults = !(data?.interimResults === false);
        this._lang = data?.lang ? data.lang : typeof window !== 'undefined' ? window.document.documentElement.getAttribute('lang') || window.navigator.language : 'en-US';
        data?.grammarsList && (this._grammars.phrases = data.grammarsList);
        this._debug = !!data?.debug || false;
        const { audioConfig: audioConfig = null, enableTelemetry: // https://github.com/Microsoft/cognitive-services-speech-sdk-js#data--telemetry
        enableTelemetry = true, fetchCredentials: fetchCredentials, looseEvents: looseEvents, referenceGrammars: referenceGrammars, speechRecognitionEndpointId: speechRecognitionEndpointId, textNormalization: textNormalization = 'display' } = $f92276aae71962b2$var$$cec424af042710dc$export$2e2bcd8739ae039(options);
        this.enableTelemetry = enableTelemetry;
        this.looseEvents = !!looseEvents;
        this.referenceGrammars = referenceGrammars;
        this.textNormalization = textNormalization;
        if (!audioConfig && (!window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia)) console.warn('web-speech-cognitive-services: This browser does not support WebRTC and it will not work with Cognitive Services Speech Services.');
        else try {
            this.audioConfig = audioConfig || $1rrno.AudioConfig.fromDefaultMicrophoneInput();
            this.initRecognizer(fetchCredentials, speechRecognitionEndpointId, data?.timerBeforeSpeechEnd);
        } catch (e) {
            console.warn(e);
        }
    }
    get passive() {
        return this._passive;
    }
    set passive(value) {
        this._passive = value;
    }
    get wakeWords() {
        return this._wakeWords;
    }
    set wakeWords(value) {
        this._wakeWords = value;
    }
    get continuous() {
        return this._continuous;
    }
    set continuous(value) {
        this._continuous = value;
    }
    get grammars() {
        return this._grammars;
    }
    set grammars(value) {
        if (value instanceof $f92276aae71962b2$var$$c213b3979e1323e8$export$2e2bcd8739ae039) this._grammars = value;
        else throw new Error(`The provided value is not of type 'SpeechGrammarList'`);
    }
    get interimResults() {
        return this._interimResults;
    }
    set interimResults(value) {
        this._interimResults = value;
    }
    get maxAlternatives() {
        return this._maxAlternatives;
    }
    set maxAlternatives(value) {
        this._maxAlternatives = value;
    }
    get lang() {
        return this._lang;
    }
    set lang(value) {
        this._lang = value;
    }
    async _startOnce() {
        if (this.audioConfig && !this.started) {
            const { pause: pause, unprepare: unprepare } = $f92276aae71962b2$var$$87729c1c3277125d$var$prepareAudioConfig(this.audioConfig);
            const queue = $f92276aae71962b2$var$$521b485d0cd15790$export$2e2bcd8739ae039();
            let soundStarted = false;
            let speechStarted = false;
            let stopping = '';
            const { detach: detachAudioConfigEvent } = this.audioConfig.events.attach((event)=>{
                const { name: name } = event;
                if (name === 'AudioSourceReadyEvent') queue.push({
                    audioSourceReady: {}
                });
                else if (name === 'AudioSourceOffEvent') queue.push({
                    audioSourceOff: {}
                });
                else if (name === 'FirstAudibleChunk') queue.push({
                    firstAudibleChunk: {}
                });
            });
            await this.createRecognizer();
            if (this.recognizer) try {
                this.recognizer.canceled = (_, { errorDetails: errorDetails, offset: offset, reason: reason, sessionId: sessionId })=>{
                    queue.push({
                        canceled: {
                            errorDetails: errorDetails,
                            offset: offset,
                            reason: reason,
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.recognized = (_, { offset: offset, result: result, sessionId: sessionId })=>{
                    queue.push({
                        recognized: {
                            offset: offset,
                            result: $f92276aae71962b2$var$$87729c1c3277125d$var$serializeRecognitionResult(result),
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.recognizing = (_, { offset: offset, result: result, sessionId: sessionId })=>{
                    queue.push({
                        recognizing: {
                            offset: offset,
                            result: $f92276aae71962b2$var$$87729c1c3277125d$var$serializeRecognitionResult(result),
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.sessionStarted = (_, { sessionId: sessionId })=>{
                    queue.push({
                        sessionStarted: {
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.sessionStopped = (_, { sessionId: sessionId })=>{
                    // "sessionStopped" is never fired, probably because we are using startContinuousRecognitionAsync instead of recognizeOnceAsync.
                    queue.push({
                        sessionStopped: {
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.speechStartDetected = (_, { offset: offset, sessionId: sessionId })=>{
                    queue.push({
                        speechStartDetected: {
                            offset: offset,
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.speechEndDetected = (_, { sessionId: sessionId })=>{
                    // "speechEndDetected" is never fired, probably because we are using startContinuousRecognitionAsync instead of recognizeOnceAsync.
                    // Update: "speechEndDetected" is fired for DLSpeech.listenOnceAsync()
                    queue.push({
                        speechEndDetected: {
                            sessionId: sessionId
                        }
                    });
                };
                await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.startContinuousRecognitionAsync.bind(this.recognizer))();
                this.abort = ()=>queue.push({
                        abort: {}
                    });
                this.stop = ()=>queue.push({
                        stop: {}
                    });
                let audioStarted = false;
                let finalEvent = null;
                let finalizedResults = [];
                for(let loop = 0; !stopping || audioStarted; loop++){
                    const event = await queue.shift();
                    const { abort: abort, audioSourceOff: audioSourceOff, audioSourceReady: audioSourceReady, canceled: canceled, firstAudibleChunk: firstAudibleChunk, recognized: recognized, recognizing: recognizing, stop: stop } = event;
                    const errorMessage = canceled && canceled.errorDetails;
                    if (/Permission\sdenied/u.test(errorMessage || '')) {
                        // If microphone is not allowed, we should not emit "start" event.
                        finalEvent = {
                            data: 'not-allowed',
                            type: 'error'
                        };
                        break;
                    }
                    if (!loop) this.processSendEvent('start');
                    if (errorMessage) {
                        if (/1006/u.test(errorMessage)) {
                            if (!audioStarted) {
                                this.processSendEvent('audiostart');
                                this.processSendEvent('audioend');
                            }
                            finalEvent = {
                                data: 'network',
                                type: 'error'
                            };
                        } else finalEvent = {
                            data: 'unknown',
                            type: 'error'
                        };
                        break;
                    } else if (abort || stop) {
                        if (abort) {
                            finalEvent = {
                                type: 'abort'
                            };
                            // If we are aborting, we will ignore lingering recognizing/recognized events. But if we are stopping, we need them.
                            stopping = 'abort';
                        } else {
                            // When we pause, we will send { isEnd: true }, Speech Services will send us "recognized" event.
                            pause();
                            stopping = 'stop';
                        }
                        // Abort should not be dispatched without support of "stopContinuousRecognitionAsync".
                        // But for defensive purpose, we make sure "stopContinuousRecognitionAsync" is available before we can call.
                        if (abort && this.recognizer.stopContinuousRecognitionAsync) await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                    } else if (audioSourceReady) {
                        this.processSendEvent('audiostart');
                        audioStarted = true;
                    } else if (firstAudibleChunk) {
                        this.processSendEvent('soundstart');
                        soundStarted = true;
                    } else if (audioSourceOff) {
                        // Looks like we don't need this line and all the tests are still working.
                        // Guessing probably stopping is already truthy.
                        // stopping = true;
                        speechStarted && this.processSendEvent('speechend');
                        soundStarted && this.processSendEvent('soundend');
                        audioStarted && this.processSendEvent('audioend');
                        audioStarted = soundStarted = speechStarted = false;
                        break;
                    } else if (stopping !== 'abort') {
                        if (recognized && recognized.result && recognized.result.reason === $1rrno.ResultReason.NoMatch) finalEvent = {
                            data: 'no-speech',
                            type: 'error'
                        };
                        else if (recognized || recognizing) {
                            if (!audioStarted) {
                                // Unconfirmed prevention of quirks
                                this.processSendEvent('audiostart');
                                audioStarted = true;
                            }
                            if (!soundStarted) {
                                this.processSendEvent('soundstart');
                                soundStarted = true;
                            }
                            if (!speechStarted) {
                                this.processSendEvent('speechstart');
                                speechStarted = true;
                            }
                            if (recognized) {
                                const result = $f92276aae71962b2$var$$4e800713d8cfc243$export$2e2bcd8739ae039(recognized.result, {
                                    maxAlternatives: this.maxAlternatives,
                                    textNormalization: this.textNormalization
                                });
                                const recognizable = !!result[0].transcript;
                                if (recognizable) {
                                    finalizedResults = [
                                        ...finalizedResults,
                                        ...result
                                    ];
                                    if (this._interimResults) {
                                        this.processSendEvent('result', {
                                            results: finalizedResults
                                        });
                                        this._passive && this.processSendEvent('passiveresult', {
                                            results: result
                                        });
                                    }
                                }
                                // If it is continuous, we just sent the finalized results. So we don't need to send it again after "audioend" event.
                                if (this._continuous && recognizable) finalEvent = null;
                                else this._interimResults && (finalEvent = {
                                    data: {
                                        results: finalizedResults
                                    },
                                    type: 'result'
                                });
                                if (!this._continuous && this.recognizer.stopContinuousRecognitionAsync) await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                                // If event order can be loosened, we can send the recognized event as soon as we receive it.
                                // 1. If it is not recognizable (no-speech), we should send an "error" event just before "end" event. We will not loosen "error" events.
                                if (this.looseEvents && finalEvent && recognizable) {
                                    this.processSendEvent(finalEvent.type, finalEvent.data);
                                    finalEvent = null;
                                }
                            } else if (recognizing) {
                                const result = $f92276aae71962b2$var$$4e800713d8cfc243$export$2e2bcd8739ae039(recognizing.result, {
                                    maxAlternatives: this.maxAlternatives,
                                    textNormalization: this.textNormalization
                                });
                                if (this._passive && this._wakeWords && this._wakeWords.length > 0) {
                                    // Test wake words if some are present
                                    if (result && Array.isArray(result) && result.length > 0 && result[0].transcript) {
                                        const { transcript: transcript } = {
                                            ...result[0]
                                        };
                                        this._wakeWords.forEach((wakeWord)=>{
                                            if (transcript.toLowerCase().includes(wakeWord.toLowerCase())) this.processSendEvent('wakeup');
                                        });
                                    }
                                    this._interimResults && this.processSendEvent('passiveresult', {
                                        results: result
                                    });
                                }
                                this._interimResults && this.processSendEvent('result', {
                                    results: [
                                        ...finalizedResults,
                                        ...result
                                    ]
                                });
                            }
                        }
                    }
                }
                speechStarted && this.processSendEvent('speechend');
                soundStarted && this.processSendEvent('soundend');
                audioStarted && this.processSendEvent('audioend');
                if (finalEvent) {
                    if (finalEvent.type === 'result' && (typeof finalEvent.data === 'string' || !finalEvent.data?.results || !finalEvent.data.results.length)) finalEvent = {
                        data: 'no-speech',
                        type: 'error'
                    };
                    this.processSendEvent(finalEvent.type, finalEvent.data);
                }
                // Even though there is no "start" event emitted, we will still emit "end" event
                // This is mainly for "microphone blocked" story.
                this.processSendEvent('end');
                detachAudioConfigEvent && detachAudioConfigEvent();
            } catch (err) {
                // Logging out the erorr because Speech SDK would fail silently.
                console.error(err);
                throw err;
            } finally{
                unprepare();
                this.recognizer.close();
            }
        }
    }
}
const $f92276aae71962b2$var$$87729c1c3277125d$export$7c06391dbd8298b0 = (options, data)=>{
    return {
        speechRecognition: new $f92276aae71962b2$var$$87729c1c3277125d$export$7a5e8c1807e6b8ee(options, data),
        SpeechGrammarList: $f92276aae71962b2$var$$c213b3979e1323e8$export$2e2bcd8739ae039
    };
};
var $f92276aae71962b2$var$$87729c1c3277125d$export$2e2bcd8739ae039 = $f92276aae71962b2$var$$87729c1c3277125d$export$7c06391dbd8298b0;
/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */ class $f92276aae71962b2$var$$fd1e2557ea351c52$var$SpeechSynthesisUtterance extends EventTarget {
    constructor(text){
        super(), this._lang = undefined, this._pitch = 1, this._rate = 1, this._voice = undefined, this._volume = 1;
        this.text = text;
    }
    get lang() {
        return this._lang;
    }
    set lang(value) {
        this._lang = value;
    }
    get pitch() {
        return this._pitch;
    }
    set pitch(value) {
        this._pitch = value;
    }
    get rate() {
        return this._rate;
    }
    set rate(value) {
        this._rate = value;
    }
    get voice() {
        return this._voice;
    }
    set voice(value) {
        this._voice = value;
    }
    get volume() {
        return this._volume;
    }
    set volume(value) {
        this._volume = value;
    }
    onstart() {}
    onend() {}
    onerror(error) {
        console.log(error);
    }
    onsynthesisstart() {}
    onsynthesiscompleted() {}
    onboundary(data) {
        console.log(data);
    }
    onviseme(data) {
        console.log(data);
    }
    onmark(data) {
        console.log(data);
    }
}
var $f92276aae71962b2$var$$fd1e2557ea351c52$export$2e2bcd8739ae039 = $f92276aae71962b2$var$$fd1e2557ea351c52$var$SpeechSynthesisUtterance;
class $f92276aae71962b2$var$$fd058ea71144ee3c$export$2e2bcd8739ae039 {
    constructor({ gender: gender, lang: lang, voiceURI: voiceURI }){
        this._default = false;
        this._localService = false;
        this._gender = gender;
        this._lang = lang;
        this._name = voiceURI;
        this._voiceURI = voiceURI;
    }
    get default() {
        return this._default;
    }
    get gender() {
        return this._gender;
    }
    get lang() {
        return this._lang;
    }
    get localService() {
        return this._localService;
    }
    get name() {
        return this._name;
    }
    get voiceURI() {
        return this._voiceURI;
    }
}
class $f92276aae71962b2$var$$0adf7fcdea541e7b$export$1268b12b5ca510be {
    constructor(options){
        this.speaking = false;
        this.speakerAudioDestination = new $1rrno.SpeakerAudioDestination();
        this.audioConfig = undefined;
        this.speechConfig = null;
        this.queue = [];
        this.canceled = false;
        this.synth = null;
        this.synthesizing = false;
        // Function that returns an empty array of available voices
        this.getVoices = ()=>{
            return [];
        };
        this.onvoiceschanged = ()=>{
            console.log('Voices changed');
        };
        // Extract parameters from options using the patchOptions function
        const { audioContext: audioContext, fetchCredentials: fetchCredentials, ponyfill: ponyfill = {
            // @ts-ignore
            AudioContext: window.AudioContext || window.webkitAudioContext
        }, speechSynthesisDeploymentId: speechSynthesisDeploymentId } = $f92276aae71962b2$var$$cec424af042710dc$export$2e2bcd8739ae039(options);
        // Check if the browser supports the Web Audio API, if not, return an empty object
        if (!audioContext && !ponyfill.AudioContext) console.warn('web-speech-cognitive-services: This browser does not support Web Audio and it will not work with Cognitive Services Speech Services.');
        else {
            this.audioConfig = $1rrno.AudioConfig.fromSpeakerOutput(this.speakerAudioDestination);
            // Init synthesizer
            this.initSpeechSynthesizer(fetchCredentials, speechSynthesisDeploymentId);
        }
    }
    mute() {
        this.speakerAudioDestination && this.speakerAudioDestination.mute();
    }
    unmute() {
        this.speakerAudioDestination && this.speakerAudioDestination.unmute();
    }
    getVolume() {
        // eslint-disable-next-line no-magic-numbers
        return this.speakerAudioDestination ? this.speakerAudioDestination.volume : -1;
    }
    setVolume(value) {
        this.speakerAudioDestination && (this.speakerAudioDestination.volume = value);
    }
    // Asynchronous function that initializes the speech synthesizer class
    async initSpeechSynthesizer(fetchCredentials, speechSynthesisDeploymentId) {
        const { speechSynthesisHostname: speechSynthesisHostname, subscriptionKey: subscriptionKey, authorizationToken: authorizationToken, region: region } = await fetchCredentials();
        if (!authorizationToken && !subscriptionKey) throw new Error('no subscription data : authorizationToken or subscriptionKey needed');
        // Configure the synthesizer and audio
        if (speechSynthesisDeploymentId) {
            const hostname = speechSynthesisHostname || `${region}.customvoice.api.speech.microsoft.com`;
            const url = `https://${encodeURI(hostname)}/api/texttospeech/v2.0/endpoints/${encodeURIComponent(speechSynthesisDeploymentId)}`;
            this.speechConfig = $1rrno.SpeechConfig.fromEndpoint(new URL(url), subscriptionKey);
        } else if (speechSynthesisHostname) this.speechConfig = $1rrno.SpeechConfig.fromHost(speechSynthesisHostname, subscriptionKey);
        else this.speechConfig = authorizationToken ? $1rrno.SpeechConfig.fromAuthorizationToken(authorizationToken, region) : $1rrno.SpeechConfig.fromSubscription(subscriptionKey, region);
        this.synth = new $1rrno.SpeechSynthesizer(this.speechConfig, this.audioConfig);
        // Update available voices
        this.updateVoices();
    }
    // Function to recreate the synthesizer
    createSynthesizer(voice, stream) {
        if (stream) this.audioConfig = $1rrno.AudioConfig.fromStreamOutput(stream);
        else {
            this.speakerAudioDestination = new $1rrno.SpeakerAudioDestination();
            this.audioConfig = $1rrno.AudioConfig.fromSpeakerOutput(this.speakerAudioDestination);
        }
        if (this.speechConfig) {
            if (voice) {
                const tempSpeechConfig = this.speechConfig;
                tempSpeechConfig.speechSynthesisVoiceName = voice;
                this.synth = new $1rrno.SpeechSynthesizer(tempSpeechConfig, this.audioConfig);
            } else this.synth = new $1rrno.SpeechSynthesizer(this.speechConfig, this.audioConfig);
        }
    }
    // Cancel current synthesis
    cancel() {
        if (this.synthesizing) try {
            // @ts-ignore
            this.synth && !this.synth.privDisposed && this.synth.close();
            this.queue = [];
        } catch (e) {
            console.warn(e);
        }
        else if (this.speaking) try {
            this.speakerAudioDestination.pause();
            this.speakerAudioDestination.onAudioEnd(this.speakerAudioDestination);
            this.speakerAudioDestination.close();
        } catch (e) {
            console.warn(e);
        }
        this.queue = [];
        this.canceled = true;
    }
    // Pause current synthesis
    pause() {
        if (this.speakerAudioDestination) this.speakerAudioDestination.pause();
    }
    // Resume current synthesis
    resume() {
        if (this.speakerAudioDestination && !this.canceled) this.speakerAudioDestination.resume();
    }
    /**
   * Add events listeners to the events received by the synthesizer if callbakcs are given in the utterance
   * @param {SpeechSynthesisUtterance} utterance
   */ linkEventsCallbacks(utterance) {
        if (this.synth) {
            // Events callbacks
            this.synth.synthesisStarted = ()=>{
                utterance.onsynthesisstart && utterance.onsynthesisstart();
                this.synthesizing = true;
            };
            this.synth.synthesisCompleted = ()=>{
                utterance.onsynthesiscompleted && utterance.onsynthesiscompleted();
                this.synthesizing = false;
            };
            this.synth.wordBoundary = (synth, e)=>{
                !synth && console.warn('No synthesizer');
                const data = {
                    boundaryType: e.boundaryType,
                    name: e.text,
                    elapsedTime: e.audioOffset,
                    duration: e.duration
                };
                utterance.onboundary && utterance.onboundary(data);
            };
            this.synth.visemeReceived = (synth, e)=>{
                !synth && console.warn('No synthesizer');
                const data = {
                    boundaryType: 'Viseme',
                    name: `${e.visemeId}`,
                    elapsedTime: e.audioOffset,
                    duration: 0
                };
                utterance.onboundary && utterance.onboundary(data);
                utterance.onviseme && utterance.onviseme(data);
            };
            this.synth.bookmarkReached = (synth, e)=>{
                !synth && console.warn('No synthesizer');
                const data = {
                    boundaryType: 'Mark',
                    name: e.text,
                    elapsedTime: e.audioOffset,
                    duration: 0
                };
                utterance.onmark && utterance.onmark(data);
            };
        }
    }
    /**
   * Launch synthesis and play sound with the speech synthesizer
   * @param {SpeechSynthesisUtterance} utterance 
   */ speak(utterance, stream) {
        // Test utterance
        if (!(utterance instanceof $f92276aae71962b2$var$$fd1e2557ea351c52$export$2e2bcd8739ae039)) throw new Error('invalid utterance');
        // Add the utterance to the queue
        this.queue.push(utterance);
        // Function to process the queued utterances
        const processQueue = ()=>{
            if (this.queue.length && !this.speaking) {
                const currentUtterance = this.queue.shift(); // Get the next utterance from the queue
                if (currentUtterance) {
                    const isSSML = /<speak[\s\S]*?>/iu.test(currentUtterance.text);
                    if (currentUtterance.voice && (currentUtterance.voice.voiceURI || currentUtterance.voice._name)) this.createSynthesizer(currentUtterance.voice.voiceURI || currentUtterance.voice._name, stream);
                    else this.createSynthesizer(undefined, stream);
                    // Set volume / mute status if present in the utterance parameters
                    currentUtterance.volume && (this.speakerAudioDestination.volume = currentUtterance.volume);
                    // SpeakerAudioDestination events callbacks
                    this.speakerAudioDestination.onAudioStart = ()=>{
                        this.speaking = true;
                        currentUtterance.onstart && currentUtterance.onstart();
                    };
                    this.speakerAudioDestination.onAudioEnd = ()=>{
                        this.speaking = false;
                        currentUtterance.onend && currentUtterance.onend();
                        processQueue(); // Process the next queued utterance after the current one has finished
                    };
                    this.linkEventsCallbacks(currentUtterance);
                    return isSSML ? new Promise((reject)=>{
                        this.synth && this.synth.speakSsmlAsync(currentUtterance.text, (result)=>{
                            if (result) this.synth && this.synth.close();
                            else reject(new Error('No synthesis result.'));
                        }, (error)=>{
                            reject(new Error(`Synthesis failed : ${error}`));
                        });
                    }) : new Promise((reject)=>{
                        this.synth && this.synth.speakTextAsync(currentUtterance.text, (result)=>{
                            if (result) this.synth && this.synth.close();
                            else reject(new Error('No synthesis result.'));
                        }, (error)=>{
                            reject(new Error(`Synthesis failed : ${error}`));
                        });
                    });
                }
            }
        };
        processQueue(); // Start processing the queue
        this.canceled = false; // Reset canceled state after processing the queue
    }
    /**
   * Launch synthesis without sound being played and call callback function with an ArrayBuffer after synthesis finished, containing the sound data
   * @param {SpeechSynthesisUtterance} utterance 
   * @param {Function} callback 
   */ synthesizeAndGetArrayData(utterance, callback) {
        // Test utterance
        if (!(utterance instanceof $f92276aae71962b2$var$$fd1e2557ea351c52$export$2e2bcd8739ae039)) throw new Error('invalid utterance');
        const isSSML = /<speak[\s\S]*?>/iu.test(utterance.text);
        if (this.speechConfig) {
            if (utterance.voice && (utterance.voice.voiceURI || utterance.voice._name)) {
                const tempSpeechConfig = this.speechConfig;
                tempSpeechConfig.speechSynthesisVoiceName = utterance.voice.voiceURI || utterance.voice._name;
                // @ts-ignore
                this.synth = new $1rrno.SpeechSynthesizer(tempSpeechConfig, null);
            } else this.synth = new $1rrno.SpeechSynthesizer(this.speechConfig, null);
        }
        this.linkEventsCallbacks(utterance);
        try {
            isSSML ? this.synth && this.synth.speakSsmlAsync(utterance.text, (result)=>{
                if (result && result.audioData) {
                    callback(result.audioData);
                    this.synth && this.synth.close();
                } else callback(null);
            }, (error)=>{
                console.error(error);
                callback(null);
            }) : this.synth && this.synth.speakTextAsync(utterance.text, (result)=>{
                if (result && result.audioData) {
                    callback(result.audioData);
                    this.synth && this.synth.close();
                } else callback(null);
            }, (error)=>{
                console.error(error);
                callback(null);
            });
        } catch (error) {
            console.error(error);
        }
    }
    // Asynchronous function that updates available voices
    async updateVoices() {
        const voicesResult = this.synth ? await this.synth.getVoicesAsync() : null;
        const voices = voicesResult?.voices;
        if (Array.isArray(voices)) {
            const formattedVoices = voices.map((voice)=>new $f92276aae71962b2$var$$fd058ea71144ee3c$export$2e2bcd8739ae039({
                    // eslint-disable-next-line no-magic-numbers
                    gender: voice.gender === 1 ? 'Female' : voice.gender === 2 ? 'Male' : 'Undefined',
                    lang: voice.locale,
                    voiceURI: voice.name
                }));
            this.getVoices = ()=>formattedVoices;
        } else console.warn("Failed to retrieve voices. 'voices' is not an array.");
        // Call 'onvoiceschanged' callback to notify the voices update
        this.onvoiceschanged();
    }
}
const $f92276aae71962b2$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c = (options)=>{
    return {
        speechSynthesis: new $f92276aae71962b2$var$$0adf7fcdea541e7b$export$1268b12b5ca510be(options),
        SpeechSynthesisUtterance: $f92276aae71962b2$var$$fd1e2557ea351c52$export$2e2bcd8739ae039
    };
};
var $f92276aae71962b2$var$$0adf7fcdea541e7b$export$2e2bcd8739ae039 = $f92276aae71962b2$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c;
const $f92276aae71962b2$var$$3e54160c801e3614$var$TOKEN_URL_TEMPLATE = 'https://{region}.api.cognitive.microsoft.com/sts/v1.0/issueToken';
async function $f92276aae71962b2$var$$3e54160c801e3614$export$2e2bcd8739ae039({ region: region, subscriptionKey: subscriptionKey }) {
    if (!region || !subscriptionKey) throw new Error('Region AND subscription must be provided');
    else {
        const res = await fetch($f92276aae71962b2$var$$3e54160c801e3614$var$TOKEN_URL_TEMPLATE.replace(/\{region\}/u, region), {
            headers: {
                'Ocp-Apim-Subscription-Key': subscriptionKey
            },
            method: 'POST'
        });
        if (!res.ok) throw new Error(`Failed to fetch authorization token, server returned ${res.status}`);
        return res.text();
    }
}
function $f92276aae71962b2$var$$882b6d93070905b3$export$2e2bcd8739ae039(options, recognitionData) {
    return {
        ...$f92276aae71962b2$var$$87729c1c3277125d$export$7c06391dbd8298b0(options, recognitionData),
        ...$f92276aae71962b2$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c(options)
    };
}

});
parcelRegister("1rrno", function(module, exports) {
"use strict";
var $10cd8c7278e28b4c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $10cd8c7278e28b4c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $10cd8c7278e28b4c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hgjD5 = parcelRequire("hgjD5");
// Note: this instantiation ensures the above import isn't
// removed on compile. The import being absent causes an error on running
new $hgjD5.AgentConfig();

// Speech SDK API
$10cd8c7278e28b4c$var$__exportStar((parcelRequire("gttSn")), module.exports);

});
parcelRegister("hgjD5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $c913284cd7b42aa7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c913284cd7b42aa7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c913284cd7b42aa7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguagesOpenRangeOptionName = module.exports.ForceDictationPropertyName = module.exports.ServicePropertiesPropertyName = module.exports.CancellationErrorCodePropertyName = module.exports.OutputFormatPropertyName = module.exports.SpeechSynthesisAdapter = module.exports.AvatarSynthesisAdapter = void 0;

// Make sure not to export internal modules.
//
$c913284cd7b42aa7$var$__exportStar((parcelRequire("6HIA2")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("4t6tB")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("8YUMa")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("8zICa")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("cZtKQ")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("5bgRq")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("lDTeU")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("1t7Y3")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("3ppF1")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("kigto")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("iUPWQ")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("gXTdh")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("6ipmx")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("9enGg")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("7nNfh")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("2Fj9D")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("3up4e")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("gNbeL")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("1epFV")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("7sc1G")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("iZPBw")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("24xBg")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("5Xm3f")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("buBkw")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("6Rigu")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("7w59Q")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("19jLl")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("8QE2v")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("cg0MH")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("jsqMv")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("lkId6")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("hRi9W")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("f9t0q")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("l5ThZ")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("51cqC")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("a39gX")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("6nl23")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("dsBs3")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("gd3Vj")), module.exports);

var $eJTfA = parcelRequire("eJTfA");
Object.defineProperty(module.exports, "AvatarSynthesisAdapter", {
    enumerable: true,
    get: function() {
        return $eJTfA.AvatarSynthesisAdapter;
    }
});

var $5ilMI = parcelRequire("5ilMI");
Object.defineProperty(module.exports, "SpeechSynthesisAdapter", {
    enumerable: true,
    get: function() {
        return $5ilMI.SpeechSynthesisAdapter;
    }
});

$c913284cd7b42aa7$var$__exportStar((parcelRequire("bOCy4")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("gBlwq")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("bgoz0")), module.exports);

$c913284cd7b42aa7$var$__exportStar((parcelRequire("6xqgT")), module.exports);
module.exports.OutputFormatPropertyName = "OutputFormat";
module.exports.CancellationErrorCodePropertyName = "CancellationErrorCode";
module.exports.ServicePropertiesPropertyName = "ServiceProperties";
module.exports.ForceDictationPropertyName = "ForceDictation";
module.exports.AutoDetectSourceLanguagesOpenRangeOptionName = "UND";

});
parcelRegister("6HIA2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CognitiveSubscriptionKeyAuthentication = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $40Pvg = parcelRequire("40Pvg");

var $8YUMa = parcelRequire("8YUMa");
/**
 * @class
 */ class $01427924f138524d$var$CognitiveSubscriptionKeyAuthentication {
    /**
     * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
     * @constructor
     * @param {string} subscriptionKey - The subscription key
     */ constructor(subscriptionKey){
        if (!subscriptionKey) throw new $5OUhN.ArgumentNullError("subscriptionKey");
        this.privAuthInfo = new $8YUMa.AuthInfo($40Pvg.HeaderNames.AuthKey, subscriptionKey);
    }
    /**
     * Fetches the subscription key.
     * @member
     * @function
     * @public
     * @param {string} authFetchEventId - The id to fetch.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetch(authFetchEventId) {
        return Promise.resolve(this.privAuthInfo);
    }
    /**
     * Fetches the subscription key.
     * @member
     * @function
     * @public
     * @param {string} authFetchEventId - The id to fetch.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetchOnExpiry(authFetchEventId) {
        return Promise.resolve(this.privAuthInfo);
    }
}
module.exports.CognitiveSubscriptionKeyAuthentication = $01427924f138524d$var$CognitiveSubscriptionKeyAuthentication;

});
parcelRegister("5OUhN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $43cd487d89950108$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $43cd487d89950108$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $43cd487d89950108$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationStatus = void 0;

$43cd487d89950108$var$__exportStar((parcelRequire("1AwHR")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("ls19Y")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("k419T")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("jyCxe")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("iYjv4")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("32dAT")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("3NF6I")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("5vbCN")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("9SKhX")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("8lWt4")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("jODUz")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("9klG9")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("8UNKy")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("95vqE")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("8KXOL")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("lwbJi")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("i8sQl")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("9BIeo")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("clt1b")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("9sJtU")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("jHUvS")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("dVTTx")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("ciGbY")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("63lFD")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("hkGW0")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("csECP")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("brK4I")), module.exports);

var $iv8Pq = parcelRequire("iv8Pq");
Object.defineProperty(module.exports, "TranslationStatus", {
    enumerable: true,
    get: function() {
        return $iv8Pq.TranslationStatus;
    }
});

$43cd487d89950108$var$__exportStar((parcelRequire("ds9gc")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("cHP06")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("8WCaJ")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("gihMu")), module.exports);

$43cd487d89950108$var$__exportStar((parcelRequire("lWqSg")), module.exports);

});
parcelRegister("1AwHR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioStreamNodeErrorEvent = module.exports.AudioStreamNodeDetachedEvent = module.exports.AudioStreamNodeAttachedEvent = module.exports.AudioStreamNodeAttachingEvent = module.exports.AudioStreamNodeEvent = module.exports.AudioSourceErrorEvent = module.exports.AudioSourceOffEvent = module.exports.AudioSourceReadyEvent = module.exports.AudioSourceInitializingEvent = module.exports.AudioSourceEvent = void 0;

var $dVTTx = parcelRequire("dVTTx");
class $12828613243373fc$var$AudioSourceEvent extends $dVTTx.PlatformEvent {
    constructor(eventName, audioSourceId, eventType = $dVTTx.EventType.Info){
        super(eventName, eventType);
        this.privAudioSourceId = audioSourceId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
}
module.exports.AudioSourceEvent = $12828613243373fc$var$AudioSourceEvent;
class $12828613243373fc$var$AudioSourceInitializingEvent extends $12828613243373fc$var$AudioSourceEvent {
    constructor(audioSourceId){
        super("AudioSourceInitializingEvent", audioSourceId);
    }
}
module.exports.AudioSourceInitializingEvent = $12828613243373fc$var$AudioSourceInitializingEvent;
class $12828613243373fc$var$AudioSourceReadyEvent extends $12828613243373fc$var$AudioSourceEvent {
    constructor(audioSourceId){
        super("AudioSourceReadyEvent", audioSourceId);
    }
}
module.exports.AudioSourceReadyEvent = $12828613243373fc$var$AudioSourceReadyEvent;
class $12828613243373fc$var$AudioSourceOffEvent extends $12828613243373fc$var$AudioSourceEvent {
    constructor(audioSourceId){
        super("AudioSourceOffEvent", audioSourceId);
    }
}
module.exports.AudioSourceOffEvent = $12828613243373fc$var$AudioSourceOffEvent;
class $12828613243373fc$var$AudioSourceErrorEvent extends $12828613243373fc$var$AudioSourceEvent {
    constructor(audioSourceId, error){
        super("AudioSourceErrorEvent", audioSourceId, $dVTTx.EventType.Error);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}
module.exports.AudioSourceErrorEvent = $12828613243373fc$var$AudioSourceErrorEvent;
class $12828613243373fc$var$AudioStreamNodeEvent extends $12828613243373fc$var$AudioSourceEvent {
    constructor(eventName, audioSourceId, audioNodeId){
        super(eventName, audioSourceId);
        this.privAudioNodeId = audioNodeId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
module.exports.AudioStreamNodeEvent = $12828613243373fc$var$AudioStreamNodeEvent;
class $12828613243373fc$var$AudioStreamNodeAttachingEvent extends $12828613243373fc$var$AudioStreamNodeEvent {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachingEvent", audioSourceId, audioNodeId);
    }
}
module.exports.AudioStreamNodeAttachingEvent = $12828613243373fc$var$AudioStreamNodeAttachingEvent;
class $12828613243373fc$var$AudioStreamNodeAttachedEvent extends $12828613243373fc$var$AudioStreamNodeEvent {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachedEvent", audioSourceId, audioNodeId);
    }
}
module.exports.AudioStreamNodeAttachedEvent = $12828613243373fc$var$AudioStreamNodeAttachedEvent;
class $12828613243373fc$var$AudioStreamNodeDetachedEvent extends $12828613243373fc$var$AudioStreamNodeEvent {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeDetachedEvent", audioSourceId, audioNodeId);
    }
}
module.exports.AudioStreamNodeDetachedEvent = $12828613243373fc$var$AudioStreamNodeDetachedEvent;
class $12828613243373fc$var$AudioStreamNodeErrorEvent extends $12828613243373fc$var$AudioStreamNodeEvent {
    constructor(audioSourceId, audioNodeId, error){
        super("AudioStreamNodeErrorEvent", audioSourceId, audioNodeId);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}
module.exports.AudioStreamNodeErrorEvent = $12828613243373fc$var$AudioStreamNodeErrorEvent;

});
parcelRegister("dVTTx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlatformEvent = module.exports.EventType = void 0;

var $8lWt4 = parcelRequire("8lWt4");
var $a24bf4c6b6d00914$var$EventType;
(function(EventType) {
    EventType[EventType["Debug"] = 0] = "Debug";
    EventType[EventType["Info"] = 1] = "Info";
    EventType[EventType["Warning"] = 2] = "Warning";
    EventType[EventType["Error"] = 3] = "Error";
    EventType[EventType["None"] = 4] = "None";
})($a24bf4c6b6d00914$var$EventType = module.exports.EventType || (module.exports.EventType = {}));
class $a24bf4c6b6d00914$var$PlatformEvent {
    constructor(eventName, eventType){
        this.privName = eventName;
        this.privEventId = (0, $8lWt4.createNoDashGuid)();
        this.privEventTime = new Date().toISOString();
        this.privEventType = eventType;
        this.privMetadata = {};
    }
    get name() {
        return this.privName;
    }
    get eventId() {
        return this.privEventId;
    }
    get eventTime() {
        return this.privEventTime;
    }
    get eventType() {
        return this.privEventType;
    }
    get metadata() {
        return this.privMetadata;
    }
}
module.exports.PlatformEvent = $a24bf4c6b6d00914$var$PlatformEvent;

});
parcelRegister("8lWt4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNoDashGuid = module.exports.createGuid = void 0;

var $9dZ9o = parcelRequire("9dZ9o");
const $614da360328fa112$var$createGuid = ()=>(0, $9dZ9o.v4)();
module.exports.createGuid = $614da360328fa112$var$createGuid;
const $614da360328fa112$var$createNoDashGuid = ()=>$614da360328fa112$var$createGuid().replace(new RegExp("-", "g"), "").toUpperCase();
module.exports.createNoDashGuid = $614da360328fa112$var$createNoDashGuid;

});
parcelRegister("9dZ9o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "NIL", {
    enumerable: true,
    get: function get() {
        return $6b74c328d49f1af9$var$_nil.default;
    }
});
Object.defineProperty(module.exports, "parse", {
    enumerable: true,
    get: function get() {
        return $6b74c328d49f1af9$var$_parse.default;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function get() {
        return $6b74c328d49f1af9$var$_stringify.default;
    }
});
Object.defineProperty(module.exports, "v1", {
    enumerable: true,
    get: function get() {
        return $6b74c328d49f1af9$var$_v.default;
    }
});
Object.defineProperty(module.exports, "v3", {
    enumerable: true,
    get: function get() {
        return $6b74c328d49f1af9$var$_v2.default;
    }
});
Object.defineProperty(module.exports, "v4", {
    enumerable: true,
    get: function get() {
        return $6b74c328d49f1af9$var$_v3.default;
    }
});
Object.defineProperty(module.exports, "v5", {
    enumerable: true,
    get: function get() {
        return $6b74c328d49f1af9$var$_v4.default;
    }
});
Object.defineProperty(module.exports, "validate", {
    enumerable: true,
    get: function get() {
        return $6b74c328d49f1af9$var$_validate.default;
    }
});
Object.defineProperty(module.exports, "version", {
    enumerable: true,
    get: function get() {
        return $6b74c328d49f1af9$var$_version.default;
    }
});

var $6b74c328d49f1af9$var$_v = $6b74c328d49f1af9$var$_interopRequireDefault((parcelRequire("j1RPF")));

var $6b74c328d49f1af9$var$_v2 = $6b74c328d49f1af9$var$_interopRequireDefault((parcelRequire("irGUa")));

var $6b74c328d49f1af9$var$_v3 = $6b74c328d49f1af9$var$_interopRequireDefault((parcelRequire("bbtu4")));

var $6b74c328d49f1af9$var$_v4 = $6b74c328d49f1af9$var$_interopRequireDefault((parcelRequire("3dMsp")));

var $6b74c328d49f1af9$var$_nil = $6b74c328d49f1af9$var$_interopRequireDefault((parcelRequire("htTDh")));

var $6b74c328d49f1af9$var$_version = $6b74c328d49f1af9$var$_interopRequireDefault((parcelRequire("cbVYp")));

var $6b74c328d49f1af9$var$_validate = $6b74c328d49f1af9$var$_interopRequireDefault((parcelRequire("eniqw")));

var $6b74c328d49f1af9$var$_stringify = $6b74c328d49f1af9$var$_interopRequireDefault((parcelRequire("cEsLR")));

var $6b74c328d49f1af9$var$_parse = $6b74c328d49f1af9$var$_interopRequireDefault((parcelRequire("wuaTg")));
function $6b74c328d49f1af9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("j1RPF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dda7de4a6b1df7ec$var$_rng = $dda7de4a6b1df7ec$var$_interopRequireDefault((parcelRequire("4bun6")));

var $cEsLR = parcelRequire("cEsLR");
function $dda7de4a6b1df7ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let $dda7de4a6b1df7ec$var$_nodeId;
let $dda7de4a6b1df7ec$var$_clockseq; // Previous uuid creation time
let $dda7de4a6b1df7ec$var$_lastMSecs = 0;
let $dda7de4a6b1df7ec$var$_lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
function $dda7de4a6b1df7ec$var$v1(options, buf, offset) {
    let i = buf && offset || 0;
    const b = buf || new Array(16);
    options = options || {};
    let node = options.node || $dda7de4a6b1df7ec$var$_nodeId;
    let clockseq = options.clockseq !== undefined ? options.clockseq : $dda7de4a6b1df7ec$var$_clockseq; // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        const seedBytes = options.random || (options.rng || $dda7de4a6b1df7ec$var$_rng.default)();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $dda7de4a6b1df7ec$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $dda7de4a6b1df7ec$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    let nsecs = options.nsecs !== undefined ? options.nsecs : $dda7de4a6b1df7ec$var$_lastNSecs + 1; // Time since last uuid creation (in msecs)
    const dt = msecs - $dda7de4a6b1df7ec$var$_lastMSecs + (nsecs - $dda7de4a6b1df7ec$var$_lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
     // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $dda7de4a6b1df7ec$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
     // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $dda7de4a6b1df7ec$var$_lastMSecs = msecs;
    $dda7de4a6b1df7ec$var$_lastNSecs = nsecs;
    $dda7de4a6b1df7ec$var$_clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000; // `time_low`
    const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff; // `time_mid`
    const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff; // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
    b[i++] = clockseq & 0xff; // `node`
    for(let n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf || (0, $cEsLR.unsafeStringify)(b);
}
var $dda7de4a6b1df7ec$var$_default = $dda7de4a6b1df7ec$var$v1;
module.exports.default = $dda7de4a6b1df7ec$var$_default;

});
parcelRegister("4bun6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30bfbfae5d7ea38c$var$rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $30bfbfae5d7ea38c$var$getRandomValues;
const $30bfbfae5d7ea38c$var$rnds8 = new Uint8Array(16);
function $30bfbfae5d7ea38c$var$rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$30bfbfae5d7ea38c$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $30bfbfae5d7ea38c$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$30bfbfae5d7ea38c$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $30bfbfae5d7ea38c$var$getRandomValues($30bfbfae5d7ea38c$var$rnds8);
}

});

parcelRegister("cEsLR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unsafeStringify = $935f89c6b9e2659c$var$unsafeStringify;

var $935f89c6b9e2659c$var$_validate = $935f89c6b9e2659c$var$_interopRequireDefault((parcelRequire("eniqw")));
function $935f89c6b9e2659c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $935f89c6b9e2659c$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$935f89c6b9e2659c$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $935f89c6b9e2659c$var$unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $935f89c6b9e2659c$var$byteToHex[arr[offset + 0]] + $935f89c6b9e2659c$var$byteToHex[arr[offset + 1]] + $935f89c6b9e2659c$var$byteToHex[arr[offset + 2]] + $935f89c6b9e2659c$var$byteToHex[arr[offset + 3]] + '-' + $935f89c6b9e2659c$var$byteToHex[arr[offset + 4]] + $935f89c6b9e2659c$var$byteToHex[arr[offset + 5]] + '-' + $935f89c6b9e2659c$var$byteToHex[arr[offset + 6]] + $935f89c6b9e2659c$var$byteToHex[arr[offset + 7]] + '-' + $935f89c6b9e2659c$var$byteToHex[arr[offset + 8]] + $935f89c6b9e2659c$var$byteToHex[arr[offset + 9]] + '-' + $935f89c6b9e2659c$var$byteToHex[arr[offset + 10]] + $935f89c6b9e2659c$var$byteToHex[arr[offset + 11]] + $935f89c6b9e2659c$var$byteToHex[arr[offset + 12]] + $935f89c6b9e2659c$var$byteToHex[arr[offset + 13]] + $935f89c6b9e2659c$var$byteToHex[arr[offset + 14]] + $935f89c6b9e2659c$var$byteToHex[arr[offset + 15]];
}
function $935f89c6b9e2659c$var$stringify(arr, offset = 0) {
    const uuid = $935f89c6b9e2659c$var$unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $935f89c6b9e2659c$var$_validate.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $935f89c6b9e2659c$var$_default = $935f89c6b9e2659c$var$stringify;
module.exports.default = $935f89c6b9e2659c$var$_default;

});
parcelRegister("eniqw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a77181dcc9aa831f$var$_regex = $a77181dcc9aa831f$var$_interopRequireDefault((parcelRequire("6nIX9")));
function $a77181dcc9aa831f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a77181dcc9aa831f$var$validate(uuid) {
    return typeof uuid === 'string' && $a77181dcc9aa831f$var$_regex.default.test(uuid);
}
var $a77181dcc9aa831f$var$_default = $a77181dcc9aa831f$var$validate;
module.exports.default = $a77181dcc9aa831f$var$_default;

});
parcelRegister("6nIX9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $4a57c2cbe807e3ea$var$_default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
module.exports.default = $4a57c2cbe807e3ea$var$_default;

});




parcelRegister("irGUa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6dc07a87411b447$var$_v = $d6dc07a87411b447$var$_interopRequireDefault((parcelRequire("6RjLh")));

var $d6dc07a87411b447$var$_md = $d6dc07a87411b447$var$_interopRequireDefault((parcelRequire("cymq9")));
function $d6dc07a87411b447$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d6dc07a87411b447$var$v3 = (0, $d6dc07a87411b447$var$_v.default)('v3', 0x30, $d6dc07a87411b447$var$_md.default);
var $d6dc07a87411b447$var$_default = $d6dc07a87411b447$var$v3;
module.exports.default = $d6dc07a87411b447$var$_default;

});
parcelRegister("6RjLh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.URL = module.exports.DNS = void 0;
module.exports.default = $4fe7058d8991469f$var$v35;

var $cEsLR = parcelRequire("cEsLR");

var $4fe7058d8991469f$var$_parse = $4fe7058d8991469f$var$_interopRequireDefault((parcelRequire("wuaTg")));
function $4fe7058d8991469f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4fe7058d8991469f$var$stringToBytes(str) {
    str = unescape(encodeURIComponent(str)); // UTF8 escape
    const bytes = [];
    for(let i = 0; i < str.length; ++i)bytes.push(str.charCodeAt(i));
    return bytes;
}
const $4fe7058d8991469f$var$DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
module.exports.DNS = $4fe7058d8991469f$var$DNS;
const $4fe7058d8991469f$var$URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
module.exports.URL = $4fe7058d8991469f$var$URL;
function $4fe7058d8991469f$var$v35(name, version, hashfunc) {
    function generateUUID(value, namespace, buf, offset) {
        var _namespace;
        if (typeof value === 'string') value = $4fe7058d8991469f$var$stringToBytes(value);
        if (typeof namespace === 'string') namespace = (0, $4fe7058d8991469f$var$_parse.default)(namespace);
        if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
         // Compute hash of namespace and value, Per 4.3
        // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
        // hashfunc([...namespace, ... value])`
        let bytes = new Uint8Array(16 + value.length);
        bytes.set(namespace);
        bytes.set(value, namespace.length);
        bytes = hashfunc(bytes);
        bytes[6] = bytes[6] & 0x0f | version;
        bytes[8] = bytes[8] & 0x3f | 0x80;
        if (buf) {
            offset = offset || 0;
            for(let i = 0; i < 16; ++i)buf[offset + i] = bytes[i];
            return buf;
        }
        return (0, $cEsLR.unsafeStringify)(bytes);
    } // Function#name is not settable on some platforms (#270)
    try {
        generateUUID.name = name; // eslint-disable-next-line no-empty
    } catch (err) {} // For CommonJS default export support
    generateUUID.DNS = $4fe7058d8991469f$var$DNS;
    generateUUID.URL = $4fe7058d8991469f$var$URL;
    return generateUUID;
}

});
parcelRegister("wuaTg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $061a6554a716718e$var$_validate = $061a6554a716718e$var$_interopRequireDefault((parcelRequire("eniqw")));
function $061a6554a716718e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $061a6554a716718e$var$parse(uuid) {
    if (!(0, $061a6554a716718e$var$_validate.default)(uuid)) throw TypeError('Invalid UUID');
    let v;
    const arr = new Uint8Array(16); // Parse ########-....-....-....-............
    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
    arr[1] = v >>> 16 & 0xff;
    arr[2] = v >>> 8 & 0xff;
    arr[3] = v & 0xff; // Parse ........-####-....-....-............
    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
    arr[5] = v & 0xff; // Parse ........-....-####-....-............
    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
    arr[7] = v & 0xff; // Parse ........-....-....-####-............
    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
    arr[9] = v & 0xff; // Parse ........-....-....-....-############
    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
    arr[11] = v / 0x100000000 & 0xff;
    arr[12] = v >>> 24 & 0xff;
    arr[13] = v >>> 16 & 0xff;
    arr[14] = v >>> 8 & 0xff;
    arr[15] = v & 0xff;
    return arr;
}
var $061a6554a716718e$var$_default = $061a6554a716718e$var$parse;
module.exports.default = $061a6554a716718e$var$_default;

});


parcelRegister("cymq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ function $923a0d50f1451f9a$var$md5(bytes) {
    if (typeof bytes === 'string') {
        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = new Uint8Array(msg.length);
        for(let i = 0; i < msg.length; ++i)bytes[i] = msg.charCodeAt(i);
    }
    return $923a0d50f1451f9a$var$md5ToHexEncodedArray($923a0d50f1451f9a$var$wordsToMd5($923a0d50f1451f9a$var$bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */ function $923a0d50f1451f9a$var$md5ToHexEncodedArray(input) {
    const output = [];
    const length32 = input.length * 32;
    const hexTab = '0123456789abcdef';
    for(let i = 0; i < length32; i += 8){
        const x = input[i >> 5] >>> i % 32 & 0xff;
        const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
        output.push(hex);
    }
    return output;
}
/**
 * Calculate output length with padding and bit length
 */ function $923a0d50f1451f9a$var$getOutputLength(inputLength8) {
    return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */ function $923a0d50f1451f9a$var$wordsToMd5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[$923a0d50f1451f9a$var$getOutputLength(len) - 1] = len;
    let a = 1732584193;
    let b = -271733879;
    let c = -1732584194;
    let d = 271733878;
    for(let i = 0; i < x.length; i += 16){
        const olda = a;
        const oldb = b;
        const oldc = c;
        const oldd = d;
        a = $923a0d50f1451f9a$var$md5ff(a, b, c, d, x[i], 7, -680876936);
        d = $923a0d50f1451f9a$var$md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = $923a0d50f1451f9a$var$md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = $923a0d50f1451f9a$var$md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = $923a0d50f1451f9a$var$md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = $923a0d50f1451f9a$var$md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = $923a0d50f1451f9a$var$md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = $923a0d50f1451f9a$var$md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = $923a0d50f1451f9a$var$md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = $923a0d50f1451f9a$var$md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = $923a0d50f1451f9a$var$md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = $923a0d50f1451f9a$var$md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = $923a0d50f1451f9a$var$md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = $923a0d50f1451f9a$var$md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = $923a0d50f1451f9a$var$md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = $923a0d50f1451f9a$var$md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = $923a0d50f1451f9a$var$md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = $923a0d50f1451f9a$var$md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = $923a0d50f1451f9a$var$md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = $923a0d50f1451f9a$var$md5gg(b, c, d, a, x[i], 20, -373897302);
        a = $923a0d50f1451f9a$var$md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = $923a0d50f1451f9a$var$md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = $923a0d50f1451f9a$var$md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = $923a0d50f1451f9a$var$md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = $923a0d50f1451f9a$var$md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = $923a0d50f1451f9a$var$md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = $923a0d50f1451f9a$var$md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = $923a0d50f1451f9a$var$md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = $923a0d50f1451f9a$var$md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = $923a0d50f1451f9a$var$md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = $923a0d50f1451f9a$var$md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = $923a0d50f1451f9a$var$md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = $923a0d50f1451f9a$var$md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = $923a0d50f1451f9a$var$md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = $923a0d50f1451f9a$var$md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = $923a0d50f1451f9a$var$md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = $923a0d50f1451f9a$var$md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = $923a0d50f1451f9a$var$md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = $923a0d50f1451f9a$var$md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = $923a0d50f1451f9a$var$md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = $923a0d50f1451f9a$var$md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = $923a0d50f1451f9a$var$md5hh(d, a, b, c, x[i], 11, -358537222);
        c = $923a0d50f1451f9a$var$md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = $923a0d50f1451f9a$var$md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = $923a0d50f1451f9a$var$md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = $923a0d50f1451f9a$var$md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = $923a0d50f1451f9a$var$md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = $923a0d50f1451f9a$var$md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = $923a0d50f1451f9a$var$md5ii(a, b, c, d, x[i], 6, -198630844);
        d = $923a0d50f1451f9a$var$md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = $923a0d50f1451f9a$var$md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = $923a0d50f1451f9a$var$md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = $923a0d50f1451f9a$var$md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = $923a0d50f1451f9a$var$md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = $923a0d50f1451f9a$var$md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = $923a0d50f1451f9a$var$md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = $923a0d50f1451f9a$var$md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = $923a0d50f1451f9a$var$md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = $923a0d50f1451f9a$var$md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = $923a0d50f1451f9a$var$md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = $923a0d50f1451f9a$var$md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = $923a0d50f1451f9a$var$md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = $923a0d50f1451f9a$var$md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = $923a0d50f1451f9a$var$md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = $923a0d50f1451f9a$var$safeAdd(a, olda);
        b = $923a0d50f1451f9a$var$safeAdd(b, oldb);
        c = $923a0d50f1451f9a$var$safeAdd(c, oldc);
        d = $923a0d50f1451f9a$var$safeAdd(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */ function $923a0d50f1451f9a$var$bytesToWords(input) {
    if (input.length === 0) return [];
    const length8 = input.length * 8;
    const output = new Uint32Array($923a0d50f1451f9a$var$getOutputLength(length8));
    for(let i = 0; i < length8; i += 8)output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
    return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function $923a0d50f1451f9a$var$safeAdd(x, y) {
    const lsw = (x & 0xffff) + (y & 0xffff);
    const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function $923a0d50f1451f9a$var$bitRotateLeft(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function $923a0d50f1451f9a$var$md5cmn(q, a, b, x, s, t) {
    return $923a0d50f1451f9a$var$safeAdd($923a0d50f1451f9a$var$bitRotateLeft($923a0d50f1451f9a$var$safeAdd($923a0d50f1451f9a$var$safeAdd(a, q), $923a0d50f1451f9a$var$safeAdd(x, t)), s), b);
}
function $923a0d50f1451f9a$var$md5ff(a, b, c, d, x, s, t) {
    return $923a0d50f1451f9a$var$md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function $923a0d50f1451f9a$var$md5gg(a, b, c, d, x, s, t) {
    return $923a0d50f1451f9a$var$md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function $923a0d50f1451f9a$var$md5hh(a, b, c, d, x, s, t) {
    return $923a0d50f1451f9a$var$md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function $923a0d50f1451f9a$var$md5ii(a, b, c, d, x, s, t) {
    return $923a0d50f1451f9a$var$md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
var $923a0d50f1451f9a$var$_default = $923a0d50f1451f9a$var$md5;
module.exports.default = $923a0d50f1451f9a$var$_default;

});


parcelRegister("bbtu4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $824797b8e9a2bc9b$var$_native = $824797b8e9a2bc9b$var$_interopRequireDefault((parcelRequire("9AVpx")));

var $824797b8e9a2bc9b$var$_rng = $824797b8e9a2bc9b$var$_interopRequireDefault((parcelRequire("4bun6")));

var $cEsLR = parcelRequire("cEsLR");
function $824797b8e9a2bc9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $824797b8e9a2bc9b$var$v4(options, buf, offset) {
    if ($824797b8e9a2bc9b$var$_native.default.randomUUID && !buf && !options) return $824797b8e9a2bc9b$var$_native.default.randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || $824797b8e9a2bc9b$var$_rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $cEsLR.unsafeStringify)(rnds);
}
var $824797b8e9a2bc9b$var$_default = $824797b8e9a2bc9b$var$v4;
module.exports.default = $824797b8e9a2bc9b$var$_default;

});
parcelRegister("9AVpx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $6fc4026ffb6471c9$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $6fc4026ffb6471c9$var$_default = {
    randomUUID: $6fc4026ffb6471c9$var$randomUUID
};
module.exports.default = $6fc4026ffb6471c9$var$_default;

});


parcelRegister("3dMsp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25882c9c106202a1$var$_v = $25882c9c106202a1$var$_interopRequireDefault((parcelRequire("6RjLh")));

var $25882c9c106202a1$var$_sha = $25882c9c106202a1$var$_interopRequireDefault((parcelRequire("4rZOO")));
function $25882c9c106202a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $25882c9c106202a1$var$v5 = (0, $25882c9c106202a1$var$_v.default)('v5', 0x50, $25882c9c106202a1$var$_sha.default);
var $25882c9c106202a1$var$_default = $25882c9c106202a1$var$v5;
module.exports.default = $25882c9c106202a1$var$_default;

});
parcelRegister("4rZOO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function $33d9a2e6fc191eb0$var$f(s, x, y, z) {
    switch(s){
        case 0:
            return x & y ^ ~x & z;
        case 1:
            return x ^ y ^ z;
        case 2:
            return x & y ^ x & z ^ y & z;
        case 3:
            return x ^ y ^ z;
    }
}
function $33d9a2e6fc191eb0$var$ROTL(x, n) {
    return x << n | x >>> 32 - n;
}
function $33d9a2e6fc191eb0$var$sha1(bytes) {
    const K = [
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xca62c1d6
    ];
    const H = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    if (typeof bytes === 'string') {
        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = [];
        for(let i = 0; i < msg.length; ++i)bytes.push(msg.charCodeAt(i));
    } else if (!Array.isArray(bytes)) // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
    bytes.push(0x80);
    const l = bytes.length / 4 + 2;
    const N = Math.ceil(l / 16);
    const M = new Array(N);
    for(let i = 0; i < N; ++i){
        const arr = new Uint32Array(16);
        for(let j = 0; j < 16; ++j)arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
        M[i] = arr;
    }
    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
    M[N - 1][14] = Math.floor(M[N - 1][14]);
    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
    for(let i = 0; i < N; ++i){
        const W = new Uint32Array(80);
        for(let t = 0; t < 16; ++t)W[t] = M[i][t];
        for(let t = 16; t < 80; ++t)W[t] = $33d9a2e6fc191eb0$var$ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
        let a = H[0];
        let b = H[1];
        let c = H[2];
        let d = H[3];
        let e = H[4];
        for(let t = 0; t < 80; ++t){
            const s = Math.floor(t / 20);
            const T = $33d9a2e6fc191eb0$var$ROTL(a, 5) + $33d9a2e6fc191eb0$var$f(s, b, c, d) + e + K[s] + W[t] >>> 0;
            e = d;
            d = c;
            c = $33d9a2e6fc191eb0$var$ROTL(b, 30) >>> 0;
            b = a;
            a = T;
        }
        H[0] = H[0] + a >>> 0;
        H[1] = H[1] + b >>> 0;
        H[2] = H[2] + c >>> 0;
        H[3] = H[3] + d >>> 0;
        H[4] = H[4] + e >>> 0;
    }
    return [
        H[0] >> 24 & 0xff,
        H[0] >> 16 & 0xff,
        H[0] >> 8 & 0xff,
        H[0] & 0xff,
        H[1] >> 24 & 0xff,
        H[1] >> 16 & 0xff,
        H[1] >> 8 & 0xff,
        H[1] & 0xff,
        H[2] >> 24 & 0xff,
        H[2] >> 16 & 0xff,
        H[2] >> 8 & 0xff,
        H[2] & 0xff,
        H[3] >> 24 & 0xff,
        H[3] >> 16 & 0xff,
        H[3] >> 8 & 0xff,
        H[3] & 0xff,
        H[4] >> 24 & 0xff,
        H[4] >> 16 & 0xff,
        H[4] >> 8 & 0xff,
        H[4] & 0xff
    ];
}
var $33d9a2e6fc191eb0$var$_default = $33d9a2e6fc191eb0$var$sha1;
module.exports.default = $33d9a2e6fc191eb0$var$_default;

});


parcelRegister("htTDh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $cba04c936365254f$var$_default = '00000000-0000-0000-0000-000000000000';
module.exports.default = $cba04c936365254f$var$_default;

});

parcelRegister("cbVYp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e037b6f47e95c24$var$_validate = $8e037b6f47e95c24$var$_interopRequireDefault((parcelRequire("eniqw")));
function $8e037b6f47e95c24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8e037b6f47e95c24$var$version(uuid) {
    if (!(0, $8e037b6f47e95c24$var$_validate.default)(uuid)) throw TypeError('Invalid UUID');
    return parseInt(uuid.slice(14, 15), 16);
}
var $8e037b6f47e95c24$var$_default = $8e037b6f47e95c24$var$version;
module.exports.default = $8e037b6f47e95c24$var$_default;

});





parcelRegister("ls19Y", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionRedirectEvent = module.exports.ConnectionMessageSentEvent = module.exports.ConnectionMessageReceivedEvent = module.exports.ConnectionEstablishErrorEvent = module.exports.ConnectionErrorEvent = module.exports.ConnectionClosedEvent = module.exports.ConnectionEstablishedEvent = module.exports.ConnectionStartEvent = module.exports.ConnectionEvent = module.exports.ServiceEvent = void 0;

var $dVTTx = parcelRequire("dVTTx");
class $f9dd1cd947d65b53$var$ServiceEvent extends $dVTTx.PlatformEvent {
    constructor(eventName, jsonstring, eventType = $dVTTx.EventType.Info){
        super(eventName, eventType);
        this.privJsonResult = jsonstring;
    }
    get jsonString() {
        return this.privJsonResult;
    }
}
module.exports.ServiceEvent = $f9dd1cd947d65b53$var$ServiceEvent;
class $f9dd1cd947d65b53$var$ConnectionEvent extends $dVTTx.PlatformEvent {
    constructor(eventName, connectionId, eventType = $dVTTx.EventType.Info){
        super(eventName, eventType);
        this.privConnectionId = connectionId;
    }
    get connectionId() {
        return this.privConnectionId;
    }
}
module.exports.ConnectionEvent = $f9dd1cd947d65b53$var$ConnectionEvent;
class $f9dd1cd947d65b53$var$ConnectionStartEvent extends $f9dd1cd947d65b53$var$ConnectionEvent {
    constructor(connectionId, uri, headers){
        super("ConnectionStartEvent", connectionId);
        this.privUri = uri;
        this.privHeaders = headers;
    }
    get uri() {
        return this.privUri;
    }
    get headers() {
        return this.privHeaders;
    }
}
module.exports.ConnectionStartEvent = $f9dd1cd947d65b53$var$ConnectionStartEvent;
class $f9dd1cd947d65b53$var$ConnectionEstablishedEvent extends $f9dd1cd947d65b53$var$ConnectionEvent {
    constructor(connectionId){
        super("ConnectionEstablishedEvent", connectionId);
    }
}
module.exports.ConnectionEstablishedEvent = $f9dd1cd947d65b53$var$ConnectionEstablishedEvent;
class $f9dd1cd947d65b53$var$ConnectionClosedEvent extends $f9dd1cd947d65b53$var$ConnectionEvent {
    constructor(connectionId, statusCode, reason){
        super("ConnectionClosedEvent", connectionId, $dVTTx.EventType.Debug);
        this.privReason = reason;
        this.privStatusCode = statusCode;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
module.exports.ConnectionClosedEvent = $f9dd1cd947d65b53$var$ConnectionClosedEvent;
class $f9dd1cd947d65b53$var$ConnectionErrorEvent extends $f9dd1cd947d65b53$var$ConnectionEvent {
    constructor(connectionId, message, type){
        super("ConnectionErrorEvent", connectionId, $dVTTx.EventType.Debug);
        this.privMessage = message;
        this.privType = type;
    }
    get message() {
        return this.privMessage;
    }
    get type() {
        return this.privType;
    }
}
module.exports.ConnectionErrorEvent = $f9dd1cd947d65b53$var$ConnectionErrorEvent;
class $f9dd1cd947d65b53$var$ConnectionEstablishErrorEvent extends $f9dd1cd947d65b53$var$ConnectionEvent {
    constructor(connectionId, statuscode, reason){
        super("ConnectionEstablishErrorEvent", connectionId, $dVTTx.EventType.Error);
        this.privStatusCode = statuscode;
        this.privReason = reason;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
module.exports.ConnectionEstablishErrorEvent = $f9dd1cd947d65b53$var$ConnectionEstablishErrorEvent;
class $f9dd1cd947d65b53$var$ConnectionMessageReceivedEvent extends $f9dd1cd947d65b53$var$ConnectionEvent {
    constructor(connectionId, networkReceivedTimeISO, message){
        super("ConnectionMessageReceivedEvent", connectionId);
        this.privNetworkReceivedTime = networkReceivedTimeISO;
        this.privMessage = message;
    }
    get networkReceivedTime() {
        return this.privNetworkReceivedTime;
    }
    get message() {
        return this.privMessage;
    }
}
module.exports.ConnectionMessageReceivedEvent = $f9dd1cd947d65b53$var$ConnectionMessageReceivedEvent;
class $f9dd1cd947d65b53$var$ConnectionMessageSentEvent extends $f9dd1cd947d65b53$var$ConnectionEvent {
    constructor(connectionId, networkSentTimeISO, message){
        super("ConnectionMessageSentEvent", connectionId);
        this.privNetworkSentTime = networkSentTimeISO;
        this.privMessage = message;
    }
    get networkSentTime() {
        return this.privNetworkSentTime;
    }
    get message() {
        return this.privMessage;
    }
}
module.exports.ConnectionMessageSentEvent = $f9dd1cd947d65b53$var$ConnectionMessageSentEvent;
class $f9dd1cd947d65b53$var$ConnectionRedirectEvent extends $f9dd1cd947d65b53$var$ConnectionEvent {
    constructor(connectionId, redirectUrl, originalUrl, context){
        super("ConnectionRedirectEvent", connectionId, $dVTTx.EventType.Info);
        this.privRedirectUrl = redirectUrl;
        this.privOriginalUrl = originalUrl;
        this.privContext = context;
    }
    get redirectUrl() {
        return this.privRedirectUrl;
    }
    get originalUrl() {
        return this.privOriginalUrl;
    }
    get context() {
        return this.privContext;
    }
}
module.exports.ConnectionRedirectEvent = $f9dd1cd947d65b53$var$ConnectionRedirectEvent;

});

parcelRegister("k419T", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-return */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessage = module.exports.MessageType = void 0;

var $3NF6I = parcelRequire("3NF6I");

var $8lWt4 = parcelRequire("8lWt4");
var $e9b51472080e5f45$var$MessageType;
(function(MessageType) {
    MessageType[MessageType["Text"] = 0] = "Text";
    MessageType[MessageType["Binary"] = 1] = "Binary";
})($e9b51472080e5f45$var$MessageType = module.exports.MessageType || (module.exports.MessageType = {}));
class $e9b51472080e5f45$var$ConnectionMessage {
    constructor(messageType, body, headers, id){
        this.privBody = null;
        if (messageType === $e9b51472080e5f45$var$MessageType.Text && body && !(typeof body === "string")) throw new $3NF6I.InvalidOperationError("Payload must be a string");
        if (messageType === $e9b51472080e5f45$var$MessageType.Binary && body && !(body instanceof ArrayBuffer)) throw new $3NF6I.InvalidOperationError("Payload must be ArrayBuffer");
        this.privMessageType = messageType;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.privBody = body;
        this.privHeaders = headers ? headers : {};
        this.privId = id ? id : (0, $8lWt4.createNoDashGuid)();
        switch(this.messageType){
            case $e9b51472080e5f45$var$MessageType.Binary:
                this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
                break;
            case $e9b51472080e5f45$var$MessageType.Text:
                this.privSize = this.textBody.length;
        }
    }
    get messageType() {
        return this.privMessageType;
    }
    get headers() {
        return this.privHeaders;
    }
    get body() {
        return this.privBody;
    }
    get textBody() {
        if (this.privMessageType === $e9b51472080e5f45$var$MessageType.Binary) throw new $3NF6I.InvalidOperationError("Not supported for binary message");
        return this.privBody;
    }
    get binaryBody() {
        if (this.privMessageType === $e9b51472080e5f45$var$MessageType.Text) throw new $3NF6I.InvalidOperationError("Not supported for text message");
        return this.privBody;
    }
    get id() {
        return this.privId;
    }
}
module.exports.ConnectionMessage = $e9b51472080e5f45$var$ConnectionMessage;

});
parcelRegister("3NF6I", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectDisposedError = module.exports.InvalidOperationError = module.exports.ArgumentNullError = void 0;
/* eslint-disable max-classes-per-file */ /**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class ArgumentNullError
 * @extends {Error}
 */ class $2c45d5bfcd53d721$var$ArgumentNullError extends Error {
    /**
     * Creates an instance of ArgumentNullError.
     *
     * @param {string} argumentName - Name of the argument that is null
     *
     * @memberOf ArgumentNullError
     */ constructor(argumentName){
        super(argumentName);
        this.name = "ArgumentNull";
        this.message = argumentName;
    }
}
module.exports.ArgumentNullError = $2c45d5bfcd53d721$var$ArgumentNullError;
/**
 * The error that is thrown when an invalid operation is performed in the code.
 *
 * @export
 * @class InvalidOperationError
 * @extends {Error}
 */ class $2c45d5bfcd53d721$var$InvalidOperationError extends Error {
    /**
     * Creates an instance of InvalidOperationError.
     *
     * @param {string} error - The error
     *
     * @memberOf InvalidOperationError
     */ constructor(error){
        super(error);
        this.name = "InvalidOperation";
        this.message = error;
    }
}
module.exports.InvalidOperationError = $2c45d5bfcd53d721$var$InvalidOperationError;
/**
 * The error that is thrown when an object is disposed.
 *
 * @export
 * @class ObjectDisposedError
 * @extends {Error}
 */ class $2c45d5bfcd53d721$var$ObjectDisposedError extends Error {
    /**
     * Creates an instance of ObjectDisposedError.
     *
     * @param {string} objectName - The object that is disposed
     * @param {string} error - The error
     *
     * @memberOf ObjectDisposedError
     */ constructor(objectName, error){
        super(error);
        this.name = objectName + "ObjectDisposed";
        this.message = error;
    }
}
module.exports.ObjectDisposedError = $2c45d5bfcd53d721$var$ObjectDisposedError;

});


parcelRegister("jyCxe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionOpenResponse = void 0;
class $e3cf158e7aef369e$var$ConnectionOpenResponse {
    constructor(statusCode, reason){
        this.privStatusCode = statusCode;
        this.privReason = reason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
    get reason() {
        return this.privReason;
    }
}
module.exports.ConnectionOpenResponse = $e3cf158e7aef369e$var$ConnectionOpenResponse;

});

parcelRegister("iYjv4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DeferralMap = void 0;
/**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class DefferalMap
 */ class $dcfcf4e9fc4542d6$var$DeferralMap {
    constructor(){
        this.privMap = {};
    }
    add(id, deferral) {
        this.privMap[id] = deferral;
    }
    getId(id) {
        return this.privMap[id];
    }
    complete(id, result) {
        try {
            this.privMap[id].resolve(result);
        } catch (error) {
            this.privMap[id].reject(error);
        } finally{
            this.privMap[id] = undefined;
        }
    }
}
module.exports.DeferralMap = $dcfcf4e9fc4542d6$var$DeferralMap;

});

parcelRegister("32dAT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SendingAgentContextMessageEvent = module.exports.DialogEvent = void 0;

var $dVTTx = parcelRequire("dVTTx");
class $235c1a8366fcc3a8$var$DialogEvent extends $dVTTx.PlatformEvent {
    constructor(eventName, eventType = $dVTTx.EventType.Info){
        super(eventName, eventType);
    }
}
module.exports.DialogEvent = $235c1a8366fcc3a8$var$DialogEvent;
class $235c1a8366fcc3a8$var$SendingAgentContextMessageEvent extends $235c1a8366fcc3a8$var$DialogEvent {
    constructor(agentConfig){
        super("SendingAgentContextMessageEvent");
        this.privAgentConfig = agentConfig;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
}
module.exports.SendingAgentContextMessageEvent = $235c1a8366fcc3a8$var$SendingAgentContextMessageEvent;

});

parcelRegister("5vbCN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Events = void 0;

var $3NF6I = parcelRequire("3NF6I");

var $9SKhX = parcelRequire("9SKhX");
class $4018dd6fa9e4d561$var$Events {
    static setEventSource(eventSource) {
        if (!eventSource) throw new $3NF6I.ArgumentNullError("eventSource");
        $4018dd6fa9e4d561$var$Events.privInstance = eventSource;
    }
    static get instance() {
        return $4018dd6fa9e4d561$var$Events.privInstance;
    }
}
module.exports.Events = $4018dd6fa9e4d561$var$Events;
$4018dd6fa9e4d561$var$Events.privInstance = new $9SKhX.EventSource();

});
parcelRegister("9SKhX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventSource = void 0;

var $3NF6I = parcelRequire("3NF6I");

var $8lWt4 = parcelRequire("8lWt4");
class $731d102e8bff58d9$var$EventSource {
    constructor(metadata){
        this.privEventListeners = {};
        this.privIsDisposed = false;
        this.privConsoleListener = undefined;
        this.privMetadata = metadata;
    }
    onEvent(event) {
        if (this.isDisposed()) throw new $3NF6I.ObjectDisposedError("EventSource");
        if (this.metadata) {
            for(const paramName in this.metadata)if (paramName) {
                if (event.metadata) {
                    if (!event.metadata[paramName]) event.metadata[paramName] = this.metadata[paramName];
                }
            }
        }
        for(const eventId in this.privEventListeners)if (eventId && this.privEventListeners[eventId]) this.privEventListeners[eventId](event);
    }
    attach(onEventCallback) {
        const id = (0, $8lWt4.createNoDashGuid)();
        this.privEventListeners[id] = onEventCallback;
        return {
            detach: ()=>{
                delete this.privEventListeners[id];
                return Promise.resolve();
            }
        };
    }
    attachListener(listener) {
        return this.attach((e)=>listener.onEvent(e));
    }
    attachConsoleListener(listener) {
        if (!!this.privConsoleListener) this.privConsoleListener.detach(); // Detach implementation for eventListeners is synchronous
        this.privConsoleListener = this.attach((e)=>listener.onEvent(e));
        return this.privConsoleListener;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        this.privEventListeners = null;
        this.privIsDisposed = true;
    }
    get metadata() {
        return this.privMetadata;
    }
}
module.exports.EventSource = $731d102e8bff58d9$var$EventSource;

});


parcelRegister("jODUz", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9klG9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionState = void 0;
var $6ca6cc4a58644bfc$var$ConnectionState;
(function(ConnectionState) {
    ConnectionState[ConnectionState["None"] = 0] = "None";
    ConnectionState[ConnectionState["Connected"] = 1] = "Connected";
    ConnectionState[ConnectionState["Connecting"] = 2] = "Connecting";
    ConnectionState[ConnectionState["Disconnected"] = 3] = "Disconnected";
})($6ca6cc4a58644bfc$var$ConnectionState = module.exports.ConnectionState || (module.exports.ConnectionState = {}));

});

parcelRegister("8UNKy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("95vqE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8KXOL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lwbJi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("i8sQl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9BIeo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("clt1b", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9sJtU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jHUvS", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.List = void 0;

var $3NF6I = parcelRequire("3NF6I");
class $e58dded2f036002a$var$List {
    constructor(list){
        this.privSubscriptionIdCounter = 0;
        this.privAddSubscriptions = {};
        this.privRemoveSubscriptions = {};
        this.privDisposedSubscriptions = {};
        this.privDisposeReason = null;
        this.privList = [];
        // copy the list rather than taking as is.
        if (list) for (const item of list)this.privList.push(item);
    }
    get(itemIndex) {
        this.throwIfDisposed();
        return this.privList[itemIndex];
    }
    first() {
        return this.get(0);
    }
    last() {
        return this.get(this.length() - 1);
    }
    add(item) {
        this.throwIfDisposed();
        this.insertAt(this.privList.length, item);
    }
    insertAt(index, item) {
        this.throwIfDisposed();
        if (index === 0) this.privList.unshift(item);
        else if (index === this.privList.length) this.privList.push(item);
        else this.privList.splice(index, 0, item);
        this.triggerSubscriptions(this.privAddSubscriptions);
    }
    removeFirst() {
        this.throwIfDisposed();
        return this.removeAt(0);
    }
    removeLast() {
        this.throwIfDisposed();
        return this.removeAt(this.length() - 1);
    }
    removeAt(index) {
        this.throwIfDisposed();
        return this.remove(index, 1)[0];
    }
    remove(index, count) {
        this.throwIfDisposed();
        const removedElements = this.privList.splice(index, count);
        this.triggerSubscriptions(this.privRemoveSubscriptions);
        return removedElements;
    }
    clear() {
        this.throwIfDisposed();
        this.remove(0, this.length());
    }
    length() {
        this.throwIfDisposed();
        return this.privList.length;
    }
    onAdded(addedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privAddSubscriptions[subscriptionId] = addedCallback;
        return {
            detach: ()=>{
                delete this.privAddSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    onRemoved(removedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privRemoveSubscriptions[subscriptionId] = removedCallback;
        return {
            detach: ()=>{
                delete this.privRemoveSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    onDisposed(disposedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privDisposedSubscriptions[subscriptionId] = disposedCallback;
        return {
            detach: ()=>{
                delete this.privDisposedSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    join(seperator) {
        this.throwIfDisposed();
        return this.privList.join(seperator);
    }
    toArray() {
        const cloneCopy = Array();
        this.privList.forEach((val)=>{
            cloneCopy.push(val);
        });
        return cloneCopy;
    }
    any(callback) {
        this.throwIfDisposed();
        if (callback) return this.where(callback).length() > 0;
        else return this.length() > 0;
    }
    all(callback) {
        this.throwIfDisposed();
        return this.where(callback).length() === this.length();
    }
    forEach(callback) {
        this.throwIfDisposed();
        for(let i = 0; i < this.length(); i++)callback(this.privList[i], i);
    }
    select(callback) {
        this.throwIfDisposed();
        const selectList = [];
        for(let i = 0; i < this.privList.length; i++)selectList.push(callback(this.privList[i], i));
        return new $e58dded2f036002a$var$List(selectList);
    }
    where(callback) {
        this.throwIfDisposed();
        const filteredList = new $e58dded2f036002a$var$List();
        for(let i = 0; i < this.privList.length; i++)if (callback(this.privList[i], i)) filteredList.add(this.privList[i]);
        return filteredList;
    }
    orderBy(compareFn) {
        this.throwIfDisposed();
        const clonedArray = this.toArray();
        const orderedArray = clonedArray.sort(compareFn);
        return new $e58dded2f036002a$var$List(orderedArray);
    }
    orderByDesc(compareFn) {
        this.throwIfDisposed();
        return this.orderBy((a, b)=>compareFn(b, a));
    }
    clone() {
        this.throwIfDisposed();
        return new $e58dded2f036002a$var$List(this.toArray());
    }
    concat(list) {
        this.throwIfDisposed();
        return new $e58dded2f036002a$var$List(this.privList.concat(list.toArray()));
    }
    concatArray(array) {
        this.throwIfDisposed();
        return new $e58dded2f036002a$var$List(this.privList.concat(array));
    }
    isDisposed() {
        return this.privList == null;
    }
    dispose(reason) {
        if (!this.isDisposed()) {
            this.privDisposeReason = reason;
            this.privList = null;
            this.privAddSubscriptions = null;
            this.privRemoveSubscriptions = null;
            this.triggerSubscriptions(this.privDisposedSubscriptions);
        }
    }
    throwIfDisposed() {
        if (this.isDisposed()) throw new $3NF6I.ObjectDisposedError("List", this.privDisposeReason);
    }
    triggerSubscriptions(subscriptions) {
        if (subscriptions) {
            for(const subscriptionId in subscriptions)if (subscriptionId) subscriptions[subscriptionId]();
        }
    }
}
module.exports.List = $e58dded2f036002a$var$List;

});

parcelRegister("ciGbY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.marshalPromiseToCallbacks = module.exports.Sink = module.exports.Deferred = module.exports.PromiseResultEventSource = module.exports.PromiseResult = module.exports.PromiseState = void 0;
/* eslint-disable max-classes-per-file, @typescript-eslint/typedef */ var $8f47e4f5f5fe996a$var$PromiseState;
(function(PromiseState) {
    PromiseState[PromiseState["None"] = 0] = "None";
    PromiseState[PromiseState["Resolved"] = 1] = "Resolved";
    PromiseState[PromiseState["Rejected"] = 2] = "Rejected";
})($8f47e4f5f5fe996a$var$PromiseState = module.exports.PromiseState || (module.exports.PromiseState = {}));
class $8f47e4f5f5fe996a$var$PromiseResult {
    constructor(promiseResultEventSource){
        this.throwIfError = ()=>{
            if (this.isError) throw this.error;
        };
        promiseResultEventSource.on((result)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = false;
                this.privResult = result;
            }
        }, (error)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = true;
                this.privError = error;
            }
        });
    }
    get isCompleted() {
        return this.privIsCompleted;
    }
    get isError() {
        return this.privIsError;
    }
    get error() {
        return this.privError;
    }
    get result() {
        return this.privResult;
    }
}
module.exports.PromiseResult = $8f47e4f5f5fe996a$var$PromiseResult;
class $8f47e4f5f5fe996a$var$PromiseResultEventSource {
    constructor(){
        this.setResult = (result)=>{
            this.privOnSetResult(result);
        };
        this.setError = (error)=>{
            this.privOnSetError(error);
        };
        this.on = (onSetResult, onSetError)=>{
            this.privOnSetResult = onSetResult;
            this.privOnSetError = onSetError;
        };
    }
}
module.exports.PromiseResultEventSource = $8f47e4f5f5fe996a$var$PromiseResultEventSource;
class $8f47e4f5f5fe996a$var$Deferred {
    constructor(){
        this.resolve = (result)=>{
            this.privResolve(result);
            return this;
        };
        this.reject = (error)=>{
            this.privReject(error);
            return this;
        };
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        this.privPromise = new Promise((resolve, reject)=>{
            this.privResolve = resolve;
            this.privReject = reject;
        });
    }
    get promise() {
        return this.privPromise;
    }
}
module.exports.Deferred = $8f47e4f5f5fe996a$var$Deferred;
class $8f47e4f5f5fe996a$var$Sink {
    constructor(){
        this.privState = $8f47e4f5f5fe996a$var$PromiseState.None;
        this.privPromiseResult = null;
        this.privPromiseResultEvents = null;
        this.privSuccessHandlers = [];
        this.privErrorHandlers = [];
        this.privPromiseResultEvents = new $8f47e4f5f5fe996a$var$PromiseResultEventSource();
        this.privPromiseResult = new $8f47e4f5f5fe996a$var$PromiseResult(this.privPromiseResultEvents);
    }
    get state() {
        return this.privState;
    }
    get result() {
        return this.privPromiseResult;
    }
    resolve(result) {
        if (this.privState !== $8f47e4f5f5fe996a$var$PromiseState.None) throw new Error("'Cannot resolve a completed promise'");
        this.privState = $8f47e4f5f5fe996a$var$PromiseState.Resolved;
        this.privPromiseResultEvents.setResult(result);
        for(let i = 0; i < this.privSuccessHandlers.length; i++)this.executeSuccessCallback(result, this.privSuccessHandlers[i], this.privErrorHandlers[i]);
        this.detachHandlers();
    }
    reject(error) {
        if (this.privState !== $8f47e4f5f5fe996a$var$PromiseState.None) throw new Error("'Cannot reject a completed promise'");
        this.privState = $8f47e4f5f5fe996a$var$PromiseState.Rejected;
        this.privPromiseResultEvents.setError(error);
        for (const errorHandler of this.privErrorHandlers)this.executeErrorCallback(error, errorHandler);
        this.detachHandlers();
    }
    on(successCallback, errorCallback) {
        if (successCallback == null) // eslint-disable-next-line @typescript-eslint/no-empty-function
        successCallback = ()=>{};
        if (this.privState === $8f47e4f5f5fe996a$var$PromiseState.None) {
            this.privSuccessHandlers.push(successCallback);
            this.privErrorHandlers.push(errorCallback);
        } else {
            if (this.privState === $8f47e4f5f5fe996a$var$PromiseState.Resolved) this.executeSuccessCallback(this.privPromiseResult.result, successCallback, errorCallback);
            else if (this.privState === $8f47e4f5f5fe996a$var$PromiseState.Rejected) this.executeErrorCallback(this.privPromiseResult.error, errorCallback);
            this.detachHandlers();
        }
    }
    executeSuccessCallback(result, successCallback, errorCallback) {
        try {
            successCallback(result);
        } catch (e) {
            this.executeErrorCallback(`'Unhandled callback error: ${e}'`, errorCallback);
        }
    }
    executeErrorCallback(error, errorCallback) {
        if (errorCallback) try {
            errorCallback(error);
        } catch (e) {
            throw new Error(`'Unhandled callback error: ${e}. InnerError: ${error}'`);
        }
        else throw new Error(`'Unhandled error: ${error}'`);
    }
    detachHandlers() {
        this.privErrorHandlers = [];
        this.privSuccessHandlers = [];
    }
}
module.exports.Sink = $8f47e4f5f5fe996a$var$Sink;
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function $8f47e4f5f5fe996a$var$marshalPromiseToCallbacks(promise, cb, err) {
    promise.then((val)=>{
        try {
            if (!!cb) cb(val);
        } catch (error) {
            if (!!err) try {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            // eslint-disable-next-line no-empty
            } catch (error) {}
        }
    }, (error)=>{
        if (!!err) try {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        // eslint-disable-next-line no-empty
        } catch (error) {}
    });
}
module.exports.marshalPromiseToCallbacks = $8f47e4f5f5fe996a$var$marshalPromiseToCallbacks;

});

parcelRegister("63lFD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Queue = void 0;

var $3NF6I = parcelRequire("3NF6I");

var $jHUvS = parcelRequire("jHUvS");

var $ciGbY = parcelRequire("ciGbY");
var $4683d5306442318e$var$SubscriberType;
(function(SubscriberType) {
    SubscriberType[SubscriberType["Dequeue"] = 0] = "Dequeue";
    SubscriberType[SubscriberType["Peek"] = 1] = "Peek";
})($4683d5306442318e$var$SubscriberType || ($4683d5306442318e$var$SubscriberType = {}));
class $4683d5306442318e$var$Queue {
    constructor(list){
        this.privPromiseStore = new $jHUvS.List();
        this.privIsDrainInProgress = false;
        this.privIsDisposing = false;
        this.privDisposeReason = null;
        this.privList = list ? list : new $jHUvS.List();
        this.privDetachables = [];
        this.privSubscribers = new $jHUvS.List();
        this.privDetachables.push(this.privList.onAdded(()=>this.drain()));
    }
    enqueue(item) {
        this.throwIfDispose();
        this.enqueueFromPromise(new Promise((resolve)=>resolve(item)));
    }
    enqueueFromPromise(promise) {
        this.throwIfDispose();
        promise.then((val)=>{
            this.privList.add(val);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        }, ()=>{});
    }
    dequeue() {
        this.throwIfDispose();
        const deferredSubscriber = new $ciGbY.Deferred();
        if (this.privSubscribers) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $4683d5306442318e$var$SubscriberType.Dequeue
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    }
    peek() {
        this.throwIfDispose();
        const deferredSubscriber = new $ciGbY.Deferred();
        const subs = this.privSubscribers;
        if (subs) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $4683d5306442318e$var$SubscriberType.Peek
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    }
    length() {
        this.throwIfDispose();
        return this.privList.length();
    }
    isDisposed() {
        return this.privSubscribers == null;
    }
    async drainAndDispose(pendingItemProcessor, reason) {
        if (!this.isDisposed() && !this.privIsDisposing) {
            this.privDisposeReason = reason;
            this.privIsDisposing = true;
            const subs = this.privSubscribers;
            if (subs) {
                while(subs.length() > 0){
                    const subscriber = subs.removeFirst();
                    // TODO: this needs work (Resolve(null) instead?).
                    subscriber.deferral.resolve(undefined);
                // subscriber.deferral.reject("Disposed");
                }
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privSubscribers === subs) this.privSubscribers = subs;
            }
            for (const detachable of this.privDetachables)await detachable.detach();
            if (this.privPromiseStore.length() > 0 && pendingItemProcessor) {
                const promiseArray = [];
                this.privPromiseStore.toArray().forEach((wrapper)=>{
                    promiseArray.push(wrapper);
                });
                return Promise.all(promiseArray).finally(()=>{
                    this.privSubscribers = null;
                    this.privList.forEach((item)=>{
                        pendingItemProcessor(item);
                    });
                    this.privList = null;
                    return;
                }).then();
            } else {
                this.privSubscribers = null;
                this.privList = null;
            }
        }
    }
    async dispose(reason) {
        await this.drainAndDispose(null, reason);
    }
    drain() {
        if (!this.privIsDrainInProgress && !this.privIsDisposing) {
            this.privIsDrainInProgress = true;
            const subs = this.privSubscribers;
            const lists = this.privList;
            if (subs && lists) {
                while(lists.length() > 0 && subs.length() > 0 && !this.privIsDisposing){
                    const subscriber = subs.removeFirst();
                    if (subscriber.type === $4683d5306442318e$var$SubscriberType.Peek) subscriber.deferral.resolve(lists.first());
                    else {
                        const dequeuedItem = lists.removeFirst();
                        subscriber.deferral.resolve(dequeuedItem);
                    }
                }
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privSubscribers === subs) this.privSubscribers = subs;
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privList === lists) this.privList = lists;
            }
            this.privIsDrainInProgress = false;
        }
    }
    throwIfDispose() {
        if (this.isDisposed()) {
            if (this.privDisposeReason) throw new $3NF6I.InvalidOperationError(this.privDisposeReason);
            throw new $3NF6I.ObjectDisposedError("Queue");
        } else if (this.privIsDisposing) throw new $3NF6I.InvalidOperationError("Queue disposing");
    }
}
module.exports.Queue = $4683d5306442318e$var$Queue;

});

parcelRegister("hkGW0", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawWebsocketMessage = void 0;

var $k419T = parcelRequire("k419T");

var $3NF6I = parcelRequire("3NF6I");

var $8lWt4 = parcelRequire("8lWt4");
class $c9e59bd21b330f3f$var$RawWebsocketMessage {
    constructor(messageType, payload, id){
        this.privPayload = null;
        if (!payload) throw new $3NF6I.ArgumentNullError("payload");
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (messageType === $k419T.MessageType.Binary && Object.getPrototypeOf(payload).constructor.name !== "ArrayBuffer") throw new $3NF6I.InvalidOperationError("Payload must be ArrayBuffer");
        if (messageType === $k419T.MessageType.Text && !(typeof payload === "string")) throw new $3NF6I.InvalidOperationError("Payload must be a string");
        this.privMessageType = messageType;
        this.privPayload = payload;
        this.privId = id ? id : (0, $8lWt4.createNoDashGuid)();
    }
    get messageType() {
        return this.privMessageType;
    }
    get payload() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.privPayload;
    }
    get textContent() {
        if (this.privMessageType === $k419T.MessageType.Binary) throw new $3NF6I.InvalidOperationError("Not supported for binary message");
        return this.privPayload;
    }
    get binaryContent() {
        if (this.privMessageType === $k419T.MessageType.Text) throw new $3NF6I.InvalidOperationError("Not supported for text message");
        return this.privPayload;
    }
    get id() {
        return this.privId;
    }
}
module.exports.RawWebsocketMessage = $c9e59bd21b330f3f$var$RawWebsocketMessage;

});

parcelRegister("csECP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RiffPcmEncoder = void 0;
class $91279cdf251eb24d$var$RiffPcmEncoder {
    constructor(actualSampleRate, desiredSampleRate){
        this.privActualSampleRate = actualSampleRate;
        this.privDesiredSampleRate = desiredSampleRate;
    }
    encode(actualAudioFrame) {
        const audioFrame = this.downSampleAudioFrame(actualAudioFrame, this.privActualSampleRate, this.privDesiredSampleRate);
        if (!audioFrame) return null;
        const audioLength = audioFrame.length * 2;
        const buffer = new ArrayBuffer(audioLength);
        const view = new DataView(buffer);
        this.floatTo16BitPCM(view, 0, audioFrame);
        return buffer;
    }
    setString(view, offset, str) {
        for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    }
    floatTo16BitPCM(view, offset, input) {
        for(let i = 0; i < input.length; i++, offset += 2){
            const s = Math.max(-1, Math.min(1, input[i]));
            view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
    }
    downSampleAudioFrame(srcFrame, srcRate, dstRate) {
        if (!srcFrame) return null;
        if (dstRate === srcRate || dstRate > srcRate) return srcFrame;
        const ratio = srcRate / dstRate;
        const dstLength = Math.round(srcFrame.length / ratio);
        const dstFrame = new Float32Array(dstLength);
        let srcOffset = 0;
        let dstOffset = 0;
        while(dstOffset < dstLength){
            const nextSrcOffset = Math.round((dstOffset + 1) * ratio);
            let accum = 0;
            let count = 0;
            while(srcOffset < nextSrcOffset && srcOffset < srcFrame.length){
                accum += srcFrame[srcOffset++];
                count++;
            }
            dstFrame[dstOffset++] = accum / count;
        }
        return dstFrame;
    }
}
module.exports.RiffPcmEncoder = $91279cdf251eb24d$var$RiffPcmEncoder;

});

parcelRegister("brK4I", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Stream = void 0;

var $3NF6I = parcelRequire("3NF6I");

var $8lWt4 = parcelRequire("8lWt4");

var $63lFD = parcelRequire("63lFD");
class $8555f4e074c0502f$var$Stream {
    constructor(streamId){
        this.privIsWriteEnded = false;
        this.privIsReadEnded = false;
        this.privId = streamId ? streamId : (0, $8lWt4.createNoDashGuid)();
        this.privReaderQueue = new $63lFD.Queue();
    }
    get isClosed() {
        return this.privIsWriteEnded;
    }
    get isReadEnded() {
        return this.privIsReadEnded;
    }
    get id() {
        return this.privId;
    }
    close() {
        if (!this.privIsWriteEnded) {
            this.writeStreamChunk({
                buffer: null,
                isEnd: true,
                timeReceived: Date.now()
            });
            this.privIsWriteEnded = true;
        }
    }
    writeStreamChunk(streamChunk) {
        this.throwIfClosed();
        if (!this.privReaderQueue.isDisposed()) try {
            this.privReaderQueue.enqueue(streamChunk);
        } catch (e) {
        // Do nothing
        }
    }
    read() {
        if (this.privIsReadEnded) throw new $3NF6I.InvalidOperationError("Stream read has already finished");
        return this.privReaderQueue.dequeue().then(async (streamChunk)=>{
            if (streamChunk === undefined || streamChunk.isEnd) await this.privReaderQueue.dispose("End of stream reached");
            return streamChunk;
        });
    }
    readEnded() {
        if (!this.privIsReadEnded) {
            this.privIsReadEnded = true;
            this.privReaderQueue = new $63lFD.Queue();
        }
    }
    throwIfClosed() {
        if (this.privIsWriteEnded) throw new $3NF6I.InvalidOperationError("Stream closed");
    }
}
module.exports.Stream = $8555f4e074c0502f$var$Stream;

});

parcelRegister("iv8Pq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationStatus = void 0;
/**
 * Defines translation status.
 * @class TranslationStatus
 */ var $d781f861488c06bb$var$TranslationStatus;
(function(TranslationStatus) {
    /**
     * @member TranslationStatus.Success
     */ TranslationStatus[TranslationStatus["Success"] = 0] = "Success";
    /**
     * @member TranslationStatus.Error
     */ TranslationStatus[TranslationStatus["Error"] = 1] = "Error";
})($d781f861488c06bb$var$TranslationStatus = module.exports.TranslationStatus || (module.exports.TranslationStatus = {}));

});

parcelRegister("ds9gc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChunkedArrayBufferStream = void 0;

var $5OUhN = parcelRequire("5OUhN");
class $9cb512c8c40b5f4c$var$ChunkedArrayBufferStream extends $5OUhN.Stream {
    constructor(targetChunkSize, streamId){
        super(streamId);
        this.privTargetChunkSize = Math.round(targetChunkSize);
        this.privNextBufferReadyBytes = 0;
    }
    writeStreamChunk(chunk) {
        // No pending write, and the buffer is the right size so write it.
        if (chunk.isEnd || 0 === this.privNextBufferReadyBytes && chunk.buffer.byteLength === this.privTargetChunkSize) {
            super.writeStreamChunk(chunk);
            return;
        }
        let bytesCopiedFromBuffer = 0;
        while(bytesCopiedFromBuffer < chunk.buffer.byteLength){
            // Fill the next buffer.
            if (undefined === this.privNextBufferToWrite) {
                this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize);
                this.privNextBufferStartTime = chunk.timeReceived;
            }
            // Find out how many bytes we can copy into the read buffer.
            const bytesToCopy = Math.min(chunk.buffer.byteLength - bytesCopiedFromBuffer, this.privTargetChunkSize - this.privNextBufferReadyBytes);
            const targetView = new Uint8Array(this.privNextBufferToWrite);
            const sourceView = new Uint8Array(chunk.buffer.slice(bytesCopiedFromBuffer, bytesToCopy + bytesCopiedFromBuffer));
            targetView.set(sourceView, this.privNextBufferReadyBytes);
            this.privNextBufferReadyBytes += bytesToCopy;
            bytesCopiedFromBuffer += bytesToCopy;
            // Are we ready to write?
            if (this.privNextBufferReadyBytes === this.privTargetChunkSize) {
                super.writeStreamChunk({
                    buffer: this.privNextBufferToWrite,
                    isEnd: false,
                    timeReceived: this.privNextBufferStartTime
                });
                this.privNextBufferReadyBytes = 0;
                this.privNextBufferToWrite = undefined;
            }
        }
    }
    close() {
        // Send whatever is pending, then close the base class.
        if (0 !== this.privNextBufferReadyBytes && !this.isClosed) super.writeStreamChunk({
            buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
            isEnd: false,
            timeReceived: this.privNextBufferStartTime
        });
        super.close();
    }
}
module.exports.ChunkedArrayBufferStream = $9cb512c8c40b5f4c$var$ChunkedArrayBufferStream;

});

parcelRegister("cHP06", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8WCaJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
class $683159ac6661ce6b$var$Timeout {
    static load() {
        // Prefilling the Maps with a function indexed by zero is necessary to be compliant with the specification.
        const scheduledTimeoutFunctions = new Map([
            [
                0,
                ()=>{}
            ]
        ]); // eslint-disable-line @typescript-eslint/no-empty-function
        const unhandledRequests = new Map();
        // eslint-disable-next-line
        const workerScript = `!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`;
        const workerUrl = "data:text/javascript;base64," + btoa(workerScript);
        const worker = new Worker(workerUrl);
        worker.addEventListener("message", ({ data: data })=>{
            if ($683159ac6661ce6b$var$Timeout.isCallNotification(data)) {
                const { params: { timerId: timerId } } = data;
                const idOrFunc = scheduledTimeoutFunctions.get(timerId);
                if (typeof idOrFunc === "number") {
                    const unhandledTimerId = unhandledRequests.get(idOrFunc);
                    if (unhandledTimerId === undefined || unhandledTimerId !== timerId) throw new Error("The timer is in an undefined state.");
                } else if (typeof idOrFunc !== "undefined") {
                    idOrFunc();
                    // A timeout can be safely deleted because it is only called once.
                    scheduledTimeoutFunctions.delete(timerId);
                } else throw new Error("The timer is in an undefined state.");
            } else if ($683159ac6661ce6b$var$Timeout.isClearResponse(data)) {
                const { id: id } = data;
                const unhandledTimerId = unhandledRequests.get(id);
                if (unhandledTimerId === undefined) throw new Error("The timer is in an undefined state.");
                unhandledRequests.delete(id);
                scheduledTimeoutFunctions.delete(unhandledTimerId);
            } else {
                const { error: { message: message } } = data;
                throw new Error(message);
            }
        });
        const clearTimeout = (timerId)=>{
            const id = Math.random();
            unhandledRequests.set(id, timerId);
            scheduledTimeoutFunctions.set(timerId, id);
            worker.postMessage({
                id: id,
                method: "clear",
                params: {
                    timerId: timerId
                }
            });
        };
        const setTimeout = (func, delay)=>{
            const timerId = Math.random();
            scheduledTimeoutFunctions.set(timerId, func);
            worker.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: delay,
                    now: performance.now(),
                    timerId: timerId
                }
            });
            return timerId;
        };
        return {
            clearTimeout: clearTimeout,
            setTimeout: setTimeout
        };
    }
    static loadWorkerTimers() {
        return ()=>{
            if ($683159ac6661ce6b$var$Timeout.workerTimers !== null) return $683159ac6661ce6b$var$Timeout.workerTimers;
            $683159ac6661ce6b$var$Timeout.workerTimers = $683159ac6661ce6b$var$Timeout.load();
            return $683159ac6661ce6b$var$Timeout.workerTimers;
        };
    }
    static isCallNotification(message) {
        return message.method !== undefined && message.method === "call";
    }
    static isClearResponse(message) {
        return message.error === null && typeof message.id === "number";
    }
}
module.exports.Timeout = $683159ac6661ce6b$var$Timeout;
$683159ac6661ce6b$var$Timeout.workerTimers = null;
$683159ac6661ce6b$var$Timeout.clearTimeout = (timerId)=>$683159ac6661ce6b$var$Timeout.timers().clearTimeout(timerId);
$683159ac6661ce6b$var$Timeout.setTimeout = (func, delay)=>$683159ac6661ce6b$var$Timeout.timers().setTimeout(func, delay);
$683159ac6661ce6b$var$Timeout.timers = $683159ac6661ce6b$var$Timeout.loadWorkerTimers();

});

parcelRegister("gihMu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OCSPCacheUpdateErrorEvent = module.exports.OCSPResponseRetrievedEvent = module.exports.OCSPCacheFetchErrorEvent = module.exports.OCSPVerificationFailedEvent = module.exports.OCSPCacheHitEvent = module.exports.OCSPCacheEntryNeedsRefreshEvent = module.exports.OCSPCacheEntryExpiredEvent = module.exports.OCSPWSUpgradeStartedEvent = module.exports.OCSPStapleReceivedEvent = module.exports.OCSPCacheUpdateCompleteEvent = module.exports.OCSPDiskCacheStoreEvent = module.exports.OCSPMemoryCacheStoreEvent = module.exports.OCSPCacheUpdateNeededEvent = module.exports.OCSPDiskCacheHitEvent = module.exports.OCSPCacheMissEvent = module.exports.OCSPMemoryCacheHitEvent = module.exports.OCSPEvent = void 0;

var $dVTTx = parcelRequire("dVTTx");
class $030fadea4d85d091$var$OCSPEvent extends $dVTTx.PlatformEvent {
    constructor(eventName, eventType, signature){
        super(eventName, eventType);
        this.privSignature = signature;
    }
}
module.exports.OCSPEvent = $030fadea4d85d091$var$OCSPEvent;
class $030fadea4d85d091$var$OCSPMemoryCacheHitEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(signature){
        super("OCSPMemoryCacheHitEvent", $dVTTx.EventType.Debug, signature);
    }
}
module.exports.OCSPMemoryCacheHitEvent = $030fadea4d85d091$var$OCSPMemoryCacheHitEvent;
class $030fadea4d85d091$var$OCSPCacheMissEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(signature){
        super("OCSPCacheMissEvent", $dVTTx.EventType.Debug, signature);
    }
}
module.exports.OCSPCacheMissEvent = $030fadea4d85d091$var$OCSPCacheMissEvent;
class $030fadea4d85d091$var$OCSPDiskCacheHitEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(signature){
        super("OCSPDiskCacheHitEvent", $dVTTx.EventType.Debug, signature);
    }
}
module.exports.OCSPDiskCacheHitEvent = $030fadea4d85d091$var$OCSPDiskCacheHitEvent;
class $030fadea4d85d091$var$OCSPCacheUpdateNeededEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(signature){
        super("OCSPCacheUpdateNeededEvent", $dVTTx.EventType.Debug, signature);
    }
}
module.exports.OCSPCacheUpdateNeededEvent = $030fadea4d85d091$var$OCSPCacheUpdateNeededEvent;
class $030fadea4d85d091$var$OCSPMemoryCacheStoreEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(signature){
        super("OCSPMemoryCacheStoreEvent", $dVTTx.EventType.Debug, signature);
    }
}
module.exports.OCSPMemoryCacheStoreEvent = $030fadea4d85d091$var$OCSPMemoryCacheStoreEvent;
class $030fadea4d85d091$var$OCSPDiskCacheStoreEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(signature){
        super("OCSPDiskCacheStoreEvent", $dVTTx.EventType.Debug, signature);
    }
}
module.exports.OCSPDiskCacheStoreEvent = $030fadea4d85d091$var$OCSPDiskCacheStoreEvent;
class $030fadea4d85d091$var$OCSPCacheUpdateCompleteEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(signature){
        super("OCSPCacheUpdateCompleteEvent", $dVTTx.EventType.Debug, signature);
    }
}
module.exports.OCSPCacheUpdateCompleteEvent = $030fadea4d85d091$var$OCSPCacheUpdateCompleteEvent;
class $030fadea4d85d091$var$OCSPStapleReceivedEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(){
        super("OCSPStapleReceivedEvent", $dVTTx.EventType.Debug, "");
    }
}
module.exports.OCSPStapleReceivedEvent = $030fadea4d85d091$var$OCSPStapleReceivedEvent;
class $030fadea4d85d091$var$OCSPWSUpgradeStartedEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(serialNumber){
        super("OCSPWSUpgradeStartedEvent", $dVTTx.EventType.Debug, serialNumber);
    }
}
module.exports.OCSPWSUpgradeStartedEvent = $030fadea4d85d091$var$OCSPWSUpgradeStartedEvent;
class $030fadea4d85d091$var$OCSPCacheEntryExpiredEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(serialNumber, expireTime){
        super("OCSPCacheEntryExpiredEvent", $dVTTx.EventType.Debug, serialNumber);
        this.privExpireTime = expireTime;
    }
}
module.exports.OCSPCacheEntryExpiredEvent = $030fadea4d85d091$var$OCSPCacheEntryExpiredEvent;
class $030fadea4d85d091$var$OCSPCacheEntryNeedsRefreshEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(serialNumber, startTime, expireTime){
        super("OCSPCacheEntryNeedsRefreshEvent", $dVTTx.EventType.Debug, serialNumber);
        this.privExpireTime = expireTime;
        this.privStartTime = startTime;
    }
}
module.exports.OCSPCacheEntryNeedsRefreshEvent = $030fadea4d85d091$var$OCSPCacheEntryNeedsRefreshEvent;
class $030fadea4d85d091$var$OCSPCacheHitEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(serialNumber, startTime, expireTime){
        super("OCSPCacheHitEvent", $dVTTx.EventType.Debug, serialNumber);
        this.privExpireTime = expireTime;
        this.privExpireTimeString = new Date(expireTime).toLocaleDateString();
        this.privStartTime = startTime;
        this.privStartTimeString = new Date(startTime).toLocaleTimeString();
    }
}
module.exports.OCSPCacheHitEvent = $030fadea4d85d091$var$OCSPCacheHitEvent;
class $030fadea4d85d091$var$OCSPVerificationFailedEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(serialNumber, error){
        super("OCSPVerificationFailedEvent", $dVTTx.EventType.Debug, serialNumber);
        this.privError = error;
    }
}
module.exports.OCSPVerificationFailedEvent = $030fadea4d85d091$var$OCSPVerificationFailedEvent;
class $030fadea4d85d091$var$OCSPCacheFetchErrorEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(serialNumber, error){
        super("OCSPCacheFetchErrorEvent", $dVTTx.EventType.Debug, serialNumber);
        this.privError = error;
    }
}
module.exports.OCSPCacheFetchErrorEvent = $030fadea4d85d091$var$OCSPCacheFetchErrorEvent;
class $030fadea4d85d091$var$OCSPResponseRetrievedEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(serialNumber){
        super("OCSPResponseRetrievedEvent", $dVTTx.EventType.Debug, serialNumber);
    }
}
module.exports.OCSPResponseRetrievedEvent = $030fadea4d85d091$var$OCSPResponseRetrievedEvent;
class $030fadea4d85d091$var$OCSPCacheUpdateErrorEvent extends $030fadea4d85d091$var$OCSPEvent {
    constructor(serialNumber, error){
        super("OCSPCacheUpdateErrorEvent", $dVTTx.EventType.Debug, serialNumber);
        this.privError = error;
    }
}
module.exports.OCSPCacheUpdateErrorEvent = $030fadea4d85d091$var$OCSPCacheUpdateErrorEvent;

});

parcelRegister("lWqSg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackgroundEvent = void 0;

var $5OUhN = parcelRequire("5OUhN");
class $ff93dc6908a54656$var$BackgroundEvent extends $5OUhN.PlatformEvent {
    constructor(error){
        super("BackgroundEvent", $5OUhN.EventType.Error);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}
module.exports.BackgroundEvent = $ff93dc6908a54656$var$BackgroundEvent;

});


parcelRegister("40Pvg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeaderNames = void 0;
class $2ebf1d02cdce8ed7$var$HeaderNames {
}
module.exports.HeaderNames = $2ebf1d02cdce8ed7$var$HeaderNames;
$2ebf1d02cdce8ed7$var$HeaderNames.AuthKey = "Ocp-Apim-Subscription-Key";
$2ebf1d02cdce8ed7$var$HeaderNames.Authorization = "Authorization";
$2ebf1d02cdce8ed7$var$HeaderNames.SpIDAuthKey = "Apim-Subscription-Id";
$2ebf1d02cdce8ed7$var$HeaderNames.ConnectionId = "X-ConnectionId";
$2ebf1d02cdce8ed7$var$HeaderNames.ContentType = "Content-Type";
$2ebf1d02cdce8ed7$var$HeaderNames.CustomCommandsAppId = "X-CommandsAppId";
$2ebf1d02cdce8ed7$var$HeaderNames.Path = "Path";
$2ebf1d02cdce8ed7$var$HeaderNames.RequestId = "X-RequestId";
$2ebf1d02cdce8ed7$var$HeaderNames.RequestStreamId = "X-StreamId";
$2ebf1d02cdce8ed7$var$HeaderNames.RequestTimestamp = "X-Timestamp";

});

parcelRegister("8YUMa", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthInfo = void 0;
class $689ff7daabb00893$var$AuthInfo {
    constructor(headerName, token){
        this.privHeaderName = headerName;
        this.privToken = token;
    }
    get headerName() {
        return this.privHeaderName;
    }
    get token() {
        return this.privToken;
    }
}
module.exports.AuthInfo = $689ff7daabb00893$var$AuthInfo;

});


parcelRegister("4t6tB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CognitiveTokenAuthentication = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $8YUMa = parcelRequire("8YUMa");

var $40Pvg = parcelRequire("40Pvg");
class $340ee4f178b929b7$var$CognitiveTokenAuthentication {
    constructor(fetchCallback, fetchOnExpiryCallback){
        if (!fetchCallback) throw new $5OUhN.ArgumentNullError("fetchCallback");
        if (!fetchOnExpiryCallback) throw new $5OUhN.ArgumentNullError("fetchOnExpiryCallback");
        this.privFetchCallback = fetchCallback;
        this.privFetchOnExpiryCallback = fetchOnExpiryCallback;
    }
    fetch(authFetchEventId) {
        return this.privFetchCallback(authFetchEventId).then((token)=>new $8YUMa.AuthInfo($40Pvg.HeaderNames.Authorization, token === undefined ? undefined : $340ee4f178b929b7$var$CognitiveTokenAuthentication.privTokenPrefix + token));
    }
    fetchOnExpiry(authFetchEventId) {
        return this.privFetchOnExpiryCallback(authFetchEventId).then((token)=>new $8YUMa.AuthInfo($40Pvg.HeaderNames.Authorization, token === undefined ? undefined : $340ee4f178b929b7$var$CognitiveTokenAuthentication.privTokenPrefix + token));
    }
}
module.exports.CognitiveTokenAuthentication = $340ee4f178b929b7$var$CognitiveTokenAuthentication;
$340ee4f178b929b7$var$CognitiveTokenAuthentication.privTokenPrefix = "Bearer ";

});

parcelRegister("8zICa", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cZtKQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5bgRq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionEndedEvent = module.exports.RecognitionCompletionStatus = module.exports.RecognitionStartedEvent = module.exports.ConnectingToServiceEvent = module.exports.ListeningStartedEvent = module.exports.RecognitionTriggeredEvent = module.exports.SpeechRecognitionEvent = void 0;

var $5OUhN = parcelRequire("5OUhN");
class $3c5b0efd67d2dee7$var$SpeechRecognitionEvent extends $5OUhN.PlatformEvent {
    constructor(eventName, requestId, sessionId, eventType = $5OUhN.EventType.Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
        this.privSessionId = sessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get sessionId() {
        return this.privSessionId;
    }
}
module.exports.SpeechRecognitionEvent = $3c5b0efd67d2dee7$var$SpeechRecognitionEvent;
class $3c5b0efd67d2dee7$var$RecognitionTriggeredEvent extends $3c5b0efd67d2dee7$var$SpeechRecognitionEvent {
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("RecognitionTriggeredEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
module.exports.RecognitionTriggeredEvent = $3c5b0efd67d2dee7$var$RecognitionTriggeredEvent;
class $3c5b0efd67d2dee7$var$ListeningStartedEvent extends $3c5b0efd67d2dee7$var$SpeechRecognitionEvent {
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("ListeningStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
module.exports.ListeningStartedEvent = $3c5b0efd67d2dee7$var$ListeningStartedEvent;
class $3c5b0efd67d2dee7$var$ConnectingToServiceEvent extends $3c5b0efd67d2dee7$var$SpeechRecognitionEvent {
    constructor(requestId, authFetchEventid, sessionId){
        super("ConnectingToServiceEvent", requestId, sessionId);
        this.privAuthFetchEventid = authFetchEventid;
    }
    get authFetchEventid() {
        return this.privAuthFetchEventid;
    }
}
module.exports.ConnectingToServiceEvent = $3c5b0efd67d2dee7$var$ConnectingToServiceEvent;
class $3c5b0efd67d2dee7$var$RecognitionStartedEvent extends $3c5b0efd67d2dee7$var$SpeechRecognitionEvent {
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId){
        super("RecognitionStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
module.exports.RecognitionStartedEvent = $3c5b0efd67d2dee7$var$RecognitionStartedEvent;
var $3c5b0efd67d2dee7$var$RecognitionCompletionStatus;
(function(RecognitionCompletionStatus) {
    RecognitionCompletionStatus[RecognitionCompletionStatus["Success"] = 0] = "Success";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceError"] = 1] = "AudioSourceError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceTimeout"] = 2] = "AudioSourceTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchError"] = 3] = "AuthTokenFetchError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchTimeout"] = 4] = "AuthTokenFetchTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnAuthorized"] = 5] = "UnAuthorized";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectTimeout"] = 6] = "ConnectTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectError"] = 7] = "ConnectError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ClientRecognitionActivityTimeout"] = 8] = "ClientRecognitionActivityTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnknownError"] = 9] = "UnknownError";
})($3c5b0efd67d2dee7$var$RecognitionCompletionStatus = module.exports.RecognitionCompletionStatus || (module.exports.RecognitionCompletionStatus = {}));
class $3c5b0efd67d2dee7$var$RecognitionEndedEvent extends $3c5b0efd67d2dee7$var$SpeechRecognitionEvent {
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId, serviceTag, status, error){
        super("RecognitionEndedEvent", requestId, sessionId, status === $3c5b0efd67d2dee7$var$RecognitionCompletionStatus.Success ? $5OUhN.EventType.Info : $5OUhN.EventType.Error);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
        this.privStatus = status;
        this.privError = error;
        this.privServiceTag = serviceTag;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
    get serviceTag() {
        return this.privServiceTag;
    }
    get status() {
        return this.privStatus;
    }
    get error() {
        return this.privError;
    }
}
module.exports.RecognitionEndedEvent = $3c5b0efd67d2dee7$var$RecognitionEndedEvent;

});

parcelRegister("lDTeU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceRecognizerBase = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $5OUhN = parcelRequire("5OUhN");

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");

var $ccM4b = parcelRequire("ccM4b");

var $kyLke = parcelRequire("kyLke");

var $6rQ2O = parcelRequire("6rQ2O");

var $WtAk0 = parcelRequire("WtAk0");

var $iYXZ1 = parcelRequire("iYXZ1");

var $asFUo = parcelRequire("asFUo");

var $9H0bk = parcelRequire("9H0bk");

var $4DFBe = parcelRequire("4DFBe");

var $inqHk = parcelRequire("inqHk");

var $jFIy8 = parcelRequire("jFIy8");

var $ioQxp = parcelRequire("ioQxp");
class $fc1816ed069b338f$var$ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        // A promise for a connection, but one that has not had the speech context sent yet.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionPromise = undefined;
        this.privSetTimeout = setTimeout;
        this.privIsLiveAudio = false;
        this.privAverageBytesPerMs = 0;
        this.privEnableSpeakerId = false;
        this.privExpectContentAssessmentResponse = false;
        this.recognizeOverride = undefined;
        this.disconnectOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.sendPrePayloadJSONOverride = undefined;
        this.postConnectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        this.handleSpeechPhraseMessage = undefined;
        this.handleSpeechHypothesisMessage = undefined;
        if (!authentication) throw new $5OUhN.ArgumentNullError("authentication");
        if (!connectionFactory) throw new $5OUhN.ArgumentNullError("connectionFactory");
        if (!audioSource) throw new $5OUhN.ArgumentNullError("audioSource");
        if (!recognizerConfig) throw new $5OUhN.ArgumentNullError("recognizerConfig");
        this.privEnableSpeakerId = recognizerConfig.isSpeakerDiarizationEnabled;
        this.privMustReportEndOfStream = false;
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privAudioSource = audioSource;
        this.privRecognizerConfig = recognizerConfig;
        this.privIsDisposed = false;
        this.privRecognizer = recognizer;
        this.privRequestSession = new $hgjD5.RequestSession(this.privAudioSource.id());
        this.privConnectionEvents = new $5OUhN.EventSource();
        this.privServiceEvents = new $5OUhN.EventSource();
        this.privDynamicGrammar = new $hgjD5.DynamicGrammarBuilder();
        this.privSpeechContext = new $hgjD5.SpeechContext(this.privDynamicGrammar);
        this.privAgentConfig = new $hgjD5.AgentConfig();
        const webWorkerLoadType = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.WebWorkerLoadType, "on").toLowerCase();
        if (webWorkerLoadType === "on" && typeof Blob !== "undefined" && typeof Worker !== "undefined") this.privSetTimeout = $5OUhN.Timeout.setTimeout;
        else {
            if (typeof window !== "undefined") // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privSetTimeout = window.setTimeout.bind(window);
            if (typeof globalThis !== "undefined") // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privSetTimeout = globalThis.setTimeout.bind(globalThis);
        }
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") {
                const connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode === 1003 || connectionClosedEvent.statusCode === 1007 || connectionClosedEvent.statusCode === 1002 || connectionClosedEvent.statusCode === 4000 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount) this.cancelRecognitionLocal($gttSn.CancellationReason.Error, connectionClosedEvent.statusCode === 1007 ? $gttSn.CancellationErrorCode.BadRequestParameters : $gttSn.CancellationErrorCode.ConnectionFailure, `${connectionClosedEvent.reason} websocket error code: ${connectionClosedEvent.statusCode}`);
            }
        });
        if (this.privEnableSpeakerId) this.privDiarizationSessionId = (0, $5OUhN.createNoDashGuid)();
    }
    setTranslationJson() {
        const targetLanguages = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined);
        if (targetLanguages !== undefined) {
            const languages = targetLanguages.split(",");
            const translationVoice = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
            const categoryId = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationCategoryId, undefined);
            const action = translationVoice !== undefined ? $WtAk0.NextAction.Synthesize : $WtAk0.NextAction.None;
            this.privSpeechContext.getContext().translation = {
                onPassthrough: {
                    action: action
                },
                onSuccess: {
                    action: action
                },
                output: {
                    includePassThroughResults: true,
                    interimResults: {
                        mode: $iYXZ1.Mode.Always
                    }
                },
                targetLanguages: languages
            };
            // Add category if specified
            if (categoryId !== undefined) this.privSpeechContext.getContext().translation.category = categoryId;
            if (translationVoice !== undefined) {
                const languageToVoiceMap = {};
                for (const lang of languages)languageToVoiceMap[lang] = translationVoice;
                this.privSpeechContext.getContext().synthesis = {
                    defaultVoices: languageToVoiceMap
                };
            }
            // Configure phrase detection for translation
            const phraseDetection = this.privSpeechContext.getContext().phraseDetection || {};
            phraseDetection.onSuccess = {
                action: $ioQxp.NextAction.Translate
            };
            phraseDetection.onInterim = {
                action: $ioQxp.NextAction.Translate
            };
            this.privSpeechContext.getContext().phraseDetection = phraseDetection;
        }
    }
    setSpeechSegmentationTimeoutJson() {
        const speechSegmentationSilenceTimeoutMs = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.Speech_SegmentationSilenceTimeoutMs, undefined);
        const speechSegmentationMaximumTimeMs = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.Speech_SegmentationMaximumTimeMs, undefined);
        const speechSegmentationStrategy = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.Speech_SegmentationStrategy, undefined);
        const segmentation = {
            mode: $kyLke.SegmentationMode.Normal
        };
        let configuredSegment = false;
        if (speechSegmentationStrategy !== undefined) {
            configuredSegment = true;
            let segMode = $kyLke.SegmentationMode.Normal;
            switch(speechSegmentationStrategy.toLowerCase()){
                case "default":
                    break;
                case "time":
                    segMode = $kyLke.SegmentationMode.Custom;
                    break;
                case "semantic":
                    segMode = $kyLke.SegmentationMode.Semantic;
                    break;
            }
            segmentation.mode = segMode;
        }
        if (speechSegmentationSilenceTimeoutMs !== undefined) {
            configuredSegment = true;
            const segmentationSilenceTimeoutMs = parseInt(speechSegmentationSilenceTimeoutMs, 10);
            segmentation.mode = $kyLke.SegmentationMode.Custom;
            segmentation.segmentationSilenceTimeoutMs = segmentationSilenceTimeoutMs;
        }
        if (speechSegmentationMaximumTimeMs !== undefined) {
            configuredSegment = true;
            const segmentationMaximumTimeMs = parseInt(speechSegmentationMaximumTimeMs, 10);
            segmentation.mode = $kyLke.SegmentationMode.Custom;
            segmentation.segmentationForcedTimeoutMs = segmentationMaximumTimeMs;
        }
        if (configuredSegment) {
            const phraseDetection = this.privSpeechContext.getContext().phraseDetection || {};
            phraseDetection.mode = this.recognitionMode;
            switch(this.recognitionMode){
                case $6rQ2O.RecognitionMode.Conversation:
                    phraseDetection.conversation = phraseDetection.conversation ?? {
                        segmentation: {}
                    };
                    phraseDetection.conversation.segmentation = segmentation;
                    break;
                case $6rQ2O.RecognitionMode.Interactive:
                    phraseDetection.interactive = phraseDetection.interactive ?? {
                        segmentation: {}
                    };
                    phraseDetection.interactive.segmentation = segmentation;
                    break;
                case $6rQ2O.RecognitionMode.Dictation:
                    phraseDetection.dictation = phraseDetection.dictation ?? {};
                    phraseDetection.dictation.segmentation = segmentation;
                    break;
            }
            this.privSpeechContext.getContext().phraseDetection = phraseDetection;
        }
    }
    setLanguageIdJson() {
        const phraseDetection = this.privSpeechContext.getContext().phraseDetection || {};
        if (this.privRecognizerConfig.autoDetectSourceLanguages !== undefined) {
            const sourceLanguages = this.privRecognizerConfig.autoDetectSourceLanguages.split(",");
            if (sourceLanguages.length === 1 && sourceLanguages[0] === $hgjD5.AutoDetectSourceLanguagesOpenRangeOptionName) sourceLanguages[0] = "UND";
            let speechContextLidMode;
            if (this.privRecognizerConfig.languageIdMode === "Continuous") speechContextLidMode = $asFUo.LanguageIdDetectionMode.DetectContinuous;
            else speechContextLidMode = $asFUo.LanguageIdDetectionMode.DetectAtAudioStart;
            this.privSpeechContext.getContext().languageId = {
                languages: sourceLanguages,
                mode: speechContextLidMode,
                onSuccess: {
                    action: $9H0bk.NextAction.Recognize
                },
                onUnknown: {
                    action: $4DFBe.OnUnknownAction.None
                },
                priority: $asFUo.LanguageIdDetectionPriority.PrioritizeLatency
            };
            this.privSpeechContext.getContext().phraseOutput = {
                interimResults: {
                    resultType: $inqHk.ResultType.Auto
                },
                phraseResults: {
                    resultType: $jFIy8.PhraseResultOutputType.Always
                }
            };
            const customModels = this.privRecognizerConfig.sourceLanguageModels;
            if (customModels !== undefined) {
                phraseDetection.customModels = customModels;
                phraseDetection.onInterim = {
                    action: $ioQxp.NextAction.None
                };
                phraseDetection.onSuccess = {
                    action: $ioQxp.NextAction.None
                };
            }
        }
        // No longer setting translation-specific configuration here
        // This is now handled in setTranslationJson and setupTranslationWithLanguageId methods
        this.privSpeechContext.getContext().phraseDetection = phraseDetection;
    }
    setOutputDetailLevelJson() {
        if (this.privEnableSpeakerId) {
            const requestWordLevelTimestamps = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase();
            if (requestWordLevelTimestamps === "true") this.privSpeechContext.setWordLevelTimings();
            else {
                const outputFormat = this.privRecognizerConfig.parameters.getProperty($hgjD5.OutputFormatPropertyName, $gttSn.OutputFormat[$gttSn.OutputFormat.Simple]).toLowerCase();
                if (outputFormat === $gttSn.OutputFormat[$gttSn.OutputFormat.Detailed].toLocaleLowerCase()) this.privSpeechContext.setDetailedOutputFormat();
            }
        }
    }
    setSpeechStartEventSensitivityJson() {
        const sensitivity = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.Speech_StartEventSensitivity, undefined);
        if (sensitivity !== undefined) {
            let configuredSensitivity = false;
            switch(sensitivity.toLowerCase()){
                case $6rQ2O.SpeechStartEventSensitivity.Low:
                case $6rQ2O.SpeechStartEventSensitivity.Medium:
                case $6rQ2O.SpeechStartEventSensitivity.High:
                    configuredSensitivity = true;
                    break;
            }
            if (configuredSensitivity) {
                const phraseDetection = this.privSpeechContext.getContext().phraseDetection || {};
                phraseDetection.voiceOnsetSensitivity = sensitivity.toLowerCase();
                this.privSpeechContext.getContext().phraseDetection = phraseDetection;
            }
        }
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    get audioSource() {
        return this.privAudioSource;
    }
    get speechContext() {
        return this.privSpeechContext;
    }
    get dynamicGrammar() {
        return this.privDynamicGrammar;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    set conversationTranslatorToken(token) {
        this.privRecognizerConfig.parameters.setProperty($gttSn.PropertyId.ConversationTranslator_Token, token);
    }
    set authentication(auth) {
        this.privAuthentication = auth;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    async dispose(reason) {
        this.privIsDisposed = true;
        if (this.privConnectionPromise !== undefined) try {
            const connection = await this.privConnectionPromise;
            await connection.dispose(reason);
        } catch (error) {
            // The connection is in a bad state. But we're trying to kill it, so...
            return;
        }
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    get recognitionMode() {
        return this.privRecognizerConfig.recognitionMode;
    }
    async recognize(recoMode, successCallback, errorCallBack) {
        if (this.recognizeOverride !== undefined) {
            await this.recognizeOverride(recoMode, successCallback, errorCallBack);
            return;
        }
        // Clear the existing configuration promise to force a re-transmission of config and context.
        this.privConnectionConfigurationPromise = undefined;
        this.privRecognizerConfig.recognitionMode = recoMode;
        if (this.privRecognizerConfig.recognitionEndpointVersion === "2") {
            const phraseDetection = this.privSpeechContext.getContext().phraseDetection || {};
            phraseDetection.mode = recoMode;
            this.privSpeechContext.getContext().phraseDetection = phraseDetection;
        }
        // Set language ID (if configured)
        this.setLanguageIdJson();
        // Then set translation (if configured)
        this.setTranslationJson();
        // Configure the integration between language ID and translation (if both are used)
        if (this.privRecognizerConfig.autoDetectSourceLanguages !== undefined && this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) this.setupTranslationWithLanguageId();
        this.setSpeechSegmentationTimeoutJson();
        this.setOutputDetailLevelJson();
        this.setSpeechStartEventSensitivityJson();
        this.privSuccessCallback = successCallback;
        this.privErrorCallback = errorCallBack;
        this.privRequestSession.startNewRecognition();
        this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        let audioNode;
        try {
            const audioStreamNode = await this.audioSource.attach(this.privRequestSession.audioNodeId);
            const format = await this.audioSource.format;
            const deviceInfo = await this.audioSource.deviceInfo;
            this.privIsLiveAudio = deviceInfo.type && deviceInfo.type === $hgjD5.type.Microphones;
            audioNode = new $s6RJO.ReplayableAudioNode(audioStreamNode, format.avgBytesPerSec);
            await this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
            this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: deviceInfo
            };
        } catch (error) {
            await this.privRequestSession.onStopRecognizing();
            throw error;
        }
        try {
            await conPromise;
        } catch (error) {
            await this.cancelRecognitionLocal($gttSn.CancellationReason.Error, $gttSn.CancellationErrorCode.ConnectionFailure, error);
            return;
        }
        const sessionStartEventArgs = new $gttSn.SessionEventArgs(this.privRequestSession.sessionId);
        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
        this.receiveMessage();
        const audioSendPromise = this.sendAudio(audioNode);
        audioSendPromise.catch(async (error)=>{
            await this.cancelRecognitionLocal($gttSn.CancellationReason.Error, $gttSn.CancellationErrorCode.RuntimeError, error);
        });
        return;
    }
    async stopRecognizing() {
        if (this.privRequestSession.isRecognizing) try {
            await this.audioSource.turnOff();
            await this.sendFinalAudio();
            await this.privRequestSession.onStopRecognizing();
            await this.privRequestSession.turnCompletionPromise;
        } finally{
            await this.privRequestSession.dispose();
        }
        return;
    }
    async connect() {
        await this.connectImpl();
        return Promise.resolve();
    }
    connectAsync(cb, err) {
        this.connectImpl().then(()=>{
            try {
                if (!!cb) cb();
            } catch (e) {
                if (!!err) err(e);
            }
        }, (reason)=>{
            try {
                if (!!err) err(reason);
            /* eslint-disable no-empty */ } catch (error) {}
        });
    }
    async disconnect() {
        await this.cancelRecognitionLocal($gttSn.CancellationReason.Error, $gttSn.CancellationErrorCode.NoError, "Disconnecting");
        if (this.disconnectOverride !== undefined) await this.disconnectOverride();
        if (this.privConnectionPromise !== undefined) try {
            await (await this.privConnectionPromise).dispose();
        } catch (error) {}
        this.privConnectionPromise = undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendMessage(message) {
        return;
    }
    async sendNetworkMessage(path, payload) {
        const type = typeof payload === "string" ? $5OUhN.MessageType.Text : $5OUhN.MessageType.Binary;
        const contentType = typeof payload === "string" ? "application/json" : "";
        const connection = await this.fetchConnection();
        return connection.send(new $ccM4b.SpeechConnectionMessage(type, path, this.privRequestSession.requestId, contentType, payload));
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    set expectContentAssessmentResponse(value) {
        this.privExpectContentAssessmentResponse = value;
    }
    async sendTelemetryData() {
        const telemetryData = this.privRequestSession.getTelemetry();
        if ($fc1816ed069b338f$var$ServiceRecognizerBase.telemetryDataEnabled !== true || this.privIsDisposed || null === telemetryData) return;
        if (!!$fc1816ed069b338f$var$ServiceRecognizerBase.telemetryData) try {
            $fc1816ed069b338f$var$ServiceRecognizerBase.telemetryData(telemetryData);
        /* eslint-disable no-empty */ } catch  {}
        const connection = await this.fetchConnection();
        await connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Text, "telemetry", this.privRequestSession.requestId, "application/json", telemetryData));
    }
    // Cancels recognition.
    async cancelRecognitionLocal(cancellationReason, errorCode, error) {
        if (!!this.privRequestSession.isRecognizing) {
            await this.privRequestSession.onStopRecognizing();
            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, cancellationReason, errorCode, error);
        }
    }
    async receiveMessage() {
        try {
            if (this.privIsDisposed) // We're done.
            return;
            let connection = await this.fetchConnection();
            const message = await connection.read();
            if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
            // indicates we are draining the queue and it came with no message;
            if (!message) return this.receiveMessage();
            this.privServiceHasSentMessage = true;
            const connectionMessage = $ccM4b.SpeechConnectionMessage.fromConnectionMessage(message);
            if (connectionMessage.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                case "turn.start":
                    this.privMustReportEndOfStream = true;
                    this.privRequestSession.onServiceTurnStartResponse();
                    break;
                case "speech.startdetected":
                    const speechStartDetected = $hgjD5.SpeechDetected.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset);
                    const speechStartEventArgs = new $gttSn.RecognitionEventArgs(speechStartDetected.Offset, this.privRequestSession.sessionId);
                    if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                    break;
                case "speech.enddetected":
                    let json;
                    if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                    else // If the request was empty, the JSON returned is empty.
                    json = "{ Offset: 0 }";
                    const speechStopDetected = $hgjD5.SpeechDetected.fromJSON(json, this.privRequestSession.currentTurnAudioOffset);
                    const speechStopEventArgs = new $gttSn.RecognitionEventArgs(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                    if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                    break;
                case "turn.end":
                    await this.sendTelemetryData();
                    if (this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream) {
                        this.privMustReportEndOfStream = false;
                        await this.cancelRecognitionLocal($gttSn.CancellationReason.EndOfStream, $gttSn.CancellationErrorCode.NoError, undefined);
                    }
                    const sessionStopEventArgs = new $gttSn.SessionEventArgs(this.privRequestSession.sessionId);
                    await this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition);
                    if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                        if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                        return;
                    } else {
                        connection = await this.fetchConnection();
                        await this.sendPrePayloadJSON(connection);
                    }
                    break;
                default:
                    if (!await this.processTypeSpecificMessages(connectionMessage)) // here are some messages that the derived class has not processed, dispatch them to connect class
                    {
                        if (!!this.privServiceEvents) this.serviceEvents.onEvent(new $5OUhN.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                    }
            }
            return this.receiveMessage();
        } catch (error) {
            return null;
        }
    }
    updateSpeakerDiarizationAudioOffset() {
        const bytesSent = this.privRequestSession.recognitionBytesSent;
        const audioOffsetMs = this.privAverageBytesPerMs !== 0 ? bytesSent / this.privAverageBytesPerMs : 0;
        this.privSpeechContext.setSpeakerDiarizationAudioOffsetMs(audioOffsetMs);
    }
    sendSpeechContext(connection, generateNewRequestId) {
        if (this.privEnableSpeakerId) this.updateSpeakerDiarizationAudioOffset();
        const speechContextJson = this.speechContext.toJSON();
        if (generateNewRequestId) this.privRequestSession.onSpeechContext();
        if (speechContextJson) return connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Text, "speech.context", this.privRequestSession.requestId, "application/json", speechContextJson));
        return;
    }
    setupTranslationWithLanguageId() {
        const targetLanguages = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined);
        const hasLanguageId = this.privRecognizerConfig.autoDetectSourceLanguages !== undefined;
        if (targetLanguages !== undefined && hasLanguageId) {
            // Configure phraseOutput for translation + language ID scenario
            this.privSpeechContext.getContext().phraseOutput = {
                interimResults: {
                    resultType: $inqHk.ResultType.None
                },
                phraseResults: {
                    resultType: $jFIy8.PhraseResultOutputType.None
                }
            };
            // Handle custom language models and voice mapping
            const translationContext = this.privSpeechContext.getContext().translation;
            if (translationContext) {
                const customModels = this.privRecognizerConfig.sourceLanguageModels;
                if (customModels !== undefined && customModels.length > 0) {
                    const phraseDetection = this.privSpeechContext.getContext().phraseDetection || {};
                    phraseDetection.customModels = customModels;
                    this.privSpeechContext.getContext().phraseDetection = phraseDetection;
                }
                const translationVoice = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
                if (translationVoice !== undefined) {
                    // Update translation actions for synthesis
                    translationContext.onSuccess = {
                        action: $WtAk0.NextAction.Synthesize
                    };
                    translationContext.onPassthrough = {
                        action: $WtAk0.NextAction.Synthesize
                    };
                }
            }
        }
    }
    noOp() {
        // operation not supported
        return;
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    async sendPrePayloadJSON(connection, generateNewRequestId = true) {
        if (this.sendPrePayloadJSONOverride !== undefined) return this.sendPrePayloadJSONOverride(connection);
        await this.sendSpeechContext(connection, generateNewRequestId);
        await this.sendWaveHeader(connection);
        return;
    }
    async sendWaveHeader(connection) {
        const format = await this.audioSource.format;
        // this.writeBufferToConsole(format.header);
        return connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", format.header));
    }
    // Establishes a websocket connection to the end point.
    connectImpl() {
        if (this.privConnectionPromise !== undefined) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === $5OUhN.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = undefined;
                this.privServiceHasSentMessage = false;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionPromise = undefined;
            this.privServiceHasSentMessage = false;
            return this.connectImpl();
        });
        this.privConnectionPromise = this.retryableConnect();
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(()=>{});
        if (this.postConnectImplOverride !== undefined) return this.postConnectImplOverride(this.privConnectionPromise);
        return this.privConnectionPromise;
    }
    sendSpeechServiceConfig(connection, requestSession, SpeechServiceConfigJson) {
        requestSession.onSpeechContext();
        // filter out anything that is not required for the service to work.
        if ($fc1816ed069b338f$var$ServiceRecognizerBase.telemetryDataEnabled !== true) {
            const withTelemetry = JSON.parse(SpeechServiceConfigJson);
            const replacement = {
                context: {
                    system: withTelemetry.context.system
                }
            };
            SpeechServiceConfigJson = JSON.stringify(replacement);
        }
        if (this.privRecognizerConfig.parameters.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() === "true") {
            const json = JSON.parse(SpeechServiceConfigJson);
            json.context.DisableReferenceChannel = "True";
            json.context.MicSpec = "1_0_0";
            SpeechServiceConfigJson = JSON.stringify(json);
        }
        if (SpeechServiceConfigJson) return connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Text, "speech.config", requestSession.requestId, "application/json", SpeechServiceConfigJson));
        return;
    }
    async fetchConnection() {
        if (this.privConnectionConfigurationPromise !== undefined) return this.privConnectionConfigurationPromise.then((connection)=>{
            if (connection.state() === $5OUhN.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = undefined;
                this.privServiceHasSentMessage = false;
                return this.fetchConnection();
            }
            return this.privConnectionConfigurationPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionConfigurationPromise = undefined;
            this.privServiceHasSentMessage = false;
            return this.fetchConnection();
        });
        this.privConnectionConfigurationPromise = this.configureConnection();
        return await this.privConnectionConfigurationPromise;
    }
    async sendAudio(audioStreamNode) {
        const audioFormat = await this.audioSource.format;
        this.privAverageBytesPerMs = audioFormat.avgBytesPerSec / 1000;
        // The time we last sent data to the service.
        let nextSendTime = Date.now();
        // Max amount to send before we start to throttle
        const fastLaneSizeMs = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000");
        const maxSendUnthrottledBytes = audioFormat.avgBytesPerSec / 1000 * parseInt(fastLaneSizeMs, 10);
        const startRecogNumber = this.privRequestSession.recogNumber;
        const readAndUploadCycle = async ()=>{
            // If speech is done, stop sending audio.
            if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                const connection = await this.fetchConnection();
                const audioStreamChunk = await audioStreamNode.read();
                // we have a new audio chunk to upload.
                if (this.privRequestSession.isSpeechEnded) // If service already recognized audio end then don't send any more audio
                return;
                let payload;
                let sendDelay;
                if (!audioStreamChunk || audioStreamChunk.isEnd) {
                    payload = null;
                    sendDelay = 0;
                } else {
                    payload = audioStreamChunk.buffer;
                    this.privRequestSession.onAudioSent(payload.byteLength);
                    if (maxSendUnthrottledBytes >= this.privRequestSession.bytesSent) sendDelay = 0;
                    else sendDelay = Math.max(0, nextSendTime - Date.now());
                }
                if (0 !== sendDelay) await this.delay(sendDelay);
                if (payload !== null) nextSendTime = Date.now() + payload.byteLength * 1000 / (audioFormat.avgBytesPerSec * 2);
                // Are we still alive?
                if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                    connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Binary, "audio", this.privRequestSession.requestId, null, payload)).catch(()=>{
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition).catch(()=>{});
                    });
                    if (!audioStreamChunk?.isEnd) // this.writeBufferToConsole(payload);
                    // Regardless of success or failure, schedule the next upload.
                    // If the underlying connection was broken, the next cycle will
                    // get a new connection and re-transmit missing audio automatically.
                    return readAndUploadCycle();
                    else // the audio stream has been closed, no need to schedule next
                    // read-upload cycle.
                    if (!this.privIsLiveAudio) this.privRequestSession.onSpeechEnded();
                }
            }
        };
        return readAndUploadCycle();
    }
    async retryableConnect() {
        let isUnAuthorized = false;
        this.privAuthFetchEventId = (0, $5OUhN.createNoDashGuid)();
        const sessionId = this.privRequestSession.sessionId;
        this.privConnectionId = sessionId !== undefined ? sessionId : (0, $5OUhN.createNoDashGuid)();
        this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
        let lastStatusCode = 0;
        let lastReason = "";
        while(this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount){
            this.privRequestSession.onRetryConnection();
            // Get the auth information for the connection. This is a bit of overkill for the current API surface, but leaving the plumbing in place to be able to raise a developer-customer
            // facing event when a connection fails to let them try and provide new auth information.
            const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
            const auth = await authPromise;
            await this.privRequestSession.onAuthCompleted(false);
            // Create the connection
            const connection = await this.privConnectionFactory.create(this.privRecognizerConfig, auth, this.privConnectionId);
            // Attach the telemetry handlers.
            this.privRequestSession.listenForServiceTelemetry(connection.events);
            // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
            // it'll stop sending events.
            connection.events.attach((event)=>{
                this.connectionEvents.onEvent(event);
            });
            const response = await connection.open();
            // 200 == everything is fine.
            if (response.statusCode === 200) {
                await this.privRequestSession.onConnectionEstablishCompleted(response.statusCode);
                return Promise.resolve(connection);
            } else if (response.statusCode === 1006) isUnAuthorized = true;
            lastStatusCode = response.statusCode;
            lastReason = response.reason;
        }
        await this.privRequestSession.onConnectionEstablishCompleted(lastStatusCode, lastReason);
        return Promise.reject(`Unable to contact server. StatusCode: ${lastStatusCode}, ${this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint)} Reason: ${lastReason}`);
    }
    delay(delayMs) {
        return new Promise((resolve)=>this.privSetTimeout(resolve, delayMs));
    }
    writeBufferToConsole(buffer) {
        let out = "Buffer Size: ";
        if (null === buffer) out += "null";
        else {
            const readView = new Uint8Array(buffer);
            out += `${buffer.byteLength}\r\n`;
            for(let i = 0; i < buffer.byteLength; i++){
                out += readView[i].toString(16).padStart(2, "0") + " ";
                if ((i + 1) % 16 === 0) {
                    // eslint-disable-next-line no-console
                    console.info(out);
                    out = "";
                }
            }
        }
        // eslint-disable-next-line no-console
        console.info(out);
    }
    async sendFinalAudio() {
        const connection = await this.fetchConnection();
        await connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Binary, "audio", this.privRequestSession.requestId, null, null));
        return;
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configureConnection() {
        const connection = await this.connectImpl();
        if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
        await this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize());
        await this.sendPrePayloadJSON(connection, false);
        return connection;
    }
}
module.exports.ServiceRecognizerBase = $fc1816ed069b338f$var$ServiceRecognizerBase;
$fc1816ed069b338f$var$ServiceRecognizerBase.telemetryDataEnabled = true;

});
parcelRegister("s6RJO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $0547f10872e59a26$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0547f10872e59a26$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0547f10872e59a26$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0547f10872e59a26$var$__exportStar((parcelRequire("LNF3F")), module.exports);

$0547f10872e59a26$var$__exportStar((parcelRequire("3fCzx")), module.exports);

$0547f10872e59a26$var$__exportStar((parcelRequire("7uZTa")), module.exports);

$0547f10872e59a26$var$__exportStar((parcelRequire("7rsPH")), module.exports);

$0547f10872e59a26$var$__exportStar((parcelRequire("38XBR")), module.exports);

$0547f10872e59a26$var$__exportStar((parcelRequire("4MedZ")), module.exports);

$0547f10872e59a26$var$__exportStar((parcelRequire("kvQYc")), module.exports);

$0547f10872e59a26$var$__exportStar((parcelRequire("k2jz9")), module.exports);

$0547f10872e59a26$var$__exportStar((parcelRequire("bRS6a")), module.exports);

$0547f10872e59a26$var$__exportStar((parcelRequire("lfoMA")), module.exports);

$0547f10872e59a26$var$__exportStar((parcelRequire("cTQ6R")), module.exports);

});
parcelRegister("LNF3F", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $08fae9960e5d4966$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $08fae9960e5d4966$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $08fae9960e5d4966$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $08fae9960e5d4966$var$__createBinding(result, mod, k);
    }
    $08fae9960e5d4966$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleLoggingListener = void 0;

const $08fae9960e5d4966$var$fs = $08fae9960e5d4966$var$__importStar((parcelRequire("9zn7p")));

var $aAcmn = parcelRequire("aAcmn");

var $3SMEZ = parcelRequire("3SMEZ");
class $08fae9960e5d4966$var$ConsoleLoggingListener {
    constructor(logLevelFilter = $aAcmn.LogLevel.None){
        this.privLogPath = undefined;
        this.privEnableConsoleOutput = true;
        this.privLogLevelFilter = logLevelFilter;
    }
    set logPath(path) {
        $3SMEZ.Contracts.throwIfNullOrUndefined($08fae9960e5d4966$var$fs.openSync, "\nFile System access not available");
        this.privLogPath = path;
    }
    set enableConsoleOutput(enableOutput) {
        this.privEnableConsoleOutput = enableOutput;
    }
    onEvent(event) {
        if (event.eventType >= this.privLogLevelFilter) {
            const log = this.toString(event);
            if (!!this.logCallback) this.logCallback(log);
            if (!!this.privLogPath) $08fae9960e5d4966$var$fs.writeFileSync(this.privLogPath, log + "\n", {
                flag: "a+"
            });
            if (this.privEnableConsoleOutput) switch(event.eventType){
                case $aAcmn.LogLevel.Debug:
                    // eslint-disable-next-line no-console
                    console.debug(log);
                    break;
                case $aAcmn.LogLevel.Info:
                    // eslint-disable-next-line no-console
                    console.info(log);
                    break;
                case $aAcmn.LogLevel.Warning:
                    // eslint-disable-next-line no-console
                    console.warn(log);
                    break;
                case $aAcmn.LogLevel.Error:
                    // eslint-disable-next-line no-console
                    console.error(log);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.log(log);
                    break;
            }
        }
    }
    toString(event) {
        const logFragments = [
            `${event.eventTime}`,
            `${event.name}`
        ];
        const e = event;
        for(const prop in e)if (prop && event.hasOwnProperty(prop) && prop !== "eventTime" && prop !== "eventType" && prop !== "eventId" && prop !== "name" && prop !== "constructor") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            const value = e[prop];
            let valueToLog = "<NULL>";
            if (value !== undefined && value !== null) {
                if (typeof value === "number" || typeof value === "string") valueToLog = value.toString();
                else valueToLog = JSON.stringify(value);
            }
            logFragments.push(`${prop}: ${valueToLog}`);
        }
        return logFragments.join(" | ");
    }
}
module.exports.ConsoleLoggingListener = $08fae9960e5d4966$var$ConsoleLoggingListener;

});
parcelRegister("9zn7p", function(module, exports) {
"use strict";

});

parcelRegister("aAcmn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogLevel = void 0;

var $5OUhN = parcelRequire("5OUhN");
Object.defineProperty(module.exports, "LogLevel", {
    enumerable: true,
    get: function() {
        return $5OUhN.EventType;
    }
});

});

parcelRegister("3SMEZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Contracts = void 0;
/**
 * @class Contracts
 * @private
 */ class $2d3c291d0e7973d0$var$Contracts {
    static throwIfNullOrUndefined(param, name) {
        if (param === undefined || param === null) throw new Error("throwIfNullOrUndefined:" + name);
    }
    static throwIfNull(param, name) {
        if (param === null) throw new Error("throwIfNull:" + name);
    }
    static throwIfNullOrWhitespace(param, name) {
        $2d3c291d0e7973d0$var$Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).trim().length < 1) throw new Error("throwIfNullOrWhitespace:" + name);
    }
    static throwIfNullOrTooLong(param, name, maxLength) {
        $2d3c291d0e7973d0$var$Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).length > maxLength) throw new Error("throwIfNullOrTooLong:" + name + " (more than " + maxLength.toString() + " characters)");
    }
    static throwIfNullOrTooShort(param, name, minLength) {
        $2d3c291d0e7973d0$var$Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).length < minLength) throw new Error("throwIfNullOrTooShort:" + name + " (less than " + minLength.toString() + " characters)");
    }
    static throwIfDisposed(isDisposed) {
        if (isDisposed) throw new Error("the object is already disposed");
    }
    static throwIfArrayEmptyOrWhitespace(array, name) {
        $2d3c291d0e7973d0$var$Contracts.throwIfNullOrUndefined(array, name);
        if (array.length === 0) throw new Error("throwIfArrayEmptyOrWhitespace:" + name);
        for (const item of array)$2d3c291d0e7973d0$var$Contracts.throwIfNullOrWhitespace(item, name);
    }
    static throwIfFileDoesNotExist(param, name) {
        $2d3c291d0e7973d0$var$Contracts.throwIfNullOrWhitespace(param, name);
    // TODO check for file existence.
    }
    static throwIfNotUndefined(param, name) {
        if (param !== undefined) throw new Error("throwIfNotUndefined:" + name);
    }
    static throwIfNumberOutOfRange(value, name, rangeStart, rangeEnd) {
        $2d3c291d0e7973d0$var$Contracts.throwIfNullOrUndefined(value, name);
        if (value < rangeStart || value > rangeEnd) throw new Error("throwIfNumberOutOfRange:" + name + " (must be between " + rangeStart.toString() + " and " + rangeEnd.toString() + ")");
    }
}
module.exports.Contracts = $2d3c291d0e7973d0$var$Contracts;

});


parcelRegister("3fCzx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7uZTa", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MicAudioSource = module.exports.AudioWorkletSourceURLPropertyName = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $hzVTX = parcelRequire("hzVTX");
module.exports.AudioWorkletSourceURLPropertyName = "MICROPHONE-WorkletSourceUrl";
class $575b579640329ac7$var$MicAudioSource {
    constructor(privRecorder, deviceId, audioSourceId, mediaStream){
        this.privRecorder = privRecorder;
        this.deviceId = deviceId;
        this.privStreams = {};
        this.privOutputChunkSize = $575b579640329ac7$var$MicAudioSource.AUDIOFORMAT.avgBytesPerSec / 10;
        this.privId = audioSourceId ? audioSourceId : (0, $5OUhN.createNoDashGuid)();
        this.privEvents = new $5OUhN.EventSource();
        this.privMediaStream = mediaStream || null;
        this.privIsClosing = false;
    }
    get format() {
        return Promise.resolve($575b579640329ac7$var$MicAudioSource.AUDIOFORMAT);
    }
    turnOn() {
        if (this.privInitializeDeferral) return this.privInitializeDeferral.promise;
        this.privInitializeDeferral = new $5OUhN.Deferred();
        try {
            this.createAudioContext();
        } catch (error) {
            if (error instanceof Error) {
                const typedError = error;
                this.privInitializeDeferral.reject(typedError.name + ": " + typedError.message);
            } else this.privInitializeDeferral.reject(error);
            return this.privInitializeDeferral.promise;
        }
        const nav = window.navigator;
        let getUserMedia = // eslint-disable-next-line
        nav.getUserMedia || nav.webkitGetUserMedia || nav.mozGetUserMedia || nav.msGetUserMedia;
        if (!!nav.mediaDevices) getUserMedia = (constraints, successCallback, errorCallback)=>{
            nav.mediaDevices.getUserMedia(constraints).then(successCallback).catch(errorCallback);
        };
        if (!getUserMedia) {
            const errorMsg = "Browser does not support getUserMedia.";
            this.privInitializeDeferral.reject(errorMsg);
            this.onEvent(new $5OUhN.AudioSourceErrorEvent(errorMsg, "")); // mic initialized error - no streamid at this point
        } else {
            const next = ()=>{
                this.onEvent(new $5OUhN.AudioSourceInitializingEvent(this.privId)); // no stream id
                if (this.privMediaStream && this.privMediaStream.active) {
                    this.onEvent(new $5OUhN.AudioSourceReadyEvent(this.privId));
                    this.privInitializeDeferral.resolve();
                } else getUserMedia({
                    audio: this.deviceId ? {
                        deviceId: this.deviceId
                    } : true,
                    video: false
                }, (mediaStream)=>{
                    this.privMediaStream = mediaStream;
                    this.onEvent(new $5OUhN.AudioSourceReadyEvent(this.privId));
                    this.privInitializeDeferral.resolve();
                }, (error)=>{
                    const errorMsg = `Error occurred during microphone initialization: ${error}`;
                    this.privInitializeDeferral.reject(errorMsg);
                    this.onEvent(new $5OUhN.AudioSourceErrorEvent(this.privId, errorMsg));
                });
            };
            if (this.privContext.state === "suspended") // NOTE: On iOS, the Web Audio API requires sounds to be triggered from an explicit user action.
            // https://github.com/WebAudio/web-audio-api/issues/790
            this.privContext.resume().then(next).catch((reason)=>{
                this.privInitializeDeferral.reject(`Failed to initialize audio context: ${reason}`);
            });
            else next();
        }
        return this.privInitializeDeferral.promise;
    }
    id() {
        return this.privId;
    }
    attach(audioNodeId) {
        this.onEvent(new $5OUhN.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        return this.listen(audioNodeId).then((stream)=>{
            this.onEvent(new $5OUhN.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
            return {
                detach: async ()=>{
                    stream.readEnded();
                    delete this.privStreams[audioNodeId];
                    this.onEvent(new $5OUhN.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                    return this.turnOff();
                },
                id: ()=>audioNodeId,
                read: ()=>stream.read()
            };
        });
    }
    detach(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new $5OUhN.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
        }
    }
    async turnOff() {
        for(const streamId in this.privStreams)if (streamId) {
            const stream = this.privStreams[streamId];
            if (stream) stream.close();
        }
        this.onEvent(new $5OUhN.AudioSourceOffEvent(this.privId)); // no stream now
        if (this.privInitializeDeferral) {
            // Correctly handle when browser forces mic off before turnOn() completes
            // eslint-disable-next-line @typescript-eslint/await-thenable
            await this.privInitializeDeferral;
            this.privInitializeDeferral = null;
        }
        await this.destroyAudioContext();
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.getMicrophoneLabel().then((label)=>({
                bitspersample: $575b579640329ac7$var$MicAudioSource.AUDIOFORMAT.bitsPerSample,
                channelcount: $575b579640329ac7$var$MicAudioSource.AUDIOFORMAT.channels,
                connectivity: $hgjD5.connectivity.Unknown,
                manufacturer: "Speech SDK",
                model: label,
                samplerate: $575b579640329ac7$var$MicAudioSource.AUDIOFORMAT.samplesPerSec,
                type: $hgjD5.type.Microphones
            }));
    }
    setProperty(name, value) {
        if (name === module.exports.AudioWorkletSourceURLPropertyName) this.privRecorder.setWorkletUrl(value);
        else throw new Error("Property '" + name + "' is not supported on Microphone.");
    }
    getMicrophoneLabel() {
        const defaultMicrophoneName = "microphone";
        // If we did this already, return the value.
        if (this.privMicrophoneLabel !== undefined) return Promise.resolve(this.privMicrophoneLabel);
        // If the stream isn't currently running, we can't query devices because security.
        if (this.privMediaStream === undefined || !this.privMediaStream.active) return Promise.resolve(defaultMicrophoneName);
        // Setup a default
        this.privMicrophoneLabel = defaultMicrophoneName;
        // Get the id of the device running the audio track.
        const microphoneDeviceId = this.privMediaStream.getTracks()[0].getSettings().deviceId;
        // If the browser doesn't support getting the device ID, set a default and return.
        if (undefined === microphoneDeviceId) return Promise.resolve(this.privMicrophoneLabel);
        const deferred = new $5OUhN.Deferred();
        // Enumerate the media devices.
        navigator.mediaDevices.enumerateDevices().then((devices)=>{
            for (const device of devices)if (device.deviceId === microphoneDeviceId) {
                // Found the device
                this.privMicrophoneLabel = device.label;
                break;
            }
            deferred.resolve(this.privMicrophoneLabel);
        }, ()=>deferred.resolve(this.privMicrophoneLabel));
        return deferred.promise;
    }
    async listen(audioNodeId) {
        await this.turnOn();
        const stream = new $5OUhN.ChunkedArrayBufferStream(this.privOutputChunkSize, audioNodeId);
        this.privStreams[audioNodeId] = stream;
        try {
            this.privRecorder.record(this.privContext, this.privMediaStream, stream);
        } catch (error) {
            this.onEvent(new $5OUhN.AudioStreamNodeErrorEvent(this.privId, audioNodeId, error));
            throw error;
        }
        const result = stream;
        return result;
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $5OUhN.Events.instance.onEvent(event);
    }
    createAudioContext() {
        if (!!this.privContext) return;
        this.privContext = $hzVTX.AudioStreamFormatImpl.getAudioContext($575b579640329ac7$var$MicAudioSource.AUDIOFORMAT.samplesPerSec);
    }
    async destroyAudioContext() {
        if (!this.privContext) return;
        this.privRecorder.releaseMediaResources(this.privContext);
        // This pattern brought to you by a bug in the TypeScript compiler where it
        // confuses the ("close" in this.privContext) with this.privContext always being null as the alternate.
        // https://github.com/Microsoft/TypeScript/issues/11498
        let hasClose = false;
        if ("close" in this.privContext) hasClose = true;
        if (hasClose) {
            if (!this.privIsClosing) {
                // The audio context close may take enough time that the close is called twice
                this.privIsClosing = true;
                await this.privContext.close();
                this.privContext = null;
                this.privIsClosing = false;
            }
        } else if (null !== this.privContext && this.privContext.state === "running") // Suspend actually takes a callback, but analogous to the
        // resume method, it'll be only fired if suspend is called
        // in a direct response to a user action. The later is not always
        // the case, as TurnOff is also called, when we receive an
        // end-of-speech message from the service. So, doing a best effort
        // fire-and-forget here.
        await this.privContext.suspend();
    }
}
module.exports.MicAudioSource = $575b579640329ac7$var$MicAudioSource;
$575b579640329ac7$var$MicAudioSource.AUDIOFORMAT = $hzVTX.AudioStreamFormat.getDefaultInputFormat();

});
parcelRegister("hzVTX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioStreamFormatImpl = module.exports.AudioStreamFormat = module.exports.AudioFormatTag = void 0;
// eslint-disable-next-line max-classes-per-file
var $ccc29e9c8d1f38e2$var$AudioFormatTag;
(function(AudioFormatTag) {
    AudioFormatTag[AudioFormatTag["PCM"] = 1] = "PCM";
    AudioFormatTag[AudioFormatTag["MuLaw"] = 2] = "MuLaw";
    AudioFormatTag[AudioFormatTag["Siren"] = 3] = "Siren";
    AudioFormatTag[AudioFormatTag["MP3"] = 4] = "MP3";
    AudioFormatTag[AudioFormatTag["SILKSkype"] = 5] = "SILKSkype";
    AudioFormatTag[AudioFormatTag["OGG_OPUS"] = 6] = "OGG_OPUS";
    AudioFormatTag[AudioFormatTag["WEBM_OPUS"] = 7] = "WEBM_OPUS";
    AudioFormatTag[AudioFormatTag["ALaw"] = 8] = "ALaw";
    AudioFormatTag[AudioFormatTag["FLAC"] = 9] = "FLAC";
    AudioFormatTag[AudioFormatTag["OPUS"] = 10] = "OPUS";
    AudioFormatTag[AudioFormatTag["AMR_WB"] = 11] = "AMR_WB";
    AudioFormatTag[AudioFormatTag["G722"] = 12] = "G722";
})($ccc29e9c8d1f38e2$var$AudioFormatTag = module.exports.AudioFormatTag || (module.exports.AudioFormatTag = {}));
/**
 * Represents audio stream format used for custom audio input configurations.
 * @class AudioStreamFormat
 */ class $ccc29e9c8d1f38e2$var$AudioStreamFormat {
    /**
     * Creates an audio stream format object representing the default audio stream
     * format (16KHz 16bit mono PCM).
     * @member AudioStreamFormat.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getDefaultInputFormat() {
        return $ccc29e9c8d1f38e2$var$AudioStreamFormatImpl.getDefaultInputFormat();
    }
    /**
     * Creates an audio stream format object with the specified format characteristics.
     * @member AudioStreamFormat.getWaveFormat
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getWaveFormat(samplesPerSecond, bitsPerSample, channels, format) {
        return new $ccc29e9c8d1f38e2$var$AudioStreamFormatImpl(samplesPerSecond, bitsPerSample, channels, format);
    }
    /**
     * Creates an audio stream format object with the specified pcm waveformat characteristics.
     * @member AudioStreamFormat.getWaveFormatPCM
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getWaveFormatPCM(samplesPerSecond, bitsPerSample, channels) {
        return new $ccc29e9c8d1f38e2$var$AudioStreamFormatImpl(samplesPerSecond, bitsPerSample, channels);
    }
}
module.exports.AudioStreamFormat = $ccc29e9c8d1f38e2$var$AudioStreamFormat;
/**
 * @private
 * @class AudioStreamFormatImpl
 */ class $ccc29e9c8d1f38e2$var$AudioStreamFormatImpl extends $ccc29e9c8d1f38e2$var$AudioStreamFormat {
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {number} channels - Number of channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     */ constructor(samplesPerSec = 16000, bitsPerSample = 16, channels = 1, format = $ccc29e9c8d1f38e2$var$AudioFormatTag.PCM){
        super();
        let isWavFormat = true;
        /* 1 for PCM; 6 for alaw; 7 for mulaw */ switch(format){
            case $ccc29e9c8d1f38e2$var$AudioFormatTag.PCM:
                this.formatTag = 1;
                break;
            case $ccc29e9c8d1f38e2$var$AudioFormatTag.ALaw:
                this.formatTag = 6;
                break;
            case $ccc29e9c8d1f38e2$var$AudioFormatTag.MuLaw:
                this.formatTag = 7;
                break;
            default:
                isWavFormat = false;
        }
        this.bitsPerSample = bitsPerSample;
        this.samplesPerSec = samplesPerSec;
        this.channels = channels;
        this.avgBytesPerSec = this.samplesPerSec * this.channels * (this.bitsPerSample / 8);
        this.blockAlign = this.channels * Math.max(this.bitsPerSample, 8);
        if (isWavFormat) {
            this.privHeader = new ArrayBuffer(44);
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DataView
            const view = new DataView(this.privHeader);
            /* RIFF identifier */ this.setString(view, 0, "RIFF");
            /* file length */ view.setUint32(4, 0, true);
            /* RIFF type & Format */ this.setString(view, 8, "WAVEfmt ");
            /* format chunk length */ view.setUint32(16, 16, true);
            /* audio format */ view.setUint16(20, this.formatTag, true);
            /* channel count */ view.setUint16(22, this.channels, true);
            /* sample rate */ view.setUint32(24, this.samplesPerSec, true);
            /* byte rate (sample rate * block align) */ view.setUint32(28, this.avgBytesPerSec, true);
            /* block align (channel count * bytes per sample) */ view.setUint16(32, this.channels * (this.bitsPerSample / 8), true);
            /* bits per sample */ view.setUint16(34, this.bitsPerSample, true);
            /* data chunk identifier */ this.setString(view, 36, "data");
            /* data chunk length */ view.setUint32(40, 0, true);
        }
    }
    /**
     * Retrieves the default input format.
     * @member AudioStreamFormatImpl.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormatImpl} The default input format.
     */ static getDefaultInputFormat() {
        return new $ccc29e9c8d1f38e2$var$AudioStreamFormatImpl();
    }
    /**
     * Creates an audio context appropriate to current browser
     * @member AudioStreamFormatImpl.getAudioContext
     * @function
     * @public
     * @returns {AudioContext} An audio context instance
     */ /* eslint-disable */ static getAudioContext(sampleRate) {
        // Workaround for Speech SDK bug in Safari.
        const AudioContext = window.AudioContext // our preferred impl
         || window.webkitAudioContext // fallback, mostly when on Safari
         || false; // could not find.
        // https://developer.mozilla.org/en-US/docs/Web/API/AudioContext
        if (!!AudioContext) {
            if (sampleRate !== undefined && navigator.mediaDevices.getSupportedConstraints().sampleRate) return new AudioContext({
                sampleRate: sampleRate
            });
            else return new AudioContext();
        } else throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    }
    /* eslint-enable */ /**
     * Closes the configuration object.
     * @member AudioStreamFormatImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
    get header() {
        return this.privHeader;
    }
    setString(view, offset, str) {
        for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    }
}
module.exports.AudioStreamFormatImpl = $ccc29e9c8d1f38e2$var$AudioStreamFormatImpl;

});


parcelRegister("7rsPH", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FileAudioSource = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $hzVTX = parcelRequire("hzVTX");
class $56b16b9bd5156b0e$var$FileAudioSource {
    constructor(file, filename, audioSourceId){
        this.privStreams = {};
        this.privHeaderEnd = 44;
        this.privId = audioSourceId ? audioSourceId : (0, $5OUhN.createNoDashGuid)();
        this.privEvents = new $5OUhN.EventSource();
        this.privSource = file;
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && this.privSource instanceof Blob) this.privFilename = file.name;
        else this.privFilename = filename || "unknown.wav";
        // Read the header.
        this.privAudioFormatPromise = this.readHeader();
    }
    get format() {
        return this.privAudioFormatPromise;
    }
    turnOn() {
        if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
            const errorMsg = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
            this.onEvent(new $5OUhN.AudioSourceErrorEvent(errorMsg, ""));
            return Promise.reject(errorMsg);
        }
        this.onEvent(new $5OUhN.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $5OUhN.AudioSourceReadyEvent(this.privId));
        return;
    }
    id() {
        return this.privId;
    }
    async attach(audioNodeId) {
        this.onEvent(new $5OUhN.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        const stream = await this.upload(audioNodeId);
        this.onEvent(new $5OUhN.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
        return Promise.resolve({
            detach: async ()=>{
                stream.readEnded();
                delete this.privStreams[audioNodeId];
                this.onEvent(new $5OUhN.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                await this.turnOff();
            },
            id: ()=>audioNodeId,
            read: ()=>stream.read()
        });
    }
    detach(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new $5OUhN.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
        }
    }
    turnOff() {
        for(const streamId in this.privStreams)if (streamId) {
            const stream = this.privStreams[streamId];
            if (stream && !stream.isClosed) stream.close();
        }
        this.onEvent(new $5OUhN.AudioSourceOffEvent(this.privId)); // no stream now
        return Promise.resolve();
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.privAudioFormatPromise.then((result)=>Promise.resolve({
                bitspersample: result.bitsPerSample,
                channelcount: result.channels,
                connectivity: $hgjD5.connectivity.Unknown,
                manufacturer: "Speech SDK",
                model: "File",
                samplerate: result.samplesPerSec,
                type: $hgjD5.type.File
            }));
    }
    readHeader() {
        // Read the wave header.
        const maxHeaderSize = 4296;
        const header = this.privSource.slice(0, maxHeaderSize);
        const headerResult = new $5OUhN.Deferred();
        const processHeader = (header)=>{
            const view = new DataView(header);
            const getWord = (index)=>String.fromCharCode(view.getUint8(index), view.getUint8(index + 1), view.getUint8(index + 2), view.getUint8(index + 3));
            // RIFF 4 bytes.
            if ("RIFF" !== getWord(0)) {
                headerResult.reject("Invalid WAV header in file, RIFF was not found");
                return;
            }
            // length, 4 bytes
            // RIFF Type & fmt 8 bytes
            if ("WAVE" !== getWord(8) || "fmt " !== getWord(12)) {
                headerResult.reject("Invalid WAV header in file, WAVEfmt was not found");
                return;
            }
            const formatSize = view.getInt32(16, true);
            const channelCount = view.getUint16(22, true);
            const sampleRate = view.getUint32(24, true);
            const bitsPerSample = view.getUint16(34, true);
            // Confirm if header is 44 bytes long.
            let pos = 36 + Math.max(formatSize - 16, 0);
            for(; getWord(pos) !== "data"; pos += 2)if (pos > maxHeaderSize - 8) {
                headerResult.reject("Invalid WAV header in file, data block was not found");
                return;
            }
            this.privHeaderEnd = pos + 8;
            headerResult.resolve($hzVTX.AudioStreamFormat.getWaveFormatPCM(sampleRate, bitsPerSample, channelCount));
        };
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && header instanceof Blob) {
            const reader = new FileReader();
            reader.onload = (event)=>{
                const header = event.target.result;
                processHeader(header);
            };
            reader.readAsArrayBuffer(header);
        } else {
            const h = header;
            processHeader(h.buffer.slice(h.byteOffset, h.byteOffset + h.byteLength));
        }
        return headerResult.promise;
    }
    async upload(audioNodeId) {
        const onerror = (error)=>{
            const errorMsg = `Error occurred while processing '${this.privFilename}'. ${error}`;
            this.onEvent(new $5OUhN.AudioStreamNodeErrorEvent(this.privId, audioNodeId, errorMsg));
            throw new Error(errorMsg);
        };
        try {
            await this.turnOn();
            const format = await this.privAudioFormatPromise;
            const stream = new $5OUhN.ChunkedArrayBufferStream(format.avgBytesPerSec / 10, audioNodeId);
            this.privStreams[audioNodeId] = stream;
            const chunk = this.privSource.slice(this.privHeaderEnd);
            const processFile = (buff)=>{
                if (stream.isClosed) return; // output stream was closed (somebody called TurnOff). We're done here.
                stream.writeStreamChunk({
                    buffer: buff,
                    isEnd: false,
                    timeReceived: Date.now()
                });
                stream.close();
            };
            if (typeof window !== "undefined" && typeof Blob !== "undefined" && chunk instanceof Blob) {
                const reader = new FileReader();
                reader.onerror = (ev)=>onerror(ev.toString());
                reader.onload = (event)=>{
                    const fileBuffer = event.target.result;
                    processFile(fileBuffer);
                };
                reader.readAsArrayBuffer(chunk);
            } else {
                const c = chunk;
                processFile(c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength));
            }
            return stream;
        } catch (e) {
            onerror(e);
        }
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $5OUhN.Events.instance.onEvent(event);
    }
}
module.exports.FileAudioSource = $56b16b9bd5156b0e$var$FileAudioSource;

});

parcelRegister("38XBR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PcmRecorder = void 0;

var $5OUhN = parcelRequire("5OUhN");
class $24a05bb4ec29c64d$var$PcmRecorder {
    constructor(stopInputOnRelease){
        this.privStopInputOnRelease = stopInputOnRelease;
    }
    record(context, mediaStream, outputStream) {
        const desiredSampleRate = 16000;
        const waveStreamEncoder = new $5OUhN.RiffPcmEncoder(context.sampleRate, desiredSampleRate);
        const micInput = context.createMediaStreamSource(mediaStream);
        const attachScriptProcessor = ()=>{
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            const scriptNode = (()=>{
                let bufferSize = 0;
                try {
                    return context.createScriptProcessor(bufferSize, 1, 1);
                } catch (error) {
                    // Webkit (<= version 31) requires a valid bufferSize.
                    bufferSize = 2048;
                    let audioSampleRate = context.sampleRate;
                    while(bufferSize < 16384 && audioSampleRate >= 2 * desiredSampleRate){
                        bufferSize <<= 1;
                        audioSampleRate >>= 1;
                    }
                    return context.createScriptProcessor(bufferSize, 1, 1);
                }
            })();
            scriptNode.onaudioprocess = (event)=>{
                const inputFrame = event.inputBuffer.getChannelData(0);
                if (outputStream && !outputStream.isClosed) {
                    const waveFrame = waveStreamEncoder.encode(inputFrame);
                    if (!!waveFrame) outputStream.writeStreamChunk({
                        buffer: waveFrame,
                        isEnd: false,
                        timeReceived: Date.now()
                    });
                }
            };
            micInput.connect(scriptNode);
            scriptNode.connect(context.destination);
            this.privMediaResources = {
                scriptProcessorNode: scriptNode,
                source: micInput,
                stream: mediaStream
            };
        };
        // https://webaudio.github.io/web-audio-api/#audioworklet
        // Using AudioWorklet to improve audio quality and avoid audio glitches due to blocking the UI thread
        const skipAudioWorklet = !!this.privSpeechProcessorScript && this.privSpeechProcessorScript.toLowerCase() === "ignore";
        if (!!context.audioWorklet && !skipAudioWorklet) {
            if (!this.privSpeechProcessorScript) {
                const workletScript = `class SP extends AudioWorkletProcessor {
                    constructor(options) {
                      super(options);
                    }
                    process(inputs, outputs) {
                      const input = inputs[0];
                      const output = [];
                      for (let channel = 0; channel < input.length; channel += 1) {
                        output[channel] = input[channel];
                      }
                      this.port.postMessage(output[0]);
                      return true;
                    }
                  }
                  registerProcessor('speech-processor', SP);`;
                const blob = new Blob([
                    workletScript
                ], {
                    type: "application/javascript; charset=utf-8"
                });
                this.privSpeechProcessorScript = URL.createObjectURL(blob);
            }
            context.audioWorklet.addModule(this.privSpeechProcessorScript).then(()=>{
                const workletNode = new AudioWorkletNode(context, "speech-processor");
                workletNode.port.onmessage = (ev)=>{
                    const inputFrame = ev.data;
                    if (outputStream && !outputStream.isClosed) {
                        const waveFrame = waveStreamEncoder.encode(inputFrame);
                        if (!!waveFrame) outputStream.writeStreamChunk({
                            buffer: waveFrame,
                            isEnd: false,
                            timeReceived: Date.now()
                        });
                    }
                };
                micInput.connect(workletNode);
                workletNode.connect(context.destination);
                this.privMediaResources = {
                    scriptProcessorNode: workletNode,
                    source: micInput,
                    stream: mediaStream
                };
            }).catch(()=>{
                attachScriptProcessor();
            });
        } else try {
            attachScriptProcessor();
        } catch (err) {
            throw new Error(`Unable to start audio worklet node for PCMRecorder: ${err}`);
        }
    }
    releaseMediaResources(context) {
        if (this.privMediaResources) {
            if (this.privMediaResources.scriptProcessorNode) {
                this.privMediaResources.scriptProcessorNode.disconnect(context.destination);
                this.privMediaResources.scriptProcessorNode = null;
            }
            if (this.privMediaResources.source) {
                this.privMediaResources.source.disconnect();
                if (this.privStopInputOnRelease) this.privMediaResources.stream.getTracks().forEach((track)=>track.stop());
                this.privMediaResources.source = null;
            }
        }
    }
    setWorkletUrl(url) {
        this.privSpeechProcessorScript = url;
    }
}
module.exports.PcmRecorder = $24a05bb4ec29c64d$var$PcmRecorder;

});

parcelRegister("4MedZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketConnection = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $kvQYc = parcelRequire("kvQYc");
class $37a6add96d63ba14$var$WebsocketConnection {
    constructor(uri, queryParameters, headers, messageFormatter, proxyInfo, enableCompression = false, connectionId){
        this.privIsDisposed = false;
        if (!uri) throw new $5OUhN.ArgumentNullError("uri");
        if (!messageFormatter) throw new $5OUhN.ArgumentNullError("messageFormatter");
        this.privMessageFormatter = messageFormatter;
        let queryParams = "";
        let i = 0;
        if (queryParameters) {
            for(const paramName in queryParameters)if (paramName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const key = encodeURIComponent(paramName);
                queryParams += key;
                let val = queryParameters[paramName];
                if (val) {
                    val = encodeURIComponent(val);
                    queryParams += `=${val}`;
                }
                i++;
            }
        }
        if (headers) {
            for(const headerName in headers)if (headerName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const val = encodeURIComponent(headers[headerName]);
                queryParams += `${headerName}=${val}`;
                i++;
            }
        }
        this.privUri = uri + queryParams;
        this.privId = connectionId ? connectionId : (0, $5OUhN.createNoDashGuid)();
        this.privConnectionMessageAdapter = new $kvQYc.WebsocketMessageAdapter(this.privUri, this.id, this.privMessageFormatter, proxyInfo, headers, enableCompression);
    }
    async dispose() {
        this.privIsDisposed = true;
        if (this.privConnectionMessageAdapter) await this.privConnectionMessageAdapter.close();
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    get id() {
        return this.privId;
    }
    get uri() {
        return this.privUri;
    }
    state() {
        return this.privConnectionMessageAdapter.state;
    }
    open() {
        return this.privConnectionMessageAdapter.open();
    }
    send(message) {
        return this.privConnectionMessageAdapter.send(message);
    }
    read() {
        return this.privConnectionMessageAdapter.read();
    }
    get events() {
        return this.privConnectionMessageAdapter.events;
    }
}
module.exports.WebsocketConnection = $37a6add96d63ba14$var$WebsocketConnection;

});
parcelRegister("kvQYc", function(module, exports) {

var $f2Nvv = parcelRequire("f2Nvv");
var $eeefcaa3c5db8bfe$require$Buffer = $f2Nvv.Buffer;
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $eeefcaa3c5db8bfe$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eeefcaa3c5db8bfe$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $eeefcaa3c5db8bfe$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $eeefcaa3c5db8bfe$var$__createBinding(result, mod, k);
    }
    $eeefcaa3c5db8bfe$var$__setModuleDefault(result, mod);
    return result;
};
var $eeefcaa3c5db8bfe$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketMessageAdapter = void 0;

const $eeefcaa3c5db8bfe$var$net = $eeefcaa3c5db8bfe$var$__importStar((parcelRequire("9zn7p")));

const $eeefcaa3c5db8bfe$var$tls = $eeefcaa3c5db8bfe$var$__importStar((parcelRequire("9zn7p")));

const $eeefcaa3c5db8bfe$var$agent_base_1 = $eeefcaa3c5db8bfe$var$__importDefault((parcelRequire("9zn7p")));

const $eeefcaa3c5db8bfe$var$https_proxy_agent_1 = $eeefcaa3c5db8bfe$var$__importDefault((parcelRequire("9zn7p")));

const $eeefcaa3c5db8bfe$var$ws_1 = $eeefcaa3c5db8bfe$var$__importDefault((parcelRequire("9zn7p")));

var $40Pvg = parcelRequire("40Pvg");

var $5OUhN = parcelRequire("5OUhN");
class $eeefcaa3c5db8bfe$var$WebsocketMessageAdapter {
    constructor(uri, connectionId, messageFormatter, proxyInfo, headers, enableCompression){
        if (!uri) throw new $5OUhN.ArgumentNullError("uri");
        if (!messageFormatter) throw new $5OUhN.ArgumentNullError("messageFormatter");
        this.proxyInfo = proxyInfo;
        this.privConnectionEvents = new $5OUhN.EventSource();
        this.privConnectionId = connectionId;
        this.privMessageFormatter = messageFormatter;
        this.privConnectionState = $5OUhN.ConnectionState.None;
        this.privUri = uri;
        this.privHeaders = headers;
        this.privEnableCompression = enableCompression;
        // Add the connection ID to the headers
        this.privHeaders[$40Pvg.HeaderNames.ConnectionId] = this.privConnectionId;
        this.privHeaders.connectionId = this.privConnectionId;
        this.privLastErrorReceived = "";
    }
    get state() {
        return this.privConnectionState;
    }
    open() {
        if (this.privConnectionState === $5OUhN.ConnectionState.Disconnected) return Promise.reject(`Cannot open a connection that is in ${this.privConnectionState} state`);
        if (this.privConnectionEstablishDeferral) return this.privConnectionEstablishDeferral.promise;
        this.privConnectionEstablishDeferral = new $5OUhN.Deferred();
        this.privCertificateValidatedDeferral = new $5OUhN.Deferred();
        this.privConnectionState = $5OUhN.ConnectionState.Connecting;
        try {
            if (typeof WebSocket !== "undefined" && !$eeefcaa3c5db8bfe$var$WebsocketMessageAdapter.forceNpmWebSocket) {
                // Browser handles cert checks.
                this.privCertificateValidatedDeferral.resolve();
                this.privWebsocketClient = new WebSocket(this.privUri);
            } else {
                // Workaround for https://github.com/microsoft/cognitive-services-speech-sdk-js/issues/465
                // Which is root caused by https://github.com/TooTallNate/node-agent-base/issues/61
                const uri = new URL(this.privUri);
                let protocol = uri.protocol;
                if (protocol?.toLocaleLowerCase() === "wss:") protocol = "https:";
                else if (protocol?.toLocaleLowerCase() === "ws:") protocol = "http:";
                const options = {
                    headers: this.privHeaders,
                    perMessageDeflate: this.privEnableCompression,
                    followRedirects: protocol.toLocaleLowerCase() === "https:"
                };
                // The ocsp library will handle validation for us and fail the connection if needed.
                this.privCertificateValidatedDeferral.resolve();
                options.agent = this.getAgent();
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                options.agent.protocol = protocol;
                this.privWebsocketClient = new $eeefcaa3c5db8bfe$var$ws_1.default(this.privUri, options);
                this.privWebsocketClient.on("redirect", (redirectUrl)=>{
                    const event = new $5OUhN.ConnectionRedirectEvent(this.privConnectionId, redirectUrl, this.privUri, `Getting redirect URL from endpoint ${this.privUri} with redirect URL '${redirectUrl}'`);
                    $5OUhN.Events.instance.onEvent(event);
                });
            }
            this.privWebsocketClient.binaryType = "arraybuffer";
            this.privReceivingMessageQueue = new $5OUhN.Queue();
            this.privDisconnectDeferral = new $5OUhN.Deferred();
            this.privSendMessageQueue = new $5OUhN.Queue();
            this.processSendQueue().catch((reason)=>{
                $5OUhN.Events.instance.onEvent(new $5OUhN.BackgroundEvent(reason));
            });
        } catch (error) {
            this.privConnectionEstablishDeferral.resolve(new $5OUhN.ConnectionOpenResponse(500, error));
            return this.privConnectionEstablishDeferral.promise;
        }
        this.onEvent(new $5OUhN.ConnectionStartEvent(this.privConnectionId, this.privUri));
        this.privWebsocketClient.onopen = ()=>{
            this.privCertificateValidatedDeferral.promise.then(()=>{
                this.privConnectionState = $5OUhN.ConnectionState.Connected;
                this.onEvent(new $5OUhN.ConnectionEstablishedEvent(this.privConnectionId));
                this.privConnectionEstablishDeferral.resolve(new $5OUhN.ConnectionOpenResponse(200, ""));
            }, (error)=>{
                this.privConnectionEstablishDeferral.reject(error);
            });
        };
        this.privWebsocketClient.onerror = (e)=>{
            this.onEvent(new $5OUhN.ConnectionErrorEvent(this.privConnectionId, e.message, e.type));
            this.privLastErrorReceived = e.message;
        };
        this.privWebsocketClient.onclose = (e)=>{
            if (this.privConnectionState === $5OUhN.ConnectionState.Connecting) {
                this.privConnectionState = $5OUhN.ConnectionState.Disconnected;
                // this.onEvent(new ConnectionEstablishErrorEvent(this.connectionId, e.code, e.reason));
                this.privConnectionEstablishDeferral.resolve(new $5OUhN.ConnectionOpenResponse(e.code, e.reason + " " + this.privLastErrorReceived));
            } else {
                this.privConnectionState = $5OUhN.ConnectionState.Disconnected;
                this.privWebsocketClient = null;
                this.onEvent(new $5OUhN.ConnectionClosedEvent(this.privConnectionId, e.code, e.reason));
            }
            this.onClose(e.code, e.reason).catch((reason)=>{
                $5OUhN.Events.instance.onEvent(new $5OUhN.BackgroundEvent(reason));
            });
        };
        this.privWebsocketClient.onmessage = (e)=>{
            const networkReceivedTime = new Date().toISOString();
            if (this.privConnectionState === $5OUhN.ConnectionState.Connected) {
                const deferred = new $5OUhN.Deferred();
                // let id = ++this.idCounter;
                this.privReceivingMessageQueue.enqueueFromPromise(deferred.promise);
                if (e.data instanceof ArrayBuffer) {
                    const rawMessage = new $5OUhN.RawWebsocketMessage($5OUhN.MessageType.Binary, e.data);
                    this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                        this.onEvent(new $5OUhN.ConnectionMessageReceivedEvent(this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred.resolve(connectionMessage);
                    }, (error)=>{
                        // TODO: Events for these ?
                        deferred.reject(`Invalid binary message format. Error: ${error}`);
                    });
                } else {
                    const rawMessage = new $5OUhN.RawWebsocketMessage($5OUhN.MessageType.Text, e.data);
                    this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                        this.onEvent(new $5OUhN.ConnectionMessageReceivedEvent(this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred.resolve(connectionMessage);
                    }, (error)=>{
                        // TODO: Events for these ?
                        deferred.reject(`Invalid text message format. Error: ${error}`);
                    });
                }
            }
        };
        return this.privConnectionEstablishDeferral.promise;
    }
    send(message) {
        if (this.privConnectionState !== $5OUhN.ConnectionState.Connected) return Promise.reject(`Cannot send on connection that is in ${$5OUhN.ConnectionState[this.privConnectionState]} state`);
        const messageSendStatusDeferral = new $5OUhN.Deferred();
        const messageSendDeferral = new $5OUhN.Deferred();
        this.privSendMessageQueue.enqueueFromPromise(messageSendDeferral.promise);
        this.privMessageFormatter.fromConnectionMessage(message).then((rawMessage)=>{
            messageSendDeferral.resolve({
                Message: message,
                RawWebsocketMessage: rawMessage,
                sendStatusDeferral: messageSendStatusDeferral
            });
        }, (error)=>{
            messageSendDeferral.reject(`Error formatting the message. ${error}`);
        });
        return messageSendStatusDeferral.promise;
    }
    read() {
        if (this.privConnectionState !== $5OUhN.ConnectionState.Connected) return Promise.reject(`Cannot read on connection that is in ${this.privConnectionState} state`);
        return this.privReceivingMessageQueue.dequeue();
    }
    close(reason) {
        if (this.privWebsocketClient) {
            if (this.privConnectionState !== $5OUhN.ConnectionState.Disconnected) this.privWebsocketClient.close(1000, reason ? reason : "Normal closure by client");
        } else return Promise.resolve();
        return this.privDisconnectDeferral.promise;
    }
    get events() {
        return this.privConnectionEvents;
    }
    sendRawMessage(sendItem) {
        try {
            // indicates we are draining the queue and it came with no message;
            if (!sendItem) return Promise.resolve();
            this.onEvent(new $5OUhN.ConnectionMessageSentEvent(this.privConnectionId, new Date().toISOString(), sendItem.Message));
            // add a check for the ws readystate in order to stop the red console error 'WebSocket is already in CLOSING or CLOSED state' appearing
            if (this.isWebsocketOpen) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privWebsocketClient.send(sendItem.RawWebsocketMessage.payload);
            else return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + sendItem.Message.id + " " + new Error().stack);
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(`websocket send error: ${e}`);
        }
    }
    async onClose(code, reason) {
        const closeReason = `Connection closed. ${code}: ${reason}`;
        this.privConnectionState = $5OUhN.ConnectionState.Disconnected;
        this.privDisconnectDeferral.resolve();
        await this.privReceivingMessageQueue.drainAndDispose(()=>{
        // TODO: Events for these ?
        // Logger.instance.onEvent(new LoggingEvent(LogType.Warning, null, `Failed to process received message. Reason: ${closeReason}, Message: ${JSON.stringify(pendingReceiveItem)}`));
        }, closeReason);
        await this.privSendMessageQueue.drainAndDispose((pendingSendItem)=>{
            pendingSendItem.sendStatusDeferral.reject(closeReason);
        }, closeReason);
    }
    async processSendQueue() {
        while(true){
            const itemToSend = this.privSendMessageQueue.dequeue();
            const sendItem = await itemToSend;
            // indicates we are draining the queue and it came with no message;
            if (!sendItem) return;
            try {
                await this.sendRawMessage(sendItem);
                sendItem.sendStatusDeferral.resolve();
            } catch (sendError) {
                sendItem.sendStatusDeferral.reject(sendError);
            }
        }
    }
    onEvent(event) {
        this.privConnectionEvents.onEvent(event);
        $5OUhN.Events.instance.onEvent(event);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAgent() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const agent = new $eeefcaa3c5db8bfe$var$agent_base_1.default.Agent(this.createConnection);
        if (this.proxyInfo !== undefined && this.proxyInfo.HostName !== undefined && this.proxyInfo.Port > 0) agent.proxyInfo = this.proxyInfo;
        return agent;
    }
    static GetProxyAgent(proxyInfo) {
        const httpProxyOptions = {
            host: proxyInfo.HostName,
            port: proxyInfo.Port
        };
        if (!!proxyInfo.UserName) httpProxyOptions.headers = {
            "Proxy-Authentication": "Basic " + $eeefcaa3c5db8bfe$require$Buffer.from(`${proxyInfo.UserName}:${proxyInfo.Password === undefined ? "" : proxyInfo.Password}`).toString("base64")
        };
        else httpProxyOptions.headers = {};
        httpProxyOptions.headers.requestOCSP = "true";
        const httpProxyAgent = new $eeefcaa3c5db8bfe$var$https_proxy_agent_1.default(httpProxyOptions);
        return httpProxyAgent;
    }
    createConnection(request, options) {
        let socketPromise;
        options = {
            ...options,
            requestOCSP: true,
            servername: options.host
        };
        if (!!this.proxyInfo) {
            const httpProxyAgent = $eeefcaa3c5db8bfe$var$WebsocketMessageAdapter.GetProxyAgent(this.proxyInfo);
            const baseAgent = httpProxyAgent;
            socketPromise = new Promise((resolve, reject)=>{
                baseAgent.callback(request, options, (error, socket)=>{
                    if (!!error) reject(error);
                    else resolve(socket);
                });
            });
        } else if (!!options.secureEndpoint) socketPromise = Promise.resolve($eeefcaa3c5db8bfe$var$tls.connect(options));
        else socketPromise = Promise.resolve($eeefcaa3c5db8bfe$var$net.connect(options));
        return socketPromise;
    }
    get isWebsocketOpen() {
        return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
    }
}
module.exports.WebsocketMessageAdapter = $eeefcaa3c5db8bfe$var$WebsocketMessageAdapter;
$eeefcaa3c5db8bfe$var$WebsocketMessageAdapter.forceNpmWebSocket = false;

});
parcelRegister("f2Nvv", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $af3d72024532fa73$export$a143d493d941bafc, (v) => $af3d72024532fa73$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $af3d72024532fa73$export$f99ded8fe4b79145, (v) => $af3d72024532fa73$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $af3d72024532fa73$export$a143d493d941bafc;
var $af3d72024532fa73$export$e4cf37d7f6fb9e0a;
var $af3d72024532fa73$export$f99ded8fe4b79145;
var $af3d72024532fa73$export$599f31c3813fae4d;
'use strict';

var $jPqBZ = parcelRequire("jPqBZ");

var $oaTF8 = parcelRequire("oaTF8");
var $af3d72024532fa73$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$af3d72024532fa73$export$a143d493d941bafc = $af3d72024532fa73$var$Buffer;
$af3d72024532fa73$export$e4cf37d7f6fb9e0a = $af3d72024532fa73$var$SlowBuffer;
$af3d72024532fa73$export$f99ded8fe4b79145 = 50;
var $af3d72024532fa73$var$K_MAX_LENGTH = 0x7fffffff;
$af3d72024532fa73$export$599f31c3813fae4d = $af3d72024532fa73$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $af3d72024532fa73$var$Buffer.TYPED_ARRAY_SUPPORT = $af3d72024532fa73$var$typedArraySupport();
if (!$af3d72024532fa73$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $af3d72024532fa73$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($af3d72024532fa73$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$af3d72024532fa73$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($af3d72024532fa73$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$af3d72024532fa73$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $af3d72024532fa73$var$createBuffer(length) {
    if (length > $af3d72024532fa73$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $af3d72024532fa73$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $af3d72024532fa73$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $af3d72024532fa73$var$allocUnsafe(arg);
    }
    return $af3d72024532fa73$var$from(arg, encodingOrOffset, length);
}
$af3d72024532fa73$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $af3d72024532fa73$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $af3d72024532fa73$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $af3d72024532fa73$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($af3d72024532fa73$var$isInstance(value, ArrayBuffer) || value && $af3d72024532fa73$var$isInstance(value.buffer, ArrayBuffer)) return $af3d72024532fa73$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($af3d72024532fa73$var$isInstance(value, SharedArrayBuffer) || value && $af3d72024532fa73$var$isInstance(value.buffer, SharedArrayBuffer))) return $af3d72024532fa73$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $af3d72024532fa73$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $af3d72024532fa73$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $af3d72024532fa73$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $af3d72024532fa73$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $af3d72024532fa73$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($af3d72024532fa73$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($af3d72024532fa73$var$Buffer, Uint8Array);
function $af3d72024532fa73$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $af3d72024532fa73$var$alloc(size, fill, encoding) {
    $af3d72024532fa73$var$assertSize(size);
    if (size <= 0) return $af3d72024532fa73$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $af3d72024532fa73$var$createBuffer(size).fill(fill, encoding) : $af3d72024532fa73$var$createBuffer(size).fill(fill);
    return $af3d72024532fa73$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $af3d72024532fa73$var$Buffer.alloc = function(size, fill, encoding) {
    return $af3d72024532fa73$var$alloc(size, fill, encoding);
};
function $af3d72024532fa73$var$allocUnsafe(size) {
    $af3d72024532fa73$var$assertSize(size);
    return $af3d72024532fa73$var$createBuffer(size < 0 ? 0 : $af3d72024532fa73$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $af3d72024532fa73$var$Buffer.allocUnsafe = function(size) {
    return $af3d72024532fa73$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $af3d72024532fa73$var$Buffer.allocUnsafeSlow = function(size) {
    return $af3d72024532fa73$var$allocUnsafe(size);
};
function $af3d72024532fa73$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$af3d72024532fa73$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $af3d72024532fa73$var$byteLength(string, encoding) | 0;
    var buf = $af3d72024532fa73$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $af3d72024532fa73$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $af3d72024532fa73$var$checked(array.length) | 0;
    var buf = $af3d72024532fa73$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $af3d72024532fa73$var$fromArrayView(arrayView) {
    if ($af3d72024532fa73$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $af3d72024532fa73$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $af3d72024532fa73$var$fromArrayLike(arrayView);
}
function $af3d72024532fa73$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $af3d72024532fa73$var$Buffer.prototype);
    return buf;
}
function $af3d72024532fa73$var$fromObject(obj) {
    if ($af3d72024532fa73$var$Buffer.isBuffer(obj)) {
        var len = $af3d72024532fa73$var$checked(obj.length) | 0;
        var buf = $af3d72024532fa73$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $af3d72024532fa73$var$numberIsNaN(obj.length)) return $af3d72024532fa73$var$createBuffer(0);
        return $af3d72024532fa73$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $af3d72024532fa73$var$fromArrayLike(obj.data);
}
function $af3d72024532fa73$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $af3d72024532fa73$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $af3d72024532fa73$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $af3d72024532fa73$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $af3d72024532fa73$var$Buffer.alloc(+length);
}
$af3d72024532fa73$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $af3d72024532fa73$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$af3d72024532fa73$var$Buffer.compare = function compare(a, b) {
    if ($af3d72024532fa73$var$isInstance(a, Uint8Array)) a = $af3d72024532fa73$var$Buffer.from(a, a.offset, a.byteLength);
    if ($af3d72024532fa73$var$isInstance(b, Uint8Array)) b = $af3d72024532fa73$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$af3d72024532fa73$var$Buffer.isBuffer(a) || !$af3d72024532fa73$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$af3d72024532fa73$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$af3d72024532fa73$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $af3d72024532fa73$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $af3d72024532fa73$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($af3d72024532fa73$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $af3d72024532fa73$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$af3d72024532fa73$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $af3d72024532fa73$var$byteLength(string, encoding) {
    if ($af3d72024532fa73$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $af3d72024532fa73$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $af3d72024532fa73$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $af3d72024532fa73$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $af3d72024532fa73$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$af3d72024532fa73$var$Buffer.byteLength = $af3d72024532fa73$var$byteLength;
function $af3d72024532fa73$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $af3d72024532fa73$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $af3d72024532fa73$var$utf8Slice(this, start, end);
        case 'ascii':
            return $af3d72024532fa73$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $af3d72024532fa73$var$latin1Slice(this, start, end);
        case 'base64':
            return $af3d72024532fa73$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $af3d72024532fa73$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$af3d72024532fa73$var$Buffer.prototype._isBuffer = true;
function $af3d72024532fa73$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$af3d72024532fa73$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$af3d72024532fa73$var$swap(this, i, i + 1);
    return this;
};
$af3d72024532fa73$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $af3d72024532fa73$var$swap(this, i, i + 3);
        $af3d72024532fa73$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$af3d72024532fa73$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $af3d72024532fa73$var$swap(this, i, i + 7);
        $af3d72024532fa73$var$swap(this, i + 1, i + 6);
        $af3d72024532fa73$var$swap(this, i + 2, i + 5);
        $af3d72024532fa73$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$af3d72024532fa73$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $af3d72024532fa73$var$utf8Slice(this, 0, length);
    return $af3d72024532fa73$var$slowToString.apply(this, arguments);
};
$af3d72024532fa73$var$Buffer.prototype.toLocaleString = $af3d72024532fa73$var$Buffer.prototype.toString;
$af3d72024532fa73$var$Buffer.prototype.equals = function equals(b) {
    if (!$af3d72024532fa73$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $af3d72024532fa73$var$Buffer.compare(this, b) === 0;
};
$af3d72024532fa73$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $af3d72024532fa73$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($af3d72024532fa73$var$customInspectSymbol) $af3d72024532fa73$var$Buffer.prototype[$af3d72024532fa73$var$customInspectSymbol] = $af3d72024532fa73$var$Buffer.prototype.inspect;
$af3d72024532fa73$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($af3d72024532fa73$var$isInstance(target, Uint8Array)) target = $af3d72024532fa73$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$af3d72024532fa73$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $af3d72024532fa73$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($af3d72024532fa73$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $af3d72024532fa73$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($af3d72024532fa73$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $af3d72024532fa73$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $af3d72024532fa73$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $af3d72024532fa73$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$af3d72024532fa73$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$af3d72024532fa73$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $af3d72024532fa73$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$af3d72024532fa73$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $af3d72024532fa73$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $af3d72024532fa73$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($af3d72024532fa73$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $af3d72024532fa73$var$utf8Write(buf, string, offset, length) {
    return $af3d72024532fa73$var$blitBuffer($af3d72024532fa73$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $af3d72024532fa73$var$asciiWrite(buf, string, offset, length) {
    return $af3d72024532fa73$var$blitBuffer($af3d72024532fa73$var$asciiToBytes(string), buf, offset, length);
}
function $af3d72024532fa73$var$base64Write(buf, string, offset, length) {
    return $af3d72024532fa73$var$blitBuffer($af3d72024532fa73$var$base64ToBytes(string), buf, offset, length);
}
function $af3d72024532fa73$var$ucs2Write(buf, string, offset, length) {
    return $af3d72024532fa73$var$blitBuffer($af3d72024532fa73$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$af3d72024532fa73$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $af3d72024532fa73$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $af3d72024532fa73$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $af3d72024532fa73$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $af3d72024532fa73$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $af3d72024532fa73$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$af3d72024532fa73$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $af3d72024532fa73$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $jPqBZ.fromByteArray(buf);
    else return $jPqBZ.fromByteArray(buf.slice(start, end));
}
function $af3d72024532fa73$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $af3d72024532fa73$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $af3d72024532fa73$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $af3d72024532fa73$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $af3d72024532fa73$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $af3d72024532fa73$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $af3d72024532fa73$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $af3d72024532fa73$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $af3d72024532fa73$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $af3d72024532fa73$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $af3d72024532fa73$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$af3d72024532fa73$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $af3d72024532fa73$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $af3d72024532fa73$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$af3d72024532fa73$var$Buffer.prototype.readUintLE = $af3d72024532fa73$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$af3d72024532fa73$var$Buffer.prototype.readUintBE = $af3d72024532fa73$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$af3d72024532fa73$var$Buffer.prototype.readUint8 = $af3d72024532fa73$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$af3d72024532fa73$var$Buffer.prototype.readUint16LE = $af3d72024532fa73$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$af3d72024532fa73$var$Buffer.prototype.readUint16BE = $af3d72024532fa73$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$af3d72024532fa73$var$Buffer.prototype.readUint32LE = $af3d72024532fa73$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$af3d72024532fa73$var$Buffer.prototype.readUint32BE = $af3d72024532fa73$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$af3d72024532fa73$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$af3d72024532fa73$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$af3d72024532fa73$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$af3d72024532fa73$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$af3d72024532fa73$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$af3d72024532fa73$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$af3d72024532fa73$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$af3d72024532fa73$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return $oaTF8.read(this, offset, true, 23, 4);
};
$af3d72024532fa73$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return $oaTF8.read(this, offset, false, 23, 4);
};
$af3d72024532fa73$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 8, this.length);
    return $oaTF8.read(this, offset, true, 52, 8);
};
$af3d72024532fa73$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 8, this.length);
    return $oaTF8.read(this, offset, false, 52, 8);
};
function $af3d72024532fa73$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$af3d72024532fa73$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$af3d72024532fa73$var$Buffer.prototype.writeUintLE = $af3d72024532fa73$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $af3d72024532fa73$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$af3d72024532fa73$var$Buffer.prototype.writeUintBE = $af3d72024532fa73$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $af3d72024532fa73$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$af3d72024532fa73$var$Buffer.prototype.writeUint8 = $af3d72024532fa73$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$af3d72024532fa73$var$Buffer.prototype.writeUint16LE = $af3d72024532fa73$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$af3d72024532fa73$var$Buffer.prototype.writeUint16BE = $af3d72024532fa73$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$af3d72024532fa73$var$Buffer.prototype.writeUint32LE = $af3d72024532fa73$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$af3d72024532fa73$var$Buffer.prototype.writeUint32BE = $af3d72024532fa73$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$af3d72024532fa73$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $af3d72024532fa73$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$af3d72024532fa73$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $af3d72024532fa73$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$af3d72024532fa73$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$af3d72024532fa73$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$af3d72024532fa73$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$af3d72024532fa73$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$af3d72024532fa73$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $af3d72024532fa73$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $af3d72024532fa73$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $oaTF8.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$af3d72024532fa73$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $af3d72024532fa73$var$writeFloat(this, value, offset, true, noAssert);
};
$af3d72024532fa73$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $af3d72024532fa73$var$writeFloat(this, value, offset, false, noAssert);
};
function $af3d72024532fa73$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $oaTF8.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$af3d72024532fa73$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $af3d72024532fa73$var$writeDouble(this, value, offset, true, noAssert);
};
$af3d72024532fa73$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $af3d72024532fa73$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$af3d72024532fa73$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$af3d72024532fa73$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$af3d72024532fa73$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$af3d72024532fa73$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $af3d72024532fa73$var$Buffer.isBuffer(val) ? val : $af3d72024532fa73$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $af3d72024532fa73$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $af3d72024532fa73$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($af3d72024532fa73$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $af3d72024532fa73$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $af3d72024532fa73$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $af3d72024532fa73$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $af3d72024532fa73$var$base64ToBytes(str) {
    return $jPqBZ.toByteArray($af3d72024532fa73$var$base64clean(str));
}
function $af3d72024532fa73$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $af3d72024532fa73$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $af3d72024532fa73$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $af3d72024532fa73$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("jPqBZ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $e6f76c44bab27d1f$export$d622b2ad8d90c771, (v) => $e6f76c44bab27d1f$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $e6f76c44bab27d1f$export$6100ba28696e12de, (v) => $e6f76c44bab27d1f$export$6100ba28696e12de = v);
var $e6f76c44bab27d1f$export$a48f0734ac7c2329;
var $e6f76c44bab27d1f$export$d622b2ad8d90c771;
var $e6f76c44bab27d1f$export$6100ba28696e12de;
'use strict';
$e6f76c44bab27d1f$export$a48f0734ac7c2329 = $e6f76c44bab27d1f$var$byteLength;
$e6f76c44bab27d1f$export$d622b2ad8d90c771 = $e6f76c44bab27d1f$var$toByteArray;
$e6f76c44bab27d1f$export$6100ba28696e12de = $e6f76c44bab27d1f$var$fromByteArray;
var $e6f76c44bab27d1f$var$lookup = [];
var $e6f76c44bab27d1f$var$revLookup = [];
var $e6f76c44bab27d1f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e6f76c44bab27d1f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e6f76c44bab27d1f$var$i = 0, $e6f76c44bab27d1f$var$len = $e6f76c44bab27d1f$var$code.length; $e6f76c44bab27d1f$var$i < $e6f76c44bab27d1f$var$len; ++$e6f76c44bab27d1f$var$i){
    $e6f76c44bab27d1f$var$lookup[$e6f76c44bab27d1f$var$i] = $e6f76c44bab27d1f$var$code[$e6f76c44bab27d1f$var$i];
    $e6f76c44bab27d1f$var$revLookup[$e6f76c44bab27d1f$var$code.charCodeAt($e6f76c44bab27d1f$var$i)] = $e6f76c44bab27d1f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e6f76c44bab27d1f$var$revLookup['-'.charCodeAt(0)] = 62;
$e6f76c44bab27d1f$var$revLookup['_'.charCodeAt(0)] = 63;
function $e6f76c44bab27d1f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e6f76c44bab27d1f$var$byteLength(b64) {
    var lens = $e6f76c44bab27d1f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e6f76c44bab27d1f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e6f76c44bab27d1f$var$toByteArray(b64) {
    var tmp;
    var lens = $e6f76c44bab27d1f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e6f76c44bab27d1f$var$Arr($e6f76c44bab27d1f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i)] << 18 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i)] << 2 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i)] << 10 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e6f76c44bab27d1f$var$tripletToBase64(num) {
    return $e6f76c44bab27d1f$var$lookup[num >> 18 & 0x3F] + $e6f76c44bab27d1f$var$lookup[num >> 12 & 0x3F] + $e6f76c44bab27d1f$var$lookup[num >> 6 & 0x3F] + $e6f76c44bab27d1f$var$lookup[num & 0x3F];
}
function $e6f76c44bab27d1f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e6f76c44bab27d1f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e6f76c44bab27d1f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e6f76c44bab27d1f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e6f76c44bab27d1f$var$lookup[tmp >> 2] + $e6f76c44bab27d1f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e6f76c44bab27d1f$var$lookup[tmp >> 10] + $e6f76c44bab27d1f$var$lookup[tmp >> 4 & 0x3F] + $e6f76c44bab27d1f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("oaTF8", function(module, exports) {

$parcel$export(module.exports, "read", () => $048ab1e1373f922a$export$aafa59e2e03f2942, (v) => $048ab1e1373f922a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $048ab1e1373f922a$export$68d8715fc104d294, (v) => $048ab1e1373f922a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $048ab1e1373f922a$export$aafa59e2e03f2942;
var $048ab1e1373f922a$export$68d8715fc104d294;
$048ab1e1373f922a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$048ab1e1373f922a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("k2jz9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReplayableAudioNode = void 0;
class $e9632beacc52811d$var$ReplayableAudioNode {
    constructor(audioSource, bytesPerSecond){
        this.privBuffers = [];
        this.privReplayOffset = 0;
        this.privLastShrinkOffset = 0;
        this.privBufferStartOffset = 0;
        this.privBufferSerial = 0;
        this.privBufferedBytes = 0;
        this.privReplay = false;
        this.privLastChunkAcquiredTime = 0;
        this.privAudioNode = audioSource;
        this.privBytesPerSecond = bytesPerSecond;
    }
    id() {
        return this.privAudioNode.id();
    }
    // Reads and returns the next chunk of audio buffer.
    // If replay of existing buffers are needed, read() will first seek and replay
    // existing content, and upoin completion it will read new content from the underlying
    // audio node, saving that content into the replayable buffers.
    read() {
        // if there is a replay request to honor.
        if (!!this.privReplay && this.privBuffers.length !== 0) {
            // Find the start point in the buffers.
            // Offsets are in 100ns increments.
            // So how many bytes do we need to seek to get the right offset?
            const offsetToSeek = this.privReplayOffset - this.privBufferStartOffset;
            let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
            if (0 !== bytesToSeek % 2) bytesToSeek++;
            let i = 0;
            while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
            if (i < this.privBuffers.length) {
                const retVal = this.privBuffers[i].chunk.buffer.slice(bytesToSeek);
                this.privReplayOffset += retVal.byteLength / this.privBytesPerSecond * 1e+7;
                // If we've reached the end of the buffers, stop replaying.
                if (i === this.privBuffers.length - 1) this.privReplay = false;
                return Promise.resolve({
                    buffer: retVal,
                    isEnd: false,
                    timeReceived: this.privBuffers[i].chunk.timeReceived
                });
            }
        }
        return this.privAudioNode.read().then((result)=>{
            if (result && result.buffer && this.privBuffers) {
                this.privBuffers.push(new $e9632beacc52811d$var$BufferEntry(result, this.privBufferSerial++, this.privBufferedBytes));
                this.privBufferedBytes += result.buffer.byteLength;
            }
            return result;
        });
    }
    detach() {
        this.privBuffers = undefined;
        return this.privAudioNode.detach();
    }
    replay() {
        if (this.privBuffers && 0 !== this.privBuffers.length) {
            this.privReplay = true;
            this.privReplayOffset = this.privLastShrinkOffset;
        }
    }
    // Shrinks the existing audio buffers to start at the new offset, or at the
    // beginning of the buffer closest to the requested offset.
    // A replay request will start from the last shrink point.
    shrinkBuffers(offset) {
        if (this.privBuffers === undefined || this.privBuffers.length === 0) return;
        this.privLastShrinkOffset = offset;
        // Find the start point in the buffers.
        // Offsets are in 100ns increments.
        // So how many bytes do we need to seek to get the right offset?
        const offsetToSeek = offset - this.privBufferStartOffset;
        let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
        let i = 0;
        while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
        this.privBufferStartOffset = Math.round(offset - bytesToSeek / this.privBytesPerSecond * 1e+7);
        this.privBuffers = this.privBuffers.slice(i);
    }
    // Finds the time a buffer of audio was first seen by offset.
    findTimeAtOffset(offset) {
        if (offset < this.privBufferStartOffset || this.privBuffers === undefined) return 0;
        for (const value of this.privBuffers){
            const startOffset = value.byteOffset / this.privBytesPerSecond * 1e7;
            const endOffset = startOffset + value.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
            if (offset >= startOffset && offset <= endOffset) return value.chunk.timeReceived;
        }
        return 0;
    }
}
module.exports.ReplayableAudioNode = $e9632beacc52811d$var$ReplayableAudioNode;
// Primary use of this class is to help debugging problems with the replay
// code. If the memory cost of alloc / dealloc gets too much, drop it and just use
// the ArrayBuffer directly.
class $e9632beacc52811d$var$BufferEntry {
    constructor(chunk, serial, byteOffset){
        this.chunk = chunk;
        this.serial = serial;
        this.byteOffset = byteOffset;
    }
}

});

parcelRegister("bRS6a", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyInfo = void 0;

var $gttSn = parcelRequire("gttSn");
class $8a3e9bc939eeb4f6$var$ProxyInfo {
    constructor(proxyHostName, proxyPort, proxyUserName, proxyPassword){
        this.privProxyHostName = proxyHostName;
        this.privProxyPort = proxyPort;
        this.privProxyUserName = proxyUserName;
        this.privProxyPassword = proxyPassword;
    }
    static fromParameters(parameters) {
        return new $8a3e9bc939eeb4f6$var$ProxyInfo(parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_ProxyHostName), parseInt(parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_ProxyPort), 10), parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_ProxyUserName), parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_ProxyPassword));
    }
    static fromRecognizerConfig(config) {
        return this.fromParameters(config.parameters);
    }
    get HostName() {
        return this.privProxyHostName;
    }
    get Port() {
        return this.privProxyPort;
    }
    get UserName() {
        return this.privProxyUserName;
    }
    get Password() {
        return this.privProxyPassword;
    }
}
module.exports.ProxyInfo = $8a3e9bc939eeb4f6$var$ProxyInfo;

});
parcelRegister("gttSn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomCommandsConfig = module.exports.BotFrameworkConfig = module.exports.DialogServiceConfig = module.exports.PhraseListGrammar = module.exports.Connection = module.exports.ServiceEventArgs = module.exports.ConnectionEventArgs = module.exports.CancellationErrorCode = module.exports.CancellationDetails = module.exports.CancellationDetailsBase = module.exports.TranslationRecognitionCanceledEventArgs = module.exports.NoMatchDetails = module.exports.NoMatchReason = module.exports.Translations = module.exports.TranslationRecognizer = module.exports.SpeechRecognizer = module.exports.Recognizer = module.exports.PropertyId = module.exports.PropertyCollection = module.exports.SpeechTranslationConfigImpl = module.exports.SpeechTranslationConfig = module.exports.SpeechConfigImpl = module.exports.SpeechConfig = module.exports.ResultReason = module.exports.TranslationSynthesisResult = module.exports.TranslationRecognitionResult = module.exports.TranslationSynthesisEventArgs = module.exports.TranslationRecognitionEventArgs = module.exports.SpeechRecognitionCanceledEventArgs = module.exports.MeetingTranscriptionEventArgs = module.exports.ConversationTranscriptionEventArgs = module.exports.SpeechRecognitionEventArgs = module.exports.SpeechRecognitionResult = module.exports.RecognitionResult = module.exports.OutputFormat = module.exports.RecognitionEventArgs = module.exports.SessionEventArgs = module.exports.KeywordRecognitionModel = module.exports.PushAudioOutputStreamCallback = module.exports.PullAudioInputStreamCallback = module.exports.CancellationReason = module.exports.PushAudioOutputStream = module.exports.PullAudioOutputStream = module.exports.AudioOutputStream = module.exports.PushAudioInputStream = module.exports.PullAudioInputStream = module.exports.AudioInputStream = module.exports.AudioFormatTag = module.exports.AudioStreamFormat = module.exports.AudioConfig = void 0;
module.exports.AvatarSynthesizer = module.exports.AvatarEventArgs = module.exports.AvatarConfig = module.exports.LanguageIdMode = module.exports.PronunciationAssessmentResult = module.exports.PronunciationAssessmentConfig = module.exports.PronunciationAssessmentGranularity = module.exports.PronunciationAssessmentGradingSystem = module.exports.MeetingTranscriptionCanceledEventArgs = module.exports.ConversationTranscriptionCanceledEventArgs = module.exports.SpeakerAudioDestination = module.exports.VoiceInfo = module.exports.SynthesisVoiceType = module.exports.SynthesisVoiceGender = module.exports.SynthesisVoicesResult = module.exports.SpeechSynthesisBoundaryType = module.exports.SpeechSynthesisVisemeEventArgs = module.exports.SpeechSynthesisBookmarkEventArgs = module.exports.SpeechSynthesisWordBoundaryEventArgs = module.exports.SpeechSynthesisEventArgs = module.exports.SpeechSynthesisResult = module.exports.SynthesisResult = module.exports.SpeechSynthesizer = module.exports.SpeechSynthesisOutputFormat = module.exports.Synthesizer = module.exports.User = module.exports.ParticipantChangedReason = module.exports.Participant = module.exports.MeetingTranscriber = module.exports.Meeting = module.exports.ConversationTranscriptionResult = module.exports.ConversationTranscriber = module.exports.ConversationTranslator = module.exports.ConversationTranslationResult = module.exports.ConversationTranslationEventArgs = module.exports.ConversationTranslationCanceledEventArgs = module.exports.ConversationParticipantsChangedEventArgs = module.exports.ConversationExpirationEventArgs = module.exports.Conversation = module.exports.SourceLanguageConfig = module.exports.AutoDetectSourceLanguageResult = module.exports.AutoDetectSourceLanguageConfig = module.exports.ConnectionMessage = module.exports.ConnectionMessageEventArgs = module.exports.BaseAudioPlayer = module.exports.ProfanityOption = module.exports.ServicePropertyChannel = module.exports.TurnStatusReceivedEventArgs = module.exports.ActivityReceivedEventArgs = module.exports.DialogServiceConnector = void 0;
module.exports.LogLevel = module.exports.Diagnostics = module.exports.AvatarWebRTCConnectionResult = module.exports.Coordinate = module.exports.AvatarVideoFormat = void 0;

var $85V5Z = parcelRequire("85V5Z");
Object.defineProperty(module.exports, "AudioConfig", {
    enumerable: true,
    get: function() {
        return $85V5Z.AudioConfig;
    }
});

var $hzVTX = parcelRequire("hzVTX");
Object.defineProperty(module.exports, "AudioStreamFormat", {
    enumerable: true,
    get: function() {
        return $hzVTX.AudioStreamFormat;
    }
});
Object.defineProperty(module.exports, "AudioFormatTag", {
    enumerable: true,
    get: function() {
        return $hzVTX.AudioFormatTag;
    }
});

var $35Ity = parcelRequire("35Ity");
Object.defineProperty(module.exports, "AudioInputStream", {
    enumerable: true,
    get: function() {
        return $35Ity.AudioInputStream;
    }
});
Object.defineProperty(module.exports, "PullAudioInputStream", {
    enumerable: true,
    get: function() {
        return $35Ity.PullAudioInputStream;
    }
});
Object.defineProperty(module.exports, "PushAudioInputStream", {
    enumerable: true,
    get: function() {
        return $35Ity.PushAudioInputStream;
    }
});

var $kzV1n = parcelRequire("kzV1n");
Object.defineProperty(module.exports, "AudioOutputStream", {
    enumerable: true,
    get: function() {
        return $kzV1n.AudioOutputStream;
    }
});
Object.defineProperty(module.exports, "PullAudioOutputStream", {
    enumerable: true,
    get: function() {
        return $kzV1n.PullAudioOutputStream;
    }
});
Object.defineProperty(module.exports, "PushAudioOutputStream", {
    enumerable: true,
    get: function() {
        return $kzV1n.PushAudioOutputStream;
    }
});

var $6Oi8a = parcelRequire("6Oi8a");
Object.defineProperty(module.exports, "CancellationReason", {
    enumerable: true,
    get: function() {
        return $6Oi8a.CancellationReason;
    }
});

var $7pMg9 = parcelRequire("7pMg9");
Object.defineProperty(module.exports, "PullAudioInputStreamCallback", {
    enumerable: true,
    get: function() {
        return $7pMg9.PullAudioInputStreamCallback;
    }
});

var $92Nur = parcelRequire("92Nur");
Object.defineProperty(module.exports, "PushAudioOutputStreamCallback", {
    enumerable: true,
    get: function() {
        return $92Nur.PushAudioOutputStreamCallback;
    }
});

var $b0rl7 = parcelRequire("b0rl7");
Object.defineProperty(module.exports, "KeywordRecognitionModel", {
    enumerable: true,
    get: function() {
        return $b0rl7.KeywordRecognitionModel;
    }
});

var $83GF9 = parcelRequire("83GF9");
Object.defineProperty(module.exports, "SessionEventArgs", {
    enumerable: true,
    get: function() {
        return $83GF9.SessionEventArgs;
    }
});

var $jBghy = parcelRequire("jBghy");
Object.defineProperty(module.exports, "RecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $jBghy.RecognitionEventArgs;
    }
});

var $jcTbW = parcelRequire("jcTbW");
Object.defineProperty(module.exports, "OutputFormat", {
    enumerable: true,
    get: function() {
        return $jcTbW.OutputFormat;
    }
});

var $fzoDC = parcelRequire("fzoDC");
Object.defineProperty(module.exports, "RecognitionResult", {
    enumerable: true,
    get: function() {
        return $fzoDC.RecognitionResult;
    }
});

var $b5LoR = parcelRequire("b5LoR");
Object.defineProperty(module.exports, "SpeechRecognitionResult", {
    enumerable: true,
    get: function() {
        return $b5LoR.SpeechRecognitionResult;
    }
});

var $9naJi = parcelRequire("9naJi");
Object.defineProperty(module.exports, "SpeechRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $9naJi.SpeechRecognitionEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriptionEventArgs", {
    enumerable: true,
    get: function() {
        return $9naJi.ConversationTranscriptionEventArgs;
    }
});
Object.defineProperty(module.exports, "MeetingTranscriptionEventArgs", {
    enumerable: true,
    get: function() {
        return $9naJi.MeetingTranscriptionEventArgs;
    }
});

var $iGIs8 = parcelRequire("iGIs8");
Object.defineProperty(module.exports, "SpeechRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $iGIs8.SpeechRecognitionCanceledEventArgs;
    }
});

var $iTP4M = parcelRequire("iTP4M");
Object.defineProperty(module.exports, "TranslationRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $iTP4M.TranslationRecognitionEventArgs;
    }
});

var $8FYnw = parcelRequire("8FYnw");
Object.defineProperty(module.exports, "TranslationSynthesisEventArgs", {
    enumerable: true,
    get: function() {
        return $8FYnw.TranslationSynthesisEventArgs;
    }
});

var $7duHD = parcelRequire("7duHD");
Object.defineProperty(module.exports, "TranslationRecognitionResult", {
    enumerable: true,
    get: function() {
        return $7duHD.TranslationRecognitionResult;
    }
});

var $bbzu4 = parcelRequire("bbzu4");
Object.defineProperty(module.exports, "TranslationSynthesisResult", {
    enumerable: true,
    get: function() {
        return $bbzu4.TranslationSynthesisResult;
    }
});

var $20d7X = parcelRequire("20d7X");
Object.defineProperty(module.exports, "ResultReason", {
    enumerable: true,
    get: function() {
        return $20d7X.ResultReason;
    }
});

var $fnMfN = parcelRequire("fnMfN");
Object.defineProperty(module.exports, "SpeechConfig", {
    enumerable: true,
    get: function() {
        return $fnMfN.SpeechConfig;
    }
});
Object.defineProperty(module.exports, "SpeechConfigImpl", {
    enumerable: true,
    get: function() {
        return $fnMfN.SpeechConfigImpl;
    }
});

var $ineJh = parcelRequire("ineJh");
Object.defineProperty(module.exports, "SpeechTranslationConfig", {
    enumerable: true,
    get: function() {
        return $ineJh.SpeechTranslationConfig;
    }
});
Object.defineProperty(module.exports, "SpeechTranslationConfigImpl", {
    enumerable: true,
    get: function() {
        return $ineJh.SpeechTranslationConfigImpl;
    }
});

var $isROj = parcelRequire("isROj");
Object.defineProperty(module.exports, "PropertyCollection", {
    enumerable: true,
    get: function() {
        return $isROj.PropertyCollection;
    }
});

var $fWPg2 = parcelRequire("fWPg2");
Object.defineProperty(module.exports, "PropertyId", {
    enumerable: true,
    get: function() {
        return $fWPg2.PropertyId;
    }
});

var $fTUeo = parcelRequire("fTUeo");
Object.defineProperty(module.exports, "Recognizer", {
    enumerable: true,
    get: function() {
        return $fTUeo.Recognizer;
    }
});

var $2eIQR = parcelRequire("2eIQR");
Object.defineProperty(module.exports, "SpeechRecognizer", {
    enumerable: true,
    get: function() {
        return $2eIQR.SpeechRecognizer;
    }
});

var $4s3Fn = parcelRequire("4s3Fn");
Object.defineProperty(module.exports, "TranslationRecognizer", {
    enumerable: true,
    get: function() {
        return $4s3Fn.TranslationRecognizer;
    }
});

var $gJEne = parcelRequire("gJEne");
Object.defineProperty(module.exports, "Translations", {
    enumerable: true,
    get: function() {
        return $gJEne.Translations;
    }
});

var $k9CAk = parcelRequire("k9CAk");
Object.defineProperty(module.exports, "NoMatchReason", {
    enumerable: true,
    get: function() {
        return $k9CAk.NoMatchReason;
    }
});

var $iAXt8 = parcelRequire("iAXt8");
Object.defineProperty(module.exports, "NoMatchDetails", {
    enumerable: true,
    get: function() {
        return $iAXt8.NoMatchDetails;
    }
});

var $2FCvx = parcelRequire("2FCvx");
Object.defineProperty(module.exports, "TranslationRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $2FCvx.TranslationRecognitionCanceledEventArgs;
    }
});

var $9zn0S = parcelRequire("9zn0S");
Object.defineProperty(module.exports, "CancellationDetailsBase", {
    enumerable: true,
    get: function() {
        return $9zn0S.CancellationDetailsBase;
    }
});

var $2dQl7 = parcelRequire("2dQl7");
Object.defineProperty(module.exports, "CancellationDetails", {
    enumerable: true,
    get: function() {
        return $2dQl7.CancellationDetails;
    }
});

var $5bdH7 = parcelRequire("5bdH7");
Object.defineProperty(module.exports, "CancellationErrorCode", {
    enumerable: true,
    get: function() {
        return $5bdH7.CancellationErrorCode;
    }
});

var $5QSwF = parcelRequire("5QSwF");
Object.defineProperty(module.exports, "ConnectionEventArgs", {
    enumerable: true,
    get: function() {
        return $5QSwF.ConnectionEventArgs;
    }
});

var $cGYnP = parcelRequire("cGYnP");
Object.defineProperty(module.exports, "ServiceEventArgs", {
    enumerable: true,
    get: function() {
        return $cGYnP.ServiceEventArgs;
    }
});

var $e8g5r = parcelRequire("e8g5r");
Object.defineProperty(module.exports, "Connection", {
    enumerable: true,
    get: function() {
        return $e8g5r.Connection;
    }
});

var $jjpOc = parcelRequire("jjpOc");
Object.defineProperty(module.exports, "PhraseListGrammar", {
    enumerable: true,
    get: function() {
        return $jjpOc.PhraseListGrammar;
    }
});

var $bLWpJ = parcelRequire("bLWpJ");
Object.defineProperty(module.exports, "DialogServiceConfig", {
    enumerable: true,
    get: function() {
        return $bLWpJ.DialogServiceConfig;
    }
});

var $eaQev = parcelRequire("eaQev");
Object.defineProperty(module.exports, "BotFrameworkConfig", {
    enumerable: true,
    get: function() {
        return $eaQev.BotFrameworkConfig;
    }
});

var $eFm2B = parcelRequire("eFm2B");
Object.defineProperty(module.exports, "CustomCommandsConfig", {
    enumerable: true,
    get: function() {
        return $eFm2B.CustomCommandsConfig;
    }
});

var $6r8Ji = parcelRequire("6r8Ji");
Object.defineProperty(module.exports, "DialogServiceConnector", {
    enumerable: true,
    get: function() {
        return $6r8Ji.DialogServiceConnector;
    }
});

var $2zgjg = parcelRequire("2zgjg");
Object.defineProperty(module.exports, "ActivityReceivedEventArgs", {
    enumerable: true,
    get: function() {
        return $2zgjg.ActivityReceivedEventArgs;
    }
});

var $23BEu = parcelRequire("23BEu");
Object.defineProperty(module.exports, "TurnStatusReceivedEventArgs", {
    enumerable: true,
    get: function() {
        return $23BEu.TurnStatusReceivedEventArgs;
    }
});

var $2PlNu = parcelRequire("2PlNu");
Object.defineProperty(module.exports, "ServicePropertyChannel", {
    enumerable: true,
    get: function() {
        return $2PlNu.ServicePropertyChannel;
    }
});

var $biETf = parcelRequire("biETf");
Object.defineProperty(module.exports, "ProfanityOption", {
    enumerable: true,
    get: function() {
        return $biETf.ProfanityOption;
    }
});

var $9GDKk = parcelRequire("9GDKk");
Object.defineProperty(module.exports, "BaseAudioPlayer", {
    enumerable: true,
    get: function() {
        return $9GDKk.BaseAudioPlayer;
    }
});

var $8E9OG = parcelRequire("8E9OG");
Object.defineProperty(module.exports, "ConnectionMessageEventArgs", {
    enumerable: true,
    get: function() {
        return $8E9OG.ConnectionMessageEventArgs;
    }
});

var $2wzdb = parcelRequire("2wzdb");
Object.defineProperty(module.exports, "ConnectionMessage", {
    enumerable: true,
    get: function() {
        return $2wzdb.ConnectionMessage;
    }
});

var $dbzYj = parcelRequire("dbzYj");
Object.defineProperty(module.exports, "AutoDetectSourceLanguageConfig", {
    enumerable: true,
    get: function() {
        return $dbzYj.AutoDetectSourceLanguageConfig;
    }
});

var $5jtSb = parcelRequire("5jtSb");
Object.defineProperty(module.exports, "AutoDetectSourceLanguageResult", {
    enumerable: true,
    get: function() {
        return $5jtSb.AutoDetectSourceLanguageResult;
    }
});

var $9fvCG = parcelRequire("9fvCG");
Object.defineProperty(module.exports, "SourceLanguageConfig", {
    enumerable: true,
    get: function() {
        return $9fvCG.SourceLanguageConfig;
    }
});

var $ejSiE = parcelRequire("ejSiE");
Object.defineProperty(module.exports, "Conversation", {
    enumerable: true,
    get: function() {
        return $ejSiE.Conversation;
    }
});
Object.defineProperty(module.exports, "ConversationExpirationEventArgs", {
    enumerable: true,
    get: function() {
        return $ejSiE.ConversationExpirationEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationParticipantsChangedEventArgs", {
    enumerable: true,
    get: function() {
        return $ejSiE.ConversationParticipantsChangedEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $ejSiE.ConversationTranslationCanceledEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $ejSiE.ConversationTranslationEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationResult", {
    enumerable: true,
    get: function() {
        return $ejSiE.ConversationTranslationResult;
    }
});
Object.defineProperty(module.exports, "ConversationTranslator", {
    enumerable: true,
    get: function() {
        return $ejSiE.ConversationTranslator;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriber", {
    enumerable: true,
    get: function() {
        return $ejSiE.ConversationTranscriber;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriptionResult", {
    enumerable: true,
    get: function() {
        return $ejSiE.ConversationTranscriptionResult;
    }
});
Object.defineProperty(module.exports, "Meeting", {
    enumerable: true,
    get: function() {
        return $ejSiE.Meeting;
    }
});
Object.defineProperty(module.exports, "MeetingTranscriber", {
    enumerable: true,
    get: function() {
        return $ejSiE.MeetingTranscriber;
    }
});
Object.defineProperty(module.exports, "Participant", {
    enumerable: true,
    get: function() {
        return $ejSiE.Participant;
    }
});
Object.defineProperty(module.exports, "ParticipantChangedReason", {
    enumerable: true,
    get: function() {
        return $ejSiE.ParticipantChangedReason;
    }
});
Object.defineProperty(module.exports, "User", {
    enumerable: true,
    get: function() {
        return $ejSiE.User;
    }
});

var $ctHGQ = parcelRequire("ctHGQ");
Object.defineProperty(module.exports, "Synthesizer", {
    enumerable: true,
    get: function() {
        return $ctHGQ.Synthesizer;
    }
});

var $38QGp = parcelRequire("38QGp");
Object.defineProperty(module.exports, "SpeechSynthesisOutputFormat", {
    enumerable: true,
    get: function() {
        return $38QGp.SpeechSynthesisOutputFormat;
    }
});

var $khunP = parcelRequire("khunP");
Object.defineProperty(module.exports, "SpeechSynthesizer", {
    enumerable: true,
    get: function() {
        return $khunP.SpeechSynthesizer;
    }
});

var $jNWUv = parcelRequire("jNWUv");
Object.defineProperty(module.exports, "SynthesisResult", {
    enumerable: true,
    get: function() {
        return $jNWUv.SynthesisResult;
    }
});

var $3GDrg = parcelRequire("3GDrg");
Object.defineProperty(module.exports, "SpeechSynthesisResult", {
    enumerable: true,
    get: function() {
        return $3GDrg.SpeechSynthesisResult;
    }
});

var $jGC6z = parcelRequire("jGC6z");
Object.defineProperty(module.exports, "SpeechSynthesisEventArgs", {
    enumerable: true,
    get: function() {
        return $jGC6z.SpeechSynthesisEventArgs;
    }
});

var $8UuSQ = parcelRequire("8UuSQ");
Object.defineProperty(module.exports, "SpeechSynthesisWordBoundaryEventArgs", {
    enumerable: true,
    get: function() {
        return $8UuSQ.SpeechSynthesisWordBoundaryEventArgs;
    }
});

var $ijhvW = parcelRequire("ijhvW");
Object.defineProperty(module.exports, "SpeechSynthesisBookmarkEventArgs", {
    enumerable: true,
    get: function() {
        return $ijhvW.SpeechSynthesisBookmarkEventArgs;
    }
});

var $7cBsb = parcelRequire("7cBsb");
Object.defineProperty(module.exports, "SpeechSynthesisVisemeEventArgs", {
    enumerable: true,
    get: function() {
        return $7cBsb.SpeechSynthesisVisemeEventArgs;
    }
});

var $jUg6s = parcelRequire("jUg6s");
Object.defineProperty(module.exports, "SpeechSynthesisBoundaryType", {
    enumerable: true,
    get: function() {
        return $jUg6s.SpeechSynthesisBoundaryType;
    }
});

var $8EK5K = parcelRequire("8EK5K");
Object.defineProperty(module.exports, "SynthesisVoicesResult", {
    enumerable: true,
    get: function() {
        return $8EK5K.SynthesisVoicesResult;
    }
});

var $dDI25 = parcelRequire("dDI25");
Object.defineProperty(module.exports, "SynthesisVoiceGender", {
    enumerable: true,
    get: function() {
        return $dDI25.SynthesisVoiceGender;
    }
});
Object.defineProperty(module.exports, "SynthesisVoiceType", {
    enumerable: true,
    get: function() {
        return $dDI25.SynthesisVoiceType;
    }
});
Object.defineProperty(module.exports, "VoiceInfo", {
    enumerable: true,
    get: function() {
        return $dDI25.VoiceInfo;
    }
});

var $3RAj2 = parcelRequire("3RAj2");
Object.defineProperty(module.exports, "SpeakerAudioDestination", {
    enumerable: true,
    get: function() {
        return $3RAj2.SpeakerAudioDestination;
    }
});

var $jftUp = parcelRequire("jftUp");
Object.defineProperty(module.exports, "ConversationTranscriptionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $jftUp.ConversationTranscriptionCanceledEventArgs;
    }
});

var $2bzvy = parcelRequire("2bzvy");
Object.defineProperty(module.exports, "MeetingTranscriptionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $2bzvy.MeetingTranscriptionCanceledEventArgs;
    }
});

var $hfhIk = parcelRequire("hfhIk");
Object.defineProperty(module.exports, "PronunciationAssessmentGradingSystem", {
    enumerable: true,
    get: function() {
        return $hfhIk.PronunciationAssessmentGradingSystem;
    }
});

var $2bYA3 = parcelRequire("2bYA3");
Object.defineProperty(module.exports, "PronunciationAssessmentGranularity", {
    enumerable: true,
    get: function() {
        return $2bYA3.PronunciationAssessmentGranularity;
    }
});

var $93Snx = parcelRequire("93Snx");
Object.defineProperty(module.exports, "PronunciationAssessmentConfig", {
    enumerable: true,
    get: function() {
        return $93Snx.PronunciationAssessmentConfig;
    }
});

var $ay2D3 = parcelRequire("ay2D3");
Object.defineProperty(module.exports, "PronunciationAssessmentResult", {
    enumerable: true,
    get: function() {
        return $ay2D3.PronunciationAssessmentResult;
    }
});

var $7Xt19 = parcelRequire("7Xt19");
Object.defineProperty(module.exports, "LanguageIdMode", {
    enumerable: true,
    get: function() {
        return $7Xt19.LanguageIdMode;
    }
});

var $dnZrT = parcelRequire("dnZrT");
Object.defineProperty(module.exports, "AvatarConfig", {
    enumerable: true,
    get: function() {
        return $dnZrT.AvatarConfig;
    }
});

var $3c1Tt = parcelRequire("3c1Tt");
Object.defineProperty(module.exports, "AvatarEventArgs", {
    enumerable: true,
    get: function() {
        return $3c1Tt.AvatarEventArgs;
    }
});

var $78veo = parcelRequire("78veo");
Object.defineProperty(module.exports, "AvatarSynthesizer", {
    enumerable: true,
    get: function() {
        return $78veo.AvatarSynthesizer;
    }
});

var $lvcSj = parcelRequire("lvcSj");
Object.defineProperty(module.exports, "AvatarVideoFormat", {
    enumerable: true,
    get: function() {
        return $lvcSj.AvatarVideoFormat;
    }
});
Object.defineProperty(module.exports, "Coordinate", {
    enumerable: true,
    get: function() {
        return $lvcSj.Coordinate;
    }
});

var $hwjbb = parcelRequire("hwjbb");
Object.defineProperty(module.exports, "AvatarWebRTCConnectionResult", {
    enumerable: true,
    get: function() {
        return $hwjbb.AvatarWebRTCConnectionResult;
    }
});

var $gT5Jf = parcelRequire("gT5Jf");
Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return $gT5Jf.Diagnostics;
    }
});

var $aAcmn = parcelRequire("aAcmn");
Object.defineProperty(module.exports, "LogLevel", {
    enumerable: true,
    get: function() {
        return $aAcmn.LogLevel;
    }
});

});
parcelRegister("85V5Z", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioOutputConfigImpl = module.exports.AudioConfigImpl = module.exports.AudioConfig = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");

var $5d2Dz = parcelRequire("5d2Dz");

var $35Ity = parcelRequire("35Ity");

var $kzV1n = parcelRequire("kzV1n");
/**
 * Represents audio input configuration used for specifying what type of input to use (microphone, file, stream).
 * @class AudioConfig
 * Updated in version 1.11.0
 */ class $5e4b14609c3bc285$var$AudioConfig {
    /**
     * Creates an AudioConfig object representing the default microphone on the system.
     * @member AudioConfig.fromDefaultMicrophoneInput
     * @function
     * @public
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromDefaultMicrophoneInput() {
        const pcmRecorder = new $s6RJO.PcmRecorder(true);
        return new $5e4b14609c3bc285$var$AudioConfigImpl(new $s6RJO.MicAudioSource(pcmRecorder));
    }
    /**
     * Creates an AudioConfig object representing a microphone with the specified device ID.
     * @member AudioConfig.fromMicrophoneInput
     * @function
     * @public
     * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
     * Default microphone is used the value is omitted.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromMicrophoneInput(deviceId) {
        const pcmRecorder = new $s6RJO.PcmRecorder(true);
        return new $5e4b14609c3bc285$var$AudioConfigImpl(new $s6RJO.MicAudioSource(pcmRecorder, deviceId));
    }
    /**
     * Creates an AudioConfig object representing the specified file.
     * @member AudioConfig.fromWavFileInput
     * @function
     * @public
     * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromWavFileInput(file, name = "unnamedBuffer.wav") {
        return new $5e4b14609c3bc285$var$AudioConfigImpl(new $s6RJO.FileAudioSource(file, name));
    }
    /**
     * Creates an AudioConfig object representing the specified stream.
     * @member AudioConfig.fromStreamInput
     * @function
     * @public
     * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
     * stream. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromStreamInput(audioStream) {
        if (audioStream instanceof $gttSn.PullAudioInputStreamCallback) return new $5e4b14609c3bc285$var$AudioConfigImpl(new $35Ity.PullAudioInputStreamImpl(audioStream));
        if (audioStream instanceof $gttSn.AudioInputStream) return new $5e4b14609c3bc285$var$AudioConfigImpl(audioStream);
        if (typeof MediaStream !== "undefined" && audioStream instanceof MediaStream) {
            const pcmRecorder = new $s6RJO.PcmRecorder(false);
            return new $5e4b14609c3bc285$var$AudioConfigImpl(new $s6RJO.MicAudioSource(pcmRecorder, null, null, audioStream));
        }
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing the default speaker.
     * @member AudioConfig.fromDefaultSpeakerOutput
     * @function
     * @public
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromDefaultSpeakerOutput() {
        return new $5e4b14609c3bc285$var$AudioOutputConfigImpl(new $gttSn.SpeakerAudioDestination());
    }
    /**
     * Creates an AudioConfig object representing the custom IPlayer object.
     * You can use the IPlayer object to control pause, resume, etc.
     * @member AudioConfig.fromSpeakerOutput
     * @function
     * @public
     * @param {IPlayer} player - the IPlayer object for playback.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.12.0
     */ static fromSpeakerOutput(player) {
        if (player === undefined) return $5e4b14609c3bc285$var$AudioConfig.fromDefaultSpeakerOutput();
        if (player instanceof $gttSn.SpeakerAudioDestination) return new $5e4b14609c3bc285$var$AudioOutputConfigImpl(player);
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing a specified output audio file
     * @member AudioConfig.fromAudioFileOutput
     * @function
     * @public
     * @param {PathLike} filename - the filename of the output audio file
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromAudioFileOutput(filename) {
        return new $5e4b14609c3bc285$var$AudioOutputConfigImpl(new $5d2Dz.AudioFileWriter(filename));
    }
    /**
     * Creates an AudioConfig object representing a specified audio output stream
     * @member AudioConfig.fromStreamOutput
     * @function
     * @public
     * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
     * stream.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromStreamOutput(audioStream) {
        if (audioStream instanceof $gttSn.PushAudioOutputStreamCallback) return new $5e4b14609c3bc285$var$AudioOutputConfigImpl(new $kzV1n.PushAudioOutputStreamImpl(audioStream));
        if (audioStream instanceof $gttSn.PushAudioOutputStream) return new $5e4b14609c3bc285$var$AudioOutputConfigImpl(audioStream);
        if (audioStream instanceof $gttSn.PullAudioOutputStream) return new $5e4b14609c3bc285$var$AudioOutputConfigImpl(audioStream);
        throw new Error("Not Supported Type");
    }
}
module.exports.AudioConfig = $5e4b14609c3bc285$var$AudioConfig;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class AudioConfigImpl
 */ class $5e4b14609c3bc285$var$AudioConfigImpl extends $5e4b14609c3bc285$var$AudioConfig {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioSource} source - An audio source.
     */ constructor(source){
        super();
        this.privSource = source;
    }
    /**
     * Format information for the audio
     */ get format() {
        return this.privSource.format;
    }
    /**
     * @member AudioConfigImpl.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        this.privSource.turnOff().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
    }
    /**
     * @member AudioConfigImpl.prototype.id
     * @function
     * @public
     */ id() {
        return this.privSource.id();
    }
    /**
     * @member AudioConfigImpl.prototype.turnOn
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOn() {
        return this.privSource.turnOn();
    }
    /**
     * @member AudioConfigImpl.prototype.attach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     * @returns {Promise<IAudioStreamNode>} A promise.
     */ attach(audioNodeId) {
        return this.privSource.attach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.detach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     */ detach(audioNodeId) {
        return this.privSource.detach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.turnOff
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOff() {
        return this.privSource.turnOff();
    }
    /**
     * @member AudioConfigImpl.prototype.events
     * @function
     * @public
     * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
     */ get events() {
        return this.privSource.events;
    }
    setProperty(name, value) {
        $3SMEZ.Contracts.throwIfNull(value, "value");
        if (undefined !== this.privSource.setProperty) this.privSource.setProperty(name, value);
        else throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(name, def) {
        if (undefined !== this.privSource.getProperty) return this.privSource.getProperty(name, def);
        else throw new Error("This AudioConfig instance does not support getting properties.");
        return def;
    }
    get deviceInfo() {
        return this.privSource.deviceInfo;
    }
}
module.exports.AudioConfigImpl = $5e4b14609c3bc285$var$AudioConfigImpl;
class $5e4b14609c3bc285$var$AudioOutputConfigImpl extends $5e4b14609c3bc285$var$AudioConfig {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioDestination} destination - An audio destination.
     */ constructor(destination){
        super();
        this.privDestination = destination;
    }
    set format(format) {
        this.privDestination.format = format;
    }
    write(buffer) {
        this.privDestination.write(buffer);
    }
    close() {
        this.privDestination.close();
    }
    id() {
        return this.privDestination.id();
    }
    setProperty() {
        throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty() {
        throw new Error("This AudioConfig instance does not support getting properties.");
    }
}
module.exports.AudioOutputConfigImpl = $5e4b14609c3bc285$var$AudioOutputConfigImpl;

});
parcelRegister("5d2Dz", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $3cb0365e19847bc3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3cb0365e19847bc3$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3cb0365e19847bc3$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3cb0365e19847bc3$var$__createBinding(result, mod, k);
    }
    $3cb0365e19847bc3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioFileWriter = void 0;

const $3cb0365e19847bc3$var$fs = $3cb0365e19847bc3$var$__importStar((parcelRequire("9zn7p")));

var $3SMEZ = parcelRequire("3SMEZ");
class $3cb0365e19847bc3$var$AudioFileWriter {
    constructor(filename){
        $3SMEZ.Contracts.throwIfNullOrUndefined($3cb0365e19847bc3$var$fs.openSync, "\nFile System access not available, please use Push or PullAudioOutputStream");
        this.privFd = $3cb0365e19847bc3$var$fs.openSync(filename, "w");
    }
    set format(format) {
        $3SMEZ.Contracts.throwIfNotUndefined(this.privAudioFormat, "format is already set");
        this.privAudioFormat = format;
        let headerOffset = 0;
        if (this.privAudioFormat.hasHeader) headerOffset = this.privAudioFormat.header.byteLength;
        if (this.privFd !== undefined) this.privWriteStream = $3cb0365e19847bc3$var$fs.createWriteStream("", {
            fd: this.privFd,
            start: headerOffset,
            autoClose: false
        });
    }
    write(buffer) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing.");
        if (this.privWriteStream !== undefined) this.privWriteStream.write(new Uint8Array(buffer.slice(0)));
    }
    close() {
        if (this.privFd !== undefined) {
            this.privWriteStream.on("finish", ()=>{
                if (this.privAudioFormat.hasHeader) {
                    this.privAudioFormat.updateHeader(this.privWriteStream.bytesWritten);
                    $3cb0365e19847bc3$var$fs.writeSync(this.privFd, new Int8Array(this.privAudioFormat.header), 0, this.privAudioFormat.header.byteLength, 0);
                }
                $3cb0365e19847bc3$var$fs.closeSync(this.privFd);
                this.privFd = undefined;
            });
            this.privWriteStream.end();
        }
    }
    id() {
        return this.privId;
    }
}
module.exports.AudioFileWriter = $3cb0365e19847bc3$var$AudioFileWriter;

});

parcelRegister("35Ity", function(module, exports) {

var $f2Nvv = parcelRequire("f2Nvv");
var $240456aa2db316f1$require$Buffer = $f2Nvv.Buffer;
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PullAudioInputStreamImpl = module.exports.PullAudioInputStream = module.exports.PushAudioInputStreamImpl = module.exports.PushAudioInputStream = module.exports.AudioInputStream = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $8lWt4 = parcelRequire("8lWt4");

var $gttSn = parcelRequire("gttSn");

var $hzVTX = parcelRequire("hzVTX");
/**
 * Represents audio input stream used for custom audio input configurations.
 * @class AudioInputStream
 */ class $240456aa2db316f1$var$AudioInputStream {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member AudioInputStream.createPushStream
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The audio input stream being created.
     */ static createPushStream(format) {
        return $240456aa2db316f1$var$PushAudioInputStream.create(format);
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
     * and close() methods.
     * @member AudioInputStream.createPullStream
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
     * PullAudioInputStreamCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
     * the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The audio input stream being created.
     */ static createPullStream(callback, format) {
        return $240456aa2db316f1$var$PullAudioInputStream.create(callback, format);
    // throw new Error("Oops");
    }
}
module.exports.AudioInputStream = $240456aa2db316f1$var$AudioInputStream;
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @class PushAudioInputStream
 */ class $240456aa2db316f1$var$PushAudioInputStream extends $240456aa2db316f1$var$AudioInputStream {
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member PushAudioInputStream.create
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
     * push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The push audio input stream being created.
     */ static create(format) {
        return new $240456aa2db316f1$var$PushAudioInputStreamImpl(format);
    }
}
module.exports.PushAudioInputStream = $240456aa2db316f1$var$PushAudioInputStream;
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @private
 * @class PushAudioInputStreamImpl
 */ class $240456aa2db316f1$var$PushAudioInputStreamImpl extends $240456aa2db316f1$var$PushAudioInputStream {
    /**
     * Creates and initalizes an instance with the given values.
     * @constructor
     * @param {AudioStreamFormat} format - The audio stream format.
     */ constructor(format){
        super();
        if (format === undefined) this.privFormat = $hzVTX.AudioStreamFormatImpl.getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new $5OUhN.EventSource();
        this.privId = (0, $8lWt4.createNoDashGuid)();
        this.privStream = new $5OUhN.ChunkedArrayBufferStream(this.privFormat.avgBytesPerSec / 10);
    }
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PushAudioInputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PushAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new $5OUhN.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $5OUhN.AudioSourceReadyEvent(this.privId));
        return;
    }
    async attach(audioNodeId) {
        this.onEvent(new $5OUhN.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        await this.turnOn();
        const stream = this.privStream;
        this.onEvent(new $5OUhN.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
        return {
            detach: async ()=>{
                this.onEvent(new $5OUhN.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                return this.turnOff();
            },
            id: ()=>audioNodeId,
            read: ()=>stream.read()
        };
    }
    detach(audioNodeId) {
        this.onEvent(new $5OUhN.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: $hgjD5.connectivity.Unknown,
            manufacturer: "Speech SDK",
            model: "PushStream",
            samplerate: this.privFormat.samplesPerSec,
            type: $hgjD5.type.Stream
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $5OUhN.Events.instance.onEvent(event);
    }
    toBuffer(arrayBuffer) {
        const buf = $240456aa2db316f1$require$Buffer.alloc(arrayBuffer.byteLength);
        const view = new Uint8Array(arrayBuffer);
        for(let i = 0; i < buf.length; ++i)buf[i] = view[i];
        return buf;
    }
}
module.exports.PushAudioInputStreamImpl = $240456aa2db316f1$var$PushAudioInputStreamImpl;
/*
 * Represents audio input stream used for custom audio input configurations.
 * @class PullAudioInputStream
 */ class $240456aa2db316f1$var$PullAudioInputStream extends $240456aa2db316f1$var$AudioInputStream {
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @member PullAudioInputStream.create
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The push audio input stream being created.
     */ static create(callback, format) {
        return new $240456aa2db316f1$var$PullAudioInputStreamImpl(callback, format);
    }
}
module.exports.PullAudioInputStream = $240456aa2db316f1$var$PullAudioInputStream;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class PullAudioInputStreamImpl
 */ class $240456aa2db316f1$var$PullAudioInputStreamImpl extends $240456aa2db316f1$var$PullAudioInputStream {
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @constructor
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     */ constructor(callback, format){
        super();
        if (undefined === format) this.privFormat = $gttSn.AudioStreamFormat.getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new $5OUhN.EventSource();
        this.privId = (0, $8lWt4.createNoDashGuid)();
        this.privCallback = callback;
        this.privIsClosed = false;
        this.privBufferSize = this.privFormat.avgBytesPerSec / 10;
    }
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Closes the stream.
     * @member PullAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privIsClosed = true;
        this.privCallback.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new $5OUhN.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $5OUhN.AudioSourceReadyEvent(this.privId));
        return;
    }
    async attach(audioNodeId) {
        this.onEvent(new $5OUhN.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        await this.turnOn();
        this.onEvent(new $5OUhN.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
        return {
            detach: ()=>{
                this.privCallback.close();
                this.onEvent(new $5OUhN.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                return this.turnOff();
            },
            id: ()=>audioNodeId,
            read: ()=>{
                let totalBytes = 0;
                let transmitBuff;
                // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
                while(totalBytes < this.privBufferSize){
                    // Sizing the read buffer to the delta between the perfect size and what's left means we won't ever get too much
                    // data back.
                    const readBuff = new ArrayBuffer(this.privBufferSize - totalBytes);
                    const pulledBytes = this.privCallback.read(readBuff);
                    // If there is no return buffer yet defined, set the return buffer to the that was just populated.
                    // This was, if we have enough data there's no copy penalty, but if we don't we have a buffer that's the
                    // preferred size allocated.
                    if (undefined === transmitBuff) transmitBuff = readBuff;
                    else {
                        // Not the first bite at the apple, so fill the return buffer with the data we got back.
                        const intView = new Int8Array(transmitBuff);
                        intView.set(new Int8Array(readBuff), totalBytes);
                    }
                    // If there are no bytes to read, just break out and be done.
                    if (0 === pulledBytes) break;
                    totalBytes += pulledBytes;
                }
                return Promise.resolve({
                    buffer: transmitBuff.slice(0, totalBytes),
                    isEnd: this.privIsClosed || totalBytes === 0,
                    timeReceived: Date.now()
                });
            }
        };
    }
    detach(audioNodeId) {
        this.onEvent(new $5OUhN.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: $hgjD5.connectivity.Unknown,
            manufacturer: "Speech SDK",
            model: "PullStream",
            samplerate: this.privFormat.samplesPerSec,
            type: $hgjD5.type.Stream
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $5OUhN.Events.instance.onEvent(event);
    }
}
module.exports.PullAudioInputStreamImpl = $240456aa2db316f1$var$PullAudioInputStreamImpl;

});

parcelRegister("kzV1n", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PushAudioOutputStreamImpl = module.exports.PushAudioOutputStream = module.exports.PullAudioOutputStreamImpl = module.exports.PullAudioOutputStream = module.exports.AudioOutputStream = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $913NY = parcelRequire("913NY");
/**
 * Represents audio output stream used for custom audio output configurations.
 * @class AudioOutputStream
 */ class $efb34ec3a539ab8b$var$AudioOutputStream {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member AudioOutputStream.createPullStream
     * @function
     * @public
     * @returns {PullAudioOutputStream} The audio output stream being created.
     */ static createPullStream() {
        return $efb34ec3a539ab8b$var$PullAudioOutputStream.create();
    }
}
module.exports.AudioOutputStream = $efb34ec3a539ab8b$var$AudioOutputStream;
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @class PullAudioOutputStream
 */ class $efb34ec3a539ab8b$var$PullAudioOutputStream extends $efb34ec3a539ab8b$var$AudioOutputStream {
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member PullAudioOutputStream.create
     * @function
     * @public
     * @returns {PullAudioOutputStream} The push audio output stream being created.
     */ static create() {
        return new $efb34ec3a539ab8b$var$PullAudioOutputStreamImpl();
    }
}
module.exports.PullAudioOutputStream = $efb34ec3a539ab8b$var$PullAudioOutputStream;
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @private
 * @class PullAudioOutputStreamImpl
 */ class $efb34ec3a539ab8b$var$PullAudioOutputStreamImpl extends $efb34ec3a539ab8b$var$PullAudioOutputStream {
    /**
     * Creates and initializes an instance with the given values.
     * @constructor
     */ constructor(){
        super();
        this.privId = (0, $5OUhN.createNoDashGuid)();
        this.privStream = new $5OUhN.Stream();
    }
    /**
     * Sets the format information to the stream. For internal use only.
     * @param {AudioStreamFormat} format - the format to be set.
     */ set format(format) {
        if (format === undefined || format === null) this.privFormat = $913NY.AudioOutputFormatImpl.getDefaultOutputFormat();
        this.privFormat = format;
    }
    /**
     * Format information for the audio
     */ get format() {
        return this.privFormat;
    }
    /**
     * Checks if the stream is closed
     * @member PullAudioOutputStreamImpl.prototype.isClosed
     * @property
     * @public
     */ get isClosed() {
        return this.privStream.isClosed;
    }
    /**
     * Gets the id of the stream
     * @member PullAudioOutputStreamImpl.prototype.id
     * @property
     * @public
     */ id() {
        return this.privId;
    }
    /**
     * Reads audio data from the internal buffer.
     * @member PullAudioOutputStreamImpl.prototype.read
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
     * @returns {Promise<number>} - Audio buffer length has been read.
     */ async read(dataBuffer) {
        const intView = new Int8Array(dataBuffer);
        let totalBytes = 0;
        if (this.privLastChunkView !== undefined) {
            if (this.privLastChunkView.length > dataBuffer.byteLength) {
                intView.set(this.privLastChunkView.slice(0, dataBuffer.byteLength));
                this.privLastChunkView = this.privLastChunkView.slice(dataBuffer.byteLength);
                return Promise.resolve(dataBuffer.byteLength);
            }
            intView.set(this.privLastChunkView);
            totalBytes = this.privLastChunkView.length;
            this.privLastChunkView = undefined;
        }
        // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
        while(totalBytes < dataBuffer.byteLength && !this.privStream.isReadEnded){
            const chunk = await this.privStream.read();
            if (chunk !== undefined && !chunk.isEnd) {
                let tmpBuffer;
                if (chunk.buffer.byteLength > dataBuffer.byteLength - totalBytes) {
                    tmpBuffer = chunk.buffer.slice(0, dataBuffer.byteLength - totalBytes);
                    this.privLastChunkView = new Int8Array(chunk.buffer.slice(dataBuffer.byteLength - totalBytes));
                } else tmpBuffer = chunk.buffer;
                intView.set(new Int8Array(tmpBuffer), totalBytes);
                totalBytes += tmpBuffer.byteLength;
            } else this.privStream.readEnded();
        }
        return totalBytes;
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PullAudioOutputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(this.privStream, "must set format before writing");
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PullAudioOutputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
}
module.exports.PullAudioOutputStreamImpl = $efb34ec3a539ab8b$var$PullAudioOutputStreamImpl;
/*
 * Represents audio output stream used for custom audio output configurations.
 * @class PushAudioOutputStream
 */ class $efb34ec3a539ab8b$var$PushAudioOutputStream extends $efb34ec3a539ab8b$var$AudioOutputStream {
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * write() and close() methods.
     * @member PushAudioOutputStream.create
     * @function
     * @public
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     * @returns {PushAudioOutputStream} The push audio output stream being created.
     */ static create(callback) {
        return new $efb34ec3a539ab8b$var$PushAudioOutputStreamImpl(callback);
    }
}
module.exports.PushAudioOutputStream = $efb34ec3a539ab8b$var$PushAudioOutputStream;
/**
 * Represents audio output stream used for custom audio output configurations.
 * @private
 * @class PushAudioOutputStreamImpl
 */ class $efb34ec3a539ab8b$var$PushAudioOutputStreamImpl extends $efb34ec3a539ab8b$var$PushAudioOutputStream {
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * read() and close() methods.
     * @constructor
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     */ constructor(callback){
        super();
        this.privId = (0, $5OUhN.createNoDashGuid)();
        this.privCallback = callback;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set format(format) {}
    write(buffer) {
        if (!!this.privCallback.write) this.privCallback.write(buffer);
    }
    close() {
        if (!!this.privCallback.close) this.privCallback.close();
    }
    id() {
        return this.privId;
    }
}
module.exports.PushAudioOutputStreamImpl = $efb34ec3a539ab8b$var$PushAudioOutputStreamImpl;

});
parcelRegister("913NY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioOutputFormatImpl = void 0;

var $38QGp = parcelRequire("38QGp");

var $hzVTX = parcelRequire("hzVTX");
/**
 * @private
 * @class AudioOutputFormatImpl
 * Updated in version 1.17.0
 */ // eslint-disable-next-line max-classes-per-file
class $690728ad26725fe0$var$AudioOutputFormatImpl extends $hzVTX.AudioStreamFormatImpl {
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param formatTag
     * @param {number} channels - Number of channels.
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} avgBytesPerSec - Average bytes per second.
     * @param {number} blockAlign - Block alignment.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {string} audioFormatString - Audio format string
     * @param {string} requestAudioFormatString - Audio format string sent to service.
     * @param {boolean} hasHeader - If the format has header or not.
     */ constructor(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, audioFormatString, requestAudioFormatString, hasHeader){
        super(samplesPerSec, bitsPerSample, channels, formatTag);
        this.formatTag = formatTag;
        this.avgBytesPerSec = avgBytesPerSec;
        this.blockAlign = blockAlign;
        this.priAudioFormatString = audioFormatString;
        this.priRequestAudioFormatString = requestAudioFormatString;
        this.priHasHeader = hasHeader;
    }
    static fromSpeechSynthesisOutputFormat(speechSynthesisOutputFormat) {
        if (speechSynthesisOutputFormat === undefined) return $690728ad26725fe0$var$AudioOutputFormatImpl.getDefaultOutputFormat();
        return $690728ad26725fe0$var$AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString($690728ad26725fe0$var$AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString[speechSynthesisOutputFormat]);
    }
    static fromSpeechSynthesisOutputFormatString(speechSynthesisOutputFormatString) {
        switch(speechSynthesisOutputFormatString){
            case "raw-8khz-8bit-mono-mulaw":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-16khz-16kbps-mono-siren":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, "audio-16khz-16kbps-mono-siren", true);
            case "audio-16khz-16kbps-mono-siren":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-32kbitrate-mono-mp3":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.MP3, 1, 16000, 4096, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-128kbitrate-mono-mp3":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.MP3, 1, 16000, 16384, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-64kbitrate-mono-mp3":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.MP3, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-48kbitrate-mono-mp3":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.MP3, 1, 24000, 6144, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-96kbitrate-mono-mp3":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.MP3, 1, 24000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-160kbitrate-mono-mp3":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.MP3, 1, 24000, 20480, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-16khz-16bit-mono-truesilk":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.SILKSkype, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-16bit-mono-pcm":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", true);
            case "riff-24khz-16bit-mono-pcm":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", true);
            case "riff-8khz-8bit-mono-mulaw":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-mulaw", true);
            case "raw-16khz-16bit-mono-pcm":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, "raw-16khz-16bit-mono-pcm", false);
            case "raw-24khz-16bit-mono-pcm":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", false);
            case "raw-8khz-16bit-mono-pcm":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", false);
            case "ogg-16khz-16bit-mono-opus":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.OGG_OPUS, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-24khz-16bit-mono-opus":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.OGG_OPUS, 1, 24000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-48khz-16bit-mono-pcm":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", false);
            case "riff-48khz-16bit-mono-pcm":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", true);
            case "audio-48khz-96kbitrate-mono-mp3":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.MP3, 1, 48000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-192kbitrate-mono-mp3":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.MP3, 1, 48000, 24576, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-48khz-16bit-mono-opus":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.OGG_OPUS, 1, 48000, 12000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-16khz-16bit-mono-opus":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.WEBM_OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-mono-opus":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.WEBM_OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-24kbps-mono-opus":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.WEBM_OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-16bit-32kbps-mono-opus":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-48kbps-mono-opus":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-24kbps-mono-opus":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-mono-flac":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.FLAC, 1, 24000, 24000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-16bit-mono-flac":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.FLAC, 1, 48000, 30000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-24khz-16bit-mono-truesilk":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.SILKSkype, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-8khz-8bit-mono-alaw":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-8bit-mono-alaw":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-alaw", true);
            case "raw-22050hz-16bit-mono-pcm":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-22050hz-16bit-mono-pcm":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, "raw-22050hz-16bit-mono-pcm", true);
            case "raw-44100hz-16bit-mono-pcm":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-44100hz-16bit-mono-pcm":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, "raw-44100hz-16bit-mono-pcm", true);
            case "amr-wb-16000h":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.AMR_WB, 1, 16000, 3052, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "g722-16khz-64kbps":
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.G722, 1, 16000, 8000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-16khz-16bit-mono-pcm":
            default:
                return new $690728ad26725fe0$var$AudioOutputFormatImpl($hzVTX.AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", true);
        }
    }
    static getDefaultOutputFormat() {
        return $690728ad26725fe0$var$AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(typeof window !== "undefined" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
    }
    /**
     * Specifies if this audio output format has a header
     * @boolean AudioOutputFormatImpl.prototype.hasHeader
     * @function
     * @public
     */ get hasHeader() {
        return this.priHasHeader;
    }
    /**
     * Specifies the header of this format
     * @ArrayBuffer AudioOutputFormatImpl.prototype.header
     * @function
     * @public
     */ get header() {
        if (this.hasHeader) return this.privHeader;
        return undefined;
    }
    /**
     * Updates the header based on the audio length
     * @member AudioOutputFormatImpl.updateHeader
     * @function
     * @public
     * @param {number} audioLength - the audio length
     */ updateHeader(audioLength) {
        if (this.priHasHeader) {
            const view = new DataView(this.privHeader);
            view.setUint32(4, audioLength + this.privHeader.byteLength - 8, true);
            view.setUint32(40, audioLength, true);
        }
    }
    /**
     * Specifies the audio format string to be sent to the service
     * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
     * @function
     * @public
     */ get requestAudioFormatString() {
        return this.priRequestAudioFormatString;
    }
    /**
     * Adds audio header
     * @param audio the raw audio without header
     * @returns the audio with header if applicable
     */ addHeader(audio) {
        if (!this.hasHeader) return audio;
        this.updateHeader(audio.byteLength);
        const tmp = new Uint8Array(audio.byteLength + this.header.byteLength);
        tmp.set(new Uint8Array(this.header), 0);
        tmp.set(new Uint8Array(audio), this.header.byteLength);
        return tmp.buffer;
    }
}
module.exports.AudioOutputFormatImpl = $690728ad26725fe0$var$AudioOutputFormatImpl;
$690728ad26725fe0$var$AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString = {
    [$38QGp.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw]: "raw-8khz-8bit-mono-mulaw",
    [$38QGp.SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren]: "riff-16khz-16kbps-mono-siren",
    [$38QGp.SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren]: "audio-16khz-16kbps-mono-siren",
    [$38QGp.SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3]: "audio-16khz-32kbitrate-mono-mp3",
    [$38QGp.SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3]: "audio-16khz-128kbitrate-mono-mp3",
    [$38QGp.SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3]: "audio-16khz-64kbitrate-mono-mp3",
    [$38QGp.SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3]: "audio-24khz-48kbitrate-mono-mp3",
    [$38QGp.SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3]: "audio-24khz-96kbitrate-mono-mp3",
    [$38QGp.SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3]: "audio-24khz-160kbitrate-mono-mp3",
    [$38QGp.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk]: "raw-16khz-16bit-mono-truesilk",
    [$38QGp.SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm]: "riff-16khz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm]: "riff-8khz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm]: "riff-24khz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw]: "riff-8khz-8bit-mono-mulaw",
    [$38QGp.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm]: "raw-16khz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm]: "raw-24khz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm]: "raw-8khz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus]: "ogg-16khz-16bit-mono-opus",
    [$38QGp.SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus]: "ogg-24khz-16bit-mono-opus",
    [$38QGp.SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm]: "raw-48khz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm]: "riff-48khz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3]: "audio-48khz-96kbitrate-mono-mp3",
    [$38QGp.SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3]: "audio-48khz-192kbitrate-mono-mp3",
    [$38QGp.SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus]: "ogg-48khz-16bit-mono-opus",
    [$38QGp.SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus]: "webm-16khz-16bit-mono-opus",
    [$38QGp.SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus]: "webm-24khz-16bit-mono-opus",
    [$38QGp.SpeechSynthesisOutputFormat.Webm24Khz16Bit24KbpsMonoOpus]: "webm-24khz-16bit-24kbps-mono-opus",
    [$38QGp.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk]: "raw-24khz-16bit-mono-truesilk",
    [$38QGp.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw]: "raw-8khz-8bit-mono-alaw",
    [$38QGp.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw]: "riff-8khz-8bit-mono-alaw",
    [$38QGp.SpeechSynthesisOutputFormat.Audio16Khz16Bit32KbpsMonoOpus]: "audio-16khz-16bit-32kbps-mono-opus",
    [$38QGp.SpeechSynthesisOutputFormat.Audio24Khz16Bit48KbpsMonoOpus]: "audio-24khz-16bit-48kbps-mono-opus",
    [$38QGp.SpeechSynthesisOutputFormat.Audio24Khz16Bit24KbpsMonoOpus]: "audio-24khz-16bit-24kbps-mono-opus",
    [$38QGp.SpeechSynthesisOutputFormat.Raw22050Hz16BitMonoPcm]: "raw-22050hz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.Riff22050Hz16BitMonoPcm]: "riff-22050hz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.Raw44100Hz16BitMonoPcm]: "raw-44100hz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.Riff44100Hz16BitMonoPcm]: "riff-44100hz-16bit-mono-pcm",
    [$38QGp.SpeechSynthesisOutputFormat.AmrWb16000Hz]: "amr-wb-16000hz",
    [$38QGp.SpeechSynthesisOutputFormat.G72216Khz64Kbps]: "g722-16khz-64kbps"
};

});
parcelRegister("38QGp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisOutputFormat = void 0;
/**
 * Define speech synthesis audio output formats.
 * @enum SpeechSynthesisOutputFormat
 * Updated in version 1.17.0
 */ var $249afc32f4439222$var$SpeechSynthesisOutputFormat;
(function(SpeechSynthesisOutputFormat) {
    /**
     * raw-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw,
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoMULaw"] = 0] = "Raw8Khz8BitMonoMULaw";
    /**
     * riff-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16KbpsMonoSiren"] = 1] = "Riff16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16KbpsMonoSiren"] = 2] = "Audio16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-32kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz32KBitRateMonoMp3"] = 3] = "Audio16Khz32KBitRateMonoMp3";
    /**
     * audio-16khz-128kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz128KBitRateMonoMp3"] = 4] = "Audio16Khz128KBitRateMonoMp3";
    /**
     * audio-16khz-64kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz64KBitRateMonoMp3"] = 5] = "Audio16Khz64KBitRateMonoMp3";
    /**
     * audio-24khz-48kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz48KBitRateMonoMp3"] = 6] = "Audio24Khz48KBitRateMonoMp3";
    /**
     * audio-24khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz96KBitRateMonoMp3"] = 7] = "Audio24Khz96KBitRateMonoMp3";
    /**
     * audio-24khz-160kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz160KBitRateMonoMp3"] = 8] = "Audio24Khz160KBitRateMonoMp3";
    /**
     * raw-16khz-16bit-mono-truesilk
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoTrueSilk"] = 9] = "Raw16Khz16BitMonoTrueSilk";
    /**
     * riff-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16BitMonoPcm"] = 10] = "Riff16Khz16BitMonoPcm";
    /**
     * riff-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz16BitMonoPcm"] = 11] = "Riff8Khz16BitMonoPcm";
    /**
     * riff-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff24Khz16BitMonoPcm"] = 12] = "Riff24Khz16BitMonoPcm";
    /**
     * riff-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoMULaw"] = 13] = "Riff8Khz8BitMonoMULaw";
    /**
     * raw-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoPcm"] = 14] = "Raw16Khz16BitMonoPcm";
    /**
     * raw-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoPcm"] = 15] = "Raw24Khz16BitMonoPcm";
    /**
     * raw-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz16BitMonoPcm"] = 16] = "Raw8Khz16BitMonoPcm";
    /**
     * ogg-16khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg16Khz16BitMonoOpus"] = 17] = "Ogg16Khz16BitMonoOpus";
    /**
     * ogg-24khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg24Khz16BitMonoOpus"] = 18] = "Ogg24Khz16BitMonoOpus";
    /**
     * raw-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw48Khz16BitMonoPcm"] = 19] = "Raw48Khz16BitMonoPcm";
    /**
     * riff-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff48Khz16BitMonoPcm"] = 20] = "Riff48Khz16BitMonoPcm";
    /**
     * audio-48khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz96KBitRateMonoMp3"] = 21] = "Audio48Khz96KBitRateMonoMp3";
    /**
     * audio-48khz-192kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz192KBitRateMonoMp3"] = 22] = "Audio48Khz192KBitRateMonoMp3";
    /**
     * ogg-48khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg48Khz16BitMonoOpus"] = 23] = "Ogg48Khz16BitMonoOpus";
    /**
     * webm-16khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm16Khz16BitMonoOpus"] = 24] = "Webm16Khz16BitMonoOpus";
    /**
     * webm-24khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16BitMonoOpus"] = 25] = "Webm24Khz16BitMonoOpus";
    /**
     * raw-24khz-16bit-mono-truesilk
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoTrueSilk"] = 26] = "Raw24Khz16BitMonoTrueSilk";
    /**
     * raw-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoALaw"] = 27] = "Raw8Khz8BitMonoALaw";
    /**
     * riff-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoALaw"] = 28] = "Riff8Khz8BitMonoALaw";
    /**
     * webm-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec in a webm container, with bitrate of 24kbps, optimized for IoT scenario.
     * Added in version 1.19.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16Bit24KbpsMonoOpus"] = 29] = "Webm24Khz16Bit24KbpsMonoOpus";
    /**
     * audio-16khz-16bit-32kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 32kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio16Khz16Bit32KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16Bit32KbpsMonoOpus"] = 30] = "Audio16Khz16Bit32KbpsMonoOpus";
    /**
     * audio-24khz-16bit-48kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 48kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit48KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit48KbpsMonoOpus"] = 31] = "Audio24Khz16Bit48KbpsMonoOpus";
    /**
     * audio-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 24kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit24KbpsMonoOpus"] = 32] = "Audio24Khz16Bit24KbpsMonoOpus";
    /**
     * raw-22050hz-16bit-mono-pcm
     * Raw PCM audio at 22050Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw22050Hz16BitMonoPcm"] = 33] = "Raw22050Hz16BitMonoPcm";
    /**
     * riff-22050hz-16bit-mono-pcm
     * PCM audio at 22050Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff22050Hz16BitMonoPcm"] = 34] = "Riff22050Hz16BitMonoPcm";
    /**
     * raw-44100hz-16bit-mono-pcm
     * Raw PCM audio at 44100Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw44100Hz16BitMonoPcm"] = 35] = "Raw44100Hz16BitMonoPcm";
    /**
     * riff-44100hz-16bit-mono-pcm
     * PCM audio at 44100Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff44100Hz16BitMonoPcm"] = 36] = "Riff44100Hz16BitMonoPcm";
    /**
     * amr-wb-16000hz
     * AMR-WB audio at 16kHz sampling rate.
     * Added in version 1.38.0
     * @member SpeechSynthesisOutputFormat.AmrWb16000Hz
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["AmrWb16000Hz"] = 37] = "AmrWb16000Hz";
    /**
     * g722-16khz-64kbps
     * G.722 audio at 16kHz sampling rate and 64kbps bitrate.
     * Added in version 1.38.0
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["G72216Khz64Kbps"] = 38] = "G72216Khz64Kbps";
})($249afc32f4439222$var$SpeechSynthesisOutputFormat = module.exports.SpeechSynthesisOutputFormat || (module.exports.SpeechSynthesisOutputFormat = {}));

});




parcelRegister("6Oi8a", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationReason = void 0;
/**
 * Defines the possible reasons a recognition result might be canceled.
 * @class CancellationReason
 */ var $4f5579f86c0a3e77$var$CancellationReason;
(function(CancellationReason) {
    /**
     * Indicates that an error occurred during speech recognition.
     * @member CancellationReason.Error
     */ CancellationReason[CancellationReason["Error"] = 0] = "Error";
    /**
     * Indicates that the end of the audio stream was reached.
     * @member CancellationReason.EndOfStream
     */ CancellationReason[CancellationReason["EndOfStream"] = 1] = "EndOfStream";
})($4f5579f86c0a3e77$var$CancellationReason = module.exports.CancellationReason || (module.exports.CancellationReason = {}));

});

parcelRegister("7pMg9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PullAudioInputStreamCallback = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (read() and close()) for
 * custom audio input streams).
 * @class PullAudioInputStreamCallback
 */ class $56604d866a7afa1d$var$PullAudioInputStreamCallback {
}
module.exports.PullAudioInputStreamCallback = $56604d866a7afa1d$var$PullAudioInputStreamCallback;

});

parcelRegister("92Nur", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PushAudioOutputStreamCallback = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (write() and close()) for
 * custom audio output streams).
 * @class PushAudioOutputStreamCallback
 */ class $695ab09f88963d4f$var$PushAudioOutputStreamCallback {
}
module.exports.PushAudioOutputStreamCallback = $695ab09f88963d4f$var$PushAudioOutputStreamCallback;

});

parcelRegister("b0rl7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeywordRecognitionModel = void 0;

var $3SMEZ = parcelRequire("3SMEZ");
/**
 * Represents a keyword recognition model for recognizing when
 * the user says a keyword to initiate further speech recognition.
 * @class KeywordRecognitionModel
 */ class $8034e6e03b2ba8e3$var$KeywordRecognitionModel {
    /**
     * Create and initializes a new instance.
     * @constructor
     */ constructor(){
        this.privDisposed = false;
        return;
    }
    /**
     * Creates a keyword recognition model using the specified filename.
     * @member KeywordRecognitionModel.fromFile
     * @function
     * @public
     * @param {string} fileName - A string that represents file name for the keyword recognition model.
     * Note, the file can point to a zip file in which case the model
     * will be extracted from the zip.
     * @returns {KeywordRecognitionModel} The keyword recognition model being created.
     */ static fromFile(fileName) {
        $3SMEZ.Contracts.throwIfFileDoesNotExist(fileName, "fileName");
        throw new Error("Not yet implemented.");
    }
    /**
     * Creates a keyword recognition model using the specified filename.
     * @member KeywordRecognitionModel.fromStream
     * @function
     * @public
     * @param {string} file - A File that represents file for the keyword recognition model.
     * Note, the file can point to a zip file in which case the model will be extracted from the zip.
     * @returns {KeywordRecognitionModel} The keyword recognition model being created.
     */ static fromStream(file) {
        $3SMEZ.Contracts.throwIfNull(file, "file");
        throw new Error("Not yet implemented.");
    }
    /**
     * Dispose of associated resources.
     * @member KeywordRecognitionModel.prototype.close
     * @function
     * @public
     */ close() {
        if (this.privDisposed) return;
        this.privDisposed = true;
    }
}
module.exports.KeywordRecognitionModel = $8034e6e03b2ba8e3$var$KeywordRecognitionModel;

});

parcelRegister("83GF9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SessionEventArgs = void 0;
/**
 * Defines content for session events like SessionStarted/Stopped, SoundStarted/Stopped.
 * @class SessionEventArgs
 */ class $5ddfb27eae42a463$var$SessionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionId - The session id.
     */ constructor(sessionId){
        this.privSessionId = sessionId;
    }
    /**
     * Represents the session identifier.
     * @member SessionEventArgs.prototype.sessionId
     * @function
     * @public
     * @returns {string} Represents the session identifier.
     */ get sessionId() {
        return this.privSessionId;
    }
}
module.exports.SessionEventArgs = $5ddfb27eae42a463$var$SessionEventArgs;

});

parcelRegister("jBghy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionEventArgs = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Defines payload for session events like Speech Start/End Detected
 * @class
 */ class $e44e1a53a80faaf6$var$RecognitionEventArgs extends $gttSn.SessionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(offset, sessionId){
        super(sessionId);
        this.privOffset = offset;
    }
    /**
     * Represents the message offset
     * @member RecognitionEventArgs.prototype.offset
     * @function
     * @public
     */ get offset() {
        return this.privOffset;
    }
}
module.exports.RecognitionEventArgs = $e44e1a53a80faaf6$var$RecognitionEventArgs;

});

parcelRegister("jcTbW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OutputFormat = void 0;
/**
 * Define Speech Recognizer output formats.
 * @class OutputFormat
 */ var $dfb9f335ea62f961$var$OutputFormat;
(function(OutputFormat) {
    /**
     * @member OutputFormat.Simple
     */ OutputFormat[OutputFormat["Simple"] = 0] = "Simple";
    /**
     * @member OutputFormat.Detailed
     */ OutputFormat[OutputFormat["Detailed"] = 1] = "Detailed";
})($dfb9f335ea62f961$var$OutputFormat = module.exports.OutputFormat || (module.exports.OutputFormat = {}));

});

parcelRegister("fzoDC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionResult = void 0;
/**
 * Defines result of speech recognition.
 * @class RecognitionResult
 */ class $b55d3c7b1d7855c2$var$RecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privText = text;
        this.privDuration = duration;
        this.privOffset = offset;
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
        this.privErrorDetails = errorDetails;
        this.privJson = json;
        this.privProperties = properties;
    }
    /**
     * Specifies the result identifier.
     * @member RecognitionResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member RecognitionResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * Presents the recognized text in the result.
     * @member RecognitionResult.prototype.text
     * @function
     * @public
     * @returns {string} Presents the recognized text in the result.
     */ get text() {
        return this.privText;
    }
    /**
     * Duration of recognized speech in 100 nano second increments.
     * @member RecognitionResult.prototype.duration
     * @function
     * @public
     * @returns {number} Duration of recognized speech in 100 nano second increments.
     */ get duration() {
        return this.privDuration;
    }
    /**
     * Offset of recognized speech in 100 nano second increments.
     * @member RecognitionResult.prototype.offset
     * @function
     * @public
     * @returns {number} Offset of recognized speech in 100 nano second increments.
     */ get offset() {
        return this.privOffset;
    }
    /**
     * Primary Language detected.
     * @member RecognitionResult.prototype.language
     * @function
     * @public
     * @returns {string} language detected.
     */ get language() {
        return this.privLanguage;
    }
    /**
     * Primary Language detection confidence (Unknown, Low, Medium, High).
     * @member RecognitionResult.prototype.languageDetectionConfidence
     * @function
     * @public
     * @returns {string} detection confidence strength.
     */ get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member RecognitionResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * A string containing Json serialized recognition result as it was received from the service.
     * @member RecognitionResult.prototype.json
     * @function
     * @private
     * @returns {string} Json serialized representation of the result.
     */ get json() {
        return this.privJson;
    }
    /**
     * The set of properties exposed in the result.
     * @member RecognitionResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
}
module.exports.RecognitionResult = $b55d3c7b1d7855c2$var$RecognitionResult;

});

parcelRegister("b5LoR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognitionResult = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Defines result of speech recognition.
 * @class SpeechRecognitionResult
 */ class $8134ee01dca4e96e$var$SpeechRecognitionResult extends $gttSn.RecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription, if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, speakerId, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties);
        this.privSpeakerId = speakerId;
    }
    /**
     * speaker id from conversation transcription/id scenarios
     * @member SpeechRecognitionResult.prototype.speakerId
     * @function
     * @public
     * @returns {string} id of speaker in given result
     */ get speakerId() {
        return this.privSpeakerId;
    }
}
module.exports.SpeechRecognitionResult = $8134ee01dca4e96e$var$SpeechRecognitionResult;

});

parcelRegister("9naJi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriptionEventArgs = module.exports.ConversationTranscriptionEventArgs = module.exports.SpeechRecognitionEventArgs = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Defines contents of speech recognizing/recognized event.
 * @class SpeechRecognitionEventArgs
 */ class $6d2e95b33c75001c$var$SpeechRecognitionEventArgs extends $gttSn.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechRecognitionResult} result - The speech recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the recognition result.
     * @member SpeechRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.SpeechRecognitionEventArgs = $6d2e95b33c75001c$var$SpeechRecognitionEventArgs;
/**
 * Defines contents of conversation transcribed/transcribing event.
 * @class ConversationTranscriptionEventArgs
 */ class $6d2e95b33c75001c$var$ConversationTranscriptionEventArgs extends $gttSn.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ConversationTranscriptionResult} result - The conversation transcription result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the transcription result.
     * @member ConversationTranscription1EventArgs.prototype.result
     * @function
     * @public
     * @returns {ConversationTranscriptionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.ConversationTranscriptionEventArgs = $6d2e95b33c75001c$var$ConversationTranscriptionEventArgs;
/**
 * Defines contents of meeting transcribed/transcribing event.
 * @class MeetingTranscriptionEventArgs
 */ class $6d2e95b33c75001c$var$MeetingTranscriptionEventArgs extends $6d2e95b33c75001c$var$SpeechRecognitionEventArgs {
}
module.exports.MeetingTranscriptionEventArgs = $6d2e95b33c75001c$var$MeetingTranscriptionEventArgs;

});

parcelRegister("iGIs8", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognitionCanceledEventArgs = void 0;

var $g5epc = parcelRequire("g5epc");
class $d9aea1a2d292a401$var$SpeechRecognitionCanceledEventArgs extends $g5epc.CancellationEventArgsBase {
}
module.exports.SpeechRecognitionCanceledEventArgs = $d9aea1a2d292a401$var$SpeechRecognitionCanceledEventArgs;

});
parcelRegister("g5epc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationEventArgsBase = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Defines content of a CancellationEvent.
 * @class CancellationEventArgsBase
 */ class $bb58499c9c1fbac8$var$CancellationEventArgsBase extends $gttSn.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(reason, errorDetails, errorCode, offset, sessionId){
        super(offset, sessionId);
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    /**
     * The reason the recognition was canceled.
     * @member CancellationEventArgsBase.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful operation.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful operation, provides details of the occurred error.
     * @member CancellationEventArgsBase.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
}
module.exports.CancellationEventArgsBase = $bb58499c9c1fbac8$var$CancellationEventArgsBase;

});


parcelRegister("iTP4M", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionEventArgs = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Translation text result event arguments.
 * @class TranslationRecognitionEventArgs
 */ class $dc24fbb2668d7b85$var$TranslationRecognitionEventArgs extends $gttSn.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationRecognitionResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the recognition result.
     * @member TranslationRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.TranslationRecognitionEventArgs = $dc24fbb2668d7b85$var$TranslationRecognitionEventArgs;

});

parcelRegister("8FYnw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisEventArgs = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Translation Synthesis event arguments
 * @class TranslationSynthesisEventArgs
 */ class $6510fcf8c52e9d62$var$TranslationSynthesisEventArgs extends $gttSn.SessionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationSynthesisResult} result - The translation synthesis result.
     * @param {string} sessionId - The session id.
     */ constructor(result, sessionId){
        super(sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the translation synthesis result.
     * @member TranslationSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationSynthesisResult} Specifies the translation synthesis result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.TranslationSynthesisEventArgs = $6510fcf8c52e9d62$var$TranslationSynthesisEventArgs;

});

parcelRegister("7duHD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionResult = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Translation text result.
 * @class TranslationRecognitionResult
 */ class $54119042850023fc$var$TranslationRecognitionResult extends $gttSn.SpeechRecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {Translations} translations - The translations.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(translations, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, undefined, errorDetails, json, properties);
        this.privTranslations = translations;
    }
    static fromSpeechRecognitionResult(result) {
        return new $54119042850023fc$var$TranslationRecognitionResult(undefined, result.resultId, result.reason, result.text, result.duration, result.offset, result.language, result.languageDetectionConfidence, result.errorDetails, result.json, result.properties);
    }
    /**
     * Presents the translation results. Each item in the dictionary represents
     * a translation result in one of target languages, where the key is the name
     * of the target language, in BCP-47 format, and the value is the translation
     * text in the specified language.
     * @member TranslationRecognitionResult.prototype.translations
     * @function
     * @public
     * @returns {Translations} the current translation map that holds all translations requested.
     */ get translations() {
        return this.privTranslations;
    }
}
module.exports.TranslationRecognitionResult = $54119042850023fc$var$TranslationRecognitionResult;

});

parcelRegister("bbzu4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisResult = void 0;
/**
 * Defines translation synthesis result, i.e. the voice output of the translated
 * text in the target language.
 * @class TranslationSynthesisResult
 */ class $824c3f30212ef4c3$var$TranslationSynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ResultReason} reason - The synthesis reason.
     * @param {ArrayBuffer} audio - The audio data.
     */ constructor(reason, audio){
        this.privReason = reason;
        this.privAudio = audio;
    }
    /**
     * Translated text in the target language.
     * @member TranslationSynthesisResult.prototype.audio
     * @function
     * @public
     * @returns {ArrayBuffer} Translated audio in the target language.
     */ get audio() {
        return this.privAudio;
    }
    /**
     * The synthesis status.
     * @member TranslationSynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} The synthesis status.
     */ get reason() {
        return this.privReason;
    }
}
module.exports.TranslationSynthesisResult = $824c3f30212ef4c3$var$TranslationSynthesisResult;

});

parcelRegister("20d7X", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResultReason = void 0;
/**
 * Defines the possible reasons a recognition result might be generated.
 * @class ResultReason
 */ var $1755c3b092484014$var$ResultReason;
(function(ResultReason) {
    /**
     * Indicates speech could not be recognized. More details
     * can be found in the NoMatchDetails object.
     * @member ResultReason.NoMatch
     */ ResultReason[ResultReason["NoMatch"] = 0] = "NoMatch";
    /**
     * Indicates that the recognition was canceled. More details
     * can be found using the CancellationDetails object.
     * @member ResultReason.Canceled
     */ ResultReason[ResultReason["Canceled"] = 1] = "Canceled";
    /**
     * Indicates the speech result contains hypothesis text.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizingSpeech"] = 2] = "RecognizingSpeech";
    /**
     * Indicates the speech result contains final text that has been recognized.
     * Speech Recognition is now complete for this phrase.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizedSpeech"] = 3] = "RecognizedSpeech";
    /**
     * Indicates the speech result contains a finalized acceptance of a provided keyword.
     * Speech recognition will continue unless otherwise configured.
     * @member ResultReason.RecognizedKeyword
     */ ResultReason[ResultReason["RecognizedKeyword"] = 4] = "RecognizedKeyword";
    /**
     * Indicates the translation result contains hypothesis text and its translation(s).
     * @member ResultReason.TranslatingSpeech
     */ ResultReason[ResultReason["TranslatingSpeech"] = 5] = "TranslatingSpeech";
    /**
     * Indicates the translation result contains final text and corresponding translation(s).
     * Speech Recognition and Translation are now complete for this phrase.
     * @member ResultReason.TranslatedSpeech
     */ ResultReason[ResultReason["TranslatedSpeech"] = 6] = "TranslatedSpeech";
    /**
     * Indicates the synthesized audio result contains a non-zero amount of audio data
     * @member ResultReason.SynthesizingAudio
     */ ResultReason[ResultReason["SynthesizingAudio"] = 7] = "SynthesizingAudio";
    /**
     * Indicates the synthesized audio is now complete for this phrase.
     * @member ResultReason.SynthesizingAudioCompleted
     */ ResultReason[ResultReason["SynthesizingAudioCompleted"] = 8] = "SynthesizingAudioCompleted";
    /**
     * Indicates the speech synthesis is now started
     * @member ResultReason.SynthesizingAudioStarted
     */ ResultReason[ResultReason["SynthesizingAudioStarted"] = 9] = "SynthesizingAudioStarted";
    /**
     * Indicates synthesis voices list has been successfully retrieved.
     * @member ResultReason.VoicesListRetrieved
     */ ResultReason[ResultReason["VoicesListRetrieved"] = 10] = "VoicesListRetrieved";
    /**
     * Indicates the transcription result contains hypothesis text and its translation(s) for
     * other participants in the conversation.
     * @member ResultReason.TranslatingParticipantSpeech
     */ ResultReason[ResultReason["TranslatingParticipantSpeech"] = 11] = "TranslatingParticipantSpeech";
    /**
     * Indicates the transcription result contains final text and corresponding translation(s)
     * for other participants in the conversation. Speech Recognition and Translation are now
     * complete for this phrase.
     * @member ResultReason.TranslatedParticipantSpeech
     */ ResultReason[ResultReason["TranslatedParticipantSpeech"] = 12] = "TranslatedParticipantSpeech";
    /**
     * <summary>
     * Indicates the transcription result contains the instant message and corresponding
     * translation(s).
     * @member ResultReason.TranslatedInstantMessage
     */ ResultReason[ResultReason["TranslatedInstantMessage"] = 13] = "TranslatedInstantMessage";
    /**
     * Indicates the transcription result contains the instant message for other participants
     * in the conversation and corresponding translation(s).
     * @member ResultReason.TranslatedParticipantInstantMessage
     */ ResultReason[ResultReason["TranslatedParticipantInstantMessage"] = 14] = "TranslatedParticipantInstantMessage";
})($1755c3b092484014$var$ResultReason = module.exports.ResultReason || (module.exports.ResultReason = {}));

});

parcelRegister("fnMfN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConfigImpl = module.exports.SpeechConfig = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
/**
 * Speech configuration.
 * @class SpeechConfig
 */ class $b32e6f34075fb810$var$SpeechConfig {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
     * @member SpeechConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} The speech factory
     */ static fromSubscription(subscriptionKey, region) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $b32e6f34075fb810$var$SpeechConfigImpl();
        speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Region, region);
        speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Internal implementation of fromEndpoint() overloads. Accepts either a subscription key or a TokenCredential.
     * @private
     */ static fromEndpoint(endpoint, auth) {
        $3SMEZ.Contracts.throwIfNull(endpoint, "endpoint");
        const isValidString = typeof auth === "string" && auth.trim().length > 0;
        const isTokenCredential = typeof auth === "object" && auth !== null && typeof auth.getToken === "function";
        const isKeyCredential = typeof auth === "object" && auth !== null && typeof auth.key === "string";
        if (auth !== undefined && !isValidString && !isTokenCredential && !isKeyCredential) throw new Error("Invalid 'auth' parameter: expected a non-empty API key string, a TokenCredential, or a KeyCredential.");
        let speechImpl;
        if (typeof auth === "string") {
            speechImpl = new $b32e6f34075fb810$var$SpeechConfigImpl();
            speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, auth);
        } else if (typeof auth === "object" && typeof auth.getToken === "function") speechImpl = new $b32e6f34075fb810$var$SpeechConfigImpl(auth);
        else if (typeof auth === "object" && typeof auth.key === "string") {
            speechImpl = new $b32e6f34075fb810$var$SpeechConfigImpl();
            speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, auth.key);
        } else speechImpl = new $b32e6f34075fb810$var$SpeechConfigImpl();
        speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint, endpoint.href);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromHost(hostName, subscriptionKey) {
        $3SMEZ.Contracts.throwIfNull(hostName, "hostName");
        const speechImpl = new $b32e6f34075fb810$var$SpeechConfigImpl();
        speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        // Containers do not yet have /stt/speech/universal/v2 routes.
        speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "1");
        if (undefined !== subscriptionKey) speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech factory with specified initial authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * Note: As configuration values are copied when creating a new recognizer,
     * the new token value will not apply to recognizers that have already been created. For recognizers
     * that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The initial authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromAuthorizationToken(authorizationToken, region) {
        $3SMEZ.Contracts.throwIfNull(authorizationToken, "authorizationToken");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $b32e6f34075fb810$var$SpeechConfigImpl();
        speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Region, region);
        speechImpl.authorizationToken = authorizationToken;
        return speechImpl;
    }
    /**
     * Closes the configuration.
     * @member SpeechConfig.prototype.close
     * @function
     * @public
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    close() {}
}
module.exports.SpeechConfig = $b32e6f34075fb810$var$SpeechConfig;
/**
 * @public
 * @class SpeechConfigImpl
 */ class $b32e6f34075fb810$var$SpeechConfigImpl extends $b32e6f34075fb810$var$SpeechConfig {
    constructor(tokenCredential){
        super();
        this.privProperties = new $gttSn.PropertyCollection();
        this.speechRecognitionLanguage = "en-US"; // Should we have a default?
        this.outputFormat = $gttSn.OutputFormat.Simple;
        this.privTokenCredential = tokenCredential;
    }
    get properties() {
        return this.privProperties;
    }
    get endPoint() {
        return new URL(this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint));
    }
    get subscriptionKey() {
        return this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_Key);
    }
    get region() {
        return this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_Region);
    }
    get authorizationToken() {
        return this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(value) {
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, value);
    }
    get speechRecognitionLanguage() {
        return this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    set speechRecognitionLanguage(value) {
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage, value);
    }
    get autoDetectSourceLanguages() {
        return this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages);
    }
    set autoDetectSourceLanguages(value) {
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, value);
    }
    get outputFormat() {
        return $gttSn.OutputFormat[this.privProperties.getProperty($hgjD5.OutputFormatPropertyName, undefined)];
    }
    set outputFormat(value) {
        this.privProperties.setProperty($hgjD5.OutputFormatPropertyName, $gttSn.OutputFormat[value]);
    }
    get endpointId() {
        return this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_EndpointId);
    }
    set endpointId(value) {
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_EndpointId, value);
    }
    get tokenCredential() {
        return this.privTokenCredential;
    }
    setProperty(name, value) {
        $3SMEZ.Contracts.throwIfNull(value, "value");
        this.privProperties.setProperty(name, value);
    }
    getProperty(name, def) {
        return this.privProperties.getProperty(name, def);
    }
    setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_ProxyPassword], proxyPassword);
    }
    setServiceProperty(name, value) {
        const currentProperties = JSON.parse(this.privProperties.getProperty($hgjD5.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty($hgjD5.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    }
    setProfanity(profanity) {
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceResponse_ProfanityOption, $gttSn.ProfanityOption[profanity]);
    }
    enableAudioLogging() {
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
        this.privProperties.setProperty($hgjD5.OutputFormatPropertyName, $gttSn.OutputFormat[$gttSn.OutputFormat.Detailed]);
    }
    enableDictation() {
        this.privProperties.setProperty($hgjD5.ForceDictationPropertyName, "true");
    }
    clone() {
        const ret = new $b32e6f34075fb810$var$SpeechConfigImpl(this.tokenCredential);
        ret.privProperties = this.privProperties.clone();
        return ret;
    }
    get speechSynthesisLanguage() {
        return this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(language) {
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_SynthLanguage, language);
    }
    get speechSynthesisVoiceName() {
        return this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(voice) {
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_SynthVoice, voice);
    }
    get speechSynthesisOutputFormat() {
        return $gttSn.SpeechSynthesisOutputFormat[this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)];
    }
    set speechSynthesisOutputFormat(format) {
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_SynthOutputFormat, $gttSn.SpeechSynthesisOutputFormat[format]);
    }
}
module.exports.SpeechConfigImpl = $b32e6f34075fb810$var$SpeechConfigImpl;

});

parcelRegister("ineJh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechTranslationConfigImpl = module.exports.SpeechTranslationConfig = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
/**
 * Speech translation configuration.
 * @class SpeechTranslationConfig
 */ class $d605ccecc3ab7f41$var$SpeechTranslationConfig extends $gttSn.SpeechConfig {
    /**
     * Creates an instance of recognizer config.
     */ constructor(){
        super();
    }
    /**
     * Static instance of SpeechTranslationConfig returned by passing a subscription key and service region.
     * @member SpeechTranslationConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */ static fromSubscription(subscriptionKey, region) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(region, "region");
        const ret = new $d605ccecc3ab7f41$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        ret.properties.setProperty($gttSn.PropertyId.SpeechServiceConnection_Region, region);
        return ret;
    }
    /**
     * Static instance of SpeechTranslationConfig returned by passing authorization token and service region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by setting the property authorizationToken with a new
     * valid token. Otherwise, all the recognizers created by this SpeechTranslationConfig instance
     * will encounter errors during recognition.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply
     * to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechTranslationConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */ static fromAuthorizationToken(authorizationToken, region) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(region, "region");
        const ret = new $d605ccecc3ab7f41$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        ret.properties.setProperty($gttSn.PropertyId.SpeechServiceConnection_Region, region);
        return ret;
    }
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromHost(hostName, subscriptionKey) {
        $3SMEZ.Contracts.throwIfNull(hostName, "hostName");
        const speechImpl = new $d605ccecc3ab7f41$var$SpeechTranslationConfigImpl();
        speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Internal implementation of fromEndpoint() overloads. Accepts either a subscription key or a TokenCredential.
     * @private
     */ static fromEndpoint(endpoint, auth) {
        $3SMEZ.Contracts.throwIfNull(endpoint, "endpoint");
        const isValidString = typeof auth === "string" && auth.trim().length > 0;
        const isTokenCredential = typeof auth === "object" && auth !== null && typeof auth.getToken === "function";
        const isKeyCredential = typeof auth === "object" && auth !== null && typeof auth.key === "string";
        if (auth !== undefined && !isValidString && !isTokenCredential && !isKeyCredential) throw new Error("Invalid 'auth' parameter: expected a non-empty API key string, a TokenCredential, or a KeyCredential.");
        let speechImpl;
        if (typeof auth === "string") {
            speechImpl = new $d605ccecc3ab7f41$var$SpeechTranslationConfigImpl();
            speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, auth);
        } else if (typeof auth === "object" && typeof auth.getToken === "function") speechImpl = new $d605ccecc3ab7f41$var$SpeechTranslationConfigImpl(auth);
        else if (typeof auth === "object" && typeof auth.key === "string") {
            speechImpl = new $d605ccecc3ab7f41$var$SpeechTranslationConfigImpl();
            speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, auth.key);
        } else speechImpl = new $d605ccecc3ab7f41$var$SpeechTranslationConfigImpl();
        speechImpl.setProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint, endpoint.href);
        return speechImpl;
    }
}
module.exports.SpeechTranslationConfig = $d605ccecc3ab7f41$var$SpeechTranslationConfig;
/**
 * @private
 * @class SpeechTranslationConfigImpl
 */ class $d605ccecc3ab7f41$var$SpeechTranslationConfigImpl extends $d605ccecc3ab7f41$var$SpeechTranslationConfig {
    constructor(tokenCredential){
        super();
        this.privSpeechProperties = new $gttSn.PropertyCollection();
        this.outputFormat = $gttSn.OutputFormat.Simple;
        this.privTokenCredential = tokenCredential;
    }
    /**
     * Gets/Sets the authorization token.
     * If this is set, subscription key is ignored.
     * User needs to make sure the provided authorization token is valid and not expired.
     * @member SpeechTranslationConfigImpl.prototype.authorizationToken
     * @function
     * @public
     * @param {string} value - The authorization token.
     */ set authorizationToken(value) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechProperties.setProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, value);
    }
    /**
     * Sets the speech recognition language.
     * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @param {string} value - The authorization token.
     */ set speechRecognitionLanguage(value) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage, value);
    }
    /**
     * Gets the speech recognition language.
     * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @return {string} The speechRecognitionLanguage.
     */ get speechRecognitionLanguage() {
        return this.privSpeechProperties.getProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage]);
    }
    /**
     * @member SpeechTranslationConfigImpl.prototype.subscriptionKey
     * @function
     * @public
     */ get subscriptionKey() {
        return this.privSpeechProperties.getProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_Key]);
    }
    /**
     * Gets the output format
     * @member SpeechTranslationConfigImpl.prototype.outputFormat
     * @function
     * @public
     */ get outputFormat() {
        // eslint-disable-next-line
        return $gttSn.OutputFormat[this.privSpeechProperties.getProperty($hgjD5.OutputFormatPropertyName, undefined)];
    }
    /**
     * Gets/Sets the output format
     * @member SpeechTranslationConfigImpl.prototype.outputFormat
     * @function
     * @public
     */ set outputFormat(value) {
        this.privSpeechProperties.setProperty($hgjD5.OutputFormatPropertyName, $gttSn.OutputFormat[value]);
    }
    /**
     * Gets the endpoint id.
     * @member SpeechTranslationConfigImpl.prototype.endpointId
     * @function
     * @public
     */ get endpointId() {
        return this.privSpeechProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_EndpointId);
    }
    /**
     * Gets/Sets the endpoint id.
     * @member SpeechTranslationConfigImpl.prototype.endpointId
     * @function
     * @public
     */ set endpointId(value) {
        this.privSpeechProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_EndpointId, value);
    }
    /**
     * Add a (text) target language to translate into.
     * @member SpeechTranslationConfigImpl.prototype.addTargetLanguage
     * @function
     * @public
     * @param {string} value - The language such as de-DE
     */ addTargetLanguage(value) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(value, "value");
        const languages = this.targetLanguages;
        if (!languages.includes(value)) {
            languages.push(value);
            this.privSpeechProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
        }
    }
    /**
     * Gets the (text) target language to translate into.
     * @member SpeechTranslationConfigImpl.prototype.targetLanguages
     * @function
     * @public
     * @param {string} value - The language such as de-DE
     */ get targetLanguages() {
        if (this.privSpeechProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) return this.privSpeechProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
        else return [];
    }
    /**
     * Gets the voice name.
     * @member SpeechTranslationConfigImpl.prototype.voiceName
     * @function
     * @public
     */ get voiceName() {
        return this.getProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_TranslationVoice]);
    }
    /**
     * Gets/Sets the voice of the translated language, enable voice synthesis output.
     * @member SpeechTranslationConfigImpl.prototype.voiceName
     * @function
     * @public
     * @param {string} value - The name of the voice.
     */ set voiceName(value) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationVoice, value);
    }
    /**
     * Provides the region.
     * @member SpeechTranslationConfigImpl.prototype.region
     * @function
     * @public
     * @returns {string} The region.
     */ get region() {
        return this.privSpeechProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_Region);
    }
    get tokenCredential() {
        return this.privTokenCredential;
    }
    setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_ProxyPassword], proxyPassword);
    }
    /**
     * Gets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {string} name - The name of the property.
     * @param {string} def - The default value of the property in case it is not set.
     * @returns {string} The value of the property.
     */ getProperty(name, def) {
        return this.privSpeechProperties.getProperty(name, def);
    }
    /**
     * Gets/Sets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {string | PropertyId} name - The name of the property to set.
     * @param {string} value - The value of the property.
     */ setProperty(name, value) {
        this.privSpeechProperties.setProperty(name, value);
    }
    /**
     * Provides access to custom properties.
     * @member SpeechTranslationConfigImpl.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The properties.
     */ get properties() {
        return this.privSpeechProperties;
    }
    /**
     * Dispose of associated resources.
     * @member SpeechTranslationConfigImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
    setServiceProperty(name, value) {
        const currentProperties = JSON.parse(this.privSpeechProperties.getProperty($hgjD5.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privSpeechProperties.setProperty($hgjD5.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    }
    setProfanity(profanity) {
        this.privSpeechProperties.setProperty($gttSn.PropertyId.SpeechServiceResponse_ProfanityOption, $gttSn.ProfanityOption[profanity]);
    }
    enableAudioLogging() {
        this.privSpeechProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privSpeechProperties.setProperty($gttSn.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privSpeechProperties.setProperty($hgjD5.ForceDictationPropertyName, "true");
    }
    get speechSynthesisLanguage() {
        return this.privSpeechProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(language) {
        this.privSpeechProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_SynthLanguage, language);
    }
    get speechSynthesisVoiceName() {
        return this.privSpeechProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(voice) {
        this.privSpeechProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_SynthVoice, voice);
    }
    get speechSynthesisOutputFormat() {
        // eslint-disable-next-line
        return $gttSn.SpeechSynthesisOutputFormat[this.privSpeechProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)];
    }
    set speechSynthesisOutputFormat(format) {
        this.privSpeechProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_SynthOutputFormat, $gttSn.SpeechSynthesisOutputFormat[format]);
    }
}
module.exports.SpeechTranslationConfigImpl = $d605ccecc3ab7f41$var$SpeechTranslationConfigImpl;

});

parcelRegister("isROj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyCollection = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Represents collection of properties and their values.
 * @class PropertyCollection
 */ class $d714952c6de1dabc$var$PropertyCollection {
    constructor(){
        this.privKeys = [];
        this.privValues = [];
    }
    /**
     * Returns the property value in type String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member PropertyCollection.prototype.getProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string | number | boolean} def - The default value which is returned if the parameter
     * is not available in the collection.
     * @returns {string} value of the parameter.
     */ getProperty(key, def) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = $gttSn.PropertyId[key];
        for(let n = 0; n < this.privKeys.length; n++){
            if (this.privKeys[n] === keyToUse) return this.privValues[n];
        }
        if (def === undefined) return undefined;
        return String(def);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member PropertyCollection.prototype.setProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ setProperty(key, value) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = $gttSn.PropertyId[key];
        for(let n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === keyToUse) {
            this.privValues[n] = value;
            return;
        }
        this.privKeys.push(keyToUse);
        this.privValues.push(value);
    }
    /**
     * Clones the collection.
     * @member PropertyCollection.prototype.clone
     * @function
     * @public
     * @returns {PropertyCollection} A copy of the collection.
     */ clone() {
        const clonedMap = new $d714952c6de1dabc$var$PropertyCollection();
        for(let n = 0; n < this.privKeys.length; n++){
            clonedMap.privKeys.push(this.privKeys[n]);
            clonedMap.privValues.push(this.privValues[n]);
        }
        return clonedMap;
    }
    /**
     * Merges this set of properties into another, no overwrites.
     * @member PropertyCollection.prototype.mergeTo
     * @function
     * @public
     * @param {PropertyCollection}  destinationCollection - The collection to merge into.
     */ mergeTo(destinationCollection) {
        this.privKeys.forEach((key)=>{
            if (destinationCollection.getProperty(key, undefined) === undefined) {
                const value = this.getProperty(key);
                destinationCollection.setProperty(key, value);
            }
        });
    }
    /**
     * Get the keys in Property Collection.
     * @member PropertyCollection.prototype.keys
     * @function
     * @public
     * @returns {string []} Keys in the collection.
     */ get keys() {
        return this.privKeys;
    }
}
module.exports.PropertyCollection = $d714952c6de1dabc$var$PropertyCollection;

});

parcelRegister("fWPg2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyId = void 0;
/**
 * Defines speech property ids.
 * @class PropertyId
 */ var $b9c4087a93e84323$var$PropertyId;
(function(PropertyId) {
    /**
     * The Cognitive Services Speech Service subscription Key. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]].
     * @member PropertyId.SpeechServiceConnection_Key
     */ PropertyId[PropertyId["SpeechServiceConnection_Key"] = 0] = "SpeechServiceConnection_Key";
    /**
     * The Cognitive Services Speech Service endpoint (url). Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromEndpoint]].
     * NOTE: This endpoint is not the same as the endpoint used to obtain an access token.
     * @member PropertyId.SpeechServiceConnection_Endpoint
     */ PropertyId[PropertyId["SpeechServiceConnection_Endpoint"] = 1] = "SpeechServiceConnection_Endpoint";
    /**
     * The Cognitive Services Speech Service region. Under normal circumstances, you shouldn't have to
     * use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]], [[SpeechConfig.fromEndpoint]], [[SpeechConfig.fromAuthorizationToken]].
     * @member PropertyId.SpeechServiceConnection_Region
     */ PropertyId[PropertyId["SpeechServiceConnection_Region"] = 2] = "SpeechServiceConnection_Region";
    /**
     * The Cognitive Services Speech Service authorization token (aka access token). Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromAuthorizationToken]], [[SpeechRecognizer.authorizationToken]],
     * [[TranslationRecognizer.authorizationToken]], [[SpeakerRecognizer.authorizationToken]].
     * @member PropertyId.SpeechServiceAuthorization_Token
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Token"] = 3] = "SpeechServiceAuthorization_Token";
    /**
     * The Cognitive Services Speech Service authorization type. Currently unused.
     * @member PropertyId.SpeechServiceAuthorization_Type
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Type"] = 4] = "SpeechServiceAuthorization_Type";
    /**
     * The Cognitive Services Speech Service endpoint id. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.endpointId]].
     * NOTE: The endpoint id is available in the Speech Portal, listed under Endpoint Details.
     * @member PropertyId.SpeechServiceConnection_EndpointId
     */ PropertyId[PropertyId["SpeechServiceConnection_EndpointId"] = 5] = "SpeechServiceConnection_EndpointId";
    /**
     * The list of comma separated languages (BCP-47 format) used as target translation languages. Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead use [[SpeechTranslationConfig.addTargetLanguage]],
     * [[SpeechTranslationConfig.targetLanguages]], [[TranslationRecognizer.targetLanguages]].
     * @member PropertyId.SpeechServiceConnection_TranslationToLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationToLanguages"] = 6] = "SpeechServiceConnection_TranslationToLanguages";
    /**
     * The name of the Cognitive Service Text to Speech Service Voice. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead, use [[SpeechTranslationConfig.voiceName]].
     * NOTE: Valid voice names can be found <a href="https://aka.ms/csspeech/voicenames">here</a>.
     * @member PropertyId.SpeechServiceConnection_TranslationVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationVoice"] = 7] = "SpeechServiceConnection_TranslationVoice";
    /**
     * Translation features.
     * @member PropertyId.SpeechServiceConnection_TranslationFeatures
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationFeatures"] = 8] = "SpeechServiceConnection_TranslationFeatures";
    /**
     * The category ID for translation.
     * @member PropertyId.SpeechServiceConnection_TranslationCategoryId
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationCategoryId"] = 9] = "SpeechServiceConnection_TranslationCategoryId";
    /**
     * The host name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyHostName"] = 10] = "SpeechServiceConnection_ProxyHostName";
    /**
     * The port of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPort"] = 11] = "SpeechServiceConnection_ProxyPort";
    /**
     * The user name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyUserName"] = 12] = "SpeechServiceConnection_ProxyUserName";
    /**
     * The password of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPassword"] = 13] = "SpeechServiceConnection_ProxyPassword";
    /**
     * The Cognitive Services Speech Service recognition Mode. Can be "INTERACTIVE", "CONVERSATION", "DICTATION".
     * This property is intended to be read-only. The SDK is using it internally.
     * @member PropertyId.SpeechServiceConnection_RecoMode
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoMode"] = 14] = "SpeechServiceConnection_RecoMode";
    /**
     * The spoken language to be recognized (in BCP-47 format). Under normal circumstances, you shouldn't have to use this property
     * directly.
     * Instead, use [[SpeechConfig.speechRecognitionLanguage]].
     * @member PropertyId.SpeechServiceConnection_RecoLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoLanguage"] = 15] = "SpeechServiceConnection_RecoLanguage";
    /**
     * The session id. This id is a universally unique identifier (aka UUID) representing a specific binding of an audio input stream
     * and the underlying speech recognition instance to which it is bound. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead use [[SessionEventArgs.sessionId]].
     * @member PropertyId.Speech_SessionId
     */ PropertyId[PropertyId["Speech_SessionId"] = 16] = "Speech_SessionId";
    /**
     * The spoken language to be synthesized (e.g. en-US)
     * @member PropertyId.SpeechServiceConnection_SynthLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthLanguage"] = 17] = "SpeechServiceConnection_SynthLanguage";
    /**
     * The name of the TTS voice to be used for speech synthesis
     * @member PropertyId.SpeechServiceConnection_SynthVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthVoice"] = 18] = "SpeechServiceConnection_SynthVoice";
    /**
     * The string to specify TTS output audio format
     * @member PropertyId.SpeechServiceConnection_SynthOutputFormat
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthOutputFormat"] = 19] = "SpeechServiceConnection_SynthOutputFormat";
    /**
     * The list of comma separated languages used as possible source languages
     * Added in version 1.13.0
     * @member PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_AutoDetectSourceLanguages"] = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages";
    /**
     * The requested Cognitive Services Speech Service response output format (simple or detailed). Under normal circumstances, you shouldn't have
     * to use this property directly.
     * Instead use [[SpeechConfig.outputFormat]].
     * @member PropertyId.SpeechServiceResponse_RequestDetailedResultTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestDetailedResultTrueFalse"] = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse";
    /**
     * The requested Cognitive Services Speech Service response output profanity level. Currently unused.
     * @member PropertyId.SpeechServiceResponse_RequestProfanityFilterTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestProfanityFilterTrueFalse"] = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse";
    /**
     * The Cognitive Services Speech Service response output (in JSON format). This property is available on recognition result objects only.
     * @member PropertyId.SpeechServiceResponse_JsonResult
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonResult"] = 23] = "SpeechServiceResponse_JsonResult";
    /**
     * The Cognitive Services Speech Service error details (in JSON format). Under normal circumstances, you shouldn't have to
     * use this property directly. Instead use [[CancellationDetails.errorDetails]].
     * @member PropertyId.SpeechServiceResponse_JsonErrorDetails
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonErrorDetails"] = 24] = "SpeechServiceResponse_JsonErrorDetails";
    /**
     * The cancellation reason. Currently unused.
     * @member PropertyId.CancellationDetails_Reason
     */ PropertyId[PropertyId["CancellationDetails_Reason"] = 25] = "CancellationDetails_Reason";
    /**
     * The cancellation text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonText
     */ PropertyId[PropertyId["CancellationDetails_ReasonText"] = 26] = "CancellationDetails_ReasonText";
    /**
     * The Cancellation detailed text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonDetailedText
     */ PropertyId[PropertyId["CancellationDetails_ReasonDetailedText"] = 27] = "CancellationDetails_ReasonDetailedText";
    /**
     * The URL string built from speech configuration.
     * This property is intended to be read-only. The SDK is using it internally.
     * NOTE: Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_Url"] = 28] = "SpeechServiceConnection_Url";
    /**
     * The initial silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_InitialSilenceTimeoutMs"] = 29] = "SpeechServiceConnection_InitialSilenceTimeoutMs";
    /**
     * This property is deprecated.
     * For current information about silence timeouts, please visit https://aka.ms/csspeech/timeouts.
     */ PropertyId[PropertyId["SpeechServiceConnection_EndSilenceTimeoutMs"] = 30] = "SpeechServiceConnection_EndSilenceTimeoutMs";
    /**
     * A duration of detected silence, measured in milliseconds, after which speech-to-text will determine a spoken
     * phrase has ended and generate a final Recognized result. Configuring this timeout may be helpful in situations
     * where spoken input is significantly faster or slower than usual and default segmentation behavior consistently
     * yields results that are too long or too short. Segmentation timeout values that are inappropriately high or low
     * can negatively affect speech-to-text accuracy; this property should be carefully configured and the resulting
     * behavior should be thoroughly validated as intended.
     *
     * Refer to the documentation for valid value ranges and additional details:
     * https://aka.ms/csspeech/timeouts
     *
     * Added in version 1.42.0.
     */ PropertyId[PropertyId["Speech_SegmentationSilenceTimeoutMs"] = 31] = "Speech_SegmentationSilenceTimeoutMs";
    /**
     * SegmentationMaximumTimeMs represents the maximum length of a spoken phrase when using the Time segmentation strategy.
     * @member Speech_SegmentationSilenceTimeoutMs must be set in order to use this setting.
     * As the length of a spoken phrase approaches this value, the @member Speech_SegmentationSilenceTimeoutMs will be reduced until either
     * the phrase silence timeout is reached or the phrase reaches the maximum length.
     *
     * Valid range: **20,000 to 70,000** milliseconds.
     *
     * Added in version 1.42.0.
     */ PropertyId[PropertyId["Speech_SegmentationMaximumTimeMs"] = 32] = "Speech_SegmentationMaximumTimeMs";
    /**
     * Specifies the strategy used to determine when a spoken phrase has ended,
     * triggering the generation of a final recognition result.
     *
     * Supported values:
     * - "Default": Uses the Speech Service's default segmentation strategy. Recommended for most use cases.
     * - "Time": Uses a silence-based timeout. A final result is generated after a defined period of silence.
     * Requires @member Speech_SegmentationMaximumTimeMs to be configured appropriately.
     * Optional: Adjust @member Speech_SegmentationSilenceTimeoutMs to control how much silence ends a phrase.
     * - "Semantic": Uses an AI model to semantically infer phrase boundaries based on content.
     * No adjustable parameters are available for this strategy.
     *
     * Introduced in version 1.42.0.
     */ PropertyId[PropertyId["Speech_SegmentationStrategy"] = 33] = "Speech_SegmentationStrategy";
    /**
     * The sensitivity of how soon a potential speech start can be signaled.
     * Allowed values are "low" (default), "medium" and "high".
     */ PropertyId[PropertyId["Speech_StartEventSensitivity"] = 34] = "Speech_StartEventSensitivity";
    /**
     * A boolean value specifying whether audio logging is enabled in the service or not.
     * Audio and content logs are stored either in Microsoft-owned storage, or in your own storage account linked
     * to your Cognitive Services subscription (Bring Your Own Storage (BYOS) enabled Speech resource).
     * The logs will be removed after 30 days.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EnableAudioLogging"] = 35] = "SpeechServiceConnection_EnableAudioLogging";
    /**
     * The speech service connection language identifier mode.
     * Can be "AtStart" (the default), or "Continuous". See Language
     * Identification document https://aka.ms/speech/lid?pivots=programming-language-javascript
     * for more details.
     * Added in 1.25.0
     **/ PropertyId[PropertyId["SpeechServiceConnection_LanguageIdMode"] = 36] = "SpeechServiceConnection_LanguageIdMode";
    /**
     * A string value representing the desired endpoint version to target for Speech Recognition.
     * Added in version 1.21.0
     */ PropertyId[PropertyId["SpeechServiceConnection_RecognitionEndpointVersion"] = 37] = "SpeechServiceConnection_RecognitionEndpointVersion";
    /**
     * The requested Cognitive Services Speech Service response output profanity setting.
     * Allowed values are "masked", "removed", and "raw".
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_ProfanityOption"] = 38] = "SpeechServiceResponse_ProfanityOption";
    /**
     * A string value specifying which post processing option should be used by service.
     * Allowed values are "TrueText".
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_PostProcessingOption"] = 39] = "SpeechServiceResponse_PostProcessingOption";
    /**
     * A boolean value specifying whether to include word-level timestamps in the response result.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordLevelTimestamps"] = 40] = "SpeechServiceResponse_RequestWordLevelTimestamps";
    /**
     * The number of times a word has to be in partial results to be returned.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_StablePartialResultThreshold"] = 41] = "SpeechServiceResponse_StablePartialResultThreshold";
    /**
     * A string value specifying the output format option in the response result. Internal use only.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_OutputFormatOption"] = 42] = "SpeechServiceResponse_OutputFormatOption";
    /**
     * A boolean value to request for stabilizing translation partial results by omitting words in the end.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_TranslationRequestStablePartialResult"] = 43] = "SpeechServiceResponse_TranslationRequestStablePartialResult";
    /**
     * A boolean value specifying whether to request WordBoundary events.
     * @member PropertyId.SpeechServiceResponse_RequestWordBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordBoundary"] = 44] = "SpeechServiceResponse_RequestWordBoundary";
    /**
     * A boolean value specifying whether to request punctuation boundary in WordBoundary Events. Default is true.
     * @member PropertyId.SpeechServiceResponse_RequestPunctuationBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestPunctuationBoundary"] = 45] = "SpeechServiceResponse_RequestPunctuationBoundary";
    /**
     * A boolean value specifying whether to request sentence boundary in WordBoundary Events. Default is false.
     * @member PropertyId.SpeechServiceResponse_RequestSentenceBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestSentenceBoundary"] = 46] = "SpeechServiceResponse_RequestSentenceBoundary";
    /**
     * Determines if intermediate results contain speaker identification.
     * Allowed values are "true" or "false". If set to "true", the intermediate results will contain speaker identification.
     * The default value if unset or set to an invalid value is "false".
     * This is currently only supported for scenarios using the ConversationTranscriber".
     * @member PropertyId.SpeechServiceResponse_DiarizeIntermediateResults
     * Adding in version 1.41.
     */ PropertyId[PropertyId["SpeechServiceResponse_DiarizeIntermediateResults"] = 47] = "SpeechServiceResponse_DiarizeIntermediateResults";
    /**
     * Identifier used to connect to the backend service.
     * @member PropertyId.Conversation_ApplicationId
     */ PropertyId[PropertyId["Conversation_ApplicationId"] = 48] = "Conversation_ApplicationId";
    /**
     * Type of dialog backend to connect to.
     * @member PropertyId.Conversation_DialogType
     */ PropertyId[PropertyId["Conversation_DialogType"] = 49] = "Conversation_DialogType";
    /**
     * Silence timeout for listening
     * @member PropertyId.Conversation_Initial_Silence_Timeout
     */ PropertyId[PropertyId["Conversation_Initial_Silence_Timeout"] = 50] = "Conversation_Initial_Silence_Timeout";
    /**
     * From Id to add to speech recognition activities.
     * @member PropertyId.Conversation_From_Id
     */ PropertyId[PropertyId["Conversation_From_Id"] = 51] = "Conversation_From_Id";
    /**
     * ConversationId for the session.
     * @member PropertyId.Conversation_Conversation_Id
     */ PropertyId[PropertyId["Conversation_Conversation_Id"] = 52] = "Conversation_Conversation_Id";
    /**
     * Comma separated list of custom voice deployment ids.
     * @member PropertyId.Conversation_Custom_Voice_Deployment_Ids
     */ PropertyId[PropertyId["Conversation_Custom_Voice_Deployment_Ids"] = 53] = "Conversation_Custom_Voice_Deployment_Ids";
    /**
     * Speech activity template, stamp properties from the template on the activity generated by the service for speech.
     * @member PropertyId.Conversation_Speech_Activity_Template
     * Added in version 1.10.0.
     */ PropertyId[PropertyId["Conversation_Speech_Activity_Template"] = 54] = "Conversation_Speech_Activity_Template";
    /**
     * Enables or disables the receipt of turn status messages as obtained on the turnStatusReceived event.
     * @member PropertyId.Conversation_Request_Bot_Status_Messages
     * Added in version 1.15.0.
     */ PropertyId[PropertyId["Conversation_Request_Bot_Status_Messages"] = 55] = "Conversation_Request_Bot_Status_Messages";
    /**
     * Specifies the connection ID to be provided in the Agent configuration message, e.g. a Direct Line token for
     * channel authentication.
     * Added in version 1.15.1.
     */ PropertyId[PropertyId["Conversation_Agent_Connection_Id"] = 56] = "Conversation_Agent_Connection_Id";
    /**
     * The Cognitive Services Speech Service host (url). Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromHost]].
     */ PropertyId[PropertyId["SpeechServiceConnection_Host"] = 57] = "SpeechServiceConnection_Host";
    /**
     * Set the host for service calls to the Conversation Translator REST management and websocket calls.
     */ PropertyId[PropertyId["ConversationTranslator_Host"] = 58] = "ConversationTranslator_Host";
    /**
     * Optionally set the the host's display name.
     * Used when joining a conversation.
     */ PropertyId[PropertyId["ConversationTranslator_Name"] = 59] = "ConversationTranslator_Name";
    /**
     * Optionally set a value for the X-CorrelationId request header.
     * Used for troubleshooting errors in the server logs. It should be a valid guid.
     */ PropertyId[PropertyId["ConversationTranslator_CorrelationId"] = 60] = "ConversationTranslator_CorrelationId";
    /**
     * Set the conversation token to be sent to the speech service. This enables the
     * service to service call from the speech service to the Conversation Translator service for relaying
     * recognitions. For internal use.
     */ PropertyId[PropertyId["ConversationTranslator_Token"] = 61] = "ConversationTranslator_Token";
    /**
     * The reference text of the audio for pronunciation evaluation.
     * For this and the following pronunciation assessment parameters, see
     * https://docs.microsoft.com/azure/cognitive-services/speech-service/rest-speech-to-text#pronunciation-assessment-parameters for details.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_ReferenceText"] = 62] = "PronunciationAssessment_ReferenceText";
    /**
     * The point system for pronunciation score calibration (FivePoint or HundredMark).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_GradingSystem"] = 63] = "PronunciationAssessment_GradingSystem";
    /**
     * The pronunciation evaluation granularity (Phoneme, Word, or FullText).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Granularity"] = 64] = "PronunciationAssessment_Granularity";
    /**
     * Defines if enable miscue calculation.
     * With this enabled, the pronounced words will be compared to the reference text,
     * and will be marked with omission/insertion based on the comparison. The default setting is False.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_EnableMiscue"] = 65] = "PronunciationAssessment_EnableMiscue";
    /**
     * The json string of pronunciation assessment parameters
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Json"] = 66] = "PronunciationAssessment_Json";
    /**
     * Pronunciation assessment parameters.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Params"] = 67] = "PronunciationAssessment_Params";
    /**
     * Specifies whether to allow load of data URL for web worker
     * Allowed values are "off" and "on". Default is "on".
     * Added in version 1.32.0
     */ PropertyId[PropertyId["WebWorkerLoadType"] = 68] = "WebWorkerLoadType";
    /**
     * Talking avatar service WebRTC session description protocol.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.33.0
     */ PropertyId[PropertyId["TalkingAvatarService_WebRTC_SDP"] = 69] = "TalkingAvatarService_WebRTC_SDP";
})($b9c4087a93e84323$var$PropertyId = module.exports.PropertyId || (module.exports.PropertyId = {}));

});

parcelRegister("fTUeo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
/**
 * Defines the base class Recognizer which mainly contains common event handlers.
 * @class Recognizer
 */ class $b9379c624d89d1aa$var$Recognizer {
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {AudioConfig} audioInput - An optional audio input stream associated with the recognizer
     * @param {PropertyCollection} properties - A set of properties to set on the recognizer
     * @param {IConnectionFactory} connectionFactory - The factory class used to create a custom IConnection for the recognizer
     */ constructor(audioConfig, properties, connectionFactory, tokenCredential){
        this.audioConfig = audioConfig !== undefined ? audioConfig : $gttSn.AudioConfig.fromDefaultMicrophoneInput();
        this.privDisposed = false;
        this.privProperties = properties.clone();
        this.privConnectionFactory = connectionFactory;
        this.tokenCredential = tokenCredential;
        this.implCommonRecognizerSetup();
    }
    /**
     * Dispose of associated resources.
     * @member Recognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposed);
        (0, $5OUhN.marshalPromiseToCallbacks)(this.dispose(true), cb, errorCb);
    }
    /**
     * @Internal
     * Internal data member to support fromRecognizer* pattern methods on other classes.
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privReco;
    }
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Recognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ async dispose(disposing) {
        if (this.privDisposed) return;
        this.privDisposed = true;
        if (disposing) {
            if (this.privReco) {
                await this.privReco.audioSource.turnOff();
                await this.privReco.dispose();
            }
        }
    }
    /**
     * This method returns the current state of the telemetry setting.
     * @member Recognizer.prototype.telemetryEnabled
     * @function
     * @public
     * @returns true if the telemetry is enabled, false otherwise.
     */ static get telemetryEnabled() {
        return $hgjD5.ServiceRecognizerBase.telemetryDataEnabled;
    }
    /**
     * This method globally enables or disables telemetry.
     * @member Recognizer.prototype.enableTelemetry
     * @function
     * @public
     * @param enabled - Global setting for telemetry collection.
     * If set to true, telemetry information like microphone errors,
     * recognition errors are collected and sent to Microsoft.
     * If set to false, no telemetry is sent to Microsoft.
     */ static enableTelemetry(enabled) {
        $hgjD5.ServiceRecognizerBase.telemetryDataEnabled = enabled;
    }
    // Does the generic recognizer setup that is common across all recognizer types.
    implCommonRecognizerSetup() {
        let osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        let osName = "unknown";
        let osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        const recognizerConfig = this.createRecognizerConfig(new $hgjD5.SpeechServiceConfig(new $hgjD5.Context(new $hgjD5.OS(osPlatform, osName, osVersion))));
        this.privReco = this.createServiceRecognizer($b9379c624d89d1aa$var$Recognizer.getAuth(this.privProperties, this.tokenCredential), this.privConnectionFactory, this.audioConfig, recognizerConfig);
    }
    async recognizeOnceAsyncImpl(recognitionMode) {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposed);
        const ret = new $5OUhN.Deferred();
        await this.implRecognizerStop();
        await this.privReco.recognize(recognitionMode, ret.resolve, ret.reject);
        const result = await ret.promise;
        await this.implRecognizerStop();
        return result;
    }
    async startContinuousRecognitionAsyncImpl(recognitionMode) {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposed);
        await this.implRecognizerStop();
        await this.privReco.recognize(recognitionMode, undefined, undefined);
    }
    async stopContinuousRecognitionAsyncImpl() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposed);
        await this.implRecognizerStop();
    }
    async implRecognizerStop() {
        if (this.privReco) await this.privReco.stopRecognizing();
        return;
    }
    static getAuth(properties, tokenCredential) {
        const subscriptionKey = properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_Key, undefined);
        if (subscriptionKey && subscriptionKey !== "") return new $hgjD5.CognitiveSubscriptionKeyAuthentication(subscriptionKey);
        if (tokenCredential) return new $hgjD5.CognitiveTokenAuthentication(async ()=>{
            try {
                const tokenResponse = await tokenCredential.getToken("https://cognitiveservices.azure.com/.default");
                return tokenResponse?.token ?? "";
            } catch (err) {
                throw err;
            }
        }, async ()=>{
            try {
                const tokenResponse = await tokenCredential.getToken("https://cognitiveservices.azure.com/.default");
                return tokenResponse?.token ?? "";
            } catch (err) {
                throw err;
            }
        });
        return new $hgjD5.CognitiveTokenAuthentication(()=>{
            const authorizationToken = properties.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, ()=>{
            const authorizationToken = properties.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
    }
}
module.exports.Recognizer = $b9379c624d89d1aa$var$Recognizer;

});

parcelRegister("2eIQR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognizer = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $6rQ2O = parcelRequire("6rQ2O");

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
/**
 * Performs speech recognition from microphone, file, or other audio input streams, and gets transcribed text as result.
 * @class SpeechRecognizer
 */ class $1a0fae283b39512b$var$SpeechRecognizer extends $gttSn.Recognizer {
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ constructor(speechConfig, audioConfig){
        const speechConfigImpl = speechConfig;
        $3SMEZ.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(speechConfigImpl.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage), $gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage]);
        super(audioConfig, speechConfigImpl.properties, new $hgjD5.SpeechConnectionFactory(), speechConfig.tokenCredential);
        this.privDisposedRecognizer = false;
    }
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ static FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        const recognizer = new $1a0fae283b39512b$var$SpeechRecognizer(speechConfig, audioConfig);
        return recognizer;
    }
    /**
     * Gets the endpoint id of a customized speech model that is used for speech recognition.
     * @member SpeechRecognizer.prototype.endpointId
     * @function
     * @public
     * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
     */ get endpointId() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * Gets the spoken language of recognition.
     * @member SpeechRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of recognition.
     */ get speechRecognitionLanguage() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the output format of recognition.
     * @member SpeechRecognizer.prototype.outputFormat
     * @function
     * @public
     * @returns {OutputFormat} The output format of recognition.
     */ get outputFormat() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        if (this.properties.getProperty($hgjD5.OutputFormatPropertyName, $gttSn.OutputFormat[$gttSn.OutputFormat.Simple]) === $gttSn.OutputFormat[$gttSn.OutputFormat.Simple]) return $gttSn.OutputFormat.Simple;
        else return $gttSn.OutputFormat.Detailed;
    }
    /**
     * The collection of properties and their values defined for this SpeechRecognizer.
     * @member SpeechRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Starts speech recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     * so it is suitable only for single shot recognition
     * like command or query. For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member SpeechRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the SpeechRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */ recognizeOnceAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.recognizeOnceAsyncImpl($6rQ2O.RecognitionMode.Interactive), cb, err);
    }
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member SpeechRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startContinuousRecognitionAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.startContinuousRecognitionAsyncImpl(this.properties.getProperty($hgjD5.ForceDictationPropertyName, undefined) === undefined ? $6rQ2O.RecognitionMode.Conversation : $6rQ2O.RecognitionMode.Dictation), cb, err);
    }
    /**
     * Stops continuous speech recognition.
     * @member SpeechRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopContinuousRecognitionAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * Starts speech recognition with keyword spotting, until
     * stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model The keyword recognition model that
     * specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startKeywordRecognitionAsync(model, cb, err) {
        $3SMEZ.Contracts.throwIfNull(model, "model");
        if (!!err) err("Not yet implemented.");
    }
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopKeywordRecognitionAsync(cb) {
        if (!!cb) cb();
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member SpeechRecognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        (0, $5OUhN.marshalPromiseToCallbacks)(this.dispose(true), cb, errorCb);
    }
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (disposing) {
            this.privDisposedRecognizer = true;
            await this.implRecognizerStop();
        }
        await super.dispose(disposing);
    }
    createRecognizerConfig(speechConfig) {
        return new $hgjD5.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        return new $hgjD5.SpeechServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
}
module.exports.SpeechRecognizer = $1a0fae283b39512b$var$SpeechRecognizer;

});
parcelRegister("6rQ2O", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechStartEventSensitivity = module.exports.RecognitionMode = void 0;
/**
 * The Recognition modes
 */ var $4b1da2a4c54a046a$var$RecognitionMode;
(function(RecognitionMode) {
    RecognitionMode["Interactive"] = "Interactive";
    RecognitionMode["Dictation"] = "Dictation";
    RecognitionMode["Conversation"] = "Conversation";
    RecognitionMode["None"] = "None";
})($4b1da2a4c54a046a$var$RecognitionMode = module.exports.RecognitionMode || (module.exports.RecognitionMode = {}));
/**
 * The speech start event sensitivity.
 */ var $4b1da2a4c54a046a$var$SpeechStartEventSensitivity;
(function(SpeechStartEventSensitivity) {
    SpeechStartEventSensitivity["Low"] = "low";
    SpeechStartEventSensitivity["Medium"] = "medium";
    SpeechStartEventSensitivity["High"] = "high";
})($4b1da2a4c54a046a$var$SpeechStartEventSensitivity = module.exports.SpeechStartEventSensitivity || (module.exports.SpeechStartEventSensitivity = {}));

});


parcelRegister("4s3Fn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognizer = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $6rQ2O = parcelRequire("6rQ2O");

var $5OUhN = parcelRequire("5OUhN");

var $e8g5r = parcelRequire("e8g5r");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
/**
 * Translation recognizer
 * @class TranslationRecognizer
 */ class $33dc9f017f3dac92$var$TranslationRecognizer extends $gttSn.Recognizer {
    /**
     * Initializes an instance of the TranslationRecognizer.
     * @constructor
     * @param {SpeechTranslationConfig} speechConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     * @param {IConnectionFactory} connectionFactory - An optional connection factory to use to generate the endpoint URIs, headers to set, etc...
     */ constructor(speechConfig, audioConfig, connectionFactory){
        const configImpl = speechConfig;
        $3SMEZ.Contracts.throwIfNull(configImpl, "speechConfig");
        super(audioConfig, configImpl.properties, connectionFactory || new $hgjD5.TranslationConnectionFactory(), speechConfig.tokenCredential);
        this.privDisposedTranslationRecognizer = false;
        if (this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationVoice, undefined) !== undefined) $3SMEZ.Contracts.throwIfNullOrWhitespace(this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationVoice), $gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_TranslationVoice]);
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages), $gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages]);
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage), $gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage]);
    }
    /**
     * TranslationRecognizer constructor.
     * @constructor
     * @param {SpeechTranslationConfig} speechTranslationConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ static FromConfig(speechTranslationConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechTranslationConfigImpl = speechTranslationConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechTranslationConfigImpl.properties);
        if (autoDetectSourceLanguageConfig.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, undefined) === $hgjD5.AutoDetectSourceLanguagesOpenRangeOptionName) speechTranslationConfigImpl.properties.setProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage, "en-US");
        return new $33dc9f017f3dac92$var$TranslationRecognizer(speechTranslationConfig, audioConfig);
    }
    /**
     * Gets the language name that was set when the recognizer was created.
     * @member TranslationRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} Gets the language name that was set when the recognizer was created.
     */ get speechRecognitionLanguage() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets target languages for translation that were set when the recognizer was created.
     * The language is specified in BCP-47 format. The translation will provide translated text for each of language.
     * @member TranslationRecognizer.prototype.targetLanguages
     * @function
     * @public
     * @returns {string[]} Gets target languages for translation that were set when the recognizer was created.
     */ get targetLanguages() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
    }
    /**
     * Gets the name of output voice.
     * @member TranslationRecognizer.prototype.voiceName
     * @function
     * @public
     * @returns {string} the name of output voice.
     */ get voiceName() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
    }
    /**
     * The collection of properties and their values defined for this TranslationRecognizer.
     * @member TranslationRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this TranslationRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member TranslationRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member TranslationRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} value - Authorization token.
     */ set authorizationToken(value) {
        this.properties.setProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, value);
    }
    /**
     * Starts recognition and translation, and stops after the first utterance is recognized.
     * The task returns the translation text as result.
     * Note: recognizeOnceAsync returns when the first utterance has been recognized, so it is suitable only
     * for single shot recognition like command or query. For long-running recognition,
     * use startContinuousRecognitionAsync() instead.
     * @member TranslationRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the translation has completed.
     * @param err - Callback invoked in case of an error.
     */ recognizeOnceAsync(cb, err) {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        (0, $5OUhN.marshalPromiseToCallbacks)(this.recognizeOnceAsyncImpl($6rQ2O.RecognitionMode.Interactive), cb, err);
    }
    /**
     * Starts recognition and translation, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive translation results.
     * @member TranslationRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has started.
     * @param err - Callback invoked in case of an error.
     */ startContinuousRecognitionAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.startContinuousRecognitionAsyncImpl($6rQ2O.RecognitionMode.Conversation), cb, err);
    }
    /**
     * Stops continuous recognition and translation.
     * @member TranslationRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopContinuousRecognitionAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * dynamically remove a language from list of target language
     * (can be used while recognition is ongoing)
     * @member TranslationRecognizer.prototype.removeTargetLanguage
     * @function
     * @param lang - language to be removed
     * @public
     */ removeTargetLanguage(lang) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(lang, "language to be removed");
        if (this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) {
            const languages = this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
            const index = languages.indexOf(lang);
            if (index > -1) {
                languages.splice(index, 1);
                this.properties.setProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
                this.updateLanguages(languages);
            }
        }
    }
    /**
     * dynamically add a language to list of target language
     * (can be used while recognition is ongoing)
     * @member TranslationRecognizer.prototype.addTargetLanguage
     * @function
     * @param lang - language to be added
     * @public
     */ addTargetLanguage(lang) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(lang, "language to be added");
        let languages = [];
        if (this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) {
            languages = this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
            if (!languages.includes(lang)) {
                languages.push(lang);
                this.properties.setProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
            }
        } else {
            this.properties.setProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages, lang);
            languages = [
                lang
            ];
        }
        this.updateLanguages(languages);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member TranslationRecognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        (0, $5OUhN.marshalPromiseToCallbacks)(this.dispose(true), cb, errorCb);
    }
    /**
     * handles ConnectionEstablishedEvent for conversation translation scenarios.
     * @member TranslationRecognizer.prototype.onConnection
     * @function
     * @public
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    onConnection() {}
    async dispose(disposing) {
        if (this.privDisposedTranslationRecognizer) return;
        this.privDisposedTranslationRecognizer = true;
        if (disposing) {
            await this.implRecognizerStop();
            await super.dispose(disposing);
        }
    }
    createRecognizerConfig(speechConfig) {
        return new $hgjD5.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        return new $hgjD5.TranslationServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
    updateLanguages(languages) {
        const conn = $e8g5r.Connection.fromRecognizer(this);
        if (!!conn) {
            conn.setMessageProperty("speech.context", "translationcontext", {
                to: languages
            });
            conn.sendMessageAsync("event", JSON.stringify({
                id: "translation",
                name: "updateLanguage",
                to: languages
            }));
        }
    }
}
module.exports.TranslationRecognizer = $33dc9f017f3dac92$var$TranslationRecognizer;

});
parcelRegister("e8g5r", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Connection = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $2wzdb = parcelRequire("2wzdb");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
/**
 * Connection is a proxy class for managing connection to the speech service of the specified Recognizer.
 * By default, a Recognizer autonomously manages connection to service when needed.
 * The Connection class provides additional methods for users to explicitly open or close a connection and
 * to subscribe to connection status changes.
 * The use of Connection is optional, and mainly for scenarios where fine tuning of application
 * behavior based on connection status is needed. Users can optionally call Open() to manually set up a connection
 * in advance before starting recognition on the Recognizer associated with this Connection.
 * If the Recognizer needs to connect or disconnect to service, it will
 * setup or shutdown the connection independently. In this case the Connection will be notified by change of connection
 * status via Connected/Disconnected events.
 * Added in version 1.2.1.
 */ class $a49e4a8ac85e9546$var$Connection {
    /**
     * Gets the Connection instance from the specified recognizer.
     * @param recognizer The recognizer associated with the connection.
     * @return The Connection instance of the recognizer.
     */ static fromRecognizer(recognizer) {
        const recoBase = recognizer.internalData;
        const ret = new $a49e4a8ac85e9546$var$Connection();
        ret.privInternalData = recoBase;
        ret.setupEvents();
        return ret;
    }
    /**
     * Gets the Connection instance from the specified synthesizer.
     * @param synthesizer The synthesizer associated with the connection.
     * @return The Connection instance of the synthesizer.
     */ static fromSynthesizer(synthesizer) {
        const synthBase = synthesizer.internalData;
        const ret = new $a49e4a8ac85e9546$var$Connection();
        ret.privInternalData = synthBase;
        ret.setupEvents();
        return ret;
    }
    /**
     * Starts to set up connection to the service.
     * Users can optionally call openConnection() to manually set up a connection in advance before starting recognition on the
     * Recognizer associated with this Connection. After starting recognition, calling Open() will have no effect
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     */ openConnection(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.privInternalData.connect(), cb, err);
    }
    /**
     * Closes the connection the service.
     * Users can optionally call closeConnection() to manually shutdown the connection of the associated Recognizer.
     *
     * If closeConnection() is called during recognition, recognition will fail and cancel with an error.
     */ closeConnection(cb, err) {
        if (this.privInternalData instanceof $hgjD5.SynthesisAdapterBase) throw new Error("Disconnecting a synthesizer's connection is currently not supported");
        else (0, $5OUhN.marshalPromiseToCallbacks)(this.privInternalData.disconnect(), cb, err);
    }
    /**
     * Appends a parameter in a message to service.
     * Added in version 1.12.1.
     * @param path The path of the network message.
     * @param propertyName Name of the property
     * @param propertyValue Value of the property. This is a json string.
     */ setMessageProperty(path, propertyName, propertyValue) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(propertyName, "propertyName");
        if (this.privInternalData instanceof $hgjD5.ServiceRecognizerBase) {
            if (path.toLowerCase() !== "speech.context") throw new Error("Only speech.context message property sets are currently supported for recognizer");
            else {
                const context = this.privInternalData.speechContext.getContext();
                context[propertyName] = propertyValue;
            }
        } else if (this.privInternalData instanceof $hgjD5.SynthesisAdapterBase) {
            if (path.toLowerCase() !== "speech.config" && path.toLowerCase() !== "synthesis.context") throw new Error("Only speech.config and synthesis.context message paths are currently supported for synthesizer");
            else if (path.toLowerCase() === "speech.config") {
                if (propertyName.toLowerCase() !== "context") throw new Error("Only context property is currently supported for speech.config message path for synthesizer");
                else this.privInternalData.synthesizerConfig.setContextFromJson(propertyValue);
            } else this.privInternalData.synthesisContext.setSection(propertyName, propertyValue);
        }
    }
    /**
     * Sends a message to the speech service.
     * Added in version 1.13.0.
     * @param path The WebSocket path of the message
     * @param payload The payload of the message. This is a json string or a ArrayBuffer.
     * @param success A callback to indicate success.
     * @param error A callback to indicate an error.
     */ sendMessageAsync(path, payload, success, error) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.privInternalData.sendNetworkMessage(path, payload), success, error);
    }
    /**
     * Dispose of associated resources.
     */ close() {
    /* eslint-disable no-empty */ }
    setupEvents() {
        this.privEventListener = this.privInternalData.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionEstablishedEvent") {
                if (!!this.connected) this.connected(new $gttSn.ConnectionEventArgs(connectionEvent.connectionId));
            } else if (connectionEvent.name === "ConnectionClosedEvent") {
                if (!!this.disconnected) this.disconnected(new $gttSn.ConnectionEventArgs(connectionEvent.connectionId));
            } else if (connectionEvent.name === "ConnectionMessageSentEvent") {
                if (!!this.messageSent) this.messageSent(new $gttSn.ConnectionMessageEventArgs(new $2wzdb.ConnectionMessageImpl(connectionEvent.message)));
            } else if (connectionEvent.name === "ConnectionMessageReceivedEvent") {
                if (!!this.messageReceived) this.messageReceived(new $gttSn.ConnectionMessageEventArgs(new $2wzdb.ConnectionMessageImpl(connectionEvent.message)));
            }
        });
        this.privServiceEventListener = this.privInternalData.serviceEvents.attach((e)=>{
            if (!!this.receivedServiceMessage) this.receivedServiceMessage(new $gttSn.ServiceEventArgs(e.jsonString, e.name));
        });
    }
}
module.exports.Connection = $a49e4a8ac85e9546$var$Connection;

});
parcelRegister("2wzdb", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageImpl = module.exports.ConnectionMessage = void 0;

var $40Pvg = parcelRequire("40Pvg");

var $5OUhN = parcelRequire("5OUhN");

var $isROj = parcelRequire("isROj");

var $fWPg2 = parcelRequire("fWPg2");
/**
 * ConnectionMessage represents implementation specific messages sent to and received from
 * the speech service. These messages are provided for debugging purposes and should not
 * be used for production use cases with the Azure Cognitive Services Speech Service.
 * Messages sent to and received from the Speech Service are subject to change without
 * notice. This includes message contents, headers, payloads, ordering, etc.
 * Added in version 1.11.0.
 */ class $1d69e238649194b9$var$ConnectionMessage {
}
module.exports.ConnectionMessage = $1d69e238649194b9$var$ConnectionMessage;
class $1d69e238649194b9$var$ConnectionMessageImpl {
    constructor(message){
        this.privConnectionMessage = message;
        this.privProperties = new $isROj.PropertyCollection();
        if (!!this.privConnectionMessage.headers[$40Pvg.HeaderNames.ConnectionId]) this.privProperties.setProperty($fWPg2.PropertyId.Speech_SessionId, this.privConnectionMessage.headers[$40Pvg.HeaderNames.ConnectionId]);
        Object.keys(this.privConnectionMessage.headers).forEach((header)=>{
            this.privProperties.setProperty(header, this.privConnectionMessage.headers[header]);
        });
    }
    /**
     * The message path.
     */ get path() {
        return this.privConnectionMessage.headers[Object.keys(this.privConnectionMessage.headers).find((key)=>key.toLowerCase() === "path".toLowerCase())];
    }
    /**
     * Checks to see if the ConnectionMessage is a text message.
     * See also IsBinaryMessage().
     */ get isTextMessage() {
        return this.privConnectionMessage.messageType === $5OUhN.MessageType.Text;
    }
    /**
     * Checks to see if the ConnectionMessage is a binary message.
     * See also GetBinaryMessage().
     */ get isBinaryMessage() {
        return this.privConnectionMessage.messageType === $5OUhN.MessageType.Binary;
    }
    /**
     * Gets the text message payload. Typically the text message content-type is
     * application/json. To determine other content-types use
     * Properties.GetProperty("Content-Type").
     */ get TextMessage() {
        return this.privConnectionMessage.textBody;
    }
    /**
     * Gets the binary message payload.
     */ get binaryMessage() {
        return this.privConnectionMessage.binaryBody;
    }
    /**
     * A collection of properties and their values defined for this <see cref="ConnectionMessage"/>.
     * Message headers can be accessed via this collection (e.g. "Content-Type").
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Returns a string that represents the connection message.
     */ toString() {
        return "";
    }
}
module.exports.ConnectionMessageImpl = $1d69e238649194b9$var$ConnectionMessageImpl;

});



parcelRegister("gJEne", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Translations = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Represents collection of parameters and their values.
 * @class Translations
 */ class $c2f02aad7aec2118$var$Translations {
    constructor(){
        // Use an PropertyCollection internally, just wrapping it to hide the | enum syntax it has.
        this.privMap = new $gttSn.PropertyCollection();
    }
    /**
     * Get the languages in the object in a String array.
     * @member Translations.prototype.languages
     * @function
     * @public
     * @returns {string[]} languages in translations object.
     */ get languages() {
        return this.privMap.keys;
    }
    /**
     * Returns the parameter value in type String. The parameter must have the same type as String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member Translations.prototype.get
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} def - The default value which is returned if the parameter is not available in the collection.
     * @returns {string} value of the parameter.
     */ get(key, def) {
        return this.privMap.getProperty(key, def);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member Translations.prototype.set
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ set(key, value) {
        this.privMap.setProperty(key, value);
    }
}
module.exports.Translations = $c2f02aad7aec2118$var$Translations;

});

parcelRegister("k9CAk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoMatchReason = void 0;
/**
 * Defines the possible reasons a recognition result might not be recognized.
 * @class NoMatchReason
 */ var $eac29412e63b9af2$var$NoMatchReason;
(function(NoMatchReason) {
    /**
     * Indicates that speech was detected, but not recognized.
     * @member NoMatchReason.NotRecognized
     */ NoMatchReason[NoMatchReason["NotRecognized"] = 0] = "NotRecognized";
    /**
     * Indicates that the start of the audio stream contained only silence,
     * and the service timed out waiting for speech.
     * @member NoMatchReason.InitialSilenceTimeout
     */ NoMatchReason[NoMatchReason["InitialSilenceTimeout"] = 1] = "InitialSilenceTimeout";
    /**
     * Indicates that the start of the audio stream contained only noise,
     * and the service timed out waiting for speech.
     * @member NoMatchReason.InitialBabbleTimeout
     */ NoMatchReason[NoMatchReason["InitialBabbleTimeout"] = 2] = "InitialBabbleTimeout";
})($eac29412e63b9af2$var$NoMatchReason = module.exports.NoMatchReason || (module.exports.NoMatchReason = {}));

});

parcelRegister("iAXt8", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoMatchDetails = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $gttSn = parcelRequire("gttSn");
/**
 * Contains detailed information for NoMatch recognition results.
 * @class NoMatchDetails
 */ class $d899b81536145e07$var$NoMatchDetails {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {NoMatchReason} reason - The no-match reason.
     */ constructor(reason){
        this.privReason = reason;
    }
    /**
     * Creates an instance of NoMatchDetails object for the NoMatch SpeechRecognitionResults.
     * @member NoMatchDetails.fromResult
     * @function
     * @public
     * @param {SpeechRecognitionResult | TranslationRecognitionResult}
     * result - The recognition result that was not recognized.
     * @returns {NoMatchDetails} The no match details object being created.
     */ static fromResult(result) {
        const simpleSpeech = $hgjD5.SimpleSpeechPhrase.fromJSON(result.json, 0); // Offset fixups are already done.
        let reason = $gttSn.NoMatchReason.NotRecognized;
        switch(simpleSpeech.RecognitionStatus){
            case $hgjD5.RecognitionStatus.BabbleTimeout:
                reason = $gttSn.NoMatchReason.InitialBabbleTimeout;
                break;
            case $hgjD5.RecognitionStatus.InitialSilenceTimeout:
                reason = $gttSn.NoMatchReason.InitialSilenceTimeout;
                break;
            default:
                reason = $gttSn.NoMatchReason.NotRecognized;
                break;
        }
        return new $d899b81536145e07$var$NoMatchDetails(reason);
    }
    /**
     * The reason the recognition was canceled.
     * @member NoMatchDetails.prototype.reason
     * @function
     * @public
     * @returns {NoMatchReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
}
module.exports.NoMatchDetails = $d899b81536145e07$var$NoMatchDetails;

});

parcelRegister("2FCvx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionCanceledEventArgs = void 0;
/**
 * Define payload of speech recognition canceled result events.
 * @class TranslationRecognitionCanceledEventArgs
 */ class $1f1d47eaba826f3d$var$TranslationRecognitionCanceledEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionid - The session id.
     * @param {CancellationReason} cancellationReason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {TranslationRecognitionResult} result - The result.
     */ constructor(sessionid, cancellationReason, errorDetails, errorCode, result){
        this.privCancelReason = cancellationReason;
        this.privErrorDetails = errorDetails;
        this.privResult = result;
        this.privSessionId = sessionid;
        this.privErrorCode = errorCode;
    }
    /**
     * Specifies the recognition result.
     * @member TranslationRecognitionCanceledEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Specifies the session identifier.
     * @member TranslationRecognitionCanceledEventArgs.prototype.sessionId
     * @function
     * @public
     * @returns {string} the session identifier.
     */ get sessionId() {
        return this.privSessionId;
    }
    /**
     * The reason the recognition was canceled.
     * @member TranslationRecognitionCanceledEventArgs.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privCancelReason;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member TranslationRecognitionCanceledEventArgs.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
}
module.exports.TranslationRecognitionCanceledEventArgs = $1f1d47eaba826f3d$var$TranslationRecognitionCanceledEventArgs;

});

parcelRegister("9zn0S", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationDetailsBase = void 0;
/**
 * Contains detailed information about why a result was canceled.
 * @class CancellationDetailsBase
 */ class $6f793bdce9f5f847$var$CancellationDetailsBase {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - The error details, if provided.
     */ constructor(reason, errorDetails, errorCode){
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    /**
     * The reason the recognition was canceled.
     * @member CancellationDetailsBase.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member CancellationDetailsBase.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get ErrorCode() {
        return this.privErrorCode;
    }
}
module.exports.CancellationDetailsBase = $6f793bdce9f5f847$var$CancellationDetailsBase;

});

parcelRegister("2dQl7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationDetails = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $9zn0S = parcelRequire("9zn0S");

var $gttSn = parcelRequire("gttSn");
/**
 * Contains detailed information about why a result was canceled.
 * @class CancellationDetails
 */ class $19e5653d1f922425$var$CancellationDetails extends $9zn0S.CancellationDetailsBase {
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
    /**
     * Creates an instance of CancellationDetails object for the canceled RecognitionResult.
     * @member CancellationDetails.fromResult
     * @function
     * @public
     * @param {RecognitionResult | SpeechSynthesisResult} result - The result that was canceled.
     * @returns {CancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        let reason = $gttSn.CancellationReason.Error;
        let errorCode = $gttSn.CancellationErrorCode.NoError;
        if (result instanceof $gttSn.RecognitionResult && !!result.json) {
            const simpleSpeech = $hgjD5.SimpleSpeechPhrase.fromJSON(result.json, 0); // Offset fixups are already done.
            reason = $hgjD5.EnumTranslation.implTranslateCancelResult(simpleSpeech.RecognitionStatus);
        }
        if (!!result.properties) errorCode = $gttSn.CancellationErrorCode[result.properties.getProperty($hgjD5.CancellationErrorCodePropertyName, $gttSn.CancellationErrorCode[$gttSn.CancellationErrorCode.NoError])];
        return new $19e5653d1f922425$var$CancellationDetails(reason, result.errorDetails || $hgjD5.EnumTranslation.implTranslateErrorDetails(errorCode), errorCode);
    }
}
module.exports.CancellationDetails = $19e5653d1f922425$var$CancellationDetails;

});

parcelRegister("5bdH7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationErrorCode = void 0;
/**
 * Defines error code in case that CancellationReason is Error.
 * Added in version 1.1.0.
 */ var $3c589a4675c4d8b2$var$CancellationErrorCode;
(function(CancellationErrorCode) {
    /**
     * Indicates that no error occurred during speech recognition.
     */ CancellationErrorCode[CancellationErrorCode["NoError"] = 0] = "NoError";
    /**
     * Indicates an authentication error.
     */ CancellationErrorCode[CancellationErrorCode["AuthenticationFailure"] = 1] = "AuthenticationFailure";
    /**
     * Indicates that one or more recognition parameters are invalid.
     */ CancellationErrorCode[CancellationErrorCode["BadRequestParameters"] = 2] = "BadRequestParameters";
    /**
     * Indicates that the number of parallel requests exceeded the number of allowed
     * concurrent transcriptions for the subscription.
     */ CancellationErrorCode[CancellationErrorCode["TooManyRequests"] = 3] = "TooManyRequests";
    /**
     * Indicates a connection error.
     */ CancellationErrorCode[CancellationErrorCode["ConnectionFailure"] = 4] = "ConnectionFailure";
    /**
     * Indicates a time-out error when waiting for response from service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceTimeout"] = 5] = "ServiceTimeout";
    /**
     * Indicates that an error is returned by the service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceError"] = 6] = "ServiceError";
    /**
     * Indicates an unexpected runtime error.
     */ CancellationErrorCode[CancellationErrorCode["RuntimeError"] = 7] = "RuntimeError";
    /**
     * Indicates an quota overrun on existing key.
     */ CancellationErrorCode[CancellationErrorCode["Forbidden"] = 8] = "Forbidden";
})($3c589a4675c4d8b2$var$CancellationErrorCode = module.exports.CancellationErrorCode || (module.exports.CancellationErrorCode = {}));

});

parcelRegister("5QSwF", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionEventArgs = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Defines payload for connection events like Connected/Disconnected.
 * Added in version 1.2.0
 */ class $442c1ac364bc9cfe$var$ConnectionEventArgs extends $gttSn.SessionEventArgs {
}
module.exports.ConnectionEventArgs = $442c1ac364bc9cfe$var$ConnectionEventArgs;

});

parcelRegister("cGYnP", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceEventArgs = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Defines payload for any Service message event
 * Added in version 1.9.0
 */ class $93d83f217ace9ee8$var$ServiceEventArgs extends $gttSn.SessionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} json - json payload of the USP message.
     */ constructor(json, name, sessionId){
        super(sessionId);
        this.privJsonResult = json;
        this.privEventName = name;
    }
    get jsonString() {
        return this.privJsonResult;
    }
    get eventName() {
        return this.privEventName;
    }
}
module.exports.ServiceEventArgs = $93d83f217ace9ee8$var$ServiceEventArgs;

});

parcelRegister("jjpOc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PhraseListGrammar = void 0;

var $3SMEZ = parcelRequire("3SMEZ");
/**
 * Allows additions of new phrases to improve speech recognition.
 *
 * Phrases added to the recognizer are effective at the start of the next recognition, or the next time the SpeechSDK must reconnect
 * to the speech service.
 */ class $e0f3cfb916fc7ae1$var$PhraseListGrammar {
    constructor(recogBase){
        this.privGrammerBuilder = recogBase.dynamicGrammar;
    }
    /**
     * Creates a PhraseListGrammar from a given speech recognizer. Will accept any recognizer that derives from @class Recognizer.
     * @param recognizer The recognizer to add phrase lists to.
     */ static fromRecognizer(recognizer) {
        const recoBase = recognizer.internalData;
        return new $e0f3cfb916fc7ae1$var$PhraseListGrammar(recoBase);
    }
    /**
     * Adds a single phrase to the current recognizer.
     * @param phrase Phrase to add.
     */ addPhrase(phrase) {
        this.privGrammerBuilder.addPhrase(phrase);
    }
    /**
     * Adds multiple phrases to the current recognizer.
     * @param phrases Array of phrases to add.
     */ addPhrases(phrases) {
        this.privGrammerBuilder.addPhrase(phrases);
    }
    /**
     * Clears all phrases added to the current recognizer.
     */ clear() {
        this.privGrammerBuilder.clearPhrases();
    }
    /**
     * Sets the phrase list grammar biasing weight.
     * The allowed range is [0.0, 2.0].
     * The default weight is 1.0. Value zero disables the phrase list.
     * @param weight Phrase list grammar biasing weight.
     */ setWeight(weight) {
        $3SMEZ.Contracts.throwIfNumberOutOfRange(weight, "weight", 0.0, 2.0);
        this.privGrammerBuilder.setWeight(weight);
    }
}
module.exports.PhraseListGrammar = $e0f3cfb916fc7ae1$var$PhraseListGrammar;

});

parcelRegister("bLWpJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceConfigImpl = module.exports.DialogServiceConfig = void 0;

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
/**
 * Class that defines base configurations for dialog service connector
 * @class DialogServiceConfig
 */ class $8921654ac2afc31d$var$DialogServiceConfig {
    /**
     * Creates an instance of DialogService config.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Sets the corresponding backend application identifier.
     * @member DialogServiceConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to set.
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    set applicationId(value) {}
    static get DialogTypes() {
        return {
            BotFramework: "bot_framework",
            CustomCommands: "custom_commands"
        };
    }
}
module.exports.DialogServiceConfig = $8921654ac2afc31d$var$DialogServiceConfig;
/**
 * Dialog Service configuration.
 * @class DialogServiceConfigImpl
 */ class $8921654ac2afc31d$var$DialogServiceConfigImpl extends $8921654ac2afc31d$var$DialogServiceConfig {
    /**
     * Creates an instance of dialogService config.
     */ constructor(){
        super();
        this.privSpeechConfig = new $gttSn.SpeechConfigImpl();
    }
    /**
     * Provides access to custom properties.
     * @member DialogServiceConfigImpl.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The properties.
     */ get properties() {
        return this.privSpeechConfig.properties;
    }
    /**
     * Gets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     */ get speechRecognitionLanguage() {
        return this.privSpeechConfig.speechRecognitionLanguage;
    }
    /**
     * Sets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @param {string} value - The language to set.
     */ set speechRecognitionLanguage(value) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechConfig.speechRecognitionLanguage = value;
    }
    get outputFormat() {
        return this.privSpeechConfig.outputFormat;
    }
    set outputFormat(value) {
        this.privSpeechConfig.outputFormat = value;
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to set.
     * @param {string} value - The value.
     */ setProperty(name, value) {
        this.privSpeechConfig.setProperty(name, value);
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to get.
     * @param {string} def - The default value to return in case the property is not known.
     * @returns {string} The current value, or provided default, of the given property.
     */ getProperty(name, def) {
        return this.privSpeechConfig.getProperty(name);
    }
    /**
     * Sets the proxy configuration.
     * Only relevant in Node.js environments.
     * Added in version 1.4.0.
     * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
     * @param proxyPort The port number of the proxy server.
     * @param proxyUserName The user name of the proxy server.
     * @param proxyPassword The password of the proxy server.
     */ setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($gttSn.PropertyId.SpeechServiceConnection_ProxyHostName, proxyHostName);
        this.setProperty($gttSn.PropertyId.SpeechServiceConnection_ProxyPort, `${proxyPort}`);
        if (proxyUserName) this.setProperty($gttSn.PropertyId.SpeechServiceConnection_ProxyUserName, proxyUserName);
        if (proxyPassword) this.setProperty($gttSn.PropertyId.SpeechServiceConnection_ProxyPassword, proxyPassword);
    }
    setServiceProperty(name, value, channel) {
        this.privSpeechConfig.setServiceProperty(name, value);
    }
    /**
     * Dispose of associated resources.
     * @member DialogServiceConfigImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
}
module.exports.DialogServiceConfigImpl = $8921654ac2afc31d$var$DialogServiceConfigImpl;

});

parcelRegister("eaQev", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BotFrameworkConfig = void 0;

var $3SMEZ = parcelRequire("3SMEZ");

var $bLWpJ = parcelRequire("bLWpJ");

var $gttSn = parcelRequire("gttSn");
/**
 * Class that defines configurations for the dialog service connector object for using a Bot Framework backend.
 * @class BotFrameworkConfig
 */ class $a51a843e9486b8fd$var$BotFrameworkConfig extends $bLWpJ.DialogServiceConfigImpl {
    /**
     * Creates an instance of BotFrameworkConfig.
     */ constructor(){
        super();
    }
    /**
     * Creates a bot framework configuration instance with the provided subscription information.
     * @member BotFrameworkConfig.fromSubscription
     * @function
     * @public
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromSubscription(subscription, region, botId) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(subscription, "subscription");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(region, "region");
        const botFrameworkConfig = new $bLWpJ.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($gttSn.PropertyId.Conversation_DialogType, $bLWpJ.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, subscription);
        botFrameworkConfig.setProperty($gttSn.PropertyId.SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty($gttSn.PropertyId.Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    }
    /**
     * Creates a bot framework configuration instance for the specified authorization token and region.
     * Note: The caller must ensure that an authorization token is valid. Before an authorization token expires, the
     * caller must refresh it by setting the authorizationToken property on the corresponding
     * DialogServiceConnector instance created with this config. The contents of configuration objects are copied
     * when connectors are created, so setting authorizationToken on a DialogServiceConnector will not update the
     * original configuration's authorization token. Create a new configuration instance or set the
     * SpeechServiceAuthorization_Token property to update an existing instance if it will be used to create
     * further DialogServiceConnectors.
     * @member BotFrameworkConfig.fromAuthorizationToken
     * @function
     * @public
     * @param authorizationToken The authorization token associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromAuthorizationToken(authorizationToken, region, botId) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(region, "region");
        const botFrameworkConfig = new $bLWpJ.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($gttSn.PropertyId.Conversation_DialogType, $bLWpJ.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        botFrameworkConfig.setProperty($gttSn.PropertyId.SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty($gttSn.PropertyId.Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    }
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-default service host. The standard resource path will be
     * assumed. For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL) and then set the AuthorizationToken
     * property on the created BotFrameworkConfig instance.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromHost
     * @function
     * @public
     * @param {URL | string} host - If a URL is provided, the fully-qualified host with protocol (e.g.
     * wss://your.host.com:1234) will be used. If a string is provided, it will be embedded in
     * wss://{host}.convai.speech.azure.us.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     * token must be set.
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromHost(host, subscriptionKey, botId) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(host, "host");
        const resolvedHost = host instanceof URL ? host : new URL(`wss://${host}.convai.speech.azure.us`);
        $3SMEZ.Contracts.throwIfNullOrUndefined(resolvedHost, "resolvedHost");
        const botFrameworkConfig = new $bLWpJ.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($gttSn.PropertyId.Conversation_DialogType, $bLWpJ.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($gttSn.PropertyId.SpeechServiceConnection_Host, resolvedHost.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    }
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created BotFrameworkConfig instance to
     * use the authorization token.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     * token must be set.
     * @returns {BotFrameworkConfig} - A new bot framework configuration instance using the provided endpoint.
     */ static fromEndpoint(endpoint, subscriptionKey) {
        $3SMEZ.Contracts.throwIfNull(endpoint, "endpoint");
        const botFrameworkConfig = new $bLWpJ.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($gttSn.PropertyId.Conversation_DialogType, $bLWpJ.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint, endpoint.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    }
}
module.exports.BotFrameworkConfig = $a51a843e9486b8fd$var$BotFrameworkConfig;

});

parcelRegister("eFm2B", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomCommandsConfig = void 0;

var $3SMEZ = parcelRequire("3SMEZ");

var $bLWpJ = parcelRequire("bLWpJ");

var $gttSn = parcelRequire("gttSn");
/**
 * Class that defines configurations for the dialog service connector object for using a CustomCommands backend.
 * @class CustomCommandsConfig
 */ class $aad5fdeb3249605b$var$CustomCommandsConfig extends $bLWpJ.DialogServiceConfigImpl {
    /**
     * Creates an instance of CustomCommandsConfig.
     */ constructor(){
        super();
    }
    /**
     * Creates an instance of the bot framework config with the specified subscription and region.
     * @member CustomCommandsConfig.fromSubscription
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new bot framework config.
     */ static fromSubscription(applicationId, subscription, region) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(applicationId, "applicationId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(subscription, "subscription");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(region, "region");
        const customCommandsConfig = new $bLWpJ.DialogServiceConfigImpl();
        customCommandsConfig.setProperty($gttSn.PropertyId.Conversation_DialogType, $bLWpJ.DialogServiceConfig.DialogTypes.CustomCommands);
        customCommandsConfig.setProperty($gttSn.PropertyId.Conversation_ApplicationId, applicationId);
        customCommandsConfig.setProperty($gttSn.PropertyId.SpeechServiceConnection_Key, subscription);
        customCommandsConfig.setProperty($gttSn.PropertyId.SpeechServiceConnection_Region, region);
        return customCommandsConfig;
    }
    /**
     * Creates an instance of the bot framework config with the specified Speech Commands application id, authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member CustomCommandsConfig.fromAuthorizationToken
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param authorizationToken The authorization token associated with the application.
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new speech commands config.
     */ static fromAuthorizationToken(applicationId, authorizationToken, region) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(applicationId, "applicationId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(region, "region");
        const customCommandsConfig = new $bLWpJ.DialogServiceConfigImpl();
        customCommandsConfig.setProperty($gttSn.PropertyId.Conversation_DialogType, $bLWpJ.DialogServiceConfig.DialogTypes.CustomCommands);
        customCommandsConfig.setProperty($gttSn.PropertyId.Conversation_ApplicationId, applicationId);
        customCommandsConfig.setProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        customCommandsConfig.setProperty($gttSn.PropertyId.SpeechServiceConnection_Region, region);
        return customCommandsConfig;
    }
    /**
     * Sets the corresponding backend application identifier.
     * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to set.
     */ set applicationId(value) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(value, "value");
        this.setProperty($gttSn.PropertyId.Conversation_ApplicationId, value);
    }
    /**
     * Gets the corresponding backend application identifier.
     * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to get.
     */ get applicationId() {
        return this.getProperty($gttSn.PropertyId.Conversation_ApplicationId);
    }
}
module.exports.CustomCommandsConfig = $aad5fdeb3249605b$var$CustomCommandsConfig;

});

parcelRegister("6r8Ji", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceConnector = void 0;

var $jTjuw = parcelRequire("jTjuw");

var $hgjD5 = parcelRequire("hgjD5");

var $6rQ2O = parcelRequire("6rQ2O");

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");

var $fWPg2 = parcelRequire("fWPg2");
/**
 * Dialog Service Connector
 * @class DialogServiceConnector
 */ class $4afc093727dede1e$var$DialogServiceConnector extends $gttSn.Recognizer {
    /**
     * Initializes an instance of the DialogServiceConnector.
     * @constructor
     * @param {DialogServiceConfig} dialogConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     */ constructor(dialogConfig, audioConfig){
        const dialogServiceConfigImpl = dialogConfig;
        $3SMEZ.Contracts.throwIfNull(dialogConfig, "dialogConfig");
        super(audioConfig, dialogServiceConfigImpl.properties, new $jTjuw.DialogConnectionFactory());
        this.isTurnComplete = true;
        this.privIsDisposed = false;
        this.privProperties = dialogServiceConfigImpl.properties.clone();
        const agentConfig = this.buildAgentConfig();
        this.privReco.agentConfig.set(agentConfig);
    }
    /**
     * Starts a connection to the service.
     * Users can optionally call connect() to manually set up a connection in advance, before starting interactions.
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     * @member DialogServiceConnector.prototype.connect
     * @function
     * @public
     */ connect(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.privReco.connect(), cb, err);
    }
    /**
     * Closes the connection the service.
     * Users can optionally call disconnect() to manually shutdown the connection of the associated DialogServiceConnector.
     *
     * If disconnect() is called during a recognition, recognition will fail and cancel with an error.
     */ disconnect(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.privReco.disconnect(), cb, err);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member DialogServiceConnector.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($fWPg2.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Sets the authorization token used to communicate with the service.
     * @member DialogServiceConnector.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($fWPg2.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * The collection of properties and their values defined for this DialogServiceConnector.
     * @member DialogServiceConnector.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this DialogServiceConnector.
     */ get properties() {
        return this.privProperties;
    }
    /** Gets the template for the activity generated by service from speech.
     * Properties from the template will be stamped on the generated activity.
     * It can be empty
     */ get speechActivityTemplate() {
        return this.properties.getProperty($fWPg2.PropertyId.Conversation_Speech_Activity_Template);
    }
    /** Sets the template for the activity generated by service from speech.
     * Properties from the template will be stamped on the generated activity.
     * It can be null or empty.
     * Note: it has to be a valid Json object.
     */ set speechActivityTemplate(speechActivityTemplate) {
        this.properties.setProperty($fWPg2.PropertyId.Conversation_Speech_Activity_Template, speechActivityTemplate);
    }
    /**
     * Starts recognition and stops after the first utterance is recognized.
     * @member DialogServiceConnector.prototype.listenOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the reco has completed.
     * @param err - Callback invoked in case of an error.
     */ listenOnceAsync(cb, err) {
        if (this.isTurnComplete) {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            const callbackHolder = async ()=>{
                await this.privReco.connect();
                await this.implRecognizerStop();
                this.isTurnComplete = false;
                const ret = new $5OUhN.Deferred();
                await this.privReco.recognize($6rQ2O.RecognitionMode.Conversation, ret.resolve, ret.reject);
                const e = await ret.promise;
                await this.implRecognizerStop();
                return e;
            };
            const retPromise = callbackHolder();
            retPromise.catch(()=>{
                // Destroy the recognizer.
                // We've done all we can here.
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                this.dispose(true).catch(()=>{});
            });
            (0, $5OUhN.marshalPromiseToCallbacks)(retPromise.finally(()=>{
                this.isTurnComplete = true;
            }), cb, err);
        }
    }
    sendActivityAsync(activity, cb, errCb) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.privReco.sendMessage(activity), cb, errCb);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member DialogServiceConnector.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
        (0, $5OUhN.marshalPromiseToCallbacks)(this.dispose(true), cb, err);
    }
    async dispose(disposing) {
        if (this.privIsDisposed) return;
        if (disposing) {
            this.privIsDisposed = true;
            await this.implRecognizerStop();
            await super.dispose(disposing);
        }
    }
    createRecognizerConfig(speechConfig) {
        return new $hgjD5.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioSource = audioConfig;
        return new $hgjD5.DialogServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, this);
    }
    buildAgentConfig() {
        const communicationType = this.properties.getProperty("Conversation_Communication_Type", "Default");
        return {
            botInfo: {
                commType: communicationType,
                commandsCulture: undefined,
                connectionId: this.properties.getProperty($fWPg2.PropertyId.Conversation_Agent_Connection_Id),
                conversationId: this.properties.getProperty($fWPg2.PropertyId.Conversation_Conversation_Id, undefined),
                fromId: this.properties.getProperty($fWPg2.PropertyId.Conversation_From_Id, undefined),
                ttsAudioFormat: this.properties.getProperty($fWPg2.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)
            },
            version: 0.2
        };
    }
}
module.exports.DialogServiceConnector = $4afc093727dede1e$var$DialogServiceConnector;

});
parcelRegister("jTjuw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogConnectionFactory = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $hgjD5 = parcelRequire("hgjD5");

var $gttSn = parcelRequire("gttSn");

var $kBobk = parcelRequire("kBobk");

var $hgjD5 = parcelRequire("hgjD5");

var $40Pvg = parcelRequire("40Pvg");

var $jE6M6 = parcelRequire("jE6M6");
class $e7b245ee6ecd157b$var$DialogConnectionFactory extends $kBobk.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        const applicationId = config.parameters.getProperty($gttSn.PropertyId.Conversation_ApplicationId, "");
        const dialogType = config.parameters.getProperty($gttSn.PropertyId.Conversation_DialogType);
        const region = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Region);
        const language = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage, "en-US");
        const requestTurnStatus = config.parameters.getProperty($gttSn.PropertyId.Conversation_Request_Bot_Status_Messages, "true");
        const queryParams = {};
        queryParams[$40Pvg.HeaderNames.ConnectionId] = connectionId;
        queryParams[$jE6M6.QueryParameterNames.Format] = config.parameters.getProperty($hgjD5.OutputFormatPropertyName, $gttSn.OutputFormat[$gttSn.OutputFormat.Simple]).toLowerCase();
        queryParams[$jE6M6.QueryParameterNames.Language] = language;
        queryParams[$jE6M6.QueryParameterNames.RequestBotStatusMessages] = requestTurnStatus;
        if (applicationId) {
            queryParams[$jE6M6.QueryParameterNames.BotId] = applicationId;
            if (dialogType === $gttSn.DialogServiceConfig.DialogTypes.CustomCommands) queryParams[$40Pvg.HeaderNames.CustomCommandsAppId] = applicationId;
        }
        const resourceInfix = dialogType === $gttSn.DialogServiceConfig.DialogTypes.CustomCommands ? "commands/" : "";
        const version = dialogType === $gttSn.DialogServiceConfig.DialogTypes.CustomCommands ? "v1" : dialogType === $gttSn.DialogServiceConfig.DialogTypes.BotFramework ? "v3" : "v0";
        const headers = {};
        if (authInfo.token != null && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        // The URL used for connection is chosen in a priority order of specification:
        //  1. If a custom endpoint is provided, that URL is used verbatim.
        //  2. If a custom host is provided (e.g. "wss://my.custom.endpoint.com:1123"), a URL is constructed from it.
        //  3. If no custom connection details are provided, a URL is constructed from default values.
        let endpoint = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint, "");
        if (!endpoint) {
            const hostSuffix = $kBobk.ConnectionFactoryBase.getHostSuffix(region);
            const host = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Host, `wss://${region}.${$e7b245ee6ecd157b$var$DialogConnectionFactory.BaseUrl}${hostSuffix}`);
            const standardizedHost = host.endsWith("/") ? host : host + "/";
            endpoint = `${standardizedHost}${resourceInfix}${$e7b245ee6ecd157b$var$DialogConnectionFactory.ApiKey}/${version}`;
        }
        this.setCommonUrlParams(config, queryParams, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return Promise.resolve(new $s6RJO.WebsocketConnection(endpoint, queryParams, headers, new $hgjD5.WebsocketMessageFormatter(), $s6RJO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId));
    }
}
module.exports.DialogConnectionFactory = $e7b245ee6ecd157b$var$DialogConnectionFactory;
$e7b245ee6ecd157b$var$DialogConnectionFactory.ApiKey = "api";
$e7b245ee6ecd157b$var$DialogConnectionFactory.BaseUrl = "convai.speech";

});
parcelRegister("kBobk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionFactoryBase = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $gttSn = parcelRequire("gttSn");

var $jE6M6 = parcelRequire("jE6M6");
class $effa05594b805a41$var$ConnectionFactoryBase {
    static getHostSuffix(region) {
        if (!!region) {
            if (region.toLowerCase().startsWith("china")) return ".azure.cn";
            if (region.toLowerCase().startsWith("usgov")) return ".azure.us";
        }
        return ".microsoft.com";
    }
    setCommonUrlParams(config, queryParams, endpoint) {
        const propertyIdToParameterMap = new Map([
            [
                $gttSn.PropertyId.Speech_SegmentationSilenceTimeoutMs,
                $jE6M6.QueryParameterNames.SegmentationSilenceTimeoutMs
            ],
            [
                $gttSn.PropertyId.SpeechServiceConnection_EnableAudioLogging,
                $jE6M6.QueryParameterNames.EnableAudioLogging
            ],
            [
                $gttSn.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs,
                $jE6M6.QueryParameterNames.EndSilenceTimeoutMs
            ],
            [
                $gttSn.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs,
                $jE6M6.QueryParameterNames.InitialSilenceTimeoutMs
            ],
            [
                $gttSn.PropertyId.SpeechServiceResponse_PostProcessingOption,
                $jE6M6.QueryParameterNames.Postprocessing
            ],
            [
                $gttSn.PropertyId.SpeechServiceResponse_ProfanityOption,
                $jE6M6.QueryParameterNames.Profanity
            ],
            [
                $gttSn.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps,
                $jE6M6.QueryParameterNames.EnableWordLevelTimestamps
            ],
            [
                $gttSn.PropertyId.SpeechServiceResponse_StablePartialResultThreshold,
                $jE6M6.QueryParameterNames.StableIntermediateThreshold
            ]
        ]);
        propertyIdToParameterMap.forEach((parameterName, propertyId)=>{
            this.setUrlParameter(propertyId, parameterName, config, queryParams, endpoint);
        });
        const serviceProperties = JSON.parse(config.parameters.getProperty($hgjD5.ServicePropertiesPropertyName, "{}"));
        Object.keys(serviceProperties).forEach((value)=>{
            queryParams[value] = serviceProperties[value];
        });
    }
    setUrlParameter(propId, parameterName, config, queryParams, endpoint) {
        const value = config.parameters.getProperty(propId, undefined);
        // FIXME: The .search() check will incorrectly match parameter name anywhere in the string
        //        including e.g. the path portion, or even as a substring of other query parameters
        if (value && (!endpoint || endpoint.search(parameterName) === -1)) queryParams[parameterName] = value.toLocaleLowerCase();
    }
    static async getRedirectUrlFromEndpoint(endpoint) {
        // make a rest call to the endpoint to get the redirect url
        const redirectUrl = new URL(endpoint);
        redirectUrl.protocol = "https:";
        redirectUrl.port = "443";
        const params = redirectUrl.searchParams;
        params.append("GenerateRedirectResponse", "true");
        const redirectedUrlString = redirectUrl.toString();
        $5OUhN.Events.instance.onEvent(new $5OUhN.ConnectionRedirectEvent("", redirectedUrlString, undefined, "ConnectionFactoryBase: redirectUrl request"));
        const redirectResponse = await fetch(redirectedUrlString);
        if (redirectResponse.status !== 200) return endpoint;
        // Fix: properly read the response text
        const redirectUrlString = await redirectResponse.text();
        $5OUhN.Events.instance.onEvent(new $5OUhN.ConnectionRedirectEvent("", redirectUrlString, endpoint, "ConnectionFactoryBase: redirectUrlString"));
        try {
            // Validate the URL before returning
            return new URL(redirectUrlString.trim()).toString();
        } catch (error) {
            return endpoint; // Return original endpoint if the redirect URL is invalid
        }
    }
}
module.exports.ConnectionFactoryBase = $effa05594b805a41$var$ConnectionFactoryBase;

});
parcelRegister("jE6M6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryParameterNames = void 0;
class $e4d702137d0d199c$var$QueryParameterNames {
}
module.exports.QueryParameterNames = $e4d702137d0d199c$var$QueryParameterNames;
$e4d702137d0d199c$var$QueryParameterNames.BotId = "botid";
$e4d702137d0d199c$var$QueryParameterNames.CustomSpeechDeploymentId = "cid";
$e4d702137d0d199c$var$QueryParameterNames.CustomVoiceDeploymentId = "deploymentId";
$e4d702137d0d199c$var$QueryParameterNames.EnableAudioLogging = "storeAudio";
$e4d702137d0d199c$var$QueryParameterNames.EnableLanguageId = "lidEnabled";
$e4d702137d0d199c$var$QueryParameterNames.EnableWordLevelTimestamps = "wordLevelTimestamps";
$e4d702137d0d199c$var$QueryParameterNames.EndSilenceTimeoutMs = "endSilenceTimeoutMs";
$e4d702137d0d199c$var$QueryParameterNames.SegmentationSilenceTimeoutMs = "segmentationSilenceTimeoutMs";
$e4d702137d0d199c$var$QueryParameterNames.SegmentationMaximumTimeMs = "segmentationMaximumTimeMs";
$e4d702137d0d199c$var$QueryParameterNames.SegmentationStrategy = "segmentationStrategy";
$e4d702137d0d199c$var$QueryParameterNames.Format = "format";
$e4d702137d0d199c$var$QueryParameterNames.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs";
$e4d702137d0d199c$var$QueryParameterNames.Language = "language";
$e4d702137d0d199c$var$QueryParameterNames.Profanity = "profanity";
$e4d702137d0d199c$var$QueryParameterNames.RequestBotStatusMessages = "enableBotMessageStatus";
$e4d702137d0d199c$var$QueryParameterNames.StableIntermediateThreshold = "stableIntermediateThreshold";
$e4d702137d0d199c$var$QueryParameterNames.StableTranslation = "stableTranslation";
$e4d702137d0d199c$var$QueryParameterNames.TestHooks = "testhooks";
$e4d702137d0d199c$var$QueryParameterNames.Postprocessing = "postprocessing";
$e4d702137d0d199c$var$QueryParameterNames.CtsMeetingId = "meetingId";
$e4d702137d0d199c$var$QueryParameterNames.CtsDeviceId = "deviceId";
$e4d702137d0d199c$var$QueryParameterNames.CtsIsParticipant = "isParticipant";
$e4d702137d0d199c$var$QueryParameterNames.EnableAvatar = "enableTalkingAvatar";

});




parcelRegister("2zgjg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActivityReceivedEventArgs = void 0;
/**
 * Defines contents of received message/events.
 * @class ActivityReceivedEventArgs
 */ class $1deb807186336591$var$ActivityReceivedEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {any} activity - The activity..
     */ constructor(activity, audioStream){
        this.privActivity = activity;
        this.privAudioStream = audioStream;
    }
    /**
     * Gets the received activity
     * @member ActivityReceivedEventArgs.prototype.activity
     * @function
     * @public
     * @returns {any} the received activity.
     */ get activity() {
        return this.privActivity;
    }
    get audioStream() {
        return this.privAudioStream;
    }
}
module.exports.ActivityReceivedEventArgs = $1deb807186336591$var$ActivityReceivedEventArgs;

});

parcelRegister("23BEu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TurnStatusReceivedEventArgs = void 0;

var $iKSg1 = parcelRequire("iKSg1");
/**
 * Defines contents of received message/events.
 * @class TurnStatusReceivedEventArgs
 */ class $17f9118403f7cfe1$var$TurnStatusReceivedEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} turnStatus - The JSON-encoded turn status message.
     */ constructor(turnStatus){
        this.privTurnStatus = $iKSg1.TurnStatusResponsePayload.fromJSON(turnStatus);
    }
    /**
     * Gets the interaction identifier associated with this turn status event.
     * @member TurnStatusReceivedEventArgs.prototype.interactionId
     * @function
     * @public
     * @returns {any} the received interaction id.
     */ get interactionId() {
        return this.privTurnStatus.interactionId;
    }
    /**
     * Gets the conversation identifier associated with this turn status event.
     * @member TurnStatusReceivedEventArgs.prototype.conversationId
     * @function
     * @public
     * @returns {any} the received conversation id.
     */ get conversationId() {
        return this.privTurnStatus.conversationId;
    }
    /**
     * Gets the received turn status code.
     * @member TurnStatusReceivedEventArgs.prototype.statusCode
     * @function
     * @public
     * @returns {number} the received turn status.
     */ get statusCode() {
        return this.privTurnStatus.statusCode; // eslint-disable-line @typescript-eslint/no-unsafe-return
    }
}
module.exports.TurnStatusReceivedEventArgs = $17f9118403f7cfe1$var$TurnStatusReceivedEventArgs;

});
parcelRegister("iKSg1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TurnStatusResponsePayload = void 0;
class $da769c3f1e96c13e$var$TurnStatusResponsePayload {
    constructor(json){
        this.privMessageStatusResponse = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $da769c3f1e96c13e$var$TurnStatusResponsePayload(json);
    }
    get interactionId() {
        return this.privMessageStatusResponse.interactionId;
    }
    get conversationId() {
        return this.privMessageStatusResponse.conversationId;
    }
    get statusCode() {
        // Payloads may contain a limited set of textual representations or a numeric status
        // code. The textual values are here converted into numeric ones.
        switch(this.privMessageStatusResponse.statusCode){
            case "Success":
                return 200;
            case "Failed":
                return 400;
            case "TimedOut":
                return 429;
            default:
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return this.privMessageStatusResponse.statusCode;
        }
    }
}
module.exports.TurnStatusResponsePayload = $da769c3f1e96c13e$var$TurnStatusResponsePayload;

});


parcelRegister("2PlNu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServicePropertyChannel = void 0;
/**
 * Defines channels used to pass property settings to service.
 * Added in version 1.7.0.
 */ var $20f140b0a95f1c51$var$ServicePropertyChannel;
(function(ServicePropertyChannel) {
    /**
     * Uses URI query parameter to pass property settings to service.
     */ ServicePropertyChannel[ServicePropertyChannel["UriQueryParameter"] = 0] = "UriQueryParameter";
})($20f140b0a95f1c51$var$ServicePropertyChannel = module.exports.ServicePropertyChannel || (module.exports.ServicePropertyChannel = {}));

});

parcelRegister("biETf", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProfanityOption = void 0;
/**
 * Profanity option.
 * Added in version 1.7.0.
 */ var $83a11814171cbe8e$var$ProfanityOption;
(function(ProfanityOption) {
    ProfanityOption[ProfanityOption["Masked"] = 0] = "Masked";
    ProfanityOption[ProfanityOption["Removed"] = 1] = "Removed";
    ProfanityOption[ProfanityOption["Raw"] = 2] = "Raw";
})($83a11814171cbe8e$var$ProfanityOption = module.exports.ProfanityOption || (module.exports.ProfanityOption = {}));

});

parcelRegister("9GDKk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAudioPlayer = void 0;

var $3NF6I = parcelRequire("3NF6I");

var $gttSn = parcelRequire("gttSn");

var $hzVTX = parcelRequire("hzVTX");
/**
 * Base audio player class
 * TODO: Plays only PCM for now.
 * @class
 */ class $70d6de0d4f3a6a20$var$BaseAudioPlayer {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {AudioStreamFormat} audioFormat audio stream format recognized by the player.
     */ constructor(audioFormat){
        this.audioContext = null;
        this.gainNode = null;
        this.autoUpdateBufferTimer = 0;
        if (audioFormat === undefined) audioFormat = $gttSn.AudioStreamFormat.getDefaultInputFormat();
        this.init(audioFormat);
    }
    /**
     * play Audio sample
     * @param newAudioData audio data to be played.
     */ playAudioSample(newAudioData, cb, err) {
        try {
            this.ensureInitializedContext();
            const audioData = this.formatAudioData(newAudioData);
            const newSamplesData = new Float32Array(this.samples.length + audioData.length);
            newSamplesData.set(this.samples, 0);
            newSamplesData.set(audioData, this.samples.length);
            this.samples = newSamplesData;
            if (!!cb) cb();
        } catch (e) {
            if (!!err) err(e);
        }
    }
    /**
     * stops audio and clears the buffers
     */ stopAudio(cb, err) {
        if (this.audioContext !== null) {
            this.samples = new Float32Array();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            clearInterval(this.autoUpdateBufferTimer);
            this.audioContext.close().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
            this.audioContext = null;
        }
    }
    init(audioFormat) {
        this.audioFormat = audioFormat;
        this.samples = new Float32Array();
    }
    ensureInitializedContext() {
        if (this.audioContext === null) {
            this.createAudioContext();
            const timerPeriod = 200;
            this.autoUpdateBufferTimer = setInterval(()=>{
                this.updateAudioBuffer();
            }, timerPeriod);
        }
    }
    createAudioContext() {
        // new ((window as any).AudioContext || (window as any).webkitAudioContext)();
        this.audioContext = $hzVTX.AudioStreamFormatImpl.getAudioContext();
        // TODO: Various examples shows this gain node, it does not seem to be needed unless we plan
        // to control the volume, not likely
        this.gainNode = this.audioContext.createGain();
        this.gainNode.gain.value = 1;
        this.gainNode.connect(this.audioContext.destination);
        this.startTime = this.audioContext.currentTime;
    }
    formatAudioData(audioData) {
        switch(this.audioFormat.bitsPerSample){
            case 8:
                return this.formatArrayBuffer(new Int8Array(audioData), 128);
            case 16:
                return this.formatArrayBuffer(new Int16Array(audioData), 32768);
            case 32:
                return this.formatArrayBuffer(new Int32Array(audioData), 2147483648);
            default:
                throw new $3NF6I.InvalidOperationError("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
        }
    }
    formatArrayBuffer(audioData, maxValue) {
        const float32Data = new Float32Array(audioData.length);
        for(let i = 0; i < audioData.length; i++)float32Data[i] = audioData[i] / maxValue;
        return float32Data;
    }
    updateAudioBuffer() {
        if (this.samples.length === 0) return;
        const channelCount = this.audioFormat.channels;
        const bufferSource = this.audioContext.createBufferSource();
        const frameCount = this.samples.length / channelCount;
        const audioBuffer = this.audioContext.createBuffer(channelCount, frameCount, this.audioFormat.samplesPerSec);
        // TODO: Should we do the conversion in the pushAudioSample instead?
        for(let channel = 0; channel < channelCount; channel++){
            // Fill in individual channel data
            let channelOffset = channel;
            const audioData = audioBuffer.getChannelData(channel);
            for(let i = 0; i < this.samples.length; i++, channelOffset += channelCount)audioData[i] = this.samples[channelOffset];
        }
        if (this.startTime < this.audioContext.currentTime) this.startTime = this.audioContext.currentTime;
        bufferSource.buffer = audioBuffer;
        bufferSource.connect(this.gainNode);
        bufferSource.start(this.startTime);
        // Make sure we play the next sample after the current one.
        this.startTime += audioBuffer.duration;
        // Clear the samples for the next pushed data.
        this.samples = new Float32Array();
    }
    async playAudio(audioData) {
        if (this.audioContext === null) this.createAudioContext();
        const source = this.audioContext.createBufferSource();
        const destination = this.audioContext.destination;
        await this.audioContext.decodeAudioData(audioData, (newBuffer)=>{
            source.buffer = newBuffer;
            source.connect(destination);
            source.start(0);
        });
    }
}
module.exports.BaseAudioPlayer = $70d6de0d4f3a6a20$var$BaseAudioPlayer;

});

parcelRegister("8E9OG", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageEventArgs = void 0;
class $64b9ac7b3f38ab91$var$ConnectionMessageEventArgs {
    constructor(message){
        this.privConnectionMessage = message;
    }
    /**
     * Gets the <see cref="ConnectionMessage"/> associated with this <see cref="ConnectionMessageEventArgs"/>.
     */ get message() {
        return this.privConnectionMessage;
    }
    /**
     * Returns a string that represents the connection message event.
     */ toString() {
        return "Message: " + this.privConnectionMessage.toString();
    }
}
module.exports.ConnectionMessageEventArgs = $64b9ac7b3f38ab91$var$ConnectionMessageEventArgs;

});

parcelRegister("dbzYj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguageConfig = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");

var $7Xt19 = parcelRequire("7Xt19");
/**
 * Language auto detect configuration.
 * @class AutoDetectSourceLanguageConfig
 * Added in version 1.13.0.
 */ class $999834b2c0858261$var$AutoDetectSourceLanguageConfig {
    constructor(){
        this.privProperties = new $gttSn.PropertyCollection();
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_LanguageIdMode, "AtStart");
        this.privLanguageIdMode = $7Xt19.LanguageIdMode.AtStart;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromOpenRange
     * @function
     * @public
     * Only [[SpeechSynthesizer]] supports source language auto detection from open range,
     * for [[Recognizer]], please use AutoDetectSourceLanguageConfig with specific source languages.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with open range.
     */ static fromOpenRange() {
        const config = new $999834b2c0858261$var$AutoDetectSourceLanguageConfig();
        config.properties.setProperty($gttSn.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, $hgjD5.AutoDetectSourceLanguagesOpenRangeOptionName);
        config.properties.setProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage, "en-US");
        return config;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromLanguages
     * @function
     * @public
     * @param {string[]} languages Comma-separated string of languages (eg. "en-US,fr-FR") to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given languages.
     */ static fromLanguages(languages) {
        $3SMEZ.Contracts.throwIfArrayEmptyOrWhitespace(languages, "languages");
        const config = new $999834b2c0858261$var$AutoDetectSourceLanguageConfig();
        config.properties.setProperty($gttSn.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, languages.join());
        return config;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromSourceLanguageConfigs
     * @function
     * @public
     * @param {SourceLanguageConfig[]} configs SourceLanguageConfigs to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given SourceLanguageConfigs.
     */ static fromSourceLanguageConfigs(configs) {
        if (configs.length < 1) throw new Error("Expected non-empty SourceLanguageConfig array.");
        const autoConfig = new $999834b2c0858261$var$AutoDetectSourceLanguageConfig();
        const langs = [];
        configs.forEach((config)=>{
            langs.push(config.language);
            if (config.endpointId !== undefined && config.endpointId !== "") {
                const customProperty = config.language + $gttSn.PropertyId.SpeechServiceConnection_EndpointId.toString();
                autoConfig.properties.setProperty(customProperty, config.endpointId);
            }
        });
        autoConfig.properties.setProperty($gttSn.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, langs.join());
        return autoConfig;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.prototype.properties
     * @function
     * @public
     * @return {PropertyCollection} Properties of the config.
     * @summary Gets an auto detected language config properties
     */ get properties() {
        return this.privProperties;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.prototype.mode
     * @function
     * @public
     * @param {LanguageIdMode} mode LID mode desired.
     * @summary Sets LID operation to desired mode
     */ set mode(mode) {
        if (mode === $7Xt19.LanguageIdMode.Continuous) {
            this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "2");
            this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_LanguageIdMode, "Continuous");
        } else {
            this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "1");
            this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_LanguageIdMode, "AtStart");
        }
        this.privLanguageIdMode = mode;
    }
}
module.exports.AutoDetectSourceLanguageConfig = $999834b2c0858261$var$AutoDetectSourceLanguageConfig;

});
parcelRegister("7Xt19", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LanguageIdMode = void 0;
/**
 * Language Identification mode
 * @class LanguageIdMode
 */ var $5cb48d5c4aedac6d$var$LanguageIdMode;
(function(LanguageIdMode) {
    /**
     * Detect language at audio start
     * @member LanguageIdMode.AtStart
     */ LanguageIdMode[LanguageIdMode["AtStart"] = 0] = "AtStart";
    /**
     * Continuously detect language
     * @member LanguageIdMode.Continuous
     */ LanguageIdMode[LanguageIdMode["Continuous"] = 1] = "Continuous";
})($5cb48d5c4aedac6d$var$LanguageIdMode = module.exports.LanguageIdMode || (module.exports.LanguageIdMode = {}));

});


parcelRegister("5jtSb", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguageResult = void 0;

var $3SMEZ = parcelRequire("3SMEZ");
/**
 * Output format
 * @class AutoDetectSourceLanguageResult
 */ class $3de5e6419a6e997e$var$AutoDetectSourceLanguageResult {
    constructor(language, languageDetectionConfidence){
        $3SMEZ.Contracts.throwIfNullOrUndefined(language, "language");
        $3SMEZ.Contracts.throwIfNullOrUndefined(languageDetectionConfidence, "languageDetectionConfidence");
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
    }
    /**
     * Creates an instance of AutoDetectSourceLanguageResult object from a SpeechRecognitionResult instance.
     * @member AutoDetectSourceLanguageResult.fromResult
     * @function
     * @public
     * @param {SpeechRecognitionResult} result - The recognition result.
     * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
     */ static fromResult(result) {
        return new $3de5e6419a6e997e$var$AutoDetectSourceLanguageResult(result.language, result.languageDetectionConfidence);
    }
    /**
     * Creates an instance of AutoDetectSourceLanguageResult object from a ConversationTranscriptionResult instance.
     * @member AutoDetectSourceLanguageResult.fromConversationTranscriptionResult
     * @function
     * @public
     * @param {ConversationTranscriptionResult} result - The transcription result.
     * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
     */ static fromConversationTranscriptionResult(result) {
        return new $3de5e6419a6e997e$var$AutoDetectSourceLanguageResult(result.language, result.languageDetectionConfidence);
    }
    get language() {
        return this.privLanguage;
    }
    get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
}
module.exports.AutoDetectSourceLanguageResult = $3de5e6419a6e997e$var$AutoDetectSourceLanguageResult;

});

parcelRegister("9fvCG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SourceLanguageConfig = void 0;

var $3SMEZ = parcelRequire("3SMEZ");
/**
 * Source Language configuration.
 * @class SourceLanguageConfig
 */ class $6bbe0b66c49ca4ab$var$SourceLanguageConfig {
    constructor(language, endpointId){
        $3SMEZ.Contracts.throwIfNullOrUndefined(language, "language");
        this.privLanguage = language;
        this.privEndpointId = endpointId;
    }
    /**
     * @member SourceLanguageConfig.fromLanguage
     * @function
     * @public
     * @param {string} language language (eg. "en-US") value of config.
     * @param {string?} endpointId endpointId of model bound to given language of config.
     * @return {SourceLanguageConfig} Instance of SourceLanguageConfig
     * @summary Creates an instance of the SourceLanguageConfig with the given language and optional endpointId.
     * Added in version 1.13.0.
     */ static fromLanguage(language, endpointId) {
        return new $6bbe0b66c49ca4ab$var$SourceLanguageConfig(language, endpointId);
    }
    get language() {
        return this.privLanguage;
    }
    get endpointId() {
        return this.privEndpointId;
    }
}
module.exports.SourceLanguageConfig = $6bbe0b66c49ca4ab$var$SourceLanguageConfig;

});

parcelRegister("ejSiE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionResult = module.exports.MeetingTranscriber = module.exports.MeetingTranscriptionCanceledEventArgs = module.exports.MeetingImpl = module.exports.Meeting = module.exports.ParticipantChangedReason = module.exports.User = module.exports.Participant = module.exports.ConversationTranscriber = module.exports.ConversationTranslator = module.exports.ConversationTranslationResult = module.exports.ConversationTranslationEventArgs = module.exports.ConversationTranslationCanceledEventArgs = module.exports.ConversationParticipantsChangedEventArgs = module.exports.ConversationExpirationEventArgs = module.exports.ConversationCommon = module.exports.ConversationImpl = module.exports.Conversation = void 0;

var $icOZl = parcelRequire("icOZl");
Object.defineProperty(module.exports, "Conversation", {
    enumerable: true,
    get: function() {
        return $icOZl.Conversation;
    }
});
Object.defineProperty(module.exports, "ConversationImpl", {
    enumerable: true,
    get: function() {
        return $icOZl.ConversationImpl;
    }
});

var $g3541 = parcelRequire("g3541");
Object.defineProperty(module.exports, "ConversationCommon", {
    enumerable: true,
    get: function() {
        return $g3541.ConversationCommon;
    }
});

var $8D5nK = parcelRequire("8D5nK");
Object.defineProperty(module.exports, "ConversationExpirationEventArgs", {
    enumerable: true,
    get: function() {
        return $8D5nK.ConversationExpirationEventArgs;
    }
});

var $kLPW7 = parcelRequire("kLPW7");
Object.defineProperty(module.exports, "ConversationParticipantsChangedEventArgs", {
    enumerable: true,
    get: function() {
        return $kLPW7.ConversationParticipantsChangedEventArgs;
    }
});

var $iZ4Ku = parcelRequire("iZ4Ku");
Object.defineProperty(module.exports, "ConversationTranslationCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $iZ4Ku.ConversationTranslationCanceledEventArgs;
    }
});

var $hqfR4 = parcelRequire("hqfR4");
Object.defineProperty(module.exports, "ConversationTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $hqfR4.ConversationTranslationEventArgs;
    }
});

var $c8RCw = parcelRequire("c8RCw");
Object.defineProperty(module.exports, "ConversationTranslationResult", {
    enumerable: true,
    get: function() {
        return $c8RCw.ConversationTranslationResult;
    }
});

var $8z9RT = parcelRequire("8z9RT");
Object.defineProperty(module.exports, "ConversationTranslator", {
    enumerable: true,
    get: function() {
        return $8z9RT.ConversationTranslator;
    }
});

var $603mk = parcelRequire("603mk");
Object.defineProperty(module.exports, "ConversationTranscriber", {
    enumerable: true,
    get: function() {
        return $603mk.ConversationTranscriber;
    }
});

var $jzyuG = parcelRequire("jzyuG");
Object.defineProperty(module.exports, "Participant", {
    enumerable: true,
    get: function() {
        return $jzyuG.Participant;
    }
});
Object.defineProperty(module.exports, "User", {
    enumerable: true,
    get: function() {
        return $jzyuG.User;
    }
});

var $kHyWL = parcelRequire("kHyWL");
Object.defineProperty(module.exports, "ParticipantChangedReason", {
    enumerable: true,
    get: function() {
        return $kHyWL.ParticipantChangedReason;
    }
});

var $9qyr0 = parcelRequire("9qyr0");
Object.defineProperty(module.exports, "Meeting", {
    enumerable: true,
    get: function() {
        return $9qyr0.Meeting;
    }
});
Object.defineProperty(module.exports, "MeetingImpl", {
    enumerable: true,
    get: function() {
        return $9qyr0.MeetingImpl;
    }
});

var $4pAPh = parcelRequire("4pAPh");
Object.defineProperty(module.exports, "MeetingTranscriptionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $4pAPh.MeetingTranscriptionCanceledEventArgs;
    }
});

var $jx8tw = parcelRequire("jx8tw");
Object.defineProperty(module.exports, "MeetingTranscriber", {
    enumerable: true,
    get: function() {
        return $jx8tw.MeetingTranscriber;
    }
});

var $eYrkS = parcelRequire("eYrkS");
Object.defineProperty(module.exports, "ConversationTranscriptionResult", {
    enumerable: true,
    get: function() {
        return $eYrkS.ConversationTranscriptionResult;
    }
});

});
parcelRegister("icOZl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationImpl = module.exports.Conversation = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
class $d410e63c93bc3788$var$Conversation {
    constructor(){
        return;
    }
    /**
     * Create a conversation
     * @param speechConfig
     * @param cb
     * @param err
     */ static createConversationAsync(speechConfig, arg2, arg3, arg4) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(speechConfig, $hgjD5.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "config"));
        $3SMEZ.Contracts.throwIfNullOrUndefined(speechConfig.region, $hgjD5.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region"));
        if (!speechConfig.subscriptionKey && !speechConfig.getProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceAuthorization_Token])) $3SMEZ.Contracts.throwIfNullOrUndefined(speechConfig.subscriptionKey, $hgjD5.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        let conversationImpl;
        let cb;
        let err;
        if (typeof arg2 === "string") {
            conversationImpl = new $d410e63c93bc3788$var$ConversationImpl(speechConfig, arg2);
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            (0, $5OUhN.marshalPromiseToCallbacks)((async ()=>{})(), arg3, arg4);
        } else {
            conversationImpl = new $d410e63c93bc3788$var$ConversationImpl(speechConfig);
            cb = arg2;
            err = arg3;
            conversationImpl.createConversationAsync(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        }
        return conversationImpl;
    }
}
module.exports.Conversation = $d410e63c93bc3788$var$Conversation;
class $d410e63c93bc3788$var$ConversationImpl extends $d410e63c93bc3788$var$Conversation {
    /**
     * Create a conversation impl
     * @param speechConfig
     * @param {string} id - optional conversationId
     */ constructor(speechConfig, id){
        super();
        this.privErrors = $hgjD5.ConversationConnectionConfig.restErrors;
        /** websocket callbacks */ /* eslint-disable @typescript-eslint/typedef */ this.onConnected = (e)=>{
            this.privIsConnected = true;
            try {
                if (!!this.privConversationTranslator?.sessionStarted) this.privConversationTranslator.sessionStarted(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onDisconnected = (e)=>{
            try {
                if (!!this.privConversationTranslator?.sessionStopped) this.privConversationTranslator.sessionStopped(this.privConversationTranslator, e);
            } catch (e) {
            //
            } finally{
                this.close(false);
            }
        };
        this.onCanceled = (r, e)=>{
            try {
                if (!!this.privConversationTranslator?.canceled) this.privConversationTranslator.canceled(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onParticipantUpdateCommandReceived = (r, e)=>{
            try {
                const updatedParticipant = this.privParticipants.getParticipant(e.id);
                if (updatedParticipant !== undefined) {
                    switch(e.key){
                        case $hgjD5.ConversationTranslatorCommandTypes.changeNickname:
                            updatedParticipant.displayName = e.value;
                            break;
                        case $hgjD5.ConversationTranslatorCommandTypes.setUseTTS:
                            updatedParticipant.isUsingTts = e.value;
                            break;
                        case $hgjD5.ConversationTranslatorCommandTypes.setProfanityFiltering:
                            updatedParticipant.profanity = e.value;
                            break;
                        case $hgjD5.ConversationTranslatorCommandTypes.setMute:
                            updatedParticipant.isMuted = e.value;
                            break;
                        case $hgjD5.ConversationTranslatorCommandTypes.setTranslateToLanguages:
                            updatedParticipant.translateToLanguages = e.value;
                            break;
                    }
                    this.privParticipants.addOrUpdateParticipant(updatedParticipant);
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $gttSn.ConversationParticipantsChangedEventArgs($gttSn.ParticipantChangedReason.Updated, [
                        this.toParticipant(updatedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onLockRoomCommandReceived = ()=>{
        // TODO
        };
        this.onMuteAllCommandReceived = (r, e)=>{
            try {
                this.privParticipants.participants.forEach((p)=>p.isMuted = p.isHost ? false : e.isMuted);
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $gttSn.ConversationParticipantsChangedEventArgs($gttSn.ParticipantChangedReason.Updated, this.toParticipants(false), e.sessionId));
            } catch (e) {
            //
            }
        };
        this.onParticipantJoinCommandReceived = (r, e)=>{
            try {
                const newParticipant = this.privParticipants.addOrUpdateParticipant(e.participant);
                if (newParticipant !== undefined) {
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $gttSn.ConversationParticipantsChangedEventArgs($gttSn.ParticipantChangedReason.JoinedConversation, [
                        this.toParticipant(newParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantLeaveCommandReceived = (r, e)=>{
            try {
                const ejectedParticipant = this.privParticipants.getParticipant(e.participant.id);
                if (ejectedParticipant !== undefined) {
                    // remove the participant from the internal participants list
                    this.privParticipants.deleteParticipant(e.participant.id);
                    if (!!this.privConversationTranslator) // notify subscribers that the participant has left the conversation
                    this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $gttSn.ConversationParticipantsChangedEventArgs($gttSn.ParticipantChangedReason.LeftConversation, [
                        this.toParticipant(ejectedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onTranslationReceived = (r, e)=>{
            try {
                switch(e.command){
                    case $hgjD5.ConversationTranslatorMessageTypes.final:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribed(this.privConversationTranslator, new $gttSn.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $hgjD5.ConversationTranslatorMessageTypes.partial:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribing(this.privConversationTranslator, new $gttSn.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $hgjD5.ConversationTranslatorMessageTypes.instantMessage:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new $gttSn.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantsListReceived = (r, e)=>{
            try {
                // check if the session token needs to be updated
                if (e.sessionToken !== undefined && e.sessionToken !== null) this.privRoom.token = e.sessionToken;
                // save the participants
                this.privParticipants.participants = [
                    ...e.participants
                ];
                // enable the conversation
                if (this.privParticipants.me !== undefined) this.privIsReady = true;
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $gttSn.ConversationParticipantsChangedEventArgs($gttSn.ParticipantChangedReason.JoinedConversation, this.toParticipants(true), e.sessionId));
                // if this is the host, update the nickname if needed
                if (this.me.isHost) {
                    const nickname = this.privConversationTranslator?.properties.getProperty($gttSn.PropertyId.ConversationTranslator_Name);
                    if (nickname !== undefined && nickname.length > 0 && nickname !== this.me.displayName) // issue a change nickname request
                    this.changeNicknameAsync(nickname);
                }
            } catch (e) {
            //
            }
        };
        this.onConversationExpiration = (r, e)=>{
            try {
                if (!!this.privConversationTranslator) this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.privIsConnected = false;
        this.privIsDisposed = false;
        this.privConversationId = "";
        this.privProperties = new $gttSn.PropertyCollection();
        this.privManager = new $hgjD5.ConversationManager();
        // check the speech language
        const language = speechConfig.getProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!language) speechConfig.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage], $hgjD5.ConversationConnectionConfig.defaultLanguageCode);
        this.privLanguage = speechConfig.getProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!id) {
            // check the target language(s)
            if (speechConfig.targetLanguages.length === 0) speechConfig.addTargetLanguage(this.privLanguage);
            // check the profanity setting: speech and conversationTranslator should be in sync
            const profanity = speechConfig.getProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceResponse_ProfanityOption]);
            if (!profanity) speechConfig.setProfanity($gttSn.ProfanityOption.Masked);
            // check the nickname: it should pass this regex: ^\w+([\s-][\w\(\)]+)*$"
            // TODO: specify the regex required. Nicknames must be unique or get the duplicate nickname error
            // TODO: check what the max length is and if a truncation is required or if the service handles it without an error
            let hostNickname = speechConfig.getProperty($gttSn.PropertyId[$gttSn.PropertyId.ConversationTranslator_Name]);
            if (hostNickname === undefined || hostNickname === null) hostNickname = "Host";
            $3SMEZ.Contracts.throwIfNullOrTooLong(hostNickname, "nickname", 50);
            $3SMEZ.Contracts.throwIfNullOrTooShort(hostNickname, "nickname", 2);
            speechConfig.setProperty($gttSn.PropertyId[$gttSn.PropertyId.ConversationTranslator_Name], hostNickname);
        } else this.privConversationId = id;
        // save the speech config for future usage
        this.privConfig = speechConfig;
        // save the config properties
        const configImpl = speechConfig;
        $3SMEZ.Contracts.throwIfNull(configImpl, "speechConfig");
        this.privProperties = configImpl.properties.clone();
        this.privIsConnected = false;
        this.privParticipants = new $hgjD5.InternalParticipants();
        this.privIsReady = false;
        this.privTextMessageMaxLength = 1000;
    }
    // get the internal data about a conversation
    get room() {
        return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
        return this.privConversationRecognizer; // this.privConnection;
    }
    // get the config
    get config() {
        return this.privConfig;
    }
    // get the conversation Id
    get conversationId() {
        return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
        return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
        return this.privLanguage;
    }
    get isMutedByHost() {
        return this.privParticipants.me?.isHost ? false : this.privParticipants.me?.isMuted;
    }
    get isConnected() {
        return this.privIsConnected && this.privIsReady;
    }
    get participants() {
        return this.toParticipants(true);
    }
    get me() {
        return this.toParticipant(this.privParticipants.me);
    }
    get host() {
        return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
        return this.privTranscriberRecognizer;
    }
    get conversationInfo() {
        const convId = this.conversationId;
        const p = this.participants.map((part)=>({
                id: part.id,
                preferredLanguage: part.preferredLanguage,
                voice: part.voice
            }));
        const props = {};
        for (const key of $hgjD5.ConversationConnectionConfig.transcriptionEventKeys){
            const val = this.properties.getProperty(key, "");
            if (val !== "") props[key] = val;
        }
        const info = {
            id: convId,
            participants: p,
            conversationProperties: props
        };
        return info;
    }
    get canSend() {
        return this.privIsConnected && !this.privParticipants.me?.isMuted;
    }
    get canSendAsHost() {
        return this.privIsConnected && this.privParticipants.me?.isHost;
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
        return this.privToken;
    }
    set authorizationToken(value) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(value, "authorizationToken");
        this.privToken = value;
    }
    set conversationTranslator(conversationTranslator) {
        this.privConversationTranslator = conversationTranslator;
    }
    onToken(token) {
        this.privConversationTranslator.onToken(token);
    }
    /**
     * Create a new conversation as Host
     * @param cb
     * @param err
     */ createConversationAsync(cb, err) {
        try {
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            this.privManager.createOrJoin(this.privProperties, undefined, (room)=>{
                if (!room) this.handleError(new Error(this.privErrors.permissionDeniedConnect), err);
                this.privRoom = room;
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Starts a new conversation as host.
     * @param cb
     * @param err
     */ startConversationAsync(cb, err) {
        try {
            // check if there is already a recognizer
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            // check if there is conversation data available
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect);
            // connect to the conversation websocket
            this.privParticipants.meId = this.privRoom.participantId;
            this.privConversationRecognizer = $hgjD5.ConversationRecognizerFactory.fromConfig(this, this.privConfig);
            // Because ConversationTranslator manually sets up and manages the connection, Conversation
            // has to forward serviceRecognizer connection events that usually get passed automatically
            this.privConversationRecognizer.connected = this.onConnected;
            this.privConversationRecognizer.disconnected = this.onDisconnected;
            this.privConversationRecognizer.canceled = this.onCanceled;
            this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived;
            this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived;
            this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived;
            this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived;
            this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived;
            this.privConversationRecognizer.translationReceived = this.onTranslationReceived;
            this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived;
            this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration;
            this.privConversationRecognizer.connect(this.privRoom.token, ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Join a conversation as a participant.
     * @param { IParticipant } participant - participant to add
     * @param cb
     * @param err
     */ addParticipantAsync(participant, cb, err) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(participant, "Participant");
        (0, $5OUhN.marshalPromiseToCallbacks)(this.addParticipantImplAsync(participant), cb, err);
    }
    /**
     * Join a conversation as a participant.
     * @param conversation
     * @param nickname
     * @param lang
     * @param cb
     * @param err
     */ joinConversationAsync(conversationId, nickname, lang, cb, err) {
        try {
            // TODO
            // if (!!this.privConversationRecognizer) {
            //     throw new Error(this.privErrors.permissionDeniedStart);
            // }
            $3SMEZ.Contracts.throwIfNullOrWhitespace(conversationId, this.privErrors.invalidArgs.replace("{arg}", "conversationId"));
            $3SMEZ.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $3SMEZ.Contracts.throwIfNullOrWhitespace(lang, this.privErrors.invalidArgs.replace("{arg}", "language"));
            // join the conversation
            this.privManager.createOrJoin(this.privProperties, conversationId, (room)=>{
                $3SMEZ.Contracts.throwIfNullOrUndefined(room, this.privErrors.permissionDeniedConnect);
                this.privRoom = room;
                this.privConfig.authorizationToken = room.cognitiveSpeechAuthToken;
                // join callback
                if (!!cb) cb(room.cognitiveSpeechAuthToken);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Deletes a conversation
     * @param cb
     * @param err
     */ deleteConversationAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.deleteConversationImplAsync(), cb, err);
    }
    async deleteConversationImplAsync() {
        $3SMEZ.Contracts.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect);
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect);
        await this.privManager.leave(this.privProperties, this.privRoom.token);
        this.dispose();
    }
    /**
     * Issues a request to close the client websockets
     * @param cb
     * @param err
     */ endConversationAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.endConversationImplAsync(), cb, err);
    }
    endConversationImplAsync() {
        return this.close(true);
    }
    /**
     * Issues a request to lock the conversation
     * @param cb
     * @param err
     */ lockConversationAsync(cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute the conversation
     * @param cb
     * @param err
     */ muteAllParticipantsAsync(cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend);
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the user's permissions
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */ muteParticipantAsync(userId, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to remove a participant from the conversation
     * @param userId
     * @param cb
     * @param err
     */ removeParticipantAsync(userId, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            if (!!this.privTranscriberRecognizer && userId.hasOwnProperty("id")) // Assume this is a transcription participant
            (0, $5OUhN.marshalPromiseToCallbacks)(this.removeParticipantImplAsync(userId), cb, err);
            else {
                $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
                $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
                if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), err);
                let participantId = "";
                if (typeof userId === "string") participantId = userId;
                else if (userId.hasOwnProperty("id")) {
                    const participant = userId;
                    participantId = participant.id;
                } else if (userId.hasOwnProperty("userId")) {
                    const user = userId;
                    participantId = user.userId;
                }
                $3SMEZ.Contracts.throwIfNullOrWhitespace(participantId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
                // check the participant exists
                const index = this.participants.findIndex((p)=>p.id === participantId);
                if (index === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
                if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getEjectCommand(participantId), ()=>{
                    this.handleCallback(cb, err);
                }, (error)=>{
                    this.handleError(error, err);
                });
            }
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unlock the conversation
     * @param cb
     * @param err
     */ unlockConversationAsync(cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute all participants in the conversation
     * @param cb
     * @param err
     */ unmuteAllParticipantsAsync(cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */ unmuteParticipantAsync(userId, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ sendTextMessageAsync(message, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", "message"));
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // TODO: is a max length check required?
            if (message.length > this.privTextMessageMaxLength) this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMessageCommand(message), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Set translated to languages
     * @param {string[]} languages - languages to translate to
     * @param cb
     * @param err
     */ setTranslatedLanguagesAsync(languages, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfArrayEmptyOrWhitespace(languages, this.privErrors.invalidArgs.replace("{arg}", "languages"));
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(languages), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Change nickname
     * @param {string} nickname - new nickname for the room
     * @param cb
     * @param err
     */ changeNicknameAsync(nickname, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(nickname), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        if (this.isDisposed) return;
        this.privIsDisposed = true;
        if (!!this.config) this.config.close();
        this.privConfig = undefined;
        this.privLanguage = undefined;
        this.privProperties = undefined;
        this.privRoom = undefined;
        this.privToken = undefined;
        this.privManager = undefined;
        this.privIsConnected = false;
        this.privIsReady = false;
        this.privParticipants = undefined;
    }
    async connectTranscriberRecognizer(recognizer) {
        if (!!this.privTranscriberRecognizer) await this.privTranscriberRecognizer.close();
        await recognizer.enforceAudioGating();
        this.privTranscriberRecognizer = recognizer;
        this.privTranscriberRecognizer.conversation = this;
    }
    getKeepAlive() {
        const nickname = !!this.me ? this.me.displayName : "default_nickname";
        return JSON.stringify({
            id: "0",
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.keepAlive
        });
    }
    /* eslint-enable @typescript-eslint/typedef */ addParticipantImplAsync(participant) {
        const newParticipant = this.privParticipants.addOrUpdateParticipant(participant);
        if (newParticipant !== undefined) {
            if (!!this.privTranscriberRecognizer) {
                const conversationInfo = this.conversationInfo;
                conversationInfo.participants = [
                    participant
                ];
                return this.privTranscriberRecognizer.pushConversationEvent(conversationInfo, "join");
            }
        }
    }
    removeParticipantImplAsync(participant) {
        this.privParticipants.deleteParticipant(participant.id);
        const conversationInfo = this.conversationInfo;
        conversationInfo.participants = [
            participant
        ];
        return this.privTranscriberRecognizer.pushConversationEvent(conversationInfo, "leave");
    }
    async close(dispose) {
        try {
            this.privIsConnected = false;
            await this.privConversationRecognizer?.close();
            this.privConversationRecognizer = undefined;
            if (!!this.privConversationTranslator) this.privConversationTranslator.dispose();
        } catch (e) {
            // ignore error
            throw e;
        }
        if (dispose) this.dispose();
    }
    /** Helpers */ handleCallback(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    }
    handleError(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    }
    /** Participant Helpers */ toParticipants(includeHost) {
        const participants = this.privParticipants.participants.map((p)=>this.toParticipant(p));
        if (!includeHost) return participants.filter((p)=>p.isHost === false);
        else return participants;
    }
    toParticipant(p) {
        return new $gttSn.Participant(p.id, p.avatar, p.displayName, p.isHost, p.isMuted, p.isUsingTts, p.preferredLanguage, p.voice);
    }
    getMuteAllCommand(isMuted) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.setMuteAll,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getMuteCommand(participantId, isMuted) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.setMute,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getLockCommand(isLocked) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.setLockState,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand,
            value: isLocked
        });
    }
    getEjectCommand(participantId) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.ejectParticipant,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand
        });
    }
    getSetTranslateToLanguagesCommand(languages) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.setTranslateToLanguages,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand,
            value: languages
        });
    }
    getChangeNicknameCommand(nickname) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.changeNickname,
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand,
            value: nickname
        });
    }
    getMessageCommand(message) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(message, "message");
        return JSON.stringify({
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: message,
            type: $hgjD5.ConversationTranslatorMessageTypes.instantMessage
        });
    }
}
module.exports.ConversationImpl = $d410e63c93bc3788$var$ConversationImpl;

});

parcelRegister("g3541", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationCommon = void 0;
class $baf0dabfba22eeec$var$ConversationCommon {
    constructor(audioConfig){
        this.privAudioConfig = audioConfig;
    }
    handleCallback(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    }
    handleError(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    }
}
module.exports.ConversationCommon = $baf0dabfba22eeec$var$ConversationCommon;

});

parcelRegister("8D5nK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationExpirationEventArgs = void 0;

var $gttSn = parcelRequire("gttSn");
class $648623ff2eb9ec87$var$ConversationExpirationEventArgs extends $gttSn.SessionEventArgs {
    constructor(expirationTime, sessionId){
        super(sessionId);
        this.privExpirationTime = expirationTime;
    }
    /** How much longer until the conversation expires (in minutes). */ get expirationTime() {
        return this.privExpirationTime;
    }
}
module.exports.ConversationExpirationEventArgs = $648623ff2eb9ec87$var$ConversationExpirationEventArgs;

});

parcelRegister("kLPW7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationParticipantsChangedEventArgs = void 0;

var $gttSn = parcelRequire("gttSn");
class $f1f07be84c2bde0c$var$ConversationParticipantsChangedEventArgs extends $gttSn.SessionEventArgs {
    constructor(reason, participants, sessionId){
        super(sessionId);
        this.privReason = reason;
        this.privParticipant = participants;
    }
    get reason() {
        return this.privReason;
    }
    get participants() {
        return this.privParticipant;
    }
}
module.exports.ConversationParticipantsChangedEventArgs = $f1f07be84c2bde0c$var$ConversationParticipantsChangedEventArgs;

});

parcelRegister("iZ4Ku", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationCanceledEventArgs = void 0;

var $g5epc = parcelRequire("g5epc");
class $dd219b8b5852714a$var$ConversationTranslationCanceledEventArgs extends $g5epc.CancellationEventArgsBase {
}
module.exports.ConversationTranslationCanceledEventArgs = $dd219b8b5852714a$var$ConversationTranslationCanceledEventArgs;

});

parcelRegister("hqfR4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationEventArgs = void 0;

var $gttSn = parcelRequire("gttSn");
class $caf129dcca6ec9cc$var$ConversationTranslationEventArgs extends $gttSn.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ConversationTranslationResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the recognition result.
     * @returns {ConversationTranslationResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.ConversationTranslationEventArgs = $caf129dcca6ec9cc$var$ConversationTranslationEventArgs;

});

parcelRegister("c8RCw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationResult = void 0;

var $7duHD = parcelRequire("7duHD");
class $8d6fd3461ac74979$var$ConversationTranslationResult extends $7duHD.TranslationRecognitionResult {
    constructor(participantId, translations, originalLanguage, resultId, reason, text, duration, offset, errorDetails, json, properties){
        super(translations, resultId, reason, text, duration, offset, undefined, undefined, errorDetails, json, properties);
        this.privId = participantId;
        this.privOrigLang = originalLanguage;
    }
    /**
     * The unique identifier for the participant this result is for.
     */ get participantId() {
        return this.privId;
    }
    /**
     * The original language this result was in.
     */ get originalLang() {
        return this.privOrigLang;
    }
}
module.exports.ConversationTranslationResult = $8d6fd3461ac74979$var$ConversationTranslationResult;

});

parcelRegister("8z9RT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslator = module.exports.SpeechState = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5BbB5 = parcelRequire("5BbB5");

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");

var $icOZl = parcelRequire("icOZl");

var $ejSiE = parcelRequire("ejSiE");
var $63c93f403255b8d5$var$SpeechState;
(function(SpeechState) {
    SpeechState[SpeechState["Inactive"] = 0] = "Inactive";
    SpeechState[SpeechState["Connecting"] = 1] = "Connecting";
    SpeechState[SpeechState["Connected"] = 2] = "Connected";
})($63c93f403255b8d5$var$SpeechState = module.exports.SpeechState || (module.exports.SpeechState = {}));
// child class of TranslationRecognizer meant only for use with ConversationTranslator
class $63c93f403255b8d5$var$ConversationTranslationRecognizer extends $gttSn.TranslationRecognizer {
    constructor(speechConfig, audioConfig, translator, convGetter){
        super(speechConfig, audioConfig, new $5BbB5.ConversationTranslatorConnectionFactory(convGetter));
        this.privSpeechState = $63c93f403255b8d5$var$SpeechState.Inactive;
        if (!!translator) {
            this.privTranslator = translator;
            this.sessionStarted = ()=>{
                this.privSpeechState = $63c93f403255b8d5$var$SpeechState.Connected;
            };
            this.sessionStopped = ()=>{
                this.privSpeechState = $63c93f403255b8d5$var$SpeechState.Inactive;
            };
            this.recognizing = (tr, e)=>{
                if (!!this.privTranslator.recognizing) this.privTranslator.recognizing(this.privTranslator, e);
            };
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            this.recognized = async (tr, e)=>{
                // if there is an error connecting to the conversation service from the speech service the error will be returned in the ErrorDetails field.
                if (e.result?.errorDetails) {
                    await this.cancelSpeech();
                    // TODO: format the error message contained in 'errorDetails'
                    this.fireCancelEvent(e.result.errorDetails);
                } else if (!!this.privTranslator.recognized) this.privTranslator.recognized(this.privTranslator, e);
                return;
            };
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            this.canceled = async ()=>{
                if (this.privSpeechState !== $63c93f403255b8d5$var$SpeechState.Inactive) try {
                    await this.cancelSpeech();
                } catch (error) {
                    this.privSpeechState = $63c93f403255b8d5$var$SpeechState.Inactive;
                }
            };
        }
    }
    get state() {
        return this.privSpeechState;
    }
    set state(newState) {
        this.privSpeechState = newState;
    }
    set authentication(token) {
        this.privReco.authentication = token;
    }
    onConnection() {
        this.privSpeechState = $63c93f403255b8d5$var$SpeechState.Connected;
    }
    async onCancelSpeech() {
        this.privSpeechState = $63c93f403255b8d5$var$SpeechState.Inactive;
        await this.cancelSpeech();
    }
    /**
     * Fire a cancel event
     * @param error
     */ fireCancelEvent(error) {
        try {
            if (!!this.privTranslator.canceled) {
                const cancelEvent = new $ejSiE.ConversationTranslationCanceledEventArgs($gttSn.CancellationReason.Error, error, $gttSn.CancellationErrorCode.RuntimeError);
                this.privTranslator.canceled(this.privTranslator, cancelEvent);
            }
        } catch (e) {
        //
        }
    }
    async cancelSpeech() {
        try {
            this.stopContinuousRecognitionAsync();
            await this.privReco?.disconnect();
            this.privSpeechState = $63c93f403255b8d5$var$SpeechState.Inactive;
        } catch (e) {
        // ignore the error
        }
    }
}
/**
 * Join, leave or connect to a conversation.
 */ class $63c93f403255b8d5$var$ConversationTranslator extends $ejSiE.ConversationCommon {
    constructor(audioConfig){
        super(audioConfig);
        this.privErrors = $hgjD5.ConversationConnectionConfig.restErrors;
        this.privIsDisposed = false;
        this.privIsSpeaking = false;
        this.privPlaceholderKey = "abcdefghijklmnopqrstuvwxyz012345";
        this.privPlaceholderRegion = "westus";
        this.privProperties = new $gttSn.PropertyCollection();
    }
    get properties() {
        return this.privProperties;
    }
    get speechRecognitionLanguage() {
        return this.privSpeechRecognitionLanguage;
    }
    get participants() {
        return this.privConversation?.participants;
    }
    get canSpeak() {
        // is there a Conversation websocket available and has the Recognizer been set up
        if (!this.privConversation.isConnected || !this.privCTRecognizer) return false;
        // is the user already speaking
        if (this.privIsSpeaking || this.privCTRecognizer.state === $63c93f403255b8d5$var$SpeechState.Connected || this.privCTRecognizer.state === $63c93f403255b8d5$var$SpeechState.Connecting) return false;
        // is the user muted
        if (this.privConversation.isMutedByHost) return false;
        return true;
    }
    onToken(token) {
        this.privCTRecognizer.authentication = token;
    }
    setServiceProperty(name, value) {
        const currentProperties = JSON.parse(this.privProperties.getProperty($hgjD5.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty($hgjD5.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    }
    joinConversationAsync(conversation, nickname, param1, param2, param3) {
        try {
            if (typeof conversation === "string") {
                $3SMEZ.Contracts.throwIfNullOrUndefined(conversation, this.privErrors.invalidArgs.replace("{arg}", "conversation id"));
                $3SMEZ.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
                if (!!this.privConversation) this.handleError(new Error(this.privErrors.permissionDeniedStart), param3);
                let lang = param1;
                if (lang === undefined || lang === null || lang === "") lang = $hgjD5.ConversationConnectionConfig.defaultLanguageCode;
                // create a placeholder config
                this.privSpeechTranslationConfig = $gttSn.SpeechTranslationConfig.fromSubscription(this.privPlaceholderKey, this.privPlaceholderRegion);
                this.privSpeechTranslationConfig.setProfanity($gttSn.ProfanityOption.Masked);
                this.privSpeechTranslationConfig.addTargetLanguage(lang);
                this.privSpeechTranslationConfig.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage], lang);
                this.privSpeechTranslationConfig.setProperty($gttSn.PropertyId[$gttSn.PropertyId.ConversationTranslator_Name], nickname);
                const propertyIdsToCopy = [
                    $gttSn.PropertyId.SpeechServiceConnection_Host,
                    $gttSn.PropertyId.ConversationTranslator_Host,
                    $gttSn.PropertyId.SpeechServiceConnection_Endpoint,
                    $gttSn.PropertyId.SpeechServiceConnection_ProxyHostName,
                    $gttSn.PropertyId.SpeechServiceConnection_ProxyPassword,
                    $gttSn.PropertyId.SpeechServiceConnection_ProxyPort,
                    $gttSn.PropertyId.SpeechServiceConnection_ProxyUserName,
                    "ConversationTranslator_MultiChannelAudio",
                    "ConversationTranslator_Region"
                ];
                for (const prop of propertyIdsToCopy){
                    const value = this.privProperties.getProperty(prop);
                    if (value) {
                        const key = typeof prop === "string" ? prop : $gttSn.PropertyId[prop];
                        this.privSpeechTranslationConfig.setProperty(key, value);
                    }
                }
                const currentProperties = JSON.parse(this.privProperties.getProperty($hgjD5.ServicePropertiesPropertyName, "{}"));
                for (const prop of Object.keys(currentProperties))this.privSpeechTranslationConfig.setServiceProperty(prop, currentProperties[prop], $gttSn.ServicePropertyChannel.UriQueryParameter);
                // join the conversation
                this.privConversation = new $icOZl.ConversationImpl(this.privSpeechTranslationConfig);
                this.privConversation.conversationTranslator = this;
                this.privConversation.joinConversationAsync(conversation, nickname, lang, (result)=>{
                    if (!result) this.handleError(new Error(this.privErrors.permissionDeniedConnect), param3);
                    this.privSpeechTranslationConfig.authorizationToken = result;
                    this.privConversation.room.isHost = false;
                    // connect to the ws
                    this.privConversation.startConversationAsync(()=>{
                        this.handleCallback(param2, param3);
                    }, (error)=>{
                        this.handleError(error, param3);
                    });
                }, (error)=>{
                    this.handleError(error, param3);
                });
            } else if (typeof conversation === "object") {
                $3SMEZ.Contracts.throwIfNullOrUndefined(conversation, this.privErrors.invalidArgs.replace("{arg}", "conversation id"));
                $3SMEZ.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
                // save the nickname
                this.privProperties.setProperty($gttSn.PropertyId.ConversationTranslator_Name, nickname);
                // ref the conversation object
                this.privConversation = conversation;
                // ref the conversation translator object
                this.privConversation.conversationTranslator = this;
                this.privConversation.room.isHost = true;
                $3SMEZ.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedConnect);
                $3SMEZ.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect);
                this.privSpeechTranslationConfig = conversation.config;
                this.handleCallback(param1, param2);
            } else this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "invalid conversation type")), param2);
        } catch (error) {
            this.handleError(error, typeof param1 === "string" ? param3 : param2);
        }
    }
    /**
     * Leave the conversation
     * @param cb
     * @param err
     */ leaveConversationAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)((async ()=>{
            // stop the speech websocket
            await this.cancelSpeech();
            // stop the websocket
            await this.privConversation.endConversationImplAsync();
            // https delete request
            await this.privConversation.deleteConversationImplAsync();
            this.dispose();
        })(), cb, err);
    }
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ sendTextMessageAsync(message, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend);
            $3SMEZ.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", message));
            this.privConversation.sendTextMessageAsync(message, cb, err);
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Start speaking
     * @param cb
     * @param err
     */ startTranscribingAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)((async ()=>{
            try {
                $3SMEZ.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend);
                $3SMEZ.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect);
                if (this.privCTRecognizer === undefined) await this.connectTranslatorRecognizer();
                $3SMEZ.Contracts.throwIfNullOrUndefined(this.privCTRecognizer, this.privErrors.permissionDeniedSend);
                if (!this.canSpeak) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
                await this.startContinuousRecognition();
                this.privIsSpeaking = true;
            } catch (error) {
                this.privIsSpeaking = false;
                await this.cancelSpeech();
                throw error;
            }
        })(), cb, err);
    }
    /**
     * Stop speaking
     * @param cb
     * @param err
     */ stopTranscribingAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)((async ()=>{
            try {
                if (!this.privIsSpeaking) {
                    // stop speech
                    await this.cancelSpeech();
                    return;
                }
                // stop the recognition but leave the websocket open
                this.privIsSpeaking = false;
                await new Promise((resolve, reject)=>{
                    this.privCTRecognizer.stopContinuousRecognitionAsync(resolve, reject);
                });
            } catch (error) {
                await this.cancelSpeech();
            }
        })(), cb, err);
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(reason, success, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)((async ()=>{
            if (this.isDisposed && !this.privIsSpeaking) return;
            await this.cancelSpeech();
            this.privIsDisposed = true;
            this.privSpeechTranslationConfig.close();
            this.privSpeechRecognitionLanguage = undefined;
            this.privProperties = undefined;
            this.privAudioConfig = undefined;
            this.privSpeechTranslationConfig = undefined;
            this.privConversation.dispose();
            this.privConversation = undefined;
        })(), success, err);
    }
    /**
     * Cancel the speech websocket
     */ async cancelSpeech() {
        try {
            this.privIsSpeaking = false;
            await this.privCTRecognizer?.onCancelSpeech();
            this.privCTRecognizer = undefined;
        } catch (e) {
        // ignore the error
        }
    }
    /**
     * Connect to the speech translation recognizer.
     * Currently there is no language validation performed before sending the SpeechLanguage code to the service.
     * If it's an invalid language the raw error will be: 'Error during WebSocket handshake: Unexpected response code: 400'
     * e.g. pass in 'fr' instead of 'fr-FR', or a text-only language 'cy'
     */ async connectTranslatorRecognizer() {
        try {
            if (this.privAudioConfig === undefined) this.privAudioConfig = $gttSn.AudioConfig.fromDefaultMicrophoneInput();
            // clear the temp subscription key if it's a participant joining
            if (this.privSpeechTranslationConfig.getProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_Key]) === this.privPlaceholderKey) this.privSpeechTranslationConfig.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_Key], "");
            const convGetter = ()=>this.privConversation;
            this.privCTRecognizer = new $63c93f403255b8d5$var$ConversationTranslationRecognizer(this.privSpeechTranslationConfig, this.privAudioConfig, this, convGetter);
        } catch (error) {
            await this.cancelSpeech();
            throw error;
        }
    }
    /**
     * Handle the start speaking request
     */ startContinuousRecognition() {
        return new Promise((resolve, reject)=>{
            this.privCTRecognizer.startContinuousRecognitionAsync(resolve, reject);
        });
    }
}
module.exports.ConversationTranslator = $63c93f403255b8d5$var$ConversationTranslator;

});
parcelRegister("5BbB5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorConnectionFactory = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $7HCM3 = parcelRequire("7HCM3");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");

var $40Pvg = parcelRequire("40Pvg");

var $jE6M6 = parcelRequire("jE6M6");

var $kBobk = parcelRequire("kBobk");

var $hgjD5 = parcelRequire("hgjD5");
/**
 * Connection factory for the conversation translator. Handles connecting to the regular translator endpoint,
 * as well as the virtual microphone array transcription endpoint
 */ class $413967631953072c$var$ConversationTranslatorConnectionFactory extends $kBobk.ConnectionFactoryBase {
    constructor(convGetter){
        super();
        $3SMEZ.Contracts.throwIfNullOrUndefined(convGetter, "convGetter");
        this.privConvGetter = convGetter;
    }
    create(config, authInfo, connectionId) {
        const isVirtMicArrayEndpoint = config.parameters.getProperty("ConversationTranslator_MultiChannelAudio", "").toUpperCase() === "TRUE";
        const convInfo = this.privConvGetter().room;
        const region = convInfo.cognitiveSpeechRegion || config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Region, "");
        const replacementValues = {
            hostSuffix: $kBobk.ConnectionFactoryBase.getHostSuffix(region),
            path: $413967631953072c$var$ConversationTranslatorConnectionFactory.CTS_VIRT_MIC_PATH,
            region: encodeURIComponent(region)
        };
        replacementValues[$jE6M6.QueryParameterNames.Language] = encodeURIComponent(config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage, ""));
        replacementValues[$jE6M6.QueryParameterNames.CtsMeetingId] = encodeURIComponent(convInfo.roomId);
        replacementValues[$jE6M6.QueryParameterNames.CtsDeviceId] = encodeURIComponent(convInfo.participantId);
        replacementValues[$jE6M6.QueryParameterNames.CtsIsParticipant] = convInfo.isHost ? "" : "&" + $jE6M6.QueryParameterNames.CtsIsParticipant;
        let endpointUrl = "";
        const queryParams = {};
        const headers = {};
        if (isVirtMicArrayEndpoint) {
            // connecting to the conversation transcription virtual microphone array endpoint
            endpointUrl = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint);
            if (!endpointUrl) {
                const hostName = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Host, "transcribe.{region}.cts.speech{hostSuffix}");
                endpointUrl = "wss://" + hostName + "{path}";
            }
            // because the region can change during a session, we support being passed a format string which we can then
            // replace with the correct information.
            endpointUrl = $7HCM3.StringUtils.formatString(endpointUrl, replacementValues);
            const parsedUrl = new URL(endpointUrl);
            parsedUrl.searchParams.forEach((val, key)=>{
                queryParams[key] = val;
            });
            const connFactory = new $hgjD5.TranscriberConnectionFactory();
            connFactory.setQueryParams(queryParams, config, endpointUrl);
            // Some query parameters are required for the CTS endpoint, let's explicity set them here
            queryParams[$jE6M6.QueryParameterNames.CtsMeetingId] = replacementValues[$jE6M6.QueryParameterNames.CtsMeetingId];
            queryParams[$jE6M6.QueryParameterNames.CtsDeviceId] = replacementValues[$jE6M6.QueryParameterNames.CtsDeviceId];
            if (!convInfo.isHost) queryParams[$jE6M6.QueryParameterNames.CtsIsParticipant] = ""; // this doesn't have a value so set to an empty string
            if (!($jE6M6.QueryParameterNames.Format in queryParams)) queryParams[$jE6M6.QueryParameterNames.Format] = "simple";
            parsedUrl.searchParams.forEach((val, key)=>{
                parsedUrl.searchParams.set(key, queryParams[key]);
                delete queryParams[key];
            });
            endpointUrl = parsedUrl.toString();
        } else {
            // connecting to regular translation endpoint
            const connFactory = new $hgjD5.TranslationConnectionFactory();
            endpointUrl = connFactory.getEndpointUrl(config, true);
            endpointUrl = $7HCM3.StringUtils.formatString(endpointUrl, replacementValues);
            connFactory.setQueryParams(queryParams, config, endpointUrl);
        }
        headers[$40Pvg.HeaderNames.ConnectionId] = connectionId;
        headers[$s6RJO.RestConfigBase.configParams.token] = convInfo.token;
        if (!!authInfo.token) headers[authInfo.headerName] = authInfo.token;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "").toUpperCase() === "TRUE";
        return Promise.resolve(new $s6RJO.WebsocketConnection(endpointUrl, queryParams, headers, new $hgjD5.WebsocketMessageFormatter(), $s6RJO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId));
    }
}
module.exports.ConversationTranslatorConnectionFactory = $413967631953072c$var$ConversationTranslatorConnectionFactory;
$413967631953072c$var$ConversationTranslatorConnectionFactory.CTS_VIRT_MIC_PATH = "/speech/recognition/dynamicaudio";

});
parcelRegister("7HCM3", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StringUtils = void 0;
/**
 * String helper functions
 */ class $59baa04b9245c2dc$var$StringUtils {
    /**
     * Formats a string by replacing the named {keys} in the string with the values contained in the replacement dictionary.
     * @param format The format string that contains the parts to replace surrounded by {}. For example: "wss://{region}.cts.speech.microsoft.com".
     * If your string needs to contain a { or } you can use the {{ and }} escape sequences respectively.
     * @param replacements The dictionary of replacements. If a replacement is not found, it is replaced with an empty string
     * @returns The formatted string. If you pass in a null or undefined format string, an empty string will be returned
     */ static formatString(format, replacements) {
        if (!format) return "";
        if (!replacements) return format;
        let formatted = "";
        let key = "";
        const appendToFormatted = (str)=>{
            formatted += str;
        };
        const appendToKey = (str)=>{
            key += str;
        };
        let appendFunc = appendToFormatted;
        for(let i = 0; i < format.length; i++){
            const c = format[i];
            const next = i + 1 < format.length ? format[i + 1] : "";
            switch(c){
                case "{":
                    if (next === "{") {
                        appendFunc("{");
                        i++;
                    } else appendFunc = appendToKey;
                    break;
                case "}":
                    if (next === "}") {
                        appendFunc("}");
                        i++;
                    } else {
                        if (replacements.hasOwnProperty(key)) formatted += replacements[key];
                        appendFunc = appendToFormatted;
                        key = "";
                    }
                    break;
                default:
                    appendFunc(c);
                    break;
            }
        }
        return formatted;
    }
}
module.exports.StringUtils = $59baa04b9245c2dc$var$StringUtils;

});



parcelRegister("603mk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriber = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $6rQ2O = parcelRequire("6rQ2O");

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
/**
 * Performs speech recognition with speaker separation from microphone, file, or other audio input streams, and gets transcribed text as result.
 * @class ConversationTranscriber
 */ class $45e55937652113f6$var$ConversationTranscriber extends $gttSn.Recognizer {
    /**
     * ConversationTranscriber constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ constructor(speechConfig, audioConfig){
        const speechConfigImpl = speechConfig;
        $3SMEZ.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(speechConfigImpl.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage), $gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage]);
        super(audioConfig, speechConfigImpl.properties, new $hgjD5.ConversationTranscriberConnectionFactory(), speechConfig.tokenCredential);
        this.privProperties.setProperty($gttSn.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "2");
        this.privDisposedRecognizer = false;
    }
    /**
     * ConversationTranscriber constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ static FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        const recognizer = new $45e55937652113f6$var$ConversationTranscriber(speechConfig, audioConfig);
        return recognizer;
    }
    /**
     * Gets the endpoint id of a customized speech model that is used for transcription.
     * @member ConversationTranscriber.prototype.endpointId
     * @function
     * @public
     * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
     */ get endpointId() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member ConversationTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member ConversationTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * Gets the spoken language of transcription.
     * @member ConversationTranscriber.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of transcription.
     */ get speechRecognitionLanguage() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the output format of transcription.
     * @member ConversationTranscriber.prototype.outputFormat
     * @function
     * @public
     * @returns {OutputFormat} The output format of transcription.
     */ get outputFormat() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        if (this.properties.getProperty($hgjD5.OutputFormatPropertyName, $gttSn.OutputFormat[$gttSn.OutputFormat.Simple]) === $gttSn.OutputFormat[$gttSn.OutputFormat.Simple]) return $gttSn.OutputFormat.Simple;
        else return $gttSn.OutputFormat.Detailed;
    }
    /**
     * The collection of properties and their values defined for this conversation transcriber.
     * @member ConversationTranscriber.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Starts conversation transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member ConversationTranscriber.prototype.startTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ startTranscribingAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.startContinuousRecognitionAsyncImpl($6rQ2O.RecognitionMode.Conversation), cb, err);
    }
    /**
     * Stops conversation transcription.
     * @member ConversationTranscriber.prototype.stopTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopTranscribingAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member ConversationTranscriber.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        (0, $5OUhN.marshalPromiseToCallbacks)(this.dispose(true), cb, errorCb);
    }
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (disposing) {
            this.privDisposedRecognizer = true;
            await this.implRecognizerStop();
        }
        await super.dispose(disposing);
    }
    createRecognizerConfig(speechConfig) {
        return new $hgjD5.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        recognizerConfig.isSpeakerDiarizationEnabled = true;
        return new $hgjD5.ConversationTranscriptionServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
}
module.exports.ConversationTranscriber = $45e55937652113f6$var$ConversationTranscriber;

});

parcelRegister("jzyuG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Participant = module.exports.User = void 0;

var $gttSn = parcelRequire("gttSn");
class $e3fc0afdbf1559ed$var$User {
    constructor(userId){
        this.privUserId = userId;
    }
    get userId() {
        return this.privUserId;
    }
}
module.exports.User = $e3fc0afdbf1559ed$var$User;
class $e3fc0afdbf1559ed$var$Participant {
    constructor(id, avatar, displayName, isHost, isMuted, isUsingTts, preferredLanguage, voice){
        this.privId = id;
        this.privAvatar = avatar;
        this.privDisplayName = displayName;
        this.privIsHost = isHost;
        this.privIsMuted = isMuted;
        this.privIsUsingTts = isUsingTts;
        this.privPreferredLanguage = preferredLanguage;
        this.privVoice = voice;
        this.privProperties = new $gttSn.PropertyCollection();
    }
    get avatar() {
        return this.privAvatar;
    }
    get displayName() {
        return this.privDisplayName;
    }
    get id() {
        return this.privId;
    }
    get preferredLanguage() {
        return this.privPreferredLanguage;
    }
    get isHost() {
        return this.privIsHost;
    }
    get isMuted() {
        return this.privIsMuted;
    }
    get isUsingTts() {
        return this.privIsUsingTts;
    }
    get voice() {
        return this.privVoice;
    }
    get properties() {
        return this.privProperties;
    }
    static From(id, language, voice) {
        return new $e3fc0afdbf1559ed$var$Participant(id, "", id, false, false, false, language, voice);
    }
}
module.exports.Participant = $e3fc0afdbf1559ed$var$Participant;

});

parcelRegister("kHyWL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParticipantChangedReason = void 0;
var $03e3a9021b771cdc$var$ParticipantChangedReason;
(function(ParticipantChangedReason) {
    /** Participant has joined the conversation. */ ParticipantChangedReason[ParticipantChangedReason["JoinedConversation"] = 0] = "JoinedConversation";
    /** Participant has left the conversation. This could be voluntary, or involuntary
     * (e.g. they are experiencing networking issues).
     */ ParticipantChangedReason[ParticipantChangedReason["LeftConversation"] = 1] = "LeftConversation";
    /** The participants' state has changed (e.g. they became muted, changed their nickname). */ ParticipantChangedReason[ParticipantChangedReason["Updated"] = 2] = "Updated";
})($03e3a9021b771cdc$var$ParticipantChangedReason = module.exports.ParticipantChangedReason || (module.exports.ParticipantChangedReason = {}));

});

parcelRegister("9qyr0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingImpl = module.exports.Meeting = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
class $01c570874d8ec500$var$Meeting {
    constructor(){
        return;
    }
    /**
     * Create a meeting
     * @param speechConfig
     * @param meetingId
     * @param cb
     * @param err
     */ static createMeetingAsync(speechConfig, meetingId, arg3, arg4) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(speechConfig, $hgjD5.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "config"));
        $3SMEZ.Contracts.throwIfNullOrUndefined(speechConfig.region, $hgjD5.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region"));
        $3SMEZ.Contracts.throwIfNull(meetingId, "meetingId");
        if (meetingId.length === 0) throw new Error("meetingId cannot be empty");
        if (!speechConfig.subscriptionKey && !speechConfig.getProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceAuthorization_Token])) $3SMEZ.Contracts.throwIfNullOrUndefined(speechConfig.subscriptionKey, $hgjD5.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        const meetingImpl = new $01c570874d8ec500$var$MeetingImpl(speechConfig, meetingId);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        (0, $5OUhN.marshalPromiseToCallbacks)((async ()=>{})(), arg3, arg4);
        return meetingImpl;
    }
}
module.exports.Meeting = $01c570874d8ec500$var$Meeting;
class $01c570874d8ec500$var$MeetingImpl extends $01c570874d8ec500$var$Meeting {
    /**
     * Create a Meeting impl
     * @param speechConfig
     * @param {string} id - optional conversationId
     */ constructor(speechConfig, id){
        super();
        this.privErrors = $hgjD5.ConversationConnectionConfig.restErrors;
        /** websocket callbacks */ /* eslint-disable @typescript-eslint/typedef */ this.onConnected = (e)=>{
            this.privIsConnected = true;
            try {
                if (!!this.privConversationTranslator?.sessionStarted) this.privConversationTranslator.sessionStarted(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onDisconnected = (e)=>{
            try {
                if (!!this.privConversationTranslator?.sessionStopped) this.privConversationTranslator.sessionStopped(this.privConversationTranslator, e);
            } catch (e) {
            //
            } finally{
                this.close(false);
            }
        };
        this.onCanceled = (r, e)=>{
            try {
                if (!!this.privConversationTranslator?.canceled) this.privConversationTranslator.canceled(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onParticipantUpdateCommandReceived = (r, e)=>{
            try {
                const updatedParticipant = this.privParticipants.getParticipant(e.id);
                if (updatedParticipant !== undefined) {
                    switch(e.key){
                        case $hgjD5.ConversationTranslatorCommandTypes.changeNickname:
                            updatedParticipant.displayName = e.value;
                            break;
                        case $hgjD5.ConversationTranslatorCommandTypes.setUseTTS:
                            updatedParticipant.isUsingTts = e.value;
                            break;
                        case $hgjD5.ConversationTranslatorCommandTypes.setProfanityFiltering:
                            updatedParticipant.profanity = e.value;
                            break;
                        case $hgjD5.ConversationTranslatorCommandTypes.setMute:
                            updatedParticipant.isMuted = e.value;
                            break;
                        case $hgjD5.ConversationTranslatorCommandTypes.setTranslateToLanguages:
                            updatedParticipant.translateToLanguages = e.value;
                            break;
                    }
                    this.privParticipants.addOrUpdateParticipant(updatedParticipant);
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $gttSn.ConversationParticipantsChangedEventArgs($gttSn.ParticipantChangedReason.Updated, [
                        this.toParticipant(updatedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onLockRoomCommandReceived = ()=>{
        // TODO
        };
        this.onMuteAllCommandReceived = (r, e)=>{
            try {
                this.privParticipants.participants.forEach((p)=>p.isMuted = p.isHost ? false : e.isMuted);
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $gttSn.ConversationParticipantsChangedEventArgs($gttSn.ParticipantChangedReason.Updated, this.toParticipants(false), e.sessionId));
            } catch (e) {
            //
            }
        };
        this.onParticipantJoinCommandReceived = (r, e)=>{
            try {
                const newParticipant = this.privParticipants.addOrUpdateParticipant(e.participant);
                if (newParticipant !== undefined) {
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $gttSn.ConversationParticipantsChangedEventArgs($gttSn.ParticipantChangedReason.JoinedConversation, [
                        this.toParticipant(newParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantLeaveCommandReceived = (r, e)=>{
            try {
                const ejectedParticipant = this.privParticipants.getParticipant(e.participant.id);
                if (ejectedParticipant !== undefined) {
                    // remove the participant from the internal participants list
                    this.privParticipants.deleteParticipant(e.participant.id);
                    if (!!this.privConversationTranslator) // notify subscribers that the participant has left the conversation
                    this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $gttSn.ConversationParticipantsChangedEventArgs($gttSn.ParticipantChangedReason.LeftConversation, [
                        this.toParticipant(ejectedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onTranslationReceived = (r, e)=>{
            try {
                switch(e.command){
                    case $hgjD5.ConversationTranslatorMessageTypes.final:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribed(this.privConversationTranslator, new $gttSn.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $hgjD5.ConversationTranslatorMessageTypes.partial:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribing(this.privConversationTranslator, new $gttSn.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $hgjD5.ConversationTranslatorMessageTypes.instantMessage:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new $gttSn.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantsListReceived = (r, e)=>{
            try {
                // check if the session token needs to be updated
                if (e.sessionToken !== undefined && e.sessionToken !== null) this.privRoom.token = e.sessionToken;
                // save the participants
                this.privParticipants.participants = [
                    ...e.participants
                ];
                // enable the conversation
                if (this.privParticipants.me !== undefined) this.privIsReady = true;
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $gttSn.ConversationParticipantsChangedEventArgs($gttSn.ParticipantChangedReason.JoinedConversation, this.toParticipants(true), e.sessionId));
                // if this is the host, update the nickname if needed
                if (this.me.isHost) {
                    const nickname = this.privConversationTranslator?.properties.getProperty($gttSn.PropertyId.ConversationTranslator_Name);
                    if (nickname !== undefined && nickname.length > 0 && nickname !== this.me.displayName) // issue a change nickname request
                    this.changeNicknameAsync(nickname);
                }
            } catch (e) {
            //
            }
        };
        this.onConversationExpiration = (r, e)=>{
            try {
                if (!!this.privConversationTranslator) this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.privIsConnected = false;
        this.privIsDisposed = false;
        this.privConversationId = "";
        this.privProperties = new $gttSn.PropertyCollection();
        this.privManager = new $hgjD5.ConversationManager();
        // check the speech language
        const language = speechConfig.getProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!language) speechConfig.setProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage], $hgjD5.ConversationConnectionConfig.defaultLanguageCode);
        this.privLanguage = speechConfig.getProperty($gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage]);
        this.privConversationId = id;
        // save the speech config for future usage
        this.privConfig = speechConfig;
        // save the config properties
        const configImpl = speechConfig;
        $3SMEZ.Contracts.throwIfNull(configImpl, "speechConfig");
        this.privProperties = configImpl.properties.clone();
        this.privIsConnected = false;
        this.privParticipants = new $hgjD5.InternalParticipants();
        this.privIsReady = false;
        this.privTextMessageMaxLength = 1000;
    }
    // get the internal data about a conversation
    get room() {
        return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
        return this.privConversationRecognizer; // this.privConnection;
    }
    // get the config
    get config() {
        return this.privConfig;
    }
    // get the meeting Id
    get meetingId() {
        return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
        return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
        return this.privLanguage;
    }
    get isMutedByHost() {
        return this.privParticipants.me?.isHost ? false : this.privParticipants.me?.isMuted;
    }
    get isConnected() {
        return this.privIsConnected && this.privIsReady;
    }
    get participants() {
        return this.toParticipants(true);
    }
    get me() {
        return this.toParticipant(this.privParticipants.me);
    }
    get host() {
        return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
        return this.privTranscriberRecognizer;
    }
    get meetingInfo() {
        const convId = this.meetingId;
        const p = this.participants.map((part)=>({
                id: part.id,
                preferredLanguage: part.preferredLanguage,
                voice: part.voice
            }));
        const props = {};
        for (const key of $hgjD5.ConversationConnectionConfig.transcriptionEventKeys){
            const val = this.properties.getProperty(key, "");
            if (val !== "") props[key] = val;
        }
        const info = {
            id: convId,
            participants: p,
            meetingProperties: props
        };
        return info;
    }
    get canSend() {
        return this.privIsConnected && !this.privParticipants.me?.isMuted;
    }
    get canSendAsHost() {
        return this.privIsConnected && this.privParticipants.me?.isHost;
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
        return this.privToken;
    }
    set authorizationToken(value) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(value, "authorizationToken");
        this.privToken = value;
    }
    /**
     * Create a new meeting as Host
     * @param cb
     * @param err
     */ createMeetingAsync(cb, err) {
        try {
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            this.privManager.createOrJoin(this.privProperties, undefined, (room)=>{
                if (!room) this.handleError(new Error(this.privErrors.permissionDeniedConnect), err);
                this.privRoom = room;
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Starts a new meeting as host.
     * @param cb
     * @param err
     */ startMeetingAsync(cb, err) {
        try {
            // check if there is already a recognizer
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            // check if there is conversation data available
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect);
            // connect to the conversation websocket
            this.privParticipants.meId = this.privRoom.participantId;
            // Because ConversationTranslator manually sets up and manages the connection, Conversation
            // has to forward serviceRecognizer connection events that usually get passed automatically
            this.privConversationRecognizer.connected = this.onConnected;
            this.privConversationRecognizer.disconnected = this.onDisconnected;
            this.privConversationRecognizer.canceled = this.onCanceled;
            this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived;
            this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived;
            this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived;
            this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived;
            this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived;
            this.privConversationRecognizer.translationReceived = this.onTranslationReceived;
            this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived;
            this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration;
            this.privConversationRecognizer.connect(this.privRoom.token, ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Join a meeting as a participant.
     * @param { IParticipant } participant - participant to add
     * @param cb
     * @param err
     */ addParticipantAsync(participant, cb, err) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(participant, "Participant");
        (0, $5OUhN.marshalPromiseToCallbacks)(this.addParticipantImplAsync(participant), cb, err);
    }
    /**
     * Join a meeting as a participant.
     * @param meeting
     * @param nickname
     * @param lang
     * @param cb
     * @param err
     */ joinMeetingAsync(meetingId, nickname, lang, cb, err) {
        try {
            // TODO
            // if (!!this.privConversationRecognizer) {
            //     throw new Error(this.privErrors.permissionDeniedStart);
            // }
            $3SMEZ.Contracts.throwIfNullOrWhitespace(meetingId, this.privErrors.invalidArgs.replace("{arg}", "conversationId"));
            $3SMEZ.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $3SMEZ.Contracts.throwIfNullOrWhitespace(lang, this.privErrors.invalidArgs.replace("{arg}", "language"));
            // join the conversation
            this.privManager.createOrJoin(this.privProperties, meetingId, (room)=>{
                $3SMEZ.Contracts.throwIfNullOrUndefined(room, this.privErrors.permissionDeniedConnect);
                this.privRoom = room;
                this.privConfig.authorizationToken = room.cognitiveSpeechAuthToken;
                // join callback
                if (!!cb) cb(room.cognitiveSpeechAuthToken);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Deletes a meeting
     * @param cb
     * @param err
     */ deleteMeetingAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.deleteMeetingImplAsync(), cb, err);
    }
    async deleteMeetingImplAsync() {
        $3SMEZ.Contracts.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect);
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect);
        await this.privManager.leave(this.privProperties, this.privRoom.token);
        this.dispose();
    }
    /**
     * Issues a request to close the client websockets
     * @param cb
     * @param err
     */ endMeetingAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.endMeetingImplAsync(), cb, err);
    }
    endMeetingImplAsync() {
        return this.close(true);
    }
    /**
     * Issues a request to lock the conversation
     * @param cb
     * @param err
     */ lockMeetingAsync(cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute the meeting
     * @param cb
     * @param err
     */ muteAllParticipantsAsync(cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend);
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the user's permissions
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute a participant in the meeting
     * @param userId
     * @param cb
     * @param err
     */ muteParticipantAsync(userId, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to remove a participant from the conversation
     * @param userId
     * @param cb
     * @param err
     */ removeParticipantAsync(userId, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            if (!!this.privTranscriberRecognizer && userId.hasOwnProperty("id")) // Assume this is a transcription participant
            (0, $5OUhN.marshalPromiseToCallbacks)(this.removeParticipantImplAsync(userId), cb, err);
            else {
                $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
                $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
                if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), err);
                let participantId = "";
                if (typeof userId === "string") participantId = userId;
                else if (userId.hasOwnProperty("id")) {
                    const participant = userId;
                    participantId = participant.id;
                } else if (userId.hasOwnProperty("userId")) {
                    const user = userId;
                    participantId = user.userId;
                }
                $3SMEZ.Contracts.throwIfNullOrWhitespace(participantId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
                // check the participant exists
                const index = this.participants.findIndex((p)=>p.id === participantId);
                if (index === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
                if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getEjectCommand(participantId), ()=>{
                    this.handleCallback(cb, err);
                }, (error)=>{
                    this.handleError(error, err);
                });
            }
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unlock the meeting
     * @param cb
     * @param err
     */ unlockMeetingAsync(cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute all participants in the meeting
     * @param cb
     * @param err
     */ unmuteAllParticipantsAsync(cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute a participant in the meeting
     * @param userId
     * @param cb
     * @param err
     */ unmuteParticipantAsync(userId, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ sendTextMessageAsync(message, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", "message"));
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // TODO: is a max length check required?
            if (message.length > this.privTextMessageMaxLength) this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMessageCommand(message), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Set translated to languages
     * @param {string[]} languages - languages to translate to
     * @param cb
     * @param err
     */ setTranslatedLanguagesAsync(languages, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfArrayEmptyOrWhitespace(languages, this.privErrors.invalidArgs.replace("{arg}", "languages"));
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(languages), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Change nickname
     * @param {string} nickname - new nickname for the room
     * @param cb
     * @param err
     */ changeNicknameAsync(nickname, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $3SMEZ.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(nickname), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        if (this.isDisposed) return;
        this.privIsDisposed = true;
        if (!!this.config) this.config.close();
        this.privConfig = undefined;
        this.privLanguage = undefined;
        this.privProperties = undefined;
        this.privRoom = undefined;
        this.privToken = undefined;
        this.privManager = undefined;
        this.privIsConnected = false;
        this.privIsReady = false;
        this.privParticipants = undefined;
    }
    async connectTranscriberRecognizer(recognizer) {
        if (!!this.privTranscriberRecognizer) await this.privTranscriberRecognizer.close();
        await recognizer.enforceAudioGating();
        this.privTranscriberRecognizer = recognizer;
        this.privTranscriberRecognizer.meeting = this;
    }
    getKeepAlive() {
        const nickname = !!this.me ? this.me.displayName : "default_nickname";
        return JSON.stringify({
            id: "0",
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.keepAlive
        });
    }
    /* eslint-enable @typescript-eslint/typedef */ addParticipantImplAsync(participant) {
        const newParticipant = this.privParticipants.addOrUpdateParticipant(participant);
        if (newParticipant !== undefined) {
            if (!!this.privTranscriberRecognizer) {
                const meetingInfo = this.meetingInfo;
                meetingInfo.participants = [
                    participant
                ];
                return this.privTranscriberRecognizer.pushMeetingEvent(meetingInfo, "join");
            }
        }
    }
    removeParticipantImplAsync(participant) {
        this.privParticipants.deleteParticipant(participant.id);
        const meetingInfo = this.meetingInfo;
        meetingInfo.participants = [
            participant
        ];
        return this.privTranscriberRecognizer.pushMeetingEvent(meetingInfo, "leave");
    }
    async close(dispose) {
        try {
            this.privIsConnected = false;
            await this.privConversationRecognizer?.close();
            this.privConversationRecognizer = undefined;
            if (!!this.privConversationTranslator) this.privConversationTranslator.dispose();
        } catch (e) {
            // ignore error
            throw e;
        }
        if (dispose) this.dispose();
    }
    /** Helpers */ handleCallback(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    }
    handleError(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    }
    /** Participant Helpers */ toParticipants(includeHost) {
        const participants = this.privParticipants.participants.map((p)=>this.toParticipant(p));
        if (!includeHost) return participants.filter((p)=>p.isHost === false);
        else return participants;
    }
    toParticipant(p) {
        return new $gttSn.Participant(p.id, p.avatar, p.displayName, p.isHost, p.isMuted, p.isUsingTts, p.preferredLanguage, p.voice);
    }
    getMuteAllCommand(isMuted) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingd");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.setMuteAll,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getMuteCommand(participantId, isMuted) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.setMute,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getLockCommand(isLocked) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.setLockState,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand,
            value: isLocked
        });
    }
    getEjectCommand(participantId) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.ejectParticipant,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand
        });
    }
    getSetTranslateToLanguagesCommand(languages) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.setTranslateToLanguages,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand,
            value: languages
        });
    }
    getChangeNicknameCommand(nickname) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $hgjD5.ConversationTranslatorCommandTypes.changeNickname,
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $hgjD5.ConversationTranslatorMessageTypes.participantCommand,
            value: nickname
        });
    }
    getMessageCommand(message) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(message, "message");
        return JSON.stringify({
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: message,
            type: $hgjD5.ConversationTranslatorMessageTypes.instantMessage
        });
    }
}
module.exports.MeetingImpl = $01c570874d8ec500$var$MeetingImpl;

});

parcelRegister("4pAPh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriptionCanceledEventArgs = void 0;

var $g5epc = parcelRequire("g5epc");
class $336610185bd18f55$var$MeetingTranscriptionCanceledEventArgs extends $g5epc.CancellationEventArgsBase {
}
module.exports.MeetingTranscriptionCanceledEventArgs = $336610185bd18f55$var$MeetingTranscriptionCanceledEventArgs;

});

parcelRegister("jx8tw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriber = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");

var $ejSiE = parcelRequire("ejSiE");
class $e387ac5ad219ec2a$var$MeetingTranscriber {
    /**
     * MeetingTranscriber constructor.
     * @constructor
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ constructor(audioConfig){
        this.privAudioConfig = audioConfig;
        this.privProperties = new $gttSn.PropertyCollection();
        this.privRecognizer = undefined;
        this.privDisposedRecognizer = false;
    }
    /**
     * Gets the spoken language of recognition.
     * @member MeetingTranscriber.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of recognition.
     */ get speechRecognitionLanguage() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * The collection of properties and their values defined for this MeetingTranscriber.
     * @member MeetingTranscriber.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this MeetingTranscriber.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * @Internal
     * Internal data member to support fromRecognizer* pattern methods on other classes.
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privRecognizer.internalData;
    }
    /**
     * @Deprecated
     * @Obsolete
     * Please use the Connection.fromRecognizer pattern to obtain a connection object
     */ get connection() {
        return $gttSn.Connection.fromRecognizer(this.privRecognizer);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member MeetingTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member MeetingTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * @param {Meeting} meeting - meeting to be recognized
     */ joinMeetingAsync(meeting, cb, err) {
        /* eslint-disable no-console */ // console.log(">> MeetingTranscriber::joinMeetingAsync");
        /* eslint-enable no-console */ const meetingImpl = meeting;
        $3SMEZ.Contracts.throwIfNullOrUndefined($ejSiE.MeetingImpl, "Meeting");
        // ref the meeting object
        // create recognizer and subscribe to recognizer events
        this.privRecognizer = new $hgjD5.TranscriberRecognizer(meeting.config, this.privAudioConfig);
        $3SMEZ.Contracts.throwIfNullOrUndefined(this.privRecognizer, "Recognizer");
        this.privRecognizer.connectMeetingCallbacks(this);
        (0, $5OUhN.marshalPromiseToCallbacks)(meetingImpl.connectTranscriberRecognizer(this.privRecognizer), cb, err);
    }
    /**
     * Starts meeting transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member MeetingTranscriber.prototype.startTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ startTranscribingAsync(cb, err) {
        this.privRecognizer.startContinuousRecognitionAsync(cb, err);
    }
    /**
     * Starts meeting transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member MeetingTranscriber.prototype.stopTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ stopTranscribingAsync(cb, err) {
        this.privRecognizer.stopContinuousRecognitionAsync(cb, err);
    }
    /**
     * Leave the current meeting. After this is called, you will no longer receive any events.
     */ leaveMeetingAsync(cb, err) {
        this.privRecognizer.disconnectCallbacks();
        // eslint-disable-next-line
        (0, $5OUhN.marshalPromiseToCallbacks)((async ()=>{
            return;
        })(), cb, err);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member MeetingTranscriber.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        (0, $5OUhN.marshalPromiseToCallbacks)(this.dispose(true), cb, errorCb);
    }
    /**
     * Disposes any resources held by the object.
     * @member MeetingTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (!!this.privRecognizer) {
            await this.privRecognizer.close();
            this.privRecognizer = undefined;
        }
        if (disposing) this.privDisposedRecognizer = true;
    }
}
module.exports.MeetingTranscriber = $e387ac5ad219ec2a$var$MeetingTranscriber;

});

parcelRegister("eYrkS", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionResult = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Defines result of conversation transcription.
 * @class ConversationTranscriptionResult
 */ class $ae6bdf972d53cf5e$var$ConversationTranscriptionResult extends $gttSn.RecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, speakerId, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties);
        this.privSpeakerId = speakerId;
    }
    /**
     * speaker id
     * @member ConversationTranscriptionResult.prototype.speakerId
     * @function
     * @public
     * @returns {string} id of speaker in given result
     */ get speakerId() {
        return this.privSpeakerId;
    }
}
module.exports.ConversationTranscriptionResult = $ae6bdf972d53cf5e$var$ConversationTranscriptionResult;

});


parcelRegister("ctHGQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisRequest = module.exports.Synthesizer = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
class $915a1568f832bc18$var$Synthesizer {
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {SpeechConfig} speechConfig - The speech config to initialize the synthesizer.
     */ constructor(speechConfig){
        const speechConfigImpl = speechConfig;
        $3SMEZ.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        this.privProperties = speechConfigImpl.properties.clone();
        this.privDisposed = false;
        this.privSynthesizing = false;
        this.synthesisRequestQueue = new $5OUhN.Queue();
        this.tokenCredential = speechConfig.tokenCredential;
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member Synthesizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member Synthesizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * The collection of properties and their values defined for this Synthesizer.
     * @member Synthesizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechSynthesizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Indicates if auto detect source language is enabled
     * @member Synthesizer.prototype.autoDetectSourceLanguage
     * @function
     * @public
     * @returns {boolean} if auto detect source language is enabled
     */ get autoDetectSourceLanguage() {
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages) === $hgjD5.AutoDetectSourceLanguagesOpenRangeOptionName;
    }
    buildSsml(text) {
        const languageToDefaultVoice = {
            ["af-ZA"]: "af-ZA-AdriNeural",
            ["am-ET"]: "am-ET-AmehaNeural",
            ["ar-AE"]: "ar-AE-FatimaNeural",
            ["ar-BH"]: "ar-BH-AliNeural",
            ["ar-DZ"]: "ar-DZ-AminaNeural",
            ["ar-EG"]: "ar-EG-SalmaNeural",
            ["ar-IQ"]: "ar-IQ-BasselNeural",
            ["ar-JO"]: "ar-JO-SanaNeural",
            ["ar-KW"]: "ar-KW-FahedNeural",
            ["ar-LY"]: "ar-LY-ImanNeural",
            ["ar-MA"]: "ar-MA-JamalNeural",
            ["ar-QA"]: "ar-QA-AmalNeural",
            ["ar-SA"]: "ar-SA-HamedNeural",
            ["ar-SY"]: "ar-SY-AmanyNeural",
            ["ar-TN"]: "ar-TN-HediNeural",
            ["ar-YE"]: "ar-YE-MaryamNeural",
            ["bg-BG"]: "bg-BG-BorislavNeural",
            ["bn-BD"]: "bn-BD-NabanitaNeural",
            ["bn-IN"]: "bn-IN-BashkarNeural",
            ["ca-ES"]: "ca-ES-JoanaNeural",
            ["cs-CZ"]: "cs-CZ-AntoninNeural",
            ["cy-GB"]: "cy-GB-AledNeural",
            ["da-DK"]: "da-DK-ChristelNeural",
            ["de-AT"]: "de-AT-IngridNeural",
            ["de-CH"]: "de-CH-JanNeural",
            ["de-DE"]: "de-DE-KatjaNeural",
            ["el-GR"]: "el-GR-AthinaNeural",
            ["en-AU"]: "en-AU-NatashaNeural",
            ["en-CA"]: "en-CA-ClaraNeural",
            ["en-GB"]: "en-GB-LibbyNeural",
            ["en-HK"]: "en-HK-SamNeural",
            ["en-IE"]: "en-IE-ConnorNeural",
            ["en-IN"]: "en-IN-NeerjaNeural",
            ["en-KE"]: "en-KE-AsiliaNeural",
            ["en-NG"]: "en-NG-AbeoNeural",
            ["en-NZ"]: "en-NZ-MitchellNeural",
            ["en-PH"]: "en-PH-JamesNeural",
            ["en-SG"]: "en-SG-LunaNeural",
            ["en-TZ"]: "en-TZ-ElimuNeural",
            ["en-US"]: "en-US-AvaMultilingualNeural",
            ["en-ZA"]: "en-ZA-LeahNeural",
            ["es-AR"]: "es-AR-ElenaNeural",
            ["es-BO"]: "es-BO-MarceloNeural",
            ["es-CL"]: "es-CL-CatalinaNeural",
            ["es-CO"]: "es-CO-GonzaloNeural",
            ["es-CR"]: "es-CR-JuanNeural",
            ["es-CU"]: "es-CU-BelkysNeural",
            ["es-DO"]: "es-DO-EmilioNeural",
            ["es-EC"]: "es-EC-AndreaNeural",
            ["es-ES"]: "es-ES-AlvaroNeural",
            ["es-GQ"]: "es-GQ-JavierNeural",
            ["es-GT"]: "es-GT-AndresNeural",
            ["es-HN"]: "es-HN-CarlosNeural",
            ["es-MX"]: "es-MX-DaliaNeural",
            ["es-NI"]: "es-NI-FedericoNeural",
            ["es-PA"]: "es-PA-MargaritaNeural",
            ["es-PE"]: "es-PE-AlexNeural",
            ["es-PR"]: "es-PR-KarinaNeural",
            ["es-PY"]: "es-PY-MarioNeural",
            ["es-SV"]: "es-SV-LorenaNeural",
            ["es-US"]: "es-US-AlonsoNeural",
            ["es-UY"]: "es-UY-MateoNeural",
            ["es-VE"]: "es-VE-PaolaNeural",
            ["et-EE"]: "et-EE-AnuNeural",
            ["fa-IR"]: "fa-IR-DilaraNeural",
            ["fi-FI"]: "fi-FI-SelmaNeural",
            ["fil-PH"]: "fil-PH-AngeloNeural",
            ["fr-BE"]: "fr-BE-CharlineNeural",
            ["fr-CA"]: "fr-CA-SylvieNeural",
            ["fr-CH"]: "fr-CH-ArianeNeural",
            ["fr-FR"]: "fr-FR-DeniseNeural",
            ["ga-IE"]: "ga-IE-ColmNeural",
            ["gl-ES"]: "gl-ES-RoiNeural",
            ["gu-IN"]: "gu-IN-DhwaniNeural",
            ["he-IL"]: "he-IL-AvriNeural",
            ["hi-IN"]: "hi-IN-MadhurNeural",
            ["hr-HR"]: "hr-HR-GabrijelaNeural",
            ["hu-HU"]: "hu-HU-NoemiNeural",
            ["id-ID"]: "id-ID-ArdiNeural",
            ["is-IS"]: "is-IS-GudrunNeural",
            ["it-IT"]: "it-IT-IsabellaNeural",
            ["ja-JP"]: "ja-JP-NanamiNeural",
            ["jv-ID"]: "jv-ID-DimasNeural",
            ["kk-KZ"]: "kk-KZ-AigulNeural",
            ["km-KH"]: "km-KH-PisethNeural",
            ["kn-IN"]: "kn-IN-GaganNeural",
            ["ko-KR"]: "ko-KR-SunHiNeural",
            ["lo-LA"]: "lo-LA-ChanthavongNeural",
            ["lt-LT"]: "lt-LT-LeonasNeural",
            ["lv-LV"]: "lv-LV-EveritaNeural",
            ["mk-MK"]: "mk-MK-AleksandarNeural",
            ["ml-IN"]: "ml-IN-MidhunNeural",
            ["mr-IN"]: "mr-IN-AarohiNeural",
            ["ms-MY"]: "ms-MY-OsmanNeural",
            ["mt-MT"]: "mt-MT-GraceNeural",
            ["my-MM"]: "my-MM-NilarNeural",
            ["nb-NO"]: "nb-NO-PernilleNeural",
            ["nl-BE"]: "nl-BE-ArnaudNeural",
            ["nl-NL"]: "nl-NL-ColetteNeural",
            ["pl-PL"]: "pl-PL-AgnieszkaNeural",
            ["ps-AF"]: "ps-AF-GulNawazNeural",
            ["pt-BR"]: "pt-BR-FranciscaNeural",
            ["pt-PT"]: "pt-PT-DuarteNeural",
            ["ro-RO"]: "ro-RO-AlinaNeural",
            ["ru-RU"]: "ru-RU-SvetlanaNeural",
            ["si-LK"]: "si-LK-SameeraNeural",
            ["sk-SK"]: "sk-SK-LukasNeural",
            ["sl-SI"]: "sl-SI-PetraNeural",
            ["so-SO"]: "so-SO-MuuseNeural",
            ["sr-RS"]: "sr-RS-NicholasNeural",
            ["su-ID"]: "su-ID-JajangNeural",
            ["sv-SE"]: "sv-SE-SofieNeural",
            ["sw-KE"]: "sw-KE-RafikiNeural",
            ["sw-TZ"]: "sw-TZ-DaudiNeural",
            ["ta-IN"]: "ta-IN-PallaviNeural",
            ["ta-LK"]: "ta-LK-KumarNeural",
            ["ta-SG"]: "ta-SG-AnbuNeural",
            ["te-IN"]: "te-IN-MohanNeural",
            ["th-TH"]: "th-TH-PremwadeeNeural",
            ["tr-TR"]: "tr-TR-AhmetNeural",
            ["uk-UA"]: "uk-UA-OstapNeural",
            ["ur-IN"]: "ur-IN-GulNeural",
            ["ur-PK"]: "ur-PK-AsadNeural",
            ["uz-UZ"]: "uz-UZ-MadinaNeural",
            ["vi-VN"]: "vi-VN-HoaiMyNeural",
            ["zh-CN"]: "zh-CN-XiaoxiaoNeural",
            ["zh-HK"]: "zh-HK-HiuMaanNeural",
            ["zh-TW"]: "zh-TW-HsiaoChenNeural",
            ["zu-ZA"]: "zu-ZA-ThandoNeural"
        };
        let language = this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_SynthLanguage, "en-US");
        let voice = this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_SynthVoice, "");
        let ssml = $915a1568f832bc18$var$Synthesizer.XMLEncode(text);
        if (this.autoDetectSourceLanguage) language = "en-US";
        else voice = voice || languageToDefaultVoice[language];
        if (voice) ssml = `<voice name='${voice}'>${ssml}</voice>`;
        ssml = `<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xmlns:emo='http://www.w3.org/2009/10/emotionml' xml:lang='${language}'>${ssml}</speak>`;
        return ssml;
    }
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Synthesizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ async dispose(disposing) {
        if (this.privDisposed) return;
        if (disposing) {
            if (this.privAdapter) await this.privAdapter.dispose();
        }
        this.privDisposed = true;
    }
    async adapterSpeak() {
        if (!this.privDisposed && !this.privSynthesizing) {
            this.privSynthesizing = true;
            const request = await this.synthesisRequestQueue.dequeue();
            return this.privAdapter.Speak(request.text, request.isSSML, request.requestId, request.cb, request.err, request.dataStream);
        }
    }
    createSynthesizerConfig(speechConfig) {
        return new $hgjD5.SynthesizerConfig(speechConfig, this.privProperties);
    }
    // Does the generic synthesizer setup that is common across all synthesizer types.
    implCommonSynthesizeSetup() {
        let osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        let osName = "unknown";
        let osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        const synthesizerConfig = this.createSynthesizerConfig(new $hgjD5.SpeechServiceConfig(new $hgjD5.Context(new $hgjD5.OS(osPlatform, osName, osVersion))));
        const subscriptionKey = this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceConnection_Key, undefined);
        const authentication = subscriptionKey && subscriptionKey !== "" ? new $hgjD5.CognitiveSubscriptionKeyAuthentication(subscriptionKey) : this.tokenCredential ? new $hgjD5.CognitiveTokenAuthentication(async ()=>{
            try {
                const tokenResponse = await this.tokenCredential.getToken("https://cognitiveservices.azure.com/.default");
                return tokenResponse?.token ?? "";
            } catch (err) {
                throw err;
            }
        }, async ()=>{
            try {
                const tokenResponse = await this.tokenCredential.getToken("https://cognitiveservices.azure.com/.default");
                return tokenResponse?.token ?? "";
            } catch (err) {
                throw err;
            }
        }) : new $hgjD5.CognitiveTokenAuthentication(()=>{
            const authorizationToken = this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, ()=>{
            const authorizationToken = this.privProperties.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        this.privAdapter = this.createSynthesisAdapter(authentication, this.privConnectionFactory, synthesizerConfig);
        this.privRestAdapter = this.createRestSynthesisAdapter(authentication, synthesizerConfig);
    }
    static XMLEncode(text) {
        return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    }
}
module.exports.Synthesizer = $915a1568f832bc18$var$Synthesizer;
class $915a1568f832bc18$var$SynthesisRequest {
    constructor(requestId, text, isSSML, cb, err, dataStream){
        this.requestId = requestId;
        this.text = text;
        this.isSSML = isSSML;
        this.cb = cb;
        this.err = err;
        this.dataStream = dataStream;
    }
}
module.exports.SynthesisRequest = $915a1568f832bc18$var$SynthesisRequest;

});

parcelRegister("khunP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesizer = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $5d2Dz = parcelRequire("5d2Dz");

var $913NY = parcelRequire("913NY");

var $kzV1n = parcelRequire("kzV1n");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");

var $ctHGQ = parcelRequire("ctHGQ");
/**
 * Defines the class SpeechSynthesizer for text to speech.
 * Updated in version 1.16.0
 * @class SpeechSynthesizer
 */ class $ec3cf6ad6a7e6d74$var$SpeechSynthesizer extends $gttSn.Synthesizer {
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer.
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer.
     */ constructor(speechConfig, audioConfig){
        super(speechConfig);
        if (audioConfig !== null) {
            if (audioConfig === undefined) this.audioConfig = typeof window === "undefined" ? undefined : $gttSn.AudioConfig.fromDefaultSpeakerOutput();
            else this.audioConfig = audioConfig;
        }
        this.privConnectionFactory = new $hgjD5.SpeechSynthesisConnectionFactory();
        this.implCommonSynthesizeSetup();
    }
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this synthesizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the synthesizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer
     */ static FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        return new $ec3cf6ad6a7e6d74$var$SpeechSynthesizer(speechConfig, audioConfig);
    }
    /**
     * Executes speech synthesis on plain text.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakTextAsync
     * @function
     * @public
     * @param text - Text to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ speakTextAsync(text, cb, err, stream) {
        this.speakImpl(text, false, cb, err, stream);
    }
    /**
     * Executes speech synthesis on SSML.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakSsmlAsync
     * @function
     * @public
     * @param ssml - SSML to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ speakSsmlAsync(ssml, cb, err, stream) {
        this.speakImpl(ssml, true, cb, err, stream);
    }
    /**
     * Get list of synthesis voices available.
     * The task returns the synthesis voice result.
     * @member SpeechSynthesizer.prototype.getVoicesAsync
     * @function
     * @async
     * @public
     * @param locale - Locale of voices in BCP-47 format; if left empty, get all available voices.
     * @return {Promise<SynthesisVoicesResult>} - Promise of a SynthesisVoicesResult.
     */ async getVoicesAsync(locale = "") {
        return this.getVoices(locale);
    }
    /**
     * Dispose of associated resources.
     * @member SpeechSynthesizer.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposed);
        (0, $5OUhN.marshalPromiseToCallbacks)(this.dispose(true), cb, err);
    }
    /**
     * @Internal
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privAdapter;
    }
    //
    // ################################################################################################################
    // IMPLEMENTATION.
    // ################################################################################################################
    //
    // Creates the synthesis adapter
    createSynthesisAdapter(authentication, connectionFactory, synthesizerConfig) {
        return new $hgjD5.SpeechSynthesisAdapter(authentication, connectionFactory, synthesizerConfig, this, this.audioConfig);
    }
    createRestSynthesisAdapter(authentication, synthesizerConfig) {
        return new $hgjD5.SynthesisRestAdapter(synthesizerConfig, authentication);
    }
    implCommonSynthesizeSetup() {
        super.implCommonSynthesizeSetup();
        this.privAdapter.audioOutputFormat = $913NY.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat($gttSn.SpeechSynthesisOutputFormat[this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)]);
    }
    speakImpl(text, IsSsml, cb, err, dataStream) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privDisposed);
            const requestId = (0, $5OUhN.createNoDashGuid)();
            let audioDestination;
            if (dataStream instanceof $gttSn.PushAudioOutputStreamCallback) audioDestination = new $kzV1n.PushAudioOutputStreamImpl(dataStream);
            else if (dataStream instanceof $gttSn.PullAudioOutputStream) audioDestination = dataStream;
            else if (dataStream !== undefined) audioDestination = new $5d2Dz.AudioFileWriter(dataStream);
            else audioDestination = undefined;
            this.synthesisRequestQueue.enqueue(new $ctHGQ.SynthesisRequest(requestId, text, IsSsml, (e)=>{
                this.privSynthesizing = false;
                if (!!cb) try {
                    cb(e);
                } catch (e) {
                    if (!!err) err(e);
                }
                cb = undefined;
                /* eslint-disable no-empty */ this.adapterSpeak().catch(()=>{});
            }, (e)=>{
                if (!!err) err(e);
            }, audioDestination));
            /* eslint-disable no-empty-function */ this.adapterSpeak().catch(()=>{});
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the synthesizer.
            /* eslint-disable no-empty */ this.dispose(true).catch(()=>{});
        }
    }
    async getVoices(locale) {
        const requestId = (0, $5OUhN.createNoDashGuid)();
        const response = await this.privRestAdapter.getVoicesList(requestId);
        if (response.ok && Array.isArray(response.json)) {
            let json = response.json;
            if (!!locale && locale.length > 0) json = json.filter((item)=>!!item.Locale && item.Locale.toLowerCase() === locale.toLowerCase());
            return new $gttSn.SynthesisVoicesResult(requestId, json, undefined);
        } else return new $gttSn.SynthesisVoicesResult(requestId, undefined, `Error: ${response.status}: ${response.statusText}`);
    }
}
module.exports.SpeechSynthesizer = $ec3cf6ad6a7e6d74$var$SpeechSynthesizer;

});

parcelRegister("jNWUv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisResult = void 0;
/**
 * Base class for synthesis results
 * @class SynthesisResult
 * Added in version 1.20.0
 */ class $e6b04a4660ac0673$var$SynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, errorDetails, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privProperties = properties;
    }
    /**
     * Specifies the result identifier.
     * @member SynthesisResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member SynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * In case of an unsuccessful synthesis, provides details of the occurred error.
     * @member SynthesisResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * The set of properties exposed in the result.
     * @member SynthesisResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
}
module.exports.SynthesisResult = $e6b04a4660ac0673$var$SynthesisResult;

});

parcelRegister("3GDrg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisResult = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Defines result of speech synthesis.
 * @class SpeechSynthesisResult
 * Added in version 1.11.0
 */ class $2af3e307ea2c312c$var$SpeechSynthesisResult extends $gttSn.SynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {ArrayBuffer} audioData - The synthesized audio binary.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     * @param {number} audioDuration - The audio duration.
     */ constructor(resultId, reason, audioData, errorDetails, properties, audioDuration){
        super(resultId, reason, errorDetails, properties);
        this.privAudioData = audioData;
        this.privAudioDuration = audioDuration;
    }
    /**
     * The synthesized audio data
     * @member SpeechSynthesisResult.prototype.audioData
     * @function
     * @public
     * @returns {ArrayBuffer} The synthesized audio data.
     */ get audioData() {
        return this.privAudioData;
    }
    /**
     * The time duration of synthesized audio, in ticks (100 nanoseconds).
     * @member SpeechSynthesisResult.prototype.audioDuration
     * @function
     * @public
     * @returns {number} The time duration of synthesized audio.
     */ get audioDuration() {
        return this.privAudioDuration;
    }
}
module.exports.SpeechSynthesisResult = $2af3e307ea2c312c$var$SpeechSynthesisResult;

});

parcelRegister("jGC6z", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisEventArgs = void 0;
/**
 * Defines contents of speech synthesis events.
 * @class SpeechSynthesisEventArgs
 * Added in version 1.11.0
 */ class $e54f7f67c8a681af$var$SpeechSynthesisEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechSynthesisResult} result - The speech synthesis result.
     */ constructor(result){
        this.privResult = result;
    }
    /**
     * Specifies the synthesis result.
     * @member SpeechSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechSynthesisResult} the synthesis result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.SpeechSynthesisEventArgs = $e54f7f67c8a681af$var$SpeechSynthesisEventArgs;

});

parcelRegister("8UuSQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisWordBoundaryEventArgs = void 0;
/**
 * Defines contents of speech synthesis word boundary event.
 * @class SpeechSynthesisWordBoundaryEventArgs
 * Added in version 1.11.0
 */ class $67cb82814ef60933$var$SpeechSynthesisWordBoundaryEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} duration - The audio duration.
     * @param {string} text - The text.
     * @param {number} wordLength - The length of the word.
     * @param {number} textOffset - The text offset.
     * @param {SpeechSynthesisBoundaryType} boundaryType - The boundary type
     */ constructor(audioOffset, duration, text, wordLength, textOffset, boundaryType){
        this.privAudioOffset = audioOffset;
        this.privDuration = duration;
        this.privText = text;
        this.privWordLength = wordLength;
        this.privTextOffset = textOffset;
        this.privBoundaryType = boundaryType;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the duration, in ticks (100 nanoseconds).
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.duration
     * @function
     * @public
     * @returns {number} Duration in 100 nanosecond increments.
     */ get duration() {
        return this.privDuration;
    }
    /**
     * Specifies the text of the word boundary event.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the text.
     */ get text() {
        return this.privText;
    }
    /**
     * Specifies the word length
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
     * @function
     * @public
     * @returns {number} the word length
     */ get wordLength() {
        return this.privWordLength;
    }
    /**
     * Specifies the text offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
     * @function
     * @public
     * @returns {number} the text offset.
     */ get textOffset() {
        return this.privTextOffset;
    }
    /**
     * Specifies the boundary type.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.boundaryType
     * @function
     * @public
     * @returns {SpeechSynthesisBoundaryType} the boundary type.
     */ get boundaryType() {
        return this.privBoundaryType;
    }
}
module.exports.SpeechSynthesisWordBoundaryEventArgs = $67cb82814ef60933$var$SpeechSynthesisWordBoundaryEventArgs;

});

parcelRegister("ijhvW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisBookmarkEventArgs = void 0;
/**
 * Defines contents of speech synthesis bookmark event.
 * @class SpeechSynthesisBookmarkEventArgs
 * Added in version 1.16.0
 */ class $d547964a41ea1a6d$var$SpeechSynthesisBookmarkEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} text - The bookmark text.
     */ constructor(audioOffset, text){
        this.privAudioOffset = audioOffset;
        this.privText = text;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the bookmark.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the bookmark text.
     */ get text() {
        return this.privText;
    }
}
module.exports.SpeechSynthesisBookmarkEventArgs = $d547964a41ea1a6d$var$SpeechSynthesisBookmarkEventArgs;

});

parcelRegister("7cBsb", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisVisemeEventArgs = void 0;
/**
 * Defines contents of speech synthesis viseme event.
 * @class SpeechSynthesisVisemeEventArgs
 * Added in version 1.16.0
 */ class $53e6b4e82b368f7b$var$SpeechSynthesisVisemeEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} visemeId - The viseme ID.
     * @param {string} animation - The animation, could be in svg or other format.
     */ constructor(audioOffset, visemeId, animation){
        this.privAudioOffset = audioOffset;
        this.privVisemeId = visemeId;
        this.privAnimation = animation;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the viseme ID.
     * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
     * @function
     * @public
     * @returns {number} the viseme ID.
     */ get visemeId() {
        return this.privVisemeId;
    }
    /**
     * Specifies the animation.
     * @member SpeechSynthesisVisemeEventArgs.prototype.animation
     * @function
     * @public
     * @returns {string} the animation, could be in svg or other format.
     */ get animation() {
        return this.privAnimation;
    }
}
module.exports.SpeechSynthesisVisemeEventArgs = $53e6b4e82b368f7b$var$SpeechSynthesisVisemeEventArgs;

});

parcelRegister("jUg6s", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisBoundaryType = void 0;
/**
 * Defines the boundary type of speech synthesis boundary event.
 * @class SpeechSynthesisBoundaryType
 * Added in version 1.21.0
 */ var $e7dfbd0b9d5f9c97$var$SpeechSynthesisBoundaryType;
(function(SpeechSynthesisBoundaryType) {
    /**
     * Indicates the boundary text is a word.
     * @member SpeechSynthesisBoundaryType.Word
     */ SpeechSynthesisBoundaryType["Word"] = "WordBoundary";
    /**
     * Indicates the boundary text is a punctuation.
     * @member SpeechSynthesisBoundaryType.Punctuation
     */ SpeechSynthesisBoundaryType["Punctuation"] = "PunctuationBoundary";
    /**
     * Indicates the boundary text is a sentence.
     * @member SpeechSynthesisBoundaryType.Sentence
     */ SpeechSynthesisBoundaryType["Sentence"] = "SentenceBoundary";
})($e7dfbd0b9d5f9c97$var$SpeechSynthesisBoundaryType = module.exports.SpeechSynthesisBoundaryType || (module.exports.SpeechSynthesisBoundaryType = {}));

});

parcelRegister("8EK5K", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisVoicesResult = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Defines result of speech synthesis.
 * @class SynthesisVoicesResult
 * Added in version 1.20.0
 */ class $64d5d00689caf6bd$var$SynthesisVoicesResult extends $gttSn.SynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param requestId - result id for request.
     * @param json - json payload from endpoint.
     */ constructor(requestId, json, errorDetails){
        if (Array.isArray(json)) {
            super(requestId, $gttSn.ResultReason.VoicesListRetrieved, undefined, new $gttSn.PropertyCollection());
            this.privVoices = [];
            for (const item of json)this.privVoices.push(new $gttSn.VoiceInfo(item));
        } else super(requestId, $gttSn.ResultReason.Canceled, errorDetails ? errorDetails : "Error information unavailable", new $gttSn.PropertyCollection());
    }
    /**
     * The list of voices
     * @member SynthesisVoicesResult.prototype.voices
     * @function
     * @public
     * @returns {VoiceInfo[]} List of synthesized voices.
     */ get voices() {
        return this.privVoices;
    }
}
module.exports.SynthesisVoicesResult = $64d5d00689caf6bd$var$SynthesisVoicesResult;

});

parcelRegister("dDI25", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceInfo = module.exports.SynthesisVoiceType = module.exports.SynthesisVoiceGender = void 0;
/**
 * Defines the gender of synthesis voices.
 * Added in version 1.20.0.
 */ var $9ee112d62df7e855$var$SynthesisVoiceGender;
(function(SynthesisVoiceGender) {
    /** Gender unknown */ SynthesisVoiceGender[SynthesisVoiceGender["Unknown"] = 0] = "Unknown";
    /** Female voice */ SynthesisVoiceGender[SynthesisVoiceGender["Female"] = 1] = "Female";
    /** Male voice */ SynthesisVoiceGender[SynthesisVoiceGender["Male"] = 2] = "Male";
    /** Neutral voice */ SynthesisVoiceGender[SynthesisVoiceGender["Neutral"] = 3] = "Neutral";
})($9ee112d62df7e855$var$SynthesisVoiceGender = module.exports.SynthesisVoiceGender || (module.exports.SynthesisVoiceGender = {}));
var $9ee112d62df7e855$var$SynthesisVoiceType;
(function(SynthesisVoiceType) {
    /**
     * Voice type is not known.
     */ SynthesisVoiceType[SynthesisVoiceType["Unknown"] = 0] = "Unknown";
    /**
     * Online neural voices.
     */ SynthesisVoiceType[SynthesisVoiceType["OnlineNeural"] = 1] = "OnlineNeural";
    /**
     * Online standard voices. These voices are deprecated.
     */ SynthesisVoiceType[SynthesisVoiceType["OnlineStandard"] = 2] = "OnlineStandard";
    /**
     * Offline neural voices.
     */ SynthesisVoiceType[SynthesisVoiceType["OfflineNeural"] = 3] = "OfflineNeural";
    /**
     * Offline standard voices.
     */ SynthesisVoiceType[SynthesisVoiceType["OfflineStandard"] = 4] = "OfflineStandard";
    /**
     * High definition (HD) voices. Refer to https://learn.microsoft.com/azure/ai-services/speech-service/high-definition-voices
     */ SynthesisVoiceType[SynthesisVoiceType["OnlineNeuralHD"] = 5] = "OnlineNeuralHD";
})($9ee112d62df7e855$var$SynthesisVoiceType = module.exports.SynthesisVoiceType || (module.exports.SynthesisVoiceType = {}));
const $9ee112d62df7e855$var$GENDER_LOOKUP = {
    [$9ee112d62df7e855$var$SynthesisVoiceGender[$9ee112d62df7e855$var$SynthesisVoiceGender.Neutral]]: $9ee112d62df7e855$var$SynthesisVoiceGender.Neutral,
    [$9ee112d62df7e855$var$SynthesisVoiceGender[$9ee112d62df7e855$var$SynthesisVoiceGender.Male]]: $9ee112d62df7e855$var$SynthesisVoiceGender.Male,
    [$9ee112d62df7e855$var$SynthesisVoiceGender[$9ee112d62df7e855$var$SynthesisVoiceGender.Female]]: $9ee112d62df7e855$var$SynthesisVoiceGender.Female
};
const $9ee112d62df7e855$var$VOICE_TYPE_LOOKUP = {
    Neural: $9ee112d62df7e855$var$SynthesisVoiceType.OnlineNeural,
    NeuralHD: $9ee112d62df7e855$var$SynthesisVoiceType.OnlineNeuralHD
};
/**
 * Information about Speech Synthesis voice
 * Added in version 1.20.0.
 * @class VoiceInfo
 */ class $9ee112d62df7e855$var$VoiceInfo {
    constructor(json){
        this.privStyleList = [];
        if (!!json) {
            this.privName = json.Name;
            this.privLocale = json.Locale;
            this.privShortName = json.ShortName;
            this.privLocaleName = json.LocaleName;
            this.privDisplayName = json.DisplayName;
            this.privLocalName = json.LocalName;
            this.privVoiceType = $9ee112d62df7e855$var$VOICE_TYPE_LOOKUP[json.VoiceType] || $9ee112d62df7e855$var$SynthesisVoiceType.Unknown;
            this.privGender = $9ee112d62df7e855$var$GENDER_LOOKUP[json.Gender] || $9ee112d62df7e855$var$SynthesisVoiceGender.Unknown;
            if (!!json.StyleList && Array.isArray(json.StyleList)) for (const style of json.StyleList)this.privStyleList.push(style);
            this.privSampleRateHertz = json.SampleRateHertz;
            this.privStatus = json.Status;
            if (json.ExtendedPropertyMap) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privExtendedPropertyMap = json.ExtendedPropertyMap;
            this.privWordsPerMinute = json.WordsPerMinute;
            if (Array.isArray(json.SecondaryLocaleList)) this.privSecondaryLocaleList = [
                ...json.SecondaryLocaleList
            ];
            if (Array.isArray(json.RolePlayList)) this.privRolePlayList = [
                ...json.RolePlayList
            ];
            if (json.VoiceTag) this.privVoiceTag = json.VoiceTag;
        }
    }
    get name() {
        return this.privName;
    }
    get locale() {
        return this.privLocale;
    }
    get shortName() {
        return this.privShortName;
    }
    get displayName() {
        return this.privDisplayName;
    }
    get localName() {
        return this.privLocalName;
    }
    get localeName() {
        return this.privLocaleName;
    }
    get gender() {
        return this.privGender;
    }
    get voiceType() {
        return this.privVoiceType;
    }
    get styleList() {
        return this.privStyleList;
    }
    get sampleRateHertz() {
        return this.privSampleRateHertz;
    }
    get status() {
        return this.privStatus;
    }
    get extendedPropertyMap() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.privExtendedPropertyMap;
    }
    get wordsPerMinute() {
        return this.privWordsPerMinute;
    }
    get secondaryLocaleList() {
        return this.privSecondaryLocaleList;
    }
    get rolePlayList() {
        return this.privRolePlayList;
    }
    get voiceTag() {
        return this.privVoiceTag;
    }
}
module.exports.VoiceInfo = $9ee112d62df7e855$var$VoiceInfo;

});

parcelRegister("3RAj2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerAudioDestination = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $kzV1n = parcelRequire("kzV1n");

var $hzVTX = parcelRequire("hzVTX");
const $2d027bf4788f0616$var$MediaDurationPlaceholderSeconds = 1800;
const $2d027bf4788f0616$var$AudioFormatToMimeType = {
    [$hzVTX.AudioFormatTag.PCM]: "audio/wav",
    [$hzVTX.AudioFormatTag.MuLaw]: "audio/x-wav",
    [$hzVTX.AudioFormatTag.MP3]: "audio/mpeg",
    [$hzVTX.AudioFormatTag.OGG_OPUS]: "audio/ogg",
    [$hzVTX.AudioFormatTag.WEBM_OPUS]: "audio/webm; codecs=opus",
    [$hzVTX.AudioFormatTag.ALaw]: "audio/x-wav",
    [$hzVTX.AudioFormatTag.FLAC]: "audio/flac",
    [$hzVTX.AudioFormatTag.AMR_WB]: "audio/amr-wb",
    [$hzVTX.AudioFormatTag.G722]: "audio/G722"
};
/**
 * Represents the speaker playback audio destination, which only works in browser.
 * Note: the SDK will try to use <a href="https://www.w3.org/TR/media-source/">Media Source Extensions</a> to play audio.
 * Mp3 format has better supports on Microsoft Edge, Chrome and Safari (desktop), so, it's better to specify mp3 format for playback.
 * @class SpeakerAudioDestination
 * Updated in version 1.17.0
 */ class $2d027bf4788f0616$var$SpeakerAudioDestination {
    constructor(audioDestinationId){
        this.privPlaybackStarted = false;
        this.privAppendingToBuffer = false;
        this.privMediaSourceOpened = false;
        this.privBytesReceived = 0;
        this.privId = audioDestinationId ? audioDestinationId : (0, $5OUhN.createNoDashGuid)();
        this.privIsPaused = false;
        this.privIsClosed = false;
    }
    id() {
        return this.privId;
    }
    write(buffer, cb, err) {
        if (this.privAudioBuffer !== undefined) {
            this.privAudioBuffer.push(buffer);
            this.updateSourceBuffer().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        } else if (this.privAudioOutputStream !== undefined) {
            this.privAudioOutputStream.write(buffer);
            this.privBytesReceived += buffer.byteLength;
        }
    }
    close(cb, err) {
        this.privIsClosed = true;
        if (this.privSourceBuffer !== undefined) this.handleSourceBufferUpdateEnd().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
        else if (this.privAudioOutputStream !== undefined && typeof window !== "undefined") {
            if ((this.privFormat.formatTag === $hzVTX.AudioFormatTag.PCM || this.privFormat.formatTag === $hzVTX.AudioFormatTag.MuLaw || this.privFormat.formatTag === $hzVTX.AudioFormatTag.ALaw) && this.privFormat.hasHeader === false) {
                // eslint-disable-next-line no-console
                console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header.");
                if (!!this.onAudioEnd) this.onAudioEnd(this);
            } else {
                let receivedAudio = new ArrayBuffer(this.privBytesReceived);
                this.privAudioOutputStream.read(receivedAudio).then(()=>{
                    receivedAudio = this.privFormat.addHeader(receivedAudio);
                    const audioBlob = new Blob([
                        receivedAudio
                    ], {
                        type: $2d027bf4788f0616$var$AudioFormatToMimeType[this.privFormat.formatTag]
                    });
                    this.privAudio.src = window.URL.createObjectURL(audioBlob);
                    this.notifyPlayback().then(()=>{
                        if (!!cb) cb();
                    }, (error)=>{
                        if (!!err) err(error);
                    });
                }, (error)=>{
                    if (!!err) err(error);
                });
            }
        } else // unsupported format, call onAudioEnd directly.
        if (!!this.onAudioEnd) this.onAudioEnd(this);
    }
    set format(format) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (typeof AudioContext !== "undefined" || typeof window !== "undefined" && typeof window.webkitAudioContext !== "undefined") {
            this.privFormat = format;
            const mimeType = $2d027bf4788f0616$var$AudioFormatToMimeType[this.privFormat.formatTag];
            if (mimeType === undefined) // eslint-disable-next-line no-console
            console.warn(`Unknown mimeType for format ${$hzVTX.AudioFormatTag[this.privFormat.formatTag]}; playback is not supported.`);
            else if (typeof MediaSource !== "undefined" && MediaSource.isTypeSupported(mimeType)) {
                this.privAudio = new Audio();
                this.privAudioBuffer = [];
                this.privMediaSource = new MediaSource();
                this.privAudio.src = URL.createObjectURL(this.privMediaSource);
                this.privAudio.load();
                this.privMediaSource.onsourceopen = ()=>{
                    this.privMediaSourceOpened = true;
                    this.privMediaSource.duration = $2d027bf4788f0616$var$MediaDurationPlaceholderSeconds;
                    this.privSourceBuffer = this.privMediaSource.addSourceBuffer(mimeType);
                    this.privSourceBuffer.onupdate = ()=>{
                        this.updateSourceBuffer().catch((reason)=>{
                            $5OUhN.Events.instance.onEvent(new $5OUhN.BackgroundEvent(reason));
                        });
                    };
                    this.privSourceBuffer.onupdateend = ()=>{
                        this.handleSourceBufferUpdateEnd().catch((reason)=>{
                            $5OUhN.Events.instance.onEvent(new $5OUhN.BackgroundEvent(reason));
                        });
                    };
                    this.privSourceBuffer.onupdatestart = ()=>{
                        this.privAppendingToBuffer = false;
                    };
                };
                this.updateSourceBuffer().catch((reason)=>{
                    $5OUhN.Events.instance.onEvent(new $5OUhN.BackgroundEvent(reason));
                });
            } else {
                // eslint-disable-next-line no-console
                console.warn(`Format ${$hzVTX.AudioFormatTag[this.privFormat.formatTag]} could not be played by MSE, streaming playback is not enabled.`);
                this.privAudioOutputStream = new $kzV1n.PullAudioOutputStreamImpl();
                this.privAudioOutputStream.format = this.privFormat;
                this.privAudio = new Audio();
            }
        }
    }
    get volume() {
        return this.privAudio?.volume ?? -1;
    }
    set volume(volume) {
        if (!!this.privAudio) this.privAudio.volume = volume;
    }
    mute() {
        if (!!this.privAudio) this.privAudio.muted = true;
    }
    unmute() {
        if (!!this.privAudio) this.privAudio.muted = false;
    }
    get isClosed() {
        return this.privIsClosed;
    }
    get currentTime() {
        if (this.privAudio !== undefined) return this.privAudio.currentTime;
        return -1;
    }
    pause() {
        if (!this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.pause();
            this.privIsPaused = true;
        }
    }
    resume(cb, err) {
        if (this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.play().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
            this.privIsPaused = false;
        }
    }
    get internalAudio() {
        return this.privAudio;
    }
    async updateSourceBuffer() {
        if (this.privAudioBuffer !== undefined && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
            this.privAppendingToBuffer = true;
            const binary = this.privAudioBuffer.shift();
            try {
                this.privSourceBuffer.appendBuffer(binary);
            } catch (error) {
                this.privAudioBuffer.unshift(binary);
                // eslint-disable-next-line no-console
                console.log("buffer filled, pausing addition of binaries until space is made");
                return;
            }
            await this.notifyPlayback();
        } else if (this.canEndStream()) await this.handleSourceBufferUpdateEnd();
    }
    async handleSourceBufferUpdateEnd() {
        if (this.canEndStream() && this.sourceBufferAvailable()) {
            this.privMediaSource.endOfStream();
            await this.notifyPlayback();
        }
    }
    async notifyPlayback() {
        if (!this.privPlaybackStarted && this.privAudio !== undefined) {
            this.privPlaybackStarted = true;
            if (!!this.onAudioStart) this.onAudioStart(this);
            this.privAudio.onended = ()=>{
                if (!!this.onAudioEnd) this.onAudioEnd(this);
            };
            if (!this.privIsPaused) await this.privAudio.play();
        }
    }
    canEndStream() {
        return this.isClosed && this.privSourceBuffer !== undefined && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    }
    sourceBufferAvailable() {
        return this.privSourceBuffer !== undefined && !this.privSourceBuffer.updating;
    }
}
module.exports.SpeakerAudioDestination = $2d027bf4788f0616$var$SpeakerAudioDestination;

});

parcelRegister("jftUp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionCanceledEventArgs = void 0;

var $g5epc = parcelRequire("g5epc");
/**
 * Defines content of a RecognitionErrorEvent.
 * @class ConversationTranscriptionCanceledEventArgs
 */ class $e0369e486914fb0c$var$ConversationTranscriptionCanceledEventArgs extends $g5epc.CancellationEventArgsBase {
}
module.exports.ConversationTranscriptionCanceledEventArgs = $e0369e486914fb0c$var$ConversationTranscriptionCanceledEventArgs;

});

parcelRegister("2bzvy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriptionCanceledEventArgs = void 0;

var $g5epc = parcelRequire("g5epc");
/**
 * Defines content of a MeetingTranscriptionCanceledEvent.
 * @class MeetingTranscriptionCanceledEventArgs
 */ class $19782701f9100c9a$var$MeetingTranscriptionCanceledEventArgs extends $g5epc.CancellationEventArgsBase {
}
module.exports.MeetingTranscriptionCanceledEventArgs = $19782701f9100c9a$var$MeetingTranscriptionCanceledEventArgs;

});

parcelRegister("hfhIk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentGradingSystem = void 0;
/**
 * Defines the point system for pronunciation score calibration; default value is FivePoint.
 * Added in version 1.15.0
 * @class PronunciationAssessmentGradingSystem
 */ var $c8e193ff707960ee$var$PronunciationAssessmentGradingSystem;
(function(PronunciationAssessmentGradingSystem) {
    /**
     * Five point calibration
     * @member PronunciationAssessmentGradingSystem.FivePoint
     */ PronunciationAssessmentGradingSystem[PronunciationAssessmentGradingSystem["FivePoint"] = 1] = "FivePoint";
    /**
     * Hundred mark
     * @member PronunciationAssessmentGradingSystem.HundredMark
     */ PronunciationAssessmentGradingSystem[PronunciationAssessmentGradingSystem["HundredMark"] = 2] = "HundredMark";
})($c8e193ff707960ee$var$PronunciationAssessmentGradingSystem = module.exports.PronunciationAssessmentGradingSystem || (module.exports.PronunciationAssessmentGradingSystem = {}));

});

parcelRegister("2bYA3", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentGranularity = void 0;
/**
 * Defines the pronunciation evaluation granularity; default value is Phoneme.
 * Added in version 1.15.0
 * @class PronunciationAssessmentGranularity
 */ var $198b99e14d2ee257$var$PronunciationAssessmentGranularity;
(function(PronunciationAssessmentGranularity) {
    /**
     * Shows the score on the full text, word and phoneme level
     * @member PronunciationAssessmentGranularity.Phoneme
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["Phoneme"] = 1] = "Phoneme";
    /**
     * Shows the score on the full text and word level
     * @member PronunciationAssessmentGranularity.Word
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["Word"] = 2] = "Word";
    /**
     * Shows the score on the full text level only
     * @member PronunciationAssessmentGranularity.FullText
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["FullText"] = 3] = "FullText";
})($198b99e14d2ee257$var$PronunciationAssessmentGranularity = module.exports.PronunciationAssessmentGranularity || (module.exports.PronunciationAssessmentGranularity = {}));

});

parcelRegister("93Snx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentConfig = void 0;

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
/**
 * Pronunciation assessment configuration.
 * @class PronunciationAssessmentConfig
 * Added in version 1.15.0.
 */ class $698e93581d604e91$var$PronunciationAssessmentConfig {
    /**
     * PronunciationAssessmentConfig constructor.
     * @constructor
     * @param {string} referenceText
     * @param gradingSystem
     * @param granularity
     * @param enableMiscue
     */ constructor(referenceText, gradingSystem = $gttSn.PronunciationAssessmentGradingSystem.FivePoint, granularity = $gttSn.PronunciationAssessmentGranularity.Phoneme, enableMiscue = false){
        $3SMEZ.Contracts.throwIfNullOrUndefined(referenceText, "referenceText");
        this.privProperties = new $gttSn.PropertyCollection();
        this.privProperties.setProperty($gttSn.PropertyId.PronunciationAssessment_ReferenceText, referenceText);
        this.privProperties.setProperty($gttSn.PropertyId.PronunciationAssessment_GradingSystem, $gttSn.PronunciationAssessmentGradingSystem[gradingSystem]);
        this.privProperties.setProperty($gttSn.PropertyId.PronunciationAssessment_Granularity, $gttSn.PronunciationAssessmentGranularity[granularity]);
        this.privProperties.setProperty($gttSn.PropertyId.PronunciationAssessment_EnableMiscue, String(enableMiscue));
    }
    /**
     * @member PronunciationAssessmentConfig.fromJSON
     * @function
     * @public
     * @param {string} json The json string containing the pronunciation assessment parameters.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentConfig from json.
     * This method is designed to support the pronunciation assessment parameters still in preview.
     * Under normal circumstances, use the constructor instead.
     */ static fromJSON(json) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(json, "json");
        const config = new $698e93581d604e91$var$PronunciationAssessmentConfig("");
        config.privProperties = new $gttSn.PropertyCollection();
        config.properties.setProperty($gttSn.PropertyId.PronunciationAssessment_Json, json);
        return config;
    }
    toJSON() {
        this.updateJson();
        return this.privProperties.getProperty($gttSn.PropertyId.PronunciationAssessment_Params);
    }
    applyTo(recognizer) {
        this.updateJson();
        const recoBase = recognizer.internalData;
        recoBase.speechContext.setPronunciationAssessmentParams(this.properties.getProperty($gttSn.PropertyId.PronunciationAssessment_Params), recoBase.isSpeakerDiarizationEnabled);
    }
    /**
     * Gets the reference text.
     * @member PronunciationAssessmentConfig.prototype.referenceText
     * @function
     * @public
     * @returns {string} Reference text.
     */ get referenceText() {
        return this.properties.getProperty($gttSn.PropertyId.PronunciationAssessment_ReferenceText);
    }
    /**
     * Gets/Sets the reference text.
     * @member PronunciationAssessmentConfig.prototype.referenceText
     * @function
     * @public
     * @param {string} referenceText - Reference text.
     */ set referenceText(referenceText) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(referenceText, "referenceText");
        this.properties.setProperty($gttSn.PropertyId.PronunciationAssessment_ReferenceText, referenceText);
    }
    /**
     * Sets the phoneme alphabet.
     * The valid values are "SAPI" (default) and "IPA".
     * Added in version 1.20.0
     * @member PronunciationAssessmentConfig.prototype.phonemeAlphabet
     * @function
     * @public
     * @param {string} phonemeAlphabet - Phoneme alphabet.
     */ set phonemeAlphabet(phonemeAlphabet) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(phonemeAlphabet, "phonemeAlphabet");
        this.privPhonemeAlphabet = phonemeAlphabet;
    }
    /**
     * Sets the boolean enableMiscue property.
     * Added in version 1.26.0
     * @member PronunciationAssessmentConfig.prototype.enableMiscue
     * @function
     * @public
     * @param {boolean} enableMiscue - enable miscue.
     */ set enableMiscue(enableMiscue) {
        const enableMiscueString = enableMiscue ? "true" : "false";
        this.properties.setProperty($gttSn.PropertyId.PronunciationAssessment_EnableMiscue, enableMiscueString);
    }
    /**
     * Gets the boolean enableMiscue property.
     * Added in version 1.26.0
     * @member PronunciationAssessmentConfig.prototype.enableMiscue
     * @function
     * @public
     * @return {boolean} enableMiscue - enable miscue.
     */ get enableMiscue() {
        const enableMiscueString = this.properties.getProperty($gttSn.PropertyId.PronunciationAssessment_EnableMiscue, "false");
        return enableMiscueString.toLowerCase() === "true";
    }
    /**
     * Sets the nbest phoneme count
     * Added in version 1.20.0
     * @member PronunciationAssessmentConfig.prototype.nbestPhonemeCount
     * @function
     * @public
     * @param {number} nbestPhonemeCount - NBest phoneme count.
     */ set nbestPhonemeCount(nbestPhonemeCount) {
        this.privNBestPhonemeCount = nbestPhonemeCount;
    }
    /**
     * Enables the prosody assessment.
     * Added in version 1.34.0
     * @member PronunciationAssessmentConfig.prototype.enableProsodyAssessment
     * @function
     * @public
     * @param {boolean} enableProsodyAssessment - enable prosody assessment.
     */ set enableProsodyAssessment(enableProsodyAssessment) {
        this.privEnableProsodyAssessment = enableProsodyAssessment;
    }
    /**
     * @member PronunciationAssessmentConfig.prototype.properties
     * @function
     * @public
     * @return {PropertyCollection} Properties of the config.
     * @summary Gets a pronunciation assessment config properties
     */ get properties() {
        return this.privProperties;
    }
    updateJson() {
        const jsonString = this.privProperties.getProperty($gttSn.PropertyId.PronunciationAssessment_Json, "{}");
        const paramsJson = JSON.parse(jsonString);
        const referenceText = this.privProperties.getProperty($gttSn.PropertyId.PronunciationAssessment_ReferenceText);
        if (referenceText) paramsJson.referenceText = referenceText;
        const gradingSystem = this.privProperties.getProperty($gttSn.PropertyId.PronunciationAssessment_GradingSystem);
        if (gradingSystem) paramsJson.gradingSystem = gradingSystem;
        const granularity = this.privProperties.getProperty($gttSn.PropertyId.PronunciationAssessment_Granularity);
        if (granularity) paramsJson.granularity = granularity;
        if (this.privPhonemeAlphabet) paramsJson.phonemeAlphabet = this.privPhonemeAlphabet;
        if (this.privNBestPhonemeCount) paramsJson.nbestPhonemeCount = this.privNBestPhonemeCount;
        paramsJson.enableProsodyAssessment = this.privEnableProsodyAssessment;
        // always set dimension to Comprehensive
        paramsJson.dimension = "Comprehensive";
        const enableMiscueString = this.privProperties.getProperty($gttSn.PropertyId.PronunciationAssessment_EnableMiscue);
        if (enableMiscueString) paramsJson.enableMiscue = this.enableMiscue;
        this.privProperties.setProperty($gttSn.PropertyId.PronunciationAssessment_Params, JSON.stringify(paramsJson));
    }
}
module.exports.PronunciationAssessmentConfig = $698e93581d604e91$var$PronunciationAssessmentConfig;

});

parcelRegister("ay2D3", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentResult = void 0;

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
/**
 * Pronunciation assessment results.
 * @class PronunciationAssessmentResult
 * Added in version 1.15.0.
 */ class $7adf1e6e003a07a5$var$PronunciationAssessmentResult {
    constructor(jsonString){
        const j = JSON.parse(jsonString);
        $3SMEZ.Contracts.throwIfNullOrUndefined(j.NBest[0], "NBest");
        this.privPronJson = j.NBest[0];
    }
    /**
     * @member PronunciationAssessmentResult.fromResult
     * @function
     * @public
     * @param {RecognitionResult} result The recognition result.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentResult from recognition result.
     */ static fromResult(result) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(result, "result");
        const json = result.properties.getProperty($gttSn.PropertyId.SpeechServiceResponse_JsonResult);
        $3SMEZ.Contracts.throwIfNullOrUndefined(json, "json");
        return new $7adf1e6e003a07a5$var$PronunciationAssessmentResult(json);
    }
    /**
     * Gets the detail result of pronunciation assessment.
     * @member PronunciationAssessmentConfig.prototype.detailResult
     * @function
     * @public
     * @returns {DetailResult} detail result.
     */ get detailResult() {
        return this.privPronJson;
    }
    /**
     * The score indicating the pronunciation accuracy of the given speech, which indicates
     * how closely the phonemes match a native speaker's pronunciation.
     * @member PronunciationAssessmentResult.prototype.accuracyScore
     * @function
     * @public
     * @returns {number} Accuracy score.
     */ get accuracyScore() {
        return this.detailResult.PronunciationAssessment?.AccuracyScore;
    }
    /**
     * The overall score indicating the pronunciation quality of the given speech.
     * This is calculated from AccuracyScore, FluencyScore and CompletenessScore with weight.
     * @member PronunciationAssessmentResult.prototype.pronunciationScore
     * @function
     * @public
     * @returns {number} Pronunciation score.
     */ get pronunciationScore() {
        return this.detailResult.PronunciationAssessment?.PronScore;
    }
    /**
     * The score indicating the completeness of the given speech by calculating the ratio of pronounced words towards entire input.
     * @member PronunciationAssessmentResult.prototype.completenessScore
     * @function
     * @public
     * @returns {number} Completeness score.
     */ get completenessScore() {
        return this.detailResult.PronunciationAssessment?.CompletenessScore;
    }
    /**
     * The score indicating the fluency of the given speech.
     * @member PronunciationAssessmentResult.prototype.fluencyScore
     * @function
     * @public
     * @returns {number} Fluency score.
     */ get fluencyScore() {
        return this.detailResult.PronunciationAssessment?.FluencyScore;
    }
    /**
     * The prosody score, which indicates how nature of the given speech, including stress, intonation, speaking speed and rhythm.
     * @member PronunciationAssessmentResult.prototype.prosodyScore
     * @function
     * @public
     * @returns {number} Prosody score.
     */ get prosodyScore() {
        return this.detailResult.PronunciationAssessment?.ProsodyScore;
    }
}
module.exports.PronunciationAssessmentResult = $7adf1e6e003a07a5$var$PronunciationAssessmentResult;

});

parcelRegister("dnZrT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarConfig = void 0;

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");
/**
 * Defines the talking avatar configuration.
 * @class AvatarConfig
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change or have limited support.
 */ class $9bed16d64af4c68a$var$AvatarConfig {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} character - The avatar character.
     * @param {string} style - The avatar style.
     * @param {AvatarVideoFormat} videoFormat - The talking avatar output video format.
     */ constructor(character, style, videoFormat){
        this.privCustomized = false;
        this.privUseBuiltInVoice = false;
        $3SMEZ.Contracts.throwIfNullOrWhitespace(character, "character");
        this.character = character;
        this.style = style;
        if (videoFormat === undefined) videoFormat = new $gttSn.AvatarVideoFormat();
        this.videoFormat = videoFormat;
    }
    /**
     * Indicates if the talking avatar is customized.
     */ get customized() {
        return this.privCustomized;
    }
    /**
     * Sets if the talking avatar is customized.
     */ set customized(value) {
        this.privCustomized = value;
    }
    /**
     * Indicates whether to use built-in voice for custom avatar.
     */ get useBuiltInVoice() {
        return this.privUseBuiltInVoice;
    }
    /**
     * Sets whether to use built-in voice for custom avatar.
     */ set useBuiltInVoice(value) {
        this.privUseBuiltInVoice = value;
    }
    /**
     * Gets the photo avatar base model name.
     */ get photoAvatarBaseModel() {
        return this.privPhotoAvatarBaseModel;
    }
    /**
     * Sets the photo avatar base model name.
     */ set photoAvatarBaseModel(value) {
        this.privPhotoAvatarBaseModel = value;
    }
    /**
     * Gets the background color.
     */ get backgroundColor() {
        return this.privBackgroundColor;
    }
    /**
     * Sets the background color.
     */ set backgroundColor(value) {
        this.privBackgroundColor = value;
    }
    /**
     * Gets the background image.
     */ get backgroundImage() {
        return this.privBackgroundImage;
    }
    /**
     * Sets the background image.
     * @param {URL} value - The background image.
     */ set backgroundImage(value) {
        this.privBackgroundImage = value;
    }
    /**
     * Gets the remote ICE servers.
     * @remarks This method is designed to be used internally in the SDK.
     * @returns {RTCIceServer[]} The remote ICE servers.
     */ get remoteIceServers() {
        return this.privRemoteIceServers;
    }
    /**
     * Sets the remote ICE servers.
     * @remarks Normally, the ICE servers are gathered from the PeerConnection,
     * set this property to override the ICE servers. E.g., the ICE servers are
     * different in client and server side.
     * @param {RTCIceServer[]} value - The remote ICE servers.
     */ set remoteIceServers(value) {
        this.privRemoteIceServers = value;
    }
}
module.exports.AvatarConfig = $9bed16d64af4c68a$var$AvatarConfig;

});

parcelRegister("3c1Tt", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarEventArgs = module.exports.AvatarEventTypes = void 0;
var $2533f6236fce4d3a$var$AvatarEventTypes;
(function(AvatarEventTypes) {
    AvatarEventTypes["SwitchedToSpeaking"] = "SwitchedToSpeaking";
    AvatarEventTypes["SwitchedToIdle"] = "SwitchedToIdle";
    AvatarEventTypes["SessionClosed"] = "SessionClosed";
})($2533f6236fce4d3a$var$AvatarEventTypes = module.exports.AvatarEventTypes || (module.exports.AvatarEventTypes = {}));
/**
 * Defines content for talking avatar events.
 * @class AvatarEventArgs
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change or have limited support.
 */ class $2533f6236fce4d3a$var$AvatarEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} description - The description of the event.
     */ constructor(audioOffset, description){
        this.privOffset = audioOffset;
        this.privDescription = description;
    }
    /**
     * The type of the event.
     * @public
     * @returns {AvatarEventTypes} The type of the event.
     */ get type() {
        return this.privType;
    }
    /**
     * The time offset associated with this event.
     * @public
     * @returns {number} The time offset associated with this event.
     */ get offset() {
        return this.privOffset;
    }
    /**
     * The description of the event.
     * @public
     * @returns {string} The description of the event.
     */ get description() {
        return this.privDescription;
    }
}
module.exports.AvatarEventArgs = $2533f6236fce4d3a$var$AvatarEventArgs;

});

parcelRegister("78veo", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarSynthesizer = void 0;

var $2Fj9D = parcelRequire("2Fj9D");

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $913NY = parcelRequire("913NY");

var $gttSn = parcelRequire("gttSn");

var $3SMEZ = parcelRequire("3SMEZ");

var $ctHGQ = parcelRequire("ctHGQ");
/**
 * Defines the avatar synthesizer.
 * @class AvatarSynthesizer
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change or have limited support.
 */ class $5321819a3bd15546$var$AvatarSynthesizer extends $gttSn.Synthesizer {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechConfig} speechConfig - The speech config.
     * @param {AvatarConfig} avatarConfig - The talking avatar config.
     */ constructor(speechConfig, avatarConfig){
        super(speechConfig);
        $3SMEZ.Contracts.throwIfNullOrUndefined(avatarConfig, "avatarConfig");
        this.privConnectionFactory = new $2Fj9D.SpeechSynthesisConnectionFactory();
        this.privAvatarConfig = avatarConfig;
        this.implCommonSynthesizeSetup();
    }
    implCommonSynthesizeSetup() {
        super.implCommonSynthesizeSetup();
        // The service checks the audio format setting while it ignores it in avatar synthesis.
        this.privAdapter.audioOutputFormat = $913NY.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat($gttSn.SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm);
    }
    /**
     * Starts the talking avatar session and establishes the WebRTC connection.
     * @member AvatarSynthesizer.prototype.startAvatarAsync
     * @function
     * @public
     * @param {AvatarWebRTCConnectionInfo} peerConnection - The peer connection.
     * @returns {Promise<SynthesisResult>} The promise of the connection result.
     */ async startAvatarAsync(peerConnection) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(peerConnection, "peerConnection");
        this.privIceServers = peerConnection.getConfiguration().iceServers;
        $3SMEZ.Contracts.throwIfNullOrUndefined(this.privIceServers, "Ice servers must be set.");
        const iceGatheringDone = new $5OUhN.Deferred();
        // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/icegatheringstatechange_event
        peerConnection.onicegatheringstatechange = ()=>{
            $5OUhN.Events.instance.onEvent(new $5OUhN.PlatformEvent("peer connection: ice gathering state: " + peerConnection.iceGatheringState, $5OUhN.EventType.Debug));
            if (peerConnection.iceGatheringState === "complete") {
                $5OUhN.Events.instance.onEvent(new $5OUhN.PlatformEvent("peer connection: ice gathering complete.", $5OUhN.EventType.Info));
                iceGatheringDone.resolve();
            }
        };
        peerConnection.onicecandidate = (event)=>{
            if (event.candidate) $5OUhN.Events.instance.onEvent(new $5OUhN.PlatformEvent("peer connection: ice candidate: " + event.candidate.candidate, $5OUhN.EventType.Debug));
            else {
                $5OUhN.Events.instance.onEvent(new $5OUhN.PlatformEvent("peer connection: ice candidate: complete", $5OUhN.EventType.Debug));
                iceGatheringDone.resolve();
            }
        };
        // Set a timeout for ice gathering, currently 2 seconds.
        setTimeout(()=>{
            if (peerConnection.iceGatheringState !== "complete") {
                $5OUhN.Events.instance.onEvent(new $5OUhN.PlatformEvent("peer connection: ice gathering timeout.", $5OUhN.EventType.Warning));
                iceGatheringDone.resolve();
            }
        }, 2000);
        const sdp = await peerConnection.createOffer();
        await peerConnection.setLocalDescription(sdp);
        await iceGatheringDone.promise;
        $5OUhN.Events.instance.onEvent(new $5OUhN.PlatformEvent("peer connection: got local SDP.", $5OUhN.EventType.Info));
        this.privProperties.setProperty($gttSn.PropertyId.TalkingAvatarService_WebRTC_SDP, JSON.stringify(peerConnection.localDescription));
        const result = await this.speak("", false);
        if (result.reason !== $gttSn.ResultReason.SynthesizingAudioCompleted) return new $gttSn.SynthesisResult(result.resultId, result.reason, result.errorDetails, result.properties);
        const sdpAnswerString = atob(result.properties.getProperty($gttSn.PropertyId.TalkingAvatarService_WebRTC_SDP));
        const sdpAnswer = new RTCSessionDescription(JSON.parse(sdpAnswerString));
        await peerConnection.setRemoteDescription(sdpAnswer);
        return new $gttSn.SynthesisResult(result.resultId, result.reason, undefined, result.properties);
    }
    /**
     * Speaks plain text asynchronously. The rendered audio and video will be sent via the WebRTC connection.
     * @member AvatarSynthesizer.prototype.speakTextAsync
     * @function
     * @public
     * @param {string} text - The plain text to speak.
     * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
     */ async speakTextAsync(text) {
        const r = await this.speak(text, false);
        return new $gttSn.SynthesisResult(r.resultId, r.reason, r.errorDetails, r.properties);
    }
    /**
     * Speaks SSML asynchronously. The rendered audio and video will be sent via the WebRTC connection.
     * @member AvatarSynthesizer.prototype.speakSsmlAsync
     * @function
     * @public
     * @param {string} ssml - The SSML text to speak.
     * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
     */ async speakSsmlAsync(ssml) {
        const r = await this.speak(ssml, true);
        return new $gttSn.SynthesisResult(r.resultId, r.reason, r.errorDetails, r.properties);
    }
    /**
     * Speaks text asynchronously. The avatar will switch to idle state.
     * @member AvatarSynthesizer.prototype.stopSpeakingAsync
     * @function
     * @public
     * @returns {Promise<void>} The promise of the void result.
     */ async stopSpeakingAsync() {
        while(this.synthesisRequestQueue.length() > 0){
            const request = await this.synthesisRequestQueue.dequeue();
            request.err("Synthesis is canceled by user.");
        }
        return this.privAdapter.stopSpeaking();
    }
    /**
     * Stops the talking avatar session and closes the WebRTC connection.
     * For now, this is the same as close().
     * You need to create a new AvatarSynthesizer instance to start a new session.
     * @member AvatarSynthesizer.prototype.stopAvatarAsync
     * @function
     * @public
     * @returns {Promise<void>} The promise of the void result.
     */ async stopAvatarAsync() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposed);
        return this.dispose(true);
    }
    /**
     * Dispose of associated resources.
     * @member AvatarSynthesizer.prototype.close
     * @function
     * @public
     */ async close() {
        if (this.privDisposed) return;
        return this.dispose(true);
    }
    /**
     * Gets the ICE servers. Internal use only.
     */ get iceServers() {
        return this.privIceServers;
    }
    // Creates the synthesis adapter
    createSynthesisAdapter(authentication, connectionFactory, synthesizerConfig) {
        return new $hgjD5.AvatarSynthesisAdapter(authentication, connectionFactory, synthesizerConfig, this, this.privAvatarConfig);
    }
    createRestSynthesisAdapter(_authentication, _synthesizerConfig) {
        return undefined;
    }
    createSynthesizerConfig(speechConfig) {
        const config = super.createSynthesizerConfig(speechConfig);
        config.avatarEnabled = true;
        return config;
    }
    async speak(text, isSSML) {
        const requestId = (0, $5OUhN.createNoDashGuid)();
        const deferredResult = new $5OUhN.Deferred();
        this.synthesisRequestQueue.enqueue(new $ctHGQ.SynthesisRequest(requestId, text, isSSML, (e)=>{
            deferredResult.resolve(e);
            this.privSynthesizing = false;
            this.adapterSpeak();
        }, (e)=>{
            deferredResult.reject(e);
            this.privSynthesizing = false;
        }));
        this.adapterSpeak();
        return deferredResult.promise;
    }
}
module.exports.AvatarSynthesizer = $5321819a3bd15546$var$AvatarSynthesizer;

});
parcelRegister("2Fj9D", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisConnectionFactory = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $gttSn = parcelRequire("gttSn");

var $kBobk = parcelRequire("kBobk");

var $hgjD5 = parcelRequire("hgjD5");

var $40Pvg = parcelRequire("40Pvg");

var $jE6M6 = parcelRequire("jE6M6");
class $1f0e44bfdad73924$var$SpeechSynthesisConnectionFactory {
    constructor(){
        this.synthesisUri = "/tts/cognitiveservices/websocket/v1";
    }
    async create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Region, undefined);
        const hostSuffix = $kBobk.ConnectionFactoryBase.getHostSuffix(region);
        const endpointId = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const hostPrefix = endpointId === undefined ? "tts" : "voice";
        const host = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Host, "wss://" + region + "." + hostPrefix + ".speech" + hostSuffix);
        const queryParams = {};
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$40Pvg.HeaderNames.ConnectionId] = connectionId;
        if (endpointId !== undefined && endpointId !== "") {
            if (!endpoint || endpoint.search($jE6M6.QueryParameterNames.CustomVoiceDeploymentId) === -1) queryParams[$jE6M6.QueryParameterNames.CustomVoiceDeploymentId] = endpointId;
        }
        if (config.avatarEnabled) {
            if (!endpoint || endpoint.search($jE6M6.QueryParameterNames.EnableAvatar) === -1) queryParams[$jE6M6.QueryParameterNames.EnableAvatar] = "true";
        }
        if (!!endpoint) {
            const endpointUrl = new URL(endpoint);
            const pathName = endpointUrl.pathname;
            if (pathName === "" || pathName === "/") {
                // We need to generate the path, and we need to check for a redirect.
                endpointUrl.pathname = this.synthesisUri;
                endpoint = await $kBobk.ConnectionFactoryBase.getRedirectUrlFromEndpoint(endpointUrl.toString());
            }
        }
        if (!endpoint) endpoint = host + this.synthesisUri;
        config.parameters.setProperty($gttSn.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $s6RJO.WebsocketConnection(endpoint, queryParams, headers, new $hgjD5.WebsocketMessageFormatter(), $s6RJO.ProxyInfo.fromParameters(config.parameters), enableCompression, connectionId);
    }
}
module.exports.SpeechSynthesisConnectionFactory = $1f0e44bfdad73924$var$SpeechSynthesisConnectionFactory;

});


parcelRegister("lvcSj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarVideoFormat = module.exports.Coordinate = void 0;
/* eslint-disable max-classes-per-file */ /**
 * Defines a coordinate in 2D space.
 * @class Coordinate
 * Added in version 1.33.0
 */ class $040a2b45f84fe6db$var$Coordinate {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
}
module.exports.Coordinate = $040a2b45f84fe6db$var$Coordinate;
/**
 * Defines the avatar output video format.
 * @class AvatarVideoFormat
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change in the future.
 */ class $040a2b45f84fe6db$var$AvatarVideoFormat {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} codec - The video codec.
     * @param {number} bitrate - The video bitrate.
     * @param {number} width - The video width.
     * @param {number} height - The video height.
     */ constructor(codec = "H264", bitrate = 2000000, width = 1920, height = 1080){
        this.codec = codec;
        this.bitrate = bitrate;
        this.width = width;
        this.height = height;
    }
    /**
     * Sets the video crop range.
     */ setCropRange(topLeft, bottomRight) {
        this.cropRange = {
            bottomRight: bottomRight,
            topLeft: topLeft
        };
    }
}
module.exports.AvatarVideoFormat = $040a2b45f84fe6db$var$AvatarVideoFormat;

});

parcelRegister("hwjbb", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarWebRTCConnectionResult = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Defines the avatar WebRTC connection result.
 * @class AvatarWebRTCConnectionResult
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change in the future.
 */ class $cc144d7496bcd7eb$var$AvatarWebRTCConnectionResult extends $gttSn.SynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {RTCSessionDescriptionInit} SDPAnswer - The SDP answer of WebRTC connection.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(SDPAnswer, resultId, reason, errorDetails, properties){
        super(resultId, reason, errorDetails, properties);
        this.privSDPAnswer = SDPAnswer;
    }
    /**
     * Specifies SDP (Session Description Protocol) answer of WebRTC connection.
     * @member AvatarWebRTCConnectionResult.prototype.SDPAnswer
     * @function
     * @public
     * @returns {RTCSessionDescriptionInit} Specifies the SDP answer of WebRTC connection.
     */ get SDPAnswer() {
        return this.privSDPAnswer;
    }
}
module.exports.AvatarWebRTCConnectionResult = $cc144d7496bcd7eb$var$AvatarWebRTCConnectionResult;

});

parcelRegister("gT5Jf", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $5OUhN = parcelRequire("5OUhN");
/**
 * Defines diagnostics API for managing console output
 * Added in version 1.21.0
 */ class $c4b639fe8aba689e$var$Diagnostics {
    static SetLoggingLevel(logLevel) {
        this.privListener = new $s6RJO.ConsoleLoggingListener(logLevel);
        $5OUhN.Events.instance.attachConsoleListener(this.privListener);
    }
    static StartConsoleOutput() {
        if (!!this.privListener) this.privListener.enableConsoleOutput = true;
    }
    static StopConsoleOutput() {
        if (!!this.privListener) this.privListener.enableConsoleOutput = false;
    }
    static SetLogOutputPath(path) {
        if (typeof window === "undefined") {
            if (!!this.privListener) this.privListener.logPath = path;
        } else throw new Error("File system logging not available in browser.");
    }
    static set onLogOutput(callback) {
        if (!!this.privListener) this.privListener.logCallback = callback;
    }
}
module.exports.Diagnostics = $c4b639fe8aba689e$var$Diagnostics;
$c4b639fe8aba689e$var$Diagnostics.privListener = undefined;

});



parcelRegister("lfoMA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $f77e38fb60fb6fd5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestMessageAdapter = module.exports.RestRequestType = void 0;

const $f77e38fb60fb6fd5$var$bent_1 = $f77e38fb60fb6fd5$var$__importDefault((parcelRequire("bLd4X")));

var $5OUhN = parcelRequire("5OUhN");
var $f77e38fb60fb6fd5$var$RestRequestType;
(function(RestRequestType) {
    RestRequestType["Get"] = "GET";
    RestRequestType["Post"] = "POST";
    RestRequestType["Delete"] = "DELETE";
    RestRequestType["File"] = "file";
})($f77e38fb60fb6fd5$var$RestRequestType = module.exports.RestRequestType || (module.exports.RestRequestType = {}));
// accept rest operations via request method and return abstracted objects from server response
class $f77e38fb60fb6fd5$var$RestMessageAdapter {
    constructor(configParams){
        if (!configParams) throw new $5OUhN.ArgumentNullError("configParams");
        this.privHeaders = configParams.headers;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    static extractHeaderValue(headerKey, headers) {
        let headerValue = "";
        try {
            const arr = headers.trim().split(/[\r\n]+/);
            const headerMap = {};
            arr.forEach((line)=>{
                const parts = line.split(": ");
                const header = parts.shift().toLowerCase();
                const value = parts.join(": ");
                headerMap[header] = value;
            });
            headerValue = headerMap[headerKey.toLowerCase()];
        } catch (e) {
        // ignore the error
        }
        return headerValue;
    }
    set options(configParams) {
        this.privHeaders = configParams.headers;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    setHeaders(key, value) {
        this.privHeaders[key] = value;
    }
    request(method, uri, queryParams = {}, body = null) {
        const responseReceivedDeferral = new $5OUhN.Deferred();
        const requestCommand = method === $f77e38fb60fb6fd5$var$RestRequestType.File ? "POST" : method;
        const handleRestResponse = (data, j = {})=>{
            const d = data;
            return {
                data: JSON.stringify(j),
                headers: JSON.stringify(data.headers),
                json: j,
                ok: data.statusCode >= 200 && data.statusCode < 300,
                status: data.statusCode,
                statusText: j.error ? j.error.message : d.statusText ? d.statusText : d.statusMessage
            };
        };
        const send = (postData)=>{
            const sendRequest = (0, $f77e38fb60fb6fd5$var$bent_1.default)(uri, requestCommand, this.privHeaders, 200, 201, 202, 204, 400, 401, 402, 403, 404);
            const params = this.queryParams(queryParams) === "" ? "" : `?${this.queryParams(queryParams)}`;
            sendRequest(params, postData).then(async (data)=>{
                if (method === $f77e38fb60fb6fd5$var$RestRequestType.Delete || data.statusCode === 204) // No JSON from Delete and reset (204) operations
                responseReceivedDeferral.resolve(handleRestResponse(data));
                else try {
                    const j = await data.json();
                    responseReceivedDeferral.resolve(handleRestResponse(data, j));
                } catch  {
                    responseReceivedDeferral.resolve(handleRestResponse(data));
                }
            }).catch((error)=>{
                responseReceivedDeferral.reject(error);
            });
        };
        if (this.privIgnoreCache) this.privHeaders["Cache-Control"] = "no-cache";
        if (method === $f77e38fb60fb6fd5$var$RestRequestType.Post && body) {
            this.privHeaders["content-type"] = "application/json";
            this.privHeaders["Content-Type"] = "application/json";
        }
        send(body);
        return responseReceivedDeferral.promise;
    }
    queryParams(params = {}) {
        return Object.keys(params).map((k)=>encodeURIComponent(k) + "=" + encodeURIComponent(params[k])).join("&");
    }
}
module.exports.RestMessageAdapter = $f77e38fb60fb6fd5$var$RestMessageAdapter;

});
parcelRegister("bLd4X", function(module, exports) {
'use strict';

var $4QMNu = parcelRequire("4QMNu");
class $88fe3aaee92acb81$var$StatusError extends Error {
    constructor(res, ...params){
        super(...params);
        if (Error.captureStackTrace) Error.captureStackTrace(this, $88fe3aaee92acb81$var$StatusError);
        this.name = 'StatusError';
        this.message = res.statusMessage;
        this.statusCode = res.status;
        this.res = res;
        this.json = res.json.bind(res);
        this.text = res.text.bind(res);
        this.arrayBuffer = res.arrayBuffer.bind(res);
        let buffer;
        const get = ()=>{
            if (!buffer) buffer = this.arrayBuffer();
            return buffer;
        };
        Object.defineProperty(this, 'responseBody', {
            get: get
        });
        // match Node.js headers object
        this.headers = {};
        for (const [key, value] of res.headers.entries())this.headers[key.toLowerCase()] = value;
    }
}
const $88fe3aaee92acb81$var$mkrequest = (statusCodes, method, encoding, headers, baseurl)=>async (_url, body, _headers = {})=>{
        _url = baseurl + (_url || '');
        let parsed = new URL(_url);
        if (!headers) headers = {};
        if (parsed.username) {
            headers.Authorization = 'Basic ' + btoa(parsed.username + ':' + parsed.password);
            parsed = new URL(parsed.protocol + '//' + parsed.host + parsed.pathname + parsed.search);
        }
        if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') throw new Error(`Unknown protocol, ${parsed.protocol}`);
        if (body) {
            if (body instanceof ArrayBuffer || ArrayBuffer.isView(body) || typeof body === 'string') ;
            else if (typeof body === 'object') {
                body = JSON.stringify(body);
                headers['Content-Type'] = 'application/json';
            } else throw new Error('Unknown body type.');
        }
        _headers = new Headers({
            ...headers || {},
            ..._headers
        });
        const resp = await fetch(parsed, {
            method: method,
            headers: _headers,
            body: body
        });
        resp.statusCode = resp.status;
        if (!statusCodes.has(resp.status)) throw new $88fe3aaee92acb81$var$StatusError(resp);
        if (encoding === 'json') return resp.json();
        else if (encoding === 'buffer') return resp.arrayBuffer();
        else if (encoding === 'string') return resp.text();
        else return resp;
    };
module.exports = $4QMNu($88fe3aaee92acb81$var$mkrequest);

});
parcelRegister("4QMNu", function(module, exports) {
'use strict';
const $3881dedbff731964$var$encodings = new Set([
    'json',
    'buffer',
    'string'
]);
module.exports = (mkrequest)=>(...args)=>{
        const statusCodes = new Set();
        let method;
        let encoding;
        let headers;
        let baseurl = '';
        args.forEach((arg)=>{
            if (typeof arg === 'string') {
                if (arg.toUpperCase() === arg) {
                    if (method) {
                        const msg = `Can't set method to ${arg}, already set to ${method}.`;
                        throw new Error(msg);
                    } else method = arg;
                } else if (arg.startsWith('http:') || arg.startsWith('https:')) baseurl = arg;
                else {
                    if ($3881dedbff731964$var$encodings.has(arg)) encoding = arg;
                    else throw new Error(`Unknown encoding, ${arg}`);
                }
            } else if (typeof arg === 'number') statusCodes.add(arg);
            else if (typeof arg === 'object') {
                if (Array.isArray(arg) || arg instanceof Set) arg.forEach((code)=>statusCodes.add(code));
                else {
                    if (headers) throw new Error('Cannot set headers twice.');
                    headers = arg;
                }
            } else throw new Error(`Unknown type: ${typeof arg}`);
        });
        if (!method) method = 'GET';
        if (statusCodes.size === 0) statusCodes.add(200);
        return mkrequest(statusCodes, method, encoding, headers, baseurl);
    };

});



parcelRegister("cTQ6R", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestConfigBase = void 0;
class $96430af81b82bafd$var$RestConfigBase {
    static get requestOptions() {
        return $96430af81b82bafd$var$RestConfigBase.privDefaultRequestOptions;
    }
    static get configParams() {
        return $96430af81b82bafd$var$RestConfigBase.privDefaultParams;
    }
    static get restErrors() {
        return $96430af81b82bafd$var$RestConfigBase.privRestErrors;
    }
}
module.exports.RestConfigBase = $96430af81b82bafd$var$RestConfigBase;
$96430af81b82bafd$var$RestConfigBase.privDefaultRequestOptions = {
    headers: {
        Accept: "application/json"
    },
    ignoreCache: false,
    timeout: 10000
};
$96430af81b82bafd$var$RestConfigBase.privRestErrors = {
    authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.",
    authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.",
    invalidArgs: "Required input not found: {arg}.",
    invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.",
    invalidParticipantRequest: "The requested participant was not found.",
    permissionDeniedConnect: "Required credentials not found.",
    permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.",
    permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.",
    permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.",
    permissionDeniedStart: "Invalid operation: there is already an active conversation."
};
$96430af81b82bafd$var$RestConfigBase.privDefaultParams = {
    apiVersion: "api-version",
    authorization: "Authorization",
    clientAppId: "X-ClientAppId",
    contentTypeKey: "Content-Type",
    correlationId: "X-CorrelationId",
    languageCode: "language",
    nickname: "nickname",
    profanity: "profanity",
    requestId: "X-RequestId",
    roomId: "roomid",
    sessionToken: "token",
    subscriptionKey: "Ocp-Apim-Subscription-Key",
    subscriptionRegion: "Ocp-Apim-Subscription-Region",
    token: "X-CapitoToken"
};

});


parcelRegister("ccM4b", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConnectionMessage = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $40Pvg = parcelRequire("40Pvg");
class $8e2be402df271926$var$SpeechConnectionMessage extends $5OUhN.ConnectionMessage {
    constructor(messageType, path, requestId, contentType, body, streamId, additionalHeaders, id){
        if (!path) throw new $5OUhN.ArgumentNullError("path");
        if (!requestId) throw new $5OUhN.ArgumentNullError("requestId");
        const headers = {};
        headers[$40Pvg.HeaderNames.Path] = path;
        headers[$40Pvg.HeaderNames.RequestId] = requestId;
        headers[$40Pvg.HeaderNames.RequestTimestamp] = new Date().toISOString();
        if (contentType) headers[$40Pvg.HeaderNames.ContentType] = contentType;
        if (streamId) headers[$40Pvg.HeaderNames.RequestStreamId] = streamId;
        if (additionalHeaders) {
            for(const headerName in additionalHeaders)if (headerName) headers[headerName] = additionalHeaders[headerName];
        }
        if (id) super(messageType, body, headers, id);
        else super(messageType, body, headers);
        this.privPath = path;
        this.privRequestId = requestId;
        this.privContentType = contentType;
        this.privStreamId = streamId;
        this.privAdditionalHeaders = additionalHeaders;
    }
    get path() {
        return this.privPath;
    }
    get requestId() {
        return this.privRequestId;
    }
    get contentType() {
        return this.privContentType;
    }
    get streamId() {
        return this.privStreamId;
    }
    get additionalHeaders() {
        return this.privAdditionalHeaders;
    }
    static fromConnectionMessage(message) {
        let path = null;
        let requestId = null;
        let contentType = null;
        // let requestTimestamp = null;
        let streamId = null;
        const additionalHeaders = {};
        if (message.headers) {
            for(const headerName in message.headers)if (headerName) {
                if (headerName.toLowerCase() === $40Pvg.HeaderNames.Path.toLowerCase()) path = message.headers[headerName];
                else if (headerName.toLowerCase() === $40Pvg.HeaderNames.RequestId.toLowerCase()) requestId = message.headers[headerName];
                else if (headerName.toLowerCase() === $40Pvg.HeaderNames.ContentType.toLowerCase()) contentType = message.headers[headerName];
                else if (headerName.toLowerCase() === $40Pvg.HeaderNames.RequestStreamId.toLowerCase()) streamId = message.headers[headerName];
                else additionalHeaders[headerName] = message.headers[headerName];
            }
        }
        return new $8e2be402df271926$var$SpeechConnectionMessage(message.messageType, path, requestId, contentType, message.body, streamId, additionalHeaders, message.id);
    }
}
module.exports.SpeechConnectionMessage = $8e2be402df271926$var$SpeechConnectionMessage;

});

parcelRegister("kyLke", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SegmentationMode = void 0;
/**
 * The segmentation mode.
 */ var $ef7bb17373702041$var$SegmentationMode;
(function(SegmentationMode) {
    SegmentationMode["Normal"] = "Normal";
    SegmentationMode["Disabled"] = "Disabled";
    SegmentationMode["Custom"] = "Custom";
    SegmentationMode["Semantic"] = "Semantic";
})($ef7bb17373702041$var$SegmentationMode = module.exports.SegmentationMode || (module.exports.SegmentationMode = {}));

});

parcelRegister("WtAk0", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NextAction = void 0;
/**
 * The action to take on success
 */ var $0afc5dd35cd4fffd$var$NextAction;
(function(NextAction) {
    NextAction["None"] = "None";
    NextAction["Synthesize"] = "Synthesize";
})($0afc5dd35cd4fffd$var$NextAction = module.exports.NextAction || (module.exports.NextAction = {}));

});

parcelRegister("iYXZ1", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Mode = void 0;
/**
 * Result type
 */ var $dd1c5c00bdc65105$var$Mode;
(function(Mode) {
    Mode["None"] = "None";
    Mode["Always"] = "Always";
})($dd1c5c00bdc65105$var$Mode = module.exports.Mode || (module.exports.Mode = {}));

});

parcelRegister("asFUo", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LanguageIdDetectionPriority = module.exports.LanguageIdDetectionMode = void 0;
/**
 * The enum that represents which mode will language detection take place
 * There is only detectAtAudioStart mode for now as language detection models are not trained for different modes
 * This enum can be extended in future to support different modes
 */ var $79dd070e5b3fcc22$var$LanguageIdDetectionMode;
(function(LanguageIdDetectionMode) {
    LanguageIdDetectionMode["DetectAtAudioStart"] = "DetectAtAudioStart";
    LanguageIdDetectionMode["DetectContinuous"] = "DetectContinuous";
    LanguageIdDetectionMode["DetectSegments"] = "DetectSegments";
})($79dd070e5b3fcc22$var$LanguageIdDetectionMode = module.exports.LanguageIdDetectionMode || (module.exports.LanguageIdDetectionMode = {}));
/**
 * The language id detection mode, setting this will load the detection setting of MaxAudioDuration and MaxSpeechDuration
 * If the maxAudioDuration and maxSpeechDuration is set in the speech.context, then this detection mode will be ignored
 */ var $79dd070e5b3fcc22$var$LanguageIdDetectionPriority;
(function(LanguageIdDetectionPriority) {
    /**
     * default, Service decides the best mode to use.
     */ LanguageIdDetectionPriority["Auto"] = "Auto";
    /**
     * Offers lower latency via a trade-off of accuracy.
     */ LanguageIdDetectionPriority["PrioritizeLatency"] = "PrioritizeLatency";
    /**
     * Offers higher accuracy via a trade-off of latency.
     */ LanguageIdDetectionPriority["PrioritizeAccuracy"] = "PrioritizeAccuracy";
})($79dd070e5b3fcc22$var$LanguageIdDetectionPriority = module.exports.LanguageIdDetectionPriority || (module.exports.LanguageIdDetectionPriority = {}));

});

parcelRegister("9H0bk", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NextAction = void 0;
/**
 * The action to take on successful language detection
 */ var $70e84544b2555e8b$var$NextAction;
(function(NextAction) {
    NextAction["Recognize"] = "Recognize";
    NextAction["None"] = "None";
})($70e84544b2555e8b$var$NextAction = module.exports.NextAction || (module.exports.NextAction = {}));

});

parcelRegister("4DFBe", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OnUnknownAction = void 0;
/**
 * An enum that defines actions that can be taken on unknown language detection
 */ var $360b12c1288954f1$var$OnUnknownAction;
(function(OnUnknownAction) {
    OnUnknownAction["RecognizeWithDefaultLanguage"] = "RecognizeWithDefaultLanguage";
    OnUnknownAction["None"] = "None";
})($360b12c1288954f1$var$OnUnknownAction = module.exports.OnUnknownAction || (module.exports.OnUnknownAction = {}));

});

parcelRegister("inqHk", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResultType = void 0;
/**
 * The result type enum
 */ var $d60f15a3230a8cdf$var$ResultType;
(function(ResultType) {
    ResultType["Auto"] = "Auto";
    ResultType["StableFragment"] = "StableFragment";
    ResultType["Hypothesis"] = "Hypothesis";
    ResultType["None"] = "None";
})($d60f15a3230a8cdf$var$ResultType = module.exports.ResultType || (module.exports.ResultType = {}));

});

parcelRegister("jFIy8", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PhraseResultOutputType = void 0;
/**
 * The phrase result output type
 */ var $e5246748f0598211$var$PhraseResultOutputType;
(function(PhraseResultOutputType) {
    PhraseResultOutputType["Always"] = "Always";
    PhraseResultOutputType["None"] = "None";
})($e5246748f0598211$var$PhraseResultOutputType = module.exports.PhraseResultOutputType || (module.exports.PhraseResultOutputType = {}));

});

parcelRegister("ioQxp", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NextAction = void 0;
/**
 * The action enum when speech recognition return a final phrase result
 */ var $d65338cfcb894e9f$var$NextAction;
(function(NextAction) {
    NextAction["None"] = "None";
    NextAction["Translate"] = "Translate";
})($d65338cfcb894e9f$var$NextAction = module.exports.NextAction || (module.exports.NextAction = {}));

});


parcelRegister("1t7Y3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationServiceRecognizer = void 0;

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");
class $111eae1a240faed4$var$ConversationServiceRecognizer extends $hgjD5.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.handleSpeechPhraseMessage = async (textBody)=>this.handleSpeechPhrase(textBody);
        this.handleSpeechHypothesisMessage = (textBody)=>this.handleSpeechHypothesis(textBody);
    }
    processTypeSpecificMessages(connectionMessage) {
        return;
    }
    handleRecognizedCallback(result, offset, sessionId) {
        return;
    }
    handleRecognizingCallback(result, duration, sessionId) {
        return;
    }
    async processSpeechMessages(connectionMessage) {
        let processed = false;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
            case "speech.fragment":
                if (!!this.handleSpeechHypothesisMessage) this.handleSpeechHypothesisMessage(connectionMessage.textBody);
                processed = true;
                break;
            case "speech.phrase":
                if (!!this.handleSpeechPhraseMessage) await this.handleSpeechPhraseMessage(connectionMessage.textBody);
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {}
    async handleSpeechPhrase(textBody) {
        const simple = $hgjD5.SimpleSpeechPhrase.fromJSON(textBody, this.privRequestSession.currentTurnAudioOffset);
        const resultReason = $hgjD5.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus);
        let result;
        const resultProps = new $gttSn.PropertyCollection();
        resultProps.setProperty($gttSn.PropertyId.SpeechServiceResponse_JsonResult, textBody);
        this.privRequestSession.onPhraseRecognized(simple.Offset + simple.Duration);
        if ($gttSn.ResultReason.Canceled === resultReason) {
            const cancelReason = $hgjD5.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
            const cancellationErrorCode = $hgjD5.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus);
            await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $hgjD5.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
        } else if (simple.RecognitionStatus !== $hgjD5.RecognitionStatus.EndOfDictation) {
            if (this.privRecognizerConfig.parameters.getProperty($hgjD5.OutputFormatPropertyName) === $gttSn.OutputFormat[$gttSn.OutputFormat.Simple]) result = new $gttSn.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset, simple.Language, simple.LanguageDetectionConfidence, simple.SpeakerId, undefined, simple.asJson(), resultProps);
            else {
                const detailed = $hgjD5.DetailedSpeechPhrase.fromJSON(textBody, this.privRequestSession.currentTurnAudioOffset);
                result = new $gttSn.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, detailed.Text, detailed.Duration, detailed.Offset, detailed.Language, detailed.LanguageDetectionConfidence, detailed.SpeakerId, undefined, detailed.asJson(), resultProps);
            }
            this.handleRecognizedCallback(result, result.offset, this.privRequestSession.sessionId);
        }
    }
    handleSpeechHypothesis(textBody) {
        const hypothesis = $hgjD5.SpeechHypothesis.fromJSON(textBody, this.privRequestSession.currentTurnAudioOffset);
        const resultProps = new $gttSn.PropertyCollection();
        resultProps.setProperty($gttSn.PropertyId.SpeechServiceResponse_JsonResult, textBody);
        const result = new $gttSn.SpeechRecognitionResult(this.privRequestSession.requestId, $gttSn.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, hypothesis.Offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, hypothesis.SpeakerId, undefined, hypothesis.asJson(), resultProps);
        this.privRequestSession.onHypothesis(hypothesis.Offset);
        this.handleRecognizingCallback(result, hypothesis.Duration, this.privRequestSession.sessionId);
    }
}
module.exports.ConversationServiceRecognizer = $111eae1a240faed4$var$ConversationServiceRecognizer;

});

parcelRegister("3ppF1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognizerConfig = module.exports.SpeechResultFormat = void 0;

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");

var $6rQ2O = parcelRequire("6rQ2O");
var $27b79c9703ca383b$var$SpeechResultFormat;
(function(SpeechResultFormat) {
    SpeechResultFormat[SpeechResultFormat["Simple"] = 0] = "Simple";
    SpeechResultFormat[SpeechResultFormat["Detailed"] = 1] = "Detailed";
})($27b79c9703ca383b$var$SpeechResultFormat = module.exports.SpeechResultFormat || (module.exports.SpeechResultFormat = {}));
class $27b79c9703ca383b$var$RecognizerConfig {
    constructor(speechServiceConfig, parameters){
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $hgjD5.SpeechServiceConfig(new $hgjD5.Context(null));
        this.privParameters = parameters;
        this.privMaxRetryCount = parseInt(parameters.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10);
        this.privLanguageIdMode = parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_LanguageIdMode, undefined);
        this.privEnableSpeakerId = false;
    }
    get parameters() {
        return this.privParameters;
    }
    get recognitionMode() {
        return this.privRecognitionMode;
    }
    set recognitionMode(value) {
        this.privRecognitionMode = value;
        this.privRecognitionActivityTimeout = value === $6rQ2O.RecognitionMode.Interactive ? 8000 : 25000;
        this.privSpeechServiceConfig.Recognition = $6rQ2O.RecognitionMode[value];
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
    get recognitionActivityTimeout() {
        return this.privRecognitionActivityTimeout;
    }
    get isContinuousRecognition() {
        return this.privRecognitionMode !== $6rQ2O.RecognitionMode.Interactive;
    }
    get languageIdMode() {
        return this.privLanguageIdMode;
    }
    get autoDetectSourceLanguages() {
        return this.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, undefined);
    }
    get recognitionEndpointVersion() {
        return this.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "2");
    }
    set recognitionEndpointVersion(version) {
        this.parameters.setProperty($gttSn.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, version);
    }
    get sourceLanguageModels() {
        const models = [];
        let modelsExist = false;
        if (this.autoDetectSourceLanguages !== undefined) for (const language of this.autoDetectSourceLanguages.split(",")){
            const customProperty = language + $gttSn.PropertyId.SpeechServiceConnection_EndpointId.toString();
            const modelId = this.parameters.getProperty(customProperty, undefined);
            if (modelId !== undefined) {
                models.push({
                    language: language,
                    endpoint: modelId
                });
                modelsExist = true;
            } else models.push({
                language: language,
                endpoint: ""
            });
        }
        return modelsExist ? models : undefined;
    }
    get maxRetryCount() {
        return this.privMaxRetryCount;
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    set isSpeakerDiarizationEnabled(value) {
        this.privEnableSpeakerId = value;
    }
}
module.exports.RecognizerConfig = $27b79c9703ca383b$var$RecognizerConfig;

});

parcelRegister("kigto", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iUPWQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketMessageFormatter = void 0;

var $5OUhN = parcelRequire("5OUhN");
const $dc55c0c4cccf4a8e$var$CRLF = "\r\n";
class $dc55c0c4cccf4a8e$var$WebsocketMessageFormatter {
    toConnectionMessage(message) {
        const deferral = new $5OUhN.Deferred();
        try {
            if (message.messageType === $5OUhN.MessageType.Text) {
                const textMessage = message.textContent;
                let headers = {};
                let body = null;
                if (textMessage) {
                    const headerBodySplit = textMessage.split("\r\n\r\n");
                    if (headerBodySplit && headerBodySplit.length > 0) {
                        headers = this.parseHeaders(headerBodySplit[0]);
                        if (headerBodySplit.length > 1) body = headerBodySplit[1];
                    }
                }
                deferral.resolve(new $5OUhN.ConnectionMessage(message.messageType, body, headers, message.id));
            } else if (message.messageType === $5OUhN.MessageType.Binary) {
                const binaryMessage = message.binaryContent;
                let headers = {};
                let body = null;
                if (!binaryMessage || binaryMessage.byteLength < 2) throw new Error("Invalid binary message format. Header length missing.");
                const dataView = new DataView(binaryMessage);
                const headerLength = dataView.getInt16(0);
                if (binaryMessage.byteLength < headerLength + 2) throw new Error("Invalid binary message format. Header content missing.");
                let headersString = "";
                for(let i = 0; i < headerLength; i++)headersString += String.fromCharCode(dataView.getInt8(i + 2));
                headers = this.parseHeaders(headersString);
                if (binaryMessage.byteLength > headerLength + 2) body = binaryMessage.slice(2 + headerLength);
                deferral.resolve(new $5OUhN.ConnectionMessage(message.messageType, body, headers, message.id));
            }
        } catch (e) {
            deferral.reject(`Error formatting the message. Error: ${e}`);
        }
        return deferral.promise;
    }
    fromConnectionMessage(message) {
        const deferral = new $5OUhN.Deferred();
        try {
            if (message.messageType === $5OUhN.MessageType.Text) {
                const payload = `${this.makeHeaders(message)}${$dc55c0c4cccf4a8e$var$CRLF}${message.textBody ? message.textBody : ""}`;
                deferral.resolve(new $5OUhN.RawWebsocketMessage($5OUhN.MessageType.Text, payload, message.id));
            } else if (message.messageType === $5OUhN.MessageType.Binary) {
                const headersString = this.makeHeaders(message);
                const content = message.binaryBody;
                const headerBuffer = this.stringToArrayBuffer(headersString);
                const headerInt8Array = new Int8Array(headerBuffer);
                const headerLength = headerInt8Array.byteLength;
                const payloadInt8Array = new Int8Array(2 + headerLength + (content ? content.byteLength : 0));
                payloadInt8Array[0] = headerLength >> 8 & 0xff;
                payloadInt8Array[1] = headerLength & 0xff;
                payloadInt8Array.set(headerInt8Array, 2);
                if (content) {
                    const bodyInt8Array = new Int8Array(content);
                    payloadInt8Array.set(bodyInt8Array, 2 + headerLength);
                }
                const payload = payloadInt8Array.buffer;
                deferral.resolve(new $5OUhN.RawWebsocketMessage($5OUhN.MessageType.Binary, payload, message.id));
            }
        } catch (e) {
            deferral.reject(`Error formatting the message. ${e}`);
        }
        return deferral.promise;
    }
    makeHeaders(message) {
        let headersString = "";
        if (message.headers) {
            for(const header in message.headers)if (header) headersString += `${header}: ${message.headers[header]}${$dc55c0c4cccf4a8e$var$CRLF}`;
        }
        return headersString;
    }
    parseHeaders(headersString) {
        const headers = {};
        if (headersString) {
            const headerMatches = headersString.match(/[^\r\n]+/g);
            if (headers) {
                for (const header of headerMatches)if (header) {
                    const separatorIndex = header.indexOf(":");
                    const headerName = separatorIndex > 0 ? header.substr(0, separatorIndex).trim().toLowerCase() : header;
                    const headerValue = separatorIndex > 0 && header.length > separatorIndex + 1 ? header.substr(separatorIndex + 1).trim() : "";
                    headers[headerName] = headerValue;
                }
            }
        }
        return headers;
    }
    stringToArrayBuffer(str) {
        const buffer = new ArrayBuffer(str.length);
        const view = new DataView(buffer);
        for(let i = 0; i < str.length; i++)view.setUint8(i, str.charCodeAt(i));
        return buffer;
    }
}
module.exports.WebsocketMessageFormatter = $dc55c0c4cccf4a8e$var$WebsocketMessageFormatter;

});

parcelRegister("gXTdh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConnectionFactory = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $hgjD5 = parcelRequire("hgjD5");

var $gttSn = parcelRequire("gttSn");

var $kBobk = parcelRequire("kBobk");

var $hgjD5 = parcelRequire("hgjD5");

var $40Pvg = parcelRequire("40Pvg");

var $jE6M6 = parcelRequire("jE6M6");

var $6rQ2O = parcelRequire("6rQ2O");
class $c59cfc3ce2eedfdd$var$SpeechConnectionFactory extends $kBobk.ConnectionFactoryBase {
    constructor(){
        super(...arguments);
        this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1";
        this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1";
        this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1";
        this.universalUri = "/stt/speech/universal/v";
    }
    async create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Region, undefined);
        const hostSuffix = $kBobk.ConnectionFactoryBase.getHostSuffix(region);
        const host = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".stt.speech" + hostSuffix);
        const queryParams = {};
        const endpointId = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const language = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId) {
            if (!endpoint || endpoint.search($jE6M6.QueryParameterNames.CustomSpeechDeploymentId) === -1) queryParams[$jE6M6.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
        } else if (language) {
            if (!endpoint || endpoint.search($jE6M6.QueryParameterNames.Language) === -1) queryParams[$jE6M6.QueryParameterNames.Language] = language;
        }
        if (!endpoint || endpoint.search($jE6M6.QueryParameterNames.Format) === -1) queryParams[$jE6M6.QueryParameterNames.Format] = config.parameters.getProperty($hgjD5.OutputFormatPropertyName, $gttSn.OutputFormat[$gttSn.OutputFormat.Simple]).toLowerCase();
        if (config.autoDetectSourceLanguages !== undefined) queryParams[$jE6M6.QueryParameterNames.EnableLanguageId] = "true";
        this.setCommonUrlParams(config, queryParams, endpoint);
        if (!!endpoint) {
            const endpointUrl = new URL(endpoint);
            const pathName = endpointUrl.pathname;
            if (pathName === "" || pathName === "/") {
                // We need to generate the path, and we need to check for a redirect.
                endpointUrl.pathname = this.universalUri + config.recognitionEndpointVersion;
                endpoint = await $kBobk.ConnectionFactoryBase.getRedirectUrlFromEndpoint(endpointUrl.toString());
            }
        }
        if (!endpoint) switch(config.recognitionMode){
            case $6rQ2O.RecognitionMode.Conversation:
                if (config.parameters.getProperty($hgjD5.ForceDictationPropertyName, "false") === "true") endpoint = host + this.dictationRelativeUri;
                else if (config.recognitionEndpointVersion !== undefined && parseInt(config.recognitionEndpointVersion, 10) > 1) endpoint = `${host}${this.universalUri}${config.recognitionEndpointVersion}`;
                else endpoint = host + this.conversationRelativeUri;
                break;
            case $6rQ2O.RecognitionMode.Dictation:
                endpoint = host + this.dictationRelativeUri;
                break;
            default:
                if (config.recognitionEndpointVersion !== undefined && parseInt(config.recognitionEndpointVersion, 10) > 1) endpoint = `${host}${this.universalUri}${config.recognitionEndpointVersion}`;
                else endpoint = host + this.interactiveRelativeUri; // default is interactive
                break;
        }
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$40Pvg.HeaderNames.ConnectionId] = connectionId;
        headers.connectionId = connectionId;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        const webSocketConnection = new $s6RJO.WebsocketConnection(endpoint, queryParams, headers, new $hgjD5.WebsocketMessageFormatter(), $s6RJO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        // Set the value of SpeechServiceConnection_Url to webSocketConnection.uri (and not to `endpoint`), since this value is the final
        // URI that was used to make the connection (including query parameters).
        const uri = webSocketConnection.uri;
        config.parameters.setProperty($gttSn.PropertyId.SpeechServiceConnection_Url, uri);
        return webSocketConnection;
    }
}
module.exports.SpeechConnectionFactory = $c59cfc3ce2eedfdd$var$SpeechConnectionFactory;

});

parcelRegister("6ipmx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriberConnectionFactory = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");

var $kBobk = parcelRequire("kBobk");

var $hgjD5 = parcelRequire("hgjD5");

var $40Pvg = parcelRequire("40Pvg");

var $jE6M6 = parcelRequire("jE6M6");
class $495818f7a03b9722$var$ConversationTranscriberConnectionFactory extends $kBobk.ConnectionFactoryBase {
    constructor(){
        super(...arguments);
        this.universalUri = "/stt/speech/universal/v2";
        this.conversationRelativeUriV1 = "/speech/recognition/conversation/cognitiveservices/v1";
    }
    async create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Region, undefined);
        const hostSuffix = $kBobk.ConnectionFactoryBase.getHostSuffix(region);
        const host = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".stt.speech" + hostSuffix);
        const queryParams = {};
        const endpointId = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const language = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId) {
            if (!endpoint || endpoint.search($jE6M6.QueryParameterNames.CustomSpeechDeploymentId) === -1) queryParams[$jE6M6.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
        } else if (language) {
            if (!endpoint || endpoint.search($jE6M6.QueryParameterNames.Language) === -1) queryParams[$jE6M6.QueryParameterNames.Language] = language;
        }
        if (config.autoDetectSourceLanguages !== undefined) queryParams[$jE6M6.QueryParameterNames.EnableLanguageId] = "true";
        const apiVersion = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, undefined);
        if (apiVersion === "1") endpoint = `${host}${this.universalUri}`;
        else {
            this.setV2UrlParams(config, queryParams, endpoint);
            if (!!endpoint) {
                const endpointUrl = new URL(endpoint);
                const pathName = endpointUrl.pathname;
                if (pathName === "" || pathName === "/") {
                    // We need to generate the path, and we need to check for a redirect.
                    endpointUrl.pathname = this.universalUri;
                    endpoint = await $kBobk.ConnectionFactoryBase.getRedirectUrlFromEndpoint(endpointUrl.toString());
                }
            }
            if (!endpoint) endpoint = `${host}${this.conversationRelativeUriV1}`;
        }
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$40Pvg.HeaderNames.ConnectionId] = connectionId;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        const webSocketConnection = new $s6RJO.WebsocketConnection(endpoint, queryParams, headers, new $hgjD5.WebsocketMessageFormatter(), $s6RJO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        // Set the value of SpeechServiceConnection_Url to webSocketConnection.uri (and not to `endpoint`), since this value is the final
        // URI that was used to make the connection (including query parameters).
        const uri = webSocketConnection.uri;
        config.parameters.setProperty($gttSn.PropertyId.SpeechServiceConnection_Url, uri);
        return webSocketConnection;
    }
    setV2UrlParams(config, queryParams, endpoint) {
        const propertyIdToParameterMap = new Map([
            [
                $gttSn.PropertyId.Speech_SegmentationSilenceTimeoutMs,
                $jE6M6.QueryParameterNames.SegmentationSilenceTimeoutMs
            ],
            [
                $gttSn.PropertyId.SpeechServiceConnection_EnableAudioLogging,
                $jE6M6.QueryParameterNames.EnableAudioLogging
            ],
            [
                $gttSn.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs,
                $jE6M6.QueryParameterNames.EndSilenceTimeoutMs
            ],
            [
                $gttSn.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs,
                $jE6M6.QueryParameterNames.InitialSilenceTimeoutMs
            ],
            [
                $gttSn.PropertyId.SpeechServiceResponse_PostProcessingOption,
                $jE6M6.QueryParameterNames.Postprocessing
            ],
            [
                $gttSn.PropertyId.SpeechServiceResponse_ProfanityOption,
                $jE6M6.QueryParameterNames.Profanity
            ],
            [
                $gttSn.PropertyId.SpeechServiceResponse_StablePartialResultThreshold,
                $jE6M6.QueryParameterNames.StableIntermediateThreshold
            ]
        ]);
        propertyIdToParameterMap.forEach((parameterName, propertyId)=>{
            this.setUrlParameter(propertyId, parameterName, config, queryParams, endpoint);
        });
        const serviceProperties = JSON.parse(config.parameters.getProperty($hgjD5.ServicePropertiesPropertyName, "{}"));
        Object.keys(serviceProperties).forEach((value)=>{
            queryParams[value] = serviceProperties[value];
        });
    }
}
module.exports.ConversationTranscriberConnectionFactory = $495818f7a03b9722$var$ConversationTranscriberConnectionFactory;

});

parcelRegister("9enGg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriberConnectionFactory = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $gttSn = parcelRequire("gttSn");

var $kBobk = parcelRequire("kBobk");

var $hgjD5 = parcelRequire("hgjD5");

var $40Pvg = parcelRequire("40Pvg");

var $jE6M6 = parcelRequire("jE6M6");
class $6b87ca5c3feb1991$var$TranscriberConnectionFactory extends $kBobk.ConnectionFactoryBase {
    constructor(){
        super(...arguments);
        this.multiaudioRelativeUri = "/speech/recognition/multiaudio";
    }
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Region, "centralus");
        const hostSuffix = $kBobk.ConnectionFactoryBase.getHostSuffix(region);
        const hostDefault = "wss://transcribe." + region + ".cts.speech" + hostSuffix + this.multiaudioRelativeUri;
        const host = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Host, hostDefault);
        const queryParams = {};
        this.setQueryParams(queryParams, config, endpoint);
        if (!endpoint) endpoint = host;
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$40Pvg.HeaderNames.ConnectionId] = connectionId;
        config.parameters.setProperty($gttSn.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return Promise.resolve(new $s6RJO.WebsocketConnection(endpoint, queryParams, headers, new $hgjD5.WebsocketMessageFormatter(), $s6RJO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId));
    }
    setQueryParams(queryParams, config, endpointUrl) {
        const endpointId = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const language = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId && !($jE6M6.QueryParameterNames.CustomSpeechDeploymentId in queryParams)) queryParams[$jE6M6.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
        if (language && !($jE6M6.QueryParameterNames.Language in queryParams)) queryParams[$jE6M6.QueryParameterNames.Language] = language;
        const wordLevelTimings = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase() === "true";
        const detailed = config.parameters.getProperty($hgjD5.OutputFormatPropertyName, $gttSn.OutputFormat[$gttSn.OutputFormat.Simple]) !== $gttSn.OutputFormat[$gttSn.OutputFormat.Simple];
        if (wordLevelTimings || detailed) queryParams[$jE6M6.QueryParameterNames.Format] = $gttSn.OutputFormat[$gttSn.OutputFormat.Detailed].toLowerCase();
        this.setCommonUrlParams(config, queryParams, endpointUrl);
    }
}
module.exports.TranscriberConnectionFactory = $6b87ca5c3feb1991$var$TranscriberConnectionFactory;

});

parcelRegister("7nNfh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationConnectionFactory = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $7HCM3 = parcelRequire("7HCM3");

var $gttSn = parcelRequire("gttSn");

var $kBobk = parcelRequire("kBobk");

var $hgjD5 = parcelRequire("hgjD5");

var $40Pvg = parcelRequire("40Pvg");

var $jE6M6 = parcelRequire("jE6M6");

var $6rQ2O = parcelRequire("6rQ2O");
class $5600e1804506198f$var$TranslationConnectionFactory extends $kBobk.ConnectionFactoryBase {
    constructor(){
        super(...arguments);
        this.universalUri = "/stt/speech/universal/v2";
        this.translationV1Uri = "/speech/translation/cognitiveservices/v1";
    }
    async create(config, authInfo, connectionId) {
        let endpoint = this.getEndpointUrl(config);
        const queryParams = {};
        // Determine if we're using V1 or V2 endpoint
        this.setQueryParams(queryParams, config, endpoint);
        if (!!endpoint) {
            const endpointUrl = new URL(endpoint);
            const pathName = endpointUrl.pathname;
            if (pathName === "" || pathName === "/") {
                // We need to generate the path, and we need to check for a redirect.
                endpointUrl.pathname = this.universalUri;
                endpoint = await $kBobk.ConnectionFactoryBase.getRedirectUrlFromEndpoint(endpointUrl.toString());
            }
        }
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$40Pvg.HeaderNames.ConnectionId] = connectionId;
        config.parameters.setProperty($gttSn.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        const webSocketConnection = new $s6RJO.WebsocketConnection(endpoint, queryParams, headers, new $hgjD5.WebsocketMessageFormatter(), $s6RJO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        return webSocketConnection;
    }
    getEndpointUrl(config, returnRegionPlaceholder) {
        const region = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Region);
        const hostSuffix = $kBobk.ConnectionFactoryBase.getHostSuffix(region);
        // First check for an explicitly specified endpoint
        let endpointUrl = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        // If an explicit endpoint is provided, use it
        if (endpointUrl) {
            if (returnRegionPlaceholder === true) return endpointUrl;
            return $7HCM3.StringUtils.formatString(endpointUrl, {
                region: region
            });
        }
        // Check if V1 endpoint is explicitly requested
        const forceV1Endpoint = config.parameters.getProperty("SPEECH-ForceV1Endpoint", "false") === "true";
        if (forceV1Endpoint) {
            // Use V1 endpoint with s2s.speech host
            const host = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Host, "wss://{region}.s2s.speech" + hostSuffix);
            endpointUrl = host + this.translationV1Uri;
        } else {
            // Default to V2 endpoint with stt.speech host
            const host = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Host, "wss://{region}.stt.speech" + hostSuffix);
            endpointUrl = host + this.universalUri;
        }
        if (returnRegionPlaceholder === true) return endpointUrl;
        return $7HCM3.StringUtils.formatString(endpointUrl, {
            region: region
        });
    }
    setQueryParams(queryParams, config, endpointUrl) {
        // Common parameters for both V1 and V2 endpoints
        queryParams.from = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage);
        queryParams.to = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationToLanguages);
        queryParams.scenario = config.recognitionMode === $6rQ2O.RecognitionMode.Interactive ? "interactive" : config.recognitionMode === $6rQ2O.RecognitionMode.Conversation ? "conversation" : "";
        // Set common parameters
        this.setCommonUrlParams(config, queryParams, endpointUrl);
        this.setUrlParameter($gttSn.PropertyId.SpeechServiceResponse_TranslationRequestStablePartialResult, $jE6M6.QueryParameterNames.StableTranslation, config, queryParams, endpointUrl);
        // Handle translation voice if specified
        const translationVoice = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
        if (translationVoice !== undefined) {
            queryParams.voice = translationVoice;
            // Updated to match C++ implementation
            queryParams.features = "requireVoice";
        }
    }
}
module.exports.TranslationConnectionFactory = $5600e1804506198f$var$TranslationConnectionFactory;

});

parcelRegister("3up4e", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EnumTranslation = void 0;

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");
class $28a79e45593b71ca$var$EnumTranslation {
    static implTranslateRecognitionResult(recognitionStatus, expectEndOfDictation = false) {
        let reason = $gttSn.ResultReason.Canceled;
        switch(recognitionStatus){
            case $hgjD5.RecognitionStatus.Success:
                reason = $gttSn.ResultReason.RecognizedSpeech;
                break;
            case $hgjD5.RecognitionStatus.EndOfDictation:
                // If we need the result in EndOfDictation (typically some session level result),
                // translate into RecognizedSpeech, otherwise NoMatch
                reason = expectEndOfDictation ? $gttSn.ResultReason.RecognizedSpeech : $gttSn.ResultReason.NoMatch;
                break;
            case $hgjD5.RecognitionStatus.NoMatch:
            case $hgjD5.RecognitionStatus.InitialSilenceTimeout:
            case $hgjD5.RecognitionStatus.BabbleTimeout:
                reason = $gttSn.ResultReason.NoMatch;
                break;
            case $hgjD5.RecognitionStatus.Error:
            case $hgjD5.RecognitionStatus.BadRequest:
            case $hgjD5.RecognitionStatus.Forbidden:
            default:
                reason = $gttSn.ResultReason.Canceled;
                break;
        }
        return reason;
    }
    static implTranslateCancelResult(recognitionStatus) {
        let reason = $gttSn.CancellationReason.EndOfStream;
        switch(recognitionStatus){
            case $hgjD5.RecognitionStatus.Success:
            case $hgjD5.RecognitionStatus.EndOfDictation:
            case $hgjD5.RecognitionStatus.NoMatch:
                reason = $gttSn.CancellationReason.EndOfStream;
                break;
            case $hgjD5.RecognitionStatus.InitialSilenceTimeout:
            case $hgjD5.RecognitionStatus.BabbleTimeout:
            case $hgjD5.RecognitionStatus.Error:
            case $hgjD5.RecognitionStatus.BadRequest:
            case $hgjD5.RecognitionStatus.Forbidden:
            default:
                reason = $gttSn.CancellationReason.Error;
                break;
        }
        return reason;
    }
    static implTranslateCancelErrorCode(recognitionStatus) {
        let reason = $gttSn.CancellationErrorCode.NoError;
        switch(recognitionStatus){
            case $hgjD5.RecognitionStatus.Error:
                reason = $gttSn.CancellationErrorCode.ServiceError;
                break;
            case $hgjD5.RecognitionStatus.TooManyRequests:
                reason = $gttSn.CancellationErrorCode.TooManyRequests;
                break;
            case $hgjD5.RecognitionStatus.BadRequest:
                reason = $gttSn.CancellationErrorCode.BadRequestParameters;
                break;
            case $hgjD5.RecognitionStatus.Forbidden:
                reason = $gttSn.CancellationErrorCode.Forbidden;
                break;
            default:
                reason = $gttSn.CancellationErrorCode.NoError;
                break;
        }
        return reason;
    }
    static implTranslateErrorDetails(cancellationErrorCode) {
        let errorDetails = "The speech service encountered an internal error and could not continue.";
        switch(cancellationErrorCode){
            case $gttSn.CancellationErrorCode.Forbidden:
                errorDetails = "The recognizer is using a free subscription that ran out of quota.";
                break;
            case $gttSn.CancellationErrorCode.BadRequestParameters:
                errorDetails = "Invalid parameter or unsupported audio format in the request.";
                break;
            case $gttSn.CancellationErrorCode.TooManyRequests:
                errorDetails = "The number of parallel requests exceeded the number of allowed concurrent transcriptions.";
                break;
            default:
                break;
        }
        return errorDetails;
    }
}
module.exports.EnumTranslation = $28a79e45593b71ca$var$EnumTranslation;

});

parcelRegister("gNbeL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionStatus = module.exports.SynthesisStatus = void 0;
/**
 * @class SynthesisStatus
 * @private
 */ var $c399f068c86ad2e8$var$SynthesisStatus;
(function(SynthesisStatus) {
    /**
     * The response contains valid audio data.
     * @member SynthesisStatus.Success
     */ SynthesisStatus[SynthesisStatus["Success"] = 0] = "Success";
    /**
     * Indicates the end of audio data. No valid audio data is included in the message.
     * @member SynthesisStatus.SynthesisEnd
     */ SynthesisStatus[SynthesisStatus["SynthesisEnd"] = 1] = "SynthesisEnd";
    /**
     * Indicates an error occurred during synthesis data processing.
     * @member SynthesisStatus.Error
     */ SynthesisStatus[SynthesisStatus["Error"] = 2] = "Error";
})($c399f068c86ad2e8$var$SynthesisStatus = module.exports.SynthesisStatus || (module.exports.SynthesisStatus = {}));
var $c399f068c86ad2e8$var$RecognitionStatus;
(function(RecognitionStatus) {
    RecognitionStatus[RecognitionStatus["Success"] = 0] = "Success";
    RecognitionStatus[RecognitionStatus["NoMatch"] = 1] = "NoMatch";
    RecognitionStatus[RecognitionStatus["InitialSilenceTimeout"] = 2] = "InitialSilenceTimeout";
    RecognitionStatus[RecognitionStatus["BabbleTimeout"] = 3] = "BabbleTimeout";
    RecognitionStatus[RecognitionStatus["Error"] = 4] = "Error";
    RecognitionStatus[RecognitionStatus["EndOfDictation"] = 5] = "EndOfDictation";
    RecognitionStatus[RecognitionStatus["TooManyRequests"] = 6] = "TooManyRequests";
    RecognitionStatus[RecognitionStatus["BadRequest"] = 7] = "BadRequest";
    RecognitionStatus[RecognitionStatus["Forbidden"] = 8] = "Forbidden";
})($c399f068c86ad2e8$var$RecognitionStatus = module.exports.RecognitionStatus || (module.exports.RecognitionStatus = {}));

});

parcelRegister("1epFV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisEnd = void 0;

var $hgjD5 = parcelRequire("hgjD5");
class $0e5b03d42a84aaf6$var$TranslationSynthesisEnd {
    constructor(json){
        this.privSynthesisEnd = JSON.parse(json);
        if (!!this.privSynthesisEnd.SynthesisStatus) this.privSynthesisEnd.SynthesisStatus = $hgjD5.SynthesisStatus[this.privSynthesisEnd.SynthesisStatus];
        if (!!this.privSynthesisEnd.Status) this.privSynthesisEnd.SynthesisStatus = $hgjD5.SynthesisStatus[this.privSynthesisEnd.Status];
    }
    static fromJSON(json) {
        return new $0e5b03d42a84aaf6$var$TranslationSynthesisEnd(json);
    }
    get SynthesisStatus() {
        return this.privSynthesisEnd.SynthesisStatus;
    }
    get FailureReason() {
        return this.privSynthesisEnd.FailureReason;
    }
}
module.exports.TranslationSynthesisEnd = $0e5b03d42a84aaf6$var$TranslationSynthesisEnd;

});

parcelRegister("7sc1G", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationHypothesis = void 0;

var $3SMEZ = parcelRequire("3SMEZ");

var $iv8Pq = parcelRequire("iv8Pq");
class $56d47a1602f8b116$var$TranslationHypothesis {
    constructor(hypothesis, baseOffset){
        this.privTranslationHypothesis = hypothesis;
        this.privTranslationHypothesis.Offset += baseOffset;
        this.privTranslationHypothesis.Translation.TranslationStatus = this.mapTranslationStatus(this.privTranslationHypothesis.Translation.TranslationStatus);
    }
    static fromJSON(json, baseOffset) {
        return new $56d47a1602f8b116$var$TranslationHypothesis(JSON.parse(json), baseOffset);
    }
    static fromTranslationResponse(translationHypothesis, baseOffset) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(translationHypothesis, "translationHypothesis");
        const hypothesis = translationHypothesis.SpeechHypothesis;
        translationHypothesis.SpeechHypothesis = undefined;
        hypothesis.Translation = translationHypothesis;
        return new $56d47a1602f8b116$var$TranslationHypothesis(hypothesis, baseOffset);
    }
    get Duration() {
        return this.privTranslationHypothesis.Duration;
    }
    get Offset() {
        return this.privTranslationHypothesis.Offset;
    }
    get Text() {
        return this.privTranslationHypothesis.Text;
    }
    get Translation() {
        return this.privTranslationHypothesis.Translation;
    }
    get Language() {
        return this.privTranslationHypothesis.PrimaryLanguage?.Language;
    }
    asJson() {
        const jsonObj = {
            ...this.privTranslationHypothesis
        };
        // Convert the enum value to its string representation for serialization purposes.
        return jsonObj.Translation !== undefined ? JSON.stringify({
            ...jsonObj,
            TranslationStatus: $iv8Pq.TranslationStatus[jsonObj.Translation.TranslationStatus]
        }) : JSON.stringify(jsonObj);
    }
    mapTranslationStatus(status) {
        if (typeof status === "string") return $iv8Pq.TranslationStatus[status];
        else if (typeof status === "number") return status;
    }
}
module.exports.TranslationHypothesis = $56d47a1602f8b116$var$TranslationHypothesis;

});

parcelRegister("iZPBw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationPhrase = void 0;

var $3SMEZ = parcelRequire("3SMEZ");

var $hgjD5 = parcelRequire("hgjD5");

var $iv8Pq = parcelRequire("iv8Pq");
class $dd45f4050dd824c4$var$TranslationPhrase {
    constructor(phrase, baseOffset){
        this.privTranslationPhrase = phrase;
        this.privTranslationPhrase.Offset += baseOffset;
        this.privTranslationPhrase.RecognitionStatus = this.mapRecognitionStatus(this.privTranslationPhrase.RecognitionStatus);
        if (this.privTranslationPhrase.Translation !== undefined) this.privTranslationPhrase.Translation.TranslationStatus = this.mapTranslationStatus(this.privTranslationPhrase.Translation.TranslationStatus);
    }
    static fromJSON(json, baseOffset) {
        return new $dd45f4050dd824c4$var$TranslationPhrase(JSON.parse(json), baseOffset);
    }
    static fromTranslationResponse(translationResponse, baseOffset) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(translationResponse, "translationResponse");
        const phrase = translationResponse.SpeechPhrase;
        translationResponse.SpeechPhrase = undefined;
        phrase.Translation = translationResponse;
        phrase.Text = phrase.DisplayText;
        return new $dd45f4050dd824c4$var$TranslationPhrase(phrase, baseOffset);
    }
    get RecognitionStatus() {
        return this.privTranslationPhrase.RecognitionStatus;
    }
    get Offset() {
        return this.privTranslationPhrase.Offset;
    }
    get Duration() {
        return this.privTranslationPhrase.Duration;
    }
    get Text() {
        return this.privTranslationPhrase.Text;
    }
    get Language() {
        return this.privTranslationPhrase.PrimaryLanguage?.Language;
    }
    get Confidence() {
        return this.privTranslationPhrase.PrimaryLanguage?.Confidence;
    }
    get Translation() {
        return this.privTranslationPhrase.Translation;
    }
    asJson() {
        const jsonObj = {
            ...this.privTranslationPhrase
        };
        // Convert the enum values to their string representations for serialization
        const serializedObj = {
            ...jsonObj,
            RecognitionStatus: $hgjD5.RecognitionStatus[jsonObj.RecognitionStatus]
        };
        if (jsonObj.Translation) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        serializedObj.Translation = {
            ...jsonObj.Translation,
            TranslationStatus: $iv8Pq.TranslationStatus[jsonObj.Translation.TranslationStatus]
        };
        return JSON.stringify(serializedObj);
    }
    mapRecognitionStatus(status) {
        if (typeof status === "string") return $hgjD5.RecognitionStatus[status];
        else if (typeof status === "number") return status;
    }
    mapTranslationStatus(status) {
        if (typeof status === "string") return $iv8Pq.TranslationStatus[status];
        else if (typeof status === "number") return status;
    }
}
module.exports.TranslationPhrase = $dd45f4050dd824c4$var$TranslationPhrase;

});

parcelRegister("24xBg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationServiceRecognizer = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");
// eslint-disable-next-line max-classes-per-file
class $182604beb66ae2b0$var$TranslationServiceRecognizer extends $hgjD5.ConversationServiceRecognizer {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer);
        this.privTranslationRecognizer = translationRecognizer;
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionEstablishedEvent") this.privTranslationRecognizer.onConnection();
        });
    }
    async processTypeSpecificMessages(connectionMessage) {
        const resultProps = new $gttSn.PropertyCollection();
        let processed = await this.processSpeechMessages(connectionMessage);
        if (processed) return true;
        const handleTranslationPhrase = async (translatedPhrase)=>{
            resultProps.setProperty($gttSn.PropertyId.SpeechServiceResponse_JsonResult, translatedPhrase.asJson());
            this.privRequestSession.onPhraseRecognized(translatedPhrase.Offset + translatedPhrase.Duration);
            if (translatedPhrase.RecognitionStatus === $hgjD5.RecognitionStatus.Success) {
                // OK, the recognition was successful. How'd the translation do?
                const result = this.fireEventForResult(translatedPhrase, resultProps);
                if (!!this.privTranslationRecognizer.recognized) try {
                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, result);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                // report result to promise.
                if (!!this.privSuccessCallback) {
                    try {
                        this.privSuccessCallback(result.result);
                    } catch (e) {
                        if (!!this.privErrorCallback) this.privErrorCallback(e);
                    }
                    // Only invoke the call back once.
                    // and if it's successful don't invoke the
                    // error after that.
                    this.privSuccessCallback = undefined;
                    this.privErrorCallback = undefined;
                }
            } else {
                const reason = $hgjD5.EnumTranslation.implTranslateRecognitionResult(translatedPhrase.RecognitionStatus);
                const result = new $gttSn.TranslationRecognitionResult(undefined, this.privRequestSession.requestId, reason, translatedPhrase.Text, translatedPhrase.Duration, translatedPhrase.Offset, translatedPhrase.Language, translatedPhrase.Confidence, undefined, translatedPhrase.asJson(), resultProps);
                if (reason === $gttSn.ResultReason.Canceled) {
                    const cancelReason = $hgjD5.EnumTranslation.implTranslateCancelResult(translatedPhrase.RecognitionStatus);
                    const cancellationErrorCode = $hgjD5.EnumTranslation.implTranslateCancelErrorCode(translatedPhrase.RecognitionStatus);
                    await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $hgjD5.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
                } else if (translatedPhrase.RecognitionStatus !== $hgjD5.RecognitionStatus.EndOfDictation) {
                    const ev = new $gttSn.TranslationRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                    if (!!this.privTranslationRecognizer.recognized) try {
                        this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    // report result to promise.
                    if (!!this.privSuccessCallback) {
                        try {
                            this.privSuccessCallback(result);
                        } catch (e) {
                            if (!!this.privErrorCallback) this.privErrorCallback(e);
                        }
                        // Only invoke the call back once.
                        // and if it's successful don't invoke the
                        // error after that.
                        this.privSuccessCallback = undefined;
                        this.privErrorCallback = undefined;
                    }
                }
                processed = true;
            }
        };
        const handleTranslationHypothesis = (hypothesis)=>{
            resultProps.setProperty($gttSn.PropertyId.SpeechServiceResponse_JsonResult, hypothesis.asJson());
            const result = this.fireEventForResult(hypothesis, resultProps);
            this.privRequestSession.onHypothesis(result.offset);
            if (!!this.privTranslationRecognizer.recognizing) try {
                this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, result);
            /* eslint-disable no-empty */ } catch (error) {
            // Not going to let errors in the event handler
            // trip things up.
            }
            processed = true;
        };
        if (connectionMessage.messageType === $5OUhN.MessageType.Text) resultProps.setProperty($gttSn.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            case "translation.hypothesis":
                handleTranslationHypothesis($hgjD5.TranslationHypothesis.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset));
                break;
            case "translation.response":
                const phrase = JSON.parse(connectionMessage.textBody);
                if (!!phrase.SpeechPhrase) await handleTranslationPhrase($hgjD5.TranslationPhrase.fromTranslationResponse(phrase, this.privRequestSession.currentTurnAudioOffset));
                else {
                    const hypothesis = JSON.parse(connectionMessage.textBody);
                    if (!!hypothesis.SpeechHypothesis) handleTranslationHypothesis($hgjD5.TranslationHypothesis.fromTranslationResponse(hypothesis, this.privRequestSession.currentTurnAudioOffset));
                }
                break;
            case "translation.phrase":
                await handleTranslationPhrase($hgjD5.TranslationPhrase.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset));
                break;
            case "translation.synthesis":
            case "audio":
                this.sendSynthesisAudio(connectionMessage.binaryBody, this.privRequestSession.sessionId);
                processed = true;
                break;
            case "audio.end":
            case "translation.synthesis.end":
                const synthEnd = $hgjD5.TranslationSynthesisEnd.fromJSON(connectionMessage.textBody);
                switch(synthEnd.SynthesisStatus){
                    case $hgjD5.SynthesisStatus.Error:
                        if (!!this.privTranslationRecognizer.synthesizing) {
                            const result = new $gttSn.TranslationSynthesisResult($gttSn.ResultReason.Canceled, undefined);
                            const retEvent = new $gttSn.TranslationSynthesisEventArgs(result, this.privRequestSession.sessionId);
                            try {
                                this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
                            /* eslint-disable no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        if (!!this.privTranslationRecognizer.canceled) {
                            // And raise a canceled event to send the rich(er) error message back.
                            const canceledResult = new $gttSn.TranslationRecognitionCanceledEventArgs(this.privRequestSession.sessionId, $gttSn.CancellationReason.Error, synthEnd.FailureReason, $gttSn.CancellationErrorCode.ServiceError, null);
                            try {
                                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, canceledResult);
                            /* eslint-disable no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        break;
                    case $hgjD5.SynthesisStatus.Success:
                        this.sendSynthesisAudio(undefined, this.privRequestSession.sessionId);
                        break;
                    default:
                        break;
                }
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $gttSn.PropertyCollection();
        properties.setProperty($hgjD5.CancellationErrorCodePropertyName, $gttSn.CancellationErrorCode[errorCode]);
        if (!!this.privTranslationRecognizer.canceled) {
            const cancelEvent = new $gttSn.TranslationRecognitionCanceledEventArgs(sessionId, cancellationReason, error, errorCode, undefined);
            try {
                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
        if (!!this.privSuccessCallback) {
            const result = new $gttSn.TranslationRecognitionResult(undefined, requestId, $gttSn.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                /* eslint-disable no-empty */ this.privSuccessCallback = undefined;
            } catch  {}
        }
    }
    handleRecognizingCallback(result, offset, sessionId) {
        try {
            const ev = new $gttSn.TranslationRecognitionEventArgs($gttSn.TranslationRecognitionResult.fromSpeechRecognitionResult(result), offset, sessionId);
            this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, ev);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    handleRecognizedCallback(result, offset, sessionId) {
        try {
            const ev = new $gttSn.TranslationRecognitionEventArgs($gttSn.TranslationRecognitionResult.fromSpeechRecognitionResult(result), offset, sessionId);
            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    fireEventForResult(serviceResult, properties) {
        let translations;
        if (undefined !== serviceResult.Translation.Translations) {
            translations = new $gttSn.Translations();
            for (const translation of serviceResult.Translation.Translations)translations.set(translation.Language, translation.Text || translation.DisplayText);
        }
        let resultReason;
        let confidence;
        if (serviceResult instanceof $hgjD5.TranslationPhrase) {
            if (!!serviceResult.Translation && serviceResult.Translation.TranslationStatus === $5OUhN.TranslationStatus.Success) resultReason = $gttSn.ResultReason.TranslatedSpeech;
            else resultReason = $gttSn.ResultReason.RecognizedSpeech;
            confidence = serviceResult.Confidence;
        } else resultReason = $gttSn.ResultReason.TranslatingSpeech;
        const language = serviceResult.Language;
        const result = new $gttSn.TranslationRecognitionResult(translations, this.privRequestSession.requestId, resultReason, serviceResult.Text, serviceResult.Duration, serviceResult.Offset, language, confidence, serviceResult.Translation.FailureReason, serviceResult.asJson(), properties);
        const ev = new $gttSn.TranslationRecognitionEventArgs(result, serviceResult.Offset, this.privRequestSession.sessionId);
        return ev;
    }
    sendSynthesisAudio(audio, sessionId) {
        const reason = undefined === audio ? $gttSn.ResultReason.SynthesizingAudioCompleted : $gttSn.ResultReason.SynthesizingAudio;
        const result = new $gttSn.TranslationSynthesisResult(reason, audio);
        const retEvent = new $gttSn.TranslationSynthesisEventArgs(result, sessionId);
        if (!!this.privTranslationRecognizer.synthesizing) try {
            this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
}
module.exports.TranslationServiceRecognizer = $182604beb66ae2b0$var$TranslationServiceRecognizer;

});

parcelRegister("5Xm3f", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechDetected = void 0;
class $45639161942a5125$var$SpeechDetected {
    constructor(json, baseOffset){
        this.privSpeechStartDetected = JSON.parse(json);
        this.privSpeechStartDetected.Offset += baseOffset;
    }
    static fromJSON(json, baseOffset) {
        return new $45639161942a5125$var$SpeechDetected(json, baseOffset);
    }
    get Offset() {
        return this.privSpeechStartDetected.Offset;
    }
}
module.exports.SpeechDetected = $45639161942a5125$var$SpeechDetected;

});

parcelRegister("buBkw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechHypothesis = void 0;
class $85df73fdb05916be$var$SpeechHypothesis {
    constructor(json, baseOffset){
        this.privSpeechHypothesis = JSON.parse(json);
        this.updateOffset(baseOffset);
    }
    static fromJSON(json, baseOffset) {
        return new $85df73fdb05916be$var$SpeechHypothesis(json, baseOffset);
    }
    updateOffset(baseOffset) {
        this.privSpeechHypothesis.Offset += baseOffset;
    }
    asJson() {
        return JSON.stringify(this.privSpeechHypothesis);
    }
    get Text() {
        return this.privSpeechHypothesis.Text;
    }
    get Offset() {
        return this.privSpeechHypothesis.Offset;
    }
    get Duration() {
        return this.privSpeechHypothesis.Duration;
    }
    get Language() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSpeechHypothesis.SpeakerId;
    }
}
module.exports.SpeechHypothesis = $85df73fdb05916be$var$SpeechHypothesis;

});

parcelRegister("6Rigu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechKeyword = void 0;
class $4fe5dc549adfe3a0$var$SpeechKeyword {
    constructor(json, baseOffset){
        this.privSpeechKeyword = JSON.parse(json);
        this.privSpeechKeyword.Offset += baseOffset;
    }
    static fromJSON(json, baseOffset) {
        return new $4fe5dc549adfe3a0$var$SpeechKeyword(json, baseOffset);
    }
    get Status() {
        return this.privSpeechKeyword.Status;
    }
    get Text() {
        return this.privSpeechKeyword.Text;
    }
    get Offset() {
        return this.privSpeechKeyword.Offset;
    }
    get Duration() {
        return this.privSpeechKeyword.Duration;
    }
    asJson() {
        return JSON.stringify(this.privSpeechKeyword);
    }
}
module.exports.SpeechKeyword = $4fe5dc549adfe3a0$var$SpeechKeyword;

});

parcelRegister("7w59Q", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechServiceRecognizer = void 0;

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");
// eslint-disable-next-line max-classes-per-file
class $578f85c59f575ac7$var$SpeechServiceRecognizer extends $hgjD5.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer);
        this.privSpeechRecognizer = speechRecognizer;
    }
    async processTypeSpecificMessages(connectionMessage) {
        let result;
        const resultProps = new $gttSn.PropertyCollection();
        let processed = false;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
            case "speech.fragment":
                const hypothesis = $hgjD5.SpeechHypothesis.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset);
                resultProps.setProperty($gttSn.PropertyId.SpeechServiceResponse_JsonResult, hypothesis.asJson());
                result = new $gttSn.SpeechRecognitionResult(this.privRequestSession.requestId, $gttSn.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, hypothesis.Offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, hypothesis.asJson(), resultProps);
                this.privRequestSession.onHypothesis(hypothesis.Offset);
                const ev = new $gttSn.SpeechRecognitionEventArgs(result, hypothesis.Offset, this.privRequestSession.sessionId);
                if (!!this.privSpeechRecognizer.recognizing) try {
                    this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.phrase":
                const simple = $hgjD5.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset);
                resultProps.setProperty($gttSn.PropertyId.SpeechServiceResponse_JsonResult, simple.asJson());
                const resultReason = $hgjD5.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus, this.privExpectContentAssessmentResponse);
                this.privRequestSession.onPhraseRecognized(simple.Offset + simple.Duration);
                if ($gttSn.ResultReason.Canceled === resultReason) {
                    const cancelReason = $hgjD5.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
                    const cancellationErrorCode = $hgjD5.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus);
                    await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $hgjD5.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
                } else {
                    // Like the native SDK's, don't event / return an EndOfDictation message.
                    if (simple.RecognitionStatus === $hgjD5.RecognitionStatus.EndOfDictation) break;
                    if (this.privRecognizerConfig.parameters.getProperty($hgjD5.OutputFormatPropertyName) === $gttSn.OutputFormat[$gttSn.OutputFormat.Simple]) result = new $gttSn.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset, simple.Language, simple.LanguageDetectionConfidence, undefined, undefined, simple.asJson(), resultProps);
                    else {
                        const detailed = $hgjD5.DetailedSpeechPhrase.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset);
                        resultProps.setProperty($gttSn.PropertyId.SpeechServiceResponse_JsonResult, detailed.asJson());
                        result = new $gttSn.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === $hgjD5.RecognitionStatus.Success ? detailed.NBest[0].Display : "", detailed.Duration, detailed.Offset, detailed.Language, detailed.LanguageDetectionConfidence, undefined, undefined, detailed.asJson(), resultProps);
                    }
                    const event = new $gttSn.SpeechRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                    if (!!this.privSpeechRecognizer.recognized) try {
                        this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, event);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    if (!!this.privSuccessCallback) {
                        try {
                            this.privSuccessCallback(result);
                        } catch (e) {
                            if (!!this.privErrorCallback) this.privErrorCallback(e);
                        }
                        // Only invoke the call back once.
                        // and if it's successful don't invoke the
                        // error after that.
                        this.privSuccessCallback = undefined;
                        this.privErrorCallback = undefined;
                    }
                }
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $gttSn.PropertyCollection();
        properties.setProperty($hgjD5.CancellationErrorCodePropertyName, $gttSn.CancellationErrorCode[errorCode]);
        if (!!this.privSpeechRecognizer.canceled) {
            const cancelEvent = new $gttSn.SpeechRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
        if (!!this.privSuccessCallback) {
            const result = new $gttSn.SpeechRecognitionResult(requestId, $gttSn.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch  {}
        }
    }
}
module.exports.SpeechServiceRecognizer = $578f85c59f575ac7$var$SpeechServiceRecognizer;

});

parcelRegister("19jLl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionServiceRecognizer = void 0;

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");

var $5p4li = parcelRequire("5p4li");

var $6rQ2O = parcelRequire("6rQ2O");
// eslint-disable-next-line max-classes-per-file
class $0d65f62d17c84537$var$ConversationTranscriptionServiceRecognizer extends $hgjD5.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, conversationTranscriber){
        super(authentication, connectionFactory, audioSource, recognizerConfig, conversationTranscriber);
        this.privConversationTranscriber = conversationTranscriber;
        this.setSpeakerDiarizationJson();
    }
    setSpeakerDiarizationJson() {
        if (this.privEnableSpeakerId) {
            const phraseDetection = this.privSpeechContext.getContext().phraseDetection || {};
            phraseDetection.mode = $6rQ2O.RecognitionMode.Conversation;
            const speakerDiarization = {};
            speakerDiarization.mode = $5p4li.SpeakerDiarizationMode.Anonymous;
            speakerDiarization.audioSessionId = this.privDiarizationSessionId;
            speakerDiarization.audioOffsetMs = 0;
            speakerDiarization.diarizeIntermediates = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceResponse_DiarizeIntermediateResults, "false") === "true";
            phraseDetection.speakerDiarization = speakerDiarization;
            this.privSpeechContext.getContext().phraseDetection = phraseDetection;
        }
    }
    async processTypeSpecificMessages(connectionMessage) {
        let result;
        const resultProps = new $gttSn.PropertyCollection();
        resultProps.setProperty($gttSn.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        let processed = false;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
            case "speech.fragment":
                const hypothesis = $hgjD5.SpeechHypothesis.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset);
                result = new $gttSn.ConversationTranscriptionResult(this.privRequestSession.requestId, $gttSn.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, hypothesis.Offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, hypothesis.SpeakerId, undefined, hypothesis.asJson(), resultProps);
                this.privRequestSession.onHypothesis(hypothesis.Offset);
                const ev = new $gttSn.ConversationTranscriptionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                if (!!this.privConversationTranscriber.transcribing) try {
                    this.privConversationTranscriber.transcribing(this.privConversationTranscriber, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.phrase":
                const simple = $hgjD5.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset);
                const resultReason = $hgjD5.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus);
                this.privRequestSession.onPhraseRecognized(simple.Offset + simple.Duration);
                if ($gttSn.ResultReason.Canceled === resultReason) {
                    const cancelReason = $hgjD5.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
                    const cancellationErrorCode = $hgjD5.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus);
                    await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $hgjD5.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
                } else if (!(this.privRequestSession.isSpeechEnded && resultReason === $gttSn.ResultReason.NoMatch && simple.RecognitionStatus !== $hgjD5.RecognitionStatus.InitialSilenceTimeout)) {
                    if (this.privRecognizerConfig.parameters.getProperty($hgjD5.OutputFormatPropertyName) === $gttSn.OutputFormat[$gttSn.OutputFormat.Simple]) result = new $gttSn.ConversationTranscriptionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset, simple.Language, simple.LanguageDetectionConfidence, simple.SpeakerId, undefined, simple.asJson(), resultProps);
                    else {
                        const detailed = $hgjD5.DetailedSpeechPhrase.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset);
                        result = new $gttSn.ConversationTranscriptionResult(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === $hgjD5.RecognitionStatus.Success ? detailed.NBest[0].Display : undefined, detailed.Duration, detailed.Offset, detailed.Language, detailed.LanguageDetectionConfidence, simple.SpeakerId, undefined, detailed.asJson(), resultProps);
                    }
                    const event = new $gttSn.ConversationTranscriptionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                    if (!!this.privConversationTranscriber.transcribed) try {
                        this.privConversationTranscriber.transcribed(this.privConversationTranscriber, event);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $gttSn.PropertyCollection();
        properties.setProperty($hgjD5.CancellationErrorCodePropertyName, $gttSn.CancellationErrorCode[errorCode]);
        if (!!this.privConversationTranscriber.canceled) {
            const cancelEvent = new $gttSn.ConversationTranscriptionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privConversationTranscriber.canceled(this.privConversationTranscriber, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
    }
}
module.exports.ConversationTranscriptionServiceRecognizer = $0d65f62d17c84537$var$ConversationTranscriptionServiceRecognizer;

});
parcelRegister("5p4li", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IdentityProvider = module.exports.SpeakerDiarizationMode = void 0;
/**
 * The speaker diarization mode
 */ var $3ef2a7e20db22d9b$var$SpeakerDiarizationMode;
(function(SpeakerDiarizationMode) {
    SpeakerDiarizationMode["None"] = "None";
    SpeakerDiarizationMode["Identity"] = "Identity";
    SpeakerDiarizationMode["Anonymous"] = "Anonymous";
})($3ef2a7e20db22d9b$var$SpeakerDiarizationMode = module.exports.SpeakerDiarizationMode || (module.exports.SpeakerDiarizationMode = {}));
/**
 * The identity provider
 */ var $3ef2a7e20db22d9b$var$IdentityProvider;
(function(IdentityProvider) {
    IdentityProvider["CallCenter"] = "CallCenter";
})($3ef2a7e20db22d9b$var$IdentityProvider = module.exports.IdentityProvider || (module.exports.IdentityProvider = {}));

});


parcelRegister("8QE2v", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriptionServiceRecognizer = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");

var $ccM4b = parcelRequire("ccM4b");
// eslint-disable-next-line max-classes-per-file
class $67123d10edf5e700$var$TranscriptionServiceRecognizer extends $hgjD5.ConversationServiceRecognizer {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, transcriber){
        super(authentication, connectionFactory, audioSource, recognizerConfig, transcriber);
        this.privTranscriberRecognizer = transcriber;
        this.sendPrePayloadJSONOverride = (connection)=>this.sendTranscriptionStartJSON(connection);
        if (this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps) === "true") this.privSpeechContext.setWordLevelTimings();
    }
    async sendSpeechEventAsync(info, command) {
        if (!!this.privRequestSession.isRecognizing) {
            const connection = await this.fetchConnection();
            await this.sendSpeechEvent(connection, this.createSpeechEventPayload(info, command));
        }
    }
    async sendMeetingSpeechEventAsync(info, command) {
        if (!!this.privRequestSession.isRecognizing) {
            const connection = await this.fetchConnection();
            await this.sendSpeechEvent(connection, this.createMeetingSpeechEventPayload(info, command));
        }
    }
    processTypeSpecificMessages(connectionMessage) {
        return this.processSpeechMessages(connectionMessage);
    }
    handleRecognizedCallback(result, offset, sessionId) {
        try {
            const event = new $gttSn.SpeechRecognitionEventArgs(result, offset, sessionId);
            this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, event);
            if (!!this.privSuccessCallback) {
                try {
                    this.privSuccessCallback(result);
                } catch (e) {
                    if (!!this.privErrorCallback) this.privErrorCallback(e);
                }
                // Only invoke the call back once.
                // and if it's successful don't invoke the
                // error after that.
                this.privSuccessCallback = undefined;
                this.privErrorCallback = undefined;
            }
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    handleRecognizingCallback(result, duration, sessionId) {
        try {
            const ev = new $gttSn.SpeechRecognitionEventArgs(result, duration, sessionId);
            this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, ev);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $gttSn.PropertyCollection();
        properties.setProperty($hgjD5.CancellationErrorCodePropertyName, $gttSn.CancellationErrorCode[errorCode]);
        if (this.privTranscriberRecognizer.IsMeetingRecognizer()) {
            if (!!this.privTranscriberRecognizer.canceled) {
                const cancelEvent = new $gttSn.MeetingTranscriptionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
                try {
                    this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, cancelEvent);
                /* eslint-disable no-empty */ } catch  {}
            }
        } else if (!!this.privTranscriberRecognizer.canceled) {
            const cancelEvent = new $gttSn.ConversationTranscriptionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
        if (!!this.privSuccessCallback) {
            const result = new $gttSn.SpeechRecognitionResult(requestId, $gttSn.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch  {}
        }
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    async sendTranscriptionStartJSON(connection) {
        await this.sendSpeechContext(connection, true);
        if (this.privTranscriberRecognizer.IsMeetingRecognizer()) {
            const info = this.privTranscriberRecognizer.getMeetingInfo();
            const payload = this.createMeetingSpeechEventPayload(info, "start");
            await this.sendSpeechEvent(connection, payload);
        } else {
            const info = this.privTranscriberRecognizer.getConversationInfo();
            const payload = this.createSpeechEventPayload(info, "start");
            await this.sendSpeechEvent(connection, payload);
        }
        await this.sendWaveHeader(connection);
        return;
    }
    sendSpeechEvent(connection, payload) {
        const speechEventJson = JSON.stringify(payload);
        if (speechEventJson) return connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Text, "speech.event", this.privRequestSession.requestId, "application/json", speechEventJson));
        return;
    }
    createSpeechEventPayload(info, command) {
        const eventDict = {
            id: "meeting",
            name: command,
            meeting: info.conversationProperties
        };
        eventDict.meeting.id = info.id;
        eventDict.meeting.attendees = info.participants;
        return eventDict;
    }
    createMeetingSpeechEventPayload(info, command) {
        const eventDict = {
            id: "meeting",
            name: command,
            meeting: info.meetingProperties
        };
        eventDict.meeting.id = info.id;
        eventDict.meeting.attendees = info.participants;
        return eventDict;
    }
}
module.exports.TranscriptionServiceRecognizer = $67123d10edf5e700$var$TranscriptionServiceRecognizer;

});

parcelRegister("cg0MH", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DetailedSpeechPhrase = void 0;

var $hgjD5 = parcelRequire("hgjD5");
class $8ec7966bc80cbded$var$DetailedSpeechPhrase {
    constructor(json, baseOffset){
        this.privDetailedSpeechPhrase = JSON.parse(json);
        this.privDetailedSpeechPhrase.RecognitionStatus = this.mapRecognitionStatus(this.privDetailedSpeechPhrase.RecognitionStatus);
        this.updateOffsets(baseOffset);
    }
    static fromJSON(json, baseOffset) {
        return new $8ec7966bc80cbded$var$DetailedSpeechPhrase(json, baseOffset);
    }
    updateOffsets(baseOffset) {
        this.privDetailedSpeechPhrase.Offset += baseOffset;
        if (!!this.privDetailedSpeechPhrase.NBest) for (const phrase of this.privDetailedSpeechPhrase.NBest){
            if (!!phrase.Words) for (const word of phrase.Words)word.Offset += baseOffset;
            if (!!phrase.DisplayWords) for (const word of phrase.DisplayWords)word.Offset += baseOffset;
        }
    }
    asJson() {
        const jsonObj = {
            ...this.privDetailedSpeechPhrase
        };
        // Convert the enum value to its string representation for serialization purposes.
        return JSON.stringify({
            ...jsonObj,
            RecognitionStatus: $hgjD5.RecognitionStatus[jsonObj.RecognitionStatus]
        });
    }
    get RecognitionStatus() {
        return this.privDetailedSpeechPhrase.RecognitionStatus;
    }
    get NBest() {
        return this.privDetailedSpeechPhrase.NBest;
    }
    get Duration() {
        return this.privDetailedSpeechPhrase.Duration;
    }
    get Offset() {
        return this.privDetailedSpeechPhrase.Offset;
    }
    get Language() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get Text() {
        if (!!this.privDetailedSpeechPhrase.NBest && this.privDetailedSpeechPhrase.NBest[0]) return this.privDetailedSpeechPhrase.NBest[0].Display || this.privDetailedSpeechPhrase.NBest[0].DisplayText;
        return this.privDetailedSpeechPhrase.DisplayText;
    }
    get SpeakerId() {
        return this.privDetailedSpeechPhrase.SpeakerId;
    }
    mapRecognitionStatus(status) {
        if (typeof status === "string") return $hgjD5.RecognitionStatus[status];
        else if (typeof status === "number") return status;
    }
}
module.exports.DetailedSpeechPhrase = $8ec7966bc80cbded$var$DetailedSpeechPhrase;

});

parcelRegister("jsqMv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleSpeechPhrase = void 0;

var $hgjD5 = parcelRequire("hgjD5");
class $e2a5680a4142a753$var$SimpleSpeechPhrase {
    constructor(json, baseOffset = 0){
        this.privSimpleSpeechPhrase = JSON.parse(json);
        this.privSimpleSpeechPhrase.RecognitionStatus = this.mapRecognitionStatus(this.privSimpleSpeechPhrase.RecognitionStatus); // RecognitionStatus[this.privSimpleSpeechPhrase.RecognitionStatus as unknown as keyof typeof RecognitionStatus];
        this.updateOffset(baseOffset);
    }
    static fromJSON(json, baseOffset) {
        return new $e2a5680a4142a753$var$SimpleSpeechPhrase(json, baseOffset);
    }
    updateOffset(baseOffset) {
        this.privSimpleSpeechPhrase.Offset += baseOffset;
    }
    asJson() {
        const jsonObj = {
            ...this.privSimpleSpeechPhrase
        };
        // Convert the enum value to its string representation for serialization purposes.
        return JSON.stringify({
            ...jsonObj,
            RecognitionStatus: $hgjD5.RecognitionStatus[jsonObj.RecognitionStatus]
        });
    }
    get RecognitionStatus() {
        return this.privSimpleSpeechPhrase.RecognitionStatus;
    }
    get DisplayText() {
        return this.privSimpleSpeechPhrase.DisplayText;
    }
    get Offset() {
        return this.privSimpleSpeechPhrase.Offset;
    }
    get Duration() {
        return this.privSimpleSpeechPhrase.Duration;
    }
    get Language() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSimpleSpeechPhrase.SpeakerId;
    }
    mapRecognitionStatus(status) {
        if (typeof status === "string") return $hgjD5.RecognitionStatus[status];
        else if (typeof status === "number") return status;
    }
}
module.exports.SimpleSpeechPhrase = $e2a5680a4142a753$var$SimpleSpeechPhrase;

});

parcelRegister("lkId6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RequestSession = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $5bgRq = parcelRequire("5bgRq");

var $izEx7 = parcelRequire("izEx7");
class $f87dc27befc29b7b$var$RequestSession {
    constructor(audioSourceId){
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privIsAudioNodeDetached = false;
        this.privIsRecognizing = false;
        this.privIsSpeechEnded = false;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privHypothesisReceived = false;
        this.privBytesSent = 0;
        this.privRecognitionBytesSent = 0;
        this.privRecogNumber = 0;
        this.privInTurn = false;
        this.privConnectionAttempts = 0;
        this.privAudioSourceId = audioSourceId;
        this.privRequestId = (0, $5OUhN.createNoDashGuid)();
        this.privAudioNodeId = (0, $5OUhN.createNoDashGuid)();
        this.privTurnDeferral = new $5OUhN.Deferred();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSpeechEnded() {
        return this.privIsSpeechEnded;
    }
    get isRecognizing() {
        return this.privIsRecognizing;
    }
    get currentTurnAudioOffset() {
        return this.privTurnStartAudioOffset;
    }
    get recogNumber() {
        return this.privRecogNumber;
    }
    get numConnectionAttempts() {
        return this.privConnectionAttempts;
    }
    // The number of bytes sent for the current connection.
    // Counter is reset to 0 each time a connection is established.
    get bytesSent() {
        return this.privBytesSent;
    }
    // The number of bytes sent for the current recognition.
    // Counter is reset to 0 each time recognition is started.
    get recognitionBytesSent() {
        return this.privRecognitionBytesSent;
    }
    listenForServiceTelemetry(eventSource) {
        if (!!this.privServiceTelemetryListener) this.privDetachables.push(eventSource.attachListener(this.privServiceTelemetryListener));
    }
    startNewRecognition() {
        this.privRecognitionBytesSent = 0;
        this.privIsSpeechEnded = false;
        this.privIsRecognizing = true;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privRecogNumber++;
        this.privServiceTelemetryListener = new $izEx7.ServiceTelemetryListener(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId);
        this.onEvent(new $5bgRq.RecognitionTriggeredEvent(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    async onAudioSourceAttachCompleted(audioNode, isError) {
        this.privAudioNode = audioNode;
        this.privIsAudioNodeDetached = false;
        if (isError) await this.onComplete();
        else this.onEvent(new $5bgRq.ListeningStartedEvent(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    onPreConnectionStart(authFetchEventId, connectionId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.privSessionId = connectionId;
        this.onEvent(new $5bgRq.ConnectingToServiceEvent(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
    }
    async onAuthCompleted(isError) {
        if (isError) await this.onComplete();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async onConnectionEstablishCompleted(statusCode, reason) {
        if (statusCode === 200) {
            this.onEvent(new $5bgRq.RecognitionStartedEvent(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId));
            if (!!this.privAudioNode) this.privAudioNode.replay();
            this.privTurnStartAudioOffset = this.privLastRecoOffset;
            this.privBytesSent = 0;
            return;
        } else if (statusCode === 403) await this.onComplete();
    }
    async onServiceTurnEndResponse(continuousRecognition) {
        this.privTurnDeferral.resolve();
        if (!continuousRecognition || this.isSpeechEnded) {
            await this.onComplete();
            this.privInTurn = false;
        } else {
            // Start a new request set.
            this.privTurnStartAudioOffset = this.privLastRecoOffset;
            this.privAudioNode.replay();
        }
    }
    onSpeechContext() {
        this.privRequestId = (0, $5OUhN.createNoDashGuid)();
    }
    onServiceTurnStartResponse() {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(()=>{});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new $5OUhN.Deferred();
    }
    onHypothesis(offset) {
        if (!this.privHypothesisReceived) {
            this.privHypothesisReceived = true;
            this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(offset));
        }
    }
    onPhraseRecognized(offset) {
        this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(offset));
        this.onServiceRecognized(offset);
    }
    onServiceRecognized(offset) {
        this.privLastRecoOffset = offset;
        this.privHypothesisReceived = false;
        this.privAudioNode.shrinkBuffers(offset);
        this.privConnectionAttempts = 0;
    }
    onAudioSent(bytesSent) {
        this.privBytesSent += bytesSent;
        this.privRecognitionBytesSent += bytesSent;
    }
    onRetryConnection() {
        this.privConnectionAttempts++;
    }
    async dispose() {
        if (!this.privIsDisposed) {
            // we should have completed by now. If we did not its an unknown error.
            this.privIsDisposed = true;
            for (const detachable of this.privDetachables)await detachable.detach();
            if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.dispose();
            this.privIsRecognizing = false;
        }
    }
    getTelemetry() {
        if (this.privServiceTelemetryListener.hasTelemetry) return this.privServiceTelemetryListener.getTelemetry();
        else return null;
    }
    async onStopRecognizing() {
        await this.onComplete();
    }
    // Should be called with the audioNode for this session has indicated that it is out of speech.
    onSpeechEnded() {
        this.privIsSpeechEnded = true;
    }
    onEvent(event) {
        if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.onEvent(event);
        $5OUhN.Events.instance.onEvent(event);
    }
    async onComplete() {
        if (!!this.privIsRecognizing) {
            this.privIsRecognizing = false;
            await this.detachAudioNode();
        }
    }
    async detachAudioNode() {
        if (!this.privIsAudioNodeDetached) {
            this.privIsAudioNodeDetached = true;
            if (this.privAudioNode) await this.privAudioNode.detach();
        }
    }
}
module.exports.RequestSession = $f87dc27befc29b7b$var$RequestSession;

});
parcelRegister("izEx7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceTelemetryListener = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $5bgRq = parcelRequire("5bgRq");
class $d85aefe7af370369$var$ServiceTelemetryListener {
    constructor(requestId, audioSourceId, audioNodeId){
        this.privIsDisposed = false;
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privRequestId = requestId;
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privReceivedMessages = {};
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
    }
    phraseReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privPhraseLatencies.push(Date.now() - audioReceivedTime);
    }
    hypothesisReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privHypothesisLatencies.push(Date.now() - audioReceivedTime);
    }
    onEvent(e) {
        if (this.privIsDisposed) return;
        if (e instanceof $5bgRq.RecognitionTriggeredEvent && e.requestId === this.privRequestId) this.privListeningTriggerMetric = {
            End: e.eventTime,
            Name: "ListeningTrigger",
            Start: e.eventTime
        };
        if (e instanceof $5OUhN.AudioStreamNodeAttachingEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof $5OUhN.AudioStreamNodeAttachedEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof $5OUhN.AudioSourceErrorEvent && e.audioSourceId === this.privAudioSourceId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $5OUhN.AudioStreamNodeErrorEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $5OUhN.AudioStreamNodeDetachedEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $5bgRq.ConnectingToServiceEvent && e.requestId === this.privRequestId) this.privConnectionId = e.sessionId;
        if (e instanceof $5OUhN.ConnectionStartEvent && e.connectionId === this.privConnectionId) this.privConnectionStartTime = e.eventTime;
        if (e instanceof $5OUhN.ConnectionEstablishedEvent && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof $5OUhN.ConnectionEstablishErrorEvent && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Error: this.getConnectionError(e.statusCode),
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof $5OUhN.ConnectionMessageReceivedEvent && e.connectionId === this.privConnectionId) {
            if (e.message && e.message.headers && e.message.headers.path) {
                if (!this.privReceivedMessages[e.message.headers.path]) this.privReceivedMessages[e.message.headers.path] = new Array();
                const maxMessagesToSend = 50;
                if (this.privReceivedMessages[e.message.headers.path].length < maxMessagesToSend) this.privReceivedMessages[e.message.headers.path].push(e.networkReceivedTime);
            }
        }
    }
    getTelemetry() {
        const metrics = new Array();
        if (this.privListeningTriggerMetric) metrics.push(this.privListeningTriggerMetric);
        if (this.privMicMetric) metrics.push(this.privMicMetric);
        if (this.privConnectionEstablishMetric) metrics.push(this.privConnectionEstablishMetric);
        if (this.privPhraseLatencies.length > 0) metrics.push({
            PhraseLatencyMs: this.privPhraseLatencies
        });
        if (this.privHypothesisLatencies.length > 0) metrics.push({
            FirstHypothesisLatencyMs: this.privHypothesisLatencies
        });
        const telemetry = {
            Metrics: metrics,
            ReceivedMessages: this.privReceivedMessages
        };
        const json = JSON.stringify(telemetry);
        // We dont want to send the same telemetry again. So clean those out.
        this.privReceivedMessages = {};
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
        return json;
    }
    // Determines if there are any telemetry events to send to the service.
    get hasTelemetry() {
        return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
    }
    dispose() {
        this.privIsDisposed = true;
    }
    getConnectionError(statusCode) {
        /*
        -- Websocket status codes --
        NormalClosure = 1000,
        EndpointUnavailable = 1001,
        ProtocolError = 1002,
        InvalidMessageType = 1003,
        Empty = 1005,
        InvalidPayloadData = 1007,
        PolicyViolation = 1008,
        MessageTooBig = 1009,
        MandatoryExtension = 1010,
        InternalServerError = 1011
        */ switch(statusCode){
            case 400:
            case 1002:
            case 1003:
            case 1005:
            case 1007:
            case 1008:
            case 1009:
                return "BadRequest";
            case 401:
                return "Unauthorized";
            case 403:
                return "Forbidden";
            case 503:
            case 1001:
                return "ServerUnavailable";
            case 500:
            case 1011:
                return "ServerError";
            case 408:
            case 504:
                return "Timeout";
            default:
                return "statuscode:" + statusCode.toString();
        }
    }
}
module.exports.ServiceTelemetryListener = $d85aefe7af370369$var$ServiceTelemetryListener;

});


parcelRegister("hRi9W", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechContext = void 0;

var $6rQ2O = parcelRequire("6rQ2O");

var $jToLb = parcelRequire("jToLb");
/**
 * Represents the JSON used in the speech.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ class $d00578fe1ead9939$var$SpeechContext {
    constructor(dynamicGrammar){
        this.privContext = {};
        this.privDynamicGrammar = dynamicGrammar;
    }
    getContext() {
        return this.privContext;
    }
    /**
     * @Internal
     * This is only used by pronunciation assessment config.
     * Do not use externally, object returned will change without warning or notice.
     */ setPronunciationAssessmentParams(params, isSpeakerDiarizationEnabled = false) {
        if (this.privContext.phraseDetection === undefined) this.privContext.phraseDetection = {
            enrichment: {
                pronunciationAssessment: {}
            }
        };
        if (this.privContext.phraseDetection.enrichment === undefined) this.privContext.phraseDetection.enrichment = {
            pronunciationAssessment: {}
        };
        this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(params) || {};
        if (isSpeakerDiarizationEnabled) this.privContext.phraseDetection.mode = $6rQ2O.RecognitionMode.Conversation;
        this.setWordLevelTimings();
        this.privContext.phraseOutput.detailed.options.push($jToLb.PhraseOption.PronunciationAssessment);
        if (this.privContext.phraseOutput.detailed.options.indexOf($jToLb.PhraseOption.SNR) === -1) this.privContext.phraseOutput.detailed.options.push($jToLb.PhraseOption.SNR);
    }
    setDetailedOutputFormat() {
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            }
        };
        if (this.privContext.phraseOutput.detailed === undefined) this.privContext.phraseOutput.detailed = {
            options: []
        };
        this.privContext.phraseOutput.format = $jToLb.OutputFormat.Detailed;
    }
    setWordLevelTimings() {
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            }
        };
        if (this.privContext.phraseOutput.detailed === undefined) this.privContext.phraseOutput.detailed = {
            options: []
        };
        this.privContext.phraseOutput.format = $jToLb.OutputFormat.Detailed;
        if (this.privContext.phraseOutput.detailed.options.indexOf($jToLb.PhraseOption.WordTimings) === -1) this.privContext.phraseOutput.detailed.options.push($jToLb.PhraseOption.WordTimings);
    }
    setSpeakerDiarizationAudioOffsetMs(audioOffsetMs) {
        this.privContext.phraseDetection.speakerDiarization.audioOffsetMs = audioOffsetMs;
    }
    toJSON() {
        const dgi = this.privDynamicGrammar.generateGrammarObject();
        this.privContext.dgi = dgi;
        const ret = JSON.stringify(this.privContext);
        return ret;
    }
}
module.exports.SpeechContext = $d00578fe1ead9939$var$SpeechContext;

});
parcelRegister("jToLb", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TentativePhraseResultsOption = module.exports.OutputFormat = module.exports.PhraseExtension = module.exports.PhraseOption = void 0;
/**
 * The detailed output options.
 */ var $e7b65c314ad5db7f$var$PhraseOption;
(function(PhraseOption) {
    PhraseOption["WordTimings"] = "WordTimings";
    PhraseOption["SNR"] = "SNR";
    PhraseOption["Pronunciation"] = "Pronunciation";
    PhraseOption["WordPronunciation"] = "WordPronunciation";
    PhraseOption["WordConfidence"] = "WordConfidence";
    PhraseOption["Words"] = "Words";
    PhraseOption["Sentiment"] = "Sentiment";
    PhraseOption["PronunciationAssessment"] = "PronunciationAssessment";
    PhraseOption["ContentAssessment"] = "ContentAssessment";
    PhraseOption["PhraseAMScore"] = "PhraseAMScore";
    PhraseOption["PhraseLMScore"] = "PhraseLMScore";
    PhraseOption["WordAMScore"] = "WordAMScore";
    PhraseOption["WordLMScore"] = "WordLMScore";
    PhraseOption["RuleTree"] = "RuleTree";
    PhraseOption["NBestTimings"] = "NBestTimings";
    PhraseOption["DecoderDiagnostics"] = "DecoderDiagnostics";
    PhraseOption["DisplayWordTimings"] = "DisplayWordTimings";
    PhraseOption["DisplayWords"] = "DisplayWords";
})($e7b65c314ad5db7f$var$PhraseOption = module.exports.PhraseOption || (module.exports.PhraseOption = {}));
/**
 * The detailed output extensions.
 */ var $e7b65c314ad5db7f$var$PhraseExtension;
(function(PhraseExtension) {
    PhraseExtension["Graph"] = "Graph";
    PhraseExtension["Corrections"] = "Corrections";
    PhraseExtension["Sentiment"] = "Sentiment";
})($e7b65c314ad5db7f$var$PhraseExtension = module.exports.PhraseExtension || (module.exports.PhraseExtension = {}));
/**
 * The Recognition modes
 */ var $e7b65c314ad5db7f$var$OutputFormat;
(function(OutputFormat) {
    OutputFormat["Simple"] = "Simple";
    OutputFormat["Detailed"] = "Detailed";
})($e7b65c314ad5db7f$var$OutputFormat = module.exports.OutputFormat || (module.exports.OutputFormat = {}));
/**
 * The Tentative Phrase Results option
 */ var $e7b65c314ad5db7f$var$TentativePhraseResultsOption;
(function(TentativePhraseResultsOption) {
    TentativePhraseResultsOption["None"] = "None";
    TentativePhraseResultsOption["Always"] = "Always";
})($e7b65c314ad5db7f$var$TentativePhraseResultsOption = module.exports.TentativePhraseResultsOption || (module.exports.TentativePhraseResultsOption = {}));

});


parcelRegister("f9t0q", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DynamicGrammarBuilder = void 0;

var $c5Gum = parcelRequire("c5Gum");
/**
 * Responsible for building the object to be sent to the speech service to support dynamic grammars.
 * @class DynamicGrammarBuilder
 */ class $b07e324304d66a0a$var$DynamicGrammarBuilder {
    constructor(){
        this.privWeight = 1.0;
    }
    // Adds one more reference phrases to the dynamic grammar to send.
    // All added phrases are generic phrases.
    addPhrase(phrase) {
        if (!this.privPhrases) this.privPhrases = [];
        if (phrase instanceof Array) this.privPhrases = this.privPhrases.concat(phrase);
        else this.privPhrases.push(phrase);
    }
    // Clears all phrases stored in the current object.
    clearPhrases() {
        this.privPhrases = undefined;
    }
    // Adds one or more reference grammars to the current grammar.
    addReferenceGrammar(grammar) {
        if (!this.privGrammars) this.privGrammars = [];
        if (grammar instanceof Array) this.privGrammars = this.privGrammars.concat(grammar);
        else this.privGrammars.push(grammar);
    }
    // clears all grammars stored on the recognizer.
    clearGrammars() {
        this.privGrammars = undefined;
    }
    // Sets the weight for the dynamic grammar.
    setWeight(weight) {
        this.privWeight = weight;
    }
    // Generates an object that represents the dynamic grammar used by the Speech Service.
    // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
    // of a DynamicGrammarBuilder
    generateGrammarObject() {
        if (this.privGrammars === undefined && this.privPhrases === undefined) return undefined;
        const retObj = {};
        retObj.referenceGrammars = this.privGrammars;
        if (undefined !== this.privPhrases && 0 !== this.privPhrases.length) {
            const retPhrases = [];
            this.privPhrases.forEach((value)=>{
                retPhrases.push({
                    text: value
                });
            });
            retObj.groups = [
                {
                    type: $c5Gum.GroupType.Generic,
                    items: retPhrases
                }
            ];
            retObj.bias = this.privWeight;
        }
        return retObj;
    }
}
module.exports.DynamicGrammarBuilder = $b07e324304d66a0a$var$DynamicGrammarBuilder;

});
parcelRegister("c5Gum", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SubstringMatchType = module.exports.GroupType = void 0;
/**
 * Represents the type of the Intent.
 */ var $8cd6e90f222956cb$var$GroupType;
(function(GroupType) {
    GroupType["IntentText"] = "IntentText";
    GroupType["IntentEntity"] = "IntentEntity";
    GroupType["Generic"] = "Generic";
    GroupType["People"] = "People";
    GroupType["Place"] = "Place";
    GroupType["DynamicEntity"] = "DynamicEntity";
})($8cd6e90f222956cb$var$GroupType = module.exports.GroupType || (module.exports.GroupType = {}));
/**
 * Represents the type of the substring match.
 */ var $8cd6e90f222956cb$var$SubstringMatchType;
(function(SubstringMatchType) {
    SubstringMatchType["None"] = "None";
    SubstringMatchType["LeftRooted"] = "LeftRooted";
    SubstringMatchType["PartialName"] = "PartialName";
    SubstringMatchType["MiddleOfSentence"] = "MiddleOfSentence";
})($8cd6e90f222956cb$var$SubstringMatchType = module.exports.SubstringMatchType || (module.exports.SubstringMatchType = {}));

});


parcelRegister("l5ThZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceAdapter = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $32dAT = parcelRequire("32dAT");

var $5OUhN = parcelRequire("5OUhN");

var $913NY = parcelRequire("913NY");

var $gttSn = parcelRequire("gttSn");

var $6j3mc = parcelRequire("6j3mc");

var $hgjD5 = parcelRequire("hgjD5");

var $gtHIs = parcelRequire("gtHIs");

var $kug0v = parcelRequire("kug0v");

var $3q6ms = parcelRequire("3q6ms");

var $ccM4b = parcelRequire("ccM4b");
class $f5b4f3e34c1346eb$var$DialogServiceAdapter extends $hgjD5.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector){
        super(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector);
        this.privEvents = new $5OUhN.EventSource();
        this.privDialogServiceConnector = dialogServiceConnector;
        this.receiveMessageOverride = ()=>this.receiveDialogMessageOverride();
        this.privTurnStateManager = new $6j3mc.DialogServiceTurnStateManager();
        this.recognizeOverride = (recoMode, successCallback, errorCallback)=>this.listenOnce(recoMode, successCallback, errorCallback);
        this.postConnectImplOverride = (connection)=>this.dialogConnectImpl(connection);
        this.configConnectionOverride = (connection)=>this.configConnection(connection);
        this.disconnectOverride = ()=>this.privDisconnect();
        this.privDialogAudioSource = audioSource;
        this.agentConfigSent = false;
        this.privLastResult = null;
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") this.terminateMessageLoop = true;
        });
    }
    async sendMessage(message) {
        const interactionGuid = (0, $5OUhN.createGuid)();
        const requestId = (0, $5OUhN.createNoDashGuid)();
        const agentMessage = {
            context: {
                interactionId: interactionGuid
            },
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            messagePayload: JSON.parse(message),
            version: 0.5
        };
        const agentMessageJson = JSON.stringify(agentMessage);
        const connection = await this.fetchConnection();
        await connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Text, "agent", requestId, "application/json", agentMessageJson));
    }
    async privDisconnect() {
        await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $gttSn.CancellationReason.Error, $gttSn.CancellationErrorCode.NoError, "Disconnecting");
        this.terminateMessageLoop = true;
        this.agentConfigSent = false;
        return;
    }
    processTypeSpecificMessages(connectionMessage) {
        const resultProps = new $gttSn.PropertyCollection();
        if (connectionMessage.messageType === $5OUhN.MessageType.Text) resultProps.setProperty($gttSn.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        let result;
        let processed;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.phrase":
                const speechPhrase = $hgjD5.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset);
                this.privRequestSession.onPhraseRecognized(speechPhrase.Offset + speechPhrase.Duration);
                if (speechPhrase.RecognitionStatus !== $hgjD5.RecognitionStatus.TooManyRequests && speechPhrase.RecognitionStatus !== $hgjD5.RecognitionStatus.Error) {
                    const args = this.fireEventForResult(speechPhrase, resultProps);
                    this.privLastResult = args.result;
                    if (!!this.privDialogServiceConnector.recognized) try {
                        this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, args);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            case "speech.hypothesis":
                const hypothesis = $hgjD5.SpeechHypothesis.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset);
                result = new $gttSn.SpeechRecognitionResult(this.privRequestSession.requestId, $gttSn.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, hypothesis.Offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, hypothesis.asJson(), resultProps);
                this.privRequestSession.onHypothesis(hypothesis.Offset);
                const ev = new $gttSn.SpeechRecognitionEventArgs(result, hypothesis.Offset, this.privRequestSession.sessionId);
                if (!!this.privDialogServiceConnector.recognizing) try {
                    this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.keyword":
                const keyword = $hgjD5.SpeechKeyword.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset);
                result = new $gttSn.SpeechRecognitionResult(this.privRequestSession.requestId, keyword.Status === "Accepted" ? $gttSn.ResultReason.RecognizedKeyword : $gttSn.ResultReason.NoMatch, keyword.Text, keyword.Duration, keyword.Offset, undefined, undefined, undefined, undefined, keyword.asJson(), resultProps);
                if (keyword.Status !== "Accepted") this.privLastResult = result;
                const event = new $gttSn.SpeechRecognitionEventArgs(result, result.duration, result.resultId);
                if (!!this.privDialogServiceConnector.recognized) try {
                    this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, event);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "audio":
                {
                    const audioRequestId = connectionMessage.requestId.toUpperCase();
                    const turn = this.privTurnStateManager.GetTurn(audioRequestId);
                    try {
                        // Empty binary message signals end of stream.
                        if (!connectionMessage.binaryBody) turn.endAudioStream();
                        else turn.audioStream.write(connectionMessage.binaryBody);
                    } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            case "response":
                this.handleResponseMessage(connectionMessage);
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new $5OUhN.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    async cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        this.terminateMessageLoop = true;
        if (!!this.privRequestSession.isRecognizing) await this.privRequestSession.onStopRecognizing();
        if (!!this.privDialogServiceConnector.canceled) {
            const properties = new $gttSn.PropertyCollection();
            properties.setProperty($hgjD5.CancellationErrorCodePropertyName, $gttSn.CancellationErrorCode[errorCode]);
            const cancelEvent = new $gttSn.SpeechRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
            if (!!this.privSuccessCallback) {
                const result = new $gttSn.SpeechRecognitionResult(undefined, $gttSn.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
                try {
                    this.privSuccessCallback(result);
                    this.privSuccessCallback = undefined;
                /* eslint-disable no-empty */ } catch  {}
            }
        }
    }
    async listenOnce(recoMode, successCallback, errorCallback) {
        this.privRecognizerConfig.recognitionMode = recoMode;
        this.privSuccessCallback = successCallback;
        this.privErrorCallback = errorCallback;
        this.privRequestSession.startNewRecognition();
        this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events);
        this.privRecognizerConfig.parameters.setProperty($gttSn.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        const preAudioPromise = this.sendPreAudioMessages();
        const node = await this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId);
        const format = await this.privDialogAudioSource.format;
        const deviceInfo = await this.privDialogAudioSource.deviceInfo;
        const audioNode = new $s6RJO.ReplayableAudioNode(node, format.avgBytesPerSec);
        await this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
            source: deviceInfo
        };
        try {
            await conPromise;
            await preAudioPromise;
        } catch (error) {
            await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $gttSn.CancellationReason.Error, $gttSn.CancellationErrorCode.ConnectionFailure, error);
            return Promise.resolve();
        }
        const sessionStartEventArgs = new $gttSn.SessionEventArgs(this.privRequestSession.sessionId);
        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
        const audioSendPromise = this.sendAudio(audioNode);
        // /* eslint-disable no-empty */
        audioSendPromise.then(()=>{}, async (error)=>{
            await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $gttSn.CancellationReason.Error, $gttSn.CancellationErrorCode.RuntimeError, error);
        });
    }
    // Establishes a websocket connection to the end point.
    dialogConnectImpl(connection) {
        this.privConnectionLoop = this.startMessageLoop();
        return connection;
    }
    receiveDialogMessageOverride() {
        // we won't rely on the cascading promises of the connection since we want to continually be available to receive messages
        const communicationCustodian = new $5OUhN.Deferred();
        const loop = async ()=>{
            try {
                const isDisposed = this.isDisposed();
                const terminateMessageLoop = !this.isDisposed() && this.terminateMessageLoop;
                if (isDisposed || terminateMessageLoop) {
                    // We're done.
                    communicationCustodian.resolve(undefined);
                    return;
                }
                const connection = await this.fetchConnection();
                const message = await connection.read();
                if (!message) return loop();
                const connectionMessage = $ccM4b.SpeechConnectionMessage.fromConnectionMessage(message);
                switch(connectionMessage.path.toLowerCase()){
                    case "turn.start":
                        {
                            const turnRequestId = connectionMessage.requestId.toUpperCase();
                            const audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                            // turn started by the service
                            if (turnRequestId !== audioSessionReqId) this.privTurnStateManager.StartTurn(turnRequestId);
                            else this.privRequestSession.onServiceTurnStartResponse();
                        }
                        break;
                    case "speech.startdetected":
                        const speechStartDetected = $hgjD5.SpeechDetected.fromJSON(connectionMessage.textBody, this.privRequestSession.currentTurnAudioOffset);
                        const speechStartEventArgs = new $gttSn.RecognitionEventArgs(speechStartDetected.Offset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                        break;
                    case "speech.enddetected":
                        let json;
                        if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                        else // If the request was empty, the JSON returned is empty.
                        json = "{ Offset: 0 }";
                        const speechStopDetected = $hgjD5.SpeechDetected.fromJSON(json, this.privRequestSession.currentTurnAudioOffset);
                        this.privRequestSession.onServiceRecognized(speechStopDetected.Offset);
                        const speechStopEventArgs = new $gttSn.RecognitionEventArgs(speechStopDetected.Offset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                        break;
                    case "turn.end":
                        {
                            const turnEndRequestId = connectionMessage.requestId.toUpperCase();
                            const audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                            // turn started by the service
                            if (turnEndRequestId !== audioSessionReqId) this.privTurnStateManager.CompleteTurn(turnEndRequestId);
                            else {
                                // Audio session turn
                                const sessionStopEventArgs = new $gttSn.SessionEventArgs(this.privRequestSession.sessionId);
                                await this.privRequestSession.onServiceTurnEndResponse(false);
                                if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                                    if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                                }
                                // report result to promise.
                                if (!!this.privSuccessCallback && this.privLastResult) {
                                    try {
                                        this.privSuccessCallback(this.privLastResult);
                                        this.privLastResult = null;
                                    } catch (e) {
                                        if (!!this.privErrorCallback) this.privErrorCallback(e);
                                    }
                                    // Only invoke the call back once.
                                    // and if it's successful don't invoke the
                                    // error after that.
                                    this.privSuccessCallback = undefined;
                                    this.privErrorCallback = undefined;
                                }
                            }
                        }
                        break;
                    default:
                        try {
                            const processed = await this.processTypeSpecificMessages(connectionMessage);
                            if (!processed) {
                                if (!!this.serviceEvents) this.serviceEvents.onEvent(new $5OUhN.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                            }
                        } catch (e) {
                        //
                        }
                }
                const ret = loop();
                return ret;
            } catch (error) {
                this.terminateMessageLoop = true;
                communicationCustodian.resolve();
            }
        };
        loop().catch((reason)=>{
            $5OUhN.Events.instance.onEvent(new $5OUhN.BackgroundEvent(reason));
        });
        return communicationCustodian.promise;
    }
    async startMessageLoop() {
        this.terminateMessageLoop = false;
        try {
            await this.receiveDialogMessageOverride();
        } catch (error) {
            await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $gttSn.CancellationReason.Error, $gttSn.CancellationErrorCode.RuntimeError, error);
        }
        return Promise.resolve();
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configConnection(connection) {
        if (this.terminateMessageLoop) {
            this.terminateMessageLoop = false;
            return Promise.reject("Connection to service terminated.");
        }
        await this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize());
        await this.sendAgentConfig(connection);
        return connection;
    }
    async sendPreAudioMessages() {
        const connection = await this.fetchConnection();
        this.addKeywordContextData();
        await this.sendSpeechContext(connection, true);
        await this.sendAgentContext(connection);
        await this.sendWaveHeader(connection);
    }
    sendAgentConfig(connection) {
        if (this.agentConfig && !this.agentConfigSent) {
            if (this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.Conversation_DialogType) === $gttSn.DialogServiceConfig.DialogTypes.CustomCommands) {
                const config = this.agentConfig.get();
                config.botInfo.commandsCulture = this.privRecognizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage, "en-us");
                this.agentConfig.set(config);
            }
            this.onEvent(new $32dAT.SendingAgentContextMessageEvent(this.agentConfig));
            const agentConfigJson = this.agentConfig.toJsonString();
            // guard against sending this multiple times on one connection
            this.agentConfigSent = true;
            return connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Text, "agent.config", this.privRequestSession.requestId, "application/json", agentConfigJson));
        }
        return;
    }
    sendAgentContext(connection) {
        const guid = (0, $5OUhN.createGuid)();
        const speechActivityTemplate = this.privDialogServiceConnector.properties.getProperty($gttSn.PropertyId.Conversation_Speech_Activity_Template);
        const agentContext = {
            channelData: "",
            context: {
                interactionId: guid
            },
            messagePayload: speechActivityTemplate,
            version: 0.5
        };
        const agentContextJson = JSON.stringify(agentContext);
        return connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Text, "speech.agent.context", this.privRequestSession.requestId, "application/json", agentContextJson));
    }
    fireEventForResult(serviceResult, properties) {
        const resultReason = $hgjD5.EnumTranslation.implTranslateRecognitionResult(serviceResult.RecognitionStatus);
        const result = new $gttSn.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, serviceResult.DisplayText, serviceResult.Duration, serviceResult.Offset, serviceResult.Language, serviceResult.LanguageDetectionConfidence, undefined, undefined, serviceResult.asJson(), properties);
        const ev = new $gttSn.SpeechRecognitionEventArgs(result, serviceResult.Offset, this.privRequestSession.sessionId);
        return ev;
    }
    handleResponseMessage(responseMessage) {
        // "response" messages can contain either "message" (activity) or "MessageStatus" data. Fire the appropriate
        // event according to the message type that's specified.
        const responsePayload = JSON.parse(responseMessage.textBody);
        switch(responsePayload.messageType.toLowerCase()){
            case "message":
                const responseRequestId = responseMessage.requestId.toUpperCase();
                const activityPayload = $gtHIs.ActivityPayloadResponse.fromJSON(responseMessage.textBody);
                const turn = this.privTurnStateManager.GetTurn(responseRequestId);
                // update the conversation Id
                if (activityPayload.conversationId) {
                    const updateAgentConfig = this.agentConfig.get();
                    updateAgentConfig.botInfo.conversationId = activityPayload.conversationId;
                    this.agentConfig.set(updateAgentConfig);
                }
                const pullAudioOutputStream = turn.processActivityPayload(activityPayload, $913NY.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(this.privDialogServiceConnector.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)));
                const activity = new $gttSn.ActivityReceivedEventArgs(activityPayload.messagePayload, pullAudioOutputStream);
                if (!!this.privDialogServiceConnector.activityReceived) try {
                    this.privDialogServiceConnector.activityReceived(this.privDialogServiceConnector, activity);
                /* eslint-disable-next-line no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                break;
            case "messagestatus":
                if (!!this.privDialogServiceConnector.turnStatusReceived) try {
                    this.privDialogServiceConnector.turnStatusReceived(this.privDialogServiceConnector, new $gttSn.TurnStatusReceivedEventArgs(responseMessage.textBody));
                /* eslint-disable-next-line no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                break;
            default:
                $5OUhN.Events.instance.onEvent(new $5OUhN.BackgroundEvent(`Unexpected response of type ${responsePayload.messageType}. Ignoring.`));
                break;
        }
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $5OUhN.Events.instance.onEvent(event);
    }
    addKeywordContextData() {
        const keywordPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
        if (keywordPropertyValue === undefined) return;
        const keywordOffsetPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets");
        const keywordDurationPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations");
        const keywords = keywordPropertyValue.split(";");
        const keywordOffsets = keywordOffsetPropertyValue === undefined ? [] : keywordOffsetPropertyValue.split(";");
        const keywordDurations = keywordDurationPropertyValue === undefined ? [] : keywordDurationPropertyValue.split(";");
        const keywordDefinitionArray = [];
        for(let i = 0; i < keywords.length; i++){
            const definition = {
                text: keywords[i]
            };
            if (i < keywordOffsets.length) definition.startOffset = Number(keywordOffsets[i]);
            if (i < keywordDurations.length) definition.duration = Number(keywordDurations[i]);
            keywordDefinitionArray.push(definition);
        }
        this.speechContext.getContext().invocationSource = $kug0v.InvocationSource.VoiceActivationWithKeyword;
        this.speechContext.getContext().keywordDetection = [
            {
                clientDetectedKeywords: keywordDefinitionArray,
                onReject: {
                    action: $3q6ms.OnRejectAction.EndOfTurn
                },
                type: $3q6ms.KeywordDetectionType.StartTrigger
            }
        ];
    }
}
module.exports.DialogServiceAdapter = $f5b4f3e34c1346eb$var$DialogServiceAdapter;

});
parcelRegister("6j3mc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceTurnStateManager = void 0;

var $3NF6I = parcelRequire("3NF6I");

var $i5mxe = parcelRequire("i5mxe");
class $49771f160bbaa617$var$DialogServiceTurnStateManager {
    constructor(){
        this.privTurnMap = new Map();
        return;
    }
    StartTurn(id) {
        if (this.privTurnMap.has(id)) throw new $3NF6I.InvalidOperationError("Service error: There is already a turn with id:" + id);
        const turnState = new $i5mxe.DialogServiceTurnState(this, id);
        this.privTurnMap.set(id, turnState);
        return this.privTurnMap.get(id);
    }
    GetTurn(id) {
        return this.privTurnMap.get(id);
    }
    CompleteTurn(id) {
        if (!this.privTurnMap.has(id)) throw new $3NF6I.InvalidOperationError("Service error: Received turn end for an unknown turn id:" + id);
        const turnState = this.privTurnMap.get(id);
        turnState.complete();
        this.privTurnMap.delete(id);
        return turnState;
    }
}
module.exports.DialogServiceTurnStateManager = $49771f160bbaa617$var$DialogServiceTurnStateManager;

});
parcelRegister("i5mxe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceTurnState = void 0;

var $913NY = parcelRequire("913NY");

var $kzV1n = parcelRequire("kzV1n");

var $gtHIs = parcelRequire("gtHIs");
class $d2aa2c9468bbaf3d$var$DialogServiceTurnState {
    constructor(manager, requestId){
        this.privRequestId = requestId;
        this.privIsCompleted = false;
        this.privAudioStream = null;
        this.privTurnManager = manager;
        this.resetTurnEndTimeout();
    }
    get audioStream() {
        // Called when is needed to stream.
        this.resetTurnEndTimeout();
        return this.privAudioStream;
    }
    processActivityPayload(payload, audioFormat) {
        if (payload.messageDataStreamType === $gtHIs.MessageDataStreamType.TextToSpeechAudio) {
            this.privAudioStream = $kzV1n.AudioOutputStream.createPullStream();
            this.privAudioStream.format = audioFormat !== undefined ? audioFormat : $913NY.AudioOutputFormatImpl.getDefaultOutputFormat();
        }
        return this.privAudioStream;
    }
    endAudioStream() {
        if (this.privAudioStream !== null && !this.privAudioStream.isClosed) this.privAudioStream.close();
    }
    complete() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        clearTimeout(this.privTimeoutToken);
        this.endAudioStream();
    }
    resetTurnEndTimeout() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        clearTimeout(this.privTimeoutToken);
        this.privTimeoutToken = setTimeout(()=>{
            this.privTurnManager.CompleteTurn(this.privRequestId);
            return;
        }, 2000);
    }
}
module.exports.DialogServiceTurnState = $d2aa2c9468bbaf3d$var$DialogServiceTurnState;

});
parcelRegister("gtHIs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MessageDataStreamType = module.exports.ActivityPayloadResponse = void 0;
class $bff143e28c6be1fe$var$ActivityPayloadResponse {
    constructor(json){
        this.privActivityResponse = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $bff143e28c6be1fe$var$ActivityPayloadResponse(json);
    }
    get conversationId() {
        return this.privActivityResponse.conversationId;
    }
    get messageDataStreamType() {
        return this.privActivityResponse.messageDataStreamType;
    }
    get messagePayload() {
        return this.privActivityResponse.messagePayload;
    }
    get version() {
        return this.privActivityResponse.version;
    }
}
module.exports.ActivityPayloadResponse = $bff143e28c6be1fe$var$ActivityPayloadResponse;
var $bff143e28c6be1fe$var$MessageDataStreamType;
(function(MessageDataStreamType) {
    MessageDataStreamType[MessageDataStreamType["None"] = 0] = "None";
    MessageDataStreamType[MessageDataStreamType["TextToSpeechAudio"] = 1] = "TextToSpeechAudio";
})($bff143e28c6be1fe$var$MessageDataStreamType = module.exports.MessageDataStreamType || (module.exports.MessageDataStreamType = {}));

});



parcelRegister("kug0v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvocationSource = void 0;
/**
 * Represents the source of speech recognition invocation.
 */ var $eea306b31f4dca94$var$InvocationSource;
(function(InvocationSource) {
    /**
     * No invocation source specified.
     */ InvocationSource["None"] = "None";
    /**
     * Voice activation with a keyword.
     */ InvocationSource["VoiceActivationWithKeyword"] = "VoiceActivationWithKeyword";
})($eea306b31f4dca94$var$InvocationSource = module.exports.InvocationSource || (module.exports.InvocationSource = {}));

});

parcelRegister("3q6ms", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OnRejectAction = module.exports.KeywordDetectionType = void 0;
/**
 * Represents the type of keyword detection.
 */ var $27d8bc089705fd8f$var$KeywordDetectionType;
(function(KeywordDetectionType) {
    /**
     * Triggered at the start of input.
     */ KeywordDetectionType["StartTrigger"] = "StartTrigger";
})($27d8bc089705fd8f$var$KeywordDetectionType = module.exports.KeywordDetectionType || (module.exports.KeywordDetectionType = {}));
/**
 * The action to take when a keyword is rejected.
 */ var $27d8bc089705fd8f$var$OnRejectAction;
(function(OnRejectAction) {
    /**
     * End the current turn.
     */ OnRejectAction["EndOfTurn"] = "EndOfTurn";
    /**
     * Continue processing.
     */ OnRejectAction["Continue"] = "Continue";
})($27d8bc089705fd8f$var$OnRejectAction = module.exports.OnRejectAction || (module.exports.OnRejectAction = {}));

});


parcelRegister("51cqC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AgentConfig = void 0;
/**
 * Represents the JSON used in the agent.config message sent to the speech service.
 */ class $3a76afc331a50408$var$AgentConfig {
    toJsonString() {
        return JSON.stringify(this.iPrivConfig);
    }
    get() {
        return this.iPrivConfig;
    }
    /**
     * Setter for the agent.config object.
     * @param value a JSON serializable object.
     */ set(value) {
        this.iPrivConfig = value;
    }
}
module.exports.AgentConfig = $3a76afc331a50408$var$AgentConfig;

});

parcelRegister("a39gX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternalParticipants = module.exports.ConversationTranslatorMessageTypes = module.exports.ConversationTranslatorCommandTypes = module.exports.ParticipantsListEventArgs = module.exports.ParticipantEventArgs = module.exports.ParticipantAttributeEventArgs = module.exports.MuteAllEventArgs = module.exports.LockRoomEventArgs = module.exports.ConversationReceivedTranslationEventArgs = module.exports.TranscriberRecognizer = module.exports.ConversationRecognizerFactory = module.exports.ConversationConnectionConfig = module.exports.ConversationManager = void 0;

var $7oJkL = parcelRequire("7oJkL");
Object.defineProperty(module.exports, "ConversationManager", {
    enumerable: true,
    get: function() {
        return $7oJkL.ConversationManager;
    }
});

var $lPjFC = parcelRequire("lPjFC");
Object.defineProperty(module.exports, "ConversationConnectionConfig", {
    enumerable: true,
    get: function() {
        return $lPjFC.ConversationConnectionConfig;
    }
});

var $5ZAMR = parcelRequire("5ZAMR");
Object.defineProperty(module.exports, "ConversationRecognizerFactory", {
    enumerable: true,
    get: function() {
        return $5ZAMR.ConversationRecognizerFactory;
    }
});

var $dPCKT = parcelRequire("dPCKT");
Object.defineProperty(module.exports, "TranscriberRecognizer", {
    enumerable: true,
    get: function() {
        return $dPCKT.TranscriberRecognizer;
    }
});

var $3TeUh = parcelRequire("3TeUh");
Object.defineProperty(module.exports, "ConversationReceivedTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $3TeUh.ConversationReceivedTranslationEventArgs;
    }
});
Object.defineProperty(module.exports, "LockRoomEventArgs", {
    enumerable: true,
    get: function() {
        return $3TeUh.LockRoomEventArgs;
    }
});
Object.defineProperty(module.exports, "MuteAllEventArgs", {
    enumerable: true,
    get: function() {
        return $3TeUh.MuteAllEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantAttributeEventArgs", {
    enumerable: true,
    get: function() {
        return $3TeUh.ParticipantAttributeEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantEventArgs", {
    enumerable: true,
    get: function() {
        return $3TeUh.ParticipantEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantsListEventArgs", {
    enumerable: true,
    get: function() {
        return $3TeUh.ParticipantsListEventArgs;
    }
});

var $hUMcT = parcelRequire("hUMcT");
Object.defineProperty(module.exports, "ConversationTranslatorCommandTypes", {
    enumerable: true,
    get: function() {
        return $hUMcT.ConversationTranslatorCommandTypes;
    }
});
Object.defineProperty(module.exports, "ConversationTranslatorMessageTypes", {
    enumerable: true,
    get: function() {
        return $hUMcT.ConversationTranslatorMessageTypes;
    }
});
Object.defineProperty(module.exports, "InternalParticipants", {
    enumerable: true,
    get: function() {
        return $hUMcT.InternalParticipants;
    }
});

});
parcelRegister("7oJkL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationManager = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");

var $lPjFC = parcelRequire("lPjFC");
class $562df0a6706b5c89$var$ConversationManager {
    constructor(){
        //
        this.privRequestParams = $lPjFC.ConversationConnectionConfig.configParams;
        this.privErrors = $lPjFC.ConversationConnectionConfig.restErrors;
        this.privHost = $lPjFC.ConversationConnectionConfig.host;
        this.privApiVersion = $lPjFC.ConversationConnectionConfig.apiVersion;
        this.privRestPath = $lPjFC.ConversationConnectionConfig.restPath;
        this.privRestAdapter = new $s6RJO.RestMessageAdapter({});
    }
    /**
     * Make a POST request to the Conversation Manager service endpoint to create or join a conversation.
     * @param args
     * @param conversationCode
     * @param callback
     * @param errorCallback
     */ createOrJoin(args, conversationCode, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfNullOrUndefined(args, "args");
            const languageCode = args.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage, $lPjFC.ConversationConnectionConfig.defaultLanguageCode);
            const nickname = args.getProperty($gttSn.PropertyId.ConversationTranslator_Name, "conversation_host");
            const endpointHost = args.getProperty($gttSn.PropertyId.ConversationTranslator_Host, this.privHost);
            const correlationId = args.getProperty($gttSn.PropertyId.ConversationTranslator_CorrelationId);
            const subscriptionKey = args.getProperty($gttSn.PropertyId.SpeechServiceConnection_Key);
            const subscriptionRegion = args.getProperty($gttSn.PropertyId.SpeechServiceConnection_Region);
            const authToken = args.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token);
            $3SMEZ.Contracts.throwIfNullOrWhitespace(languageCode, "languageCode");
            $3SMEZ.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
            $3SMEZ.Contracts.throwIfNullOrWhitespace(endpointHost, "endpointHost");
            const queryParams = {};
            queryParams[this.privRequestParams.apiVersion] = this.privApiVersion;
            queryParams[this.privRequestParams.languageCode] = languageCode;
            queryParams[this.privRequestParams.nickname] = nickname;
            const headers = {};
            if (correlationId) headers[this.privRequestParams.correlationId] = correlationId;
            headers[this.privRequestParams.clientAppId] = $lPjFC.ConversationConnectionConfig.clientAppId;
            if (conversationCode !== undefined) queryParams[this.privRequestParams.roomId] = conversationCode;
            else {
                $3SMEZ.Contracts.throwIfNullOrUndefined(subscriptionRegion, this.privErrors.authInvalidSubscriptionRegion);
                headers[this.privRequestParams.subscriptionRegion] = subscriptionRegion;
                if (subscriptionKey) headers[this.privRequestParams.subscriptionKey] = subscriptionKey;
                else if (authToken) headers[this.privRequestParams.authorization] = `Bearer ${authToken}`;
                else $3SMEZ.Contracts.throwIfNullOrUndefined(subscriptionKey, this.privErrors.authInvalidSubscriptionKey);
            }
            const config = {};
            config.headers = headers;
            this.privRestAdapter.options = config;
            const endpoint = `https://${endpointHost}${this.privRestPath}`;
            // TODO: support a proxy and certificate validation
            this.privRestAdapter.request($s6RJO.RestRequestType.Post, endpoint, queryParams, null).then((response)=>{
                const requestId = $s6RJO.RestMessageAdapter.extractHeaderValue(this.privRequestParams.requestId, response.headers);
                if (!response.ok) {
                    if (!!err) {
                        // get the error
                        let errorMessage = this.privErrors.invalidCreateJoinConversationResponse.replace("{status}", response.status.toString());
                        let errMessageRaw;
                        try {
                            errMessageRaw = JSON.parse(response.data);
                            errorMessage += ` [${errMessageRaw.error.code}: ${errMessageRaw.error.message}]`;
                        } catch (e) {
                            errorMessage += ` [${response.data}]`;
                        }
                        if (requestId) errorMessage += ` ${requestId}`;
                        err(errorMessage);
                    }
                    return;
                }
                const conversation = JSON.parse(response.data);
                if (conversation) conversation.requestId = requestId;
                if (!!cb) {
                    try {
                        cb(conversation);
                    } catch (e) {
                        if (!!err) err(e);
                    }
                    cb = undefined;
                }
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            }).catch(()=>{});
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
        }
    }
    /**
     * Make a DELETE request to the Conversation Manager service endpoint to leave the conversation.
     * @param args
     * @param sessionToken
     * @param callback
     */ leave(args, sessionToken) {
        return new Promise((resolve, reject)=>{
            try {
                $3SMEZ.Contracts.throwIfNullOrUndefined(args, this.privErrors.invalidArgs.replace("{arg}", "config"));
                $3SMEZ.Contracts.throwIfNullOrWhitespace(sessionToken, this.privErrors.invalidArgs.replace("{arg}", "token"));
                const endpointHost = args.getProperty($gttSn.PropertyId.ConversationTranslator_Host, this.privHost);
                const correlationId = args.getProperty($gttSn.PropertyId.ConversationTranslator_CorrelationId);
                const queryParams = {};
                queryParams[this.privRequestParams.apiVersion] = this.privApiVersion;
                queryParams[this.privRequestParams.sessionToken] = sessionToken;
                const headers = {};
                if (correlationId) headers[this.privRequestParams.correlationId] = correlationId;
                const config = {};
                config.headers = headers;
                this.privRestAdapter.options = config;
                const endpoint = `https://${endpointHost}${this.privRestPath}`;
                // TODO: support a proxy and certificate validation
                this.privRestAdapter.request($s6RJO.RestRequestType.Delete, endpoint, queryParams, null).then((response)=>{
                    response.ok;
                    resolve();
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                }).catch(()=>{});
            } catch (error) {
                if (error instanceof Error) {
                    const typedError = error;
                    reject(typedError.name + ": " + typedError.message);
                } else reject(error);
            }
        });
    }
}
module.exports.ConversationManager = $562df0a6706b5c89$var$ConversationManager;

});
parcelRegister("lPjFC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionConfig = void 0;

var $cTQ6R = parcelRequire("cTQ6R");
class $fe3d9e81a62ad225$var$ConversationConnectionConfig extends $cTQ6R.RestConfigBase {
    static get host() {
        return $fe3d9e81a62ad225$var$ConversationConnectionConfig.privHost;
    }
    static get apiVersion() {
        return $fe3d9e81a62ad225$var$ConversationConnectionConfig.privApiVersion;
    }
    static get clientAppId() {
        return $fe3d9e81a62ad225$var$ConversationConnectionConfig.privClientAppId;
    }
    static get defaultLanguageCode() {
        return $fe3d9e81a62ad225$var$ConversationConnectionConfig.privDefaultLanguageCode;
    }
    static get restPath() {
        return $fe3d9e81a62ad225$var$ConversationConnectionConfig.privRestPath;
    }
    static get webSocketPath() {
        return $fe3d9e81a62ad225$var$ConversationConnectionConfig.privWebSocketPath;
    }
    static get transcriptionEventKeys() {
        return $fe3d9e81a62ad225$var$ConversationConnectionConfig.privTranscriptionEventKeys;
    }
}
module.exports.ConversationConnectionConfig = $fe3d9e81a62ad225$var$ConversationConnectionConfig;
$fe3d9e81a62ad225$var$ConversationConnectionConfig.privHost = "dev.microsofttranslator.com";
$fe3d9e81a62ad225$var$ConversationConnectionConfig.privRestPath = "/capito/room";
$fe3d9e81a62ad225$var$ConversationConnectionConfig.privApiVersion = "2.0";
$fe3d9e81a62ad225$var$ConversationConnectionConfig.privDefaultLanguageCode = "en-US";
$fe3d9e81a62ad225$var$ConversationConnectionConfig.privClientAppId = "FC539C22-1767-4F1F-84BC-B4D811114F15";
$fe3d9e81a62ad225$var$ConversationConnectionConfig.privWebSocketPath = "/capito/translate";
$fe3d9e81a62ad225$var$ConversationConnectionConfig.privTranscriptionEventKeys = [
    "iCalUid",
    "callId",
    "organizer",
    "FLAC",
    "MTUri",
    "DifferentiateGuestSpeakers",
    "audiorecording",
    "Threadid",
    "OrganizerMri",
    "OrganizerTenantId",
    "UserToken"
];

});


parcelRegister("5ZAMR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorRecognizer = module.exports.ConversationRecognizerFactory = void 0;

var $hgjD5 = parcelRequire("hgjD5");

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");

var $lWWGV = parcelRequire("lWWGV");

var $ho1gq = parcelRequire("ho1gq");
class $45cf2f6656dc1ece$var$ConversationRecognizerFactory {
    static fromConfig(conversation, speechConfig, audioConfig) {
        return new $45cf2f6656dc1ece$var$ConversationTranslatorRecognizer(conversation, speechConfig, audioConfig);
    }
}
module.exports.ConversationRecognizerFactory = $45cf2f6656dc1ece$var$ConversationRecognizerFactory;
/**
 * Sends messages to the Conversation Translator websocket and listens for incoming events containing websocket messages.
 * Based off the recognizers in the SDK folder.
 */ class $45cf2f6656dc1ece$var$ConversationTranslatorRecognizer extends $gttSn.Recognizer {
    constructor(conversation, speechConfig, audioConfig){
        const serviceConfigImpl = speechConfig;
        $3SMEZ.Contracts.throwIfNull(serviceConfigImpl, "speechConfig");
        const conversationImpl = conversation;
        $3SMEZ.Contracts.throwIfNull(conversationImpl, "conversationImpl");
        super(audioConfig, serviceConfigImpl.properties, new $lWWGV.ConversationConnectionFactory());
        this.privConversation = conversationImpl;
        this.privIsDisposed = false;
        this.privProperties = serviceConfigImpl.properties.clone();
        this.privConnection = $gttSn.Connection.fromRecognizer(this);
        const webWorkerLoadType = this.privProperties.getProperty($gttSn.PropertyId.WebWorkerLoadType, "on").toLowerCase();
        if (webWorkerLoadType === "on" && typeof Blob !== "undefined" && typeof Worker !== "undefined") {
            this.privSetTimeout = $5OUhN.Timeout.setTimeout;
            this.privClearTimeout = $5OUhN.Timeout.clearTimeout;
        } else if (typeof window !== "undefined") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privSetTimeout = window.setTimeout.bind(window);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privClearTimeout = window.clearTimeout.bind(window);
        } else {
            this.privSetTimeout = setTimeout;
            this.privClearTimeout = clearTimeout;
        }
    }
    set connected(cb) {
        this.privConnection.connected = cb;
    }
    set disconnected(cb) {
        this.privConnection.disconnected = cb;
    }
    /**
     * Return the speech language used by the recognizer
     */ get speechRecognitionLanguage() {
        return this.privSpeechRecognitionLanguage;
    }
    /**
     * Return the properties for the recognizer
     */ get properties() {
        return this.privProperties;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    /**
     * Connect to the recognizer
     * @param token
     */ connect(token, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            $3SMEZ.Contracts.throwIfNullOrWhitespace(token, "token");
            this.privReco.conversationTranslatorToken = token;
            this.resetConversationTimeout();
            this.privReco.connectAsync(cb, err);
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
        }
    }
    /**
     * Disconnect from the recognizer
     */ disconnect(cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privClearTimeout(this.privTimeoutToken);
            this.privReco.disconnect().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the recognizer.
            this.dispose(true).catch((reason)=>{
                $5OUhN.Events.instance.onEvent(new $5OUhN.BackgroundEvent(reason));
            });
        }
    }
    /**
     * Send the mute all participants command to the websocket
     * @param conversationId
     * @param participantId
     * @param isMuted
     */ sendRequest(command, cb, err) {
        try {
            $3SMEZ.Contracts.throwIfDisposed(this.privIsDisposed);
            this.sendMessage(command, cb, err);
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the recognizer.
            this.dispose(true).catch((reason)=>{
                $5OUhN.Events.instance.onEvent(new $5OUhN.BackgroundEvent(reason));
            });
        }
    }
    /**
     * Handle update of service auth token (#694)
     */ onToken(token) {
        this.privConversation.onToken(token);
    }
    /**
     * Close and dispose the recognizer
     */ async close() {
        if (!this.privIsDisposed) {
            if (!!this.privConnection) {
                this.privConnection.closeConnection();
                this.privConnection.close();
            }
            this.privConnection = undefined;
            await this.dispose(true);
        }
    }
    /**
     * Dispose the recognizer
     * @param disposing
     */ async dispose(disposing) {
        if (this.privIsDisposed) return;
        if (disposing) {
            if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privClearTimeout(this.privTimeoutToken);
            this.privIsDisposed = true;
            if (!!this.privConnection) {
                this.privConnection.closeConnection();
                this.privConnection.close();
                this.privConnection = undefined;
            }
            await super.dispose(disposing);
        }
    }
    /**
     * Create the config for the recognizer
     * @param speechConfig
     */ createRecognizerConfig(speechConfig) {
        return new $hgjD5.RecognizerConfig(speechConfig, this.privProperties);
    }
    /**
     * Create the service recognizer.
     * The audio source is redundnant here but is required by the implementation.
     * @param authentication
     * @param connectionFactory
     * @param audioConfig
     * @param recognizerConfig
     */ createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioSource = audioConfig;
        return new $ho1gq.ConversationServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, this);
    }
    sendMessage(msg, cb, err) {
        const withAsync = this.privReco;
        const PromiseToEmptyCallback = (promise, cb, err)=>{
            if (promise !== undefined) promise.then(()=>{
                try {
                    if (!!cb) cb();
                } catch (e) {
                    if (!!err) err(`'Unhandled error on promise callback: ${e}'`);
                }
            }, (reason)=>{
                try {
                    if (!!err) err(reason);
                // eslint-disable-next-line no-empty
                } catch (error) {}
            });
            else if (!!err) err("Null promise");
        };
        PromiseToEmptyCallback(withAsync.sendMessageAsync(msg), cb, err);
        this.resetConversationTimeout();
    }
    resetConversationTimeout() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.privClearTimeout(this.privTimeoutToken);
        this.privTimeoutToken = this.privSetTimeout(()=>{
            this.sendRequest(this.privConversation.getKeepAlive());
        }, 60000);
    }
}
module.exports.ConversationTranslatorRecognizer = $45cf2f6656dc1ece$var$ConversationTranslatorRecognizer;

});
parcelRegister("lWWGV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionFactory = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");

var $kBobk = parcelRequire("kBobk");

var $lPjFC = parcelRequire("lPjFC");

var $byL6d = parcelRequire("byL6d");
/**
 * Create a connection to the Conversation Translator websocket for sending instant messages and commands, and for receiving translated messages.
 * The conversation must already have been started or joined.
 */ class $ffac8aa12bc95782$var$ConversationConnectionFactory extends $kBobk.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        const endpointHost = config.parameters.getProperty($gttSn.PropertyId.ConversationTranslator_Host, $lPjFC.ConversationConnectionConfig.host);
        const correlationId = config.parameters.getProperty($gttSn.PropertyId.ConversationTranslator_CorrelationId, (0, $5OUhN.createGuid)());
        const endpoint = `wss://${endpointHost}${$lPjFC.ConversationConnectionConfig.webSocketPath}`;
        const token = config.parameters.getProperty($gttSn.PropertyId.ConversationTranslator_Token, undefined);
        $3SMEZ.Contracts.throwIfNullOrUndefined(token, "token");
        const queryParams = {};
        queryParams[$lPjFC.ConversationConnectionConfig.configParams.apiVersion] = $lPjFC.ConversationConnectionConfig.apiVersion;
        queryParams[$lPjFC.ConversationConnectionConfig.configParams.token] = token;
        queryParams[$lPjFC.ConversationConnectionConfig.configParams.correlationId] = correlationId;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return Promise.resolve(new $s6RJO.WebsocketConnection(endpoint, queryParams, {}, new $byL6d.ConversationWebsocketMessageFormatter(), $s6RJO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId));
    }
}
module.exports.ConversationConnectionFactory = $ffac8aa12bc95782$var$ConversationConnectionFactory;

});
parcelRegister("byL6d", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationWebsocketMessageFormatter = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $2H2BM = parcelRequire("2H2BM");
/**
 * Based off WebsocketMessageFormatter. The messages for Conversation Translator have some variations from the Speech messages.
 */ class $86a7679741e9334e$var$ConversationWebsocketMessageFormatter {
    /**
     * Format incoming messages: text (speech partial/final, IM) or binary (tts)
     */ toConnectionMessage(message) {
        const deferral = new $5OUhN.Deferred();
        try {
            if (message.messageType === $5OUhN.MessageType.Text) {
                const incomingMessage = new $2H2BM.ConversationConnectionMessage(message.messageType, message.textContent, {}, message.id);
                deferral.resolve(incomingMessage);
            } else if (message.messageType === $5OUhN.MessageType.Binary) deferral.resolve(new $2H2BM.ConversationConnectionMessage(message.messageType, message.binaryContent, undefined, message.id));
        } catch (e) {
            deferral.reject(`Error formatting the message. Error: ${e}`);
        }
        return deferral.promise;
    }
    /**
     * Format outgoing messages: text (commands or IM)
     */ fromConnectionMessage(message) {
        const deferral = new $5OUhN.Deferred();
        try {
            if (message.messageType === $5OUhN.MessageType.Text) {
                const payload = `${message.textBody ? message.textBody : ""}`;
                deferral.resolve(new $5OUhN.RawWebsocketMessage($5OUhN.MessageType.Text, payload, message.id));
            }
        } catch (e) {
            deferral.reject(`Error formatting the message. ${e}`);
        }
        return deferral.promise;
    }
}
module.exports.ConversationWebsocketMessageFormatter = $86a7679741e9334e$var$ConversationWebsocketMessageFormatter;

});
parcelRegister("2H2BM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionMessage = void 0;

var $5OUhN = parcelRequire("5OUhN");
class $1f619ee29e4e3ab1$var$ConversationConnectionMessage extends $5OUhN.ConnectionMessage {
    constructor(messageType, body, headers, id){
        super(messageType, body, headers, id);
        const json = JSON.parse(this.textBody);
        if (json.type !== undefined) this.privConversationMessageType = json.type;
    }
    get conversationMessageType() {
        return this.privConversationMessageType;
    }
}
module.exports.ConversationConnectionMessage = $1f619ee29e4e3ab1$var$ConversationConnectionMessage;

});



parcelRegister("ho1gq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationServiceAdapter = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");

var $2H2BM = parcelRequire("2H2BM");

var $kBgHY = parcelRequire("kBgHY");

var $3TeUh = parcelRequire("3TeUh");

var $hUMcT = parcelRequire("hUMcT");

var $jipXi = parcelRequire("jipXi");
/**
 * The service adapter handles sending and receiving messages to the Conversation Translator websocket.
 */ class $ca85a890cd092b95$var$ConversationServiceAdapter extends $hgjD5.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, conversationServiceConnector){
        super(authentication, connectionFactory, audioSource, recognizerConfig, conversationServiceConnector);
        this.privConnectionConfigPromise = undefined;
        this.privLastPartialUtteranceId = "";
        this.privConversationServiceConnector = conversationServiceConnector;
        this.privConversationAuthentication = authentication;
        this.receiveMessageOverride = ()=>this.receiveConversationMessageOverride();
        this.recognizeOverride = ()=>this.noOp();
        this.postConnectImplOverride = (connection)=>this.conversationConnectImpl(connection);
        this.configConnectionOverride = ()=>this.configConnection();
        this.disconnectOverride = ()=>this.privDisconnect();
        this.privConversationRequestSession = new $kBgHY.ConversationRequestSession((0, $5OUhN.createNoDashGuid)());
        this.privConversationConnectionFactory = connectionFactory;
        this.privConversationIsDisposed = false;
    }
    isDisposed() {
        return super.isDisposed() || this.privConversationIsDisposed;
    }
    async dispose(reason) {
        this.privConversationIsDisposed = true;
        if (this.privConnectionConfigPromise !== undefined) {
            const connection = await this.privConnectionConfigPromise;
            await connection.dispose(reason);
        }
        await super.dispose(reason);
    }
    async sendMessage(message) {
        const connection = await this.fetchConnection();
        return connection.send(new $2H2BM.ConversationConnectionMessage($5OUhN.MessageType.Text, message));
    }
    async sendMessageAsync(message) {
        const connection = await this.fetchConnection();
        await connection.send(new $2H2BM.ConversationConnectionMessage($5OUhN.MessageType.Text, message));
    }
    privDisconnect() {
        if (this.terminateMessageLoop) return;
        this.cancelRecognition(this.privConversationRequestSession.sessionId, this.privConversationRequestSession.requestId, $gttSn.CancellationReason.Error, $gttSn.CancellationErrorCode.NoError, "Disconnecting");
        this.terminateMessageLoop = true;
        return Promise.resolve();
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    async processTypeSpecificMessages() {
        return true;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        this.terminateMessageLoop = true;
        const cancelEvent = new $gttSn.ConversationTranslationCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
        try {
            if (!!this.privConversationServiceConnector.canceled) this.privConversationServiceConnector.canceled(this.privConversationServiceConnector, cancelEvent);
        } catch  {
        // continue on error
        }
    }
    /**
     * Establishes a websocket connection to the end point.
     */ async conversationConnectImpl(connection) {
        this.privConnectionLoop = this.startMessageLoop();
        return connection;
    }
    /**
     * Process incoming websocket messages
     */ async receiveConversationMessageOverride() {
        if (this.isDisposed() || this.terminateMessageLoop) return Promise.resolve();
        // we won't rely on the cascading promises of the connection since we want to continually be available to receive messages
        const communicationCustodian = new $5OUhN.Deferred();
        try {
            const connection = await this.fetchConnection();
            const message = await connection.read();
            if (this.isDisposed() || this.terminateMessageLoop) {
                // We're done.
                communicationCustodian.resolve();
                return Promise.resolve();
            }
            if (!message) return this.receiveConversationMessageOverride();
            const sessionId = this.privConversationRequestSession.sessionId;
            const conversationMessageType = message.conversationMessageType.toLowerCase();
            let sendFinal = false;
            try {
                switch(conversationMessageType){
                    case "info":
                    case "participant_command":
                    case "command":
                        const commandPayload = $jipXi.CommandResponsePayload.fromJSON(message.textBody);
                        switch(commandPayload.command.toLowerCase()){
                            /**
                             * 'ParticpantList' is the first message sent to the user after the websocket connection has opened.
                             * The consuming client must wait for this message to arrive
                             * before starting to send their own data.
                             */ case "participantlist":
                                const participantsPayload = $jipXi.ParticipantsListPayloadResponse.fromJSON(message.textBody);
                                const participantsResult = participantsPayload.participants.map((p)=>{
                                    const participant = {
                                        avatar: p.avatar,
                                        displayName: p.nickname,
                                        id: p.participantId,
                                        isHost: p.ishost,
                                        isMuted: p.ismuted,
                                        isUsingTts: p.usetts,
                                        preferredLanguage: p.locale
                                    };
                                    return participant;
                                });
                                if (!!this.privConversationServiceConnector.participantsListReceived) this.privConversationServiceConnector.participantsListReceived(this.privConversationServiceConnector, new $3TeUh.ParticipantsListEventArgs(participantsPayload.roomid, participantsPayload.token, participantsPayload.translateTo, participantsPayload.profanityFilter, participantsPayload.roomProfanityFilter, participantsPayload.roomLocked, participantsPayload.muteAll, participantsResult, sessionId));
                                break;
                            /**
                             * 'SetTranslateToLanguages' represents the list of languages being used in the Conversation by all users(?).
                             * This is sent at the start of the Conversation
                             */ case "settranslatetolanguages":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $3TeUh.ParticipantAttributeEventArgs(commandPayload.participantId, $hUMcT.ConversationTranslatorCommandTypes.setTranslateToLanguages, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetProfanityFiltering' lets the client set the level of profanity filtering.
                             * If sent by the participant the setting will effect only their own profanity level.
                             * If sent by the host, the setting will effect all participants including the host.
                             * Note: the profanity filters differ from Speech Service (?): 'marked', 'raw', 'removed', 'tagged'
                             */ case "setprofanityfiltering":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $3TeUh.ParticipantAttributeEventArgs(commandPayload.participantId, $hUMcT.ConversationTranslatorCommandTypes.setProfanityFiltering, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetMute' is sent if the participant has been muted by the host.
                             * Check the 'participantId' to determine if the current user has been muted.
                             */ case "setmute":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $3TeUh.ParticipantAttributeEventArgs(commandPayload.participantId, $hUMcT.ConversationTranslatorCommandTypes.setMute, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetMuteAll' is sent if the Conversation has been muted by the host.
                             */ case "setmuteall":
                                if (!!this.privConversationServiceConnector.muteAllCommandReceived) this.privConversationServiceConnector.muteAllCommandReceived(this.privConversationServiceConnector, new $3TeUh.MuteAllEventArgs(commandPayload.value, sessionId));
                                break;
                            /**
                             * 'RoomExpirationWarning' is sent towards the end of the Conversation session to give a timeout warning.
                             */ case "roomexpirationwarning":
                                if (!!this.privConversationServiceConnector.conversationExpiration) this.privConversationServiceConnector.conversationExpiration(this.privConversationServiceConnector, new $gttSn.ConversationExpirationEventArgs(commandPayload.value, this.privConversationRequestSession.sessionId));
                                break;
                            /**
                             * 'SetUseTts' is sent as a confirmation if the user requests TTS to be turned on or off.
                             */ case "setusetts":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $3TeUh.ParticipantAttributeEventArgs(commandPayload.participantId, $hUMcT.ConversationTranslatorCommandTypes.setUseTTS, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetLockState' is set if the host has locked or unlocked the Conversation.
                             */ case "setlockstate":
                                if (!!this.privConversationServiceConnector.lockRoomCommandReceived) this.privConversationServiceConnector.lockRoomCommandReceived(this.privConversationServiceConnector, new $3TeUh.LockRoomEventArgs(commandPayload.value, sessionId));
                                break;
                            /**
                             * 'ChangeNickname' is received if a user changes their display name.
                             * Any cached particpiants list should be updated to reflect the display name.
                             */ case "changenickname":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $3TeUh.ParticipantAttributeEventArgs(commandPayload.participantId, $hUMcT.ConversationTranslatorCommandTypes.changeNickname, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'JoinSession' is sent when a user joins the Conversation.
                             */ case "joinsession":
                                const joinParticipantPayload = $jipXi.ParticipantPayloadResponse.fromJSON(message.textBody);
                                const joiningParticipant = {
                                    avatar: joinParticipantPayload.avatar,
                                    displayName: joinParticipantPayload.nickname,
                                    id: joinParticipantPayload.participantId,
                                    isHost: joinParticipantPayload.ishost,
                                    isMuted: joinParticipantPayload.ismuted,
                                    isUsingTts: joinParticipantPayload.usetts,
                                    preferredLanguage: joinParticipantPayload.locale
                                };
                                if (!!this.privConversationServiceConnector.participantJoinCommandReceived) this.privConversationServiceConnector.participantJoinCommandReceived(this.privConversationServiceConnector, new $3TeUh.ParticipantEventArgs(joiningParticipant, sessionId));
                                break;
                            /**
                             * 'LeaveSession' is sent when a user leaves the Conversation'.
                             */ case "leavesession":
                                const leavingParticipant = {
                                    id: commandPayload.participantId
                                };
                                if (!!this.privConversationServiceConnector.participantLeaveCommandReceived) this.privConversationServiceConnector.participantLeaveCommandReceived(this.privConversationServiceConnector, new $3TeUh.ParticipantEventArgs(leavingParticipant, sessionId));
                                break;
                            /**
                             * 'DisconnectSession' is sent when a user is disconnected from the session (e.g. network problem).
                             * Check the 'ParticipantId' to check whether the message is for the current user.
                             */ case "disconnectsession":
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                const disconnectParticipant = {
                                    id: commandPayload.participantId
                                };
                                break;
                            case "token":
                                const token = new $hgjD5.CognitiveTokenAuthentication(()=>{
                                    const authorizationToken = commandPayload.token;
                                    return Promise.resolve(authorizationToken);
                                }, ()=>{
                                    const authorizationToken = commandPayload.token;
                                    return Promise.resolve(authorizationToken);
                                });
                                this.authentication = token;
                                this.privConversationServiceConnector.onToken(token);
                                break;
                            /**
                             * Message not recognized.
                             */ default:
                                break;
                        }
                        break;
                    /**
                     * 'partial' (or 'hypothesis') represents a unfinalized speech message.
                     */ case "partial":
                    /**
                     * 'final' (or 'phrase') represents a finalized speech message.
                     */ case "final":
                        const speechPayload = $jipXi.SpeechResponsePayload.fromJSON(message.textBody);
                        const conversationResultReason = conversationMessageType === "final" ? $gttSn.ResultReason.TranslatedParticipantSpeech : $gttSn.ResultReason.TranslatingParticipantSpeech;
                        const speechResult = new $gttSn.ConversationTranslationResult(speechPayload.participantId, this.getTranslations(speechPayload.translations), speechPayload.language, speechPayload.id, conversationResultReason, speechPayload.recognition, undefined, undefined, message.textBody, undefined);
                        if (speechPayload.isFinal) {
                            // check the length, sometimes empty finals are returned
                            if (speechResult.text !== undefined && speechResult.text.length > 0) sendFinal = true;
                            else if (speechPayload.id === this.privLastPartialUtteranceId) // send final as normal. We had a non-empty partial for this same utterance
                            // so sending the empty final is important
                            sendFinal = true;
                            if (sendFinal) {
                                if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $3TeUh.ConversationReceivedTranslationEventArgs($hUMcT.ConversationTranslatorMessageTypes.final, speechResult, sessionId));
                            }
                        } else if (speechResult.text !== undefined) {
                            this.privLastPartialUtteranceId = speechPayload.id;
                            if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $3TeUh.ConversationReceivedTranslationEventArgs($hUMcT.ConversationTranslatorMessageTypes.partial, speechResult, sessionId));
                        }
                        break;
                    /**
                     * "translated_message" is a text message or instant message (IM).
                     */ case "translated_message":
                        const textPayload = $jipXi.TextResponsePayload.fromJSON(message.textBody);
                        // TODO: (Native parity) a result reason should be set based whether the participantId is ours or not
                        const textResult = new $gttSn.ConversationTranslationResult(textPayload.participantId, this.getTranslations(textPayload.translations), textPayload.language, undefined, undefined, textPayload.originalText, undefined, undefined, undefined, message.textBody, undefined);
                        if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $3TeUh.ConversationReceivedTranslationEventArgs($hUMcT.ConversationTranslatorMessageTypes.instantMessage, textResult, sessionId));
                        break;
                    default:
                        break;
                }
            } catch (e) {
            // continue
            }
            return this.receiveConversationMessageOverride();
        } catch (e) {
            this.terminateMessageLoop = true;
        }
        return communicationCustodian.promise;
    }
    async startMessageLoop() {
        if (this.isDisposed()) return Promise.resolve();
        this.terminateMessageLoop = false;
        const messageRetrievalPromise = this.receiveConversationMessageOverride();
        try {
            const r = await messageRetrievalPromise;
            return r;
        } catch (error) {
            this.cancelRecognition(this.privRequestSession ? this.privRequestSession.sessionId : "", this.privRequestSession ? this.privRequestSession.requestId : "", $gttSn.CancellationReason.Error, $gttSn.CancellationErrorCode.RuntimeError, error);
            return null;
        }
    }
    // Takes an established websocket connection to the endpoint
    configConnection() {
        if (this.isDisposed()) return Promise.resolve(undefined);
        if (this.privConnectionConfigPromise !== undefined) return this.privConnectionConfigPromise.then((connection)=>{
            if (connection.state() === $5OUhN.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionConfigPromise = undefined;
                return this.configConnection();
            }
            return this.privConnectionConfigPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionConfigPromise = undefined;
            return this.configConnection();
        });
        if (this.terminateMessageLoop) return Promise.resolve(undefined);
        this.privConnectionConfigPromise = this.connectImpl().then((connection)=>connection);
        return this.privConnectionConfigPromise;
    }
    getTranslations(serviceResultTranslations) {
        let translations;
        if (undefined !== serviceResultTranslations) {
            translations = new $gttSn.Translations();
            for (const translation of serviceResultTranslations)translations.set(translation.lang, translation.translation);
        }
        return translations;
    }
}
module.exports.ConversationServiceAdapter = $ca85a890cd092b95$var$ConversationServiceAdapter;

});
parcelRegister("kBgHY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationRequestSession = void 0;

var $5OUhN = parcelRequire("5OUhN");
/**
 * Placeholder class for the Conversation Request Session. Based off RequestSession.
 * TODO: define what telemetry is required.
 */ class $eff43946608b24e3$var$ConversationRequestSession {
    constructor(sessionId){
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privSessionId = sessionId;
        this.privRequestId = (0, $5OUhN.createNoDashGuid)();
        this.privRequestCompletionDeferral = new $5OUhN.Deferred();
    }
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get completionPromise() {
        return this.privRequestCompletionDeferral.promise;
    }
    onPreConnectionStart(authFetchEventId, connectionId) {
        this.privSessionId = connectionId;
    }
    onAuthCompleted(isError) {
        if (isError) this.onComplete();
    }
    onConnectionEstablishCompleted(statusCode) {
        if (statusCode === 200) return;
        else if (statusCode === 403) this.onComplete();
    }
    onServiceTurnEndResponse(continuousRecognition) {
        if (!continuousRecognition) this.onComplete();
        else this.privRequestId = (0, $5OUhN.createNoDashGuid)();
    }
    async dispose() {
        if (!this.privIsDisposed) {
            // we should have completed by now. If we did not its an unknown error.
            this.privIsDisposed = true;
            for (const detachable of this.privDetachables)await detachable.detach();
        }
    }
    onComplete() {
    //
    }
}
module.exports.ConversationRequestSession = $eff43946608b24e3$var$ConversationRequestSession;

});

parcelRegister("3TeUh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationReceivedTranslationEventArgs = module.exports.ParticipantsListEventArgs = module.exports.ParticipantAttributeEventArgs = module.exports.ParticipantEventArgs = module.exports.LockRoomEventArgs = module.exports.MuteAllEventArgs = void 0;

var $gttSn = parcelRequire("gttSn");
class $2d521256b3e946a6$var$MuteAllEventArgs extends $gttSn.SessionEventArgs {
    constructor(isMuted, sessionId){
        super(sessionId);
        this.privIsMuted = isMuted;
    }
    get isMuted() {
        return this.privIsMuted;
    }
}
module.exports.MuteAllEventArgs = $2d521256b3e946a6$var$MuteAllEventArgs;
class $2d521256b3e946a6$var$LockRoomEventArgs extends $gttSn.SessionEventArgs {
    constructor(isLocked, sessionId){
        super(sessionId);
        this.privIsLocked = isLocked;
    }
    get isMuted() {
        return this.privIsLocked;
    }
}
module.exports.LockRoomEventArgs = $2d521256b3e946a6$var$LockRoomEventArgs;
class $2d521256b3e946a6$var$ParticipantEventArgs extends $gttSn.SessionEventArgs {
    constructor(participant, sessionId){
        super(sessionId);
        this.privParticipant = participant;
    }
    get participant() {
        return this.privParticipant;
    }
}
module.exports.ParticipantEventArgs = $2d521256b3e946a6$var$ParticipantEventArgs;
class $2d521256b3e946a6$var$ParticipantAttributeEventArgs extends $gttSn.SessionEventArgs {
    constructor(participantId, key, value, sessionId){
        super(sessionId);
        this.privKey = key;
        this.privValue = value;
        this.privParticipantId = participantId;
    }
    get value() {
        return this.privValue;
    }
    get key() {
        return this.privKey;
    }
    get id() {
        return this.privParticipantId;
    }
}
module.exports.ParticipantAttributeEventArgs = $2d521256b3e946a6$var$ParticipantAttributeEventArgs;
class $2d521256b3e946a6$var$ParticipantsListEventArgs extends $gttSn.SessionEventArgs {
    constructor(conversationId, token, translateTo, profanityFilter, roomProfanityFilter, isRoomLocked, isMuteAll, participants, sessionId){
        super(sessionId);
        this.privRoomId = conversationId;
        this.privSessionToken = token;
        this.privTranslateTo = translateTo;
        this.privProfanityFilter = profanityFilter;
        this.privRoomProfanityFilter = roomProfanityFilter;
        this.privIsRoomLocked = isRoomLocked;
        this.privIsRoomLocked = isMuteAll;
        this.privParticipants = participants;
    }
    get sessionToken() {
        return this.privSessionToken;
    }
    get conversationId() {
        return this.privRoomId;
    }
    get translateTo() {
        return this.privTranslateTo;
    }
    get profanityFilter() {
        return this.privProfanityFilter;
    }
    get roomProfanityFilter() {
        return this.privRoomProfanityFilter;
    }
    get isRoomLocked() {
        return this.privIsRoomLocked;
    }
    get isMuteAll() {
        return this.privIsMuteAll;
    }
    get participants() {
        return this.privParticipants;
    }
}
module.exports.ParticipantsListEventArgs = $2d521256b3e946a6$var$ParticipantsListEventArgs;
class $2d521256b3e946a6$var$ConversationReceivedTranslationEventArgs {
    constructor(command, payload, sessionId){
        this.privPayload = payload;
        this.privCommand = command;
        this.privSessionId = sessionId;
    }
    get payload() {
        return this.privPayload;
    }
    get command() {
        return this.privCommand;
    }
    get sessionId() {
        return this.privSessionId;
    }
}
module.exports.ConversationReceivedTranslationEventArgs = $2d521256b3e946a6$var$ConversationReceivedTranslationEventArgs;

});

parcelRegister("hUMcT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorCommandTypes = module.exports.ConversationTranslatorMessageTypes = module.exports.InternalParticipants = void 0;
/** Users participating in the conversation */ class $d0ad0f8aecb5de82$var$InternalParticipants {
    constructor(participants = [], meId){
        this.participants = participants;
        this.meId = meId;
    }
    /**
     * Add or update a participant
     * @param value
     */ addOrUpdateParticipant(value) {
        if (value === undefined) return;
        const exists = this.getParticipantIndex(value.id);
        if (exists > -1) this.participants.splice(exists, 1, value);
        else this.participants.push(value);
        // ensure it was added ok
        return this.getParticipant(value.id);
    }
    /**
     * Find the participant's position in the participants list.
     * @param id
     */ getParticipantIndex(id) {
        return this.participants.findIndex((p)=>p.id === id);
    }
    /**
     * Find the participant by id.
     * @param id
     */ getParticipant(id) {
        return this.participants.find((p)=>p.id === id);
    }
    /**
     * Remove a participant from the participants list.
     */ deleteParticipant(id) {
        this.participants = this.participants.filter((p)=>p.id !== id);
    }
    /**
     * Helper to return the conversation host.
     */ get host() {
        return this.participants.find((p)=>p.isHost === true);
    }
    /**
     * Helper to return the current user.
     */ get me() {
        return this.getParticipant(this.meId);
    }
}
module.exports.InternalParticipants = $d0ad0f8aecb5de82$var$InternalParticipants;
/**
 * List of command message types
 */ module.exports.ConversationTranslatorMessageTypes = {
    command: "command",
    final: "final",
    info: "info",
    instantMessage: "instant_message",
    keepAlive: "keep_alive",
    partial: "partial",
    participantCommand: "participant_command",
    translatedMessage: "translated_message"
};
/**
 * List of command types
 */ module.exports.ConversationTranslatorCommandTypes = {
    changeNickname: "ChangeNickname",
    disconnectSession: "DisconnectSession",
    ejectParticipant: "EjectParticipant",
    instant_message: "instant_message",
    joinSession: "JoinSession",
    leaveSession: "LeaveSession",
    participantList: "ParticipantList",
    roomExpirationWarning: "RoomExpirationWarning",
    setLockState: "SetLockState",
    setMute: "SetMute",
    setMuteAll: "SetMuteAll",
    setProfanityFiltering: "SetProfanityFiltering",
    setTranslateToLanguages: "SetTranslateToLanguages",
    setUseTTS: "SetUseTTS"
};

});

parcelRegister("jipXi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextResponsePayload = module.exports.SpeechResponsePayload = module.exports.ParticipantPayloadResponse = module.exports.ParticipantsListPayloadResponse = module.exports.CommandResponsePayload = void 0;

var $3DPa2 = parcelRequire("3DPa2");
Object.defineProperty(module.exports, "CommandResponsePayload", {
    enumerable: true,
    get: function() {
        return $3DPa2.CommandResponsePayload;
    }
});

var $ld1tK = parcelRequire("ld1tK");
Object.defineProperty(module.exports, "ParticipantsListPayloadResponse", {
    enumerable: true,
    get: function() {
        return $ld1tK.ParticipantsListPayloadResponse;
    }
});
Object.defineProperty(module.exports, "ParticipantPayloadResponse", {
    enumerable: true,
    get: function() {
        return $ld1tK.ParticipantPayloadResponse;
    }
});

var $9yhxl = parcelRequire("9yhxl");
Object.defineProperty(module.exports, "SpeechResponsePayload", {
    enumerable: true,
    get: function() {
        return $9yhxl.SpeechResponsePayload;
    }
});
Object.defineProperty(module.exports, "TextResponsePayload", {
    enumerable: true,
    get: function() {
        return $9yhxl.TextResponsePayload;
    }
});

});
parcelRegister("3DPa2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommandResponsePayload = void 0;
const $2a6cb31a8f2a634a$var$parseCommandResponse = (json)=>JSON.parse(json);
class $2a6cb31a8f2a634a$var$CommandResponsePayload {
    constructor(json){
        this.privCommandResponse = $2a6cb31a8f2a634a$var$parseCommandResponse(json);
    }
    get type() {
        return this.privCommandResponse.type;
    }
    get command() {
        return this.privCommandResponse.command;
    }
    get id() {
        return this.privCommandResponse.id;
    }
    get nickname() {
        return this.privCommandResponse.nickname;
    }
    get participantId() {
        return this.privCommandResponse.participantId;
    }
    get roomid() {
        return this.privCommandResponse.roomid;
    }
    get value() {
        return this.privCommandResponse.value;
    }
    get token() {
        return this.privCommandResponse.token;
    }
    static fromJSON(json) {
        return new $2a6cb31a8f2a634a$var$CommandResponsePayload(json);
    }
}
module.exports.CommandResponsePayload = $2a6cb31a8f2a634a$var$CommandResponsePayload;

});

parcelRegister("ld1tK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParticipantPayloadResponse = module.exports.ParticipantsListPayloadResponse = void 0;
const $f70bf589f107f90f$var$parseListResponse = (json)=>JSON.parse(json);
const $f70bf589f107f90f$var$parseParticipantResponse = (json)=>JSON.parse(json);
class $f70bf589f107f90f$var$ParticipantsListPayloadResponse {
    constructor(json){
        this.privParticipantsPayloadResponse = $f70bf589f107f90f$var$parseListResponse(json);
    }
    get roomid() {
        return this.privParticipantsPayloadResponse.roomid;
    }
    get id() {
        return this.privParticipantsPayloadResponse.id;
    }
    get command() {
        return this.privParticipantsPayloadResponse.command;
    }
    get participants() {
        return this.privParticipantsPayloadResponse.participants;
    }
    get token() {
        return this.privParticipantsPayloadResponse.token;
    }
    get translateTo() {
        return this.privParticipantsPayloadResponse.translateTo;
    }
    get profanityFilter() {
        return this.privParticipantsPayloadResponse.profanityFilter;
    }
    get roomProfanityFilter() {
        return this.privParticipantsPayloadResponse.roomProfanityFilter;
    }
    get roomLocked() {
        return this.privParticipantsPayloadResponse.roomLocked;
    }
    get muteAll() {
        return this.privParticipantsPayloadResponse.muteAll;
    }
    get type() {
        return this.privParticipantsPayloadResponse.type;
    }
    static fromJSON(json) {
        return new $f70bf589f107f90f$var$ParticipantsListPayloadResponse(json);
    }
}
module.exports.ParticipantsListPayloadResponse = $f70bf589f107f90f$var$ParticipantsListPayloadResponse;
class $f70bf589f107f90f$var$ParticipantPayloadResponse {
    constructor(json){
        this.privParticipantPayloadResponse = $f70bf589f107f90f$var$parseParticipantResponse(json);
    }
    get nickname() {
        return this.privParticipantPayloadResponse.nickname;
    }
    get locale() {
        return this.privParticipantPayloadResponse.locale;
    }
    get usetts() {
        return this.privParticipantPayloadResponse.usetts;
    }
    get ismuted() {
        return this.privParticipantPayloadResponse.ismuted;
    }
    get ishost() {
        return this.privParticipantPayloadResponse.ishost;
    }
    get participantId() {
        return this.privParticipantPayloadResponse.participantId;
    }
    get avatar() {
        return this.privParticipantPayloadResponse.avatar;
    }
    static fromJSON(json) {
        return new $f70bf589f107f90f$var$ParticipantPayloadResponse(json);
    }
}
module.exports.ParticipantPayloadResponse = $f70bf589f107f90f$var$ParticipantPayloadResponse;

});

parcelRegister("9yhxl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextResponsePayload = module.exports.SpeechResponsePayload = void 0;
const $6f44e47a0735ed5a$var$parseSpeechResponse = (json)=>JSON.parse(json);
const $6f44e47a0735ed5a$var$parseTextResponse = (json)=>JSON.parse(json);
class $6f44e47a0735ed5a$var$SpeechResponsePayload {
    constructor(json){
        this.privSpeechResponse = $6f44e47a0735ed5a$var$parseSpeechResponse(json);
    }
    get recognition() {
        return this.privSpeechResponse.recognition;
    }
    get translations() {
        return this.privSpeechResponse.translations;
    }
    get id() {
        return this.privSpeechResponse.id;
    }
    get language() {
        return this.privSpeechResponse.language;
    }
    get nickname() {
        return this.privSpeechResponse.nickname;
    }
    get participantId() {
        return this.privSpeechResponse.participantId;
    }
    get roomid() {
        return this.privSpeechResponse.roomid;
    }
    get timestamp() {
        return this.privSpeechResponse.timestamp;
    }
    get type() {
        return this.privSpeechResponse.type;
    }
    get isFinal() {
        return this.privSpeechResponse.type === "final";
    }
    static fromJSON(json) {
        return new $6f44e47a0735ed5a$var$SpeechResponsePayload(json);
    }
}
module.exports.SpeechResponsePayload = $6f44e47a0735ed5a$var$SpeechResponsePayload;
class $6f44e47a0735ed5a$var$TextResponsePayload {
    constructor(json){
        this.privTextResponse = $6f44e47a0735ed5a$var$parseTextResponse(json);
    }
    get originalText() {
        return this.privTextResponse.originalText;
    }
    get translations() {
        return this.privTextResponse.translations;
    }
    get id() {
        return this.privTextResponse.id;
    }
    get language() {
        return this.privTextResponse.language;
    }
    get nickname() {
        return this.privTextResponse.nickname;
    }
    get participantId() {
        return this.privTextResponse.participantId;
    }
    get roomid() {
        return this.privTextResponse.roomid;
    }
    get timestamp() {
        return this.privTextResponse.timestamp;
    }
    get type() {
        return this.privTextResponse.type;
    }
    static fromJSON(json) {
        return new $6f44e47a0735ed5a$var$TextResponsePayload(json);
    }
}
module.exports.TextResponsePayload = $6f44e47a0735ed5a$var$TextResponsePayload;

});




parcelRegister("dPCKT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriberRecognizer = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $3SMEZ = parcelRequire("3SMEZ");

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");

var $6rQ2O = parcelRequire("6rQ2O");
class $a11e19c43f19f6c4$var$TranscriberRecognizer extends $gttSn.Recognizer {
    /**
     * TranscriberRecognizer constructor.
     * @constructor
     * @param {SpeechTranslationConfig} speechTranslationConfig - Non-audio configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An audio configuration associated with the recognizer
     */ constructor(speechTranslationConfig, audioConfig){
        const speechTranslationConfigImpl = speechTranslationConfig;
        $3SMEZ.Contracts.throwIfNull(speechTranslationConfigImpl, "speechTranslationConfig");
        const audioConfigImpl = audioConfig;
        $3SMEZ.Contracts.throwIfNull(audioConfigImpl, "audioConfigImpl");
        $3SMEZ.Contracts.throwIfNullOrWhitespace(speechTranslationConfigImpl.speechRecognitionLanguage, $gttSn.PropertyId[$gttSn.PropertyId.SpeechServiceConnection_RecoLanguage]);
        super(audioConfig, speechTranslationConfigImpl.properties, new $hgjD5.TranscriberConnectionFactory());
        this.privDisposedRecognizer = false;
        this.isMeetingRecognizer = false;
    }
    get speechRecognitionLanguage() {
        $3SMEZ.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    get properties() {
        return this.privProperties;
    }
    get authorizationToken() {
        return this.properties.getProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(token) {
        $3SMEZ.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($gttSn.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    set conversation(c) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(c, "Conversation");
        this.isMeetingRecognizer = false;
        this.privConversation = c;
    }
    getConversationInfo() {
        $3SMEZ.Contracts.throwIfNullOrUndefined(this.privConversation, "Conversation");
        return this.privConversation.conversationInfo;
    }
    set meeting(m) {
        $3SMEZ.Contracts.throwIfNullOrUndefined(m, "Meeting");
        this.isMeetingRecognizer = true;
        this.privMeeting = m;
    }
    getMeetingInfo() {
        $3SMEZ.Contracts.throwIfNullOrUndefined(this.privMeeting, "Meeting");
        return this.privMeeting.meetingInfo;
    }
    IsMeetingRecognizer() {
        return this.isMeetingRecognizer;
    }
    startContinuousRecognitionAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.startContinuousRecognitionAsyncImpl($6rQ2O.RecognitionMode.Conversation), cb, err);
    }
    stopContinuousRecognitionAsync(cb, err) {
        (0, $5OUhN.marshalPromiseToCallbacks)(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    async close() {
        if (!this.privDisposedRecognizer) await this.dispose(true);
    }
    // Push async join/leave conversation message via serviceRecognizer
    async pushConversationEvent(conversationInfo, command) {
        const reco = this.privReco;
        $3SMEZ.Contracts.throwIfNullOrUndefined(reco, "serviceRecognizer");
        await reco.sendSpeechEventAsync(conversationInfo, command);
    }
    // Push async join/leave meeting message via serviceRecognizer
    async pushMeetingEvent(meetingInfo, command) {
        const reco = this.privReco;
        $3SMEZ.Contracts.throwIfNullOrUndefined(reco, "serviceRecognizer");
        await reco.sendMeetingSpeechEventAsync(meetingInfo, command);
    }
    async enforceAudioGating() {
        const audioConfigImpl = this.audioConfig;
        const format = await audioConfigImpl.format;
        const channels = format.channels;
        if (channels === 1) {
            if (this.properties.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() !== "true") throw new Error("Single channel audio configuration for MeetingTranscriber is currently under private preview, please contact diarizationrequest@microsoft.com for more details");
        } else if (channels !== 8) throw new Error(`Unsupported audio configuration: Detected ${channels}-channel audio`);
        return;
    }
    connectMeetingCallbacks(transcriber) {
        this.isMeetingRecognizer = true;
        this.canceled = (s, e)=>{
            if (!!transcriber.canceled) transcriber.canceled(transcriber, e);
        };
        this.recognizing = (s, e)=>{
            if (!!transcriber.transcribing) transcriber.transcribing(transcriber, e);
        };
        this.recognized = (s, e)=>{
            if (!!transcriber.transcribed) transcriber.transcribed(transcriber, e);
        };
        this.sessionStarted = (s, e)=>{
            if (!!transcriber.sessionStarted) transcriber.sessionStarted(transcriber, e);
        };
        this.sessionStopped = (s, e)=>{
            if (!!transcriber.sessionStopped) transcriber.sessionStopped(transcriber, e);
        };
    }
    disconnectCallbacks() {
        this.canceled = undefined;
        this.recognizing = undefined;
        this.recognized = undefined;
        this.sessionStarted = undefined;
        this.sessionStopped = undefined;
    }
    /**
     * Disposes any resources held by the object.
     * @member ConversationTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (disposing) {
            this.privDisposedRecognizer = true;
            await this.implRecognizerStop();
        }
        await super.dispose(disposing);
    }
    createRecognizerConfig(speechConfig) {
        return new $hgjD5.RecognizerConfig(speechConfig, this.properties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        return new $hgjD5.TranscriptionServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
}
module.exports.TranscriberRecognizer = $a11e19c43f19f6c4$var$TranscriberRecognizer;

});


parcelRegister("6nl23", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisAudioMetadata = module.exports.MetadataType = void 0;
var $4a45349f0bd6d19b$var$MetadataType;
(function(MetadataType) {
    MetadataType["WordBoundary"] = "WordBoundary";
    MetadataType["Bookmark"] = "Bookmark";
    MetadataType["Viseme"] = "Viseme";
    MetadataType["SentenceBoundary"] = "SentenceBoundary";
    MetadataType["SessionEnd"] = "SessionEnd";
    MetadataType["AvatarSignal"] = "TalkingAvatarSignal";
})($4a45349f0bd6d19b$var$MetadataType = module.exports.MetadataType || (module.exports.MetadataType = {}));
class $4a45349f0bd6d19b$var$SynthesisAudioMetadata {
    constructor(json){
        this.privSynthesisAudioMetadata = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $4a45349f0bd6d19b$var$SynthesisAudioMetadata(json);
    }
    get Metadata() {
        return this.privSynthesisAudioMetadata.Metadata;
    }
}
module.exports.SynthesisAudioMetadata = $4a45349f0bd6d19b$var$SynthesisAudioMetadata;

});

parcelRegister("dsBs3", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisTurn = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $kzV1n = parcelRequire("kzV1n");

var $gttSn = parcelRequire("gttSn");

var $6nl23 = parcelRequire("6nl23");

var $geVE6 = parcelRequire("geVE6");
class $9ccaf0fa75ec9ef2$var$SynthesisTurn {
    constructor(){
        this.privIsDisposed = false;
        this.privIsSynthesizing = false;
        this.privIsSynthesisEnded = false;
        this.privBytesReceived = 0;
        this.privInTurn = false;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privRequestId = (0, $5OUhN.createNoDashGuid)();
        this.privTurnDeferral = new $5OUhN.Deferred();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    get requestId() {
        return this.privRequestId;
    }
    get streamId() {
        return this.privStreamId;
    }
    set streamId(value) {
        this.privStreamId = value;
    }
    get audioOutputFormat() {
        return this.privAudioOutputFormat;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSynthesisEnded() {
        return this.privIsSynthesisEnded;
    }
    get isSynthesizing() {
        return this.privIsSynthesizing;
    }
    get currentTextOffset() {
        return this.privTextOffset;
    }
    get currentSentenceOffset() {
        return this.privSentenceOffset;
    }
    // The number of bytes received for current turn
    get bytesReceived() {
        return this.privBytesReceived;
    }
    get audioDuration() {
        return this.privAudioDuration;
    }
    get extraProperties() {
        if (!!this.privWebRTCSDP) {
            const properties = new $gttSn.PropertyCollection();
            properties.setProperty($gttSn.PropertyId.TalkingAvatarService_WebRTC_SDP, this.privWebRTCSDP);
            return properties;
        }
        return undefined;
    }
    async getAllReceivedAudio() {
        if (!!this.privReceivedAudio) return Promise.resolve(this.privReceivedAudio);
        if (!this.privIsSynthesisEnded) return null;
        await this.readAllAudioFromStream();
        return Promise.resolve(this.privReceivedAudio);
    }
    async getAllReceivedAudioWithHeader() {
        if (!!this.privReceivedAudioWithHeader) return this.privReceivedAudioWithHeader;
        if (!this.privIsSynthesisEnded) return null;
        if (this.audioOutputFormat.hasHeader) {
            const audio = await this.getAllReceivedAudio();
            this.privReceivedAudioWithHeader = this.audioOutputFormat.addHeader(audio);
            return this.privReceivedAudioWithHeader;
        } else return this.getAllReceivedAudio();
    }
    startNewSynthesis(requestId, rawText, isSSML, audioDestination) {
        this.privIsSynthesisEnded = false;
        this.privIsSynthesizing = true;
        this.privRequestId = requestId;
        this.privRawText = rawText;
        this.privIsSSML = isSSML;
        this.privAudioOutputStream = new $kzV1n.PullAudioOutputStreamImpl();
        this.privAudioOutputStream.format = this.privAudioOutputFormat;
        this.privReceivedAudio = null;
        this.privReceivedAudioWithHeader = null;
        this.privBytesReceived = 0;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privPartialVisemeAnimation = "";
        this.privWebRTCSDP = "";
        if (audioDestination !== undefined) {
            this.privTurnAudioDestination = audioDestination;
            this.privTurnAudioDestination.format = this.privAudioOutputFormat;
        }
        this.onEvent(new $geVE6.SynthesisTriggeredEvent(this.requestId, undefined, audioDestination === undefined ? undefined : audioDestination.id()));
    }
    onPreConnectionStart(authFetchEventId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.onEvent(new $geVE6.ConnectingToSynthesisServiceEvent(this.privRequestId, this.privAuthFetchEventId));
    }
    onAuthCompleted(isError) {
        if (isError) this.onComplete();
    }
    onConnectionEstablishCompleted(statusCode) {
        if (statusCode === 200) {
            this.onEvent(new $geVE6.SynthesisStartedEvent(this.requestId, this.privAuthFetchEventId));
            this.privBytesReceived = 0;
            return;
        } else if (statusCode === 403) this.onComplete();
    }
    onServiceResponseMessage(responseJson) {
        const response = JSON.parse(responseJson);
        this.streamId = response.audio.streamId;
    }
    onServiceTurnEndResponse() {
        this.privInTurn = false;
        this.privTurnDeferral.resolve();
        this.onComplete();
    }
    onServiceTurnStartResponse(responseJson) {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(()=>{});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new $5OUhN.Deferred();
        const response = JSON.parse(responseJson);
        if (!!response.webrtc) this.privWebRTCSDP = response.webrtc.connectionString;
    }
    onAudioChunkReceived(data) {
        if (this.isSynthesizing) {
            this.privAudioOutputStream.write(data);
            this.privBytesReceived += data.byteLength;
            if (this.privTurnAudioDestination !== undefined) this.privTurnAudioDestination.write(data);
        }
    }
    onTextBoundaryEvent(metadata) {
        this.updateTextOffset(metadata.Data.text.Text, metadata.Type);
    }
    onVisemeMetadataReceived(metadata) {
        if (metadata.Data.AnimationChunk !== undefined) this.privPartialVisemeAnimation += metadata.Data.AnimationChunk;
    }
    onSessionEnd(metadata) {
        this.privAudioDuration = metadata.Data.Offset;
    }
    async constructSynthesisResult() {
        const audioBuffer = await this.getAllReceivedAudioWithHeader();
        return new $gttSn.SpeechSynthesisResult(this.requestId, $gttSn.ResultReason.SynthesizingAudioCompleted, audioBuffer, undefined, this.extraProperties, this.audioDuration);
    }
    dispose() {
        if (!this.privIsDisposed) // we should have completed by now. If we did not its an unknown error.
        this.privIsDisposed = true;
    }
    onStopSynthesizing() {
        this.onComplete();
    }
    /**
     * Gets the viseme animation string (merged from animation chunk), and clears the internal
     * partial animation.
     */ getAndClearVisemeAnimation() {
        const animation = this.privPartialVisemeAnimation;
        this.privPartialVisemeAnimation = "";
        return animation;
    }
    onEvent(event) {
        $5OUhN.Events.instance.onEvent(event);
    }
    /**
     * Check if the text is an XML(SSML) tag
     * @param text
     * @private
     */ static isXmlTag(text) {
        return text.length >= 2 && text[0] === "<" && text[text.length - 1] === ">";
    }
    updateTextOffset(text, type) {
        if (type === $6nl23.MetadataType.WordBoundary) {
            this.privTextOffset = this.privRawText.indexOf(text, this.privNextSearchTextIndex);
            if (this.privTextOffset >= 0) {
                this.privNextSearchTextIndex = this.privTextOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privTextOffset) && !$9ccaf0fa75ec9ef2$var$SynthesisTurn.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        } else {
            this.privSentenceOffset = this.privRawText.indexOf(text, this.privNextSearchSentenceIndex);
            if (this.privSentenceOffset >= 0) {
                this.privNextSearchSentenceIndex = this.privSentenceOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privSentenceOffset) && !$9ccaf0fa75ec9ef2$var$SynthesisTurn.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        }
    }
    onComplete() {
        if (this.privIsSynthesizing) {
            this.privIsSynthesizing = false;
            this.privIsSynthesisEnded = true;
            this.privAudioOutputStream.close();
            this.privInTurn = false;
            if (this.privTurnAudioDestination !== undefined) {
                this.privTurnAudioDestination.close();
                this.privTurnAudioDestination = undefined;
            }
        }
    }
    async readAllAudioFromStream() {
        if (this.privIsSynthesisEnded) {
            this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
            try {
                await this.privAudioOutputStream.read(this.privReceivedAudio);
            } catch (e) {
                this.privReceivedAudio = new ArrayBuffer(0);
            }
        }
    }
    /**
     * Check if current idx is in XML(SSML) tag
     * @param idx
     * @private
     */ withinXmlTag(idx) {
        return this.privRawText.indexOf("<", idx + 1) > this.privRawText.indexOf(">", idx + 1);
    }
}
module.exports.SynthesisTurn = $9ccaf0fa75ec9ef2$var$SynthesisTurn;

});
parcelRegister("geVE6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisStartedEvent = module.exports.ConnectingToSynthesisServiceEvent = module.exports.SynthesisTriggeredEvent = module.exports.SpeechSynthesisEvent = void 0;

var $5OUhN = parcelRequire("5OUhN");
class $bd2aab628a0b7022$var$SpeechSynthesisEvent extends $5OUhN.PlatformEvent {
    constructor(eventName, requestId, eventType = $5OUhN.EventType.Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
    }
    get requestId() {
        return this.privRequestId;
    }
}
module.exports.SpeechSynthesisEvent = $bd2aab628a0b7022$var$SpeechSynthesisEvent;
class $bd2aab628a0b7022$var$SynthesisTriggeredEvent extends $bd2aab628a0b7022$var$SpeechSynthesisEvent {
    constructor(requestId, sessionAudioDestinationId, turnAudioDestinationId){
        super("SynthesisTriggeredEvent", requestId);
        this.privSessionAudioDestinationId = sessionAudioDestinationId;
        this.privTurnAudioDestinationId = turnAudioDestinationId;
    }
    get audioSessionDestinationId() {
        return this.privSessionAudioDestinationId;
    }
    get audioTurnDestinationId() {
        return this.privTurnAudioDestinationId;
    }
}
module.exports.SynthesisTriggeredEvent = $bd2aab628a0b7022$var$SynthesisTriggeredEvent;
class $bd2aab628a0b7022$var$ConnectingToSynthesisServiceEvent extends $bd2aab628a0b7022$var$SpeechSynthesisEvent {
    constructor(requestId, authFetchEventId){
        super("ConnectingToSynthesisServiceEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
module.exports.ConnectingToSynthesisServiceEvent = $bd2aab628a0b7022$var$ConnectingToSynthesisServiceEvent;
class $bd2aab628a0b7022$var$SynthesisStartedEvent extends $bd2aab628a0b7022$var$SpeechSynthesisEvent {
    constructor(requestId, authFetchEventId){
        super("SynthesisStartedEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
module.exports.SynthesisStartedEvent = $bd2aab628a0b7022$var$SynthesisStartedEvent;

});


parcelRegister("gd3Vj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisAdapterBase = void 0;

var $5OUhN = parcelRequire("5OUhN");

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");

var $ccM4b = parcelRequire("ccM4b");
class $bcd0e75b488f1184$var$SynthesisAdapterBase {
    constructor(authentication, connectionFactory, synthesizerConfig, audioDestination){
        this.speakOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.connectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        if (!authentication) throw new $5OUhN.ArgumentNullError("authentication");
        if (!connectionFactory) throw new $5OUhN.ArgumentNullError("connectionFactory");
        if (!synthesizerConfig) throw new $5OUhN.ArgumentNullError("synthesizerConfig");
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privSynthesizerConfig = synthesizerConfig;
        this.privIsDisposed = false;
        this.privSessionAudioDestination = audioDestination;
        this.privSynthesisTurn = new $hgjD5.SynthesisTurn();
        this.privConnectionEvents = new $5OUhN.EventSource();
        this.privServiceEvents = new $5OUhN.EventSource();
        this.privSynthesisContext = new $hgjD5.SynthesisContext();
        this.privAgentConfig = new $hgjD5.AgentConfig();
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") {
                const connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode !== 1000) this.cancelSynthesisLocal($gttSn.CancellationReason.Error, connectionClosedEvent.statusCode === 1007 ? $gttSn.CancellationErrorCode.BadRequestParameters : $gttSn.CancellationErrorCode.ConnectionFailure, `${connectionClosedEvent.reason} websocket error code: ${connectionClosedEvent.statusCode}`);
            }
        });
    }
    get synthesizerConfig() {
        return this.privSynthesizerConfig;
    }
    get synthesisContext() {
        return this.privSynthesisContext;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
        this.privSynthesisTurn.audioOutputFormat = format;
        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.format = format;
        if (this.synthesisContext !== undefined) this.synthesisContext.audioOutputFormat = format;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    async dispose(reason) {
        this.privIsDisposed = true;
        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.close();
        if (this.privConnectionConfigurationPromise !== undefined) {
            const connection = await this.privConnectionConfigurationPromise;
            await connection.dispose(reason);
        }
    }
    async connect() {
        await this.connectImpl();
    }
    async sendNetworkMessage(path, payload) {
        const type = typeof payload === "string" ? $5OUhN.MessageType.Text : $5OUhN.MessageType.Binary;
        const contentType = typeof payload === "string" ? "application/json" : "";
        const connection = await this.fetchConnection();
        return connection.send(new $ccM4b.SpeechConnectionMessage(type, path, this.privSynthesisTurn.requestId, contentType, payload));
    }
    async Speak(text, isSSML, requestId, successCallback, errorCallBack, audioDestination) {
        let ssml;
        if (isSSML) ssml = text;
        else ssml = this.privSynthesizer.buildSsml(text);
        if (this.speakOverride !== undefined) return this.speakOverride(ssml, requestId, successCallback, errorCallBack);
        this.privSuccessCallback = successCallback;
        this.privErrorCallback = errorCallBack;
        this.privSynthesisTurn.startNewSynthesis(requestId, text, isSSML, audioDestination);
        try {
            await this.connectImpl();
            const connection = await this.fetchConnection();
            await this.sendSynthesisContext(connection);
            await this.sendSsmlMessage(connection, ssml, requestId);
            this.onSynthesisStarted(requestId);
            this.receiveMessage();
        } catch (e) {
            this.cancelSynthesisLocal($gttSn.CancellationReason.Error, $gttSn.CancellationErrorCode.ConnectionFailure, e);
            return Promise.reject(e);
        }
    }
    async stopSpeaking() {
        await this.connectImpl();
        const connection = await this.fetchConnection();
        return connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Text, "synthesis.control", this.privSynthesisTurn.requestId, "application/json", JSON.stringify({
            action: "stop"
        })));
    }
    // Cancels synthesis.
    cancelSynthesis(requestId, _cancellationReason, errorCode, error) {
        const properties = new $gttSn.PropertyCollection();
        properties.setProperty($hgjD5.CancellationErrorCodePropertyName, $gttSn.CancellationErrorCode[errorCode]);
        const result = new $gttSn.SpeechSynthesisResult(requestId, $gttSn.ResultReason.Canceled, undefined, error, properties);
        this.onSynthesisCancelled(result);
        if (!!this.privSuccessCallback) try {
            this.privSuccessCallback(result);
        /* eslint-disable no-empty */ } catch  {}
    }
    // Cancels synthesis.
    cancelSynthesisLocal(cancellationReason, errorCode, error) {
        if (!!this.privSynthesisTurn.isSynthesizing) {
            this.privSynthesisTurn.onStopSynthesizing();
            this.cancelSynthesis(this.privSynthesisTurn.requestId, cancellationReason, errorCode, error);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    processTypeSpecificMessages(_connectionMessage) {
        return true;
    }
    async receiveMessage() {
        try {
            const connection = await this.fetchConnection();
            const message = await connection.read();
            if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
            if (this.privIsDisposed) // We're done.
            return;
            // indicates we are draining the queue and it came with no message;
            if (!message) {
                if (!this.privSynthesisTurn.isSynthesizing) return;
                else return this.receiveMessage();
            }
            const connectionMessage = $ccM4b.SpeechConnectionMessage.fromConnectionMessage(message);
            if (connectionMessage.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                case "turn.start":
                    this.privSynthesisTurn.onServiceTurnStartResponse(connectionMessage.textBody);
                    break;
                case "response":
                    this.privSynthesisTurn.onServiceResponseMessage(connectionMessage.textBody);
                    break;
                case "audio":
                    if (this.privSynthesisTurn.streamId.toLowerCase() === connectionMessage.streamId.toLowerCase() && !!connectionMessage.binaryBody) {
                        this.privSynthesisTurn.onAudioChunkReceived(connectionMessage.binaryBody);
                        this.onSynthesizing(connectionMessage.binaryBody);
                        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.write(connectionMessage.binaryBody);
                    }
                    break;
                case "audio.metadata":
                    const metadataList = $hgjD5.SynthesisAudioMetadata.fromJSON(connectionMessage.textBody).Metadata;
                    for (const metadata of metadataList)switch(metadata.Type){
                        case $hgjD5.MetadataType.WordBoundary:
                        case $hgjD5.MetadataType.SentenceBoundary:
                            this.privSynthesisTurn.onTextBoundaryEvent(metadata);
                            const wordBoundaryEventArgs = new $gttSn.SpeechSynthesisWordBoundaryEventArgs(metadata.Data.Offset, metadata.Data.Duration, metadata.Data.text.Text, metadata.Data.text.Length, metadata.Type === $hgjD5.MetadataType.WordBoundary ? this.privSynthesisTurn.currentTextOffset : this.privSynthesisTurn.currentSentenceOffset, metadata.Data.text.BoundaryType);
                            this.onWordBoundary(wordBoundaryEventArgs);
                            break;
                        case $hgjD5.MetadataType.Bookmark:
                            const bookmarkEventArgs = new $gttSn.SpeechSynthesisBookmarkEventArgs(metadata.Data.Offset, metadata.Data.Bookmark);
                            this.onBookmarkReached(bookmarkEventArgs);
                            break;
                        case $hgjD5.MetadataType.Viseme:
                            this.privSynthesisTurn.onVisemeMetadataReceived(metadata);
                            if (metadata.Data.IsLastAnimation) {
                                const visemeEventArgs = new $gttSn.SpeechSynthesisVisemeEventArgs(metadata.Data.Offset, metadata.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                                this.onVisemeReceived(visemeEventArgs);
                            }
                            break;
                        case $hgjD5.MetadataType.AvatarSignal:
                            this.onAvatarEvent(metadata);
                            break;
                        case $hgjD5.MetadataType.SessionEnd:
                            this.privSynthesisTurn.onSessionEnd(metadata);
                            break;
                    }
                    break;
                case "turn.end":
                    this.privSynthesisTurn.onServiceTurnEndResponse();
                    let result;
                    try {
                        result = await this.privSynthesisTurn.constructSynthesisResult();
                        if (!!this.privSuccessCallback) this.privSuccessCallback(result);
                    } catch (error) {
                        if (!!this.privErrorCallback) this.privErrorCallback(error);
                    }
                    this.onSynthesisCompleted(result);
                    break;
                default:
                    if (!this.processTypeSpecificMessages(connectionMessage)) // here are some messages that the derived class has not processed, dispatch them to connect class
                    {
                        if (!!this.privServiceEvents) this.serviceEvents.onEvent(new $5OUhN.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                    }
            }
            return this.receiveMessage();
        } catch (e) {
        // TODO: What goes here?
        }
    }
    sendSynthesisContext(connection) {
        this.setSynthesisContextSynthesisSection();
        const synthesisContextJson = this.synthesisContext.toJSON();
        if (synthesisContextJson) return connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", synthesisContextJson));
        return;
    }
    setSpeechConfigSynthesisSection() {
        return;
    }
    connectImpl(isUnAuthorized = false) {
        if (this.privConnectionPromise != null) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === $5OUhN.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = null;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionPromise = null;
            return this.connectImpl();
        });
        this.privAuthFetchEventId = (0, $5OUhN.createNoDashGuid)();
        this.privConnectionId = (0, $5OUhN.createNoDashGuid)();
        this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId);
        const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        this.privConnectionPromise = authPromise.then(async (result)=>{
            this.privSynthesisTurn.onAuthCompleted(false);
            const connection = await this.privConnectionFactory.create(this.privSynthesizerConfig, result, this.privConnectionId);
            // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
            // it'll stop sending events.
            connection.events.attach((event)=>{
                this.connectionEvents.onEvent(event);
            });
            const response = await connection.open();
            if (response.statusCode === 200) {
                this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                return Promise.resolve(connection);
            } else if (response.statusCode === 403 && !isUnAuthorized) return this.connectImpl(true);
            else {
                this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                return Promise.reject(`Unable to contact server. StatusCode: ${response.statusCode},
                    ${this.privSynthesizerConfig.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Url)} Reason: ${response.reason}`);
            }
        }, (error)=>{
            this.privSynthesisTurn.onAuthCompleted(true);
            throw new Error(error);
        });
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(()=>{});
        return this.privConnectionPromise;
    }
    sendSpeechServiceConfig(connection, SpeechServiceConfigJson) {
        if (SpeechServiceConfigJson) return connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", SpeechServiceConfigJson));
    }
    sendSsmlMessage(connection, ssml, requestId) {
        return connection.send(new $ccM4b.SpeechConnectionMessage($5OUhN.MessageType.Text, "ssml", requestId, "application/ssml+xml", ssml));
    }
    async fetchConnection() {
        if (this.privConnectionConfigurationPromise !== undefined) return this.privConnectionConfigurationPromise.then((connection)=>{
            if (connection.state() === $5OUhN.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = undefined;
                return this.fetchConnection();
            }
            return this.privConnectionConfigurationPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionConfigurationPromise = undefined;
            return this.fetchConnection();
        });
        this.privConnectionConfigurationPromise = this.configureConnection();
        return await this.privConnectionConfigurationPromise;
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configureConnection() {
        const connection = await this.connectImpl();
        if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
        this.setSpeechConfigSynthesisSection();
        await this.sendSpeechServiceConfig(connection, this.privSynthesizerConfig.SpeechServiceConfig.serialize());
        return connection;
    }
    onAvatarEvent(_metadata) {
        return;
    }
    onSynthesisStarted(_requestId) {
        return;
    }
    onSynthesizing(_audio) {
        return;
    }
    onSynthesisCancelled(_result) {
        return;
    }
    onSynthesisCompleted(_result) {
        return;
    }
    onWordBoundary(_wordBoundaryEventArgs) {
        return;
    }
    onVisemeReceived(_visemeEventArgs) {
        return;
    }
    onBookmarkReached(_bookmarkEventArgs) {
        return;
    }
}
module.exports.SynthesisAdapterBase = $bcd0e75b488f1184$var$SynthesisAdapterBase;
$bcd0e75b488f1184$var$SynthesisAdapterBase.telemetryDataEnabled = true;

});

parcelRegister("eJTfA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarSynthesisAdapter = void 0;

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");
class $abb02041c54b1e22$var$AvatarSynthesisAdapter extends $hgjD5.SynthesisAdapterBase {
    constructor(authentication, connectionFactory, synthesizerConfig, avatarSynthesizer, avatarConfig){
        super(authentication, connectionFactory, synthesizerConfig, undefined);
        this.privAvatarSynthesizer = avatarSynthesizer;
        this.privSynthesizer = avatarSynthesizer;
        this.privAvatarConfig = avatarConfig;
    }
    setSynthesisContextSynthesisSection() {
        this.privSynthesisContext.setSynthesisSection(undefined);
    }
    setSpeechConfigSynthesisSection() {
        this.privSynthesizerConfig.synthesisVideoSection = {
            format: {
                bitrate: this.privAvatarConfig.videoFormat?.bitrate,
                codec: this.privAvatarConfig.videoFormat?.codec,
                crop: {
                    bottomRight: {
                        x: this.privAvatarConfig.videoFormat?.cropRange?.bottomRight?.x,
                        y: this.privAvatarConfig.videoFormat?.cropRange?.bottomRight?.y
                    },
                    topLeft: {
                        x: this.privAvatarConfig.videoFormat?.cropRange?.topLeft?.x,
                        y: this.privAvatarConfig.videoFormat?.cropRange?.topLeft?.y
                    }
                },
                resolution: {
                    height: this.privAvatarConfig.videoFormat?.height,
                    width: this.privAvatarConfig.videoFormat?.width
                }
            },
            protocol: {
                name: "WebRTC",
                webrtcConfig: {
                    clientDescription: btoa(this.privSynthesizerConfig.parameters.getProperty($gttSn.PropertyId.TalkingAvatarService_WebRTC_SDP)),
                    iceServers: this.privAvatarConfig.remoteIceServers ?? this.privAvatarSynthesizer.iceServers
                }
            },
            talkingAvatar: {
                background: {
                    color: this.privAvatarConfig.backgroundColor,
                    image: {
                        url: this.privAvatarConfig.backgroundImage?.toString()
                    }
                },
                character: this.privAvatarConfig.character,
                customized: this.privAvatarConfig.customized,
                photoAvatarBaseModel: this.privAvatarConfig.photoAvatarBaseModel,
                style: this.privAvatarConfig.style,
                useBuiltInVoice: this.privAvatarConfig.useBuiltInVoice
            }
        };
    }
    onAvatarEvent(metadata) {
        if (!!this.privAvatarSynthesizer.avatarEventReceived) {
            const avatarEventArgs = new $gttSn.AvatarEventArgs(metadata.Data.Offset, metadata.Data.Name);
            try {
                this.privAvatarSynthesizer.avatarEventReceived(this.privAvatarSynthesizer, avatarEventArgs);
            } catch (error) {
            // Not going to let errors in the event handler
            // trip things up.
            }
        }
    }
}
module.exports.AvatarSynthesisAdapter = $abb02041c54b1e22$var$AvatarSynthesisAdapter;

});

parcelRegister("5ilMI", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisAdapter = void 0;

var $gttSn = parcelRequire("gttSn");

var $hgjD5 = parcelRequire("hgjD5");
class $3daf883026743774$var$SpeechSynthesisAdapter extends $hgjD5.SynthesisAdapterBase {
    constructor(authentication, connectionFactory, synthesizerConfig, speechSynthesizer, audioDestination){
        super(authentication, connectionFactory, synthesizerConfig, audioDestination);
        this.privSpeechSynthesizer = speechSynthesizer;
        this.privSynthesizer = speechSynthesizer;
    }
    setSynthesisContextSynthesisSection() {
        this.privSynthesisContext.setSynthesisSection(this.privSpeechSynthesizer);
    }
    onSynthesisStarted(requestId) {
        const synthesisStartEventArgs = new $gttSn.SpeechSynthesisEventArgs(new $gttSn.SpeechSynthesisResult(requestId, $gttSn.ResultReason.SynthesizingAudioStarted));
        if (!!this.privSpeechSynthesizer.synthesisStarted) this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, synthesisStartEventArgs);
    }
    onSynthesizing(audio) {
        if (!!this.privSpeechSynthesizer.synthesizing) try {
            const audioWithHeader = this.privSynthesisTurn.audioOutputFormat.addHeader(audio);
            const ev = new $gttSn.SpeechSynthesisEventArgs(new $gttSn.SpeechSynthesisResult(this.privSynthesisTurn.requestId, $gttSn.ResultReason.SynthesizingAudio, audioWithHeader));
            this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, ev);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onSynthesisCancelled(result) {
        if (!!this.privSpeechSynthesizer.SynthesisCanceled) {
            const cancelEvent = new $gttSn.SpeechSynthesisEventArgs(result);
            try {
                this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
    }
    onSynthesisCompleted(result) {
        if (this.privSpeechSynthesizer.synthesisCompleted) try {
            this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new $gttSn.SpeechSynthesisEventArgs(result));
        } catch (e) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onWordBoundary(wordBoundaryEventArgs) {
        if (!!this.privSpeechSynthesizer.wordBoundary) try {
            this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, wordBoundaryEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onVisemeReceived(visemeEventArgs) {
        if (!!this.privSpeechSynthesizer.visemeReceived) try {
            this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, visemeEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onBookmarkReached(bookmarkEventArgs) {
        if (!!this.privSpeechSynthesizer.bookmarkReached) try {
            this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, bookmarkEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
}
module.exports.SpeechSynthesisAdapter = $3daf883026743774$var$SpeechSynthesisAdapter;

});

parcelRegister("bOCy4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisRestAdapter = void 0;

var $s6RJO = parcelRequire("s6RJO");

var $gttSn = parcelRequire("gttSn");

var $kBobk = parcelRequire("kBobk");

var $40Pvg = parcelRequire("40Pvg");
/**
 * Implements methods for speech synthesis classes, sending requests to endpoint
 * and parsing response into expected format
 * @class SynthesisRestAdapter
 */ class $89a2442acde752ea$var$SynthesisRestAdapter {
    constructor(config, authentication){
        let endpoint = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        if (!endpoint) {
            const region = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Region, "westus");
            const hostSuffix = $kBobk.ConnectionFactoryBase.getHostSuffix(region);
            endpoint = config.parameters.getProperty($gttSn.PropertyId.SpeechServiceConnection_Host, `https://${region}.tts.speech${hostSuffix}`);
        }
        this.privUri = `${endpoint}/cognitiveservices/voices/list`;
        const options = $s6RJO.RestConfigBase.requestOptions;
        this.privRestAdapter = new $s6RJO.RestMessageAdapter(options);
        this.privAuthentication = authentication;
    }
    /**
     * Sends list voices request to endpoint.
     * @function
     * @public
     * @param connectionId - guid for connectionId
     * @returns {Promise<IRestResponse>} rest response to status request
     */ getVoicesList(connectionId) {
        this.privRestAdapter.setHeaders($40Pvg.HeaderNames.ConnectionId, connectionId);
        return this.privAuthentication.fetch(connectionId).then((authInfo)=>{
            this.privRestAdapter.setHeaders(authInfo.headerName, authInfo.token);
            return this.privRestAdapter.request($s6RJO.RestRequestType.Get, this.privUri);
        });
    }
}
module.exports.SynthesisRestAdapter = $89a2442acde752ea$var$SynthesisRestAdapter;

});

parcelRegister("gBlwq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesizerConfig = module.exports.SynthesisServiceType = void 0;

var $hgjD5 = parcelRequire("hgjD5");
var $c160cbdc83f14ac0$var$SynthesisServiceType;
(function(SynthesisServiceType) {
    SynthesisServiceType[SynthesisServiceType["Standard"] = 0] = "Standard";
    SynthesisServiceType[SynthesisServiceType["Custom"] = 1] = "Custom";
})($c160cbdc83f14ac0$var$SynthesisServiceType = module.exports.SynthesisServiceType || (module.exports.SynthesisServiceType = {}));
class $c160cbdc83f14ac0$var$SynthesizerConfig {
    constructor(speechServiceConfig, parameters){
        this.privSynthesisServiceType = $c160cbdc83f14ac0$var$SynthesisServiceType.Standard;
        this.avatarEnabled = false;
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $hgjD5.SpeechServiceConfig(new $hgjD5.Context(null));
        this.privParameters = parameters;
    }
    get parameters() {
        return this.privParameters;
    }
    get synthesisServiceType() {
        return this.privSynthesisServiceType;
    }
    set synthesisServiceType(value) {
        this.privSynthesisServiceType = value;
    }
    set synthesisVideoSection(value) {
        this.privSpeechServiceConfig.Context.synthesis = {
            video: value
        };
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
    setContextFromJson(contextJson) {
        const context = JSON.parse(contextJson);
        if (context.system) this.privSpeechServiceConfig.Context.system = context.system;
        if (context.os) this.privSpeechServiceConfig.Context.os = context.os;
        if (context.audio) this.privSpeechServiceConfig.Context.audio = context.audio;
        if (context.synthesis) this.privSpeechServiceConfig.Context.synthesis = context.synthesis;
    }
}
module.exports.SynthesizerConfig = $c160cbdc83f14ac0$var$SynthesizerConfig;

});

parcelRegister("bgoz0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisContext = void 0;

var $gttSn = parcelRequire("gttSn");
/**
 * Represents the JSON used in the synthesis.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ class $83343e232e8b3d33$var$SynthesisContext {
    constructor(){
        this.privContext = {};
    }
    /**
     * Adds a section to the synthesis.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ setSection(sectionName, value) {
        this.privContext[sectionName] = value;
    }
    /**
     * Sets the audio output format for synthesis context generation.
     * @param format {AudioOutputFormatImpl} the output format
     */ set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    toJSON() {
        return JSON.stringify(this.privContext);
    }
    setSynthesisSection(speechSynthesizer) {
        const synthesisSection = this.buildSynthesisContext(speechSynthesizer);
        this.setSection("synthesis", synthesisSection);
    }
    buildSynthesisContext(speechSynthesizer) {
        return {
            audio: {
                metadataOptions: {
                    bookmarkEnabled: !!speechSynthesizer?.bookmarkReached,
                    punctuationBoundaryEnabled: speechSynthesizer?.properties.getProperty($gttSn.PropertyId.SpeechServiceResponse_RequestPunctuationBoundary, !!speechSynthesizer?.wordBoundary),
                    sentenceBoundaryEnabled: speechSynthesizer?.properties.getProperty($gttSn.PropertyId.SpeechServiceResponse_RequestSentenceBoundary, false),
                    sessionEndEnabled: true,
                    visemeEnabled: !!speechSynthesizer?.visemeReceived,
                    wordBoundaryEnabled: speechSynthesizer?.properties.getProperty($gttSn.PropertyId.SpeechServiceResponse_RequestWordBoundary, !!speechSynthesizer?.wordBoundary)
                },
                outputFormat: this.privAudioOutputFormat.requestAudioFormatString
            },
            language: {
                autoDetection: speechSynthesizer?.autoDetectSourceLanguage
            }
        };
    }
}
module.exports.SynthesisContext = $83343e232e8b3d33$var$SynthesisContext;

});

parcelRegister("6xqgT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.type = module.exports.connectivity = module.exports.Device = module.exports.OS = module.exports.System = module.exports.Context = module.exports.SpeechServiceConfig = void 0;
/* eslint-disable max-classes-per-file */ // The config is serialized and sent as the Speech.Config
class $4c2a341d1e549fbb$var$SpeechServiceConfig {
    constructor(context){
        this.context = context;
    }
    serialize() {
        return JSON.stringify(this, (key, value)=>{
            if (value && typeof value === "object" && !Array.isArray(value)) {
                const replacement = {};
                for(const k in value)if (Object.hasOwnProperty.call(value, k)) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                replacement[k && k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                return replacement;
            }
            return value;
        });
    }
    get Context() {
        return this.context;
    }
    get Recognition() {
        return this.recognition;
    }
    set Recognition(value) {
        this.recognition = value.toLowerCase();
    }
}
module.exports.SpeechServiceConfig = $4c2a341d1e549fbb$var$SpeechServiceConfig;
class $4c2a341d1e549fbb$var$Context {
    constructor(os){
        this.system = new $4c2a341d1e549fbb$var$System();
        this.os = os;
    }
}
module.exports.Context = $4c2a341d1e549fbb$var$Context;
class $4c2a341d1e549fbb$var$System {
    constructor(){
        // Note: below will be patched for official builds.
        const SPEECHSDK_CLIENTSDK_VERSION = "1.47.0";
        this.name = "SpeechSDK";
        this.version = SPEECHSDK_CLIENTSDK_VERSION;
        this.build = "JavaScript";
        this.lang = "JavaScript";
    }
}
module.exports.System = $4c2a341d1e549fbb$var$System;
class $4c2a341d1e549fbb$var$OS {
    constructor(platform, name, version){
        this.platform = platform;
        this.name = name;
        this.version = version;
    }
}
module.exports.OS = $4c2a341d1e549fbb$var$OS;
class $4c2a341d1e549fbb$var$Device {
    constructor(manufacturer, model, version){
        this.manufacturer = manufacturer;
        this.model = model;
        this.version = version;
    }
}
module.exports.Device = $4c2a341d1e549fbb$var$Device;
var $4c2a341d1e549fbb$var$connectivity;
(function(connectivity) {
    connectivity["Bluetooth"] = "Bluetooth";
    connectivity["Wired"] = "Wired";
    connectivity["WiFi"] = "WiFi";
    connectivity["Cellular"] = "Cellular";
    connectivity["InBuilt"] = "InBuilt";
    connectivity["Unknown"] = "Unknown";
})($4c2a341d1e549fbb$var$connectivity = module.exports.connectivity || (module.exports.connectivity = {}));
var $4c2a341d1e549fbb$var$type;
(function(type) {
    type["Phone"] = "Phone";
    type["Speaker"] = "Speaker";
    type["Car"] = "Car";
    type["Headset"] = "Headset";
    type["Thermostat"] = "Thermostat";
    type["Microphones"] = "Microphones";
    type["Deskphone"] = "Deskphone";
    type["RemoteControl"] = "RemoteControl";
    type["Unknown"] = "Unknown";
    type["File"] = "File";
    type["Stream"] = "Stream";
})($4c2a341d1e549fbb$var$type = module.exports.type || (module.exports.type = {}));

});



parcelRegister("kKnec", function(module, exports) {
"use strict";

var $i3HcB = parcelRequire("i3HcB");
var $f1aa1f21e09b6f79$var$_interopRequireDefault = $i3HcB.default;

var $f1aa1f21e09b6f79$var$_promise = $f1aa1f21e09b6f79$var$_interopRequireDefault((parcelRequire("k3Scp")));
// ../p-defer/index.js
function $f1aa1f21e09b6f79$var$pDefer() {
    var deferred = {};
    deferred.promise = new $f1aa1f21e09b6f79$var$_promise["default"](function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}
// src/index.js
module.exports = $f1aa1f21e09b6f79$var$pDefer;

});
parcelRegister("i3HcB", function(module, exports) {
function $d25a04e0ff6b5159$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $d25a04e0ff6b5159$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("k3Scp", function(module, exports) {

module.exports = (parcelRequire("IJZrE"));

});
parcelRegister("IJZrE", function(module, exports) {
'use strict';

var $gRDsX = parcelRequire("gRDsX");
parcelRequire("jlLxD");
module.exports = $gRDsX;

});
parcelRegister("gRDsX", function(module, exports) {
'use strict';
parcelRequire("1pUxE");
parcelRequire("1sRs4");
parcelRequire("1o61r");
parcelRequire("bW6p0");
parcelRequire("3Fwpb");
parcelRequire("9hluD");
parcelRequire("djTyE");
parcelRequire("3Comk");
parcelRequire("hyQQI");
parcelRequire("hNffK");

var $fDEaU = parcelRequire("fDEaU");
module.exports = $fDEaU.Promise;

});
parcelRegister("1pUxE", function(module, exports) {
'use strict';
parcelRequire("2OyLJ");

});
parcelRegister("2OyLJ", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $3MFCD = parcelRequire("3MFCD");

var $fugbv = parcelRequire("fugbv");

var $1DwRe = parcelRequire("1DwRe");

var $6JHYn = parcelRequire("6JHYn");

var $18Ax7 = parcelRequire("18Ax7");

var $5QIuJ = parcelRequire("5QIuJ");

var $jw35K = parcelRequire("jw35K");

var $9IqsX = parcelRequire("9IqsX");

var $fRZA9 = parcelRequire("fRZA9");

var $7ICfs = parcelRequire("7ICfs");

var $bn7kC = parcelRequire("bn7kC");

var $1TMNu = parcelRequire("1TMNu");
var $20cb38adc7773e46$var$TO_STRING_TAG = $1TMNu('toStringTag');
var $20cb38adc7773e46$var$$Error = Error;
var $20cb38adc7773e46$var$push = [].push;
var $20cb38adc7773e46$var$$AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = $3MFCD($20cb38adc7773e46$var$AggregateErrorPrototype, this);
    var that;
    if ($1DwRe) that = $1DwRe(new $20cb38adc7773e46$var$$Error(), isInstance ? $fugbv(this) : $20cb38adc7773e46$var$AggregateErrorPrototype);
    else {
        that = isInstance ? this : $18Ax7($20cb38adc7773e46$var$AggregateErrorPrototype);
        $5QIuJ(that, $20cb38adc7773e46$var$TO_STRING_TAG, 'Error');
    }
    if (message !== undefined) $5QIuJ(that, 'message', $bn7kC(message));
    $fRZA9(that, $20cb38adc7773e46$var$$AggregateError, that.stack, 1);
    if (arguments.length > 2) $9IqsX(that, arguments[2]);
    var errorsArray = [];
    $7ICfs(errors, $20cb38adc7773e46$var$push, {
        that: errorsArray
    });
    $5QIuJ(that, 'errors', errorsArray);
    return that;
};
if ($1DwRe) $1DwRe($20cb38adc7773e46$var$$AggregateError, $20cb38adc7773e46$var$$Error);
else $6JHYn($20cb38adc7773e46$var$$AggregateError, $20cb38adc7773e46$var$$Error, {
    name: true
});
var $20cb38adc7773e46$var$AggregateErrorPrototype = $20cb38adc7773e46$var$$AggregateError.prototype = $18Ax7($20cb38adc7773e46$var$$Error.prototype, {
    constructor: $jw35K(1, $20cb38adc7773e46$var$$AggregateError),
    message: $jw35K(1, ''),
    name: $jw35K(1, 'AggregateError')
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$k8IkA({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $20cb38adc7773e46$var$$AggregateError
});

});
parcelRegister("k8IkA", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $dgWbh = parcelRequire("dgWbh");

var $8yMwi = parcelRequire("8yMwi");

var $bCB23 = parcelRequire("bCB23");

var $Cu1XA = parcelRequire("Cu1XA");
var $ea96f13e007491fa$require$getOwnPropertyDescriptor = $Cu1XA.f;

var $7xCLo = parcelRequire("7xCLo");

var $fDEaU = parcelRequire("fDEaU");

var $iyHek = parcelRequire("iyHek");

var $5QIuJ = parcelRequire("5QIuJ");

var $8Gs5d = parcelRequire("8Gs5d");

var $ea96f13e007491fa$var$wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $dgWbh(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $a974b : STATIC ? $a974b[TARGET] : $a974b[TARGET] && $a974b[TARGET].prototype;
    var target = GLOBAL ? $fDEaU : $fDEaU[TARGET] || $5QIuJ($fDEaU, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $7xCLo(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $8Gs5d(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $ea96f13e007491fa$require$getOwnPropertyDescriptor(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (!FORCED && !PROTO && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $iyHek(sourceProperty, $a974b);
        else if (options.wrap && USE_NATIVE) resultProperty = $ea96f13e007491fa$var$wrapConstructor(sourceProperty);
        else if (PROTO && $bCB23(sourceProperty)) resultProperty = $8yMwi(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $5QIuJ(resultProperty, 'sham', true);
        $5QIuJ(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
            if (!$8Gs5d($fDEaU, VIRTUAL_PROTOTYPE)) $5QIuJ($fDEaU, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $5QIuJ($fDEaU[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $5QIuJ(targetPrototype, key, sourceProperty);
        }
    }
};

});
parcelRegister("a974b", function(module, exports) {
'use strict';
var $763039e6b2c42a44$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$763039e6b2c42a44$var$check(typeof globalThis == 'object' && globalThis) || $763039e6b2c42a44$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$763039e6b2c42a44$var$check(typeof self == 'object' && self) || $763039e6b2c42a44$var$check(typeof $parcel$global == 'object' && $parcel$global) || $763039e6b2c42a44$var$check(typeof module.exports == 'object' && module.exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();

});

parcelRegister("dgWbh", function(module, exports) {
'use strict';

var $lfb3z = parcelRequire("lfb3z");
var $9a99e68842319011$var$FunctionPrototype = Function.prototype;
var $9a99e68842319011$var$apply = $9a99e68842319011$var$FunctionPrototype.apply;
var $9a99e68842319011$var$call = $9a99e68842319011$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || ($lfb3z ? $9a99e68842319011$var$call.bind($9a99e68842319011$var$apply) : function() {
    return $9a99e68842319011$var$call.apply($9a99e68842319011$var$apply, arguments);
});

});
parcelRegister("lfb3z", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");
module.exports = !$5TNal(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});

});
parcelRegister("5TNal", function(module, exports) {
'use strict';
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});



parcelRegister("8yMwi", function(module, exports) {
'use strict';

var $abkeB = parcelRequire("abkeB");

var $blzM2 = parcelRequire("blzM2");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($abkeB(fn) === 'Function') return $blzM2(fn);
};

});
parcelRegister("abkeB", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");
var $769aa09d4596201c$var$toString = $blzM2({}.toString);
var $769aa09d4596201c$var$stringSlice = $blzM2(''.slice);
module.exports = function(it) {
    return $769aa09d4596201c$var$stringSlice($769aa09d4596201c$var$toString(it), 8, -1);
};

});
parcelRegister("blzM2", function(module, exports) {
'use strict';

var $lfb3z = parcelRequire("lfb3z");
var $842d67d3864b0d9b$var$FunctionPrototype = Function.prototype;
var $842d67d3864b0d9b$var$call = $842d67d3864b0d9b$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $842d67d3864b0d9b$var$uncurryThisWithBind = $lfb3z && $842d67d3864b0d9b$var$FunctionPrototype.bind.bind($842d67d3864b0d9b$var$call, $842d67d3864b0d9b$var$call);
module.exports = $lfb3z ? $842d67d3864b0d9b$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $842d67d3864b0d9b$var$call.apply(fn, arguments);
    };
};

});



parcelRegister("bCB23", function(module, exports) {
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $875ff82551747bfa$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof $875ff82551747bfa$var$documentAll == 'undefined' && $875ff82551747bfa$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $875ff82551747bfa$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};

});

parcelRegister("Cu1XA", function(module, exports) {

$parcel$export(module.exports, "f", () => $073ad82dcdc065d7$export$2d1720544b23b823, (v) => $073ad82dcdc065d7$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $073ad82dcdc065d7$export$2d1720544b23b823;
'use strict';

var $izyPX = parcelRequire("izyPX");

var $fztCk = parcelRequire("fztCk");

var $aXXjS = parcelRequire("aXXjS");

var $jw35K = parcelRequire("jw35K");

var $22RLh = parcelRequire("22RLh");

var $cDVev = parcelRequire("cDVev");

var $8Gs5d = parcelRequire("8Gs5d");

var $yje0b = parcelRequire("yje0b");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $073ad82dcdc065d7$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$073ad82dcdc065d7$export$2d1720544b23b823 = $izyPX ? $073ad82dcdc065d7$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $22RLh(O);
    P = $cDVev(P);
    if ($yje0b) try {
        return $073ad82dcdc065d7$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($8Gs5d(O, P)) return $jw35K(!$fztCk($aXXjS.f, O, P), O[P]);
};

});
parcelRegister("izyPX", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$5TNal(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

});

parcelRegister("fztCk", function(module, exports) {
'use strict';

var $lfb3z = parcelRequire("lfb3z");
var $b561193d6d25af95$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = $lfb3z ? $b561193d6d25af95$var$call.bind($b561193d6d25af95$var$call) : function() {
    return $b561193d6d25af95$var$call.apply($b561193d6d25af95$var$call, arguments);
};

});

parcelRegister("aXXjS", function(module, exports) {

$parcel$export(module.exports, "f", () => $020f7140e1656b0a$export$2d1720544b23b823, (v) => $020f7140e1656b0a$export$2d1720544b23b823 = v);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $020f7140e1656b0a$export$2d1720544b23b823;
'use strict';
var $020f7140e1656b0a$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $020f7140e1656b0a$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $020f7140e1656b0a$var$NASHORN_BUG = $020f7140e1656b0a$var$getOwnPropertyDescriptor && !$020f7140e1656b0a$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$020f7140e1656b0a$export$2d1720544b23b823 = $020f7140e1656b0a$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $020f7140e1656b0a$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $020f7140e1656b0a$var$$propertyIsEnumerable;

});

parcelRegister("jw35K", function(module, exports) {
'use strict';
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRegister("22RLh", function(module, exports) {
'use strict';

var $hZOGl = parcelRequire("hZOGl");

var $wWRWr = parcelRequire("wWRWr");
module.exports = function(it) {
    return $hZOGl($wWRWr(it));
};

});
parcelRegister("hZOGl", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $5TNal = parcelRequire("5TNal");

var $abkeB = parcelRequire("abkeB");
var $d19f7290ce8cfb4b$var$$Object = Object;
var $d19f7290ce8cfb4b$var$split = $blzM2(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $5TNal(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$d19f7290ce8cfb4b$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $abkeB(it) === 'String' ? $d19f7290ce8cfb4b$var$split(it, '') : $d19f7290ce8cfb4b$var$$Object(it);
} : $d19f7290ce8cfb4b$var$$Object;

});

parcelRegister("wWRWr", function(module, exports) {
'use strict';

var $giVYe = parcelRequire("giVYe");
var $0630a76faf6e2804$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($giVYe(it)) throw new $0630a76faf6e2804$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRegister("giVYe", function(module, exports) {
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});



parcelRegister("cDVev", function(module, exports) {
'use strict';

var $aDxXM = parcelRequire("aDxXM");

var $1RGBa = parcelRequire("1RGBa");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $aDxXM(argument, 'string');
    return $1RGBa(key) ? key : key + '';
};

});
parcelRegister("aDxXM", function(module, exports) {
'use strict';

var $fztCk = parcelRequire("fztCk");

var $81LAJ = parcelRequire("81LAJ");

var $1RGBa = parcelRequire("1RGBa");

var $dcbJP = parcelRequire("dcbJP");

var $jaUSS = parcelRequire("jaUSS");

var $1TMNu = parcelRequire("1TMNu");
var $7be7e4482ec15e95$var$$TypeError = TypeError;
var $7be7e4482ec15e95$var$TO_PRIMITIVE = $1TMNu('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$81LAJ(input) || $1RGBa(input)) return input;
    var exoticToPrim = $dcbJP(input, $7be7e4482ec15e95$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $fztCk(exoticToPrim, input, pref);
        if (!$81LAJ(result) || $1RGBa(result)) return result;
        throw new $7be7e4482ec15e95$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $jaUSS(input, pref);
};

});
parcelRegister("81LAJ", function(module, exports) {
'use strict';

var $bCB23 = parcelRequire("bCB23");
module.exports = function(it) {
    return typeof it == 'object' ? it !== null : $bCB23(it);
};

});

parcelRegister("1RGBa", function(module, exports) {
'use strict';

var $a1ZFI = parcelRequire("a1ZFI");

var $bCB23 = parcelRequire("bCB23");

var $3MFCD = parcelRequire("3MFCD");

var $6jrJb = parcelRequire("6jrJb");
var $15bbc8ddc173fd7d$var$$Object = Object;
module.exports = $6jrJb ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $a1ZFI('Symbol');
    return $bCB23($Symbol) && $3MFCD($Symbol.prototype, $15bbc8ddc173fd7d$var$$Object(it));
};

});
parcelRegister("a1ZFI", function(module, exports) {
'use strict';

var $fDEaU = parcelRequire("fDEaU");

var $a974b = parcelRequire("a974b");

var $bCB23 = parcelRequire("bCB23");
var $74d9d62512367c24$var$aFunction = function(variable) {
    return $bCB23(variable) ? variable : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $74d9d62512367c24$var$aFunction($fDEaU[namespace]) || $74d9d62512367c24$var$aFunction($a974b[namespace]) : $fDEaU[namespace] && $fDEaU[namespace][method] || $a974b[namespace] && $a974b[namespace][method];
};

});
parcelRegister("fDEaU", function(module, exports) {
'use strict';
module.exports = {};

});


parcelRegister("3MFCD", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");
module.exports = $blzM2({}.isPrototypeOf);

});

parcelRegister("6jrJb", function(module, exports) {
'use strict';

var $c0AT5 = parcelRequire("c0AT5");
module.exports = $c0AT5 && !Symbol.sham && typeof Symbol.iterator == 'symbol';

});
parcelRegister("c0AT5", function(module, exports) {
'use strict';

var $gYjxe = parcelRequire("gYjxe");

var $5TNal = parcelRequire("5TNal");

var $a974b = parcelRequire("a974b");
var $8be2193c46f64bf8$var$$String = $a974b.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$5TNal(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$8be2193c46f64bf8$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $gYjxe && $gYjxe < 41;
});

});
parcelRegister("gYjxe", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $bd2Ce = parcelRequire("bd2Ce");
var $c5b1673215b05c7f$var$process = $a974b.process;
var $c5b1673215b05c7f$var$Deno = $a974b.Deno;
var $c5b1673215b05c7f$var$versions = $c5b1673215b05c7f$var$process && $c5b1673215b05c7f$var$process.versions || $c5b1673215b05c7f$var$Deno && $c5b1673215b05c7f$var$Deno.version;
var $c5b1673215b05c7f$var$v8 = $c5b1673215b05c7f$var$versions && $c5b1673215b05c7f$var$versions.v8;
var $c5b1673215b05c7f$var$match, $c5b1673215b05c7f$var$version;
if ($c5b1673215b05c7f$var$v8) {
    $c5b1673215b05c7f$var$match = $c5b1673215b05c7f$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $c5b1673215b05c7f$var$version = $c5b1673215b05c7f$var$match[0] > 0 && $c5b1673215b05c7f$var$match[0] < 4 ? 1 : +($c5b1673215b05c7f$var$match[0] + $c5b1673215b05c7f$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$c5b1673215b05c7f$var$version && $bd2Ce) {
    $c5b1673215b05c7f$var$match = $bd2Ce.match(/Edge\/(\d+)/);
    if (!$c5b1673215b05c7f$var$match || $c5b1673215b05c7f$var$match[1] >= 74) {
        $c5b1673215b05c7f$var$match = $bd2Ce.match(/Chrome\/(\d+)/);
        if ($c5b1673215b05c7f$var$match) $c5b1673215b05c7f$var$version = +$c5b1673215b05c7f$var$match[1];
    }
}
module.exports = $c5b1673215b05c7f$var$version;

});
parcelRegister("bd2Ce", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");
var $8292f007eba65e7a$var$navigator = $a974b.navigator;
var $8292f007eba65e7a$var$userAgent = $8292f007eba65e7a$var$navigator && $8292f007eba65e7a$var$navigator.userAgent;
module.exports = $8292f007eba65e7a$var$userAgent ? String($8292f007eba65e7a$var$userAgent) : '';

});





parcelRegister("dcbJP", function(module, exports) {
'use strict';

var $9I3bq = parcelRequire("9I3bq");

var $giVYe = parcelRequire("giVYe");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $giVYe(func) ? undefined : $9I3bq(func);
};

});
parcelRegister("9I3bq", function(module, exports) {
'use strict';

var $bCB23 = parcelRequire("bCB23");

var $gEcAW = parcelRequire("gEcAW");
var $711ab139f5037f6b$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($bCB23(argument)) return argument;
    throw new $711ab139f5037f6b$var$$TypeError($gEcAW(argument) + ' is not a function');
};

});
parcelRegister("gEcAW", function(module, exports) {
'use strict';
var $c1ea26d1966771ef$var$$String = String;
module.exports = function(argument) {
    try {
        return $c1ea26d1966771ef$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};

});



parcelRegister("jaUSS", function(module, exports) {
'use strict';

var $fztCk = parcelRequire("fztCk");

var $bCB23 = parcelRequire("bCB23");

var $81LAJ = parcelRequire("81LAJ");
var $df5b137b8650f474$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $bCB23(fn = input.toString) && !$81LAJ(val = $fztCk(fn, input))) return val;
    if ($bCB23(fn = input.valueOf) && !$81LAJ(val = $fztCk(fn, input))) return val;
    if (pref !== 'string' && $bCB23(fn = input.toString) && !$81LAJ(val = $fztCk(fn, input))) return val;
    throw new $df5b137b8650f474$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRegister("1TMNu", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $2DACA = parcelRequire("2DACA");

var $8Gs5d = parcelRequire("8Gs5d");

var $g713c = parcelRequire("g713c");

var $c0AT5 = parcelRequire("c0AT5");

var $6jrJb = parcelRequire("6jrJb");
var $1620c796c5c010ea$var$Symbol = $a974b.Symbol;
var $1620c796c5c010ea$var$WellKnownSymbolsStore = $2DACA('wks');
var $1620c796c5c010ea$var$createWellKnownSymbol = $6jrJb ? $1620c796c5c010ea$var$Symbol['for'] || $1620c796c5c010ea$var$Symbol : $1620c796c5c010ea$var$Symbol && $1620c796c5c010ea$var$Symbol.withoutSetter || $g713c;
module.exports = function(name) {
    if (!$8Gs5d($1620c796c5c010ea$var$WellKnownSymbolsStore, name)) $1620c796c5c010ea$var$WellKnownSymbolsStore[name] = $c0AT5 && $8Gs5d($1620c796c5c010ea$var$Symbol, name) ? $1620c796c5c010ea$var$Symbol[name] : $1620c796c5c010ea$var$createWellKnownSymbol('Symbol.' + name);
    return $1620c796c5c010ea$var$WellKnownSymbolsStore[name];
};

});
parcelRegister("2DACA", function(module, exports) {
'use strict';

var $6D74Q = parcelRequire("6D74Q");
module.exports = function(key, value) {
    return $6D74Q[key] || ($6D74Q[key] = value || {});
};

});
parcelRegister("6D74Q", function(module, exports) {
'use strict';

var $1cBJJ = parcelRequire("1cBJJ");

var $a974b = parcelRequire("a974b");

var $7k1Pl = parcelRequire("7k1Pl");
var $4d3bdff4f7e0e859$var$SHARED = '__core-js_shared__';
var $4d3bdff4f7e0e859$var$store = module.exports = $a974b[$4d3bdff4f7e0e859$var$SHARED] || $7k1Pl($4d3bdff4f7e0e859$var$SHARED, {});
($4d3bdff4f7e0e859$var$store.versions || ($4d3bdff4f7e0e859$var$store.versions = [])).push({
    version: '3.49.0',
    mode: $1cBJJ ? 'pure' : 'global',
    copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
    license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});

});
parcelRegister("1cBJJ", function(module, exports) {
'use strict';
module.exports = true;

});

parcelRegister("7k1Pl", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $554bd17c504e90b5$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $554bd17c504e90b5$var$defineProperty($a974b, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $a974b[key] = value;
    }
    return value;
};

});



parcelRegister("8Gs5d", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $67owA = parcelRequire("67owA");
var $652807b09d66bbe6$var$hasOwnProperty = $blzM2({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $652807b09d66bbe6$var$hasOwnProperty($67owA(it), key);
};

});
parcelRegister("67owA", function(module, exports) {
'use strict';

var $wWRWr = parcelRequire("wWRWr");
var $47466b95662ba698$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $47466b95662ba698$var$$Object($wWRWr(argument));
};

});


parcelRegister("g713c", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");
var $bbae1d6ea63f48c8$var$id = 0;
var $bbae1d6ea63f48c8$var$postfix = Math.random();
var $bbae1d6ea63f48c8$var$toString = $blzM2(1.1.toString);
module.exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $bbae1d6ea63f48c8$var$toString(++$bbae1d6ea63f48c8$var$id + $bbae1d6ea63f48c8$var$postfix, 36);
};

});




parcelRegister("yje0b", function(module, exports) {
'use strict';

var $izyPX = parcelRequire("izyPX");

var $5TNal = parcelRequire("5TNal");

var $fUD4A = parcelRequire("fUD4A");
// Thanks to IE8 for its funny defineProperty
module.exports = !$izyPX && !$5TNal(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($fUD4A('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

});
parcelRegister("fUD4A", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $81LAJ = parcelRequire("81LAJ");
var $b95a650ffef36724$var$document = $a974b.document;
// typeof document.createElement is 'object' in old IE
var $b95a650ffef36724$var$EXISTS = $81LAJ($b95a650ffef36724$var$document) && $81LAJ($b95a650ffef36724$var$document.createElement);
module.exports = function(it) {
    return $b95a650ffef36724$var$EXISTS ? $b95a650ffef36724$var$document.createElement(it) : {};
};

});



parcelRegister("7xCLo", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");

var $bCB23 = parcelRequire("bCB23");
var $57d9af10ce46e318$var$replacement = /#|\.prototype\./;
var $57d9af10ce46e318$var$isForced = function(feature, detection) {
    var value = $57d9af10ce46e318$var$data[$57d9af10ce46e318$var$normalize(feature)];
    return value === $57d9af10ce46e318$var$POLYFILL ? true : value === $57d9af10ce46e318$var$NATIVE ? false : $bCB23(detection) ? $5TNal(detection) : !!detection;
};
var $57d9af10ce46e318$var$normalize = $57d9af10ce46e318$var$isForced.normalize = function(string) {
    return String(string).replace($57d9af10ce46e318$var$replacement, '.').toLowerCase();
};
var $57d9af10ce46e318$var$data = $57d9af10ce46e318$var$isForced.data = {};
var $57d9af10ce46e318$var$NATIVE = $57d9af10ce46e318$var$isForced.NATIVE = 'N';
var $57d9af10ce46e318$var$POLYFILL = $57d9af10ce46e318$var$isForced.POLYFILL = 'P';
module.exports = $57d9af10ce46e318$var$isForced;

});

parcelRegister("iyHek", function(module, exports) {
'use strict';

var $8yMwi = parcelRequire("8yMwi");

var $9I3bq = parcelRequire("9I3bq");

var $lfb3z = parcelRequire("lfb3z");
var $d82cef8f26151ae1$var$bind = $8yMwi($8yMwi.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $9I3bq(fn);
    return that === undefined ? fn : $lfb3z ? $d82cef8f26151ae1$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});

parcelRegister("5QIuJ", function(module, exports) {
'use strict';

var $izyPX = parcelRequire("izyPX");

var $2llQo = parcelRequire("2llQo");

var $jw35K = parcelRequire("jw35K");
module.exports = $izyPX ? function(object, key, value) {
    return $2llQo.f(object, key, $jw35K(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("2llQo", function(module, exports) {

$parcel$export(module.exports, "f", () => $1b4e7cb4f30d4df5$export$2d1720544b23b823, (v) => $1b4e7cb4f30d4df5$export$2d1720544b23b823 = v);
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $1b4e7cb4f30d4df5$export$2d1720544b23b823;
'use strict';

var $izyPX = parcelRequire("izyPX");

var $yje0b = parcelRequire("yje0b");

var $cB6If = parcelRequire("cB6If");

var $amhk0 = parcelRequire("amhk0");

var $cDVev = parcelRequire("cDVev");
var $1b4e7cb4f30d4df5$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $1b4e7cb4f30d4df5$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1b4e7cb4f30d4df5$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $1b4e7cb4f30d4df5$var$ENUMERABLE = 'enumerable';
var $1b4e7cb4f30d4df5$var$CONFIGURABLE = 'configurable';
var $1b4e7cb4f30d4df5$var$WRITABLE = 'writable';
$1b4e7cb4f30d4df5$export$2d1720544b23b823 = $izyPX ? $cB6If ? function defineProperty(O, P, Attributes) {
    $amhk0(O);
    P = $cDVev(P);
    $amhk0(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $1b4e7cb4f30d4df5$var$WRITABLE in Attributes && !Attributes[$1b4e7cb4f30d4df5$var$WRITABLE]) {
        var current = $1b4e7cb4f30d4df5$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$1b4e7cb4f30d4df5$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $1b4e7cb4f30d4df5$var$CONFIGURABLE in Attributes ? Attributes[$1b4e7cb4f30d4df5$var$CONFIGURABLE] : current[$1b4e7cb4f30d4df5$var$CONFIGURABLE],
                enumerable: $1b4e7cb4f30d4df5$var$ENUMERABLE in Attributes ? Attributes[$1b4e7cb4f30d4df5$var$ENUMERABLE] : current[$1b4e7cb4f30d4df5$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $1b4e7cb4f30d4df5$var$$defineProperty(O, P, Attributes);
} : $1b4e7cb4f30d4df5$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $amhk0(O);
    P = $cDVev(P);
    $amhk0(Attributes);
    if ($yje0b) try {
        return $1b4e7cb4f30d4df5$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $1b4e7cb4f30d4df5$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("cB6If", function(module, exports) {
'use strict';

var $izyPX = parcelRequire("izyPX");

var $5TNal = parcelRequire("5TNal");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $izyPX && $5TNal(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});

});

parcelRegister("amhk0", function(module, exports) {
'use strict';

var $81LAJ = parcelRequire("81LAJ");
var $78a96530546817de$var$$String = String;
var $78a96530546817de$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($81LAJ(argument)) return argument;
    throw new $78a96530546817de$var$$TypeError($78a96530546817de$var$$String(argument) + ' is not an object');
};

});




parcelRegister("fugbv", function(module, exports) {
'use strict';

var $8Gs5d = parcelRequire("8Gs5d");

var $bCB23 = parcelRequire("bCB23");

var $67owA = parcelRequire("67owA");

var $eh6hB = parcelRequire("eh6hB");

var $j0P42 = parcelRequire("j0P42");
var $b466364683ae94ff$var$IE_PROTO = $eh6hB('IE_PROTO');
var $b466364683ae94ff$var$$Object = Object;
var $b466364683ae94ff$var$ObjectPrototype = $b466364683ae94ff$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $j0P42 ? $b466364683ae94ff$var$$Object.getPrototypeOf : function(O) {
    var object = $67owA(O);
    if ($8Gs5d(object, $b466364683ae94ff$var$IE_PROTO)) return object[$b466364683ae94ff$var$IE_PROTO];
    var constructor = object.constructor;
    if ($bCB23(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $b466364683ae94ff$var$$Object ? $b466364683ae94ff$var$ObjectPrototype : null;
};

});
parcelRegister("eh6hB", function(module, exports) {
'use strict';

var $2DACA = parcelRequire("2DACA");

var $g713c = parcelRequire("g713c");
var $a64786db7f59c34f$var$keys = $2DACA('keys');
module.exports = function(key) {
    return $a64786db7f59c34f$var$keys[key] || ($a64786db7f59c34f$var$keys[key] = $g713c(key));
};

});

parcelRegister("j0P42", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");
module.exports = !$5TNal(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});


parcelRegister("1DwRe", function(module, exports) {
'use strict';

var $6Vebe = parcelRequire("6Vebe");

var $81LAJ = parcelRequire("81LAJ");

var $wWRWr = parcelRequire("wWRWr");

var $6SQtZ = parcelRequire("6SQtZ");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $6Vebe(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $wWRWr(O);
        $6SQtZ(proto);
        if (!$81LAJ(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRegister("6Vebe", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $9I3bq = parcelRequire("9I3bq");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $blzM2($9I3bq(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRegister("6SQtZ", function(module, exports) {
'use strict';

var $ldfVa = parcelRequire("ldfVa");
var $50307f382b048e70$var$$String = String;
var $50307f382b048e70$var$$TypeError = TypeError;
module.exports = function(argument) {
    if ($ldfVa(argument)) return argument;
    throw new $50307f382b048e70$var$$TypeError("Can't set " + $50307f382b048e70$var$$String(argument) + ' as a prototype');
};

});
parcelRegister("ldfVa", function(module, exports) {
'use strict';

var $81LAJ = parcelRequire("81LAJ");
module.exports = function(argument) {
    return $81LAJ(argument) || argument === null;
};

});



parcelRegister("6JHYn", function(module, exports) {
'use strict';

var $8Gs5d = parcelRequire("8Gs5d");

var $jffIL = parcelRequire("jffIL");

var $Cu1XA = parcelRequire("Cu1XA");

var $2llQo = parcelRequire("2llQo");
module.exports = function(target, source, exceptions) {
    var keys = $jffIL(source);
    var defineProperty = $2llQo.f;
    var getOwnPropertyDescriptor = $Cu1XA.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$8Gs5d(target, key) && !(exceptions && $8Gs5d(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRegister("jffIL", function(module, exports) {
'use strict';

var $a1ZFI = parcelRequire("a1ZFI");

var $blzM2 = parcelRequire("blzM2");

var $fhlkb = parcelRequire("fhlkb");

var $hIQfK = parcelRequire("hIQfK");

var $amhk0 = parcelRequire("amhk0");
var $e02b9ce610bfe0cc$var$concat = $blzM2([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $a1ZFI('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $fhlkb.f($amhk0(it));
    var getOwnPropertySymbols = $hIQfK.f;
    return getOwnPropertySymbols ? $e02b9ce610bfe0cc$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});
parcelRegister("fhlkb", function(module, exports) {

$parcel$export(module.exports, "f", () => $b1f8fc28c23eb1b8$export$2d1720544b23b823, (v) => $b1f8fc28c23eb1b8$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $b1f8fc28c23eb1b8$export$2d1720544b23b823;
'use strict';

var $dMOyj = parcelRequire("dMOyj");

var $6AIDI = parcelRequire("6AIDI");
var $b1f8fc28c23eb1b8$var$hiddenKeys = $6AIDI.concat('length', 'prototype');
$b1f8fc28c23eb1b8$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $dMOyj(O, $b1f8fc28c23eb1b8$var$hiddenKeys);
};

});
parcelRegister("dMOyj", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $8Gs5d = parcelRequire("8Gs5d");

var $22RLh = parcelRequire("22RLh");

var $icdlP = parcelRequire("icdlP");
var $a096f8b9dc6f76f3$require$indexOf = $icdlP.indexOf;

var $5NSM3 = parcelRequire("5NSM3");
var $a096f8b9dc6f76f3$var$push = $blzM2([].push);
module.exports = function(object, names) {
    var O = $22RLh(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$8Gs5d($5NSM3, key) && $8Gs5d(O, key) && $a096f8b9dc6f76f3$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8Gs5d(O, key = names[i++])) ~$a096f8b9dc6f76f3$require$indexOf(result, key) || $a096f8b9dc6f76f3$var$push(result, key);
    return result;
};

});
parcelRegister("icdlP", function(module, exports) {
'use strict';

var $22RLh = parcelRequire("22RLh");

var $4U47N = parcelRequire("4U47N");

var $1kfO2 = parcelRequire("1kfO2");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $d3f3b4379a96c0dd$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $22RLh($this);
        var length = $1kfO2(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $4U47N(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $d3f3b4379a96c0dd$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $d3f3b4379a96c0dd$var$createMethod(false)
};

});
parcelRegister("4U47N", function(module, exports) {
'use strict';

var $aiawW = parcelRequire("aiawW");
var $391f977d0103e8b4$var$max = Math.max;
var $391f977d0103e8b4$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $aiawW(index);
    return integer < 0 ? $391f977d0103e8b4$var$max(integer + length, 0) : $391f977d0103e8b4$var$min(integer, length);
};

});
parcelRegister("aiawW", function(module, exports) {
'use strict';

var $hSViC = parcelRequire("hSViC");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $hSViC(number);
};

});
parcelRegister("hSViC", function(module, exports) {
'use strict';
var $d053ed497945b18f$var$ceil = Math.ceil;
var $d053ed497945b18f$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $d053ed497945b18f$var$floor : $d053ed497945b18f$var$ceil)(n);
};

});



parcelRegister("1kfO2", function(module, exports) {
'use strict';

var $1oKxw = parcelRequire("1oKxw");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $1oKxw(obj.length);
};

});
parcelRegister("1oKxw", function(module, exports) {
'use strict';

var $aiawW = parcelRequire("aiawW");
var $104c22294f0fd108$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = $aiawW(argument);
    return len > 0 ? $104c22294f0fd108$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});



parcelRegister("5NSM3", function(module, exports) {
'use strict';
module.exports = {};

});


parcelRegister("6AIDI", function(module, exports) {
'use strict';
// IE8- don't enum bug keys
module.exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];

});


parcelRegister("hIQfK", function(module, exports) {

$parcel$export(module.exports, "f", () => $ce6f1414a4f8cb9b$export$2d1720544b23b823, (v) => $ce6f1414a4f8cb9b$export$2d1720544b23b823 = v);
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $ce6f1414a4f8cb9b$export$2d1720544b23b823;
'use strict';
$ce6f1414a4f8cb9b$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRegister("18Ax7", function(module, exports) {
'use strict';

var $amhk0 = parcelRequire("amhk0");

var $7a0ao = parcelRequire("7a0ao");

var $6AIDI = parcelRequire("6AIDI");

var $5NSM3 = parcelRequire("5NSM3");

var $lDC5s = parcelRequire("lDC5s");

var $fUD4A = parcelRequire("fUD4A");

var $eh6hB = parcelRequire("eh6hB");
var $0d42e0863dedd3c7$var$GT = '>';
var $0d42e0863dedd3c7$var$LT = '<';
var $0d42e0863dedd3c7$var$PROTOTYPE = 'prototype';
var $0d42e0863dedd3c7$var$SCRIPT = 'script';
var $0d42e0863dedd3c7$var$IE_PROTO = $eh6hB('IE_PROTO');
var $0d42e0863dedd3c7$var$EmptyConstructor = function() {};
var $0d42e0863dedd3c7$var$scriptTag = function(content) {
    return $0d42e0863dedd3c7$var$LT + $0d42e0863dedd3c7$var$SCRIPT + $0d42e0863dedd3c7$var$GT + content + $0d42e0863dedd3c7$var$LT + '/' + $0d42e0863dedd3c7$var$SCRIPT + $0d42e0863dedd3c7$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $0d42e0863dedd3c7$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($0d42e0863dedd3c7$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $0d42e0863dedd3c7$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $fUD4A('iframe');
    var JS = 'java' + $0d42e0863dedd3c7$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $lDC5s.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($0d42e0863dedd3c7$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $0d42e0863dedd3c7$var$activeXDocument;
var $0d42e0863dedd3c7$var$NullProtoObject = function() {
    try {
        $0d42e0863dedd3c7$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $0d42e0863dedd3c7$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $0d42e0863dedd3c7$var$activeXDocument ? $0d42e0863dedd3c7$var$NullProtoObjectViaActiveX($0d42e0863dedd3c7$var$activeXDocument) // old IE
     : $0d42e0863dedd3c7$var$NullProtoObjectViaIFrame() : $0d42e0863dedd3c7$var$NullProtoObjectViaActiveX($0d42e0863dedd3c7$var$activeXDocument); // WSH
    var length = $6AIDI.length;
    while(length--)delete $0d42e0863dedd3c7$var$NullProtoObject[$0d42e0863dedd3c7$var$PROTOTYPE][$6AIDI[length]];
    return $0d42e0863dedd3c7$var$NullProtoObject();
};
$5NSM3[$0d42e0863dedd3c7$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $0d42e0863dedd3c7$var$EmptyConstructor[$0d42e0863dedd3c7$var$PROTOTYPE] = $amhk0(O);
        result = new $0d42e0863dedd3c7$var$EmptyConstructor();
        $0d42e0863dedd3c7$var$EmptyConstructor[$0d42e0863dedd3c7$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$0d42e0863dedd3c7$var$IE_PROTO] = O;
    } else result = $0d42e0863dedd3c7$var$NullProtoObject();
    return Properties === undefined ? result : $7a0ao.f(result, Properties);
};

});
parcelRegister("7a0ao", function(module, exports) {

$parcel$export(module.exports, "f", () => $536998b0bdb04212$export$2d1720544b23b823, (v) => $536998b0bdb04212$export$2d1720544b23b823 = v);
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $536998b0bdb04212$export$2d1720544b23b823;
'use strict';

var $izyPX = parcelRequire("izyPX");

var $cB6If = parcelRequire("cB6If");

var $2llQo = parcelRequire("2llQo");

var $amhk0 = parcelRequire("amhk0");

var $22RLh = parcelRequire("22RLh");

var $4Ws1L = parcelRequire("4Ws1L");
$536998b0bdb04212$export$2d1720544b23b823 = $izyPX && !$cB6If ? Object.defineProperties : function defineProperties(O, Properties) {
    $amhk0(O);
    var props = $22RLh(Properties);
    var keys = $4Ws1L(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$2llQo.f(O, key = keys[index++], props[key]);
    return O;
};

});
parcelRegister("4Ws1L", function(module, exports) {
'use strict';

var $dMOyj = parcelRequire("dMOyj");

var $6AIDI = parcelRequire("6AIDI");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $dMOyj(O, $6AIDI);
};

});


parcelRegister("lDC5s", function(module, exports) {
'use strict';

var $a1ZFI = parcelRequire("a1ZFI");
module.exports = $a1ZFI('document', 'documentElement');

});


parcelRegister("9IqsX", function(module, exports) {
'use strict';

var $81LAJ = parcelRequire("81LAJ");

var $5QIuJ = parcelRequire("5QIuJ");
// `InstallErrorCause` abstract operation
// https://tc39.es/ecma262/#sec-installerrorcause
module.exports = function(O, options) {
    if ($81LAJ(options) && 'cause' in options) $5QIuJ(O, 'cause', options.cause);
};

});

parcelRegister("fRZA9", function(module, exports) {
'use strict';

var $5QIuJ = parcelRequire("5QIuJ");

var $cq7Tk = parcelRequire("cq7Tk");

var $jorX2 = parcelRequire("jorX2");
// non-standard V8
// eslint-disable-next-line es/no-nonstandard-error-properties -- safe
var $b8db9328d661e3e4$var$captureStackTrace = Error.captureStackTrace;
module.exports = function(error, C, stack, dropEntries) {
    if ($jorX2) {
        if ($b8db9328d661e3e4$var$captureStackTrace) $b8db9328d661e3e4$var$captureStackTrace(error, C);
        else $5QIuJ(error, 'stack', $cq7Tk(stack, dropEntries));
    }
};

});
parcelRegister("cq7Tk", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");
var $90ae08cdf0fdebf2$var$$Error = Error;
var $90ae08cdf0fdebf2$var$replace = $blzM2(''.replace);
var $90ae08cdf0fdebf2$var$TEST = function(arg) {
    return String(new $90ae08cdf0fdebf2$var$$Error(arg).stack);
}('zxcasd');
// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
var $90ae08cdf0fdebf2$var$V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var $90ae08cdf0fdebf2$var$IS_V8_OR_CHAKRA_STACK = $90ae08cdf0fdebf2$var$V8_OR_CHAKRA_STACK_ENTRY.test($90ae08cdf0fdebf2$var$TEST);
module.exports = function(stack, dropEntries) {
    if ($90ae08cdf0fdebf2$var$IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$90ae08cdf0fdebf2$var$$Error.prepareStackTrace) while(dropEntries--)stack = $90ae08cdf0fdebf2$var$replace(stack, $90ae08cdf0fdebf2$var$V8_OR_CHAKRA_STACK_ENTRY, '');
    return stack;
};

});

parcelRegister("jorX2", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");

var $jw35K = parcelRequire("jw35K");
module.exports = !$5TNal(function() {
    var error = new Error('a');
    if (!('stack' in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, 'stack', $jw35K(1, 7));
    return error.stack !== 7;
});

});


parcelRegister("7ICfs", function(module, exports) {
'use strict';

var $iyHek = parcelRequire("iyHek");

var $fztCk = parcelRequire("fztCk");

var $amhk0 = parcelRequire("amhk0");

var $gEcAW = parcelRequire("gEcAW");

var $iPzAE = parcelRequire("iPzAE");

var $1kfO2 = parcelRequire("1kfO2");

var $3MFCD = parcelRequire("3MFCD");

var $6ZzCi = parcelRequire("6ZzCi");

var $3rBCg = parcelRequire("3rBCg");

var $UXfhQ = parcelRequire("UXfhQ");
var $59ea4fc769c24c34$var$$TypeError = TypeError;
var $59ea4fc769c24c34$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $59ea4fc769c24c34$var$ResultPrototype = $59ea4fc769c24c34$var$Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $iyHek(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        var $iterator = iterator;
        iterator = undefined;
        if ($iterator) $UXfhQ($iterator, 'normal');
        return new $59ea4fc769c24c34$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $amhk0(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $3rBCg(iterable);
        if (!iterFn) throw new $59ea4fc769c24c34$var$$TypeError($gEcAW(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($iPzAE(iterFn)) {
            for(index = 0, length = $1kfO2(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $3MFCD($59ea4fc769c24c34$var$ResultPrototype, result)) return result;
            }
            return new $59ea4fc769c24c34$var$Result(false);
        }
        iterator = $6ZzCi(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $fztCk(next, iterator)).done){
        // `IteratorValue` errors should propagate without closing the iterator
        var value = step.value;
        try {
            result = callFn(value);
        } catch (error) {
            if (iterator) $UXfhQ(iterator, 'throw', error);
            else throw error;
        }
        if (typeof result == 'object' && result && $3MFCD($59ea4fc769c24c34$var$ResultPrototype, result)) return result;
    }
    return new $59ea4fc769c24c34$var$Result(false);
};

});
parcelRegister("iPzAE", function(module, exports) {
'use strict';

var $1TMNu = parcelRequire("1TMNu");

var $bim2i = parcelRequire("bim2i");
var $db5898de4d4e0edd$var$ITERATOR = $1TMNu('iterator');
var $db5898de4d4e0edd$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($bim2i.Array === it || $db5898de4d4e0edd$var$ArrayPrototype[$db5898de4d4e0edd$var$ITERATOR] === it);
};

});
parcelRegister("bim2i", function(module, exports) {
'use strict';
module.exports = {};

});


parcelRegister("6ZzCi", function(module, exports) {
'use strict';

var $fztCk = parcelRequire("fztCk");

var $9I3bq = parcelRequire("9I3bq");

var $amhk0 = parcelRequire("amhk0");

var $gEcAW = parcelRequire("gEcAW");

var $3rBCg = parcelRequire("3rBCg");
var $5174115574bb1362$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $3rBCg(argument) : usingIterator;
    if ($9I3bq(iteratorMethod)) return $amhk0($fztCk(iteratorMethod, argument));
    throw new $5174115574bb1362$var$$TypeError($gEcAW(argument) + ' is not iterable');
};

});
parcelRegister("3rBCg", function(module, exports) {
'use strict';

var $7IIKI = parcelRequire("7IIKI");

var $dcbJP = parcelRequire("dcbJP");

var $giVYe = parcelRequire("giVYe");

var $bim2i = parcelRequire("bim2i");

var $1TMNu = parcelRequire("1TMNu");
var $282112865371d58e$var$ITERATOR = $1TMNu('iterator');
module.exports = function(it) {
    if (!$giVYe(it)) return $dcbJP(it, $282112865371d58e$var$ITERATOR) || $dcbJP(it, '@@iterator') || $bim2i[$7IIKI(it)];
};

});
parcelRegister("7IIKI", function(module, exports) {
'use strict';

var $b6Nx2 = parcelRequire("b6Nx2");

var $bCB23 = parcelRequire("bCB23");

var $abkeB = parcelRequire("abkeB");

var $1TMNu = parcelRequire("1TMNu");
var $59ef5b633a277b83$var$TO_STRING_TAG = $1TMNu('toStringTag');
var $59ef5b633a277b83$var$$Object = Object;
// ES3 wrong here
var $59ef5b633a277b83$var$CORRECT_ARGUMENTS = $abkeB(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $59ef5b633a277b83$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $b6Nx2 ? $abkeB : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $59ef5b633a277b83$var$tryGet(O = $59ef5b633a277b83$var$$Object(it), $59ef5b633a277b83$var$TO_STRING_TAG)) == 'string' ? tag : $59ef5b633a277b83$var$CORRECT_ARGUMENTS ? $abkeB(O) : (result = $abkeB(O)) === 'Object' && $bCB23(O.callee) ? 'Arguments' : result;
};

});
parcelRegister("b6Nx2", function(module, exports) {
'use strict';

var $1TMNu = parcelRequire("1TMNu");
var $8166ad44b60844a3$var$TO_STRING_TAG = $1TMNu('toStringTag');
var $8166ad44b60844a3$var$test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
$8166ad44b60844a3$var$test[$8166ad44b60844a3$var$TO_STRING_TAG] = 'z';
module.exports = String($8166ad44b60844a3$var$test) === '[object z]';

});




parcelRegister("UXfhQ", function(module, exports) {
'use strict';

var $fztCk = parcelRequire("fztCk");

var $amhk0 = parcelRequire("amhk0");

var $dcbJP = parcelRequire("dcbJP");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $amhk0(iterator);
    try {
        innerResult = $dcbJP(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $fztCk(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $amhk0(innerResult);
    return value;
};

});


parcelRegister("bn7kC", function(module, exports) {
'use strict';

var $1ffsO = parcelRequire("1ffsO");
module.exports = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? '' : $default : $1ffsO(argument);
};

});
parcelRegister("1ffsO", function(module, exports) {
'use strict';

var $7IIKI = parcelRequire("7IIKI");
var $0e832ff382ed3d5a$var$$String = String;
module.exports = function(argument) {
    if ($7IIKI(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $0e832ff382ed3d5a$var$$String(argument);
};

});




parcelRegister("1sRs4", function(module, exports) {
'use strict';

var $22RLh = parcelRequire("22RLh");

var $eelBH = parcelRequire("eelBH");

var $bim2i = parcelRequire("bim2i");

var $iUh4p = parcelRequire("iUh4p");

var $2llQo = parcelRequire("2llQo");
var $1111de617187a88f$require$defineProperty = $2llQo.f;

var $03Wh9 = parcelRequire("03Wh9");

var $fJ7og = parcelRequire("fJ7og");

var $1cBJJ = parcelRequire("1cBJJ");

var $izyPX = parcelRequire("izyPX");
var $1111de617187a88f$var$ARRAY_ITERATOR = 'Array Iterator';
var $1111de617187a88f$var$setInternalState = $iUh4p.set;
var $1111de617187a88f$var$getInternalState = $iUh4p.getterFor($1111de617187a88f$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $03Wh9(Array, 'Array', function(iterated, kind) {
    $1111de617187a88f$var$setInternalState(this, {
        type: $1111de617187a88f$var$ARRAY_ITERATOR,
        target: $22RLh(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $1111de617187a88f$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $fJ7og(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $fJ7og(index, false);
        case 'values':
            return $fJ7og(target[index], false);
    }
    return $fJ7og([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $1111de617187a88f$var$values = $bim2i.Arguments = $bim2i.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$eelBH('keys');
$eelBH('values');
$eelBH('entries');
// V8 ~ Chrome 45- bug
if (!$1cBJJ && $izyPX && $1111de617187a88f$var$values.name !== 'values') try {
    $1111de617187a88f$require$defineProperty($1111de617187a88f$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}

});
parcelRegister("eelBH", function(module, exports) {
'use strict';
module.exports = function() {};

});

parcelRegister("iUh4p", function(module, exports) {
'use strict';

var $e8ACr = parcelRequire("e8ACr");

var $a974b = parcelRequire("a974b");

var $81LAJ = parcelRequire("81LAJ");

var $5QIuJ = parcelRequire("5QIuJ");

var $8Gs5d = parcelRequire("8Gs5d");

var $6D74Q = parcelRequire("6D74Q");

var $eh6hB = parcelRequire("eh6hB");

var $5NSM3 = parcelRequire("5NSM3");
var $dc3ab2b3bcd32b6b$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $dc3ab2b3bcd32b6b$var$TypeError = $a974b.TypeError;
var $dc3ab2b3bcd32b6b$var$WeakMap = $a974b.WeakMap;
var $dc3ab2b3bcd32b6b$var$set, $dc3ab2b3bcd32b6b$var$get, $dc3ab2b3bcd32b6b$var$has;
var $dc3ab2b3bcd32b6b$var$enforce = function(it) {
    return $dc3ab2b3bcd32b6b$var$has(it) ? $dc3ab2b3bcd32b6b$var$get(it) : $dc3ab2b3bcd32b6b$var$set(it, {});
};
var $dc3ab2b3bcd32b6b$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$81LAJ(it) || (state = $dc3ab2b3bcd32b6b$var$get(it)).type !== TYPE) throw new $dc3ab2b3bcd32b6b$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($e8ACr || $6D74Q.state) {
    var $dc3ab2b3bcd32b6b$var$store = $6D74Q.state || ($6D74Q.state = new $dc3ab2b3bcd32b6b$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $dc3ab2b3bcd32b6b$var$store.get = $dc3ab2b3bcd32b6b$var$store.get;
    $dc3ab2b3bcd32b6b$var$store.has = $dc3ab2b3bcd32b6b$var$store.has;
    $dc3ab2b3bcd32b6b$var$store.set = $dc3ab2b3bcd32b6b$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $dc3ab2b3bcd32b6b$var$set = function(it, metadata) {
        if ($dc3ab2b3bcd32b6b$var$store.has(it)) throw new $dc3ab2b3bcd32b6b$var$TypeError($dc3ab2b3bcd32b6b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $dc3ab2b3bcd32b6b$var$store.set(it, metadata);
        return metadata;
    };
    $dc3ab2b3bcd32b6b$var$get = function(it) {
        return $dc3ab2b3bcd32b6b$var$store.get(it) || {};
    };
    $dc3ab2b3bcd32b6b$var$has = function(it) {
        return $dc3ab2b3bcd32b6b$var$store.has(it);
    };
} else {
    var $dc3ab2b3bcd32b6b$var$STATE = $eh6hB('state');
    $5NSM3[$dc3ab2b3bcd32b6b$var$STATE] = true;
    $dc3ab2b3bcd32b6b$var$set = function(it, metadata) {
        if ($8Gs5d(it, $dc3ab2b3bcd32b6b$var$STATE)) throw new $dc3ab2b3bcd32b6b$var$TypeError($dc3ab2b3bcd32b6b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5QIuJ(it, $dc3ab2b3bcd32b6b$var$STATE, metadata);
        return metadata;
    };
    $dc3ab2b3bcd32b6b$var$get = function(it) {
        return $8Gs5d(it, $dc3ab2b3bcd32b6b$var$STATE) ? it[$dc3ab2b3bcd32b6b$var$STATE] : {};
    };
    $dc3ab2b3bcd32b6b$var$has = function(it) {
        return $8Gs5d(it, $dc3ab2b3bcd32b6b$var$STATE);
    };
}
module.exports = {
    set: $dc3ab2b3bcd32b6b$var$set,
    get: $dc3ab2b3bcd32b6b$var$get,
    has: $dc3ab2b3bcd32b6b$var$has,
    enforce: $dc3ab2b3bcd32b6b$var$enforce,
    getterFor: $dc3ab2b3bcd32b6b$var$getterFor
};

});
parcelRegister("e8ACr", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $bCB23 = parcelRequire("bCB23");
var $a4ae37d02805c089$var$WeakMap = $a974b.WeakMap;
module.exports = $bCB23($a4ae37d02805c089$var$WeakMap) && /native code/.test(String($a4ae37d02805c089$var$WeakMap));

});


parcelRegister("03Wh9", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $fztCk = parcelRequire("fztCk");

var $1cBJJ = parcelRequire("1cBJJ");

var $Pi9oo = parcelRequire("Pi9oo");

var $bCB23 = parcelRequire("bCB23");

var $eof8u = parcelRequire("eof8u");

var $fugbv = parcelRequire("fugbv");

var $1DwRe = parcelRequire("1DwRe");

var $3pVms = parcelRequire("3pVms");

var $5QIuJ = parcelRequire("5QIuJ");

var $9DIeg = parcelRequire("9DIeg");

var $1TMNu = parcelRequire("1TMNu");

var $bim2i = parcelRequire("bim2i");

var $fjUiZ = parcelRequire("fjUiZ");
var $00bd7c45dd2dc870$var$PROPER_FUNCTION_NAME = $Pi9oo.PROPER;
var $00bd7c45dd2dc870$var$CONFIGURABLE_FUNCTION_NAME = $Pi9oo.CONFIGURABLE;
var $00bd7c45dd2dc870$var$IteratorPrototype = $fjUiZ.IteratorPrototype;
var $00bd7c45dd2dc870$var$BUGGY_SAFARI_ITERATORS = $fjUiZ.BUGGY_SAFARI_ITERATORS;
var $00bd7c45dd2dc870$var$ITERATOR = $1TMNu('iterator');
var $00bd7c45dd2dc870$var$KEYS = 'keys';
var $00bd7c45dd2dc870$var$VALUES = 'values';
var $00bd7c45dd2dc870$var$ENTRIES = 'entries';
var $00bd7c45dd2dc870$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $eof8u(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$00bd7c45dd2dc870$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $00bd7c45dd2dc870$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $00bd7c45dd2dc870$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $00bd7c45dd2dc870$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$00bd7c45dd2dc870$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$00bd7c45dd2dc870$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $fugbv(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$1cBJJ && $fugbv(CurrentIteratorPrototype) !== $00bd7c45dd2dc870$var$IteratorPrototype) {
                if ($1DwRe) $1DwRe(CurrentIteratorPrototype, $00bd7c45dd2dc870$var$IteratorPrototype);
                else if (!$bCB23(CurrentIteratorPrototype[$00bd7c45dd2dc870$var$ITERATOR])) $9DIeg(CurrentIteratorPrototype, $00bd7c45dd2dc870$var$ITERATOR, $00bd7c45dd2dc870$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $3pVms(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($1cBJJ) $bim2i[TO_STRING_TAG] = $00bd7c45dd2dc870$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($00bd7c45dd2dc870$var$PROPER_FUNCTION_NAME && DEFAULT === $00bd7c45dd2dc870$var$VALUES && nativeIterator && nativeIterator.name !== $00bd7c45dd2dc870$var$VALUES) {
        if (!$1cBJJ && $00bd7c45dd2dc870$var$CONFIGURABLE_FUNCTION_NAME) $5QIuJ(IterablePrototype, 'name', $00bd7c45dd2dc870$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $fztCk(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($00bd7c45dd2dc870$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($00bd7c45dd2dc870$var$KEYS),
            entries: getIterationMethod($00bd7c45dd2dc870$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($00bd7c45dd2dc870$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $9DIeg(IterablePrototype, KEY, methods[KEY]);
        } else $k8IkA({
            target: NAME,
            proto: true,
            forced: $00bd7c45dd2dc870$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$1cBJJ || FORCED) && IterablePrototype[$00bd7c45dd2dc870$var$ITERATOR] !== defaultIterator) $9DIeg(IterablePrototype, $00bd7c45dd2dc870$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $bim2i[NAME] = defaultIterator;
    return methods;
};

});
parcelRegister("Pi9oo", function(module, exports) {
'use strict';

var $izyPX = parcelRequire("izyPX");

var $8Gs5d = parcelRequire("8Gs5d");
var $09a2d7d827b77642$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $09a2d7d827b77642$var$getDescriptor = $izyPX && Object.getOwnPropertyDescriptor;
var $09a2d7d827b77642$var$EXISTS = $8Gs5d($09a2d7d827b77642$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $09a2d7d827b77642$var$PROPER = $09a2d7d827b77642$var$EXISTS && (function something() {}).name === 'something';
var $09a2d7d827b77642$var$CONFIGURABLE = $09a2d7d827b77642$var$EXISTS && (!$izyPX || $izyPX && $09a2d7d827b77642$var$getDescriptor($09a2d7d827b77642$var$FunctionPrototype, 'name').configurable);
module.exports = {
    EXISTS: $09a2d7d827b77642$var$EXISTS,
    PROPER: $09a2d7d827b77642$var$PROPER,
    CONFIGURABLE: $09a2d7d827b77642$var$CONFIGURABLE
};

});

parcelRegister("eof8u", function(module, exports) {
'use strict';

var $fjUiZ = parcelRequire("fjUiZ");
var $a79f0c3d48f4d169$require$IteratorPrototype = $fjUiZ.IteratorPrototype;

var $18Ax7 = parcelRequire("18Ax7");

var $jw35K = parcelRequire("jw35K");

var $3pVms = parcelRequire("3pVms");

var $bim2i = parcelRequire("bim2i");
var $a79f0c3d48f4d169$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $18Ax7($a79f0c3d48f4d169$require$IteratorPrototype, {
        next: $jw35K(+!ENUMERABLE_NEXT, next)
    });
    $3pVms(IteratorConstructor, TO_STRING_TAG, false, true);
    $bim2i[TO_STRING_TAG] = $a79f0c3d48f4d169$var$returnThis;
    return IteratorConstructor;
};

});
parcelRegister("fjUiZ", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");

var $bCB23 = parcelRequire("bCB23");

var $81LAJ = parcelRequire("81LAJ");

var $18Ax7 = parcelRequire("18Ax7");

var $fugbv = parcelRequire("fugbv");

var $9DIeg = parcelRequire("9DIeg");

var $1TMNu = parcelRequire("1TMNu");

var $1cBJJ = parcelRequire("1cBJJ");
var $b2744e674335f849$var$ITERATOR = $1TMNu('iterator');
var $b2744e674335f849$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $b2744e674335f849$var$IteratorPrototype, $b2744e674335f849$var$PrototypeOfArrayIteratorPrototype, $b2744e674335f849$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $b2744e674335f849$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $b2744e674335f849$var$arrayIterator)) $b2744e674335f849$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $b2744e674335f849$var$PrototypeOfArrayIteratorPrototype = $fugbv($fugbv($b2744e674335f849$var$arrayIterator));
        if ($b2744e674335f849$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $b2744e674335f849$var$IteratorPrototype = $b2744e674335f849$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $b2744e674335f849$var$NEW_ITERATOR_PROTOTYPE = !$81LAJ($b2744e674335f849$var$IteratorPrototype) || $5TNal(function() {
    var test = {};
    // FF44- legacy iterators case
    return $b2744e674335f849$var$IteratorPrototype[$b2744e674335f849$var$ITERATOR].call(test) !== test;
});
if ($b2744e674335f849$var$NEW_ITERATOR_PROTOTYPE) $b2744e674335f849$var$IteratorPrototype = {};
else if ($1cBJJ) $b2744e674335f849$var$IteratorPrototype = $18Ax7($b2744e674335f849$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$bCB23($b2744e674335f849$var$IteratorPrototype[$b2744e674335f849$var$ITERATOR])) $9DIeg($b2744e674335f849$var$IteratorPrototype, $b2744e674335f849$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $b2744e674335f849$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $b2744e674335f849$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRegister("9DIeg", function(module, exports) {
'use strict';

var $5QIuJ = parcelRequire("5QIuJ");
module.exports = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else $5QIuJ(target, key, value);
    return target;
};

});


parcelRegister("3pVms", function(module, exports) {
'use strict';

var $b6Nx2 = parcelRequire("b6Nx2");

var $2llQo = parcelRequire("2llQo");
var $27d033a943f5d823$require$defineProperty = $2llQo.f;

var $5QIuJ = parcelRequire("5QIuJ");

var $8Gs5d = parcelRequire("8Gs5d");

var $jyhCT = parcelRequire("jyhCT");

var $1TMNu = parcelRequire("1TMNu");
var $27d033a943f5d823$var$TO_STRING_TAG = $1TMNu('toStringTag');
module.exports = function(it, TAG, STATIC, SET_METHOD) {
    var target = STATIC ? it : it && it.prototype;
    if (target) {
        if (!$8Gs5d(target, $27d033a943f5d823$var$TO_STRING_TAG)) $27d033a943f5d823$require$defineProperty(target, $27d033a943f5d823$var$TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !$b6Nx2) $5QIuJ(target, 'toString', $jyhCT);
    }
};

});
parcelRegister("jyhCT", function(module, exports) {
'use strict';

var $b6Nx2 = parcelRequire("b6Nx2");

var $7IIKI = parcelRequire("7IIKI");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $b6Nx2 ? ({}).toString : function toString() {
    return '[object ' + $7IIKI(this) + ']';
};

});




parcelRegister("fJ7og", function(module, exports) {
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});


parcelRegister("1o61r", function(module, exports) {
// empty

});

parcelRegister("bW6p0", function(module, exports) {
'use strict';
parcelRequire("9hSKp");
parcelRequire("4MY5K");
parcelRequire("chvhL");
parcelRequire("1KFVU");
parcelRequire("6UgSe");
parcelRequire("euzrX");

});
parcelRegister("9hSKp", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $1cBJJ = parcelRequire("1cBJJ");

var $i7XiZ = parcelRequire("i7XiZ");

var $a974b = parcelRequire("a974b");

var $fDEaU = parcelRequire("fDEaU");

var $fztCk = parcelRequire("fztCk");

var $9DIeg = parcelRequire("9DIeg");

var $1DwRe = parcelRequire("1DwRe");

var $3pVms = parcelRequire("3pVms");

var $6Fx27 = parcelRequire("6Fx27");

var $9I3bq = parcelRequire("9I3bq");

var $bCB23 = parcelRequire("bCB23");

var $81LAJ = parcelRequire("81LAJ");

var $6ABtt = parcelRequire("6ABtt");

var $17lIF = parcelRequire("17lIF");

var $laoax = parcelRequire("laoax");
var $6c302b4c80c55ef8$require$task = $laoax.set;

var $kln2e = parcelRequire("kln2e");

var $ggKK7 = parcelRequire("ggKK7");

var $97RGR = parcelRequire("97RGR");

var $fOoey = parcelRequire("fOoey");

var $iUh4p = parcelRequire("iUh4p");

var $4BzCf = parcelRequire("4BzCf");

var $bpphM = parcelRequire("bpphM");

var $2hmlq = parcelRequire("2hmlq");
var $6c302b4c80c55ef8$var$PROMISE = 'Promise';
var $6c302b4c80c55ef8$var$FORCED_PROMISE_CONSTRUCTOR = $bpphM.CONSTRUCTOR;
var $6c302b4c80c55ef8$var$NATIVE_PROMISE_REJECTION_EVENT = $bpphM.REJECTION_EVENT;
var $6c302b4c80c55ef8$var$NATIVE_PROMISE_SUBCLASSING = $bpphM.SUBCLASSING;
var $6c302b4c80c55ef8$var$getInternalPromiseState = $iUh4p.getterFor($6c302b4c80c55ef8$var$PROMISE);
var $6c302b4c80c55ef8$var$setInternalState = $iUh4p.set;
var $6c302b4c80c55ef8$var$NativePromisePrototype = $4BzCf && $4BzCf.prototype;
var $6c302b4c80c55ef8$var$PromiseConstructor = $4BzCf;
var $6c302b4c80c55ef8$var$PromisePrototype = $6c302b4c80c55ef8$var$NativePromisePrototype;
var $6c302b4c80c55ef8$var$TypeError = $a974b.TypeError;
var $6c302b4c80c55ef8$var$document = $a974b.document;
var $6c302b4c80c55ef8$var$process = $a974b.process;
var $6c302b4c80c55ef8$var$newPromiseCapability = $2hmlq.f;
var $6c302b4c80c55ef8$var$newGenericPromiseCapability = $6c302b4c80c55ef8$var$newPromiseCapability;
var $6c302b4c80c55ef8$var$DISPATCH_EVENT = !!($6c302b4c80c55ef8$var$document && $6c302b4c80c55ef8$var$document.createEvent && $a974b.dispatchEvent);
var $6c302b4c80c55ef8$var$UNHANDLED_REJECTION = 'unhandledrejection';
var $6c302b4c80c55ef8$var$REJECTION_HANDLED = 'rejectionhandled';
var $6c302b4c80c55ef8$var$PENDING = 0;
var $6c302b4c80c55ef8$var$FULFILLED = 1;
var $6c302b4c80c55ef8$var$REJECTED = 2;
var $6c302b4c80c55ef8$var$HANDLED = 1;
var $6c302b4c80c55ef8$var$UNHANDLED = 2;
var $6c302b4c80c55ef8$var$Internal, $6c302b4c80c55ef8$var$OwnPromiseCapability, $6c302b4c80c55ef8$var$PromiseWrapper, $6c302b4c80c55ef8$var$nativeThen;
// helpers
var $6c302b4c80c55ef8$var$isThenable = function(it) {
    var then;
    return $81LAJ(it) && $bCB23(then = it.then) ? then : false;
};
var $6c302b4c80c55ef8$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state === $6c302b4c80c55ef8$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $6c302b4c80c55ef8$var$UNHANDLED) $6c302b4c80c55ef8$var$onHandleUnhandled(state);
                state.rejection = $6c302b4c80c55ef8$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $6c302b4c80c55ef8$var$TypeError('Promise-chain cycle'));
            else if (then = $6c302b4c80c55ef8$var$isThenable(result)) $fztCk(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $6c302b4c80c55ef8$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $kln2e(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$6c302b4c80c55ef8$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $6c302b4c80c55ef8$var$onUnhandled(state);
    });
};
var $6c302b4c80c55ef8$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($6c302b4c80c55ef8$var$DISPATCH_EVENT) {
        event = $6c302b4c80c55ef8$var$document.createEvent('Event');
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $a974b.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$6c302b4c80c55ef8$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $a974b['on' + name])) handler(event);
    else if (name === $6c302b4c80c55ef8$var$UNHANDLED_REJECTION) $ggKK7('Unhandled promise rejection', reason);
};
var $6c302b4c80c55ef8$var$onUnhandled = function(state) {
    $fztCk($6c302b4c80c55ef8$require$task, $a974b, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $6c302b4c80c55ef8$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $97RGR(function() {
                if ($i7XiZ) $6c302b4c80c55ef8$var$process.emit('unhandledRejection', value, promise);
                else $6c302b4c80c55ef8$var$dispatchEvent($6c302b4c80c55ef8$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $i7XiZ || $6c302b4c80c55ef8$var$isUnhandled(state) ? $6c302b4c80c55ef8$var$UNHANDLED : $6c302b4c80c55ef8$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $6c302b4c80c55ef8$var$isUnhandled = function(state) {
    return state.rejection !== $6c302b4c80c55ef8$var$HANDLED && !state.parent;
};
var $6c302b4c80c55ef8$var$onHandleUnhandled = function(state) {
    $fztCk($6c302b4c80c55ef8$require$task, $a974b, function() {
        var promise = state.facade;
        if ($i7XiZ) $6c302b4c80c55ef8$var$process.emit('rejectionHandled', promise);
        else $6c302b4c80c55ef8$var$dispatchEvent($6c302b4c80c55ef8$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $6c302b4c80c55ef8$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $6c302b4c80c55ef8$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $6c302b4c80c55ef8$var$REJECTED;
    $6c302b4c80c55ef8$var$notify(state, true);
};
var $6c302b4c80c55ef8$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $6c302b4c80c55ef8$var$TypeError("Promise can't be resolved itself");
        var then = $6c302b4c80c55ef8$var$isThenable(value);
        if (then) $kln2e(function() {
            var wrapper = {
                done: false
            };
            try {
                $fztCk(then, value, $6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalResolve, wrapper, state), $6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalReject, wrapper, state));
            } catch (error) {
                $6c302b4c80c55ef8$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $6c302b4c80c55ef8$var$FULFILLED;
            $6c302b4c80c55ef8$var$notify(state, false);
        }
    } catch (error) {
        $6c302b4c80c55ef8$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($6c302b4c80c55ef8$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $6c302b4c80c55ef8$var$PromiseConstructor = function Promise(executor) {
        $6ABtt(this, $6c302b4c80c55ef8$var$PromisePrototype);
        $9I3bq(executor);
        $fztCk($6c302b4c80c55ef8$var$Internal, this);
        var state = $6c302b4c80c55ef8$var$getInternalPromiseState(this);
        try {
            executor($6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalResolve, state), $6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalReject, state));
        } catch (error) {
            $6c302b4c80c55ef8$var$internalReject(state, error);
        }
    };
    $6c302b4c80c55ef8$var$PromisePrototype = $6c302b4c80c55ef8$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $6c302b4c80c55ef8$var$Internal = function Promise(executor) {
        $6c302b4c80c55ef8$var$setInternalState(this, {
            type: $6c302b4c80c55ef8$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $fOoey(),
            rejection: false,
            state: $6c302b4c80c55ef8$var$PENDING,
            value: null
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $6c302b4c80c55ef8$var$Internal.prototype = $9DIeg($6c302b4c80c55ef8$var$PromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var state = $6c302b4c80c55ef8$var$getInternalPromiseState(this);
        var reaction = $6c302b4c80c55ef8$var$newPromiseCapability($17lIF(this, $6c302b4c80c55ef8$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $bCB23(onFulfilled) ? onFulfilled : true;
        reaction.fail = $bCB23(onRejected) && onRejected;
        reaction.domain = $i7XiZ ? $6c302b4c80c55ef8$var$process.domain : undefined;
        if (state.state === $6c302b4c80c55ef8$var$PENDING) state.reactions.add(reaction);
        else $kln2e(function() {
            $6c302b4c80c55ef8$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $6c302b4c80c55ef8$var$OwnPromiseCapability = function() {
        var promise = new $6c302b4c80c55ef8$var$Internal();
        var state = $6c302b4c80c55ef8$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalResolve, state);
        this.reject = $6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalReject, state);
    };
    $2hmlq.f = $6c302b4c80c55ef8$var$newPromiseCapability = function(C) {
        return C === $6c302b4c80c55ef8$var$PromiseConstructor || C === $6c302b4c80c55ef8$var$PromiseWrapper ? new $6c302b4c80c55ef8$var$OwnPromiseCapability(C) : $6c302b4c80c55ef8$var$newGenericPromiseCapability(C);
    };
    if (!$1cBJJ && $bCB23($4BzCf) && $6c302b4c80c55ef8$var$NativePromisePrototype !== Object.prototype) {
        $6c302b4c80c55ef8$var$nativeThen = $6c302b4c80c55ef8$var$NativePromisePrototype.then;
        if (!$6c302b4c80c55ef8$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $9DIeg($6c302b4c80c55ef8$var$NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
            var that = this;
            return new $6c302b4c80c55ef8$var$PromiseConstructor(function(resolve, reject) {
                $fztCk($6c302b4c80c55ef8$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $6c302b4c80c55ef8$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($1DwRe) $1DwRe($6c302b4c80c55ef8$var$NativePromisePrototype, $6c302b4c80c55ef8$var$PromisePrototype);
    }
}
// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$k8IkA({
    global: true,
    constructor: true,
    wrap: true,
    forced: $6c302b4c80c55ef8$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $6c302b4c80c55ef8$var$PromiseConstructor
});
$6c302b4c80c55ef8$var$PromiseWrapper = $fDEaU.Promise;
$3pVms($6c302b4c80c55ef8$var$PromiseConstructor, $6c302b4c80c55ef8$var$PROMISE, false, true);
$6Fx27($6c302b4c80c55ef8$var$PROMISE);

});
parcelRegister("i7XiZ", function(module, exports) {
'use strict';

var $dlL5c = parcelRequire("dlL5c");
module.exports = $dlL5c === 'NODE';

});
parcelRegister("dlL5c", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $bd2Ce = parcelRequire("bd2Ce");

var $abkeB = parcelRequire("abkeB");
var $9b81c2357b0a5960$var$userAgentStartsWith = function(string) {
    return $bd2Ce.slice(0, string.length) === string;
};
module.exports = function() {
    if ($9b81c2357b0a5960$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($9b81c2357b0a5960$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($9b81c2357b0a5960$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($9b81c2357b0a5960$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($a974b.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($a974b.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($abkeB($a974b.process) === 'process') return 'NODE';
    if ($a974b.window && $a974b.document) return 'BROWSER';
    return 'REST';
}();

});


parcelRegister("6Fx27", function(module, exports) {
'use strict';

var $a1ZFI = parcelRequire("a1ZFI");

var $ca0NC = parcelRequire("ca0NC");

var $1TMNu = parcelRequire("1TMNu");

var $izyPX = parcelRequire("izyPX");
var $4db0322016396c49$var$SPECIES = $1TMNu('species');
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $a1ZFI(CONSTRUCTOR_NAME);
    if ($izyPX && Constructor && !Constructor[$4db0322016396c49$var$SPECIES]) $ca0NC(Constructor, $4db0322016396c49$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});
parcelRegister("ca0NC", function(module, exports) {
'use strict';

var $2llQo = parcelRequire("2llQo");
module.exports = function(target, name, descriptor) {
    return $2llQo.f(target, name, descriptor);
};

});


parcelRegister("6ABtt", function(module, exports) {
'use strict';

var $3MFCD = parcelRequire("3MFCD");
var $4cc32c7eba8a551a$var$$TypeError = TypeError;
module.exports = function(it, Prototype) {
    if ($3MFCD(Prototype, it)) return it;
    throw new $4cc32c7eba8a551a$var$$TypeError('Incorrect invocation');
};

});

parcelRegister("17lIF", function(module, exports) {
'use strict';

var $amhk0 = parcelRequire("amhk0");

var $21d1Z = parcelRequire("21d1Z");

var $giVYe = parcelRequire("giVYe");

var $1TMNu = parcelRequire("1TMNu");
var $0d074aed54c19725$var$SPECIES = $1TMNu('species');
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = $amhk0(O).constructor;
    var S;
    return C === undefined || $giVYe(S = $amhk0(C)[$0d074aed54c19725$var$SPECIES]) ? defaultConstructor : $21d1Z(S);
};

});
parcelRegister("21d1Z", function(module, exports) {
'use strict';

var $6khJx = parcelRequire("6khJx");

var $gEcAW = parcelRequire("gEcAW");
var $1785c87ad2f83d9d$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
module.exports = function(argument) {
    if ($6khJx(argument)) return argument;
    throw new $1785c87ad2f83d9d$var$$TypeError($gEcAW(argument) + ' is not a constructor');
};

});
parcelRegister("6khJx", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $5TNal = parcelRequire("5TNal");

var $bCB23 = parcelRequire("bCB23");

var $7IIKI = parcelRequire("7IIKI");

var $a1ZFI = parcelRequire("a1ZFI");

var $hl3EW = parcelRequire("hl3EW");
var $49b25dd5c4f9389e$var$noop = function() {};
var $49b25dd5c4f9389e$var$construct = $a1ZFI('Reflect', 'construct');
var $49b25dd5c4f9389e$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $49b25dd5c4f9389e$var$exec = $blzM2($49b25dd5c4f9389e$var$constructorRegExp.exec);
var $49b25dd5c4f9389e$var$INCORRECT_TO_STRING = !$49b25dd5c4f9389e$var$constructorRegExp.test($49b25dd5c4f9389e$var$noop);
var $49b25dd5c4f9389e$var$isConstructorModern = function isConstructor(argument) {
    if (!$bCB23(argument)) return false;
    try {
        $49b25dd5c4f9389e$var$construct($49b25dd5c4f9389e$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $49b25dd5c4f9389e$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$bCB23(argument)) return false;
    switch($7IIKI(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $49b25dd5c4f9389e$var$INCORRECT_TO_STRING || !!$49b25dd5c4f9389e$var$exec($49b25dd5c4f9389e$var$constructorRegExp, $hl3EW(argument));
    } catch (error) {
        return true;
    }
};
$49b25dd5c4f9389e$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$49b25dd5c4f9389e$var$construct || $5TNal(function() {
    var called;
    return $49b25dd5c4f9389e$var$isConstructorModern($49b25dd5c4f9389e$var$isConstructorModern.call) || !$49b25dd5c4f9389e$var$isConstructorModern(Object) || !$49b25dd5c4f9389e$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $49b25dd5c4f9389e$var$isConstructorLegacy : $49b25dd5c4f9389e$var$isConstructorModern;

});
parcelRegister("hl3EW", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $bCB23 = parcelRequire("bCB23");

var $6D74Q = parcelRequire("6D74Q");
var $c9f73c7f7baa270d$var$functionToString = $blzM2(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$bCB23($6D74Q.inspectSource)) $6D74Q.inspectSource = function(it) {
    return $c9f73c7f7baa270d$var$functionToString(it);
};
module.exports = $6D74Q.inspectSource;

});




parcelRegister("laoax", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $dgWbh = parcelRequire("dgWbh");

var $iyHek = parcelRequire("iyHek");

var $bCB23 = parcelRequire("bCB23");

var $8Gs5d = parcelRequire("8Gs5d");

var $5TNal = parcelRequire("5TNal");

var $lDC5s = parcelRequire("lDC5s");

var $eXbub = parcelRequire("eXbub");

var $fUD4A = parcelRequire("fUD4A");

var $lcEhe = parcelRequire("lcEhe");

var $4LkyJ = parcelRequire("4LkyJ");

var $i7XiZ = parcelRequire("i7XiZ");
var $f68d4795da4bb704$var$set = $a974b.setImmediate;
var $f68d4795da4bb704$var$clear = $a974b.clearImmediate;
var $f68d4795da4bb704$var$process = $a974b.process;
var $f68d4795da4bb704$var$Dispatch = $a974b.Dispatch;
var $f68d4795da4bb704$var$Function = $a974b.Function;
var $f68d4795da4bb704$var$MessageChannel = $a974b.MessageChannel;
var $f68d4795da4bb704$var$String = $a974b.String;
var $f68d4795da4bb704$var$counter = 0;
var $f68d4795da4bb704$var$queue = {};
var $f68d4795da4bb704$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $f68d4795da4bb704$var$$location, $f68d4795da4bb704$var$defer, $f68d4795da4bb704$var$channel, $f68d4795da4bb704$var$port;
$5TNal(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $f68d4795da4bb704$var$$location = $a974b.location;
});
var $f68d4795da4bb704$var$run = function(id) {
    if ($8Gs5d($f68d4795da4bb704$var$queue, id)) {
        var fn = $f68d4795da4bb704$var$queue[id];
        delete $f68d4795da4bb704$var$queue[id];
        fn();
    }
};
var $f68d4795da4bb704$var$runner = function(id) {
    return function() {
        $f68d4795da4bb704$var$run(id);
    };
};
var $f68d4795da4bb704$var$eventListener = function(event) {
    $f68d4795da4bb704$var$run(event.data);
};
var $f68d4795da4bb704$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $a974b.postMessage($f68d4795da4bb704$var$String(id), $f68d4795da4bb704$var$$location.protocol + '//' + $f68d4795da4bb704$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$f68d4795da4bb704$var$set || !$f68d4795da4bb704$var$clear) {
    $f68d4795da4bb704$var$set = function setImmediate(handler) {
        $lcEhe(arguments.length, 1);
        var fn = $bCB23(handler) ? handler : $f68d4795da4bb704$var$Function(handler);
        var args = $eXbub(arguments, 1);
        $f68d4795da4bb704$var$queue[++$f68d4795da4bb704$var$counter] = function() {
            $dgWbh(fn, undefined, args);
        };
        $f68d4795da4bb704$var$defer($f68d4795da4bb704$var$counter);
        return $f68d4795da4bb704$var$counter;
    };
    $f68d4795da4bb704$var$clear = function clearImmediate(id) {
        delete $f68d4795da4bb704$var$queue[id];
    };
    // Node.js 0.8-
    if ($i7XiZ) $f68d4795da4bb704$var$defer = function(id) {
        $f68d4795da4bb704$var$process.nextTick($f68d4795da4bb704$var$runner(id));
    };
    else if ($f68d4795da4bb704$var$Dispatch && $f68d4795da4bb704$var$Dispatch.now) $f68d4795da4bb704$var$defer = function(id) {
        $f68d4795da4bb704$var$Dispatch.now($f68d4795da4bb704$var$runner(id));
    };
    else if ($f68d4795da4bb704$var$MessageChannel && !$4LkyJ) {
        $f68d4795da4bb704$var$channel = new $f68d4795da4bb704$var$MessageChannel();
        $f68d4795da4bb704$var$port = $f68d4795da4bb704$var$channel.port2;
        $f68d4795da4bb704$var$channel.port1.onmessage = $f68d4795da4bb704$var$eventListener;
        $f68d4795da4bb704$var$defer = $iyHek($f68d4795da4bb704$var$port.postMessage, $f68d4795da4bb704$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($a974b.addEventListener && $bCB23($a974b.postMessage) && !$a974b.importScripts && $f68d4795da4bb704$var$$location && $f68d4795da4bb704$var$$location.protocol !== 'file:' && !$5TNal($f68d4795da4bb704$var$globalPostMessageDefer)) {
        $f68d4795da4bb704$var$defer = $f68d4795da4bb704$var$globalPostMessageDefer;
        $a974b.addEventListener('message', $f68d4795da4bb704$var$eventListener, false);
    // IE8-
    } else if ($f68d4795da4bb704$var$ONREADYSTATECHANGE in $fUD4A('script')) $f68d4795da4bb704$var$defer = function(id) {
        $lDC5s.appendChild($fUD4A('script'))[$f68d4795da4bb704$var$ONREADYSTATECHANGE] = function() {
            $lDC5s.removeChild(this);
            $f68d4795da4bb704$var$run(id);
        };
    };
    else $f68d4795da4bb704$var$defer = function(id) {
        setTimeout($f68d4795da4bb704$var$runner(id), 0);
    };
}
module.exports = {
    set: $f68d4795da4bb704$var$set,
    clear: $f68d4795da4bb704$var$clear
};

});
parcelRegister("eXbub", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");
module.exports = $blzM2([].slice);

});

parcelRegister("lcEhe", function(module, exports) {
'use strict';
var $f6f9f6259be2e999$var$$TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw new $f6f9f6259be2e999$var$$TypeError('Not enough arguments');
    return passed;
};

});

parcelRegister("4LkyJ", function(module, exports) {
'use strict';

var $bd2Ce = parcelRequire("bd2Ce");
module.exports = /ipad|iphone|ipod/i.test($bd2Ce) && /applewebkit/i.test($bd2Ce);

});


parcelRegister("kln2e", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $2VzIO = parcelRequire("2VzIO");

var $iyHek = parcelRequire("iyHek");

var $laoax = parcelRequire("laoax");
var $ecf7a30f3d257c00$require$macrotask = $laoax.set;

var $fOoey = parcelRequire("fOoey");

var $4LkyJ = parcelRequire("4LkyJ");

var $3k2dW = parcelRequire("3k2dW");

var $4eHfF = parcelRequire("4eHfF");

var $i7XiZ = parcelRequire("i7XiZ");
var $ecf7a30f3d257c00$var$MutationObserver = $a974b.MutationObserver || $a974b.WebKitMutationObserver;
var $ecf7a30f3d257c00$var$document = $a974b.document;
var $ecf7a30f3d257c00$var$process = $a974b.process;
var $ecf7a30f3d257c00$var$Promise = $a974b.Promise;
var $ecf7a30f3d257c00$var$microtask = $2VzIO('queueMicrotask');
var $ecf7a30f3d257c00$var$notify, $ecf7a30f3d257c00$var$toggle, $ecf7a30f3d257c00$var$node, $ecf7a30f3d257c00$var$promise, $ecf7a30f3d257c00$var$then;
// modern engines have queueMicrotask method
if (!$ecf7a30f3d257c00$var$microtask) {
    var $ecf7a30f3d257c00$var$queue = new $fOoey();
    var $ecf7a30f3d257c00$var$flush = function() {
        var parent, fn;
        if ($i7XiZ && (parent = $ecf7a30f3d257c00$var$process.domain)) parent.exit();
        while(fn = $ecf7a30f3d257c00$var$queue.get())try {
            fn();
        } catch (error) {
            if ($ecf7a30f3d257c00$var$queue.head) $ecf7a30f3d257c00$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$4LkyJ && !$i7XiZ && !$4eHfF && $ecf7a30f3d257c00$var$MutationObserver && $ecf7a30f3d257c00$var$document) {
        $ecf7a30f3d257c00$var$toggle = true;
        $ecf7a30f3d257c00$var$node = $ecf7a30f3d257c00$var$document.createTextNode('');
        new $ecf7a30f3d257c00$var$MutationObserver($ecf7a30f3d257c00$var$flush).observe($ecf7a30f3d257c00$var$node, {
            characterData: true
        });
        $ecf7a30f3d257c00$var$notify = function() {
            $ecf7a30f3d257c00$var$node.data = $ecf7a30f3d257c00$var$toggle = !$ecf7a30f3d257c00$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$3k2dW && $ecf7a30f3d257c00$var$Promise && $ecf7a30f3d257c00$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $ecf7a30f3d257c00$var$promise = $ecf7a30f3d257c00$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $ecf7a30f3d257c00$var$promise.constructor = $ecf7a30f3d257c00$var$Promise;
        $ecf7a30f3d257c00$var$then = $iyHek($ecf7a30f3d257c00$var$promise.then, $ecf7a30f3d257c00$var$promise);
        $ecf7a30f3d257c00$var$notify = function() {
            $ecf7a30f3d257c00$var$then($ecf7a30f3d257c00$var$flush);
        };
    // Node.js without promises
    } else if ($i7XiZ) $ecf7a30f3d257c00$var$notify = function() {
        $ecf7a30f3d257c00$var$process.nextTick($ecf7a30f3d257c00$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $ecf7a30f3d257c00$require$macrotask = $iyHek($ecf7a30f3d257c00$require$macrotask, $a974b);
        $ecf7a30f3d257c00$var$notify = function() {
            $ecf7a30f3d257c00$require$macrotask($ecf7a30f3d257c00$var$flush);
        };
    }
    $ecf7a30f3d257c00$var$microtask = function(fn) {
        if (!$ecf7a30f3d257c00$var$queue.head) $ecf7a30f3d257c00$var$notify();
        $ecf7a30f3d257c00$var$queue.add(fn);
    };
}
module.exports = $ecf7a30f3d257c00$var$microtask;

});
parcelRegister("2VzIO", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $izyPX = parcelRequire("izyPX");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $221c9d439e8ee9bb$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
module.exports = function(name) {
    if (!$izyPX) return $a974b[name];
    var descriptor = $221c9d439e8ee9bb$var$getOwnPropertyDescriptor($a974b, name);
    return descriptor && descriptor.value;
};

});

parcelRegister("fOoey", function(module, exports) {
'use strict';
var $b82e52d647d9fee7$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$b82e52d647d9fee7$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
module.exports = $b82e52d647d9fee7$var$Queue;

});

parcelRegister("3k2dW", function(module, exports) {
'use strict';

var $bd2Ce = parcelRequire("bd2Ce");
module.exports = /ipad|iphone|ipod/i.test($bd2Ce) && typeof Pebble != 'undefined';

});

parcelRegister("4eHfF", function(module, exports) {
'use strict';

var $bd2Ce = parcelRequire("bd2Ce");
module.exports = /web0s(?!.*chrome)/i.test($bd2Ce);

});


parcelRegister("ggKK7", function(module, exports) {
'use strict';
module.exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};

});

parcelRegister("97RGR", function(module, exports) {
'use strict';
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

});

parcelRegister("4BzCf", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");
module.exports = $a974b.Promise;

});

parcelRegister("bpphM", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $4BzCf = parcelRequire("4BzCf");

var $bCB23 = parcelRequire("bCB23");

var $7xCLo = parcelRequire("7xCLo");

var $hl3EW = parcelRequire("hl3EW");

var $1TMNu = parcelRequire("1TMNu");

var $dlL5c = parcelRequire("dlL5c");

var $1cBJJ = parcelRequire("1cBJJ");

var $gYjxe = parcelRequire("gYjxe");
var $84e5a4b698051148$var$NativePromisePrototype = $4BzCf && $4BzCf.prototype;
var $84e5a4b698051148$var$SPECIES = $1TMNu('species');
var $84e5a4b698051148$var$SUBCLASSING = false;
var $84e5a4b698051148$var$NATIVE_PROMISE_REJECTION_EVENT = $bCB23($a974b.PromiseRejectionEvent);
var $84e5a4b698051148$var$FORCED_PROMISE_CONSTRUCTOR = $7xCLo('Promise', function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $hl3EW($4BzCf);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($4BzCf);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $gYjxe === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($1cBJJ && !($84e5a4b698051148$var$NativePromisePrototype['catch'] && $84e5a4b698051148$var$NativePromisePrototype['finally'])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$gYjxe || $gYjxe < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $4BzCf(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$84e5a4b698051148$var$SPECIES] = FakePromise;
        $84e5a4b698051148$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$84e5a4b698051148$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($dlL5c === 'BROWSER' || $dlL5c === 'DENO') && !$84e5a4b698051148$var$NATIVE_PROMISE_REJECTION_EVENT;
});
module.exports = {
    CONSTRUCTOR: $84e5a4b698051148$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $84e5a4b698051148$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $84e5a4b698051148$var$SUBCLASSING
};

});

parcelRegister("2hmlq", function(module, exports) {

$parcel$export(module.exports, "f", () => $1a8e807b5a76d4aa$export$2d1720544b23b823, (v) => $1a8e807b5a76d4aa$export$2d1720544b23b823 = v);
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $1a8e807b5a76d4aa$export$2d1720544b23b823;
'use strict';

var $9I3bq = parcelRequire("9I3bq");
var $1a8e807b5a76d4aa$var$$TypeError = TypeError;
var $1a8e807b5a76d4aa$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $1a8e807b5a76d4aa$var$$TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $9I3bq(resolve);
    this.reject = $9I3bq(reject);
};
$1a8e807b5a76d4aa$export$2d1720544b23b823 = function(C) {
    return new $1a8e807b5a76d4aa$var$PromiseCapability(C);
};

});


parcelRegister("4MY5K", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $fztCk = parcelRequire("fztCk");

var $9I3bq = parcelRequire("9I3bq");

var $2hmlq = parcelRequire("2hmlq");

var $97RGR = parcelRequire("97RGR");

var $7ICfs = parcelRequire("7ICfs");

var $enhYZ = parcelRequire("enhYZ");
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $enhYZ
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $2hmlq.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $97RGR(function() {
            var $promiseResolve = $9I3bq(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $7ICfs(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $fztCk($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});
parcelRegister("enhYZ", function(module, exports) {
'use strict';

var $4BzCf = parcelRequire("4BzCf");

var $fWetc = parcelRequire("fWetc");

var $bpphM = parcelRequire("bpphM");
var $a77129ab13e958db$require$FORCED_PROMISE_CONSTRUCTOR = $bpphM.CONSTRUCTOR;
module.exports = $a77129ab13e958db$require$FORCED_PROMISE_CONSTRUCTOR || !$fWetc(function(iterable) {
    $4BzCf.all(iterable).then(undefined, function() {});
});

});
parcelRegister("fWetc", function(module, exports) {
'use strict';

var $1TMNu = parcelRequire("1TMNu");
var $b9a77f3661b0eae5$var$ITERATOR = $1TMNu('iterator');
var $b9a77f3661b0eae5$var$SAFE_CLOSING = false;
try {
    var $b9a77f3661b0eae5$var$called = 0;
    var $b9a77f3661b0eae5$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$b9a77f3661b0eae5$var$called++
            };
        },
        'return': function() {
            $b9a77f3661b0eae5$var$SAFE_CLOSING = true;
        }
    };
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    $b9a77f3661b0eae5$var$iteratorWithReturn[$b9a77f3661b0eae5$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($b9a77f3661b0eae5$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$b9a77f3661b0eae5$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        object[$b9a77f3661b0eae5$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});



parcelRegister("chvhL", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $1cBJJ = parcelRequire("1cBJJ");

var $bpphM = parcelRequire("bpphM");
var $8f0f573b6c790cb3$require$FORCED_PROMISE_CONSTRUCTOR = $bpphM.CONSTRUCTOR;

var $4BzCf = parcelRequire("4BzCf");

var $a1ZFI = parcelRequire("a1ZFI");

var $bCB23 = parcelRequire("bCB23");

var $9DIeg = parcelRequire("9DIeg");
var $8f0f573b6c790cb3$var$NativePromisePrototype = $4BzCf && $4BzCf.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$k8IkA({
    target: 'Promise',
    proto: true,
    forced: $8f0f573b6c790cb3$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    'catch': function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$1cBJJ && $bCB23($4BzCf)) {
    var $8f0f573b6c790cb3$var$method = $a1ZFI('Promise').prototype['catch'];
    if ($8f0f573b6c790cb3$var$NativePromisePrototype['catch'] !== $8f0f573b6c790cb3$var$method) $9DIeg($8f0f573b6c790cb3$var$NativePromisePrototype, 'catch', $8f0f573b6c790cb3$var$method, {
        unsafe: true
    });
}

});

parcelRegister("1KFVU", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $fztCk = parcelRequire("fztCk");

var $9I3bq = parcelRequire("9I3bq");

var $2hmlq = parcelRequire("2hmlq");

var $97RGR = parcelRequire("97RGR");

var $7ICfs = parcelRequire("7ICfs");

var $enhYZ = parcelRequire("enhYZ");
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $enhYZ
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $2hmlq.f(C);
        var reject = capability.reject;
        var result = $97RGR(function() {
            var $promiseResolve = $9I3bq(C.resolve);
            $7ICfs(iterable, function(promise) {
                $fztCk($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("6UgSe", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $2hmlq = parcelRequire("2hmlq");

var $bpphM = parcelRequire("bpphM");
var $50750fc96650feef$require$FORCED_PROMISE_CONSTRUCTOR = $bpphM.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $50750fc96650feef$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $2hmlq.f(this);
        var capabilityReject = capability.reject;
        capabilityReject(r);
        return capability.promise;
    }
});

});

parcelRegister("euzrX", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $a1ZFI = parcelRequire("a1ZFI");

var $1cBJJ = parcelRequire("1cBJJ");

var $4BzCf = parcelRequire("4BzCf");

var $bpphM = parcelRequire("bpphM");
var $a8cf5da170f4bdf7$require$FORCED_PROMISE_CONSTRUCTOR = $bpphM.CONSTRUCTOR;

var $46QV9 = parcelRequire("46QV9");
var $a8cf5da170f4bdf7$var$PromiseConstructorWrapper = $a1ZFI('Promise');
var $a8cf5da170f4bdf7$var$CHECK_WRAPPER = $1cBJJ && !$a8cf5da170f4bdf7$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $1cBJJ || $a8cf5da170f4bdf7$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $46QV9($a8cf5da170f4bdf7$var$CHECK_WRAPPER && this === $a8cf5da170f4bdf7$var$PromiseConstructorWrapper ? $4BzCf : this, x);
    }
});

});
parcelRegister("46QV9", function(module, exports) {
'use strict';

var $amhk0 = parcelRequire("amhk0");

var $81LAJ = parcelRequire("81LAJ");

var $2hmlq = parcelRequire("2hmlq");
module.exports = function(C, x) {
    $amhk0(C);
    if ($81LAJ(x) && x.constructor === C) return x;
    var promiseCapability = $2hmlq.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});



parcelRegister("3Fwpb", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $fztCk = parcelRequire("fztCk");

var $9I3bq = parcelRequire("9I3bq");

var $2hmlq = parcelRequire("2hmlq");

var $97RGR = parcelRequire("97RGR");

var $7ICfs = parcelRequire("7ICfs");

var $enhYZ = parcelRequire("enhYZ");
// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $enhYZ
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $2hmlq.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $97RGR(function() {
            var promiseResolve = $9I3bq(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $7ICfs(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $fztCk(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'fulfilled',
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'rejected',
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("9hluD", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $fztCk = parcelRequire("fztCk");

var $9I3bq = parcelRequire("9I3bq");

var $a1ZFI = parcelRequire("a1ZFI");

var $2hmlq = parcelRequire("2hmlq");

var $97RGR = parcelRequire("97RGR");

var $7ICfs = parcelRequire("7ICfs");

var $enhYZ = parcelRequire("enhYZ");
var $6c165fb20d954d57$var$PROMISE_ANY_ERROR = 'No one promise resolved';
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $enhYZ
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = $a1ZFI('AggregateError');
        var capability = $2hmlq.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $97RGR(function() {
            var promiseResolve = $9I3bq(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $7ICfs(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                $fztCk(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, $6c165fb20d954d57$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, $6c165fb20d954d57$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("djTyE", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $a974b = parcelRequire("a974b");

var $dgWbh = parcelRequire("dgWbh");

var $eXbub = parcelRequire("eXbub");

var $2hmlq = parcelRequire("2hmlq");

var $9I3bq = parcelRequire("9I3bq");

var $97RGR = parcelRequire("97RGR");
var $9b282556ae670410$var$Promise = $a974b.Promise;
var $9b282556ae670410$var$ACCEPT_ARGUMENTS = false;
// Avoiding the use of polyfills of the previous iteration of this proposal
// that does not accept arguments of the callback
var $9b282556ae670410$var$FORCED = !$9b282556ae670410$var$Promise || !$9b282556ae670410$var$Promise['try'] || $97RGR(function() {
    $9b282556ae670410$var$Promise['try'](function(argument) {
        $9b282556ae670410$var$ACCEPT_ARGUMENTS = argument === 8;
    }, 8);
}).error || !$9b282556ae670410$var$ACCEPT_ARGUMENTS;
// `Promise.try` method
// https://tc39.es/ecma262/#sec-promise.try
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $9b282556ae670410$var$FORCED
}, {
    'try': function(callbackfn /* , ...args */ ) {
        var args = arguments.length > 1 ? $eXbub(arguments, 1) : [];
        var promiseCapability = $2hmlq.f(this);
        var result = $97RGR(function() {
            return $dgWbh($9I3bq(callbackfn), undefined, args);
        });
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});

});

parcelRegister("3Comk", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $2hmlq = parcelRequire("2hmlq");
// `Promise.withResolvers` method
// https://tc39.es/ecma262/#sec-promise.withResolvers
$k8IkA({
    target: 'Promise',
    stat: true
}, {
    withResolvers: function withResolvers() {
        var promiseCapability = $2hmlq.f(this);
        return {
            promise: promiseCapability.promise,
            resolve: promiseCapability.resolve,
            reject: promiseCapability.reject
        };
    }
});

});

parcelRegister("hyQQI", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $1cBJJ = parcelRequire("1cBJJ");

var $4BzCf = parcelRequire("4BzCf");

var $5TNal = parcelRequire("5TNal");

var $a1ZFI = parcelRequire("a1ZFI");

var $bCB23 = parcelRequire("bCB23");

var $17lIF = parcelRequire("17lIF");

var $46QV9 = parcelRequire("46QV9");

var $9DIeg = parcelRequire("9DIeg");
var $cc8e9b6d76347651$var$NativePromisePrototype = $4BzCf && $4BzCf.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $cc8e9b6d76347651$var$NON_GENERIC = !!$4BzCf && $5TNal(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $cc8e9b6d76347651$var$NativePromisePrototype['finally'].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$k8IkA({
    target: 'Promise',
    proto: true,
    real: true,
    forced: $cc8e9b6d76347651$var$NON_GENERIC
}, {
    'finally': function(onFinally) {
        var C = $17lIF(this, $a1ZFI('Promise'));
        var isFunction = $bCB23(onFinally);
        return this.then(isFunction ? function(x) {
            return $46QV9(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $46QV9(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$1cBJJ && $bCB23($4BzCf)) {
    var $cc8e9b6d76347651$var$method = $a1ZFI('Promise').prototype['finally'];
    if ($cc8e9b6d76347651$var$NativePromisePrototype['finally'] !== $cc8e9b6d76347651$var$method) $9DIeg($cc8e9b6d76347651$var$NativePromisePrototype, 'finally', $cc8e9b6d76347651$var$method, {
        unsafe: true
    });
}

});

parcelRegister("hNffK", function(module, exports) {
'use strict';

var $eBbjp = parcelRequire("eBbjp");
var $cf42d8318689f7b3$require$charAt = $eBbjp.charAt;

var $1ffsO = parcelRequire("1ffsO");

var $iUh4p = parcelRequire("iUh4p");

var $03Wh9 = parcelRequire("03Wh9");

var $fJ7og = parcelRequire("fJ7og");
var $cf42d8318689f7b3$var$STRING_ITERATOR = 'String Iterator';
var $cf42d8318689f7b3$var$setInternalState = $iUh4p.set;
var $cf42d8318689f7b3$var$getInternalState = $iUh4p.getterFor($cf42d8318689f7b3$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$03Wh9(String, 'String', function(iterated) {
    $cf42d8318689f7b3$var$setInternalState(this, {
        type: $cf42d8318689f7b3$var$STRING_ITERATOR,
        string: $1ffsO(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $cf42d8318689f7b3$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $fJ7og(undefined, true);
    point = $cf42d8318689f7b3$require$charAt(string, index);
    state.index += point.length;
    return $fJ7og(point, false);
});

});
parcelRegister("eBbjp", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $aiawW = parcelRequire("aiawW");

var $1ffsO = parcelRequire("1ffsO");

var $wWRWr = parcelRequire("wWRWr");
var $aa0d4bb909cd6b22$var$charAt = $blzM2(''.charAt);
var $aa0d4bb909cd6b22$var$charCodeAt = $blzM2(''.charCodeAt);
var $aa0d4bb909cd6b22$var$stringSlice = $blzM2(''.slice);
var $aa0d4bb909cd6b22$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $1ffsO($wWRWr($this));
        var position = $aiawW(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $aa0d4bb909cd6b22$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $aa0d4bb909cd6b22$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $aa0d4bb909cd6b22$var$charAt(S, position) : first : CONVERT_TO_STRING ? $aa0d4bb909cd6b22$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $aa0d4bb909cd6b22$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $aa0d4bb909cd6b22$var$createMethod(true)
};

});



parcelRegister("jlLxD", function(module, exports) {
'use strict';
parcelRequire("1sRs4");

var $aoGv6 = parcelRequire("aoGv6");

var $a974b = parcelRequire("a974b");

var $3pVms = parcelRequire("3pVms");

var $bim2i = parcelRequire("bim2i");
for(var $e164db42d8f880ec$var$COLLECTION_NAME in $aoGv6){
    $3pVms($a974b[$e164db42d8f880ec$var$COLLECTION_NAME], $e164db42d8f880ec$var$COLLECTION_NAME);
    $bim2i[$e164db42d8f880ec$var$COLLECTION_NAME] = $bim2i.Array;
}

});
parcelRegister("aoGv6", function(module, exports) {
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});






parcelRegister("f9W3H", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("5iA6N"),
    $parcel$import("cby9Y")
]).then(()=>parcelRequire('7wiNg'));

});

parcelRegister("hhGYP", function(module, exports) {
module.exports = $parcel$import("bVNjP").then(()=>parcelRequire('buL06'));

});

parcelRegister("hQGDp", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("5iA6N"),
    $parcel$import("7kS9u")
]).then(()=>parcelRequire('6aGvI'));

});

parcelRegister("7Qm9Q", function(module, exports) {
module.exports = $parcel$import("f7mOL").then(()=>parcelRequire('80oYR'));

});

parcelRegister("itb2K", function(module, exports) {

$parcel$export(module.exports, "getCharacterHeight", () => $d7238066c5de7f1c$export$4e44afb352581c74);
$parcel$export(module.exports, "setCharacterState", () => $d7238066c5de7f1c$export$83a16ee147243363);
$parcel$export(module.exports, "getCameraPosition", () => $d7238066c5de7f1c$export$f411fdc3e02e158b);
$parcel$export(module.exports, "setLookAtCamera", () => $d7238066c5de7f1c$export$c4b950f052e6bb5c);
$parcel$export(module.exports, "setShowFirstTarget", () => $d7238066c5de7f1c$export$26a025b74ed1352e);
$parcel$export(module.exports, "presets", () => $d7238066c5de7f1c$export$7afd9c1079ecedf7);
$parcel$export(module.exports, "setVisemes", () => $d7238066c5de7f1c$export$53e124f45dac8729);
$parcel$export(module.exports, "addViseme", () => $d7238066c5de7f1c$export$a6f0d0f24e5dc19b);
$parcel$export(module.exports, "flushLipSyncData", () => $d7238066c5de7f1c$export$1a9c534915c6839e);
$parcel$export(module.exports, "Character", () => $d7238066c5de7f1c$export$cb68cc2163cd3f1);
$parcel$export(module.exports, "CharacterState", () => (parcelRequire("jKwRh")).CharacterState);
$parcel$export(module.exports, "CreationTool", () => (parcelRequire("jKwRh")).CreationTool);
$parcel$export(module.exports, "Object3D", () => (parcelRequire("329ek")).Object3D);

var $bxRTa = parcelRequire("bxRTa");

var $329ek = parcelRequire("329ek");parcelRequire("iB18M");
var $329ek = parcelRequire("329ek");
var $iB18M = parcelRequire("iB18M");

var $jKwRh = parcelRequire("jKwRh");

var $dhXas = parcelRequire("dhXas");
var $c4Vvr = parcelRequire("c4Vvr");
var $60WrR = parcelRequire("60WrR");
var $7Ur5h = parcelRequire("7Ur5h");
var $8f92r = parcelRequire("8f92r");

var $3gAAP = parcelRequire("3gAAP");
var $9sE5i = parcelRequire("9sE5i");

var $f2Nvv = parcelRequire("f2Nvv");
var $d7238066c5de7f1c$require$Buffer = $f2Nvv.Buffer;
const $d7238066c5de7f1c$var$Oa = (r)=>{
    let e;
    const t = /* @__PURE__ */ new Set(), i = (h, a)=>{
        const d = typeof h == "function" ? h(e) : h;
        if (!Object.is(d, e)) {
            const v = e;
            e = a ?? (typeof d != "object" || d === null) ? d : Object.assign({}, e, d), t.forEach((g)=>g(e, v));
        }
    }, n = ()=>e, c = {
        setState: i,
        getState: n,
        getInitialState: ()=>p,
        subscribe: (h)=>(t.add(h), ()=>t.delete(h))
    }, p = e = r(i, n, c);
    return c;
}, $d7238066c5de7f1c$var$id = (r)=>r ? $d7238066c5de7f1c$var$Oa(r) : $d7238066c5de7f1c$var$Oa, $d7238066c5de7f1c$var$rd = (r)=>r;
function $d7238066c5de7f1c$var$nd(r, e = $d7238066c5de7f1c$var$rd) {
    const t = (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useSyncExternalStore(r.subscribe, (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useCallback(()=>e(r.getState()), [
        r,
        e
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useCallback(()=>e(r.getInitialState()), [
        r,
        e
    ]));
    return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useDebugValue(t), t;
}
const $d7238066c5de7f1c$var$sd = (r)=>{
    const e = $d7238066c5de7f1c$var$id(r), t = (i)=>$d7238066c5de7f1c$var$nd(e, i);
    return Object.assign(t, e), t;
}, $d7238066c5de7f1c$var$Pi = (r)=>$d7238066c5de7f1c$var$sd, $d7238066c5de7f1c$export$c7fe76dc325a276e = $d7238066c5de7f1c$var$Pi()(()=>({
        character: null,
        managers: [],
        globalManager: null,
        lipSyncManager: null,
        blendshapeManager: null,
        eyeBlinkManager: null,
        animationManager: null,
        FACSManager: null,
        headPoseManager: null,
        gazeManager: null,
        bmlManager: null,
        animationsLoaded: !1,
        characterWidth: 0,
        characterHeight: 0,
        characterDepth: 0,
        characterState: (0, $jKwRh.CharacterState).idle
    })), $d7238066c5de7f1c$var$od = (r)=>{
    $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        character: r
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        managers: {
            lipSyncManager: (r == null ? void 0 : r.lipSyncManager) || null,
            blendshapeManager: (r == null ? void 0 : r.blendshapeManager) || null,
            eyeBlinkManager: (r == null ? void 0 : r.eyeBlinkManager) || null,
            animationManager: (r == null ? void 0 : r.animationManager) || null
        }
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        globalManager: (r == null ? void 0 : r.globalManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        lipSyncManager: (r == null ? void 0 : r.lipSyncManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        blendshapeManager: (r == null ? void 0 : r.blendshapeManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        eyeBlinkManager: (r == null ? void 0 : r.eyeBlinkManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        animationManager: (r == null ? void 0 : r.animationManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        FACSManager: (r == null ? void 0 : r.FACSManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        headPoseManager: (r == null ? void 0 : r.headPoseManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        gazeManager: (r == null ? void 0 : r.gazeManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        bmlManager: (r == null ? void 0 : r.bmlManager) || null
    });
}, $d7238066c5de7f1c$var$za = (r)=>{
    $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        animationsLoaded: r
    });
}, $d7238066c5de7f1c$var$ad = (r)=>{
    $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        characterWidth: r.x
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        characterHeight: r.y
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        characterDepth: r.z
    });
}, $d7238066c5de7f1c$export$4e44afb352581c74 = ()=>$d7238066c5de7f1c$export$c7fe76dc325a276e.getState().characterHeight, $d7238066c5de7f1c$export$83a16ee147243363 = (r)=>{
    $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        characterState: r
    });
}, $d7238066c5de7f1c$var$Te = $d7238066c5de7f1c$var$Pi()(()=>({
        cameraRef: null,
        cameraPosition: new (0, $329ek.Vector3)(0, 0, 5),
        bodyCenter: null,
        defaultPositions: null,
        defaultDistances: null,
        lookAt: null,
        movable: !0
    })), $d7238066c5de7f1c$var$cd = (r)=>{
    $d7238066c5de7f1c$var$Te.setState({
        cameraRef: r
    });
}, $d7238066c5de7f1c$export$e5bf5ad244df1ebf = (r)=>{
    $d7238066c5de7f1c$var$Te.setState({
        cameraPosition: r
    });
}, $d7238066c5de7f1c$export$f411fdc3e02e158b = ()=>$d7238066c5de7f1c$var$Te.getState().cameraPosition, $d7238066c5de7f1c$var$pd = (r)=>{
    $d7238066c5de7f1c$var$Te.setState({
        bodyCenter: r
    });
}, $d7238066c5de7f1c$var$hd = (r)=>{
    $d7238066c5de7f1c$var$Te.setState({
        defaultPositions: r
    });
}, $d7238066c5de7f1c$var$ud = (r)=>{
    $d7238066c5de7f1c$var$Te.setState({
        defaultDistances: r
    });
}, $d7238066c5de7f1c$var$xa = (r)=>{
    $d7238066c5de7f1c$var$Te.setState({
        lookAt: r
    });
}, $d7238066c5de7f1c$export$2d786297390db70a = ()=>$d7238066c5de7f1c$var$Te.getState().lookAt, $d7238066c5de7f1c$export$545c1d117b311d16 = (r)=>{
    $d7238066c5de7f1c$var$Te.setState({
        movable: r
    });
}, $d7238066c5de7f1c$var$ze = $d7238066c5de7f1c$var$Pi()(()=>({
        currentAUs: null,
        currentGaze: null,
        currentHeadPose: null,
        lookAtCamera: !1,
        targets: [],
        showFirstTarget: !1
    })), $d7238066c5de7f1c$var$ld = (r)=>{
    $d7238066c5de7f1c$var$ze.setState({
        targets: r
    });
}, $d7238066c5de7f1c$export$4e30b10203d50fb8 = (r)=>{
    $d7238066c5de7f1c$var$ze.setState({
        currentAUs: r
    });
}, $d7238066c5de7f1c$export$3bf029edb7af26ca = (r)=>{
    $d7238066c5de7f1c$var$ze.setState({
        currentGaze: r
    });
}, $d7238066c5de7f1c$export$bc06a1b48d31c5a3 = (r)=>{
    $d7238066c5de7f1c$var$ze.setState({
        currentHeadPose: r
    });
}, $d7238066c5de7f1c$export$c4b950f052e6bb5c = (r)=>{
    $d7238066c5de7f1c$var$ze.setState({
        lookAtCamera: r
    }), r ? $d7238066c5de7f1c$export$5466d9107c924e1f() : $d7238066c5de7f1c$export$75766fc1823cc42c();
}, $d7238066c5de7f1c$export$c7467e85c2c803 = (r)=>{
    $d7238066c5de7f1c$var$ze.setState({
        lookAtCamera: r
    });
    const e = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().globalManager;
    if (r) {
        const t = $d7238066c5de7f1c$var$Te.getState().cameraRef;
        e == null || e.lookAtAndSteady(t);
    } else e == null || e.releaseLookAt();
}, $d7238066c5de7f1c$export$5466d9107c924e1f = (r)=>{
    const e = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().globalManager;
    if (r) e == null || e.lookAtAndKeep(r);
    else {
        const t = $d7238066c5de7f1c$var$Te.getState().cameraRef;
        e == null || e.lookAtAndKeep(t);
    }
}, $d7238066c5de7f1c$export$75766fc1823cc42c = ()=>{
    var r;
    (r = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().globalManager) == null || r.releaseLookAt();
}, $d7238066c5de7f1c$export$26a025b74ed1352e = (r)=>{
    $d7238066c5de7f1c$var$ze.setState({
        showFirstTarget: r
    });
}, $d7238066c5de7f1c$var$Si = $d7238066c5de7f1c$var$Pi()(()=>({
        animationsNames: [],
        animations: /* @__PURE__ */ new Map(),
        currentAnimation: null,
        autoPlay: !0
    })), $d7238066c5de7f1c$var$gd = (r)=>{
    $d7238066c5de7f1c$var$Si.setState({
        animationsNames: r
    });
}, $d7238066c5de7f1c$var$md = (r)=>{
    $d7238066c5de7f1c$var$Si.setState({
        animations: r
    });
}, $d7238066c5de7f1c$export$b021c3458b2d227d = ()=>$d7238066c5de7f1c$var$Si.getState().animations, $d7238066c5de7f1c$export$ddf7477d0ab427b2 = (r)=>{
    $d7238066c5de7f1c$var$Si.setState({
        autoPlay: r
    });
}, $d7238066c5de7f1c$export$f4b33447f2fe6a80 = (r)=>{
    if ($d7238066c5de7f1c$var$Si.setState({
        autoPlay: !1
    }), $d7238066c5de7f1c$var$Si.getState().animationsNames.includes(r)) {
        const t = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().animationManager;
        t == null || t.playAnimation(r);
    }
};
var $d7238066c5de7f1c$export$53ba1d920b7b1325 = /* @__PURE__ */ ((r)=>(r.eye = "eye", r.mouth = "mouth", r.neck = "neck", r.clavicle = "clavicle", r.torso = "torso", r.belly = "belly", r.lowerbelly = "lowerbelly", r.hips = "hips", r.higherthigh = "higherthigh", r.thigh = "thigh", r.knee = "knee", r.leg = "leg", r.feet = "feet", r))($d7238066c5de7f1c$export$53ba1d920b7b1325 || {}), $d7238066c5de7f1c$export$bf368148f23d1abd = /* @__PURE__ */ ((r)=>(r[r.face = 1] = "face", r[r.eighthleft = 2] = "eighthleft", r[r.thirdleft = 3] = "thirdleft", r[r.quarterleft = 4] = "quarterleft", r[r.halfleft = 5] = "halfleft", r[r.eighthright = 6] = "eighthright", r[r.thirdright = 7] = "thirdright", r[r.quarterright = 8] = "quarterright", r[r.halfright = 9] = "halfright", r))($d7238066c5de7f1c$export$bf368148f23d1abd || {}), $d7238066c5de7f1c$export$9e8ba99cc9517849 = /* @__PURE__ */ ((r)=>(r[r.veryclose = 1] = "veryclose", r[r.closer = 2] = "closer", r[r.close = 3] = "close", r[r.midclose = 4] = "midclose", r[r.medium = 5] = "medium", r[r.midfar = 6] = "midfar", r[r.far = 7] = "far", r[r.farther = 8] = "farther", r[r.veryfar = 9] = "veryfar", r))($d7238066c5de7f1c$export$9e8ba99cc9517849 || {}), $d7238066c5de7f1c$var$qr = /* @__PURE__ */ ((r)=>(r.cc3 = "CC_Base_Body", r.avatarsdk = "AvatarBody", r.avaturn = "Body_Mesh", r))($d7238066c5de7f1c$var$qr || {}), $d7238066c5de7f1c$var$mo = /* @__PURE__ */ ((r)=>(r.Jay = "joy", r.Anger = "anger", r.Contempt = "contempt", r.Disgust = "disgust", r.Dislike = "dislike", r.Distress = "distress", r.Fear = "fear", r.Frustration = "frustration", r.Guilt = "guilt", r.Hope = "hope", r.Love = "love", r.Pride = "pride", r.Regret = "regret", r.Relief = "relief", r.Sadness = "sadness", r.Shame = "shame", r.Smile = "smile", r.Surprise = "surprise", r.Neutral = "neutral", r))($d7238066c5de7f1c$var$mo || {});
const $d7238066c5de7f1c$var$_a = /* @__PURE__ */ new Map([
    [
        0,
        "sil"
    ],
    [
        1,
        "aa"
    ],
    [
        2,
        "aa"
    ],
    [
        3,
        "O"
    ],
    [
        4,
        "E"
    ],
    [
        5,
        "E"
    ],
    [
        6,
        "I"
    ],
    [
        7,
        "U"
    ],
    [
        8,
        "O"
    ],
    [
        9,
        "U"
    ],
    [
        10,
        "O"
    ],
    [
        11,
        "aa"
    ],
    [
        12,
        "kk"
    ],
    [
        13,
        "RR"
    ],
    [
        14,
        "nn"
    ],
    [
        15,
        "SS"
    ],
    [
        16,
        "CH"
    ],
    [
        17,
        "TH"
    ],
    [
        18,
        "FF"
    ],
    [
        19,
        "DD"
    ],
    [
        20,
        "kk"
    ],
    [
        21,
        "PP"
    ]
]), $d7238066c5de7f1c$var$Sd = /* @__PURE__ */ new Map([
    [
        "#",
        "#"
    ],
    [
        "p",
        "p"
    ],
    [
        "b",
        "b"
    ],
    [
        "t",
        "t"
    ],
    [
        "d",
        "d"
    ],
    [
        "k",
        "k"
    ],
    [
        "g",
        "g"
    ],
    [
        "f",
        "f"
    ],
    [
        "s",
        "s"
    ],
    [
        "S",
        "\u0283"
    ],
    [
        "v",
        "v"
    ],
    [
        "z",
        "z"
    ],
    [
        "Z",
        "\u0292"
    ],
    [
        "m",
        "m"
    ],
    [
        "n",
        "n"
    ],
    [
        "l",
        "l"
    ],
    [
        "R",
        "\u0281"
    ],
    [
        "j",
        "j"
    ],
    [
        "w",
        "w"
    ],
    [
        "H",
        "\u0265"
    ],
    [
        "E",
        "\u025B"
    ],
    [
        "A/",
        "\u0251"
    ],
    [
        "9",
        "oe"
    ],
    [
        "i",
        "i"
    ],
    [
        "e",
        "e"
    ],
    [
        "O/",
        "o"
    ],
    [
        "u",
        "u"
    ],
    [
        "y",
        "y"
    ],
    [
        "2",
        "\xf8"
    ],
    [
        "@",
        "\u0259"
    ],
    [
        "a~",
        "\xe3"
    ],
    [
        "U~/",
        "\u025B\u0303"
    ],
    [
        "U~/",
        "oe\u0303"
    ],
    [
        "O~",
        "\u0254\u0303"
    ],
    [
        "a",
        "a"
    ],
    [
        "A",
        "\u0251"
    ],
    [
        "3",
        "\u025C"
    ],
    [
        "I",
        "\u026A"
    ],
    [
        "o",
        "o"
    ],
    [
        "O",
        "\u0254"
    ],
    [
        "U",
        "\u028A"
    ],
    [
        "Y",
        "\u028F"
    ],
    [
        "A~",
        "\u0251\u0303"
    ],
    [
        "E~",
        "\u025B\u0303"
    ],
    [
        "e~",
        "\u025B\u0303"
    ],
    [
        "9~",
        "oe\u0303"
    ],
    [
        "N",
        "\u014B"
    ],
    [
        "J",
        "\u0272"
    ]
]), $d7238066c5de7f1c$var$yd = /* @__PURE__ */ new Map([
    [
        "#",
        0
    ],
    [
        "\xe6",
        1
    ],
    [
        "\u0259",
        1
    ],
    [
        "\u028C",
        1
    ],
    [
        "\u0251",
        2
    ],
    [
        "\u0254",
        3
    ],
    [
        "\u025B",
        4
    ],
    [
        "\u028A",
        4
    ],
    [
        "\u025D",
        5
    ],
    [
        "j",
        6
    ],
    [
        "i",
        6
    ],
    [
        "\u026A",
        6
    ],
    [
        "w",
        7
    ],
    [
        "u",
        7
    ],
    [
        "o",
        8
    ],
    [
        "a\u028A",
        9
    ],
    [
        "\u0254\u026A",
        10
    ],
    [
        "a\u026A",
        11
    ],
    [
        "h",
        12
    ],
    [
        "\u0279",
        13
    ],
    [
        "l",
        14
    ],
    [
        "s",
        15
    ],
    [
        "z",
        15
    ],
    [
        "\u0283",
        16
    ],
    [
        "t\u0283",
        16
    ],
    [
        "d\u0292",
        16
    ],
    [
        "\u0292",
        16
    ],
    [
        "\xf0",
        17
    ],
    [
        "f",
        18
    ],
    [
        "v",
        18
    ],
    [
        "d",
        19
    ],
    [
        "t",
        19
    ],
    [
        "n",
        19
    ],
    [
        "\u03B8",
        19
    ],
    [
        "k",
        20
    ],
    [
        "g",
        20
    ],
    [
        "\u014B",
        20
    ],
    [
        "p",
        21
    ],
    [
        "b",
        21
    ],
    [
        "m",
        21
    ]
]), $d7238066c5de7f1c$var$Cd = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.farther,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.lowerbelly
}, $d7238066c5de7f1c$var$wd = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.close,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth
}, $d7238066c5de7f1c$var$Rd = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.midclose,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth
}, $d7238066c5de7f1c$var$Id = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.neck,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.close,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.neck
}, $d7238066c5de7f1c$var$Td = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.eye,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.medium,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.neck
}, $d7238066c5de7f1c$var$Pd = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.eye,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.medium,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.clavicle
}, $d7238066c5de7f1c$var$bd = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.eye,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.midfar,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.belly
}, $d7238066c5de7f1c$var$Ed = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.eye,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.far,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.lowerbelly
}, $d7238066c5de7f1c$export$7afd9c1079ecedf7 = {
    default: $d7238066c5de7f1c$var$Cd,
    head: $d7238066c5de7f1c$var$wd,
    neck: $d7238066c5de7f1c$var$Rd,
    shoulders: $d7238066c5de7f1c$var$Id,
    chest: $d7238066c5de7f1c$var$Td,
    belly: $d7238066c5de7f1c$var$Pd,
    knees: $d7238066c5de7f1c$var$bd,
    feet: $d7238066c5de7f1c$var$Ed
}, $d7238066c5de7f1c$var$Z = $d7238066c5de7f1c$var$Pi()(()=>({
        credentials: void 0,
        currentUtterance: null,
        boundaries: [],
        visemes: [],
        blendshapes: [],
        currentVisemeIndex: 0,
        currentBlendshapeIndex: 0,
        voice: null,
        voices: [],
        textToSpeak: null,
        visemeIntensity: 1,
        useBlendshapeManager: !1
    })), $d7238066c5de7f1c$var$Ad = (r)=>{
    $d7238066c5de7f1c$var$Z.setState({
        credentials: r
    });
}, $d7238066c5de7f1c$export$361f43c8d19dc717 = (r)=>{
    if (r) {
        const e = $d7238066c5de7f1c$var$Z.getState().voice;
        e && (r.voice = e);
    }
    $d7238066c5de7f1c$var$Z.setState({
        currentUtterance: r
    }), $d7238066c5de7f1c$var$Z.setState({
        textToSpeak: null
    });
}, $d7238066c5de7f1c$export$53e124f45dac8729 = (r)=>{
    $d7238066c5de7f1c$var$Z.setState({
        visemes: r
    });
}, $d7238066c5de7f1c$export$69dd9e2eb85d8caa = (r)=>{
    $d7238066c5de7f1c$var$Z.setState({
        blendshapes: r
    });
}, $d7238066c5de7f1c$export$a6f0d0f24e5dc19b = (r)=>{
    $d7238066c5de7f1c$var$Z.setState({
        visemes: [
            ...$d7238066c5de7f1c$var$Z.getState().visemes,
            r
        ]
    });
}, $d7238066c5de7f1c$export$a1a4c16424295a4a = (r)=>{
    $d7238066c5de7f1c$var$Z.setState({
        blendshapes: [
            ...$d7238066c5de7f1c$var$Z.getState().blendshapes,
            r
        ]
    });
}, $d7238066c5de7f1c$export$e71a64fa83f377e7 = (r, e)=>{
    const t = $d7238066c5de7f1c$var$Sd.get(r.name);
    if (t) {
        const i = $d7238066c5de7f1c$var$yd.get(t);
        i !== void 0 && $d7238066c5de7f1c$export$a6f0d0f24e5dc19b({
            ...r,
            name: `${i}`,
            elapsedTime: r.elapsedTime * (e || 1e7)
        });
    }
}, $d7238066c5de7f1c$var$Dd = (r)=>{
    $d7238066c5de7f1c$var$Z.setState({
        currentVisemeIndex: r
    });
}, $d7238066c5de7f1c$var$Od = (r)=>{
    $d7238066c5de7f1c$var$Z.setState({
        currentBlendshapeIndex: r
    });
}, $d7238066c5de7f1c$export$1a9c534915c6839e = ()=>{
    var r;
    $d7238066c5de7f1c$var$Z.setState({
        visemes: [],
        currentVisemeIndex: 0
    }), (r = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().lipSyncManager) == null || r.stop();
}, $d7238066c5de7f1c$export$9d82da69aac8f6ca = ()=>{
    var r;
    $d7238066c5de7f1c$var$Z.setState({
        blendshapes: [],
        currentBlendshapeIndex: 0
    }), (r = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().blendshapeManager) == null || r.stop();
}, $d7238066c5de7f1c$export$f7fa6f9f21f4683c = (r)=>{
    $d7238066c5de7f1c$var$Z.setState({
        voice: r
    });
}, $d7238066c5de7f1c$var$La = (r)=>{
    $d7238066c5de7f1c$var$Z.setState({
        voices: r
    });
}, $d7238066c5de7f1c$export$14dfb2a29f632771 = (r)=>{
    $d7238066c5de7f1c$var$Z.setState({
        textToSpeak: r
    });
}, $d7238066c5de7f1c$export$d474912f4c21f069 = ()=>$d7238066c5de7f1c$var$Z.getState().voices, $d7238066c5de7f1c$export$80884be05e236fad = (r)=>{
    $d7238066c5de7f1c$var$Z.setState({
        visemeIntensity: r
    });
}, $d7238066c5de7f1c$var$Nd = (r)=>{
    r !== $d7238066c5de7f1c$var$Z.getState().useBlendshapeManager && ($d7238066c5de7f1c$export$1a9c534915c6839e(), $d7238066c5de7f1c$export$9d82da69aac8f6ca(), $d7238066c5de7f1c$var$Z.setState({
        useBlendshapeManager: r
    }));
}, $d7238066c5de7f1c$var$Md = (r, e, t)=>{
    let i = t[r.position || $d7238066c5de7f1c$export$53ba1d920b7b1325.eye].getComponent(0);
    const n = t[r.position || $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth].getComponent(1);
    let s = 0;
    const o = typeof r.distance == "string" ? parseInt(r.distance) : r.distance, c = typeof r.rotation == "string" ? parseInt(r.rotation) : r.rotation;
    switch(o){
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.veryclose:
            s = e.veryclose;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.closer:
            s = e.closer;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.close:
            s = e.close;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.midclose:
            s = e.midclose;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.medium:
            s = e.medium;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.midfar:
            s = e.midfar;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.far:
            s = e.far;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.farther:
        case void 0:
        default:
            s = e.farther;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.veryfar:
            s = e.veryfar;
            break;
    }
    if (c && c !== $d7238066c5de7f1c$export$bf368148f23d1abd.face) switch(c){
        case $d7238066c5de7f1c$export$bf368148f23d1abd.eighthleft:
            {
                const p = 0.2588190451;
                i = i - s * p, s = s * Math.sqrt(1 - Math.pow(p, 2));
                break;
            }
        case $d7238066c5de7f1c$export$bf368148f23d1abd.thirdleft:
            i = i - s * 0.5, s = s * (Math.sqrt(3) / 2);
            break;
        case $d7238066c5de7f1c$export$bf368148f23d1abd.quarterleft:
            i = i - s * (Math.SQRT2 / 2), s = s * (Math.SQRT2 / 2);
            break;
        case $d7238066c5de7f1c$export$bf368148f23d1abd.halfleft:
            i = i - s, s = t.eye.getComponent(2);
            break;
        case $d7238066c5de7f1c$export$bf368148f23d1abd.eighthright:
            {
                const p = 0.2588190451;
                i = i + s * p, s = s * Math.sqrt(1 - Math.pow(p, 2));
                break;
            }
        case $d7238066c5de7f1c$export$bf368148f23d1abd.thirdright:
            i = i + s * 0.5, s = s * (Math.sqrt(3) / 2);
            break;
        case $d7238066c5de7f1c$export$bf368148f23d1abd.quarterright:
            i = i + s * (Math.SQRT2 / 2), s = s * (Math.SQRT2 / 2);
            break;
        case $d7238066c5de7f1c$export$bf368148f23d1abd.halfright:
            i = i + s, s = t.eye.getComponent(2);
            break;
    }
    return new $329ek.Vector3(i, n, s);
};
var $d7238066c5de7f1c$var$Tr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $d7238066c5de7f1c$var$xd(r) {
    return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function $d7238066c5de7f1c$var$_d(r) {
    if (r.__esModule) return r;
    var e = r.default;
    if (typeof e == "function") {
        var t = function i() {
            return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        t.prototype = e.prototype;
    } else t = {};
    return Object.defineProperty(t, "__esModule", {
        value: !0
    }), Object.keys(r).forEach(function(i) {
        var n = Object.getOwnPropertyDescriptor(r, i);
        Object.defineProperty(t, i, n.get ? n : {
            enumerable: !0,
            get: function() {
                return r[i];
            }
        });
    }), t;
}
var $d7238066c5de7f1c$var$Ap = {
    exports: {}
};
let $d7238066c5de7f1c$var$Pr;
const $d7238066c5de7f1c$var$Ld = new Uint8Array(16);
function $d7238066c5de7f1c$var$$d() {
    if (!$d7238066c5de7f1c$var$Pr && ($d7238066c5de7f1c$var$Pr = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !$d7238066c5de7f1c$var$Pr)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return $d7238066c5de7f1c$var$Pr($d7238066c5de7f1c$var$Ld);
}
const $d7238066c5de7f1c$var$Re = [];
for(let r = 0; r < 256; ++r)$d7238066c5de7f1c$var$Re.push((r + 256).toString(16).slice(1));
function $d7238066c5de7f1c$var$Bd(r, e = 0) {
    return $d7238066c5de7f1c$var$Re[r[e + 0]] + $d7238066c5de7f1c$var$Re[r[e + 1]] + $d7238066c5de7f1c$var$Re[r[e + 2]] + $d7238066c5de7f1c$var$Re[r[e + 3]] + "-" + $d7238066c5de7f1c$var$Re[r[e + 4]] + $d7238066c5de7f1c$var$Re[r[e + 5]] + "-" + $d7238066c5de7f1c$var$Re[r[e + 6]] + $d7238066c5de7f1c$var$Re[r[e + 7]] + "-" + $d7238066c5de7f1c$var$Re[r[e + 8]] + $d7238066c5de7f1c$var$Re[r[e + 9]] + "-" + $d7238066c5de7f1c$var$Re[r[e + 10]] + $d7238066c5de7f1c$var$Re[r[e + 11]] + $d7238066c5de7f1c$var$Re[r[e + 12]] + $d7238066c5de7f1c$var$Re[r[e + 13]] + $d7238066c5de7f1c$var$Re[r[e + 14]] + $d7238066c5de7f1c$var$Re[r[e + 15]];
}
const $d7238066c5de7f1c$var$Ud = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), $d7238066c5de7f1c$var$$a = {
    randomUUID: $d7238066c5de7f1c$var$Ud
};
function $d7238066c5de7f1c$var$qd(r, e, t) {
    if ($d7238066c5de7f1c$var$$a.randomUUID && !r) return $d7238066c5de7f1c$var$$a.randomUUID();
    r = r || {};
    const i = r.random || (r.rng || $d7238066c5de7f1c$var$$d)();
    return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, $d7238066c5de7f1c$var$Bd(i);
}
const $d7238066c5de7f1c$var$Qr = ()=>$d7238066c5de7f1c$var$qd(), $d7238066c5de7f1c$var$ee = ()=>$d7238066c5de7f1c$var$Qr().replace(new RegExp("-", "g"), "").toUpperCase();
var $d7238066c5de7f1c$var$ce;
(function(r) {
    r[r.Debug = 0] = "Debug", r[r.Info = 1] = "Info", r[r.Warning = 2] = "Warning", r[r.Error = 3] = "Error", r[r.None = 4] = "None";
})($d7238066c5de7f1c$var$ce || ($d7238066c5de7f1c$var$ce = {}));
class $d7238066c5de7f1c$var$pt {
    constructor(e, t){
        this.privName = e, this.privEventId = $d7238066c5de7f1c$var$ee(), this.privEventTime = /* @__PURE__ */ new Date().toISOString(), this.privEventType = t, this.privMetadata = {};
    }
    get name() {
        return this.privName;
    }
    get eventId() {
        return this.privEventId;
    }
    get eventTime() {
        return this.privEventTime;
    }
    get eventType() {
        return this.privEventType;
    }
    get metadata() {
        return this.privMetadata;
    }
}
class $d7238066c5de7f1c$var$cr extends $d7238066c5de7f1c$var$pt {
    constructor(e, t, i = $d7238066c5de7f1c$var$ce.Info){
        super(e, i), this.privAudioSourceId = t;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
}
class $d7238066c5de7f1c$var$un extends $d7238066c5de7f1c$var$cr {
    constructor(e){
        super("AudioSourceInitializingEvent", e);
    }
}
class $d7238066c5de7f1c$var$Gi extends $d7238066c5de7f1c$var$cr {
    constructor(e){
        super("AudioSourceReadyEvent", e);
    }
}
class $d7238066c5de7f1c$var$kp extends $d7238066c5de7f1c$var$cr {
    constructor(e){
        super("AudioSourceOffEvent", e);
    }
}
class $d7238066c5de7f1c$var$Yr extends $d7238066c5de7f1c$var$cr {
    constructor(e, t){
        super("AudioSourceErrorEvent", e, $d7238066c5de7f1c$var$ce.Error), this.privError = t;
    }
    get error() {
        return this.privError;
    }
}
class $d7238066c5de7f1c$var$dn extends $d7238066c5de7f1c$var$cr {
    constructor(e, t, i){
        super(e, t), this.privAudioNodeId = i;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $d7238066c5de7f1c$var$pr extends $d7238066c5de7f1c$var$dn {
    constructor(e, t){
        super("AudioStreamNodeAttachingEvent", e, t);
    }
}
class $d7238066c5de7f1c$var$hr extends $d7238066c5de7f1c$var$dn {
    constructor(e, t){
        super("AudioStreamNodeAttachedEvent", e, t);
    }
}
class $d7238066c5de7f1c$var$Pt extends $d7238066c5de7f1c$var$dn {
    constructor(e, t){
        super("AudioStreamNodeDetachedEvent", e, t);
    }
}
class $d7238066c5de7f1c$var$So extends $d7238066c5de7f1c$var$dn {
    constructor(e, t, i){
        super("AudioStreamNodeErrorEvent", e, t), this.privError = i;
    }
    get error() {
        return this.privError;
    }
}
class $d7238066c5de7f1c$var$yo extends $d7238066c5de7f1c$var$pt {
    constructor(e, t, i = $d7238066c5de7f1c$var$ce.Info){
        super(e, i), this.privJsonResult = t;
    }
    get jsonString() {
        return this.privJsonResult;
    }
}
class $d7238066c5de7f1c$var$Yt extends $d7238066c5de7f1c$var$pt {
    constructor(e, t, i = $d7238066c5de7f1c$var$ce.Info){
        super(e, i), this.privConnectionId = t;
    }
    get connectionId() {
        return this.privConnectionId;
    }
}
class $d7238066c5de7f1c$var$Dp extends $d7238066c5de7f1c$var$Yt {
    constructor(e, t, i){
        super("ConnectionStartEvent", e), this.privUri = t, this.privHeaders = i;
    }
    get uri() {
        return this.privUri;
    }
    get headers() {
        return this.privHeaders;
    }
}
class $d7238066c5de7f1c$var$Op extends $d7238066c5de7f1c$var$Yt {
    constructor(e){
        super("ConnectionEstablishedEvent", e);
    }
}
class $d7238066c5de7f1c$var$Wd extends $d7238066c5de7f1c$var$Yt {
    constructor(e, t, i){
        super("ConnectionClosedEvent", e, $d7238066c5de7f1c$var$ce.Debug), this.privReason = i, this.privStatusCode = t;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
class $d7238066c5de7f1c$var$Hd extends $d7238066c5de7f1c$var$Yt {
    constructor(e, t, i){
        super("ConnectionErrorEvent", e, $d7238066c5de7f1c$var$ce.Debug), this.privMessage = t, this.privType = i;
    }
    get message() {
        return this.privMessage;
    }
    get type() {
        return this.privType;
    }
}
class $d7238066c5de7f1c$var$Fd extends $d7238066c5de7f1c$var$Yt {
    constructor(e, t, i){
        super("ConnectionEstablishErrorEvent", e, $d7238066c5de7f1c$var$ce.Error), this.privStatusCode = t, this.privReason = i;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
class $d7238066c5de7f1c$var$Ns extends $d7238066c5de7f1c$var$Yt {
    constructor(e, t, i){
        super("ConnectionMessageReceivedEvent", e), this.privNetworkReceivedTime = t, this.privMessage = i;
    }
    get networkReceivedTime() {
        return this.privNetworkReceivedTime;
    }
    get message() {
        return this.privMessage;
    }
}
class $d7238066c5de7f1c$var$Vd extends $d7238066c5de7f1c$var$Yt {
    constructor(e, t, i){
        super("ConnectionMessageSentEvent", e), this.privNetworkSentTime = t, this.privMessage = i;
    }
    get networkSentTime() {
        return this.privNetworkSentTime;
    }
    get message() {
        return this.privMessage;
    }
}
class $d7238066c5de7f1c$var$le extends Error {
    /**
   * Creates an instance of ArgumentNullError.
   *
   * @param {string} argumentName - Name of the argument that is null
   *
   * @memberOf ArgumentNullError
   */ constructor(e){
        super(e), this.name = "ArgumentNull", this.message = e;
    }
}
class $d7238066c5de7f1c$var$De extends Error {
    /**
   * Creates an instance of InvalidOperationError.
   *
   * @param {string} error - The error
   *
   * @memberOf InvalidOperationError
   */ constructor(e){
        super(e), this.name = "InvalidOperation", this.message = e;
    }
}
class $d7238066c5de7f1c$var$Co extends Error {
    /**
   * Creates an instance of ObjectDisposedError.
   *
   * @param {string} objectName - The object that is disposed
   * @param {string} error - The error
   *
   * @memberOf ObjectDisposedError
   */ constructor(e, t){
        super(t), this.name = e + "ObjectDisposed", this.message = t;
    }
}
var $d7238066c5de7f1c$var$k;
(function(r) {
    r[r.Text = 0] = "Text", r[r.Binary = 1] = "Binary";
})($d7238066c5de7f1c$var$k || ($d7238066c5de7f1c$var$k = {}));
let $d7238066c5de7f1c$var$Zr = class {
    constructor(e, t, i, n){
        if (this.privBody = null, e === $d7238066c5de7f1c$var$k.Text && t && typeof t != "string") throw new $d7238066c5de7f1c$var$De("Payload must be a string");
        if (e === $d7238066c5de7f1c$var$k.Binary && t && !(t instanceof ArrayBuffer)) throw new $d7238066c5de7f1c$var$De("Payload must be ArrayBuffer");
        switch(this.privMessageType = e, this.privBody = t, this.privHeaders = i || {}, this.privId = n || $d7238066c5de7f1c$var$ee(), this.messageType){
            case $d7238066c5de7f1c$var$k.Binary:
                this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
                break;
            case $d7238066c5de7f1c$var$k.Text:
                this.privSize = this.textBody.length;
        }
    }
    get messageType() {
        return this.privMessageType;
    }
    get headers() {
        return this.privHeaders;
    }
    get body() {
        return this.privBody;
    }
    get textBody() {
        if (this.privMessageType === $d7238066c5de7f1c$var$k.Binary) throw new $d7238066c5de7f1c$var$De("Not supported for binary message");
        return this.privBody;
    }
    get binaryBody() {
        if (this.privMessageType === $d7238066c5de7f1c$var$k.Text) throw new $d7238066c5de7f1c$var$De("Not supported for text message");
        return this.privBody;
    }
    get id() {
        return this.privId;
    }
};
class $d7238066c5de7f1c$var$Un {
    constructor(e, t){
        this.privStatusCode = e, this.privReason = t;
    }
    get statusCode() {
        return this.privStatusCode;
    }
    get reason() {
        return this.privReason;
    }
}
class $d7238066c5de7f1c$var$Kd {
    constructor(){
        this.privMap = {};
    }
    add(e, t) {
        this.privMap[e] = t;
    }
    getId(e) {
        return this.privMap[e];
    }
    complete(e, t) {
        try {
            this.privMap[e].resolve(t);
        } catch (i) {
            this.privMap[e].reject(i);
        } finally{
            this.privMap[e] = void 0;
        }
    }
}
class $d7238066c5de7f1c$var$jd extends $d7238066c5de7f1c$var$pt {
    constructor(e, t = $d7238066c5de7f1c$var$ce.Info){
        super(e, t);
    }
}
class $d7238066c5de7f1c$var$Jd extends $d7238066c5de7f1c$var$jd {
    constructor(e){
        super("SendingAgentContextMessageEvent"), this.privAgentConfig = e;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
}
class $d7238066c5de7f1c$var$Ze {
    constructor(e){
        this.privEventListeners = {}, this.privIsDisposed = !1, this.privConsoleListener = void 0, this.privMetadata = e;
    }
    onEvent(e) {
        if (this.isDisposed()) throw new $d7238066c5de7f1c$var$Co("EventSource");
        if (this.metadata) for(const t in this.metadata)t && e.metadata && (e.metadata[t] || (e.metadata[t] = this.metadata[t]));
        for(const t in this.privEventListeners)t && this.privEventListeners[t] && this.privEventListeners[t](e);
    }
    attach(e) {
        const t = $d7238066c5de7f1c$var$ee();
        return this.privEventListeners[t] = e, {
            detach: ()=>(delete this.privEventListeners[t], Promise.resolve())
        };
    }
    attachListener(e) {
        return this.attach((t)=>e.onEvent(t));
    }
    attachConsoleListener(e) {
        return this.privConsoleListener && this.privConsoleListener.detach(), this.privConsoleListener = this.attach((t)=>e.onEvent(t)), this.privConsoleListener;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        this.privEventListeners = null, this.privIsDisposed = !0;
    }
    get metadata() {
        return this.privMetadata;
    }
}
class $d7238066c5de7f1c$var$oe {
    static setEventSource(e) {
        if (!e) throw new $d7238066c5de7f1c$var$le("eventSource");
        $d7238066c5de7f1c$var$oe.privInstance = e;
    }
    static get instance() {
        return $d7238066c5de7f1c$var$oe.privInstance;
    }
}
$d7238066c5de7f1c$var$oe.privInstance = new $d7238066c5de7f1c$var$Ze();
var $d7238066c5de7f1c$var$pe;
(function(r) {
    r[r.None = 0] = "None", r[r.Connected = 1] = "Connected", r[r.Connecting = 2] = "Connecting", r[r.Disconnected = 3] = "Disconnected";
})($d7238066c5de7f1c$var$pe || ($d7238066c5de7f1c$var$pe = {}));
class $d7238066c5de7f1c$var$st {
    constructor(e){
        if (this.privSubscriptionIdCounter = 0, this.privAddSubscriptions = {}, this.privRemoveSubscriptions = {}, this.privDisposedSubscriptions = {}, this.privDisposeReason = null, this.privList = [], e) for (const t of e)this.privList.push(t);
    }
    get(e) {
        return this.throwIfDisposed(), this.privList[e];
    }
    first() {
        return this.get(0);
    }
    last() {
        return this.get(this.length() - 1);
    }
    add(e) {
        this.throwIfDisposed(), this.insertAt(this.privList.length, e);
    }
    insertAt(e, t) {
        this.throwIfDisposed(), e === 0 ? this.privList.unshift(t) : e === this.privList.length ? this.privList.push(t) : this.privList.splice(e, 0, t), this.triggerSubscriptions(this.privAddSubscriptions);
    }
    removeFirst() {
        return this.throwIfDisposed(), this.removeAt(0);
    }
    removeLast() {
        return this.throwIfDisposed(), this.removeAt(this.length() - 1);
    }
    removeAt(e) {
        return this.throwIfDisposed(), this.remove(e, 1)[0];
    }
    remove(e, t) {
        this.throwIfDisposed();
        const i = this.privList.splice(e, t);
        return this.triggerSubscriptions(this.privRemoveSubscriptions), i;
    }
    clear() {
        this.throwIfDisposed(), this.remove(0, this.length());
    }
    length() {
        return this.throwIfDisposed(), this.privList.length;
    }
    onAdded(e) {
        this.throwIfDisposed();
        const t = this.privSubscriptionIdCounter++;
        return this.privAddSubscriptions[t] = e, {
            detach: ()=>(delete this.privAddSubscriptions[t], Promise.resolve())
        };
    }
    onRemoved(e) {
        this.throwIfDisposed();
        const t = this.privSubscriptionIdCounter++;
        return this.privRemoveSubscriptions[t] = e, {
            detach: ()=>(delete this.privRemoveSubscriptions[t], Promise.resolve())
        };
    }
    onDisposed(e) {
        this.throwIfDisposed();
        const t = this.privSubscriptionIdCounter++;
        return this.privDisposedSubscriptions[t] = e, {
            detach: ()=>(delete this.privDisposedSubscriptions[t], Promise.resolve())
        };
    }
    join(e) {
        return this.throwIfDisposed(), this.privList.join(e);
    }
    toArray() {
        const e = Array();
        return this.privList.forEach((t)=>{
            e.push(t);
        }), e;
    }
    any(e) {
        return this.throwIfDisposed(), e ? this.where(e).length() > 0 : this.length() > 0;
    }
    all(e) {
        return this.throwIfDisposed(), this.where(e).length() === this.length();
    }
    forEach(e) {
        this.throwIfDisposed();
        for(let t = 0; t < this.length(); t++)e(this.privList[t], t);
    }
    select(e) {
        this.throwIfDisposed();
        const t = [];
        for(let i = 0; i < this.privList.length; i++)t.push(e(this.privList[i], i));
        return new $d7238066c5de7f1c$var$st(t);
    }
    where(e) {
        this.throwIfDisposed();
        const t = new $d7238066c5de7f1c$var$st();
        for(let i = 0; i < this.privList.length; i++)e(this.privList[i], i) && t.add(this.privList[i]);
        return t;
    }
    orderBy(e) {
        this.throwIfDisposed();
        const i = this.toArray().sort(e);
        return new $d7238066c5de7f1c$var$st(i);
    }
    orderByDesc(e) {
        return this.throwIfDisposed(), this.orderBy((t, i)=>e(i, t));
    }
    clone() {
        return this.throwIfDisposed(), new $d7238066c5de7f1c$var$st(this.toArray());
    }
    concat(e) {
        return this.throwIfDisposed(), new $d7238066c5de7f1c$var$st(this.privList.concat(e.toArray()));
    }
    concatArray(e) {
        return this.throwIfDisposed(), new $d7238066c5de7f1c$var$st(this.privList.concat(e));
    }
    isDisposed() {
        return this.privList == null;
    }
    dispose(e) {
        this.isDisposed() || (this.privDisposeReason = e, this.privList = null, this.privAddSubscriptions = null, this.privRemoveSubscriptions = null, this.triggerSubscriptions(this.privDisposedSubscriptions));
    }
    throwIfDisposed() {
        if (this.isDisposed()) throw new $d7238066c5de7f1c$var$Co("List", this.privDisposeReason);
    }
    triggerSubscriptions(e) {
        if (e) for(const t in e)t && e[t]();
    }
}
var $d7238066c5de7f1c$var$Ba;
(function(r) {
    r[r.None = 0] = "None", r[r.Resolved = 1] = "Resolved", r[r.Rejected = 2] = "Rejected";
})($d7238066c5de7f1c$var$Ba || ($d7238066c5de7f1c$var$Ba = {}));
class $d7238066c5de7f1c$var$F {
    constructor(){
        this.resolve = (e)=>(this.privResolve(e), this), this.reject = (e)=>(this.privReject(e), this), this.privPromise = new Promise((e, t)=>{
            this.privResolve = e, this.privReject = t;
        });
    }
    get promise() {
        return this.privPromise;
    }
}
function $d7238066c5de7f1c$var$x(r, e, t) {
    r.then((i)=>{
        try {
            e && e(i);
        } catch (n) {
            if (t) try {
                if (n instanceof Error) {
                    const s = n;
                    t(s.name + ": " + s.message);
                } else t(n);
            } catch  {}
        }
    }, (i)=>{
        if (t) try {
            if (i instanceof Error) {
                const n = i;
                t(n.name + ": " + n.message);
            } else t(i);
        } catch  {}
    });
}
var $d7238066c5de7f1c$var$Ua = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
}, $d7238066c5de7f1c$var$Hi;
(function(r) {
    r[r.Dequeue = 0] = "Dequeue", r[r.Peek = 1] = "Peek";
})($d7238066c5de7f1c$var$Hi || ($d7238066c5de7f1c$var$Hi = {}));
let $d7238066c5de7f1c$var$Qi = class {
    constructor(e){
        this.privPromiseStore = new $d7238066c5de7f1c$var$st(), this.privIsDrainInProgress = !1, this.privIsDisposing = !1, this.privDisposeReason = null, this.privList = e || new $d7238066c5de7f1c$var$st(), this.privDetachables = [], this.privSubscribers = new $d7238066c5de7f1c$var$st(), this.privDetachables.push(this.privList.onAdded(()=>this.drain()));
    }
    enqueue(e) {
        this.throwIfDispose(), this.enqueueFromPromise(new Promise((t)=>t(e)));
    }
    enqueueFromPromise(e) {
        this.throwIfDispose(), e.then((t)=>{
            this.privList.add(t);
        }, ()=>{});
    }
    dequeue() {
        this.throwIfDispose();
        const e = new $d7238066c5de7f1c$var$F();
        return this.privSubscribers && (this.privSubscribers.add({
            deferral: e,
            type: $d7238066c5de7f1c$var$Hi.Dequeue
        }), this.drain()), e.promise;
    }
    peek() {
        this.throwIfDispose();
        const e = new $d7238066c5de7f1c$var$F();
        return this.privSubscribers && (this.privSubscribers.add({
            deferral: e,
            type: $d7238066c5de7f1c$var$Hi.Peek
        }), this.drain()), e.promise;
    }
    length() {
        return this.throwIfDispose(), this.privList.length();
    }
    isDisposed() {
        return this.privSubscribers == null;
    }
    drainAndDispose(e, t) {
        return $d7238066c5de7f1c$var$Ua(this, void 0, void 0, function*() {
            if (!this.isDisposed() && !this.privIsDisposing) {
                this.privDisposeReason = t, this.privIsDisposing = !0;
                const i = this.privSubscribers;
                if (i) {
                    for(; i.length() > 0;)i.removeFirst().deferral.resolve(void 0);
                    this.privSubscribers === i && (this.privSubscribers = i);
                }
                for (const n of this.privDetachables)yield n.detach();
                if (this.privPromiseStore.length() > 0 && e) {
                    const n = [];
                    return this.privPromiseStore.toArray().forEach((s)=>{
                        n.push(s);
                    }), Promise.all(n).finally(()=>{
                        this.privSubscribers = null, this.privList.forEach((s)=>{
                            e(s);
                        }), this.privList = null;
                    }).then();
                } else this.privSubscribers = null, this.privList = null;
            }
        });
    }
    dispose(e) {
        return $d7238066c5de7f1c$var$Ua(this, void 0, void 0, function*() {
            yield this.drainAndDispose(null, e);
        });
    }
    drain() {
        if (!this.privIsDrainInProgress && !this.privIsDisposing) {
            this.privIsDrainInProgress = !0;
            const e = this.privSubscribers, t = this.privList;
            if (e && t) {
                for(; t.length() > 0 && e.length() > 0 && !this.privIsDisposing;){
                    const i = e.removeFirst();
                    if (i.type === $d7238066c5de7f1c$var$Hi.Peek) i.deferral.resolve(t.first());
                    else {
                        const n = t.removeFirst();
                        i.deferral.resolve(n);
                    }
                }
                this.privSubscribers === e && (this.privSubscribers = e), this.privList === t && (this.privList = t);
            }
            this.privIsDrainInProgress = !1;
        }
    }
    throwIfDispose() {
        if (this.isDisposed()) throw this.privDisposeReason ? new $d7238066c5de7f1c$var$De(this.privDisposeReason) : new $d7238066c5de7f1c$var$Co("Queue");
        if (this.privIsDisposing) throw new $d7238066c5de7f1c$var$De("Queue disposing");
    }
};
class $d7238066c5de7f1c$var$Yi {
    constructor(e, t, i){
        if (this.privPayload = null, !t) throw new $d7238066c5de7f1c$var$le("payload");
        if (e === $d7238066c5de7f1c$var$k.Binary && t.__proto__.constructor.name !== "ArrayBuffer") throw new $d7238066c5de7f1c$var$De("Payload must be ArrayBuffer");
        if (e === $d7238066c5de7f1c$var$k.Text && typeof t != "string") throw new $d7238066c5de7f1c$var$De("Payload must be a string");
        this.privMessageType = e, this.privPayload = t, this.privId = i || $d7238066c5de7f1c$var$ee();
    }
    get messageType() {
        return this.privMessageType;
    }
    get payload() {
        return this.privPayload;
    }
    get textContent() {
        if (this.privMessageType === $d7238066c5de7f1c$var$k.Binary) throw new $d7238066c5de7f1c$var$De("Not supported for binary message");
        return this.privPayload;
    }
    get binaryContent() {
        if (this.privMessageType === $d7238066c5de7f1c$var$k.Text) throw new $d7238066c5de7f1c$var$De("Not supported for text message");
        return this.privPayload;
    }
    get id() {
        return this.privId;
    }
}
class $d7238066c5de7f1c$var$Gd {
    constructor(e, t){
        this.privActualSampleRate = e, this.privDesiredSampleRate = t;
    }
    encode(e) {
        const t = this.downSampleAudioFrame(e, this.privActualSampleRate, this.privDesiredSampleRate);
        if (!t) return null;
        const i = t.length * 2, n = new ArrayBuffer(i), s = new DataView(n);
        return this.floatTo16BitPCM(s, 0, t), n;
    }
    setString(e, t, i) {
        for(let n = 0; n < i.length; n++)e.setUint8(t + n, i.charCodeAt(n));
    }
    floatTo16BitPCM(e, t, i) {
        for(let n = 0; n < i.length; n++, t += 2){
            const s = Math.max(-1, Math.min(1, i[n]));
            e.setInt16(t, s < 0 ? s * 32768 : s * 32767, !0);
        }
    }
    downSampleAudioFrame(e, t, i) {
        if (!e) return null;
        if (i === t || i > t) return e;
        const n = t / i, s = Math.round(e.length / n), o = new Float32Array(s);
        let c = 0, p = 0;
        for(; p < s;){
            const h = Math.round((p + 1) * n);
            let a = 0, d = 0;
            for(; c < h && c < e.length;)a += e[c++], d++;
            o[p++] = a / d;
        }
        return o;
    }
}
var $d7238066c5de7f1c$var$Qd = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$zp {
    constructor(e){
        this.privIsWriteEnded = !1, this.privIsReadEnded = !1, this.privId = e || $d7238066c5de7f1c$var$ee(), this.privReaderQueue = new $d7238066c5de7f1c$var$Qi();
    }
    get isClosed() {
        return this.privIsWriteEnded;
    }
    get isReadEnded() {
        return this.privIsReadEnded;
    }
    get id() {
        return this.privId;
    }
    close() {
        this.privIsWriteEnded || (this.writeStreamChunk({
            buffer: null,
            isEnd: !0,
            timeReceived: Date.now()
        }), this.privIsWriteEnded = !0);
    }
    writeStreamChunk(e) {
        if (this.throwIfClosed(), !this.privReaderQueue.isDisposed()) try {
            this.privReaderQueue.enqueue(e);
        } catch  {}
    }
    read() {
        if (this.privIsReadEnded) throw new $d7238066c5de7f1c$var$De("Stream read has already finished");
        return this.privReaderQueue.dequeue().then((e)=>$d7238066c5de7f1c$var$Qd(this, void 0, void 0, function*() {
                return (e === void 0 || e.isEnd) && (yield this.privReaderQueue.dispose("End of stream reached")), e;
            }));
    }
    readEnded() {
        this.privIsReadEnded || (this.privIsReadEnded = !0, this.privReaderQueue = new $d7238066c5de7f1c$var$Qi());
    }
    throwIfClosed() {
        if (this.privIsWriteEnded) throw new $d7238066c5de7f1c$var$De("Stream closed");
    }
}
var $d7238066c5de7f1c$var$Zi;
(function(r) {
    r[r.Success = 0] = "Success", r[r.Error = 1] = "Error";
})($d7238066c5de7f1c$var$Zi || ($d7238066c5de7f1c$var$Zi = {}));
class $d7238066c5de7f1c$var$wo extends $d7238066c5de7f1c$var$zp {
    constructor(e, t){
        super(t), this.privTargetChunkSize = e, this.privNextBufferReadyBytes = 0;
    }
    writeStreamChunk(e) {
        if (e.isEnd || this.privNextBufferReadyBytes === 0 && e.buffer.byteLength === this.privTargetChunkSize) {
            super.writeStreamChunk(e);
            return;
        }
        let t = 0;
        for(; t < e.buffer.byteLength;){
            this.privNextBufferToWrite === void 0 && (this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize), this.privNextBufferStartTime = e.timeReceived);
            const i = Math.min(e.buffer.byteLength - t, this.privTargetChunkSize - this.privNextBufferReadyBytes), n = new Uint8Array(this.privNextBufferToWrite), s = new Uint8Array(e.buffer.slice(t, i + t));
            n.set(s, this.privNextBufferReadyBytes), this.privNextBufferReadyBytes += i, t += i, this.privNextBufferReadyBytes === this.privTargetChunkSize && (super.writeStreamChunk({
                buffer: this.privNextBufferToWrite,
                isEnd: !1,
                timeReceived: this.privNextBufferStartTime
            }), this.privNextBufferReadyBytes = 0, this.privNextBufferToWrite = void 0);
        }
    }
    close() {
        this.privNextBufferReadyBytes !== 0 && !this.isClosed && super.writeStreamChunk({
            buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
            isEnd: !1,
            timeReceived: this.privNextBufferStartTime
        }), super.close();
    }
}
class $d7238066c5de7f1c$var$ye {
    static load() {
        const e = /* @__PURE__ */ new Map([
            [
                0,
                ()=>{}
            ]
        ]), t = /* @__PURE__ */ new Map(), n = "data:text/javascript;base64," + btoa(`!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`), s = new Worker(n);
        return s.addEventListener("message", ({ data: p })=>{
            if ($d7238066c5de7f1c$var$ye.isCallNotification(p)) {
                const { params: { timerId: h } } = p, a = e.get(h);
                if (typeof a == "number") {
                    const d = t.get(a);
                    if (d === void 0 || d !== h) throw new Error("The timer is in an undefined state.");
                } else if (typeof a < "u") a(), e.delete(h);
                else throw new Error("The timer is in an undefined state.");
            } else if ($d7238066c5de7f1c$var$ye.isClearResponse(p)) {
                const { id: h } = p, a = t.get(h);
                if (a === void 0) throw new Error("The timer is in an undefined state.");
                t.delete(h), e.delete(a);
            } else {
                const { error: { message: h } } = p;
                throw new Error(h);
            }
        }), {
            clearTimeout: (p)=>{
                const h = Math.random();
                t.set(h, p), e.set(p, h), s.postMessage({
                    id: h,
                    method: "clear",
                    params: {
                        timerId: p
                    }
                });
            },
            setTimeout: (p, h)=>{
                const a = Math.random();
                return e.set(a, p), s.postMessage({
                    id: null,
                    method: "set",
                    params: {
                        delay: h,
                        now: performance.now(),
                        timerId: a
                    }
                }), a;
            }
        };
    }
    static loadWorkerTimers() {
        return ()=>($d7238066c5de7f1c$var$ye.workerTimers !== null || ($d7238066c5de7f1c$var$ye.workerTimers = $d7238066c5de7f1c$var$ye.load()), $d7238066c5de7f1c$var$ye.workerTimers);
    }
    static isCallNotification(e) {
        return e.method !== void 0 && e.method === "call";
    }
    static isClearResponse(e) {
        return e.error === null && typeof e.id == "number";
    }
}
$d7238066c5de7f1c$var$ye.workerTimers = null;
$d7238066c5de7f1c$var$ye.clearTimeout = (r)=>$d7238066c5de7f1c$var$ye.timers().clearTimeout(r);
$d7238066c5de7f1c$var$ye.setTimeout = (r, e)=>$d7238066c5de7f1c$var$ye.timers().setTimeout(r, e);
$d7238066c5de7f1c$var$ye.timers = $d7238066c5de7f1c$var$ye.loadWorkerTimers();
class $d7238066c5de7f1c$var$Ct extends $d7238066c5de7f1c$var$pt {
    constructor(e){
        super("BackgroundEvent", $d7238066c5de7f1c$var$ce.Error), this.privError = e;
    }
    get error() {
        return this.privError;
    }
}
class $d7238066c5de7f1c$var$W {
}
$d7238066c5de7f1c$var$W.AuthKey = "Ocp-Apim-Subscription-Key";
$d7238066c5de7f1c$var$W.Authorization = "Authorization";
$d7238066c5de7f1c$var$W.SpIDAuthKey = "Apim-Subscription-Id";
$d7238066c5de7f1c$var$W.ConnectionId = "X-ConnectionId";
$d7238066c5de7f1c$var$W.ContentType = "Content-Type";
$d7238066c5de7f1c$var$W.CustomCommandsAppId = "X-CommandsAppId";
$d7238066c5de7f1c$var$W.Path = "Path";
$d7238066c5de7f1c$var$W.RequestId = "X-RequestId";
$d7238066c5de7f1c$var$W.RequestStreamId = "X-StreamId";
$d7238066c5de7f1c$var$W.RequestTimestamp = "X-Timestamp";
class $d7238066c5de7f1c$var$Ms {
    constructor(e, t){
        this.privHeaderName = e, this.privToken = t;
    }
    get headerName() {
        return this.privHeaderName;
    }
    get token() {
        return this.privToken;
    }
}
class $d7238066c5de7f1c$var$Np {
    /**
   * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
   * @constructor
   * @param {string} subscriptionKey - The subscription key
   */ constructor(e){
        if (!e) throw new $d7238066c5de7f1c$var$le("subscriptionKey");
        this.privAuthInfo = new $d7238066c5de7f1c$var$Ms($d7238066c5de7f1c$var$W.AuthKey, e);
    }
    /**
   * Fetches the subscription key.
   * @member
   * @function
   * @public
   * @param {string} authFetchEventId - The id to fetch.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetch(e) {
        return Promise.resolve(this.privAuthInfo);
    }
    /**
   * Fetches the subscription key.
   * @member
   * @function
   * @public
   * @param {string} authFetchEventId - The id to fetch.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetchOnExpiry(e) {
        return Promise.resolve(this.privAuthInfo);
    }
}
class $d7238066c5de7f1c$var$jt {
    constructor(e, t){
        if (!e) throw new $d7238066c5de7f1c$var$le("fetchCallback");
        if (!t) throw new $d7238066c5de7f1c$var$le("fetchOnExpiryCallback");
        this.privFetchCallback = e, this.privFetchOnExpiryCallback = t;
    }
    fetch(e) {
        return this.privFetchCallback(e).then((t)=>new $d7238066c5de7f1c$var$Ms($d7238066c5de7f1c$var$W.Authorization, t === void 0 ? void 0 : $d7238066c5de7f1c$var$jt.privTokenPrefix + t));
    }
    fetchOnExpiry(e) {
        return this.privFetchOnExpiryCallback(e).then((t)=>new $d7238066c5de7f1c$var$Ms($d7238066c5de7f1c$var$W.Authorization, t === void 0 ? void 0 : $d7238066c5de7f1c$var$jt.privTokenPrefix + t));
    }
}
$d7238066c5de7f1c$var$jt.privTokenPrefix = "Bearer ";
const $d7238066c5de7f1c$var$qn = {};
class $d7238066c5de7f1c$var$l {
    static throwIfNullOrUndefined(e, t) {
        if (e == null) throw new Error("throwIfNullOrUndefined:" + t);
    }
    static throwIfNull(e, t) {
        if (e === null) throw new Error("throwIfNull:" + t);
    }
    static throwIfNullOrWhitespace(e, t) {
        if ($d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, t), ("" + e).trim().length < 1) throw new Error("throwIfNullOrWhitespace:" + t);
    }
    static throwIfNullOrTooLong(e, t, i) {
        if ($d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, t), ("" + e).length > i) throw new Error("throwIfNullOrTooLong:" + t + " (more than " + i.toString() + " characters)");
    }
    static throwIfNullOrTooShort(e, t, i) {
        if ($d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, t), ("" + e).length < i) throw new Error("throwIfNullOrTooShort:" + t + " (less than " + i.toString() + " characters)");
    }
    static throwIfDisposed(e) {
        if (e) throw new Error("the object is already disposed");
    }
    static throwIfArrayEmptyOrWhitespace(e, t) {
        if ($d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, t), e.length === 0) throw new Error("throwIfArrayEmptyOrWhitespace:" + t);
        for (const i of e)$d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(i, t);
    }
    static throwIfFileDoesNotExist(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, t);
    }
    static throwIfNotUndefined(e, t) {
        if (e !== void 0) throw new Error("throwIfNotUndefined:" + t);
    }
}
class $d7238066c5de7f1c$var$Yd {
    constructor(e = $d7238066c5de7f1c$var$ce.None){
        this.privLogPath = void 0, this.privEnableConsoleOutput = !0, this.privLogLevelFilter = e;
    }
    set logPath(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(void 0, `
File System access not available`), this.privLogPath = e;
    }
    set enableConsoleOutput(e) {
        this.privEnableConsoleOutput = e;
    }
    onEvent(e) {
        if (e.eventType >= this.privLogLevelFilter) {
            const t = this.toString(e);
            if (this.privLogPath && (void 0)(this.privLogPath, t + `
`, {
                flag: "a+"
            }), this.privEnableConsoleOutput) switch(e.eventType){
                case $d7238066c5de7f1c$var$ce.Debug:
                    console.debug(t);
                    break;
                case $d7238066c5de7f1c$var$ce.Info:
                    console.info(t);
                    break;
                case $d7238066c5de7f1c$var$ce.Warning:
                    console.warn(t);
                    break;
                case $d7238066c5de7f1c$var$ce.Error:
                    console.error(t);
                    break;
                default:
                    console.log(t);
                    break;
            }
        }
    }
    toString(e) {
        const t = [
            `${e.eventTime}`,
            `${e.name}`
        ], i = e;
        for(const n in i)if (n && e.hasOwnProperty(n) && n !== "eventTime" && n !== "eventType" && n !== "eventId" && n !== "name" && n !== "constructor") {
            const s = i[n];
            let o = "<NULL>";
            s != null && (typeof s == "number" || typeof s == "string" ? o = s.toString() : o = JSON.stringify(s)), t.push(`${n}: ${o}`);
        }
        return t.join(" | ");
    }
}
var $d7238066c5de7f1c$var$E;
(function(r) {
    r[r.PCM = 1] = "PCM", r[r.MuLaw = 2] = "MuLaw", r[r.Siren = 3] = "Siren", r[r.MP3 = 4] = "MP3", r[r.SILKSkype = 5] = "SILKSkype", r[r.OGG_OPUS = 6] = "OGG_OPUS", r[r.WEBM_OPUS = 7] = "WEBM_OPUS", r[r.ALaw = 8] = "ALaw", r[r.FLAC = 9] = "FLAC", r[r.OPUS = 10] = "OPUS";
})($d7238066c5de7f1c$var$E || ($d7238066c5de7f1c$var$E = {}));
class $d7238066c5de7f1c$var$bi {
    /**
   * Creates an audio stream format object representing the default audio stream
   * format (16KHz 16bit mono PCM).
   * @member AudioStreamFormat.getDefaultInputFormat
   * @function
   * @public
   * @returns {AudioStreamFormat} The audio stream format being created.
   */ static getDefaultInputFormat() {
        return $d7238066c5de7f1c$var$wt.getDefaultInputFormat();
    }
    /**
   * Creates an audio stream format object with the specified format characteristics.
   * @member AudioStreamFormat.getWaveFormat
   * @function
   * @public
   * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
   * @param {number} bitsPerSample - Bits per sample, typically 16.
   * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
   * uses one channel and stereo data uses two channels.
   * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
   * @returns {AudioStreamFormat} The audio stream format being created.
   */ static getWaveFormat(e, t, i, n) {
        return new $d7238066c5de7f1c$var$wt(e, t, i, n);
    }
    /**
   * Creates an audio stream format object with the specified pcm waveformat characteristics.
   * @member AudioStreamFormat.getWaveFormatPCM
   * @function
   * @public
   * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
   * @param {number} bitsPerSample - Bits per sample, typically 16.
   * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
   * uses one channel and stereo data uses two channels.
   * @returns {AudioStreamFormat} The audio stream format being created.
   */ static getWaveFormatPCM(e, t, i) {
        return new $d7238066c5de7f1c$var$wt(e, t, i);
    }
}
class $d7238066c5de7f1c$var$wt extends $d7238066c5de7f1c$var$bi {
    /**
   * Creates an instance with the given values.
   * @constructor
   * @param {number} samplesPerSec - Samples per second.
   * @param {number} bitsPerSample - Bits per sample.
   * @param {number} channels - Number of channels.
   * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
   */ constructor(e = 16e3, t = 16, i = 1, n = $d7238066c5de7f1c$var$E.PCM){
        super();
        let s = !0;
        switch(n){
            case $d7238066c5de7f1c$var$E.PCM:
                this.formatTag = 1;
                break;
            case $d7238066c5de7f1c$var$E.ALaw:
                this.formatTag = 6;
                break;
            case $d7238066c5de7f1c$var$E.MuLaw:
                this.formatTag = 7;
                break;
            default:
                s = !1;
        }
        if (this.bitsPerSample = t, this.samplesPerSec = e, this.channels = i, this.avgBytesPerSec = this.samplesPerSec * this.channels * (this.bitsPerSample / 8), this.blockAlign = this.channels * Math.max(this.bitsPerSample, 8), s) {
            this.privHeader = new ArrayBuffer(44);
            const o = new DataView(this.privHeader);
            this.setString(o, 0, "RIFF"), o.setUint32(4, 0, !0), this.setString(o, 8, "WAVEfmt "), o.setUint32(16, 16, !0), o.setUint16(20, this.formatTag, !0), o.setUint16(22, this.channels, !0), o.setUint32(24, this.samplesPerSec, !0), o.setUint32(28, this.avgBytesPerSec, !0), o.setUint16(32, this.channels * (this.bitsPerSample / 8), !0), o.setUint16(34, this.bitsPerSample, !0), this.setString(o, 36, "data"), o.setUint32(40, 0, !0);
        }
    }
    /**
   * Retrieves the default input format.
   * @member AudioStreamFormatImpl.getDefaultInputFormat
   * @function
   * @public
   * @returns {AudioStreamFormatImpl} The default input format.
   */ static getDefaultInputFormat() {
        return new $d7238066c5de7f1c$var$wt();
    }
    /**
   * Creates an audio context appropriate to current browser
   * @member AudioStreamFormatImpl.getAudioContext
   * @function
   * @public
   * @returns {AudioContext} An audio context instance
   */ /* eslint-disable */ static getAudioContext(e) {
        const t = window.AudioContext || window.webkitAudioContext || !1;
        if (t) return e !== void 0 && navigator.mediaDevices.getSupportedConstraints().sampleRate ? new t({
            sampleRate: e
        }) : new t();
        throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    }
    /* eslint-enable */ /**
   * Closes the configuration object.
   * @member AudioStreamFormatImpl.prototype.close
   * @function
   * @public
   */ close() {}
    get header() {
        return this.privHeader;
    }
    setString(e, t, i) {
        for(let n = 0; n < i.length; n++)e.setUint8(t + n, i.charCodeAt(n));
    }
}
var $d7238066c5de7f1c$var$br = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
const $d7238066c5de7f1c$var$Zd = "MICROPHONE-WorkletSourceUrl";
class $d7238066c5de7f1c$var$Ge {
    constructor(e, t, i, n){
        this.privRecorder = e, this.deviceId = t, this.privStreams = {}, this.privOutputChunkSize = $d7238066c5de7f1c$var$Ge.AUDIOFORMAT.avgBytesPerSec / 10, this.privId = i || $d7238066c5de7f1c$var$ee(), this.privEvents = new $d7238066c5de7f1c$var$Ze(), this.privMediaStream = n || null, this.privIsClosing = !1;
    }
    get format() {
        return Promise.resolve($d7238066c5de7f1c$var$Ge.AUDIOFORMAT);
    }
    turnOn() {
        if (this.privInitializeDeferral) return this.privInitializeDeferral.promise;
        this.privInitializeDeferral = new $d7238066c5de7f1c$var$F();
        try {
            this.createAudioContext();
        } catch (i) {
            if (i instanceof Error) {
                const n = i;
                this.privInitializeDeferral.reject(n.name + ": " + n.message);
            } else this.privInitializeDeferral.reject(i);
            return this.privInitializeDeferral.promise;
        }
        const e = window.navigator;
        let t = // eslint-disable-next-line
        e.getUserMedia || e.webkitGetUserMedia || e.mozGetUserMedia || e.msGetUserMedia;
        if (e.mediaDevices && (t = (i, n, s)=>{
            e.mediaDevices.getUserMedia(i).then(n).catch(s);
        }), t) {
            const i = ()=>{
                this.onEvent(new $d7238066c5de7f1c$var$un(this.privId)), this.privMediaStream && this.privMediaStream.active ? (this.onEvent(new $d7238066c5de7f1c$var$Gi(this.privId)), this.privInitializeDeferral.resolve()) : t({
                    audio: this.deviceId ? {
                        deviceId: this.deviceId
                    } : !0,
                    video: !1
                }, (n)=>{
                    this.privMediaStream = n, this.onEvent(new $d7238066c5de7f1c$var$Gi(this.privId)), this.privInitializeDeferral.resolve();
                }, (n)=>{
                    const s = `Error occurred during microphone initialization: ${n}`;
                    this.privInitializeDeferral.reject(s), this.onEvent(new $d7238066c5de7f1c$var$Yr(this.privId, s));
                });
            };
            this.privContext.state === "suspended" ? this.privContext.resume().then(i).catch((n)=>{
                this.privInitializeDeferral.reject(`Failed to initialize audio context: ${n}`);
            }) : i();
        } else {
            const i = "Browser does not support getUserMedia.";
            this.privInitializeDeferral.reject(i), this.onEvent(new $d7238066c5de7f1c$var$Yr(i, ""));
        }
        return this.privInitializeDeferral.promise;
    }
    id() {
        return this.privId;
    }
    attach(e) {
        return this.onEvent(new $d7238066c5de7f1c$var$pr(this.privId, e)), this.listen(e).then((t)=>(this.onEvent(new $d7238066c5de7f1c$var$hr(this.privId, e)), {
                detach: ()=>$d7238066c5de7f1c$var$br(this, void 0, void 0, function*() {
                        return t.readEnded(), delete this.privStreams[e], this.onEvent(new $d7238066c5de7f1c$var$Pt(this.privId, e)), this.turnOff();
                    }),
                id: ()=>e,
                read: ()=>t.read()
            }));
    }
    detach(e) {
        e && this.privStreams[e] && (this.privStreams[e].close(), delete this.privStreams[e], this.onEvent(new $d7238066c5de7f1c$var$Pt(this.privId, e)));
    }
    turnOff() {
        return $d7238066c5de7f1c$var$br(this, void 0, void 0, function*() {
            for(const e in this.privStreams)if (e) {
                const t = this.privStreams[e];
                t && t.close();
            }
            this.onEvent(new $d7238066c5de7f1c$var$kp(this.privId)), this.privInitializeDeferral && (yield this.privInitializeDeferral, this.privInitializeDeferral = null), yield this.destroyAudioContext();
        });
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.getMicrophoneLabel().then((e)=>({
                bitspersample: $d7238066c5de7f1c$var$Ge.AUDIOFORMAT.bitsPerSample,
                channelcount: $d7238066c5de7f1c$var$Ge.AUDIOFORMAT.channels,
                connectivity: $d7238066c5de7f1c$var$Ri.Unknown,
                manufacturer: "Speech SDK",
                model: e,
                samplerate: $d7238066c5de7f1c$var$Ge.AUDIOFORMAT.samplesPerSec,
                type: $d7238066c5de7f1c$var$Qt.Microphones
            }));
    }
    setProperty(e, t) {
        if (e === $d7238066c5de7f1c$var$Zd) this.privRecorder.setWorkletUrl(t);
        else throw new Error("Property '" + e + "' is not supported on Microphone.");
    }
    getMicrophoneLabel() {
        const e = "microphone";
        if (this.privMicrophoneLabel !== void 0) return Promise.resolve(this.privMicrophoneLabel);
        if (this.privMediaStream === void 0 || !this.privMediaStream.active) return Promise.resolve(e);
        this.privMicrophoneLabel = e;
        const t = this.privMediaStream.getTracks()[0].getSettings().deviceId;
        if (t === void 0) return Promise.resolve(this.privMicrophoneLabel);
        const i = new $d7238066c5de7f1c$var$F();
        return navigator.mediaDevices.enumerateDevices().then((n)=>{
            for (const s of n)if (s.deviceId === t) {
                this.privMicrophoneLabel = s.label;
                break;
            }
            i.resolve(this.privMicrophoneLabel);
        }, ()=>i.resolve(this.privMicrophoneLabel)), i.promise;
    }
    listen(e) {
        return $d7238066c5de7f1c$var$br(this, void 0, void 0, function*() {
            yield this.turnOn();
            const t = new $d7238066c5de7f1c$var$wo(this.privOutputChunkSize, e);
            this.privStreams[e] = t;
            try {
                this.privRecorder.record(this.privContext, this.privMediaStream, t);
            } catch (n) {
                throw this.onEvent(new $d7238066c5de7f1c$var$So(this.privId, e, n)), n;
            }
            return t;
        });
    }
    onEvent(e) {
        this.privEvents.onEvent(e), $d7238066c5de7f1c$var$oe.instance.onEvent(e);
    }
    createAudioContext() {
        this.privContext || (this.privContext = $d7238066c5de7f1c$var$wt.getAudioContext($d7238066c5de7f1c$var$Ge.AUDIOFORMAT.samplesPerSec));
    }
    destroyAudioContext() {
        return $d7238066c5de7f1c$var$br(this, void 0, void 0, function*() {
            if (!this.privContext) return;
            this.privRecorder.releaseMediaResources(this.privContext);
            let e = !1;
            "close" in this.privContext && (e = !0), e ? this.privIsClosing || (this.privIsClosing = !0, yield this.privContext.close(), this.privContext = null, this.privIsClosing = !1) : this.privContext !== null && this.privContext.state === "running" && (yield this.privContext.suspend());
        });
    }
}
$d7238066c5de7f1c$var$Ge.AUDIOFORMAT = $d7238066c5de7f1c$var$bi.getDefaultInputFormat();
var $d7238066c5de7f1c$var$Wn = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Xd {
    constructor(e, t, i){
        this.privStreams = {}, this.privHeaderEnd = 44, this.privId = i || $d7238066c5de7f1c$var$ee(), this.privEvents = new $d7238066c5de7f1c$var$Ze(), this.privSource = e, typeof window < "u" && typeof Blob < "u" && this.privSource instanceof Blob ? this.privFilename = e.name : this.privFilename = t || "unknown.wav", this.privAudioFormatPromise = this.readHeader();
    }
    get format() {
        return this.privAudioFormatPromise;
    }
    turnOn() {
        if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
            const e = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
            return this.onEvent(new $d7238066c5de7f1c$var$Yr(e, "")), Promise.reject(e);
        }
        this.onEvent(new $d7238066c5de7f1c$var$un(this.privId)), this.onEvent(new $d7238066c5de7f1c$var$Gi(this.privId));
    }
    id() {
        return this.privId;
    }
    attach(e) {
        return $d7238066c5de7f1c$var$Wn(this, void 0, void 0, function*() {
            this.onEvent(new $d7238066c5de7f1c$var$pr(this.privId, e));
            const t = yield this.upload(e);
            return this.onEvent(new $d7238066c5de7f1c$var$hr(this.privId, e)), Promise.resolve({
                detach: ()=>$d7238066c5de7f1c$var$Wn(this, void 0, void 0, function*() {
                        t.readEnded(), delete this.privStreams[e], this.onEvent(new $d7238066c5de7f1c$var$Pt(this.privId, e)), yield this.turnOff();
                    }),
                id: ()=>e,
                read: ()=>t.read()
            });
        });
    }
    detach(e) {
        e && this.privStreams[e] && (this.privStreams[e].close(), delete this.privStreams[e], this.onEvent(new $d7238066c5de7f1c$var$Pt(this.privId, e)));
    }
    turnOff() {
        for(const e in this.privStreams)if (e) {
            const t = this.privStreams[e];
            t && !t.isClosed && t.close();
        }
        return this.onEvent(new $d7238066c5de7f1c$var$kp(this.privId)), Promise.resolve();
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.privAudioFormatPromise.then((e)=>Promise.resolve({
                bitspersample: e.bitsPerSample,
                channelcount: e.channels,
                connectivity: $d7238066c5de7f1c$var$Ri.Unknown,
                manufacturer: "Speech SDK",
                model: "File",
                samplerate: e.samplesPerSec,
                type: $d7238066c5de7f1c$var$Qt.File
            }));
    }
    readHeader() {
        const t = this.privSource.slice(0, 4296), i = new $d7238066c5de7f1c$var$F(), n = (s)=>{
            const o = new DataView(s), c = (g)=>String.fromCharCode(o.getUint8(g), o.getUint8(g + 1), o.getUint8(g + 2), o.getUint8(g + 3));
            if (c(0) !== "RIFF") {
                i.reject("Invalid WAV header in file, RIFF was not found");
                return;
            }
            if (c(8) !== "WAVE" || c(12) !== "fmt ") {
                i.reject("Invalid WAV header in file, WAVEfmt was not found");
                return;
            }
            const p = o.getInt32(16, !0), h = o.getUint16(22, !0), a = o.getUint32(24, !0), d = o.getUint16(34, !0);
            let v = 36 + Math.max(p - 16, 0);
            for(; c(v) !== "data"; v += 2)if (v > 4288) {
                i.reject("Invalid WAV header in file, data block was not found");
                return;
            }
            this.privHeaderEnd = v + 8, i.resolve($d7238066c5de7f1c$var$bi.getWaveFormatPCM(a, d, h));
        };
        if (typeof window < "u" && typeof Blob < "u" && t instanceof Blob) {
            const s = new FileReader();
            s.onload = (o)=>{
                const c = o.target.result;
                n(c);
            }, s.readAsArrayBuffer(t);
        } else {
            const s = t;
            n(s.buffer.slice(s.byteOffset, s.byteOffset + s.byteLength));
        }
        return i.promise;
    }
    upload(e) {
        return $d7238066c5de7f1c$var$Wn(this, void 0, void 0, function*() {
            const t = (i)=>{
                const n = `Error occurred while processing '${this.privFilename}'. ${i}`;
                throw this.onEvent(new $d7238066c5de7f1c$var$So(this.privId, e, n)), new Error(n);
            };
            try {
                yield this.turnOn();
                const i = yield this.privAudioFormatPromise, n = new $d7238066c5de7f1c$var$wo(i.avgBytesPerSec / 10, e);
                this.privStreams[e] = n;
                const s = this.privSource.slice(this.privHeaderEnd), o = (c)=>{
                    n.isClosed || (n.writeStreamChunk({
                        buffer: c,
                        isEnd: !1,
                        timeReceived: Date.now()
                    }), n.close());
                };
                if (typeof window < "u" && typeof Blob < "u" && s instanceof Blob) {
                    const c = new FileReader();
                    c.onerror = (p)=>t(p.toString()), c.onload = (p)=>{
                        const h = p.target.result;
                        o(h);
                    }, c.readAsArrayBuffer(s);
                } else {
                    const c = s;
                    o(c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength));
                }
                return n;
            } catch (i) {
                t(i);
            }
        });
    }
    onEvent(e) {
        this.privEvents.onEvent(e), $d7238066c5de7f1c$var$oe.instance.onEvent(e);
    }
}

class $d7238066c5de7f1c$var$Hn {
    constructor(e){
        this.privStopInputOnRelease = e;
    }
    record(e, t, i) {
        const s = new $d7238066c5de7f1c$var$Gd(e.sampleRate, 16e3), o = e.createMediaStreamSource(t), c = ()=>{
            const a = (()=>{
                let d = 0;
                try {
                    return e.createScriptProcessor(d, 1, 1);
                } catch  {
                    d = 2048;
                    let g = e.sampleRate;
                    for(; d < 16384 && g >= 32e3;)d <<= 1, g >>= 1;
                    return e.createScriptProcessor(d, 1, 1);
                }
            })();
            a.onaudioprocess = (d)=>{
                const v = d.inputBuffer.getChannelData(0);
                if (i && !i.isClosed) {
                    const g = s.encode(v);
                    g && i.writeStreamChunk({
                        buffer: g,
                        isEnd: !1,
                        timeReceived: Date.now()
                    });
                }
            }, o.connect(a), a.connect(e.destination), this.privMediaResources = {
                scriptProcessorNode: a,
                source: o,
                stream: t
            };
        }, p = (a)=>{
            const d = new AudioWorkletNode(a, "speech-processor");
            d.port.onmessage = (v)=>{
                const g = v.data;
                if (i && !i.isClosed) {
                    const I = s.encode(g);
                    I && i.writeStreamChunk({
                        buffer: I,
                        isEnd: !1,
                        timeReceived: Date.now()
                    });
                }
            }, o.connect(d), d.connect(a.destination), this.privMediaResources = {
                scriptProcessorNode: d,
                source: o,
                stream: t
            };
        }, h = !!this.privSpeechProcessorScript && this.privSpeechProcessorScript.toLowerCase() === "ignore";
        if (e.audioWorklet && !h) this.privSpeechProcessorScript = new URL((parcelRequire("9HfWD"))).toString(), e.audioWorklet.addModule(this.privSpeechProcessorScript).then(()=>{
            p(e);
        }).catch(()=>{
            const a = `class SP extends AudioWorkletProcessor {
                        constructor(options) {
                        super(options);
                        }
                        process(inputs, outputs) {
                        const input = inputs[0];
                        const output = [];
                        for (let channel = 0; channel < input.length; channel += 1) {
                            output[channel] = input[channel];
                        }
                        this.port.postMessage(output[0]);
                        return true;
                        }
                    }
                    registerProcessor('speech-processor', SP);`, d = new Blob([
                a
            ], {
                type: "application/javascript; charset=utf-8"
            });
            this.privSpeechProcessorScript = URL.createObjectURL(d), e.audioWorklet.addModule(this.privSpeechProcessorScript).then(()=>{
                p(e);
            }).catch(()=>{
                c();
            });
        });
        else try {
            c();
        } catch (a) {
            throw new Error(`Unable to start audio worklet node for PCMRecorder: ${a}`);
        }
    }
    releaseMediaResources(e) {
        this.privMediaResources && (this.privMediaResources.scriptProcessorNode && (this.privMediaResources.scriptProcessorNode.disconnect(e.destination), this.privMediaResources.scriptProcessorNode = null), this.privMediaResources.source && (this.privMediaResources.source.disconnect(), this.privStopInputOnRelease && this.privMediaResources.stream.getTracks().forEach((t)=>t.stop()), this.privMediaResources.source = null));
    }
    setWorkletUrl(e) {
        this.privSpeechProcessorScript = e;
    }
}
var $d7238066c5de7f1c$var$qa = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Xi {
    constructor(e, t, i, n, s, o){
        if (!e) throw new $d7238066c5de7f1c$var$le("uri");
        if (!i) throw new $d7238066c5de7f1c$var$le("messageFormatter");
        this.proxyInfo = n, this.privConnectionEvents = new $d7238066c5de7f1c$var$Ze(), this.privConnectionId = t, this.privMessageFormatter = i, this.privConnectionState = $d7238066c5de7f1c$var$pe.None, this.privUri = e, this.privHeaders = s, this.privEnableCompression = o, this.privHeaders[$d7238066c5de7f1c$var$W.ConnectionId] = this.privConnectionId, this.privLastErrorReceived = "";
    }
    get state() {
        return this.privConnectionState;
    }
    open() {
        if (this.privConnectionState === $d7238066c5de7f1c$var$pe.Disconnected) return Promise.reject(`Cannot open a connection that is in ${this.privConnectionState} state`);
        if (this.privConnectionEstablishDeferral) return this.privConnectionEstablishDeferral.promise;
        this.privConnectionEstablishDeferral = new $d7238066c5de7f1c$var$F(), this.privCertificateValidatedDeferral = new $d7238066c5de7f1c$var$F(), this.privConnectionState = $d7238066c5de7f1c$var$pe.Connecting;
        try {
            if (typeof WebSocket < "u" && !$d7238066c5de7f1c$var$Xi.forceNpmWebSocket) this.privCertificateValidatedDeferral.resolve(), this.privWebsocketClient = new WebSocket(this.privUri);
            else {
                const e = {
                    headers: this.privHeaders,
                    perMessageDeflate: this.privEnableCompression
                };
                this.privCertificateValidatedDeferral.resolve(), e.agent = this.getAgent();
                let i = new URL(this.privUri).protocol;
                (i == null ? void 0 : i.toLocaleLowerCase()) === "wss:" ? i = "https:" : (i == null ? void 0 : i.toLocaleLowerCase()) === "ws:" && (i = "http:"), e.agent.protocol = i, this.privWebsocketClient = new $d7238066c5de7f1c$var$qn(this.privUri, e);
            }
            this.privWebsocketClient.binaryType = "arraybuffer", this.privReceivingMessageQueue = new $d7238066c5de7f1c$var$Qi(), this.privDisconnectDeferral = new $d7238066c5de7f1c$var$F(), this.privSendMessageQueue = new $d7238066c5de7f1c$var$Qi(), this.processSendQueue().catch((e)=>{
                $d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$Ct(e));
            });
        } catch (e) {
            return this.privConnectionEstablishDeferral.resolve(new $d7238066c5de7f1c$var$Un(500, e)), this.privConnectionEstablishDeferral.promise;
        }
        return this.onEvent(new $d7238066c5de7f1c$var$Dp(this.privConnectionId, this.privUri)), this.privWebsocketClient.onopen = ()=>{
            this.privCertificateValidatedDeferral.promise.then(()=>{
                this.privConnectionState = $d7238066c5de7f1c$var$pe.Connected, this.onEvent(new $d7238066c5de7f1c$var$Op(this.privConnectionId)), this.privConnectionEstablishDeferral.resolve(new $d7238066c5de7f1c$var$Un(200, ""));
            }, (e)=>{
                this.privConnectionEstablishDeferral.reject(e);
            });
        }, this.privWebsocketClient.onerror = (e)=>{
            this.onEvent(new $d7238066c5de7f1c$var$Hd(this.privConnectionId, e.message, e.type)), this.privLastErrorReceived = e.message;
        }, this.privWebsocketClient.onclose = (e)=>{
            this.privConnectionState === $d7238066c5de7f1c$var$pe.Connecting ? (this.privConnectionState = $d7238066c5de7f1c$var$pe.Disconnected, this.privConnectionEstablishDeferral.resolve(new $d7238066c5de7f1c$var$Un(e.code, e.reason + " " + this.privLastErrorReceived))) : (this.privConnectionState = $d7238066c5de7f1c$var$pe.Disconnected, this.privWebsocketClient = null, this.onEvent(new $d7238066c5de7f1c$var$Wd(this.privConnectionId, e.code, e.reason))), this.onClose(e.code, e.reason).catch((t)=>{
                $d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$Ct(t));
            });
        }, this.privWebsocketClient.onmessage = (e)=>{
            const t = /* @__PURE__ */ new Date().toISOString();
            if (this.privConnectionState === $d7238066c5de7f1c$var$pe.Connected) {
                const i = new $d7238066c5de7f1c$var$F();
                if (this.privReceivingMessageQueue.enqueueFromPromise(i.promise), e.data instanceof ArrayBuffer) {
                    const n = new $d7238066c5de7f1c$var$Yi($d7238066c5de7f1c$var$k.Binary, e.data);
                    this.privMessageFormatter.toConnectionMessage(n).then((s)=>{
                        this.onEvent(new $d7238066c5de7f1c$var$Ns(this.privConnectionId, t, s)), i.resolve(s);
                    }, (s)=>{
                        i.reject(`Invalid binary message format. Error: ${s}`);
                    });
                } else {
                    const n = new $d7238066c5de7f1c$var$Yi($d7238066c5de7f1c$var$k.Text, e.data);
                    this.privMessageFormatter.toConnectionMessage(n).then((s)=>{
                        this.onEvent(new $d7238066c5de7f1c$var$Ns(this.privConnectionId, t, s)), i.resolve(s);
                    }, (s)=>{
                        i.reject(`Invalid text message format. Error: ${s}`);
                    });
                }
            }
        }, this.privConnectionEstablishDeferral.promise;
    }
    send(e) {
        if (this.privConnectionState !== $d7238066c5de7f1c$var$pe.Connected) return Promise.reject(`Cannot send on connection that is in ${$d7238066c5de7f1c$var$pe[this.privConnectionState]} state`);
        const t = new $d7238066c5de7f1c$var$F(), i = new $d7238066c5de7f1c$var$F();
        return this.privSendMessageQueue.enqueueFromPromise(i.promise), this.privMessageFormatter.fromConnectionMessage(e).then((n)=>{
            i.resolve({
                Message: e,
                RawWebsocketMessage: n,
                sendStatusDeferral: t
            });
        }, (n)=>{
            i.reject(`Error formatting the message. ${n}`);
        }), t.promise;
    }
    read() {
        return this.privConnectionState !== $d7238066c5de7f1c$var$pe.Connected ? Promise.reject(`Cannot read on connection that is in ${this.privConnectionState} state`) : this.privReceivingMessageQueue.dequeue();
    }
    close(e) {
        if (this.privWebsocketClient) this.privConnectionState !== $d7238066c5de7f1c$var$pe.Disconnected && this.privWebsocketClient.close(1e3, e || "Normal closure by client");
        else return Promise.resolve();
        return this.privDisconnectDeferral.promise;
    }
    get events() {
        return this.privConnectionEvents;
    }
    sendRawMessage(e) {
        try {
            if (!e) return Promise.resolve();
            if (this.onEvent(new $d7238066c5de7f1c$var$Vd(this.privConnectionId, /* @__PURE__ */ new Date().toISOString(), e.Message)), this.isWebsocketOpen) this.privWebsocketClient.send(e.RawWebsocketMessage.payload);
            else return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + e.Message.id + " " + new Error().stack);
            return Promise.resolve();
        } catch (t) {
            return Promise.reject(`websocket send error: ${t}`);
        }
    }
    onClose(e, t) {
        return $d7238066c5de7f1c$var$qa(this, void 0, void 0, function*() {
            const i = `Connection closed. ${e}: ${t}`;
            this.privConnectionState = $d7238066c5de7f1c$var$pe.Disconnected, this.privDisconnectDeferral.resolve(), yield this.privReceivingMessageQueue.drainAndDispose(()=>{}, i), yield this.privSendMessageQueue.drainAndDispose((n)=>{
                n.sendStatusDeferral.reject(i);
            }, i);
        });
    }
    processSendQueue() {
        return $d7238066c5de7f1c$var$qa(this, void 0, void 0, function*() {
            for(;;){
                const t = yield this.privSendMessageQueue.dequeue();
                if (!t) return;
                try {
                    yield this.sendRawMessage(t), t.sendStatusDeferral.resolve();
                } catch (i) {
                    t.sendStatusDeferral.reject(i);
                }
            }
        });
    }
    onEvent(e) {
        this.privConnectionEvents.onEvent(e), $d7238066c5de7f1c$var$oe.instance.onEvent(e);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAgent() {
        const e = new $d7238066c5de7f1c$var$qn.Agent(this.createConnection);
        return this.proxyInfo !== void 0 && this.proxyInfo.HostName !== void 0 && this.proxyInfo.Port > 0 && (e.proxyInfo = this.proxyInfo), e;
    }
    static GetProxyAgent(e) {
        const t = {
            host: e.HostName,
            port: e.Port
        };
        return e.UserName ? t.headers = {
            "Proxy-Authentication": "Basic " + new $d7238066c5de7f1c$require$Buffer(`${e.UserName}:${e.Password === void 0 ? "" : e.Password}`).toString("base64")
        } : t.headers = {}, t.headers.requestOCSP = "true", new $d7238066c5de7f1c$var$qn(t);
    }
    createConnection(e, t) {
        let i;
        if (t = Object.assign(Object.assign({}, t), {
            requestOCSP: !0,
            servername: t.host
        }), this.proxyInfo) {
            const s = $d7238066c5de7f1c$var$Xi.GetProxyAgent(this.proxyInfo);
            i = new Promise((o, c)=>{
                s.callback(e, t, (p, h)=>{
                    p ? c(p) : o(h);
                });
            });
        } else t.secureEndpoint, i = Promise.resolve((void 0)(t));
        return i;
    }
    get isWebsocketOpen() {
        return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
    }
}
$d7238066c5de7f1c$var$Xi.forceNpmWebSocket = !1;
var $d7238066c5de7f1c$var$el = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$ut {
    constructor(e, t, i, n, s, o = !1, c){
        if (this.privIsDisposed = !1, !e) throw new $d7238066c5de7f1c$var$le("uri");
        if (!n) throw new $d7238066c5de7f1c$var$le("messageFormatter");
        this.privMessageFormatter = n;
        let p = "", h = 0;
        if (t) {
            for(const a in t)if (a) {
                p += h === 0 && e.indexOf("?") === -1 ? "?" : "&";
                const d = encodeURIComponent(a);
                p += d;
                let v = t[a];
                v && (v = encodeURIComponent(v), p += `=${v}`), h++;
            }
        }
        if (i) {
            for(const a in i)if (a) {
                p += h === 0 && e.indexOf("?") === -1 ? "?" : "&";
                const d = encodeURIComponent(i[a]);
                p += `${a}=${d}`, h++;
            }
        }
        this.privUri = e + p, this.privId = c || $d7238066c5de7f1c$var$ee(), this.privConnectionMessageAdapter = new $d7238066c5de7f1c$var$Xi(this.privUri, this.id, this.privMessageFormatter, s, i, o);
    }
    dispose() {
        return $d7238066c5de7f1c$var$el(this, void 0, void 0, function*() {
            this.privIsDisposed = !0, this.privConnectionMessageAdapter && (yield this.privConnectionMessageAdapter.close());
        });
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    get id() {
        return this.privId;
    }
    get uri() {
        return this.privUri;
    }
    state() {
        return this.privConnectionMessageAdapter.state;
    }
    open() {
        return this.privConnectionMessageAdapter.open();
    }
    send(e) {
        return this.privConnectionMessageAdapter.send(e);
    }
    read() {
        return this.privConnectionMessageAdapter.read();
    }
    get events() {
        return this.privConnectionMessageAdapter.events;
    }
}
class $d7238066c5de7f1c$var$ln {
    constructor(e, t){
        this.privBuffers = [], this.privReplayOffset = 0, this.privLastShrinkOffset = 0, this.privBufferStartOffset = 0, this.privBufferSerial = 0, this.privBufferedBytes = 0, this.privReplay = !1, this.privLastChunkAcquiredTime = 0, this.privAudioNode = e, this.privBytesPerSecond = t;
    }
    id() {
        return this.privAudioNode.id();
    }
    // Reads and returns the next chunk of audio buffer.
    // If replay of existing buffers are needed, read() will first seek and replay
    // existing content, and upoin completion it will read new content from the underlying
    // audio node, saving that content into the replayable buffers.
    read() {
        if (this.privReplay && this.privBuffers.length !== 0) {
            const e = this.privReplayOffset - this.privBufferStartOffset;
            let t = Math.round(e * this.privBytesPerSecond * 1e-7);
            t % 2 !== 0 && t++;
            let i = 0;
            for(; i < this.privBuffers.length && t >= this.privBuffers[i].chunk.buffer.byteLength;)t -= this.privBuffers[i++].chunk.buffer.byteLength;
            if (i < this.privBuffers.length) {
                const n = this.privBuffers[i].chunk.buffer.slice(t);
                return this.privReplayOffset += n.byteLength / this.privBytesPerSecond * 1e7, i === this.privBuffers.length - 1 && (this.privReplay = !1), Promise.resolve({
                    buffer: n,
                    isEnd: !1,
                    timeReceived: this.privBuffers[i].chunk.timeReceived
                });
            }
        }
        return this.privAudioNode.read().then((e)=>(e && e.buffer && (this.privBuffers.push(new $d7238066c5de7f1c$var$tl(e, this.privBufferSerial++, this.privBufferedBytes)), this.privBufferedBytes += e.buffer.byteLength), e));
    }
    detach() {
        return this.privBuffers = void 0, this.privAudioNode.detach();
    }
    replay() {
        this.privBuffers && this.privBuffers.length !== 0 && (this.privReplay = !0, this.privReplayOffset = this.privLastShrinkOffset);
    }
    // Shrinks the existing audio buffers to start at the new offset, or at the
    // beginning of the buffer closest to the requested offset.
    // A replay request will start from the last shrink point.
    shrinkBuffers(e) {
        if (this.privBuffers === void 0 || this.privBuffers.length === 0) return;
        this.privLastShrinkOffset = e;
        const t = e - this.privBufferStartOffset;
        let i = Math.round(t * this.privBytesPerSecond * 1e-7), n = 0;
        for(; n < this.privBuffers.length && i >= this.privBuffers[n].chunk.buffer.byteLength;)i -= this.privBuffers[n++].chunk.buffer.byteLength;
        this.privBufferStartOffset = Math.round(e - i / this.privBytesPerSecond * 1e7), this.privBuffers = this.privBuffers.slice(n);
    }
    // Finds the time a buffer of audio was first seen by offset.
    findTimeAtOffset(e) {
        if (e < this.privBufferStartOffset || this.privBuffers === void 0) return 0;
        for (const t of this.privBuffers){
            const i = t.byteOffset / this.privBytesPerSecond * 1e7, n = i + t.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
            if (e >= i && e <= n) return t.chunk.timeReceived;
        }
        return 0;
    }
}
class $d7238066c5de7f1c$var$tl {
    constructor(e, t, i){
        this.chunk = e, this.serial = t, this.byteOffset = i;
    }
}
class $d7238066c5de7f1c$var$Mp {
    constructor(e){
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(void 0, `
File System access not available, please use Push or PullAudioOutputStream`), this.privFd = (void 0)(e, "w");
    }
    set format(e) {
        $d7238066c5de7f1c$var$l.throwIfNotUndefined(this.privAudioFormat, "format is already set"), this.privAudioFormat = e;
        let t = 0;
        this.privAudioFormat.hasHeader && (t = this.privAudioFormat.header.byteLength), this.privFd !== void 0 && (this.privWriteStream = (void 0)("", {
            fd: this.privFd,
            start: t,
            autoClose: !1
        }));
    }
    write(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing."), this.privWriteStream !== void 0 && this.privWriteStream.write(new Uint8Array(e.slice(0)));
    }
    close() {
        this.privFd !== void 0 && (this.privWriteStream.on("finish", ()=>{
            this.privAudioFormat.hasHeader && (this.privAudioFormat.updateHeader(this.privWriteStream.bytesWritten), (void 0)(this.privFd, new Int8Array(this.privAudioFormat.header), 0, this.privAudioFormat.header.byteLength, 0)), (void 0)(this.privFd), this.privFd = void 0;
        }), this.privWriteStream.end());
    }
    id() {
        return this.privId;
    }
}
var $d7238066c5de7f1c$var$xs = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$ur {
    /**
   * Creates and initializes an instance.
   * @constructor
   */ constructor(){}
    /**
   * Creates a memory backed PushAudioInputStream with the specified audio format.
   * @member AudioInputStream.createPushStream
   * @function
   * @public
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   * written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PushAudioInputStream} The audio input stream being created.
   */ static createPushStream(e) {
        return $d7238066c5de7f1c$var$Ro.create(e);
    }
    /**
   * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
   * and close() methods.
   * @member AudioInputStream.createPullStream
   * @function
   * @public
   * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
   * PullAudioInputStreamCallback
   * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
   * the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PullAudioInputStream} The audio input stream being created.
   */ static createPullStream(e, t) {
        return $d7238066c5de7f1c$var$Io.create(e, t);
    }
}
class $d7238066c5de7f1c$var$Ro extends $d7238066c5de7f1c$var$ur {
    /**
   * Creates a memory backed PushAudioInputStream with the specified audio format.
   * @member PushAudioInputStream.create
   * @function
   * @public
   * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
   * push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PushAudioInputStream} The push audio input stream being created.
   */ static create(e) {
        return new $d7238066c5de7f1c$var$il(e);
    }
}
class $d7238066c5de7f1c$var$il extends $d7238066c5de7f1c$var$Ro {
    /**
   * Creates and initalizes an instance with the given values.
   * @constructor
   * @param {AudioStreamFormat} format - The audio stream format.
   */ constructor(e){
        super(), e === void 0 ? this.privFormat = $d7238066c5de7f1c$var$wt.getDefaultInputFormat() : this.privFormat = e, this.privEvents = new $d7238066c5de7f1c$var$Ze(), this.privId = $d7238066c5de7f1c$var$ee(), this.privStream = new $d7238066c5de7f1c$var$wo(this.privFormat.avgBytesPerSec / 10);
    }
    /**
   * Format information for the audio
   */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
   * Writes the audio data specified by making an internal copy of the data.
   * @member PushAudioInputStreamImpl.prototype.write
   * @function
   * @public
   * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
   */ write(e) {
        this.privStream.writeStreamChunk({
            buffer: e,
            isEnd: !1,
            timeReceived: Date.now()
        });
    }
    /**
   * Closes the stream.
   * @member PushAudioInputStreamImpl.prototype.close
   * @function
   * @public
   */ close() {
        this.privStream.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new $d7238066c5de7f1c$var$un(this.privId)), this.onEvent(new $d7238066c5de7f1c$var$Gi(this.privId));
    }
    attach(e) {
        return $d7238066c5de7f1c$var$xs(this, void 0, void 0, function*() {
            this.onEvent(new $d7238066c5de7f1c$var$pr(this.privId, e)), yield this.turnOn();
            const t = this.privStream;
            return this.onEvent(new $d7238066c5de7f1c$var$hr(this.privId, e)), {
                detach: ()=>$d7238066c5de7f1c$var$xs(this, void 0, void 0, function*() {
                        return this.onEvent(new $d7238066c5de7f1c$var$Pt(this.privId, e)), this.turnOff();
                    }),
                id: ()=>e,
                read: ()=>t.read()
            };
        });
    }
    detach(e) {
        this.onEvent(new $d7238066c5de7f1c$var$Pt(this.privId, e));
    }
    turnOff() {}
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: $d7238066c5de7f1c$var$Ri.Unknown,
            manufacturer: "Speech SDK",
            model: "PushStream",
            samplerate: this.privFormat.samplesPerSec,
            type: $d7238066c5de7f1c$var$Qt.Stream
        });
    }
    onEvent(e) {
        this.privEvents.onEvent(e), $d7238066c5de7f1c$var$oe.instance.onEvent(e);
    }
    toBuffer(e) {
        const t = $d7238066c5de7f1c$require$Buffer.alloc(e.byteLength), i = new Uint8Array(e);
        for(let n = 0; n < t.length; ++n)t[n] = i[n];
        return t;
    }
}
class $d7238066c5de7f1c$var$Io extends $d7238066c5de7f1c$var$ur {
    /**
   * Creates and initializes and instance.
   * @constructor
   */ constructor(){
        super();
    }
    /**
   * Creates a PullAudioInputStream that delegates to the specified callback interface for
   * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
   * @member PullAudioInputStream.create
   * @function
   * @public
   * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
   * derived from PullAudioInputStreamCustomCallback
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PullAudioInputStream} The push audio input stream being created.
   */ static create(e, t) {
        return new $d7238066c5de7f1c$var$xp(e, t);
    }
}
class $d7238066c5de7f1c$var$xp extends $d7238066c5de7f1c$var$Io {
    /**
   * Creates a PullAudioInputStream that delegates to the specified callback interface for
   * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
   * @constructor
   * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
   * derived from PullAudioInputStreamCustomCallback
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
   */ constructor(e, t){
        super(), t === void 0 ? this.privFormat = $d7238066c5de7f1c$var$bi.getDefaultInputFormat() : this.privFormat = t, this.privEvents = new $d7238066c5de7f1c$var$Ze(), this.privId = $d7238066c5de7f1c$var$ee(), this.privCallback = e, this.privIsClosed = !1, this.privBufferSize = this.privFormat.avgBytesPerSec / 10;
    }
    /**
   * Format information for the audio
   */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
   * Closes the stream.
   * @member PullAudioInputStreamImpl.prototype.close
   * @function
   * @public
   */ close() {
        this.privIsClosed = !0, this.privCallback.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new $d7238066c5de7f1c$var$un(this.privId)), this.onEvent(new $d7238066c5de7f1c$var$Gi(this.privId));
    }
    attach(e) {
        return $d7238066c5de7f1c$var$xs(this, void 0, void 0, function*() {
            return this.onEvent(new $d7238066c5de7f1c$var$pr(this.privId, e)), yield this.turnOn(), this.onEvent(new $d7238066c5de7f1c$var$hr(this.privId, e)), {
                detach: ()=>(this.privCallback.close(), this.onEvent(new $d7238066c5de7f1c$var$Pt(this.privId, e)), this.turnOff()),
                id: ()=>e,
                read: ()=>{
                    let t = 0, i;
                    for(; t < this.privBufferSize;){
                        const n = new ArrayBuffer(this.privBufferSize - t), s = this.privCallback.read(n);
                        if (i === void 0 ? i = n : new Int8Array(i).set(new Int8Array(n), t), s === 0) break;
                        t += s;
                    }
                    return Promise.resolve({
                        buffer: i.slice(0, t),
                        isEnd: this.privIsClosed || t === 0,
                        timeReceived: Date.now()
                    });
                }
            };
        });
    }
    detach(e) {
        this.onEvent(new $d7238066c5de7f1c$var$Pt(this.privId, e));
    }
    turnOff() {}
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: $d7238066c5de7f1c$var$Ri.Unknown,
            manufacturer: "Speech SDK",
            model: "PullStream",
            samplerate: this.privFormat.samplesPerSec,
            type: $d7238066c5de7f1c$var$Qt.Stream
        });
    }
    onEvent(e) {
        this.privEvents.onEvent(e), $d7238066c5de7f1c$var$oe.instance.onEvent(e);
    }
}
var $d7238066c5de7f1c$var$M;
(function(r) {
    r[r.Raw8Khz8BitMonoMULaw = 0] = "Raw8Khz8BitMonoMULaw", r[r.Riff16Khz16KbpsMonoSiren = 1] = "Riff16Khz16KbpsMonoSiren", r[r.Audio16Khz16KbpsMonoSiren = 2] = "Audio16Khz16KbpsMonoSiren", r[r.Audio16Khz32KBitRateMonoMp3 = 3] = "Audio16Khz32KBitRateMonoMp3", r[r.Audio16Khz128KBitRateMonoMp3 = 4] = "Audio16Khz128KBitRateMonoMp3", r[r.Audio16Khz64KBitRateMonoMp3 = 5] = "Audio16Khz64KBitRateMonoMp3", r[r.Audio24Khz48KBitRateMonoMp3 = 6] = "Audio24Khz48KBitRateMonoMp3", r[r.Audio24Khz96KBitRateMonoMp3 = 7] = "Audio24Khz96KBitRateMonoMp3", r[r.Audio24Khz160KBitRateMonoMp3 = 8] = "Audio24Khz160KBitRateMonoMp3", r[r.Raw16Khz16BitMonoTrueSilk = 9] = "Raw16Khz16BitMonoTrueSilk", r[r.Riff16Khz16BitMonoPcm = 10] = "Riff16Khz16BitMonoPcm", r[r.Riff8Khz16BitMonoPcm = 11] = "Riff8Khz16BitMonoPcm", r[r.Riff24Khz16BitMonoPcm = 12] = "Riff24Khz16BitMonoPcm", r[r.Riff8Khz8BitMonoMULaw = 13] = "Riff8Khz8BitMonoMULaw", r[r.Raw16Khz16BitMonoPcm = 14] = "Raw16Khz16BitMonoPcm", r[r.Raw24Khz16BitMonoPcm = 15] = "Raw24Khz16BitMonoPcm", r[r.Raw8Khz16BitMonoPcm = 16] = "Raw8Khz16BitMonoPcm", r[r.Ogg16Khz16BitMonoOpus = 17] = "Ogg16Khz16BitMonoOpus", r[r.Ogg24Khz16BitMonoOpus = 18] = "Ogg24Khz16BitMonoOpus", r[r.Raw48Khz16BitMonoPcm = 19] = "Raw48Khz16BitMonoPcm", r[r.Riff48Khz16BitMonoPcm = 20] = "Riff48Khz16BitMonoPcm", r[r.Audio48Khz96KBitRateMonoMp3 = 21] = "Audio48Khz96KBitRateMonoMp3", r[r.Audio48Khz192KBitRateMonoMp3 = 22] = "Audio48Khz192KBitRateMonoMp3", r[r.Ogg48Khz16BitMonoOpus = 23] = "Ogg48Khz16BitMonoOpus", r[r.Webm16Khz16BitMonoOpus = 24] = "Webm16Khz16BitMonoOpus", r[r.Webm24Khz16BitMonoOpus = 25] = "Webm24Khz16BitMonoOpus", r[r.Raw24Khz16BitMonoTrueSilk = 26] = "Raw24Khz16BitMonoTrueSilk", r[r.Raw8Khz8BitMonoALaw = 27] = "Raw8Khz8BitMonoALaw", r[r.Riff8Khz8BitMonoALaw = 28] = "Riff8Khz8BitMonoALaw", r[r.Webm24Khz16Bit24KbpsMonoOpus = 29] = "Webm24Khz16Bit24KbpsMonoOpus", r[r.Audio16Khz16Bit32KbpsMonoOpus = 30] = "Audio16Khz16Bit32KbpsMonoOpus", r[r.Audio24Khz16Bit48KbpsMonoOpus = 31] = "Audio24Khz16Bit48KbpsMonoOpus", r[r.Audio24Khz16Bit24KbpsMonoOpus = 32] = "Audio24Khz16Bit24KbpsMonoOpus", r[r.Raw22050Hz16BitMonoPcm = 33] = "Raw22050Hz16BitMonoPcm", r[r.Riff22050Hz16BitMonoPcm = 34] = "Riff22050Hz16BitMonoPcm", r[r.Raw44100Hz16BitMonoPcm = 35] = "Raw44100Hz16BitMonoPcm", r[r.Riff44100Hz16BitMonoPcm = 36] = "Riff44100Hz16BitMonoPcm";
})($d7238066c5de7f1c$var$M || ($d7238066c5de7f1c$var$M = {}));
class $d7238066c5de7f1c$var$O extends $d7238066c5de7f1c$var$wt {
    /**
   * Creates an instance with the given values.
   * @constructor
   * @param formatTag
   * @param {number} channels - Number of channels.
   * @param {number} samplesPerSec - Samples per second.
   * @param {number} avgBytesPerSec - Average bytes per second.
   * @param {number} blockAlign - Block alignment.
   * @param {number} bitsPerSample - Bits per sample.
   * @param {string} audioFormatString - Audio format string
   * @param {string} requestAudioFormatString - Audio format string sent to service.
   * @param {boolean} hasHeader - If the format has header or not.
   */ constructor(e, t, i, n, s, o, c, p, h){
        super(i, o, t, e), this.formatTag = e, this.avgBytesPerSec = n, this.blockAlign = s, this.priAudioFormatString = c, this.priRequestAudioFormatString = p, this.priHasHeader = h;
    }
    static fromSpeechSynthesisOutputFormat(e) {
        return e === void 0 ? $d7238066c5de7f1c$var$O.getDefaultOutputFormat() : $d7238066c5de7f1c$var$O.fromSpeechSynthesisOutputFormatString($d7238066c5de7f1c$var$O.SpeechSynthesisOutputFormatToString[e]);
    }
    static fromSpeechSynthesisOutputFormatString(e) {
        switch(e){
            case "raw-8khz-8bit-mono-mulaw":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.MuLaw, 1, 8e3, 8e3, 1, 8, e, e, !1);
            case "riff-16khz-16kbps-mono-siren":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.Siren, 1, 16e3, 2e3, 40, 0, e, "audio-16khz-16kbps-mono-siren", !0);
            case "audio-16khz-16kbps-mono-siren":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.Siren, 1, 16e3, 2e3, 40, 0, e, e, !1);
            case "audio-16khz-32kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.MP3, 1, 16e3, 4096, 2, 16, e, e, !1);
            case "audio-16khz-128kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.MP3, 1, 16e3, 16384, 2, 16, e, e, !1);
            case "audio-16khz-64kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.MP3, 1, 16e3, 8192, 2, 16, e, e, !1);
            case "audio-24khz-48kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.MP3, 1, 24e3, 6144, 2, 16, e, e, !1);
            case "audio-24khz-96kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.MP3, 1, 24e3, 12288, 2, 16, e, e, !1);
            case "audio-24khz-160kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.MP3, 1, 24e3, 20480, 2, 16, e, e, !1);
            case "raw-16khz-16bit-mono-truesilk":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.SILKSkype, 1, 16e3, 32e3, 2, 16, e, e, !1);
            case "riff-8khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 8e3, 16e3, 2, 16, e, "raw-8khz-16bit-mono-pcm", !0);
            case "riff-24khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 24e3, 48e3, 2, 16, e, "raw-24khz-16bit-mono-pcm", !0);
            case "riff-8khz-8bit-mono-mulaw":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.MuLaw, 1, 8e3, 8e3, 1, 8, e, "raw-8khz-8bit-mono-mulaw", !0);
            case "raw-16khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 16e3, 32e3, 2, 16, e, "raw-16khz-16bit-mono-pcm", !1);
            case "raw-24khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 24e3, 48e3, 2, 16, e, "raw-24khz-16bit-mono-pcm", !1);
            case "raw-8khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 8e3, 16e3, 2, 16, e, "raw-8khz-16bit-mono-pcm", !1);
            case "ogg-16khz-16bit-mono-opus":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.OGG_OPUS, 1, 16e3, 8192, 2, 16, e, e, !1);
            case "ogg-24khz-16bit-mono-opus":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.OGG_OPUS, 1, 24e3, 8192, 2, 16, e, e, !1);
            case "raw-48khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 48e3, 96e3, 2, 16, e, "raw-48khz-16bit-mono-pcm", !1);
            case "riff-48khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 48e3, 96e3, 2, 16, e, "raw-48khz-16bit-mono-pcm", !0);
            case "audio-48khz-96kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.MP3, 1, 48e3, 12288, 2, 16, e, e, !1);
            case "audio-48khz-192kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.MP3, 1, 48e3, 24576, 2, 16, e, e, !1);
            case "ogg-48khz-16bit-mono-opus":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.OGG_OPUS, 1, 48e3, 12e3, 2, 16, e, e, !1);
            case "webm-16khz-16bit-mono-opus":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.WEBM_OPUS, 1, 16e3, 4e3, 2, 16, e, e, !1);
            case "webm-24khz-16bit-mono-opus":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.WEBM_OPUS, 1, 24e3, 6e3, 2, 16, e, e, !1);
            case "webm-24khz-16bit-24kbps-mono-opus":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.WEBM_OPUS, 1, 24e3, 3e3, 2, 16, e, e, !1);
            case "audio-16khz-16bit-32kbps-mono-opus":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.OPUS, 1, 16e3, 4e3, 2, 16, e, e, !1);
            case "audio-24khz-16bit-48kbps-mono-opus":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.OPUS, 1, 24e3, 6e3, 2, 16, e, e, !1);
            case "audio-24khz-16bit-24kbps-mono-opus":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.OPUS, 1, 24e3, 3e3, 2, 16, e, e, !1);
            case "audio-24khz-16bit-mono-flac":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.FLAC, 1, 24e3, 24e3, 2, 16, e, e, !1);
            case "audio-48khz-16bit-mono-flac":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.FLAC, 1, 48e3, 3e4, 2, 16, e, e, !1);
            case "raw-24khz-16bit-mono-truesilk":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.SILKSkype, 1, 24e3, 48e3, 2, 16, e, e, !1);
            case "raw-8khz-8bit-mono-alaw":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.ALaw, 1, 8e3, 8e3, 1, 8, e, e, !1);
            case "riff-8khz-8bit-mono-alaw":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.ALaw, 1, 8e3, 8e3, 1, 8, e, "raw-8khz-8bit-mono-alaw", !0);
            case "raw-22050hz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 22050, 44100, 2, 16, e, e, !1);
            case "riff-22050hz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 22050, 44100, 2, 16, e, "raw-22050hz-16bit-mono-pcm", !0);
            case "raw-44100hz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 44100, 88200, 2, 16, e, e, !1);
            case "riff-44100hz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 44100, 88200, 2, 16, e, "raw-44100hz-16bit-mono-pcm", !0);
            case "riff-16khz-16bit-mono-pcm":
            default:
                return new $d7238066c5de7f1c$var$O($d7238066c5de7f1c$var$E.PCM, 1, 16e3, 32e3, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", !0);
        }
    }
    static getDefaultOutputFormat() {
        return $d7238066c5de7f1c$var$O.fromSpeechSynthesisOutputFormatString(typeof window < "u" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
    }
    /**
   * Specifies if this audio output format has a header
   * @boolean AudioOutputFormatImpl.prototype.hasHeader
   * @function
   * @public
   */ get hasHeader() {
        return this.priHasHeader;
    }
    /**
   * Specifies the header of this format
   * @ArrayBuffer AudioOutputFormatImpl.prototype.header
   * @function
   * @public
   */ get header() {
        if (this.hasHeader) return this.privHeader;
    }
    /**
   * Updates the header based on the audio length
   * @member AudioOutputFormatImpl.updateHeader
   * @function
   * @public
   * @param {number} audioLength - the audio length
   */ updateHeader(e) {
        if (this.priHasHeader) {
            const t = new DataView(this.privHeader);
            t.setUint32(4, e + this.privHeader.byteLength - 8, !0), t.setUint32(40, e, !0);
        }
    }
    /**
   * Specifies the audio format string to be sent to the service
   * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
   * @function
   * @public
   */ get requestAudioFormatString() {
        return this.priRequestAudioFormatString;
    }
    /**
   * Adds audio header
   * @param audio the raw audio without header
   * @returns the audio with header if applicable
   */ addHeader(e) {
        if (!this.hasHeader) return e;
        this.updateHeader(e.byteLength);
        const t = new Uint8Array(e.byteLength + this.header.byteLength);
        return t.set(new Uint8Array(this.header), 0), t.set(new Uint8Array(e), this.header.byteLength), t.buffer;
    }
}
$d7238066c5de7f1c$var$O.SpeechSynthesisOutputFormatToString = {
    [$d7238066c5de7f1c$var$M.Raw8Khz8BitMonoMULaw]: "raw-8khz-8bit-mono-mulaw",
    [$d7238066c5de7f1c$var$M.Riff16Khz16KbpsMonoSiren]: "riff-16khz-16kbps-mono-siren",
    [$d7238066c5de7f1c$var$M.Audio16Khz16KbpsMonoSiren]: "audio-16khz-16kbps-mono-siren",
    [$d7238066c5de7f1c$var$M.Audio16Khz32KBitRateMonoMp3]: "audio-16khz-32kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$M.Audio16Khz128KBitRateMonoMp3]: "audio-16khz-128kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$M.Audio16Khz64KBitRateMonoMp3]: "audio-16khz-64kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$M.Audio24Khz48KBitRateMonoMp3]: "audio-24khz-48kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$M.Audio24Khz96KBitRateMonoMp3]: "audio-24khz-96kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$M.Audio24Khz160KBitRateMonoMp3]: "audio-24khz-160kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$M.Raw16Khz16BitMonoTrueSilk]: "raw-16khz-16bit-mono-truesilk",
    [$d7238066c5de7f1c$var$M.Riff16Khz16BitMonoPcm]: "riff-16khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$M.Riff8Khz16BitMonoPcm]: "riff-8khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$M.Riff24Khz16BitMonoPcm]: "riff-24khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$M.Riff8Khz8BitMonoMULaw]: "riff-8khz-8bit-mono-mulaw",
    [$d7238066c5de7f1c$var$M.Raw16Khz16BitMonoPcm]: "raw-16khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$M.Raw24Khz16BitMonoPcm]: "raw-24khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$M.Raw8Khz16BitMonoPcm]: "raw-8khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$M.Ogg16Khz16BitMonoOpus]: "ogg-16khz-16bit-mono-opus",
    [$d7238066c5de7f1c$var$M.Ogg24Khz16BitMonoOpus]: "ogg-24khz-16bit-mono-opus",
    [$d7238066c5de7f1c$var$M.Raw48Khz16BitMonoPcm]: "raw-48khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$M.Riff48Khz16BitMonoPcm]: "riff-48khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$M.Audio48Khz96KBitRateMonoMp3]: "audio-48khz-96kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$M.Audio48Khz192KBitRateMonoMp3]: "audio-48khz-192kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$M.Ogg48Khz16BitMonoOpus]: "ogg-48khz-16bit-mono-opus",
    [$d7238066c5de7f1c$var$M.Webm16Khz16BitMonoOpus]: "webm-16khz-16bit-mono-opus",
    [$d7238066c5de7f1c$var$M.Webm24Khz16BitMonoOpus]: "webm-24khz-16bit-mono-opus",
    [$d7238066c5de7f1c$var$M.Webm24Khz16Bit24KbpsMonoOpus]: "webm-24khz-16bit-24kbps-mono-opus",
    [$d7238066c5de7f1c$var$M.Raw24Khz16BitMonoTrueSilk]: "raw-24khz-16bit-mono-truesilk",
    [$d7238066c5de7f1c$var$M.Raw8Khz8BitMonoALaw]: "raw-8khz-8bit-mono-alaw",
    [$d7238066c5de7f1c$var$M.Riff8Khz8BitMonoALaw]: "riff-8khz-8bit-mono-alaw",
    [$d7238066c5de7f1c$var$M.Audio16Khz16Bit32KbpsMonoOpus]: "audio-16khz-16bit-32kbps-mono-opus",
    [$d7238066c5de7f1c$var$M.Audio24Khz16Bit48KbpsMonoOpus]: "audio-24khz-16bit-48kbps-mono-opus",
    [$d7238066c5de7f1c$var$M.Audio24Khz16Bit24KbpsMonoOpus]: "audio-24khz-16bit-24kbps-mono-opus",
    [$d7238066c5de7f1c$var$M.Raw22050Hz16BitMonoPcm]: "raw-22050hz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$M.Riff22050Hz16BitMonoPcm]: "riff-22050hz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$M.Raw44100Hz16BitMonoPcm]: "raw-44100hz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$M.Riff44100Hz16BitMonoPcm]: "riff-44100hz-16bit-mono-pcm"
};
var $d7238066c5de7f1c$var$rl = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$vn {
    /**
   * Creates and initializes an instance.
   * @constructor
   */ constructor(){}
    /**
   * Creates a memory backed PullAudioOutputStream with the specified audio format.
   * @member AudioOutputStream.createPullStream
   * @function
   * @public
   * @returns {PullAudioOutputStream} The audio output stream being created.
   */ static createPullStream() {
        return $d7238066c5de7f1c$var$dr.create();
    }
}
class $d7238066c5de7f1c$var$dr extends $d7238066c5de7f1c$var$vn {
    /**
   * Creates a memory backed PullAudioOutputStream with the specified audio format.
   * @member PullAudioOutputStream.create
   * @function
   * @public
   * @returns {PullAudioOutputStream} The push audio output stream being created.
   */ static create() {
        return new $d7238066c5de7f1c$var$To();
    }
}
class $d7238066c5de7f1c$var$To extends $d7238066c5de7f1c$var$dr {
    /**
   * Creates and initializes an instance with the given values.
   * @constructor
   */ constructor(){
        super(), this.privId = $d7238066c5de7f1c$var$ee(), this.privStream = new $d7238066c5de7f1c$var$zp();
    }
    /**
   * Sets the format information to the stream. For internal use only.
   * @param {AudioStreamFormat} format - the format to be set.
   */ set format(e) {
        e == null && (this.privFormat = $d7238066c5de7f1c$var$O.getDefaultOutputFormat()), this.privFormat = e;
    }
    /**
   * Format information for the audio
   */ get format() {
        return this.privFormat;
    }
    /**
   * Checks if the stream is closed
   * @member PullAudioOutputStreamImpl.prototype.isClosed
   * @property
   * @public
   */ get isClosed() {
        return this.privStream.isClosed;
    }
    /**
   * Gets the id of the stream
   * @member PullAudioOutputStreamImpl.prototype.id
   * @property
   * @public
   */ id() {
        return this.privId;
    }
    /**
   * Reads audio data from the internal buffer.
   * @member PullAudioOutputStreamImpl.prototype.read
   * @function
   * @public
   * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
   * @returns {Promise<number>} - Audio buffer length has been read.
   */ read(e) {
        return $d7238066c5de7f1c$var$rl(this, void 0, void 0, function*() {
            const t = new Int8Array(e);
            let i = 0;
            if (this.privLastChunkView !== void 0) {
                if (this.privLastChunkView.length > e.byteLength) return t.set(this.privLastChunkView.slice(0, e.byteLength)), this.privLastChunkView = this.privLastChunkView.slice(e.byteLength), Promise.resolve(e.byteLength);
                t.set(this.privLastChunkView), i = this.privLastChunkView.length, this.privLastChunkView = void 0;
            }
            for(; i < e.byteLength && !this.privStream.isReadEnded;){
                const n = yield this.privStream.read();
                if (n !== void 0 && !n.isEnd) {
                    let s;
                    n.buffer.byteLength > e.byteLength - i ? (s = n.buffer.slice(0, e.byteLength - i), this.privLastChunkView = new Int8Array(n.buffer.slice(e.byteLength - i))) : s = n.buffer, t.set(new Int8Array(s), i), i += s.byteLength;
                } else this.privStream.readEnded();
            }
            return i;
        });
    }
    /**
   * Writes the audio data specified by making an internal copy of the data.
   * @member PullAudioOutputStreamImpl.prototype.write
   * @function
   * @public
   * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
   */ write(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privStream, "must set format before writing"), this.privStream.writeStreamChunk({
            buffer: e,
            isEnd: !1,
            timeReceived: Date.now()
        });
    }
    /**
   * Closes the stream.
   * @member PullAudioOutputStreamImpl.prototype.close
   * @function
   * @public
   */ close() {
        this.privStream.close();
    }
}
class $d7238066c5de7f1c$var$Po extends $d7238066c5de7f1c$var$vn {
    /**
   * Creates and initializes and instance.
   * @constructor
   */ constructor(){
        super();
    }
    /**
   * Creates a PushAudioOutputStream that delegates to the specified callback interface for
   * write() and close() methods.
   * @member PushAudioOutputStream.create
   * @function
   * @public
   * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
   * derived from PushAudioOutputStreamCallback
   * @returns {PushAudioOutputStream} The push audio output stream being created.
   */ static create(e) {
        return new $d7238066c5de7f1c$var$bo(e);
    }
}
class $d7238066c5de7f1c$var$bo extends $d7238066c5de7f1c$var$Po {
    /**
   * Creates a PushAudioOutputStream that delegates to the specified callback interface for
   * read() and close() methods.
   * @constructor
   * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
   * derived from PushAudioOutputStreamCallback
   */ constructor(e){
        super(), this.privId = $d7238066c5de7f1c$var$ee(), this.privCallback = e;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set format(e) {}
    write(e) {
        this.privCallback.write && this.privCallback.write(e);
    }
    close() {
        this.privCallback.close && this.privCallback.close();
    }
    id() {
        return this.privId;
    }
}
class $d7238066c5de7f1c$var$bt {
    /**
   * Creates an AudioConfig object representing the default microphone on the system.
   * @member AudioConfig.fromDefaultMicrophoneInput
   * @function
   * @public
   * @returns {AudioConfig} The audio input configuration being created.
   */ static fromDefaultMicrophoneInput() {
        const e = new $d7238066c5de7f1c$var$Hn(!0);
        return new $d7238066c5de7f1c$var$ni(new $d7238066c5de7f1c$var$Ge(e));
    }
    /**
   * Creates an AudioConfig object representing a microphone with the specified device ID.
   * @member AudioConfig.fromMicrophoneInput
   * @function
   * @public
   * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
   * Default microphone is used the value is omitted.
   * @returns {AudioConfig} The audio input configuration being created.
   */ static fromMicrophoneInput(e) {
        const t = new $d7238066c5de7f1c$var$Hn(!0);
        return new $d7238066c5de7f1c$var$ni(new $d7238066c5de7f1c$var$Ge(t, e));
    }
    /**
   * Creates an AudioConfig object representing the specified file.
   * @member AudioConfig.fromWavFileInput
   * @function
   * @public
   * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
   * @returns {AudioConfig} The audio input configuration being created.
   */ static fromWavFileInput(e, t = "unnamedBuffer.wav") {
        return new $d7238066c5de7f1c$var$ni(new $d7238066c5de7f1c$var$Xd(e, t));
    }
    /**
   * Creates an AudioConfig object representing the specified stream.
   * @member AudioConfig.fromStreamInput
   * @function
   * @public
   * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
   * stream. Currently, only WAV / PCM is supported.
   * @returns {AudioConfig} The audio input configuration being created.
   */ static fromStreamInput(e) {
        if (e instanceof $d7238066c5de7f1c$var$_p) return new $d7238066c5de7f1c$var$ni(new $d7238066c5de7f1c$var$xp(e));
        if (e instanceof $d7238066c5de7f1c$var$ur) return new $d7238066c5de7f1c$var$ni(e);
        if (typeof MediaStream < "u" && e instanceof MediaStream) {
            const t = new $d7238066c5de7f1c$var$Hn(!1);
            return new $d7238066c5de7f1c$var$ni(new $d7238066c5de7f1c$var$Ge(t, null, null, e));
        }
        throw new Error("Not Supported Type");
    }
    /**
   * Creates an AudioConfig object representing the default speaker.
   * @member AudioConfig.fromDefaultSpeakerOutput
   * @function
   * @public
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.11.0
   */ static fromDefaultSpeakerOutput() {
        return new $d7238066c5de7f1c$var$si(new $d7238066c5de7f1c$var$Js());
    }
    /**
   * Creates an AudioConfig object representing the custom IPlayer object.
   * You can use the IPlayer object to control pause, resume, etc.
   * @member AudioConfig.fromSpeakerOutput
   * @function
   * @public
   * @param {IPlayer} player - the IPlayer object for playback.
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.12.0
   */ static fromSpeakerOutput(e) {
        if (e === void 0) return $d7238066c5de7f1c$var$bt.fromDefaultSpeakerOutput();
        if (e instanceof $d7238066c5de7f1c$var$Js) return new $d7238066c5de7f1c$var$si(e);
        throw new Error("Not Supported Type");
    }
    /**
   * Creates an AudioConfig object representing a specified output audio file
   * @member AudioConfig.fromAudioFileOutput
   * @function
   * @public
   * @param {PathLike} filename - the filename of the output audio file
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.11.0
   */ static fromAudioFileOutput(e) {
        return new $d7238066c5de7f1c$var$si(new $d7238066c5de7f1c$var$Mp(e));
    }
    /**
   * Creates an AudioConfig object representing a specified audio output stream
   * @member AudioConfig.fromStreamOutput
   * @function
   * @public
   * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
   * stream.
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.11.0
   */ static fromStreamOutput(e) {
        if (e instanceof $d7238066c5de7f1c$var$Eo) return new $d7238066c5de7f1c$var$si(new $d7238066c5de7f1c$var$bo(e));
        if (e instanceof $d7238066c5de7f1c$var$Po) return new $d7238066c5de7f1c$var$si(e);
        if (e instanceof $d7238066c5de7f1c$var$dr) return new $d7238066c5de7f1c$var$si(e);
        throw new Error("Not Supported Type");
    }
}
class $d7238066c5de7f1c$var$ni extends $d7238066c5de7f1c$var$bt {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {IAudioSource} source - An audio source.
   */ constructor(e){
        super(), this.privSource = e;
    }
    /**
   * Format information for the audio
   */ get format() {
        return this.privSource.format;
    }
    /**
   * @member AudioConfigImpl.prototype.close
   * @function
   * @public
   */ close(e, t) {
        this.privSource.turnOff().then(()=>{
            e && e();
        }, (i)=>{
            t && t(i);
        });
    }
    /**
   * @member AudioConfigImpl.prototype.id
   * @function
   * @public
   */ id() {
        return this.privSource.id();
    }
    /**
   * @member AudioConfigImpl.prototype.turnOn
   * @function
   * @public
   * @returns {Promise<void>} A promise.
   */ turnOn() {
        return this.privSource.turnOn();
    }
    /**
   * @member AudioConfigImpl.prototype.attach
   * @function
   * @public
   * @param {string} audioNodeId - The audio node id.
   * @returns {Promise<IAudioStreamNode>} A promise.
   */ attach(e) {
        return this.privSource.attach(e);
    }
    /**
   * @member AudioConfigImpl.prototype.detach
   * @function
   * @public
   * @param {string} audioNodeId - The audio node id.
   */ detach(e) {
        return this.privSource.detach(e);
    }
    /**
   * @member AudioConfigImpl.prototype.turnOff
   * @function
   * @public
   * @returns {Promise<void>} A promise.
   */ turnOff() {
        return this.privSource.turnOff();
    }
    /**
   * @member AudioConfigImpl.prototype.events
   * @function
   * @public
   * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
   */ get events() {
        return this.privSource.events;
    }
    setProperty(e, t) {
        if ($d7238066c5de7f1c$var$l.throwIfNull(t, "value"), this.privSource.setProperty !== void 0) this.privSource.setProperty(e, t);
        else throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(e, t) {
        if (this.privSource.getProperty !== void 0) return this.privSource.getProperty(e, t);
        throw new Error("This AudioConfig instance does not support getting properties.");
    }
    get deviceInfo() {
        return this.privSource.deviceInfo;
    }
}
class $d7238066c5de7f1c$var$si extends $d7238066c5de7f1c$var$bt {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {IAudioDestination} destination - An audio destination.
   */ constructor(e){
        super(), this.privDestination = e;
    }
    set format(e) {
        this.privDestination.format = e;
    }
    write(e) {
        this.privDestination.write(e);
    }
    close() {
        this.privDestination.close();
    }
    id() {
        return this.privDestination.id();
    }
    setProperty() {
        throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty() {
        throw new Error("This AudioConfig instance does not support getting properties.");
    }
}
var $d7238066c5de7f1c$var$X;
(function(r) {
    r[r.Error = 0] = "Error", r[r.EndOfStream = 1] = "EndOfStream";
})($d7238066c5de7f1c$var$X || ($d7238066c5de7f1c$var$X = {}));
class $d7238066c5de7f1c$var$_p {
}
class $d7238066c5de7f1c$var$Eo {
}
class $d7238066c5de7f1c$var$nl {
    /**
   * Create and initializes a new instance.
   * @constructor
   */ constructor(){
        this.privDisposed = !1;
    }
    /**
   * Creates a keyword recognition model using the specified filename.
   * @member KeywordRecognitionModel.fromFile
   * @function
   * @public
   * @param {string} fileName - A string that represents file name for the keyword recognition model.
   * Note, the file can point to a zip file in which case the model
   * will be extracted from the zip.
   * @returns {KeywordRecognitionModel} The keyword recognition model being created.
   */ static fromFile(e) {
        throw $d7238066c5de7f1c$var$l.throwIfFileDoesNotExist(e, "fileName"), new Error("Not yet implemented.");
    }
    /**
   * Creates a keyword recognition model using the specified filename.
   * @member KeywordRecognitionModel.fromStream
   * @function
   * @public
   * @param {string} file - A File that represents file for the keyword recognition model.
   * Note, the file can point to a zip file in which case the model will be extracted from the zip.
   * @returns {KeywordRecognitionModel} The keyword recognition model being created.
   */ static fromStream(e) {
        throw $d7238066c5de7f1c$var$l.throwIfNull(e, "file"), new Error("Not yet implemented.");
    }
    /**
   * Dispose of associated resources.
   * @member KeywordRecognitionModel.prototype.close
   * @function
   * @public
   */ close() {
        this.privDisposed || (this.privDisposed = !0);
    }
}
class $d7238066c5de7f1c$var$Ce {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} sessionId - The session id.
   */ constructor(e){
        this.privSessionId = e;
    }
    /**
   * Represents the session identifier.
   * @member SessionEventArgs.prototype.sessionId
   * @function
   * @public
   * @returns {string} Represents the session identifier.
   */ get sessionId() {
        return this.privSessionId;
    }
}
class $d7238066c5de7f1c$var$Xe extends $d7238066c5de7f1c$var$Ce {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t){
        super(t), this.privOffset = e;
    }
    /**
   * Represents the message offset
   * @member RecognitionEventArgs.prototype.offset
   * @function
   * @public
   */ get offset() {
        return this.privOffset;
    }
}
var $d7238066c5de7f1c$var$B;
(function(r) {
    r[r.Simple = 0] = "Simple", r[r.Detailed = 1] = "Detailed";
})($d7238066c5de7f1c$var$B || ($d7238066c5de7f1c$var$B = {}));
class $d7238066c5de7f1c$var$ui extends $d7238066c5de7f1c$var$Xe {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param result - The result of the intent recognition.
   * @param offset - The offset.
   * @param sessionId - The session id.
   */ constructor(e, t, i){
        super(t, i), this.privResult = e;
    }
    /**
   * Represents the intent recognition result.
   * @member IntentRecognitionEventArgs.prototype.result
   * @function
   * @public
   * @returns {IntentRecognitionResult} Represents the intent recognition result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$fn {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} language - Primary Language detected, if provided.
   * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s, o, c, p, h, a){
        this.privResultId = e, this.privReason = t, this.privText = i, this.privDuration = n, this.privOffset = s, this.privLanguage = o, this.privLanguageDetectionConfidence = c, this.privErrorDetails = p, this.privJson = h, this.privProperties = a;
    }
    /**
   * Specifies the result identifier.
   * @member RecognitionResult.prototype.resultId
   * @function
   * @public
   * @returns {string} Specifies the result identifier.
   */ get resultId() {
        return this.privResultId;
    }
    /**
   * Specifies status of the result.
   * @member RecognitionResult.prototype.reason
   * @function
   * @public
   * @returns {ResultReason} Specifies status of the result.
   */ get reason() {
        return this.privReason;
    }
    /**
   * Presents the recognized text in the result.
   * @member RecognitionResult.prototype.text
   * @function
   * @public
   * @returns {string} Presents the recognized text in the result.
   */ get text() {
        return this.privText;
    }
    /**
   * Duration of recognized speech in 100 nano second increments.
   * @member RecognitionResult.prototype.duration
   * @function
   * @public
   * @returns {number} Duration of recognized speech in 100 nano second increments.
   */ get duration() {
        return this.privDuration;
    }
    /**
   * Offset of recognized speech in 100 nano second increments.
   * @member RecognitionResult.prototype.offset
   * @function
   * @public
   * @returns {number} Offset of recognized speech in 100 nano second increments.
   */ get offset() {
        return this.privOffset;
    }
    /**
   * Primary Language detected.
   * @member RecognitionResult.prototype.language
   * @function
   * @public
   * @returns {string} language detected.
   */ get language() {
        return this.privLanguage;
    }
    /**
   * Primary Language detection confidence (Unknown, Low, Medium, High).
   * @member RecognitionResult.prototype.languageDetectionConfidence
   * @function
   * @public
   * @returns {string} detection confidence strength.
   */ get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
    /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member RecognitionResult.prototype.errorDetails
   * @function
   * @public
   * @returns {string} a brief description of an error.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
   * A string containing Json serialized recognition result as it was received from the service.
   * @member RecognitionResult.prototype.json
   * @function
   * @private
   * @returns {string} Json serialized representation of the result.
   */ get json() {
        return this.privJson;
    }
    /**
   * The set of properties exposed in the result.
   * @member RecognitionResult.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The set of properties exposed in the result.
   */ get properties() {
        return this.privProperties;
    }
}
class $d7238066c5de7f1c$var$Oe extends $d7238066c5de7f1c$var$fn {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @public
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} language - Primary Language detected, if provided.
   * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param {string} speakerId - speaker id for conversation transcription, if provided.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s, o, c, p, h, a, d){
        super(e, t, i, n, s, o, c, h, a, d), this.privSpeakerId = p;
    }
    /**
   * speaker id from conversation transcription/id scenarios
   * @member SpeechRecognitionResult.prototype.speakerId
   * @function
   * @public
   * @returns {string} id of speaker in given result
   */ get speakerId() {
        return this.privSpeakerId;
    }
}
class $d7238066c5de7f1c$var$hi extends $d7238066c5de7f1c$var$Oe {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param intentId - The intent id.
   * @param resultId - The result id.
   * @param reason - The reason.
   * @param text - The recognized text.
   * @param duration - The duration.
   * @param offset - The offset into the stream.
   * @param language - Primary Language detected, if provided.
   * @param languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param errorDetails - Error details, if provided.
   * @param json - Additional Json, if provided.
   * @param properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s, o, c, p, h, a, d){
        super(t, i, n, s, o, c, p, void 0, h, a, d), this.privIntentId = e;
    }
    /**
   * A String that represents the intent identifier being recognized.
   * @member IntentRecognitionResult.prototype.intentId
   * @function
   * @public
   * @returns {string} A String that represents the intent identifier being recognized.
   */ get intentId() {
        return this.privIntentId;
    }
}
class $d7238066c5de7f1c$var$Lp {
    /**
   * Creates and initializes a new instance
   * @constructor
   */ constructor(){}
    /**
   * Creates an language understanding model using the specified endpoint.
   * @member LanguageUnderstandingModel.fromEndpoint
   * @function
   * @public
   * @param {URL} uri - A String that represents the endpoint of the language understanding model.
   * @returns {LanguageUnderstandingModel} The language understanding model being created.
   */ static fromEndpoint(e) {
        $d7238066c5de7f1c$var$l.throwIfNull(e, "uri"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e.hostname, "uri");
        const t = new $d7238066c5de7f1c$var$Fn(), i = e.host.indexOf(".");
        if (i === -1) throw new Error("Could not determine region from endpoint");
        t.region = e.host.substr(0, i);
        const n = e.pathname.lastIndexOf("/") + 1;
        if (n === -1) throw new Error("Could not determine appId from endpoint");
        if (t.appId = e.pathname.substr(n), t.subscriptionKey = e.searchParams.get("subscription-key"), t.subscriptionKey === void 0) throw new Error("Could not determine subscription key from endpoint");
        return t;
    }
    /**
   * Creates an language understanding model using the application id of Language Understanding service.
   * @member LanguageUnderstandingModel.fromAppId
   * @function
   * @public
   * @param {string} appId - A String that represents the application id of Language Understanding service.
   * @returns {LanguageUnderstandingModel} The language understanding model being created.
   */ static fromAppId(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "appId");
        const t = new $d7238066c5de7f1c$var$Fn();
        return t.appId = e, t;
    }
    /**
   * Creates a language understanding model using hostname, subscription key and application
   * id of Language Understanding service.
   * @member LanguageUnderstandingModel.fromSubscription
   * @function
   * @public
   * @param {string} subscriptionKey - A String that represents the subscription key of
   * Language Understanding service.
   * @param {string} appId - A String that represents the application id of Language
   * Understanding service.
   * @param {LanguageUnderstandingModel} region - A String that represents the region
   * of the Language Understanding service (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {LanguageUnderstandingModel} The language understanding model being created.
   */ static fromSubscription(e, t, i) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "subscriptionKey"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, "appId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(i, "region");
        const n = new $d7238066c5de7f1c$var$Fn();
        return n.appId = t, n.region = i, n.subscriptionKey = e, n;
    }
}
class $d7238066c5de7f1c$var$Fn extends $d7238066c5de7f1c$var$Lp {
}
class $d7238066c5de7f1c$var$Rt extends $d7238066c5de7f1c$var$Xe {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {SpeechRecognitionResult} result - The speech recognition result.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t, i){
        super(t, i), this.privResult = e;
    }
    /**
   * Specifies the recognition result.
   * @member SpeechRecognitionEventArgs.prototype.result
   * @function
   * @public
   * @returns {SpeechRecognitionResult} the recognition result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$_s extends $d7238066c5de7f1c$var$Xe {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {ConversationTranscriptionResult} result - The conversation transcription result.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t, i){
        super(t, i), this.privResult = e;
    }
    /**
   * Specifies the transcription result.
   * @member ConversationTranscription1EventArgs.prototype.result
   * @function
   * @public
   * @returns {ConversationTranscriptionResult} the recognition result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$sl extends $d7238066c5de7f1c$var$Rt {
}
class $d7238066c5de7f1c$var$gn extends $d7238066c5de7f1c$var$Xe {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {CancellationReason} reason - The cancellation reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t, i, n, s){
        super(n, s), this.privReason = e, this.privErrorDetails = t, this.privErrorCode = i;
    }
    /**
   * The reason the recognition was canceled.
   * @member CancellationEventArgsBase.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */ get reason() {
        return this.privReason;
    }
    /**
   * The error code in case of an unsuccessful operation.
   * @return An error code that represents the error reason.
   */ get errorCode() {
        return this.privErrorCode;
    }
    /**
   * In case of an unsuccessful operation, provides details of the occurred error.
   * @member CancellationEventArgsBase.prototype.errorDetails
   * @function
   * @public
   * @returns {string} A String that represents the error details.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
}
class $d7238066c5de7f1c$var$Ao extends $d7238066c5de7f1c$var$gn {
}
class $d7238066c5de7f1c$var$Ui extends $d7238066c5de7f1c$var$Xe {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {TranslationRecognitionResult} result - The translation recognition result.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t, i){
        super(t, i), this.privResult = e;
    }
    /**
   * Specifies the recognition result.
   * @member TranslationRecognitionEventArgs.prototype.result
   * @function
   * @public
   * @returns {TranslationRecognitionResult} the recognition result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$Ls extends $d7238066c5de7f1c$var$Ce {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {TranslationSynthesisResult} result - The translation synthesis result.
   * @param {string} sessionId - The session id.
   */ constructor(e, t){
        super(t), this.privResult = e;
    }
    /**
   * Specifies the translation synthesis result.
   * @member TranslationSynthesisEventArgs.prototype.result
   * @function
   * @public
   * @returns {TranslationSynthesisResult} Specifies the translation synthesis result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$yt extends $d7238066c5de7f1c$var$Oe {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {Translations} translations - The translations.
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} language - Primary Language detected, if provided.
   * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s, o, c, p, h, a, d){
        super(t, i, n, s, o, c, p, void 0, h, a, d), this.privTranslations = e;
    }
    static fromSpeechRecognitionResult(e) {
        return new $d7238066c5de7f1c$var$yt(void 0, e.resultId, e.reason, e.text, e.duration, e.offset, e.language, e.languageDetectionConfidence, e.errorDetails, e.json, e.properties);
    }
    /**
   * Presents the translation results. Each item in the dictionary represents
   * a translation result in one of target languages, where the key is the name
   * of the target language, in BCP-47 format, and the value is the translation
   * text in the specified language.
   * @member TranslationRecognitionResult.prototype.translations
   * @function
   * @public
   * @returns {Translations} the current translation map that holds all translations requested.
   */ get translations() {
        return this.privTranslations;
    }
}
class $d7238066c5de7f1c$var$$s {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {ResultReason} reason - The synthesis reason.
   * @param {ArrayBuffer} audio - The audio data.
   */ constructor(e, t){
        this.privReason = e, this.privAudio = t;
    }
    /**
   * Translated text in the target language.
   * @member TranslationSynthesisResult.prototype.audio
   * @function
   * @public
   * @returns {ArrayBuffer} Translated audio in the target language.
   */ get audio() {
        return this.privAudio;
    }
    /**
   * The synthesis status.
   * @member TranslationSynthesisResult.prototype.reason
   * @function
   * @public
   * @returns {ResultReason} The synthesis status.
   */ get reason() {
        return this.privReason;
    }
}
var $d7238066c5de7f1c$var$R;
(function(r) {
    r[r.NoMatch = 0] = "NoMatch", r[r.Canceled = 1] = "Canceled", r[r.RecognizingSpeech = 2] = "RecognizingSpeech", r[r.RecognizedSpeech = 3] = "RecognizedSpeech", r[r.RecognizedKeyword = 4] = "RecognizedKeyword", r[r.RecognizingIntent = 5] = "RecognizingIntent", r[r.RecognizedIntent = 6] = "RecognizedIntent", r[r.TranslatingSpeech = 7] = "TranslatingSpeech", r[r.TranslatedSpeech = 8] = "TranslatedSpeech", r[r.SynthesizingAudio = 9] = "SynthesizingAudio", r[r.SynthesizingAudioCompleted = 10] = "SynthesizingAudioCompleted", r[r.SynthesizingAudioStarted = 11] = "SynthesizingAudioStarted", r[r.EnrollingVoiceProfile = 12] = "EnrollingVoiceProfile", r[r.EnrolledVoiceProfile = 13] = "EnrolledVoiceProfile", r[r.RecognizedSpeakers = 14] = "RecognizedSpeakers", r[r.RecognizedSpeaker = 15] = "RecognizedSpeaker", r[r.ResetVoiceProfile = 16] = "ResetVoiceProfile", r[r.DeletedVoiceProfile = 17] = "DeletedVoiceProfile", r[r.VoicesListRetrieved = 18] = "VoicesListRetrieved", r[r.TranslatingParticipantSpeech = 19] = "TranslatingParticipantSpeech", r[r.TranslatedParticipantSpeech = 20] = "TranslatedParticipantSpeech", r[r.TranslatedInstantMessage = 21] = "TranslatedInstantMessage", r[r.TranslatedParticipantInstantMessage = 22] = "TranslatedParticipantInstantMessage";
})($d7238066c5de7f1c$var$R || ($d7238066c5de7f1c$var$R = {}));
class $d7238066c5de7f1c$var$ko {
    /**
   * Creates and initializes an instance.
   * @constructor
   */ constructor(){}
    /**
   * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
   * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
   * @member SpeechConfig.fromSubscription
   * @function
   * @public
   * @param {string} subscriptionKey - The subscription key.
   * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {SpeechConfig} The speech factory
   */ static fromSubscription(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "subscriptionKey"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, "region");
        const i = new $d7238066c5de7f1c$var$xt();
        return i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, t), i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_IntentRegion, t), i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, e), i;
    }
    /**
   * Creates an instance of the speech config with specified endpoint and subscription key.
   * This method is intended only for users who use a non-standard service endpoint or parameters.
   * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
   * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
   * For example, if language is defined in the uri as query parameter "language=de-DE", and also set by
   * SpeechConfig.speechRecognitionLanguage = "en-US", the language setting in uri takes precedence,
   * and the effective language is "de-DE". Only the parameters that are not specified in the
   * endpoint URL can be set by other APIs.
   * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
   * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
   * use the authorization token.
   * @member SpeechConfig.fromEndpoint
   * @function
   * @public
   * @param {URL} endpoint - The service endpoint to connect to.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
   * @returns {SpeechConfig} A speech factory instance.
   */ static fromEndpoint(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNull(e, "endpoint");
        const i = new $d7238066c5de7f1c$var$xt();
        return i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint, e.href), t !== void 0 && i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, t), i;
    }
    /**
   * Creates an instance of the speech config with specified host and subscription key.
   * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
   * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
   * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
   * Note: To use an authorization token with fromHost, use fromHost(URL),
   * and then set the AuthorizationToken property on the created SpeechConfig instance.
   * Note: Added in version 1.9.0.
   * @member SpeechConfig.fromHost
   * @function
   * @public
   * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
   * @returns {SpeechConfig} A speech factory instance.
   */ static fromHost(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNull(e, "hostName");
        const i = new $d7238066c5de7f1c$var$xt();
        return i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, e.protocol + "//" + e.hostname + (e.port === "" ? "" : ":" + e.port)), t !== void 0 && i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, t), i;
    }
    /**
   * Creates an instance of the speech factory with specified initial authorization token and region.
   * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
   * expires, the caller needs to refresh it by calling this setter with a new valid token.
   * Note: Please use a token derived from your LanguageUnderstanding subscription key in case you want
   * to use the Intent recognizer. As configuration values are copied when creating a new recognizer,
   * the new token value will not apply to recognizers that have already been created. For recognizers
   * that have been created before, you need to set authorization token of the corresponding recognizer
   * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
   * @member SpeechConfig.fromAuthorizationToken
   * @function
   * @public
   * @param {string} authorizationToken - The initial authorization token.
   * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {SpeechConfig} A speech factory instance.
   */ static fromAuthorizationToken(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNull(e, "authorizationToken"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, "region");
        const i = new $d7238066c5de7f1c$var$xt();
        return i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, t), i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_IntentRegion, t), i.authorizationToken = e, i;
    }
    /**
   * Closes the configuration.
   * @member SpeechConfig.prototype.close
   * @function
   * @public
   */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    close() {}
}
class $d7238066c5de7f1c$var$xt extends $d7238066c5de7f1c$var$ko {
    constructor(){
        super(), this.privProperties = new $d7238066c5de7f1c$var$U(), this.speechRecognitionLanguage = "en-US", this.outputFormat = $d7238066c5de7f1c$var$B.Simple;
    }
    get properties() {
        return this.privProperties;
    }
    get endPoint() {
        return new URL(this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint));
    }
    get subscriptionKey() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key);
    }
    get region() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region);
    }
    get authorizationToken() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    get speechRecognitionLanguage() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage);
    }
    set speechRecognitionLanguage(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage, e);
    }
    get autoDetectSourceLanguages() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_AutoDetectSourceLanguages);
    }
    set autoDetectSourceLanguages(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_AutoDetectSourceLanguages, e);
    }
    get outputFormat() {
        return $d7238066c5de7f1c$var$B[this.privProperties.getProperty($d7238066c5de7f1c$var$$e, void 0)];
    }
    set outputFormat(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$$e, $d7238066c5de7f1c$var$B[e]);
    }
    get endpointId() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId);
    }
    set endpointId(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId, e);
    }
    setProperty(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNull(t, "value"), this.privProperties.setProperty(e, t);
    }
    getProperty(e, t) {
        return this.privProperties.getProperty(e, t);
    }
    setProxy(e, t, i, n) {
        this.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyHostName], e), this.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyPort], t), this.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyUserName], i), this.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyPassword], n);
    }
    setServiceProperty(e, t) {
        const i = JSON.parse(this.privProperties.getProperty($d7238066c5de7f1c$var$It, "{}"));
        i[e] = t, this.privProperties.setProperty($d7238066c5de7f1c$var$It, JSON.stringify(i));
    }
    setProfanity(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_ProfanityOption, $d7238066c5de7f1c$var$Gt[e]);
    }
    enableAudioLogging() {
        this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privProperties.setProperty($d7238066c5de7f1c$var$aa, "true");
    }
    clone() {
        const e = new $d7238066c5de7f1c$var$xt();
        return e.privProperties = this.privProperties.clone(), e;
    }
    get speechSynthesisLanguage() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthLanguage, e);
    }
    get speechSynthesisVoiceName() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthVoice, e);
    }
    get speechSynthesisOutputFormat() {
        return $d7238066c5de7f1c$var$M[this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthOutputFormat, void 0)];
    }
    set speechSynthesisOutputFormat(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthOutputFormat, $d7238066c5de7f1c$var$M[e]);
    }
}
class $d7238066c5de7f1c$var$Do extends $d7238066c5de7f1c$var$ko {
    /**
   * Creates an instance of recognizer config.
   */ constructor(){
        super();
    }
    /**
   * Static instance of SpeechTranslationConfig returned by passing a subscription key and service region.
   * @member SpeechTranslationConfig.fromSubscription
   * @function
   * @public
   * @param {string} subscriptionKey - The subscription key.
   * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {SpeechTranslationConfig} The speech translation config.
   */ static fromSubscription(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "subscriptionKey"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, "region");
        const i = new $d7238066c5de7f1c$var$qi();
        return i.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, e), i.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, t), i;
    }
    /**
   * Static instance of SpeechTranslationConfig returned by passing authorization token and service region.
   * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
   * expires, the caller needs to refresh it by setting the property authorizationToken with a new
   * valid token. Otherwise, all the recognizers created by this SpeechTranslationConfig instance
   * will encounter errors during recognition.
   * As configuration values are copied when creating a new recognizer, the new token value will not apply
   * to recognizers that have already been created.
   * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
   * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
   * @member SpeechTranslationConfig.fromAuthorizationToken
   * @function
   * @public
   * @param {string} authorizationToken - The authorization token.
   * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {SpeechTranslationConfig} The speech translation config.
   */ static fromAuthorizationToken(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "authorizationToken"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, "region");
        const i = new $d7238066c5de7f1c$var$qi();
        return i.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e), i.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, t), i;
    }
    /**
   * Creates an instance of the speech config with specified host and subscription key.
   * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
   * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
   * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
   * Note: To use an authorization token with fromHost, use fromHost(URL),
   * and then set the AuthorizationToken property on the created SpeechConfig instance.
   * Note: Added in version 1.9.0.
   * @member SpeechConfig.fromHost
   * @function
   * @public
   * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
   * @returns {SpeechConfig} A speech factory instance.
   */ static fromHost(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNull(e, "hostName");
        const i = new $d7238066c5de7f1c$var$qi();
        return i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, e.protocol + "//" + e.hostname + (e.port === "" ? "" : ":" + e.port)), t !== void 0 && i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, t), i;
    }
    /**
   * Creates an instance of the speech translation config with specified endpoint and subscription key.
   * This method is intended only for users who use a non-standard service endpoint or paramters.
   * Note: The query properties specified in the endpoint URL are not changed, even if they are
   * set by any other APIs. For example, if language is defined in the uri as query parameter
   * "language=de-DE", and also set by the speechRecognitionLanguage property, the language
   * setting in uri takes precedence, and the effective language is "de-DE".
   * Only the properties that are not specified in the endpoint URL can be set by other APIs.
   * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
   * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
   * use the authorization token.
   * @member SpeechTranslationConfig.fromEndpoint
   * @function
   * @public
   * @param {URL} endpoint - The service endpoint to connect to.
   * @param {string} subscriptionKey - The subscription key.
   * @returns {SpeechTranslationConfig} A speech config instance.
   */ static fromEndpoint(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNull(e, "endpoint"), $d7238066c5de7f1c$var$l.throwIfNull(t, "subscriptionKey");
        const i = new $d7238066c5de7f1c$var$qi();
        return i.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint, e.href), i.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, t), i;
    }
}
class $d7238066c5de7f1c$var$qi extends $d7238066c5de7f1c$var$Do {
    constructor(){
        super(), this.privSpeechProperties = new $d7238066c5de7f1c$var$U(), this.outputFormat = $d7238066c5de7f1c$var$B.Simple;
    }
    /**
   * Gets/Sets the authorization token.
   * If this is set, subscription key is ignored.
   * User needs to make sure the provided authorization token is valid and not expired.
   * @member SpeechTranslationConfigImpl.prototype.authorizationToken
   * @function
   * @public
   * @param {string} value - The authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "value"), this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    /**
   * Sets the speech recognition language.
   * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @param {string} value - The authorization token.
   */ set speechRecognitionLanguage(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "value"), this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage, e);
    }
    /**
   * Gets the speech recognition language.
   * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @return {string} The speechRecognitionLanguage.
   */ get speechRecognitionLanguage() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage]);
    }
    /**
   * @member SpeechTranslationConfigImpl.prototype.subscriptionKey
   * @function
   * @public
   */ get subscriptionKey() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_Key]);
    }
    /**
   * Gets the output format
   * @member SpeechTranslationConfigImpl.prototype.outputFormat
   * @function
   * @public
   */ get outputFormat() {
        return $d7238066c5de7f1c$var$B[this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$$e, void 0)];
    }
    /**
   * Gets/Sets the output format
   * @member SpeechTranslationConfigImpl.prototype.outputFormat
   * @function
   * @public
   */ set outputFormat(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$$e, $d7238066c5de7f1c$var$B[e]);
    }
    /**
   * Gets the endpoint id.
   * @member SpeechTranslationConfigImpl.prototype.endpointId
   * @function
   * @public
   */ get endpointId() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId);
    }
    /**
   * Gets/Sets the endpoint id.
   * @member SpeechTranslationConfigImpl.prototype.endpointId
   * @function
   * @public
   */ set endpointId(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId, e);
    }
    /**
   * Add a (text) target language to translate into.
   * @member SpeechTranslationConfigImpl.prototype.addTargetLanguage
   * @function
   * @public
   * @param {string} value - The language such as de-DE
   */ addTargetLanguage(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "value");
        const t = this.targetLanguages;
        t.includes(e) || (t.push(e), this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages, t.join(",")));
    }
    /**
   * Gets the (text) target language to translate into.
   * @member SpeechTranslationConfigImpl.prototype.targetLanguages
   * @function
   * @public
   * @param {string} value - The language such as de-DE
   */ get targetLanguages() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0 ? this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages).split(",") : [];
    }
    /**
   * Gets the voice name.
   * @member SpeechTranslationConfigImpl.prototype.voiceName
   * @function
   * @public
   */ get voiceName() {
        return this.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationVoice]);
    }
    /**
   * Gets/Sets the voice of the translated language, enable voice synthesis output.
   * @member SpeechTranslationConfigImpl.prototype.voiceName
   * @function
   * @public
   * @param {string} value - The name of the voice.
   */ set voiceName(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "value"), this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationVoice, e);
    }
    /**
   * Provides the region.
   * @member SpeechTranslationConfigImpl.prototype.region
   * @function
   * @public
   * @returns {string} The region.
   */ get region() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region);
    }
    setProxy(e, t, i, n) {
        this.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyHostName], e), this.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyPort], t), this.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyUserName], i), this.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyPassword], n);
    }
    /**
   * Gets an arbitrary property value.
   * @member SpeechTranslationConfigImpl.prototype.getProperty
   * @function
   * @public
   * @param {string} name - The name of the property.
   * @param {string} def - The default value of the property in case it is not set.
   * @returns {string} The value of the property.
   */ getProperty(e, t) {
        return this.privSpeechProperties.getProperty(e, t);
    }
    /**
   * Gets/Sets an arbitrary property value.
   * @member SpeechTranslationConfigImpl.prototype.setProperty
   * @function
   * @public
   * @param {string | PropertyId} name - The name of the property to set.
   * @param {string} value - The value of the property.
   */ setProperty(e, t) {
        this.privSpeechProperties.setProperty(e, t);
    }
    /**
   * Provides access to custom properties.
   * @member SpeechTranslationConfigImpl.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The properties.
   */ get properties() {
        return this.privSpeechProperties;
    }
    /**
   * Dispose of associated resources.
   * @member SpeechTranslationConfigImpl.prototype.close
   * @function
   * @public
   */ close() {}
    setServiceProperty(e, t) {
        const i = JSON.parse(this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$It, "{}"));
        i[e] = t, this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$It, JSON.stringify(i));
    }
    setProfanity(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_ProfanityOption, $d7238066c5de7f1c$var$Gt[e]);
    }
    enableAudioLogging() {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$aa, "true");
    }
    get speechSynthesisLanguage() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthLanguage, e);
    }
    get speechSynthesisVoiceName() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthVoice, e);
    }
    get speechSynthesisOutputFormat() {
        return $d7238066c5de7f1c$var$M[this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthOutputFormat, void 0)];
    }
    set speechSynthesisOutputFormat(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthOutputFormat, $d7238066c5de7f1c$var$M[e]);
    }
}
class $d7238066c5de7f1c$var$U {
    constructor(){
        this.privKeys = [], this.privValues = [];
    }
    /**
   * Returns the property value in type String.
   * Currently only String, int and bool are allowed.
   * If the name is not available, the specified defaultValue is returned.
   * @member PropertyCollection.prototype.getProperty
   * @function
   * @public
   * @param {string} key - The parameter name.
   * @param {string | number | boolean} def - The default value which is returned if the parameter
   * is not available in the collection.
   * @returns {string} value of the parameter.
   */ getProperty(e, t) {
        let i;
        typeof e == "string" ? i = e : i = $d7238066c5de7f1c$var$u[e];
        for(let n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === i) return this.privValues[n];
        if (t !== void 0) return String(t);
    }
    /**
   * Sets the String value of the parameter specified by name.
   * @member PropertyCollection.prototype.setProperty
   * @function
   * @public
   * @param {string} key - The parameter name.
   * @param {string} value - The value of the parameter.
   */ setProperty(e, t) {
        let i;
        typeof e == "string" ? i = e : i = $d7238066c5de7f1c$var$u[e];
        for(let n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === i) {
            this.privValues[n] = t;
            return;
        }
        this.privKeys.push(i), this.privValues.push(t);
    }
    /**
   * Clones the collection.
   * @member PropertyCollection.prototype.clone
   * @function
   * @public
   * @returns {PropertyCollection} A copy of the collection.
   */ clone() {
        const e = new $d7238066c5de7f1c$var$U();
        for(let t = 0; t < this.privKeys.length; t++)e.privKeys.push(this.privKeys[t]), e.privValues.push(this.privValues[t]);
        return e;
    }
    /**
   * Merges this set of properties into another, no overwrites.
   * @member PropertyCollection.prototype.mergeTo
   * @function
   * @public
   * @param {PropertyCollection}  destinationCollection - The collection to merge into.
   */ mergeTo(e) {
        this.privKeys.forEach((t)=>{
            if (e.getProperty(t, void 0) === void 0) {
                const i = this.getProperty(t);
                e.setProperty(t, i);
            }
        });
    }
    /**
   * Get the keys in Property Collection.
   * @member PropertyCollection.prototype.keys
   * @function
   * @public
   * @returns {string []} Keys in the collection.
   */ get keys() {
        return this.privKeys;
    }
}
var $d7238066c5de7f1c$var$u;
(function(r) {
    r[r.SpeechServiceConnection_Key = 0] = "SpeechServiceConnection_Key", r[r.SpeechServiceConnection_Endpoint = 1] = "SpeechServiceConnection_Endpoint", r[r.SpeechServiceConnection_Region = 2] = "SpeechServiceConnection_Region", r[r.SpeechServiceAuthorization_Token = 3] = "SpeechServiceAuthorization_Token", r[r.SpeechServiceAuthorization_Type = 4] = "SpeechServiceAuthorization_Type", r[r.SpeechServiceConnection_EndpointId = 5] = "SpeechServiceConnection_EndpointId", r[r.SpeechServiceConnection_TranslationToLanguages = 6] = "SpeechServiceConnection_TranslationToLanguages", r[r.SpeechServiceConnection_TranslationVoice = 7] = "SpeechServiceConnection_TranslationVoice", r[r.SpeechServiceConnection_TranslationFeatures = 8] = "SpeechServiceConnection_TranslationFeatures", r[r.SpeechServiceConnection_IntentRegion = 9] = "SpeechServiceConnection_IntentRegion", r[r.SpeechServiceConnection_ProxyHostName = 10] = "SpeechServiceConnection_ProxyHostName", r[r.SpeechServiceConnection_ProxyPort = 11] = "SpeechServiceConnection_ProxyPort", r[r.SpeechServiceConnection_ProxyUserName = 12] = "SpeechServiceConnection_ProxyUserName", r[r.SpeechServiceConnection_ProxyPassword = 13] = "SpeechServiceConnection_ProxyPassword", r[r.SpeechServiceConnection_RecoMode = 14] = "SpeechServiceConnection_RecoMode", r[r.SpeechServiceConnection_RecoLanguage = 15] = "SpeechServiceConnection_RecoLanguage", r[r.Speech_SessionId = 16] = "Speech_SessionId", r[r.SpeechServiceConnection_SynthLanguage = 17] = "SpeechServiceConnection_SynthLanguage", r[r.SpeechServiceConnection_SynthVoice = 18] = "SpeechServiceConnection_SynthVoice", r[r.SpeechServiceConnection_SynthOutputFormat = 19] = "SpeechServiceConnection_SynthOutputFormat", r[r.SpeechServiceConnection_AutoDetectSourceLanguages = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages", r[r.SpeechServiceResponse_RequestDetailedResultTrueFalse = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse", r[r.SpeechServiceResponse_RequestProfanityFilterTrueFalse = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse", r[r.SpeechServiceResponse_JsonResult = 23] = "SpeechServiceResponse_JsonResult", r[r.SpeechServiceResponse_JsonErrorDetails = 24] = "SpeechServiceResponse_JsonErrorDetails", r[r.CancellationDetails_Reason = 25] = "CancellationDetails_Reason", r[r.CancellationDetails_ReasonText = 26] = "CancellationDetails_ReasonText", r[r.CancellationDetails_ReasonDetailedText = 27] = "CancellationDetails_ReasonDetailedText", r[r.LanguageUnderstandingServiceResponse_JsonResult = 28] = "LanguageUnderstandingServiceResponse_JsonResult", r[r.SpeechServiceConnection_Url = 29] = "SpeechServiceConnection_Url", r[r.SpeechServiceConnection_InitialSilenceTimeoutMs = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs", r[r.SpeechServiceConnection_EndSilenceTimeoutMs = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs", r[r.Speech_SegmentationSilenceTimeoutMs = 32] = "Speech_SegmentationSilenceTimeoutMs", r[r.SpeechServiceConnection_EnableAudioLogging = 33] = "SpeechServiceConnection_EnableAudioLogging", r[r.SpeechServiceConnection_LanguageIdMode = 34] = "SpeechServiceConnection_LanguageIdMode", r[r.SpeechServiceConnection_RecognitionEndpointVersion = 35] = "SpeechServiceConnection_RecognitionEndpointVersion", r[r.SpeechServiceConnection_SpeakerIdMode = 36] = "SpeechServiceConnection_SpeakerIdMode", r[r.SpeechServiceResponse_ProfanityOption = 37] = "SpeechServiceResponse_ProfanityOption", r[r.SpeechServiceResponse_PostProcessingOption = 38] = "SpeechServiceResponse_PostProcessingOption", r[r.SpeechServiceResponse_RequestWordLevelTimestamps = 39] = "SpeechServiceResponse_RequestWordLevelTimestamps", r[r.SpeechServiceResponse_StablePartialResultThreshold = 40] = "SpeechServiceResponse_StablePartialResultThreshold", r[r.SpeechServiceResponse_OutputFormatOption = 41] = "SpeechServiceResponse_OutputFormatOption", r[r.SpeechServiceResponse_TranslationRequestStablePartialResult = 42] = "SpeechServiceResponse_TranslationRequestStablePartialResult", r[r.SpeechServiceResponse_RequestWordBoundary = 43] = "SpeechServiceResponse_RequestWordBoundary", r[r.SpeechServiceResponse_RequestPunctuationBoundary = 44] = "SpeechServiceResponse_RequestPunctuationBoundary", r[r.SpeechServiceResponse_RequestSentenceBoundary = 45] = "SpeechServiceResponse_RequestSentenceBoundary", r[r.Conversation_ApplicationId = 46] = "Conversation_ApplicationId", r[r.Conversation_DialogType = 47] = "Conversation_DialogType", r[r.Conversation_Initial_Silence_Timeout = 48] = "Conversation_Initial_Silence_Timeout", r[r.Conversation_From_Id = 49] = "Conversation_From_Id", r[r.Conversation_Conversation_Id = 50] = "Conversation_Conversation_Id", r[r.Conversation_Custom_Voice_Deployment_Ids = 51] = "Conversation_Custom_Voice_Deployment_Ids", r[r.Conversation_Speech_Activity_Template = 52] = "Conversation_Speech_Activity_Template", r[r.Conversation_Request_Bot_Status_Messages = 53] = "Conversation_Request_Bot_Status_Messages", r[r.Conversation_Agent_Connection_Id = 54] = "Conversation_Agent_Connection_Id", r[r.SpeechServiceConnection_Host = 55] = "SpeechServiceConnection_Host", r[r.ConversationTranslator_Host = 56] = "ConversationTranslator_Host", r[r.ConversationTranslator_Name = 57] = "ConversationTranslator_Name", r[r.ConversationTranslator_CorrelationId = 58] = "ConversationTranslator_CorrelationId", r[r.ConversationTranslator_Token = 59] = "ConversationTranslator_Token", r[r.PronunciationAssessment_ReferenceText = 60] = "PronunciationAssessment_ReferenceText", r[r.PronunciationAssessment_GradingSystem = 61] = "PronunciationAssessment_GradingSystem", r[r.PronunciationAssessment_Granularity = 62] = "PronunciationAssessment_Granularity", r[r.PronunciationAssessment_EnableMiscue = 63] = "PronunciationAssessment_EnableMiscue", r[r.PronunciationAssessment_Json = 64] = "PronunciationAssessment_Json", r[r.PronunciationAssessment_Params = 65] = "PronunciationAssessment_Params", r[r.SpeakerRecognition_Api_Version = 66] = "SpeakerRecognition_Api_Version", r[r.WebWorkerLoadType = 67] = "WebWorkerLoadType", r[r.TalkingAvatarService_WebRTC_SDP = 68] = "TalkingAvatarService_WebRTC_SDP";
})($d7238066c5de7f1c$var$u || ($d7238066c5de7f1c$var$u = {}));
var $d7238066c5de7f1c$var$zi = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Fe {
    /**
   * Creates and initializes an instance of a Recognizer
   * @constructor
   * @param {AudioConfig} audioInput - An optional audio input stream associated with the recognizer
   * @param {PropertyCollection} properties - A set of properties to set on the recognizer
   * @param {IConnectionFactory} connectionFactory - The factory class used to create a custom IConnection for the recognizer
   */ constructor(e, t, i){
        this.audioConfig = e !== void 0 ? e : $d7238066c5de7f1c$var$bt.fromDefaultMicrophoneInput(), this.privDisposed = !1, this.privProperties = t.clone(), this.privConnectionFactory = i, this.implCommonRecognizerSetup();
    }
    /**
   * Dispose of associated resources.
   * @member Recognizer.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposed), $d7238066c5de7f1c$var$x(this.dispose(!0), e, t);
    }
    /**
   * @Internal
   * Internal data member to support fromRecognizer* pattern methods on other classes.
   * Do not use externally, object returned will change without warning or notice.
   */ get internalData() {
        return this.privReco;
    }
    /**
   * This method performs cleanup of resources.
   * The Boolean parameter disposing indicates whether the method is called
   * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
   * Derived classes should override this method to dispose resource if needed.
   * @member Recognizer.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - Flag to request disposal.
   */ dispose(e) {
        return $d7238066c5de7f1c$var$zi(this, void 0, void 0, function*() {
            this.privDisposed || (this.privDisposed = !0, e && this.privReco && (yield this.privReco.audioSource.turnOff(), yield this.privReco.dispose()));
        });
    }
    /**
   * This method returns the current state of the telemetry setting.
   * @member Recognizer.prototype.telemetryEnabled
   * @function
   * @public
   * @returns true if the telemetry is enabled, false otherwise.
   */ static get telemetryEnabled() {
        return $d7238066c5de7f1c$var$Ie.telemetryDataEnabled;
    }
    /**
   * This method globally enables or disables telemetry.
   * @member Recognizer.prototype.enableTelemetry
   * @function
   * @public
   * @param enabled - Global setting for telemetry collection.
   * If set to true, telemetry information like microphone errors,
   * recognition errors are collected and sent to Microsoft.
   * If set to false, no telemetry is sent to Microsoft.
   */ static enableTelemetry(e) {
        $d7238066c5de7f1c$var$Ie.telemetryDataEnabled = e;
    }
    // Does the generic recognizer setup that is common across all recognizer types.
    implCommonRecognizerSetup() {
        let e = typeof window < "u" ? "Browser" : "Node", t = "unknown", i = "unknown";
        typeof navigator < "u" && (e = e + "/" + navigator.platform, t = navigator.userAgent, i = navigator.appVersion);
        const n = this.createRecognizerConfig(new $d7238066c5de7f1c$var$wn(new $d7238066c5de7f1c$var$Rn(new $d7238066c5de7f1c$var$dh(e, t, i))));
        this.privReco = this.createServiceRecognizer($d7238066c5de7f1c$var$Fe.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, n);
    }
    recognizeOnceAsyncImpl(e) {
        return $d7238066c5de7f1c$var$zi(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposed);
            const t = new $d7238066c5de7f1c$var$F();
            yield this.implRecognizerStop(), yield this.privReco.recognize(e, t.resolve, t.reject);
            const i = yield t.promise;
            return yield this.implRecognizerStop(), i;
        });
    }
    startContinuousRecognitionAsyncImpl(e) {
        return $d7238066c5de7f1c$var$zi(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposed), yield this.implRecognizerStop(), yield this.privReco.recognize(e, void 0, void 0);
        });
    }
    stopContinuousRecognitionAsyncImpl() {
        return $d7238066c5de7f1c$var$zi(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposed), yield this.implRecognizerStop();
        });
    }
    implRecognizerStop() {
        return $d7238066c5de7f1c$var$zi(this, void 0, void 0, function*() {
            this.privReco && (yield this.privReco.stopRecognizing());
        });
    }
    static getAuthFromProperties(e) {
        const t = e.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, void 0);
        return t && t !== "" ? new $d7238066c5de7f1c$var$Np(t) : new $d7238066c5de7f1c$var$jt(()=>{
            const n = e.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, void 0);
            return Promise.resolve(n);
        }, ()=>{
            const n = e.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, void 0);
            return Promise.resolve(n);
        });
    }
}
var $d7238066c5de7f1c$var$ol = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Oo extends $d7238066c5de7f1c$var$Fe {
    /**
   * SpeechRecognizer constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ constructor(e, t){
        const i = e;
        $d7238066c5de7f1c$var$l.throwIfNull(i, "speechConfig"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(i.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage), $d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage]), super(t, i.properties, new $d7238066c5de7f1c$var$Wl()), this.privDisposedRecognizer = !1;
    }
    /**
   * SpeechRecognizer constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
   * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ static FromConfig(e, t, i) {
        const n = e;
        return t.properties.mergeTo(n.properties), new $d7238066c5de7f1c$var$Oo(e, i);
    }
    /**
   * Gets the endpoint id of a customized speech model that is used for speech recognition.
   * @member SpeechRecognizer.prototype.endpointId
   * @function
   * @public
   * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
   */ get endpointId() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member SpeechRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member SpeechRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    /**
   * Gets the spoken language of recognition.
   * @member SpeechRecognizer.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @returns {string} The spoken language of recognition.
   */ get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage);
    }
    /**
   * Gets the output format of recognition.
   * @member SpeechRecognizer.prototype.outputFormat
   * @function
   * @public
   * @returns {OutputFormat} The output format of recognition.
   */ get outputFormat() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$$e, $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple]) === $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple] ? $d7238066c5de7f1c$var$B.Simple : $d7238066c5de7f1c$var$B.Detailed;
    }
    /**
   * The collection of properties and their values defined for this SpeechRecognizer.
   * @member SpeechRecognizer.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Starts speech recognition, and stops after the first utterance is recognized.
   * The task returns the recognition text as result.
   * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
   * so it is suitable only for single shot recognition
   * like command or query. For long-running recognition, use StartContinuousRecognitionAsync() instead.
   * @member SpeechRecognizer.prototype.recognizeOnceAsync
   * @function
   * @public
   * @param cb - Callback that received the SpeechRecognitionResult.
   * @param err - Callback invoked in case of an error.
   */ recognizeOnceAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.recognizeOnceAsyncImpl($d7238066c5de7f1c$var$ue.Interactive), e, t);
    }
    /**
   * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
   * User must subscribe to events to receive recognition results.
   * @member SpeechRecognizer.prototype.startContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has started.
   * @param err - Callback invoked in case of an error.
   */ startContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.startContinuousRecognitionAsyncImpl($d7238066c5de7f1c$var$ue.Conversation), e, t);
    }
    /**
   * Stops continuous speech recognition.
   * @member SpeechRecognizer.prototype.stopContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    /**
   * Starts speech recognition with keyword spotting, until
   * stopKeywordRecognitionAsync() is called.
   * User must subscribe to events to receive recognition results.
   * Note: Key word spotting functionality is only available on the
   * Speech Devices SDK. This functionality is currently not included in the SDK itself.
   * @member SpeechRecognizer.prototype.startKeywordRecognitionAsync
   * @function
   * @public
   * @param {KeywordRecognitionModel} model The keyword recognition model that
   * specifies the keyword to be recognized.
   * @param cb - Callback invoked once the recognition has started.
   * @param err - Callback invoked in case of an error.
   */ startKeywordRecognitionAsync(e, t, i) {
        $d7238066c5de7f1c$var$l.throwIfNull(e, "model"), i && i("Not yet implemented.");
    }
    /**
   * Stops continuous speech recognition.
   * Note: Key word spotting functionality is only available on the
   * Speech Devices SDK. This functionality is currently not included in the SDK itself.
   * @member SpeechRecognizer.prototype.stopKeywordRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopKeywordRecognitionAsync(e) {
        e && e();
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member SpeechRecognizer.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedRecognizer), $d7238066c5de7f1c$var$x(this.dispose(!0), e, t);
    }
    /**
   * Disposes any resources held by the object.
   * @member SpeechRecognizer.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - true if disposing the object.
   */ dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$ol(this, void 0, void 0, function*() {
            this.privDisposedRecognizer || (e && (this.privDisposedRecognizer = !0, yield this.implRecognizerStop()), yield t.dispose.call(this, e));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$Et(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$Kl(e, t, s, n, this);
    }
}
var $d7238066c5de7f1c$var$al = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$cl extends $d7238066c5de7f1c$var$Fe {
    /**
   * Initializes an instance of the IntentRecognizer.
   * @constructor
   * @param {SpeechConfig} speechConfig - The set of configuration properties.
   * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
   */ constructor(e, t){
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "speechConfig");
        const i = e;
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(i, "speechConfig"), super(t, i.properties, new $d7238066c5de7f1c$var$Ll()), this.privAddedIntents = [], this.privAddedLmIntents = {}, this.privDisposedIntentRecognizer = !1, this.privProperties = i.properties, $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage), $d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage]);
    }
    /**
   * Gets the spoken language of recognition.
   * @member IntentRecognizer.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @returns {string} the spoken language of recognition.
   */ get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedIntentRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage);
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member IntentRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * Note: Please use a token derived from your LanguageUnderstanding subscription key for the Intent recognizer.
   * @member IntentRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @param {string} value - Authorization token.
   */ set authorizationToken(e) {
        this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    /**
   * The collection of properties and their values defined for this IntentRecognizer.
   * @member IntentRecognizer.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their
   * values defined for this IntentRecognizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Starts intent recognition, and stops after the first utterance is recognized.
   * The task returns the recognition text and intent as result.
   * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
   * so it is suitable only for single shot recognition like command or query.
   * For long-running recognition, use StartContinuousRecognitionAsync() instead.
   * @member IntentRecognizer.prototype.recognizeOnceAsync
   * @function
   * @public
   * @param cb - Callback that received the recognition has finished with an IntentRecognitionResult.
   * @param err - Callback invoked in case of an error.
   */ recognizeOnceAsync(e, t) {
        if ($d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedIntentRecognizer), Object.keys(this.privAddedLmIntents).length !== 0 || this.privUmbrellaIntent !== void 0) {
            const i = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", i.Intent), this.privReco.dynamicGrammar.addReferenceGrammar(i.ReferenceGrammars), this.privReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $d7238066c5de7f1c$var$x(this.recognizeOnceAsyncImpl($d7238066c5de7f1c$var$ue.Interactive), e, t);
    }
    /**
   * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
   * User must subscribe to events to receive recognition results.
   * @member IntentRecognizer.prototype.startContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has started.
   * @param err - Callback invoked in case of an error.
   */ startContinuousRecognitionAsync(e, t) {
        if (Object.keys(this.privAddedLmIntents).length !== 0 || this.privUmbrellaIntent !== void 0) {
            const i = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", i.Intent), this.privReco.dynamicGrammar.addReferenceGrammar(i.ReferenceGrammars), this.privReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $d7238066c5de7f1c$var$x(this.startContinuousRecognitionAsyncImpl($d7238066c5de7f1c$var$ue.Conversation), e, t);
    }
    /**
   * Stops continuous intent recognition.
   * @member IntentRecognizer.prototype.stopContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    /**
   * Starts speech recognition with keyword spotting, until stopKeywordRecognitionAsync() is called.
   * User must subscribe to events to receive recognition results.
   * Note: Key word spotting functionality is only available on the Speech Devices SDK.
   * This functionality is currently not included in the SDK itself.
   * @member IntentRecognizer.prototype.startKeywordRecognitionAsync
   * @function
   * @public
   * @param {KeywordRecognitionModel} model - The keyword recognition model that specifies the keyword to be recognized.
   * @param cb - Callback invoked once the recognition has started.
   * @param err - Callback invoked in case of an error.
   */ startKeywordRecognitionAsync(e, t, i) {
        $d7238066c5de7f1c$var$l.throwIfNull(e, "model"), i && i("Not yet implemented.");
    }
    /**
   * Stops continuous speech recognition.
   * Note: Key word spotting functionality is only available on the Speech Devices SDK.
   * This functionality is currently not included in the SDK itself.
   * @member IntentRecognizer.prototype.stopKeywordRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopKeywordRecognitionAsync(e, t) {
        if (e) try {
            e();
        } catch (i) {
            t && t(i);
        }
    }
    /**
   * Adds a phrase that should be recognized as intent.
   * @member IntentRecognizer.prototype.addIntent
   * @function
   * @public
   * @param {string} intentId - A String that represents the identifier of the intent to be recognized.
   * @param {string} phrase - A String that specifies the phrase representing the intent.
   */ addIntent(e, t) {
        $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedIntentRecognizer), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, "intentId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "simplePhrase"), this.privAddedIntents.push([
            t,
            e
        ]);
    }
    /**
   * Adds an intent from Language Understanding service for recognition.
   * @member IntentRecognizer.prototype.addIntentWithLanguageModel
   * @function
   * @public
   * @param {string} intentId - A String that represents the identifier of the intent
   * to be recognized. Ignored if intentName is empty.
   * @param {string} model - The intent model from Language Understanding service.
   * @param {string} intentName - The intent name defined in the intent model. If it
   * is empty, all intent names defined in the model will be added.
   */ addIntentWithLanguageModel(e, t, i) {
        $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedIntentRecognizer), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "intentId"), $d7238066c5de7f1c$var$l.throwIfNull(t, "model");
        const n = t;
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(n.appId, "model.appId"), this.privAddedLmIntents[e] = new $d7238066c5de7f1c$var$Xa(n, i);
    }
    /**
   * @summary Adds all intents from the specified Language Understanding Model.
   * @member IntentRecognizer.prototype.addAllIntents
   * @function
   * @public
   * @function
   * @public
   * @param {LanguageUnderstandingModel} model - The language understanding model containing the intents.
   * @param {string} intentId - A custom id String to be returned in the IntentRecognitionResult's getIntentId() method.
   */ addAllIntents(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNull(e, "model");
        const i = e;
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(i.appId, "model.appId"), this.privUmbrellaIntent = new $d7238066c5de7f1c$var$Xa(i, t);
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member IntentRecognizer.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedIntentRecognizer), $d7238066c5de7f1c$var$x(this.dispose(!0), e, t);
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$Et(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$Ql(e, t, s, n, this);
    }
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$al(this, void 0, void 0, function*() {
            this.privDisposedIntentRecognizer || e && (this.privDisposedIntentRecognizer = !0, yield t.dispose.call(this, e));
        });
    }
    buildSpeechContext() {
        let e, t, i;
        const n = [];
        this.privUmbrellaIntent !== void 0 && (e = this.privUmbrellaIntent.modelImpl.appId, t = this.privUmbrellaIntent.modelImpl.region, i = this.privUmbrellaIntent.modelImpl.subscriptionKey);
        for (const s of Object.keys(this.privAddedLmIntents)){
            const o = this.privAddedLmIntents[s];
            if (e === void 0) e = o.modelImpl.appId;
            else if (e !== o.modelImpl.appId) throw new Error("Intents must all be from the same LUIS model");
            if (t === void 0) t = o.modelImpl.region;
            else if (t !== o.modelImpl.region) throw new Error("Intents must all be from the same LUIS model in a single region");
            if (i === void 0) i = o.modelImpl.subscriptionKey;
            else if (i !== o.modelImpl.subscriptionKey) throw new Error("Intents must all use the same subscription key");
            const c = "luis/" + e + "-PRODUCTION#" + s;
            n.push(c);
        }
        return {
            Intent: {
                id: e,
                key: i === void 0 ? this.privProperties.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_Key]) : i,
                provider: "LUIS"
            },
            ReferenceGrammars: this.privUmbrellaIntent === void 0 ? n : [
                "luis/" + e + "-PRODUCTION"
            ]
        };
    }
}
var $d7238066c5de7f1c$var$ct;
(function(r) {
    r[r.TextIndependentIdentification = 0] = "TextIndependentIdentification", r[r.TextDependentVerification = 1] = "TextDependentVerification", r[r.TextIndependentVerification = 2] = "TextIndependentVerification";
})($d7238066c5de7f1c$var$ct || ($d7238066c5de7f1c$var$ct = {}));
class $d7238066c5de7f1c$var$pl {
}
class $d7238066c5de7f1c$var$Wa {
    constructor(e){
        this.privConnectionMessage = e, this.privProperties = new $d7238066c5de7f1c$var$U(), this.privConnectionMessage.headers[$d7238066c5de7f1c$var$W.ConnectionId] && this.privProperties.setProperty($d7238066c5de7f1c$var$u.Speech_SessionId, this.privConnectionMessage.headers[$d7238066c5de7f1c$var$W.ConnectionId]), Object.keys(this.privConnectionMessage.headers).forEach((t)=>{
            this.privProperties.setProperty(t, this.privConnectionMessage.headers[t]);
        });
    }
    /**
   * The message path.
   */ get path() {
        return this.privConnectionMessage.headers[Object.keys(this.privConnectionMessage.headers).find((e)=>e.toLowerCase() === "path".toLowerCase())];
    }
    /**
   * Checks to see if the ConnectionMessage is a text message.
   * See also IsBinaryMessage().
   */ get isTextMessage() {
        return this.privConnectionMessage.messageType === $d7238066c5de7f1c$var$k.Text;
    }
    /**
   * Checks to see if the ConnectionMessage is a binary message.
   * See also GetBinaryMessage().
   */ get isBinaryMessage() {
        return this.privConnectionMessage.messageType === $d7238066c5de7f1c$var$k.Binary;
    }
    /**
   * Gets the text message payload. Typically the text message content-type is
   * application/json. To determine other content-types use
   * Properties.GetProperty("Content-Type").
   */ get TextMessage() {
        return this.privConnectionMessage.textBody;
    }
    /**
   * Gets the binary message payload.
   */ get binaryMessage() {
        return this.privConnectionMessage.binaryBody;
    }
    /**
   * A collection of properties and their values defined for this <see cref="ConnectionMessage"/>.
   * Message headers can be accessed via this collection (e.g. "Content-Type").
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Returns a string that represents the connection message.
   */ toString() {
        return "";
    }
}
class $d7238066c5de7f1c$var$Jt {
    /**
   * Gets the Connection instance from the specified recognizer.
   * @param recognizer The recognizer associated with the connection.
   * @return The Connection instance of the recognizer.
   */ static fromRecognizer(e) {
        const t = e.internalData, i = new $d7238066c5de7f1c$var$Jt();
        return i.privInternalData = t, i.setupEvents(), i;
    }
    /**
   * Gets the Connection instance from the specified synthesizer.
   * @param synthesizer The synthesizer associated with the connection.
   * @return The Connection instance of the synthesizer.
   */ static fromSynthesizer(e) {
        const t = e.internalData, i = new $d7238066c5de7f1c$var$Jt();
        return i.privInternalData = t, i.setupEvents(), i;
    }
    /**
   * Starts to set up connection to the service.
   * Users can optionally call openConnection() to manually set up a connection in advance before starting recognition on the
   * Recognizer associated with this Connection. After starting recognition, calling Open() will have no effect
   *
   * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
   * be notified when the connection is established.
   */ openConnection(e, t) {
        $d7238066c5de7f1c$var$x(this.privInternalData.connect(), e, t);
    }
    /**
   * Closes the connection the service.
   * Users can optionally call closeConnection() to manually shutdown the connection of the associated Recognizer.
   *
   * If closeConnection() is called during recognition, recognition will fail and cancel with an error.
   */ closeConnection(e, t) {
        if (this.privInternalData instanceof $d7238066c5de7f1c$var$sr) throw new Error("Disconnecting a synthesizer's connection is currently not supported");
        $d7238066c5de7f1c$var$x(this.privInternalData.disconnect(), e, t);
    }
    /**
   * Appends a parameter in a message to service.
   * Added in version 1.12.1.
   * @param path The path of the network message.
   * @param propertyName Name of the property
   * @param propertyValue Value of the property. This is a json string.
   */ setMessageProperty(e, t, i) {
        if ($d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, "propertyName"), this.privInternalData instanceof $d7238066c5de7f1c$var$Ie) {
            if (e.toLowerCase() !== "speech.context") throw new Error("Only speech.context message property sets are currently supported for recognizer");
            this.privInternalData.speechContext.setSection(t, i);
        } else if (this.privInternalData instanceof $d7238066c5de7f1c$var$sr) {
            if (e.toLowerCase() !== "synthesis.context") throw new Error("Only synthesis.context message property sets are currently supported for synthesizer");
            this.privInternalData.synthesisContext.setSection(t, i);
        }
    }
    /**
   * Sends a message to the speech service.
   * Added in version 1.13.0.
   * @param path The WebSocket path of the message
   * @param payload The payload of the message. This is a json string or a ArrayBuffer.
   * @param success A callback to indicate success.
   * @param error A callback to indicate an error.
   */ sendMessageAsync(e, t, i, n) {
        $d7238066c5de7f1c$var$x(this.privInternalData.sendNetworkMessage(e, t), i, n);
    }
    /**
   * Dispose of associated resources.
   */ close() {}
    setupEvents() {
        this.privEventListener = this.privInternalData.connectionEvents.attach((e)=>{
            e.name === "ConnectionEstablishedEvent" ? this.connected && this.connected(new $d7238066c5de7f1c$var$Us(e.connectionId)) : e.name === "ConnectionClosedEvent" ? this.disconnected && this.disconnected(new $d7238066c5de7f1c$var$Us(e.connectionId)) : e.name === "ConnectionMessageSentEvent" ? this.messageSent && this.messageSent(new $d7238066c5de7f1c$var$qs(new $d7238066c5de7f1c$var$Wa(e.message))) : e.name === "ConnectionMessageReceivedEvent" && this.messageReceived && this.messageReceived(new $d7238066c5de7f1c$var$qs(new $d7238066c5de7f1c$var$Wa(e.message)));
        }), this.privServiceEventListener = this.privInternalData.serviceEvents.attach((e)=>{
            this.receivedServiceMessage && this.receivedServiceMessage(new $d7238066c5de7f1c$var$Bp(e.jsonString, e.name));
        });
    }
}
var $d7238066c5de7f1c$var$hl = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$mn extends $d7238066c5de7f1c$var$Fe {
    /**
   * Initializes an instance of the TranslationRecognizer.
   * @constructor
   * @param {SpeechTranslationConfig} speechConfig - Set of properties to configure this recognizer.
   * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
   * @param {IConnectionFactory} connectionFactory - An optional connection factory to use to generate the endpoint URIs, headers to set, etc...
   */ constructor(e, t, i){
        const n = e;
        $d7238066c5de7f1c$var$l.throwIfNull(n, "speechConfig"), super(t, n.properties, i || new $d7238066c5de7f1c$var$ch()), this.privDisposedTranslationRecognizer = !1, this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationVoice, void 0) !== void 0 && $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationVoice), $d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationVoice]), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages), $d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages]), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage), $d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage]);
    }
    /**
   * TranslationRecognizer constructor.
   * @constructor
   * @param {SpeechTranslationConfig} speechTranslationConfig - an set of initial properties for this recognizer
   * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ static FromConfig(e, t, i) {
        const n = e;
        return t.properties.mergeTo(n.properties), new $d7238066c5de7f1c$var$mn(e, i);
    }
    /**
   * Gets the language name that was set when the recognizer was created.
   * @member TranslationRecognizer.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @returns {string} Gets the language name that was set when the recognizer was created.
   */ get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage);
    }
    /**
   * Gets target languages for translation that were set when the recognizer was created.
   * The language is specified in BCP-47 format. The translation will provide translated text for each of language.
   * @member TranslationRecognizer.prototype.targetLanguages
   * @function
   * @public
   * @returns {string[]} Gets target languages for translation that were set when the recognizer was created.
   */ get targetLanguages() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages).split(",");
    }
    /**
   * Gets the name of output voice.
   * @member TranslationRecognizer.prototype.voiceName
   * @function
   * @public
   * @returns {string} the name of output voice.
   */ get voiceName() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationVoice, void 0);
    }
    /**
   * The collection of properties and their values defined for this TranslationRecognizer.
   * @member TranslationRecognizer.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this TranslationRecognizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member TranslationRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member TranslationRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @param {string} value - Authorization token.
   */ set authorizationToken(e) {
        this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    /**
   * Starts recognition and translation, and stops after the first utterance is recognized.
   * The task returns the translation text as result.
   * Note: recognizeOnceAsync returns when the first utterance has been recognized, so it is suitable only
   * for single shot recognition like command or query. For long-running recognition,
   * use startContinuousRecognitionAsync() instead.
   * @member TranslationRecognizer.prototype.recognizeOnceAsync
   * @function
   * @public
   * @param cb - Callback that received the result when the translation has completed.
   * @param err - Callback invoked in case of an error.
   */ recognizeOnceAsync(e, t) {
        $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedTranslationRecognizer), $d7238066c5de7f1c$var$x(this.recognizeOnceAsyncImpl($d7238066c5de7f1c$var$ue.Interactive), e, t);
    }
    /**
   * Starts recognition and translation, until stopContinuousRecognitionAsync() is called.
   * User must subscribe to events to receive translation results.
   * @member TranslationRecognizer.prototype.startContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback that received the translation has started.
   * @param err - Callback invoked in case of an error.
   */ startContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.startContinuousRecognitionAsyncImpl($d7238066c5de7f1c$var$ue.Conversation), e, t);
    }
    /**
   * Stops continuous recognition and translation.
   * @member TranslationRecognizer.prototype.stopContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback that received the translation has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    /**
   * dynamically remove a language from list of target language
   * (can be used while recognition is ongoing)
   * @member TranslationRecognizer.prototype.removeTargetLanguage
   * @function
   * @param lang - language to be removed
   * @public
   */ removeTargetLanguage(e) {
        if ($d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "language to be removed"), this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0) {
            const t = this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages).split(","), i = t.indexOf(e);
            i > -1 && (t.splice(i, 1), this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages, t.join(",")), this.updateLanguages(t));
        }
    }
    /**
   * dynamically add a language to list of target language
   * (can be used while recognition is ongoing)
   * @member TranslationRecognizer.prototype.addTargetLanguage
   * @function
   * @param lang - language to be added
   * @public
   */ addTargetLanguage(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "language to be added");
        let t = [];
        this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0 ? (t = this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages).split(","), t.includes(e) || (t.push(e), this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages, t.join(",")))) : (this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages, e), t = [
            e
        ]), this.updateLanguages(t);
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member TranslationRecognizer.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedTranslationRecognizer), $d7238066c5de7f1c$var$x(this.dispose(!0), e, t);
    }
    /**
   * handles ConnectionEstablishedEvent for conversation translation scenarios.
   * @member TranslationRecognizer.prototype.onConnection
   * @function
   * @public
   */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    onConnection() {}
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$hl(this, void 0, void 0, function*() {
            this.privDisposedTranslationRecognizer || (this.privDisposedTranslationRecognizer = !0, e && (yield this.implRecognizerStop(), yield t.dispose.call(this, e)));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$Et(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$Fl(e, t, s, n, this);
    }
    updateLanguages(e) {
        const t = $d7238066c5de7f1c$var$Jt.fromRecognizer(this);
        t && (t.setMessageProperty("speech.context", "translationcontext", {
            to: e
        }), t.sendMessageAsync("event", JSON.stringify({
            id: "translation",
            name: "updateLanguage",
            to: e
        })));
    }
}
class $d7238066c5de7f1c$var$zo {
    constructor(){
        this.privMap = new $d7238066c5de7f1c$var$U();
    }
    /**
   * Get the languages in the object in a String array.
   * @member Translations.prototype.languages
   * @function
   * @public
   * @returns {string[]} languages in translations object.
   */ get languages() {
        return this.privMap.keys;
    }
    /**
   * Returns the parameter value in type String. The parameter must have the same type as String.
   * Currently only String, int and bool are allowed.
   * If the name is not available, the specified defaultValue is returned.
   * @member Translations.prototype.get
   * @function
   * @public
   * @param {string} key - The parameter name.
   * @param {string} def - The default value which is returned if the parameter is not available in the collection.
   * @returns {string} value of the parameter.
   */ get(e, t) {
        return this.privMap.getProperty(e, t);
    }
    /**
   * Sets the String value of the parameter specified by name.
   * @member Translations.prototype.set
   * @function
   * @public
   * @param {string} key - The parameter name.
   * @param {string} value - The value of the parameter.
   */ set(e, t) {
        this.privMap.setProperty(e, t);
    }
}
var $d7238066c5de7f1c$var$Ft;
(function(r) {
    r[r.NotRecognized = 0] = "NotRecognized", r[r.InitialSilenceTimeout = 1] = "InitialSilenceTimeout", r[r.InitialBabbleTimeout = 2] = "InitialBabbleTimeout";
})($d7238066c5de7f1c$var$Ft || ($d7238066c5de7f1c$var$Ft = {}));
class $d7238066c5de7f1c$var$No {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {NoMatchReason} reason - The no-match reason.
   */ constructor(e){
        this.privReason = e;
    }
    /**
   * Creates an instance of NoMatchDetails object for the NoMatch SpeechRecognitionResults.
   * @member NoMatchDetails.fromResult
   * @function
   * @public
   * @param {SpeechRecognitionResult | IntentRecognitionResult | TranslationRecognitionResult}
   * result - The recognition result that was not recognized.
   * @returns {NoMatchDetails} The no match details object being created.
   */ static fromResult(e) {
        const t = $d7238066c5de7f1c$var$kt.fromJSON(e.json);
        let i = $d7238066c5de7f1c$var$Ft.NotRecognized;
        switch(t.RecognitionStatus){
            case $d7238066c5de7f1c$var$H.BabbleTimeout:
                i = $d7238066c5de7f1c$var$Ft.InitialBabbleTimeout;
                break;
            case $d7238066c5de7f1c$var$H.InitialSilenceTimeout:
                i = $d7238066c5de7f1c$var$Ft.InitialSilenceTimeout;
                break;
            default:
                i = $d7238066c5de7f1c$var$Ft.NotRecognized;
                break;
        }
        return new $d7238066c5de7f1c$var$No(i);
    }
    /**
   * The reason the recognition was canceled.
   * @member NoMatchDetails.prototype.reason
   * @function
   * @public
   * @returns {NoMatchReason} Specifies the reason canceled.
   */ get reason() {
        return this.privReason;
    }
}
class $d7238066c5de7f1c$var$Bs {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} sessionid - The session id.
   * @param {CancellationReason} cancellationReason - The cancellation reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {TranslationRecognitionResult} result - The result.
   */ constructor(e, t, i, n, s){
        this.privCancelReason = t, this.privErrorDetails = i, this.privResult = s, this.privSessionId = e, this.privErrorCode = n;
    }
    /**
   * Specifies the recognition result.
   * @member TranslationRecognitionCanceledEventArgs.prototype.result
   * @function
   * @public
   * @returns {TranslationRecognitionResult} the recognition result.
   */ get result() {
        return this.privResult;
    }
    /**
   * Specifies the session identifier.
   * @member TranslationRecognitionCanceledEventArgs.prototype.sessionId
   * @function
   * @public
   * @returns {string} the session identifier.
   */ get sessionId() {
        return this.privSessionId;
    }
    /**
   * The reason the recognition was canceled.
   * @member TranslationRecognitionCanceledEventArgs.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */ get reason() {
        return this.privCancelReason;
    }
    /**
   * The error code in case of an unsuccessful recognition.
   * Added in version 1.1.0.
   * @return An error code that represents the error reason.
   */ get errorCode() {
        return this.privErrorCode;
    }
    /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member TranslationRecognitionCanceledEventArgs.prototype.errorDetails
   * @function
   * @public
   * @returns {string} A String that represents the error details.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
}
class $d7238066c5de7f1c$var$$p extends $d7238066c5de7f1c$var$ui {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {CancellationReason} result - The result of the intent recognition.
   * @param {string} offset - The offset.
   * @param {IntentRecognitionResult} sessionId - The session id.
   */ constructor(e, t, i, n, s, o){
        super(n, s, o), this.privReason = e, this.privErrorDetails = t, this.privErrorCode = i;
    }
    /**
   * The reason the recognition was canceled.
   * @member IntentRecognitionCanceledEventArgs.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */ get reason() {
        return this.privReason;
    }
    /**
   * The error code in case of an unsuccessful recognition.
   * Added in version 1.1.0.
   * @return An error code that represents the error reason.
   */ get errorCode() {
        return this.privErrorCode;
    }
    /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member IntentRecognitionCanceledEventArgs.prototype.errorDetails
   * @function
   * @public
   * @returns {string} A String that represents the error details.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
}
class $d7238066c5de7f1c$var$lr {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {CancellationReason} reason - The cancellation reason.
   * @param {string} errorDetails - The error details, if provided.
   */ constructor(e, t, i){
        this.privReason = e, this.privErrorDetails = t, this.privErrorCode = i;
    }
    /**
   * The reason the recognition was canceled.
   * @member CancellationDetailsBase.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */ get reason() {
        return this.privReason;
    }
    /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member CancellationDetailsBase.prototype.errorDetails
   * @function
   * @public
   * @returns {string} A String that represents the error details.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
   * The error code in case of an unsuccessful recognition.
   * Added in version 1.1.0.
   * @return An error code that represents the error reason.
   */ get ErrorCode() {
        return this.privErrorCode;
    }
}
class $d7238066c5de7f1c$var$Mo extends $d7238066c5de7f1c$var$lr {
    constructor(e, t, i){
        super(e, t, i);
    }
    /**
   * Creates an instance of CancellationDetails object for the canceled RecognitionResult.
   * @member CancellationDetails.fromResult
   * @function
   * @public
   * @param {RecognitionResult | SpeechSynthesisResult} result - The result that was canceled.
   * @returns {CancellationDetails} The cancellation details object being created.
   */ static fromResult(e) {
        let t = $d7238066c5de7f1c$var$X.Error, i = $d7238066c5de7f1c$var$T.NoError;
        if (e instanceof $d7238066c5de7f1c$var$fn && e.json) {
            const n = $d7238066c5de7f1c$var$kt.fromJSON(e.json);
            t = $d7238066c5de7f1c$var$he.implTranslateCancelResult(n.RecognitionStatus);
        }
        return e.properties && (i = $d7238066c5de7f1c$var$T[e.properties.getProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.NoError])]), new $d7238066c5de7f1c$var$Mo(t, e.errorDetails || $d7238066c5de7f1c$var$he.implTranslateErrorDetails(i), i);
    }
}
var $d7238066c5de7f1c$var$T;
(function(r) {
    r[r.NoError = 0] = "NoError", r[r.AuthenticationFailure = 1] = "AuthenticationFailure", r[r.BadRequestParameters = 2] = "BadRequestParameters", r[r.TooManyRequests = 3] = "TooManyRequests", r[r.ConnectionFailure = 4] = "ConnectionFailure", r[r.ServiceTimeout = 5] = "ServiceTimeout", r[r.ServiceError = 6] = "ServiceError", r[r.RuntimeError = 7] = "RuntimeError", r[r.Forbidden = 8] = "Forbidden";
})($d7238066c5de7f1c$var$T || ($d7238066c5de7f1c$var$T = {}));
class $d7238066c5de7f1c$var$Us extends $d7238066c5de7f1c$var$Ce {
}
class $d7238066c5de7f1c$var$Bp extends $d7238066c5de7f1c$var$Ce {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} json - json payload of the USP message.
   */ constructor(e, t, i){
        super(i), this.privJsonResult = e, this.privEventName = t;
    }
    get jsonString() {
        return this.privJsonResult;
    }
    get eventName() {
        return this.privEventName;
    }
}
class $d7238066c5de7f1c$var$xo {
    constructor(e){
        this.privGrammerBuilder = e.dynamicGrammar;
    }
    /**
   * Creates a PhraseListGrammar from a given speech recognizer. Will accept any recognizer that derives from @class Recognizer.
   * @param recognizer The recognizer to add phrase lists to.
   */ static fromRecognizer(e) {
        const t = e.internalData;
        return new $d7238066c5de7f1c$var$xo(t);
    }
    /**
   * Adds a single phrase to the current recognizer.
   * @param phrase Phrase to add.
   */ addPhrase(e) {
        this.privGrammerBuilder.addPhrase(e);
    }
    /**
   * Adds multiple phrases to the current recognizer.
   * @param phrases Array of phrases to add.
   */ addPhrases(e) {
        this.privGrammerBuilder.addPhrase(e);
    }
    /**
   * Clears all phrases added to the current recognizer.
   */ clear() {
        this.privGrammerBuilder.clearPhrases();
    }
}
class $d7238066c5de7f1c$var$_e {
    /**
   * Creates an instance of DialogService config.
   * @constructor
   */ constructor(){}
    /**
   * Sets the corresponding backend application identifier.
   * @member DialogServiceConfig.prototype.Conversation_ApplicationId
   * @function
   * @public
   * @param {string} value - The application identifier to set.
   */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    set applicationId(e) {}
    static get DialogTypes() {
        return {
            BotFramework: "bot_framework",
            CustomCommands: "custom_commands"
        };
    }
}
class $d7238066c5de7f1c$var$Mt extends $d7238066c5de7f1c$var$_e {
    /**
   * Creates an instance of dialogService config.
   */ constructor(){
        super(), this.privSpeechConfig = new $d7238066c5de7f1c$var$xt();
    }
    /**
   * Provides access to custom properties.
   * @member DialogServiceConfigImpl.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The properties.
   */ get properties() {
        return this.privSpeechConfig.properties;
    }
    /**
   * Gets the speech recognition language.
   * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
   * @function
   * @public
   */ get speechRecognitionLanguage() {
        return this.privSpeechConfig.speechRecognitionLanguage;
    }
    /**
   * Sets the speech recognition language.
   * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @param {string} value - The language to set.
   */ set speechRecognitionLanguage(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "value"), this.privSpeechConfig.speechRecognitionLanguage = e;
    }
    get outputFormat() {
        return this.privSpeechConfig.outputFormat;
    }
    set outputFormat(e) {
        this.privSpeechConfig.outputFormat = e;
    }
    /**
   * Sets a named property as value
   * @member DialogServiceConfigImpl.prototype.setProperty
   * @function
   * @public
   * @param {PropertyId | string} name - The property to set.
   * @param {string} value - The value.
   */ setProperty(e, t) {
        this.privSpeechConfig.setProperty(e, t);
    }
    /**
   * Sets a named property as value
   * @member DialogServiceConfigImpl.prototype.getProperty
   * @function
   * @public
   * @param {PropertyId | string} name - The property to get.
   * @param {string} def - The default value to return in case the property is not known.
   * @returns {string} The current value, or provided default, of the given property.
   */ getProperty(e, t) {
        return this.privSpeechConfig.getProperty(e);
    }
    /**
   * Sets the proxy configuration.
   * Only relevant in Node.js environments.
   * Added in version 1.4.0.
   * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
   * @param proxyPort The port number of the proxy server.
   * @param proxyUserName The user name of the proxy server.
   * @param proxyPassword The password of the proxy server.
   */ setProxy(e, t, i, n) {
        this.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyHostName, e), this.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyPort, `${t}`), i && this.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyUserName, i), n && this.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyPassword, n);
    }
    setServiceProperty(e, t, i) {
        this.privSpeechConfig.setServiceProperty(e, t);
    }
    /**
   * Dispose of associated resources.
   * @member DialogServiceConfigImpl.prototype.close
   * @function
   * @public
   */ close() {}
}
class $d7238066c5de7f1c$var$ul extends $d7238066c5de7f1c$var$Mt {
    /**
   * Creates an instance of BotFrameworkConfig.
   */ constructor(){
        super();
    }
    /**
   * Creates a bot framework configuration instance with the provided subscription information.
   * @member BotFrameworkConfig.fromSubscription
   * @function
   * @public
   * @param subscription Subscription key associated with the bot
   * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
   * resource name.
   * @returns {BotFrameworkConfig} A new bot framework configuration instance.
   */ static fromSubscription(e, t, i) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "subscription"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, "region");
        const n = new $d7238066c5de7f1c$var$Mt();
        return n.setProperty($d7238066c5de7f1c$var$u.Conversation_DialogType, $d7238066c5de7f1c$var$_e.DialogTypes.BotFramework), n.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, e), n.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, t), i && n.setProperty($d7238066c5de7f1c$var$u.Conversation_ApplicationId, i), n;
    }
    /**
   * Creates a bot framework configuration instance for the specified authorization token and region.
   * Note: The caller must ensure that an authorization token is valid. Before an authorization token expires, the
   * caller must refresh it by setting the authorizationToken property on the corresponding
   * DialogServiceConnector instance created with this config. The contents of configuration objects are copied
   * when connectors are created, so setting authorizationToken on a DialogServiceConnector will not update the
   * original configuration's authorization token. Create a new configuration instance or set the
   * SpeechServiceAuthorization_Token property to update an existing instance if it will be used to create
   * further DialogServiceConnectors.
   * @member BotFrameworkConfig.fromAuthorizationToken
   * @function
   * @public
   * @param authorizationToken The authorization token associated with the bot
   * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
   * resource name.
   * @returns {BotFrameworkConfig} A new bot framework configuration instance.
   */ static fromAuthorizationToken(e, t, i) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "authorizationToken"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, "region");
        const n = new $d7238066c5de7f1c$var$Mt();
        return n.setProperty($d7238066c5de7f1c$var$u.Conversation_DialogType, $d7238066c5de7f1c$var$_e.DialogTypes.BotFramework), n.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e), n.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, t), i && n.setProperty($d7238066c5de7f1c$var$u.Conversation_ApplicationId, i), n;
    }
    /**
   * Creates an instance of a BotFrameworkConfig.
   * This method is intended only for users who use a non-default service host. The standard resource path will be
   * assumed. For services with a non-standard resource path or no path at all, use fromEndpoint instead.
   * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
   * Note: To use an authorization token with fromHost, use fromHost(URL) and then set the AuthorizationToken
   * property on the created BotFrameworkConfig instance.
   * Note: Added in version 1.15.0.
   * @member BotFrameworkConfig.fromHost
   * @function
   * @public
   * @param {URL | string} host - If a URL is provided, the fully-qualified host with protocol (e.g.
   * wss://your.host.com:1234) will be used. If a string is provided, it will be embedded in
   * wss://{host}.convai.speech.azure.us.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
   * token must be set.
   * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
   * resource name.
   * @returns {BotFrameworkConfig} A new bot framework configuration instance.
   */ static fromHost(e, t, i) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "host");
        const n = e instanceof URL ? e : new URL(`wss://${e}.convai.speech.azure.us`);
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(n, "resolvedHost");
        const s = new $d7238066c5de7f1c$var$Mt();
        return s.setProperty($d7238066c5de7f1c$var$u.Conversation_DialogType, $d7238066c5de7f1c$var$_e.DialogTypes.BotFramework), s.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, n.toString()), t !== void 0 && s.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, t), s;
    }
    /**
   * Creates an instance of a BotFrameworkConfig.
   * This method is intended only for users who use a non-standard service endpoint or parameters.
   * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
   * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
   * fromEndpoint method, and then set authorizationToken="token" on the created BotFrameworkConfig instance to
   * use the authorization token.
   * Note: Added in version 1.15.0.
   * @member BotFrameworkConfig.fromEndpoint
   * @function
   * @public
   * @param {URL} endpoint - The service endpoint to connect to.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
   * token must be set.
   * @returns {BotFrameworkConfig} - A new bot framework configuration instance using the provided endpoint.
   */ static fromEndpoint(e, t) {
        $d7238066c5de7f1c$var$l.throwIfNull(e, "endpoint");
        const i = new $d7238066c5de7f1c$var$Mt();
        return i.setProperty($d7238066c5de7f1c$var$u.Conversation_DialogType, $d7238066c5de7f1c$var$_e.DialogTypes.BotFramework), i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint, e.toString()), t !== void 0 && i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, t), i;
    }
}
class $d7238066c5de7f1c$var$dl extends $d7238066c5de7f1c$var$Mt {
    /**
   * Creates an instance of CustomCommandsConfig.
   */ constructor(){
        super();
    }
    /**
   * Creates an instance of the bot framework config with the specified subscription and region.
   * @member CustomCommandsConfig.fromSubscription
   * @function
   * @public
   * @param applicationId Speech Commands application id.
   * @param subscription Subscription key associated with the bot
   * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {CustomCommandsConfig} A new bot framework config.
   */ static fromSubscription(e, t, i) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "applicationId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, "subscription"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(i, "region");
        const n = new $d7238066c5de7f1c$var$Mt();
        return n.setProperty($d7238066c5de7f1c$var$u.Conversation_DialogType, $d7238066c5de7f1c$var$_e.DialogTypes.CustomCommands), n.setProperty($d7238066c5de7f1c$var$u.Conversation_ApplicationId, e), n.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, t), n.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, i), n;
    }
    /**
   * Creates an instance of the bot framework config with the specified Speech Commands application id, authorization token and region.
   * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
   * expires, the caller needs to refresh it by calling this setter with a new valid token.
   * As configuration values are copied when creating a new recognizer, the new token value will not apply to recognizers that have already been created.
   * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
   * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
   * @member CustomCommandsConfig.fromAuthorizationToken
   * @function
   * @public
   * @param applicationId Speech Commands application id.
   * @param authorizationToken The authorization token associated with the application.
   * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {CustomCommandsConfig} A new speech commands config.
   */ static fromAuthorizationToken(e, t, i) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "applicationId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, "authorizationToken"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(i, "region");
        const n = new $d7238066c5de7f1c$var$Mt();
        return n.setProperty($d7238066c5de7f1c$var$u.Conversation_DialogType, $d7238066c5de7f1c$var$_e.DialogTypes.CustomCommands), n.setProperty($d7238066c5de7f1c$var$u.Conversation_ApplicationId, e), n.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, t), n.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, i), n;
    }
    /**
   * Sets the corresponding backend application identifier.
   * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
   * @function
   * @public
   * @param {string} value - The application identifier to set.
   */ set applicationId(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "value"), this.setProperty($d7238066c5de7f1c$var$u.Conversation_ApplicationId, e);
    }
    /**
   * Gets the corresponding backend application identifier.
   * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
   * @function
   * @public
   * @param {string} value - The application identifier to get.
   */ get applicationId() {
        return this.getProperty($d7238066c5de7f1c$var$u.Conversation_ApplicationId);
    }
}
class $d7238066c5de7f1c$var$w {
}
$d7238066c5de7f1c$var$w.BotId = "botid";
$d7238066c5de7f1c$var$w.CustomSpeechDeploymentId = "cid";
$d7238066c5de7f1c$var$w.CustomVoiceDeploymentId = "deploymentId";
$d7238066c5de7f1c$var$w.EnableAudioLogging = "storeAudio";
$d7238066c5de7f1c$var$w.EnableLanguageId = "lidEnabled";
$d7238066c5de7f1c$var$w.EnableWordLevelTimestamps = "wordLevelTimestamps";
$d7238066c5de7f1c$var$w.EndSilenceTimeoutMs = "endSilenceTimeoutMs";
$d7238066c5de7f1c$var$w.SegmentationSilenceTimeoutMs = "segmentationSilenceTimeoutMs";
$d7238066c5de7f1c$var$w.Format = "format";
$d7238066c5de7f1c$var$w.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs";
$d7238066c5de7f1c$var$w.Language = "language";
$d7238066c5de7f1c$var$w.Profanity = "profanity";
$d7238066c5de7f1c$var$w.RequestBotStatusMessages = "enableBotMessageStatus";
$d7238066c5de7f1c$var$w.StableIntermediateThreshold = "stableIntermediateThreshold";
$d7238066c5de7f1c$var$w.StableTranslation = "stableTranslation";
$d7238066c5de7f1c$var$w.TestHooks = "testhooks";
$d7238066c5de7f1c$var$w.Postprocessing = "postprocessing";
$d7238066c5de7f1c$var$w.CtsMeetingId = "meetingId";
$d7238066c5de7f1c$var$w.CtsDeviceId = "deviceId";
$d7238066c5de7f1c$var$w.CtsIsParticipant = "isParticipant";
$d7238066c5de7f1c$var$w.EnableAvatar = "enableTalkingAvatar";
class $d7238066c5de7f1c$var$fe {
    static getHostSuffix(e) {
        if (e) {
            if (e.toLowerCase().startsWith("china")) return ".azure.cn";
            if (e.toLowerCase().startsWith("usgov")) return ".azure.us";
        }
        return ".microsoft.com";
    }
    setCommonUrlParams(e, t, i) {
        /* @__PURE__ */ new Map([
            [
                $d7238066c5de7f1c$var$u.Speech_SegmentationSilenceTimeoutMs,
                $d7238066c5de7f1c$var$w.SegmentationSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceConnection_EnableAudioLogging,
                $d7238066c5de7f1c$var$w.EnableAudioLogging
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceConnection_EndSilenceTimeoutMs,
                $d7238066c5de7f1c$var$w.EndSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceConnection_InitialSilenceTimeoutMs,
                $d7238066c5de7f1c$var$w.InitialSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceResponse_PostProcessingOption,
                $d7238066c5de7f1c$var$w.Postprocessing
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceResponse_ProfanityOption,
                $d7238066c5de7f1c$var$w.Profanity
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceResponse_RequestWordLevelTimestamps,
                $d7238066c5de7f1c$var$w.EnableWordLevelTimestamps
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceResponse_StablePartialResultThreshold,
                $d7238066c5de7f1c$var$w.StableIntermediateThreshold
            ]
        ]).forEach((o, c)=>{
            this.setUrlParameter(c, o, e, t, i);
        });
        const s = JSON.parse(e.parameters.getProperty($d7238066c5de7f1c$var$It, "{}"));
        Object.keys(s).forEach((o)=>{
            t[o] = s[o];
        });
    }
    setUrlParameter(e, t, i, n, s) {
        const o = i.parameters.getProperty(e, void 0);
        o && (!s || s.search(t) === -1) && (n[t] = o.toLocaleLowerCase());
    }
}
class $d7238066c5de7f1c$var$yi extends $d7238066c5de7f1c$var$fe {
    create(e, t, i) {
        const n = e.parameters.getProperty($d7238066c5de7f1c$var$u.Conversation_ApplicationId, ""), s = e.parameters.getProperty($d7238066c5de7f1c$var$u.Conversation_DialogType), o = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region), c = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage, "en-US"), p = e.parameters.getProperty($d7238066c5de7f1c$var$u.Conversation_Request_Bot_Status_Messages, "true"), h = {};
        h[$d7238066c5de7f1c$var$W.ConnectionId] = i, h[$d7238066c5de7f1c$var$w.Format] = e.parameters.getProperty($d7238066c5de7f1c$var$$e, $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple]).toLowerCase(), h[$d7238066c5de7f1c$var$w.Language] = c, h[$d7238066c5de7f1c$var$w.RequestBotStatusMessages] = p, n && (h[$d7238066c5de7f1c$var$w.BotId] = n, s === $d7238066c5de7f1c$var$_e.DialogTypes.CustomCommands && (h[$d7238066c5de7f1c$var$W.CustomCommandsAppId] = n));
        const a = s === $d7238066c5de7f1c$var$_e.DialogTypes.CustomCommands ? "commands/" : "", d = s === $d7238066c5de7f1c$var$_e.DialogTypes.CustomCommands ? "v1" : s === $d7238066c5de7f1c$var$_e.DialogTypes.BotFramework ? "v3" : "v0", v = {};
        t.token != null && t.token !== "" && (v[t.headerName] = t.token);
        let g = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint, "");
        if (!g) {
            const A = $d7238066c5de7f1c$var$fe.getHostSuffix(o), D = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, `wss://${o}.${$d7238066c5de7f1c$var$yi.BaseUrl}${A}`);
            g = `${D.endsWith("/") ? D : D + "/"}${a}${$d7238066c5de7f1c$var$yi.ApiKey}/${d}`;
        }
        this.setCommonUrlParams(e, h, g);
        const I = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$ut(g, h, v, new $d7238066c5de7f1c$var$At(), $d7238066c5de7f1c$var$Ve.fromRecognizerConfig(e), I, i);
    }
}
$d7238066c5de7f1c$var$yi.ApiKey = "api";
$d7238066c5de7f1c$var$yi.BaseUrl = "convai.speech";
var $d7238066c5de7f1c$var$Ha = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$ll extends $d7238066c5de7f1c$var$Fe {
    /**
   * Initializes an instance of the DialogServiceConnector.
   * @constructor
   * @param {DialogServiceConfig} dialogConfig - Set of properties to configure this recognizer.
   * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
   */ constructor(e, t){
        const i = e;
        $d7238066c5de7f1c$var$l.throwIfNull(e, "dialogConfig"), super(t, i.properties, new $d7238066c5de7f1c$var$yi()), this.isTurnComplete = !0, this.privIsDisposed = !1, this.privProperties = i.properties.clone();
        const n = this.buildAgentConfig();
        this.privReco.agentConfig.set(n);
    }
    /**
   * Starts a connection to the service.
   * Users can optionally call connect() to manually set up a connection in advance, before starting interactions.
   *
   * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
   * be notified when the connection is established.
   * @member DialogServiceConnector.prototype.connect
   * @function
   * @public
   */ connect(e, t) {
        $d7238066c5de7f1c$var$x(this.privReco.connect(), e, t);
    }
    /**
   * Closes the connection the service.
   * Users can optionally call disconnect() to manually shutdown the connection of the associated DialogServiceConnector.
   *
   * If disconnect() is called during a recognition, recognition will fail and cancel with an error.
   */ disconnect(e, t) {
        $d7238066c5de7f1c$var$x(this.privReco.disconnect(), e, t);
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member DialogServiceConnector.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
    }
    /**
   * Sets the authorization token used to communicate with the service.
   * @member DialogServiceConnector.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    /**
   * The collection of properties and their values defined for this DialogServiceConnector.
   * @member DialogServiceConnector.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this DialogServiceConnector.
   */ get properties() {
        return this.privProperties;
    }
    /** Gets the template for the activity generated by service from speech.
   * Properties from the template will be stamped on the generated activity.
   * It can be empty
   */ get speechActivityTemplate() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.Conversation_Speech_Activity_Template);
    }
    /** Sets the template for the activity generated by service from speech.
   * Properties from the template will be stamped on the generated activity.
   * It can be null or empty.
   * Note: it has to be a valid Json object.
   */ set speechActivityTemplate(e) {
        this.properties.setProperty($d7238066c5de7f1c$var$u.Conversation_Speech_Activity_Template, e);
    }
    /**
   * Starts recognition and stops after the first utterance is recognized.
   * @member DialogServiceConnector.prototype.listenOnceAsync
   * @function
   * @public
   * @param cb - Callback that received the result when the reco has completed.
   * @param err - Callback invoked in case of an error.
   */ listenOnceAsync(e, t) {
        if (this.isTurnComplete) {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed);
            const n = $d7238066c5de7f1c$var$Ha(this, void 0, void 0, function*() {
                yield this.privReco.connect(), yield this.implRecognizerStop(), this.isTurnComplete = !1;
                const s = new $d7238066c5de7f1c$var$F();
                yield this.privReco.recognize($d7238066c5de7f1c$var$ue.Conversation, s.resolve, s.reject);
                const o = yield s.promise;
                return yield this.implRecognizerStop(), o;
            });
            n.catch(()=>{
                this.dispose(!0).catch(()=>{});
            }), $d7238066c5de7f1c$var$x(n.finally(()=>{
                this.isTurnComplete = !0;
            }), e, t);
        }
    }
    sendActivityAsync(e, t, i) {
        $d7238066c5de7f1c$var$x(this.privReco.sendMessage(e), t, i);
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member DialogServiceConnector.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$x(this.dispose(!0), e, t);
    }
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$Ha(this, void 0, void 0, function*() {
            this.privIsDisposed || e && (this.privIsDisposed = !0, yield this.implRecognizerStop(), yield t.dispose.call(this, e));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$Et(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$rv(e, t, s, n, this);
    }
    buildAgentConfig() {
        return {
            botInfo: {
                commType: this.properties.getProperty("Conversation_Communication_Type", "Default"),
                commandsCulture: void 0,
                connectionId: this.properties.getProperty($d7238066c5de7f1c$var$u.Conversation_Agent_Connection_Id),
                conversationId: this.properties.getProperty($d7238066c5de7f1c$var$u.Conversation_Conversation_Id, void 0),
                fromId: this.properties.getProperty($d7238066c5de7f1c$var$u.Conversation_From_Id, void 0),
                ttsAudioFormat: this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthOutputFormat, void 0)
            },
            version: 0.2
        };
    }
}
class $d7238066c5de7f1c$var$Up {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {any} activity - The activity..
   */ constructor(e, t){
        this.privActivity = e, this.privAudioStream = t;
    }
    /**
   * Gets the received activity
   * @member ActivityReceivedEventArgs.prototype.activity
   * @function
   * @public
   * @returns {any} the received activity.
   */ get activity() {
        return this.privActivity;
    }
    get audioStream() {
        return this.privAudioStream;
    }
}
class $d7238066c5de7f1c$var$_o {
    constructor(e){
        this.privMessageStatusResponse = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$_o(e);
    }
    get interactionId() {
        return this.privMessageStatusResponse.interactionId;
    }
    get conversationId() {
        return this.privMessageStatusResponse.conversationId;
    }
    get statusCode() {
        switch(this.privMessageStatusResponse.statusCode){
            case "Success":
                return 200;
            case "Failed":
                return 400;
            case "TimedOut":
                return 429;
            default:
                return this.privMessageStatusResponse.statusCode;
        }
    }
}
class $d7238066c5de7f1c$var$qp {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} turnStatus - The JSON-encoded turn status message.
   */ constructor(e){
        this.privTurnStatus = $d7238066c5de7f1c$var$_o.fromJSON(e);
    }
    /**
   * Gets the interaction identifier associated with this turn status event.
   * @member TurnStatusReceivedEventArgs.prototype.interactionId
   * @function
   * @public
   * @returns {any} the received interaction id.
   */ get interactionId() {
        return this.privTurnStatus.interactionId;
    }
    /**
   * Gets the conversation identifier associated with this turn status event.
   * @member TurnStatusReceivedEventArgs.prototype.conversationId
   * @function
   * @public
   * @returns {any} the received conversation id.
   */ get conversationId() {
        return this.privTurnStatus.conversationId;
    }
    /**
   * Gets the received turn status code.
   * @member TurnStatusReceivedEventArgs.prototype.statusCode
   * @function
   * @public
   * @returns {number} the received turn status.
   */ get statusCode() {
        return this.privTurnStatus.statusCode;
    }
}
var $d7238066c5de7f1c$var$Xr;
(function(r) {
    r[r.UriQueryParameter = 0] = "UriQueryParameter";
})($d7238066c5de7f1c$var$Xr || ($d7238066c5de7f1c$var$Xr = {}));
var $d7238066c5de7f1c$var$Gt;
(function(r) {
    r[r.Masked = 0] = "Masked", r[r.Removed = 1] = "Removed", r[r.Raw = 2] = "Raw";
})($d7238066c5de7f1c$var$Gt || ($d7238066c5de7f1c$var$Gt = {}));
var $d7238066c5de7f1c$var$vl = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$fl {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {AudioStreamFormat} audioFormat audio stream format recognized by the player.
   */ constructor(e){
        this.audioContext = null, this.gainNode = null, this.autoUpdateBufferTimer = 0, e === void 0 && (e = $d7238066c5de7f1c$var$bi.getDefaultInputFormat()), this.init(e);
    }
    /**
   * play Audio sample
   * @param newAudioData audio data to be played.
   */ playAudioSample(e, t, i) {
        try {
            this.ensureInitializedContext();
            const n = this.formatAudioData(e), s = new Float32Array(this.samples.length + n.length);
            s.set(this.samples, 0), s.set(n, this.samples.length), this.samples = s, t && t();
        } catch (n) {
            i && i(n);
        }
    }
    /**
   * stops audio and clears the buffers
   */ stopAudio(e, t) {
        this.audioContext !== null && (this.samples = new Float32Array(), clearInterval(this.autoUpdateBufferTimer), this.audioContext.close().then(()=>{
            e && e();
        }, (i)=>{
            t && t(i);
        }), this.audioContext = null);
    }
    init(e) {
        this.audioFormat = e, this.samples = new Float32Array();
    }
    ensureInitializedContext() {
        if (this.audioContext === null) {
            this.createAudioContext();
            const e = 200;
            this.autoUpdateBufferTimer = setInterval(()=>{
                this.updateAudioBuffer();
            }, e);
        }
    }
    createAudioContext() {
        this.audioContext = $d7238066c5de7f1c$var$wt.getAudioContext(), this.gainNode = this.audioContext.createGain(), this.gainNode.gain.value = 1, this.gainNode.connect(this.audioContext.destination), this.startTime = this.audioContext.currentTime;
    }
    formatAudioData(e) {
        switch(this.audioFormat.bitsPerSample){
            case 8:
                return this.formatArrayBuffer(new Int8Array(e), 128);
            case 16:
                return this.formatArrayBuffer(new Int16Array(e), 32768);
            case 32:
                return this.formatArrayBuffer(new Int32Array(e), 2147483648);
            default:
                throw new $d7238066c5de7f1c$var$De("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
        }
    }
    formatArrayBuffer(e, t) {
        const i = new Float32Array(e.length);
        for(let n = 0; n < e.length; n++)i[n] = e[n] / t;
        return i;
    }
    updateAudioBuffer() {
        if (this.samples.length === 0) return;
        const e = this.audioFormat.channels, t = this.audioContext.createBufferSource(), i = this.samples.length / e, n = this.audioContext.createBuffer(e, i, this.audioFormat.samplesPerSec);
        for(let s = 0; s < e; s++){
            let o = s;
            const c = n.getChannelData(s);
            for(let p = 0; p < this.samples.length; p++, o += e)c[p] = this.samples[o];
        }
        this.startTime < this.audioContext.currentTime && (this.startTime = this.audioContext.currentTime), t.buffer = n, t.connect(this.gainNode), t.start(this.startTime), this.startTime += n.duration, this.samples = new Float32Array();
    }
    playAudio(e) {
        return $d7238066c5de7f1c$var$vl(this, void 0, void 0, function*() {
            this.audioContext === null && this.createAudioContext();
            const t = this.audioContext.createBufferSource(), i = this.audioContext.destination;
            yield this.audioContext.decodeAudioData(e, (n)=>{
                t.buffer = n, t.connect(i), t.start(0);
            });
        });
    }
}
class $d7238066c5de7f1c$var$qs {
    constructor(e){
        this.privConnectionMessage = e;
    }
    /**
   * Gets the <see cref="ConnectionMessage"/> associated with this <see cref="ConnectionMessageEventArgs"/>.
   */ get message() {
        return this.privConnectionMessage;
    }
    /**
   * Returns a string that represents the connection message event.
   */ toString() {
        return "Message: " + this.privConnectionMessage.toString();
    }
}
class $d7238066c5de7f1c$var$Wp {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} profileId - profileId of this Voice Profile.
   * @param {VoiceProfileType} profileType - profileType of this Voice Profile.
   */ constructor(e, t){
        this.privId = e, this.privProfileType = t;
    }
    /**
   * profileId of this Voice Profile instance
   * @member VoiceProfile.prototype.profileId
   * @function
   * @public
   * @returns {string} profileId of this Voice Profile instance.
   */ get profileId() {
        return this.privId;
    }
    /**
   * profileType of this Voice Profile instance
   * @member VoiceProfile.prototype.profileType
   * @function
   * @public
   * @returns {VoiceProfileType} profile type of this Voice Profile instance.
   */ get profileType() {
        return this.privProfileType;
    }
}
class $d7238066c5de7f1c$var$_t {
    constructor(e, t, i){
        this.privReason = e, this.privProperties = new $d7238066c5de7f1c$var$U(), this.privReason !== $d7238066c5de7f1c$var$R.Canceled ? t && (this.privDetails = JSON.parse(t), this.privDetails.enrollmentStatus.toLowerCase() === "enrolling" && (this.privReason = $d7238066c5de7f1c$var$R.EnrollingVoiceProfile)) : (this.privErrorDetails = i, this.privProperties.setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.ServiceError]));
    }
    get reason() {
        return this.privReason;
    }
    get enrollmentsCount() {
        return this.privDetails.enrollmentsCount;
    }
    get enrollmentsLength() {
        return this.privDetails.enrollmentsLength;
    }
    get properties() {
        return this.privProperties;
    }
    get enrollmentResultDetails() {
        return this.privDetails;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
    static FromIdentificationProfileList(e) {
        const t = [];
        for (const i of e.value){
            const n = i.enrollmentStatus.toLowerCase() === "enrolling" ? $d7238066c5de7f1c$var$R.EnrollingVoiceProfile : i.enrollmentStatus.toLowerCase() === "enrolled" ? $d7238066c5de7f1c$var$R.EnrolledVoiceProfile : $d7238066c5de7f1c$var$R.Canceled, s = new $d7238066c5de7f1c$var$_t(n, null, null);
            s.privDetails = this.getIdentificationDetails(i), t.push(s);
        }
        return t;
    }
    static FromVerificationProfileList(e) {
        const t = [];
        for (const i of e.value){
            const n = i.enrollmentStatus.toLowerCase() === "enrolling" ? $d7238066c5de7f1c$var$R.EnrollingVoiceProfile : i.enrollmentStatus.toLowerCase() === "enrolled" ? $d7238066c5de7f1c$var$R.EnrolledVoiceProfile : $d7238066c5de7f1c$var$R.Canceled, s = new $d7238066c5de7f1c$var$_t(n, null, null);
            s.privDetails = this.getVerificationDetails(i), t.push(s);
        }
        return t;
    }
    static getIdentificationDetails(e) {
        return {
            audioLength: e.audioLength ? parseFloat(e.audioLength) : 0,
            audioSpeechLength: e.audioSpeechLength ? parseFloat(e.audioSpeechLength) : 0,
            enrollmentStatus: e.enrollmentStatus,
            enrollmentsCount: e.enrollmentsCount || 0,
            enrollmentsLength: e.enrollmentsLength ? parseFloat(e.enrollmentsLength) : 0,
            enrollmentsSpeechLength: e.enrollmentsSpeechLength ? parseFloat(e.enrollmentsSpeechLength) : 0,
            profileId: e.profileId || e.identificationProfileId,
            remainingEnrollmentsSpeechLength: e.remainingEnrollmentsSpeechLength ? parseFloat(e.remainingEnrollmentsSpeechLength) : 0
        };
    }
    static getVerificationDetails(e) {
        return {
            audioLength: e.audioLength ? parseFloat(e.audioLength) : 0,
            audioSpeechLength: e.audioSpeechLength ? parseFloat(e.audioSpeechLength) : 0,
            enrollmentStatus: e.enrollmentStatus,
            enrollmentsCount: e.enrollmentsCount,
            enrollmentsLength: e.enrollmentsLength ? parseFloat(e.enrollmentsLength) : 0,
            enrollmentsSpeechLength: e.enrollmentsSpeechLength ? parseFloat(e.enrollmentsSpeechLength) : 0,
            profileId: e.profileId || e.verificationProfileId,
            remainingEnrollmentsCount: e.remainingEnrollments || e.remainingEnrollmentsCount,
            remainingEnrollmentsSpeechLength: e.remainingEnrollmentsSpeechLength ? parseFloat(e.remainingEnrollmentsSpeechLength) : 0
        };
    }
}
class $d7238066c5de7f1c$var$Lo extends $d7238066c5de7f1c$var$lr {
    constructor(e, t, i){
        super(e, t, i);
    }
    /**
   * Creates an instance of VoiceProfileEnrollmentCancellationDetails object for the canceled VoiceProfileEnrollmentResult.
   * @member VoiceProfileEnrollmentCancellationDetails.fromResult
   * @function
   * @public
   * @param {VoiceProfileEnrollmentResult} result - The result that was canceled.
   * @returns {VoiceProfileEnrollmentCancellationDetails} The cancellation details object being created.
   */ static fromResult(e) {
        const t = $d7238066c5de7f1c$var$X.Error;
        let i = $d7238066c5de7f1c$var$T.NoError;
        return e.properties && (i = $d7238066c5de7f1c$var$T[e.properties.getProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.NoError])]), new $d7238066c5de7f1c$var$Lo(t, e.errorDetails, i);
    }
}
class $d7238066c5de7f1c$var$Sn {
    constructor(e, t){
        this.privReason = e, this.privProperties = new $d7238066c5de7f1c$var$U(), e === $d7238066c5de7f1c$var$R.Canceled && ($d7238066c5de7f1c$var$l.throwIfNullOrUndefined(t, "statusText"), this.privErrorDetails = t, this.privProperties.setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.ServiceError]));
    }
    get reason() {
        return this.privReason;
    }
    get properties() {
        return this.privProperties;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
}
class $d7238066c5de7f1c$var$$o extends $d7238066c5de7f1c$var$lr {
    constructor(e, t, i){
        super(e, t, i);
    }
    /**
   * Creates an instance of VoiceProfileCancellationDetails object for the canceled VoiceProfileResult.
   * @member VoiceProfileCancellationDetails.fromResult
   * @function
   * @public
   * @param {VoiceProfileResult} result - The result that was canceled.
   * @returns {VoiceProfileCancellationDetails} The cancellation details object being created.
   */ static fromResult(e) {
        const t = $d7238066c5de7f1c$var$X.Error;
        let i = $d7238066c5de7f1c$var$T.NoError;
        return e.properties && (i = $d7238066c5de7f1c$var$T[e.properties.getProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.NoError])]), new $d7238066c5de7f1c$var$$o(t, e.errorDetails, i);
    }
}
class $d7238066c5de7f1c$var$Ws extends $d7238066c5de7f1c$var$Sn {
    constructor(e, t, i, n){
        super(e, t), this.privPhrases = [], $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(n, "phrase array"), this.privType = i, n && n[0] && (this.privPhrases = n);
    }
    get phrases() {
        return this.privPhrases;
    }
    get type() {
        return this.privType;
    }
}
var $d7238066c5de7f1c$var$gt = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$gl extends $d7238066c5de7f1c$var$Fe {
    /**
   * VoiceProfileClient constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer (authentication key, region, &c)
   */ constructor(e){
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "speechConfig");
        const t = e;
        $d7238066c5de7f1c$var$l.throwIfNull(t, "speechConfig"), super($d7238066c5de7f1c$var$bt.fromStreamInput($d7238066c5de7f1c$var$ur.createPushStream()), t.properties, new $d7238066c5de7f1c$var$Bl()), this.privProperties = t.properties.clone(), this.privVoiceAdapter = this.privReco, this.privDisposedVoiceAdapter = !1;
    }
    /**
   * The collection of properties and their values defined for this VoiceProfileClient.
   * @member VoiceProfileClient.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this VoiceProfileClient.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member VoiceProfileClient.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member VoiceProfileClient.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    /**
   * Create a speaker recognition voice profile
   * @member VoiceProfileClient.prototype.createProfileAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfileType} profileType Type of Voice Profile to be created
   * @param {string} lang Language string (locale) for Voice Profile
   * @return {Promise<VoiceProfile>} - Promise of a VoiceProfile.
   */ createProfileAsync(e, t) {
        return $d7238066c5de7f1c$var$gt(this, void 0, void 0, function*() {
            const i = yield this.privVoiceAdapter.createProfile(e, t);
            return new $d7238066c5de7f1c$var$Wp(i[0], e);
        });
    }
    /**
   * Get current information of a voice profile
   * @member VoiceProfileClient.prototype.retrieveEnrollmentResultAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfile} profile Voice Profile to retrieve info for
   * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
   */ retrieveEnrollmentResultAsync(e) {
        return $d7238066c5de7f1c$var$gt(this, void 0, void 0, function*() {
            return this.privVoiceAdapter.retrieveEnrollmentResult(e);
        });
    }
    /**
   * Get all voice profiles on account with given voice profile type
   * @member VoiceProfileClient.prototype.getAllProfilesAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfileType} profileType profile type (identification/verification) for which to list profiles
   * @return {Promise<VoiceProfileEnrollmentResult[]>} - Promise of an array of VoiceProfileEnrollmentResults.
   */ getAllProfilesAsync(e) {
        return $d7238066c5de7f1c$var$gt(this, void 0, void 0, function*() {
            return this.privVoiceAdapter.getAllProfiles(e);
        });
    }
    /**
   * Get valid authorization phrases for voice profile enrollment
   * @member VoiceProfileClient.prototype.getActivationPhrasesAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfileType} profileType Profile Type to get activation phrases for
   * @param {string} lang Language string (locale) for Voice Profile
   */ getActivationPhrasesAsync(e, t) {
        return $d7238066c5de7f1c$var$gt(this, void 0, void 0, function*() {
            return this.privVoiceAdapter.getActivationPhrases(e, t);
        });
    }
    /**
   * Create a speaker recognition voice profile
   * @member VoiceProfileClient.prototype.enrollProfileAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfile} profile Voice Profile to create enrollment for
   * @param {AudioConfig} audioConfig source info from which to create enrollment
   * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
   */ enrollProfileAsync(e, t) {
        return $d7238066c5de7f1c$var$gt(this, void 0, void 0, function*() {
            const i = t;
            return $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(i, "audioConfig"), this.audioConfig = t, this.privVoiceAdapter.SpeakerAudioSource = i, this.privVoiceAdapter.enrollProfile(e);
        });
    }
    /**
   * Delete a speaker recognition voice profile
   * @member VoiceProfileClient.prototype.deleteProfileAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfile} profile Voice Profile to be deleted
   * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
   */ deleteProfileAsync(e) {
        return $d7238066c5de7f1c$var$gt(this, void 0, void 0, function*() {
            return this.privVoiceAdapter.deleteProfile(e);
        });
    }
    /**
   * Remove all enrollments for a speaker recognition voice profile
   * @member VoiceProfileClient.prototype.resetProfileAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfile} profile Voice Profile to be reset
   * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
   */ resetProfileAsync(e) {
        return $d7238066c5de7f1c$var$gt(this, void 0, void 0, function*() {
            return this.privVoiceAdapter.resetProfile(e);
        });
    }
    /**
   * Clean up object and close underlying connection
   * @member VoiceProfileClient.prototype.close
   * @function
   * @async
   * @public
   */ close() {
        return $d7238066c5de7f1c$var$gt(this, void 0, void 0, function*() {
            yield this.dispose(!0);
        });
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$kv(e, t, s, n, this);
    }
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$gt(this, void 0, void 0, function*() {
            this.privDisposedVoiceAdapter || (this.privDisposedVoiceAdapter = !0, e && (yield t.dispose.call(this, e)));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$Et(e, this.properties);
    }
    getResult(e, t) {
        return new $d7238066c5de7f1c$var$Sn(e.ok ? t : $d7238066c5de7f1c$var$R.Canceled, e.statusText);
    }
}
var $d7238066c5de7f1c$var$Ni = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$ml extends $d7238066c5de7f1c$var$Fe {
    /**
   * Initializes an instance of the SpeakerRecognizer.
   * @constructor
   * @param {SpeechConfig} speechConfig - The set of configuration properties.
   * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
   */ constructor(e, t){
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "speechConfig");
        const i = e;
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(i, "speechConfig"), super(t, i.properties, new $d7238066c5de7f1c$var$$l()), this.privAudioConfigImpl = t, $d7238066c5de7f1c$var$l.throwIfNull(this.privAudioConfigImpl, "audioConfig"), this.privDisposedSpeakerRecognizer = !1, this.privProperties = i.properties;
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member SpeakerRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member SpeakerRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    /**
   * The collection of properties and their values defined for this SpeakerRecognizer.
   * @member SpeakerRecognizer.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this SpeakerRecognizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Get recognition result for model using given audio
   * @member SpeakerRecognizer.prototype.recognizeOnceAsync
   * @function
   * @public
   * @async
   * @param {SpeakerIdentificationModel | SpeakerVerificationModel} model Model containing Voice Profiles to be identified
   * @param cb - Callback invoked once result is returned.
   * @param err - Callback invoked in case of an error.
   */ recognizeOnceAsync(e) {
        return $d7238066c5de7f1c$var$Ni(this, void 0, void 0, function*() {
            return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedSpeakerRecognizer), this.recognizeSpeakerOnceAsyncImpl(e);
        });
    }
    /**
   * Included for compatibility
   * @member SpeakerRecognizer.prototype.close
   * @function
   * @public
   * @async
   */ close() {
        return $d7238066c5de7f1c$var$Ni(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedSpeakerRecognizer), yield this.dispose(!0);
        });
    }
    recognizeSpeakerOnceAsyncImpl(e) {
        return $d7238066c5de7f1c$var$Ni(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedSpeakerRecognizer), yield this.implRecognizerStop();
            const t = yield this.privReco.recognizeSpeaker(e);
            return yield this.implRecognizerStop(), t;
        });
    }
    implRecognizerStop() {
        return $d7238066c5de7f1c$var$Ni(this, void 0, void 0, function*() {
            this.privReco && (yield this.privReco.stopRecognizing());
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$Et(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$Av(e, t, s, n, this);
    }
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$Ni(this, void 0, void 0, function*() {
            this.privDisposedSpeakerRecognizer || e && (this.privDisposedSpeakerRecognizer = !0, yield t.dispose.call(this, e));
        });
    }
}
class $d7238066c5de7f1c$var$Bo {
    constructor(e){
        if (this.privVoiceProfiles = [], this.privProfileIds = [], $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "VoiceProfiles"), e.length === 0) throw new Error("Empty Voice Profiles array");
        for (const t of e){
            if (t.profileType !== $d7238066c5de7f1c$var$ct.TextIndependentIdentification) throw new Error("Identification model can only be created from Identification profile: " + t.profileId);
            this.privVoiceProfiles.push(t), this.privProfileIds.push(t.profileId);
        }
    }
    static fromProfiles(e) {
        return new $d7238066c5de7f1c$var$Bo(e);
    }
    get voiceProfileIds() {
        return this.privProfileIds.join(",");
    }
    get profileIds() {
        return this.privProfileIds;
    }
    get scenario() {
        return "TextIndependentIdentification";
    }
}
class $d7238066c5de7f1c$var$Uo {
    constructor(e){
        if ($d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "VoiceProfile"), e.profileType === $d7238066c5de7f1c$var$ct.TextIndependentIdentification) throw new Error("Verification model cannot be created from Identification profile");
        this.privVoiceProfile = e;
    }
    static fromProfile(e) {
        return new $d7238066c5de7f1c$var$Uo(e);
    }
    get voiceProfile() {
        return this.privVoiceProfile;
    }
    get profileIds() {
        return [
            this.voiceProfile.profileId
        ];
    }
    get scenario() {
        return this.voiceProfile.profileType === $d7238066c5de7f1c$var$ct.TextDependentVerification ? "TextDependentVerification" : "TextIndependentVerification";
    }
}
var $d7238066c5de7f1c$var$er;
(function(r) {
    r[r.AtStart = 0] = "AtStart", r[r.Continuous = 1] = "Continuous";
})($d7238066c5de7f1c$var$er || ($d7238066c5de7f1c$var$er = {}));
class $d7238066c5de7f1c$var$Fi {
    constructor(){
        this.privProperties = new $d7238066c5de7f1c$var$U(), this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_LanguageIdMode, "AtStart"), this.privLanguageIdMode = $d7238066c5de7f1c$var$er.AtStart;
    }
    /**
   * @member AutoDetectSourceLanguageConfig.fromOpenRange
   * @function
   * @public
   * Only [[SpeechSynthesizer]] supports source language auto detection from open range,
   * for [[Recognizer]], please use AutoDetectSourceLanguageConfig with specific source languages.
   * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
   * @summary Creates an instance of the AutoDetectSourceLanguageConfig with open range.
   */ static fromOpenRange() {
        const e = new $d7238066c5de7f1c$var$Fi();
        return e.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_AutoDetectSourceLanguages, $d7238066c5de7f1c$var$lh), e;
    }
    /**
   * @member AutoDetectSourceLanguageConfig.fromLanguages
   * @function
   * @public
   * @param {string[]} languages Comma-separated string of languages (eg. "en-US,fr-FR") to populate properties of config.
   * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
   * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given languages.
   */ static fromLanguages(e) {
        $d7238066c5de7f1c$var$l.throwIfArrayEmptyOrWhitespace(e, "languages");
        const t = new $d7238066c5de7f1c$var$Fi();
        return t.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_AutoDetectSourceLanguages, e.join()), t;
    }
    /**
   * @member AutoDetectSourceLanguageConfig.fromSourceLanguageConfigs
   * @function
   * @public
   * @param {SourceLanguageConfig[]} configs SourceLanguageConfigs to populate properties of config.
   * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
   * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given SourceLanguageConfigs.
   */ static fromSourceLanguageConfigs(e) {
        if (e.length < 1) throw new Error("Expected non-empty SourceLanguageConfig array.");
        const t = new $d7238066c5de7f1c$var$Fi(), i = [];
        return e.forEach((n)=>{
            if (i.push(n.language), n.endpointId !== void 0 && n.endpointId !== "") {
                const s = n.language + $d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId.toString();
                t.properties.setProperty(s, n.endpointId);
            }
        }), t.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_AutoDetectSourceLanguages, i.join()), t;
    }
    /**
   * @member AutoDetectSourceLanguageConfig.prototype.properties
   * @function
   * @public
   * @return {PropertyCollection} Properties of the config.
   * @summary Gets an auto detected language config properties
   */ get properties() {
        return this.privProperties;
    }
    /**
   * @member AutoDetectSourceLanguageConfig.prototype.mode
   * @function
   * @public
   * @param {LanguageIdMode} mode LID mode desired.
   * @summary Sets LID operation to desired mode
   */ set mode(e) {
        e === $d7238066c5de7f1c$var$er.Continuous ? (this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecognitionEndpointVersion, "2"), this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_LanguageIdMode, "Continuous")) : (this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecognitionEndpointVersion, "1"), this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_LanguageIdMode, "AtStart")), this.privLanguageIdMode = e;
    }
}
class $d7238066c5de7f1c$var$en {
    constructor(e, t){
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "language"), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(t, "languageDetectionConfidence"), this.privLanguage = e, this.privLanguageDetectionConfidence = t;
    }
    /**
   * Creates an instance of AutoDetectSourceLanguageResult object from a SpeechRecognitionResult instance.
   * @member AutoDetectSourceLanguageResult.fromResult
   * @function
   * @public
   * @param {SpeechRecognitionResult} result - The recognition result.
   * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
   */ static fromResult(e) {
        return new $d7238066c5de7f1c$var$en(e.language, e.languageDetectionConfidence);
    }
    /**
   * Creates an instance of AutoDetectSourceLanguageResult object from a ConversationTranscriptionResult instance.
   * @member AutoDetectSourceLanguageResult.fromConversationTranscriptionResult
   * @function
   * @public
   * @param {ConversationTranscriptionResult} result - The transcription result.
   * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
   */ static fromConversationTranscriptionResult(e) {
        return new $d7238066c5de7f1c$var$en(e.language, e.languageDetectionConfidence);
    }
    get language() {
        return this.privLanguage;
    }
    get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
}
class $d7238066c5de7f1c$var$qo {
    constructor(e, t){
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "language"), this.privLanguage = e, this.privEndpointId = t;
    }
    /**
   * @member SourceLanguageConfig.fromLanguage
   * @function
   * @public
   * @param {string} language language (eg. "en-US") value of config.
   * @param {string?} endpointId endpointId of model bound to given language of config.
   * @return {SourceLanguageConfig} Instance of SourceLanguageConfig
   * @summary Creates an instance of the SourceLanguageConfig with the given language and optional endpointId.
   * Added in version 1.13.0.
   */ static fromLanguage(e, t) {
        return new $d7238066c5de7f1c$var$qo(e, t);
    }
    get language() {
        return this.privLanguage;
    }
    get endpointId() {
        return this.privEndpointId;
    }
}
var $d7238066c5de7f1c$var$fi;
(function(r) {
    r[r.Verify = 0] = "Verify", r[r.Identify = 1] = "Identify";
})($d7238066c5de7f1c$var$fi || ($d7238066c5de7f1c$var$fi = {}));
class $d7238066c5de7f1c$var$Wr {
    constructor(e, t = $d7238066c5de7f1c$var$R.RecognizedSpeaker, i = $d7238066c5de7f1c$var$T.NoError, n = ""){
        this.privProperties = new $d7238066c5de7f1c$var$U();
        const s = e.scenario === "TextIndependentIdentification" ? $d7238066c5de7f1c$var$fi.Identify : $d7238066c5de7f1c$var$fi.Verify;
        this.privReason = t, this.privReason !== $d7238066c5de7f1c$var$R.Canceled ? s === $d7238066c5de7f1c$var$fi.Identify ? (this.privProfileId = e.identificationResult.identifiedProfile.profileId, this.privScore = e.identificationResult.identifiedProfile.score, this.privReason = $d7238066c5de7f1c$var$R.RecognizedSpeakers) : (this.privScore = e.verificationResult.score, e.verificationResult.recognitionResult.toLowerCase() !== "accept" && (this.privReason = $d7238066c5de7f1c$var$R.NoMatch), e.verificationResult.profileId !== void 0 && e.verificationResult.profileId !== "" && (this.privProfileId = e.verificationResult.profileId)) : (this.privErrorDetails = n, this.privProperties.setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[i])), this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_JsonResult, JSON.stringify(e));
    }
    get properties() {
        return this.privProperties;
    }
    get reason() {
        return this.privReason;
    }
    get profileId() {
        return this.privProfileId;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
    get score() {
        return this.privScore;
    }
}
class $d7238066c5de7f1c$var$Wo extends $d7238066c5de7f1c$var$lr {
    constructor(e, t, i){
        super(e, t, i);
    }
    /**
   * Creates an instance of SpeakerRecognitionCancellationDetails object for the canceled SpeakerRecognitionResult
   * @member SpeakerRecognitionCancellationDetails.fromResult
   * @function
   * @public
   * @param {SpeakerRecognitionResult} result - The result that was canceled.
   * @returns {SpeakerRecognitionCancellationDetails} The cancellation details object being created.
   */ static fromResult(e) {
        const t = $d7238066c5de7f1c$var$X.Error;
        let i = $d7238066c5de7f1c$var$T.NoError;
        return e.properties && (i = $d7238066c5de7f1c$var$T[e.properties.getProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.NoError])]), new $d7238066c5de7f1c$var$Wo(t, e.errorDetails, i);
    }
}
var $d7238066c5de7f1c$var$Hr = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Hp {
    constructor(){}
    /**
   * Create a conversation
   * @param speechConfig
   * @param cb
   * @param err
   */ static createConversationAsync(e, t, i, n) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, $d7238066c5de7f1c$var$$.restErrors.invalidArgs.replace("{arg}", "config")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e.region, $d7238066c5de7f1c$var$$.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region")), !e.subscriptionKey && !e.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token]) && $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e.subscriptionKey, $d7238066c5de7f1c$var$$.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        let s, o, c;
        return typeof t == "string" ? (s = new $d7238066c5de7f1c$var$Hs(e, t), $d7238066c5de7f1c$var$x($d7238066c5de7f1c$var$Hr(this, void 0, void 0, function*() {}), i, n)) : (s = new $d7238066c5de7f1c$var$Hs(e), o = t, c = i, s.createConversationAsync(()=>{
            o && o();
        }, (p)=>{
            c && c(p);
        })), s;
    }
}
class $d7238066c5de7f1c$var$Hs extends $d7238066c5de7f1c$var$Hp {
    /**
   * Create a conversation impl
   * @param speechConfig
   * @param {string} id - optional conversationId
   */ constructor(e, t){
        if (super(), this.privErrors = $d7238066c5de7f1c$var$$.restErrors, this.onConnected = (s)=>{
            var o;
            this.privIsConnected = !0;
            try {
                !((o = this.privConversationTranslator) === null || o === void 0) && o.sessionStarted && this.privConversationTranslator.sessionStarted(this.privConversationTranslator, s);
            } catch  {}
        }, this.onDisconnected = (s)=>{
            var o;
            try {
                !((o = this.privConversationTranslator) === null || o === void 0) && o.sessionStopped && this.privConversationTranslator.sessionStopped(this.privConversationTranslator, s);
            } catch  {} finally{
                this.close(!1);
            }
        }, this.onCanceled = (s, o)=>{
            var c;
            try {
                !((c = this.privConversationTranslator) === null || c === void 0) && c.canceled && this.privConversationTranslator.canceled(this.privConversationTranslator, o);
            } catch  {}
        }, this.onParticipantUpdateCommandReceived = (s, o)=>{
            try {
                const c = this.privParticipants.getParticipant(o.id);
                if (c !== void 0) {
                    switch(o.key){
                        case $d7238066c5de7f1c$var$re.changeNickname:
                            c.displayName = o.value;
                            break;
                        case $d7238066c5de7f1c$var$re.setUseTTS:
                            c.isUsingTts = o.value;
                            break;
                        case $d7238066c5de7f1c$var$re.setProfanityFiltering:
                            c.profanity = o.value;
                            break;
                        case $d7238066c5de7f1c$var$re.setMute:
                            c.isMuted = o.value;
                            break;
                        case $d7238066c5de7f1c$var$re.setTranslateToLanguages:
                            c.translateToLanguages = o.value;
                            break;
                    }
                    this.privParticipants.addOrUpdateParticipant(c), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$Ye($d7238066c5de7f1c$var$xe.Updated, [
                        this.toParticipant(c)
                    ], o.sessionId));
                }
            } catch  {}
        }, this.onLockRoomCommandReceived = ()=>{}, this.onMuteAllCommandReceived = (s, o)=>{
            try {
                this.privParticipants.participants.forEach((c)=>c.isMuted = c.isHost ? !1 : o.isMuted), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$Ye($d7238066c5de7f1c$var$xe.Updated, this.toParticipants(!1), o.sessionId));
            } catch  {}
        }, this.onParticipantJoinCommandReceived = (s, o)=>{
            try {
                const c = this.privParticipants.addOrUpdateParticipant(o.participant);
                c !== void 0 && this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$Ye($d7238066c5de7f1c$var$xe.JoinedConversation, [
                    this.toParticipant(c)
                ], o.sessionId));
            } catch  {}
        }, this.onParticipantLeaveCommandReceived = (s, o)=>{
            try {
                const c = this.privParticipants.getParticipant(o.participant.id);
                c !== void 0 && (this.privParticipants.deleteParticipant(o.participant.id), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$Ye($d7238066c5de7f1c$var$xe.LeftConversation, [
                    this.toParticipant(c)
                ], o.sessionId)));
            } catch  {}
        }, this.onTranslationReceived = (s, o)=>{
            try {
                switch(o.command){
                    case $d7238066c5de7f1c$var$ne.final:
                        this.privConversationTranslator && this.privConversationTranslator.transcribed(this.privConversationTranslator, new $d7238066c5de7f1c$var$Vt(o.payload, void 0, o.sessionId));
                        break;
                    case $d7238066c5de7f1c$var$ne.partial:
                        this.privConversationTranslator && this.privConversationTranslator.transcribing(this.privConversationTranslator, new $d7238066c5de7f1c$var$Vt(o.payload, void 0, o.sessionId));
                        break;
                    case $d7238066c5de7f1c$var$ne.instantMessage:
                        this.privConversationTranslator && this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new $d7238066c5de7f1c$var$Vt(o.payload, void 0, o.sessionId));
                        break;
                }
            } catch  {}
        }, this.onParticipantsListReceived = (s, o)=>{
            var c;
            try {
                if (o.sessionToken !== void 0 && o.sessionToken !== null && (this.privRoom.token = o.sessionToken), this.privParticipants.participants = [
                    ...o.participants
                ], this.privParticipants.me !== void 0 && (this.privIsReady = !0), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$Ye($d7238066c5de7f1c$var$xe.JoinedConversation, this.toParticipants(!0), o.sessionId)), this.me.isHost) {
                    const p = (c = this.privConversationTranslator) === null || c === void 0 ? void 0 : c.properties.getProperty($d7238066c5de7f1c$var$u.ConversationTranslator_Name);
                    p !== void 0 && p.length > 0 && p !== this.me.displayName && this.changeNicknameAsync(p);
                }
            } catch  {}
        }, this.onConversationExpiration = (s, o)=>{
            try {
                this.privConversationTranslator && this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, o);
            } catch  {}
        }, this.privIsConnected = !1, this.privIsDisposed = !1, this.privConversationId = "", this.privProperties = new $d7238066c5de7f1c$var$U(), this.privManager = new $d7238066c5de7f1c$var$hh(), e.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage]) || e.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage], $d7238066c5de7f1c$var$$.defaultLanguageCode), this.privLanguage = e.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage]), t) this.privConversationId = t;
        else {
            e.targetLanguages.length === 0 && e.addTargetLanguage(this.privLanguage), e.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceResponse_ProfanityOption]) || e.setProfanity($d7238066c5de7f1c$var$Gt.Masked);
            let o = e.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.ConversationTranslator_Name]);
            o == null && (o = "Host"), $d7238066c5de7f1c$var$l.throwIfNullOrTooLong(o, "nickname", 50), $d7238066c5de7f1c$var$l.throwIfNullOrTooShort(o, "nickname", 2), e.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.ConversationTranslator_Name], o);
        }
        this.privConfig = e;
        const n = e;
        $d7238066c5de7f1c$var$l.throwIfNull(n, "speechConfig"), this.privProperties = n.properties.clone(), this.privIsConnected = !1, this.privParticipants = new $d7238066c5de7f1c$var$uh(), this.privIsReady = !1, this.privTextMessageMaxLength = 1e3;
    }
    // get the internal data about a conversation
    get room() {
        return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
        return this.privConversationRecognizer;
    }
    // get the config
    get config() {
        return this.privConfig;
    }
    // get the conversation Id
    get conversationId() {
        return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
        return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
        return this.privLanguage;
    }
    get isMutedByHost() {
        var e, t;
        return !((e = this.privParticipants.me) === null || e === void 0) && e.isHost ? !1 : (t = this.privParticipants.me) === null || t === void 0 ? void 0 : t.isMuted;
    }
    get isConnected() {
        return this.privIsConnected && this.privIsReady;
    }
    get participants() {
        return this.toParticipants(!0);
    }
    get me() {
        return this.toParticipant(this.privParticipants.me);
    }
    get host() {
        return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
        return this.privTranscriberRecognizer;
    }
    get conversationInfo() {
        const e = this.conversationId, t = this.participants.map((s)=>({
                id: s.id,
                preferredLanguage: s.preferredLanguage,
                voice: s.voice
            })), i = {};
        for (const s of $d7238066c5de7f1c$var$$.transcriptionEventKeys){
            const o = this.properties.getProperty(s, "");
            o !== "" && (i[s] = o);
        }
        return {
            id: e,
            participants: t,
            conversationProperties: i
        };
    }
    get canSend() {
        var e;
        return this.privIsConnected && !(!((e = this.privParticipants.me) === null || e === void 0) && e.isMuted);
    }
    get canSendAsHost() {
        var e;
        return this.privIsConnected && ((e = this.privParticipants.me) === null || e === void 0 ? void 0 : e.isHost);
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
        return this.privToken;
    }
    set authorizationToken(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "authorizationToken"), this.privToken = e;
    }
    set conversationTranslator(e) {
        this.privConversationTranslator = e;
    }
    onToken(e) {
        this.privConversationTranslator.onToken(e);
    }
    /**
   * Create a new conversation as Host
   * @param cb
   * @param err
   */ createConversationAsync(e, t) {
        try {
            this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), t), this.privManager.createOrJoin(this.privProperties, void 0, (i)=>{
                i || this.handleError(new Error(this.privErrors.permissionDeniedConnect), t), this.privRoom = i, this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Starts a new conversation as host.
   * @param cb
   * @param err
   */ startConversationAsync(e, t) {
        try {
            this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), t), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect), this.privParticipants.meId = this.privRoom.participantId, this.privConversationRecognizer = $d7238066c5de7f1c$var$mv.fromConfig(this, this.privConfig), this.privConversationRecognizer.connected = this.onConnected, this.privConversationRecognizer.disconnected = this.onDisconnected, this.privConversationRecognizer.canceled = this.onCanceled, this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived, this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived, this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived, this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived, this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived, this.privConversationRecognizer.translationReceived = this.onTranslationReceived, this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived, this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration, this.privConversationRecognizer.connect(this.privRoom.token, ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Join a conversation as a participant.
   * @param { IParticipant } participant - participant to add
   * @param cb
   * @param err
   */ addParticipantAsync(e, t, i) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "Participant"), $d7238066c5de7f1c$var$x(this.addParticipantImplAsync(e), t, i);
    }
    /**
   * Join a conversation as a participant.
   * @param conversation
   * @param nickname
   * @param lang
   * @param cb
   * @param err
   */ joinConversationAsync(e, t, i, n, s) {
        try {
            $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "conversationId")), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "nickname")), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(i, this.privErrors.invalidArgs.replace("{arg}", "language")), this.privManager.createOrJoin(this.privProperties, e, (o)=>{
                $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(o, this.privErrors.permissionDeniedConnect), this.privRoom = o, this.privConfig.authorizationToken = o.cognitiveSpeechAuthToken, n && n(o.cognitiveSpeechAuthToken);
            }, (o)=>{
                this.handleError(o, s);
            });
        } catch (o) {
            this.handleError(o, s);
        }
    }
    /**
   * Deletes a conversation
   * @param cb
   * @param err
   */ deleteConversationAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.deleteConversationImplAsync(), e, t);
    }
    deleteConversationImplAsync() {
        return $d7238066c5de7f1c$var$Hr(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect), yield this.privManager.leave(this.privProperties, this.privRoom.token), this.dispose();
        });
    }
    /**
   * Issues a request to close the client websockets
   * @param cb
   * @param err
   */ endConversationAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.endConversationImplAsync(), e, t);
    }
    endConversationImplAsync() {
        return this.close(!0);
    }
    /**
   * Issues a request to lock the conversation
   * @param cb
   * @param err
   */ lockConversationAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!0), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to mute the conversation
   * @param cb
   * @param err
   */ muteAllParticipantsAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!0), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to mute a participant in the conversation
   * @param userId
   * @param cb
   * @param err
   */ muteParticipantAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "userId")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), !this.me.isHost && this.me.id !== e && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), i), this.privParticipants.getParticipantIndex(e) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(e, !0), ()=>{
                this.handleCallback(t, i);
            }, (s)=>{
                this.handleError(s, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Issues a request to remove a participant from the conversation
   * @param userId
   * @param cb
   * @param err
   */ removeParticipantAsync(e, t, i) {
        try {
            if ($d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), this.privTranscriberRecognizer && e.hasOwnProperty("id")) $d7238066c5de7f1c$var$x(this.removeParticipantImplAsync(e), t, i);
            else {
                $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), i);
                let n = "";
                typeof e == "string" ? n = e : e.hasOwnProperty("id") ? n = e.id : e.hasOwnProperty("userId") && (n = e.userId), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(n, this.privErrors.invalidArgs.replace("{arg}", "userId")), this.participants.findIndex((o)=>o.id === n) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getEjectCommand(n), ()=>{
                    this.handleCallback(t, i);
                }, (o)=>{
                    this.handleError(o, i);
                });
            }
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Issues a request to unlock the conversation
   * @param cb
   * @param err
   */ unlockConversationAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!1), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to unmute all participants in the conversation
   * @param cb
   * @param err
   */ unmuteAllParticipantsAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!1), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to unmute a participant in the conversation
   * @param userId
   * @param cb
   * @param err
   */ unmuteParticipantAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "userId")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), !this.me.isHost && this.me.id !== e && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), i), this.privParticipants.getParticipantIndex(e) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(e, !1), ()=>{
                this.handleCallback(t, i);
            }, (s)=>{
                this.handleError(s, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Send a text message
   * @param message
   * @param cb
   * @param err
   */ sendTextMessageAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "message")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), e.length > this.privTextMessageMaxLength && this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMessageCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Set translated to languages
   * @param {string[]} languages - languages to translate to
   * @param cb
   * @param err
   */ setTranslatedLanguagesAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfArrayEmptyOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "languages")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Change nickname
   * @param {string} nickname - new nickname for the room
   * @param cb
   * @param err
   */ changeNicknameAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "nickname")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        this.isDisposed || (this.privIsDisposed = !0, this.config && this.config.close(), this.privConfig = void 0, this.privLanguage = void 0, this.privProperties = void 0, this.privRoom = void 0, this.privToken = void 0, this.privManager = void 0, this.privIsConnected = !1, this.privIsReady = !1, this.privParticipants = void 0);
    }
    connectTranscriberRecognizer(e) {
        return $d7238066c5de7f1c$var$Hr(this, void 0, void 0, function*() {
            this.privTranscriberRecognizer && (yield this.privTranscriberRecognizer.close()), yield e.enforceAudioGating(), this.privTranscriberRecognizer = e, this.privTranscriberRecognizer.conversation = this;
        });
    }
    getKeepAlive() {
        const e = this.me ? this.me.displayName : "default_nickname";
        return JSON.stringify({
            id: "0",
            nickname: e,
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.keepAlive
        });
    }
    /* eslint-enable @typescript-eslint/typedef */ addParticipantImplAsync(e) {
        if (this.privParticipants.addOrUpdateParticipant(e) !== void 0 && this.privTranscriberRecognizer) {
            const i = this.conversationInfo;
            return i.participants = [
                e
            ], this.privTranscriberRecognizer.pushConversationEvent(i, "join");
        }
    }
    removeParticipantImplAsync(e) {
        this.privParticipants.deleteParticipant(e.id);
        const t = this.conversationInfo;
        return t.participants = [
            e
        ], this.privTranscriberRecognizer.pushConversationEvent(t, "leave");
    }
    close(e) {
        var t;
        return $d7238066c5de7f1c$var$Hr(this, void 0, void 0, function*() {
            try {
                this.privIsConnected = !1, yield (t = this.privConversationRecognizer) === null || t === void 0 ? void 0 : t.close(), this.privConversationRecognizer = void 0, this.privConversationTranslator && this.privConversationTranslator.dispose();
            } catch (i) {
                throw i;
            }
            e && this.dispose();
        });
    }
    /** Helpers */ handleCallback(e, t) {
        if (e) {
            try {
                e();
            } catch (i) {
                t && t(i);
            }
            e = void 0;
        }
    }
    handleError(e, t) {
        if (t) {
            if (e instanceof Error) {
                const i = e;
                t(i.name + ": " + i.message);
            } else t(e);
        }
    }
    /** Participant Helpers */ toParticipants(e) {
        const t = this.privParticipants.participants.map((i)=>this.toParticipant(i));
        return e ? t : t.filter((i)=>i.isHost === !1);
    }
    toParticipant(e) {
        return new $d7238066c5de7f1c$var$vr(e.id, e.avatar, e.displayName, e.isHost, e.isMuted, e.isUsingTts, e.preferredLanguage, e.voice);
    }
    getMuteAllCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.setMuteAll,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand,
            value: e
        });
    }
    getMuteCommand(e, t) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.setMute,
            // eslint-disable-next-line object-shorthand
            participantId: e,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand,
            value: t
        });
    }
    getLockCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.setLockState,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand,
            value: e
        });
    }
    getEjectCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.ejectParticipant,
            // eslint-disable-next-line object-shorthand
            participantId: e,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand
        });
    }
    getSetTranslateToLanguagesCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.setTranslateToLanguages,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand,
            value: e
        });
    }
    getChangeNicknameCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "nickname"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.changeNickname,
            nickname: e,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand,
            value: e
        });
    }
    getMessageCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "message"), JSON.stringify({
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: e,
            type: $d7238066c5de7f1c$var$ne.instantMessage
        });
    }
}
class $d7238066c5de7f1c$var$Sl {
    constructor(e){
        this.privAudioConfig = e;
    }
    handleCallback(e, t) {
        if (e) {
            try {
                e();
            } catch (i) {
                t && t(i);
            }
            e = void 0;
        }
    }
    handleError(e, t) {
        if (t) {
            if (e instanceof Error) {
                const i = e;
                t(i.name + ": " + i.message);
            } else t(e);
        }
    }
}
class $d7238066c5de7f1c$var$Fp extends $d7238066c5de7f1c$var$Ce {
    constructor(e, t){
        super(t), this.privExpirationTime = e;
    }
    /** How much longer until the conversation expires (in minutes). */ get expirationTime() {
        return this.privExpirationTime;
    }
}
class $d7238066c5de7f1c$var$Ye extends $d7238066c5de7f1c$var$Ce {
    constructor(e, t, i){
        super(i), this.privReason = e, this.privParticipant = t;
    }
    get reason() {
        return this.privReason;
    }
    get participants() {
        return this.privParticipant;
    }
}
class $d7238066c5de7f1c$var$Ho extends $d7238066c5de7f1c$var$gn {
}
class $d7238066c5de7f1c$var$Vt extends $d7238066c5de7f1c$var$Xe {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {ConversationTranslationResult} result - The translation recognition result.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t, i){
        super(t, i), this.privResult = e;
    }
    /**
   * Specifies the recognition result.
   * @returns {ConversationTranslationResult} the recognition result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$Fs extends $d7238066c5de7f1c$var$yt {
    constructor(e, t, i, n, s, o, c, p, h, a, d){
        super(t, n, s, o, c, p, void 0, void 0, h, a, d), this.privId = e, this.privOrigLang = i;
    }
    /**
   * The unique identifier for the participant this result is for.
   */ get participantId() {
        return this.privId;
    }
    /**
   * The original language this result was in.
   */ get originalLang() {
        return this.privOrigLang;
    }
}
class $d7238066c5de7f1c$var$Vs {
    /**
   * Formats a string by replacing the named {keys} in the string with the values contained in the replacement dictionary.
   * @param format The format string that contains the parts to replace surrounded by {}. For example: "wss://{region}.cts.speech.microsoft.com".
   * If your string needs to contain a { or } you can use the {{ and }} escape sequences respectively.
   * @param replacements The dictionary of replacements. If a replacement is not found, it is replaced with an empty string
   * @returns The formatted string. If you pass in a null or undefined format string, an empty string will be returned
   */ static formatString(e, t) {
        if (!e) return "";
        if (!t) return e;
        let i = "", n = "";
        const s = (p)=>{
            i += p;
        }, o = (p)=>{
            n += p;
        };
        let c = s;
        for(let p = 0; p < e.length; p++){
            const h = e[p], a = p + 1 < e.length ? e[p + 1] : "";
            switch(h){
                case "{":
                    a === "{" ? (c("{"), p++) : c = o;
                    break;
                case "}":
                    a === "}" ? (c("}"), p++) : (t.hasOwnProperty(n) && (i += t[n]), c = s, n = "");
                    break;
                default:
                    c(h);
                    break;
            }
        }
        return i;
    }
}
class $d7238066c5de7f1c$var$yn extends $d7238066c5de7f1c$var$fe {
    constructor(e){
        super(), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "convGetter"), this.privConvGetter = e;
    }
    create(e, t, i) {
        const n = e.parameters.getProperty("ConversationTranslator_MultiChannelAudio", "").toUpperCase() === "TRUE", s = this.privConvGetter().room, o = s.cognitiveSpeechRegion || e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, ""), c = {
            hostSuffix: $d7238066c5de7f1c$var$fe.getHostSuffix(o),
            path: $d7238066c5de7f1c$var$yn.CTS_VIRT_MIC_PATH,
            region: encodeURIComponent(o)
        };
        c[$d7238066c5de7f1c$var$w.Language] = encodeURIComponent(e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage, "")), c[$d7238066c5de7f1c$var$w.CtsMeetingId] = encodeURIComponent(s.roomId), c[$d7238066c5de7f1c$var$w.CtsDeviceId] = encodeURIComponent(s.participantId), c[$d7238066c5de7f1c$var$w.CtsIsParticipant] = s.isHost ? "" : "&" + $d7238066c5de7f1c$var$w.CtsIsParticipant;
        let p = "";
        const h = {}, a = {};
        if (n) {
            p = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint), p || (p = "wss://" + e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, "transcribe.{region}.cts.speech{hostSuffix}") + "{path}"), p = $d7238066c5de7f1c$var$Vs.formatString(p, c);
            const v = new URL(p);
            v.searchParams.forEach((I, A)=>{
                h[A] = I;
            }), new $d7238066c5de7f1c$var$ah().setQueryParams(h, e, p), h[$d7238066c5de7f1c$var$w.CtsMeetingId] = c[$d7238066c5de7f1c$var$w.CtsMeetingId], h[$d7238066c5de7f1c$var$w.CtsDeviceId] = c[$d7238066c5de7f1c$var$w.CtsDeviceId], s.isHost || (h[$d7238066c5de7f1c$var$w.CtsIsParticipant] = ""), $d7238066c5de7f1c$var$w.Format in h || (h[$d7238066c5de7f1c$var$w.Format] = "simple"), v.searchParams.forEach((I, A)=>{
                v.searchParams.set(A, h[A]), delete h[A];
            }), p = v.toString();
        } else {
            const v = new $d7238066c5de7f1c$var$ch();
            p = v.getEndpointUrl(e, !0), p = $d7238066c5de7f1c$var$Vs.formatString(p, c), v.setQueryParams(h, e, p);
        }
        a[$d7238066c5de7f1c$var$W.ConnectionId] = i, a[$d7238066c5de7f1c$var$ht.configParams.token] = s.token, t.token && (a[t.headerName] = t.token);
        const d = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "").toUpperCase() === "TRUE";
        return new $d7238066c5de7f1c$var$ut(p, h, a, new $d7238066c5de7f1c$var$At(), $d7238066c5de7f1c$var$Ve.fromRecognizerConfig(e), d, i);
    }
}
$d7238066c5de7f1c$var$yn.CTS_VIRT_MIC_PATH = "/speech/recognition/dynamicaudio";
var $d7238066c5de7f1c$var$ot = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
}, $d7238066c5de7f1c$var$He;
(function(r) {
    r[r.Inactive = 0] = "Inactive", r[r.Connecting = 1] = "Connecting", r[r.Connected = 2] = "Connected";
})($d7238066c5de7f1c$var$He || ($d7238066c5de7f1c$var$He = {}));
class $d7238066c5de7f1c$var$yl extends $d7238066c5de7f1c$var$mn {
    constructor(e, t, i, n){
        super(e, t, new $d7238066c5de7f1c$var$yn(n)), this.privSpeechState = $d7238066c5de7f1c$var$He.Inactive, i && (this.privTranslator = i, this.sessionStarted = ()=>{
            this.privSpeechState = $d7238066c5de7f1c$var$He.Connected;
        }, this.sessionStopped = ()=>{
            this.privSpeechState = $d7238066c5de7f1c$var$He.Inactive;
        }, this.recognizing = (s, o)=>{
            this.privTranslator.recognizing && this.privTranslator.recognizing(this.privTranslator, o);
        }, this.recognized = (s, o)=>$d7238066c5de7f1c$var$ot(this, void 0, void 0, function*() {
                var c;
                !((c = o.result) === null || c === void 0) && c.errorDetails ? (yield this.cancelSpeech(), this.fireCancelEvent(o.result.errorDetails)) : this.privTranslator.recognized && this.privTranslator.recognized(this.privTranslator, o);
            }), this.canceled = ()=>$d7238066c5de7f1c$var$ot(this, void 0, void 0, function*() {
                if (this.privSpeechState !== $d7238066c5de7f1c$var$He.Inactive) try {
                    yield this.cancelSpeech();
                } catch  {
                    this.privSpeechState = $d7238066c5de7f1c$var$He.Inactive;
                }
            }));
    }
    get state() {
        return this.privSpeechState;
    }
    set state(e) {
        this.privSpeechState = e;
    }
    set authentication(e) {
        this.privReco.authentication = e;
    }
    onConnection() {
        this.privSpeechState = $d7238066c5de7f1c$var$He.Connected;
    }
    onCancelSpeech() {
        return $d7238066c5de7f1c$var$ot(this, void 0, void 0, function*() {
            this.privSpeechState = $d7238066c5de7f1c$var$He.Inactive, yield this.cancelSpeech();
        });
    }
    /**
   * Fire a cancel event
   * @param error
   */ fireCancelEvent(e) {
        try {
            if (this.privTranslator.canceled) {
                const t = new $d7238066c5de7f1c$var$Ho($d7238066c5de7f1c$var$X.Error, e, $d7238066c5de7f1c$var$T.RuntimeError);
                this.privTranslator.canceled(this.privTranslator, t);
            }
        } catch  {}
    }
    cancelSpeech() {
        var e;
        return $d7238066c5de7f1c$var$ot(this, void 0, void 0, function*() {
            try {
                this.stopContinuousRecognitionAsync(), yield (e = this.privReco) === null || e === void 0 ? void 0 : e.disconnect(), this.privSpeechState = $d7238066c5de7f1c$var$He.Inactive;
            } catch  {}
        });
    }
}
class $d7238066c5de7f1c$var$Cl extends $d7238066c5de7f1c$var$Sl {
    constructor(e){
        super(e), this.privErrors = $d7238066c5de7f1c$var$$.restErrors, this.privIsDisposed = !1, this.privIsSpeaking = !1, this.privPlaceholderKey = "abcdefghijklmnopqrstuvwxyz012345", this.privPlaceholderRegion = "westus", this.privProperties = new $d7238066c5de7f1c$var$U();
    }
    get properties() {
        return this.privProperties;
    }
    get speechRecognitionLanguage() {
        return this.privSpeechRecognitionLanguage;
    }
    get participants() {
        var e;
        return (e = this.privConversation) === null || e === void 0 ? void 0 : e.participants;
    }
    get canSpeak() {
        return !(!this.privConversation.isConnected || !this.privCTRecognizer || this.privIsSpeaking || this.privCTRecognizer.state === $d7238066c5de7f1c$var$He.Connected || this.privCTRecognizer.state === $d7238066c5de7f1c$var$He.Connecting || this.privConversation.isMutedByHost);
    }
    onToken(e) {
        this.privCTRecognizer.authentication = e;
    }
    setServiceProperty(e, t) {
        const i = JSON.parse(this.privProperties.getProperty($d7238066c5de7f1c$var$It, "{}"));
        i[e] = t, this.privProperties.setProperty($d7238066c5de7f1c$var$It, JSON.stringify(i));
    }
    joinConversationAsync(e, t, i, n, s) {
        try {
            if (typeof e == "string") {
                $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, this.privErrors.invalidArgs.replace("{arg}", "conversation id")), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "nickname")), this.privConversation && this.handleError(new Error(this.privErrors.permissionDeniedStart), s);
                let o = i;
                (o == null || o === "") && (o = $d7238066c5de7f1c$var$$.defaultLanguageCode), this.privSpeechTranslationConfig = $d7238066c5de7f1c$var$Do.fromSubscription(this.privPlaceholderKey, this.privPlaceholderRegion), this.privSpeechTranslationConfig.setProfanity($d7238066c5de7f1c$var$Gt.Masked), this.privSpeechTranslationConfig.addTargetLanguage(o), this.privSpeechTranslationConfig.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage], o), this.privSpeechTranslationConfig.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.ConversationTranslator_Name], t);
                const c = [
                    $d7238066c5de7f1c$var$u.SpeechServiceConnection_Host,
                    $d7238066c5de7f1c$var$u.ConversationTranslator_Host,
                    $d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint,
                    $d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyHostName,
                    $d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyPassword,
                    $d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyPort,
                    $d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyUserName,
                    "ConversationTranslator_MultiChannelAudio",
                    "ConversationTranslator_Region"
                ];
                for (const h of c){
                    const a = this.privProperties.getProperty(h);
                    if (a) {
                        const d = typeof h == "string" ? h : $d7238066c5de7f1c$var$u[h];
                        this.privSpeechTranslationConfig.setProperty(d, a);
                    }
                }
                const p = JSON.parse(this.privProperties.getProperty($d7238066c5de7f1c$var$It, "{}"));
                for (const h of Object.keys(p))this.privSpeechTranslationConfig.setServiceProperty(h, p[h], $d7238066c5de7f1c$var$Xr.UriQueryParameter);
                this.privConversation = new $d7238066c5de7f1c$var$Hs(this.privSpeechTranslationConfig), this.privConversation.conversationTranslator = this, this.privConversation.joinConversationAsync(e, t, o, (h)=>{
                    h || this.handleError(new Error(this.privErrors.permissionDeniedConnect), s), this.privSpeechTranslationConfig.authorizationToken = h, this.privConversation.room.isHost = !1, this.privConversation.startConversationAsync(()=>{
                        this.handleCallback(n, s);
                    }, (a)=>{
                        this.handleError(a, s);
                    });
                }, (h)=>{
                    this.handleError(h, s);
                });
            } else typeof e == "object" ? ($d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, this.privErrors.invalidArgs.replace("{arg}", "conversation id")), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "nickname")), this.privProperties.setProperty($d7238066c5de7f1c$var$u.ConversationTranslator_Name, t), this.privConversation = e, this.privConversation.conversationTranslator = this, this.privConversation.room.isHost = !0, $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedConnect), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect), this.privSpeechTranslationConfig = e.config, this.handleCallback(i, n)) : this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "invalid conversation type")), n);
        } catch (o) {
            this.handleError(o, typeof i == "string" ? s : n);
        }
    }
    /**
   * Leave the conversation
   * @param cb
   * @param err
   */ leaveConversationAsync(e, t) {
        $d7238066c5de7f1c$var$x($d7238066c5de7f1c$var$ot(this, void 0, void 0, function*() {
            yield this.cancelSpeech(), yield this.privConversation.endConversationImplAsync(), yield this.privConversation.deleteConversationImplAsync(), this.dispose();
        }), e, t);
    }
    /**
   * Send a text message
   * @param message
   * @param cb
   * @param err
   */ sendTextMessageAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", e)), this.privConversation.sendTextMessageAsync(e, t, i);
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Start speaking
   * @param cb
   * @param err
   */ startTranscribingAsync(e, t) {
        $d7238066c5de7f1c$var$x($d7238066c5de7f1c$var$ot(this, void 0, void 0, function*() {
            try {
                $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect), this.privCTRecognizer === void 0 && (yield this.connectTranslatorRecognizer()), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privCTRecognizer, this.privErrors.permissionDeniedSend), this.canSpeak || this.handleError(new Error(this.privErrors.permissionDeniedSend), t), yield this.startContinuousRecognition(), this.privIsSpeaking = !0;
            } catch (i) {
                throw this.privIsSpeaking = !1, yield this.cancelSpeech(), i;
            }
        }), e, t);
    }
    /**
   * Stop speaking
   * @param cb
   * @param err
   */ stopTranscribingAsync(e, t) {
        $d7238066c5de7f1c$var$x($d7238066c5de7f1c$var$ot(this, void 0, void 0, function*() {
            try {
                if (!this.privIsSpeaking) {
                    yield this.cancelSpeech();
                    return;
                }
                this.privIsSpeaking = !1, yield new Promise((i, n)=>{
                    this.privCTRecognizer.stopContinuousRecognitionAsync(i, n);
                });
            } catch  {
                yield this.cancelSpeech();
            }
        }), e, t);
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(e, t, i) {
        $d7238066c5de7f1c$var$x($d7238066c5de7f1c$var$ot(this, void 0, void 0, function*() {
            this.isDisposed && !this.privIsSpeaking || (yield this.cancelSpeech(), this.privIsDisposed = !0, this.privSpeechTranslationConfig.close(), this.privSpeechRecognitionLanguage = void 0, this.privProperties = void 0, this.privAudioConfig = void 0, this.privSpeechTranslationConfig = void 0, this.privConversation.dispose(), this.privConversation = void 0);
        }), t, i);
    }
    /**
   * Cancel the speech websocket
   */ cancelSpeech() {
        var e;
        return $d7238066c5de7f1c$var$ot(this, void 0, void 0, function*() {
            try {
                this.privIsSpeaking = !1, yield (e = this.privCTRecognizer) === null || e === void 0 ? void 0 : e.onCancelSpeech(), this.privCTRecognizer = void 0;
            } catch  {}
        });
    }
    /**
   * Connect to the speech translation recognizer.
   * Currently there is no language validation performed before sending the SpeechLanguage code to the service.
   * If it's an invalid language the raw error will be: 'Error during WebSocket handshake: Unexpected response code: 400'
   * e.g. pass in 'fr' instead of 'fr-FR', or a text-only language 'cy'
   */ connectTranslatorRecognizer() {
        return $d7238066c5de7f1c$var$ot(this, void 0, void 0, function*() {
            try {
                this.privAudioConfig === void 0 && (this.privAudioConfig = $d7238066c5de7f1c$var$bt.fromDefaultMicrophoneInput()), this.privSpeechTranslationConfig.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_Key]) === this.privPlaceholderKey && this.privSpeechTranslationConfig.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_Key], "");
                const e = ()=>this.privConversation;
                this.privCTRecognizer = new $d7238066c5de7f1c$var$yl(this.privSpeechTranslationConfig, this.privAudioConfig, this, e);
            } catch (e) {
                throw yield this.cancelSpeech(), e;
            }
        });
    }
    /**
   * Handle the start speaking request
   */ startContinuousRecognition() {
        return new Promise((e, t)=>{
            this.privCTRecognizer.startContinuousRecognitionAsync(e, t);
        });
    }
}
var $d7238066c5de7f1c$var$wl = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Fo extends $d7238066c5de7f1c$var$Fe {
    /**
   * ConversationTranscriber constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ constructor(e, t){
        const i = e;
        $d7238066c5de7f1c$var$l.throwIfNull(i, "speechConfig"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(i.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage), $d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage]), super(t, i.properties, new $d7238066c5de7f1c$var$Hl()), this.privProperties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecognitionEndpointVersion, "2"), this.privDisposedRecognizer = !1;
    }
    /**
   * ConversationTranscriber constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
   * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ static FromConfig(e, t, i) {
        const n = e;
        return t.properties.mergeTo(n.properties), new $d7238066c5de7f1c$var$Fo(e, i);
    }
    /**
   * Gets the endpoint id of a customized speech model that is used for transcription.
   * @member ConversationTranscriber.prototype.endpointId
   * @function
   * @public
   * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
   */ get endpointId() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member ConversationTranscriber.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member ConversationTranscriber.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    /**
   * Gets the spoken language of transcription.
   * @member ConversationTranscriber.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @returns {string} The spoken language of transcription.
   */ get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage);
    }
    /**
   * Gets the output format of transcription.
   * @member ConversationTranscriber.prototype.outputFormat
   * @function
   * @public
   * @returns {OutputFormat} The output format of transcription.
   */ get outputFormat() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$$e, $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple]) === $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple] ? $d7238066c5de7f1c$var$B.Simple : $d7238066c5de7f1c$var$B.Detailed;
    }
    /**
   * The collection of properties and their values defined for this conversation transcriber.
   * @member ConversationTranscriber.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Starts conversation transcription, until stopTranscribingAsync() is called.
   * User must subscribe to events to receive transcription results.
   * @member ConversationTranscriber.prototype.startTranscribingAsync
   * @function
   * @public
   * @param cb - Callback invoked once the transcription has started.
   * @param err - Callback invoked in case of an error.
   */ startTranscribingAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.startContinuousRecognitionAsyncImpl($d7238066c5de7f1c$var$ue.Conversation), e, t);
    }
    /**
   * Stops conversation transcription.
   * @member ConversationTranscriber.prototype.stopTranscribingAsync
   * @function
   * @public
   * @param cb - Callback invoked once the transcription has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopTranscribingAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member ConversationTranscriber.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedRecognizer), $d7238066c5de7f1c$var$x(this.dispose(!0), e, t);
    }
    /**
   * Disposes any resources held by the object.
   * @member SpeechRecognizer.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - true if disposing the object.
   */ dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$wl(this, void 0, void 0, function*() {
            this.privDisposedRecognizer || (e && (this.privDisposedRecognizer = !0, yield this.implRecognizerStop()), yield t.dispose.call(this, e));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$Et(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return n.isSpeakerDiarizationEnabled = !0, new $d7238066c5de7f1c$var$Jl(e, t, s, n, this);
    }
}
class $d7238066c5de7f1c$var$Rl {
    constructor(e){
        this.privUserId = e;
    }
    get userId() {
        return this.privUserId;
    }
}
class $d7238066c5de7f1c$var$vr {
    constructor(e, t, i, n, s, o, c, p){
        this.privId = e, this.privAvatar = t, this.privDisplayName = i, this.privIsHost = n, this.privIsMuted = s, this.privIsUsingTts = o, this.privPreferredLanguage = c, this.privVoice = p, this.privProperties = new $d7238066c5de7f1c$var$U();
    }
    get avatar() {
        return this.privAvatar;
    }
    get displayName() {
        return this.privDisplayName;
    }
    get id() {
        return this.privId;
    }
    get preferredLanguage() {
        return this.privPreferredLanguage;
    }
    get isHost() {
        return this.privIsHost;
    }
    get isMuted() {
        return this.privIsMuted;
    }
    get isUsingTts() {
        return this.privIsUsingTts;
    }
    get voice() {
        return this.privVoice;
    }
    get properties() {
        return this.privProperties;
    }
    static From(e, t, i) {
        return new $d7238066c5de7f1c$var$vr(e, "", e, !1, !1, !1, t, i);
    }
}
var $d7238066c5de7f1c$var$xe;
(function(r) {
    r[r.JoinedConversation = 0] = "JoinedConversation", r[r.LeftConversation = 1] = "LeftConversation", r[r.Updated = 2] = "Updated";
})($d7238066c5de7f1c$var$xe || ($d7238066c5de7f1c$var$xe = {}));
var $d7238066c5de7f1c$var$Fr = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Vp {
    constructor(){}
    /**
   * Create a meeting
   * @param speechConfig
   * @param meetingId
   * @param cb
   * @param err
   */ static createMeetingAsync(e, t, i, n) {
        if ($d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, $d7238066c5de7f1c$var$$.restErrors.invalidArgs.replace("{arg}", "config")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e.region, $d7238066c5de7f1c$var$$.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region")), $d7238066c5de7f1c$var$l.throwIfNull(t, "meetingId"), t.length === 0) throw new Error("meetingId cannot be empty");
        !e.subscriptionKey && !e.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token]) && $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e.subscriptionKey, $d7238066c5de7f1c$var$$.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        const s = new $d7238066c5de7f1c$var$Kp(e, t);
        return $d7238066c5de7f1c$var$x($d7238066c5de7f1c$var$Fr(this, void 0, void 0, function*() {}), i, n), s;
    }
}
class $d7238066c5de7f1c$var$Kp extends $d7238066c5de7f1c$var$Vp {
    /**
   * Create a Meeting impl
   * @param speechConfig
   * @param {string} id - optional conversationId
   */ constructor(e, t){
        super(), this.privErrors = $d7238066c5de7f1c$var$$.restErrors, this.onConnected = (s)=>{
            var o;
            this.privIsConnected = !0;
            try {
                !((o = this.privConversationTranslator) === null || o === void 0) && o.sessionStarted && this.privConversationTranslator.sessionStarted(this.privConversationTranslator, s);
            } catch  {}
        }, this.onDisconnected = (s)=>{
            var o;
            try {
                !((o = this.privConversationTranslator) === null || o === void 0) && o.sessionStopped && this.privConversationTranslator.sessionStopped(this.privConversationTranslator, s);
            } catch  {} finally{
                this.close(!1);
            }
        }, this.onCanceled = (s, o)=>{
            var c;
            try {
                !((c = this.privConversationTranslator) === null || c === void 0) && c.canceled && this.privConversationTranslator.canceled(this.privConversationTranslator, o);
            } catch  {}
        }, this.onParticipantUpdateCommandReceived = (s, o)=>{
            try {
                const c = this.privParticipants.getParticipant(o.id);
                if (c !== void 0) {
                    switch(o.key){
                        case $d7238066c5de7f1c$var$re.changeNickname:
                            c.displayName = o.value;
                            break;
                        case $d7238066c5de7f1c$var$re.setUseTTS:
                            c.isUsingTts = o.value;
                            break;
                        case $d7238066c5de7f1c$var$re.setProfanityFiltering:
                            c.profanity = o.value;
                            break;
                        case $d7238066c5de7f1c$var$re.setMute:
                            c.isMuted = o.value;
                            break;
                        case $d7238066c5de7f1c$var$re.setTranslateToLanguages:
                            c.translateToLanguages = o.value;
                            break;
                    }
                    this.privParticipants.addOrUpdateParticipant(c), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$Ye($d7238066c5de7f1c$var$xe.Updated, [
                        this.toParticipant(c)
                    ], o.sessionId));
                }
            } catch  {}
        }, this.onLockRoomCommandReceived = ()=>{}, this.onMuteAllCommandReceived = (s, o)=>{
            try {
                this.privParticipants.participants.forEach((c)=>c.isMuted = c.isHost ? !1 : o.isMuted), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$Ye($d7238066c5de7f1c$var$xe.Updated, this.toParticipants(!1), o.sessionId));
            } catch  {}
        }, this.onParticipantJoinCommandReceived = (s, o)=>{
            try {
                const c = this.privParticipants.addOrUpdateParticipant(o.participant);
                c !== void 0 && this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$Ye($d7238066c5de7f1c$var$xe.JoinedConversation, [
                    this.toParticipant(c)
                ], o.sessionId));
            } catch  {}
        }, this.onParticipantLeaveCommandReceived = (s, o)=>{
            try {
                const c = this.privParticipants.getParticipant(o.participant.id);
                c !== void 0 && (this.privParticipants.deleteParticipant(o.participant.id), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$Ye($d7238066c5de7f1c$var$xe.LeftConversation, [
                    this.toParticipant(c)
                ], o.sessionId)));
            } catch  {}
        }, this.onTranslationReceived = (s, o)=>{
            try {
                switch(o.command){
                    case $d7238066c5de7f1c$var$ne.final:
                        this.privConversationTranslator && this.privConversationTranslator.transcribed(this.privConversationTranslator, new $d7238066c5de7f1c$var$Vt(o.payload, void 0, o.sessionId));
                        break;
                    case $d7238066c5de7f1c$var$ne.partial:
                        this.privConversationTranslator && this.privConversationTranslator.transcribing(this.privConversationTranslator, new $d7238066c5de7f1c$var$Vt(o.payload, void 0, o.sessionId));
                        break;
                    case $d7238066c5de7f1c$var$ne.instantMessage:
                        this.privConversationTranslator && this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new $d7238066c5de7f1c$var$Vt(o.payload, void 0, o.sessionId));
                        break;
                }
            } catch  {}
        }, this.onParticipantsListReceived = (s, o)=>{
            var c;
            try {
                if (o.sessionToken !== void 0 && o.sessionToken !== null && (this.privRoom.token = o.sessionToken), this.privParticipants.participants = [
                    ...o.participants
                ], this.privParticipants.me !== void 0 && (this.privIsReady = !0), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$Ye($d7238066c5de7f1c$var$xe.JoinedConversation, this.toParticipants(!0), o.sessionId)), this.me.isHost) {
                    const p = (c = this.privConversationTranslator) === null || c === void 0 ? void 0 : c.properties.getProperty($d7238066c5de7f1c$var$u.ConversationTranslator_Name);
                    p !== void 0 && p.length > 0 && p !== this.me.displayName && this.changeNicknameAsync(p);
                }
            } catch  {}
        }, this.onConversationExpiration = (s, o)=>{
            try {
                this.privConversationTranslator && this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, o);
            } catch  {}
        }, this.privIsConnected = !1, this.privIsDisposed = !1, this.privConversationId = "", this.privProperties = new $d7238066c5de7f1c$var$U(), this.privManager = new $d7238066c5de7f1c$var$hh(), e.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage]) || e.setProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage], $d7238066c5de7f1c$var$$.defaultLanguageCode), this.privLanguage = e.getProperty($d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage]), this.privConversationId = t, this.privConfig = e;
        const n = e;
        $d7238066c5de7f1c$var$l.throwIfNull(n, "speechConfig"), this.privProperties = n.properties.clone(), this.privIsConnected = !1, this.privParticipants = new $d7238066c5de7f1c$var$uh(), this.privIsReady = !1, this.privTextMessageMaxLength = 1e3;
    }
    // get the internal data about a conversation
    get room() {
        return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
        return this.privConversationRecognizer;
    }
    // get the config
    get config() {
        return this.privConfig;
    }
    // get the meeting Id
    get meetingId() {
        return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
        return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
        return this.privLanguage;
    }
    get isMutedByHost() {
        var e, t;
        return !((e = this.privParticipants.me) === null || e === void 0) && e.isHost ? !1 : (t = this.privParticipants.me) === null || t === void 0 ? void 0 : t.isMuted;
    }
    get isConnected() {
        return this.privIsConnected && this.privIsReady;
    }
    get participants() {
        return this.toParticipants(!0);
    }
    get me() {
        return this.toParticipant(this.privParticipants.me);
    }
    get host() {
        return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
        return this.privTranscriberRecognizer;
    }
    get meetingInfo() {
        const e = this.meetingId, t = this.participants.map((s)=>({
                id: s.id,
                preferredLanguage: s.preferredLanguage,
                voice: s.voice
            })), i = {};
        for (const s of $d7238066c5de7f1c$var$$.transcriptionEventKeys){
            const o = this.properties.getProperty(s, "");
            o !== "" && (i[s] = o);
        }
        return {
            id: e,
            participants: t,
            meetingProperties: i
        };
    }
    get canSend() {
        var e;
        return this.privIsConnected && !(!((e = this.privParticipants.me) === null || e === void 0) && e.isMuted);
    }
    get canSendAsHost() {
        var e;
        return this.privIsConnected && ((e = this.privParticipants.me) === null || e === void 0 ? void 0 : e.isHost);
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
        return this.privToken;
    }
    set authorizationToken(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "authorizationToken"), this.privToken = e;
    }
    /**
   * Create a new meeting as Host
   * @param cb
   * @param err
   */ createMeetingAsync(e, t) {
        try {
            this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), t), this.privManager.createOrJoin(this.privProperties, void 0, (i)=>{
                i || this.handleError(new Error(this.privErrors.permissionDeniedConnect), t), this.privRoom = i, this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Starts a new meeting as host.
   * @param cb
   * @param err
   */ startMeetingAsync(e, t) {
        try {
            this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), t), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect), this.privParticipants.meId = this.privRoom.participantId, this.privConversationRecognizer.connected = this.onConnected, this.privConversationRecognizer.disconnected = this.onDisconnected, this.privConversationRecognizer.canceled = this.onCanceled, this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived, this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived, this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived, this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived, this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived, this.privConversationRecognizer.translationReceived = this.onTranslationReceived, this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived, this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration, this.privConversationRecognizer.connect(this.privRoom.token, ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Join a meeting as a participant.
   * @param { IParticipant } participant - participant to add
   * @param cb
   * @param err
   */ addParticipantAsync(e, t, i) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "Participant"), $d7238066c5de7f1c$var$x(this.addParticipantImplAsync(e), t, i);
    }
    /**
   * Join a meeting as a participant.
   * @param meeting
   * @param nickname
   * @param lang
   * @param cb
   * @param err
   */ joinMeetingAsync(e, t, i, n, s) {
        try {
            $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "conversationId")), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "nickname")), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(i, this.privErrors.invalidArgs.replace("{arg}", "language")), this.privManager.createOrJoin(this.privProperties, e, (o)=>{
                $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(o, this.privErrors.permissionDeniedConnect), this.privRoom = o, this.privConfig.authorizationToken = o.cognitiveSpeechAuthToken, n && n(o.cognitiveSpeechAuthToken);
            }, (o)=>{
                this.handleError(o, s);
            });
        } catch (o) {
            this.handleError(o, s);
        }
    }
    /**
   * Deletes a meeting
   * @param cb
   * @param err
   */ deleteMeetingAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.deleteMeetingImplAsync(), e, t);
    }
    deleteMeetingImplAsync() {
        return $d7238066c5de7f1c$var$Fr(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect), yield this.privManager.leave(this.privProperties, this.privRoom.token), this.dispose();
        });
    }
    /**
   * Issues a request to close the client websockets
   * @param cb
   * @param err
   */ endMeetingAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.endMeetingImplAsync(), e, t);
    }
    endMeetingImplAsync() {
        return this.close(!0);
    }
    /**
   * Issues a request to lock the conversation
   * @param cb
   * @param err
   */ lockMeetingAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!0), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to mute the meeting
   * @param cb
   * @param err
   */ muteAllParticipantsAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!0), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to mute a participant in the meeting
   * @param userId
   * @param cb
   * @param err
   */ muteParticipantAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "userId")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), !this.me.isHost && this.me.id !== e && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), i), this.privParticipants.getParticipantIndex(e) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(e, !0), ()=>{
                this.handleCallback(t, i);
            }, (s)=>{
                this.handleError(s, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Issues a request to remove a participant from the conversation
   * @param userId
   * @param cb
   * @param err
   */ removeParticipantAsync(e, t, i) {
        try {
            if ($d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), this.privTranscriberRecognizer && e.hasOwnProperty("id")) $d7238066c5de7f1c$var$x(this.removeParticipantImplAsync(e), t, i);
            else {
                $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), i);
                let n = "";
                typeof e == "string" ? n = e : e.hasOwnProperty("id") ? n = e.id : e.hasOwnProperty("userId") && (n = e.userId), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(n, this.privErrors.invalidArgs.replace("{arg}", "userId")), this.participants.findIndex((o)=>o.id === n) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getEjectCommand(n), ()=>{
                    this.handleCallback(t, i);
                }, (o)=>{
                    this.handleError(o, i);
                });
            }
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Issues a request to unlock the meeting
   * @param cb
   * @param err
   */ unlockMeetingAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!1), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to unmute all participants in the meeting
   * @param cb
   * @param err
   */ unmuteAllParticipantsAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!1), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to unmute a participant in the meeting
   * @param userId
   * @param cb
   * @param err
   */ unmuteParticipantAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "userId")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), !this.me.isHost && this.me.id !== e && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), i), this.privParticipants.getParticipantIndex(e) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(e, !1), ()=>{
                this.handleCallback(t, i);
            }, (s)=>{
                this.handleError(s, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Send a text message
   * @param message
   * @param cb
   * @param err
   */ sendTextMessageAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "message")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), e.length > this.privTextMessageMaxLength && this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMessageCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Set translated to languages
   * @param {string[]} languages - languages to translate to
   * @param cb
   * @param err
   */ setTranslatedLanguagesAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfArrayEmptyOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "languages")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Change nickname
   * @param {string} nickname - new nickname for the room
   * @param cb
   * @param err
   */ changeNicknameAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "nickname")), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        this.isDisposed || (this.privIsDisposed = !0, this.config && this.config.close(), this.privConfig = void 0, this.privLanguage = void 0, this.privProperties = void 0, this.privRoom = void 0, this.privToken = void 0, this.privManager = void 0, this.privIsConnected = !1, this.privIsReady = !1, this.privParticipants = void 0);
    }
    connectTranscriberRecognizer(e) {
        return $d7238066c5de7f1c$var$Fr(this, void 0, void 0, function*() {
            this.privTranscriberRecognizer && (yield this.privTranscriberRecognizer.close()), yield e.enforceAudioGating(), this.privTranscriberRecognizer = e, this.privTranscriberRecognizer.meeting = this;
        });
    }
    getKeepAlive() {
        const e = this.me ? this.me.displayName : "default_nickname";
        return JSON.stringify({
            id: "0",
            nickname: e,
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.keepAlive
        });
    }
    /* eslint-enable @typescript-eslint/typedef */ addParticipantImplAsync(e) {
        if (this.privParticipants.addOrUpdateParticipant(e) !== void 0 && this.privTranscriberRecognizer) {
            const i = this.meetingInfo;
            return i.participants = [
                e
            ], this.privTranscriberRecognizer.pushMeetingEvent(i, "join");
        }
    }
    removeParticipantImplAsync(e) {
        this.privParticipants.deleteParticipant(e.id);
        const t = this.meetingInfo;
        return t.participants = [
            e
        ], this.privTranscriberRecognizer.pushMeetingEvent(t, "leave");
    }
    close(e) {
        var t;
        return $d7238066c5de7f1c$var$Fr(this, void 0, void 0, function*() {
            try {
                this.privIsConnected = !1, yield (t = this.privConversationRecognizer) === null || t === void 0 ? void 0 : t.close(), this.privConversationRecognizer = void 0, this.privConversationTranslator && this.privConversationTranslator.dispose();
            } catch (i) {
                throw i;
            }
            e && this.dispose();
        });
    }
    /** Helpers */ handleCallback(e, t) {
        if (e) {
            try {
                e();
            } catch (i) {
                t && t(i);
            }
            e = void 0;
        }
    }
    handleError(e, t) {
        if (t) {
            if (e instanceof Error) {
                const i = e;
                t(i.name + ": " + i.message);
            } else t(e);
        }
    }
    /** Participant Helpers */ toParticipants(e) {
        const t = this.privParticipants.participants.map((i)=>this.toParticipant(i));
        return e ? t : t.filter((i)=>i.isHost === !1);
    }
    toParticipant(e) {
        return new $d7238066c5de7f1c$var$vr(e.id, e.avatar, e.displayName, e.isHost, e.isMuted, e.isUsingTts, e.preferredLanguage, e.voice);
    }
    getMuteAllCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingd"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.setMuteAll,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand,
            value: e
        });
    }
    getMuteCommand(e, t) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.setMute,
            // eslint-disable-next-line object-shorthand
            participantId: e,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand,
            value: t
        });
    }
    getLockCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.setLockState,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand,
            value: e
        });
    }
    getEjectCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.ejectParticipant,
            // eslint-disable-next-line object-shorthand
            participantId: e,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand
        });
    }
    getSetTranslateToLanguagesCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.setTranslateToLanguages,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand,
            value: e
        });
    }
    getChangeNicknameCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "nickname"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$re.changeNickname,
            nickname: e,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$ne.participantCommand,
            value: e
        });
    }
    getMessageCommand(e) {
        return $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "message"), JSON.stringify({
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: e,
            type: $d7238066c5de7f1c$var$ne.instantMessage
        });
    }
}
var $d7238066c5de7f1c$var$Fa = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Il {
    /**
   * MeetingTranscriber constructor.
   * @constructor
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ constructor(e){
        this.privAudioConfig = e, this.privProperties = new $d7238066c5de7f1c$var$U(), this.privRecognizer = void 0, this.privDisposedRecognizer = !1;
    }
    /**
   * Gets the spoken language of recognition.
   * @member MeetingTranscriber.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @returns {string} The spoken language of recognition.
   */ get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage);
    }
    /**
   * The collection of properties and their values defined for this MeetingTranscriber.
   * @member MeetingTranscriber.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this MeetingTranscriber.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * @Internal
   * Internal data member to support fromRecognizer* pattern methods on other classes.
   * Do not use externally, object returned will change without warning or notice.
   */ get internalData() {
        return this.privRecognizer.internalData;
    }
    /**
   * @Deprecated
   * @Obsolete
   * Please use the Connection.fromRecognizer pattern to obtain a connection object
   */ get connection() {
        return $d7238066c5de7f1c$var$Jt.fromRecognizer(this.privRecognizer);
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member MeetingTranscriber.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member MeetingTranscriber.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    /**
   * @param {Meeting} meeting - meeting to be recognized
   */ joinMeetingAsync(e, t, i) {
        const n = e;
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined($d7238066c5de7f1c$var$Kp, "Meeting"), this.privRecognizer = new $d7238066c5de7f1c$var$yv(e.config, this.privAudioConfig), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privRecognizer, "Recognizer"), this.privRecognizer.connectMeetingCallbacks(this), $d7238066c5de7f1c$var$x(n.connectTranscriberRecognizer(this.privRecognizer), t, i);
    }
    /**
   * Starts meeting transcription, until stopTranscribingAsync() is called.
   * User must subscribe to events to receive transcription results.
   * @member MeetingTranscriber.prototype.startTranscribingAsync
   * @function
   * @public
   * @param cb - Callback invoked once the transcription has started.
   * @param err - Callback invoked in case of an error.
   */ startTranscribingAsync(e, t) {
        this.privRecognizer.startContinuousRecognitionAsync(e, t);
    }
    /**
   * Starts meeting transcription, until stopTranscribingAsync() is called.
   * User must subscribe to events to receive transcription results.
   * @member MeetingTranscriber.prototype.stopTranscribingAsync
   * @function
   * @public
   * @param cb - Callback invoked once the transcription has started.
   * @param err - Callback invoked in case of an error.
   */ stopTranscribingAsync(e, t) {
        this.privRecognizer.stopContinuousRecognitionAsync(e, t);
    }
    /**
   * Leave the current meeting. After this is called, you will no longer receive any events.
   */ leaveMeetingAsync(e, t) {
        this.privRecognizer.disconnectCallbacks(), $d7238066c5de7f1c$var$x($d7238066c5de7f1c$var$Fa(this, void 0, void 0, function*() {}), e, t);
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member MeetingTranscriber.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedRecognizer), $d7238066c5de7f1c$var$x(this.dispose(!0), e, t);
    }
    /**
   * Disposes any resources held by the object.
   * @member MeetingTranscriber.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - true if disposing the object.
   */ dispose(e) {
        return $d7238066c5de7f1c$var$Fa(this, void 0, void 0, function*() {
            this.privDisposedRecognizer || (this.privRecognizer && (yield this.privRecognizer.close(), this.privRecognizer = void 0), e && (this.privDisposedRecognizer = !0));
        });
    }
}
class $d7238066c5de7f1c$var$Vr extends $d7238066c5de7f1c$var$fn {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @public
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} language - Primary Language detected, if provided.
   * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param {string} speakerId - speaker id for conversation transcription.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s, o, c, p, h, a, d){
        super(e, t, i, n, s, o, c, h, a, d), this.privSpeakerId = p;
    }
    /**
   * speaker id
   * @member ConversationTranscriptionResult.prototype.speakerId
   * @function
   * @public
   * @returns {string} id of speaker in given result
   */ get speakerId() {
        return this.privSpeakerId;
    }
}
var $d7238066c5de7f1c$var$Va = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$fr {
    /**
   * Creates and initializes an instance of a Recognizer
   * @constructor
   * @param {SpeechConfig} speechConfig - The speech config to initialize the synthesizer.
   */ constructor(e){
        const t = e;
        $d7238066c5de7f1c$var$l.throwIfNull(t, "speechConfig"), this.privProperties = t.properties.clone(), this.privDisposed = !1, this.privSynthesizing = !1, this.synthesisRequestQueue = new $d7238066c5de7f1c$var$Qi();
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member Synthesizer.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member Synthesizer.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    /**
   * The collection of properties and their values defined for this Synthesizer.
   * @member Synthesizer.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechSynthesizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Indicates if auto detect source language is enabled
   * @member Synthesizer.prototype.autoDetectSourceLanguage
   * @function
   * @public
   * @returns {boolean} if auto detect source language is enabled
   */ get autoDetectSourceLanguage() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_AutoDetectSourceLanguages) === $d7238066c5de7f1c$var$lh;
    }
    buildSsml(e) {
        const t = {
            "af-ZA": "af-ZA-AdriNeural",
            "am-ET": "am-ET-AmehaNeural",
            "ar-AE": "ar-AE-FatimaNeural",
            "ar-BH": "ar-BH-AliNeural",
            "ar-DZ": "ar-DZ-AminaNeural",
            "ar-EG": "ar-EG-SalmaNeural",
            "ar-IQ": "ar-IQ-BasselNeural",
            "ar-JO": "ar-JO-SanaNeural",
            "ar-KW": "ar-KW-FahedNeural",
            "ar-LY": "ar-LY-ImanNeural",
            "ar-MA": "ar-MA-JamalNeural",
            "ar-QA": "ar-QA-AmalNeural",
            "ar-SA": "ar-SA-HamedNeural",
            "ar-SY": "ar-SY-AmanyNeural",
            "ar-TN": "ar-TN-HediNeural",
            "ar-YE": "ar-YE-MaryamNeural",
            "bg-BG": "bg-BG-BorislavNeural",
            "bn-BD": "bn-BD-NabanitaNeural",
            "bn-IN": "bn-IN-BashkarNeural",
            "ca-ES": "ca-ES-JoanaNeural",
            "cs-CZ": "cs-CZ-AntoninNeural",
            "cy-GB": "cy-GB-AledNeural",
            "da-DK": "da-DK-ChristelNeural",
            "de-AT": "de-AT-IngridNeural",
            "de-CH": "de-CH-JanNeural",
            "de-DE": "de-DE-KatjaNeural",
            "el-GR": "el-GR-AthinaNeural",
            "en-AU": "en-AU-NatashaNeural",
            "en-CA": "en-CA-ClaraNeural",
            "en-GB": "en-GB-LibbyNeural",
            "en-HK": "en-HK-SamNeural",
            "en-IE": "en-IE-ConnorNeural",
            "en-IN": "en-IN-NeerjaNeural",
            "en-KE": "en-KE-AsiliaNeural",
            "en-NG": "en-NG-AbeoNeural",
            "en-NZ": "en-NZ-MitchellNeural",
            "en-PH": "en-PH-JamesNeural",
            "en-SG": "en-SG-LunaNeural",
            "en-TZ": "en-TZ-ElimuNeural",
            "en-US": "en-US-JennyNeural",
            "en-ZA": "en-ZA-LeahNeural",
            "es-AR": "es-AR-ElenaNeural",
            "es-BO": "es-BO-MarceloNeural",
            "es-CL": "es-CL-CatalinaNeural",
            "es-CO": "es-CO-GonzaloNeural",
            "es-CR": "es-CR-JuanNeural",
            "es-CU": "es-CU-BelkysNeural",
            "es-DO": "es-DO-EmilioNeural",
            "es-EC": "es-EC-AndreaNeural",
            "es-ES": "es-ES-AlvaroNeural",
            "es-GQ": "es-GQ-JavierNeural",
            "es-GT": "es-GT-AndresNeural",
            "es-HN": "es-HN-CarlosNeural",
            "es-MX": "es-MX-DaliaNeural",
            "es-NI": "es-NI-FedericoNeural",
            "es-PA": "es-PA-MargaritaNeural",
            "es-PE": "es-PE-AlexNeural",
            "es-PR": "es-PR-KarinaNeural",
            "es-PY": "es-PY-MarioNeural",
            "es-SV": "es-SV-LorenaNeural",
            "es-US": "es-US-AlonsoNeural",
            "es-UY": "es-UY-MateoNeural",
            "es-VE": "es-VE-PaolaNeural",
            "et-EE": "et-EE-AnuNeural",
            "fa-IR": "fa-IR-DilaraNeural",
            "fi-FI": "fi-FI-SelmaNeural",
            "fil-PH": "fil-PH-AngeloNeural",
            "fr-BE": "fr-BE-CharlineNeural",
            "fr-CA": "fr-CA-SylvieNeural",
            "fr-CH": "fr-CH-ArianeNeural",
            "fr-FR": "fr-FR-DeniseNeural",
            "ga-IE": "ga-IE-ColmNeural",
            "gl-ES": "gl-ES-RoiNeural",
            "gu-IN": "gu-IN-DhwaniNeural",
            "he-IL": "he-IL-AvriNeural",
            "hi-IN": "hi-IN-MadhurNeural",
            "hr-HR": "hr-HR-GabrijelaNeural",
            "hu-HU": "hu-HU-NoemiNeural",
            "id-ID": "id-ID-ArdiNeural",
            "is-IS": "is-IS-GudrunNeural",
            "it-IT": "it-IT-IsabellaNeural",
            "ja-JP": "ja-JP-NanamiNeural",
            "jv-ID": "jv-ID-DimasNeural",
            "kk-KZ": "kk-KZ-AigulNeural",
            "km-KH": "km-KH-PisethNeural",
            "kn-IN": "kn-IN-GaganNeural",
            "ko-KR": "ko-KR-SunHiNeural",
            "lo-LA": "lo-LA-ChanthavongNeural",
            "lt-LT": "lt-LT-LeonasNeural",
            "lv-LV": "lv-LV-EveritaNeural",
            "mk-MK": "mk-MK-AleksandarNeural",
            "ml-IN": "ml-IN-MidhunNeural",
            "mr-IN": "mr-IN-AarohiNeural",
            "ms-MY": "ms-MY-OsmanNeural",
            "mt-MT": "mt-MT-GraceNeural",
            "my-MM": "my-MM-NilarNeural",
            "nb-NO": "nb-NO-PernilleNeural",
            "nl-BE": "nl-BE-ArnaudNeural",
            "nl-NL": "nl-NL-ColetteNeural",
            "pl-PL": "pl-PL-AgnieszkaNeural",
            "ps-AF": "ps-AF-GulNawazNeural",
            "pt-BR": "pt-BR-FranciscaNeural",
            "pt-PT": "pt-PT-DuarteNeural",
            "ro-RO": "ro-RO-AlinaNeural",
            "ru-RU": "ru-RU-SvetlanaNeural",
            "si-LK": "si-LK-SameeraNeural",
            "sk-SK": "sk-SK-LukasNeural",
            "sl-SI": "sl-SI-PetraNeural",
            "so-SO": "so-SO-MuuseNeural",
            "sr-RS": "sr-RS-NicholasNeural",
            "su-ID": "su-ID-JajangNeural",
            "sv-SE": "sv-SE-SofieNeural",
            "sw-KE": "sw-KE-RafikiNeural",
            "sw-TZ": "sw-TZ-DaudiNeural",
            "ta-IN": "ta-IN-PallaviNeural",
            "ta-LK": "ta-LK-KumarNeural",
            "ta-SG": "ta-SG-AnbuNeural",
            "te-IN": "te-IN-MohanNeural",
            "th-TH": "th-TH-PremwadeeNeural",
            "tr-TR": "tr-TR-AhmetNeural",
            "uk-UA": "uk-UA-OstapNeural",
            "ur-IN": "ur-IN-GulNeural",
            "ur-PK": "ur-PK-AsadNeural",
            "uz-UZ": "uz-UZ-MadinaNeural",
            "vi-VN": "vi-VN-HoaiMyNeural",
            "zh-CN": "zh-CN-XiaoxiaoNeural",
            "zh-HK": "zh-HK-HiuMaanNeural",
            "zh-TW": "zh-TW-HsiaoChenNeural",
            "zu-ZA": "zu-ZA-ThandoNeural"
        };
        let i = this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthLanguage, "en-US"), n = this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthVoice, ""), s = $d7238066c5de7f1c$var$fr.XMLEncode(e);
        return this.autoDetectSourceLanguage ? i = "en-US" : n = n || t[i], n && (s = `<voice name='${n}'>${s}</voice>`), s = `<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xmlns:emo='http://www.w3.org/2009/10/emotionml' xml:lang='${i}'>${s}</speak>`, s;
    }
    /**
   * This method performs cleanup of resources.
   * The Boolean parameter disposing indicates whether the method is called
   * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
   * Derived classes should override this method to dispose resource if needed.
   * @member Synthesizer.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - Flag to request disposal.
   */ dispose(e) {
        return $d7238066c5de7f1c$var$Va(this, void 0, void 0, function*() {
            this.privDisposed || (e && this.privAdapter && (yield this.privAdapter.dispose()), this.privDisposed = !0);
        });
    }
    adapterSpeak() {
        return $d7238066c5de7f1c$var$Va(this, void 0, void 0, function*() {
            if (!this.privDisposed && !this.privSynthesizing) {
                this.privSynthesizing = !0;
                const e = yield this.synthesisRequestQueue.dequeue();
                return this.privAdapter.Speak(e.text, e.isSSML, e.requestId, e.cb, e.err, e.dataStream);
            }
        });
    }
    createSynthesizerConfig(e) {
        return new $d7238066c5de7f1c$var$bv(e, this.privProperties);
    }
    // Does the generic synthesizer setup that is common across all synthesizer types.
    implCommonSynthesizeSetup() {
        let e = typeof window < "u" ? "Browser" : "Node", t = "unknown", i = "unknown";
        typeof navigator < "u" && (e = e + "/" + navigator.platform, t = navigator.userAgent, i = navigator.appVersion);
        const n = this.createSynthesizerConfig(new $d7238066c5de7f1c$var$wn(new $d7238066c5de7f1c$var$Rn(new $d7238066c5de7f1c$var$dh(e, t, i)))), s = this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key, void 0), o = s && s !== "" ? new $d7238066c5de7f1c$var$Np(s) : new $d7238066c5de7f1c$var$jt(()=>{
            const c = this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, void 0);
            return Promise.resolve(c);
        }, ()=>{
            const c = this.privProperties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, void 0);
            return Promise.resolve(c);
        });
        this.privAdapter = this.createSynthesisAdapter(o, this.privConnectionFactory, n), this.privRestAdapter = this.createRestSynthesisAdapter(o, n);
    }
    static XMLEncode(e) {
        return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    }
}
class $d7238066c5de7f1c$var$jp {
    constructor(e, t, i, n, s, o){
        this.requestId = e, this.text = t, this.isSSML = i, this.cb = n, this.err = s, this.dataStream = o;
    }
}
var $d7238066c5de7f1c$var$Ka = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Vo extends $d7238066c5de7f1c$var$fr {
    /**
   * SpeechSynthesizer constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer.
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer.
   */ constructor(e, t){
        super(e), t !== null && (t === void 0 ? this.audioConfig = typeof window > "u" ? void 0 : $d7238066c5de7f1c$var$bt.fromDefaultSpeakerOutput() : this.audioConfig = t), this.privConnectionFactory = new $d7238066c5de7f1c$var$eh(), this.implCommonSynthesizeSetup();
    }
    /**
   * SpeechSynthesizer constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - an set of initial properties for this synthesizer
   * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the synthesizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer
   */ static FromConfig(e, t, i) {
        const n = e;
        return t.properties.mergeTo(n.properties), new $d7238066c5de7f1c$var$Vo(e, i);
    }
    /**
   * Executes speech synthesis on plain text.
   * The task returns the synthesis result.
   * @member SpeechSynthesizer.prototype.speakTextAsync
   * @function
   * @public
   * @param text - Text to be synthesized.
   * @param cb - Callback that received the SpeechSynthesisResult.
   * @param err - Callback invoked in case of an error.
   * @param stream - AudioOutputStream to receive the synthesized audio.
   */ speakTextAsync(e, t, i, n) {
        this.speakImpl(e, !1, t, i, n);
    }
    /**
   * Executes speech synthesis on SSML.
   * The task returns the synthesis result.
   * @member SpeechSynthesizer.prototype.speakSsmlAsync
   * @function
   * @public
   * @param ssml - SSML to be synthesized.
   * @param cb - Callback that received the SpeechSynthesisResult.
   * @param err - Callback invoked in case of an error.
   * @param stream - AudioOutputStream to receive the synthesized audio.
   */ speakSsmlAsync(e, t, i, n) {
        this.speakImpl(e, !0, t, i, n);
    }
    /**
   * Get list of synthesis voices available.
   * The task returns the synthesis voice result.
   * @member SpeechSynthesizer.prototype.getVoicesAsync
   * @function
   * @async
   * @public
   * @param locale - Locale of voices in BCP-47 format; if left empty, get all available voices.
   * @return {Promise<SynthesisVoicesResult>} - Promise of a SynthesisVoicesResult.
   */ getVoicesAsync(e = "") {
        return $d7238066c5de7f1c$var$Ka(this, void 0, void 0, function*() {
            return this.getVoices(e);
        });
    }
    /**
   * Dispose of associated resources.
   * @member SpeechSynthesizer.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposed), $d7238066c5de7f1c$var$x(this.dispose(!0), e, t);
    }
    /**
   * @Internal
   * Do not use externally, object returned will change without warning or notice.
   */ get internalData() {
        return this.privAdapter;
    }
    //
    // ################################################################################################################
    // IMPLEMENTATION.
    // ################################################################################################################
    //
    // Creates the synthesis adapter
    createSynthesisAdapter(e, t, i) {
        return new $d7238066c5de7f1c$var$Tv(e, t, i, this, this.audioConfig);
    }
    createRestSynthesisAdapter(e, t) {
        return new $d7238066c5de7f1c$var$Pv(t, e);
    }
    implCommonSynthesizeSetup() {
        super.implCommonSynthesizeSetup(), this.privAdapter.audioOutputFormat = $d7238066c5de7f1c$var$O.fromSpeechSynthesisOutputFormat($d7238066c5de7f1c$var$M[this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthOutputFormat, void 0)]);
    }
    speakImpl(e, t, i, n, s) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposed);
            const o = $d7238066c5de7f1c$var$ee();
            let c;
            s instanceof $d7238066c5de7f1c$var$Eo ? c = new $d7238066c5de7f1c$var$bo(s) : s instanceof $d7238066c5de7f1c$var$dr ? c = s : s !== void 0 ? c = new $d7238066c5de7f1c$var$Mp(s) : c = void 0, this.synthesisRequestQueue.enqueue(new $d7238066c5de7f1c$var$jp(o, e, t, (p)=>{
                if (this.privSynthesizing = !1, i) try {
                    i(p);
                } catch (h) {
                    n && n(h);
                }
                i = void 0, this.adapterSpeak().catch(()=>{});
            }, (p)=>{
                n && n(p);
            }, c)), this.adapterSpeak().catch(()=>{});
        } catch (o) {
            if (n) {
                if (o instanceof Error) {
                    const c = o;
                    n(c.name + ": " + c.message);
                } else n(o);
            }
            this.dispose(!0).catch(()=>{});
        }
    }
    getVoices(e) {
        return $d7238066c5de7f1c$var$Ka(this, void 0, void 0, function*() {
            const t = $d7238066c5de7f1c$var$ee(), i = yield this.privRestAdapter.getVoicesList(t);
            if (i.ok && Array.isArray(i.json)) {
                let n = i.json;
                return e && e.length > 0 && (n = n.filter((s)=>!!s.Locale && s.Locale.toLowerCase() === e.toLowerCase())), new $d7238066c5de7f1c$var$js(t, n, void 0);
            } else return new $d7238066c5de7f1c$var$js(t, void 0, `Error: ${i.status}: ${i.statusText}`);
        });
    }
}
class $d7238066c5de7f1c$var$Kt {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n){
        this.privResultId = e, this.privReason = t, this.privErrorDetails = i, this.privProperties = n;
    }
    /**
   * Specifies the result identifier.
   * @member SynthesisResult.prototype.resultId
   * @function
   * @public
   * @returns {string} Specifies the result identifier.
   */ get resultId() {
        return this.privResultId;
    }
    /**
   * Specifies status of the result.
   * @member SynthesisResult.prototype.reason
   * @function
   * @public
   * @returns {ResultReason} Specifies status of the result.
   */ get reason() {
        return this.privReason;
    }
    /**
   * In case of an unsuccessful synthesis, provides details of the occurred error.
   * @member SynthesisResult.prototype.errorDetails
   * @function
   * @public
   * @returns {string} a brief description of an error.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
   * The set of properties exposed in the result.
   * @member SynthesisResult.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The set of properties exposed in the result.
   */ get properties() {
        return this.privProperties;
    }
}
class $d7238066c5de7f1c$var$tr extends $d7238066c5de7f1c$var$Kt {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {ArrayBuffer} audioData - The synthesized audio binary.
   * @param {string} errorDetails - Error details, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   * @param {number} audioDuration - The audio duration.
   */ constructor(e, t, i, n, s, o){
        super(e, t, n, s), this.privAudioData = i, this.privAudioDuration = o;
    }
    /**
   * The synthesized audio data
   * @member SpeechSynthesisResult.prototype.audioData
   * @function
   * @public
   * @returns {ArrayBuffer} The synthesized audio data.
   */ get audioData() {
        return this.privAudioData;
    }
    /**
   * The time duration of synthesized audio, in ticks (100 nanoseconds).
   * @member SpeechSynthesisResult.prototype.audioDuration
   * @function
   * @public
   * @returns {number} The time duration of synthesized audio.
   */ get audioDuration() {
        return this.privAudioDuration;
    }
}
class $d7238066c5de7f1c$var$Wi {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {SpeechSynthesisResult} result - The speech synthesis result.
   */ constructor(e){
        this.privResult = e;
    }
    /**
   * Specifies the synthesis result.
   * @member SpeechSynthesisEventArgs.prototype.result
   * @function
   * @public
   * @returns {SpeechSynthesisResult} the synthesis result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$Jp {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {number} duration - The audio duration.
   * @param {string} text - The text.
   * @param {number} wordLength - The length of the word.
   * @param {number} textOffset - The text offset.
   * @param {SpeechSynthesisBoundaryType} boundaryType - The boundary type
   */ constructor(e, t, i, n, s, o){
        this.privAudioOffset = e, this.privDuration = t, this.privText = i, this.privWordLength = n, this.privTextOffset = s, this.privBoundaryType = o;
    }
    /**
   * Specifies the audio offset.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
   * Specifies the duration, in ticks (100 nanoseconds).
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.duration
   * @function
   * @public
   * @returns {number} Duration in 100 nanosecond increments.
   */ get duration() {
        return this.privDuration;
    }
    /**
   * Specifies the text of the word boundary event.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
   * @function
   * @public
   * @returns {string} the text.
   */ get text() {
        return this.privText;
    }
    /**
   * Specifies the word length
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
   * @function
   * @public
   * @returns {number} the word length
   */ get wordLength() {
        return this.privWordLength;
    }
    /**
   * Specifies the text offset.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
   * @function
   * @public
   * @returns {number} the text offset.
   */ get textOffset() {
        return this.privTextOffset;
    }
    /**
   * Specifies the boundary type.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.boundaryType
   * @function
   * @public
   * @returns {SpeechSynthesisBoundaryType} the boundary type.
   */ get boundaryType() {
        return this.privBoundaryType;
    }
}
class $d7238066c5de7f1c$var$Gp {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {string} text - The bookmark text.
   */ constructor(e, t){
        this.privAudioOffset = e, this.privText = t;
    }
    /**
   * Specifies the audio offset.
   * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
   * Specifies the bookmark.
   * @member SpeechSynthesisBookmarkEventArgs.prototype.text
   * @function
   * @public
   * @returns {string} the bookmark text.
   */ get text() {
        return this.privText;
    }
}
class $d7238066c5de7f1c$var$Qp {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {number} visemeId - The viseme ID.
   * @param {string} animation - The animation, could be in svg or other format.
   */ constructor(e, t, i){
        this.privAudioOffset = e, this.privVisemeId = t, this.privAnimation = i;
    }
    /**
   * Specifies the audio offset.
   * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
   * Specifies the viseme ID.
   * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
   * @function
   * @public
   * @returns {number} the viseme ID.
   */ get visemeId() {
        return this.privVisemeId;
    }
    /**
   * Specifies the animation.
   * @member SpeechSynthesisVisemeEventArgs.prototype.animation
   * @function
   * @public
   * @returns {string} the animation, could be in svg or other format.
   */ get animation() {
        return this.privAnimation;
    }
}
var $d7238066c5de7f1c$var$Ks;
(function(r) {
    r.Word = "WordBoundary", r.Punctuation = "PunctuationBoundary", r.Sentence = "SentenceBoundary";
})($d7238066c5de7f1c$var$Ks || ($d7238066c5de7f1c$var$Ks = {}));
class $d7238066c5de7f1c$var$js extends $d7238066c5de7f1c$var$Kt {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param requestId - result id for request.
   * @param json - json payload from endpoint.
   */ constructor(e, t, i){
        if (Array.isArray(t)) {
            super(e, $d7238066c5de7f1c$var$R.VoicesListRetrieved, void 0, new $d7238066c5de7f1c$var$U()), this.privVoices = [];
            for (const n of t)this.privVoices.push(new $d7238066c5de7f1c$var$Yp(n));
        } else super(e, $d7238066c5de7f1c$var$R.Canceled, i || "Error information unavailable", new $d7238066c5de7f1c$var$U());
    }
    /**
   * The list of voices
   * @member SynthesisVoicesResult.prototype.voices
   * @function
   * @public
   * @returns {VoiceInfo[]} List of synthesized voices.
   */ get voices() {
        return this.privVoices;
    }
}
var $d7238066c5de7f1c$var$Vi;
(function(r) {
    r[r.Unknown = 0] = "Unknown", r[r.Female = 1] = "Female", r[r.Male = 2] = "Male";
})($d7238066c5de7f1c$var$Vi || ($d7238066c5de7f1c$var$Vi = {}));
var $d7238066c5de7f1c$var$tn;
(function(r) {
    r[r.OnlineNeural = 1] = "OnlineNeural", r[r.OnlineStandard = 2] = "OnlineStandard", r[r.OfflineNeural = 3] = "OfflineNeural", r[r.OfflineStandard = 4] = "OfflineStandard";
})($d7238066c5de7f1c$var$tn || ($d7238066c5de7f1c$var$tn = {}));
class $d7238066c5de7f1c$var$Yp {
    constructor(e){
        if (this.privStyleList = [], this.privVoicePath = "", e && (this.privName = e.Name, this.privLocale = e.Locale, this.privShortName = e.ShortName, this.privLocaleName = e.LocaleName, this.privDisplayName = e.DisplayName, this.privLocalName = e.LocalName, this.privVoiceType = e.VoiceType.endsWith("Standard") ? $d7238066c5de7f1c$var$tn.OnlineStandard : $d7238066c5de7f1c$var$tn.OnlineNeural, this.privGender = e.Gender === "Male" ? $d7238066c5de7f1c$var$Vi.Male : e.Gender === "Female" ? $d7238066c5de7f1c$var$Vi.Female : $d7238066c5de7f1c$var$Vi.Unknown, e.StyleList && Array.isArray(e.StyleList))) for (const t of e.StyleList)this.privStyleList.push(t);
    }
    get name() {
        return this.privName;
    }
    get locale() {
        return this.privLocale;
    }
    get shortName() {
        return this.privShortName;
    }
    get displayName() {
        return this.privDisplayName;
    }
    get localName() {
        return this.privLocalName;
    }
    get localeName() {
        return this.privLocaleName;
    }
    get gender() {
        return this.privGender;
    }
    get voiceType() {
        return this.privVoiceType;
    }
    get styleList() {
        return this.privStyleList;
    }
    get voicePath() {
        return this.privVoicePath;
    }
}
var $d7238066c5de7f1c$var$Vn = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
const $d7238066c5de7f1c$var$Tl = 1800, $d7238066c5de7f1c$var$ja = {
    [$d7238066c5de7f1c$var$E.PCM]: "audio/wav",
    [$d7238066c5de7f1c$var$E.MuLaw]: "audio/x-wav",
    [$d7238066c5de7f1c$var$E.MP3]: "audio/mpeg",
    [$d7238066c5de7f1c$var$E.OGG_OPUS]: "audio/ogg",
    [$d7238066c5de7f1c$var$E.WEBM_OPUS]: "audio/webm; codecs=opus",
    [$d7238066c5de7f1c$var$E.ALaw]: "audio/x-wav",
    [$d7238066c5de7f1c$var$E.FLAC]: "audio/flac"
};
class $d7238066c5de7f1c$var$Js {
    constructor(e){
        this.privPlaybackStarted = !1, this.privAppendingToBuffer = !1, this.privMediaSourceOpened = !1, this.privBytesReceived = 0, this.privId = e || $d7238066c5de7f1c$var$ee(), this.privIsPaused = !1, this.privIsClosed = !1;
    }
    id() {
        return this.privId;
    }
    write(e, t, i) {
        this.privAudioBuffer !== void 0 ? (this.privAudioBuffer.push(e), this.updateSourceBuffer().then(()=>{
            t && t();
        }, (n)=>{
            i && i(n);
        })) : this.privAudioOutputStream !== void 0 && (this.privAudioOutputStream.write(e), this.privBytesReceived += e.byteLength);
    }
    close(e, t) {
        if (this.privIsClosed = !0, this.privSourceBuffer !== void 0) this.handleSourceBufferUpdateEnd().then(()=>{
            e && e();
        }, (i)=>{
            t && t(i);
        });
        else if (this.privAudioOutputStream !== void 0 && typeof window < "u") {
            if ((this.privFormat.formatTag === $d7238066c5de7f1c$var$E.PCM || this.privFormat.formatTag === $d7238066c5de7f1c$var$E.MuLaw || this.privFormat.formatTag === $d7238066c5de7f1c$var$E.ALaw) && this.privFormat.hasHeader === !1) console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header."), this.onAudioEnd && this.onAudioEnd(this);
            else {
                let i = new ArrayBuffer(this.privBytesReceived);
                this.privAudioOutputStream.read(i).then(()=>{
                    i = this.privFormat.addHeader(i);
                    const n = new Blob([
                        i
                    ], {
                        type: $d7238066c5de7f1c$var$ja[this.privFormat.formatTag]
                    });
                    this.privAudio.src = window.URL.createObjectURL(n), this.notifyPlayback().then(()=>{
                        e && e();
                    }, (s)=>{
                        t && t(s);
                    });
                }, (n)=>{
                    t && t(n);
                });
            }
        } else this.onAudioEnd && this.onAudioEnd(this);
    }
    set format(e) {
        if (typeof AudioContext < "u" || typeof window < "u" && typeof window.webkitAudioContext < "u") {
            this.privFormat = e;
            const t = $d7238066c5de7f1c$var$ja[this.privFormat.formatTag];
            t === void 0 ? console.warn(`Unknown mimeType for format ${$d7238066c5de7f1c$var$E[this.privFormat.formatTag]}; playback is not supported.`) : typeof MediaSource < "u" && MediaSource.isTypeSupported(t) ? (this.privAudio = new Audio(), this.privAudioBuffer = [], this.privMediaSource = new MediaSource(), this.privAudio.src = URL.createObjectURL(this.privMediaSource), this.privAudio.load(), this.privMediaSource.onsourceopen = ()=>{
                this.privMediaSourceOpened = !0, this.privMediaSource.duration = $d7238066c5de7f1c$var$Tl, this.privSourceBuffer = this.privMediaSource.addSourceBuffer(t), this.privSourceBuffer.onupdate = ()=>{
                    this.updateSourceBuffer().catch((i)=>{
                        $d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$Ct(i));
                    });
                }, this.privSourceBuffer.onupdateend = ()=>{
                    this.handleSourceBufferUpdateEnd().catch((i)=>{
                        $d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$Ct(i));
                    });
                }, this.privSourceBuffer.onupdatestart = ()=>{
                    this.privAppendingToBuffer = !1;
                };
            }, this.updateSourceBuffer().catch((i)=>{
                $d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$Ct(i));
            })) : (console.warn(`Format ${$d7238066c5de7f1c$var$E[this.privFormat.formatTag]} could not be played by MSE, streaming playback is not enabled.`), this.privAudioOutputStream = new $d7238066c5de7f1c$var$To(), this.privAudioOutputStream.format = this.privFormat, this.privAudio = new Audio());
        }
    }
    get volume() {
        var e, t;
        return (t = (e = this.privAudio) === null || e === void 0 ? void 0 : e.volume) !== null && t !== void 0 ? t : -1;
    }
    set volume(e) {
        this.privAudio && (this.privAudio.volume = e);
    }
    mute() {
        this.privAudio && (this.privAudio.muted = !0);
    }
    unmute() {
        this.privAudio && (this.privAudio.muted = !1);
    }
    get isClosed() {
        return this.privIsClosed;
    }
    get currentTime() {
        return this.privAudio !== void 0 ? this.privAudio.currentTime : -1;
    }
    pause() {
        !this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.pause(), this.privIsPaused = !0);
    }
    resume(e, t) {
        this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.play().then(()=>{
            e && e();
        }, (i)=>{
            t && t(i);
        }), this.privIsPaused = !1);
    }
    get internalAudio() {
        return this.privAudio;
    }
    updateSourceBuffer() {
        return $d7238066c5de7f1c$var$Vn(this, void 0, void 0, function*() {
            if (this.privAudioBuffer !== void 0 && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
                this.privAppendingToBuffer = !0;
                const e = this.privAudioBuffer.shift();
                try {
                    this.privSourceBuffer.appendBuffer(e);
                } catch  {
                    this.privAudioBuffer.unshift(e), console.log("buffer filled, pausing addition of binaries until space is made");
                    return;
                }
                yield this.notifyPlayback();
            } else this.canEndStream() && (yield this.handleSourceBufferUpdateEnd());
        });
    }
    handleSourceBufferUpdateEnd() {
        return $d7238066c5de7f1c$var$Vn(this, void 0, void 0, function*() {
            this.canEndStream() && this.sourceBufferAvailable() && (this.privMediaSource.endOfStream(), yield this.notifyPlayback());
        });
    }
    notifyPlayback() {
        return $d7238066c5de7f1c$var$Vn(this, void 0, void 0, function*() {
            !this.privPlaybackStarted && this.privAudio !== void 0 && (this.privPlaybackStarted = !0, this.onAudioStart && this.onAudioStart(this), this.privAudio.onended = ()=>{
                this.onAudioEnd && this.onAudioEnd(this);
            }, this.privIsPaused || (yield this.privAudio.play()));
        });
    }
    canEndStream() {
        return this.isClosed && this.privSourceBuffer !== void 0 && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    }
    sourceBufferAvailable() {
        return this.privSourceBuffer !== void 0 && !this.privSourceBuffer.updating;
    }
}
class $d7238066c5de7f1c$var$Ko extends $d7238066c5de7f1c$var$gn {
}
class $d7238066c5de7f1c$var$Zp extends $d7238066c5de7f1c$var$gn {
}
var $d7238066c5de7f1c$var$ir;
(function(r) {
    r[r.FivePoint = 1] = "FivePoint", r[r.HundredMark = 2] = "HundredMark";
})($d7238066c5de7f1c$var$ir || ($d7238066c5de7f1c$var$ir = {}));
var $d7238066c5de7f1c$var$rr;
(function(r) {
    r[r.Phoneme = 1] = "Phoneme", r[r.Word = 2] = "Word", r[r.FullText = 3] = "FullText";
})($d7238066c5de7f1c$var$rr || ($d7238066c5de7f1c$var$rr = {}));
class $d7238066c5de7f1c$var$jo {
    /**
   * PronunciationAssessmentConfig constructor.
   * @constructor
   * @param {string} referenceText
   * @param gradingSystem
   * @param granularity
   * @param enableMiscue
   */ constructor(e, t = $d7238066c5de7f1c$var$ir.FivePoint, i = $d7238066c5de7f1c$var$rr.Phoneme, n = !1){
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "referenceText"), this.privProperties = new $d7238066c5de7f1c$var$U(), this.privProperties.setProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_ReferenceText, e), this.privProperties.setProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_GradingSystem, $d7238066c5de7f1c$var$ir[t]), this.privProperties.setProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_Granularity, $d7238066c5de7f1c$var$rr[i]), this.privProperties.setProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_EnableMiscue, String(n));
    }
    /**
   * @member PronunciationAssessmentConfig.fromJSON
   * @function
   * @public
   * @param {string} json The json string containing the pronunciation assessment parameters.
   * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
   * @summary Creates an instance of the PronunciationAssessmentConfig from json.
   * This method is designed to support the pronunciation assessment parameters still in preview.
   * Under normal circumstances, use the constructor instead.
   */ static fromJSON(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "json");
        const t = new $d7238066c5de7f1c$var$jo("");
        return t.privProperties = new $d7238066c5de7f1c$var$U(), t.properties.setProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_Json, e), t;
    }
    toJSON() {
        return this.updateJson(), this.privProperties.getProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_Params);
    }
    applyTo(e) {
        this.updateJson();
        const t = e.internalData;
        t.speechContext.setPronunciationAssessmentParams(this.properties.getProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_Params), this.privContentAssessmentTopic, t.isSpeakerDiarizationEnabled);
    }
    /**
   * Gets the reference text.
   * @member PronunciationAssessmentConfig.prototype.referenceText
   * @function
   * @public
   * @returns {string} Reference text.
   */ get referenceText() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_ReferenceText);
    }
    /**
   * Gets/Sets the reference text.
   * @member PronunciationAssessmentConfig.prototype.referenceText
   * @function
   * @public
   * @param {string} referenceText - Reference text.
   */ set referenceText(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "referenceText"), this.properties.setProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_ReferenceText, e);
    }
    /**
   * Sets the phoneme alphabet.
   * The valid values are "SAPI" (default) and "IPA".
   * Added in version 1.20.0
   * @member PronunciationAssessmentConfig.prototype.phonemeAlphabet
   * @function
   * @public
   * @param {string} phonemeAlphabet - Phoneme alphabet.
   */ set phonemeAlphabet(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "phonemeAlphabet"), this.privPhonemeAlphabet = e;
    }
    /**
   * Sets the boolean enableMiscue property.
   * Added in version 1.26.0
   * @member PronunciationAssessmentConfig.prototype.enableMiscue
   * @function
   * @public
   * @param {boolean} enableMiscue - enable miscue.
   */ set enableMiscue(e) {
        const t = e ? "true" : "false";
        this.properties.setProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_EnableMiscue, t);
    }
    /**
   * Gets the boolean enableMiscue property.
   * Added in version 1.26.0
   * @member PronunciationAssessmentConfig.prototype.enableMiscue
   * @function
   * @public
   * @return {boolean} enableMiscue - enable miscue.
   */ get enableMiscue() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_EnableMiscue, "false").toLowerCase() === "true";
    }
    /**
   * Sets the nbest phoneme count
   * Added in version 1.20.0
   * @member PronunciationAssessmentConfig.prototype.nbestPhonemeCount
   * @function
   * @public
   * @param {number} nbestPhonemeCount - NBest phoneme count.
   */ set nbestPhonemeCount(e) {
        this.privNBestPhonemeCount = e;
    }
    /**
   * Enables the prosody assessment.
   * Added in version 1.34.0
   * @member PronunciationAssessmentConfig.prototype.enableProsodyAssessment
   * @function
   * @public
   * @param {boolean} enableProsodyAssessment - enable prosody assessment.
   */ set enableProsodyAssessment(e) {
        this.privEnableProsodyAssessment = e;
    }
    /**
   * Enables content assessment and sets the topic.
   * Added in version 1.34.0
   * @member PronunciationAssessmentConfig.prototype.enableContentAssessmentWithTopic
   * @function
   * @public
   * @param {string} topic - Topic for content assessment.
   */ enableContentAssessmentWithTopic(e) {
        this.privContentAssessmentTopic = e;
    }
    /**
   * @member PronunciationAssessmentConfig.prototype.properties
   * @function
   * @public
   * @return {PropertyCollection} Properties of the config.
   * @summary Gets a pronunciation assessment config properties
   */ get properties() {
        return this.privProperties;
    }
    updateJson() {
        const e = this.privProperties.getProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_Json, "{}"), t = JSON.parse(e), i = this.privProperties.getProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_ReferenceText);
        i && (t.referenceText = i);
        const n = this.privProperties.getProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_GradingSystem);
        n && (t.gradingSystem = n);
        const s = this.privProperties.getProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_Granularity);
        s && (t.granularity = s), this.privPhonemeAlphabet && (t.phonemeAlphabet = this.privPhonemeAlphabet), this.privNBestPhonemeCount && (t.nbestPhonemeCount = this.privNBestPhonemeCount), t.enableProsodyAssessment = this.privEnableProsodyAssessment, t.dimension = "Comprehensive", this.privProperties.getProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_EnableMiscue) && (t.enableMiscue = this.enableMiscue), this.privProperties.setProperty($d7238066c5de7f1c$var$u.PronunciationAssessment_Params, JSON.stringify(t));
    }
}
class $d7238066c5de7f1c$var$Pl {
    /**
   * @Internal
   * Do not use externally.
   */ constructor(e){
        this.privPronJson = e;
    }
    /**
   * Correctness in using grammar and variety of sentence patterns.
   * Grammatical errors are jointly evaluated by lexical accuracy,
   * grammatical accuracy and diversity of sentence structures.
   * @member ContentAssessmentResult.prototype.grammarScore
   * @function
   * @public
   * @returns {number} Grammar score.
   */ get grammarScore() {
        return this.privPronJson.ContentAssessment.GrammarScore;
    }
    /**
   * Proficiency in lexical usage. It evaluates the speaker's effective usage
   * of words and their appropriateness within the given context to express
   * ideas accurately, as well as level of lexical complexity.
   * @member ContentAssessmentResult.prototype.vocabularyScore
   * @function
   * @public
   * @returns {number} Vocabulary score.
   */ get vocabularyScore() {
        return this.privPronJson.ContentAssessment.VocabularyScore;
    }
    /**
   * Level of understanding and engagement with the topic, which provides
   * insights into the speaker’s ability to express their thoughts and ideas
   * effectively and the ability to engage with the topic.
   * @member ContentAssessmentResult.prototype.topicScore
   * @function
   * @public
   * @returns {number} Topic score.
   */ get topicScore() {
        return this.privPronJson.ContentAssessment.TopicScore;
    }
}
class $d7238066c5de7f1c$var$Jo {
    constructor(e){
        const t = JSON.parse(e);
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(t.NBest[0], "NBest"), this.privPronJson = t.NBest[0];
    }
    /**
   * @member PronunciationAssessmentResult.fromResult
   * @function
   * @public
   * @param {RecognitionResult} result The recognition result.
   * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
   * @summary Creates an instance of the PronunciationAssessmentResult from recognition result.
   */ static fromResult(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "result");
        const t = e.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_JsonResult);
        return $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(t, "json"), new $d7238066c5de7f1c$var$Jo(t);
    }
    /**
   * Gets the detail result of pronunciation assessment.
   * @member PronunciationAssessmentConfig.prototype.detailResult
   * @function
   * @public
   * @returns {DetailResult} detail result.
   */ get detailResult() {
        return this.privPronJson;
    }
    /**
   * The score indicating the pronunciation accuracy of the given speech, which indicates
   * how closely the phonemes match a native speaker's pronunciation.
   * @member PronunciationAssessmentResult.prototype.accuracyScore
   * @function
   * @public
   * @returns {number} Accuracy score.
   */ get accuracyScore() {
        var e;
        return (e = this.detailResult.PronunciationAssessment) === null || e === void 0 ? void 0 : e.AccuracyScore;
    }
    /**
   * The overall score indicating the pronunciation quality of the given speech.
   * This is calculated from AccuracyScore, FluencyScore and CompletenessScore with weight.
   * @member PronunciationAssessmentResult.prototype.pronunciationScore
   * @function
   * @public
   * @returns {number} Pronunciation score.
   */ get pronunciationScore() {
        var e;
        return (e = this.detailResult.PronunciationAssessment) === null || e === void 0 ? void 0 : e.PronScore;
    }
    /**
   * The score indicating the completeness of the given speech by calculating the ratio of pronounced words towards entire input.
   * @member PronunciationAssessmentResult.prototype.completenessScore
   * @function
   * @public
   * @returns {number} Completeness score.
   */ get completenessScore() {
        var e;
        return (e = this.detailResult.PronunciationAssessment) === null || e === void 0 ? void 0 : e.CompletenessScore;
    }
    /**
   * The score indicating the fluency of the given speech.
   * @member PronunciationAssessmentResult.prototype.fluencyScore
   * @function
   * @public
   * @returns {number} Fluency score.
   */ get fluencyScore() {
        var e;
        return (e = this.detailResult.PronunciationAssessment) === null || e === void 0 ? void 0 : e.FluencyScore;
    }
    /**
   * The prosody score, which indicates how nature of the given speech, including stress, intonation, speaking speed and rhythm.
   * @member PronunciationAssessmentResult.prototype.prosodyScore
   * @function
   * @public
   * @returns {number} Prosody score.
   */ get prosodyScore() {
        var e;
        return (e = this.detailResult.PronunciationAssessment) === null || e === void 0 ? void 0 : e.ProsodyScore;
    }
    /**
   * The concent assessment result.
   * Only available when content assessment is enabled.
   * @member PronunciationAssessmentResult.prototype.contentAssessmentResult
   * @function
   * @public
   * @returns {ContentAssessmentResult} Content assessment result.
   */ get contentAssessmentResult() {
        if (this.detailResult.ContentAssessment !== void 0) return new $d7238066c5de7f1c$var$Pl(this.detailResult);
    }
}
class $d7238066c5de7f1c$var$bl {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} character - The avatar character.
   * @param {string} style - The avatar style.
   * @param {AvatarVideoFormat} videoFormat - The talking avatar output video format.
   */ constructor(e, t, i){
        this.privCustomized = !1, $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "character"), this.character = e, this.style = t, i === void 0 && (i = new $d7238066c5de7f1c$var$th()), this.videoFormat = i;
    }
    /**
   * Indicates if the talking avatar is customized.
   */ get customized() {
        return this.privCustomized;
    }
    /**
   * Sets if the talking avatar is customized.
   */ set customized(e) {
        this.privCustomized = e;
    }
    /**
   * Sets the background color.
   */ get backgroundColor() {
        return this.privBackgroundColor;
    }
    /**
   * Gets the background color.
   */ set backgroundColor(e) {
        this.privBackgroundColor = e;
    }
}
var $d7238066c5de7f1c$var$Ja;
(function(r) {
    r.SwitchedToSpeaking = "SwitchedToSpeaking", r.SwitchedToIdle = "SwitchedToIdle", r.SessionClosed = "SessionClosed";
})($d7238066c5de7f1c$var$Ja || ($d7238066c5de7f1c$var$Ja = {}));
class $d7238066c5de7f1c$var$Xp {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {string} description - The description of the event.
   */ constructor(e, t){
        this.privOffset = e, this.privDescription = t;
    }
    /**
   * The type of the event.
   * @public
   * @returns {AvatarEventTypes} The type of the event.
   */ get type() {
        return this.privType;
    }
    /**
   * The time offset associated with this event.
   * @public
   * @returns {number} The time offset associated with this event.
   */ get offset() {
        return this.privOffset;
    }
    /**
   * The description of the event.
   * @public
   * @returns {string} The description of the event.
   */ get description() {
        return this.privDescription;
    }
}
class $d7238066c5de7f1c$var$eh {
    constructor(){
        this.synthesisUri = "/cognitiveservices/websocket/v1";
    }
    create(e, t, i) {
        let n = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint, void 0);
        const s = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, void 0), o = $d7238066c5de7f1c$var$fe.getHostSuffix(s), c = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId, void 0), p = c === void 0 ? "tts" : "voice", h = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, "wss://" + s + "." + p + ".speech" + o), a = {}, d = {};
        t.token !== void 0 && t.token !== "" && (d[t.headerName] = t.token), d[$d7238066c5de7f1c$var$W.ConnectionId] = i, c !== void 0 && c !== "" && (!n || n.search($d7238066c5de7f1c$var$w.CustomVoiceDeploymentId) === -1) && (a[$d7238066c5de7f1c$var$w.CustomVoiceDeploymentId] = c), e.avatarEnabled && (!n || n.search($d7238066c5de7f1c$var$w.EnableAvatar) === -1) && (a[$d7238066c5de7f1c$var$w.EnableAvatar] = "true"), n || (n = h + this.synthesisUri), e.parameters.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Url, n);
        const v = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$ut(n, a, d, new $d7238066c5de7f1c$var$At(), $d7238066c5de7f1c$var$Ve.fromParameters(e.parameters), v, i);
    }
}
var $d7238066c5de7f1c$var$qt = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$El extends $d7238066c5de7f1c$var$fr {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {SpeechConfig} speechConfig - The speech config.
   * @param {AvatarConfig} avatarConfig - The talking avatar config.
   */ constructor(e, t){
        super(e), $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(t, "avatarConfig"), this.privConnectionFactory = new $d7238066c5de7f1c$var$eh(), this.privAvatarConfig = t, this.implCommonSynthesizeSetup();
    }
    implCommonSynthesizeSetup() {
        super.implCommonSynthesizeSetup(), this.privAdapter.audioOutputFormat = $d7238066c5de7f1c$var$O.fromSpeechSynthesisOutputFormat($d7238066c5de7f1c$var$M.Riff24Khz16BitMonoPcm);
    }
    /**
   * Starts the talking avatar session and establishes the WebRTC connection.
   * @member AvatarSynthesizer.prototype.startAvatarAsync
   * @function
   * @public
   * @param {AvatarWebRTCConnectionInfo} peerConnection - The peer connection.
   * @returns {Promise<SynthesisResult>} The promise of the connection result.
   */ startAvatarAsync(e) {
        return $d7238066c5de7f1c$var$qt(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "peerConnection"), this.privIceServers = e.getConfiguration().iceServers, $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privIceServers, "Ice servers must be set.");
            const t = new $d7238066c5de7f1c$var$F();
            e.onicegatheringstatechange = ()=>{
                $d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$pt("peer connection: ice gathering state: " + e.iceGatheringState, $d7238066c5de7f1c$var$ce.Debug)), e.iceGatheringState === "complete" && ($d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$pt("peer connection: ice gathering complete.", $d7238066c5de7f1c$var$ce.Info)), t.resolve());
            };
            const i = yield e.createOffer();
            yield e.setLocalDescription(i), yield t.promise, $d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$pt("peer connection: got local SDP.", $d7238066c5de7f1c$var$ce.Info)), this.privProperties.setProperty($d7238066c5de7f1c$var$u.TalkingAvatarService_WebRTC_SDP, JSON.stringify(e.localDescription));
            const n = yield this.speak("", !1), s = atob(n.properties.getProperty($d7238066c5de7f1c$var$u.TalkingAvatarService_WebRTC_SDP)), o = new RTCSessionDescription(JSON.parse(s));
            return yield e.setRemoteDescription(o), new $d7238066c5de7f1c$var$Kt(n.resultId, n.reason, void 0, n.properties);
        });
    }
    /**
   * Speaks plain text asynchronously. The rendered audio and video will be sent via the WebRTC connection.
   * @member AvatarSynthesizer.prototype.speakTextAsync
   * @function
   * @public
   * @param {string} text - The plain text to speak.
   * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
   */ speakTextAsync(e) {
        return $d7238066c5de7f1c$var$qt(this, void 0, void 0, function*() {
            const t = yield this.speak(e, !1);
            return new $d7238066c5de7f1c$var$Kt(t.resultId, t.reason, t.errorDetails, t.properties);
        });
    }
    /**
   * Speaks SSML asynchronously. The rendered audio and video will be sent via the WebRTC connection.
   * @member AvatarSynthesizer.prototype.speakSsmlAsync
   * @function
   * @public
   * @param {string} ssml - The SSML text to speak.
   * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
   */ speakSsmlAsync(e) {
        return $d7238066c5de7f1c$var$qt(this, void 0, void 0, function*() {
            const t = yield this.speak(e, !0);
            return new $d7238066c5de7f1c$var$Kt(t.resultId, t.reason, t.errorDetails, t.properties);
        });
    }
    /**
   * Speaks text asynchronously. The avatar will switch to idle state.
   * @member AvatarSynthesizer.prototype.stopSpeakingAsync
   * @function
   * @public
   * @returns {Promise<void>} The promise of the void result.
   */ stopSpeakingAsync() {
        return $d7238066c5de7f1c$var$qt(this, void 0, void 0, function*() {
            return this.privAdapter.stopSpeaking();
        });
    }
    /**
   * Stops the talking avatar session and closes the WebRTC connection.
   * For now, this is the same as close().
   * You need to create a new AvatarSynthesizer instance to start a new session.
   * @member AvatarSynthesizer.prototype.stopAvatarAsync
   * @function
   * @public
   * @returns {Promise<void>} The promise of the void result.
   */ stopAvatarAsync() {
        return $d7238066c5de7f1c$var$qt(this, void 0, void 0, function*() {
            return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposed), this.dispose(!0);
        });
    }
    /**
   * Dispose of associated resources.
   * @member AvatarSynthesizer.prototype.close
   * @function
   * @public
   */ close() {
        return $d7238066c5de7f1c$var$qt(this, void 0, void 0, function*() {
            if (!this.privDisposed) return this.dispose(!0);
        });
    }
    /**
   * Gets the ICE servers. Internal use only.
   */ get iceServers() {
        return this.privIceServers;
    }
    // Creates the synthesis adapter
    createSynthesisAdapter(e, t, i) {
        return new $d7238066c5de7f1c$var$Iv(e, t, i, this, this.privAvatarConfig);
    }
    createRestSynthesisAdapter(e, t) {}
    createSynthesizerConfig(e) {
        const t = super.createSynthesizerConfig(e);
        return t.avatarEnabled = !0, t;
    }
    speak(e, t) {
        return $d7238066c5de7f1c$var$qt(this, void 0, void 0, function*() {
            const i = $d7238066c5de7f1c$var$ee(), n = new $d7238066c5de7f1c$var$F();
            return this.synthesisRequestQueue.enqueue(new $d7238066c5de7f1c$var$jp(i, e, t, (s)=>{
                n.resolve(s), this.privSynthesizing = !1, this.adapterSpeak();
            }, (s)=>{
                n.reject(s), this.privSynthesizing = !1;
            })), this.adapterSpeak(), n.promise;
        });
    }
}
class $d7238066c5de7f1c$var$Al {
    constructor(e, t){
        this.x = e, this.y = t;
    }
}
class $d7238066c5de7f1c$var$th {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} codec - The video codec.
   * @param {number} bitrate - The video bitrate.
   * @param {number} width - The video width.
   * @param {number} height - The video height.
   */ constructor(e = "H264", t = 2e6, i = 1920, n = 1080){
        this.codec = e, this.bitrate = t, this.width = i, this.height = n;
    }
    /**
   * Sets the video crop range.
   */ setCropRange(e, t) {
        this.cropRange = {
            bottomRight: t,
            topLeft: e
        };
    }
}
class $d7238066c5de7f1c$var$kl extends $d7238066c5de7f1c$var$Kt {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {RTCSessionDescriptionInit} SDPAnswer - The SDP answer of WebRTC connection.
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s){
        super(t, i, n, s), this.privSDPAnswer = e;
    }
    /**
   * Specifies SDP (Session Description Protocol) answer of WebRTC connection.
   * @member AvatarWebRTCConnectionResult.prototype.SDPAnswer
   * @function
   * @public
   * @returns {RTCSessionDescriptionInit} Specifies the SDP answer of WebRTC connection.
   */ get SDPAnswer() {
        return this.privSDPAnswer;
    }
}
class $d7238066c5de7f1c$var$ih {
    static SetLoggingLevel(e) {
        this.privListener = new $d7238066c5de7f1c$var$Yd(e), $d7238066c5de7f1c$var$oe.instance.attachConsoleListener(this.privListener);
    }
    static StartConsoleOutput() {
        this.privListener && (this.privListener.enableConsoleOutput = !0);
    }
    static StopConsoleOutput() {
        this.privListener && (this.privListener.enableConsoleOutput = !1);
    }
    static SetLogOutputPath(e) {
        if (typeof window > "u") this.privListener && (this.privListener.logPath = e);
        else throw new Error("File system logging not available in browser.");
    }
}
$d7238066c5de7f1c$var$ih.privListener = void 0;
class $d7238066c5de7f1c$var$Ve {
    constructor(e, t, i, n){
        this.privProxyHostName = e, this.privProxyPort = t, this.privProxyUserName = i, this.privProxyPassword = n;
    }
    static fromParameters(e) {
        return new $d7238066c5de7f1c$var$Ve(e.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyHostName), parseInt(e.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyPort), 10), e.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyUserName), e.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_ProxyPassword));
    }
    static fromRecognizerConfig(e) {
        return this.fromParameters(e.parameters);
    }
    get HostName() {
        return this.privProxyHostName;
    }
    get Port() {
        return this.privProxyPort;
    }
    get UserName() {
        return this.privProxyUserName;
    }
    get Password() {
        return this.privProxyPassword;
    }
}
const $d7238066c5de7f1c$var$Dl = /* @__PURE__ */ new Set([
    "json",
    "buffer",
    "string"
]);
var $d7238066c5de7f1c$var$Ol = (r)=>(...e)=>{
        const t = /* @__PURE__ */ new Set();
        let i, n, s, o = "";
        return e.forEach((c)=>{
            if (typeof c == "string") {
                if (c.toUpperCase() === c) {
                    if (i) {
                        const p = `Can't set method to ${c}, already set to ${i}.`;
                        throw new Error(p);
                    } else i = c;
                } else if (c.startsWith("http:") || c.startsWith("https:")) o = c;
                else if ($d7238066c5de7f1c$var$Dl.has(c)) n = c;
                else throw new Error(`Unknown encoding, ${c}`);
            } else if (typeof c == "number") t.add(c);
            else if (typeof c == "object") {
                if (Array.isArray(c) || c instanceof Set) c.forEach((p)=>t.add(p));
                else {
                    if (s) throw new Error("Cannot set headers twice.");
                    s = c;
                }
            } else throw new Error(`Unknown type: ${typeof c}`);
        }), i || (i = "GET"), t.size === 0 && t.add(200), r(t, i, n, s, o);
    };
const $d7238066c5de7f1c$var$zl = $d7238066c5de7f1c$var$Ol;
class $d7238066c5de7f1c$var$Go extends Error {
    constructor(e, ...t){
        super(...t), Error.captureStackTrace && Error.captureStackTrace(this, $d7238066c5de7f1c$var$Go), this.name = "StatusError", this.message = e.statusMessage, this.statusCode = e.status, this.res = e, this.json = e.json.bind(e), this.text = e.text.bind(e), this.arrayBuffer = e.arrayBuffer.bind(e);
        let i;
        Object.defineProperty(this, "responseBody", {
            get: ()=>(i || (i = this.arrayBuffer()), i)
        }), this.headers = {};
        for (const [s, o] of e.headers.entries())this.headers[s.toLowerCase()] = o;
    }
}
const $d7238066c5de7f1c$var$Nl = (r, e, t, i, n)=>async (s, o, c = {})=>{
        s = n + (s || "");
        let p = new URL(s);
        if (i || (i = {}), p.username && (i.Authorization = "Basic " + btoa(p.username + ":" + p.password), p = new URL(p.protocol + "//" + p.host + p.pathname + p.search)), p.protocol !== "https:" && p.protocol !== "http:") throw new Error(`Unknown protocol, ${p.protocol}`);
        if (o && !(o instanceof ArrayBuffer || ArrayBuffer.isView(o) || typeof o == "string")) {
            if (typeof o == "object") o = JSON.stringify(o), i["Content-Type"] = "application/json";
            else throw new Error("Unknown body type.");
        }
        c = new Headers({
            ...i || {},
            ...c
        });
        const h = await fetch(p, {
            method: e,
            headers: c,
            body: o
        });
        if (h.statusCode = h.status, !r.has(h.status)) throw new $d7238066c5de7f1c$var$Go(h);
        return t === "json" ? h.json() : t === "buffer" ? h.arrayBuffer() : t === "string" ? h.text() : h;
    };
var $d7238066c5de7f1c$var$Ml = $d7238066c5de7f1c$var$zl($d7238066c5de7f1c$var$Nl);
const $d7238066c5de7f1c$var$xl = /* @__PURE__ */ $d7238066c5de7f1c$var$xd($d7238066c5de7f1c$var$Ml);
var $d7238066c5de7f1c$var$_l = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
}, $d7238066c5de7f1c$var$Lt;
(function(r) {
    r.Get = "GET", r.Post = "POST", r.Delete = "DELETE", r.File = "file";
})($d7238066c5de7f1c$var$Lt || ($d7238066c5de7f1c$var$Lt = {}));
class $d7238066c5de7f1c$var$Gs {
    constructor(e){
        if (!e) throw new $d7238066c5de7f1c$var$le("configParams");
        this.privHeaders = e.headers, this.privIgnoreCache = e.ignoreCache;
    }
    static extractHeaderValue(e, t) {
        let i = "";
        try {
            const n = t.trim().split(/[\r\n]+/), s = {};
            n.forEach((o)=>{
                const c = o.split(": "), p = c.shift().toLowerCase(), h = c.join(": ");
                s[p] = h;
            }), i = s[e.toLowerCase()];
        } catch  {}
        return i;
    }
    set options(e) {
        this.privHeaders = e.headers, this.privIgnoreCache = e.ignoreCache;
    }
    setHeaders(e, t) {
        this.privHeaders[e] = t;
    }
    request(e, t, i = {}, n = null) {
        const s = new $d7238066c5de7f1c$var$F(), o = e === $d7238066c5de7f1c$var$Lt.File ? "POST" : e, c = (h, a = {})=>{
            const d = h;
            return {
                data: JSON.stringify(a),
                headers: JSON.stringify(h.headers),
                json: a,
                ok: h.statusCode >= 200 && h.statusCode < 300,
                status: h.statusCode,
                statusText: a.error ? a.error.message : d.statusText ? d.statusText : d.statusMessage
            };
        }, p = (h)=>{
            const a = $d7238066c5de7f1c$var$xl(t, o, this.privHeaders, 200, 201, 202, 204, 400, 401, 402, 403, 404), d = this.queryParams(i) === "" ? "" : `?${this.queryParams(i)}`;
            a(d, h).then((v)=>$d7238066c5de7f1c$var$_l(this, void 0, void 0, function*() {
                    if (e === $d7238066c5de7f1c$var$Lt.Delete || v.statusCode === 204) s.resolve(c(v));
                    else try {
                        const g = yield v.json();
                        s.resolve(c(v, g));
                    } catch  {
                        s.resolve(c(v));
                    }
                })).catch((v)=>{
                s.reject(v);
            });
        };
        return this.privIgnoreCache && (this.privHeaders["Cache-Control"] = "no-cache"), e === $d7238066c5de7f1c$var$Lt.Post && n && (this.privHeaders["content-type"] = "application/json", this.privHeaders["Content-Type"] = "application/json"), p(n), s.promise;
    }
    queryParams(e = {}) {
        return Object.keys(e).map((t)=>encodeURIComponent(t) + "=" + encodeURIComponent(e[t])).join("&");
    }
}
class $d7238066c5de7f1c$var$ht {
    static get requestOptions() {
        return $d7238066c5de7f1c$var$ht.privDefaultRequestOptions;
    }
    static get configParams() {
        return $d7238066c5de7f1c$var$ht.privDefaultParams;
    }
    static get restErrors() {
        return $d7238066c5de7f1c$var$ht.privRestErrors;
    }
}
$d7238066c5de7f1c$var$ht.privDefaultRequestOptions = {
    headers: {
        Accept: "application/json"
    },
    ignoreCache: !1,
    timeout: 1e4
};
$d7238066c5de7f1c$var$ht.privRestErrors = {
    authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.",
    authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.",
    invalidArgs: "Required input not found: {arg}.",
    invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.",
    invalidParticipantRequest: "The requested participant was not found.",
    permissionDeniedConnect: "Required credentials not found.",
    permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.",
    permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.",
    permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.",
    permissionDeniedStart: "Invalid operation: there is already an active conversation."
};
$d7238066c5de7f1c$var$ht.privDefaultParams = {
    apiVersion: "api-version",
    authorization: "Authorization",
    clientAppId: "X-ClientAppId",
    contentTypeKey: "Content-Type",
    correlationId: "X-CorrelationId",
    languageCode: "language",
    nickname: "nickname",
    profanity: "profanity",
    requestId: "X-RequestId",
    roomId: "roomid",
    sessionToken: "token",
    subscriptionKey: "Ocp-Apim-Subscription-Key",
    subscriptionRegion: "Ocp-Apim-Subscription-Region",
    token: "X-CapitoToken"
};
class $d7238066c5de7f1c$var$Ll extends $d7238066c5de7f1c$var$fe {
    create(e, t, i) {
        let n = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint);
        if (!n) {
            const p = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_IntentRegion), h = $d7238066c5de7f1c$var$fe.getHostSuffix(p);
            n = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, "wss://" + p + ".sr.speech" + h) + "/speech/recognition/interactive/cognitiveservices/v1";
        }
        const s = {
            format: "simple",
            language: e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage)
        };
        this.setCommonUrlParams(e, s, n);
        const o = {};
        t.token !== void 0 && t.token !== "" && (o[t.headerName] = t.token), o[$d7238066c5de7f1c$var$W.ConnectionId] = i, e.parameters.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Url, n);
        const c = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$ut(n, s, o, new $d7238066c5de7f1c$var$At(), $d7238066c5de7f1c$var$Ve.fromRecognizerConfig(e), c, i);
    }
    getSpeechRegionFromIntentRegion(e) {
        switch(e){
            case "West US":
            case "US West":
            case "westus":
                return "uswest";
            case "West US 2":
            case "US West 2":
            case "westus2":
                return "uswest2";
            case "South Central US":
            case "US South Central":
            case "southcentralus":
                return "ussouthcentral";
            case "West Central US":
            case "US West Central":
            case "westcentralus":
                return "uswestcentral";
            case "East US":
            case "US East":
            case "eastus":
                return "useast";
            case "East US 2":
            case "US East 2":
            case "eastus2":
                return "useast2";
            case "West Europe":
            case "Europe West":
            case "westeurope":
                return "europewest";
            case "North Europe":
            case "Europe North":
            case "northeurope":
                return "europenorth";
            case "Brazil South":
            case "South Brazil":
            case "southbrazil":
                return "brazilsouth";
            case "Australia East":
            case "East Australia":
            case "eastaustralia":
                return "australiaeast";
            case "Southeast Asia":
            case "Asia Southeast":
            case "southeastasia":
                return "asiasoutheast";
            case "East Asia":
            case "Asia East":
            case "eastasia":
                return "asiaeast";
            default:
                return e;
        }
    }
}
class $d7238066c5de7f1c$var$rh extends $d7238066c5de7f1c$var$fe {
    create(e, t, i, n) {
        let s = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint);
        if (!s) {
            const h = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region), a = $d7238066c5de7f1c$var$fe.getHostSuffix(h), d = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, `wss://${h}.spr-frontend.speech${a}`), v = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SpeakerIdMode, "TextIndependentIdentification");
            s = `${d}/speaker/ws/${this.scenarioToPath(v)}/${i}`;
        }
        const o = {
            format: "simple",
            language: e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage)
        };
        this.setCommonUrlParams(e, o, s);
        const c = {};
        t.token !== void 0 && t.token !== "" && (c[t.headerName] = t.token), c[$d7238066c5de7f1c$var$W.ConnectionId] = n, c[$d7238066c5de7f1c$var$W.SpIDAuthKey] = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key), e.parameters.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Url, s);
        const p = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$ut(s, o, c, new $d7238066c5de7f1c$var$At(), $d7238066c5de7f1c$var$Ve.fromRecognizerConfig(e), p, n);
    }
    scenarioToPath(e) {
        switch(e){
            case "TextIndependentVerification":
            case "2":
                return "verification/text-independent";
            case "TextDependentVerification":
            case "1":
                return "verification/text-dependent";
            default:
                return "identification/text-independent";
        }
    }
}
class $d7238066c5de7f1c$var$$l extends $d7238066c5de7f1c$var$rh {
    create(e, t, i) {
        return super.create(e, t, "recognition", i);
    }
}
class $d7238066c5de7f1c$var$Bl extends $d7238066c5de7f1c$var$rh {
    create(e, t, i) {
        return super.create(e, t, "profile", i);
    }
}
class $d7238066c5de7f1c$var$Cn extends $d7238066c5de7f1c$var$pt {
    constructor(e, t, i, n = $d7238066c5de7f1c$var$ce.Info){
        super(e, n), this.privRequestId = t, this.privSessionId = i;
    }
    get requestId() {
        return this.privRequestId;
    }
    get sessionId() {
        return this.privSessionId;
    }
}
class $d7238066c5de7f1c$var$nh extends $d7238066c5de7f1c$var$Cn {
    constructor(e, t, i, n){
        super("RecognitionTriggeredEvent", e, t), this.privAudioSourceId = i, this.privAudioNodeId = n;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $d7238066c5de7f1c$var$Ul extends $d7238066c5de7f1c$var$Cn {
    constructor(e, t, i, n){
        super("ListeningStartedEvent", e, t), this.privAudioSourceId = i, this.privAudioNodeId = n;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $d7238066c5de7f1c$var$sh extends $d7238066c5de7f1c$var$Cn {
    constructor(e, t, i){
        super("ConnectingToServiceEvent", e, i), this.privAuthFetchEventid = t;
    }
    get authFetchEventid() {
        return this.privAuthFetchEventid;
    }
}
class $d7238066c5de7f1c$var$ql extends $d7238066c5de7f1c$var$Cn {
    constructor(e, t, i, n, s){
        super("RecognitionStartedEvent", e, s), this.privAudioSourceId = t, this.privAudioNodeId = i, this.privAuthFetchEventId = n;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
var $d7238066c5de7f1c$var$Ga;
(function(r) {
    r[r.Success = 0] = "Success", r[r.AudioSourceError = 1] = "AudioSourceError", r[r.AudioSourceTimeout = 2] = "AudioSourceTimeout", r[r.AuthTokenFetchError = 3] = "AuthTokenFetchError", r[r.AuthTokenFetchTimeout = 4] = "AuthTokenFetchTimeout", r[r.UnAuthorized = 5] = "UnAuthorized", r[r.ConnectTimeout = 6] = "ConnectTimeout", r[r.ConnectError = 7] = "ConnectError", r[r.ClientRecognitionActivityTimeout = 8] = "ClientRecognitionActivityTimeout", r[r.UnknownError = 9] = "UnknownError";
})($d7238066c5de7f1c$var$Ga || ($d7238066c5de7f1c$var$Ga = {}));
class $d7238066c5de7f1c$var$se extends $d7238066c5de7f1c$var$Zr {
    constructor(e, t, i, n, s, o, c, p){
        if (!t) throw new $d7238066c5de7f1c$var$le("path");
        if (!i) throw new $d7238066c5de7f1c$var$le("requestId");
        const h = {};
        if (h[$d7238066c5de7f1c$var$W.Path] = t, h[$d7238066c5de7f1c$var$W.RequestId] = i, h[$d7238066c5de7f1c$var$W.RequestTimestamp] = /* @__PURE__ */ new Date().toISOString(), n && (h[$d7238066c5de7f1c$var$W.ContentType] = n), o && (h[$d7238066c5de7f1c$var$W.RequestStreamId] = o), c) for(const a in c)a && (h[a] = c[a]);
        p ? super(e, s, h, p) : super(e, s, h), this.privPath = t, this.privRequestId = i, this.privContentType = n, this.privStreamId = o, this.privAdditionalHeaders = c;
    }
    get path() {
        return this.privPath;
    }
    get requestId() {
        return this.privRequestId;
    }
    get contentType() {
        return this.privContentType;
    }
    get streamId() {
        return this.privStreamId;
    }
    get additionalHeaders() {
        return this.privAdditionalHeaders;
    }
    static fromConnectionMessage(e) {
        let t = null, i = null, n = null, s = null;
        const o = {};
        if (e.headers) for(const c in e.headers)c && (c.toLowerCase() === $d7238066c5de7f1c$var$W.Path.toLowerCase() ? t = e.headers[c] : c.toLowerCase() === $d7238066c5de7f1c$var$W.RequestId.toLowerCase() ? i = e.headers[c] : c.toLowerCase() === $d7238066c5de7f1c$var$W.ContentType.toLowerCase() ? n = e.headers[c] : c.toLowerCase() === $d7238066c5de7f1c$var$W.RequestStreamId.toLowerCase() ? s = e.headers[c] : o[c] = e.headers[c]);
        return new $d7238066c5de7f1c$var$se(e.messageType, t, i, n, e.body, s, o, e.id);
    }
}
var $d7238066c5de7f1c$var$me = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Ie {
    constructor(e, t, i, n, s){
        if (this.privConnectionConfigurationPromise = void 0, this.privConnectionPromise = void 0, this.privSetTimeout = setTimeout, this.privIsLiveAudio = !1, this.privAverageBytesPerMs = 0, this.privEnableSpeakerId = !1, this.recognizeOverride = void 0, this.recognizeSpeaker = void 0, this.disconnectOverride = void 0, this.receiveMessageOverride = void 0, this.sendPrePayloadJSONOverride = void 0, this.postConnectImplOverride = void 0, this.configConnectionOverride = void 0, this.handleSpeechPhraseMessage = void 0, this.handleSpeechHypothesisMessage = void 0, !e) throw new $d7238066c5de7f1c$var$le("authentication");
        if (!t) throw new $d7238066c5de7f1c$var$le("connectionFactory");
        if (!i) throw new $d7238066c5de7f1c$var$le("audioSource");
        if (!n) throw new $d7238066c5de7f1c$var$le("recognizerConfig");
        this.privEnableSpeakerId = n.isSpeakerDiarizationEnabled, this.privMustReportEndOfStream = !1, this.privAuthentication = e, this.privConnectionFactory = t, this.privAudioSource = i, this.privRecognizerConfig = n, this.privIsDisposed = !1, this.privRecognizer = s, this.privRequestSession = new $d7238066c5de7f1c$var$Zl(this.privAudioSource.id()), this.privConnectionEvents = new $d7238066c5de7f1c$var$Ze(), this.privServiceEvents = new $d7238066c5de7f1c$var$Ze(), this.privDynamicGrammar = new $d7238066c5de7f1c$var$ev(), this.privSpeechContext = new $d7238066c5de7f1c$var$Xl(this.privDynamicGrammar), this.privAgentConfig = new $d7238066c5de7f1c$var$ph(), this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.WebWorkerLoadType, "on").toLowerCase() === "on" && typeof Blob < "u" && typeof Worker < "u" ? this.privSetTimeout = $d7238066c5de7f1c$var$ye.setTimeout : typeof window < "u" && (this.privSetTimeout = window.setTimeout.bind(window)), this.connectionEvents.attach((c)=>{
            if (c.name === "ConnectionClosedEvent") {
                const p = c;
                (p.statusCode === 1003 || p.statusCode === 1007 || p.statusCode === 1002 || p.statusCode === 4e3 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount) && this.cancelRecognitionLocal($d7238066c5de7f1c$var$X.Error, p.statusCode === 1007 ? $d7238066c5de7f1c$var$T.BadRequestParameters : $d7238066c5de7f1c$var$T.ConnectionFailure, `${p.reason} websocket error code: ${p.statusCode}`);
            }
        }), this.privEnableSpeakerId && (this.privDiarizationSessionId = $d7238066c5de7f1c$var$ee()), this.setLanguageIdJson(), this.setOutputDetailLevelJson();
    }
    setTranslationJson() {
        const e = this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages, void 0);
        if (e !== void 0) {
            const t = e.split(","), i = this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationVoice, void 0), n = i !== void 0 ? "Synthesize" : "None";
            if (this.privSpeechContext.setSection("translation", {
                onSuccess: {
                    action: n
                },
                output: {
                    interimResults: {
                        mode: "Always"
                    }
                },
                targetLanguages: t
            }), i !== void 0) {
                const s = {};
                for (const o of t)s[o] = i;
                this.privSpeechContext.setSection("synthesis", {
                    defaultVoices: s
                });
            }
        }
    }
    setSpeechSegmentationTimeoutJson() {
        const e = this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.Speech_SegmentationSilenceTimeoutMs, void 0);
        if (e !== void 0) {
            const t = this.recognitionMode === $d7238066c5de7f1c$var$ue.Conversation ? "CONVERSATION" : this.recognitionMode === $d7238066c5de7f1c$var$ue.Dictation ? "DICTATION" : "INTERACTIVE", i = parseInt(e, 10), n = this.privSpeechContext.getSection("phraseDetection");
            n.mode = t, n[t] = {
                segmentation: {
                    mode: "Custom",
                    segmentationSilenceTimeoutMs: i
                }
            }, this.privSpeechContext.setSection("phraseDetection", n);
        }
    }
    setLanguageIdJson() {
        const e = this.privSpeechContext.getSection("phraseDetection");
        if (this.privRecognizerConfig.autoDetectSourceLanguages !== void 0) {
            const i = this.privRecognizerConfig.autoDetectSourceLanguages.split(",");
            let n;
            this.privRecognizerConfig.languageIdMode === "Continuous" ? n = "DetectContinuous" : n = "DetectAtAudioStart", this.privSpeechContext.setSection("languageId", {
                Priority: "PrioritizeLatency",
                languages: i,
                mode: n,
                onSuccess: {
                    action: "Recognize"
                },
                onUnknown: {
                    action: "None"
                }
            }), this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "Auto"
                },
                phraseResults: {
                    resultType: "Always"
                }
            });
            const s = this.privRecognizerConfig.sourceLanguageModels;
            s !== void 0 && (e.customModels = s, e.onInterim = {
                action: "None"
            }, e.onSuccess = {
                action: "None"
            });
        }
        this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0 && (e.onInterim = {
            action: "Translate"
        }, e.onSuccess = {
            action: "Translate"
        }, this.privSpeechContext.setSection("phraseOutput", {
            interimResults: {
                resultType: "None"
            },
            phraseResults: {
                resultType: "None"
            }
        })), this.privSpeechContext.setSection("phraseDetection", e);
    }
    setOutputDetailLevelJson() {
        this.privEnableSpeakerId && (this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase() === "true" ? this.privSpeechContext.setWordLevelTimings() : this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$$e, $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple]).toLowerCase() === $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Detailed].toLocaleLowerCase() && this.privSpeechContext.setDetailedOutputFormat());
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    get audioSource() {
        return this.privAudioSource;
    }
    get speechContext() {
        return this.privSpeechContext;
    }
    get dynamicGrammar() {
        return this.privDynamicGrammar;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    set conversationTranslatorToken(e) {
        this.privRecognizerConfig.parameters.setProperty($d7238066c5de7f1c$var$u.ConversationTranslator_Token, e);
    }
    set voiceProfileType(e) {
        this.privRecognizerConfig.parameters.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SpeakerIdMode, e);
    }
    set authentication(e) {
        this.privAuthentication = e;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(e) {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            if (this.privIsDisposed = !0, this.privConnectionConfigurationPromise !== void 0) try {
                yield (yield this.privConnectionConfigurationPromise).dispose(e);
            } catch  {
                return;
            }
        });
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    get recognitionMode() {
        return this.privRecognizerConfig.recognitionMode;
    }
    recognize(e, t, i) {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            if (this.recognizeOverride !== void 0) {
                yield this.recognizeOverride(e, t, i);
                return;
            }
            this.privConnectionConfigurationPromise = void 0, this.privRecognizerConfig.recognitionMode = e, this.setSpeechSegmentationTimeoutJson(), this.setTranslationJson(), this.privSuccessCallback = t, this.privErrorCallback = i, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
            const n = this.connectImpl();
            let s;
            try {
                const p = yield this.audioSource.attach(this.privRequestSession.audioNodeId), h = yield this.audioSource.format, a = yield this.audioSource.deviceInfo;
                this.privIsLiveAudio = a.type && a.type === $d7238066c5de7f1c$var$Qt.Microphones, s = new $d7238066c5de7f1c$var$ln(p, h.avgBytesPerSec), yield this.privRequestSession.onAudioSourceAttachCompleted(s, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                    source: a
                };
            } catch (p) {
                throw yield this.privRequestSession.onStopRecognizing(), p;
            }
            try {
                yield n;
            } catch (p) {
                yield this.cancelRecognitionLocal($d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.ConnectionFailure, p);
                return;
            }
            const o = new $d7238066c5de7f1c$var$Ce(this.privRequestSession.sessionId);
            this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, o), this.receiveMessage(), this.sendAudio(s).catch((p)=>$d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
                    yield this.cancelRecognitionLocal($d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.RuntimeError, p);
                }));
        });
    }
    stopRecognizing() {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            if (this.privRequestSession.isRecognizing) try {
                yield this.audioSource.turnOff(), yield this.sendFinalAudio(), yield this.privRequestSession.onStopRecognizing(), yield this.privRequestSession.turnCompletionPromise;
            } finally{
                yield this.privRequestSession.dispose();
            }
        });
    }
    connect() {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            return yield this.connectImpl(), Promise.resolve();
        });
    }
    connectAsync(e, t) {
        this.connectImpl().then(()=>{
            try {
                e && e();
            } catch (i) {
                t && t(i);
            }
        }, (i)=>{
            try {
                t && t(i);
            } catch  {}
        });
    }
    disconnect() {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            if (yield this.cancelRecognitionLocal($d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.NoError, "Disconnecting"), this.disconnectOverride !== void 0 && (yield this.disconnectOverride()), this.privConnectionPromise !== void 0) try {
                yield (yield this.privConnectionPromise).dispose();
            } catch  {}
            this.privConnectionPromise = void 0;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendMessage(e) {}
    sendNetworkMessage(e, t) {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            const i = typeof t == "string" ? $d7238066c5de7f1c$var$k.Text : $d7238066c5de7f1c$var$k.Binary, n = typeof t == "string" ? "application/json" : "";
            return (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$se(i, e, this.privRequestSession.requestId, n, t));
        });
    }
    set activityTemplate(e) {
        this.privActivityTemplate = e;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    sendTelemetryData() {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            const e = this.privRequestSession.getTelemetry();
            if ($d7238066c5de7f1c$var$Ie.telemetryDataEnabled !== !0 || this.privIsDisposed || e === null) return;
            if ($d7238066c5de7f1c$var$Ie.telemetryData) try {
                $d7238066c5de7f1c$var$Ie.telemetryData(e);
            } catch  {}
            yield (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "telemetry", this.privRequestSession.requestId, "application/json", e));
        });
    }
    // Cancels recognition.
    cancelRecognitionLocal(e, t, i) {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            this.privRequestSession.isRecognizing && (yield this.privRequestSession.onStopRecognizing(), this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, e, t, i));
        });
    }
    receiveMessage() {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            try {
                if (this.privIsDisposed) return;
                let e = yield this.fetchConnection();
                const t = yield e.read();
                if (this.receiveMessageOverride !== void 0) return this.receiveMessageOverride();
                if (!t) return this.receiveMessage();
                this.privServiceHasSentMessage = !0;
                const i = $d7238066c5de7f1c$var$se.fromConnectionMessage(t);
                if (i.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase()) switch(i.path.toLowerCase()){
                    case "turn.start":
                        this.privMustReportEndOfStream = !0, this.privRequestSession.onServiceTurnStartResponse();
                        break;
                    case "speech.startdetected":
                        const n = $d7238066c5de7f1c$var$wi.fromJSON(i.textBody), s = new $d7238066c5de7f1c$var$Xe(n.Offset, this.privRequestSession.sessionId);
                        this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, s);
                        break;
                    case "speech.enddetected":
                        let o;
                        i.textBody.length > 0 ? o = i.textBody : o = "{ Offset: 0 }";
                        const c = $d7238066c5de7f1c$var$wi.fromJSON(o), p = new $d7238066c5de7f1c$var$Xe(c.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                        this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, p);
                        break;
                    case "turn.end":
                        yield this.sendTelemetryData(), this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream && (this.privMustReportEndOfStream = !1, yield this.cancelRecognitionLocal($d7238066c5de7f1c$var$X.EndOfStream, $d7238066c5de7f1c$var$T.NoError, void 0));
                        const h = new $d7238066c5de7f1c$var$Ce(this.privRequestSession.sessionId);
                        if (yield this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition), !this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                            this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, h);
                            return;
                        } else e = yield this.fetchConnection(), yield this.sendPrePayloadJSON(e);
                        break;
                    default:
                        (yield this.processTypeSpecificMessages(i)) || this.privServiceEvents && this.serviceEvents.onEvent(new $d7238066c5de7f1c$var$yo(i.path.toLowerCase(), i.textBody));
                }
                return this.receiveMessage();
            } catch  {
                return null;
            }
        });
    }
    updateSpeakerDiarizationAudioOffset() {
        const t = this.privRequestSession.recognitionBytesSent / this.privAverageBytesPerMs;
        this.privSpeechContext.setSpeakerDiarizationAudioOffsetMs(t);
    }
    sendSpeechContext(e, t) {
        this.privEnableSpeakerId && this.updateSpeakerDiarizationAudioOffset();
        const i = this.speechContext.toJSON();
        if (t && this.privRequestSession.onSpeechContext(), i) return e.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "speech.context", this.privRequestSession.requestId, "application/json", i));
    }
    noOp() {}
    // Encapsulated for derived service recognizers that need to send additional JSON
    sendPrePayloadJSON(e, t = !0) {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            if (this.sendPrePayloadJSONOverride !== void 0) return this.sendPrePayloadJSONOverride(e);
            yield this.sendSpeechContext(e, t), yield this.sendWaveHeader(e);
        });
    }
    sendWaveHeader(e) {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            const t = yield this.audioSource.format;
            return e.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", t.header));
        });
    }
    // Establishes a websocket connection to the end point.
    connectImpl() {
        return this.privConnectionPromise !== void 0 ? this.privConnectionPromise.then((e)=>e.state() === $d7238066c5de7f1c$var$pe.Disconnected ? (this.privConnectionId = null, this.privConnectionPromise = void 0, this.privServiceHasSentMessage = !1, this.connectImpl()) : this.privConnectionPromise, ()=>(this.privConnectionId = null, this.privConnectionPromise = void 0, this.privServiceHasSentMessage = !1, this.connectImpl())) : (this.privConnectionPromise = this.retryableConnect(), this.privConnectionPromise.catch(()=>{}), this.postConnectImplOverride !== void 0 ? this.postConnectImplOverride(this.privConnectionPromise) : this.privConnectionPromise);
    }
    sendSpeechServiceConfig(e, t, i) {
        if (t.onSpeechContext(), $d7238066c5de7f1c$var$Ie.telemetryDataEnabled !== !0) {
            const s = {
                context: {
                    system: JSON.parse(i).context.system
                }
            };
            i = JSON.stringify(s);
        }
        if (this.privRecognizerConfig.parameters.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() === "true") {
            const n = JSON.parse(i);
            n.context.DisableReferenceChannel = "True", n.context.MicSpec = "1_0_0", i = JSON.stringify(n);
        }
        if (i) return e.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "speech.config", t.requestId, "application/json", i));
    }
    fetchConnection() {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            return this.privConnectionConfigurationPromise !== void 0 ? this.privConnectionConfigurationPromise.then((e)=>e.state() === $d7238066c5de7f1c$var$pe.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.privServiceHasSentMessage = !1, this.fetchConnection()) : this.privConnectionConfigurationPromise, ()=>(this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.privServiceHasSentMessage = !1, this.fetchConnection())) : (this.privConnectionConfigurationPromise = this.configureConnection(), yield this.privConnectionConfigurationPromise);
        });
    }
    sendAudio(e) {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            const t = yield this.audioSource.format;
            this.privAverageBytesPerMs = t.avgBytesPerSec / 1e3;
            let i = Date.now();
            const n = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000"), s = t.avgBytesPerSec / 1e3 * parseInt(n, 10), o = this.privRequestSession.recogNumber, c = ()=>$d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
                    if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === o) {
                        const p = yield this.fetchConnection(), h = yield e.read();
                        if (this.privRequestSession.isSpeechEnded) return;
                        let a, d;
                        if (!h || h.isEnd ? (a = null, d = 0) : (a = h.buffer, this.privRequestSession.onAudioSent(a.byteLength), s >= this.privRequestSession.bytesSent ? d = 0 : d = Math.max(0, i - Date.now())), d !== 0 && (yield this.delay(d)), a !== null && (i = Date.now() + a.byteLength * 1e3 / (t.avgBytesPerSec * 2)), !this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === o) {
                            if (p.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Binary, "audio", this.privRequestSession.requestId, null, a)).catch(()=>{
                                this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition).catch(()=>{});
                            }), h != null && h.isEnd) this.privIsLiveAudio || this.privRequestSession.onSpeechEnded();
                            else return c();
                        }
                    }
                });
            return c();
        });
    }
    retryableConnect() {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            let e = !1;
            this.privAuthFetchEventId = $d7238066c5de7f1c$var$ee();
            const t = this.privRequestSession.sessionId;
            this.privConnectionId = t !== void 0 ? t : $d7238066c5de7f1c$var$ee(), this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
            let i = 0, n = "";
            for(; this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount;){
                const o = yield e ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
                yield this.privRequestSession.onAuthCompleted(!1);
                const c = this.privConnectionFactory.create(this.privRecognizerConfig, o, this.privConnectionId);
                this.privRequestSession.listenForServiceTelemetry(c.events), c.events.attach((h)=>{
                    this.connectionEvents.onEvent(h);
                });
                const p = yield c.open();
                if (p.statusCode === 200) return yield this.privRequestSession.onConnectionEstablishCompleted(p.statusCode), Promise.resolve(c);
                p.statusCode === 1006 && (e = !0), i = p.statusCode, n = p.reason, this.privRequestSession.onRetryConnection();
            }
            return yield this.privRequestSession.onConnectionEstablishCompleted(i, n), Promise.reject(`Unable to contact server. StatusCode: ${i}, ${this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint)} Reason: ${n}`);
        });
    }
    delay(e) {
        return new Promise((t)=>this.privSetTimeout(t, e));
    }
    writeBufferToConsole(e) {
        let t = "Buffer Size: ";
        if (e === null) t += "null";
        else {
            const i = new Uint8Array(e);
            t += `${e.byteLength}\r
`;
            for(let n = 0; n < e.byteLength; n++)t += i[n].toString(16).padStart(2, "0") + " ", (n + 1) % 16 === 0 && (console.info(t), t = "");
        }
        console.info(t);
    }
    sendFinalAudio() {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            yield (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Binary, "audio", this.privRequestSession.requestId, null, null));
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configureConnection() {
        return $d7238066c5de7f1c$var$me(this, void 0, void 0, function*() {
            const e = yield this.connectImpl();
            return this.configConnectionOverride !== void 0 ? this.configConnectionOverride(e) : (yield this.sendSpeechServiceConfig(e, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize()), yield this.sendPrePayloadJSON(e, !1), e);
        });
    }
}
$d7238066c5de7f1c$var$Ie.telemetryDataEnabled = !0;
var $d7238066c5de7f1c$var$Kn = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$oh extends $d7238066c5de7f1c$var$Ie {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.handleSpeechPhraseMessage = (o)=>$d7238066c5de7f1c$var$Kn(this, void 0, void 0, function*() {
                return this.handleSpeechPhrase(o);
            }), this.handleSpeechHypothesisMessage = (o)=>this.handleSpeechHypothesis(o);
    }
    processTypeSpecificMessages(e) {}
    handleRecognizedCallback(e, t, i) {}
    handleRecognizingCallback(e, t, i) {}
    processSpeechMessages(e) {
        return $d7238066c5de7f1c$var$Kn(this, void 0, void 0, function*() {
            let t = !1;
            switch(e.path.toLowerCase()){
                case "speech.hypothesis":
                case "speech.fragment":
                    this.handleSpeechHypothesisMessage && this.handleSpeechHypothesisMessage(e.textBody), t = !0;
                    break;
                case "speech.phrase":
                    this.handleSpeechPhraseMessage && (yield this.handleSpeechPhraseMessage(e.textBody)), t = !0;
                    break;
            }
            return t;
        });
    }
    cancelRecognition(e, t, i, n, s) {}
    handleSpeechPhrase(e) {
        return $d7238066c5de7f1c$var$Kn(this, void 0, void 0, function*() {
            const t = $d7238066c5de7f1c$var$kt.fromJSON(e), i = $d7238066c5de7f1c$var$he.implTranslateRecognitionResult(t.RecognitionStatus);
            let n;
            const s = new $d7238066c5de7f1c$var$U();
            s.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_JsonResult, e);
            const o = t.Offset + this.privRequestSession.currentTurnAudioOffset;
            let c = o;
            if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + t.Offset + t.Duration), $d7238066c5de7f1c$var$R.Canceled === i) {
                const p = $d7238066c5de7f1c$var$he.implTranslateCancelResult(t.RecognitionStatus), h = $d7238066c5de7f1c$var$he.implTranslateCancelErrorCode(t.RecognitionStatus);
                yield this.cancelRecognitionLocal(p, h, $d7238066c5de7f1c$var$he.implTranslateErrorDetails(h));
            } else if (!(this.privRequestSession.isSpeechEnded && i === $d7238066c5de7f1c$var$R.NoMatch && t.RecognitionStatus !== $d7238066c5de7f1c$var$H.InitialSilenceTimeout)) {
                if (this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$$e) === $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple]) n = new $d7238066c5de7f1c$var$Oe(this.privRequestSession.requestId, i, t.DisplayText, t.Duration, o, t.Language, t.LanguageDetectionConfidence, t.SpeakerId, void 0, e, s);
                else {
                    const p = $d7238066c5de7f1c$var$gr.fromJSON(e), h = p.Offset + this.privRequestSession.currentTurnAudioOffset, a = p.getJsonWithCorrectedOffsets(h);
                    n = new $d7238066c5de7f1c$var$Oe(this.privRequestSession.requestId, i, p.Text, p.Duration, h, p.Language, p.LanguageDetectionConfidence, p.SpeakerId, void 0, a, s), c = n.offset;
                }
                this.handleRecognizedCallback(n, c, this.privRequestSession.sessionId);
            }
        });
    }
    handleSpeechHypothesis(e) {
        const t = $d7238066c5de7f1c$var$Zt.fromJSON(e), i = t.Offset + this.privRequestSession.currentTurnAudioOffset, n = new $d7238066c5de7f1c$var$U();
        n.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_JsonResult, e);
        const s = new $d7238066c5de7f1c$var$Oe(this.privRequestSession.requestId, $d7238066c5de7f1c$var$R.RecognizingSpeech, t.Text, t.Duration, i, t.Language, t.LanguageDetectionConfidence, t.SpeakerId, void 0, e, n);
        this.privRequestSession.onHypothesis(i), this.handleRecognizingCallback(s, t.Duration, this.privRequestSession.sessionId);
    }
}
var $d7238066c5de7f1c$var$ue;
(function(r) {
    r[r.Interactive = 0] = "Interactive", r[r.Conversation = 1] = "Conversation", r[r.Dictation = 2] = "Dictation";
})($d7238066c5de7f1c$var$ue || ($d7238066c5de7f1c$var$ue = {}));
var $d7238066c5de7f1c$var$Qa;
(function(r) {
    r[r.Simple = 0] = "Simple", r[r.Detailed = 1] = "Detailed";
})($d7238066c5de7f1c$var$Qa || ($d7238066c5de7f1c$var$Qa = {}));
class $d7238066c5de7f1c$var$Et {
    constructor(e, t){
        this.privSpeechServiceConfig = e || new $d7238066c5de7f1c$var$wn(new $d7238066c5de7f1c$var$Rn(null)), this.privParameters = t, this.privMaxRetryCount = parseInt(t.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10), this.privLanguageIdMode = t.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_LanguageIdMode, void 0), this.privEnableSpeakerId = !1;
    }
    get parameters() {
        return this.privParameters;
    }
    get recognitionMode() {
        return this.privRecognitionMode;
    }
    set recognitionMode(e) {
        this.privRecognitionMode = e, this.privRecognitionActivityTimeout = e === $d7238066c5de7f1c$var$ue.Interactive ? 8e3 : 25e3, this.privSpeechServiceConfig.Recognition = $d7238066c5de7f1c$var$ue[e];
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
    get recognitionActivityTimeout() {
        return this.privRecognitionActivityTimeout;
    }
    get isContinuousRecognition() {
        return this.privRecognitionMode !== $d7238066c5de7f1c$var$ue.Interactive;
    }
    get languageIdMode() {
        return this.privLanguageIdMode;
    }
    get autoDetectSourceLanguages() {
        return this.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_AutoDetectSourceLanguages, void 0);
    }
    get recognitionEndpointVersion() {
        return this.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecognitionEndpointVersion, void 0);
    }
    get sourceLanguageModels() {
        const e = [];
        let t = !1;
        if (this.autoDetectSourceLanguages !== void 0) for (const i of this.autoDetectSourceLanguages.split(",")){
            const n = i + $d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId.toString(), s = this.parameters.getProperty(n, void 0);
            s !== void 0 ? (e.push({
                language: i,
                endpoint: s
            }), t = !0) : e.push({
                language: i,
                endpoint: ""
            });
        }
        return t ? e : void 0;
    }
    get maxRetryCount() {
        return this.privMaxRetryCount;
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    set isSpeakerDiarizationEnabled(e) {
        this.privEnableSpeakerId = e;
    }
}
const $d7238066c5de7f1c$var$Ya = `\r
`;
class $d7238066c5de7f1c$var$At {
    toConnectionMessage(e) {
        const t = new $d7238066c5de7f1c$var$F();
        try {
            if (e.messageType === $d7238066c5de7f1c$var$k.Text) {
                const i = e.textContent;
                let n = {}, s = null;
                if (i) {
                    const o = i.split(`\r
\r
`);
                    o && o.length > 0 && (n = this.parseHeaders(o[0]), o.length > 1 && (s = o[1]));
                }
                t.resolve(new $d7238066c5de7f1c$var$Zr(e.messageType, s, n, e.id));
            } else if (e.messageType === $d7238066c5de7f1c$var$k.Binary) {
                const i = e.binaryContent;
                let n = {}, s = null;
                if (!i || i.byteLength < 2) throw new Error("Invalid binary message format. Header length missing.");
                const o = new DataView(i), c = o.getInt16(0);
                if (i.byteLength < c + 2) throw new Error("Invalid binary message format. Header content missing.");
                let p = "";
                for(let h = 0; h < c; h++)p += String.fromCharCode(o.getInt8(h + 2));
                n = this.parseHeaders(p), i.byteLength > c + 2 && (s = i.slice(2 + c)), t.resolve(new $d7238066c5de7f1c$var$Zr(e.messageType, s, n, e.id));
            }
        } catch (i) {
            t.reject(`Error formatting the message. Error: ${i}`);
        }
        return t.promise;
    }
    fromConnectionMessage(e) {
        const t = new $d7238066c5de7f1c$var$F();
        try {
            if (e.messageType === $d7238066c5de7f1c$var$k.Text) {
                const i = `${this.makeHeaders(e)}${$d7238066c5de7f1c$var$Ya}${e.textBody ? e.textBody : ""}`;
                t.resolve(new $d7238066c5de7f1c$var$Yi($d7238066c5de7f1c$var$k.Text, i, e.id));
            } else if (e.messageType === $d7238066c5de7f1c$var$k.Binary) {
                const i = this.makeHeaders(e), n = e.binaryBody, s = this.stringToArrayBuffer(i), o = new Int8Array(s), c = o.byteLength, p = new Int8Array(2 + c + (n ? n.byteLength : 0));
                if (p[0] = c >> 8 & 255, p[1] = c & 255, p.set(o, 2), n) {
                    const a = new Int8Array(n);
                    p.set(a, 2 + c);
                }
                const h = p.buffer;
                t.resolve(new $d7238066c5de7f1c$var$Yi($d7238066c5de7f1c$var$k.Binary, h, e.id));
            }
        } catch (i) {
            t.reject(`Error formatting the message. ${i}`);
        }
        return t.promise;
    }
    makeHeaders(e) {
        let t = "";
        if (e.headers) for(const i in e.headers)i && (t += `${i}: ${e.headers[i]}${$d7238066c5de7f1c$var$Ya}`);
        return t;
    }
    parseHeaders(e) {
        const t = {};
        if (e) {
            const i = e.match(/[^\r\n]+/g);
            if (t) {
                for (const n of i)if (n) {
                    const s = n.indexOf(":"), o = s > 0 ? n.substr(0, s).trim().toLowerCase() : n, c = s > 0 && n.length > s + 1 ? n.substr(s + 1).trim() : "";
                    t[o] = c;
                }
            }
        }
        return t;
    }
    stringToArrayBuffer(e) {
        const t = new ArrayBuffer(e.length), i = new DataView(t);
        for(let n = 0; n < e.length; n++)i.setUint8(n, e.charCodeAt(n));
        return t;
    }
}
class $d7238066c5de7f1c$var$Wl extends $d7238066c5de7f1c$var$fe {
    constructor(){
        super(...arguments), this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1", this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1", this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1", this.universalUri = "/speech/universal/v";
    }
    create(e, t, i) {
        let n = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint, void 0);
        const s = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, void 0), o = $d7238066c5de7f1c$var$fe.getHostSuffix(s), c = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, "wss://" + s + ".stt.speech" + o), p = {}, h = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId, void 0), a = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage, void 0);
        if (h ? (!n || n.search($d7238066c5de7f1c$var$w.CustomSpeechDeploymentId) === -1) && (p[$d7238066c5de7f1c$var$w.CustomSpeechDeploymentId] = h) : a && (!n || n.search($d7238066c5de7f1c$var$w.Language) === -1) && (p[$d7238066c5de7f1c$var$w.Language] = a), (!n || n.search($d7238066c5de7f1c$var$w.Format) === -1) && (p[$d7238066c5de7f1c$var$w.Format] = e.parameters.getProperty($d7238066c5de7f1c$var$$e, $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple]).toLowerCase()), e.autoDetectSourceLanguages !== void 0 && (p[$d7238066c5de7f1c$var$w.EnableLanguageId] = "true"), this.setCommonUrlParams(e, p, n), !n) switch(e.recognitionMode){
            case $d7238066c5de7f1c$var$ue.Conversation:
                e.parameters.getProperty($d7238066c5de7f1c$var$aa, "false") === "true" ? n = c + this.dictationRelativeUri : e.recognitionEndpointVersion !== void 0 && parseInt(e.recognitionEndpointVersion, 10) > 1 ? n = `${c}${this.universalUri}${e.recognitionEndpointVersion}` : n = c + this.conversationRelativeUri;
                break;
            case $d7238066c5de7f1c$var$ue.Dictation:
                n = c + this.dictationRelativeUri;
                break;
            default:
                e.recognitionEndpointVersion !== void 0 && parseInt(e.recognitionEndpointVersion, 10) > 1 ? n = `${c}${this.universalUri}${e.recognitionEndpointVersion}` : n = c + this.interactiveRelativeUri;
                break;
        }
        const d = {};
        t.token !== void 0 && t.token !== "" && (d[t.headerName] = t.token), d[$d7238066c5de7f1c$var$W.ConnectionId] = i;
        const v = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true", g = new $d7238066c5de7f1c$var$ut(n, p, d, new $d7238066c5de7f1c$var$At(), $d7238066c5de7f1c$var$Ve.fromRecognizerConfig(e), v, i), I = g.uri;
        return e.parameters.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Url, I), g;
    }
}
class $d7238066c5de7f1c$var$Hl extends $d7238066c5de7f1c$var$fe {
    constructor(){
        super(...arguments), this.universalUri = "/speech/universal/v2";
    }
    create(e, t, i) {
        let n = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint, void 0);
        const s = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, void 0), o = $d7238066c5de7f1c$var$fe.getHostSuffix(s), c = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, "wss://" + s + ".stt.speech" + o), p = {}, h = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId, void 0), a = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage, void 0);
        h ? (!n || n.search($d7238066c5de7f1c$var$w.CustomSpeechDeploymentId) === -1) && (p[$d7238066c5de7f1c$var$w.CustomSpeechDeploymentId] = h) : a && (!n || n.search($d7238066c5de7f1c$var$w.Language) === -1) && (p[$d7238066c5de7f1c$var$w.Language] = a), e.autoDetectSourceLanguages !== void 0 && (p[$d7238066c5de7f1c$var$w.EnableLanguageId] = "true"), this.setV2UrlParams(e, p, n), n || (n = `${c}${this.universalUri}`);
        const d = {};
        t.token !== void 0 && t.token !== "" && (d[t.headerName] = t.token), d[$d7238066c5de7f1c$var$W.ConnectionId] = i;
        const v = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true", g = new $d7238066c5de7f1c$var$ut(n, p, d, new $d7238066c5de7f1c$var$At(), $d7238066c5de7f1c$var$Ve.fromRecognizerConfig(e), v, i), I = g.uri;
        return e.parameters.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Url, I), g;
    }
    setV2UrlParams(e, t, i) {
        /* @__PURE__ */ new Map([
            [
                $d7238066c5de7f1c$var$u.Speech_SegmentationSilenceTimeoutMs,
                $d7238066c5de7f1c$var$w.SegmentationSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceConnection_EnableAudioLogging,
                $d7238066c5de7f1c$var$w.EnableAudioLogging
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceConnection_EndSilenceTimeoutMs,
                $d7238066c5de7f1c$var$w.EndSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceConnection_InitialSilenceTimeoutMs,
                $d7238066c5de7f1c$var$w.InitialSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceResponse_PostProcessingOption,
                $d7238066c5de7f1c$var$w.Postprocessing
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceResponse_ProfanityOption,
                $d7238066c5de7f1c$var$w.Profanity
            ],
            [
                $d7238066c5de7f1c$var$u.SpeechServiceResponse_StablePartialResultThreshold,
                $d7238066c5de7f1c$var$w.StableIntermediateThreshold
            ]
        ]).forEach((o, c)=>{
            this.setUrlParameter(c, o, e, t, i);
        });
        const s = JSON.parse(e.parameters.getProperty($d7238066c5de7f1c$var$It, "{}"));
        Object.keys(s).forEach((o)=>{
            t[o] = s[o];
        });
    }
}
class $d7238066c5de7f1c$var$ah extends $d7238066c5de7f1c$var$fe {
    constructor(){
        super(...arguments), this.multiaudioRelativeUri = "/speech/recognition/multiaudio";
    }
    create(e, t, i) {
        let n = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint, void 0);
        const s = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, "centralus"), o = $d7238066c5de7f1c$var$fe.getHostSuffix(s), c = "wss://transcribe." + s + ".cts.speech" + o + this.multiaudioRelativeUri, p = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, c), h = {};
        this.setQueryParams(h, e, n), n || (n = p);
        const a = {};
        t.token !== void 0 && t.token !== "" && (a[t.headerName] = t.token), a[$d7238066c5de7f1c$var$W.ConnectionId] = i, e.parameters.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Url, n);
        const d = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$ut(n, h, a, new $d7238066c5de7f1c$var$At(), $d7238066c5de7f1c$var$Ve.fromRecognizerConfig(e), d, i);
    }
    setQueryParams(e, t, i) {
        const n = t.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_EndpointId, void 0), s = t.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage, void 0);
        n && !($d7238066c5de7f1c$var$w.CustomSpeechDeploymentId in e) && (e[$d7238066c5de7f1c$var$w.CustomSpeechDeploymentId] = n), s && !($d7238066c5de7f1c$var$w.Language in e) && (e[$d7238066c5de7f1c$var$w.Language] = s);
        const o = t.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase() === "true", c = t.parameters.getProperty($d7238066c5de7f1c$var$$e, $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple]) !== $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple];
        (o || c) && (e[$d7238066c5de7f1c$var$w.Format] = $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Detailed].toLowerCase()), this.setCommonUrlParams(t, e, i);
    }
}
class $d7238066c5de7f1c$var$ch extends $d7238066c5de7f1c$var$fe {
    create(e, t, i) {
        const n = this.getEndpointUrl(e), s = {};
        e.autoDetectSourceLanguages !== void 0 && (s[$d7238066c5de7f1c$var$w.EnableLanguageId] = "true"), this.setQueryParams(s, e, n);
        const o = {};
        t.token !== void 0 && t.token !== "" && (o[t.headerName] = t.token), o[$d7238066c5de7f1c$var$W.ConnectionId] = i, e.parameters.setProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Url, n);
        const c = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$ut(n, s, o, new $d7238066c5de7f1c$var$At(), $d7238066c5de7f1c$var$Ve.fromRecognizerConfig(e), c, i);
    }
    getEndpointUrl(e, t) {
        const i = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region), n = $d7238066c5de7f1c$var$fe.getHostSuffix(i);
        let s = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint, void 0);
        return s || (e.autoDetectSourceLanguages !== void 0 ? s = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, "wss://{region}.stt.speech" + n) + "/speech/universal/v2" : s = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, "wss://{region}.s2s.speech" + n) + "/speech/translation/cognitiveservices/v1"), t === !0 ? s : $d7238066c5de7f1c$var$Vs.formatString(s, {
            region: i
        });
    }
    setQueryParams(e, t, i) {
        e.from = t.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage), e.to = t.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationToLanguages), e.scenario = t.recognitionMode === $d7238066c5de7f1c$var$ue.Interactive ? "interactive" : t.recognitionMode === $d7238066c5de7f1c$var$ue.Conversation ? "conversation" : "", this.setCommonUrlParams(t, e, i), this.setUrlParameter($d7238066c5de7f1c$var$u.SpeechServiceResponse_TranslationRequestStablePartialResult, $d7238066c5de7f1c$var$w.StableTranslation, t, e, i);
        const n = t.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_TranslationVoice, void 0);
        n !== void 0 && (e.voice = n, e.features = "texttospeech");
    }
}
class $d7238066c5de7f1c$var$he {
    static implTranslateRecognitionResult(e) {
        let t = $d7238066c5de7f1c$var$R.Canceled;
        switch(e){
            case $d7238066c5de7f1c$var$H.Success:
                t = $d7238066c5de7f1c$var$R.RecognizedSpeech;
                break;
            case $d7238066c5de7f1c$var$H.NoMatch:
            case $d7238066c5de7f1c$var$H.InitialSilenceTimeout:
            case $d7238066c5de7f1c$var$H.BabbleTimeout:
            case $d7238066c5de7f1c$var$H.EndOfDictation:
                t = $d7238066c5de7f1c$var$R.NoMatch;
                break;
            case $d7238066c5de7f1c$var$H.Error:
            case $d7238066c5de7f1c$var$H.BadRequest:
            case $d7238066c5de7f1c$var$H.Forbidden:
            default:
                t = $d7238066c5de7f1c$var$R.Canceled;
                break;
        }
        return t;
    }
    static implTranslateCancelResult(e) {
        let t = $d7238066c5de7f1c$var$X.EndOfStream;
        switch(e){
            case $d7238066c5de7f1c$var$H.Success:
            case $d7238066c5de7f1c$var$H.EndOfDictation:
            case $d7238066c5de7f1c$var$H.NoMatch:
                t = $d7238066c5de7f1c$var$X.EndOfStream;
                break;
            case $d7238066c5de7f1c$var$H.InitialSilenceTimeout:
            case $d7238066c5de7f1c$var$H.BabbleTimeout:
            case $d7238066c5de7f1c$var$H.Error:
            case $d7238066c5de7f1c$var$H.BadRequest:
            case $d7238066c5de7f1c$var$H.Forbidden:
            default:
                t = $d7238066c5de7f1c$var$X.Error;
                break;
        }
        return t;
    }
    static implTranslateCancelErrorCode(e) {
        let t = $d7238066c5de7f1c$var$T.NoError;
        switch(e){
            case $d7238066c5de7f1c$var$H.Error:
                t = $d7238066c5de7f1c$var$T.ServiceError;
                break;
            case $d7238066c5de7f1c$var$H.TooManyRequests:
                t = $d7238066c5de7f1c$var$T.TooManyRequests;
                break;
            case $d7238066c5de7f1c$var$H.BadRequest:
                t = $d7238066c5de7f1c$var$T.BadRequestParameters;
                break;
            case $d7238066c5de7f1c$var$H.Forbidden:
                t = $d7238066c5de7f1c$var$T.Forbidden;
                break;
            default:
                t = $d7238066c5de7f1c$var$T.NoError;
                break;
        }
        return t;
    }
    static implTranslateErrorDetails(e) {
        let t = "The speech service encountered an internal error and could not continue.";
        switch(e){
            case $d7238066c5de7f1c$var$T.Forbidden:
                t = "The recognizer is using a free subscription that ran out of quota.";
                break;
            case $d7238066c5de7f1c$var$T.BadRequestParameters:
                t = "Invalid parameter or unsupported audio format in the request.";
                break;
            case $d7238066c5de7f1c$var$T.TooManyRequests:
                t = "The number of parallel requests exceeded the number of allowed concurrent transcriptions.";
                break;
        }
        return t;
    }
}
var $d7238066c5de7f1c$var$Ci;
(function(r) {
    r[r.Success = 0] = "Success", r[r.SynthesisEnd = 1] = "SynthesisEnd", r[r.Error = 2] = "Error";
})($d7238066c5de7f1c$var$Ci || ($d7238066c5de7f1c$var$Ci = {}));
var $d7238066c5de7f1c$var$H;
(function(r) {
    r[r.Success = 0] = "Success", r[r.NoMatch = 1] = "NoMatch", r[r.InitialSilenceTimeout = 2] = "InitialSilenceTimeout", r[r.BabbleTimeout = 3] = "BabbleTimeout", r[r.Error = 4] = "Error", r[r.EndOfDictation = 5] = "EndOfDictation", r[r.TooManyRequests = 6] = "TooManyRequests", r[r.BadRequest = 7] = "BadRequest", r[r.Forbidden = 8] = "Forbidden";
})($d7238066c5de7f1c$var$H || ($d7238066c5de7f1c$var$H = {}));
class $d7238066c5de7f1c$var$Qo {
    constructor(e){
        this.privSynthesisEnd = JSON.parse(e), this.privSynthesisEnd.SynthesisStatus && (this.privSynthesisEnd.SynthesisStatus = $d7238066c5de7f1c$var$Ci[this.privSynthesisEnd.SynthesisStatus]), this.privSynthesisEnd.Status && (this.privSynthesisEnd.SynthesisStatus = $d7238066c5de7f1c$var$Ci[this.privSynthesisEnd.Status]);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$Qo(e);
    }
    get SynthesisStatus() {
        return this.privSynthesisEnd.SynthesisStatus;
    }
    get FailureReason() {
        return this.privSynthesisEnd.FailureReason;
    }
}
class $d7238066c5de7f1c$var$nr {
    constructor(e){
        this.privTranslationHypothesis = e, this.privTranslationHypothesis.Translation.TranslationStatus = $d7238066c5de7f1c$var$Zi[this.privTranslationHypothesis.Translation.TranslationStatus];
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$nr(JSON.parse(e));
    }
    static fromTranslationResponse(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "translationHypothesis");
        const t = e.SpeechHypothesis;
        return e.SpeechHypothesis = void 0, t.Translation = e, new $d7238066c5de7f1c$var$nr(t);
    }
    get Duration() {
        return this.privTranslationHypothesis.Duration;
    }
    get Offset() {
        return this.privTranslationHypothesis.Offset;
    }
    get Text() {
        return this.privTranslationHypothesis.Text;
    }
    get Translation() {
        return this.privTranslationHypothesis.Translation;
    }
    get Language() {
        var e;
        return (e = this.privTranslationHypothesis.PrimaryLanguage) === null || e === void 0 ? void 0 : e.Language;
    }
}
class $d7238066c5de7f1c$var$gi {
    constructor(e){
        this.privTranslationPhrase = e, this.privTranslationPhrase.RecognitionStatus = $d7238066c5de7f1c$var$H[this.privTranslationPhrase.RecognitionStatus], this.privTranslationPhrase.Translation !== void 0 && (this.privTranslationPhrase.Translation.TranslationStatus = $d7238066c5de7f1c$var$Zi[this.privTranslationPhrase.Translation.TranslationStatus]);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$gi(JSON.parse(e));
    }
    static fromTranslationResponse(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "translationResponse");
        const t = e.SpeechPhrase;
        return e.SpeechPhrase = void 0, t.Translation = e, t.Text = t.DisplayText, new $d7238066c5de7f1c$var$gi(t);
    }
    get RecognitionStatus() {
        return this.privTranslationPhrase.RecognitionStatus;
    }
    get Offset() {
        return this.privTranslationPhrase.Offset;
    }
    get Duration() {
        return this.privTranslationPhrase.Duration;
    }
    get Text() {
        return this.privTranslationPhrase.Text;
    }
    get Language() {
        var e;
        return (e = this.privTranslationPhrase.PrimaryLanguage) === null || e === void 0 ? void 0 : e.Language;
    }
    get Confidence() {
        var e;
        return (e = this.privTranslationPhrase.PrimaryLanguage) === null || e === void 0 ? void 0 : e.Confidence;
    }
    get Translation() {
        return this.privTranslationPhrase.Translation;
    }
}
var $d7238066c5de7f1c$var$Za = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Fl extends $d7238066c5de7f1c$var$oh {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privTranslationRecognizer = s, this.connectionEvents.attach((o)=>{
            o.name === "ConnectionEstablishedEvent" && this.privTranslationRecognizer.onConnection();
        });
    }
    processTypeSpecificMessages(e) {
        return $d7238066c5de7f1c$var$Za(this, void 0, void 0, function*() {
            const t = new $d7238066c5de7f1c$var$U();
            let i = yield this.processSpeechMessages(e);
            if (i) return !0;
            const n = (o)=>$d7238066c5de7f1c$var$Za(this, void 0, void 0, function*() {
                    if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + o.Offset + o.Duration), o.RecognitionStatus === $d7238066c5de7f1c$var$H.Success) {
                        const c = this.fireEventForResult(o, t);
                        if (this.privTranslationRecognizer.recognized) try {
                            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, c);
                        } catch  {}
                        if (this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(c.result);
                            } catch (p) {
                                this.privErrorCallback && this.privErrorCallback(p);
                            }
                            this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                        }
                    } else {
                        const c = $d7238066c5de7f1c$var$he.implTranslateRecognitionResult(o.RecognitionStatus), p = new $d7238066c5de7f1c$var$yt(void 0, this.privRequestSession.requestId, c, o.Text, o.Duration, this.privRequestSession.currentTurnAudioOffset + o.Offset, o.Language, o.Confidence, void 0, e.textBody, t);
                        if (c === $d7238066c5de7f1c$var$R.Canceled) {
                            const h = $d7238066c5de7f1c$var$he.implTranslateCancelResult(o.RecognitionStatus), a = $d7238066c5de7f1c$var$he.implTranslateCancelErrorCode(o.RecognitionStatus);
                            yield this.cancelRecognitionLocal(h, a, $d7238066c5de7f1c$var$he.implTranslateErrorDetails(a));
                        } else {
                            if (!(this.privRequestSession.isSpeechEnded && c === $d7238066c5de7f1c$var$R.NoMatch && o.RecognitionStatus !== $d7238066c5de7f1c$var$H.InitialSilenceTimeout)) {
                                const h = new $d7238066c5de7f1c$var$Ui(p, p.offset, this.privRequestSession.sessionId);
                                if (this.privTranslationRecognizer.recognized) try {
                                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, h);
                                } catch  {}
                            }
                            if (this.privSuccessCallback) {
                                try {
                                    this.privSuccessCallback(p);
                                } catch (h) {
                                    this.privErrorCallback && this.privErrorCallback(h);
                                }
                                this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                            }
                        }
                        i = !0;
                    }
                }), s = (o, c)=>{
                const p = this.fireEventForResult(o, c);
                if (this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + p.offset), this.privTranslationRecognizer.recognizing) try {
                    this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, p);
                } catch  {}
                i = !0;
            };
            switch(e.messageType === $d7238066c5de7f1c$var$k.Text && t.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_JsonResult, e.textBody), e.path.toLowerCase()){
                case "translation.hypothesis":
                    s($d7238066c5de7f1c$var$nr.fromJSON(e.textBody), t);
                    break;
                case "translation.response":
                    const o = JSON.parse(e.textBody);
                    if (o.SpeechPhrase) yield n($d7238066c5de7f1c$var$gi.fromTranslationResponse(o));
                    else {
                        const p = JSON.parse(e.textBody);
                        p.SpeechHypothesis && s($d7238066c5de7f1c$var$nr.fromTranslationResponse(p), t);
                    }
                    break;
                case "translation.phrase":
                    yield n($d7238066c5de7f1c$var$gi.fromJSON(e.textBody));
                    break;
                case "translation.synthesis":
                    this.sendSynthesisAudio(e.binaryBody, this.privRequestSession.sessionId), i = !0;
                    break;
                case "audio.end":
                case "translation.synthesis.end":
                    const c = $d7238066c5de7f1c$var$Qo.fromJSON(e.textBody);
                    switch(c.SynthesisStatus){
                        case $d7238066c5de7f1c$var$Ci.Error:
                            if (this.privTranslationRecognizer.synthesizing) {
                                const p = new $d7238066c5de7f1c$var$$s($d7238066c5de7f1c$var$R.Canceled, void 0), h = new $d7238066c5de7f1c$var$Ls(p, this.privRequestSession.sessionId);
                                try {
                                    this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, h);
                                } catch  {}
                            }
                            if (this.privTranslationRecognizer.canceled) {
                                const p = new $d7238066c5de7f1c$var$Bs(this.privRequestSession.sessionId, $d7238066c5de7f1c$var$X.Error, c.FailureReason, $d7238066c5de7f1c$var$T.ServiceError, null);
                                try {
                                    this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, p);
                                } catch  {}
                            }
                            break;
                        case $d7238066c5de7f1c$var$Ci.Success:
                            this.sendSynthesisAudio(void 0, this.privRequestSession.sessionId);
                            break;
                    }
                    i = !0;
                    break;
            }
            return i;
        });
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        const o = new $d7238066c5de7f1c$var$U();
        if (o.setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[n]), this.privTranslationRecognizer.canceled) {
            const c = new $d7238066c5de7f1c$var$Bs(e, i, s, n, void 0);
            try {
                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, c);
            } catch  {}
        }
        if (this.privSuccessCallback) {
            const c = new $d7238066c5de7f1c$var$yt(void 0, // Translations
            t, $d7238066c5de7f1c$var$R.Canceled, void 0, // Text
            void 0, // Druation
            void 0, // Offset
            void 0, // Language
            void 0, // LanguageDetectionConfidence
            s, void 0, // Json
            o);
            try {
                this.privSuccessCallback(c), this.privSuccessCallback = void 0;
            } catch  {}
        }
    }
    handleRecognizingCallback(e, t, i) {
        try {
            const n = new $d7238066c5de7f1c$var$Ui($d7238066c5de7f1c$var$yt.fromSpeechRecognitionResult(e), t, i);
            this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, n);
        } catch  {}
    }
    handleRecognizedCallback(e, t, i) {
        try {
            const n = new $d7238066c5de7f1c$var$Ui($d7238066c5de7f1c$var$yt.fromSpeechRecognitionResult(e), t, i);
            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, n);
        } catch  {}
    }
    fireEventForResult(e, t) {
        let i;
        if (e.Translation.Translations !== void 0) {
            i = new $d7238066c5de7f1c$var$zo();
            for (const a of e.Translation.Translations)i.set(a.Language, a.Text || a.DisplayText);
        }
        let n, s;
        e instanceof $d7238066c5de7f1c$var$gi ? (e.Translation && e.Translation.TranslationStatus === $d7238066c5de7f1c$var$Zi.Success ? n = $d7238066c5de7f1c$var$R.TranslatedSpeech : n = $d7238066c5de7f1c$var$R.RecognizedSpeech, s = e.Confidence) : n = $d7238066c5de7f1c$var$R.TranslatingSpeech;
        const o = e.Language, c = e.Offset + this.privRequestSession.currentTurnAudioOffset, p = new $d7238066c5de7f1c$var$yt(i, this.privRequestSession.requestId, n, e.Text, e.Duration, c, o, s, e.Translation.FailureReason, JSON.stringify(e), t);
        return new $d7238066c5de7f1c$var$Ui(p, c, this.privRequestSession.sessionId);
    }
    sendSynthesisAudio(e, t) {
        const i = e === void 0 ? $d7238066c5de7f1c$var$R.SynthesizingAudioCompleted : $d7238066c5de7f1c$var$R.SynthesizingAudio, n = new $d7238066c5de7f1c$var$$s(i, e), s = new $d7238066c5de7f1c$var$Ls(n, t);
        if (this.privTranslationRecognizer.synthesizing) try {
            this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, s);
        } catch  {}
    }
}
class $d7238066c5de7f1c$var$wi {
    constructor(e){
        this.privSpeechStartDetected = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$wi(e);
    }
    get Offset() {
        return this.privSpeechStartDetected.Offset;
    }
}
class $d7238066c5de7f1c$var$Zt {
    constructor(e){
        this.privSpeechHypothesis = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$Zt(e);
    }
    get Text() {
        return this.privSpeechHypothesis.Text;
    }
    get Offset() {
        return this.privSpeechHypothesis.Offset;
    }
    get Duration() {
        return this.privSpeechHypothesis.Duration;
    }
    get Language() {
        return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSpeechHypothesis.SpeakerId;
    }
}
class $d7238066c5de7f1c$var$Yo {
    constructor(e){
        this.privSpeechKeyword = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$Yo(e);
    }
    get Status() {
        return this.privSpeechKeyword.Status;
    }
    get Text() {
        return this.privSpeechKeyword.Text;
    }
    get Offset() {
        return this.privSpeechKeyword.Offset;
    }
    get Duration() {
        return this.privSpeechKeyword.Duration;
    }
}
var $d7238066c5de7f1c$var$Vl = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Kl extends $d7238066c5de7f1c$var$Ie {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privSpeechRecognizer = s;
    }
    processTypeSpecificMessages(e) {
        return $d7238066c5de7f1c$var$Vl(this, void 0, void 0, function*() {
            let t;
            const i = new $d7238066c5de7f1c$var$U();
            i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_JsonResult, e.textBody);
            let n = !1;
            switch(e.path.toLowerCase()){
                case "speech.hypothesis":
                case "speech.fragment":
                    const s = $d7238066c5de7f1c$var$Zt.fromJSON(e.textBody), o = s.Offset + this.privRequestSession.currentTurnAudioOffset;
                    t = new $d7238066c5de7f1c$var$Oe(this.privRequestSession.requestId, $d7238066c5de7f1c$var$R.RecognizingSpeech, s.Text, s.Duration, o, s.Language, s.LanguageDetectionConfidence, void 0, // Speaker Id
                    void 0, e.textBody, i), this.privRequestSession.onHypothesis(o);
                    const c = new $d7238066c5de7f1c$var$Rt(t, s.Duration, this.privRequestSession.sessionId);
                    if (this.privSpeechRecognizer.recognizing) try {
                        this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, c);
                    } catch  {}
                    n = !0;
                    break;
                case "speech.phrase":
                    const p = $d7238066c5de7f1c$var$kt.fromJSON(e.textBody), h = $d7238066c5de7f1c$var$he.implTranslateRecognitionResult(p.RecognitionStatus);
                    if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + p.Offset + p.Duration), $d7238066c5de7f1c$var$R.Canceled === h) {
                        const a = $d7238066c5de7f1c$var$he.implTranslateCancelResult(p.RecognitionStatus), d = $d7238066c5de7f1c$var$he.implTranslateCancelErrorCode(p.RecognitionStatus);
                        yield this.cancelRecognitionLocal(a, d, $d7238066c5de7f1c$var$he.implTranslateErrorDetails(d));
                    } else {
                        if (!(this.privRequestSession.isSpeechEnded && h === $d7238066c5de7f1c$var$R.NoMatch && p.RecognitionStatus !== $d7238066c5de7f1c$var$H.InitialSilenceTimeout)) {
                            if (this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$$e) === $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple]) t = new $d7238066c5de7f1c$var$Oe(this.privRequestSession.requestId, h, p.DisplayText, p.Duration, p.Offset + this.privRequestSession.currentTurnAudioOffset, p.Language, p.LanguageDetectionConfidence, void 0, // Speaker Id
                            void 0, e.textBody, i);
                            else {
                                const d = $d7238066c5de7f1c$var$gr.fromJSON(e.textBody), v = d.Offset + this.privRequestSession.currentTurnAudioOffset, g = d.getJsonWithCorrectedOffsets(v);
                                t = new $d7238066c5de7f1c$var$Oe(this.privRequestSession.requestId, h, d.RecognitionStatus === $d7238066c5de7f1c$var$H.Success ? d.NBest[0].Display : void 0, d.Duration, v, d.Language, d.LanguageDetectionConfidence, void 0, // Speaker Id
                                void 0, g, i);
                            }
                            const a = new $d7238066c5de7f1c$var$Rt(t, t.offset, this.privRequestSession.sessionId);
                            if (this.privSpeechRecognizer.recognized) try {
                                this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, a);
                            } catch  {}
                        }
                        if (this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(t);
                            } catch (a) {
                                this.privErrorCallback && this.privErrorCallback(a);
                            }
                            this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                        }
                    }
                    n = !0;
                    break;
            }
            return n;
        });
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        const o = new $d7238066c5de7f1c$var$U();
        if (o.setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[n]), this.privSpeechRecognizer.canceled) {
            const c = new $d7238066c5de7f1c$var$Ao(i, s, n, void 0, e);
            try {
                this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, c);
            } catch  {}
        }
        if (this.privSuccessCallback) {
            const c = new $d7238066c5de7f1c$var$Oe(t, $d7238066c5de7f1c$var$R.Canceled, void 0, // Text
            void 0, // Duration
            void 0, // Offset
            void 0, // Language
            void 0, // Language Detection Confidence
            void 0, // Speaker Id
            s, void 0, // Json
            o);
            try {
                this.privSuccessCallback(c), this.privSuccessCallback = void 0;
            } catch  {}
        }
    }
}
var $d7238066c5de7f1c$var$jl = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Jl extends $d7238066c5de7f1c$var$Ie {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privConversationTranscriber = s, this.setSpeakerDiarizationJson();
    }
    setSpeakerDiarizationJson() {
        if (this.privEnableSpeakerId) {
            const e = this.privSpeechContext.getSection("phraseDetection");
            e.mode = "Conversation";
            const t = {};
            t.mode = "Anonymous", t.audioSessionId = this.privDiarizationSessionId, t.audioOffsetMs = 0, e.speakerDiarization = t, this.privSpeechContext.setSection("phraseDetection", e);
        }
    }
    processTypeSpecificMessages(e) {
        return $d7238066c5de7f1c$var$jl(this, void 0, void 0, function*() {
            let t;
            const i = new $d7238066c5de7f1c$var$U();
            i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_JsonResult, e.textBody);
            let n = !1;
            switch(e.path.toLowerCase()){
                case "speech.hypothesis":
                case "speech.fragment":
                    const s = $d7238066c5de7f1c$var$Zt.fromJSON(e.textBody), o = s.Offset + this.privRequestSession.currentTurnAudioOffset;
                    t = new $d7238066c5de7f1c$var$Vr(this.privRequestSession.requestId, $d7238066c5de7f1c$var$R.RecognizingSpeech, s.Text, s.Duration, o, s.Language, s.LanguageDetectionConfidence, void 0, // Speaker Id
                    void 0, e.textBody, i), this.privRequestSession.onHypothesis(o);
                    const c = new $d7238066c5de7f1c$var$_s(t, s.Duration, this.privRequestSession.sessionId);
                    if (this.privConversationTranscriber.transcribing) try {
                        this.privConversationTranscriber.transcribing(this.privConversationTranscriber, c);
                    } catch  {}
                    n = !0;
                    break;
                case "speech.phrase":
                    const p = $d7238066c5de7f1c$var$kt.fromJSON(e.textBody), h = $d7238066c5de7f1c$var$he.implTranslateRecognitionResult(p.RecognitionStatus);
                    if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + p.Offset + p.Duration), $d7238066c5de7f1c$var$R.Canceled === h) {
                        const a = $d7238066c5de7f1c$var$he.implTranslateCancelResult(p.RecognitionStatus), d = $d7238066c5de7f1c$var$he.implTranslateCancelErrorCode(p.RecognitionStatus);
                        yield this.cancelRecognitionLocal(a, d, $d7238066c5de7f1c$var$he.implTranslateErrorDetails(d));
                    } else if (!(this.privRequestSession.isSpeechEnded && h === $d7238066c5de7f1c$var$R.NoMatch && p.RecognitionStatus !== $d7238066c5de7f1c$var$H.InitialSilenceTimeout)) {
                        if (this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$$e) === $d7238066c5de7f1c$var$B[$d7238066c5de7f1c$var$B.Simple]) t = new $d7238066c5de7f1c$var$Vr(this.privRequestSession.requestId, h, p.DisplayText, p.Duration, p.Offset + this.privRequestSession.currentTurnAudioOffset, p.Language, p.LanguageDetectionConfidence, p.SpeakerId, void 0, e.textBody, i);
                        else {
                            const d = $d7238066c5de7f1c$var$gr.fromJSON(e.textBody), v = d.Offset + this.privRequestSession.currentTurnAudioOffset, g = d.getJsonWithCorrectedOffsets(v);
                            t = new $d7238066c5de7f1c$var$Vr(this.privRequestSession.requestId, h, d.RecognitionStatus === $d7238066c5de7f1c$var$H.Success ? d.NBest[0].Display : void 0, d.Duration, v, d.Language, d.LanguageDetectionConfidence, p.SpeakerId, void 0, g, i);
                        }
                        const a = new $d7238066c5de7f1c$var$_s(t, t.offset, this.privRequestSession.sessionId);
                        if (this.privConversationTranscriber.transcribed) try {
                            this.privConversationTranscriber.transcribed(this.privConversationTranscriber, a);
                        } catch  {}
                    }
                    n = !0;
                    break;
            }
            return n;
        });
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        if (new $d7238066c5de7f1c$var$U().setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[n]), this.privConversationTranscriber.canceled) {
            const c = new $d7238066c5de7f1c$var$Ko(i, s, n, void 0, e);
            try {
                this.privConversationTranscriber.canceled(this.privConversationTranscriber, c);
            } catch  {}
        }
    }
}
var $d7238066c5de7f1c$var$jn = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Gl extends $d7238066c5de7f1c$var$oh {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privTranscriberRecognizer = s, this.sendPrePayloadJSONOverride = (o)=>this.sendTranscriptionStartJSON(o), this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_RequestWordLevelTimestamps) === "true" && this.privSpeechContext.setWordLevelTimings();
    }
    sendSpeechEventAsync(e, t) {
        return $d7238066c5de7f1c$var$jn(this, void 0, void 0, function*() {
            if (this.privRequestSession.isRecognizing) {
                const i = yield this.fetchConnection();
                yield this.sendSpeechEvent(i, this.createSpeechEventPayload(e, t));
            }
        });
    }
    sendMeetingSpeechEventAsync(e, t) {
        return $d7238066c5de7f1c$var$jn(this, void 0, void 0, function*() {
            if (this.privRequestSession.isRecognizing) {
                const i = yield this.fetchConnection();
                yield this.sendSpeechEvent(i, this.createMeetingSpeechEventPayload(e, t));
            }
        });
    }
    processTypeSpecificMessages(e) {
        return this.processSpeechMessages(e);
    }
    handleRecognizedCallback(e, t, i) {
        try {
            const n = new $d7238066c5de7f1c$var$Rt(e, t, i);
            if (this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, n), this.privSuccessCallback) {
                try {
                    this.privSuccessCallback(e);
                } catch (s) {
                    this.privErrorCallback && this.privErrorCallback(s);
                }
                this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
            }
        } catch  {}
    }
    handleRecognizingCallback(e, t, i) {
        try {
            const n = new $d7238066c5de7f1c$var$Rt(e, t, i);
            this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, n);
        } catch  {}
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        const o = new $d7238066c5de7f1c$var$U();
        if (o.setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[n]), this.privTranscriberRecognizer.IsMeetingRecognizer()) {
            if (this.privTranscriberRecognizer.canceled) {
                const c = new $d7238066c5de7f1c$var$Zp(i, s, n, void 0, e);
                try {
                    this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, c);
                } catch  {}
            }
        } else if (this.privTranscriberRecognizer.canceled) {
            const c = new $d7238066c5de7f1c$var$Ko(i, s, n, void 0, e);
            try {
                this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, c);
            } catch  {}
        }
        if (this.privSuccessCallback) {
            const c = new $d7238066c5de7f1c$var$Oe(t, $d7238066c5de7f1c$var$R.Canceled, void 0, // Text
            void 0, // Duration
            void 0, // Offset
            void 0, // Language
            void 0, // Language Detection Confidence
            void 0, // Speaker Id
            s, void 0, // Json
            o);
            try {
                this.privSuccessCallback(c), this.privSuccessCallback = void 0;
            } catch  {}
        }
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    sendTranscriptionStartJSON(e) {
        return $d7238066c5de7f1c$var$jn(this, void 0, void 0, function*() {
            if (yield this.sendSpeechContext(e, !0), this.privTranscriberRecognizer.IsMeetingRecognizer()) {
                const t = this.privTranscriberRecognizer.getMeetingInfo(), i = this.createMeetingSpeechEventPayload(t, "start");
                yield this.sendSpeechEvent(e, i);
            } else {
                const t = this.privTranscriberRecognizer.getConversationInfo(), i = this.createSpeechEventPayload(t, "start");
                yield this.sendSpeechEvent(e, i);
            }
            yield this.sendWaveHeader(e);
        });
    }
    sendSpeechEvent(e, t) {
        const i = JSON.stringify(t);
        if (i) return e.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "speech.event", this.privRequestSession.requestId, "application/json", i));
    }
    createSpeechEventPayload(e, t) {
        const i = {
            id: "meeting",
            name: t,
            meeting: e.conversationProperties
        };
        return i.meeting.id = e.id, i.meeting.attendees = e.participants, i;
    }
    createMeetingSpeechEventPayload(e, t) {
        const i = {
            id: "meeting",
            name: t,
            meeting: e.meetingProperties
        };
        return i.meeting.id = e.id, i.meeting.attendees = e.participants, i;
    }
}
class $d7238066c5de7f1c$var$gr {
    constructor(e){
        this.privDetailedSpeechPhrase = JSON.parse(e), this.privDetailedSpeechPhrase.RecognitionStatus = $d7238066c5de7f1c$var$H[this.privDetailedSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$gr(e);
    }
    getJsonWithCorrectedOffsets(e) {
        if (this.privDetailedSpeechPhrase.NBest) {
            let t;
            for (const i of this.privDetailedSpeechPhrase.NBest)if (i.Words && i.Words[0]) {
                t = i.Words[0].Offset;
                break;
            }
            if (t && t < e) {
                const i = e - t;
                for (const n of this.privDetailedSpeechPhrase.NBest){
                    if (n.Words) for (const s of n.Words)s.Offset += i;
                    if (n.DisplayWords) for (const s of n.DisplayWords)s.Offset += i;
                }
            }
        }
        return JSON.stringify(this.privDetailedSpeechPhrase);
    }
    get RecognitionStatus() {
        return this.privDetailedSpeechPhrase.RecognitionStatus;
    }
    get NBest() {
        return this.privDetailedSpeechPhrase.NBest;
    }
    get Duration() {
        return this.privDetailedSpeechPhrase.Duration;
    }
    get Offset() {
        return this.privDetailedSpeechPhrase.Offset;
    }
    get Language() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get Text() {
        return this.privDetailedSpeechPhrase.NBest && this.privDetailedSpeechPhrase.NBest[0] ? this.privDetailedSpeechPhrase.NBest[0].Display || this.privDetailedSpeechPhrase.NBest[0].DisplayText : this.privDetailedSpeechPhrase.DisplayText;
    }
    get SpeakerId() {
        return this.privDetailedSpeechPhrase.SpeakerId;
    }
}
class $d7238066c5de7f1c$var$kt {
    constructor(e){
        this.privSimpleSpeechPhrase = JSON.parse(e), this.privSimpleSpeechPhrase.RecognitionStatus = $d7238066c5de7f1c$var$H[this.privSimpleSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$kt(e);
    }
    get RecognitionStatus() {
        return this.privSimpleSpeechPhrase.RecognitionStatus;
    }
    get DisplayText() {
        return this.privSimpleSpeechPhrase.DisplayText;
    }
    get Offset() {
        return this.privSimpleSpeechPhrase.Offset;
    }
    get Duration() {
        return this.privSimpleSpeechPhrase.Duration;
    }
    get Language() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSimpleSpeechPhrase.SpeakerId;
    }
}
class $d7238066c5de7f1c$var$Xa {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param modelImpl - The model.
   * @param intentName - The intent name.
   */ constructor(e, t){
        this.modelImpl = e, this.intentName = t;
    }
}
class $d7238066c5de7f1c$var$Ql extends $d7238066c5de7f1c$var$Ie {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privIntentRecognizer = s, this.privIntentDataSent = !1;
    }
    setIntents(e, t) {
        this.privAddedLmIntents = e, this.privUmbrellaIntent = t, this.privIntentDataSent = !0;
    }
    processTypeSpecificMessages(e) {
        let t, i, n = !1;
        const s = new $d7238066c5de7f1c$var$U();
        switch(e.messageType === $d7238066c5de7f1c$var$k.Text && s.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_JsonResult, e.textBody), e.path.toLowerCase()){
            case "speech.hypothesis":
                const c = $d7238066c5de7f1c$var$Zt.fromJSON(e.textBody);
                if (t = new $d7238066c5de7f1c$var$hi(void 0, this.privRequestSession.requestId, $d7238066c5de7f1c$var$R.RecognizingIntent, c.Text, c.Duration, c.Offset + this.privRequestSession.currentTurnAudioOffset, c.Language, c.LanguageDetectionConfidence, void 0, e.textBody, s), this.privRequestSession.onHypothesis(t.offset), i = new $d7238066c5de7f1c$var$ui(t, c.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId), this.privIntentRecognizer.recognizing) try {
                    this.privIntentRecognizer.recognizing(this.privIntentRecognizer, i);
                } catch  {}
                n = !0;
                break;
            case "speech.phrase":
                const p = $d7238066c5de7f1c$var$kt.fromJSON(e.textBody);
                t = new $d7238066c5de7f1c$var$hi(void 0, this.privRequestSession.requestId, $d7238066c5de7f1c$var$he.implTranslateRecognitionResult(p.RecognitionStatus), p.DisplayText, p.Duration, p.Offset + this.privRequestSession.currentTurnAudioOffset, p.Language, p.LanguageDetectionConfidence, void 0, e.textBody, s), i = new $d7238066c5de7f1c$var$ui(t, t.offset, this.privRequestSession.sessionId);
                const h = ()=>{
                    if (this.privIntentRecognizer.recognized) try {
                        this.privIntentRecognizer.recognized(this.privIntentRecognizer, i);
                    } catch  {}
                    if (this.privSuccessCallback) {
                        try {
                            this.privSuccessCallback(t);
                        } catch (d) {
                            this.privErrorCallback && this.privErrorCallback(d);
                        }
                        this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                    }
                };
                this.privIntentDataSent === !1 || $d7238066c5de7f1c$var$R.NoMatch === i.result.reason ? (this.privRequestSession.onPhraseRecognized(i.offset + i.result.duration), h()) : this.privPendingIntentArgs = i, n = !0;
                break;
            case "response":
                if (i = this.privPendingIntentArgs, this.privPendingIntentArgs = void 0, i === void 0) {
                    if (e.textBody === "") return;
                    i = new $d7238066c5de7f1c$var$ui(new $d7238066c5de7f1c$var$hi(), 0, this.privRequestSession.sessionId);
                }
                const a = $d7238066c5de7f1c$var$Zo.fromJSON(e.textBody);
                if (a !== null && a.topScoringIntent && a.topScoringIntent.intent) {
                    let d = this.privAddedLmIntents[a.topScoringIntent.intent];
                    if (this.privUmbrellaIntent !== void 0 && (d = this.privUmbrellaIntent), d) {
                        const v = d === void 0 || d.intentName === void 0 ? a.topScoringIntent.intent : d.intentName;
                        let g = i.result.reason;
                        v !== void 0 && (g = $d7238066c5de7f1c$var$R.RecognizedIntent);
                        const I = i.result.properties !== void 0 ? i.result.properties : new $d7238066c5de7f1c$var$U();
                        I.setProperty($d7238066c5de7f1c$var$u.LanguageUnderstandingServiceResponse_JsonResult, e.textBody), i = new $d7238066c5de7f1c$var$ui(new $d7238066c5de7f1c$var$hi(v, i.result.resultId, g, i.result.text, i.result.duration, i.result.offset, void 0, void 0, i.result.errorDetails, i.result.json, I), i.offset, i.sessionId);
                    }
                }
                if (this.privRequestSession.onPhraseRecognized(i.offset + i.result.duration), this.privIntentRecognizer.recognized) try {
                    this.privIntentRecognizer.recognized(this.privIntentRecognizer, i);
                } catch  {}
                if (this.privSuccessCallback) {
                    try {
                        this.privSuccessCallback(i.result);
                    } catch (d) {
                        this.privErrorCallback && this.privErrorCallback(d);
                    }
                    this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                }
                n = !0;
                break;
        }
        const o = new $d7238066c5de7f1c$var$F();
        return o.resolve(n), o.promise;
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        const o = new $d7238066c5de7f1c$var$U();
        if (o.setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[n]), this.privIntentRecognizer.canceled) {
            const c = new $d7238066c5de7f1c$var$$p(i, s, n, void 0, void 0, e);
            try {
                this.privIntentRecognizer.canceled(this.privIntentRecognizer, c);
            } catch  {}
        }
        if (this.privSuccessCallback) {
            const c = new $d7238066c5de7f1c$var$hi(void 0, // Intent Id
            t, $d7238066c5de7f1c$var$R.Canceled, void 0, // Text
            void 0, // Duration
            void 0, // Offset
            void 0, // Language
            void 0, // LanguageDetectionConfidence
            s, void 0, // Json
            o);
            try {
                this.privSuccessCallback(c), this.privSuccessCallback = void 0;
            } catch  {}
        }
    }
}
class $d7238066c5de7f1c$var$Zo {
    constructor(e){
        e === "" ? this.privIntentResponse = {} : this.privIntentResponse = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$Zo(e);
    }
    get query() {
        return this.privIntentResponse.query;
    }
    get topScoringIntent() {
        return this.privIntentResponse.topScoringIntent;
    }
    get entities() {
        return this.privIntentResponse.entities;
    }
}
class $d7238066c5de7f1c$var$Yl {
    constructor(e, t, i){
        this.privIsDisposed = !1, this.privListeningTriggerMetric = null, this.privMicMetric = null, this.privConnectionEstablishMetric = null, this.privRequestId = e, this.privAudioSourceId = t, this.privAudioNodeId = i, this.privReceivedMessages = {}, this.privPhraseLatencies = [], this.privHypothesisLatencies = [];
    }
    phraseReceived(e) {
        e > 0 && this.privPhraseLatencies.push(Date.now() - e);
    }
    hypothesisReceived(e) {
        e > 0 && this.privHypothesisLatencies.push(Date.now() - e);
    }
    onEvent(e) {
        this.privIsDisposed || (e instanceof $d7238066c5de7f1c$var$nh && e.requestId === this.privRequestId && (this.privListeningTriggerMetric = {
            End: e.eventTime,
            Name: "ListeningTrigger",
            Start: e.eventTime
        }), e instanceof $d7238066c5de7f1c$var$pr && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId && (this.privMicStartTime = e.eventTime), e instanceof $d7238066c5de7f1c$var$hr && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId && (this.privMicStartTime = e.eventTime), e instanceof $d7238066c5de7f1c$var$Yr && e.audioSourceId === this.privAudioSourceId && (this.privMicMetric || (this.privMicMetric = {
            End: e.eventTime,
            Error: e.error,
            Name: "Microphone",
            Start: this.privMicStartTime
        })), e instanceof $d7238066c5de7f1c$var$So && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId && (this.privMicMetric || (this.privMicMetric = {
            End: e.eventTime,
            Error: e.error,
            Name: "Microphone",
            Start: this.privMicStartTime
        })), e instanceof $d7238066c5de7f1c$var$Pt && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId && (this.privMicMetric || (this.privMicMetric = {
            End: e.eventTime,
            Name: "Microphone",
            Start: this.privMicStartTime
        })), e instanceof $d7238066c5de7f1c$var$sh && e.requestId === this.privRequestId && (this.privConnectionId = e.sessionId), e instanceof $d7238066c5de7f1c$var$Dp && e.connectionId === this.privConnectionId && (this.privConnectionStartTime = e.eventTime), e instanceof $d7238066c5de7f1c$var$Op && e.connectionId === this.privConnectionId && (this.privConnectionEstablishMetric || (this.privConnectionEstablishMetric = {
            End: e.eventTime,
            Id: this.privConnectionId,
            Name: "Connection",
            Start: this.privConnectionStartTime
        })), e instanceof $d7238066c5de7f1c$var$Fd && e.connectionId === this.privConnectionId && (this.privConnectionEstablishMetric || (this.privConnectionEstablishMetric = {
            End: e.eventTime,
            Error: this.getConnectionError(e.statusCode),
            Id: this.privConnectionId,
            Name: "Connection",
            Start: this.privConnectionStartTime
        })), e instanceof $d7238066c5de7f1c$var$Ns && e.connectionId === this.privConnectionId && e.message && e.message.headers && e.message.headers.path && (this.privReceivedMessages[e.message.headers.path] || (this.privReceivedMessages[e.message.headers.path] = new Array()), this.privReceivedMessages[e.message.headers.path].length < 50 && this.privReceivedMessages[e.message.headers.path].push(e.networkReceivedTime)));
    }
    getTelemetry() {
        const e = new Array();
        this.privListeningTriggerMetric && e.push(this.privListeningTriggerMetric), this.privMicMetric && e.push(this.privMicMetric), this.privConnectionEstablishMetric && e.push(this.privConnectionEstablishMetric), this.privPhraseLatencies.length > 0 && e.push({
            PhraseLatencyMs: this.privPhraseLatencies
        }), this.privHypothesisLatencies.length > 0 && e.push({
            FirstHypothesisLatencyMs: this.privHypothesisLatencies
        });
        const t = {
            Metrics: e,
            ReceivedMessages: this.privReceivedMessages
        }, i = JSON.stringify(t);
        return this.privReceivedMessages = {}, this.privListeningTriggerMetric = null, this.privMicMetric = null, this.privConnectionEstablishMetric = null, this.privPhraseLatencies = [], this.privHypothesisLatencies = [], i;
    }
    // Determines if there are any telemetry events to send to the service.
    get hasTelemetry() {
        return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
    }
    dispose() {
        this.privIsDisposed = !0;
    }
    getConnectionError(e) {
        switch(e){
            case 400:
            case 1002:
            case 1003:
            case 1005:
            case 1007:
            case 1008:
            case 1009:
                return "BadRequest";
            case 401:
                return "Unauthorized";
            case 403:
                return "Forbidden";
            case 503:
            case 1001:
                return "ServerUnavailable";
            case 500:
            case 1011:
                return "ServerError";
            case 408:
            case 504:
                return "Timeout";
            default:
                return "statuscode:" + e.toString();
        }
    }
}
var $d7238066c5de7f1c$var$Nt = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Zl {
    constructor(e){
        this.privIsDisposed = !1, this.privDetachables = new Array(), this.privIsAudioNodeDetached = !1, this.privIsRecognizing = !1, this.privIsSpeechEnded = !1, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privHypothesisReceived = !1, this.privBytesSent = 0, this.privRecognitionBytesSent = 0, this.privRecogNumber = 0, this.privInTurn = !1, this.privConnectionAttempts = 0, this.privAudioSourceId = e, this.privRequestId = $d7238066c5de7f1c$var$ee(), this.privAudioNodeId = $d7238066c5de7f1c$var$ee(), this.privTurnDeferral = new $d7238066c5de7f1c$var$F(), this.privTurnDeferral.resolve();
    }
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSpeechEnded() {
        return this.privIsSpeechEnded;
    }
    get isRecognizing() {
        return this.privIsRecognizing;
    }
    get currentTurnAudioOffset() {
        return this.privTurnStartAudioOffset;
    }
    get recogNumber() {
        return this.privRecogNumber;
    }
    get numConnectionAttempts() {
        return this.privConnectionAttempts;
    }
    // The number of bytes sent for the current connection.
    // Counter is reset to 0 each time a connection is established.
    get bytesSent() {
        return this.privBytesSent;
    }
    // The number of bytes sent for the current recognition.
    // Counter is reset to 0 each time recognition is started.
    get recognitionBytesSent() {
        return this.privRecognitionBytesSent;
    }
    listenForServiceTelemetry(e) {
        this.privServiceTelemetryListener && this.privDetachables.push(e.attachListener(this.privServiceTelemetryListener));
    }
    startNewRecognition() {
        this.privRecognitionBytesSent = 0, this.privIsSpeechEnded = !1, this.privIsRecognizing = !0, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privRecogNumber++, this.privServiceTelemetryListener = new $d7238066c5de7f1c$var$Yl(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId), this.onEvent(new $d7238066c5de7f1c$var$nh(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    onAudioSourceAttachCompleted(e, t) {
        return $d7238066c5de7f1c$var$Nt(this, void 0, void 0, function*() {
            this.privAudioNode = e, this.privIsAudioNodeDetached = !1, t ? yield this.onComplete() : this.onEvent(new $d7238066c5de7f1c$var$Ul(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
        });
    }
    onPreConnectionStart(e, t) {
        this.privAuthFetchEventId = e, this.privSessionId = t, this.onEvent(new $d7238066c5de7f1c$var$sh(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
    }
    onAuthCompleted(e) {
        return $d7238066c5de7f1c$var$Nt(this, void 0, void 0, function*() {
            e && (yield this.onComplete());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onConnectionEstablishCompleted(e, t) {
        return $d7238066c5de7f1c$var$Nt(this, void 0, void 0, function*() {
            if (e === 200) {
                this.onEvent(new $d7238066c5de7f1c$var$ql(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId)), this.privAudioNode && this.privAudioNode.replay(), this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privBytesSent = 0;
                return;
            } else e === 403 && (yield this.onComplete());
        });
    }
    onServiceTurnEndResponse(e) {
        return $d7238066c5de7f1c$var$Nt(this, void 0, void 0, function*() {
            this.privTurnDeferral.resolve(), !e || this.isSpeechEnded ? (yield this.onComplete(), this.privInTurn = !1) : (this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privAudioNode.replay());
        });
    }
    onSpeechContext() {
        this.privRequestId = $d7238066c5de7f1c$var$ee();
    }
    onServiceTurnStartResponse() {
        this.privTurnDeferral && this.privInTurn && (this.privTurnDeferral.reject("Another turn started before current completed."), this.privTurnDeferral.promise.then().catch(()=>{})), this.privInTurn = !0, this.privTurnDeferral = new $d7238066c5de7f1c$var$F();
    }
    onHypothesis(e) {
        this.privHypothesisReceived || (this.privHypothesisReceived = !0, this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(e)));
    }
    onPhraseRecognized(e) {
        this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(e)), this.onServiceRecognized(e);
    }
    onServiceRecognized(e) {
        this.privLastRecoOffset = e, this.privHypothesisReceived = !1, this.privAudioNode.shrinkBuffers(e), this.privConnectionAttempts = 0;
    }
    onAudioSent(e) {
        this.privBytesSent += e, this.privRecognitionBytesSent += e;
    }
    onRetryConnection() {
        this.privConnectionAttempts++;
    }
    dispose() {
        return $d7238066c5de7f1c$var$Nt(this, void 0, void 0, function*() {
            if (!this.privIsDisposed) {
                this.privIsDisposed = !0;
                for (const e of this.privDetachables)yield e.detach();
                this.privServiceTelemetryListener && this.privServiceTelemetryListener.dispose(), this.privIsRecognizing = !1;
            }
        });
    }
    getTelemetry() {
        return this.privServiceTelemetryListener.hasTelemetry ? this.privServiceTelemetryListener.getTelemetry() : null;
    }
    onStopRecognizing() {
        return $d7238066c5de7f1c$var$Nt(this, void 0, void 0, function*() {
            yield this.onComplete();
        });
    }
    // Should be called with the audioNode for this session has indicated that it is out of speech.
    onSpeechEnded() {
        this.privIsSpeechEnded = !0;
    }
    onEvent(e) {
        this.privServiceTelemetryListener && this.privServiceTelemetryListener.onEvent(e), $d7238066c5de7f1c$var$oe.instance.onEvent(e);
    }
    onComplete() {
        return $d7238066c5de7f1c$var$Nt(this, void 0, void 0, function*() {
            this.privIsRecognizing && (this.privIsRecognizing = !1, yield this.detachAudioNode());
        });
    }
    detachAudioNode() {
        return $d7238066c5de7f1c$var$Nt(this, void 0, void 0, function*() {
            this.privIsAudioNodeDetached || (this.privIsAudioNodeDetached = !0, this.privAudioNode && (yield this.privAudioNode.detach()));
        });
    }
}
class $d7238066c5de7f1c$var$Xl {
    constructor(e){
        this.privContext = {}, this.privDynamicGrammar = e;
    }
    /**
   * Gets a section of the speech.context object.
   * @param sectionName Name of the section to get.
   * @return string or Context JSON serializable object that represents the value.
   */ getSection(e) {
        return this.privContext[e] || {};
    }
    /**
   * Adds a section to the speech.context object.
   * @param sectionName Name of the section to add.
   * @param value JSON serializable object that represents the value.
   */ setSection(e, t) {
        this.privContext[e] = t;
    }
    /**
   * @Internal
   * This is only used by pronunciation assessment config.
   * Do not use externally, object returned will change without warning or notice.
   */ setPronunciationAssessmentParams(e, t, i = !1) {
        this.privContext.phraseDetection === void 0 && (this.privContext.phraseDetection = {
            enrichment: {
                pronunciationAssessment: {}
            }
        }), this.privContext.phraseDetection.enrichment === void 0 && (this.privContext.phraseDetection.enrichment = {
            pronunciationAssessment: {}
        }), this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(e), i && (this.privContext.phraseDetection.mode = "Conversation"), this.setWordLevelTimings(), this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment"), this.privContext.phraseOutput.detailed.options.indexOf("SNR") === -1 && this.privContext.phraseOutput.detailed.options.push("SNR"), t && (this.privContext.phraseDetection.enrichment.contentAssessment = {
            topic: t
        }, this.privContext.phraseOutput.detailed.options.push("ContentAssessment"));
    }
    setDetailedOutputFormat() {
        this.privContext.phraseOutput === void 0 && (this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        }), this.privContext.phraseOutput.detailed === void 0 && (this.privContext.phraseOutput.detailed = {
            options: []
        }), this.privContext.phraseOutput.format = "Detailed";
    }
    setWordLevelTimings() {
        this.privContext.phraseOutput === void 0 && (this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        }), this.privContext.phraseOutput.detailed === void 0 && (this.privContext.phraseOutput.detailed = {
            options: []
        }), this.privContext.phraseOutput.format = "Detailed", this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1 && this.privContext.phraseOutput.detailed.options.push("WordTimings");
    }
    setSpeakerDiarizationAudioOffsetMs(e) {
        this.privContext.phraseDetection.speakerDiarization.audioOffsetMs = e;
    }
    toJSON() {
        const e = this.privDynamicGrammar.generateGrammarObject();
        return this.setSection("dgi", e), JSON.stringify(this.privContext);
    }
}
class $d7238066c5de7f1c$var$ev {
    // Adds one more reference phrases to the dynamic grammar to send.
    // All added phrases are generic phrases.
    addPhrase(e) {
        this.privPhrases || (this.privPhrases = []), e instanceof Array ? this.privPhrases = this.privPhrases.concat(e) : this.privPhrases.push(e);
    }
    // Clears all phrases stored in the current object.
    clearPhrases() {
        this.privPhrases = void 0;
    }
    // Adds one or more reference grammars to the current grammar.
    addReferenceGrammar(e) {
        this.privGrammars || (this.privGrammars = []), e instanceof Array ? this.privGrammars = this.privGrammars.concat(e) : this.privGrammars.push(e);
    }
    // clears all grammars stored on the recognizer.
    clearGrammars() {
        this.privGrammars = void 0;
    }
    // Generates an object that represents the dynamic grammar used by the Speech Service.
    // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
    // of a DynamicGrammarBuilder
    generateGrammarObject() {
        if (this.privGrammars === void 0 && this.privPhrases === void 0) return;
        const e = {};
        if (e.ReferenceGrammars = this.privGrammars, this.privPhrases !== void 0 && this.privPhrases.length !== 0) {
            const t = [];
            this.privPhrases.forEach((i)=>{
                t.push({
                    Text: i
                });
            }), e.Groups = [
                {
                    Type: "Generic",
                    Items: t
                }
            ];
        }
        return e;
    }
}
class $d7238066c5de7f1c$var$Xo {
    constructor(e){
        this.privActivityResponse = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$Xo(e);
    }
    get conversationId() {
        return this.privActivityResponse.conversationId;
    }
    get messageDataStreamType() {
        return this.privActivityResponse.messageDataStreamType;
    }
    get messagePayload() {
        return this.privActivityResponse.messagePayload;
    }
    get version() {
        return this.privActivityResponse.version;
    }
}
var $d7238066c5de7f1c$var$Qs;
(function(r) {
    r[r.None = 0] = "None", r[r.TextToSpeechAudio = 1] = "TextToSpeechAudio";
})($d7238066c5de7f1c$var$Qs || ($d7238066c5de7f1c$var$Qs = {}));
class $d7238066c5de7f1c$var$tv {
    constructor(e, t){
        this.privRequestId = t, this.privIsCompleted = !1, this.privAudioStream = null, this.privTurnManager = e, this.resetTurnEndTimeout();
    }
    get audioStream() {
        return this.resetTurnEndTimeout(), this.privAudioStream;
    }
    processActivityPayload(e, t) {
        return e.messageDataStreamType === $d7238066c5de7f1c$var$Qs.TextToSpeechAudio && (this.privAudioStream = $d7238066c5de7f1c$var$vn.createPullStream(), this.privAudioStream.format = t !== void 0 ? t : $d7238066c5de7f1c$var$O.getDefaultOutputFormat()), this.privAudioStream;
    }
    endAudioStream() {
        this.privAudioStream !== null && !this.privAudioStream.isClosed && this.privAudioStream.close();
    }
    complete() {
        this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.endAudioStream();
    }
    resetTurnEndTimeout() {
        this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.privTimeoutToken = setTimeout(()=>{
            this.privTurnManager.CompleteTurn(this.privRequestId);
        }, 2e3);
    }
}
class $d7238066c5de7f1c$var$iv {
    constructor(){
        this.privTurnMap = /* @__PURE__ */ new Map();
    }
    StartTurn(e) {
        if (this.privTurnMap.has(e)) throw new $d7238066c5de7f1c$var$De("Service error: There is already a turn with id:" + e);
        const t = new $d7238066c5de7f1c$var$tv(this, e);
        return this.privTurnMap.set(e, t), this.privTurnMap.get(e);
    }
    GetTurn(e) {
        return this.privTurnMap.get(e);
    }
    CompleteTurn(e) {
        if (!this.privTurnMap.has(e)) throw new $d7238066c5de7f1c$var$De("Service error: Received turn end for an unknown turn id:" + e);
        const t = this.privTurnMap.get(e);
        return t.complete(), this.privTurnMap.delete(e), t;
    }
}
var $d7238066c5de7f1c$var$mt = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$rv extends $d7238066c5de7f1c$var$Ie {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privEvents = new $d7238066c5de7f1c$var$Ze(), this.privDialogServiceConnector = s, this.receiveMessageOverride = ()=>this.receiveDialogMessageOverride(), this.privTurnStateManager = new $d7238066c5de7f1c$var$iv(), this.recognizeOverride = (o, c, p)=>this.listenOnce(o, c, p), this.postConnectImplOverride = (o)=>this.dialogConnectImpl(o), this.configConnectionOverride = (o)=>this.configConnection(o), this.disconnectOverride = ()=>this.privDisconnect(), this.privDialogAudioSource = i, this.agentConfigSent = !1, this.privLastResult = null, this.connectionEvents.attach((o)=>{
            o.name === "ConnectionClosedEvent" && (this.terminateMessageLoop = !0);
        });
    }
    sendMessage(e) {
        return $d7238066c5de7f1c$var$mt(this, void 0, void 0, function*() {
            const t = $d7238066c5de7f1c$var$Qr(), i = $d7238066c5de7f1c$var$ee(), n = {
                context: {
                    interactionId: t
                },
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                messagePayload: JSON.parse(e),
                version: 0.5
            }, s = JSON.stringify(n);
            yield (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "agent", i, "application/json", s));
        });
    }
    privDisconnect() {
        return $d7238066c5de7f1c$var$mt(this, void 0, void 0, function*() {
            yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.NoError, "Disconnecting"), this.terminateMessageLoop = !0, this.agentConfigSent = !1;
        });
    }
    processTypeSpecificMessages(e) {
        const t = new $d7238066c5de7f1c$var$U();
        e.messageType === $d7238066c5de7f1c$var$k.Text && t.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_JsonResult, e.textBody);
        let i, n;
        switch(e.path.toLowerCase()){
            case "speech.phrase":
                const o = $d7238066c5de7f1c$var$kt.fromJSON(e.textBody);
                if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + o.Offset + o.Duration), o.RecognitionStatus !== $d7238066c5de7f1c$var$H.TooManyRequests && o.RecognitionStatus !== $d7238066c5de7f1c$var$H.Error) {
                    const v = this.fireEventForResult(o, t);
                    if (this.privLastResult = v.result, this.privDialogServiceConnector.recognized) try {
                        this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, v);
                    } catch  {}
                }
                n = !0;
                break;
            case "speech.hypothesis":
                const c = $d7238066c5de7f1c$var$Zt.fromJSON(e.textBody), p = c.Offset + this.privRequestSession.currentTurnAudioOffset;
                i = new $d7238066c5de7f1c$var$Oe(this.privRequestSession.requestId, $d7238066c5de7f1c$var$R.RecognizingSpeech, c.Text, c.Duration, p, c.Language, c.LanguageDetectionConfidence, void 0, void 0, e.textBody, t), this.privRequestSession.onHypothesis(p);
                const h = new $d7238066c5de7f1c$var$Rt(i, c.Duration, this.privRequestSession.sessionId);
                if (this.privDialogServiceConnector.recognizing) try {
                    this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, h);
                } catch  {}
                n = !0;
                break;
            case "speech.keyword":
                const a = $d7238066c5de7f1c$var$Yo.fromJSON(e.textBody);
                i = new $d7238066c5de7f1c$var$Oe(this.privRequestSession.requestId, a.Status === "Accepted" ? $d7238066c5de7f1c$var$R.RecognizedKeyword : $d7238066c5de7f1c$var$R.NoMatch, a.Text, a.Duration, a.Offset, void 0, void 0, void 0, void 0, e.textBody, t), a.Status !== "Accepted" && (this.privLastResult = i);
                const d = new $d7238066c5de7f1c$var$Rt(i, i.duration, i.resultId);
                if (this.privDialogServiceConnector.recognized) try {
                    this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, d);
                } catch  {}
                n = !0;
                break;
            case "audio":
                {
                    const v = e.requestId.toUpperCase(), g = this.privTurnStateManager.GetTurn(v);
                    try {
                        e.binaryBody ? g.audioStream.write(e.binaryBody) : g.endAudioStream();
                    } catch  {}
                }
                n = !0;
                break;
            case "response":
                this.handleResponseMessage(e), n = !0;
                break;
        }
        const s = new $d7238066c5de7f1c$var$F();
        return s.resolve(n), s.promise;
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        return $d7238066c5de7f1c$var$mt(this, void 0, void 0, function*() {
            if (this.terminateMessageLoop = !0, this.privRequestSession.isRecognizing && (yield this.privRequestSession.onStopRecognizing()), this.privDialogServiceConnector.canceled) {
                const o = new $d7238066c5de7f1c$var$U();
                o.setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[n]);
                const c = new $d7238066c5de7f1c$var$Ao(i, s, n, void 0, e);
                try {
                    this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, c);
                } catch  {}
                if (this.privSuccessCallback) {
                    const p = new $d7238066c5de7f1c$var$Oe(void 0, // ResultId
                    $d7238066c5de7f1c$var$R.Canceled, void 0, // Text
                    void 0, // Duration
                    void 0, // Offset
                    void 0, // Language
                    void 0, // Language Detection Confidence
                    void 0, // Speaker Id
                    s, void 0, // Json
                    o);
                    try {
                        this.privSuccessCallback(p), this.privSuccessCallback = void 0;
                    } catch  {}
                }
            }
        });
    }
    listenOnce(e, t, i) {
        return $d7238066c5de7f1c$var$mt(this, void 0, void 0, function*() {
            this.privRecognizerConfig.recognitionMode = e, this.privSuccessCallback = t, this.privErrorCallback = i, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events), this.privRecognizerConfig.parameters.setProperty($d7238066c5de7f1c$var$u.Speech_SessionId, this.privRequestSession.sessionId);
            const n = this.connectImpl(), s = this.sendPreAudioMessages(), o = yield this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId), c = yield this.privDialogAudioSource.format, p = yield this.privDialogAudioSource.deviceInfo, h = new $d7238066c5de7f1c$var$ln(o, c.avgBytesPerSec);
            yield this.privRequestSession.onAudioSourceAttachCompleted(h, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: p
            };
            try {
                yield n, yield s;
            } catch (v) {
                return yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.ConnectionFailure, v), Promise.resolve();
            }
            const a = new $d7238066c5de7f1c$var$Ce(this.privRequestSession.sessionId);
            this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, a), this.sendAudio(h).then(()=>{}, (v)=>$d7238066c5de7f1c$var$mt(this, void 0, void 0, function*() {
                    yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.RuntimeError, v);
                }));
        });
    }
    // Establishes a websocket connection to the end point.
    dialogConnectImpl(e) {
        return this.privConnectionLoop = this.startMessageLoop(), e;
    }
    receiveDialogMessageOverride() {
        const e = new $d7238066c5de7f1c$var$F(), t = ()=>$d7238066c5de7f1c$var$mt(this, void 0, void 0, function*() {
                try {
                    const i = this.isDisposed(), n = !this.isDisposed() && this.terminateMessageLoop;
                    if (i || n) {
                        e.resolve(void 0);
                        return;
                    }
                    const o = yield (yield this.fetchConnection()).read();
                    if (!o) return t();
                    const c = $d7238066c5de7f1c$var$se.fromConnectionMessage(o);
                    switch(c.path.toLowerCase()){
                        case "turn.start":
                            {
                                const I = c.requestId.toUpperCase(), A = this.privRequestSession.requestId.toUpperCase();
                                I !== A ? this.privTurnStateManager.StartTurn(I) : this.privRequestSession.onServiceTurnStartResponse();
                            }
                            break;
                        case "speech.startdetected":
                            const h = $d7238066c5de7f1c$var$wi.fromJSON(c.textBody), a = new $d7238066c5de7f1c$var$Xe(h.Offset, this.privRequestSession.sessionId);
                            this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, a);
                            break;
                        case "speech.enddetected":
                            let d;
                            c.textBody.length > 0 ? d = c.textBody : d = "{ Offset: 0 }";
                            const v = $d7238066c5de7f1c$var$wi.fromJSON(d);
                            this.privRequestSession.onServiceRecognized(v.Offset + this.privRequestSession.currentTurnAudioOffset);
                            const g = new $d7238066c5de7f1c$var$Xe(v.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                            this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, g);
                            break;
                        case "turn.end":
                            {
                                const I = c.requestId.toUpperCase(), A = this.privRequestSession.requestId.toUpperCase();
                                if (I !== A) this.privTurnStateManager.CompleteTurn(I);
                                else {
                                    const D = new $d7238066c5de7f1c$var$Ce(this.privRequestSession.sessionId);
                                    if (yield this.privRequestSession.onServiceTurnEndResponse(!1), (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) && this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, D), this.privSuccessCallback && this.privLastResult) {
                                        try {
                                            this.privSuccessCallback(this.privLastResult), this.privLastResult = null;
                                        } catch (z) {
                                            this.privErrorCallback && this.privErrorCallback(z);
                                        }
                                        this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                                    }
                                }
                            }
                            break;
                        default:
                            try {
                                (yield this.processTypeSpecificMessages(c)) || this.serviceEvents && this.serviceEvents.onEvent(new $d7238066c5de7f1c$var$yo(c.path.toLowerCase(), c.textBody));
                            } catch  {}
                    }
                    return t();
                } catch  {
                    this.terminateMessageLoop = !0, e.resolve();
                }
            });
        return t().catch((i)=>{
            $d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$Ct(i));
        }), e.promise;
    }
    startMessageLoop() {
        return $d7238066c5de7f1c$var$mt(this, void 0, void 0, function*() {
            this.terminateMessageLoop = !1;
            try {
                yield this.receiveDialogMessageOverride();
            } catch (e) {
                yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.RuntimeError, e);
            }
            return Promise.resolve();
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configConnection(e) {
        return $d7238066c5de7f1c$var$mt(this, void 0, void 0, function*() {
            return this.terminateMessageLoop ? (this.terminateMessageLoop = !1, Promise.reject("Connection to service terminated.")) : (yield this.sendSpeechServiceConfig(e, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize()), yield this.sendAgentConfig(e), e);
        });
    }
    sendPreAudioMessages() {
        return $d7238066c5de7f1c$var$mt(this, void 0, void 0, function*() {
            const e = yield this.fetchConnection();
            this.addKeywordContextData(), yield this.sendSpeechContext(e, !0), yield this.sendAgentContext(e), yield this.sendWaveHeader(e);
        });
    }
    sendAgentConfig(e) {
        if (this.agentConfig && !this.agentConfigSent) {
            if (this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.Conversation_DialogType) === $d7238066c5de7f1c$var$_e.DialogTypes.CustomCommands) {
                const i = this.agentConfig.get();
                i.botInfo.commandsCulture = this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage, "en-us"), this.agentConfig.set(i);
            }
            this.onEvent(new $d7238066c5de7f1c$var$Jd(this.agentConfig));
            const t = this.agentConfig.toJsonString();
            return this.agentConfigSent = !0, e.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "agent.config", this.privRequestSession.requestId, "application/json", t));
        }
    }
    sendAgentContext(e) {
        const t = $d7238066c5de7f1c$var$Qr(), i = this.privDialogServiceConnector.properties.getProperty($d7238066c5de7f1c$var$u.Conversation_Speech_Activity_Template), s = JSON.stringify({
            channelData: "",
            context: {
                interactionId: t
            },
            messagePayload: i,
            version: 0.5
        });
        return e.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "speech.agent.context", this.privRequestSession.requestId, "application/json", s));
    }
    fireEventForResult(e, t) {
        const i = $d7238066c5de7f1c$var$he.implTranslateRecognitionResult(e.RecognitionStatus), n = e.Offset + this.privRequestSession.currentTurnAudioOffset, s = new $d7238066c5de7f1c$var$Oe(this.privRequestSession.requestId, i, e.DisplayText, e.Duration, n, e.Language, e.LanguageDetectionConfidence, void 0, void 0, JSON.stringify(e), t);
        return new $d7238066c5de7f1c$var$Rt(s, n, this.privRequestSession.sessionId);
    }
    handleResponseMessage(e) {
        const t = JSON.parse(e.textBody);
        switch(t.messageType.toLowerCase()){
            case "message":
                const i = e.requestId.toUpperCase(), n = $d7238066c5de7f1c$var$Xo.fromJSON(e.textBody), s = this.privTurnStateManager.GetTurn(i);
                if (n.conversationId) {
                    const p = this.agentConfig.get();
                    p.botInfo.conversationId = n.conversationId, this.agentConfig.set(p);
                }
                const o = s.processActivityPayload(n, $d7238066c5de7f1c$var$O.fromSpeechSynthesisOutputFormatString(this.privDialogServiceConnector.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_SynthOutputFormat, void 0))), c = new $d7238066c5de7f1c$var$Up(n.messagePayload, o);
                if (this.privDialogServiceConnector.activityReceived) try {
                    this.privDialogServiceConnector.activityReceived(this.privDialogServiceConnector, c);
                } catch  {}
                break;
            case "messagestatus":
                if (this.privDialogServiceConnector.turnStatusReceived) try {
                    this.privDialogServiceConnector.turnStatusReceived(this.privDialogServiceConnector, new $d7238066c5de7f1c$var$qp(e.textBody));
                } catch  {}
                break;
            default:
                $d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$Ct(`Unexpected response of type ${t.messageType}. Ignoring.`));
                break;
        }
    }
    onEvent(e) {
        this.privEvents.onEvent(e), $d7238066c5de7f1c$var$oe.instance.onEvent(e);
    }
    addKeywordContextData() {
        const e = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
        if (e === void 0) return;
        const t = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets"), i = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations"), n = e.split(";"), s = t === void 0 ? [] : t.split(";"), o = i === void 0 ? [] : i.split(";"), c = [];
        for(let p = 0; p < n.length; p++){
            const h = {};
            h.text = n[p], p < s.length && (h.offset = Number(s[p])), p < o.length && (h.duration = Number(o[p])), c.push(h);
        }
        this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword"), this.speechContext.setSection("keywordDetection", [
            {
                clientDetectedKeywords: c,
                onReject: {
                    action: "EndOfTurn"
                },
                type: "startTrigger"
            }
        ]);
    }
}
class $d7238066c5de7f1c$var$ph {
    toJsonString() {
        return JSON.stringify(this.iPrivConfig);
    }
    get() {
        return this.iPrivConfig;
    }
    /**
   * Setter for the agent.config object.
   * @param value a JSON serializable object.
   */ set(e) {
        this.iPrivConfig = e;
    }
}
class $d7238066c5de7f1c$var$$ extends $d7238066c5de7f1c$var$ht {
    static get host() {
        return $d7238066c5de7f1c$var$$.privHost;
    }
    static get apiVersion() {
        return $d7238066c5de7f1c$var$$.privApiVersion;
    }
    static get clientAppId() {
        return $d7238066c5de7f1c$var$$.privClientAppId;
    }
    static get defaultLanguageCode() {
        return $d7238066c5de7f1c$var$$.privDefaultLanguageCode;
    }
    static get restPath() {
        return $d7238066c5de7f1c$var$$.privRestPath;
    }
    static get webSocketPath() {
        return $d7238066c5de7f1c$var$$.privWebSocketPath;
    }
    static get transcriptionEventKeys() {
        return $d7238066c5de7f1c$var$$.privTranscriptionEventKeys;
    }
}
$d7238066c5de7f1c$var$$.privHost = "dev.microsofttranslator.com";
$d7238066c5de7f1c$var$$.privRestPath = "/capito/room";
$d7238066c5de7f1c$var$$.privApiVersion = "2.0";
$d7238066c5de7f1c$var$$.privDefaultLanguageCode = "en-US";
$d7238066c5de7f1c$var$$.privClientAppId = "FC539C22-1767-4F1F-84BC-B4D811114F15";
$d7238066c5de7f1c$var$$.privWebSocketPath = "/capito/translate";
$d7238066c5de7f1c$var$$.privTranscriptionEventKeys = [
    "iCalUid",
    "callId",
    "organizer",
    "FLAC",
    "MTUri",
    "DifferentiateGuestSpeakers",
    "audiorecording",
    "Threadid",
    "OrganizerMri",
    "OrganizerTenantId",
    "UserToken"
];
class $d7238066c5de7f1c$var$hh {
    constructor(){
        this.privRequestParams = $d7238066c5de7f1c$var$$.configParams, this.privErrors = $d7238066c5de7f1c$var$$.restErrors, this.privHost = $d7238066c5de7f1c$var$$.host, this.privApiVersion = $d7238066c5de7f1c$var$$.apiVersion, this.privRestPath = $d7238066c5de7f1c$var$$.restPath, this.privRestAdapter = new $d7238066c5de7f1c$var$Gs({});
    }
    /**
   * Make a POST request to the Conversation Manager service endpoint to create or join a conversation.
   * @param args
   * @param conversationCode
   * @param callback
   * @param errorCallback
   */ createOrJoin(e, t, i, n) {
        try {
            $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "args");
            const s = e.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage, $d7238066c5de7f1c$var$$.defaultLanguageCode), o = e.getProperty($d7238066c5de7f1c$var$u.ConversationTranslator_Name, "conversation_host"), c = e.getProperty($d7238066c5de7f1c$var$u.ConversationTranslator_Host, this.privHost), p = e.getProperty($d7238066c5de7f1c$var$u.ConversationTranslator_CorrelationId), h = e.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Key), a = e.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region), d = e.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
            $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(s, "languageCode"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(o, "nickname"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(c, "endpointHost");
            const v = {};
            v[this.privRequestParams.apiVersion] = this.privApiVersion, v[this.privRequestParams.languageCode] = s, v[this.privRequestParams.nickname] = o;
            const g = {};
            p && (g[this.privRequestParams.correlationId] = p), g[this.privRequestParams.clientAppId] = $d7238066c5de7f1c$var$$.clientAppId, t !== void 0 ? v[this.privRequestParams.roomId] = t : ($d7238066c5de7f1c$var$l.throwIfNullOrUndefined(a, this.privErrors.authInvalidSubscriptionRegion), g[this.privRequestParams.subscriptionRegion] = a, h ? g[this.privRequestParams.subscriptionKey] = h : d ? g[this.privRequestParams.authorization] = `Bearer ${d}` : $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(h, this.privErrors.authInvalidSubscriptionKey));
            const I = {};
            I.headers = g, this.privRestAdapter.options = I;
            const A = `https://${c}${this.privRestPath}`;
            this.privRestAdapter.request($d7238066c5de7f1c$var$Lt.Post, A, v, null).then((D)=>{
                const z = $d7238066c5de7f1c$var$Gs.extractHeaderValue(this.privRequestParams.requestId, D.headers);
                if (!D.ok) {
                    if (n) {
                        let _ = this.privErrors.invalidCreateJoinConversationResponse.replace("{status}", D.status.toString()), L;
                        try {
                            L = JSON.parse(D.data), _ += ` [${L.error.code}: ${L.error.message}]`;
                        } catch  {
                            _ += ` [${D.data}]`;
                        }
                        z && (_ += ` ${z}`), n(_);
                    }
                    return;
                }
                const C = JSON.parse(D.data);
                if (C && (C.requestId = z), i) {
                    try {
                        i(C);
                    } catch (_) {
                        n && n(_);
                    }
                    i = void 0;
                }
            }).catch(()=>{});
        } catch (s) {
            if (n) {
                if (s instanceof Error) {
                    const o = s;
                    n(o.name + ": " + o.message);
                } else n(s);
            }
        }
    }
    /**
   * Make a DELETE request to the Conversation Manager service endpoint to leave the conversation.
   * @param args
   * @param sessionToken
   * @param callback
   */ leave(e, t) {
        return new Promise((i, n)=>{
            try {
                $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, this.privErrors.invalidArgs.replace("{arg}", "config")), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "token"));
                const s = e.getProperty($d7238066c5de7f1c$var$u.ConversationTranslator_Host, this.privHost), o = e.getProperty($d7238066c5de7f1c$var$u.ConversationTranslator_CorrelationId), c = {};
                c[this.privRequestParams.apiVersion] = this.privApiVersion, c[this.privRequestParams.sessionToken] = t;
                const p = {};
                o && (p[this.privRequestParams.correlationId] = o);
                const h = {};
                h.headers = p, this.privRestAdapter.options = h;
                const a = `https://${s}${this.privRestPath}`;
                this.privRestAdapter.request($d7238066c5de7f1c$var$Lt.Delete, a, c, null).then((d)=>{
                    d.ok, i();
                }).catch(()=>{});
            } catch (s) {
                if (s instanceof Error) {
                    const o = s;
                    n(o.name + ": " + o.message);
                } else n(s);
            }
        });
    }
}
class $d7238066c5de7f1c$var$rn extends $d7238066c5de7f1c$var$Zr {
    constructor(e, t, i, n){
        super(e, t, i, n);
        const s = JSON.parse(this.textBody);
        s.type !== void 0 && (this.privConversationMessageType = s.type);
    }
    get conversationMessageType() {
        return this.privConversationMessageType;
    }
}
class $d7238066c5de7f1c$var$nv {
    /**
   * Format incoming messages: text (speech partial/final, IM) or binary (tts)
   */ toConnectionMessage(e) {
        const t = new $d7238066c5de7f1c$var$F();
        try {
            if (e.messageType === $d7238066c5de7f1c$var$k.Text) {
                const i = new $d7238066c5de7f1c$var$rn(e.messageType, e.textContent, {}, e.id);
                t.resolve(i);
            } else e.messageType === $d7238066c5de7f1c$var$k.Binary && t.resolve(new $d7238066c5de7f1c$var$rn(e.messageType, e.binaryContent, void 0, e.id));
        } catch (i) {
            t.reject(`Error formatting the message. Error: ${i}`);
        }
        return t.promise;
    }
    /**
   * Format outgoing messages: text (commands or IM)
   */ fromConnectionMessage(e) {
        const t = new $d7238066c5de7f1c$var$F();
        try {
            if (e.messageType === $d7238066c5de7f1c$var$k.Text) {
                const i = `${e.textBody ? e.textBody : ""}`;
                t.resolve(new $d7238066c5de7f1c$var$Yi($d7238066c5de7f1c$var$k.Text, i, e.id));
            }
        } catch (i) {
            t.reject(`Error formatting the message. ${i}`);
        }
        return t.promise;
    }
}
class $d7238066c5de7f1c$var$sv extends $d7238066c5de7f1c$var$fe {
    create(e, t, i) {
        const n = e.parameters.getProperty($d7238066c5de7f1c$var$u.ConversationTranslator_Host, $d7238066c5de7f1c$var$$.host), s = e.parameters.getProperty($d7238066c5de7f1c$var$u.ConversationTranslator_CorrelationId, $d7238066c5de7f1c$var$Qr()), o = `wss://${n}${$d7238066c5de7f1c$var$$.webSocketPath}`, c = e.parameters.getProperty($d7238066c5de7f1c$var$u.ConversationTranslator_Token, void 0);
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(c, "token");
        const p = {};
        p[$d7238066c5de7f1c$var$$.configParams.apiVersion] = $d7238066c5de7f1c$var$$.apiVersion, p[$d7238066c5de7f1c$var$$.configParams.token] = c, p[$d7238066c5de7f1c$var$$.configParams.correlationId] = s;
        const h = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$ut(o, p, {}, new $d7238066c5de7f1c$var$nv(), $d7238066c5de7f1c$var$Ve.fromRecognizerConfig(e), h, i);
    }
}
var $d7238066c5de7f1c$var$ov = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$av {
    constructor(e){
        this.privIsDisposed = !1, this.privDetachables = new Array(), this.privSessionId = e, this.privRequestId = $d7238066c5de7f1c$var$ee(), this.privRequestCompletionDeferral = new $d7238066c5de7f1c$var$F();
    }
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get completionPromise() {
        return this.privRequestCompletionDeferral.promise;
    }
    onPreConnectionStart(e, t) {
        this.privSessionId = t;
    }
    onAuthCompleted(e) {
        e && this.onComplete();
    }
    onConnectionEstablishCompleted(e) {
        e !== 200 && e === 403 && this.onComplete();
    }
    onServiceTurnEndResponse(e) {
        e ? this.privRequestId = $d7238066c5de7f1c$var$ee() : this.onComplete();
    }
    dispose() {
        return $d7238066c5de7f1c$var$ov(this, void 0, void 0, function*() {
            if (!this.privIsDisposed) {
                this.privIsDisposed = !0;
                for (const e of this.privDetachables)yield e.detach();
            }
        });
    }
    onComplete() {}
}
class $d7238066c5de7f1c$var$cv extends $d7238066c5de7f1c$var$Ce {
    constructor(e, t){
        super(t), this.privIsMuted = e;
    }
    get isMuted() {
        return this.privIsMuted;
    }
}
class $d7238066c5de7f1c$var$pv extends $d7238066c5de7f1c$var$Ce {
    constructor(e, t){
        super(t), this.privIsLocked = e;
    }
    get isMuted() {
        return this.privIsLocked;
    }
}
class $d7238066c5de7f1c$var$ec extends $d7238066c5de7f1c$var$Ce {
    constructor(e, t){
        super(t), this.privParticipant = e;
    }
    get participant() {
        return this.privParticipant;
    }
}
class $d7238066c5de7f1c$var$Mi extends $d7238066c5de7f1c$var$Ce {
    constructor(e, t, i, n){
        super(n), this.privKey = t, this.privValue = i, this.privParticipantId = e;
    }
    get value() {
        return this.privValue;
    }
    get key() {
        return this.privKey;
    }
    get id() {
        return this.privParticipantId;
    }
}
class $d7238066c5de7f1c$var$hv extends $d7238066c5de7f1c$var$Ce {
    constructor(e, t, i, n, s, o, c, p, h){
        super(h), this.privRoomId = e, this.privSessionToken = t, this.privTranslateTo = i, this.privProfanityFilter = n, this.privRoomProfanityFilter = s, this.privIsRoomLocked = o, this.privIsRoomLocked = c, this.privParticipants = p;
    }
    get sessionToken() {
        return this.privSessionToken;
    }
    get conversationId() {
        return this.privRoomId;
    }
    get translateTo() {
        return this.privTranslateTo;
    }
    get profanityFilter() {
        return this.privProfanityFilter;
    }
    get roomProfanityFilter() {
        return this.privRoomProfanityFilter;
    }
    get isRoomLocked() {
        return this.privIsRoomLocked;
    }
    get isMuteAll() {
        return this.privIsMuteAll;
    }
    get participants() {
        return this.privParticipants;
    }
}
class $d7238066c5de7f1c$var$Jn {
    constructor(e, t, i){
        this.privPayload = t, this.privCommand = e, this.privSessionId = i;
    }
    get payload() {
        return this.privPayload;
    }
    get command() {
        return this.privCommand;
    }
    get sessionId() {
        return this.privSessionId;
    }
}
class $d7238066c5de7f1c$var$uh {
    constructor(e = [], t){
        this.participants = e, this.meId = t;
    }
    /**
   * Add or update a participant
   * @param value
   */ addOrUpdateParticipant(e) {
        if (e === void 0) return;
        const t = this.getParticipantIndex(e.id);
        return t > -1 ? this.participants.splice(t, 1, e) : this.participants.push(e), this.getParticipant(e.id);
    }
    /**
   * Find the participant's position in the participants list.
   * @param id
   */ getParticipantIndex(e) {
        return this.participants.findIndex((t)=>t.id === e);
    }
    /**
   * Find the participant by id.
   * @param id
   */ getParticipant(e) {
        return this.participants.find((t)=>t.id === e);
    }
    /**
   * Remove a participant from the participants list.
   */ deleteParticipant(e) {
        this.participants = this.participants.filter((t)=>t.id !== e);
    }
    /**
   * Helper to return the conversation host.
   */ get host() {
        return this.participants.find((e)=>e.isHost === !0);
    }
    /**
   * Helper to return the current user.
   */ get me() {
        return this.getParticipant(this.meId);
    }
}
const $d7238066c5de7f1c$var$ne = {
    command: "command",
    final: "final",
    info: "info",
    instantMessage: "instant_message",
    keepAlive: "keep_alive",
    partial: "partial",
    participantCommand: "participant_command",
    translatedMessage: "translated_message"
}, $d7238066c5de7f1c$var$re = {
    changeNickname: "ChangeNickname",
    disconnectSession: "DisconnectSession",
    ejectParticipant: "EjectParticipant",
    instant_message: "instant_message",
    joinSession: "JoinSession",
    leaveSession: "LeaveSession",
    participantList: "ParticipantList",
    roomExpirationWarning: "RoomExpirationWarning",
    setLockState: "SetLockState",
    setMute: "SetMute",
    setMuteAll: "SetMuteAll",
    setProfanityFiltering: "SetProfanityFiltering",
    setTranslateToLanguages: "SetTranslateToLanguages",
    setUseTTS: "SetUseTTS"
}, $d7238066c5de7f1c$var$uv = (r)=>JSON.parse(r);
class $d7238066c5de7f1c$var$ea {
    constructor(e){
        this.privCommandResponse = $d7238066c5de7f1c$var$uv(e);
    }
    get type() {
        return this.privCommandResponse.type;
    }
    get command() {
        return this.privCommandResponse.command;
    }
    get id() {
        return this.privCommandResponse.id;
    }
    get nickname() {
        return this.privCommandResponse.nickname;
    }
    get participantId() {
        return this.privCommandResponse.participantId;
    }
    get roomid() {
        return this.privCommandResponse.roomid;
    }
    get value() {
        return this.privCommandResponse.value;
    }
    get token() {
        return this.privCommandResponse.token;
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$ea(e);
    }
}
const $d7238066c5de7f1c$var$dv = (r)=>JSON.parse(r), $d7238066c5de7f1c$var$lv = (r)=>JSON.parse(r);
class $d7238066c5de7f1c$var$ta {
    constructor(e){
        this.privParticipantsPayloadResponse = $d7238066c5de7f1c$var$dv(e);
    }
    get roomid() {
        return this.privParticipantsPayloadResponse.roomid;
    }
    get id() {
        return this.privParticipantsPayloadResponse.id;
    }
    get command() {
        return this.privParticipantsPayloadResponse.command;
    }
    get participants() {
        return this.privParticipantsPayloadResponse.participants;
    }
    get token() {
        return this.privParticipantsPayloadResponse.token;
    }
    get translateTo() {
        return this.privParticipantsPayloadResponse.translateTo;
    }
    get profanityFilter() {
        return this.privParticipantsPayloadResponse.profanityFilter;
    }
    get roomProfanityFilter() {
        return this.privParticipantsPayloadResponse.roomProfanityFilter;
    }
    get roomLocked() {
        return this.privParticipantsPayloadResponse.roomLocked;
    }
    get muteAll() {
        return this.privParticipantsPayloadResponse.muteAll;
    }
    get type() {
        return this.privParticipantsPayloadResponse.type;
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$ta(e);
    }
}
class $d7238066c5de7f1c$var$ia {
    constructor(e){
        this.privParticipantPayloadResponse = $d7238066c5de7f1c$var$lv(e);
    }
    get nickname() {
        return this.privParticipantPayloadResponse.nickname;
    }
    get locale() {
        return this.privParticipantPayloadResponse.locale;
    }
    get usetts() {
        return this.privParticipantPayloadResponse.usetts;
    }
    get ismuted() {
        return this.privParticipantPayloadResponse.ismuted;
    }
    get ishost() {
        return this.privParticipantPayloadResponse.ishost;
    }
    get participantId() {
        return this.privParticipantPayloadResponse.participantId;
    }
    get avatar() {
        return this.privParticipantPayloadResponse.avatar;
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$ia(e);
    }
}
const $d7238066c5de7f1c$var$vv = (r)=>JSON.parse(r), $d7238066c5de7f1c$var$fv = (r)=>JSON.parse(r);
class $d7238066c5de7f1c$var$ra {
    constructor(e){
        this.privSpeechResponse = $d7238066c5de7f1c$var$vv(e);
    }
    get recognition() {
        return this.privSpeechResponse.recognition;
    }
    get translations() {
        return this.privSpeechResponse.translations;
    }
    get id() {
        return this.privSpeechResponse.id;
    }
    get language() {
        return this.privSpeechResponse.language;
    }
    get nickname() {
        return this.privSpeechResponse.nickname;
    }
    get participantId() {
        return this.privSpeechResponse.participantId;
    }
    get roomid() {
        return this.privSpeechResponse.roomid;
    }
    get timestamp() {
        return this.privSpeechResponse.timestamp;
    }
    get type() {
        return this.privSpeechResponse.type;
    }
    get isFinal() {
        return this.privSpeechResponse.type === "final";
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$ra(e);
    }
}
class $d7238066c5de7f1c$var$na {
    constructor(e){
        this.privTextResponse = $d7238066c5de7f1c$var$fv(e);
    }
    get originalText() {
        return this.privTextResponse.originalText;
    }
    get translations() {
        return this.privTextResponse.translations;
    }
    get id() {
        return this.privTextResponse.id;
    }
    get language() {
        return this.privTextResponse.language;
    }
    get nickname() {
        return this.privTextResponse.nickname;
    }
    get participantId() {
        return this.privTextResponse.participantId;
    }
    get roomid() {
        return this.privTextResponse.roomid;
    }
    get timestamp() {
        return this.privTextResponse.timestamp;
    }
    get type() {
        return this.privTextResponse.type;
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$na(e);
    }
}
var $d7238066c5de7f1c$var$Wt = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$gv extends $d7238066c5de7f1c$var$Ie {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privConnectionConfigPromise = void 0, this.privLastPartialUtteranceId = "", this.privConversationServiceConnector = s, this.privConversationAuthentication = e, this.receiveMessageOverride = ()=>this.receiveConversationMessageOverride(), this.recognizeOverride = ()=>this.noOp(), this.postConnectImplOverride = (o)=>this.conversationConnectImpl(o), this.configConnectionOverride = ()=>this.configConnection(), this.disconnectOverride = ()=>this.privDisconnect(), this.privConversationRequestSession = new $d7238066c5de7f1c$var$av($d7238066c5de7f1c$var$ee()), this.privConversationConnectionFactory = t, this.privConversationIsDisposed = !1;
    }
    isDisposed() {
        return super.isDisposed() || this.privConversationIsDisposed;
    }
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$Wt(this, void 0, void 0, function*() {
            this.privConversationIsDisposed = !0, this.privConnectionConfigPromise !== void 0 && (yield (yield this.privConnectionConfigPromise).dispose(e)), yield t.dispose.call(this, e);
        });
    }
    sendMessage(e) {
        return $d7238066c5de7f1c$var$Wt(this, void 0, void 0, function*() {
            return (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$rn($d7238066c5de7f1c$var$k.Text, e));
        });
    }
    sendMessageAsync(e) {
        return $d7238066c5de7f1c$var$Wt(this, void 0, void 0, function*() {
            yield (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$rn($d7238066c5de7f1c$var$k.Text, e));
        });
    }
    privDisconnect() {
        if (!this.terminateMessageLoop) return this.cancelRecognition(this.privConversationRequestSession.sessionId, this.privConversationRequestSession.requestId, $d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.NoError, "Disconnecting"), this.terminateMessageLoop = !0, Promise.resolve();
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    processTypeSpecificMessages() {
        return $d7238066c5de7f1c$var$Wt(this, void 0, void 0, function*() {
            return !0;
        });
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        this.terminateMessageLoop = !0;
        const o = new $d7238066c5de7f1c$var$Ho(i, s, n, void 0, e);
        try {
            this.privConversationServiceConnector.canceled && this.privConversationServiceConnector.canceled(this.privConversationServiceConnector, o);
        } catch  {}
    }
    /**
   * Establishes a websocket connection to the end point.
   */ conversationConnectImpl(e) {
        return $d7238066c5de7f1c$var$Wt(this, void 0, void 0, function*() {
            return this.privConnectionLoop = this.startMessageLoop(), e;
        });
    }
    /**
   * Process incoming websocket messages
   */ receiveConversationMessageOverride() {
        return $d7238066c5de7f1c$var$Wt(this, void 0, void 0, function*() {
            if (this.isDisposed() || this.terminateMessageLoop) return Promise.resolve();
            const e = new $d7238066c5de7f1c$var$F();
            try {
                const i = yield (yield this.fetchConnection()).read();
                if (this.isDisposed() || this.terminateMessageLoop) return e.resolve(), Promise.resolve();
                if (!i) return this.receiveConversationMessageOverride();
                const n = this.privConversationRequestSession.sessionId, s = i.conversationMessageType.toLowerCase();
                let o = !1;
                try {
                    switch(s){
                        case "info":
                        case "participant_command":
                        case "command":
                            const c = $d7238066c5de7f1c$var$ea.fromJSON(i.textBody);
                            switch(c.command.toLowerCase()){
                                case "participantlist":
                                    const g = $d7238066c5de7f1c$var$ta.fromJSON(i.textBody), I = g.participants.map((L)=>({
                                            avatar: L.avatar,
                                            displayName: L.nickname,
                                            id: L.participantId,
                                            isHost: L.ishost,
                                            isMuted: L.ismuted,
                                            isUsingTts: L.usetts,
                                            preferredLanguage: L.locale
                                        }));
                                    this.privConversationServiceConnector.participantsListReceived && this.privConversationServiceConnector.participantsListReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$hv(g.roomid, g.token, g.translateTo, g.profanityFilter, g.roomProfanityFilter, g.roomLocked, g.muteAll, I, n));
                                    break;
                                case "settranslatetolanguages":
                                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$Mi(c.participantId, $d7238066c5de7f1c$var$re.setTranslateToLanguages, c.value, n));
                                    break;
                                case "setprofanityfiltering":
                                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$Mi(c.participantId, $d7238066c5de7f1c$var$re.setProfanityFiltering, c.value, n));
                                    break;
                                case "setmute":
                                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$Mi(c.participantId, $d7238066c5de7f1c$var$re.setMute, c.value, n));
                                    break;
                                case "setmuteall":
                                    this.privConversationServiceConnector.muteAllCommandReceived && this.privConversationServiceConnector.muteAllCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$cv(c.value, n));
                                    break;
                                case "roomexpirationwarning":
                                    this.privConversationServiceConnector.conversationExpiration && this.privConversationServiceConnector.conversationExpiration(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$Fp(c.value, this.privConversationRequestSession.sessionId));
                                    break;
                                case "setusetts":
                                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$Mi(c.participantId, $d7238066c5de7f1c$var$re.setUseTTS, c.value, n));
                                    break;
                                case "setlockstate":
                                    this.privConversationServiceConnector.lockRoomCommandReceived && this.privConversationServiceConnector.lockRoomCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$pv(c.value, n));
                                    break;
                                case "changenickname":
                                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$Mi(c.participantId, $d7238066c5de7f1c$var$re.changeNickname, c.value, n));
                                    break;
                                case "joinsession":
                                    const A = $d7238066c5de7f1c$var$ia.fromJSON(i.textBody), D = {
                                        avatar: A.avatar,
                                        displayName: A.nickname,
                                        id: A.participantId,
                                        isHost: A.ishost,
                                        isMuted: A.ismuted,
                                        isUsingTts: A.usetts,
                                        preferredLanguage: A.locale
                                    };
                                    this.privConversationServiceConnector.participantJoinCommandReceived && this.privConversationServiceConnector.participantJoinCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$ec(D, n));
                                    break;
                                case "leavesession":
                                    const z = {
                                        id: c.participantId
                                    };
                                    this.privConversationServiceConnector.participantLeaveCommandReceived && this.privConversationServiceConnector.participantLeaveCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$ec(z, n));
                                    break;
                                case "disconnectsession":
                                    const C = {
                                        id: c.participantId
                                    };
                                    break;
                                case "token":
                                    const _ = new $d7238066c5de7f1c$var$jt(()=>{
                                        const L = c.token;
                                        return Promise.resolve(L);
                                    }, ()=>{
                                        const L = c.token;
                                        return Promise.resolve(L);
                                    });
                                    this.authentication = _, this.privConversationServiceConnector.onToken(_);
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case "partial":
                        case "final":
                            const p = $d7238066c5de7f1c$var$ra.fromJSON(i.textBody), h = s === "final" ? $d7238066c5de7f1c$var$R.TranslatedParticipantSpeech : $d7238066c5de7f1c$var$R.TranslatingParticipantSpeech, a = new $d7238066c5de7f1c$var$Fs(p.participantId, this.getTranslations(p.translations), p.language, p.id, h, p.recognition, void 0, void 0, i.textBody, void 0);
                            p.isFinal ? ((a.text !== void 0 && a.text.length > 0 || p.id === this.privLastPartialUtteranceId) && (o = !0), o && this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$Jn($d7238066c5de7f1c$var$ne.final, a, n))) : a.text !== void 0 && (this.privLastPartialUtteranceId = p.id, this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$Jn($d7238066c5de7f1c$var$ne.partial, a, n)));
                            break;
                        case "translated_message":
                            const d = $d7238066c5de7f1c$var$na.fromJSON(i.textBody), v = new $d7238066c5de7f1c$var$Fs(d.participantId, this.getTranslations(d.translations), d.language, void 0, void 0, d.originalText, void 0, void 0, void 0, i.textBody, void 0);
                            this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$Jn($d7238066c5de7f1c$var$ne.instantMessage, v, n));
                            break;
                        default:
                            break;
                    }
                } catch  {}
                return this.receiveConversationMessageOverride();
            } catch  {
                this.terminateMessageLoop = !0;
            }
            return e.promise;
        });
    }
    startMessageLoop() {
        return $d7238066c5de7f1c$var$Wt(this, void 0, void 0, function*() {
            if (this.isDisposed()) return Promise.resolve();
            this.terminateMessageLoop = !1;
            const e = this.receiveConversationMessageOverride();
            try {
                return yield e;
            } catch (t) {
                return this.cancelRecognition(this.privRequestSession ? this.privRequestSession.sessionId : "", this.privRequestSession ? this.privRequestSession.requestId : "", $d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.RuntimeError, t), null;
            }
        });
    }
    // Takes an established websocket connection to the endpoint
    configConnection() {
        return this.isDisposed() ? Promise.resolve(void 0) : this.privConnectionConfigPromise !== void 0 ? this.privConnectionConfigPromise.then((e)=>e.state() === $d7238066c5de7f1c$var$pe.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigPromise = void 0, this.configConnection()) : this.privConnectionConfigPromise, ()=>(this.privConnectionId = null, this.privConnectionConfigPromise = void 0, this.configConnection())) : this.terminateMessageLoop ? Promise.resolve(void 0) : (this.privConnectionConfigPromise = this.connectImpl().then((e)=>e), this.privConnectionConfigPromise);
    }
    getTranslations(e) {
        let t;
        if (e !== void 0) {
            t = new $d7238066c5de7f1c$var$zo();
            for (const i of e)t.set(i.lang, i.translation);
        }
        return t;
    }
}
var $d7238066c5de7f1c$var$tc = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$mv {
    static fromConfig(e, t, i) {
        return new $d7238066c5de7f1c$var$Sv(e, t, i);
    }
}
class $d7238066c5de7f1c$var$Sv extends $d7238066c5de7f1c$var$Fe {
    constructor(e, t, i){
        const n = t;
        $d7238066c5de7f1c$var$l.throwIfNull(n, "speechConfig");
        const s = e;
        $d7238066c5de7f1c$var$l.throwIfNull(s, "conversationImpl"), super(i, n.properties, new $d7238066c5de7f1c$var$sv()), this.privConversation = s, this.privIsDisposed = !1, this.privProperties = n.properties.clone(), this.privConnection = $d7238066c5de7f1c$var$Jt.fromRecognizer(this), this.privProperties.getProperty($d7238066c5de7f1c$var$u.WebWorkerLoadType, "on").toLowerCase() === "on" && typeof Blob < "u" && typeof Worker < "u" ? (this.privSetTimeout = $d7238066c5de7f1c$var$ye.setTimeout, this.privClearTimeout = $d7238066c5de7f1c$var$ye.clearTimeout) : typeof window < "u" ? (this.privSetTimeout = window.setTimeout.bind(window), this.privClearTimeout = window.clearTimeout.bind(window)) : (this.privSetTimeout = setTimeout, this.privClearTimeout = clearTimeout);
    }
    set connected(e) {
        this.privConnection.connected = e;
    }
    set disconnected(e) {
        this.privConnection.disconnected = e;
    }
    /**
   * Return the speech language used by the recognizer
   */ get speechRecognitionLanguage() {
        return this.privSpeechRecognitionLanguage;
    }
    /**
   * Return the properties for the recognizer
   */ get properties() {
        return this.privProperties;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    /**
   * Connect to the recognizer
   * @param token
   */ connect(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "token"), this.privReco.conversationTranslatorToken = e, this.resetConversationTimeout(), this.privReco.connectAsync(t, i);
        } catch (n) {
            if (i) {
                if (n instanceof Error) {
                    const s = n;
                    i(s.name + ": " + s.message);
                } else i(n);
            }
        }
    }
    /**
   * Disconnect from the recognizer
   */ disconnect(e, t) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), this.privTimeoutToken !== void 0 && this.privClearTimeout(this.privTimeoutToken), this.privReco.disconnect().then(()=>{
                e && e();
            }, (i)=>{
                t && t(i);
            });
        } catch (i) {
            if (t) {
                if (i instanceof Error) {
                    const n = i;
                    t(n.name + ": " + n.message);
                } else t(i);
            }
            this.dispose(!0).catch((n)=>{
                $d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$Ct(n));
            });
        }
    }
    /**
   * Send the mute all participants command to the websocket
   * @param conversationId
   * @param participantId
   * @param isMuted
   */ sendRequest(e, t, i) {
        try {
            $d7238066c5de7f1c$var$l.throwIfDisposed(this.privIsDisposed), this.sendMessage(e, t, i);
        } catch (n) {
            if (i) {
                if (n instanceof Error) {
                    const s = n;
                    i(s.name + ": " + s.message);
                } else i(n);
            }
            this.dispose(!0).catch((s)=>{
                $d7238066c5de7f1c$var$oe.instance.onEvent(new $d7238066c5de7f1c$var$Ct(s));
            });
        }
    }
    /**
   * Handle update of service auth token (#694)
   */ onToken(e) {
        this.privConversation.onToken(e);
    }
    /**
   * Close and dispose the recognizer
   */ close() {
        return $d7238066c5de7f1c$var$tc(this, void 0, void 0, function*() {
            this.privIsDisposed || (this.privConnection && (this.privConnection.closeConnection(), this.privConnection.close()), this.privConnection = void 0, yield this.dispose(!0));
        });
    }
    /**
   * Dispose the recognizer
   * @param disposing
   */ dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$tc(this, void 0, void 0, function*() {
            this.privIsDisposed || e && (this.privTimeoutToken !== void 0 && this.privClearTimeout(this.privTimeoutToken), this.privIsDisposed = !0, this.privConnection && (this.privConnection.closeConnection(), this.privConnection.close(), this.privConnection = void 0), yield t.dispose.call(this, e));
        });
    }
    /**
   * Create the config for the recognizer
   * @param speechConfig
   */ createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$Et(e, this.privProperties);
    }
    /**
   * Create the service recognizer.
   * The audio source is redundnant here but is required by the implementation.
   * @param authentication
   * @param connectionFactory
   * @param audioConfig
   * @param recognizerConfig
   */ createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$gv(e, t, s, n, this);
    }
    sendMessage(e, t, i) {
        const n = this.privReco;
        ((o, c, p)=>{
            o !== void 0 ? o.then(()=>{
                try {
                    c && c();
                } catch (h) {
                    p && p(`'Unhandled error on promise callback: ${h}'`);
                }
            }, (h)=>{
                try {
                    p && p(h);
                } catch  {}
            }) : p && p("Null promise");
        })(n.sendMessageAsync(e), t, i), this.resetConversationTimeout();
    }
    resetConversationTimeout() {
        this.privTimeoutToken !== void 0 && this.privClearTimeout(this.privTimeoutToken), this.privTimeoutToken = this.privSetTimeout(()=>{
            this.sendRequest(this.privConversation.getKeepAlive());
        }, 6e4);
    }
}
var $d7238066c5de7f1c$var$xi = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$yv extends $d7238066c5de7f1c$var$Fe {
    /**
   * TranscriberRecognizer constructor.
   * @constructor
   * @param {SpeechTranslationConfig} speechTranslationConfig - Non-audio configuration associated with the recognizer
   * @param {AudioConfig} audioConfig - An audio configuration associated with the recognizer
   */ constructor(e, t){
        const i = e;
        $d7238066c5de7f1c$var$l.throwIfNull(i, "speechTranslationConfig");
        const n = t;
        $d7238066c5de7f1c$var$l.throwIfNull(n, "audioConfigImpl"), $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(i.speechRecognitionLanguage, $d7238066c5de7f1c$var$u[$d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage]), super(t, i.properties, new $d7238066c5de7f1c$var$ah()), this.privDisposedRecognizer = !1, this.isMeetingRecognizer = !1;
    }
    get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$l.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_RecoLanguage);
    }
    get properties() {
        return this.privProperties;
    }
    get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$u.SpeechServiceAuthorization_Token, e);
    }
    set conversation(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "Conversation"), this.isMeetingRecognizer = !1, this.privConversation = e;
    }
    getConversationInfo() {
        return $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privConversation, "Conversation"), this.privConversation.conversationInfo;
    }
    set meeting(e) {
        $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(e, "Meeting"), this.isMeetingRecognizer = !0, this.privMeeting = e;
    }
    getMeetingInfo() {
        return $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(this.privMeeting, "Meeting"), this.privMeeting.meetingInfo;
    }
    IsMeetingRecognizer() {
        return this.isMeetingRecognizer;
    }
    startContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.startContinuousRecognitionAsyncImpl($d7238066c5de7f1c$var$ue.Conversation), e, t);
    }
    stopContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$x(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    close() {
        return $d7238066c5de7f1c$var$xi(this, void 0, void 0, function*() {
            this.privDisposedRecognizer || (yield this.dispose(!0));
        });
    }
    // Push async join/leave conversation message via serviceRecognizer
    pushConversationEvent(e, t) {
        return $d7238066c5de7f1c$var$xi(this, void 0, void 0, function*() {
            const i = this.privReco;
            $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(i, "serviceRecognizer"), yield i.sendSpeechEventAsync(e, t);
        });
    }
    // Push async join/leave meeting message via serviceRecognizer
    pushMeetingEvent(e, t) {
        return $d7238066c5de7f1c$var$xi(this, void 0, void 0, function*() {
            const i = this.privReco;
            $d7238066c5de7f1c$var$l.throwIfNullOrUndefined(i, "serviceRecognizer"), yield i.sendMeetingSpeechEventAsync(e, t);
        });
    }
    enforceAudioGating() {
        return $d7238066c5de7f1c$var$xi(this, void 0, void 0, function*() {
            const i = (yield this.audioConfig.format).channels;
            if (i === 1) {
                if (this.properties.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() !== "true") throw new Error("Single channel audio configuration for MeetingTranscriber is currently under private preview, please contact diarizationrequest@microsoft.com for more details");
            } else if (i !== 8) throw new Error(`Unsupported audio configuration: Detected ${i}-channel audio`);
        });
    }
    connectMeetingCallbacks(e) {
        this.isMeetingRecognizer = !0, this.canceled = (t, i)=>{
            e.canceled && e.canceled(e, i);
        }, this.recognizing = (t, i)=>{
            e.transcribing && e.transcribing(e, i);
        }, this.recognized = (t, i)=>{
            e.transcribed && e.transcribed(e, i);
        }, this.sessionStarted = (t, i)=>{
            e.sessionStarted && e.sessionStarted(e, i);
        }, this.sessionStopped = (t, i)=>{
            e.sessionStopped && e.sessionStopped(e, i);
        };
    }
    disconnectCallbacks() {
        this.canceled = void 0, this.recognizing = void 0, this.recognized = void 0, this.sessionStarted = void 0, this.sessionStopped = void 0;
    }
    /**
   * Disposes any resources held by the object.
   * @member ConversationTranscriber.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - true if disposing the object.
   */ dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$xi(this, void 0, void 0, function*() {
            this.privDisposedRecognizer || (e && (this.privDisposedRecognizer = !0, yield this.implRecognizerStop()), yield t.dispose.call(this, e));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$Et(e, this.properties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$Gl(e, t, s, n, this);
    }
}
var $d7238066c5de7f1c$var$nt;
(function(r) {
    r.WordBoundary = "WordBoundary", r.Bookmark = "Bookmark", r.Viseme = "Viseme", r.SentenceBoundary = "SentenceBoundary", r.SessionEnd = "SessionEnd", r.AvatarSignal = "TalkingAvatarSignal";
})($d7238066c5de7f1c$var$nt || ($d7238066c5de7f1c$var$nt = {}));
class $d7238066c5de7f1c$var$sa {
    constructor(e){
        this.privSynthesisAudioMetadata = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$sa(e);
    }
    get Metadata() {
        return this.privSynthesisAudioMetadata.Metadata;
    }
}
class $d7238066c5de7f1c$var$oa extends $d7238066c5de7f1c$var$pt {
    constructor(e, t, i = $d7238066c5de7f1c$var$ce.Info){
        super(e, i), this.privRequestId = t;
    }
    get requestId() {
        return this.privRequestId;
    }
}
class $d7238066c5de7f1c$var$Cv extends $d7238066c5de7f1c$var$oa {
    constructor(e, t, i){
        super("SynthesisTriggeredEvent", e), this.privSessionAudioDestinationId = t, this.privTurnAudioDestinationId = i;
    }
    get audioSessionDestinationId() {
        return this.privSessionAudioDestinationId;
    }
    get audioTurnDestinationId() {
        return this.privTurnAudioDestinationId;
    }
}
class $d7238066c5de7f1c$var$wv extends $d7238066c5de7f1c$var$oa {
    constructor(e, t){
        super("ConnectingToSynthesisServiceEvent", e), this.privAuthFetchEventId = t;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
class $d7238066c5de7f1c$var$Rv extends $d7238066c5de7f1c$var$oa {
    constructor(e, t){
        super("SynthesisStartedEvent", e), this.privAuthFetchEventId = t;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
var $d7238066c5de7f1c$var$Er = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$nn {
    constructor(){
        this.privIsDisposed = !1, this.privIsSynthesizing = !1, this.privIsSynthesisEnded = !1, this.privBytesReceived = 0, this.privInTurn = !1, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.privSentenceOffset = 0, this.privNextSearchSentenceIndex = 0, this.privRequestId = $d7238066c5de7f1c$var$ee(), this.privTurnDeferral = new $d7238066c5de7f1c$var$F(), this.privTurnDeferral.resolve();
    }
    get requestId() {
        return this.privRequestId;
    }
    get streamId() {
        return this.privStreamId;
    }
    set streamId(e) {
        this.privStreamId = e;
    }
    get audioOutputFormat() {
        return this.privAudioOutputFormat;
    }
    set audioOutputFormat(e) {
        this.privAudioOutputFormat = e;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSynthesisEnded() {
        return this.privIsSynthesisEnded;
    }
    get isSynthesizing() {
        return this.privIsSynthesizing;
    }
    get currentTextOffset() {
        return this.privTextOffset;
    }
    get currentSentenceOffset() {
        return this.privSentenceOffset;
    }
    // The number of bytes received for current turn
    get bytesReceived() {
        return this.privBytesReceived;
    }
    get audioDuration() {
        return this.privAudioDuration;
    }
    get extraProperties() {
        if (this.privWebRTCSDP) {
            const e = new $d7238066c5de7f1c$var$U();
            return e.setProperty($d7238066c5de7f1c$var$u.TalkingAvatarService_WebRTC_SDP, this.privWebRTCSDP), e;
        }
    }
    getAllReceivedAudio() {
        return $d7238066c5de7f1c$var$Er(this, void 0, void 0, function*() {
            return this.privReceivedAudio ? Promise.resolve(this.privReceivedAudio) : this.privIsSynthesisEnded ? (yield this.readAllAudioFromStream(), Promise.resolve(this.privReceivedAudio)) : null;
        });
    }
    getAllReceivedAudioWithHeader() {
        return $d7238066c5de7f1c$var$Er(this, void 0, void 0, function*() {
            if (this.privReceivedAudioWithHeader) return this.privReceivedAudioWithHeader;
            if (!this.privIsSynthesisEnded) return null;
            if (this.audioOutputFormat.hasHeader) {
                const e = yield this.getAllReceivedAudio();
                return this.privReceivedAudioWithHeader = this.audioOutputFormat.addHeader(e), this.privReceivedAudioWithHeader;
            } else return this.getAllReceivedAudio();
        });
    }
    startNewSynthesis(e, t, i, n) {
        this.privIsSynthesisEnded = !1, this.privIsSynthesizing = !0, this.privRequestId = e, this.privRawText = t, this.privIsSSML = i, this.privAudioOutputStream = new $d7238066c5de7f1c$var$To(), this.privAudioOutputStream.format = this.privAudioOutputFormat, this.privReceivedAudio = null, this.privReceivedAudioWithHeader = null, this.privBytesReceived = 0, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.privSentenceOffset = 0, this.privNextSearchSentenceIndex = 0, this.privPartialVisemeAnimation = "", this.privWebRTCSDP = "", n !== void 0 && (this.privTurnAudioDestination = n, this.privTurnAudioDestination.format = this.privAudioOutputFormat), this.onEvent(new $d7238066c5de7f1c$var$Cv(this.requestId, void 0, n === void 0 ? void 0 : n.id()));
    }
    onPreConnectionStart(e) {
        this.privAuthFetchEventId = e, this.onEvent(new $d7238066c5de7f1c$var$wv(this.privRequestId, this.privAuthFetchEventId));
    }
    onAuthCompleted(e) {
        e && this.onComplete();
    }
    onConnectionEstablishCompleted(e) {
        if (e === 200) {
            this.onEvent(new $d7238066c5de7f1c$var$Rv(this.requestId, this.privAuthFetchEventId)), this.privBytesReceived = 0;
            return;
        } else e === 403 && this.onComplete();
    }
    onServiceResponseMessage(e) {
        const t = JSON.parse(e);
        this.streamId = t.audio.streamId;
    }
    onServiceTurnEndResponse() {
        this.privInTurn = !1, this.privTurnDeferral.resolve(), this.onComplete();
    }
    onServiceTurnStartResponse(e) {
        this.privTurnDeferral && this.privInTurn && (this.privTurnDeferral.reject("Another turn started before current completed."), this.privTurnDeferral.promise.then().catch(()=>{})), this.privInTurn = !0, this.privTurnDeferral = new $d7238066c5de7f1c$var$F();
        const t = JSON.parse(e);
        t.webrtc && (this.privWebRTCSDP = t.webrtc.connectionString);
    }
    onAudioChunkReceived(e) {
        this.isSynthesizing && (this.privAudioOutputStream.write(e), this.privBytesReceived += e.byteLength, this.privTurnAudioDestination !== void 0 && this.privTurnAudioDestination.write(e));
    }
    onTextBoundaryEvent(e) {
        this.updateTextOffset(e.Data.text.Text, e.Type);
    }
    onVisemeMetadataReceived(e) {
        e.Data.AnimationChunk !== void 0 && (this.privPartialVisemeAnimation += e.Data.AnimationChunk);
    }
    onSessionEnd(e) {
        this.privAudioDuration = e.Data.Offset;
    }
    constructSynthesisResult() {
        return $d7238066c5de7f1c$var$Er(this, void 0, void 0, function*() {
            const e = yield this.getAllReceivedAudioWithHeader();
            return new $d7238066c5de7f1c$var$tr(this.requestId, $d7238066c5de7f1c$var$R.SynthesizingAudioCompleted, e, void 0, this.extraProperties, this.audioDuration);
        });
    }
    dispose() {
        this.privIsDisposed || (this.privIsDisposed = !0);
    }
    onStopSynthesizing() {
        this.onComplete();
    }
    /**
   * Gets the viseme animation string (merged from animation chunk), and clears the internal
   * partial animation.
   */ getAndClearVisemeAnimation() {
        const e = this.privPartialVisemeAnimation;
        return this.privPartialVisemeAnimation = "", e;
    }
    onEvent(e) {
        $d7238066c5de7f1c$var$oe.instance.onEvent(e);
    }
    /**
   * Check if the text is an XML(SSML) tag
   * @param text
   * @private
   */ static isXmlTag(e) {
        return e.length >= 2 && e[0] === "<" && e[e.length - 1] === ">";
    }
    updateTextOffset(e, t) {
        t === $d7238066c5de7f1c$var$nt.WordBoundary ? (this.privTextOffset = this.privRawText.indexOf(e, this.privNextSearchTextIndex), this.privTextOffset >= 0 && (this.privNextSearchTextIndex = this.privTextOffset + e.length, this.privIsSSML && this.withinXmlTag(this.privTextOffset) && !$d7238066c5de7f1c$var$nn.isXmlTag(e) && this.updateTextOffset(e, t))) : (this.privSentenceOffset = this.privRawText.indexOf(e, this.privNextSearchSentenceIndex), this.privSentenceOffset >= 0 && (this.privNextSearchSentenceIndex = this.privSentenceOffset + e.length, this.privIsSSML && this.withinXmlTag(this.privSentenceOffset) && !$d7238066c5de7f1c$var$nn.isXmlTag(e) && this.updateTextOffset(e, t)));
    }
    onComplete() {
        this.privIsSynthesizing && (this.privIsSynthesizing = !1, this.privIsSynthesisEnded = !0, this.privAudioOutputStream.close(), this.privInTurn = !1, this.privTurnAudioDestination !== void 0 && (this.privTurnAudioDestination.close(), this.privTurnAudioDestination = void 0));
    }
    readAllAudioFromStream() {
        return $d7238066c5de7f1c$var$Er(this, void 0, void 0, function*() {
            if (this.privIsSynthesisEnded) {
                this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
                try {
                    yield this.privAudioOutputStream.read(this.privReceivedAudio);
                } catch  {
                    this.privReceivedAudio = new ArrayBuffer(0);
                }
            }
        });
    }
    /**
   * Check if current idx is in XML(SSML) tag
   * @param idx
   * @private
   */ withinXmlTag(e) {
        return this.privRawText.indexOf("<", e + 1) > this.privRawText.indexOf(">", e + 1);
    }
}
var $d7238066c5de7f1c$var$St = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$sr {
    constructor(e, t, i, n){
        if (this.speakOverride = void 0, this.receiveMessageOverride = void 0, this.connectImplOverride = void 0, this.configConnectionOverride = void 0, this.privConnectionConfigurationPromise = void 0, !e) throw new $d7238066c5de7f1c$var$le("authentication");
        if (!t) throw new $d7238066c5de7f1c$var$le("connectionFactory");
        if (!i) throw new $d7238066c5de7f1c$var$le("synthesizerConfig");
        this.privAuthentication = e, this.privConnectionFactory = t, this.privSynthesizerConfig = i, this.privIsDisposed = !1, this.privSessionAudioDestination = n, this.privSynthesisTurn = new $d7238066c5de7f1c$var$nn(), this.privConnectionEvents = new $d7238066c5de7f1c$var$Ze(), this.privServiceEvents = new $d7238066c5de7f1c$var$Ze(), this.privSynthesisContext = new $d7238066c5de7f1c$var$Ev(), this.privAgentConfig = new $d7238066c5de7f1c$var$ph(), this.connectionEvents.attach((s)=>{
            if (s.name === "ConnectionClosedEvent") {
                const o = s;
                o.statusCode !== 1e3 && this.cancelSynthesisLocal($d7238066c5de7f1c$var$X.Error, o.statusCode === 1007 ? $d7238066c5de7f1c$var$T.BadRequestParameters : $d7238066c5de7f1c$var$T.ConnectionFailure, `${o.reason} websocket error code: ${o.statusCode}`);
            }
        });
    }
    get synthesisContext() {
        return this.privSynthesisContext;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    set activityTemplate(e) {
        this.privActivityTemplate = e;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    set audioOutputFormat(e) {
        this.privAudioOutputFormat = e, this.privSynthesisTurn.audioOutputFormat = e, this.privSessionAudioDestination !== void 0 && (this.privSessionAudioDestination.format = e), this.synthesisContext !== void 0 && (this.synthesisContext.audioOutputFormat = e);
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(e) {
        return $d7238066c5de7f1c$var$St(this, void 0, void 0, function*() {
            this.privIsDisposed = !0, this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.close(), this.privConnectionConfigurationPromise !== void 0 && (yield (yield this.privConnectionConfigurationPromise).dispose(e));
        });
    }
    connect() {
        return $d7238066c5de7f1c$var$St(this, void 0, void 0, function*() {
            yield this.connectImpl();
        });
    }
    sendNetworkMessage(e, t) {
        return $d7238066c5de7f1c$var$St(this, void 0, void 0, function*() {
            const i = typeof t == "string" ? $d7238066c5de7f1c$var$k.Text : $d7238066c5de7f1c$var$k.Binary, n = typeof t == "string" ? "application/json" : "";
            return (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$se(i, e, this.privSynthesisTurn.requestId, n, t));
        });
    }
    Speak(e, t, i, n, s, o) {
        return $d7238066c5de7f1c$var$St(this, void 0, void 0, function*() {
            let c;
            if (t ? c = e : c = this.privSynthesizer.buildSsml(e), this.speakOverride !== void 0) return this.speakOverride(c, i, n, s);
            this.privSuccessCallback = n, this.privErrorCallback = s, this.privSynthesisTurn.startNewSynthesis(i, e, t, o);
            try {
                yield this.connectImpl();
                const p = yield this.fetchConnection();
                yield this.sendSynthesisContext(p), yield this.sendSsmlMessage(p, c, i), this.onSynthesisStarted(i), this.receiveMessage();
            } catch (p) {
                return this.cancelSynthesisLocal($d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.ConnectionFailure, p), Promise.reject(p);
            }
        });
    }
    stopSpeaking() {
        return $d7238066c5de7f1c$var$St(this, void 0, void 0, function*() {
            return yield this.connectImpl(), (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "synthesis.control", this.privSynthesisTurn.requestId, "application/json", JSON.stringify({
                action: "stop"
            })));
        });
    }
    // Cancels synthesis.
    cancelSynthesis(e, t, i, n) {
        const s = new $d7238066c5de7f1c$var$U();
        s.setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[i]);
        const o = new $d7238066c5de7f1c$var$tr(e, $d7238066c5de7f1c$var$R.Canceled, void 0, n, s);
        if (this.onSynthesisCancelled(o), this.privSuccessCallback) try {
            this.privSuccessCallback(o);
        } catch  {}
    }
    // Cancels synthesis.
    cancelSynthesisLocal(e, t, i) {
        this.privSynthesisTurn.isSynthesizing && (this.privSynthesisTurn.onStopSynthesizing(), this.cancelSynthesis(this.privSynthesisTurn.requestId, e, t, i));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    processTypeSpecificMessages(e) {
        return !0;
    }
    receiveMessage() {
        return $d7238066c5de7f1c$var$St(this, void 0, void 0, function*() {
            try {
                const t = yield (yield this.fetchConnection()).read();
                if (this.receiveMessageOverride !== void 0) return this.receiveMessageOverride();
                if (this.privIsDisposed) return;
                if (!t) return this.privSynthesisTurn.isSynthesizing ? this.receiveMessage() : void 0;
                const i = $d7238066c5de7f1c$var$se.fromConnectionMessage(t);
                if (i.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase()) switch(i.path.toLowerCase()){
                    case "turn.start":
                        this.privSynthesisTurn.onServiceTurnStartResponse(i.textBody);
                        break;
                    case "response":
                        this.privSynthesisTurn.onServiceResponseMessage(i.textBody);
                        break;
                    case "audio":
                        this.privSynthesisTurn.streamId.toLowerCase() === i.streamId.toLowerCase() && i.binaryBody && (this.privSynthesisTurn.onAudioChunkReceived(i.binaryBody), this.onSynthesizing(i.binaryBody), this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.write(i.binaryBody));
                        break;
                    case "audio.metadata":
                        const n = $d7238066c5de7f1c$var$sa.fromJSON(i.textBody).Metadata;
                        for (const o of n)switch(o.Type){
                            case $d7238066c5de7f1c$var$nt.WordBoundary:
                            case $d7238066c5de7f1c$var$nt.SentenceBoundary:
                                this.privSynthesisTurn.onTextBoundaryEvent(o);
                                const c = new $d7238066c5de7f1c$var$Jp(o.Data.Offset, o.Data.Duration, o.Data.text.Text, o.Data.text.Length, o.Type === $d7238066c5de7f1c$var$nt.WordBoundary ? this.privSynthesisTurn.currentTextOffset : this.privSynthesisTurn.currentSentenceOffset, o.Data.text.BoundaryType);
                                this.onWordBoundary(c);
                                break;
                            case $d7238066c5de7f1c$var$nt.Bookmark:
                                const p = new $d7238066c5de7f1c$var$Gp(o.Data.Offset, o.Data.Bookmark);
                                this.onBookmarkReached(p);
                                break;
                            case $d7238066c5de7f1c$var$nt.Viseme:
                                if (this.privSynthesisTurn.onVisemeMetadataReceived(o), o.Data.IsLastAnimation) {
                                    const h = new $d7238066c5de7f1c$var$Qp(o.Data.Offset, o.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                                    this.onVisemeReceived(h);
                                }
                                break;
                            case $d7238066c5de7f1c$var$nt.AvatarSignal:
                                this.onAvatarEvent(o);
                                break;
                            case $d7238066c5de7f1c$var$nt.SessionEnd:
                                this.privSynthesisTurn.onSessionEnd(o);
                                break;
                        }
                        break;
                    case "turn.end":
                        this.privSynthesisTurn.onServiceTurnEndResponse();
                        let s;
                        try {
                            s = yield this.privSynthesisTurn.constructSynthesisResult(), this.privSuccessCallback && this.privSuccessCallback(s);
                        } catch (o) {
                            this.privErrorCallback && this.privErrorCallback(o);
                        }
                        this.onSynthesisCompleted(s);
                        break;
                    default:
                        this.processTypeSpecificMessages(i) || this.privServiceEvents && this.serviceEvents.onEvent(new $d7238066c5de7f1c$var$yo(i.path.toLowerCase(), i.textBody));
                }
                return this.receiveMessage();
            } catch  {}
        });
    }
    sendSynthesisContext(e) {
        this.setSynthesisContextSynthesisSection();
        const t = this.synthesisContext.toJSON();
        if (t) return e.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", t));
    }
    setSpeechConfigSynthesisSection() {}
    connectImpl(e = !1) {
        if (this.privConnectionPromise != null) return this.privConnectionPromise.then((i)=>i.state() === $d7238066c5de7f1c$var$pe.Disconnected ? (this.privConnectionId = null, this.privConnectionPromise = null, this.connectImpl()) : this.privConnectionPromise, ()=>(this.privConnectionId = null, this.privConnectionPromise = null, this.connectImpl()));
        this.privAuthFetchEventId = $d7238066c5de7f1c$var$ee(), this.privConnectionId = $d7238066c5de7f1c$var$ee(), this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId);
        const t = e ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        return this.privConnectionPromise = t.then((i)=>$d7238066c5de7f1c$var$St(this, void 0, void 0, function*() {
                this.privSynthesisTurn.onAuthCompleted(!1);
                const n = this.privConnectionFactory.create(this.privSynthesizerConfig, i, this.privConnectionId);
                n.events.attach((o)=>{
                    this.connectionEvents.onEvent(o);
                });
                const s = yield n.open();
                return s.statusCode === 200 ? (this.privSynthesisTurn.onConnectionEstablishCompleted(s.statusCode), Promise.resolve(n)) : s.statusCode === 403 && !e ? this.connectImpl(!0) : (this.privSynthesisTurn.onConnectionEstablishCompleted(s.statusCode), Promise.reject(`Unable to contact server. StatusCode: ${s.statusCode}, ${this.privSynthesizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint)} Reason: ${s.reason}`));
            }), (i)=>{
            throw this.privSynthesisTurn.onAuthCompleted(!0), new Error(i);
        }), this.privConnectionPromise.catch(()=>{}), this.privConnectionPromise;
    }
    sendSpeechServiceConfig(e, t) {
        if (t) return e.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", t));
    }
    sendSsmlMessage(e, t, i) {
        return e.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "ssml", i, "application/ssml+xml", t));
    }
    fetchConnection() {
        return $d7238066c5de7f1c$var$St(this, void 0, void 0, function*() {
            return this.privConnectionConfigurationPromise !== void 0 ? this.privConnectionConfigurationPromise.then((e)=>e.state() === $d7238066c5de7f1c$var$pe.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.fetchConnection()) : this.privConnectionConfigurationPromise, ()=>(this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.fetchConnection())) : (this.privConnectionConfigurationPromise = this.configureConnection(), yield this.privConnectionConfigurationPromise);
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configureConnection() {
        return $d7238066c5de7f1c$var$St(this, void 0, void 0, function*() {
            const e = yield this.connectImpl();
            return this.configConnectionOverride !== void 0 ? this.configConnectionOverride(e) : (this.setSpeechConfigSynthesisSection(), yield this.sendSpeechServiceConfig(e, this.privSynthesizerConfig.SpeechServiceConfig.serialize()), e);
        });
    }
    onAvatarEvent(e) {}
    onSynthesisStarted(e) {}
    onSynthesizing(e) {}
    onSynthesisCancelled(e) {}
    onSynthesisCompleted(e) {}
    onWordBoundary(e) {}
    onVisemeReceived(e) {}
    onBookmarkReached(e) {}
}
$d7238066c5de7f1c$var$sr.telemetryDataEnabled = !0;
class $d7238066c5de7f1c$var$Iv extends $d7238066c5de7f1c$var$sr {
    constructor(e, t, i, n, s){
        super(e, t, i, void 0), this.privAvatarSynthesizer = n, this.privSynthesizer = n, this.privAvatarConfig = s;
    }
    setSynthesisContextSynthesisSection() {
        this.privSynthesisContext.setSynthesisSection(void 0);
    }
    setSpeechConfigSynthesisSection() {
        var e, t, i, n, s, o, c, p, h, a, d, v, g, I, A, D;
        this.privSynthesizerConfig.synthesisVideoSection = {
            format: {
                bitrate: (e = this.privAvatarConfig.videoFormat) === null || e === void 0 ? void 0 : e.bitrate,
                codec: (t = this.privAvatarConfig.videoFormat) === null || t === void 0 ? void 0 : t.codec,
                crop: {
                    bottomRight: {
                        x: (s = (n = (i = this.privAvatarConfig.videoFormat) === null || i === void 0 ? void 0 : i.cropRange) === null || n === void 0 ? void 0 : n.bottomRight) === null || s === void 0 ? void 0 : s.x,
                        y: (p = (c = (o = this.privAvatarConfig.videoFormat) === null || o === void 0 ? void 0 : o.cropRange) === null || c === void 0 ? void 0 : c.bottomRight) === null || p === void 0 ? void 0 : p.y
                    },
                    topLeft: {
                        x: (d = (a = (h = this.privAvatarConfig.videoFormat) === null || h === void 0 ? void 0 : h.cropRange) === null || a === void 0 ? void 0 : a.topLeft) === null || d === void 0 ? void 0 : d.x,
                        y: (I = (g = (v = this.privAvatarConfig.videoFormat) === null || v === void 0 ? void 0 : v.cropRange) === null || g === void 0 ? void 0 : g.topLeft) === null || I === void 0 ? void 0 : I.y
                    }
                },
                resolution: {
                    height: (A = this.privAvatarConfig.videoFormat) === null || A === void 0 ? void 0 : A.height,
                    width: (D = this.privAvatarConfig.videoFormat) === null || D === void 0 ? void 0 : D.width
                }
            },
            protocol: {
                name: "WebRTC",
                webrtcConfig: {
                    clientDescription: btoa(this.privSynthesizerConfig.parameters.getProperty($d7238066c5de7f1c$var$u.TalkingAvatarService_WebRTC_SDP)),
                    iceServers: this.privAvatarSynthesizer.iceServers
                }
            },
            talkingAvatar: {
                background: {
                    color: this.privAvatarConfig.backgroundColor
                },
                character: this.privAvatarConfig.character,
                customized: this.privAvatarConfig.customized,
                style: this.privAvatarConfig.style
            }
        };
    }
    onAvatarEvent(e) {
        if (this.privAvatarSynthesizer.avatarEventReceived) {
            const t = new $d7238066c5de7f1c$var$Xp(e.Data.Offset, e.Data.Name);
            try {
                this.privAvatarSynthesizer.avatarEventReceived(this.privAvatarSynthesizer, t);
            } catch  {}
        }
    }
}
class $d7238066c5de7f1c$var$Tv extends $d7238066c5de7f1c$var$sr {
    constructor(e, t, i, n, s){
        super(e, t, i, s), this.privSpeechSynthesizer = n, this.privSynthesizer = n;
    }
    setSynthesisContextSynthesisSection() {
        this.privSynthesisContext.setSynthesisSection(this.privSpeechSynthesizer);
    }
    onSynthesisStarted(e) {
        const t = new $d7238066c5de7f1c$var$Wi(new $d7238066c5de7f1c$var$tr(e, $d7238066c5de7f1c$var$R.SynthesizingAudioStarted));
        this.privSpeechSynthesizer.synthesisStarted && this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, t);
    }
    onSynthesizing(e) {
        if (this.privSpeechSynthesizer.synthesizing) try {
            const t = this.privSynthesisTurn.audioOutputFormat.addHeader(e), i = new $d7238066c5de7f1c$var$Wi(new $d7238066c5de7f1c$var$tr(this.privSynthesisTurn.requestId, $d7238066c5de7f1c$var$R.SynthesizingAudio, t));
            this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, i);
        } catch  {}
    }
    onSynthesisCancelled(e) {
        if (this.privSpeechSynthesizer.SynthesisCanceled) {
            const t = new $d7238066c5de7f1c$var$Wi(e);
            try {
                this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, t);
            } catch  {}
        }
    }
    onSynthesisCompleted(e) {
        if (this.privSpeechSynthesizer.synthesisCompleted) try {
            this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new $d7238066c5de7f1c$var$Wi(e));
        } catch  {}
    }
    onWordBoundary(e) {
        if (this.privSpeechSynthesizer.wordBoundary) try {
            this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, e);
        } catch  {}
    }
    onVisemeReceived(e) {
        if (this.privSpeechSynthesizer.visemeReceived) try {
            this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, e);
        } catch  {}
    }
    onBookmarkReached(e) {
        if (this.privSpeechSynthesizer.bookmarkReached) try {
            this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, e);
        } catch  {}
    }
}
class $d7238066c5de7f1c$var$Pv {
    constructor(e, t){
        let i = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Endpoint, void 0);
        if (!i) {
            const s = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Region, "westus"), o = $d7238066c5de7f1c$var$fe.getHostSuffix(s);
            i = e.parameters.getProperty($d7238066c5de7f1c$var$u.SpeechServiceConnection_Host, `https://${s}.tts.speech${o}`);
        }
        this.privUri = `${i}/cognitiveservices/voices/list`;
        const n = $d7238066c5de7f1c$var$ht.requestOptions;
        this.privRestAdapter = new $d7238066c5de7f1c$var$Gs(n), this.privAuthentication = t;
    }
    /**
   * Sends list voices request to endpoint.
   * @function
   * @public
   * @param connectionId - guid for connectionId
   * @returns {Promise<IRestResponse>} rest response to status request
   */ getVoicesList(e) {
        return this.privRestAdapter.setHeaders($d7238066c5de7f1c$var$W.ConnectionId, e), this.privAuthentication.fetch(e).then((t)=>(this.privRestAdapter.setHeaders(t.headerName, t.token), this.privRestAdapter.request($d7238066c5de7f1c$var$Lt.Get, this.privUri)));
    }
}
var $d7238066c5de7f1c$var$Ys;
(function(r) {
    r[r.Standard = 0] = "Standard", r[r.Custom = 1] = "Custom";
})($d7238066c5de7f1c$var$Ys || ($d7238066c5de7f1c$var$Ys = {}));
class $d7238066c5de7f1c$var$bv {
    constructor(e, t){
        this.privSynthesisServiceType = $d7238066c5de7f1c$var$Ys.Standard, this.avatarEnabled = !1, this.privSpeechServiceConfig = e || new $d7238066c5de7f1c$var$wn(new $d7238066c5de7f1c$var$Rn(null)), this.privParameters = t;
    }
    get parameters() {
        return this.privParameters;
    }
    get synthesisServiceType() {
        return this.privSynthesisServiceType;
    }
    set synthesisServiceType(e) {
        this.privSynthesisServiceType = e;
    }
    set synthesisVideoSection(e) {
        this.privSpeechServiceConfig.Context.synthesis = {
            video: e
        };
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
}
class $d7238066c5de7f1c$var$Ev {
    constructor(){
        this.privContext = {};
    }
    /**
   * Adds a section to the synthesis.context object.
   * @param sectionName Name of the section to add.
   * @param value JSON serializable object that represents the value.
   */ setSection(e, t) {
        this.privContext[e] = t;
    }
    /**
   * Sets the audio output format for synthesis context generation.
   * @param format {AudioOutputFormatImpl} the output format
   */ set audioOutputFormat(e) {
        this.privAudioOutputFormat = e;
    }
    toJSON() {
        return JSON.stringify(this.privContext);
    }
    setSynthesisSection(e) {
        const t = this.buildSynthesisContext(e);
        this.setSection("synthesis", t);
    }
    buildSynthesisContext(e) {
        return {
            audio: {
                metadataOptions: {
                    bookmarkEnabled: !!(e != null && e.bookmarkReached),
                    punctuationBoundaryEnabled: e == null ? void 0 : e.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_RequestPunctuationBoundary, !!(e != null && e.wordBoundary)),
                    sentenceBoundaryEnabled: e == null ? void 0 : e.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_RequestSentenceBoundary, !1),
                    sessionEndEnabled: !0,
                    visemeEnabled: !!(e != null && e.visemeReceived),
                    wordBoundaryEnabled: e == null ? void 0 : e.properties.getProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_RequestWordBoundary, !!(e != null && e.wordBoundary))
                },
                outputFormat: this.privAudioOutputFormat.requestAudioFormatString
            },
            language: {
                autoDetection: e == null ? void 0 : e.autoDetectSourceLanguage
            }
        };
    }
}
var $d7238066c5de7f1c$var$Gn = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Av extends $d7238066c5de7f1c$var$Ie {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privSpeakerRecognizer = s, this.privSpeakerAudioSource = i, this.recognizeSpeaker = (o)=>this.recognizeSpeakerOnce(o), this.sendPrePayloadJSONOverride = ()=>this.noOp();
    }
    processTypeSpecificMessages(e) {
        let t = !1;
        const i = new $d7238066c5de7f1c$var$U();
        switch(e.messageType === $d7238066c5de7f1c$var$k.Text && i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_JsonResult, e.textBody), e.path.toLowerCase()){
            case "speaker.response":
                const s = JSON.parse(e.textBody);
                let o;
                s.status.statusCode.toLowerCase() !== "success" ? o = new $d7238066c5de7f1c$var$Wr(s, $d7238066c5de7f1c$var$R.Canceled, $d7238066c5de7f1c$var$T.ServiceError, s.status.reason) : o = new $d7238066c5de7f1c$var$Wr(s, $d7238066c5de7f1c$var$R.RecognizedSpeaker), this.privResultDeferral && this.privResultDeferral.resolve(o), t = !0;
                break;
        }
        const n = new $d7238066c5de7f1c$var$F();
        return n.resolve(t), n.promise;
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        if (new $d7238066c5de7f1c$var$U().setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[n]), this.privResultDeferral) {
            const c = new $d7238066c5de7f1c$var$Wr({
                scenario: this.privSpeakerModel.scenario,
                status: {
                    statusCode: s,
                    reason: s
                }
            }, $d7238066c5de7f1c$var$R.Canceled, n, s);
            try {
                this.privResultDeferral.resolve(c);
            } catch (p) {
                this.privResultDeferral.reject(p);
            }
        }
    }
    recognizeSpeakerOnce(e) {
        return $d7238066c5de7f1c$var$Gn(this, void 0, void 0, function*() {
            this.privSpeakerModel = e, this.voiceProfileType = e.scenario, this.privResultDeferral || (this.privResultDeferral = new $d7238066c5de7f1c$var$F()), this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events), this.privRecognizerConfig.parameters.setProperty($d7238066c5de7f1c$var$u.Speech_SessionId, this.privRequestSession.sessionId);
            const t = this.connectImpl(), i = this.sendPreAudioMessages(this.extractSpeakerContext(e)), n = yield this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId), s = yield this.privSpeakerAudioSource.format, o = yield this.privSpeakerAudioSource.deviceInfo, c = new $d7238066c5de7f1c$var$ln(n, s.avgBytesPerSec);
            yield this.privRequestSession.onAudioSourceAttachCompleted(c, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: o
            };
            try {
                yield t, yield i;
            } catch (a) {
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.ConnectionFailure, a);
            }
            const p = new $d7238066c5de7f1c$var$Ce(this.privRequestSession.sessionId);
            return this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, p), this.receiveMessage(), this.sendAudio(c).then(()=>{}, (a)=>{
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.RuntimeError, a);
            }), this.privResultDeferral.promise;
        });
    }
    sendPreAudioMessages(e) {
        return $d7238066c5de7f1c$var$Gn(this, void 0, void 0, function*() {
            const t = yield this.fetchConnection();
            yield this.sendSpeakerRecognition(t, e);
        });
    }
    sendSpeakerRecognition(e, t) {
        return $d7238066c5de7f1c$var$Gn(this, void 0, void 0, function*() {
            const i = JSON.stringify(t);
            return e.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "speaker.context", this.privRequestSession.requestId, "application/json; charset=utf-8", i));
        });
    }
    extractSpeakerContext(e) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: e.profileIds,
            scenario: e.scenario
        };
    }
}
var $d7238066c5de7f1c$var$We = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(o) {
            o(s);
        });
    }
    return new (t || (t = Promise))(function(s, o) {
        function c(a) {
            try {
                h(i.next(a));
            } catch (d) {
                o(d);
            }
        }
        function p(a) {
            try {
                h(i.throw(a));
            } catch (d) {
                o(d);
            }
        }
        function h(a) {
            a.done ? s(a.value) : n(a.value).then(c, p);
        }
        h((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$kv extends $d7238066c5de7f1c$var$Ie {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privDeferralMap = new $d7238066c5de7f1c$var$Kd(), this.privSpeakerAudioSource = i, this.sendPrePayloadJSONOverride = ()=>this.noOp();
    }
    set SpeakerAudioSource(e) {
        this.privSpeakerAudioSource = e;
    }
    processTypeSpecificMessages(e) {
        let t = !1;
        const i = new $d7238066c5de7f1c$var$U();
        switch(e.messageType === $d7238066c5de7f1c$var$k.Text && i.setProperty($d7238066c5de7f1c$var$u.SpeechServiceResponse_JsonResult, e.textBody), e.path.toLowerCase()){
            case "speaker.profiles":
                const s = JSON.parse(e.textBody);
                switch(s.operation.toLowerCase()){
                    case "create":
                        this.handleCreateResponse(s, e.requestId);
                        break;
                    case "delete":
                    case "reset":
                        this.handleResultResponse(s, e.requestId);
                        break;
                    case "fetch":
                        const h = JSON.parse(e.textBody);
                        this.handleFetchResponse(h, e.requestId);
                        break;
                }
                t = !0;
                break;
            case "speaker.phrases":
                const o = JSON.parse(e.textBody);
                this.handlePhrasesResponse(o, e.requestId), t = !0;
                break;
            case "speaker.profile.enrollment":
                const c = JSON.parse(e.textBody), p = new $d7238066c5de7f1c$var$_t(this.enrollmentReasonFrom(c.enrollment ? c.enrollment.enrollmentStatus : c.status.statusCode), c.enrollment ? JSON.stringify(c.enrollment) : void 0, c.status.reason);
                this.privDeferralMap.getId(e.requestId) && this.privDeferralMap.complete(e.requestId, p), this.privRequestSession.onSpeechEnded(), t = !0;
                break;
        }
        const n = new $d7238066c5de7f1c$var$F();
        return n.resolve(t), n.promise;
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        new $d7238066c5de7f1c$var$U().setProperty($d7238066c5de7f1c$var$Ae, $d7238066c5de7f1c$var$T[n]);
        const c = new $d7238066c5de7f1c$var$_t($d7238066c5de7f1c$var$R.Canceled, s, s);
        this.privDeferralMap.getId(t) && this.privDeferralMap.complete(t, c);
    }
    createProfile(e, t) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            this.voiceProfileType = e.toString();
            const i = this.connectImpl();
            try {
                const n = new $d7238066c5de7f1c$var$F();
                return yield i, yield this.sendCreateProfile(n, e, t), this.receiveMessage(), n.promise;
            } catch (n) {
                throw n;
            }
        });
    }
    resetProfile(e) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            return this.voiceProfileType = e.profileType.toString(), this.sendCommonRequest("reset", e.profileType, e);
        });
    }
    deleteProfile(e) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            return this.voiceProfileType = e.profileType.toString(), this.sendCommonRequest("delete", e.profileType, e);
        });
    }
    retrieveEnrollmentResult(e) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            return this.voiceProfileType = e.profileType.toString(), this.privExpectedProfileId = e.profileId, this.sendCommonRequest("fetch", e.profileType, e);
        });
    }
    getAllProfiles(e) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            return this.voiceProfileType = e.toString(), this.sendCommonRequest("fetch", e);
        });
    }
    getActivationPhrases(e, t) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            this.voiceProfileType = e.toString();
            const i = this.connectImpl();
            try {
                const n = new $d7238066c5de7f1c$var$F();
                return yield i, yield this.sendPhrasesRequest(n, e, t), this.receiveMessage(), n.promise;
            } catch (n) {
                throw n;
            }
        });
    }
    enrollProfile(e) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            this.voiceProfileType = e.profileType.toString();
            const t = new $d7238066c5de7f1c$var$F();
            this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events), this.privRecognizerConfig.parameters.setProperty($d7238066c5de7f1c$var$u.Speech_SessionId, this.privRequestSession.sessionId);
            const i = this.connectImpl(), n = this.sendPreAudioMessages(e, t), s = yield this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId), o = yield this.privSpeakerAudioSource.format, c = yield this.privSpeakerAudioSource.deviceInfo, p = new $d7238066c5de7f1c$var$ln(s, o.avgBytesPerSec);
            yield this.privRequestSession.onAudioSourceAttachCompleted(p, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: c
            };
            try {
                yield i, yield n;
            } catch (d) {
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.ConnectionFailure, d);
            }
            const h = new $d7238066c5de7f1c$var$Ce(this.privRequestSession.sessionId);
            return this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, h), this.receiveMessage(), this.sendAudio(p).then(()=>{}, (d)=>{
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$X.Error, $d7238066c5de7f1c$var$T.RuntimeError, d);
            }), t.promise;
        });
    }
    sendPreAudioMessages(e, t) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            const i = yield this.fetchConnection();
            this.privRequestSession.onSpeechContext(), this.privDeferralMap.add(this.privRequestSession.requestId, t), yield this.sendBaseRequest(i, "enroll", this.scenarioFrom(e.profileType), e);
        });
    }
    sendPhrasesRequest(e, t, i) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            const n = yield this.fetchConnection();
            this.privRequestSession.onSpeechContext(), this.privDeferralMap.add(this.privRequestSession.requestId, e);
            const s = this.scenarioFrom(t), o = {
                locale: i,
                scenario: s
            };
            return n.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "speaker.profile.phrases", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(o)));
        });
    }
    sendCreateProfile(e, t, i) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            const n = yield this.fetchConnection();
            this.privRequestSession.onSpeechContext(), this.privDeferralMap.add(this.privRequestSession.requestId, e);
            const s = t === $d7238066c5de7f1c$var$ct.TextIndependentIdentification ? "TextIndependentIdentification" : t === $d7238066c5de7f1c$var$ct.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification", o = {
                locale: i,
                number: "1",
                scenario: s
            };
            return n.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, "speaker.profile.create", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(o)));
        });
    }
    sendCommonRequest(e, t, i) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            const n = this.connectImpl();
            try {
                const s = new $d7238066c5de7f1c$var$F();
                this.privRequestSession.onSpeechContext(), yield n;
                const o = yield this.fetchConnection();
                return this.privDeferralMap.add(this.privRequestSession.requestId, s), yield this.sendBaseRequest(o, e, this.scenarioFrom(t), i), this.receiveMessage(), s.promise;
            } catch (s) {
                throw s;
            }
        });
    }
    sendBaseRequest(e, t, i, n) {
        return $d7238066c5de7f1c$var$We(this, void 0, void 0, function*() {
            const s = {
                scenario: i
            };
            return n ? s.profileIds = [
                n.profileId
            ] : s.maxPageSize = -1, e.send(new $d7238066c5de7f1c$var$se($d7238066c5de7f1c$var$k.Text, `speaker.profile.${t}`, this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(s)));
        });
    }
    extractSpeakerContext(e) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: e.profileIds,
            scenario: e.scenario
        };
    }
    handlePhrasesResponse(e, t) {
        if (this.privDeferralMap.getId(t)) {
            if (e.status.statusCode.toLowerCase() !== "success") {
                const i = $d7238066c5de7f1c$var$R.Canceled, n = new $d7238066c5de7f1c$var$Ws(i, e.status.statusCode, e.passPhraseType, []);
                this.privDeferralMap.complete(t, n);
            } else if (e.phrases && e.phrases.length > 0) {
                const i = $d7238066c5de7f1c$var$R.EnrollingVoiceProfile, n = new $d7238066c5de7f1c$var$Ws(i, e.status.statusCode, e.passPhraseType, e.phrases);
                this.privDeferralMap.complete(t, n);
            } else throw new Error("Voice Profile get activation phrases failed, no phrases received");
        } else throw new Error(`Voice Profile get activation phrases request for requestID ${t} not found`);
    }
    handleCreateResponse(e, t) {
        if (e.profiles && e.profiles.length > 0) {
            if (this.privDeferralMap.getId(t)) {
                const i = e.profiles.map((n)=>n.profileId);
                this.privDeferralMap.complete(t, i);
            } else throw new Error(`Voice Profile create request for requestID ${t} not found`);
        } else throw new Error("Voice Profile create failed, no profile id received");
    }
    handleResultResponse(e, t) {
        if (this.privDeferralMap.getId(t)) {
            const i = e.operation.toLowerCase() === "delete" ? $d7238066c5de7f1c$var$R.DeletedVoiceProfile : $d7238066c5de7f1c$var$R.ResetVoiceProfile, n = e.status.statusCode.toLowerCase() === "success" ? i : $d7238066c5de7f1c$var$R.Canceled, s = new $d7238066c5de7f1c$var$Sn(n, `statusCode: ${e.status.statusCode}, errorDetails: ${e.status.reason}`);
            this.privDeferralMap.complete(t, s);
        } else throw new Error(`Voice Profile create request for requestID ${t} not found`);
    }
    handleFetchResponse(e, t) {
        if (this.privDeferralMap.getId(t) && e.profiles[0]) {
            if (this.privExpectedProfileId && e.profiles.length === 1 && e.profiles[0].profileId === this.privExpectedProfileId) {
                this.privExpectedProfileId = void 0;
                const i = e.profiles[0], n = new $d7238066c5de7f1c$var$_t(this.enrollmentReasonFrom(i.enrollmentStatus), JSON.stringify(i), e.status.reason);
                this.privDeferralMap.complete(t, n);
            } else if (e.profiles.length > 0) {
                const i = e.profiles, n = [];
                for (const s of i)n.push(new $d7238066c5de7f1c$var$_t(this.enrollmentReasonFrom(s.enrollmentStatus), JSON.stringify(s), e.status.reason));
                this.privDeferralMap.complete(t, n);
            }
        } else throw new Error(`Voice Profile fetch request for requestID ${t} not found`);
    }
    enrollmentReasonFrom(e) {
        switch(e.toLowerCase()){
            case "enrolled":
                return $d7238066c5de7f1c$var$R.EnrolledVoiceProfile;
            case "invalidlocale":
            case "invalidphrase":
            case "invalidaudioformat":
            case "invalidscenario":
            case "invalidprofilecount":
            case "invalidoperation":
            case "audiotooshort":
            case "audiotoolong":
            case "toomanyenrollments":
            case "storageconflict":
            case "profilenotfound":
            case "incompatibleprofiles":
            case "incompleteenrollment":
                return $d7238066c5de7f1c$var$R.Canceled;
            default:
                return $d7238066c5de7f1c$var$R.EnrollingVoiceProfile;
        }
    }
    scenarioFrom(e) {
        return e === $d7238066c5de7f1c$var$ct.TextIndependentIdentification ? "TextIndependentIdentification" : e === $d7238066c5de7f1c$var$ct.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification";
    }
}
class $d7238066c5de7f1c$var$wn {
    constructor(e){
        this.context = e;
    }
    serialize() {
        return JSON.stringify(this, (e, t)=>{
            if (t && typeof t == "object" && !Array.isArray(t)) {
                const i = {};
                for(const n in t)Object.hasOwnProperty.call(t, n) && (i[n && n.charAt(0).toLowerCase() + n.substring(1)] = t[n]);
                return i;
            }
            return t;
        });
    }
    get Context() {
        return this.context;
    }
    get Recognition() {
        return this.recognition;
    }
    set Recognition(e) {
        this.recognition = e.toLowerCase();
    }
}
class $d7238066c5de7f1c$var$Rn {
    constructor(e){
        this.system = new $d7238066c5de7f1c$var$Dv(), this.os = e;
    }
}
class $d7238066c5de7f1c$var$Dv {
    constructor(){
        const e = "1.33.1";
        this.name = "SpeechSDK", this.version = e, this.build = "JavaScript", this.lang = "JavaScript";
    }
}
class $d7238066c5de7f1c$var$dh {
    constructor(e, t, i){
        this.platform = e, this.name = t, this.version = i;
    }
}
var $d7238066c5de7f1c$var$Ri;
(function(r) {
    r.Bluetooth = "Bluetooth", r.Wired = "Wired", r.WiFi = "WiFi", r.Cellular = "Cellular", r.InBuilt = "InBuilt", r.Unknown = "Unknown";
})($d7238066c5de7f1c$var$Ri || ($d7238066c5de7f1c$var$Ri = {}));
var $d7238066c5de7f1c$var$Qt;
(function(r) {
    r.Phone = "Phone", r.Speaker = "Speaker", r.Car = "Car", r.Headset = "Headset", r.Thermostat = "Thermostat", r.Microphones = "Microphones", r.Deskphone = "Deskphone", r.RemoteControl = "RemoteControl", r.Unknown = "Unknown", r.File = "File", r.Stream = "Stream";
})($d7238066c5de7f1c$var$Qt || ($d7238066c5de7f1c$var$Qt = {}));
const $d7238066c5de7f1c$var$$e = "OutputFormat", $d7238066c5de7f1c$var$Ae = "CancellationErrorCode", $d7238066c5de7f1c$var$It = "ServiceProperties", $d7238066c5de7f1c$var$aa = "ForceDictation", $d7238066c5de7f1c$var$lh = "OpenRange", $d7238066c5de7f1c$var$Ov = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    ActivityReceivedEventArgs: $d7238066c5de7f1c$var$Up,
    AudioConfig: $d7238066c5de7f1c$var$bt,
    get AudioFormatTag () {
        return $d7238066c5de7f1c$var$E;
    },
    AudioInputStream: $d7238066c5de7f1c$var$ur,
    AudioOutputStream: $d7238066c5de7f1c$var$vn,
    AudioStreamFormat: $d7238066c5de7f1c$var$bi,
    AutoDetectSourceLanguageConfig: $d7238066c5de7f1c$var$Fi,
    AutoDetectSourceLanguageResult: $d7238066c5de7f1c$var$en,
    AvatarConfig: $d7238066c5de7f1c$var$bl,
    AvatarEventArgs: $d7238066c5de7f1c$var$Xp,
    AvatarSynthesizer: $d7238066c5de7f1c$var$El,
    AvatarVideoFormat: $d7238066c5de7f1c$var$th,
    AvatarWebRTCConnectionResult: $d7238066c5de7f1c$var$kl,
    BaseAudioPlayer: $d7238066c5de7f1c$var$fl,
    BotFrameworkConfig: $d7238066c5de7f1c$var$ul,
    CancellationDetails: $d7238066c5de7f1c$var$Mo,
    CancellationDetailsBase: $d7238066c5de7f1c$var$lr,
    get CancellationErrorCode () {
        return $d7238066c5de7f1c$var$T;
    },
    get CancellationReason () {
        return $d7238066c5de7f1c$var$X;
    },
    Connection: $d7238066c5de7f1c$var$Jt,
    ConnectionEventArgs: $d7238066c5de7f1c$var$Us,
    ConnectionMessage: $d7238066c5de7f1c$var$pl,
    ConnectionMessageEventArgs: $d7238066c5de7f1c$var$qs,
    Conversation: $d7238066c5de7f1c$var$Hp,
    ConversationExpirationEventArgs: $d7238066c5de7f1c$var$Fp,
    ConversationParticipantsChangedEventArgs: $d7238066c5de7f1c$var$Ye,
    ConversationTranscriber: $d7238066c5de7f1c$var$Fo,
    ConversationTranscriptionCanceledEventArgs: $d7238066c5de7f1c$var$Ko,
    ConversationTranscriptionEventArgs: $d7238066c5de7f1c$var$_s,
    ConversationTranscriptionResult: $d7238066c5de7f1c$var$Vr,
    ConversationTranslationCanceledEventArgs: $d7238066c5de7f1c$var$Ho,
    ConversationTranslationEventArgs: $d7238066c5de7f1c$var$Vt,
    ConversationTranslationResult: $d7238066c5de7f1c$var$Fs,
    ConversationTranslator: $d7238066c5de7f1c$var$Cl,
    Coordinate: $d7238066c5de7f1c$var$Al,
    CustomCommandsConfig: $d7238066c5de7f1c$var$dl,
    Diagnostics: $d7238066c5de7f1c$var$ih,
    DialogServiceConfig: $d7238066c5de7f1c$var$_e,
    DialogServiceConnector: $d7238066c5de7f1c$var$ll,
    IntentRecognitionCanceledEventArgs: $d7238066c5de7f1c$var$$p,
    IntentRecognitionEventArgs: $d7238066c5de7f1c$var$ui,
    IntentRecognitionResult: $d7238066c5de7f1c$var$hi,
    IntentRecognizer: $d7238066c5de7f1c$var$cl,
    KeywordRecognitionModel: $d7238066c5de7f1c$var$nl,
    get LanguageIdMode () {
        return $d7238066c5de7f1c$var$er;
    },
    LanguageUnderstandingModel: $d7238066c5de7f1c$var$Lp,
    get LogLevel () {
        return $d7238066c5de7f1c$var$ce;
    },
    Meeting: $d7238066c5de7f1c$var$Vp,
    MeetingTranscriber: $d7238066c5de7f1c$var$Il,
    MeetingTranscriptionCanceledEventArgs: $d7238066c5de7f1c$var$Zp,
    MeetingTranscriptionEventArgs: $d7238066c5de7f1c$var$sl,
    NoMatchDetails: $d7238066c5de7f1c$var$No,
    get NoMatchReason () {
        return $d7238066c5de7f1c$var$Ft;
    },
    get OutputFormat () {
        return $d7238066c5de7f1c$var$B;
    },
    Participant: $d7238066c5de7f1c$var$vr,
    get ParticipantChangedReason () {
        return $d7238066c5de7f1c$var$xe;
    },
    PhraseListGrammar: $d7238066c5de7f1c$var$xo,
    get ProfanityOption () {
        return $d7238066c5de7f1c$var$Gt;
    },
    PronunciationAssessmentConfig: $d7238066c5de7f1c$var$jo,
    get PronunciationAssessmentGradingSystem () {
        return $d7238066c5de7f1c$var$ir;
    },
    get PronunciationAssessmentGranularity () {
        return $d7238066c5de7f1c$var$rr;
    },
    PronunciationAssessmentResult: $d7238066c5de7f1c$var$Jo,
    PropertyCollection: $d7238066c5de7f1c$var$U,
    get PropertyId () {
        return $d7238066c5de7f1c$var$u;
    },
    PullAudioInputStream: $d7238066c5de7f1c$var$Io,
    PullAudioInputStreamCallback: $d7238066c5de7f1c$var$_p,
    PullAudioOutputStream: $d7238066c5de7f1c$var$dr,
    PushAudioInputStream: $d7238066c5de7f1c$var$Ro,
    PushAudioOutputStream: $d7238066c5de7f1c$var$Po,
    PushAudioOutputStreamCallback: $d7238066c5de7f1c$var$Eo,
    RecognitionEventArgs: $d7238066c5de7f1c$var$Xe,
    RecognitionResult: $d7238066c5de7f1c$var$fn,
    Recognizer: $d7238066c5de7f1c$var$Fe,
    get ResultReason () {
        return $d7238066c5de7f1c$var$R;
    },
    ServiceEventArgs: $d7238066c5de7f1c$var$Bp,
    get ServicePropertyChannel () {
        return $d7238066c5de7f1c$var$Xr;
    },
    SessionEventArgs: $d7238066c5de7f1c$var$Ce,
    SourceLanguageConfig: $d7238066c5de7f1c$var$qo,
    SpeakerAudioDestination: $d7238066c5de7f1c$var$Js,
    SpeakerIdentificationModel: $d7238066c5de7f1c$var$Bo,
    SpeakerRecognitionCancellationDetails: $d7238066c5de7f1c$var$Wo,
    SpeakerRecognitionResult: $d7238066c5de7f1c$var$Wr,
    get SpeakerRecognitionResultType () {
        return $d7238066c5de7f1c$var$fi;
    },
    SpeakerRecognizer: $d7238066c5de7f1c$var$ml,
    SpeakerVerificationModel: $d7238066c5de7f1c$var$Uo,
    SpeechConfig: $d7238066c5de7f1c$var$ko,
    SpeechConfigImpl: $d7238066c5de7f1c$var$xt,
    SpeechRecognitionCanceledEventArgs: $d7238066c5de7f1c$var$Ao,
    SpeechRecognitionEventArgs: $d7238066c5de7f1c$var$Rt,
    SpeechRecognitionResult: $d7238066c5de7f1c$var$Oe,
    SpeechRecognizer: $d7238066c5de7f1c$var$Oo,
    SpeechSynthesisBookmarkEventArgs: $d7238066c5de7f1c$var$Gp,
    get SpeechSynthesisBoundaryType () {
        return $d7238066c5de7f1c$var$Ks;
    },
    SpeechSynthesisEventArgs: $d7238066c5de7f1c$var$Wi,
    get SpeechSynthesisOutputFormat () {
        return $d7238066c5de7f1c$var$M;
    },
    SpeechSynthesisResult: $d7238066c5de7f1c$var$tr,
    SpeechSynthesisVisemeEventArgs: $d7238066c5de7f1c$var$Qp,
    SpeechSynthesisWordBoundaryEventArgs: $d7238066c5de7f1c$var$Jp,
    SpeechSynthesizer: $d7238066c5de7f1c$var$Vo,
    SpeechTranslationConfig: $d7238066c5de7f1c$var$Do,
    SpeechTranslationConfigImpl: $d7238066c5de7f1c$var$qi,
    SynthesisResult: $d7238066c5de7f1c$var$Kt,
    SynthesisVoicesResult: $d7238066c5de7f1c$var$js,
    Synthesizer: $d7238066c5de7f1c$var$fr,
    TranslationRecognitionCanceledEventArgs: $d7238066c5de7f1c$var$Bs,
    TranslationRecognitionEventArgs: $d7238066c5de7f1c$var$Ui,
    TranslationRecognitionResult: $d7238066c5de7f1c$var$yt,
    TranslationRecognizer: $d7238066c5de7f1c$var$mn,
    TranslationSynthesisEventArgs: $d7238066c5de7f1c$var$Ls,
    TranslationSynthesisResult: $d7238066c5de7f1c$var$$s,
    Translations: $d7238066c5de7f1c$var$zo,
    TurnStatusReceivedEventArgs: $d7238066c5de7f1c$var$qp,
    User: $d7238066c5de7f1c$var$Rl,
    VoiceInfo: $d7238066c5de7f1c$var$Yp,
    VoiceProfile: $d7238066c5de7f1c$var$Wp,
    VoiceProfileCancellationDetails: $d7238066c5de7f1c$var$$o,
    VoiceProfileClient: $d7238066c5de7f1c$var$gl,
    VoiceProfileEnrollmentCancellationDetails: $d7238066c5de7f1c$var$Lo,
    VoiceProfileEnrollmentResult: $d7238066c5de7f1c$var$_t,
    VoiceProfilePhraseResult: $d7238066c5de7f1c$var$Ws,
    VoiceProfileResult: $d7238066c5de7f1c$var$Sn,
    get VoiceProfileType () {
        return $d7238066c5de7f1c$var$ct;
    }
}, Symbol.toStringTag, {
    value: "Module"
})), $d7238066c5de7f1c$var$zv = /* @__PURE__ */ $d7238066c5de7f1c$var$_d($d7238066c5de7f1c$var$Ov);
var $d7238066c5de7f1c$var$vh = {
    exports: {}
};
(function(r) {
    function e(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    }
    r.exports = e, r.exports.__esModule = !0, r.exports.default = r.exports;
})($d7238066c5de7f1c$var$vh);
var $d7238066c5de7f1c$var$Nv = $d7238066c5de7f1c$var$vh.exports, $d7238066c5de7f1c$var$_i = function(r) {
    return r && r.Math === Math && r;
}, $d7238066c5de7f1c$var$de = // eslint-disable-next-line es/no-global-this -- safe
$d7238066c5de7f1c$var$_i(typeof globalThis == "object" && globalThis) || $d7238066c5de7f1c$var$_i(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$d7238066c5de7f1c$var$_i(typeof self == "object" && self) || $d7238066c5de7f1c$var$_i(typeof $d7238066c5de7f1c$var$Tr == "object" && $d7238066c5de7f1c$var$Tr) || $d7238066c5de7f1c$var$_i(typeof $d7238066c5de7f1c$var$Tr == "object" && $d7238066c5de7f1c$var$Tr) || // eslint-disable-next-line no-new-func -- fallback
/* @__PURE__ */ function() {
    return this;
}() || Function("return this")(), $d7238066c5de7f1c$var$Be = function(r) {
    try {
        return !!r();
    } catch  {
        return !0;
    }
}, $d7238066c5de7f1c$var$Mv = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$In = !$d7238066c5de7f1c$var$Mv(function() {
    var r = (function() {}).bind();
    return typeof r != "function" || r.hasOwnProperty("prototype");
}), $d7238066c5de7f1c$var$xv = $d7238066c5de7f1c$var$In, $d7238066c5de7f1c$var$fh = Function.prototype, $d7238066c5de7f1c$var$ic = $d7238066c5de7f1c$var$fh.apply, $d7238066c5de7f1c$var$rc = $d7238066c5de7f1c$var$fh.call, $d7238066c5de7f1c$var$ca = typeof Reflect == "object" && Reflect.apply || ($d7238066c5de7f1c$var$xv ? $d7238066c5de7f1c$var$rc.bind($d7238066c5de7f1c$var$ic) : function() {
    return $d7238066c5de7f1c$var$rc.apply($d7238066c5de7f1c$var$ic, arguments);
}), $d7238066c5de7f1c$var$gh = $d7238066c5de7f1c$var$In, $d7238066c5de7f1c$var$mh = Function.prototype, $d7238066c5de7f1c$var$Zs = $d7238066c5de7f1c$var$mh.call, $d7238066c5de7f1c$var$_v = $d7238066c5de7f1c$var$gh && $d7238066c5de7f1c$var$mh.bind.bind($d7238066c5de7f1c$var$Zs, $d7238066c5de7f1c$var$Zs), $d7238066c5de7f1c$var$Ne = $d7238066c5de7f1c$var$gh ? $d7238066c5de7f1c$var$_v : function(r) {
    return function() {
        return $d7238066c5de7f1c$var$Zs.apply(r, arguments);
    };
}, $d7238066c5de7f1c$var$Sh = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$Lv = $d7238066c5de7f1c$var$Sh({}.toString), $d7238066c5de7f1c$var$$v = $d7238066c5de7f1c$var$Sh("".slice), $d7238066c5de7f1c$var$Tn = function(r) {
    return $d7238066c5de7f1c$var$$v($d7238066c5de7f1c$var$Lv(r), 8, -1);
}, $d7238066c5de7f1c$var$Bv = $d7238066c5de7f1c$var$Tn, $d7238066c5de7f1c$var$Uv = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$yh = function(r) {
    if ($d7238066c5de7f1c$var$Bv(r) === "Function") return $d7238066c5de7f1c$var$Uv(r);
}, $d7238066c5de7f1c$var$Qn = typeof document == "object" && document.all, $d7238066c5de7f1c$var$Pe = typeof $d7238066c5de7f1c$var$Qn > "u" && $d7238066c5de7f1c$var$Qn !== void 0 ? function(r) {
    return typeof r == "function" || r === $d7238066c5de7f1c$var$Qn;
} : function(r) {
    return typeof r == "function";
}, $d7238066c5de7f1c$var$pa = {}, $d7238066c5de7f1c$var$qv = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$Dt = !$d7238066c5de7f1c$var$qv(function() {
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
}), $d7238066c5de7f1c$var$Wv = $d7238066c5de7f1c$var$In, $d7238066c5de7f1c$var$Ar = Function.prototype.call, $d7238066c5de7f1c$var$Ke = $d7238066c5de7f1c$var$Wv ? $d7238066c5de7f1c$var$Ar.bind($d7238066c5de7f1c$var$Ar) : function() {
    return $d7238066c5de7f1c$var$Ar.apply($d7238066c5de7f1c$var$Ar, arguments);
}, $d7238066c5de7f1c$var$Ch = {}, $d7238066c5de7f1c$var$wh = {}.propertyIsEnumerable, $d7238066c5de7f1c$var$Rh = Object.getOwnPropertyDescriptor, $d7238066c5de7f1c$var$Hv = $d7238066c5de7f1c$var$Rh && !$d7238066c5de7f1c$var$wh.call({
    1: 2
}, 1);
$d7238066c5de7f1c$var$Ch.f = $d7238066c5de7f1c$var$Hv ? function(e) {
    var t = $d7238066c5de7f1c$var$Rh(this, e);
    return !!t && t.enumerable;
} : $d7238066c5de7f1c$var$wh;
var $d7238066c5de7f1c$var$mr = function(r, e) {
    return {
        enumerable: !(r & 1),
        configurable: !(r & 2),
        writable: !(r & 4),
        value: e
    };
}, $d7238066c5de7f1c$var$Fv = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$Vv = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$Kv = $d7238066c5de7f1c$var$Tn, $d7238066c5de7f1c$var$Yn = Object, $d7238066c5de7f1c$var$jv = $d7238066c5de7f1c$var$Fv("".split), $d7238066c5de7f1c$var$Jv = $d7238066c5de7f1c$var$Vv(function() {
    return !$d7238066c5de7f1c$var$Yn("z").propertyIsEnumerable(0);
}) ? function(r) {
    return $d7238066c5de7f1c$var$Kv(r) === "String" ? $d7238066c5de7f1c$var$jv(r, "") : $d7238066c5de7f1c$var$Yn(r);
} : $d7238066c5de7f1c$var$Yn, $d7238066c5de7f1c$var$Pn = function(r) {
    return r == null;
}, $d7238066c5de7f1c$var$Gv = $d7238066c5de7f1c$var$Pn, $d7238066c5de7f1c$var$Qv = TypeError, $d7238066c5de7f1c$var$bn = function(r) {
    if ($d7238066c5de7f1c$var$Gv(r)) throw new $d7238066c5de7f1c$var$Qv("Can't call method on " + r);
    return r;
}, $d7238066c5de7f1c$var$Yv = $d7238066c5de7f1c$var$Jv, $d7238066c5de7f1c$var$Zv = $d7238066c5de7f1c$var$bn, $d7238066c5de7f1c$var$Sr = function(r) {
    return $d7238066c5de7f1c$var$Yv($d7238066c5de7f1c$var$Zv(r));
}, $d7238066c5de7f1c$var$Xv = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$et = function(r) {
    return typeof r == "object" ? r !== null : $d7238066c5de7f1c$var$Xv(r);
}, $d7238066c5de7f1c$var$En = {}, $d7238066c5de7f1c$var$Zn = $d7238066c5de7f1c$var$En, $d7238066c5de7f1c$var$Xn = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$ef = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$nc = function(r) {
    return $d7238066c5de7f1c$var$ef(r) ? r : void 0;
}, $d7238066c5de7f1c$var$Bt = function(r, e) {
    return arguments.length < 2 ? $d7238066c5de7f1c$var$nc($d7238066c5de7f1c$var$Zn[r]) || $d7238066c5de7f1c$var$nc($d7238066c5de7f1c$var$Xn[r]) : $d7238066c5de7f1c$var$Zn[r] && $d7238066c5de7f1c$var$Zn[r][e] || $d7238066c5de7f1c$var$Xn[r] && $d7238066c5de7f1c$var$Xn[r][e];
}, $d7238066c5de7f1c$var$tf = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$An = $d7238066c5de7f1c$var$tf({}.isPrototypeOf), $d7238066c5de7f1c$var$rf = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$sc = $d7238066c5de7f1c$var$rf.navigator, $d7238066c5de7f1c$var$oc = $d7238066c5de7f1c$var$sc && $d7238066c5de7f1c$var$sc.userAgent, $d7238066c5de7f1c$var$yr = $d7238066c5de7f1c$var$oc ? String($d7238066c5de7f1c$var$oc) : "", $d7238066c5de7f1c$var$Ih = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$es = $d7238066c5de7f1c$var$yr, $d7238066c5de7f1c$var$ac = $d7238066c5de7f1c$var$Ih.process, $d7238066c5de7f1c$var$cc = $d7238066c5de7f1c$var$Ih.Deno, $d7238066c5de7f1c$var$pc = $d7238066c5de7f1c$var$ac && $d7238066c5de7f1c$var$ac.versions || $d7238066c5de7f1c$var$cc && $d7238066c5de7f1c$var$cc.version, $d7238066c5de7f1c$var$hc = $d7238066c5de7f1c$var$pc && $d7238066c5de7f1c$var$pc.v8, $d7238066c5de7f1c$var$Qe, $d7238066c5de7f1c$var$sn;
$d7238066c5de7f1c$var$hc && ($d7238066c5de7f1c$var$Qe = $d7238066c5de7f1c$var$hc.split("."), $d7238066c5de7f1c$var$sn = $d7238066c5de7f1c$var$Qe[0] > 0 && $d7238066c5de7f1c$var$Qe[0] < 4 ? 1 : +($d7238066c5de7f1c$var$Qe[0] + $d7238066c5de7f1c$var$Qe[1]));
!$d7238066c5de7f1c$var$sn && $d7238066c5de7f1c$var$es && ($d7238066c5de7f1c$var$Qe = $d7238066c5de7f1c$var$es.match(/Edge\/(\d+)/), (!$d7238066c5de7f1c$var$Qe || $d7238066c5de7f1c$var$Qe[1] >= 74) && ($d7238066c5de7f1c$var$Qe = $d7238066c5de7f1c$var$es.match(/Chrome\/(\d+)/), $d7238066c5de7f1c$var$Qe && ($d7238066c5de7f1c$var$sn = +$d7238066c5de7f1c$var$Qe[1])));
var $d7238066c5de7f1c$var$Th = $d7238066c5de7f1c$var$sn, $d7238066c5de7f1c$var$uc = $d7238066c5de7f1c$var$Th, $d7238066c5de7f1c$var$nf = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$sf = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$of = $d7238066c5de7f1c$var$sf.String, $d7238066c5de7f1c$var$Ph = !!Object.getOwnPropertySymbols && !$d7238066c5de7f1c$var$nf(function() {
    var r = Symbol("symbol detection");
    return !$d7238066c5de7f1c$var$of(r) || !(Object(r) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $d7238066c5de7f1c$var$uc && $d7238066c5de7f1c$var$uc < 41;
}), $d7238066c5de7f1c$var$af = $d7238066c5de7f1c$var$Ph, $d7238066c5de7f1c$var$bh = $d7238066c5de7f1c$var$af && !Symbol.sham && typeof Symbol.iterator == "symbol", $d7238066c5de7f1c$var$cf = $d7238066c5de7f1c$var$Bt, $d7238066c5de7f1c$var$pf = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$hf = $d7238066c5de7f1c$var$An, $d7238066c5de7f1c$var$uf = $d7238066c5de7f1c$var$bh, $d7238066c5de7f1c$var$df = Object, $d7238066c5de7f1c$var$Eh = $d7238066c5de7f1c$var$uf ? function(r) {
    return typeof r == "symbol";
} : function(r) {
    var e = $d7238066c5de7f1c$var$cf("Symbol");
    return $d7238066c5de7f1c$var$pf(e) && $d7238066c5de7f1c$var$hf(e.prototype, $d7238066c5de7f1c$var$df(r));
}, $d7238066c5de7f1c$var$lf = String, $d7238066c5de7f1c$var$kn = function(r) {
    try {
        return $d7238066c5de7f1c$var$lf(r);
    } catch  {
        return "Object";
    }
}, $d7238066c5de7f1c$var$vf = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$ff = $d7238066c5de7f1c$var$kn, $d7238066c5de7f1c$var$gf = TypeError, $d7238066c5de7f1c$var$tt = function(r) {
    if ($d7238066c5de7f1c$var$vf(r)) return r;
    throw new $d7238066c5de7f1c$var$gf($d7238066c5de7f1c$var$ff(r) + " is not a function");
}, $d7238066c5de7f1c$var$mf = $d7238066c5de7f1c$var$tt, $d7238066c5de7f1c$var$Sf = $d7238066c5de7f1c$var$Pn, $d7238066c5de7f1c$var$ha = function(r, e) {
    var t = r[e];
    return $d7238066c5de7f1c$var$Sf(t) ? void 0 : $d7238066c5de7f1c$var$mf(t);
}, $d7238066c5de7f1c$var$ts = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$is = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$rs = $d7238066c5de7f1c$var$et, $d7238066c5de7f1c$var$yf = TypeError, $d7238066c5de7f1c$var$Cf = function(r, e) {
    var t, i;
    if (e === "string" && $d7238066c5de7f1c$var$is(t = r.toString) && !$d7238066c5de7f1c$var$rs(i = $d7238066c5de7f1c$var$ts(t, r)) || $d7238066c5de7f1c$var$is(t = r.valueOf) && !$d7238066c5de7f1c$var$rs(i = $d7238066c5de7f1c$var$ts(t, r)) || e !== "string" && $d7238066c5de7f1c$var$is(t = r.toString) && !$d7238066c5de7f1c$var$rs(i = $d7238066c5de7f1c$var$ts(t, r))) return i;
    throw new $d7238066c5de7f1c$var$yf("Can't convert object to primitive value");
}, $d7238066c5de7f1c$var$Ah = {
    exports: {}
}, $d7238066c5de7f1c$var$wf = !0, $d7238066c5de7f1c$var$dc = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$Rf = Object.defineProperty, $d7238066c5de7f1c$var$If = function(r, e) {
    try {
        $d7238066c5de7f1c$var$Rf($d7238066c5de7f1c$var$dc, r, {
            value: e,
            configurable: !0,
            writable: !0
        });
    } catch  {
        $d7238066c5de7f1c$var$dc[r] = e;
    }
    return e;
}, $d7238066c5de7f1c$var$Tf = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$Pf = $d7238066c5de7f1c$var$If, $d7238066c5de7f1c$var$lc = "__core-js_shared__", $d7238066c5de7f1c$var$vc = $d7238066c5de7f1c$var$Ah.exports = $d7238066c5de7f1c$var$Tf[$d7238066c5de7f1c$var$lc] || $d7238066c5de7f1c$var$Pf($d7238066c5de7f1c$var$lc, {});
($d7238066c5de7f1c$var$vc.versions || ($d7238066c5de7f1c$var$vc.versions = [])).push({
    version: "3.49.0",
    mode: "pure",
    copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
    license: "https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $d7238066c5de7f1c$var$ua = $d7238066c5de7f1c$var$Ah.exports, $d7238066c5de7f1c$var$fc = $d7238066c5de7f1c$var$ua, $d7238066c5de7f1c$var$kh = function(r, e) {
    return $d7238066c5de7f1c$var$fc[r] || ($d7238066c5de7f1c$var$fc[r] = e || {});
}, $d7238066c5de7f1c$var$bf = $d7238066c5de7f1c$var$bn, $d7238066c5de7f1c$var$Ef = Object, $d7238066c5de7f1c$var$Dh = function(r) {
    return $d7238066c5de7f1c$var$Ef($d7238066c5de7f1c$var$bf(r));
}, $d7238066c5de7f1c$var$Af = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$kf = $d7238066c5de7f1c$var$Dh, $d7238066c5de7f1c$var$Df = $d7238066c5de7f1c$var$Af({}.hasOwnProperty), $d7238066c5de7f1c$var$dt = Object.hasOwn || function(e, t) {
    return $d7238066c5de7f1c$var$Df($d7238066c5de7f1c$var$kf(e), t);
}, $d7238066c5de7f1c$var$Of = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$zf = 0, $d7238066c5de7f1c$var$Nf = Math.random(), $d7238066c5de7f1c$var$Mf = $d7238066c5de7f1c$var$Of(1.1.toString), $d7238066c5de7f1c$var$Oh = function(r) {
    return "Symbol(" + (r === void 0 ? "" : r) + ")_" + $d7238066c5de7f1c$var$Mf(++$d7238066c5de7f1c$var$zf + $d7238066c5de7f1c$var$Nf, 36);
}, $d7238066c5de7f1c$var$xf = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$_f = $d7238066c5de7f1c$var$kh, $d7238066c5de7f1c$var$gc = $d7238066c5de7f1c$var$dt, $d7238066c5de7f1c$var$Lf = $d7238066c5de7f1c$var$Oh, $d7238066c5de7f1c$var$$f = $d7238066c5de7f1c$var$Ph, $d7238066c5de7f1c$var$Bf = $d7238066c5de7f1c$var$bh, $d7238066c5de7f1c$var$di = $d7238066c5de7f1c$var$xf.Symbol, $d7238066c5de7f1c$var$ns = $d7238066c5de7f1c$var$_f("wks"), $d7238066c5de7f1c$var$Uf = $d7238066c5de7f1c$var$Bf ? $d7238066c5de7f1c$var$di.for || $d7238066c5de7f1c$var$di : $d7238066c5de7f1c$var$di && $d7238066c5de7f1c$var$di.withoutSetter || $d7238066c5de7f1c$var$Lf, $d7238066c5de7f1c$var$Ue = function(r) {
    return $d7238066c5de7f1c$var$gc($d7238066c5de7f1c$var$ns, r) || ($d7238066c5de7f1c$var$ns[r] = $d7238066c5de7f1c$var$$f && $d7238066c5de7f1c$var$gc($d7238066c5de7f1c$var$di, r) ? $d7238066c5de7f1c$var$di[r] : $d7238066c5de7f1c$var$Uf("Symbol." + r)), $d7238066c5de7f1c$var$ns[r];
}, $d7238066c5de7f1c$var$qf = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$mc = $d7238066c5de7f1c$var$et, $d7238066c5de7f1c$var$Sc = $d7238066c5de7f1c$var$Eh, $d7238066c5de7f1c$var$Wf = $d7238066c5de7f1c$var$ha, $d7238066c5de7f1c$var$Hf = $d7238066c5de7f1c$var$Cf, $d7238066c5de7f1c$var$Ff = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$Vf = TypeError, $d7238066c5de7f1c$var$Kf = $d7238066c5de7f1c$var$Ff("toPrimitive"), $d7238066c5de7f1c$var$jf = function(r, e) {
    if (!$d7238066c5de7f1c$var$mc(r) || $d7238066c5de7f1c$var$Sc(r)) return r;
    var t = $d7238066c5de7f1c$var$Wf(r, $d7238066c5de7f1c$var$Kf), i;
    if (t) {
        if (e === void 0 && (e = "default"), i = $d7238066c5de7f1c$var$qf(t, r, e), !$d7238066c5de7f1c$var$mc(i) || $d7238066c5de7f1c$var$Sc(i)) return i;
        throw new $d7238066c5de7f1c$var$Vf("Can't convert object to primitive value");
    }
    return e === void 0 && (e = "number"), $d7238066c5de7f1c$var$Hf(r, e);
}, $d7238066c5de7f1c$var$Jf = $d7238066c5de7f1c$var$jf, $d7238066c5de7f1c$var$Gf = $d7238066c5de7f1c$var$Eh, $d7238066c5de7f1c$var$zh = function(r) {
    var e = $d7238066c5de7f1c$var$Jf(r, "string");
    return $d7238066c5de7f1c$var$Gf(e) ? e : e + "";
}, $d7238066c5de7f1c$var$Qf = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$yc = $d7238066c5de7f1c$var$et, $d7238066c5de7f1c$var$Xs = $d7238066c5de7f1c$var$Qf.document, $d7238066c5de7f1c$var$Yf = $d7238066c5de7f1c$var$yc($d7238066c5de7f1c$var$Xs) && $d7238066c5de7f1c$var$yc($d7238066c5de7f1c$var$Xs.createElement), $d7238066c5de7f1c$var$da = function(r) {
    return $d7238066c5de7f1c$var$Yf ? $d7238066c5de7f1c$var$Xs.createElement(r) : {};
}, $d7238066c5de7f1c$var$Zf = $d7238066c5de7f1c$var$Dt, $d7238066c5de7f1c$var$Xf = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$eg = $d7238066c5de7f1c$var$da, $d7238066c5de7f1c$var$Nh = !$d7238066c5de7f1c$var$Zf && !$d7238066c5de7f1c$var$Xf(function() {
    return Object.defineProperty($d7238066c5de7f1c$var$eg("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
}), $d7238066c5de7f1c$var$tg = $d7238066c5de7f1c$var$Dt, $d7238066c5de7f1c$var$ig = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$rg = $d7238066c5de7f1c$var$Ch, $d7238066c5de7f1c$var$ng = $d7238066c5de7f1c$var$mr, $d7238066c5de7f1c$var$sg = $d7238066c5de7f1c$var$Sr, $d7238066c5de7f1c$var$og = $d7238066c5de7f1c$var$zh, $d7238066c5de7f1c$var$ag = $d7238066c5de7f1c$var$dt, $d7238066c5de7f1c$var$cg = $d7238066c5de7f1c$var$Nh, $d7238066c5de7f1c$var$Cc = Object.getOwnPropertyDescriptor;
$d7238066c5de7f1c$var$pa.f = $d7238066c5de7f1c$var$tg ? $d7238066c5de7f1c$var$Cc : function(e, t) {
    if (e = $d7238066c5de7f1c$var$sg(e), t = $d7238066c5de7f1c$var$og(t), $d7238066c5de7f1c$var$cg) try {
        return $d7238066c5de7f1c$var$Cc(e, t);
    } catch  {}
    if ($d7238066c5de7f1c$var$ag(e, t)) return $d7238066c5de7f1c$var$ng(!$d7238066c5de7f1c$var$ig($d7238066c5de7f1c$var$rg.f, e, t), e[t]);
};
var $d7238066c5de7f1c$var$pg = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$hg = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$ug = /#|\.prototype\./, $d7238066c5de7f1c$var$Cr = function(r, e) {
    var t = $d7238066c5de7f1c$var$lg[$d7238066c5de7f1c$var$dg(r)];
    return t === $d7238066c5de7f1c$var$fg ? !0 : t === $d7238066c5de7f1c$var$vg ? !1 : $d7238066c5de7f1c$var$hg(e) ? $d7238066c5de7f1c$var$pg(e) : !!e;
}, $d7238066c5de7f1c$var$dg = $d7238066c5de7f1c$var$Cr.normalize = function(r) {
    return String(r).replace($d7238066c5de7f1c$var$ug, ".").toLowerCase();
}, $d7238066c5de7f1c$var$lg = $d7238066c5de7f1c$var$Cr.data = {}, $d7238066c5de7f1c$var$vg = $d7238066c5de7f1c$var$Cr.NATIVE = "N", $d7238066c5de7f1c$var$fg = $d7238066c5de7f1c$var$Cr.POLYFILL = "P", $d7238066c5de7f1c$var$Mh = $d7238066c5de7f1c$var$Cr, $d7238066c5de7f1c$var$wc = $d7238066c5de7f1c$var$yh, $d7238066c5de7f1c$var$gg = $d7238066c5de7f1c$var$tt, $d7238066c5de7f1c$var$mg = $d7238066c5de7f1c$var$In, $d7238066c5de7f1c$var$Sg = $d7238066c5de7f1c$var$wc($d7238066c5de7f1c$var$wc.bind), $d7238066c5de7f1c$var$Dn = function(r, e) {
    return $d7238066c5de7f1c$var$gg(r), e === void 0 ? r : $d7238066c5de7f1c$var$mg ? $d7238066c5de7f1c$var$Sg(r, e) : function() {
        return r.apply(e, arguments);
    };
}, $d7238066c5de7f1c$var$Xt = {}, $d7238066c5de7f1c$var$yg = $d7238066c5de7f1c$var$Dt, $d7238066c5de7f1c$var$Cg = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$xh = $d7238066c5de7f1c$var$yg && $d7238066c5de7f1c$var$Cg(function() {
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: !1
    }).prototype !== 42;
}), $d7238066c5de7f1c$var$wg = $d7238066c5de7f1c$var$et, $d7238066c5de7f1c$var$Rg = String, $d7238066c5de7f1c$var$Ig = TypeError, $d7238066c5de7f1c$var$Ot = function(r) {
    if ($d7238066c5de7f1c$var$wg(r)) return r;
    throw new $d7238066c5de7f1c$var$Ig($d7238066c5de7f1c$var$Rg(r) + " is not an object");
}, $d7238066c5de7f1c$var$Tg = $d7238066c5de7f1c$var$Dt, $d7238066c5de7f1c$var$Pg = $d7238066c5de7f1c$var$Nh, $d7238066c5de7f1c$var$bg = $d7238066c5de7f1c$var$xh, $d7238066c5de7f1c$var$kr = $d7238066c5de7f1c$var$Ot, $d7238066c5de7f1c$var$Rc = $d7238066c5de7f1c$var$zh, $d7238066c5de7f1c$var$Eg = TypeError, $d7238066c5de7f1c$var$ss = Object.defineProperty, $d7238066c5de7f1c$var$Ag = Object.getOwnPropertyDescriptor, $d7238066c5de7f1c$var$os = "enumerable", $d7238066c5de7f1c$var$as = "configurable", $d7238066c5de7f1c$var$cs = "writable";
$d7238066c5de7f1c$var$Xt.f = $d7238066c5de7f1c$var$Tg ? $d7238066c5de7f1c$var$bg ? function(e, t, i) {
    if ($d7238066c5de7f1c$var$kr(e), t = $d7238066c5de7f1c$var$Rc(t), $d7238066c5de7f1c$var$kr(i), typeof e == "function" && t === "prototype" && "value" in i && $d7238066c5de7f1c$var$cs in i && !i[$d7238066c5de7f1c$var$cs]) {
        var n = $d7238066c5de7f1c$var$Ag(e, t);
        n && n[$d7238066c5de7f1c$var$cs] && (e[t] = i.value, i = {
            configurable: $d7238066c5de7f1c$var$as in i ? i[$d7238066c5de7f1c$var$as] : n[$d7238066c5de7f1c$var$as],
            enumerable: $d7238066c5de7f1c$var$os in i ? i[$d7238066c5de7f1c$var$os] : n[$d7238066c5de7f1c$var$os],
            writable: !1
        });
    }
    return $d7238066c5de7f1c$var$ss(e, t, i);
} : $d7238066c5de7f1c$var$ss : function(e, t, i) {
    if ($d7238066c5de7f1c$var$kr(e), t = $d7238066c5de7f1c$var$Rc(t), $d7238066c5de7f1c$var$kr(i), $d7238066c5de7f1c$var$Pg) try {
        return $d7238066c5de7f1c$var$ss(e, t, i);
    } catch  {}
    if ("get" in i || "set" in i) throw new $d7238066c5de7f1c$var$Eg("Accessors not supported");
    return "value" in i && (e[t] = i.value), e;
};
var $d7238066c5de7f1c$var$kg = $d7238066c5de7f1c$var$Dt, $d7238066c5de7f1c$var$Dg = $d7238066c5de7f1c$var$Xt, $d7238066c5de7f1c$var$Og = $d7238066c5de7f1c$var$mr, $d7238066c5de7f1c$var$ei = $d7238066c5de7f1c$var$kg ? function(r, e, t) {
    return $d7238066c5de7f1c$var$Dg.f(r, e, $d7238066c5de7f1c$var$Og(1, t));
} : function(r, e, t) {
    return r[e] = t, r;
}, $d7238066c5de7f1c$var$Li = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$zg = $d7238066c5de7f1c$var$ca, $d7238066c5de7f1c$var$Ng = $d7238066c5de7f1c$var$yh, $d7238066c5de7f1c$var$Mg = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$xg = $d7238066c5de7f1c$var$pa.f, $d7238066c5de7f1c$var$_g = $d7238066c5de7f1c$var$Mh, $d7238066c5de7f1c$var$oi = $d7238066c5de7f1c$var$En, $d7238066c5de7f1c$var$Lg = $d7238066c5de7f1c$var$Dn, $d7238066c5de7f1c$var$ai = $d7238066c5de7f1c$var$ei, $d7238066c5de7f1c$var$Ic = $d7238066c5de7f1c$var$dt, $d7238066c5de7f1c$var$$g = function(r) {
    var e = function(t, i, n) {
        if (this instanceof e) {
            switch(arguments.length){
                case 0:
                    return new r();
                case 1:
                    return new r(t);
                case 2:
                    return new r(t, i);
            }
            return new r(t, i, n);
        }
        return $d7238066c5de7f1c$var$zg(r, this, arguments);
    };
    return e.prototype = r.prototype, e;
}, $d7238066c5de7f1c$var$qe = function(r, e) {
    var t = r.target, i = r.global, n = r.stat, s = r.proto, o = i ? $d7238066c5de7f1c$var$Li : n ? $d7238066c5de7f1c$var$Li[t] : $d7238066c5de7f1c$var$Li[t] && $d7238066c5de7f1c$var$Li[t].prototype, c = i ? $d7238066c5de7f1c$var$oi : $d7238066c5de7f1c$var$oi[t] || $d7238066c5de7f1c$var$ai($d7238066c5de7f1c$var$oi, t, {})[t], p = c.prototype, h, a, d, v, g, I, A, D, z;
    for(v in e)h = $d7238066c5de7f1c$var$_g(i ? v : t + (n ? "." : "#") + v, r.forced), a = !h && o && $d7238066c5de7f1c$var$Ic(o, v), I = c[v], a && (r.dontCallGetSet ? (z = $d7238066c5de7f1c$var$xg(o, v), A = z && z.value) : A = o[v]), g = a && A ? A : e[v], !(!h && !s && typeof I == typeof g) && (r.bind && a ? D = $d7238066c5de7f1c$var$Lg(g, $d7238066c5de7f1c$var$Li) : r.wrap && a ? D = $d7238066c5de7f1c$var$$g(g) : s && $d7238066c5de7f1c$var$Mg(g) ? D = $d7238066c5de7f1c$var$Ng(g) : D = g, (r.sham || g && g.sham || I && I.sham) && $d7238066c5de7f1c$var$ai(D, "sham", !0), $d7238066c5de7f1c$var$ai(c, v, D), s && (d = t + "Prototype", $d7238066c5de7f1c$var$Ic($d7238066c5de7f1c$var$oi, d) || $d7238066c5de7f1c$var$ai($d7238066c5de7f1c$var$oi, d, {}), $d7238066c5de7f1c$var$ai($d7238066c5de7f1c$var$oi[d], v, g), r.real && p && (h || !p[v]) && $d7238066c5de7f1c$var$ai(p, v, g)));
}, $d7238066c5de7f1c$var$Bg = $d7238066c5de7f1c$var$kh, $d7238066c5de7f1c$var$Ug = $d7238066c5de7f1c$var$Oh, $d7238066c5de7f1c$var$Tc = $d7238066c5de7f1c$var$Bg("keys"), $d7238066c5de7f1c$var$la = function(r) {
    return $d7238066c5de7f1c$var$Tc[r] || ($d7238066c5de7f1c$var$Tc[r] = $d7238066c5de7f1c$var$Ug(r));
}, $d7238066c5de7f1c$var$qg = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$Wg = !$d7238066c5de7f1c$var$qg(function() {
    function r() {}
    return r.prototype.constructor = null, Object.getPrototypeOf(new r()) !== r.prototype;
}), $d7238066c5de7f1c$var$Hg = $d7238066c5de7f1c$var$dt, $d7238066c5de7f1c$var$Fg = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$Vg = $d7238066c5de7f1c$var$Dh, $d7238066c5de7f1c$var$Kg = $d7238066c5de7f1c$var$la, $d7238066c5de7f1c$var$jg = $d7238066c5de7f1c$var$Wg, $d7238066c5de7f1c$var$Pc = $d7238066c5de7f1c$var$Kg("IE_PROTO"), $d7238066c5de7f1c$var$eo = Object, $d7238066c5de7f1c$var$Jg = $d7238066c5de7f1c$var$eo.prototype, $d7238066c5de7f1c$var$va = $d7238066c5de7f1c$var$jg ? $d7238066c5de7f1c$var$eo.getPrototypeOf : function(r) {
    var e = $d7238066c5de7f1c$var$Vg(r);
    if ($d7238066c5de7f1c$var$Hg(e, $d7238066c5de7f1c$var$Pc)) return e[$d7238066c5de7f1c$var$Pc];
    var t = e.constructor;
    return $d7238066c5de7f1c$var$Fg(t) && e instanceof t ? t.prototype : e instanceof $d7238066c5de7f1c$var$eo ? $d7238066c5de7f1c$var$Jg : null;
}, $d7238066c5de7f1c$var$Gg = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$Qg = $d7238066c5de7f1c$var$tt, $d7238066c5de7f1c$var$Yg = function(r, e, t) {
    try {
        return $d7238066c5de7f1c$var$Gg($d7238066c5de7f1c$var$Qg(Object.getOwnPropertyDescriptor(r, e)[t]));
    } catch  {}
}, $d7238066c5de7f1c$var$Zg = $d7238066c5de7f1c$var$et, $d7238066c5de7f1c$var$Xg = function(r) {
    return $d7238066c5de7f1c$var$Zg(r) || r === null;
}, $d7238066c5de7f1c$var$em = $d7238066c5de7f1c$var$Xg, $d7238066c5de7f1c$var$tm = String, $d7238066c5de7f1c$var$im = TypeError, $d7238066c5de7f1c$var$rm = function(r) {
    if ($d7238066c5de7f1c$var$em(r)) return r;
    throw new $d7238066c5de7f1c$var$im("Can't set " + $d7238066c5de7f1c$var$tm(r) + " as a prototype");
}, $d7238066c5de7f1c$var$nm = $d7238066c5de7f1c$var$Yg, $d7238066c5de7f1c$var$sm = $d7238066c5de7f1c$var$et, $d7238066c5de7f1c$var$om = $d7238066c5de7f1c$var$bn, $d7238066c5de7f1c$var$am = $d7238066c5de7f1c$var$rm, $d7238066c5de7f1c$var$cm = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var r = !1, e = {}, t;
    try {
        t = $d7238066c5de7f1c$var$nm(Object.prototype, "__proto__", "set"), t(e, []), r = e instanceof Array;
    } catch  {}
    return function(n, s) {
        return $d7238066c5de7f1c$var$om(n), $d7238066c5de7f1c$var$am(s), $d7238066c5de7f1c$var$sm(n) && (r ? t(n, s) : n.__proto__ = s), n;
    };
}() : void 0), $d7238066c5de7f1c$var$_h = {}, $d7238066c5de7f1c$var$pm = Math.ceil, $d7238066c5de7f1c$var$hm = Math.floor, $d7238066c5de7f1c$var$um = Math.trunc || function(e) {
    var t = +e;
    return (t > 0 ? $d7238066c5de7f1c$var$hm : $d7238066c5de7f1c$var$pm)(t);
}, $d7238066c5de7f1c$var$dm = $d7238066c5de7f1c$var$um, $d7238066c5de7f1c$var$fa = function(r) {
    var e = +r;
    return e !== e || e === 0 ? 0 : $d7238066c5de7f1c$var$dm(e);
}, $d7238066c5de7f1c$var$lm = $d7238066c5de7f1c$var$fa, $d7238066c5de7f1c$var$vm = Math.max, $d7238066c5de7f1c$var$fm = Math.min, $d7238066c5de7f1c$var$gm = function(r, e) {
    var t = $d7238066c5de7f1c$var$lm(r);
    return t < 0 ? $d7238066c5de7f1c$var$vm(t + e, 0) : $d7238066c5de7f1c$var$fm(t, e);
}, $d7238066c5de7f1c$var$mm = $d7238066c5de7f1c$var$fa, $d7238066c5de7f1c$var$Sm = Math.min, $d7238066c5de7f1c$var$ym = function(r) {
    var e = $d7238066c5de7f1c$var$mm(r);
    return e > 0 ? $d7238066c5de7f1c$var$Sm(e, 9007199254740991) : 0;
}, $d7238066c5de7f1c$var$Cm = $d7238066c5de7f1c$var$ym, $d7238066c5de7f1c$var$Lh = function(r) {
    return $d7238066c5de7f1c$var$Cm(r.length);
}, $d7238066c5de7f1c$var$wm = $d7238066c5de7f1c$var$Sr, $d7238066c5de7f1c$var$Rm = $d7238066c5de7f1c$var$gm, $d7238066c5de7f1c$var$Im = $d7238066c5de7f1c$var$Lh, $d7238066c5de7f1c$var$Tm = function(r) {
    return function(e, t, i) {
        var n = $d7238066c5de7f1c$var$wm(e), s = $d7238066c5de7f1c$var$Im(n);
        if (s === 0) return !r && -1;
        var o = $d7238066c5de7f1c$var$Rm(i, s), c;
        if (r && t !== t) {
            for(; s > o;)if (c = n[o++], c !== c) return !0;
        } else for(; s > o; o++)if ((r || o in n) && n[o] === t) return r || o || 0;
        return !r && -1;
    };
}, $d7238066c5de7f1c$var$Pm = {
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $d7238066c5de7f1c$var$Tm(!1)
}, $d7238066c5de7f1c$var$ga = {}, $d7238066c5de7f1c$var$bm = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$ps = $d7238066c5de7f1c$var$dt, $d7238066c5de7f1c$var$Em = $d7238066c5de7f1c$var$Sr, $d7238066c5de7f1c$var$Am = $d7238066c5de7f1c$var$Pm.indexOf, $d7238066c5de7f1c$var$km = $d7238066c5de7f1c$var$ga, $d7238066c5de7f1c$var$bc = $d7238066c5de7f1c$var$bm([].push), $d7238066c5de7f1c$var$$h = function(r, e) {
    var t = $d7238066c5de7f1c$var$Em(r), i = 0, n = [], s;
    for(s in t)!$d7238066c5de7f1c$var$ps($d7238066c5de7f1c$var$km, s) && $d7238066c5de7f1c$var$ps(t, s) && $d7238066c5de7f1c$var$bc(n, s);
    for(; e.length > i;)$d7238066c5de7f1c$var$ps(t, s = e[i++]) && (~$d7238066c5de7f1c$var$Am(n, s) || $d7238066c5de7f1c$var$bc(n, s));
    return n;
}, $d7238066c5de7f1c$var$ma = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
], $d7238066c5de7f1c$var$Dm = $d7238066c5de7f1c$var$$h, $d7238066c5de7f1c$var$Om = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$zm = $d7238066c5de7f1c$var$Om.concat("length", "prototype");
$d7238066c5de7f1c$var$_h.f = Object.getOwnPropertyNames || function(e) {
    return $d7238066c5de7f1c$var$Dm(e, $d7238066c5de7f1c$var$zm);
};
var $d7238066c5de7f1c$var$Bh = {};
$d7238066c5de7f1c$var$Bh.f = Object.getOwnPropertySymbols;
var $d7238066c5de7f1c$var$Nm = $d7238066c5de7f1c$var$Bt, $d7238066c5de7f1c$var$Mm = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$xm = $d7238066c5de7f1c$var$_h, $d7238066c5de7f1c$var$_m = $d7238066c5de7f1c$var$Bh, $d7238066c5de7f1c$var$Lm = $d7238066c5de7f1c$var$Ot, $d7238066c5de7f1c$var$$m = $d7238066c5de7f1c$var$Mm([].concat), $d7238066c5de7f1c$var$Bm = $d7238066c5de7f1c$var$Nm("Reflect", "ownKeys") || function(e) {
    var t = $d7238066c5de7f1c$var$xm.f($d7238066c5de7f1c$var$Lm(e)), i = $d7238066c5de7f1c$var$_m.f;
    return i ? $d7238066c5de7f1c$var$$m(t, i(e)) : t;
}, $d7238066c5de7f1c$var$Ec = $d7238066c5de7f1c$var$dt, $d7238066c5de7f1c$var$Um = $d7238066c5de7f1c$var$Bm, $d7238066c5de7f1c$var$qm = $d7238066c5de7f1c$var$pa, $d7238066c5de7f1c$var$Wm = $d7238066c5de7f1c$var$Xt, $d7238066c5de7f1c$var$Hm = function(r, e, t) {
    for(var i = $d7238066c5de7f1c$var$Um(e), n = $d7238066c5de7f1c$var$Wm.f, s = $d7238066c5de7f1c$var$qm.f, o = 0; o < i.length; o++){
        var c = i[o];
        !$d7238066c5de7f1c$var$Ec(r, c) && !(t && $d7238066c5de7f1c$var$Ec(t, c)) && n(r, c, s(e, c));
    }
}, $d7238066c5de7f1c$var$Uh = {}, $d7238066c5de7f1c$var$Fm = $d7238066c5de7f1c$var$$h, $d7238066c5de7f1c$var$Vm = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$Km = Object.keys || function(e) {
    return $d7238066c5de7f1c$var$Fm(e, $d7238066c5de7f1c$var$Vm);
}, $d7238066c5de7f1c$var$jm = $d7238066c5de7f1c$var$Dt, $d7238066c5de7f1c$var$Jm = $d7238066c5de7f1c$var$xh, $d7238066c5de7f1c$var$Gm = $d7238066c5de7f1c$var$Xt, $d7238066c5de7f1c$var$Qm = $d7238066c5de7f1c$var$Ot, $d7238066c5de7f1c$var$Ym = $d7238066c5de7f1c$var$Sr, $d7238066c5de7f1c$var$Zm = $d7238066c5de7f1c$var$Km;
$d7238066c5de7f1c$var$Uh.f = $d7238066c5de7f1c$var$jm && !$d7238066c5de7f1c$var$Jm ? Object.defineProperties : function(e, t) {
    $d7238066c5de7f1c$var$Qm(e);
    for(var i = $d7238066c5de7f1c$var$Ym(t), n = $d7238066c5de7f1c$var$Zm(t), s = n.length, o = 0, c; s > o;)$d7238066c5de7f1c$var$Gm.f(e, c = n[o++], i[c]);
    return e;
};
var $d7238066c5de7f1c$var$Xm = $d7238066c5de7f1c$var$Bt, $d7238066c5de7f1c$var$qh = $d7238066c5de7f1c$var$Xm("document", "documentElement"), $d7238066c5de7f1c$var$eS = $d7238066c5de7f1c$var$Ot, $d7238066c5de7f1c$var$tS = $d7238066c5de7f1c$var$Uh, $d7238066c5de7f1c$var$Ac = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$iS = $d7238066c5de7f1c$var$ga, $d7238066c5de7f1c$var$rS = $d7238066c5de7f1c$var$qh, $d7238066c5de7f1c$var$nS = $d7238066c5de7f1c$var$da, $d7238066c5de7f1c$var$sS = $d7238066c5de7f1c$var$la, $d7238066c5de7f1c$var$kc = ">", $d7238066c5de7f1c$var$Dc = "<", $d7238066c5de7f1c$var$to = "prototype", $d7238066c5de7f1c$var$io = "script", $d7238066c5de7f1c$var$Wh = $d7238066c5de7f1c$var$sS("IE_PROTO"), $d7238066c5de7f1c$var$hs = function() {}, $d7238066c5de7f1c$var$Hh = function(r) {
    return $d7238066c5de7f1c$var$Dc + $d7238066c5de7f1c$var$io + $d7238066c5de7f1c$var$kc + r + $d7238066c5de7f1c$var$Dc + "/" + $d7238066c5de7f1c$var$io + $d7238066c5de7f1c$var$kc;
}, $d7238066c5de7f1c$var$Oc = function(r) {
    r.write($d7238066c5de7f1c$var$Hh("")), r.close();
    var e = r.parentWindow.Object;
    return r = null, e;
}, $d7238066c5de7f1c$var$oS = function() {
    var r = $d7238066c5de7f1c$var$nS("iframe"), e = "java" + $d7238066c5de7f1c$var$io + ":", t;
    return r.style.display = "none", $d7238066c5de7f1c$var$rS.appendChild(r), r.src = String(e), t = r.contentWindow.document, t.open(), t.write($d7238066c5de7f1c$var$Hh("document.F=Object")), t.close(), t.F;
}, $d7238066c5de7f1c$var$Dr, $d7238066c5de7f1c$var$Kr = function() {
    try {
        $d7238066c5de7f1c$var$Dr = new ActiveXObject("htmlfile");
    } catch  {}
    $d7238066c5de7f1c$var$Kr = typeof document < "u" ? document.domain && $d7238066c5de7f1c$var$Dr ? $d7238066c5de7f1c$var$Oc($d7238066c5de7f1c$var$Dr) : $d7238066c5de7f1c$var$oS() : $d7238066c5de7f1c$var$Oc($d7238066c5de7f1c$var$Dr);
    for(var r = $d7238066c5de7f1c$var$Ac.length; r--;)delete $d7238066c5de7f1c$var$Kr[$d7238066c5de7f1c$var$to][$d7238066c5de7f1c$var$Ac[r]];
    return $d7238066c5de7f1c$var$Kr();
};
$d7238066c5de7f1c$var$iS[$d7238066c5de7f1c$var$Wh] = !0;
var $d7238066c5de7f1c$var$Sa = Object.create || function(e, t) {
    var i;
    return e !== null ? ($d7238066c5de7f1c$var$hs[$d7238066c5de7f1c$var$to] = $d7238066c5de7f1c$var$eS(e), i = new $d7238066c5de7f1c$var$hs(), $d7238066c5de7f1c$var$hs[$d7238066c5de7f1c$var$to] = null, i[$d7238066c5de7f1c$var$Wh] = e) : i = $d7238066c5de7f1c$var$Kr(), t === void 0 ? i : $d7238066c5de7f1c$var$tS.f(i, t);
}, $d7238066c5de7f1c$var$aS = $d7238066c5de7f1c$var$et, $d7238066c5de7f1c$var$cS = $d7238066c5de7f1c$var$ei, $d7238066c5de7f1c$var$pS = function(r, e) {
    $d7238066c5de7f1c$var$aS(e) && "cause" in e && $d7238066c5de7f1c$var$cS(r, "cause", e.cause);
}, $d7238066c5de7f1c$var$hS = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$Fh = Error, $d7238066c5de7f1c$var$uS = $d7238066c5de7f1c$var$hS("".replace), $d7238066c5de7f1c$var$dS = function(r) {
    return String(new $d7238066c5de7f1c$var$Fh(r).stack);
}("zxcasd"), $d7238066c5de7f1c$var$Vh = /\n\s*at [^:]*:[^\n]*/, $d7238066c5de7f1c$var$lS = $d7238066c5de7f1c$var$Vh.test($d7238066c5de7f1c$var$dS), $d7238066c5de7f1c$var$vS = function(r, e) {
    if ($d7238066c5de7f1c$var$lS && typeof r == "string" && !$d7238066c5de7f1c$var$Fh.prepareStackTrace) for(; e--;)r = $d7238066c5de7f1c$var$uS(r, $d7238066c5de7f1c$var$Vh, "");
    return r;
}, $d7238066c5de7f1c$var$fS = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$gS = $d7238066c5de7f1c$var$mr, $d7238066c5de7f1c$var$mS = !$d7238066c5de7f1c$var$fS(function() {
    var r = new Error("a");
    return "stack" in r ? (Object.defineProperty(r, "stack", $d7238066c5de7f1c$var$gS(1, 7)), r.stack !== 7) : !0;
}), $d7238066c5de7f1c$var$SS = $d7238066c5de7f1c$var$ei, $d7238066c5de7f1c$var$yS = $d7238066c5de7f1c$var$vS, $d7238066c5de7f1c$var$CS = $d7238066c5de7f1c$var$mS, $d7238066c5de7f1c$var$zc = Error.captureStackTrace, $d7238066c5de7f1c$var$wS = function(r, e, t, i) {
    $d7238066c5de7f1c$var$CS && ($d7238066c5de7f1c$var$zc ? $d7238066c5de7f1c$var$zc(r, e) : $d7238066c5de7f1c$var$SS(r, "stack", $d7238066c5de7f1c$var$yS(t, i)));
}, $d7238066c5de7f1c$var$Ei = {}, $d7238066c5de7f1c$var$RS = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$IS = $d7238066c5de7f1c$var$Ei, $d7238066c5de7f1c$var$TS = $d7238066c5de7f1c$var$RS("iterator"), $d7238066c5de7f1c$var$PS = Array.prototype, $d7238066c5de7f1c$var$bS = function(r) {
    return r !== void 0 && ($d7238066c5de7f1c$var$IS.Array === r || $d7238066c5de7f1c$var$PS[$d7238066c5de7f1c$var$TS] === r);
}, $d7238066c5de7f1c$var$ES = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$AS = $d7238066c5de7f1c$var$ES("toStringTag"), $d7238066c5de7f1c$var$Kh = {};
$d7238066c5de7f1c$var$Kh[$d7238066c5de7f1c$var$AS] = "z";
var $d7238066c5de7f1c$var$ya = String($d7238066c5de7f1c$var$Kh) === "[object z]", $d7238066c5de7f1c$var$kS = $d7238066c5de7f1c$var$ya, $d7238066c5de7f1c$var$DS = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$jr = $d7238066c5de7f1c$var$Tn, $d7238066c5de7f1c$var$OS = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$zS = $d7238066c5de7f1c$var$OS("toStringTag"), $d7238066c5de7f1c$var$NS = Object, $d7238066c5de7f1c$var$MS = $d7238066c5de7f1c$var$jr(/* @__PURE__ */ function() {
    return arguments;
}()) === "Arguments", $d7238066c5de7f1c$var$xS = function(r, e) {
    try {
        return r[e];
    } catch  {}
}, $d7238066c5de7f1c$var$On = $d7238066c5de7f1c$var$kS ? $d7238066c5de7f1c$var$jr : function(r) {
    var e, t, i;
    return r === void 0 ? "Undefined" : r === null ? "Null" : typeof (t = $d7238066c5de7f1c$var$xS(e = $d7238066c5de7f1c$var$NS(r), $d7238066c5de7f1c$var$zS)) == "string" ? t : $d7238066c5de7f1c$var$MS ? $d7238066c5de7f1c$var$jr(e) : (i = $d7238066c5de7f1c$var$jr(e)) === "Object" && $d7238066c5de7f1c$var$DS(e.callee) ? "Arguments" : i;
}, $d7238066c5de7f1c$var$_S = $d7238066c5de7f1c$var$On, $d7238066c5de7f1c$var$Nc = $d7238066c5de7f1c$var$ha, $d7238066c5de7f1c$var$LS = $d7238066c5de7f1c$var$Pn, $d7238066c5de7f1c$var$$S = $d7238066c5de7f1c$var$Ei, $d7238066c5de7f1c$var$BS = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$US = $d7238066c5de7f1c$var$BS("iterator"), $d7238066c5de7f1c$var$jh = function(r) {
    if (!$d7238066c5de7f1c$var$LS(r)) return $d7238066c5de7f1c$var$Nc(r, $d7238066c5de7f1c$var$US) || $d7238066c5de7f1c$var$Nc(r, "@@iterator") || $d7238066c5de7f1c$var$$S[$d7238066c5de7f1c$var$_S(r)];
}, $d7238066c5de7f1c$var$qS = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$WS = $d7238066c5de7f1c$var$tt, $d7238066c5de7f1c$var$HS = $d7238066c5de7f1c$var$Ot, $d7238066c5de7f1c$var$FS = $d7238066c5de7f1c$var$kn, $d7238066c5de7f1c$var$VS = $d7238066c5de7f1c$var$jh, $d7238066c5de7f1c$var$KS = TypeError, $d7238066c5de7f1c$var$jS = function(r, e) {
    var t = arguments.length < 2 ? $d7238066c5de7f1c$var$VS(r) : e;
    if ($d7238066c5de7f1c$var$WS(t)) return $d7238066c5de7f1c$var$HS($d7238066c5de7f1c$var$qS(t, r));
    throw new $d7238066c5de7f1c$var$KS($d7238066c5de7f1c$var$FS(r) + " is not iterable");
}, $d7238066c5de7f1c$var$JS = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$Mc = $d7238066c5de7f1c$var$Ot, $d7238066c5de7f1c$var$GS = $d7238066c5de7f1c$var$ha, $d7238066c5de7f1c$var$QS = function(r, e, t) {
    var i, n;
    $d7238066c5de7f1c$var$Mc(r);
    try {
        if (i = $d7238066c5de7f1c$var$GS(r, "return"), !i) {
            if (e === "throw") throw t;
            return t;
        }
        i = $d7238066c5de7f1c$var$JS(i, r);
    } catch (s) {
        n = !0, i = s;
    }
    if (e === "throw") throw t;
    if (n) throw i;
    return $d7238066c5de7f1c$var$Mc(i), t;
}, $d7238066c5de7f1c$var$YS = $d7238066c5de7f1c$var$Dn, $d7238066c5de7f1c$var$ZS = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$XS = $d7238066c5de7f1c$var$Ot, $d7238066c5de7f1c$var$ey = $d7238066c5de7f1c$var$kn, $d7238066c5de7f1c$var$ty = $d7238066c5de7f1c$var$bS, $d7238066c5de7f1c$var$iy = $d7238066c5de7f1c$var$Lh, $d7238066c5de7f1c$var$xc = $d7238066c5de7f1c$var$An, $d7238066c5de7f1c$var$ry = $d7238066c5de7f1c$var$jS, $d7238066c5de7f1c$var$ny = $d7238066c5de7f1c$var$jh, $d7238066c5de7f1c$var$_c = $d7238066c5de7f1c$var$QS, $d7238066c5de7f1c$var$sy = TypeError, $d7238066c5de7f1c$var$Jr = function(r, e) {
    this.stopped = r, this.result = e;
}, $d7238066c5de7f1c$var$Lc = $d7238066c5de7f1c$var$Jr.prototype, $d7238066c5de7f1c$var$wr = function(r, e, t) {
    var i = t && t.that, n = !!(t && t.AS_ENTRIES), s = !!(t && t.IS_RECORD), o = !!(t && t.IS_ITERATOR), c = !!(t && t.INTERRUPTED), p = $d7238066c5de7f1c$var$YS(e, i), h, a, d, v, g, I, A, D = function(_) {
        var L = h;
        return h = void 0, L && $d7238066c5de7f1c$var$_c(L, "normal"), new $d7238066c5de7f1c$var$Jr(!0, _);
    }, z = function(_) {
        return n ? ($d7238066c5de7f1c$var$XS(_), c ? p(_[0], _[1], D) : p(_[0], _[1])) : c ? p(_, D) : p(_);
    };
    if (s) h = r.iterator;
    else if (o) h = r;
    else {
        if (a = $d7238066c5de7f1c$var$ny(r), !a) throw new $d7238066c5de7f1c$var$sy($d7238066c5de7f1c$var$ey(r) + " is not iterable");
        if ($d7238066c5de7f1c$var$ty(a)) {
            for(d = 0, v = $d7238066c5de7f1c$var$iy(r); v > d; d++)if (g = z(r[d]), g && $d7238066c5de7f1c$var$xc($d7238066c5de7f1c$var$Lc, g)) return g;
            return new $d7238066c5de7f1c$var$Jr(!1);
        }
        h = $d7238066c5de7f1c$var$ry(r, a);
    }
    for(I = s ? r.next : h.next; !(A = $d7238066c5de7f1c$var$ZS(I, h)).done;){
        var C = A.value;
        try {
            g = z(C);
        } catch (_) {
            if (h) $d7238066c5de7f1c$var$_c(h, "throw", _);
            else throw _;
        }
        if (typeof g == "object" && g && $d7238066c5de7f1c$var$xc($d7238066c5de7f1c$var$Lc, g)) return g;
    }
    return new $d7238066c5de7f1c$var$Jr(!1);
}, $d7238066c5de7f1c$var$oy = $d7238066c5de7f1c$var$On, $d7238066c5de7f1c$var$ay = String, $d7238066c5de7f1c$var$Ca = function(r) {
    if ($d7238066c5de7f1c$var$oy(r) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $d7238066c5de7f1c$var$ay(r);
}, $d7238066c5de7f1c$var$cy = $d7238066c5de7f1c$var$Ca, $d7238066c5de7f1c$var$py = function(r, e) {
    return r === void 0 ? arguments.length < 2 ? "" : e : $d7238066c5de7f1c$var$cy(r);
}, $d7238066c5de7f1c$var$hy = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$uy = $d7238066c5de7f1c$var$An, $d7238066c5de7f1c$var$dy = $d7238066c5de7f1c$var$va, $d7238066c5de7f1c$var$on = $d7238066c5de7f1c$var$cm, $d7238066c5de7f1c$var$ly = $d7238066c5de7f1c$var$Hm, $d7238066c5de7f1c$var$Jh = $d7238066c5de7f1c$var$Sa, $d7238066c5de7f1c$var$us = $d7238066c5de7f1c$var$ei, $d7238066c5de7f1c$var$ds = $d7238066c5de7f1c$var$mr, $d7238066c5de7f1c$var$vy = $d7238066c5de7f1c$var$pS, $d7238066c5de7f1c$var$fy = $d7238066c5de7f1c$var$wS, $d7238066c5de7f1c$var$gy = $d7238066c5de7f1c$var$wr, $d7238066c5de7f1c$var$my = $d7238066c5de7f1c$var$py, $d7238066c5de7f1c$var$Sy = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$yy = $d7238066c5de7f1c$var$Sy("toStringTag"), $d7238066c5de7f1c$var$an = Error, $d7238066c5de7f1c$var$Cy = [].push, $d7238066c5de7f1c$var$Ii = function(e, t) {
    var i = $d7238066c5de7f1c$var$uy($d7238066c5de7f1c$var$ls, this), n;
    $d7238066c5de7f1c$var$on ? n = $d7238066c5de7f1c$var$on(new $d7238066c5de7f1c$var$an(), i ? $d7238066c5de7f1c$var$dy(this) : $d7238066c5de7f1c$var$ls) : (n = i ? this : $d7238066c5de7f1c$var$Jh($d7238066c5de7f1c$var$ls), $d7238066c5de7f1c$var$us(n, $d7238066c5de7f1c$var$yy, "Error")), t !== void 0 && $d7238066c5de7f1c$var$us(n, "message", $d7238066c5de7f1c$var$my(t)), $d7238066c5de7f1c$var$fy(n, $d7238066c5de7f1c$var$Ii, n.stack, 1), arguments.length > 2 && $d7238066c5de7f1c$var$vy(n, arguments[2]);
    var s = [];
    return $d7238066c5de7f1c$var$gy(e, $d7238066c5de7f1c$var$Cy, {
        that: s
    }), $d7238066c5de7f1c$var$us(n, "errors", s), n;
};
$d7238066c5de7f1c$var$on ? $d7238066c5de7f1c$var$on($d7238066c5de7f1c$var$Ii, $d7238066c5de7f1c$var$an) : $d7238066c5de7f1c$var$ly($d7238066c5de7f1c$var$Ii, $d7238066c5de7f1c$var$an, {
    name: !0
});
var $d7238066c5de7f1c$var$ls = $d7238066c5de7f1c$var$Ii.prototype = $d7238066c5de7f1c$var$Jh($d7238066c5de7f1c$var$an.prototype, {
    constructor: $d7238066c5de7f1c$var$ds(1, $d7238066c5de7f1c$var$Ii),
    message: $d7238066c5de7f1c$var$ds(1, ""),
    name: $d7238066c5de7f1c$var$ds(1, "AggregateError")
});
$d7238066c5de7f1c$var$hy({
    global: !0
}, {
    AggregateError: $d7238066c5de7f1c$var$Ii
});
var $d7238066c5de7f1c$var$wy = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$Ry = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$$c = $d7238066c5de7f1c$var$wy.WeakMap, $d7238066c5de7f1c$var$Iy = $d7238066c5de7f1c$var$Ry($d7238066c5de7f1c$var$$c) && /native code/.test(String($d7238066c5de7f1c$var$$c)), $d7238066c5de7f1c$var$Ty = $d7238066c5de7f1c$var$Iy, $d7238066c5de7f1c$var$Gh = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$Py = $d7238066c5de7f1c$var$et, $d7238066c5de7f1c$var$by = $d7238066c5de7f1c$var$ei, $d7238066c5de7f1c$var$vs = $d7238066c5de7f1c$var$dt, $d7238066c5de7f1c$var$fs = $d7238066c5de7f1c$var$ua, $d7238066c5de7f1c$var$Ey = $d7238066c5de7f1c$var$la, $d7238066c5de7f1c$var$Ay = $d7238066c5de7f1c$var$ga, $d7238066c5de7f1c$var$Bc = "Object already initialized", $d7238066c5de7f1c$var$ro = $d7238066c5de7f1c$var$Gh.TypeError, $d7238066c5de7f1c$var$ky = $d7238066c5de7f1c$var$Gh.WeakMap, $d7238066c5de7f1c$var$cn, $d7238066c5de7f1c$var$or, $d7238066c5de7f1c$var$pn, $d7238066c5de7f1c$var$Dy = function(r) {
    return $d7238066c5de7f1c$var$pn(r) ? $d7238066c5de7f1c$var$or(r) : $d7238066c5de7f1c$var$cn(r, {});
}, $d7238066c5de7f1c$var$Oy = function(r) {
    return function(e) {
        var t;
        if (!$d7238066c5de7f1c$var$Py(e) || (t = $d7238066c5de7f1c$var$or(e)).type !== r) throw new $d7238066c5de7f1c$var$ro("Incompatible receiver, " + r + " required");
        return t;
    };
};
if ($d7238066c5de7f1c$var$Ty || $d7238066c5de7f1c$var$fs.state) {
    var $d7238066c5de7f1c$var$it = $d7238066c5de7f1c$var$fs.state || ($d7238066c5de7f1c$var$fs.state = new $d7238066c5de7f1c$var$ky());
    $d7238066c5de7f1c$var$it.get = $d7238066c5de7f1c$var$it.get, $d7238066c5de7f1c$var$it.has = $d7238066c5de7f1c$var$it.has, $d7238066c5de7f1c$var$it.set = $d7238066c5de7f1c$var$it.set, $d7238066c5de7f1c$var$cn = function(r, e) {
        if ($d7238066c5de7f1c$var$it.has(r)) throw new $d7238066c5de7f1c$var$ro($d7238066c5de7f1c$var$Bc);
        return e.facade = r, $d7238066c5de7f1c$var$it.set(r, e), e;
    }, $d7238066c5de7f1c$var$or = function(r) {
        return $d7238066c5de7f1c$var$it.get(r) || {};
    }, $d7238066c5de7f1c$var$pn = function(r) {
        return $d7238066c5de7f1c$var$it.has(r);
    };
} else {
    var $d7238066c5de7f1c$var$ci = $d7238066c5de7f1c$var$Ey("state");
    $d7238066c5de7f1c$var$Ay[$d7238066c5de7f1c$var$ci] = !0, $d7238066c5de7f1c$var$cn = function(r, e) {
        if ($d7238066c5de7f1c$var$vs(r, $d7238066c5de7f1c$var$ci)) throw new $d7238066c5de7f1c$var$ro($d7238066c5de7f1c$var$Bc);
        return e.facade = r, $d7238066c5de7f1c$var$by(r, $d7238066c5de7f1c$var$ci, e), e;
    }, $d7238066c5de7f1c$var$or = function(r) {
        return $d7238066c5de7f1c$var$vs(r, $d7238066c5de7f1c$var$ci) ? r[$d7238066c5de7f1c$var$ci] : {};
    }, $d7238066c5de7f1c$var$pn = function(r) {
        return $d7238066c5de7f1c$var$vs(r, $d7238066c5de7f1c$var$ci);
    };
}
var $d7238066c5de7f1c$var$wa = {
    set: $d7238066c5de7f1c$var$cn,
    get: $d7238066c5de7f1c$var$or,
    has: $d7238066c5de7f1c$var$pn,
    enforce: $d7238066c5de7f1c$var$Dy,
    getterFor: $d7238066c5de7f1c$var$Oy
}, $d7238066c5de7f1c$var$no = $d7238066c5de7f1c$var$Dt, $d7238066c5de7f1c$var$zy = $d7238066c5de7f1c$var$dt, $d7238066c5de7f1c$var$Qh = Function.prototype, $d7238066c5de7f1c$var$Ny = $d7238066c5de7f1c$var$no && Object.getOwnPropertyDescriptor, $d7238066c5de7f1c$var$Yh = $d7238066c5de7f1c$var$zy($d7238066c5de7f1c$var$Qh, "name"), $d7238066c5de7f1c$var$My = $d7238066c5de7f1c$var$Yh && (function() {}).name === "something", $d7238066c5de7f1c$var$xy = $d7238066c5de7f1c$var$Yh && (!$d7238066c5de7f1c$var$no || $d7238066c5de7f1c$var$no && $d7238066c5de7f1c$var$Ny($d7238066c5de7f1c$var$Qh, "name").configurable), $d7238066c5de7f1c$var$_y = {
    PROPER: $d7238066c5de7f1c$var$My,
    CONFIGURABLE: $d7238066c5de7f1c$var$xy
}, $d7238066c5de7f1c$var$Ly = $d7238066c5de7f1c$var$ei, $d7238066c5de7f1c$var$Ra = function(r, e, t, i) {
    return i && i.enumerable ? r[e] = t : $d7238066c5de7f1c$var$Ly(r, e, t), r;
}, $d7238066c5de7f1c$var$$y = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$By = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$Uy = $d7238066c5de7f1c$var$et, $d7238066c5de7f1c$var$qy = $d7238066c5de7f1c$var$Sa, $d7238066c5de7f1c$var$Uc = $d7238066c5de7f1c$var$va, $d7238066c5de7f1c$var$Wy = $d7238066c5de7f1c$var$Ra, $d7238066c5de7f1c$var$Hy = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$so = $d7238066c5de7f1c$var$Hy("iterator"), $d7238066c5de7f1c$var$Zh = !1, $d7238066c5de7f1c$var$Tt, $d7238066c5de7f1c$var$gs, $d7238066c5de7f1c$var$ms;
[].keys && ($d7238066c5de7f1c$var$ms = [].keys(), "next" in $d7238066c5de7f1c$var$ms ? ($d7238066c5de7f1c$var$gs = $d7238066c5de7f1c$var$Uc($d7238066c5de7f1c$var$Uc($d7238066c5de7f1c$var$ms)), $d7238066c5de7f1c$var$gs !== Object.prototype && ($d7238066c5de7f1c$var$Tt = $d7238066c5de7f1c$var$gs)) : $d7238066c5de7f1c$var$Zh = !0);
var $d7238066c5de7f1c$var$Fy = !$d7238066c5de7f1c$var$Uy($d7238066c5de7f1c$var$Tt) || $d7238066c5de7f1c$var$$y(function() {
    var r = {};
    return $d7238066c5de7f1c$var$Tt[$d7238066c5de7f1c$var$so].call(r) !== r;
});
$d7238066c5de7f1c$var$Fy ? $d7238066c5de7f1c$var$Tt = {} : $d7238066c5de7f1c$var$Tt = $d7238066c5de7f1c$var$qy($d7238066c5de7f1c$var$Tt);
$d7238066c5de7f1c$var$By($d7238066c5de7f1c$var$Tt[$d7238066c5de7f1c$var$so]) || $d7238066c5de7f1c$var$Wy($d7238066c5de7f1c$var$Tt, $d7238066c5de7f1c$var$so, function() {
    return this;
});
var $d7238066c5de7f1c$var$Xh = {
    IteratorPrototype: $d7238066c5de7f1c$var$Tt,
    BUGGY_SAFARI_ITERATORS: $d7238066c5de7f1c$var$Zh
}, $d7238066c5de7f1c$var$Vy = $d7238066c5de7f1c$var$ya, $d7238066c5de7f1c$var$Ky = $d7238066c5de7f1c$var$On, $d7238066c5de7f1c$var$jy = $d7238066c5de7f1c$var$Vy ? ({}).toString : function() {
    return "[object " + $d7238066c5de7f1c$var$Ky(this) + "]";
}, $d7238066c5de7f1c$var$Jy = $d7238066c5de7f1c$var$ya, $d7238066c5de7f1c$var$Gy = $d7238066c5de7f1c$var$Xt.f, $d7238066c5de7f1c$var$Qy = $d7238066c5de7f1c$var$ei, $d7238066c5de7f1c$var$Yy = $d7238066c5de7f1c$var$dt, $d7238066c5de7f1c$var$Zy = $d7238066c5de7f1c$var$jy, $d7238066c5de7f1c$var$Xy = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$qc = $d7238066c5de7f1c$var$Xy("toStringTag"), $d7238066c5de7f1c$var$zn = function(r, e, t, i) {
    var n = t ? r : r && r.prototype;
    n && ($d7238066c5de7f1c$var$Yy(n, $d7238066c5de7f1c$var$qc) || $d7238066c5de7f1c$var$Gy(n, $d7238066c5de7f1c$var$qc, {
        configurable: !0,
        value: e
    }), i && !$d7238066c5de7f1c$var$Jy && $d7238066c5de7f1c$var$Qy(n, "toString", $d7238066c5de7f1c$var$Zy));
}, $d7238066c5de7f1c$var$eC = $d7238066c5de7f1c$var$Xh.IteratorPrototype, $d7238066c5de7f1c$var$tC = $d7238066c5de7f1c$var$Sa, $d7238066c5de7f1c$var$iC = $d7238066c5de7f1c$var$mr, $d7238066c5de7f1c$var$rC = $d7238066c5de7f1c$var$zn, $d7238066c5de7f1c$var$nC = $d7238066c5de7f1c$var$Ei, $d7238066c5de7f1c$var$sC = function() {
    return this;
}, $d7238066c5de7f1c$var$oC = function(r, e, t, i) {
    var n = e + " Iterator";
    return r.prototype = $d7238066c5de7f1c$var$tC($d7238066c5de7f1c$var$eC, {
        next: $d7238066c5de7f1c$var$iC(+!i, t)
    }), $d7238066c5de7f1c$var$rC(r, n, !1, !0), $d7238066c5de7f1c$var$nC[n] = $d7238066c5de7f1c$var$sC, r;
}, $d7238066c5de7f1c$var$aC = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$cC = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$eu = $d7238066c5de7f1c$var$_y, $d7238066c5de7f1c$var$pC = $d7238066c5de7f1c$var$oC, $d7238066c5de7f1c$var$hC = $d7238066c5de7f1c$var$va, $d7238066c5de7f1c$var$uC = $d7238066c5de7f1c$var$zn, $d7238066c5de7f1c$var$Wc = $d7238066c5de7f1c$var$Ra, $d7238066c5de7f1c$var$dC = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$Hc = $d7238066c5de7f1c$var$Ei, $d7238066c5de7f1c$var$tu = $d7238066c5de7f1c$var$Xh, $d7238066c5de7f1c$var$lC = $d7238066c5de7f1c$var$eu.PROPER;
$d7238066c5de7f1c$var$eu.CONFIGURABLE;
$d7238066c5de7f1c$var$tu.IteratorPrototype;
var $d7238066c5de7f1c$var$Or = $d7238066c5de7f1c$var$tu.BUGGY_SAFARI_ITERATORS, $d7238066c5de7f1c$var$Ss = $d7238066c5de7f1c$var$dC("iterator"), $d7238066c5de7f1c$var$Fc = "keys", $d7238066c5de7f1c$var$zr = "values", $d7238066c5de7f1c$var$Vc = "entries", $d7238066c5de7f1c$var$vC = function() {
    return this;
}, $d7238066c5de7f1c$var$iu = function(r, e, t, i, n, s, o) {
    $d7238066c5de7f1c$var$pC(t, e, i);
    var c = function(z) {
        if (z === n && v) return v;
        if (!$d7238066c5de7f1c$var$Or && z && z in a) return a[z];
        switch(z){
            case $d7238066c5de7f1c$var$Fc:
                return function() {
                    return new t(this, z);
                };
            case $d7238066c5de7f1c$var$zr:
                return function() {
                    return new t(this, z);
                };
            case $d7238066c5de7f1c$var$Vc:
                return function() {
                    return new t(this, z);
                };
        }
        return function() {
            return new t(this);
        };
    }, p = e + " Iterator", h = !1, a = r.prototype, d = a[$d7238066c5de7f1c$var$Ss] || a["@@iterator"] || n && a[n], v = !$d7238066c5de7f1c$var$Or && d || c(n), g = e === "Array" && a.entries || d, I, A, D;
    if (g && (I = $d7238066c5de7f1c$var$hC(g.call(new r())), I !== Object.prototype && I.next && ($d7238066c5de7f1c$var$uC(I, p, !0, !0), $d7238066c5de7f1c$var$Hc[p] = $d7238066c5de7f1c$var$vC)), $d7238066c5de7f1c$var$lC && n === $d7238066c5de7f1c$var$zr && d && d.name !== $d7238066c5de7f1c$var$zr && (h = !0, v = function() {
        return $d7238066c5de7f1c$var$cC(d, this);
    }), n) {
        if (A = {
            values: c($d7238066c5de7f1c$var$zr),
            keys: s ? v : c($d7238066c5de7f1c$var$Fc),
            entries: c($d7238066c5de7f1c$var$Vc)
        }, o) for(D in A)($d7238066c5de7f1c$var$Or || h || !(D in a)) && $d7238066c5de7f1c$var$Wc(a, D, A[D]);
        else $d7238066c5de7f1c$var$aC({
            target: e,
            proto: !0,
            forced: $d7238066c5de7f1c$var$Or || h
        }, A);
    }
    return o && a[$d7238066c5de7f1c$var$Ss] !== v && $d7238066c5de7f1c$var$Wc(a, $d7238066c5de7f1c$var$Ss, v, {}), $d7238066c5de7f1c$var$Hc[e] = v, A;
}, $d7238066c5de7f1c$var$ru = function(r, e) {
    return {
        value: r,
        done: e
    };
}, $d7238066c5de7f1c$var$fC = $d7238066c5de7f1c$var$Sr, $d7238066c5de7f1c$var$Kc = $d7238066c5de7f1c$var$Ei, $d7238066c5de7f1c$var$nu = $d7238066c5de7f1c$var$wa;
$d7238066c5de7f1c$var$Xt.f;
var $d7238066c5de7f1c$var$gC = $d7238066c5de7f1c$var$iu, $d7238066c5de7f1c$var$Nr = $d7238066c5de7f1c$var$ru, $d7238066c5de7f1c$var$su = "Array Iterator", $d7238066c5de7f1c$var$mC = $d7238066c5de7f1c$var$nu.set, $d7238066c5de7f1c$var$SC = $d7238066c5de7f1c$var$nu.getterFor($d7238066c5de7f1c$var$su);
$d7238066c5de7f1c$var$gC(Array, "Array", function(r, e) {
    $d7238066c5de7f1c$var$mC(this, {
        type: $d7238066c5de7f1c$var$su,
        target: $d7238066c5de7f1c$var$fC(r),
        // target
        index: 0,
        // next index
        kind: e
    });
}, function() {
    var r = $d7238066c5de7f1c$var$SC(this), e = r.target, t = r.index++;
    if (!e || t >= e.length) return r.target = null, $d7238066c5de7f1c$var$Nr(void 0, !0);
    switch(r.kind){
        case "keys":
            return $d7238066c5de7f1c$var$Nr(t, !1);
        case "values":
            return $d7238066c5de7f1c$var$Nr(e[t], !1);
    }
    return $d7238066c5de7f1c$var$Nr([
        t,
        e[t]
    ], !1);
}, "values");
$d7238066c5de7f1c$var$Kc.Arguments = $d7238066c5de7f1c$var$Kc.Array;
var $d7238066c5de7f1c$var$$i = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$yC = $d7238066c5de7f1c$var$yr, $d7238066c5de7f1c$var$CC = $d7238066c5de7f1c$var$Tn, $d7238066c5de7f1c$var$Mr = function(r) {
    return $d7238066c5de7f1c$var$yC.slice(0, r.length) === r;
}, $d7238066c5de7f1c$var$ou = function() {
    return $d7238066c5de7f1c$var$Mr("Bun/") ? "BUN" : $d7238066c5de7f1c$var$Mr("Cloudflare-Workers") ? "CLOUDFLARE" : $d7238066c5de7f1c$var$Mr("Deno/") ? "DENO" : $d7238066c5de7f1c$var$Mr("Node.js/") ? "NODE" : $d7238066c5de7f1c$var$$i.Bun && typeof Bun.version == "string" ? "BUN" : $d7238066c5de7f1c$var$$i.Deno && typeof Deno.version == "object" ? "DENO" : $d7238066c5de7f1c$var$CC($d7238066c5de7f1c$var$$i.process) === "process" ? "NODE" : $d7238066c5de7f1c$var$$i.window && $d7238066c5de7f1c$var$$i.document ? "BROWSER" : "REST";
}(), $d7238066c5de7f1c$var$wC = $d7238066c5de7f1c$var$ou, $d7238066c5de7f1c$var$Ia = $d7238066c5de7f1c$var$wC === "NODE", $d7238066c5de7f1c$var$RC = $d7238066c5de7f1c$var$Xt, $d7238066c5de7f1c$var$IC = function(r, e, t) {
    return $d7238066c5de7f1c$var$RC.f(r, e, t);
}, $d7238066c5de7f1c$var$TC = $d7238066c5de7f1c$var$Bt, $d7238066c5de7f1c$var$PC = $d7238066c5de7f1c$var$IC, $d7238066c5de7f1c$var$bC = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$EC = $d7238066c5de7f1c$var$Dt, $d7238066c5de7f1c$var$jc = $d7238066c5de7f1c$var$bC("species"), $d7238066c5de7f1c$var$AC = function(r) {
    var e = $d7238066c5de7f1c$var$TC(r);
    $d7238066c5de7f1c$var$EC && e && !e[$d7238066c5de7f1c$var$jc] && $d7238066c5de7f1c$var$PC(e, $d7238066c5de7f1c$var$jc, {
        configurable: !0,
        get: function() {
            return this;
        }
    });
}, $d7238066c5de7f1c$var$kC = $d7238066c5de7f1c$var$An, $d7238066c5de7f1c$var$DC = TypeError, $d7238066c5de7f1c$var$OC = function(r, e) {
    if ($d7238066c5de7f1c$var$kC(e, r)) return r;
    throw new $d7238066c5de7f1c$var$DC("Incorrect invocation");
}, $d7238066c5de7f1c$var$zC = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$NC = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$oo = $d7238066c5de7f1c$var$ua, $d7238066c5de7f1c$var$MC = $d7238066c5de7f1c$var$zC(Function.toString);
$d7238066c5de7f1c$var$NC($d7238066c5de7f1c$var$oo.inspectSource) || ($d7238066c5de7f1c$var$oo.inspectSource = function(r) {
    return $d7238066c5de7f1c$var$MC(r);
});
var $d7238066c5de7f1c$var$au = $d7238066c5de7f1c$var$oo.inspectSource, $d7238066c5de7f1c$var$xC = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$_C = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$cu = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$LC = $d7238066c5de7f1c$var$On, $d7238066c5de7f1c$var$$C = $d7238066c5de7f1c$var$Bt, $d7238066c5de7f1c$var$BC = $d7238066c5de7f1c$var$au, $d7238066c5de7f1c$var$pu = function() {}, $d7238066c5de7f1c$var$hu = $d7238066c5de7f1c$var$$C("Reflect", "construct"), $d7238066c5de7f1c$var$Ta = /^\s*(?:class|function)\b/, $d7238066c5de7f1c$var$UC = $d7238066c5de7f1c$var$xC($d7238066c5de7f1c$var$Ta.exec), $d7238066c5de7f1c$var$qC = !$d7238066c5de7f1c$var$Ta.test($d7238066c5de7f1c$var$pu), $d7238066c5de7f1c$var$Bi = function(e) {
    if (!$d7238066c5de7f1c$var$cu(e)) return !1;
    try {
        return $d7238066c5de7f1c$var$hu($d7238066c5de7f1c$var$pu, [], e), !0;
    } catch  {
        return !1;
    }
}, $d7238066c5de7f1c$var$uu = function(e) {
    if (!$d7238066c5de7f1c$var$cu(e)) return !1;
    switch($d7238066c5de7f1c$var$LC(e)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return !1;
    }
    try {
        return $d7238066c5de7f1c$var$qC || !!$d7238066c5de7f1c$var$UC($d7238066c5de7f1c$var$Ta, $d7238066c5de7f1c$var$BC(e));
    } catch  {
        return !0;
    }
};
$d7238066c5de7f1c$var$uu.sham = !0;
var $d7238066c5de7f1c$var$WC = !$d7238066c5de7f1c$var$hu || $d7238066c5de7f1c$var$_C(function() {
    var r;
    return $d7238066c5de7f1c$var$Bi($d7238066c5de7f1c$var$Bi.call) || !$d7238066c5de7f1c$var$Bi(Object) || !$d7238066c5de7f1c$var$Bi(function() {
        r = !0;
    }) || r;
}) ? $d7238066c5de7f1c$var$uu : $d7238066c5de7f1c$var$Bi, $d7238066c5de7f1c$var$HC = $d7238066c5de7f1c$var$WC, $d7238066c5de7f1c$var$FC = $d7238066c5de7f1c$var$kn, $d7238066c5de7f1c$var$VC = TypeError, $d7238066c5de7f1c$var$KC = function(r) {
    if ($d7238066c5de7f1c$var$HC(r)) return r;
    throw new $d7238066c5de7f1c$var$VC($d7238066c5de7f1c$var$FC(r) + " is not a constructor");
}, $d7238066c5de7f1c$var$Jc = $d7238066c5de7f1c$var$Ot, $d7238066c5de7f1c$var$jC = $d7238066c5de7f1c$var$KC, $d7238066c5de7f1c$var$JC = $d7238066c5de7f1c$var$Pn, $d7238066c5de7f1c$var$GC = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$QC = $d7238066c5de7f1c$var$GC("species"), $d7238066c5de7f1c$var$du = function(r, e) {
    var t = $d7238066c5de7f1c$var$Jc(r).constructor, i;
    return t === void 0 || $d7238066c5de7f1c$var$JC(i = $d7238066c5de7f1c$var$Jc(t)[$d7238066c5de7f1c$var$QC]) ? e : $d7238066c5de7f1c$var$jC(i);
}, $d7238066c5de7f1c$var$YC = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$lu = $d7238066c5de7f1c$var$YC([].slice), $d7238066c5de7f1c$var$ZC = TypeError, $d7238066c5de7f1c$var$XC = function(r, e) {
    if (r < e) throw new $d7238066c5de7f1c$var$ZC("Not enough arguments");
    return r;
}, $d7238066c5de7f1c$var$Gc = $d7238066c5de7f1c$var$yr, $d7238066c5de7f1c$var$vu = /ipad|iphone|ipod/i.test($d7238066c5de7f1c$var$Gc) && /applewebkit/i.test($d7238066c5de7f1c$var$Gc), $d7238066c5de7f1c$var$Le = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$ew = $d7238066c5de7f1c$var$ca, $d7238066c5de7f1c$var$tw = $d7238066c5de7f1c$var$Dn, $d7238066c5de7f1c$var$Qc = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$iw = $d7238066c5de7f1c$var$dt, $d7238066c5de7f1c$var$fu = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$Yc = $d7238066c5de7f1c$var$qh, $d7238066c5de7f1c$var$rw = $d7238066c5de7f1c$var$lu, $d7238066c5de7f1c$var$Zc = $d7238066c5de7f1c$var$da, $d7238066c5de7f1c$var$nw = $d7238066c5de7f1c$var$XC, $d7238066c5de7f1c$var$sw = $d7238066c5de7f1c$var$vu, $d7238066c5de7f1c$var$ow = $d7238066c5de7f1c$var$Ia, $d7238066c5de7f1c$var$ao = $d7238066c5de7f1c$var$Le.setImmediate, $d7238066c5de7f1c$var$Xc = $d7238066c5de7f1c$var$Le.clearImmediate, $d7238066c5de7f1c$var$aw = $d7238066c5de7f1c$var$Le.process, $d7238066c5de7f1c$var$ys = $d7238066c5de7f1c$var$Le.Dispatch, $d7238066c5de7f1c$var$cw = $d7238066c5de7f1c$var$Le.Function, $d7238066c5de7f1c$var$ep = $d7238066c5de7f1c$var$Le.MessageChannel, $d7238066c5de7f1c$var$pw = $d7238066c5de7f1c$var$Le.String, $d7238066c5de7f1c$var$Cs = 0, $d7238066c5de7f1c$var$Ki = {}, $d7238066c5de7f1c$var$tp = "onreadystatechange", $d7238066c5de7f1c$var$ar, $d7238066c5de7f1c$var$Ht, $d7238066c5de7f1c$var$ws, $d7238066c5de7f1c$var$Rs;
$d7238066c5de7f1c$var$fu(function() {
    $d7238066c5de7f1c$var$ar = $d7238066c5de7f1c$var$Le.location;
});
var $d7238066c5de7f1c$var$Pa = function(r) {
    if ($d7238066c5de7f1c$var$iw($d7238066c5de7f1c$var$Ki, r)) {
        var e = $d7238066c5de7f1c$var$Ki[r];
        delete $d7238066c5de7f1c$var$Ki[r], e();
    }
}, $d7238066c5de7f1c$var$Is = function(r) {
    return function() {
        $d7238066c5de7f1c$var$Pa(r);
    };
}, $d7238066c5de7f1c$var$ip = function(r) {
    $d7238066c5de7f1c$var$Pa(r.data);
}, $d7238066c5de7f1c$var$rp = function(r) {
    $d7238066c5de7f1c$var$Le.postMessage($d7238066c5de7f1c$var$pw(r), $d7238066c5de7f1c$var$ar.protocol + "//" + $d7238066c5de7f1c$var$ar.host);
};
(!$d7238066c5de7f1c$var$ao || !$d7238066c5de7f1c$var$Xc) && ($d7238066c5de7f1c$var$ao = function(e) {
    $d7238066c5de7f1c$var$nw(arguments.length, 1);
    var t = $d7238066c5de7f1c$var$Qc(e) ? e : $d7238066c5de7f1c$var$cw(e), i = $d7238066c5de7f1c$var$rw(arguments, 1);
    return $d7238066c5de7f1c$var$Ki[++$d7238066c5de7f1c$var$Cs] = function() {
        $d7238066c5de7f1c$var$ew(t, void 0, i);
    }, $d7238066c5de7f1c$var$Ht($d7238066c5de7f1c$var$Cs), $d7238066c5de7f1c$var$Cs;
}, $d7238066c5de7f1c$var$Xc = function(e) {
    delete $d7238066c5de7f1c$var$Ki[e];
}, $d7238066c5de7f1c$var$ow ? $d7238066c5de7f1c$var$Ht = function(r) {
    $d7238066c5de7f1c$var$aw.nextTick($d7238066c5de7f1c$var$Is(r));
} : $d7238066c5de7f1c$var$ys && $d7238066c5de7f1c$var$ys.now ? $d7238066c5de7f1c$var$Ht = function(r) {
    $d7238066c5de7f1c$var$ys.now($d7238066c5de7f1c$var$Is(r));
} : $d7238066c5de7f1c$var$ep && !$d7238066c5de7f1c$var$sw ? ($d7238066c5de7f1c$var$ws = new $d7238066c5de7f1c$var$ep(), $d7238066c5de7f1c$var$Rs = $d7238066c5de7f1c$var$ws.port2, $d7238066c5de7f1c$var$ws.port1.onmessage = $d7238066c5de7f1c$var$ip, $d7238066c5de7f1c$var$Ht = $d7238066c5de7f1c$var$tw($d7238066c5de7f1c$var$Rs.postMessage, $d7238066c5de7f1c$var$Rs)) : $d7238066c5de7f1c$var$Le.addEventListener && $d7238066c5de7f1c$var$Qc($d7238066c5de7f1c$var$Le.postMessage) && !$d7238066c5de7f1c$var$Le.importScripts && $d7238066c5de7f1c$var$ar && $d7238066c5de7f1c$var$ar.protocol !== "file:" && !$d7238066c5de7f1c$var$fu($d7238066c5de7f1c$var$rp) ? ($d7238066c5de7f1c$var$Ht = $d7238066c5de7f1c$var$rp, $d7238066c5de7f1c$var$Le.addEventListener("message", $d7238066c5de7f1c$var$ip, !1)) : $d7238066c5de7f1c$var$tp in $d7238066c5de7f1c$var$Zc("script") ? $d7238066c5de7f1c$var$Ht = function(r) {
    $d7238066c5de7f1c$var$Yc.appendChild($d7238066c5de7f1c$var$Zc("script"))[$d7238066c5de7f1c$var$tp] = function() {
        $d7238066c5de7f1c$var$Yc.removeChild(this), $d7238066c5de7f1c$var$Pa(r);
    };
} : $d7238066c5de7f1c$var$Ht = function(r) {
    setTimeout($d7238066c5de7f1c$var$Is(r), 0);
});
var $d7238066c5de7f1c$var$gu = {
    set: $d7238066c5de7f1c$var$ao
}, $d7238066c5de7f1c$var$np = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$hw = $d7238066c5de7f1c$var$Dt, $d7238066c5de7f1c$var$uw = Object.getOwnPropertyDescriptor, $d7238066c5de7f1c$var$dw = function(r) {
    if (!$d7238066c5de7f1c$var$hw) return $d7238066c5de7f1c$var$np[r];
    var e = $d7238066c5de7f1c$var$uw($d7238066c5de7f1c$var$np, r);
    return e && e.value;
}, $d7238066c5de7f1c$var$mu = function() {
    this.head = null, this.tail = null;
};
$d7238066c5de7f1c$var$mu.prototype = {
    add: function(r) {
        var e = {
            item: r,
            next: null
        }, t = this.tail;
        t ? t.next = e : this.head = e, this.tail = e;
    },
    get: function() {
        var r = this.head;
        if (r) {
            var e = this.head = r.next;
            return e === null && (this.tail = null), r.item;
        }
    }
};
var $d7238066c5de7f1c$var$Su = $d7238066c5de7f1c$var$mu, $d7238066c5de7f1c$var$lw = $d7238066c5de7f1c$var$yr, $d7238066c5de7f1c$var$vw = /ipad|iphone|ipod/i.test($d7238066c5de7f1c$var$lw) && typeof Pebble < "u", $d7238066c5de7f1c$var$fw = $d7238066c5de7f1c$var$yr, $d7238066c5de7f1c$var$gw = /web0s(?!.*chrome)/i.test($d7238066c5de7f1c$var$fw), $d7238066c5de7f1c$var$Ti = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$mw = $d7238066c5de7f1c$var$dw, $d7238066c5de7f1c$var$sp = $d7238066c5de7f1c$var$Dn, $d7238066c5de7f1c$var$Ts = $d7238066c5de7f1c$var$gu.set, $d7238066c5de7f1c$var$Sw = $d7238066c5de7f1c$var$Su, $d7238066c5de7f1c$var$yw = $d7238066c5de7f1c$var$vu, $d7238066c5de7f1c$var$Cw = $d7238066c5de7f1c$var$vw, $d7238066c5de7f1c$var$ww = $d7238066c5de7f1c$var$gw, $d7238066c5de7f1c$var$Ps = $d7238066c5de7f1c$var$Ia, $d7238066c5de7f1c$var$op = $d7238066c5de7f1c$var$Ti.MutationObserver || $d7238066c5de7f1c$var$Ti.WebKitMutationObserver, $d7238066c5de7f1c$var$ap = $d7238066c5de7f1c$var$Ti.document, $d7238066c5de7f1c$var$cp = $d7238066c5de7f1c$var$Ti.process, $d7238066c5de7f1c$var$xr = $d7238066c5de7f1c$var$Ti.Promise, $d7238066c5de7f1c$var$co = $d7238066c5de7f1c$var$mw("queueMicrotask"), $d7238066c5de7f1c$var$pi, $d7238066c5de7f1c$var$bs, $d7238066c5de7f1c$var$Es, $d7238066c5de7f1c$var$_r, $d7238066c5de7f1c$var$pp;
if (!$d7238066c5de7f1c$var$co) {
    var $d7238066c5de7f1c$var$Lr = new $d7238066c5de7f1c$var$Sw(), $d7238066c5de7f1c$var$$r = function() {
        var r, e;
        for($d7238066c5de7f1c$var$Ps && (r = $d7238066c5de7f1c$var$cp.domain) && r.exit(); e = $d7238066c5de7f1c$var$Lr.get();)try {
            e();
        } catch (t) {
            throw $d7238066c5de7f1c$var$Lr.head && $d7238066c5de7f1c$var$pi(), t;
        }
        r && r.enter();
    };
    !$d7238066c5de7f1c$var$yw && !$d7238066c5de7f1c$var$Ps && !$d7238066c5de7f1c$var$ww && $d7238066c5de7f1c$var$op && $d7238066c5de7f1c$var$ap ? ($d7238066c5de7f1c$var$bs = !0, $d7238066c5de7f1c$var$Es = $d7238066c5de7f1c$var$ap.createTextNode(""), new $d7238066c5de7f1c$var$op($d7238066c5de7f1c$var$$r).observe($d7238066c5de7f1c$var$Es, {
        characterData: !0
    }), $d7238066c5de7f1c$var$pi = function() {
        $d7238066c5de7f1c$var$Es.data = $d7238066c5de7f1c$var$bs = !$d7238066c5de7f1c$var$bs;
    }) : !$d7238066c5de7f1c$var$Cw && $d7238066c5de7f1c$var$xr && $d7238066c5de7f1c$var$xr.resolve ? ($d7238066c5de7f1c$var$_r = $d7238066c5de7f1c$var$xr.resolve(void 0), $d7238066c5de7f1c$var$_r.constructor = $d7238066c5de7f1c$var$xr, $d7238066c5de7f1c$var$pp = $d7238066c5de7f1c$var$sp($d7238066c5de7f1c$var$_r.then, $d7238066c5de7f1c$var$_r), $d7238066c5de7f1c$var$pi = function() {
        $d7238066c5de7f1c$var$pp($d7238066c5de7f1c$var$$r);
    }) : $d7238066c5de7f1c$var$Ps ? $d7238066c5de7f1c$var$pi = function() {
        $d7238066c5de7f1c$var$cp.nextTick($d7238066c5de7f1c$var$$r);
    } : ($d7238066c5de7f1c$var$Ts = $d7238066c5de7f1c$var$sp($d7238066c5de7f1c$var$Ts, $d7238066c5de7f1c$var$Ti), $d7238066c5de7f1c$var$pi = function() {
        $d7238066c5de7f1c$var$Ts($d7238066c5de7f1c$var$$r);
    }), $d7238066c5de7f1c$var$co = function(r) {
        $d7238066c5de7f1c$var$Lr.head || $d7238066c5de7f1c$var$pi(), $d7238066c5de7f1c$var$Lr.add(r);
    };
}
var $d7238066c5de7f1c$var$Rw = $d7238066c5de7f1c$var$co, $d7238066c5de7f1c$var$Iw = function(r, e) {
    try {
        arguments.length === 1 ? console.error(r) : console.error(r, e);
    } catch  {}
}, $d7238066c5de7f1c$var$Ai = function(r) {
    try {
        return {
            error: !1,
            value: r()
        };
    } catch (e) {
        return {
            error: !0,
            value: e
        };
    }
}, $d7238066c5de7f1c$var$Tw = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$ki = $d7238066c5de7f1c$var$Tw.Promise, $d7238066c5de7f1c$var$Pw = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$ji = $d7238066c5de7f1c$var$ki, $d7238066c5de7f1c$var$bw = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$Ew = $d7238066c5de7f1c$var$Mh, $d7238066c5de7f1c$var$Aw = $d7238066c5de7f1c$var$au, $d7238066c5de7f1c$var$kw = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$hp = $d7238066c5de7f1c$var$ou, $d7238066c5de7f1c$var$As = $d7238066c5de7f1c$var$Th, $d7238066c5de7f1c$var$up = $d7238066c5de7f1c$var$ji && $d7238066c5de7f1c$var$ji.prototype, $d7238066c5de7f1c$var$Dw = $d7238066c5de7f1c$var$kw("species"), $d7238066c5de7f1c$var$po = !1, $d7238066c5de7f1c$var$yu = $d7238066c5de7f1c$var$bw($d7238066c5de7f1c$var$Pw.PromiseRejectionEvent), $d7238066c5de7f1c$var$Ow = $d7238066c5de7f1c$var$Ew("Promise", function() {
    var r = $d7238066c5de7f1c$var$Aw($d7238066c5de7f1c$var$ji), e = r !== String($d7238066c5de7f1c$var$ji);
    if (!e && $d7238066c5de7f1c$var$As === 66 || !($d7238066c5de7f1c$var$up.catch && $d7238066c5de7f1c$var$up.finally)) return !0;
    if (!$d7238066c5de7f1c$var$As || $d7238066c5de7f1c$var$As < 51 || !/native code/.test(r)) {
        var t = new $d7238066c5de7f1c$var$ji(function(s) {
            s(1);
        }), i = function(s) {
            s(function() {}, function() {});
        }, n = t.constructor = {};
        if (n[$d7238066c5de7f1c$var$Dw] = i, $d7238066c5de7f1c$var$po = t.then(function() {}) instanceof i, !$d7238066c5de7f1c$var$po) return !0;
    }
    return !e && ($d7238066c5de7f1c$var$hp === "BROWSER" || $d7238066c5de7f1c$var$hp === "DENO") && !$d7238066c5de7f1c$var$yu;
}), $d7238066c5de7f1c$var$Rr = {
    CONSTRUCTOR: $d7238066c5de7f1c$var$Ow,
    REJECTION_EVENT: $d7238066c5de7f1c$var$yu,
    SUBCLASSING: $d7238066c5de7f1c$var$po
}, $d7238066c5de7f1c$var$lt = {}, $d7238066c5de7f1c$var$dp = $d7238066c5de7f1c$var$tt, $d7238066c5de7f1c$var$zw = TypeError, $d7238066c5de7f1c$var$Nw = function(r) {
    var e, t;
    this.promise = new r(function(i, n) {
        if (e !== void 0 || t !== void 0) throw new $d7238066c5de7f1c$var$zw("Bad Promise constructor");
        e = i, t = n;
    }), this.resolve = $d7238066c5de7f1c$var$dp(e), this.reject = $d7238066c5de7f1c$var$dp(t);
};
$d7238066c5de7f1c$var$lt.f = function(r) {
    return new $d7238066c5de7f1c$var$Nw(r);
};
var $d7238066c5de7f1c$var$Mw = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$hn = $d7238066c5de7f1c$var$Ia, $d7238066c5de7f1c$var$$t = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$xw = $d7238066c5de7f1c$var$En, $d7238066c5de7f1c$var$Ir = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$_w = $d7238066c5de7f1c$var$Ra, $d7238066c5de7f1c$var$Lw = $d7238066c5de7f1c$var$zn, $d7238066c5de7f1c$var$$w = $d7238066c5de7f1c$var$AC, $d7238066c5de7f1c$var$Bw = $d7238066c5de7f1c$var$tt, $d7238066c5de7f1c$var$ho = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$Uw = $d7238066c5de7f1c$var$et, $d7238066c5de7f1c$var$qw = $d7238066c5de7f1c$var$OC, $d7238066c5de7f1c$var$Ww = $d7238066c5de7f1c$var$du, $d7238066c5de7f1c$var$Cu = $d7238066c5de7f1c$var$gu.set, $d7238066c5de7f1c$var$ba = $d7238066c5de7f1c$var$Rw, $d7238066c5de7f1c$var$Hw = $d7238066c5de7f1c$var$Iw, $d7238066c5de7f1c$var$Fw = $d7238066c5de7f1c$var$Ai, $d7238066c5de7f1c$var$Vw = $d7238066c5de7f1c$var$Su, $d7238066c5de7f1c$var$wu = $d7238066c5de7f1c$var$wa, $d7238066c5de7f1c$var$uo = $d7238066c5de7f1c$var$ki, $d7238066c5de7f1c$var$Ea = $d7238066c5de7f1c$var$Rr, $d7238066c5de7f1c$var$Ru = $d7238066c5de7f1c$var$lt, $d7238066c5de7f1c$var$Nn = "Promise", $d7238066c5de7f1c$var$Iu = $d7238066c5de7f1c$var$Ea.CONSTRUCTOR, $d7238066c5de7f1c$var$Kw = $d7238066c5de7f1c$var$Ea.REJECTION_EVENT;
$d7238066c5de7f1c$var$Ea.SUBCLASSING;
var $d7238066c5de7f1c$var$ks = $d7238066c5de7f1c$var$wu.getterFor($d7238066c5de7f1c$var$Nn), $d7238066c5de7f1c$var$jw = $d7238066c5de7f1c$var$wu.set, $d7238066c5de7f1c$var$Jw = $d7238066c5de7f1c$var$uo && $d7238066c5de7f1c$var$uo.prototype, $d7238066c5de7f1c$var$li = $d7238066c5de7f1c$var$uo, $d7238066c5de7f1c$var$Ds = $d7238066c5de7f1c$var$Jw, $d7238066c5de7f1c$var$Tu = $d7238066c5de7f1c$var$$t.TypeError, $d7238066c5de7f1c$var$lo = $d7238066c5de7f1c$var$$t.document, $d7238066c5de7f1c$var$Aa = $d7238066c5de7f1c$var$$t.process, $d7238066c5de7f1c$var$vo = $d7238066c5de7f1c$var$Ru.f, $d7238066c5de7f1c$var$Gw = $d7238066c5de7f1c$var$vo, $d7238066c5de7f1c$var$Qw = !!($d7238066c5de7f1c$var$lo && $d7238066c5de7f1c$var$lo.createEvent && $d7238066c5de7f1c$var$$t.dispatchEvent), $d7238066c5de7f1c$var$Pu = "unhandledrejection", $d7238066c5de7f1c$var$Yw = "rejectionhandled", $d7238066c5de7f1c$var$lp = 0, $d7238066c5de7f1c$var$bu = 1, $d7238066c5de7f1c$var$Zw = 2, $d7238066c5de7f1c$var$ka = 1, $d7238066c5de7f1c$var$Eu = 2, $d7238066c5de7f1c$var$Br, $d7238066c5de7f1c$var$vp, $d7238066c5de7f1c$var$Au, $d7238066c5de7f1c$var$ku = function(r) {
    var e;
    return $d7238066c5de7f1c$var$Uw(r) && $d7238066c5de7f1c$var$ho(e = r.then) ? e : !1;
}, $d7238066c5de7f1c$var$Du = function(r, e) {
    var t = e.value, i = e.state === $d7238066c5de7f1c$var$bu, n = i ? r.ok : r.fail, s = r.resolve, o = r.reject, c = r.domain, p, h, a;
    try {
        n ? (i || (e.rejection === $d7238066c5de7f1c$var$Eu && $d7238066c5de7f1c$var$eR(e), e.rejection = $d7238066c5de7f1c$var$ka), n === !0 ? p = t : (c && c.enter(), p = n(t), c && (c.exit(), a = !0)), p === r.promise ? o(new $d7238066c5de7f1c$var$Tu("Promise-chain cycle")) : (h = $d7238066c5de7f1c$var$ku(p)) ? $d7238066c5de7f1c$var$Ir(h, p, s, o) : s(p)) : o(t);
    } catch (d) {
        c && !a && c.exit(), o(d);
    }
}, $d7238066c5de7f1c$var$Ou = function(r, e) {
    r.notified || (r.notified = !0, $d7238066c5de7f1c$var$ba(function() {
        for(var t = r.reactions, i; i = t.get();)$d7238066c5de7f1c$var$Du(i, r);
        r.notified = !1, e && !r.rejection && $d7238066c5de7f1c$var$Xw(r);
    }));
}, $d7238066c5de7f1c$var$zu = function(r, e, t) {
    var i, n;
    $d7238066c5de7f1c$var$Qw ? (i = $d7238066c5de7f1c$var$lo.createEvent("Event"), i.promise = e, i.reason = t, i.initEvent(r, !1, !0), $d7238066c5de7f1c$var$$t.dispatchEvent(i)) : i = {
        promise: e,
        reason: t
    }, !$d7238066c5de7f1c$var$Kw && (n = $d7238066c5de7f1c$var$$t["on" + r]) ? n(i) : r === $d7238066c5de7f1c$var$Pu && $d7238066c5de7f1c$var$Hw("Unhandled promise rejection", t);
}, $d7238066c5de7f1c$var$Xw = function(r) {
    $d7238066c5de7f1c$var$Ir($d7238066c5de7f1c$var$Cu, $d7238066c5de7f1c$var$$t, function() {
        var e = r.facade, t = r.value, i = $d7238066c5de7f1c$var$fp(r), n;
        if (i && (n = $d7238066c5de7f1c$var$Fw(function() {
            $d7238066c5de7f1c$var$hn ? $d7238066c5de7f1c$var$Aa.emit("unhandledRejection", t, e) : $d7238066c5de7f1c$var$zu($d7238066c5de7f1c$var$Pu, e, t);
        }), r.rejection = $d7238066c5de7f1c$var$hn || $d7238066c5de7f1c$var$fp(r) ? $d7238066c5de7f1c$var$Eu : $d7238066c5de7f1c$var$ka, n.error)) throw n.value;
    });
}, $d7238066c5de7f1c$var$fp = function(r) {
    return r.rejection !== $d7238066c5de7f1c$var$ka && !r.parent;
}, $d7238066c5de7f1c$var$eR = function(r) {
    $d7238066c5de7f1c$var$Ir($d7238066c5de7f1c$var$Cu, $d7238066c5de7f1c$var$$t, function() {
        var e = r.facade;
        $d7238066c5de7f1c$var$hn ? $d7238066c5de7f1c$var$Aa.emit("rejectionHandled", e) : $d7238066c5de7f1c$var$zu($d7238066c5de7f1c$var$Yw, e, r.value);
    });
}, $d7238066c5de7f1c$var$vi = function(r, e, t) {
    return function(i) {
        r(e, i, t);
    };
}, $d7238066c5de7f1c$var$mi = function(r, e, t) {
    r.done || (r.done = !0, t && (r = t), r.value = e, r.state = $d7238066c5de7f1c$var$Zw, $d7238066c5de7f1c$var$Ou(r, !0));
}, $d7238066c5de7f1c$var$fo = function(r, e, t) {
    if (!r.done) {
        r.done = !0, t && (r = t);
        try {
            if (r.facade === e) throw new $d7238066c5de7f1c$var$Tu("Promise can't be resolved itself");
            var i = $d7238066c5de7f1c$var$ku(e);
            i ? $d7238066c5de7f1c$var$ba(function() {
                var n = {
                    done: !1
                };
                try {
                    $d7238066c5de7f1c$var$Ir(i, e, $d7238066c5de7f1c$var$vi($d7238066c5de7f1c$var$fo, n, r), $d7238066c5de7f1c$var$vi($d7238066c5de7f1c$var$mi, n, r));
                } catch (s) {
                    $d7238066c5de7f1c$var$mi(n, s, r);
                }
            }) : (r.value = e, r.state = $d7238066c5de7f1c$var$bu, $d7238066c5de7f1c$var$Ou(r, !1));
        } catch (n) {
            $d7238066c5de7f1c$var$mi({
                done: !1
            }, n, r);
        }
    }
};
$d7238066c5de7f1c$var$Iu && ($d7238066c5de7f1c$var$li = function(e) {
    $d7238066c5de7f1c$var$qw(this, $d7238066c5de7f1c$var$Ds), $d7238066c5de7f1c$var$Bw(e), $d7238066c5de7f1c$var$Ir($d7238066c5de7f1c$var$Br, this);
    var t = $d7238066c5de7f1c$var$ks(this);
    try {
        e($d7238066c5de7f1c$var$vi($d7238066c5de7f1c$var$fo, t), $d7238066c5de7f1c$var$vi($d7238066c5de7f1c$var$mi, t));
    } catch (i) {
        $d7238066c5de7f1c$var$mi(t, i);
    }
}, $d7238066c5de7f1c$var$Ds = $d7238066c5de7f1c$var$li.prototype, $d7238066c5de7f1c$var$Br = function(e) {
    $d7238066c5de7f1c$var$jw(this, {
        type: $d7238066c5de7f1c$var$Nn,
        done: !1,
        notified: !1,
        parent: !1,
        reactions: new $d7238066c5de7f1c$var$Vw(),
        rejection: !1,
        state: $d7238066c5de7f1c$var$lp,
        value: null
    });
}, $d7238066c5de7f1c$var$Br.prototype = $d7238066c5de7f1c$var$_w($d7238066c5de7f1c$var$Ds, "then", function(e, t) {
    var i = $d7238066c5de7f1c$var$ks(this), n = $d7238066c5de7f1c$var$vo($d7238066c5de7f1c$var$Ww(this, $d7238066c5de7f1c$var$li));
    return i.parent = !0, n.ok = $d7238066c5de7f1c$var$ho(e) ? e : !0, n.fail = $d7238066c5de7f1c$var$ho(t) && t, n.domain = $d7238066c5de7f1c$var$hn ? $d7238066c5de7f1c$var$Aa.domain : void 0, i.state === $d7238066c5de7f1c$var$lp ? i.reactions.add(n) : $d7238066c5de7f1c$var$ba(function() {
        $d7238066c5de7f1c$var$Du(n, i);
    }), n.promise;
}), $d7238066c5de7f1c$var$vp = function() {
    var r = new $d7238066c5de7f1c$var$Br(), e = $d7238066c5de7f1c$var$ks(r);
    this.promise = r, this.resolve = $d7238066c5de7f1c$var$vi($d7238066c5de7f1c$var$fo, e), this.reject = $d7238066c5de7f1c$var$vi($d7238066c5de7f1c$var$mi, e);
}, $d7238066c5de7f1c$var$Ru.f = $d7238066c5de7f1c$var$vo = function(r) {
    return r === $d7238066c5de7f1c$var$li || r === $d7238066c5de7f1c$var$Au ? new $d7238066c5de7f1c$var$vp(r) : $d7238066c5de7f1c$var$Gw(r);
});
$d7238066c5de7f1c$var$Mw({
    global: !0,
    wrap: !0,
    forced: $d7238066c5de7f1c$var$Iu
}, {
    Promise: $d7238066c5de7f1c$var$li
});
$d7238066c5de7f1c$var$Au = $d7238066c5de7f1c$var$xw.Promise;
$d7238066c5de7f1c$var$Lw($d7238066c5de7f1c$var$li, $d7238066c5de7f1c$var$Nn, !1, !0);
$d7238066c5de7f1c$var$$w($d7238066c5de7f1c$var$Nn);
var $d7238066c5de7f1c$var$tR = $d7238066c5de7f1c$var$Ue, $d7238066c5de7f1c$var$Nu = $d7238066c5de7f1c$var$tR("iterator"), $d7238066c5de7f1c$var$Mu = !1;
try {
    var $d7238066c5de7f1c$var$iR = 0, $d7238066c5de7f1c$var$gp = {
        next: function() {
            return {
                done: !!$d7238066c5de7f1c$var$iR++
            };
        },
        return: function() {
            $d7238066c5de7f1c$var$Mu = !0;
        }
    };
    $d7238066c5de7f1c$var$gp[$d7238066c5de7f1c$var$Nu] = function() {
        return this;
    }, Array.from($d7238066c5de7f1c$var$gp, function() {
        throw 2;
    });
} catch  {}
var $d7238066c5de7f1c$var$rR = function(r, e) {
    try {
        if (!e && !$d7238066c5de7f1c$var$Mu) return !1;
    } catch  {
        return !1;
    }
    var t = !1;
    try {
        var i = {};
        i[$d7238066c5de7f1c$var$Nu] = function() {
            return {
                next: function() {
                    return {
                        done: t = !0
                    };
                }
            };
        }, r(i);
    } catch  {}
    return t;
}, $d7238066c5de7f1c$var$nR = $d7238066c5de7f1c$var$ki, $d7238066c5de7f1c$var$sR = $d7238066c5de7f1c$var$rR, $d7238066c5de7f1c$var$oR = $d7238066c5de7f1c$var$Rr.CONSTRUCTOR, $d7238066c5de7f1c$var$Mn = $d7238066c5de7f1c$var$oR || !$d7238066c5de7f1c$var$sR(function(r) {
    $d7238066c5de7f1c$var$nR.all(r).then(void 0, function() {});
}), $d7238066c5de7f1c$var$aR = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$cR = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$pR = $d7238066c5de7f1c$var$tt, $d7238066c5de7f1c$var$hR = $d7238066c5de7f1c$var$lt, $d7238066c5de7f1c$var$uR = $d7238066c5de7f1c$var$Ai, $d7238066c5de7f1c$var$dR = $d7238066c5de7f1c$var$wr, $d7238066c5de7f1c$var$lR = $d7238066c5de7f1c$var$Mn;
$d7238066c5de7f1c$var$aR({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$lR
}, {
    all: function(e) {
        var t = this, i = $d7238066c5de7f1c$var$hR.f(t), n = i.resolve, s = i.reject, o = $d7238066c5de7f1c$var$uR(function() {
            var c = $d7238066c5de7f1c$var$pR(t.resolve), p = [], h = 0, a = 1;
            $d7238066c5de7f1c$var$dR(e, function(d) {
                var v = h++, g = !1;
                a++, $d7238066c5de7f1c$var$cR(c, t, d).then(function(I) {
                    g || (g = !0, p[v] = I, --a || n(p));
                }, s);
            }), --a || n(p);
        });
        return o.error && s(o.value), i.promise;
    }
});
var $d7238066c5de7f1c$var$vR = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$fR = $d7238066c5de7f1c$var$Rr.CONSTRUCTOR, $d7238066c5de7f1c$var$mp = $d7238066c5de7f1c$var$ki;
$d7238066c5de7f1c$var$mp && $d7238066c5de7f1c$var$mp.prototype;
$d7238066c5de7f1c$var$vR({
    target: "Promise",
    proto: !0,
    forced: $d7238066c5de7f1c$var$fR,
    real: !0
}, {
    catch: function(r) {
        return this.then(void 0, r);
    }
});
var $d7238066c5de7f1c$var$gR = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$mR = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$SR = $d7238066c5de7f1c$var$tt, $d7238066c5de7f1c$var$yR = $d7238066c5de7f1c$var$lt, $d7238066c5de7f1c$var$CR = $d7238066c5de7f1c$var$Ai, $d7238066c5de7f1c$var$wR = $d7238066c5de7f1c$var$wr, $d7238066c5de7f1c$var$RR = $d7238066c5de7f1c$var$Mn;
$d7238066c5de7f1c$var$gR({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$RR
}, {
    race: function(e) {
        var t = this, i = $d7238066c5de7f1c$var$yR.f(t), n = i.reject, s = $d7238066c5de7f1c$var$CR(function() {
            var o = $d7238066c5de7f1c$var$SR(t.resolve);
            $d7238066c5de7f1c$var$wR(e, function(c) {
                $d7238066c5de7f1c$var$mR(o, t, c).then(i.resolve, n);
            });
        });
        return s.error && n(s.value), i.promise;
    }
});
var $d7238066c5de7f1c$var$IR = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$TR = $d7238066c5de7f1c$var$lt, $d7238066c5de7f1c$var$PR = $d7238066c5de7f1c$var$Rr.CONSTRUCTOR;
$d7238066c5de7f1c$var$IR({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$PR
}, {
    reject: function(e) {
        var t = $d7238066c5de7f1c$var$TR.f(this), i = t.reject;
        return i(e), t.promise;
    }
});
var $d7238066c5de7f1c$var$bR = $d7238066c5de7f1c$var$Ot, $d7238066c5de7f1c$var$ER = $d7238066c5de7f1c$var$et, $d7238066c5de7f1c$var$AR = $d7238066c5de7f1c$var$lt, $d7238066c5de7f1c$var$xu = function(r, e) {
    if ($d7238066c5de7f1c$var$bR(r), $d7238066c5de7f1c$var$ER(e) && e.constructor === r) return e;
    var t = $d7238066c5de7f1c$var$AR.f(r), i = t.resolve;
    return i(e), t.promise;
}, $d7238066c5de7f1c$var$kR = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$DR = $d7238066c5de7f1c$var$Bt, $d7238066c5de7f1c$var$OR = $d7238066c5de7f1c$var$wf, $d7238066c5de7f1c$var$zR = $d7238066c5de7f1c$var$ki, $d7238066c5de7f1c$var$NR = $d7238066c5de7f1c$var$Rr.CONSTRUCTOR, $d7238066c5de7f1c$var$MR = $d7238066c5de7f1c$var$xu, $d7238066c5de7f1c$var$xR = $d7238066c5de7f1c$var$DR("Promise"), $d7238066c5de7f1c$var$_R = !$d7238066c5de7f1c$var$NR;
$d7238066c5de7f1c$var$kR({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$OR
}, {
    resolve: function(e) {
        return $d7238066c5de7f1c$var$MR($d7238066c5de7f1c$var$_R && this === $d7238066c5de7f1c$var$xR ? $d7238066c5de7f1c$var$zR : this, e);
    }
});
var $d7238066c5de7f1c$var$LR = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$$R = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$BR = $d7238066c5de7f1c$var$tt, $d7238066c5de7f1c$var$UR = $d7238066c5de7f1c$var$lt, $d7238066c5de7f1c$var$qR = $d7238066c5de7f1c$var$Ai, $d7238066c5de7f1c$var$WR = $d7238066c5de7f1c$var$wr, $d7238066c5de7f1c$var$HR = $d7238066c5de7f1c$var$Mn;
$d7238066c5de7f1c$var$LR({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$HR
}, {
    allSettled: function(e) {
        var t = this, i = $d7238066c5de7f1c$var$UR.f(t), n = i.resolve, s = i.reject, o = $d7238066c5de7f1c$var$qR(function() {
            var c = $d7238066c5de7f1c$var$BR(t.resolve), p = [], h = 0, a = 1;
            $d7238066c5de7f1c$var$WR(e, function(d) {
                var v = h++, g = !1;
                a++, $d7238066c5de7f1c$var$$R(c, t, d).then(function(I) {
                    g || (g = !0, p[v] = {
                        status: "fulfilled",
                        value: I
                    }, --a || n(p));
                }, function(I) {
                    g || (g = !0, p[v] = {
                        status: "rejected",
                        reason: I
                    }, --a || n(p));
                });
            }), --a || n(p);
        });
        return o.error && s(o.value), i.promise;
    }
});
var $d7238066c5de7f1c$var$FR = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$VR = $d7238066c5de7f1c$var$Ke, $d7238066c5de7f1c$var$KR = $d7238066c5de7f1c$var$tt, $d7238066c5de7f1c$var$jR = $d7238066c5de7f1c$var$Bt, $d7238066c5de7f1c$var$JR = $d7238066c5de7f1c$var$lt, $d7238066c5de7f1c$var$GR = $d7238066c5de7f1c$var$Ai, $d7238066c5de7f1c$var$QR = $d7238066c5de7f1c$var$wr, $d7238066c5de7f1c$var$YR = $d7238066c5de7f1c$var$Mn, $d7238066c5de7f1c$var$Sp = "No one promise resolved";
$d7238066c5de7f1c$var$FR({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$YR
}, {
    any: function(e) {
        var t = this, i = $d7238066c5de7f1c$var$jR("AggregateError"), n = $d7238066c5de7f1c$var$JR.f(t), s = n.resolve, o = n.reject, c = $d7238066c5de7f1c$var$GR(function() {
            var p = $d7238066c5de7f1c$var$KR(t.resolve), h = [], a = 0, d = 1, v = !1;
            $d7238066c5de7f1c$var$QR(e, function(g) {
                var I = a++, A = !1;
                d++, $d7238066c5de7f1c$var$VR(p, t, g).then(function(D) {
                    A || v || (v = !0, s(D));
                }, function(D) {
                    A || v || (A = !0, h[I] = D, --d || o(new i(h, $d7238066c5de7f1c$var$Sp)));
                });
            }), --d || o(new i(h, $d7238066c5de7f1c$var$Sp));
        });
        return c.error && o(c.value), n.promise;
    }
});
var $d7238066c5de7f1c$var$ZR = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$XR = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$eI = $d7238066c5de7f1c$var$ca, $d7238066c5de7f1c$var$tI = $d7238066c5de7f1c$var$lu, $d7238066c5de7f1c$var$iI = $d7238066c5de7f1c$var$lt, $d7238066c5de7f1c$var$rI = $d7238066c5de7f1c$var$tt, $d7238066c5de7f1c$var$_u = $d7238066c5de7f1c$var$Ai, $d7238066c5de7f1c$var$Os = $d7238066c5de7f1c$var$XR.Promise, $d7238066c5de7f1c$var$yp = !1, $d7238066c5de7f1c$var$nI = !$d7238066c5de7f1c$var$Os || !$d7238066c5de7f1c$var$Os.try || $d7238066c5de7f1c$var$_u(function() {
    $d7238066c5de7f1c$var$Os.try(function(r) {
        $d7238066c5de7f1c$var$yp = r === 8;
    }, 8);
}).error || !$d7238066c5de7f1c$var$yp;
$d7238066c5de7f1c$var$ZR({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$nI
}, {
    try: function(r) {
        var e = arguments.length > 1 ? $d7238066c5de7f1c$var$tI(arguments, 1) : [], t = $d7238066c5de7f1c$var$iI.f(this), i = $d7238066c5de7f1c$var$_u(function() {
            return $d7238066c5de7f1c$var$eI($d7238066c5de7f1c$var$rI(r), void 0, e);
        });
        return (i.error ? t.reject : t.resolve)(i.value), t.promise;
    }
});
var $d7238066c5de7f1c$var$sI = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$oI = $d7238066c5de7f1c$var$lt;
$d7238066c5de7f1c$var$sI({
    target: "Promise",
    stat: !0
}, {
    withResolvers: function() {
        var e = $d7238066c5de7f1c$var$oI.f(this);
        return {
            promise: e.promise,
            resolve: e.resolve,
            reject: e.reject
        };
    }
});
var $d7238066c5de7f1c$var$aI = $d7238066c5de7f1c$var$qe, $d7238066c5de7f1c$var$go = $d7238066c5de7f1c$var$ki, $d7238066c5de7f1c$var$cI = $d7238066c5de7f1c$var$Be, $d7238066c5de7f1c$var$pI = $d7238066c5de7f1c$var$Bt, $d7238066c5de7f1c$var$hI = $d7238066c5de7f1c$var$Pe, $d7238066c5de7f1c$var$uI = $d7238066c5de7f1c$var$du, $d7238066c5de7f1c$var$Cp = $d7238066c5de7f1c$var$xu, $d7238066c5de7f1c$var$dI = $d7238066c5de7f1c$var$go && $d7238066c5de7f1c$var$go.prototype, $d7238066c5de7f1c$var$lI = !!$d7238066c5de7f1c$var$go && $d7238066c5de7f1c$var$cI(function() {
    $d7238066c5de7f1c$var$dI.finally.call({
        then: function() {}
    }, function() {});
});
$d7238066c5de7f1c$var$aI({
    target: "Promise",
    proto: !0,
    real: !0,
    forced: $d7238066c5de7f1c$var$lI
}, {
    finally: function(r) {
        var e = $d7238066c5de7f1c$var$uI(this, $d7238066c5de7f1c$var$pI("Promise")), t = $d7238066c5de7f1c$var$hI(r);
        return this.then(t ? function(i) {
            return $d7238066c5de7f1c$var$Cp(e, r()).then(function() {
                return i;
            });
        } : r, t ? function(i) {
            return $d7238066c5de7f1c$var$Cp(e, r()).then(function() {
                throw i;
            });
        } : r);
    }
});
var $d7238066c5de7f1c$var$Da = $d7238066c5de7f1c$var$Ne, $d7238066c5de7f1c$var$vI = $d7238066c5de7f1c$var$fa, $d7238066c5de7f1c$var$fI = $d7238066c5de7f1c$var$Ca, $d7238066c5de7f1c$var$gI = $d7238066c5de7f1c$var$bn, $d7238066c5de7f1c$var$mI = $d7238066c5de7f1c$var$Da("".charAt), $d7238066c5de7f1c$var$wp = $d7238066c5de7f1c$var$Da("".charCodeAt), $d7238066c5de7f1c$var$SI = $d7238066c5de7f1c$var$Da("".slice), $d7238066c5de7f1c$var$yI = function(r) {
    return function(e, t) {
        var i = $d7238066c5de7f1c$var$fI($d7238066c5de7f1c$var$gI(e)), n = $d7238066c5de7f1c$var$vI(t), s = i.length, o, c;
        return n < 0 || n >= s ? r ? "" : void 0 : (o = $d7238066c5de7f1c$var$wp(i, n), o < 55296 || o > 56319 || n + 1 === s || (c = $d7238066c5de7f1c$var$wp(i, n + 1)) < 56320 || c > 57343 ? r ? $d7238066c5de7f1c$var$mI(i, n) : o : r ? $d7238066c5de7f1c$var$SI(i, n, n + 2) : (o - 55296 << 10) + (c - 56320) + 65536);
    };
}, $d7238066c5de7f1c$var$CI = {
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $d7238066c5de7f1c$var$yI(!0)
}, $d7238066c5de7f1c$var$wI = $d7238066c5de7f1c$var$CI.charAt, $d7238066c5de7f1c$var$RI = $d7238066c5de7f1c$var$Ca, $d7238066c5de7f1c$var$Lu = $d7238066c5de7f1c$var$wa, $d7238066c5de7f1c$var$II = $d7238066c5de7f1c$var$iu, $d7238066c5de7f1c$var$Rp = $d7238066c5de7f1c$var$ru, $d7238066c5de7f1c$var$$u = "String Iterator", $d7238066c5de7f1c$var$TI = $d7238066c5de7f1c$var$Lu.set, $d7238066c5de7f1c$var$PI = $d7238066c5de7f1c$var$Lu.getterFor($d7238066c5de7f1c$var$$u);
$d7238066c5de7f1c$var$II(String, "String", function(r) {
    $d7238066c5de7f1c$var$TI(this, {
        type: $d7238066c5de7f1c$var$$u,
        string: $d7238066c5de7f1c$var$RI(r),
        index: 0
    });
}, function() {
    var e = $d7238066c5de7f1c$var$PI(this), t = e.string, i = e.index, n;
    return i >= t.length ? $d7238066c5de7f1c$var$Rp(void 0, !0) : (n = $d7238066c5de7f1c$var$wI(t, i), e.index += n.length, $d7238066c5de7f1c$var$Rp(n, !1));
});
var $d7238066c5de7f1c$var$bI = $d7238066c5de7f1c$var$En, $d7238066c5de7f1c$var$EI = $d7238066c5de7f1c$var$bI.Promise, $d7238066c5de7f1c$var$AI = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
}, $d7238066c5de7f1c$var$kI = $d7238066c5de7f1c$var$AI, $d7238066c5de7f1c$var$DI = $d7238066c5de7f1c$var$de, $d7238066c5de7f1c$var$OI = $d7238066c5de7f1c$var$zn, $d7238066c5de7f1c$var$Ip = $d7238066c5de7f1c$var$Ei;
for(var $d7238066c5de7f1c$var$zs in $d7238066c5de7f1c$var$kI)$d7238066c5de7f1c$var$OI($d7238066c5de7f1c$var$DI[$d7238066c5de7f1c$var$zs], $d7238066c5de7f1c$var$zs), $d7238066c5de7f1c$var$Ip[$d7238066c5de7f1c$var$zs] = $d7238066c5de7f1c$var$Ip.Array;
var $d7238066c5de7f1c$var$zI = $d7238066c5de7f1c$var$EI, $d7238066c5de7f1c$var$NI = $d7238066c5de7f1c$var$zI, $d7238066c5de7f1c$var$MI = $d7238066c5de7f1c$var$NI, $d7238066c5de7f1c$var$xI = $d7238066c5de7f1c$var$Nv.default, $d7238066c5de7f1c$var$_I = $d7238066c5de7f1c$var$xI($d7238066c5de7f1c$var$MI);
function $d7238066c5de7f1c$var$LI() {
    var r = {};
    return r.promise = new $d7238066c5de7f1c$var$_I.default(function(e, t) {
        r.resolve = e, r.reject = t;
    }), r;
}
var $d7238066c5de7f1c$var$$I = $d7238066c5de7f1c$var$LI;
(function(r) {
    var e = $d7238066c5de7f1c$var$zv, t = $d7238066c5de7f1c$var$$I;
    function i(P) {
        Object.defineProperty(P, "__esModule", {
            value: !0,
            configurable: !0
        });
    }
    function n(P, f, S, y) {
        Object.defineProperty(P, f, {
            get: S,
            set: y,
            enumerable: !0,
            configurable: !0
        });
    }
    function s(P) {
        return P && P.__esModule ? P.default : P;
    }
    i(r.exports), n(r.exports, "default", ()=>xn), n(r.exports, "createSpeechRecognitionPonyfill", ()=>ke), n(r.exports, "createSpeechSynthesisPonyfill", ()=>Ut), n(r.exports, "fetchAuthorizationToken", ()=>ti), n(r.exports, "SpeechSynthesisUtterance", ()=>V), n(r.exports, "SpeechSynthesis", ()=>ft), n(r.exports, "SpeechGrammarList", ()=>A);
    function o(P, f) {
        const S = {
            // @ts-ignore
            ...[].reduce.call(P, (y, m, N)=>(y[N] = m, y), {}),
            ...f,
            length: P.length,
            [Symbol.iterator]: ()=>[].slice.call(S)[Symbol.iterator]()
        };
        return S;
    }
    var c = {
        AudioConfig: e.AudioConfig,
        OutputFormat: e.OutputFormat,
        ResultReason: e.ResultReason,
        SpeechConfig: e.SpeechConfig,
        SpeechRecognizer: e.SpeechRecognizer,
        SpeechSynthesizer: e.SpeechSynthesizer
    };
    const { ResultReason: { RecognizingSpeech: p, RecognizedSpeech: h } } = c;
    function a(P, { maxAlternatives: f = 1 / 0, textNormalization: S = "display" } = {}) {
        if (P.reason === p || P.reason === h && !P.json.NBest) {
            const y = [
                {
                    confidence: 0.5,
                    transcript: P.text
                }
            ];
            return P.reason === h && (y.isFinal = !0), y;
        } else if (P.reason === h) return o((P.json.NBest || []).slice(0, f).map(({ Confidence: m, Display: N, ITN: q, Lexical: G, MaskedITN: te })=>({
                confidence: m,
                transcript: S === "itn" ? q : S === "lexical" ? G : S === "maskeditn" ? te : N
            })), {
            isFinal: !0
        });
        return [];
    }
    function d() {
        let P;
        const f = [];
        return {
            push: (m)=>{
                if (P) {
                    const { resolve: N } = P;
                    P = null, N(m);
                } else f.push(m);
            },
            shift: ()=>f.length ? Promise.resolve(f.shift()) : (P || (P = s(t)())).promise
        };
    }
    function v(P) {
        return typeof P == "function" ? P() : P;
    }
    let g = !0;
    function I({ credentials: P, looseEvents: f, ...S }) {
        if (!P) throw new Error("web-speech-cognitive-services: Credentials must be specified.");
        return {
            ...S,
            fetchCredentials: async ()=>{
                const { authorizationToken: y, customVoiceHostname: m, region: N, speechRecognitionHostname: q, speechSynthesisHostname: G, subscriptionKey: te } = await v(P);
                if (!y && !te || y && te) throw new Error('web-speech-cognitive-services: Either "authorizationToken" or "subscriptionKey" must be provided.');
                if (!N && !(q && G)) throw new Error('web-speech-cognitive-services: Either "region" or "speechRecognitionHostname" and "speechSynthesisHostname" must be set.');
                if (N && (m || q || G)) throw new Error('web-speech-cognitive-services: Only either "region" or "customVoiceHostname", "speechRecognitionHostname" and "speechSynthesisHostname" can be set.');
                if (y) {
                    if (typeof y != "string") throw new Error('web-speech-cognitive-services: "authorizationToken" must be a string.');
                } else if (typeof te != "string") throw new Error('web-speech-cognitive-services: "subscriptionKey" must be a string.');
                return g && te && (console.warn("web-speech-cognitive-services: In production environment, subscription key should not be used, authorization token should be used instead."), g = !1), {
                    region: N,
                    authorizationToken: y,
                    subscriptionKey: te,
                    customVoiceHostname: m,
                    speechRecognitionHostname: q,
                    speechSynthesisHostname: G
                };
            },
            looseEvents: f
        };
    }
    class A {
        addFromString() {
            throw new Error("JSGF is not supported");
        }
        get phrases() {
            return this._phrases;
        }
        set phrases(f) {
            if (Array.isArray(f)) this._phrases = f;
            else if (typeof f == "string") this._phrases = [
                f
            ];
            else throw new Error("The provided value is not an array or of type 'string'");
        }
        constructor(){
            this._phrases = [];
        }
    }
    function D({ duration: P, errorDetails: f, json: S, offset: y, properties: m, reason: N, resultId: q, text: G }) {
        return {
            duration: P,
            errorDetails: f,
            json: JSON.parse(S),
            offset: y,
            properties: m,
            reason: N,
            resultId: q,
            text: G
        };
    }
    function z(P) {
        const f = new Int16Array(P);
        return f.reduce((S, y)=>S + Math.abs(y), 0) / f.length;
    }
    function C(P) {
        return (...f)=>new Promise((S, y)=>P(...f, S, y));
    }
    function _(P) {
        const f = P.attach, S = P.attach.bind(P);
        let y = !1, m = !1;
        return P.attach = async ()=>{
            const N = await S();
            return {
                ...N,
                read: async ()=>{
                    const q = await N.read();
                    return !y && z(q.buffer) > 150 && (P.events.onEvent({
                        name: "FirstAudibleChunk"
                    }), y = !0), m ? {
                        buffer: new ArrayBuffer(0),
                        isEnd: !0,
                        timeReceived: Date.now()
                    } : q;
                }
            };
        }, {
            audioConfig: P,
            pause: ()=>{
                m = !0;
            },
            unprepare: ()=>{
                P.attach = f;
            }
        };
    }
    class L {
        constructor(f, S){
            this.audioConfig = null, this.speechConfig = null, this.recognizer = null, this.enableTelemetry = !0, this.looseEvents = !1, this.textNormalization = "display", this.started = !1, this._autoStart = !1, this._passive = !1, this._continuous = !1, this._interimResults = !0, this._grammars = new A(), this._maxAlternatives = 1, this._debug = !1, this.onstart = ()=>{}, this.onend = ()=>{}, this.onpassivestart = ()=>{}, this.onpassiveend = ()=>{}, this.onaudiostart = ()=>{}, this.onaudioend = ()=>{}, this.onsoundstart = ()=>{}, this.onsoundend = ()=>{}, this.onspeechstart = ()=>{}, this.onspeechend = ()=>{}, this.onerror = (b)=>{
                console.log("Error : ", b);
            }, this.onabort = ()=>{
                this._debug && console.log("Recognition aborted");
            }, this.onresult = (b)=>{
                this._debug && console.log("Result : ", b);
            }, this.onpassiveresult = (b)=>{
                this._debug && console.log("Passive Result : ", b);
            }, this.onwakeup = ()=>{
                this._debug && console.log("Wake up !");
            }, this.start = ()=>{
                this._startOnce().catch((b)=>{
                    new Error(`error : ${b.message}
callstack : ${b.stack}`);
                });
            }, this.abort = void 0, this.stop = void 0, this.initRecognizer = async (b, Q, be)=>{
                const { authorizationToken: K, region: we = "westus", speechRecognitionHostname: Me, subscriptionKey: zt } = await b();
                if (Me) {
                    const Di = Me.startsWith("ws://") || Me.startsWith("wss://") ? Me : `wss://${Me}`;
                    K ? (this.speechConfig = e.SpeechConfig.fromHost(new URL(Di)), this.speechConfig.authorizationToken = K) : this.speechConfig = e.SpeechConfig.fromHost(new URL(Di), zt);
                } else we && (K || zt) && (this.speechConfig = K ? e.SpeechConfig.fromAuthorizationToken(K, we) : zt ? e.SpeechConfig.fromSubscription(zt, we) : null);
                this.speechConfig && (Q && this.speechConfig && (this.speechConfig.endpointId = Q), this.speechConfig.outputFormat = e.OutputFormat.Detailed, this.speechConfig.speechRecognitionLanguage = this._lang || "en-US", be && this.speechConfig.setProperty(e.PropertyId[e.PropertyId.Speech_SegmentationSilenceTimeoutMs], `${be}`), this._autoStart && this.start());
            }, this.createRecognizer = async ()=>{
                if (this.audioConfig && this.speechConfig) {
                    this.speechConfig.speechRecognitionLanguage = this._lang, this.recognizer = new e.SpeechRecognizer(this.speechConfig, this.audioConfig);
                    const { dynamicGrammar: b } = this.recognizer.internalData;
                    this.referenceGrammars && this.referenceGrammars.length && b.addReferenceGrammar(this.referenceGrammars);
                    const { phrases: Q } = this._grammars;
                    if (Q && Q.length) {
                        const be = e.PhraseListGrammar.fromRecognizer(this.recognizer);
                        Q.forEach((K)=>{
                            be.addPhrase(K);
                        });
                    }
                } else this.recognizer = null;
            }, this.changeLanguage = async (b)=>{
                this.recognizer && this.audioConfig && this.speechConfig && b && b !== this._lang ? (await C(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))(), this._lang = b, this._continuous && this.start()) : this.recognizer = null;
            }, this.toggleContinuousPassiveToActive = async ()=>{
                this._continuous && this.recognizer && this.audioConfig && this.speechConfig && (this.started && await C(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))(), this._continuous = !1, this._passive = !1, this.start());
            }, this.toggleContinuousActiveToPassive = async ()=>{
                !this._continuous && this.recognizer && this.audioConfig && this.speechConfig && (this.started && await C(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))(), this._continuous = !0, this._passive = !0, this.start());
            }, this.processSendEvent = (b, Q)=>{
                switch(this._debug && console.log("Speech Recognizer Event : type = ", b, `
, data = `, Q), b){
                    case "start":
                        this._passive ? this.onpassivestart && this.onpassivestart() : this.onstart && this.onstart(), this.started = !0;
                        break;
                    case "end":
                        this._passive ? this.onpassiveend && this.onpassiveend() : this.onend && this.onend(), this.started = !1;
                        break;
                    case "audiostart":
                        this.onaudiostart && this.onaudiostart();
                        break;
                    case "audioend":
                        this.onaudioend && this.onaudioend();
                        break;
                    case "soundstart":
                        this.onsoundstart && this.onsoundstart();
                        break;
                    case "soundend":
                        this.onsoundend && this.onsoundend();
                        break;
                    case "speechstart":
                        this.onspeechstart && this.onspeechstart();
                        break;
                    case "speechend":
                        this.onspeechend && this.onspeechend();
                        break;
                    case "error":
                        this.onerror && this.onerror(Q), this.started = !1;
                        break;
                    case "abort":
                        this.onabort && this.onabort(), this.started = !1;
                        break;
                    case "result":
                        this.onresult && this.onresult(Q.results);
                        break;
                    case "passiveresult":
                        this.onpassiveresult && this.onpassiveresult(Q.results);
                        break;
                    case "wakeup":
                        this.onwakeup && this.onwakeup();
                        break;
                }
            }, this._autoStart = !!(S != null && S.autoStart), this._passive = !!(S != null && S.passive), this._wakeWords = (S == null ? void 0 : S.wakeWords) || [], this._continuous = !!(S != null && S.continuous), this._interimResults = (S == null ? void 0 : S.interimResults) !== !1, this._lang = S != null && S.lang ? S.lang : typeof window < "u" ? window.document.documentElement.getAttribute("lang") || window.navigator.language : "en-US", S != null && S.grammarsList && (this._grammars.phrases = S.grammarsList), this._debug = !!(S != null && S.debug) || !1;
            const { audioConfig: y = null, enableTelemetry: m = !0, fetchCredentials: N, looseEvents: q, referenceGrammars: G, speechRecognitionEndpointId: te, textNormalization: ge = "display" } = I(f);
            if (this.enableTelemetry = m, this.looseEvents = !!q, this.referenceGrammars = G, this.textNormalization = ge, !y && (!window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia)) console.warn("web-speech-cognitive-services: This browser does not support WebRTC and it will not work with Cognitive Services Speech Services.");
            else try {
                this.audioConfig = y || e.AudioConfig.fromDefaultMicrophoneInput(), this.initRecognizer(N, te, S == null ? void 0 : S.timerBeforeSpeechEnd);
            } catch (b) {
                console.warn(b);
            }
        }
        get passive() {
            return this._passive;
        }
        set passive(f) {
            this._passive = f;
        }
        get wakeWords() {
            return this._wakeWords;
        }
        set wakeWords(f) {
            this._wakeWords = f;
        }
        get continuous() {
            return this._continuous;
        }
        set continuous(f) {
            this._continuous = f;
        }
        get grammars() {
            return this._grammars;
        }
        set grammars(f) {
            if (f instanceof A) this._grammars = f;
            else throw new Error("The provided value is not of type 'SpeechGrammarList'");
        }
        get interimResults() {
            return this._interimResults;
        }
        set interimResults(f) {
            this._interimResults = f;
        }
        get maxAlternatives() {
            return this._maxAlternatives;
        }
        set maxAlternatives(f) {
            this._maxAlternatives = f;
        }
        get lang() {
            return this._lang;
        }
        set lang(f) {
            this._lang = f;
        }
        async _startOnce() {
            var f;
            if (this.audioConfig && !this.started) {
                const { pause: S, unprepare: y } = _(this.audioConfig), m = d();
                let N = !1, q = !1, G = "";
                const { detach: te } = this.audioConfig.events.attach((ge)=>{
                    const { name: b } = ge;
                    b === "AudioSourceReadyEvent" ? m.push({
                        audioSourceReady: {}
                    }) : b === "AudioSourceOffEvent" ? m.push({
                        audioSourceOff: {}
                    }) : b === "FirstAudibleChunk" && m.push({
                        firstAudibleChunk: {}
                    });
                });
                if (await this.createRecognizer(), this.recognizer) try {
                    this.recognizer.canceled = (be, { errorDetails: K, offset: we, reason: Me, sessionId: zt })=>{
                        m.push({
                            canceled: {
                                errorDetails: K,
                                offset: we,
                                reason: Me,
                                sessionId: zt
                            }
                        });
                    }, this.recognizer.recognized = (be, { offset: K, result: we, sessionId: Me })=>{
                        m.push({
                            recognized: {
                                offset: K,
                                result: D(we),
                                sessionId: Me
                            }
                        });
                    }, this.recognizer.recognizing = (be, { offset: K, result: we, sessionId: Me })=>{
                        m.push({
                            recognizing: {
                                offset: K,
                                result: D(we),
                                sessionId: Me
                            }
                        });
                    }, this.recognizer.sessionStarted = (be, { sessionId: K })=>{
                        m.push({
                            sessionStarted: {
                                sessionId: K
                            }
                        });
                    }, this.recognizer.sessionStopped = (be, { sessionId: K })=>{
                        m.push({
                            sessionStopped: {
                                sessionId: K
                            }
                        });
                    }, this.recognizer.speechStartDetected = (be, { offset: K, sessionId: we })=>{
                        m.push({
                            speechStartDetected: {
                                offset: K,
                                sessionId: we
                            }
                        });
                    }, this.recognizer.speechEndDetected = (be, { sessionId: K })=>{
                        m.push({
                            speechEndDetected: {
                                sessionId: K
                            }
                        });
                    }, await C(this.recognizer.startContinuousRecognitionAsync.bind(this.recognizer))(), this.abort = ()=>m.push({
                            abort: {}
                        }), this.stop = ()=>m.push({
                            stop: {}
                        });
                    let ge = !1, b = null, Q = [];
                    for(let be = 0; !G || ge; be++){
                        const K = await m.shift(), { abort: we, audioSourceOff: Me, audioSourceReady: zt, canceled: Di, firstAudibleChunk: Bu, recognized: ii, recognizing: _n, stop: Uu } = K, Ln = Di && Di.errorDetails;
                        if (/Permission\sdenied/u.test(Ln || "")) {
                            b = {
                                data: "not-allowed",
                                type: "error"
                            };
                            break;
                        }
                        if (be || this.processSendEvent("start"), Ln) {
                            /1006/u.test(Ln) ? (ge || (this.processSendEvent("audiostart"), this.processSendEvent("audioend")), b = {
                                data: "network",
                                type: "error"
                            }) : b = {
                                data: "unknown",
                                type: "error"
                            };
                            break;
                        } else if (we || Uu) we ? (b = {
                            type: "abort"
                        }, G = "abort") : (S(), G = "stop"), we && this.recognizer.stopContinuousRecognitionAsync && await C(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                        else if (zt) this.processSendEvent("audiostart"), ge = !0;
                        else if (Bu) this.processSendEvent("soundstart"), N = !0;
                        else if (Me) {
                            q && this.processSendEvent("speechend"), N && this.processSendEvent("soundend"), ge && this.processSendEvent("audioend"), ge = N = q = !1;
                            break;
                        } else if (G !== "abort") {
                            if (ii && ii.result && ii.result.reason === e.ResultReason.NoMatch) b = {
                                data: "no-speech",
                                type: "error"
                            };
                            else if (ii || _n) {
                                if (ge || (this.processSendEvent("audiostart"), ge = !0), N || (this.processSendEvent("soundstart"), N = !0), q || (this.processSendEvent("speechstart"), q = !0), ii) {
                                    const Je = a(ii.result, {
                                        maxAlternatives: this.maxAlternatives,
                                        textNormalization: this.textNormalization
                                    }), Oi = !!Je[0].transcript;
                                    Oi && (Q = [
                                        ...Q,
                                        ...Je
                                    ], this._interimResults && (this.processSendEvent("result", {
                                        results: Q
                                    }), this._passive && this.processSendEvent("passiveresult", {
                                        results: Je
                                    }))), this._continuous && Oi ? b = null : this._interimResults && (b = {
                                        data: {
                                            results: Q
                                        },
                                        type: "result"
                                    }), !this._continuous && this.recognizer.stopContinuousRecognitionAsync && await C(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))(), this.looseEvents && b && Oi && (this.processSendEvent(b.type, b.data), b = null);
                                } else if (_n) {
                                    const Je = a(_n.result, {
                                        maxAlternatives: this.maxAlternatives,
                                        textNormalization: this.textNormalization
                                    });
                                    if (this._passive && this._wakeWords && this._wakeWords.length > 0) {
                                        if (Je && Array.isArray(Je) && Je.length > 0 && Je[0].transcript) {
                                            const { transcript: Oi } = {
                                                ...Je[0]
                                            };
                                            this._wakeWords.forEach((qu)=>{
                                                Oi.toLowerCase().includes(qu.toLowerCase()) && this.processSendEvent("wakeup");
                                            });
                                        }
                                        this._interimResults && this.processSendEvent("passiveresult", {
                                            results: Je
                                        });
                                    }
                                    this._interimResults && this.processSendEvent("result", {
                                        results: [
                                            ...Q,
                                            ...Je
                                        ]
                                    });
                                }
                            }
                        }
                    }
                    q && this.processSendEvent("speechend"), N && this.processSendEvent("soundend"), ge && this.processSendEvent("audioend"), b && (b.type === "result" && (typeof b.data == "string" || !((f = b.data) != null && f.results) || !b.data.results.length) && (b = {
                        data: "no-speech",
                        type: "error"
                    }), this.processSendEvent(b.type, b.data)), this.processSendEvent("end"), te && te();
                } catch (ge) {
                    throw console.error(ge), ge;
                } finally{
                    y(), this.recognizer.close();
                }
            }
        }
    }
    const ke = (P, f)=>({
            speechRecognition: new L(P, f),
            SpeechGrammarList: A
        });
    class vt extends EventTarget {
        constructor(f){
            super(), this._lang = void 0, this._pitch = 1, this._rate = 1, this._voice = void 0, this._volume = 1, this.text = f;
        }
        get lang() {
            return this._lang;
        }
        set lang(f) {
            this._lang = f;
        }
        get pitch() {
            return this._pitch;
        }
        set pitch(f) {
            this._pitch = f;
        }
        get rate() {
            return this._rate;
        }
        set rate(f) {
            this._rate = f;
        }
        get voice() {
            return this._voice;
        }
        set voice(f) {
            this._voice = f;
        }
        get volume() {
            return this._volume;
        }
        set volume(f) {
            this._volume = f;
        }
        onstart() {}
        onend() {}
        onerror(f) {
            console.log(f);
        }
        onsynthesisstart() {}
        onsynthesiscompleted() {}
        onboundary(f) {
            console.log(f);
        }
        onviseme(f) {
            console.log(f);
        }
        onmark(f) {
            console.log(f);
        }
    }
    var V = vt;
    class ie {
        constructor({ gender: f, lang: S, voiceURI: y }){
            this._default = !1, this._localService = !1, this._gender = f, this._lang = S, this._name = y, this._voiceURI = y;
        }
        get default() {
            return this._default;
        }
        get gender() {
            return this._gender;
        }
        get lang() {
            return this._lang;
        }
        get localService() {
            return this._localService;
        }
        get name() {
            return this._name;
        }
        get voiceURI() {
            return this._voiceURI;
        }
    }
    class ft {
        constructor(f){
            this.speaking = !1, this.speakerAudioDestination = new e.SpeakerAudioDestination(), this.audioConfig = void 0, this.speechConfig = null, this.queue = [], this.canceled = !1, this.synth = null, this.synthesizing = !1, this.getVoices = ()=>[], this.onvoiceschanged = ()=>{
                console.log("Voices changed");
            };
            const { audioContext: S, fetchCredentials: y, ponyfill: m = {
                // @ts-ignore
                AudioContext: window.AudioContext || window.webkitAudioContext
            }, speechSynthesisDeploymentId: N } = I(f);
            !S && !m.AudioContext ? console.warn("web-speech-cognitive-services: This browser does not support Web Audio and it will not work with Cognitive Services Speech Services.") : (this.audioConfig = e.AudioConfig.fromSpeakerOutput(this.speakerAudioDestination), this.initSpeechSynthesizer(y, N));
        }
        mute() {
            this.speakerAudioDestination && this.speakerAudioDestination.mute();
        }
        unmute() {
            this.speakerAudioDestination && this.speakerAudioDestination.unmute();
        }
        getVolume() {
            return this.speakerAudioDestination ? this.speakerAudioDestination.volume : -1;
        }
        setVolume(f) {
            this.speakerAudioDestination && (this.speakerAudioDestination.volume = f);
        }
        // Asynchronous function that initializes the speech synthesizer class
        async initSpeechSynthesizer(f, S) {
            const { speechSynthesisHostname: y, subscriptionKey: m, authorizationToken: N, region: q } = await f();
            if (!N && !m) throw new Error("no subscription data : authorizationToken or subscriptionKey needed");
            if (S) {
                const G = y || `${q}.customvoice.api.speech.microsoft.com`, te = `https://${encodeURI(G)}/api/texttospeech/v2.0/endpoints/${encodeURIComponent(S)}`;
                this.speechConfig = e.SpeechConfig.fromEndpoint(new URL(te), m);
            } else y ? this.speechConfig = e.SpeechConfig.fromHost(y, m) : this.speechConfig = N ? e.SpeechConfig.fromAuthorizationToken(N, q) : e.SpeechConfig.fromSubscription(m, q);
            this.synth = new e.SpeechSynthesizer(this.speechConfig, this.audioConfig), this.updateVoices();
        }
        // Function to recreate the synthesizer
        createSynthesizer(f, S) {
            if (S ? this.audioConfig = e.AudioConfig.fromStreamOutput(S) : (this.speakerAudioDestination = new e.SpeakerAudioDestination(), this.audioConfig = e.AudioConfig.fromSpeakerOutput(this.speakerAudioDestination)), this.speechConfig) {
                if (f) {
                    const y = this.speechConfig;
                    y.speechSynthesisVoiceName = f, this.synth = new e.SpeechSynthesizer(y, this.audioConfig);
                } else this.synth = new e.SpeechSynthesizer(this.speechConfig, this.audioConfig);
            }
        }
        // Cancel current synthesis
        cancel() {
            if (this.synthesizing) try {
                this.synth && !this.synth.privDisposed && this.synth.close(), this.queue = [];
            } catch (f) {
                console.warn(f);
            }
            else if (this.speaking) try {
                this.speakerAudioDestination.pause(), this.speakerAudioDestination.onAudioEnd(this.speakerAudioDestination), this.speakerAudioDestination.close();
            } catch (f) {
                console.warn(f);
            }
            this.queue = [], this.canceled = !0;
        }
        // Pause current synthesis
        pause() {
            this.speakerAudioDestination && this.speakerAudioDestination.pause();
        }
        // Resume current synthesis
        resume() {
            this.speakerAudioDestination && !this.canceled && this.speakerAudioDestination.resume();
        }
        /**
    * Add events listeners to the events received by the synthesizer if callbakcs are given in the utterance
    * @param {SpeechSynthesisUtterance} utterance
    */ linkEventsCallbacks(f) {
            this.synth && (this.synth.synthesisStarted = ()=>{
                f.onsynthesisstart && f.onsynthesisstart(), this.synthesizing = !0;
            }, this.synth.synthesisCompleted = ()=>{
                f.onsynthesiscompleted && f.onsynthesiscompleted(), this.synthesizing = !1;
            }, this.synth.wordBoundary = (S, y)=>{
                !S && console.warn("No synthesizer");
                const m = {
                    boundaryType: y.boundaryType,
                    name: y.text,
                    elapsedTime: y.audioOffset,
                    duration: y.duration
                };
                f.onboundary && f.onboundary(m);
            }, this.synth.visemeReceived = (S, y)=>{
                !S && console.warn("No synthesizer");
                const m = {
                    boundaryType: "Viseme",
                    name: `${y.visemeId}`,
                    elapsedTime: y.audioOffset,
                    duration: 0
                };
                f.onboundary && f.onboundary(m), f.onviseme && f.onviseme(m);
            }, this.synth.bookmarkReached = (S, y)=>{
                !S && console.warn("No synthesizer");
                const m = {
                    boundaryType: "Mark",
                    name: y.text,
                    elapsedTime: y.audioOffset,
                    duration: 0
                };
                f.onmark && f.onmark(m);
            });
        }
        /**
    * Launch synthesis and play sound with the speech synthesizer
    * @param {SpeechSynthesisUtterance} utterance 
    */ speak(f, S) {
            if (!(f instanceof V)) throw new Error("invalid utterance");
            this.queue.push(f);
            const y = ()=>{
                if (this.queue.length && !this.speaking) {
                    const m = this.queue.shift();
                    if (m) {
                        const N = /<speak[\s\S]*?>/iu.test(m.text);
                        return m.voice && (m.voice.voiceURI || m.voice._name) ? this.createSynthesizer(m.voice.voiceURI || m.voice._name, S) : this.createSynthesizer(void 0, S), m.volume && (this.speakerAudioDestination.volume = m.volume), this.speakerAudioDestination.onAudioStart = ()=>{
                            this.speaking = !0, m.onstart && m.onstart();
                        }, this.speakerAudioDestination.onAudioEnd = ()=>{
                            this.speaking = !1, m.onend && m.onend(), y();
                        }, this.linkEventsCallbacks(m), N ? new Promise((q)=>{
                            this.synth && this.synth.speakSsmlAsync(m.text, (G)=>{
                                G ? this.synth && this.synth.close() : q(new Error("No synthesis result."));
                            }, (G)=>{
                                q(new Error(`Synthesis failed : ${G}`));
                            });
                        }) : new Promise((q)=>{
                            this.synth && this.synth.speakTextAsync(m.text, (G)=>{
                                G ? this.synth && this.synth.close() : q(new Error("No synthesis result."));
                            }, (G)=>{
                                q(new Error(`Synthesis failed : ${G}`));
                            });
                        });
                    }
                }
            };
            y(), this.canceled = !1;
        }
        /**
    * Launch synthesis without sound being played and call callback function with an ArrayBuffer after synthesis finished, containing the sound data
    * @param {SpeechSynthesisUtterance} utterance 
    * @param {Function} callback 
    */ synthesizeAndGetArrayData(f, S) {
            if (!(f instanceof V)) throw new Error("invalid utterance");
            const y = /<speak[\s\S]*?>/iu.test(f.text);
            if (this.speechConfig) {
                if (f.voice && (f.voice.voiceURI || f.voice._name)) {
                    const m = this.speechConfig;
                    m.speechSynthesisVoiceName = f.voice.voiceURI || f.voice._name, this.synth = new e.SpeechSynthesizer(m, null);
                } else this.synth = new e.SpeechSynthesizer(this.speechConfig, null);
            }
            this.linkEventsCallbacks(f);
            try {
                y ? this.synth && this.synth.speakSsmlAsync(f.text, (m)=>{
                    m && m.audioData ? (S(m.audioData), this.synth && this.synth.close()) : S(null);
                }, (m)=>{
                    console.error(m), S(null);
                }) : this.synth && this.synth.speakTextAsync(f.text, (m)=>{
                    m && m.audioData ? (S(m.audioData), this.synth && this.synth.close()) : S(null);
                }, (m)=>{
                    console.error(m), S(null);
                });
            } catch (m) {
                console.error(m);
            }
        }
        // Asynchronous function that updates available voices
        async updateVoices() {
            const f = this.synth ? await this.synth.getVoicesAsync() : null, S = f == null ? void 0 : f.voices;
            if (Array.isArray(S)) {
                const y = S.map((m)=>new ie({
                        // eslint-disable-next-line no-magic-numbers
                        gender: m.gender === 1 ? "Female" : m.gender === 2 ? "Male" : "Undefined",
                        lang: m.locale,
                        voiceURI: m.name
                    }));
                this.getVoices = ()=>y;
            } else console.warn("Failed to retrieve voices. 'voices' is not an array.");
            this.onvoiceschanged();
        }
    }
    const Ut = (P)=>({
            speechSynthesis: new ft(P),
            SpeechSynthesisUtterance: V
        }), je = "https://{region}.api.cognitive.microsoft.com/sts/v1.0/issueToken";
    async function ti({ region: P, subscriptionKey: f }) {
        if (!P || !f) throw new Error("Region AND subscription must be provided");
        {
            const S = await fetch(je.replace(/\{region\}/u, P), {
                headers: {
                    "Ocp-Apim-Subscription-Key": f
                },
                method: "POST"
            });
            if (!S.ok) throw new Error(`Failed to fetch authorization token, server returned ${S.status}`);
            return S.text();
        }
    }
    function xn(P, f) {
        return {
            ...ke(P, f),
            ...Ut(P)
        };
    }
})($d7238066c5de7f1c$var$Ap);
var $d7238066c5de7f1c$var$Tp = $d7238066c5de7f1c$var$Ap.exports;
const $d7238066c5de7f1c$var$BI = ()=>{
    const r = $d7238066c5de7f1c$export$c7fe76dc325a276e((C)=>C.animationsLoaded), e = $d7238066c5de7f1c$export$c7fe76dc325a276e((C)=>C.characterState), t = $d7238066c5de7f1c$export$c7fe76dc325a276e((C)=>C.lipSyncManager), i = $d7238066c5de7f1c$export$c7fe76dc325a276e((C)=>C.blendshapeManager), n = $d7238066c5de7f1c$var$Z((C)=>C.credentials), s = $d7238066c5de7f1c$var$Z((C)=>C.currentUtterance), o = $d7238066c5de7f1c$var$Z((C)=>C.textToSpeak), c = $d7238066c5de7f1c$var$Z((C)=>C.visemes), p = $d7238066c5de7f1c$var$Z((C)=>C.blendshapes), h = $d7238066c5de7f1c$var$Z((C)=>C.visemeIntensity), a = $d7238066c5de7f1c$var$Z((C)=>C.currentVisemeIndex), d = $d7238066c5de7f1c$var$Z((C)=>C.currentBlendshapeIndex), v = $d7238066c5de7f1c$var$Z((C)=>C.useBlendshapeManager), [g, I] = (0, $bxRTa.useState)(!1), [A, D] = (0, $bxRTa.useState)(!1), z = (0, $bxRTa.useMemo)(()=>n != null && n.region && (n.subscriptionKey || n.token) ? $d7238066c5de7f1c$var$Tp.createSpeechSynthesisPonyfill({
            credentials: {
                region: n.region,
                authorizationToken: n.token,
                subscriptionKey: n.subscriptionKey
            }
        }) : null, [
        n
    ]);
    return (0, $bxRTa.useEffect)(()=>{
        if (z) {
            const C = z.speechSynthesis.getVoices();
            C && Array.isArray(C) && C.length ? ($d7238066c5de7f1c$var$La(C), I(!0)) : z.speechSynthesis.onvoiceschanged = ()=>{
                $d7238066c5de7f1c$var$La(z.speechSynthesis.getVoices()), I(!0);
            };
        }
    }, [
        z
    ]), (0, $bxRTa.useEffect)(()=>{
        g && (v ? !!i : !!t) && r && D(!0);
    }, [
        g,
        t,
        i,
        r,
        v
    ]), (0, $bxRTa.useEffect)(()=>{
        if (o) {
            const C = new $d7238066c5de7f1c$var$Tp.SpeechSynthesisUtterance(o);
            $d7238066c5de7f1c$export$361f43c8d19dc717(C);
        }
    }, [
        o
    ]), (0, $bxRTa.useEffect)(()=>{
        var C, _;
        s && A ? (s.onstart = ()=>{
            console.log("Start"), $d7238066c5de7f1c$export$83a16ee147243363((0, $jKwRh.CharacterState).speaking);
        }, s.onend = ()=>{
            console.log("End"), $d7238066c5de7f1c$export$83a16ee147243363((0, $jKwRh.CharacterState).idle);
        }, s.onboundary = ()=>{}, s.onviseme = (L)=>{
            $d7238066c5de7f1c$export$a6f0d0f24e5dc19b(L);
        }, (C = z == null ? void 0 : z.speechSynthesis) == null || C.speak(s, null)) : (_ = z == null ? void 0 : z.speechSynthesis) == null || _.cancel();
    }, [
        s
    ]), (0, $bxRTa.useEffect)(()=>{
        t && (t.visemeIntensity = h);
    }, [
        h
    ]), (0, $bxRTa.useEffect)(()=>{
        if (!v && t && e === (0, $jKwRh.CharacterState).speaking) {
            if (!t.isStarted && t.start(), c.length > 1 && a === 0) c.forEach((C)=>{
                const _ = parseInt(C.name);
                if (!isNaN(_)) {
                    const L = $d7238066c5de7f1c$var$_a.get(_);
                    L && t.PlayVisemeAsync(L, C.elapsedTime / 1e4);
                }
            });
            else for(let C = a + 1; C < c.length; C++){
                const _ = c[C], L = parseInt(_.name);
                if (!isNaN(L)) {
                    const ke = $d7238066c5de7f1c$var$_a.get(L);
                    ke && t.PlayVisemeAsync(ke, _.elapsedTime / 1e4);
                }
            }
            $d7238066c5de7f1c$var$Dd(c.length - 1);
        }
    }, [
        e,
        c,
        t,
        v
    ]), (0, $bxRTa.useEffect)(()=>{
        if (v && i && e === (0, $jKwRh.CharacterState).speaking) {
            if (!i.isStarted && i.start(), p.length > 1 && d === 0) p.forEach((C)=>{
                i.PlayBlendShapeAsync(C);
            });
            else for(let C = d + 1; C < p.length; C++){
                const _ = p[C];
                i.PlayBlendShapeAsync(_);
            }
            $d7238066c5de7f1c$var$Od(p.length - 1);
        }
    }, [
        e,
        p,
        i,
        v
    ]), (0, $bxRTa.useEffect)(()=>{
        e !== (0, $jKwRh.CharacterState).speaking && ($d7238066c5de7f1c$export$1a9c534915c6839e(), $d7238066c5de7f1c$export$9d82da69aac8f6ca());
    }, [
        e
    ]), null;
}, $d7238066c5de7f1c$var$UI = ({ points: r, color: e = "red" })=>{
    const t = (0, $bxRTa.useMemo)(()=>{
        const i = new $329ek.BufferGeometry().setFromPoints(r), n = new $329ek.LineBasicMaterial({
            color: e,
            toneMapped: !1
        });
        return new $329ek.Line(i, n);
    }, [
        r,
        e
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("primitive", {
        object: t
    });
}, $d7238066c5de7f1c$var$qI = ({ parentGpuTier: r, setIsGpuAvailable: e, children: t, tonemapping: i })=>{
    const n = $d7238066c5de7f1c$var$Te((V)=>V.cameraPosition), s = $d7238066c5de7f1c$var$Te((V)=>V.lookAt), o = $d7238066c5de7f1c$var$Te((V)=>V.movable), c = $d7238066c5de7f1c$var$ze((V)=>V.targets), p = $d7238066c5de7f1c$var$ze((V)=>V.showFirstTarget), [h] = (0, $bxRTa.useState)(r || (0, $8f92r.useDetectGPU)()), [a, d] = (0, $bxRTa.useState)(), [v, g] = (0, $bxRTa.useState)(null), [I, A] = (0, $bxRTa.useState)(void 0), D = (0, $bxRTa.useRef)(), z = (0, $bxRTa.useRef)(), C = (0, $bxRTa.useRef)(), _ = (V)=>{
        V.preventDefault(), V.stopPropagation();
    };
    (0, $bxRTa.useEffect)(()=>{
        $d7238066c5de7f1c$var$cd(z.current);
    }, [
        z.current
    ]), (0, $bxRTa.useEffect)(()=>{
        var V, ie, ft, Ut;
        if (o) v == null || v.abort(), g(null);
        else {
            const je = new AbortController();
            g(je), (V = D.current) == null || V.addEventListener("wheel", _, {
                passive: !1,
                signal: je.signal
            }), (ie = D.current) == null || ie.addEventListener("pointerdown", _, {
                passive: !1,
                signal: je.signal
            }), (ft = D.current) == null || ft.addEventListener("pointermove", _, {
                passive: !1,
                signal: je.signal
            }), (Ut = D.current) == null || Ut.addEventListener("click", _, {
                passive: !1,
                signal: je.signal
            });
        }
    }, [
        o
    ]), (0, $bxRTa.useEffect)(()=>{
        C != null && C.current && s && n && C.current.setLookAt(n.x, n.y, n.z, s.x, s.y, s.z, !0);
    }, [
        n,
        s
    ]), (0, $bxRTa.useEffect)(()=>{
        if (h) {
            if (h.type === "FALLBACK") d("medium");
            else switch(h.tier){
                case 0:
                case 1:
                    d("low");
                    break;
                case 2:
                    d("medium");
                    break;
                case 3:
                    d("high");
                    break;
                default:
                    d("low");
                    break;
            }
        }
    }, [
        h
    ]), (0, $bxRTa.useEffect)(()=>{
        switch(a){
            case "low":
                console.warn("Retorik React-Bodyengine-Three > GPU tier too low, no rendering available"), e(!1);
                break;
            case "medium":
                A([
                    0.8,
                    1
                ]), console.log(`Retorik React-Bodyengine-Three > GPU tier detected : ${a}`), e(!0);
                break;
            case "high":
                A([
                    1,
                    2
                ]), console.log(`Retorik React-Bodyengine-Three > GPU tier detected : ${a}`), e(!0);
                break;
        }
    }, [
        a
    ]);
    const [L] = (0, $bxRTa.useState)(new $329ek.Scene()), ke = (0, $bxRTa.useMemo)(()=>{
        if (L && a !== "low" && z.current && D.current) {
            const V = {
                antialias: a !== "medium",
                powerPreference: "high-performance",
                forceWebGL: !1,
                colorBufferType: a === "medium" ? $329ek.UnsignedByteType : $329ek.HalfFloatType
            }, ie = new (0, $iB18M.WebGPURenderer)(V);
            return ie.setClearColor(new $329ek.Color("#000000"), 0), ie.setPixelRatio(devicePixelRatio), ie.shadowMap.type = $329ek.PCFSoftShadowMap, ie.setAnimationLoop(()=>{
                ie.render(L, z.current);
            }), ie;
        }
    }, [
        L,
        a,
        z.current,
        D.current
    ]), vt = (0, $bxRTa.useMemo)(()=>{
        if (c.length) {
            const V = c[0], ie = new $329ek.Vector3(V.position.x - 0.5, V.position.y, V.position.z - 0.1), ft = new $329ek.Vector3(V.position.x + 0.5, V.position.y, V.position.z - 0.1);
            return [
                ie,
                ft
            ];
        } else if (n) {
            const V = new $329ek.Vector3(n.x - 0.5, n.y, n.z - 0.1), ie = new $329ek.Vector3(n.x + 0.5, n.y, n.z - 0.1);
            return [
                V,
                ie
            ];
        }
        return [];
    }, [
        c,
        n
    ]);
    return I ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $3gAAP.Canvas), {
        gl: ke,
        dpr: I,
        ref: D,
        shadows: !0,
        scene: L
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$WI, {
        renderer: ke,
        tonemapping: i,
        processedTier: a,
        scene: L
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $dhXas.AdaptiveDpr), null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$BI, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $7Ur5h.PerspectiveCamera), {
        ref: z,
        makeDefault: !0,
        fov: 28
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $c4Vvr.CameraControls), {
        ref: C
    }), p && vt.length && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$UI, {
        points: vt,
        color: "red"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $bxRTa.Suspense), {
        fallback: null
    }, t)) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null);
}, $d7238066c5de7f1c$var$WI = ({ renderer: r, tonemapping: e, processedTier: t, scene: i })=>{
    const { gl: n } = (0, $9sE5i.D)(), [s] = (0, $bxRTa.useState)(new $329ek.Vector3(-3, 2, 2)), [o] = (0, $bxRTa.useState)(new $329ek.Vector3(0, 1, 0)), [c] = (0, $bxRTa.useState)(2), [p] = (0, $bxRTa.useState)(-0.001), [h] = (0, $bxRTa.useState)(0.6), a = (0, $bxRTa.useRef)();
    return (0, $bxRTa.useEffect)(()=>{
        !n || !r || (n.shadowMap.type = $329ek.PCFSoftShadowMap, n.toneMapping = e, t !== "low" ? i.environmentIntensity = h : i.environmentIntensity = 1);
    }, [
        n,
        r,
        e
    ]), (0, $bxRTa.useEffect)(()=>{
        i.environmentIntensity = h;
    }, [
        h
    ]), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null, t !== "low" && n && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("directionalLight", {
        ref: a,
        color: "white",
        position: s.toArray(),
        "target-position": o.toArray(),
        intensity: c,
        castShadow: !0,
        "shadow-mapSize-width": 1024,
        "shadow-mapSize-height": 1024,
        "shadow-bias": p
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("orthographicCamera", {
        attach: "shadow-camera",
        args: [
            -1,
            1,
            2,
            -0.5,
            2,
            8
        ]
    }))));
}, $d7238066c5de7f1c$var$HI = ({ character: r, autoLookAt: e })=>{
    const t = $d7238066c5de7f1c$export$c7fe76dc325a276e((h)=>h.characterState), i = $d7238066c5de7f1c$var$ze((h)=>h.currentAUs), n = $d7238066c5de7f1c$var$ze((h)=>h.currentGaze), s = $d7238066c5de7f1c$var$ze((h)=>h.currentHeadPose), o = $d7238066c5de7f1c$var$ze((h)=>h.lookAtCamera), c = $d7238066c5de7f1c$var$Te((h)=>h.cameraPosition), p = $d7238066c5de7f1c$var$ze((h)=>h.targets);
    return (0, $9sE5i.F)((h, a)=>{
        const d = {
            deltaTime: a,
            timestamp: h.clock.oldTime,
            AU: i,
            gaze: n,
            headPose: s,
            characterState: t,
            lookAt: o ? c : void 0,
            targets: p
        };
        r.update(d);
    }), (0, $bxRTa.useEffect)(()=>{
        if (e) switch(t){
            case (0, $jKwRh.CharacterState).idle:
            case (0, $jKwRh.CharacterState).waiting:
                $d7238066c5de7f1c$export$c4b950f052e6bb5c(!1);
                break;
            case (0, $jKwRh.CharacterState).listening:
            case (0, $jKwRh.CharacterState).speaking:
                $d7238066c5de7f1c$export$c4b950f052e6bb5c(!0);
                break;
        }
        else $d7238066c5de7f1c$export$c4b950f052e6bb5c(!1);
    }, [
        t,
        e
    ]), (0, $bxRTa.useEffect)(()=>{
        $d7238066c5de7f1c$var$od(r);
    }, [
        r
    ]), null;
}, $d7238066c5de7f1c$export$cb68cc2163cd3f1 = ({ url: r, type: e, animationsUrl: t, gender: i, speechSynthesis: n, camera: s, onLoadingCompleted: o, autoLookAt: c, breathing: p, disableAnimations: h, debug: a, enableBml: d, animationWeights: v, license: g, detectGpuData: I, environmentPreset: A = "apartment", tonemapping: D = $329ek.NeutralToneMapping, targets: z, useBlendshapeManager: C = !1 })=>{
    const _ = $d7238066c5de7f1c$export$c7fe76dc325a276e((y)=>y.animationsLoaded), L = $d7238066c5de7f1c$var$Te((y)=>y.defaultPositions), ke = $d7238066c5de7f1c$var$Te((y)=>y.defaultDistances), [vt, V] = (0, $bxRTa.useState)(), [ie, ft] = (0, $bxRTa.useState)(null), [Ut, je] = (0, $bxRTa.useState)(), [ti, xn] = (0, $bxRTa.useState)(!1), P = async (y)=>{
        let m = null;
        switch(e){
            case (0, $jKwRh.CreationTool).cc3:
                m = new (0, $jKwRh.CC3Loader)(), je($d7238066c5de7f1c$var$qr.cc3);
                break;
            case (0, $jKwRh.CreationTool).avatarsdk:
                m = new (0, $jKwRh.AvatarSDKLoader)(), je($d7238066c5de7f1c$var$qr.avatarsdk);
                break;
            case (0, $jKwRh.CreationTool).avaturn:
                m = new (0, $jKwRh.AvaturnLoader)(), je($d7238066c5de7f1c$var$qr.avaturn);
                break;
        }
        const N = await m.loadAsync(y).catch((q)=>console.warn("Error loading character : ", q));
        if (N) {
            let q = null;
            const G = {
                mesh: N,
                onAnimationsLoaded: f,
                animationsUrl: t,
                gender: i || "male",
                type: e,
                debug: a,
                enableBmlManager: !!d,
                animationWeights: v,
                useBlendshapeManager: C,
                license: g
            };
            switch(e){
                case (0, $jKwRh.CreationTool).cc3:
                    q = await (0, $jKwRh.Character).fromCharacterCreator(G);
                    break;
                case (0, $jKwRh.CreationTool).avatarsdk:
                    q = await (0, $jKwRh.Character).fromAvatarSDK(G);
                    break;
                case (0, $jKwRh.CreationTool).avaturn:
                    q = await (0, $jKwRh.Character).fromAvaturn(G);
                    break;
            }
            q && ft(q);
        }
    }, f = ()=>{
        $d7238066c5de7f1c$var$za(!0);
    };
    (0, $bxRTa.useEffect)(()=>{
        var y, m;
        ie && _ && (p === !1 && ((m = (y = ie.animationManager) == null ? void 0 : y.disableBreathing) == null || m.call(y)), ti ? ($d7238066c5de7f1c$var$gd(ie.getAllAnimationNames()), $d7238066c5de7f1c$var$md(ie.getAllAnimations()), setTimeout(()=>{
            o == null || o();
        }, 1e3)) : S());
    }, [
        ie,
        _,
        ti
    ]), (0, $bxRTa.useEffect)(()=>{
        $d7238066c5de7f1c$var$ld(z || []);
    }, [
        z
    ]), (0, $bxRTa.useEffect)(()=>{
        $d7238066c5de7f1c$var$za(!1), vt !== void 0 && (vt ? P(r) : o == null || o());
    }, [
        r,
        vt
    ]), (0, $bxRTa.useEffect)(()=>{
        if (ti && ke && L) {
            if (s) {
                const y = $d7238066c5de7f1c$var$Md(s, ke, L);
                $d7238066c5de7f1c$export$e5bf5ad244df1ebf(y), $d7238066c5de7f1c$var$xa(s.lookAt ? L[s.lookAt] : L.lowerbelly), $d7238066c5de7f1c$export$545c1d117b311d16(!!s.movable);
            } else {
                const y = L.mouth.clone();
                y.setComponent(2, ke.farther), $d7238066c5de7f1c$export$e5bf5ad244df1ebf(y), $d7238066c5de7f1c$var$xa(L.lowerbelly);
            }
        }
    }, [
        ti,
        s,
        ke,
        L
    ]), (0, $bxRTa.useEffect)(()=>{
        n && (n.credentials && $d7238066c5de7f1c$var$Ad(n.credentials), n.voice && $d7238066c5de7f1c$export$f7fa6f9f21f4683c(n.voice));
    }, [
        n
    ]), (0, $bxRTa.useEffect)(()=>{
        $d7238066c5de7f1c$var$Nd(C);
    }, [
        C
    ]);
    const S = ()=>{
        if (ie && Ut) {
            try {
                const y = new $329ek.Box3().setFromObject(ie), m = y.max, N = y.min, q = new $329ek.Vector3((m.x + N.x) / 2, (m.y + N.y) / 2, (m.z + N.z) / 2);
                $d7238066c5de7f1c$var$pd(q);
                const G = Math.abs(m.x - N.x), te = Math.abs(m.y - N.y), ge = Math.abs(m.z - N.z);
                $d7238066c5de7f1c$var$ad({
                    x: G,
                    y: te,
                    z: ge
                });
                const b = (m.x + N.x) / 2, Q = (m.z + N.z) / 2, be = {
                    eye: new $329ek.Vector3(b, m.y - te / 16, Q),
                    mouth: new $329ek.Vector3(b, m.y - te / 12, Q),
                    neck: new $329ek.Vector3(b, m.y - te / 8, Q),
                    clavicle: new $329ek.Vector3(b, m.y - te / 6, Q),
                    torso: new $329ek.Vector3(b, m.y - te / 4, Q),
                    belly: new $329ek.Vector3(b, m.y - te / 8 * 3, Q),
                    lowerbelly: new $329ek.Vector3(b, m.y - te / 32 * 15, Q),
                    hips: q,
                    higherthigh: new $329ek.Vector3(b, N.y + te / 32 * 15, Q),
                    thigh: new $329ek.Vector3(b, N.y + te / 8 * 3, Q),
                    knee: new $329ek.Vector3(b, N.y + te / 4, Q),
                    leg: new $329ek.Vector3(b, N.y + te / 8, Q),
                    feet: new $329ek.Vector3(b, N.y, Q)
                }, K = (m.y - (N.y + te / 7 * 2)) / 2 / Math.tan(25 * (Math.PI / 180)), we = {
                    veryclose: K / 4,
                    closer: K / 3,
                    close: K / 2.5,
                    midclose: K / 2,
                    medium: K,
                    midfar: K * 2,
                    far: K * 2.5,
                    farther: K * 3,
                    veryfar: K * 4
                };
                $d7238066c5de7f1c$var$hd(be), $d7238066c5de7f1c$var$ud(we);
            } catch (y) {
                console.warn(y);
            }
            xn(!0);
        }
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$qI, {
        parentGpuTier: I,
        setIsGpuAvailable: V,
        tonemapping: D
    }, vt ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null, ie && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$HI, {
        character: ie,
        autoLookAt: !!c
    }), ie && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $60WrR.Environment), {
        preset: A
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("primitive", {
        object: ie,
        castShadow: !0,
        receiveShadow: !0
    }))) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null));
}, $d7238066c5de7f1c$var$FI = {
    emotions: [],
    currentTopEmotion: $d7238066c5de7f1c$var$mo.Neutral,
    useTopEmotionOnly: !0,
    autoDecay: !1
}, $d7238066c5de7f1c$var$Ji = $d7238066c5de7f1c$var$Pi()(()=>$d7238066c5de7f1c$var$FI), $d7238066c5de7f1c$export$7e5dc4bfb1d9b6a2 = (r)=>{
    if ($d7238066c5de7f1c$var$Ji.setState({
        emotions: r || []
    }), r != null && r.length) {
        const e = r.reduce((t, i)=>t.value > i.value ? t : i);
        $d7238066c5de7f1c$var$Ji.setState({
            currentTopEmotion: e.emotion
        });
    } else $d7238066c5de7f1c$var$Ji.setState({
        currentTopEmotion: $d7238066c5de7f1c$var$mo.Neutral
    });
}, $d7238066c5de7f1c$export$bb16ea1cc7bbe090 = (r)=>{
    $d7238066c5de7f1c$var$Ji.setState({
        useTopEmotionOnly: r
    });
}, $d7238066c5de7f1c$export$35e7ff73377d45eb = (r)=>{
    $d7238066c5de7f1c$var$Ji.setState({
        autoDecay: r
    });
}, $d7238066c5de7f1c$export$45f49513892eb08f = (r)=>{
    const e = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().FACSManager;
    e == null || e.playFacialAnimation({
        ...r
    });
};

});
parcelRegister("329ek", function(module, exports) {

$parcel$export(module.exports, "REVISION", () => $2358b7e4ec07df88$export$3545e07a80636437);
$parcel$export(module.exports, "MOUSE", () => $2358b7e4ec07df88$export$7177b3e430c2d7ca);
$parcel$export(module.exports, "TOUCH", () => $2358b7e4ec07df88$export$d46bd3ead7cc759b);
$parcel$export(module.exports, "CullFaceNone", () => $2358b7e4ec07df88$export$3237e1f2c1ea1f44);
$parcel$export(module.exports, "CullFaceBack", () => $2358b7e4ec07df88$export$b9a7b4fc5cb15f9b);
$parcel$export(module.exports, "CullFaceFront", () => $2358b7e4ec07df88$export$b8058bcc7037d3f3);
$parcel$export(module.exports, "CullFaceFrontBack", () => $2358b7e4ec07df88$export$f24be24dcddeac0d);
$parcel$export(module.exports, "BasicShadowMap", () => $2358b7e4ec07df88$export$346307dbae2b7447);
$parcel$export(module.exports, "PCFShadowMap", () => $2358b7e4ec07df88$export$5813f879eee7cd88);
$parcel$export(module.exports, "PCFSoftShadowMap", () => $2358b7e4ec07df88$export$a47c4b43a1be34f0);
$parcel$export(module.exports, "VSMShadowMap", () => $2358b7e4ec07df88$export$896ae1ade6c829c4);
$parcel$export(module.exports, "FrontSide", () => $2358b7e4ec07df88$export$2ede184fc2998901);
$parcel$export(module.exports, "BackSide", () => $2358b7e4ec07df88$export$d9f0486e75b5ace);
$parcel$export(module.exports, "DoubleSide", () => $2358b7e4ec07df88$export$3b296b6f144d5b03);
$parcel$export(module.exports, "NoBlending", () => $2358b7e4ec07df88$export$63b8d6b580fc65ba);
$parcel$export(module.exports, "NormalBlending", () => $2358b7e4ec07df88$export$5b29a26d96ee6af0);
$parcel$export(module.exports, "AdditiveBlending", () => $2358b7e4ec07df88$export$777d8f9551c2216b);
$parcel$export(module.exports, "SubtractiveBlending", () => $2358b7e4ec07df88$export$cdfa06f868e2e467);
$parcel$export(module.exports, "MultiplyBlending", () => $2358b7e4ec07df88$export$4138e1c684b46a20);
$parcel$export(module.exports, "CustomBlending", () => $2358b7e4ec07df88$export$eda4864c68df1fa2);
$parcel$export(module.exports, "AddEquation", () => $2358b7e4ec07df88$export$20183a0484ce21a0);
$parcel$export(module.exports, "SubtractEquation", () => $2358b7e4ec07df88$export$73e0df5177988548);
$parcel$export(module.exports, "ReverseSubtractEquation", () => $2358b7e4ec07df88$export$28e582859cbec660);
$parcel$export(module.exports, "MinEquation", () => $2358b7e4ec07df88$export$c8c1508da8d0600c);
$parcel$export(module.exports, "MaxEquation", () => $2358b7e4ec07df88$export$99948c02fb51055f);
$parcel$export(module.exports, "ZeroFactor", () => $2358b7e4ec07df88$export$2110f05edf778d3d);
$parcel$export(module.exports, "OneFactor", () => $2358b7e4ec07df88$export$8805bad65e24940e);
$parcel$export(module.exports, "SrcColorFactor", () => $2358b7e4ec07df88$export$7fbe15b28d28cf52);
$parcel$export(module.exports, "OneMinusSrcColorFactor", () => $2358b7e4ec07df88$export$947829af9f2c17f6);
$parcel$export(module.exports, "SrcAlphaFactor", () => $2358b7e4ec07df88$export$d5773124e86cf28c);
$parcel$export(module.exports, "OneMinusSrcAlphaFactor", () => $2358b7e4ec07df88$export$11d468cc7f19e971);
$parcel$export(module.exports, "DstAlphaFactor", () => $2358b7e4ec07df88$export$a78aed1ca2a87192);
$parcel$export(module.exports, "OneMinusDstAlphaFactor", () => $2358b7e4ec07df88$export$5d0fe17fd8773bac);
$parcel$export(module.exports, "DstColorFactor", () => $2358b7e4ec07df88$export$ef5f2dd8ffac5574);
$parcel$export(module.exports, "OneMinusDstColorFactor", () => $2358b7e4ec07df88$export$56b85b2686ab16);
$parcel$export(module.exports, "SrcAlphaSaturateFactor", () => $2358b7e4ec07df88$export$c05e2a1fc8609506);
$parcel$export(module.exports, "ConstantColorFactor", () => $2358b7e4ec07df88$export$7dd8f434fd59075);
$parcel$export(module.exports, "OneMinusConstantColorFactor", () => $2358b7e4ec07df88$export$99c8d898a9afbcee);
$parcel$export(module.exports, "ConstantAlphaFactor", () => $2358b7e4ec07df88$export$310cd2be38d13b56);
$parcel$export(module.exports, "OneMinusConstantAlphaFactor", () => $2358b7e4ec07df88$export$db77b8fbcf45dbf4);
$parcel$export(module.exports, "NeverDepth", () => $2358b7e4ec07df88$export$69025ce147cee220);
$parcel$export(module.exports, "AlwaysDepth", () => $2358b7e4ec07df88$export$7182eb52ea3b3f04);
$parcel$export(module.exports, "LessDepth", () => $2358b7e4ec07df88$export$eedccec66ab7ebe);
$parcel$export(module.exports, "LessEqualDepth", () => $2358b7e4ec07df88$export$296f78a0b892f81a);
$parcel$export(module.exports, "EqualDepth", () => $2358b7e4ec07df88$export$a60d398fc7b7590e);
$parcel$export(module.exports, "GreaterEqualDepth", () => $2358b7e4ec07df88$export$7d7234c1240a1fc4);
$parcel$export(module.exports, "GreaterDepth", () => $2358b7e4ec07df88$export$c5e2c52991f30937);
$parcel$export(module.exports, "NotEqualDepth", () => $2358b7e4ec07df88$export$2f843afa843d8916);
$parcel$export(module.exports, "MultiplyOperation", () => $2358b7e4ec07df88$export$e50ac29801f1774d);
$parcel$export(module.exports, "MixOperation", () => $2358b7e4ec07df88$export$9f9d94f963c85479);
$parcel$export(module.exports, "AddOperation", () => $2358b7e4ec07df88$export$e641dc52bc3494aa);
$parcel$export(module.exports, "NoToneMapping", () => $2358b7e4ec07df88$export$9fcb6b4294603b2);
$parcel$export(module.exports, "LinearToneMapping", () => $2358b7e4ec07df88$export$98f52c2a46c598ca);
$parcel$export(module.exports, "ReinhardToneMapping", () => $2358b7e4ec07df88$export$74b25e54b3bcd548);
$parcel$export(module.exports, "CineonToneMapping", () => $2358b7e4ec07df88$export$932b3dd283d4a366);
$parcel$export(module.exports, "ACESFilmicToneMapping", () => $2358b7e4ec07df88$export$a0d98fe6d7e4af64);
$parcel$export(module.exports, "CustomToneMapping", () => $2358b7e4ec07df88$export$2c7b09c1e9abfb5e);
$parcel$export(module.exports, "AgXToneMapping", () => $2358b7e4ec07df88$export$212d53a513a325b2);
$parcel$export(module.exports, "NeutralToneMapping", () => $2358b7e4ec07df88$export$f2863e1668a8e317);
$parcel$export(module.exports, "AttachedBindMode", () => $2358b7e4ec07df88$export$2595a3798997538);
$parcel$export(module.exports, "DetachedBindMode", () => $2358b7e4ec07df88$export$d7e7dc2e114517a0);
$parcel$export(module.exports, "UVMapping", () => $2358b7e4ec07df88$export$1beec6768cbb3d2d);
$parcel$export(module.exports, "CubeReflectionMapping", () => $2358b7e4ec07df88$export$8759762a6477f2c4);
$parcel$export(module.exports, "CubeRefractionMapping", () => $2358b7e4ec07df88$export$dc59f8aed047f61d);
$parcel$export(module.exports, "EquirectangularReflectionMapping", () => $2358b7e4ec07df88$export$d64030b316d3b087);
$parcel$export(module.exports, "EquirectangularRefractionMapping", () => $2358b7e4ec07df88$export$ee99d97d46898098);
$parcel$export(module.exports, "CubeUVReflectionMapping", () => $2358b7e4ec07df88$export$dbf3e70ff37af79);
$parcel$export(module.exports, "RepeatWrapping", () => $2358b7e4ec07df88$export$533346c8e8dac0f5);
$parcel$export(module.exports, "ClampToEdgeWrapping", () => $2358b7e4ec07df88$export$9d9334239a5a5e06);
$parcel$export(module.exports, "MirroredRepeatWrapping", () => $2358b7e4ec07df88$export$c7e7c00b14f51a4f);
$parcel$export(module.exports, "NearestFilter", () => $2358b7e4ec07df88$export$727aa5ec3fe39bf0);
$parcel$export(module.exports, "NearestMipmapNearestFilter", () => $2358b7e4ec07df88$export$d129e38cf6feaa8c);
$parcel$export(module.exports, "NearestMipMapNearestFilter", () => $2358b7e4ec07df88$export$14a4936464a36496);
$parcel$export(module.exports, "NearestMipmapLinearFilter", () => $2358b7e4ec07df88$export$d2327c1afe5bfdf2);
$parcel$export(module.exports, "NearestMipMapLinearFilter", () => $2358b7e4ec07df88$export$cbc5b7f5647595d8);
$parcel$export(module.exports, "LinearFilter", () => $2358b7e4ec07df88$export$8a72f490b25c56c8);
$parcel$export(module.exports, "LinearMipmapNearestFilter", () => $2358b7e4ec07df88$export$19a719f377145a13);
$parcel$export(module.exports, "LinearMipMapNearestFilter", () => $2358b7e4ec07df88$export$dbe96bee3fe9dbf0);
$parcel$export(module.exports, "LinearMipmapLinearFilter", () => $2358b7e4ec07df88$export$5d8599b6a933fb1b);
$parcel$export(module.exports, "LinearMipMapLinearFilter", () => $2358b7e4ec07df88$export$90d80f1e3506775f);
$parcel$export(module.exports, "UnsignedByteType", () => $2358b7e4ec07df88$export$2e8ce08d3f6f5e10);
$parcel$export(module.exports, "ByteType", () => $2358b7e4ec07df88$export$545fce0311a9796a);
$parcel$export(module.exports, "ShortType", () => $2358b7e4ec07df88$export$88572337f312435f);
$parcel$export(module.exports, "UnsignedShortType", () => $2358b7e4ec07df88$export$c63dc51868b06a9d);
$parcel$export(module.exports, "IntType", () => $2358b7e4ec07df88$export$5c612977753abe2);
$parcel$export(module.exports, "UnsignedIntType", () => $2358b7e4ec07df88$export$c3c7fc4518ebba96);
$parcel$export(module.exports, "FloatType", () => $2358b7e4ec07df88$export$f6d331659b644596);
$parcel$export(module.exports, "HalfFloatType", () => $2358b7e4ec07df88$export$2697304443f382bc);
$parcel$export(module.exports, "UnsignedShort4444Type", () => $2358b7e4ec07df88$export$b3969b01faf587f2);
$parcel$export(module.exports, "UnsignedShort5551Type", () => $2358b7e4ec07df88$export$18886f8ae33e90de);
$parcel$export(module.exports, "UnsignedInt248Type", () => $2358b7e4ec07df88$export$6c8ea339bfab1301);
$parcel$export(module.exports, "UnsignedInt5999Type", () => $2358b7e4ec07df88$export$5a4c329b7e2092d3);
$parcel$export(module.exports, "UnsignedInt101111Type", () => $2358b7e4ec07df88$export$f240f067f72abe41);
$parcel$export(module.exports, "AlphaFormat", () => $2358b7e4ec07df88$export$988473390501ed4b);
$parcel$export(module.exports, "RGBFormat", () => $2358b7e4ec07df88$export$7c67423a5ee6f5eb);
$parcel$export(module.exports, "RGBAFormat", () => $2358b7e4ec07df88$export$3f8bb04b555a363c);
$parcel$export(module.exports, "DepthFormat", () => $2358b7e4ec07df88$export$c1b6b5136be58045);
$parcel$export(module.exports, "DepthStencilFormat", () => $2358b7e4ec07df88$export$1e113ac2d0905829);
$parcel$export(module.exports, "RedFormat", () => $2358b7e4ec07df88$export$4e041a7967d15c4b);
$parcel$export(module.exports, "RedIntegerFormat", () => $2358b7e4ec07df88$export$aa92e870a709d190);
$parcel$export(module.exports, "RGFormat", () => $2358b7e4ec07df88$export$6cdf0b461c7ce8a0);
$parcel$export(module.exports, "RGIntegerFormat", () => $2358b7e4ec07df88$export$1ba1c45f9f77d4d7);
$parcel$export(module.exports, "RGBIntegerFormat", () => $2358b7e4ec07df88$export$d1fd40c11bfa798e);
$parcel$export(module.exports, "RGBAIntegerFormat", () => $2358b7e4ec07df88$export$c200e7d26f592f21);
$parcel$export(module.exports, "RGB_S3TC_DXT1_Format", () => $2358b7e4ec07df88$export$21d1799c6d552fc0);
$parcel$export(module.exports, "RGBA_S3TC_DXT1_Format", () => $2358b7e4ec07df88$export$afa304c3e981b668);
$parcel$export(module.exports, "RGBA_S3TC_DXT3_Format", () => $2358b7e4ec07df88$export$d2a1a68024a3e56c);
$parcel$export(module.exports, "RGBA_S3TC_DXT5_Format", () => $2358b7e4ec07df88$export$9a79c424327dacf9);
$parcel$export(module.exports, "RGB_PVRTC_4BPPV1_Format", () => $2358b7e4ec07df88$export$19ada9bbb1af3573);
$parcel$export(module.exports, "RGB_PVRTC_2BPPV1_Format", () => $2358b7e4ec07df88$export$d0f0355bb3d948e4);
$parcel$export(module.exports, "RGBA_PVRTC_4BPPV1_Format", () => $2358b7e4ec07df88$export$b82296714358084c);
$parcel$export(module.exports, "RGBA_PVRTC_2BPPV1_Format", () => $2358b7e4ec07df88$export$b71692456c47b6c3);
$parcel$export(module.exports, "RGB_ETC1_Format", () => $2358b7e4ec07df88$export$6ab91af2d757aee7);
$parcel$export(module.exports, "RGB_ETC2_Format", () => $2358b7e4ec07df88$export$7800993ef8106a6a);
$parcel$export(module.exports, "RGBA_ETC2_EAC_Format", () => $2358b7e4ec07df88$export$23ed8300a860e7d8);
$parcel$export(module.exports, "R11_EAC_Format", () => $2358b7e4ec07df88$export$d5c566817123b2bf);
$parcel$export(module.exports, "SIGNED_R11_EAC_Format", () => $2358b7e4ec07df88$export$f5668dc623297d86);
$parcel$export(module.exports, "RG11_EAC_Format", () => $2358b7e4ec07df88$export$e443ea3e1485f7bf);
$parcel$export(module.exports, "SIGNED_RG11_EAC_Format", () => $2358b7e4ec07df88$export$211402338cb75433);
$parcel$export(module.exports, "RGBA_ASTC_4x4_Format", () => $2358b7e4ec07df88$export$dc5570b4a2b92d48);
$parcel$export(module.exports, "RGBA_ASTC_5x4_Format", () => $2358b7e4ec07df88$export$68880cd325f8b2fb);
$parcel$export(module.exports, "RGBA_ASTC_5x5_Format", () => $2358b7e4ec07df88$export$7d2c0be323373d95);
$parcel$export(module.exports, "RGBA_ASTC_6x5_Format", () => $2358b7e4ec07df88$export$22b52da301fc3a3e);
$parcel$export(module.exports, "RGBA_ASTC_6x6_Format", () => $2358b7e4ec07df88$export$c009e2cb4a66485e);
$parcel$export(module.exports, "RGBA_ASTC_8x5_Format", () => $2358b7e4ec07df88$export$118fff5afa255b63);
$parcel$export(module.exports, "RGBA_ASTC_8x6_Format", () => $2358b7e4ec07df88$export$120713c829ae0667);
$parcel$export(module.exports, "RGBA_ASTC_8x8_Format", () => $2358b7e4ec07df88$export$c79eeabbf53313e9);
$parcel$export(module.exports, "RGBA_ASTC_10x5_Format", () => $2358b7e4ec07df88$export$443cf6567cdd6424);
$parcel$export(module.exports, "RGBA_ASTC_10x6_Format", () => $2358b7e4ec07df88$export$6573984fc9840780);
$parcel$export(module.exports, "RGBA_ASTC_10x8_Format", () => $2358b7e4ec07df88$export$e7aee563f30091de);
$parcel$export(module.exports, "RGBA_ASTC_10x10_Format", () => $2358b7e4ec07df88$export$2eb8634622ddeab7);
$parcel$export(module.exports, "RGBA_ASTC_12x10_Format", () => $2358b7e4ec07df88$export$202b1ce7b5d25742);
$parcel$export(module.exports, "RGBA_ASTC_12x12_Format", () => $2358b7e4ec07df88$export$18ab77abd087e467);
$parcel$export(module.exports, "RGBA_BPTC_Format", () => $2358b7e4ec07df88$export$ce40b115e188bc81);
$parcel$export(module.exports, "RGB_BPTC_SIGNED_Format", () => $2358b7e4ec07df88$export$d279c5c4bac5121e);
$parcel$export(module.exports, "RGB_BPTC_UNSIGNED_Format", () => $2358b7e4ec07df88$export$cde52d17225fdbd3);
$parcel$export(module.exports, "RED_RGTC1_Format", () => $2358b7e4ec07df88$export$b1688df4c4c21670);
$parcel$export(module.exports, "SIGNED_RED_RGTC1_Format", () => $2358b7e4ec07df88$export$fc15e5d8261eed58);
$parcel$export(module.exports, "RED_GREEN_RGTC2_Format", () => $2358b7e4ec07df88$export$d220f6ade8463a0f);
$parcel$export(module.exports, "SIGNED_RED_GREEN_RGTC2_Format", () => $2358b7e4ec07df88$export$768646d09dc1b6ef);
$parcel$export(module.exports, "LoopOnce", () => $2358b7e4ec07df88$export$d62fdc9d1b1cccad);
$parcel$export(module.exports, "LoopRepeat", () => $2358b7e4ec07df88$export$dfaf4422ce096e29);
$parcel$export(module.exports, "LoopPingPong", () => $2358b7e4ec07df88$export$f8f6f2041b78e210);
$parcel$export(module.exports, "InterpolateDiscrete", () => $2358b7e4ec07df88$export$995b32462a65e855);
$parcel$export(module.exports, "InterpolateLinear", () => $2358b7e4ec07df88$export$30fac1aace31cf4d);
$parcel$export(module.exports, "InterpolateSmooth", () => $2358b7e4ec07df88$export$198b11ff4c72bb30);
$parcel$export(module.exports, "ZeroCurvatureEnding", () => $2358b7e4ec07df88$export$7f795934b84ab523);
$parcel$export(module.exports, "ZeroSlopeEnding", () => $2358b7e4ec07df88$export$24a4ccb5099273b5);
$parcel$export(module.exports, "WrapAroundEnding", () => $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee);
$parcel$export(module.exports, "NormalAnimationBlendMode", () => $2358b7e4ec07df88$export$bcfbbdcf8de7f8cd);
$parcel$export(module.exports, "AdditiveAnimationBlendMode", () => $2358b7e4ec07df88$export$d875e029ef558d3);
$parcel$export(module.exports, "TrianglesDrawMode", () => $2358b7e4ec07df88$export$4c28c87c2dc84758);
$parcel$export(module.exports, "TriangleStripDrawMode", () => $2358b7e4ec07df88$export$b23a071aa286eb29);
$parcel$export(module.exports, "TriangleFanDrawMode", () => $2358b7e4ec07df88$export$f0d8293634f88842);
$parcel$export(module.exports, "BasicDepthPacking", () => $2358b7e4ec07df88$export$deeb383078690b50);
$parcel$export(module.exports, "RGBADepthPacking", () => $2358b7e4ec07df88$export$8f910f4c4f73df11);
$parcel$export(module.exports, "RGBDepthPacking", () => $2358b7e4ec07df88$export$be2e2ddbc3983173);
$parcel$export(module.exports, "RGDepthPacking", () => $2358b7e4ec07df88$export$1a54198784742f80);
$parcel$export(module.exports, "TangentSpaceNormalMap", () => $2358b7e4ec07df88$export$2852a58ebdac27b8);
$parcel$export(module.exports, "ObjectSpaceNormalMap", () => $2358b7e4ec07df88$export$9990ad26f9db5b2c);
$parcel$export(module.exports, "NoColorSpace", () => $2358b7e4ec07df88$export$bfcb490c2dd3db51);
$parcel$export(module.exports, "SRGBColorSpace", () => $2358b7e4ec07df88$export$561f394b24edfcaa);
$parcel$export(module.exports, "LinearSRGBColorSpace", () => $2358b7e4ec07df88$export$42429b3acfb233a4);
$parcel$export(module.exports, "LinearTransfer", () => $2358b7e4ec07df88$export$f197347d588c1b4a);
$parcel$export(module.exports, "SRGBTransfer", () => $2358b7e4ec07df88$export$8d0a61916cc26abb);
$parcel$export(module.exports, "NoNormalPacking", () => $2358b7e4ec07df88$export$7f96a53e6ab01dca);
$parcel$export(module.exports, "NormalRGPacking", () => $2358b7e4ec07df88$export$bbd2d5168fed5fd6);
$parcel$export(module.exports, "NormalGAPacking", () => $2358b7e4ec07df88$export$4f8d192b60f65626);
$parcel$export(module.exports, "ZeroStencilOp", () => $2358b7e4ec07df88$export$69433f11f42d5527);
$parcel$export(module.exports, "KeepStencilOp", () => $2358b7e4ec07df88$export$9f542ae4b5baca34);
$parcel$export(module.exports, "ReplaceStencilOp", () => $2358b7e4ec07df88$export$8a4f28336ef203d3);
$parcel$export(module.exports, "IncrementStencilOp", () => $2358b7e4ec07df88$export$2928c0231297c036);
$parcel$export(module.exports, "DecrementStencilOp", () => $2358b7e4ec07df88$export$c0e9611c8a15f9a8);
$parcel$export(module.exports, "IncrementWrapStencilOp", () => $2358b7e4ec07df88$export$9c2c08927385dcc4);
$parcel$export(module.exports, "DecrementWrapStencilOp", () => $2358b7e4ec07df88$export$7c74ea00fa1315e6);
$parcel$export(module.exports, "InvertStencilOp", () => $2358b7e4ec07df88$export$22e2e5726612443);
$parcel$export(module.exports, "NeverStencilFunc", () => $2358b7e4ec07df88$export$1343870698229224);
$parcel$export(module.exports, "LessStencilFunc", () => $2358b7e4ec07df88$export$8e1d8ed281997fa6);
$parcel$export(module.exports, "EqualStencilFunc", () => $2358b7e4ec07df88$export$55648a1cde8329a7);
$parcel$export(module.exports, "LessEqualStencilFunc", () => $2358b7e4ec07df88$export$2dff107857e6aca2);
$parcel$export(module.exports, "GreaterStencilFunc", () => $2358b7e4ec07df88$export$6f93765ab2f451a2);
$parcel$export(module.exports, "NotEqualStencilFunc", () => $2358b7e4ec07df88$export$6f3fb2d2440f2b76);
$parcel$export(module.exports, "GreaterEqualStencilFunc", () => $2358b7e4ec07df88$export$4119cf7b4c98fd5a);
$parcel$export(module.exports, "AlwaysStencilFunc", () => $2358b7e4ec07df88$export$14cf96713ddd97a8);
$parcel$export(module.exports, "NeverCompare", () => $2358b7e4ec07df88$export$d9e2d19a747baaab);
$parcel$export(module.exports, "LessCompare", () => $2358b7e4ec07df88$export$36bcf49c713b3eb7);
$parcel$export(module.exports, "EqualCompare", () => $2358b7e4ec07df88$export$66f28d946fc6a0d5);
$parcel$export(module.exports, "LessEqualCompare", () => $2358b7e4ec07df88$export$64eea11eb407ddf1);
$parcel$export(module.exports, "GreaterCompare", () => $2358b7e4ec07df88$export$155af022118f3a38);
$parcel$export(module.exports, "NotEqualCompare", () => $2358b7e4ec07df88$export$67ab95dde6bed156);
$parcel$export(module.exports, "GreaterEqualCompare", () => $2358b7e4ec07df88$export$1cdcb70d53d65f61);
$parcel$export(module.exports, "AlwaysCompare", () => $2358b7e4ec07df88$export$187b73a3e352c145);
$parcel$export(module.exports, "StaticDrawUsage", () => $2358b7e4ec07df88$export$763e8360f4d7f77d);
$parcel$export(module.exports, "DynamicDrawUsage", () => $2358b7e4ec07df88$export$8505d14ac8546ca);
$parcel$export(module.exports, "StreamDrawUsage", () => $2358b7e4ec07df88$export$721e63549e51d81e);
$parcel$export(module.exports, "StaticReadUsage", () => $2358b7e4ec07df88$export$415731dc4f48e299);
$parcel$export(module.exports, "DynamicReadUsage", () => $2358b7e4ec07df88$export$9e809946455f13bc);
$parcel$export(module.exports, "StreamReadUsage", () => $2358b7e4ec07df88$export$2ed9499a35b5f832);
$parcel$export(module.exports, "StaticCopyUsage", () => $2358b7e4ec07df88$export$32ab2503ea19469a);
$parcel$export(module.exports, "DynamicCopyUsage", () => $2358b7e4ec07df88$export$ab4022c2c3f86315);
$parcel$export(module.exports, "StreamCopyUsage", () => $2358b7e4ec07df88$export$ba7f1db36a76a970);
$parcel$export(module.exports, "GLSL1", () => $2358b7e4ec07df88$export$43600cc67fabd9f);
$parcel$export(module.exports, "GLSL3", () => $2358b7e4ec07df88$export$f63012db5506e7dd);
$parcel$export(module.exports, "WebGLCoordinateSystem", () => $2358b7e4ec07df88$export$5a0e9190d10875d3);
$parcel$export(module.exports, "WebGPUCoordinateSystem", () => $2358b7e4ec07df88$export$cc83beedcb9be9ac);
$parcel$export(module.exports, "TimestampQuery", () => $2358b7e4ec07df88$export$f97db56e2b647801);
$parcel$export(module.exports, "InterpolationSamplingType", () => $2358b7e4ec07df88$export$ff3764a6b1cf3544);
$parcel$export(module.exports, "InterpolationSamplingMode", () => $2358b7e4ec07df88$export$599d2e4c2d7b2a01);
$parcel$export(module.exports, "arrayNeedsUint32", () => $2358b7e4ec07df88$export$bc6f937da07eae17);
$parcel$export(module.exports, "isTypedArray", () => $2358b7e4ec07df88$export$b119cc7e1840e59c);
$parcel$export(module.exports, "createElementNS", () => $2358b7e4ec07df88$export$7094a064528c7fee);
$parcel$export(module.exports, "createCanvasElement", () => $2358b7e4ec07df88$export$1033a2df66368859);
$parcel$export(module.exports, "setConsoleFunction", () => $2358b7e4ec07df88$export$702823ffb42fb3aa);
$parcel$export(module.exports, "getConsoleFunction", () => $2358b7e4ec07df88$export$fa86edd994bb169f);
$parcel$export(module.exports, "log", () => $2358b7e4ec07df88$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "warn", () => $2358b7e4ec07df88$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "error", () => $2358b7e4ec07df88$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "warnOnce", () => $2358b7e4ec07df88$export$5b28268982f175ba);
$parcel$export(module.exports, "probeAsync", () => $2358b7e4ec07df88$export$d43f91ebeafb2c7);
$parcel$export(module.exports, "EventDispatcher", () => $2358b7e4ec07df88$export$ec8b666c5fe2c75a);
$parcel$export(module.exports, "RAD2DEG", () => $2358b7e4ec07df88$export$914076c8150813e5);
$parcel$export(module.exports, "MathUtils", () => $2358b7e4ec07df88$export$6a7ef315a0d1ef07);
$parcel$export(module.exports, "Vector2", () => $2358b7e4ec07df88$export$c977b3e384af9ae1);
$parcel$export(module.exports, "Quaternion", () => $2358b7e4ec07df88$export$23d6a54f0bbc85a3);
$parcel$export(module.exports, "Vector3", () => $2358b7e4ec07df88$export$64b5c384219d3699);
$parcel$export(module.exports, "Matrix3", () => $2358b7e4ec07df88$export$8ff26dafa08918);
$parcel$export(module.exports, "ColorManagement", () => $2358b7e4ec07df88$export$5e6fd513f44698c);
$parcel$export(module.exports, "ImageUtils", () => $2358b7e4ec07df88$export$698882cf06df44aa);
$parcel$export(module.exports, "Source", () => $2358b7e4ec07df88$export$1d2df86270c81ecb);
$parcel$export(module.exports, "Texture", () => $2358b7e4ec07df88$export$5431306cf43de24a);
$parcel$export(module.exports, "Vector4", () => $2358b7e4ec07df88$export$fa7daccca11cdbe3);
$parcel$export(module.exports, "RenderTarget", () => $2358b7e4ec07df88$export$efcb1f8bf367cbfb);
$parcel$export(module.exports, "WebGLRenderTarget", () => $2358b7e4ec07df88$export$3c052beb2e51e23f);
$parcel$export(module.exports, "DataArrayTexture", () => $2358b7e4ec07df88$export$dfac6c8e811406a3);
$parcel$export(module.exports, "WebGLArrayRenderTarget", () => $2358b7e4ec07df88$export$c77a02c11ed180c7);
$parcel$export(module.exports, "Data3DTexture", () => $2358b7e4ec07df88$export$d7a3086320f856db);
$parcel$export(module.exports, "WebGL3DRenderTarget", () => $2358b7e4ec07df88$export$7ee06591009639df);
$parcel$export(module.exports, "Box3", () => $2358b7e4ec07df88$export$6f7d5a9418ab2aa3);
$parcel$export(module.exports, "Sphere", () => $2358b7e4ec07df88$export$805e8b72413ccaba);
$parcel$export(module.exports, "Ray", () => $2358b7e4ec07df88$export$a186db52eed6d40e);
$parcel$export(module.exports, "Matrix4", () => $2358b7e4ec07df88$export$2ae72fc923e5eb5);
$parcel$export(module.exports, "Euler", () => $2358b7e4ec07df88$export$d93cc409a0768c5f);
$parcel$export(module.exports, "Layers", () => $2358b7e4ec07df88$export$89312ce47c0ca777);
$parcel$export(module.exports, "Object3D", () => $2358b7e4ec07df88$export$e4dd07dff30cc924);
$parcel$export(module.exports, "Triangle", () => $2358b7e4ec07df88$export$5a465592bfe74b48);
$parcel$export(module.exports, "Color", () => $2358b7e4ec07df88$export$892596cec99bc70e);
$parcel$export(module.exports, "Material", () => $2358b7e4ec07df88$export$a2d8b23205c25948);
$parcel$export(module.exports, "MeshBasicMaterial", () => $2358b7e4ec07df88$export$55cbcc9b622fe1f5);
$parcel$export(module.exports, "DataUtils", () => $2358b7e4ec07df88$export$11ce8b759162cc80);
$parcel$export(module.exports, "BufferAttribute", () => $2358b7e4ec07df88$export$8dea267bd6bde117);
$parcel$export(module.exports, "Int8BufferAttribute", () => $2358b7e4ec07df88$export$f9ff2d6a20248cbf);
$parcel$export(module.exports, "Uint8BufferAttribute", () => $2358b7e4ec07df88$export$cacc90cf35d11cdd);
$parcel$export(module.exports, "Uint8ClampedBufferAttribute", () => $2358b7e4ec07df88$export$baaa85a1a812c157);
$parcel$export(module.exports, "Int16BufferAttribute", () => $2358b7e4ec07df88$export$2b755a102ccdcefe);
$parcel$export(module.exports, "Uint16BufferAttribute", () => $2358b7e4ec07df88$export$640a853f68025f2e);
$parcel$export(module.exports, "Int32BufferAttribute", () => $2358b7e4ec07df88$export$46b369aed2968a0a);
$parcel$export(module.exports, "Uint32BufferAttribute", () => $2358b7e4ec07df88$export$7eb8c9fa25cd5bd6);
$parcel$export(module.exports, "Float16BufferAttribute", () => $2358b7e4ec07df88$export$dbd3698c64958d69);
$parcel$export(module.exports, "Float32BufferAttribute", () => $2358b7e4ec07df88$export$cbe7a62641830ebd);
$parcel$export(module.exports, "BufferGeometry", () => $2358b7e4ec07df88$export$b7be63a67df8959);
$parcel$export(module.exports, "Mesh", () => $2358b7e4ec07df88$export$e176487c05830cc5);
$parcel$export(module.exports, "BoxGeometry", () => $2358b7e4ec07df88$export$33e43285f7406bd5);
$parcel$export(module.exports, "cloneUniforms", () => $2358b7e4ec07df88$export$acda854380553452);
$parcel$export(module.exports, "mergeUniforms", () => $2358b7e4ec07df88$export$8916ce6879271f43);
$parcel$export(module.exports, "getUnlitUniformColorSpace", () => $2358b7e4ec07df88$export$a630742c640528c1);
$parcel$export(module.exports, "UniformsUtils", () => $2358b7e4ec07df88$export$d8ecdf8615bfea69);
$parcel$export(module.exports, "ShaderMaterial", () => $2358b7e4ec07df88$export$83c7d75d550a8b0d);
$parcel$export(module.exports, "Camera", () => $2358b7e4ec07df88$export$79f141de891a5fed);
$parcel$export(module.exports, "PerspectiveCamera", () => $2358b7e4ec07df88$export$74e4ae24825f68d7);
$parcel$export(module.exports, "CubeCamera", () => $2358b7e4ec07df88$export$d0cdd0bd804995de);
$parcel$export(module.exports, "CubeTexture", () => $2358b7e4ec07df88$export$ee2e5a18258a4049);
$parcel$export(module.exports, "WebGLCubeRenderTarget", () => $2358b7e4ec07df88$export$ac386671d651941e);
$parcel$export(module.exports, "Group", () => $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4);
$parcel$export(module.exports, "WebXRController", () => $2358b7e4ec07df88$export$cb626c57dcc48b9f);
$parcel$export(module.exports, "FogExp2", () => $2358b7e4ec07df88$export$6f1519f023b8d0f6);
$parcel$export(module.exports, "Fog", () => $2358b7e4ec07df88$export$3c890837b09508d4);
$parcel$export(module.exports, "Scene", () => $2358b7e4ec07df88$export$38af1803e3442a7f);
$parcel$export(module.exports, "InterleavedBuffer", () => $2358b7e4ec07df88$export$3d5cd879f108f53f);
$parcel$export(module.exports, "InterleavedBufferAttribute", () => $2358b7e4ec07df88$export$920b6d07334599c7);
$parcel$export(module.exports, "SpriteMaterial", () => $2358b7e4ec07df88$export$5ec7dd1c6994bf8e);
$parcel$export(module.exports, "Sprite", () => $2358b7e4ec07df88$export$3075603db8e6204c);
$parcel$export(module.exports, "LOD", () => $2358b7e4ec07df88$export$112e7237be0c5f30);
$parcel$export(module.exports, "SkinnedMesh", () => $2358b7e4ec07df88$export$b303577035157ecf);
$parcel$export(module.exports, "Bone", () => $2358b7e4ec07df88$export$b127726e56765aa4);
$parcel$export(module.exports, "DataTexture", () => $2358b7e4ec07df88$export$b691f601014eabe1);
$parcel$export(module.exports, "Skeleton", () => $2358b7e4ec07df88$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InstancedBufferAttribute", () => $2358b7e4ec07df88$export$32ea87a8b54d744a);
$parcel$export(module.exports, "InstancedMesh", () => $2358b7e4ec07df88$export$f3c979c331175ad7);
$parcel$export(module.exports, "Plane", () => $2358b7e4ec07df88$export$7ff5ac152ef991b0);
$parcel$export(module.exports, "Frustum", () => $2358b7e4ec07df88$export$35efe6f4c85463d2);
$parcel$export(module.exports, "FrustumArray", () => $2358b7e4ec07df88$export$2d7d04327620499c);
$parcel$export(module.exports, "BatchedMesh", () => $2358b7e4ec07df88$export$6e01c5ee52ed8f7b);
$parcel$export(module.exports, "LineBasicMaterial", () => $2358b7e4ec07df88$export$fbaaa33907730a0c);
$parcel$export(module.exports, "Line", () => $2358b7e4ec07df88$export$17d680238e50603e);
$parcel$export(module.exports, "LineSegments", () => $2358b7e4ec07df88$export$ff1ed10fedfdd604);
$parcel$export(module.exports, "LineLoop", () => $2358b7e4ec07df88$export$f85a24d745e4f17d);
$parcel$export(module.exports, "PointsMaterial", () => $2358b7e4ec07df88$export$a178c45366ce5d6b);
$parcel$export(module.exports, "Points", () => $2358b7e4ec07df88$export$1c787534cb11aa3e);
$parcel$export(module.exports, "VideoTexture", () => $2358b7e4ec07df88$export$6e09d1edf8d5a25c);
$parcel$export(module.exports, "VideoFrameTexture", () => $2358b7e4ec07df88$export$68498d200b825382);
$parcel$export(module.exports, "FramebufferTexture", () => $2358b7e4ec07df88$export$9270d786f73ce6fe);
$parcel$export(module.exports, "CompressedTexture", () => $2358b7e4ec07df88$export$3466bac9141a5cc4);
$parcel$export(module.exports, "CompressedArrayTexture", () => $2358b7e4ec07df88$export$5fe6b8e34b274fcb);
$parcel$export(module.exports, "CompressedCubeTexture", () => $2358b7e4ec07df88$export$d80173634de65bff);
$parcel$export(module.exports, "CanvasTexture", () => $2358b7e4ec07df88$export$f7189e49152d1c13);
$parcel$export(module.exports, "DepthTexture", () => $2358b7e4ec07df88$export$fc830aa069cc8c2f);
$parcel$export(module.exports, "CubeDepthTexture", () => $2358b7e4ec07df88$export$c9f39eef7fb1d170);
$parcel$export(module.exports, "ExternalTexture", () => $2358b7e4ec07df88$export$cd10147cacf16ab2);
$parcel$export(module.exports, "CapsuleGeometry", () => $2358b7e4ec07df88$export$41680e8551036033);
$parcel$export(module.exports, "CircleGeometry", () => $2358b7e4ec07df88$export$d5c0e8d607467193);
$parcel$export(module.exports, "CylinderGeometry", () => $2358b7e4ec07df88$export$68f745719dbe5198);
$parcel$export(module.exports, "ConeGeometry", () => $2358b7e4ec07df88$export$a7a48974f285c9b3);
$parcel$export(module.exports, "PolyhedronGeometry", () => $2358b7e4ec07df88$export$60e57a7d3f20ff65);
$parcel$export(module.exports, "DodecahedronGeometry", () => $2358b7e4ec07df88$export$c0babfeb8708fc9c);
$parcel$export(module.exports, "EdgesGeometry", () => $2358b7e4ec07df88$export$4730b1542707547f);
$parcel$export(module.exports, "Curve", () => $2358b7e4ec07df88$export$b0e83c3ef8d2db1);
$parcel$export(module.exports, "EllipseCurve", () => $2358b7e4ec07df88$export$3f87a931616cde04);
$parcel$export(module.exports, "ArcCurve", () => $2358b7e4ec07df88$export$b1eedc9aab6300e8);
$parcel$export(module.exports, "CatmullRomCurve3", () => $2358b7e4ec07df88$export$b9146b27c24b744c);
$parcel$export(module.exports, "CubicBezierCurve", () => $2358b7e4ec07df88$export$e36650d36468bb39);
$parcel$export(module.exports, "CubicBezierCurve3", () => $2358b7e4ec07df88$export$13d5f1c9525f246c);
$parcel$export(module.exports, "LineCurve", () => $2358b7e4ec07df88$export$ab2e07e76531a47e);
$parcel$export(module.exports, "LineCurve3", () => $2358b7e4ec07df88$export$1fdfd9d9cf487600);
$parcel$export(module.exports, "QuadraticBezierCurve", () => $2358b7e4ec07df88$export$5938c4ee491a43ad);
$parcel$export(module.exports, "QuadraticBezierCurve3", () => $2358b7e4ec07df88$export$bf3f4c7e459f90fc);
$parcel$export(module.exports, "SplineCurve", () => $2358b7e4ec07df88$export$d3bdd77da77afc1b);
$parcel$export(module.exports, "CurvePath", () => $2358b7e4ec07df88$export$4aaf9b66af1bbf2c);
$parcel$export(module.exports, "Path", () => $2358b7e4ec07df88$export$4b2950bdac9b6ee9);
$parcel$export(module.exports, "Shape", () => $2358b7e4ec07df88$export$6428a7f2611ef1fa);
$parcel$export(module.exports, "ShapeUtils", () => $2358b7e4ec07df88$export$96bdf6d9c66d7ba8);
$parcel$export(module.exports, "ExtrudeGeometry", () => $2358b7e4ec07df88$export$598697a1efa63ca7);
$parcel$export(module.exports, "IcosahedronGeometry", () => $2358b7e4ec07df88$export$9567cc828c9535da);
$parcel$export(module.exports, "LatheGeometry", () => $2358b7e4ec07df88$export$6d839803fcd1882c);
$parcel$export(module.exports, "OctahedronGeometry", () => $2358b7e4ec07df88$export$1954e2b809fe361e);
$parcel$export(module.exports, "PlaneGeometry", () => $2358b7e4ec07df88$export$967d831af31f69ce);
$parcel$export(module.exports, "RingGeometry", () => $2358b7e4ec07df88$export$68cb731f50f614af);
$parcel$export(module.exports, "ShapeGeometry", () => $2358b7e4ec07df88$export$57a29a1c803e9065);
$parcel$export(module.exports, "SphereGeometry", () => $2358b7e4ec07df88$export$1b417fc3b307a251);
$parcel$export(module.exports, "TetrahedronGeometry", () => $2358b7e4ec07df88$export$fb3f7adc68bd6e02);
$parcel$export(module.exports, "TorusGeometry", () => $2358b7e4ec07df88$export$a2312a2a1fa56495);
$parcel$export(module.exports, "TorusKnotGeometry", () => $2358b7e4ec07df88$export$77e9bfadfb9ab8c8);
$parcel$export(module.exports, "TubeGeometry", () => $2358b7e4ec07df88$export$7897d9d48904490c);
$parcel$export(module.exports, "WireframeGeometry", () => $2358b7e4ec07df88$export$4b739da06d24892b);
$parcel$export(module.exports, "ShadowMaterial", () => $2358b7e4ec07df88$export$e8564da406055a3);
$parcel$export(module.exports, "RawShaderMaterial", () => $2358b7e4ec07df88$export$21c421a2e1df9d22);
$parcel$export(module.exports, "MeshStandardMaterial", () => $2358b7e4ec07df88$export$f2980790215acccd);
$parcel$export(module.exports, "MeshPhysicalMaterial", () => $2358b7e4ec07df88$export$28d04986c4269c9f);
$parcel$export(module.exports, "MeshPhongMaterial", () => $2358b7e4ec07df88$export$24c72f71cbaf0678);
$parcel$export(module.exports, "MeshToonMaterial", () => $2358b7e4ec07df88$export$df893cf97e765622);
$parcel$export(module.exports, "MeshNormalMaterial", () => $2358b7e4ec07df88$export$bfe8c0a091f41ae7);
$parcel$export(module.exports, "MeshLambertMaterial", () => $2358b7e4ec07df88$export$5023a9a8114806b8);
$parcel$export(module.exports, "MeshDepthMaterial", () => $2358b7e4ec07df88$export$2698c22ec13825db);
$parcel$export(module.exports, "MeshDistanceMaterial", () => $2358b7e4ec07df88$export$33e187ed002f2a19);
$parcel$export(module.exports, "MeshMatcapMaterial", () => $2358b7e4ec07df88$export$6f5fef6235ec12ee);
$parcel$export(module.exports, "LineDashedMaterial", () => $2358b7e4ec07df88$export$327886a3efaeaebe);
$parcel$export(module.exports, "AnimationUtils", () => $2358b7e4ec07df88$export$7ee8caa573e71ad1);
$parcel$export(module.exports, "Interpolant", () => $2358b7e4ec07df88$export$b558baee9c0f72d3);
$parcel$export(module.exports, "CubicInterpolant", () => $2358b7e4ec07df88$export$3646682e7a3959);
$parcel$export(module.exports, "LinearInterpolant", () => $2358b7e4ec07df88$export$a8e6009059f51e1a);
$parcel$export(module.exports, "DiscreteInterpolant", () => $2358b7e4ec07df88$export$fb9758ef7ef8d5cc);
$parcel$export(module.exports, "KeyframeTrack", () => $2358b7e4ec07df88$export$b0e479f45b7006d6);
$parcel$export(module.exports, "BooleanKeyframeTrack", () => $2358b7e4ec07df88$export$d3a344b98cf0b775);
$parcel$export(module.exports, "ColorKeyframeTrack", () => $2358b7e4ec07df88$export$83444c5d885347d8);
$parcel$export(module.exports, "NumberKeyframeTrack", () => $2358b7e4ec07df88$export$d45f0d1a4d9a9314);
$parcel$export(module.exports, "QuaternionLinearInterpolant", () => $2358b7e4ec07df88$export$2db1cfb7923d931e);
$parcel$export(module.exports, "QuaternionKeyframeTrack", () => $2358b7e4ec07df88$export$b8043f12b5aafbd7);
$parcel$export(module.exports, "StringKeyframeTrack", () => $2358b7e4ec07df88$export$6ce41d4f3a8df9cd);
$parcel$export(module.exports, "VectorKeyframeTrack", () => $2358b7e4ec07df88$export$5ce2dcb4cc9f2bff);
$parcel$export(module.exports, "AnimationClip", () => $2358b7e4ec07df88$export$d942c706bf23829c);
$parcel$export(module.exports, "Cache", () => $2358b7e4ec07df88$export$94affb487e701bf2);
$parcel$export(module.exports, "LoadingManager", () => $2358b7e4ec07df88$export$99cc795e99919eed);
$parcel$export(module.exports, "DefaultLoadingManager", () => $2358b7e4ec07df88$export$b033c3f9a95c6a16);
$parcel$export(module.exports, "Loader", () => $2358b7e4ec07df88$export$3b0d6d7590275603);
$parcel$export(module.exports, "FileLoader", () => $2358b7e4ec07df88$export$98435a25b5cf7b2b);
$parcel$export(module.exports, "AnimationLoader", () => $2358b7e4ec07df88$export$29711c7e14f61db);
$parcel$export(module.exports, "CompressedTextureLoader", () => $2358b7e4ec07df88$export$bd73ce947a280350);
$parcel$export(module.exports, "ImageLoader", () => $2358b7e4ec07df88$export$8905ce1c7a2464a1);
$parcel$export(module.exports, "CubeTextureLoader", () => $2358b7e4ec07df88$export$2ec114afc2cf6308);
$parcel$export(module.exports, "DataTextureLoader", () => $2358b7e4ec07df88$export$792d8a18f2c55855);
$parcel$export(module.exports, "TextureLoader", () => $2358b7e4ec07df88$export$fd1bfc71f64c538c);
$parcel$export(module.exports, "Light", () => $2358b7e4ec07df88$export$6ecadb6ed240d696);
$parcel$export(module.exports, "HemisphereLight", () => $2358b7e4ec07df88$export$8d474f55edbb9624);
$parcel$export(module.exports, "SpotLight", () => $2358b7e4ec07df88$export$81495cbb73897362);
$parcel$export(module.exports, "PointLight", () => $2358b7e4ec07df88$export$4c9c1cb3f0b6f455);
$parcel$export(module.exports, "OrthographicCamera", () => $2358b7e4ec07df88$export$9ebf355ee4ed261b);
$parcel$export(module.exports, "DirectionalLight", () => $2358b7e4ec07df88$export$3fea33cc9972c868);
$parcel$export(module.exports, "AmbientLight", () => $2358b7e4ec07df88$export$af279bfef9ec2c96);
$parcel$export(module.exports, "RectAreaLight", () => $2358b7e4ec07df88$export$61db2d908bbd2429);
$parcel$export(module.exports, "SphericalHarmonics3", () => $2358b7e4ec07df88$export$ba61ce607e1f405a);
$parcel$export(module.exports, "LightProbe", () => $2358b7e4ec07df88$export$e7ef036e309b38d2);
$parcel$export(module.exports, "MaterialLoader", () => $2358b7e4ec07df88$export$3bd6d323353dcf96);
$parcel$export(module.exports, "LoaderUtils", () => $2358b7e4ec07df88$export$b5d2dc08d867e41a);
$parcel$export(module.exports, "InstancedBufferGeometry", () => $2358b7e4ec07df88$export$231f009cbe414146);
$parcel$export(module.exports, "BufferGeometryLoader", () => $2358b7e4ec07df88$export$dc275bb96327833a);
$parcel$export(module.exports, "ObjectLoader", () => $2358b7e4ec07df88$export$40110c8505c5ad19);
$parcel$export(module.exports, "ImageBitmapLoader", () => $2358b7e4ec07df88$export$52286b55c4a9b51f);
$parcel$export(module.exports, "AudioContext", () => $2358b7e4ec07df88$export$fcbc63750ec2a81f);
$parcel$export(module.exports, "AudioLoader", () => $2358b7e4ec07df88$export$d8d5fccfbf47714e);
$parcel$export(module.exports, "StereoCamera", () => $2358b7e4ec07df88$export$bc7f73a1065bee0c);
$parcel$export(module.exports, "ArrayCamera", () => $2358b7e4ec07df88$export$56b937d9e5581166);
$parcel$export(module.exports, "Clock", () => $2358b7e4ec07df88$export$9735c82c4bae3302);
$parcel$export(module.exports, "AudioListener", () => $2358b7e4ec07df88$export$8a1b810c6fde8951);
$parcel$export(module.exports, "Audio", () => $2358b7e4ec07df88$export$153755f98d9861de);
$parcel$export(module.exports, "PositionalAudio", () => $2358b7e4ec07df88$export$4b3e397ef1832507);
$parcel$export(module.exports, "AudioAnalyser", () => $2358b7e4ec07df88$export$d47da1ef3d382827);
$parcel$export(module.exports, "PropertyMixer", () => $2358b7e4ec07df88$export$dfe0af1ca1acb78a);
$parcel$export(module.exports, "PropertyBinding", () => $2358b7e4ec07df88$export$7bf70fcf9f891893);
$parcel$export(module.exports, "AnimationObjectGroup", () => $2358b7e4ec07df88$export$30619c2afd3f34db);
$parcel$export(module.exports, "AnimationAction", () => $2358b7e4ec07df88$export$6946940a69e799e);
$parcel$export(module.exports, "AnimationMixer", () => $2358b7e4ec07df88$export$fbd77e5aefaa0102);
$parcel$export(module.exports, "RenderTarget3D", () => $2358b7e4ec07df88$export$6b116d2fdfef087c);
$parcel$export(module.exports, "Uniform", () => $2358b7e4ec07df88$export$2947cebfe91c02f8);
$parcel$export(module.exports, "UniformsGroup", () => $2358b7e4ec07df88$export$c412d5ffe1f79209);
$parcel$export(module.exports, "InstancedInterleavedBuffer", () => $2358b7e4ec07df88$export$25ec0e1af1389358);
$parcel$export(module.exports, "GLBufferAttribute", () => $2358b7e4ec07df88$export$6b7339ae8dbddf73);
$parcel$export(module.exports, "Raycaster", () => $2358b7e4ec07df88$export$8b7aaceff00bd2f);
$parcel$export(module.exports, "Timer", () => $2358b7e4ec07df88$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "Spherical", () => $2358b7e4ec07df88$export$d712cd887b4a00f7);
$parcel$export(module.exports, "Cylindrical", () => $2358b7e4ec07df88$export$287165bb2177f4fd);
$parcel$export(module.exports, "Matrix2", () => $2358b7e4ec07df88$export$cbcc6560bf79fb38);
$parcel$export(module.exports, "Box2", () => $2358b7e4ec07df88$export$60f553fa130f08b0);
$parcel$export(module.exports, "Line3", () => $2358b7e4ec07df88$export$e0ba6359f1954fd3);
$parcel$export(module.exports, "SpotLightHelper", () => $2358b7e4ec07df88$export$4b14638ffdd81e68);
$parcel$export(module.exports, "SkeletonHelper", () => $2358b7e4ec07df88$export$5277df3c9e732259);
$parcel$export(module.exports, "PointLightHelper", () => $2358b7e4ec07df88$export$9a9291685b9e4023);
$parcel$export(module.exports, "HemisphereLightHelper", () => $2358b7e4ec07df88$export$8dca15f13f4f8172);
$parcel$export(module.exports, "GridHelper", () => $2358b7e4ec07df88$export$3875d39926561055);
$parcel$export(module.exports, "PolarGridHelper", () => $2358b7e4ec07df88$export$361430a10f533cd3);
$parcel$export(module.exports, "DirectionalLightHelper", () => $2358b7e4ec07df88$export$f8e434dc14203e7d);
$parcel$export(module.exports, "CameraHelper", () => $2358b7e4ec07df88$export$ed8e93f853cd795);
$parcel$export(module.exports, "BoxHelper", () => $2358b7e4ec07df88$export$38a664cc862a6a9d);
$parcel$export(module.exports, "Box3Helper", () => $2358b7e4ec07df88$export$ce39f4bb96c9a290);
$parcel$export(module.exports, "PlaneHelper", () => $2358b7e4ec07df88$export$a34fe8156c66e5d7);
$parcel$export(module.exports, "ArrowHelper", () => $2358b7e4ec07df88$export$a3008e7bd8d2cbe7);
$parcel$export(module.exports, "AxesHelper", () => $2358b7e4ec07df88$export$6c8303f35b8578fd);
$parcel$export(module.exports, "ShapePath", () => $2358b7e4ec07df88$export$148534a3c727230b);
$parcel$export(module.exports, "Controls", () => $2358b7e4ec07df88$export$c7c44baae9d9f25f);
$parcel$export(module.exports, "getByteLength", () => $2358b7e4ec07df88$export$cc8c3b705bb8e6e2);
$parcel$export(module.exports, "TextureUtils", () => $2358b7e4ec07df88$export$ec276d39f33d4b7);
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $2358b7e4ec07df88$export$3545e07a80636437 = '182';
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsMouse}
 * @constant
 */ const $2358b7e4ec07df88$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
/**
 * Represents touch interaction types in context of controls.
 *
 * @type {ConstantsTouch}
 * @constant
 */ const $2358b7e4ec07df88$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
/**
 * Disables face culling.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$3237e1f2c1ea1f44 = 0;
/**
 * Culls back faces.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b9a7b4fc5cb15f9b = 1;
/**
 * Culls front faces.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b8058bcc7037d3f3 = 2;
/**
 * Culls both front and back faces.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f24be24dcddeac0d = 3;
/**
 * Gives unfiltered shadow maps - fastest, but lowest quality.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$346307dbae2b7447 = 0;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5813f879eee7cd88 = 1;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm with
 * better soft shadows especially when using low-resolution shadow maps.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$a47c4b43a1be34f0 = 2;
/**
 * Filters shadow maps using the Variance Shadow Map (VSM) algorithm.
 * When using VSMShadowMap all shadow receivers will also cast shadows.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$896ae1ade6c829c4 = 3;
/**
 * Only front faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2ede184fc2998901 = 0;
/**
 * Only back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d9f0486e75b5ace = 1;
/**
 * Both front and back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$3b296b6f144d5b03 = 2;
/**
 * No blending is performed which effectively disables
 * alpha transparency.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$63b8d6b580fc65ba = 0;
/**
 * The default blending.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5b29a26d96ee6af0 = 1;
/**
 * Represents additive blending.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$777d8f9551c2216b = 2;
/**
 * Represents subtractive blending.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$cdfa06f868e2e467 = 3;
/**
 * Represents multiply blending.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$4138e1c684b46a20 = 4;
/**
 * Represents custom blending.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$eda4864c68df1fa2 = 5;
/**
 * A `source + destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$20183a0484ce21a0 = 100;
/**
 * A `source - destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$73e0df5177988548 = 101;
/**
 * A `destination - source` blending equation.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$28e582859cbec660 = 102;
/**
 * A blend equation that uses the minimum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c8c1508da8d0600c = 103;
/**
 * A blend equation that uses the maximum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$99948c02fb51055f = 104;
/**
 * Multiplies all colors by `0`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2110f05edf778d3d = 200;
/**
 * Multiplies all colors by `1`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8805bad65e24940e = 201;
/**
 * Multiplies all colors by the source colors.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7fbe15b28d28cf52 = 202;
/**
 * Multiplies all colors by `1` minus each source color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$947829af9f2c17f6 = 203;
/**
 * Multiplies all colors by the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d5773124e86cf28c = 204;
/**
 * Multiplies all colors by 1 minus the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$11d468cc7f19e971 = 205;
/**
 * Multiplies all colors by the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$a78aed1ca2a87192 = 206;
/**
 * Multiplies all colors by `1` minus the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5d0fe17fd8773bac = 207;
/**
 * Multiplies all colors by the destination color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$ef5f2dd8ffac5574 = 208;
/**
 * Multiplies all colors by `1` minus each destination color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$56b85b2686ab16 = 209;
/**
 * Multiplies the RGB colors by the smaller of either the source alpha
 * value or the value of `1` minus the destination alpha value. The alpha
 * value is multiplied by `1`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c05e2a1fc8609506 = 210;
/**
 * Multiplies all colors by a constant color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7dd8f434fd59075 = 211;
/**
 * Multiplies all colors by `1` minus a constant color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$99c8d898a9afbcee = 212;
/**
 * Multiplies all colors by a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$310cd2be38d13b56 = 213;
/**
 * Multiplies all colors by 1 minus a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$db77b8fbcf45dbf4 = 214;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$69025ce147cee220 = 0;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7182eb52ea3b3f04 = 1;
/**
 * Pass if the incoming value is less than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$eedccec66ab7ebe = 2;
/**
 * Pass if the incoming value is less than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$296f78a0b892f81a = 3;
/**
 * Pass if the incoming value equals the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$a60d398fc7b7590e = 4;
/**
 * Pass if the incoming value is greater than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7d7234c1240a1fc4 = 5;
/**
 * Pass if the incoming value is greater than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c5e2c52991f30937 = 6;
/**
 * Pass if the incoming value is not equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2f843afa843d8916 = 7;
/**
 * Multiplies the environment map color with the surface color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$e50ac29801f1774d = 0;
/**
 * Uses reflectivity to blend between the two colors.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9f9d94f963c85479 = 1;
/**
 * Adds the two colors.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$e641dc52bc3494aa = 2;
/**
 * No tone mapping is applied.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9fcb6b4294603b2 = 0;
/**
 * Linear tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$98f52c2a46c598ca = 1;
/**
 * Reinhard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$74b25e54b3bcd548 = 2;
/**
 * Cineon tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$932b3dd283d4a366 = 3;
/**
 * ACES Filmic tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$a0d98fe6d7e4af64 = 4;
/**
 * Custom tone mapping.
 *
 * Expects a custom implementation by modifying shader code of the material's fragment shader.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2c7b09c1e9abfb5e = 5;
/**
 * AgX tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$212d53a513a325b2 = 6;
/**
 * Neutral tone mapping.
 *
 * Implementation based on the Khronos 3D Commerce Group standard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f2863e1668a8e317 = 7;
/**
 * The skinned mesh shares the same world space as the skeleton.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$2595a3798997538 = 'attached';
/**
 * The skinned mesh does not share the same world space as the skeleton.
 * This is useful when a skeleton is shared across multiple skinned meshes.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$d7e7dc2e114517a0 = 'detached';
/**
 * Maps textures using the geometry's UV coordinates.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1beec6768cbb3d2d = 300;
/**
 * Reflection mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8759762a6477f2c4 = 301;
/**
 * Refraction mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$dc59f8aed047f61d = 302;
/**
 * Reflection mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d64030b316d3b087 = 303;
/**
 * Refraction mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$ee99d97d46898098 = 304;
/**
 * Reflection mapping for PMREM textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$dbf3e70ff37af79 = 306;
/**
 * The texture will simply repeat to infinity.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$533346c8e8dac0f5 = 1000;
/**
 * The last pixel of the texture stretches to the edge of the mesh.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9d9334239a5a5e06 = 1001;
/**
 * The texture will repeats to infinity, mirroring on each repeat.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c7e7c00b14f51a4f = 1002;
/**
 * Returns the value of the texture element that is nearest (in Manhattan distance)
 * to the specified texture coordinates.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$727aa5ec3fe39bf0 = 1003;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured
 * and uses the `NearestFilter` criterion (the texel nearest to the center of the pixel)
 * to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d129e38cf6feaa8c = 1004;
const $2358b7e4ec07df88$export$14a4936464a36496 = 1004; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and
 * uses the `NearestFilter` criterion to produce a texture value from each mipmap.
 * The final texture value is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d2327c1afe5bfdf2 = 1005;
const $2358b7e4ec07df88$export$cbc5b7f5647595d8 = 1005; // legacy
/**
 * Returns the weighted average of the four texture elements that are closest to the specified
 * texture coordinates, and can include items wrapped or repeated from other parts of a texture,
 * depending on the values of `wrapS` and `wrapT`, and on the exact mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8a72f490b25c56c8 = 1006;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured and uses
 * the `LinearFilter` criterion (a weighted average of the four texels that are closest to the
 * center of the pixel) to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$19a719f377145a13 = 1007;
const $2358b7e4ec07df88$export$dbe96bee3fe9dbf0 = 1007; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and uses
 * the `LinearFilter` criterion to produce a texture value from each mipmap. The final texture value
 * is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5d8599b6a933fb1b = 1008;
const $2358b7e4ec07df88$export$90d80f1e3506775f = 1008; // legacy
/**
 * An unsigned byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2e8ce08d3f6f5e10 = 1009;
/**
 * A byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$545fce0311a9796a = 1010;
/**
 * A short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$88572337f312435f = 1011;
/**
 * An unsigned short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c63dc51868b06a9d = 1012;
/**
 * An int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5c612977753abe2 = 1013;
/**
 * An unsigned int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c3c7fc4518ebba96 = 1014;
/**
 * A float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f6d331659b644596 = 1015;
/**
 * A half float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2697304443f382bc = 1016;
/**
 * An unsigned short 4_4_4_4 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b3969b01faf587f2 = 1017;
/**
 * An unsigned short 5_5_5_1 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$18886f8ae33e90de = 1018;
/**
 * An unsigned int 24_8 data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6c8ea339bfab1301 = 1020;
/**
 * An unsigned int 5_9_9_9 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5a4c329b7e2092d3 = 35902;
/**
 * An unsigned int 10_11_11 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f240f067f72abe41 = 35899;
/**
 * Discards the red, green and blue components and reads just the alpha component.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$988473390501ed4b = 1021;
/**
 * Discards the alpha component and reads the red, green and blue component.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7c67423a5ee6f5eb = 1022;
/**
 * Reads the red, green, blue and alpha components.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$3f8bb04b555a363c = 1023;
/**
 * Reads each element as a single depth value, converts it to floating point, and clamps to the range `[0,1]`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c1b6b5136be58045 = 1026;
/**
 * Reads each element is a pair of depth and stencil values. The depth component of the pair is interpreted as
 * in `DepthFormat`. The stencil component is interpreted based on the depth + stencil internal format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1e113ac2d0905829 = 1027;
/**
 * Discards the green, blue and alpha components and reads just the red component.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$4e041a7967d15c4b = 1028;
/**
 * Discards the green, blue and alpha components and reads just the red component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$aa92e870a709d190 = 1029;
/**
 * Discards the alpha, and blue components and reads the red, and green components.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6cdf0b461c7ce8a0 = 1030;
/**
 * Discards the alpha, and blue components and reads the red, and green components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1ba1c45f9f77d4d7 = 1031;
/**
 * Discards the alpha component and reads the red, green and blue component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d1fd40c11bfa798e = 1032;
/**
 * Reads the red, green, blue and alpha components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c200e7d26f592f21 = 1033;
/**
 * A DXT1-compressed image in an RGB image format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$21d1799c6d552fc0 = 33776;
/**
 * A DXT1-compressed image in an RGB image format with a simple on/off alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$afa304c3e981b668 = 33777;
/**
 * A DXT3-compressed image in an RGBA image format. Compared to a 32-bit RGBA texture, it offers 4:1 compression.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d2a1a68024a3e56c = 33778;
/**
 * A DXT5-compressed image in an RGBA image format. It also provides a 4:1 compression, but differs to the DXT3
 * compression in how the alpha compression is done.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9a79c424327dacf9 = 33779;
/**
 * PVRTC RGB compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$19ada9bbb1af3573 = 35840;
/**
 * PVRTC RGB compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d0f0355bb3d948e4 = 35841;
/**
 * PVRTC RGBA compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b82296714358084c = 35842;
/**
 * PVRTC RGBA compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b71692456c47b6c3 = 35843;
/**
 * ETC1 RGB format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6ab91af2d757aee7 = 36196;
/**
 * ETC2 RGB format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7800993ef8106a6a = 37492;
/**
 * ETC2 RGBA format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$23ed8300a860e7d8 = 37496;
/**
 * EAC R11 UNORM format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d5c566817123b2bf = 37488; // 0x9270
/**
 * EAC R11 SNORM format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f5668dc623297d86 = 37489; // 0x9271
/**
 * EAC RG11 UNORM format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$e443ea3e1485f7bf = 37490; // 0x9272
/**
 * EAC RG11 SNORM format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$211402338cb75433 = 37491; // 0x9273
/**
 * ASTC RGBA 4x4 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$dc5570b4a2b92d48 = 37808;
/**
 * ASTC RGBA 5x4 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$68880cd325f8b2fb = 37809;
/**
 * ASTC RGBA 5x5 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7d2c0be323373d95 = 37810;
/**
 * ASTC RGBA 6x5 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$22b52da301fc3a3e = 37811;
/**
 * ASTC RGBA 6x6 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c009e2cb4a66485e = 37812;
/**
 * ASTC RGBA 8x5 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$118fff5afa255b63 = 37813;
/**
 * ASTC RGBA 8x6 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$120713c829ae0667 = 37814;
/**
 * ASTC RGBA 8x8 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c79eeabbf53313e9 = 37815;
/**
 * ASTC RGBA 10x5 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$443cf6567cdd6424 = 37816;
/**
 * ASTC RGBA 10x6 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6573984fc9840780 = 37817;
/**
 * ASTC RGBA 10x8 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$e7aee563f30091de = 37818;
/**
 * ASTC RGBA 10x10 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2eb8634622ddeab7 = 37819;
/**
 * ASTC RGBA 12x10 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$202b1ce7b5d25742 = 37820;
/**
 * ASTC RGBA 12x12 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$18ab77abd087e467 = 37821;
/**
 * BPTC RGBA format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$ce40b115e188bc81 = 36492;
/**
 * BPTC Signed RGB format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d279c5c4bac5121e = 36494;
/**
 * BPTC Unsigned RGB format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$cde52d17225fdbd3 = 36495;
/**
 * RGTC1 Red format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b1688df4c4c21670 = 36283;
/**
 * RGTC1 Signed Red format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$fc15e5d8261eed58 = 36284;
/**
 * RGTC2 Red Green format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d220f6ade8463a0f = 36285;
/**
 * RGTC2 Signed Red Green format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$768646d09dc1b6ef = 36286;
/**
 * Animations are played once.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d62fdc9d1b1cccad = 2200;
/**
 * Animations are played with a chosen number of repetitions, each time jumping from
 * the end of the clip directly to its beginning.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$dfaf4422ce096e29 = 2201;
/**
 * Animations are played with a chosen number of repetitions, alternately playing forward
 * and backward.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f8f6f2041b78e210 = 2202;
/**
 * Discrete interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$995b32462a65e855 = 2300;
/**
 * Linear interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$30fac1aace31cf4d = 2301;
/**
 * Smooth interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$198b11ff4c72bb30 = 2302;
/**
 * Zero curvature ending for animations.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7f795934b84ab523 = 2400;
/**
 * Zero slope ending for animations.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$24a4ccb5099273b5 = 2401;
/**
 * Wrap around ending for animations.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee = 2402;
/**
 * Default animation blend mode.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$bcfbbdcf8de7f8cd = 2500;
/**
 * Additive animation blend mode. Can be used to layer motions on top of
 * each other to build complex performances from smaller re-usable assets.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d875e029ef558d3 = 2501;
/**
 * For every three vertices draw a single triangle.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$4c28c87c2dc84758 = 0;
/**
 * For each vertex draw a triangle from the last three vertices.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b23a071aa286eb29 = 1;
/**
 * For each vertex draw a triangle from the first vertex and the last two vertices.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f0d8293634f88842 = 2;
/**
 * The depth value is inverted (1.0 - z) for visualization purposes.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$deeb383078690b50 = 3200;
/**
 * The depth value is packed into 32 bit RGBA.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8f910f4c4f73df11 = 3201;
/**
 * The depth value is packed into 24 bit RGB.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$be2e2ddbc3983173 = 3202;
/**
 * The depth value is packed into 16 bit RG.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1a54198784742f80 = 3203;
/**
 * Normal information is relative to the underlying surface.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2852a58ebdac27b8 = 0;
/**
 * Normal information is relative to the object orientation.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
/**
 * No color space.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$bfcb490c2dd3db51 = '';
/**
 * sRGB color space.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$561f394b24edfcaa = 'srgb';
/**
 * sRGB-linear color space.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$42429b3acfb233a4 = 'srgb-linear';
/**
 * Linear transfer function.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$f197347d588c1b4a = 'linear';
/**
 * sRGB transfer function.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$8d0a61916cc26abb = 'srgb';
/**
 * No normal map packing.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$7f96a53e6ab01dca = '';
/**
 * Normal RG packing.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$bbd2d5168fed5fd6 = 'rg';
/**
 * Normal GA packing.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$4f8d192b60f65626 = 'ga';
/**
 * Sets the stencil buffer value to `0`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$69433f11f42d5527 = 0;
/**
 * Keeps the current value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9f542ae4b5baca34 = 7680;
/**
 * Sets the stencil buffer value to the specified reference value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8a4f28336ef203d3 = 7681;
/**
 * Increments the current stencil buffer value. Clamps to the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2928c0231297c036 = 7682;
/**
 * Decrements the current stencil buffer value. Clamps to `0`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c0e9611c8a15f9a8 = 7683;
/**
 * Increments the current stencil buffer value. Wraps stencil buffer value to zero when incrementing
 * the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9c2c08927385dcc4 = 34055;
/**
 * Decrements the current stencil buffer value. Wraps stencil buffer value to the maximum representable
 * unsigned value when decrementing a stencil buffer value of `0`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7c74ea00fa1315e6 = 34056;
/**
 * Inverts the current stencil buffer value bitwise.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$22e2e5726612443 = 5386;
/**
 * Will never return true.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1343870698229224 = 512;
/**
 * Will return true if the stencil reference value is less than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8e1d8ed281997fa6 = 513;
/**
 * Will return true if the stencil reference value is equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$55648a1cde8329a7 = 514;
/**
 * Will return true if the stencil reference value is less than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2dff107857e6aca2 = 515;
/**
 * Will return true if the stencil reference value is greater than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6f93765ab2f451a2 = 516;
/**
 * Will return true if the stencil reference value is not equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6f3fb2d2440f2b76 = 517;
/**
 * Will return true if the stencil reference value is greater than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$4119cf7b4c98fd5a = 518;
/**
 * Will always return true.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$14cf96713ddd97a8 = 519;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d9e2d19a747baaab = 512;
/**
 * Pass if the incoming value is less than the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$36bcf49c713b3eb7 = 513;
/**
 * Pass if the incoming value equals the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$66f28d946fc6a0d5 = 514;
/**
 * Pass if the incoming value is less than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$64eea11eb407ddf1 = 515;
/**
 * Pass if the incoming value is greater than the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$155af022118f3a38 = 516;
/**
 * Pass if the incoming value is not equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$67ab95dde6bed156 = 517;
/**
 * Pass if the incoming value is greater than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1cdcb70d53d65f61 = 518;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$187b73a3e352c145 = 519;
/**
 * The contents are intended to be specified once by the application, and used many
 * times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$763e8360f4d7f77d = 35044;
/**
 * The contents are intended to be respecified repeatedly by the application, and
 * used many times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8505d14ac8546ca = 35048;
/**
 * The contents are intended to be specified once by the application, and used at most
 * a few times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$721e63549e51d81e = 35040;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$415731dc4f48e299 = 35045;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9e809946455f13bc = 35049;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried at most
 * a few times by the application
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2ed9499a35b5f832 = 35041;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used many times as
 * the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$32ab2503ea19469a = 35046;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and used many times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$ab4022c2c3f86315 = 35050;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used at most a few times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$ba7f1db36a76a970 = 35042;
/**
 * GLSL 1 shader code.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$43600cc67fabd9f = '100';
/**
 * GLSL 3 shader code.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$f63012db5506e7dd = '300 es';
/**
 * WebGL coordinate system.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5a0e9190d10875d3 = 2000;
/**
 * WebGPU coordinate system.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$cc83beedcb9be9ac = 2001;
/**
 * Represents the different timestamp query types.
 *
 * @type {ConstantsTimestampQuery}
 * @constant
 */ const $2358b7e4ec07df88$export$f97db56e2b647801 = {
    COMPUTE: 'compute',
    RENDER: 'render'
};
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsInterpolationSamplingType}
 * @constant
 */ const $2358b7e4ec07df88$export$ff3764a6b1cf3544 = {
    PERSPECTIVE: 'perspective',
    LINEAR: 'linear',
    FLAT: 'flat'
};
/**
 * Represents the different interpolation sampling modes.
 *
 * @type {ConstantsInterpolationSamplingMode}
 * @constant
 */ const $2358b7e4ec07df88$export$599d2e4c2d7b2a01 = {
    NORMAL: 'normal',
    CENTROID: 'centroid',
    SAMPLE: 'sample',
    FIRST: 'first',
    EITHER: 'either'
};
/**
 * This type represents mouse buttons and interaction types in context of controls.
 *
 * @typedef {Object} ConstantsMouse
 * @property {number} MIDDLE - The left mouse button.
 * @property {number} LEFT - The middle mouse button.
 * @property {number} RIGHT - The right mouse button.
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} DOLLY - A dolly interaction.
 * @property {number} PAN - A pan interaction.
 **/ /**
 * This type represents touch interaction types in context of controls.
 *
 * @typedef {Object} ConstantsTouch
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} PAN - A pan interaction.
 * @property {number} DOLLY_PAN - The dolly-pan interaction.
 * @property {number} DOLLY_ROTATE - A dolly-rotate interaction.
 **/ /**
 * This type represents the different timestamp query types.
 *
 * @typedef {Object} ConstantsTimestampQuery
 * @property {string} COMPUTE - A `compute` timestamp query.
 * @property {string} RENDER - A `render` timestamp query.
 **/ /**
 * Represents the different interpolation sampling types.
 *
 * @typedef {Object} ConstantsInterpolationSamplingType
 * @property {string} PERSPECTIVE - Perspective-correct interpolation.
 * @property {string} LINEAR - Linear interpolation.
 * @property {string} FLAT - Flat interpolation.
 */ /**
 * Represents the different interpolation sampling modes.
 *
 * @typedef {Object} ConstantsInterpolationSamplingMode
 * @property {string} NORMAL - Normal sampling mode.
 * @property {string} CENTROID - Centroid sampling mode.
 * @property {string} SAMPLE - Sample-specific sampling mode.
 * @property {string} FIRST - Flat interpolation using the first vertex.
 * @property {string} EITHER - Flat interpolation using either vertex.
 */ function $2358b7e4ec07df88$export$bc6f937da07eae17(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $2358b7e4ec07df88$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $2358b7e4ec07df88$var$getTypedArray(type, buffer) {
    return new $2358b7e4ec07df88$var$TYPED_ARRAYS[type](buffer);
}
/**
 * Returns `true` if the given object is a typed array.
 *
 * @param {any} array - The object to check.
 * @return {boolean} Whether the given object is a typed array.
 */ function $2358b7e4ec07df88$export$b119cc7e1840e59c(array) {
    return ArrayBuffer.isView(array) && !(array instanceof DataView);
}
function $2358b7e4ec07df88$export$7094a064528c7fee(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $2358b7e4ec07df88$export$1033a2df66368859() {
    const canvas = $2358b7e4ec07df88$export$7094a064528c7fee('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $2358b7e4ec07df88$var$_cache = {};
let $2358b7e4ec07df88$var$_setConsoleFunction = null;
function $2358b7e4ec07df88$export$702823ffb42fb3aa(fn) {
    $2358b7e4ec07df88$var$_setConsoleFunction = fn;
}
function $2358b7e4ec07df88$export$fa86edd994bb169f() {
    return $2358b7e4ec07df88$var$_setConsoleFunction;
}
function $2358b7e4ec07df88$export$bef1f36f5486a6a3(...params) {
    const message = 'THREE.' + params.shift();
    if ($2358b7e4ec07df88$var$_setConsoleFunction) $2358b7e4ec07df88$var$_setConsoleFunction('log', message, ...params);
    else console.log(message, ...params);
}
function $2358b7e4ec07df88$export$c106dd0671a0fc2d(...params) {
    const message = 'THREE.' + params.shift();
    if ($2358b7e4ec07df88$var$_setConsoleFunction) $2358b7e4ec07df88$var$_setConsoleFunction('warn', message, ...params);
    else console.warn(message, ...params);
}
function $2358b7e4ec07df88$export$a3bc9b8ed74fc(...params) {
    const message = 'THREE.' + params.shift();
    if ($2358b7e4ec07df88$var$_setConsoleFunction) $2358b7e4ec07df88$var$_setConsoleFunction('error', message, ...params);
    else console.error(message, ...params);
}
function $2358b7e4ec07df88$export$5b28268982f175ba(...params) {
    const message = params.join(' ');
    if (message in $2358b7e4ec07df88$var$_cache) return;
    $2358b7e4ec07df88$var$_cache[message] = true;
    $2358b7e4ec07df88$export$c106dd0671a0fc2d(...params);
}
function $2358b7e4ec07df88$export$d43f91ebeafb2c7(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
/**
 * This modules allows to dispatch event objects on custom JavaScript objects.
 *
 * Main repository: [eventdispatcher.js](https://github.com/mrdoob/eventdispatcher.js/)
 *
 * Code Example:
 * ```js
 * class Car extends EventDispatcher {
 * 	start() {
 *		this.dispatchEvent( { type: 'start', message: 'vroom vroom!' } );
 *	}
 *};
 *
 * // Using events with the custom object
 * const car = new Car();
 * car.addEventListener( 'start', function ( event ) {
 * 	alert( event.message );
 * } );
 *
 * car.start();
 * ```
 */ class $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Adds the given event listener to the given event type.
	 *
	 * @param {string} type - The type of event to listen to.
	 * @param {Function} listener - The function that gets called when the event is fired.
	 */ addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    /**
	 * Returns `true` if the given event listener has been added to the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to check.
	 * @return {boolean} Whether the given event listener has been added to the given event type.
	 */ hasEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return false;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    /**
	 * Removes the given event listener from the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to remove.
	 */ removeEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
	 * Dispatches an event object.
	 *
	 * @param {Object} event - The event that gets fired.
	 */ dispatchEvent(event) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $2358b7e4ec07df88$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $2358b7e4ec07df88$var$_seed = 1234567;
const $2358b7e4ec07df88$var$DEG2RAD = Math.PI / 180;
const $2358b7e4ec07df88$export$914076c8150813e5 = 180 / Math.PI;
/**
 * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
 * (universally unique identifier).
 *
 * @return {string} The UUID.
 */ function $2358b7e4ec07df88$var$generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $2358b7e4ec07df88$var$_lut[d0 & 0xff] + $2358b7e4ec07df88$var$_lut[d0 >> 8 & 0xff] + $2358b7e4ec07df88$var$_lut[d0 >> 16 & 0xff] + $2358b7e4ec07df88$var$_lut[d0 >> 24 & 0xff] + '-' + $2358b7e4ec07df88$var$_lut[d1 & 0xff] + $2358b7e4ec07df88$var$_lut[d1 >> 8 & 0xff] + '-' + $2358b7e4ec07df88$var$_lut[d1 >> 16 & 0x0f | 0x40] + $2358b7e4ec07df88$var$_lut[d1 >> 24 & 0xff] + '-' + $2358b7e4ec07df88$var$_lut[d2 & 0x3f | 0x80] + $2358b7e4ec07df88$var$_lut[d2 >> 8 & 0xff] + '-' + $2358b7e4ec07df88$var$_lut[d2 >> 16 & 0xff] + $2358b7e4ec07df88$var$_lut[d2 >> 24 & 0xff] + $2358b7e4ec07df88$var$_lut[d3 & 0xff] + $2358b7e4ec07df88$var$_lut[d3 >> 8 & 0xff] + $2358b7e4ec07df88$var$_lut[d3 >> 16 & 0xff] + $2358b7e4ec07df88$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
/**
 * Clamps the given value between min and max.
 *
 * @param {number} value - The value to clamp.
 * @param {number} min - The min value.
 * @param {number} max - The max value.
 * @return {number} The clamped value.
 */ function $2358b7e4ec07df88$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Computes the Euclidean modulo of the given parameters that
 * is `( ( n % m ) + m ) % m`.
 *
 * @param {number} n - The first parameter.
 * @param {number} m - The second parameter.
 * @return {number} The Euclidean modulo.
 */ function $2358b7e4ec07df88$var$euclideanModulo(n, m) {
    // https://en.wikipedia.org/wiki/Modulo_operation
    return (n % m + m) % m;
}
/**
 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
 * for the given value.
 *
 * @param {number} x - The value to be mapped.
 * @param {number} a1 - Minimum value for range A.
 * @param {number} a2 - Maximum value for range A.
 * @param {number} b1 - Minimum value for range B.
 * @param {number} b2 - Maximum value for range B.
 * @return {number} The mapped value.
 */ function $2358b7e4ec07df88$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
/**
 * Returns the percentage in the closed interval `[0, 1]` of the given value
 * between the start and end point.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} value - A value between start and end.
 * @return {number} The interpolation factor.
 */ function $2358b7e4ec07df88$var$inverseLerp(x, y, value) {
    // https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
/**
 * Returns a value linearly interpolated from two known points based on the given interval -
 * `t = 0` will return `x` and `t = 1` will return `y`.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
 * @return {number} The interpolated value.
 */ function $2358b7e4ec07df88$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
/**
 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
 * time to maintain frame rate independent movement. For details, see
 * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
 *
 * @param {number} x - The current point.
 * @param {number} y - The target point.
 * @param {number} lambda - A higher lambda value will make the movement more sudden,
 * and a lower value will make the movement more gradual.
 * @param {number} dt - Delta time in seconds.
 * @return {number} The interpolated value.
 */ function $2358b7e4ec07df88$var$damp(x, y, lambda, dt) {
    return $2358b7e4ec07df88$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
/**
 * Returns a value that alternates between `0` and the given `length` parameter.
 *
 * @param {number} x - The value to pingpong.
 * @param {number} [length=1] - The positive value the function will pingpong to.
 * @return {number} The alternated value.
 */ function $2358b7e4ec07df88$var$pingpong(x, length = 1) {
    // https://www.desmos.com/calculator/vcsjnyz7x4
    return length - Math.abs($2358b7e4ec07df88$var$euclideanModulo(x, length * 2) - length);
}
/**
 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
 * the `min` and `max`.
 *
 * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $2358b7e4ec07df88$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
/**
 * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $2358b7e4ec07df88$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
/**
 * Returns a random integer from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random integer.
 */ function $2358b7e4ec07df88$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
/**
 * Returns a random float from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random float.
 */ function $2358b7e4ec07df88$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
/**
 * Returns a random integer from `<-range/2, range/2>` interval.
 *
 * @param {number} range - Defines the value range.
 * @return {number} A random float.
 */ function $2358b7e4ec07df88$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
/**
 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
 *
 * @param {number} [s] - The integer seed.
 * @return {number} A random float.
 */ function $2358b7e4ec07df88$var$seededRandom(s) {
    if (s !== undefined) $2358b7e4ec07df88$var$_seed = s;
    // Mulberry32 generator
    let t = $2358b7e4ec07df88$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
/**
 * Converts degrees to radians.
 *
 * @param {number} degrees - A value in degrees.
 * @return {number} The converted value in radians.
 */ function $2358b7e4ec07df88$var$degToRad(degrees) {
    return degrees * $2358b7e4ec07df88$var$DEG2RAD;
}
/**
 * Converts radians to degrees.
 *
 * @param {number} radians - A value in radians.
 * @return {number} The converted value in degrees.
 */ function $2358b7e4ec07df88$var$radToDeg(radians) {
    return radians * $2358b7e4ec07df88$export$914076c8150813e5;
}
/**
 * Returns `true` if the given number is a power of two.
 *
 * @param {number} value - The value to check.
 * @return {boolean} Whether the given number is a power of two or not.
 */ function $2358b7e4ec07df88$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
/**
 * Returns the smallest power of two that is greater than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The smallest power of two that is greater than or equal to the given number.
 */ function $2358b7e4ec07df88$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
/**
 * Returns the largest power of two that is less than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The largest power of two that is less than or equal to the given number.
 */ function $2358b7e4ec07df88$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
/**
 * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
 * defined by the given angles and order.
 *
 * Rotations are applied to the axes in the order specified by order:
 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
 *
 * @param {Quaternion} q - The quaternion to set.
 * @param {number} a - The rotation applied to the first axis, in radians.
 * @param {number} b - The rotation applied to the second axis, in radians.
 * @param {number} c - The rotation applied to the third axis, in radians.
 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
 */ function $2358b7e4ec07df88$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
/**
 * Denormalizes the given value according to the given typed array.
 *
 * @param {number} value - The value to denormalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The denormalize (float) value in the range `[0,1]`.
 */ function $2358b7e4ec07df88$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * Normalizes the given value according to the given typed array.
 *
 * @param {number} value - The float value in the range `[0,1]` to normalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The normalize value.
 */ function $2358b7e4ec07df88$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * @class
 * @classdesc A collection of math utility functions.
 * @hideconstructor
 */ const $2358b7e4ec07df88$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $2358b7e4ec07df88$var$DEG2RAD,
    RAD2DEG: $2358b7e4ec07df88$export$914076c8150813e5,
    /**
	 * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
	 * (universally unique identifier).
	 *
	 * @static
	 * @method
	 * @return {string} The UUID.
	 */ generateUUID: $2358b7e4ec07df88$var$generateUUID,
    /**
	 * Clamps the given value between min and max.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to clamp.
	 * @param {number} min - The min value.
	 * @param {number} max - The max value.
	 * @return {number} The clamped value.
	 */ clamp: $2358b7e4ec07df88$var$clamp,
    /**
	 * Computes the Euclidean modulo of the given parameters that
	 * is `( ( n % m ) + m ) % m`.
	 *
	 * @static
	 * @method
	 * @param {number} n - The first parameter.
	 * @param {number} m - The second parameter.
	 * @return {number} The Euclidean modulo.
	 */ euclideanModulo: $2358b7e4ec07df88$var$euclideanModulo,
    /**
	 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
	 * for the given value.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to be mapped.
	 * @param {number} a1 - Minimum value for range A.
	 * @param {number} a2 - Maximum value for range A.
	 * @param {number} b1 - Minimum value for range B.
	 * @param {number} b2 - Maximum value for range B.
	 * @return {number} The mapped value.
	 */ mapLinear: $2358b7e4ec07df88$var$mapLinear,
    /**
	 * Returns the percentage in the closed interval `[0, 1]` of the given value
	 * between the start and end point.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} value - A value between start and end.
	 * @return {number} The interpolation factor.
	 */ inverseLerp: $2358b7e4ec07df88$var$inverseLerp,
    /**
	 * Returns a value linearly interpolated from two known points based on the given interval -
	 * `t = 0` will return `x` and `t = 1` will return `y`.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {number} The interpolated value.
	 */ lerp: $2358b7e4ec07df88$var$lerp,
    /**
	 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
	 * time to maintain frame rate independent movement. For details, see
	 * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
	 *
	 * @static
	 * @method
	 * @param {number} x - The current point.
	 * @param {number} y - The target point.
	 * @param {number} lambda - A higher lambda value will make the movement more sudden,
	 * and a lower value will make the movement more gradual.
	 * @param {number} dt - Delta time in seconds.
	 * @return {number} The interpolated value.
	 */ damp: $2358b7e4ec07df88$var$damp,
    /**
	 * Returns a value that alternates between `0` and the given `length` parameter.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to pingpong.
	 * @param {number} [length=1] - The positive value the function will pingpong to.
	 * @return {number} The alternated value.
	 */ pingpong: $2358b7e4ec07df88$var$pingpong,
    /**
	 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
	 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
	 * the `min` and `max`.
	 *
	 * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smoothstep: $2358b7e4ec07df88$var$smoothstep,
    /**
	 * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
	 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smootherstep: $2358b7e4ec07df88$var$smootherstep,
    /**
	 * Returns a random integer from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random integer.
	 */ randInt: $2358b7e4ec07df88$var$randInt,
    /**
	 * Returns a random float from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random float.
	 */ randFloat: $2358b7e4ec07df88$var$randFloat,
    /**
	 * Returns a random integer from `<-range/2, range/2>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} range - Defines the value range.
	 * @return {number} A random float.
	 */ randFloatSpread: $2358b7e4ec07df88$var$randFloatSpread,
    /**
	 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
	 *
	 * @static
	 * @method
	 * @param {number} [s] - The integer seed.
	 * @return {number} A random float.
	 */ seededRandom: $2358b7e4ec07df88$var$seededRandom,
    /**
	 * Converts degrees to radians.
	 *
	 * @static
	 * @method
	 * @param {number} degrees - A value in degrees.
	 * @return {number} The converted value in radians.
	 */ degToRad: $2358b7e4ec07df88$var$degToRad,
    /**
	 * Converts radians to degrees.
	 *
	 * @static
	 * @method
	 * @param {number} radians - A value in radians.
	 * @return {number} The converted value in degrees.
	 */ radToDeg: $2358b7e4ec07df88$var$radToDeg,
    /**
	 * Returns `true` if the given number is a power of two.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to check.
	 * @return {boolean} Whether the given number is a power of two or not.
	 */ isPowerOfTwo: $2358b7e4ec07df88$var$isPowerOfTwo,
    /**
	 * Returns the smallest power of two that is greater than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The smallest power of two that is greater than or equal to the given number.
	 */ ceilPowerOfTwo: $2358b7e4ec07df88$var$ceilPowerOfTwo,
    /**
	 * Returns the largest power of two that is less than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The largest power of two that is less than or equal to the given number.
	 */ floorPowerOfTwo: $2358b7e4ec07df88$var$floorPowerOfTwo,
    /**
	 * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
	 * defined by the given angles and order.
	 *
	 * Rotations are applied to the axes in the order specified by order:
	 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
	 *
	 * @static
	 * @method
	 * @param {Quaternion} q - The quaternion to set.
	 * @param {number} a - The rotation applied to the first axis, in radians.
	 * @param {number} b - The rotation applied to the second axis, in radians.
	 * @param {number} c - The rotation applied to the third axis, in radians.
	 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
	 */ setQuaternionFromProperEuler: $2358b7e4ec07df88$var$setQuaternionFromProperEuler,
    /**
	 * Normalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The float value in the range `[0,1]` to normalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The normalize value.
	 */ normalize: $2358b7e4ec07df88$var$normalize,
    /**
	 * Denormalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to denormalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The denormalize (float) value in the range `[0,1]`.
	 */ denormalize: $2358b7e4ec07df88$var$denormalize
};
/**
 * Class representing a 2D vector. A 2D vector is an ordered pair of numbers
 * (labeled x and y), which can be used to represent a number of things, such as:
 *
 * - A point in 2D space (i.e. a position on a plane).
 * - A direction and length across a plane. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0)` to `(x, y)`
 * and the direction is also measured from `(0, 0)` towards `(x, y)`.
 * - Any arbitrary ordered pair of numbers.
 *
 * There are other things a 2D vector can be used to represent, such as
 * momentum vectors, complex numbers and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector2( 0, 1 );
 *
 * //no arguments; will be initialised to (0, 0)
 * const b = new THREE.Vector2( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $2358b7e4ec07df88$export$c977b3e384af9ae1 {
    /**
	 * Constructs a new 2D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 */ constructor(x = 0, y = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$c977b3e384af9ae1.prototype.isVector2 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
    }
    /**
	 * Alias for {@link Vector2#x}.
	 *
	 * @type {number}
	 */ get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    /**
	 * Alias for {@link Vector2#y}.
	 *
	 * @type {number}
	 */ get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @return {Vector2} A reference to this vector.
	 */ set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector2} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @param {number} value - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector2} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to copy.
	 * @return {Vector2} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to add.
	 * @return {Vector2} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector2} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector2} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector2} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector2} v - The vector to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector2} v - The vector to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Multiplies this vector (with an implicit 1 as the 3rd component) by
	 * the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {Vector2} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the given vector's x or y
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is less than the given vector's x or y
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the max vector's x or y
	 * value, it is replaced by the corresponding value.
	 * If this vector's x or y value is less than the min vector's x or y value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector2} min - The minimum x and y values.
	 * @param {Vector2} max - The maximum x and y values in the desired range.
	 * @return {Vector2} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $2358b7e4ec07df88$var$clamp(this.x, min.x, max.x);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, min.y, max.y);
        return this;
    }
    /**
	 * If this vector's x or y values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x or y values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $2358b7e4ec07df88$var$clamp(this.x, minVal, maxVal);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($2358b7e4ec07df88$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector2} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x and y = -y.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the cross product with.
	 * @return {number} The result of the cross product.
	 */ cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Computes the angle in radians of this vector with respect to the positive x-axis.
	 *
	 * @return {number} The angle in radians.
	 */ angle() {
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector2} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($2358b7e4ec07df88$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector2} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector2} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector2} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector2} v1 - The first vector.
	 * @param {Vector2} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector2} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]` and y
	 * value to be `array[ offset + 1 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector2} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector2} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    /**
	 * Rotates this vector around the given center by the given angle.
	 *
	 * @param {Vector2} center - The point around which to rotate.
	 * @param {number} angle - The angle to rotate, in radians.
	 * @return {Vector2} A reference to this vector.
	 */ rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
/**
 * Class for representing a Quaternion. Quaternions are used in three.js to represent rotations.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 *
 * Note that three.js expects Quaternions to be normalized.
 * ```js
 * const quaternion = new THREE.Quaternion();
 * quaternion.setFromAxisAngle( new THREE.Vector3( 0, 1, 0 ), Math.PI / 2 );
 *
 * const vector = new THREE.Vector3( 1, 0, 0 );
 * vector.applyQuaternion( quaternion );
 * ```
 */ class $2358b7e4ec07df88$export$23d6a54f0bbc85a3 {
    /**
	 * Constructs a new quaternion.
	 *
	 * @param {number} [x=0] - The x value of this quaternion.
	 * @param {number} [y=0] - The y value of this quaternion.
	 * @param {number} [z=0] - The z value of this quaternion.
	 * @param {number} [w=1] - The w value of this quaternion.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    /**
	 * Interpolates between two quaternions via SLERP. This implementation assumes the
	 * quaternion data are managed in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @param {number} t - The interpolation factor in the range `[0,1]`.
	 * @see {@link Quaternion#slerp}
	 */ static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        let x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t <= 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t >= 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let dot = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1;
            if (dot < 0) {
                x1 = -x1;
                y1 = -y1;
                z1 = -z1;
                w1 = -w1;
                dot = -dot;
            }
            let s = 1 - t;
            if (dot < 0.9995) {
                // slerp
                const theta = Math.acos(dot);
                const sin = Math.sin(theta);
                s = Math.sin(s * theta) / sin;
                t = Math.sin(t * theta) / sin;
                x0 = x0 * s + x1 * t;
                y0 = y0 * s + y1 * t;
                z0 = z0 * s + z1 * t;
                w0 = w0 * s + w1 * t;
            } else {
                // for small angles, lerp then normalize
                x0 = x0 * s + x1 * t;
                y0 = y0 * s + y1 * t;
                z0 = z0 * s + z1 * t;
                w0 = w0 * s + w1 * t;
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    /**
	 * Multiplies two quaternions. This implementation assumes the quaternion data are managed
	 * in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @return {Array<number>} The destination array.
	 * @see {@link Quaternion#multiplyQuaternions}.
	 */ static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    /**
	 * The x value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The y value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The z value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * The w value of this quaternion.
	 *
	 * @type {number}
	 * @default 1
	 */ get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the quaternion components.
	 *
	 * @param {number} x - The x value of this quaternion.
	 * @param {number} y - The y value of this quaternion.
	 * @param {number} z - The z value of this quaternion.
	 * @param {number} w - The w value of this quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new quaternion with copied values from this instance.
	 *
	 * @return {Quaternion} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    /**
	 * Copies the values of the given quaternion to this instance.
	 *
	 * @param {Quaternion} quaternion - The quaternion to copy.
	 * @return {Quaternion} A reference to this quaternion.
	 */ copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the rotation specified by the given
	 * Euler angles.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                $2358b7e4ec07df88$export$c106dd0671a0fc2d('Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given axis and angle.
	 *
	 * @param {Vector3} axis - The normalized axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion to the rotation required to rotate the direction vector
	 * `vFrom` to the direction vector `vTo`.
	 *
	 * @param {Vector3} vFrom - The first (normalized) direction vector.
	 * @param {Vector3} vTo - The second (normalized) direction vector.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < 1e-8) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    /**
	 * Returns the angle between this quaternion and the given one in radians.
	 *
	 * @param {Quaternion} q - The quaternion to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(q) {
        return 2 * Math.acos(Math.abs($2358b7e4ec07df88$var$clamp(this.dot(q), -1, 1)));
    }
    /**
	 * Rotates this quaternion by a given angular step to the given quaternion.
	 * The method ensures that the final quaternion will not overshoot `q`.
	 *
	 * @param {Quaternion} q - The target quaternion.
	 * @param {number} step - The angular step in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    /**
	 * Sets this quaternion to the identity quaternion; that is, to the
	 * quaternion that represents "no rotation".
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ identity() {
        return this.set(0, 0, 0, 1);
    }
    /**
	 * Inverts this quaternion via {@link Quaternion#conjugate}. The
	 * quaternion is assumed to have unit length.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ invert() {
        return this.conjugate();
    }
    /**
	 * Returns the rotational conjugate of this quaternion. The conjugate of a
	 * quaternion represents the same rotation in the opposite direction about
	 * the rotational axis.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Calculates the dot product of this quaternion and the given one.
	 *
	 * @param {Quaternion} v - The quaternion to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    /**
	 * Computes the squared Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector. This can be useful if you are comparing the
	 * lengths of two quaternions, as this is a slightly more efficient calculation than
	 * {@link Quaternion#length}.
	 *
	 * @return {number} The squared Euclidean length.
	 */ lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
	 * Computes the Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector.
	 *
	 * @return {number} The Euclidean length.
	 */ length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    /**
	 * Normalizes this quaternion - that is, calculated the quaternion that performs
	 * the same rotation as this one, but has a length equal to `1`.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    /**
	 * Pre-multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    /**
	 * Multiplies the given quaternions and stores the result in this instance.
	 *
	 * @param {Quaternion} a - The first quaternion.
	 * @param {Quaternion} b - The second quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between quaternions.
	 *
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerp(qb, t) {
        if (t <= 0) return this;
        if (t >= 1) return this.copy(qb); // copy calls _onChangeCallback()
        let x = qb._x, y = qb._y, z = qb._z, w = qb._w;
        let dot = this.dot(qb);
        if (dot < 0) {
            x = -x;
            y = -y;
            z = -z;
            w = -w;
            dot = -dot;
        }
        let s = 1 - t;
        if (dot < 0.9995) {
            // slerp
            const theta = Math.acos(dot);
            const sin = Math.sin(theta);
            s = Math.sin(s * theta) / sin;
            t = Math.sin(t * theta) / sin;
            this._x = this._x * s + x * t;
            this._y = this._y * s + y * t;
            this._z = this._z * s + z * t;
            this._w = this._w * s + w * t;
            this._onChangeCallback();
        } else {
            // for small angles, lerp then normalize
            this._x = this._x * s + x * t;
            this._y = this._y * s + y * t;
            this._z = this._z * s + z * t;
            this._w = this._w * s + w * t;
            this.normalize(); // normalize calls _onChangeCallback()
        }
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between the given quaternions
	 * and stores the result in this quaternion.
	 *
	 * @param {Quaternion} qa - The source quaternion.
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    /**
	 * Sets this quaternion to a uniformly random, normalized quaternion.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ random() {
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    /**
	 * Returns `true` if this quaternion is equal with the given one.
	 *
	 * @param {Quaternion} quaternion - The quaternion to test for equality.
	 * @return {boolean} Whether this quaternion is equal with the given one.
	 */ equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    /**
	 * Sets this quaternion's components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the quaternion component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this quaternion to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The quaternion components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    /**
	 * Sets the components of this quaternion from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
	 * @param {number} index - The index into the attribute.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the
	 * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
	 *
	 * @return {Array<number>} The serialized quaternion.
	 */ toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
/**
 * Class representing a 3D vector. A 3D vector is an ordered triplet of numbers
 * (labeled x, y and z), which can be used to represent a number of things, such as:
 *
 * - A point in 3D space.
 * - A direction and length in 3D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0)` to `(x, y, z)`
 * and the direction is also measured from `(0, 0, 0)` towards `(x, y, z)`.
 * - Any arbitrary ordered triplet of numbers.
 *
 * There are other things a 3D vector can be used to represent, such as
 * momentum vectors and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y, z)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector3( 0, 1, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0)
 * const b = new THREE.Vector3( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $2358b7e4ec07df88$export$64b5c384219d3699 {
    /**
	 * Constructs a new 3D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 */ constructor(x = 0, y = 0, z = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$64b5c384219d3699.prototype.isVector3 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @return {Vector3} A reference to this vector.
	 */ set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector3} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @param {number} value - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector3} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to copy.
	 * @return {Vector3} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to add.
	 * @return {Vector3} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector3} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector3} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector3} v - The vector to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    /**
	 * Multiplies the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    /**
	 * Applies the given Euler rotation to this vector.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Vector3} A reference to this vector.
	 */ applyEuler(euler) {
        return this.applyQuaternion($2358b7e4ec07df88$var$_quaternion$4.setFromEuler(euler));
    }
    /**
	 * Applies a rotation specified by an axis and an angle to this vector.
	 *
	 * @param {Vector3} axis - A normalized vector representing the rotation axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ applyAxisAngle(axis, angle) {
        return this.applyQuaternion($2358b7e4ec07df88$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    /**
	 * Multiplies this vector with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    /**
	 * Multiplies this vector by the given normal matrix and normalizes
	 * the result.
	 *
	 * @param {Matrix3} m - The normal matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    /**
	 * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
	 * divides by perspective.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    /**
	 * Applies the given Quaternion to this vector.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Vector3} A reference to this vector.
	 */ applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    /**
	 * Projects this vector from world space into the camera's normalized
	 * device coordinate (NDC) space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    /**
	 * Unprojects this vector from the camera's normalized device coordinate (NDC)
	 * space into world space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    /**
	 * Transforms the direction of this vector by a matrix (the upper left 3 x 3
	 * subset of the given 4x4 matrix and then normalizes the result.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Vector3} A reference to this vector.
	 */ transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector3} v - The vector to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * If this vector's x, y or z value is greater than the given vector's x, y or z
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is less than the given vector's x, y or z
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is greater than the max vector's x, y or z
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y or z value is less than the min vector's x, y or z value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector3} min - The minimum x, y and z values.
	 * @param {Vector3} max - The maximum x, y and z values in the desired range.
	 * @return {Vector3} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $2358b7e4ec07df88$var$clamp(this.x, min.x, max.x);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, min.y, max.y);
        this.z = $2358b7e4ec07df88$var$clamp(this.z, min.z, max.z);
        return this;
    }
    /**
	 * If this vector's x, y or z values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y or z values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $2358b7e4ec07df88$var$clamp(this.x, minVal, maxVal);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, minVal, maxVal);
        this.z = $2358b7e4ec07df88$var$clamp(this.z, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($2358b7e4ec07df88$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector3} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector3} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector3} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector3} v1 - The first vector.
	 * @param {Vector3} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the cross product with.
	 * @return {Vector3} The result of the cross product.
	 */ cross(v) {
        return this.crossVectors(this, v);
    }
    /**
	 * Calculates the cross product of the given vectors and stores the result
	 * in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    /**
	 * Projects this vector onto the given one.
	 *
	 * @param {Vector3} v - The vector to project to.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    /**
	 * Projects this vector onto a plane by subtracting this
	 * vector projected onto the plane's normal from this vector.
	 *
	 * @param {Vector3} planeNormal - The plane normal.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnPlane(planeNormal) {
        $2358b7e4ec07df88$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($2358b7e4ec07df88$var$_vector$c);
    }
    /**
	 * Reflects this vector off a plane orthogonal to the given normal vector.
	 *
	 * @param {Vector3} normal - The (normalized) normal vector.
	 * @return {Vector3} A reference to this vector.
	 */ reflect(normal) {
        return this.sub($2358b7e4ec07df88$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector3} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($2358b7e4ec07df88$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector3} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {Spherical} s - The spherical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The phi angle in radians.
	 * @param {number} theta - The theta angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {Cylindrical} c - The cylindrical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle in radians.
	 * @param {number} y - The y value.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    /**
	 * Sets the vector components to the scale elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    /**
	 * Sets the vector components from the given Euler angles.
	 *
	 * @param {Euler} e - The Euler angles to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    /**
	 * Sets the vector components from the RGB components of the
	 * given color.
	 *
	 * @param {Color} c - The color to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector3} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
	 * and z value to be `array[ offset + 2 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector3} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector3} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    /**
	 * Sets this vector to a uniformly random point on a unit sphere.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $2358b7e4ec07df88$var$_vector$c = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_quaternion$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
/**
 * Represents a 3x3 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix();
 * m.set( 11, 12, 13,
 *        21, 22, 23,
 *        31, 32, 33 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31,
 *                12, 22, 32,
 *                13, 23, 33 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $2358b7e4ec07df88$export$8ff26dafa08918 {
    /**
	 * Constructs a new 3x3 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 */ constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$8ff26dafa08918.prototype.isMatrix3 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @return {Matrix3} A reference to this matrix.
	 */ set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    /**
	 * Sets this matrix to the 3x3 identity matrix.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix3} m - The matrix to copy.
	 * @return {Matrix3} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    /**
	 * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 3x3 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix3} a - The first matrix.
	 * @param {Matrix3} b - The second matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    /**
	 * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    /**
	 * Computes the normal matrix which is the inverse transpose of the upper
	 * left 3x3 portion of the given 4x4 matrix.
	 *
	 * @param {Matrix4} matrix4 - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    /**
	 * Transposes this matrix into the supplied array, and returns itself unchanged.
	 *
	 * @param {Array<number>} r - An array to store the transposed matrix elements.
	 * @return {Matrix3} A reference to this matrix.
	 */ transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    /**
	 * Sets the UV transform matrix from offset, repeat, rotation, and center.
	 *
	 * @param {number} tx - Offset x.
	 * @param {number} ty - Offset y.
	 * @param {number} sx - Repeat x.
	 * @param {number} sy - Repeat y.
	 * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
	 * @param {number} cx - Center x of rotation.
	 * @param {number} cy - Center y of rotation
	 * @return {Matrix3} A reference to this matrix.
	 */ setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    /**
	 * Scales this matrix with the given scalar values.
	 *
	 * @param {number} sx - The amount to scale in the X axis.
	 * @param {number} sy - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ scale(sx, sy) {
        this.premultiply($2358b7e4ec07df88$var$_m3.makeScale(sx, sy));
        return this;
    }
    /**
	 * Rotates this matrix by the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ rotate(theta) {
        this.premultiply($2358b7e4ec07df88$var$_m3.makeRotation(-theta));
        return this;
    }
    /**
	 * Translates this matrix by the given scalar values.
	 *
	 * @param {number} tx - The amount to translate in the X axis.
	 * @param {number} ty - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ translate(tx, ty) {
        this.premultiply($2358b7e4ec07df88$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    /**
	 * Sets this matrix as a 2D translation transform.
	 *
	 * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D rotational transformation.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D scale transform.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix3} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix3} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix3} A clone of this instance.
	 */ clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $2358b7e4ec07df88$var$_m3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$8ff26dafa08918();
const $2358b7e4ec07df88$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new $2358b7e4ec07df88$export$8ff26dafa08918().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
const $2358b7e4ec07df88$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new $2358b7e4ec07df88$export$8ff26dafa08918().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function $2358b7e4ec07df88$var$createColorManagement() {
    const ColorManagement = {
        enabled: true,
        workingColorSpace: $2358b7e4ec07df88$export$42429b3acfb233a4,
        /**
		 * Implementations of supported color spaces.
		 *
		 * Required:
		 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
		 *	- whitePoint: reference white [ x y ]
		 *	- transfer: transfer function (pre-defined)
		 *	- toXYZ: Matrix3 RGB to XYZ transform
		 *	- fromXYZ: Matrix3 XYZ to RGB transform
		 *	- luminanceCoefficients: RGB luminance coefficients
		 *
		 * Optional:
		 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace, toneMappingMode: 'extended' | 'standard' }
		 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
		 *
		 * Reference:
		 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
		 */ spaces: {},
        convert: function(color, sourceColorSpace, targetColorSpace) {
            if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
            if (this.spaces[sourceColorSpace].transfer === $2358b7e4ec07df88$export$8d0a61916cc26abb) {
                color.r = $2358b7e4ec07df88$var$SRGBToLinear(color.r);
                color.g = $2358b7e4ec07df88$var$SRGBToLinear(color.g);
                color.b = $2358b7e4ec07df88$var$SRGBToLinear(color.b);
            }
            if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
                color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
                color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
            }
            if (this.spaces[targetColorSpace].transfer === $2358b7e4ec07df88$export$8d0a61916cc26abb) {
                color.r = $2358b7e4ec07df88$var$LinearToSRGB(color.r);
                color.g = $2358b7e4ec07df88$var$LinearToSRGB(color.g);
                color.b = $2358b7e4ec07df88$var$LinearToSRGB(color.b);
            }
            return color;
        },
        workingToColorSpace: function(color, targetColorSpace) {
            return this.convert(color, this.workingColorSpace, targetColorSpace);
        },
        colorSpaceToWorking: function(color, sourceColorSpace) {
            return this.convert(color, sourceColorSpace, this.workingColorSpace);
        },
        getPrimaries: function(colorSpace) {
            return this.spaces[colorSpace].primaries;
        },
        getTransfer: function(colorSpace) {
            if (colorSpace === $2358b7e4ec07df88$export$bfcb490c2dd3db51) return $2358b7e4ec07df88$export$f197347d588c1b4a;
            return this.spaces[colorSpace].transfer;
        },
        getToneMappingMode: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.toneMappingMode || 'standard';
        },
        getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
            return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
        },
        define: function(colorSpaces) {
            Object.assign(this.spaces, colorSpaces);
        },
        // Internal APIs
        _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
            return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
            return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
        },
        // Deprecated
        fromWorkingColorSpace: function(color, targetColorSpace) {
            $2358b7e4ec07df88$export$5b28268982f175ba('ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().'); // @deprecated, r177
            return ColorManagement.workingToColorSpace(color, targetColorSpace);
        },
        toWorkingColorSpace: function(color, sourceColorSpace) {
            $2358b7e4ec07df88$export$5b28268982f175ba('ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().'); // @deprecated, r177
            return ColorManagement.colorSpaceToWorking(color, sourceColorSpace);
        }
    };
    /******************************************************************************
	 * sRGB definitions
	 */ const REC709_PRIMARIES = [
        0.640,
        0.330,
        0.300,
        0.600,
        0.150,
        0.060
    ];
    const REC709_LUMINANCE_COEFFICIENTS = [
        0.2126,
        0.7152,
        0.0722
    ];
    const D65 = [
        0.3127,
        0.3290
    ];
    ColorManagement.define({
        [$2358b7e4ec07df88$export$42429b3acfb233a4]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $2358b7e4ec07df88$export$f197347d588c1b4a,
            toXYZ: $2358b7e4ec07df88$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $2358b7e4ec07df88$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            workingColorSpaceConfig: {
                unpackColorSpace: $2358b7e4ec07df88$export$561f394b24edfcaa
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $2358b7e4ec07df88$export$561f394b24edfcaa
            }
        },
        [$2358b7e4ec07df88$export$561f394b24edfcaa]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $2358b7e4ec07df88$export$8d0a61916cc26abb,
            toXYZ: $2358b7e4ec07df88$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $2358b7e4ec07df88$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $2358b7e4ec07df88$export$561f394b24edfcaa
            }
        }
    });
    return ColorManagement;
}
const $2358b7e4ec07df88$export$5e6fd513f44698c = /*@__PURE__*/ $2358b7e4ec07df88$var$createColorManagement();
function $2358b7e4ec07df88$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $2358b7e4ec07df88$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $2358b7e4ec07df88$var$_canvas;
/**
 * A class containing utility functions for images.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$698882cf06df44aa {
    /**
	 * Returns a data URI containing a representation of the given image.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
	 * @param {string} [type='image/png'] - Indicates the image format.
	 * @return {string} The data URI.
	 */ static getDataURL(image, type = 'image/png') {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($2358b7e4ec07df88$var$_canvas === undefined) $2358b7e4ec07df88$var$_canvas = $2358b7e4ec07df88$export$7094a064528c7fee('canvas');
            $2358b7e4ec07df88$var$_canvas.width = image.width;
            $2358b7e4ec07df88$var$_canvas.height = image.height;
            const context = $2358b7e4ec07df88$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $2358b7e4ec07df88$var$_canvas;
        }
        return canvas.toDataURL(type);
    }
    /**
	 * Converts the given sRGB image data to linear color space.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
	 * @return {HTMLCanvasElement|Object} The converted image.
	 */ static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $2358b7e4ec07df88$export$7094a064528c7fee('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $2358b7e4ec07df88$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($2358b7e4ec07df88$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $2358b7e4ec07df88$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $2358b7e4ec07df88$var$_sourceId = 0;
/**
 * Represents the data source of a texture.
 *
 * The main purpose of this class is to decouple the data definition from the texture
 * definition so the same data can be used with multiple texture instances.
 */ class $2358b7e4ec07df88$export$1d2df86270c81ecb {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {any} [data=null] - The data definition of a texture.
	 */ constructor(data = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSource = true;
        /**
		 * The ID of the source.
		 *
		 * @name Source#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_sourceId++
        });
        /**
		 * The UUID of the source.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * The data definition of a texture.
		 *
		 * @type {any}
		 */ this.data = data;
        /**
		 * This property is only relevant when {@link Source#needsUpdate} is set to `true` and
		 * provides more control on how texture data should be processed. When `dataReady` is set
		 * to `false`, the engine performs the memory allocation (if necessary) but does not transfer
		 * the data into the GPU memory.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.dataReady = true;
        /**
		 * This starts at `0` and counts how many times {@link Source#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
    }
    /**
	 * Returns the dimensions of the source into the given target vector.
	 *
	 * @param {(Vector2|Vector3)} target - The target object the result is written into.
	 * @return {(Vector2|Vector3)} The dimensions of the source.
	 */ getSize(target) {
        const data = this.data;
        if (typeof HTMLVideoElement !== 'undefined' && data instanceof HTMLVideoElement) target.set(data.videoWidth, data.videoHeight, 0);
        else if (typeof VideoFrame !== 'undefined' && data instanceof VideoFrame) target.set(data.displayHeight, data.displayWidth, 0);
        else if (data !== null) target.set(data.width, data.height, data.depth || 0);
        else target.set(0, 0, 0);
        return target;
    }
    /**
	 * When the property is set to `true`, the engine allocates the memory
	 * for the texture (if necessary) and triggers the actual texture upload
	 * to the GPU next time the source is used.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Serializes the source into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized source.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($2358b7e4ec07df88$var$serializeImage(data[i].image));
                else url.push($2358b7e4ec07df88$var$serializeImage(data[i]));
            } else // texture
            url = $2358b7e4ec07df88$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $2358b7e4ec07df88$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $2358b7e4ec07df88$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $2358b7e4ec07df88$var$_textureId = 0;
const $2358b7e4ec07df88$var$_tempVec3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Base class for all textures.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$5431306cf43de24a extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(image = $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $2358b7e4ec07df88$export$9d9334239a5a5e06, wrapT = $2358b7e4ec07df88$export$9d9334239a5a5e06, magFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8, minFilter = $2358b7e4ec07df88$export$5d8599b6a933fb1b, format = $2358b7e4ec07df88$export$3f8bb04b555a363c, type = $2358b7e4ec07df88$export$2e8ce08d3f6f5e10, anisotropy = $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace = $2358b7e4ec07df88$export$bfcb490c2dd3db51){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTexture = true;
        /**
		 * The ID of the texture.
		 *
		 * @name Texture#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_textureId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The data definition of a texture. A reference to the data source can be
		 * shared across textures. This is often useful in context of spritesheets
		 * where multiple textures render the same data but with different texture
		 * transformations.
		 *
		 * @type {Source}
		 */ this.source = new $2358b7e4ec07df88$export$1d2df86270c81ecb(image);
        /**
		 * An array holding user-defined mipmaps.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = [];
        /**
		 * How the texture is applied to the object. The value `UVMapping`
		 * is the default, where texture or uv coordinates are used to apply the map.
		 *
		 * @type {(UVMapping|CubeReflectionMapping|CubeRefractionMapping|EquirectangularReflectionMapping|EquirectangularRefractionMapping|CubeUVReflectionMapping)}
		 * @default UVMapping
		*/ this.mapping = mapping;
        /**
		 * Lets you select the uv attribute to map the texture to. `0` for `uv`,
		 * `1` for `uv1`, `2` for `uv2` and `3` for `uv3`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.channel = 0;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *U* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapS = wrapS;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *V* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapT = wrapT;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearFilter
		 */ this.magFilter = magFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearMipmapLinearFilter
		 */ this.minFilter = minFilter;
        /**
		 * The number of samples taken along the axis through the pixel that has the
		 * highest density of texels. By default, this value is `1`. A higher value
		 * gives a less blurry result than a basic mipmap, at the cost of more
		 * texture samples being used.
		 *
		 * @type {number}
		 * @default Texture.DEFAULT_ANISOTROPY
		 */ this.anisotropy = anisotropy;
        /**
		 * The format of the texture.
		 *
		 * @type {number}
		 * @default RGBAFormat
		 */ this.format = format;
        /**
		 * The default internal format is derived from {@link Texture#format} and {@link Texture#type} and
		 * defines how the texture data is going to be stored on the GPU.
		 *
		 * This property allows to overwrite the default format.
		 *
		 * @type {?string}
		 * @default null
		 */ this.internalFormat = null;
        /**
		 * The data type of the texture.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.type = type;
        /**
		 * How much a single repetition of the texture is offset from the beginning,
		 * in each direction U and V. Typical range is `0.0` to `1.0`.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.offset = new $2358b7e4ec07df88$export$c977b3e384af9ae1(0, 0);
        /**
		 * How many times the texture is repeated across the surface, in each
		 * direction U and V. If repeat is set greater than `1` in either direction,
		 * the corresponding wrap parameter should also be set to `RepeatWrapping`
		 * or `MirroredRepeatWrapping` to achieve the desired tiling effect.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.repeat = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The point around which rotation occurs. A value of `(0.5, 0.5)` corresponds
		 * to the center of the texture. Default is `(0, 0)`, the lower left.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.center = new $2358b7e4ec07df88$export$c977b3e384af9ae1(0, 0);
        /**
		 * How much the texture is rotated around the center point, in radians.
		 * Positive values are counter-clockwise.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Whether to update the texture's uv-transformation {@link Texture#matrix}
		 * from the properties {@link Texture#offset}, {@link Texture#repeat},
		 * {@link Texture#rotation}, and {@link Texture#center}.
		 *
		 * Set this to `false` if you are specifying the uv-transform matrix directly.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = true;
        /**
		 * The uv-transformation matrix of the texture.
		 *
		 * @type {Matrix3}
		 */ this.matrix = new $2358b7e4ec07df88$export$8ff26dafa08918();
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Set this to `false` if you are creating mipmaps manually.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.generateMipmaps = true;
        /**
		 * If set to `true`, the alpha channel, if present, is multiplied into the
		 * color channels when the texture is uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure premultiply alpha on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultiplyAlpha = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure the flip on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.flipY = true;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 * The allowable values are `1` (byte-alignment), `2` (rows aligned to even-numbered bytes),
		 * `4` (word-alignment), and `8` (rows start on double-word boundaries).
		 *
		 * @type {number}
		 * @default 4
		 */ this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        /**
		 * Textures containing color data should be annotated with `SRGBColorSpace` or `LinearSRGBColorSpace`.
		 *
		 * @type {string}
		 * @default NoColorSpace
		 */ this.colorSpace = colorSpace;
        /**
		 * An object that can be used to store custom data about the texture. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This can be used to only update a subregion or specific rows of the texture (for example, just the
		 * first 3 rows). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * This starts at `0` and counts how many times {@link Texture#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        /**
		 * A callback function, called when the texture is updated (e.g., when
		 * {@link Texture#needsUpdate} has been set to true and then the texture is used).
		 *
		 * @type {?Function}
		 * @default null
		 */ this.onUpdate = null;
        /**
		 * An optional back reference to the textures render target.
		 *
		 * @type {?(RenderTarget|WebGLRenderTarget)}
		 * @default null
		 */ this.renderTarget = null;
        /**
		 * Indicates whether a texture belongs to a render target or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isRenderTargetTexture = false;
        /**
		 * Indicates if a texture should be handled like a texture array.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isArrayTexture = image && image.depth && image.depth > 1 ? true : false;
        /**
		 * Indicates whether this texture should be processed by `PMREMGenerator` or not
		 * (only relevant for render target textures).
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.pmremVersion = 0;
    }
    /**
	 * The width of the texture in pixels.
	 */ get width() {
        return this.source.getSize($2358b7e4ec07df88$var$_tempVec3).x;
    }
    /**
	 * The height of the texture in pixels.
	 */ get height() {
        return this.source.getSize($2358b7e4ec07df88$var$_tempVec3).y;
    }
    /**
	 * The depth of the texture in pixels.
	 */ get depth() {
        return this.source.getSize($2358b7e4ec07df88$var$_tempVec3).z;
    }
    /**
	 * The image object holding the texture data.
	 *
	 * @type {?Object}
	 */ get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    /**
	 * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
	 * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
	 */ updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    /**
	 * Adds a range of data in the data texture to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Returns a new texture with copied values from this instance.
	 *
	 * @return {Texture} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given texture to this instance.
	 *
	 * @param {Texture} source - The texture to copy.
	 * @return {Texture} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.renderTarget = source.renderTarget;
        this.isRenderTargetTexture = source.isRenderTargetTexture;
        this.isArrayTexture = source.isArrayTexture;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    /**
	 * Sets this texture's properties based on `values`.
	 * @param {Object} values - A container with texture parameters.
	 */ setValues(values) {
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                $2358b7e4ec07df88$export$c106dd0671a0fc2d(`Texture.setValues(): parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                $2358b7e4ec07df88$export$c106dd0671a0fc2d(`Texture.setValues(): property '${key}' does not exist.`);
                continue;
            }
            if (currentValue && newValue && currentValue.isVector2 && newValue.isVector2) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isVector3 && newValue.isVector3) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isMatrix3 && newValue.isMatrix3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the texture into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized texture.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.7,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        /**
		 * Fires when the texture has been disposed of.
		 *
		 * @event Texture#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Transforms the given uv vector with the textures uv transformation matrix.
	 *
	 * @param {Vector2} uv - The uv vector.
	 * @return {Vector2} The transformed uv vector.
	 */ transformUv(uv) {
        if (this.mapping !== $2358b7e4ec07df88$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $2358b7e4ec07df88$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $2358b7e4ec07df88$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $2358b7e4ec07df88$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $2358b7e4ec07df88$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $2358b7e4ec07df88$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $2358b7e4ec07df88$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    /**
	 * Setting this property to `true` indicates the engine the texture
	 * must be updated in the next render. This triggers a texture upload
	 * to the GPU and ensures correct texture parameter configuration.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    /**
	 * Setting this property to `true` indicates the engine the PMREM
	 * must be regenerated.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
/**
 * The default image for all textures.
 *
 * @static
 * @type {?Image}
 * @default null
 */ $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_IMAGE = null;
/**
 * The default mapping for all textures.
 *
 * @static
 * @type {number}
 * @default UVMapping
 */ $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_MAPPING = $2358b7e4ec07df88$export$1beec6768cbb3d2d;
/**
 * The default anisotropy value for all textures.
 *
 * @static
 * @type {number}
 * @default 1
 */ $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
/**
 * Class representing a 4D vector. A 4D vector is an ordered quadruplet of numbers
 * (labeled x, y, z and w), which can be used to represent a number of things, such as:
 *
 * - A point in 4D space.
 * - A direction and length in 4D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0, 0)` to `(x, y, z, w)`
 * and the direction is also measured from `(0, 0, 0, 0)` towards `(x, y, z, w)`.
 * - Any arbitrary ordered quadruplet of numbers.
 *
 * There are other things a 4D vector can be used to represent, however these
 * are the most common uses in *three.js*.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector4( 0, 1, 0, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0, 1)
 * const b = new THREE.Vector4( );
 *
 * const d = a.dot( b );
 * ```
 */ class $2358b7e4ec07df88$export$fa7daccca11cdbe3 {
    /**
	 * Constructs a new 4D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 * @param {number} [w=1] - The w value of this vector.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
        /**
		 * The w value of this vector.
		 *
		 * @type {number}
		 */ this.w = w;
    }
    /**
	 * Alias for {@link Vector4#z}.
	 *
	 * @type {number}
	 */ get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    /**
	 * Alias for {@link Vector4#w}.
	 *
	 * @type {number}
	 */ get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @param {number} w - The value of the w component.
	 * @return {Vector4} A reference to this vector.
	 */ set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector4} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector's w component to the given value
	 *
	 * @param {number} w - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setW(w) {
        this.w = w;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @param {number} value - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector4} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector to copy.
	 * @return {Vector4} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector4} v - The vector to add.
	 * @return {Vector4} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector4} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector4} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector4} v - The vector to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    /**
	 * Multiplies this vector with the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector4} v - The vector to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the quaternion's axis and w to the angle.
	 *
	 * @param {Quaternion} q - The Quaternion to set.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the axis of rotation and w to the angle.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector4} min - The minimum x, y and z values.
	 * @param {Vector4} max - The maximum x, y and z values in the desired range.
	 * @return {Vector4} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $2358b7e4ec07df88$var$clamp(this.x, min.x, max.x);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, min.y, max.y);
        this.z = $2358b7e4ec07df88$var$clamp(this.z, min.z, max.z);
        this.w = $2358b7e4ec07df88$var$clamp(this.w, min.w, max.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y, z or w values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $2358b7e4ec07df88$var$clamp(this.x, minVal, maxVal);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, minVal, maxVal);
        this.z = $2358b7e4ec07df88$var$clamp(this.z, minVal, maxVal);
        this.w = $2358b7e4ec07df88$var$clamp(this.w, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($2358b7e4ec07df88$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector4} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector4} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector4} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector4} v1 - The first vector.
	 * @param {Vector4} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector4} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
	 * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector4} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector4} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/**
 * A render target is a buffer where the video card draws pixels for a scene
 * that is being rendered in the background. It is used in different effects,
 * such as applying postprocessing to a rendered image before displaying it
 * on the screen.
 *
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$efcb1f8bf367cbfb extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Render target options.
	 *
	 * @typedef {Object} RenderTarget~Options
	 * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
	 * @property {number} [magFilter=LinearFilter] - The mag filter.
	 * @property {number} [minFilter=LinearFilter] - The min filter.
	 * @property {number} [format=RGBAFormat] - The texture format.
	 * @property {number} [type=UnsignedByteType] - The texture type.
	 * @property {?string} [internalFormat=null] - The texture's internal format.
	 * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [anisotropy=1] - The texture's anisotropy value.
	 * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
	 * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
	 * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
	 * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
	 * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
	 * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
	 * @property {number} [samples=0] - The MSAA samples count.
	 * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
	 * @property {number} [depth=1] - The texture depth.
	 * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
	 */ /**
	 * Constructs a new render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super();
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $2358b7e4ec07df88$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: false
        }, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget = true;
        /**
		 * The width of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.width = width;
        /**
		 * The height of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.height = height;
        /**
		 * The depth of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.depth = options.depth;
        /**
		 * A rectangular area inside the render target's viewport. Fragments that are
		 * outside the area will be discarded.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.scissor = new $2358b7e4ec07df88$export$fa7daccca11cdbe3(0, 0, width, height);
        /**
		 * Indicates whether the scissor test should be enabled when rendering into
		 * this render target or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.scissorTest = false;
        /**
		 * A rectangular area representing the render target's viewport.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.viewport = new $2358b7e4ec07df88$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: options.depth
        };
        const texture = new $2358b7e4ec07df88$export$5431306cf43de24a(image);
        /**
		 * An array of textures. Each color attachment is represented as a separate texture.
		 * Has at least a single entry for the default color attachment.
		 *
		 * @type {Array<Texture>}
		 */ this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
        }
        this._setTextureOptions(options);
        /**
		 * Whether to allocate a depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthBuffer = options.depthBuffer;
        /**
		 * Whether to allocate a stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilBuffer = options.stencilBuffer;
        /**
		 * Whether to resolve the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveDepthBuffer = options.resolveDepthBuffer;
        /**
		 * Whether to resolve the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveStencilBuffer = options.resolveStencilBuffer;
        this._depthTexture = null;
        this.depthTexture = options.depthTexture;
        /**
		 * The number of MSAA samples.
		 *
		 * A value of `0` disables MSAA.
		 *
		 * @type {number}
		 * @default 0
		 */ this.samples = options.samples;
        /**
		 * Whether to this target is used in multiview rendering.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.multiview = options.multiview;
    }
    _setTextureOptions(options = {}) {
        const values = {
            minFilter: $2358b7e4ec07df88$export$8a72f490b25c56c8,
            generateMipmaps: false,
            flipY: false,
            internalFormat: null
        };
        if (options.mapping !== undefined) values.mapping = options.mapping;
        if (options.wrapS !== undefined) values.wrapS = options.wrapS;
        if (options.wrapT !== undefined) values.wrapT = options.wrapT;
        if (options.wrapR !== undefined) values.wrapR = options.wrapR;
        if (options.magFilter !== undefined) values.magFilter = options.magFilter;
        if (options.minFilter !== undefined) values.minFilter = options.minFilter;
        if (options.format !== undefined) values.format = options.format;
        if (options.type !== undefined) values.type = options.type;
        if (options.anisotropy !== undefined) values.anisotropy = options.anisotropy;
        if (options.colorSpace !== undefined) values.colorSpace = options.colorSpace;
        if (options.flipY !== undefined) values.flipY = options.flipY;
        if (options.generateMipmaps !== undefined) values.generateMipmaps = options.generateMipmaps;
        if (options.internalFormat !== undefined) values.internalFormat = options.internalFormat;
        for(let i = 0; i < this.textures.length; i++){
            const texture = this.textures[i];
            texture.setValues(values);
        }
    }
    /**
	 * The texture representing the default color attachment.
	 *
	 * @type {Texture}
	 */ get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    set depthTexture(current) {
        if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
        if (current !== null) current.renderTarget = this;
        this._depthTexture = current;
    }
    /**
	 * Instead of saving the depth in a renderbuffer, a texture
	 * can be used instead which is useful for further processing
	 * e.g. in context of post-processing.
	 *
	 * @type {?DepthTexture}
	 * @default null
	 */ get depthTexture() {
        return this._depthTexture;
    }
    /**
	 * Sets the size of this render target.
	 *
	 * @param {number} width - The width.
	 * @param {number} height - The height.
	 * @param {number} [depth=1] - The depth.
	 */ setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
                if (this.textures[i].isData3DTexture !== true) // TODO: Reconsider setting isArrayTexture flag here and in the ctor of Texture.
                // Maybe a method `isArrayTexture()` or just a getter could replace a flag since
                // both are evaluated on each call?
                this.textures[i].isArrayTexture = this.textures[i].image.depth > 1;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    /**
	 * Returns a new render target with copied values from this instance.
	 *
	 * @return {RenderTarget} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the settings of the given render target. This is a structural copy so
	 * no resources are shared between render targets after the copy. That includes
	 * all MRT textures and the depth texture.
	 *
	 * @param {RenderTarget} source - The render target to copy.
	 * @return {RenderTarget} A reference to this instance.
	 */ copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
            // ensure image object is not shared, see #20328
            const image = Object.assign({}, source.textures[i].image);
            this.textures[i].source = new $2358b7e4ec07df88$export$1d2df86270c81ecb(image);
        }
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires RenderTarget#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
/**
 * A render target used in context of {@link WebGLRenderer}.
 *
 * @augments RenderTarget
 */ class $2358b7e4ec07df88$export$3c052beb2e51e23f extends $2358b7e4ec07df88$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderTarget = true;
    }
}
/**
 * Creates an array of textures directly from raw buffer data.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$dfac6c8e811406a3 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataArrayTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $2358b7e4ec07df88$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire data texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * An array render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $2358b7e4ec07df88$export$c77a02c11ed180c7 extends $2358b7e4ec07df88$export$3c052beb2e51e23f {
    /**
	 * Constructs a new array render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new $2358b7e4ec07df88$export$dfac6c8e811406a3(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Creates a three-dimensional texture from raw data, with parameters to
 * divide it into width, height, and depth.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$d7a3086320f856db extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in Data3DTexture directly.
        //
        //	const texture = new THREE.Data3DTexture( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isData3DTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $2358b7e4ec07df88$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
/**
 * A 3D render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $2358b7e4ec07df88$export$7ee06591009639df extends $2358b7e4ec07df88$export$3c052beb2e51e23f {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $2358b7e4ec07df88$export$d7a3086320f856db(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents an axis-aligned bounding box (AABB) in 3D space.
 */ class $2358b7e4ec07df88$export$6f7d5a9418ab2aa3 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $2358b7e4ec07df88$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $2358b7e4ec07df88$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox3 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector3} min - The lower boundary of the box.
	 * @param {Vector3} max - The upper boundary of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<number>} array - An array holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($2358b7e4ec07df88$var$_vector$b.fromArray(array, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($2358b7e4ec07df88$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector3} center - The center of the box.
	 * @param {Vector3} size - The x, y and z dimensions of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $2358b7e4ec07df88$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Computes the world-axis-aligned bounding box for the given 3D object
	 * (including its children), accounting for the object's, and children's,
	 * world transforms. The function may result in a larger box than strictly necessary.
	 *
	 * @param {Object3D} object - The 3D object to compute the bounding box for.
	 * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
	 * world-axis-aligned bounding box at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box3} box - The box to copy.
	 * @return {Box3} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 3D.
	 *
	 * @return {Box3} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector3} point - The point that should be included by the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions. The depth of this box will be
	 * expanded by the z component of the vector in both directions.
	 *
	 * @param {Vector3} vector - The vector that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Expands the boundaries of this box to include the given 3D object and
	 * its children, accounting for the object's, and children's, world
	 * transforms. The function may result in a larger box than strictly
	 * necessary (unless the precise parameter is set to true).
	 *
	 * @param {Object3D} object - The 3D object that should expand the bounding box.
	 * @param {boolean} precise - If set to `true`, the method expands the bounding box
	 * as little as necessary at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $2358b7e4ec07df88$var$_vector$b);
                else $2358b7e4ec07df88$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $2358b7e4ec07df88$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($2358b7e4ec07df88$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $2358b7e4ec07df88$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $2358b7e4ec07df88$var$_box$4.copy(geometry.boundingBox);
                }
                $2358b7e4ec07df88$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($2358b7e4ec07df88$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    /**
	 * Returns a point as a proportion of this box's width, height and depth.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A point as a proportion of this box's width, height and depth.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with this bounding box.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
	 */ intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $2358b7e4ec07df88$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $2358b7e4ec07df88$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Returns `true` if the given plane intersects with this bounding box.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether the given plane intersects with this bounding box.
	 */ intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    /**
	 * Returns `true` if the given triangle intersects with this bounding box.
	 *
	 * @param {Triangle} triangle - The triangle to test.
	 * @return {boolean} Whether the given triangle intersects with this bounding box.
	 */ intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($2358b7e4ec07df88$var$_center);
        $2358b7e4ec07df88$var$_extents.subVectors(this.max, $2358b7e4ec07df88$var$_center);
        // translate triangle to aabb origin
        $2358b7e4ec07df88$var$_v0$2.subVectors(triangle.a, $2358b7e4ec07df88$var$_center);
        $2358b7e4ec07df88$var$_v1$7.subVectors(triangle.b, $2358b7e4ec07df88$var$_center);
        $2358b7e4ec07df88$var$_v2$4.subVectors(triangle.c, $2358b7e4ec07df88$var$_center);
        // compute edge vectors for triangle
        $2358b7e4ec07df88$var$_f0.subVectors($2358b7e4ec07df88$var$_v1$7, $2358b7e4ec07df88$var$_v0$2);
        $2358b7e4ec07df88$var$_f1.subVectors($2358b7e4ec07df88$var$_v2$4, $2358b7e4ec07df88$var$_v1$7);
        $2358b7e4ec07df88$var$_f2.subVectors($2358b7e4ec07df88$var$_v0$2, $2358b7e4ec07df88$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$2358b7e4ec07df88$var$_f0.z,
            $2358b7e4ec07df88$var$_f0.y,
            0,
            -$2358b7e4ec07df88$var$_f1.z,
            $2358b7e4ec07df88$var$_f1.y,
            0,
            -$2358b7e4ec07df88$var$_f2.z,
            $2358b7e4ec07df88$var$_f2.y,
            $2358b7e4ec07df88$var$_f0.z,
            0,
            -$2358b7e4ec07df88$var$_f0.x,
            $2358b7e4ec07df88$var$_f1.z,
            0,
            -$2358b7e4ec07df88$var$_f1.x,
            $2358b7e4ec07df88$var$_f2.z,
            0,
            -$2358b7e4ec07df88$var$_f2.x,
            -$2358b7e4ec07df88$var$_f0.y,
            $2358b7e4ec07df88$var$_f0.x,
            0,
            -$2358b7e4ec07df88$var$_f1.y,
            $2358b7e4ec07df88$var$_f1.x,
            0,
            -$2358b7e4ec07df88$var$_f2.y,
            $2358b7e4ec07df88$var$_f2.x,
            0
        ];
        if (!$2358b7e4ec07df88$var$satForAxes(axes, $2358b7e4ec07df88$var$_v0$2, $2358b7e4ec07df88$var$_v1$7, $2358b7e4ec07df88$var$_v2$4, $2358b7e4ec07df88$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$2358b7e4ec07df88$var$satForAxes(axes, $2358b7e4ec07df88$var$_v0$2, $2358b7e4ec07df88$var$_v1$7, $2358b7e4ec07df88$var$_v2$4, $2358b7e4ec07df88$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $2358b7e4ec07df88$var$_triangleNormal.crossVectors($2358b7e4ec07df88$var$_f0, $2358b7e4ec07df88$var$_f1);
        axes = [
            $2358b7e4ec07df88$var$_triangleNormal.x,
            $2358b7e4ec07df88$var$_triangleNormal.y,
            $2358b7e4ec07df88$var$_triangleNormal.z
        ];
        return $2358b7e4ec07df88$var$satForAxes(axes, $2358b7e4ec07df88$var$_v0$2, $2358b7e4ec07df88$var$_v1$7, $2358b7e4ec07df88$var$_v2$4, $2358b7e4ec07df88$var$_extents);
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector3} point - The point to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $2358b7e4ec07df88$var$_vector$b).distanceTo(point);
    }
    /**
	 * Returns a bounding sphere that encloses this bounding box.
	 *
	 * @param {Sphere} target - The target sphere that is used to store the method's result.
	 * @return {Sphere} The bounding sphere that encloses this bounding box.
	 */ getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($2358b7e4ec07df88$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box3} box - The bounding box to intersect with.
	 * @return {Box3} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box3} box - The bounding box that will be unioned with this instance.
	 * @return {Box3} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Transforms this bounding box by the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Box3} A reference to this bounding box.
	 */ applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $2358b7e4ec07df88$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $2358b7e4ec07df88$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $2358b7e4ec07df88$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $2358b7e4ec07df88$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $2358b7e4ec07df88$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $2358b7e4ec07df88$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $2358b7e4ec07df88$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $2358b7e4ec07df88$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($2358b7e4ec07df88$var$_points);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 3D space.
	 *
	 * @param {Vector3} offset - The offset that should be used to translate the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box3} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            min: this.min.toArray(),
            max: this.max.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @param {Object} json - The serialized json to set the box from.
	 * @return {Box3} A reference to this bounding box.
	 */ fromJSON(json) {
        this.min.fromArray(json.min);
        this.max.fromArray(json.max);
        return this;
    }
}
const $2358b7e4ec07df88$var$_points = [
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699()
];
const $2358b7e4ec07df88$var$_vector$b = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_box$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $2358b7e4ec07df88$var$_v0$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v1$7 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v2$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
// triangle edge vectors
const $2358b7e4ec07df88$var$_f0 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_f1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_f2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_center = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_extents = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_triangleNormal = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_testAxis = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
function $2358b7e4ec07df88$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $2358b7e4ec07df88$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($2358b7e4ec07df88$var$_testAxis.x) + extents.y * Math.abs($2358b7e4ec07df88$var$_testAxis.y) + extents.z * Math.abs($2358b7e4ec07df88$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($2358b7e4ec07df88$var$_testAxis);
        const p1 = v1.dot($2358b7e4ec07df88$var$_testAxis);
        const p2 = v2.dot($2358b7e4ec07df88$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $2358b7e4ec07df88$var$_box$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
const $2358b7e4ec07df88$var$_v1$6 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v2$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * An analytical 3D sphere defined by a center and radius. This class is mainly
 * used as a Bounding Sphere for 3D objects.
 */ class $2358b7e4ec07df88$export$805e8b72413ccaba {
    /**
	 * Constructs a new sphere.
	 *
	 * @param {Vector3} [center=(0,0,0)] - The center of the sphere
	 * @param {number} [radius=-1] - The radius of the sphere.
	 */ constructor(center = new $2358b7e4ec07df88$export$64b5c384219d3699(), radius = -1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphere = true;
        /**
		 * The center of the sphere
		 *
		 * @type {Vector3}
		 */ this.center = center;
        /**
		 * The radius of the sphere.
		 *
		 * @type {number}
		 */ this.radius = radius;
    }
    /**
	 * Sets the sphere's components by copying the given values.
	 *
	 * @param {Vector3} center - The center.
	 * @param {number} radius - The radius.
	 * @return {Sphere} A reference to this sphere.
	 */ set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    /**
	 * Computes the minimum bounding sphere for list of points.
	 * If the optional center point is given, it is used as the sphere's
	 * center. Otherwise, the center of the axis-aligned bounding box
	 * encompassing the points is calculated.
	 *
	 * @param {Array<Vector3>} points - A list of points in 3D space.
	 * @param {Vector3} [optionalCenter] - The center of the sphere.
	 * @return {Sphere} A reference to this sphere.
	 */ setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $2358b7e4ec07df88$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    /**
	 * Copies the values of the given sphere to this instance.
	 *
	 * @param {Sphere} sphere - The sphere to copy.
	 * @return {Sphere} A reference to this sphere.
	 */ copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    /**
	 * Returns `true` if the sphere is empty (the radius set to a negative number).
	 *
	 * Spheres with a radius of `0` contain only their center point and are not
	 * considered to be empty.
	 *
	 * @return {boolean} Whether this sphere is empty or not.
	 */ isEmpty() {
        return this.radius < 0;
    }
    /**
	 * Makes this sphere empty which means in encloses a zero space in 3D.
	 *
	 * @return {Sphere} A reference to this sphere.
	 */ makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    /**
	 * Returns `true` if this sphere contains the given point inclusive of
	 * the surface of the sphere.
	 *
	 * @param {Vector3} point - The point to check.
	 * @return {boolean} Whether this sphere contains the given point or not.
	 */ containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    /**
	 * Returns the closest distance from the boundary of the sphere to the
	 * given point. If the sphere contains the point, the distance will
	 * be negative.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The distance to the point.
	 */ distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    /**
	 * Returns `true` if this sphere intersects with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test.
	 * @return {boolean} Whether this sphere intersects with the given one or not.
	 */ intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    /**
	 * Returns `true` if this sphere intersects with the given box.
	 *
	 * @param {Box3} box - The box to test.
	 * @return {boolean} Whether this sphere intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    /**
	 * Returns `true` if this sphere intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether this sphere intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    /**
	 * Clamps a point within the sphere. If the point is outside the sphere, it
	 * will clamp it to the closest point on the edge of the sphere. Points
	 * already inside the sphere will not be affected.
	 *
	 * @param {Vector3} point - The plane to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    /**
	 * Returns a bounding box that encloses this sphere.
	 *
	 * @param {Box3} target - The target box that is used to store the method's result.
	 * @return {Box3} The bounding box that encloses this sphere.
	 */ getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    /**
	 * Transforms this sphere with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Sphere} A reference to this sphere.
	 */ applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    /**
	 * Translates the sphere's center by the given offset.
	 *
	 * @param {Vector3} offset - The offset.
	 * @return {Sphere} A reference to this sphere.
	 */ translate(offset) {
        this.center.add(offset);
        return this;
    }
    /**
	 * Expands the boundaries of this sphere to include the given point.
	 *
	 * @param {Vector3} point - The point to include.
	 * @return {Sphere} A reference to this sphere.
	 */ expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $2358b7e4ec07df88$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $2358b7e4ec07df88$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($2358b7e4ec07df88$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    /**
	 * Expands this sphere to enclose both the original sphere and the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to include.
	 * @return {Sphere} A reference to this sphere.
	 */ union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $2358b7e4ec07df88$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($2358b7e4ec07df88$var$_v1$6.copy(sphere.center).add($2358b7e4ec07df88$var$_v2$3));
            this.expandByPoint($2358b7e4ec07df88$var$_v1$6.copy(sphere.center).sub($2358b7e4ec07df88$var$_v2$3));
        }
        return this;
    }
    /**
	 * Returns `true` if this sphere is equal with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test for equality.
	 * @return {boolean} Whether this bounding sphere is equal with the given one.
	 */ equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    /**
	 * Returns a new sphere with copied values from this instance.
	 *
	 * @return {Sphere} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            radius: this.radius,
            center: this.center.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @param {Object} json - The serialized json to set the sphere from.
	 * @return {Sphere} A reference to this bounding sphere.
	 */ fromJSON(json) {
        this.radius = json.radius;
        this.center.fromArray(json.center);
        return this;
    }
}
const $2358b7e4ec07df88$var$_vector$a = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_segCenter = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_segDir = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_diff = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_edge1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_edge2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_normal$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A ray that emits from an origin in a certain direction. The class is used by
 * {@link Raycaster} to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3D space the mouse is over)
 * amongst other things.
 */ class $2358b7e4ec07df88$export$a186db52eed6d40e {
    /**
	 * Constructs a new ray.
	 *
	 * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
	 * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
	 */ constructor(origin = new $2358b7e4ec07df88$export$64b5c384219d3699(), direction = new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, -1)){
        /**
		 * The origin of the ray.
		 *
		 * @type {Vector3}
		 */ this.origin = origin;
        /**
		 * The (normalized) direction of the ray.
		 *
		 * @type {Vector3}
		 */ this.direction = direction;
    }
    /**
	 * Sets the ray's components by copying the given values.
	 *
	 * @param {Vector3} origin - The origin.
	 * @param {Vector3} direction - The direction.
	 * @return {Ray} A reference to this ray.
	 */ set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    /**
	 * Copies the values of the given ray to this instance.
	 *
	 * @param {Ray} ray - The ray to copy.
	 * @return {Ray} A reference to this ray.
	 */ copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    /**
	 * Returns a vector that is located at a given distance along this ray.
	 *
	 * @param {number} t - The distance along the ray to retrieve a position for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A position on the ray.
	 */ at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    /**
	 * Adjusts the direction of the ray to point at the given vector in world space.
	 *
	 * @param {Vector3} v - The target position.
	 * @return {Ray} A reference to this ray.
	 */ lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    /**
	 * Shift the origin of this ray along its direction by the given distance.
	 *
	 * @param {number} t - The distance along the ray to interpolate.
	 * @return {Ray} A reference to this ray.
	 */ recast(t) {
        this.origin.copy(this.at(t, $2358b7e4ec07df88$var$_vector$a));
        return this;
    }
    /**
	 * Returns the point along this ray that is closest to the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on this ray.
	 */ closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    /**
	 * Returns the distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The distance.
	 */ distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    /**
	 * Returns the squared distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The squared distance.
	 */ distanceSqToPoint(point) {
        const directionDistance = $2358b7e4ec07df88$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $2358b7e4ec07df88$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $2358b7e4ec07df88$var$_vector$a.distanceToSquared(point);
    }
    /**
	 * Returns the squared distance between this ray and the given line segment.
	 *
	 * @param {Vector3} v0 - The start point of the line segment.
	 * @param {Vector3} v1 - The end point of the line segment.
	 * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
	 * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
	 * @return {number} The squared distance.
	 */ distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $2358b7e4ec07df88$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $2358b7e4ec07df88$var$_segDir.copy(v1).sub(v0).normalize();
        $2358b7e4ec07df88$var$_diff.copy(this.origin).sub($2358b7e4ec07df88$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($2358b7e4ec07df88$var$_segDir);
        const b0 = $2358b7e4ec07df88$var$_diff.dot(this.direction);
        const b1 = -$2358b7e4ec07df88$var$_diff.dot($2358b7e4ec07df88$var$_segDir);
        const c = $2358b7e4ec07df88$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($2358b7e4ec07df88$var$_segCenter).addScaledVector($2358b7e4ec07df88$var$_segDir, s1);
        return sqrDist;
    }
    /**
	 * Intersects this ray with the given sphere, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectSphere(sphere, target) {
        $2358b7e4ec07df88$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $2358b7e4ec07df88$var$_vector$a.dot(this.direction);
        const d2 = $2358b7e4ec07df88$var$_vector$a.dot($2358b7e4ec07df88$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @return {boolean} Whether this ray intersects with the given sphere or not.
	 */ intersectsSphere(sphere) {
        if (sphere.radius < 0) return false; // handle empty spheres, see #31187
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
	 * does not intersect with the plane.
	 *
	 * @param {Plane} plane - The plane to compute the distance to.
	 * @return {?number} Whether this ray intersects with the given sphere or not.
	 */ distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    /**
	 * Intersects this ray with the given plane, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @return {boolean} Whether this ray intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    /**
	 * Intersects this ray with the given bounding box, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this ray intersects with the given box or not.
	 */ intersectsBox(box) {
        return this.intersectBox(box, $2358b7e4ec07df88$var$_vector$a) !== null;
    }
    /**
	 * Intersects this ray with the given triangle, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Vector3} a - The first vertex of the triangle.
	 * @param {Vector3} b - The second vertex of the triangle.
	 * @param {Vector3} c - The third vertex of the triangle.
	 * @param {boolean} backfaceCulling - Whether to use backface culling or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $2358b7e4ec07df88$var$_edge1.subVectors(b, a);
        $2358b7e4ec07df88$var$_edge2.subVectors(c, a);
        $2358b7e4ec07df88$var$_normal$1.crossVectors($2358b7e4ec07df88$var$_edge1, $2358b7e4ec07df88$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($2358b7e4ec07df88$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $2358b7e4ec07df88$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($2358b7e4ec07df88$var$_edge2.crossVectors($2358b7e4ec07df88$var$_diff, $2358b7e4ec07df88$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($2358b7e4ec07df88$var$_edge1.cross($2358b7e4ec07df88$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $2358b7e4ec07df88$var$_diff.dot($2358b7e4ec07df88$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    /**
	 * Transforms this ray with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix4 - The transformation matrix.
	 * @return {Ray} A reference to this ray.
	 */ applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    /**
	 * Returns `true` if this ray is equal with the given one.
	 *
	 * @param {Ray} ray - The ray to test for equality.
	 * @return {boolean} Whether this ray is equal with the given one.
	 */ equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    /**
	 * Returns a new ray with copied values from this instance.
	 *
	 * @return {Ray} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 4x4 matrix.
 *
 * The most common use of a 4x4 matrix in 3D computer graphics is as a transformation matrix.
 * For an introduction to transformation matrices as used in WebGL, check out [this tutorial](https://www.opengl-tutorial.org/beginners-tutorials/tutorial-3-matrices)
 *
 * This allows a 3D vector representing a point in 3D space to undergo
 * transformations such as translation, rotation, shear, scale, reflection,
 * orthogonal or perspective projection and so on, by being multiplied by the
 * matrix. This is known as `applying` the matrix to the vector.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix4();
 * m.set( 11, 12, 13, 14,
 *        21, 22, 23, 24,
 *        31, 32, 33, 34,
 *        41, 42, 43, 44 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31, 41,
 *                12, 22, 32, 42,
 *                13, 23, 33, 43,
 *                14, 24, 34, 44 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $2358b7e4ec07df88$export$2ae72fc923e5eb5 {
    /**
	 * Constructs a new 4x4 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 */ constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 * @return {Matrix4} A reference to this matrix.
	 */ set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    /**
	 * Sets this matrix to the 4x4 identity matrix.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix4} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix4} m - The matrix to copy.
	 * @return {Matrix4} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    /**
	 * Copies the translation component of the given matrix
	 * into this matrix's translation component.
	 *
	 * @param {Matrix4} m - The matrix to copy the translation component.
	 * @return {Matrix4} A reference to this matrix.
	 */ copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    /**
	 * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        if (this.determinant() === 0) {
            xAxis.set(1, 0, 0);
            yAxis.set(0, 1, 0);
            zAxis.set(0, 0, 1);
            return this;
        }
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    /**
	 * Sets the given basis vectors to this matrix.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the rotation component of the given matrix
	 * into this matrix's rotation component.
	 *
	 * Note: This method does not support reflection matrices.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractRotation(m) {
        if (m.determinant() === 0) return this.identity();
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $2358b7e4ec07df88$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $2358b7e4ec07df88$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $2358b7e4ec07df88$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
	 * the rotation specified by the given Euler angles. The rest of
	 * the matrix is set to the identity. Depending on the {@link Euler#order},
	 * there are six possible outcomes. See [this page](https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix)
	 * for a complete list.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component of this matrix to the rotation specified by
	 * the given Quaternion as outlined [here](https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion)
	 * The rest of the matrix is set to the identity.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromQuaternion(q) {
        return this.compose($2358b7e4ec07df88$var$_zero, q, $2358b7e4ec07df88$var$_one);
    }
    /**
	 * Sets the rotation component of the transformation matrix, looking from `eye` towards
	 * `target`, and oriented by the up-direction.
	 *
	 * @param {Vector3} eye - The eye vector.
	 * @param {Vector3} target - The target vector.
	 * @param {Vector3} up - The up vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ lookAt(eye, target, up) {
        const te = this.elements;
        $2358b7e4ec07df88$var$_z.subVectors(eye, target);
        if ($2358b7e4ec07df88$var$_z.lengthSq() === 0) // eye and target are in the same position
        $2358b7e4ec07df88$var$_z.z = 1;
        $2358b7e4ec07df88$var$_z.normalize();
        $2358b7e4ec07df88$var$_x.crossVectors(up, $2358b7e4ec07df88$var$_z);
        if ($2358b7e4ec07df88$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $2358b7e4ec07df88$var$_z.x += 0.0001;
            else $2358b7e4ec07df88$var$_z.z += 0.0001;
            $2358b7e4ec07df88$var$_z.normalize();
            $2358b7e4ec07df88$var$_x.crossVectors(up, $2358b7e4ec07df88$var$_z);
        }
        $2358b7e4ec07df88$var$_x.normalize();
        $2358b7e4ec07df88$var$_y.crossVectors($2358b7e4ec07df88$var$_z, $2358b7e4ec07df88$var$_x);
        te[0] = $2358b7e4ec07df88$var$_x.x;
        te[4] = $2358b7e4ec07df88$var$_y.x;
        te[8] = $2358b7e4ec07df88$var$_z.x;
        te[1] = $2358b7e4ec07df88$var$_x.y;
        te[5] = $2358b7e4ec07df88$var$_y.y;
        te[9] = $2358b7e4ec07df88$var$_z.y;
        te[2] = $2358b7e4ec07df88$var$_x.z;
        te[6] = $2358b7e4ec07df88$var$_y.z;
        te[10] = $2358b7e4ec07df88$var$_z.z;
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 4x4 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix4} a - The first matrix.
	 * @param {Matrix4} b - The second matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * Based on the method outlined [here](http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html).
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        const t11 = n23 * n34 - n24 * n33;
        const t12 = n22 * n34 - n24 * n32;
        const t13 = n22 * n33 - n23 * n32;
        const t21 = n21 * n34 - n24 * n31;
        const t22 = n21 * n33 - n23 * n31;
        const t23 = n21 * n32 - n22 * n31;
        return n11 * (n42 * t11 - n43 * t12 + n44 * t13) - n12 * (n41 * t11 - n43 * t21 + n44 * t22) + n13 * (n41 * t12 - n42 * t21 + n44 * t23) - n14 * (n41 * t13 - n42 * t22 + n43 * t23);
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    /**
	 * Sets the position component for this matrix from the given vector,
	 * without affecting the rest of the matrix.
	 *
	 * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
	 * @param {number} y - The y component of the vector.
	 * @param {number} z - The z component of the vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    /**
	 * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    /**
	 * Multiplies the columns of this matrix by the given vector.
	 *
	 * @param {Vector3} v - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    /**
	 * Gets the maximum scale value of the three axes.
	 *
	 * @return {number} The maximum scale.
	 */ getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    /**
	 * Sets this matrix as a translation transform from the given vector.
	 *
	 * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @param {number} z - The amount to translate in the z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the X axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Y axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Z axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the given axis by
	 * the given angle.
	 *
	 * This is a somewhat controversial but mathematically sound alternative to
	 * rotating via Quaternions. See the discussion [here](https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199).
	 *
	 * @param {Vector3} axis - The normalized rotation axis.
	 * @param {number} angle - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a scale transformation.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @param {number} z - The amount to scale in the Z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a shear transformation.
	 *
	 * @param {number} xy - The amount to shear X by Y.
	 * @param {number} xz - The amount to shear X by Z.
	 * @param {number} yx - The amount to shear Y by X.
	 * @param {number} yz - The amount to shear Y by Z.
	 * @param {number} zx - The amount to shear Z by X.
	 * @param {number} zy - The amount to shear Z by Y.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix to the transformation composed of the given position,
	 * rotation (Quaternion) and scale.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    /**
	 * Decomposes this matrix into its position, rotation and scale components
	 * and provides the result in the given objects.
	 *
	 * Note: Not all matrices are decomposable in this way. For example, if an
	 * object has a non-uniformly scaled parent, then the object's world matrix
	 * may not be decomposable, and this method may not be appropriate.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ decompose(position, quaternion, scale) {
        const te = this.elements;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        if (this.determinant() === 0) {
            scale.set(1, 1, 1);
            quaternion.identity();
            return this;
        }
        let sx = $2358b7e4ec07df88$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $2358b7e4ec07df88$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $2358b7e4ec07df88$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        // scale the rotation part
        $2358b7e4ec07df88$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $2358b7e4ec07df88$var$_m1$2.elements[0] *= invSX;
        $2358b7e4ec07df88$var$_m1$2.elements[1] *= invSX;
        $2358b7e4ec07df88$var$_m1$2.elements[2] *= invSX;
        $2358b7e4ec07df88$var$_m1$2.elements[4] *= invSY;
        $2358b7e4ec07df88$var$_m1$2.elements[5] *= invSY;
        $2358b7e4ec07df88$var$_m1$2.elements[6] *= invSY;
        $2358b7e4ec07df88$var$_m1$2.elements[8] *= invSZ;
        $2358b7e4ec07df88$var$_m1$2.elements[9] *= invSZ;
        $2358b7e4ec07df88$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($2358b7e4ec07df88$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    /**
	 * Creates a perspective projection matrix. This is used internally by
	 * {@link PerspectiveCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Matrix4} A reference to this matrix.
	 */ makePerspective(left, right, top, bottom, near, far, coordinateSystem = $2358b7e4ec07df88$export$5a0e9190d10875d3, reversedDepth = false) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
            c = near / (far - near);
            d = far * near / (far - near);
        } else {
            if (coordinateSystem === $2358b7e4ec07df88$export$5a0e9190d10875d3) {
                c = -(far + near) / (far - near);
                d = -2 * far * near / (far - near);
            } else if (coordinateSystem === $2358b7e4ec07df88$export$cc83beedcb9be9ac) {
                c = -far / (far - near);
                d = -far * near / (far - near);
            } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        }
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    /**
	 * Creates a orthographic projection matrix. This is used internally by
	 * {@link OrthographicCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $2358b7e4ec07df88$export$5a0e9190d10875d3, reversedDepth = false) {
        const te = this.elements;
        const x = 2 / (right - left);
        const y = 2 / (top - bottom);
        const a = -(right + left) / (right - left);
        const b = -(top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
            c = 1 / (far - near);
            d = far / (far - near);
        } else {
            if (coordinateSystem === $2358b7e4ec07df88$export$5a0e9190d10875d3) {
                c = -2 / (far - near);
                d = -(far + near) / (far - near);
            } else if (coordinateSystem === $2358b7e4ec07df88$export$cc83beedcb9be9ac) {
                c = -1 / (far - near);
                d = -near / (far - near);
            } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        }
        te[0] = x;
        te[4] = 0;
        te[8] = 0;
        te[12] = a;
        te[1] = 0;
        te[5] = y;
        te[9] = 0;
        te[13] = b;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix4} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix4} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $2358b7e4ec07df88$var$_v1$5 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_m1$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_zero = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, 0);
const $2358b7e4ec07df88$var$_one = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(1, 1, 1);
const $2358b7e4ec07df88$var$_x = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_y = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_z = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_matrix$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_quaternion$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
/**
 * A class representing Euler angles.
 *
 * Euler angles describe a rotational transformation by rotating an object on
 * its various axes in specified amounts per axis, and a specified axis
 * order.
 *
 * Iterating through an instance will yield its components (x, y, z,
 * order) in the corresponding order.
 *
 * ```js
 * const a = new THREE.Euler( 0, 1, 1.57, 'XYZ' );
 * const b = new THREE.Vector3( 1, 0, 1 );
 * b.applyEuler(a);
 * ```
 */ class $2358b7e4ec07df88$export$d93cc409a0768c5f {
    /**
	 * Constructs a new euler instance.
	 *
	 * @param {number} [x=0] - The angle of the x axis in radians.
	 * @param {number} [y=0] - The angle of the y axis in radians.
	 * @param {number} [z=0] - The angle of the z axis in radians.
	 * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
	 */ constructor(x = 0, y = 0, z = 0, order = $2358b7e4ec07df88$export$d93cc409a0768c5f.DEFAULT_ORDER){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    /**
	 * The angle of the x axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the y axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the z axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * A string representing the order that the rotations are applied.
	 *
	 * @type {string}
	 * @default 'XYZ'
	 */ get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the Euler components.
	 *
	 * @param {number} x - The angle of the x axis in radians.
	 * @param {number} y - The angle of the y axis in radians.
	 * @param {number} z - The angle of the z axis in radians.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new Euler instance with copied values from this instance.
	 *
	 * @return {Euler} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    /**
	 * Copies the values of the given Euler instance to this instance.
	 *
	 * @param {Euler} euler - The Euler instance to copy.
	 * @return {Euler} A reference to this Euler instance.
	 */ copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a pure rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromRotationMatrix(m, order = this._order, update = true) {
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($2358b7e4ec07df88$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$2358b7e4ec07df88$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($2358b7e4ec07df88$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$2358b7e4ec07df88$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($2358b7e4ec07df88$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$2358b7e4ec07df88$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                $2358b7e4ec07df88$export$c106dd0671a0fc2d('Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a normalized quaternion.
	 *
	 * @param {Quaternion} q - A normalized Quaternion.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromQuaternion(q, order, update) {
        $2358b7e4ec07df88$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($2358b7e4ec07df88$var$_matrix$2, order, update);
    }
    /**
	 * Sets the angles of this Euler instance from the given vector.
	 *
	 * @param {Vector3} v - The vector.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    /**
	 * Resets the euler angle with a new order by creating a quaternion from this
	 * euler angle and then setting this euler angle with the quaternion and the
	 * new order.
	 *
	 * Warning: This discards revolution information.
	 *
	 * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ reorder(newOrder) {
        $2358b7e4ec07df88$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($2358b7e4ec07df88$var$_quaternion$3, newOrder);
    }
    /**
	 * Returns `true` if this Euler instance is equal with the given one.
	 *
	 * @param {Euler} euler - The Euler instance to test for equality.
	 * @return {boolean} Whether this Euler instance is equal with the given one.
	 */ equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    /**
	 * Sets this Euler instance's components to values from the given array. The first three
	 * entries of the array are assign to the x,y and z components. An optional fourth entry
	 * defines the Euler order.
	 *
	 * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
	 * @return {Euler} A reference to this Euler instance.
	 */ fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this Euler instance to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number,number,number,string>} The Euler components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
/**
 * The default Euler angle order.
 *
 * @static
 * @type {string}
 * @default 'XYZ'
 */ $2358b7e4ec07df88$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
/**
 * A layers object assigns an 3D object to 1 or more of 32
 * layers numbered `0` to `31` - internally the layers are stored as a
 * bit mask], and by default all 3D objects are a member of layer `0`.
 *
 * This can be used to control visibility - an object must share a layer with
 * a camera to be visible when that camera's view is
 * rendered.
 *
 * All classes that inherit from {@link Object3D} have an `layers` property which
 * is an instance of this class.
 */ class $2358b7e4ec07df88$export$89312ce47c0ca777 {
    /**
	 * Constructs a new layers instance, with membership
	 * initially set to layer `0`.
	 */ constructor(){
        /**
		 * A bit mask storing which of the 32 layers this layers object is currently
		 * a member of.
		 *
		 * @type {number}
		 */ this.mask = 1;
    }
    /**
	 * Sets membership to the given layer, and remove membership all other layers.
	 *
	 * @param {number} layer - The layer to set.
	 */ set(layer) {
        this.mask = (1 << layer | 0) >>> 0;
    }
    /**
	 * Adds membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ enable(layer) {
        this.mask |= 1 << layer | 0;
    }
    /**
	 * Adds membership to all layers.
	 */ enableAll() {
        this.mask = -1;
    }
    /**
	 * Toggles the membership of the given layer.
	 *
	 * @param {number} layer - The layer to toggle.
	 */ toggle(layer) {
        this.mask ^= 1 << layer | 0;
    }
    /**
	 * Removes membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ disable(layer) {
        this.mask &= ~(1 << layer | 0);
    }
    /**
	 * Removes the membership from all layers.
	 */ disableAll() {
        this.mask = 0;
    }
    /**
	 * Returns `true` if this and the given layers object have at least one
	 * layer in common.
	 *
	 * @param {Layers} layers - The layers to test.
	 * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
	 */ test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    /**
	 * Returns `true` if the given layer is enabled.
	 *
	 * @param {number} layer - The layer to test.
	 * @return {boolean } Whether the given layer is enabled or not.
	 */ isEnabled(layer) {
        return (this.mask & (1 << layer | 0)) !== 0;
    }
}
let $2358b7e4ec07df88$var$_object3DId = 0;
const $2358b7e4ec07df88$var$_v1$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_q1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
const $2358b7e4ec07df88$var$_m1$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_target = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_position$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_scale$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_quaternion$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
const $2358b7e4ec07df88$var$_xAxis = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(1, 0, 0);
const $2358b7e4ec07df88$var$_yAxis = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(0, 1, 0);
const $2358b7e4ec07df88$var$_zAxis = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, 1);
/**
 * Fires when the object has been added to its parent object.
 *
 * @event Object3D#added
 * @type {Object}
 */ const $2358b7e4ec07df88$var$_addedEvent = {
    type: 'added'
};
/**
 * Fires when the object has been removed from its parent object.
 *
 * @event Object3D#removed
 * @type {Object}
 */ const $2358b7e4ec07df88$var$_removedEvent = {
    type: 'removed'
};
/**
 * Fires when a new child object has been added.
 *
 * @event Object3D#childadded
 * @type {Object}
 */ const $2358b7e4ec07df88$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
/**
 * Fires when a child object has been removed.
 *
 * @event Object3D#childremoved
 * @type {Object}
 */ const $2358b7e4ec07df88$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
/**
 * This is the base class for most objects in three.js and provides a set of
 * properties and methods for manipulating objects in 3D space.
 *
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$e4dd07dff30cc924 extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new 3D object.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isObject3D = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name Object3D#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_object3DId++
        });
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * The name of the 3D object.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Object3D';
        /**
		 * A reference to the parent object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.parent = null;
        /**
		 * An array holding the child 3D objects of this instance.
		 *
		 * @type {Array<Object3D>}
		 */ this.children = [];
        /**
		 * Defines the `up` direction of the 3D object which influences
		 * the orientation via methods like {@link Object3D#lookAt}.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_UP`.
		 *
		 * @type {Vector3}
		 */ this.up = $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const rotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        const quaternion = new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
        const scale = new $2358b7e4ec07df88$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            /**
			 * Represents the object's local position.
			 *
			 * @name Object3D#position
			 * @type {Vector3}
			 * @default (0,0,0)
			 */ position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            /**
			 * Represents the object's local rotation as Euler angles, in radians.
			 *
			 * @name Object3D#rotation
			 * @type {Euler}
			 * @default (0,0,0)
			 */ rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            /**
			 * Represents the object's local rotation as Quaternions.
			 *
			 * @name Object3D#quaternion
			 * @type {Quaternion}
			 */ quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            /**
			 * Represents the object's local scale.
			 *
			 * @name Object3D#scale
			 * @type {Vector3}
			 * @default (1,1,1)
			 */ scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            /**
			 * Represents the object's model-view matrix.
			 *
			 * @name Object3D#modelViewMatrix
			 * @type {Matrix4}
			 */ modelViewMatrix: {
                value: new $2358b7e4ec07df88$export$2ae72fc923e5eb5()
            },
            /**
			 * Represents the object's normal matrix.
			 *
			 * @name Object3D#normalMatrix
			 * @type {Matrix3}
			 */ normalMatrix: {
                value: new $2358b7e4ec07df88$export$8ff26dafa08918()
            }
        });
        /**
		 * Represents the object's transformation matrix in local space.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * Represents the object's transformation matrix in world space.
		 * If the 3D object has no parent, then it's identical to the local transformation matrix
		 *
		 * @type {Matrix4}
		 */ this.matrixWorld = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * When set to `true`, the engine automatically computes the local matrix from position,
		 * rotation and scale every frame.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        /**
		 * When set to `true`, the engine automatically computes the world matrix from the current local
		 * matrix and the object's transformation hierarchy.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixWorldAutoUpdate = $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        /**
		 * When set to `true`, it calculates the world matrix in that frame and resets this property
		 * to `false`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.matrixWorldNeedsUpdate = false;
        /**
		 * The layer membership of the 3D object. The 3D object is only visible if it has
		 * at least one layer in common with the camera in use. This property can also be
		 * used to filter out unwanted objects in ray-intersection tests when using {@link Raycaster}.
		 *
		 * @type {Layers}
		 */ this.layers = new $2358b7e4ec07df88$export$89312ce47c0ca777();
        /**
		 * When set to `true`, the 3D object gets rendered.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * When set to `true`, the 3D object gets rendered into shadow maps.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.castShadow = false;
        /**
		 * When set to `true`, the 3D object is affected by shadows in the scene.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.receiveShadow = false;
        /**
		 * When set to `true`, the 3D object is honored by view frustum culling.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.frustumCulled = true;
        /**
		 * This value allows the default rendering order of scene graph objects to be
		 * overridden although opaque and transparent objects remain sorted independently.
		 * When this property is set for an instance of {@link Group},all descendants
		 * objects will be sorted and rendered together. Sorting is from lowest to highest
		 * render order.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderOrder = 0;
        /**
		 * An array holding the animation clips of the 3D object.
		 *
		 * @type {Array<AnimationClip>}
		 */ this.animations = [];
        /**
		 * Custom depth material to be used when rendering to the depth map. Can only be used
		 * in context of meshes. When shadow-casting with a {@link DirectionalLight} or {@link SpotLight},
		 * if you are modifying vertex positions in the vertex shader you must specify a custom depth
		 * material for proper shadows.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDepthMaterial = undefined;
        /**
		 * Same as {@link Object3D#customDepthMaterial}, but used with {@link PointLight}.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDistanceMaterial = undefined;
        /**
		 * An object that can be used to store custom data about the 3D object. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
    /**
	 * A callback that is executed immediately before a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeShadow() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterShadow() {}
    /**
	 * A callback that is executed immediately before a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterRender() {}
    /**
	 * Applies the given transformation matrix to the object and updates the object's position,
	 * rotation and scale.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 */ applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    /**
	 * Applies a rotation represented by given the quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Object3D} A reference to this instance.
	 */ applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    /**
	 * Sets the given rotation represented as an axis/angle couple to the 3D object.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 */ setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    /**
	 * Sets the given rotation represented as Euler angles to the 3D object.
	 *
	 * @param {Euler} euler - The Euler angles.
	 */ setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    /**
	 * Sets the given rotation represented as rotation matrix to the 3D object.
	 *
	 * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
	 * a pure rotation matrix (i.e, unscaled).
	 */ setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    /**
	 * Sets the given rotation represented as a Quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The Quaternion
	 */ setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    /**
	 * Rotates the 3D object along an axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $2358b7e4ec07df88$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($2358b7e4ec07df88$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object along an axis in world space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $2358b7e4ec07df88$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($2358b7e4ec07df88$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object around its X axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateX(angle) {
        return this.rotateOnAxis($2358b7e4ec07df88$var$_xAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Y axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateY(angle) {
        return this.rotateOnAxis($2358b7e4ec07df88$var$_yAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Z axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateZ(angle) {
        return this.rotateOnAxis($2358b7e4ec07df88$var$_zAxis, angle);
    }
    /**
	 * Translate the 3D object by a distance along the given axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $2358b7e4ec07df88$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($2358b7e4ec07df88$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    /**
	 * Translate the 3D object by a distance along its X-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateX(distance) {
        return this.translateOnAxis($2358b7e4ec07df88$var$_xAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Y-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateY(distance) {
        return this.translateOnAxis($2358b7e4ec07df88$var$_yAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Z-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateZ(distance) {
        return this.translateOnAxis($2358b7e4ec07df88$var$_zAxis, distance);
    }
    /**
	 * Converts the given vector from this 3D object's local space to world space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    /**
	 * Converts the given vector from this 3D object's word space to local space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($2358b7e4ec07df88$var$_m1$1.copy(this.matrixWorld).invert());
    }
    /**
	 * Rotates the object to face a point in world space.
	 *
	 * This method does not support objects having non-uniformly-scaled parent(s).
	 *
	 * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
	 * @param {number} [y] - The y coordinate in world space.
	 * @param {number} [z] - The z coordinate in world space.
	 */ lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $2358b7e4ec07df88$var$_target.copy(x);
        else $2358b7e4ec07df88$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $2358b7e4ec07df88$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $2358b7e4ec07df88$var$_m1$1.lookAt($2358b7e4ec07df88$var$_position$3, $2358b7e4ec07df88$var$_target, this.up);
        else $2358b7e4ec07df88$var$_m1$1.lookAt($2358b7e4ec07df88$var$_target, $2358b7e4ec07df88$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($2358b7e4ec07df88$var$_m1$1);
        if (parent) {
            $2358b7e4ec07df88$var$_m1$1.extractRotation(parent.matrixWorld);
            $2358b7e4ec07df88$var$_q1.setFromRotationMatrix($2358b7e4ec07df88$var$_m1$1);
            this.quaternion.premultiply($2358b7e4ec07df88$var$_q1.invert());
        }
    }
    /**
	 * Adds the given 3D object as a child to this 3D object. An arbitrary number of
	 * objects may be added. Any current parent on an object passed in here will be
	 * removed, since an object can have at most one parent.
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to add.
	 * @return {Object3D} A reference to this instance.
	 */ add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($2358b7e4ec07df88$var$_addedEvent);
            $2358b7e4ec07df88$var$_childaddedEvent.child = object;
            this.dispatchEvent($2358b7e4ec07df88$var$_childaddedEvent);
            $2358b7e4ec07df88$var$_childaddedEvent.child = null;
        } else $2358b7e4ec07df88$export$a3bc9b8ed74fc('Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    /**
	 * Removes the given 3D object as child from this 3D object.
	 * An arbitrary number of objects may be removed.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @param {Object3D} object - The 3D object to remove.
	 * @return {Object3D} A reference to this instance.
	 */ remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($2358b7e4ec07df88$var$_removedEvent);
            $2358b7e4ec07df88$var$_childremovedEvent.child = object;
            this.dispatchEvent($2358b7e4ec07df88$var$_childremovedEvent);
            $2358b7e4ec07df88$var$_childremovedEvent.child = null;
        }
        return this;
    }
    /**
	 * Removes this 3D object from its current parent.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    /**
	 * Removes all child objects.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ clear() {
        return this.remove(...this.children);
    }
    /**
	 * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
	 * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to attach.
	 * @return {Object3D} A reference to this instance.
	 */ attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $2358b7e4ec07df88$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $2358b7e4ec07df88$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($2358b7e4ec07df88$var$_m1$1);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($2358b7e4ec07df88$var$_addedEvent);
        $2358b7e4ec07df88$var$_childaddedEvent.child = object;
        this.dispatchEvent($2358b7e4ec07df88$var$_childaddedEvent);
        $2358b7e4ec07df88$var$_childaddedEvent.child = null;
        return this;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching ID.
	 *
	 * @param {number} id - The id.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching name.
	 *
	 * @param {string} name - The name.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns all 3D objects with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @param {Array<Object3D>} result - The method stores the result in this array.
	 * @return {Array<Object3D>} The found 3D objects.
	 */ getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    /**
	 * Returns a vector representing the position of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's position in world space.
	 */ getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    /**
	 * Returns a Quaternion representing the position of the 3D object in world space.
	 *
	 * @param {Quaternion} target - The target Quaternion the result is stored to.
	 * @return {Quaternion} The 3D object's rotation in world space.
	 */ getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($2358b7e4ec07df88$var$_position$3, target, $2358b7e4ec07df88$var$_scale$2);
        return target;
    }
    /**
	 * Returns a vector representing the scale of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's scale in world space.
	 */ getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($2358b7e4ec07df88$var$_position$3, $2358b7e4ec07df88$var$_quaternion$2, target);
        return target;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    /**
	 * Abstract method to get intersections between a casted ray and this
	 * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
	 * implement this method in order to use raycasting.
	 *
	 * @abstract
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - An array holding the result of the method.
	 */ raycast() {}
    /**
	 * Executes the callback on this 3D object and all descendants.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
	 * Descendants of invisible 3D objects are not traversed.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    /**
	 * Updates the transformation matrix in local space by computing it from the current
	 * position, rotation and scale values.
	 */ updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    /**
	 * Updates the transformation matrix in world space of this 3D objects and its descendants.
	 *
	 * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
	 * local space. The computation of the local and world matrix can be controlled with the
	 * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
	 * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
	 *
	 * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
	 * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
	 */ updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    /**
	 * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
	 * update of ancestor and descendant nodes.
	 *
	 * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
	 * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
	 */ updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    /**
	 * Serializes the 3D object into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized 3D object.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.7,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.geometryInfo = this._geometryInfo.map((info)=>({
                    ...info,
                    boundingBox: info.boundingBox ? info.boundingBox.toJSON() : undefined,
                    boundingSphere: info.boundingSphere ? info.boundingSphere.toJSON() : undefined
                }));
            object.instanceInfo = this._instanceInfo.map((info)=>({
                    ...info
                }));
            object.availableInstanceIds = this._availableInstanceIds.slice();
            object.availableGeometryIds = this._availableGeometryIds.slice();
            object.nextIndexStart = this._nextIndexStart;
            object.nextVertexStart = this._nextVertexStart;
            object.geometryCount = this._geometryCount;
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            object.indirectTexture = this._indirectTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = this.boundingSphere.toJSON();
            if (this.boundingBox !== null) object.boundingBox = this.boundingBox.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    /**
	 * Returns a new 3D object with copied values from this instance.
	 *
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
	 * @return {Object3D} A clone of this instance.
	 */ clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    /**
	 * Copies the values of the given 3D object to this instance.
	 *
	 * @param {Object3D} source - The 3D object to copy.
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
	 * @return {Object3D} A reference to this instance.
	 */ copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
/**
 * The default up direction for objects, also used as the default
 * position for {@link DirectionalLight} and {@link HemisphereLight}.
 *
 * @static
 * @type {Vector3}
 * @default (0,1,0)
 */ $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(0, 1, 0);
/**
 * The default setting for {@link Object3D#matrixAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
/**
 * The default setting for {@link Object3D#matrixWorldAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $2358b7e4ec07df88$var$_v0$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v1$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v2$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v3$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vab = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vac = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vbc = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vap = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vbp = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vcp = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v40 = /*@__PURE__*/ new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
const $2358b7e4ec07df88$var$_v41 = /*@__PURE__*/ new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
const $2358b7e4ec07df88$var$_v42 = /*@__PURE__*/ new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
/**
 * A geometric triangle as defined by three vectors representing its three corners.
 */ class $2358b7e4ec07df88$export$5a465592bfe74b48 {
    /**
	 * Constructs a new triangle.
	 *
	 * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
	 * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
	 * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
	 */ constructor(a = new $2358b7e4ec07df88$export$64b5c384219d3699(), b = new $2358b7e4ec07df88$export$64b5c384219d3699(), c = new $2358b7e4ec07df88$export$64b5c384219d3699()){
        /**
		 * The first corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.a = a;
        /**
		 * The second corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.b = b;
        /**
		 * The third corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.c = c;
    }
    /**
	 * Computes the normal vector of a triangle.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $2358b7e4ec07df88$var$_v0$1.subVectors(a, b);
        target.cross($2358b7e4ec07df88$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ static getBarycoord(point, a, b, c, target) {
        // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
        $2358b7e4ec07df88$var$_v0$1.subVectors(c, a);
        $2358b7e4ec07df88$var$_v1$3.subVectors(b, a);
        $2358b7e4ec07df88$var$_v2$2.subVectors(point, a);
        const dot00 = $2358b7e4ec07df88$var$_v0$1.dot($2358b7e4ec07df88$var$_v0$1);
        const dot01 = $2358b7e4ec07df88$var$_v0$1.dot($2358b7e4ec07df88$var$_v1$3);
        const dot02 = $2358b7e4ec07df88$var$_v0$1.dot($2358b7e4ec07df88$var$_v2$2);
        const dot11 = $2358b7e4ec07df88$var$_v1$3.dot($2358b7e4ec07df88$var$_v1$3);
        const dot12 = $2358b7e4ec07df88$var$_v1$3.dot($2358b7e4ec07df88$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $2358b7e4ec07df88$var$_v3$2) === null) return false;
        return $2358b7e4ec07df88$var$_v3$2.x >= 0 && $2358b7e4ec07df88$var$_v3$2.y >= 0 && $2358b7e4ec07df88$var$_v3$2.x + $2358b7e4ec07df88$var$_v3$2.y <= 1;
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} p1 - The first corner of the triangle.
	 * @param {Vector3} p2 - The second corner of the triangle.
	 * @param {Vector3} p3 - The third corner of the triangle.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $2358b7e4ec07df88$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $2358b7e4ec07df88$var$_v3$2.x);
        target.addScaledVector(v2, $2358b7e4ec07df88$var$_v3$2.y);
        target.addScaledVector(v3, $2358b7e4ec07df88$var$_v3$2.z);
        return target;
    }
    /**
	 * Computes the value barycentrically interpolated for the given attribute and indices.
	 *
	 * @param {BufferAttribute} attr - The attribute to interpolate.
	 * @param {number} i1 - Index of first vertex.
	 * @param {number} i2 - Index of second vertex.
	 * @param {number} i3 - Index of third vertex.
	 * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The interpolated attribute value.
	 */ static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        $2358b7e4ec07df88$var$_v40.setScalar(0);
        $2358b7e4ec07df88$var$_v41.setScalar(0);
        $2358b7e4ec07df88$var$_v42.setScalar(0);
        $2358b7e4ec07df88$var$_v40.fromBufferAttribute(attr, i1);
        $2358b7e4ec07df88$var$_v41.fromBufferAttribute(attr, i2);
        $2358b7e4ec07df88$var$_v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector($2358b7e4ec07df88$var$_v40, barycoord.x);
        target.addScaledVector($2358b7e4ec07df88$var$_v41, barycoord.y);
        target.addScaledVector($2358b7e4ec07df88$var$_v42, barycoord.z);
        return target;
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ static isFrontFacing(a, b, c, direction) {
        $2358b7e4ec07df88$var$_v0$1.subVectors(c, b);
        $2358b7e4ec07df88$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $2358b7e4ec07df88$var$_v0$1.cross($2358b7e4ec07df88$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    /**
	 * Sets the triangle's vertices by copying the given values.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given array values.
	 *
	 * @param {Array<Vector3>} points - An array with 3D points.
	 * @param {number} i0 - The array index representing the first corner of the triangle.
	 * @param {number} i1 - The array index representing the second corner of the triangle.
	 * @param {number} i2 - The array index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given attribute values.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
	 * @param {number} i0 - The attribute index representing the first corner of the triangle.
	 * @param {number} i1 - The attribute index representing the second corner of the triangle.
	 * @param {number} i2 - The attribute index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    /**
	 * Returns a new triangle with copied values from this instance.
	 *
	 * @return {Triangle} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given triangle to this instance.
	 *
	 * @param {Triangle} triangle - The triangle to copy.
	 * @return {Triangle} A reference to this triangle.
	 */ copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    /**
	 * Computes the area of the triangle.
	 *
	 * @return {number} The triangle's area.
	 */ getArea() {
        $2358b7e4ec07df88$var$_v0$1.subVectors(this.c, this.b);
        $2358b7e4ec07df88$var$_v1$3.subVectors(this.a, this.b);
        return $2358b7e4ec07df88$var$_v0$1.cross($2358b7e4ec07df88$var$_v1$3).length() * 0.5;
    }
    /**
	 * Computes the midpoint of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's midpoint.
	 */ getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    /**
	 * Computes the normal of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ getNormal(target) {
        return $2358b7e4ec07df88$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    /**
	 * Computes a plane the triangle lies within.
	 *
	 * @param {Plane} target - The target vector that is used to store the method's result.
	 * @return {Plane} The plane the triangle lies within.
	 */ getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ getBarycoord(point, target) {
        return $2358b7e4ec07df88$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ getInterpolation(point, v1, v2, v3, target) {
        return $2358b7e4ec07df88$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ containsPoint(point) {
        return $2358b7e4ec07df88$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ isFrontFacing(direction) {
        return $2358b7e4ec07df88$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    /**
	 * Returns `true` if this triangle intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this triangle intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    /**
	 * Returns the closest point on the triangle to the given point.
	 *
	 * @param {Vector3} p - The point to compute the closest point for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the triangle.
	 */ closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $2358b7e4ec07df88$var$_vab.subVectors(b, a);
        $2358b7e4ec07df88$var$_vac.subVectors(c, a);
        $2358b7e4ec07df88$var$_vap.subVectors(p, a);
        const d1 = $2358b7e4ec07df88$var$_vab.dot($2358b7e4ec07df88$var$_vap);
        const d2 = $2358b7e4ec07df88$var$_vac.dot($2358b7e4ec07df88$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $2358b7e4ec07df88$var$_vbp.subVectors(p, b);
        const d3 = $2358b7e4ec07df88$var$_vab.dot($2358b7e4ec07df88$var$_vbp);
        const d4 = $2358b7e4ec07df88$var$_vac.dot($2358b7e4ec07df88$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($2358b7e4ec07df88$var$_vab, v);
        }
        $2358b7e4ec07df88$var$_vcp.subVectors(p, c);
        const d5 = $2358b7e4ec07df88$var$_vab.dot($2358b7e4ec07df88$var$_vcp);
        const d6 = $2358b7e4ec07df88$var$_vac.dot($2358b7e4ec07df88$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($2358b7e4ec07df88$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $2358b7e4ec07df88$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($2358b7e4ec07df88$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($2358b7e4ec07df88$var$_vab, v).addScaledVector($2358b7e4ec07df88$var$_vac, w);
    }
    /**
	 * Returns `true` if this triangle is equal with the given one.
	 *
	 * @param {Triangle} triangle - The triangle to test for equality.
	 * @return {boolean} Whether this triangle is equal with the given one.
	 */ equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const $2358b7e4ec07df88$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $2358b7e4ec07df88$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $2358b7e4ec07df88$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $2358b7e4ec07df88$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
/**
 * A Color instance is represented by RGB components in the linear <i>working
 * color space</i>, which defaults to `LinearSRGBColorSpace`. Inputs
 * conventionally using `SRGBColorSpace` (such as hexadecimals and CSS
 * strings) are converted to the working color space automatically.
 *
 * ```js
 * // converted automatically from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setHex( 0x112233 );
 * ```
 * Source color spaces may be specified explicitly, to ensure correct conversions.
 * ```js
 * // assumed already LinearSRGBColorSpace; no conversion
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5 );
 *
 * // converted explicitly from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5, SRGBColorSpace );
 * ```
 * If THREE.ColorManagement is disabled, no conversions occur. For details,
 * see <i>Color management</i>. Iterating through a Color instance will yield
 * its components (r, g, b) in the corresponding order. A Color can be initialised
 * in any of the following ways:
 * ```js
 * //empty constructor - will default white
 * const color1 = new THREE.Color();
 *
 * //Hexadecimal color (recommended)
 * const color2 = new THREE.Color( 0xff0000 );
 *
 * //RGB string
 * const color3 = new THREE.Color("rgb(255, 0, 0)");
 * const color4 = new THREE.Color("rgb(100%, 0%, 0%)");
 *
 * //X11 color name - all 140 color names are supported.
 * //Note the lack of CamelCase in the name
 * const color5 = new THREE.Color( 'skyblue' );
 * //HSL string
 * const color6 = new THREE.Color("hsl(0, 100%, 50%)");
 *
 * //Separate RGB values between 0 and 1
 * const color7 = new THREE.Color( 1, 0, 0 );
 * ```
 */ class $2358b7e4ec07df88$export$892596cec99bc70e {
    /**
	 * Constructs a new color.
	 *
	 * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
	 * and that method is used throughout the rest of the documentation.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 */ constructor(r, g, b){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isColor = true;
        /**
		 * The red component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.r = 1;
        /**
		 * The green component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.g = 1;
        /**
		 * The blue component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.b = 1;
        return this.set(r, g, b);
    }
    /**
	 * Sets the colors's components from the given values.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 * @return {Color} A reference to this color.
	 */ set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    /**
	 * Sets the colors's components to the given scalar value.
	 *
	 * @param {number} scalar - The scalar value.
	 * @return {Color} A reference to this color.
	 */ setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    /**
	 * Sets this color from a hexadecimal value.
	 *
	 * @param {number} hex - The hexadecimal value.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHex(hex, colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $2358b7e4ec07df88$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} r - Red channel value between `0.0` and `1.0`.
	 * @param {number} g - Green channel value between `0.0` and `1.0`.
	 * @param {number} b - Blue channel value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setRGB(r, g, b, colorSpace = $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $2358b7e4ec07df88$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHSL(h, s, l, colorSpace = $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $2358b7e4ec07df88$var$euclideanModulo(h, 1);
        s = $2358b7e4ec07df88$var$clamp(s, 0, 1);
        l = $2358b7e4ec07df88$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $2358b7e4ec07df88$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $2358b7e4ec07df88$var$hue2rgb(q, p, h);
            this.b = $2358b7e4ec07df88$var$hue2rgb(q, p, h - 1 / 3);
        }
        $2358b7e4ec07df88$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
	 * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
	 * any [X11 color name](https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart) -
	 * all 140 color names are supported).
	 *
	 * @param {string} style - Color as a CSS-style string.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setStyle(style, colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) $2358b7e4ec07df88$export$c106dd0671a0fc2d('Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                    }
                    break;
                default:
                    $2358b7e4ec07df88$export$c106dd0671a0fc2d('Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace);
            else $2358b7e4ec07df88$export$c106dd0671a0fc2d('Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a color name. Faster than {@link Color#setStyle} if
	 * you don't need the other CSS-style formats.
	 *
	 * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
	 * ```js
	 * Color.NAMES.aliceblue // returns 0xF0F8FF
	 * ```
	 *
	 * @param {string} style - The color name.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setColorName(style, colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        // color keywords
        const hex = $2358b7e4ec07df88$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace);
        else // unknown color
        $2358b7e4ec07df88$export$c106dd0671a0fc2d('Color: Unknown color ' + style);
        return this;
    }
    /**
	 * Returns a new color with copied values from this instance.
	 *
	 * @return {Color} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    /**
	 * Copies the values of the given color to this instance.
	 *
	 * @param {Color} color - The color to copy.
	 * @return {Color} A reference to this color.
	 */ copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copySRGBToLinear(color) {
        this.r = $2358b7e4ec07df88$var$SRGBToLinear(color.r);
        this.g = $2358b7e4ec07df88$var$SRGBToLinear(color.g);
        this.b = $2358b7e4ec07df88$var$SRGBToLinear(color.b);
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copyLinearToSRGB(color) {
        this.r = $2358b7e4ec07df88$var$LinearToSRGB(color.r);
        this.g = $2358b7e4ec07df88$var$LinearToSRGB(color.g);
        this.b = $2358b7e4ec07df88$var$LinearToSRGB(color.b);
        return this;
    }
    /**
	 * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    /**
	 * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    /**
	 * Returns the hexadecimal value of this color.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {number} The hexadecimal value.
	 */ getHex(colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        $2358b7e4ec07df88$export$5e6fd513f44698c.workingToColorSpace($2358b7e4ec07df88$var$_color.copy(this), colorSpace);
        return Math.round($2358b7e4ec07df88$var$clamp($2358b7e4ec07df88$var$_color.r * 255, 0, 255)) * 65536 + Math.round($2358b7e4ec07df88$var$clamp($2358b7e4ec07df88$var$_color.g * 255, 0, 255)) * 256 + Math.round($2358b7e4ec07df88$var$clamp($2358b7e4ec07df88$var$_color.b * 255, 0, 255));
    }
    /**
	 * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The hexadecimal value as a string.
	 */ getHexString(colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    /**
	 * Converts the colors RGB values into the HSL format and stores them into the
	 * given target object.
	 *
	 * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {{h:number,s:number,l:number}} The HSL representation of this color.
	 */ getHSL(target, colorSpace = $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $2358b7e4ec07df88$export$5e6fd513f44698c.workingToColorSpace($2358b7e4ec07df88$var$_color.copy(this), colorSpace);
        const r = $2358b7e4ec07df88$var$_color.r, g = $2358b7e4ec07df88$var$_color.g, b = $2358b7e4ec07df88$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    /**
	 * Returns the RGB values of this color and stores them into the given target object.
	 *
	 * @param {Color} target - The target color that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} The RGB representation of this color.
	 */ getRGB(target, colorSpace = $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace) {
        $2358b7e4ec07df88$export$5e6fd513f44698c.workingToColorSpace($2358b7e4ec07df88$var$_color.copy(this), colorSpace);
        target.r = $2358b7e4ec07df88$var$_color.r;
        target.g = $2358b7e4ec07df88$var$_color.g;
        target.b = $2358b7e4ec07df88$var$_color.b;
        return target;
    }
    /**
	 * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The CSS representation of this color.
	 */ getStyle(colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        $2358b7e4ec07df88$export$5e6fd513f44698c.workingToColorSpace($2358b7e4ec07df88$var$_color.copy(this), colorSpace);
        const r = $2358b7e4ec07df88$var$_color.r, g = $2358b7e4ec07df88$var$_color.g, b = $2358b7e4ec07df88$var$_color.b;
        if (colorSpace !== $2358b7e4ec07df88$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    /**
	 * Adds the given HSL values to this color's values.
	 * Internally, this converts the color's RGB values to HSL, adds HSL
	 * and then converts the color back to RGB.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @return {Color} A reference to this color.
	 */ offsetHSL(h, s, l) {
        this.getHSL($2358b7e4ec07df88$var$_hslA);
        return this.setHSL($2358b7e4ec07df88$var$_hslA.h + h, $2358b7e4ec07df88$var$_hslA.s + s, $2358b7e4ec07df88$var$_hslA.l + l);
    }
    /**
	 * Adds the RGB values of the given color to the RGB values of this color.
	 *
	 * @param {Color} color - The color to add.
	 * @return {Color} A reference to this color.
	 */ add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    /**
	 * Adds the RGB values of the given colors and stores the result in this instance.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @return {Color} A reference to this color.
	 */ addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    /**
	 * Adds the given scalar value to the RGB values of this color.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Color} A reference to this color.
	 */ addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    /**
	 * Subtracts the RGB values of the given color from the RGB values of this color.
	 *
	 * @param {Color} color - The color to subtract.
	 * @return {Color} A reference to this color.
	 */ sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    /**
	 * Multiplies the RGB values of the given color with the RGB values of this color.
	 *
	 * @param {Color} color - The color to multiply.
	 * @return {Color} A reference to this color.
	 */ multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    /**
	 * Multiplies the given scalar value with the RGB values of this color.
	 *
	 * @param {number} s - The scalar to multiply.
	 * @return {Color} A reference to this color.
	 */ multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    /**
	 * Linearly interpolates this color's RGB values toward the RGB values of the
	 * given color. The alpha argument can be thought of as the ratio between
	 * the two colors, where `0.0` is this color and `1.0` is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given colors and stores the result in this instance.
	 * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
	 * is the first and `1.0` is the second color.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates this color's HSL values toward the HSL values of the
	 * given color. It differs from {@link Color#lerp} by not interpolating straight
	 * from one color to the other, but instead going through all the hues in between
	 * those two colors. The alpha argument can be thought of as the ratio between
	 * the two colors, where 0.0 is this color and 1.0 is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpHSL(color, alpha) {
        this.getHSL($2358b7e4ec07df88$var$_hslA);
        color.getHSL($2358b7e4ec07df88$var$_hslB);
        const h = $2358b7e4ec07df88$var$lerp($2358b7e4ec07df88$var$_hslA.h, $2358b7e4ec07df88$var$_hslB.h, alpha);
        const s = $2358b7e4ec07df88$var$lerp($2358b7e4ec07df88$var$_hslA.s, $2358b7e4ec07df88$var$_hslB.s, alpha);
        const l = $2358b7e4ec07df88$var$lerp($2358b7e4ec07df88$var$_hslA.l, $2358b7e4ec07df88$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    /**
	 * Sets the color's RGB components from the given 3D vector.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Color} A reference to this color.
	 */ setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    /**
	 * Transforms this color with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix.
	 * @return {Color} A reference to this color.
	 */ applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    /**
	 * Returns `true` if this color is equal with the given one.
	 *
	 * @param {Color} c - The color to test for equality.
	 * @return {boolean} Whether this bounding color is equal with the given one.
	 */ equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    /**
	 * Sets this color's RGB components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the RGB values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Color} A reference to this color.
	 */ fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    /**
	 * Writes the RGB components of this color to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the color components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The color components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    /**
	 * Sets the components of this color from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding color data.
	 * @param {number} index - The index into the attribute.
	 * @return {Color} A reference to this color.
	 */ fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the color
	 * as a hexadecimal value.
	 *
	 * @return {number} The hexadecimal value.
	 */ toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $2358b7e4ec07df88$var$_color = /*@__PURE__*/ new $2358b7e4ec07df88$export$892596cec99bc70e();
/**
 * A dictionary with X11 color names.
 *
 * Note that multiple words such as Dark Orange become the string 'darkorange'.
 *
 * @static
 * @type {Object}
 */ $2358b7e4ec07df88$export$892596cec99bc70e.NAMES = $2358b7e4ec07df88$var$_colorKeywords;
let $2358b7e4ec07df88$var$_materialId = 0;
/**
 * Abstract base class for materials.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$a2d8b23205c25948 extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new material.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMaterial = true;
        /**
		 * The ID of the material.
		 *
		 * @name Material#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_materialId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Material';
        /**
		 * Defines the blending type of the material.
		 *
		 * It must be set to `CustomBlending` if custom blending properties like
		 * {@link Material#blendSrc}, {@link Material#blendDst} or {@link Material#blendEquation}
		 * should have any effect.
		 *
		 * @type {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending)}
		 * @default NormalBlending
		 */ this.blending = $2358b7e4ec07df88$export$5b29a26d96ee6af0;
        /**
		 * Defines which side of faces will be rendered - front, back or both.
		 *
		 * @type {(FrontSide|BackSide|DoubleSide)}
		 * @default FrontSide
		 */ this.side = $2358b7e4ec07df88$export$2ede184fc2998901;
        /**
		 * If set to `true`, vertex colors should be used.
		 *
		 * The engine supports RGB and RGBA vertex colors depending on whether a three (RGB) or
		 * four (RGBA) component color buffer attribute is used.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.vertexColors = false;
        /**
		 * Defines how transparent the material is.
		 * A value of `0.0` indicates fully transparent, `1.0` is fully opaque.
		 *
		 * If the {@link Material#transparent} is not set to `true`,
		 * the material will remain fully opaque and this value will only affect its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.opacity = 1;
        /**
		 * Defines whether this material is transparent. This has an effect on
		 * rendering as transparent objects need special treatment and are rendered
		 * after non-transparent objects.
		 *
		 * When set to true, the extent to which the material is transparent is
		 * controlled by {@link Material#opacity}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transparent = false;
        /**
		 * Enables alpha hashed transparency, an alternative to {@link Material#transparent} or
		 * {@link Material#alphaTest}. The material will not be rendered if opacity is lower than
		 * a random threshold. Randomization introduces some grain or noise, but approximates alpha
		 * blending without the associated problems of sorting. Using TAA can reduce the resulting noise.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaHash = false;
        /**
		 * Defines the blending source factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default SrcAlphaFactor
		 */ this.blendSrc = $2358b7e4ec07df88$export$d5773124e86cf28c;
        /**
		 * Defines the blending destination factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default OneMinusSrcAlphaFactor
		 */ this.blendDst = $2358b7e4ec07df88$export$11d468cc7f19e971;
        /**
		 * Defines the blending equation.
		 *
		 * @type {(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default AddEquation
		 */ this.blendEquation = $2358b7e4ec07df88$export$20183a0484ce21a0;
        /**
		 * Defines the blending source alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendSrcAlpha = null;
        /**
		 * Defines the blending destination alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendDstAlpha = null;
        /**
		 * Defines the blending equation of the alpha channel.
		 *
		 * @type {?(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default null
		 */ this.blendEquationAlpha = null;
        /**
		 * Represents the RGB values of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantColor` or `OneMinusConstantColor`.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.blendColor = new $2358b7e4ec07df88$export$892596cec99bc70e(0, 0, 0);
        /**
		 * Represents the alpha value of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantAlpha` or `OneMinusConstantAlpha`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.blendAlpha = 0;
        /**
		 * Defines the depth function.
		 *
		 * @type {(NeverDepth|AlwaysDepth|LessDepth|LessEqualDepth|EqualDepth|GreaterEqualDepth|GreaterDepth|NotEqualDepth)}
		 * @default LessEqualDepth
		 */ this.depthFunc = $2358b7e4ec07df88$export$296f78a0b892f81a;
        /**
		 * Whether to have depth test enabled when rendering this material.
		 * When the depth test is disabled, the depth write will also be implicitly disabled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthTest = true;
        /**
		 * Whether rendering this material has any effect on the depth buffer.
		 *
		 * When drawing 2D overlays it can be useful to disable the depth writing in
		 * order to layer several things together without creating z-index artifacts.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthWrite = true;
        /**
		 * The bit mask to use when writing to the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilWriteMask = 0xff;
        /**
		 * The stencil comparison function to use.
		 *
		 * @type {NeverStencilFunc|LessStencilFunc|EqualStencilFunc|LessEqualStencilFunc|GreaterStencilFunc|NotEqualStencilFunc|GreaterEqualStencilFunc|AlwaysStencilFunc}
		 * @default AlwaysStencilFunc
		 */ this.stencilFunc = $2358b7e4ec07df88$export$14cf96713ddd97a8;
        /**
		 * The value to use when performing stencil comparisons or stencil operations.
		 *
		 * @type {number}
		 * @default 0
		 */ this.stencilRef = 0;
        /**
		 * The bit mask to use when comparing against the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilFuncMask = 0xff;
        /**
		 * Which stencil operation to perform when the comparison function returns `false`.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilFail = $2358b7e4ec07df88$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` but the depth test fails.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZFail = $2358b7e4ec07df88$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` and the depth test passes.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZPass = $2358b7e4ec07df88$export$9f542ae4b5baca34;
        /**
		 * Whether stencil operations are performed against the stencil buffer. In
		 * order to perform writes or comparisons against the stencil buffer this
		 * value must be `true`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilWrite = false;
        /**
		 * User-defined clipping planes specified as THREE.Plane objects in world
		 * space. These planes apply to the objects this material is attached to.
		 * Points in space whose signed distance to the plane is negative are clipped
		 * (not rendered). This requires {@link WebGLRenderer#localClippingEnabled} to
		 * be `true`.
		 *
		 * @type {?Array<Plane>}
		 * @default null
		 */ this.clippingPlanes = null;
        /**
		 * Changes the behavior of clipping planes so that only their intersection is
		 * clipped, rather than their union.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipIntersection = false;
        /**
		 * Defines whether to clip shadows according to the clipping planes specified
		 * on this material.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipShadows = false;
        /**
		 * Defines which side of faces cast shadows. If `null`, the side casting shadows
		 * is determined as follows:
		 *
		 * - When {@link Material#side} is set to `FrontSide`, the back side cast shadows.
		 * - When {@link Material#side} is set to `BackSide`, the front side cast shadows.
		 * - When {@link Material#side} is set to `DoubleSide`, both sides cast shadows.
		 *
		 * @type {?(FrontSide|BackSide|DoubleSide)}
		 * @default null
		 */ this.shadowSide = null;
        /**
		 * Whether to render the material's color.
		 *
		 * This can be used in conjunction with {@link Object3D#renderOder} to create invisible
		 * objects that occlude other objects.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.colorWrite = true;
        /**
		 * Override the renderer's default precision for this material.
		 *
		 * @type {?('highp'|'mediump'|'lowp')}
		 * @default null
		 */ this.precision = null;
        /**
		 * Whether to use polygon offset or not. When enabled, each fragment's depth value will
		 * be offset after it is interpolated from the depth values of the appropriate vertices.
		 * The offset is added before the depth test is performed and before the value is written
		 * into the depth buffer.
		 *
		 * Can be useful for rendering hidden-line images, for applying decals to surfaces, and for
		 * rendering solids with highlighted edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.polygonOffset = false;
        /**
		 * Specifies a scale factor that is used to create a variable depth offset for each polygon.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetFactor = 0;
        /**
		 * Is multiplied by an implementation-specific value to create a constant depth offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetUnits = 0;
        /**
		 * Whether to apply dithering to the color to remove the appearance of banding.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.dithering = false;
        /**
		 * Whether alpha to coverage should be enabled or not. Can only be used with MSAA-enabled contexts
		 * (meaning when the renderer was created with *antialias* parameter set to `true`). Enabling this
		 * will smooth aliasing on clip plane edges and alphaTest-clipped edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaToCoverage = false;
        /**
		 * Whether to premultiply the alpha (transparency) value.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultipliedAlpha = false;
        /**
		 * Whether double-sided, transparent objects should be rendered with a single pass or not.
		 *
		 * The engine renders double-sided, transparent objects with two draw calls (back faces first,
		 * then front faces) to mitigate transparency artifacts. There are scenarios however where this
		 * approach produces no quality gains but still doubles draw calls e.g. when rendering flat
		 * vegetation like grass sprites. In these cases, set the `forceSinglePass` flag to `true` to
		 * disable the two pass rendering to avoid performance issues.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.forceSinglePass = false;
        /**
		 * Whether it's possible to override the material with {@link Scene#overrideMaterial} or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.allowOverride = true;
        /**
		 * Defines whether 3D objects using this material are visible.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * Defines whether this material is tone mapped according to the renderer's tone mapping setting.
		 *
		 * It is ignored when rendering to a render target or using post processing or when using
		 * `WebGPURenderer`. In all these cases, all materials are honored by tone mapping.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.toneMapped = true;
        /**
		 * An object that can be used to store custom data about the Material. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This starts at `0` and counts how many times {@link Material#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        this._alphaTest = 0;
    }
    /**
	 * Sets the alpha value to be used when running an alpha test. The material
	 * will not be rendered if the opacity is lower than this value.
	 *
	 * @type {number}
	 * @readonly
	 * @default 0
	 */ get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    /**
	 * An optional callback that is executed immediately before the material is used to render a 3D object.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Object3D} object - The 3D object.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * An optional callback that is executed immediately before the shader
	 * program is compiled. This function is called with the shader source code
	 * as a parameter. Useful for the modification of built-in materials.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}. The
	 * recommended approach when customizing materials is to use `WebGPURenderer` with the new
	 * Node Material system and [TSL](https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language).
	 *
	 * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
	 * @param {WebGLRenderer} renderer - A reference to the renderer.
	 */ onBeforeCompile() {}
    /**
	 * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
	 * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
	 * shader or recompile the shader for this material as needed.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @return {string} The custom program cache key.
	 */ customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    /**
	 * This method can be used to set default values from parameter objects.
	 * It is a generic implementation so it can be used with different types
	 * of materials.
	 *
	 * @param {Object} [values] - The material values to set.
	 */ setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                $2358b7e4ec07df88$export$c106dd0671a0fc2d(`Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                $2358b7e4ec07df88$export$c106dd0671a0fc2d(`Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the material into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized material.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.7,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.sheenColorMap && this.sheenColorMap.isTexture) data.sheenColorMap = this.sheenColorMap.toJSON(meta).uuid;
        if (this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture) data.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(meta).uuid;
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $2358b7e4ec07df88$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $2358b7e4ec07df88$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $2358b7e4ec07df88$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $2358b7e4ec07df88$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $2358b7e4ec07df88$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $2358b7e4ec07df88$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $2358b7e4ec07df88$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $2358b7e4ec07df88$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $2358b7e4ec07df88$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $2358b7e4ec07df88$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.allowOverride === false) data.allowOverride = false;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    /**
	 * Returns a new material with copied values from this instance.
	 *
	 * @return {Material} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given material to this instance.
	 *
	 * @param {Material} source - The material to copy.
	 * @return {Material} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.allowOverride = source.allowOverride;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Material#dispose
	 */ dispose() {
        /**
		 * Fires when the material has been disposed of.
		 *
		 * @event Material#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Setting this property to `true` indicates the engine the material
	 * needs to be recompiled.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
/**
 * A material for drawing geometries in a simple shaded (flat or wireframe) way.
 *
 * This material is not affected by lights.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshBasicMaterial
 */ class $2358b7e4ec07df88$export$55cbcc9b622fe1f5 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $2358b7e4ec07df88$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $2358b7e4ec07df88$var$_tables = /*@__PURE__*/ $2358b7e4ec07df88$var$_generateTables();
function $2358b7e4ec07df88$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
/**
 * Returns a half precision floating point value (FP16) from the given single
 * precision floating point value (FP32).
 *
 * @param {number} val - A single precision floating point value.
 * @return {number} The FP16 value.
 */ function $2358b7e4ec07df88$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) $2358b7e4ec07df88$export$c106dd0671a0fc2d('DataUtils.toHalfFloat(): Value out of range.');
    val = $2358b7e4ec07df88$var$clamp(val, -65504, 65504);
    $2358b7e4ec07df88$var$_tables.floatView[0] = val;
    const f = $2358b7e4ec07df88$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $2358b7e4ec07df88$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $2358b7e4ec07df88$var$_tables.shiftTable[e]);
}
/**
 * Returns a single precision floating point value (FP32) from the given half
 * precision floating point value (FP16).
 *
 * @param {number} val - A half precision floating point value.
 * @return {number} The FP32 value.
 */ function $2358b7e4ec07df88$var$fromHalfFloat(val) {
    const m = val >> 10;
    $2358b7e4ec07df88$var$_tables.uint32View[0] = $2358b7e4ec07df88$var$_tables.mantissaTable[$2358b7e4ec07df88$var$_tables.offsetTable[m] + (val & 0x3ff)] + $2358b7e4ec07df88$var$_tables.exponentTable[m];
    return $2358b7e4ec07df88$var$_tables.floatView[0];
}
/**
 * A class containing utility functions for data.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$11ce8b759162cc80 {
    /**
	 * Returns a half precision floating point value (FP16) from the given single
	 * precision floating point value (FP32).
	 *
	 * @param {number} val - A single precision floating point value.
	 * @return {number} The FP16 value.
	 */ static toHalfFloat(val) {
        return $2358b7e4ec07df88$var$toHalfFloat(val);
    }
    /**
	 * Returns a single precision floating point value (FP32) from the given half
	 * precision floating point value (FP16).
	 *
	 * @param {number} val - A half precision floating point value.
	 * @return {number} The FP32 value.
	 */ static fromHalfFloat(val) {
        return $2358b7e4ec07df88$var$fromHalfFloat(val);
    }
}
const $2358b7e4ec07df88$var$_vector$9 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vector2$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
let $2358b7e4ec07df88$var$_id$2 = 0;
/**
 * This class stores data for an attribute (such as vertex positions, face
 * indices, normals, colors, UVs, and any custom attributes ) associated with
 * a geometry, which allows for more efficient passing of data to the GPU.
 *
 * When working with vector-like data, the `fromBufferAttribute( attribute, index )`
 * helper methods on vector and color class might be helpful. E.g. {@link Vector3#fromBufferAttribute}.
 */ class $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferAttribute = true;
        /**
		 * The ID of the buffer attribute.
		 *
		 * @name BufferAttribute#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_id$2++
        });
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The array holding the attribute data. It should have `itemSize * numVertices`
		 * elements, where `numVertices` is the number of vertices in the associated geometry.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of values of the array that should be associated with a particular vertex.
		 * For instance, if this attribute is storing a 3-component vector (such as a position,
		 * normal, or color), then the value should be `3`.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * Represents the number of items this buffer attribute stores. It is internally computed
		 * by dividing the `array` length by the `itemSize`.
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / itemSize : 0;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `array` is an instance of `UInt16Array`,
		 * and `normalized` is `true`, the values `0 - +65535` in the array data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $2358b7e4ec07df88$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * Configures the bound GPU type for use in shaders.
		 *
		 * Note: this only has an effect for integer arrays and is not configurable for float arrays.
		 * For lower precision float types, use `Float16BufferAttribute`.
		 *
		 * @type {(FloatType|IntType)}
		 * @default FloatType
		 */ this.gpuType = $2358b7e4ec07df88$export$f6d331659b644596;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute
	 * array data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this buffer attribute.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {BufferAttribute} A reference to this buffer attribute.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given buffer attribute to this instance.
	 *
	 * @param {BufferAttribute} source - The buffer attribute to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    /**
	 * Copies a vector from the given buffer attribute to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this buffer attribute.
	 * @param {BufferAttribute} attribute - The buffer attribute to copy from.
	 * @param {number} index2 - The source index into the given buffer attribute.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    /**
	 * Copies the given array data into this buffer attribute.
	 *
	 * @param {(TypedArray|Array)} array - The array to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyArray(array) {
        this.array.set(array);
        return this;
    }
    /**
	 * Applies the given 3x3 matrix to the given attribute. Works with
	 * item size `2` and `3`.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector2$1.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $2358b7e4ec07df88$var$_vector2$1.x, $2358b7e4ec07df88$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$9.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$9.x, $2358b7e4ec07df88$var$_vector$9.y, $2358b7e4ec07df88$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$9.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$9.x, $2358b7e4ec07df88$var$_vector$9.y, $2358b7e4ec07df88$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$9.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$9.x, $2358b7e4ec07df88$var$_vector$9.y, $2358b7e4ec07df88$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$9.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$9.x, $2358b7e4ec07df88$var$_vector$9.y, $2358b7e4ec07df88$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Sets the given array data in the buffer attribute.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this buffer attribute's array.
	 * @return {BufferAttribute} A reference to this instance.
	 */ set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $2358b7e4ec07df88$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $2358b7e4ec07df88$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $2358b7e4ec07df88$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $2358b7e4ec07df88$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $2358b7e4ec07df88$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $2358b7e4ec07df88$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $2358b7e4ec07df88$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $2358b7e4ec07df88$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $2358b7e4ec07df88$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $2358b7e4ec07df88$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
            w = $2358b7e4ec07df88$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the attribute array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when attribute data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {BufferAttribute} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * @return {BufferAttribute} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $2358b7e4ec07df88$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
}
/**
 * Convenient class that can be used when creating a `Int8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$f9ff2d6a20248cbf extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$cacc90cf35d11cdd extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8Clamped` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$baaa85a1a812c157 extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8ClampedArray)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$2b755a102ccdcefe extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$640a853f68025f2e extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$46b369aed2968a0a extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$7eb8c9fa25cd5bd6 extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Float16` buffer attribute with
 * a plain `Array` instance.
 *
 * This class automatically converts to and from FP16 via `Uint16Array` since `Float16Array`
 * browser support is still problematic.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$dbd3698c64958d69 extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $2358b7e4ec07df88$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $2358b7e4ec07df88$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $2358b7e4ec07df88$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $2358b7e4ec07df88$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $2358b7e4ec07df88$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $2358b7e4ec07df88$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $2358b7e4ec07df88$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $2358b7e4ec07df88$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $2358b7e4ec07df88$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $2358b7e4ec07df88$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $2358b7e4ec07df88$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $2358b7e4ec07df88$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $2358b7e4ec07df88$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $2358b7e4ec07df88$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $2358b7e4ec07df88$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $2358b7e4ec07df88$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
        }
        this.array[index + 0] = $2358b7e4ec07df88$var$toHalfFloat(x);
        this.array[index + 1] = $2358b7e4ec07df88$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
        }
        this.array[index + 0] = $2358b7e4ec07df88$var$toHalfFloat(x);
        this.array[index + 1] = $2358b7e4ec07df88$var$toHalfFloat(y);
        this.array[index + 2] = $2358b7e4ec07df88$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
            w = $2358b7e4ec07df88$var$normalize(w, this.array);
        }
        this.array[index + 0] = $2358b7e4ec07df88$var$toHalfFloat(x);
        this.array[index + 1] = $2358b7e4ec07df88$var$toHalfFloat(y);
        this.array[index + 2] = $2358b7e4ec07df88$var$toHalfFloat(z);
        this.array[index + 3] = $2358b7e4ec07df88$var$toHalfFloat(w);
        return this;
    }
}
/**
 * Convenient class that can be used when creating a `Float32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$cbe7a62641830ebd extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
let $2358b7e4ec07df88$var$_id$1 = 0;
const $2358b7e4ec07df88$var$_m1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_obj = /*@__PURE__*/ new $2358b7e4ec07df88$export$e4dd07dff30cc924();
const $2358b7e4ec07df88$var$_offset = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_box$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
const $2358b7e4ec07df88$var$_boxMorphTargets = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
const $2358b7e4ec07df88$var$_vector$8 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A representation of mesh, line, or point geometry. Includes vertex
 * positions, face indices, normals, colors, UVs, and custom attributes
 * within buffers, reducing the cost of passing all this data to the GPU.
 *
 * ```js
 * const geometry = new THREE.BufferGeometry();
 * // create a simple square shape. We duplicate the top left and bottom right
 * // vertices because each vertex needs to appear once per triangle.
 * const vertices = new Float32Array( [
 * 	-1.0, -1.0,  1.0, // v0
 * 	 1.0, -1.0,  1.0, // v1
 * 	 1.0,  1.0,  1.0, // v2
 *
 * 	 1.0,  1.0,  1.0, // v3
 * 	-1.0,  1.0,  1.0, // v4
 * 	-1.0, -1.0,  1.0  // v5
 * ] );
 * // itemSize = 3 because there are 3 values (components) per vertex
 * geometry.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ) );
 * const material = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * ```
 *
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$b7be63a67df8959 extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferGeometry = true;
        /**
		 * The ID of the geometry.
		 *
		 * @name BufferGeometry#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_id$1++
        });
        /**
		 * The UUID of the geometry.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * The name of the geometry.
		 *
		 * @type {string}
		 */ this.name = '';
        this.type = 'BufferGeometry';
        /**
		 * Allows for vertices to be re-used across multiple triangles; this is
		 * called using "indexed triangles". Each triangle is associated with the
		 * indices of three vertices. This attribute therefore stores the index of
		 * each vertex for each triangular face. If this attribute is not set, the
		 * renderer assumes that each three contiguous positions represent a single triangle.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.index = null;
        /**
		 * A (storage) buffer attribute which was generated with a compute shader and
		 * now defines indirect draw calls.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.indirect = null;
        /**
		 * The offset, in bytes, into the indirect drawing buffer where the value data begins. If an array is provided, multiple indirect draw calls will be made for each offset.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {number|Array<number>}
		 * @default 0
		 */ this.indirectOffset = 0;
        /**
		 * This dictionary has as id the name of the attribute to be set and as value
		 * the buffer attribute to set it to. Rather than accessing this property directly,
		 * use `setAttribute()` and `getAttribute()` to access attributes of this geometry.
		 *
		 * @type {Object<string,(BufferAttribute|InterleavedBufferAttribute)>}
		 */ this.attributes = {};
        /**
		 * This dictionary holds the morph targets of the geometry.
		 *
		 * Note: Once the geometry has been rendered, the morph attribute data cannot
		 * be changed. You will have to call `dispose()`, and create a new geometry instance.
		 *
		 * @type {Object}
		 */ this.morphAttributes = {};
        /**
		 * Used to control the morph target behavior; when set to `true`, the morph
		 * target data is treated as relative offsets, rather than as absolute
		 * positions/normals.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.morphTargetsRelative = false;
        /**
		 * Split the geometry into groups, each of which will be rendered in a
		 * separate draw call. This allows an array of materials to be used with the geometry.
		 *
		 * Use `addGroup()` and `clearGroups()` to edit groups, rather than modifying this array directly.
		 *
		 * Every vertex and index must belong to exactly one group — groups must not share vertices or
		 * indices, and must not leave vertices or indices unused.
		 *
		 * @type {Array<Object>}
		 */ this.groups = [];
        /**
		 * Bounding box for the geometry which can be calculated with `computeBoundingBox()`.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * Bounding sphere for the geometry which can be calculated with `computeBoundingSphere()`.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Determines the part of the geometry to render. This should not be set directly,
		 * instead use `setDrawRange()`.
		 *
		 * @type {{start:number,count:number}}
		 */ this.drawRange = {
            start: 0,
            count: Infinity
        };
        /**
		 * An object that can be used to store custom data about the geometry.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
    /**
	 * Returns the index of this geometry.
	 *
	 * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
	 */ getIndex() {
        return this.index;
    }
    /**
	 * Sets the given index to this geometry.
	 *
	 * @param {Array<number>|BufferAttribute} index - The index to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndex(index) {
        if (Array.isArray(index)) this.index = new ($2358b7e4ec07df88$export$bc6f937da07eae17(index) ? $2358b7e4ec07df88$export$7eb8c9fa25cd5bd6 : $2358b7e4ec07df88$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    /**
	 * Sets the given indirect attribute to this geometry.
	 *
	 * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
	 * @param {number|Array<number>} [indirectOffset=0] - The offset, in bytes, into the indirect drawing buffer where the value data begins. If an array is provided, multiple indirect draw calls will be made for each offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndirect(indirect, indirectOffset = 0) {
        this.indirect = indirect;
        this.indirectOffset = indirectOffset;
        return this;
    }
    /**
	 * Returns the indirect attribute of this geometry.
	 *
	 * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
	 */ getIndirect() {
        return this.indirect;
    }
    /**
	 * Returns the buffer attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
	 * Returns `undefined` if not attribute has been found.
	 */ getAttribute(name) {
        return this.attributes[name];
    }
    /**
	 * Sets the given attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    /**
	 * Deletes the attribute for the given name.
	 *
	 * @param {string} name - The attribute name to delete.
	 * @return {BufferGeometry} A reference to this instance.
	 */ deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    /**
	 * Returns `true` if this geometry has an attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {boolean} Whether this geometry has an attribute for the given name or not.
	 */ hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    /**
	 * Adds a group to this geometry.
	 *
	 * @param {number} start - The first element in this draw call. That is the first
	 * vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - Specifies how many vertices (or indices) are part of this group.
	 * @param {number} [materialIndex=0] - The material array index to use.
	 */ addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    /**
	 * Clears all groups.
	 */ clearGroups() {
        this.groups = [];
    }
    /**
	 * Sets the draw range for this geometry.
	 *
	 * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
	 * For indexed BufferGeometry, `count` is the number of indices to render.
	 */ setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    /**
	 * Applies the given 4x4 transformation matrix to the geometry.
	 *
	 * @param {Matrix4} matrix - The matrix to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $2358b7e4ec07df88$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    /**
	 * Applies the rotation represented by the Quaternion to the geometry.
	 *
	 * @param {Quaternion} q - The Quaternion to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyQuaternion(q) {
        $2358b7e4ec07df88$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the X axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateX(angle) {
        // rotate geometry around world x-axis
        $2358b7e4ec07df88$var$_m1.makeRotationX(angle);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Y axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateY(angle) {
        // rotate geometry around world y-axis
        $2358b7e4ec07df88$var$_m1.makeRotationY(angle);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Z axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateZ(angle) {
        // rotate geometry around world z-axis
        $2358b7e4ec07df88$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Translates the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#position} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x offset.
	 * @param {number} y - The y offset.
	 * @param {number} z - The z offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ translate(x, y, z) {
        // translate geometry
        $2358b7e4ec07df88$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Scales the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#scale} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x scale.
	 * @param {number} y - The y scale.
	 * @param {number} z - The z scale.
	 * @return {BufferGeometry} A reference to this instance.
	 */ scale(x, y, z) {
        // scale geometry
        $2358b7e4ec07df88$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry to face a point in 3D space. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
	 * real-time mesh rotation.
	 *
	 * @param {Vector3} vector - The target point.
	 * @return {BufferGeometry} A reference to this instance.
	 */ lookAt(vector) {
        $2358b7e4ec07df88$var$_obj.lookAt(vector);
        $2358b7e4ec07df88$var$_obj.updateMatrix();
        this.applyMatrix4($2358b7e4ec07df88$var$_obj.matrix);
        return this;
    }
    /**
	 * Center the geometry based on its bounding box.
	 *
	 * @return {BufferGeometry} A reference to this instance.
	 */ center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($2358b7e4ec07df88$var$_offset).negate();
        this.translate($2358b7e4ec07df88$var$_offset.x, $2358b7e4ec07df88$var$_offset.y, $2358b7e4ec07df88$var$_offset.z);
        return this;
    }
    /**
	 * Defines a geometry by creating a `position` attribute based on the given array of points. The array
	 * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
	 * set to `0`.
	 *
	 * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
	 * data from the array. The length of the array must match the vertex count.
	 *
	 * @param {Array<Vector2>|Array<Vector3>} points - The points.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setFromPoints(points) {
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute === undefined) {
            const position = [];
            for(let i = 0, l = points.length; i < l; i++){
                const point = points[i];
                position.push(point.x, point.y, point.z || 0);
            }
            this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(position, 3));
        } else {
            const l = Math.min(points.length, positionAttribute.count); // make sure data do not exceed buffer size
            for(let i = 0; i < l; i++){
                const point = points[i];
                positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
            }
            if (points.length > positionAttribute.count) $2358b7e4ec07df88$export$c106dd0671a0fc2d('BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
            positionAttribute.needsUpdate = true;
        }
        return this;
    }
    /**
	 * Computes the bounding box of the geometry, and updates the `boundingBox` member.
	 * The bounding box is not computed by the engine; it must be computed by your app.
	 * You may need to recompute the bounding box if the geometry vertices are modified.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new $2358b7e4ec07df88$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $2358b7e4ec07df88$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $2358b7e4ec07df88$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $2358b7e4ec07df88$var$_vector$8.addVectors(this.boundingBox.min, $2358b7e4ec07df88$var$_box$2.min);
                    this.boundingBox.expandByPoint($2358b7e4ec07df88$var$_vector$8);
                    $2358b7e4ec07df88$var$_vector$8.addVectors(this.boundingBox.max, $2358b7e4ec07df88$var$_box$2.max);
                    this.boundingBox.expandByPoint($2358b7e4ec07df88$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($2358b7e4ec07df88$var$_box$2.min);
                    this.boundingBox.expandByPoint($2358b7e4ec07df88$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) $2358b7e4ec07df88$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    /**
	 * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if the geometry vertices are modified.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new $2358b7e4ec07df88$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $2358b7e4ec07df88$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $2358b7e4ec07df88$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $2358b7e4ec07df88$var$_vector$8.addVectors($2358b7e4ec07df88$var$_box$2.min, $2358b7e4ec07df88$var$_boxMorphTargets.min);
                    $2358b7e4ec07df88$var$_box$2.expandByPoint($2358b7e4ec07df88$var$_vector$8);
                    $2358b7e4ec07df88$var$_vector$8.addVectors($2358b7e4ec07df88$var$_box$2.max, $2358b7e4ec07df88$var$_boxMorphTargets.max);
                    $2358b7e4ec07df88$var$_box$2.expandByPoint($2358b7e4ec07df88$var$_vector$8);
                } else {
                    $2358b7e4ec07df88$var$_box$2.expandByPoint($2358b7e4ec07df88$var$_boxMorphTargets.min);
                    $2358b7e4ec07df88$var$_box$2.expandByPoint($2358b7e4ec07df88$var$_boxMorphTargets.max);
                }
            }
            $2358b7e4ec07df88$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $2358b7e4ec07df88$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($2358b7e4ec07df88$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $2358b7e4ec07df88$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $2358b7e4ec07df88$var$_offset.fromBufferAttribute(position, j);
                        $2358b7e4ec07df88$var$_vector$8.add($2358b7e4ec07df88$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($2358b7e4ec07df88$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) $2358b7e4ec07df88$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    /**
	 * Calculates and adds a tangent attribute to this geometry.
	 *
	 * The computation is only supported for indexed geometries and if position, normal, and uv attributes
	 * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
	 * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
	 */ computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $2358b7e4ec07df88$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $2358b7e4ec07df88$export$64b5c384219d3699();
            tan2[i] = new $2358b7e4ec07df88$export$64b5c384219d3699();
        }
        const vA = new $2358b7e4ec07df88$export$64b5c384219d3699(), vB = new $2358b7e4ec07df88$export$64b5c384219d3699(), vC = new $2358b7e4ec07df88$export$64b5c384219d3699(), uvA = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), uvB = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), uvC = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), sdir = new $2358b7e4ec07df88$export$64b5c384219d3699(), tdir = new $2358b7e4ec07df88$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $2358b7e4ec07df88$export$64b5c384219d3699(), tmp2 = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const n = new $2358b7e4ec07df88$export$64b5c384219d3699(), n2 = new $2358b7e4ec07df88$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    /**
	 * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
	 * each vertex normal to be the average of the face normals of the faces that share that vertex.
	 * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
	 * to be the same as the face normal.
	 */ computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $2358b7e4ec07df88$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $2358b7e4ec07df88$export$64b5c384219d3699(), pB = new $2358b7e4ec07df88$export$64b5c384219d3699(), pC = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const nA = new $2358b7e4ec07df88$export$64b5c384219d3699(), nB = new $2358b7e4ec07df88$export$64b5c384219d3699(), nC = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const cb = new $2358b7e4ec07df88$export$64b5c384219d3699(), ab = new $2358b7e4ec07df88$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    /**
	 * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
	 * correct lighting on the geometry surfaces.
	 */ normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $2358b7e4ec07df88$var$_vector$8.fromBufferAttribute(normals, i);
            $2358b7e4ec07df88$var$_vector$8.normalize();
            normals.setXYZ(i, $2358b7e4ec07df88$var$_vector$8.x, $2358b7e4ec07df88$var$_vector$8.y, $2358b7e4ec07df88$var$_vector$8.z);
        }
    }
    /**
	 * Return a new non-index version of this indexed geometry. If the geometry
	 * is already non-indexed, the method is a NOOP.
	 *
	 * @return {BufferGeometry} The non-indexed version of this indexed geometry.
	 */ toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $2358b7e4ec07df88$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $2358b7e4ec07df88$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    /**
	 * Serializes the geometry into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized geometry.
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = boundingSphere.toJSON();
        return data;
    }
    /**
	 * Returns a new geometry with copied values from this instance.
	 *
	 * @return {BufferGeometry} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given geometry to this instance.
	 *
	 * @param {BufferGeometry} source - The geometry to copy.
	 * @return {BufferGeometry} A reference to this instance.
	 */ copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone());
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires BufferGeometry#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $2358b7e4ec07df88$var$_inverseMatrix$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_ray$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$a186db52eed6d40e();
const $2358b7e4ec07df88$var$_sphere$6 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_sphereHitAt = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vA$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vB$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vC$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_tempA = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_morphA = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_intersectionPoint = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_intersectionPointWorld = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Class representing triangular polygon mesh based objects.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$e176487c05830cc5 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry = new $2358b7e4ec07df88$export$b7be63a67df8959(), material = new $2358b7e4ec07df88$export$55cbcc9b622fe1f5()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMesh = true;
        this.type = 'Mesh';
        /**
		 * The mesh geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The mesh material.
		 *
		 * @type {Material|Array<Material>}
		 * @default MeshBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        /**
		 * The number of instances of this mesh.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    /**
	 * Returns the local-space position of the vertex at the given index, taking into
	 * account the current animation state of both morph targets and skinning.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * @return {Vector3} The vertex position in local space.
	 */ getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $2358b7e4ec07df88$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $2358b7e4ec07df88$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $2358b7e4ec07df88$var$_morphA.addScaledVector($2358b7e4ec07df88$var$_tempA, influence);
                else $2358b7e4ec07df88$var$_morphA.addScaledVector($2358b7e4ec07df88$var$_tempA.sub(target), influence);
            }
            target.add($2358b7e4ec07df88$var$_morphA);
        }
        return target;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $2358b7e4ec07df88$var$_sphere$6.copy(geometry.boundingSphere);
        $2358b7e4ec07df88$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $2358b7e4ec07df88$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($2358b7e4ec07df88$var$_sphere$6.containsPoint($2358b7e4ec07df88$var$_ray$3.origin) === false) {
            if ($2358b7e4ec07df88$var$_ray$3.intersectSphere($2358b7e4ec07df88$var$_sphere$6, $2358b7e4ec07df88$var$_sphereHitAt) === null) return;
            if ($2358b7e4ec07df88$var$_ray$3.origin.distanceToSquared($2358b7e4ec07df88$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $2358b7e4ec07df88$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $2358b7e4ec07df88$var$_ray$3.copy(raycaster.ray).applyMatrix4($2358b7e4ec07df88$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($2358b7e4ec07df88$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $2358b7e4ec07df88$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $2358b7e4ec07df88$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $2358b7e4ec07df88$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $2358b7e4ec07df88$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $2358b7e4ec07df88$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $2358b7e4ec07df88$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $2358b7e4ec07df88$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $2358b7e4ec07df88$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $2358b7e4ec07df88$var$_intersectionPointWorld.copy(point);
    $2358b7e4ec07df88$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($2358b7e4ec07df88$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $2358b7e4ec07df88$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $2358b7e4ec07df88$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $2358b7e4ec07df88$var$_vA$1);
    object.getVertexPosition(b, $2358b7e4ec07df88$var$_vB$1);
    object.getVertexPosition(c, $2358b7e4ec07df88$var$_vC$1);
    const intersection = $2358b7e4ec07df88$var$checkIntersection$1(object, material, raycaster, ray, $2358b7e4ec07df88$var$_vA$1, $2358b7e4ec07df88$var$_vB$1, $2358b7e4ec07df88$var$_vC$1, $2358b7e4ec07df88$var$_intersectionPoint);
    if (intersection) {
        const barycoord = new $2358b7e4ec07df88$export$64b5c384219d3699();
        $2358b7e4ec07df88$export$5a465592bfe74b48.getBarycoord($2358b7e4ec07df88$var$_intersectionPoint, $2358b7e4ec07df88$var$_vA$1, $2358b7e4ec07df88$var$_vB$1, $2358b7e4ec07df88$var$_vC$1, barycoord);
        if (uv) intersection.uv = $2358b7e4ec07df88$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $2358b7e4ec07df88$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $2358b7e4ec07df88$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $2358b7e4ec07df88$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $2358b7e4ec07df88$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $2358b7e4ec07df88$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $2358b7e4ec07df88$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $2358b7e4ec07df88$export$5a465592bfe74b48.getNormal($2358b7e4ec07df88$var$_vA$1, $2358b7e4ec07df88$var$_vB$1, $2358b7e4ec07df88$var$_vC$1, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
/**
 * A geometry class for a rectangular cuboid with a given width, height, and depth.
 * On creation, the cuboid is centred on the origin, with each edge parallel to one
 * of the axes.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const cube = new THREE.Mesh( geometry, material );
 * scene.add( cube );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#BoxGeometry
 */ class $2358b7e4ec07df88$export$33e43285f7406bd5 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new box geometry.
	 *
	 * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
	 * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
	 * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
	 * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
	 * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
	 * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
	 */ constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $2358b7e4ec07df88$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {BoxGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Provides utility functions for managing uniforms.
 *
 * @module UniformsUtils
 */ /**
 * Clones the given uniform definitions by performing a deep-copy. That means
 * if the value of a uniform refers to an object like a Vector3 or Texture,
 * the cloned uniform will refer to a new object reference.
 *
 * @param {Object} src - An object representing uniform definitions.
 * @return {Object} The cloned uniforms.
 */ function $2358b7e4ec07df88$export$acda854380553452(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    $2358b7e4ec07df88$export$c106dd0671a0fc2d('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
/**
 * Merges the given uniform definitions into a single object. Since the
 * method internally uses cloneUniforms(), it performs a deep-copy when
 * producing the merged uniform definitions.
 *
 * @param {Array} uniforms - An array of objects containing uniform definitions.
 * @return {Object} The merged uniforms.
 */ function $2358b7e4ec07df88$export$8916ce6879271f43(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $2358b7e4ec07df88$export$acda854380553452(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $2358b7e4ec07df88$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $2358b7e4ec07df88$export$a630742c640528c1(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $2358b7e4ec07df88$export$d8ecdf8615bfea69 = {
    clone: $2358b7e4ec07df88$export$acda854380553452,
    merge: $2358b7e4ec07df88$export$8916ce6879271f43
};
var $2358b7e4ec07df88$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $2358b7e4ec07df88$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * A material rendered with custom shaders. A shader is a small program written in GLSL.
 * that runs on the GPU. You may want to use a custom shader if you need to implement an
 * effect not included with any of the built-in materials.
 *
 * There are the following notes to bear in mind when using a `ShaderMaterial`:
 *
 * - `ShaderMaterial` can only be used with {@link WebGLRenderer}.
 * - Built in attributes and uniforms are passed to the shaders along with your code. If
 * you don't want that, use {@link RawShaderMaterial} instead.
 * - You can use the directive `#pragma unroll_loop_start` and `#pragma unroll_loop_end`
 * in order to unroll a `for` loop in GLSL by the shader preprocessor. The directive has
 * to be placed right above the loop. The loop formatting has to correspond to a defined standard.
 *   - The loop has to be [normalized](https://en.wikipedia.org/wiki/Normalized_loop).
 *   - The loop variable has to be *i*.
 *   - The value `UNROLLED_LOOP_INDEX` will be replaced with the explicitly
 * value of *i* for the given iteration and can be used in preprocessor
 * statements.
 *
 * ```js
 * const material = new THREE.ShaderMaterial( {
 * 	uniforms: {
 * 		time: { value: 1.0 },
 * 		resolution: { value: new THREE.Vector2() }
 * 	},
 * 	vertexShader: document.getElementById( 'vertexShader' ).textContent,
 * 	fragmentShader: document.getElementById( 'fragmentShader' ).textContent
 * } );
 * ```
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$83c7d75d550a8b0d extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        /**
		 * Defines custom constants using `#define` directives within the GLSL code
		 * for both the vertex shader and the fragment shader; each key/value pair
		 * yields another directive.
		 * ```js
		 * defines: {
		 * 	FOO: 15,
		 * 	BAR: true
		 * }
		 * ```
		 * Yields the lines:
		 * ```
		 * #define FOO 15
		 * #define BAR true
		 * ```
		 *
		 * @type {Object}
		 */ this.defines = {};
        /**
		 * An object of the form:
		 * ```js
		 * {
		 * 	"uniform1": { value: 1.0 },
		 * 	"uniform2": { value: 2 }
		 * }
		 * ```
		 * specifying the uniforms to be passed to the shader code; keys are uniform
		 * names, values are definitions of the form
		 * ```
		 * {
		 * 	value: 1.0
		 * }
		 * ```
		 * where `value` is the value of the uniform. Names must match the name of
		 * the uniform, as defined in the GLSL code. Note that uniforms are refreshed
		 * on every frame, so updating the value of the uniform will immediately
		 * update the value available to the GLSL code.
		 *
		 * @type {Object}
		 */ this.uniforms = {};
        /**
		 * An array holding uniforms groups for configuring UBOs.
		 *
		 * @type {Array<UniformsGroup>}
		 */ this.uniformsGroups = [];
        /**
		 * Vertex shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.vertexShader = $2358b7e4ec07df88$var$default_vertex;
        /**
		 * Fragment shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.fragmentShader = $2358b7e4ec07df88$var$default_fragment;
        /**
		 * Controls line thickness or lines.
		 *
		 * WebGL and WebGPU ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines whether the material color is affected by global fog settings; `true`
		 * to pass fog uniforms to the shader.
		 *
		 * Setting this property to `true` requires the definition of fog uniforms. It is
		 * recommended to use `UniformsUtils.merge()` to combine the custom shader uniforms
		 * with predefined fog uniforms.
		 *
		 * ```js
		 * const material = new ShaderMaterial( {
		 *     uniforms: UniformsUtils.merge( [ UniformsLib[ 'fog' ], shaderUniforms ] );
		 *     vertexShader: vertexShader,
		 *     fragmentShader: fragmentShader,
		 *     fog: true
		 * } );
		 * ```
		 *
		 * @type {boolean}
		 * @default false
		 */ this.fog = false;
        /**
		 * Defines whether this material uses lighting; `true` to pass uniform data
		 * related to lighting to this shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.lights = false;
        /**
		 * Defines whether this material supports clipping; `true` to let the renderer
		 * pass the clippingPlanes uniform.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipping = false;
        /**
		 * Overwritten and set to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.forceSinglePass = true;
        /**
		 * This object allows to enable certain WebGL 2 extensions.
		 *
		 * - clipCullDistance: set to `true` to use vertex shader clipping
		 * - multiDraw: set to `true` to use vertex shader multi_draw / enable gl_DrawID
		 *
		 * @type {{clipCullDistance:false,multiDraw:false}}
		 */ this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        /**
		 * When the rendered geometry doesn't include these attributes but the
		 * material does, these default values will be passed to the shaders. This
		 * avoids errors when buffer data is missing.
		 *
		 * - color: [ 1, 1, 1 ]
		 * - uv: [ 0, 0 ]
		 * - uv1: [ 0, 0 ]
		 *
		 * @type {Object}
		 */ this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        /**
		 * If set, this calls [gl.bindAttribLocation](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bindAttribLocation)
		 * to bind a generic vertex index to an attribute variable.
		 *
		 * @type {string|undefined}
		 * @default undefined
		 */ this.index0AttributeName = undefined;
        /**
		 * Can be used to force a uniform update while changing uniforms in
		 * {@link Object3D#onBeforeRender}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.uniformsNeedUpdate = false;
        /**
		 * Defines the GLSL version of custom shader code.
		 *
		 * @type {?(GLSL1|GLSL3)}
		 * @default null
		 */ this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $2358b7e4ec07df88$export$acda854380553452(source.uniforms);
        this.uniformsGroups = $2358b7e4ec07df88$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        this.defaultAttributeValues = Object.assign({}, source.defaultAttributeValues);
        this.index0AttributeName = source.index0AttributeName;
        this.uniformsNeedUpdate = source.uniformsNeedUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
/**
 * Abstract base class for cameras. This class should always be inherited
 * when you build a new camera.
 *
 * @abstract
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$79f141de891a5fed extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new camera.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCamera = true;
        this.type = 'Camera';
        /**
		 * The inverse of the camera's world matrix.
		 *
		 * @type {Matrix4}
		 */ this.matrixWorldInverse = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * The camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrix = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * The inverse of the camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrixInverse = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * The coordinate system in which the camera is used.
		 *
		 * @type {(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 */ this.coordinateSystem = $2358b7e4ec07df88$export$5a0e9190d10875d3;
        this._reversedDepth = false;
    }
    /**
	 * The flag that indicates whether the camera uses a reversed depth buffer.
	 *
	 * @type {boolean}
	 * @default false
	 */ get reversedDepth() {
        return this._reversedDepth;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * This method is overwritten since cameras have a different forward vector compared to other
	 * 3D objects. A camera looks down its local, negative z-axis by default.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $2358b7e4ec07df88$var$_v3$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_minTarget = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
const $2358b7e4ec07df88$var$_maxTarget = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
/**
 * Camera that uses [perspective projection](https://en.wikipedia.org/wiki/Perspective_(graphical)).
 *
 * This projection mode is designed to mimic the way the human eye sees. It
 * is the most common projection mode used for rendering a 3D scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 45, width / height, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $2358b7e4ec07df88$export$74e4ae24825f68d7 extends $2358b7e4ec07df88$export$79f141de891a5fed {
    /**
	 * Constructs a new perspective camera.
	 *
	 * @param {number} [fov=50] - The vertical field of view.
	 * @param {number} [aspect=1] - The aspect ratio.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        /**
		 * The vertical field of view, from bottom to top of view,
		 * in degrees.
		 *
		 * @type {number}
		 * @default 50
		 */ this.fov = fov;
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link PerspectiveCamera#far}.
		 *
		 * Note that, unlike for the {@link OrthographicCamera}, `0` is <em>not</em> a
		 * valid value for a perspective camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link PerspectiveCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        /**
		 * Object distance used for stereoscopy and depth-of-field effects. This
		 * parameter does not influence the projection matrix unless a
		 * {@link StereoCamera} is being used.
		 *
		 * @type {number}
		 * @default 10
		 */ this.focus = 10;
        /**
		 * The aspect ratio, usually the canvas width / canvas height.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = aspect;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * Film size used for the larger axis. Default is `35` (millimeters). This
		 * parameter does not influence the projection matrix unless {@link PerspectiveCamera#filmOffset}
		 * is set to a nonzero value.
		 *
		 * @type {number}
		 * @default 35
		 */ this.filmGauge = 35;
        /**
		 * Horizontal off-center offset in the same unit as {@link PerspectiveCamera#filmGauge}.
		 *
		 * @type {number}
		 * @default 0
		 */ this.filmOffset = 0;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $2358b7e4ec07df88$export$914076c8150813e5 * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Returns the focal length from the current {@link PerspectiveCamera#fov} and
	 * {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The computed focal length.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($2358b7e4ec07df88$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    /**
	 * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
	 *
	 * @return {number} The effective FOV.
	 */ getEffectiveFOV() {
        return $2358b7e4ec07df88$export$914076c8150813e5 * 2 * Math.atan(Math.tan($2358b7e4ec07df88$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    /**
	 * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    /**
	 * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
	 * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $2358b7e4ec07df88$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($2358b7e4ec07df88$var$_v3$1.x, $2358b7e4ec07df88$var$_v3$1.y).multiplyScalar(-distance / $2358b7e4ec07df88$var$_v3$1.z);
        $2358b7e4ec07df88$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($2358b7e4ec07df88$var$_v3$1.x, $2358b7e4ec07df88$var$_v3$1.y).multiplyScalar(-distance / $2358b7e4ec07df88$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
	 * @returns {Vector2} The view size.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $2358b7e4ec07df88$var$_minTarget, $2358b7e4ec07df88$var$_maxTarget);
        return target.subVectors($2358b7e4ec07df88$var$_maxTarget, $2358b7e4ec07df88$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *```
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *```
	 * then for each monitor you would call it like this:
	 *```js
	 * const w = 1920;
	 * const h = 1080;
	 * const fullWidth = w * 3;
	 * const fullHeight = h * 2;
	 *
	 * // --A--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 * // --B--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 * // --C--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 * // --D--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 * // --E--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 * // --F--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 * ```
	 *
	 * Note there is no reason monitors have to be the same size or in a grid.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($2358b7e4ec07df88$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $2358b7e4ec07df88$var$fov = -90; // negative fov is not an error
const $2358b7e4ec07df88$var$aspect = 1;
/**
 * A special type of camera that is positioned in 3D space to render its surroundings into a
 * cube render target. The render target can then be used as an environment map for rendering
 * realtime reflections in your scene.
 *
 * ```js
 * // Create cube render target
 * const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256, { generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter } );
 *
 * // Create cube camera
 * const cubeCamera = new THREE.CubeCamera( 1, 100000, cubeRenderTarget );
 * scene.add( cubeCamera );
 *
 * // Create car
 * const chromeMaterial = new THREE.MeshLambertMaterial( { color: 0xffffff, envMap: cubeRenderTarget.texture } );
 * const car = new THREE.Mesh( carGeometry, chromeMaterial );
 * scene.add( car );
 *
 * // Update the render target cube
 * car.visible = false;
 * cubeCamera.position.copy( car.position );
 * cubeCamera.update( renderer, scene );
 *
 * // Render the scene
 * car.visible = true;
 * renderer.render( scene, camera );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$d0cdd0bd804995de extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new cube camera.
	 *
	 * @param {number} near - The camera's near plane.
	 * @param {number} far - The camera's far plane.
	 * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
	 */ constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        /**
		 * A reference to the cube render target.
		 *
		 * @type {WebGLCubeRenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * The current active coordinate system.
		 *
		 * @type {?(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 * @default null
		 */ this.coordinateSystem = null;
        /**
		 * The current active mipmap level
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeMipmapLevel = 0;
        const cameraPX = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    /**
	 * Must be called when the coordinate system of the cube camera is changed.
	 */ updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $2358b7e4ec07df88$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $2358b7e4ec07df88$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    /**
	 * Calling this method will render the given scene with the given renderer
	 * into the cube render target of the camera.
	 *
	 * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
	 * @param {Scene} scene - The scene to render.
	 */ update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
/**
 * Creates a cube texture made up of six images.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader();
 * loader.setPath( 'textures/cube/pisa/' );
 *
 * const textureCube = loader.load( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xffffff, envMap: textureCube } );
 * ```
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$ee2e5a18258a4049 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new cube texture.
	 *
	 * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
	 * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space value.
	 */ constructor(images = [], mapping = $2358b7e4ec07df88$export$8759762a6477f2c4, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace){
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
    }
    /**
	 * Alias for {@link CubeTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
/**
 * A cube render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $2358b7e4ec07df88$export$ac386671d651941e extends $2358b7e4ec07df88$export$3c052beb2e51e23f {
    /**
	 * Constructs a new cube render target.
	 *
	 * @param {number} [size=1] - The size of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(size = 1, options = {}){
        super(size, size, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new $2358b7e4ec07df88$export$ee2e5a18258a4049(images);
        this._setTextureOptions(options);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
    }
    /**
	 * Converts the given equirectangular texture to a cube map.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Texture} texture - The equirectangular texture.
	 * @return {WebGLCubeRenderTarget} A reference to this cube render target.
	 */ fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $2358b7e4ec07df88$export$33e43285f7406bd5(5, 5, 5);
        const material = new $2358b7e4ec07df88$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $2358b7e4ec07df88$export$acda854380553452(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $2358b7e4ec07df88$export$d9f0486e75b5ace,
            blending: $2358b7e4ec07df88$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $2358b7e4ec07df88$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $2358b7e4ec07df88$export$5d8599b6a933fb1b) texture.minFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8;
        const camera = new $2358b7e4ec07df88$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    /**
	 * Clears this cube render target.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 */ clear(renderer, color = true, depth = true, stencil = true) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
/**
 * This is almost identical to an {@link Object3D}. Its purpose is to
 * make working with groups of objects syntactically clearer.
 *
 * ```js
 * // Create a group and add the two cubes.
 * // These cubes can now be rotated / scaled etc as a group.
 * const group = new THREE.Group();
 *
 * group.add( meshA );
 * group.add( meshB );
 *
 * scene.add( group );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGroup = true;
        this.type = 'Group';
    }
}
const $2358b7e4ec07df88$var$_moveEvent = {
    type: 'move'
};
/**
 * Class for representing a XR controller with its
 * different coordinate systems.
 *
 * @private
 */ class $2358b7e4ec07df88$export$cb626c57dcc48b9f {
    /**
	 * Constructs a new XR controller.
	 */ constructor(){
        /**
		 * A group representing the target ray space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._targetRay = null;
        /**
		 * A group representing the grip space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._grip = null;
        /**
		 * A group representing the hand space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._hand = null;
    }
    /**
	 * Returns a group representing the hand space of the XR controller.
	 *
	 * @return {Group} A group representing the hand space of the XR controller.
	 */ getHandSpace() {
        if (this._hand === null) {
            this._hand = new $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    /**
	 * Returns a group representing the target ray space of the XR controller.
	 *
	 * @return {Group} A group representing the target ray space of the XR controller.
	 */ getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $2358b7e4ec07df88$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $2358b7e4ec07df88$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    /**
	 * Returns a group representing the grip space of the XR controller.
	 *
	 * @return {Group} A group representing the grip space of the XR controller.
	 */ getGripSpace() {
        if (this._grip === null) {
            this._grip = new $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $2358b7e4ec07df88$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $2358b7e4ec07df88$export$64b5c384219d3699();
        }
        return this._grip;
    }
    /**
	 * Dispatches the given event to the groups representing
	 * the different coordinate spaces of the XR controller.
	 *
	 * @param {Object} event - The event to dispatch.
	 * @return {WebXRController} A reference to this instance.
	 */ dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    /**
	 * Connects the controller with the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    /**
	 * Disconnects the controller from the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    /**
	 * Updates the controller with the given input source, XR frame and reference space.
	 * This updates the transformations of the groups that represent the different
	 * coordinate systems of the controller.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @param {XRFrame} frame - The XR frame.
	 * @param {XRReferenceSpace} referenceSpace - The reference space.
	 * @return {WebXRController} A reference to this instance.
	 */ update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($2358b7e4ec07df88$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    /**
	 * Returns a group representing the hand joint for the given input joint.
	 *
	 * @private
	 * @param {Group} hand - The group representing the hand space.
	 * @param {XRJointSpace} inputjoint - The hand joint data.
	 * @return {Group} A group representing the hand joint for the given input joint.
	 */ _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
/**
 * This class can be used to define an exponential squared fog,
 * which gives a clear view near the camera and a faster than exponentially
 * densening fog farther from the camera.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );
 * ```
 */ class $2358b7e4ec07df88$export$6f1519f023b8d0f6 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [density=0.00025] - Defines how fast the fog will grow dense.
	 */ constructor(color, density = 0.00025){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFogExp2 = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(color);
        /**
		 *  Defines how fast the fog will grow dense.
		 *
		 * @type {number}
		 * @default 0.00025
		 */ this.density = density;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {FogExp2} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$6f1519f023b8d0f6(this.color, this.density);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
/**
 * This class can be used to define a linear fog that grows linearly denser
 * with the distance.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.Fog( 0xcccccc, 10, 15 );
 * ```
 */ class $2358b7e4ec07df88$export$3c890837b09508d4 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [near=1] - The minimum distance to start applying fog.
	 * @param {number} [far=1000] - The maximum distance at which fog stops being calculated and applied.
	 */ constructor(color, near = 1, far = 1000){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFog = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(color);
        /**
		 * The minimum distance to start applying fog. Objects that are less than
		 * `near` units from the active camera won't be affected by fog.
		 *
		 * @type {number}
		 * @default 1
		 */ this.near = near;
        /**
		 * The maximum distance at which fog stops being calculated and applied.
		 * Objects that are more than `far` units away from the active camera won't
		 * be affected by fog.
		 *
		 * @type {number}
		 * @default 1000
		 */ this.far = far;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {Fog} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
/**
 * Scenes allow you to set up what is to be rendered and where by three.js.
 * This is where you place 3D objects like meshes, lines or lights.
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$38af1803e3442a7f extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new scene.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isScene = true;
        this.type = 'Scene';
        /**
		 * Defines the background of the scene. Valid inputs are:
		 *
		 * - A color for defining a uniform colored background.
		 * - A texture for defining a (flat) textured background.
		 * - Cube textures or equirectangular textures for defining a skybox.
		 *
		 * @type {?(Color|Texture)}
		 * @default null
		 */ this.background = null;
        /**
		 * Sets the environment map for all physical materials in the scene. However,
		 * it's not possible to overwrite an existing texture assigned to the `envMap`
		 * material property.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.environment = null;
        /**
		 * A fog instance defining the type of fog that affects everything
		 * rendered in the scene.
		 *
		 * @type {?(Fog|FogExp2)}
		 * @default null
		 */ this.fog = null;
        /**
		 * Sets the blurriness of the background. Only influences environment maps
		 * assigned to {@link Scene#background}. Valid input is a float between `0`
		 * and `1`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.backgroundBlurriness = 0;
        /**
		 * Attenuates the color of the background. Only applies to background textures.
		 *
		 * @type {number}
		 * @default 1
		 */ this.backgroundIntensity = 1;
        /**
		 * The rotation of the background in radians. Only influences environment maps
		 * assigned to {@link Scene#background}.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.backgroundRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * Attenuates the color of the environment. Only influences environment maps
		 * assigned to {@link Scene#environment}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.environmentIntensity = 1;
        /**
		 * The rotation of the environment map in radians. Only influences physical materials
		 * in the scene when {@link Scene#environment} is used.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.environmentRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * Forces everything in the scene to be rendered with the defined material. It is possible
		 * to exclude materials from override by setting {@link Material#allowOverride} to `false`.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
/**
 * "Interleaved" means that multiple attributes, possibly of different types,
 * (e.g., position, normal, uv, color) are packed into a single array buffer.
 *
 * An introduction into interleaved arrays can be found here: [Interleaved array basics](https://blog.tojicode.com/2011/05/interleaved-array-basics.html)
 */ class $2358b7e4ec07df88$export$3d5cd879f108f53f {
    /**
	 * Constructs a new interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 */ constructor(array, stride){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBuffer = true;
        /**
		 * A typed array with a shared buffer storing attribute data.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of typed-array elements per vertex.
		 *
		 * @type {number}
		 */ this.stride = stride;
        /**
		 * The total number of elements in the array
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / stride : 0;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $2358b7e4ec07df88$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
        /**
		 * The UUID of the interleaved buffer.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute array
	 * data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this interleaved buffer.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {InterleavedBuffer} A reference to this interleaved buffer.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given interleaved buffer to this instance.
	 *
	 * @param {InterleavedBuffer} source - The interleaved buffer to copy.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    /**
	 * Copies a vector from the given interleaved buffer to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this interleaved buffer.
	 * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
	 * @param {number} index2 - The source index into the given interleaved buffer.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copyAt(index1, interleavedBuffer, index2) {
        index1 *= this.stride;
        index2 *= interleavedBuffer.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = interleavedBuffer.array[index2 + i];
        return this;
    }
    /**
	 * Sets the given array data in the interleaved buffer.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this interleaved buffer's array.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns a new interleaved buffer with copied values from this instance.
	 *
	 * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
	 * @return {InterleavedBuffer} A clone of this instance.
	 */ clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $2358b7e4ec07df88$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Serializes the interleaved buffer into JSON.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized interleaved buffer.
	 */ toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $2358b7e4ec07df88$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $2358b7e4ec07df88$var$_vector$7 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * An alternative version of a buffer attribute with interleaved data. Interleaved
 * attributes share a common interleaved data storage ({@link InterleavedBuffer}) and refer with
 * different offsets into the buffer.
 */ class $2358b7e4ec07df88$export$920b6d07334599c7 {
    /**
	 * Constructs a new interleaved buffer attribute.
	 *
	 * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
	 * @param {number} itemSize - The item size.
	 * @param {number} offset - The attribute offset into the buffer.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(interleavedBuffer, itemSize, offset, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer holding the interleaved data.
		 *
		 * @type {InterleavedBuffer}
		 */ this.data = interleavedBuffer;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The attribute offset into the buffer.
		 *
		 * @type {number}
		 */ this.offset = offset;
        /**
		 * Whether the data are normalized or not, see {@link BufferAttribute#normalized}
		 *
		 * @type {InterleavedBuffer}
		 */ this.normalized = normalized;
    }
    /**
	 * The item count of this buffer attribute.
	 *
	 * @type {number}
	 * @readonly
	 */ get count() {
        return this.data.count;
    }
    /**
	 * The array holding the interleaved buffer attribute data.
	 *
	 * @type {TypedArray}
	 */ get array() {
        return this.data.array;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$7.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$7.applyMatrix4(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$7.x, $2358b7e4ec07df88$var$_vector$7.y, $2358b7e4ec07df88$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$7.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$7.applyNormalMatrix(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$7.x, $2358b7e4ec07df88$var$_vector$7.y, $2358b7e4ec07df88$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$7.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$7.transformDirection(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$7.x, $2358b7e4ec07df88$var$_vector$7.y, $2358b7e4ec07df88$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $2358b7e4ec07df88$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $2358b7e4ec07df88$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $2358b7e4ec07df88$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $2358b7e4ec07df88$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $2358b7e4ec07df88$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $2358b7e4ec07df88$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $2358b7e4ec07df88$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $2358b7e4ec07df88$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $2358b7e4ec07df88$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $2358b7e4ec07df88$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
            w = $2358b7e4ec07df88$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
	 * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
	 */ clone(data) {
        if (data === undefined) {
            $2358b7e4ec07df88$export$bef1f36f5486a6a3('InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $2358b7e4ec07df88$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $2358b7e4ec07df88$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON(data) {
        if (data === undefined) {
            $2358b7e4ec07df88$export$bef1f36f5486a6a3('InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
/**
 * A material for rendering instances of {@link Sprite}.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'textures/sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map, color: 0xffffff } );
 *
 * const sprite = new THREE.Sprite( material );
 * sprite.scale.set(200, 200, 1)
 * scene.add( sprite );
 * ```
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$5ec7dd1c6994bf8e extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new sprite material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The rotation of the sprite in radians.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Specifies whether size of the sprite is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Overwritten since sprite materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $2358b7e4ec07df88$var$_geometry;
const $2358b7e4ec07df88$var$_intersectPoint = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_worldScale = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_mvPosition = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_alignedPosition = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
const $2358b7e4ec07df88$var$_rotatedPosition = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
const $2358b7e4ec07df88$var$_viewWorldMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_vA = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vB = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vC = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_uvA = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
const $2358b7e4ec07df88$var$_uvB = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
const $2358b7e4ec07df88$var$_uvC = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
/**
 * A sprite is a plane that always faces towards the camera, generally with a
 * partially transparent texture applied.
 *
 * Sprites do not cast shadows, setting {@link Object3D#castShadow} to `true` will
 * have no effect.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map } );
 *
 * const sprite = new THREE.Sprite( material );
 * scene.add( sprite );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$3075603db8e6204c extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new sprite.
	 *
	 * @param {(SpriteMaterial|SpriteNodeMaterial)} [material] - The sprite material.
	 */ constructor(material = new $2358b7e4ec07df88$export$5ec7dd1c6994bf8e()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSprite = true;
        this.type = 'Sprite';
        if ($2358b7e4ec07df88$var$_geometry === undefined) {
            $2358b7e4ec07df88$var$_geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $2358b7e4ec07df88$export$3d5cd879f108f53f(float32Array, 5);
            $2358b7e4ec07df88$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $2358b7e4ec07df88$var$_geometry.setAttribute('position', new $2358b7e4ec07df88$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $2358b7e4ec07df88$var$_geometry.setAttribute('uv', new $2358b7e4ec07df88$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        /**
		 * The sprite geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = $2358b7e4ec07df88$var$_geometry;
        /**
		 * The sprite material.
		 *
		 * @type {(SpriteMaterial|SpriteNodeMaterial)}
		 */ this.material = material;
        /**
		 * The sprite's anchor point, and the point around which the sprite rotates.
		 * A value of `(0.5, 0.5)` corresponds to the midpoint of the sprite. A value
		 * of `(0, 0)` corresponds to the lower left corner of the sprite.
		 *
		 * @type {Vector2}
		 * @default (0.5,0.5)
		 */ this.center = new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, 0.5);
        /**
		 * The number of instances of this sprite.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
    }
    /**
	 * Computes intersection points between a casted ray and this sprite.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        if (raycaster.camera === null) $2358b7e4ec07df88$export$a3bc9b8ed74fc('Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $2358b7e4ec07df88$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $2358b7e4ec07df88$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $2358b7e4ec07df88$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $2358b7e4ec07df88$var$_worldScale.multiplyScalar(-$2358b7e4ec07df88$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $2358b7e4ec07df88$var$transformVertex($2358b7e4ec07df88$var$_vA.set(-0.5, -0.5, 0), $2358b7e4ec07df88$var$_mvPosition, center, $2358b7e4ec07df88$var$_worldScale, sin, cos);
        $2358b7e4ec07df88$var$transformVertex($2358b7e4ec07df88$var$_vB.set(0.5, -0.5, 0), $2358b7e4ec07df88$var$_mvPosition, center, $2358b7e4ec07df88$var$_worldScale, sin, cos);
        $2358b7e4ec07df88$var$transformVertex($2358b7e4ec07df88$var$_vC.set(0.5, 0.5, 0), $2358b7e4ec07df88$var$_mvPosition, center, $2358b7e4ec07df88$var$_worldScale, sin, cos);
        $2358b7e4ec07df88$var$_uvA.set(0, 0);
        $2358b7e4ec07df88$var$_uvB.set(1, 0);
        $2358b7e4ec07df88$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($2358b7e4ec07df88$var$_vA, $2358b7e4ec07df88$var$_vB, $2358b7e4ec07df88$var$_vC, false, $2358b7e4ec07df88$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $2358b7e4ec07df88$var$transformVertex($2358b7e4ec07df88$var$_vB.set(-0.5, 0.5, 0), $2358b7e4ec07df88$var$_mvPosition, center, $2358b7e4ec07df88$var$_worldScale, sin, cos);
            $2358b7e4ec07df88$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($2358b7e4ec07df88$var$_vA, $2358b7e4ec07df88$var$_vC, $2358b7e4ec07df88$var$_vB, false, $2358b7e4ec07df88$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($2358b7e4ec07df88$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $2358b7e4ec07df88$var$_intersectPoint.clone(),
            uv: $2358b7e4ec07df88$export$5a465592bfe74b48.getInterpolation($2358b7e4ec07df88$var$_intersectPoint, $2358b7e4ec07df88$var$_vA, $2358b7e4ec07df88$var$_vB, $2358b7e4ec07df88$var$_vC, $2358b7e4ec07df88$var$_uvA, $2358b7e4ec07df88$var$_uvB, $2358b7e4ec07df88$var$_uvC, new $2358b7e4ec07df88$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $2358b7e4ec07df88$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $2358b7e4ec07df88$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $2358b7e4ec07df88$var$_rotatedPosition.x = cos * $2358b7e4ec07df88$var$_alignedPosition.x - sin * $2358b7e4ec07df88$var$_alignedPosition.y;
        $2358b7e4ec07df88$var$_rotatedPosition.y = sin * $2358b7e4ec07df88$var$_alignedPosition.x + cos * $2358b7e4ec07df88$var$_alignedPosition.y;
    } else $2358b7e4ec07df88$var$_rotatedPosition.copy($2358b7e4ec07df88$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $2358b7e4ec07df88$var$_rotatedPosition.x;
    vertexPosition.y += $2358b7e4ec07df88$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($2358b7e4ec07df88$var$_viewWorldMatrix);
}
const $2358b7e4ec07df88$var$_v1$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v2$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A component for providing a basic Level of Detail (LOD) mechanism.
 *
 * Every LOD level is associated with an object, and rendering can be switched
 * between them at the distances specified. Typically you would create, say,
 * three meshes, one for far away (low detail), one for mid range (medium
 * detail) and one for close up (high detail).
 *
 * ```js
 * const lod = new THREE.LOD();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 *
 * //Create spheres with 3 levels of detail and create new LOD levels for them
 * for( let i = 0; i < 3; i++ ) {
 *
 * 	const geometry = new THREE.IcosahedronGeometry( 10, 3 - i );
 * 	const mesh = new THREE.Mesh( geometry, material );
 * 	lod.addLevel( mesh, i * 75 );
 *
 * }
 *
 * scene.add( lod );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$112e7237be0c5f30 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new LOD.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLOD = true;
        /**
		 * The current LOD index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            /**
			 * This array holds the LOD levels.
			 *
			 * @name LOD#levels
			 * @type {Array<{object:Object3D,distance:number,hysteresis:number}>}
			 */ levels: {
                enumerable: true,
                value: []
            }
        });
        /**
		 * Whether the LOD object is updated automatically by the renderer per frame
		 * or not. If set to `false`, you have to call {@link LOD#update} in the
		 * render loop by yourself.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    /**
	 * Adds a mesh that will display at a certain distance and greater. Typically
	 * the further away the distance, the lower the detail on the mesh.
	 *
	 * @param {Object3D} object - The 3D object to display at this level.
	 * @param {number} [distance=0] - The distance at which to display this level of detail.
	 * @param {number} [hysteresis=0] - Threshold used to avoid flickering at LOD boundaries, as a fraction of distance.
	 * @return {LOD} A reference to this instance.
	 */ addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    /**
	 * Removes an existing level, based on the distance from the camera.
	 * Returns `true` when the level has been removed. Otherwise `false`.
	 *
	 * @param {number} distance - Distance of the level to remove.
	 * @return {boolean} Whether the level has been removed or not.
	 */ removeLevel(distance) {
        const levels = this.levels;
        for(let i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
            const removedElements = levels.splice(i, 1);
            this.remove(removedElements[0].object);
            return true;
        }
        return false;
    }
    /**
	 * Returns the currently active LOD level index.
	 *
	 * @return {number} The current active LOD level index.
	 */ getCurrentLevel() {
        return this._currentLevel;
    }
    /**
	 * Returns a reference to the first 3D object that is greater than
	 * the given distance.
	 *
	 * @param {number} distance - The LOD distance.
	 * @return {?Object3D} The found 3D object. `null` if no 3D object has been found.
	 */ getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    /**
	 * Computes intersection points between a casted ray and this LOD.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $2358b7e4ec07df88$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($2358b7e4ec07df88$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    /**
	 * Updates the LOD by computing which LOD level should be visible according
	 * to the current distance of the given camera.
	 *
	 * @param {Camera} camera - The camera the scene is rendered with.
	 */ update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $2358b7e4ec07df88$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $2358b7e4ec07df88$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $2358b7e4ec07df88$var$_v1$2.distanceTo($2358b7e4ec07df88$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $2358b7e4ec07df88$var$_basePosition = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_skinIndex = /*@__PURE__*/ new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
const $2358b7e4ec07df88$var$_skinWeight = /*@__PURE__*/ new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
const $2358b7e4ec07df88$var$_vector3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_matrix4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_vertex = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_sphere$5 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_inverseMatrix$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_ray$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$a186db52eed6d40e();
/**
 * A mesh that has a {@link Skeleton} that can then be used to animate the
 * vertices of the geometry with skinning/skeleton animation.
 *
 * Next to a valid skeleton, the skinned mesh requires skin indices and weights
 * as buffer attributes in its geometry. These attribute define which bones affect a single
 * vertex to a certain extend.
 *
 * Typically skinned meshes are not created manually but loaders like {@link GLTFLoader}
 * or {@link FBXLoader } import respective models.
 *
 * @augments Mesh
 * @demo scenes/bones-browser.html
 */ class $2358b7e4ec07df88$export$b303577035157ecf extends $2358b7e4ec07df88$export$e176487c05830cc5 {
    /**
	 * Constructs a new skinned mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        /**
		 * `AttachedBindMode` means the skinned mesh shares the same world space as the skeleton.
		 * This is not true when using `DetachedBindMode` which is useful when sharing a skeleton
		 * across multiple skinned meshes.
		 *
		 * @type {(AttachedBindMode|DetachedBindMode)}
		 * @default AttachedBindMode
		 */ this.bindMode = $2358b7e4ec07df88$export$2595a3798997538;
        /**
		 * The base matrix that is used for the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrix = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * The base matrix that is used for resetting the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrixInverse = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * The bounding box of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
    }
    /**
	 * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
	 * the current animation state.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $2358b7e4ec07df88$var$_vertex);
            this.boundingBox.expandByPoint($2358b7e4ec07df88$var$_vertex);
        }
    }
    /**
	 * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
	 * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
	 * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
	 * per frame in order to reflect the current animation state.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $2358b7e4ec07df88$var$_vertex);
            this.boundingSphere.expandByPoint($2358b7e4ec07df88$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $2358b7e4ec07df88$var$_sphere$5.copy(this.boundingSphere);
        $2358b7e4ec07df88$var$_sphere$5.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($2358b7e4ec07df88$var$_sphere$5) === false) return;
        // convert ray to local space of skinned mesh
        $2358b7e4ec07df88$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $2358b7e4ec07df88$var$_ray$2.copy(raycaster.ray).applyMatrix4($2358b7e4ec07df88$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($2358b7e4ec07df88$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $2358b7e4ec07df88$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    /**
	 * Binds the given skeleton to the skinned mesh.
	 *
	 * @param {Skeleton} skeleton - The skeleton to bind.
	 * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
	 * the skinned mesh's world matrix will be used instead.
	 */ bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    /**
	 * This method sets the skinned mesh in the rest pose).
	 */ pose() {
        this.skeleton.pose();
    }
    /**
	 * Normalizes the skin weights which are defined as a buffer attribute
	 * in the skinned mesh's geometry.
	 */ normalizeSkinWeights() {
        const vector = new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $2358b7e4ec07df88$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $2358b7e4ec07df88$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else $2358b7e4ec07df88$export$c106dd0671a0fc2d('SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    /**
	 * Applies the bone transform associated with the given index to the given
	 * vertex position. Returns the updated vector.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * the skinned mesh's world matrix will be used instead.
	 * @return {Vector3} The updated vertex position.
	 */ applyBoneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $2358b7e4ec07df88$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $2358b7e4ec07df88$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $2358b7e4ec07df88$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $2358b7e4ec07df88$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $2358b7e4ec07df88$var$_skinIndex.getComponent(i);
                $2358b7e4ec07df88$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($2358b7e4ec07df88$var$_vector3.copy($2358b7e4ec07df88$var$_basePosition).applyMatrix4($2358b7e4ec07df88$var$_matrix4), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
/**
 * A bone which is part of a {@link Skeleton}. The skeleton in turn is used by
 * the {@link SkinnedMesh}.
 *
 * ```js
 * const root = new THREE.Bone();
 * const child = new THREE.Bone();
 *
 * root.add( child );
 * child.position.y = 5;
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$b127726e56765aa4 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new bone.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBone = true;
        this.type = 'Bone';
    }
}
/**
 * Creates a texture directly from raw buffer data.
 *
 * The interpretation of the data depends on type and format: If the type is
 * `UnsignedByteType`, a `Uint8Array` will be useful for addressing the
 * texel data. If the format is `RGBAFormat`, data needs four values for
 * one texel; Red, Green, Blue and Alpha (typically the opacity).
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$b691f601014eabe1 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new data texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=NearestFilter] - The mag filter value.
	 * @param {number} [minFilter=NearestFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0, minFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height
        };
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
const $2358b7e4ec07df88$var$_offsetMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_identityMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
/**
 * Class for representing the armatures in `three.js`. The skeleton
 * is defined by a hierarchy of bones.
 *
 * ```js
 * const bones = [];
 *
 * const shoulder = new THREE.Bone();
 * const elbow = new THREE.Bone();
 * const hand = new THREE.Bone();
 *
 * shoulder.add( elbow );
 * elbow.add( hand );
 *
 * bones.push( shoulder , elbow, hand);
 *
 * shoulder.position.y = -5;
 * elbow.position.y = 0;
 * hand.position.y = 5;
 *
 * const armSkeleton = new THREE.Skeleton( bones );
 * ```
 */ class $2358b7e4ec07df88$export$8f31e4c4a37b8e9c {
    /**
	 * Constructs a new skeleton.
	 *
	 * @param {Array<Bone>} [bones] - An array of bones.
	 * @param {Array<Matrix4>} [boneInverses] - An array of bone inverse matrices.
	 * If not provided, these matrices will be computed automatically via {@link Skeleton#calculateInverses}.
	 */ constructor(bones = [], boneInverses = []){
        this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * An array of bones defining the skeleton.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones.slice(0);
        /**
		 * An array of bone inverse matrices.
		 *
		 * @type {Array<Matrix4>}
		 */ this.boneInverses = boneInverses;
        /**
		 * An array buffer holding the bone data.
		 * Input data for {@link Skeleton#boneTexture}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.boneMatrices = null;
        /**
		 * An array buffer holding the bone data of the previous frame.
		 * Required for computing velocity. Maintained in {@link SkinningNode}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.previousBoneMatrices = null;
        /**
		 * A texture holding the bone data for use
		 * in the vertex shader.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.boneTexture = null;
        this.init();
    }
    /**
	 * Initializes the skeleton. This method gets automatically called by the constructor
	 * but depending on how the skeleton is created it might be necessary to call this method
	 * manually.
	 */ init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $2358b7e4ec07df88$export$2ae72fc923e5eb5());
        }
    }
    /**
	 * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
	 * and fills it with new matrices.
	 */ calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $2358b7e4ec07df88$var$_identityMatrix;
            $2358b7e4ec07df88$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $2358b7e4ec07df88$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    /**
	 * Returns a new skeleton with copied values from this instance.
	 *
	 * @return {Skeleton} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    /**
	 * Computes a data texture for passing bone data to the vertex shader.
	 *
	 * @return {Skeleton} A reference of this instance.
	 */ computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $2358b7e4ec07df88$export$b691f601014eabe1(boneMatrices, size, size, $2358b7e4ec07df88$export$3f8bb04b555a363c, $2358b7e4ec07df88$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    /**
	 * Searches through the skeleton's bone array and returns the first with a
	 * matching name.
	 *
	 * @param {string} name - The name of the bone.
	 * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
	 */ getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    /**
	 * Setups the skeleton by the given JSON and bones.
	 *
	 * @param {Object} json - The skeleton as serialized JSON.
	 * @param {Object<string, Bone>} bones - An array of bones.
	 * @return {Skeleton} A reference of this instance.
	 */ fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                $2358b7e4ec07df88$export$c106dd0671a0fc2d('Skeleton: No bone found with UUID:', uuid);
                bone = new $2358b7e4ec07df88$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $2358b7e4ec07df88$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    /**
	 * Serializes the skeleton into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized skeleton.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
/**
 * An instanced version of a buffer attribute.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$32ea87a8b54d744a extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new instanced buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
	 */ constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferAttribute = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated. A
		 * value of one means that each value of the instanced attribute is used for
		 * a single instance. A value of two means that each value is used for two
		 * consecutive instances (and so on).
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $2358b7e4ec07df88$var$_instanceLocalMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_instanceWorldMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_instanceIntersects = [];
const $2358b7e4ec07df88$var$_box3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
const $2358b7e4ec07df88$var$_identity = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_mesh$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$e176487c05830cc5();
const $2358b7e4ec07df88$var$_sphere$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
/**
 * A special version of a mesh with instanced rendering support. Use
 * this class if you have to render a large number of objects with the same
 * geometry and material(s) but with different world transformations. The usage
 * of 'InstancedMesh' will help you to reduce the number of draw calls and thus
 * improve the overall rendering performance in your application.
 *
 * @augments Mesh
 */ class $2358b7e4ec07df88$export$f3c979c331175ad7 extends $2358b7e4ec07df88$export$e176487c05830cc5 {
    /**
	 * Constructs a new instanced mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 * @param {number} count - The number of instances.
	 */ constructor(geometry, material, count){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedMesh = true;
        /**
		 * Represents the local transformation of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMatrixAt}.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceMatrix = new $2358b7e4ec07df88$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        /**
		 * Represents the color of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setColorAt}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ this.instanceColor = null;
        /**
		 * Represents the morph target weights of all instances. You have to set its
		 * {@link Texture#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMorphAt}.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.morphTexture = null;
        /**
		 * The number of instances.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * The bounding box of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $2358b7e4ec07df88$var$_identity);
    }
    /**
	 * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $2358b7e4ec07df88$var$_instanceLocalMatrix);
            $2358b7e4ec07df88$var$_box3.copy(geometry.boundingBox).applyMatrix4($2358b7e4ec07df88$var$_instanceLocalMatrix);
            this.boundingBox.union($2358b7e4ec07df88$var$_box3);
        }
    }
    /**
	 * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $2358b7e4ec07df88$var$_instanceLocalMatrix);
            $2358b7e4ec07df88$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4($2358b7e4ec07df88$var$_instanceLocalMatrix);
            this.boundingSphere.union($2358b7e4ec07df88$var$_sphere$4);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    /**
	 * Gets the color of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The target object that is used to store the method's result.
	 */ getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Gets the local transformation matrix of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 */ getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Gets the morph target weights of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object - The target object that is used to store the method's result.
	 */ getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $2358b7e4ec07df88$var$_mesh$1.geometry = this.geometry;
        $2358b7e4ec07df88$var$_mesh$1.material = this.material;
        if ($2358b7e4ec07df88$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $2358b7e4ec07df88$var$_sphere$4.copy(this.boundingSphere);
        $2358b7e4ec07df88$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($2358b7e4ec07df88$var$_sphere$4) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $2358b7e4ec07df88$var$_instanceLocalMatrix);
            $2358b7e4ec07df88$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $2358b7e4ec07df88$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $2358b7e4ec07df88$var$_mesh$1.matrixWorld = $2358b7e4ec07df88$var$_instanceWorldMatrix;
            $2358b7e4ec07df88$var$_mesh$1.raycast(raycaster, $2358b7e4ec07df88$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $2358b7e4ec07df88$var$_instanceIntersects.length; i < l; i++){
                const intersect = $2358b7e4ec07df88$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $2358b7e4ec07df88$var$_instanceIntersects.length = 0;
        }
    }
    /**
	 * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The instance color.
	 */ setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $2358b7e4ec07df88$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The local transformation.
	 */ setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
	 * of a single instance.
	 */ setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $2358b7e4ec07df88$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $2358b7e4ec07df88$export$4e041a7967d15c4b, $2358b7e4ec07df88$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
    }
}
const $2358b7e4ec07df88$var$_vector1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vector2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_normalMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$8ff26dafa08918();
/**
 * A two dimensional surface that extends infinitely in 3D space, represented
 * in [Hessian normal form](http://mathworld.wolfram.com/HessianNormalForm.html)
 * by a unit length normal vector and a constant.
 */ class $2358b7e4ec07df88$export$7ff5ac152ef991b0 {
    /**
	 * Constructs a new plane.
	 *
	 * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
	 * @param {number} [constant=0] - The signed distance from the origin to the plane.
	 */ constructor(normal = new $2358b7e4ec07df88$export$64b5c384219d3699(1, 0, 0), constant = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPlane = true;
        /**
		 * A unit length vector defining the normal of the plane.
		 *
		 * @type {Vector3}
		 */ this.normal = normal;
        /**
		 * The signed distance from the origin to the plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.constant = constant;
    }
    /**
	 * Sets the plane components by copying the given values.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {number} constant - The constant.
	 * @return {Plane} A reference to this plane.
	 */ set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    /**
	 * Sets the plane components by defining `x`, `y`, `z` as the
	 * plane normal and `w` as the constant.
	 *
	 * @param {number} x - The value for the normal's x component.
	 * @param {number} y - The value for the normal's y component.
	 * @param {number} z - The value for the normal's z component.
	 * @param {number} w - The constant value.
	 * @return {Plane} A reference to this plane.
	 */ setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    /**
	 * Sets the plane from the given normal and coplanar point (that is a point
	 * that lies onto the plane).
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Vector3} point - A coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    /**
	 * Sets the plane from three coplanar points. The winding order is
	 * assumed to be counter-clockwise, and determines the direction of
	 * the plane normal.
	 *
	 * @param {Vector3} a - The first coplanar point.
	 * @param {Vector3} b - The second coplanar point.
	 * @param {Vector3} c - The third coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromCoplanarPoints(a, b, c) {
        const normal = $2358b7e4ec07df88$var$_vector1.subVectors(c, b).cross($2358b7e4ec07df88$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    /**
	 * Copies the values of the given plane to this instance.
	 *
	 * @param {Plane} plane - The plane to copy.
	 * @return {Plane} A reference to this plane.
	 */ copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    /**
	 * Normalizes the plane normal and adjusts the constant accordingly.
	 *
	 * @return {Plane} A reference to this plane.
	 */ normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    /**
	 * Negates both the plane normal and the constant.
	 *
	 * @return {Plane} A reference to this plane.
	 */ negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    /**
	 * Returns the signed distance from the given point to this plane.
	 *
	 * @param {Vector3} point - The point to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    /**
	 * Returns the signed distance from the given sphere to this plane.
	 *
	 * @param {Sphere} sphere - The sphere to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    /**
	 * Projects a the given point onto the plane.
	 *
	 * @param {Vector3} point - The point to project.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The projected point on the plane.
	 */ projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    /**
	 * Returns the intersection point of the passed line and the plane. Returns
	 * `null` if the line does not intersect. Returns the line's starting point if
	 * the line is coplanar with the plane.
	 *
	 * @param {Line3} line - The line to compute the intersection for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectLine(line, target) {
        const direction = line.delta($2358b7e4ec07df88$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    /**
	 * Returns `true` if the given line segment intersects with (passes through) the plane.
	 *
	 * @param {Line3} line - The line to test.
	 * @return {boolean} Whether the given line segment intersects with the plane or not.
	 */ intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    /**
	 * Returns `true` if the given bounding box intersects with the plane.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with the plane or not.
	 */ intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with the plane.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
	 */ intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    /**
	 * Returns a coplanar vector to the plane, by calculating the
	 * projection of the normal at the origin onto the plane.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The coplanar point.
	 */ coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    /**
	 * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
	 *
	 * The optional normal matrix can be pre-computed like so:
	 * ```js
	 * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
	 * ```
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
	 * @return {Plane} A reference to this plane.
	 */ applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $2358b7e4ec07df88$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($2358b7e4ec07df88$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    /**
	 * Translates the plane by the distance defined by the given offset vector.
	 * Note that this only affects the plane constant and will not affect the normal vector.
	 *
	 * @param {Vector3} offset - The offset vector.
	 * @return {Plane} A reference to this plane.
	 */ translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    /**
	 * Returns `true` if this plane is equal with the given one.
	 *
	 * @param {Plane} plane - The plane to test for equality.
	 * @return {boolean} Whether this plane is equal with the given one.
	 */ equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    /**
	 * Returns a new plane with copied values from this instance.
	 *
	 * @return {Plane} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $2358b7e4ec07df88$var$_sphere$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_defaultSpriteCenter = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, 0.5);
const $2358b7e4ec07df88$var$_vector$6 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Frustums are used to determine what is inside the camera's field of view.
 * They help speed up the rendering process - objects which lie outside a camera's
 * frustum can safely be excluded from rendering.
 *
 * This class is mainly intended for use internally by a renderer.
 */ class $2358b7e4ec07df88$export$35efe6f4c85463d2 {
    /**
	 * Constructs a new frustum.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 */ constructor(p0 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0(), p1 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0(), p2 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0(), p3 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0(), p4 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0(), p5 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0()){
        /**
		 * This array holds the planes that enclose the frustum.
		 *
		 * @type {Array<Plane>}
		 */ this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    /**
	 * Sets the frustum planes by copying the given planes.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 * @return {Frustum} A reference to this frustum.
	 */ set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    /**
	 * Copies the values of the given frustum to this instance.
	 *
	 * @param {Frustum} frustum - The frustum to copy.
	 * @return {Frustum} A reference to this frustum.
	 */ copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    /**
	 * Sets the frustum planes from the given projection matrix.
	 *
	 * @param {Matrix4} m - The projection matrix.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Frustum} A reference to this frustum.
	 */ setFromProjectionMatrix(m, coordinateSystem = $2358b7e4ec07df88$export$5a0e9190d10875d3, reversedDepth = false) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        if (reversedDepth) {
            planes[4].setComponents(me2, me6, me10, me14).normalize(); // far
            planes[5].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize(); // near
        } else {
            planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize(); // far
            if (coordinateSystem === $2358b7e4ec07df88$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize(); // near
            else if (coordinateSystem === $2358b7e4ec07df88$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize(); // near
            else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        }
        return this;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
	 *
	 * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
	 */ intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $2358b7e4ec07df88$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $2358b7e4ec07df88$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($2358b7e4ec07df88$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given sprite is intersecting this frustum.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @return {boolean} Whether the sprite is intersecting this frustum or not.
	 */ intersectsSprite(sprite) {
        $2358b7e4ec07df88$var$_sphere$3.center.set(0, 0, 0);
        const offset = $2358b7e4ec07df88$var$_defaultSpriteCenter.distanceTo(sprite.center);
        $2358b7e4ec07df88$var$_sphere$3.radius = 0.7071067811865476 + offset;
        $2358b7e4ec07df88$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($2358b7e4ec07df88$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting this frustum.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
	 */ intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given bounding box is intersecting this frustum.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box is intersecting this frustum or not.
	 */ intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $2358b7e4ec07df88$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $2358b7e4ec07df88$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $2358b7e4ec07df88$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($2358b7e4ec07df88$var$_vector$6) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given point lies within the frustum.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the point lies within this frustum or not.
	 */ containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns a new frustum with copied values from this instance.
	 *
	 * @return {Frustum} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $2358b7e4ec07df88$var$_projScreenMatrix$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_frustum$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$35efe6f4c85463d2();
/**
 * FrustumArray is used to determine if an object is visible in at least one camera
 * from an array of cameras. This is particularly useful for multi-view renderers.
*/ class $2358b7e4ec07df88$export$2d7d04327620499c {
    /**
	 * Constructs a new frustum array.
	 *
	 */ constructor(){
        /**
		 * The coordinate system to use.
		 *
		 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
		 * @default WebGLCoordinateSystem
		 */ this.coordinateSystem = $2358b7e4ec07df88$export$5a0e9190d10875d3;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the 3D object is visible in any camera.
	 */ intersectsObject(object, cameraArray) {
        if (!cameraArray.isArrayCamera || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $2358b7e4ec07df88$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $2358b7e4ec07df88$var$_frustum$1.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($2358b7e4ec07df88$var$_frustum$1.intersectsObject(object)) return true; // Object is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given sprite is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sprite is visible in any camera.
	 */ intersectsSprite(sprite, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $2358b7e4ec07df88$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $2358b7e4ec07df88$var$_frustum$1.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($2358b7e4ec07df88$var$_frustum$1.intersectsSprite(sprite)) return true; // Sprite is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sphere is visible in any camera.
	 */ intersectsSphere(sphere, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $2358b7e4ec07df88$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $2358b7e4ec07df88$var$_frustum$1.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($2358b7e4ec07df88$var$_frustum$1.intersectsSphere(sphere)) return true; // Sphere is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding box is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the box is visible in any camera.
	 */ intersectsBox(box, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $2358b7e4ec07df88$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $2358b7e4ec07df88$var$_frustum$1.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($2358b7e4ec07df88$var$_frustum$1.intersectsBox(box)) return true; // Box is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given point lies within any frustum
	 * from the camera array.
	 *
	 * @param {Vector3} point - The point to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the point is visible in any camera.
	 */ containsPoint(point, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $2358b7e4ec07df88$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $2358b7e4ec07df88$var$_frustum$1.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($2358b7e4ec07df88$var$_frustum$1.containsPoint(point)) return true; // Point is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns a new frustum array with copied values from this instance.
	 *
	 * @return {FrustumArray} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$2d7d04327620499c();
    }
}
function $2358b7e4ec07df88$var$ascIdSort(a, b) {
    return a - b;
}
function $2358b7e4ec07df88$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $2358b7e4ec07df88$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $2358b7e4ec07df88$var$MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(start, count, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = start;
        item.count = count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const $2358b7e4ec07df88$var$_matrix$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_whiteColor = /*@__PURE__*/ new $2358b7e4ec07df88$export$892596cec99bc70e(1, 1, 1);
const $2358b7e4ec07df88$var$_frustum = /*@__PURE__*/ new $2358b7e4ec07df88$export$35efe6f4c85463d2();
const $2358b7e4ec07df88$var$_frustumArray = /*@__PURE__*/ new $2358b7e4ec07df88$export$2d7d04327620499c();
const $2358b7e4ec07df88$var$_box$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
const $2358b7e4ec07df88$var$_sphere$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_vector$5 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_forward$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_temp = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_renderList = /*@__PURE__*/ new $2358b7e4ec07df88$var$MultiDrawRenderList();
const $2358b7e4ec07df88$var$_mesh = /*@__PURE__*/ new $2358b7e4ec07df88$export$e176487c05830cc5();
const $2358b7e4ec07df88$var$_batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function $2358b7e4ec07df88$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function $2358b7e4ec07df88$var$copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        const len = Math.min(src.length, target.length);
        for(let i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        const len = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len));
    }
}
/**
 * A special version of a mesh with multi draw batch rendering support. Use
 * this class if you have to render a large number of objects with the same
 * material but with different geometries or world transformations. The usage of
 * `BatchedMesh` will help you to reduce the number of draw calls and thus improve the overall
 * rendering performance in your application.
 *
 * ```js
 * const box = new THREE.BoxGeometry( 1, 1, 1 );
 * const sphere = new THREE.SphereGeometry( 1, 12, 12 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 *
 * // initialize and add geometries into the batched mesh
 * const batchedMesh = new BatchedMesh( 10, 5000, 10000, material );
 * const boxGeometryId = batchedMesh.addGeometry( box );
 * const sphereGeometryId = batchedMesh.addGeometry( sphere );
 *
 * // create instances of those geometries
 * const boxInstancedId1 = batchedMesh.addInstance( boxGeometryId );
 * const boxInstancedId2 = batchedMesh.addInstance( boxGeometryId );
 *
 * const sphereInstancedId1 = batchedMesh.addInstance( sphereGeometryId );
 * const sphereInstancedId2 = batchedMesh.addInstance( sphereGeometryId );
 *
 * // position the geometries
 * batchedMesh.setMatrixAt( boxInstancedId1, boxMatrix1 );
 * batchedMesh.setMatrixAt( boxInstancedId2, boxMatrix2 );
 *
 * batchedMesh.setMatrixAt( sphereInstancedId1, sphereMatrix1 );
 * batchedMesh.setMatrixAt( sphereInstancedId2, sphereMatrix2 );
 *
 * scene.add( batchedMesh );
 * ```
 *
 * @augments Mesh
 */ class $2358b7e4ec07df88$export$6e01c5ee52ed8f7b extends $2358b7e4ec07df88$export$e176487c05830cc5 {
    /**
	 * Constructs a new batched mesh.
	 *
	 * @param {number} maxInstanceCount - The maximum number of individual instances planned to be added and rendered.
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries.
	 * @param {number} [maxIndexCount=maxVertexCount*2] - The maximum number of indices to be used by all unique geometries
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $2358b7e4ec07df88$export$b7be63a67df8959(), material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBatchedMesh = true;
        /**
		 * When set ot `true`, the individual objects of a batch are frustum culled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.perObjectFrustumCulled = true;
        /**
		 * When set to `true`, the individual objects of a batch are sorted to improve overdraw-related artifacts.
		 * If the material is marked as "transparent" objects are rendered back to front and if not then they are
		 * rendered front to back.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        /**
		 * The bounding box of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Takes a sort a function that is run before render. The function takes a list of instances to
		 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered
		 * sort with.
		 *
		 * @type {?Function}
		 * @default null
		 */ this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        this._instanceInfo = [];
        this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        this._availableInstanceIds = [];
        this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        this._nextIndexStart = 0;
        this._nextVertexStart = 0;
        this._geometryCount = 0;
        // flags
        this._visibilityChanged = true;
        this._geometryInitialized = false;
        // cached user options
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    /**
	 * The maximum number of individual instances that can be stored in the batch.
	 *
	 * @type {number}
	 * @readonly
	 */ get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    /**
	 * The instance count.
	 *
	 * @type {number}
	 * @readonly
	 */ get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    /**
	 * The number of unused vertices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    /**
	 * The number of unused indices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $2358b7e4ec07df88$export$b691f601014eabe1(matricesArray, size, size, $2358b7e4ec07df88$export$3f8bb04b555a363c, $2358b7e4ec07df88$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $2358b7e4ec07df88$export$b691f601014eabe1(indirectArray, size, size, $2358b7e4ec07df88$export$aa92e870a709d190, $2358b7e4ec07df88$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $2358b7e4ec07df88$export$b691f601014eabe1(colorsArray, size, size, $2358b7e4ec07df88$export$3f8bb04b555a363c, $2358b7e4ec07df88$export$f6d331659b644596);
        colorsTexture.colorSpace = $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $2358b7e4ec07df88$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $2358b7e4ec07df88$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`THREE.BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
        }
    }
    /**
	 * Validates the instance defined by the given ID.
	 *
	 * @param {number} instanceId - The instance to validate.
	 */ validateInstanceId(instanceId) {
        const instanceInfo = this._instanceInfo;
        if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) throw new Error(`THREE.BatchedMesh: Invalid instanceId ${instanceId}. Instance is either out of range or has been deleted.`);
    }
    /**
	 * Validates the geometry defined by the given ID.
	 *
	 * @param {number} geometryId - The geometry to validate.
	 */ validateGeometryId(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) throw new Error(`THREE.BatchedMesh: Invalid geometryId ${geometryId}. Geometry is either out of range or has been deleted.`);
    }
    /**
	 * Takes a sort a function that is run before render. The function takes a list of instances to
	 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered sort with.
	 *
	 * @param {Function} func - The custom sort function.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    /**
	 * Computes the bounding box, updating {@link BatchedMesh#boundingBox}.
	 * Bounding boxes aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
        const boundingBox = this.boundingBox;
        const instanceInfo = this._instanceInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $2358b7e4ec07df88$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $2358b7e4ec07df88$var$_box$1).applyMatrix4($2358b7e4ec07df88$var$_matrix$1);
            boundingBox.union($2358b7e4ec07df88$var$_box$1);
        }
    }
    /**
	 * Computes the bounding sphere, updating {@link BatchedMesh#boundingSphere}.
	 * Bounding spheres aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const instanceInfo = this._instanceInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $2358b7e4ec07df88$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $2358b7e4ec07df88$var$_sphere$2).applyMatrix4($2358b7e4ec07df88$var$_matrix$1);
            boundingSphere.union($2358b7e4ec07df88$var$_sphere$2);
        }
    }
    /**
	 * Adds a new instance to the batch using the geometry of the given ID and returns
	 * a new id referring to the new instance to be used by other functions.
	 *
	 * @param {number} geometryId - The ID of a previously added geometry via {@link BatchedMesh#addGeometry}.
	 * @return {number} The instance ID.
	 */ addInstance(geometryId) {
        const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
        // ensure we're not over geometry
        if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('THREE.BatchedMesh: Maximum item count reached.');
        const instanceInfo = {
            visible: true,
            active: true,
            geometryIndex: geometryId
        };
        let drawId = null;
        // Prioritize using previously freed instance ids
        if (this._availableInstanceIds.length > 0) {
            this._availableInstanceIds.sort($2358b7e4ec07df88$var$ascIdSort);
            drawId = this._availableInstanceIds.shift();
            this._instanceInfo[drawId] = instanceInfo;
        } else {
            drawId = this._instanceInfo.length;
            this._instanceInfo.push(instanceInfo);
        }
        const matricesTexture = this._matricesTexture;
        $2358b7e4ec07df88$var$_matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $2358b7e4ec07df88$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        this._visibilityChanged = true;
        return drawId;
    }
    /**
	 * Adds the given geometry to the batch and returns the associated
	 * geometry id referring to it to be used in other functions.
	 *
	 * @param {BufferGeometry} geometry - The geometry to add.
	 * @param {number} [reservedVertexCount=-1] - Optional parameter specifying the amount of
	 * vertex buffer space to reserve for the added geometry. This is necessary if it is planned
	 * to set a new geometry at this index at a later time that is larger than the original geometry.
	 * Defaults to the length of the given geometry vertex buffer.
	 * @param {number} [reservedIndexCount=-1] - Optional parameter specifying the amount of index
	 * buffer space to reserve for the added geometry. This is necessary if it is planned to set a
	 * new geometry at this index at a later time that is larger than the original geometry. Defaults to
	 * the length of the given geometry index buffer.
	 * @return {number} The geometry ID.
	 */ addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        const geometryInfo = {
            // geometry information
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            // draw range information
            start: -1,
            count: -1,
            // state
            boundingBox: null,
            boundingSphere: null,
            active: true
        };
        const geometryInfoList = this._geometryInfo;
        geometryInfo.vertexStart = this._nextVertexStart;
        geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            geometryInfo.indexStart = this._nextIndexStart;
            geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
        }
        if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.');
        // update id
        let geometryId;
        if (this._availableGeometryIds.length > 0) {
            this._availableGeometryIds.sort($2358b7e4ec07df88$var$ascIdSort);
            geometryId = this._availableGeometryIds.shift();
            geometryInfoList[geometryId] = geometryInfo;
        } else {
            geometryId = this._geometryCount;
            this._geometryCount++;
            geometryInfoList.push(geometryInfo);
        }
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        // increment the next geometry position
        this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
        this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        return geometryId;
    }
    /**
	 * Replaces the geometry at the given ID with the provided geometry. Throws an error if there
	 * is not enough space reserved for geometry. Calling this will change all instances that are
	 * rendering that geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry that should be replaced with the given geometry.
	 * @param {BufferGeometry} geometry - The new geometry.
	 * @return {number} The geometry ID.
	 */ setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error('THREE.BatchedMesh: Maximum geometry count reached.');
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const geometryInfo = this._geometryInfo[geometryId];
        if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('THREE.BatchedMesh: Reserved space not large enough for provided geometry.');
        // copy geometry buffer data over
        const vertexStart = geometryInfo.vertexStart;
        const reservedVertexCount = geometryInfo.reservedVertexCount;
        geometryInfo.vertexCount = geometry.getAttribute('position').count;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $2358b7e4ec07df88$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = geometryInfo.indexStart;
            const reservedIndexCount = geometryInfo.reservedIndexCount;
            geometryInfo.indexCount = geometry.getIndex().count;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedIndexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
        }
        // update the draw range
        geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
        geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
        // store the bounding boxes
        geometryInfo.boundingBox = null;
        if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
        geometryInfo.boundingSphere = null;
        if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
        this._visibilityChanged = true;
        return geometryId;
    }
    /**
	 * Deletes the geometry defined by the given ID from this batch. Any instances referencing
	 * this geometry will also be removed as a side effect.
	 *
	 * @param {number} geometryId - The ID of the geometry to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteGeometry(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
        // delete any instances associated with this geometry
        const instanceInfo = this._instanceInfo;
        for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].active && instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
        geometryInfoList[geometryId].active = false;
        this._availableGeometryIds.push(geometryId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Deletes an existing instance from the batch using the given ID.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteInstance(instanceId) {
        this.validateInstanceId(instanceId);
        this._instanceInfo[instanceId].active = false;
        this._availableInstanceIds.push(instanceId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Repacks the sub geometries in BatchedMesh to remove any unused space remaining from
	 * previously deleted geometry, freeing up space to add new geometry.
	 *
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ optimize() {
        // track the next indices to copy data to
        let nextVertexStart = 0;
        let nextIndexStart = 0;
        // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
        // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
        const geometryInfoList = this._geometryInfo;
        const indices = geometryInfoList.map((e, i)=>i).sort((a, b)=>{
            return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
        });
        const geometry = this.geometry;
        for(let i = 0, l = geometryInfoList.length; i < l; i++){
            // if a geometry range is inactive then don't copy anything
            const index = indices[i];
            const geometryInfo = geometryInfoList[index];
            if (geometryInfo.active === false) continue;
            // if a geometry contains an index buffer then shift it, as well
            if (geometry.index !== null) {
                if (geometryInfo.indexStart !== nextIndexStart) {
                    const { indexStart: indexStart, vertexStart: vertexStart, reservedIndexCount: reservedIndexCount } = geometryInfo;
                    const index = geometry.index;
                    const array = index.array;
                    // shift the index pointers based on how the vertex data will shift
                    // adjusting the index must happen first so the original vertex start value is available
                    const elementDelta = nextVertexStart - vertexStart;
                    for(let j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                    index.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                    index.addUpdateRange(nextIndexStart, reservedIndexCount);
                    index.needsUpdate = true;
                    geometryInfo.indexStart = nextIndexStart;
                }
                nextIndexStart += geometryInfo.reservedIndexCount;
            }
            // if a geometry needs to be moved then copy attribute data to overwrite unused space
            if (geometryInfo.vertexStart !== nextVertexStart) {
                const { vertexStart: vertexStart, reservedVertexCount: reservedVertexCount } = geometryInfo;
                const attributes = geometry.attributes;
                for(const key in attributes){
                    const attribute = attributes[key];
                    const { array: array, itemSize: itemSize } = attribute;
                    array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
                    attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                    attribute.needsUpdate = true;
                }
                geometryInfo.vertexStart = nextVertexStart;
            }
            nextVertexStart += geometryInfo.reservedVertexCount;
            geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
            // step the next geometry points to the shifted position
            this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
            this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        }
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the bounding box for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding box for.
	 * @param {Box3} target - The target object that is used to store the method's result.
	 * @return {?Box3} The geometry's bounding box. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingBox === null) {
            const box = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
            const index = geometry.index;
            const position = geometry.attributes.position;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($2358b7e4ec07df88$var$_vector$5.fromBufferAttribute(position, iv));
            }
            geometryInfo.boundingBox = box;
        }
        target.copy(geometryInfo.boundingBox);
        return target;
    }
    /**
	 * Returns the bounding sphere for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding sphere for.
	 * @param {Sphere} target - The target object that is used to store the method's result.
	 * @return {?Sphere} The geometry's bounding sphere. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingSphere === null) {
            const sphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
            this.getBoundingBoxAt(geometryId, $2358b7e4ec07df88$var$_box$1);
            $2358b7e4ec07df88$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            let maxRadiusSq = 0;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $2358b7e4ec07df88$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($2358b7e4ec07df88$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            geometryInfo.boundingSphere = sphere;
        }
        target.copy(geometryInfo.boundingSphere);
        return target;
    }
    /**
	 * Sets the given local transformation matrix to the defined instance.
	 * Negatively scaled matrices are not supported.
	 *
	 * @param {number} instanceId - The ID of an instance to set the matrix of.
	 * @param {Matrix4} matrix - A 4x4 matrix representing the local transformation of a single instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the local transformation matrix of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the matrix of.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 * @return {Matrix4} The instance's local transformation matrix.
	 */ getMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
    }
    /**
	 * Sets the given color to the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to set the color of.
	 * @param {Color} color - The color to set the instance to.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        if (this._colorsTexture === null) this._initColorsTexture();
        color.toArray(this._colorsTexture.image.data, instanceId * 4);
        this._colorsTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the color of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the color of.
	 * @param {Color} color - The target object that is used to store the method's result.
	 * @return {Color} The instance's color.
	 */ getColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
    }
    /**
	 * Sets the visibility of the instance.
	 *
	 * @param {number} instanceId - The id of the instance to set the visibility of.
	 * @param {boolean} visible - Whether the instance is visible or not.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setVisibleAt(instanceId, visible) {
        this.validateInstanceId(instanceId);
        if (this._instanceInfo[instanceId].visible === visible) return this;
        this._instanceInfo[instanceId].visible = visible;
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the visibility state of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the visibility state of.
	 * @return {boolean} Whether the instance is visible or not.
	 */ getVisibleAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].visible;
    }
    /**
	 * Sets the geometry ID of the instance at the given index.
	 *
	 * @param {number} instanceId - The ID of the instance to set the geometry ID of.
	 * @param {number} geometryId - The geometry ID to be use by the instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setGeometryIdAt(instanceId, geometryId) {
        this.validateInstanceId(instanceId);
        this.validateGeometryId(geometryId);
        this._instanceInfo[instanceId].geometryIndex = geometryId;
        return this;
    }
    /**
	 * Returns the geometry ID of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the geometry ID of.
	 * @return {number} The instance's geometry ID.
	 */ getGeometryIdAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].geometryIndex;
    }
    /**
	 * Get the range representing the subset of triangles related to the attached geometry,
	 * indicating the starting offset and count, or `null` if invalid.
	 *
	 * @param {number} geometryId - The id of the geometry to get the range of.
	 * @param {Object} [target] - The target object that is used to store the method's result.
	 * @return {{
	 * 	vertexStart:number,vertexCount:number,reservedVertexCount:number,
	 * 	indexStart:number,indexCount:number,reservedIndexCount:number,
	 * 	start:number,count:number
	 * }} The result object with range data.
	 */ getGeometryRangeAt(geometryId, target = {}) {
        this.validateGeometryId(geometryId);
        const geometryInfo = this._geometryInfo[geometryId];
        target.vertexStart = geometryInfo.vertexStart;
        target.vertexCount = geometryInfo.vertexCount;
        target.reservedVertexCount = geometryInfo.reservedVertexCount;
        target.indexStart = geometryInfo.indexStart;
        target.indexCount = geometryInfo.indexCount;
        target.reservedIndexCount = geometryInfo.reservedIndexCount;
        target.start = geometryInfo.start;
        target.count = geometryInfo.count;
        return target;
    }
    /**
	 * Resizes the necessary buffers to support the provided number of instances.
	 * If the provided arguments shrink the number of instances but there are not enough
	 * unused Ids at the end of the list then an error is thrown.
	 *
	 * @param {number} maxInstanceCount - The max number of individual instances that can be added and rendered by the batch.
	*/ setInstanceCount(maxInstanceCount) {
        // shrink the available instances as much as possible
        const availableInstanceIds = this._availableInstanceIds;
        const instanceInfo = this._instanceInfo;
        availableInstanceIds.sort($2358b7e4ec07df88$var$ascIdSort);
        while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length - 1){
            instanceInfo.pop();
            availableInstanceIds.pop();
        }
        // throw an error if it can't be shrunk to the desired size
        if (maxInstanceCount < instanceInfo.length) throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
        // copy the multi draw counts
        const multiDrawCounts = new Int32Array(maxInstanceCount);
        const multiDrawStarts = new Int32Array(maxInstanceCount);
        $2358b7e4ec07df88$var$copyArrayContents(this._multiDrawCounts, multiDrawCounts);
        $2358b7e4ec07df88$var$copyArrayContents(this._multiDrawStarts, multiDrawStarts);
        this._multiDrawCounts = multiDrawCounts;
        this._multiDrawStarts = multiDrawStarts;
        this._maxInstanceCount = maxInstanceCount;
        // update texture data for instance sampling
        const indirectTexture = this._indirectTexture;
        const matricesTexture = this._matricesTexture;
        const colorsTexture = this._colorsTexture;
        indirectTexture.dispose();
        this._initIndirectTexture();
        $2358b7e4ec07df88$var$copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
        matricesTexture.dispose();
        this._initMatricesTexture();
        $2358b7e4ec07df88$var$copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
        if (colorsTexture) {
            colorsTexture.dispose();
            this._initColorsTexture();
            $2358b7e4ec07df88$var$copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
        }
    }
    /**
	 * Resizes the available space in the batch's vertex and index buffer attributes to the provided sizes.
	 * If the provided arguments shrink the geometry buffers but there is not enough unused space at the
	 * end of the geometry attributes then an error is thrown.
	 *
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries to resize to.
	 * @param {number} maxIndexCount - The maximum number of indices to be used by all unique geometries to resize to.
	*/ setGeometrySize(maxVertexCount, maxIndexCount) {
        // Check if we can shrink to the requested vertex attribute size
        const validRanges = [
            ...this._geometryInfo
        ].filter((info)=>info.active);
        const requiredVertexLength = Math.max(...validRanges.map((range)=>range.vertexStart + range.reservedVertexCount));
        if (requiredVertexLength > maxVertexCount) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        // Check if we can shrink to the requested index attribute size
        if (this.geometry.index) {
            const requiredIndexLength = Math.max(...validRanges.map((range)=>range.indexStart + range.reservedIndexCount));
            if (requiredIndexLength > maxIndexCount) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        }
        //
        // dispose of the previous geometry
        const oldGeometry = this.geometry;
        oldGeometry.dispose();
        // recreate the geometry needed based on the previous variant
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        if (this._geometryInitialized) {
            this._geometryInitialized = false;
            this.geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
            this._initializeGeometry(oldGeometry);
        }
        // copy data from the previous geometry
        const geometry = this.geometry;
        if (oldGeometry.index) $2358b7e4ec07df88$var$copyArrayContents(oldGeometry.index.array, geometry.index.array);
        for(const key in oldGeometry.attributes)$2358b7e4ec07df88$var$copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
    raycast(raycaster, intersects) {
        const instanceInfo = this._instanceInfo;
        const geometryInfoList = this._geometryInfo;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $2358b7e4ec07df88$var$_mesh.material = this.material;
        $2358b7e4ec07df88$var$_mesh.geometry.index = batchGeometry.index;
        $2358b7e4ec07df88$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($2358b7e4ec07df88$var$_mesh.geometry.boundingBox === null) $2358b7e4ec07df88$var$_mesh.geometry.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
        if ($2358b7e4ec07df88$var$_mesh.geometry.boundingSphere === null) $2358b7e4ec07df88$var$_mesh.geometry.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            const geometryInfo = geometryInfoList[geometryId];
            $2358b7e4ec07df88$var$_mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
            // get the intersects
            this.getMatrixAt(i, $2358b7e4ec07df88$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $2358b7e4ec07df88$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $2358b7e4ec07df88$var$_mesh.geometry.boundingSphere);
            $2358b7e4ec07df88$var$_mesh.raycast(raycaster, $2358b7e4ec07df88$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $2358b7e4ec07df88$var$_batchIntersects.length; j < l; j++){
                const intersect = $2358b7e4ec07df88$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $2358b7e4ec07df88$var$_batchIntersects.length = 0;
        }
        $2358b7e4ec07df88$var$_mesh.material = null;
        $2358b7e4ec07df88$var$_mesh.geometry.index = null;
        $2358b7e4ec07df88$var$_mesh.geometry.attributes = {};
        $2358b7e4ec07df88$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._geometryInfo = source._geometryInfo.map((info)=>({
                ...info,
                boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
            }));
        this._instanceInfo = source._instanceInfo.map((info)=>({
                ...info
            }));
        this._availableInstanceIds = source._availableInstanceIds.slice();
        this._availableGeometryIds = source._availableGeometryIds.slice();
        this._nextIndexStart = source._nextIndexStart;
        this._nextVertexStart = source._nextVertexStart;
        this._geometryCount = source._geometryCount;
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._indirectTexture = source._indirectTexture.clone();
        this._indirectTexture.image.data = this._indirectTexture.image.data.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        const instanceInfo = this._instanceInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const geometryInfoList = this._geometryInfo;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        const frustum = camera.isArrayCamera ? $2358b7e4ec07df88$var$_frustumArray : $2358b7e4ec07df88$var$_frustum;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled && !camera.isArrayCamera) {
            $2358b7e4ec07df88$var$_matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $2358b7e4ec07df88$var$_frustum.setFromProjectionMatrix($2358b7e4ec07df88$var$_matrix$1, camera.coordinateSystem, camera.reversedDepth);
        }
        let multiDrawCount = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $2358b7e4ec07df88$var$_matrix$1.copy(this.matrixWorld).invert();
            $2358b7e4ec07df88$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($2358b7e4ec07df88$var$_matrix$1);
            $2358b7e4ec07df88$var$_forward$1.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($2358b7e4ec07df88$var$_matrix$1);
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $2358b7e4ec07df88$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $2358b7e4ec07df88$var$_sphere$2).applyMatrix4($2358b7e4ec07df88$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !frustum.intersectsSphere($2358b7e4ec07df88$var$_sphere$2, camera);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const geometryInfo = geometryInfoList[geometryId];
                    const z = $2358b7e4ec07df88$var$_temp.subVectors($2358b7e4ec07df88$var$_sphere$2.center, $2358b7e4ec07df88$var$_vector$5).dot($2358b7e4ec07df88$var$_forward$1);
                    $2358b7e4ec07df88$var$_renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $2358b7e4ec07df88$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $2358b7e4ec07df88$var$sortTransparent : $2358b7e4ec07df88$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
                multiDrawCounts[multiDrawCount] = item.count;
                indirectArray[multiDrawCount] = item.index;
                multiDrawCount++;
            }
            $2358b7e4ec07df88$var$_renderList.reset();
        } else {
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $2358b7e4ec07df88$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $2358b7e4ec07df88$var$_sphere$2).applyMatrix4($2358b7e4ec07df88$var$_matrix$1);
                    culled = !frustum.intersectsSphere($2358b7e4ec07df88$var$_sphere$2, camera);
                }
                if (!culled) {
                    const geometryInfo = geometryInfoList[geometryId];
                    multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement;
                    multiDrawCounts[multiDrawCount] = geometryInfo.count;
                    indirectArray[multiDrawCount] = i;
                    multiDrawCount++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = multiDrawCount;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 * ```
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$fbaaa33907730a0c extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new line basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff);
        /**
		 * Sets the color of the lines using data from a texture. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Controls line thickness or lines.
		 *
		 * Can only be used with {@link SVGRenderer}. WebGL and WebGPU
		 * ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Defines appearance of line ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('butt'|'round'|'square')}
		 * @default 'round'
		 */ this.linecap = 'round';
        /**
		 * Defines appearance of line joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.linejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $2358b7e4ec07df88$var$_vStart = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vEnd = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_inverseMatrix$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_ray$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$a186db52eed6d40e();
const $2358b7e4ec07df88$var$_sphere$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_intersectPointOnRay = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_intersectPointOnSegment = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A continuous line. The line are rendered by connecting consecutive
 * vertices with straight lines.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0x0000ff } );
 *
 * const points = [];
 * points.push( new THREE.Vector3( - 10, 0, 0 ) );
 * points.push( new THREE.Vector3( 0, 10, 0 ) );
 * points.push( new THREE.Vector3( 10, 0, 0 ) );
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$17d680238e50603e extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new line.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry = new $2358b7e4ec07df88$export$b7be63a67df8959(), material = new $2358b7e4ec07df88$export$fbaaa33907730a0c()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLine = true;
        this.type = 'Line';
        /**
		 * The line geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default LineBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes an array of distance values which are necessary for rendering dashed lines.
	 * For each vertex in the geometry, the method calculates the cumulative length from the
	 * current point to the very beginning of the line.
	 *
	 * @return {Line} A reference to this line.
	 */ computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $2358b7e4ec07df88$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $2358b7e4ec07df88$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $2358b7e4ec07df88$var$_vStart.distanceTo($2358b7e4ec07df88$var$_vEnd);
            }
            geometry.setAttribute('lineDistance', new $2358b7e4ec07df88$export$cbe7a62641830ebd(lineDistances, 1));
        } else $2358b7e4ec07df88$export$c106dd0671a0fc2d('Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $2358b7e4ec07df88$var$_sphere$1.copy(geometry.boundingSphere);
        $2358b7e4ec07df88$var$_sphere$1.applyMatrix4(matrixWorld);
        $2358b7e4ec07df88$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($2358b7e4ec07df88$var$_sphere$1) === false) return;
        //
        $2358b7e4ec07df88$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $2358b7e4ec07df88$var$_ray$1.copy(raycaster.ray).applyMatrix4($2358b7e4ec07df88$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $2358b7e4ec07df88$var$checkIntersection(this, raycaster, $2358b7e4ec07df88$var$_ray$1, localThresholdSq, a, b, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $2358b7e4ec07df88$var$checkIntersection(this, raycaster, $2358b7e4ec07df88$var$_ray$1, localThresholdSq, a, b, end - 1);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $2358b7e4ec07df88$var$checkIntersection(this, raycaster, $2358b7e4ec07df88$var$_ray$1, localThresholdSq, i, i + 1, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $2358b7e4ec07df88$var$checkIntersection(this, raycaster, $2358b7e4ec07df88$var$_ray$1, localThresholdSq, end - 1, start, end - 1);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    /**
	 * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $2358b7e4ec07df88$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b, i) {
    const positionAttribute = object.geometry.attributes.position;
    $2358b7e4ec07df88$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $2358b7e4ec07df88$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($2358b7e4ec07df88$var$_vStart, $2358b7e4ec07df88$var$_vEnd, $2358b7e4ec07df88$var$_intersectPointOnRay, $2358b7e4ec07df88$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $2358b7e4ec07df88$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($2358b7e4ec07df88$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $2358b7e4ec07df88$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: i,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
const $2358b7e4ec07df88$var$_start = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_end = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A series of lines drawn between pairs of vertices.
 *
 * @augments Line
 */ class $2358b7e4ec07df88$export$ff1ed10fedfdd604 extends $2358b7e4ec07df88$export$17d680238e50603e {
    /**
	 * Constructs a new line segments.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $2358b7e4ec07df88$var$_start.fromBufferAttribute(positionAttribute, i);
                $2358b7e4ec07df88$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $2358b7e4ec07df88$var$_start.distanceTo($2358b7e4ec07df88$var$_end);
            }
            geometry.setAttribute('lineDistance', new $2358b7e4ec07df88$export$cbe7a62641830ebd(lineDistances, 1));
        } else $2358b7e4ec07df88$export$c106dd0671a0fc2d('LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
/**
 * A continuous line. This is nearly the same as {@link Line} the only difference
 * is that the last vertex is connected with the first vertex in order to close
 * the line to form a loop.
 *
 * @augments Line
 */ class $2358b7e4ec07df88$export$f85a24d745e4f17d extends $2358b7e4ec07df88$export$17d680238e50603e {
    /**
	 * Constructs a new line loop.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
/**
 * A material for rendering point primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const vertices = [];
 *
 * for ( let i = 0; i < 10000; i ++ ) {
 * 	const x = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const y = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const z = THREE.MathUtils.randFloatSpread( 2000 );
 *
 * 	vertices.push( x, y, z );
 * }
 *
 * const geometry = new THREE.BufferGeometry();
 * geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
 * const material = new THREE.PointsMaterial( { color: 0x888888 } );
 * const points = new THREE.Points( geometry, material );
 * scene.add( points );
 * ```
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$a178c45366ce5d6b extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new points material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Defines the size of the points in pixels.
		 *
		 * Might be capped if the value exceeds hardware dependent parameters like [gl.ALIASED_POINT_SIZE_RANGE](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getParamete).
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = 1;
        /**
		 * Specifies whether size of individual points is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $2358b7e4ec07df88$var$_inverseMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_ray = /*@__PURE__*/ new $2358b7e4ec07df88$export$a186db52eed6d40e();
const $2358b7e4ec07df88$var$_sphere = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_position$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A class for displaying points or point clouds.
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$1c787534cb11aa3e extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new point cloud.
	 *
	 * @param {BufferGeometry} [geometry] - The points geometry.
	 * @param {Material|Array<Material>} [material] - The points material.
	 */ constructor(geometry = new $2358b7e4ec07df88$export$b7be63a67df8959(), material = new $2358b7e4ec07df88$export$a178c45366ce5d6b()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPoints = true;
        this.type = 'Points';
        /**
		 * The points geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default PointsMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this point cloud.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $2358b7e4ec07df88$var$_sphere.copy(geometry.boundingSphere);
        $2358b7e4ec07df88$var$_sphere.applyMatrix4(matrixWorld);
        $2358b7e4ec07df88$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($2358b7e4ec07df88$var$_sphere) === false) return;
        //
        $2358b7e4ec07df88$var$_inverseMatrix.copy(matrixWorld).invert();
        $2358b7e4ec07df88$var$_ray.copy(raycaster.ray).applyMatrix4($2358b7e4ec07df88$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $2358b7e4ec07df88$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $2358b7e4ec07df88$var$testPoint($2358b7e4ec07df88$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $2358b7e4ec07df88$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $2358b7e4ec07df88$var$testPoint($2358b7e4ec07df88$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    /**
	 * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $2358b7e4ec07df88$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $2358b7e4ec07df88$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $2358b7e4ec07df88$export$64b5c384219d3699();
        $2358b7e4ec07df88$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
/**
 * A texture for use with a video.
 *
 * ```js
 * // assuming you have created a HTML video element with id="video"
 * const video = document.getElementById( 'video' );
 * const texture = new THREE.VideoTexture( video );
 * ```
 *
 * Note: When using video textures with {@link WebGPURenderer}, {@link Texture#colorSpace} must be
 * set to THREE.SRGBColorSpace.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$6e09d1edf8d5a25c extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {HTMLVideoElement} video - The video element to use as a data source for the texture.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(video, mapping, wrapS, wrapT, magFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8, minFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoTexture = true;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * The video frame request callback identifier, which is a positive integer.
		 *
		 * Value of 0 represents no scheduled rVFC.
		 *
		 * @private
		 * @type {number}
		 */ this._requestVideoFrameCallbackId = 0;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            scope._requestVideoFrameCallbackId = video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) this._requestVideoFrameCallbackId = video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    /**
	 * This method is called automatically by the renderer and sets {@link Texture#needsUpdate}
	 * to `true` every time a new frame is available.
	 *
	 * Only relevant if `requestVideoFrameCallback` is not supported in the browser.
	 */ update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
    dispose() {
        if (this._requestVideoFrameCallbackId !== 0) {
            this.source.data.cancelVideoFrameCallback(this._requestVideoFrameCallbackId);
            this._requestVideoFrameCallbackId = 0;
        }
        super.dispose();
    }
}
/**
 * This class can be used as an alternative way to define video data. Instead of using
 * an instance of `HTMLVideoElement` like with `VideoTexture`, `VideoFrameTexture` expects each frame is
 * defined manually via {@link VideoFrameTexture#setFrame}. A typical use case for this module is when
 * video frames are decoded with the WebCodecs API.
 *
 * ```js
 * const texture = new THREE.VideoFrameTexture();
 * texture.setFrame( frame );
 * ```
 *
 * @augments VideoTexture
 */ class $2358b7e4ec07df88$export$68498d200b825382 extends $2358b7e4ec07df88$export$6e09d1edf8d5a25c {
    /**
	 * Constructs a new video frame texture.
	 *
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super({}, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoFrameTexture = true;
    }
    /**
	 * This method overwritten with an empty implementation since
	 * this type of texture is updated via `setFrame()`.
	 */ update() {}
    clone() {
        return new this.constructor().copy(this); // restoring Texture.clone()
    }
    /**
	 * Sets the current frame of the video. This will automatically update the texture
	 * so the data can be used for rendering.
	 *
	 * @param {VideoFrame} frame - The video frame.
	 */ setFrame(frame) {
        this.image = frame;
        this.needsUpdate = true;
    }
}
/**
 * This class can only be used in combination with `copyFramebufferToTexture()` methods
 * of renderers. It extracts the contents of the current bound framebuffer and provides it
 * as a texture for further usage.
 *
 * ```js
 * const pixelRatio = window.devicePixelRatio;
 * const textureSize = 128 * pixelRatio;
 *
 * const frameTexture = new FramebufferTexture( textureSize, textureSize );
 *
 * // calculate start position for copying part of the frame data
 * const vector = new Vector2();
 * vector.x = ( window.innerWidth * pixelRatio / 2 ) - ( textureSize / 2 );
 * vector.y = ( window.innerHeight * pixelRatio / 2 ) - ( textureSize / 2 );
 *
 * renderer.render( scene, camera );
 *
 * // copy part of the rendered frame into the framebuffer texture
 * renderer.copyFramebufferToTexture( frameTexture, vector );
 * ```
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$9270d786f73ce6fe extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new framebuffer texture.
	 *
	 * @param {number} [width] - The width of the texture.
	 * @param {number} [height] - The height of the texture.
	 */ constructor(width, height){
        super({
            width: width,
            height: height
        });
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFramebufferTexture = true;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
/**
 * Creates a texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$3466bac9141a5cc4 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @type {{width:number,height:number}}
		 */ this.image = {
            width: width,
            height: height
        };
        /**
		 * This array holds for all mipmaps (including the bases mip) the data and dimensions.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = mipmaps;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default since it is not possible to
		 * flip compressed textures.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default since it is not
		 * possible to generate mipmaps for compressed data. Mipmaps
		 * must be embedded in the compressed texture file.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.generateMipmaps = false;
    }
}
/**
 * Creates a texture 2D array based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $2358b7e4ec07df88$export$5fe6b8e34b274fcb extends $2358b7e4ec07df88$export$3466bac9141a5cc4 {
    /**
	 * Constructs a new compressed array texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} depth - The depth of the texture.
	 * @param {number} [format=RGBAFormat] - The min filter value.
	 * @param {number} [type=UnsignedByteType] - The min filter value.
	 */ constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedArrayTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @name CompressedArrayTexture#image
		 * @type {{width:number,height:number,depth:number}}
		 */ this.image.depth = depth;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $2358b7e4ec07df88$export$9d9334239a5a5e06;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire compressed texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * Creates a cube texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $2358b7e4ec07df88$export$d80173634de65bff extends $2358b7e4ec07df88$export$3466bac9141a5cc4 {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<CompressedTexture>} images - An array of compressed textures.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 */ constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $2358b7e4ec07df88$export$8759762a6477f2c4);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedCubeTexture = true;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        this.image = images;
    }
}
/**
 * Creates a texture from a canvas element.
 *
 * This is almost the same as the base texture class, except that it sets {@link Texture#needsUpdate}
 * to `true` immediately since a canvas can directly be used for rendering.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$f7189e49152d1c13 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {HTMLCanvasElement} [canvas] - The HTML canvas element.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * This class can be used to automatically save the depth information of a
 * rendering into a texture.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$fc830aa069cc8c2f extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new depth texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [type=UnsignedIntType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {number} [format=DepthFormat] - The texture format.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(width, height, type = $2358b7e4ec07df88$export$c3c7fc4518ebba96, mapping, wrapS, wrapT, magFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0, minFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0, anisotropy, format = $2358b7e4ec07df88$export$c1b6b5136be58045, depth = 1){
        if (format !== $2358b7e4ec07df88$export$c1b6b5136be58045 && format !== $2358b7e4ec07df88$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        const image = {
            width: width,
            height: height,
            depth: depth
        };
        super(image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDepthTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * Code corresponding to the depth compare function.
		 *
		 * @type {?(NeverCompare|LessCompare|EqualCompare|LessEqualCompare|GreaterCompare|NotEqualCompare|GreaterEqualCompare|AlwaysCompare)}
		 * @default null
		 */ this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.source = new $2358b7e4ec07df88$export$1d2df86270c81ecb(Object.assign({}, source.image)); // see #30540
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * This class can be used to automatically save the depth information of a
 * cube rendering into a cube texture with depth format. Used for PointLight shadows.
 *
 * @augments DepthTexture
 */ class $2358b7e4ec07df88$export$c9f39eef7fb1d170 extends $2358b7e4ec07df88$export$fc830aa069cc8c2f {
    /**
	 * Constructs a new cube depth texture.
	 *
	 * @param {number} size - The size (width and height) of each cube face.
	 * @param {number} [type=UnsignedIntType] - The texture type.
	 * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=NearestFilter] - The mag filter value.
	 * @param {number} [minFilter=NearestFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {number} [format=DepthFormat] - The texture format.
	 */ constructor(size, type = $2358b7e4ec07df88$export$c3c7fc4518ebba96, mapping = $2358b7e4ec07df88$export$8759762a6477f2c4, wrapS, wrapT, magFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0, minFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0, anisotropy, format = $2358b7e4ec07df88$export$c1b6b5136be58045){
        // Create 6 identical image descriptors for the cube faces
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        // Call DepthTexture constructor with width, height
        super(size, size, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format);
        // Replace the single image with the array of 6 images
        this.image = images;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeDepthTexture = true;
        /**
		 * Set to true for cube texture handling in WebGLTextures.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
    }
    /**
	 * Alias for {@link CubeDepthTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
/**
 * Represents a texture created externally with the same renderer context.
 *
 * This may be a texture from a protected media stream, device camera feed,
 * or other data feeds like a depth sensor.
 *
 * Note that this class is only supported in {@link WebGLRenderer}, and in
 * the {@link WebGPURenderer} WebGPU backend.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$cd10147cacf16ab2 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Creates a new raw texture.
	 *
	 * @param {?(WebGLTexture|GPUTexture)} [sourceTexture=null] - The external texture.
	 */ constructor(sourceTexture = null){
        super();
        /**
		 * The external source texture.
		 *
		 * @type {?(WebGLTexture|GPUTexture)}
		 * @default null
		 */ this.sourceTexture = sourceTexture;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isExternalTexture = true;
    }
    copy(source) {
        super.copy(source);
        this.sourceTexture = source.sourceTexture;
        return this;
    }
}
/**
 * A geometry class for representing a capsule.
 *
 * ```js
 * const geometry = new THREE.CapsuleGeometry( 1, 1, 4, 8, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const capsule = new THREE.Mesh( geometry, material );
 * scene.add( capsule );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CapsuleGeometry
 */ class $2358b7e4ec07df88$export$41680e8551036033 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new capsule geometry.
	 *
	 * @param {number} [radius=1] - Radius of the capsule.
	 * @param {number} [height=1] - Height of the middle section.
	 * @param {number} [capSegments=4] - Number of curve segments used to build each cap.
	 * @param {number} [radialSegments=8] - Number of segmented faces around the circumference of the capsule. Must be an integer >= 3.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the middle section. Must be an integer >= 1.
	 */ constructor(radius = 1, height = 1, capSegments = 4, radialSegments = 8, heightSegments = 1){
        super();
        this.type = 'CapsuleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            capSegments: capSegments,
            radialSegments: radialSegments,
            heightSegments: heightSegments
        };
        height = Math.max(0, height);
        capSegments = Math.max(1, Math.floor(capSegments));
        radialSegments = Math.max(3, Math.floor(radialSegments));
        heightSegments = Math.max(1, Math.floor(heightSegments));
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const halfHeight = height / 2;
        const capArcLength = Math.PI / 2 * radius;
        const cylinderPartLength = height;
        const totalArcLength = 2 * capArcLength + cylinderPartLength;
        const numVerticalSegments = capSegments * 2 + heightSegments;
        const verticesPerRow = radialSegments + 1;
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        // generate vertices, normals, and uvs
        for(let iy = 0; iy <= numVerticalSegments; iy++){
            let currentArcLength = 0;
            let profileY = 0;
            let profileRadius = 0;
            let normalYComponent = 0;
            if (iy <= capSegments) {
                // bottom cap
                const segmentProgress = iy / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = -halfHeight - radius * Math.cos(angle);
                profileRadius = radius * Math.sin(angle);
                normalYComponent = -radius * Math.cos(angle);
                currentArcLength = segmentProgress * capArcLength;
            } else if (iy <= capSegments + heightSegments) {
                // middle section
                const segmentProgress = (iy - capSegments) / heightSegments;
                profileY = -halfHeight + segmentProgress * height;
                profileRadius = radius;
                normalYComponent = 0;
                currentArcLength = capArcLength + segmentProgress * cylinderPartLength;
            } else {
                // top cap
                const segmentProgress = (iy - capSegments - heightSegments) / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = halfHeight + radius * Math.sin(angle);
                profileRadius = radius * Math.cos(angle);
                normalYComponent = radius * Math.sin(angle);
                currentArcLength = capArcLength + cylinderPartLength + segmentProgress * capArcLength;
            }
            const v = Math.max(0, Math.min(1, currentArcLength / totalArcLength));
            // special case for the poles
            let uOffset = 0;
            if (iy === 0) uOffset = 0.5 / radialSegments;
            else if (iy === numVerticalSegments) uOffset = -0.5 / radialSegments;
            for(let ix = 0; ix <= radialSegments; ix++){
                const u = ix / radialSegments;
                const theta = u * Math.PI * 2;
                const sinTheta = Math.sin(theta);
                const cosTheta = Math.cos(theta);
                // vertex
                vertex.x = -profileRadius * cosTheta;
                vertex.y = profileY;
                vertex.z = profileRadius * sinTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.set(-profileRadius * cosTheta, normalYComponent, profileRadius * sinTheta);
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, v);
            }
            if (iy > 0) {
                const prevIndexRow = (iy - 1) * verticesPerRow;
                for(let ix = 0; ix < radialSegments; ix++){
                    const i1 = prevIndexRow + ix;
                    const i2 = prevIndexRow + ix + 1;
                    const i3 = iy * verticesPerRow + ix;
                    const i4 = iy * verticesPerRow + ix + 1;
                    indices.push(i1, i2, i3);
                    indices.push(i2, i4, i3);
                }
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CapsuleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$41680e8551036033(data.radius, data.height, data.capSegments, data.radialSegments, data.heightSegments);
    }
}
/**
 * A simple shape of Euclidean geometry. It is constructed from a
 * number of triangular segments that are oriented around a central point and
 * extend as far out as a given radius. It is built counter-clockwise from a
 * start angle and a given central angle. It can also be used to create
 * regular polygons, where the number of segments determines the number of
 * sides.
 *
 * ```js
 * const geometry = new THREE.CircleGeometry( 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const circle = new THREE.Mesh( geometry, material );
 * scene.add( circle )
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CircleGeometry
 */ class $2358b7e4ec07df88$export$d5c0e8d607467193 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new circle geometry.
	 *
	 * @param {number} [radius=1] - Radius of the circle.
	 * @param {number} [segments=32] - Number of segments (triangles), minimum = `3`.
	 * @param {number} [thetaStart=0] - Start angle for first segment in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta,
	 * of the circular sector in radians. The default value results in a complete circle.
	 */ constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const uv = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CircleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cylinder.
 *
 * ```js
 * const geometry = new THREE.CylinderGeometry( 5, 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cylinder = new THREE.Mesh( geometry, material );
 * scene.add( cylinder );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CylinderGeometry
 */ class $2358b7e4ec07df88$export$68f745719dbe5198 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new cylinder geometry.
	 *
	 * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
	 * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
	 * @param {number} [height=1] - Height of the cylinder.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
	 * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cylinder.
	 */ constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                if (radiusTop > 0 || y !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
            const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CylinderGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cone.
 *
 * ```js
 * const geometry = new THREE.ConeGeometry( 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cone = new THREE.Mesh(geometry, material );
 * scene.add( cone );
 * ```
 *
 * @augments CylinderGeometry
 * @demo scenes/geometry-browser.html#ConeGeometry
 */ class $2358b7e4ec07df88$export$a7a48974f285c9b3 extends $2358b7e4ec07df88$export$68f745719dbe5198 {
    /**
	 * Constructs a new cone geometry.
	 *
	 * @param {number} [radius=1] - Radius of the cone base.
	 * @param {number} [height=1] - Height of the cone.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cone.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cone.
	 * @param {boolean} [openEnded=false] - Whether the base of the cone is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cone.
	 */ constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {ConeGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A polyhedron is a solid in three dimensions with flat faces. This class
 * will take an array of vertices, project them onto a sphere, and then
 * divide them up to the desired level of detail.
 *
 * @augments BufferGeometry
 */ class $2358b7e4ec07df88$export$60e57a7d3f20ff65 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new polyhedron geometry.
	 *
	 * @param {Array<number>} [vertices] - A flat array of vertices describing the base shape.
	 * @param {Array<number>} [indices] - A flat array of indices describing the base shape.
	 * @param {number} [radius=1] - The radius of the shape.
	 * @param {number} [detail=0] - How many levels to subdivide the geometry. The more detail, the smoother the shape.
	 */ constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const b = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const c = new $2358b7e4ec07df88$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const b = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const c = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const centroid = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const uvA = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
            const uvB = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
            const uvC = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PolyhedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.detail);
    }
}
/**
 * A geometry class for representing a dodecahedron.
 *
 * ```js
 * const geometry = new THREE.DodecahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const dodecahedron = new THREE.Mesh( geometry, material );
 * scene.add( dodecahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#DodecahedronGeometry
 */ class $2358b7e4ec07df88$export$c0babfeb8708fc9c extends $2358b7e4ec07df88$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new dodecahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the dodecahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a dodecahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {DodecahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $2358b7e4ec07df88$var$_v0 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v1$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_normal = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_triangle = /*@__PURE__*/ new $2358b7e4ec07df88$export$5a465592bfe74b48();
/**
 * Can be used as a helper object to view the edges of a geometry.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry();
 * const edges = new THREE.EdgesGeometry( geometry );
 * const line = new THREE.LineSegments( edges );
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $2358b7e4ec07df88$export$4730b1542707547f extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new edges geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 * @param {number} [thresholdAngle=1] - An edge is only rendered if the angle (in degrees)
	 * between the face normals of the adjoining faces exceeds this value.
	 */ constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($2358b7e4ec07df88$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $2358b7e4ec07df88$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $2358b7e4ec07df88$var$_triangle.getNormal($2358b7e4ec07df88$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $2358b7e4ec07df88$var$_triangle[vertKeys[j]];
                    const v1 = $2358b7e4ec07df88$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($2358b7e4ec07df88$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $2358b7e4ec07df88$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $2358b7e4ec07df88$var$_v0.fromBufferAttribute(positionAttr, index0);
                $2358b7e4ec07df88$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($2358b7e4ec07df88$var$_v0.x, $2358b7e4ec07df88$var$_v0.y, $2358b7e4ec07df88$var$_v0.z);
                vertices.push($2358b7e4ec07df88$var$_v1$1.x, $2358b7e4ec07df88$var$_v1$1.y, $2358b7e4ec07df88$var$_v1$1.z);
            }
            this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
/**
 * An abstract base class for creating an analytic curve object that contains methods
 * for interpolation.
 *
 * @abstract
 */ class $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Curve';
        /**
		 * This value determines the amount of divisions when calculating the
		 * cumulative segment lengths of a curve via {@link Curve#getLengths}. To ensure
		 * precision when using methods like {@link Curve#getSpacedPoints}, it is
		 * recommended to increase the value of this property if the curve is very large.
		 *
		 * @type {number}
		 * @default 200
		 */ this.arcLengthDivisions = 200;
        /**
		 * Must be set to `true` if the curve parameters have changed.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        /**
		 * An internal cache that holds precomputed curve length values.
		 *
		 * @private
		 * @type {?Array<number>}
		 * @default null
		 */ this.cacheArcLengths = null;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor.
	 *
	 * @abstract
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint() {
        $2358b7e4ec07df88$export$c106dd0671a0fc2d('Curve: .getPoint() not implemented.');
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
	 * of the curve which equidistant samples.
	 *
	 * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    /**
	 * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
	 * the curve shape.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    /**
	 * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
	 * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
	 * curve.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    /**
	 * Returns the total arc length of the curve.
	 *
	 * @return {number} The length of the curve.
	 */ getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    /**
	 * Returns an array of cumulative segment lengths of the curve.
	 *
	 * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
	 * @return {Array<number>} An array holding the cumulative segment lengths.
	 */ getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    /**
	 * Update the cumulative segment distance cache. The method must be called
	 * every time curve parameters are changed. If an updated curve is part of a
	 * composed curve like {@link CurvePath}, this method must be called on the
	 * composed curve, too.
	 */ updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    /**
	 * Given an interpolation factor in the range `[0,1]`, this method returns an updated
	 * interpolation factor in the same range that can be ued to sample equidistant points
	 * from a curve.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {?number} distance - An optional distance on the curve.
	 * @return {number} The updated interpolation factor.
	 */ getUtoTmapping(u, distance = null) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    /**
	 * Returns a unit vector tangent for the given interpolation factor.
	 * If the derived curve does not implement its tangent derivation,
	 * two points a small delta apart will be used to find its gradient
	 * which seems to give a reasonable approximation.
	 *
	 * @param {number} t - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 */ getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $2358b7e4ec07df88$export$c977b3e384af9ae1() : new $2358b7e4ec07df88$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    /**
	 * Same as {@link Curve#getTangent} but with equidistant samples.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 * @see {@link Curve#getPointAt}
	 */ getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    /**
	 * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
	 * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
	 *
	 * @param {number} segments - The number of segments.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
	 */ computeFrenetFrames(segments, closed = false) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const mat = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $2358b7e4ec07df88$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $2358b7e4ec07df88$export$64b5c384219d3699();
        binormals[0] = new $2358b7e4ec07df88$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($2358b7e4ec07df88$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($2358b7e4ec07df88$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    /**
	 * Returns a new curve with copied values from this instance.
	 *
	 * @return {Curve} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given curve to this instance.
	 *
	 * @param {Curve} source - The curve to copy.
	 * @return {Curve} A reference to this curve.
	 */ copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    /**
	 * Serializes the curve into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized curve.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    /**
	 * Deserializes the curve from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized curve.
	 * @return {Curve} A reference to this curve.
	 */ fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
/**
 * A curve representing an ellipse.
 *
 * ```js
 * const curve = new THREE.EllipseCurve(
 * 	0, 0,
 * 	10, 10,
 * 	0, 2 * Math.PI,
 * 	false,
 * 	0
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const ellipse = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$3f87a931616cde04 extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new ellipse curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 */ constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        /**
		 * The X center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aX = aX;
        /**
		 * The Y center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aY = aY;
        /**
		 * The radius of the ellipse in the x direction.
		 * Setting the this value equal to the {@link EllipseCurve#yRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.xRadius = xRadius;
        /**
		 * The radius of the ellipse in the y direction.
		 * Setting the this value equal to the {@link EllipseCurve#xRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.yRadius = yRadius;
        /**
		 * The start angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aStartAngle = aStartAngle;
        /**
		 * The end angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default Math.PI*2
		 */ this.aEndAngle = aEndAngle;
        /**
		 * Whether the ellipse is drawn clockwise or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.aClockwise = aClockwise;
        /**
		 * The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aRotation = aRotation;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
/**
 * A curve representing an arc.
 *
 * @augments EllipseCurve
 */ class $2358b7e4ec07df88$export$b1eedc9aab6300e8 extends $2358b7e4ec07df88$export$3f87a931616cde04 {
    /**
	 * Constructs a new arc curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [aRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 */ constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
function $2358b7e4ec07df88$var$CubicPoly() {
    /**
	 * Centripetal CatmullRom Curve - which is useful for avoiding
	* cusps and self-intersections in non-uniform catmull rom curves.
	* http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	*
	* curve.type accepts centripetal(default), chordal and catmullrom
	* curve.tension is used for catmullrom which defaults to 0.5
	*/ /*
	Based on an optimized c++ solution in
	- http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
	- http://ideone.com/NoEbVM

	This CubicPoly class could be used for reusing some variables and calculations,
	but for three.js curve use, it could be possible inlined and flatten into a single function call
	which can be placed in CurveUtils.
	*/ let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $2358b7e4ec07df88$var$tmp = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$px = /*@__PURE__*/ new $2358b7e4ec07df88$var$CubicPoly();
const $2358b7e4ec07df88$var$py = /*@__PURE__*/ new $2358b7e4ec07df88$var$CubicPoly();
const $2358b7e4ec07df88$var$pz = /*@__PURE__*/ new $2358b7e4ec07df88$var$CubicPoly();
/**
 * A curve representing a Catmull-Rom spline.
 *
 * ```js
 * //Create a closed wavey loop
 * const curve = new THREE.CatmullRomCurve3( [
 * 	new THREE.Vector3( -10, 0, 10 ),
 * 	new THREE.Vector3( -5, 5, 5 ),
 * 	new THREE.Vector3( 0, 0, 0 ),
 * 	new THREE.Vector3( 5, -5, 5 ),
 * 	new THREE.Vector3( 10, 0, 10 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$b9146b27c24b744c extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Catmull-Rom curve.
	 *
	 * @param {Array<Vector3>} [points] - An array of 3D points defining the curve.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @param {('centripetal'|'chordal'|'catmullrom')} [curveType='centripetal'] - The curve type.
	 * @param {number} [tension=0.5] - Tension of the curve.
	 */ constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        /**
		 * An array of 3D points defining the curve.
		 *
		 * @type {Array<Vector3>}
		 */ this.points = points;
        /**
		 * Whether the curve is closed or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.closed = closed;
        /**
		 * The curve type.
		 *
		 * @type {('centripetal'|'chordal'|'catmullrom')}
		 * @default 'centripetal'
		 */ this.curveType = curveType;
        /**
		 * Tension of the curve.
		 *
		 * @type {number}
		 * @default 0.5
		 */ this.tension = tension;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $2358b7e4ec07df88$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $2358b7e4ec07df88$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $2358b7e4ec07df88$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $2358b7e4ec07df88$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $2358b7e4ec07df88$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $2358b7e4ec07df88$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $2358b7e4ec07df88$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $2358b7e4ec07df88$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $2358b7e4ec07df88$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $2358b7e4ec07df88$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($2358b7e4ec07df88$var$px.calc(weight), $2358b7e4ec07df88$var$py.calc(weight), $2358b7e4ec07df88$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $2358b7e4ec07df88$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Interpolations contains spline and Bézier functions internally used by concrete curve classes.
 *
 * Bezier Curves formulas obtained from: https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 *
 * @module Interpolations
 */ /**
 * Computes a point on a Catmull-Rom spline.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Catmull-Rom spline.
 */ function $2358b7e4ec07df88$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $2358b7e4ec07df88$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $2358b7e4ec07df88$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $2358b7e4ec07df88$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
/**
 * Computes a point on a Quadratic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @return {number} The calculated point on a Quadratic Bezier curve.
 */ function $2358b7e4ec07df88$var$QuadraticBezier(t, p0, p1, p2) {
    return $2358b7e4ec07df88$var$QuadraticBezierP0(t, p0) + $2358b7e4ec07df88$var$QuadraticBezierP1(t, p1) + $2358b7e4ec07df88$var$QuadraticBezierP2(t, p2);
}
//
function $2358b7e4ec07df88$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $2358b7e4ec07df88$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $2358b7e4ec07df88$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $2358b7e4ec07df88$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
/**
 * Computes a point on a Cubic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Cubic Bezier curve.
 */ function $2358b7e4ec07df88$var$CubicBezier(t, p0, p1, p2, p3) {
    return $2358b7e4ec07df88$var$CubicBezierP0(t, p0) + $2358b7e4ec07df88$var$CubicBezierP1(t, p1) + $2358b7e4ec07df88$var$CubicBezierP2(t, p2) + $2358b7e4ec07df88$var$CubicBezierP3(t, p3);
}
/**
 * A curve representing a 2D Cubic Bezier curve.
 *
 * ```js
 * const curve = new THREE.CubicBezierCurve(
 * 	new THREE.Vector2( - 0, 0 ),
 * 	new THREE.Vector2( - 5, 15 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$e36650d36468bb39 extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The first control point.
	 * @param {Vector2} [v2] - The second control point.
	 * @param {Vector2} [v3] - The end point.
	 */ constructor(v0 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v1 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v2 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v3 = new $2358b7e4ec07df88$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($2358b7e4ec07df88$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $2358b7e4ec07df88$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 3D Cubic Bezier curve.
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$13d5f1c9525f246c extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The first control point.
	 * @param {Vector3} [v2] - The second control point.
	 * @param {Vector3} [v3] - The end point.
	 */ constructor(v0 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v1 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v2 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v3 = new $2358b7e4ec07df88$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($2358b7e4ec07df88$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $2358b7e4ec07df88$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $2358b7e4ec07df88$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 2D line segment.
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$ab2e07e76531a47e extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector2} [v1] - The start point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v1 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v2 = new $2358b7e4ec07df88$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve = true;
        this.type = 'LineCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the line.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D line segment.
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$1fdfd9d9cf487600 extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector3} [v1] - The start point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v1 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v2 = new $2358b7e4ec07df88$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the line.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $2358b7e4ec07df88$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D Quadratic Bezier curve.
 *
 * ```js
 * const curve = new THREE.QuadraticBezierCurve(
 * 	new THREE.Vector2( - 10, 0 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * )
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$5938c4ee491a43ad extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The control point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v0 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v1 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v2 = new $2358b7e4ec07df88$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($2358b7e4ec07df88$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $2358b7e4ec07df88$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D Quadratic Bezier curve.
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$bf3f4c7e459f90fc extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The control point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v0 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v1 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v2 = new $2358b7e4ec07df88$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($2358b7e4ec07df88$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $2358b7e4ec07df88$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $2358b7e4ec07df88$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D spline curve.
 *
 * ```js
 * // Create a sine-like wave
 * const curve = new THREE.SplineCurve( [
 * 	new THREE.Vector2( -10, 0 ),
 * 	new THREE.Vector2( -5, 5 ),
 * 	new THREE.Vector2( 0, 0 ),
 * 	new THREE.Vector2( 5, -5 ),
 * 	new THREE.Vector2( 10, 0 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const splineObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$d3bdd77da77afc1b extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new 2D spline curve.
	 *
	 * @param {Array<Vector2>} [points] -  An array of 2D points defining the curve.
	 */ constructor(points = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSplineCurve = true;
        this.type = 'SplineCurve';
        /**
		 * An array of 2D points defining the curve.
		 *
		 * @type {Array<Vector2>}
		 */ this.points = points;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($2358b7e4ec07df88$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $2358b7e4ec07df88$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $2358b7e4ec07df88$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $2358b7e4ec07df88$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $2358b7e4ec07df88$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $2358b7e4ec07df88$export$b9146b27c24b744c,
    CubicBezierCurve: $2358b7e4ec07df88$export$e36650d36468bb39,
    CubicBezierCurve3: $2358b7e4ec07df88$export$13d5f1c9525f246c,
    EllipseCurve: $2358b7e4ec07df88$export$3f87a931616cde04,
    LineCurve: $2358b7e4ec07df88$export$ab2e07e76531a47e,
    LineCurve3: $2358b7e4ec07df88$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $2358b7e4ec07df88$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $2358b7e4ec07df88$export$bf3f4c7e459f90fc,
    SplineCurve: $2358b7e4ec07df88$export$d3bdd77da77afc1b
});
/**
 * A base class extending {@link Curve}. `CurvePath` is simply an
 * array of connected curves, but retains the API of a curve.
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$4aaf9b66af1bbf2c extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve path.
	 */ constructor(){
        super();
        this.type = 'CurvePath';
        /**
		 * An array of curves defining the
		 * path.
		 *
		 * @type {Array<Curve>}
		 */ this.curves = [];
        /**
		 * Whether the path should automatically be closed
		 * by a line curve.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoClose = false;
    }
    /**
	 * Adds a curve to this curve path.
	 *
	 * @param {Curve} curve - The curve to add.
	 */ add(curve) {
        this.curves.push(curve);
    }
    /**
	 * Adds a line curve to close the path.
	 *
	 * @return {CurvePath} A reference to this curve path.
	 */ closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $2358b7e4ec07df88$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definitions)
	 * for the given interpolation factor.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {?(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint(t, optionalTarget) {
        // To get accurate point with reference to
        // entire path distance at time t,
        // following has to be done:
        // 1. Length of each sub path have to be known
        // 2. Locate and identify type of curve
        // 3. Get t for the curve
        // 4. Return curve.getPointAt(t')
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    getLength() {
        // We cannot use the default THREE.Curve getPoint() with getLength() because in
        // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
        // getPoint() depends on getLength
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    updateArcLengths() {
        // cacheLengths must be recalculated.
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    /**
	 * Returns list of cumulative curve lengths of the defined curves.
	 *
	 * @return {Array<number>} The curve lengths.
	 */ getCurveLengths() {
        // Compute lengths and cache them
        // We cannot overwrite getLengths() because UtoT mapping uses it.
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $2358b7e4ec07df88$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
/**
 * A 2D path representation. The class provides methods for creating paths
 * and contours of 2D shapes similar to the 2D Canvas API.
 *
 * ```js
 * const path = new THREE.Path();
 *
 * path.lineTo( 0, 0.8 );
 * path.quadraticCurveTo( 0, 1, 0.2, 1 );
 * path.lineTo( 1, 1 );
 *
 * const points = path.getPoints();
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments CurvePath
 */ class $2358b7e4ec07df88$export$4b2950bdac9b6ee9 extends $2358b7e4ec07df88$export$4aaf9b66af1bbf2c {
    /**
	 * Constructs a new path.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the path.
	 */ constructor(points){
        super();
        this.type = 'Path';
        /**
		 * The current offset of the path. Any new curve added will start here.
		 *
		 * @type {Vector2}
		 */ this.currentPoint = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    /**
	 * Creates a path from the given list of points. The points are added
	 * to the path as instances of {@link LineCurve}.
	 *
	 * @param {Array<Vector2>} points - An array of 2D points.
	 * @return {Path} A reference to this path.
	 */ setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    /**
	 * Moves {@link Path#currentPoint} to the given point.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {Path} A reference to this path.
	 */ moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ lineTo(x, y) {
        const curve = new $2358b7e4ec07df88$export$ab2e07e76531a47e(this.currentPoint.clone(), new $2358b7e4ec07df88$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $2358b7e4ec07df88$export$5938c4ee491a43ad(this.currentPoint.clone(), new $2358b7e4ec07df88$export$c977b3e384af9ae1(aCPx, aCPy), new $2358b7e4ec07df88$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $2358b7e4ec07df88$export$e36650d36468bb39(this.currentPoint.clone(), new $2358b7e4ec07df88$export$c977b3e384af9ae1(aCP1x, aCP1y), new $2358b7e4ec07df88$export$c977b3e384af9ae1(aCP2x, aCP2y), new $2358b7e4ec07df88$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {Path} A reference to this path.
	 */ splineThru(pts) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $2358b7e4ec07df88$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    /**
	 * Adds an arc as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an absolutely positioned arc as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an ellipse as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    /**
	 * Adds an absolutely positioned ellipse as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the absolute center of the ellipse.
	 * @param {number} [aY=0] - The y coordinate of the absolute center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $2358b7e4ec07df88$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
/**
 * Defines an arbitrary 2d shape plane using paths with optional holes. It
 * can be used with {@link ExtrudeGeometry}, {@link ShapeGeometry}, to get
 * points, or to get triangulated faces.
 *
 * ```js
 * const heartShape = new THREE.Shape();
 *
 * heartShape.moveTo( 25, 25 );
 * heartShape.bezierCurveTo( 25, 25, 20, 0, 0, 0 );
 * heartShape.bezierCurveTo( - 30, 0, - 30, 35, - 30, 35 );
 * heartShape.bezierCurveTo( - 30, 55, - 10, 77, 25, 95 );
 * heartShape.bezierCurveTo( 60, 77, 80, 55, 80, 35 );
 * heartShape.bezierCurveTo( 80, 35, 80, 0, 50, 0 );
 * heartShape.bezierCurveTo( 35, 0, 25, 25, 25, 25 );
 *
 * const extrudeSettings = {
 * 	depth: 8,
 * 	bevelEnabled: true,
 * 	bevelSegments: 2,
 * 	steps: 2,
 * 	bevelSize: 1,
 * 	bevelThickness: 1
 * };
 *
 * const geometry = new THREE.ExtrudeGeometry( heartShape, extrudeSettings );
 * const mesh = new THREE.Mesh( geometry, new THREE.MeshBasicMaterial() );
 * ```
 *
 * @augments Path
 */ class $2358b7e4ec07df88$export$6428a7f2611ef1fa extends $2358b7e4ec07df88$export$4b2950bdac9b6ee9 {
    /**
	 * Constructs a new shape.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the shape.
	 */ constructor(points){
        super(points);
        /**
		 * The UUID of the shape.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        this.type = 'Shape';
        /**
		 * Defines the holes in the shape. Hole definitions must use the
		 * opposite winding order (CW/CCW) than the outer shape.
		 *
		 * @type {Array<Path>}
		 * @readonly
		 */ this.holes = [];
    }
    /**
	 * Returns an array representing each contour of the holes
	 * as a list of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {Array<Array<Vector2>>} The holes as a series of 2D points.
	 */ getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    /**
	 * Returns an object that holds contour data for the shape and its holes as
	 * arrays of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {{shape:Array<Vector2>,holes:Array<Array<Vector2>>}} An object with contour data.
	 */ extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $2358b7e4ec07df88$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/* eslint-disable */ // copy of mapbox/earcut version 3.0.2
// https://github.com/mapbox/earcut/tree/v3.0.2
function $2358b7e4ec07df88$var$earcut(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $2358b7e4ec07df88$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $2358b7e4ec07df88$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = data[0];
        minY = data[1];
        let maxX = minX;
        let maxY = minY;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $2358b7e4ec07df88$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $2358b7e4ec07df88$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $2358b7e4ec07df88$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $2358b7e4ec07df88$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $2358b7e4ec07df88$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $2358b7e4ec07df88$var$equals(last, last.next)) {
        $2358b7e4ec07df88$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $2358b7e4ec07df88$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($2358b7e4ec07df88$var$equals(p, p.next) || $2358b7e4ec07df88$var$area(p.prev, p, p.next) === 0)) {
            $2358b7e4ec07df88$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $2358b7e4ec07df88$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $2358b7e4ec07df88$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $2358b7e4ec07df88$var$isEarHashed(ear, minX, minY, invSize) : $2358b7e4ec07df88$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $2358b7e4ec07df88$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $2358b7e4ec07df88$var$earcutLinked($2358b7e4ec07df88$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $2358b7e4ec07df88$var$cureLocalIntersections($2358b7e4ec07df88$var$filterPoints(ear), triangles);
                $2358b7e4ec07df88$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $2358b7e4ec07df88$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $2358b7e4ec07df88$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($2358b7e4ec07df88$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $2358b7e4ec07df88$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $2358b7e4ec07df88$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($2358b7e4ec07df88$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $2358b7e4ec07df88$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $2358b7e4ec07df88$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $2358b7e4ec07df88$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $2358b7e4ec07df88$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $2358b7e4ec07df88$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $2358b7e4ec07df88$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $2358b7e4ec07df88$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$2358b7e4ec07df88$var$equals(a, b) && $2358b7e4ec07df88$var$intersects(a, p, p.next, b) && $2358b7e4ec07df88$var$locallyInside(a, b) && $2358b7e4ec07df88$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $2358b7e4ec07df88$var$removeNode(p);
            $2358b7e4ec07df88$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $2358b7e4ec07df88$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $2358b7e4ec07df88$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $2358b7e4ec07df88$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $2358b7e4ec07df88$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $2358b7e4ec07df88$var$filterPoints(a, a.next);
                c = $2358b7e4ec07df88$var$filterPoints(c, c.next);
                // run earcut on each half
                $2358b7e4ec07df88$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $2358b7e4ec07df88$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $2358b7e4ec07df88$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $2358b7e4ec07df88$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($2358b7e4ec07df88$var$getLeftmost(list));
    }
    queue.sort($2358b7e4ec07df88$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $2358b7e4ec07df88$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $2358b7e4ec07df88$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $2358b7e4ec07df88$var$eliminateHole(hole, outerNode) {
    const bridge = $2358b7e4ec07df88$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $2358b7e4ec07df88$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $2358b7e4ec07df88$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $2358b7e4ec07df88$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $2358b7e4ec07df88$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($2358b7e4ec07df88$var$equals(hole, p)) return p;
    do {
        if ($2358b7e4ec07df88$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $2358b7e4ec07df88$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($2358b7e4ec07df88$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $2358b7e4ec07df88$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $2358b7e4ec07df88$var$sectorContainsSector(m, p) {
    return $2358b7e4ec07df88$var$area(m.prev, m, p.prev) < 0 && $2358b7e4ec07df88$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $2358b7e4ec07df88$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $2358b7e4ec07df88$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $2358b7e4ec07df88$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $2358b7e4ec07df88$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $2358b7e4ec07df88$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $2358b7e4ec07df88$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $2358b7e4ec07df88$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $2358b7e4ec07df88$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $2358b7e4ec07df88$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$2358b7e4ec07df88$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($2358b7e4ec07df88$var$locallyInside(a, b) && $2358b7e4ec07df88$var$locallyInside(b, a) && $2358b7e4ec07df88$var$middleInside(a, b) && // locally visible
    ($2358b7e4ec07df88$var$area(a.prev, a, b.prev) || $2358b7e4ec07df88$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $2358b7e4ec07df88$var$equals(a, b) && $2358b7e4ec07df88$var$area(a.prev, a, a.next) > 0 && $2358b7e4ec07df88$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $2358b7e4ec07df88$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $2358b7e4ec07df88$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $2358b7e4ec07df88$var$intersects(p1, q1, p2, q2) {
    const o1 = $2358b7e4ec07df88$var$sign($2358b7e4ec07df88$var$area(p1, q1, p2));
    const o2 = $2358b7e4ec07df88$var$sign($2358b7e4ec07df88$var$area(p1, q1, q2));
    const o3 = $2358b7e4ec07df88$var$sign($2358b7e4ec07df88$var$area(p2, q2, p1));
    const o4 = $2358b7e4ec07df88$var$sign($2358b7e4ec07df88$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $2358b7e4ec07df88$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $2358b7e4ec07df88$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $2358b7e4ec07df88$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $2358b7e4ec07df88$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $2358b7e4ec07df88$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $2358b7e4ec07df88$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $2358b7e4ec07df88$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $2358b7e4ec07df88$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $2358b7e4ec07df88$var$locallyInside(a, b) {
    return $2358b7e4ec07df88$var$area(a.prev, a, a.next) < 0 ? $2358b7e4ec07df88$var$area(a, b, a.next) >= 0 && $2358b7e4ec07df88$var$area(a, a.prev, b) >= 0 : $2358b7e4ec07df88$var$area(a, b, a.prev) < 0 || $2358b7e4ec07df88$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $2358b7e4ec07df88$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $2358b7e4ec07df88$var$splitPolygon(a, b) {
    const a2 = $2358b7e4ec07df88$var$createNode(a.i, a.x, a.y), b2 = $2358b7e4ec07df88$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $2358b7e4ec07df88$var$insertNode(i, x, y, last) {
    const p = $2358b7e4ec07df88$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $2358b7e4ec07df88$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $2358b7e4ec07df88$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $2358b7e4ec07df88$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
/**
 * An implementation of the earcut polygon triangulation algorithm.
 * The code is a port of [mapbox/earcut](https://github.com/mapbox/earcut).
 *
 * @see https://github.com/mapbox/earcut
 */ class $2358b7e4ec07df88$var$Earcut {
    /**
	 * Triangulates the given shape definition by returning an array of triangles.
	 *
	 * @param {Array<number>} data - An array with 2D points.
	 * @param {Array<number>} holeIndices - An array with indices defining holes.
	 * @param {number} [dim=2] - The number of coordinates per vertex in the input array.
	 * @return {Array<number>} An array representing the triangulated faces. Each face is defined by three consecutive numbers
	 * representing vertex indices.
	 */ static triangulate(data, holeIndices, dim = 2) {
        return $2358b7e4ec07df88$var$earcut(data, holeIndices, dim);
    }
}
/**
 * A class containing utility functions for shapes.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$96bdf6d9c66d7ba8 {
    /**
	 * Calculate area of a ( 2D ) contour polygon.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points.
	 * @return {number} The area.
	 */ static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    /**
	 * Returns `true` if the given contour uses a clockwise winding order.
	 *
	 * @param {Array<Vector2>} pts - An array of 2D points defining a polygon.
	 * @return {boolean} Whether the given contour uses a clockwise winding order or not.
	 */ static isClockWise(pts) {
        return $2358b7e4ec07df88$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    /**
	 * Triangulates the given shape definition.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points defining the contour.
	 * @param {Array<Array<Vector2>>} holes - An array that holds arrays of 2D points defining the holes.
	 * @return {Array<Array<number>>} An array that holds for each face definition an array with three indices.
	 */ static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $2358b7e4ec07df88$var$removeDupEndPts(contour);
        $2358b7e4ec07df88$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($2358b7e4ec07df88$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $2358b7e4ec07df88$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $2358b7e4ec07df88$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $2358b7e4ec07df88$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $2358b7e4ec07df88$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * ```js
 * const length = 12, width = 8;
 *
 * const shape = new THREE.Shape();
 * shape.moveTo( 0,0 );
 * shape.lineTo( 0, width );
 * shape.lineTo( length, width );
 * shape.lineTo( length, 0 );
 * shape.lineTo( 0, 0 );
 *
 * const geometry = new THREE.ExtrudeGeometry( shape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#ExtrudeGeometry
 */ class $2358b7e4ec07df88$export$598697a1efa63ca7 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new extrude geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {ExtrudeGeometry~Options} [options] - The extrude settings.
	 */ constructor(shapes = new $2358b7e4ec07df88$export$6428a7f2611ef1fa([
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, 0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(-0.5, 0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(-0.5, -0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $2358b7e4ec07df88$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                const isClosed = extrudePath.isCatmullRomCurve3 ? extrudePath.closed : false;
                splineTube = extrudePath.computeFrenetFrames(steps, isClosed);
                // log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $2358b7e4ec07df88$export$64b5c384219d3699();
                normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
                position2 = new $2358b7e4ec07df88$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$2358b7e4ec07df88$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($2358b7e4ec07df88$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            /**Merges index-adjacent points that are within a threshold distance of each other. Array is modified in-place. Threshold distance is empirical, and scaled based on the magnitude of point coordinates.
			 * @param {Array<Vector2>} points
			*/ function mergeOverlappingPoints(points) {
                const THRESHOLD = 1e-10;
                const THRESHOLD_SQ = THRESHOLD * THRESHOLD;
                let prevPos = points[0];
                for(let i = 1; i <= points.length; i++){
                    const currentIndex = i % points.length;
                    const currentPos = points[currentIndex];
                    const dx = currentPos.x - prevPos.x;
                    const dy = currentPos.y - prevPos.y;
                    const distSq = dx * dx + dy * dy;
                    const scalingFactorSqrt = Math.max(Math.abs(currentPos.x), Math.abs(currentPos.y), Math.abs(prevPos.x), Math.abs(prevPos.y));
                    const thresholdSqScaled = THRESHOLD_SQ * scalingFactorSqrt * scalingFactorSqrt;
                    if (distSq <= thresholdSqScaled) {
                        points.splice(currentIndex, 1);
                        i--;
                        continue;
                    }
                    prevPos = currentPos;
                }
            }
            mergeOverlappingPoints(vertices);
            holes.forEach(mergeOverlappingPoints);
            const numHoles = holes.length;
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0; h < numHoles; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) $2358b7e4ec07df88$export$a3bc9b8ed74fc('ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $2358b7e4ec07df88$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $2358b7e4ec07df88$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = numHoles; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            let faces;
            if (bevelSegments === 0) faces = $2358b7e4ec07df88$export$96bdf6d9c66d7ba8.triangulateShape(contour, holes);
            else {
                const contractedContourVertices = [];
                const expandedHoleVertices = [];
                // Loop bevelSegments, 1 for the front, 1 for the back
                for(let b = 0; b < bevelSegments; b++){
                    //for ( b = bevelSegments; b > 0; b -- ) {
                    const t = b / bevelSegments;
                    const z = bevelThickness * Math.cos(t * Math.PI / 2);
                    const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                    // contract shape
                    for(let i = 0, il = contour.length; i < il; i++){
                        const vert = scalePt2(contour[i], contourMovements[i], bs);
                        v(vert.x, vert.y, -z);
                        if (t === 0) contractedContourVertices.push(vert);
                    }
                    // expand holes
                    for(let h = 0, hl = numHoles; h < hl; h++){
                        const ahole = holes[h];
                        oneHoleMovements = holesMovements[h];
                        const oneHoleVertices = [];
                        for(let i = 0, il = ahole.length; i < il; i++){
                            const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                            v(vert.x, vert.y, -z);
                            if (t === 0) oneHoleVertices.push(vert);
                        }
                        if (t === 0) expandedHoleVertices.push(oneHoleVertices);
                    }
                }
                faces = $2358b7e4ec07df88$export$96bdf6d9c66d7ba8.triangulateShape(contractedContourVertices, expandedHoleVertices);
            }
            const flen = faces.length;
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $2358b7e4ec07df88$var$toJSON$1(shapes, options, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ExtrudeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $2358b7e4ec07df88$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $2358b7e4ec07df88$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $2358b7e4ec07df88$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(a_x, a_y),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(b_x, b_y),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $2358b7e4ec07df88$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
/**
 * A geometry class for representing an icosahedron.
 *
 * ```js
 * const geometry = new THREE.IcosahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const icosahedron = new THREE.Mesh( geometry, material );
 * scene.add( icosahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#IcosahedronGeometry
 */ class $2358b7e4ec07df88$export$9567cc828c9535da extends $2358b7e4ec07df88$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new icosahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the icosahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a icosahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {IcosahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$9567cc828c9535da(data.radius, data.detail);
    }
}
/**
 * Creates meshes with axial symmetry like vases. The lathe rotates around the Y axis.
 *
 * ```js
 * const points = [];
 * for ( let i = 0; i < 10; i ++ ) {
 * 	points.push( new THREE.Vector2( Math.sin( i * 0.2 ) * 10 + 5, ( i - 5 ) * 2 ) );
 * }
 * const geometry = new THREE.LatheGeometry( points );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const lathe = new THREE.Mesh( geometry, material );
 * scene.add( lathe );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#LatheGeometry
 */ class $2358b7e4ec07df88$export$6d839803fcd1882c extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new lathe geometry.
	 *
	 * @param {Array<Vector2|Vector3>} [points] - An array of points in 2D space. The x-coordinate of each point
	 * must be greater than zero.
	 * @param {number} [segments=12] - The number of circumference segments to generate.
	 * @param {number} [phiStart=0] - The starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The radian (0 to 2PI) range of the lathed section 2PI is a
	 * closed lathe, less than 2PI is a portion.
	 */ constructor(points = [
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0, -0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, 0),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $2358b7e4ec07df88$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const uv = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const curNormal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const prevNormal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {LatheGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
/**
 * A geometry class for representing an octahedron.
 *
 * ```js
 * const geometry = new THREE.OctahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const octahedron = new THREE.Mesh( geometry, material );
 * scene.add( octahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#OctahedronGeometry
 */ class $2358b7e4ec07df88$export$1954e2b809fe361e extends $2358b7e4ec07df88$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new octahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the octahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a octahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {OctahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing a plane.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const plane = new THREE.Mesh( geometry, material );
 * scene.add( plane );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#PlaneGeometry
 */ class $2358b7e4ec07df88$export$967d831af31f69ce extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new plane geometry.
	 *
	 * @param {number} [width=1] - The width along the X axis.
	 * @param {number} [height=1] - The height along the Y axis
	 * @param {number} [widthSegments=1] - The number of segments along the X axis.
	 * @param {number} [heightSegments=1] - The number of segments along the Y axis.
	 */ constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PlaneGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
/**
 * A class for generating a two-dimensional ring geometry.
 *
 * ```js
 * const geometry = new THREE.RingGeometry( 1, 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#RingGeometry
 */ class $2358b7e4ec07df88$export$68cb731f50f614af extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new ring geometry.
	 *
	 * @param {number} [innerRadius=0.5] - The inner radius of the ring.
	 * @param {number} [outerRadius=1] - The outer radius of the ring.
	 * @param {number} [thetaSegments=32] - Number of segments. A higher number means the ring will be more round. Minimum is `3`.
	 * @param {number} [phiSegments=1] - Number of segments per ring segment. Minimum is `1`.
	 * @param {number} [thetaStart=0] - Starting angle in radians.
	 * @param {number} [thetaLength=Math.PI*2] - Central angle in radians.
	 */ constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const uv = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {RingGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
/**
 * Creates an one-sided polygonal geometry from one or more path shapes.
 *
 * ```js
 * const arcShape = new THREE.Shape()
 *	.moveTo( 5, 1 )
 *	.absarc( 1, 1, 4, 0, Math.PI * 2, false );
 *
 * const geometry = new THREE.ShapeGeometry( arcShape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#ShapeGeometry
 */ class $2358b7e4ec07df88$export$57a29a1c803e9065 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new shape geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {number} [curveSegments=12] - Number of segments per shape.
	 */ constructor(shapes = new $2358b7e4ec07df88$export$6428a7f2611ef1fa([
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0, 0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(-0.5, -0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($2358b7e4ec07df88$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($2358b7e4ec07df88$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $2358b7e4ec07df88$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $2358b7e4ec07df88$var$toJSON(shapes, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ShapeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $2358b7e4ec07df88$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $2358b7e4ec07df88$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
/**
 * A class for generating a sphere geometry.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry( 15, 32, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const sphere = new THREE.Mesh( geometry, material );
 * scene.add( sphere );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#SphereGeometry
 */ class $2358b7e4ec07df88$export$1b417fc3b307a251 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new sphere geometry.
	 *
	 * @param {number} [radius=1] - The sphere radius.
	 * @param {number} [widthSegments=32] - The number of horizontal segments. Minimum value is `3`.
	 * @param {number} [heightSegments=16] - The number of vertical segments. Minimum value is `2`.
	 * @param {number} [phiStart=0] - The horizontal starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The horizontal sweep angle size.
	 * @param {number} [thetaStart=0] - The vertical starting angle in radians.
	 * @param {number} [thetaLength=Math.PI] - The vertical sweep angle size.
	 */ constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {SphereGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing an tetrahedron.
 *
 * ```js
 * const geometry = new THREE.TetrahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const tetrahedron = new THREE.Mesh( geometry, material );
 * scene.add( tetrahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#TetrahedronGeometry
 */ class $2358b7e4ec07df88$export$fb3f7adc68bd6e02 extends $2358b7e4ec07df88$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new tetrahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the tetrahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a tetrahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TetrahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing an torus.
 *
 * ```js
 * const geometry = new THREE.TorusGeometry( 10, 3, 16, 100 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torus = new THREE.Mesh( geometry, material );
 * scene.add( torus );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TorusGeometry
 */ class $2358b7e4ec07df88$export$a2312a2a1fa56495 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus, from the center of the torus to the center of the tube.
	 * @param {number} [tube=0.4] - Radius of the tube. Must be smaller than `radius`.
	 * @param {number} [radialSegments=12] - The number of radial segments.
	 * @param {number} [tubularSegments=48] - The number of tubular segments.
	 * @param {number} [arc=Math.PI*2] - Central angle in radians.
	 */ constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
/**
 * Creates a torus knot, the particular shape of which is defined by a pair
 * of coprime integers, p and q. If p and q are not coprime, the result will
 * be a torus link.
 *
 * ```js
 * const geometry = new THREE.TorusKnotGeometry( 10, 3, 100, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torusKnot = new THREE.Mesh( geometry, material );
 * scene.add( torusKnot );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TorusKnotGeometry
 */ class $2358b7e4ec07df88$export$77e9bfadfb9ab8c8 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus knot geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus knot.
	 * @param {number} [tube=0.4] - Radius of the tube.
	 * @param {number} [tubularSegments=64] - The number of tubular segments.
	 * @param {number} [radialSegments=8] - The number of radial segments.
	 * @param {number} [p=2] - This value determines, how many times the geometry winds around its axis of rotational symmetry.
	 * @param {number} [q=3] - This value determines, how many times the geometry winds around a circle in the interior of the torus.
	 */ constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const P1 = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const P2 = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const B = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const T = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const N = new $2358b7e4ec07df88$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusKnotGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
/**
 * Creates a tube that extrudes along a 3D curve.
 *
 * ```js
 * class CustomSinCurve extends THREE.Curve {
 *
 * 	getPoint( t, optionalTarget = new THREE.Vector3() ) {
 *
 * 		const tx = t * 3 - 1.5;
 * 		const ty = Math.sin( 2 * Math.PI * t );
 * 		const tz = 0;
 *
 * 		return optionalTarget.set( tx, ty, tz );
 * 	}
 *
 * }
 *
 * const path = new CustomSinCurve( 10 );
 * const geometry = new THREE.TubeGeometry( path, 20, 2, 8, false );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TubeGeometry
 */ class $2358b7e4ec07df88$export$7897d9d48904490c extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new tube geometry.
	 *
	 * @param {Curve} [path=QuadraticBezierCurve3] - A 3D curve defining the path of the tube.
	 * @param {number} [tubularSegments=64] - The number of segments that make up the tube.
	 * @param {number} [radius=1] -The radius of the tube.
	 * @param {number} [radialSegments=8] - The number of segments that make up the cross-section.
	 * @param {boolean} [closed=false] - Whether the tube is closed or not.
	 */ constructor(path = new $2358b7e4ec07df88$export$bf3f4c7e459f90fc(new $2358b7e4ec07df88$export$64b5c384219d3699(-1, -1, 0), new $2358b7e4ec07df88$export$64b5c384219d3699(-1, 1, 0), new $2358b7e4ec07df88$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const uv = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
        let P = new $2358b7e4ec07df88$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TubeGeometry} A new instance.
	 */ static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $2358b7e4ec07df88$export$7897d9d48904490c(new $2358b7e4ec07df88$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
/**
 * Can be used as a helper object to visualize a geometry as a wireframe.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry();
 *
 * const wireframe = new THREE.WireframeGeometry( geometry );
 *
 * const line = new THREE.LineSegments( wireframe );
 * line.material.depthWrite = false;
 * line.material.opacity = 0.25;
 * line.material.transparent = true;
 *
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $2358b7e4ec07df88$export$4b739da06d24892b extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new wireframe geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 */ constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const end = new $2358b7e4ec07df88$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($2358b7e4ec07df88$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($2358b7e4ec07df88$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $2358b7e4ec07df88$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $2358b7e4ec07df88$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $2358b7e4ec07df88$export$33e43285f7406bd5,
    CapsuleGeometry: $2358b7e4ec07df88$export$41680e8551036033,
    CircleGeometry: $2358b7e4ec07df88$export$d5c0e8d607467193,
    ConeGeometry: $2358b7e4ec07df88$export$a7a48974f285c9b3,
    CylinderGeometry: $2358b7e4ec07df88$export$68f745719dbe5198,
    DodecahedronGeometry: $2358b7e4ec07df88$export$c0babfeb8708fc9c,
    EdgesGeometry: $2358b7e4ec07df88$export$4730b1542707547f,
    ExtrudeGeometry: $2358b7e4ec07df88$export$598697a1efa63ca7,
    IcosahedronGeometry: $2358b7e4ec07df88$export$9567cc828c9535da,
    LatheGeometry: $2358b7e4ec07df88$export$6d839803fcd1882c,
    OctahedronGeometry: $2358b7e4ec07df88$export$1954e2b809fe361e,
    PlaneGeometry: $2358b7e4ec07df88$export$967d831af31f69ce,
    PolyhedronGeometry: $2358b7e4ec07df88$export$60e57a7d3f20ff65,
    RingGeometry: $2358b7e4ec07df88$export$68cb731f50f614af,
    ShapeGeometry: $2358b7e4ec07df88$export$57a29a1c803e9065,
    SphereGeometry: $2358b7e4ec07df88$export$1b417fc3b307a251,
    TetrahedronGeometry: $2358b7e4ec07df88$export$fb3f7adc68bd6e02,
    TorusGeometry: $2358b7e4ec07df88$export$a2312a2a1fa56495,
    TorusKnotGeometry: $2358b7e4ec07df88$export$77e9bfadfb9ab8c8,
    TubeGeometry: $2358b7e4ec07df88$export$7897d9d48904490c,
    WireframeGeometry: $2358b7e4ec07df88$export$4b739da06d24892b
});
/**
 * This material can receive shadows, but otherwise is completely transparent.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 2000, 2000 );
 * geometry.rotateX( - Math.PI / 2 );
 *
 * const material = new THREE.ShadowMaterial();
 * material.opacity = 0.2;
 *
 * const plane = new THREE.Mesh( geometry, material );
 * plane.position.y = -200;
 * plane.receiveShadow = true;
 * scene.add( plane );
 * ```
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$e8564da406055a3 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new shadow material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * Overwritten since shadow materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
/**
 * This class works just like {@link ShaderMaterial}, except that definitions
 * of built-in uniforms and attributes are not automatically prepended to the
 * GLSL shader code.
 *
 * `RawShaderMaterial` can only be used with {@link WebGLRenderer}.
 *
 * @augments ShaderMaterial
 */ class $2358b7e4ec07df88$export$21c421a2e1df9d22 extends $2358b7e4ec07df88$export$83c7d75d550a8b0d {
    /**
	 * Constructs a new raw shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super(parameters);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
/**
 * A standard physically based material, using Metallic-Roughness workflow.
 *
 * Physically based rendering (PBR) has recently become the standard in many
 * 3D applications, such as [Unity](https://blogs.unity3d.com/2014/10/29/physically-based-shading-in-unity-5-a-primer/),
 * [Unreal](https://docs.unrealengine.com/latest/INT/Engine/Rendering/Materials/PhysicallyBased/) and
 * [3D Studio Max](http://area.autodesk.com/blogs/the-3ds-max-blog/what039s-new-for-rendering-in-3ds-max-2017).
 *
 * This approach differs from older approaches in that instead of using
 * approximations for the way in which light interacts with a surface, a
 * physically correct model is used. The idea is that, instead of tweaking
 * materials to look good under specific lighting, a material can be created
 * that will react 'correctly' under all lighting scenarios.
 *
 * In practice this gives a more accurate and realistic looking result than
 * the {@link MeshLambertMaterial} or {@link MeshPhongMaterial}, at the cost of
 * being somewhat more computationally expensive. `MeshStandardMaterial` uses per-fragment
 * shading.
 *
 * Note that for best results you should always specify an environment map when using this material.
 *
 * For a non-technical introduction to the concept of PBR and how to set up a
 * PBR material, check out these articles by the people at [marmoset](https://www.marmoset.co):
 *
 * - [Basic Theory of Physically Based Rendering](https://www.marmoset.co/posts/basic-theory-of-physically-based-rendering/)
 * - [Physically Based Rendering and You Can Too](https://www.marmoset.co/posts/physically-based-rendering-and-you-can-too/)
 *
 * Technical details of the approach used in three.js (and most other PBR systems) can be found is this
 * [paper from Disney](https://media.disneyanimation.com/uploads/production/publication_asset/48/asset/s2012_pbs_disney_brdf_notes_v3.pdf)
 * (pdf), by Brent Burley.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshStandardMaterial
 */ class $2358b7e4ec07df88$export$f2980790215acccd extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh standard material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshStandardMaterial = true;
        this.type = 'MeshStandardMaterial';
        this.defines = {
            'STANDARD': ''
        };
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * How rough the material appears. `0.0` means a smooth mirror reflection, `1.0`
		 * means fully diffuse. If `roughnessMap` is also provided,
		 * both values are multiplied.
		 *
		 * @type {number}
		 * @default 1
		 */ this.roughness = 1.0;
        /**
		 * How much the material is like a metal. Non-metallic materials such as wood
		 * or stone use `0.0`, metallic use `1.0`, with nothing (usually) in between.
		 * A value between `0.0` and `1.0` could be used for a rusty metal look.
		 * If `metalnessMap` is also provided, both values are multiplied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.metalness = 0.0;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The green channel of this texture is used to alter the roughness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.roughnessMap = null;
        /**
		 * The blue channel of this texture is used to alter the metalness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.metalnessMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map. To ensure a physically correct rendering, environment maps
		 * are internally pre-processed with {@link PMREMGenerator}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.envMapIntensity = 1.0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * An extension of the {@link MeshStandardMaterial}, providing more advanced
 * physically-based rendering properties:
 *
 * - Anisotropy: Ability to represent the anisotropic property of materials
 * as observable with brushed metals.
 * - Clearcoat: Some materials — like car paints, carbon fiber, and wet surfaces — require
 * a clear, reflective layer on top of another layer that may be irregular or rough.
 * Clearcoat approximates this effect, without the need for a separate transparent surface.
 * - Iridescence: Allows to render the effect where hue varies  depending on the viewing
 * angle and illumination angle. This can be seen on soap bubbles, oil films, or on the
 * wings of many insects.
 * - Physically-based transparency: One limitation of {@link Material#opacity} is that highly
 * transparent materials are less reflective. Physically-based transmission provides a more
 * realistic option for thin, transparent surfaces like glass.
 * - Advanced reflectivity: More flexible reflectivity for non-metallic materials.
 * - Sheen: Can be used for representing cloth and fabric materials.
 *
 * As a result of these complex shading features, `MeshPhysicalMaterial` has a
 * higher performance cost, per pixel, than other three.js materials. Most
 * effects are disabled by default, and add cost as they are enabled. For
 * best results, always specify an environment map when using this material.
 *
 * @augments MeshStandardMaterial
 * @demo scenes/material-browser.html#MeshPhysicalMaterial
 */ class $2358b7e4ec07df88$export$28d04986c4269c9f extends $2358b7e4ec07df88$export$f2980790215acccd {
    /**
	 * Constructs a new mesh physical material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        /**
		 * The rotation of the anisotropy in tangent, bitangent space, measured in radians
		 * counter-clockwise from the tangent. When `anisotropyMap` is present, this
		 * property provides additional rotation to the vectors in the texture.
		 *
		 * @type {number}
		 * @default 1
		 */ this.anisotropyRotation = 0;
        /**
		 * Red and green channels represent the anisotropy direction in `[-1, 1]` tangent,
		 * bitangent space, to be rotated by `anisotropyRotation`. The blue channel
		 * contains strength as `[0, 1]` to be multiplied by `anisotropy`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.anisotropyMap = null;
        /**
		 * The red channel of this texture is multiplied against `clearcoat`,
		 * for per-pixel control over a coating's intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatMap = null;
        /**
		 * Roughness of the clear coat layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.clearcoatRoughness = 0.0;
        /**
		 * The green channel of this texture is multiplied against
		 * `clearcoatRoughness`, for per-pixel control over a coating's roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatRoughnessMap = null;
        /**
		 * How much `clearcoatNormalMap` affects the clear coat layer, from
		 * `(0,0)` to `(1,1)`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.clearcoatNormalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * Can be used to enable independent normals for the clear coat layer.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatNormalMap = null;
        /**
		 * Index-of-refraction for non-metallic materials, from `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.5
		 */ this.ior = 1.5;
        /**
		 * Degree of reflectivity, from `0.0` to `1.0`. Default is `0.5`, which
		 * corresponds to an index-of-refraction of `1.5`.
		 *
		 * This models the reflectivity of non-metallic materials. It has no effect
		 * when `metalness` is `1.0`
		 *
		 * @name MeshPhysicalMaterial#reflectivity
		 * @type {number}
		 * @default 0.5
		 */ Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $2358b7e4ec07df88$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        /**
		 * The red channel of this texture is multiplied against `iridescence`, for per-pixel
		 * control over iridescence.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceMap = null;
        /**
		 * Strength of the iridescence RGB color shift effect, represented by an index-of-refraction.
		 * Between `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.3
		 */ this.iridescenceIOR = 1.3;
        /**
		 *Array of exactly 2 elements, specifying minimum and maximum thickness of the iridescence layer.
		 Thickness of iridescence layer has an equivalent effect of the one `thickness` has on `ior`.
		 *
		 * @type {Array<number,number>}
		 * @default [100,400]
		 */ this.iridescenceThicknessRange = [
            100,
            400
        ];
        /**
		 * A texture that defines the thickness of the iridescence layer, stored in the green channel.
		 * Minimum and maximum values of thickness are defined by `iridescenceThicknessRange` array:
		 * - `0.0` in the green channel will result in thickness equal to first element of the array.
		 * - `1.0` in the green channel will result in thickness equal to second element of the array.
		 * - Values in-between will linearly interpolate between the elements of the array.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceThicknessMap = null;
        /**
		 * The sheen tint.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.sheenColor = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * The RGB channels of this texture are multiplied against  `sheenColor`, for per-pixel control
		 * over sheen tint.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenColorMap = null;
        /**
		 * Roughness of the sheen layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.sheenRoughness = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `sheenRoughness`, for per-pixel control
		 * over sheen roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenRoughnessMap = null;
        /**
		 * The red channel of this texture is multiplied against `transmission`, for per-pixel control over
		 * optical transparency.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.transmissionMap = null;
        /**
		 * The thickness of the volume beneath the surface. The value is given in the
		 * coordinate space of the mesh. If the value is `0` the material is
		 * thin-walled. Otherwise the material is a volume boundary.
		 *
		 * @type {number}
		 * @default 0
		 */ this.thickness = 0;
        /**
		 * A texture that defines the thickness, stored in the green channel. This will
		 * be multiplied by `thickness`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.thicknessMap = null;
        /**
		 * Density of the medium given as the average distance that light travels in
		 * the medium before interacting with a particle. The value is given in world
		 * space units, and must be greater than zero.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.attenuationDistance = Infinity;
        /**
		 * The color that white light turns into due to absorption when reaching the
		 * attenuation distance.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.attenuationColor = new $2358b7e4ec07df88$export$892596cec99bc70e(1, 1, 1);
        /**
		 * A float that scales the amount of specular reflection for non-metals only.
		 * When set to zero, the model is effectively Lambertian. From `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.specularIntensity = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `specularIntensity`,
		 * for per-pixel control over specular intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularIntensityMap = null;
        /**
		 * Tints the specular reflection at normal incidence for non-metals only.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.specularColor = new $2358b7e4ec07df88$export$892596cec99bc70e(1, 1, 1);
        /**
		 * The RGB channels of this texture are multiplied against `specularColor`,
		 * for per-pixel control over specular color.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    /**
	 * The anisotropy strength, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    /**
	 * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
	 * clear coat related properties to enable multilayer materials that have a
	 * thin translucent layer over the base layer.
	 *
	 * @type {number}
	 * @default 0
	 */ get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    /**
	 * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
	 * the surface and the viewer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    /**
	 * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
	 * through a relatively clear volume. Any value zero or larger is valid, the typical range of
	 * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
	 *
	 * @type {number}
	 * @default 0
	 */ get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    /**
	 * The intensity of the sheen layer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    /**
	 * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
	 *
	 * Thin, transparent or semitransparent, plastic or glass materials remain
	 * largely reflective even if they are fully transmissive. The transmission
	 * property can be used to model these materials.
	 *
	 * When transmission is non-zero, `opacity` should be  set to `1`.
	 *
	 * @type {number}
	 * @default 0
	 */ get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
/**
 * A material for shiny surfaces with specular highlights.
 *
 * The material uses a non-physically based [Blinn-Phong](https://en.wikipedia.org/wiki/Blinn-Phong_shading_model)
 * model for calculating reflectance. Unlike the Lambertian model used in the
 * {@link MeshLambertMaterial} this can simulate shiny surfaces with specular
 * highlights (such as varnished wood). `MeshPhongMaterial` uses per-fragment shading.
 *
 * Performance will generally be greater when using this material over the
 * {@link MeshStandardMaterial} or {@link MeshPhysicalMaterial}, at the cost of
 * some graphical accuracy.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshPhongMaterial
 */ class $2358b7e4ec07df88$export$24c72f71cbaf0678 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh phong material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * Specular color of the material. The default color is set to `0x111111` (very dark grey)
		 *
		 * This defines how shiny the material is and the color of its shine.
		 *
		 * @type {Color}
		 */ this.specular = new $2358b7e4ec07df88$export$892596cec99bc70e(0x111111);
        /**
		 * How shiny the specular highlight is; a higher value gives a sharper highlight.
		 *
		 * @type {number}
		 * @default 30
		 */ this.shininess = 30;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The specular map value affects both how much the specular surface
		 * highlight contributes and how much of the environment map affects the
		 * surface.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $2358b7e4ec07df88$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material implementing toon shading.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshToonMaterial
 */ class $2358b7e4ec07df88$export$df893cf97e765622 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh toon material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Gradient map for toon shading. It's required to set
		 * {@link Texture#minFilter} and {@link Texture#magFilter} to {@linkNearestFilter}
		 * when using this type of texture.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.gradientMap = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material that maps the normal vectors to RGB colors.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshNormalMaterial
 */ class $2358b7e4ec07df88$export$bfe8c0a091f41ae7 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh normal material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
/**
 * A material for non-shiny surfaces, without specular highlights.
 *
 * The material uses a non-physically based [Lambertian](https://en.wikipedia.org/wiki/Lambertian_reflectance)
 * model for calculating reflectance. This can simulate some surfaces (such
 * as untreated wood or stone) well, but cannot simulate shiny surfaces with
 * specular highlights (such as varnished wood). `MeshLambertMaterial` uses per-fragment
 * shading.
 *
 * Due to the simplicity of the reflectance and illumination models,
 * performance will be greater when using this material over the
 * {@link MeshPhongMaterial}, {@link MeshStandardMaterial} or
 * {@link MeshPhysicalMaterial}, at the cost of some graphical accuracy.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshLambertMaterial
 */ class $2358b7e4ec07df88$export$5023a9a8114806b8 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh lambert material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $2358b7e4ec07df88$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for drawing geometry by depth. Depth is based off of the camera
 * near and far plane. White is nearest, black is farthest.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshDepthMaterial
 */ class $2358b7e4ec07df88$export$2698c22ec13825db extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh depth material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        /**
		 * Type for depth packing.
		 *
		 * @type {(BasicDepthPacking|RGBADepthPacking|RGBDepthPacking|RGDepthPacking)}
		 * @default BasicDepthPacking
		 */ this.depthPacking = $2358b7e4ec07df88$export$deeb383078690b50;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
/**
 * A material used internally for implementing shadow mapping with
 * point lights.
 *
 * Can also be used to customize the shadow casting of an object by assigning
 * an instance of `MeshDistanceMaterial` to {@link Object3D#customDistanceMaterial}.
 * The following examples demonstrates this approach in order to ensure
 * transparent parts of objects do not cast shadows.
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$33e187ed002f2a19 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh distance material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
/**
 * This material is defined by a MatCap (or Lit Sphere) texture, which encodes the
 * material color and shading.
 *
 * `MeshMatcapMaterial` does not respond to lights since the matcap image file encodes
 * baked lighting. It will cast a shadow onto an object that receives shadows
 * (and shadow clipping works), but it will not self-shadow or receive
 * shadows.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshMatcapMaterial
 */ class $2358b7e4ec07df88$export$6f5fef6235ec12ee extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh matcap material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The matcap map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.matcap = null;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineDashedMaterial( {
 * 	color: 0xffffff,
 * 	scale: 1,
 * 	dashSize: 3,
 * 	gapSize: 1,
 * } );
 * ```
 *
 * @augments LineBasicMaterial
 */ class $2358b7e4ec07df88$export$327886a3efaeaebe extends $2358b7e4ec07df88$export$fbaaa33907730a0c {
    /**
	 * Constructs a new line dashed material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        /**
		 * The scale of the dashed part of a line.
		 *
		 * @type {number}
		 * @default 1
		 */ this.scale = 1;
        /**
		 * The size of the dash. This is both the gap with the stroke.
		 *
		 * @type {number}
		 * @default 3
		 */ this.dashSize = 3;
        /**
		 * The size of the gap.
		 *
		 * @type {number}
		 * @default 1
		 */ this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
/**
 * Converts an array to a specific type.
 *
 * @param {TypedArray|Array} array - The array to convert.
 * @param {TypedArray.constructor} type - The constructor of a typed array that defines the new type.
 * @return {TypedArray} The converted array.
 */ function $2358b7e4ec07df88$var$convertArray(array, type) {
    if (!array || array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
/**
 * Returns an array by which times and values can be sorted.
 *
 * @param {Array<number>} times - The keyframe time values.
 * @return {Array<number>} The array.
 */ function $2358b7e4ec07df88$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
/**
 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
 *
 * @param {Array<number>} values - The values to sort.
 * @param {number} stride - The stride.
 * @param {Array<number>} order - The sort order.
 * @return {Array<number>} The sorted values.
 */ function $2358b7e4ec07df88$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
/**
 * Used for parsing AOS keyframe formats.
 *
 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
 * @param {Array<number>} times - This array will be filled with keyframe times by this function.
 * @param {Array<number>} values - This array will be filled with keyframe values by this function.
 * @param {string} valuePropertyName - The name of the property to use.
 */ function $2358b7e4ec07df88$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(...value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
/**
 * Creates a new clip, containing only the segment of the original clip between the given frames.
 *
 * @param {AnimationClip} sourceClip - The values to sort.
 * @param {string} name - The name of the clip.
 * @param {number} startFrame - The start frame.
 * @param {number} endFrame - The end frame.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The new sub clip.
 */ function $2358b7e4ec07df88$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $2358b7e4ec07df88$var$convertArray(times, track.times.constructor);
        track.values = $2358b7e4ec07df88$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
/**
 * Converts the keyframes of the given animation clip to an additive format.
 *
 * @param {AnimationClip} targetClip - The clip to make additive.
 * @param {number} [referenceFrame=0] - The reference frame.
 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The updated clip which is now additive.
 */ function $2358b7e4ec07df88$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $2358b7e4ec07df88$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $2358b7e4ec07df88$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $2358b7e4ec07df88$export$d875e029ef558d3;
    return targetClip;
}
/**
 * A class with various methods to assist with animations.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$7ee8caa573e71ad1 {
    /**
	 * Converts an array to a specific type
	 *
	 * @static
	 * @param {TypedArray|Array} array - The array to convert.
	 * @param {TypedArray.constructor} type - The constructor of a type array.
	 * @return {TypedArray} The converted array
	 */ static convertArray(array, type) {
        return $2358b7e4ec07df88$var$convertArray(array, type);
    }
    /**
	 * Returns `true` if the given object is a typed array.
	 *
	 * @static
	 * @param {any} object - The object to check.
	 * @return {boolean} Whether the given object is a typed array.
	 */ static isTypedArray(object) {
        return $2358b7e4ec07df88$export$b119cc7e1840e59c(object);
    }
    /**
	 * Returns an array by which times and values can be sorted.
	 *
	 * @static
	 * @param {Array<number>} times - The keyframe time values.
	 * @return {Array<number>} The array.
	 */ static getKeyframeOrder(times) {
        return $2358b7e4ec07df88$var$getKeyframeOrder(times);
    }
    /**
	 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
	 *
	 * @static
	 * @param {Array<number>} values - The values to sort.
	 * @param {number} stride - The stride.
	 * @param {Array<number>} order - The sort order.
	 * @return {Array<number>} The sorted values.
	 */ static sortedArray(values, stride, order) {
        return $2358b7e4ec07df88$var$sortedArray(values, stride, order);
    }
    /**
	 * Used for parsing AOS keyframe formats.
	 *
	 * @static
	 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
	 * @param {Array<number>} times - This array will be filled with keyframe times by this method.
	 * @param {Array<number>} values - This array will be filled with keyframe values by this method.
	 * @param {string} valuePropertyName - The name of the property to use.
	 */ static flattenJSON(jsonKeys, times, values, valuePropertyName) {
        $2358b7e4ec07df88$var$flattenJSON(jsonKeys, times, values, valuePropertyName);
    }
    /**
	 * Creates a new clip, containing only the segment of the original clip between the given frames.
	 *
	 * @static
	 * @param {AnimationClip} sourceClip - The values to sort.
	 * @param {string} name - The name of the clip.
	 * @param {number} startFrame - The start frame.
	 * @param {number} endFrame - The end frame.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The new sub clip.
	 */ static subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
        return $2358b7e4ec07df88$var$subclip(sourceClip, name, startFrame, endFrame, fps);
    }
    /**
	 * Converts the keyframes of the given animation clip to an additive format.
	 *
	 * @static
	 * @param {AnimationClip} targetClip - The clip to make additive.
	 * @param {number} [referenceFrame=0] - The reference frame.
	 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The updated clip which is now additive.
	 */ static makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        return $2358b7e4ec07df88$var$makeClipAdditive(targetClip, referenceFrame, referenceClip, fps);
    }
}
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References: {@link http://www.oodesign.com/template-method-pattern.html}
 *
 * @abstract
 */ class $2358b7e4ec07df88$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        /**
		 * The parameter positions.
		 *
		 * @type {TypedArray}
		 */ this.parameterPositions = parameterPositions;
        /**
		 * A cache index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._cachedIndex = 0;
        /**
		 * The result buffer.
		 *
		 * @type {TypedArray}
		 */ this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        /**
		 * The sample values.
		 *
		 * @type {TypedArray}
		 */ this.sampleValues = sampleValues;
        /**
		 * The value size.
		 *
		 * @type {TypedArray}
		 */ this.valueSize = sampleSize;
        /**
		 * The interpolation settings.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.settings = null;
        /**
		 * The default settings object.
		 *
		 * @type {Object}
		 */ this.DefaultSettings_ = {};
    }
    /**
	 * Evaluate the interpolant at position `t`.
	 *
	 * @param {number} t - The interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    /**
	 * Returns the interpolation settings.
	 *
	 * @return {Object} The interpolation settings.
	 */ getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @param {number} index - An index into the sample value buffer.
	 * @return {TypedArray} The result buffer.
	 */ copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @abstract
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 * @param {number} t1 - The next interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    /**
	 * Optional method that is executed when the interval has changed.
	 *
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 */ intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 *
 * @augments Interpolant
 */ class $2358b7e4ec07df88$export$3646682e7a3959 extends $2358b7e4ec07df88$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new cubic interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $2358b7e4ec07df88$export$7f795934b84ab523,
            endingEnd: $2358b7e4ec07df88$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $2358b7e4ec07df88$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $2358b7e4ec07df88$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
/**
 * A basic linear interpolant.
 *
 * @augments Interpolant
 */ class $2358b7e4ec07df88$export$a8e6009059f51e1a extends $2358b7e4ec07df88$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new linear interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 *
 * @augments Interpolant
 */ class $2358b7e4ec07df88$export$fb9758ef7ef8d5cc extends $2358b7e4ec07df88$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new discrete interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
/**
 * Represents s a timed sequence of keyframes, which are composed of lists of
 * times and related values, and which are used to animate a specific property
 * of an object.
 */ class $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number|string|boolean>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        /**
		 * The track's name can refer to morph targets or bones or
		 * possibly other values within an animated object. See {@link PropertyBinding#parseTrackName}
		 * for the forms of strings that can be parsed for property binding.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The keyframe times.
		 *
		 * @type {Float32Array}
		 */ this.times = $2358b7e4ec07df88$var$convertArray(times, this.TimeBufferType);
        /**
		 * The keyframe values.
		 *
		 * @type {Float32Array}
		 */ this.values = $2358b7e4ec07df88$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    /**
	 * Converts the keyframe track to JSON.
	 *
	 * @static
	 * @param {KeyframeTrack} track - The keyframe track to serialize.
	 * @return {Object} The serialized keyframe track as JSON.
	 */ static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $2358b7e4ec07df88$var$convertArray(track.times, Array),
                'values': $2358b7e4ec07df88$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    /**
	 * Factory method for creating a new discrete interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {DiscreteInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodDiscrete(result) {
        return new $2358b7e4ec07df88$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new linear interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {LinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $2358b7e4ec07df88$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new smooth interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {CubicInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodSmooth(result) {
        return new $2358b7e4ec07df88$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Defines the interpolation factor method for this keyframe track.
	 *
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} interpolation - The interpolation type.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $2358b7e4ec07df88$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $2358b7e4ec07df88$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $2358b7e4ec07df88$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    /**
	 * Returns the current interpolation type.
	 *
	 * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} The interpolation type.
	 */ getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $2358b7e4ec07df88$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $2358b7e4ec07df88$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $2358b7e4ec07df88$export$198b11ff4c72bb30;
        }
    }
    /**
	 * Returns the value size.
	 *
	 * @return {number} The value size.
	 */ getValueSize() {
        return this.values.length / this.times.length;
    }
    /**
	 * Moves all keyframes either forward or backward in time.
	 *
	 * @param {number} timeOffset - The offset to move the time values.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    /**
	 * Scale all keyframe times by a factor (useful for frame - seconds conversions).
	 *
	 * @param {number} timeScale - The time scale.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    /**
	 * Removes keyframes before and after animation without changing any values within the defined time range.
	 *
	 * Note: The method does not shift around keys to the start of the track time, because for interpolated
	 * keys this will change their values
	 *
	 * @param {number} startTime - The start time.
	 * @param {number} endTime - The end time.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    /**
	 * Performs minimal validation on the keyframe track. Returns `true` if the values
	 * are valid.
	 *
	 * @return {boolean} Whether the keyframes are valid or not.
	 */ validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                $2358b7e4ec07df88$export$a3bc9b8ed74fc('KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                $2358b7e4ec07df88$export$a3bc9b8ed74fc('KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($2358b7e4ec07df88$export$b119cc7e1840e59c(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    $2358b7e4ec07df88$export$a3bc9b8ed74fc('KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    /**
	 * Optimizes this keyframe track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $2358b7e4ec07df88$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    /**
	 * Returns a new keyframe track with copied values from this instance.
	 *
	 * @return {KeyframeTrack} A clone of this instance.
	 */ clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default ''
 */ $2358b7e4ec07df88$export$b0e479f45b7006d6.prototype.ValueTypeName = '';
/**
 * The time buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $2358b7e4ec07df88$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $2358b7e4ec07df88$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateLinear
 */ $2358b7e4ec07df88$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $2358b7e4ec07df88$export$30fac1aace31cf4d;
/**
 * A track for boolean keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$d3a344b98cf0b775 extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new boolean keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<boolean>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'bool'
 */ $2358b7e4ec07df88$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $2358b7e4ec07df88$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $2358b7e4ec07df88$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $2358b7e4ec07df88$export$995b32462a65e855;
$2358b7e4ec07df88$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$2358b7e4ec07df88$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for color keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$83444c5d885347d8 extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new color keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'color'
 */ $2358b7e4ec07df88$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A track for numeric keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$d45f0d1a4d9a9314 extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new number keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'number'
 */ $2358b7e4ec07df88$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 *
 * @augments Interpolant
 */ class $2358b7e4ec07df88$export$2db1cfb7923d931e extends $2358b7e4ec07df88$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new SLERP interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$2358b7e4ec07df88$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A track for Quaternion keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$b8043f12b5aafbd7 extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new Quaternion keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
    /**
	 * Overwritten so the method returns Quaternion based interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {QuaternionLinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $2358b7e4ec07df88$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'quaternion'
 */ $2358b7e4ec07df88$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$2358b7e4ec07df88$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for string keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$6ce41d4f3a8df9cd extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new string keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<string>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'string'
 */ $2358b7e4ec07df88$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $2358b7e4ec07df88$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $2358b7e4ec07df88$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $2358b7e4ec07df88$export$995b32462a65e855;
$2358b7e4ec07df88$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$2358b7e4ec07df88$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for vector keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$5ce2dcb4cc9f2bff extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new vector keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'vector'
 */ $2358b7e4ec07df88$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
/**
 * A reusable set of keyframe tracks which represent an animation.
 */ class $2358b7e4ec07df88$export$d942c706bf23829c {
    /**
	 * Constructs a new animation clip.
	 *
	 * Note: Instead of instantiating an AnimationClip directly with the constructor, you can
	 * use the static interface of this class for creating clips. In most cases though, animation clips
	 * will automatically be created by loaders when importing animated 3D assets.
	 *
	 * @param {string} [name=''] - The clip's name.
	 * @param {number} [duration=-1] - The clip's duration in seconds. If a negative value is passed,
	 * the duration will be calculated from the passed keyframes.
	 * @param {Array<KeyframeTrack>} tracks - An array of keyframe tracks.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode=NormalAnimationBlendMode] - Defines how the animation
	 * is blended/combined when two or more animations are simultaneously played.
	 */ constructor(name = '', duration = -1, tracks = [], blendMode = $2358b7e4ec07df88$export$bcfbbdcf8de7f8cd){
        /**
		 * The clip's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 *  An array of keyframe tracks.
		 *
		 * @type {Array<KeyframeTrack>}
		 */ this.tracks = tracks;
        /**
		 * The clip's duration in seconds.
		 *
		 * @type {number}
		 */ this.duration = duration;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        /**
		 * The UUID of the animation clip.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * An object that can be used to store custom data about the animation clip.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    /**
	 * Factory method for creating an animation clip from the given JSON.
	 *
	 * @static
	 * @param {Object} json - The serialized animation clip.
	 * @return {AnimationClip} The new animation clip.
	 */ static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($2358b7e4ec07df88$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        clip.userData = JSON.parse(json.userData || '{}');
        return clip;
    }
    /**
	 * Serializes the given animation clip into JSON.
	 *
	 * @static
	 * @param {AnimationClip} clip - The animation clip to serialize.
	 * @return {Object} The JSON object.
	 */ static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode,
            'userData': JSON.stringify(clip.userData)
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($2358b7e4ec07df88$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    /**
	 * Returns a new animation clip from the passed morph targets array of a
	 * geometry, taking a name and the number of frames per second.
	 *
	 * Note: The fps parameter is required, but the animation speed can be
	 * overridden via {@link AnimationAction#setDuration}.
	 *
	 * @static
	 * @param {string} name - The name of the animation clip.
	 * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {AnimationClip} The new animation clip.
	 */ static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $2358b7e4ec07df88$var$getKeyframeOrder(times);
            times = $2358b7e4ec07df88$var$sortedArray(times, 1, order);
            values = $2358b7e4ec07df88$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $2358b7e4ec07df88$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    /**
	 * Searches for an animation clip by name, taking as its first parameter
	 * either an array of clips, or a mesh or geometry that contains an
	 * array named "animations" property.
	 *
	 * @static
	 * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
	 * @param {string} name - The name to search for.
	 * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
	 */ static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    /**
	 * Returns an array of new AnimationClips created from the morph target
	 * sequences of a geometry, trying to sort morph target names into
	 * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
	 *
	 * See {@link MD2Loader#parse} as an example for how the method should be used.
	 *
	 * @static
	 * @param {Array<Object>} morphTargets - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {Array<AnimationClip>} An array of new animation clips.
	 */ static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    /**
	 * Parses the `animation.hierarchy` format and returns a new animation clip.
	 *
	 * @static
	 * @deprecated since r175.
	 * @param {Object} animation - A serialized animation clip as JSON.
	 * @param {Array<Bones>} bones - An array of bones.
	 * @return {?AnimationClip} The new animation clip.
	 */ static parseAnimation(animation, bones) {
        $2358b7e4ec07df88$export$c106dd0671a0fc2d('AnimationClip: parseAnimation() is deprecated and will be removed with r185');
        if (!animation) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $2358b7e4ec07df88$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $2358b7e4ec07df88$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($2358b7e4ec07df88$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($2358b7e4ec07df88$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($2358b7e4ec07df88$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    /**
	 * Sets the duration of this clip to the duration of its longest keyframe track.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    /**
	 * Trims all tracks to the clip's duration.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    /**
	 * Performs minimal validation on each track in the clip. Returns `true` if all
	 * tracks are valid.
	 *
	 * @return {boolean} Whether the clip's keyframes are valid or not.
	 */ validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    /**
	 * Optimizes each track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    /**
	 * Returns a new animation clip with copied values from this instance.
	 *
	 * @return {AnimationClip} A clone of this instance.
	 */ clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        const clip = new this.constructor(this.name, this.duration, tracks, this.blendMode);
        clip.userData = JSON.parse(JSON.stringify(this.userData));
        return clip;
    }
    /**
	 * Serializes this animation clip into JSON.
	 *
	 * @return {Object} The JSON object.
	 */ toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $2358b7e4ec07df88$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $2358b7e4ec07df88$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $2358b7e4ec07df88$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $2358b7e4ec07df88$export$83444c5d885347d8;
        case 'quaternion':
            return $2358b7e4ec07df88$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $2358b7e4ec07df88$export$d3a344b98cf0b775;
        case 'string':
            return $2358b7e4ec07df88$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $2358b7e4ec07df88$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $2358b7e4ec07df88$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $2358b7e4ec07df88$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
/**
 * @class
 * @classdesc A simple caching system, used internally by {@link FileLoader}.
 * To enable caching across all loaders that use {@link FileLoader}, add `THREE.Cache.enabled = true.` once in your app.
 * @hideconstructor
 */ const $2358b7e4ec07df88$export$94affb487e701bf2 = {
    /**
	 * Whether caching is enabled or not.
	 *
	 * @static
	 * @type {boolean}
	 * @default false
	 */ enabled: false,
    /**
	 * A dictionary that holds cached files.
	 *
	 * @static
	 * @type {Object<string,Object>}
	 */ files: {},
    /**
	 * Adds a cache entry with a key to reference the file. If this key already
	 * holds a file, it is overwritten.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @param {Object} file -  The file to be cached.
	 */ add: function(key, file) {
        if (this.enabled === false) return;
        // log( 'Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    /**
	 * Gets the cached value for the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
	 */ get: function(key) {
        if (this.enabled === false) return;
        // log( 'Cache', 'Checking key:', key );
        return this.files[key];
    },
    /**
	 * Removes the cached file associated with the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 */ remove: function(key) {
        delete this.files[key];
    },
    /**
	 * Remove all values from the cache.
	 *
	 * @static
	 */ clear: function() {
        this.files = {};
    }
};
/**
 * Handles and keeps track of loaded and pending data. A default global
 * instance of this class is created and used by loaders if not supplied
 * manually.
 *
 * In general that should be sufficient, however there are times when it can
 * be useful to have separate loaders - for example if you want to show
 * separate loading bars for objects and textures.
 *
 * ```js
 * const manager = new THREE.LoadingManager();
 * manager.onLoad = () => console.log( 'Loading complete!' );
 *
 * const loader1 = new OBJLoader( manager );
 * const loader2 = new ColladaLoader( manager );
 * ```
 */ class $2358b7e4ec07df88$export$99cc795e99919eed {
    /**
	 * Constructs a new loading manager.
	 *
	 * @param {Function} [onLoad] - Executes when all items have been loaded.
	 * @param {Function} [onProgress] - Executes when single items have been loaded.
	 * @param {Function} [onError] - Executes when an error occurs.
	 */ constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        /**
		 * Executes when an item starts loading.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onStart = undefined;
        /**
		 * Executes when all items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onLoad = onLoad;
        /**
		 * Executes when single items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onProgress = onProgress;
        /**
		 * Executes when an error occurs.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onError = onError;
        /**
		 * Used for aborting ongoing requests in loaders using this manager.
		 *
		 * @private
		 * @type {AbortController | null}
		 */ this._abortController = null;
        /**
		 * This should be called by any loader using the manager when the loader
		 * starts loading an item.
		 *
		 * @param {string} url - The URL to load.
		 */ this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * ended loading an item.
		 *
		 * @param {string} url - The URL of the loaded item.
		 */ this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * encounters an error when loading an item.
		 *
		 * @param {string} url - The URL of the item that produces an error.
		 */ this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        /**
		 * Given a URL, uses the URL modifier callback (if any) and returns a
		 * resolved URL. If no URL modifier is set, returns the original URL.
		 *
		 * @param {string} url - The URL to load.
		 * @return {string} The resolved URL.
		 */ this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        /**
		 * If provided, the callback will be passed each resource URL before a
		 * request is sent. The callback may return the original URL, or a new URL to
		 * override loading behavior. This behavior can be used to load assets from
		 * .ZIP files, drag-and-drop APIs, and Data URIs.
		 *
		 * ```js
		 * const blobs = {'fish.gltf': blob1, 'diffuse.png': blob2, 'normal.png': blob3};
		 *
		 * const manager = new THREE.LoadingManager();
		 *
		 * // Initialize loading manager with URL callback.
		 * const objectURLs = [];
		 * manager.setURLModifier( ( url ) => {
		 *
		 * 	url = URL.createObjectURL( blobs[ url ] );
		 * 	objectURLs.push( url );
		 * 	return url;
		 *
		 * } );
		 *
		 * // Load as usual, then revoke the blob URLs.
		 * const loader = new GLTFLoader( manager );
		 * loader.load( 'fish.gltf', (gltf) => {
		 *
		 * 	scene.add( gltf.scene );
		 * 	objectURLs.forEach( ( url ) => URL.revokeObjectURL( url ) );
		 *
		 * } );
		 * ```
		 *
		 * @param {function(string):string} transform - URL modifier callback. Called with an URL and must return a resolved URL.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        /**
		 * Registers a loader with the given regular expression. Can be used to
		 * define what loader should be used in order to load specific files. A
		 * typical use case is to overwrite the default loader for textures.
		 *
		 * ```js
		 * // add handler for TGA textures
		 * manager.addHandler( /\.tga$/i, new TGALoader() );
		 * ```
		 *
		 * @param {string} regex - A regular expression.
		 * @param {Loader} loader - A loader that should handle matched cases.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        /**
		 * Removes the loader for the given regular expression.
		 *
		 * @param {string} regex - A regular expression.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        /**
		 * Can be used to retrieve the registered loader for the given file path.
		 *
		 * @param {string} file - The file path.
		 * @return {?Loader} The registered loader. Returns `null` if no loader was found.
		 */ this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
        /**
		 * Can be used to abort ongoing loading requests in loaders using this manager.
		 * The abort only works if the loaders implement {@link Loader#abort} and `AbortSignal.any()`
		 * is supported in the browser.
		 *
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.abort = function() {
            this.abortController.abort();
            this._abortController = null;
            return this;
        };
    }
    // TODO: Revert this back to a single member variable once this issue has been fixed
    // https://github.com/cloudflare/workerd/issues/3657
    /**
	 * Used for aborting ongoing requests in loaders using this manager.
	 *
	 * @type {AbortController}
	 */ get abortController() {
        if (!this._abortController) this._abortController = new AbortController();
        return this._abortController;
    }
}
/**
 * The global default loading manager.
 *
 * @constant
 * @type {LoadingManager}
 */ const $2358b7e4ec07df88$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $2358b7e4ec07df88$export$99cc795e99919eed();
/**
 * Abstract base class for loaders.
 *
 * @abstract
 */ class $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        /**
		 * The loading manager.
		 *
		 * @type {LoadingManager}
		 * @default DefaultLoadingManager
		 */ this.manager = manager !== undefined ? manager : $2358b7e4ec07df88$export$b033c3f9a95c6a16;
        /**
		 * The crossOrigin string to implement CORS for loading the url from a
		 * different domain that allows CORS.
		 *
		 * @type {string}
		 * @default 'anonymous'
		 */ this.crossOrigin = 'anonymous';
        /**
		 * Whether the XMLHttpRequest uses credentials.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.withCredentials = false;
        /**
		 * The base path from which the asset will be loaded.
		 *
		 * @type {string}
		 */ this.path = '';
        /**
		 * The base path from which additional resources like textures will be loaded.
		 *
		 * @type {string}
		 */ this.resourcePath = '';
        /**
		 * The [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
		 * used in HTTP request.
		 *
		 * @type {Object<string, any>}
		 */ this.requestHeader = {};
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for loading assets from the backend.
	 *
	 * @abstract
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {Function} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 */ load() {}
    /**
	 * A async version of {@link Loader#load}.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @return {Promise} A Promise that resolves when the asset has been loaded.
	 */ loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for parsing the asset into three.js entities.
	 *
	 * @abstract
	 * @param {any} data - The data to parse.
	 */ parse() {}
    /**
	 * Sets the `crossOrigin` String to implement CORS for loading the URL
	 * from a different domain that allows CORS.
	 *
	 * @param {string} crossOrigin - The `crossOrigin` value.
	 * @return {Loader} A reference to this instance.
	 */ setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    /**
	 * Whether the XMLHttpRequest uses credentials such as cookies, authorization
	 * headers or TLS client certificates, see [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials).
	 *
	 * Note: This setting has no effect if you are loading files locally or from the same domain.
	 *
	 * @param {boolean} value - The `withCredentials` value.
	 * @return {Loader} A reference to this instance.
	 */ setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    /**
	 * Sets the base path for the asset.
	 *
	 * @param {string} path - The base path.
	 * @return {Loader} A reference to this instance.
	 */ setPath(path) {
        this.path = path;
        return this;
    }
    /**
	 * Sets the base path for dependent resources like textures.
	 *
	 * @param {string} resourcePath - The resource path.
	 * @return {Loader} A reference to this instance.
	 */ setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    /**
	 * Sets the given request header.
	 *
	 * @param {Object} requestHeader - A [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
	 * for configuring the HTTP request.
	 * @return {Loader} A reference to this instance.
	 */ setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
    /**
	 * This method can be implemented in loaders for aborting ongoing requests.
	 *
	 * @abstract
	 * @return {Loader} A reference to this instance.
	 */ abort() {
        return this;
    }
}
/**
 * Callback for onProgress in loaders.
 *
 * @callback onProgressCallback
 * @param {ProgressEvent} event - An instance of `ProgressEvent` that represents the current loading status.
 */ /**
 * Callback for onError in loaders.
 *
 * @callback onErrorCallback
 * @param {Error} error - The error which occurred during the loading process.
 */ /**
 * The default material name that is used by loaders
 * when creating materials for loaded 3D objects.
 *
 * Note: Not all loaders might honor this setting.
 *
 * @static
 * @type {string}
 * @default '__DEFAULT'
 */ $2358b7e4ec07df88$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $2358b7e4ec07df88$var$loading = {};
class $2358b7e4ec07df88$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
/**
 * A low level class for loading resources with the Fetch API, used internally by
 * most loaders. It can also be used directly to load any file type that does
 * not have a loader.
 *
 * This loader supports caching. If you want to use it, add `THREE.Cache.enabled = true;`
 * once to your application.
 *
 * ```js
 * const loader = new THREE.FileLoader();
 * const data = await loader.loadAsync( 'example.txt' );
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$98435a25b5cf7b2b extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new file loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * The expected mime type. Valid values can be found
		 * [here](hhttps://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#mimetype)
		 *
		 * @type {string}
		 */ this.mimeType = '';
        /**
		 * The expected response type.
		 *
		 * @type {('arraybuffer'|'blob'|'document'|'json'|'')}
		 * @default ''
		 */ this.responseType = '';
        /**
		 * Used for aborting requests.
		 *
		 * @private
		 * @type {AbortController}
		 */ this._abortController = new AbortController();
    }
    /**
	 * Starts loading from the given URL and pass the loaded response to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(any)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 * @return {any|undefined} The cached resource if available.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $2358b7e4ec07df88$export$94affb487e701bf2.get(`file:${url}`);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($2358b7e4ec07df88$var$loading[url] !== undefined) {
            $2358b7e4ec07df88$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $2358b7e4ec07df88$var$loading[url] = [];
        $2358b7e4ec07df88$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin',
            signal: typeof AbortSignal.any === 'function' ? AbortSignal.any([
                this._abortController.signal,
                this.manager.abortController.signal
            ]) : this._abortController.signal
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) $2358b7e4ec07df88$export$c106dd0671a0fc2d('FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $2358b7e4ec07df88$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $2358b7e4ec07df88$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === '') return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $2358b7e4ec07df88$export$94affb487e701bf2.add(`file:${url}`, data);
            const callbacks = $2358b7e4ec07df88$var$loading[url];
            delete $2358b7e4ec07df88$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $2358b7e4ec07df88$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $2358b7e4ec07df88$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    /**
	 * Sets the expected response type.
	 *
	 * @param {('arraybuffer'|'blob'|'document'|'json'|'')} value - The response type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setResponseType(value) {
        this.responseType = value;
        return this;
    }
    /**
	 * Sets the expected mime type of the loaded file.
	 *
	 * @param {string} value - The mime type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setMimeType(value) {
        this.mimeType = value;
        return this;
    }
    /**
	 * Aborts ongoing fetch requests.
	 *
	 * @return {FileLoader} A reference to this instance.
	 */ abort() {
        this._abortController.abort();
        this._abortController = new AbortController();
        return this;
    }
}
/**
 * Class for loading animation clips in the JSON format. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.AnimationLoader();
 * const animations = await loader.loadAsync( 'animations/animation.js' );
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$29711c7e14f61db extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new animation loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded animations as an array
	 * holding instances of {@link AnimationClip} to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Array<AnimationClip>)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $2358b7e4ec07df88$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns an array of animation clips.
	 *
	 * @param {Object} json - The serialized animation clips.
	 * @return {Array<AnimationClip>} The parsed animation clips.
	 */ parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $2358b7e4ec07df88$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract base class for loading compressed texture formats S3TC, ASTC or ETC.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $2358b7e4ec07df88$export$bd73ce947a280350 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new compressed texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded compressed texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(CompressedTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CompressedTexture} The compressed texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $2358b7e4ec07df88$export$3466bac9141a5cc4();
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
const $2358b7e4ec07df88$var$_loading = new WeakMap();
/**
 * A loader for loading images. The class loads images with the HTML `Image` API.
 *
 * ```js
 * const loader = new THREE.ImageLoader();
 * const image = await loader.loadAsync( 'image.png' );
 * ```
 * Please note that `ImageLoader` has dropped support for progress
 * events in `r84`. For an `ImageLoader` that supports progress events, see
 * [this thread](https://github.com/mrdoob/three.js/issues/10439#issuecomment-275785639).
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$8905ce1c7a2464a1 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new image loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded image
	 * to the `onLoad()` callback. The method also returns a new `Image` object which can
	 * directly be used for texture creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Image)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Image} The image.
	 */ load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $2358b7e4ec07df88$export$94affb487e701bf2.get(`image:${url}`);
        if (cached !== undefined) {
            if (cached.complete === true) {
                scope.manager.itemStart(url);
                setTimeout(function() {
                    if (onLoad) onLoad(cached);
                    scope.manager.itemEnd(url);
                }, 0);
            } else {
                let arr = $2358b7e4ec07df88$var$_loading.get(cached);
                if (arr === undefined) {
                    arr = [];
                    $2358b7e4ec07df88$var$_loading.set(cached, arr);
                }
                arr.push({
                    onLoad: onLoad,
                    onError: onError
                });
            }
            return cached;
        }
        const image = $2358b7e4ec07df88$export$7094a064528c7fee('img');
        function onImageLoad() {
            removeEventListeners();
            if (onLoad) onLoad(this);
            //
            const callbacks = $2358b7e4ec07df88$var$_loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(this);
            }
            $2358b7e4ec07df88$var$_loading.delete(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            $2358b7e4ec07df88$export$94affb487e701bf2.remove(`image:${url}`);
            //
            const callbacks = $2358b7e4ec07df88$var$_loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(event);
            }
            $2358b7e4ec07df88$var$_loading.delete(this);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        $2358b7e4ec07df88$export$94affb487e701bf2.add(`image:${url}`, image);
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
/**
 * Class for loading cube textures. Images are internally loaded via {@link ImageLoader}.
 *
 * The loader returns an instance of {@link CubeTexture} and expects the cube map to
 * be defined as six separate images representing the sides of a cube. Other cube map definitions
 * like vertical and horizontal cross, column and row layouts are not supported.
 *
 * Note that, by convention, cube maps are specified in a coordinate system
 * in which positive-x is to the right when looking up the positive-z axis --
 * in other words, using a left-handed coordinate system. Since three.js uses
 * a right-handed coordinate system, environment maps used in three.js will
 * have pos-x and neg-x swapped.
 *
 * The loaded cube texture is in sRGB color space. Meaning {@link Texture#colorSpace}
 * is set to `SRGBColorSpace` by default.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader().setPath( 'textures/cubeMaps/' );
 * const cubeTexture = await loader.loadAsync( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 * scene.background = cubeTexture;
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$2ec114afc2cf6308 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new cube texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded cube texture
	 * to the `onLoad()` callback. The method also returns a new cube texture object which can
	 * directly be used for material creation. If you do it this way, the cube texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {Array<string>} urls - Array of 6 URLs to images, one for each side of the
	 * cube texture. The urls should be specified in the following order: pos-x,
	 * neg-x, pos-y, neg-y, pos-z, neg-z. An array of data URIs are allowed as well.
	 * @param {function(CubeTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CubeTexture} The cube texture.
	 */ load(urls, onLoad, onProgress, onError) {
        const texture = new $2358b7e4ec07df88$export$ee2e5a18258a4049();
        texture.colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa;
        const loader = new $2358b7e4ec07df88$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract base class for loading binary texture formats RGBE, EXR or TGA.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $2358b7e4ec07df88$export$792d8a18f2c55855 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new data texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded data texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(DataTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {DataTexture} The data texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $2358b7e4ec07df88$export$b691f601014eabe1();
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $2358b7e4ec07df88$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $2358b7e4ec07df88$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $2358b7e4ec07df88$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $2358b7e4ec07df88$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $2358b7e4ec07df88$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Class for loading textures. Images are internally
 * loaded via {@link ImageLoader}.
 *
 * ```js
 * const loader = new THREE.TextureLoader();
 * const texture = await loader.loadAsync( 'textures/land_ocean_ice_cloud_2048.jpg' );
 *
 * const material = new THREE.MeshBasicMaterial( { map:texture } );
 * ```
 * Please note that `TextureLoader` has dropped support for progress
 * events in `r84`. For a `TextureLoader` that supports progress events, see
 * [this thread](https://github.com/mrdoob/three.js/issues/10439#issuecomment-293260145).
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$fd1bfc71f64c538c extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Texture} The texture.
	 */ load(url, onLoad, onProgress, onError) {
        const texture = new $2358b7e4ec07df88$export$5431306cf43de24a();
        const loader = new $2358b7e4ec07df88$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Abstract base class for lights - all other light types inherit the
 * properties and methods described here.
 *
 * @abstract
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$6ecadb6ed240d696 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity = 1){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLight = true;
        this.type = 'Light';
        /**
		 * The light's color.
		 *
		 * @type {Color}
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(color);
        /**
		 * The light's intensity.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = intensity;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        return data;
    }
}
/**
 * A light source positioned directly above the scene, with color fading from
 * the sky color to the ground color.
 *
 * This light cannot be used to cast shadows.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$8d474f55edbb9624 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new hemisphere light.
	 *
	 * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
	 * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The light's ground color.
		 *
		 * @type {Color}
		 */ this.groundColor = new $2358b7e4ec07df88$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.groundColor = this.groundColor.getHex();
        return data;
    }
}
const $2358b7e4ec07df88$var$_projScreenMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_lightPositionWorld = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_lookTarget = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Abstract base class for light shadow classes. These classes
 * represent the shadow configuration for different light types.
 *
 * @abstract
 */ class $2358b7e4ec07df88$var$LightShadow {
    /**
	 * Constructs a new light shadow.
	 *
	 * @param {Camera} camera - The light's view of the world.
	 */ constructor(camera){
        /**
		 * The light's view of the world.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The intensity of the shadow. The default is `1`.
		 * Valid values are in the range `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = 1;
        /**
		 * Shadow map bias, how much to add or subtract from the normalized depth
		 * when deciding whether a surface is in shadow.
		 *
		 * The default is `0`. Very tiny adjustments here (in the order of `0.0001`)
		 * may help reduce artifacts in shadows.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bias = 0;
        /**
		 * Defines how much the position used to query the shadow map is offset along
		 * the object normal. The default is `0`. Increasing this value can be used to
		 * reduce shadow acne especially in large scenes where light shines onto
		 * geometry at a shallow angle. The cost is that shadows may appear distorted.
		 *
		 * @type {number}
		 * @default 0
		 */ this.normalBias = 0;
        /**
		 * Setting this to values greater than 1 will blur the edges of the shadow.
		 * High values will cause unwanted banding effects in the shadows - a greater
		 * map size will allow for a higher value to be used here before these effects
		 * become visible.
		 *
		 * The property has no effect when the shadow map type is `BasicShadowMap`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = 1;
        /**
		 * The amount of samples to use when blurring a VSM shadow map.
		 *
		 * @type {number}
		 * @default 8
		 */ this.blurSamples = 8;
        /**
		 * Defines the width and height of the shadow map. Higher values give better quality
		 * shadows at the cost of computation time. Values must be powers of two.
		 *
		 * @type {Vector2}
		 * @default (512,512)
		 */ this.mapSize = new $2358b7e4ec07df88$export$c977b3e384af9ae1(512, 512);
        /**
		 * The type of shadow texture. The default is `UnsignedByteType`.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.mapType = $2358b7e4ec07df88$export$2e8ce08d3f6f5e10;
        /**
		 * The depth map generated using the internal camera; a location beyond a
		 * pixel's depth is in shadow. Computed internally during rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.map = null;
        /**
		 * The distribution map generated using the internal camera; an occlusion is
		 * calculated based on the distribution of depths. Computed internally during
		 * rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.mapPass = null;
        /**
		 * Model to shadow camera space, to compute location and depth in shadow map.
		 * This is computed internally during rendering.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * Enables automatic updates of the light's shadow. If you do not require dynamic
		 * lighting / shadows, you may set this to `false`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
        /**
		 * When set to `true`, shadow maps will be updated in the next `render` call.
		 * If you have set {@link LightShadow#autoUpdate} to `false`, you will need to
		 * set this property to `true` and then make a render call to update the light's shadow.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        this._frustum = new $2358b7e4ec07df88$export$35efe6f4c85463d2();
        this._frameExtents = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $2358b7e4ec07df88$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    /**
	 * Used internally by the renderer to get the number of viewports that need
	 * to be rendered for this shadow.
	 *
	 * @return {number} The viewport count.
	 */ getViewportCount() {
        return this._viewportCount;
    }
    /**
	 * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
	 *
	 * @return {Frustum} The shadow camera frustum.
	 */ getFrustum() {
        return this._frustum;
    }
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 */ updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $2358b7e4ec07df88$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($2358b7e4ec07df88$var$_lightPositionWorld);
        $2358b7e4ec07df88$var$_lookTarget.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($2358b7e4ec07df88$var$_lookTarget);
        shadowCamera.updateMatrixWorld();
        $2358b7e4ec07df88$var$_projScreenMatrix.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix, shadowCamera.coordinateSystem, shadowCamera.reversedDepth);
        if (shadowCamera.reversedDepth) shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
        else shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($2358b7e4ec07df88$var$_projScreenMatrix);
    }
    /**
	 * Returns a viewport definition for the given viewport index.
	 *
	 * @param {number} viewportIndex - The viewport index.
	 * @return {Vector4} The viewport.
	 */ getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    /**
	 * Returns the frame extends.
	 *
	 * @return {Vector2} The frame extends.
	 */ getFrameExtents() {
        return this._frameExtents;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    /**
	 * Copies the values of the given light shadow instance to this instance.
	 *
	 * @param {LightShadow} source - The light shadow to copy.
	 * @return {LightShadow} A reference to this light shadow instance.
	 */ copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.autoUpdate = source.autoUpdate;
        this.needsUpdate = source.needsUpdate;
        this.normalBias = source.normalBias;
        this.blurSamples = source.blurSamples;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    /**
	 * Returns a new light shadow instance with copied values from this instance.
	 *
	 * @return {LightShadow} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Serializes the light shadow into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized light shadow.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $2358b7e4ec07df88$var$SpotLightShadow extends $2358b7e4ec07df88$var$LightShadow {
    /**
	 * Constructs a new spot light shadow.
	 */ constructor(){
        super(new $2358b7e4ec07df88$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLightShadow = true;
        /**
		 * Used to focus the shadow camera. The camera's field of view is set as a
		 * percentage of the spotlight's field-of-view. Range is `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.focus = 1;
        /**
		 * Texture aspect ratio.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $2358b7e4ec07df88$export$914076c8150813e5 * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height * this.aspect;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
/**
 * This light gets emitted from a single point in one direction, along a cone
 * that increases in size the further from the light it gets.
 *
 * This light can cast shadows - see the {@link SpotLightShadow} for details.
 *
 * ```js
 * // white spotlight shining from the side, modulated by a texture
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 100, 1000, 100 );
 * spotLight.map = new THREE.TextureLoader().load( url );
 *
 * spotLight.castShadow = true;
 * spotLight.shadow.mapSize.width = 1024;
 * spotLight.shadow.mapSize.height = 1024;
 * spotLight.shadow.camera.near = 500;
 * spotLight.shadow.camera.far = 4000;
 * spotLight.shadow.camera.fov = 30;s
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$81495cbb73897362 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new spot light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The spot light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $2358b7e4ec07df88$export$e4dd07dff30cc924();
        /**
		 * Maximum range of the light. `0` means no limit.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
		 *
		 * @type {number}
		 * @default Math.PI/3
		 */ this.angle = angle;
        /**
		 * Percent of the spotlight cone that is attenuated due to penumbra.
		 * Value range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.penumbra = penumbra;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * A texture used to modulate the color of the light. The spot light
		 * color is mixed with the RGB value of this texture, with a ratio
		 * corresponding to its alpha value. The cookie-like masking effect is
		 * reproduced using pixel values (0, 0, 0, 1-cookie_value).
		 *
		 * *Warning*: This property is disabled if {@link Object3D#castShadow} is set to `false`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {SpotLightShadow}
		 */ this.shadow = new $2358b7e4ec07df88$var$SpotLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 *  Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.map = source.map;
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.distance = this.distance;
        data.object.angle = this.angle;
        data.object.decay = this.decay;
        data.object.penumbra = this.penumbra;
        data.object.target = this.target.uuid;
        if (this.map && this.map.isTexture) data.object.map = this.map.toJSON(meta).uuid;
        data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
/**
 * Represents the shadow configuration of point lights.
 *
 * @augments LightShadow
 */ class $2358b7e4ec07df88$var$PointLightShadow extends $2358b7e4ec07df88$var$LightShadow {
    /**
	 * Constructs a new point light shadow.
	 */ constructor(){
        super(new $2358b7e4ec07df88$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLightShadow = true;
    }
}
/**
 * A light that gets emitted from a single point in all directions. A common
 * use case for this is to replicate the light emitted from a bare
 * lightbulb.
 *
 * This light can cast shadows - see the {@link PointLightShadow} for details.
 *
 * ```js
 * const light = new THREE.PointLight( 0xff0000, 1, 100 );
 * light.position.set( 50, 50, 50 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$4c9c1cb3f0b6f455 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new point light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLight = true;
        this.type = 'PointLight';
        /**
		 * When distance is zero, light will attenuate according to inverse-square
		 * law to infinite distance. When distance is non-zero, light will attenuate
		 * according to inverse-square law until near the distance cutoff, where it
		 * will then attenuate quickly and smoothly to 0. Inherently, cutoffs are not
		 * physically correct.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {PointLightShadow}
		 */ this.shadow = new $2358b7e4ec07df88$var$PointLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.distance = this.distance;
        data.object.decay = this.decay;
        data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
/**
 * Camera that uses [orthographic projection](https://en.wikipedia.org/wiki/Orthographic_projection).
 *
 * In this projection mode, an object's size in the rendered image stays
 * constant regardless of its distance from the camera. This can be useful
 * for rendering 2D scenes and UI elements, amongst other things.
 *
 * ```js
 * const camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $2358b7e4ec07df88$export$9ebf355ee4ed261b extends $2358b7e4ec07df88$export$79f141de891a5fed {
    /**
	 * Constructs a new orthographic camera.
	 *
	 * @param {number} [left=-1] - The left plane of the camera's frustum.
	 * @param {number} [right=1] - The right plane of the camera's frustum.
	 * @param {number} [top=1] - The top plane of the camera's frustum.
	 * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * The left plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.left = left;
        /**
		 * The right plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.right = right;
        /**
		 * The top plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.top = top;
        /**
		 * The bottom plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.bottom = bottom;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link OrthographicCamera#far}.
		 *
		 * Note that, unlike for the {@link PerspectiveCamera}, `0` is a
		 * valid value for an orthographic camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link OrthographicCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 * @see {@link PerspectiveCamera#setViewOffset}
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $2358b7e4ec07df88$var$DirectionalLightShadow extends $2358b7e4ec07df88$var$LightShadow {
    /**
	 * Constructs a new directional light shadow.
	 */ constructor(){
        super(new $2358b7e4ec07df88$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLightShadow = true;
    }
}
/**
 * A light that gets emitted in a specific direction. This light will behave
 * as though it is infinitely far away and the rays produced from it are all
 * parallel. The common use case for this is to simulate daylight; the sun is
 * far enough away that its position can be considered to be infinite, and
 * all light rays coming from it are parallel.
 *
 * A common point of confusion for directional lights is that setting the
 * rotation has no effect. This is because three.js's DirectionalLight is the
 * equivalent to what is often called a 'Target Direct Light' in other
 * applications.
 *
 * This means that its direction is calculated as pointing from the light's
 * {@link Object3D#position} to the {@link DirectionalLight#target} position
 * (as opposed to a 'Free Direct Light' that just has a rotation
 * component).
 *
 * This light can cast shadows - see the {@link DirectionalLightShadow} for details.
 *
 * ```js
 * // White directional light at half intensity shining from the top.
 * const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
 * scene.add( directionalLight );
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$3fea33cc9972c868 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new directional light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The directional light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $2358b7e4ec07df88$export$e4dd07dff30cc924();
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {DirectionalLightShadow}
		 */ this.shadow = new $2358b7e4ec07df88$var$DirectionalLightShadow();
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.shadow = this.shadow.toJSON();
        data.object.target = this.target.uuid;
        return data;
    }
}
/**
 * This light globally illuminates all objects in the scene equally.
 *
 * It cannot be used to cast shadows as it does not have a direction.
 *
 * ```js
 * const light = new THREE.AmbientLight( 0x404040 ); // soft white light
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$af279bfef9ec2c96 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new ambient light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
/**
 * This class emits light uniformly across the face a rectangular plane.
 * This light type can be used to simulate light sources such as bright
 * windows or strip lighting.
 *
 * Important Notes:
 *
 * - There is no shadow support.
 * - Only PBR materials are supported.
 * - You have to include `RectAreaLightUniformsLib` (`WebGLRenderer`) or `RectAreaLightTexturesLib` (`WebGPURenderer`)
 * into your app and init the uniforms/textures.
 *
 * ```js
 * RectAreaLightUniformsLib.init(); // only relevant for WebGLRenderer
 * THREE.RectAreaLightNode.setLTC( RectAreaLightTexturesLib.init() ); //  only relevant for WebGPURenderer
 *
 * const intensity = 1; const width = 10; const height = 10;
 * const rectLight = new THREE.RectAreaLight( 0xffffff, intensity, width, height );
 * rectLight.position.set( 5, 5, 0 );
 * rectLight.lookAt( 0, 0, 0 );
 * scene.add( rectLight )
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$61db2d908bbd2429 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new area light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 * @param {number} [width=10] - The width of the light.
	 * @param {number} [height=10] - The height of the light.
	 */ constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        /**
		 * The width of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.width = width;
        /**
		 * The height of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.height = height;
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Represents a third-order spherical harmonics (SH). Light probes use this class
 * to encode lighting information.
 *
 * - Primary reference: {@link https://graphics.stanford.edu/papers/envmap/envmap.pdf}
 * - Secondary reference: {@link https://www.ppsloan.org/publications/StupidSH36.pdf}
 */ class $2358b7e4ec07df88$export$ba61ce607e1f405a {
    /**
	 * Constructs a new spherical harmonics.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphericalHarmonics3 = true;
        /**
		 * An array holding the (9) SH coefficients.
		 *
		 * @type {Array<Vector3>}
		 */ this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $2358b7e4ec07df88$export$64b5c384219d3699());
    }
    /**
	 * Sets the given SH coefficients to this instance by copying
	 * the values.
	 *
	 * @param {Array<Vector3>} coefficients - The SH coefficients.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    /**
	 * Sets all SH coefficients to `0`.
	 *
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    /**
	 * Returns the radiance in the direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The radiance.
	 */ getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    /**
	 * Returns the irradiance (radiance convolved with cosine lobe) in the
	 * direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The irradiance.
	 */ getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    /**
	 * Adds the given SH to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    /**
	 * A convenience method for performing {@link SphericalHarmonics3#add} and
	 * {@link SphericalHarmonics3#scale} at once.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    /**
	 * Scales this SH by the given scale factor.
	 *
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    /**
	 * Linear interpolates between the given SH and this instance by the given
	 * alpha factor.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to interpolate with.
	 * @param {number} alpha - The alpha factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    /**
	 * Returns `true` if this spherical harmonics is equal with the given one.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to test for equality.
	 * @return {boolean} Whether this spherical harmonics is equal with the given one.
	 */ equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    /**
	 * Copies the values of the given spherical harmonics to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to copy.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ copy(sh) {
        return this.set(sh.coefficients);
    }
    /**
	 * Returns a new spherical harmonics with copied values from this instance.
	 *
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Sets the SH coefficients of this instance from the given array.
	 *
	 * @param {Array<number>} array - An array holding the SH coefficients.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    /**
	 * Returns an array with the SH coefficients, or copies them into the provided
	 * array. The coefficients are represented as numbers.
	 *
	 * @param {Array<number>} [array=[]] - The target array.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {Array<number>} An array with flat SH coefficients.
	 */ toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    /**
	 * Computes the SH basis for the given normal vector.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Array<number>} shBasis - The target array holding the SH basis.
	 */ static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
/**
 * Light probes are an alternative way of adding light to a 3D scene. Unlike
 * classical light sources (e.g. directional, point or spot lights), light
 * probes do not emit light. Instead they store information about light
 * passing through 3D space. During rendering, the light that hits a 3D
 * object is approximated by using the data from the light probe.
 *
 * Light probes are usually created from (radiance) environment maps. The
 * class {@link LightProbeGenerator} can be used to create light probes from
 * cube textures or render targets. However, light estimation data could also
 * be provided in other forms e.g. by WebXR. This enables the rendering of
 * augmented reality content that reacts to real world lighting.
 *
 * The current probe implementation in three.js supports so-called diffuse
 * light probes. This type of light probe is functionally equivalent to an
 * irradiance environment map.
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$e7ef036e309b38d2 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new light probe.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics which represents encoded lighting information.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(sh = new $2358b7e4ec07df88$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLightProbe = true;
        /**
		 * A light probe uses spherical harmonics to encode lighting information.
		 *
		 * @type {SphericalHarmonics3}
		 */ this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
/**
 * Class for loading materials. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.MaterialLoader();
 * const material = await loader.loadAsync( 'material.json' );
 * ```
 * This loader does not support node materials. Use {@link NodeMaterialLoader} instead.
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$3bd6d323353dcf96 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new material loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * A dictionary holding textures used by the material.
		 *
		 * @type {Object<string,Texture>}
		 */ this.textures = {};
    }
    /**
	 * Starts loading from the given URL and pass the loaded material to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Material)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $2358b7e4ec07df88$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a material.
	 *
	 * @param {Object} json - The serialized material.
	 * @return {Material} The parsed material.
	 */ parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = this.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $2358b7e4ec07df88$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.allowOverride !== undefined) material.allowOverride = json.allowOverride;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    /**
	 * Textures are not embedded in the material JSON so they have
	 * to be injected before the loading process starts.
	 *
	 * @param {Object} value - A dictionary holding textures for material properties.
	 * @return {MaterialLoader} A reference to this material loader.
	 */ setTextures(value) {
        this.textures = value;
        return this;
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ createMaterialFromType(type) {
        return $2358b7e4ec07df88$export$3bd6d323353dcf96.createMaterialFromType(type);
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @static
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $2358b7e4ec07df88$export$e8564da406055a3,
            SpriteMaterial: $2358b7e4ec07df88$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $2358b7e4ec07df88$export$21c421a2e1df9d22,
            ShaderMaterial: $2358b7e4ec07df88$export$83c7d75d550a8b0d,
            PointsMaterial: $2358b7e4ec07df88$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $2358b7e4ec07df88$export$28d04986c4269c9f,
            MeshStandardMaterial: $2358b7e4ec07df88$export$f2980790215acccd,
            MeshPhongMaterial: $2358b7e4ec07df88$export$24c72f71cbaf0678,
            MeshToonMaterial: $2358b7e4ec07df88$export$df893cf97e765622,
            MeshNormalMaterial: $2358b7e4ec07df88$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $2358b7e4ec07df88$export$5023a9a8114806b8,
            MeshDepthMaterial: $2358b7e4ec07df88$export$2698c22ec13825db,
            MeshDistanceMaterial: $2358b7e4ec07df88$export$33e187ed002f2a19,
            MeshBasicMaterial: $2358b7e4ec07df88$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $2358b7e4ec07df88$export$6f5fef6235ec12ee,
            LineDashedMaterial: $2358b7e4ec07df88$export$327886a3efaeaebe,
            LineBasicMaterial: $2358b7e4ec07df88$export$fbaaa33907730a0c,
            Material: $2358b7e4ec07df88$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
/**
 * A class with loader utility functions.
 */ class $2358b7e4ec07df88$export$b5d2dc08d867e41a {
    /**
	 * Extracts the base URL from the given URL.
	 *
	 * @param {string} url -The URL to extract the base URL from.
	 * @return {string} The extracted base URL.
	 */ static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    /**
	 * Resolves relative URLs against the given path. Absolute paths, data urls,
	 * and blob URLs will be returned as is. Invalid URLs will return an empty
	 * string.
	 *
	 * @param {string} url -The URL to resolve.
	 * @param {string} path - The base path for relative URLs to be resolved against.
	 * @return {string} The resolved URL.
	 */ static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
/**
 * An instanced version of a geometry.
 */ class $2358b7e4ec07df88$export$231f009cbe414146 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new instanced buffer geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        /**
		 * The instance count.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.BufferGeometryLoader();
 * const geometry = await loader.loadAsync( 'models/json/pressure.json' );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xF5F5F5 } );
 * const object = new THREE.Mesh( geometry, material );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$dc275bb96327833a extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new geometry loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded geometry to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(BufferGeometry)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $2358b7e4ec07df88$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a geometry.
	 *
	 * @param {Object} json - The serialized geometry.
	 * @return {BufferGeometry} The parsed geometry.
	 */ parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $2358b7e4ec07df88$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $2358b7e4ec07df88$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $2358b7e4ec07df88$export$231f009cbe414146() : new $2358b7e4ec07df88$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $2358b7e4ec07df88$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $2358b7e4ec07df88$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $2358b7e4ec07df88$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $2358b7e4ec07df88$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $2358b7e4ec07df88$export$32ea87a8b54d744a : $2358b7e4ec07df88$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $2358b7e4ec07df88$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $2358b7e4ec07df88$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $2358b7e4ec07df88$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) geometry.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba().fromJSON(boundingSphere);
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
/**
 * A loader for loading a JSON resource in the [JSON Object/Scene format](https://github.com/mrdoob/three.js/wiki/JSON-Object-Scene-format-4).
 * The files are internally loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.ObjectLoader();
 * const obj = await loader.loadAsync( 'models/json/example.json' );
 * scene.add( obj );
 *
 * // Alternatively, to parse a previously loaded JSON structure
 * const object = await loader.parseAsync( a_json_object );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$40110c8505c5ad19 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new object loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded 3D object to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Object3D)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $2358b7e4ec07df88$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                error('ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                $2358b7e4ec07df88$export$a3bc9b8ed74fc('ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    /**
	 * Async version of {@link ObjectLoader#load}.
	 *
	 * @async
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @return {Promise<Object3D>} A Promise that resolves with the loaded 3D object.
	 */ async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $2358b7e4ec07df88$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    /**
	 * Parses the given JSON. This is used internally by {@link ObjectLoader#load}
	 * but can also be used directly to parse a previously loaded JSON structure.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @param {onLoad} onLoad - Executed when all resources (e.g. textures) have been fully loaded.
	 * @return {Object3D} The parsed 3D object.
	 */ parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    /**
	 * Async version of {@link ObjectLoader#parse}.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @return {Promise<Object3D>} A Promise that resolves with the parsed 3D object.
	 */ async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    // internals
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $2358b7e4ec07df88$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $2358b7e4ec07df88$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $2358b7e4ec07df88$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $2358b7e4ec07df88$var$Geometries) geometry = $2358b7e4ec07df88$var$Geometries[data.type].fromJSON(data, shapes);
                        else $2358b7e4ec07df88$export$c106dd0671a0fc2d(`ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $2358b7e4ec07df88$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $2358b7e4ec07df88$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $2358b7e4ec07df88$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $2358b7e4ec07df88$export$99cc795e99919eed(onLoad);
            loader = new $2358b7e4ec07df88$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $2358b7e4ec07df88$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $2358b7e4ec07df88$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $2358b7e4ec07df88$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $2358b7e4ec07df88$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $2358b7e4ec07df88$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $2358b7e4ec07df88$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $2358b7e4ec07df88$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $2358b7e4ec07df88$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $2358b7e4ec07df88$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $2358b7e4ec07df88$export$b691f601014eabe1();
                else texture = new $2358b7e4ec07df88$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $2358b7e4ec07df88$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $2358b7e4ec07df88$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $2358b7e4ec07df88$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $2358b7e4ec07df88$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $2358b7e4ec07df88$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $2358b7e4ec07df88$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $2358b7e4ec07df88$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $2358b7e4ec07df88$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $2358b7e4ec07df88$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case 'PerspectiveCamera':
                object = new $2358b7e4ec07df88$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $2358b7e4ec07df88$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $2358b7e4ec07df88$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $2358b7e4ec07df88$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || '';
                break;
            case 'PointLight':
                object = new $2358b7e4ec07df88$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $2358b7e4ec07df88$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $2358b7e4ec07df88$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || '';
                break;
            case 'HemisphereLight':
                object = new $2358b7e4ec07df88$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                const sh = new $2358b7e4ec07df88$export$ba61ce607e1f405a().fromArray(data.sh);
                object = new $2358b7e4ec07df88$export$e7ef036e309b38d2(sh, data.intensity);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $2358b7e4ec07df88$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $2358b7e4ec07df88$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $2358b7e4ec07df88$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $2358b7e4ec07df88$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $2358b7e4ec07df88$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'BatchedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $2358b7e4ec07df88$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._geometryInfo = data.geometryInfo.map((info)=>{
                    let box = null;
                    let sphere = null;
                    if (info.boundingBox !== undefined) box = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3().fromJSON(info.boundingBox);
                    if (info.boundingSphere !== undefined) sphere = new $2358b7e4ec07df88$export$805e8b72413ccaba().fromJSON(info.boundingSphere);
                    return {
                        ...info,
                        boundingBox: box,
                        boundingSphere: sphere
                    };
                });
                object._instanceInfo = data.instanceInfo;
                object._availableInstanceIds = data._availableInstanceIds;
                object._availableGeometryIds = data._availableGeometryIds;
                object._nextIndexStart = data.nextIndexStart;
                object._nextVertexStart = data.nextVertexStart;
                object._geometryCount = data.geometryCount;
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                object._indirectTexture = getTexture(data.indirectTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                if (data.boundingSphere !== undefined) object.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba().fromJSON(data.boundingSphere);
                if (data.boundingBox !== undefined) object.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3().fromJSON(data.boundingBox);
                break;
            case 'LOD':
                object = new $2358b7e4ec07df88$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $2358b7e4ec07df88$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $2358b7e4ec07df88$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $2358b7e4ec07df88$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $2358b7e4ec07df88$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $2358b7e4ec07df88$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $2358b7e4ec07df88$export$b127726e56765aa4();
                break;
            default:
                object = new $2358b7e4ec07df88$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty('uuid', uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $2358b7e4ec07df88$export$e4dd07dff30cc924();
            }
        });
    }
}
const $2358b7e4ec07df88$var$TEXTURE_MAPPING = {
    UVMapping: $2358b7e4ec07df88$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $2358b7e4ec07df88$export$8759762a6477f2c4,
    CubeRefractionMapping: $2358b7e4ec07df88$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $2358b7e4ec07df88$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $2358b7e4ec07df88$export$ee99d97d46898098,
    CubeUVReflectionMapping: $2358b7e4ec07df88$export$dbf3e70ff37af79
};
const $2358b7e4ec07df88$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $2358b7e4ec07df88$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $2358b7e4ec07df88$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $2358b7e4ec07df88$export$c7e7c00b14f51a4f
};
const $2358b7e4ec07df88$var$TEXTURE_FILTER = {
    NearestFilter: $2358b7e4ec07df88$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $2358b7e4ec07df88$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $2358b7e4ec07df88$export$d2327c1afe5bfdf2,
    LinearFilter: $2358b7e4ec07df88$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $2358b7e4ec07df88$export$19a719f377145a13,
    LinearMipmapLinearFilter: $2358b7e4ec07df88$export$5d8599b6a933fb1b
};
const $2358b7e4ec07df88$var$_errorMap = new WeakMap();
/**
 * A loader for loading images as an [ImageBitmap](https://developer.mozilla.org/en-US/docs/Web/API/ImageBitmap).
 * An `ImageBitmap` provides an asynchronous and resource efficient pathway to prepare
 * textures for rendering.
 *
 * Note that {@link Texture#flipY} and {@link Texture#premultiplyAlpha} are ignored with image bitmaps.
 * They needs these configuration on bitmap creation unlike regular images need them on uploading to GPU.
 *
 * You need to set the equivalent options via {@link ImageBitmapLoader#setOptions} instead.
 *
 * Also note that unlike {@link FileLoader}, this loader avoids multiple concurrent requests to the same URL only if `Cache` is enabled.
 *
 * ```js
 * const loader = new THREE.ImageBitmapLoader();
 * loader.setOptions( { imageOrientation: 'flipY' } ); // set options if needed
 * const imageBitmap = await loader.loadAsync( 'image.png' );
 *
 * const texture = new THREE.Texture( imageBitmap );
 * texture.needsUpdate = true;
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$52286b55c4a9b51f extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new image bitmap loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') $2358b7e4ec07df88$export$c106dd0671a0fc2d('ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') $2358b7e4ec07df88$export$c106dd0671a0fc2d('ImageBitmapLoader: fetch() not supported.');
        /**
		 * Represents the loader options.
		 *
		 * @type {Object}
		 * @default {premultiplyAlpha:'none'}
		 */ this.options = {
            premultiplyAlpha: 'none'
        };
        /**
		 * Used for aborting requests.
		 *
		 * @private
		 * @type {AbortController}
		 */ this._abortController = new AbortController();
    }
    /**
	 * Sets the given loader options. The structure of the object must match the `options` parameter of
	 * [createImageBitmap](https://developer.mozilla.org/en-US/docs/Web/API/Window/createImageBitmap).
	 *
	 * @param {Object} options - The loader options to set.
	 * @return {ImageBitmapLoader} A reference to this image bitmap loader.
	 */ setOptions(options) {
        this.options = options;
        return this;
    }
    /**
	 * Starts loading from the given URL and pass the loaded image bitmap to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(ImageBitmap)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {ImageBitmap|undefined} The image bitmap.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $2358b7e4ec07df88$export$94affb487e701bf2.get(`image-bitmap:${url}`);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    // check if there is an error for the cached promise
                    if ($2358b7e4ec07df88$var$_errorMap.has(cached) === true) {
                        if (onError) onError($2358b7e4ec07df88$var$_errorMap.get(cached));
                        scope.manager.itemError(url);
                        scope.manager.itemEnd(url);
                    } else {
                        if (onLoad) onLoad(imageBitmap);
                        scope.manager.itemEnd(url);
                        return imageBitmap;
                    }
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        fetchOptions.signal = typeof AbortSignal.any === 'function' ? AbortSignal.any([
            this._abortController.signal,
            this.manager.abortController.signal
        ]) : this._abortController.signal;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $2358b7e4ec07df88$export$94affb487e701bf2.add(`image-bitmap:${url}`, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            $2358b7e4ec07df88$var$_errorMap.set(promise, e);
            $2358b7e4ec07df88$export$94affb487e701bf2.remove(`image-bitmap:${url}`);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $2358b7e4ec07df88$export$94affb487e701bf2.add(`image-bitmap:${url}`, promise);
        scope.manager.itemStart(url);
    }
    /**
	 * Aborts ongoing fetch requests.
	 *
	 * @return {ImageBitmapLoader} A reference to this instance.
	 */ abort() {
        this._abortController.abort();
        this._abortController = new AbortController();
        return this;
    }
}
let $2358b7e4ec07df88$var$_context;
/**
 * Manages the global audio context in the engine.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$fcbc63750ec2a81f {
    /**
	 * Returns the global native audio context.
	 *
	 * @return {AudioContext} The native audio context.
	 */ static getContext() {
        if ($2358b7e4ec07df88$var$_context === undefined) $2358b7e4ec07df88$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $2358b7e4ec07df88$var$_context;
    }
    /**
	 * Allows to set the global native audio context from outside.
	 *
	 * @param {AudioContext} value - The native context to set.
	 */ static setContext(value) {
        $2358b7e4ec07df88$var$_context = value;
    }
}
/**
 * Class for loading audio buffers. Audios are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const audioListener = new THREE.AudioListener();
 * const ambientSound = new THREE.Audio( audioListener );
 *
 * const loader = new THREE.AudioLoader();
 * const audioBuffer = await loader.loadAsync( 'audio/ambient_ocean.ogg' );
 *
 * ambientSound.setBuffer( audioBuffer );
 * ambientSound.play();
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$d8d5fccfbf47714e extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new audio loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded audio buffer
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(AudioBuffer)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $2358b7e4ec07df88$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else $2358b7e4ec07df88$export$a3bc9b8ed74fc(e);
            scope.manager.itemError(url);
        }
    }
}
const $2358b7e4ec07df88$var$_eyeRight = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_eyeLeft = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_projectionMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
/**
 * A special type of camera that uses two perspective cameras with
 * stereoscopic projection. Can be used for rendering stereo effects
 * like [3D Anaglyph](https://en.wikipedia.org/wiki/Anaglyph_3D) or
 * [Parallax Barrier](https://en.wikipedia.org/wiki/parallax_barrier).
 */ class $2358b7e4ec07df88$export$bc7f73a1065bee0c {
    /**
	 * Constructs a new stereo camera.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'StereoCamera';
        /**
		 * The aspect.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
        /**
		 * The eye separation which represents the distance
		 * between the left and right camera.
		 *
		 * @type {number}
		 * @default 0.064
		 */ this.eyeSep = 0.064;
        /**
		 * The camera representing the left eye. This is added to layer `1` so objects to be
		 * rendered by the left camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraL = new $2358b7e4ec07df88$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        /**
		 * The camera representing the right eye. This is added to layer `2` so objects to be
		 * rendered by the right camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraR = new $2358b7e4ec07df88$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    /**
	 * Updates the stereo camera based on the given perspective camera.
	 *
	 * @param {PerspectiveCamera} camera - The perspective camera.
	 */ update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $2358b7e4ec07df88$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($2358b7e4ec07df88$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $2358b7e4ec07df88$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $2358b7e4ec07df88$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $2358b7e4ec07df88$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $2358b7e4ec07df88$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($2358b7e4ec07df88$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $2358b7e4ec07df88$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $2358b7e4ec07df88$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($2358b7e4ec07df88$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($2358b7e4ec07df88$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($2358b7e4ec07df88$var$_eyeRight);
    }
}
/**
 * This type of camera can be used in order to efficiently render a scene with a
 * predefined set of cameras. This is an important performance aspect for
 * rendering VR scenes.
 *
 * An instance of `ArrayCamera` always has an array of sub cameras. It's mandatory
 * to define for each sub camera the `viewport` property which determines the
 * part of the viewport that is rendered with this camera.
 *
 * @augments PerspectiveCamera
 */ class $2358b7e4ec07df88$export$56b937d9e5581166 extends $2358b7e4ec07df88$export$74e4ae24825f68d7 {
    /**
	 * Constructs a new array camera.
	 *
	 * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
	 */ constructor(array = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayCamera = true;
        /**
		 * Whether this camera is used with multiview rendering or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isMultiViewCamera = false;
        /**
		 * An array of perspective sub cameras.
		 *
		 * @type {Array<PerspectiveCamera>}
		 */ this.cameras = array;
    }
}
/**
 * Class for keeping track of time.
 */ class $2358b7e4ec07df88$export$9735c82c4bae3302 {
    /**
	 * Constructs a new clock.
	 *
	 * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
	 * `getDelta()` is called for the first time.
	 */ constructor(autoStart = true){
        /**
		 * If set to `true`, the clock starts automatically when `getDelta()` is called
		 * for the first time.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoStart = autoStart;
        /**
		 * Holds the time at which the clock's `start()` method was last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.startTime = 0;
        /**
		 * Holds the time at which the clock's `start()`, `getElapsedTime()` or
		 * `getDelta()` methods were last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.oldTime = 0;
        /**
		 * Keeps track of the total time that the clock has been running.
		 *
		 * @type {number}
		 * @default 0
		 */ this.elapsedTime = 0;
        /**
		 * Whether the clock is running or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.running = false;
    }
    /**
	 * Starts the clock. When `autoStart` is set to `true`, the method is automatically
	 * called by the class.
	 */ start() {
        this.startTime = performance.now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    /**
	 * Stops the clock.
	 */ stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time.
	 */ getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    /**
	 * Returns the delta time in seconds.
	 *
	 * @return {number} The delta time.
	 */ getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = performance.now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
const $2358b7e4ec07df88$var$_position$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_quaternion$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
const $2358b7e4ec07df88$var$_scale$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_forward = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_up = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * The class represents a virtual listener of the all positional and non-positional audio effects
 * in the scene. A three.js application usually creates a single listener. It is a mandatory
 * constructor parameter for audios entities like {@link Audio} and {@link PositionalAudio}.
 *
 * In most cases, the listener object is a child of the camera. So the 3D transformation of the
 * camera represents the 3D transformation of the listener.
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$8a1b810c6fde8951 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio listener.
	 */ constructor(){
        super();
        this.type = 'AudioListener';
        /**
		 * The native audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = $2358b7e4ec07df88$export$fcbc63750ec2a81f.getContext();
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        /**
		 * An optional filter.
		 *
		 * Defined via {@link AudioListener#setFilter}.
		 *
		 * @type {?AudioNode}
		 * @default null
		 * @readonly
		 */ this.filter = null;
        /**
		 * Time delta values required for `linearRampToValueAtTime()` usage.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.timeDelta = 0;
        // private
        this._clock = new $2358b7e4ec07df88$export$9735c82c4bae3302();
    }
    /**
	 * Returns the listener's input node.
	 *
	 * This method is used by other audio nodes to connect to this listener.
	 *
	 * @return {GainNode} The input node.
	 */ getInput() {
        return this.gain;
    }
    /**
	 * Removes the current filter from this listener.
	 *
	 * @return {AudioListener} A reference to this listener.
	 */ removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    /**
	 * Returns the current set filter.
	 *
	 * @return {?AudioNode} The filter.
	 */ getFilter() {
        return this.filter;
    }
    /**
	 * Sets the given filter to this listener.
	 *
	 * @param {AudioNode} value - The filter to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    /**
	 * Returns the applications master volume.
	 *
	 * @return {number} The master volume.
	 */ getMasterVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the applications master volume. This volume setting affects
	 * all audio nodes in the scene.
	 *
	 * @param {number} value - The master volume to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($2358b7e4ec07df88$var$_position$1, $2358b7e4ec07df88$var$_quaternion$1, $2358b7e4ec07df88$var$_scale$1);
        // the initial forward and up directions must be orthogonal
        $2358b7e4ec07df88$var$_forward.set(0, 0, -1).applyQuaternion($2358b7e4ec07df88$var$_quaternion$1);
        $2358b7e4ec07df88$var$_up.set(0, 1, 0).applyQuaternion($2358b7e4ec07df88$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($2358b7e4ec07df88$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($2358b7e4ec07df88$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($2358b7e4ec07df88$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($2358b7e4ec07df88$var$_forward.x, endTime);
            listener.forwardY.linearRampToValueAtTime($2358b7e4ec07df88$var$_forward.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($2358b7e4ec07df88$var$_forward.z, endTime);
            listener.upX.linearRampToValueAtTime($2358b7e4ec07df88$var$_up.x, endTime);
            listener.upY.linearRampToValueAtTime($2358b7e4ec07df88$var$_up.y, endTime);
            listener.upZ.linearRampToValueAtTime($2358b7e4ec07df88$var$_up.z, endTime);
        } else {
            listener.setPosition($2358b7e4ec07df88$var$_position$1.x, $2358b7e4ec07df88$var$_position$1.y, $2358b7e4ec07df88$var$_position$1.z);
            listener.setOrientation($2358b7e4ec07df88$var$_forward.x, $2358b7e4ec07df88$var$_forward.y, $2358b7e4ec07df88$var$_forward.z, $2358b7e4ec07df88$var$_up.x, $2358b7e4ec07df88$var$_up.y, $2358b7e4ec07df88$var$_up.z);
        }
    }
}
/**
 * Represents a non-positional ( global ) audio object.
 *
 * This and related audio modules make use of the [Web Audio API](https://www.w3.org/TR/webaudio-1.1/).
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create a global audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop( true );
 * 	sound.setVolume( 0.5 );
 * 	sound.play();
 * });
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$153755f98d9861de extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super();
        this.type = 'Audio';
        /**
		 * The global audio listener.
		 *
		 * @type {AudioListener}
		 * @readonly
		 */ this.listener = listener;
        /**
		 * The audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = listener.context;
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        /**
		 * Whether to start playback automatically or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoplay = false;
        /**
		 * A reference to an audio buffer.
		 *
		 * Defined via {@link Audio#setBuffer}.
		 *
		 * @type {?AudioBuffer}
		 * @default null
		 * @readonly
		 */ this.buffer = null;
        /**
		 * Modify pitch, measured in cents. +/- 100 is a semitone.
		 * +/- 1200 is an octave.
		 *
		 * Defined via {@link Audio#setDetune}.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.detune = 0;
        /**
		 * Whether the audio should loop or not.
		 *
		 * Defined via {@link Audio#setLoop}.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.loop = false;
        /**
		 * Defines where in the audio buffer the replay should
		 * start, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopStart = 0;
        /**
		 * Defines where in the audio buffer the replay should
		 * stop, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopEnd = 0;
        /**
		 * An offset to the time within the audio buffer the playback
		 * should begin, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.offset = 0;
        /**
		 * Overrides the default duration of the audio.
		 *
		 * @type {undefined|number}
		 * @default undefined
		 */ this.duration = undefined;
        /**
		 * The playback speed.
		 *
		 * Defined via {@link Audio#setPlaybackRate}.
		 *
		 * @type {number}
		 * @readonly
		 * @default 1
		 */ this.playbackRate = 1;
        /**
		 * Indicates whether the audio is playing or not.
		 *
		 * This flag will be automatically set when using {@link Audio#play},
		 * {@link Audio#pause}, {@link Audio#stop}.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPlaying = false;
        /**
		 * Indicates whether the audio playback can be controlled
		 * with method like {@link Audio#play} or {@link Audio#pause}.
		 *
		 * This flag will be automatically set when audio sources are
		 * defined.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.hasPlaybackControl = true;
        /**
		 * Holds a reference to the current audio source.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {?AudioNode}
		 * @readonly
		 * @default null
		 */ this.source = null;
        /**
		 * Defines the source type.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {('empty'|'audioNode'|'mediaNode'|'mediaStreamNode'|'buffer')}
		 * @readonly
		 * @default 'empty'
		 */ this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        /**
		 * Can be used to apply a variety of low-order filters to create
		 * more complex sound effects e.g. via `BiquadFilterNode`.
		 *
		 * The property is automatically set by {@link Audio#setFilters}.
		 *
		 * @type {Array<AudioNode>}
		 * @readonly
		 */ this.filters = [];
    }
    /**
	 * Returns the output audio node.
	 *
	 * @return {GainNode} The output node.
	 */ getOutput() {
        return this.gain;
    }
    /**
	 * Sets the given audio node as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `audioNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {AudioNode} audioNode - The audio node like an instance of `OscillatorNode`.
	 * @return {Audio} A reference to this instance.
	 */ setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    /**
	 * Sets the given media element as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {HTMLMediaElement} mediaElement - The media element.
	 * @return {Audio} A reference to this instance.
	 */ setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    /**
	 * Sets the given media stream as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaStreamNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {MediaStream} mediaStream - The media stream.
	 * @return {Audio} A reference to this instance.
	 */ setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    /**
	 * Sets the given audio buffer as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `buffer` and {@link Audio#hasPlaybackControl} to `true`.
	 *
	 * @param {AudioBuffer} audioBuffer - The audio buffer.
	 * @return {Audio} A reference to this instance.
	 */ setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    /**
	 * Starts the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should start playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ play(delay = 0) {
        if (this.isPlaying === true) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    /**
	 * Pauses the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ pause() {
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    /**
	 * Stops the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should stop playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ stop(delay = 0) {
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop(this.context.currentTime + delay);
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    /**
	 * Connects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio} A reference to this instance.
	 */ connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    /**
	 * Disconnects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    /**
	 * Returns the current set filters.
	 *
	 * @return {Array<AudioNode>} The list of filters.
	 */ getFilters() {
        return this.filters;
    }
    /**
	 * Sets an array of filters and connects them with the audio source.
	 *
	 * @param {Array<AudioNode>} [value] - A list of filters.
	 * @return {Audio} A reference to this instance.
	 */ setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    /**
	 * Defines the detuning of oscillation in cents.
	 *
	 * @param {number} value - The detuning of oscillation in cents.
	 * @return {Audio} A reference to this instance.
	 */ setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the detuning of oscillation in cents.
	 *
	 * @return {number} The detuning of oscillation in cents.
	 */ getDetune() {
        return this.detune;
    }
    /**
	 * Returns the first filter in the list of filters.
	 *
	 * @return {AudioNode|undefined} The first filter in the list of filters.
	 */ getFilter() {
        return this.getFilters()[0];
    }
    /**
	 * Applies a single filter node to the audio.
	 *
	 * @param {AudioNode} [filter] - The filter to set.
	 * @return {Audio} A reference to this instance.
	 */ setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    /**
	 * Sets the playback rate.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [value] - The playback rate to set.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the current playback rate.

	 * @return {number} The playback rate.
	 */ getPlaybackRate() {
        return this.playbackRate;
    }
    /**
	 * Automatically called when playback finished.
	 */ onEnded() {
        this.isPlaying = false;
        this._progress = 0;
    }
    /**
	 * Returns the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {boolean} Whether the audio should loop or not.
	 */ getLoop() {
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    /**
	 * Sets the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {boolean} value - Whether the audio should loop or not.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setLoop(value) {
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    /**
	 * Sets the loop start value which defines where in the audio buffer the replay should
	 * start, in seconds.
	 *
	 * @param {number} value - The loop start value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    /**
	 * Sets the loop end value which defines where in the audio buffer the replay should
	 * stop, in seconds.
	 *
	 * @param {number} value - The loop end value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    /**
	 * Returns the volume.
	 *
	 * @return {number} The volume.
	 */ getVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the volume.
	 *
	 * @param {number} value - The volume to set.
	 * @return {Audio} A reference to this instance.
	 */ setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.sourceType !== 'buffer') {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: Audio source type cannot be copied.');
            return this;
        }
        this.autoplay = source.autoplay;
        this.buffer = source.buffer;
        this.detune = source.detune;
        this.loop = source.loop;
        this.loopStart = source.loopStart;
        this.loopEnd = source.loopEnd;
        this.offset = source.offset;
        this.duration = source.duration;
        this.playbackRate = source.playbackRate;
        this.hasPlaybackControl = source.hasPlaybackControl;
        this.sourceType = source.sourceType;
        this.filters = source.filters.slice();
        return this;
    }
    clone(recursive) {
        return new this.constructor(this.listener).copy(this, recursive);
    }
}
const $2358b7e4ec07df88$var$_position = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_quaternion = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
const $2358b7e4ec07df88$var$_scale = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_orientation = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Represents a positional audio object.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create the PositionalAudio object (passing in the listener)
 * const sound = new THREE.PositionalAudio( listener );
 *
 * // load a sound and set it as the PositionalAudio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/song.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setRefDistance( 20 );
 * 	sound.play();
 * });
 *
 * // create an object for the sound to play from
 * const sphere = new THREE.SphereGeometry( 20, 32, 16 );
 * const material = new THREE.MeshPhongMaterial( { color: 0xff2200 } );
 * const mesh = new THREE.Mesh( sphere, material );
 * scene.add( mesh );
 *
 * // finally add the sound to the mesh
 * mesh.add( sound );
 *
 * @augments Audio
 */ class $2358b7e4ec07df88$export$4b3e397ef1832507 extends $2358b7e4ec07df88$export$153755f98d9861de {
    /**
	 * Constructs a positional audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super(listener);
        /**
		 * The panner node represents the location, direction, and behavior of an audio
		 * source in 3D space.
		 *
		 * @type {PannerNode}
		 * @readonly
		 */ this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
        return this;
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
        return this;
    }
    getOutput() {
        return this.panner;
    }
    /**
	 * Returns the current reference distance.
	 *
	 * @return {number} The reference distance.
	 */ getRefDistance() {
        return this.panner.refDistance;
    }
    /**
	 * Defines the reference distance for reducing volume as the audio source moves
	 * further from the listener – i.e. the distance at which the volume reduction
	 * starts taking effect.
	 *
	 * @param {number} value - The reference distance to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    /**
	 * Returns the current rolloff factor.
	 *
	 * @return {number} The rolloff factor.
	 */ getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    /**
	 * Defines how quickly the volume is reduced as the source moves away from the listener.
	 *
	 * @param {number} value - The rolloff factor.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    /**
	 * Returns the current distance model.
	 *
	 * @return {('linear'|'inverse'|'exponential')} The distance model.
	 */ getDistanceModel() {
        return this.panner.distanceModel;
    }
    /**
	 * Defines which algorithm to use to reduce the volume of the audio source
	 * as it moves away from the listener.
	 *
	 * Read [the spec](https://www.w3.org/TR/webaudio-1.1/#enumdef-distancemodeltype)
	 * for more details.
	 *
	 * @param {('linear'|'inverse'|'exponential')} value - The distance model to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    /**
	 * Returns the current max distance.
	 *
	 * @return {number} The max distance.
	 */ getMaxDistance() {
        return this.panner.maxDistance;
    }
    /**
	 * Defines the maximum distance between the audio source and the listener,
	 * after which the volume is not reduced any further.
	 *
	 * This value is used only by the `linear` distance model.
	 *
	 * @param {number} value - The max distance.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    /**
	 * Sets the directional cone in which the audio can be listened.
	 *
	 * @param {number} coneInnerAngle - An angle, in degrees, of a cone inside of which there will be no volume reduction.
	 * @param {number} coneOuterAngle - An angle, in degrees, of a cone outside of which the volume will be reduced by a constant value, defined by the `coneOuterGain` parameter.
	 * @param {number} coneOuterGain - The amount of volume reduction outside the cone defined by the `coneOuterAngle`. When set to `0`, no sound can be heard.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($2358b7e4ec07df88$var$_position, $2358b7e4ec07df88$var$_quaternion, $2358b7e4ec07df88$var$_scale);
        $2358b7e4ec07df88$var$_orientation.set(0, 0, 1).applyQuaternion($2358b7e4ec07df88$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($2358b7e4ec07df88$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($2358b7e4ec07df88$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($2358b7e4ec07df88$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($2358b7e4ec07df88$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($2358b7e4ec07df88$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($2358b7e4ec07df88$var$_orientation.z, endTime);
        } else {
            panner.setPosition($2358b7e4ec07df88$var$_position.x, $2358b7e4ec07df88$var$_position.y, $2358b7e4ec07df88$var$_position.z);
            panner.setOrientation($2358b7e4ec07df88$var$_orientation.x, $2358b7e4ec07df88$var$_orientation.y, $2358b7e4ec07df88$var$_orientation.z);
        }
    }
}
/**
 * This class can be used to analyse audio data.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create an Audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop(true);
 * 	sound.setVolume(0.5);
 * 	sound.play();
 * });
 *
 * // create an AudioAnalyser, passing in the sound and desired fftSize
 * const analyser = new THREE.AudioAnalyser( sound, 32 );
 *
 * // get the average frequency of the sound
 * const data = analyser.getAverageFrequency();
 * ```
 */ class $2358b7e4ec07df88$export$d47da1ef3d382827 {
    /**
	 * Constructs a new audio analyzer.
	 *
	 * @param {Audio} audio - The audio to analyze.
	 * @param {number} [fftSize=2048] - The window size in samples that is used when performing a Fast Fourier Transform (FFT) to get frequency domain data.
	 */ constructor(audio, fftSize = 2048){
        /**
		 * The global audio listener.
		 *
		 * @type {AnalyserNode}
		 */ this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        /**
		 * Holds the analyzed data.
		 *
		 * @type {Uint8Array}
		 */ this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    /**
	 * Returns an array with frequency data of the audio.
	 *
	 * Each item in the array represents the decibel value for a specific frequency.
	 * The frequencies are spread linearly from 0 to 1/2 of the sample rate.
	 * For example, for 48000 sample rate, the last item of the array will represent
	 * the decibel value for 24000 Hz.
	 *
	 * @return {Uint8Array} The frequency data.
	 */ getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    /**
	 * Returns the average of the frequencies returned by {@link AudioAnalyser#getFrequencyData}.
	 *
	 * @return {number} The average frequency.
	 */ getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
/**
 * Buffered scene graph property that allows weighted accumulation; used internally.
 */ class $2358b7e4ec07df88$export$dfe0af1ca1acb78a {
    /**
	 * Constructs a new property mixer.
	 *
	 * @param {PropertyBinding} binding - The property binding.
	 * @param {string} typeName - The keyframe track type name.
	 * @param {number} valueSize - The keyframe track value size.
	 */ constructor(binding, typeName, valueSize){
        /**
		 * The property binding.
		 *
		 * @type {PropertyBinding}
		 */ this.binding = binding;
        /**
		 * The keyframe track value size.
		 *
		 * @type {number}
		 */ this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeight = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeightAdditive = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.useCount = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.referenceCount = 0;
    }
    /**
	 * Accumulates data in the `incoming` region into `accu<i>`.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 * @param {number} weight - The weight.
	 */ accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    /**
	 * Accumulates data in the `incoming` region into `add`.
	 *
	 * @param {number} weight - The weight.
	 */ accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    /**
	 * Applies the state of `accu<i>` to the binding when accus differ.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 */ apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    /**
	 * Remembers the state of the bound property and copy it to both accus.
	 */ saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    /**
	 * Applies the state previously taken via {@link PropertyMixer#saveOriginalState} to the binding.
	 */ restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    // internals
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $2358b7e4ec07df88$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $2358b7e4ec07df88$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $2358b7e4ec07df88$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $2358b7e4ec07df88$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $2358b7e4ec07df88$var$_reservedRe = new RegExp('[' + $2358b7e4ec07df88$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $2358b7e4ec07df88$var$_wordChar = '[^' + $2358b7e4ec07df88$var$_RESERVED_CHARS_RE + ']';
const $2358b7e4ec07df88$var$_wordCharOrDot = '[^' + $2358b7e4ec07df88$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $2358b7e4ec07df88$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $2358b7e4ec07df88$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $2358b7e4ec07df88$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $2358b7e4ec07df88$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $2358b7e4ec07df88$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $2358b7e4ec07df88$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $2358b7e4ec07df88$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $2358b7e4ec07df88$var$_wordChar);
const $2358b7e4ec07df88$var$_trackRe = new RegExp("^" + $2358b7e4ec07df88$var$_directoryRe + $2358b7e4ec07df88$var$_nodeRe + $2358b7e4ec07df88$var$_objectRe + $2358b7e4ec07df88$var$_propertyRe + '$');
const $2358b7e4ec07df88$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $2358b7e4ec07df88$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $2358b7e4ec07df88$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
/**
 * This holds a reference to a real property in the scene graph; used internally.
 */ class $2358b7e4ec07df88$export$7bf70fcf9f891893 {
    /**
	 * Constructs a new property binding.
	 *
	 * @param {Object} rootNode - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 */ constructor(rootNode, path, parsedPath){
        /**
		 * The object path to the animated property.
		 *
		 * @type {string}
		 */ this.path = path;
        /**
		 * An object holding information about the path.
		 *
		 * @type {Object}
		 */ this.parsedPath = parsedPath || $2358b7e4ec07df88$export$7bf70fcf9f891893.parseTrackName(path);
        /**
		 * The object owns the animated property.
		 *
		 * @type {?Object}
		 */ this.node = $2358b7e4ec07df88$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        /**
		 * The root node.
		 *
		 * @type {Object3D|Skeleton}
		 */ this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    /**
	 * Factory method for creating a property binding from the given parameters.
	 *
	 * @static
	 * @param {Object} root - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 * @return {PropertyBinding|Composite} The created property binding or composite.
	 */ static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $2358b7e4ec07df88$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $2358b7e4ec07df88$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name - Node name to be sanitized.
	 * @return {string} The sanitized node name.
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($2358b7e4ec07df88$var$_reservedRe, '');
    }
    /**
	 * Parses the given track name (an object path to an animated property) and
	 * returns an object with information about the path. Matches strings in the following forms:
	 *
	 * - nodeName.property
	 * - nodeName.property[accessor]
	 * - nodeName.material.property[accessor]
	 * - uuid.property[accessor]
	 * - uuid.objectName[objectIndex].propertyName[propertyIndex]
	 * - parentName/nodeName.property
	 * - parentName/parentName/nodeName.property[index]
	 * - .bone[Armature.DEF_cog].position
	 * - scene:helium_balloon_model:helium_balloon_model.position
	 *
	 * @static
	 * @param {string} trackName - The track name to parse.
	 * @return {Object} The parsed track name as an object.
	 */ static parseTrackName(trackName) {
        const matches = $2358b7e4ec07df88$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($2358b7e4ec07df88$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    /**
	 * Searches for a node in the hierarchy of the given root object by the given
	 * node name.
	 *
	 * @static
	 * @param {Object} root - The root object.
	 * @param {string|number} nodeName - The name of the node.
	 * @return {?Object} The found node. Returns `null` if no object was found.
	 */ static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    /**
	 * Creates a getter / setter pair for the property tracked by this binding.
	 */ bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $2358b7e4ec07df88$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.isMaterial === true) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.isObject3D === true) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    /**
	 * Unbinds the property.
	 */ unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$2358b7e4ec07df88$export$7bf70fcf9f891893.Composite = $2358b7e4ec07df88$var$Composite;
$2358b7e4ec07df88$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$2358b7e4ec07df88$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$2358b7e4ec07df88$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._getValue_direct,
    $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._getValue_array,
    $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$2358b7e4ec07df88$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_direct,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_array,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 * - Add objects you would otherwise pass as 'root' to the
 * constructor or the .clipAction method of AnimationMixer.
 * - Instead pass this object as 'root'.
 * - You can also add and remove objects later when the mixer is running.
 *
 * Note:
 *
 * - Objects of this class appear as one object to the mixer,
 * so cache control of the individual objects must be done on the group.
 *
 * Limitation:
 *
 * - The animated properties must be compatible among the all objects in the group.
 * - A single property can either be controlled through a target group or directly, but not both.
 */ class $2358b7e4ec07df88$export$30619c2afd3f34db {
    /**
	 * Constructs a new animation group.
	 *
	 * @param {...Object3D} arguments - An arbitrary number of 3D objects that share the same animation state.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAnimationObjectGroup = true;
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    /**
	 * Adds an arbitrary number of objects to this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to add.
	 */ add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $2358b7e4ec07df88$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $2358b7e4ec07df88$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) $2358b7e4ec07df88$export$a3bc9b8ed74fc("AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Removes an arbitrary number of objects to this animation group
	 *
	 * @param {...Object3D} arguments - The 3D objects to remove.
	 */ remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Deallocates all memory resources for the passed 3D objects of this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to uncache.
	 */ uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $2358b7e4ec07df88$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
/**
 * An instance of `AnimationAction` schedules the playback of an animation which is
 * stored in {@link AnimationClip}.
 */ class $2358b7e4ec07df88$export$6946940a69e799e {
    /**
	 * Constructs a new animation action.
	 *
	 * @param {AnimationMixer} mixer - The mixer that is controlled by this action.
	 * @param {AnimationClip} clip - The animation clip that holds the actual keyframes.
	 * @param {?Object3D} [localRoot=null] - The root object on which this action is performed.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 */ constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $2358b7e4ec07df88$export$7f795934b84ab523,
            endingEnd: $2358b7e4ec07df88$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        /**
		 * The loop mode, set via {@link AnimationAction#setLoop}.
		 *
		 * @type {(LoopRepeat|LoopOnce|LoopPingPong)}
		 * @default LoopRepeat
		 */ this.loop = $2358b7e4ec07df88$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        /**
		 * The local time of this action (in seconds, starting with `0`).
		 *
		 * The value gets clamped or wrapped to `[0,clip.duration]` (according to the
		 * loop state).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.time = 0;
        /**
		 * Scaling factor for the {@link AnimationAction#time}. A value of `0` causes the
		 * animation to pause. Negative values cause the animation to play backwards.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1;
        this._effectiveTimeScale = 1;
        /**
		 * The degree of influence of this action (in the interval `[0, 1]`). Values
		 * between `0` (no impact) and `1` (full impact) can be used to blend between
		 * several actions.
		 *
		 * @type {number}
		 * @default 1
		 */ this.weight = 1;
        this._effectiveWeight = 1;
        /**
		 * The number of repetitions of the performed clip over the course of this action.
		 * Can be set via {@link AnimationAction#setLoop}.
		 *
		 * Setting this number has no effect if {@link AnimationAction#loop} is set to
		 * `THREE:LoopOnce`.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.repetitions = Infinity;
        /**
		 * If set to `true`, the playback of the action is paused.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.paused = false;
        /**
		 * If set to `false`, the action is disabled so it has no impact.
		 *
		 * When the action is re-enabled, the animation continues from its current
		 * time (setting `enabled` to `false` doesn't reset the action).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * If set to true the animation will automatically be paused on its last frame.
		 *
		 * If set to false, {@link AnimationAction#enabled} will automatically be switched
		 * to `false` when the last loop of the action has finished, so that this action has
		 * no further impact.
		 *
		 * Note: This member has no impact if the action is interrupted (it
		 * has only an effect if its last loop has really finished).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clampWhenFinished = false;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtStart = true;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtEnd = true;
    }
    /**
	 * Starts the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ play() {
        this._mixer._activateAction(this);
        return this;
    }
    /**
	 * Stops the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    /**
	 * Resets the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    /**
	 * Returns `true` if the animation is running.
	 *
	 * @return {boolean} Whether the animation is running or not.
	 */ isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    /**
	 * Returns `true` when {@link AnimationAction#play} has been called.
	 *
	 * @return {boolean} Whether the animation is scheduled or not.
	 */ isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    /**
	 * Defines the time when the animation should start.
	 *
	 * @param {number} time - The start time in seconds.
	 * @return {AnimationAction} A reference to this animation action.
	 */ startAt(time) {
        this._startTime = time;
        return this;
    }
    /**
	 * Configures the loop settings for this action.
	 *
	 * @param {(LoopRepeat|LoopOnce|LoopPingPong)} mode - The loop mode.
	 * @param {number} repetitions - The number of repetitions.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    /**
	 * Sets the effective weight of this action.
	 *
	 * An action has no effect and thus an effective weight of zero when the
	 * action is disabled.
	 *
	 * @param {number} weight - The weight to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    /**
	 * Returns the effective weight of this action.
	 *
	 * @return {number} The effective weight.
	 */ getEffectiveWeight() {
        return this._effectiveWeight;
    }
    /**
	 * Fades the animation in by increasing its weight gradually from `0` to `1`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    /**
	 * Fades the animation out by decreasing its weight gradually from `1` to `0`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    /**
	 * Causes this action to fade in and the given action to fade out,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeOutAction - The animation action to fade out.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeFrom(fadeOutAction, duration, warp = false) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp === true) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    /**
	 * Causes this action to fade out and the given action to fade in,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeInAction - The animation action to fade in.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeTo(fadeInAction, duration, warp = false) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    /**
	 * Stops any fading which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    /**
	 * Sets the effective time scale of this action.
	 *
	 * An action has no effect and thus an effective time scale of zero when the
	 * action is paused.
	 *
	 * @param {number} timeScale - The time scale to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    /**
	 * Returns the effective time scale of this action.
	 *
	 * @return {number} The effective time scale.
	 */ getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    /**
	 * Sets the duration for a single loop of this action.
	 *
	 * @param {number} duration - The duration to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    /**
	 * Synchronizes this action with the passed other action.
	 *
	 * @param {AnimationAction} action - The action to sync with.
	 * @return {AnimationAction} A reference to this animation action.
	 */ syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    /**
	 * Decelerates this animation's speed to `0` within the passed time interval.
	 *
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    /**
	 * Changes the playback speed, within the passed time interval, by modifying
	 * {@link AnimationAction#timeScale} gradually from `startTimeScale` to
	 * `endTimeScale`.
	 *
	 * @param {number} startTimeScale - The start time scale.
	 * @param {number} endTimeScale - The end time scale.
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    /**
	 * Stops any scheduled warping which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    /**
	 * Returns the animation mixer of this animation action.
	 *
	 * @return {AnimationMixer} The animation mixer.
	 */ getMixer() {
        return this._mixer;
    }
    /**
	 * Returns the animation clip of this animation action.
	 *
	 * @return {AnimationClip} The animation clip.
	 */ getClip() {
        return this._clip;
    }
    /**
	 * Returns the root object of this animation action.
	 *
	 * @return {Object3D} The root object.
	 */ getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $2358b7e4ec07df88$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $2358b7e4ec07df88$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $2358b7e4ec07df88$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $2358b7e4ec07df88$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $2358b7e4ec07df88$export$24a4ccb5099273b5;
            settings.endingEnd = $2358b7e4ec07df88$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $2358b7e4ec07df88$export$24a4ccb5099273b5 : $2358b7e4ec07df88$export$7f795934b84ab523;
            else settings.endingStart = $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $2358b7e4ec07df88$export$24a4ccb5099273b5 : $2358b7e4ec07df88$export$7f795934b84ab523;
            else settings.endingEnd = $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $2358b7e4ec07df88$var$_controlInterpolantsResultBuffer = new Float32Array(1);
/**
 * `AnimationMixer` is a player for animations on a particular object in
 * the scene. When multiple objects in the scene are animated independently,
 * one `AnimationMixer` may be used for each object.
 */ class $2358b7e4ec07df88$export$fbd77e5aefaa0102 extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new animation mixer.
	 *
	 * @param {Object3D} root - The object whose animations shall be played by this mixer.
	 */ constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        /**
		 * The global mixer time (in seconds; starting with `0` on the mixer's creation).
		 *
		 * @type {number}
		 * @default 0
		 */ this.time = 0;
        /**
		 * A scaling factor for the global time.
		 *
		 * Note: Setting this member to `0` and later back to `1` is a
		 * possibility to pause/unpause all actions that are controlled by this
		 * mixer.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $2358b7e4ec07df88$export$dfe0af1ca1acb78a($2358b7e4ec07df88$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $2358b7e4ec07df88$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $2358b7e4ec07df88$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    /**
	 * Returns an instance of {@link AnimationAction} for the passed clip.
	 *
	 * If an action fitting the clip and root parameters doesn't yet exist, it
	 * will be created by this method. Calling this method several times with the
	 * same clip and root parameters always returns the same action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 * @return {?AnimationAction} The animation action.
	 */ clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $2358b7e4ec07df88$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $2358b7e4ec07df88$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $2358b7e4ec07df88$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    /**
	 * Returns an existing animation action for the passed clip.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @return {?AnimationAction} The animation action. Returns `null` if no action was found.
	 */ existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $2358b7e4ec07df88$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    /**
	 * Deactivates all previously scheduled actions on this mixer.
	 *
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    /**
	 * Advances the global mixer time and updates the animation.
	 *
	 * This is usually done in the render loop by passing the delta
	 * time from {@link Clock} or {@link Timer}.
	 *
	 * @param {number} deltaTime - The delta time in seconds.
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    /**
	 * Sets the global mixer to a specific time and updates the animation accordingly.
	 *
	 * This is useful when you need to jump to an exact time in an animation. The
	 * input parameter will be scaled by {@link AnimationMixer#timeScale}
	 *
	 * @param {number} time - The time to set in seconds.
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ setTime(time) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(time); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    /**
	 * Returns this mixer's root object.
	 *
	 * @return {Object3D} The mixer's root object.
	 */ getRoot() {
        return this._root;
    }
    /**
	 * Deallocates all memory resources for a clip. Before using this method make
	 * sure to call {@link AnimationAction#stop} for all related actions.
	 *
	 * @param {AnimationClip} clip - The clip to uncache.
	 */ uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    /**
	 * Deallocates all memory resources for a root object. Before using this
	 * method make sure to call {@link AnimationAction#stop} for all related
	 * actions or alternatively {@link AnimationMixer#stopAllAction} when the
	 * mixer operates on a single root.
	 *
	 * @param {Object3D} root - The root object to uncache.
	 */ uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    /**
	 * Deallocates all memory resources for an action. The action is identified by the
	 * given clip and an optional root object. Before using this method make
	 * sure to call {@link AnimationAction#stop} to deactivate the action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 */ uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
/**
 * Represents a 3D render target.
 *
 * @augments RenderTarget
 */ class $2358b7e4ec07df88$export$6b116d2fdfef087c extends $2358b7e4ec07df88$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget3D = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $2358b7e4ec07df88$export$d7a3086320f856db(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents a uniform which is a global shader variable. They are passed to shader programs.
 *
 * When declaring a uniform of a {@link ShaderMaterial}, it is declared by value or by object.
 * ```js
 * uniforms: {
 * 	time: { value: 1.0 },
 * 	resolution: new Uniform( new Vector2() )
 * };
 * ```
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 */ class $2358b7e4ec07df88$export$2947cebfe91c02f8 {
    /**
	 * Constructs a new uniform.
	 *
	 * @param {any} value - The uniform value.
	 */ constructor(value){
        /**
		 * The uniform value.
		 *
		 * @type {any}
		 */ this.value = value;
    }
    /**
	 * Returns a new uniform with copied values from this instance.
	 * If the value has a `clone()` method, the value is cloned as well.
	 *
	 * @return {Uniform} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $2358b7e4ec07df88$var$_id = 0;
/**
 * A class for managing multiple uniforms in a single group. The renderer will process
 * such a definition as a single UBO.
 *
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 *
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$c412d5ffe1f79209 extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new uniforms group.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformsGroup = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name UniformsGroup#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_id++
        });
        /**
		 * The name of the uniforms group.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer usage.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $2358b7e4ec07df88$export$763e8360f4d7f77d;
        /**
		 * An array holding the uniforms.
		 *
		 * @type {Array<Uniform>}
		 */ this.uniforms = [];
    }
    /**
	 * Adds the given uniform to this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to add.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    /**
	 * Removes the given uniform from this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to remove.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    /**
	 * Sets the name of this uniforms group.
	 *
	 * @param {string} name - The name to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the usage of this uniforms group.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Copies the values of the given uniforms group to this instance.
	 *
	 * @param {UniformsGroup} source - The uniforms group to copy.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    /**
	 * Returns a new uniforms group with copied values from this instance.
	 *
	 * @return {UniformsGroup} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * An instanced version of an interleaved buffer.
 *
 * @augments InterleavedBuffer
 */ class $2358b7e4ec07df88$export$25ec0e1af1389358 extends $2358b7e4ec07df88$export$3d5cd879f108f53f {
    /**
	 * Constructs a new instanced interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 * @param {number} [meshPerAttribute=1] - Defines how often a value of this interleaved buffer should be repeated.
	 */ constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedInterleavedBuffer = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated,
		 * see {@link InstancedBufferAttribute#meshPerAttribute}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
/**
 * An alternative version of a buffer attribute with more control over the VBO.
 *
 * The renderer does not construct a VBO for this kind of attribute. Instead, it uses
 * whatever VBO is passed in constructor and can later be altered via the `buffer` property.
 *
 * The most common use case for this class is when some kind of GPGPU calculation interferes
 * or even produces the VBOs in question.
 *
 * Notice that this class can only be used with {@link WebGLRenderer}.
 */ class $2358b7e4ec07df88$export$6b7339ae8dbddf73 {
    /**
	 * Constructs a new GL buffer attribute.
	 *
	 * @param {WebGLBuffer} buffer - The native WebGL buffer.
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} itemSize - The item size.
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @param {number} count - The expected number of vertices in VBO.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(buffer, type, itemSize, elementSize, count, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGLBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The native WebGL buffer.
		 *
		 * @type {WebGLBuffer}
		 */ this.buffer = buffer;
        /**
		 * The native data type.
		 *
		 * @type {number}
		 */ this.type = type;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The corresponding size (in bytes) for the given `type` parameter.
		 *
		 * @type {number}
		 */ this.elementSize = elementSize;
        /**
		 * The expected number of vertices in VBO.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `buffer` contains data of `gl.UNSIGNED_SHORT`,
		 * and `normalized` is `true`, the values `0 - +65535` in the buffer data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the given native WebGL buffer.
	 *
	 * @param {WebGLBuffer} buffer - The buffer to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    /**
	 * Sets the given native data type and element size.
	 *
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    /**
	 * Sets the item size.
	 *
	 * @param {number} itemSize - The item size.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    /**
	 * Sets the count (the expected number of vertices in VBO).
	 *
	 * @param {number} count - The count.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setCount(count) {
        this.count = count;
        return this;
    }
}
const $2358b7e4ec07df88$var$_matrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
/**
 * This class is designed to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3d space the mouse is over)
 * amongst other things.
 */ class $2358b7e4ec07df88$export$8b7aaceff00bd2f {
    /**
	 * Constructs a new raycaster.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
	 * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
	 */ constructor(origin, direction, near = 0, far = Infinity){
        /**
		 * The ray used for raycasting.
		 *
		 * @type {Ray}
		 */ this.ray = new $2358b7e4ec07df88$export$a186db52eed6d40e(origin, direction);
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default 0
		 */ this.near = near;
        /**
		 * All results returned are closer than far. Far can't be lower than near.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.far = far;
        /**
		 * The camera to use when raycasting against view-dependent objects such as
		 * billboarded objects like sprites. This field can be set manually or
		 * is set when calling `setFromCamera()`.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * Allows to selectively ignore 3D objects when performing intersection tests.
		 * The following code example ensures that only 3D objects on layer `1` will be
		 * honored by raycaster.
		 * ```js
		 * raycaster.layers.set( 1 );
		 * object.layers.enable( 1 );
		 * ```
		 *
		 * @type {Layers}
		 */ this.layers = new $2358b7e4ec07df88$export$89312ce47c0ca777();
        /**
		 * A parameter object that configures the raycasting. It has the structure:
		 *
		 * ```
		 * {
		 * 	Mesh: {},
		 * 	Line: { threshold: 1 },
		 * 	LOD: {},
		 * 	Points: { threshold: 1 },
		 * 	Sprite: {}
		 * }
		 * ```
		 * Where `threshold` is the precision of the raycaster when intersecting objects, in world units.
		 *
		 * @type {Object}
		 */ this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    /**
	 * Updates the ray with a new origin and direction by copying the values from the arguments.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 */ set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    /**
	 * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
	 *
	 * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
	 * X and Y components should be between `-1` and `1`.
	 * @param {Camera} camera - The camera from which the ray should originate.
	 */ setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else $2358b7e4ec07df88$export$a3bc9b8ed74fc('Raycaster: Unsupported camera type: ' + camera.type);
    }
    /**
	 * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
	 *
	 * @param {WebXRController} controller - The controller to copy the position and direction from.
	 * @return {Raycaster} A reference to this raycaster.
	 */ setFromXRController(controller) {
        $2358b7e4ec07df88$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($2358b7e4ec07df88$var$_matrix);
        return this;
    }
    /**
	 * The intersection point of a raycaster intersection test.
	 * @typedef {Object} Raycaster~Intersection
	 * @property {number} distance - The distance from the ray's origin to the intersection point.
	 * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
	 * intersection to the nearest point on the ray. For other objects it will be `undefined`.
	 * @property {Vector3} point - The intersection point, in world coordinates.
	 * @property {Object} face - The face that has been intersected.
	 * @property {number} faceIndex - The face index.
	 * @property {Object3D} object - The 3D object that has been intersected.
	 * @property {Vector2} uv - U,V coordinates at point of intersection.
	 * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
	 * @property {Vector3} normal - Interpolated normal vector at point of intersection.
	 * @property {number} instanceId - The index number of the instance where the ray
	 * intersects the {@link InstancedMesh}.
	 */ /**
	 * Checks all intersection between the ray and the object with or without the
	 * descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
	 * evaluating whether the ray intersects the object or not. This allows meshes to respond
	 * differently to ray casting than lines or points.
	 *
	 * Note that for meshes, faces must be pointed towards the origin of the ray in order
	 * to be detected; intersections of the ray passing through the back of a face will not
	 * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
	 * to `THREE.DoubleSide`.
	 *
	 * @param {Object3D} object - The 3D object to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObject(object, recursive = true, intersects = []) {
        $2358b7e4ec07df88$var$intersect(object, this, intersects, recursive);
        intersects.sort($2358b7e4ec07df88$var$ascSort);
        return intersects;
    }
    /**
	 * Checks all intersection between the ray and the objects with or without
	 * the descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$2358b7e4ec07df88$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($2358b7e4ec07df88$var$ascSort);
        return intersects;
    }
}
function $2358b7e4ec07df88$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $2358b7e4ec07df88$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$2358b7e4ec07df88$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * This class is an alternative to {@link Clock} with a different API design and behavior.
 * The goal is to avoid the conceptual flaws that became apparent in `Clock` over time.
 *
 * - `Timer` has an `update()` method that updates its internal state. That makes it possible to
 * call `getDelta()` and `getElapsed()` multiple times per simulation step without getting different values.
 * - The class can make use of the Page Visibility API to avoid large time delta values when the app
 * is inactive (e.g. tab switched or browser hidden).
 *
 * ```js
 * const timer = new Timer();
 * timer.connect( document ); // use Page Visibility API
 * ```
 */ class $2358b7e4ec07df88$export$c57e9b2d8b9e4de {
    /**
	 * Constructs a new timer.
	 */ constructor(){
        this._previousTime = 0;
        this._currentTime = 0;
        this._startTime = performance.now();
        this._delta = 0;
        this._elapsed = 0;
        this._timescale = 1;
        this._document = null;
        this._pageVisibilityHandler = null;
    }
    /**
	 * Connect the timer to the given document.Calling this method is not mandatory to
	 * use the timer but enables the usage of the Page Visibility API to avoid large time
	 * delta values.
	 *
	 * @param {Document} document - The document.
	 */ connect(document1) {
        this._document = document1;
        // use Page Visibility API to avoid large time delta values
        if (document1.hidden !== undefined) {
            this._pageVisibilityHandler = $2358b7e4ec07df88$var$handleVisibilityChange.bind(this);
            document1.addEventListener('visibilitychange', this._pageVisibilityHandler, false);
        }
    }
    /**
	 * Disconnects the timer from the DOM and also disables the usage of the Page Visibility API.
	 */ disconnect() {
        if (this._pageVisibilityHandler !== null) {
            this._document.removeEventListener('visibilitychange', this._pageVisibilityHandler);
            this._pageVisibilityHandler = null;
        }
        this._document = null;
    }
    /**
	 * Returns the time delta in seconds.
	 *
	 * @return {number} The time delta in second.
	 */ getDelta() {
        return this._delta / 1000;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time in second.
	 */ getElapsed() {
        return this._elapsed / 1000;
    }
    /**
	 * Returns the timescale.
	 *
	 * @return {number} The timescale.
	 */ getTimescale() {
        return this._timescale;
    }
    /**
	 * Sets the given timescale which scale the time delta computation
	 * in `update()`.
	 *
	 * @param {number} timescale - The timescale to set.
	 * @return {Timer} A reference to this timer.
	 */ setTimescale(timescale) {
        this._timescale = timescale;
        return this;
    }
    /**
	 * Resets the time computation for the current simulation step.
	 *
	 * @return {Timer} A reference to this timer.
	 */ reset() {
        this._currentTime = performance.now() - this._startTime;
        return this;
    }
    /**
	 * Can be used to free all internal resources. Usually called when
	 * the timer instance isn't required anymore.
	 */ dispose() {
        this.disconnect();
    }
    /**
	 * Updates the internal state of the timer. This method should be called
	 * once per simulation step and before you perform queries against the timer
	 * (e.g. via `getDelta()`).
	 *
	 * @param {number} timestamp - The current time in milliseconds. Can be obtained
	 * from the `requestAnimationFrame` callback argument. If not provided, the current
	 * time will be determined with `performance.now`.
	 * @return {Timer} A reference to this timer.
	 */ update(timestamp) {
        if (this._pageVisibilityHandler !== null && this._document.hidden === true) this._delta = 0;
        else {
            this._previousTime = this._currentTime;
            this._currentTime = (timestamp !== undefined ? timestamp : performance.now()) - this._startTime;
            this._delta = (this._currentTime - this._previousTime) * this._timescale;
            this._elapsed += this._delta; // _elapsed is the accumulation of all previous deltas
        }
        return this;
    }
}
function $2358b7e4ec07df88$var$handleVisibilityChange() {
    if (this._document.hidden === false) this.reset();
}
/**
 * This class can be used to represent points in 3D space as
 * [Spherical coordinates](https://en.wikipedia.org/wiki/Spherical_coordinate_system).
 */ class $2358b7e4ec07df88$export$d712cd887b4a00f7 {
    /**
	 * Constructs a new spherical.
	 *
	 * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
	 * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
	 * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
	 */ constructor(radius = 1, phi = 0, theta = 0){
        /**
		 * The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * The polar angle in radians from the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.phi = phi;
        /**
		 * The equator/azimuthal angle in radians around the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
    }
    /**
	 * Sets the spherical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The polar angle.
	 * @param {number} theta - The azimuthal angle.
	 * @return {Spherical} A reference to this spherical.
	 */ set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    /**
	 * Copies the values of the given spherical to this instance.
	 *
	 * @param {Spherical} other - The spherical to copy.
	 * @return {Spherical} A reference to this spherical.
	 */ copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    /**
	 * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
	 * `0.000001`.
	 *
	 * @return {Spherical} A reference to this spherical.
	 */ makeSafe() {
        const EPS = 0.000001;
        this.phi = $2358b7e4ec07df88$var$clamp(this.phi, EPS, Math.PI - EPS);
        return this;
    }
    /**
	 * Sets the spherical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the spherical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The y value.
	 * @param {number} z - The z value.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($2358b7e4ec07df88$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    /**
	 * Returns a new spherical with copied values from this instance.
	 *
	 * @return {Spherical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Cylindrical coordinates](https://en.wikipedia.org/wiki/Cylindrical_coordinate_system).
 */ class $2358b7e4ec07df88$export$287165bb2177f4fd {
    /**
	 * Constructs a new cylindrical.
	 *
	 * @param {number} [radius=1] - The distance from the origin to a point in the x-z plane.
	 * @param {number} [theta=0] - A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
	 * @param {number} [y=0] - The height above the x-z plane.
	 */ constructor(radius = 1, theta = 0, y = 0){
        /**
		 * The distance from the origin to a point in the x-z plane.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
        /**
		 * The height above the x-z plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.y = y;
    }
    /**
	 * Sets the cylindrical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle.
	 * @param {number} y - The height value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    /**
	 * Copies the values of the given cylindrical to this instance.
	 *
	 * @param {Cylindrical} other - The cylindrical to copy.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    /**
	 * Sets the cylindrical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the cylindrical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    /**
	 * Returns a new cylindrical with copied values from this instance.
	 *
	 * @return {Cylindrical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 2x2 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix2#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix2#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix2();
 * m.set( 11, 12,
 *        21, 22 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21,
 *                12, 22 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $2358b7e4ec07df88$export$cbcc6560bf79fb38 {
    /**
	 * Constructs a new 2x2 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 */ constructor(n11, n12, n21, n22){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    /**
	 * Sets this matrix to the 2x2 identity matrix.
	 *
	 * @return {Matrix2} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix2} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} n11 - 1-1 matrix element.
	 * @param {number} n12 - 1-2 matrix element.
	 * @param {number} n21 - 2-1 matrix element.
	 * @param {number} n22 - 2-2 matrix element.
	 * @return {Matrix2} A reference to this matrix.
	 */ set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const $2358b7e4ec07df88$var$_vector$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
/**
 * Represents an axis-aligned bounding box (AABB) in 2D space.
 */ class $2358b7e4ec07df88$export$60f553fa130f08b0 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector2} [min=(Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector2} [max=(-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $2358b7e4ec07df88$export$c977b3e384af9ae1(Infinity, Infinity), max = new $2358b7e4ec07df88$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox2 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector2} min - The lower boundary of the box.
	 * @param {Vector2} max - The upper boundary of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector2>} points - An array holding 2D position data as instances of {@link Vector2}.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector2} center - The center of the box.
	 * @param {Vector2} size - The x and y dimensions of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $2358b7e4ec07df88$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box2} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box2} box - The box to copy.
	 * @return {Box2} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 2D.
	 *
	 * @return {Box2} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector2} point - The point that should be included by the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions.
	 *
	 * @param {Vector2} vector - The vector that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector2} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    /**
	 * Returns a point as a proportion of this box's width and height.
	 *
	 * @param {Vector2} point - A point in 2D space.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} A point as a proportion of this box's width and height.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector2} point - The point to clamp.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector2} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $2358b7e4ec07df88$var$_vector$4).distanceTo(point);
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box2} box - The bounding box to intersect with.
	 * @return {Box2} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box2} box - The bounding box that will be unioned with this instance.
	 * @return {Box2} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 2D space.
	 *
	 * @param {Vector2} offset - The offset that should be used to translate the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box2} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $2358b7e4ec07df88$var$_startP = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_startEnd = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_d1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_d2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_r = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_c1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_c2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * An analytical line segment in 3D space represented by a start and end point.
 */ class $2358b7e4ec07df88$export$e0ba6359f1954fd3 {
    /**
	 * Constructs a new line segment.
	 *
	 * @param {Vector3} [start=(0,0,0)] - Start of the line segment.
	 * @param {Vector3} [end=(0,0,0)] - End of the line segment.
	 */ constructor(start = new $2358b7e4ec07df88$export$64b5c384219d3699(), end = new $2358b7e4ec07df88$export$64b5c384219d3699()){
        /**
		 * Start of the line segment.
		 *
		 * @type {Vector3}
		 */ this.start = start;
        /**
		 * End of the line segment.
		 *
		 * @type {Vector3}
		 */ this.end = end;
    }
    /**
	 * Sets the start and end values by copying the given vectors.
	 *
	 * @param {Vector3} start - The start point.
	 * @param {Vector3} end - The end point.
	 * @return {Line3} A reference to this line segment.
	 */ set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    /**
	 * Copies the values of the given line segment to this instance.
	 *
	 * @param {Line3} line - The line segment to copy.
	 * @return {Line3} A reference to this line segment.
	 */ copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    /**
	 * Returns the center of the line segment.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    /**
	 * Returns the delta vector of the line segment's start and end point.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ delta(target) {
        return target.subVectors(this.end, this.start);
    }
    /**
	 * Returns the squared Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The squared Euclidean distance.
	 */ distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    /**
	 * Returns the Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The Euclidean distance.
	 */ distance() {
        return this.start.distanceTo(this.end);
    }
    /**
	 * Returns a vector at a certain position along the line segment.
	 *
	 * @param {number} t - A value between `[0,1]` to represent a position along the line segment.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns a point parameter based on the closest point as projected on the line segment.
	 *
	 * @param {Vector3} point - The point for which to return a point parameter.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @return {number} The point parameter.
	 */ closestPointToPointParameter(point, clampToLine) {
        $2358b7e4ec07df88$var$_startP.subVectors(point, this.start);
        $2358b7e4ec07df88$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $2358b7e4ec07df88$var$_startEnd.dot($2358b7e4ec07df88$var$_startEnd);
        const startEnd_startP = $2358b7e4ec07df88$var$_startEnd.dot($2358b7e4ec07df88$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $2358b7e4ec07df88$var$clamp(t, 0, 1);
        return t;
    }
    /**
	 * Returns the closest point on the line for a given point.
	 *
	 * @param {Vector3} point - The point to compute the closest point on the line for.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the line.
	 */ closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns the closest squared distance between this line segment and the given one.
	 *
	 * @param {Line3} line - The line segment to compute the closest squared distance to.
	 * @param {Vector3} [c1] - The closest point on this line segment.
	 * @param {Vector3} [c2] - The closest point on the given line segment.
	 * @return {number} The squared distance between this line segment and the given one.
	 */ distanceSqToLine3(line, c1 = $2358b7e4ec07df88$var$_c1, c2 = $2358b7e4ec07df88$var$_c2) {
        // from Real-Time Collision Detection by Christer Ericson, chapter 5.1.9
        // Computes closest points C1 and C2 of S1(s)=P1+s*(Q1-P1) and
        // S2(t)=P2+t*(Q2-P2), returning s and t. Function result is squared
        // distance between between S1(s) and S2(t)
        const EPSILON = 1e-8 * 1e-8; // must be squared since we compare squared length
        let s, t;
        const p1 = this.start;
        const p2 = line.start;
        const q1 = this.end;
        const q2 = line.end;
        $2358b7e4ec07df88$var$_d1.subVectors(q1, p1); // Direction vector of segment S1
        $2358b7e4ec07df88$var$_d2.subVectors(q2, p2); // Direction vector of segment S2
        $2358b7e4ec07df88$var$_r.subVectors(p1, p2);
        const a = $2358b7e4ec07df88$var$_d1.dot($2358b7e4ec07df88$var$_d1); // Squared length of segment S1, always nonnegative
        const e = $2358b7e4ec07df88$var$_d2.dot($2358b7e4ec07df88$var$_d2); // Squared length of segment S2, always nonnegative
        const f = $2358b7e4ec07df88$var$_d2.dot($2358b7e4ec07df88$var$_r);
        // Check if either or both segments degenerate into points
        if (a <= EPSILON && e <= EPSILON) {
            // Both segments degenerate into points
            c1.copy(p1);
            c2.copy(p2);
            c1.sub(c2);
            return c1.dot(c1);
        }
        if (a <= EPSILON) {
            // First segment degenerates into a point
            s = 0;
            t = f / e; // s = 0 => t = (b*s + f) / e = f / e
            t = $2358b7e4ec07df88$var$clamp(t, 0, 1);
        } else {
            const c = $2358b7e4ec07df88$var$_d1.dot($2358b7e4ec07df88$var$_r);
            if (e <= EPSILON) {
                // Second segment degenerates into a point
                t = 0;
                s = $2358b7e4ec07df88$var$clamp(-c / a, 0, 1); // t = 0 => s = (b*t - c) / a = -c / a
            } else {
                // The general nondegenerate case starts here
                const b = $2358b7e4ec07df88$var$_d1.dot($2358b7e4ec07df88$var$_d2);
                const denom = a * e - b * b; // Always nonnegative
                // If segments not parallel, compute closest point on L1 to L2 and
                // clamp to segment S1. Else pick arbitrary s (here 0)
                if (denom !== 0) s = $2358b7e4ec07df88$var$clamp((b * f - c * e) / denom, 0, 1);
                else s = 0;
                // Compute point on L2 closest to S1(s) using
                // t = Dot((P1 + D1*s) - P2,D2) / Dot(D2,D2) = (b*s + f) / e
                t = (b * s + f) / e;
                // If t in [0,1] done. Else clamp t, recompute s for the new value
                // of t using s = Dot((P2 + D2*t) - P1,D1) / Dot(D1,D1)= (t*b - c) / a
                // and clamp s to [0, 1]
                if (t < 0) {
                    t = 0.;
                    s = $2358b7e4ec07df88$var$clamp(-c / a, 0, 1);
                } else if (t > 1) {
                    t = 1;
                    s = $2358b7e4ec07df88$var$clamp((b - c) / a, 0, 1);
                }
            }
        }
        c1.copy(p1).add($2358b7e4ec07df88$var$_d1.multiplyScalar(s));
        c2.copy(p2).add($2358b7e4ec07df88$var$_d2.multiplyScalar(t));
        c1.sub(c2);
        return c1.dot(c1);
    }
    /**
	 * Applies a 4x4 transformation matrix to this line segment.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Line3} A reference to this line segment.
	 */ applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    /**
	 * Returns `true` if this line segment is equal with the given one.
	 *
	 * @param {Line3} line - The line segment to test for equality.
	 * @return {boolean} Whether this line segment is equal with the given one.
	 */ equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    /**
	 * Returns a new line segment with copied values from this instance.
	 *
	 * @return {Line3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $2358b7e4ec07df88$var$_vector$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * This displays a cone shaped helper object for a {@link SpotLight}.
 *
 * ```js
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 10, 10, 10 );
 * scene.add( spotLight );
 *
 * const spotLightHelper = new THREE.SpotLightHelper( spotLight );
 * scene.add( spotLightHelper );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$4b14638ffdd81e68 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new spot light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {SpotLight}
		 */ this.light = light;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(positions, 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $2358b7e4ec07df88$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $2358b7e4ec07df88$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($2358b7e4ec07df88$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $2358b7e4ec07df88$var$_vector$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_boneMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_matrixWorldInv = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
/**
 * A helper object to assist with visualizing a {@link Skeleton}.
 *
 * ```js
 * const helper = new THREE.SkeletonHelper( skinnedMesh );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$5277df3c9e732259 extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new skeleton helper.
	 *
	 * @param {Object3D} object -  Usually an instance of {@link SkinnedMesh}. However, any 3D object
	 * can be used if it represents a hierarchy of bones (see {@link Bone}).
	 */ constructor(object){
        const bones = $2358b7e4ec07df88$var$getBoneList(object);
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(0, 0, 0);
                colors.push(0, 0, 0);
            }
        }
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$cbe7a62641830ebd(colors, 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        /**
		 * The object being visualized.
		 *
		 * @type {Object3D}
		 */ this.root = object;
        /**
		 * The list of bones that the helper visualizes.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
        // colors
        const color1 = new $2358b7e4ec07df88$export$892596cec99bc70e(0x0000ff);
        const color2 = new $2358b7e4ec07df88$export$892596cec99bc70e(0x00ff00);
        this.setColors(color1, color2);
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $2358b7e4ec07df88$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $2358b7e4ec07df88$var$_boneMatrix.multiplyMatrices($2358b7e4ec07df88$var$_matrixWorldInv, bone.matrixWorld);
                $2358b7e4ec07df88$var$_vector$2.setFromMatrixPosition($2358b7e4ec07df88$var$_boneMatrix);
                position.setXYZ(j, $2358b7e4ec07df88$var$_vector$2.x, $2358b7e4ec07df88$var$_vector$2.y, $2358b7e4ec07df88$var$_vector$2.z);
                $2358b7e4ec07df88$var$_boneMatrix.multiplyMatrices($2358b7e4ec07df88$var$_matrixWorldInv, bone.parent.matrixWorld);
                $2358b7e4ec07df88$var$_vector$2.setFromMatrixPosition($2358b7e4ec07df88$var$_boneMatrix);
                position.setXYZ(j + 1, $2358b7e4ec07df88$var$_vector$2.x, $2358b7e4ec07df88$var$_vector$2.y, $2358b7e4ec07df88$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} color1 - The first line color for each bone.
	 * @param {Color} color2 - The second line color for each bone.
	 * @return {SkeletonHelper} A reference to this helper.
	 */ setColors(color1, color2) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        for(let i = 0; i < colorAttribute.count; i += 2){
            colorAttribute.setXYZ(i, color1.r, color1.g, color1.b);
            colorAttribute.setXYZ(i + 1, color2.r, color2.g, color2.b);
        }
        colorAttribute.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $2358b7e4ec07df88$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push(...$2358b7e4ec07df88$var$getBoneList(object.children[i]));
    return boneList;
}
/**
 * This displays a helper object consisting of a spherical mesh for
 * visualizing an instance of {@link PointLight}.
 *
 * ```js
 * const pointLight = new THREE.PointLight( 0xff0000, 1, 100 );
 * pointLight.position.set( 10, 10, 10 );
 * scene.add( pointLight );
 *
 * const sphereSize = 1;
 * const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
 * scene.add( pointLightHelper );
 * ```
 *
 * @augments Mesh
 */ class $2358b7e4ec07df88$export$9a9291685b9e4023 extends $2358b7e4ec07df88$export$e176487c05830cc5 {
    /**
	 * Constructs a new point light helper.
	 *
	 * @param {PointLight} light - The light to be visualized.
	 * @param {number} [sphereSize=1] - The size of the sphere helper.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, sphereSize, color){
        const geometry = new $2358b7e4ec07df88$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $2358b7e4ec07df88$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        /**
		 * The light being visualized.
		 *
		 * @type {PointLight}
		 */ this.light = light;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Updates the helper to match the position of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $2358b7e4ec07df88$var$_vector$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_color1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$892596cec99bc70e();
const $2358b7e4ec07df88$var$_color2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$892596cec99bc70e();
/**
 * Creates a visual aid consisting of a spherical mesh for a
 * given {@link HemisphereLight}.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * const helper = new THREE.HemisphereLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$8dca15f13f4f8172 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new hemisphere light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number} [size=1] - The size of the mesh used to visualize the light.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $2358b7e4ec07df88$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $2358b7e4ec07df88$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$8dea267bd6bde117(colors, 3));
        this.add(new $2358b7e4ec07df88$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $2358b7e4ec07df88$var$_color1.copy(this.light.color);
            $2358b7e4ec07df88$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $2358b7e4ec07df88$var$_color1 : $2358b7e4ec07df88$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($2358b7e4ec07df88$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
/**
 * The helper is an object to define grids. Grids are two-dimensional
 * arrays of lines.
 *
 * ```js
 * const size = 10;
 * const divisions = 10;
 *
 * const gridHelper = new THREE.GridHelper( size, divisions );
 * scene.add( gridHelper );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$3875d39926561055 extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new grid helper.
	 *
	 * @param {number} [size=10] - The size of the grid.
	 * @param {number} [divisions=10] - The number of divisions across the grid.
	 * @param {number|Color|string} [color1=0x444444] - The color of the center line.
	 * @param {number|Color|string} [color2=0x888888] - The color of the lines of the grid.
	 */ constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $2358b7e4ec07df88$export$892596cec99bc70e(color1);
        color2 = new $2358b7e4ec07df88$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$cbe7a62641830ebd(colors, 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This helper is an object to define polar grids. Grids are
 * two-dimensional arrays of lines.
 *
 * ```js
 * const radius = 10;
 * const sectors = 16;
 * const rings = 8;
 * const divisions = 64;
 *
 * const helper = new THREE.PolarGridHelper( radius, sectors, rings, divisions );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$361430a10f533cd3 extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new polar grid helper.
	 *
	 * @param {number} [radius=10] - The radius of the polar grid. This can be any positive number.
	 * @param {number} [sectors=16] - The number of sectors the grid will be divided into. This can be any positive integer.
	 * @param {number} [rings=16] - The number of rings. This can be any positive integer.
	 * @param {number} [divisions=64] - The number of line segments used for each circle. This can be any positive integer.
	 * @param {number|Color|string} [color1=0x444444] - The first color used for grid elements.
	 * @param {number|Color|string} [color2=0x888888] -  The second color used for grid elements.
	 */ constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $2358b7e4ec07df88$export$892596cec99bc70e(color1);
        color2 = new $2358b7e4ec07df88$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$cbe7a62641830ebd(colors, 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $2358b7e4ec07df88$var$_v1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Helper object to assist with visualizing a {@link DirectionalLight}'s
 * effect on the scene. This consists of plane and a line representing the
 * light's position and direction.
 *
 * ```js
 * const light = new THREE.DirectionalLight( 0xFFFFFF );
 * scene.add( light );
 *
 * const helper = new THREE.DirectionalLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$f8e434dc14203e7d extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new directional light helper.
	 *
	 * @param {DirectionalLight} light - The light to be visualized.
	 * @param {number} [size=1] - The dimensions of the plane.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {DirectionalLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        /**
		 * Contains the line showing the location of the directional light.
		 *
		 * @type {Line}
		 */ this.lightPlane = new $2358b7e4ec07df88$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        /**
		 * Represents the target line of the directional light.
		 *
		 * @type {Line}
		 */ this.targetLine = new $2358b7e4ec07df88$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $2358b7e4ec07df88$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $2358b7e4ec07df88$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $2358b7e4ec07df88$var$_v3.subVectors($2358b7e4ec07df88$var$_v2, $2358b7e4ec07df88$var$_v1);
        this.lightPlane.lookAt($2358b7e4ec07df88$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($2358b7e4ec07df88$var$_v2);
        this.targetLine.scale.z = $2358b7e4ec07df88$var$_v3.length();
    }
}
const $2358b7e4ec07df88$var$_vector = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_camera = /*@__PURE__*/ new $2358b7e4ec07df88$export$79f141de891a5fed();
/**
 * This helps with visualizing what a camera contains in its frustum. It
 * visualizes the frustum of a camera using a line segments.
 *
 * Based on frustum visualization in [lightgl.js shadowmap example](https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html).
 *
 * `CameraHelper` must be a child of the scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
 * const helper = new THREE.CameraHelper( camera );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$ed8e93f853cd795 extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Camera} camera - The camera to visualize.
	 */ constructor(camera){
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        /**
		 * The camera being visualized.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * This contains the points used to visualize the camera.
		 *
		 * @type {Object<string,Array<number>>}
		 */ this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $2358b7e4ec07df88$export$892596cec99bc70e(0xff0000);
        const colorUp = new $2358b7e4ec07df88$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff);
        const colorCross = new $2358b7e4ec07df88$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} frustum - The frustum line color.
	 * @param {Color} cone - The cone line color.
	 * @param {Color} up - The up line color.
	 * @param {Color} target - The target line color.
	 * @param {Color} cross - The cross line color.
	 * @return {CameraHelper} A reference to this helper.
	 */ setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
        return this;
    }
    /**
	 * Updates the helper based on the projection matrix of the camera.
	 */ update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        let nearZ, farZ;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $2358b7e4ec07df88$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // Adjust z values based on coordinate system
        if (this.camera.reversedDepth === true) {
            nearZ = 1;
            farZ = 0;
        } else {
            if (this.camera.coordinateSystem === $2358b7e4ec07df88$export$5a0e9190d10875d3) {
                nearZ = -1;
                farZ = 1;
            } else if (this.camera.coordinateSystem === $2358b7e4ec07df88$export$cc83beedcb9be9ac) {
                nearZ = 0;
                farZ = 1;
            } else throw new Error('THREE.CameraHelper.update(): Invalid coordinate system: ' + this.camera.coordinateSystem);
        }
        // center / target
        $2358b7e4ec07df88$var$setPoint('c', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, 0, nearZ);
        $2358b7e4ec07df88$var$setPoint('t', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, 0, farZ);
        // near
        $2358b7e4ec07df88$var$setPoint('n1', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, -h, nearZ);
        $2358b7e4ec07df88$var$setPoint('n2', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, -h, nearZ);
        $2358b7e4ec07df88$var$setPoint('n3', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, h, nearZ);
        $2358b7e4ec07df88$var$setPoint('n4', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, h, nearZ);
        // far
        $2358b7e4ec07df88$var$setPoint('f1', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, -h, farZ);
        $2358b7e4ec07df88$var$setPoint('f2', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, -h, farZ);
        $2358b7e4ec07df88$var$setPoint('f3', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, h, farZ);
        $2358b7e4ec07df88$var$setPoint('f4', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, h, farZ);
        // up
        $2358b7e4ec07df88$var$setPoint('u1', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w * 0.7, h * 1.1, nearZ);
        $2358b7e4ec07df88$var$setPoint('u2', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w * 0.7, h * 1.1, nearZ);
        $2358b7e4ec07df88$var$setPoint('u3', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, h * 2, nearZ);
        // cross
        $2358b7e4ec07df88$var$setPoint('cf1', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, 0, farZ);
        $2358b7e4ec07df88$var$setPoint('cf2', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, 0, farZ);
        $2358b7e4ec07df88$var$setPoint('cf3', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, -h, farZ);
        $2358b7e4ec07df88$var$setPoint('cf4', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, h, farZ);
        $2358b7e4ec07df88$var$setPoint('cn1', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, 0, nearZ);
        $2358b7e4ec07df88$var$setPoint('cn2', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, 0, nearZ);
        $2358b7e4ec07df88$var$setPoint('cn3', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, -h, nearZ);
        $2358b7e4ec07df88$var$setPoint('cn4', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, h, nearZ);
        geometry.getAttribute('position').needsUpdate = true;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $2358b7e4ec07df88$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $2358b7e4ec07df88$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $2358b7e4ec07df88$var$_vector.x, $2358b7e4ec07df88$var$_vector.y, $2358b7e4ec07df88$var$_vector.z);
    }
}
const $2358b7e4ec07df88$var$_box = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
/**
 * Helper object to graphically show the world-axis-aligned bounding box
 * around an object. The actual bounding box is handled with {@link Box3},
 * this is just a visual helper for debugging. It can be automatically
 * resized with {@link BoxHelper#update} when the object it's created from
 * is transformed. Note that the object must have a geometry for this to work,
 * so it won't work with sprites.
 *
 * ```js
 * const sphere = new THREE.SphereGeometry();
 * const object = new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( 0xff0000 ) );
 * const box = new THREE.BoxHelper( object, 0xffff00 );
 * scene.add( box );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$38a664cc862a6a9d extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box helper.
	 *
	 * @param {Object3D} [object] - The 3D object to show the world-axis-aligned bounding box.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setIndex(new $2358b7e4ec07df88$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The 3D object being visualized.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    /**
	 * Updates the helper's geometry to match the dimensions of the object,
	 * including any children.
	 */ update() {
        if (this.object !== undefined) $2358b7e4ec07df88$var$_box.setFromObject(this.object);
        if ($2358b7e4ec07df88$var$_box.isEmpty()) return;
        const min = $2358b7e4ec07df88$var$_box.min;
        const max = $2358b7e4ec07df88$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    /**
	 * Updates the wireframe box for the passed object.
	 *
	 * @param {Object3D} object - The 3D object to create the helper for.
	 * @return {BoxHelper} A reference to this instance.
	 */ setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Box3}.
 *
 * ```js
 * const box = new THREE.Box3();
 * box.setFromCenterAndSize( new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 2, 1, 3 ) );
 *
 * const helper = new THREE.Box3Helper( box, 0xffff00 );
 * scene.add( helper )
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$ce39f4bb96c9a290 extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box3 helper.
	 *
	 * @param {Box3} box - The box to visualize.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setIndex(new $2358b7e4ec07df88$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The box being visualized.
		 *
		 * @type {Box3}
		 */ this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Plane}.
 *
 * ```js
 * const plane = new THREE.Plane( new THREE.Vector3( 1, 1, 0.2 ), 3 );
 * const helper = new THREE.PlaneHelper( plane, 1, 0xffff00 );
 * scene.add( helper );
 * ```
 *
 * @augments Line
 */ class $2358b7e4ec07df88$export$a34fe8156c66e5d7 extends $2358b7e4ec07df88$export$17d680238e50603e {
    /**
	 * Constructs a new plane helper.
	 *
	 * @param {Plane} plane - The plane to be visualized.
	 * @param {number} [size=1] - The side length of plane helper.
	 * @param {number|Color|string} [hex=0xffff00] - The helper's color.
	 */ constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        /**
		 * The plane being visualized.
		 *
		 * @type {Plane}
		 */ this.plane = plane;
        /**
		 * The side length of plane helper.
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $2358b7e4ec07df88$export$e176487c05830cc5(geometry2, new $2358b7e4ec07df88$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $2358b7e4ec07df88$var$_axis = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
let $2358b7e4ec07df88$var$_lineGeometry, $2358b7e4ec07df88$var$_coneGeometry;
/**
 * An 3D arrow object for visualizing directions.
 *
 * ```js
 * const dir = new THREE.Vector3( 1, 2, 0 );
 *
 * //normalize the direction vector (convert to vector of length 1)
 * dir.normalize();
 *
 * const origin = new THREE.Vector3( 0, 0, 0 );
 * const length = 1;
 * const hex = 0xffff00;
 *
 * const arrowHelper = new THREE.ArrowHelper( dir, origin, length, hex );
 * scene.add( arrowHelper );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$a3008e7bd8d2cbe7 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Vector3} [dir=(0, 0, 1)] - The (normalized) direction vector.
	 * @param {Vector3} [origin=(0, 0, 0)] - Point at which the arrow starts.
	 * @param {number} [length=1] - Length of the arrow in world units.
	 * @param {(number|Color|string)} [color=0xffff00] - Color of the arrow.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ constructor(dir = new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, 1), origin = new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($2358b7e4ec07df88$var$_lineGeometry === undefined) {
            $2358b7e4ec07df88$var$_lineGeometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
            $2358b7e4ec07df88$var$_lineGeometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $2358b7e4ec07df88$var$_coneGeometry = new $2358b7e4ec07df88$export$a7a48974f285c9b3(0.5, 1, 5, 1);
            $2358b7e4ec07df88$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        /**
		 * The line part of the arrow helper.
		 *
		 * @type {Line}
		 */ this.line = new $2358b7e4ec07df88$export$17d680238e50603e($2358b7e4ec07df88$var$_lineGeometry, new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        /**
		 * The cone part of the arrow helper.
		 *
		 * @type {Mesh}
		 */ this.cone = new $2358b7e4ec07df88$export$e176487c05830cc5($2358b7e4ec07df88$var$_coneGeometry, new $2358b7e4ec07df88$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    /**
	 * Sets the direction of the helper.
	 *
	 * @param {Vector3} dir - The normalized direction vector.
	 */ setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $2358b7e4ec07df88$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($2358b7e4ec07df88$var$_axis, radians);
        }
    }
    /**
	 * Sets the length of the helper.
	 *
	 * @param {number} length - Length of the arrow in world units.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    /**
	 * Sets the color of the helper.
	 *
	 * @param {number|Color|string} color - The color to set.
	 */ setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
/**
 * An axis object to visualize the 3 axes in a simple way.
 * The X axis is red. The Y axis is green. The Z axis is blue.
 *
 * ```js
 * const axesHelper = new THREE.AxesHelper( 5 );
 * scene.add( axesHelper );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$6c8303f35b8578fd extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new axes helper.
	 *
	 * @param {number} [size=1] - Size of the lines representing the axes.
	 */ constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$cbe7a62641830ebd(colors, 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    /**
	 * Defines the colors of the axes helper.
	 *
	 * @param {number|Color|string} xAxisColor - The color for the x axis.
	 * @param {number|Color|string} yAxisColor - The color for the y axis.
	 * @param {number|Color|string} zAxisColor - The color for the z axis.
	 * @return {AxesHelper} A reference to this axes helper.
	 */ setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $2358b7e4ec07df88$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This class is used to convert a series of paths to an array of
 * shapes. It is specifically used in context of fonts and SVG.
 */ class $2358b7e4ec07df88$export$148534a3c727230b {
    /**
	 * Constructs a new shape path.
	 */ constructor(){
        this.type = 'ShapePath';
        /**
		 * The color of the shape.
		 *
		 * @type {Color}
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e();
        /**
		 * The paths that have been generated for this shape.
		 *
		 * @type {Array<Path>}
		 * @default null
		 */ this.subPaths = [];
        /**
		 * The current path that is being generated.
		 *
		 * @type {?Path}
		 * @default null
		 */ this.currentPath = null;
    }
    /**
	 * Creates a new path and moves it current point to the given one.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {ShapePath} A reference to this shape path.
	 */ moveTo(x, y) {
        this.currentPath = new $2358b7e4ec07df88$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {ShapePath} A reference to this shape path.
	 */ splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    /**
	 * Converts the paths into an array of shapes.
	 *
	 * @param {boolean} isCCW - By default solid shapes are  defined clockwise (CW) and holes are defined counterclockwise (CCW).
	 * If this flag is set to `true`, then those are flipped.
	 * @return {Array<Shape>} An array of shapes.
	 */ toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $2358b7e4ec07df88$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $2358b7e4ec07df88$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $2358b7e4ec07df88$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $2358b7e4ec07df88$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //log("shape", shapes);
        return shapes;
    }
}
/**
 * Abstract base class for controls.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$c7c44baae9d9f25f extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLElement} domElement - The HTML element used for event listeners.
	 */ constructor(object, domElement = null){
        super();
        /**
		 * The object that is managed by the controls.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The HTML element used for event listeners.
		 *
		 * @type {?HTMLElement}
		 * @default null
		 */ this.domElement = domElement;
        /**
		 * Whether the controls responds to user input or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * The internal state of the controls.
		 *
		 * @type {number}
		 * @default -1
		 */ this.state = -1;
        /**
		 * This object defines the keyboard input of the controls.
		 *
		 * @type {Object}
		 */ this.keys = {};
        /**
		 * This object defines what type of actions are assigned to the available mouse buttons.
		 * It depends on the control implementation what kind of mouse buttons and actions are supported.
		 *
		 * @type {{LEFT: ?number, MIDDLE: ?number, RIGHT: ?number}}
		 */ this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        /**
		 * This object defines what type of actions are assigned to what kind of touch interaction.
		 * It depends on the control implementation what kind of touch interaction and actions are supported.
		 *
		 * @type {{ONE: ?number, TWO: ?number}}
		 */ this.touches = {
            ONE: null,
            TWO: null
        };
    }
    /**
	 * Connects the controls to the DOM. This method has so called "side effects" since
	 * it adds the module's event listeners to the DOM.
	 *
	 * @param {HTMLElement} element - The DOM element to connect to.
	 */ connect(element) {
        if (element === undefined) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Controls: connect() now requires an element.'); // @deprecated, the warning can be removed with r185
            return;
        }
        if (this.domElement !== null) this.disconnect();
        this.domElement = element;
    }
    /**
	 * Disconnects the controls from the DOM.
	 */ disconnect() {}
    /**
	 * Call this method if you no longer want use to the controls. It frees all internal
	 * resources and removes all event listeners.
	 */ dispose() {}
    /**
	 * Controls should implement this method if they have to update their internal state
	 * per simulation step.
	 *
	 * @param {number} [delta] - The time delta in seconds.
	 */ update() {}
}
/**
 * Scales the texture as large as possible within its surface without cropping
 * or stretching the texture. The method preserves the original aspect ratio of
 * the texture. Akin to CSS `object-fit: contain`
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $2358b7e4ec07df88$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
/**
 * Scales the texture to the smallest possible size to fill the surface, leaving
 * no empty space. The method preserves the original aspect ratio of the texture.
 * Akin to CSS `object-fit: cover`.
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $2358b7e4ec07df88$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
/**
 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
 *
 * @param {Texture} texture - The texture.
 * @return {Texture} The updated texture.
 */ function $2358b7e4ec07df88$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Determines how many bytes must be used to represent the texture.
 *
 * @param {number} width - The width of the texture.
 * @param {number} height - The height of the texture.
 * @param {number} format - The texture's format.
 * @param {number} type - The texture's type.
 * @return {number} The byte length.
 */ function $2358b7e4ec07df88$export$cc8c3b705bb8e6e2(width, height, format, type) {
    const typeByteLength = $2358b7e4ec07df88$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $2358b7e4ec07df88$export$988473390501ed4b:
            return width * height;
        case $2358b7e4ec07df88$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $2358b7e4ec07df88$export$21d1799c6d552fc0:
        case $2358b7e4ec07df88$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $2358b7e4ec07df88$export$d2a1a68024a3e56c:
        case $2358b7e4ec07df88$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $2358b7e4ec07df88$export$d0f0355bb3d948e4:
        case $2358b7e4ec07df88$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $2358b7e4ec07df88$export$19ada9bbb1af3573:
        case $2358b7e4ec07df88$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $2358b7e4ec07df88$export$6ab91af2d757aee7:
        case $2358b7e4ec07df88$export$7800993ef8106a6a:
        case $2358b7e4ec07df88$export$d5c566817123b2bf:
        case $2358b7e4ec07df88$export$f5668dc623297d86:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $2358b7e4ec07df88$export$23ed8300a860e7d8:
        case $2358b7e4ec07df88$export$e443ea3e1485f7bf:
        case $2358b7e4ec07df88$export$211402338cb75433:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $2358b7e4ec07df88$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $2358b7e4ec07df88$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $2358b7e4ec07df88$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $2358b7e4ec07df88$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $2358b7e4ec07df88$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $2358b7e4ec07df88$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $2358b7e4ec07df88$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $2358b7e4ec07df88$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $2358b7e4ec07df88$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $2358b7e4ec07df88$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $2358b7e4ec07df88$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $2358b7e4ec07df88$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $2358b7e4ec07df88$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $2358b7e4ec07df88$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $2358b7e4ec07df88$export$ce40b115e188bc81:
        case $2358b7e4ec07df88$export$d279c5c4bac5121e:
        case $2358b7e4ec07df88$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $2358b7e4ec07df88$export$b1688df4c4c21670:
        case $2358b7e4ec07df88$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $2358b7e4ec07df88$export$d220f6ade8463a0f:
        case $2358b7e4ec07df88$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $2358b7e4ec07df88$var$getTextureTypeByteLength(type) {
    switch(type){
        case $2358b7e4ec07df88$export$2e8ce08d3f6f5e10:
        case $2358b7e4ec07df88$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $2358b7e4ec07df88$export$c63dc51868b06a9d:
        case $2358b7e4ec07df88$export$88572337f312435f:
        case $2358b7e4ec07df88$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $2358b7e4ec07df88$export$b3969b01faf587f2:
        case $2358b7e4ec07df88$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $2358b7e4ec07df88$export$c3c7fc4518ebba96:
        case $2358b7e4ec07df88$export$5c612977753abe2:
        case $2358b7e4ec07df88$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $2358b7e4ec07df88$export$5a4c329b7e2092d3:
        case $2358b7e4ec07df88$export$f240f067f72abe41:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
/**
 * A class containing utility functions for textures.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$ec276d39f33d4b7 {
    /**
	 * Scales the texture as large as possible within its surface without cropping
	 * or stretching the texture. The method preserves the original aspect ratio of
	 * the texture. Akin to CSS `object-fit: contain`
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static contain(texture, aspect) {
        return $2358b7e4ec07df88$var$contain(texture, aspect);
    }
    /**
	 * Scales the texture to the smallest possible size to fill the surface, leaving
	 * no empty space. The method preserves the original aspect ratio of the texture.
	 * Akin to CSS `object-fit: cover`.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static cover(texture, aspect) {
        return $2358b7e4ec07df88$var$cover(texture, aspect);
    }
    /**
	 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {Texture} The updated texture.
	 */ static fill(texture) {
        return $2358b7e4ec07df88$var$fill(texture);
    }
    /**
	 * Determines how many bytes must be used to represent the texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} format - The texture's format.
	 * @param {number} type - The texture's type.
	 * @return {number} The byte length.
	 */ static getByteLength(width, height, format, type) {
        return $2358b7e4ec07df88$export$cc8c3b705bb8e6e2(width, height, format, type);
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $2358b7e4ec07df88$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) $2358b7e4ec07df88$export$c106dd0671a0fc2d('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $2358b7e4ec07df88$export$3545e07a80636437;
}

});

parcelRegister("iB18M", function(module, exports) {

$parcel$export(module.exports, "WebGPURenderer", () => $d89c9137a3d237c2$export$19fd8015bd4822d4);
$parcel$export(module.exports, "BufferGeometry", () => (parcelRequire("329ek")).BufferGeometry);
$parcel$export(module.exports, "Color", () => (parcelRequire("329ek")).Color);
$parcel$export(module.exports, "DoubleSide", () => (parcelRequire("329ek")).DoubleSide);
$parcel$export(module.exports, "Euler", () => (parcelRequire("329ek")).Euler);
$parcel$export(module.exports, "FileLoader", () => (parcelRequire("329ek")).FileLoader);
$parcel$export(module.exports, "FrontSide", () => (parcelRequire("329ek")).FrontSide);
$parcel$export(module.exports, "Group", () => (parcelRequire("329ek")).Group);
$parcel$export(module.exports, "HalfFloatType", () => (parcelRequire("329ek")).HalfFloatType);
$parcel$export(module.exports, "LineBasicMaterial", () => (parcelRequire("329ek")).LineBasicMaterial);
$parcel$export(module.exports, "Loader", () => (parcelRequire("329ek")).Loader);
$parcel$export(module.exports, "MathUtils", () => (parcelRequire("329ek")).MathUtils);
$parcel$export(module.exports, "Matrix4", () => (parcelRequire("329ek")).Matrix4);
$parcel$export(module.exports, "MeshBasicMaterial", () => (parcelRequire("329ek")).MeshBasicMaterial);
$parcel$export(module.exports, "MeshPhysicalMaterial", () => (parcelRequire("329ek")).MeshPhysicalMaterial);
$parcel$export(module.exports, "NeutralToneMapping", () => (parcelRequire("329ek")).NeutralToneMapping);
$parcel$export(module.exports, "NoColorSpace", () => (parcelRequire("329ek")).NoColorSpace);
$parcel$export(module.exports, "Object3D", () => (parcelRequire("329ek")).Object3D);
$parcel$export(module.exports, "Quaternion", () => (parcelRequire("329ek")).Quaternion);
$parcel$export(module.exports, "RGBAFormat", () => (parcelRequire("329ek")).RGBAFormat);
$parcel$export(module.exports, "RepeatWrapping", () => (parcelRequire("329ek")).RepeatWrapping);
$parcel$export(module.exports, "SRGBColorSpace", () => (parcelRequire("329ek")).SRGBColorSpace);
$parcel$export(module.exports, "Scene", () => (parcelRequire("329ek")).Scene);
$parcel$export(module.exports, "UnsignedByteType", () => (parcelRequire("329ek")).UnsignedByteType);
$parcel$export(module.exports, "Vector2", () => (parcelRequire("329ek")).Vector2);
$parcel$export(module.exports, "Vector3", () => (parcelRequire("329ek")).Vector3);
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
var $329ek = parcelRequire("329ek");
const $d89c9137a3d237c2$var$refreshUniforms = [
    'alphaMap',
    'alphaTest',
    'anisotropy',
    'anisotropyMap',
    'anisotropyRotation',
    'aoMap',
    'aoMapIntensity',
    'attenuationColor',
    'attenuationDistance',
    'bumpMap',
    'clearcoat',
    'clearcoatMap',
    'clearcoatNormalMap',
    'clearcoatNormalScale',
    'clearcoatRoughness',
    'color',
    'dispersion',
    'displacementMap',
    'emissive',
    'emissiveIntensity',
    'emissiveMap',
    'envMap',
    'envMapIntensity',
    'gradientMap',
    'ior',
    'iridescence',
    'iridescenceIOR',
    'iridescenceMap',
    'iridescenceThicknessMap',
    'lightMap',
    'lightMapIntensity',
    'map',
    'matcap',
    'metalness',
    'metalnessMap',
    'normalMap',
    'normalScale',
    'opacity',
    'roughness',
    'roughnessMap',
    'sheen',
    'sheenColor',
    'sheenColorMap',
    'sheenRoughnessMap',
    'shininess',
    'specular',
    'specularColor',
    'specularColorMap',
    'specularIntensity',
    'specularIntensityMap',
    'specularMap',
    'thickness',
    'transmission',
    'transmissionMap'
];
/**
 * A WeakMap to cache lights data for node materials.
 * Cache lights data by render ID to avoid unnecessary recalculations.
 *
 * @private
 * @type {WeakMap<LightsNode,Object>}
 */ const $d89c9137a3d237c2$var$_lightsCache = new WeakMap();
/**
 * This class is used by {@link WebGPURenderer} as management component.
 * It's primary purpose is to determine whether render objects require a
 * refresh right before they are going to be rendered or not.
 */ class $d89c9137a3d237c2$export$4f65c0b4ff530286 {
    /**
	 * Constructs a new node material observer.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 */ constructor(builder){
        /**
		 * A node material can be used by more than one render object so the
		 * monitor must maintain a list of render objects.
		 *
		 * @type {WeakMap<RenderObject,Object>}
		 */ this.renderObjects = new WeakMap();
        /**
		 * Whether the material uses node objects or not.
		 *
		 * @type {boolean}
		 */ this.hasNode = this.containsNode(builder);
        /**
		 * Whether the node builder's 3D object is animated or not.
		 *
		 * @type {boolean}
		 */ this.hasAnimation = builder.object.isSkinnedMesh === true;
        /**
		 * A list of all possible material uniforms
		 *
		 * @type {Array<string>}
		 */ this.refreshUniforms = $d89c9137a3d237c2$var$refreshUniforms;
        /**
		 * Holds the current render ID from the node frame.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderId = 0;
    }
    /**
	 * Returns `true` if the given render object is verified for the first time of this observer.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the given render object is verified for the first time of this observer.
	 */ firstInitialization(renderObject) {
        const hasInitialized = this.renderObjects.has(renderObject);
        if (hasInitialized === false) {
            this.getRenderObjectData(renderObject);
            return true;
        }
        return false;
    }
    /**
	 * Returns `true` if the current rendering produces motion vectors.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @return {boolean} Whether the current rendering produces motion vectors or not.
	 */ needsVelocity(renderer) {
        const mrt = renderer.getMRT();
        return mrt !== null && mrt.has('velocity');
    }
    /**
	 * Returns monitoring data for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {Object} The monitoring data.
	 */ getRenderObjectData(renderObject) {
        let data = this.renderObjects.get(renderObject);
        if (data === undefined) {
            const { geometry: geometry, material: material, object: object } = renderObject;
            data = {
                material: this.getMaterialData(material),
                geometry: {
                    id: geometry.id,
                    attributes: this.getAttributesData(geometry.attributes),
                    indexVersion: geometry.index ? geometry.index.version : null,
                    drawRange: {
                        start: geometry.drawRange.start,
                        count: geometry.drawRange.count
                    }
                },
                worldMatrix: object.matrixWorld.clone()
            };
            if (object.center) data.center = object.center.clone();
            if (object.morphTargetInfluences) data.morphTargetInfluences = object.morphTargetInfluences.slice();
            if (renderObject.bundle !== null) data.version = renderObject.bundle.version;
            if (data.material.transmission > 0) {
                const { width: width, height: height } = renderObject.context;
                data.bufferWidth = width;
                data.bufferHeight = height;
            }
            data.lights = this.getLightsData(renderObject.lightsNode.getLights());
            this.renderObjects.set(renderObject, data);
        }
        return data;
    }
    /**
	 * Returns an attribute data structure holding the attributes versions for
	 * monitoring.
	 *
	 * @param {Object} attributes - The geometry attributes.
	 * @return {Object} An object for monitoring the versions of attributes.
	 */ getAttributesData(attributes) {
        const attributesData = {};
        for(const name in attributes){
            const attribute = attributes[name];
            attributesData[name] = {
                version: attribute.version
            };
        }
        return attributesData;
    }
    /**
	 * Returns `true` if the node builder's material uses
	 * node properties.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {boolean} Whether the node builder's material uses node properties or not.
	 */ containsNode(builder) {
        const material = builder.material;
        for(const property in material){
            if (material[property] && material[property].isNode) return true;
        }
        if (builder.context.modelViewMatrix || builder.context.modelNormalViewMatrix || builder.context.getAO || builder.context.getShadow) return true;
        return false;
    }
    /**
	 * Returns a material data structure holding the material property values for
	 * monitoring.
	 *
	 * @param {Material} material - The material.
	 * @return {Object} An object for monitoring material properties.
	 */ getMaterialData(material) {
        const data = {};
        for (const property of this.refreshUniforms){
            const value = material[property];
            if (value === null || value === undefined) continue;
            if (typeof value === 'object' && value.clone !== undefined) {
                if (value.isTexture === true) data[property] = {
                    id: value.id,
                    version: value.version
                };
                else data[property] = value.clone();
            } else data[property] = value;
        }
        return data;
    }
    /**
	 * Returns `true` if the given render object has not changed its state.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Array<Light>} lightsData - The current material lights.
	 * @return {boolean} Whether the given render object has changed its state or not.
	 */ equals(renderObject, lightsData) {
        const { object: object, material: material, geometry: geometry } = renderObject;
        const renderObjectData = this.getRenderObjectData(renderObject);
        // world matrix
        if (renderObjectData.worldMatrix.equals(object.matrixWorld) !== true) {
            renderObjectData.worldMatrix.copy(object.matrixWorld);
            return false;
        }
        // material
        const materialData = renderObjectData.material;
        for(const property in materialData){
            const value = materialData[property];
            const mtlValue = material[property];
            if (value.equals !== undefined) {
                if (value.equals(mtlValue) === false) {
                    value.copy(mtlValue);
                    return false;
                }
            } else if (mtlValue.isTexture === true) {
                if (value.id !== mtlValue.id || value.version !== mtlValue.version) {
                    value.id = mtlValue.id;
                    value.version = mtlValue.version;
                    return false;
                }
            } else if (value !== mtlValue) {
                materialData[property] = mtlValue;
                return false;
            }
        }
        if (materialData.transmission > 0) {
            const { width: width, height: height } = renderObject.context;
            if (renderObjectData.bufferWidth !== width || renderObjectData.bufferHeight !== height) {
                renderObjectData.bufferWidth = width;
                renderObjectData.bufferHeight = height;
                return false;
            }
        }
        // geometry
        const storedGeometryData = renderObjectData.geometry;
        const attributes = geometry.attributes;
        const storedAttributes = storedGeometryData.attributes;
        const storedAttributeNames = Object.keys(storedAttributes);
        const currentAttributeNames = Object.keys(attributes);
        if (storedGeometryData.id !== geometry.id) {
            storedGeometryData.id = geometry.id;
            return false;
        }
        if (storedAttributeNames.length !== currentAttributeNames.length) {
            renderObjectData.geometry.attributes = this.getAttributesData(attributes);
            return false;
        }
        // compare each attribute
        for (const name of storedAttributeNames){
            const storedAttributeData = storedAttributes[name];
            const attribute = attributes[name];
            if (attribute === undefined) {
                // attribute was removed
                delete storedAttributes[name];
                return false;
            }
            if (storedAttributeData.version !== attribute.version) {
                storedAttributeData.version = attribute.version;
                return false;
            }
        }
        // check index
        const index = geometry.index;
        const storedIndexVersion = storedGeometryData.indexVersion;
        const currentIndexVersion = index ? index.version : null;
        if (storedIndexVersion !== currentIndexVersion) {
            storedGeometryData.indexVersion = currentIndexVersion;
            return false;
        }
        // check drawRange
        if (storedGeometryData.drawRange.start !== geometry.drawRange.start || storedGeometryData.drawRange.count !== geometry.drawRange.count) {
            storedGeometryData.drawRange.start = geometry.drawRange.start;
            storedGeometryData.drawRange.count = geometry.drawRange.count;
            return false;
        }
        // morph targets
        if (renderObjectData.morphTargetInfluences) {
            let morphChanged = false;
            for(let i = 0; i < renderObjectData.morphTargetInfluences.length; i++)if (renderObjectData.morphTargetInfluences[i] !== object.morphTargetInfluences[i]) {
                renderObjectData.morphTargetInfluences[i] = object.morphTargetInfluences[i];
                morphChanged = true;
            }
            if (morphChanged) return false;
        }
        // lights
        if (renderObjectData.lights) for(let i = 0; i < lightsData.length; i++){
            if (renderObjectData.lights[i].map !== lightsData[i].map) return false;
        }
        // center
        if (renderObjectData.center) {
            if (renderObjectData.center.equals(object.center) === false) {
                renderObjectData.center.copy(object.center);
                return true;
            }
        }
        // bundle
        if (renderObject.bundle !== null) renderObjectData.version = renderObject.bundle.version;
        return true;
    }
    /**
	 * Returns the lights data for the given material lights.
	 *
	 * @param {Array<Light>} materialLights - The material lights.
	 * @return {Array<Object>} The lights data for the given material lights.
	 */ getLightsData(materialLights) {
        const lights = [];
        for (const light of materialLights)if (light.isSpotLight === true && light.map !== null) // only add lights that have a map
        lights.push({
            map: light.map.version
        });
        return lights;
    }
    /**
	 * Returns the lights for the given lights node and render ID.
	 *
	 * @param {LightsNode} lightsNode - The lights node.
	 * @param {number} renderId - The render ID.
	 * @return {Array<Object>} The lights for the given lights node and render ID.
	 */ getLights(lightsNode, renderId) {
        if ($d89c9137a3d237c2$var$_lightsCache.has(lightsNode)) {
            const cached = $d89c9137a3d237c2$var$_lightsCache.get(lightsNode);
            if (cached.renderId === renderId) return cached.lightsData;
        }
        const lightsData = this.getLightsData(lightsNode.getLights());
        $d89c9137a3d237c2$var$_lightsCache.set(lightsNode, {
            renderId: renderId,
            lightsData: lightsData
        });
        return lightsData;
    }
    /**
	 * Checks if the given render object requires a refresh.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {NodeFrame} nodeFrame - The current node frame.
	 * @return {boolean} Whether the given render object requires a refresh or not.
	 */ needsRefresh(renderObject, nodeFrame) {
        if (this.hasNode || this.hasAnimation || this.firstInitialization(renderObject) || this.needsVelocity(nodeFrame.renderer)) return true;
        const { renderId: renderId } = nodeFrame;
        if (this.renderId !== renderId) {
            this.renderId = renderId;
            return true;
        }
        const isStatic = renderObject.object.static === true;
        const isBundle = renderObject.bundle !== null && renderObject.bundle.static === true && this.getRenderObjectData(renderObject).version === renderObject.bundle.version;
        if (isStatic || isBundle) return false;
        const lightsData = this.getLights(renderObject.lightsNode, renderId);
        const notEqual = this.equals(renderObject, lightsData) !== true;
        return notEqual;
    }
}
// cyrb53 (c) 2018 bryc (github.com/bryc). License: Public domain. Attribution appreciated.
// A fast and simple 64-bit (or 53-bit) string hash function with decent collision resistance.
// Largely inspired by MurmurHash2/3, but with a focus on speed/simplicity.
// See https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript/52171480#52171480
// https://github.com/bryc/code/blob/master/jshash/experimental/cyrb53.js
function $d89c9137a3d237c2$var$cyrb53(value, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    if (value instanceof Array) for(let i = 0, val; i < value.length; i++){
        val = value[i];
        h1 = Math.imul(h1 ^ val, 2654435761);
        h2 = Math.imul(h2 ^ val, 1597334677);
    }
    else for(let i = 0, ch; i < value.length; i++){
        ch = value.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
    h1 ^= Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
    h2 ^= Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
/**
 * Computes a hash for the given string.
 *
 * @private
 * @method
 * @param {string} str - The string to be hashed.
 * @return {number} The hash.
 */ const $d89c9137a3d237c2$var$hashString = (str)=>$d89c9137a3d237c2$var$cyrb53(str);
/**
 * Computes a hash for the given array.
 *
 * @private
 * @method
 * @param {Array<number>} array - The array to be hashed.
 * @return {number} The hash.
 */ const $d89c9137a3d237c2$var$hashArray = (array)=>$d89c9137a3d237c2$var$cyrb53(array);
/**
 * Computes a hash for the given list of parameters.
 *
 * @private
 * @method
 * @param {...number} params - A list of parameters.
 * @return {number} The hash.
 */ const $d89c9137a3d237c2$var$hash$1 = (...params)=>$d89c9137a3d237c2$var$cyrb53(params);
const $d89c9137a3d237c2$var$typeFromLength = /*@__PURE__*/ new Map([
    [
        1,
        'float'
    ],
    [
        2,
        'vec2'
    ],
    [
        3,
        'vec3'
    ],
    [
        4,
        'vec4'
    ],
    [
        9,
        'mat3'
    ],
    [
        16,
        'mat4'
    ]
]);
const $d89c9137a3d237c2$var$dataFromObject = /*@__PURE__*/ new WeakMap();
/**
 * Returns the data type for the given the length.
 *
 * @private
 * @method
 * @param {number} length - The length.
 * @return {string} The data type.
 */ function $d89c9137a3d237c2$var$getTypeFromLength(length) {
    return $d89c9137a3d237c2$var$typeFromLength.get(length);
}
/**
 * Returns the typed array for the given data type.
 *
 * @private
 * @method
 * @param {string} type - The data type.
 * @return {TypedArray} The typed array.
 */ function $d89c9137a3d237c2$var$getTypedArrayFromType(type) {
    // Handle component type for vectors and matrices
    if (/[iu]?vec\d/.test(type)) {
        // Handle int vectors
        if (type.startsWith('ivec')) return Int32Array;
        // Handle uint vectors
        if (type.startsWith('uvec')) return Uint32Array;
        // Default to float vectors
        return Float32Array;
    }
    // Handle matrices (always float)
    if (/mat\d/.test(type)) return Float32Array;
    // Basic types
    if (/float/.test(type)) return Float32Array;
    if (/uint/.test(type)) return Uint32Array;
    if (/int/.test(type)) return Int32Array;
    throw new Error(`THREE.NodeUtils: Unsupported type: ${type}`);
}
/**
 * Returns the length for the given data type.
 *
 * @private
 * @method
 * @param {string} type - The data type.
 * @return {number} The length.
 */ function $d89c9137a3d237c2$var$getLengthFromType(type) {
    if (/float|int|uint/.test(type)) return 1;
    if (/vec2/.test(type)) return 2;
    if (/vec3/.test(type)) return 3;
    if (/vec4/.test(type)) return 4;
    if (/mat2/.test(type)) return 4;
    if (/mat3/.test(type)) return 9;
    if (/mat4/.test(type)) return 16;
    (0, $329ek.error)('TSL: Unsupported type:', type);
}
/**
 * Returns the gpu memory length for the given data type.
 *
 * @private
 * @method
 * @param {string} type - The data type.
 * @return {number} The length.
 */ function $d89c9137a3d237c2$var$getMemoryLengthFromType(type) {
    if (/float|int|uint/.test(type)) return 1;
    if (/vec2/.test(type)) return 2;
    if (/vec3/.test(type)) return 3;
    if (/vec4/.test(type)) return 4;
    if (/mat2/.test(type)) return 4;
    if (/mat3/.test(type)) return 12;
    if (/mat4/.test(type)) return 16;
    (0, $329ek.error)('TSL: Unsupported type:', type);
}
/**
 * Returns the alignment requirement for the given data type.
 *
 * @private
 * @method
 * @param {string} type - The data type.
 * @return {number} The alignment requirement in bytes.
 */ function $d89c9137a3d237c2$var$getAlignmentFromType(type) {
    if (/float|int|uint/.test(type)) return 4;
    if (/vec2/.test(type)) return 8;
    if (/vec3/.test(type)) return 16;
    if (/vec4/.test(type)) return 16;
    if (/mat2/.test(type)) return 8;
    if (/mat3/.test(type)) return 16;
    if (/mat4/.test(type)) return 16;
    (0, $329ek.error)('TSL: Unsupported type:', type);
}
/**
 * Returns the data type for the given value.
 *
 * @private
 * @method
 * @param {any} value - The value.
 * @return {?string} The data type.
 */ function $d89c9137a3d237c2$var$getValueType(value) {
    if (value === undefined || value === null) return null;
    const typeOf = typeof value;
    if (value.isNode === true) return 'node';
    else if (typeOf === 'number') return 'float';
    else if (typeOf === 'boolean') return 'bool';
    else if (typeOf === 'string') return 'string';
    else if (typeOf === 'function') return 'shader';
    else if (value.isVector2 === true) return 'vec2';
    else if (value.isVector3 === true) return 'vec3';
    else if (value.isVector4 === true) return 'vec4';
    else if (value.isMatrix2 === true) return 'mat2';
    else if (value.isMatrix3 === true) return 'mat3';
    else if (value.isMatrix4 === true) return 'mat4';
    else if (value.isColor === true) return 'color';
    else if (value instanceof ArrayBuffer) return 'ArrayBuffer';
    return null;
}
/**
 * Returns the value/object for the given data type and parameters.
 *
 * @private
 * @method
 * @param {string} type - The given type.
 * @param {...any} params - A parameter list.
 * @return {any} The value/object.
 */ function $d89c9137a3d237c2$var$getValueFromType(type, ...params) {
    const last4 = type ? type.slice(-4) : undefined;
    if (params.length === 1) {
        if (last4 === 'vec2') params = [
            params[0],
            params[0]
        ];
        else if (last4 === 'vec3') params = [
            params[0],
            params[0],
            params[0]
        ];
        else if (last4 === 'vec4') params = [
            params[0],
            params[0],
            params[0],
            params[0]
        ];
    }
    if (type === 'color') return new (0, $329ek.Color)(...params);
    else if (last4 === 'vec2') return new (0, $329ek.Vector2)(...params);
    else if (last4 === 'vec3') return new (0, $329ek.Vector3)(...params);
    else if (last4 === 'vec4') return new (0, $329ek.Vector4)(...params);
    else if (last4 === 'mat2') return new (0, $329ek.Matrix2)(...params);
    else if (last4 === 'mat3') return new (0, $329ek.Matrix3)(...params);
    else if (last4 === 'mat4') return new (0, $329ek.Matrix4)(...params);
    else if (type === 'bool') return params[0] || false;
    else if (type === 'float' || type === 'int' || type === 'uint') return params[0] || 0;
    else if (type === 'string') return params[0] || '';
    else if (type === 'ArrayBuffer') return $d89c9137a3d237c2$var$base64ToArrayBuffer(params[0]);
    return null;
}
/**
 * Gets the object data that can be shared between different rendering steps.
 *
 * @private
 * @param {Object} object - The object to get the data for.
 * @return {Object} The object data.
 */ function $d89c9137a3d237c2$var$getDataFromObject(object) {
    let data = $d89c9137a3d237c2$var$dataFromObject.get(object);
    if (data === undefined) {
        data = {};
        $d89c9137a3d237c2$var$dataFromObject.set(object, data);
    }
    return data;
}
/**
 * Converts the given array buffer to a Base64 string.
 *
 * @private
 * @method
 * @param {ArrayBuffer} arrayBuffer - The array buffer.
 * @return {string} The Base64 string.
 */ function $d89c9137a3d237c2$var$arrayBufferToBase64(arrayBuffer) {
    let chars = '';
    const array = new Uint8Array(arrayBuffer);
    for(let i = 0; i < array.length; i++)chars += String.fromCharCode(array[i]);
    return btoa(chars);
}
/**
 * Converts the given Base64 string to an array buffer.
 *
 * @private
 * @method
 * @param {string} base64 - The Base64 string.
 * @return {ArrayBuffer} The array buffer.
 */ function $d89c9137a3d237c2$var$base64ToArrayBuffer(base64) {
    return Uint8Array.from(atob(base64), (c)=>c.charCodeAt(0)).buffer;
}
var $d89c9137a3d237c2$export$78670c1cacf147e6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    arrayBufferToBase64: $d89c9137a3d237c2$var$arrayBufferToBase64,
    base64ToArrayBuffer: $d89c9137a3d237c2$var$base64ToArrayBuffer,
    getAlignmentFromType: $d89c9137a3d237c2$var$getAlignmentFromType,
    getDataFromObject: $d89c9137a3d237c2$var$getDataFromObject,
    getLengthFromType: $d89c9137a3d237c2$var$getLengthFromType,
    getMemoryLengthFromType: $d89c9137a3d237c2$var$getMemoryLengthFromType,
    getTypeFromLength: $d89c9137a3d237c2$var$getTypeFromLength,
    getTypedArrayFromType: $d89c9137a3d237c2$var$getTypedArrayFromType,
    getValueFromType: $d89c9137a3d237c2$var$getValueFromType,
    getValueType: $d89c9137a3d237c2$var$getValueType,
    hash: $d89c9137a3d237c2$var$hash$1,
    hashArray: $d89c9137a3d237c2$var$hashArray,
    hashString: $d89c9137a3d237c2$var$hashString
});
/**
 * Possible shader stages.
 *
 * @property {string} VERTEX The vertex shader stage.
 * @property {string} FRAGMENT The fragment shader stage.
 */ const $d89c9137a3d237c2$export$9e43649cde3e3072 = {
    VERTEX: 'vertex',
    FRAGMENT: 'fragment'
};
/**
 * Update types of a node.
 *
 * @property {string} NONE The update method is not executed.
 * @property {string} FRAME The update method is executed per frame.
 * @property {string} RENDER The update method is executed per render. A frame might be produced by multiple render calls so this value allows more detailed updates than FRAME.
 * @property {string} OBJECT The update method is executed per {@link Object3D} that uses the node for rendering.
 */ const $d89c9137a3d237c2$export$26f7a8bbd9469530 = {
    NONE: 'none',
    FRAME: 'frame',
    RENDER: 'render',
    OBJECT: 'object'
};
/**
 * Data types of a node.
 *
 * @property {string} BOOLEAN Boolean type.
 * @property {string} INTEGER Integer type.
 * @property {string} FLOAT Float type.
 * @property {string} VECTOR2 Two-dimensional vector type.
 * @property {string} VECTOR3 Three-dimensional vector type.
 * @property {string} VECTOR4 Four-dimensional vector type.
 * @property {string} MATRIX2 2x2 matrix type.
 * @property {string} MATRIX3 3x3 matrix type.
 * @property {string} MATRIX4 4x4 matrix type.
 */ const $d89c9137a3d237c2$export$f06e977173f1857c = {
    BOOLEAN: 'bool',
    INTEGER: 'int',
    FLOAT: 'float',
    VECTOR2: 'vec2',
    VECTOR3: 'vec3',
    VECTOR4: 'vec4',
    MATRIX2: 'mat2',
    MATRIX3: 'mat3',
    MATRIX4: 'mat4'
};
/**
 * Access types of a node. These are relevant for compute and storage usage.
 *
 * @property {string} READ_ONLY Read-only access
 * @property {string} WRITE_ONLY Write-only access.
 * @property {string} READ_WRITE Read and write access.
 */ const $d89c9137a3d237c2$export$92538c74c63a703d = {
    READ_ONLY: 'readOnly',
    WRITE_ONLY: 'writeOnly',
    READ_WRITE: 'readWrite'
};
const $d89c9137a3d237c2$export$565139d2263e2965 = [
    'fragment',
    'vertex'
];
const $d89c9137a3d237c2$export$f2213ed98eb895d6 = [
    'setup',
    'analyze',
    'generate'
];
const $d89c9137a3d237c2$export$48fd793f0255b86a = [
    ...$d89c9137a3d237c2$export$565139d2263e2965,
    'compute'
];
const $d89c9137a3d237c2$export$1c0adcb9073b646d = [
    'x',
    'y',
    'z',
    'w'
];
const $d89c9137a3d237c2$var$_parentBuildStage = {
    analyze: 'setup',
    generate: 'analyze'
};
let $d89c9137a3d237c2$var$_nodeId = 0;
/**
 * Base class for all nodes.
 *
 * @augments EventDispatcher
 */ class $d89c9137a3d237c2$export$85c928794f8d04d4 extends (0, $329ek.EventDispatcher) {
    static get type() {
        return 'Node';
    }
    /**
	 * Constructs a new node.
	 *
	 * @param {?string} nodeType - The node type.
	 */ constructor(nodeType = null){
        super();
        /**
		 * The node type. This represents the result type of the node (e.g. `float` or `vec3`).
		 *
		 * @type {?string}
		 * @default null
		 */ this.nodeType = nodeType;
        /**
		 * The update type of the node's {@link Node#update} method. Possible values are listed in {@link NodeUpdateType}.
		 *
		 * @type {string}
		 * @default 'none'
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.NONE;
        /**
		 * The update type of the node's {@link Node#updateBefore} method. Possible values are listed in {@link NodeUpdateType}.
		 *
		 * @type {string}
		 * @default 'none'
		 */ this.updateBeforeType = $d89c9137a3d237c2$export$26f7a8bbd9469530.NONE;
        /**
		 * The update type of the node's {@link Node#updateAfter} method. Possible values are listed in {@link NodeUpdateType}.
		 *
		 * @type {string}
		 * @default 'none'
		 */ this.updateAfterType = $d89c9137a3d237c2$export$26f7a8bbd9469530.NONE;
        /**
		 * The UUID of the node.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = (0, $329ek.MathUtils).generateUUID();
        /**
		 * The version of the node. The version automatically is increased when {@link Node#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        /**
		 * The name of the node.
		 *
		 * @type {string}
		 * @default ''
		 */ this.name = '';
        /**
		 * Whether this node is global or not. This property is relevant for the internal
		 * node caching system. All nodes which should be declared just once should
		 * set this flag to `true` (a typical example is {@link AttributeNode}).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.global = false;
        /**
		 * Create a list of parents for this node during the build process.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.parents = false;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNode = true;
        // private
        this._beforeNodes = null;
        /**
		 * The cache key of this node.
		 *
		 * @private
		 * @type {?number}
		 * @default null
		 */ this._cacheKey = null;
        /**
		 * The cache key 's version.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._cacheKeyVersion = 0;
        Object.defineProperty(this, 'id', {
            value: $d89c9137a3d237c2$var$_nodeId++
        });
    }
    /**
	 * Set this property to `true` when the node should be regenerated.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * The type of the class. The value is usually the constructor name.
	 *
	 * @type {string}
 	 * @readonly
	 */ get type() {
        return this.constructor.type;
    }
    /**
	 * Convenient method for defining {@link Node#update}.
	 *
	 * @param {Function} callback - The update method.
	 * @param {string} updateType - The update type.
	 * @return {Node} A reference to this node.
	 */ onUpdate(callback, updateType) {
        this.updateType = updateType;
        this.update = callback.bind(this);
        return this;
    }
    /**
	 * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
	 * this method automatically sets the update type to `FRAME`.
	 *
	 * @param {Function} callback - The update method.
	 * @return {Node} A reference to this node.
	 */ onFrameUpdate(callback) {
        return this.onUpdate(callback, $d89c9137a3d237c2$export$26f7a8bbd9469530.FRAME);
    }
    /**
	 * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
	 * this method automatically sets the update type to `RENDER`.
	 *
	 * @param {Function} callback - The update method.
	 * @return {Node} A reference to this node.
	 */ onRenderUpdate(callback) {
        return this.onUpdate(callback, $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER);
    }
    /**
	 * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
	 * this method automatically sets the update type to `OBJECT`.
	 *
	 * @param {Function} callback - The update method.
	 * @return {Node} A reference to this node.
	 */ onObjectUpdate(callback) {
        return this.onUpdate(callback, $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT);
    }
    /**
	 * Convenient method for defining {@link Node#updateReference}.
	 *
	 * @param {Function} callback - The update method.
	 * @return {Node} A reference to this node.
	 */ onReference(callback) {
        this.updateReference = callback.bind(this);
        return this;
    }
    /**
	 * Nodes might refer to other objects like materials. This method allows to dynamically update the reference
	 * to such objects based on a given state (e.g. the current node frame or builder).
	 *
	 * @param {any} state - This method can be invocated in different contexts so `state` can refer to any object type.
	 * @return {any} The updated reference.
	 */ updateReference() {
        return this;
    }
    /**
	 * By default this method returns the value of the {@link Node#global} flag. This method
	 * can be overwritten in derived classes if an analytical way is required to determine the
	 * global cache referring to the current shader-stage.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {boolean} Whether this node is global or not.
	 */ isGlobal() {
        return this.global;
    }
    /**
	 * Generator function that can be used to iterate over the child nodes.
	 *
	 * @generator
	 * @yields {Node} A child node.
	 */ *getChildren() {
        for (const { childNode: childNode } of this._getChildren())yield childNode;
    }
    /**
	 * Calling this method dispatches the `dispose` event. This event can be used
	 * to register event listeners for clean up tasks.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Callback for {@link Node#traverse}.
	 *
	 * @callback traverseCallback
	 * @param {Node} node - The current node.
	 */ /**
	 * Can be used to traverse through the node's hierarchy.
	 *
	 * @param {traverseCallback} callback - A callback that is executed per node.
	 */ traverse(callback) {
        callback(this);
        for (const childNode of this.getChildren())childNode.traverse(callback);
    }
    /**
	 * Returns the child nodes of this node.
	 *
	 * @private
	 * @param {Set<Node>} [ignores=new Set()] - A set of nodes to ignore during the search to avoid circular references.
	 * @returns {Array<Object>} An array of objects describing the child nodes.
	 */ _getChildren(ignores = new Set()) {
        const children = [];
        // avoid circular references
        ignores.add(this);
        for (const property of Object.getOwnPropertyNames(this)){
            const object = this[property];
            // Ignore private properties and ignored nodes.
            if (property.startsWith('_') === true || ignores.has(object)) continue;
            if (Array.isArray(object) === true) for(let i = 0; i < object.length; i++){
                const child = object[i];
                if (child && child.isNode === true) children.push({
                    property: property,
                    index: i,
                    childNode: child
                });
            }
            else if (object && object.isNode === true) children.push({
                property: property,
                childNode: object
            });
            else if (object && Object.getPrototypeOf(object) === Object.prototype) for(const subProperty in object){
                // Ignore private sub-properties.
                if (subProperty.startsWith('_') === true) continue;
                const child = object[subProperty];
                if (child && child.isNode === true) children.push({
                    property: property,
                    index: subProperty,
                    childNode: child
                });
            }
        }
        //
        return children;
    }
    /**
	 * Returns the cache key for this node.
	 *
	 * @param {boolean} [force=false] - When set to `true`, a recomputation of the cache key is forced.
	 * @param {Set<Node>} [ignores=null] - A set of nodes to ignore during the computation of the cache key.
	 * @return {number} The cache key of the node.
	 */ getCacheKey(force = false, ignores = null) {
        force = force || this.version !== this._cacheKeyVersion;
        if (force === true || this._cacheKey === null) {
            if (ignores === null) ignores = new Set();
            //
            const values = [];
            for (const { property: property, childNode: childNode } of this._getChildren(ignores))values.push($d89c9137a3d237c2$var$hashString(property.slice(0, -4)), childNode.getCacheKey(force, ignores));
            //
            this._cacheKey = $d89c9137a3d237c2$var$hash$1($d89c9137a3d237c2$var$hashArray(values), this.customCacheKey());
            this._cacheKeyVersion = this.version;
        }
        return this._cacheKey;
    }
    /**
	 * Generate a custom cache key for this node.
	 *
	 * @return {number} The cache key of the node.
	 */ customCacheKey() {
        return this.id;
    }
    /**
	 * Returns the references to this node which is by default `this`.
	 *
	 * @return {Node} A reference to this node.
	 */ getScope() {
        return this;
    }
    /**
	 * Returns the hash of the node which is used to identify the node. By default it's
	 * the {@link Node#uuid} however derived node classes might have to overwrite this method
	 * depending on their implementation.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The hash.
	 */ getHash() {
        return this.uuid;
    }
    /**
	 * Returns the update type of {@link Node#update}.
	 *
	 * @return {NodeUpdateType} The update type.
	 */ getUpdateType() {
        return this.updateType;
    }
    /**
	 * Returns the update type of {@link Node#updateBefore}.
	 *
	 * @return {NodeUpdateType} The update type.
	 */ getUpdateBeforeType() {
        return this.updateBeforeType;
    }
    /**
	 * Returns the update type of {@link Node#updateAfter}.
	 *
	 * @return {NodeUpdateType} The update type.
	 */ getUpdateAfterType() {
        return this.updateAfterType;
    }
    /**
	 * Certain types are composed of multiple elements. For example a `vec3`
	 * is composed of three `float` values. This method returns the type of
	 * these elements.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The type of the node.
	 */ getElementType(builder) {
        const type = this.getNodeType(builder);
        const elementType = builder.getElementType(type);
        return elementType;
    }
    /**
	 * Returns the node member type for the given name.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The name of the member.
	 * @return {string} The type of the node.
	 */ getMemberType() {
        return 'void';
    }
    /**
	 * Returns the node's type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The type of the node.
	 */ getNodeType(builder) {
        const nodeProperties = builder.getNodeProperties(this);
        if (nodeProperties.outputNode) return nodeProperties.outputNode.getNodeType(builder);
        return this.nodeType;
    }
    /**
	 * This method is used during the build process of a node and ensures
	 * equal nodes are not built multiple times but just once. For example if
	 * `attribute( 'uv' )` is used multiple times by the user, the build
	 * process makes sure to process just the first node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node} The shared node if possible. Otherwise `this` is returned.
	 */ getShared(builder) {
        const hash = this.getHash(builder);
        const nodeFromHash = builder.getNodeFromHash(hash);
        return nodeFromHash || this;
    }
    /**
	 * Returns the number of elements in the node array.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?number} The number of elements in the node array.
	 */ getArrayCount() {
        return null;
    }
    /**
	 * Represents the setup stage which is the first step of the build process, see {@link Node#build} method.
	 * This method is often overwritten in derived modules to prepare the node which is used as a node's output/result.
	 * If an output node is prepared, then it must be returned in the `return` statement of the derived module's setup function.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?Node} The output node.
	 */ setup(builder) {
        const nodeProperties = builder.getNodeProperties(this);
        let index = 0;
        for (const childNode of this.getChildren())nodeProperties['node' + index++] = childNode;
        // return a outputNode if exists or null
        return nodeProperties.outputNode || null;
    }
    /**
	 * Represents the analyze stage which is the second step of the build process, see {@link Node#build} method.
	 * This stage analyzes the node hierarchy and ensures descendent nodes are built.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {?Node} output - The target output node.
	 */ analyze(builder, output = null) {
        const usageCount = builder.increaseUsage(this);
        if (this.parents === true) {
            const nodeData = builder.getDataFromNode(this, 'any');
            nodeData.stages = nodeData.stages || {};
            nodeData.stages[builder.shaderStage] = nodeData.stages[builder.shaderStage] || [];
            nodeData.stages[builder.shaderStage].push(output);
        }
        if (usageCount === 1) {
            // node flow children
            const nodeProperties = builder.getNodeProperties(this);
            for (const childNode of Object.values(nodeProperties))if (childNode && childNode.isNode === true) childNode.build(builder, this);
        }
    }
    /**
	 * Represents the generate stage which is the third step of the build process, see {@link Node#build} method.
	 * This state builds the output node and returns the resulting shader string.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {?string} [output] - Can be used to define the output type.
	 * @return {?string} The generated shader string.
	 */ generate(builder, output) {
        const { outputNode: outputNode } = builder.getNodeProperties(this);
        if (outputNode && outputNode.isNode === true) return outputNode.build(builder, output);
    }
    /**
	 * The method can be implemented to update the node's internal state before it is used to render an object.
	 * The {@link Node#updateBeforeType} property defines how often the update is executed.
	 *
	 * @abstract
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
	 */ updateBefore() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * The method can be implemented to update the node's internal state after it was used to render an object.
	 * The {@link Node#updateAfterType} property defines how often the update is executed.
	 *
	 * @abstract
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
	 */ updateAfter() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * The method can be implemented to update the node's internal state when it is used to render an object.
	 * The {@link Node#updateType} property defines how often the update is executed.
	 *
	 * @abstract
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
	 */ update() {
        (0, $329ek.warn)('Abstract function.');
    }
    before(node) {
        if (this._beforeNodes === null) this._beforeNodes = [];
        this._beforeNodes.push(node);
        return this;
    }
    /**
	 * This method performs the build of a node. The behavior and return value depend on the current build stage:
	 * - **setup**: Prepares the node and its children for the build process. This process can also create new nodes. Returns the node itself or a variant.
	 * - **analyze**: Analyzes the node hierarchy for optimizations in the code generation stage. Returns `null`.
	 * - **generate**: Generates the shader code for the node. Returns the generated shader string.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {?(string|Node)} [output=null] - Can be used to define the output type.
	 * @return {?(Node|string)} The result of the build process, depending on the build stage.
	 */ build(builder, output = null) {
        const refNode = this.getShared(builder);
        if (this !== refNode) return refNode.build(builder, output);
        //
        if (this._beforeNodes !== null) {
            const currentBeforeNodes = this._beforeNodes;
            this._beforeNodes = null;
            for (const beforeNode of currentBeforeNodes)beforeNode.build(builder, output);
            this._beforeNodes = currentBeforeNodes;
        }
        //
        const nodeData = builder.getDataFromNode(this);
        nodeData.buildStages = nodeData.buildStages || {};
        nodeData.buildStages[builder.buildStage] = true;
        const parentBuildStage = $d89c9137a3d237c2$var$_parentBuildStage[builder.buildStage];
        if (parentBuildStage && nodeData.buildStages[parentBuildStage] !== true) {
            // force parent build stage (setup or analyze)
            const previousBuildStage = builder.getBuildStage();
            builder.setBuildStage(parentBuildStage);
            this.build(builder);
            builder.setBuildStage(previousBuildStage);
        }
        //
        builder.addNode(this);
        builder.addChain(this);
        /* Build stages expected results:
			- "setup"		-> Node
			- "analyze"		-> null
			- "generate"	-> String
		*/ let result = null;
        const buildStage = builder.getBuildStage();
        if (buildStage === 'setup') {
            this.updateReference(builder);
            const properties = builder.getNodeProperties(this);
            if (properties.initialized !== true) {
                //const stackNodesBeforeSetup = builder.stack.nodes.length;
                properties.initialized = true;
                properties.outputNode = this.setup(builder) || properties.outputNode || null;
                /*if ( isNodeOutput && builder.stack.nodes.length !== stackNodesBeforeSetup ) {

					// !! no outputNode !!
					//outputNode = builder.stack;

				}*/ for (const childNode of Object.values(properties))if (childNode && childNode.isNode === true) {
                    if (childNode.parents === true) {
                        const childProperties = builder.getNodeProperties(childNode);
                        childProperties.parents = childProperties.parents || [];
                        childProperties.parents.push(this);
                    }
                    childNode.build(builder);
                }
            }
            result = properties.outputNode;
        } else if (buildStage === 'analyze') this.analyze(builder, output);
        else if (buildStage === 'generate') {
            // If generate has just one argument, it means the output type is not required.
            // This means that the node does not handle output conversions internally,
            // so the value is stored in a cache and the builder handles the conversion
            // for all requested output types.
            const isGenerateOnce = this.generate.length < 2;
            if (isGenerateOnce) {
                const type = this.getNodeType(builder);
                const nodeData = builder.getDataFromNode(this);
                result = nodeData.snippet;
                if (result === undefined) {
                    if (nodeData.generated === undefined) {
                        nodeData.generated = true;
                        result = this.generate(builder) || '';
                        nodeData.snippet = result;
                    } else {
                        (0, $329ek.warn)('Node: Recursion detected.', this);
                        result = '/* Recursion detected. */';
                    }
                } else if (nodeData.flowCodes !== undefined && builder.context.nodeBlock !== undefined) builder.addFlowCodeHierarchy(this, builder.context.nodeBlock);
                result = builder.format(result, type, output);
            } else result = this.generate(builder, output) || '';
            if (result === '' && output !== null && output !== 'void' && output !== 'OutputType') {
                // if no snippet is generated, return a default value
                (0, $329ek.error)(`TSL: Invalid generated code, expected a "${output}".`);
                result = builder.generateConst(output);
            }
        }
        builder.removeChain(this);
        builder.addSequentialNode(this);
        return result;
    }
    /**
	 * Returns the child nodes as a JSON object.
	 *
	 * @return {Generator<Object>} An iterable list of serialized child objects as JSON.
	 */ getSerializeChildren() {
        return this._getChildren();
    }
    /**
	 * Serializes the node to JSON.
	 *
	 * @param {Object} json - The output JSON object.
	 */ serialize(json) {
        const nodeChildren = this.getSerializeChildren();
        const inputNodes = {};
        for (const { property: property, index: index, childNode: childNode } of nodeChildren)if (index !== undefined) {
            if (inputNodes[property] === undefined) inputNodes[property] = Number.isInteger(index) ? [] : {};
            inputNodes[property][index] = childNode.toJSON(json.meta).uuid;
        } else inputNodes[property] = childNode.toJSON(json.meta).uuid;
        if (Object.keys(inputNodes).length > 0) json.inputNodes = inputNodes;
    }
    /**
	 * Deserializes the node from the given JSON.
	 *
	 * @param {Object} json - The JSON object.
	 */ deserialize(json) {
        if (json.inputNodes !== undefined) {
            const nodes = json.meta.nodes;
            for(const property in json.inputNodes){
                if (Array.isArray(json.inputNodes[property])) {
                    const inputArray = [];
                    for (const uuid of json.inputNodes[property])inputArray.push(nodes[uuid]);
                    this[property] = inputArray;
                } else if (typeof json.inputNodes[property] === 'object') {
                    const inputObject = {};
                    for(const subProperty in json.inputNodes[property]){
                        const uuid = json.inputNodes[property][subProperty];
                        inputObject[subProperty] = nodes[uuid];
                    }
                    this[property] = inputObject;
                } else {
                    const uuid = json.inputNodes[property];
                    this[property] = nodes[uuid];
                }
            }
        }
    }
    /**
	 * Serializes the node into the three.js JSON Object/Scene format.
	 *
	 * @param {?Object} meta - An optional JSON object that already holds serialized data from other scene objects.
	 * @return {Object} The serialized node.
	 */ toJSON(meta) {
        const { uuid: uuid, type: type } = this;
        const isRoot = meta === undefined || typeof meta === 'string';
        if (isRoot) meta = {
            textures: {},
            images: {},
            nodes: {}
        };
        // serialize
        let data = meta.nodes[uuid];
        if (data === undefined) {
            data = {
                uuid: uuid,
                type: type,
                meta: meta,
                metadata: {
                    version: 4.7,
                    type: 'Node',
                    generator: 'Node.toJSON'
                }
            };
            if (isRoot !== true) meta.nodes[data.uuid] = data;
            this.serialize(data);
            delete data.meta;
        }
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const nodes = extractFromCache(meta.nodes);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
            if (nodes.length > 0) data.nodes = nodes;
        }
        return data;
    }
}
/**
 * Base class for representing element access on an array-like
 * node data structures.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$f2edd1d22bf6d00b extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ArrayElementNode';
    }
    /**
	 * Constructs an array element node.
	 *
	 * @param {Node} node - The array-like node.
	 * @param {Node} indexNode - The index node that defines the element access.
	 */ constructor(node, indexNode){
        super();
        /**
		 * The array-like node.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The index node that defines the element access.
		 *
		 * @type {Node}
		 */ this.indexNode = indexNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayElementNode = true;
    }
    /**
	 * This method is overwritten since the node type is inferred from the array-like node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        return this.node.getElementType(builder);
    }
    /**
	 * This method is overwritten since the member type is inferred from the array-like node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The member name.
	 * @return {string} The member type.
	 */ getMemberType(builder, name) {
        return this.node.getMemberType(builder, name);
    }
    generate(builder) {
        const indexType = this.indexNode.getNodeType(builder);
        const nodeSnippet = this.node.build(builder);
        const indexSnippet = this.indexNode.build(builder, !builder.isVector(indexType) && builder.isInteger(indexType) ? indexType : 'uint');
        return `${nodeSnippet}[ ${indexSnippet} ]`;
    }
}
/**
 * This module is part of the TSL core and usually not used in app level code.
 * It represents a convert operation during the shader generation process
 * meaning it converts the data type of a node to a target data type.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$77fac4ed96fd2435 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ConvertNode';
    }
    /**
	 * Constructs a new convert node.
	 *
	 * @param {Node} node - The node which type should be converted.
	 * @param {string} convertTo - The target node type. Multiple types can be defined by separating them with a `|` sign.
	 */ constructor(node, convertTo){
        super();
        /**
		 * The node which type should be converted.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The target node type. Multiple types can be defined by separating them with a `|` sign.
		 *
		 * @type {string}
		 */ this.convertTo = convertTo;
    }
    /**
	 * This method is overwritten since the implementation tries to infer the best
	 * matching type from the {@link ConvertNode#convertTo} property.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        const requestType = this.node.getNodeType(builder);
        let convertTo = null;
        for (const overloadingType of this.convertTo.split('|'))if (convertTo === null || builder.getTypeLength(requestType) === builder.getTypeLength(overloadingType)) convertTo = overloadingType;
        return convertTo;
    }
    serialize(data) {
        super.serialize(data);
        data.convertTo = this.convertTo;
    }
    deserialize(data) {
        super.deserialize(data);
        this.convertTo = data.convertTo;
    }
    generate(builder, output) {
        const node = this.node;
        const type = this.getNodeType(builder);
        const snippet = node.build(builder, type);
        return builder.format(snippet, type, output);
    }
}
/**
 * This module uses cache management to create temporary variables
 * if the node is used more than once to prevent duplicate calculations.
 *
 * The class acts as a base class for many other nodes types.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$bbad94d2cd32d688 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'TempNode';
    }
    /**
	 * Constructs a temp node.
	 *
	 * @param {?string} nodeType - The node type.
	 */ constructor(nodeType = null){
        super(nodeType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTempNode = true;
    }
    /**
	 * Whether this node is used more than once in context of other nodes.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @return {boolean} A flag that indicates if there is more than one dependency to other nodes.
	 */ hasDependencies(builder) {
        return builder.getDataFromNode(this).usageCount > 1;
    }
    build(builder, output) {
        const buildStage = builder.getBuildStage();
        if (buildStage === 'generate') {
            const type = builder.getVectorType(this.getNodeType(builder, output));
            const nodeData = builder.getDataFromNode(this);
            if (nodeData.propertyName !== undefined) return builder.format(nodeData.propertyName, type, output);
            else if (type !== 'void' && output !== 'void' && this.hasDependencies(builder)) {
                const snippet = super.build(builder, type);
                const nodeVar = builder.getVarFromNode(this, null, type);
                const propertyName = builder.getPropertyName(nodeVar);
                builder.addLineFlowCode(`${propertyName} = ${snippet}`, this);
                nodeData.snippet = snippet;
                nodeData.propertyName = propertyName;
                return builder.format(nodeData.propertyName, type, output);
            }
        }
        return super.build(builder, output);
    }
}
/**
 * This module is part of the TSL core and usually not used in app level code.
 * It represents a join operation during the shader generation process.
 * For example in can compose/join two single floats into a `vec2` type.
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$737956ea59502441 extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'JoinNode';
    }
    /**
	 * Constructs a new join node.
	 *
	 * @param {Array<Node>} nodes - An array of nodes that should be joined.
	 * @param {?string} [nodeType=null] - The node type.
	 */ constructor(nodes = [], nodeType = null){
        super(nodeType);
        /**
		 * An array of nodes that should be joined.
		 *
		 * @type {Array<Node>}
		 */ this.nodes = nodes;
    }
    /**
	 * This method is overwritten since the node type must be inferred from the
	 * joined data length if not explicitly defined.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        if (this.nodeType !== null) return builder.getVectorType(this.nodeType);
        return builder.getTypeFromLength(this.nodes.reduce((count, cur)=>count + builder.getTypeLength(cur.getNodeType(builder)), 0));
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const maxLength = builder.getTypeLength(type);
        const nodes = this.nodes;
        const primitiveType = builder.getComponentType(type);
        const snippetValues = [];
        let length = 0;
        for (const input of nodes){
            if (length >= maxLength) {
                (0, $329ek.error)(`TSL: Length of parameters exceeds maximum length of function '${type}()' type.`);
                break;
            }
            let inputType = input.getNodeType(builder);
            let inputTypeLength = builder.getTypeLength(inputType);
            let inputSnippet;
            if (length + inputTypeLength > maxLength) {
                (0, $329ek.error)(`TSL: Length of '${type}()' data exceeds maximum length of output type.`);
                inputTypeLength = maxLength - length;
                inputType = builder.getTypeFromLength(inputTypeLength);
            }
            length += inputTypeLength;
            inputSnippet = input.build(builder, inputType);
            const inputPrimitiveType = builder.getComponentType(inputType);
            if (inputPrimitiveType !== primitiveType) {
                const targetType = builder.getTypeFromLength(inputTypeLength, primitiveType);
                inputSnippet = builder.format(inputSnippet, inputType, targetType);
            }
            snippetValues.push(inputSnippet);
        }
        const snippet = `${builder.getType(type)}( ${snippetValues.join(', ')} )`;
        return builder.format(snippet, type, output);
    }
}
const $d89c9137a3d237c2$var$_stringVectorComponents = $d89c9137a3d237c2$export$1c0adcb9073b646d.join('');
/**
 * This module is part of the TSL core and usually not used in app level code.
 * `SplitNode` represents a property access operation which means it is
 * used to implement any `.xyzw`, `.rgba` and `stpq` usage on node objects.
 * For example:
 * ```js
 * const redValue = color.r;
 * ```
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$3cd993069e2dfb64 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'SplitNode';
    }
    /**
	 * Constructs a new split node.
	 *
	 * @param {Node} node - The node that should be accessed.
	 * @param {string} [components='x'] - The components that should be accessed.
	 */ constructor(node, components = 'x'){
        super();
        /**
		 * The node that should be accessed.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The components that should be accessed.
		 *
		 * @type {string}
		 */ this.components = components;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSplitNode = true;
    }
    /**
	 * Returns the vector length which is computed based on the requested components.
	 *
	 * @return {number} The vector length.
	 */ getVectorLength() {
        let vectorLength = this.components.length;
        for (const c of this.components)vectorLength = Math.max($d89c9137a3d237c2$export$1c0adcb9073b646d.indexOf(c) + 1, vectorLength);
        return vectorLength;
    }
    /**
	 * Returns the component type of the node's type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The component type.
	 */ getComponentType(builder) {
        return builder.getComponentType(this.node.getNodeType(builder));
    }
    /**
	 * This method is overwritten since the node type is inferred from requested components.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        return builder.getTypeFromLength(this.components.length, this.getComponentType(builder));
    }
    /**
	 * Returns the scope of the node.
	 *
	 * @return {Node} The scope of the node.
	 */ getScope() {
        return this.node.getScope();
    }
    generate(builder, output) {
        const node = this.node;
        const nodeTypeLength = builder.getTypeLength(node.getNodeType(builder));
        let snippet = null;
        if (nodeTypeLength > 1) {
            let type = null;
            const componentsLength = this.getVectorLength();
            if (componentsLength >= nodeTypeLength) // needed expand the input node
            type = builder.getTypeFromLength(this.getVectorLength(), this.getComponentType(builder));
            const nodeSnippet = node.build(builder, type);
            if (this.components.length === nodeTypeLength && this.components === $d89c9137a3d237c2$var$_stringVectorComponents.slice(0, this.components.length)) // unnecessary swizzle
            snippet = builder.format(nodeSnippet, type, output);
            else snippet = builder.format(`${nodeSnippet}.${this.components}`, this.getNodeType(builder), output);
        } else // ignore .components if .node returns float/integer
        snippet = node.build(builder, output);
        return snippet;
    }
    serialize(data) {
        super.serialize(data);
        data.components = this.components;
    }
    deserialize(data) {
        super.deserialize(data);
        this.components = data.components;
    }
}
/**
 * This module is part of the TSL core and usually not used in app level code.
 * `SetNode` represents a set operation which means it is used to implement any
 * `setXYZW()`, `setRGBA()` and `setSTPQ()` method invocations on node objects.
 * For example:
 * ```js
 * materialLine.colorNode = color( 0, 0, 0 ).setR( float( 1 ) );
 * ```
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$dfddef9573185145 extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'SetNode';
    }
    /**
	 * Constructs a new set node.
	 *
	 * @param {Node} sourceNode - The node that should be updated.
	 * @param {string} components - The components that should be updated.
	 * @param {Node} targetNode - The value node.
	 */ constructor(sourceNode, components, targetNode){
        super();
        /**
		 * The node that should be updated.
		 *
		 * @type {Node}
		 */ this.sourceNode = sourceNode;
        /**
		 * The components that should be updated.
		 *
		 * @type {string}
		 */ this.components = components;
        /**
		 * The value node.
		 *
		 * @type {Node}
		 */ this.targetNode = targetNode;
    }
    /**
	 * This method is overwritten since the node type is inferred from {@link SetNode#sourceNode}.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        return this.sourceNode.getNodeType(builder);
    }
    generate(builder) {
        const { sourceNode: sourceNode, components: components, targetNode: targetNode } = this;
        const sourceType = this.getNodeType(builder);
        const componentType = builder.getComponentType(targetNode.getNodeType(builder));
        const targetType = builder.getTypeFromLength(components.length, componentType);
        const targetSnippet = targetNode.build(builder, targetType);
        const sourceSnippet = sourceNode.build(builder, sourceType);
        const length = builder.getTypeLength(sourceType);
        const snippetValues = [];
        for(let i = 0; i < length; i++){
            const component = $d89c9137a3d237c2$export$1c0adcb9073b646d[i];
            if (component === components[0]) {
                snippetValues.push(targetSnippet);
                i += components.length - 1;
            } else snippetValues.push(sourceSnippet + '.' + component);
        }
        return `${builder.getType(sourceType)}( ${snippetValues.join(', ')} )`;
    }
}
/**
 * This module is part of the TSL core and usually not used in app level code.
 * It represents a flip operation during the shader generation process
 * meaning it flips normalized values with the following formula:
 * ```
 * x = 1 - x;
 * ```
 * `FlipNode` is internally used to implement any `flipXYZW()`, `flipRGBA()` and
 * `flipSTPQ()` method invocations on node objects. For example:
 * ```js
 * uvNode = uvNode.flipY();
 * ```
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$var$FlipNode extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'FlipNode';
    }
    /**
	 * Constructs a new flip node.
	 *
	 * @param {Node} sourceNode - The node which component(s) should be flipped.
	 * @param {string} components - The components that should be flipped e.g. `'x'` or `'xy'`.
	 */ constructor(sourceNode, components){
        super();
        /**
		 * The node which component(s) should be flipped.
		 *
		 * @type {Node}
		 */ this.sourceNode = sourceNode;
        /**
		 * The components that should be flipped e.g. `'x'` or `'xy'`.
		 *
		 * @type {string}
		 */ this.components = components;
    }
    /**
	 * This method is overwritten since the node type is inferred from the source node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        return this.sourceNode.getNodeType(builder);
    }
    generate(builder) {
        const { components: components, sourceNode: sourceNode } = this;
        const sourceType = this.getNodeType(builder);
        const sourceSnippet = sourceNode.build(builder);
        const sourceCache = builder.getVarFromNode(this);
        const sourceProperty = builder.getPropertyName(sourceCache);
        builder.addLineFlowCode(sourceProperty + ' = ' + sourceSnippet, this);
        const length = builder.getTypeLength(sourceType);
        const snippetValues = [];
        let componentIndex = 0;
        for(let i = 0; i < length; i++){
            const component = $d89c9137a3d237c2$export$1c0adcb9073b646d[i];
            if (component === components[componentIndex]) {
                snippetValues.push('1.0 - ' + (sourceProperty + '.' + component));
                componentIndex++;
            } else snippetValues.push(sourceProperty + '.' + component);
        }
        return `${builder.getType(sourceType)}( ${snippetValues.join(', ')} )`;
    }
}
/**
 * Base class for representing data input nodes.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$var$InputNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'InputNode';
    }
    /**
	 * Constructs a new input node.
	 *
	 * @param {any} value - The value of this node. This can be any JS primitive, functions, array buffers or even three.js objects (vector, matrices, colors).
	 * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
	 */ constructor(value, nodeType = null){
        super(nodeType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInputNode = true;
        /**
		 * The value of this node. This can be any JS primitive, functions, array buffers or even three.js objects (vector, matrices, colors).
		 *
		 * @type {any}
		 */ this.value = value;
        /**
		 * The precision of the value in the shader.
		 *
		 * @type {?('low'|'medium'|'high')}
		 * @default null
		 */ this.precision = null;
    }
    getNodeType() {
        if (this.nodeType === null) return $d89c9137a3d237c2$var$getValueType(this.value);
        return this.nodeType;
    }
    /**
	 * Returns the input type of the node which is by default the node type. Derived modules
	 * might overwrite this method and use a fixed type or compute one analytically.
	 *
	 * A typical example for different input and node types are textures. The input type of a
	 * normal RGBA texture is `texture` whereas its node type is `vec4`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType(builder) {
        return this.getNodeType(builder);
    }
    /**
	 * Sets the precision to the given value. The method can be
	 * overwritten in derived classes if the final precision must be computed
	 * analytically.
	 *
	 * @param {('low'|'medium'|'high')} precision - The precision of the input value in the shader.
	 * @return {InputNode} A reference to this node.
	 */ setPrecision(precision) {
        this.precision = precision;
        return this;
    }
    serialize(data) {
        super.serialize(data);
        data.value = this.value;
        if (this.value && this.value.toArray) data.value = this.value.toArray();
        data.valueType = $d89c9137a3d237c2$var$getValueType(this.value);
        data.nodeType = this.nodeType;
        if (data.valueType === 'ArrayBuffer') data.value = $d89c9137a3d237c2$var$arrayBufferToBase64(data.value);
        data.precision = this.precision;
    }
    deserialize(data) {
        super.deserialize(data);
        this.nodeType = data.nodeType;
        this.value = Array.isArray(data.value) ? $d89c9137a3d237c2$var$getValueFromType(data.valueType, ...data.value) : data.value;
        this.precision = data.precision || null;
        if (this.value && this.value.fromArray) this.value = this.value.fromArray(data.value);
    }
    generate() {
        (0, $329ek.warn)('Abstract function.');
    }
}
const $d89c9137a3d237c2$var$_regNum = /float|u?int/;
/**
 * Class for representing a constant value in the shader.
 *
 * @augments InputNode
 */ class $d89c9137a3d237c2$export$ec99b5196691da75 extends $d89c9137a3d237c2$var$InputNode {
    static get type() {
        return 'ConstNode';
    }
    /**
	 * Constructs a new input node.
	 *
	 * @param {any} value - The value of this node. Usually a JS primitive or three.js object (vector, matrix, color).
	 * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
	 */ constructor(value, nodeType = null){
        super(value, nodeType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isConstNode = true;
    }
    /**
	 * Generates the shader string of the value with the current node builder.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated value as a shader string.
	 */ generateConst(builder) {
        return builder.generateConst(this.getNodeType(builder), this.value);
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        if ($d89c9137a3d237c2$var$_regNum.test(type) && $d89c9137a3d237c2$var$_regNum.test(output)) return builder.generateConst(output, this.value);
        return builder.format(this.generateConst(builder), type, output);
    }
}
/**
 * Base class for representing member access on an object-like
 * node data structures.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$81fa5d002f21ba26 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'MemberNode';
    }
    /**
	 * Constructs a member node.
	 *
	 * @param {Node} structNode - The struct node.
	 * @param {string} property - The property name.
	 */ constructor(structNode, property){
        super();
        /**
		 * The struct node.
		 *
		 * @type {Node}
		 */ this.structNode = structNode;
        /**
		 * The property name.
		 *
		 * @type {Node}
		 */ this.property = property;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMemberNode = true;
    }
    hasMember(builder) {
        if (this.structNode.isMemberNode) {
            if (this.structNode.hasMember(builder) === false) return false;
        }
        return this.structNode.getMemberType(builder, this.property) !== 'void';
    }
    getNodeType(builder) {
        if (this.hasMember(builder) === false) // default type if member does not exist
        return 'float';
        return this.structNode.getMemberType(builder, this.property);
    }
    getMemberType(builder, name) {
        if (this.hasMember(builder) === false) // default type if member does not exist
        return 'float';
        const type = this.getNodeType(builder);
        const struct = builder.getStructTypeNode(type);
        return struct.getMemberType(builder, name);
    }
    generate(builder) {
        if (this.hasMember(builder) === false) {
            (0, $329ek.warn)(`TSL: Member "${this.property}" does not exist in struct.`);
            const type = this.getNodeType(builder);
            return builder.generateConst(type);
        }
        const propertyName = this.structNode.build(builder);
        return propertyName + '.' + this.property;
    }
}
let $d89c9137a3d237c2$var$currentStack = null;
const $d89c9137a3d237c2$var$NodeElements = new Map();
// Extend Node Class for TSL using prototype
function $d89c9137a3d237c2$var$addMethodChaining(name, nodeElement) {
    if ($d89c9137a3d237c2$var$NodeElements.has(name)) {
        (0, $329ek.warn)(`TSL: Redefinition of method chaining '${name}'.`);
        return;
    }
    if (typeof nodeElement !== 'function') throw new Error(`THREE.TSL: Node element ${name} is not a function`);
    $d89c9137a3d237c2$var$NodeElements.set(name, nodeElement);
    if (name !== 'assign') {
        // Changing Node prototype to add method chaining
        $d89c9137a3d237c2$export$85c928794f8d04d4.prototype[name] = function(...params) {
            //if ( name === 'toVarIntent' ) return this;
            return this.isStackNode ? this.addToStack(nodeElement(...params)) : nodeElement(this, ...params);
        };
        // Adding assign method chaining
        $d89c9137a3d237c2$export$85c928794f8d04d4.prototype[name + 'Assign'] = function(...params) {
            return this.isStackNode ? this.assign(params[0], nodeElement(...params)) : this.assign(nodeElement(this, ...params));
        };
    }
}
const $d89c9137a3d237c2$var$parseSwizzle = (props)=>props.replace(/r|s/g, 'x').replace(/g|t/g, 'y').replace(/b|p/g, 'z').replace(/a|q/g, 'w');
const $d89c9137a3d237c2$var$parseSwizzleAndSort = (props)=>$d89c9137a3d237c2$var$parseSwizzle(props).split('').sort().join('');
$d89c9137a3d237c2$export$85c928794f8d04d4.prototype.assign = function(...params) {
    if (this.isStackNode !== true) {
        if ($d89c9137a3d237c2$var$currentStack !== null) $d89c9137a3d237c2$var$currentStack.assign(this, ...params);
        else (0, $329ek.error)('TSL: No stack defined for assign operation. Make sure the assign is inside a Fn().');
        return this;
    } else {
        const nodeElement = $d89c9137a3d237c2$var$NodeElements.get('assign');
        return this.addToStack(nodeElement(...params));
    }
};
$d89c9137a3d237c2$export$85c928794f8d04d4.prototype.toVarIntent = function() {
    return this;
};
$d89c9137a3d237c2$export$85c928794f8d04d4.prototype.get = function(value) {
    return new $d89c9137a3d237c2$export$81fa5d002f21ba26(this, value);
};
// Cache prototype for TSL
const $d89c9137a3d237c2$var$proto = {};
// Set swizzle properties for xyzw, rgba, and stpq.
function $d89c9137a3d237c2$var$setProtoSwizzle(property, altA, altB) {
    // swizzle properties
    $d89c9137a3d237c2$var$proto[property] = $d89c9137a3d237c2$var$proto[altA] = $d89c9137a3d237c2$var$proto[altB] = {
        get () {
            this._cache = this._cache || {};
            //
            let split = this._cache[property];
            if (split === undefined) {
                split = new $d89c9137a3d237c2$export$3cd993069e2dfb64(this, property);
                this._cache[property] = split;
            }
            return split;
        },
        set (value) {
            this[property].assign($d89c9137a3d237c2$var$nodeObject(value));
        }
    };
    // set properties ( swizzle ) and sort to xyzw sequence
    const propUpper = property.toUpperCase();
    const altAUpper = altA.toUpperCase();
    const altBUpper = altB.toUpperCase();
    // Set methods for swizzle properties
    $d89c9137a3d237c2$export$85c928794f8d04d4.prototype['set' + propUpper] = $d89c9137a3d237c2$export$85c928794f8d04d4.prototype['set' + altAUpper] = $d89c9137a3d237c2$export$85c928794f8d04d4.prototype['set' + altBUpper] = function(value) {
        const swizzle = $d89c9137a3d237c2$var$parseSwizzleAndSort(property);
        return new $d89c9137a3d237c2$export$dfddef9573185145(this, swizzle, $d89c9137a3d237c2$var$nodeObject(value));
    };
    // Set methods for flip properties
    $d89c9137a3d237c2$export$85c928794f8d04d4.prototype['flip' + propUpper] = $d89c9137a3d237c2$export$85c928794f8d04d4.prototype['flip' + altAUpper] = $d89c9137a3d237c2$export$85c928794f8d04d4.prototype['flip' + altBUpper] = function() {
        const swizzle = $d89c9137a3d237c2$var$parseSwizzleAndSort(property);
        return new $d89c9137a3d237c2$var$FlipNode(this, swizzle);
    };
}
const $d89c9137a3d237c2$var$swizzleA = [
    'x',
    'y',
    'z',
    'w'
];
const $d89c9137a3d237c2$var$swizzleB = [
    'r',
    'g',
    'b',
    'a'
];
const $d89c9137a3d237c2$var$swizzleC = [
    's',
    't',
    'p',
    'q'
];
for(let a = 0; a < 4; a++){
    let prop = $d89c9137a3d237c2$var$swizzleA[a];
    let altA = $d89c9137a3d237c2$var$swizzleB[a];
    let altB = $d89c9137a3d237c2$var$swizzleC[a];
    $d89c9137a3d237c2$var$setProtoSwizzle(prop, altA, altB);
    for(let b = 0; b < 4; b++){
        prop = $d89c9137a3d237c2$var$swizzleA[a] + $d89c9137a3d237c2$var$swizzleA[b];
        altA = $d89c9137a3d237c2$var$swizzleB[a] + $d89c9137a3d237c2$var$swizzleB[b];
        altB = $d89c9137a3d237c2$var$swizzleC[a] + $d89c9137a3d237c2$var$swizzleC[b];
        $d89c9137a3d237c2$var$setProtoSwizzle(prop, altA, altB);
        for(let c = 0; c < 4; c++){
            prop = $d89c9137a3d237c2$var$swizzleA[a] + $d89c9137a3d237c2$var$swizzleA[b] + $d89c9137a3d237c2$var$swizzleA[c];
            altA = $d89c9137a3d237c2$var$swizzleB[a] + $d89c9137a3d237c2$var$swizzleB[b] + $d89c9137a3d237c2$var$swizzleB[c];
            altB = $d89c9137a3d237c2$var$swizzleC[a] + $d89c9137a3d237c2$var$swizzleC[b] + $d89c9137a3d237c2$var$swizzleC[c];
            $d89c9137a3d237c2$var$setProtoSwizzle(prop, altA, altB);
            for(let d = 0; d < 4; d++){
                prop = $d89c9137a3d237c2$var$swizzleA[a] + $d89c9137a3d237c2$var$swizzleA[b] + $d89c9137a3d237c2$var$swizzleA[c] + $d89c9137a3d237c2$var$swizzleA[d];
                altA = $d89c9137a3d237c2$var$swizzleB[a] + $d89c9137a3d237c2$var$swizzleB[b] + $d89c9137a3d237c2$var$swizzleB[c] + $d89c9137a3d237c2$var$swizzleB[d];
                altB = $d89c9137a3d237c2$var$swizzleC[a] + $d89c9137a3d237c2$var$swizzleC[b] + $d89c9137a3d237c2$var$swizzleC[c] + $d89c9137a3d237c2$var$swizzleC[d];
                $d89c9137a3d237c2$var$setProtoSwizzle(prop, altA, altB);
            }
        }
    }
}
// Set/get static properties for array elements (0-31).
for(let i = 0; i < 32; i++)$d89c9137a3d237c2$var$proto[i] = {
    get () {
        this._cache = this._cache || {};
        //
        let element = this._cache[i];
        if (element === undefined) {
            element = new $d89c9137a3d237c2$export$f2edd1d22bf6d00b(this, new $d89c9137a3d237c2$export$ec99b5196691da75(i, 'uint'));
            this._cache[i] = element;
        }
        return element;
    },
    set (value) {
        this[i].assign($d89c9137a3d237c2$var$nodeObject(value));
    }
};
/*
// Set properties for width, height, and depth.

function setProtoProperty( property, target ) {

	proto[ property ] = {

		get() {

			this._cache = this._cache || {};

			//

			let split = this._cache[ target ];

			if ( split === undefined ) {

				split = new SplitNode( this, target );

				this._cache[ target ] = split;

			}

			return split;

		},

		set( value ) {

			this[ target ].assign( nodeObject( value ) );

		}

	};

}

setProtoProperty( 'width', 'x' );
setProtoProperty( 'height', 'y' );
setProtoProperty( 'depth', 'z' );
*/ Object.defineProperties($d89c9137a3d237c2$export$85c928794f8d04d4.prototype, $d89c9137a3d237c2$var$proto);
// --- FINISH ---
const $d89c9137a3d237c2$var$nodeBuilderFunctionsCacheMap = new WeakMap();
const $d89c9137a3d237c2$var$ShaderNodeObject = function(obj, altType = null) {
    const type = $d89c9137a3d237c2$var$getValueType(obj);
    if (type === 'node') return obj;
    else if (altType === null && (type === 'float' || type === 'boolean') || type && type !== 'shader' && type !== 'string') return $d89c9137a3d237c2$var$nodeObject($d89c9137a3d237c2$var$getConstNode(obj, altType));
    else if (type === 'shader') return obj.isFn ? obj : $d89c9137a3d237c2$var$Fn(obj);
    return obj;
};
const $d89c9137a3d237c2$var$ShaderNodeObjects = function(objects, altType = null) {
    for(const name in objects)objects[name] = $d89c9137a3d237c2$var$nodeObject(objects[name], altType);
    return objects;
};
const $d89c9137a3d237c2$var$ShaderNodeArray = function(array, altType = null) {
    const len = array.length;
    for(let i = 0; i < len; i++)array[i] = $d89c9137a3d237c2$var$nodeObject(array[i], altType);
    return array;
};
const $d89c9137a3d237c2$var$ShaderNodeProxy = function(NodeClass, scope = null, factor = null, settings = null) {
    function assignNode(node) {
        if (settings !== null) {
            node = $d89c9137a3d237c2$var$nodeObject(Object.assign(node, settings));
            if (settings.intent === true) node = node.toVarIntent();
        } else node = $d89c9137a3d237c2$var$nodeObject(node);
        return node;
    }
    let fn, name = scope, minParams, maxParams;
    function verifyParamsLimit(params) {
        let tslName;
        if (name) tslName = /[a-z]/i.test(name) ? name + '()' : name;
        else tslName = NodeClass.type;
        if (minParams !== undefined && params.length < minParams) {
            (0, $329ek.error)(`TSL: "${tslName}" parameter length is less than minimum required.`);
            return params.concat(new Array(minParams - params.length).fill(0));
        } else if (maxParams !== undefined && params.length > maxParams) {
            (0, $329ek.error)(`TSL: "${tslName}" parameter length exceeds limit.`);
            return params.slice(0, maxParams);
        }
        return params;
    }
    if (scope === null) fn = (...params)=>{
        return assignNode(new NodeClass(...$d89c9137a3d237c2$var$nodeArray(verifyParamsLimit(params))));
    };
    else if (factor !== null) {
        factor = $d89c9137a3d237c2$var$nodeObject(factor);
        fn = (...params)=>{
            return assignNode(new NodeClass(scope, ...$d89c9137a3d237c2$var$nodeArray(verifyParamsLimit(params)), factor));
        };
    } else fn = (...params)=>{
        return assignNode(new NodeClass(scope, ...$d89c9137a3d237c2$var$nodeArray(verifyParamsLimit(params))));
    };
    fn.setParameterLength = (...params)=>{
        if (params.length === 1) minParams = maxParams = params[0];
        else if (params.length === 2) [minParams, maxParams] = params;
        return fn;
    };
    fn.setName = (value)=>{
        name = value;
        return fn;
    };
    return fn;
};
const $d89c9137a3d237c2$var$ShaderNodeImmutable = function(NodeClass, ...params) {
    return new NodeClass(...$d89c9137a3d237c2$var$nodeArray(params));
};
class $d89c9137a3d237c2$var$ShaderCallNodeInternal extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    constructor(shaderNode, rawInputs){
        super();
        this.shaderNode = shaderNode;
        this.rawInputs = rawInputs;
        this.isShaderCallNodeInternal = true;
    }
    getNodeType(builder) {
        return this.shaderNode.nodeType || this.getOutputNode(builder).getNodeType(builder);
    }
    getElementType(builder) {
        return this.getOutputNode(builder).getElementType(builder);
    }
    getMemberType(builder, name) {
        return this.getOutputNode(builder).getMemberType(builder, name);
    }
    call(builder) {
        const { shaderNode: shaderNode, rawInputs: rawInputs } = this;
        const properties = builder.getNodeProperties(shaderNode);
        const subBuild = builder.getClosestSubBuild(shaderNode.subBuilds) || '';
        const subBuildProperty = subBuild || 'default';
        if (properties[subBuildProperty]) return properties[subBuildProperty];
        //
        const previousSubBuildFn = builder.subBuildFn;
        const previousFnCall = builder.fnCall;
        builder.subBuildFn = subBuild;
        builder.fnCall = this;
        let result = null;
        if (shaderNode.layout) {
            let functionNodesCacheMap = $d89c9137a3d237c2$var$nodeBuilderFunctionsCacheMap.get(builder.constructor);
            if (functionNodesCacheMap === undefined) {
                functionNodesCacheMap = new WeakMap();
                $d89c9137a3d237c2$var$nodeBuilderFunctionsCacheMap.set(builder.constructor, functionNodesCacheMap);
            }
            let functionNode = functionNodesCacheMap.get(shaderNode);
            if (functionNode === undefined) {
                functionNode = $d89c9137a3d237c2$var$nodeObject(builder.buildFunctionNode(shaderNode));
                functionNodesCacheMap.set(shaderNode, functionNode);
            }
            builder.addInclude(functionNode);
            //
            const inputs = rawInputs ? $d89c9137a3d237c2$var$getLayoutParameters(rawInputs) : null;
            result = $d89c9137a3d237c2$var$nodeObject(functionNode.call(inputs));
        } else {
            const secureNodeBuilder = new Proxy(builder, {
                get: (target, property, receiver)=>{
                    let value;
                    if (Symbol.iterator === property) value = function*() {
                        yield undefined;
                    };
                    else value = Reflect.get(target, property, receiver);
                    return value;
                }
            });
            //
            const inputs = rawInputs ? $d89c9137a3d237c2$var$getProxyParameters(rawInputs) : null;
            const hasParameters = Array.isArray(rawInputs) ? rawInputs.length > 0 : rawInputs !== null;
            const jsFunc = shaderNode.jsFunc;
            const outputNode = hasParameters || jsFunc.length > 1 ? jsFunc(inputs, secureNodeBuilder) : jsFunc(secureNodeBuilder);
            result = $d89c9137a3d237c2$var$nodeObject(outputNode);
        }
        builder.subBuildFn = previousSubBuildFn;
        builder.fnCall = previousFnCall;
        if (shaderNode.once) properties[subBuildProperty] = result;
        return result;
    }
    setupOutput(builder) {
        builder.addStack();
        builder.stack.outputNode = this.call(builder);
        return builder.removeStack();
    }
    getOutputNode(builder) {
        const properties = builder.getNodeProperties(this);
        const subBuildOutput = builder.getSubBuildOutput(this);
        properties[subBuildOutput] = properties[subBuildOutput] || this.setupOutput(builder);
        properties[subBuildOutput].subBuild = builder.getClosestSubBuild(this);
        return properties[subBuildOutput];
    }
    build(builder, output = null) {
        let result = null;
        const buildStage = builder.getBuildStage();
        const properties = builder.getNodeProperties(this);
        const subBuildOutput = builder.getSubBuildOutput(this);
        const outputNode = this.getOutputNode(builder);
        const previousFnCall = builder.fnCall;
        builder.fnCall = this;
        if (buildStage === 'setup') {
            const subBuildInitialized = builder.getSubBuildProperty('initialized', this);
            if (properties[subBuildInitialized] !== true) {
                properties[subBuildInitialized] = true;
                properties[subBuildOutput] = this.getOutputNode(builder);
                properties[subBuildOutput].build(builder);
                // If the shaderNode has subBuilds, add them to the chaining nodes
                // so they can be built later in the build process.
                if (this.shaderNode.subBuilds) for (const node of builder.chaining){
                    const nodeData = builder.getDataFromNode(node, 'any');
                    nodeData.subBuilds = nodeData.subBuilds || new Set();
                    for (const subBuild of this.shaderNode.subBuilds)nodeData.subBuilds.add(subBuild);
                //builder.getDataFromNode( node ).subBuilds = nodeData.subBuilds;
                }
            }
            result = properties[subBuildOutput];
        } else if (buildStage === 'analyze') outputNode.build(builder, output);
        else if (buildStage === 'generate') result = outputNode.build(builder, output) || '';
        builder.fnCall = previousFnCall;
        return result;
    }
}
function $d89c9137a3d237c2$var$getLayoutParameters(params) {
    let output;
    $d89c9137a3d237c2$var$nodeObjects(params);
    const isArrayAsParameter = params[0] && (params[0].isNode || Object.getPrototypeOf(params[0]) !== Object.prototype);
    if (isArrayAsParameter) output = [
        ...params
    ];
    else output = params[0];
    return output;
}
function $d89c9137a3d237c2$var$getProxyParameters(params) {
    let index = 0;
    $d89c9137a3d237c2$var$nodeObjects(params);
    return new Proxy(params, {
        get: (target, property, receiver)=>{
            let value;
            if (property === 'length') {
                value = params.length;
                return value;
            }
            if (Symbol.iterator === property) value = function*() {
                for (const inputNode of params)yield $d89c9137a3d237c2$var$nodeObject(inputNode);
            };
            else {
                if (params.length > 0) {
                    if (Object.getPrototypeOf(params[0]) === Object.prototype) {
                        const objectTarget = params[0];
                        if (objectTarget[property] === undefined) value = objectTarget[index++];
                        else value = Reflect.get(objectTarget, property, receiver);
                    } else if (params[0] instanceof $d89c9137a3d237c2$export$85c928794f8d04d4) {
                        if (params[property] === undefined) value = params[index++];
                        else value = Reflect.get(params, property, receiver);
                    }
                } else value = Reflect.get(target, property, receiver);
                value = $d89c9137a3d237c2$var$nodeObject(value);
            }
            return value;
        }
    });
}
class $d89c9137a3d237c2$var$ShaderNodeInternal extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    constructor(jsFunc, nodeType){
        super(nodeType);
        this.jsFunc = jsFunc;
        this.layout = null;
        this.global = true;
        this.once = false;
    }
    setLayout(layout) {
        this.layout = layout;
        return this;
    }
    getLayout() {
        return this.layout;
    }
    call(rawInputs = null) {
        return new $d89c9137a3d237c2$var$ShaderCallNodeInternal(this, rawInputs);
    }
    setup() {
        return this.call();
    }
}
const $d89c9137a3d237c2$var$bools = [
    false,
    true
];
const $d89c9137a3d237c2$var$uints = [
    0,
    1,
    2,
    3
];
const $d89c9137a3d237c2$var$ints = [
    -1,
    -2
];
const $d89c9137a3d237c2$var$floats = [
    0.5,
    1.5,
    1 / 3,
    1e-6,
    1e6,
    Math.PI,
    Math.PI * 2,
    1 / Math.PI,
    2 / Math.PI,
    1 / (Math.PI * 2),
    Math.PI / 2
];
const $d89c9137a3d237c2$var$boolsCacheMap = new Map();
for (const bool of $d89c9137a3d237c2$var$bools)$d89c9137a3d237c2$var$boolsCacheMap.set(bool, new $d89c9137a3d237c2$export$ec99b5196691da75(bool));
const $d89c9137a3d237c2$var$uintsCacheMap = new Map();
for (const uint of $d89c9137a3d237c2$var$uints)$d89c9137a3d237c2$var$uintsCacheMap.set(uint, new $d89c9137a3d237c2$export$ec99b5196691da75(uint, 'uint'));
const $d89c9137a3d237c2$var$intsCacheMap = new Map([
    ...$d89c9137a3d237c2$var$uintsCacheMap
].map((el)=>new $d89c9137a3d237c2$export$ec99b5196691da75(el.value, 'int')));
for (const int of $d89c9137a3d237c2$var$ints)$d89c9137a3d237c2$var$intsCacheMap.set(int, new $d89c9137a3d237c2$export$ec99b5196691da75(int, 'int'));
const $d89c9137a3d237c2$var$floatsCacheMap = new Map([
    ...$d89c9137a3d237c2$var$intsCacheMap
].map((el)=>new $d89c9137a3d237c2$export$ec99b5196691da75(el.value)));
for (const float of $d89c9137a3d237c2$var$floats)$d89c9137a3d237c2$var$floatsCacheMap.set(float, new $d89c9137a3d237c2$export$ec99b5196691da75(float));
for (const float of $d89c9137a3d237c2$var$floats)$d89c9137a3d237c2$var$floatsCacheMap.set(-float, new $d89c9137a3d237c2$export$ec99b5196691da75(-float));
const $d89c9137a3d237c2$var$cacheMaps = {
    bool: $d89c9137a3d237c2$var$boolsCacheMap,
    uint: $d89c9137a3d237c2$var$uintsCacheMap,
    ints: $d89c9137a3d237c2$var$intsCacheMap,
    float: $d89c9137a3d237c2$var$floatsCacheMap
};
const $d89c9137a3d237c2$var$constNodesCacheMap = new Map([
    ...$d89c9137a3d237c2$var$boolsCacheMap,
    ...$d89c9137a3d237c2$var$floatsCacheMap
]);
const $d89c9137a3d237c2$var$getConstNode = (value, type)=>{
    if ($d89c9137a3d237c2$var$constNodesCacheMap.has(value)) return $d89c9137a3d237c2$var$constNodesCacheMap.get(value);
    else if (value.isNode === true) return value;
    else return new $d89c9137a3d237c2$export$ec99b5196691da75(value, type);
};
const $d89c9137a3d237c2$var$ConvertType = function(type, cacheMap = null) {
    return (...params)=>{
        for (const param of params)if (param === undefined) {
            (0, $329ek.error)(`TSL: Invalid parameter for the type "${type}".`);
            return new $d89c9137a3d237c2$export$ec99b5196691da75(0, type);
        }
        if (params.length === 0 || ![
            'bool',
            'float',
            'int',
            'uint'
        ].includes(type) && params.every((param)=>{
            const paramType = typeof param;
            return paramType !== 'object' && paramType !== 'function';
        })) params = [
            $d89c9137a3d237c2$var$getValueFromType(type, ...params)
        ];
        if (params.length === 1 && cacheMap !== null && cacheMap.has(params[0])) return $d89c9137a3d237c2$var$nodeObjectIntent(cacheMap.get(params[0]));
        if (params.length === 1) {
            const node = $d89c9137a3d237c2$var$getConstNode(params[0], type);
            if (node.nodeType === type) return $d89c9137a3d237c2$var$nodeObjectIntent(node);
            return $d89c9137a3d237c2$var$nodeObjectIntent(new $d89c9137a3d237c2$export$77fac4ed96fd2435(node, type));
        }
        const nodes = params.map((param)=>$d89c9137a3d237c2$var$getConstNode(param));
        return $d89c9137a3d237c2$var$nodeObjectIntent(new $d89c9137a3d237c2$export$737956ea59502441(nodes, type));
    };
};
// exports
const $d89c9137a3d237c2$var$defined = (v)=>typeof v === 'object' && v !== null ? v.value : v; // TODO: remove boolean conversion and defined function
// utils
const $d89c9137a3d237c2$var$getConstNodeType = (value)=>value !== undefined && value !== null ? value.nodeType || value.convertTo || (typeof value === 'string' ? value : null) : null;
// shader node base
function $d89c9137a3d237c2$var$ShaderNode(jsFunc, nodeType) {
    return new $d89c9137a3d237c2$var$ShaderNodeInternal(jsFunc, nodeType);
}
const $d89c9137a3d237c2$var$nodeObject = (val, altType = null)=>/* new */ $d89c9137a3d237c2$var$ShaderNodeObject(val, altType);
const $d89c9137a3d237c2$var$nodeObjectIntent = (val, altType = null)=>/* new */ $d89c9137a3d237c2$var$nodeObject(val, altType).toVarIntent();
const $d89c9137a3d237c2$var$nodeObjects = (val, altType = null)=>new $d89c9137a3d237c2$var$ShaderNodeObjects(val, altType);
const $d89c9137a3d237c2$var$nodeArray = (val, altType = null)=>new $d89c9137a3d237c2$var$ShaderNodeArray(val, altType);
const $d89c9137a3d237c2$var$nodeProxy = (NodeClass, scope = null, factor = null, settings = null)=>new $d89c9137a3d237c2$var$ShaderNodeProxy(NodeClass, scope, factor, settings);
const $d89c9137a3d237c2$var$nodeImmutable = (NodeClass, ...params)=>new $d89c9137a3d237c2$var$ShaderNodeImmutable(NodeClass, ...params);
const $d89c9137a3d237c2$var$nodeProxyIntent = (NodeClass, scope = null, factor = null, settings = {})=>new $d89c9137a3d237c2$var$ShaderNodeProxy(NodeClass, scope, factor, {
        ...settings,
        intent: true
    });
let $d89c9137a3d237c2$var$fnId = 0;
class $d89c9137a3d237c2$var$FnNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    constructor(jsFunc, layout = null){
        super();
        let nodeType = null;
        if (layout !== null) {
            if (typeof layout === 'object') nodeType = layout.return;
            else {
                if (typeof layout === 'string') nodeType = layout;
                else (0, $329ek.error)('TSL: Invalid layout type.');
                layout = null;
            }
        }
        this.shaderNode = new $d89c9137a3d237c2$var$ShaderNode(jsFunc, nodeType);
        if (layout !== null) this.setLayout(layout);
        this.isFn = true;
    }
    setLayout(layout) {
        const nodeType = this.shaderNode.nodeType;
        if (typeof layout.inputs !== 'object') {
            const fullLayout = {
                name: 'fn' + $d89c9137a3d237c2$var$fnId++,
                type: nodeType,
                inputs: []
            };
            for(const name in layout){
                if (name === 'return') continue;
                fullLayout.inputs.push({
                    name: name,
                    type: layout[name]
                });
            }
            layout = fullLayout;
        }
        this.shaderNode.setLayout(layout);
        return this;
    }
    getNodeType(builder) {
        return this.shaderNode.getNodeType(builder) || 'float';
    }
    call(...params) {
        const fnCall = this.shaderNode.call(params);
        if (this.shaderNode.nodeType === 'void') fnCall.toStack();
        return fnCall.toVarIntent();
    }
    once(subBuilds = null) {
        this.shaderNode.once = true;
        this.shaderNode.subBuilds = subBuilds;
        return this;
    }
    generate(builder) {
        const type = this.getNodeType(builder);
        (0, $329ek.error)('TSL: "Fn()" was declared but not invoked. Try calling it like "Fn()( ...params )".');
        return builder.generateConst(type);
    }
}
function $d89c9137a3d237c2$var$Fn(jsFunc, layout = null) {
    const instance = new $d89c9137a3d237c2$var$FnNode(jsFunc, layout);
    return new Proxy(()=>{}, {
        apply (target, thisArg, params) {
            return instance.call(...params);
        },
        get (target, prop, receiver) {
            return Reflect.get(instance, prop, receiver);
        },
        set (target, prop, value, receiver) {
            return Reflect.set(instance, prop, value, receiver);
        }
    });
}
//
const $d89c9137a3d237c2$var$setCurrentStack = (stack)=>{
    $d89c9137a3d237c2$var$currentStack = stack;
};
const $d89c9137a3d237c2$var$getCurrentStack = ()=>$d89c9137a3d237c2$var$currentStack;
/**
 * Represent a conditional node using if/else statements.
 *
 * ```js
 * If( condition, function )
 * 	.ElseIf( condition, function )
 * 	.Else( function )
 * ```
 * @tsl
 * @function
 * @param {...any} params - The parameters for the conditional node.
 * @returns {StackNode} The conditional node.
 */ const $d89c9137a3d237c2$var$If = (...params)=>$d89c9137a3d237c2$var$currentStack.If(...params);
/**
 * Represent a conditional node using switch/case statements.
 *
 * ```js
 * Switch( value )
 * 	.Case( 1, function )
 * 	.Case( 2, 3, 4, function )
 * 	.Default( function )
 * ```
 * @tsl
 * @function
 * @param {...any} params - The parameters for the conditional node.
 * @returns {StackNode} The conditional node.
 */ const $d89c9137a3d237c2$var$Switch = (...params)=>$d89c9137a3d237c2$var$currentStack.Switch(...params);
/**
 * Add the given node to the current stack.
 *
 * @param {Node} node - The node to add.
 * @returns {Node} The node that was added to the stack.
 */ function $d89c9137a3d237c2$var$Stack(node) {
    if ($d89c9137a3d237c2$var$currentStack) $d89c9137a3d237c2$var$currentStack.addToStack(node);
    return node;
}
$d89c9137a3d237c2$var$addMethodChaining('toStack', $d89c9137a3d237c2$var$Stack);
// types
const $d89c9137a3d237c2$var$color = new $d89c9137a3d237c2$var$ConvertType('color');
const $d89c9137a3d237c2$var$float = new $d89c9137a3d237c2$var$ConvertType('float', $d89c9137a3d237c2$var$cacheMaps.float);
const $d89c9137a3d237c2$var$int = new $d89c9137a3d237c2$var$ConvertType('int', $d89c9137a3d237c2$var$cacheMaps.ints);
const $d89c9137a3d237c2$var$uint = new $d89c9137a3d237c2$var$ConvertType('uint', $d89c9137a3d237c2$var$cacheMaps.uint);
const $d89c9137a3d237c2$var$bool = new $d89c9137a3d237c2$var$ConvertType('bool', $d89c9137a3d237c2$var$cacheMaps.bool);
const $d89c9137a3d237c2$var$vec2 = new $d89c9137a3d237c2$var$ConvertType('vec2');
const $d89c9137a3d237c2$var$ivec2 = new $d89c9137a3d237c2$var$ConvertType('ivec2');
const $d89c9137a3d237c2$var$uvec2 = new $d89c9137a3d237c2$var$ConvertType('uvec2');
const $d89c9137a3d237c2$var$bvec2 = new $d89c9137a3d237c2$var$ConvertType('bvec2');
const $d89c9137a3d237c2$var$vec3 = new $d89c9137a3d237c2$var$ConvertType('vec3');
const $d89c9137a3d237c2$var$ivec3 = new $d89c9137a3d237c2$var$ConvertType('ivec3');
const $d89c9137a3d237c2$var$uvec3 = new $d89c9137a3d237c2$var$ConvertType('uvec3');
const $d89c9137a3d237c2$var$bvec3 = new $d89c9137a3d237c2$var$ConvertType('bvec3');
const $d89c9137a3d237c2$var$vec4 = new $d89c9137a3d237c2$var$ConvertType('vec4');
const $d89c9137a3d237c2$var$ivec4 = new $d89c9137a3d237c2$var$ConvertType('ivec4');
const $d89c9137a3d237c2$var$uvec4 = new $d89c9137a3d237c2$var$ConvertType('uvec4');
const $d89c9137a3d237c2$var$bvec4 = new $d89c9137a3d237c2$var$ConvertType('bvec4');
const $d89c9137a3d237c2$var$mat2 = new $d89c9137a3d237c2$var$ConvertType('mat2');
const $d89c9137a3d237c2$var$mat3 = new $d89c9137a3d237c2$var$ConvertType('mat3');
const $d89c9137a3d237c2$var$mat4 = new $d89c9137a3d237c2$var$ConvertType('mat4');
const $d89c9137a3d237c2$var$string = (value = '')=>new $d89c9137a3d237c2$export$ec99b5196691da75(value, 'string');
const $d89c9137a3d237c2$var$arrayBuffer = (value)=>new $d89c9137a3d237c2$export$ec99b5196691da75(value, 'ArrayBuffer');
$d89c9137a3d237c2$var$addMethodChaining('toColor', $d89c9137a3d237c2$var$color);
$d89c9137a3d237c2$var$addMethodChaining('toFloat', $d89c9137a3d237c2$var$float);
$d89c9137a3d237c2$var$addMethodChaining('toInt', $d89c9137a3d237c2$var$int);
$d89c9137a3d237c2$var$addMethodChaining('toUint', $d89c9137a3d237c2$var$uint);
$d89c9137a3d237c2$var$addMethodChaining('toBool', $d89c9137a3d237c2$var$bool);
$d89c9137a3d237c2$var$addMethodChaining('toVec2', $d89c9137a3d237c2$var$vec2);
$d89c9137a3d237c2$var$addMethodChaining('toIVec2', $d89c9137a3d237c2$var$ivec2);
$d89c9137a3d237c2$var$addMethodChaining('toUVec2', $d89c9137a3d237c2$var$uvec2);
$d89c9137a3d237c2$var$addMethodChaining('toBVec2', $d89c9137a3d237c2$var$bvec2);
$d89c9137a3d237c2$var$addMethodChaining('toVec3', $d89c9137a3d237c2$var$vec3);
$d89c9137a3d237c2$var$addMethodChaining('toIVec3', $d89c9137a3d237c2$var$ivec3);
$d89c9137a3d237c2$var$addMethodChaining('toUVec3', $d89c9137a3d237c2$var$uvec3);
$d89c9137a3d237c2$var$addMethodChaining('toBVec3', $d89c9137a3d237c2$var$bvec3);
$d89c9137a3d237c2$var$addMethodChaining('toVec4', $d89c9137a3d237c2$var$vec4);
$d89c9137a3d237c2$var$addMethodChaining('toIVec4', $d89c9137a3d237c2$var$ivec4);
$d89c9137a3d237c2$var$addMethodChaining('toUVec4', $d89c9137a3d237c2$var$uvec4);
$d89c9137a3d237c2$var$addMethodChaining('toBVec4', $d89c9137a3d237c2$var$bvec4);
$d89c9137a3d237c2$var$addMethodChaining('toMat2', $d89c9137a3d237c2$var$mat2);
$d89c9137a3d237c2$var$addMethodChaining('toMat3', $d89c9137a3d237c2$var$mat3);
$d89c9137a3d237c2$var$addMethodChaining('toMat4', $d89c9137a3d237c2$var$mat4);
// basic nodes
const $d89c9137a3d237c2$var$element = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$f2edd1d22bf6d00b).setParameterLength(2);
const $d89c9137a3d237c2$var$convert = (node, types)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$77fac4ed96fd2435($d89c9137a3d237c2$var$nodeObject(node), types));
const $d89c9137a3d237c2$var$split = (node, channels)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$3cd993069e2dfb64($d89c9137a3d237c2$var$nodeObject(node), channels));
$d89c9137a3d237c2$var$addMethodChaining('element', $d89c9137a3d237c2$var$element);
$d89c9137a3d237c2$var$addMethodChaining('convert', $d89c9137a3d237c2$var$convert);
// deprecated
/**
 * @tsl
 * @function
 * @deprecated since r176. Use {@link Stack} instead.
 *
 * @param {Node} node - The node to add.
 * @returns {Function}
 */ const $d89c9137a3d237c2$var$append = (node)=>{
    (0, $329ek.warn)('TSL: append() has been renamed to Stack().');
    return $d89c9137a3d237c2$var$Stack(node);
};
$d89c9137a3d237c2$var$addMethodChaining('append', (node)=>{
    (0, $329ek.warn)('TSL: .append() has been renamed to .toStack().');
    return $d89c9137a3d237c2$var$Stack(node);
});
/**
 * This class represents a shader property. It can be used
 * to explicitly define a property and assign a value to it.
 *
 * ```js
 * const threshold = property( 'float', 'threshold' ).assign( THRESHOLD );
 *```
 * `PropertyNode` is used by the engine to predefined common material properties
 * for TSL code.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$c87c56924d182f24 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'PropertyNode';
    }
    /**
	 * Constructs a new property node.
	 *
	 * @param {string} nodeType - The type of the node.
	 * @param {?string} [name=null] - The name of the property in the shader.
	 * @param {boolean} [varying=false] - Whether this property is a varying or not.
	 */ constructor(nodeType, name = null, varying = false){
        super(nodeType);
        /**
		 * The name of the property in the shader. If no name is defined,
		 * the node system auto-generates one.
		 *
		 * @type {?string}
		 * @default null
		 */ this.name = name;
        /**
		 * Whether this property is a varying or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.varying = varying;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPropertyNode = true;
        /**
		 * This flag is used for global cache.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
    }
    customCacheKey() {
        return $d89c9137a3d237c2$var$hashString(this.type + ':' + (this.name || '') + ':' + (this.varying ? '1' : '0'));
    }
    getHash(builder) {
        return this.name || super.getHash(builder);
    }
    generate(builder) {
        let nodeVar;
        if (this.varying === true) {
            nodeVar = builder.getVaryingFromNode(this, this.name);
            nodeVar.needsInterpolation = true;
        } else nodeVar = builder.getVarFromNode(this, this.name);
        return builder.getPropertyName(nodeVar);
    }
}
/**
 * TSL function for creating a property node.
 *
 * @tsl
 * @function
 * @param {string} type - The type of the node.
 * @param {?string} [name=null] - The name of the property in the shader.
 * @returns {PropertyNode}
 */ const $d89c9137a3d237c2$var$property = (type, name)=>new $d89c9137a3d237c2$export$c87c56924d182f24(type, name);
/**
 * TSL function for creating a varying property node.
 *
 * @tsl
 * @function
 * @param {string} type - The type of the node.
 * @param {?string} [name=null] - The name of the varying in the shader.
 * @returns {PropertyNode}
 */ const $d89c9137a3d237c2$var$varyingProperty = (type, name)=>new $d89c9137a3d237c2$export$c87c56924d182f24(type, name, true);
/**
 * TSL object that represents the shader variable `DiffuseColor`.
 *
 * @tsl
 * @type {PropertyNode<vec4>}
 */ const $d89c9137a3d237c2$var$diffuseColor = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'vec4', 'DiffuseColor');
/**
 * TSL object that represents the shader variable `DiffuseContribution`.
 *
 * @tsl
 * @type {PropertyNode<vec3>}
 */ const $d89c9137a3d237c2$var$diffuseContribution = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'vec3', 'DiffuseContribution');
/**
 * TSL object that represents the shader variable `EmissiveColor`.
 *
 * @tsl
 * @type {PropertyNode<vec3>}
 */ const $d89c9137a3d237c2$var$emissive = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'vec3', 'EmissiveColor');
/**
 * TSL object that represents the shader variable `Roughness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$roughness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'Roughness');
/**
 * TSL object that represents the shader variable `Metalness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$metalness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'Metalness');
/**
 * TSL object that represents the shader variable `Clearcoat`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$clearcoat = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'Clearcoat');
/**
 * TSL object that represents the shader variable `ClearcoatRoughness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$clearcoatRoughness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'ClearcoatRoughness');
/**
 * TSL object that represents the shader variable `Sheen`.
 *
 * @tsl
 * @type {PropertyNode<vec3>}
 */ const $d89c9137a3d237c2$var$sheen = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'vec3', 'Sheen');
/**
 * TSL object that represents the shader variable `SheenRoughness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$sheenRoughness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'SheenRoughness');
/**
 * TSL object that represents the shader variable `Iridescence`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$iridescence = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'Iridescence');
/**
 * TSL object that represents the shader variable `IridescenceIOR`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$iridescenceIOR = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'IridescenceIOR');
/**
 * TSL object that represents the shader variable `IridescenceThickness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$iridescenceThickness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'IridescenceThickness');
/**
 * TSL object that represents the shader variable `AlphaT`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$alphaT = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'AlphaT');
/**
 * TSL object that represents the shader variable `Anisotropy`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$anisotropy = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'Anisotropy');
/**
 * TSL object that represents the shader variable `AnisotropyT`.
 *
 * @tsl
 * @type {PropertyNode<vec3>}
 */ const $d89c9137a3d237c2$var$anisotropyT = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'vec3', 'AnisotropyT');
/**
 * TSL object that represents the shader variable `AnisotropyB`.
 *
 * @tsl
 * @type {PropertyNode<vec3>}
 */ const $d89c9137a3d237c2$var$anisotropyB = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'vec3', 'AnisotropyB');
/**
 * TSL object that represents the shader variable `SpecularColor`.
 *
 * @tsl
 * @type {PropertyNode<color>}
 */ const $d89c9137a3d237c2$var$specularColor = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'color', 'SpecularColor');
/**
 * TSL object that represents the shader variable `SpecularColorBlended`.
 *
 * @tsl
 * @type {PropertyNode<color>}
 */ const $d89c9137a3d237c2$var$specularColorBlended = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'color', 'SpecularColorBlended');
/**
 * TSL object that represents the shader variable `SpecularF90`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$specularF90 = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'SpecularF90');
/**
 * TSL object that represents the shader variable `Shininess`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$shininess = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'Shininess');
/**
 * TSL object that represents the shader variable `Output`.
 *
 * @tsl
 * @type {PropertyNode<vec4>}
 */ const $d89c9137a3d237c2$var$output = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'vec4', 'Output');
/**
 * TSL object that represents the shader variable `dashSize`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$dashSize = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'dashSize');
/**
 * TSL object that represents the shader variable `gapSize`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$gapSize = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'gapSize');
/**
 * TSL object that represents the shader variable `pointWidth`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$pointWidth = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'pointWidth');
/**
 * TSL object that represents the shader variable `IOR`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$ior = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'IOR');
/**
 * TSL object that represents the shader variable `Transmission`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$transmission = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'Transmission');
/**
 * TSL object that represents the shader variable `Thickness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$thickness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'Thickness');
/**
 * TSL object that represents the shader variable `AttenuationDistance`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$attenuationDistance = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'AttenuationDistance');
/**
 * TSL object that represents the shader variable `AttenuationColor`.
 *
 * @tsl
 * @type {PropertyNode<color>}
 */ const $d89c9137a3d237c2$var$attenuationColor = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'color', 'AttenuationColor');
/**
 * TSL object that represents the shader variable `Dispersion`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $d89c9137a3d237c2$var$dispersion = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$c87c56924d182f24, 'float', 'Dispersion');
/**
 * This node can be used to group single instances of {@link UniformNode}
 * and manage them as a uniform buffer.
 *
 * In most cases, the predefined nodes `objectGroup`, `renderGroup` and `frameGroup`
 * will be used when defining the {@link UniformNode#groupNode} property.
 *
 * - `objectGroup`: Uniform buffer per object.
 * - `renderGroup`: Shared uniform buffer, updated once per render call.
 * - `frameGroup`: Shared uniform buffer, updated once per frame.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$15b35e9032996af8 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'UniformGroupNode';
    }
    /**
	 * Constructs a new uniform group node.
	 *
	 * @param {string} name - The name of the uniform group node.
	 * @param {boolean} [shared=false] - Whether this uniform group node is shared or not.
	 * @param {number} [order=1] - Influences the internal sorting.
	 */ constructor(name, shared = false, order = 1){
        super('string');
        /**
		 * The name of the uniform group node.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * Whether this uniform group node is shared or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.shared = shared;
        /**
		 * Influences the internal sorting.
		 * TODO: Add details when this property should be changed.
		 *
		 * @type {number}
		 * @default 1
		 */ this.order = order;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformGroup = true;
    }
    serialize(data) {
        super.serialize(data);
        data.name = this.name;
        data.version = this.version;
        data.shared = this.shared;
    }
    deserialize(data) {
        super.deserialize(data);
        this.name = data.name;
        this.version = data.version;
        this.shared = data.shared;
    }
}
/**
 * TSL function for creating a uniform group node with the given name.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the uniform group node.
 * @returns {UniformGroupNode}
 */ const $d89c9137a3d237c2$var$uniformGroup = (name)=>new $d89c9137a3d237c2$export$15b35e9032996af8(name);
/**
 * TSL function for creating a shared uniform group node with the given name and order.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the uniform group node.
 * @param {number} [order=0] - Influences the internal sorting.
 * @returns {UniformGroupNode}
 */ const $d89c9137a3d237c2$var$sharedUniformGroup = (name, order = 0)=>new $d89c9137a3d237c2$export$15b35e9032996af8(name, true, order);
/**
 * TSL object that represents a shared uniform group node which is updated once per frame.
 *
 * @tsl
 * @type {UniformGroupNode}
 */ const $d89c9137a3d237c2$var$frameGroup = /*@__PURE__*/ $d89c9137a3d237c2$var$sharedUniformGroup('frame');
/**
 * TSL object that represents a shared uniform group node which is updated once per render.
 *
 * @tsl
 * @type {UniformGroupNode}
 */ const $d89c9137a3d237c2$var$renderGroup = /*@__PURE__*/ $d89c9137a3d237c2$var$sharedUniformGroup('render');
/**
 * TSL object that represents a uniform group node which is updated once per object.
 *
 * @tsl
 * @type {UniformGroupNode}
 */ const $d89c9137a3d237c2$var$objectGroup = /*@__PURE__*/ $d89c9137a3d237c2$var$uniformGroup('object');
/**
 * Class for representing a uniform.
 *
 * @augments InputNode
 */ class $d89c9137a3d237c2$export$c0cca4cf699a03e1 extends $d89c9137a3d237c2$var$InputNode {
    static get type() {
        return 'UniformNode';
    }
    /**
	 * Constructs a new uniform node.
	 *
	 * @param {any} value - The value of this node. Usually a JS primitive or three.js object (vector, matrix, color, texture).
	 * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
	 */ constructor(value, nodeType = null){
        super(value, nodeType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformNode = true;
        /**
		 * The name or label of the uniform.
		 *
		 * @type {string}
		 * @default ''
		 */ this.name = '';
        /**
		 * The uniform group of this uniform. By default, uniforms are
		 * managed per object but they might belong to a shared group
		 * which is updated per frame or render call.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = $d89c9137a3d237c2$var$objectGroup;
    }
    /**
	 * Sets the {@link UniformNode#name} property.
	 *
	 * @param {string} name - The name of the uniform.
	 * @return {UniformNode} A reference to this node.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the {@link UniformNode#name} property.
	 *
	 * @deprecated
	 * @param {string} name - The name of the uniform.
	 * @return {UniformNode} A reference to this node.
	 */ label(name) {
        (0, $329ek.warn)('TSL: "label()" has been deprecated. Use "setName()" instead.'); // @deprecated r179
        return this.setName(name);
    }
    /**
	 * Sets the {@link UniformNode#groupNode} property.
	 *
	 * @param {UniformGroupNode} group - The uniform group.
	 * @return {UniformNode} A reference to this node.
	 */ setGroup(group) {
        this.groupNode = group;
        return this;
    }
    /**
	 * Returns the {@link UniformNode#groupNode}.
	 *
	 * @return {UniformGroupNode} The uniform group.
	 */ getGroup() {
        return this.groupNode;
    }
    /**
	 * By default, this method returns the result of {@link Node#getHash} but derived
	 * classes might overwrite this method with a different implementation.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The uniform hash.
	 */ getUniformHash(builder) {
        return this.getHash(builder);
    }
    onUpdate(callback, updateType) {
        callback = callback.bind(this);
        return super.onUpdate((frame)=>{
            const value = callback(frame, this);
            if (value !== undefined) this.value = value;
        }, updateType);
    }
    getInputType(builder) {
        let type = super.getInputType(builder);
        if (type === 'bool') type = 'uint';
        return type;
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const hash = this.getUniformHash(builder);
        let sharedNode = builder.getNodeFromHash(hash);
        if (sharedNode === undefined) {
            builder.setHashNode(this, hash);
            sharedNode = this;
        }
        const sharedNodeType = sharedNode.getInputType(builder);
        const nodeUniform = builder.getUniformFromNode(sharedNode, sharedNodeType, builder.shaderStage, this.name || builder.context.nodeName);
        const uniformName = builder.getPropertyName(nodeUniform);
        if (builder.context.nodeName !== undefined) delete builder.context.nodeName;
        //
        let snippet = uniformName;
        if (type === 'bool') {
            // cache to variable
            const nodeData = builder.getDataFromNode(this);
            let propertyName = nodeData.propertyName;
            if (propertyName === undefined) {
                const nodeVar = builder.getVarFromNode(this, null, 'bool');
                propertyName = builder.getPropertyName(nodeVar);
                nodeData.propertyName = propertyName;
                snippet = builder.format(uniformName, sharedNodeType, type);
                builder.addLineFlowCode(`${propertyName} = ${snippet}`, this);
            }
            snippet = propertyName;
        }
        return builder.format(snippet, type, output);
    }
}
/**
 * TSL function for creating a uniform node.
 *
 * @tsl
 * @function
 * @param {any|string} value - The value of this uniform or your type. Usually a JS primitive or three.js object (vector, matrix, color, texture).
 * @param {string} [type] - The node type. If no explicit type is defined, the node tries to derive the type from its value.
 * @returns {UniformNode}
 */ const $d89c9137a3d237c2$var$uniform = (value, type)=>{
    const nodeType = $d89c9137a3d237c2$var$getConstNodeType(type || value);
    if (nodeType === value) // if the value is a type but no having a value
    value = $d89c9137a3d237c2$var$getValueFromType(nodeType);
    if (value && value.isNode === true) {
        let v = value.value;
        value.traverse((n)=>{
            if (n.isConstNode === true) v = n.value;
        });
        value = v;
    }
    return new $d89c9137a3d237c2$export$c0cca4cf699a03e1(value, nodeType);
};
/**
 * ArrayNode represents a collection of nodes, typically created using the {@link array} function.
 * ```js
 * const colors = array( [
 * 	vec3( 1, 0, 0 ),
 * 	vec3( 0, 1, 0 ),
 * 	vec3( 0, 0, 1 )
 * ] );
 *
 * const redColor = tintColors.element( 0 );
 * ```
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$97d96bf9b84874d5 extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'ArrayNode';
    }
    /**
	 * Constructs a new array node.
	 *
	 * @param {?string} nodeType - The data type of the elements.
	 * @param {number} count - Size of the array.
	 * @param {?Array<Node>} [values=null] - Array default values.
	 */ constructor(nodeType, count, values = null){
        super(nodeType);
        /**
		 * Array size.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * Array default values.
		 *
		 * @type {?Array<Node>}
		 */ this.values = values;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayNode = true;
    }
    /**
	 * Returns the number of elements in the node array.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {number} The number of elements in the node array.
	 */ getArrayCount() {
        return this.count;
    }
    /**
	 * Returns the node's type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The type of the node.
	 */ getNodeType(builder) {
        if (this.nodeType === null) return this.values[0].getNodeType(builder);
        return this.nodeType;
    }
    /**
	 * Returns the node's type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The type of the node.
	 */ getElementType(builder) {
        return this.getNodeType(builder);
    }
    /**
	 * Returns the type of a member variable.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The name of the member variable.
	 * @return {string} The type of the member variable.
	 */ getMemberType(builder, name) {
        if (this.nodeType === null) return this.values[0].getMemberType(builder, name);
        return super.getMemberType(builder, name);
    }
    /**
	 * This method builds the output node and returns the resulting array as a shader string.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated shader string.
	 */ generate(builder) {
        const type = this.getNodeType(builder);
        return builder.generateArray(type, this.count, this.values);
    }
}
/**
 * TSL function for creating an array node.
 *
 * @tsl
 * @function
 * @param {string|Array<Node>} nodeTypeOrValues - A string representing the element type (e.g., 'vec3')
 * or an array containing the default values (e.g., [ vec3() ]).
 * @param {?number} [count] - Size of the array.
 * @returns {ArrayNode}
 */ const $d89c9137a3d237c2$var$array = (...params)=>{
    let node;
    if (params.length === 1) {
        const values = params[0];
        node = new $d89c9137a3d237c2$export$97d96bf9b84874d5(null, values.length, values);
    } else {
        const nodeType = params[0];
        const count = params[1];
        node = new $d89c9137a3d237c2$export$97d96bf9b84874d5(nodeType, count);
    }
    return $d89c9137a3d237c2$var$nodeObject(node);
};
$d89c9137a3d237c2$var$addMethodChaining('toArray', (node, count)=>$d89c9137a3d237c2$var$array(Array(count).fill(node)));
/**
 * These node represents an assign operation. Meaning a node is assigned
 * to another node.
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$ebe87770a40e383b extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'AssignNode';
    }
    /**
	 * Constructs a new assign node.
	 *
	 * @param {Node} targetNode - The target node.
	 * @param {Node} sourceNode - The source type.
	 */ constructor(targetNode, sourceNode){
        super();
        /**
		 * The target node.
		 *
		 * @type {Node}
		 */ this.targetNode = targetNode;
        /**
		 * The source node.
		 *
		 * @type {Node}
		 */ this.sourceNode = sourceNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAssignNode = true;
    }
    /**
	 * Whether this node is used more than once in context of other nodes. This method
	 * is overwritten since it always returns `false` (assigns are unique).
	 *
	 * @return {boolean} A flag that indicates if there is more than one dependency to other nodes. Always `false`.
	 */ hasDependencies() {
        return false;
    }
    getNodeType(builder, output) {
        return output !== 'void' ? this.targetNode.getNodeType(builder) : 'void';
    }
    /**
	 * Whether a split is required when assigning source to target. This can happen when the component length of
	 * target and source data type does not match.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {boolean} Whether a split is required when assigning source to target.
	 */ needsSplitAssign(builder) {
        const { targetNode: targetNode } = this;
        if (builder.isAvailable('swizzleAssign') === false && targetNode.isSplitNode && targetNode.components.length > 1) {
            const targetLength = builder.getTypeLength(targetNode.node.getNodeType(builder));
            const assignDifferentVector = $d89c9137a3d237c2$export$1c0adcb9073b646d.join('').slice(0, targetLength) !== targetNode.components;
            return assignDifferentVector;
        }
        return false;
    }
    setup(builder) {
        const { targetNode: targetNode, sourceNode: sourceNode } = this;
        const scope = targetNode.getScope();
        const scopeData = builder.getDataFromNode(scope);
        scopeData.assign = true;
        const properties = builder.getNodeProperties(this);
        properties.sourceNode = sourceNode;
        properties.targetNode = targetNode.context({
            assign: true
        });
    }
    generate(builder, output) {
        const { targetNode: targetNode, sourceNode: sourceNode } = builder.getNodeProperties(this);
        const needsSplitAssign = this.needsSplitAssign(builder);
        const target = targetNode.build(builder);
        const targetType = targetNode.getNodeType(builder);
        const source = sourceNode.build(builder, targetType);
        const sourceType = sourceNode.getNodeType(builder);
        const nodeData = builder.getDataFromNode(this);
        //
        let snippet;
        if (nodeData.initialized === true) {
            if (output !== 'void') snippet = target;
        } else if (needsSplitAssign) {
            const sourceVar = builder.getVarFromNode(this, null, targetType);
            const sourceProperty = builder.getPropertyName(sourceVar);
            builder.addLineFlowCode(`${sourceProperty} = ${source}`, this);
            const splitNode = targetNode.node;
            const splitTargetNode = splitNode.node.context({
                assign: true
            });
            const targetRoot = splitTargetNode.build(builder);
            for(let i = 0; i < splitNode.components.length; i++){
                const component = splitNode.components[i];
                builder.addLineFlowCode(`${targetRoot}.${component} = ${sourceProperty}[ ${i} ]`, this);
            }
            if (output !== 'void') snippet = target;
        } else {
            snippet = `${target} = ${source}`;
            if (output === 'void' || sourceType === 'void') {
                builder.addLineFlowCode(snippet, this);
                if (output !== 'void') snippet = target;
            }
        }
        nodeData.initialized = true;
        return builder.format(snippet, targetType, output);
    }
}
/**
 * TSL function for creating an assign node.
 *
 * @tsl
 * @function
 * @param {Node} targetNode - The target node.
 * @param {Node} sourceNode - The source type.
 * @returns {AssignNode}
 */ const $d89c9137a3d237c2$var$assign = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$ebe87770a40e383b).setParameterLength(2);
$d89c9137a3d237c2$var$addMethodChaining('assign', $d89c9137a3d237c2$var$assign);
/**
 * This module represents the call of a {@link FunctionNode}. Developers are usually not confronted
 * with this module since they use the predefined TSL syntax `wgslFn` and `glslFn` which encapsulate
 * this logic.
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$cc00f01476ebb746 extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'FunctionCallNode';
    }
    /**
	 * Constructs a new function call node.
	 *
	 * @param {?FunctionNode} functionNode - The function node.
	 * @param {Object<string, Node>} [parameters={}] - The parameters for the function call.
	 */ constructor(functionNode = null, parameters = {}){
        super();
        /**
		 * The function node.
		 *
		 * @type {?FunctionNode}
		 * @default null
		 */ this.functionNode = functionNode;
        /**
		 * The parameters of the function call.
		 *
		 * @type {Object<string, Node>}
		 * @default {}
		 */ this.parameters = parameters;
    }
    /**
	 * Sets the parameters of the function call node.
	 *
	 * @param {Object<string, Node>} parameters - The parameters to set.
	 * @return {FunctionCallNode} A reference to this node.
	 */ setParameters(parameters) {
        this.parameters = parameters;
        return this;
    }
    /**
	 * Returns the parameters of the function call node.
	 *
	 * @return {Object<string, Node>} The parameters of this node.
	 */ getParameters() {
        return this.parameters;
    }
    /**
	 * Returns the type of this function call node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @returns {string} The type of this node.
	 */ getNodeType(builder) {
        return this.functionNode.getNodeType(builder);
    }
    /**
	 * Returns the function node of this function call node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} [name] - The name of the member.
	 * @returns {string} The type of the member.
	 */ getMemberType(builder, name) {
        return this.functionNode.getMemberType(builder, name);
    }
    generate(builder) {
        const params = [];
        const functionNode = this.functionNode;
        const inputs = functionNode.getInputs(builder);
        const parameters = this.parameters;
        const generateInput = (node, inputNode)=>{
            const type = inputNode.type;
            const pointer = type === 'pointer';
            let output;
            if (pointer) output = '&' + node.build(builder);
            else output = node.build(builder, type);
            return output;
        };
        if (Array.isArray(parameters)) {
            if (parameters.length > inputs.length) {
                (0, $329ek.error)('TSL: The number of provided parameters exceeds the expected number of inputs in \'Fn()\'.');
                parameters.length = inputs.length;
            } else if (parameters.length < inputs.length) {
                (0, $329ek.error)('TSL: The number of provided parameters is less than the expected number of inputs in \'Fn()\'.');
                while(parameters.length < inputs.length)parameters.push($d89c9137a3d237c2$var$float(0));
            }
            for(let i = 0; i < parameters.length; i++)params.push(generateInput(parameters[i], inputs[i]));
        } else for (const inputNode of inputs){
            const node = parameters[inputNode.name];
            if (node !== undefined) params.push(generateInput(node, inputNode));
            else {
                (0, $329ek.error)(`TSL: Input '${inputNode.name}' not found in \'Fn()\'.`);
                params.push(generateInput($d89c9137a3d237c2$var$float(0), inputNode));
            }
        }
        const functionName = functionNode.build(builder, 'property');
        return `${functionName}( ${params.join(', ')} )`;
    }
}
const $d89c9137a3d237c2$var$call = (func, ...params)=>{
    params = params.length > 1 || params[0] && params[0].isNode === true ? $d89c9137a3d237c2$var$nodeArray(params) : $d89c9137a3d237c2$var$nodeObjects(params[0]);
    return new $d89c9137a3d237c2$export$cc00f01476ebb746($d89c9137a3d237c2$var$nodeObject(func), params);
};
$d89c9137a3d237c2$var$addMethodChaining('call', $d89c9137a3d237c2$var$call);
const $d89c9137a3d237c2$var$_vectorOperators = {
    '==': 'equal',
    '!=': 'notEqual',
    '<': 'lessThan',
    '>': 'greaterThan',
    '<=': 'lessThanEqual',
    '>=': 'greaterThanEqual',
    '%': 'mod'
};
/**
 * This node represents basic mathematical and logical operations like addition,
 * subtraction or comparisons (e.g. `equal()`).
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$var$OperatorNode extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'OperatorNode';
    }
    /**
	 * Constructs a new operator node.
	 *
	 * @param {string} op - The operator.
	 * @param {Node} aNode - The first input.
	 * @param {Node} bNode - The second input.
	 * @param {...Node} params - Additional input parameters.
	 */ constructor(op, aNode, bNode, ...params){
        super();
        if (params.length > 0) {
            let finalOp = new $d89c9137a3d237c2$var$OperatorNode(op, aNode, bNode);
            for(let i = 0; i < params.length - 1; i++)finalOp = new $d89c9137a3d237c2$var$OperatorNode(op, finalOp, params[i]);
            aNode = finalOp;
            bNode = params[params.length - 1];
        }
        /**
		 * The operator.
		 *
		 * @type {string}
		 */ this.op = op;
        /**
		 * The first input.
		 *
		 * @type {Node}
		 */ this.aNode = aNode;
        /**
		 * The second input.
		 *
		 * @type {Node}
		 */ this.bNode = bNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOperatorNode = true;
    }
    /**
	 * Returns the operator method name.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} output - The output type.
	 * @returns {string} The operator method name.
	 */ getOperatorMethod(builder, output) {
        return builder.getMethod($d89c9137a3d237c2$var$_vectorOperators[this.op], output);
    }
    /**
	 * This method is overwritten since the node type is inferred from the operator
	 * and the input node types.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {?string} [output=null] - The output type.
	 * @return {string} The node type.
	 */ getNodeType(builder, output = null) {
        const op = this.op;
        const aNode = this.aNode;
        const bNode = this.bNode;
        const typeA = aNode.getNodeType(builder);
        const typeB = bNode ? bNode.getNodeType(builder) : null;
        if (typeA === 'void' || typeB === 'void') return output || 'void';
        else if (op === '%') return typeA;
        else if (op === '~' || op === '&' || op === '|' || op === '^' || op === '>>' || op === '<<') return builder.getIntegerType(typeA);
        else if (op === '!' || op === '&&' || op === '||' || op === '^^') return 'bool';
        else if (op === '==' || op === '!=' || op === '<' || op === '>' || op === '<=' || op === '>=') {
            const typeLength = Math.max(builder.getTypeLength(typeA), builder.getTypeLength(typeB));
            return typeLength > 1 ? `bvec${typeLength}` : 'bool';
        } else {
            // Handle matrix operations
            if (builder.isMatrix(typeA)) {
                if (typeB === 'float') return typeA; // matrix * scalar = matrix
                else if (builder.isVector(typeB)) return builder.getVectorFromMatrix(typeA); // matrix * vector
                else if (builder.isMatrix(typeB)) return typeA; // matrix * matrix
            } else if (builder.isMatrix(typeB)) {
                if (typeA === 'float') return typeB; // scalar * matrix = matrix
                else if (builder.isVector(typeA)) return builder.getVectorFromMatrix(typeB); // vector * matrix
            }
            // Handle non-matrix cases
            if (builder.getTypeLength(typeB) > builder.getTypeLength(typeA)) // anytype x anytype: use the greater length vector
            return typeB;
            return typeA;
        }
    }
    generate(builder, output) {
        const op = this.op;
        const { aNode: aNode, bNode: bNode } = this;
        const type = this.getNodeType(builder, output);
        let typeA = null;
        let typeB = null;
        if (type !== 'void') {
            typeA = aNode.getNodeType(builder);
            typeB = bNode ? bNode.getNodeType(builder) : null;
            if (op === '<' || op === '>' || op === '<=' || op === '>=' || op === '==' || op === '!=') {
                if (builder.isVector(typeA)) typeB = typeA;
                else if (builder.isVector(typeB)) typeA = typeB;
                else if (typeA !== typeB) typeA = typeB = 'float';
            } else if (op === '>>' || op === '<<') {
                typeA = type;
                typeB = builder.changeComponentType(typeB, 'uint');
            } else if (op === '%') {
                typeA = type;
                typeB = builder.isInteger(typeA) && builder.isInteger(typeB) ? typeB : typeA;
            } else if (builder.isMatrix(typeA)) {
                if (typeB === 'float') // Keep matrix type for typeA, but ensure typeB stays float
                typeB = 'float';
                else if (builder.isVector(typeB)) // matrix x vector
                typeB = builder.getVectorFromMatrix(typeA);
                else if (builder.isMatrix(typeB)) ;
                else typeA = typeB = type;
            } else if (builder.isMatrix(typeB)) {
                if (typeA === 'float') // Keep matrix type for typeB, but ensure typeA stays float
                typeA = 'float';
                else if (builder.isVector(typeA)) // vector x matrix
                typeA = builder.getVectorFromMatrix(typeB);
                else typeA = typeB = type;
            } else // anytype x anytype
            typeA = typeB = type;
        } else typeA = typeB = type;
        const a = aNode.build(builder, typeA);
        const b = bNode ? bNode.build(builder, typeB) : null;
        const fnOpSnippet = builder.getFunctionOperator(op);
        if (output !== 'void') {
            const isGLSL = builder.renderer.coordinateSystem === (0, $329ek.WebGLCoordinateSystem);
            if (op === '==' || op === '!=' || op === '<' || op === '>' || op === '<=' || op === '>=') {
                if (isGLSL) {
                    if (builder.isVector(typeA)) return builder.format(`${this.getOperatorMethod(builder, output)}( ${a}, ${b} )`, type, output);
                    else return builder.format(`( ${a} ${op} ${b} )`, type, output);
                } else // WGSL
                return builder.format(`( ${a} ${op} ${b} )`, type, output);
            } else if (op === '%') {
                if (builder.isInteger(typeB)) return builder.format(`( ${a} % ${b} )`, type, output);
                else return builder.format(`${this.getOperatorMethod(builder, type)}( ${a}, ${b} )`, type, output);
            } else if (op === '!' || op === '~') return builder.format(`(${op}${a})`, typeA, output);
            else if (fnOpSnippet) return builder.format(`${fnOpSnippet}( ${a}, ${b} )`, type, output);
            else {
                // Handle matrix operations
                if (builder.isMatrix(typeA) && typeB === 'float') return builder.format(`( ${b} ${op} ${a} )`, type, output);
                else if (typeA === 'float' && builder.isMatrix(typeB)) return builder.format(`${a} ${op} ${b}`, type, output);
                else {
                    let snippet = `( ${a} ${op} ${b} )`;
                    if (!isGLSL && type === 'bool' && builder.isVector(typeA) && builder.isVector(typeB)) snippet = `all${snippet}`;
                    return builder.format(snippet, type, output);
                }
            }
        } else if (typeA !== 'void') {
            if (fnOpSnippet) return builder.format(`${fnOpSnippet}( ${a}, ${b} )`, type, output);
            else {
                if (builder.isMatrix(typeA) && typeB === 'float') return builder.format(`${b} ${op} ${a}`, type, output);
                else return builder.format(`${a} ${op} ${b}`, type, output);
            }
        }
    }
    serialize(data) {
        super.serialize(data);
        data.op = this.op;
    }
    deserialize(data) {
        super.deserialize(data);
        this.op = data.op;
    }
}
/**
 * Returns the addition of two or more value.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @param {...Node} params - Additional input parameters.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$add = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '+').setParameterLength(2, Infinity).setName('add');
/**
 * Returns the subtraction of two or more value.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @param {...Node} params - Additional input parameters.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$sub = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '-').setParameterLength(2, Infinity).setName('sub');
/**
 * Returns the multiplication of two or more value.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @param {...Node} params - Additional input parameters.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$mul = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '*').setParameterLength(2, Infinity).setName('mul');
/**
 * Returns the division of two or more value.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @param {...Node} params - Additional input parameters.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$div = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '/').setParameterLength(2, Infinity).setName('div');
/**
 * Computes the remainder of dividing the first node by the second one.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$mod = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '%').setParameterLength(2).setName('mod');
/**
 * Checks if two nodes are equal.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$equal = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '==').setParameterLength(2).setName('equal');
/**
 * Checks if two nodes are not equal.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$notEqual = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '!=').setParameterLength(2).setName('notEqual');
/**
 * Checks if the first node is less than the second.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$lessThan = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '<').setParameterLength(2).setName('lessThan');
/**
 * Checks if the first node is greater than the second.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$greaterThan = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '>').setParameterLength(2).setName('greaterThan');
/**
 * Checks if the first node is less than or equal to the second.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$lessThanEqual = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '<=').setParameterLength(2).setName('lessThanEqual');
/**
 * Checks if the first node is greater than or equal to the second.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$greaterThanEqual = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '>=').setParameterLength(2).setName('greaterThanEqual');
/**
 * Performs a logical AND operation on multiple nodes.
 *
 * @tsl
 * @function
 * @param {...Node} nodes - The input nodes to be combined using AND.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$and = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '&&').setParameterLength(2, Infinity).setName('and');
/**
 * Performs a logical OR operation on multiple nodes.
 *
 * @tsl
 * @function
 * @param {...Node} nodes - The input nodes to be combined using OR.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$or = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '||').setParameterLength(2, Infinity).setName('or');
/**
 * Performs logical NOT on a node.
 *
 * @tsl
 * @function
 * @param {Node} value - The value.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$not = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '!').setParameterLength(1).setName('not');
/**
 * Performs logical XOR on two nodes.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$xor = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '^^').setParameterLength(2).setName('xor');
/**
 * Performs bitwise AND on two nodes.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$bitAnd = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '&').setParameterLength(2).setName('bitAnd');
/**
 * Performs bitwise NOT on a node.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$bitNot = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '~').setParameterLength(1).setName('bitNot');
/**
 * Performs bitwise OR on two nodes.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$bitOr = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '|').setParameterLength(2).setName('bitOr');
/**
 * Performs bitwise XOR on two nodes.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$bitXor = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '^').setParameterLength(2).setName('bitXor');
/**
 * Shifts a node to the left.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to shift.
 * @param {Node} b - The value to shift.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$shiftLeft = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '<<').setParameterLength(2).setName('shiftLeft');
/**
 * Shifts a node to the right.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to shift.
 * @param {Node} b - The value to shift.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$shiftRight = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$OperatorNode, '>>').setParameterLength(2).setName('shiftRight');
/**
 * Increments a node by 1.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to increment.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$incrementBefore = $d89c9137a3d237c2$var$Fn(([a])=>{
    a.addAssign(1);
    return a;
});
/**
 * Decrements a node by 1.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to decrement.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$decrementBefore = $d89c9137a3d237c2$var$Fn(([a])=>{
    a.subAssign(1);
    return a;
});
/**
 * Increments a node by 1 and returns the previous value.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to increment.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$increment = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([a])=>{
    const temp = $d89c9137a3d237c2$var$int(a).toConst();
    a.addAssign(1);
    return temp;
});
/**
 * Decrements a node by 1 and returns the previous value.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to decrement.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$decrement = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([a])=>{
    const temp = $d89c9137a3d237c2$var$int(a).toConst();
    a.subAssign(1);
    return temp;
});
$d89c9137a3d237c2$var$addMethodChaining('add', $d89c9137a3d237c2$var$add);
$d89c9137a3d237c2$var$addMethodChaining('sub', $d89c9137a3d237c2$var$sub);
$d89c9137a3d237c2$var$addMethodChaining('mul', $d89c9137a3d237c2$var$mul);
$d89c9137a3d237c2$var$addMethodChaining('div', $d89c9137a3d237c2$var$div);
$d89c9137a3d237c2$var$addMethodChaining('mod', $d89c9137a3d237c2$var$mod);
$d89c9137a3d237c2$var$addMethodChaining('equal', $d89c9137a3d237c2$var$equal);
$d89c9137a3d237c2$var$addMethodChaining('notEqual', $d89c9137a3d237c2$var$notEqual);
$d89c9137a3d237c2$var$addMethodChaining('lessThan', $d89c9137a3d237c2$var$lessThan);
$d89c9137a3d237c2$var$addMethodChaining('greaterThan', $d89c9137a3d237c2$var$greaterThan);
$d89c9137a3d237c2$var$addMethodChaining('lessThanEqual', $d89c9137a3d237c2$var$lessThanEqual);
$d89c9137a3d237c2$var$addMethodChaining('greaterThanEqual', $d89c9137a3d237c2$var$greaterThanEqual);
$d89c9137a3d237c2$var$addMethodChaining('and', $d89c9137a3d237c2$var$and);
$d89c9137a3d237c2$var$addMethodChaining('or', $d89c9137a3d237c2$var$or);
$d89c9137a3d237c2$var$addMethodChaining('not', $d89c9137a3d237c2$var$not);
$d89c9137a3d237c2$var$addMethodChaining('xor', $d89c9137a3d237c2$var$xor);
$d89c9137a3d237c2$var$addMethodChaining('bitAnd', $d89c9137a3d237c2$var$bitAnd);
$d89c9137a3d237c2$var$addMethodChaining('bitNot', $d89c9137a3d237c2$var$bitNot);
$d89c9137a3d237c2$var$addMethodChaining('bitOr', $d89c9137a3d237c2$var$bitOr);
$d89c9137a3d237c2$var$addMethodChaining('bitXor', $d89c9137a3d237c2$var$bitXor);
$d89c9137a3d237c2$var$addMethodChaining('shiftLeft', $d89c9137a3d237c2$var$shiftLeft);
$d89c9137a3d237c2$var$addMethodChaining('shiftRight', $d89c9137a3d237c2$var$shiftRight);
$d89c9137a3d237c2$var$addMethodChaining('incrementBefore', $d89c9137a3d237c2$var$incrementBefore);
$d89c9137a3d237c2$var$addMethodChaining('decrementBefore', $d89c9137a3d237c2$var$decrementBefore);
$d89c9137a3d237c2$var$addMethodChaining('increment', $d89c9137a3d237c2$var$increment);
$d89c9137a3d237c2$var$addMethodChaining('decrement', $d89c9137a3d237c2$var$decrement);
/**
 * @tsl
 * @function
 * @deprecated since r175. Use {@link mod} instead.
 *
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $d89c9137a3d237c2$var$modInt = (a, b)=>{
    (0, $329ek.warn)('TSL: "modInt()" is deprecated. Use "mod( int( ... ) )" instead.');
    return $d89c9137a3d237c2$var$mod($d89c9137a3d237c2$var$int(a), $d89c9137a3d237c2$var$int(b));
};
$d89c9137a3d237c2$var$addMethodChaining('modInt', $d89c9137a3d237c2$var$modInt);
/**
 * This node represents a variety of mathematical methods available in shaders.
 * They are divided into three categories:
 *
 * - Methods with one input like `sin`, `cos` or `normalize`.
 * - Methods with two inputs like `dot`, `cross` or `pow`.
 * - Methods with three inputs like `mix`, `clamp` or `smoothstep`.
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$var$MathNode extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'MathNode';
    }
    /**
	 * Constructs a new math node.
	 *
	 * @param {string} method - The method name.
	 * @param {Node} aNode - The first input.
	 * @param {?Node} [bNode=null] - The second input.
	 * @param {?Node} [cNode=null] - The third input.
	 */ constructor(method, aNode, bNode = null, cNode = null){
        super();
        // Allow the max() and min() functions to take an arbitrary number of arguments.
        if ((method === $d89c9137a3d237c2$var$MathNode.MAX || method === $d89c9137a3d237c2$var$MathNode.MIN) && arguments.length > 3) {
            let finalOp = new $d89c9137a3d237c2$var$MathNode(method, aNode, bNode);
            for(let i = 2; i < arguments.length - 1; i++)finalOp = new $d89c9137a3d237c2$var$MathNode(method, finalOp, arguments[i]);
            aNode = finalOp;
            bNode = arguments[arguments.length - 1];
            cNode = null;
        }
        /**
		 * The method name.
		 *
		 * @type {string}
		 */ this.method = method;
        /**
		 * The first input.
		 *
		 * @type {Node}
		 */ this.aNode = aNode;
        /**
		 * The second input.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.bNode = bNode;
        /**
		 * The third input.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.cNode = cNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMathNode = true;
    }
    /**
	 * The input type is inferred from the node types of the input nodes.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType(builder) {
        const aType = this.aNode.getNodeType(builder);
        const bType = this.bNode ? this.bNode.getNodeType(builder) : null;
        const cType = this.cNode ? this.cNode.getNodeType(builder) : null;
        const aLen = builder.isMatrix(aType) ? 0 : builder.getTypeLength(aType);
        const bLen = builder.isMatrix(bType) ? 0 : builder.getTypeLength(bType);
        const cLen = builder.isMatrix(cType) ? 0 : builder.getTypeLength(cType);
        if (aLen > bLen && aLen > cLen) return aType;
        else if (bLen > cLen) return bType;
        else if (cLen > aLen) return cType;
        return aType;
    }
    /**
	 * The selected method as well as the input type determine the node type of this node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        const method = this.method;
        if (method === $d89c9137a3d237c2$var$MathNode.LENGTH || method === $d89c9137a3d237c2$var$MathNode.DISTANCE || method === $d89c9137a3d237c2$var$MathNode.DOT) return 'float';
        else if (method === $d89c9137a3d237c2$var$MathNode.CROSS) return 'vec3';
        else if (method === $d89c9137a3d237c2$var$MathNode.ALL || method === $d89c9137a3d237c2$var$MathNode.ANY) return 'bool';
        else if (method === $d89c9137a3d237c2$var$MathNode.EQUALS) return builder.changeComponentType(this.aNode.getNodeType(builder), 'bool');
        else return this.getInputType(builder);
    }
    setup(builder) {
        const { aNode: aNode, bNode: bNode, method: method } = this;
        let outputNode = null;
        if (method === $d89c9137a3d237c2$var$MathNode.ONE_MINUS) outputNode = $d89c9137a3d237c2$var$sub(1.0, aNode);
        else if (method === $d89c9137a3d237c2$var$MathNode.RECIPROCAL) outputNode = $d89c9137a3d237c2$var$div(1.0, aNode);
        else if (method === $d89c9137a3d237c2$var$MathNode.DIFFERENCE) outputNode = $d89c9137a3d237c2$var$abs($d89c9137a3d237c2$var$sub(aNode, bNode));
        else if (method === $d89c9137a3d237c2$var$MathNode.TRANSFORM_DIRECTION) {
            // dir can be either a direction vector or a normal vector
            // upper-left 3x3 of matrix is assumed to be orthogonal
            let tA = aNode;
            let tB = bNode;
            if (builder.isMatrix(tA.getNodeType(builder))) tB = $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$vec3(tB), 0.0);
            else tA = $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$vec3(tA), 0.0);
            const mulNode = $d89c9137a3d237c2$var$mul(tA, tB).xyz;
            outputNode = $d89c9137a3d237c2$var$normalize(mulNode);
        }
        if (outputNode !== null) return outputNode;
        else return super.setup(builder);
    }
    generate(builder, output) {
        const properties = builder.getNodeProperties(this);
        if (properties.outputNode) return super.generate(builder, output);
        let method = this.method;
        const type = this.getNodeType(builder);
        const inputType = this.getInputType(builder);
        const a = this.aNode;
        const b = this.bNode;
        const c = this.cNode;
        const coordinateSystem = builder.renderer.coordinateSystem;
        if (method === $d89c9137a3d237c2$var$MathNode.NEGATE) return builder.format('( - ' + a.build(builder, inputType) + ' )', type, output);
        else {
            const params = [];
            if (method === $d89c9137a3d237c2$var$MathNode.CROSS) params.push(a.build(builder, type), b.build(builder, type));
            else if (coordinateSystem === (0, $329ek.WebGLCoordinateSystem) && method === $d89c9137a3d237c2$var$MathNode.STEP) params.push(a.build(builder, builder.getTypeLength(a.getNodeType(builder)) === 1 ? 'float' : inputType), b.build(builder, inputType));
            else if (coordinateSystem === (0, $329ek.WebGLCoordinateSystem) && (method === $d89c9137a3d237c2$var$MathNode.MIN || method === $d89c9137a3d237c2$var$MathNode.MAX)) params.push(a.build(builder, inputType), b.build(builder, builder.getTypeLength(b.getNodeType(builder)) === 1 ? 'float' : inputType));
            else if (method === $d89c9137a3d237c2$var$MathNode.REFRACT) params.push(a.build(builder, inputType), b.build(builder, inputType), c.build(builder, 'float'));
            else if (method === $d89c9137a3d237c2$var$MathNode.MIX) params.push(a.build(builder, inputType), b.build(builder, inputType), c.build(builder, builder.getTypeLength(c.getNodeType(builder)) === 1 ? 'float' : inputType));
            else {
                if (coordinateSystem === (0, $329ek.WebGPUCoordinateSystem) && method === $d89c9137a3d237c2$var$MathNode.ATAN && b !== null) method = 'atan2';
                if (builder.shaderStage !== 'fragment' && (method === $d89c9137a3d237c2$var$MathNode.DFDX || method === $d89c9137a3d237c2$var$MathNode.DFDY)) {
                    (0, $329ek.warn)(`TSL: '${method}' is not supported in the ${builder.shaderStage} stage.`);
                    method = '/*' + method + '*/';
                }
                params.push(a.build(builder, inputType));
                if (b !== null) params.push(b.build(builder, inputType));
                if (c !== null) params.push(c.build(builder, inputType));
            }
            return builder.format(`${builder.getMethod(method, type)}( ${params.join(', ')} )`, type, output);
        }
    }
    serialize(data) {
        super.serialize(data);
        data.method = this.method;
    }
    deserialize(data) {
        super.deserialize(data);
        this.method = data.method;
    }
}
// 1 input
$d89c9137a3d237c2$var$MathNode.ALL = 'all';
$d89c9137a3d237c2$var$MathNode.ANY = 'any';
$d89c9137a3d237c2$var$MathNode.RADIANS = 'radians';
$d89c9137a3d237c2$var$MathNode.DEGREES = 'degrees';
$d89c9137a3d237c2$var$MathNode.EXP = 'exp';
$d89c9137a3d237c2$var$MathNode.EXP2 = 'exp2';
$d89c9137a3d237c2$var$MathNode.LOG = 'log';
$d89c9137a3d237c2$var$MathNode.LOG2 = 'log2';
$d89c9137a3d237c2$var$MathNode.SQRT = 'sqrt';
$d89c9137a3d237c2$var$MathNode.INVERSE_SQRT = 'inversesqrt';
$d89c9137a3d237c2$var$MathNode.FLOOR = 'floor';
$d89c9137a3d237c2$var$MathNode.CEIL = 'ceil';
$d89c9137a3d237c2$var$MathNode.NORMALIZE = 'normalize';
$d89c9137a3d237c2$var$MathNode.FRACT = 'fract';
$d89c9137a3d237c2$var$MathNode.SIN = 'sin';
$d89c9137a3d237c2$var$MathNode.COS = 'cos';
$d89c9137a3d237c2$var$MathNode.TAN = 'tan';
$d89c9137a3d237c2$var$MathNode.ASIN = 'asin';
$d89c9137a3d237c2$var$MathNode.ACOS = 'acos';
$d89c9137a3d237c2$var$MathNode.ATAN = 'atan';
$d89c9137a3d237c2$var$MathNode.ABS = 'abs';
$d89c9137a3d237c2$var$MathNode.SIGN = 'sign';
$d89c9137a3d237c2$var$MathNode.LENGTH = 'length';
$d89c9137a3d237c2$var$MathNode.NEGATE = 'negate';
$d89c9137a3d237c2$var$MathNode.ONE_MINUS = 'oneMinus';
$d89c9137a3d237c2$var$MathNode.DFDX = 'dFdx';
$d89c9137a3d237c2$var$MathNode.DFDY = 'dFdy';
$d89c9137a3d237c2$var$MathNode.ROUND = 'round';
$d89c9137a3d237c2$var$MathNode.RECIPROCAL = 'reciprocal';
$d89c9137a3d237c2$var$MathNode.TRUNC = 'trunc';
$d89c9137a3d237c2$var$MathNode.FWIDTH = 'fwidth';
$d89c9137a3d237c2$var$MathNode.TRANSPOSE = 'transpose';
$d89c9137a3d237c2$var$MathNode.DETERMINANT = 'determinant';
$d89c9137a3d237c2$var$MathNode.INVERSE = 'inverse';
// 2 inputs
$d89c9137a3d237c2$var$MathNode.EQUALS = 'equals';
$d89c9137a3d237c2$var$MathNode.MIN = 'min';
$d89c9137a3d237c2$var$MathNode.MAX = 'max';
$d89c9137a3d237c2$var$MathNode.STEP = 'step';
$d89c9137a3d237c2$var$MathNode.REFLECT = 'reflect';
$d89c9137a3d237c2$var$MathNode.DISTANCE = 'distance';
$d89c9137a3d237c2$var$MathNode.DIFFERENCE = 'difference';
$d89c9137a3d237c2$var$MathNode.DOT = 'dot';
$d89c9137a3d237c2$var$MathNode.CROSS = 'cross';
$d89c9137a3d237c2$var$MathNode.POW = 'pow';
$d89c9137a3d237c2$var$MathNode.TRANSFORM_DIRECTION = 'transformDirection';
// 3 inputs
$d89c9137a3d237c2$var$MathNode.MIX = 'mix';
$d89c9137a3d237c2$var$MathNode.CLAMP = 'clamp';
$d89c9137a3d237c2$var$MathNode.REFRACT = 'refract';
$d89c9137a3d237c2$var$MathNode.SMOOTHSTEP = 'smoothstep';
$d89c9137a3d237c2$var$MathNode.FACEFORWARD = 'faceforward';
// 1 inputs
/**
 * A small value used to handle floating-point precision errors.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$EPSILON = /*@__PURE__*/ $d89c9137a3d237c2$var$float(1e-6);
/**
 * Represents infinity.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$INFINITY = /*@__PURE__*/ $d89c9137a3d237c2$var$float(1e6);
/**
 * Represents PI.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$PI = /*@__PURE__*/ $d89c9137a3d237c2$var$float(Math.PI);
/**
 * Represents PI * 2. Please use the non-deprecated version `TWO_PI`.
 *
 * @tsl
 * @deprecated
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$PI2 = /*@__PURE__*/ $d89c9137a3d237c2$var$float(Math.PI * 2); // @deprecated r181
/**
 * Represents PI * 2.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$TWO_PI = /*@__PURE__*/ $d89c9137a3d237c2$var$float(Math.PI * 2);
/**
 * Represents PI / 2.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$HALF_PI = /*@__PURE__*/ $d89c9137a3d237c2$var$float(Math.PI * 0.5);
/**
 * Returns `true` if all components of `x` are `true`.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node<bool>}
 */ const $d89c9137a3d237c2$var$all = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.ALL).setParameterLength(1);
/**
 * Returns `true` if any components of `x` are `true`.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node<bool>}
 */ const $d89c9137a3d237c2$var$any = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.ANY).setParameterLength(1);
/**
 * Converts a quantity in degrees to radians.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The input in degrees.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$radians = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.RADIANS).setParameterLength(1);
/**
 * Convert a quantity in radians to degrees.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The input in radians.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$degrees = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.DEGREES).setParameterLength(1);
/**
 * Returns the natural exponentiation of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$exp = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.EXP).setParameterLength(1);
/**
 * Returns 2 raised to the power of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$exp2 = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.EXP2).setParameterLength(1);
/**
 * Returns the natural logarithm of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$log = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.LOG).setParameterLength(1);
/**
 * Returns the base 2 logarithm of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$log2 = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.LOG2).setParameterLength(1);
/**
 * Returns the square root of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$sqrt = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.SQRT).setParameterLength(1);
/**
 * Returns the inverse of the square root of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$inverseSqrt = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.INVERSE_SQRT).setParameterLength(1);
/**
 * Finds the nearest integer less than or equal to the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$floor = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.FLOOR).setParameterLength(1);
/**
 * Finds the nearest integer that is greater than or equal to the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$ceil = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.CEIL).setParameterLength(1);
/**
 * Calculates the unit vector in the same direction as the original vector.
 *
 * @tsl
 * @function
 * @param {Node} x - The input vector.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$normalize = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.NORMALIZE).setParameterLength(1);
/**
 * Computes the fractional part of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$fract = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.FRACT).setParameterLength(1);
/**
 * Returns the sine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$sin = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.SIN).setParameterLength(1);
/**
 * Returns the cosine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$cos = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.COS).setParameterLength(1);
/**
 * Returns the tangent of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$tan = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.TAN).setParameterLength(1);
/**
 * Returns the arcsine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$asin = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.ASIN).setParameterLength(1);
/**
 * Returns the arccosine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$acos = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.ACOS).setParameterLength(1);
/**
 * Returns the arc-tangent of the parameter.
 * If two parameters are provided, the result is `atan2(y/x)`.
 *
 * @tsl
 * @function
 * @param {Node | number} y - The y parameter.
 * @param {?(Node | number)} x - The x parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$atan = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.ATAN).setParameterLength(1, 2);
/**
 * Returns the absolute value of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$abs = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.ABS).setParameterLength(1);
/**
 * Extracts the sign of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$sign = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.SIGN).setParameterLength(1);
/**
 * Calculates the length of a vector.
 *
 * @tsl
 * @function
 * @param {Node} x - The parameter.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$length = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.LENGTH).setParameterLength(1);
/**
 * Negates the value of the parameter (-x).
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$negate = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.NEGATE).setParameterLength(1);
/**
 * Return `1` minus the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$oneMinus = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.ONE_MINUS).setParameterLength(1);
/**
 * Returns the partial derivative of the parameter with respect to x.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$dFdx = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.DFDX).setParameterLength(1);
/**
 * Returns the partial derivative of the parameter with respect to y.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$dFdy = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.DFDY).setParameterLength(1);
/**
 * Rounds the parameter to the nearest integer.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$round = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.ROUND).setParameterLength(1);
/**
 * Returns the reciprocal of the parameter `(1/x)`.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$reciprocal = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.RECIPROCAL).setParameterLength(1);
/**
 * Truncates the parameter, removing the fractional part.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$trunc = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.TRUNC).setParameterLength(1);
/**
 * Returns the sum of the absolute derivatives in x and y.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$fwidth = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.FWIDTH).setParameterLength(1);
/**
 * Returns the transpose of a matrix.
 *
 * @tsl
 * @function
 * @param {Node<mat2|mat3|mat4>} x - The parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$transpose = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.TRANSPOSE).setParameterLength(1);
/**
 * Returns the determinant of a matrix.
 *
 * @tsl
 * @function
 * @param {Node<mat2|mat3|mat4>} x - The parameter.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$determinant = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.DETERMINANT).setParameterLength(1);
/**
 * Returns the inverse of a matrix.
 *
 * @tsl
 * @function
 * @param {Node<mat2|mat3|mat4>} x - The parameter.
 * @returns {Node<mat2|mat3|mat4>}
 */ const $d89c9137a3d237c2$var$inverse = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.INVERSE).setParameterLength(1);
// 2 inputs
/**
 * Returns `true` if `x` equals `y`.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The first parameter.
 * @param {Node | number} y - The second parameter.
 * @deprecated since r175. Use {@link equal} instead.
 * @returns {Node<bool>}
 */ const $d89c9137a3d237c2$var$equals = (x, y)=>{
    (0, $329ek.warn)('TSL: "equals" is deprecated. Use "equal" inside a vector instead, like: "bvec*( equal( ... ) )"');
    return $d89c9137a3d237c2$var$equal(x, y);
};
/**
 * Returns the least of the given values.
 *
 * @tsl
 * @function
 * @param {...(Node | number)} values - The values to compare.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$min$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.MIN).setParameterLength(2, Infinity);
/**
 * Returns the greatest of the given values.
 *
 * @tsl
 * @function
 * @param {...(Node | number)} values - The values to compare.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$max$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.MAX).setParameterLength(2, Infinity);
/**
 * Generate a step function by comparing two values.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The y parameter.
 * @param {Node | number} y - The x parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$step = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.STEP).setParameterLength(2);
/**
 * Calculates the reflection direction for an incident vector.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} I - The incident vector.
 * @param {Node<vec2|vec3|vec4>} N - The normal vector.
 * @returns {Node<vec2|vec3|vec4>}
 */ const $d89c9137a3d237c2$var$reflect = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.REFLECT).setParameterLength(2);
/**
 * Calculates the distance between two points.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} x - The first point.
 * @param {Node<vec2|vec3|vec4>} y - The second point.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$distance = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.DISTANCE).setParameterLength(2);
/**
 * Calculates the absolute difference between two values.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The first parameter.
 * @param {Node | number} y - The second parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$difference = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.DIFFERENCE).setParameterLength(2);
/**
 * Calculates the dot product of two vectors.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} x - The first vector.
 * @param {Node<vec2|vec3|vec4>} y - The second vector.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$dot = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.DOT).setParameterLength(2);
/**
 * Calculates the cross product of two vectors.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3>} x - The first vector.
 * @param {Node<vec2|vec3>} y - The second vector.
 * @returns {Node<float|vec3>}
 */ const $d89c9137a3d237c2$var$cross = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.CROSS).setParameterLength(2);
/**
 * Return the value of the first parameter raised to the power of the second one.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The first parameter.
 * @param {Node | number} y - The second parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$pow = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.POW).setParameterLength(2);
/**
 * Returns the square of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The first parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$pow2 = (x)=>$d89c9137a3d237c2$var$mul(x, x);
/**
 * Returns the cube of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The first parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$pow3 = (x)=>$d89c9137a3d237c2$var$mul(x, x, x);
/**
 * Returns the fourth power of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The first parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$pow4 = (x)=>$d89c9137a3d237c2$var$mul(x, x, x, x);
/**
 * Transforms the direction of a vector by a matrix and then normalizes the result.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} direction - The direction vector.
 * @param {Node<mat2|mat3|mat4>} matrix - The transformation matrix.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$transformDirection = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.TRANSFORM_DIRECTION).setParameterLength(2);
/**
 * Returns the cube root of a number.
 *
 * @tsl
 * @function
 * @param {Node | number} a - The first parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$cbrt = (a)=>$d89c9137a3d237c2$var$mul($d89c9137a3d237c2$var$sign(a), $d89c9137a3d237c2$var$pow($d89c9137a3d237c2$var$abs(a), 1.0 / 3.0));
/**
 * Calculate the squared length of a vector.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} a - The vector.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$lengthSq = (a)=>$d89c9137a3d237c2$var$dot(a, a);
/**
 * Linearly interpolates between two values.
 *
 * @tsl
 * @function
 * @param {Node | number} a - The first parameter.
 * @param {Node | number} b - The second parameter.
 * @param {Node | number} t - The interpolation value.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$mix = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.MIX).setParameterLength(3);
/**
 * Constrains a value to lie between two further values.
 *
 * @tsl
 * @function
 * @param {Node | number} value - The value to constrain.
 * @param {Node | number} [low=0] - The lower bound.
 * @param {Node | number} [high=1] - The upper bound.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$clamp = (value, low = 0, high = 1)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$var$MathNode($d89c9137a3d237c2$var$MathNode.CLAMP, $d89c9137a3d237c2$var$nodeObject(value), $d89c9137a3d237c2$var$nodeObject(low), $d89c9137a3d237c2$var$nodeObject(high)));
/**
 * Constrains a value between `0` and `1`.
 *
 * @tsl
 * @function
 * @param {Node | number} value - The value to constrain.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$saturate = (value)=>$d89c9137a3d237c2$var$clamp(value);
/**
 * Calculates the refraction direction for an incident vector.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} I - The incident vector.
 * @param {Node<vec2|vec3|vec4>} N - The normal vector.
 * @param {Node<float>} eta - The ratio of indices of refraction.
 * @returns {Node<vec2|vec3|vec4>}
 */ const $d89c9137a3d237c2$var$refract = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.REFRACT).setParameterLength(3);
/**
 * Performs a Hermite interpolation between two values.
 *
 * @tsl
 * @function
 * @param {Node | number} low - The value of the lower edge of the Hermite function.
 * @param {Node | number} high - The value of the upper edge of the Hermite function.
 * @param {Node | number} x - The source value for interpolation.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$smoothstep = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.SMOOTHSTEP).setParameterLength(3);
/**
 * Returns a vector pointing in the same direction as another.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} N - The vector to orient.
 * @param {Node<vec2|vec3|vec4>} I - The incident vector.
 * @param {Node<vec2|vec3|vec4>} Nref - The reference vector.
 * @returns {Node<vec2|vec3|vec4>}
 */ const $d89c9137a3d237c2$var$faceForward = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$MathNode, $d89c9137a3d237c2$var$MathNode.FACEFORWARD).setParameterLength(3);
/**
 * Returns a random value for the given uv.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} uv - The uv node.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$rand = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([uv])=>{
    const a = 12.9898, b = 78.233, c = 43758.5453;
    const dt = $d89c9137a3d237c2$var$dot(uv.xy, $d89c9137a3d237c2$var$vec2(a, b)), sn = $d89c9137a3d237c2$var$mod(dt, $d89c9137a3d237c2$var$PI);
    return $d89c9137a3d237c2$var$fract($d89c9137a3d237c2$var$sin(sn).mul(c));
});
/**
 * Alias for `mix()` with a different parameter order.
 *
 * @tsl
 * @function
 * @param {Node | number} t - The interpolation value.
 * @param {Node | number} e1 - The first parameter.
 * @param {Node | number} e2 - The second parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$mixElement = (t, e1, e2)=>$d89c9137a3d237c2$var$mix(e1, e2, t);
/**
 * Alias for `smoothstep()` with a different parameter order.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The source value for interpolation.
 * @param {Node | number} low - The value of the lower edge of the Hermite function.
 * @param {Node | number} high - The value of the upper edge of the Hermite function.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$smoothstepElement = (x, low, high)=>$d89c9137a3d237c2$var$smoothstep(low, high, x);
/**
 * Alias for `step()` with a different parameter order.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The source value for interpolation.
 * @param {Node | number} edge - The edge value.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$stepElement = (x, edge)=>$d89c9137a3d237c2$var$step(edge, x);
/**
 * Returns the arc-tangent of the quotient of its parameters.
 *
 * @tsl
 * @function
 * @deprecated since r172. Use {@link atan} instead.
 *
 * @param {Node | number} y - The y parameter.
 * @param {Node | number} x - The x parameter.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$atan2 = (y, x)=>{
    (0, $329ek.warn)('TSL: "atan2" is overloaded. Use "atan" instead.');
    return $d89c9137a3d237c2$var$atan(y, x);
};
// GLSL alias function
const $d89c9137a3d237c2$var$faceforward = $d89c9137a3d237c2$var$faceForward;
const $d89c9137a3d237c2$var$inversesqrt = $d89c9137a3d237c2$var$inverseSqrt;
// Method chaining
$d89c9137a3d237c2$var$addMethodChaining('all', $d89c9137a3d237c2$var$all);
$d89c9137a3d237c2$var$addMethodChaining('any', $d89c9137a3d237c2$var$any);
$d89c9137a3d237c2$var$addMethodChaining('equals', $d89c9137a3d237c2$var$equals);
$d89c9137a3d237c2$var$addMethodChaining('radians', $d89c9137a3d237c2$var$radians);
$d89c9137a3d237c2$var$addMethodChaining('degrees', $d89c9137a3d237c2$var$degrees);
$d89c9137a3d237c2$var$addMethodChaining('exp', $d89c9137a3d237c2$var$exp);
$d89c9137a3d237c2$var$addMethodChaining('exp2', $d89c9137a3d237c2$var$exp2);
$d89c9137a3d237c2$var$addMethodChaining('log', $d89c9137a3d237c2$var$log);
$d89c9137a3d237c2$var$addMethodChaining('log2', $d89c9137a3d237c2$var$log2);
$d89c9137a3d237c2$var$addMethodChaining('sqrt', $d89c9137a3d237c2$var$sqrt);
$d89c9137a3d237c2$var$addMethodChaining('inverseSqrt', $d89c9137a3d237c2$var$inverseSqrt);
$d89c9137a3d237c2$var$addMethodChaining('floor', $d89c9137a3d237c2$var$floor);
$d89c9137a3d237c2$var$addMethodChaining('ceil', $d89c9137a3d237c2$var$ceil);
$d89c9137a3d237c2$var$addMethodChaining('normalize', $d89c9137a3d237c2$var$normalize);
$d89c9137a3d237c2$var$addMethodChaining('fract', $d89c9137a3d237c2$var$fract);
$d89c9137a3d237c2$var$addMethodChaining('sin', $d89c9137a3d237c2$var$sin);
$d89c9137a3d237c2$var$addMethodChaining('cos', $d89c9137a3d237c2$var$cos);
$d89c9137a3d237c2$var$addMethodChaining('tan', $d89c9137a3d237c2$var$tan);
$d89c9137a3d237c2$var$addMethodChaining('asin', $d89c9137a3d237c2$var$asin);
$d89c9137a3d237c2$var$addMethodChaining('acos', $d89c9137a3d237c2$var$acos);
$d89c9137a3d237c2$var$addMethodChaining('atan', $d89c9137a3d237c2$var$atan);
$d89c9137a3d237c2$var$addMethodChaining('abs', $d89c9137a3d237c2$var$abs);
$d89c9137a3d237c2$var$addMethodChaining('sign', $d89c9137a3d237c2$var$sign);
$d89c9137a3d237c2$var$addMethodChaining('length', $d89c9137a3d237c2$var$length);
$d89c9137a3d237c2$var$addMethodChaining('lengthSq', $d89c9137a3d237c2$var$lengthSq);
$d89c9137a3d237c2$var$addMethodChaining('negate', $d89c9137a3d237c2$var$negate);
$d89c9137a3d237c2$var$addMethodChaining('oneMinus', $d89c9137a3d237c2$var$oneMinus);
$d89c9137a3d237c2$var$addMethodChaining('dFdx', $d89c9137a3d237c2$var$dFdx);
$d89c9137a3d237c2$var$addMethodChaining('dFdy', $d89c9137a3d237c2$var$dFdy);
$d89c9137a3d237c2$var$addMethodChaining('round', $d89c9137a3d237c2$var$round);
$d89c9137a3d237c2$var$addMethodChaining('reciprocal', $d89c9137a3d237c2$var$reciprocal);
$d89c9137a3d237c2$var$addMethodChaining('trunc', $d89c9137a3d237c2$var$trunc);
$d89c9137a3d237c2$var$addMethodChaining('fwidth', $d89c9137a3d237c2$var$fwidth);
$d89c9137a3d237c2$var$addMethodChaining('atan2', $d89c9137a3d237c2$var$atan2);
$d89c9137a3d237c2$var$addMethodChaining('min', $d89c9137a3d237c2$var$min$1);
$d89c9137a3d237c2$var$addMethodChaining('max', $d89c9137a3d237c2$var$max$1);
$d89c9137a3d237c2$var$addMethodChaining('step', $d89c9137a3d237c2$var$stepElement);
$d89c9137a3d237c2$var$addMethodChaining('reflect', $d89c9137a3d237c2$var$reflect);
$d89c9137a3d237c2$var$addMethodChaining('distance', $d89c9137a3d237c2$var$distance);
$d89c9137a3d237c2$var$addMethodChaining('dot', $d89c9137a3d237c2$var$dot);
$d89c9137a3d237c2$var$addMethodChaining('cross', $d89c9137a3d237c2$var$cross);
$d89c9137a3d237c2$var$addMethodChaining('pow', $d89c9137a3d237c2$var$pow);
$d89c9137a3d237c2$var$addMethodChaining('pow2', $d89c9137a3d237c2$var$pow2);
$d89c9137a3d237c2$var$addMethodChaining('pow3', $d89c9137a3d237c2$var$pow3);
$d89c9137a3d237c2$var$addMethodChaining('pow4', $d89c9137a3d237c2$var$pow4);
$d89c9137a3d237c2$var$addMethodChaining('transformDirection', $d89c9137a3d237c2$var$transformDirection);
$d89c9137a3d237c2$var$addMethodChaining('mix', $d89c9137a3d237c2$var$mixElement);
$d89c9137a3d237c2$var$addMethodChaining('clamp', $d89c9137a3d237c2$var$clamp);
$d89c9137a3d237c2$var$addMethodChaining('refract', $d89c9137a3d237c2$var$refract);
$d89c9137a3d237c2$var$addMethodChaining('smoothstep', $d89c9137a3d237c2$var$smoothstepElement);
$d89c9137a3d237c2$var$addMethodChaining('faceForward', $d89c9137a3d237c2$var$faceForward);
$d89c9137a3d237c2$var$addMethodChaining('difference', $d89c9137a3d237c2$var$difference);
$d89c9137a3d237c2$var$addMethodChaining('saturate', $d89c9137a3d237c2$var$saturate);
$d89c9137a3d237c2$var$addMethodChaining('cbrt', $d89c9137a3d237c2$var$cbrt);
$d89c9137a3d237c2$var$addMethodChaining('transpose', $d89c9137a3d237c2$var$transpose);
$d89c9137a3d237c2$var$addMethodChaining('determinant', $d89c9137a3d237c2$var$determinant);
$d89c9137a3d237c2$var$addMethodChaining('inverse', $d89c9137a3d237c2$var$inverse);
$d89c9137a3d237c2$var$addMethodChaining('rand', $d89c9137a3d237c2$var$rand);
/**
 * Represents a logical `if/else` statement. Can be used as an alternative
 * to the `If()`/`Else()` syntax.
 *
 * The corresponding TSL `select()` looks like so:
 * ```js
 * velocity = position.greaterThanEqual( limit ).select( velocity.negate(), velocity );
 * ```
 * The `select()` method is called in a chaining fashion on a condition. The parameter nodes of `select()`
 * determine the outcome of the entire statement.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$var$ConditionalNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ConditionalNode';
    }
    /**
	 * Constructs a new conditional node.
	 *
	 * @param {Node} condNode - The node that defines the condition.
	 * @param {Node} ifNode - The node that is evaluate when the condition ends up `true`.
	 * @param {?Node} [elseNode=null] - The node that is evaluate when the condition ends up `false`.
	 */ constructor(condNode, ifNode, elseNode = null){
        super();
        /**
		 * The node that defines the condition.
		 *
		 * @type {Node}
		 */ this.condNode = condNode;
        /**
		 * The node that is evaluate when the condition ends up `true`.
		 *
		 * @type {Node}
		 */ this.ifNode = ifNode;
        /**
		 * The node that is evaluate when the condition ends up `false`.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.elseNode = elseNode;
    }
    /**
	 * This method is overwritten since the node type is inferred from the if/else
	 * nodes.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        const { ifNode: ifNode, elseNode: elseNode } = builder.getNodeProperties(this);
        if (ifNode === undefined) {
            // fallback setup
            builder.flowBuildStage(this, 'setup');
            return this.getNodeType(builder);
        }
        const ifType = ifNode.getNodeType(builder);
        if (elseNode !== null) {
            const elseType = elseNode.getNodeType(builder);
            if (builder.getTypeLength(elseType) > builder.getTypeLength(ifType)) return elseType;
        }
        return ifType;
    }
    setup(builder) {
        const condNode = this.condNode;
        const ifNode = this.ifNode.isolate();
        const elseNode = this.elseNode ? this.elseNode.isolate() : null;
        //
        const currentNodeBlock = builder.context.nodeBlock;
        builder.getDataFromNode(ifNode).parentNodeBlock = currentNodeBlock;
        if (elseNode !== null) builder.getDataFromNode(elseNode).parentNodeBlock = currentNodeBlock;
        //
        const isUniformFlow = builder.context.uniformFlow;
        const properties = builder.getNodeProperties(this);
        properties.condNode = condNode;
        properties.ifNode = isUniformFlow ? ifNode : ifNode.context({
            nodeBlock: ifNode
        });
        properties.elseNode = elseNode ? isUniformFlow ? elseNode : elseNode.context({
            nodeBlock: elseNode
        }) : null;
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const nodeData = builder.getDataFromNode(this);
        if (nodeData.nodeProperty !== undefined) return nodeData.nodeProperty;
        const { condNode: condNode, ifNode: ifNode, elseNode: elseNode } = builder.getNodeProperties(this);
        const functionNode = builder.currentFunctionNode;
        const needsOutput = output !== 'void';
        const nodeProperty = needsOutput ? $d89c9137a3d237c2$var$property(type).build(builder) : '';
        nodeData.nodeProperty = nodeProperty;
        const nodeSnippet = condNode.build(builder, 'bool');
        const isUniformFlow = builder.context.uniformFlow;
        if (isUniformFlow && elseNode !== null) {
            const ifSnippet = ifNode.build(builder, type);
            const elseSnippet = elseNode.build(builder, type);
            const mathSnippet = builder.getTernary(nodeSnippet, ifSnippet, elseSnippet);
            // TODO: If node property already exists return something else
            return builder.format(mathSnippet, type, output);
        }
        builder.addFlowCode(`\n${builder.tab}if ( ${nodeSnippet} ) {\n\n`).addFlowTab();
        let ifSnippet = ifNode.build(builder, type);
        if (ifSnippet) {
            if (needsOutput) ifSnippet = nodeProperty + ' = ' + ifSnippet + ';';
            else {
                ifSnippet = 'return ' + ifSnippet + ';';
                if (functionNode === null) {
                    (0, $329ek.warn)('TSL: Return statement used in an inline \'Fn()\'. Define a layout struct to allow return values.');
                    ifSnippet = '// ' + ifSnippet;
                }
            }
        }
        builder.removeFlowTab().addFlowCode(builder.tab + '\t' + ifSnippet + '\n\n' + builder.tab + '}');
        if (elseNode !== null) {
            builder.addFlowCode(' else {\n\n').addFlowTab();
            let elseSnippet = elseNode.build(builder, type);
            if (elseSnippet) {
                if (needsOutput) elseSnippet = nodeProperty + ' = ' + elseSnippet + ';';
                else {
                    elseSnippet = 'return ' + elseSnippet + ';';
                    if (functionNode === null) {
                        (0, $329ek.warn)('TSL: Return statement used in an inline \'Fn()\'. Define a layout struct to allow return values.');
                        elseSnippet = '// ' + elseSnippet;
                    }
                }
            }
            builder.removeFlowTab().addFlowCode(builder.tab + '\t' + elseSnippet + '\n\n' + builder.tab + '}\n\n');
        } else builder.addFlowCode('\n\n');
        return builder.format(nodeProperty, type, output);
    }
}
/**
 * TSL function for creating a conditional node.
 *
 * @tsl
 * @function
 * @param {Node} condNode - The node that defines the condition.
 * @param {Node} ifNode - The node that is evaluate when the condition ends up `true`.
 * @param {?Node} [elseNode=null] - The node that is evaluate when the condition ends up `false`.
 * @returns {ConditionalNode}
 */ const $d89c9137a3d237c2$var$select = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$var$ConditionalNode).setParameterLength(2, 3);
$d89c9137a3d237c2$var$addMethodChaining('select', $d89c9137a3d237c2$var$select);
/**
 * This node can be used as a context management component for another node.
 * {@link NodeBuilder} performs its node building process in a specific context and
 * this node allows the modify the context. A typical use case is to overwrite `getUV()` e.g.:
 *
 * ```js
 *node.context( { getUV: () => customCoord } );
 *\// or
 *material.contextNode = context( { getUV: () => customCoord } );
 *\// or
 *renderer.contextNode = context( { getUV: () => customCoord } );
 *\// or
 *scenePass.contextNode = context( { getUV: () => customCoord } );
 *```
 * @augments Node
 */ class $d89c9137a3d237c2$export$17ecd2ebd87625d1 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ContextNode';
    }
    /**
	 * Constructs a new context node.
	 *
	 * @param {Node} node - The node whose context should be modified.
	 * @param {Object} [value={}] - The modified context data.
	 */ constructor(node = null, value = {}){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isContextNode = true;
        /**
		 * The node whose context should be modified.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The modified context data.
		 *
		 * @type {Object}
		 * @default {}
		 */ this.value = value;
    }
    /**
	 * This method is overwritten to ensure it returns the reference to {@link ContextNode#node}.
	 *
	 * @return {Node} A reference to {@link ContextNode#node}.
	 */ getScope() {
        return this.node.getScope();
    }
    /**
	 * This method is overwritten to ensure it returns the type of {@link ContextNode#node}.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        return this.node.getNodeType(builder);
    }
    /**
	 * Gathers the context data from all parent context nodes.
	 *
	 * @return {Object} The gathered context data.
	 */ getFlowContextData() {
        const children = [];
        this.traverse((node)=>{
            if (node.isContextNode === true) children.push(node.value);
        });
        return Object.assign({}, ...children);
    }
    /**
	 * This method is overwritten to ensure it returns the member type of {@link ContextNode#node}.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The member name.
	 * @returns {string} The member type.
	 */ getMemberType(builder, name) {
        return this.node.getMemberType(builder, name);
    }
    analyze(builder) {
        const previousContext = builder.addContext(this.value);
        this.node.build(builder);
        builder.setContext(previousContext);
    }
    setup(builder) {
        const previousContext = builder.addContext(this.value);
        this.node.build(builder);
        builder.setContext(previousContext);
    }
    generate(builder, output) {
        const previousContext = builder.addContext(this.value);
        const snippet = this.node.build(builder, output);
        builder.setContext(previousContext);
        return snippet;
    }
}
/**
 * TSL function for creating a context node.
 *
 * @tsl
 * @function
 * @param {Node|Object} [nodeOrValue={}] - The node whose context should be modified or the modified context data.
 * @param {Object} [value={}] - The modified context data.
 * @returns {ContextNode}
 */ const $d89c9137a3d237c2$var$context = (nodeOrValue = null, value = {})=>{
    let node = nodeOrValue;
    if (node === null || node.isNode !== true) {
        value = node || value;
        node = null;
    }
    return new $d89c9137a3d237c2$export$17ecd2ebd87625d1(node, value);
};
/**
 * TSL function for defining a uniformFlow context value for a given node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node whose dependencies should all execute within a uniform control-flow path.
 * @returns {ContextNode}
 */ const $d89c9137a3d237c2$var$uniformFlow = (node)=>$d89c9137a3d237c2$var$context(node, {
        uniformFlow: true
    });
/**
 * TSL function for defining a name for the context value for a given node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node whose context should be modified.
 * @param {string} name - The name to set.
 * @returns {ContextNode}
 */ const $d89c9137a3d237c2$var$setName = (node, name)=>$d89c9137a3d237c2$var$context(node, {
        nodeName: name
    });
/**
 * TSL function for defining a built-in shadow context for a given node.
 *
 * @tsl
 * @function
 * @param {ShadowNode} shadowNode - The shadow node representing the light's shadow.
 * @param {Light} light - The light associated with the shadow.
 * @param {Node} [node=null] - The node whose context should be modified.
 * @returns {ContextNode}
 */ function $d89c9137a3d237c2$var$builtinShadowContext(shadowNode, light, node = null) {
    return $d89c9137a3d237c2$var$context(node, {
        getShadow: ({ light: shadowLight, shadowColorNode: shadowColorNode })=>{
            if (light === shadowLight) return shadowColorNode.mul(shadowNode);
            return shadowColorNode;
        }
    });
}
/**
 * TSL function for defining a built-in ambient occlusion context for a given node.
 *
 * @tsl
 * @function
 * @param {Node} aoNode - The ambient occlusion value node to apply.
 * @param {Node} [node=null] - The node whose context should be modified.
 * @returns {ContextNode}
 */ function $d89c9137a3d237c2$var$builtinAOContext(aoNode, node = null) {
    return $d89c9137a3d237c2$var$context(node, {
        getAO: (inputNode, { material: material })=>{
            if (material.transparent === true) return inputNode;
            return inputNode !== null ? inputNode.mul(aoNode) : aoNode;
        }
    });
}
/**
 * TSL function for defining a label context value for a given node.
 *
 * @tsl
 * @function
 * @deprecated
 * @param {Node} node - The node whose context should be modified.
 * @param {string} name - The name/label to set.
 * @returns {ContextNode}
 */ function $d89c9137a3d237c2$var$label(node, name) {
    (0, $329ek.warn)('TSL: "label()" has been deprecated. Use "setName()" instead.'); // @deprecated r179
    return $d89c9137a3d237c2$var$setName(node, name);
}
$d89c9137a3d237c2$var$addMethodChaining('context', $d89c9137a3d237c2$var$context);
$d89c9137a3d237c2$var$addMethodChaining('label', $d89c9137a3d237c2$var$label);
$d89c9137a3d237c2$var$addMethodChaining('uniformFlow', $d89c9137a3d237c2$var$uniformFlow);
$d89c9137a3d237c2$var$addMethodChaining('setName', $d89c9137a3d237c2$var$setName);
$d89c9137a3d237c2$var$addMethodChaining('builtinShadowContext', (node, shadowNode, light)=>$d89c9137a3d237c2$var$builtinShadowContext(shadowNode, light, node));
$d89c9137a3d237c2$var$addMethodChaining('builtinAOContext', (node, aoValue)=>$d89c9137a3d237c2$var$builtinAOContext(aoValue, node));
/**
 * Class for representing shader variables as nodes. Variables are created from
 * existing nodes like the following:
 *
 * ```js
 * const depth = sampleDepth( uvNode ).toVar( 'depth' );
 * ```
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$fec192598c332c7e extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'VarNode';
    }
    /**
	 * Constructs a new variable node.
	 *
	 * @param {Node} node - The node for which a variable should be created.
	 * @param {?string} [name=null] - The name of the variable in the shader.
	 * @param {boolean} [readOnly=false] - The read-only flag.
	 */ constructor(node, name = null, readOnly = false){
        super();
        /**
		 * The node for which a variable should be created.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The name of the variable in the shader. If no name is defined,
		 * the node system auto-generates one.
		 *
		 * @type {?string}
		 * @default null
		 */ this.name = name;
        /**
		 * `VarNode` sets this property to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVarNode = true;
        /**
		 *
		 * The read-only flag.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.readOnly = readOnly;
        /**
		 *
		 * Add this flag to the node system to indicate that this node require parents.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.parents = true;
        /**
		 * This flag is used to indicate that this node is used for intent.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.intent = false;
    }
    /**
	 * Sets the intent flag for this node.
	 *
	 * This flag is used to indicate that this node is used for intent
	 * and should not be built directly. Instead, it is used to indicate that
	 * the node should be treated as a variable intent.
	 *
	 * It's useful for assigning variables without needing creating a new variable node.
	 *
	 * @param {boolean} value - The value to set for the intent flag.
	 * @returns {VarNode} This node.
	 */ setIntent(value) {
        this.intent = value;
        return this;
    }
    /**
	 * Checks if this node is used for intent.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @returns {boolean} Whether this node is used for intent.
	 */ isIntent(builder) {
        const data = builder.getDataFromNode(this);
        if (data.forceDeclaration === true) return false;
        return this.intent;
    }
    /**
	 * Returns the intent flag of this node.
	 *
	 * @return {boolean} The intent flag.
	 */ getIntent() {
        return this.intent;
    }
    getMemberType(builder, name) {
        return this.node.getMemberType(builder, name);
    }
    getElementType(builder) {
        return this.node.getElementType(builder);
    }
    getNodeType(builder) {
        return this.node.getNodeType(builder);
    }
    getArrayCount(builder) {
        return this.node.getArrayCount(builder);
    }
    isAssign(builder) {
        const data = builder.getDataFromNode(this);
        return data.assign;
    }
    build(...params) {
        const builder = params[0];
        if (this._hasStack(builder) === false && builder.buildStage === 'setup') {
            if (builder.context.nodeLoop || builder.context.nodeBlock) {
                let addBefore = false;
                if (this.node.isShaderCallNodeInternal && this.node.shaderNode.getLayout() === null) {
                    if (builder.fnCall && builder.fnCall.shaderNode) {
                        const shaderNodeData = builder.getDataFromNode(this.node.shaderNode);
                        if (shaderNodeData.hasLoop) {
                            const data = builder.getDataFromNode(this);
                            data.forceDeclaration = true;
                            addBefore = true;
                        }
                    }
                }
                const baseStack = builder.getBaseStack();
                if (addBefore) baseStack.addToStackBefore(this);
                else baseStack.addToStack(this);
            }
        }
        if (this.isIntent(builder)) {
            if (this.isAssign(builder) !== true) return this.node.build(...params);
        }
        return super.build(...params);
    }
    generate(builder) {
        const { node: node, name: name, readOnly: readOnly } = this;
        const { renderer: renderer } = builder;
        const isWebGPUBackend = renderer.backend.isWebGPUBackend === true;
        let isDeterministic = false;
        let shouldTreatAsReadOnly = false;
        if (readOnly) {
            isDeterministic = builder.isDeterministic(node);
            shouldTreatAsReadOnly = isWebGPUBackend ? readOnly : isDeterministic;
        }
        const nodeType = this.getNodeType(builder);
        if (nodeType == 'void') {
            if (this.isIntent(builder) !== true) (0, $329ek.error)('TSL: ".toVar()" can not be used with void type.');
            const snippet = node.build(builder);
            return snippet;
        }
        const vectorType = builder.getVectorType(nodeType);
        const snippet = node.build(builder, vectorType);
        const nodeVar = builder.getVarFromNode(this, name, vectorType, undefined, shouldTreatAsReadOnly);
        const propertyName = builder.getPropertyName(nodeVar);
        let declarationPrefix = propertyName;
        if (shouldTreatAsReadOnly) {
            if (isWebGPUBackend) declarationPrefix = isDeterministic ? `const ${propertyName}` : `let ${propertyName}`;
            else {
                const count = node.getArrayCount(builder);
                declarationPrefix = `const ${builder.getVar(nodeVar.type, propertyName, count)}`;
            }
        }
        builder.addLineFlowCode(`${declarationPrefix} = ${snippet}`, this);
        return propertyName;
    }
    _hasStack(builder) {
        const nodeData = builder.getDataFromNode(this);
        return nodeData.stack !== undefined;
    }
}
/**
 * TSL function for creating a var node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node for which a variable should be created.
 * @param {?string} name - The name of the variable in the shader.
 * @returns {VarNode}
 */ const $d89c9137a3d237c2$var$createVar = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$fec192598c332c7e);
/**
 * TSL function for creating a var node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node for which a variable should be created.
 * @param {?string} name - The name of the variable in the shader.
 * @returns {VarNode}
 */ const $d89c9137a3d237c2$var$Var = (node, name = null)=>$d89c9137a3d237c2$var$createVar(node, name).toStack();
/**
 * TSL function for creating a const node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node for which a constant should be created.
 * @param {?string} name - The name of the constant in the shader.
 * @returns {VarNode}
 */ const $d89c9137a3d237c2$var$Const = (node, name = null)=>$d89c9137a3d237c2$var$createVar(node, name, true).toStack();
//
//
/**
 * TSL function for creating a var intent node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node for which a variable should be created.
 * @param {?string} name - The name of the variable in the shader.
 * @returns {VarNode}
 */ const $d89c9137a3d237c2$var$VarIntent = (node)=>{
    return $d89c9137a3d237c2$var$createVar(node).setIntent(true).toStack();
};
// Method chaining
$d89c9137a3d237c2$var$addMethodChaining('toVar', $d89c9137a3d237c2$var$Var);
$d89c9137a3d237c2$var$addMethodChaining('toConst', $d89c9137a3d237c2$var$Const);
$d89c9137a3d237c2$var$addMethodChaining('toVarIntent', $d89c9137a3d237c2$var$VarIntent);
/**
 * This node is used to build a sub-build in the node system.
 *
 * @augments Node
 * @param {Node} node - The node to be built in the sub-build.
 * @param {string} name - The name of the sub-build.
 * @param {?string} [nodeType=null] - The type of the node, if known.
 */ class $d89c9137a3d237c2$export$d8653cfb8ececbb6 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'SubBuild';
    }
    constructor(node, name, nodeType = null){
        super(nodeType);
        /**
		 * The node to be built in the sub-build.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The name of the sub-build.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSubBuildNode = true;
    }
    getNodeType(builder) {
        if (this.nodeType !== null) return this.nodeType;
        builder.addSubBuild(this.name);
        const nodeType = this.node.getNodeType(builder);
        builder.removeSubBuild();
        return nodeType;
    }
    build(builder, ...params) {
        builder.addSubBuild(this.name);
        const data = this.node.build(builder, ...params);
        builder.removeSubBuild();
        return data;
    }
}
/**
 * Creates a new sub-build node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node to be built in the sub-build.
 * @param {string} name - The name of the sub-build.
 * @param {?string} [type=null] - The type of the node, if known.
 * @returns {Node} A node object wrapping the SubBuildNode instance.
 */ const $d89c9137a3d237c2$var$subBuild = (node, name, type = null)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$d8653cfb8ececbb6($d89c9137a3d237c2$var$nodeObject(node), name, type));
/**
 * Class for representing shader varyings as nodes. Varyings are create from
 * existing nodes like the following:
 *
 * ```js
 * const positionLocal = positionGeometry.toVarying( 'vPositionLocal' );
 * ```
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$c4d548faf21ac236 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'VaryingNode';
    }
    /**
	 * Constructs a new varying node.
	 *
	 * @param {Node} node - The node for which a varying should be created.
	 * @param {?string} name - The name of the varying in the shader.
	 */ constructor(node, name = null){
        super();
        /**
		 * The node for which a varying should be created.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The name of the varying in the shader. If no name is defined,
		 * the node system auto-generates one.
		 *
		 * @type {?string}
		 * @default null
		 */ this.name = name;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVaryingNode = true;
        /**
		 * The interpolation type of the varying data.
		 *
		 * @type {?string}
		 * @default null
		 */ this.interpolationType = null;
        /**
		 * The interpolation sampling type of varying data.
		 *
		 * @type {?string}
		 * @default null
		 */ this.interpolationSampling = null;
        /**
		 * This flag is used for global cache.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
    }
    /**
	 * Defines the interpolation type of the varying.
	 *
	 * @param {string} type - The interpolation type.
	 * @param {?string} sampling - The interpolation sampling type
	 * @return {VaryingNode} A reference to this node.
	 */ setInterpolation(type, sampling = null) {
        this.interpolationType = type;
        this.interpolationSampling = sampling;
        return this;
    }
    getHash(builder) {
        return this.name || super.getHash(builder);
    }
    getNodeType(builder) {
        // VaryingNode is auto type
        return this.node.getNodeType(builder);
    }
    /**
	 * This method performs the setup of a varying node with the current node builder.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {NodeVarying} The node varying from the node builder.
	 */ setupVarying(builder) {
        const properties = builder.getNodeProperties(this);
        let varying = properties.varying;
        if (varying === undefined) {
            const name = this.name;
            const type = this.getNodeType(builder);
            const interpolationType = this.interpolationType;
            const interpolationSampling = this.interpolationSampling;
            properties.varying = varying = builder.getVaryingFromNode(this, name, type, interpolationType, interpolationSampling);
            properties.node = $d89c9137a3d237c2$var$subBuild(this.node, 'VERTEX');
        }
        // this property can be used to check if the varying can be optimized for a variable
        varying.needsInterpolation || (varying.needsInterpolation = builder.shaderStage === 'fragment');
        return varying;
    }
    setup(builder) {
        this.setupVarying(builder);
        builder.flowNodeFromShaderStage($d89c9137a3d237c2$export$9e43649cde3e3072.VERTEX, this.node);
    }
    analyze(builder) {
        this.setupVarying(builder);
        builder.flowNodeFromShaderStage($d89c9137a3d237c2$export$9e43649cde3e3072.VERTEX, this.node);
    }
    generate(builder) {
        const propertyKey = builder.getSubBuildProperty('property', builder.currentStack);
        const properties = builder.getNodeProperties(this);
        const varying = this.setupVarying(builder);
        if (properties[propertyKey] === undefined) {
            const type = this.getNodeType(builder);
            const propertyName = builder.getPropertyName(varying, $d89c9137a3d237c2$export$9e43649cde3e3072.VERTEX);
            // force node run in vertex stage
            builder.flowNodeFromShaderStage($d89c9137a3d237c2$export$9e43649cde3e3072.VERTEX, properties.node, type, propertyName);
            properties[propertyKey] = propertyName;
        }
        return builder.getPropertyName(varying);
    }
}
/**
 * TSL function for creating a varying node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node for which a varying should be created.
 * @param {?string} name - The name of the varying in the shader.
 * @returns {VaryingNode}
 */ const $d89c9137a3d237c2$var$varying = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$c4d548faf21ac236).setParameterLength(1, 2);
/**
 * Computes a node in the vertex stage.
 *
 * @tsl
 * @function
 * @param {Node} node - The node which should be executed in the vertex stage.
 * @returns {VaryingNode}
 */ const $d89c9137a3d237c2$var$vertexStage = (node)=>$d89c9137a3d237c2$var$varying(node);
$d89c9137a3d237c2$var$addMethodChaining('toVarying', $d89c9137a3d237c2$var$varying);
$d89c9137a3d237c2$var$addMethodChaining('toVertexStage', $d89c9137a3d237c2$var$vertexStage);
// Deprecated
$d89c9137a3d237c2$var$addMethodChaining('varying', (...params)=>{
    (0, $329ek.warn)('TSL: .varying() has been renamed to .toVarying().');
    return $d89c9137a3d237c2$var$varying(...params);
});
$d89c9137a3d237c2$var$addMethodChaining('vertexStage', (...params)=>{
    (0, $329ek.warn)('TSL: .vertexStage() has been renamed to .toVertexStage().');
    return $d89c9137a3d237c2$var$varying(...params);
});
/**
 * Converts the given color value from sRGB to linear-sRGB color space.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The sRGB color.
 * @return {Node<vec3>} The linear-sRGB color.
 */ const $d89c9137a3d237c2$var$sRGBTransferEOTF = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color])=>{
    const a = color.mul(0.9478672986).add(0.0521327014).pow(2.4);
    const b = color.mul(0.0773993808);
    const factor = color.lessThanEqual(0.04045);
    const rgbResult = $d89c9137a3d237c2$var$mix(a, b, factor);
    return rgbResult;
}).setLayout({
    name: 'sRGBTransferEOTF',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        }
    ]
});
/**
 * Converts the given color value from linear-sRGB to sRGB color space.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The linear-sRGB color.
 * @return {Node<vec3>} The sRGB color.
 */ const $d89c9137a3d237c2$var$sRGBTransferOETF = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color])=>{
    const a = color.pow(0.41666).mul(1.055).sub(0.055);
    const b = color.mul(12.92);
    const factor = color.lessThanEqual(0.0031308);
    const rgbResult = $d89c9137a3d237c2$var$mix(a, b, factor);
    return rgbResult;
}).setLayout({
    name: 'sRGBTransferOETF',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$WORKING_COLOR_SPACE = 'WorkingColorSpace';
const $d89c9137a3d237c2$var$OUTPUT_COLOR_SPACE = 'OutputColorSpace';
/**
 * This node represents a color space conversion. Meaning it converts
 * a color value from a source to a target color space.
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$2caa30bfe4e17f17 extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'ColorSpaceNode';
    }
    /**
	 * Constructs a new color space node.
	 *
	 * @param {Node} colorNode - Represents the color to convert.
	 * @param {string} source - The source color space.
	 * @param {string} target - The target color space.
	 */ constructor(colorNode, source, target){
        super('vec4');
        /**
		 * Represents the color to convert.
		 *
		 * @type {Node}
		 */ this.colorNode = colorNode;
        /**
		 * The source color space.
		 *
		 * @type {string}
		 */ this.source = source;
        /**
		 * The target color space.
		 *
		 * @type {string}
		 */ this.target = target;
    }
    /**
	 * This method resolves the constants `WORKING_COLOR_SPACE` and
	 * `OUTPUT_COLOR_SPACE` based on the current configuration of the
	 * color management and renderer.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} colorSpace - The color space to resolve.
	 * @return {string} The resolved color space.
	 */ resolveColorSpace(builder, colorSpace) {
        if (colorSpace === $d89c9137a3d237c2$var$WORKING_COLOR_SPACE) return (0, $329ek.ColorManagement).workingColorSpace;
        else if (colorSpace === $d89c9137a3d237c2$var$OUTPUT_COLOR_SPACE) return builder.context.outputColorSpace || builder.renderer.outputColorSpace;
        return colorSpace;
    }
    setup(builder) {
        const { colorNode: colorNode } = this;
        const source = this.resolveColorSpace(builder, this.source);
        const target = this.resolveColorSpace(builder, this.target);
        let outputNode = colorNode;
        if ((0, $329ek.ColorManagement).enabled === false || source === target || !source || !target) return outputNode;
        if ((0, $329ek.ColorManagement).getTransfer(source) === (0, $329ek.SRGBTransfer)) outputNode = $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$sRGBTransferEOTF(outputNode.rgb), outputNode.a);
        if ((0, $329ek.ColorManagement).getPrimaries(source) !== (0, $329ek.ColorManagement).getPrimaries(target)) outputNode = $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$mat3((0, $329ek.ColorManagement)._getMatrix(new (0, $329ek.Matrix3)(), source, target)).mul(outputNode.rgb), outputNode.a);
        if ((0, $329ek.ColorManagement).getTransfer(target) === (0, $329ek.SRGBTransfer)) outputNode = $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$sRGBTransferOETF(outputNode.rgb), outputNode.a);
        return outputNode;
    }
}
/**
 * TSL function for converting a given color node from the current working color space to the given color space.
 *
 * @tsl
 * @function
 * @param {Node} node - Represents the node to convert.
 * @param {string} targetColorSpace - The target color space.
 * @returns {ColorSpaceNode}
 */ const $d89c9137a3d237c2$var$workingToColorSpace = (node, targetColorSpace)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$2caa30bfe4e17f17($d89c9137a3d237c2$var$nodeObject(node), $d89c9137a3d237c2$var$WORKING_COLOR_SPACE, targetColorSpace));
/**
 * TSL function for converting a given color node from the given color space to the current working color space.
 *
 * @tsl
 * @function
 * @param {Node} node - Represents the node to convert.
 * @param {string} sourceColorSpace - The source color space.
 * @returns {ColorSpaceNode}
 */ const $d89c9137a3d237c2$var$colorSpaceToWorking = (node, sourceColorSpace)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$2caa30bfe4e17f17($d89c9137a3d237c2$var$nodeObject(node), sourceColorSpace, $d89c9137a3d237c2$var$WORKING_COLOR_SPACE));
/**
 * TSL function for converting a given color node from one color space to another one.
 *
 * @tsl
 * @function
 * @param {Node} node - Represents the node to convert.
 * @param {string} sourceColorSpace - The source color space.
 * @param {string} targetColorSpace - The target color space.
 * @returns {ColorSpaceNode}
 */ const $d89c9137a3d237c2$var$convertColorSpace = (node, sourceColorSpace, targetColorSpace)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$2caa30bfe4e17f17($d89c9137a3d237c2$var$nodeObject(node), sourceColorSpace, targetColorSpace));
$d89c9137a3d237c2$var$addMethodChaining('workingToColorSpace', $d89c9137a3d237c2$var$workingToColorSpace);
$d89c9137a3d237c2$var$addMethodChaining('colorSpaceToWorking', $d89c9137a3d237c2$var$colorSpaceToWorking);
// TODO: Avoid duplicated code and use only ReferenceBaseNode or ReferenceNode
/**
 * This class is only relevant if the referenced property is array-like.
 * In this case, `ReferenceElementNode` allows to refer to a specific
 * element inside the data structure via an index.
 *
 * @augments ArrayElementNode
 */ let $d89c9137a3d237c2$var$ReferenceElementNode$1 = class ReferenceElementNode extends $d89c9137a3d237c2$export$f2edd1d22bf6d00b {
    static get type() {
        return 'ReferenceElementNode';
    }
    /**
	 * Constructs a new reference element node.
	 *
	 * @param {ReferenceBaseNode} referenceNode - The reference node.
	 * @param {Node} indexNode - The index node that defines the element access.
	 */ constructor(referenceNode, indexNode){
        super(referenceNode, indexNode);
        /**
		 * Similar to {@link ReferenceBaseNode#reference}, an additional
		 * property references to the current node.
		 *
		 * @type {?ReferenceBaseNode}
		 * @default null
		 */ this.referenceNode = referenceNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isReferenceElementNode = true;
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the uniform type of the reference node.
	 *
	 * @return {string} The node type.
	 */ getNodeType() {
        return this.referenceNode.uniformType;
    }
    generate(builder) {
        const snippet = super.generate(builder);
        const arrayType = this.referenceNode.getNodeType();
        const elementType = this.getNodeType();
        return builder.format(snippet, arrayType, elementType);
    }
};
/**
 * Base class for nodes which establishes a reference to a property of another object.
 * In this way, the value of the node is automatically linked to the value of
 * referenced object. Reference nodes internally represent the linked value
 * as a uniform.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$var$ReferenceBaseNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ReferenceBaseNode';
    }
    /**
	 * Constructs a new reference base node.
	 *
	 * @param {string} property - The name of the property the node refers to.
	 * @param {string} uniformType - The uniform type that should be used to represent the property value.
	 * @param {?Object} [object=null] - The object the property belongs to.
	 * @param {?number} [count=null] - When the linked property is an array-like, this parameter defines its length.
	 */ constructor(property, uniformType, object = null, count = null){
        super();
        /**
		 * The name of the property the node refers to.
		 *
		 * @type {string}
		 */ this.property = property;
        /**
		 * The uniform type that should be used to represent the property value.
		 *
		 * @type {string}
		 */ this.uniformType = uniformType;
        /**
		 * The object the property belongs to.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.object = object;
        /**
		 * When the linked property is an array, this parameter defines its length.
		 *
		 * @type {?number}
		 * @default null
		 */ this.count = count;
        /**
		 * The property name might have dots so nested properties can be referred.
		 * The hierarchy of the names is stored inside this array.
		 *
		 * @type {Array<string>}
		 */ this.properties = property.split('.');
        /**
		 * Points to the current referred object. This property exists next to {@link ReferenceNode#object}
		 * since the final reference might be updated from calling code.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.reference = object;
        /**
		 * The uniform node that holds the value of the reference node.
		 *
		 * @type {UniformNode}
		 * @default null
		 */ this.node = null;
        /**
		 * The uniform group of the internal uniform.
		 *
		 * @type {UniformGroupNode}
		 * @default null
		 */ this.group = null;
        /**
		 * Overwritten since reference nodes are updated per object.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT;
    }
    /**
	 * Sets the uniform group for this reference node.
	 *
	 * @param {UniformGroupNode} group - The uniform group to set.
	 * @return {ReferenceBaseNode} A reference to this node.
	 */ setGroup(group) {
        this.group = group;
        return this;
    }
    /**
	 * When the referred property is array-like, this method can be used
	 * to access elements via an index node.
	 *
	 * @param {IndexNode} indexNode - indexNode.
	 * @return {ReferenceElementNode} A reference to an element.
	 */ element(indexNode) {
        return new $d89c9137a3d237c2$var$ReferenceElementNode$1(this, $d89c9137a3d237c2$var$nodeObject(indexNode));
    }
    /**
	 * Sets the node type which automatically defines the internal
	 * uniform type.
	 *
	 * @param {string} uniformType - The type to set.
	 */ setNodeType(uniformType) {
        const node = $d89c9137a3d237c2$var$uniform(null, uniformType);
        if (this.group !== null) node.setGroup(this.group);
        this.node = node;
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the type of the reference node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        if (this.node === null) {
            this.updateReference(builder);
            this.updateValue();
        }
        return this.node.getNodeType(builder);
    }
    /**
	 * Returns the property value from the given referred object.
	 *
	 * @param {Object} [object=this.reference] - The object to retrieve the property value from.
	 * @return {any} The value.
	 */ getValueFromReference(object = this.reference) {
        const { properties: properties } = this;
        let value = object[properties[0]];
        for(let i = 1; i < properties.length; i++)value = value[properties[i]];
        return value;
    }
    /**
	 * Allows to update the reference based on the given state. The state is only
	 * evaluated {@link ReferenceBaseNode#object} is not set.
	 *
	 * @param {(NodeFrame|NodeBuilder)} state - The current state.
	 * @return {Object} The updated reference.
	 */ updateReference(state) {
        this.reference = this.object !== null ? this.object : state.object;
        return this.reference;
    }
    /**
	 * The output of the reference node is the internal uniform node.
	 *
	 * @return {UniformNode} The output node.
	 */ setup() {
        this.updateValue();
        return this.node;
    }
    /**
	 * Overwritten to update the internal uniform value.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update() {
        this.updateValue();
    }
    /**
	 * Retrieves the value from the referred object property and uses it
	 * to updated the internal uniform.
	 */ updateValue() {
        if (this.node === null) this.setNodeType(this.uniformType);
        const value = this.getValueFromReference();
        if (Array.isArray(value)) this.node.array = value;
        else this.node.value = value;
    }
}
/**
 * TSL function for creating a reference base node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the property the node refers to.
 * @param {string} type - The uniform type that should be used to represent the property value.
 * @param {Object} object - The object the property belongs to.
 * @returns {ReferenceBaseNode}
 */ const $d89c9137a3d237c2$var$reference$1 = (name, type, object)=>new $d89c9137a3d237c2$var$ReferenceBaseNode(name, type, object);
/**
 * This node is a special type of reference node which is intended
 * for linking renderer properties with node values.
 * ```js
 * const exposureNode = rendererReference( 'toneMappingExposure', 'float', renderer );
 * ```
 * When changing `renderer.toneMappingExposure`, the node value of `exposureNode` will
 * automatically be updated.
 *
 * @augments ReferenceBaseNode
 */ class $d89c9137a3d237c2$export$97b2e7d082b6f330 extends $d89c9137a3d237c2$var$ReferenceBaseNode {
    static get type() {
        return 'RendererReferenceNode';
    }
    /**
	 * Constructs a new renderer reference node.
	 *
	 * @param {string} property - The name of the property the node refers to.
	 * @param {string} inputType - The uniform type that should be used to represent the property value.
	 * @param {?Renderer} [renderer=null] - The renderer the property belongs to. When no renderer is set,
	 * the node refers to the renderer of the current state.
	 */ constructor(property, inputType, renderer = null){
        super(property, inputType, renderer);
        /**
		 * The renderer the property belongs to. When no renderer is set,
		 * the node refers to the renderer of the current state.
		 *
		 * @type {?Renderer}
		 * @default null
		 */ this.renderer = renderer;
        this.setGroup($d89c9137a3d237c2$var$renderGroup);
    }
    /**
	 * Updates the reference based on the given state. The state is only evaluated
	 * {@link RendererReferenceNode#renderer} is not set.
	 *
	 * @param {(NodeFrame|NodeBuilder)} state - The current state.
	 * @return {Object} The updated reference.
	 */ updateReference(state) {
        this.reference = this.renderer !== null ? this.renderer : state.renderer;
        return this.reference;
    }
}
/**
 * TSL function for creating a renderer reference node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the property the node refers to.
 * @param {string} type - The uniform type that should be used to represent the property value.
 * @param {?Renderer} [renderer=null] - The renderer the property belongs to. When no renderer is set,
 * the node refers to the renderer of the current state.
 * @returns {RendererReferenceNode}
 */ const $d89c9137a3d237c2$var$rendererReference = (name, type, renderer = null)=>new $d89c9137a3d237c2$export$97b2e7d082b6f330(name, type, renderer);
/**
 * This node represents a tone mapping operation.
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$efafcf9256d00888 extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'ToneMappingNode';
    }
    /**
	 * Constructs a new tone mapping node.
	 *
	 * @param {number} toneMapping - The tone mapping type.
	 * @param {Node} exposureNode - The tone mapping exposure.
	 * @param {Node} [colorNode=null] - The color node to process.
	 */ constructor(toneMapping, exposureNode = $d89c9137a3d237c2$var$toneMappingExposure, colorNode = null){
        super('vec3');
        /**
		 * The tone mapping type.
		 *
		 * @private
		 * @type {number}
		 */ this._toneMapping = toneMapping;
        /**
		 * The tone mapping exposure.
		 *
		 * @type {Node}
		 * @default null
		 */ this.exposureNode = exposureNode;
        /**
		 * Represents the color to process.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.colorNode = colorNode;
    }
    /**
	 * Overwrites the default `customCacheKey()` implementation by including the tone
	 * mapping type into the cache key.
	 *
	 * @return {number} The hash.
	 */ customCacheKey() {
        return $d89c9137a3d237c2$var$hash$1(this._toneMapping);
    }
    /**
	 * Sets the tone mapping type.
	 *
	 * @param {number} value - The tone mapping type.
	 * @return {ToneMappingNode} A reference to this node.
	 */ setToneMapping(value) {
        this._toneMapping = value;
        return this;
    }
    /**
	 * Gets the tone mapping type.
	 *
	 * @returns {number} The tone mapping type.
	 */ getToneMapping() {
        return this._toneMapping;
    }
    setup(builder) {
        const colorNode = this.colorNode || builder.context.color;
        const toneMapping = this._toneMapping;
        if (toneMapping === (0, $329ek.NoToneMapping)) return colorNode;
        let outputNode = null;
        const toneMappingFn = builder.renderer.library.getToneMappingFunction(toneMapping);
        if (toneMappingFn !== null) outputNode = $d89c9137a3d237c2$var$vec4(toneMappingFn(colorNode.rgb, this.exposureNode), colorNode.a);
        else {
            (0, $329ek.error)('ToneMappingNode: Unsupported Tone Mapping configuration.', toneMapping);
            outputNode = colorNode;
        }
        return outputNode;
    }
}
/**
 * TSL function for creating a tone mapping node.
 *
 * @tsl
 * @function
 * @param {number} mapping - The tone mapping type.
 * @param {Node<float> | number} exposure - The tone mapping exposure.
 * @param {Node<vec3> | Color} color - The color node to process.
 * @returns {ToneMappingNode<vec3>}
 */ const $d89c9137a3d237c2$var$toneMapping = (mapping, exposure, color)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$efafcf9256d00888(mapping, $d89c9137a3d237c2$var$nodeObject(exposure), $d89c9137a3d237c2$var$nodeObject(color)));
/**
 * TSL object that represents the global tone mapping exposure of the renderer.
 *
 * @tsl
 * @type {RendererReferenceNode<vec3>}
 */ const $d89c9137a3d237c2$var$toneMappingExposure = /*@__PURE__*/ $d89c9137a3d237c2$var$rendererReference('toneMappingExposure', 'float');
$d89c9137a3d237c2$var$addMethodChaining('toneMapping', (color, mapping, exposure)=>$d89c9137a3d237c2$var$toneMapping(mapping, exposure, color));
/**
 * Internal buffer attribute library.
 *
 * @private
 * @type {WeakMap<TypedArray, InterleavedBuffer>}
 */ const $d89c9137a3d237c2$var$_bufferLib = new WeakMap();
/**
 * Internal method for retrieving or creating interleaved buffers.
 *
 * @private
 * @param {TypedArray} value - The attribute data.
 * @param {number} itemSize - The attribute item size.
 * @returns {InterleavedBuffer} The interleaved buffer.
 */ function $d89c9137a3d237c2$var$_getBufferAttribute(value, itemSize) {
    let buffer = $d89c9137a3d237c2$var$_bufferLib.get(value);
    if (buffer === undefined) {
        buffer = new (0, $329ek.InterleavedBuffer)(value, itemSize);
        $d89c9137a3d237c2$var$_bufferLib.set(value, buffer);
    }
    return buffer;
}
/**
 * In earlier `three.js` versions it was only possible to define attribute data
 * on geometry level. With `BufferAttributeNode`, it is also possible to do this
 * on the node level.
 * ```js
 * const geometry = new THREE.PlaneGeometry();
 * const positionAttribute = geometry.getAttribute( 'position' );
 *
 * const colors = [];
 * for ( let i = 0; i < position.count; i ++ ) {
 * 	colors.push( 1, 0, 0 );
 * }
 *
 * material.colorNode = bufferAttribute( new THREE.Float32BufferAttribute( colors, 3 ) );
 * ```
 * This new approach is especially interesting when geometry data are generated via
 * compute shaders. The below line converts a storage buffer into an attribute node.
 * ```js
 * material.positionNode = positionBuffer.toAttribute();
 * ```
 * @augments InputNode
 */ class $d89c9137a3d237c2$export$7d6c96ed9fce09e extends $d89c9137a3d237c2$var$InputNode {
    static get type() {
        return 'BufferAttributeNode';
    }
    /**
	 * Constructs a new buffer attribute node.
	 *
	 * @param {BufferAttribute|InterleavedBuffer|TypedArray} value - The attribute data.
	 * @param {?string} [bufferType=null] - The buffer type (e.g. `'vec3'`).
	 * @param {number} [bufferStride=0] - The buffer stride.
	 * @param {number} [bufferOffset=0] - The buffer offset.
	 */ constructor(value, bufferType = null, bufferStride = 0, bufferOffset = 0){
        super(value, bufferType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferNode = true;
        /**
		 * The buffer type (e.g. `'vec3'`).
		 *
		 * @type {?string}
		 * @default null
		 */ this.bufferType = bufferType;
        /**
		 * The buffer stride.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bufferStride = bufferStride;
        /**
		 * The buffer offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bufferOffset = bufferOffset;
        /**
		 * The usage property. Set this to `THREE.DynamicDrawUsage` via `.setUsage()`,
		 * if you are planning to update the attribute data per frame.
		 *
		 * @type {number}
		 * @default StaticDrawUsage
		 */ this.usage = (0, $329ek.StaticDrawUsage);
        /**
		 * Whether the attribute is instanced or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.instanced = false;
        /**
		 * A reference to the buffer attribute.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.attribute = null;
        /**
		 * `BufferAttributeNode` sets this property to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
        if (value && value.isBufferAttribute === true && value.itemSize <= 4) {
            this.attribute = value;
            this.usage = value.usage;
            this.instanced = value.isInstancedBufferAttribute;
        }
    }
    /**
	 * This method is overwritten since the attribute data might be shared
	 * and thus the hash should be shared as well.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The hash.
	 */ getHash(builder) {
        if (this.bufferStride === 0 && this.bufferOffset === 0) {
            let bufferData = builder.globalCache.getData(this.value);
            if (bufferData === undefined) {
                bufferData = {
                    node: this
                };
                builder.globalCache.setData(this.value, bufferData);
            }
            return bufferData.node.uuid;
        }
        return this.uuid;
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the buffer attribute.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        if (this.bufferType === null) this.bufferType = builder.getTypeFromAttribute(this.attribute);
        return this.bufferType;
    }
    /**
	 * Depending on which value was passed to the node, `setup()` behaves
	 * differently. If no instance of `BufferAttribute` was passed, the method
	 * creates an internal attribute and configures it respectively.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        if (this.attribute !== null) return;
        //
        const type = this.getNodeType(builder);
        const itemSize = builder.getTypeLength(type);
        const value = this.value;
        const stride = this.bufferStride || itemSize;
        const offset = this.bufferOffset;
        let buffer;
        if (value.isInterleavedBuffer === true) buffer = value;
        else if (value.isBufferAttribute === true) buffer = $d89c9137a3d237c2$var$_getBufferAttribute(value.array, stride);
        else buffer = $d89c9137a3d237c2$var$_getBufferAttribute(value, stride);
        const bufferAttribute = new (0, $329ek.InterleavedBufferAttribute)(buffer, itemSize, offset);
        buffer.setUsage(this.usage);
        this.attribute = bufferAttribute;
        this.attribute.isInstancedBufferAttribute = this.instanced; // @TODO: Add a possible: InstancedInterleavedBufferAttribute
    }
    /**
	 * Generates the code snippet of the buffer attribute node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated code snippet.
	 */ generate(builder) {
        const nodeType = this.getNodeType(builder);
        const nodeAttribute = builder.getBufferAttributeFromNode(this, nodeType);
        const propertyName = builder.getPropertyName(nodeAttribute);
        let output = null;
        if (builder.shaderStage === 'vertex' || builder.shaderStage === 'compute') {
            this.name = propertyName;
            output = propertyName;
        } else {
            const nodeVarying = $d89c9137a3d237c2$var$varying(this);
            output = nodeVarying.build(builder, nodeType);
        }
        return output;
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'bufferAttribute'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return 'bufferAttribute';
    }
    /**
	 * Sets the `usage` property to the given value.
	 *
	 * @param {number} value - The usage to set.
	 * @return {BufferAttributeNode} A reference to this node.
	 */ setUsage(value) {
        this.usage = value;
        if (this.attribute && this.attribute.isBufferAttribute === true) this.attribute.usage = value;
        return this;
    }
    /**
	 * Sets the `instanced` property to the given value.
	 *
	 * @param {boolean} value - The value to set.
	 * @return {BufferAttributeNode} A reference to this node.
	 */ setInstanced(value) {
        this.instanced = value;
        return this;
    }
}
/**
 * Internal method for creating buffer attribute nodes.
 *
 * @private
 * @param {BufferAttribute|InterleavedBuffer|TypedArray} array - The attribute data.
 * @param {?string} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [stride=0] - The buffer stride.
 * @param {number} [offset=0] - The buffer offset.
 * @param {number} [usage=StaticDrawUsage] - The buffer usage.
 * @param {boolean} [instanced=false] - Whether the buffer is instanced.
 * @returns {BufferAttributeNode|Node} The buffer attribute node.
 */ function $d89c9137a3d237c2$var$createBufferAttribute(array, type = null, stride = 0, offset = 0, usage = (0, $329ek.StaticDrawUsage), instanced = false) {
    if (type === 'mat3' || type === null && array.itemSize === 9) return $d89c9137a3d237c2$var$mat3(new $d89c9137a3d237c2$export$7d6c96ed9fce09e(array, 'vec3', 9, 0).setUsage(usage).setInstanced(instanced), new $d89c9137a3d237c2$export$7d6c96ed9fce09e(array, 'vec3', 9, 3).setUsage(usage).setInstanced(instanced), new $d89c9137a3d237c2$export$7d6c96ed9fce09e(array, 'vec3', 9, 6).setUsage(usage).setInstanced(instanced));
    else if (type === 'mat4' || type === null && array.itemSize === 16) return $d89c9137a3d237c2$var$mat4(new $d89c9137a3d237c2$export$7d6c96ed9fce09e(array, 'vec4', 16, 0).setUsage(usage).setInstanced(instanced), new $d89c9137a3d237c2$export$7d6c96ed9fce09e(array, 'vec4', 16, 4).setUsage(usage).setInstanced(instanced), new $d89c9137a3d237c2$export$7d6c96ed9fce09e(array, 'vec4', 16, 8).setUsage(usage).setInstanced(instanced), new $d89c9137a3d237c2$export$7d6c96ed9fce09e(array, 'vec4', 16, 12).setUsage(usage).setInstanced(instanced));
    return new $d89c9137a3d237c2$export$7d6c96ed9fce09e(array, type, stride, offset);
}
/**
 * TSL function for creating a buffer attribute node.
 *
 * @tsl
 * @function
 * @param {BufferAttribute|InterleavedBuffer|TypedArray} array - The attribute data.
 * @param {?string} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [stride=0] - The buffer stride.
 * @param {number} [offset=0] - The buffer offset.
 * @returns {BufferAttributeNode|Node}
 */ const $d89c9137a3d237c2$var$bufferAttribute = (array, type = null, stride = 0, offset = 0)=>$d89c9137a3d237c2$var$createBufferAttribute(array, type, stride, offset);
/**
 * TSL function for creating a buffer attribute node but with dynamic draw usage.
 * Use this function if attribute data are updated per frame.
 *
 * @tsl
 * @function
 * @param {BufferAttribute|InterleavedBuffer|TypedArray} array - The attribute data.
 * @param {?string} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [stride=0] - The buffer stride.
 * @param {number} [offset=0] - The buffer offset.
 * @returns {BufferAttributeNode|Node}
 */ const $d89c9137a3d237c2$var$dynamicBufferAttribute = (array, type = null, stride = 0, offset = 0)=>$d89c9137a3d237c2$var$createBufferAttribute(array, type, stride, offset, (0, $329ek.DynamicDrawUsage));
/**
 * TSL function for creating a buffer attribute node but with enabled instancing
 *
 * @tsl
 * @function
 * @param {BufferAttribute|InterleavedBuffer|TypedArray} array - The attribute data.
 * @param {?string} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [stride=0] - The buffer stride.
 * @param {number} [offset=0] - The buffer offset.
 * @returns {BufferAttributeNode|Node}
 */ const $d89c9137a3d237c2$var$instancedBufferAttribute = (array, type = null, stride = 0, offset = 0)=>$d89c9137a3d237c2$var$createBufferAttribute(array, type, stride, offset, (0, $329ek.StaticDrawUsage), true);
/**
 * TSL function for creating a buffer attribute node but with dynamic draw usage and enabled instancing
 *
 * @tsl
 * @function
 * @param {BufferAttribute|InterleavedBuffer|TypedArray} array - The attribute data.
 * @param {?string} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [stride=0] - The buffer stride.
 * @param {number} [offset=0] - The buffer offset.
 * @returns {BufferAttributeNode|Node}
 */ const $d89c9137a3d237c2$var$instancedDynamicBufferAttribute = (array, type = null, stride = 0, offset = 0)=>$d89c9137a3d237c2$var$createBufferAttribute(array, type, stride, offset, (0, $329ek.DynamicDrawUsage), true);
$d89c9137a3d237c2$var$addMethodChaining('toAttribute', (bufferNode)=>$d89c9137a3d237c2$var$bufferAttribute(bufferNode.value));
/**
 * TODO
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$49fb11e9f3090754 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ComputeNode';
    }
    /**
	 * Constructs a new compute node.
	 *
	 * @param {Node} computeNode - TODO
	 * @param {Array<number>} workgroupSize - TODO.
	 */ constructor(computeNode, workgroupSize){
        super('void');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isComputeNode = true;
        /**
		 * TODO
		 *
		 * @type {Node}
		 */ this.computeNode = computeNode;
        /**
		 * TODO
		 *
		 * @type {Array<number>}
		 * @default [ 64 ]
		 */ this.workgroupSize = workgroupSize;
        /**
		 * TODO
		 *
		 * @type {number|Array<number>}
		 */ this.count = null;
        /**
		 * TODO
		 *
		 * @type {number}
		 */ this.version = 1;
        /**
		 * The name or label of the uniform.
		 *
		 * @type {string}
		 * @default ''
		 */ this.name = '';
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.OBJECT` since {@link ComputeNode#updateBefore}
		 * is executed once per object by default.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateBeforeType = $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT;
        /**
		 * TODO
		 *
		 * @type {?Function}
		 */ this.onInitFunction = null;
    }
    /**
	 * TODO
	 *
	 * @param {number|Array<number>} count - Array with [ x, y, z ] values for dispatch or a single number for the count
	 * @return {ComputeNode}
	 */ setCount(count) {
        this.count = count;
        return this;
    }
    /**
	 * TODO
	 *
	 * @return {number|Array<number>}
	 */ getCount() {
        return this.count;
    }
    /**
	 * Executes the `dispose` event for this node.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Sets the {@link ComputeNode#name} property.
	 *
	 * @param {string} name - The name of the uniform.
	 * @return {ComputeNode} A reference to this node.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the {@link ComputeNode#name} property.
	 *
	 * @deprecated
	 * @param {string} name - The name of the uniform.
	 * @return {ComputeNode} A reference to this node.
	 */ label(name) {
        (0, $329ek.warn)('TSL: "label()" has been deprecated. Use "setName()" instead.'); // @deprecated r179
        return this.setName(name);
    }
    /**
	 * TODO
	 *
	 * @param {Function} callback - TODO.
	 * @return {ComputeNode} A reference to this node.
	 */ onInit(callback) {
        this.onInitFunction = callback;
        return this;
    }
    /**
	 * The method execute the compute for this node.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ updateBefore({ renderer: renderer }) {
        renderer.compute(this);
    }
    setup(builder) {
        const result = this.computeNode.build(builder);
        if (result) {
            const properties = builder.getNodeProperties(this);
            properties.outputComputeNode = result.outputNode;
            result.outputNode = null;
        }
        return result;
    }
    generate(builder, output) {
        const { shaderStage: shaderStage } = builder;
        if (shaderStage === 'compute') {
            const snippet = this.computeNode.build(builder, 'void');
            if (snippet !== '') builder.addLineFlowCode(snippet, this);
        } else {
            const properties = builder.getNodeProperties(this);
            const outputComputeNode = properties.outputComputeNode;
            if (outputComputeNode) return outputComputeNode.build(builder, output);
        }
    }
}
/**
 * TSL function for creating a compute kernel node.
 *
 * @tsl
 * @function
 * @param {Node} node - TODO
 * @param {Array<number>} [workgroupSize=[64]] - TODO.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$computeKernel = (node, workgroupSize = [
    64
])=>{
    if (workgroupSize.length === 0 || workgroupSize.length > 3) (0, $329ek.error)('TSL: compute() workgroupSize must have 1, 2, or 3 elements');
    for(let i = 0; i < workgroupSize.length; i++){
        const val = workgroupSize[i];
        if (typeof val !== 'number' || val <= 0 || !Number.isInteger(val)) (0, $329ek.error)(`TSL: compute() workgroupSize element at index [ ${i} ] must be a positive integer`);
    }
    // Implicit fill-up to [ x, y, z ] with 1s, just like WGSL treats @workgroup_size when fewer dimensions are specified
    while(workgroupSize.length < 3)workgroupSize.push(1);
    //
    return $d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$49fb11e9f3090754($d89c9137a3d237c2$var$nodeObject(node), workgroupSize));
};
/**
 * TSL function for creating a compute node.
 *
 * @tsl
 * @function
 * @param {Node} node - TODO
 * @param {number|Array<number>} count - TODO.
 * @param {Array<number>} [workgroupSize=[64]] - TODO.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$compute = (node, count, workgroupSize)=>$d89c9137a3d237c2$var$computeKernel(node, workgroupSize).setCount(count);
$d89c9137a3d237c2$var$addMethodChaining('compute', $d89c9137a3d237c2$var$compute);
$d89c9137a3d237c2$var$addMethodChaining('computeKernel', $d89c9137a3d237c2$var$computeKernel);
/**
 * This node can be used as a cache management component for another node.
 * Caching is in general used by default in {@link NodeBuilder} but this node
 * allows the usage of a shared parent cache during the build process.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$473c54a186290bb7 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'IsolateNode';
    }
    /**
	 * Constructs a new cache node.
	 *
	 * @param {Node} node - The node that should be cached.
	 * @param {boolean} [parent=true] - Whether this node refers to a shared parent cache or not.
	 */ constructor(node, parent = true){
        super();
        /**
		 * The node that should be cached.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * Whether this node refers to a shared parent cache or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.parent = parent;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isIsolateNode = true;
    }
    getNodeType(builder) {
        const previousCache = builder.getCache();
        const cache = builder.getCacheFromNode(this, this.parent);
        builder.setCache(cache);
        const nodeType = this.node.getNodeType(builder);
        builder.setCache(previousCache);
        return nodeType;
    }
    build(builder, ...params) {
        const previousCache = builder.getCache();
        const cache = builder.getCacheFromNode(this, this.parent);
        builder.setCache(cache);
        const data = this.node.build(builder, ...params);
        builder.setCache(previousCache);
        return data;
    }
    setParent(parent) {
        this.parent = parent;
        return this;
    }
    getParent() {
        return this.parent;
    }
}
/**
 * TSL function for creating a cache node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node that should be cached.
 * @returns {IsolateNode}
 */ const $d89c9137a3d237c2$var$isolate = (node)=>new $d89c9137a3d237c2$export$473c54a186290bb7($d89c9137a3d237c2$var$nodeObject(node));
/**
 * TSL function for creating a cache node.
 *
 * @tsl
 * @function
 * @deprecated
 * @param {Node} node - The node that should be cached.
 * @param {boolean} [parent=true] - Whether this node refers to a shared parent cache or not.
 * @returns {IsolateNode}
 */ function $d89c9137a3d237c2$var$cache(node, parent = true) {
    (0, $329ek.warn)('TSL: "cache()" has been deprecated. Use "isolate()" instead.'); // @deprecated r181
    return $d89c9137a3d237c2$var$isolate(node).setParent(parent);
}
$d89c9137a3d237c2$var$addMethodChaining('cache', $d89c9137a3d237c2$var$cache);
$d89c9137a3d237c2$var$addMethodChaining('isolate', $d89c9137a3d237c2$var$isolate);
/**
 * The class generates the code of a given node but returns another node in the output.
 * This can be used to call a method or node that does not return a value, i.e.
 * type `void` on an input where returning a value is required. Example:
 *
 * ```js
 * material.colorNode = myColor.bypass( runVoidFn() )
 *```
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$c5fec9e8f9ef1a13 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'BypassNode';
    }
    /**
	 * Constructs a new bypass node.
	 *
	 * @param {Node} outputNode - The output node.
	 * @param {Node} callNode - The call node.
	 */ constructor(outputNode, callNode){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBypassNode = true;
        /**
		 * The output node.
		 *
		 * @type {Node}
		 */ this.outputNode = outputNode;
        /**
		 * The call node.
		 *
		 * @type {Node}
		 */ this.callNode = callNode;
    }
    getNodeType(builder) {
        return this.outputNode.getNodeType(builder);
    }
    generate(builder) {
        const snippet = this.callNode.build(builder, 'void');
        if (snippet !== '') builder.addLineFlowCode(snippet, this);
        return this.outputNode.build(builder);
    }
}
/**
 * TSL function for creating a bypass node.
 *
 * @tsl
 * @function
 * @param {Node} outputNode - The output node.
 * @param {Node} callNode - The call node.
 * @returns {BypassNode}
 */ const $d89c9137a3d237c2$var$bypass = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$c5fec9e8f9ef1a13).setParameterLength(2);
$d89c9137a3d237c2$var$addMethodChaining('bypass', $d89c9137a3d237c2$var$bypass);
/**
 * This node allows to remap a node value from one range into another. E.g a value of
 * `0.4` in the range `[ 0.3, 0.5 ]` should be remapped into the normalized range `[ 0, 1 ]`.
 * `RemapNode` takes care of that and converts the original value of `0.4` to `0.5`.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$89eb7dae90801eff extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'RemapNode';
    }
    /**
	 * Constructs a new remap node.
	 *
	 * @param {Node} node - The node that should be remapped.
	 * @param {Node} inLowNode - The source or current lower bound of the range.
	 * @param {Node} inHighNode - The source or current upper bound of the range.
	 * @param {Node} [outLowNode=float(0)] - The target lower bound of the range.
	 * @param {Node} [outHighNode=float(1)] - The target upper bound of the range.
	 */ constructor(node, inLowNode, inHighNode, outLowNode = $d89c9137a3d237c2$var$float(0), outHighNode = $d89c9137a3d237c2$var$float(1)){
        super();
        /**
		 * The node that should be remapped.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The source or current lower bound of the range.
		 *
		 * @type {Node}
		 */ this.inLowNode = inLowNode;
        /**
		 * The source or current upper bound of the range.
		 *
		 * @type {Node}
		 */ this.inHighNode = inHighNode;
        /**
		 * The target lower bound of the range.
		 *
		 * @type {Node}
		 * @default float(0)
		 */ this.outLowNode = outLowNode;
        /**
		 * The target upper bound of the range.
		 *
		 * @type {Node}
		 * @default float(1)
		 */ this.outHighNode = outHighNode;
        /**
		 * Whether the node value should be clamped before
		 * remapping it to the target range.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.doClamp = true;
    }
    setup() {
        const { node: node, inLowNode: inLowNode, inHighNode: inHighNode, outLowNode: outLowNode, outHighNode: outHighNode, doClamp: doClamp } = this;
        let t = node.sub(inLowNode).div(inHighNode.sub(inLowNode));
        if (doClamp === true) t = t.clamp();
        return t.mul(outHighNode.sub(outLowNode)).add(outLowNode);
    }
}
/**
 * TSL function for creating a remap node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node that should be remapped.
 * @param {Node} inLowNode - The source or current lower bound of the range.
 * @param {Node} inHighNode - The source or current upper bound of the range.
 * @param {?Node} [outLowNode=float(0)] - The target lower bound of the range.
 * @param {?Node} [outHighNode=float(1)] - The target upper bound of the range.
 * @returns {RemapNode}
 */ const $d89c9137a3d237c2$var$remap = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$89eb7dae90801eff, null, null, {
    doClamp: false
}).setParameterLength(3, 5);
/**
 * TSL function for creating a remap node, but with enabled clamping.
 *
 * @tsl
 * @function
 * @param {Node} node - The node that should be remapped.
 * @param {Node} inLowNode - The source or current lower bound of the range.
 * @param {Node} inHighNode - The source or current upper bound of the range.
 * @param {?Node} [outLowNode=float(0)] - The target lower bound of the range.
 * @param {?Node} [outHighNode=float(1)] - The target upper bound of the range.
 * @returns {RemapNode}
 */ const $d89c9137a3d237c2$var$remapClamp = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$89eb7dae90801eff).setParameterLength(3, 5);
$d89c9137a3d237c2$var$addMethodChaining('remap', $d89c9137a3d237c2$var$remap);
$d89c9137a3d237c2$var$addMethodChaining('remapClamp', $d89c9137a3d237c2$var$remapClamp);
/**
 * This class can be used to implement basic expressions in shader code.
 * Basic examples for that are `return`, `continue` or `discard` statements.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$e59ba5d29a1947fc extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ExpressionNode';
    }
    /**
	 * Constructs a new expression node.
	 *
	 * @param {string} [snippet=''] - The native code snippet.
	 * @param {string} [nodeType='void'] - The node type.
	 */ constructor(snippet = '', nodeType = 'void'){
        super(nodeType);
        /**
		 * The native code snippet.
		 *
		 * @type {string}
		 * @default ''
		 */ this.snippet = snippet;
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const snippet = this.snippet;
        if (type === 'void') builder.addLineFlowCode(snippet, this);
        else return builder.format(snippet, type, output);
    }
}
/**
 * TSL function for creating an expression node.
 *
 * @tsl
 * @function
 * @param {string} [snippet] - The native code snippet.
 * @param {?string} [nodeType='void'] - The node type.
 * @returns {ExpressionNode}
 */ const $d89c9137a3d237c2$var$expression = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$e59ba5d29a1947fc).setParameterLength(1, 2);
/**
 * Represents a `discard` shader operation in TSL.
 *
 * @tsl
 * @function
 * @param {?ConditionalNode} conditional - An optional conditional node. It allows to decide whether the discard should be executed or not.
 * @return {Node} The `discard` expression.
 */ const $d89c9137a3d237c2$var$Discard = (conditional)=>(conditional ? $d89c9137a3d237c2$var$select(conditional, $d89c9137a3d237c2$var$expression('discard')) : $d89c9137a3d237c2$var$expression('discard')).toStack();
/**
 * Represents a `return` shader operation in TSL.
 *
 * @tsl
 * @function
 * @return {ExpressionNode} The `return` expression.
 */ const $d89c9137a3d237c2$var$Return = ()=>$d89c9137a3d237c2$var$expression('return').toStack();
$d89c9137a3d237c2$var$addMethodChaining('discard', $d89c9137a3d237c2$var$Discard);
/**
 * Normally, tone mapping and color conversion happens automatically
 * before outputting pixel too the default (screen) framebuffer. In certain
 * post processing setups this happens to late because certain effects
 * require e.g. sRGB input. For such scenarios, `RenderOutputNode` can be used
 * to apply tone mapping and color space conversion at an arbitrary point
 * in the effect chain.
 *
 * When applying tone mapping and color space conversion manually with this node,
 * you have to set {@link PostProcessing#outputColorTransform} to `false`.
 *
 * ```js
 * const postProcessing = new PostProcessing( renderer );
 * postProcessing.outputColorTransform = false;
 *
 * const scenePass = pass( scene, camera );
 * const outputPass = renderOutput( scenePass );
 *
 * postProcessing.outputNode = outputPass;
 * ```
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$4fab59b0950d11f6 extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'RenderOutputNode';
    }
    /**
	 * Constructs a new render output node.
	 *
	 * @param {Node} colorNode - The color node to process.
	 * @param {?number} toneMapping - The tone mapping type.
	 * @param {?string} outputColorSpace - The output color space.
	 */ constructor(colorNode, toneMapping, outputColorSpace){
        super('vec4');
        /**
		 * The color node to process.
		 *
		 * @type {Node}
		 */ this.colorNode = colorNode;
        /**
		 * The tone mapping type.
		 *
		 * @private
		 * @type {?number}
		 */ this._toneMapping = toneMapping;
        /**
		 * The output color space.
		 *
		 * @type {?string}
		 */ this.outputColorSpace = outputColorSpace;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderOutputNode = true;
    }
    /**
	 * Sets the tone mapping type.
	 *
	 * @param {number} value - The tone mapping type.
	 * @return {ToneMappingNode} A reference to this node.
	 */ setToneMapping(value) {
        this._toneMapping = value;
        return this;
    }
    /**
	 * Gets the tone mapping type.
	 *
	 * @returns {number} The tone mapping type.
	 */ getToneMapping() {
        return this._toneMapping;
    }
    setup({ context: context }) {
        let outputNode = this.colorNode || context.color;
        // tone mapping
        const toneMapping = (this._toneMapping !== null ? this._toneMapping : context.toneMapping) || (0, $329ek.NoToneMapping);
        const outputColorSpace = (this.outputColorSpace !== null ? this.outputColorSpace : context.outputColorSpace) || (0, $329ek.NoColorSpace);
        if (toneMapping !== (0, $329ek.NoToneMapping)) outputNode = outputNode.toneMapping(toneMapping);
        // working to output color space
        if (outputColorSpace !== (0, $329ek.NoColorSpace) && outputColorSpace !== (0, $329ek.ColorManagement).workingColorSpace) outputNode = outputNode.workingToColorSpace(outputColorSpace);
        return outputNode;
    }
}
/**
 * TSL function for creating a posterize node.
 *
 * @tsl
 * @function
 * @param {Node} color - The color node to process.
 * @param {?number} [toneMapping=null] - The tone mapping type.
 * @param {?string} [outputColorSpace=null] - The output color space.
 * @returns {RenderOutputNode}
 */ const $d89c9137a3d237c2$var$renderOutput = (color, toneMapping = null, outputColorSpace = null)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$4fab59b0950d11f6($d89c9137a3d237c2$var$nodeObject(color), toneMapping, outputColorSpace));
$d89c9137a3d237c2$var$addMethodChaining('renderOutput', $d89c9137a3d237c2$var$renderOutput);
class $d89c9137a3d237c2$export$953fa3790b4cf698 extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'DebugNode';
    }
    constructor(node, callback = null){
        super();
        this.node = node;
        this.callback = callback;
    }
    getNodeType(builder) {
        return this.node.getNodeType(builder);
    }
    setup(builder) {
        return this.node.build(builder);
    }
    analyze(builder) {
        return this.node.build(builder);
    }
    generate(builder) {
        const callback = this.callback;
        const snippet = this.node.build(builder);
        const title = '--- TSL debug - ' + builder.shaderStage + ' shader ---';
        const border = '-'.repeat(title.length);
        let code = '';
        code += '// #' + title + '#\n';
        code += builder.flow.code.replace(/^\t/mg, '') + '\n';
        code += '/* ... */ ' + snippet + ' /* ... */\n';
        code += '// #' + border + '#\n';
        if (callback !== null) callback(builder, code);
        else (0, $329ek.log)(code);
        return snippet;
    }
}
/**
 * TSL function for creating a debug node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node to debug.
 * @param {?Function} [callback=null] - Optional callback function to handle the debug output.
 * @returns {DebugNode}
 */ const $d89c9137a3d237c2$var$debug = (node, callback = null)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$953fa3790b4cf698($d89c9137a3d237c2$var$nodeObject(node), callback)).toStack();
$d89c9137a3d237c2$var$addMethodChaining('debug', $d89c9137a3d237c2$var$debug);
/**
 * InspectorBase is the base class for all inspectors.
 *
 * @class InspectorBase
 */ class $d89c9137a3d237c2$export$660a27ce99fa210b {
    /**
	 * Creates a new InspectorBase.
	 */ constructor(){
        /**
		 * The renderer associated with this inspector.
		 *
		 * @type {WebGLRenderer}
		 * @private
		 */ this._renderer = null;
        /**
		 * The current frame being processed.
		 *
		 * @type {Object}
		 */ this.currentFrame = null;
    }
    /**
	 * Returns the node frame for the current renderer.
	 *
	 * @return {Object} The node frame.
	 */ get nodeFrame() {
        return this._renderer._nodes.nodeFrame;
    }
    /**
	 * Sets the renderer for this inspector.
	 *
	 * @param {WebGLRenderer} renderer - The renderer to associate with this inspector.
	 * @return {InspectorBase} This inspector instance.
	 */ setRenderer(renderer) {
        this._renderer = renderer;
        return this;
    }
    /**
	 * Returns the renderer associated with this inspector.
	 *
	 * @return {WebGLRenderer} The associated renderer.
	 */ getRenderer() {
        return this._renderer;
    }
    /**
	 * Initializes the inspector.
	 */ init() {}
    /**
	 * Called when a frame begins.
	 */ begin() {}
    /**
	 * Called when a frame ends.
	 */ finish() {}
    /**
	 * Inspects a node.
	 *
	 * @param {Node} node - The node to inspect.
	 */ inspect() {}
    /**
	 * When a compute operation is performed.
	 *
	 * @param {ComputeNode} computeNode - The compute node being executed.
	 * @param {number|Array<number>} dispatchSizeOrCount - The dispatch size or count.
	 */ computeAsync() {}
    /**
	 * Called when a compute operation begins.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @param {ComputeNode} computeNode - The compute node being executed.
	 */ beginCompute() {}
    /**
	 * Called when a compute operation ends.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @param {ComputeNode} computeNode - The compute node being executed.
	 */ finishCompute() {}
    /**
	 * Called when a render operation begins.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @param {Scene} scene - The scene being rendered.
	 * @param {Camera} camera - The camera being used for rendering.
	 * @param {?WebGLRenderTarget} renderTarget - The render target, if any.
	 */ beginRender() {}
    /**
	 * Called when an animation loop ends.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 */ finishRender() {}
    /**
	 * Called when a texture copy operation is performed.
	 *
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 */ copyTextureToTexture() {}
    /**
	 * Called when a framebuffer copy operation is performed.
	 *
	 * @param {Texture} framebufferTexture - The texture associated with the framebuffer.
	 */ copyFramebufferToTexture() {}
}
/**
 * InspectorNode is a wrapper node that allows inspection of node values during rendering.
 * It can be used to debug or analyze node outputs in the rendering pipeline.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$var$InspectorNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    /**
	 * Returns the type of the node.
	 *
	 * @returns {string}
	 */ static get type() {
        return 'InspectorNode';
    }
    /**
	 * Creates an InspectorNode.
	 *
	 * @param {Node} node - The node to inspect.
	 * @param {string} [name=''] - Optional name for the inspector node.
	 * @param {Function|null} [callback=null] - Optional callback to modify the node during setup.
	 */ constructor(node, name = '', callback = null){
        super();
        this.node = node;
        this.name = name;
        this.callback = callback;
        this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.FRAME;
        this.isInspectorNode = true;
    }
    /**
	 * Returns the name of the inspector node.
	 *
	 * @returns {string}
	 */ getName() {
        return this.name || this.node.name;
    }
    /**
	 * Updates the inspector node, allowing inspection of the wrapped node.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        frame.renderer.inspector.inspect(this);
    }
    /**
	 * Returns the type of the wrapped node.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @returns {string}
	 */ getNodeType(builder) {
        return this.node.getNodeType(builder);
    }
    /**
	 * Sets up the inspector node.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @returns {Node} The setup node.
	 */ setup(builder) {
        let node = this.node;
        if (builder.context.inspector === true && this.callback !== null) node = this.callback(node);
        if (builder.renderer.backend.isWebGPUBackend !== true && builder.renderer.inspector.constructor !== $d89c9137a3d237c2$export$660a27ce99fa210b) (0, $329ek.warnOnce)('TSL: ".toInspector()" is only available with WebGPU.');
        return node;
    }
}
/**
 * Creates an inspector node to wrap around a given node for inspection purposes.
 *
 * @tsl
 * @param {Node} node - The node to inspect.
 * @param {string} [name=''] - Optional name for the inspector node.
 * @param {Function|null} [callback=null] - Optional callback to modify the node during setup.
 * @returns {Node} The inspector node.
 */ function $d89c9137a3d237c2$var$inspector(node, name = '', callback = null) {
    node = $d89c9137a3d237c2$var$nodeObject(node);
    return node.before(new $d89c9137a3d237c2$var$InspectorNode(node, name, callback));
}
$d89c9137a3d237c2$var$addMethodChaining('toInspector', $d89c9137a3d237c2$var$inspector);
function $d89c9137a3d237c2$var$addNodeElement(name /*, nodeElement*/ ) {
    (0, $329ek.warn)('TSL: AddNodeElement has been removed in favor of tree-shaking. Trying add', name);
}
/**
 * Base class for representing shader attributes as nodes.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$dc88047a888cd46b extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'AttributeNode';
    }
    /**
	 * Constructs a new attribute node.
	 *
	 * @param {string} attributeName - The name of the attribute.
	 * @param {?string} nodeType - The node type.
	 */ constructor(attributeName, nodeType = null){
        super(nodeType);
        /**
		 * `AttributeNode` sets this property to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
        this._attributeName = attributeName;
    }
    getHash(builder) {
        return this.getAttributeName(builder);
    }
    getNodeType(builder) {
        let nodeType = this.nodeType;
        if (nodeType === null) {
            const attributeName = this.getAttributeName(builder);
            if (builder.hasGeometryAttribute(attributeName)) {
                const attribute = builder.geometry.getAttribute(attributeName);
                nodeType = builder.getTypeFromAttribute(attribute);
            } else nodeType = 'float';
        }
        return nodeType;
    }
    /**
	 * Sets the attribute name to the given value. The method can be
	 * overwritten in derived classes if the final name must be computed
	 * analytically.
	 *
	 * @param {string} attributeName - The name of the attribute.
	 * @return {AttributeNode} A reference to this node.
	 */ setAttributeName(attributeName) {
        this._attributeName = attributeName;
        return this;
    }
    /**
	 * Returns the attribute name of this node. The method can be
	 * overwritten in derived classes if the final name must be computed
	 * analytically.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The attribute name.
	 */ getAttributeName() {
        return this._attributeName;
    }
    generate(builder) {
        const attributeName = this.getAttributeName(builder);
        const nodeType = this.getNodeType(builder);
        const geometryAttribute = builder.hasGeometryAttribute(attributeName);
        if (geometryAttribute === true) {
            const attribute = builder.geometry.getAttribute(attributeName);
            const attributeType = builder.getTypeFromAttribute(attribute);
            const nodeAttribute = builder.getAttribute(attributeName, attributeType);
            if (builder.shaderStage === 'vertex') return builder.format(nodeAttribute.name, attributeType, nodeType);
            else {
                const nodeVarying = $d89c9137a3d237c2$var$varying(this);
                return nodeVarying.build(builder, nodeType);
            }
        } else {
            (0, $329ek.warn)(`AttributeNode: Vertex attribute "${attributeName}" not found on geometry.`);
            return builder.generateConst(nodeType);
        }
    }
    serialize(data) {
        super.serialize(data);
        data.global = this.global;
        data._attributeName = this._attributeName;
    }
    deserialize(data) {
        super.deserialize(data);
        this.global = data.global;
        this._attributeName = data._attributeName;
    }
}
/**
 * TSL function for creating an attribute node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the attribute.
 * @param {?string} [nodeType=null] - The node type.
 * @returns {AttributeNode}
 */ const $d89c9137a3d237c2$var$attribute = (name, nodeType = null)=>new $d89c9137a3d237c2$export$dc88047a888cd46b(name, nodeType);
/**
 * TSL function for creating an uv attribute node with the given index.
 *
 * @tsl
 * @function
 * @param {number} [index=0] - The uv index.
 * @return {AttributeNode<vec2>} The uv attribute node.
 */ const $d89c9137a3d237c2$var$uv$1 = (index = 0)=>$d89c9137a3d237c2$var$attribute('uv' + (index > 0 ? index : ''), 'vec2');
/**
 * A node that represents the dimensions of a texture. The texture size is
 * retrieved in the shader via built-in shader functions like `textureDimensions()`
 * or `textureSize()`.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$d377702479943f75 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'TextureSizeNode';
    }
    /**
	 * Constructs a new texture size node.
	 *
	 * @param {TextureNode} textureNode - A texture node which size should be retrieved.
	 * @param {?Node<int>} [levelNode=null] - A level node which defines the requested mip.
	 */ constructor(textureNode, levelNode = null){
        super('uvec2');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTextureSizeNode = true;
        /**
		 * A texture node which size should be retrieved.
		 *
		 * @type {TextureNode}
		 */ this.textureNode = textureNode;
        /**
		 * A level node which defines the requested mip.
		 *
		 * @type {Node<int>}
		 * @default null
		 */ this.levelNode = levelNode;
    }
    generate(builder, output) {
        const textureProperty = this.textureNode.build(builder, 'property');
        const level = this.levelNode === null ? '0' : this.levelNode.build(builder, 'int');
        return builder.format(`${builder.getMethod('textureDimensions')}( ${textureProperty}, ${level} )`, this.getNodeType(builder), output);
    }
}
/**
 * TSL function for creating a texture size node.
 *
 * @tsl
 * @function
 * @param {TextureNode} textureNode - A texture node which size should be retrieved.
 * @param {?Node<int>} [levelNode=null] - A level node which defines the requested mip.
 * @returns {TextureSizeNode}
 */ const $d89c9137a3d237c2$var$textureSize = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$d377702479943f75).setParameterLength(1, 2);
/**
 * A special type of uniform node that computes the
 * maximum mipmap level for a given texture node.
 *
 * ```js
 * const level = maxMipLevel( textureNode );
 * ```
 *
 * @augments UniformNode
 */ class $d89c9137a3d237c2$export$ded8507493c8fc0a extends $d89c9137a3d237c2$export$c0cca4cf699a03e1 {
    static get type() {
        return 'MaxMipLevelNode';
    }
    /**
	 * Constructs a new max mip level node.
	 *
	 * @param {TextureNode} textureNode - The texture node to compute the max mip level for.
	 */ constructor(textureNode){
        super(0);
        /**
		 * The texture node to compute the max mip level for.
		 *
		 * @private
		 * @type {TextureNode}
		 */ this._textureNode = textureNode;
        /**
		 * The `updateType` is set to `NodeUpdateType.FRAME` since the node updates
		 * the texture once per frame in its {@link MaxMipLevelNode#update} method.
		 *
		 * @type {string}
		 * @default 'frame'
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.FRAME;
    }
    /**
	 * The texture node to compute the max mip level for.
	 *
	 * @readonly
	 * @type {TextureNode}
	 */ get textureNode() {
        return this._textureNode;
    }
    /**
	 * The texture.
	 *
	 * @readonly
	 * @type {Texture}
	 */ get texture() {
        return this._textureNode.value;
    }
    update() {
        const texture = this.texture;
        const images = texture.images;
        const image = images && images.length > 0 ? images[0] && images[0].image || images[0] : texture.image;
        if (image && image.width !== undefined) {
            const { width: width, height: height } = image;
            this.value = Math.log2(Math.max(width, height));
        }
    }
}
/**
 * TSL function for creating a max mip level node.
 *
 * @tsl
 * @function
 * @param {TextureNode} textureNode - The texture node to compute the max mip level for.
 * @returns {MaxMipLevelNode}
 */ const $d89c9137a3d237c2$var$maxMipLevel = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$ded8507493c8fc0a).setParameterLength(1);
const $d89c9137a3d237c2$var$EmptyTexture$1 = /*@__PURE__*/ new (0, $329ek.Texture)();
/**
 * This type of uniform node represents a 2D texture.
 *
 * @augments UniformNode
 */ class $d89c9137a3d237c2$export$2dd903bc9e8140bc extends $d89c9137a3d237c2$export$c0cca4cf699a03e1 {
    static get type() {
        return 'TextureNode';
    }
    /**
	 * Constructs a new texture node.
	 *
	 * @param {Texture} [value=EmptyTexture] - The texture.
	 * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
	 * @param {?Node<int>} [levelNode=null] - The level node.
	 * @param {?Node<float>} [biasNode=null] - The bias node.
	 */ constructor(value = $d89c9137a3d237c2$var$EmptyTexture$1, uvNode = null, levelNode = null, biasNode = null){
        super(value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTextureNode = true;
        /**
		 * Represents the texture coordinates.
		 *
		 * @type {?Node<vec2|vec3>}
		 * @default null
		 */ this.uvNode = uvNode;
        /**
		 * Represents the mip level that should be selected.
		 *
		 * @type {?Node<int>}
		 * @default null
		 */ this.levelNode = levelNode;
        /**
		 * Represents the bias to be applied during level-of-detail computation.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.biasNode = biasNode;
        /**
		 * Represents a reference value a texture sample is compared to.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.compareNode = null;
        /**
		 * When using texture arrays, the depth node defines the layer to select.
		 *
		 * @type {?Node<int>}
		 * @default null
		 */ this.depthNode = null;
        /**
		 * When defined, a texture is sampled using explicit gradients.
		 *
		 * @type {?Array<Node<vec2>>}
		 * @default null
		 */ this.gradNode = null;
        /**
		 * Represents the optional texel offset applied to the unnormalized texture
		 * coordinate before sampling the texture.
		 *
		 * @type {?Node<ivec2|ivec3>}
		 * @default null
		 */ this.offsetNode = null;
        /**
		 * Whether texture values should be sampled or fetched.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sampler = true;
        /**
		 * Whether the uv transformation matrix should be
		 * automatically updated or not. Use `setUpdateMatrix()`
		 * if you want to change the value of the property.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.updateMatrix = false;
        /**
		 * By default the `update()` method is not executed. Depending on
		 * whether a uv transformation matrix and/or flipY is applied, `update()`
		 * is executed per object.
		 *
		 * @type {string}
		 * @default 'none'
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.NONE;
        /**
		 * The reference node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.referenceNode = null;
        /**
		 * The texture value is stored in a private property.
		 *
		 * @private
		 * @type {Texture}
		 */ this._value = value;
        /**
		 * The uniform node that represents the uv transformation matrix.
		 *
		 * @private
		 * @type {?UniformNode<mat3>}
		 * @default null
		 */ this._matrixUniform = null;
        /**
		 * The uniform node that represents the y-flip. Only required for WebGL.
		 *
		 * @private
		 * @type {?UniformNode<bool>}
		 * @default null
		 */ this._flipYUniform = null;
        this.setUpdateMatrix(uvNode === null);
    }
    set value(value) {
        if (this.referenceNode) this.referenceNode.value = value;
        else this._value = value;
    }
    /**
	 * The texture value.
	 *
	 * @type {Texture}
	 */ get value() {
        return this.referenceNode ? this.referenceNode.value : this._value;
    }
    /**
	 * Overwritten since the uniform hash is defined by the texture's UUID.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The uniform hash.
	 */ getUniformHash() {
        return this.value.uuid;
    }
    /**
	 * Overwritten since the node type is inferred from the texture type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType() {
        if (this.value.isDepthTexture === true) return 'float';
        if (this.value.type === (0, $329ek.UnsignedIntType)) return 'uvec4';
        else if (this.value.type === (0, $329ek.IntType)) return 'ivec4';
        return 'vec4';
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'texture'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return 'texture';
    }
    /**
	 * Returns a default uvs based on the current texture's channel.
	 *
	 * @return {AttributeNode<vec2>} The default uvs.
	 */ getDefaultUV() {
        return $d89c9137a3d237c2$var$uv$1(this.value.channel);
    }
    /**
	 * Overwritten to always return the texture reference of the node.
	 *
	 * @param {any} state - This method can be invocated in different contexts so `state` can refer to any object type.
	 * @return {Texture} The texture reference.
	 */ updateReference() {
        return this.value;
    }
    /**
	 * Transforms the given uv node with the texture transformation matrix.
	 *
	 * @param {Node} uvNode - The uv node to transform.
	 * @return {Node} The transformed uv node.
	 */ getTransformedUV(uvNode) {
        if (this._matrixUniform === null) this._matrixUniform = $d89c9137a3d237c2$var$uniform(this.value.matrix);
        return this._matrixUniform.mul($d89c9137a3d237c2$var$vec3(uvNode, 1)).xy;
    }
    /**
	 * Defines whether the uv transformation matrix should automatically be updated or not.
	 *
	 * @param {boolean} value - The update toggle.
	 * @return {TextureNode} A reference to this node.
	 */ setUpdateMatrix(value) {
        this.updateMatrix = value;
        return this;
    }
    /**
	 * Setups the uv node. Depending on the backend as well as texture's image and type, it might be necessary
	 * to modify the uv node for correct sampling.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} uvNode - The uv node to setup.
	 * @return {Node} The updated uv node.
	 */ setupUV(builder, uvNode) {
        if (builder.isFlipY()) {
            if (this._flipYUniform === null) this._flipYUniform = $d89c9137a3d237c2$var$uniform(false);
            uvNode = uvNode.toVar();
            if (this.sampler) uvNode = this._flipYUniform.select(uvNode.flipY(), uvNode);
            else uvNode = this._flipYUniform.select(uvNode.setY($d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$textureSize(this, this.levelNode).y).sub(uvNode.y).sub(1)), uvNode);
        }
        return uvNode;
    }
    /**
	 * Setups texture node by preparing the internal nodes for code generation.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        const properties = builder.getNodeProperties(this);
        properties.referenceNode = this.referenceNode;
        //
        const texture = this.value;
        if (!texture || texture.isTexture !== true) throw new Error('THREE.TSL: `texture( value )` function expects a valid instance of THREE.Texture().');
        //
        const uvNode = $d89c9137a3d237c2$var$Fn(()=>{
            let uvNode = this.uvNode;
            if ((uvNode === null || builder.context.forceUVContext === true) && builder.context.getUV) uvNode = builder.context.getUV(this, builder);
            if (!uvNode) uvNode = this.getDefaultUV();
            if (this.updateMatrix === true) uvNode = this.getTransformedUV(uvNode);
            uvNode = this.setupUV(builder, uvNode);
            //
            this.updateType = this._matrixUniform !== null || this._flipYUniform !== null ? $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT : $d89c9137a3d237c2$export$26f7a8bbd9469530.NONE;
            //
            return uvNode;
        })();
        //
        let levelNode = this.levelNode;
        if (levelNode === null && builder.context.getTextureLevel) levelNode = builder.context.getTextureLevel(this);
        //
        properties.uvNode = uvNode;
        properties.levelNode = levelNode;
        properties.biasNode = this.biasNode;
        properties.compareNode = this.compareNode;
        properties.gradNode = this.gradNode;
        properties.depthNode = this.depthNode;
        properties.offsetNode = this.offsetNode;
    }
    /**
	 * Generates the uv code snippet.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} uvNode - The uv node to generate code for.
	 * @return {string} The generated code snippet.
	 */ generateUV(builder, uvNode) {
        return uvNode.build(builder, this.sampler === true ? 'vec2' : 'ivec2');
    }
    /**
	 * Generates the offset code snippet.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} offsetNode - The offset node to generate code for.
	 * @return {string} The generated code snippet.
	 */ generateOffset(builder, offsetNode) {
        return offsetNode.build(builder, 'ivec2');
    }
    /**
	 * Generates the snippet for the texture sampling.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} textureProperty - The texture property.
	 * @param {string} uvSnippet - The uv snippet.
	 * @param {?string} levelSnippet - The level snippet.
	 * @param {?string} biasSnippet - The bias snippet.
	 * @param {?string} depthSnippet - The depth snippet.
	 * @param {?string} compareSnippet - The compare snippet.
	 * @param {?Array<string>} gradSnippet - The grad snippet.
	 * @param {?string} offsetSnippet - The offset snippet.
	 * @return {string} The generated code snippet.
	 */ generateSnippet(builder, textureProperty, uvSnippet, levelSnippet, biasSnippet, depthSnippet, compareSnippet, gradSnippet, offsetSnippet) {
        const texture = this.value;
        let snippet;
        if (biasSnippet) snippet = builder.generateTextureBias(texture, textureProperty, uvSnippet, biasSnippet, depthSnippet, offsetSnippet);
        else if (gradSnippet) snippet = builder.generateTextureGrad(texture, textureProperty, uvSnippet, gradSnippet, depthSnippet, offsetSnippet);
        else if (compareSnippet) snippet = builder.generateTextureCompare(texture, textureProperty, uvSnippet, compareSnippet, depthSnippet, offsetSnippet);
        else if (this.sampler === false) snippet = builder.generateTextureLoad(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, offsetSnippet);
        else if (levelSnippet) snippet = builder.generateTextureLevel(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, offsetSnippet);
        else snippet = builder.generateTexture(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet);
        return snippet;
    }
    /**
	 * Generates the code snippet of the texture node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} output - The current output.
	 * @return {string} The generated code snippet.
	 */ generate(builder, output) {
        const texture = this.value;
        const properties = builder.getNodeProperties(this);
        const textureProperty = super.generate(builder, 'property');
        if (/^sampler/.test(output)) return textureProperty + '_sampler';
        else if (builder.isReference(output)) return textureProperty;
        else {
            const nodeData = builder.getDataFromNode(this);
            let propertyName = nodeData.propertyName;
            if (propertyName === undefined) {
                const { uvNode: uvNode, levelNode: levelNode, biasNode: biasNode, compareNode: compareNode, depthNode: depthNode, gradNode: gradNode, offsetNode: offsetNode } = properties;
                const uvSnippet = this.generateUV(builder, uvNode);
                const levelSnippet = levelNode ? levelNode.build(builder, 'float') : null;
                const biasSnippet = biasNode ? biasNode.build(builder, 'float') : null;
                const depthSnippet = depthNode ? depthNode.build(builder, 'int') : null;
                const compareSnippet = compareNode ? compareNode.build(builder, 'float') : null;
                const gradSnippet = gradNode ? [
                    gradNode[0].build(builder, 'vec2'),
                    gradNode[1].build(builder, 'vec2')
                ] : null;
                const offsetSnippet = offsetNode ? this.generateOffset(builder, offsetNode) : null;
                const nodeVar = builder.getVarFromNode(this);
                propertyName = builder.getPropertyName(nodeVar);
                const snippet = this.generateSnippet(builder, textureProperty, uvSnippet, levelSnippet, biasSnippet, depthSnippet, compareSnippet, gradSnippet, offsetSnippet);
                builder.addLineFlowCode(`${propertyName} = ${snippet}`, this);
                nodeData.snippet = snippet;
                nodeData.propertyName = propertyName;
            }
            let snippet = propertyName;
            const nodeType = this.getNodeType(builder);
            if (builder.needsToWorkingColorSpace(texture)) snippet = $d89c9137a3d237c2$var$colorSpaceToWorking($d89c9137a3d237c2$var$expression(snippet, nodeType), texture.colorSpace).setup(builder).build(builder, nodeType);
            return builder.format(snippet, nodeType, output);
        }
    }
    /**
	 * Sets the sampler value.
	 *
	 * @param {boolean} value - The sampler value to set.
	 * @return {TextureNode} A reference to this texture node.
	 */ setSampler(value) {
        this.sampler = value;
        return this;
    }
    /**
	 * Returns the sampler value.
	 *
	 * @return {boolean} The sampler value.
	 */ getSampler() {
        return this.sampler;
    }
    // @TODO: Move to TSL
    /**
	 * @function
	 * @deprecated since r172. Use {@link TextureNode#sample} instead.
	 *
	 * @param {Node} uvNode - The uv node.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ uv(uvNode) {
        (0, $329ek.warn)('TextureNode: .uv() has been renamed. Use .sample() instead.');
        return this.sample(uvNode);
    }
    /**
	 * Samples the texture with the given uv node.
	 *
	 * @param {Node} uvNode - The uv node.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ sample(uvNode) {
        const textureNode = this.clone();
        textureNode.uvNode = $d89c9137a3d237c2$var$nodeObject(uvNode);
        textureNode.referenceNode = this.getBase();
        return $d89c9137a3d237c2$var$nodeObject(textureNode);
    }
    /**
	 * TSL function for creating a texture node that fetches/loads texels without interpolation.
	 *
	 * @param {Node<uvec2>} uvNode - The uv node.
	 * @returns {TextureNode} A texture node representing the texture load.
	 */ load(uvNode) {
        return this.sample(uvNode).setSampler(false);
    }
    /**
	 * Samples a blurred version of the texture by defining an internal bias.
	 *
	 * @param {Node<float>} amountNode - How blurred the texture should be.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ blur(amountNode) {
        const textureNode = this.clone();
        textureNode.biasNode = $d89c9137a3d237c2$var$nodeObject(amountNode).mul($d89c9137a3d237c2$var$maxMipLevel(textureNode));
        textureNode.referenceNode = this.getBase();
        const map = textureNode.value;
        if (textureNode.generateMipmaps === false && (map && map.generateMipmaps === false || map.minFilter === (0, $329ek.NearestFilter) || map.magFilter === (0, $329ek.NearestFilter))) {
            (0, $329ek.warn)('TSL: texture().blur() requires mipmaps and sampling. Use .generateMipmaps=true and .minFilter/.magFilter=THREE.LinearFilter in the Texture.');
            textureNode.biasNode = null;
        }
        return $d89c9137a3d237c2$var$nodeObject(textureNode);
    }
    /**
	 * Samples a specific mip of the texture.
	 *
	 * @param {Node<int>} levelNode - The mip level to sample.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ level(levelNode) {
        const textureNode = this.clone();
        textureNode.levelNode = $d89c9137a3d237c2$var$nodeObject(levelNode);
        textureNode.referenceNode = this.getBase();
        return $d89c9137a3d237c2$var$nodeObject(textureNode);
    }
    /**
	 * Returns the texture size of the requested level.
	 *
	 * @param {Node<int>} levelNode - The level to compute the size for.
	 * @return {TextureSizeNode} The texture size.
	 */ size(levelNode) {
        return $d89c9137a3d237c2$var$textureSize(this, levelNode);
    }
    /**
	 * Samples the texture with the given bias.
	 *
	 * @param {Node<float>} biasNode - The bias node.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ bias(biasNode) {
        const textureNode = this.clone();
        textureNode.biasNode = $d89c9137a3d237c2$var$nodeObject(biasNode);
        textureNode.referenceNode = this.getBase();
        return $d89c9137a3d237c2$var$nodeObject(textureNode);
    }
    /**
	 * Returns the base texture of this node.
	 * @return {TextureNode} The base texture node.
	 */ getBase() {
        return this.referenceNode ? this.referenceNode.getBase() : this;
    }
    /**
	 * Samples the texture by executing a compare operation.
	 *
	 * @param {Node<float>} compareNode - The node that defines the compare value.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ compare(compareNode) {
        const textureNode = this.clone();
        textureNode.compareNode = $d89c9137a3d237c2$var$nodeObject(compareNode);
        textureNode.referenceNode = this.getBase();
        return $d89c9137a3d237c2$var$nodeObject(textureNode);
    }
    /**
	 * Samples the texture using an explicit gradient.
	 *
	 * @param {Node<vec2>} gradNodeX - The gradX node.
	 * @param {Node<vec2>} gradNodeY - The gradY node.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ grad(gradNodeX, gradNodeY) {
        const textureNode = this.clone();
        textureNode.gradNode = [
            $d89c9137a3d237c2$var$nodeObject(gradNodeX),
            $d89c9137a3d237c2$var$nodeObject(gradNodeY)
        ];
        textureNode.referenceNode = this.getBase();
        return $d89c9137a3d237c2$var$nodeObject(textureNode);
    }
    /**
	 * Samples the texture by defining a depth node.
	 *
	 * @param {Node<int>} depthNode - The depth node.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ depth(depthNode) {
        const textureNode = this.clone();
        textureNode.depthNode = $d89c9137a3d237c2$var$nodeObject(depthNode);
        textureNode.referenceNode = this.getBase();
        return $d89c9137a3d237c2$var$nodeObject(textureNode);
    }
    /**
	 * Samples the texture by defining an offset node.
	 *
	 * @param {Node<ivec2>} offsetNode - The offset node.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ offset(offsetNode) {
        const textureNode = this.clone();
        textureNode.offsetNode = $d89c9137a3d237c2$var$nodeObject(offsetNode);
        textureNode.referenceNode = this.getBase();
        return $d89c9137a3d237c2$var$nodeObject(textureNode);
    }
    // --
    serialize(data) {
        super.serialize(data);
        data.value = this.value.toJSON(data.meta).uuid;
        data.sampler = this.sampler;
        data.updateMatrix = this.updateMatrix;
        data.updateType = this.updateType;
    }
    deserialize(data) {
        super.deserialize(data);
        this.value = data.meta.textures[data.value];
        this.sampler = data.sampler;
        this.updateMatrix = data.updateMatrix;
        this.updateType = data.updateType;
    }
    /**
	 * The update is used to implement the update of the uv transformation matrix.
	 */ update() {
        const texture = this.value;
        const matrixUniform = this._matrixUniform;
        if (matrixUniform !== null) matrixUniform.value = texture.matrix;
        if (texture.matrixAutoUpdate === true) texture.updateMatrix();
        //
        const flipYUniform = this._flipYUniform;
        if (flipYUniform !== null) flipYUniform.value = texture.image instanceof ImageBitmap && texture.flipY === true || texture.isRenderTargetTexture === true || texture.isFramebufferTexture === true || texture.isDepthTexture === true;
    }
    /**
	 * Clones the texture node.
	 *
	 * @return {TextureNode} The cloned texture node.
	 */ clone() {
        const newNode = new this.constructor(this.value, this.uvNode, this.levelNode, this.biasNode);
        newNode.sampler = this.sampler;
        newNode.depthNode = this.depthNode;
        newNode.compareNode = this.compareNode;
        newNode.gradNode = this.gradNode;
        newNode.offsetNode = this.offsetNode;
        return newNode;
    }
}
/**
 * TSL function for creating a texture node.
 *
 * @tsl
 * @function
 * @param {?Texture} value - The texture.
 * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {TextureNode}
 */ const $d89c9137a3d237c2$var$textureBase = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$2dd903bc9e8140bc).setParameterLength(1, 4).setName('texture');
/**
 * TSL function for creating a texture node or sample a texture node already existing.
 *
 * @tsl
 * @function
 * @param {?(Texture|TextureNode)} [value=EmptyTexture] - The texture.
 * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {TextureNode}
 */ const $d89c9137a3d237c2$var$texture = (value = $d89c9137a3d237c2$var$EmptyTexture$1, uvNode = null, levelNode = null, biasNode = null)=>{
    let textureNode;
    if (value && value.isTextureNode === true) {
        textureNode = $d89c9137a3d237c2$var$nodeObject(value.clone());
        textureNode.referenceNode = value.getBase(); // Ensure the reference is set to the original node
        if (uvNode !== null) textureNode.uvNode = $d89c9137a3d237c2$var$nodeObject(uvNode);
        if (levelNode !== null) textureNode.levelNode = $d89c9137a3d237c2$var$nodeObject(levelNode);
        if (biasNode !== null) textureNode.biasNode = $d89c9137a3d237c2$var$nodeObject(biasNode);
    } else textureNode = $d89c9137a3d237c2$var$textureBase(value, uvNode, levelNode, biasNode);
    return textureNode;
};
/**
 * TSL function for creating a uniform texture node.
 *
 * @tsl
 * @function
 * @param {?Texture} value - The texture.
 * @returns {TextureNode}
 */ const $d89c9137a3d237c2$var$uniformTexture = (value = $d89c9137a3d237c2$var$EmptyTexture$1)=>$d89c9137a3d237c2$var$texture(value);
/**
 * TSL function for creating a texture node that fetches/loads texels without interpolation.
 *
 * @tsl
 * @function
 * @param {?(Texture|TextureNode)} [value=EmptyTexture] - The texture.
 * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {TextureNode}
 */ const $d89c9137a3d237c2$var$textureLoad = (...params)=>$d89c9137a3d237c2$var$texture(...params).setSampler(false);
const $d89c9137a3d237c2$var$textureLevel = (value, uv, level)=>$d89c9137a3d237c2$var$texture(value, uv).level(level);
/**
 * Converts a texture or texture node to a sampler.
 *
 * @tsl
 * @function
 * @param {TextureNode|Texture} value - The texture or texture node to convert.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$sampler = (value)=>(value.isNode === true ? value : $d89c9137a3d237c2$var$texture(value)).convert('sampler');
/**
 * Converts a texture or texture node to a sampler comparison.
 *
 * @tsl
 * @function
 * @param {TextureNode|Texture} value - The texture or texture node to convert.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$samplerComparison = (value)=>(value.isNode === true ? value : $d89c9137a3d237c2$var$texture(value)).convert('samplerComparison');
/**
 * A special type of uniform node which represents array-like data
 * as uniform buffers. The access usually happens via `element()`
 * which returns an instance of {@link ArrayElementNode}. For example:
 *
 * ```js
 * const bufferNode = buffer( array, 'mat4', count );
 * const matrixNode = bufferNode.element( index ); // access a matrix from the buffer
 * ```
 * In general, it is recommended to use the more managed {@link UniformArrayNode}
 * since it handles more input types and automatically cares about buffer paddings.
 *
 * @augments UniformNode
 */ class $d89c9137a3d237c2$export$715e91fa835e6409 extends $d89c9137a3d237c2$export$c0cca4cf699a03e1 {
    static get type() {
        return 'BufferNode';
    }
    /**
	 * Constructs a new buffer node.
	 *
	 * @param {Array<number>} value - Array-like buffer data.
	 * @param {string} bufferType - The data type of the buffer.
	 * @param {number} [bufferCount=0] - The count of buffer elements.
	 */ constructor(value, bufferType, bufferCount = 0){
        super(value, bufferType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferNode = true;
        /**
		 * The data type of the buffer.
		 *
		 * @type {string}
		 */ this.bufferType = bufferType;
        /**
		 * The uniform node that holds the value of the reference node.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bufferCount = bufferCount;
        /**
		 * An array of update ranges.
		 *
		 * @type {Array<{start: number, count: number}>}
		 */ this.updateRanges = [];
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * The data type of the buffer elements.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The element type.
	 */ getElementType(builder) {
        return this.getNodeType(builder);
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'buffer'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return 'buffer';
    }
}
/**
 * TSL function for creating a buffer node.
 *
 * @tsl
 * @function
 * @param {Array<number>} value - Array-like buffer data.
 * @param {string} type - The data type of a buffer element.
 * @param {number} count - The count of buffer elements.
 * @returns {BufferNode}
 */ const $d89c9137a3d237c2$var$buffer = (value, type, count)=>new $d89c9137a3d237c2$export$715e91fa835e6409(value, type, count);
/**
 * Represents the element access on uniform array nodes.
 *
 * @augments ArrayElementNode
 */ class $d89c9137a3d237c2$var$UniformArrayElementNode extends $d89c9137a3d237c2$export$f2edd1d22bf6d00b {
    static get type() {
        return 'UniformArrayElementNode';
    }
    /**
	 * Constructs a new buffer node.
	 *
	 * @param {UniformArrayNode} uniformArrayNode - The uniform array node to access.
	 * @param {IndexNode} indexNode - The index data that define the position of the accessed element in the array.
	 */ constructor(uniformArrayNode, indexNode){
        super(uniformArrayNode, indexNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayBufferElementNode = true;
    }
    generate(builder) {
        const snippet = super.generate(builder);
        const type = this.getNodeType();
        const paddedType = this.node.getPaddedType();
        return builder.format(snippet, paddedType, type);
    }
}
/**
 * Similar to {@link BufferNode} this module represents array-like data as
 * uniform buffers. Unlike {@link BufferNode}, it can handle more common
 * data types in the array (e.g `three.js` primitives) and automatically
 * manage buffer padding. It should be the first choice when working with
 * uniforms buffers.
 * ```js
 * const tintColors = uniformArray( [
 * 	new Color( 1, 0, 0 ),
 * 	new Color( 0, 1, 0 ),
 * 	new Color( 0, 0, 1 )
 * ], 'color' );
 *
 * const redColor = tintColors.element( 0 );
 *
 * @augments BufferNode
 */ class $d89c9137a3d237c2$export$fa5dacdc1150ae22 extends $d89c9137a3d237c2$export$715e91fa835e6409 {
    static get type() {
        return 'UniformArrayNode';
    }
    /**
	 * Constructs a new uniform array node.
	 *
	 * @param {Array<any>} value - Array holding the buffer data.
	 * @param {?string} [elementType=null] - The data type of a buffer element.
	 */ constructor(value, elementType = null){
        super(null);
        /**
		 * Array holding the buffer data. Unlike {@link BufferNode}, the array can
		 * hold number primitives as well as three.js objects like vectors, matrices
		 * or colors.
		 *
		 * @type {Array<any>}
		 */ this.array = value;
        /**
		 * The data type of an array element.
		 *
		 * @type {string}
		 */ this.elementType = elementType === null ? $d89c9137a3d237c2$var$getValueType(value[0]) : elementType;
        /**
		 * The padded type. Uniform buffers must conform to a certain buffer layout
		 * so a separate type is computed to ensure correct buffer size.
		 *
		 * @type {string}
		 */ this.paddedType = this.getPaddedType();
        /**
		 * Overwritten since uniform array nodes are updated per render.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayBufferNode = true;
    }
    /**
	 * This method is overwritten since the node type is inferred from the
	 * {@link UniformArrayNode#paddedType}.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType() {
        return this.paddedType;
    }
    /**
	 * The data type of the array elements.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The element type.
	 */ getElementType() {
        return this.elementType;
    }
    /**
	 * Returns the padded type based on the element type.
	 *
	 * @return {string} The padded type.
	 */ getPaddedType() {
        const elementType = this.elementType;
        let paddedType = 'vec4';
        if (elementType === 'mat2') paddedType = 'mat2';
        else if (/mat/.test(elementType) === true) paddedType = 'mat4';
        else if (elementType.charAt(0) === 'i') paddedType = 'ivec4';
        else if (elementType.charAt(0) === 'u') paddedType = 'uvec4';
        return paddedType;
    }
    /**
	 * The update makes sure to correctly transfer the data from the (complex) objects
	 * in the array to the internal, correctly padded value buffer.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update() {
        const { array: array, value: value } = this;
        const elementType = this.elementType;
        if (elementType === 'float' || elementType === 'int' || elementType === 'uint') for(let i = 0; i < array.length; i++){
            const index = i * 4;
            value[index] = array[i];
        }
        else if (elementType === 'color') for(let i = 0; i < array.length; i++){
            const index = i * 4;
            const vector = array[i];
            value[index] = vector.r;
            value[index + 1] = vector.g;
            value[index + 2] = vector.b || 0;
        //value[ index + 3 ] = vector.a || 0;
        }
        else if (elementType === 'mat2') for(let i = 0; i < array.length; i++){
            const index = i * 4;
            const matrix = array[i];
            value[index] = matrix.elements[0];
            value[index + 1] = matrix.elements[1];
            value[index + 2] = matrix.elements[2];
            value[index + 3] = matrix.elements[3];
        }
        else if (elementType === 'mat3') for(let i = 0; i < array.length; i++){
            const index = i * 16;
            const matrix = array[i];
            value[index] = matrix.elements[0];
            value[index + 1] = matrix.elements[1];
            value[index + 2] = matrix.elements[2];
            value[index + 4] = matrix.elements[3];
            value[index + 5] = matrix.elements[4];
            value[index + 6] = matrix.elements[5];
            value[index + 8] = matrix.elements[6];
            value[index + 9] = matrix.elements[7];
            value[index + 10] = matrix.elements[8];
            value[index + 15] = 1;
        }
        else if (elementType === 'mat4') for(let i = 0; i < array.length; i++){
            const index = i * 16;
            const matrix = array[i];
            for(let i = 0; i < matrix.elements.length; i++)value[index + i] = matrix.elements[i];
        }
        else for(let i = 0; i < array.length; i++){
            const index = i * 4;
            const vector = array[i];
            value[index] = vector.x;
            value[index + 1] = vector.y;
            value[index + 2] = vector.z || 0;
            value[index + 3] = vector.w || 0;
        }
    }
    /**
	 * Implement the value buffer creation based on the array data.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {null}
	 */ setup(builder) {
        const length = this.array.length;
        const elementType = this.elementType;
        let arrayType = Float32Array;
        const paddedType = this.paddedType;
        const paddedElementLength = builder.getTypeLength(paddedType);
        if (elementType.charAt(0) === 'i') arrayType = Int32Array;
        if (elementType.charAt(0) === 'u') arrayType = Uint32Array;
        this.value = new arrayType(length * paddedElementLength);
        this.bufferCount = length;
        this.bufferType = paddedType;
        return super.setup(builder);
    }
    /**
	 * Overwrites the default `element()` method to provide element access
	 * based on {@link UniformArrayNode}.
	 *
	 * @param {IndexNode} indexNode - The index node.
	 * @return {UniformArrayElementNode}
	 */ element(indexNode) {
        return new $d89c9137a3d237c2$var$UniformArrayElementNode(this, $d89c9137a3d237c2$var$nodeObject(indexNode));
    }
}
/**
 * TSL function for creating an uniform array node.
 *
 * @tsl
 * @function
 * @param {Array<any>} values - Array-like data.
 * @param {?string} [nodeType] - The data type of the array elements.
 * @returns {UniformArrayNode}
 */ const $d89c9137a3d237c2$var$uniformArray = (values, nodeType)=>new $d89c9137a3d237c2$export$fa5dacdc1150ae22(values, nodeType);
/**
 * The node allows to set values for built-in shader variables. That is
 * required for features like hardware-accelerated vertex clipping.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$var$BuiltinNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    /**
	 * Constructs a new builtin node.
	 *
	 * @param {string} name - The name of the built-in shader variable.
	 */ constructor(name){
        super('float');
        /**
		 * The name of the built-in shader variable.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBuiltinNode = true;
    }
    /**
	 * Generates the code snippet of the builtin node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated code snippet.
	 */ generate() {
        return this.name;
    }
}
/**
 * TSL function for creating a builtin node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the built-in shader variable.
 * @returns {BuiltinNode}
 */ const $d89c9137a3d237c2$var$builtin = $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$var$BuiltinNode).setParameterLength(1);
let $d89c9137a3d237c2$var$_screenSizeVec, $d89c9137a3d237c2$var$_viewportVec;
/**
 * This node provides a collection of screen related metrics.
 * Depending on {@link ScreenNode#scope}, the nodes can represent
 * resolution or viewport data as well as fragment or uv coordinates.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$80eb8887666700bd extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ScreenNode';
    }
    /**
	 * Constructs a new screen node.
	 *
	 * @param {('coordinate'|'viewport'|'size'|'uv'|'dpr')} scope - The node's scope.
	 */ constructor(scope){
        super();
        /**
		 * The node represents different metric depending on which scope is selected.
		 *
		 * - `ScreenNode.COORDINATE`: Window-relative coordinates of the current fragment according to WebGPU standards.
		 * - `ScreenNode.VIEWPORT`: The current viewport defined as a four-dimensional vector.
		 * - `ScreenNode.SIZE`: The dimensions of the current bound framebuffer.
		 * - `ScreenNode.UV`: Normalized coordinates.
		 * - `ScreenNode.DPR`: Device pixel ratio.
		 *
		 * @type {('coordinate'|'viewport'|'size'|'uv'|'dpr')}
		 */ this.scope = scope;
        /**
		 * This output node.
		 *
		 * @private
		 * @type {?Node}
		 * @default null
		 */ this._output = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isViewportNode = true;
    }
    /**
	 * This method is overwritten since the node type depends on the selected scope.
	 *
	 * @return {('float'|'vec2'|'vec4')} The node type.
	 */ getNodeType() {
        if (this.scope === $d89c9137a3d237c2$export$80eb8887666700bd.DPR) return 'float';
        if (this.scope === $d89c9137a3d237c2$export$80eb8887666700bd.VIEWPORT) return 'vec4';
        else return 'vec2';
    }
    /**
	 * This method is overwritten since the node's update type depends on the selected scope.
	 *
	 * @return {NodeUpdateType} The update type.
	 */ getUpdateType() {
        let updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.NONE;
        if (this.scope === $d89c9137a3d237c2$export$80eb8887666700bd.SIZE || this.scope === $d89c9137a3d237c2$export$80eb8887666700bd.VIEWPORT || this.scope === $d89c9137a3d237c2$export$80eb8887666700bd.DPR) updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER;
        this.updateType = updateType;
        return updateType;
    }
    /**
	 * `ScreenNode` implements {@link Node#update} to retrieve viewport and size information
	 * from the current renderer.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update({ renderer: renderer }) {
        const renderTarget = renderer.getRenderTarget();
        if (this.scope === $d89c9137a3d237c2$export$80eb8887666700bd.VIEWPORT) {
            if (renderTarget !== null) $d89c9137a3d237c2$var$_viewportVec.copy(renderTarget.viewport);
            else {
                renderer.getViewport($d89c9137a3d237c2$var$_viewportVec);
                $d89c9137a3d237c2$var$_viewportVec.multiplyScalar(renderer.getPixelRatio());
            }
        } else if (this.scope === $d89c9137a3d237c2$export$80eb8887666700bd.DPR) this._output.value = renderer.getPixelRatio();
        else if (renderTarget !== null) {
            $d89c9137a3d237c2$var$_screenSizeVec.width = renderTarget.width;
            $d89c9137a3d237c2$var$_screenSizeVec.height = renderTarget.height;
        } else renderer.getDrawingBufferSize($d89c9137a3d237c2$var$_screenSizeVec);
    }
    setup() {
        const scope = this.scope;
        let output = null;
        if (scope === $d89c9137a3d237c2$export$80eb8887666700bd.SIZE) output = $d89c9137a3d237c2$var$uniform($d89c9137a3d237c2$var$_screenSizeVec || ($d89c9137a3d237c2$var$_screenSizeVec = new (0, $329ek.Vector2)()));
        else if (scope === $d89c9137a3d237c2$export$80eb8887666700bd.VIEWPORT) output = $d89c9137a3d237c2$var$uniform($d89c9137a3d237c2$var$_viewportVec || ($d89c9137a3d237c2$var$_viewportVec = new (0, $329ek.Vector4)()));
        else if (scope === $d89c9137a3d237c2$export$80eb8887666700bd.DPR) output = $d89c9137a3d237c2$var$uniform(1);
        else output = $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$screenCoordinate.div($d89c9137a3d237c2$var$screenSize));
        this._output = output;
        return output;
    }
    generate(builder) {
        if (this.scope === $d89c9137a3d237c2$export$80eb8887666700bd.COORDINATE) {
            let coord = builder.getFragCoord();
            if (builder.isFlipY()) {
                // follow webgpu standards
                const size = builder.getNodeProperties($d89c9137a3d237c2$var$screenSize).outputNode.build(builder);
                coord = `${builder.getType('vec2')}( ${coord}.x, ${size}.y - ${coord}.y )`;
            }
            return coord;
        }
        return super.generate(builder);
    }
}
$d89c9137a3d237c2$export$80eb8887666700bd.COORDINATE = 'coordinate';
$d89c9137a3d237c2$export$80eb8887666700bd.VIEWPORT = 'viewport';
$d89c9137a3d237c2$export$80eb8887666700bd.SIZE = 'size';
$d89c9137a3d237c2$export$80eb8887666700bd.UV = 'uv';
$d89c9137a3d237c2$export$80eb8887666700bd.DPR = 'dpr';
// Screen
/**
 * TSL object that represents the current DPR.
 *
 * @tsl
 * @type {ScreenNode<float>}
 */ const $d89c9137a3d237c2$var$screenDPR = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$80eb8887666700bd, $d89c9137a3d237c2$export$80eb8887666700bd.DPR);
/**
 * TSL object that represents normalized screen coordinates, unitless in `[0, 1]`.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $d89c9137a3d237c2$var$screenUV = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$80eb8887666700bd, $d89c9137a3d237c2$export$80eb8887666700bd.UV);
/**
 * TSL object that represents the screen resolution in physical pixel units.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $d89c9137a3d237c2$var$screenSize = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$80eb8887666700bd, $d89c9137a3d237c2$export$80eb8887666700bd.SIZE);
/**
 * TSL object that represents the current `x`/`y` pixel position on the screen in physical pixel units.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $d89c9137a3d237c2$var$screenCoordinate = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$80eb8887666700bd, $d89c9137a3d237c2$export$80eb8887666700bd.COORDINATE);
// Viewport
/**
 * TSL object that represents the viewport rectangle as `x`, `y`, `width` and `height` in physical pixel units.
 *
 * @tsl
 * @type {ScreenNode<vec4>}
 */ const $d89c9137a3d237c2$var$viewport = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$80eb8887666700bd, $d89c9137a3d237c2$export$80eb8887666700bd.VIEWPORT);
/**
 * TSL object that represents the viewport resolution in physical pixel units.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $d89c9137a3d237c2$var$viewportSize = $d89c9137a3d237c2$var$viewport.zw;
/**
 * TSL object that represents the current `x`/`y` pixel position on the viewport in physical pixel units.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $d89c9137a3d237c2$var$viewportCoordinate = /*@__PURE__*/ $d89c9137a3d237c2$var$screenCoordinate.sub($d89c9137a3d237c2$var$viewport.xy);
/**
 * TSL object that represents normalized viewport coordinates, unitless in `[0, 1]`.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $d89c9137a3d237c2$var$viewportUV = /*@__PURE__*/ $d89c9137a3d237c2$var$viewportCoordinate.div($d89c9137a3d237c2$var$viewportSize);
// Deprecated
/**
 * @deprecated since r169. Use {@link screenSize} instead.
 */ const $d89c9137a3d237c2$var$viewportResolution = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(()=>{
    (0, $329ek.warn)('TSL: "viewportResolution" is deprecated. Use "screenSize" instead.');
    return $d89c9137a3d237c2$var$screenSize;
}, 'vec2').once()();
/**
 * TSL object that represents the current `index` value of the camera if used ArrayCamera.
 *
 * @tsl
 * @type {UniformNode<uint>}
 */ const $d89c9137a3d237c2$var$cameraIndex = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform(0, 'uint').setName('u_cameraIndex').setGroup($d89c9137a3d237c2$var$sharedUniformGroup('cameraIndex')).toVarying('v_cameraIndex');
/**
 * TSL object that represents the `near` value of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<float>}
 */ const $d89c9137a3d237c2$var$cameraNear = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform('float').setName('cameraNear').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.near);
/**
 * TSL object that represents the `far` value of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<float>}
 */ const $d89c9137a3d237c2$var$cameraFar = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform('float').setName('cameraFar').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.far);
/**
 * TSL object that represents the projection matrix of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<mat4>}
 */ const $d89c9137a3d237c2$var$cameraProjectionMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ camera: camera })=>{
    let cameraProjectionMatrix;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const matrices = [];
        for (const subCamera of camera.cameras)matrices.push(subCamera.projectionMatrix);
        const cameraProjectionMatrices = $d89c9137a3d237c2$var$uniformArray(matrices).setGroup($d89c9137a3d237c2$var$renderGroup).setName('cameraProjectionMatrices');
        cameraProjectionMatrix = cameraProjectionMatrices.element(camera.isMultiViewCamera ? $d89c9137a3d237c2$var$builtin('gl_ViewID_OVR') : $d89c9137a3d237c2$var$cameraIndex).toConst('cameraProjectionMatrix');
    } else cameraProjectionMatrix = $d89c9137a3d237c2$var$uniform('mat4').setName('cameraProjectionMatrix').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.projectionMatrix);
    return cameraProjectionMatrix;
}).once()();
/**
 * TSL object that represents the inverse projection matrix of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<mat4>}
 */ const $d89c9137a3d237c2$var$cameraProjectionMatrixInverse = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ camera: camera })=>{
    let cameraProjectionMatrixInverse;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const matrices = [];
        for (const subCamera of camera.cameras)matrices.push(subCamera.projectionMatrixInverse);
        const cameraProjectionMatricesInverse = $d89c9137a3d237c2$var$uniformArray(matrices).setGroup($d89c9137a3d237c2$var$renderGroup).setName('cameraProjectionMatricesInverse');
        cameraProjectionMatrixInverse = cameraProjectionMatricesInverse.element(camera.isMultiViewCamera ? $d89c9137a3d237c2$var$builtin('gl_ViewID_OVR') : $d89c9137a3d237c2$var$cameraIndex).toConst('cameraProjectionMatrixInverse');
    } else cameraProjectionMatrixInverse = $d89c9137a3d237c2$var$uniform('mat4').setName('cameraProjectionMatrixInverse').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.projectionMatrixInverse);
    return cameraProjectionMatrixInverse;
}).once()();
/**
 * TSL object that represents the view matrix of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<mat4>}
 */ const $d89c9137a3d237c2$var$cameraViewMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ camera: camera })=>{
    let cameraViewMatrix;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const matrices = [];
        for (const subCamera of camera.cameras)matrices.push(subCamera.matrixWorldInverse);
        const cameraViewMatrices = $d89c9137a3d237c2$var$uniformArray(matrices).setGroup($d89c9137a3d237c2$var$renderGroup).setName('cameraViewMatrices');
        cameraViewMatrix = cameraViewMatrices.element(camera.isMultiViewCamera ? $d89c9137a3d237c2$var$builtin('gl_ViewID_OVR') : $d89c9137a3d237c2$var$cameraIndex).toConst('cameraViewMatrix');
    } else cameraViewMatrix = $d89c9137a3d237c2$var$uniform('mat4').setName('cameraViewMatrix').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.matrixWorldInverse);
    return cameraViewMatrix;
}).once()();
/**
 * TSL object that represents the world matrix of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<mat4>}
 */ const $d89c9137a3d237c2$var$cameraWorldMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ camera: camera })=>{
    let cameraWorldMatrix;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const matrices = [];
        for (const subCamera of camera.cameras)matrices.push(subCamera.matrixWorld);
        const cameraWorldMatrices = $d89c9137a3d237c2$var$uniformArray(matrices).setGroup($d89c9137a3d237c2$var$renderGroup).setName('cameraWorldMatrices');
        cameraWorldMatrix = cameraWorldMatrices.element(camera.isMultiViewCamera ? $d89c9137a3d237c2$var$builtin('gl_ViewID_OVR') : $d89c9137a3d237c2$var$cameraIndex).toConst('cameraWorldMatrix');
    } else cameraWorldMatrix = $d89c9137a3d237c2$var$uniform('mat4').setName('cameraWorldMatrix').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.matrixWorld);
    return cameraWorldMatrix;
}).once()();
/**
 * TSL object that represents the normal matrix of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<mat3>}
 */ const $d89c9137a3d237c2$var$cameraNormalMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ camera: camera })=>{
    let cameraNormalMatrix;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const matrices = [];
        for (const subCamera of camera.cameras)matrices.push(subCamera.normalMatrix);
        const cameraNormalMatrices = $d89c9137a3d237c2$var$uniformArray(matrices).setGroup($d89c9137a3d237c2$var$renderGroup).setName('cameraNormalMatrices');
        cameraNormalMatrix = cameraNormalMatrices.element(camera.isMultiViewCamera ? $d89c9137a3d237c2$var$builtin('gl_ViewID_OVR') : $d89c9137a3d237c2$var$cameraIndex).toConst('cameraNormalMatrix');
    } else cameraNormalMatrix = $d89c9137a3d237c2$var$uniform('mat3').setName('cameraNormalMatrix').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.normalMatrix);
    return cameraNormalMatrix;
}).once()();
/**
 * TSL object that represents the position in world space of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<vec3>}
 */ const $d89c9137a3d237c2$var$cameraPosition = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ camera: camera })=>{
    let cameraPosition;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const positions = [];
        for(let i = 0, l = camera.cameras.length; i < l; i++)positions.push(new (0, $329ek.Vector3)());
        const cameraPositions = $d89c9137a3d237c2$var$uniformArray(positions).setGroup($d89c9137a3d237c2$var$renderGroup).setName('cameraPositions').onRenderUpdate(({ camera: camera }, self1)=>{
            const subCameras = camera.cameras;
            const array = self1.array;
            for(let i = 0, l = subCameras.length; i < l; i++)array[i].setFromMatrixPosition(subCameras[i].matrixWorld);
        });
        cameraPosition = cameraPositions.element(camera.isMultiViewCamera ? $d89c9137a3d237c2$var$builtin('gl_ViewID_OVR') : $d89c9137a3d237c2$var$cameraIndex).toConst('cameraPosition');
    } else cameraPosition = $d89c9137a3d237c2$var$uniform(new (0, $329ek.Vector3)()).setName('cameraPosition').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(({ camera: camera }, self1)=>self1.value.setFromMatrixPosition(camera.matrixWorld));
    return cameraPosition;
}).once()();
/**
 * TSL object that represents the viewport of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<vec4>}
 */ const $d89c9137a3d237c2$var$cameraViewport = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ camera: camera })=>{
    let cameraViewport;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const viewports = [];
        for (const subCamera of camera.cameras)viewports.push(subCamera.viewport);
        const cameraViewports = $d89c9137a3d237c2$var$uniformArray(viewports, 'vec4').setGroup($d89c9137a3d237c2$var$renderGroup).setName('cameraViewports');
        cameraViewport = cameraViewports.element($d89c9137a3d237c2$var$cameraIndex).toConst('cameraViewport');
    } else // Fallback for single camera
    cameraViewport = $d89c9137a3d237c2$var$vec4(0, 0, $d89c9137a3d237c2$var$screenSize.x, $d89c9137a3d237c2$var$screenSize.y).toConst('cameraViewport');
    return cameraViewport;
}).once()();
const $d89c9137a3d237c2$var$_sphere = /*@__PURE__*/ new (0, $329ek.Sphere)();
/**
 * This node can be used to access transformation related metrics of 3D objects.
 * Depending on the selected scope, a different metric is represented as a uniform
 * in the shader. The following scopes are supported:
 *
 * - `POSITION`: The object's position in world space.
 * - `VIEW_POSITION`: The object's position in view/camera space.
 * - `DIRECTION`: The object's direction in world space.
 * - `SCALE`: The object's scale in world space.
 * - `WORLD_MATRIX`: The object's matrix in world space.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$2c22938328ec188a extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'Object3DNode';
    }
    /**
	 * Constructs a new object 3D node.
	 *
	 * @param {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')} scope - The node represents a different type of transformation depending on the scope.
	 * @param {?Object3D} [object3d=null] - The 3D object.
	 */ constructor(scope, object3d = null){
        super();
        /**
		 * The node reports a different type of transformation depending on the scope.
		 *
		 * @type {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')}
		 */ this.scope = scope;
        /**
		 * The 3D object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.object3d = object3d;
        /**
		 * Overwritten since this type of node is updated per object.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT;
        /**
		 * Holds the value of the node as a uniform.
		 *
		 * @type {UniformNode}
		 */ this.uniformNode = new $d89c9137a3d237c2$export$c0cca4cf699a03e1(null);
    }
    /**
	 * Overwritten since the node type is inferred from the scope.
	 *
	 * @return {('mat4'|'vec3'|'float')} The node type.
	 */ getNodeType() {
        const scope = this.scope;
        if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.WORLD_MATRIX) return 'mat4';
        else if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.POSITION || scope === $d89c9137a3d237c2$export$2c22938328ec188a.VIEW_POSITION || scope === $d89c9137a3d237c2$export$2c22938328ec188a.DIRECTION || scope === $d89c9137a3d237c2$export$2c22938328ec188a.SCALE) return 'vec3';
        else if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.RADIUS) return 'float';
    }
    /**
	 * Updates the uniform value depending on the scope.
	 *
	 * @param {NodeFrame} frame - The current node frame.
	 */ update(frame) {
        const object = this.object3d;
        const uniformNode = this.uniformNode;
        const scope = this.scope;
        if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.WORLD_MATRIX) uniformNode.value = object.matrixWorld;
        else if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.POSITION) {
            uniformNode.value = uniformNode.value || new (0, $329ek.Vector3)();
            uniformNode.value.setFromMatrixPosition(object.matrixWorld);
        } else if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.SCALE) {
            uniformNode.value = uniformNode.value || new (0, $329ek.Vector3)();
            uniformNode.value.setFromMatrixScale(object.matrixWorld);
        } else if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.DIRECTION) {
            uniformNode.value = uniformNode.value || new (0, $329ek.Vector3)();
            object.getWorldDirection(uniformNode.value);
        } else if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.VIEW_POSITION) {
            const camera = frame.camera;
            uniformNode.value = uniformNode.value || new (0, $329ek.Vector3)();
            uniformNode.value.setFromMatrixPosition(object.matrixWorld);
            uniformNode.value.applyMatrix4(camera.matrixWorldInverse);
        } else if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.RADIUS) {
            const geometry = frame.object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $d89c9137a3d237c2$var$_sphere.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
            uniformNode.value = $d89c9137a3d237c2$var$_sphere.radius;
        }
    }
    /**
	 * Generates the code snippet of the uniform node. The node type of the uniform
	 * node also depends on the selected scope.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated code snippet.
	 */ generate(builder) {
        const scope = this.scope;
        if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.WORLD_MATRIX) this.uniformNode.nodeType = 'mat4';
        else if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.POSITION || scope === $d89c9137a3d237c2$export$2c22938328ec188a.VIEW_POSITION || scope === $d89c9137a3d237c2$export$2c22938328ec188a.DIRECTION || scope === $d89c9137a3d237c2$export$2c22938328ec188a.SCALE) this.uniformNode.nodeType = 'vec3';
        else if (scope === $d89c9137a3d237c2$export$2c22938328ec188a.RADIUS) this.uniformNode.nodeType = 'float';
        return this.uniformNode.build(builder);
    }
    serialize(data) {
        super.serialize(data);
        data.scope = this.scope;
    }
    deserialize(data) {
        super.deserialize(data);
        this.scope = data.scope;
    }
}
$d89c9137a3d237c2$export$2c22938328ec188a.WORLD_MATRIX = 'worldMatrix';
$d89c9137a3d237c2$export$2c22938328ec188a.POSITION = 'position';
$d89c9137a3d237c2$export$2c22938328ec188a.SCALE = 'scale';
$d89c9137a3d237c2$export$2c22938328ec188a.VIEW_POSITION = 'viewPosition';
$d89c9137a3d237c2$export$2c22938328ec188a.DIRECTION = 'direction';
$d89c9137a3d237c2$export$2c22938328ec188a.RADIUS = 'radius';
/**
 * TSL function for creating an object 3D node that represents the object's direction in world space.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<vec3>}
 */ const $d89c9137a3d237c2$var$objectDirection = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$2c22938328ec188a, $d89c9137a3d237c2$export$2c22938328ec188a.DIRECTION).setParameterLength(1);
/**
 * TSL function for creating an object 3D node that represents the object's world matrix.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<mat4>}
 */ const $d89c9137a3d237c2$var$objectWorldMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$2c22938328ec188a, $d89c9137a3d237c2$export$2c22938328ec188a.WORLD_MATRIX).setParameterLength(1);
/**
 * TSL function for creating an object 3D node that represents the object's position in world space.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<vec3>}
 */ const $d89c9137a3d237c2$var$objectPosition = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$2c22938328ec188a, $d89c9137a3d237c2$export$2c22938328ec188a.POSITION).setParameterLength(1);
/**
 * TSL function for creating an object 3D node that represents the object's scale in world space.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<vec3>}
 */ const $d89c9137a3d237c2$var$objectScale = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$2c22938328ec188a, $d89c9137a3d237c2$export$2c22938328ec188a.SCALE).setParameterLength(1);
/**
 * TSL function for creating an object 3D node that represents the object's position in view/camera space.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<vec3>}
 */ const $d89c9137a3d237c2$var$objectViewPosition = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$2c22938328ec188a, $d89c9137a3d237c2$export$2c22938328ec188a.VIEW_POSITION).setParameterLength(1);
/**
 * TSL function for creating an object 3D node that represents the object's radius.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<float>}
 */ const $d89c9137a3d237c2$var$objectRadius = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$2c22938328ec188a, $d89c9137a3d237c2$export$2c22938328ec188a.RADIUS).setParameterLength(1);
/**
 * This type of node is a specialized version of `Object3DNode`
 * with larger set of model related metrics. Unlike `Object3DNode`,
 * `ModelNode` extracts the reference to the 3D object from the
 * current node frame state.
 *
 * @augments Object3DNode
 */ class $d89c9137a3d237c2$export$f15b179a1cc9e2bb extends $d89c9137a3d237c2$export$2c22938328ec188a {
    static get type() {
        return 'ModelNode';
    }
    /**
	 * Constructs a new object model node.
	 *
	 * @param {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')} scope - The node represents a different type of transformation depending on the scope.
	 */ constructor(scope){
        super(scope);
    }
    /**
	 * Extracts the model reference from the frame state and then
	 * updates the uniform value depending on the scope.
	 *
	 * @param {NodeFrame} frame - The current node frame.
	 */ update(frame) {
        this.object3d = frame.object;
        super.update(frame);
    }
}
/**
 * TSL object that represents the object's direction in world space.
 *
 * @tsl
 * @type {ModelNode<vec3>}
 */ const $d89c9137a3d237c2$var$modelDirection = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$f15b179a1cc9e2bb, $d89c9137a3d237c2$export$f15b179a1cc9e2bb.DIRECTION);
/**
 * TSL object that represents the object's world matrix.
 *
 * @tsl
 * @type {ModelNode<mat4>}
 */ const $d89c9137a3d237c2$var$modelWorldMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$f15b179a1cc9e2bb, $d89c9137a3d237c2$export$f15b179a1cc9e2bb.WORLD_MATRIX);
/**
 * TSL object that represents the object's position in world space.
 *
 * @tsl
 * @type {ModelNode<vec3>}
 */ const $d89c9137a3d237c2$var$modelPosition = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$f15b179a1cc9e2bb, $d89c9137a3d237c2$export$f15b179a1cc9e2bb.POSITION);
/**
 * TSL object that represents the object's scale in world space.
 *
 * @tsl
 * @type {ModelNode<vec3>}
 */ const $d89c9137a3d237c2$var$modelScale = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$f15b179a1cc9e2bb, $d89c9137a3d237c2$export$f15b179a1cc9e2bb.SCALE);
/**
 * TSL object that represents the object's position in view/camera space.
 *
 * @tsl
 * @type {ModelNode<vec3>}
 */ const $d89c9137a3d237c2$var$modelViewPosition = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$f15b179a1cc9e2bb, $d89c9137a3d237c2$export$f15b179a1cc9e2bb.VIEW_POSITION);
/**
 * TSL object that represents the object's radius.
 *
 * @tsl
 * @type {ModelNode<float>}
 */ const $d89c9137a3d237c2$var$modelRadius = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$f15b179a1cc9e2bb, $d89c9137a3d237c2$export$f15b179a1cc9e2bb.RADIUS);
/**
 * TSL object that represents the object's normal matrix.
 *
 * @tsl
 * @type {UniformNode<mat3>}
 */ const $d89c9137a3d237c2$var$modelNormalMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform(new (0, $329ek.Matrix3)()).onObjectUpdate(({ object: object }, self1)=>self1.value.getNormalMatrix(object.matrixWorld));
/**
 * TSL object that represents the object's inverse world matrix.
 *
 * @tsl
 * @type {UniformNode<mat4>}
 */ const $d89c9137a3d237c2$var$modelWorldMatrixInverse = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform(new (0, $329ek.Matrix4)()).onObjectUpdate(({ object: object }, self1)=>self1.value.copy(object.matrixWorld).invert());
/**
 * TSL object that represents the object's model view matrix.
 *
 * @tsl
 * @type {Node<mat4>}
 */ const $d89c9137a3d237c2$var$modelViewMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((builder)=>{
    return builder.context.modelViewMatrix || $d89c9137a3d237c2$var$mediumpModelViewMatrix;
}).once()().toVar('modelViewMatrix');
// GPU Precision
/**
 * TSL object that represents the object's model view in `mediump` precision.
 *
 * @tsl
 * @type {Node<mat4>}
 */ const $d89c9137a3d237c2$var$mediumpModelViewMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$cameraViewMatrix.mul($d89c9137a3d237c2$var$modelWorldMatrix);
// CPU Precision
/**
 * TSL object that represents the object's model view in `highp` precision
 * which is achieved by computing the matrix in JS and not in the shader.
 *
 * @tsl
 * @type {Node<mat4>}
 */ const $d89c9137a3d237c2$var$highpModelViewMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((builder)=>{
    builder.context.isHighPrecisionModelViewMatrix = true;
    return $d89c9137a3d237c2$var$uniform('mat4').onObjectUpdate(({ object: object, camera: camera })=>{
        return object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
    });
}).once()().toVar('highpModelViewMatrix');
/**
 * TSL object that represents the object's model normal view in `highp` precision
 * which is achieved by computing the matrix in JS and not in the shader.
 *
 * @tsl
 * @type {Node<mat3>}
 */ const $d89c9137a3d237c2$var$highpModelNormalViewMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((builder)=>{
    const isHighPrecisionModelViewMatrix = builder.context.isHighPrecisionModelViewMatrix;
    return $d89c9137a3d237c2$var$uniform('mat3').onObjectUpdate(({ object: object, camera: camera })=>{
        if (isHighPrecisionModelViewMatrix !== true) object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        return object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
    });
}).once()().toVar('highpModelNormalViewMatrix');
/**
 * TSL object that represents the position attribute of the current rendered object.
 *
 * @tsl
 * @type {AttributeNode<vec3>}
 */ const $d89c9137a3d237c2$var$positionGeometry = /*@__PURE__*/ $d89c9137a3d237c2$var$attribute('position', 'vec3');
/**
 * TSL object that represents the vertex position in local space of the current rendered object.
 *
 * @tsl
 * @type {AttributeNode<vec3>}
 */ const $d89c9137a3d237c2$var$positionLocal = /*@__PURE__*/ $d89c9137a3d237c2$var$positionGeometry.toVarying('positionLocal');
/**
 * TSL object that represents the previous vertex position in local space of the current rendered object.
 * Used in context of {@link VelocityNode} for rendering motion vectors.
 *
 * @tsl
 * @type {AttributeNode<vec3>}
 */ const $d89c9137a3d237c2$var$positionPrevious = /*@__PURE__*/ $d89c9137a3d237c2$var$positionGeometry.toVarying('positionPrevious');
/**
 * TSL object that represents the vertex position in world space of the current rendered object.
 *
 * @tsl
 * @type {VaryingNode<vec3>}
 */ const $d89c9137a3d237c2$var$positionWorld = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((builder)=>{
    return $d89c9137a3d237c2$var$modelWorldMatrix.mul($d89c9137a3d237c2$var$positionLocal).xyz.toVarying(builder.getSubBuildProperty('v_positionWorld'));
}, 'vec3').once([
    'POSITION'
])();
/**
 * TSL object that represents the position world direction of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$positionWorldDirection = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(()=>{
    const vertexPWD = $d89c9137a3d237c2$var$positionLocal.transformDirection($d89c9137a3d237c2$var$modelWorldMatrix).toVarying('v_positionWorldDirection');
    return vertexPWD.normalize().toVar('positionWorldDirection');
}, 'vec3').once([
    'POSITION'
])();
/**
 * TSL object that represents the vertex position in view space of the current rendered object.
 *
 * @tsl
 * @type {VaryingNode<vec3>}
 */ const $d89c9137a3d237c2$var$positionView = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((builder)=>{
    return builder.context.setupPositionView().toVarying('v_positionView');
}, 'vec3').once([
    'POSITION'
])();
/**
 * TSL object that represents the position view direction of the current rendered object.
 *
 * @tsl
 * @type {VaryingNode<vec3>}
 */ const $d89c9137a3d237c2$var$positionViewDirection = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((builder)=>{
    let output;
    if (builder.camera.isOrthographicCamera) output = $d89c9137a3d237c2$var$vec3(0, 0, 1);
    else output = $d89c9137a3d237c2$var$positionView.negate().toVarying('v_positionViewDirection').normalize();
    return output.toVar('positionViewDirection');
}, 'vec3').once([
    'POSITION'
])();
/**
 * This node can be used to evaluate whether a primitive is front or back facing.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$dd6b5700d49da9d0 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'FrontFacingNode';
    }
    /**
	 * Constructs a new front facing node.
	 */ constructor(){
        super('bool');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFrontFacingNode = true;
    }
    generate(builder) {
        if (builder.shaderStage !== 'fragment') return 'true';
        //
        const { material: material } = builder;
        if (material.side === (0, $329ek.BackSide)) return 'false';
        return builder.getFrontFacing();
    }
}
/**
 * TSL object that represents whether a primitive is front or back facing
 *
 * @tsl
 * @type {FrontFacingNode<bool>}
 */ const $d89c9137a3d237c2$var$frontFacing = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$dd6b5700d49da9d0);
/**
 * TSL object that represents the front facing status as a number instead of a bool.
 * `1` means front facing, `-1` means back facing.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$faceDirection = /*@__PURE__*/ $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$frontFacing).mul(2.0).sub(1.0);
/**
 * Converts a direction vector to a face direction vector based on the material's side.
 *
 * If the material is set to `BackSide`, the direction is inverted.
 * If the material is set to `DoubleSide`, the direction is multiplied by `faceDirection`.
 *
 * @tsl
 * @param {Node<vec3>} direction - The direction vector to convert.
 * @returns {Node<vec3>} The converted direction vector.
 */ const $d89c9137a3d237c2$var$directionToFaceDirection = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([direction], { material: material })=>{
    const side = material.side;
    if (side === (0, $329ek.BackSide)) direction = direction.mul(-1);
    else if (side === (0, $329ek.DoubleSide)) direction = direction.mul($d89c9137a3d237c2$var$faceDirection);
    return direction;
});
/**
 * TSL object that represents the normal attribute of the current rendered object in local space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$normalGeometry = /*@__PURE__*/ $d89c9137a3d237c2$var$attribute('normal', 'vec3');
/**
 * TSL object that represents the vertex normal of the current rendered object in local space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$normalLocal = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((builder)=>{
    if (builder.geometry.hasAttribute('normal') === false) {
        (0, $329ek.warn)('TSL: Vertex attribute "normal" not found on geometry.');
        return $d89c9137a3d237c2$var$vec3(0, 1, 0);
    }
    return $d89c9137a3d237c2$var$normalGeometry;
}, 'vec3').once()().toVar('normalLocal');
/**
 * TSL object that represents the flat vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$normalFlat = /*@__PURE__*/ $d89c9137a3d237c2$var$positionView.dFdx().cross($d89c9137a3d237c2$var$positionView.dFdy()).normalize().toVar('normalFlat');
/**
 * TSL object that represents the vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$normalViewGeometry = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((builder)=>{
    let node;
    if (builder.material.flatShading === true) node = $d89c9137a3d237c2$var$normalFlat;
    else node = $d89c9137a3d237c2$var$transformNormalToView($d89c9137a3d237c2$var$normalLocal).toVarying('v_normalViewGeometry').normalize();
    return node;
}, 'vec3').once()().toVar('normalViewGeometry');
/**
 * TSL object that represents the vertex normal of the current rendered object in world space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$normalWorldGeometry = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((builder)=>{
    let normal = $d89c9137a3d237c2$var$normalViewGeometry.transformDirection($d89c9137a3d237c2$var$cameraViewMatrix);
    if (builder.material.flatShading !== true) normal = normal.toVarying('v_normalWorldGeometry');
    return normal.normalize().toVar('normalWorldGeometry');
}, 'vec3').once()();
/**
 * TSL object that represents the vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$normalView = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ subBuildFn: subBuildFn, material: material, context: context })=>{
    let node;
    if (subBuildFn === 'NORMAL' || subBuildFn === 'VERTEX') {
        node = $d89c9137a3d237c2$var$normalViewGeometry;
        if (material.flatShading !== true) node = $d89c9137a3d237c2$var$directionToFaceDirection(node);
    } else // Use getUV context to avoid side effects from nodes overwriting getUV in the context (e.g. EnvironmentNode)
    node = context.setupNormal().context({
        getUV: null
    });
    return node;
}, 'vec3').once([
    'NORMAL',
    'VERTEX'
])().toVar('normalView');
/**
 * TSL object that represents the vertex normal of the current rendered object in world space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$normalWorld = /*@__PURE__*/ $d89c9137a3d237c2$var$normalView.transformDirection($d89c9137a3d237c2$var$cameraViewMatrix).toVar('normalWorld');
/**
 * TSL object that represents the clearcoat vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$clearcoatNormalView = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ subBuildFn: subBuildFn, context: context })=>{
    let node;
    if (subBuildFn === 'NORMAL' || subBuildFn === 'VERTEX') node = $d89c9137a3d237c2$var$normalView;
    else // Use getUV context to avoid side effects from nodes overwriting getUV in the context (e.g. EnvironmentNode)
    node = context.setupClearcoatNormal().context({
        getUV: null
    });
    return node;
}, 'vec3').once([
    'NORMAL',
    'VERTEX'
])().toVar('clearcoatNormalView');
/**
 * Transforms the normal with the given matrix.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} normal - The normal.
 * @param {Node<mat3>} [matrix=modelWorldMatrix] - The matrix.
 * @return {Node<vec3>} The transformed normal.
 */ const $d89c9137a3d237c2$var$transformNormal = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([normal, matrix = $d89c9137a3d237c2$var$modelWorldMatrix])=>{
    const m = $d89c9137a3d237c2$var$mat3(matrix);
    const transformedNormal = normal.div($d89c9137a3d237c2$var$vec3(m[0].dot(m[0]), m[1].dot(m[1]), m[2].dot(m[2])));
    return m.mul(transformedNormal).xyz;
});
/**
 * Transforms the given normal from local to view space.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} normal - The normal.
 * @param {NodeBuilder} builder - The current node builder.
 * @return {Node<vec3>} The transformed normal.
 */ const $d89c9137a3d237c2$var$transformNormalToView = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([normal], builder)=>{
    const modelNormalViewMatrix = builder.context.modelNormalViewMatrix;
    if (modelNormalViewMatrix) return modelNormalViewMatrix.transformDirection(normal);
    //
    const transformedNormal = $d89c9137a3d237c2$var$modelNormalMatrix.mul(normal);
    return $d89c9137a3d237c2$var$cameraViewMatrix.transformDirection(transformedNormal);
});
// Deprecated
/**
 * TSL object that represents the transformed vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 * @deprecated since r178. Use `normalView` instead.
 */ const $d89c9137a3d237c2$var$transformedNormalView = $d89c9137a3d237c2$var$Fn(()=>{
    (0, $329ek.warn)('TSL: "transformedNormalView" is deprecated. Use "normalView" instead.');
    return $d89c9137a3d237c2$var$normalView;
}).once([
    'NORMAL',
    'VERTEX'
])();
/**
 * TSL object that represents the transformed vertex normal of the current rendered object in world space.
 *
 * @tsl
 * @type {Node<vec3>}
 * @deprecated since r178. Use `normalWorld` instead.
 */ const $d89c9137a3d237c2$var$transformedNormalWorld = $d89c9137a3d237c2$var$Fn(()=>{
    (0, $329ek.warn)('TSL: "transformedNormalWorld" is deprecated. Use "normalWorld" instead.');
    return $d89c9137a3d237c2$var$normalWorld;
}).once([
    'NORMAL',
    'VERTEX'
])();
/**
 * TSL object that represents the transformed clearcoat vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 * @deprecated since r178. Use `clearcoatNormalView` instead.
 */ const $d89c9137a3d237c2$var$transformedClearcoatNormalView = $d89c9137a3d237c2$var$Fn(()=>{
    (0, $329ek.warn)('TSL: "transformedClearcoatNormalView" is deprecated. Use "clearcoatNormalView" instead.');
    return $d89c9137a3d237c2$var$clearcoatNormalView;
}).once([
    'NORMAL',
    'VERTEX'
])();
const $d89c9137a3d237c2$var$_e1$1 = /*@__PURE__*/ new (0, $329ek.Euler)();
const $d89c9137a3d237c2$var$_m1$1 = /*@__PURE__*/ new (0, $329ek.Matrix4)();
/**
 * TSL object that represents the refraction ratio of the material used for rendering the current object.
 *
 * @tsl
 * @type {UniformNode<float>}
 */ const $d89c9137a3d237c2$var$materialRefractionRatio = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform(0).onReference(({ material: material })=>material).onObjectUpdate(({ material: material })=>material.refractionRatio);
/**
 * TSL object that represents the intensity of environment maps of PBR materials.
 * When `material.envMap` is set, the value is `material.envMapIntensity` otherwise `scene.environmentIntensity`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialEnvIntensity = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform(1).onReference(({ material: material })=>material).onObjectUpdate(function({ material: material, scene: scene }) {
    return material.envMap ? material.envMapIntensity : scene.environmentIntensity;
});
/**
 * TSL object that represents the rotation of environment maps.
 * When `material.envMap` is set, the value is `material.envMapRotation`. `scene.environmentRotation` controls the
 * rotation of `scene.environment` instead.
 *
 * @tsl
 * @type {Node<mat4>}
 */ const $d89c9137a3d237c2$var$materialEnvRotation = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform(new (0, $329ek.Matrix4)()).onReference(function(frame) {
    return frame.material;
}).onObjectUpdate(function({ material: material, scene: scene }) {
    const rotation = scene.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
    if (rotation) {
        $d89c9137a3d237c2$var$_e1$1.copy(rotation);
        $d89c9137a3d237c2$var$_m1$1.makeRotationFromEuler($d89c9137a3d237c2$var$_e1$1);
    } else $d89c9137a3d237c2$var$_m1$1.identity();
    return $d89c9137a3d237c2$var$_m1$1;
});
/**
 * The reflect vector in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$reflectView = /*@__PURE__*/ $d89c9137a3d237c2$var$positionViewDirection.negate().reflect($d89c9137a3d237c2$var$normalView);
/**
 * The refract vector in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$refractView = /*@__PURE__*/ $d89c9137a3d237c2$var$positionViewDirection.negate().refract($d89c9137a3d237c2$var$normalView, $d89c9137a3d237c2$var$materialRefractionRatio);
/**
 * Used for sampling cube maps when using cube reflection mapping.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$reflectVector = /*@__PURE__*/ $d89c9137a3d237c2$var$reflectView.transformDirection($d89c9137a3d237c2$var$cameraViewMatrix).toVar('reflectVector');
/**
 * Used for sampling cube maps when using cube refraction mapping.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$refractVector = /*@__PURE__*/ $d89c9137a3d237c2$var$refractView.transformDirection($d89c9137a3d237c2$var$cameraViewMatrix).toVar('reflectVector');
const $d89c9137a3d237c2$var$EmptyTexture = /*@__PURE__*/ new (0, $329ek.CubeTexture)();
/**
 * This type of uniform node represents a cube texture.
 *
 * @augments TextureNode
 */ class $d89c9137a3d237c2$export$732dea7352dc5b2c extends $d89c9137a3d237c2$export$2dd903bc9e8140bc {
    static get type() {
        return 'CubeTextureNode';
    }
    /**
	 * Constructs a new cube texture node.
	 *
	 * @param {CubeTexture} value - The cube texture.
	 * @param {?Node<vec3>} [uvNode=null] - The uv node.
	 * @param {?Node<int>} [levelNode=null] - The level node.
	 * @param {?Node<float>} [biasNode=null] - The bias node.
	 */ constructor(value, uvNode = null, levelNode = null, biasNode = null){
        super(value, uvNode, levelNode, biasNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTextureNode = true;
    }
    /**
	 * Overwrites the default implementation to return the appropriate cube texture type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        if (this.value.isDepthTexture === true) return 'cubeDepthTexture';
        return 'cubeTexture';
    }
    /**
	 * Returns a default uvs based on the mapping type of the cube texture.
	 *
	 * @return {Node<vec3>} The default uv attribute.
	 */ getDefaultUV() {
        const texture = this.value;
        if (texture.mapping === (0, $329ek.CubeReflectionMapping)) return $d89c9137a3d237c2$var$reflectVector;
        else if (texture.mapping === (0, $329ek.CubeRefractionMapping)) return $d89c9137a3d237c2$var$refractVector;
        else {
            (0, $329ek.error)('CubeTextureNode: Mapping "%s" not supported.', texture.mapping);
            return $d89c9137a3d237c2$var$vec3(0, 0, 0);
        }
    }
    /**
	 * Overwritten with an empty implementation since the `updateMatrix` flag is ignored
	 * for cube textures. The uv transformation matrix is not applied to cube textures.
	 *
	 * @param {boolean} value - The update toggle.
	 */ setUpdateMatrix() {}
    /**
	 * Setups the uv node. Depending on the backend as well as the texture type, it might be necessary
	 * to modify the uv node for correct sampling.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} uvNode - The uv node to setup.
	 * @return {Node} The updated uv node.
	 */ setupUV(builder, uvNode) {
        const texture = this.value;
        // Depth textures (shadow maps) - no environment rotation, Y flip for WebGPU
        if (texture.isDepthTexture === true) {
            if (builder.renderer.coordinateSystem === (0, $329ek.WebGPUCoordinateSystem)) return $d89c9137a3d237c2$var$vec3(uvNode.x, uvNode.y.negate(), uvNode.z);
            return uvNode;
        }
        if (builder.renderer.coordinateSystem === (0, $329ek.WebGPUCoordinateSystem) || !texture.isRenderTargetTexture) uvNode = $d89c9137a3d237c2$var$vec3(uvNode.x.negate(), uvNode.yz);
        return $d89c9137a3d237c2$var$materialEnvRotation.mul(uvNode);
    }
    /**
	 * Generates the uv code snippet.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} cubeUV - The uv node to generate code for.
	 * @return {string} The generated code snippet.
	 */ generateUV(builder, cubeUV) {
        return cubeUV.build(builder, this.sampler === true ? 'vec3' : 'ivec3');
    }
}
/**
 * TSL function for creating a cube texture node.
 *
 * @tsl
 * @function
 * @param {CubeTexture} value - The cube texture.
 * @param {?Node<vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {CubeTextureNode}
 */ const $d89c9137a3d237c2$var$cubeTextureBase = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$732dea7352dc5b2c).setParameterLength(1, 4).setName('cubeTexture');
/**
 * TSL function for creating a cube texture uniform node.
 *
 * @tsl
 * @function
 * @param {?(CubeTexture|CubeTextureNode)} [value=EmptyTexture] - The cube texture.
 * @param {?Node<vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {CubeTextureNode}
 */ const $d89c9137a3d237c2$var$cubeTexture = (value = $d89c9137a3d237c2$var$EmptyTexture, uvNode = null, levelNode = null, biasNode = null)=>{
    let textureNode;
    if (value && value.isCubeTextureNode === true) {
        textureNode = $d89c9137a3d237c2$var$nodeObject(value.clone());
        textureNode.referenceNode = value; // Ensure the reference is set to the original node
        if (uvNode !== null) textureNode.uvNode = $d89c9137a3d237c2$var$nodeObject(uvNode);
        if (levelNode !== null) textureNode.levelNode = $d89c9137a3d237c2$var$nodeObject(levelNode);
        if (biasNode !== null) textureNode.biasNode = $d89c9137a3d237c2$var$nodeObject(biasNode);
    } else textureNode = $d89c9137a3d237c2$var$cubeTextureBase(value, uvNode, levelNode, biasNode);
    return textureNode;
};
/**
 * TSL function for creating a uniform cube texture node.
 *
 * @tsl
 * @function
 * @param {?CubeTexture} [value=EmptyTexture] - The cube texture.
 * @returns {CubeTextureNode}
 */ const $d89c9137a3d237c2$var$uniformCubeTexture = (value = $d89c9137a3d237c2$var$EmptyTexture)=>$d89c9137a3d237c2$var$cubeTextureBase(value);
// TODO: Avoid duplicated code and use only ReferenceBaseNode or ReferenceNode
/**
 * This class is only relevant if the referenced property is array-like.
 * In this case, `ReferenceElementNode` allows to refer to a specific
 * element inside the data structure via an index.
 *
 * @augments ArrayElementNode
 */ class $d89c9137a3d237c2$var$ReferenceElementNode extends $d89c9137a3d237c2$export$f2edd1d22bf6d00b {
    static get type() {
        return 'ReferenceElementNode';
    }
    /**
	 * Constructs a new reference element node.
	 *
	 * @param {?ReferenceNode} referenceNode - The reference node.
	 * @param {Node} indexNode - The index node that defines the element access.
	 */ constructor(referenceNode, indexNode){
        super(referenceNode, indexNode);
        /**
		 * Similar to {@link ReferenceNode#reference}, an additional
		 * property references to the current node.
		 *
		 * @type {?ReferenceNode}
		 * @default null
		 */ this.referenceNode = referenceNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isReferenceElementNode = true;
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the uniform type of the reference node.
	 *
	 * @return {string} The node type.
	 */ getNodeType() {
        return this.referenceNode.uniformType;
    }
    generate(builder) {
        const snippet = super.generate(builder);
        const arrayType = this.referenceNode.getNodeType();
        const elementType = this.getNodeType();
        return builder.format(snippet, arrayType, elementType);
    }
}
/**
 * This type of node establishes a reference to a property of another object.
 * In this way, the value of the node is automatically linked to the value of
 * referenced object. Reference nodes internally represent the linked value
 * as a uniform.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$81a720e7e5211d94 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ReferenceNode';
    }
    /**
	 * Constructs a new reference node.
	 *
	 * @param {string} property - The name of the property the node refers to.
	 * @param {string} uniformType - The uniform type that should be used to represent the property value.
	 * @param {?Object} [object=null] - The object the property belongs to.
	 * @param {?number} [count=null] - When the linked property is an array-like, this parameter defines its length.
	 */ constructor(property, uniformType, object = null, count = null){
        super();
        /**
		 * The name of the property the node refers to.
		 *
		 * @type {string}
		 */ this.property = property;
        /**
		 * The uniform type that should be used to represent the property value.
		 *
		 * @type {string}
		 */ this.uniformType = uniformType;
        /**
		 * The object the property belongs to.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.object = object;
        /**
		 * When the linked property is an array, this parameter defines its length.
		 *
		 * @type {?number}
		 * @default null
		 */ this.count = count;
        /**
		 * The property name might have dots so nested properties can be referred.
		 * The hierarchy of the names is stored inside this array.
		 *
		 * @type {Array<string>}
		 */ this.properties = property.split('.');
        /**
		 * Points to the current referred object. This property exists next to {@link ReferenceNode#object}
		 * since the final reference might be updated from calling code.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.reference = object;
        /**
		 * The uniform node that holds the value of the reference node.
		 *
		 * @type {UniformNode}
		 * @default null
		 */ this.node = null;
        /**
		 * The uniform group of the internal uniform.
		 *
		 * @type {UniformGroupNode}
		 * @default null
		 */ this.group = null;
        /**
		 * An optional label of the internal uniform node.
		 *
		 * @type {?string}
		 * @default null
		 */ this.name = null;
        /**
		 * Overwritten since reference nodes are updated per object.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT;
    }
    /**
	 * When the referred property is array-like, this method can be used
	 * to access elements via an index node.
	 *
	 * @param {IndexNode} indexNode - indexNode.
	 * @return {ReferenceElementNode} A reference to an element.
	 */ element(indexNode) {
        return new $d89c9137a3d237c2$var$ReferenceElementNode(this, $d89c9137a3d237c2$var$nodeObject(indexNode));
    }
    /**
	 * Sets the uniform group for this reference node.
	 *
	 * @param {UniformGroupNode} group - The uniform group to set.
	 * @return {ReferenceNode} A reference to this node.
	 */ setGroup(group) {
        this.group = group;
        return this;
    }
    /**
	 * Sets the name for the internal uniform.
	 *
	 * @param {string} name - The label to set.
	 * @return {ReferenceNode} A reference to this node.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the label for the internal uniform.
	 *
	 * @deprecated
	 * @param {string} name - The label to set.
	 * @return {ReferenceNode} A reference to this node.
	 */ label(name) {
        (0, $329ek.warn)('TSL: "label()" has been deprecated. Use "setName()" instead.'); // @deprecated r179
        return this.setName(name);
    }
    /**
	 * Sets the node type which automatically defines the internal
	 * uniform type.
	 *
	 * @param {string} uniformType - The type to set.
	 */ setNodeType(uniformType) {
        let node = null;
        if (this.count !== null) node = $d89c9137a3d237c2$var$buffer(null, uniformType, this.count);
        else if (Array.isArray(this.getValueFromReference())) node = $d89c9137a3d237c2$var$uniformArray(null, uniformType);
        else if (uniformType === 'texture') node = $d89c9137a3d237c2$var$texture(null);
        else if (uniformType === 'cubeTexture') node = $d89c9137a3d237c2$var$cubeTexture(null);
        else node = $d89c9137a3d237c2$var$uniform(null, uniformType);
        if (this.group !== null) node.setGroup(this.group);
        if (this.name !== null) node.setName(this.name);
        this.node = node;
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the type of the reference node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        if (this.node === null) {
            this.updateReference(builder);
            this.updateValue();
        }
        return this.node.getNodeType(builder);
    }
    /**
	 * Returns the property value from the given referred object.
	 *
	 * @param {Object} [object=this.reference] - The object to retrieve the property value from.
	 * @return {any} The value.
	 */ getValueFromReference(object = this.reference) {
        const { properties: properties } = this;
        let value = object[properties[0]];
        for(let i = 1; i < properties.length; i++)value = value[properties[i]];
        return value;
    }
    /**
	 * Allows to update the reference based on the given state. The state is only
	 * evaluated {@link ReferenceNode#object} is not set.
	 *
	 * @param {(NodeFrame|NodeBuilder)} state - The current state.
	 * @return {Object} The updated reference.
	 */ updateReference(state) {
        this.reference = this.object !== null ? this.object : state.object;
        return this.reference;
    }
    /**
	 * The output of the reference node is the internal uniform node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {UniformNode} The output node.
	 */ setup() {
        this.updateValue();
        return this.node;
    }
    /**
	 * Overwritten to update the internal uniform value.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update() {
        this.updateValue();
    }
    /**
	 * Retrieves the value from the referred object property and uses it
	 * to updated the internal uniform.
	 */ updateValue() {
        if (this.node === null) this.setNodeType(this.uniformType);
        const value = this.getValueFromReference();
        if (Array.isArray(value)) this.node.array = value;
        else this.node.value = value;
    }
}
/**
 * TSL function for creating a reference node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the property the node refers to.
 * @param {string} type - The uniform type that should be used to represent the property value.
 * @param {?Object} [object] - The object the property belongs to.
 * @returns {ReferenceNode}
 */ const $d89c9137a3d237c2$var$reference = (name, type, object)=>new $d89c9137a3d237c2$export$81a720e7e5211d94(name, type, object);
/**
 * TSL function for creating a reference node. Use this function if you want need a reference
 * to an array-like property that should be represented as a uniform buffer.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the property the node refers to.
 * @param {string} type - The uniform type that should be used to represent the property value.
 * @param {number} count - The number of value inside the array-like object.
 * @param {Object} object - An array-like object the property belongs to.
 * @returns {ReferenceNode}
 */ const $d89c9137a3d237c2$var$referenceBuffer = (name, type, count, object)=>new $d89c9137a3d237c2$export$81a720e7e5211d94(name, type, object, count);
/**
 * This node is a special type of reference node which is intended
 * for linking material properties with node values.
 * ```js
 * const opacityNode = materialReference( 'opacity', 'float', material );
 * ```
 * When changing `material.opacity`, the node value of `opacityNode` will
 * automatically be updated.
 *
 * @augments ReferenceNode
 */ class $d89c9137a3d237c2$export$a8e48e1870f9efa7 extends $d89c9137a3d237c2$export$81a720e7e5211d94 {
    static get type() {
        return 'MaterialReferenceNode';
    }
    /**
	 * Constructs a new material reference node.
	 *
	 * @param {string} property - The name of the property the node refers to.
	 * @param {string} inputType - The uniform type that should be used to represent the property value.
	 * @param {?Material} [material=null] - The material the property belongs to. When no material is set,
	 * the node refers to the material of the current rendered object.
	 */ constructor(property, inputType, material = null){
        super(property, inputType, material);
        /**
		 * The material the property belongs to. When no material is set,
		 * the node refers to the material of the current rendered object.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.material = material;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMaterialReferenceNode = true;
    }
    /**
	 * Updates the reference based on the given state. The state is only evaluated
	 * {@link MaterialReferenceNode#material} is not set.
	 *
	 * @param {(NodeFrame|NodeBuilder)} state - The current state.
	 * @return {Object} The updated reference.
	 */ updateReference(state) {
        this.reference = this.material !== null ? this.material : state.material;
        return this.reference;
    }
}
/**
 * TSL function for creating a material reference node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the property the node refers to.
 * @param {string} type - The uniform type that should be used to represent the property value.
 * @param {?Material} [material=null] - The material the property belongs to.
 * When no material is set, the node refers to the material of the current rendered object.
 * @returns {MaterialReferenceNode}
 */ const $d89c9137a3d237c2$var$materialReference = (name, type, material = null)=>new $d89c9137a3d237c2$export$a8e48e1870f9efa7(name, type, material);
// Normal Mapping Without Precomputed Tangents
// http://www.thetenthplanet.de/archives/1180
const $d89c9137a3d237c2$var$uv = $d89c9137a3d237c2$var$uv$1();
const $d89c9137a3d237c2$var$q0 = $d89c9137a3d237c2$var$positionView.dFdx();
const $d89c9137a3d237c2$var$q1 = $d89c9137a3d237c2$var$positionView.dFdy();
const $d89c9137a3d237c2$var$st0 = $d89c9137a3d237c2$var$uv.dFdx();
const $d89c9137a3d237c2$var$st1 = $d89c9137a3d237c2$var$uv.dFdy();
const $d89c9137a3d237c2$var$N = $d89c9137a3d237c2$var$normalView;
const $d89c9137a3d237c2$var$q1perp = $d89c9137a3d237c2$var$q1.cross($d89c9137a3d237c2$var$N);
const $d89c9137a3d237c2$var$q0perp = $d89c9137a3d237c2$var$N.cross($d89c9137a3d237c2$var$q0);
const $d89c9137a3d237c2$var$T = $d89c9137a3d237c2$var$q1perp.mul($d89c9137a3d237c2$var$st0.x).add($d89c9137a3d237c2$var$q0perp.mul($d89c9137a3d237c2$var$st1.x));
const $d89c9137a3d237c2$var$B = $d89c9137a3d237c2$var$q1perp.mul($d89c9137a3d237c2$var$st0.y).add($d89c9137a3d237c2$var$q0perp.mul($d89c9137a3d237c2$var$st1.y));
const $d89c9137a3d237c2$var$det = $d89c9137a3d237c2$var$T.dot($d89c9137a3d237c2$var$T).max($d89c9137a3d237c2$var$B.dot($d89c9137a3d237c2$var$B));
const $d89c9137a3d237c2$var$scale$1 = $d89c9137a3d237c2$var$det.equal(0.0).select(0.0, $d89c9137a3d237c2$var$det.inverseSqrt());
/**
 * Tangent vector in view space, computed dynamically from geometry and UV derivatives.
 * Useful for normal mapping without precomputed tangents.
 *
 * Reference: http://www.thetenthplanet.de/archives/1180
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$tangentViewFrame = /*@__PURE__*/ $d89c9137a3d237c2$var$T.mul($d89c9137a3d237c2$var$scale$1).toVar('tangentViewFrame');
/**
 * Bitangent vector in view space, computed dynamically from geometry and UV derivatives.
 * Complements the tangentViewFrame for constructing the tangent space basis.
 *
 * Reference: http://www.thetenthplanet.de/archives/1180
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$bitangentViewFrame = /*@__PURE__*/ $d89c9137a3d237c2$var$B.mul($d89c9137a3d237c2$var$scale$1).toVar('bitangentViewFrame');
/**
 * TSL object that represents the tangent attribute of the current rendered object.
 *
 * @tsl
 * @type {Node<vec4>}
 */ const $d89c9137a3d237c2$var$tangentGeometry = /*@__PURE__*/ $d89c9137a3d237c2$var$attribute('tangent', 'vec4');
/**
 * TSL object that represents the vertex tangent in local space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$tangentLocal = /*@__PURE__*/ $d89c9137a3d237c2$var$tangentGeometry.xyz.toVar('tangentLocal');
/**
 * TSL object that represents the vertex tangent in view space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$tangentView = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ subBuildFn: subBuildFn, geometry: geometry, material: material })=>{
    let node;
    if (subBuildFn === 'VERTEX' || geometry.hasAttribute('tangent')) node = $d89c9137a3d237c2$var$modelViewMatrix.mul($d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$tangentLocal, 0)).xyz.toVarying('v_tangentView').normalize();
    else node = $d89c9137a3d237c2$var$tangentViewFrame;
    if (material.flatShading !== true) node = $d89c9137a3d237c2$var$directionToFaceDirection(node);
    return node;
}, 'vec3').once([
    'NORMAL',
    'VERTEX'
])().toVar('tangentView');
/**
 * TSL object that represents the vertex tangent in world space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$tangentWorld = /*@__PURE__*/ $d89c9137a3d237c2$var$tangentView.transformDirection($d89c9137a3d237c2$var$cameraViewMatrix).toVarying('v_tangentWorld').normalize().toVar('tangentWorld');
/**
 * Returns the bitangent node and assigns it to a varying if the material is not flat shaded.
 *
 * @tsl
 * @private
 * @param {Node<vec3>} crossNormalTangent - The cross product of the normal and tangent vectors.
 * @param {string} varyingName - The name of the varying to assign the bitangent to.
 * @returns {Node<vec3>} The bitangent node.
 */ const $d89c9137a3d237c2$var$getBitangent = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([crossNormalTangent, varyingName], { subBuildFn: subBuildFn, material: material })=>{
    let bitangent = crossNormalTangent.mul($d89c9137a3d237c2$var$tangentGeometry.w).xyz;
    if (subBuildFn === 'NORMAL' && material.flatShading !== true) bitangent = bitangent.toVarying(varyingName);
    return bitangent;
}).once([
    'NORMAL'
]);
/**
 * TSL object that represents the bitangent attribute of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$bitangentGeometry = /*@__PURE__*/ $d89c9137a3d237c2$var$getBitangent($d89c9137a3d237c2$var$normalGeometry.cross($d89c9137a3d237c2$var$tangentGeometry), 'v_bitangentGeometry').normalize().toVar('bitangentGeometry');
/**
 * TSL object that represents the vertex bitangent in local space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$bitangentLocal = /*@__PURE__*/ $d89c9137a3d237c2$var$getBitangent($d89c9137a3d237c2$var$normalLocal.cross($d89c9137a3d237c2$var$tangentLocal), 'v_bitangentLocal').normalize().toVar('bitangentLocal');
/**
 * TSL object that represents the vertex bitangent in view space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$bitangentView = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ subBuildFn: subBuildFn, geometry: geometry, material: material })=>{
    let node;
    if (subBuildFn === 'VERTEX' || geometry.hasAttribute('tangent')) node = $d89c9137a3d237c2$var$getBitangent($d89c9137a3d237c2$var$normalView.cross($d89c9137a3d237c2$var$tangentView), 'v_bitangentView').normalize();
    else node = $d89c9137a3d237c2$var$bitangentViewFrame;
    if (material.flatShading !== true) node = $d89c9137a3d237c2$var$directionToFaceDirection(node);
    return node;
}, 'vec3').once([
    'NORMAL',
    'VERTEX'
])().toVar('bitangentView');
/**
 * TSL object that represents the vertex bitangent in world space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$bitangentWorld = /*@__PURE__*/ $d89c9137a3d237c2$var$getBitangent($d89c9137a3d237c2$var$normalWorld.cross($d89c9137a3d237c2$var$tangentWorld), 'v_bitangentWorld').normalize().toVar('bitangentWorld');
/**
 * TSL object that represents the TBN matrix in view space.
 *
 * @tsl
 * @type {Node<mat3>}
 */ const $d89c9137a3d237c2$var$TBNViewMatrix = /*@__PURE__*/ $d89c9137a3d237c2$var$mat3($d89c9137a3d237c2$var$tangentView, $d89c9137a3d237c2$var$bitangentView, $d89c9137a3d237c2$var$normalView).toVar('TBNViewMatrix');
/**
 * TSL object that represents the parallax direction.
 *
 * @tsl
 * @type {Node<mat3>}
 */ const $d89c9137a3d237c2$var$parallaxDirection = /*@__PURE__*/ $d89c9137a3d237c2$var$positionViewDirection.mul($d89c9137a3d237c2$var$TBNViewMatrix) /*.normalize()*/ ;
/**
 * TSL function for computing parallax uv coordinates.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} uv - A uv node.
 * @param {Node<vec2>} scale - A scale node.
 * @returns {Node<vec2>} Parallax uv coordinates.
 */ const $d89c9137a3d237c2$var$parallaxUV = (uv, scale)=>uv.sub($d89c9137a3d237c2$var$parallaxDirection.mul(scale));
/**
 * TSL function for computing bent normals.
 *
 * @tsl
 * @function
 * @returns {Node<vec3>} Bent normals.
 */ const $d89c9137a3d237c2$var$bentNormalView = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(()=>{
    // https://google.github.io/filament/Filament.md.html#lighting/imagebasedlights/anisotropy
    let bentNormal = $d89c9137a3d237c2$var$anisotropyB.cross($d89c9137a3d237c2$var$positionViewDirection);
    bentNormal = bentNormal.cross($d89c9137a3d237c2$var$anisotropyB).normalize();
    bentNormal = $d89c9137a3d237c2$var$mix(bentNormal, $d89c9137a3d237c2$var$normalView, $d89c9137a3d237c2$var$anisotropy.mul($d89c9137a3d237c2$var$roughness.oneMinus()).oneMinus().pow2().pow2()).normalize();
    return bentNormal;
}).once()();
/**
 * Packs a direction vector into a color value.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} node - The direction to pack.
 * @return {Node<vec3>} The color.
 */ const $d89c9137a3d237c2$var$directionToColor = (node)=>$d89c9137a3d237c2$var$nodeObject(node).mul(0.5).add(0.5);
/**
 * Unpacks a color value into a direction vector.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} node - The color to unpack.
 * @return {Node<vec3>} The direction.
 */ const $d89c9137a3d237c2$var$colorToDirection = (node)=>$d89c9137a3d237c2$var$nodeObject(node).mul(2.0).sub(1);
/**
 * Unpacks a tangent space normal, reconstructing the Z component by projecting the X,Y coordinates onto the hemisphere.
 * The X,Y coordinates are expected to be in the [-1, 1] range.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} xy - The X,Y coordinates of the normal.
 * @return {Node<vec3>} The resulting normal.
 */ const $d89c9137a3d237c2$var$unpackNormal = (xy)=>$d89c9137a3d237c2$var$vec3(xy, $d89c9137a3d237c2$var$sqrt($d89c9137a3d237c2$var$saturate($d89c9137a3d237c2$var$float(1.0).sub($d89c9137a3d237c2$var$dot(xy, xy)))));
/**
 * This class can be used for applying normals maps to materials.
 *
 * ```js
 * material.normalNode = normalMap( texture( normalTex ) );
 * ```
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$3561fb9303e3f13f extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'NormalMapNode';
    }
    /**
	 * Constructs a new normal map node.
	 *
	 * @param {Node<vec3>} node - Represents the normal map data.
	 * @param {?Node<vec2>} [scaleNode=null] - Controls the intensity of the effect.
	 */ constructor(node, scaleNode = null){
        super('vec3');
        /**
		 * Represents the normal map data.
		 *
		 * @type {Node<vec3>}
		 */ this.node = node;
        /**
		 * Controls the intensity of the effect.
		 *
		 * @type {?Node<vec2>}
		 * @default null
		 */ this.scaleNode = scaleNode;
        /**
		 * The normal map type.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = (0, $329ek.TangentSpaceNormalMap);
        /**
		 * Controls how to unpack the sampled normal map values.
		 *
		 * @type {string}
		 * @default NoNormalPacking
		 */ this.unpackNormalMode = (0, $329ek.NoNormalPacking);
    }
    setup({ material: material }) {
        const { normalMapType: normalMapType, scaleNode: scaleNode, unpackNormalMode: unpackNormalMode } = this;
        let normalMap = this.node.mul(2.0).sub(1.0);
        if (normalMapType === (0, $329ek.TangentSpaceNormalMap)) {
            if (unpackNormalMode === (0, $329ek.NormalRGPacking)) normalMap = $d89c9137a3d237c2$var$unpackNormal(normalMap.xy);
            else if (unpackNormalMode === (0, $329ek.NormalGAPacking)) normalMap = $d89c9137a3d237c2$var$unpackNormal(normalMap.yw);
            else if (unpackNormalMode !== (0, $329ek.NoNormalPacking)) console.error(`THREE.NodeMaterial: Unexpected unpack normal mode: ${unpackNormalMode}`);
        } else if (unpackNormalMode !== (0, $329ek.NoNormalPacking)) console.error(`THREE.NodeMaterial: Normal map type '${normalMapType}' is not compatible with unpack normal mode '${unpackNormalMode}'`);
        if (scaleNode !== null) {
            let scale = scaleNode;
            if (material.flatShading === true) scale = $d89c9137a3d237c2$var$directionToFaceDirection(scale);
            normalMap = $d89c9137a3d237c2$var$vec3(normalMap.xy.mul(scale), normalMap.z);
        }
        let output = null;
        if (normalMapType === (0, $329ek.ObjectSpaceNormalMap)) output = $d89c9137a3d237c2$var$transformNormalToView(normalMap);
        else if (normalMapType === (0, $329ek.TangentSpaceNormalMap)) output = $d89c9137a3d237c2$var$TBNViewMatrix.mul(normalMap).normalize();
        else {
            (0, $329ek.error)(`NodeMaterial: Unsupported normal map type: ${normalMapType}`);
            output = $d89c9137a3d237c2$var$normalView; // Fallback to default normal view
        }
        return output;
    }
}
/**
 * TSL function for creating a normal map node.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} node - Represents the normal map data.
 * @param {?Node<vec2>} [scaleNode=null] - Controls the intensity of the effect.
 * @returns {NormalMapNode}
 */ const $d89c9137a3d237c2$var$normalMap = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$3561fb9303e3f13f).setParameterLength(1, 2);
// Bump Mapping Unparametrized Surfaces on the GPU by Morten S. Mikkelsen
// https://mmikk.github.io/papers3d/mm_sfgrad_bump.pdf
const $d89c9137a3d237c2$var$dHdxy_fwd = $d89c9137a3d237c2$var$Fn(({ textureNode: textureNode, bumpScale: bumpScale })=>{
    // It's used to preserve the same TextureNode instance
    const sampleTexture = (callback)=>textureNode.isolate().context({
            getUV: (texNode)=>callback(texNode.uvNode || $d89c9137a3d237c2$var$uv$1()),
            forceUVContext: true
        });
    const Hll = $d89c9137a3d237c2$var$float(sampleTexture((uvNode)=>uvNode));
    return $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$float(sampleTexture((uvNode)=>uvNode.add(uvNode.dFdx()))).sub(Hll), $d89c9137a3d237c2$var$float(sampleTexture((uvNode)=>uvNode.add(uvNode.dFdy()))).sub(Hll)).mul(bumpScale);
});
// Evaluate the derivative of the height w.r.t. screen-space using forward differencing (listing 2)
const $d89c9137a3d237c2$var$perturbNormalArb = $d89c9137a3d237c2$var$Fn((inputs)=>{
    const { surf_pos: surf_pos, surf_norm: surf_norm, dHdxy: dHdxy } = inputs;
    // normalize is done to ensure that the bump map looks the same regardless of the texture's scale
    const vSigmaX = surf_pos.dFdx().normalize();
    const vSigmaY = surf_pos.dFdy().normalize();
    const vN = surf_norm; // normalized
    const R1 = vSigmaY.cross(vN);
    const R2 = vN.cross(vSigmaX);
    const fDet = vSigmaX.dot(R1).mul($d89c9137a3d237c2$var$faceDirection);
    const vGrad = fDet.sign().mul(dHdxy.x.mul(R1).add(dHdxy.y.mul(R2)));
    return fDet.abs().mul(surf_norm).sub(vGrad).normalize();
});
/**
 * This class can be used for applying bump maps to materials.
 *
 * ```js
 * material.normalNode = bumpMap( texture( bumpTex ) );
 * ```
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$e4fc1565ab09c32f extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'BumpMapNode';
    }
    /**
	 * Constructs a new bump map node.
	 *
	 * @param {Node<float>} textureNode - Represents the bump map data.
	 * @param {?Node<float>} [scaleNode=null] - Controls the intensity of the bump effect.
	 */ constructor(textureNode, scaleNode = null){
        super('vec3');
        /**
		 * Represents the bump map data.
		 *
		 * @type {Node<float>}
		 */ this.textureNode = textureNode;
        /**
		 * Controls the intensity of the bump effect.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.scaleNode = scaleNode;
    }
    setup() {
        const bumpScale = this.scaleNode !== null ? this.scaleNode : 1;
        const dHdxy = $d89c9137a3d237c2$var$dHdxy_fwd({
            textureNode: this.textureNode,
            bumpScale: bumpScale
        });
        return $d89c9137a3d237c2$var$perturbNormalArb({
            surf_pos: $d89c9137a3d237c2$var$positionView,
            surf_norm: $d89c9137a3d237c2$var$normalView,
            dHdxy: dHdxy
        });
    }
}
/**
 * TSL function for creating a bump map node.
 *
 * @tsl
 * @function
 * @param {Node<float>} textureNode - Represents the bump map data.
 * @param {?Node<float>} [scaleNode=null] - Controls the intensity of the bump effect.
 * @returns {BumpMapNode}
 */ const $d89c9137a3d237c2$var$bumpMap = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$e4fc1565ab09c32f).setParameterLength(1, 2);
const $d89c9137a3d237c2$var$_propertyCache = new Map();
/**
 * This class should simplify the node access to material properties.
 * It internal uses reference nodes to make sure  changes to material
 * properties are automatically reflected to predefined TSL objects
 * like e.g. `materialColor`.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$555471af30279064 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'MaterialNode';
    }
    /**
	 * Constructs a new material node.
	 *
	 * @param {string} scope - The scope defines what kind of material property is referred by the node.
	 */ constructor(scope){
        super();
        /**
		 * The scope defines what material property is referred by the node.
		 *
		 * @type {string}
		 */ this.scope = scope;
    }
    /**
	 * Returns a cached reference node for the given property and type.
	 *
	 * @param {string} property - The name of the material property.
	 * @param {string} type - The uniform type of the property.
	 * @return {MaterialReferenceNode} A material reference node representing the property access.
	 */ getCache(property, type) {
        let node = $d89c9137a3d237c2$var$_propertyCache.get(property);
        if (node === undefined) {
            node = $d89c9137a3d237c2$var$materialReference(property, type);
            $d89c9137a3d237c2$var$_propertyCache.set(property, node);
        }
        return node;
    }
    /**
	 * Returns a float-typed material reference node for the given property name.
	 *
	 * @param {string} property - The name of the material property.
	 * @return {MaterialReferenceNode<float>} A material reference node representing the property access.
	 */ getFloat(property) {
        return this.getCache(property, 'float');
    }
    /**
	 * Returns a color-typed material reference node for the given property name.
	 *
	 * @param {string} property - The name of the material property.
	 * @return {MaterialReferenceNode<color>} A material reference node representing the property access.
	 */ getColor(property) {
        return this.getCache(property, 'color');
    }
    /**
	 * Returns a texture-typed material reference node for the given property name.
	 *
	 * @param {string} property - The name of the material property.
	 * @return {MaterialReferenceNode} A material reference node representing the property access.
	 */ getTexture(property) {
        return this.getCache(property === 'map' ? 'map' : property + 'Map', 'texture');
    }
    /**
	 * The node setup is done depending on the selected scope. Multiple material properties
	 * might be grouped into a single node composition if they logically belong together.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node} The node representing the selected scope.
	 */ setup(builder) {
        const material = builder.context.material;
        const scope = this.scope;
        let node = null;
        if (scope === $d89c9137a3d237c2$export$555471af30279064.COLOR) {
            const colorNode = material.color !== undefined ? this.getColor(scope) : $d89c9137a3d237c2$var$vec3();
            if (material.map && material.map.isTexture === true) node = colorNode.mul(this.getTexture('map'));
            else node = colorNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.OPACITY) {
            const opacityNode = this.getFloat(scope);
            if (material.alphaMap && material.alphaMap.isTexture === true) node = opacityNode.mul(this.getTexture('alpha'));
            else node = opacityNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.SPECULAR_STRENGTH) {
            if (material.specularMap && material.specularMap.isTexture === true) node = this.getTexture('specular').r;
            else node = $d89c9137a3d237c2$var$float(1);
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.SPECULAR_INTENSITY) {
            const specularIntensityNode = this.getFloat(scope);
            if (material.specularIntensityMap && material.specularIntensityMap.isTexture === true) node = specularIntensityNode.mul(this.getTexture(scope).a);
            else node = specularIntensityNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.SPECULAR_COLOR) {
            const specularColorNode = this.getColor(scope);
            if (material.specularColorMap && material.specularColorMap.isTexture === true) node = specularColorNode.mul(this.getTexture(scope).rgb);
            else node = specularColorNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.ROUGHNESS) {
            const roughnessNode = this.getFloat(scope);
            if (material.roughnessMap && material.roughnessMap.isTexture === true) node = roughnessNode.mul(this.getTexture(scope).g);
            else node = roughnessNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.METALNESS) {
            const metalnessNode = this.getFloat(scope);
            if (material.metalnessMap && material.metalnessMap.isTexture === true) node = metalnessNode.mul(this.getTexture(scope).b);
            else node = metalnessNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.EMISSIVE) {
            const emissiveIntensityNode = this.getFloat('emissiveIntensity');
            const emissiveNode = this.getColor(scope).mul(emissiveIntensityNode);
            if (material.emissiveMap && material.emissiveMap.isTexture === true) node = emissiveNode.mul(this.getTexture(scope));
            else node = emissiveNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.NORMAL) {
            if (material.normalMap) {
                node = $d89c9137a3d237c2$var$normalMap(this.getTexture('normal'), this.getCache('normalScale', 'vec2'));
                node.normalMapType = material.normalMapType;
                if (material.normalMap.format == (0, $329ek.RGFormat) || material.normalMap.format == (0, $329ek.RED_GREEN_RGTC2_Format) || material.normalMap.format == (0, $329ek.RG11_EAC_Format)) node.unpackNormalMode = (0, $329ek.NormalRGPacking);
            } else if (material.bumpMap) node = $d89c9137a3d237c2$var$bumpMap(this.getTexture('bump').r, this.getFloat('bumpScale'));
            else node = $d89c9137a3d237c2$var$normalView;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.CLEARCOAT) {
            const clearcoatNode = this.getFloat(scope);
            if (material.clearcoatMap && material.clearcoatMap.isTexture === true) node = clearcoatNode.mul(this.getTexture(scope).r);
            else node = clearcoatNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.CLEARCOAT_ROUGHNESS) {
            const clearcoatRoughnessNode = this.getFloat(scope);
            if (material.clearcoatRoughnessMap && material.clearcoatRoughnessMap.isTexture === true) node = clearcoatRoughnessNode.mul(this.getTexture(scope).r);
            else node = clearcoatRoughnessNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.CLEARCOAT_NORMAL) {
            if (material.clearcoatNormalMap) node = $d89c9137a3d237c2$var$normalMap(this.getTexture(scope), this.getCache(scope + 'Scale', 'vec2'));
            else node = $d89c9137a3d237c2$var$normalView;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.SHEEN) {
            const sheenNode = this.getColor('sheenColor').mul(this.getFloat('sheen')); // Move this mul() to CPU
            if (material.sheenColorMap && material.sheenColorMap.isTexture === true) node = sheenNode.mul(this.getTexture('sheenColor').rgb);
            else node = sheenNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.SHEEN_ROUGHNESS) {
            const sheenRoughnessNode = this.getFloat(scope);
            if (material.sheenRoughnessMap && material.sheenRoughnessMap.isTexture === true) node = sheenRoughnessNode.mul(this.getTexture(scope).a);
            else node = sheenRoughnessNode;
            node = node.clamp(0.0001, 1.0);
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.ANISOTROPY) {
            if (material.anisotropyMap && material.anisotropyMap.isTexture === true) {
                const anisotropyPolar = this.getTexture(scope);
                const anisotropyMat = $d89c9137a3d237c2$var$mat2($d89c9137a3d237c2$var$materialAnisotropyVector.x, $d89c9137a3d237c2$var$materialAnisotropyVector.y, $d89c9137a3d237c2$var$materialAnisotropyVector.y.negate(), $d89c9137a3d237c2$var$materialAnisotropyVector.x);
                node = anisotropyMat.mul(anisotropyPolar.rg.mul(2.0).sub($d89c9137a3d237c2$var$vec2(1.0)).normalize().mul(anisotropyPolar.b));
            } else node = $d89c9137a3d237c2$var$materialAnisotropyVector;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.IRIDESCENCE_THICKNESS) {
            const iridescenceThicknessMaximum = $d89c9137a3d237c2$var$reference('1', 'float', material.iridescenceThicknessRange);
            if (material.iridescenceThicknessMap) {
                const iridescenceThicknessMinimum = $d89c9137a3d237c2$var$reference('0', 'float', material.iridescenceThicknessRange);
                node = iridescenceThicknessMaximum.sub(iridescenceThicknessMinimum).mul(this.getTexture(scope).g).add(iridescenceThicknessMinimum);
            } else node = iridescenceThicknessMaximum;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.TRANSMISSION) {
            const transmissionNode = this.getFloat(scope);
            if (material.transmissionMap) node = transmissionNode.mul(this.getTexture(scope).r);
            else node = transmissionNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.THICKNESS) {
            const thicknessNode = this.getFloat(scope);
            if (material.thicknessMap) node = thicknessNode.mul(this.getTexture(scope).g);
            else node = thicknessNode;
        } else if (scope === $d89c9137a3d237c2$export$555471af30279064.IOR) node = this.getFloat(scope);
        else if (scope === $d89c9137a3d237c2$export$555471af30279064.LIGHT_MAP) node = this.getTexture(scope).rgb.mul(this.getFloat('lightMapIntensity'));
        else if (scope === $d89c9137a3d237c2$export$555471af30279064.AO) node = this.getTexture(scope).r.sub(1.0).mul(this.getFloat('aoMapIntensity')).add(1.0);
        else if (scope === $d89c9137a3d237c2$export$555471af30279064.LINE_DASH_OFFSET) node = material.dashOffset ? this.getFloat(scope) : $d89c9137a3d237c2$var$float(0);
        else {
            const outputType = this.getNodeType(builder);
            node = this.getCache(scope, outputType);
        }
        return node;
    }
}
$d89c9137a3d237c2$export$555471af30279064.ALPHA_TEST = 'alphaTest';
$d89c9137a3d237c2$export$555471af30279064.COLOR = 'color';
$d89c9137a3d237c2$export$555471af30279064.OPACITY = 'opacity';
$d89c9137a3d237c2$export$555471af30279064.SHININESS = 'shininess';
$d89c9137a3d237c2$export$555471af30279064.SPECULAR = 'specular';
$d89c9137a3d237c2$export$555471af30279064.SPECULAR_STRENGTH = 'specularStrength';
$d89c9137a3d237c2$export$555471af30279064.SPECULAR_INTENSITY = 'specularIntensity';
$d89c9137a3d237c2$export$555471af30279064.SPECULAR_COLOR = 'specularColor';
$d89c9137a3d237c2$export$555471af30279064.REFLECTIVITY = 'reflectivity';
$d89c9137a3d237c2$export$555471af30279064.ROUGHNESS = 'roughness';
$d89c9137a3d237c2$export$555471af30279064.METALNESS = 'metalness';
$d89c9137a3d237c2$export$555471af30279064.NORMAL = 'normal';
$d89c9137a3d237c2$export$555471af30279064.CLEARCOAT = 'clearcoat';
$d89c9137a3d237c2$export$555471af30279064.CLEARCOAT_ROUGHNESS = 'clearcoatRoughness';
$d89c9137a3d237c2$export$555471af30279064.CLEARCOAT_NORMAL = 'clearcoatNormal';
$d89c9137a3d237c2$export$555471af30279064.EMISSIVE = 'emissive';
$d89c9137a3d237c2$export$555471af30279064.ROTATION = 'rotation';
$d89c9137a3d237c2$export$555471af30279064.SHEEN = 'sheen';
$d89c9137a3d237c2$export$555471af30279064.SHEEN_ROUGHNESS = 'sheenRoughness';
$d89c9137a3d237c2$export$555471af30279064.ANISOTROPY = 'anisotropy';
$d89c9137a3d237c2$export$555471af30279064.IRIDESCENCE = 'iridescence';
$d89c9137a3d237c2$export$555471af30279064.IRIDESCENCE_IOR = 'iridescenceIOR';
$d89c9137a3d237c2$export$555471af30279064.IRIDESCENCE_THICKNESS = 'iridescenceThickness';
$d89c9137a3d237c2$export$555471af30279064.IOR = 'ior';
$d89c9137a3d237c2$export$555471af30279064.TRANSMISSION = 'transmission';
$d89c9137a3d237c2$export$555471af30279064.THICKNESS = 'thickness';
$d89c9137a3d237c2$export$555471af30279064.ATTENUATION_DISTANCE = 'attenuationDistance';
$d89c9137a3d237c2$export$555471af30279064.ATTENUATION_COLOR = 'attenuationColor';
$d89c9137a3d237c2$export$555471af30279064.LINE_SCALE = 'scale';
$d89c9137a3d237c2$export$555471af30279064.LINE_DASH_SIZE = 'dashSize';
$d89c9137a3d237c2$export$555471af30279064.LINE_GAP_SIZE = 'gapSize';
$d89c9137a3d237c2$export$555471af30279064.LINE_WIDTH = 'linewidth';
$d89c9137a3d237c2$export$555471af30279064.LINE_DASH_OFFSET = 'dashOffset';
$d89c9137a3d237c2$export$555471af30279064.POINT_SIZE = 'size';
$d89c9137a3d237c2$export$555471af30279064.DISPERSION = 'dispersion';
$d89c9137a3d237c2$export$555471af30279064.LIGHT_MAP = 'light';
$d89c9137a3d237c2$export$555471af30279064.AO = 'ao';
/**
 * TSL object that represents alpha test of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialAlphaTest = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.ALPHA_TEST);
/**
 * TSL object that represents the diffuse color of the current material.
 * The value is composed via `color` * `map`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$materialColor = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.COLOR);
/**
 * TSL object that represents the shininess of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialShininess = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.SHININESS);
/**
 * TSL object that represents the emissive color of the current material.
 * The value is composed via `emissive` * `emissiveIntensity` * `emissiveMap`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$materialEmissive = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.EMISSIVE);
/**
 * TSL object that represents the opacity of the current material.
 * The value is composed via `opacity` * `alphaMap`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialOpacity = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.OPACITY);
/**
 * TSL object that represents the specular of the current material.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$materialSpecular = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.SPECULAR);
/**
 * TSL object that represents the specular intensity of the current material.
 * The value is composed via `specularIntensity` * `specularMap.a`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialSpecularIntensity = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.SPECULAR_INTENSITY);
/**
 * TSL object that represents the specular color of the current material.
 * The value is composed via `specularColor` * `specularMap.rgb`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$materialSpecularColor = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.SPECULAR_COLOR);
/**
 * TSL object that represents the specular strength of the current material.
 * The value is composed via `specularMap.r`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialSpecularStrength = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.SPECULAR_STRENGTH);
/**
 * TSL object that represents the reflectivity of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialReflectivity = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.REFLECTIVITY);
/**
 * TSL object that represents the roughness of the current material.
 * The value is composed via `roughness` * `roughnessMap.g`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialRoughness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.ROUGHNESS);
/**
 * TSL object that represents the metalness of the current material.
 * The value is composed via `metalness` * `metalnessMap.b`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialMetalness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.METALNESS);
/**
 * TSL object that represents the normal of the current material.
 * The value will be either `normalMap` * `normalScale`, `bumpMap` * `bumpScale` or `normalView`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$materialNormal = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.NORMAL);
/**
 * TSL object that represents the clearcoat of the current material.
 * The value is composed via `clearcoat` * `clearcoatMap.r`
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialClearcoat = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.CLEARCOAT);
/**
 * TSL object that represents the clearcoat roughness of the current material.
 * The value is composed via `clearcoatRoughness` * `clearcoatRoughnessMap.r`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialClearcoatRoughness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.CLEARCOAT_ROUGHNESS);
/**
 * TSL object that represents the clearcoat normal of the current material.
 * The value will be either `clearcoatNormalMap` or `normalView`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$materialClearcoatNormal = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.CLEARCOAT_NORMAL);
/**
 * TSL object that represents the rotation of the current sprite material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialRotation = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.ROTATION);
/**
 * TSL object that represents the sheen color of the current material.
 * The value is composed via `sheen` * `sheenColor` * `sheenColorMap`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$materialSheen = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.SHEEN);
/**
 * TSL object that represents the sheen roughness of the current material.
 * The value is composed via `sheenRoughness` * `sheenRoughnessMap.a`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialSheenRoughness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.SHEEN_ROUGHNESS);
/**
 * TSL object that represents the anisotropy of the current material.
 *
 * @tsl
 * @type {Node<vec2>}
 */ const $d89c9137a3d237c2$var$materialAnisotropy = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.ANISOTROPY);
/**
 * TSL object that represents the iridescence of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialIridescence = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.IRIDESCENCE);
/**
 * TSL object that represents the iridescence IOR of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialIridescenceIOR = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.IRIDESCENCE_IOR);
/**
 * TSL object that represents the iridescence thickness of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialIridescenceThickness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.IRIDESCENCE_THICKNESS);
/**
 * TSL object that represents the transmission of the current material.
 * The value is composed via `transmission` * `transmissionMap.r`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialTransmission = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.TRANSMISSION);
/**
 * TSL object that represents the thickness of the current material.
 * The value is composed via `thickness` * `thicknessMap.g`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialThickness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.THICKNESS);
/**
 * TSL object that represents the IOR of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialIOR = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.IOR);
/**
 * TSL object that represents the attenuation distance of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialAttenuationDistance = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.ATTENUATION_DISTANCE);
/**
 * TSL object that represents the attenuation color of the current material.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$materialAttenuationColor = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.ATTENUATION_COLOR);
/**
 * TSL object that represents the scale of the current dashed line material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialLineScale = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.LINE_SCALE);
/**
 * TSL object that represents the dash size of the current dashed line material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialLineDashSize = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.LINE_DASH_SIZE);
/**
 * TSL object that represents the gap size of the current dashed line material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialLineGapSize = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.LINE_GAP_SIZE);
/**
 * TSL object that represents the line width of the current line material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialLineWidth = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.LINE_WIDTH);
/**
 * TSL object that represents the dash offset of the current line material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialLineDashOffset = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.LINE_DASH_OFFSET);
/**
 * TSL object that represents the point size of the current points material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialPointSize = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.POINT_SIZE);
/**
 * TSL object that represents the dispersion of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialDispersion = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.DISPERSION);
/**
 * TSL object that represents the light map of the current material.
 * The value is composed via `lightMapIntensity` * `lightMap.rgb`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$materialLightMap = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.LIGHT_MAP);
/**
 * TSL object that represents the ambient occlusion map of the current material.
 * The value is composed via `aoMap.r` - 1 * `aoMapIntensity` + 1.
 *
 * @tsl
 * @type {Node<float>}
 */ const $d89c9137a3d237c2$var$materialAO = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$555471af30279064, $d89c9137a3d237c2$export$555471af30279064.AO);
/**
 * TSL object that represents the anisotropy vector of the current material.
 *
 * @tsl
 * @type {Node<vec2>}
 */ const $d89c9137a3d237c2$var$materialAnisotropyVector = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform(new (0, $329ek.Vector2)()).onReference(function(frame) {
    return frame.material;
}).onRenderUpdate(function({ material: material }) {
    this.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
});
/**
 * TSL object that represents the position in clip space after the model-view-projection transform of the current rendered object.
 *
 * @tsl
 * @type {VaryingNode<vec4>}
 */ const $d89c9137a3d237c2$var$modelViewProjection = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((builder)=>{
    return builder.context.setupModelViewProjection();
}, 'vec4').once()().toVarying('v_modelViewProjection');
/**
 * This class enables element access on instances of {@link StorageBufferNode}.
 * In most cases, it is indirectly used when accessing elements with the
 * {@link StorageBufferNode#element} method.
 *
 * ```js
 * const position = positionStorage.element( instanceIndex );
 * ```
 *
 * @augments ArrayElementNode
 */ class $d89c9137a3d237c2$export$24f341c51db48ae0 extends $d89c9137a3d237c2$export$f2edd1d22bf6d00b {
    static get type() {
        return 'StorageArrayElementNode';
    }
    /**
	 * Constructs storage buffer element node.
	 *
	 * @param {StorageBufferNode} storageBufferNode - The storage buffer node.
	 * @param {Node} indexNode - The index node that defines the element access.
	 */ constructor(storageBufferNode, indexNode){
        super(storageBufferNode, indexNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageArrayElementNode = true;
    }
    /**
	 * The storage buffer node.
	 *
	 * @param {Node} value
	 * @type {StorageBufferNode}
	 */ set storageBufferNode(value) {
        this.node = value;
    }
    get storageBufferNode() {
        return this.node;
    }
    getMemberType(builder, name) {
        const structTypeNode = this.storageBufferNode.structTypeNode;
        if (structTypeNode) return structTypeNode.getMemberType(builder, name);
        return 'void';
    }
    setup(builder) {
        if (builder.isAvailable('storageBuffer') === false) {
            if (this.node.isPBO === true) builder.setupPBO(this.node);
        }
        return super.setup(builder);
    }
    generate(builder, output) {
        let snippet;
        const isAssignContext = builder.context.assign;
        //
        if (builder.isAvailable('storageBuffer') === false) {
            if (this.node.isPBO === true && isAssignContext !== true && (this.node.value.isInstancedBufferAttribute || builder.shaderStage !== 'compute')) snippet = builder.generatePBO(this);
            else snippet = this.node.build(builder);
        } else snippet = super.generate(builder);
        if (isAssignContext !== true) {
            const type = this.getNodeType(builder);
            snippet = builder.format(snippet, type, output);
        }
        return snippet;
    }
}
/**
 * TSL function for creating a storage element node.
 *
 * @tsl
 * @function
 * @param {StorageBufferNode} storageBufferNode - The storage buffer node.
 * @param {Node} indexNode - The index node that defines the element access.
 * @returns {StorageArrayElementNode}
 */ const $d89c9137a3d237c2$var$storageElement = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$24f341c51db48ae0).setParameterLength(2);
/**
 * This node is used in context of compute shaders and allows to define a
 * storage buffer for data. A typical workflow is to create instances of
 * this node with the convenience functions `attributeArray()` or `instancedArray()`,
 * setup up a compute shader that writes into the buffers and then convert
 * the storage buffers to attribute nodes for rendering.
 *
 * ```js
 * const positionBuffer = instancedArray( particleCount, 'vec3' ); // the storage buffer node
 *
 * const computeInit = Fn( () => { // the compute shader
 *
 * 	const position = positionBuffer.element( instanceIndex );
 *
 * 	// compute position data
 *
 * 	position.x = 1;
 * 	position.y = 1;
 * 	position.z = 1;
 *
 * } )().compute( particleCount );
 *
 * const particleMaterial = new THREE.SpriteNodeMaterial();
 * particleMaterial.positionNode = positionBuffer.toAttribute();
 *
 * renderer.computeAsync( computeInit );
 *
 * ```
 *
 * @augments BufferNode
 */ class $d89c9137a3d237c2$export$d52c9b844d447cca extends $d89c9137a3d237c2$export$715e91fa835e6409 {
    static get type() {
        return 'StorageBufferNode';
    }
    /**
	 * Constructs a new storage buffer node.
	 *
	 * @param {StorageBufferAttribute|StorageInstancedBufferAttribute|BufferAttribute} value - The buffer data.
	 * @param {?(string|Struct)} [bufferType=null] - The buffer type (e.g. `'vec3'`).
	 * @param {number} [bufferCount=0] - The buffer count.
	 */ constructor(value, bufferType = null, bufferCount = 0){
        let nodeType, structTypeNode = null;
        if (bufferType && bufferType.isStruct) {
            nodeType = 'struct';
            structTypeNode = bufferType.layout;
            if (value.isStorageBufferAttribute || value.isStorageInstancedBufferAttribute) bufferCount = value.count;
        } else if (bufferType === null && (value.isStorageBufferAttribute || value.isStorageInstancedBufferAttribute)) {
            nodeType = $d89c9137a3d237c2$var$getTypeFromLength(value.itemSize);
            bufferCount = value.count;
        } else nodeType = bufferType;
        super(value, nodeType, bufferCount);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageBufferNode = true;
        /**
		 * The buffer struct type.
		 *
		 * @type {?StructTypeNode}
		 * @default null
		 */ this.structTypeNode = structTypeNode;
        /**
		 * The access type of the texture node.
		 *
		 * @type {string}
		 * @default 'readWrite'
		 */ this.access = $d89c9137a3d237c2$export$92538c74c63a703d.READ_WRITE;
        /**
		 * Whether the node is atomic or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.isAtomic = false;
        /**
		 * Whether the node represents a PBO or not.
		 * Only relevant for WebGL.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.isPBO = false;
        /**
		 * A reference to the internal buffer attribute node.
		 *
		 * @private
		 * @type {?BufferAttributeNode}
		 * @default null
		 */ this._attribute = null;
        /**
		 * A reference to the internal varying node.
		 *
		 * @private
		 * @type {?VaryingNode}
		 * @default null
		 */ this._varying = null;
        /**
		 * `StorageBufferNode` sets this property to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
        if (value.isStorageBufferAttribute !== true && value.isStorageInstancedBufferAttribute !== true) {
            // TODO: Improve it, possibly adding a new property to the BufferAttribute to identify it as a storage buffer read-only attribute in Renderer
            if (value.isInstancedBufferAttribute) value.isStorageInstancedBufferAttribute = true;
            else value.isStorageBufferAttribute = true;
        }
    }
    /**
	 * This method is overwritten since the buffer data might be shared
	 * and thus the hash should be shared as well.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The hash.
	 */ getHash(builder) {
        if (this.bufferCount === 0) {
            let bufferData = builder.globalCache.getData(this.value);
            if (bufferData === undefined) {
                bufferData = {
                    node: this
                };
                builder.globalCache.setData(this.value, bufferData);
            }
            return bufferData.node.uuid;
        }
        return this.uuid;
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'indirectStorageBuffer'` or `'storageBuffer'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return this.value.isIndirectStorageBufferAttribute ? 'indirectStorageBuffer' : 'storageBuffer';
    }
    /**
	 * Enables element access with the given index node.
	 *
	 * @param {IndexNode} indexNode - The index node.
	 * @return {StorageArrayElementNode} A node representing the element access.
	 */ element(indexNode) {
        return $d89c9137a3d237c2$var$storageElement(this, indexNode);
    }
    /**
	 * Defines whether this node is a PBO or not. Only relevant for WebGL.
	 *
	 * @param {boolean} value - The value so set.
	 * @return {StorageBufferNode} A reference to this node.
	 */ setPBO(value) {
        this.isPBO = value;
        return this;
    }
    /**
	 * Returns the `isPBO` value.
	 *
	 * @return {boolean} Whether the node represents a PBO or not.
	 */ getPBO() {
        return this.isPBO;
    }
    /**
	 * Defines the node access.
	 *
	 * @param {string} value - The node access.
	 * @return {StorageBufferNode} A reference to this node.
	 */ setAccess(value) {
        this.access = value;
        return this;
    }
    /**
	 * Convenience method for configuring a read-only node access.
	 *
	 * @return {StorageBufferNode} A reference to this node.
	 */ toReadOnly() {
        return this.setAccess($d89c9137a3d237c2$export$92538c74c63a703d.READ_ONLY);
    }
    /**
	 * Defines whether the node is atomic or not.
	 *
	 * @param {boolean} value - The atomic flag.
	 * @return {StorageBufferNode} A reference to this node.
	 */ setAtomic(value) {
        this.isAtomic = value;
        return this;
    }
    /**
	 * Convenience method for making this node atomic.
	 *
	 * @return {StorageBufferNode} A reference to this node.
	 */ toAtomic() {
        return this.setAtomic(true);
    }
    /**
	 * Returns attribute data for this storage buffer node.
	 *
	 * @return {{attribute: BufferAttributeNode, varying: VaryingNode}} The attribute data.
	 */ getAttributeData() {
        if (this._attribute === null) {
            this._attribute = $d89c9137a3d237c2$var$bufferAttribute(this.value);
            this._varying = $d89c9137a3d237c2$var$varying(this._attribute);
        }
        return {
            attribute: this._attribute,
            varying: this._varying
        };
    }
    /**
	 * This method is overwritten since the node type from the availability of storage buffers
	 * and the attribute data.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        if (this.structTypeNode !== null) return this.structTypeNode.getNodeType(builder);
        if (builder.isAvailable('storageBuffer') || builder.isAvailable('indirectStorageBuffer')) return super.getNodeType(builder);
        const { attribute: attribute } = this.getAttributeData();
        return attribute.getNodeType(builder);
    }
    /**
	 * Returns the type of a member of the struct.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The name of the member.
	 * @return {string} The type of the member.
	 */ getMemberType(builder, name) {
        if (this.structTypeNode !== null) return this.structTypeNode.getMemberType(builder, name);
        return 'void';
    }
    /**
	 * Generates the code snippet of the storage buffer node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated code snippet.
	 */ generate(builder) {
        if (this.structTypeNode !== null) this.structTypeNode.build(builder);
        if (builder.isAvailable('storageBuffer') || builder.isAvailable('indirectStorageBuffer')) return super.generate(builder);
        const { attribute: attribute, varying: varying } = this.getAttributeData();
        const output = varying.build(builder);
        builder.registerTransform(output, attribute);
        return output;
    }
}
/**
 * TSL function for creating a storage buffer node.
 *
 * @tsl
 * @function
 * @param {StorageBufferAttribute|StorageInstancedBufferAttribute|BufferAttribute} value - The buffer data.
 * @param {?(string|Struct)} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [count=0] - The buffer count.
 * @returns {StorageBufferNode}
 */ const $d89c9137a3d237c2$var$storage = (value, type = null, count = 0)=>new $d89c9137a3d237c2$export$d52c9b844d447cca(value, type, count);
/**
 * @tsl
 * @function
 * @deprecated since r171. Use `storage().setPBO( true )` instead.
 *
 * @param {StorageBufferAttribute|StorageInstancedBufferAttribute|BufferAttribute} value - The buffer data.
 * @param {?string} type - The buffer type (e.g. `'vec3'`).
 * @param {number} count - The buffer count.
 * @returns {StorageBufferNode}
 */ const $d89c9137a3d237c2$var$storageObject = (value, type, count)=>{
    (0, $329ek.warn)('TSL: "storageObject()" is deprecated. Use "storage().setPBO( true )" instead.');
    return $d89c9137a3d237c2$var$storage(value, type, count).setPBO(true);
};
/**
 * This class represents shader indices of different types. The following predefined node
 * objects cover frequent use cases:
 *
 * - `vertexIndex`: The index of a vertex within a mesh.
 * - `instanceIndex`: The index of either a mesh instance or an invocation of a compute shader.
 * - `drawIndex`: The index of a draw call.
 * - `invocationLocalIndex`: The index of a compute invocation within the scope of a workgroup load.
 * - `invocationSubgroupIndex`: The index of a compute invocation within the scope of a subgroup.
 * - `subgroupIndex`: The index of a compute invocation's subgroup within its workgroup.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$929eaad981940a63 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'IndexNode';
    }
    /**
	 * Constructs a new index node.
	 *
	 * @param {('vertex'|'instance'|'subgroup'|'invocationLocal'|'invocationGlobal'|'invocationSubgroup'|'draw')} scope - The scope of the index node.
	 */ constructor(scope){
        super('uint');
        /**
		 * The scope of the index node.
		 *
		 * @type {string}
		 */ this.scope = scope;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isIndexNode = true;
    }
    generate(builder) {
        const nodeType = this.getNodeType(builder);
        const scope = this.scope;
        let propertyName;
        if (scope === $d89c9137a3d237c2$export$929eaad981940a63.VERTEX) propertyName = builder.getVertexIndex();
        else if (scope === $d89c9137a3d237c2$export$929eaad981940a63.INSTANCE) propertyName = builder.getInstanceIndex();
        else if (scope === $d89c9137a3d237c2$export$929eaad981940a63.DRAW) propertyName = builder.getDrawIndex();
        else if (scope === $d89c9137a3d237c2$export$929eaad981940a63.INVOCATION_LOCAL) propertyName = builder.getInvocationLocalIndex();
        else if (scope === $d89c9137a3d237c2$export$929eaad981940a63.INVOCATION_SUBGROUP) propertyName = builder.getInvocationSubgroupIndex();
        else if (scope === $d89c9137a3d237c2$export$929eaad981940a63.SUBGROUP) propertyName = builder.getSubgroupIndex();
        else throw new Error('THREE.IndexNode: Unknown scope: ' + scope);
        let output;
        if (builder.shaderStage === 'vertex' || builder.shaderStage === 'compute') output = propertyName;
        else {
            const nodeVarying = $d89c9137a3d237c2$var$varying(this);
            output = nodeVarying.build(builder, nodeType);
        }
        return output;
    }
}
$d89c9137a3d237c2$export$929eaad981940a63.VERTEX = 'vertex';
$d89c9137a3d237c2$export$929eaad981940a63.INSTANCE = 'instance';
$d89c9137a3d237c2$export$929eaad981940a63.SUBGROUP = 'subgroup';
$d89c9137a3d237c2$export$929eaad981940a63.INVOCATION_LOCAL = 'invocationLocal';
$d89c9137a3d237c2$export$929eaad981940a63.INVOCATION_SUBGROUP = 'invocationSubgroup';
$d89c9137a3d237c2$export$929eaad981940a63.DRAW = 'draw';
/**
 * TSL object that represents the index of a vertex within a mesh.
 *
 * @tsl
 * @type {IndexNode}
 */ const $d89c9137a3d237c2$var$vertexIndex = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$929eaad981940a63, $d89c9137a3d237c2$export$929eaad981940a63.VERTEX);
/**
 * TSL object that represents the index of either a mesh instance or an invocation of a compute shader.
 *
 * @tsl
 * @type {IndexNode}
 */ const $d89c9137a3d237c2$var$instanceIndex = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$929eaad981940a63, $d89c9137a3d237c2$export$929eaad981940a63.INSTANCE);
/**
 * TSL object that represents the index of the subgroup the current compute invocation belongs to.
 *
 * @tsl
 * @type {IndexNode}
 */ const $d89c9137a3d237c2$var$subgroupIndex = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$929eaad981940a63, $d89c9137a3d237c2$export$929eaad981940a63.SUBGROUP);
/**
 * TSL object that represents the index of a compute invocation within the scope of a subgroup.
 *
 * @tsl
 * @type {IndexNode}
 */ const $d89c9137a3d237c2$var$invocationSubgroupIndex = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$929eaad981940a63, $d89c9137a3d237c2$export$929eaad981940a63.INVOCATION_SUBGROUP);
/**
 * TSL object that represents the index of a compute invocation within the scope of a workgroup load.
 *
 * @tsl
 * @type {IndexNode}
 */ const $d89c9137a3d237c2$var$invocationLocalIndex = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$929eaad981940a63, $d89c9137a3d237c2$export$929eaad981940a63.INVOCATION_LOCAL);
/**
 * TSL object that represents the index of a draw call.
 *
 * @tsl
 * @type {IndexNode}
 */ const $d89c9137a3d237c2$var$drawIndex = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$929eaad981940a63, $d89c9137a3d237c2$export$929eaad981940a63.DRAW);
/**
 * This node implements the vertex shader logic which is required
 * when rendering 3D objects via instancing. The code makes sure
 * vertex positions, normals and colors can be modified via instanced
 * data.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$fe90e00cec29e881 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'InstanceNode';
    }
    /**
	 * Constructs a new instance node.
	 *
	 * @param {number} count - The number of instances.
	 * @param {InstancedBufferAttribute|StorageInstancedBufferAttribute} instanceMatrix - Instanced buffer attribute representing the instance transformations.
	 * @param {?InstancedBufferAttribute|StorageInstancedBufferAttribute} instanceColor - Instanced buffer attribute representing the instance colors.
	 */ constructor(count, instanceMatrix, instanceColor = null){
        super('void');
        /**
		 * The number of instances.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * Instanced buffer attribute representing the transformation of instances.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceMatrix = instanceMatrix;
        /**
		 * Instanced buffer attribute representing the color of instances.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceColor = instanceColor;
        /**
		 * The node that represents the instance matrix data.
		 *
		 * @type {?Node}
		 */ this.instanceMatrixNode = null;
        /**
		 * The node that represents the instance color data.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.instanceColorNode = null;
        /**
		 * The update type is set to `frame` since an update
		 * of instanced buffer data must be checked per frame.
		 *
		 * @type {string}
		 * @default 'frame'
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.FRAME;
        /**
		 * A reference to a buffer that is used by `instanceMatrixNode`.
		 *
		 * @type {?InstancedInterleavedBuffer}
		 */ this.buffer = null;
        /**
		 * A reference to a buffer that is used by `instanceColorNode`.
		 *
		 * @type {?InstancedBufferAttribute}
		 */ this.bufferColor = null;
    }
    /**
	 * Tracks whether the matrix data is provided via a storage buffer.
	 *
	 * @type {boolean}
	 */ get isStorageMatrix() {
        const { instanceMatrix: instanceMatrix } = this;
        return instanceMatrix && instanceMatrix.isStorageInstancedBufferAttribute === true;
    }
    /**
	 * Tracks whether the color data is provided via a storage buffer.
	 *
	 * @type {boolean}
	 */ get isStorageColor() {
        const { instanceColor: instanceColor } = this;
        return instanceColor && instanceColor.isStorageInstancedBufferAttribute === true;
    }
    /**
	 * Setups the internal buffers and nodes and assigns the transformed vertex data
	 * to predefined node variables for accumulation. That follows the same patterns
	 * like with morph and skinning nodes.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        const { instanceMatrix: instanceMatrix, instanceColor: instanceColor, isStorageMatrix: isStorageMatrix, isStorageColor: isStorageColor } = this;
        const { count: count } = instanceMatrix;
        let { instanceMatrixNode: instanceMatrixNode, instanceColorNode: instanceColorNode } = this;
        if (instanceMatrixNode === null) {
            if (isStorageMatrix) instanceMatrixNode = $d89c9137a3d237c2$var$storage(instanceMatrix, 'mat4', Math.max(count, 1)).element($d89c9137a3d237c2$var$instanceIndex);
            else // Both backends have ~64kb UBO limit; fallback to attributes above 1000 matrices.
            if (count <= 1000) instanceMatrixNode = $d89c9137a3d237c2$var$buffer(instanceMatrix.array, 'mat4', Math.max(count, 1)).element($d89c9137a3d237c2$var$instanceIndex);
            else {
                const interleaved = new (0, $329ek.InstancedInterleavedBuffer)(instanceMatrix.array, 16, 1);
                this.buffer = interleaved;
                const bufferFn = instanceMatrix.usage === (0, $329ek.DynamicDrawUsage) ? $d89c9137a3d237c2$var$instancedDynamicBufferAttribute : $d89c9137a3d237c2$var$instancedBufferAttribute;
                const instanceBuffers = [
                    bufferFn(interleaved, 'vec4', 16, 0),
                    bufferFn(interleaved, 'vec4', 16, 4),
                    bufferFn(interleaved, 'vec4', 16, 8),
                    bufferFn(interleaved, 'vec4', 16, 12)
                ];
                instanceMatrixNode = $d89c9137a3d237c2$var$mat4(...instanceBuffers);
            }
            this.instanceMatrixNode = instanceMatrixNode;
        }
        if (instanceColor && instanceColorNode === null) {
            if (isStorageColor) instanceColorNode = $d89c9137a3d237c2$var$storage(instanceColor, 'vec3', Math.max(instanceColor.count, 1)).element($d89c9137a3d237c2$var$instanceIndex);
            else {
                const bufferAttribute = new (0, $329ek.InstancedBufferAttribute)(instanceColor.array, 3);
                const bufferFn = instanceColor.usage === (0, $329ek.DynamicDrawUsage) ? $d89c9137a3d237c2$var$instancedDynamicBufferAttribute : $d89c9137a3d237c2$var$instancedBufferAttribute;
                this.bufferColor = bufferAttribute;
                instanceColorNode = $d89c9137a3d237c2$var$vec3(bufferFn(bufferAttribute, 'vec3', 3, 0));
            }
            this.instanceColorNode = instanceColorNode;
        }
        // POSITION
        const instancePosition = instanceMatrixNode.mul($d89c9137a3d237c2$var$positionLocal).xyz;
        $d89c9137a3d237c2$var$positionLocal.assign(instancePosition);
        // NORMAL
        if (builder.hasGeometryAttribute('normal')) {
            const instanceNormal = $d89c9137a3d237c2$var$transformNormal($d89c9137a3d237c2$var$normalLocal, instanceMatrixNode);
            // ASSIGNS
            $d89c9137a3d237c2$var$normalLocal.assign(instanceNormal);
        }
        // COLOR
        if (this.instanceColorNode !== null) $d89c9137a3d237c2$var$varyingProperty('vec3', 'vInstanceColor').assign(this.instanceColorNode);
    }
    /**
	 * Checks if the internal buffers require an update.
	 *
	 * @param {NodeFrame} frame - The current node frame.
	 */ update() {
        if (this.buffer !== null && this.isStorageMatrix !== true) {
            this.buffer.clearUpdateRanges();
            this.buffer.updateRanges.push(...this.instanceMatrix.updateRanges);
            // update version if necessary
            if (this.instanceMatrix.usage !== (0, $329ek.DynamicDrawUsage) && this.instanceMatrix.version !== this.buffer.version) this.buffer.version = this.instanceMatrix.version;
        }
        if (this.instanceColor && this.bufferColor !== null && this.isStorageColor !== true) {
            this.bufferColor.clearUpdateRanges();
            this.bufferColor.updateRanges.push(...this.instanceColor.updateRanges);
            if (this.instanceColor.usage !== (0, $329ek.DynamicDrawUsage) && this.instanceColor.version !== this.bufferColor.version) this.bufferColor.version = this.instanceColor.version;
        }
    }
}
/**
 * TSL function for creating an instance node.
 *
 * @tsl
 * @function
 * @param {number} count - The number of instances.
 * @param {InstancedBufferAttribute|StorageInstancedBufferAttribute} instanceMatrix - Instanced buffer attribute representing the instance transformations.
 * @param {?InstancedBufferAttribute|StorageInstancedBufferAttribute} instanceColor - Instanced buffer attribute representing the instance colors.
 * @returns {InstanceNode}
 */ const $d89c9137a3d237c2$var$instance = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$fe90e00cec29e881).setParameterLength(2, 3);
/**
 * This is a special version of `InstanceNode` which requires the usage of {@link InstancedMesh}.
 * It allows an easier setup of the instance node.
 *
 * @augments InstanceNode
 */ class $d89c9137a3d237c2$export$85a732d53641b45d extends $d89c9137a3d237c2$export$fe90e00cec29e881 {
    static get type() {
        return 'InstancedMeshNode';
    }
    /**
	 * Constructs a new instanced mesh node.
	 *
	 * @param {InstancedMesh} instancedMesh - The instanced mesh.
	 */ constructor(instancedMesh){
        const { count: count, instanceMatrix: instanceMatrix, instanceColor: instanceColor } = instancedMesh;
        super(count, instanceMatrix, instanceColor);
        /**
		 * A reference to the instanced mesh.
		 *
		 * @type {InstancedMesh}
		 */ this.instancedMesh = instancedMesh;
    }
}
/**
 * TSL function for creating an instanced mesh node.
 *
 * @tsl
 * @function
 * @param {InstancedMesh} instancedMesh - The instancedMesh.
 * @returns {InstancedMeshNode}
 */ const $d89c9137a3d237c2$var$instancedMesh = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$85a732d53641b45d).setParameterLength(1);
/**
 * This node implements the vertex shader logic which is required
 * when rendering 3D objects via batching. `BatchNode` must be used
 * with instances of {@link BatchedMesh}.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$34fa8d2809c0a555 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'BatchNode';
    }
    /**
	 * Constructs a new batch node.
	 *
	 * @param {BatchedMesh} batchMesh - A reference to batched mesh.
	 */ constructor(batchMesh){
        super('void');
        /**
		 * A reference to batched mesh.
		 *
		 * @type {BatchedMesh}
		 */ this.batchMesh = batchMesh;
        /**
		 * The batching index node.
		 *
		 * @type {?IndexNode}
		 * @default null
		 */ this.batchingIdNode = null;
    }
    /**
	 * Setups the internal buffers and nodes and assigns the transformed vertex data
	 * to predefined node variables for accumulation. That follows the same patterns
	 * like with morph and skinning nodes.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        if (this.batchingIdNode === null) {
            if (builder.getDrawIndex() === null) this.batchingIdNode = $d89c9137a3d237c2$var$instanceIndex;
            else this.batchingIdNode = $d89c9137a3d237c2$var$drawIndex;
        }
        const getIndirectIndex = $d89c9137a3d237c2$var$Fn(([id])=>{
            const size = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$textureSize($d89c9137a3d237c2$var$textureLoad(this.batchMesh._indirectTexture), 0).x).toConst();
            const x = $d89c9137a3d237c2$var$int(id).mod(size).toConst();
            const y = $d89c9137a3d237c2$var$int(id).div(size).toConst();
            return $d89c9137a3d237c2$var$textureLoad(this.batchMesh._indirectTexture, $d89c9137a3d237c2$var$ivec2(x, y)).x;
        }).setLayout({
            name: 'getIndirectIndex',
            type: 'uint',
            inputs: [
                {
                    name: 'id',
                    type: 'int'
                }
            ]
        });
        const indirectId = getIndirectIndex($d89c9137a3d237c2$var$int(this.batchingIdNode));
        const matricesTexture = this.batchMesh._matricesTexture;
        const size = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$textureSize($d89c9137a3d237c2$var$textureLoad(matricesTexture), 0).x).toConst();
        const j = $d89c9137a3d237c2$var$float(indirectId).mul(4).toInt().toConst();
        const x = j.mod(size).toConst();
        const y = j.div(size).toConst();
        const batchingMatrix = $d89c9137a3d237c2$var$mat4($d89c9137a3d237c2$var$textureLoad(matricesTexture, $d89c9137a3d237c2$var$ivec2(x, y)), $d89c9137a3d237c2$var$textureLoad(matricesTexture, $d89c9137a3d237c2$var$ivec2(x.add(1), y)), $d89c9137a3d237c2$var$textureLoad(matricesTexture, $d89c9137a3d237c2$var$ivec2(x.add(2), y)), $d89c9137a3d237c2$var$textureLoad(matricesTexture, $d89c9137a3d237c2$var$ivec2(x.add(3), y)));
        const colorsTexture = this.batchMesh._colorsTexture;
        if (colorsTexture !== null) {
            const getBatchingColor = $d89c9137a3d237c2$var$Fn(([id])=>{
                const size = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$textureSize($d89c9137a3d237c2$var$textureLoad(colorsTexture), 0).x).toConst();
                const j = id;
                const x = j.mod(size).toConst();
                const y = j.div(size).toConst();
                return $d89c9137a3d237c2$var$textureLoad(colorsTexture, $d89c9137a3d237c2$var$ivec2(x, y)).rgb;
            }).setLayout({
                name: 'getBatchingColor',
                type: 'vec3',
                inputs: [
                    {
                        name: 'id',
                        type: 'int'
                    }
                ]
            });
            const color = getBatchingColor(indirectId);
            $d89c9137a3d237c2$var$varyingProperty('vec3', 'vBatchColor').assign(color);
        }
        const bm = $d89c9137a3d237c2$var$mat3(batchingMatrix);
        $d89c9137a3d237c2$var$positionLocal.assign(batchingMatrix.mul($d89c9137a3d237c2$var$positionLocal));
        const transformedNormal = $d89c9137a3d237c2$var$normalLocal.div($d89c9137a3d237c2$var$vec3(bm[0].dot(bm[0]), bm[1].dot(bm[1]), bm[2].dot(bm[2])));
        const batchingNormal = bm.mul(transformedNormal).xyz;
        $d89c9137a3d237c2$var$normalLocal.assign(batchingNormal);
        if (builder.hasGeometryAttribute('tangent')) $d89c9137a3d237c2$var$tangentLocal.mulAssign(bm);
    }
}
/**
 * TSL function for creating a batch node.
 *
 * @tsl
 * @function
 * @param {BatchedMesh} batchMesh - A reference to batched mesh.
 * @returns {BatchNode}
 */ const $d89c9137a3d237c2$var$batch = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$34fa8d2809c0a555).setParameterLength(1);
const $d89c9137a3d237c2$var$_frameId = new WeakMap();
/**
 * This node implements the vertex transformation shader logic which is required
 * for skinning/skeletal animation.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$39f3abd1a872ebbf extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'SkinningNode';
    }
    /**
	 * Constructs a new skinning node.
	 *
	 * @param {SkinnedMesh} skinnedMesh - The skinned mesh.
	 */ constructor(skinnedMesh){
        super('void');
        /**
		 * The skinned mesh.
		 *
		 * @type {SkinnedMesh}
		 */ this.skinnedMesh = skinnedMesh;
        /**
		 * The update type overwritten since skinning nodes are updated per object.
		 *
		 * @type {string}
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT;
        //
        /**
		 * The skin index attribute.
		 *
		 * @type {AttributeNode}
		 */ this.skinIndexNode = $d89c9137a3d237c2$var$attribute('skinIndex', 'uvec4');
        /**
		 * The skin weight attribute.
		 *
		 * @type {AttributeNode}
		 */ this.skinWeightNode = $d89c9137a3d237c2$var$attribute('skinWeight', 'vec4');
        /**
		 * The bind matrix node.
		 *
		 * @type {Node<mat4>}
		 */ this.bindMatrixNode = $d89c9137a3d237c2$var$reference('bindMatrix', 'mat4');
        /**
		 * The bind matrix inverse node.
		 *
		 * @type {Node<mat4>}
		 */ this.bindMatrixInverseNode = $d89c9137a3d237c2$var$reference('bindMatrixInverse', 'mat4');
        /**
		 * The bind matrices as a uniform buffer node.
		 *
		 * @type {Node}
		 */ this.boneMatricesNode = $d89c9137a3d237c2$var$referenceBuffer('skeleton.boneMatrices', 'mat4', skinnedMesh.skeleton.bones.length);
        /**
		 * The current vertex position in local space.
		 *
		 * @type {Node<vec3>}
		 */ this.positionNode = $d89c9137a3d237c2$var$positionLocal;
        /**
		 * The result of vertex position in local space.
		 *
		 * @type {Node<vec3>}
		 */ this.toPositionNode = $d89c9137a3d237c2$var$positionLocal;
        /**
		 * The previous bind matrices as a uniform buffer node.
		 * Required for computing motion vectors.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.previousBoneMatricesNode = null;
    }
    /**
	 * Transforms the given vertex position via skinning.
	 *
	 * @param {Node} [boneMatrices=this.boneMatricesNode] - The bone matrices
	 * @param {Node<vec3>} [position=this.positionNode] - The vertex position in local space.
	 * @return {Node<vec3>} The transformed vertex position.
	 */ getSkinnedPosition(boneMatrices = this.boneMatricesNode, position = this.positionNode) {
        const { skinIndexNode: skinIndexNode, skinWeightNode: skinWeightNode, bindMatrixNode: bindMatrixNode, bindMatrixInverseNode: bindMatrixInverseNode } = this;
        const boneMatX = boneMatrices.element(skinIndexNode.x);
        const boneMatY = boneMatrices.element(skinIndexNode.y);
        const boneMatZ = boneMatrices.element(skinIndexNode.z);
        const boneMatW = boneMatrices.element(skinIndexNode.w);
        // POSITION
        const skinVertex = bindMatrixNode.mul(position);
        const skinned = $d89c9137a3d237c2$var$add(boneMatX.mul(skinWeightNode.x).mul(skinVertex), boneMatY.mul(skinWeightNode.y).mul(skinVertex), boneMatZ.mul(skinWeightNode.z).mul(skinVertex), boneMatW.mul(skinWeightNode.w).mul(skinVertex));
        return bindMatrixInverseNode.mul(skinned).xyz;
    }
    /**
	 * Transforms the given vertex normal via skinning.
	 *
	 * @param {Node} [boneMatrices=this.boneMatricesNode] - The bone matrices
	 * @param {Node<vec3>} [normal=normalLocal] - The vertex normal in local space.
	 * @return {Node<vec3>} The transformed vertex normal.
	 */ getSkinnedNormal(boneMatrices = this.boneMatricesNode, normal = $d89c9137a3d237c2$var$normalLocal) {
        const { skinIndexNode: skinIndexNode, skinWeightNode: skinWeightNode, bindMatrixNode: bindMatrixNode, bindMatrixInverseNode: bindMatrixInverseNode } = this;
        const boneMatX = boneMatrices.element(skinIndexNode.x);
        const boneMatY = boneMatrices.element(skinIndexNode.y);
        const boneMatZ = boneMatrices.element(skinIndexNode.z);
        const boneMatW = boneMatrices.element(skinIndexNode.w);
        // NORMAL
        let skinMatrix = $d89c9137a3d237c2$var$add(skinWeightNode.x.mul(boneMatX), skinWeightNode.y.mul(boneMatY), skinWeightNode.z.mul(boneMatZ), skinWeightNode.w.mul(boneMatW));
        skinMatrix = bindMatrixInverseNode.mul(skinMatrix).mul(bindMatrixNode);
        return skinMatrix.transformDirection(normal).xyz;
    }
    /**
	 * Computes the transformed/skinned vertex position of the previous frame.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The skinned position from the previous frame.
	 */ getPreviousSkinnedPosition(builder) {
        const skinnedMesh = builder.object;
        if (this.previousBoneMatricesNode === null) {
            skinnedMesh.skeleton.previousBoneMatrices = new Float32Array(skinnedMesh.skeleton.boneMatrices);
            this.previousBoneMatricesNode = $d89c9137a3d237c2$var$referenceBuffer('skeleton.previousBoneMatrices', 'mat4', skinnedMesh.skeleton.bones.length);
        }
        return this.getSkinnedPosition(this.previousBoneMatricesNode, $d89c9137a3d237c2$var$positionPrevious);
    }
    /**
	 * Returns `true` if bone matrices from the previous frame are required. Relevant
	 * when computing motion vectors with {@link VelocityNode}.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {boolean} Whether bone matrices from the previous frame are required or not.
	 */ needsPreviousBoneMatrices(builder) {
        const mrt = builder.renderer.getMRT();
        return mrt && mrt.has('velocity') || $d89c9137a3d237c2$var$getDataFromObject(builder.object).useVelocity === true;
    }
    /**
	 * Setups the skinning node by assigning the transformed vertex data to predefined node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The transformed vertex position.
	 */ setup(builder) {
        if (this.needsPreviousBoneMatrices(builder)) $d89c9137a3d237c2$var$positionPrevious.assign(this.getPreviousSkinnedPosition(builder));
        const skinPosition = this.getSkinnedPosition();
        if (this.toPositionNode) this.toPositionNode.assign(skinPosition);
        //
        if (builder.hasGeometryAttribute('normal')) {
            const skinNormal = this.getSkinnedNormal();
            $d89c9137a3d237c2$var$normalLocal.assign(skinNormal);
            if (builder.hasGeometryAttribute('tangent')) $d89c9137a3d237c2$var$tangentLocal.assign(skinNormal);
        }
        return skinPosition;
    }
    /**
	 * Generates the code snippet of the skinning node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} output - The current output.
	 * @return {string} The generated code snippet.
	 */ generate(builder, output) {
        if (output !== 'void') return super.generate(builder, output);
    }
    /**
	 * Updates the state of the skinned mesh by updating the skeleton once per frame.
	 *
	 * @param {NodeFrame} frame - The current node frame.
	 */ update(frame) {
        const skeleton = frame.object && frame.object.skeleton ? frame.object.skeleton : this.skinnedMesh.skeleton;
        if ($d89c9137a3d237c2$var$_frameId.get(skeleton) === frame.frameId) return;
        $d89c9137a3d237c2$var$_frameId.set(skeleton, frame.frameId);
        if (this.previousBoneMatricesNode !== null) {
            if (skeleton.previousBoneMatrices === null) // cloned skeletons miss "previousBoneMatrices" in their first updated
            skeleton.previousBoneMatrices = new Float32Array(skeleton.boneMatrices);
            skeleton.previousBoneMatrices.set(skeleton.boneMatrices);
        }
        skeleton.update();
    }
}
/**
 * TSL function for creating a skinning node.
 *
 * @tsl
 * @function
 * @param {SkinnedMesh} skinnedMesh - The skinned mesh.
 * @returns {SkinningNode}
 */ const $d89c9137a3d237c2$var$skinning = (skinnedMesh)=>new $d89c9137a3d237c2$export$39f3abd1a872ebbf(skinnedMesh);
/**
 * TSL function for computing skinning.
 *
 * @tsl
 * @function
 * @param {SkinnedMesh} skinnedMesh - The skinned mesh.
 * @param {Node<vec3>} [toPosition=null] - The target position.
 * @returns {SkinningNode}
 */ const $d89c9137a3d237c2$var$computeSkinning = (skinnedMesh, toPosition = null)=>{
    const node = new $d89c9137a3d237c2$export$39f3abd1a872ebbf(skinnedMesh);
    node.positionNode = $d89c9137a3d237c2$var$storage(new (0, $329ek.InstancedBufferAttribute)(skinnedMesh.geometry.getAttribute('position').array, 3), 'vec3').setPBO(true).toReadOnly().element($d89c9137a3d237c2$var$instanceIndex).toVar();
    node.skinIndexNode = $d89c9137a3d237c2$var$storage(new (0, $329ek.InstancedBufferAttribute)(new Uint32Array(skinnedMesh.geometry.getAttribute('skinIndex').array), 4), 'uvec4').setPBO(true).toReadOnly().element($d89c9137a3d237c2$var$instanceIndex).toVar();
    node.skinWeightNode = $d89c9137a3d237c2$var$storage(new (0, $329ek.InstancedBufferAttribute)(skinnedMesh.geometry.getAttribute('skinWeight').array, 4), 'vec4').setPBO(true).toReadOnly().element($d89c9137a3d237c2$var$instanceIndex).toVar();
    node.bindMatrixNode = $d89c9137a3d237c2$var$uniform(skinnedMesh.bindMatrix, 'mat4');
    node.bindMatrixInverseNode = $d89c9137a3d237c2$var$uniform(skinnedMesh.bindMatrixInverse, 'mat4');
    node.boneMatricesNode = $d89c9137a3d237c2$var$buffer(skinnedMesh.skeleton.boneMatrices, 'mat4', skinnedMesh.skeleton.bones.length);
    node.toPositionNode = toPosition;
    return $d89c9137a3d237c2$var$nodeObject(node);
};
/**
 * This module offers a variety of ways to implement loops in TSL. In it's basic form it's:
 * ```js
 * Loop( count, ( { i } ) => {
 *
 * } );
 * ```
 * However, it is also possible to define a start and end ranges, data types and loop conditions:
 * ```js
 * Loop( { start: int( 0 ), end: int( 10 ), type: 'int', condition: '<' }, ( { i } ) => {
 *
 * } );
 *```
 * Nested loops can be defined in a compacted form:
 * ```js
 * Loop( 10, 5, ( { i, j } ) => {
 *
 * } );
 * ```
 * Loops that should run backwards can be defined like so:
 * ```js
 * Loop( { start: 10 }, () => {} );
 * ```
 * It is possible to execute with boolean values, similar to the `while` syntax.
 * ```js
 * const value = float( 0 ).toVar();
 *
 * Loop( value.lessThan( 10 ), () => {
 *
 * 	value.addAssign( 1 );
 *
 * } );
 * ```
 * The module also provides `Break()` and `Continue()` TSL expression for loop control.
 * @augments Node
 */ class $d89c9137a3d237c2$export$a281104ce5b2be39 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'LoopNode';
    }
    /**
	 * Constructs a new loop node.
	 *
	 * @param {Array<any>} params - Depending on the loop type, array holds different parameterization values for the loop.
	 */ constructor(params = []){
        super('void');
        this.params = params;
    }
    /**
	 * Returns a loop variable name based on an index. The pattern is
	 * `0` = `i`, `1`= `j`, `2`= `k` and so on.
	 *
	 * @param {number} index - The index.
	 * @return {string} The loop variable name.
	 */ getVarName(index) {
        return String.fromCharCode('i'.charCodeAt(0) + index);
    }
    /**
	 * Returns properties about this node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Object} The node properties.
	 */ getProperties(builder) {
        const properties = builder.getNodeProperties(this);
        if (properties.stackNode !== undefined) return properties;
        //
        const inputs = {};
        for(let i = 0, l = this.params.length - 1; i < l; i++){
            const param = this.params[i];
            const name = param.isNode !== true && param.name || this.getVarName(i);
            const type = param.isNode !== true && param.type || 'int';
            inputs[name] = $d89c9137a3d237c2$var$expression(name, type);
        }
        const stack = builder.addStack();
        const fnCall = this.params[this.params.length - 1](inputs);
        properties.returnsNode = fnCall.context({
            nodeLoop: fnCall
        });
        properties.stackNode = stack;
        const baseParam = this.params[0];
        if (baseParam.isNode !== true && typeof baseParam.update === 'function') {
            const fnUpdateCall = $d89c9137a3d237c2$var$Fn(this.params[0].update)(inputs);
            properties.updateNode = fnUpdateCall.context({
                nodeLoop: fnUpdateCall
            });
        }
        builder.removeStack();
        return properties;
    }
    setup(builder) {
        // setup properties
        this.getProperties(builder);
        if (builder.fnCall) {
            const shaderNodeData = builder.getDataFromNode(builder.fnCall.shaderNode);
            shaderNodeData.hasLoop = true;
        }
    }
    generate(builder) {
        const properties = this.getProperties(builder);
        const params = this.params;
        const stackNode = properties.stackNode;
        for(let i = 0, l = params.length - 1; i < l; i++){
            const param = params[i];
            let isWhile = false, start = null, end = null, name = null, type = null, condition = null, update = null;
            if (param.isNode) {
                if (param.getNodeType(builder) === 'bool') {
                    isWhile = true;
                    type = 'bool';
                    end = param.build(builder, type);
                } else {
                    type = 'int';
                    name = this.getVarName(i);
                    start = '0';
                    end = param.build(builder, type);
                    condition = '<';
                }
            } else {
                type = param.type || 'int';
                name = param.name || this.getVarName(i);
                start = param.start;
                end = param.end;
                condition = param.condition;
                update = param.update;
                if (typeof start === 'number') start = builder.generateConst(type, start);
                else if (start && start.isNode) start = start.build(builder, type);
                if (typeof end === 'number') end = builder.generateConst(type, end);
                else if (end && end.isNode) end = end.build(builder, type);
                if (start !== undefined && end === undefined) {
                    start = start + ' - 1';
                    end = '0';
                    condition = '>=';
                } else if (end !== undefined && start === undefined) {
                    start = '0';
                    condition = '<';
                }
                if (condition === undefined) {
                    if (Number(start) > Number(end)) condition = '>=';
                    else condition = '<';
                }
            }
            let loopSnippet;
            if (isWhile) loopSnippet = `while ( ${end} )`;
            else {
                const internalParam = {
                    start: start,
                    end: end
                };
                //
                const startSnippet = internalParam.start;
                const endSnippet = internalParam.end;
                let updateSnippet;
                const deltaOperator = ()=>condition.includes('<') ? '+=' : '-=';
                if (update !== undefined && update !== null) switch(typeof update){
                    case 'function':
                        const flow = builder.flowStagesNode(properties.updateNode, 'void');
                        const snippet = flow.code.replace(/\t|;/g, '');
                        updateSnippet = snippet;
                        break;
                    case 'number':
                        updateSnippet = name + ' ' + deltaOperator() + ' ' + builder.generateConst(type, update);
                        break;
                    case 'string':
                        updateSnippet = name + ' ' + update;
                        break;
                    default:
                        if (update.isNode) updateSnippet = name + ' ' + deltaOperator() + ' ' + update.build(builder);
                        else {
                            (0, $329ek.error)('TSL: \'Loop( { update: ... } )\' is not a function, string or number.');
                            updateSnippet = 'break /* invalid update */';
                        }
                }
                else {
                    if (type === 'int' || type === 'uint') update = condition.includes('<') ? '++' : '--';
                    else update = deltaOperator() + ' 1.';
                    updateSnippet = name + ' ' + update;
                }
                const declarationSnippet = builder.getVar(type, name) + ' = ' + startSnippet;
                const conditionalSnippet = name + ' ' + condition + ' ' + endSnippet;
                loopSnippet = `for ( ${declarationSnippet}; ${conditionalSnippet}; ${updateSnippet} )`;
            }
            builder.addFlowCode((i === 0 ? '\n' : '') + builder.tab + loopSnippet + ' {\n\n').addFlowTab();
        }
        const stackSnippet = stackNode.build(builder, 'void');
        properties.returnsNode.build(builder, 'void');
        builder.removeFlowTab().addFlowCode('\n' + builder.tab + stackSnippet);
        for(let i = 0, l = this.params.length - 1; i < l; i++)builder.addFlowCode((i === 0 ? '' : builder.tab) + '}\n\n').removeFlowTab();
        builder.addFlowTab();
    }
}
/**
 * TSL function for creating a loop node.
 *
 * @tsl
 * @function
 * @param {...any} params - A list of parameters.
 * @returns {LoopNode}
 */ const $d89c9137a3d237c2$var$Loop = (...params)=>new $d89c9137a3d237c2$export$a281104ce5b2be39($d89c9137a3d237c2$var$nodeArray(params, 'int')).toStack();
/**
 * TSL function for creating a `Continue()` expression.
 *
 * @tsl
 * @function
 * @returns {ExpressionNode}
 */ const $d89c9137a3d237c2$var$Continue = ()=>$d89c9137a3d237c2$var$expression('continue').toStack();
/**
 * TSL function for creating a `Break()` expression.
 *
 * @tsl
 * @function
 * @returns {ExpressionNode}
 */ const $d89c9137a3d237c2$var$Break = ()=>$d89c9137a3d237c2$var$expression('break').toStack();
const $d89c9137a3d237c2$var$_morphTextures = /*@__PURE__*/ new WeakMap();
const $d89c9137a3d237c2$var$_morphVec4 = /*@__PURE__*/ new (0, $329ek.Vector4)();
const $d89c9137a3d237c2$var$getMorph = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ bufferMap: bufferMap, influence: influence, stride: stride, width: width, depth: depth, offset: offset })=>{
    const texelIndex = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$vertexIndex).mul(stride).add(offset);
    const y = texelIndex.div(width);
    const x = texelIndex.sub(y.mul(width));
    const bufferAttrib = $d89c9137a3d237c2$var$textureLoad(bufferMap, $d89c9137a3d237c2$var$ivec2(x, y)).depth(depth).xyz;
    return bufferAttrib.mul(influence);
});
function $d89c9137a3d237c2$var$getEntry(geometry) {
    const hasMorphPosition = geometry.morphAttributes.position !== undefined;
    const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
    const hasMorphColors = geometry.morphAttributes.color !== undefined;
    // instead of using attributes, the WebGL 2 code path encodes morph targets
    // into an array of data textures. Each layer represents a single morph target.
    const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
    const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
    let entry = $d89c9137a3d237c2$var$_morphTextures.get(geometry);
    if (entry === undefined || entry.count !== morphTargetsCount) {
        if (entry !== undefined) entry.texture.dispose();
        const morphTargets = geometry.morphAttributes.position || [];
        const morphNormals = geometry.morphAttributes.normal || [];
        const morphColors = geometry.morphAttributes.color || [];
        let vertexDataCount = 0;
        if (hasMorphPosition === true) vertexDataCount = 1;
        if (hasMorphNormals === true) vertexDataCount = 2;
        if (hasMorphColors === true) vertexDataCount = 3;
        let width = geometry.attributes.position.count * vertexDataCount;
        let height = 1;
        const maxTextureSize = 4096; // @TODO: Use 'capabilities.maxTextureSize'
        if (width > maxTextureSize) {
            height = Math.ceil(width / maxTextureSize);
            width = maxTextureSize;
        }
        const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
        const bufferTexture = new (0, $329ek.DataArrayTexture)(buffer, width, height, morphTargetsCount);
        bufferTexture.type = (0, $329ek.FloatType);
        bufferTexture.needsUpdate = true;
        // fill buffer
        const vertexDataStride = vertexDataCount * 4;
        for(let i = 0; i < morphTargetsCount; i++){
            const morphTarget = morphTargets[i];
            const morphNormal = morphNormals[i];
            const morphColor = morphColors[i];
            const offset = width * height * 4 * i;
            for(let j = 0; j < morphTarget.count; j++){
                const stride = j * vertexDataStride;
                if (hasMorphPosition === true) {
                    $d89c9137a3d237c2$var$_morphVec4.fromBufferAttribute(morphTarget, j);
                    buffer[offset + stride + 0] = $d89c9137a3d237c2$var$_morphVec4.x;
                    buffer[offset + stride + 1] = $d89c9137a3d237c2$var$_morphVec4.y;
                    buffer[offset + stride + 2] = $d89c9137a3d237c2$var$_morphVec4.z;
                    buffer[offset + stride + 3] = 0;
                }
                if (hasMorphNormals === true) {
                    $d89c9137a3d237c2$var$_morphVec4.fromBufferAttribute(morphNormal, j);
                    buffer[offset + stride + 4] = $d89c9137a3d237c2$var$_morphVec4.x;
                    buffer[offset + stride + 5] = $d89c9137a3d237c2$var$_morphVec4.y;
                    buffer[offset + stride + 6] = $d89c9137a3d237c2$var$_morphVec4.z;
                    buffer[offset + stride + 7] = 0;
                }
                if (hasMorphColors === true) {
                    $d89c9137a3d237c2$var$_morphVec4.fromBufferAttribute(morphColor, j);
                    buffer[offset + stride + 8] = $d89c9137a3d237c2$var$_morphVec4.x;
                    buffer[offset + stride + 9] = $d89c9137a3d237c2$var$_morphVec4.y;
                    buffer[offset + stride + 10] = $d89c9137a3d237c2$var$_morphVec4.z;
                    buffer[offset + stride + 11] = morphColor.itemSize === 4 ? $d89c9137a3d237c2$var$_morphVec4.w : 1;
                }
            }
        }
        entry = {
            count: morphTargetsCount,
            texture: bufferTexture,
            stride: vertexDataCount,
            size: new (0, $329ek.Vector2)(width, height)
        };
        $d89c9137a3d237c2$var$_morphTextures.set(geometry, entry);
        function disposeTexture() {
            bufferTexture.dispose();
            $d89c9137a3d237c2$var$_morphTextures.delete(geometry);
            geometry.removeEventListener('dispose', disposeTexture);
        }
        geometry.addEventListener('dispose', disposeTexture);
    }
    return entry;
}
/**
 * This node implements the vertex transformation shader logic which is required
 * for morph target animation.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$b07a0b8e32632807 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'MorphNode';
    }
    /**
	 * Constructs a new morph node.
	 *
	 * @param {Mesh} mesh - The mesh holding the morph targets.
	 */ constructor(mesh){
        super('void');
        /**
		 * The mesh holding the morph targets.
		 *
		 * @type {Mesh}
		 */ this.mesh = mesh;
        /**
		 * A uniform node which represents the morph base influence value.
		 *
		 * @type {UniformNode<float>}
		 */ this.morphBaseInfluence = $d89c9137a3d237c2$var$uniform(1);
        /**
		 * The update type overwritten since morph nodes are updated per object.
		 *
		 * @type {string}
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT;
    }
    /**
	 * Setups the morph node by assigning the transformed vertex data to predefined node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        const { geometry: geometry } = builder;
        const hasMorphPosition = geometry.morphAttributes.position !== undefined;
        const hasMorphNormals = geometry.hasAttribute('normal') && geometry.morphAttributes.normal !== undefined;
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        // nodes
        const { texture: bufferMap, stride: stride, size: size } = $d89c9137a3d237c2$var$getEntry(geometry);
        if (hasMorphPosition === true) $d89c9137a3d237c2$var$positionLocal.mulAssign(this.morphBaseInfluence);
        if (hasMorphNormals === true) $d89c9137a3d237c2$var$normalLocal.mulAssign(this.morphBaseInfluence);
        const width = $d89c9137a3d237c2$var$int(size.width);
        $d89c9137a3d237c2$var$Loop(morphTargetsCount, ({ i: i })=>{
            const influence = $d89c9137a3d237c2$var$float(0).toVar();
            if (this.mesh.count > 1 && this.mesh.morphTexture !== null && this.mesh.morphTexture !== undefined) influence.assign($d89c9137a3d237c2$var$textureLoad(this.mesh.morphTexture, $d89c9137a3d237c2$var$ivec2($d89c9137a3d237c2$var$int(i).add(1), $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$instanceIndex))).r);
            else influence.assign($d89c9137a3d237c2$var$reference('morphTargetInfluences', 'float').element(i).toVar());
            $d89c9137a3d237c2$var$If(influence.notEqual(0), ()=>{
                if (hasMorphPosition === true) $d89c9137a3d237c2$var$positionLocal.addAssign($d89c9137a3d237c2$var$getMorph({
                    bufferMap: bufferMap,
                    influence: influence,
                    stride: stride,
                    width: width,
                    depth: i,
                    offset: $d89c9137a3d237c2$var$int(0)
                }));
                if (hasMorphNormals === true) $d89c9137a3d237c2$var$normalLocal.addAssign($d89c9137a3d237c2$var$getMorph({
                    bufferMap: bufferMap,
                    influence: influence,
                    stride: stride,
                    width: width,
                    depth: i,
                    offset: $d89c9137a3d237c2$var$int(1)
                }));
            });
        });
    }
    /**
	 * Updates the state of the morphed mesh by updating the base influence.
	 *
	 * @param {NodeFrame} frame - The current node frame.
	 */ update() {
        const morphBaseInfluence = this.morphBaseInfluence;
        if (this.mesh.geometry.morphTargetsRelative) morphBaseInfluence.value = 1;
        else morphBaseInfluence.value = 1 - this.mesh.morphTargetInfluences.reduce((a, b)=>a + b, 0);
    }
}
/**
 * TSL function for creating a morph node.
 *
 * @tsl
 * @function
 * @param {Mesh} mesh - The mesh holding the morph targets.
 * @returns {MorphNode}
 */ const $d89c9137a3d237c2$var$morphReference = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$b07a0b8e32632807).setParameterLength(1);
/**
 * Base class for lighting nodes.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$3fce9846d62aac91 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'LightingNode';
    }
    /**
	 * Constructs a new lighting node.
	 */ constructor(){
        super('vec3');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLightingNode = true;
    }
}
/**
 * A generic class that can be used by nodes which contribute
 * ambient occlusion to the scene. E.g. an ambient occlusion map
 * node can be used as input for this module. Used in {@link NodeMaterial}.
 *
 * @augments LightingNode
 */ class $d89c9137a3d237c2$export$91e1d32e5b48fb53 extends $d89c9137a3d237c2$export$3fce9846d62aac91 {
    static get type() {
        return 'AONode';
    }
    /**
	 * Constructs a new AO node.
	 *
	 * @param {?Node<float>} [aoNode=null] - The ambient occlusion node.
	 */ constructor(aoNode = null){
        super();
        /**
		 * The ambient occlusion node.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.aoNode = aoNode;
    }
    setup(builder) {
        builder.context.ambientOcclusion.mulAssign(this.aoNode);
    }
}
/**
 * `LightingContextNode` represents an extension of the {@link ContextNode} module
 * by adding lighting specific context data. It represents the runtime context of
 * {@link LightsNode}.
 *
 * @augments ContextNode
 */ class $d89c9137a3d237c2$export$cc99f7905cc5767b extends $d89c9137a3d237c2$export$17ecd2ebd87625d1 {
    static get type() {
        return 'LightingContextNode';
    }
    /**
	 * Constructs a new lighting context node.
	 *
	 * @param {LightsNode} lightsNode - The lights node.
	 * @param {?LightingModel} [lightingModel=null] - The current lighting model.
	 * @param {?Node<vec3>} [backdropNode=null] - A backdrop node.
	 * @param {?Node<float>} [backdropAlphaNode=null] - A backdrop alpha node.
	 */ constructor(lightsNode, lightingModel = null, backdropNode = null, backdropAlphaNode = null){
        super(lightsNode);
        /**
		 * The current lighting model.
		 *
		 * @type {?LightingModel}
		 * @default null
		 */ this.lightingModel = lightingModel;
        /**
		 * A backdrop node.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.backdropNode = backdropNode;
        /**
		 * A backdrop alpha node.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.backdropAlphaNode = backdropAlphaNode;
        this._value = null;
    }
    /**
	 * Returns a lighting context object.
	 *
	 * @return {{
	 * radiance: Node<vec3>,
	 * irradiance: Node<vec3>,
	 * iblIrradiance: Node<vec3>,
	 * ambientOcclusion: Node<float>,
	 * reflectedLight: {directDiffuse: Node<vec3>, directSpecular: Node<vec3>, indirectDiffuse: Node<vec3>, indirectSpecular: Node<vec3>},
	 * backdrop: Node<vec3>,
	 * backdropAlpha: Node<float>
	 * }} The lighting context object.
	 */ getContext() {
        const { backdropNode: backdropNode, backdropAlphaNode: backdropAlphaNode } = this;
        const directDiffuse = $d89c9137a3d237c2$var$vec3().toVar('directDiffuse'), directSpecular = $d89c9137a3d237c2$var$vec3().toVar('directSpecular'), indirectDiffuse = $d89c9137a3d237c2$var$vec3().toVar('indirectDiffuse'), indirectSpecular = $d89c9137a3d237c2$var$vec3().toVar('indirectSpecular');
        const reflectedLight = {
            directDiffuse: directDiffuse,
            directSpecular: directSpecular,
            indirectDiffuse: indirectDiffuse,
            indirectSpecular: indirectSpecular
        };
        const context = {
            radiance: $d89c9137a3d237c2$var$vec3().toVar('radiance'),
            irradiance: $d89c9137a3d237c2$var$vec3().toVar('irradiance'),
            iblIrradiance: $d89c9137a3d237c2$var$vec3().toVar('iblIrradiance'),
            ambientOcclusion: $d89c9137a3d237c2$var$float(1).toVar('ambientOcclusion'),
            reflectedLight: reflectedLight,
            backdrop: backdropNode,
            backdropAlpha: backdropAlphaNode
        };
        return context;
    }
    setup(builder) {
        this.value = this._value || (this._value = this.getContext());
        this.value.lightingModel = this.lightingModel || builder.context.lightingModel;
        return super.setup(builder);
    }
}
const $d89c9137a3d237c2$var$lightingContext = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$cc99f7905cc5767b);
/**
 * A generic class that can be used by nodes which contribute
 * irradiance to the scene. E.g. a light map node can be used
 * as input for this module. Used in {@link NodeMaterial}.
 *
 * @augments LightingNode
 */ class $d89c9137a3d237c2$export$26fe501f8a41ff48 extends $d89c9137a3d237c2$export$3fce9846d62aac91 {
    static get type() {
        return 'IrradianceNode';
    }
    /**
	 * Constructs a new irradiance node.
	 *
	 * @param {Node<vec3>} node - A node contributing irradiance.
	 */ constructor(node){
        super();
        /**
		 * A node contributing irradiance.
		 *
		 * @type {Node<vec3>}
		 */ this.node = node;
    }
    setup(builder) {
        builder.context.irradiance.addAssign(this.node);
    }
}
const $d89c9137a3d237c2$var$_size$5 = /*@__PURE__*/ new (0, $329ek.Vector2)();
/**
 * A special type of texture node which represents the data of the current viewport
 * as a texture. The module extracts data from the current bound framebuffer with
 * a copy operation so no extra render pass is required to produce the texture data
 * (which is good for performance). `ViewportTextureNode` can be used as an input for a
 * variety of effects like refractive or transmissive materials.
 *
 * @augments TextureNode
 */ class $d89c9137a3d237c2$export$f873d674c2e6b04d extends $d89c9137a3d237c2$export$2dd903bc9e8140bc {
    static get type() {
        return 'ViewportTextureNode';
    }
    /**
	 * Constructs a new viewport texture node.
	 *
	 * @param {Node} [uvNode=screenUV] - The uv node.
	 * @param {?Node} [levelNode=null] - The level node.
	 * @param {?Texture} [framebufferTexture=null] - A framebuffer texture holding the viewport data. If not provided, a framebuffer texture is created automatically.
	 */ constructor(uvNode = $d89c9137a3d237c2$var$screenUV, levelNode = null, framebufferTexture = null){
        let defaultFramebuffer = null;
        if (framebufferTexture === null) {
            defaultFramebuffer = new (0, $329ek.FramebufferTexture)();
            defaultFramebuffer.minFilter = (0, $329ek.LinearMipmapLinearFilter);
            framebufferTexture = defaultFramebuffer;
        } else defaultFramebuffer = framebufferTexture;
        super(framebufferTexture, uvNode, levelNode);
        /**
		 * Whether to generate mipmaps or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * The reference framebuffer texture. This is used to store the framebuffer texture
		 * for the current render target. If the render target changes, a new framebuffer texture
		 * is created automatically.
		 *
		 * @type {FramebufferTexture}
		 * @default null
		 */ this.defaultFramebuffer = defaultFramebuffer;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOutputTextureNode = true;
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.FRAME` since the node renders the
		 * scene once per frame in its {@link ViewportTextureNode#updateBefore} method.
		 *
		 * @type {string}
		 * @default 'frame'
		 */ this.updateBeforeType = $d89c9137a3d237c2$export$26f7a8bbd9469530.FRAME;
        /**
		 * The framebuffer texture for the current renderer context.
		 *
		 * @type {WeakMap<RenderTarget, FramebufferTexture>}
		 * @private
		 */ this._cacheTextures = new WeakMap();
    }
    /**
	 * This methods returns a texture for the given render target reference.
	 *
	 * To avoid rendering errors, `ViewportTextureNode` must use unique framebuffer textures
	 * for different render contexts.
	 *
	 * @param {?RenderTarget} [reference=null] - The render target reference.
	 * @return {Texture} The framebuffer texture.
	 */ getTextureForReference(reference = null) {
        let defaultFramebuffer;
        let cacheTextures;
        if (this.referenceNode) {
            defaultFramebuffer = this.referenceNode.defaultFramebuffer;
            cacheTextures = this.referenceNode._cacheTextures;
        } else {
            defaultFramebuffer = this.defaultFramebuffer;
            cacheTextures = this._cacheTextures;
        }
        if (reference === null) return defaultFramebuffer;
        if (cacheTextures.has(reference) === false) {
            const framebufferTexture = defaultFramebuffer.clone();
            cacheTextures.set(reference, framebufferTexture);
        }
        return cacheTextures.get(reference);
    }
    updateReference(frame) {
        const renderTarget = frame.renderer.getRenderTarget();
        this.value = this.getTextureForReference(renderTarget);
        return this.value;
    }
    updateBefore(frame) {
        const renderer = frame.renderer;
        const renderTarget = renderer.getRenderTarget();
        if (renderTarget === null) renderer.getDrawingBufferSize($d89c9137a3d237c2$var$_size$5);
        else $d89c9137a3d237c2$var$_size$5.set(renderTarget.width, renderTarget.height);
        //
        const framebufferTexture = this.getTextureForReference(renderTarget);
        if (framebufferTexture.image.width !== $d89c9137a3d237c2$var$_size$5.width || framebufferTexture.image.height !== $d89c9137a3d237c2$var$_size$5.height) {
            framebufferTexture.image.width = $d89c9137a3d237c2$var$_size$5.width;
            framebufferTexture.image.height = $d89c9137a3d237c2$var$_size$5.height;
            framebufferTexture.needsUpdate = true;
        }
        //
        const currentGenerateMipmaps = framebufferTexture.generateMipmaps;
        framebufferTexture.generateMipmaps = this.generateMipmaps;
        renderer.copyFramebufferToTexture(framebufferTexture);
        framebufferTexture.generateMipmaps = currentGenerateMipmaps;
    }
    clone() {
        const viewportTextureNode = new this.constructor(this.uvNode, this.levelNode, this.value);
        viewportTextureNode.generateMipmaps = this.generateMipmaps;
        return viewportTextureNode;
    }
}
/**
 * TSL function for creating a viewport texture node.
 *
 * @tsl
 * @function
 * @param {?Node} [uvNode=screenUV] - The uv node.
 * @param {?Node} [levelNode=null] - The level node.
 * @param {?Texture} [framebufferTexture=null] - A framebuffer texture holding the viewport data. If not provided, a framebuffer texture is created automatically.
 * @returns {ViewportTextureNode}
 */ const $d89c9137a3d237c2$var$viewportTexture = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$f873d674c2e6b04d).setParameterLength(0, 3);
/**
 * TSL function for creating a viewport texture node with enabled mipmap generation.
 *
 * @tsl
 * @function
 * @param {?Node} [uvNode=screenUV] - The uv node.
 * @param {?Node} [levelNode=null] - The level node.
 * @param {?Texture} [framebufferTexture=null] - A framebuffer texture holding the viewport data. If not provided, a framebuffer texture is created automatically.
 * @returns {ViewportTextureNode}
 */ const $d89c9137a3d237c2$var$viewportMipTexture = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$f873d674c2e6b04d, null, null, {
    generateMipmaps: true
}).setParameterLength(0, 3);
let $d89c9137a3d237c2$var$_sharedDepthbuffer = null;
/**
 * Represents the depth of the current viewport as a texture. This module
 * can be used in combination with viewport texture to achieve effects
 * that require depth evaluation.
 *
 * @augments ViewportTextureNode
 */ class $d89c9137a3d237c2$export$7cf1e34dae1b8553 extends $d89c9137a3d237c2$export$f873d674c2e6b04d {
    static get type() {
        return 'ViewportDepthTextureNode';
    }
    /**
	 * Constructs a new viewport depth texture node.
	 *
	 * @param {Node} [uvNode=screenUV] - The uv node.
	 * @param {?Node} [levelNode=null] - The level node.
	 */ constructor(uvNode = $d89c9137a3d237c2$var$screenUV, levelNode = null){
        if ($d89c9137a3d237c2$var$_sharedDepthbuffer === null) $d89c9137a3d237c2$var$_sharedDepthbuffer = new (0, $329ek.DepthTexture)();
        super(uvNode, levelNode, $d89c9137a3d237c2$var$_sharedDepthbuffer);
    }
    /**
	 * Overwritten so the method always returns the unique shared
	 * depth texture.
	 *
	 * @return {DepthTexture} The shared depth texture.
	 */ getTextureForReference() {
        return $d89c9137a3d237c2$var$_sharedDepthbuffer;
    }
}
/**
 * TSL function for a viewport depth texture node.
 *
 * @tsl
 * @function
 * @param {?Node} [uvNode=screenUV] - The uv node.
 * @param {?Node} [levelNode=null] - The level node.
 * @returns {ViewportDepthTextureNode}
 */ const $d89c9137a3d237c2$var$viewportDepthTexture = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$7cf1e34dae1b8553).setParameterLength(0, 2);
/**
 * This node offers a collection of features in context of the depth logic in the fragment shader.
 * Depending on {@link ViewportDepthNode#scope}, it can be used to define a depth value for the current
 * fragment or for depth evaluation purposes.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$43ab5aad252e8f95 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ViewportDepthNode';
    }
    /**
	 * Constructs a new viewport depth node.
	 *
	 * @param {('depth'|'depthBase'|'linearDepth')} scope - The node's scope.
	 * @param {?Node} [valueNode=null] - The value node.
	 */ constructor(scope, valueNode = null){
        super('float');
        /**
		 * The node behaves differently depending on which scope is selected.
		 *
		 * - `ViewportDepthNode.DEPTH_BASE`: Allows to define a value for the current fragment's depth.
		 * - `ViewportDepthNode.DEPTH`: Represents the depth value for the current fragment (`valueNode` is ignored).
		 * - `ViewportDepthNode.LINEAR_DEPTH`: Represents the linear (orthographic) depth value of the current fragment.
		 * If a `valueNode` is set, the scope can be used to convert perspective depth data to linear data.
		 *
		 * @type {('depth'|'depthBase'|'linearDepth')}
		 */ this.scope = scope;
        /**
		 * Can be used to define a custom depth value.
		 * The property is ignored in the `ViewportDepthNode.DEPTH` scope.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.valueNode = valueNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isViewportDepthNode = true;
    }
    generate(builder) {
        const { scope: scope } = this;
        if (scope === $d89c9137a3d237c2$export$43ab5aad252e8f95.DEPTH_BASE) return builder.getFragDepth();
        return super.generate(builder);
    }
    setup({ camera: camera }) {
        const { scope: scope } = this;
        const value = this.valueNode;
        let node = null;
        if (scope === $d89c9137a3d237c2$export$43ab5aad252e8f95.DEPTH_BASE) {
            if (value !== null) node = $d89c9137a3d237c2$var$depthBase().assign(value);
        } else if (scope === $d89c9137a3d237c2$export$43ab5aad252e8f95.DEPTH) {
            if (camera.isPerspectiveCamera) node = $d89c9137a3d237c2$var$viewZToPerspectiveDepth($d89c9137a3d237c2$var$positionView.z, $d89c9137a3d237c2$var$cameraNear, $d89c9137a3d237c2$var$cameraFar);
            else node = $d89c9137a3d237c2$var$viewZToOrthographicDepth($d89c9137a3d237c2$var$positionView.z, $d89c9137a3d237c2$var$cameraNear, $d89c9137a3d237c2$var$cameraFar);
        } else if (scope === $d89c9137a3d237c2$export$43ab5aad252e8f95.LINEAR_DEPTH) {
            if (value !== null) {
                if (camera.isPerspectiveCamera) {
                    const viewZ = $d89c9137a3d237c2$var$perspectiveDepthToViewZ(value, $d89c9137a3d237c2$var$cameraNear, $d89c9137a3d237c2$var$cameraFar);
                    node = $d89c9137a3d237c2$var$viewZToOrthographicDepth(viewZ, $d89c9137a3d237c2$var$cameraNear, $d89c9137a3d237c2$var$cameraFar);
                } else node = value;
            } else node = $d89c9137a3d237c2$var$viewZToOrthographicDepth($d89c9137a3d237c2$var$positionView.z, $d89c9137a3d237c2$var$cameraNear, $d89c9137a3d237c2$var$cameraFar);
        }
        return node;
    }
}
$d89c9137a3d237c2$export$43ab5aad252e8f95.DEPTH_BASE = 'depthBase';
$d89c9137a3d237c2$export$43ab5aad252e8f95.DEPTH = 'depth';
$d89c9137a3d237c2$export$43ab5aad252e8f95.LINEAR_DEPTH = 'linearDepth';
// NOTE: viewZ, the z-coordinate in camera space, is negative for points in front of the camera
/**
 * TSL function for converting a viewZ value to an orthographic depth value.
 *
 * @tsl
 * @function
 * @param {Node<float>} viewZ - The viewZ node.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$viewZToOrthographicDepth = (viewZ, near, far)=>viewZ.add(near).div(near.sub(far));
/**
 * TSL function for converting an orthographic depth value to a viewZ value.
 *
 * @tsl
 * @function
 * @param {Node<float>} depth - The orthographic depth.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$orthographicDepthToViewZ = (depth, near, far)=>near.sub(far).mul(depth).sub(near);
/**
 * TSL function for converting a viewZ value to a perspective depth value.
 *
 * Note: {link https://twitter.com/gonnavis/status/1377183786949959682}.
 *
 * @tsl
 * @function
 * @param {Node<float>} viewZ - The viewZ node.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$viewZToPerspectiveDepth = (viewZ, near, far)=>near.add(viewZ).mul(far).div(far.sub(near).mul(viewZ));
/**
 * TSL function for converting a perspective depth value to a viewZ value.
 *
 * @tsl
 * @function
 * @param {Node<float>} depth - The perspective depth.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$perspectiveDepthToViewZ = (depth, near, far)=>near.mul(far).div(far.sub(near).mul(depth).sub(far));
/**
 * TSL function for converting a viewZ value to a logarithmic depth value.
 *
 * @tsl
 * @function
 * @param {Node<float>} viewZ - The viewZ node.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$viewZToLogarithmicDepth = (viewZ, near, far)=>{
    // NOTE: viewZ must be negative--see explanation at the end of this comment block.
    // The final logarithmic depth formula used here is adapted from one described in an
    // article by Thatcher Ulrich (see http://tulrich.com/geekstuff/log_depth_buffer.txt),
    // which was an improvement upon an earlier formula one described in an
    // Outerra article (https://outerra.blogspot.com/2009/08/logarithmic-z-buffer.html).
    // Ulrich's formula is the following:
    //     z = K * log( w / cameraNear ) / log( cameraFar / cameraNear )
    //     where K = 2^k - 1, and k is the number of bits in the depth buffer.
    // The Outerra variant ignored the camera near plane (it assumed it was 0) and instead
    // opted for a "C-constant" for resolution adjustment of objects near the camera.
    // Outerra states: "Notice that the 'C' variant doesn’t use a near plane distance, it has it
    // set at 0" (quote from https://outerra.blogspot.com/2012/11/maximizing-depth-buffer-range-and.html).
    // Ulrich's variant has the benefit of constant relative precision over the whole near-far range.
    // It was debated here whether Outerra's "C-constant" or Ulrich's "near plane" variant should
    // be used, and ultimately Ulrich's "near plane" version was chosen.
    // Outerra eventually made another improvement to their original "C-constant" variant,
    // but it still does not incorporate the camera near plane (for this version,
    // see https://outerra.blogspot.com/2013/07/logarithmic-depth-buffer-optimizations.html).
    // Here we make 4 changes to Ulrich's formula:
    // 1. Clamp the camera near plane so we don't divide by 0.
    // 2. Use log2 instead of log to avoid an extra multiply (shaders implement log using log2).
    // 3. Assume K is 1 (K = maximum value in depth buffer; see Ulrich's formula above).
    // 4. To maintain consistency with the functions "viewZToOrthographicDepth" and "viewZToPerspectiveDepth",
    //    we modify the formula here to use 'viewZ' instead of 'w'. The other functions expect a negative viewZ,
    //    so we do the same here, hence the 'viewZ.negate()' call.
    // For visual representation of this depth curve, see https://www.desmos.com/calculator/uyqk0vex1u
    near = near.max(1e-6).toVar();
    const numerator = $d89c9137a3d237c2$var$log2(viewZ.negate().div(near));
    const denominator = $d89c9137a3d237c2$var$log2(far.div(near));
    return numerator.div(denominator);
};
/**
 * TSL function for converting a logarithmic depth value to a viewZ value.
 *
 * @tsl
 * @function
 * @param {Node<float>} depth - The logarithmic depth.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $d89c9137a3d237c2$var$logarithmicDepthToViewZ = (depth, near, far)=>{
    // NOTE: we add a 'negate()' call to the return value here to maintain consistency with
    // the functions "orthographicDepthToViewZ" and "perspectiveDepthToViewZ" (they return
    // a negative viewZ).
    const exponent = depth.mul($d89c9137a3d237c2$var$log(far.div(near)));
    return $d89c9137a3d237c2$var$float(Math.E).pow(exponent).mul(near).negate();
};
/**
 * TSL function for defining a value for the current fragment's depth.
 *
 * @tsl
 * @function
 * @param {Node<float>} value - The depth value to set.
 * @returns {ViewportDepthNode<float>}
 */ const $d89c9137a3d237c2$var$depthBase = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$43ab5aad252e8f95, $d89c9137a3d237c2$export$43ab5aad252e8f95.DEPTH_BASE);
/**
 * TSL object that represents the depth value for the current fragment.
 *
 * @tsl
 * @type {ViewportDepthNode}
 */ const $d89c9137a3d237c2$var$depth = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$43ab5aad252e8f95, $d89c9137a3d237c2$export$43ab5aad252e8f95.DEPTH);
/**
 * TSL function for converting a perspective depth value to linear depth.
 *
 * @tsl
 * @function
 * @param {?Node<float>} [value=null] - The perspective depth. If `null` is provided, the current fragment's depth is used.
 * @returns {ViewportDepthNode<float>}
 */ const $d89c9137a3d237c2$var$linearDepth = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$43ab5aad252e8f95, $d89c9137a3d237c2$export$43ab5aad252e8f95.LINEAR_DEPTH).setParameterLength(0, 1);
/**
 * TSL object that represents the linear (orthographic) depth value of the current fragment
 *
 * @tsl
 * @type {ViewportDepthNode}
 */ const $d89c9137a3d237c2$var$viewportLinearDepth = /*@__PURE__*/ $d89c9137a3d237c2$var$linearDepth($d89c9137a3d237c2$var$viewportDepthTexture());
$d89c9137a3d237c2$var$depth.assign = (value)=>$d89c9137a3d237c2$var$depthBase(value);
/**
 * This node is used in {@link NodeMaterial} to setup the clipping
 * which can happen hardware-accelerated (if supported) and optionally
 * use alpha-to-coverage for anti-aliasing clipped edges.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$var$ClippingNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ClippingNode';
    }
    /**
	 * Constructs a new clipping node.
	 *
	 * @param {('default'|'hardware'|'alphaToCoverage')} [scope='default'] - The node's scope. Similar to other nodes,
	 * the selected scope influences the behavior of the node and what type of code is generated.
	 */ constructor(scope = $d89c9137a3d237c2$var$ClippingNode.DEFAULT){
        super();
        /**
		 * The node's scope. Similar to other nodes, the selected scope influences
		 * the behavior of the node and what type of code is generated.
		 *
		 * @type {('default'|'hardware'|'alphaToCoverage')}
		 */ this.scope = scope;
    }
    /**
	 * Setups the node depending on the selected scope.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node} The result node.
	 */ setup(builder) {
        super.setup(builder);
        const clippingContext = builder.clippingContext;
        const { intersectionPlanes: intersectionPlanes, unionPlanes: unionPlanes } = clippingContext;
        this.hardwareClipping = builder.material.hardwareClipping;
        if (this.scope === $d89c9137a3d237c2$var$ClippingNode.ALPHA_TO_COVERAGE) return this.setupAlphaToCoverage(intersectionPlanes, unionPlanes);
        else if (this.scope === $d89c9137a3d237c2$var$ClippingNode.HARDWARE) return this.setupHardwareClipping(unionPlanes, builder);
        else return this.setupDefault(intersectionPlanes, unionPlanes);
    }
    /**
	 * Setups alpha to coverage.
	 *
	 * @param {Array<Vector4>} intersectionPlanes - The intersection planes.
	 * @param {Array<Vector4>} unionPlanes - The union planes.
	 * @return {Node} The result node.
	 */ setupAlphaToCoverage(intersectionPlanes, unionPlanes) {
        return $d89c9137a3d237c2$var$Fn(()=>{
            const distanceToPlane = $d89c9137a3d237c2$var$float().toVar('distanceToPlane');
            const distanceGradient = $d89c9137a3d237c2$var$float().toVar('distanceToGradient');
            const clipOpacity = $d89c9137a3d237c2$var$float(1).toVar('clipOpacity');
            const numUnionPlanes = unionPlanes.length;
            if (this.hardwareClipping === false && numUnionPlanes > 0) {
                const clippingPlanes = $d89c9137a3d237c2$var$uniformArray(unionPlanes).setGroup($d89c9137a3d237c2$var$renderGroup);
                $d89c9137a3d237c2$var$Loop(numUnionPlanes, ({ i: i })=>{
                    const plane = clippingPlanes.element(i);
                    distanceToPlane.assign($d89c9137a3d237c2$var$positionView.dot(plane.xyz).negate().add(plane.w));
                    distanceGradient.assign(distanceToPlane.fwidth().div(2.0));
                    clipOpacity.mulAssign($d89c9137a3d237c2$var$smoothstep(distanceGradient.negate(), distanceGradient, distanceToPlane));
                });
            }
            const numIntersectionPlanes = intersectionPlanes.length;
            if (numIntersectionPlanes > 0) {
                const clippingPlanes = $d89c9137a3d237c2$var$uniformArray(intersectionPlanes).setGroup($d89c9137a3d237c2$var$renderGroup);
                const intersectionClipOpacity = $d89c9137a3d237c2$var$float(1).toVar('intersectionClipOpacity');
                $d89c9137a3d237c2$var$Loop(numIntersectionPlanes, ({ i: i })=>{
                    const plane = clippingPlanes.element(i);
                    distanceToPlane.assign($d89c9137a3d237c2$var$positionView.dot(plane.xyz).negate().add(plane.w));
                    distanceGradient.assign(distanceToPlane.fwidth().div(2.0));
                    intersectionClipOpacity.mulAssign($d89c9137a3d237c2$var$smoothstep(distanceGradient.negate(), distanceGradient, distanceToPlane).oneMinus());
                });
                clipOpacity.mulAssign(intersectionClipOpacity.oneMinus());
            }
            $d89c9137a3d237c2$var$diffuseColor.a.mulAssign(clipOpacity);
            $d89c9137a3d237c2$var$diffuseColor.a.equal(0.0).discard();
        })();
    }
    /**
	 * Setups the default clipping.
	 *
	 * @param {Array<Vector4>} intersectionPlanes - The intersection planes.
	 * @param {Array<Vector4>} unionPlanes - The union planes.
	 * @return {Node} The result node.
	 */ setupDefault(intersectionPlanes, unionPlanes) {
        return $d89c9137a3d237c2$var$Fn(()=>{
            const numUnionPlanes = unionPlanes.length;
            if (this.hardwareClipping === false && numUnionPlanes > 0) {
                const clippingPlanes = $d89c9137a3d237c2$var$uniformArray(unionPlanes).setGroup($d89c9137a3d237c2$var$renderGroup);
                $d89c9137a3d237c2$var$Loop(numUnionPlanes, ({ i: i })=>{
                    const plane = clippingPlanes.element(i);
                    $d89c9137a3d237c2$var$positionView.dot(plane.xyz).greaterThan(plane.w).discard();
                });
            }
            const numIntersectionPlanes = intersectionPlanes.length;
            if (numIntersectionPlanes > 0) {
                const clippingPlanes = $d89c9137a3d237c2$var$uniformArray(intersectionPlanes).setGroup($d89c9137a3d237c2$var$renderGroup);
                const clipped = $d89c9137a3d237c2$var$bool(true).toVar('clipped');
                $d89c9137a3d237c2$var$Loop(numIntersectionPlanes, ({ i: i })=>{
                    const plane = clippingPlanes.element(i);
                    clipped.assign($d89c9137a3d237c2$var$positionView.dot(plane.xyz).greaterThan(plane.w).and(clipped));
                });
                clipped.discard();
            }
        })();
    }
    /**
	 * Setups hardware clipping.
	 *
	 * @param {Array<Vector4>} unionPlanes - The union planes.
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node} The result node.
	 */ setupHardwareClipping(unionPlanes, builder) {
        const numUnionPlanes = unionPlanes.length;
        builder.enableHardwareClipping(numUnionPlanes);
        return $d89c9137a3d237c2$var$Fn(()=>{
            const clippingPlanes = $d89c9137a3d237c2$var$uniformArray(unionPlanes).setGroup($d89c9137a3d237c2$var$renderGroup);
            const hw_clip_distances = $d89c9137a3d237c2$var$builtin(builder.getClipDistance());
            $d89c9137a3d237c2$var$Loop(numUnionPlanes, ({ i: i })=>{
                const plane = clippingPlanes.element(i);
                const distance = $d89c9137a3d237c2$var$positionView.dot(plane.xyz).sub(plane.w).negate();
                hw_clip_distances.element(i).assign(distance);
            });
        })();
    }
}
$d89c9137a3d237c2$var$ClippingNode.ALPHA_TO_COVERAGE = 'alphaToCoverage';
$d89c9137a3d237c2$var$ClippingNode.DEFAULT = 'default';
$d89c9137a3d237c2$var$ClippingNode.HARDWARE = 'hardware';
/**
 * TSL function for setting up the default clipping logic.
 *
 * @tsl
 * @function
 * @returns {ClippingNode}
 */ const $d89c9137a3d237c2$var$clipping = ()=>new $d89c9137a3d237c2$var$ClippingNode();
/**
 * TSL function for setting up alpha to coverage.
 *
 * @tsl
 * @function
 * @returns {ClippingNode}
 */ const $d89c9137a3d237c2$var$clippingAlpha = ()=>new $d89c9137a3d237c2$var$ClippingNode($d89c9137a3d237c2$var$ClippingNode.ALPHA_TO_COVERAGE);
/**
 * TSL function for setting up hardware-based clipping.
 *
 * @tsl
 * @function
 * @returns {ClippingNode}
 */ const $d89c9137a3d237c2$var$hardwareClipping = ()=>new $d89c9137a3d237c2$var$ClippingNode($d89c9137a3d237c2$var$ClippingNode.HARDWARE);
// See: https://casual-effects.com/research/Wyman2017Hashed/index.html
const $d89c9137a3d237c2$var$ALPHA_HASH_SCALE = 0.05; // Derived from trials only, and may be changed.
const $d89c9137a3d237c2$var$hash2D = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([value])=>{
    return $d89c9137a3d237c2$var$fract($d89c9137a3d237c2$var$mul(1.0e4, $d89c9137a3d237c2$var$sin($d89c9137a3d237c2$var$mul(17.0, value.x).add($d89c9137a3d237c2$var$mul(0.1, value.y)))).mul($d89c9137a3d237c2$var$add(0.1, $d89c9137a3d237c2$var$abs($d89c9137a3d237c2$var$sin($d89c9137a3d237c2$var$mul(13.0, value.y).add(value.x))))));
});
const $d89c9137a3d237c2$var$hash3D = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([value])=>{
    return $d89c9137a3d237c2$var$hash2D($d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$hash2D(value.xy), value.z));
});
const $d89c9137a3d237c2$var$getAlphaHashThreshold = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([position])=>{
    // Find the discretized derivatives of our coordinates
    const maxDeriv = $d89c9137a3d237c2$var$max$1($d89c9137a3d237c2$var$length($d89c9137a3d237c2$var$dFdx(position.xyz)), $d89c9137a3d237c2$var$length($d89c9137a3d237c2$var$dFdy(position.xyz)));
    const pixScale = $d89c9137a3d237c2$var$float(1).div($d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$ALPHA_HASH_SCALE).mul(maxDeriv)).toVar('pixScale');
    // Find two nearest log-discretized noise scales
    const pixScales = $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$exp2($d89c9137a3d237c2$var$floor($d89c9137a3d237c2$var$log2(pixScale))), $d89c9137a3d237c2$var$exp2($d89c9137a3d237c2$var$ceil($d89c9137a3d237c2$var$log2(pixScale))));
    // Compute alpha thresholds at our two noise scales
    const alpha = $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$hash3D($d89c9137a3d237c2$var$floor(pixScales.x.mul(position.xyz))), $d89c9137a3d237c2$var$hash3D($d89c9137a3d237c2$var$floor(pixScales.y.mul(position.xyz))));
    // Factor to interpolate lerp with
    const lerpFactor = $d89c9137a3d237c2$var$fract($d89c9137a3d237c2$var$log2(pixScale));
    // Interpolate alpha threshold from noise at two scales
    const x = $d89c9137a3d237c2$var$add($d89c9137a3d237c2$var$mul(lerpFactor.oneMinus(), alpha.x), $d89c9137a3d237c2$var$mul(lerpFactor, alpha.y));
    // Pass into CDF to compute uniformly distrib threshold
    const a = $d89c9137a3d237c2$var$min$1(lerpFactor, lerpFactor.oneMinus());
    const cases = $d89c9137a3d237c2$var$vec3(x.mul(x).div($d89c9137a3d237c2$var$mul(2.0, a).mul($d89c9137a3d237c2$var$sub(1.0, a))), x.sub($d89c9137a3d237c2$var$mul(0.5, a)).div($d89c9137a3d237c2$var$sub(1.0, a)), $d89c9137a3d237c2$var$sub(1.0, $d89c9137a3d237c2$var$sub(1.0, x).mul($d89c9137a3d237c2$var$sub(1.0, x)).div($d89c9137a3d237c2$var$mul(2.0, a).mul($d89c9137a3d237c2$var$sub(1.0, a)))));
    // Find our final, uniformly distributed alpha threshold (ατ)
    const threshold = x.lessThan(a.oneMinus()).select(x.lessThan(a).select(cases.x, cases.y), cases.z);
    // Avoids ατ == 0. Could also do ατ =1-ατ
    return $d89c9137a3d237c2$var$clamp(threshold, 1.0e-6, 1.0);
}).setLayout({
    name: 'getAlphaHashThreshold',
    type: 'float',
    inputs: [
        {
            name: 'position',
            type: 'vec3'
        }
    ]
});
/**
 * An attribute node for representing vertex colors.
 *
 * @augments AttributeNode
 */ class $d89c9137a3d237c2$export$b7d0e1b17d89bc37 extends $d89c9137a3d237c2$export$dc88047a888cd46b {
    static get type() {
        return 'VertexColorNode';
    }
    /**
	 * Constructs a new vertex color node.
	 *
	 * @param {number} index - The attribute index.
	 */ constructor(index){
        super(null, 'vec4');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVertexColorNode = true;
        /**
		 * The attribute index to enable more than one sets of vertex colors.
		 *
		 * @type {number}
		 * @default 0
		 */ this.index = index;
    }
    /**
	 * Overwrites the default implementation by honoring the attribute index.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The attribute name.
	 */ getAttributeName() {
        const index = this.index;
        return 'color' + (index > 0 ? index : '');
    }
    generate(builder) {
        const attributeName = this.getAttributeName(builder);
        const geometryAttribute = builder.hasGeometryAttribute(attributeName);
        let result;
        if (geometryAttribute === true) result = super.generate(builder);
        else // Vertex color fallback should be white
        result = builder.generateConst(this.nodeType, new (0, $329ek.Vector4)(1, 1, 1, 1));
        return result;
    }
    serialize(data) {
        super.serialize(data);
        data.index = this.index;
    }
    deserialize(data) {
        super.deserialize(data);
        this.index = data.index;
    }
}
/**
 * TSL function for creating a reference node.
 *
 * @tsl
 * @function
 * @param {number} [index=0] - The attribute index.
 * @returns {VertexColorNode}
 */ const $d89c9137a3d237c2$var$vertexColor = (index = 0)=>new $d89c9137a3d237c2$export$b7d0e1b17d89bc37(index);
/**
 * Represents a "Color Burn" blend mode.
 *
 * It's designed to darken the base layer's colors based on the color of the blend layer.
 * It significantly increases the contrast of the base layer, making the colors more vibrant and saturated.
 * The darker the color in the blend layer, the stronger the darkening and contrast effect on the base layer.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} base - The base color.
 * @param {Node<vec3>} blend - The blend color. A white (#ffffff) blend color does not alter the base color.
 * @return {Node<vec3>} The result.
 */ const $d89c9137a3d237c2$var$blendBurn = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([base, blend])=>{
    return $d89c9137a3d237c2$var$min$1(1.0, base.oneMinus().div(blend)).oneMinus();
}).setLayout({
    name: 'blendBurn',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});
/**
 * Represents a "Color Dodge" blend mode.
 *
 * It's designed to lighten the base layer's colors based on the color of the blend layer.
 * It significantly increases the brightness of the base layer, making the colors lighter and more vibrant.
 * The brighter the color in the blend layer, the stronger the lightening and contrast effect on the base layer.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} base - The base color.
 * @param {Node<vec3>} blend - The blend color. A black (#000000) blend color does not alter the base color.
 * @return {Node<vec3>} The result.
 */ const $d89c9137a3d237c2$var$blendDodge = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([base, blend])=>{
    return $d89c9137a3d237c2$var$min$1(base.div(blend.oneMinus()), 1.0);
}).setLayout({
    name: 'blendDodge',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});
/**
 * Represents a "Screen" blend mode.
 *
 * Similar to `blendDodge()`, this mode also lightens the base layer's colors based on the color of the blend layer.
 * The "Screen" blend mode is better for general brightening whereas the "Dodge" results in more subtle and nuanced
 * effects.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} base - The base color.
 * @param {Node<vec3>} blend - The blend color. A black (#000000) blend color does not alter the base color.
 * @return {Node<vec3>} The result.
 */ const $d89c9137a3d237c2$var$blendScreen = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([base, blend])=>{
    return base.oneMinus().mul(blend.oneMinus()).oneMinus();
}).setLayout({
    name: 'blendScreen',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});
/**
 * Represents a "Overlay" blend mode.
 *
 * It's designed to increase the contrast of the base layer based on the color of the blend layer.
 * It amplifies the existing colors and contrast in the base layer, making lighter areas lighter and darker areas darker.
 * The color of the blend layer significantly influences the resulting contrast and color shift in the base layer.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} base - The base color.
 * @param {Node<vec3>} blend - The blend color
 * @return {Node<vec3>} The result.
 */ const $d89c9137a3d237c2$var$blendOverlay = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([base, blend])=>{
    return $d89c9137a3d237c2$var$mix(base.mul(2.0).mul(blend), base.oneMinus().mul(2.0).mul(blend.oneMinus()).oneMinus(), $d89c9137a3d237c2$var$step(0.5, base));
}).setLayout({
    name: 'blendOverlay',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});
/**
 * This function blends two color based on their alpha values by replicating the behavior of `THREE.NormalBlending`.
 * It assumes both input colors have non-premultiplied alpha.
 *
 * @tsl
 * @function
 * @param {Node<vec4>} base - The base color.
 * @param {Node<vec4>} blend - The blend color
 * @return {Node<vec4>} The result.
 */ const $d89c9137a3d237c2$var$blendColor = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([base, blend])=>{
    const outAlpha = blend.a.add(base.a.mul(blend.a.oneMinus()));
    return $d89c9137a3d237c2$var$vec4(blend.rgb.mul(blend.a).add(base.rgb.mul(base.a).mul(blend.a.oneMinus())).div(outAlpha), outAlpha);
}).setLayout({
    name: 'blendColor',
    type: 'vec4',
    inputs: [
        {
            name: 'base',
            type: 'vec4'
        },
        {
            name: 'blend',
            type: 'vec4'
        }
    ]
});
/**
 * Premultiplies the RGB channels of a color by its alpha channel.
 *
 * This function is useful for converting a non-premultiplied alpha color
 * into a premultiplied alpha format, where the RGB values are scaled
 * by the alpha value. Premultiplied alpha is often used in graphics
 * rendering for certain operations, such as compositing and image processing.
 *
 * @tsl
 * @function
 * @param {Node<vec4>} color - The input color with non-premultiplied alpha.
 * @return {Node<vec4>} The color with premultiplied alpha.
 */ const $d89c9137a3d237c2$var$premultiplyAlpha = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color])=>{
    return $d89c9137a3d237c2$var$vec4(color.rgb.mul(color.a), color.a);
}, {
    color: 'vec4',
    return: 'vec4'
});
/**
 * Unpremultiplies the RGB channels of a color by its alpha channel.
 *
 * This function is useful for converting a premultiplied alpha color
 * back into a non-premultiplied alpha format, where the RGB values are
 * divided by the alpha value. Unpremultiplied alpha is often used in graphics
 * rendering for certain operations, such as compositing and image processing.
 *
 * @tsl
 * @function
 * @param {Node<vec4>} color - The input color with premultiplied alpha.
 * @return {Node<vec4>} The color with non-premultiplied alpha.
 */ const $d89c9137a3d237c2$var$unpremultiplyAlpha = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color])=>{
    $d89c9137a3d237c2$var$If(color.a.equal(0.0), ()=>$d89c9137a3d237c2$var$vec4(0.0));
    return $d89c9137a3d237c2$var$vec4(color.rgb.div(color.a), color.a);
}, {
    color: 'vec4',
    return: 'vec4'
});
// Deprecated
/**
 * @tsl
 * @function
 * @deprecated since r171. Use {@link blendBurn} instead.
 *
 * @param {...any} params
 * @returns {Function}
 */ const $d89c9137a3d237c2$var$burn = (...params)=>{
    (0, $329ek.warn)('TSL: "burn" has been renamed. Use "blendBurn" instead.');
    return $d89c9137a3d237c2$var$blendBurn(params);
};
/**
 * @tsl
 * @function
 * @deprecated since r171. Use {@link blendDodge} instead.
 *
 * @param {...any} params
 * @returns {Function}
 */ const $d89c9137a3d237c2$var$dodge = (...params)=>{
    (0, $329ek.warn)('TSL: "dodge" has been renamed. Use "blendDodge" instead.');
    return $d89c9137a3d237c2$var$blendDodge(params);
};
/**
 * @tsl
 * @function
 * @deprecated since r171. Use {@link blendScreen} instead.
 *
 * @param {...any} params
 * @returns {Function}
 */ const $d89c9137a3d237c2$var$screen = (...params)=>{
    (0, $329ek.warn)('TSL: "screen" has been renamed. Use "blendScreen" instead.');
    return $d89c9137a3d237c2$var$blendScreen(params);
};
/**
 * @tsl
 * @function
 * @deprecated since r171. Use {@link blendOverlay} instead.
 *
 * @param {...any} params
 * @returns {Function}
 */ const $d89c9137a3d237c2$var$overlay = (...params)=>{
    (0, $329ek.warn)('TSL: "overlay" has been renamed. Use "blendOverlay" instead.');
    return $d89c9137a3d237c2$var$blendOverlay(params);
};
/**
 * Base class for all node materials.
 *
 * @augments Material
 */ class $d89c9137a3d237c2$export$caaf3b30a544c946 extends (0, $329ek.Material) {
    static get type() {
        return 'NodeMaterial';
    }
    /**
	 * Represents the type of the node material.
	 *
	 * @type {string}
	 */ get type() {
        return this.constructor.type;
    }
    set type(_value) {}
    /**
	 * Constructs a new node material.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeMaterial = true;
        /**
		 * Whether this material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        /**
		 * Whether this material is affected by lights or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.lights = false;
        /**
		 * Whether this material uses hardware clipping or not.
		 * This property is managed by the engine and should not be
		 * modified by apps.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.hardwareClipping = false;
        /**
		 * Node materials which set their `lights` property to `true`
		 * are affected by all lights of the scene. Sometimes selective
		 * lighting is wanted which means only _some_ lights in the scene
		 * affect a material. This can be achieved by creating an instance
		 * of {@link LightsNode} with a list of selective
		 * lights and assign the node to this property.
		 *
		 * ```js
		 * const customLightsNode = lights( [ light1, light2 ] );
		 * material.lightsNode = customLightsNode;
		 * ```
		 *
		 * @type {?LightsNode}
		 * @default null
		 */ this.lightsNode = null;
        /**
		 * The environment of node materials can be defined by an environment
		 * map assigned to the `envMap` property or by `Scene.environment`
		 * if the node material is a PBR material. This node property allows to overwrite
		 * the default behavior and define the environment with a custom node.
		 *
		 * ```js
		 * material.envNode = pmremTexture( renderTarget.texture );
		 * ```
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.envNode = null;
        /**
		 * The lighting of node materials might be influenced by ambient occlusion.
		 * The default AO is inferred from an ambient occlusion map assigned to `aoMap`
		 * and the respective `aoMapIntensity`. This node property allows to overwrite
		 * the default and define the ambient occlusion with a custom node instead.
		 *
		 * If you don't want to overwrite the diffuse color but modify the existing
		 * values instead, use {@link materialAO}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.aoNode = null;
        /**
		 * The diffuse color of node materials is by default inferred from the
		 * `color` and `map` properties. This node property allows to overwrite the default
		 * and define the diffuse color with a node instead.
		 *
		 * ```js
		 * material.colorNode = color( 0xff0000 ); // define red color
		 * ```
		 *
		 * If you don't want to overwrite the diffuse color but modify the existing
		 * values instead, use {@link materialColor}.
		 *
		 * ```js
		 * material.colorNode = materialColor.mul( color( 0xff0000 ) ); // give diffuse colors a red tint
		 * ```
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.colorNode = null;
        /**
		 * The normals of node materials are by default inferred from the `normalMap`/`normalScale`
		 * or `bumpMap`/`bumpScale` properties. This node property allows to overwrite the default
		 * and define the normals with a node instead.
		 *
		 * If you don't want to overwrite the normals but modify the existing values instead,
		 * use {@link materialNormal}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.normalNode = null;
        /**
		 * The opacity of node materials is by default inferred from the `opacity`
		 * and `alphaMap` properties. This node property allows to overwrite the default
		 * and define the opacity with a node instead.
		 *
		 * If you don't want to overwrite the opacity but modify the existing
		 * value instead, use {@link materialOpacity}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.opacityNode = null;
        /**
		 * This node can be used to implement a variety of filter-like effects. The idea is
		 * to store the current rendering into a texture e.g. via `viewportSharedTexture()`, use it
		 * to create an arbitrary effect and then assign the node composition to this property.
		 * Everything behind the object using this material will now be affected by a filter.
		 *
		 * ```js
		 * const material = new NodeMaterial()
		 * material.transparent = true;
		 *
		 * // everything behind the object will be monochromatic
		 * material.backdropNode = saturation( viewportSharedTexture().rgb, 0 );
		 * ```
		 *
		 * Backdrop computations are part of the lighting so only lit materials can use this property.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.backdropNode = null;
        /**
		 * This node allows to modulate the influence of `backdropNode` to the outgoing light.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.backdropAlphaNode = null;
        /**
		 * The alpha test of node materials is by default inferred from the `alphaTest`
		 * property. This node property allows to overwrite the default and define the
		 * alpha test with a node instead.
		 *
		 * If you don't want to overwrite the alpha test but modify the existing
		 * value instead, use {@link materialAlphaTest}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.alphaTestNode = null;
        /**
		 * Discards the fragment if the mask value is `false`.
		 *
		 * @type {?Node<bool>}
		 * @default null
		 */ this.maskNode = null;
        /**
		 * The local vertex positions are computed based on multiple factors like the
		 * attribute data, morphing or skinning. This node property allows to overwrite
		 * the default and define local vertex positions with nodes instead.
		 *
		 * If you don't want to overwrite the vertex positions but modify the existing
		 * values instead, use {@link positionLocal}.
		 *
		 *```js
		 * material.positionNode = positionLocal.add( displace );
		 * ```
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.positionNode = null;
        /**
		 * This node property is intended for logic which modifies geometry data once or per animation step.
		 * Apps usually place such logic randomly in initialization routines or in the animation loop.
		 * `geometryNode` is intended as a dedicated API so there is an intended spot where geometry modifications
		 * can be implemented.
		 *
		 * The idea is to assign a `Fn` definition that holds the geometry modification logic. A typical example
		 * would be a GPU based particle system that provides a node material for usage on app level. The particle
		 * simulation would be implemented as compute shaders and managed inside a `Fn` function. This function is
		 * eventually assigned to `geometryNode`.
		 *
		 * @type {?Function}
		 * @default null
		 */ this.geometryNode = null;
        /**
		 * Allows to overwrite depth values in the fragment shader.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.depthNode = null;
        /**
		 * Allows to overwrite the position used for shadow map rendering which
		 * is by default {@link positionWorld}, the vertex position
		 * in world space.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.receivedShadowPositionNode = null;
        /**
		 * Allows to overwrite the geometry position used for shadow map projection which
		 * is by default {@link positionLocal}, the vertex position in local space.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.castShadowPositionNode = null;
        /**
		 * This node can be used to influence how an object using this node material
		 * receive shadows.
		 *
		 * ```js
		 * const totalShadows = float( 1 ).toVar();
		 * material.receivedShadowNode = Fn( ( [ shadow ] ) => {
		 * 	totalShadows.mulAssign( shadow );
		 * 	//return float( 1 ); // bypass received shadows
		 * 	return shadow.mix( color( 0xff0000 ), 1 ); // modify shadow color
		 * } );
		 *
		 * @type {?(Function|FunctionNode<vec4>)}
		 * @default null
		 */ this.receivedShadowNode = null;
        /**
		 * This node can be used to influence how an object using this node material
		 * casts shadows. To apply a color to shadows, you can simply do:
		 *
		 * ```js
		 * material.castShadowNode = vec4( 1, 0, 0, 1 );
		 * ```
		 *
		 * Which can be nice to fake colored shadows of semi-transparent objects. It
		 * is also common to use the property with `Fn` function so checks are performed
		 * per fragment.
		 *
		 * ```js
		 * materialCustomShadow.castShadowNode = Fn( () => {
		 * 	hash( vertexIndex ).greaterThan( 0.5 ).discard();
		 * 	return materialColor;
		 * } )();
		 *  ```
		 *
		 * @type {?Node<vec4>}
		 * @default null
		 */ this.castShadowNode = null;
        /**
		 * This node can be used to define the final output of the material.
		 *
		 * TODO: Explain the differences to `fragmentNode`.
		 *
		 * @type {?Node<vec4>}
		 * @default null
		 */ this.outputNode = null;
        /**
		 * MRT configuration is done on renderer or pass level. This node allows to
		 * overwrite what values are written into MRT targets on material level. This
		 * can be useful for implementing selective FX features that should only affect
		 * specific objects.
		 *
		 * @type {?MRTNode}
		 * @default null
		 */ this.mrtNode = null;
        /**
		 * This node property can be used if you need complete freedom in implementing
		 * the fragment shader. Assigning a node will replace the built-in material
		 * logic used in the fragment stage.
		 *
		 * @type {?Node<vec4>}
		 * @default null
		 */ this.fragmentNode = null;
        /**
		 * This node property can be used if you need complete freedom in implementing
		 * the vertex shader. Assigning a node will replace the built-in material logic
		 * used in the vertex stage.
		 *
		 * @type {?Node<vec4>}
		 * @default null
		 */ this.vertexNode = null;
        /**
		 * This node can be used as a global context management component for this material.
		 *
		 * @type {?ContextNode}
		 * @default null
		 */ this.contextNode = null;
        // Deprecated properties
        Object.defineProperty(this, 'shadowPositionNode', {
            get: ()=>{
                return this.receivedShadowPositionNode;
            },
            set: (value)=>{
                (0, $329ek.warn)('NodeMaterial: ".shadowPositionNode" was renamed to ".receivedShadowPositionNode".');
                this.receivedShadowPositionNode = value;
            }
        });
    }
    /**
	 * Returns an array of child nodes for this material.
	 *
	 * @private
	 * @returns {Array<{property: string, childNode: Node}>}
	 */ _getNodeChildren() {
        const children = [];
        for (const property of Object.getOwnPropertyNames(this)){
            if (property.startsWith('_') === true) continue;
            const object = this[property];
            if (object && object.isNode === true) children.push({
                property: property,
                childNode: object
            });
        }
        return children;
    }
    /**
	 * Allows to define a custom cache key that influence the material key computation
	 * for render objects.
	 *
	 * @return {string} The custom cache key.
	 */ customProgramCacheKey() {
        const values = [];
        for (const { property: property, childNode: childNode } of this._getNodeChildren())values.push($d89c9137a3d237c2$var$hashString(property.slice(0, -4)), childNode.getCacheKey());
        return this.type + $d89c9137a3d237c2$var$hashArray(values);
    }
    /**
	 * Builds this material with the given node builder.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ build(builder) {
        this.setup(builder);
    }
    /**
	 * Setups a node material observer with the given builder.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {NodeMaterialObserver} The node material observer.
	 */ setupObserver(builder) {
        return new $d89c9137a3d237c2$export$4f65c0b4ff530286(builder);
    }
    /**
	 * Setups the vertex and fragment stage of this node material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        builder.context.setupNormal = ()=>$d89c9137a3d237c2$var$subBuild(this.setupNormal(builder), 'NORMAL', 'vec3');
        builder.context.setupPositionView = ()=>this.setupPositionView(builder);
        builder.context.setupModelViewProjection = ()=>this.setupModelViewProjection(builder);
        const renderer = builder.renderer;
        const renderTarget = renderer.getRenderTarget();
        // < CONTEXT >
        if (renderer.contextNode.isContextNode === true) builder.context = {
            ...builder.context,
            ...renderer.contextNode.getFlowContextData()
        };
        else (0, $329ek.error)('NodeMaterial: "renderer.contextNode" must be an instance of `context()`.');
        if (this.contextNode !== null) {
            if (this.contextNode.isContextNode === true) builder.context = {
                ...builder.context,
                ...this.contextNode.getFlowContextData()
            };
            else (0, $329ek.error)('NodeMaterial: "material.contextNode" must be an instance of `context()`.');
        }
        // < VERTEX STAGE >
        builder.addStack();
        const mvp = $d89c9137a3d237c2$var$subBuild(this.setupVertex(builder), 'VERTEX');
        const vertexNode = this.vertexNode || mvp;
        builder.stack.outputNode = vertexNode;
        this.setupHardwareClipping(builder);
        if (this.geometryNode !== null) builder.stack.outputNode = builder.stack.outputNode.bypass(this.geometryNode);
        builder.addFlow('vertex', builder.removeStack());
        // < FRAGMENT STAGE >
        builder.addStack();
        let resultNode;
        const clippingNode = this.setupClipping(builder);
        if (this.depthWrite === true || this.depthTest === true) {
            // only write depth if depth buffer is configured
            if (renderTarget !== null) {
                if (renderTarget.depthBuffer === true) this.setupDepth(builder);
            } else if (renderer.depth === true) this.setupDepth(builder);
        }
        if (this.fragmentNode === null) {
            this.setupDiffuseColor(builder);
            this.setupVariants(builder);
            const outgoingLightNode = this.setupLighting(builder);
            if (clippingNode !== null) builder.stack.addToStack(clippingNode);
            // force unsigned floats - useful for RenderTargets
            const basicOutput = $d89c9137a3d237c2$var$vec4(outgoingLightNode, $d89c9137a3d237c2$var$diffuseColor.a).max(0);
            resultNode = this.setupOutput(builder, basicOutput);
            // OUTPUT NODE
            $d89c9137a3d237c2$var$output.assign(resultNode);
            //
            const isCustomOutput = this.outputNode !== null;
            if (isCustomOutput) resultNode = this.outputNode;
            //
            if (builder.context.getOutput) resultNode = builder.context.getOutput(resultNode, builder);
            // MRT
            if (renderTarget !== null) {
                const mrt = renderer.getMRT();
                const materialMRT = this.mrtNode;
                if (mrt !== null) {
                    if (isCustomOutput) $d89c9137a3d237c2$var$output.assign(resultNode);
                    resultNode = mrt;
                    if (materialMRT !== null) resultNode = mrt.merge(materialMRT);
                } else if (materialMRT !== null) resultNode = materialMRT;
            }
        } else {
            let fragmentNode = this.fragmentNode;
            if (fragmentNode.isOutputStructNode !== true) fragmentNode = $d89c9137a3d237c2$var$vec4(fragmentNode);
            resultNode = this.setupOutput(builder, fragmentNode);
        }
        builder.stack.outputNode = resultNode;
        builder.addFlow('fragment', builder.removeStack());
        // < OBSERVER >
        builder.observer = this.setupObserver(builder);
    }
    /**
	 * Setups the clipping node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {ClippingNode} The clipping node.
	 */ setupClipping(builder) {
        if (builder.clippingContext === null) return null;
        const { unionPlanes: unionPlanes, intersectionPlanes: intersectionPlanes } = builder.clippingContext;
        let result = null;
        if (unionPlanes.length > 0 || intersectionPlanes.length > 0) {
            const samples = builder.renderer.currentSamples;
            if (this.alphaToCoverage && samples > 1) // to be added to flow when the color/alpha value has been determined
            result = $d89c9137a3d237c2$var$clippingAlpha();
            else builder.stack.addToStack($d89c9137a3d237c2$var$clipping());
        }
        return result;
    }
    /**
	 * Setups the hardware clipping if available on the current device.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupHardwareClipping(builder) {
        this.hardwareClipping = false;
        if (builder.clippingContext === null) return;
        const candidateCount = builder.clippingContext.unionPlanes.length;
        // 8 planes supported by WebGL ANGLE_clip_cull_distance and WebGPU clip-distances
        if (candidateCount > 0 && candidateCount <= 8 && builder.isAvailable('clipDistance')) {
            builder.stack.addToStack($d89c9137a3d237c2$var$hardwareClipping());
            this.hardwareClipping = true;
        }
        return;
    }
    /**
	 * Setups the depth of this material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupDepth(builder) {
        const { renderer: renderer, camera: camera } = builder;
        // Depth
        let depthNode = this.depthNode;
        if (depthNode === null) {
            const mrt = renderer.getMRT();
            if (mrt && mrt.has('depth')) depthNode = mrt.get('depth');
            else if (renderer.logarithmicDepthBuffer === true) {
                if (camera.isPerspectiveCamera) depthNode = $d89c9137a3d237c2$var$viewZToLogarithmicDepth($d89c9137a3d237c2$var$positionView.z, $d89c9137a3d237c2$var$cameraNear, $d89c9137a3d237c2$var$cameraFar);
                else depthNode = $d89c9137a3d237c2$var$viewZToOrthographicDepth($d89c9137a3d237c2$var$positionView.z, $d89c9137a3d237c2$var$cameraNear, $d89c9137a3d237c2$var$cameraFar);
            }
        }
        if (depthNode !== null) $d89c9137a3d237c2$var$depth.assign(depthNode).toStack();
    }
    /**
	 * Setups the position node in view space. This method exists
	 * so derived node materials can modify the implementation e.g. sprite materials.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The position in view space.
	 */ setupPositionView() {
        return $d89c9137a3d237c2$var$modelViewMatrix.mul($d89c9137a3d237c2$var$positionLocal).xyz;
    }
    /**
	 * Setups the position in clip space.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec4>} The position in view space.
	 */ setupModelViewProjection() {
        return $d89c9137a3d237c2$var$cameraProjectionMatrix.mul($d89c9137a3d237c2$var$positionView);
    }
    /**
	 * Setups the logic for the vertex stage.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec4>} The position in clip space.
	 */ setupVertex(builder) {
        builder.addStack();
        this.setupPosition(builder);
        builder.context.vertex = builder.removeStack();
        return $d89c9137a3d237c2$var$modelViewProjection;
    }
    /**
	 * Setups the computation of the position in local space.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The position in local space.
	 */ setupPosition(builder) {
        const { object: object, geometry: geometry } = builder;
        if (geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color) $d89c9137a3d237c2$var$morphReference(object).toStack();
        if (object.isSkinnedMesh === true) $d89c9137a3d237c2$var$skinning(object).toStack();
        if (this.displacementMap) {
            const displacementMap = $d89c9137a3d237c2$var$materialReference('displacementMap', 'texture');
            const displacementScale = $d89c9137a3d237c2$var$materialReference('displacementScale', 'float');
            const displacementBias = $d89c9137a3d237c2$var$materialReference('displacementBias', 'float');
            $d89c9137a3d237c2$var$positionLocal.addAssign($d89c9137a3d237c2$var$normalLocal.normalize().mul(displacementMap.x.mul(displacementScale).add(displacementBias)));
        }
        if (object.isBatchedMesh) $d89c9137a3d237c2$var$batch(object).toStack();
        if (object.isInstancedMesh && object.instanceMatrix && object.instanceMatrix.isInstancedBufferAttribute === true) $d89c9137a3d237c2$var$instancedMesh(object).toStack();
        if (this.positionNode !== null) $d89c9137a3d237c2$var$positionLocal.assign($d89c9137a3d237c2$var$subBuild(this.positionNode, 'POSITION', 'vec3'));
        return $d89c9137a3d237c2$var$positionLocal;
    }
    /**
	 * Setups the computation of the material's diffuse color.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {BufferGeometry} geometry - The geometry.
	 */ setupDiffuseColor(builder) {
        const { object: object, geometry: geometry } = builder;
        // MASK
        if (this.maskNode !== null) // Discard if the mask is `false`
        $d89c9137a3d237c2$var$bool(this.maskNode).not().discard();
        // COLOR
        let colorNode = this.colorNode ? $d89c9137a3d237c2$var$vec4(this.colorNode) : $d89c9137a3d237c2$var$materialColor;
        // VERTEX COLORS
        if (this.vertexColors === true && geometry.hasAttribute('color')) colorNode = colorNode.mul($d89c9137a3d237c2$var$vertexColor());
        // INSTANCED COLORS
        if (object.instanceColor) {
            const instanceColor = $d89c9137a3d237c2$var$varyingProperty('vec3', 'vInstanceColor');
            colorNode = instanceColor.mul(colorNode);
        }
        if (object.isBatchedMesh && object._colorsTexture) {
            const batchColor = $d89c9137a3d237c2$var$varyingProperty('vec3', 'vBatchColor');
            colorNode = batchColor.mul(colorNode);
        }
        // DIFFUSE COLOR
        $d89c9137a3d237c2$var$diffuseColor.assign(colorNode);
        // OPACITY
        const opacityNode = this.opacityNode ? $d89c9137a3d237c2$var$float(this.opacityNode) : $d89c9137a3d237c2$var$materialOpacity;
        $d89c9137a3d237c2$var$diffuseColor.a.assign($d89c9137a3d237c2$var$diffuseColor.a.mul(opacityNode));
        // ALPHA TEST
        let alphaTestNode = null;
        if (this.alphaTestNode !== null || this.alphaTest > 0) {
            alphaTestNode = this.alphaTestNode !== null ? $d89c9137a3d237c2$var$float(this.alphaTestNode) : $d89c9137a3d237c2$var$materialAlphaTest;
            if (this.alphaToCoverage === true) {
                $d89c9137a3d237c2$var$diffuseColor.a = $d89c9137a3d237c2$var$smoothstep(alphaTestNode, alphaTestNode.add($d89c9137a3d237c2$var$fwidth($d89c9137a3d237c2$var$diffuseColor.a)), $d89c9137a3d237c2$var$diffuseColor.a);
                $d89c9137a3d237c2$var$diffuseColor.a.lessThanEqual(0).discard();
            } else $d89c9137a3d237c2$var$diffuseColor.a.lessThanEqual(alphaTestNode).discard();
        }
        // ALPHA HASH
        if (this.alphaHash === true) $d89c9137a3d237c2$var$diffuseColor.a.lessThan($d89c9137a3d237c2$var$getAlphaHashThreshold($d89c9137a3d237c2$var$positionLocal)).discard();
        // OPAQUE
        if (builder.isOpaque()) $d89c9137a3d237c2$var$diffuseColor.a.assign(1.0);
    }
    /**
	 * Abstract interface method that can be implemented by derived materials
	 * to setup material-specific node variables.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants() {
    // Interface function.
    }
    /**
	 * Setups the outgoing light node variable
	 *
	 * @return {Node<vec3>} The outgoing light node.
	 */ setupOutgoingLight() {
        return this.lights === true ? $d89c9137a3d237c2$var$vec3(0) : $d89c9137a3d237c2$var$diffuseColor.rgb;
    }
    /**
	 * Setups the normal node from the material.
	 *
	 * @return {Node<vec3>} The normal node.
	 */ setupNormal() {
        return this.normalNode ? $d89c9137a3d237c2$var$vec3(this.normalNode) : $d89c9137a3d237c2$var$materialNormal;
    }
    /**
	 * Setups the environment node from the material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec4>} The environment node.
	 */ setupEnvironment() {
        let node = null;
        if (this.envNode) node = this.envNode;
        else if (this.envMap) node = this.envMap.isCubeTexture ? $d89c9137a3d237c2$var$materialReference('envMap', 'cubeTexture') : $d89c9137a3d237c2$var$materialReference('envMap', 'texture');
        return node;
    }
    /**
	 * Setups the light map node from the material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The light map node.
	 */ setupLightMap(builder) {
        let node = null;
        if (builder.material.lightMap) node = new $d89c9137a3d237c2$export$26fe501f8a41ff48($d89c9137a3d237c2$var$materialLightMap);
        return node;
    }
    /**
	 * Setups the lights node based on the scene, environment and material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {LightsNode} The lights node.
	 */ setupLights(builder) {
        const materialLightsNode = [];
        //
        const envNode = this.setupEnvironment(builder);
        if (envNode && envNode.isLightingNode) materialLightsNode.push(envNode);
        const lightMapNode = this.setupLightMap(builder);
        if (lightMapNode && lightMapNode.isLightingNode) materialLightsNode.push(lightMapNode);
        let aoNode = this.aoNode;
        if (aoNode === null && builder.material.aoMap) aoNode = $d89c9137a3d237c2$var$materialAO;
        if (builder.context.getAO) aoNode = builder.context.getAO(aoNode, builder);
        if (aoNode) materialLightsNode.push(new $d89c9137a3d237c2$export$91e1d32e5b48fb53(aoNode));
        let lightsN = this.lightsNode || builder.lightsNode;
        if (materialLightsNode.length > 0) lightsN = builder.renderer.lighting.createNode([
            ...lightsN.getLights(),
            ...materialLightsNode
        ]);
        return lightsN;
    }
    /**
	 * This method should be implemented by most derived materials
	 * since it defines the material's lighting model.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {LightingModel} The lighting model.
	 */ setupLightingModel() {
    // Interface function.
    }
    /**
	 * Setups the outgoing light node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The outgoing light node.
	 */ setupLighting(builder) {
        const { material: material } = builder;
        const { backdropNode: backdropNode, backdropAlphaNode: backdropAlphaNode, emissiveNode: emissiveNode } = this;
        // OUTGOING LIGHT
        const lights = this.lights === true || this.lightsNode !== null;
        const lightsNode = lights ? this.setupLights(builder) : null;
        let outgoingLightNode = this.setupOutgoingLight(builder);
        if (lightsNode && lightsNode.getScope().hasLights) {
            const lightingModel = this.setupLightingModel(builder) || null;
            outgoingLightNode = $d89c9137a3d237c2$var$lightingContext(lightsNode, lightingModel, backdropNode, backdropAlphaNode);
        } else if (backdropNode !== null) outgoingLightNode = $d89c9137a3d237c2$var$vec3(backdropAlphaNode !== null ? $d89c9137a3d237c2$var$mix(outgoingLightNode, backdropNode, backdropAlphaNode) : backdropNode);
        // EMISSIVE
        if (emissiveNode && emissiveNode.isNode === true || material.emissive && material.emissive.isColor === true) {
            $d89c9137a3d237c2$var$emissive.assign($d89c9137a3d237c2$var$vec3(emissiveNode ? emissiveNode : $d89c9137a3d237c2$var$materialEmissive));
            outgoingLightNode = outgoingLightNode.add($d89c9137a3d237c2$var$emissive);
        }
        return outgoingLightNode;
    }
    /**
	 * Setup the fog.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node<vec4>} outputNode - The existing output node.
	 * @return {Node<vec4>} The output node.
	 */ setupFog(builder, outputNode) {
        const fogNode = builder.fogNode;
        if (fogNode) {
            $d89c9137a3d237c2$var$output.assign(outputNode);
            outputNode = $d89c9137a3d237c2$var$vec4(fogNode.toVar());
        }
        return outputNode;
    }
    /**
	 * Setups premultiplied alpha.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node<vec4>} outputNode - The existing output node.
	 * @return {Node<vec4>} The output node.
	 */ setupPremultipliedAlpha(builder, outputNode) {
        return $d89c9137a3d237c2$var$premultiplyAlpha(outputNode);
    }
    /**
	 * Setups the output node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node<vec4>} outputNode - The existing output node.
	 * @return {Node<vec4>} The output node.
	 */ setupOutput(builder, outputNode) {
        // FOG
        if (this.fog === true) outputNode = this.setupFog(builder, outputNode);
        // PREMULTIPLIED ALPHA
        if (this.premultipliedAlpha === true) outputNode = this.setupPremultipliedAlpha(builder, outputNode);
        return outputNode;
    }
    /**
	 * Most classic material types have a node pendant e.g. for `MeshBasicMaterial`
	 * there is `MeshBasicNodeMaterial`. This utility method is intended for
	 * defining all material properties of the classic type in the node type.
	 *
	 * @param {Material} material - The material to copy properties with their values to this node material.
	 */ setDefaultValues(material) {
        // This approach is to reuse the native refreshUniforms*
        // and turn available the use of features like transmission and environment in core
        for(const property in material){
            const value = material[property];
            if (this[property] === undefined) {
                this[property] = value;
                if (value && value.clone) this[property] = value.clone();
            }
        }
        const descriptors = Object.getOwnPropertyDescriptors(material.constructor.prototype);
        for(const key in descriptors)if (Object.getOwnPropertyDescriptor(this.constructor.prototype, key) === undefined && descriptors[key].get !== undefined) Object.defineProperty(this.constructor.prototype, key, descriptors[key]);
    }
    /**
	 * Serializes this material to JSON.
	 *
	 * @param {?(Object|string)} meta - The meta information for serialization.
	 * @return {Object} The serialized node.
	 */ toJSON(meta) {
        const isRoot = meta === undefined || typeof meta === 'string';
        if (isRoot) meta = {
            textures: {},
            images: {},
            nodes: {}
        };
        const data = (0, $329ek.Material).prototype.toJSON.call(this, meta);
        data.inputNodes = {};
        for (const { property: property, childNode: childNode } of this._getNodeChildren())data.inputNodes[property] = childNode.toJSON(meta).uuid;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const nodes = extractFromCache(meta.nodes);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
            if (nodes.length > 0) data.nodes = nodes;
        }
        return data;
    }
    /**
	 * Copies the properties of the given node material to this instance.
	 *
	 * @param {NodeMaterial} source - The material to copy.
	 * @return {NodeMaterial} A reference to this node material.
	 */ copy(source) {
        this.lightsNode = source.lightsNode;
        this.envNode = source.envNode;
        this.aoNode = source.aoNode;
        this.colorNode = source.colorNode;
        this.normalNode = source.normalNode;
        this.opacityNode = source.opacityNode;
        this.backdropNode = source.backdropNode;
        this.backdropAlphaNode = source.backdropAlphaNode;
        this.alphaTestNode = source.alphaTestNode;
        this.maskNode = source.maskNode;
        this.positionNode = source.positionNode;
        this.geometryNode = source.geometryNode;
        this.depthNode = source.depthNode;
        this.receivedShadowPositionNode = source.receivedShadowPositionNode;
        this.castShadowPositionNode = source.castShadowPositionNode;
        this.receivedShadowNode = source.receivedShadowNode;
        this.castShadowNode = source.castShadowNode;
        this.outputNode = source.outputNode;
        this.mrtNode = source.mrtNode;
        this.fragmentNode = source.fragmentNode;
        this.vertexNode = source.vertexNode;
        this.contextNode = source.contextNode;
        return super.copy(source);
    }
}
const $d89c9137a3d237c2$var$_defaultValues$d = /*@__PURE__*/ new (0, $329ek.LineBasicMaterial)();
/**
 * Node material version of {@link LineBasicMaterial}.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$511219d03f927a3f extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'LineBasicNodeMaterial';
    }
    /**
	 * Constructs a new line basic node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineBasicNodeMaterial = true;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$d);
        this.setValues(parameters);
    }
}
const $d89c9137a3d237c2$var$_defaultValues$c = /*@__PURE__*/ new (0, $329ek.LineDashedMaterial)();
/**
 * Node material version of  {@link LineDashedMaterial}.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$19c85750bbe979a0 extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'LineDashedNodeMaterial';
    }
    /**
	 * Constructs a new line dashed node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineDashedNodeMaterial = true;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$c);
        /**
		 * The dash offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.dashOffset = 0;
        /**
		 * The offset of dash materials is by default inferred from the `dashOffset`
		 * property. This node property allows to overwrite the default
		 * and define the offset with a node instead.
		 *
		 * If you don't want to overwrite the offset but modify the existing
		 * value instead, use {@link materialLineDashOffset}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.offsetNode = null;
        /**
		 * The scale of dash materials is by default inferred from the `scale`
		 * property. This node property allows to overwrite the default
		 * and define the scale with a node instead.
		 *
		 * If you don't want to overwrite the scale but modify the existing
		 * value instead, use {@link materialLineScale}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.dashScaleNode = null;
        /**
		 * The dash size of dash materials is by default inferred from the `dashSize`
		 * property. This node property allows to overwrite the default
		 * and define the dash size with a node instead.
		 *
		 * If you don't want to overwrite the dash size but modify the existing
		 * value instead, use {@link materialLineDashSize}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.dashSizeNode = null;
        /**
		 * The gap size of dash materials is by default inferred from the `gapSize`
		 * property. This node property allows to overwrite the default
		 * and define the gap size with a node instead.
		 *
		 * If you don't want to overwrite the gap size but modify the existing
		 * value instead, use {@link materialLineGapSize}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.gapSizeNode = null;
        this.setValues(parameters);
    }
    /**
	 * Setups the dash specific node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants() {
        const offsetNode = this.offsetNode ? $d89c9137a3d237c2$var$float(this.offsetNode) : $d89c9137a3d237c2$var$materialLineDashOffset;
        const dashScaleNode = this.dashScaleNode ? $d89c9137a3d237c2$var$float(this.dashScaleNode) : $d89c9137a3d237c2$var$materialLineScale;
        const dashSizeNode = this.dashSizeNode ? $d89c9137a3d237c2$var$float(this.dashSizeNode) : $d89c9137a3d237c2$var$materialLineDashSize;
        const gapSizeNode = this.gapSizeNode ? $d89c9137a3d237c2$var$float(this.gapSizeNode) : $d89c9137a3d237c2$var$materialLineGapSize;
        $d89c9137a3d237c2$var$dashSize.assign(dashSizeNode);
        $d89c9137a3d237c2$var$gapSize.assign(gapSizeNode);
        const vLineDistance = $d89c9137a3d237c2$var$varying($d89c9137a3d237c2$var$attribute('lineDistance').mul(dashScaleNode));
        const vLineDistanceOffset = offsetNode ? vLineDistance.add(offsetNode) : vLineDistance;
        vLineDistanceOffset.mod($d89c9137a3d237c2$var$dashSize.add($d89c9137a3d237c2$var$gapSize)).greaterThan($d89c9137a3d237c2$var$dashSize).discard();
    }
}
let $d89c9137a3d237c2$var$_sharedFramebuffer = null;
/**
 * `ViewportTextureNode` creates an internal texture for each node instance. This module
 * shares a texture across all instances of `ViewportSharedTextureNode`. It should
 * be the first choice when using data of the default/screen framebuffer for performance reasons.
 *
 * @augments ViewportTextureNode
 */ class $d89c9137a3d237c2$export$1efcb5d20eaaf706 extends $d89c9137a3d237c2$export$f873d674c2e6b04d {
    static get type() {
        return 'ViewportSharedTextureNode';
    }
    /**
	 * Constructs a new viewport shared texture node.
	 *
	 * @param {Node} [uvNode=screenUV] - The uv node.
	 * @param {?Node} [levelNode=null] - The level node.
	 */ constructor(uvNode = $d89c9137a3d237c2$var$screenUV, levelNode = null){
        if ($d89c9137a3d237c2$var$_sharedFramebuffer === null) $d89c9137a3d237c2$var$_sharedFramebuffer = new (0, $329ek.FramebufferTexture)();
        super(uvNode, levelNode, $d89c9137a3d237c2$var$_sharedFramebuffer);
    }
    /**
	 * Overwritten so the method always returns the unique shared
	 * framebuffer texture.
	 *
	 * @return {FramebufferTexture} The shared framebuffer texture.
	 */ getTextureForReference() {
        return $d89c9137a3d237c2$var$_sharedFramebuffer;
    }
    updateReference() {
        return this;
    }
}
/**
 * TSL function for creating a shared viewport texture node.
 *
 * @tsl
 * @function
 * @param {?Node} [uvNode=screenUV] - The uv node.
 * @param {?Node} [levelNode=null] - The level node.
 * @returns {ViewportSharedTextureNode}
 */ const $d89c9137a3d237c2$var$viewportSharedTexture = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$1efcb5d20eaaf706).setParameterLength(0, 2);
const $d89c9137a3d237c2$var$_defaultValues$b = /*@__PURE__*/ new (0, $329ek.LineDashedMaterial)();
/**
 * This node material can be used to render lines with a size larger than one
 * by representing them as instanced meshes.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$48bba3cc4e1e48d9 extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'Line2NodeMaterial';
    }
    /**
	 * Constructs a new node material for wide line rendering.
	 *
	 * @param {Object} [parameters={}] - The configuration parameter.
	 */ constructor(parameters = {}){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLine2NodeMaterial = true;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$b);
        /**
		 * Whether vertex colors should be used or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.useColor = parameters.vertexColors;
        /**
		 * The dash offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.dashOffset = 0;
        /**
		 * Defines the lines color.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.lineColorNode = null;
        /**
		 * Defines the offset.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.offsetNode = null;
        /**
		 * Defines the dash scale.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.dashScaleNode = null;
        /**
		 * Defines the dash size.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.dashSizeNode = null;
        /**
		 * Defines the gap size.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.gapSizeNode = null;
        /**
		 * Blending is set to `NoBlending` since transparency
		 * is not supported, yet.
		 *
		 * @type {number}
		 * @default 0
		 */ this.blending = (0, $329ek.NoBlending);
        this._useDash = parameters.dashed;
        this._useAlphaToCoverage = true;
        this._useWorldUnits = false;
        this.setValues(parameters);
    }
    /**
	 * Setups the vertex and fragment stage of this node material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        const { renderer: renderer } = builder;
        const useAlphaToCoverage = this._useAlphaToCoverage;
        const useColor = this.useColor;
        const useDash = this._useDash;
        const useWorldUnits = this._useWorldUnits;
        const trimSegment = $d89c9137a3d237c2$var$Fn(({ start: start, end: end })=>{
            const a = $d89c9137a3d237c2$var$cameraProjectionMatrix.element(2).element(2); // 3nd entry in 3th column
            const b = $d89c9137a3d237c2$var$cameraProjectionMatrix.element(3).element(2); // 3nd entry in 4th column
            const nearEstimate = b.mul(-0.5).div(a);
            const alpha = nearEstimate.sub(start.z).div(end.z.sub(start.z));
            return $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$mix(start.xyz, end.xyz, alpha), end.w);
        }).setLayout({
            name: 'trimSegment',
            type: 'vec4',
            inputs: [
                {
                    name: 'start',
                    type: 'vec4'
                },
                {
                    name: 'end',
                    type: 'vec4'
                }
            ]
        });
        this.vertexNode = $d89c9137a3d237c2$var$Fn(()=>{
            const instanceStart = $d89c9137a3d237c2$var$attribute('instanceStart');
            const instanceEnd = $d89c9137a3d237c2$var$attribute('instanceEnd');
            // camera space
            const start = $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$modelViewMatrix.mul($d89c9137a3d237c2$var$vec4(instanceStart, 1.0))).toVar('start');
            const end = $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$modelViewMatrix.mul($d89c9137a3d237c2$var$vec4(instanceEnd, 1.0))).toVar('end');
            if (useDash) {
                const dashScaleNode = this.dashScaleNode ? $d89c9137a3d237c2$var$float(this.dashScaleNode) : $d89c9137a3d237c2$var$materialLineScale;
                const offsetNode = this.offsetNode ? $d89c9137a3d237c2$var$float(this.offsetNode) : $d89c9137a3d237c2$var$materialLineDashOffset;
                const instanceDistanceStart = $d89c9137a3d237c2$var$attribute('instanceDistanceStart');
                const instanceDistanceEnd = $d89c9137a3d237c2$var$attribute('instanceDistanceEnd');
                let lineDistance = $d89c9137a3d237c2$var$positionGeometry.y.lessThan(0.5).select(dashScaleNode.mul(instanceDistanceStart), dashScaleNode.mul(instanceDistanceEnd));
                lineDistance = lineDistance.add(offsetNode);
                $d89c9137a3d237c2$var$varyingProperty('float', 'lineDistance').assign(lineDistance);
            }
            if (useWorldUnits) {
                $d89c9137a3d237c2$var$varyingProperty('vec3', 'worldStart').assign(start.xyz);
                $d89c9137a3d237c2$var$varyingProperty('vec3', 'worldEnd').assign(end.xyz);
            }
            const aspect = $d89c9137a3d237c2$var$viewport.z.div($d89c9137a3d237c2$var$viewport.w);
            // special case for perspective projection, and segments that terminate either in, or behind, the camera plane
            // clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
            // but we need to perform ndc-space calculations in the shader, so we must address this issue directly
            // perhaps there is a more elegant solution -- WestLangley
            const perspective = $d89c9137a3d237c2$var$cameraProjectionMatrix.element(2).element(3).equal(-1); // 4th entry in the 3rd column
            $d89c9137a3d237c2$var$If(perspective, ()=>{
                $d89c9137a3d237c2$var$If(start.z.lessThan(0.0).and(end.z.greaterThan(0.0)), ()=>{
                    end.assign(trimSegment({
                        start: start,
                        end: end
                    }));
                }).ElseIf(end.z.lessThan(0.0).and(start.z.greaterThanEqual(0.0)), ()=>{
                    start.assign(trimSegment({
                        start: end,
                        end: start
                    }));
                });
            });
            // clip space
            const clipStart = $d89c9137a3d237c2$var$cameraProjectionMatrix.mul(start);
            const clipEnd = $d89c9137a3d237c2$var$cameraProjectionMatrix.mul(end);
            // ndc space
            const ndcStart = clipStart.xyz.div(clipStart.w);
            const ndcEnd = clipEnd.xyz.div(clipEnd.w);
            // direction
            const dir = ndcEnd.xy.sub(ndcStart.xy).toVar();
            // account for clip-space aspect ratio
            dir.x.assign(dir.x.mul(aspect));
            dir.assign(dir.normalize());
            const clip = $d89c9137a3d237c2$var$vec4().toVar();
            if (useWorldUnits) {
                // get the offset direction as perpendicular to the view vector
                const worldDir = end.xyz.sub(start.xyz).normalize();
                const tmpFwd = $d89c9137a3d237c2$var$mix(start.xyz, end.xyz, 0.5).normalize();
                const worldUp = worldDir.cross(tmpFwd).normalize();
                const worldFwd = worldDir.cross(worldUp);
                const worldPos = $d89c9137a3d237c2$var$varyingProperty('vec4', 'worldPos');
                worldPos.assign($d89c9137a3d237c2$var$positionGeometry.y.lessThan(0.5).select(start, end));
                // height offset
                const hw = $d89c9137a3d237c2$var$materialLineWidth.mul(0.5);
                worldPos.addAssign($d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$positionGeometry.x.lessThan(0.0).select(worldUp.mul(hw), worldUp.mul(hw).negate()), 0));
                // don't extend the line if we're rendering dashes because we
                // won't be rendering the endcaps
                if (!useDash) {
                    // cap extension
                    worldPos.addAssign($d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$positionGeometry.y.lessThan(0.5).select(worldDir.mul(hw).negate(), worldDir.mul(hw)), 0));
                    // add width to the box
                    worldPos.addAssign($d89c9137a3d237c2$var$vec4(worldFwd.mul(hw), 0));
                    // endcaps
                    $d89c9137a3d237c2$var$If($d89c9137a3d237c2$var$positionGeometry.y.greaterThan(1.0).or($d89c9137a3d237c2$var$positionGeometry.y.lessThan(0.0)), ()=>{
                        worldPos.subAssign($d89c9137a3d237c2$var$vec4(worldFwd.mul(2.0).mul(hw), 0));
                    });
                }
                // project the worldpos
                clip.assign($d89c9137a3d237c2$var$cameraProjectionMatrix.mul(worldPos));
                // shift the depth of the projected points so the line
                // segments overlap neatly
                const clipPose = $d89c9137a3d237c2$var$vec3().toVar();
                clipPose.assign($d89c9137a3d237c2$var$positionGeometry.y.lessThan(0.5).select(ndcStart, ndcEnd));
                clip.z.assign(clipPose.z.mul(clip.w));
            } else {
                const offset = $d89c9137a3d237c2$var$vec2(dir.y, dir.x.negate()).toVar('offset');
                // undo aspect ratio adjustment
                dir.x.assign(dir.x.div(aspect));
                offset.x.assign(offset.x.div(aspect));
                // sign flip
                offset.assign($d89c9137a3d237c2$var$positionGeometry.x.lessThan(0.0).select(offset.negate(), offset));
                // endcaps
                $d89c9137a3d237c2$var$If($d89c9137a3d237c2$var$positionGeometry.y.lessThan(0.0), ()=>{
                    offset.assign(offset.sub(dir));
                }).ElseIf($d89c9137a3d237c2$var$positionGeometry.y.greaterThan(1.0), ()=>{
                    offset.assign(offset.add(dir));
                });
                // adjust for linewidth
                offset.assign(offset.mul($d89c9137a3d237c2$var$materialLineWidth));
                // adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
                offset.assign(offset.div($d89c9137a3d237c2$var$viewport.w.div($d89c9137a3d237c2$var$screenDPR)));
                // select end
                clip.assign($d89c9137a3d237c2$var$positionGeometry.y.lessThan(0.5).select(clipStart, clipEnd));
                // back to clip space
                offset.assign(offset.mul(clip.w));
                clip.assign(clip.add($d89c9137a3d237c2$var$vec4(offset, 0, 0)));
            }
            return clip;
        })();
        const closestLineToLine = $d89c9137a3d237c2$var$Fn(({ p1: p1, p2: p2, p3: p3, p4: p4 })=>{
            const p13 = p1.sub(p3);
            const p43 = p4.sub(p3);
            const p21 = p2.sub(p1);
            const d1343 = p13.dot(p43);
            const d4321 = p43.dot(p21);
            const d1321 = p13.dot(p21);
            const d4343 = p43.dot(p43);
            const d2121 = p21.dot(p21);
            const denom = d2121.mul(d4343).sub(d4321.mul(d4321));
            const numer = d1343.mul(d4321).sub(d1321.mul(d4343));
            const mua = numer.div(denom).clamp();
            const mub = d1343.add(d4321.mul(mua)).div(d4343).clamp();
            return $d89c9137a3d237c2$var$vec2(mua, mub);
        });
        this.colorNode = $d89c9137a3d237c2$var$Fn(()=>{
            const vUv = $d89c9137a3d237c2$var$uv$1();
            if (useDash) {
                const dashSizeNode = this.dashSizeNode ? $d89c9137a3d237c2$var$float(this.dashSizeNode) : $d89c9137a3d237c2$var$materialLineDashSize;
                const gapSizeNode = this.gapSizeNode ? $d89c9137a3d237c2$var$float(this.gapSizeNode) : $d89c9137a3d237c2$var$materialLineGapSize;
                $d89c9137a3d237c2$var$dashSize.assign(dashSizeNode);
                $d89c9137a3d237c2$var$gapSize.assign(gapSizeNode);
                const vLineDistance = $d89c9137a3d237c2$var$varyingProperty('float', 'lineDistance');
                vUv.y.lessThan(-1).or(vUv.y.greaterThan(1.0)).discard(); // discard endcaps
                vLineDistance.mod($d89c9137a3d237c2$var$dashSize.add($d89c9137a3d237c2$var$gapSize)).greaterThan($d89c9137a3d237c2$var$dashSize).discard(); // todo - FIX
            }
            const alpha = $d89c9137a3d237c2$var$float(1).toVar('alpha');
            if (useWorldUnits) {
                const worldStart = $d89c9137a3d237c2$var$varyingProperty('vec3', 'worldStart');
                const worldEnd = $d89c9137a3d237c2$var$varyingProperty('vec3', 'worldEnd');
                // Find the closest points on the view ray and the line segment
                const rayEnd = $d89c9137a3d237c2$var$varyingProperty('vec4', 'worldPos').xyz.normalize().mul(1e5);
                const lineDir = worldEnd.sub(worldStart);
                const params = closestLineToLine({
                    p1: worldStart,
                    p2: worldEnd,
                    p3: $d89c9137a3d237c2$var$vec3(0.0, 0.0, 0.0),
                    p4: rayEnd
                });
                const p1 = worldStart.add(lineDir.mul(params.x));
                const p2 = rayEnd.mul(params.y);
                const delta = p1.sub(p2);
                const len = delta.length();
                const norm = len.div($d89c9137a3d237c2$var$materialLineWidth);
                if (!useDash) {
                    if (useAlphaToCoverage && renderer.currentSamples > 0) {
                        const dnorm = norm.fwidth();
                        alpha.assign($d89c9137a3d237c2$var$smoothstep(dnorm.negate().add(0.5), dnorm.add(0.5), norm).oneMinus());
                    } else norm.greaterThan(0.5).discard();
                }
            } else // round endcaps
            if (useAlphaToCoverage && renderer.currentSamples > 0) {
                const a = vUv.x;
                const b = vUv.y.greaterThan(0.0).select(vUv.y.sub(1.0), vUv.y.add(1.0));
                const len2 = a.mul(a).add(b.mul(b));
                const dlen = $d89c9137a3d237c2$var$float(len2.fwidth()).toVar('dlen');
                $d89c9137a3d237c2$var$If(vUv.y.abs().greaterThan(1.0), ()=>{
                    alpha.assign($d89c9137a3d237c2$var$smoothstep(dlen.oneMinus(), dlen.add(1), len2).oneMinus());
                });
            } else $d89c9137a3d237c2$var$If(vUv.y.abs().greaterThan(1.0), ()=>{
                const a = vUv.x;
                const b = vUv.y.greaterThan(0.0).select(vUv.y.sub(1.0), vUv.y.add(1.0));
                const len2 = a.mul(a).add(b.mul(b));
                len2.greaterThan(1.0).discard();
            });
            let lineColorNode;
            if (this.lineColorNode) lineColorNode = this.lineColorNode;
            else if (useColor) {
                const instanceColorStart = $d89c9137a3d237c2$var$attribute('instanceColorStart');
                const instanceColorEnd = $d89c9137a3d237c2$var$attribute('instanceColorEnd');
                const instanceColor = $d89c9137a3d237c2$var$positionGeometry.y.lessThan(0.5).select(instanceColorStart, instanceColorEnd);
                lineColorNode = instanceColor.mul($d89c9137a3d237c2$var$materialColor);
            } else lineColorNode = $d89c9137a3d237c2$var$materialColor;
            return $d89c9137a3d237c2$var$vec4(lineColorNode, alpha);
        })();
        if (this.transparent) {
            const opacityNode = this.opacityNode ? $d89c9137a3d237c2$var$float(this.opacityNode) : $d89c9137a3d237c2$var$materialOpacity;
            this.outputNode = $d89c9137a3d237c2$var$vec4(this.colorNode.rgb.mul(opacityNode).add($d89c9137a3d237c2$var$viewportSharedTexture().rgb.mul(opacityNode.oneMinus())), this.colorNode.a);
        }
        super.setup(builder);
    }
    /**
	 * Whether the lines should sized in world units or not.
	 * When set to `false` the unit is pixel.
	 *
	 * @type {boolean}
	 * @default false
	 */ get worldUnits() {
        return this._useWorldUnits;
    }
    set worldUnits(value) {
        if (this._useWorldUnits !== value) {
            this._useWorldUnits = value;
            this.needsUpdate = true;
        }
    }
    /**
	 * Whether the lines should be dashed or not.
	 *
	 * @type {boolean}
	 * @default false
	 */ get dashed() {
        return this._useDash;
    }
    set dashed(value) {
        if (this._useDash !== value) {
            this._useDash = value;
            this.needsUpdate = true;
        }
    }
    /**
	 * Whether alpha to coverage should be used or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get alphaToCoverage() {
        return this._useAlphaToCoverage;
    }
    set alphaToCoverage(value) {
        if (this._useAlphaToCoverage !== value) {
            this._useAlphaToCoverage = value;
            this.needsUpdate = true;
        }
    }
}
const $d89c9137a3d237c2$var$_defaultValues$a = /*@__PURE__*/ new (0, $329ek.MeshNormalMaterial)();
/**
 * Node material version of {@link MeshNormalMaterial}.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$57e770545986d2b1 extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshNormalNodeMaterial';
    }
    /**
	 * Constructs a new mesh normal node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshNormalNodeMaterial = true;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$a);
        this.setValues(parameters);
    }
    /**
	 * Overwrites the default implementation by computing the diffuse color
	 * based on the normal data.
	 */ setupDiffuseColor() {
        const opacityNode = this.opacityNode ? $d89c9137a3d237c2$var$float(this.opacityNode) : $d89c9137a3d237c2$var$materialOpacity;
        // By convention, a normal packed to RGB is in sRGB color space. Convert it to working color space.
        $d89c9137a3d237c2$var$diffuseColor.assign($d89c9137a3d237c2$var$colorSpaceToWorking($d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$directionToColor($d89c9137a3d237c2$var$normalView), opacityNode), (0, $329ek.SRGBColorSpace)));
    }
}
/**
 * TSL function for creating an equirect uv node.
 *
 * Can be used to compute texture coordinates for projecting an
 * equirectangular texture onto a mesh for using it as the scene's
 * background.
 *
 * ```js
 * scene.backgroundNode = texture( equirectTexture, equirectUV() );
 * ```
 *
 * @tsl
 * @function
 * @param {?Node<vec3>} [dirNode=positionWorldDirection] - A direction vector for sampling which is by default `positionWorldDirection`.
 * @returns {Node<vec2>}
 */ const $d89c9137a3d237c2$var$equirectUV = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([dir = $d89c9137a3d237c2$var$positionWorldDirection])=>{
    const u = dir.z.atan(dir.x).mul(1 / (Math.PI * 2)).add(0.5);
    const v = dir.y.clamp(-1, 1.0).asin().mul(1 / Math.PI).add(0.5);
    return $d89c9137a3d237c2$var$vec2(u, v);
});
// @TODO: Consider rename WebGLCubeRenderTarget to just CubeRenderTarget
/**
 * This class represents a cube render target. It is a special version
 * of `WebGLCubeRenderTarget` which is compatible with `WebGPURenderer`.
 *
 * @augments WebGLCubeRenderTarget
 */ class $d89c9137a3d237c2$var$CubeRenderTarget extends (0, $329ek.WebGLCubeRenderTarget) {
    /**
	 * Constructs a new cube render target.
	 *
	 * @param {number} [size=1] - The size of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(size = 1, options = {}){
        super(size, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeRenderTarget = true;
    }
    /**
	 * Converts the given equirectangular texture to a cube map.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {Texture} texture - The equirectangular texture.
	 * @return {CubeRenderTarget} A reference to this cube render target.
	 */ fromEquirectangularTexture(renderer, texture$1) {
        const currentMinFilter = texture$1.minFilter;
        const currentGenerateMipmaps = texture$1.generateMipmaps;
        texture$1.generateMipmaps = true;
        this.texture.type = texture$1.type;
        this.texture.colorSpace = texture$1.colorSpace;
        this.texture.generateMipmaps = texture$1.generateMipmaps;
        this.texture.minFilter = texture$1.minFilter;
        this.texture.magFilter = texture$1.magFilter;
        const geometry = new (0, $329ek.BoxGeometry)(5, 5, 5);
        const uvNode = $d89c9137a3d237c2$var$equirectUV($d89c9137a3d237c2$var$positionWorldDirection);
        const material = new $d89c9137a3d237c2$export$caaf3b30a544c946();
        material.colorNode = $d89c9137a3d237c2$var$texture(texture$1, uvNode, 0);
        material.side = (0, $329ek.BackSide);
        material.blending = (0, $329ek.NoBlending);
        const mesh = new (0, $329ek.Mesh)(geometry, material);
        const scene = new (0, $329ek.Scene)();
        scene.add(mesh);
        // Avoid blurred poles
        if (texture$1.minFilter === (0, $329ek.LinearMipmapLinearFilter)) texture$1.minFilter = (0, $329ek.LinearFilter);
        const camera = new (0, $329ek.CubeCamera)(1, 10, this);
        const currentMRT = renderer.getMRT();
        renderer.setMRT(null);
        camera.update(renderer, scene);
        renderer.setMRT(currentMRT);
        texture$1.minFilter = currentMinFilter;
        texture$1.currentGenerateMipmaps = currentGenerateMipmaps;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
}
const $d89c9137a3d237c2$var$_cache$1 = new WeakMap();
/**
 * This node can be used to automatically convert environment maps in the
 * equirectangular format into the cube map format.
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$var$CubeMapNode extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'CubeMapNode';
    }
    /**
	 * Constructs a new cube map node.
	 *
	 * @param {Node} envNode - The node representing the environment map.
	 */ constructor(envNode){
        super('vec3');
        /**
		 * The node representing the environment map.
		 *
		 * @type {Node}
		 */ this.envNode = envNode;
        /**
		 * A reference to the internal cube texture.
		 *
		 * @private
		 * @type {?CubeTexture}
		 * @default null
		 */ this._cubeTexture = null;
        /**
		 * A reference to the internal cube texture node.
		 *
		 * @private
		 * @type {CubeTextureNode}
		 */ this._cubeTextureNode = $d89c9137a3d237c2$var$cubeTexture(null);
        const defaultTexture = new (0, $329ek.CubeTexture)();
        defaultTexture.isRenderTargetTexture = true;
        /**
		 * A default cube texture that acts as a placeholder.
		 * It is used when the conversion from equirectangular to cube
		 * map has not finished yet for a given texture.
		 *
		 * @private
		 * @type {CubeTexture}
		 */ this._defaultTexture = defaultTexture;
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.RENDER` since the node updates
		 * the texture once per render in its {@link CubeMapNode#updateBefore} method.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateBeforeType = $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER;
    }
    updateBefore(frame) {
        const { renderer: renderer, material: material } = frame;
        const envNode = this.envNode;
        if (envNode.isTextureNode || envNode.isMaterialReferenceNode) {
            const texture = envNode.isTextureNode ? envNode.value : material[envNode.property];
            if (texture && texture.isTexture) {
                const mapping = texture.mapping;
                if (mapping === (0, $329ek.EquirectangularReflectionMapping) || mapping === (0, $329ek.EquirectangularRefractionMapping)) {
                    // check for converted cubemap map
                    if ($d89c9137a3d237c2$var$_cache$1.has(texture)) {
                        const cubeMap = $d89c9137a3d237c2$var$_cache$1.get(texture);
                        $d89c9137a3d237c2$var$mapTextureMapping(cubeMap, texture.mapping);
                        this._cubeTexture = cubeMap;
                    } else {
                        // create cube map from equirectangular map
                        const image = texture.image;
                        if ($d89c9137a3d237c2$var$isEquirectangularMapReady$1(image)) {
                            const renderTarget = new $d89c9137a3d237c2$var$CubeRenderTarget(image.height);
                            renderTarget.fromEquirectangularTexture(renderer, texture);
                            $d89c9137a3d237c2$var$mapTextureMapping(renderTarget.texture, texture.mapping);
                            this._cubeTexture = renderTarget.texture;
                            $d89c9137a3d237c2$var$_cache$1.set(texture, renderTarget.texture);
                            texture.addEventListener('dispose', $d89c9137a3d237c2$var$onTextureDispose);
                        } else // default cube texture as fallback when equirectangular texture is not yet loaded
                        this._cubeTexture = this._defaultTexture;
                    }
                    //
                    this._cubeTextureNode.value = this._cubeTexture;
                } else // envNode already refers to a cube map
                this._cubeTextureNode = this.envNode;
            }
        }
    }
    setup(builder) {
        this.updateBefore(builder);
        return this._cubeTextureNode;
    }
}
/**
 * Returns true if the given equirectangular image has been fully loaded
 * and is ready for further processing.
 *
 * @private
 * @param {Image} image - The equirectangular image to check.
 * @return {boolean} Whether the image is ready or not.
 */ function $d89c9137a3d237c2$var$isEquirectangularMapReady$1(image) {
    if (image === null || image === undefined) return false;
    return image.height > 0;
}
/**
 * This function is executed when `dispose()` is called on the equirectangular
 * texture. In this case, the generated cube map with its render target
 * is deleted as well.
 *
 * @private
 * @param {Object} event - The event object.
 */ function $d89c9137a3d237c2$var$onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener('dispose', $d89c9137a3d237c2$var$onTextureDispose);
    const renderTarget = $d89c9137a3d237c2$var$_cache$1.get(texture);
    if (renderTarget !== undefined) {
        $d89c9137a3d237c2$var$_cache$1.delete(texture);
        renderTarget.dispose();
    }
}
/**
 * This function makes sure the generated cube map uses the correct
 * texture mapping that corresponds to the equirectangular original.
 *
 * @private
 * @param {Texture} texture - The cube texture.
 * @param {number} mapping - The original texture mapping.
 */ function $d89c9137a3d237c2$var$mapTextureMapping(texture, mapping) {
    if (mapping === (0, $329ek.EquirectangularReflectionMapping)) texture.mapping = (0, $329ek.CubeReflectionMapping);
    else if (mapping === (0, $329ek.EquirectangularRefractionMapping)) texture.mapping = (0, $329ek.CubeRefractionMapping);
}
/**
 * TSL function for creating a cube map node.
 *
 * @tsl
 * @function
 * @param {Node} envNode - The node representing the environment map.
 * @returns {CubeMapNode}
 */ const $d89c9137a3d237c2$var$cubeMapNode = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$var$CubeMapNode).setParameterLength(1);
/**
 * Represents a basic model for Image-based lighting (IBL). The environment
 * is defined via environment maps in the equirectangular or cube map format.
 * `BasicEnvironmentNode` is intended for non-PBR materials like {@link MeshBasicNodeMaterial}
 * or {@link MeshPhongNodeMaterial}.
 *
 * @augments LightingNode
 */ class $d89c9137a3d237c2$export$be91c1e31ea2d4a8 extends $d89c9137a3d237c2$export$3fce9846d62aac91 {
    static get type() {
        return 'BasicEnvironmentNode';
    }
    /**
	 * Constructs a new basic environment node.
	 *
	 * @param {Node} [envNode=null] - A node representing the environment.
	 */ constructor(envNode = null){
        super();
        /**
		 * A node representing the environment.
		 *
		 * @type {Node}
		 * @default null
		 */ this.envNode = envNode;
    }
    setup(builder) {
        // environment property is used in the finish() method of BasicLightingModel
        builder.context.environment = $d89c9137a3d237c2$var$cubeMapNode(this.envNode);
    }
}
/**
 * A specific version of {@link IrradianceNode} that is only relevant
 * for {@link MeshBasicNodeMaterial}. Since the material is unlit, it
 * requires a special scaling factor for the light map.
 *
 * @augments LightingNode
 */ class $d89c9137a3d237c2$var$BasicLightMapNode extends $d89c9137a3d237c2$export$3fce9846d62aac91 {
    static get type() {
        return 'BasicLightMapNode';
    }
    /**
	 * Constructs a new basic light map node.
	 *
	 * @param {?Node<vec3>} [lightMapNode=null] - The light map node.
	 */ constructor(lightMapNode = null){
        super();
        /**
		 * The light map node.
		 *
		 * @type {?Node<vec3>}
		 */ this.lightMapNode = lightMapNode;
    }
    setup(builder) {
        // irradianceLightMap property is used in the indirectDiffuse() method of BasicLightingModel
        const RECIPROCAL_PI = $d89c9137a3d237c2$var$float(1 / Math.PI);
        builder.context.irradianceLightMap = this.lightMapNode.mul(RECIPROCAL_PI);
    }
}
/**
 * Abstract class for implementing lighting models. The module defines
 * multiple methods that concrete lighting models can implement. These
 * methods are executed at different points during the light evaluation
 * process.
 */ class $d89c9137a3d237c2$export$d8f76c0bb8645ea7 {
    /**
	 * This method is intended for setting up lighting model and context data
	 * which are later used in the evaluation process.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 */ start(builder) {
        // lights ( direct )
        builder.lightsNode.setupLights(builder, builder.lightsNode.getLightNodes(builder));
        // indirect
        this.indirect(builder);
    }
    /**
	 * This method is intended for executing final tasks like final updates
	 * to the outgoing light.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 */ finish() {}
    /**
	 * This method is intended for implementing the direct light term and
	 * executed during the build process of directional, point and spot light nodes.
	 *
	 * @abstract
	 * @param {Object} lightData - The light data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ direct() {}
    /**
	 * This method is intended for implementing the direct light term for
	 * rect area light nodes.
	 *
	 * @abstract
	 * @param {Object} lightData - The light data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ directRectArea() {}
    /**
	 * This method is intended for implementing the indirect light term.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirect() {}
    /**
	 * This method is intended for implementing the ambient occlusion term.
	 * Unlike other methods, this method must be called manually by the lighting
	 * model in its indirect term.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 */ ambientOcclusion() {}
}
/**
 * Represents the lighting model for unlit materials. The only light contribution
 * is baked indirect lighting modulated with ambient occlusion and the material's
 * diffuse color. Environment mapping is supported. Used in {@link MeshBasicNodeMaterial}.
 *
 * @augments LightingModel
 */ class $d89c9137a3d237c2$var$BasicLightingModel extends $d89c9137a3d237c2$export$d8f76c0bb8645ea7 {
    /**
	 * Constructs a new basic lighting model.
	 */ constructor(){
        super();
    }
    /**
	 * Implements the baked indirect lighting with its modulation.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirect({ context: context }) {
        const ambientOcclusion = context.ambientOcclusion;
        const reflectedLight = context.reflectedLight;
        const irradianceLightMap = context.irradianceLightMap;
        reflectedLight.indirectDiffuse.assign($d89c9137a3d237c2$var$vec4(0.0));
        // accumulation (baked indirect lighting only)
        if (irradianceLightMap) reflectedLight.indirectDiffuse.addAssign(irradianceLightMap);
        else reflectedLight.indirectDiffuse.addAssign($d89c9137a3d237c2$var$vec4(1.0, 1.0, 1.0, 0.0));
        // modulation
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
        reflectedLight.indirectDiffuse.mulAssign($d89c9137a3d237c2$var$diffuseColor.rgb);
    }
    /**
	 * Implements the environment mapping.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ finish(builder) {
        const { material: material, context: context } = builder;
        const outgoingLight = context.outgoingLight;
        const envNode = builder.context.environment;
        if (envNode) switch(material.combine){
            case 0, $329ek.MultiplyOperation:
                outgoingLight.rgb.assign($d89c9137a3d237c2$var$mix(outgoingLight.rgb, outgoingLight.rgb.mul(envNode.rgb), $d89c9137a3d237c2$var$materialSpecularStrength.mul($d89c9137a3d237c2$var$materialReflectivity)));
                break;
            case 0, $329ek.MixOperation:
                outgoingLight.rgb.assign($d89c9137a3d237c2$var$mix(outgoingLight.rgb, envNode.rgb, $d89c9137a3d237c2$var$materialSpecularStrength.mul($d89c9137a3d237c2$var$materialReflectivity)));
                break;
            case 0, $329ek.AddOperation:
                outgoingLight.rgb.addAssign(envNode.rgb.mul($d89c9137a3d237c2$var$materialSpecularStrength.mul($d89c9137a3d237c2$var$materialReflectivity)));
                break;
            default:
                (0, $329ek.warn)('BasicLightingModel: Unsupported .combine value:', material.combine);
                break;
        }
    }
}
const $d89c9137a3d237c2$var$_defaultValues$9 = /*@__PURE__*/ new (0, $329ek.MeshBasicMaterial)();
/**
 * Node material version of {@link MeshBasicMaterial}.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$14d4a26075247662 extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshBasicNodeMaterial';
    }
    /**
	 * Constructs a new mesh basic node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshBasicNodeMaterial = true;
        /**
		 * Although the basic material is by definition unlit, we set
		 * this property to `true` since we use a lighting model to compute
		 * the outgoing light of the fragment shader.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$9);
        this.setValues(parameters);
    }
    /**
	 * Basic materials are not affected by normal and bump maps so we
	 * return by default {@link normalViewGeometry}.
	 *
	 * @return {Node<vec3>} The normal node.
	 */ setupNormal() {
        return $d89c9137a3d237c2$var$directionToFaceDirection($d89c9137a3d237c2$var$normalViewGeometry); // see #28839
    }
    /**
	 * Overwritten since this type of material uses {@link BasicEnvironmentNode}
	 * to implement the default environment mapping.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?BasicEnvironmentNode<vec3>} The environment node.
	 */ setupEnvironment(builder) {
        const envNode = super.setupEnvironment(builder);
        return envNode ? new $d89c9137a3d237c2$export$be91c1e31ea2d4a8(envNode) : null;
    }
    /**
	 * This method must be overwritten since light maps are evaluated
	 * with a special scaling factor for basic materials.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?BasicLightMapNode<vec3>} The light map node.
	 */ setupLightMap(builder) {
        let node = null;
        if (builder.material.lightMap) node = new $d89c9137a3d237c2$var$BasicLightMapNode($d89c9137a3d237c2$var$materialLightMap);
        return node;
    }
    /**
	 * The material overwrites this method because `lights` is set to `true` but
	 * we still want to return the diffuse color as the outgoing light.
	 *
	 * @return {Node<vec3>} The outgoing light node.
	 */ setupOutgoingLight() {
        return $d89c9137a3d237c2$var$diffuseColor.rgb;
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {BasicLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $d89c9137a3d237c2$var$BasicLightingModel();
    }
}
const $d89c9137a3d237c2$var$F_Schlick = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ f0: f0, f90: f90, dotVH: dotVH })=>{
    // Original approximation by Christophe Schlick '94
    // float fresnel = pow( 1.0 - dotVH, 5.0 );
    // Optimized variant (presented by Epic at SIGGRAPH '13)
    // https://cdn2.unrealengine.com/Resources/files/2013SiggraphPresentationsNotes-26915738.pdf
    const fresnel = dotVH.mul(-5.55473).sub(6.98316).mul(dotVH).exp2();
    return f0.mul(fresnel.oneMinus()).add(f90.mul(fresnel));
}); // validated
const $d89c9137a3d237c2$var$BRDF_Lambert = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((inputs)=>{
    return inputs.diffuseColor.mul(1 / Math.PI); // punctual light
}); // validated
const $d89c9137a3d237c2$var$G_BlinnPhong_Implicit = ()=>$d89c9137a3d237c2$var$float(0.25);
const $d89c9137a3d237c2$var$D_BlinnPhong = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ dotNH: dotNH })=>{
    return $d89c9137a3d237c2$var$shininess.mul($d89c9137a3d237c2$var$float(0.5)).add(1.0).mul($d89c9137a3d237c2$var$float(1 / Math.PI)).mul(dotNH.pow($d89c9137a3d237c2$var$shininess));
});
const $d89c9137a3d237c2$var$BRDF_BlinnPhong = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ lightDirection: lightDirection })=>{
    const halfDir = lightDirection.add($d89c9137a3d237c2$var$positionViewDirection).normalize();
    const dotNH = $d89c9137a3d237c2$var$normalView.dot(halfDir).clamp();
    const dotVH = $d89c9137a3d237c2$var$positionViewDirection.dot(halfDir).clamp();
    const F = $d89c9137a3d237c2$var$F_Schlick({
        f0: $d89c9137a3d237c2$var$specularColor,
        f90: 1.0,
        dotVH: dotVH
    });
    const G = $d89c9137a3d237c2$var$G_BlinnPhong_Implicit();
    const D = $d89c9137a3d237c2$var$D_BlinnPhong({
        dotNH: dotNH
    });
    return F.mul(G).mul(D);
});
/**
 * Represents the lighting model for a phong material. Used in {@link MeshPhongNodeMaterial}.
 *
 * @augments BasicLightingModel
 */ class $d89c9137a3d237c2$export$dd267abaadff98a7 extends $d89c9137a3d237c2$var$BasicLightingModel {
    /**
	 * Constructs a new phong lighting model.
	 *
	 * @param {boolean} [specular=true] - Whether specular is supported or not.
	 */ constructor(specular = true){
        super();
        /**
		 * Whether specular is supported or not. Set this to `false` if you are
		 * looking for a Lambert-like material meaning a material for non-shiny
		 * surfaces, without specular highlights.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.specular = specular;
    }
    /**
	 * Implements the direct lighting. The specular portion is optional an can be controlled
	 * with the {@link PhongLightingModel#specular} flag.
	 *
	 * @param {Object} lightData - The light data.
	 */ direct({ lightDirection: lightDirection, lightColor: lightColor, reflectedLight: reflectedLight }) {
        const dotNL = $d89c9137a3d237c2$var$normalView.dot(lightDirection).clamp();
        const irradiance = dotNL.mul(lightColor);
        reflectedLight.directDiffuse.addAssign(irradiance.mul($d89c9137a3d237c2$var$BRDF_Lambert({
            diffuseColor: $d89c9137a3d237c2$var$diffuseColor.rgb
        })));
        if (this.specular === true) reflectedLight.directSpecular.addAssign(irradiance.mul($d89c9137a3d237c2$var$BRDF_BlinnPhong({
            lightDirection: lightDirection
        })).mul($d89c9137a3d237c2$var$materialSpecularStrength));
    }
    /**
	 * Implements the indirect lighting.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirect(builder) {
        const { ambientOcclusion: ambientOcclusion, irradiance: irradiance, reflectedLight: reflectedLight } = builder.context;
        reflectedLight.indirectDiffuse.addAssign(irradiance.mul($d89c9137a3d237c2$var$BRDF_Lambert({
            diffuseColor: $d89c9137a3d237c2$var$diffuseColor
        })));
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
    }
}
const $d89c9137a3d237c2$var$_defaultValues$8 = /*@__PURE__*/ new (0, $329ek.MeshLambertMaterial)();
/**
 * Node material version of {@link MeshLambertMaterial}.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$ca28182707938248 extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshLambertNodeMaterial';
    }
    /**
	 * Constructs a new mesh lambert node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshLambertNodeMaterial = true;
        /**
		 * Set to `true` because lambert materials react on lights.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$8);
        this.setValues(parameters);
    }
    /**
	 * Overwritten since this type of material uses {@link BasicEnvironmentNode}
	 * to implement the default environment mapping.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?BasicEnvironmentNode<vec3>} The environment node.
	 */ setupEnvironment(builder) {
        const envNode = super.setupEnvironment(builder);
        return envNode ? new $d89c9137a3d237c2$export$be91c1e31ea2d4a8(envNode) : null;
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {PhongLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $d89c9137a3d237c2$export$dd267abaadff98a7(false); // ( specular ) -> force lambert
    }
}
const $d89c9137a3d237c2$var$_defaultValues$7 = /*@__PURE__*/ new (0, $329ek.MeshPhongMaterial)();
/**
 * Node material version of {@link MeshPhongMaterial}.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$eb6f457467ca986e extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshPhongNodeMaterial';
    }
    /**
	 * Constructs a new mesh lambert node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhongNodeMaterial = true;
        /**
		 * Set to `true` because phong materials react on lights.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        /**
		 * The shininess of phong materials is by default inferred from the `shininess`
		 * property. This node property allows to overwrite the default
		 * and define the shininess with a node instead.
		 *
		 * If you don't want to overwrite the shininess but modify the existing
		 * value instead, use {@link materialShininess}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.shininessNode = null;
        /**
		 * The specular color of phong materials is by default inferred from the
		 * `specular` property. This node property allows to overwrite the default
		 * and define the specular color with a node instead.
		 *
		 * If you don't want to overwrite the specular color but modify the existing
		 * value instead, use {@link materialSpecular}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.specularNode = null;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$7);
        this.setValues(parameters);
    }
    /**
	 * Overwritten since this type of material uses {@link BasicEnvironmentNode}
	 * to implement the default environment mapping.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?BasicEnvironmentNode<vec3>} The environment node.
	 */ setupEnvironment(builder) {
        const envNode = super.setupEnvironment(builder);
        return envNode ? new $d89c9137a3d237c2$export$be91c1e31ea2d4a8(envNode) : null;
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {PhongLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $d89c9137a3d237c2$export$dd267abaadff98a7();
    }
    /**
	 * Setups the phong specific node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants() {
        // SHININESS
        const shininessNode = (this.shininessNode ? $d89c9137a3d237c2$var$float(this.shininessNode) : $d89c9137a3d237c2$var$materialShininess).max(1e-4); // to prevent pow( 0.0, 0.0 )
        $d89c9137a3d237c2$var$shininess.assign(shininessNode);
        // SPECULAR COLOR
        const specularNode = this.specularNode || $d89c9137a3d237c2$var$materialSpecular;
        $d89c9137a3d237c2$var$specularColor.assign(specularNode);
    }
    copy(source) {
        this.shininessNode = source.shininessNode;
        this.specularNode = source.specularNode;
        return super.copy(source);
    }
}
const $d89c9137a3d237c2$var$getGeometryRoughness = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((builder)=>{
    if (builder.geometry.hasAttribute('normal') === false) return $d89c9137a3d237c2$var$float(0);
    const dxy = $d89c9137a3d237c2$var$normalViewGeometry.dFdx().abs().max($d89c9137a3d237c2$var$normalViewGeometry.dFdy().abs());
    const geometryRoughness = dxy.x.max(dxy.y).max(dxy.z);
    return geometryRoughness;
});
const $d89c9137a3d237c2$var$getRoughness = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((inputs)=>{
    const { roughness: roughness } = inputs;
    const geometryRoughness = $d89c9137a3d237c2$var$getGeometryRoughness();
    let roughnessFactor = roughness.max(0.0525); // 0.0525 corresponds to the base mip of a 256 cubemap.
    roughnessFactor = roughnessFactor.add(geometryRoughness);
    roughnessFactor = roughnessFactor.min(1.0);
    return roughnessFactor;
});
// Moving Frostbite to Physically Based Rendering 3.0 - page 12, listing 2
// https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
const $d89c9137a3d237c2$var$V_GGX_SmithCorrelated = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ alpha: alpha, dotNL: dotNL, dotNV: dotNV })=>{
    const a2 = alpha.pow2();
    const gv = dotNL.mul(a2.add(a2.oneMinus().mul(dotNV.pow2())).sqrt());
    const gl = dotNV.mul(a2.add(a2.oneMinus().mul(dotNL.pow2())).sqrt());
    return $d89c9137a3d237c2$var$div(0.5, gv.add(gl).max($d89c9137a3d237c2$var$EPSILON));
}).setLayout({
    name: 'V_GGX_SmithCorrelated',
    type: 'float',
    inputs: [
        {
            name: 'alpha',
            type: 'float'
        },
        {
            name: 'dotNL',
            type: 'float'
        },
        {
            name: 'dotNV',
            type: 'float'
        }
    ]
}); // validated
// https://google.github.io/filament/Filament.md.html#materialsystem/anisotropicmodel/anisotropicspecularbrdf
const $d89c9137a3d237c2$var$V_GGX_SmithCorrelated_Anisotropic = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ alphaT: alphaT, alphaB: alphaB, dotTV: dotTV, dotBV: dotBV, dotTL: dotTL, dotBL: dotBL, dotNV: dotNV, dotNL: dotNL })=>{
    const gv = dotNL.mul($d89c9137a3d237c2$var$vec3(alphaT.mul(dotTV), alphaB.mul(dotBV), dotNV).length());
    const gl = dotNV.mul($d89c9137a3d237c2$var$vec3(alphaT.mul(dotTL), alphaB.mul(dotBL), dotNL).length());
    const v = $d89c9137a3d237c2$var$div(0.5, gv.add(gl));
    return v;
}).setLayout({
    name: 'V_GGX_SmithCorrelated_Anisotropic',
    type: 'float',
    inputs: [
        {
            name: 'alphaT',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'alphaB',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotTV',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotBV',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotTL',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotBL',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotNV',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotNL',
            type: 'float',
            qualifier: 'in'
        }
    ]
});
// Microfacet Models for Refraction through Rough Surfaces - equation (33)
// http://graphicrants.blogspot.com/2013/08/specular-brdf-reference.html
// alpha is "roughness squared" in Disney’s reparameterization
const $d89c9137a3d237c2$var$D_GGX = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ alpha: alpha, dotNH: dotNH })=>{
    const a2 = alpha.pow2();
    const denom = dotNH.pow2().mul(a2.oneMinus()).oneMinus(); // avoid alpha = 0 with dotNH = 1
    return a2.div(denom.pow2()).mul(1 / Math.PI);
}).setLayout({
    name: 'D_GGX',
    type: 'float',
    inputs: [
        {
            name: 'alpha',
            type: 'float'
        },
        {
            name: 'dotNH',
            type: 'float'
        }
    ]
}); // validated
const $d89c9137a3d237c2$var$RECIPROCAL_PI = /*@__PURE__*/ $d89c9137a3d237c2$var$float(1 / Math.PI);
// https://google.github.io/filament/Filament.md.html#materialsystem/anisotropicmodel/anisotropicspecularbrdf
const $d89c9137a3d237c2$var$D_GGX_Anisotropic = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ alphaT: alphaT, alphaB: alphaB, dotNH: dotNH, dotTH: dotTH, dotBH: dotBH })=>{
    const a2 = alphaT.mul(alphaB);
    const v = $d89c9137a3d237c2$var$vec3(alphaB.mul(dotTH), alphaT.mul(dotBH), a2.mul(dotNH));
    const v2 = v.dot(v);
    const w2 = a2.div(v2);
    return $d89c9137a3d237c2$var$RECIPROCAL_PI.mul(a2.mul(w2.pow2()));
}).setLayout({
    name: 'D_GGX_Anisotropic',
    type: 'float',
    inputs: [
        {
            name: 'alphaT',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'alphaB',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotNH',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotTH',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotBH',
            type: 'float',
            qualifier: 'in'
        }
    ]
});
// GGX Distribution, Schlick Fresnel, GGX_SmithCorrelated Visibility
const $d89c9137a3d237c2$var$BRDF_GGX = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ lightDirection: lightDirection, f0: f0, f90: f90, roughness: roughness, f: f, normalView: normalView$1 = $d89c9137a3d237c2$var$normalView, USE_IRIDESCENCE: USE_IRIDESCENCE, USE_ANISOTROPY: USE_ANISOTROPY })=>{
    const alpha = roughness.pow2(); // UE4's roughness
    const halfDir = lightDirection.add($d89c9137a3d237c2$var$positionViewDirection).normalize();
    const dotNL = normalView$1.dot(lightDirection).clamp();
    const dotNV = normalView$1.dot($d89c9137a3d237c2$var$positionViewDirection).clamp(); // @ TODO: Move to core dotNV
    const dotNH = normalView$1.dot(halfDir).clamp();
    const dotVH = $d89c9137a3d237c2$var$positionViewDirection.dot(halfDir).clamp();
    let F = $d89c9137a3d237c2$var$F_Schlick({
        f0: f0,
        f90: f90,
        dotVH: dotVH
    });
    let V, D;
    if ($d89c9137a3d237c2$var$defined(USE_IRIDESCENCE)) F = $d89c9137a3d237c2$var$iridescence.mix(F, f);
    if ($d89c9137a3d237c2$var$defined(USE_ANISOTROPY)) {
        const dotTL = $d89c9137a3d237c2$var$anisotropyT.dot(lightDirection);
        const dotTV = $d89c9137a3d237c2$var$anisotropyT.dot($d89c9137a3d237c2$var$positionViewDirection);
        const dotTH = $d89c9137a3d237c2$var$anisotropyT.dot(halfDir);
        const dotBL = $d89c9137a3d237c2$var$anisotropyB.dot(lightDirection);
        const dotBV = $d89c9137a3d237c2$var$anisotropyB.dot($d89c9137a3d237c2$var$positionViewDirection);
        const dotBH = $d89c9137a3d237c2$var$anisotropyB.dot(halfDir);
        V = $d89c9137a3d237c2$var$V_GGX_SmithCorrelated_Anisotropic({
            alphaT: $d89c9137a3d237c2$var$alphaT,
            alphaB: alpha,
            dotTV: dotTV,
            dotBV: dotBV,
            dotTL: dotTL,
            dotBL: dotBL,
            dotNV: dotNV,
            dotNL: dotNL
        });
        D = $d89c9137a3d237c2$var$D_GGX_Anisotropic({
            alphaT: $d89c9137a3d237c2$var$alphaT,
            alphaB: alpha,
            dotNH: dotNH,
            dotTH: dotTH,
            dotBH: dotBH
        });
    } else {
        V = $d89c9137a3d237c2$var$V_GGX_SmithCorrelated({
            alpha: alpha,
            dotNL: dotNL,
            dotNV: dotNV
        });
        D = $d89c9137a3d237c2$var$D_GGX({
            alpha: alpha,
            dotNH: dotNH
        });
    }
    return F.mul(V).mul(D);
}); // validated
/**
 * Precomputed DFG LUT for Image-Based Lighting
 * Resolution: 16x16
 * Samples: 4096 per texel
 * Format: RG16F (2 half floats per texel: scale, bias)
 */ const $d89c9137a3d237c2$var$DATA = new Uint16Array([
    0x30b5,
    0x3ad1,
    0x314c,
    0x3a4d,
    0x33d2,
    0x391c,
    0x35ef,
    0x3828,
    0x37f3,
    0x36a6,
    0x38d1,
    0x3539,
    0x3979,
    0x3410,
    0x39f8,
    0x3252,
    0x3a53,
    0x30f0,
    0x3a94,
    0x2fc9,
    0x3abf,
    0x2e35,
    0x3ada,
    0x2d05,
    0x3ae8,
    0x2c1f,
    0x3aed,
    0x2ae0,
    0x3aea,
    0x29d1,
    0x3ae1,
    0x28ff,
    0x3638,
    0x38e4,
    0x364a,
    0x38ce,
    0x3699,
    0x385e,
    0x374e,
    0x372c,
    0x3839,
    0x35a4,
    0x38dc,
    0x3462,
    0x396e,
    0x32c4,
    0x39de,
    0x3134,
    0x3a2b,
    0x3003,
    0x3a59,
    0x2e3a,
    0x3a6d,
    0x2ce1,
    0x3a6e,
    0x2bba,
    0x3a5f,
    0x2a33,
    0x3a49,
    0x290a,
    0x3a2d,
    0x2826,
    0x3a0a,
    0x26e8,
    0x3894,
    0x36d7,
    0x3897,
    0x36c9,
    0x38a3,
    0x3675,
    0x38bc,
    0x35ac,
    0x38ee,
    0x349c,
    0x393e,
    0x3332,
    0x3997,
    0x3186,
    0x39e2,
    0x3038,
    0x3a13,
    0x2e75,
    0x3a29,
    0x2cf5,
    0x3a2d,
    0x2bac,
    0x3a21,
    0x29ff,
    0x3a04,
    0x28bc,
    0x39dc,
    0x2790,
    0x39ad,
    0x261a,
    0x3978,
    0x24fa,
    0x39ac,
    0x34a8,
    0x39ac,
    0x34a3,
    0x39ae,
    0x3480,
    0x39ae,
    0x3423,
    0x39b1,
    0x330e,
    0x39c2,
    0x31a9,
    0x39e0,
    0x3063,
    0x39fc,
    0x2eb5,
    0x3a0c,
    0x2d1d,
    0x3a14,
    0x2bcf,
    0x3a07,
    0x29ff,
    0x39e9,
    0x28a3,
    0x39be,
    0x273c,
    0x3989,
    0x25b3,
    0x394a,
    0x2488,
    0x3907,
    0x2345,
    0x3a77,
    0x3223,
    0x3a76,
    0x321f,
    0x3a73,
    0x3204,
    0x3a6a,
    0x31b3,
    0x3a58,
    0x3114,
    0x3a45,
    0x303b,
    0x3a34,
    0x2eb6,
    0x3a26,
    0x2d31,
    0x3a1e,
    0x2bef,
    0x3a0b,
    0x2a0d,
    0x39ec,
    0x28a1,
    0x39c0,
    0x271b,
    0x3987,
    0x2580,
    0x3944,
    0x2449,
    0x38fa,
    0x22bd,
    0x38ac,
    0x2155,
    0x3b07,
    0x2fca,
    0x3b06,
    0x2fca,
    0x3b00,
    0x2fb8,
    0x3af4,
    0x2f7c,
    0x3adb,
    0x2eea,
    0x3ab4,
    0x2e00,
    0x3a85,
    0x2cec,
    0x3a5e,
    0x2bc5,
    0x3a36,
    0x2a00,
    0x3a0d,
    0x2899,
    0x39dc,
    0x2707,
    0x39a0,
    0x2562,
    0x395a,
    0x2424,
    0x390b,
    0x2268,
    0x38b7,
    0x20fd,
    0x385f,
    0x1fd1,
    0x3b69,
    0x2cb9,
    0x3b68,
    0x2cbb,
    0x3b62,
    0x2cbb,
    0x3b56,
    0x2cae,
    0x3b3b,
    0x2c78,
    0x3b0d,
    0x2c0a,
    0x3acf,
    0x2ae3,
    0x3a92,
    0x2998,
    0x3a54,
    0x2867,
    0x3a17,
    0x26d0,
    0x39d3,
    0x253c,
    0x3989,
    0x2402,
    0x3935,
    0x2226,
    0x38dc,
    0x20bd,
    0x387d,
    0x1f54,
    0x381d,
    0x1db3,
    0x3ba9,
    0x296b,
    0x3ba8,
    0x296f,
    0x3ba3,
    0x297b,
    0x3b98,
    0x2987,
    0x3b7f,
    0x2976,
    0x3b4e,
    0x2927,
    0x3b0e,
    0x2895,
    0x3ac2,
    0x27b7,
    0x3a73,
    0x263b,
    0x3a23,
    0x24e7,
    0x39d0,
    0x239b,
    0x3976,
    0x21d9,
    0x3917,
    0x207e,
    0x38b2,
    0x1ee7,
    0x384b,
    0x1d53,
    0x37c7,
    0x1c1e,
    0x3bd2,
    0x25cb,
    0x3bd1,
    0x25d3,
    0x3bcd,
    0x25f0,
    0x3bc2,
    0x261f,
    0x3bad,
    0x2645,
    0x3b7d,
    0x262d,
    0x3b3e,
    0x25c4,
    0x3aec,
    0x250f,
    0x3a93,
    0x243a,
    0x3a32,
    0x22ce,
    0x39d0,
    0x215b,
    0x3969,
    0x202a,
    0x38fe,
    0x1e6e,
    0x388f,
    0x1cf1,
    0x381f,
    0x1b9b,
    0x3762,
    0x19dd,
    0x3be9,
    0x21ab,
    0x3be9,
    0x21b7,
    0x3be5,
    0x21e5,
    0x3bdd,
    0x2241,
    0x3bc9,
    0x22a7,
    0x3ba0,
    0x22ec,
    0x3b62,
    0x22cd,
    0x3b0f,
    0x2247,
    0x3aae,
    0x2175,
    0x3a44,
    0x2088,
    0x39d4,
    0x1f49,
    0x3960,
    0x1dbe,
    0x38e9,
    0x1c77,
    0x3870,
    0x1ae8,
    0x37f1,
    0x1953,
    0x3708,
    0x181b,
    0x3bf6,
    0x1cea,
    0x3bf6,
    0x1cfb,
    0x3bf3,
    0x1d38,
    0x3bec,
    0x1dbd,
    0x3bda,
    0x1e7c,
    0x3bb7,
    0x1f25,
    0x3b7d,
    0x1f79,
    0x3b2c,
    0x1f4c,
    0x3ac6,
    0x1ea6,
    0x3a55,
    0x1dbb,
    0x39da,
    0x1cbd,
    0x395a,
    0x1b9d,
    0x38d8,
    0x1a00,
    0x3855,
    0x18ac,
    0x37ab,
    0x173c,
    0x36b7,
    0x1598,
    0x3bfc,
    0x1736,
    0x3bfc,
    0x1759,
    0x3bf9,
    0x17e7,
    0x3bf4,
    0x1896,
    0x3be4,
    0x1997,
    0x3bc6,
    0x1aa8,
    0x3b91,
    0x1b84,
    0x3b43,
    0x1bd2,
    0x3ade,
    0x1b8a,
    0x3a65,
    0x1acd,
    0x39e2,
    0x19d3,
    0x3957,
    0x18cd,
    0x38ca,
    0x17b3,
    0x383e,
    0x1613,
    0x376d,
    0x14bf,
    0x366f,
    0x135e,
    0x3bff,
    0x101b,
    0x3bff,
    0x1039,
    0x3bfc,
    0x10c8,
    0x3bf9,
    0x1226,
    0x3bea,
    0x1428,
    0x3bcf,
    0x1584,
    0x3b9f,
    0x16c5,
    0x3b54,
    0x179a,
    0x3af0,
    0x17ce,
    0x3a76,
    0x1771,
    0x39ea,
    0x16a4,
    0x3956,
    0x15a7,
    0x38bf,
    0x14a7,
    0x3829,
    0x1379,
    0x3735,
    0x11ea,
    0x362d,
    0x10a1,
    0x3c00,
    0x061b,
    0x3c00,
    0x066a,
    0x3bfe,
    0x081c,
    0x3bfa,
    0x0a4c,
    0x3bed,
    0x0d16,
    0x3bd5,
    0x0fb3,
    0x3ba9,
    0x114d,
    0x3b63,
    0x127c,
    0x3b01,
    0x132f,
    0x3a85,
    0x1344,
    0x39f4,
    0x12d2,
    0x3957,
    0x120d,
    0x38b5,
    0x1122,
    0x3817,
    0x103c,
    0x3703,
    0x0ed3,
    0x35f0,
    0x0d6d,
    0x3c00,
    0x007a,
    0x3c00,
    0x0089,
    0x3bfe,
    0x011d,
    0x3bfb,
    0x027c,
    0x3bf0,
    0x04fa,
    0x3bda,
    0x0881,
    0x3bb1,
    0x0acd,
    0x3b6f,
    0x0c97,
    0x3b10,
    0x0d7b,
    0x3a93,
    0x0df1,
    0x39fe,
    0x0def,
    0x3959,
    0x0d8a,
    0x38af,
    0x0ce9,
    0x3808,
    0x0c31,
    0x36d5,
    0x0af0,
    0x35b9,
    0x09a3,
    0x3c00,
    0x0000,
    0x3c00,
    0x0001,
    0x3bff,
    0x0015,
    0x3bfb,
    0x0059,
    0x3bf2,
    0x00fd,
    0x3bdd,
    0x01df,
    0x3bb7,
    0x031c,
    0x3b79,
    0x047c,
    0x3b1d,
    0x05d4,
    0x3aa0,
    0x06d5,
    0x3a08,
    0x075a,
    0x395d,
    0x075e,
    0x38aa,
    0x06f7,
    0x37f4,
    0x0648,
    0x36ac,
    0x0576,
    0x3586,
    0x049f
]);
let $d89c9137a3d237c2$var$lut = null;
const $d89c9137a3d237c2$var$DFGLUT = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ roughness: roughness, dotNV: dotNV })=>{
    if ($d89c9137a3d237c2$var$lut === null) {
        $d89c9137a3d237c2$var$lut = new (0, $329ek.DataTexture)($d89c9137a3d237c2$var$DATA, 16, 16, (0, $329ek.RGFormat), (0, $329ek.HalfFloatType));
        $d89c9137a3d237c2$var$lut.name = 'DFG_LUT';
        $d89c9137a3d237c2$var$lut.minFilter = (0, $329ek.LinearFilter);
        $d89c9137a3d237c2$var$lut.magFilter = (0, $329ek.LinearFilter);
        $d89c9137a3d237c2$var$lut.wrapS = (0, $329ek.ClampToEdgeWrapping);
        $d89c9137a3d237c2$var$lut.wrapT = (0, $329ek.ClampToEdgeWrapping);
        $d89c9137a3d237c2$var$lut.generateMipmaps = false;
        $d89c9137a3d237c2$var$lut.needsUpdate = true;
    }
    const uv = $d89c9137a3d237c2$var$vec2(roughness, dotNV);
    return $d89c9137a3d237c2$var$texture($d89c9137a3d237c2$var$lut, uv).rg;
});
// GGX BRDF with multi-scattering energy compensation for direct lighting
// This provides more accurate energy conservation, especially for rough materials
// Based on "Practical Multiple Scattering Compensation for Microfacet Models"
// https://blog.selfshadow.com/publications/turquin/ms_comp_final.pdf
const $d89c9137a3d237c2$var$BRDF_GGX_Multiscatter = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ lightDirection: lightDirection, f0: f0, f90: f90, roughness: _roughness, f: f, USE_IRIDESCENCE: USE_IRIDESCENCE, USE_ANISOTROPY: USE_ANISOTROPY })=>{
    // Single-scattering BRDF (standard GGX)
    const singleScatter = $d89c9137a3d237c2$var$BRDF_GGX({
        lightDirection: lightDirection,
        f0: f0,
        f90: f90,
        roughness: _roughness,
        f: f,
        USE_IRIDESCENCE: USE_IRIDESCENCE,
        USE_ANISOTROPY: USE_ANISOTROPY
    });
    // Multi-scattering compensation
    const dotNL = $d89c9137a3d237c2$var$normalView.dot(lightDirection).clamp();
    const dotNV = $d89c9137a3d237c2$var$normalView.dot($d89c9137a3d237c2$var$positionViewDirection).clamp();
    // Precomputed DFG values for view and light directions
    const dfgV = $d89c9137a3d237c2$var$DFGLUT({
        roughness: _roughness,
        dotNV: dotNV
    });
    const dfgL = $d89c9137a3d237c2$var$DFGLUT({
        roughness: _roughness,
        dotNV: dotNL
    });
    // Single-scattering energy for view and light
    const FssEss_V = f0.mul(dfgV.x).add(f90.mul(dfgV.y));
    const FssEss_L = f0.mul(dfgL.x).add(f90.mul(dfgL.y));
    const Ess_V = dfgV.x.add(dfgV.y);
    const Ess_L = dfgL.x.add(dfgL.y);
    // Energy lost to multiple scattering
    const Ems_V = $d89c9137a3d237c2$var$float(1.0).sub(Ess_V);
    const Ems_L = $d89c9137a3d237c2$var$float(1.0).sub(Ess_L);
    // Average Fresnel reflectance
    const Favg = f0.add(f0.oneMinus().mul(0.047619)); // 1/21
    // Multiple scattering contribution
    // Uses geometric mean of view and light contributions for better energy distribution
    const Fms = FssEss_V.mul(FssEss_L).mul(Favg).div($d89c9137a3d237c2$var$float(1.0).sub(Ems_V.mul(Ems_L).mul(Favg).mul(Favg)).add($d89c9137a3d237c2$var$EPSILON));
    // Energy compensation factor
    const compensationFactor = Ems_V.mul(Ems_L);
    const multiScatter = Fms.mul(compensationFactor);
    return singleScatter.add(multiScatter);
});
const $d89c9137a3d237c2$var$EnvironmentBRDF = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn((inputs)=>{
    const { dotNV: dotNV, specularColor: specularColor, specularF90: specularF90, roughness: roughness } = inputs;
    const fab = $d89c9137a3d237c2$var$DFGLUT({
        dotNV: dotNV,
        roughness: roughness
    });
    return specularColor.mul(fab.x).add(specularF90.mul(fab.y));
});
const $d89c9137a3d237c2$var$Schlick_to_F0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ f: f, f90: f90, dotVH: dotVH })=>{
    const x = dotVH.oneMinus().saturate();
    const x2 = x.mul(x);
    const x5 = x.mul(x2, x2).clamp(0, .9999);
    return f.sub($d89c9137a3d237c2$var$vec3(f90).mul(x5)).div(x5.oneMinus());
}).setLayout({
    name: 'Schlick_to_F0',
    type: 'vec3',
    inputs: [
        {
            name: 'f',
            type: 'vec3'
        },
        {
            name: 'f90',
            type: 'float'
        },
        {
            name: 'dotVH',
            type: 'float'
        }
    ]
});
// https://github.com/google/filament/blob/master/shaders/src/brdf.fs
const $d89c9137a3d237c2$var$D_Charlie = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ roughness: roughness, dotNH: dotNH })=>{
    const alpha = roughness.pow2();
    // Estevez and Kulla 2017, "Production Friendly Microfacet Sheen BRDF"
    const invAlpha = $d89c9137a3d237c2$var$float(1.0).div(alpha);
    const cos2h = dotNH.pow2();
    const sin2h = cos2h.oneMinus().max(0.0078125); // 2^(-14/2), so sin2h^2 > 0 in fp16
    return $d89c9137a3d237c2$var$float(2.0).add(invAlpha).mul(sin2h.pow(invAlpha.mul(0.5))).div(2.0 * Math.PI);
}).setLayout({
    name: 'D_Charlie',
    type: 'float',
    inputs: [
        {
            name: 'roughness',
            type: 'float'
        },
        {
            name: 'dotNH',
            type: 'float'
        }
    ]
});
// https://github.com/google/filament/blob/master/shaders/src/brdf.fs
const $d89c9137a3d237c2$var$V_Neubelt = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ dotNV: dotNV, dotNL: dotNL })=>{
    // Neubelt and Pettineo 2013, "Crafting a Next-gen Material Pipeline for The Order: 1886"
    return $d89c9137a3d237c2$var$float(1.0).div($d89c9137a3d237c2$var$float(4.0).mul(dotNL.add(dotNV).sub(dotNL.mul(dotNV))));
}).setLayout({
    name: 'V_Neubelt',
    type: 'float',
    inputs: [
        {
            name: 'dotNV',
            type: 'float'
        },
        {
            name: 'dotNL',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$BRDF_Sheen = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ lightDirection: lightDirection })=>{
    const halfDir = lightDirection.add($d89c9137a3d237c2$var$positionViewDirection).normalize();
    const dotNL = $d89c9137a3d237c2$var$normalView.dot(lightDirection).clamp();
    const dotNV = $d89c9137a3d237c2$var$normalView.dot($d89c9137a3d237c2$var$positionViewDirection).clamp();
    const dotNH = $d89c9137a3d237c2$var$normalView.dot(halfDir).clamp();
    const D = $d89c9137a3d237c2$var$D_Charlie({
        roughness: $d89c9137a3d237c2$var$sheenRoughness,
        dotNH: dotNH
    });
    const V = $d89c9137a3d237c2$var$V_Neubelt({
        dotNV: dotNV,
        dotNL: dotNL
    });
    return $d89c9137a3d237c2$var$sheen.mul(D).mul(V);
});
// Rect Area Light
// Real-Time Polygonal-Light Shading with Linearly Transformed Cosines
// by Eric Heitz, Jonathan Dupuy, Stephen Hill and David Neubelt
// code: https://github.com/selfshadow/ltc_code/
const $d89c9137a3d237c2$var$LTC_Uv = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ N: N, V: V, roughness: roughness })=>{
    const LUT_SIZE = 64.0;
    const LUT_SCALE = (LUT_SIZE - 1.0) / LUT_SIZE;
    const LUT_BIAS = 0.5 / LUT_SIZE;
    const dotNV = N.dot(V).saturate();
    // texture parameterized by sqrt( GGX alpha ) and sqrt( 1 - cos( theta ) )
    const uv = $d89c9137a3d237c2$var$vec2(roughness, dotNV.oneMinus().sqrt());
    uv.assign(uv.mul(LUT_SCALE).add(LUT_BIAS));
    return uv;
}).setLayout({
    name: 'LTC_Uv',
    type: 'vec2',
    inputs: [
        {
            name: 'N',
            type: 'vec3'
        },
        {
            name: 'V',
            type: 'vec3'
        },
        {
            name: 'roughness',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$LTC_ClippedSphereFormFactor = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ f: f })=>{
    // Real-Time Area Lighting: a Journey from Research to Production (p.102)
    // An approximation of the form factor of a horizon-clipped rectangle.
    const l = f.length();
    return $d89c9137a3d237c2$var$max$1(l.mul(l).add(f.z).div(l.add(1.0)), 0);
}).setLayout({
    name: 'LTC_ClippedSphereFormFactor',
    type: 'float',
    inputs: [
        {
            name: 'f',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$LTC_EdgeVectorFormFactor = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ v1: v1, v2: v2 })=>{
    const x = v1.dot(v2);
    const y = x.abs().toVar();
    // rational polynomial approximation to theta / sin( theta ) / 2PI
    const a = y.mul(0.0145206).add(0.4965155).mul(y).add(0.8543985).toVar();
    const b = y.add(4.1616724).mul(y).add(3.4175940).toVar();
    const v = a.div(b);
    const theta_sintheta = x.greaterThan(0.0).select(v, $d89c9137a3d237c2$var$max$1(x.mul(x).oneMinus(), 1e-7).inverseSqrt().mul(0.5).sub(v));
    return v1.cross(v2).mul(theta_sintheta);
}).setLayout({
    name: 'LTC_EdgeVectorFormFactor',
    type: 'vec3',
    inputs: [
        {
            name: 'v1',
            type: 'vec3'
        },
        {
            name: 'v2',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$LTC_Evaluate = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ N: N, V: V, P: P, mInv: mInv, p0: p0, p1: p1, p2: p2, p3: p3 })=>{
    // bail if point is on back side of plane of light
    // assumes ccw winding order of light vertices
    const v1 = p1.sub(p0).toVar();
    const v2 = p3.sub(p0).toVar();
    const lightNormal = v1.cross(v2);
    const result = $d89c9137a3d237c2$var$vec3().toVar();
    $d89c9137a3d237c2$var$If(lightNormal.dot(P.sub(p0)).greaterThanEqual(0.0), ()=>{
        // construct orthonormal basis around N
        const T1 = V.sub(N.mul(V.dot(N))).normalize();
        const T2 = N.cross(T1).negate(); // negated from paper; possibly due to a different handedness of world coordinate system
        // compute transform
        const mat = mInv.mul($d89c9137a3d237c2$var$mat3(T1, T2, N).transpose()).toVar();
        // transform rect
        // & project rect onto sphere
        const coords0 = mat.mul(p0.sub(P)).normalize().toVar();
        const coords1 = mat.mul(p1.sub(P)).normalize().toVar();
        const coords2 = mat.mul(p2.sub(P)).normalize().toVar();
        const coords3 = mat.mul(p3.sub(P)).normalize().toVar();
        // calculate vector form factor
        const vectorFormFactor = $d89c9137a3d237c2$var$vec3(0).toVar();
        vectorFormFactor.addAssign($d89c9137a3d237c2$var$LTC_EdgeVectorFormFactor({
            v1: coords0,
            v2: coords1
        }));
        vectorFormFactor.addAssign($d89c9137a3d237c2$var$LTC_EdgeVectorFormFactor({
            v1: coords1,
            v2: coords2
        }));
        vectorFormFactor.addAssign($d89c9137a3d237c2$var$LTC_EdgeVectorFormFactor({
            v1: coords2,
            v2: coords3
        }));
        vectorFormFactor.addAssign($d89c9137a3d237c2$var$LTC_EdgeVectorFormFactor({
            v1: coords3,
            v2: coords0
        }));
        // adjust for horizon clipping
        result.assign($d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$LTC_ClippedSphereFormFactor({
            f: vectorFormFactor
        })));
    });
    return result;
}).setLayout({
    name: 'LTC_Evaluate',
    type: 'vec3',
    inputs: [
        {
            name: 'N',
            type: 'vec3'
        },
        {
            name: 'V',
            type: 'vec3'
        },
        {
            name: 'P',
            type: 'vec3'
        },
        {
            name: 'mInv',
            type: 'mat3'
        },
        {
            name: 'p0',
            type: 'vec3'
        },
        {
            name: 'p1',
            type: 'vec3'
        },
        {
            name: 'p2',
            type: 'vec3'
        },
        {
            name: 'p3',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$LTC_Evaluate_Volume = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ P: P, p0: p0, p1: p1, p2: p2, p3: p3 })=>{
    // bail if point is on back side of plane of light
    // assumes ccw winding order of light vertices
    const v1 = p1.sub(p0).toVar();
    const v2 = p3.sub(p0).toVar();
    const lightNormal = v1.cross(v2);
    const result = $d89c9137a3d237c2$var$vec3().toVar();
    $d89c9137a3d237c2$var$If(lightNormal.dot(P.sub(p0)).greaterThanEqual(0.0), ()=>{
        // transform rect
        // & project rect onto sphere
        const coords0 = p0.sub(P).normalize().toVar();
        const coords1 = p1.sub(P).normalize().toVar();
        const coords2 = p2.sub(P).normalize().toVar();
        const coords3 = p3.sub(P).normalize().toVar();
        // calculate vector form factor
        const vectorFormFactor = $d89c9137a3d237c2$var$vec3(0).toVar();
        vectorFormFactor.addAssign($d89c9137a3d237c2$var$LTC_EdgeVectorFormFactor({
            v1: coords0,
            v2: coords1
        }));
        vectorFormFactor.addAssign($d89c9137a3d237c2$var$LTC_EdgeVectorFormFactor({
            v1: coords1,
            v2: coords2
        }));
        vectorFormFactor.addAssign($d89c9137a3d237c2$var$LTC_EdgeVectorFormFactor({
            v1: coords2,
            v2: coords3
        }));
        vectorFormFactor.addAssign($d89c9137a3d237c2$var$LTC_EdgeVectorFormFactor({
            v1: coords3,
            v2: coords0
        }));
        // adjust for horizon clipping
        result.assign($d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$LTC_ClippedSphereFormFactor({
            f: vectorFormFactor.abs()
        })));
    });
    return result;
}).setLayout({
    name: 'LTC_Evaluate',
    type: 'vec3',
    inputs: [
        {
            name: 'P',
            type: 'vec3'
        },
        {
            name: 'p0',
            type: 'vec3'
        },
        {
            name: 'p1',
            type: 'vec3'
        },
        {
            name: 'p2',
            type: 'vec3'
        },
        {
            name: 'p3',
            type: 'vec3'
        }
    ]
});
// Mipped Bicubic Texture Filtering by N8
// https://www.shadertoy.com/view/Dl2SDW
const $d89c9137a3d237c2$var$bC = 1.0 / 6.0;
const $d89c9137a3d237c2$var$w0 = (a)=>$d89c9137a3d237c2$var$mul($d89c9137a3d237c2$var$bC, $d89c9137a3d237c2$var$mul(a, $d89c9137a3d237c2$var$mul(a, a.negate().add(3.0)).sub(3.0)).add(1.0));
const $d89c9137a3d237c2$var$w1 = (a)=>$d89c9137a3d237c2$var$mul($d89c9137a3d237c2$var$bC, $d89c9137a3d237c2$var$mul(a, $d89c9137a3d237c2$var$mul(a, $d89c9137a3d237c2$var$mul(3.0, a).sub(6.0))).add(4.0));
const $d89c9137a3d237c2$var$w2 = (a)=>$d89c9137a3d237c2$var$mul($d89c9137a3d237c2$var$bC, $d89c9137a3d237c2$var$mul(a, $d89c9137a3d237c2$var$mul(a, $d89c9137a3d237c2$var$mul(-3, a).add(3.0)).add(3.0)).add(1.0));
const $d89c9137a3d237c2$var$w3 = (a)=>$d89c9137a3d237c2$var$mul($d89c9137a3d237c2$var$bC, $d89c9137a3d237c2$var$pow(a, 3));
const $d89c9137a3d237c2$var$g0 = (a)=>$d89c9137a3d237c2$var$w0(a).add($d89c9137a3d237c2$var$w1(a));
const $d89c9137a3d237c2$var$g1 = (a)=>$d89c9137a3d237c2$var$w2(a).add($d89c9137a3d237c2$var$w3(a));
// h0 and h1 are the two offset functions
const $d89c9137a3d237c2$var$h0 = (a)=>$d89c9137a3d237c2$var$add(-1, $d89c9137a3d237c2$var$w1(a).div($d89c9137a3d237c2$var$w0(a).add($d89c9137a3d237c2$var$w1(a))));
const $d89c9137a3d237c2$var$h1 = (a)=>$d89c9137a3d237c2$var$add(1.0, $d89c9137a3d237c2$var$w3(a).div($d89c9137a3d237c2$var$w2(a).add($d89c9137a3d237c2$var$w3(a))));
const $d89c9137a3d237c2$var$bicubic = (textureNode, texelSize, lod)=>{
    const uv = textureNode.uvNode;
    const uvScaled = $d89c9137a3d237c2$var$mul(uv, texelSize.zw).add(0.5);
    const iuv = $d89c9137a3d237c2$var$floor(uvScaled);
    const fuv = $d89c9137a3d237c2$var$fract(uvScaled);
    const g0x = $d89c9137a3d237c2$var$g0(fuv.x);
    const g1x = $d89c9137a3d237c2$var$g1(fuv.x);
    const h0x = $d89c9137a3d237c2$var$h0(fuv.x);
    const h1x = $d89c9137a3d237c2$var$h1(fuv.x);
    const h0y = $d89c9137a3d237c2$var$h0(fuv.y);
    const h1y = $d89c9137a3d237c2$var$h1(fuv.y);
    const p0 = $d89c9137a3d237c2$var$vec2(iuv.x.add(h0x), iuv.y.add(h0y)).sub(0.5).mul(texelSize.xy);
    const p1 = $d89c9137a3d237c2$var$vec2(iuv.x.add(h1x), iuv.y.add(h0y)).sub(0.5).mul(texelSize.xy);
    const p2 = $d89c9137a3d237c2$var$vec2(iuv.x.add(h0x), iuv.y.add(h1y)).sub(0.5).mul(texelSize.xy);
    const p3 = $d89c9137a3d237c2$var$vec2(iuv.x.add(h1x), iuv.y.add(h1y)).sub(0.5).mul(texelSize.xy);
    const a = $d89c9137a3d237c2$var$g0(fuv.y).mul($d89c9137a3d237c2$var$add(g0x.mul(textureNode.sample(p0).level(lod)), g1x.mul(textureNode.sample(p1).level(lod))));
    const b = $d89c9137a3d237c2$var$g1(fuv.y).mul($d89c9137a3d237c2$var$add(g0x.mul(textureNode.sample(p2).level(lod)), g1x.mul(textureNode.sample(p3).level(lod))));
    return a.add(b);
};
/**
 * Applies mipped bicubic texture filtering to the given texture node.
 *
 * @tsl
 * @function
 * @param {TextureNode} textureNode - The texture node that should be filtered.
 * @param {Node<float>} lodNode - Defines the LOD to sample from.
 * @return {Node} The filtered texture sample.
 */ const $d89c9137a3d237c2$var$textureBicubicLevel = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([textureNode, lodNode])=>{
    const fLodSize = $d89c9137a3d237c2$var$vec2(textureNode.size($d89c9137a3d237c2$var$int(lodNode)));
    const cLodSize = $d89c9137a3d237c2$var$vec2(textureNode.size($d89c9137a3d237c2$var$int(lodNode.add(1.0))));
    const fLodSizeInv = $d89c9137a3d237c2$var$div(1.0, fLodSize);
    const cLodSizeInv = $d89c9137a3d237c2$var$div(1.0, cLodSize);
    const fSample = $d89c9137a3d237c2$var$bicubic(textureNode, $d89c9137a3d237c2$var$vec4(fLodSizeInv, fLodSize), $d89c9137a3d237c2$var$floor(lodNode));
    const cSample = $d89c9137a3d237c2$var$bicubic(textureNode, $d89c9137a3d237c2$var$vec4(cLodSizeInv, cLodSize), $d89c9137a3d237c2$var$ceil(lodNode));
    return $d89c9137a3d237c2$var$fract(lodNode).mix(fSample, cSample);
});
/**
 * Applies mipped bicubic texture filtering to the given texture node.
 *
 * @tsl
 * @function
 * @param {TextureNode} textureNode - The texture node that should be filtered.
 * @param {Node<float>} [strength] - Defines the strength of the bicubic filtering.
 * @return {Node} The filtered texture sample.
 */ const $d89c9137a3d237c2$var$textureBicubic = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([textureNode, strength])=>{
    const lod = strength.mul($d89c9137a3d237c2$var$maxMipLevel(textureNode));
    return $d89c9137a3d237c2$var$textureBicubicLevel(textureNode, lod);
});
//
// Transmission
//
const $d89c9137a3d237c2$var$getVolumeTransmissionRay = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([n, v, thickness, ior, modelMatrix])=>{
    // Direction of refracted light.
    const refractionVector = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$refract(v.negate(), $d89c9137a3d237c2$var$normalize(n), $d89c9137a3d237c2$var$div(1.0, ior)));
    // Compute rotation-independent scaling of the model matrix.
    const modelScale = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$length(modelMatrix[0].xyz), $d89c9137a3d237c2$var$length(modelMatrix[1].xyz), $d89c9137a3d237c2$var$length(modelMatrix[2].xyz));
    // The thickness is specified in local space.
    return $d89c9137a3d237c2$var$normalize(refractionVector).mul(thickness.mul(modelScale));
}).setLayout({
    name: 'getVolumeTransmissionRay',
    type: 'vec3',
    inputs: [
        {
            name: 'n',
            type: 'vec3'
        },
        {
            name: 'v',
            type: 'vec3'
        },
        {
            name: 'thickness',
            type: 'float'
        },
        {
            name: 'ior',
            type: 'float'
        },
        {
            name: 'modelMatrix',
            type: 'mat4'
        }
    ]
});
const $d89c9137a3d237c2$var$applyIorToRoughness = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([roughness, ior])=>{
    // Scale roughness with IOR so that an IOR of 1.0 results in no microfacet refraction and
    // an IOR of 1.5 results in the default amount of microfacet refraction.
    return roughness.mul($d89c9137a3d237c2$var$clamp(ior.mul(2.0).sub(2.0), 0.0, 1.0));
}).setLayout({
    name: 'applyIorToRoughness',
    type: 'float',
    inputs: [
        {
            name: 'roughness',
            type: 'float'
        },
        {
            name: 'ior',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$viewportBackSideTexture = /*@__PURE__*/ $d89c9137a3d237c2$var$viewportMipTexture();
const $d89c9137a3d237c2$var$viewportFrontSideTexture = /*@__PURE__*/ $d89c9137a3d237c2$var$viewportMipTexture();
const $d89c9137a3d237c2$var$getTransmissionSample = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([fragCoord, roughness, ior], { material: material })=>{
    const vTexture = material.side === (0, $329ek.BackSide) ? $d89c9137a3d237c2$var$viewportBackSideTexture : $d89c9137a3d237c2$var$viewportFrontSideTexture;
    const transmissionSample = vTexture.sample(fragCoord);
    //const transmissionSample = viewportMipTexture( fragCoord );
    const lod = $d89c9137a3d237c2$var$log2($d89c9137a3d237c2$var$screenSize.x).mul($d89c9137a3d237c2$var$applyIorToRoughness(roughness, ior));
    return $d89c9137a3d237c2$var$textureBicubicLevel(transmissionSample, lod);
});
const $d89c9137a3d237c2$var$volumeAttenuation = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([transmissionDistance, attenuationColor, attenuationDistance])=>{
    $d89c9137a3d237c2$var$If(attenuationDistance.notEqual(0), ()=>{
        // Compute light attenuation using Beer's law.
        const attenuationCoefficient = $d89c9137a3d237c2$var$log(attenuationColor).negate().div(attenuationDistance);
        const transmittance = $d89c9137a3d237c2$var$exp(attenuationCoefficient.negate().mul(transmissionDistance));
        return transmittance;
    });
    // Attenuation distance is +∞, i.e. the transmitted color is not attenuated at all.
    return $d89c9137a3d237c2$var$vec3(1.0);
}).setLayout({
    name: 'volumeAttenuation',
    type: 'vec3',
    inputs: [
        {
            name: 'transmissionDistance',
            type: 'float'
        },
        {
            name: 'attenuationColor',
            type: 'vec3'
        },
        {
            name: 'attenuationDistance',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$getIBLVolumeRefraction = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([n, v, roughness, diffuseColor, specularColor, specularF90, position, modelMatrix, viewMatrix, projMatrix, ior, thickness, attenuationColor, attenuationDistance, dispersion])=>{
    let transmittedLight, transmittance;
    if (dispersion) {
        transmittedLight = $d89c9137a3d237c2$var$vec4().toVar();
        transmittance = $d89c9137a3d237c2$var$vec3().toVar();
        const halfSpread = ior.sub(1.0).mul(dispersion.mul(0.025));
        const iors = $d89c9137a3d237c2$var$vec3(ior.sub(halfSpread), ior, ior.add(halfSpread));
        $d89c9137a3d237c2$var$Loop({
            start: 0,
            end: 3
        }, ({ i: i })=>{
            const ior = iors.element(i);
            const transmissionRay = $d89c9137a3d237c2$var$getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);
            const refractedRayExit = position.add(transmissionRay);
            // Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
            const ndcPos = projMatrix.mul(viewMatrix.mul($d89c9137a3d237c2$var$vec4(refractedRayExit, 1.0)));
            const refractionCoords = $d89c9137a3d237c2$var$vec2(ndcPos.xy.div(ndcPos.w)).toVar();
            refractionCoords.addAssign(1.0);
            refractionCoords.divAssign(2.0);
            refractionCoords.assign($d89c9137a3d237c2$var$vec2(refractionCoords.x, refractionCoords.y.oneMinus())); // webgpu
            // Sample framebuffer to get pixel the refracted ray hits.
            const transmissionSample = $d89c9137a3d237c2$var$getTransmissionSample(refractionCoords, roughness, ior);
            transmittedLight.element(i).assign(transmissionSample.element(i));
            transmittedLight.a.addAssign(transmissionSample.a);
            transmittance.element(i).assign(diffuseColor.element(i).mul($d89c9137a3d237c2$var$volumeAttenuation($d89c9137a3d237c2$var$length(transmissionRay), attenuationColor, attenuationDistance).element(i)));
        });
        transmittedLight.a.divAssign(3.0);
    } else {
        const transmissionRay = $d89c9137a3d237c2$var$getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);
        const refractedRayExit = position.add(transmissionRay);
        // Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
        const ndcPos = projMatrix.mul(viewMatrix.mul($d89c9137a3d237c2$var$vec4(refractedRayExit, 1.0)));
        const refractionCoords = $d89c9137a3d237c2$var$vec2(ndcPos.xy.div(ndcPos.w)).toVar();
        refractionCoords.addAssign(1.0);
        refractionCoords.divAssign(2.0);
        refractionCoords.assign($d89c9137a3d237c2$var$vec2(refractionCoords.x, refractionCoords.y.oneMinus())); // webgpu
        // Sample framebuffer to get pixel the refracted ray hits.
        transmittedLight = $d89c9137a3d237c2$var$getTransmissionSample(refractionCoords, roughness, ior);
        transmittance = diffuseColor.mul($d89c9137a3d237c2$var$volumeAttenuation($d89c9137a3d237c2$var$length(transmissionRay), attenuationColor, attenuationDistance));
    }
    const attenuatedColor = transmittance.rgb.mul(transmittedLight.rgb);
    const dotNV = n.dot(v).clamp();
    // Get the specular component.
    const F = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$EnvironmentBRDF({
        dotNV: dotNV,
        specularColor: specularColor,
        specularF90: specularF90,
        roughness: roughness
    }));
    // As less light is transmitted, the opacity should be increased. This simple approximation does a decent job
    // of modulating a CSS background, and has no effect when the buffer is opaque, due to a solid object or clear color.
    const transmittanceFactor = transmittance.r.add(transmittance.g, transmittance.b).div(3.0);
    return $d89c9137a3d237c2$var$vec4(F.oneMinus().mul(attenuatedColor), transmittedLight.a.oneMinus().mul(transmittanceFactor).oneMinus());
});
//
// Iridescence
//
// XYZ to linear-sRGB color space
const $d89c9137a3d237c2$var$XYZ_TO_REC709 = /*@__PURE__*/ $d89c9137a3d237c2$var$mat3(3.2404542, -0.969266, 0.0556434, -1.5371385, 1.8760108, -0.2040259, -0.4985314, 0.0415560, 1.0572252);
// Assume air interface for top
// Note: We don't handle the case fresnel0 == 1
const $d89c9137a3d237c2$var$Fresnel0ToIor = (fresnel0)=>{
    const sqrtF0 = fresnel0.sqrt();
    return $d89c9137a3d237c2$var$vec3(1.0).add(sqrtF0).div($d89c9137a3d237c2$var$vec3(1.0).sub(sqrtF0));
};
// ior is a value between 1.0 and 3.0. 1.0 is air interface
const $d89c9137a3d237c2$var$IorToFresnel0 = (transmittedIor, incidentIor)=>{
    return transmittedIor.sub(incidentIor).div(transmittedIor.add(incidentIor)).pow2();
};
// Fresnel equations for dielectric/dielectric interfaces.
// Ref: https://belcour.github.io/blog/research/2017/05/01/brdf-thin-film.html
// Evaluation XYZ sensitivity curves in Fourier space
const $d89c9137a3d237c2$var$evalSensitivity = (OPD, shift)=>{
    const phase = OPD.mul(2.0 * Math.PI * 1.0e-9);
    const val = $d89c9137a3d237c2$var$vec3(5.4856e-13, 4.4201e-13, 5.2481e-13);
    const pos = $d89c9137a3d237c2$var$vec3(1.6810e+06, 1.7953e+06, 2.2084e+06);
    const VAR = $d89c9137a3d237c2$var$vec3(4.3278e+09, 9.3046e+09, 6.6121e+09);
    const x = $d89c9137a3d237c2$var$float(9.7470e-14 * Math.sqrt(2.0 * Math.PI * 4.5282e+09)).mul(phase.mul(2.2399e+06).add(shift.x).cos()).mul(phase.pow2().mul(-4528200000).exp());
    let xyz = val.mul(VAR.mul(2.0 * Math.PI).sqrt()).mul(pos.mul(phase).add(shift).cos()).mul(phase.pow2().negate().mul(VAR).exp());
    xyz = $d89c9137a3d237c2$var$vec3(xyz.x.add(x), xyz.y, xyz.z).div(1.0685e-7);
    const rgb = $d89c9137a3d237c2$var$XYZ_TO_REC709.mul(xyz);
    return rgb;
};
const $d89c9137a3d237c2$var$evalIridescence = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ outsideIOR: outsideIOR, eta2: eta2, cosTheta1: cosTheta1, thinFilmThickness: thinFilmThickness, baseF0: baseF0 })=>{
    // Force iridescenceIOR -> outsideIOR when thinFilmThickness -> 0.0
    const iridescenceIOR = $d89c9137a3d237c2$var$mix(outsideIOR, eta2, $d89c9137a3d237c2$var$smoothstep(0.0, 0.03, thinFilmThickness));
    // Evaluate the cosTheta on the base layer (Snell law)
    const sinTheta2Sq = outsideIOR.div(iridescenceIOR).pow2().mul(cosTheta1.pow2().oneMinus());
    // Handle TIR:
    const cosTheta2Sq = sinTheta2Sq.oneMinus();
    $d89c9137a3d237c2$var$If(cosTheta2Sq.lessThan(0), ()=>{
        return $d89c9137a3d237c2$var$vec3(1.0);
    });
    const cosTheta2 = cosTheta2Sq.sqrt();
    // First interface
    const R0 = $d89c9137a3d237c2$var$IorToFresnel0(iridescenceIOR, outsideIOR);
    const R12 = $d89c9137a3d237c2$var$F_Schlick({
        f0: R0,
        f90: 1.0,
        dotVH: cosTheta1
    });
    //const R21 = R12;
    const T121 = R12.oneMinus();
    const phi12 = iridescenceIOR.lessThan(outsideIOR).select(Math.PI, 0.0);
    const phi21 = $d89c9137a3d237c2$var$float(Math.PI).sub(phi12);
    // Second interface
    const baseIOR = $d89c9137a3d237c2$var$Fresnel0ToIor(baseF0.clamp(0.0, 0.9999)); // guard against 1.0
    const R1 = $d89c9137a3d237c2$var$IorToFresnel0(baseIOR, iridescenceIOR.toVec3());
    const R23 = $d89c9137a3d237c2$var$F_Schlick({
        f0: R1,
        f90: 1.0,
        dotVH: cosTheta2
    });
    const phi23 = $d89c9137a3d237c2$var$vec3(baseIOR.x.lessThan(iridescenceIOR).select(Math.PI, 0.0), baseIOR.y.lessThan(iridescenceIOR).select(Math.PI, 0.0), baseIOR.z.lessThan(iridescenceIOR).select(Math.PI, 0.0));
    // Phase shift
    const OPD = iridescenceIOR.mul(thinFilmThickness, cosTheta2, 2.0);
    const phi = $d89c9137a3d237c2$var$vec3(phi21).add(phi23);
    // Compound terms
    const R123 = R12.mul(R23).clamp(1e-5, 0.9999);
    const r123 = R123.sqrt();
    const Rs = T121.pow2().mul(R23).div($d89c9137a3d237c2$var$vec3(1.0).sub(R123));
    // Reflectance term for m = 0 (DC term amplitude)
    const C0 = R12.add(Rs);
    const I = C0.toVar();
    // Reflectance term for m > 0 (pairs of diracs)
    const Cm = Rs.sub(T121).toVar();
    $d89c9137a3d237c2$var$Loop({
        start: 1,
        end: 2,
        condition: '<=',
        name: 'm'
    }, ({ m: m })=>{
        Cm.mulAssign(r123);
        const Sm = $d89c9137a3d237c2$var$evalSensitivity($d89c9137a3d237c2$var$float(m).mul(OPD), $d89c9137a3d237c2$var$float(m).mul(phi)).mul(2.0);
        I.addAssign(Cm.mul(Sm));
    });
    // Since out of gamut colors might be produced, negative color values are clamped to 0.
    return I.max($d89c9137a3d237c2$var$vec3(0.0));
}).setLayout({
    name: 'evalIridescence',
    type: 'vec3',
    inputs: [
        {
            name: 'outsideIOR',
            type: 'float'
        },
        {
            name: 'eta2',
            type: 'float'
        },
        {
            name: 'cosTheta1',
            type: 'float'
        },
        {
            name: 'thinFilmThickness',
            type: 'float'
        },
        {
            name: 'baseF0',
            type: 'vec3'
        }
    ]
});
//
//	Sheen
//
// This is a curve-fit approximation to the "Charlie sheen" BRDF integrated over the hemisphere from
// Estevez and Kulla 2017, "Production Friendly Microfacet Sheen BRDF".
const $d89c9137a3d237c2$var$IBLSheenBRDF = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ normal: normal, viewDir: viewDir, roughness: roughness })=>{
    const dotNV = normal.dot(viewDir).saturate();
    const r2 = roughness.mul(roughness);
    const rInv = roughness.add(0.1).reciprocal();
    const a = $d89c9137a3d237c2$var$float(-1.9362).add(roughness.mul(1.0678)).add(r2.mul(0.4573)).sub(rInv.mul(0.8469));
    const b = $d89c9137a3d237c2$var$float(-0.6014).add(roughness.mul(0.5538)).sub(r2.mul(0.4670)).sub(rInv.mul(0.1255));
    const DG = a.mul(dotNV).add(b).exp();
    return DG.saturate();
});
const $d89c9137a3d237c2$var$clearcoatF0 = $d89c9137a3d237c2$var$vec3(0.04);
const $d89c9137a3d237c2$var$clearcoatF90 = $d89c9137a3d237c2$var$float(1);
/**
 * Represents the lighting model for a PBR material.
 *
 * @augments LightingModel
 */ class $d89c9137a3d237c2$export$b69e16149fd7d508 extends $d89c9137a3d237c2$export$d8f76c0bb8645ea7 {
    /**
	 * Constructs a new physical lighting model.
	 *
	 * @param {boolean} [clearcoat=false] - Whether clearcoat is supported or not.
	 * @param {boolean} [sheen=false] - Whether sheen is supported or not.
	 * @param {boolean} [iridescence=false] - Whether iridescence is supported or not.
	 * @param {boolean} [anisotropy=false] - Whether anisotropy is supported or not.
	 * @param {boolean} [transmission=false] - Whether transmission is supported or not.
	 * @param {boolean} [dispersion=false] - Whether dispersion is supported or not.
	 */ constructor(clearcoat = false, sheen = false, iridescence = false, anisotropy = false, transmission = false, dispersion = false){
        super();
        /**
		 * Whether clearcoat is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clearcoat = clearcoat;
        /**
		 * Whether sheen is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.sheen = sheen;
        /**
		 * Whether iridescence is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.iridescence = iridescence;
        /**
		 * Whether anisotropy is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.anisotropy = anisotropy;
        /**
		 * Whether transmission is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transmission = transmission;
        /**
		 * Whether dispersion is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.dispersion = dispersion;
        /**
		 * The clear coat radiance.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.clearcoatRadiance = null;
        /**
		 * The clear coat specular direct.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.clearcoatSpecularDirect = null;
        /**
		 * The clear coat specular indirect.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.clearcoatSpecularIndirect = null;
        /**
		 * The sheen specular direct.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.sheenSpecularDirect = null;
        /**
		 * The sheen specular indirect.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.sheenSpecularIndirect = null;
        /**
		 * The iridescence Fresnel.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.iridescenceFresnel = null;
        /**
		 * The iridescence F0.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.iridescenceF0 = null;
        /**
		 * The iridescence F0 dielectric.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.iridescenceF0Dielectric = null;
        /**
		 * The iridescence F0 metallic.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.iridescenceF0Metallic = null;
    }
    /**
	 * Depending on what features are requested, the method prepares certain node variables
	 * which are later used for lighting computations.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ start(builder) {
        if (this.clearcoat === true) {
            this.clearcoatRadiance = $d89c9137a3d237c2$var$vec3().toVar('clearcoatRadiance');
            this.clearcoatSpecularDirect = $d89c9137a3d237c2$var$vec3().toVar('clearcoatSpecularDirect');
            this.clearcoatSpecularIndirect = $d89c9137a3d237c2$var$vec3().toVar('clearcoatSpecularIndirect');
        }
        if (this.sheen === true) {
            this.sheenSpecularDirect = $d89c9137a3d237c2$var$vec3().toVar('sheenSpecularDirect');
            this.sheenSpecularIndirect = $d89c9137a3d237c2$var$vec3().toVar('sheenSpecularIndirect');
        }
        if (this.iridescence === true) {
            const dotNVi = $d89c9137a3d237c2$var$normalView.dot($d89c9137a3d237c2$var$positionViewDirection).clamp();
            const iridescenceFresnelDielectric = $d89c9137a3d237c2$var$evalIridescence({
                outsideIOR: $d89c9137a3d237c2$var$float(1.0),
                eta2: $d89c9137a3d237c2$var$iridescenceIOR,
                cosTheta1: dotNVi,
                thinFilmThickness: $d89c9137a3d237c2$var$iridescenceThickness,
                baseF0: $d89c9137a3d237c2$var$specularColor
            });
            const iridescenceFresnelMetallic = $d89c9137a3d237c2$var$evalIridescence({
                outsideIOR: $d89c9137a3d237c2$var$float(1.0),
                eta2: $d89c9137a3d237c2$var$iridescenceIOR,
                cosTheta1: dotNVi,
                thinFilmThickness: $d89c9137a3d237c2$var$iridescenceThickness,
                baseF0: $d89c9137a3d237c2$var$diffuseColor.rgb
            });
            this.iridescenceFresnel = $d89c9137a3d237c2$var$mix(iridescenceFresnelDielectric, iridescenceFresnelMetallic, $d89c9137a3d237c2$var$metalness);
            this.iridescenceF0Dielectric = $d89c9137a3d237c2$var$Schlick_to_F0({
                f: iridescenceFresnelDielectric,
                f90: 1.0,
                dotVH: dotNVi
            });
            this.iridescenceF0Metallic = $d89c9137a3d237c2$var$Schlick_to_F0({
                f: iridescenceFresnelMetallic,
                f90: 1.0,
                dotVH: dotNVi
            });
            this.iridescenceF0 = $d89c9137a3d237c2$var$mix(this.iridescenceF0Dielectric, this.iridescenceF0Metallic, $d89c9137a3d237c2$var$metalness);
        }
        if (this.transmission === true) {
            const position = $d89c9137a3d237c2$var$positionWorld;
            const v = $d89c9137a3d237c2$var$cameraPosition.sub($d89c9137a3d237c2$var$positionWorld).normalize(); // TODO: Create Node for this, same issue in MaterialX
            const n = $d89c9137a3d237c2$var$normalWorld;
            const context = builder.context;
            context.backdrop = $d89c9137a3d237c2$var$getIBLVolumeRefraction(n, v, $d89c9137a3d237c2$var$roughness, $d89c9137a3d237c2$var$diffuseContribution, $d89c9137a3d237c2$var$specularColorBlended, $d89c9137a3d237c2$var$specularF90, position, $d89c9137a3d237c2$var$modelWorldMatrix, $d89c9137a3d237c2$var$cameraViewMatrix, $d89c9137a3d237c2$var$cameraProjectionMatrix, $d89c9137a3d237c2$var$ior, $d89c9137a3d237c2$var$thickness, $d89c9137a3d237c2$var$attenuationColor, $d89c9137a3d237c2$var$attenuationDistance, this.dispersion ? $d89c9137a3d237c2$var$dispersion : null);
            context.backdropAlpha = $d89c9137a3d237c2$var$transmission;
            $d89c9137a3d237c2$var$diffuseColor.a.mulAssign($d89c9137a3d237c2$var$mix(1, context.backdrop.a, $d89c9137a3d237c2$var$transmission));
        }
        super.start(builder);
    }
    // Fdez-Agüera's "Multiple-Scattering Microfacet Model for Real-Time Image Based Lighting"
    // Approximates multi-scattering in order to preserve energy.
    // http://www.jcgt.org/published/0008/01/03/
    computeMultiscattering(singleScatter, multiScatter, specularF90, f0, iridescenceF0 = null) {
        const dotNV = $d89c9137a3d237c2$var$normalView.dot($d89c9137a3d237c2$var$positionViewDirection).clamp(); // @ TODO: Move to core dotNV
        const fab = $d89c9137a3d237c2$var$DFGLUT({
            roughness: $d89c9137a3d237c2$var$roughness,
            dotNV: dotNV
        });
        const Fr = iridescenceF0 ? $d89c9137a3d237c2$var$iridescence.mix(f0, iridescenceF0) : f0;
        const FssEss = Fr.mul(fab.x).add(specularF90.mul(fab.y));
        const Ess = fab.x.add(fab.y);
        const Ems = Ess.oneMinus();
        const Favg = Fr.add(Fr.oneMinus().mul(0.047619)); // 1/21
        const Fms = FssEss.mul(Favg).div(Ems.mul(Favg).oneMinus());
        singleScatter.addAssign(FssEss);
        multiScatter.addAssign(Fms.mul(Ems));
    }
    /**
	 * Implements the direct light.
	 *
	 * @param {Object} lightData - The light data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ direct({ lightDirection: lightDirection, lightColor: lightColor, reflectedLight: reflectedLight }) {
        const dotNL = $d89c9137a3d237c2$var$normalView.dot(lightDirection).clamp();
        const irradiance = dotNL.mul(lightColor).toVar();
        if (this.sheen === true) {
            this.sheenSpecularDirect.addAssign(irradiance.mul($d89c9137a3d237c2$var$BRDF_Sheen({
                lightDirection: lightDirection
            })));
            const sheenAlbedoV = $d89c9137a3d237c2$var$IBLSheenBRDF({
                normal: $d89c9137a3d237c2$var$normalView,
                viewDir: $d89c9137a3d237c2$var$positionViewDirection,
                roughness: $d89c9137a3d237c2$var$sheenRoughness
            });
            const sheenAlbedoL = $d89c9137a3d237c2$var$IBLSheenBRDF({
                normal: $d89c9137a3d237c2$var$normalView,
                viewDir: lightDirection,
                roughness: $d89c9137a3d237c2$var$sheenRoughness
            });
            const sheenEnergyComp = $d89c9137a3d237c2$var$sheen.r.max($d89c9137a3d237c2$var$sheen.g).max($d89c9137a3d237c2$var$sheen.b).mul(sheenAlbedoV.max(sheenAlbedoL)).oneMinus();
            irradiance.mulAssign(sheenEnergyComp);
        }
        if (this.clearcoat === true) {
            const dotNLcc = $d89c9137a3d237c2$var$clearcoatNormalView.dot(lightDirection).clamp();
            const ccIrradiance = dotNLcc.mul(lightColor);
            this.clearcoatSpecularDirect.addAssign(ccIrradiance.mul($d89c9137a3d237c2$var$BRDF_GGX({
                lightDirection: lightDirection,
                f0: $d89c9137a3d237c2$var$clearcoatF0,
                f90: $d89c9137a3d237c2$var$clearcoatF90,
                roughness: $d89c9137a3d237c2$var$clearcoatRoughness,
                normalView: $d89c9137a3d237c2$var$clearcoatNormalView
            })));
        }
        reflectedLight.directDiffuse.addAssign(irradiance.mul($d89c9137a3d237c2$var$BRDF_Lambert({
            diffuseColor: $d89c9137a3d237c2$var$diffuseContribution
        })));
        reflectedLight.directSpecular.addAssign(irradiance.mul($d89c9137a3d237c2$var$BRDF_GGX_Multiscatter({
            lightDirection: lightDirection,
            f0: $d89c9137a3d237c2$var$specularColorBlended,
            f90: 1,
            roughness: $d89c9137a3d237c2$var$roughness,
            f: this.iridescenceFresnel,
            USE_IRIDESCENCE: this.iridescence,
            USE_ANISOTROPY: this.anisotropy
        })));
    }
    /**
	 * This method is intended for implementing the direct light term for
	 * rect area light nodes.
	 *
	 * @param {Object} input - The input data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ directRectArea({ lightColor: lightColor, lightPosition: lightPosition, halfWidth: halfWidth, halfHeight: halfHeight, reflectedLight: reflectedLight, ltc_1: ltc_1, ltc_2: ltc_2 }) {
        const p0 = lightPosition.add(halfWidth).sub(halfHeight); // counterclockwise; light shines in local neg z direction
        const p1 = lightPosition.sub(halfWidth).sub(halfHeight);
        const p2 = lightPosition.sub(halfWidth).add(halfHeight);
        const p3 = lightPosition.add(halfWidth).add(halfHeight);
        const N = $d89c9137a3d237c2$var$normalView;
        const V = $d89c9137a3d237c2$var$positionViewDirection;
        const P = $d89c9137a3d237c2$var$positionView.toVar();
        const uv = $d89c9137a3d237c2$var$LTC_Uv({
            N: N,
            V: V,
            roughness: $d89c9137a3d237c2$var$roughness
        });
        const t1 = ltc_1.sample(uv).toVar();
        const t2 = ltc_2.sample(uv).toVar();
        const mInv = $d89c9137a3d237c2$var$mat3($d89c9137a3d237c2$var$vec3(t1.x, 0, t1.y), $d89c9137a3d237c2$var$vec3(0, 1, 0), $d89c9137a3d237c2$var$vec3(t1.z, 0, t1.w)).toVar();
        // LTC Fresnel Approximation by Stephen Hill
        // http://blog.selfshadow.com/publications/s2016-advances/s2016_ltc_fresnel.pdf
        const fresnel = $d89c9137a3d237c2$var$specularColorBlended.mul(t2.x).add($d89c9137a3d237c2$var$specularColorBlended.oneMinus().mul(t2.y)).toVar();
        reflectedLight.directSpecular.addAssign(lightColor.mul(fresnel).mul($d89c9137a3d237c2$var$LTC_Evaluate({
            N: N,
            V: V,
            P: P,
            mInv: mInv,
            p0: p0,
            p1: p1,
            p2: p2,
            p3: p3
        })));
        reflectedLight.directDiffuse.addAssign(lightColor.mul($d89c9137a3d237c2$var$diffuseContribution).mul($d89c9137a3d237c2$var$LTC_Evaluate({
            N: N,
            V: V,
            P: P,
            mInv: $d89c9137a3d237c2$var$mat3(1, 0, 0, 0, 1, 0, 0, 0, 1),
            p0: p0,
            p1: p1,
            p2: p2,
            p3: p3
        })));
    }
    /**
	 * Implements the indirect lighting.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirect(builder) {
        this.indirectDiffuse(builder);
        this.indirectSpecular(builder);
        this.ambientOcclusion(builder);
    }
    /**
	 * Implements the indirect diffuse term.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirectDiffuse(builder) {
        const { irradiance: irradiance, reflectedLight: reflectedLight } = builder.context;
        const diffuse = irradiance.mul($d89c9137a3d237c2$var$BRDF_Lambert({
            diffuseColor: $d89c9137a3d237c2$var$diffuseContribution
        })).toVar();
        if (this.sheen === true) {
            const sheenAlbedo = $d89c9137a3d237c2$var$IBLSheenBRDF({
                normal: $d89c9137a3d237c2$var$normalView,
                viewDir: $d89c9137a3d237c2$var$positionViewDirection,
                roughness: $d89c9137a3d237c2$var$sheenRoughness
            });
            const sheenEnergyComp = $d89c9137a3d237c2$var$sheen.r.max($d89c9137a3d237c2$var$sheen.g).max($d89c9137a3d237c2$var$sheen.b).mul(sheenAlbedo).oneMinus();
            diffuse.mulAssign(sheenEnergyComp);
        }
        reflectedLight.indirectDiffuse.addAssign(diffuse);
    }
    /**
	 * Implements the indirect specular term.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirectSpecular(builder) {
        const { radiance: radiance, iblIrradiance: iblIrradiance, reflectedLight: reflectedLight } = builder.context;
        if (this.sheen === true) this.sheenSpecularIndirect.addAssign(iblIrradiance.mul($d89c9137a3d237c2$var$sheen, $d89c9137a3d237c2$var$IBLSheenBRDF({
            normal: $d89c9137a3d237c2$var$normalView,
            viewDir: $d89c9137a3d237c2$var$positionViewDirection,
            roughness: $d89c9137a3d237c2$var$sheenRoughness
        })));
        if (this.clearcoat === true) {
            const dotNVcc = $d89c9137a3d237c2$var$clearcoatNormalView.dot($d89c9137a3d237c2$var$positionViewDirection).clamp();
            const clearcoatEnv = $d89c9137a3d237c2$var$EnvironmentBRDF({
                dotNV: dotNVcc,
                specularColor: $d89c9137a3d237c2$var$clearcoatF0,
                specularF90: $d89c9137a3d237c2$var$clearcoatF90,
                roughness: $d89c9137a3d237c2$var$clearcoatRoughness
            });
            this.clearcoatSpecularIndirect.addAssign(this.clearcoatRadiance.mul(clearcoatEnv));
        }
        // Both indirect specular and indirect diffuse light accumulate here
        // Compute multiscattering separately for dielectric and metallic, then mix
        const singleScatteringDielectric = $d89c9137a3d237c2$var$vec3().toVar('singleScatteringDielectric');
        const multiScatteringDielectric = $d89c9137a3d237c2$var$vec3().toVar('multiScatteringDielectric');
        const singleScatteringMetallic = $d89c9137a3d237c2$var$vec3().toVar('singleScatteringMetallic');
        const multiScatteringMetallic = $d89c9137a3d237c2$var$vec3().toVar('multiScatteringMetallic');
        this.computeMultiscattering(singleScatteringDielectric, multiScatteringDielectric, $d89c9137a3d237c2$var$specularF90, $d89c9137a3d237c2$var$specularColor, this.iridescenceF0Dielectric);
        this.computeMultiscattering(singleScatteringMetallic, multiScatteringMetallic, $d89c9137a3d237c2$var$specularF90, $d89c9137a3d237c2$var$diffuseColor.rgb, this.iridescenceF0Metallic);
        // Mix based on metalness
        const singleScattering = $d89c9137a3d237c2$var$mix(singleScatteringDielectric, singleScatteringMetallic, $d89c9137a3d237c2$var$metalness);
        const multiScattering = $d89c9137a3d237c2$var$mix(multiScatteringDielectric, multiScatteringMetallic, $d89c9137a3d237c2$var$metalness);
        // Diffuse energy conservation uses dielectric path
        const totalScatteringDielectric = singleScatteringDielectric.add(multiScatteringDielectric);
        const diffuse = $d89c9137a3d237c2$var$diffuseContribution.mul(totalScatteringDielectric.oneMinus());
        const cosineWeightedIrradiance = iblIrradiance.mul(1 / Math.PI);
        const indirectSpecular = radiance.mul(singleScattering).add(multiScattering.mul(cosineWeightedIrradiance)).toVar();
        const indirectDiffuse = diffuse.mul(cosineWeightedIrradiance).toVar();
        if (this.sheen === true) {
            const sheenAlbedo = $d89c9137a3d237c2$var$IBLSheenBRDF({
                normal: $d89c9137a3d237c2$var$normalView,
                viewDir: $d89c9137a3d237c2$var$positionViewDirection,
                roughness: $d89c9137a3d237c2$var$sheenRoughness
            });
            const sheenEnergyComp = $d89c9137a3d237c2$var$sheen.r.max($d89c9137a3d237c2$var$sheen.g).max($d89c9137a3d237c2$var$sheen.b).mul(sheenAlbedo).oneMinus();
            indirectSpecular.mulAssign(sheenEnergyComp);
            indirectDiffuse.mulAssign(sheenEnergyComp);
        }
        reflectedLight.indirectSpecular.addAssign(indirectSpecular);
        reflectedLight.indirectDiffuse.addAssign(indirectDiffuse);
    }
    /**
	 * Implements the ambient occlusion term.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ ambientOcclusion(builder) {
        const { ambientOcclusion: ambientOcclusion, reflectedLight: reflectedLight } = builder.context;
        const dotNV = $d89c9137a3d237c2$var$normalView.dot($d89c9137a3d237c2$var$positionViewDirection).clamp(); // @ TODO: Move to core dotNV
        const aoNV = dotNV.add(ambientOcclusion);
        const aoExp = $d89c9137a3d237c2$var$roughness.mul(-16).oneMinus().negate().exp2();
        const aoNode = ambientOcclusion.sub(aoNV.pow(aoExp).oneMinus()).clamp();
        if (this.clearcoat === true) this.clearcoatSpecularIndirect.mulAssign(ambientOcclusion);
        if (this.sheen === true) this.sheenSpecularIndirect.mulAssign(ambientOcclusion);
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
        reflectedLight.indirectSpecular.mulAssign(aoNode);
    }
    /**
	 * Used for final lighting accumulations depending on the requested features.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ finish({ context: context }) {
        const { outgoingLight: outgoingLight } = context;
        if (this.clearcoat === true) {
            const dotNVcc = $d89c9137a3d237c2$var$clearcoatNormalView.dot($d89c9137a3d237c2$var$positionViewDirection).clamp();
            const Fcc = $d89c9137a3d237c2$var$F_Schlick({
                dotVH: dotNVcc,
                f0: $d89c9137a3d237c2$var$clearcoatF0,
                f90: $d89c9137a3d237c2$var$clearcoatF90
            });
            const clearcoatLight = outgoingLight.mul($d89c9137a3d237c2$var$clearcoat.mul(Fcc).oneMinus()).add(this.clearcoatSpecularDirect.add(this.clearcoatSpecularIndirect).mul($d89c9137a3d237c2$var$clearcoat));
            outgoingLight.assign(clearcoatLight);
        }
        if (this.sheen === true) {
            const sheenLight = outgoingLight.add(this.sheenSpecularDirect, this.sheenSpecularIndirect.mul(1.0 / Math.PI));
            outgoingLight.assign(sheenLight);
        }
    }
}
// These defines must match with PMREMGenerator
const $d89c9137a3d237c2$var$cubeUV_r0 = /*@__PURE__*/ $d89c9137a3d237c2$var$float(1.0);
const $d89c9137a3d237c2$var$cubeUV_m0 = /*@__PURE__*/ $d89c9137a3d237c2$var$float(-2);
const $d89c9137a3d237c2$var$cubeUV_r1 = /*@__PURE__*/ $d89c9137a3d237c2$var$float(0.8);
const $d89c9137a3d237c2$var$cubeUV_m1 = /*@__PURE__*/ $d89c9137a3d237c2$var$float(-1);
const $d89c9137a3d237c2$var$cubeUV_r4 = /*@__PURE__*/ $d89c9137a3d237c2$var$float(0.4);
const $d89c9137a3d237c2$var$cubeUV_m4 = /*@__PURE__*/ $d89c9137a3d237c2$var$float(2.0);
const $d89c9137a3d237c2$var$cubeUV_r5 = /*@__PURE__*/ $d89c9137a3d237c2$var$float(0.305);
const $d89c9137a3d237c2$var$cubeUV_m5 = /*@__PURE__*/ $d89c9137a3d237c2$var$float(3.0);
const $d89c9137a3d237c2$var$cubeUV_r6 = /*@__PURE__*/ $d89c9137a3d237c2$var$float(0.21);
const $d89c9137a3d237c2$var$cubeUV_m6 = /*@__PURE__*/ $d89c9137a3d237c2$var$float(4.0);
const $d89c9137a3d237c2$var$cubeUV_minMipLevel = /*@__PURE__*/ $d89c9137a3d237c2$var$float(4.0);
const $d89c9137a3d237c2$var$cubeUV_minTileSize = /*@__PURE__*/ $d89c9137a3d237c2$var$float(16.0);
// These shader functions convert between the UV coordinates of a single face of
// a cubemap, the 0-5 integer index of a cube face, and the direction vector for
// sampling a textureCube (not generally normalized ).
const $d89c9137a3d237c2$var$getFace = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([direction])=>{
    const absDirection = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$abs(direction)).toVar();
    const face = $d89c9137a3d237c2$var$float(-1).toVar();
    $d89c9137a3d237c2$var$If(absDirection.x.greaterThan(absDirection.z), ()=>{
        $d89c9137a3d237c2$var$If(absDirection.x.greaterThan(absDirection.y), ()=>{
            face.assign($d89c9137a3d237c2$var$select(direction.x.greaterThan(0.0), 0.0, 3.0));
        }).Else(()=>{
            face.assign($d89c9137a3d237c2$var$select(direction.y.greaterThan(0.0), 1.0, 4.0));
        });
    }).Else(()=>{
        $d89c9137a3d237c2$var$If(absDirection.z.greaterThan(absDirection.y), ()=>{
            face.assign($d89c9137a3d237c2$var$select(direction.z.greaterThan(0.0), 2.0, 5.0));
        }).Else(()=>{
            face.assign($d89c9137a3d237c2$var$select(direction.y.greaterThan(0.0), 1.0, 4.0));
        });
    });
    return face;
}).setLayout({
    name: 'getFace',
    type: 'float',
    inputs: [
        {
            name: 'direction',
            type: 'vec3'
        }
    ]
});
// RH coordinate system; PMREM face-indexing convention
const $d89c9137a3d237c2$var$getUV = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([direction, face])=>{
    const uv = $d89c9137a3d237c2$var$vec2().toVar();
    $d89c9137a3d237c2$var$If(face.equal(0.0), ()=>{
        uv.assign($d89c9137a3d237c2$var$vec2(direction.z, direction.y).div($d89c9137a3d237c2$var$abs(direction.x))); // pos x
    }).ElseIf(face.equal(1.0), ()=>{
        uv.assign($d89c9137a3d237c2$var$vec2(direction.x.negate(), direction.z.negate()).div($d89c9137a3d237c2$var$abs(direction.y))); // pos y
    }).ElseIf(face.equal(2.0), ()=>{
        uv.assign($d89c9137a3d237c2$var$vec2(direction.x.negate(), direction.y).div($d89c9137a3d237c2$var$abs(direction.z))); // pos z
    }).ElseIf(face.equal(3.0), ()=>{
        uv.assign($d89c9137a3d237c2$var$vec2(direction.z.negate(), direction.y).div($d89c9137a3d237c2$var$abs(direction.x))); // neg x
    }).ElseIf(face.equal(4.0), ()=>{
        uv.assign($d89c9137a3d237c2$var$vec2(direction.x.negate(), direction.z).div($d89c9137a3d237c2$var$abs(direction.y))); // neg y
    }).Else(()=>{
        uv.assign($d89c9137a3d237c2$var$vec2(direction.x, direction.y).div($d89c9137a3d237c2$var$abs(direction.z))); // neg z
    });
    return $d89c9137a3d237c2$var$mul(0.5, uv.add(1.0));
}).setLayout({
    name: 'getUV',
    type: 'vec2',
    inputs: [
        {
            name: 'direction',
            type: 'vec3'
        },
        {
            name: 'face',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$roughnessToMip = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([roughness])=>{
    const mip = $d89c9137a3d237c2$var$float(0.0).toVar();
    $d89c9137a3d237c2$var$If(roughness.greaterThanEqual($d89c9137a3d237c2$var$cubeUV_r1), ()=>{
        mip.assign($d89c9137a3d237c2$var$cubeUV_r0.sub(roughness).mul($d89c9137a3d237c2$var$cubeUV_m1.sub($d89c9137a3d237c2$var$cubeUV_m0)).div($d89c9137a3d237c2$var$cubeUV_r0.sub($d89c9137a3d237c2$var$cubeUV_r1)).add($d89c9137a3d237c2$var$cubeUV_m0));
    }).ElseIf(roughness.greaterThanEqual($d89c9137a3d237c2$var$cubeUV_r4), ()=>{
        mip.assign($d89c9137a3d237c2$var$cubeUV_r1.sub(roughness).mul($d89c9137a3d237c2$var$cubeUV_m4.sub($d89c9137a3d237c2$var$cubeUV_m1)).div($d89c9137a3d237c2$var$cubeUV_r1.sub($d89c9137a3d237c2$var$cubeUV_r4)).add($d89c9137a3d237c2$var$cubeUV_m1));
    }).ElseIf(roughness.greaterThanEqual($d89c9137a3d237c2$var$cubeUV_r5), ()=>{
        mip.assign($d89c9137a3d237c2$var$cubeUV_r4.sub(roughness).mul($d89c9137a3d237c2$var$cubeUV_m5.sub($d89c9137a3d237c2$var$cubeUV_m4)).div($d89c9137a3d237c2$var$cubeUV_r4.sub($d89c9137a3d237c2$var$cubeUV_r5)).add($d89c9137a3d237c2$var$cubeUV_m4));
    }).ElseIf(roughness.greaterThanEqual($d89c9137a3d237c2$var$cubeUV_r6), ()=>{
        mip.assign($d89c9137a3d237c2$var$cubeUV_r5.sub(roughness).mul($d89c9137a3d237c2$var$cubeUV_m6.sub($d89c9137a3d237c2$var$cubeUV_m5)).div($d89c9137a3d237c2$var$cubeUV_r5.sub($d89c9137a3d237c2$var$cubeUV_r6)).add($d89c9137a3d237c2$var$cubeUV_m5));
    }).Else(()=>{
        mip.assign($d89c9137a3d237c2$var$float(-2).mul($d89c9137a3d237c2$var$log2($d89c9137a3d237c2$var$mul(1.16, roughness)))); // 1.16 = 1.79^0.25
    });
    return mip;
}).setLayout({
    name: 'roughnessToMip',
    type: 'float',
    inputs: [
        {
            name: 'roughness',
            type: 'float'
        }
    ]
});
// RH coordinate system; PMREM face-indexing convention
const $d89c9137a3d237c2$var$getDirection = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([uv_immutable, face])=>{
    const uv = uv_immutable.toVar();
    uv.assign($d89c9137a3d237c2$var$mul(2.0, uv).sub(1.0));
    const direction = $d89c9137a3d237c2$var$vec3(uv, 1.0).toVar();
    $d89c9137a3d237c2$var$If(face.equal(0.0), ()=>{
        direction.assign(direction.zyx); // ( 1, v, u ) pos x
    }).ElseIf(face.equal(1.0), ()=>{
        direction.assign(direction.xzy);
        direction.xz.mulAssign(-1); // ( -u, 1, -v ) pos y
    }).ElseIf(face.equal(2.0), ()=>{
        direction.x.mulAssign(-1); // ( -u, v, 1 ) pos z
    }).ElseIf(face.equal(3.0), ()=>{
        direction.assign(direction.zyx);
        direction.xz.mulAssign(-1); // ( -1, v, -u ) neg x
    }).ElseIf(face.equal(4.0), ()=>{
        direction.assign(direction.xzy);
        direction.xy.mulAssign(-1); // ( -u, -1, v ) neg y
    }).ElseIf(face.equal(5.0), ()=>{
        direction.z.mulAssign(-1); // ( u, v, -1 ) neg zS
    });
    return direction;
}).setLayout({
    name: 'getDirection',
    type: 'vec3',
    inputs: [
        {
            name: 'uv',
            type: 'vec2'
        },
        {
            name: 'face',
            type: 'float'
        }
    ]
});
//
const $d89c9137a3d237c2$var$textureCubeUV = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([envMap, sampleDir_immutable, roughness_immutable, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP])=>{
    const roughness = $d89c9137a3d237c2$var$float(roughness_immutable);
    const sampleDir = $d89c9137a3d237c2$var$vec3(sampleDir_immutable);
    const mip = $d89c9137a3d237c2$var$clamp($d89c9137a3d237c2$var$roughnessToMip(roughness), $d89c9137a3d237c2$var$cubeUV_m0, CUBEUV_MAX_MIP);
    const mipF = $d89c9137a3d237c2$var$fract(mip);
    const mipInt = $d89c9137a3d237c2$var$floor(mip);
    const color0 = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$bilinearCubeUV(envMap, sampleDir, mipInt, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP)).toVar();
    $d89c9137a3d237c2$var$If(mipF.notEqual(0.0), ()=>{
        const color1 = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$bilinearCubeUV(envMap, sampleDir, mipInt.add(1.0), CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP)).toVar();
        color0.assign($d89c9137a3d237c2$var$mix(color0, color1, mipF));
    });
    return color0;
});
const $d89c9137a3d237c2$var$bilinearCubeUV = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([envMap, direction_immutable, mipInt_immutable, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP])=>{
    const mipInt = $d89c9137a3d237c2$var$float(mipInt_immutable).toVar();
    const direction = $d89c9137a3d237c2$var$vec3(direction_immutable);
    const face = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$getFace(direction)).toVar();
    const filterInt = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$max$1($d89c9137a3d237c2$var$cubeUV_minMipLevel.sub(mipInt), 0.0)).toVar();
    mipInt.assign($d89c9137a3d237c2$var$max$1(mipInt, $d89c9137a3d237c2$var$cubeUV_minMipLevel));
    const faceSize = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$exp2(mipInt)).toVar();
    const uv = $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$getUV(direction, face).mul(faceSize.sub(2.0)).add(1.0)).toVar();
    $d89c9137a3d237c2$var$If(face.greaterThan(2.0), ()=>{
        uv.y.addAssign(faceSize);
        face.subAssign(3.0);
    });
    uv.x.addAssign(face.mul(faceSize));
    uv.x.addAssign(filterInt.mul($d89c9137a3d237c2$var$mul(3.0, $d89c9137a3d237c2$var$cubeUV_minTileSize)));
    uv.y.addAssign($d89c9137a3d237c2$var$mul(4.0, $d89c9137a3d237c2$var$exp2(CUBEUV_MAX_MIP).sub(faceSize)));
    uv.x.mulAssign(CUBEUV_TEXEL_WIDTH);
    uv.y.mulAssign(CUBEUV_TEXEL_HEIGHT);
    return envMap.sample(uv).grad($d89c9137a3d237c2$var$vec2(), $d89c9137a3d237c2$var$vec2()); // disable anisotropic filtering
});
const $d89c9137a3d237c2$var$getSample = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ envMap: envMap, mipInt: mipInt, outputDirection: outputDirection, theta: theta, axis: axis, CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP: CUBEUV_MAX_MIP })=>{
    const cosTheta = $d89c9137a3d237c2$var$cos(theta);
    // Rodrigues' axis-angle rotation
    const sampleDirection = outputDirection.mul(cosTheta).add(axis.cross(outputDirection).mul($d89c9137a3d237c2$var$sin(theta))).add(axis.mul(axis.dot(outputDirection).mul(cosTheta.oneMinus())));
    return $d89c9137a3d237c2$var$bilinearCubeUV(envMap, sampleDirection, mipInt, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP);
});
const $d89c9137a3d237c2$var$blur = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ n: n, latitudinal: latitudinal, poleAxis: poleAxis, outputDirection: outputDirection, weights: weights, samples: samples, dTheta: dTheta, mipInt: mipInt, envMap: envMap, CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP: CUBEUV_MAX_MIP })=>{
    const axis = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$select(latitudinal, poleAxis, $d89c9137a3d237c2$var$cross(poleAxis, outputDirection))).toVar();
    $d89c9137a3d237c2$var$If(axis.equal($d89c9137a3d237c2$var$vec3(0.0)), ()=>{
        axis.assign($d89c9137a3d237c2$var$vec3(outputDirection.z, 0.0, outputDirection.x.negate()));
    });
    axis.assign($d89c9137a3d237c2$var$normalize(axis));
    const gl_FragColor = $d89c9137a3d237c2$var$vec3().toVar();
    gl_FragColor.addAssign(weights.element(0).mul($d89c9137a3d237c2$var$getSample({
        theta: 0.0,
        axis: axis,
        outputDirection: outputDirection,
        mipInt: mipInt,
        envMap: envMap,
        CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
        CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
        CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
    })));
    $d89c9137a3d237c2$var$Loop({
        start: $d89c9137a3d237c2$var$int(1),
        end: n
    }, ({ i: i })=>{
        $d89c9137a3d237c2$var$If(i.greaterThanEqual(samples), ()=>{
            $d89c9137a3d237c2$var$Break();
        });
        const theta = $d89c9137a3d237c2$var$float(dTheta.mul($d89c9137a3d237c2$var$float(i))).toVar();
        gl_FragColor.addAssign(weights.element(i).mul($d89c9137a3d237c2$var$getSample({
            theta: theta.mul(-1),
            axis: axis,
            outputDirection: outputDirection,
            mipInt: mipInt,
            envMap: envMap,
            CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
            CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
            CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
        })));
        gl_FragColor.addAssign(weights.element(i).mul($d89c9137a3d237c2$var$getSample({
            theta: theta,
            axis: axis,
            outputDirection: outputDirection,
            mipInt: mipInt,
            envMap: envMap,
            CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
            CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
            CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
        })));
    });
    return $d89c9137a3d237c2$var$vec4(gl_FragColor, 1);
});
// GGX VNDF importance sampling functions
// Van der Corput radical inverse for generating quasi-random sequences
const $d89c9137a3d237c2$var$radicalInverse_VdC = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([bits_immutable])=>{
    const bits = $d89c9137a3d237c2$var$uint(bits_immutable).toVar();
    bits.assign(bits.shiftLeft($d89c9137a3d237c2$var$uint(16)).bitOr(bits.shiftRight($d89c9137a3d237c2$var$uint(16))));
    bits.assign(bits.bitAnd($d89c9137a3d237c2$var$uint(0x55555555)).shiftLeft($d89c9137a3d237c2$var$uint(1)).bitOr(bits.bitAnd($d89c9137a3d237c2$var$uint(0xAAAAAAAA)).shiftRight($d89c9137a3d237c2$var$uint(1))));
    bits.assign(bits.bitAnd($d89c9137a3d237c2$var$uint(0x33333333)).shiftLeft($d89c9137a3d237c2$var$uint(2)).bitOr(bits.bitAnd($d89c9137a3d237c2$var$uint(0xCCCCCCCC)).shiftRight($d89c9137a3d237c2$var$uint(2))));
    bits.assign(bits.bitAnd($d89c9137a3d237c2$var$uint(0x0F0F0F0F)).shiftLeft($d89c9137a3d237c2$var$uint(4)).bitOr(bits.bitAnd($d89c9137a3d237c2$var$uint(0xF0F0F0F0)).shiftRight($d89c9137a3d237c2$var$uint(4))));
    bits.assign(bits.bitAnd($d89c9137a3d237c2$var$uint(0x00FF00FF)).shiftLeft($d89c9137a3d237c2$var$uint(8)).bitOr(bits.bitAnd($d89c9137a3d237c2$var$uint(0xFF00FF00)).shiftRight($d89c9137a3d237c2$var$uint(8))));
    return $d89c9137a3d237c2$var$float(bits).mul(2.3283064365386963e-10); // / 0x100000000
});
// Hammersley sequence for quasi-Monte Carlo sampling
const $d89c9137a3d237c2$var$hammersley = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([i, N])=>{
    return $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$float(i).div($d89c9137a3d237c2$var$float(N)), $d89c9137a3d237c2$var$radicalInverse_VdC(i));
});
// GGX VNDF importance sampling (Eric Heitz 2018)
// "Sampling the GGX Distribution of Visible Normals"
// https://jcgt.org/published/0007/04/01/
const $d89c9137a3d237c2$var$importanceSampleGGX_VNDF = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([Xi, V_immutable, roughness_immutable])=>{
    const V = $d89c9137a3d237c2$var$vec3(V_immutable).toVar();
    const roughness = $d89c9137a3d237c2$var$float(roughness_immutable);
    const alpha = roughness.mul(roughness).toVar();
    // Section 3.2: Transform view direction to hemisphere configuration
    const Vh = $d89c9137a3d237c2$var$normalize($d89c9137a3d237c2$var$vec3(alpha.mul(V.x), alpha.mul(V.y), V.z)).toVar();
    // Section 4.1: Orthonormal basis
    const lensq = Vh.x.mul(Vh.x).add(Vh.y.mul(Vh.y));
    const T1 = $d89c9137a3d237c2$var$select(lensq.greaterThan(0.0), $d89c9137a3d237c2$var$vec3(Vh.y.negate(), Vh.x, 0.0).div($d89c9137a3d237c2$var$sqrt(lensq)), $d89c9137a3d237c2$var$vec3(1.0, 0.0, 0.0)).toVar();
    const T2 = $d89c9137a3d237c2$var$cross(Vh, T1).toVar();
    // Section 4.2: Parameterization of projected area
    const r = $d89c9137a3d237c2$var$sqrt(Xi.x);
    const phi = $d89c9137a3d237c2$var$mul(2.0, 3.14159265359).mul(Xi.y);
    const t1 = r.mul($d89c9137a3d237c2$var$cos(phi)).toVar();
    const t2 = r.mul($d89c9137a3d237c2$var$sin(phi)).toVar();
    const s = $d89c9137a3d237c2$var$mul(0.5, Vh.z.add(1.0));
    t2.assign(s.oneMinus().mul($d89c9137a3d237c2$var$sqrt(t1.mul(t1).oneMinus())).add(s.mul(t2)));
    // Section 4.3: Reprojection onto hemisphere
    const Nh = T1.mul(t1).add(T2.mul(t2)).add(Vh.mul($d89c9137a3d237c2$var$sqrt($d89c9137a3d237c2$var$max$1(0.0, t1.mul(t1).add(t2.mul(t2)).oneMinus()))));
    // Section 3.4: Transform back to ellipsoid configuration
    return $d89c9137a3d237c2$var$normalize($d89c9137a3d237c2$var$vec3(alpha.mul(Nh.x), alpha.mul(Nh.y), $d89c9137a3d237c2$var$max$1(0.0, Nh.z)));
});
// GGX convolution using VNDF importance sampling
const $d89c9137a3d237c2$var$ggxConvolution = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ roughness: roughness, mipInt: mipInt, envMap: envMap, N_immutable: N_immutable, GGX_SAMPLES: GGX_SAMPLES, CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP: CUBEUV_MAX_MIP })=>{
    const N = $d89c9137a3d237c2$var$vec3(N_immutable).toVar();
    const prefilteredColor = $d89c9137a3d237c2$var$vec3(0.0).toVar();
    const totalWeight = $d89c9137a3d237c2$var$float(0.0).toVar();
    // For very low roughness, just sample the environment directly
    $d89c9137a3d237c2$var$If(roughness.lessThan(0.001), ()=>{
        prefilteredColor.assign($d89c9137a3d237c2$var$bilinearCubeUV(envMap, N, mipInt, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP));
    }).Else(()=>{
        // Tangent space basis for VNDF sampling
        const up = $d89c9137a3d237c2$var$select($d89c9137a3d237c2$var$abs(N.z).lessThan(0.999), $d89c9137a3d237c2$var$vec3(0.0, 0.0, 1.0), $d89c9137a3d237c2$var$vec3(1.0, 0.0, 0.0));
        const tangent = $d89c9137a3d237c2$var$normalize($d89c9137a3d237c2$var$cross(up, N)).toVar();
        const bitangent = $d89c9137a3d237c2$var$cross(N, tangent).toVar();
        $d89c9137a3d237c2$var$Loop({
            start: $d89c9137a3d237c2$var$uint(0),
            end: GGX_SAMPLES
        }, ({ i: i })=>{
            const Xi = $d89c9137a3d237c2$var$hammersley(i, GGX_SAMPLES);
            // For PMREM, V = N, so in tangent space V is always (0, 0, 1)
            const H_tangent = $d89c9137a3d237c2$var$importanceSampleGGX_VNDF(Xi, $d89c9137a3d237c2$var$vec3(0.0, 0.0, 1.0), roughness);
            // Transform H back to world space
            const H = $d89c9137a3d237c2$var$normalize(tangent.mul(H_tangent.x).add(bitangent.mul(H_tangent.y)).add(N.mul(H_tangent.z)));
            const L = $d89c9137a3d237c2$var$normalize(H.mul($d89c9137a3d237c2$var$dot(N, H).mul(2.0)).sub(N));
            const NdotL = $d89c9137a3d237c2$var$max$1($d89c9137a3d237c2$var$dot(N, L), 0.0);
            $d89c9137a3d237c2$var$If(NdotL.greaterThan(0.0), ()=>{
                // Sample environment at fixed mip level
                // VNDF importance sampling handles the distribution filtering
                const sampleColor = $d89c9137a3d237c2$var$bilinearCubeUV(envMap, L, mipInt, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP);
                // Weight by NdotL for the split-sum approximation
                // VNDF PDF naturally accounts for the visible microfacet distribution
                prefilteredColor.addAssign(sampleColor.mul(NdotL));
                totalWeight.addAssign(NdotL);
            });
        });
        $d89c9137a3d237c2$var$If(totalWeight.greaterThan(0.0), ()=>{
            prefilteredColor.assign(prefilteredColor.div(totalWeight));
        });
    });
    return $d89c9137a3d237c2$var$vec4(prefilteredColor, 1.0);
});
const $d89c9137a3d237c2$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips.
// Used for scene blur in fromScene() method.
const $d89c9137a3d237c2$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
// Used for scene blur in fromScene() method.
const $d89c9137a3d237c2$var$MAX_SAMPLES = 20;
// GGX VNDF importance sampling configuration
const $d89c9137a3d237c2$var$GGX_SAMPLES = 512;
const $d89c9137a3d237c2$var$_flatCamera = /*@__PURE__*/ new (0, $329ek.OrthographicCamera)(-1, 1, 1, -1, 0, 1);
const $d89c9137a3d237c2$var$_cubeCamera = /*@__PURE__*/ new (0, $329ek.PerspectiveCamera)(90, 1);
const $d89c9137a3d237c2$var$_clearColor$2 = /*@__PURE__*/ new (0, $329ek.Color)();
let $d89c9137a3d237c2$var$_oldTarget = null;
let $d89c9137a3d237c2$var$_oldActiveCubeFace = 0;
let $d89c9137a3d237c2$var$_oldActiveMipmapLevel = 0;
const $d89c9137a3d237c2$var$_origin = /*@__PURE__*/ new (0, $329ek.Vector3)();
// maps blur materials to their uniforms dictionary
const $d89c9137a3d237c2$var$_uniformsMap = new WeakMap();
// WebGPU Face indices
const $d89c9137a3d237c2$var$_faceLib = [
    3,
    1,
    5,
    0,
    4,
    2
];
const $d89c9137a3d237c2$var$_direction = /*@__PURE__*/ $d89c9137a3d237c2$var$getDirection($d89c9137a3d237c2$var$uv$1(), $d89c9137a3d237c2$var$attribute('faceIndex')).normalize();
const $d89c9137a3d237c2$var$_outputDirection = /*@__PURE__*/ $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$_direction.x, $d89c9137a3d237c2$var$_direction.y, $d89c9137a3d237c2$var$_direction.z);
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * The prefiltering uses GGX VNDF (Visible Normal Distribution Function)
 * importance sampling based on "Sampling the GGX Distribution of Visible Normals"
 * (Heitz, 2018) to generate environment maps that accurately match the GGX BRDF
 * used in material rendering for physically-based image-based lighting.
 */ class $d89c9137a3d237c2$export$6add42717753e221 {
    /**
	 * Constructs a new PMREM generator.
	 *
	 * @param {Renderer} renderer - The renderer.
	 */ constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._sizeLods = [];
        this._sigmas = [];
        this._lodMeshes = [];
        this._blurMaterial = null;
        this._ggxMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._backgroundBox = null;
    }
    get _hasInitialized() {
        return this._renderer.hasInitialized();
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety.
	 *
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
	 * @param {?RenderTarget} [options.renderTarget=null] - The render target to use.
	 * @return {RenderTarget} The resulting PMREM.
	 * @see {@link PMREMGenerator#fromScene}
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        const { size: size = 256, position: position = $d89c9137a3d237c2$var$_origin, renderTarget: renderTarget = null } = options;
        this._setSize(size);
        if (this._hasInitialized === false) {
            (0, $329ek.warn)('PMREMGenerator: ".fromScene()" called before the backend is initialized. Try using "await renderer.init()" instead.');
            const cubeUVRenderTarget = renderTarget || this._allocateTarget();
            options.renderTarget = cubeUVRenderTarget;
            this.fromSceneAsync(scene, sigma, near, far, options);
            return cubeUVRenderTarget;
        }
        $d89c9137a3d237c2$var$_oldTarget = this._renderer.getRenderTarget();
        $d89c9137a3d237c2$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d89c9137a3d237c2$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        const cubeUVRenderTarget = renderTarget || this._allocateTarget();
        cubeUVRenderTarget.depthBuffer = true;
        this._init(cubeUVRenderTarget);
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 *
	 * @deprecated
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.position=origin] - The position of the internal cube camera that renders the scene.
	 * @param {?RenderTarget} [options.renderTarget=null] - The render target to use.
	 * @return {Promise<RenderTarget>} A Promise that resolve with the PMREM when the generation has been finished.
	 * @see {@link PMREMGenerator#fromScene}
	 */ async fromSceneAsync(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        (0, $329ek.warnOnce)('PMREMGenerator: ".fromSceneAsync()" is deprecated. Use "await renderer.init()" instead.'); // @deprecated r181
        await this._renderer.init();
        return this.fromScene(scene, sigma, near, far, options);
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?RenderTarget} [renderTarget=null] - The render target to use.
	 * @return {RenderTarget} The resulting PMREM.
	 * @see {@link PMREMGenerator#fromEquirectangularAsync}
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        if (this._hasInitialized === false) {
            (0, $329ek.warn)('PMREMGenerator: .fromEquirectangular() called before the backend is initialized. Try using "await renderer.init()" instead.');
            this._setSizeFromTexture(equirectangular);
            const cubeUVRenderTarget = renderTarget || this._allocateTarget();
            this.fromEquirectangularAsync(equirectangular, cubeUVRenderTarget);
            return cubeUVRenderTarget;
        }
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @deprecated
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?RenderTarget} [renderTarget=null] - The render target to use.
	 * @return {Promise<RenderTarget>} The resulting PMREM.
	 * @see {@link PMREMGenerator#fromEquirectangular}
	 */ async fromEquirectangularAsync(equirectangular, renderTarget = null) {
        (0, $329ek.warnOnce)('PMREMGenerator: ".fromEquirectangularAsync()" is deprecated. Use "await renderer.init()" instead.'); // @deprecated r181
        await this._renderer.init();
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?RenderTarget} [renderTarget=null] - The render target to use.
	 * @return {RenderTarget} The resulting PMREM.
	 * @see {@link PMREMGenerator#fromCubemapAsync}
	 */ fromCubemap(cubemap, renderTarget = null) {
        if (this._hasInitialized === false) {
            (0, $329ek.warn)('PMREMGenerator: .fromCubemap() called before the backend is initialized. Try using .fromCubemapAsync() instead.');
            this._setSizeFromTexture(cubemap);
            const cubeUVRenderTarget = renderTarget || this._allocateTarget();
            this.fromCubemapAsync(cubemap, renderTarget);
            return cubeUVRenderTarget;
        }
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * with the 256 x 256 cubemap output.
	 *
	 * @deprecated
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?RenderTarget} [renderTarget=null] - The render target to use.
	 * @return {Promise<RenderTarget>} The resulting PMREM.
	 * @see {@link PMREMGenerator#fromCubemap}
	 */ async fromCubemapAsync(cubemap, renderTarget = null) {
        (0, $329ek.warnOnce)('PMREMGenerator: ".fromCubemapAsync()" is deprecated. Use "await renderer.init()" instead.'); // @deprecated r181
        await this._renderer.init();
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 *
	 * @returns {Promise}
	 */ async compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $d89c9137a3d237c2$var$_getCubemapMaterial();
            await this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 *
	 * @returns {Promise}
	 */ async compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $d89c9137a3d237c2$var$_getEquirectMaterial();
            await this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
        if (this._backgroundBox !== null) {
            this._backgroundBox.geometry.dispose();
            this._backgroundBox.material.dispose();
        }
    }
    // private interface
    _setSizeFromTexture(texture) {
        if (texture.mapping === (0, $329ek.CubeReflectionMapping) || texture.mapping === (0, $329ek.CubeRefractionMapping)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
    }
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._ggxMaterial !== null) this._ggxMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodMeshes.length; i++)this._lodMeshes[i].geometry.dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($d89c9137a3d237c2$var$_oldTarget, $d89c9137a3d237c2$var$_oldActiveCubeFace, $d89c9137a3d237c2$var$_oldActiveMipmapLevel);
        outputTarget.scissorTest = false;
        $d89c9137a3d237c2$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        this._setSizeFromTexture(texture);
        $d89c9137a3d237c2$var$_oldTarget = this._renderer.getRenderTarget();
        $d89c9137a3d237c2$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d89c9137a3d237c2$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        const cubeUVRenderTarget = renderTarget || this._allocateTarget();
        this._init(cubeUVRenderTarget);
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTarget() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const cubeUVRenderTarget = $d89c9137a3d237c2$var$_createRenderTarget(width, height);
        return cubeUVRenderTarget;
    }
    _init(renderTarget) {
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== renderTarget.width || this._pingPongRenderTarget.height !== renderTarget.height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $d89c9137a3d237c2$var$_createRenderTarget(renderTarget.width, renderTarget.height);
            const { _lodMax: _lodMax } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = $d89c9137a3d237c2$var$_createPlanes(_lodMax));
            this._blurMaterial = $d89c9137a3d237c2$var$_getBlurShader(_lodMax, renderTarget.width, renderTarget.height);
            this._ggxMaterial = $d89c9137a3d237c2$var$_getGGXShader(_lodMax, renderTarget.width, renderTarget.height);
        }
    }
    async _compileMaterial(material) {
        const mesh = new (0, $329ek.Mesh)(new (0, $329ek.BufferGeometry)(), material);
        await this._renderer.compile(mesh, $d89c9137a3d237c2$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
        const cubeCamera = $d89c9137a3d237c2$var$_cubeCamera;
        cubeCamera.near = near;
        cubeCamera.far = far;
        // px, py, pz, nx, ny, nz
        const upSign = [
            1,
            1,
            1,
            1,
            -1,
            1
        ];
        const forwardSign = [
            1,
            -1,
            1,
            -1,
            1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        renderer.getClearColor($d89c9137a3d237c2$var$_clearColor$2);
        renderer.autoClear = false;
        if (this._backgroundBox === null) this._backgroundBox = new (0, $329ek.Mesh)(new (0, $329ek.BoxGeometry)(), new (0, $329ek.MeshBasicMaterial)({
            name: 'PMREM.Background',
            side: (0, $329ek.BackSide),
            depthWrite: false,
            depthTest: false
        }));
        const backgroundBox = this._backgroundBox;
        const backgroundMaterial = backgroundBox.material;
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($d89c9137a3d237c2$var$_clearColor$2);
            useSolidColor = true;
        }
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.clear();
        if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
            }
            const size = this._cubeSize;
            $d89c9137a3d237c2$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.render(scene, cubeCamera);
        }
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, $329ek.CubeReflectionMapping) || texture.mapping === (0, $329ek.CubeRefractionMapping);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $d89c9137a3d237c2$var$_getCubemapMaterial(texture);
        } else if (this._equirectMaterial === null) this._equirectMaterial = $d89c9137a3d237c2$var$_getEquirectMaterial(texture);
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        material.fragmentNode.value = texture;
        const mesh = this._lodMeshes[0];
        mesh.material = material;
        const size = this._cubeSize;
        $d89c9137a3d237c2$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $d89c9137a3d237c2$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodMeshes.length;
        // Use GGX VNDF importance sampling
        for(let i = 1; i < n; i++)this._applyGGXFilter(cubeUVRenderTarget, i - 1, i);
        renderer.autoClear = autoClear;
    }
    /**
	 * Applies GGX VNDF importance sampling filter to generate a prefiltered environment map.
	 * Uses Monte Carlo integration with VNDF importance sampling to accurately represent the
	 * GGX BRDF for physically-based rendering. Reads from the previous LOD level and
	 * applies incremental roughness filtering to avoid over-blurring.
	 *
	 * @private
	 * @param {RenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn - Source LOD level to read from
	 * @param {number} lodOut - Target LOD level to write to
	 */ _applyGGXFilter(cubeUVRenderTarget, lodIn, lodOut) {
        const renderer = this._renderer;
        const pingPongRenderTarget = this._pingPongRenderTarget;
        const ggxMaterial = this._ggxMaterial;
        const ggxMesh = this._lodMeshes[lodOut];
        ggxMesh.material = ggxMaterial;
        const ggxUniforms = $d89c9137a3d237c2$var$_uniformsMap.get(ggxMaterial);
        // Calculate incremental roughness between LOD levels
        const targetRoughness = lodOut / (this._lodMeshes.length - 1);
        const sourceRoughness = lodIn / (this._lodMeshes.length - 1);
        const incrementalRoughness = Math.sqrt(targetRoughness * targetRoughness - sourceRoughness * sourceRoughness);
        // Apply blur strength mapping for better quality across the roughness range
        const blurStrength = 0.0 + targetRoughness * 1.25;
        const adjustedRoughness = incrementalRoughness * blurStrength;
        // Calculate viewport position based on output LOD level
        const { _lodMax: _lodMax } = this;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d89c9137a3d237c2$var$LOD_MIN ? lodOut - _lodMax + $d89c9137a3d237c2$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        // Read from previous LOD with incremental roughness
        cubeUVRenderTarget.texture.frame = (cubeUVRenderTarget.texture.frame || 0) + 1;
        ggxUniforms.envMap.value = cubeUVRenderTarget.texture;
        ggxUniforms.roughness.value = adjustedRoughness;
        ggxUniforms.mipInt.value = _lodMax - lodIn; // Sample from input LOD
        $d89c9137a3d237c2$var$_setViewport(pingPongRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(pingPongRenderTarget);
        renderer.render(ggxMesh, $d89c9137a3d237c2$var$_flatCamera);
        // Copy from pingPong back to cubeUV (simple direct copy)
        pingPongRenderTarget.texture.frame = (pingPongRenderTarget.texture.frame || 0) + 1;
        ggxUniforms.envMap.value = pingPongRenderTarget.texture;
        ggxUniforms.roughness.value = 0.0; // Direct copy
        ggxUniforms.mipInt.value = _lodMax - lodOut; // Read from the level we just wrote
        $d89c9137a3d237c2$var$_setViewport(cubeUVRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(ggxMesh, $d89c9137a3d237c2$var$_flatCamera);
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * Used for initial scene blur in fromScene() method when sigma > 0.
	 *
	 * @private
	 * @param {RenderTarget} cubeUVRenderTarget - The cubemap render target.
	 * @param {number} lodIn - The input level-of-detail.
	 * @param {number} lodOut - The output level-of-detail.
	 * @param {number} sigma - The blur radius in radians.
	 * @param {Vector3} [poleAxis] - The pole axis.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') (0, $329ek.error)('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = this._lodMeshes[lodOut];
        blurMesh.material = blurMaterial;
        const blurUniforms = $d89c9137a3d237c2$var$_uniformsMap.get(blurMaterial);
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $d89c9137a3d237c2$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $d89c9137a3d237c2$var$MAX_SAMPLES;
        if (samples > $d89c9137a3d237c2$var$MAX_SAMPLES) (0, $329ek.warn)(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$d89c9137a3d237c2$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $d89c9137a3d237c2$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        targetIn.texture.frame = (targetIn.texture.frame || 0) + 1;
        blurUniforms.envMap.value = targetIn.texture;
        blurUniforms.samples.value = samples;
        blurUniforms.weights.array = weights;
        blurUniforms.latitudinal.value = direction === 'latitudinal' ? 1 : 0;
        if (poleAxis) blurUniforms.poleAxis.value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms.dTheta.value = radiansPerPixel;
        blurUniforms.mipInt.value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d89c9137a3d237c2$var$LOD_MIN ? lodOut - _lodMax + $d89c9137a3d237c2$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $d89c9137a3d237c2$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $d89c9137a3d237c2$var$_flatCamera);
    }
}
function $d89c9137a3d237c2$var$_createPlanes(lodMax) {
    const sizeLods = [];
    const sigmas = [];
    const lodMeshes = [];
    let lod = lodMax;
    const totalLods = lodMax - $d89c9137a3d237c2$var$LOD_MIN + 1 + $d89c9137a3d237c2$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $d89c9137a3d237c2$var$LOD_MIN) sigma = $d89c9137a3d237c2$var$EXTRA_LOD_SIGMA[i - lodMax + $d89c9137a3d237c2$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            const faceIdx = $d89c9137a3d237c2$var$_faceLib[face];
            position.set(coordinates, positionSize * vertices * faceIdx);
            uv.set(uv1, uvSize * vertices * faceIdx);
            const fill = [
                faceIdx,
                faceIdx,
                faceIdx,
                faceIdx,
                faceIdx,
                faceIdx
            ];
            faceIndex.set(fill, faceIndexSize * vertices * faceIdx);
        }
        const planes = new (0, $329ek.BufferGeometry)();
        planes.setAttribute('position', new (0, $329ek.BufferAttribute)(position, positionSize));
        planes.setAttribute('uv', new (0, $329ek.BufferAttribute)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $329ek.BufferAttribute)(faceIndex, faceIndexSize));
        lodMeshes.push(new (0, $329ek.Mesh)(planes, null));
        if (lod > $d89c9137a3d237c2$var$LOD_MIN) lod--;
    }
    return {
        lodMeshes: lodMeshes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $d89c9137a3d237c2$var$_createRenderTarget(width, height) {
    const params = {
        magFilter: (0, $329ek.LinearFilter),
        minFilter: (0, $329ek.LinearFilter),
        generateMipmaps: false,
        type: (0, $329ek.HalfFloatType),
        format: (0, $329ek.RGBAFormat),
        colorSpace: (0, $329ek.LinearSRGBColorSpace)
    };
    const cubeUVRenderTarget = new (0, $329ek.RenderTarget)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $329ek.CubeUVReflectionMapping);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.texture.isPMREMTexture = true;
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $d89c9137a3d237c2$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $d89c9137a3d237c2$var$_getMaterial(type) {
    const material = new $d89c9137a3d237c2$export$caaf3b30a544c946();
    material.depthTest = false;
    material.depthWrite = false;
    material.blending = (0, $329ek.NoBlending);
    material.name = `PMREM_${type}`;
    return material;
}
function $d89c9137a3d237c2$var$_getBlurShader(lodMax, width, height) {
    const weights = $d89c9137a3d237c2$var$uniformArray(new Array($d89c9137a3d237c2$var$MAX_SAMPLES).fill(0));
    const poleAxis = $d89c9137a3d237c2$var$uniform(new (0, $329ek.Vector3)(0, 1, 0));
    const dTheta = $d89c9137a3d237c2$var$uniform(0);
    const n = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$MAX_SAMPLES);
    const latitudinal = $d89c9137a3d237c2$var$uniform(0); // false, bool
    const samples = $d89c9137a3d237c2$var$uniform(1); // int
    const envMap = $d89c9137a3d237c2$var$texture();
    const mipInt = $d89c9137a3d237c2$var$uniform(0); // int
    const CUBEUV_TEXEL_WIDTH = $d89c9137a3d237c2$var$float(1 / width);
    const CUBEUV_TEXEL_HEIGHT = $d89c9137a3d237c2$var$float(1 / height);
    const CUBEUV_MAX_MIP = $d89c9137a3d237c2$var$float(lodMax);
    const materialUniforms = {
        n: n,
        latitudinal: latitudinal,
        weights: weights,
        poleAxis: poleAxis,
        outputDirection: $d89c9137a3d237c2$var$_outputDirection,
        dTheta: dTheta,
        samples: samples,
        envMap: envMap,
        mipInt: mipInt,
        CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
        CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
        CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
    };
    const material = $d89c9137a3d237c2$var$_getMaterial('blur');
    material.fragmentNode = $d89c9137a3d237c2$var$blur({
        ...materialUniforms,
        latitudinal: latitudinal.equal(1)
    });
    $d89c9137a3d237c2$var$_uniformsMap.set(material, materialUniforms);
    return material;
}
function $d89c9137a3d237c2$var$_getGGXShader(lodMax, width, height) {
    const envMap = $d89c9137a3d237c2$var$texture();
    const roughness = $d89c9137a3d237c2$var$uniform(0);
    const mipInt = $d89c9137a3d237c2$var$uniform(0);
    const CUBEUV_TEXEL_WIDTH = $d89c9137a3d237c2$var$float(1 / width);
    const CUBEUV_TEXEL_HEIGHT = $d89c9137a3d237c2$var$float(1 / height);
    const CUBEUV_MAX_MIP = $d89c9137a3d237c2$var$float(lodMax);
    const materialUniforms = {
        envMap: envMap,
        roughness: roughness,
        mipInt: mipInt,
        CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
        CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
        CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
    };
    const material = $d89c9137a3d237c2$var$_getMaterial('ggx');
    material.fragmentNode = $d89c9137a3d237c2$var$ggxConvolution({
        ...materialUniforms,
        N_immutable: $d89c9137a3d237c2$var$_outputDirection,
        GGX_SAMPLES: $d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$GGX_SAMPLES)
    });
    $d89c9137a3d237c2$var$_uniformsMap.set(material, materialUniforms);
    return material;
}
function $d89c9137a3d237c2$var$_getCubemapMaterial(envTexture) {
    const material = $d89c9137a3d237c2$var$_getMaterial('cubemap');
    material.fragmentNode = $d89c9137a3d237c2$var$cubeTexture(envTexture, $d89c9137a3d237c2$var$_outputDirection);
    return material;
}
function $d89c9137a3d237c2$var$_getEquirectMaterial(envTexture) {
    const material = $d89c9137a3d237c2$var$_getMaterial('equirect');
    material.fragmentNode = $d89c9137a3d237c2$var$texture(envTexture, $d89c9137a3d237c2$var$equirectUV($d89c9137a3d237c2$var$_outputDirection), 0);
    return material;
}
const $d89c9137a3d237c2$var$_cache = new WeakMap();
/**
 * Generates the cubeUV size based on the given image height.
 *
 * @private
 * @param {number} imageHeight - The image height.
 * @return {{texelWidth: number,texelHeight: number, maxMip: number}} The result object.
 */ function $d89c9137a3d237c2$var$_generateCubeUVSize(imageHeight) {
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
/**
 * Generates a PMREM from the given texture.
 *
 * @private
 * @param {Texture} texture - The texture to create the PMREM for.
 * @param {Renderer} renderer - The renderer.
 * @param {PMREMGenerator} generator - The PMREM generator.
 * @return {?Texture} The PMREM.
 */ function $d89c9137a3d237c2$var$_getPMREMFromTexture(texture, renderer, generator) {
    const cache = $d89c9137a3d237c2$var$_getCache(renderer);
    let cacheTexture = cache.get(texture);
    const pmremVersion = cacheTexture !== undefined ? cacheTexture.pmremVersion : -1;
    if (pmremVersion !== texture.pmremVersion) {
        const image = texture.image;
        if (texture.isCubeTexture) {
            if ($d89c9137a3d237c2$var$isCubeMapReady(image)) cacheTexture = generator.fromCubemap(texture, cacheTexture);
            else return null;
        } else {
            if ($d89c9137a3d237c2$var$isEquirectangularMapReady(image)) cacheTexture = generator.fromEquirectangular(texture, cacheTexture);
            else return null;
        }
        cacheTexture.pmremVersion = texture.pmremVersion;
        cache.set(texture, cacheTexture);
    }
    return cacheTexture.texture;
}
/**
 * Returns a cache that stores generated PMREMs for the respective textures.
 * A cache must be maintained per renderer since PMREMs are render target textures
 * which can't be shared across render contexts.
 *
 * @private
 * @param {Renderer} renderer - The renderer.
 * @return {WeakMap<Texture, Texture>} The PMREM cache.
 */ function $d89c9137a3d237c2$var$_getCache(renderer) {
    let rendererCache = $d89c9137a3d237c2$var$_cache.get(renderer);
    if (rendererCache === undefined) {
        rendererCache = new WeakMap();
        $d89c9137a3d237c2$var$_cache.set(renderer, rendererCache);
    }
    return rendererCache;
}
/**
 * This node represents a PMREM which is a special type of preprocessed
 * environment map intended for PBR materials.
 *
 * ```js
 * const material = new MeshStandardNodeMaterial();
 * material.envNode = pmremTexture( envMap );
 * ```
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$34829f7f4dba1981 extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'PMREMNode';
    }
    /**
	 * Constructs a new function overloading node.
	 *
	 * @param {Texture} value - The input texture.
	 * @param {Node<vec2>} [uvNode=null] - The uv node.
	 * @param {Node<float>} [levelNode=null] - The level node.
	 */ constructor(value, uvNode = null, levelNode = null){
        super('vec3');
        /**
		 * Reference to the input texture.
		 *
		 * @private
		 * @type {Texture}
		 */ this._value = value;
        /**
		 * Reference to the generated PMREM.
		 *
		 * @private
		 * @type {Texture | null}
		 * @default null
		 */ this._pmrem = null;
        /**
		 *  The uv node.
		 *
		 * @type {Node<vec2>}
		 */ this.uvNode = uvNode;
        /**
		 *  The level node.
		 *
		 * @type {Node<float>}
		 */ this.levelNode = levelNode;
        /**
		 * Reference to a PMREM generator.
		 *
		 * @private
		 * @type {?PMREMGenerator}
		 * @default null
		 */ this._generator = null;
        const defaultTexture = new (0, $329ek.Texture)();
        defaultTexture.isRenderTargetTexture = true;
        /**
		 * The texture node holding the generated PMREM.
		 *
		 * @private
		 * @type {TextureNode}
		 */ this._texture = $d89c9137a3d237c2$var$texture(defaultTexture);
        /**
		 * A uniform representing the PMREM's width.
		 *
		 * @private
		 * @type {UniformNode<float>}
		 */ this._width = $d89c9137a3d237c2$var$uniform(0);
        /**
		 * A uniform representing the PMREM's height.
		 *
		 * @private
		 * @type {UniformNode<float>}
		 */ this._height = $d89c9137a3d237c2$var$uniform(0);
        /**
		 * A uniform representing the PMREM's max Mip.
		 *
		 * @private
		 * @type {UniformNode<float>}
		 */ this._maxMip = $d89c9137a3d237c2$var$uniform(0);
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.RENDER`.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateBeforeType = $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER;
    }
    set value(value) {
        this._value = value;
        this._pmrem = null;
    }
    /**
	 * The node's texture value.
	 *
	 * @type {Texture}
	 */ get value() {
        return this._value;
    }
    /**
	 * Uses the given PMREM texture to update internal values.
	 *
	 * @param {Texture} texture - The PMREM texture.
	 */ updateFromTexture(texture) {
        const cubeUVSize = $d89c9137a3d237c2$var$_generateCubeUVSize(texture.image.height);
        this._texture.value = texture;
        this._width.value = cubeUVSize.texelWidth;
        this._height.value = cubeUVSize.texelHeight;
        this._maxMip.value = cubeUVSize.maxMip;
    }
    updateBefore(frame) {
        let pmrem = this._pmrem;
        const pmremVersion = pmrem ? pmrem.pmremVersion : -1;
        const texture = this._value;
        if (pmremVersion !== texture.pmremVersion) {
            if (texture.isPMREMTexture === true) pmrem = texture;
            else pmrem = $d89c9137a3d237c2$var$_getPMREMFromTexture(texture, frame.renderer, this._generator);
            if (pmrem !== null) {
                this._pmrem = pmrem;
                this.updateFromTexture(pmrem);
            }
        }
    }
    setup(builder) {
        if (this._generator === null) this._generator = new $d89c9137a3d237c2$export$6add42717753e221(builder.renderer);
        this.updateBefore(builder);
        //
        let uvNode = this.uvNode;
        if (uvNode === null && builder.context.getUV) uvNode = builder.context.getUV(this, builder);
        //
        uvNode = $d89c9137a3d237c2$var$materialEnvRotation.mul($d89c9137a3d237c2$var$vec3(uvNode.x, uvNode.y.negate(), uvNode.z));
        //
        let levelNode = this.levelNode;
        if (levelNode === null && builder.context.getTextureLevel) levelNode = builder.context.getTextureLevel(this);
        //
        return $d89c9137a3d237c2$var$textureCubeUV(this._texture, uvNode, levelNode, this._width, this._height, this._maxMip);
    }
    dispose() {
        super.dispose();
        if (this._generator !== null) this._generator.dispose();
    }
}
/**
 * Returns `true` if the given cube map image has been fully loaded.
 *
 * @private
 * @param {?Array<(Image|Object)>} [image] - The cube map image.
 * @return {boolean} Whether the given cube map is ready or not.
 */ function $d89c9137a3d237c2$var$isCubeMapReady(image) {
    if (image === null || image === undefined) return false;
    let count = 0;
    const length = 6;
    for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
    return count === length;
}
/**
 * Returns `true` if the given equirectangular image has been fully loaded.
 *
 * @private
 * @param {(Image|Object)} image - The equirectangular image.
 * @return {boolean} Whether the given cube map is ready or not.
 */ function $d89c9137a3d237c2$var$isEquirectangularMapReady(image) {
    if (image === null || image === undefined) return false;
    return image.height > 0;
}
/**
 * TSL function for creating a PMREM node.
 *
 * @tsl
 * @function
 * @param {Texture} value - The input texture.
 * @param {?Node<vec2>} [uvNode=null] - The uv node.
 * @param {?Node<float>} [levelNode=null] - The level node.
 * @returns {PMREMNode}
 */ const $d89c9137a3d237c2$var$pmremTexture = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$34829f7f4dba1981).setParameterLength(1, 3);
const $d89c9137a3d237c2$var$_envNodeCache = new WeakMap();
/**
 * Represents a physical model for Image-based lighting (IBL). The environment
 * is defined via environment maps in the equirectangular, cube map or cubeUV (PMREM) format.
 * `EnvironmentNode` is intended for PBR materials like {@link MeshStandardNodeMaterial}.
 *
 * @augments LightingNode
 */ class $d89c9137a3d237c2$export$d2178f54b36ca231 extends $d89c9137a3d237c2$export$3fce9846d62aac91 {
    static get type() {
        return 'EnvironmentNode';
    }
    /**
	 * Constructs a new environment node.
	 *
	 * @param {Node} [envNode=null] - A node representing the environment.
	 */ constructor(envNode = null){
        super();
        /**
		 * A node representing the environment.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.envNode = envNode;
    }
    setup(builder) {
        const { material: material } = builder;
        let envNode = this.envNode;
        if (envNode.isTextureNode || envNode.isMaterialReferenceNode) {
            const value = envNode.isTextureNode ? envNode.value : material[envNode.property];
            let cacheEnvNode = $d89c9137a3d237c2$var$_envNodeCache.get(value);
            if (cacheEnvNode === undefined) {
                cacheEnvNode = $d89c9137a3d237c2$var$pmremTexture(value);
                $d89c9137a3d237c2$var$_envNodeCache.set(value, cacheEnvNode);
            }
            envNode = cacheEnvNode;
        }
        //
        const useAnisotropy = material.useAnisotropy === true || material.anisotropy > 0;
        const radianceNormalView = useAnisotropy ? $d89c9137a3d237c2$var$bentNormalView : $d89c9137a3d237c2$var$normalView;
        const radiance = envNode.context($d89c9137a3d237c2$var$createRadianceContext($d89c9137a3d237c2$var$roughness, radianceNormalView)).mul($d89c9137a3d237c2$var$materialEnvIntensity);
        const irradiance = envNode.context($d89c9137a3d237c2$var$createIrradianceContext($d89c9137a3d237c2$var$normalWorld)).mul(Math.PI).mul($d89c9137a3d237c2$var$materialEnvIntensity);
        const isolateRadiance = $d89c9137a3d237c2$var$isolate(radiance);
        const isolateIrradiance = $d89c9137a3d237c2$var$isolate(irradiance);
        //
        builder.context.radiance.addAssign(isolateRadiance);
        builder.context.iblIrradiance.addAssign(isolateIrradiance);
        //
        const clearcoatRadiance = builder.context.lightingModel.clearcoatRadiance;
        if (clearcoatRadiance) {
            const clearcoatRadianceContext = envNode.context($d89c9137a3d237c2$var$createRadianceContext($d89c9137a3d237c2$var$clearcoatRoughness, $d89c9137a3d237c2$var$clearcoatNormalView)).mul($d89c9137a3d237c2$var$materialEnvIntensity);
            const isolateClearcoatRadiance = $d89c9137a3d237c2$var$isolate(clearcoatRadianceContext);
            clearcoatRadiance.addAssign(isolateClearcoatRadiance);
        }
    }
}
const $d89c9137a3d237c2$var$createRadianceContext = (roughnessNode, normalViewNode)=>{
    let reflectVec = null;
    return {
        getUV: ()=>{
            if (reflectVec === null) {
                reflectVec = $d89c9137a3d237c2$var$positionViewDirection.negate().reflect(normalViewNode);
                // Mixing the reflection with the normal is more accurate and keeps rough objects from gathering light from behind their tangent plane.
                reflectVec = $d89c9137a3d237c2$var$pow4(roughnessNode).mix(reflectVec, normalViewNode).normalize();
                reflectVec = reflectVec.transformDirection($d89c9137a3d237c2$var$cameraViewMatrix);
            }
            return reflectVec;
        },
        getTextureLevel: ()=>{
            return roughnessNode;
        }
    };
};
const $d89c9137a3d237c2$var$createIrradianceContext = (normalWorldNode)=>{
    return {
        getUV: ()=>{
            return normalWorldNode;
        },
        getTextureLevel: ()=>{
            return $d89c9137a3d237c2$var$float(1.0);
        }
    };
};
const $d89c9137a3d237c2$var$_defaultValues$6 = /*@__PURE__*/ new (0, $329ek.MeshStandardMaterial)();
/**
 * Node material version of {@link MeshStandardMaterial}.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$92edd3f060e85562 extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshStandardNodeMaterial';
    }
    /**
	 * Constructs a new mesh standard node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshStandardNodeMaterial = true;
        /**
		 * Set to `true` because standard materials react on lights.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        /**
		 * The emissive color of standard materials is by default inferred from the `emissive`,
		 * `emissiveIntensity` and `emissiveMap` properties. This node property allows to
		 * overwrite the default and define the emissive color with a node instead.
		 *
		 * If you don't want to overwrite the emissive color but modify the existing
		 * value instead, use {@link materialEmissive}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.emissiveNode = null;
        /**
		 * The metalness of standard materials is by default inferred from the `metalness`,
		 * and `metalnessMap` properties. This node property allows to
		 * overwrite the default and define the metalness with a node instead.
		 *
		 * If you don't want to overwrite the metalness but modify the existing
		 * value instead, use {@link materialMetalness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.metalnessNode = null;
        /**
		 * The roughness of standard materials is by default inferred from the `roughness`,
		 * and `roughnessMap` properties. This node property allows to
		 * overwrite the default and define the roughness with a node instead.
		 *
		 * If you don't want to overwrite the roughness but modify the existing
		 * value instead, use {@link materialRoughness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.roughnessNode = null;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$6);
        this.setValues(parameters);
    }
    /**
	 * Overwritten since this type of material uses {@link EnvironmentNode}
	 * to implement the PBR (PMREM based) environment mapping. Besides, the
	 * method honors `Scene.environment`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?EnvironmentNode<vec3>} The environment node.
	 */ setupEnvironment(builder) {
        let envNode = super.setupEnvironment(builder);
        if (envNode === null && builder.environmentNode) envNode = builder.environmentNode;
        return envNode ? new $d89c9137a3d237c2$export$d2178f54b36ca231(envNode) : null;
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {PhysicalLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $d89c9137a3d237c2$export$b69e16149fd7d508();
    }
    /**
	 * Setups the specular related node variables.
	 */ setupSpecular() {
        const specularColorNode = $d89c9137a3d237c2$var$mix($d89c9137a3d237c2$var$vec3(0.04), $d89c9137a3d237c2$var$diffuseColor.rgb, $d89c9137a3d237c2$var$metalness);
        $d89c9137a3d237c2$var$specularColor.assign($d89c9137a3d237c2$var$vec3(0.04));
        $d89c9137a3d237c2$var$specularColorBlended.assign(specularColorNode);
        $d89c9137a3d237c2$var$specularF90.assign(1.0);
    }
    /**
	 * Setups the standard specific node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants() {
        // METALNESS
        const metalnessNode = this.metalnessNode ? $d89c9137a3d237c2$var$float(this.metalnessNode) : $d89c9137a3d237c2$var$materialMetalness;
        $d89c9137a3d237c2$var$metalness.assign(metalnessNode);
        // ROUGHNESS
        let roughnessNode = this.roughnessNode ? $d89c9137a3d237c2$var$float(this.roughnessNode) : $d89c9137a3d237c2$var$materialRoughness;
        roughnessNode = $d89c9137a3d237c2$var$getRoughness({
            roughness: roughnessNode
        });
        $d89c9137a3d237c2$var$roughness.assign(roughnessNode);
        // SPECULAR COLOR
        this.setupSpecular();
        // DIFFUSE COLOR
        $d89c9137a3d237c2$var$diffuseContribution.assign($d89c9137a3d237c2$var$diffuseColor.rgb.mul(metalnessNode.oneMinus()));
    }
    copy(source) {
        this.emissiveNode = source.emissiveNode;
        this.metalnessNode = source.metalnessNode;
        this.roughnessNode = source.roughnessNode;
        return super.copy(source);
    }
}
const $d89c9137a3d237c2$var$_defaultValues$5 = /*@__PURE__*/ new (0, $329ek.MeshPhysicalMaterial)();
/**
 * Node material version of {@link MeshPhysicalMaterial}.
 *
 * @augments MeshStandardNodeMaterial
 */ class $d89c9137a3d237c2$export$f336706882be0d39 extends $d89c9137a3d237c2$export$92edd3f060e85562 {
    static get type() {
        return 'MeshPhysicalNodeMaterial';
    }
    /**
	 * Constructs a new mesh physical node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhysicalNodeMaterial = true;
        /**
		 * The clearcoat of physical materials is by default inferred from the `clearcoat`
		 * and `clearcoatMap` properties. This node property allows to overwrite the default
		 * and define the clearcoat with a node instead.
		 *
		 * If you don't want to overwrite the clearcoat but modify the existing
		 * value instead, use {@link materialClearcoat}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.clearcoatNode = null;
        /**
		 * The clearcoat roughness of physical materials is by default inferred from the `clearcoatRoughness`
		 * and `clearcoatRoughnessMap` properties. This node property allows to overwrite the default
		 * and define the clearcoat roughness with a node instead.
		 *
		 * If you don't want to overwrite the clearcoat roughness but modify the existing
		 * value instead, use {@link materialClearcoatRoughness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.clearcoatRoughnessNode = null;
        /**
		 * The clearcoat normal of physical materials is by default inferred from the `clearcoatNormalMap`
		 * property. This node property allows to overwrite the default
		 * and define the clearcoat normal with a node instead.
		 *
		 * If you don't want to overwrite the clearcoat normal but modify the existing
		 * value instead, use {@link materialClearcoatNormal}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.clearcoatNormalNode = null;
        /**
		 * The sheen of physical materials is by default inferred from the `sheen`, `sheenColor`
		 * and `sheenColorMap` properties. This node property allows to overwrite the default
		 * and define the sheen with a node instead.
		 *
		 * If you don't want to overwrite the sheen but modify the existing
		 * value instead, use {@link materialSheen}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.sheenNode = null;
        /**
		 * The sheen roughness of physical materials is by default inferred from the `sheenRoughness` and
		 * `sheenRoughnessMap` properties. This node property allows to overwrite the default
		 * and define the sheen roughness with a node instead.
		 *
		 * If you don't want to overwrite the sheen roughness but modify the existing
		 * value instead, use {@link materialSheenRoughness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.sheenRoughnessNode = null;
        /**
		 * The iridescence of physical materials is by default inferred from the `iridescence`
		 * property. This node property allows to overwrite the default
		 * and define the iridescence with a node instead.
		 *
		 * If you don't want to overwrite the iridescence but modify the existing
		 * value instead, use {@link materialIridescence}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.iridescenceNode = null;
        /**
		 * The iridescence IOR of physical materials is by default inferred from the `iridescenceIOR`
		 * property. This node property allows to overwrite the default
		 * and define the iridescence IOR with a node instead.
		 *
		 * If you don't want to overwrite the iridescence IOR but modify the existing
		 * value instead, use {@link materialIridescenceIOR}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.iridescenceIORNode = null;
        /**
		 * The iridescence thickness of physical materials is by default inferred from the `iridescenceThicknessRange`
		 * and `iridescenceThicknessMap` properties. This node property allows to overwrite the default
		 * and define the iridescence thickness with a node instead.
		 *
		 * If you don't want to overwrite the iridescence thickness but modify the existing
		 * value instead, use {@link materialIridescenceThickness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.iridescenceThicknessNode = null;
        /**
		 * The specular intensity of physical materials is by default inferred from the `specularIntensity`
		 * and `specularIntensityMap` properties. This node property allows to overwrite the default
		 * and define the specular intensity with a node instead.
		 *
		 * If you don't want to overwrite the specular intensity but modify the existing
		 * value instead, use {@link materialSpecularIntensity}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.specularIntensityNode = null;
        /**
		 * The specular color of physical materials is by default inferred from the `specularColor`
		 * and `specularColorMap` properties. This node property allows to overwrite the default
		 * and define the specular color with a node instead.
		 *
		 * If you don't want to overwrite the specular color but modify the existing
		 * value instead, use {@link materialSpecularColor}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.specularColorNode = null;
        /**
		 * The ior of physical materials is by default inferred from the `ior`
		 * property. This node property allows to overwrite the default
		 * and define the ior with a node instead.
		 *
		 * If you don't want to overwrite the ior but modify the existing
		 * value instead, use {@link materialIOR}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.iorNode = null;
        /**
		 * The transmission of physical materials is by default inferred from the `transmission` and
		 * `transmissionMap` properties. This node property allows to overwrite the default
		 * and define the transmission with a node instead.
		 *
		 * If you don't want to overwrite the transmission but modify the existing
		 * value instead, use {@link materialTransmission}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.transmissionNode = null;
        /**
		 * The thickness of physical materials is by default inferred from the `thickness` and
		 * `thicknessMap` properties. This node property allows to overwrite the default
		 * and define the thickness with a node instead.
		 *
		 * If you don't want to overwrite the thickness but modify the existing
		 * value instead, use {@link materialThickness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.thicknessNode = null;
        /**
		 * The attenuation distance of physical materials is by default inferred from the
		 * `attenuationDistance` property. This node property allows to overwrite the default
		 * and define the attenuation distance with a node instead.
		 *
		 * If you don't want to overwrite the attenuation distance but modify the existing
		 * value instead, use {@link materialAttenuationDistance}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.attenuationDistanceNode = null;
        /**
		 * The attenuation color of physical materials is by default inferred from the
		 * `attenuationColor` property. This node property allows to overwrite the default
		 * and define the attenuation color with a node instead.
		 *
		 * If you don't want to overwrite the attenuation color but modify the existing
		 * value instead, use {@link materialAttenuationColor}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.attenuationColorNode = null;
        /**
		 * The dispersion of physical materials is by default inferred from the
		 * `dispersion` property. This node property allows to overwrite the default
		 * and define the dispersion with a node instead.
		 *
		 * If you don't want to overwrite the dispersion but modify the existing
		 * value instead, use {@link materialDispersion}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.dispersionNode = null;
        /**
		 * The anisotropy of physical materials is by default inferred from the
		 * `anisotropy` property. This node property allows to overwrite the default
		 * and define the anisotropy with a node instead.
		 *
		 * If you don't want to overwrite the anisotropy but modify the existing
		 * value instead, use {@link materialAnisotropy}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.anisotropyNode = null;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$5);
        this.setValues(parameters);
    }
    /**
	 * Whether the lighting model should use clearcoat or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useClearcoat() {
        return this.clearcoat > 0 || this.clearcoatNode !== null;
    }
    /**
	 * Whether the lighting model should use iridescence or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useIridescence() {
        return this.iridescence > 0 || this.iridescenceNode !== null;
    }
    /**
	 * Whether the lighting model should use sheen or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useSheen() {
        return this.sheen > 0 || this.sheenNode !== null;
    }
    /**
	 * Whether the lighting model should use anisotropy or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useAnisotropy() {
        return this.anisotropy > 0 || this.anisotropyNode !== null;
    }
    /**
	 * Whether the lighting model should use transmission or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useTransmission() {
        return this.transmission > 0 || this.transmissionNode !== null;
    }
    /**
	 * Whether the lighting model should use dispersion or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useDispersion() {
        return this.dispersion > 0 || this.dispersionNode !== null;
    }
    /**
	 * Setups the specular related node variables.
	 */ setupSpecular() {
        const iorNode = this.iorNode ? $d89c9137a3d237c2$var$float(this.iorNode) : $d89c9137a3d237c2$var$materialIOR;
        $d89c9137a3d237c2$var$ior.assign(iorNode);
        $d89c9137a3d237c2$var$specularColor.assign($d89c9137a3d237c2$var$min$1($d89c9137a3d237c2$var$pow2($d89c9137a3d237c2$var$ior.sub(1.0).div($d89c9137a3d237c2$var$ior.add(1.0))).mul($d89c9137a3d237c2$var$materialSpecularColor), $d89c9137a3d237c2$var$vec3(1.0)).mul($d89c9137a3d237c2$var$materialSpecularIntensity));
        $d89c9137a3d237c2$var$specularColorBlended.assign($d89c9137a3d237c2$var$mix($d89c9137a3d237c2$var$specularColor, $d89c9137a3d237c2$var$diffuseColor.rgb, $d89c9137a3d237c2$var$metalness));
        $d89c9137a3d237c2$var$specularF90.assign($d89c9137a3d237c2$var$mix($d89c9137a3d237c2$var$materialSpecularIntensity, 1.0, $d89c9137a3d237c2$var$metalness));
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {PhysicalLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $d89c9137a3d237c2$export$b69e16149fd7d508(this.useClearcoat, this.useSheen, this.useIridescence, this.useAnisotropy, this.useTransmission, this.useDispersion);
    }
    /**
	 * Setups the physical specific node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants(builder) {
        super.setupVariants(builder);
        // CLEARCOAT
        if (this.useClearcoat) {
            const clearcoatNode = this.clearcoatNode ? $d89c9137a3d237c2$var$float(this.clearcoatNode) : $d89c9137a3d237c2$var$materialClearcoat;
            const clearcoatRoughnessNode = this.clearcoatRoughnessNode ? $d89c9137a3d237c2$var$float(this.clearcoatRoughnessNode) : $d89c9137a3d237c2$var$materialClearcoatRoughness;
            $d89c9137a3d237c2$var$clearcoat.assign(clearcoatNode);
            $d89c9137a3d237c2$var$clearcoatRoughness.assign($d89c9137a3d237c2$var$getRoughness({
                roughness: clearcoatRoughnessNode
            }));
        }
        // SHEEN
        if (this.useSheen) {
            const sheenNode = this.sheenNode ? $d89c9137a3d237c2$var$vec3(this.sheenNode) : $d89c9137a3d237c2$var$materialSheen;
            const sheenRoughnessNode = this.sheenRoughnessNode ? $d89c9137a3d237c2$var$float(this.sheenRoughnessNode) : $d89c9137a3d237c2$var$materialSheenRoughness;
            $d89c9137a3d237c2$var$sheen.assign(sheenNode);
            $d89c9137a3d237c2$var$sheenRoughness.assign(sheenRoughnessNode);
        }
        // IRIDESCENCE
        if (this.useIridescence) {
            const iridescenceNode = this.iridescenceNode ? $d89c9137a3d237c2$var$float(this.iridescenceNode) : $d89c9137a3d237c2$var$materialIridescence;
            const iridescenceIORNode = this.iridescenceIORNode ? $d89c9137a3d237c2$var$float(this.iridescenceIORNode) : $d89c9137a3d237c2$var$materialIridescenceIOR;
            const iridescenceThicknessNode = this.iridescenceThicknessNode ? $d89c9137a3d237c2$var$float(this.iridescenceThicknessNode) : $d89c9137a3d237c2$var$materialIridescenceThickness;
            $d89c9137a3d237c2$var$iridescence.assign(iridescenceNode);
            $d89c9137a3d237c2$var$iridescenceIOR.assign(iridescenceIORNode);
            $d89c9137a3d237c2$var$iridescenceThickness.assign(iridescenceThicknessNode);
        }
        // ANISOTROPY
        if (this.useAnisotropy) {
            const anisotropyV = (this.anisotropyNode ? $d89c9137a3d237c2$var$vec2(this.anisotropyNode) : $d89c9137a3d237c2$var$materialAnisotropy).toVar();
            $d89c9137a3d237c2$var$anisotropy.assign(anisotropyV.length());
            $d89c9137a3d237c2$var$If($d89c9137a3d237c2$var$anisotropy.equal(0.0), ()=>{
                anisotropyV.assign($d89c9137a3d237c2$var$vec2(1.0, 0.0));
            }).Else(()=>{
                anisotropyV.divAssign($d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$anisotropy));
                $d89c9137a3d237c2$var$anisotropy.assign($d89c9137a3d237c2$var$anisotropy.saturate());
            });
            // Roughness along the anisotropy bitangent is the material roughness, while the tangent roughness increases with anisotropy.
            $d89c9137a3d237c2$var$alphaT.assign($d89c9137a3d237c2$var$anisotropy.pow2().mix($d89c9137a3d237c2$var$roughness.pow2(), 1.0));
            $d89c9137a3d237c2$var$anisotropyT.assign($d89c9137a3d237c2$var$TBNViewMatrix[0].mul(anisotropyV.x).add($d89c9137a3d237c2$var$TBNViewMatrix[1].mul(anisotropyV.y)));
            $d89c9137a3d237c2$var$anisotropyB.assign($d89c9137a3d237c2$var$TBNViewMatrix[1].mul(anisotropyV.x).sub($d89c9137a3d237c2$var$TBNViewMatrix[0].mul(anisotropyV.y)));
        }
        // TRANSMISSION
        if (this.useTransmission) {
            const transmissionNode = this.transmissionNode ? $d89c9137a3d237c2$var$float(this.transmissionNode) : $d89c9137a3d237c2$var$materialTransmission;
            const thicknessNode = this.thicknessNode ? $d89c9137a3d237c2$var$float(this.thicknessNode) : $d89c9137a3d237c2$var$materialThickness;
            const attenuationDistanceNode = this.attenuationDistanceNode ? $d89c9137a3d237c2$var$float(this.attenuationDistanceNode) : $d89c9137a3d237c2$var$materialAttenuationDistance;
            const attenuationColorNode = this.attenuationColorNode ? $d89c9137a3d237c2$var$vec3(this.attenuationColorNode) : $d89c9137a3d237c2$var$materialAttenuationColor;
            $d89c9137a3d237c2$var$transmission.assign(transmissionNode);
            $d89c9137a3d237c2$var$thickness.assign(thicknessNode);
            $d89c9137a3d237c2$var$attenuationDistance.assign(attenuationDistanceNode);
            $d89c9137a3d237c2$var$attenuationColor.assign(attenuationColorNode);
            if (this.useDispersion) {
                const dispersionNode = this.dispersionNode ? $d89c9137a3d237c2$var$float(this.dispersionNode) : $d89c9137a3d237c2$var$materialDispersion;
                $d89c9137a3d237c2$var$dispersion.assign(dispersionNode);
            }
        }
    }
    /**
	 * Setups the clearcoat normal node.
	 *
	 * @return {Node<vec3>} The clearcoat normal.
	 */ setupClearcoatNormal() {
        return this.clearcoatNormalNode ? $d89c9137a3d237c2$var$vec3(this.clearcoatNormalNode) : $d89c9137a3d237c2$var$materialClearcoatNormal;
    }
    setup(builder) {
        builder.context.setupClearcoatNormal = ()=>$d89c9137a3d237c2$var$subBuild(this.setupClearcoatNormal(builder), 'NORMAL', 'vec3');
        super.setup(builder);
    }
    copy(source) {
        this.clearcoatNode = source.clearcoatNode;
        this.clearcoatRoughnessNode = source.clearcoatRoughnessNode;
        this.clearcoatNormalNode = source.clearcoatNormalNode;
        this.sheenNode = source.sheenNode;
        this.sheenRoughnessNode = source.sheenRoughnessNode;
        this.iridescenceNode = source.iridescenceNode;
        this.iridescenceIORNode = source.iridescenceIORNode;
        this.iridescenceThicknessNode = source.iridescenceThicknessNode;
        this.specularIntensityNode = source.specularIntensityNode;
        this.specularColorNode = source.specularColorNode;
        this.transmissionNode = source.transmissionNode;
        this.thicknessNode = source.thicknessNode;
        this.attenuationDistanceNode = source.attenuationDistanceNode;
        this.attenuationColorNode = source.attenuationColorNode;
        this.dispersionNode = source.dispersionNode;
        this.anisotropyNode = source.anisotropyNode;
        return super.copy(source);
    }
}
/**
 * Represents the lighting model for {@link MeshSSSNodeMaterial}.
 *
 * @augments PhysicalLightingModel
 */ class $d89c9137a3d237c2$var$SSSLightingModel extends $d89c9137a3d237c2$export$b69e16149fd7d508 {
    /**
	 * Constructs a new physical lighting model.
	 *
	 * @param {boolean} [clearcoat=false] - Whether clearcoat is supported or not.
	 * @param {boolean} [sheen=false] - Whether sheen is supported or not.
	 * @param {boolean} [iridescence=false] - Whether iridescence is supported or not.
	 * @param {boolean} [anisotropy=false] - Whether anisotropy is supported or not.
	 * @param {boolean} [transmission=false] - Whether transmission is supported or not.
	 * @param {boolean} [dispersion=false] - Whether dispersion is supported or not.
	 * @param {boolean} [sss=false] - Whether SSS is supported or not.
	 */ constructor(clearcoat = false, sheen = false, iridescence = false, anisotropy = false, transmission = false, dispersion = false, sss = false){
        super(clearcoat, sheen, iridescence, anisotropy, transmission, dispersion);
        /**
		 * Whether the lighting model should use SSS or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.useSSS = sss;
    }
    /**
	 * Extends the default implementation with a SSS term.
	 *
	 * Reference: [Approximating Translucency for a Fast, Cheap and Convincing Subsurface Scattering Look](https://colinbarrebrisebois.com/2011/03/07/gdc-2011-approximating-translucency-for-a-fast-cheap-and-convincing-subsurface-scattering-look/)
	 *
	 * @param {Object} input - The input data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ direct({ lightDirection: lightDirection, lightColor: lightColor, reflectedLight: reflectedLight }, builder) {
        if (this.useSSS === true) {
            const material = builder.material;
            const { thicknessColorNode: thicknessColorNode, thicknessDistortionNode: thicknessDistortionNode, thicknessAmbientNode: thicknessAmbientNode, thicknessAttenuationNode: thicknessAttenuationNode, thicknessPowerNode: thicknessPowerNode, thicknessScaleNode: thicknessScaleNode } = material;
            const scatteringHalf = lightDirection.add($d89c9137a3d237c2$var$normalView.mul(thicknessDistortionNode)).normalize();
            const scatteringDot = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$positionViewDirection.dot(scatteringHalf.negate()).saturate().pow(thicknessPowerNode).mul(thicknessScaleNode));
            const scatteringIllu = $d89c9137a3d237c2$var$vec3(scatteringDot.add(thicknessAmbientNode).mul(thicknessColorNode));
            reflectedLight.directDiffuse.addAssign(scatteringIllu.mul(thicknessAttenuationNode.mul(lightColor)));
        }
        super.direct({
            lightDirection: lightDirection,
            lightColor: lightColor,
            reflectedLight: reflectedLight
        }, builder);
    }
}
/**
 * This node material is an experimental extension of {@link MeshPhysicalNodeMaterial}
 * that implements a Subsurface scattering (SSS) term.
 *
 * @augments MeshPhysicalNodeMaterial
 */ class $d89c9137a3d237c2$export$3b1fa10c015e327a extends $d89c9137a3d237c2$export$f336706882be0d39 {
    static get type() {
        return 'MeshSSSNodeMaterial';
    }
    /**
	 * Constructs a new mesh SSS node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super(parameters);
        /**
		 * Represents the thickness color.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.thicknessColorNode = null;
        /**
		 * Represents the distortion factor.
		 *
		 * @type {?Node<float>}
		 */ this.thicknessDistortionNode = $d89c9137a3d237c2$var$float(0.1);
        /**
		 * Represents the thickness ambient factor.
		 *
		 * @type {?Node<float>}
		 */ this.thicknessAmbientNode = $d89c9137a3d237c2$var$float(0.0);
        /**
		 * Represents the thickness attenuation.
		 *
		 * @type {?Node<float>}
		 */ this.thicknessAttenuationNode = $d89c9137a3d237c2$var$float(.1);
        /**
		 * Represents the thickness power.
		 *
		 * @type {?Node<float>}
		 */ this.thicknessPowerNode = $d89c9137a3d237c2$var$float(2.0);
        /**
		 * Represents the thickness scale.
		 *
		 * @type {?Node<float>}
		 */ this.thicknessScaleNode = $d89c9137a3d237c2$var$float(10.0);
    }
    /**
	 * Whether the lighting model should use SSS or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useSSS() {
        return this.thicknessColorNode !== null;
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {SSSLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $d89c9137a3d237c2$var$SSSLightingModel(this.useClearcoat, this.useSheen, this.useIridescence, this.useAnisotropy, this.useTransmission, this.useDispersion, this.useSSS);
    }
    copy(source) {
        this.thicknessColorNode = source.thicknessColorNode;
        this.thicknessDistortionNode = source.thicknessDistortionNode;
        this.thicknessAmbientNode = source.thicknessAmbientNode;
        this.thicknessAttenuationNode = source.thicknessAttenuationNode;
        this.thicknessPowerNode = source.thicknessPowerNode;
        this.thicknessScaleNode = source.thicknessScaleNode;
        return super.copy(source);
    }
}
const $d89c9137a3d237c2$var$getGradientIrradiance = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ normal: normal, lightDirection: lightDirection, builder: builder })=>{
    // dotNL will be from -1.0 to 1.0
    const dotNL = normal.dot(lightDirection);
    const coord = $d89c9137a3d237c2$var$vec2(dotNL.mul(0.5).add(0.5), 0.0);
    if (builder.material.gradientMap) {
        const gradientMap = $d89c9137a3d237c2$var$materialReference('gradientMap', 'texture').context({
            getUV: ()=>coord
        });
        return $d89c9137a3d237c2$var$vec3(gradientMap.r);
    } else {
        const fw = coord.fwidth().mul(0.5);
        return $d89c9137a3d237c2$var$mix($d89c9137a3d237c2$var$vec3(0.7), $d89c9137a3d237c2$var$vec3(1.0), $d89c9137a3d237c2$var$smoothstep($d89c9137a3d237c2$var$float(0.7).sub(fw.x), $d89c9137a3d237c2$var$float(0.7).add(fw.x), coord.x));
    }
});
/**
 * Represents the lighting model for a toon material. Used in {@link MeshToonNodeMaterial}.
 *
 * @augments LightingModel
 */ class $d89c9137a3d237c2$var$ToonLightingModel extends $d89c9137a3d237c2$export$d8f76c0bb8645ea7 {
    /**
	 * Implements the direct lighting. Instead of using a conventional smooth irradiance, the irradiance is
	 * reduced to a small number of discrete shades to create a comic-like, flat look.
	 *
	 * @param {Object} lightData - The light data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ direct({ lightDirection: lightDirection, lightColor: lightColor, reflectedLight: reflectedLight }, builder) {
        const irradiance = $d89c9137a3d237c2$var$getGradientIrradiance({
            normal: $d89c9137a3d237c2$var$normalGeometry,
            lightDirection: lightDirection,
            builder: builder
        }).mul(lightColor);
        reflectedLight.directDiffuse.addAssign(irradiance.mul($d89c9137a3d237c2$var$BRDF_Lambert({
            diffuseColor: $d89c9137a3d237c2$var$diffuseColor.rgb
        })));
    }
    /**
	 * Implements the indirect lighting.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirect(builder) {
        const { ambientOcclusion: ambientOcclusion, irradiance: irradiance, reflectedLight: reflectedLight } = builder.context;
        reflectedLight.indirectDiffuse.addAssign(irradiance.mul($d89c9137a3d237c2$var$BRDF_Lambert({
            diffuseColor: $d89c9137a3d237c2$var$diffuseColor
        })));
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
    }
}
const $d89c9137a3d237c2$var$_defaultValues$4 = /*@__PURE__*/ new (0, $329ek.MeshToonMaterial)();
/**
 * Node material version of {@link MeshToonMaterial}.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$2dd2c8d143c7c392 extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshToonNodeMaterial';
    }
    /**
	 * Constructs a new mesh toon node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshToonNodeMaterial = true;
        /**
		 * Set to `true` because toon materials react on lights.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$4);
        this.setValues(parameters);
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {ToonLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $d89c9137a3d237c2$var$ToonLightingModel();
    }
}
/**
 * TSL function for creating a matcap uv node.
 *
 * Can be used to compute texture coordinates for projecting a
 * matcap onto a mesh. Used by {@link MeshMatcapNodeMaterial}.
 *
 * @tsl
 * @function
 * @returns {Node<vec2>} The matcap UV coordinates.
 */ const $d89c9137a3d237c2$var$matcapUV = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(()=>{
    const x = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$positionViewDirection.z, 0, $d89c9137a3d237c2$var$positionViewDirection.x.negate()).normalize();
    const y = $d89c9137a3d237c2$var$positionViewDirection.cross(x);
    return $d89c9137a3d237c2$var$vec2(x.dot($d89c9137a3d237c2$var$normalView), y.dot($d89c9137a3d237c2$var$normalView)).mul(0.495).add(0.5); // 0.495 to remove artifacts caused by undersized matcap disks
}).once([
    'NORMAL',
    'VERTEX'
])().toVar('matcapUV');
const $d89c9137a3d237c2$var$_defaultValues$3 = /*@__PURE__*/ new (0, $329ek.MeshMatcapMaterial)();
/**
 * Node material version of {@link MeshMatcapMaterial}.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$f7d65f3d82d7b0b0 extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshMatcapNodeMaterial';
    }
    /**
	 * Constructs a new mesh normal node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshMatcapNodeMaterial = true;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$3);
        this.setValues(parameters);
    }
    /**
	 * Setups the matcap specific node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants(builder) {
        const uv = $d89c9137a3d237c2$var$matcapUV;
        let matcapColor;
        if (builder.material.matcap) matcapColor = $d89c9137a3d237c2$var$materialReference('matcap', 'texture').context({
            getUV: ()=>uv
        });
        else matcapColor = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mix(0.2, 0.8, uv.y)); // default if matcap is missing
        $d89c9137a3d237c2$var$diffuseColor.rgb.mulAssign(matcapColor.rgb);
    }
}
/**
 * Applies a rotation to the given position node.
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$5210a1a3dd372bdd extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'RotateNode';
    }
    /**
	 * Constructs a new rotate node.
	 *
	 * @param {Node} positionNode - The position node.
	 * @param {Node} rotationNode - Represents the rotation that is applied to the position node. Depending
	 * on whether the position data are 2D or 3D, the rotation is expressed a single float value or an Euler value.
	 */ constructor(positionNode, rotationNode){
        super();
        /**
		 * The position node.
		 *
		 * @type {Node}
		 */ this.positionNode = positionNode;
        /**
		 *  Represents the rotation that is applied to the position node.
		 *  Depending on whether the position data are 2D or 3D, the rotation is expressed a single float value or an Euler value.
		 *
		 * @type {Node}
		 */ this.rotationNode = rotationNode;
    }
    /**
	 * The type of the {@link RotateNode#positionNode} defines the node's type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node's type.
	 */ getNodeType(builder) {
        return this.positionNode.getNodeType(builder);
    }
    setup(builder) {
        const { rotationNode: rotationNode, positionNode: positionNode } = this;
        const nodeType = this.getNodeType(builder);
        if (nodeType === 'vec2') {
            const cosAngle = rotationNode.cos();
            const sinAngle = rotationNode.sin();
            const rotationMatrix = $d89c9137a3d237c2$var$mat2(cosAngle, sinAngle, sinAngle.negate(), cosAngle);
            return rotationMatrix.mul(positionNode);
        } else {
            const rotation = rotationNode;
            const rotationXMatrix = $d89c9137a3d237c2$var$mat4($d89c9137a3d237c2$var$vec4(1.0, 0.0, 0.0, 0.0), $d89c9137a3d237c2$var$vec4(0.0, $d89c9137a3d237c2$var$cos(rotation.x), $d89c9137a3d237c2$var$sin(rotation.x).negate(), 0.0), $d89c9137a3d237c2$var$vec4(0.0, $d89c9137a3d237c2$var$sin(rotation.x), $d89c9137a3d237c2$var$cos(rotation.x), 0.0), $d89c9137a3d237c2$var$vec4(0.0, 0.0, 0.0, 1.0));
            const rotationYMatrix = $d89c9137a3d237c2$var$mat4($d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$cos(rotation.y), 0.0, $d89c9137a3d237c2$var$sin(rotation.y), 0.0), $d89c9137a3d237c2$var$vec4(0.0, 1.0, 0.0, 0.0), $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$sin(rotation.y).negate(), 0.0, $d89c9137a3d237c2$var$cos(rotation.y), 0.0), $d89c9137a3d237c2$var$vec4(0.0, 0.0, 0.0, 1.0));
            const rotationZMatrix = $d89c9137a3d237c2$var$mat4($d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$cos(rotation.z), $d89c9137a3d237c2$var$sin(rotation.z).negate(), 0.0, 0.0), $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$sin(rotation.z), $d89c9137a3d237c2$var$cos(rotation.z), 0.0, 0.0), $d89c9137a3d237c2$var$vec4(0.0, 0.0, 1.0, 0.0), $d89c9137a3d237c2$var$vec4(0.0, 0.0, 0.0, 1.0));
            return rotationXMatrix.mul(rotationYMatrix).mul(rotationZMatrix).mul($d89c9137a3d237c2$var$vec4(positionNode, 1.0)).xyz;
        }
    }
}
/**
 * TSL function for creating a rotate node.
 *
 * @tsl
 * @function
 * @param {Node} positionNode - The position node.
 * @param {Node} rotationNode - Represents the rotation that is applied to the position node. Depending
 * on whether the position data are 2D or 3D, the rotation is expressed a single float value or an Euler value.
 * @returns {RotateNode}
 */ const $d89c9137a3d237c2$var$rotate = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$5210a1a3dd372bdd).setParameterLength(2);
const $d89c9137a3d237c2$var$_defaultValues$2 = /*@__PURE__*/ new (0, $329ek.SpriteMaterial)();
/**
 * Node material version of {@link SpriteMaterial}.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$80f4e36249294380 extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'SpriteNodeMaterial';
    }
    /**
	 * Constructs a new sprite node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpriteNodeMaterial = true;
        this._useSizeAttenuation = true;
        /**
		 * This property makes it possible to define the position of the sprite with a
		 * node. That can be useful when the material is used with instanced rendering
		 * and node data are defined with an instanced attribute node:
		 * ```js
		 * const positionAttribute = new InstancedBufferAttribute( new Float32Array( positions ), 3 );
		 * material.positionNode = instancedBufferAttribute( positionAttribute );
		 * ```
		 * Another possibility is to compute the instanced data with a compute shader:
		 * ```js
		 * const positionBuffer = instancedArray( particleCount, 'vec3' );
		 * particleMaterial.positionNode = positionBuffer.toAttribute();
		 * ```
		 *
		 * @type {?Node<vec2>}
		 * @default null
		 */ this.positionNode = null;
        /**
		 * The rotation of sprite materials is by default inferred from the `rotation`,
		 * property. This node property allows to overwrite the default and define
		 * the rotation with a node instead.
		 *
		 * If you don't want to overwrite the rotation but modify the existing
		 * value instead, use {@link materialRotation}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.rotationNode = null;
        /**
		 * This node property provides an additional way to scale sprites next to
		 * `Object3D.scale`. The scale transformation based in `Object3D.scale`
		 * is multiplied with the scale value of this node in the vertex shader.
		 *
		 * @type {?Node<vec2>}
		 * @default null
		 */ this.scaleNode = null;
        /**
		 * In Sprites, the transparent property is enabled by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$2);
        this.setValues(parameters);
    }
    /**
	 * Setups the position node in view space. This method implements
	 * the sprite specific vertex shader.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The position in view space.
	 */ setupPositionView(builder) {
        const { object: object, camera: camera } = builder;
        const { positionNode: positionNode, rotationNode: rotationNode, scaleNode: scaleNode, sizeAttenuation: sizeAttenuation } = this;
        const mvPosition = $d89c9137a3d237c2$var$modelViewMatrix.mul($d89c9137a3d237c2$var$vec3(positionNode || 0));
        let scale = $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$modelWorldMatrix[0].xyz.length(), $d89c9137a3d237c2$var$modelWorldMatrix[1].xyz.length());
        if (scaleNode !== null) scale = scale.mul($d89c9137a3d237c2$var$vec2(scaleNode));
        if (camera.isPerspectiveCamera && sizeAttenuation === false) scale = scale.mul(mvPosition.z.negate());
        let alignedPosition = $d89c9137a3d237c2$var$positionGeometry.xy;
        if (object.center && object.center.isVector2 === true) {
            const center = $d89c9137a3d237c2$var$reference$1('center', 'vec2', object);
            alignedPosition = alignedPosition.sub(center.sub(0.5));
        }
        alignedPosition = alignedPosition.mul(scale);
        const rotation = $d89c9137a3d237c2$var$float(rotationNode || $d89c9137a3d237c2$var$materialRotation);
        const rotatedPosition = $d89c9137a3d237c2$var$rotate(alignedPosition, rotation);
        return $d89c9137a3d237c2$var$vec4(mvPosition.xy.add(rotatedPosition), mvPosition.zw);
    }
    copy(source) {
        this.positionNode = source.positionNode;
        this.rotationNode = source.rotationNode;
        this.scaleNode = source.scaleNode;
        return super.copy(source);
    }
    /**
	 * Whether to use size attenuation or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get sizeAttenuation() {
        return this._useSizeAttenuation;
    }
    set sizeAttenuation(value) {
        if (this._useSizeAttenuation !== value) {
            this._useSizeAttenuation = value;
            this.needsUpdate = true;
        }
    }
}
const $d89c9137a3d237c2$var$_defaultValues$1 = /*@__PURE__*/ new (0, $329ek.PointsMaterial)();
const $d89c9137a3d237c2$var$_size$4 = /*@__PURE__*/ new (0, $329ek.Vector2)();
/**
 * Node material version of {@link PointsMaterial}.
 *
 * This material can be used in two ways:
 *
 * - By rendering point primitives with {@link Points}. Since WebGPU only supports point primitives
 * with a pixel size of `1`, it's not possible to define a size.
 *
 * ```js
 * const pointCloud = new THREE.Points( geometry, new THREE.PointsNodeMaterial() );
 * ```
 *
 * - By rendering point primitives with {@link Sprites}. In this case, size is honored,
 * see {@link PointsNodeMaterial#sizeNode}.
 *
 * ```js
 * const instancedPoints = new THREE.Sprite( new THREE.PointsNodeMaterial( { positionNode: instancedBufferAttribute( positionAttribute ) } ) );
 * ```
 *
 * @augments SpriteNodeMaterial
 */ class $d89c9137a3d237c2$export$986cd66fa4ca801b extends $d89c9137a3d237c2$export$80f4e36249294380 {
    static get type() {
        return 'PointsNodeMaterial';
    }
    /**
	 * Constructs a new points node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This node property provides an additional way to set the point size.
		 *
		 * Note that WebGPU only supports point primitives with 1 pixel size. Consequently,
		 * this node has no effect when the material is used with {@link Points} and a WebGPU
		 * backend. If an application wants to render points with a size larger than 1 pixel,
		 * the material should be used with {@link Sprite} and instancing.
		 *
		 * @type {?Node<vec2>}
		 * @default null
		 */ this.sizeNode = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointsNodeMaterial = true;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues$1);
        this.setValues(parameters);
    }
    setupPositionView() {
        const { positionNode: positionNode } = this;
        return $d89c9137a3d237c2$var$modelViewMatrix.mul($d89c9137a3d237c2$var$vec3(positionNode || $d89c9137a3d237c2$var$positionLocal)).xyz;
    }
    setupVertexSprite(builder) {
        const { material: material, camera: camera } = builder;
        const { rotationNode: rotationNode, scaleNode: scaleNode, sizeNode: sizeNode, sizeAttenuation: sizeAttenuation } = this;
        let mvp = super.setupVertex(builder);
        // skip further processing if the material is not a node material
        if (material.isNodeMaterial !== true) return mvp;
        // point size
        let pointSize = sizeNode !== null ? $d89c9137a3d237c2$var$vec2(sizeNode) : $d89c9137a3d237c2$var$materialPointSize;
        pointSize = pointSize.mul($d89c9137a3d237c2$var$screenDPR);
        // size attenuation
        if (camera.isPerspectiveCamera && sizeAttenuation === true) // follow WebGLRenderer's implementation, and scale by half the canvas height in logical units
        pointSize = pointSize.mul($d89c9137a3d237c2$var$scale.div($d89c9137a3d237c2$var$positionView.z.negate()));
        // scale
        if (scaleNode && scaleNode.isNode) pointSize = pointSize.mul($d89c9137a3d237c2$var$vec2(scaleNode));
        // compute offset
        let offset = $d89c9137a3d237c2$var$positionGeometry.xy;
        // apply rotation
        if (rotationNode && rotationNode.isNode) {
            const rotation = $d89c9137a3d237c2$var$float(rotationNode);
            offset = $d89c9137a3d237c2$var$rotate(offset, rotation);
        }
        // account for point size
        offset = offset.mul(pointSize);
        // scale by viewport size
        offset = offset.div($d89c9137a3d237c2$var$viewportSize.div(2));
        // compensate for the perspective divide
        offset = offset.mul(mvp.w);
        // add offset
        mvp = mvp.add($d89c9137a3d237c2$var$vec4(offset, 0, 0));
        return mvp;
    }
    setupVertex(builder) {
        if (builder.object.isPoints) return super.setupVertex(builder);
        else return this.setupVertexSprite(builder);
    }
    /**
	 * Whether alpha to coverage should be used or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get alphaToCoverage() {
        return this._useAlphaToCoverage;
    }
    set alphaToCoverage(value) {
        if (this._useAlphaToCoverage !== value) {
            this._useAlphaToCoverage = value;
            this.needsUpdate = true;
        }
    }
}
const $d89c9137a3d237c2$var$scale = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform(1).onFrameUpdate(function({ renderer: renderer }) {
    const size = renderer.getSize($d89c9137a3d237c2$var$_size$4); // logical units
    this.value = 0.5 * size.y;
});
/**
 * Represents lighting model for a shadow material. Used in {@link ShadowNodeMaterial}.
 *
 * @augments LightingModel
 */ class $d89c9137a3d237c2$var$ShadowMaskModel extends $d89c9137a3d237c2$export$d8f76c0bb8645ea7 {
    /**
	 * Constructs a new shadow mask model.
	 */ constructor(){
        super();
        /**
		 * The shadow mask node.
		 *
		 * @type {Node}
		 */ this.shadowNode = $d89c9137a3d237c2$var$float(1).toVar('shadowMask');
    }
    /**
	 * Only used to save the shadow mask.
	 *
	 * @param {Object} input - The input data.
	 */ direct({ lightNode: lightNode }) {
        if (lightNode.shadowNode !== null) this.shadowNode.mulAssign(lightNode.shadowNode);
    }
    /**
	 * Uses the shadow mask to produce the final color.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ finish({ context: context }) {
        $d89c9137a3d237c2$var$diffuseColor.a.mulAssign(this.shadowNode.oneMinus());
        context.outgoingLight.rgb.assign($d89c9137a3d237c2$var$diffuseColor.rgb); // TODO: Optimize LightsNode to avoid this assignment
    }
}
const $d89c9137a3d237c2$var$_defaultValues = /*@__PURE__*/ new (0, $329ek.ShadowMaterial)();
/**
 * Node material version of {@link ShadowMaterial}.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$6ba7483788b75e55 extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'ShadowNodeMaterial';
    }
    /**
	 * Constructs a new shadow node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowNodeMaterial = true;
        /**
		 * Set to `true` because so it's possible to implement
		 * the shadow mask effect.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        /**
		 * Overwritten since shadow materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        this.setDefaultValues($d89c9137a3d237c2$var$_defaultValues);
        this.setValues(parameters);
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {ShadowMaskModel} The lighting model.
	 */ setupLightingModel() {
        return new $d89c9137a3d237c2$var$ShadowMaskModel();
    }
}
const $d89c9137a3d237c2$var$scatteringDensity = $d89c9137a3d237c2$var$property('vec3');
const $d89c9137a3d237c2$var$linearDepthRay = $d89c9137a3d237c2$var$property('vec3');
const $d89c9137a3d237c2$var$outgoingRayLight = $d89c9137a3d237c2$var$property('vec3');
/**
 * VolumetricLightingModel class extends the LightingModel to implement volumetric lighting effects.
 * This model calculates the scattering and transmittance of light through a volumetric medium.
 * It dynamically adjusts the direction of the ray based on the camera and object positions.
 * The model supports custom scattering and depth nodes to enhance the lighting effects.
 *
 * @augments LightingModel
 */ class $d89c9137a3d237c2$var$VolumetricLightingModel extends $d89c9137a3d237c2$export$d8f76c0bb8645ea7 {
    constructor(){
        super();
    }
    start(builder) {
        const { material: material } = builder;
        const startPos = $d89c9137a3d237c2$var$property('vec3');
        const endPos = $d89c9137a3d237c2$var$property('vec3');
        // This approach dynamically changes the direction of the ray,
        // prioritizing the ray from the camera to the object if it is inside the mesh, and from the object to the camera if it is far away.
        $d89c9137a3d237c2$var$If($d89c9137a3d237c2$var$cameraPosition.sub($d89c9137a3d237c2$var$positionWorld).length().greaterThan($d89c9137a3d237c2$var$modelRadius.mul(2)), ()=>{
            startPos.assign($d89c9137a3d237c2$var$cameraPosition);
            endPos.assign($d89c9137a3d237c2$var$positionWorld);
        }).Else(()=>{
            startPos.assign($d89c9137a3d237c2$var$positionWorld);
            endPos.assign($d89c9137a3d237c2$var$cameraPosition);
        });
        //
        const viewVector = endPos.sub(startPos);
        const steps = $d89c9137a3d237c2$var$uniform('int').onRenderUpdate(({ material: material })=>material.steps);
        const stepSize = viewVector.length().div(steps).toVar();
        const rayDir = viewVector.normalize().toVar(); // TODO: toVar() should be automatic here ( in loop )
        const distTravelled = $d89c9137a3d237c2$var$float(0.0).toVar();
        const transmittance = $d89c9137a3d237c2$var$vec3(1).toVar();
        if (material.offsetNode) // reduce banding
        distTravelled.addAssign(material.offsetNode.mul(stepSize));
        $d89c9137a3d237c2$var$Loop(steps, ()=>{
            const positionRay = startPos.add(rayDir.mul(distTravelled));
            const positionViewRay = $d89c9137a3d237c2$var$cameraViewMatrix.mul($d89c9137a3d237c2$var$vec4(positionRay, 1)).xyz;
            if (material.depthNode !== null) {
                $d89c9137a3d237c2$var$linearDepthRay.assign($d89c9137a3d237c2$var$linearDepth($d89c9137a3d237c2$var$viewZToPerspectiveDepth(positionViewRay.z, $d89c9137a3d237c2$var$cameraNear, $d89c9137a3d237c2$var$cameraFar)));
                builder.context.sceneDepthNode = $d89c9137a3d237c2$var$linearDepth(material.depthNode).toVar();
            }
            builder.context.positionWorld = positionRay;
            builder.context.shadowPositionWorld = positionRay;
            builder.context.positionView = positionViewRay;
            $d89c9137a3d237c2$var$scatteringDensity.assign(0);
            let scatteringNode;
            if (material.scatteringNode) scatteringNode = material.scatteringNode({
                positionRay: positionRay
            });
            super.start(builder);
            if (scatteringNode) $d89c9137a3d237c2$var$scatteringDensity.mulAssign(scatteringNode);
            // beer's law
            const falloff = $d89c9137a3d237c2$var$scatteringDensity.mul(.01).negate().mul(stepSize).exp();
            transmittance.mulAssign(falloff);
            // move along the ray
            distTravelled.addAssign(stepSize);
        });
        $d89c9137a3d237c2$var$outgoingRayLight.addAssign(transmittance.saturate().oneMinus());
    }
    scatteringLight(lightColor, builder) {
        const sceneDepthNode = builder.context.sceneDepthNode;
        if (sceneDepthNode) $d89c9137a3d237c2$var$If(sceneDepthNode.greaterThanEqual($d89c9137a3d237c2$var$linearDepthRay), ()=>{
            $d89c9137a3d237c2$var$scatteringDensity.addAssign(lightColor);
        });
        else $d89c9137a3d237c2$var$scatteringDensity.addAssign(lightColor);
    }
    direct({ lightNode: lightNode, lightColor: lightColor }, builder) {
        // Ignore lights with infinite distance
        if (lightNode.light.distance === undefined) return;
        // TODO: We need a viewportOpaque*() ( output, depth ) to fit with modern rendering approaches
        const directLight = lightColor.xyz.toVar();
        directLight.mulAssign(lightNode.shadowNode); // it no should be necessary if used in the same render pass
        this.scatteringLight(directLight, builder);
    }
    directRectArea({ lightColor: lightColor, lightPosition: lightPosition, halfWidth: halfWidth, halfHeight: halfHeight }, builder) {
        const p0 = lightPosition.add(halfWidth).sub(halfHeight); // counterclockwise; light shines in local neg z direction
        const p1 = lightPosition.sub(halfWidth).sub(halfHeight);
        const p2 = lightPosition.sub(halfWidth).add(halfHeight);
        const p3 = lightPosition.add(halfWidth).add(halfHeight);
        const P = builder.context.positionView;
        const directLight = lightColor.xyz.mul($d89c9137a3d237c2$var$LTC_Evaluate_Volume({
            P: P,
            p0: p0,
            p1: p1,
            p2: p2,
            p3: p3
        })).pow(1.5);
        this.scatteringLight(directLight, builder);
    }
    finish(builder) {
        builder.context.outgoingLight.assign($d89c9137a3d237c2$var$outgoingRayLight);
    }
}
/**
 * Volume node material.
 *
 * @augments NodeMaterial
 */ class $d89c9137a3d237c2$export$21fbdfe5d9192491 extends $d89c9137a3d237c2$export$caaf3b30a544c946 {
    static get type() {
        return 'VolumeNodeMaterial';
    }
    /**
	 * Constructs a new volume node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVolumeNodeMaterial = true;
        /**
		 * Number of steps used for raymarching.
		 *
		 * @type {number}
		 * @default 25
		 */ this.steps = 25;
        /**
		 * Offsets the distance a ray has been traveled through a volume.
		 * Can be used to implement dithering to reduce banding.
		 *
		 * @type {Node<float>}
		 * @default null
		 */ this.offsetNode = null;
        /**
		 * Node used for scattering calculations.
		 *
		 * @type {Function|FunctionNode<vec4>}
		 * @default null
		 */ this.scatteringNode = null;
        this.lights = true;
        this.transparent = true;
        this.side = (0, $329ek.BackSide);
        this.depthTest = false;
        this.depthWrite = false;
        this.setValues(parameters);
    }
    setupLightingModel() {
        return new $d89c9137a3d237c2$var$VolumetricLightingModel();
    }
}
/**
 * This module manages the internal animation loop of the renderer.
 *
 * @private
 */ class $d89c9137a3d237c2$var$Animation {
    /**
	 * Constructs a new animation loop management component.
	 *
	 * @param {Renderer} renderer - A reference to the main renderer.
	 * @param {Nodes} nodes - Renderer component for managing nodes related logic.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(renderer, nodes, info){
        /**
		 * A reference to the main renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {Nodes}
		 */ this.nodes = nodes;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
        /**
		 * A reference to the context from `requestAnimationFrame()` can
		 * be called (usually `window`).
		 *
		 * @type {?(Window|XRSession)}
		 */ this._context = typeof self !== 'undefined' ? self : null;
        /**
		 * The user-defined animation loop.
		 *
		 * @type {?Function}
		 * @default null
		 */ this._animationLoop = null;
        /**
		 * The requestId which is returned from the `requestAnimationFrame()` call.
		 * Can be used to cancel the stop the animation loop.
		 *
		 * @type {?number}
		 * @default null
		 */ this._requestId = null;
    }
    /**
	 * Starts the internal animation loop.
	 */ start() {
        const update = (time, xrFrame)=>{
            this._requestId = this._context.requestAnimationFrame(update);
            if (this.info.autoReset === true) this.info.reset();
            this.nodes.nodeFrame.update();
            this.info.frame = this.nodes.nodeFrame.frameId;
            this.renderer._inspector.begin();
            if (this._animationLoop !== null) this._animationLoop(time, xrFrame);
            this.renderer._inspector.finish();
        };
        update();
    }
    /**
	 * Stops the internal animation loop.
	 */ stop() {
        this._context.cancelAnimationFrame(this._requestId);
        this._requestId = null;
    }
    /**
	 * Returns the user-level animation loop.
	 *
	 * @return {?Function} The animation loop.
	 */ getAnimationLoop() {
        return this._animationLoop;
    }
    /**
	 * Defines the user-level animation loop.
	 *
	 * @param {?Function} callback - The animation loop.
	 */ setAnimationLoop(callback) {
        this._animationLoop = callback;
    }
    /**
	 * Returns the animation context.
	 *
	 * @return {Window|XRSession} The animation context.
	 */ getContext() {
        return this._context;
    }
    /**
	 * Defines the context in which `requestAnimationFrame()` is executed.
	 *
	 * @param {Window|XRSession} context - The context to set.
	 */ setContext(context) {
        this._context = context;
    }
    /**
	 * Frees all internal resources and stops the animation loop.
	 */ dispose() {
        this.stop();
    }
}
/**
 * Data structure for the renderer. It allows defining values
 * with chained, hierarchical keys. Keys are meant to be
 * objects since the module internally works with Weak Maps
 * for performance reasons.
 *
 * @private
 */ class $d89c9137a3d237c2$var$ChainMap {
    /**
	 * Constructs a new Chain Map.
	 */ constructor(){
        /**
		 * A map of Weak Maps by their key length.
		 *
		 * @type {Object<number, WeakMap>}
		 */ this.weakMaps = {};
    }
    /**
	 * Returns the Weak Map for the given keys.
	 *
	 * @param {Array<Object>} keys - List of keys.
	 * @return {WeakMap} The weak map.
	 */ _getWeakMap(keys) {
        const length = keys.length;
        let weakMap = this.weakMaps[length];
        if (weakMap === undefined) {
            weakMap = new WeakMap();
            this.weakMaps[length] = weakMap;
        }
        return weakMap;
    }
    /**
	 * Returns the value for the given array of keys.
	 *
	 * @param {Array<Object>} keys - List of keys.
	 * @return {any} The value. Returns `undefined` if no value was found.
	 */ get(keys) {
        let map = this._getWeakMap(keys);
        for(let i = 0; i < keys.length - 1; i++){
            map = map.get(keys[i]);
            if (map === undefined) return undefined;
        }
        return map.get(keys[keys.length - 1]);
    }
    /**
	 * Sets the value for the given keys.
	 *
	 * @param {Array<Object>} keys - List of keys.
	 * @param {any} value - The value to set.
	 * @return {ChainMap} A reference to this Chain Map.
	 */ set(keys, value) {
        let map = this._getWeakMap(keys);
        for(let i = 0; i < keys.length - 1; i++){
            const key = keys[i];
            if (map.has(key) === false) map.set(key, new WeakMap());
            map = map.get(key);
        }
        map.set(keys[keys.length - 1], value);
        return this;
    }
    /**
	 * Deletes a value for the given keys.
	 *
	 * @param {Array<Object>} keys - The keys.
	 * @return {boolean} Returns `true` if the value has been removed successfully and `false` if the value has not be found.
	 */ delete(keys) {
        let map = this._getWeakMap(keys);
        for(let i = 0; i < keys.length - 1; i++){
            map = map.get(keys[i]);
            if (map === undefined) return false;
        }
        return map.delete(keys[keys.length - 1]);
    }
}
let $d89c9137a3d237c2$var$_id$a = 0;
function $d89c9137a3d237c2$var$getKeys(obj) {
    const keys = Object.keys(obj);
    let proto = Object.getPrototypeOf(obj);
    while(proto){
        const descriptors = Object.getOwnPropertyDescriptors(proto);
        for(const key in descriptors)if (descriptors[key] !== undefined) {
            const descriptor = descriptors[key];
            if (descriptor && typeof descriptor.get === 'function') keys.push(key);
        }
        proto = Object.getPrototypeOf(proto);
    }
    return keys;
}
/**
 * A render object is the renderer's representation of single entity that gets drawn
 * with a draw command. There is no unique mapping of render objects to 3D objects in the
 * scene since render objects also depend from the used material, the current render context
 * and the current scene's lighting.
 *
 * In general, the basic process of the renderer is:
 *
 * - Analyze the 3D objects in the scene and generate render lists containing render items.
 * - Process the render lists by calling one or more render commands for each render item.
 * - For each render command, request a render object and perform the draw.
 *
 * The module provides an interface to get data required for the draw command like the actual
 * draw parameters or vertex buffers. It also holds a series of caching related methods since
 * creating render objects should only be done when necessary.
 *
 * @private
 */ class $d89c9137a3d237c2$var$RenderObject {
    /**
	 * Constructs a new render object.
	 *
	 * @param {Nodes} nodes - Renderer component for managing nodes related logic.
	 * @param {Geometries} geometries - Renderer component for managing geometries.
	 * @param {Renderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The 3D object's material.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {LightsNode} lightsNode - The lights node.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 */ constructor(nodes, geometries, renderer, object, material, scene, camera, lightsNode, renderContext, clippingContext){
        this.id = $d89c9137a3d237c2$var$_id$a++;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {Nodes}
		 * @private
		 */ this._nodes = nodes;
        /**
		 * Renderer component for managing geometries.
		 *
		 * @type {Geometries}
		 * @private
		 */ this._geometries = geometries;
        /**
		 * The renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * The 3D object.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The 3D object's material.
		 *
		 * @type {Material}
		 */ this.material = material;
        /**
		 * The scene the 3D object belongs to.
		 *
		 * @type {Scene}
		 */ this.scene = scene;
        /**
		 * The camera the 3D object should be rendered with.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The lights node.
		 *
		 * @type {LightsNode}
		 */ this.lightsNode = lightsNode;
        /**
		 * The render context.
		 *
		 * @type {RenderContext}
		 */ this.context = renderContext;
        /**
		 * The 3D object's geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = object.geometry;
        /**
		 * The render object's version.
		 *
		 * @type {number}
		 */ this.version = material.version;
        /**
		 * The draw range of the geometry.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.drawRange = null;
        /**
		 * An array holding the buffer attributes
		 * of the render object. This entails attribute
		 * definitions on geometry and node level.
		 *
		 * @type {?Array<BufferAttribute>}
		 * @default null
		 */ this.attributes = null;
        /**
		 * An object holding the version of the
		 * attributes. The keys are the attribute names
		 * and the values are the attribute versions.
		 *
		 * @type {?Object<string, number>}
		 * @default null
		 */ this.attributesId = null;
        /**
		 * A reference to a render pipeline the render
		 * object is processed with.
		 *
		 * @type {RenderPipeline}
		 * @default null
		 */ this.pipeline = null;
        /**
		 * Only relevant for objects using
		 * multiple materials. This represents a group entry
		 * from the respective `BufferGeometry`.
		 *
		 * @type {?{start: number, count: number}}
		 * @default null
		 */ this.group = null;
        /**
		 * An array holding the vertex buffers which can
		 * be buffer attributes but also interleaved buffers.
		 *
		 * @type {?Array<BufferAttribute|InterleavedBuffer>}
		 * @default null
		 */ this.vertexBuffers = null;
        /**
		 * The parameters for the draw command.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.drawParams = null;
        /**
		 * If this render object is used inside a render bundle,
		 * this property points to the respective bundle group.
		 *
		 * @type {?BundleGroup}
		 * @default null
		 */ this.bundle = null;
        /**
		 * The clipping context.
		 *
		 * @type {ClippingContext}
		 */ this.clippingContext = clippingContext;
        /**
		 * The clipping context's cache key.
		 *
		 * @type {string}
		 */ this.clippingContextCacheKey = clippingContext !== null ? clippingContext.cacheKey : '';
        /**
		 * The initial node cache key.
		 *
		 * @type {number}
		 */ this.initialNodesCacheKey = this.getDynamicCacheKey();
        /**
		 * The initial cache key.
		 *
		 * @type {number}
		 */ this.initialCacheKey = this.getCacheKey();
        /**
		 * The node builder state.
		 *
		 * @type {?NodeBuilderState}
		 * @private
		 * @default null
		 */ this._nodeBuilderState = null;
        /**
		 * An array of bindings.
		 *
		 * @type {?Array<BindGroup>}
		 * @private
		 * @default null
		 */ this._bindings = null;
        /**
		 * Reference to the node material observer.
		 *
		 * @type {?NodeMaterialObserver}
		 * @private
		 * @default null
		 */ this._monitor = null;
        /**
		 * An event listener which is defined by `RenderObjects`. It performs
		 * clean up tasks when `dispose()` on this render object.
		 *
		 * @method
		 */ this.onDispose = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderObject = true;
        /**
		 * An event listener which is executed when `dispose()` is called on
		 * the material of this render object.
		 *
		 * @method
		 */ this.onMaterialDispose = ()=>{
            this.dispose();
        };
        /**
		 * An event listener which is executed when `dispose()` is called on
		 * the geometry of this render object.
		 *
		 * @method
		 */ this.onGeometryDispose = ()=>{
            // clear geometry cache attributes
            this.attributes = null;
            this.attributesId = null;
        };
        this.material.addEventListener('dispose', this.onMaterialDispose);
        this.geometry.addEventListener('dispose', this.onGeometryDispose);
    }
    /**
	 * Updates the clipping context.
	 *
	 * @param {ClippingContext} context - The clipping context to set.
	 */ updateClipping(context) {
        this.clippingContext = context;
    }
    /**
	 * Whether the clipping requires an update or not.
	 *
	 * @type {boolean}
	 * @readonly
	 */ get clippingNeedsUpdate() {
        if (this.clippingContext === null || this.clippingContext.cacheKey === this.clippingContextCacheKey) return false;
        this.clippingContextCacheKey = this.clippingContext.cacheKey;
        return true;
    }
    /**
	 * The number of clipping planes defined in context of hardware clipping.
	 *
	 * @type {number}
	 * @readonly
	 */ get hardwareClippingPlanes() {
        return this.material.hardwareClipping === true ? this.clippingContext.unionClippingCount : 0;
    }
    /**
	 * Returns the node builder state of this render object.
	 *
	 * @return {NodeBuilderState} The node builder state.
	 */ getNodeBuilderState() {
        return this._nodeBuilderState || (this._nodeBuilderState = this._nodes.getForRender(this));
    }
    /**
	 * Returns the node material observer of this render object.
	 *
	 * @return {NodeMaterialObserver} The node material observer.
	 */ getMonitor() {
        return this._monitor || (this._monitor = this.getNodeBuilderState().observer);
    }
    /**
	 * Returns an array of bind groups of this render object.
	 *
	 * @return {Array<BindGroup>} The bindings.
	 */ getBindings() {
        return this._bindings || (this._bindings = this.getNodeBuilderState().createBindings());
    }
    /**
	 * Returns a binding group by group name of this render object.
	 *
	 * @param {string} name - The name of the binding group.
	 * @return {?BindGroup} The bindings.
	 */ getBindingGroup(name) {
        for (const bindingGroup of this.getBindings()){
            if (bindingGroup.name === name) return bindingGroup;
        }
    }
    /**
	 * Returns the index of the render object's geometry.
	 *
	 * @return {?BufferAttribute} The index. Returns `null` for non-indexed geometries.
	 */ getIndex() {
        return this._geometries.getIndex(this);
    }
    /**
	 * Returns the indirect buffer attribute.
	 *
	 * @return {?BufferAttribute} The indirect attribute. `null` if no indirect drawing is used.
	 */ getIndirect() {
        return this._geometries.getIndirect(this);
    }
    /**
	 * Returns the byte offset into the indirect attribute buffer.
	 *
	 * @return {number|Array<number>} The byte offset into the indirect attribute buffer.
	 */ getIndirectOffset() {
        return this._geometries.getIndirectOffset(this);
    }
    /**
	 * Returns an array that acts as a key for identifying the render object in a chain map.
	 *
	 * @return {Array<Object>} An array with object references.
	 */ getChainArray() {
        return [
            this.object,
            this.material,
            this.context,
            this.lightsNode
        ];
    }
    /**
	 * This method is used when the geometry of a 3D object has been exchanged and the
	 * respective render object now requires an update.
	 *
	 * @param {BufferGeometry} geometry - The geometry to set.
	 */ setGeometry(geometry) {
        this.geometry = geometry;
        this.attributes = null;
        this.attributesId = null;
    }
    /**
	 * Returns the buffer attributes of the render object. The returned array holds
	 * attribute definitions on geometry and node level.
	 *
	 * @return {Array<BufferAttribute>} An array with buffer attributes.
	 */ getAttributes() {
        if (this.attributes !== null) return this.attributes;
        const nodeAttributes = this.getNodeBuilderState().nodeAttributes;
        const geometry = this.geometry;
        const attributes = [];
        const vertexBuffers = new Set();
        const attributesId = {};
        for (const nodeAttribute of nodeAttributes){
            let attribute;
            if (nodeAttribute.node && nodeAttribute.node.attribute) // node attribute
            attribute = nodeAttribute.node.attribute;
            else {
                // geometry attribute
                attribute = geometry.getAttribute(nodeAttribute.name);
                attributesId[nodeAttribute.name] = attribute.version;
            }
            if (attribute === undefined) continue;
            attributes.push(attribute);
            const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
            vertexBuffers.add(bufferAttribute);
        }
        this.attributes = attributes;
        this.attributesId = attributesId;
        this.vertexBuffers = Array.from(vertexBuffers.values());
        return attributes;
    }
    /**
	 * Returns the vertex buffers of the render object.
	 *
	 * @return {Array<BufferAttribute|InterleavedBuffer>} An array with buffer attribute or interleaved buffers.
	 */ getVertexBuffers() {
        if (this.vertexBuffers === null) this.getAttributes();
        return this.vertexBuffers;
    }
    /**
	 * Returns the draw parameters for the render object.
	 *
	 * @return {?{vertexCount: number, firstVertex: number, instanceCount: number, firstInstance: number}} The draw parameters.
	 */ getDrawParameters() {
        const { object: object, material: material, geometry: geometry, group: group, drawRange: drawRange } = this;
        const drawParams = this.drawParams || (this.drawParams = {
            vertexCount: 0,
            firstVertex: 0,
            instanceCount: 0,
            firstInstance: 0
        });
        const index = this.getIndex();
        const hasIndex = index !== null;
        let instanceCount = 1;
        if (geometry.isInstancedBufferGeometry === true) instanceCount = geometry.instanceCount;
        else if (object.count !== undefined) instanceCount = Math.max(0, object.count);
        if (instanceCount === 0) return null;
        drawParams.instanceCount = instanceCount;
        if (object.isBatchedMesh === true) return drawParams;
        let rangeFactor = 1;
        if (material.wireframe === true && !object.isPoints && !object.isLineSegments && !object.isLine && !object.isLineLoop) rangeFactor = 2;
        let firstVertex = drawRange.start * rangeFactor;
        let lastVertex = (drawRange.start + drawRange.count) * rangeFactor;
        if (group !== null) {
            firstVertex = Math.max(firstVertex, group.start * rangeFactor);
            lastVertex = Math.min(lastVertex, (group.start + group.count) * rangeFactor);
        }
        const position = geometry.attributes.position;
        let itemCount = Infinity;
        if (hasIndex) itemCount = index.count;
        else if (position !== undefined && position !== null) itemCount = position.count;
        firstVertex = Math.max(firstVertex, 0);
        lastVertex = Math.min(lastVertex, itemCount);
        const count = lastVertex - firstVertex;
        if (count < 0 || count === Infinity) return null;
        drawParams.vertexCount = count;
        drawParams.firstVertex = firstVertex;
        return drawParams;
    }
    /**
	 * Returns the render object's geometry cache key.
	 *
	 * The geometry cache key is part of the material cache key.
	 *
	 * @return {string} The geometry cache key.
	 */ getGeometryCacheKey() {
        const { geometry: geometry } = this;
        let cacheKey = '';
        for (const name of Object.keys(geometry.attributes).sort()){
            const attribute = geometry.attributes[name];
            cacheKey += name + ',';
            if (attribute.data) cacheKey += attribute.data.stride + ',';
            if (attribute.offset) cacheKey += attribute.offset + ',';
            if (attribute.itemSize) cacheKey += attribute.itemSize + ',';
            if (attribute.normalized) cacheKey += 'n,';
        }
        // structural equality isn't sufficient for morph targets since the
        // data are maintained in textures. only if the targets are all equal
        // the texture and thus the instance of `MorphNode` can be shared.
        for (const name of Object.keys(geometry.morphAttributes).sort()){
            const targets = geometry.morphAttributes[name];
            cacheKey += 'morph-' + name + ',';
            for(let i = 0, l = targets.length; i < l; i++){
                const attribute = targets[i];
                cacheKey += attribute.id + ',';
            }
        }
        if (geometry.index) cacheKey += 'index,';
        return cacheKey;
    }
    /**
	 * Returns the render object's material cache key.
	 *
	 * The material cache key is part of the render object cache key.
	 *
	 * @return {number} The material cache key.
	 */ getMaterialCacheKey() {
        const { object: object, material: material, renderer: renderer } = this;
        let cacheKey = material.customProgramCacheKey();
        for (const property of $d89c9137a3d237c2$var$getKeys(material)){
            if (/^(is[A-Z]|_)|^(visible|version|uuid|name|opacity|userData)$/.test(property)) continue;
            const value = material[property];
            let valueKey;
            if (value !== null) {
                // some material values require a formatting
                const type = typeof value;
                if (type === 'number') valueKey = value !== 0 ? '1' : '0'; // Convert to on/off, important for clearcoat, transmission, etc
                else if (type === 'object') {
                    valueKey = '{';
                    if (value.isTexture) {
                        valueKey += value.mapping;
                        // WebGPU must honor the sampler data because they are part of the bindings
                        if (renderer.backend.isWebGPUBackend === true) {
                            valueKey += value.magFilter;
                            valueKey += value.minFilter;
                            valueKey += value.wrapS;
                            valueKey += value.wrapT;
                            valueKey += value.wrapR;
                        }
                    }
                    valueKey += '}';
                } else valueKey = String(value);
            } else valueKey = String(value);
            cacheKey += /*property + ':' +*/ valueKey + ',';
        }
        cacheKey += this.clippingContextCacheKey + ',';
        if (object.geometry) cacheKey += this.getGeometryCacheKey();
        if (object.skeleton) cacheKey += object.skeleton.bones.length + ',';
        if (object.isBatchedMesh) {
            cacheKey += object._matricesTexture.uuid + ',';
            if (object._colorsTexture !== null) cacheKey += object._colorsTexture.uuid + ',';
        }
        if (object.isInstancedMesh || object.count > 1 || Array.isArray(object.morphTargetInfluences)) // TODO: https://github.com/mrdoob/three.js/pull/29066#issuecomment-2269400850
        cacheKey += object.uuid + ',';
        cacheKey += this.context.id + ',';
        cacheKey += object.receiveShadow + ',';
        return $d89c9137a3d237c2$var$hashString(cacheKey);
    }
    /**
	 * Whether the geometry requires an update or not.
	 *
	 * @type {boolean}
	 * @readonly
	 */ get needsGeometryUpdate() {
        if (this.geometry.id !== this.object.geometry.id) return true;
        if (this.attributes !== null) {
            const attributesId = this.attributesId;
            for(const name in attributesId){
                const attribute = this.geometry.getAttribute(name);
                if (attribute === undefined || attributesId[name] !== attribute.id) return true;
            }
        }
        return false;
    }
    /**
	 * Whether the render object requires an update or not.
	 *
	 * Note: There are two distinct places where render objects are checked for an update.
	 *
	 * 1. In `RenderObjects.get()` which is executed when the render object is request. This
	 * method checks the `needsUpdate` flag and recreates the render object if necessary.
	 * 2. In `Renderer._renderObjectDirect()` right after getting the render object via
	 * `RenderObjects.get()`. The render object's NodeMaterialObserver is then used to detect
	 * a need for a refresh due to material, geometry or object related value changes.
	 *
	 * TODO: Investigate if it's possible to merge both steps so there is only a single place
	 * that performs the 'needsUpdate' check.
	 *
	 * @type {boolean}
	 * @readonly
	 */ get needsUpdate() {
        return /*this.object.static !== true &&*/ this.initialNodesCacheKey !== this.getDynamicCacheKey() || this.clippingNeedsUpdate;
    }
    /**
	 * Returns the dynamic cache key which represents a key that is computed per draw command.
	 *
	 * @return {number} The cache key.
	 */ getDynamicCacheKey() {
        let cacheKey = 0;
        // `Nodes.getCacheKey()` returns an environment cache key which is not relevant when
        // the renderer is inside a shadow pass.
        if (this.material.isShadowPassMaterial !== true) cacheKey = this._nodes.getCacheKey(this.scene, this.lightsNode);
        if (this.camera.isArrayCamera) cacheKey = $d89c9137a3d237c2$var$hash$1(cacheKey, this.camera.cameras.length);
        if (this.object.receiveShadow) cacheKey = $d89c9137a3d237c2$var$hash$1(cacheKey, 1);
        cacheKey = $d89c9137a3d237c2$var$hash$1(cacheKey, this.camera.id, this.renderer.contextNode.id, this.renderer.contextNode.version);
        return cacheKey;
    }
    /**
	 * Returns the render object's cache key.
	 *
	 * @return {number} The cache key.
	 */ getCacheKey() {
        return this.getMaterialCacheKey() + this.getDynamicCacheKey();
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this.material.removeEventListener('dispose', this.onMaterialDispose);
        this.geometry.removeEventListener('dispose', this.onGeometryDispose);
        this.onDispose();
    }
}
const $d89c9137a3d237c2$var$_chainKeys$5 = [];
/**
 * This module manages the render objects of the renderer.
 *
 * @private
 */ class $d89c9137a3d237c2$var$RenderObjects {
    /**
	 * Constructs a new render object management component.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {Nodes} nodes - Renderer component for managing nodes related logic.
	 * @param {Geometries} geometries - Renderer component for managing geometries.
	 * @param {Pipelines} pipelines - Renderer component for managing pipelines.
	 * @param {Bindings} bindings - Renderer component for managing bindings.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(renderer, nodes, geometries, pipelines, bindings, info){
        /**
		 * The renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {Nodes}
		 */ this.nodes = nodes;
        /**
		 * Renderer component for managing geometries.
		 *
		 * @type {Geometries}
		 */ this.geometries = geometries;
        /**
		 * Renderer component for managing pipelines.
		 *
		 * @type {Pipelines}
		 */ this.pipelines = pipelines;
        /**
		 * Renderer component for managing bindings.
		 *
		 * @type {Bindings}
		 */ this.bindings = bindings;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
        /**
		 * A dictionary that manages render contexts in chain maps
		 * for each pass ID.
		 *
		 * @type {Object<string,ChainMap>}
		 */ this.chainMaps = {};
    }
    /**
	 * Returns a render object for the given object and state data.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The 3D object's material.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the 3D object should be rendered with.
	 * @param {LightsNode} lightsNode - The lights node.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 * @param {string} [passId] - An optional ID for identifying the pass.
	 * @return {RenderObject} The render object.
	 */ get(object, material, scene, camera, lightsNode, renderContext, clippingContext, passId) {
        const chainMap = this.getChainMap(passId);
        // reuse chainArray
        $d89c9137a3d237c2$var$_chainKeys$5[0] = object;
        $d89c9137a3d237c2$var$_chainKeys$5[1] = material;
        $d89c9137a3d237c2$var$_chainKeys$5[2] = renderContext;
        $d89c9137a3d237c2$var$_chainKeys$5[3] = lightsNode;
        let renderObject = chainMap.get($d89c9137a3d237c2$var$_chainKeys$5);
        if (renderObject === undefined) {
            renderObject = this.createRenderObject(this.nodes, this.geometries, this.renderer, object, material, scene, camera, lightsNode, renderContext, clippingContext, passId);
            chainMap.set($d89c9137a3d237c2$var$_chainKeys$5, renderObject);
        } else {
            renderObject.updateClipping(clippingContext);
            if (renderObject.needsGeometryUpdate) renderObject.setGeometry(object.geometry);
            if (renderObject.version !== material.version || renderObject.needsUpdate) {
                if (renderObject.initialCacheKey !== renderObject.getCacheKey()) {
                    renderObject.dispose();
                    renderObject = this.get(object, material, scene, camera, lightsNode, renderContext, clippingContext, passId);
                } else renderObject.version = material.version;
            }
        }
        $d89c9137a3d237c2$var$_chainKeys$5.length = 0;
        return renderObject;
    }
    /**
	 * Returns a chain map for the given pass ID.
	 *
	 * @param {string} [passId='default'] - The pass ID.
	 * @return {ChainMap} The chain map.
	 */ getChainMap(passId = 'default') {
        return this.chainMaps[passId] || (this.chainMaps[passId] = new $d89c9137a3d237c2$var$ChainMap());
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this.chainMaps = {};
    }
    /**
	 * Factory method for creating render objects with the given list of parameters.
	 *
	 * @param {Nodes} nodes - Renderer component for managing nodes related logic.
	 * @param {Geometries} geometries - Renderer component for managing geometries.
	 * @param {Renderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The object's material.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {LightsNode} lightsNode - The lights node.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 * @param {string} [passId] - An optional ID for identifying the pass.
	 * @return {RenderObject} The render object.
	 */ createRenderObject(nodes, geometries, renderer, object, material, scene, camera, lightsNode, renderContext, clippingContext, passId) {
        const chainMap = this.getChainMap(passId);
        const renderObject = new $d89c9137a3d237c2$var$RenderObject(nodes, geometries, renderer, object, material, scene, camera, lightsNode, renderContext, clippingContext);
        renderObject.onDispose = ()=>{
            this.pipelines.delete(renderObject);
            this.bindings.deleteForRender(renderObject);
            this.nodes.delete(renderObject);
            chainMap.delete(renderObject.getChainArray());
        };
        return renderObject;
    }
}
/**
 * Data structure for the renderer. It is intended to manage
 * data of objects in dictionaries.
 *
 * @private
 */ class $d89c9137a3d237c2$var$DataMap {
    /**
	 * Constructs a new data map.
	 */ constructor(){
        /**
		 * `DataMap` internally uses a weak map
		 * to manage its data.
		 *
		 * @type {WeakMap<Object, Object>}
		 */ this.data = new WeakMap();
    }
    /**
	 * Returns the dictionary for the given object.
	 *
	 * @param {Object} object - The object.
	 * @return {Object} The dictionary.
	 */ get(object) {
        let map = this.data.get(object);
        if (map === undefined) {
            map = {};
            this.data.set(object, map);
        }
        return map;
    }
    /**
	 * Deletes the dictionary for the given object.
	 *
	 * @param {Object} object - The object.
	 * @return {?Object} The deleted dictionary.
	 */ delete(object) {
        let map = null;
        if (this.data.has(object)) {
            map = this.data.get(object);
            this.data.delete(object);
        }
        return map;
    }
    /**
	 * Returns `true` if the given object has a dictionary defined.
	 *
	 * @param {Object} object - The object to test.
	 * @return {boolean} Whether a dictionary is defined or not.
	 */ has(object) {
        return this.data.has(object);
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this.data = new WeakMap();
    }
}
const $d89c9137a3d237c2$var$AttributeType = {
    VERTEX: 1,
    INDEX: 2,
    STORAGE: 3,
    INDIRECT: 4
};
// size of a chunk in bytes (STD140 layout)
const $d89c9137a3d237c2$var$GPU_CHUNK_BYTES = 16;
// @TODO: Move to src/constants.js
const $d89c9137a3d237c2$var$BlendColorFactor = 211;
const $d89c9137a3d237c2$var$OneMinusBlendColorFactor = 212;
/**
 * This renderer module manages geometry attributes.
 *
 * @private
 * @augments DataMap
 */ class $d89c9137a3d237c2$var$Attributes extends $d89c9137a3d237c2$var$DataMap {
    /**
	 * Constructs a new attribute management component.
	 *
	 * @param {Backend} backend - The renderer's backend.
	 */ constructor(backend){
        super();
        /**
		 * The renderer's backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
    }
    /**
	 * Deletes the data for the given attribute.
	 *
	 * @param {BufferAttribute} attribute - The attribute.
	 * @return {?Object} The deleted attribute data.
	 */ delete(attribute) {
        const attributeData = super.delete(attribute);
        if (attributeData !== null) this.backend.destroyAttribute(attribute);
        return attributeData;
    }
    /**
	 * Updates the given attribute. This method creates attribute buffers
	 * for new attributes and updates data for existing ones.
	 *
	 * @param {BufferAttribute} attribute - The attribute to update.
	 * @param {number} type - The attribute type.
	 */ update(attribute, type) {
        const data = this.get(attribute);
        if (data.version === undefined) {
            if (type === $d89c9137a3d237c2$var$AttributeType.VERTEX) this.backend.createAttribute(attribute);
            else if (type === $d89c9137a3d237c2$var$AttributeType.INDEX) this.backend.createIndexAttribute(attribute);
            else if (type === $d89c9137a3d237c2$var$AttributeType.STORAGE) this.backend.createStorageAttribute(attribute);
            else if (type === $d89c9137a3d237c2$var$AttributeType.INDIRECT) this.backend.createIndirectStorageAttribute(attribute);
            data.version = this._getBufferAttribute(attribute).version;
        } else {
            const bufferAttribute = this._getBufferAttribute(attribute);
            if (data.version < bufferAttribute.version || bufferAttribute.usage === (0, $329ek.DynamicDrawUsage)) {
                this.backend.updateAttribute(attribute);
                data.version = bufferAttribute.version;
            }
        }
    }
    /**
	 * Utility method for handling interleaved buffer attributes correctly.
	 * To process them, their `InterleavedBuffer` is returned.
	 *
	 * @param {BufferAttribute} attribute - The attribute.
	 * @return {BufferAttribute|InterleavedBuffer}
	 */ _getBufferAttribute(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return attribute;
    }
}
/**
 * Returns the wireframe version for the given geometry.
 *
 * @private
 * @function
 * @param {BufferGeometry} geometry - The geometry.
 * @return {number} The version.
 */ function $d89c9137a3d237c2$var$getWireframeVersion(geometry) {
    return geometry.index !== null ? geometry.index.version : geometry.attributes.position.version;
}
/**
 * Returns a wireframe index attribute for the given geometry.
 *
 * @private
 * @function
 * @param {BufferGeometry} geometry - The geometry.
 * @return {BufferAttribute} The wireframe index attribute.
 */ function $d89c9137a3d237c2$var$getWireframeIndex(geometry) {
    const indices = [];
    const geometryIndex = geometry.index;
    const geometryPosition = geometry.attributes.position;
    if (geometryIndex !== null) {
        const array = geometryIndex.array;
        for(let i = 0, l = array.length; i < l; i += 3){
            const a = array[i + 0];
            const b = array[i + 1];
            const c = array[i + 2];
            indices.push(a, b, b, c, c, a);
        }
    } else {
        const array = geometryPosition.array;
        for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
            const a = i + 0;
            const b = i + 1;
            const c = i + 2;
            indices.push(a, b, b, c, c, a);
        }
    }
    const attribute = new ((0, $329ek.arrayNeedsUint32)(indices) ? (0, $329ek.Uint32BufferAttribute) : (0, $329ek.Uint16BufferAttribute))(indices, 1);
    attribute.version = $d89c9137a3d237c2$var$getWireframeVersion(geometry);
    return attribute;
}
/**
 * This renderer module manages geometries.
 *
 * @private
 * @augments DataMap
 */ class $d89c9137a3d237c2$var$Geometries extends $d89c9137a3d237c2$var$DataMap {
    /**
	 * Constructs a new geometry management component.
	 *
	 * @param {Attributes} attributes - Renderer component for managing attributes.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(attributes, info){
        super();
        /**
		 * Renderer component for managing attributes.
		 *
		 * @type {Attributes}
		 */ this.attributes = attributes;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
        /**
		 * Weak Map for managing attributes for wireframe rendering.
		 *
		 * @type {WeakMap<BufferGeometry,BufferAttribute>}
		 */ this.wireframes = new WeakMap();
        /**
		 * This Weak Map is used to make sure buffer attributes are
		 * updated only once per render call.
		 *
		 * @type {WeakMap<BufferAttribute,number>}
		 */ this.attributeCall = new WeakMap();
        /**
		 * Stores the event listeners attached to geometries.
		 *
		 * @private
		 * @type {Map<BufferGeometry,Function>}
		 */ this._geometryDisposeListeners = new Map();
    }
    /**
	 * Returns `true` if the given render object has an initialized geometry.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether if the given render object has an initialized geometry or not.
	 */ has(renderObject) {
        const geometry = renderObject.geometry;
        return super.has(geometry) && this.get(geometry).initialized === true;
    }
    /**
	 * Prepares the geometry of the given render object for rendering.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateForRender(renderObject) {
        if (this.has(renderObject) === false) this.initGeometry(renderObject);
        this.updateAttributes(renderObject);
    }
    /**
	 * Initializes the geometry of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ initGeometry(renderObject) {
        const geometry = renderObject.geometry;
        const geometryData = this.get(geometry);
        geometryData.initialized = true;
        this.info.memory.geometries++;
        const onDispose = ()=>{
            this.info.memory.geometries--;
            const index = geometry.index;
            const geometryAttributes = renderObject.getAttributes();
            if (index !== null) this.attributes.delete(index);
            for (const geometryAttribute of geometryAttributes)this.attributes.delete(geometryAttribute);
            const wireframeAttribute = this.wireframes.get(geometry);
            if (wireframeAttribute !== undefined) this.attributes.delete(wireframeAttribute);
            geometry.removeEventListener('dispose', onDispose);
            this._geometryDisposeListeners.delete(geometry);
        };
        geometry.addEventListener('dispose', onDispose);
        // see #31798 why tracking separate remove listeners is required right now
        // TODO: Re-evaluate how onDispose() is managed in this component
        this._geometryDisposeListeners.set(geometry, onDispose);
    }
    /**
	 * Updates the geometry attributes of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateAttributes(renderObject) {
        // attributes
        const attributes = renderObject.getAttributes();
        for (const attribute of attributes)if (attribute.isStorageBufferAttribute || attribute.isStorageInstancedBufferAttribute) this.updateAttribute(attribute, $d89c9137a3d237c2$var$AttributeType.STORAGE);
        else this.updateAttribute(attribute, $d89c9137a3d237c2$var$AttributeType.VERTEX);
        // indexes
        const index = this.getIndex(renderObject);
        if (index !== null) this.updateAttribute(index, $d89c9137a3d237c2$var$AttributeType.INDEX);
        // indirect
        const indirect = renderObject.geometry.indirect;
        if (indirect !== null) this.updateAttribute(indirect, $d89c9137a3d237c2$var$AttributeType.INDIRECT);
    }
    /**
	 * Updates the given attribute.
	 *
	 * @param {BufferAttribute} attribute - The attribute to update.
	 * @param {number} type - The attribute type.
	 */ updateAttribute(attribute, type) {
        const callId = this.info.render.calls;
        if (!attribute.isInterleavedBufferAttribute) {
            if (this.attributeCall.get(attribute) !== callId) {
                this.attributes.update(attribute, type);
                this.attributeCall.set(attribute, callId);
            }
        } else {
            if (this.attributeCall.get(attribute) === undefined) {
                this.attributes.update(attribute, type);
                this.attributeCall.set(attribute, callId);
            } else if (this.attributeCall.get(attribute.data) !== callId) {
                this.attributes.update(attribute, type);
                this.attributeCall.set(attribute.data, callId);
                this.attributeCall.set(attribute, callId);
            }
        }
    }
    /**
	 * Returns the indirect buffer attribute of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {?BufferAttribute} The indirect attribute. `null` if no indirect drawing is used.
	 */ getIndirect(renderObject) {
        return renderObject.geometry.indirect;
    }
    /**
	 * Returns the byte offset into the indirect attribute buffer of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {number} The byte offset into the indirect attribute buffer.
	 */ getIndirectOffset(renderObject) {
        return renderObject.geometry.indirectOffset;
    }
    /**
	 * Returns the index of the given render object's geometry. This is implemented
	 * in a method to return a wireframe index if necessary.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {?BufferAttribute} The index. Returns `null` for non-indexed geometries.
	 */ getIndex(renderObject) {
        const { geometry: geometry, material: material } = renderObject;
        let index = geometry.index;
        if (material.wireframe === true) {
            const wireframes = this.wireframes;
            let wireframeAttribute = wireframes.get(geometry);
            if (wireframeAttribute === undefined) {
                wireframeAttribute = $d89c9137a3d237c2$var$getWireframeIndex(geometry);
                wireframes.set(geometry, wireframeAttribute);
            } else if (wireframeAttribute.version !== $d89c9137a3d237c2$var$getWireframeVersion(geometry)) {
                this.attributes.delete(wireframeAttribute);
                wireframeAttribute = $d89c9137a3d237c2$var$getWireframeIndex(geometry);
                wireframes.set(geometry, wireframeAttribute);
            }
            index = wireframeAttribute;
        }
        return index;
    }
    dispose() {
        for (const [geometry, onDispose] of this._geometryDisposeListeners.entries())geometry.removeEventListener('dispose', onDispose);
        this._geometryDisposeListeners.clear();
    }
}
/**
 * This renderer module provides a series of statistical information
 * about the GPU memory and the rendering process. Useful for debugging
 * and monitoring.
 */ class $d89c9137a3d237c2$var$Info {
    /**
	 * Constructs a new info component.
	 */ constructor(){
        /**
		 * Whether frame related metrics should automatically
		 * be resetted or not. This property should be set to `false`
		 * by apps which manage their own animation loop. They must
		 * then call `renderer.info.reset()` once per frame manually.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoReset = true;
        /**
		 * The current frame ID. This ID is managed
		 * by `NodeFrame`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.frame = 0;
        /**
		 * The number of render calls since the
		 * app has been started.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.calls = 0;
        /**
		 * Render related metrics.
		 *
		 * @type {Object}
		 * @readonly
		 * @property {number} calls - The number of render calls since the app has been started.
		 * @property {number} frameCalls - The number of render calls of the current frame.
		 * @property {number} drawCalls - The number of draw calls of the current frame.
		 * @property {number} triangles - The number of rendered triangle primitives of the current frame.
		 * @property {number} points - The number of rendered point primitives of the current frame.
		 * @property {number} lines - The number of rendered line primitives of the current frame.
		 * @property {number} timestamp - The timestamp of the frame.
		 */ this.render = {
            calls: 0,
            frameCalls: 0,
            drawCalls: 0,
            triangles: 0,
            points: 0,
            lines: 0,
            timestamp: 0
        };
        /**
		 * Compute related metrics.
		 *
		 * @type {Object}
		 * @readonly
		 * @property {number} calls - The number of compute calls since the app has been started.
		 * @property {number} frameCalls - The number of compute calls of the current frame.
		 * @property {number} timestamp - The timestamp of the frame when using `renderer.computeAsync()`.
		 */ this.compute = {
            calls: 0,
            frameCalls: 0,
            timestamp: 0
        };
        /**
		 * Memory related metrics.
		 *
		 * @type {Object}
		 * @readonly
		 * @property {number} geometries - The number of active geometries.
		 * @property {number} frameCalls - The number of active textures.
		 */ this.memory = {
            geometries: 0,
            textures: 0
        };
    }
    /**
	 * This method should be executed per draw call and updates the corresponding metrics.
	 *
	 * @param {Object3D} object - The 3D object that is going to be rendered.
	 * @param {number} count - The vertex or index count.
	 * @param {number} instanceCount - The instance count.
	 */ update(object, count, instanceCount) {
        this.render.drawCalls++;
        if (object.isMesh || object.isSprite) this.render.triangles += instanceCount * (count / 3);
        else if (object.isPoints) this.render.points += instanceCount * count;
        else if (object.isLineSegments) this.render.lines += instanceCount * (count / 2);
        else if (object.isLine) this.render.lines += instanceCount * (count - 1);
        else (0, $329ek.error)('WebGPUInfo: Unknown object type.');
    }
    /**
	 * Resets frame related metrics.
	 */ reset() {
        this.render.drawCalls = 0;
        this.render.frameCalls = 0;
        this.compute.frameCalls = 0;
        this.render.triangles = 0;
        this.render.points = 0;
        this.render.lines = 0;
    }
    /**
	 * Performs a complete reset of the object.
	 */ dispose() {
        this.reset();
        this.calls = 0;
        this.render.calls = 0;
        this.compute.calls = 0;
        this.render.timestamp = 0;
        this.compute.timestamp = 0;
        this.memory.geometries = 0;
        this.memory.textures = 0;
    }
}
/**
 * Abstract class for representing pipelines.
 *
 * @private
 * @abstract
 */ class $d89c9137a3d237c2$var$Pipeline {
    /**
	 * Constructs a new pipeline.
	 *
	 * @param {string} cacheKey - The pipeline's cache key.
	 */ constructor(cacheKey){
        /**
		 * The pipeline's cache key.
		 *
		 * @type {string}
		 */ this.cacheKey = cacheKey;
        /**
		 * How often the pipeline is currently in use.
		 *
		 * @type {number}
		 * @default 0
		 */ this.usedTimes = 0;
    }
}
/**
 * Class for representing render pipelines.
 *
 * @private
 * @augments Pipeline
 */ class $d89c9137a3d237c2$var$RenderPipeline extends $d89c9137a3d237c2$var$Pipeline {
    /**
	 * Constructs a new render pipeline.
	 *
	 * @param {string} cacheKey - The pipeline's cache key.
	 * @param {ProgrammableStage} vertexProgram - The pipeline's vertex shader.
	 * @param {ProgrammableStage} fragmentProgram - The pipeline's fragment shader.
	 */ constructor(cacheKey, vertexProgram, fragmentProgram){
        super(cacheKey);
        /**
		 * The pipeline's vertex shader.
		 *
		 * @type {ProgrammableStage}
		 */ this.vertexProgram = vertexProgram;
        /**
		 * The pipeline's fragment shader.
		 *
		 * @type {ProgrammableStage}
		 */ this.fragmentProgram = fragmentProgram;
    }
}
/**
 * Class for representing compute pipelines.
 *
 * @private
 * @augments Pipeline
 */ class $d89c9137a3d237c2$var$ComputePipeline extends $d89c9137a3d237c2$var$Pipeline {
    /**
	 * Constructs a new render pipeline.
	 *
	 * @param {string} cacheKey - The pipeline's cache key.
	 * @param {ProgrammableStage} computeProgram - The pipeline's compute shader.
	 */ constructor(cacheKey, computeProgram){
        super(cacheKey);
        /**
		 * The pipeline's compute shader.
		 *
		 * @type {ProgrammableStage}
		 */ this.computeProgram = computeProgram;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isComputePipeline = true;
    }
}
let $d89c9137a3d237c2$var$_id$9 = 0;
/**
 * Class for representing programmable stages which are vertex,
 * fragment or compute shaders. Unlike fixed-function states (like blending),
 * they represent the programmable part of a pipeline.
 *
 * @private
 */ class $d89c9137a3d237c2$var$ProgrammableStage {
    /**
	 * Constructs a new programmable stage.
	 *
	 * @param {string} code - The shader code.
	 * @param {('vertex'|'fragment'|'compute')} stage - The type of stage.
	 * @param {string} name - The name of the shader.
	 * @param {?Array<Object>} [transforms=null] - The transforms (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
	 * @param {?Array<Object>} [attributes=null] - The attributes (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
	 */ constructor(code, stage, name, transforms = null, attributes = null){
        /**
		 * The id of the programmable stage.
		 *
		 * @type {number}
		 */ this.id = $d89c9137a3d237c2$var$_id$9++;
        /**
		 * The shader code.
		 *
		 * @type {string}
		 */ this.code = code;
        /**
		 * The type of stage.
		 *
		 * @type {string}
		 */ this.stage = stage;
        /**
		 * The name of the stage.
		 * This is used for debugging purposes.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The transforms (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
		 *
		 * @type {?Array<Object>}
		 */ this.transforms = transforms;
        /**
		 * The attributes (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
		 *
		 * @type {?Array<Object>}
		 */ this.attributes = attributes;
        /**
		 * How often the programmable stage is currently in use.
		 *
		 * @type {number}
		 * @default 0
		 */ this.usedTimes = 0;
    }
}
/**
 * This renderer module manages the pipelines of the renderer.
 *
 * @private
 * @augments DataMap
 */ class $d89c9137a3d237c2$var$Pipelines extends $d89c9137a3d237c2$var$DataMap {
    /**
	 * Constructs a new pipeline management component.
	 *
	 * @param {Backend} backend - The renderer's backend.
	 * @param {Nodes} nodes - Renderer component for managing nodes related logic.
	 */ constructor(backend, nodes){
        super();
        /**
		 * The renderer's backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {Nodes}
		 */ this.nodes = nodes;
        /**
		 * A references to the bindings management component.
		 * This reference will be set inside the `Bindings`
		 * constructor.
		 *
		 * @type {?Bindings}
		 * @default null
		 */ this.bindings = null;
        /**
		 * Internal cache for maintaining pipelines.
		 * The key of the map is a cache key, the value the pipeline.
		 *
		 * @type {Map<string,Pipeline>}
		 */ this.caches = new Map();
        /**
		 * This dictionary maintains for each shader stage type (vertex,
		 * fragment and compute) the programmable stage objects which
		 * represent the actual shader code.
		 *
		 * @type {Object<string,Map<string, ProgrammableStage>>}
		 */ this.programs = {
            vertex: new Map(),
            fragment: new Map(),
            compute: new Map()
        };
    }
    /**
	 * Returns a compute pipeline for the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @return {ComputePipeline} The compute pipeline.
	 */ getForCompute(computeNode, bindings) {
        const { backend: backend } = this;
        const data = this.get(computeNode);
        if (this._needsComputeUpdate(computeNode)) {
            const previousPipeline = data.pipeline;
            if (previousPipeline) {
                previousPipeline.usedTimes--;
                previousPipeline.computeProgram.usedTimes--;
            }
            // get shader
            const nodeBuilderState = this.nodes.getForCompute(computeNode);
            // programmable stage
            let stageCompute = this.programs.compute.get(nodeBuilderState.computeShader);
            if (stageCompute === undefined) {
                if (previousPipeline && previousPipeline.computeProgram.usedTimes === 0) this._releaseProgram(previousPipeline.computeProgram);
                stageCompute = new $d89c9137a3d237c2$var$ProgrammableStage(nodeBuilderState.computeShader, 'compute', computeNode.name, nodeBuilderState.transforms, nodeBuilderState.nodeAttributes);
                this.programs.compute.set(nodeBuilderState.computeShader, stageCompute);
                backend.createProgram(stageCompute);
            }
            // determine compute pipeline
            const cacheKey = this._getComputeCacheKey(computeNode, stageCompute);
            let pipeline = this.caches.get(cacheKey);
            if (pipeline === undefined) {
                if (previousPipeline && previousPipeline.usedTimes === 0) this._releasePipeline(previousPipeline);
                pipeline = this._getComputePipeline(computeNode, stageCompute, cacheKey, bindings);
            }
            // keep track of all used times
            pipeline.usedTimes++;
            stageCompute.usedTimes++;
            //
            data.version = computeNode.version;
            data.pipeline = pipeline;
        }
        return data.pipeline;
    }
    /**
	 * Returns a render pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {?Array<Promise>} [promises=null] - An array of compilation promises which is only relevant in context of `Renderer.compileAsync()`.
	 * @return {RenderPipeline} The render pipeline.
	 */ getForRender(renderObject, promises = null) {
        const { backend: backend } = this;
        const data = this.get(renderObject);
        if (this._needsRenderUpdate(renderObject)) {
            const previousPipeline = data.pipeline;
            if (previousPipeline) {
                previousPipeline.usedTimes--;
                previousPipeline.vertexProgram.usedTimes--;
                previousPipeline.fragmentProgram.usedTimes--;
            }
            // get shader
            const nodeBuilderState = renderObject.getNodeBuilderState();
            const name = renderObject.material ? renderObject.material.name : '';
            // programmable stages
            let stageVertex = this.programs.vertex.get(nodeBuilderState.vertexShader);
            if (stageVertex === undefined) {
                if (previousPipeline && previousPipeline.vertexProgram.usedTimes === 0) this._releaseProgram(previousPipeline.vertexProgram);
                stageVertex = new $d89c9137a3d237c2$var$ProgrammableStage(nodeBuilderState.vertexShader, 'vertex', name);
                this.programs.vertex.set(nodeBuilderState.vertexShader, stageVertex);
                backend.createProgram(stageVertex);
            }
            let stageFragment = this.programs.fragment.get(nodeBuilderState.fragmentShader);
            if (stageFragment === undefined) {
                if (previousPipeline && previousPipeline.fragmentProgram.usedTimes === 0) this._releaseProgram(previousPipeline.fragmentProgram);
                stageFragment = new $d89c9137a3d237c2$var$ProgrammableStage(nodeBuilderState.fragmentShader, 'fragment', name);
                this.programs.fragment.set(nodeBuilderState.fragmentShader, stageFragment);
                backend.createProgram(stageFragment);
            }
            // determine render pipeline
            const cacheKey = this._getRenderCacheKey(renderObject, stageVertex, stageFragment);
            let pipeline = this.caches.get(cacheKey);
            if (pipeline === undefined) {
                if (previousPipeline && previousPipeline.usedTimes === 0) this._releasePipeline(previousPipeline);
                pipeline = this._getRenderPipeline(renderObject, stageVertex, stageFragment, cacheKey, promises);
            } else renderObject.pipeline = pipeline;
            // keep track of all used times
            pipeline.usedTimes++;
            stageVertex.usedTimes++;
            stageFragment.usedTimes++;
            //
            data.pipeline = pipeline;
        }
        return data.pipeline;
    }
    /**
	 * Deletes the pipeline for the given render object.
	 *
	 * @param {RenderObject} object - The render object.
	 * @return {?Object} The deleted dictionary.
	 */ delete(object) {
        const pipeline = this.get(object).pipeline;
        if (pipeline) {
            // pipeline
            pipeline.usedTimes--;
            if (pipeline.usedTimes === 0) this._releasePipeline(pipeline);
            // programs
            if (pipeline.isComputePipeline) {
                pipeline.computeProgram.usedTimes--;
                if (pipeline.computeProgram.usedTimes === 0) this._releaseProgram(pipeline.computeProgram);
            } else {
                pipeline.fragmentProgram.usedTimes--;
                pipeline.vertexProgram.usedTimes--;
                if (pipeline.vertexProgram.usedTimes === 0) this._releaseProgram(pipeline.vertexProgram);
                if (pipeline.fragmentProgram.usedTimes === 0) this._releaseProgram(pipeline.fragmentProgram);
            }
        }
        return super.delete(object);
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        super.dispose();
        this.caches = new Map();
        this.programs = {
            vertex: new Map(),
            fragment: new Map(),
            compute: new Map()
        };
    }
    /**
	 * Updates the pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateForRender(renderObject) {
        this.getForRender(renderObject);
    }
    /**
	 * Returns a compute pipeline for the given parameters.
	 *
	 * @private
	 * @param {Node} computeNode - The compute node.
	 * @param {ProgrammableStage} stageCompute - The programmable stage representing the compute shader.
	 * @param {string} cacheKey - The cache key.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @return {ComputePipeline} The compute pipeline.
	 */ _getComputePipeline(computeNode, stageCompute, cacheKey, bindings) {
        // check for existing pipeline
        cacheKey = cacheKey || this._getComputeCacheKey(computeNode, stageCompute);
        let pipeline = this.caches.get(cacheKey);
        if (pipeline === undefined) {
            pipeline = new $d89c9137a3d237c2$var$ComputePipeline(cacheKey, stageCompute);
            this.caches.set(cacheKey, pipeline);
            this.backend.createComputePipeline(pipeline, bindings);
        }
        return pipeline;
    }
    /**
	 * Returns a render pipeline for the given parameters.
	 *
	 * @private
	 * @param {RenderObject} renderObject - The render object.
	 * @param {ProgrammableStage} stageVertex - The programmable stage representing the vertex shader.
	 * @param {ProgrammableStage} stageFragment - The programmable stage representing the fragment shader.
	 * @param {string} cacheKey - The cache key.
	 * @param {?Array<Promise>} promises - An array of compilation promises which is only relevant in context of `Renderer.compileAsync()`.
	 * @return {ComputePipeline} The compute pipeline.
	 */ _getRenderPipeline(renderObject, stageVertex, stageFragment, cacheKey, promises) {
        // check for existing pipeline
        cacheKey = cacheKey || this._getRenderCacheKey(renderObject, stageVertex, stageFragment);
        let pipeline = this.caches.get(cacheKey);
        if (pipeline === undefined) {
            pipeline = new $d89c9137a3d237c2$var$RenderPipeline(cacheKey, stageVertex, stageFragment);
            this.caches.set(cacheKey, pipeline);
            renderObject.pipeline = pipeline;
            // The `promises` array is `null` by default and only set to an empty array when
            // `Renderer.compileAsync()` is used. The next call actually fills the array with
            // pending promises that resolve when the render pipelines are ready for rendering.
            this.backend.createRenderPipeline(renderObject, promises);
        }
        return pipeline;
    }
    /**
	 * Computes a cache key representing a compute pipeline.
	 *
	 * @private
	 * @param {Node} computeNode - The compute node.
	 * @param {ProgrammableStage} stageCompute - The programmable stage representing the compute shader.
	 * @return {string} The cache key.
	 */ _getComputeCacheKey(computeNode, stageCompute) {
        return computeNode.id + ',' + stageCompute.id;
    }
    /**
	 * Computes a cache key representing a render pipeline.
	 *
	 * @private
	 * @param {RenderObject} renderObject - The render object.
	 * @param {ProgrammableStage} stageVertex - The programmable stage representing the vertex shader.
	 * @param {ProgrammableStage} stageFragment - The programmable stage representing the fragment shader.
	 * @return {string} The cache key.
	 */ _getRenderCacheKey(renderObject, stageVertex, stageFragment) {
        return stageVertex.id + ',' + stageFragment.id + ',' + this.backend.getRenderCacheKey(renderObject);
    }
    /**
	 * Releases the given pipeline.
	 *
	 * @private
	 * @param {Pipeline} pipeline - The pipeline to release.
	 */ _releasePipeline(pipeline) {
        this.caches.delete(pipeline.cacheKey);
    }
    /**
	 * Releases the shader program.
	 *
	 * @private
	 * @param {Object} program - The shader program to release.
	 */ _releaseProgram(program) {
        const code = program.code;
        const stage = program.stage;
        this.programs[stage].delete(code);
    }
    /**
	 * Returns `true` if the compute pipeline for the given compute node requires an update.
	 *
	 * @private
	 * @param {Node} computeNode - The compute node.
	 * @return {boolean} Whether the compute pipeline for the given compute node requires an update or not.
	 */ _needsComputeUpdate(computeNode) {
        const data = this.get(computeNode);
        return data.pipeline === undefined || data.version !== computeNode.version;
    }
    /**
	 * Returns `true` if the render pipeline for the given render object requires an update.
	 *
	 * @private
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the render object for the given render object requires an update or not.
	 */ _needsRenderUpdate(renderObject) {
        const data = this.get(renderObject);
        return data.pipeline === undefined || this.backend.needsRenderUpdate(renderObject);
    }
}
/**
 * This renderer module manages the bindings of the renderer.
 *
 * @private
 * @augments DataMap
 */ class $d89c9137a3d237c2$var$Bindings extends $d89c9137a3d237c2$var$DataMap {
    /**
	 * Constructs a new bindings management component.
	 *
	 * @param {Backend} backend - The renderer's backend.
	 * @param {Nodes} nodes - Renderer component for managing nodes related logic.
	 * @param {Textures} textures - Renderer component for managing textures.
	 * @param {Attributes} attributes - Renderer component for managing attributes.
	 * @param {Pipelines} pipelines - Renderer component for managing pipelines.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(backend, nodes, textures, attributes, pipelines, info){
        super();
        /**
		 * The renderer's backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
        /**
		 * Renderer component for managing textures.
		 *
		 * @type {Textures}
		 */ this.textures = textures;
        /**
		 * Renderer component for managing pipelines.
		 *
		 * @type {Pipelines}
		 */ this.pipelines = pipelines;
        /**
		 * Renderer component for managing attributes.
		 *
		 * @type {Attributes}
		 */ this.attributes = attributes;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {Nodes}
		 */ this.nodes = nodes;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
        this.pipelines.bindings = this; // assign bindings to pipelines
    }
    /**
	 * Returns the bind groups for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {Array<BindGroup>} The bind groups.
	 */ getForRender(renderObject) {
        const bindings = renderObject.getBindings();
        for (const bindGroup of bindings){
            const groupData = this.get(bindGroup);
            if (groupData.bindGroup === undefined) {
                // each object defines an array of bindings (ubos, textures, samplers etc.)
                this._init(bindGroup);
                this.backend.createBindings(bindGroup, bindings, 0);
                groupData.bindGroup = bindGroup;
            }
        }
        return bindings;
    }
    /**
	 * Returns the bind groups for the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 * @return {Array<BindGroup>} The bind groups.
	 */ getForCompute(computeNode) {
        const bindings = this.nodes.getForCompute(computeNode).bindings;
        for (const bindGroup of bindings){
            const groupData = this.get(bindGroup);
            if (groupData.bindGroup === undefined) {
                this._init(bindGroup);
                this.backend.createBindings(bindGroup, bindings, 0);
                groupData.bindGroup = bindGroup;
            }
        }
        return bindings;
    }
    /**
	 * Updates the bindings for the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 */ updateForCompute(computeNode) {
        this._updateBindings(this.getForCompute(computeNode));
    }
    /**
	 * Updates the bindings for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateForRender(renderObject) {
        this._updateBindings(this.getForRender(renderObject));
    }
    /**
	 * Deletes the bindings for the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 */ deleteForCompute(computeNode) {
        const bindings = this.nodes.getForCompute(computeNode).bindings;
        for (const bindGroup of bindings){
            this.backend.deleteBindGroupData(bindGroup);
            this.delete(bindGroup);
        }
    }
    /**
	 * Deletes the bindings for the given renderObject node.
	 *
	 * @param {RenderObject} renderObject - The renderObject.
	 */ deleteForRender(renderObject) {
        const bindings = renderObject.getBindings();
        for (const bindGroup of bindings){
            this.backend.deleteBindGroupData(bindGroup);
            this.delete(bindGroup);
        }
    }
    /**
	 * Updates the given array of bindings.
	 *
	 * @param {Array<BindGroup>} bindings - The bind groups.
	 */ _updateBindings(bindings) {
        for (const bindGroup of bindings)this._update(bindGroup, bindings);
    }
    /**
	 * Initializes the given bind group.
	 *
	 * @param {BindGroup} bindGroup - The bind group to initialize.
	 */ _init(bindGroup) {
        for (const binding of bindGroup.bindings){
            if (binding.isSampledTexture) this.textures.updateTexture(binding.texture);
            else if (binding.isSampler) this.textures.updateSampler(binding.texture);
            else if (binding.isStorageBuffer) {
                const attribute = binding.attribute;
                const attributeType = attribute.isIndirectStorageBufferAttribute ? $d89c9137a3d237c2$var$AttributeType.INDIRECT : $d89c9137a3d237c2$var$AttributeType.STORAGE;
                this.attributes.update(attribute, attributeType);
            }
        }
    }
    /**
	 * Updates the given bind group.
	 *
	 * @param {BindGroup} bindGroup - The bind group to update.
	 * @param {Array<BindGroup>} bindings - The bind groups.
	 */ _update(bindGroup, bindings) {
        const { backend: backend } = this;
        let needsBindingsUpdate = false;
        let cacheBindings = true;
        let cacheIndex = 0;
        let version = 0;
        // iterate over all bindings and check if buffer updates or a new binding group is required
        for (const binding of bindGroup.bindings){
            const updatedGroup = this.nodes.updateGroup(binding);
            // every uniforms group is a uniform buffer. So if no update is required,
            // we move one with the next binding. Otherwise the next if block will update the group.
            if (updatedGroup === false) continue;
            //
            if (binding.isStorageBuffer) {
                const attribute = binding.attribute;
                const attributeType = attribute.isIndirectStorageBufferAttribute ? $d89c9137a3d237c2$var$AttributeType.INDIRECT : $d89c9137a3d237c2$var$AttributeType.STORAGE;
                this.attributes.update(attribute, attributeType);
            }
            if (binding.isUniformBuffer) {
                const updated = binding.update();
                if (updated) backend.updateBinding(binding);
            } else if (binding.isSampledTexture) {
                const updated = binding.update();
                // get the texture data after the update, to sync the texture reference from node
                const texture = binding.texture;
                const texturesTextureData = this.textures.get(texture);
                if (updated) {
                    // version: update the texture data or create a new one
                    this.textures.updateTexture(texture);
                    // generation: update the bindings if a new texture has been created
                    if (binding.generation !== texturesTextureData.generation) {
                        binding.generation = texturesTextureData.generation;
                        needsBindingsUpdate = true;
                        cacheBindings = false;
                    }
                }
                const textureData = backend.get(texture);
                if (textureData.externalTexture !== undefined || texturesTextureData.isDefaultTexture) cacheBindings = false;
                else {
                    cacheIndex = cacheIndex * 10 + texture.id;
                    version += texture.version;
                }
                if (texture.isStorageTexture === true && texture.mipmapsAutoUpdate === true) {
                    const textureData = this.get(texture);
                    if (binding.store === true) textureData.needsMipmap = true;
                    else if (this.textures.needsMipmaps(texture) && textureData.needsMipmap === true) {
                        this.backend.generateMipmaps(texture);
                        textureData.needsMipmap = false;
                    }
                }
            } else if (binding.isSampler) {
                const updated = binding.update();
                if (updated) {
                    const samplerKey = this.textures.updateSampler(binding.texture);
                    if (binding.samplerKey !== samplerKey) {
                        binding.samplerKey = samplerKey;
                        needsBindingsUpdate = true;
                        cacheBindings = false;
                    }
                }
            }
        }
        if (needsBindingsUpdate === true) this.backend.updateBindings(bindGroup, bindings, cacheBindings ? cacheIndex : 0, version);
    }
}
/**
 * Default sorting function for opaque render items.
 *
 * @private
 * @function
 * @param {Object} a - The first render item.
 * @param {Object} b - The second render item.
 * @return {number} A numeric value which defines the sort order.
 */ function $d89c9137a3d237c2$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
/**
 * Default sorting function for transparent render items.
 *
 * @private
 * @function
 * @param {Object} a - The first render item.
 * @param {Object} b - The second render item.
 * @return {number} A numeric value which defines the sort order.
 */ function $d89c9137a3d237c2$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
/**
 * Returns `true` if the given transparent material requires a double pass.
 *
 * @private
 * @function
 * @param {Material} material - The transparent material.
 * @return {boolean} Whether the given material requires a double pass or not.
 */ function $d89c9137a3d237c2$var$needsDoublePass(material) {
    const hasTransmission = material.transmission > 0 || material.transmissionNode && material.transmissionNode.isNode;
    return hasTransmission && material.side === (0, $329ek.DoubleSide) && material.forceSinglePass === false;
}
/**
 * When the renderer analyzes the scene at the beginning of a render call,
 * it stores 3D object for further processing in render lists. Depending on the
 * properties of a 3D objects (like their transformation or material state), the
 * objects are maintained in ordered lists for the actual rendering.
 *
 * Render lists are unique per scene and camera combination.
 *
 * @private
 * @augments Pipeline
 */ class $d89c9137a3d237c2$var$RenderList {
    /**
	 * Constructs a render list.
	 *
	 * @param {Lighting} lighting - The lighting management component.
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera the scene is rendered with.
	 */ constructor(lighting, scene, camera){
        /**
		 * 3D objects are transformed into render items and stored in this array.
		 *
		 * @type {Array<Object>}
		 */ this.renderItems = [];
        /**
		 * The current render items index.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderItemsIndex = 0;
        /**
		 * A list with opaque render items.
		 *
		 * @type {Array<Object>}
		 */ this.opaque = [];
        /**
		 * A list with transparent render items which require
		 * double pass rendering (e.g. transmissive objects).
		 *
		 * @type {Array<Object>}
		 */ this.transparentDoublePass = [];
        /**
		 * A list with transparent render items.
		 *
		 * @type {Array<Object>}
		 */ this.transparent = [];
        /**
		 * A list with transparent render bundle data.
		 *
		 * @type {Array<Object>}
		 */ this.bundles = [];
        /**
		 * The render list's lights node. This node is later
		 * relevant for the actual analytical light nodes which
		 * compute the scene's lighting in the shader.
		 *
		 * @type {LightsNode}
		 */ this.lightsNode = lighting.getNode(scene, camera);
        /**
		 * The scene's lights stored in an array. This array
		 * is used to setup the lights node.
		 *
		 * @type {Array<Light>}
		 */ this.lightsArray = [];
        /**
		 * The scene.
		 *
		 * @type {Scene}
		 */ this.scene = scene;
        /**
		 * The camera the scene is rendered with.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * How many objects perform occlusion query tests.
		 *
		 * @type {number}
		 * @default 0
		 */ this.occlusionQueryCount = 0;
    }
    /**
	 * This method is called right at the beginning of a render call
	 * before the scene is analyzed. It prepares the internal data
	 * structures for the upcoming render lists generation.
	 *
	 * @return {RenderList} A reference to this render list.
	 */ begin() {
        this.renderItemsIndex = 0;
        this.opaque.length = 0;
        this.transparentDoublePass.length = 0;
        this.transparent.length = 0;
        this.bundles.length = 0;
        this.lightsArray.length = 0;
        this.occlusionQueryCount = 0;
        return this;
    }
    /**
	 * Returns a render item for the giving render item state. The state is defined
	 * by a series of object-related parameters.
	 *
	 * The method avoids object creation by holding render items and reusing them in
	 * subsequent render calls (just with different property values).
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {number} groupOrder - The current group order.
	 * @param {number} z - Th 3D object's depth value (z value in clip space).
	 * @param {?number} group - {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {ClippingContext} clippingContext - The current clipping context.
	 * @return {Object} The render item.
	 */ getNextRenderItem(object, geometry, material, groupOrder, z, group, clippingContext) {
        let renderItem = this.renderItems[this.renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group,
                clippingContext: clippingContext
            };
            this.renderItems[this.renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
            renderItem.clippingContext = clippingContext;
        }
        this.renderItemsIndex++;
        return renderItem;
    }
    /**
	 * Pushes the given object as a render item to the internal render lists.
	 * The selected lists depend on the object properties.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {number} groupOrder - The current group order.
	 * @param {number} z - Th 3D object's depth value (z value in clip space).
	 * @param {?number} group - {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {ClippingContext} clippingContext - The current clipping context.
	 */ push(object, geometry, material, groupOrder, z, group, clippingContext) {
        const renderItem = this.getNextRenderItem(object, geometry, material, groupOrder, z, group, clippingContext);
        if (object.occlusionTest === true) this.occlusionQueryCount++;
        if (material.transparent === true || material.transmission > 0 || material.transmissionNode && material.transmissionNode.isNode || material.backdropNode && material.backdropNode.isNode) {
            if ($d89c9137a3d237c2$var$needsDoublePass(material)) this.transparentDoublePass.push(renderItem);
            this.transparent.push(renderItem);
        } else this.opaque.push(renderItem);
    }
    /**
	 * Inserts the given object as a render item at the start of the internal render lists.
	 * The selected lists depend on the object properties.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {number} groupOrder - The current group order.
	 * @param {number} z - Th 3D object's depth value (z value in clip space).
	 * @param {?number} group - {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {ClippingContext} clippingContext - The current clipping context.
	 */ unshift(object, geometry, material, groupOrder, z, group, clippingContext) {
        const renderItem = this.getNextRenderItem(object, geometry, material, groupOrder, z, group, clippingContext);
        if (material.transparent === true || material.transmission > 0 || material.transmissionNode && material.transmissionNode.isNode || material.backdropNode && material.backdropNode.isNode) {
            if ($d89c9137a3d237c2$var$needsDoublePass(material)) this.transparentDoublePass.unshift(renderItem);
            this.transparent.unshift(renderItem);
        } else this.opaque.unshift(renderItem);
    }
    /**
	 * Pushes render bundle group data into the render list.
	 *
	 * @param {Object} group - Bundle group data.
	 */ pushBundle(group) {
        this.bundles.push(group);
    }
    /**
	 * Pushes a light into the render list.
	 *
	 * @param {Light} light - The light.
	 */ pushLight(light) {
        this.lightsArray.push(light);
    }
    /**
	 * Sorts the internal render lists.
	 *
	 * @param {?function(any, any): number} customOpaqueSort - A custom sort function for opaque objects.
	 * @param {?function(any, any): number} customTransparentSort -  A custom sort function for transparent objects.
	 */ sort(customOpaqueSort, customTransparentSort) {
        if (this.opaque.length > 1) this.opaque.sort(customOpaqueSort || $d89c9137a3d237c2$var$painterSortStable);
        if (this.transparentDoublePass.length > 1) this.transparentDoublePass.sort(customTransparentSort || $d89c9137a3d237c2$var$reversePainterSortStable);
        if (this.transparent.length > 1) this.transparent.sort(customTransparentSort || $d89c9137a3d237c2$var$reversePainterSortStable);
    }
    /**
	 * This method performs finalizing tasks right after the render lists
	 * have been generated.
	 */ finish() {
        // update lights
        this.lightsNode.setLights(this.lightsArray);
        // Clear references from inactive renderItems in the list
        for(let i = this.renderItemsIndex, il = this.renderItems.length; i < il; i++){
            const renderItem = this.renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.groupOrder = null;
            renderItem.renderOrder = null;
            renderItem.z = null;
            renderItem.group = null;
            renderItem.clippingContext = null;
        }
    }
}
const $d89c9137a3d237c2$var$_chainKeys$4 = [];
/**
 * This renderer module manages the render lists which are unique
 * per scene and camera combination.
 *
 * @private
 */ class $d89c9137a3d237c2$var$RenderLists {
    /**
	 * Constructs a render lists management component.
	 *
	 * @param {Lighting} lighting - The lighting management component.
	 */ constructor(lighting){
        /**
		 * The lighting management component.
		 *
		 * @type {Lighting}
		 */ this.lighting = lighting;
        /**
		 * The internal chain map which holds the render lists.
		 *
		 * @type {ChainMap}
		 */ this.lists = new $d89c9137a3d237c2$var$ChainMap();
    }
    /**
	 * Returns a render list for the given scene and camera.
	 *
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera.
	 * @return {RenderList} The render list.
	 */ get(scene, camera) {
        const lists = this.lists;
        $d89c9137a3d237c2$var$_chainKeys$4[0] = scene;
        $d89c9137a3d237c2$var$_chainKeys$4[1] = camera;
        let list = lists.get($d89c9137a3d237c2$var$_chainKeys$4);
        if (list === undefined) {
            list = new $d89c9137a3d237c2$var$RenderList(this.lighting, scene, camera);
            lists.set($d89c9137a3d237c2$var$_chainKeys$4, list);
        }
        $d89c9137a3d237c2$var$_chainKeys$4.length = 0;
        return list;
    }
    /**
	 * Frees all internal resources.
	 */ dispose() {
        this.lists = new $d89c9137a3d237c2$var$ChainMap();
    }
}
let $d89c9137a3d237c2$var$_id$8 = 0;
/**
 * Any render or compute command is executed in a specific context that defines
 * the state of the renderer and its backend. Typical examples for such context
 * data are the current clear values or data from the active framebuffer. This
 * module is used to represent these contexts as objects.
 *
 * @private
 */ class $d89c9137a3d237c2$var$RenderContext {
    /**
	 * Constructs a new render context.
	 */ constructor(){
        /**
		 * The context's ID.
		 *
		 * @type {number}
		 */ this.id = $d89c9137a3d237c2$var$_id$8++;
        /**
		 * Whether the current active framebuffer has a color attachment.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.color = true;
        /**
		 * Whether the color attachment should be cleared or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.clearColor = true;
        /**
		 * The clear color value.
		 *
		 * @type {Object}
		 * @default true
		 */ this.clearColorValue = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        /**
		 * Whether the current active framebuffer has a depth attachment.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depth = true;
        /**
		 * Whether the depth attachment should be cleared or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.clearDepth = true;
        /**
		 * The clear depth value.
		 *
		 * @type {number}
		 * @default 1
		 */ this.clearDepthValue = 1;
        /**
		 * Whether the current active framebuffer has a stencil attachment.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencil = false;
        /**
		 * Whether the stencil attachment should be cleared or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.clearStencil = true;
        /**
		 * The clear stencil value.
		 *
		 * @type {number}
		 * @default 1
		 */ this.clearStencilValue = 1;
        /**
		 * By default the viewport encloses the entire framebuffer If a smaller
		 * viewport is manually defined, this property is to `true` by the renderer.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.viewport = false;
        /**
		 * The viewport value. This value is in physical pixels meaning it incorporates
		 * the renderer's pixel ratio. The viewport property of render targets or
		 * the renderer is in logical pixels.
		 *
		 * @type {Vector4}
		 */ this.viewportValue = new (0, $329ek.Vector4)();
        /**
		 * When the scissor test is active and scissor rectangle smaller than the
		 * framebuffers dimensions, this property is to `true` by the renderer.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.scissor = false;
        /**
		 * The scissor rectangle.
		 *
		 * @type {Vector4}
		 */ this.scissorValue = new (0, $329ek.Vector4)();
        /**
		 * The active render target.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.renderTarget = null;
        /**
		 * The textures of the active render target.
		 * `null` when no render target is set.
		 *
		 * @type {?Array<Texture>}
		 * @default null
		 */ this.textures = null;
        /**
		 * The depth texture of the active render target.
		 * `null` when no render target is set.
		 *
		 * @type {?DepthTexture}
		 * @default null
		 */ this.depthTexture = null;
        /**
		 * The active cube face.
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeCubeFace = 0;
        /**
		 * The active mipmap level.
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeMipmapLevel = 0;
        /**
		 * The number of MSAA samples. This value is always `1` when
		 * MSAA isn't used.
		 *
		 * @type {number}
		 * @default 1
		 */ this.sampleCount = 1;
        /**
		 * The active render target's width in physical pixels.
		 *
		 * @type {number}
		 * @default 0
		 */ this.width = 0;
        /**
		 * The active render target's height in physical pixels.
		 *
		 * @type {number}
		 * @default 0
		 */ this.height = 0;
        /**
		 * The occlusion query count.
		 *
		 * @type {number}
		 * @default 0
		 */ this.occlusionQueryCount = 0;
        /**
		 * The current clipping context.
		 *
		 * @type {?ClippingContext}
		 * @default null
		 */ this.clippingContext = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderContext = true;
    }
    /**
	 * Returns the cache key of this render context.
	 *
	 * @return {number} The cache key.
	 */ getCacheKey() {
        return $d89c9137a3d237c2$var$getCacheKey(this);
    }
}
/**
 * Computes a cache key for the given render context. This key
 * should identify the render target state so it is possible to
 * configure the correct attachments in the respective backend.
 *
 * @param {RenderContext} renderContext - The render context.
 * @return {number} The cache key.
 */ function $d89c9137a3d237c2$var$getCacheKey(renderContext) {
    const { textures: textures, activeCubeFace: activeCubeFace, activeMipmapLevel: activeMipmapLevel } = renderContext;
    const values = [
        activeCubeFace,
        activeMipmapLevel
    ];
    for (const texture of textures)values.push(texture.id);
    return $d89c9137a3d237c2$var$hashArray(values);
}
const $d89c9137a3d237c2$var$_chainKeys$3 = [];
const $d89c9137a3d237c2$var$_defaultScene = /*@__PURE__*/ new (0, $329ek.Scene)();
const $d89c9137a3d237c2$var$_defaultCamera = /*@__PURE__*/ new (0, $329ek.Camera)();
/**
 * This module manages the render contexts of the renderer.
 *
 * @private
 */ class $d89c9137a3d237c2$var$RenderContexts {
    /**
	 * Constructs a new render context management component.
	 */ constructor(){
        /**
		 * A dictionary that manages render contexts in chain maps
		 * for each attachment state.
		 *
		 * @type {Object<string,ChainMap>}
		 */ this.chainMaps = {};
    }
    /**
	 * Returns a render context for the given scene, camera and render target.
	 *
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {?RenderTarget} [renderTarget=null] - The active render target.
	 * @param {?MRT} [mrt=null] - The active multiple render target.
	 * @return {RenderContext} The render context.
	 */ get(scene, camera, renderTarget = null, mrt = null) {
        $d89c9137a3d237c2$var$_chainKeys$3[0] = scene;
        $d89c9137a3d237c2$var$_chainKeys$3[1] = camera;
        if (mrt !== null) $d89c9137a3d237c2$var$_chainKeys$3[2] = mrt;
        let attachmentState;
        if (renderTarget === null) attachmentState = 'default';
        else {
            const format = renderTarget.texture.format;
            const count = renderTarget.textures.length;
            attachmentState = `${count}:${format}:${renderTarget.samples}:${renderTarget.depthBuffer}:${renderTarget.stencilBuffer}`;
        }
        const chainMap = this._getChainMap(attachmentState);
        let renderState = chainMap.get($d89c9137a3d237c2$var$_chainKeys$3);
        if (renderState === undefined) {
            renderState = new $d89c9137a3d237c2$var$RenderContext();
            chainMap.set($d89c9137a3d237c2$var$_chainKeys$3, renderState);
        }
        $d89c9137a3d237c2$var$_chainKeys$3.length = 0;
        if (renderTarget !== null) renderState.sampleCount = renderTarget.samples === 0 ? 1 : renderTarget.samples;
        return renderState;
    }
    /**
	 * Returns a render context intended for clear operations.
	 *
	 * @param {?RenderTarget} [renderTarget=null] - The active render target.
	 * @return {RenderContext} The render context.
	 */ getForClear(renderTarget = null) {
        return this.get($d89c9137a3d237c2$var$_defaultScene, $d89c9137a3d237c2$var$_defaultCamera, renderTarget);
    }
    /**
	 * Returns a chain map for the given attachment state.
	 *
	 * @private
	 * @param {string} attachmentState - The attachment state.
	 * @return {ChainMap} The chain map.
	 */ _getChainMap(attachmentState) {
        return this.chainMaps[attachmentState] || (this.chainMaps[attachmentState] = new $d89c9137a3d237c2$var$ChainMap());
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this.chainMaps = {};
    }
}
const $d89c9137a3d237c2$var$_size$3 = /*@__PURE__*/ new (0, $329ek.Vector3)();
/**
 * This module manages the textures of the renderer.
 *
 * @private
 * @augments DataMap
 */ class $d89c9137a3d237c2$var$Textures extends $d89c9137a3d237c2$var$DataMap {
    /**
	 * Constructs a new texture management component.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {Backend} backend - The renderer's backend.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(renderer, backend, info){
        super();
        /**
		 * The renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * The backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
    }
    /**
	 * Updates the given render target. Based on the given render target configuration,
	 * it updates the texture states representing the attachments of the framebuffer.
	 *
	 * @param {RenderTarget} renderTarget - The render target to update.
	 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
	 */ updateRenderTarget(renderTarget, activeMipmapLevel = 0) {
        const renderTargetData = this.get(renderTarget);
        const sampleCount = renderTarget.samples === 0 ? 1 : renderTarget.samples;
        const depthTextureMips = renderTargetData.depthTextureMips || (renderTargetData.depthTextureMips = {});
        const textures = renderTarget.textures;
        const size = this.getSize(textures[0]);
        const mipWidth = size.width >> activeMipmapLevel;
        const mipHeight = size.height >> activeMipmapLevel;
        let depthTexture = renderTarget.depthTexture || depthTextureMips[activeMipmapLevel];
        const useDepthTexture = renderTarget.depthBuffer === true || renderTarget.stencilBuffer === true;
        let textureNeedsUpdate = false;
        if (depthTexture === undefined && useDepthTexture) {
            depthTexture = new (0, $329ek.DepthTexture)();
            depthTexture.format = renderTarget.stencilBuffer ? (0, $329ek.DepthStencilFormat) : (0, $329ek.DepthFormat);
            depthTexture.type = renderTarget.stencilBuffer ? (0, $329ek.UnsignedInt248Type) : (0, $329ek.UnsignedIntType); // FloatType
            depthTexture.image.width = mipWidth;
            depthTexture.image.height = mipHeight;
            depthTexture.image.depth = size.depth;
            depthTexture.renderTarget = renderTarget;
            depthTexture.isArrayTexture = renderTarget.multiview === true && size.depth > 1;
            depthTextureMips[activeMipmapLevel] = depthTexture;
        }
        if (renderTargetData.width !== size.width || size.height !== renderTargetData.height) {
            textureNeedsUpdate = true;
            if (depthTexture) {
                depthTexture.needsUpdate = true;
                depthTexture.image.width = mipWidth;
                depthTexture.image.height = mipHeight;
                depthTexture.image.depth = depthTexture.isArrayTexture ? depthTexture.image.depth : 1;
            }
        }
        renderTargetData.width = size.width;
        renderTargetData.height = size.height;
        renderTargetData.textures = textures;
        renderTargetData.depthTexture = depthTexture || null;
        renderTargetData.depth = renderTarget.depthBuffer;
        renderTargetData.stencil = renderTarget.stencilBuffer;
        renderTargetData.renderTarget = renderTarget;
        if (renderTargetData.sampleCount !== sampleCount) {
            textureNeedsUpdate = true;
            if (depthTexture) depthTexture.needsUpdate = true;
            renderTargetData.sampleCount = sampleCount;
        }
        //
        const options = {
            sampleCount: sampleCount
        };
        // XR render targets require no texture updates
        if (renderTarget.isXRRenderTarget !== true) {
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                if (textureNeedsUpdate) texture.needsUpdate = true;
                this.updateTexture(texture, options);
            }
            if (depthTexture) this.updateTexture(depthTexture, options);
        }
        // dispose handler
        if (renderTargetData.initialized !== true) {
            renderTargetData.initialized = true;
            // dispose
            renderTargetData.onDispose = ()=>{
                this._destroyRenderTarget(renderTarget);
            };
            renderTarget.addEventListener('dispose', renderTargetData.onDispose);
        }
    }
    /**
	 * Updates the given texture. Depending on the texture state, this method
	 * triggers the upload of texture data to the GPU memory. If the texture data are
	 * not yet ready for the upload, it uses default texture data for as a placeholder.
	 *
	 * @param {Texture} texture - The texture to update.
	 * @param {Object} [options={}] - The options.
	 */ updateTexture(texture, options = {}) {
        const textureData = this.get(texture);
        if (textureData.initialized === true && textureData.version === texture.version) return;
        const isRenderTarget = texture.isRenderTargetTexture || texture.isDepthTexture || texture.isFramebufferTexture;
        const backend = this.backend;
        if (isRenderTarget && textureData.initialized === true) // it's an update
        backend.destroyTexture(texture);
        //
        if (texture.isFramebufferTexture) {
            const renderTarget = this.renderer.getRenderTarget();
            if (renderTarget) texture.type = renderTarget.texture.type;
            else texture.type = (0, $329ek.UnsignedByteType);
        }
        //
        const { width: width, height: height, depth: depth } = this.getSize(texture);
        options.width = width;
        options.height = height;
        options.depth = depth;
        options.needsMipmaps = this.needsMipmaps(texture);
        options.levels = options.needsMipmaps ? this.getMipLevels(texture, width, height) : 1;
        // TODO: Uniformly handle mipmap definitions
        // Normal textures and compressed cube textures define base level + mips with their mipmap array
        // Uncompressed cube textures use their mipmap array only for mips (no base level)
        if (texture.isCubeTexture && texture.mipmaps.length > 0) options.levels++;
        //
        if (isRenderTarget || texture.isStorageTexture === true || texture.isExternalTexture === true) {
            backend.createTexture(texture, options);
            textureData.generation = texture.version;
        } else if (texture.version > 0) {
            const image = texture.image;
            if (image === undefined) (0, $329ek.warn)('Renderer: Texture marked for update but image is undefined.');
            else if (image.complete === false) (0, $329ek.warn)('Renderer: Texture marked for update but image is incomplete.');
            else {
                if (texture.images) {
                    const images = [];
                    for (const image of texture.images)images.push(image);
                    options.images = images;
                } else options.image = image;
                if (textureData.isDefaultTexture === undefined || textureData.isDefaultTexture === true) {
                    backend.createTexture(texture, options);
                    textureData.isDefaultTexture = false;
                    textureData.generation = texture.version;
                }
                if (texture.source.dataReady === true) backend.updateTexture(texture, options);
                const skipAutoGeneration = texture.isStorageTexture === true && texture.mipmapsAutoUpdate === false;
                if (options.needsMipmaps && texture.mipmaps.length === 0 && !skipAutoGeneration) backend.generateMipmaps(texture);
                if (texture.onUpdate) texture.onUpdate(texture);
            }
        } else {
            // async update
            backend.createDefaultTexture(texture);
            textureData.isDefaultTexture = true;
            textureData.generation = texture.version;
        }
        // dispose handler
        if (textureData.initialized !== true) {
            textureData.initialized = true;
            textureData.generation = texture.version;
            //
            this.info.memory.textures++;
            //
            if (texture.isVideoTexture && (0, $329ek.ColorManagement).enabled === true && (0, $329ek.ColorManagement).getTransfer(texture.colorSpace) !== (0, $329ek.SRGBTransfer)) (0, $329ek.warn)('WebGPURenderer: Video textures must use a color space with a sRGB transfer function, e.g. SRGBColorSpace.');
            // dispose
            textureData.onDispose = ()=>{
                this._destroyTexture(texture);
            };
            texture.addEventListener('dispose', textureData.onDispose);
        }
        //
        textureData.version = texture.version;
    }
    /**
	 * Updates the sampler for the given texture. This method has no effect
	 * for the WebGL backend since it has no concept of samplers. Texture
	 * parameters are configured with the `texParameter()` command for each
	 * texture.
	 *
	 * In WebGPU, samplers are objects like textures and it's possible to share
	 * them when the texture parameters match.
	 *
	 * @param {Texture} texture - The texture to update the sampler for.
	 * @return {string} The current sampler key.
	 */ updateSampler(texture) {
        return this.backend.updateSampler(texture);
    }
    /**
	 * Computes the size of the given texture and writes the result
	 * into the target vector. This vector is also returned by the
	 * method.
	 *
	 * If no texture data are available for the compute yet, the method
	 * returns default size values.
	 *
	 * @param {Texture} texture - The texture to compute the size for.
	 * @param {Vector3} target - The target vector.
	 * @return {Vector3} The target vector.
	 */ getSize(texture, target = $d89c9137a3d237c2$var$_size$3) {
        let image = texture.images ? texture.images[0] : texture.image;
        if (image) {
            if (image.image !== undefined) image = image.image;
            if (typeof HTMLVideoElement !== 'undefined' && image instanceof HTMLVideoElement) {
                target.width = image.videoWidth || 1;
                target.height = image.videoHeight || 1;
                target.depth = 1;
            } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                target.width = image.displayWidth || 1;
                target.height = image.displayHeight || 1;
                target.depth = 1;
            } else {
                target.width = image.width || 1;
                target.height = image.height || 1;
                target.depth = texture.isCubeTexture ? 6 : image.depth || 1;
            }
        } else target.width = target.height = target.depth = 1;
        return target;
    }
    /**
	 * Computes the number of mipmap levels for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} width - The texture's width.
	 * @param {number} height - The texture's height.
	 * @return {number} The number of mipmap levels.
	 */ getMipLevels(texture, width, height) {
        let mipLevelCount;
        if (texture.mipmaps.length > 0) mipLevelCount = texture.mipmaps.length;
        else if (texture.isCompressedTexture === true) // it is not possible to compute mipmaps for compressed textures. So
        // when no mipmaps are defined in "texture.mipmaps", force a texture
        // level of 1
        mipLevelCount = 1;
        else mipLevelCount = Math.floor(Math.log2(Math.max(width, height))) + 1;
        return mipLevelCount;
    }
    /**
	 * Returns `true` if the given texture makes use of mipmapping.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {boolean} Whether mipmaps are required or not.
	 */ needsMipmaps(texture) {
        return texture.generateMipmaps === true || texture.mipmaps.length > 0;
    }
    /**
	 * Frees internal resources when the given render target isn't
	 * required anymore.
	 *
	 * @param {RenderTarget} renderTarget - The render target to destroy.
	 */ _destroyRenderTarget(renderTarget) {
        if (this.has(renderTarget) === true) {
            const renderTargetData = this.get(renderTarget);
            const textures = renderTargetData.textures;
            const depthTexture = renderTargetData.depthTexture;
            //
            renderTarget.removeEventListener('dispose', renderTargetData.onDispose);
            //
            for(let i = 0; i < textures.length; i++)this._destroyTexture(textures[i]);
            if (depthTexture) this._destroyTexture(depthTexture);
            this.delete(renderTarget);
            this.backend.delete(renderTarget);
        }
    }
    /**
	 * Frees internal resource when the given texture isn't
	 * required anymore.
	 *
	 * @param {Texture} texture - The texture to destroy.
	 */ _destroyTexture(texture) {
        if (this.has(texture) === true) {
            const textureData = this.get(texture);
            //
            texture.removeEventListener('dispose', textureData.onDispose);
            // if a texture is not ready for use, it falls back to a default texture so it's possible
            // to use it for rendering. If a texture in this state is disposed, it's important to
            // not destroy/delete the underlying GPU texture object since it is cached and shared with
            // other textures.
            const isDefaultTexture = textureData.isDefaultTexture;
            this.backend.destroyTexture(texture, isDefaultTexture);
            this.delete(texture);
            this.info.memory.textures--;
        }
    }
}
/**
 * A four-component version of {@link Color} which is internally
 * used by the renderer to represents clear color with alpha as
 * one object.
 *
 * @private
 * @augments Color
 */ class $d89c9137a3d237c2$var$Color4 extends (0, $329ek.Color) {
    /**
	 * Constructs a new four-component color.
	 * You can also pass a single THREE.Color, hex or
	 * string argument to this constructor.
	 *
	 * @param {number|string} [r=1] - The red value.
	 * @param {number} [g=1] - The green value.
	 * @param {number} [b=1] - The blue value.
	 * @param {number} [a=1] - The alpha value.
	 */ constructor(r, g, b, a = 1){
        super(r, g, b);
        this.a = a;
    }
    /**
	 * Overwrites the default to honor alpha.
	 * You can also pass a single THREE.Color, hex or
	 * string argument to this method.
	 *
	 * @param {number|string|Color} r - The red value.
	 * @param {number} [g] - The green value.
	 * @param {number} [b] - The blue value.
	 * @param {number} [a=1] - The alpha value.
	 * @return {Color4} A reference to this object.
	 */ set(r, g, b, a = 1) {
        this.a = a;
        return super.set(r, g, b);
    }
    /**
	 * Overwrites the default to honor alpha.
	 *
	 * @param {Color4} color - The color to copy.
	 * @return {Color4} A reference to this object.
	 */ copy(color) {
        if (color.a !== undefined) this.a = color.a;
        return super.copy(color);
    }
    /**
	 * Overwrites the default to honor alpha.
	 *
	 * @return {Color4} The cloned color.
	 */ clone() {
        return new this.constructor(this.r, this.g, this.b, this.a);
    }
}
/**
 * Special version of {@link PropertyNode} which is used for parameters.
 *
 * @augments PropertyNode
 */ class $d89c9137a3d237c2$export$4b5f01ba1aca62ad extends $d89c9137a3d237c2$export$c87c56924d182f24 {
    static get type() {
        return 'ParameterNode';
    }
    /**
	 * Constructs a new parameter node.
	 *
	 * @param {string} nodeType - The type of the node.
	 * @param {?string} [name=null] - The name of the parameter in the shader.
	 */ constructor(nodeType, name = null){
        super(nodeType, name);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isParameterNode = true;
    }
    /**
	 * Gets the type of a member variable in the parameter node.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @param {string} name - The name of the member variable.
	 * @returns {string}
	 */ getMemberType(builder, name) {
        const type = this.getNodeType(builder);
        const struct = builder.getStructTypeNode(type);
        let memberType;
        if (struct !== null) memberType = struct.getMemberType(builder, name);
        else {
            (0, $329ek.error)(`TSL: Member "${name}" not found in struct "${type}".`);
            memberType = 'float';
        }
        return memberType;
    }
    getHash() {
        return this.uuid;
    }
    generate() {
        return this.name;
    }
}
/**
 * TSL function for creating a parameter node.
 *
 * @tsl
 * @function
 * @param {string} type - The type of the node.
 * @param {?string} name - The name of the parameter in the shader.
 * @returns {ParameterNode}
 */ const $d89c9137a3d237c2$var$parameter = (type, name)=>new $d89c9137a3d237c2$export$4b5f01ba1aca62ad(type, name);
/**
 * Stack is a helper for Nodes that need to produce stack-based code instead of continuous flow.
 * They are usually needed in cases like `If`, `Else`.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$6e11d1e78715185c extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'StackNode';
    }
    /**
	 * Constructs a new stack node.
	 *
	 * @param {?StackNode} [parent=null] - The parent stack node.
	 */ constructor(parent = null){
        super();
        /**
		 * List of nodes.
		 *
		 * @type {Array<Node>}
		 */ this.nodes = [];
        /**
		 * The output node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.outputNode = null;
        /**
		 * The parent stack node.
		 *
		 * @type {?StackNode}
		 * @default null
		 */ this.parent = parent;
        /**
		 * The current conditional node.
		 *
		 * @private
		 * @type {ConditionalNode}
		 * @default null
		 */ this._currentCond = null;
        /**
		 * The expression node. Only
		 * relevant for Switch/Case.
		 *
		 * @private
		 * @type {Node}
		 * @default null
		 */ this._expressionNode = null;
        /**
		 * The current node being processed.
		 *
		 * @private
		 * @type {Node}
		 * @default null
		 */ this._currentNode = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStackNode = true;
    }
    getElementType(builder) {
        return this.hasOutput ? this.outputNode.getElementType(builder) : 'void';
    }
    getNodeType(builder) {
        return this.hasOutput ? this.outputNode.getNodeType(builder) : 'void';
    }
    getMemberType(builder, name) {
        return this.hasOutput ? this.outputNode.getMemberType(builder, name) : 'void';
    }
    /**
	 * Adds a node to this stack.
	 *
	 * @param {Node} node - The node to add.
	 * @param {number} [index=this.nodes.length] - The index where the node should be added.
	 * @return {StackNode} A reference to this stack node.
	 */ addToStack(node, index = this.nodes.length) {
        if (node.isNode !== true) {
            (0, $329ek.error)('TSL: Invalid node added to stack.');
            return this;
        }
        this.nodes.splice(index, 0, node);
        return this;
    }
    /**
	 * Adds a node to the stack before the current node.
	 *
	 * @param {Node} node - The node to add.
	 * @return {StackNode} A reference to this stack node.
	 */ addToStackBefore(node) {
        const index = this._currentNode ? this.nodes.indexOf(this._currentNode) : 0;
        return this.addToStack(node, index);
    }
    /**
	 * Represent an `if` statement in TSL.
	 *
	 * @param {Node} boolNode - Represents the condition.
	 * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
	 * @return {StackNode} A reference to this stack node.
	 */ If(boolNode, method) {
        const methodNode = new $d89c9137a3d237c2$var$ShaderNode(method);
        this._currentCond = $d89c9137a3d237c2$var$select(boolNode, methodNode);
        return this.addToStack(this._currentCond);
    }
    /**
	 * Represent an `elseif` statement in TSL.
	 *
	 * @param {Node} boolNode - Represents the condition.
	 * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
	 * @return {StackNode} A reference to this stack node.
	 */ ElseIf(boolNode, method) {
        const methodNode = new $d89c9137a3d237c2$var$ShaderNode(method);
        const ifNode = $d89c9137a3d237c2$var$select(boolNode, methodNode);
        this._currentCond.elseNode = ifNode;
        this._currentCond = ifNode;
        return this;
    }
    /**
	 * Represent an `else` statement in TSL.
	 *
	 * @param {Function} method - TSL code which is executed in the `else` case.
	 * @return {StackNode} A reference to this stack node.
	 */ Else(method) {
        this._currentCond.elseNode = new $d89c9137a3d237c2$var$ShaderNode(method);
        return this;
    }
    /**
	 * Represents a `switch` statement in TSL.
	 *
	 * @param {any} expression - Represents the expression.
	 * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
	 * @return {StackNode} A reference to this stack node.
	 */ Switch(expression) {
        this._expressionNode = $d89c9137a3d237c2$var$nodeObject(expression);
        return this;
    }
    /**
	 * Represents a `case` statement in TSL. The TSL version accepts an arbitrary numbers of values.
	 * The last parameter must be the callback method that should be executed in the `true` case.
	 *
	 * @param {...any} params - The values of the `Case()` statement as well as the callback method.
	 * @return {StackNode} A reference to this stack node.
	 */ Case(...params) {
        const caseNodes = [];
        // extract case nodes from the parameter list
        if (params.length >= 2) for(let i = 0; i < params.length - 1; i++)caseNodes.push(this._expressionNode.equal($d89c9137a3d237c2$var$nodeObject(params[i])));
        else (0, $329ek.error)('TSL: Invalid parameter length. Case() requires at least two parameters.');
        // extract method
        const method = params[params.length - 1];
        const methodNode = new $d89c9137a3d237c2$var$ShaderNode(method);
        // chain multiple cases when using Case( 1, 2, 3, () => {} )
        let caseNode = caseNodes[0];
        for(let i = 1; i < caseNodes.length; i++)caseNode = caseNode.or(caseNodes[i]);
        // build condition
        const condNode = $d89c9137a3d237c2$var$select(caseNode, methodNode);
        if (this._currentCond === null) {
            this._currentCond = condNode;
            return this.addToStack(this._currentCond);
        } else {
            this._currentCond.elseNode = condNode;
            this._currentCond = condNode;
            return this;
        }
    }
    /**
	 * Represents the default code block of a Switch/Case statement.
	 *
	 * @param {Function} method - TSL code which is executed in the `else` case.
	 * @return {StackNode} A reference to this stack node.
	 */ Default(method) {
        this.Else(method);
        return this;
    }
    setup(builder) {
        const nodeProperties = builder.getNodeProperties(this);
        let index = 0;
        for (const childNode of this.getChildren()){
            if (childNode.isVarNode && childNode.isIntent(builder)) {
                if (childNode.isAssign(builder) !== true) continue;
            }
            nodeProperties['node' + index++] = childNode;
        }
        // return a outputNode if exists or null
        return nodeProperties.outputNode || null;
    }
    get hasOutput() {
        return this.outputNode && this.outputNode.isNode;
    }
    build(builder, ...params) {
        const previousStack = $d89c9137a3d237c2$var$getCurrentStack();
        const buildStage = builder.buildStage;
        $d89c9137a3d237c2$var$setCurrentStack(this);
        builder.setActiveStack(this);
        //
        const buildNode = (node)=>{
            this._currentNode = node;
            if (node.isVarNode && node.isIntent(builder)) {
                if (node.isAssign(builder) !== true) return;
            }
            if (buildStage === 'setup') node.build(builder);
            else if (buildStage === 'analyze') node.build(builder, this);
            else if (buildStage === 'generate') {
                const stages = builder.getDataFromNode(node, 'any').stages;
                const parents = stages && stages[builder.shaderStage];
                if (node.isVarNode && parents && parents.length === 1 && parents[0] && parents[0].isStackNode) return; // skip var nodes that are only used in .toVarying()
                node.build(builder, 'void');
            }
        };
        //
        const nodes = [
            ...this.nodes
        ];
        for (const node of nodes)buildNode(node);
        this._currentNode = null;
        const newNodes = this.nodes.filter((node)=>nodes.indexOf(node) === -1);
        for (const node of newNodes)buildNode(node);
        //
        let result;
        if (this.hasOutput) result = this.outputNode.build(builder, ...params);
        else result = super.build(builder, ...params);
        $d89c9137a3d237c2$var$setCurrentStack(previousStack);
        builder.removeActiveStack(this);
        return result;
    }
}
/**
 * TSL function for creating a stack node.
 *
 * @tsl
 * @function
 * @param {?StackNode} [parent=null] - The parent stack node.
 * @returns {StackNode}
 */ const $d89c9137a3d237c2$var$stack = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$6e11d1e78715185c).setParameterLength(0, 1);
/**
 * Generates a layout for struct members.
 * This function takes an object representing struct members and returns an array of member layouts.
 * Each member layout includes the member's name, type, and whether it is atomic.
 *
 * @param {Object.<string, string|Object>} members - An object where keys are member names and values are either types (as strings) or objects with type and atomic properties.
 * @returns {Array.<{name: string, type: string, atomic: boolean}>} An array of member layouts.
 */ function $d89c9137a3d237c2$var$getMembersLayout(members) {
    return Object.entries(members).map(([name, value])=>{
        if (typeof value === 'string') return {
            name: name,
            type: value,
            atomic: false
        };
        return {
            name: name,
            type: value.type,
            atomic: value.atomic || false
        };
    });
}
/**
 * Represents a struct type node in the node-based system.
 * This class is used to define and manage the layout and types of struct members.
 * It extends the base Node class and provides methods to get the length of the struct,
 * retrieve member types, and generate the struct type for a builder.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$fe9ea5c95793e50f extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'StructTypeNode';
    }
    /**
	 * Creates an instance of StructTypeNode.
	 *
	 * @param {Object} membersLayout - The layout of the members for the struct.
	 * @param {?string} [name=null] - The optional name of the struct.
	 */ constructor(membersLayout, name = null){
        super('struct');
        /**
		 * The layout of the members for the struct
		 *
		 * @type {Array.<{name: string, type: string, atomic: boolean}>}
		 */ this.membersLayout = $d89c9137a3d237c2$var$getMembersLayout(membersLayout);
        /**
		 * The name of the struct.
		 *
		 * @type {?string}
		 * @default null
		 */ this.name = name;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStructLayoutNode = true;
    }
    /**
	 * Returns the length of the struct.
	 * The length is calculated by summing the lengths of the struct's members.
	 *
	 * @returns {number} The length of the struct.
	 */ getLength() {
        const BYTES_PER_ELEMENT = Float32Array.BYTES_PER_ELEMENT;
        let maxAlignment = 1; // maximum alignment value in this struct
        let offset = 0; // global buffer offset in 4 byte elements
        for (const member of this.membersLayout){
            const type = member.type;
            const itemSize = $d89c9137a3d237c2$var$getMemoryLengthFromType(type);
            const alignment = $d89c9137a3d237c2$var$getAlignmentFromType(type) / BYTES_PER_ELEMENT;
            maxAlignment = Math.max(maxAlignment, alignment);
            const chunkOffset = offset % maxAlignment; // offset in the current chunk of maxAlignment elements
            const overhang = chunkOffset % alignment; // distance from the last aligned offset
            if (overhang !== 0) offset += alignment - overhang; // move to next aligned offset
            offset += itemSize;
        }
        return Math.ceil(offset / maxAlignment) * maxAlignment; // ensure length is a multiple of maxAlignment
    }
    getMemberType(builder, name) {
        const member = this.membersLayout.find((m)=>m.name === name);
        return member ? member.type : 'void';
    }
    getNodeType(builder) {
        const structType = builder.getStructTypeFromNode(this, this.membersLayout, this.name);
        return structType.name;
    }
    setup(builder) {
        builder.getStructTypeFromNode(this, this.membersLayout, this.name);
        builder.addInclude(this);
    }
    generate(builder) {
        return this.getNodeType(builder);
    }
}
/**
 * StructNode allows to create custom structures with multiple members.
 * This can also be used to define structures in attribute and uniform data.
 *
 * ```js
 * // Define a custom struct
 * const BoundingBox = struct( { min: 'vec3', max: 'vec3' } );
 *
 * // Create a new instance of the struct
 * const bb = BoundingBox( vec3( 0 ), vec3( 1 ) ); // style 1
 * const bb = BoundingBox( { min: vec3( 0 ), max: vec3( 1 ) } ); // style 2
 *
 * // Access the struct members
 * const min = bb.get( 'min' );
 *
 * // Assign a new value to a member
 * min.assign( vec3() );
 * ```
 * @augments Node
 */ class $d89c9137a3d237c2$export$e016575bf0061e5e extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'StructNode';
    }
    constructor(structTypeNode, values){
        super('vec3');
        this.structTypeNode = structTypeNode;
        this.values = values;
        this.isStructNode = true;
    }
    getNodeType(builder) {
        return this.structTypeNode.getNodeType(builder);
    }
    getMemberType(builder, name) {
        return this.structTypeNode.getMemberType(builder, name);
    }
    generate(builder) {
        const nodeVar = builder.getVarFromNode(this);
        const structType = nodeVar.type;
        const propertyName = builder.getPropertyName(nodeVar);
        builder.addLineFlowCode(`${propertyName} = ${builder.generateStruct(structType, this.structTypeNode.membersLayout, this.values)}`, this);
        return nodeVar.name;
    }
}
/**
 * TSL function for creating a struct node.
 *
 * @tsl
 * @function
 * @param {Object} membersLayout - The layout of the struct members.
 * @param {?string} [name=null] - The name of the struct.
 * @returns {Function} The struct function.
 */ const $d89c9137a3d237c2$var$struct = (membersLayout, name = null)=>{
    const structLayout = new $d89c9137a3d237c2$export$fe9ea5c95793e50f(membersLayout, name);
    const struct = (...params)=>{
        let values = null;
        if (params.length > 0) {
            if (params[0].isNode) {
                values = {};
                const names = Object.keys(membersLayout);
                for(let i = 0; i < params.length; i++)values[names[i]] = params[i];
            } else values = params[0];
        }
        return new $d89c9137a3d237c2$export$e016575bf0061e5e(structLayout, values);
    };
    struct.layout = structLayout;
    struct.isStruct = true;
    return struct;
};
/**
 * This node can be used to define multiple outputs in a shader programs.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$ae7787fb8a88b867 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'OutputStructNode';
    }
    /**
	 * Constructs a new output struct node. The constructor can be invoked with an
	 * arbitrary number of nodes representing the members.
	 *
	 * @param {...Node} members - A parameter list of nodes.
	 */ constructor(...members){
        super();
        /**
		 * An array of nodes which defines the output.
		 *
		 * @type {Array<Node>}
		 */ this.members = members;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOutputStructNode = true;
    }
    getNodeType(builder) {
        const properties = builder.getNodeProperties(this);
        if (properties.membersLayout === undefined) {
            const members = this.members;
            const membersLayout = [];
            for(let i = 0; i < members.length; i++){
                const name = 'm' + i;
                const type = members[i].getNodeType(builder);
                membersLayout.push({
                    name: name,
                    type: type,
                    index: i
                });
            }
            properties.membersLayout = membersLayout;
            properties.structType = builder.getOutputStructTypeFromNode(this, properties.membersLayout);
        }
        return properties.structType.name;
    }
    generate(builder) {
        const propertyName = builder.getOutputStructName();
        const members = this.members;
        const structPrefix = propertyName !== '' ? propertyName + '.' : '';
        for(let i = 0; i < members.length; i++){
            const snippet = members[i].build(builder);
            builder.addLineFlowCode(`${structPrefix}m${i} = ${snippet}`, this);
        }
        return propertyName;
    }
}
/**
 * TSL function for creating an output struct node.
 *
 * @tsl
 * @function
 * @param {...Node} members - A parameter list of nodes.
 * @returns {OutputStructNode}
 */ const $d89c9137a3d237c2$var$outputStruct = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$ae7787fb8a88b867);
/**
 * Returns the MRT texture index for the given name.
 *
 * @param {Array<Texture>} textures - The textures of a MRT-configured render target.
 * @param {string} name - The name of the MRT texture which index is requested.
 * @return {number} The texture index.
 */ function $d89c9137a3d237c2$var$getTextureIndex(textures, name) {
    for(let i = 0; i < textures.length; i++){
        if (textures[i].name === name) return i;
    }
    return -1;
}
/**
 * This node can be used setup a MRT context for rendering. A typical MRT setup for
 * post-processing is shown below:
 * ```js
 * const mrtNode = mrt( {
 *   output: output,
 *   normal: normalView
 * } ) );
 * ```
 * The MRT output is defined as a dictionary.
 *
 * @augments OutputStructNode
 */ class $d89c9137a3d237c2$export$48063f712ed265fc extends $d89c9137a3d237c2$export$ae7787fb8a88b867 {
    static get type() {
        return 'MRTNode';
    }
    /**
	 * Constructs a new output struct node.
	 *
	 * @param {Object<string, Node>} outputNodes - The MRT outputs.
	 */ constructor(outputNodes){
        super();
        /**
		 * A dictionary representing the MRT outputs. The key
		 * is the name of the output, the value the node which produces
		 * the output result.
		 *
		 * @type {Object<string, Node>}
		 */ this.outputNodes = outputNodes;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMRTNode = true;
    }
    /**
	 * Returns `true` if the MRT node has an output with the given name.
	 *
	 * @param {string} name - The name of the output.
	 * @return {NodeBuilder} Whether the MRT node has an output for the given name or not.
	 */ has(name) {
        return this.outputNodes[name] !== undefined;
    }
    /**
	 * Returns the output node for the given name.
	 *
	 * @param {string} name - The name of the output.
	 * @return {Node} The output node.
	 */ get(name) {
        return this.outputNodes[name];
    }
    /**
	 * Merges the outputs of the given MRT node with the outputs of this node.
	 *
	 * @param {MRTNode} mrtNode - The MRT to merge.
	 * @return {MRTNode} A new MRT node with merged outputs..
	 */ merge(mrtNode) {
        const outputs = {
            ...this.outputNodes,
            ...mrtNode.outputNodes
        };
        return $d89c9137a3d237c2$var$mrt(outputs);
    }
    setup(builder) {
        const outputNodes = this.outputNodes;
        const mrt = builder.renderer.getRenderTarget();
        const members = [];
        const textures = mrt.textures;
        for(const name in outputNodes){
            const index = $d89c9137a3d237c2$var$getTextureIndex(textures, name);
            members[index] = $d89c9137a3d237c2$var$vec4(outputNodes[name]);
        }
        this.members = members;
        return super.setup(builder);
    }
}
/**
 * TSL function for creating a MRT node.
 *
 * @tsl
 * @function
 * @param {Object<string, Node>} outputNodes - The MRT outputs.
 * @returns {MRTNode}
 */ const $d89c9137a3d237c2$var$mrt = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$48063f712ed265fc);
/**
 * This node represents an operation that reinterprets the bit representation of a value
 * in one type as a value in another type.
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$81c03d9ee746256f extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'BitcastNode';
    }
    /**
	 * Constructs a new bitcast node.
	 *
	 * @param {Node} valueNode - The value to convert.
	 * @param {string} conversionType - The type to convert to.
	 * @param {?string} [inputType = null] - The expected input data type of the bitcast operation.
	 */ constructor(valueNode, conversionType, inputType = null){
        super();
        /**
		 * The data to bitcast to a new type.
		 *
		 * @type {Node}
		 */ this.valueNode = valueNode;
        /**
		 * The type the value will be converted to.
		 *
		 * @type {string}
		 */ this.conversionType = conversionType;
        /**
		 * The expected input data type of the bitcast operation.
		 *
		 *
		 * @type {string}
		 * @default null
		 */ this.inputType = inputType;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBitcastNode = true;
    }
    getNodeType(builder) {
        // GLSL aliasing
        if (this.inputType !== null) {
            const valueType = this.valueNode.getNodeType(builder);
            const valueLength = builder.getTypeLength(valueType);
            return builder.getTypeFromLength(valueLength, this.conversionType);
        }
        return this.conversionType;
    }
    generate(builder) {
        const type = this.getNodeType(builder);
        let inputType = '';
        if (this.inputType !== null) {
            const valueType = this.valueNode.getNodeType(builder);
            const valueTypeLength = builder.getTypeLength(valueType);
            inputType = valueTypeLength === 1 ? this.inputType : builder.changeComponentType(valueType, this.inputType);
        } else inputType = this.valueNode.getNodeType(builder);
        return `${builder.getBitcastMethod(type, inputType)}( ${this.valueNode.build(builder, inputType)} )`;
    }
}
/**
 * Reinterpret the bit representation of a value in one type as a value in another type.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @param {string} y - The new type.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$bitcast = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$export$81c03d9ee746256f).setParameterLength(2);
/**
 * Bitcasts a float or a vector of floats to a corresponding integer type with the same element size.
 *
 * @tsl
 * @function
 * @param {Node<float>} value - The float or vector of floats to bitcast.
 * @returns {BitcastNode}
 */ const $d89c9137a3d237c2$var$floatBitsToInt = (value)=>new $d89c9137a3d237c2$export$81c03d9ee746256f(value, 'int', 'float');
/**
 * Bitcasts a float or a vector of floats to a corresponding unsigned integer type with the same element size.
 *
 * @tsl
 * @function
 * @param {Node<float>} value - The float or vector of floats to bitcast.
 * @returns {BitcastNode}
 */ const $d89c9137a3d237c2$var$floatBitsToUint = (value)=>new $d89c9137a3d237c2$export$81c03d9ee746256f(value, 'uint', 'float');
/**
 * Bitcasts an integer or a vector of integers to a corresponding float type with the same element size.
 *
 * @tsl
 * @function
 * @param {Node<int>} value - The integer or vector of integers to bitcast.
 * @returns {BitcastNode}
 */ const $d89c9137a3d237c2$var$intBitsToFloat = (value)=>new $d89c9137a3d237c2$export$81c03d9ee746256f(value, 'float', 'int');
/**
 * Bitcast an unsigned integer or a vector of unsigned integers to a corresponding float type with the same element size.
 *
 * @tsl
 * @function
 * @param {Node<uint>} value - The unsigned integer or vector of unsigned integers to bitcast.
 * @returns {BitcastNode}
 */ const $d89c9137a3d237c2$var$uintBitsToFloat = (value)=>new $d89c9137a3d237c2$export$81c03d9ee746256f(value, 'float', 'uint');
const $d89c9137a3d237c2$var$registeredBitcountFunctions = {};
/**
 * This node represents an operation that counts the bits of a piece of shader data.
 *
 * @augments MathNode
 */ class $d89c9137a3d237c2$var$BitcountNode extends $d89c9137a3d237c2$var$MathNode {
    static get type() {
        return 'BitcountNode';
    }
    /**
	 * Constructs a new math node.
	 *
	 * @param {'countTrailingZeros'|'countLeadingZeros'|'countOneBits'} method - The method name.
	 * @param {Node} aNode - The first input.
	 */ constructor(method, aNode){
        super(method, aNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBitcountNode = true;
    }
    /**
	 * Casts the input value of the function to an integer if necessary.
	 *
	 * @private
	 * @param {Node<uint>|Node<int>} inputNode - The input value.
	 * @param {Node<uint>} outputNode - The output value.
	 * @param {string} elementType - The type of the input value.
	 */ _resolveElementType(inputNode, outputNode, elementType) {
        if (elementType === 'int') outputNode.assign($d89c9137a3d237c2$var$bitcast(inputNode, 'uint'));
        else outputNode.assign(inputNode);
    }
    _returnDataNode(inputType) {
        switch(inputType){
            case 'uint':
                return $d89c9137a3d237c2$var$uint;
            case 'int':
                return $d89c9137a3d237c2$var$int;
            case 'uvec2':
                return $d89c9137a3d237c2$var$uvec2;
            case 'uvec3':
                return $d89c9137a3d237c2$var$uvec3;
            case 'uvec4':
                return $d89c9137a3d237c2$var$uvec4;
            case 'ivec2':
                return $d89c9137a3d237c2$var$ivec2;
            case 'ivec3':
                return $d89c9137a3d237c2$var$ivec3;
            case 'ivec4':
                return $d89c9137a3d237c2$var$ivec4;
        }
    }
    /**
	 * Creates and registers a reusable GLSL function that emulates the behavior of countTrailingZeros.
	 *
	 * @private
	 * @param {string} method - The name of the function to create.
	 * @param {string} elementType - The type of the input value.
	 * @returns {Function} - The generated function
	 */ _createTrailingZerosBaseLayout(method, elementType) {
        const outputConvertNode = this._returnDataNode(elementType);
        const fnDef = $d89c9137a3d237c2$var$Fn(([value])=>{
            const v = $d89c9137a3d237c2$var$uint(0.0);
            this._resolveElementType(value, v, elementType);
            const f = $d89c9137a3d237c2$var$float(v.bitAnd($d89c9137a3d237c2$var$negate(v)));
            const uintBits = $d89c9137a3d237c2$var$floatBitsToUint(f);
            const numTrailingZeros = uintBits.shiftRight(23).sub(127);
            return outputConvertNode(numTrailingZeros);
        }).setLayout({
            name: method,
            type: elementType,
            inputs: [
                {
                    name: 'value',
                    type: elementType
                }
            ]
        });
        return fnDef;
    }
    /**
	 * Creates and registers a reusable GLSL function that emulates the behavior of countLeadingZeros.
	 *
	 * @private
	 * @param {string} method - The name of the function to create.
	 * @param {string} elementType - The type of the input value.
	 * @returns {Function} - The generated function
	 */ _createLeadingZerosBaseLayout(method, elementType) {
        const outputConvertNode = this._returnDataNode(elementType);
        const fnDef = $d89c9137a3d237c2$var$Fn(([value])=>{
            $d89c9137a3d237c2$var$If(value.equal($d89c9137a3d237c2$var$uint(0)), ()=>{
                return $d89c9137a3d237c2$var$uint(32);
            });
            const v = $d89c9137a3d237c2$var$uint(0);
            const n = $d89c9137a3d237c2$var$uint(0);
            this._resolveElementType(value, v, elementType);
            $d89c9137a3d237c2$var$If(v.shiftRight(16).equal(0), ()=>{
                n.addAssign(16);
                v.shiftLeftAssign(16);
            });
            $d89c9137a3d237c2$var$If(v.shiftRight(24).equal(0), ()=>{
                n.addAssign(8);
                v.shiftLeftAssign(8);
            });
            $d89c9137a3d237c2$var$If(v.shiftRight(28).equal(0), ()=>{
                n.addAssign(4);
                v.shiftLeftAssign(4);
            });
            $d89c9137a3d237c2$var$If(v.shiftRight(30).equal(0), ()=>{
                n.addAssign(2);
                v.shiftLeftAssign(2);
            });
            $d89c9137a3d237c2$var$If(v.shiftRight(31).equal(0), ()=>{
                n.addAssign(1);
            });
            return outputConvertNode(n);
        }).setLayout({
            name: method,
            type: elementType,
            inputs: [
                {
                    name: 'value',
                    type: elementType
                }
            ]
        });
        return fnDef;
    }
    /**
	 * Creates and registers a reusable GLSL function that emulates the behavior of countOneBits.
	 *
	 * @private
	 * @param {string} method - The name of the function to create.
	 * @param {string} elementType - The type of the input value.
	 * @returns {Function} - The generated function
	 */ _createOneBitsBaseLayout(method, elementType) {
        const outputConvertNode = this._returnDataNode(elementType);
        const fnDef = $d89c9137a3d237c2$var$Fn(([value])=>{
            const v = $d89c9137a3d237c2$var$uint(0.0);
            this._resolveElementType(value, v, elementType);
            v.assign(v.sub(v.shiftRight($d89c9137a3d237c2$var$uint(1)).bitAnd($d89c9137a3d237c2$var$uint(0x55555555))));
            v.assign(v.bitAnd($d89c9137a3d237c2$var$uint(0x33333333)).add(v.shiftRight($d89c9137a3d237c2$var$uint(2)).bitAnd($d89c9137a3d237c2$var$uint(0x33333333))));
            const numBits = v.add(v.shiftRight($d89c9137a3d237c2$var$uint(4))).bitAnd($d89c9137a3d237c2$var$uint(0xF0F0F0F)).mul($d89c9137a3d237c2$var$uint(0x1010101)).shiftRight($d89c9137a3d237c2$var$uint(24));
            return outputConvertNode(numBits);
        }).setLayout({
            name: method,
            type: elementType,
            inputs: [
                {
                    name: 'value',
                    type: elementType
                }
            ]
        });
        return fnDef;
    }
    /**
	 * Creates and registers a reusable GLSL function that emulates the behavior of the specified bitcount function.
	 * including considerations for component-wise bitcounts on vector type inputs.
	 *
	 * @private
	 * @param {string} method - The name of the function to create.
	 * @param {string} inputType - The type of the input value.
	 * @param {number} typeLength - The vec length of the input value.
	 * @param {Function} baseFn - The base function that operates on an individual component of the vector.
	 * @returns {Function} - The alias function for the specified bitcount method.
	 */ _createMainLayout(method, inputType, typeLength, baseFn) {
        const outputConvertNode = this._returnDataNode(inputType);
        const fnDef = $d89c9137a3d237c2$var$Fn(([value])=>{
            if (typeLength === 1) return outputConvertNode(baseFn(value));
            else {
                const vec = outputConvertNode(0);
                const components = [
                    'x',
                    'y',
                    'z',
                    'w'
                ];
                for(let i = 0; i < typeLength; i++){
                    const component = components[i];
                    vec[component].assign(baseFn(value[component]));
                }
                return vec;
            }
        }).setLayout({
            name: method,
            type: inputType,
            inputs: [
                {
                    name: 'value',
                    type: inputType
                }
            ]
        });
        return fnDef;
    }
    setup(builder) {
        const { method: method, aNode: aNode } = this;
        const { renderer: renderer } = builder;
        if (renderer.backend.isWebGPUBackend) // use built-in WGSL functions for WebGPU
        return super.setup(builder);
        const inputType = this.getInputType(builder);
        const elementType = builder.getElementType(inputType);
        const typeLength = builder.getTypeLength(inputType);
        const baseMethod = `${method}_base_${elementType}`;
        const newMethod = `${method}_${inputType}`;
        let baseFn = $d89c9137a3d237c2$var$registeredBitcountFunctions[baseMethod];
        if (baseFn === undefined) {
            switch(method){
                case $d89c9137a3d237c2$var$BitcountNode.COUNT_LEADING_ZEROS:
                    baseFn = this._createLeadingZerosBaseLayout(baseMethod, elementType);
                    break;
                case $d89c9137a3d237c2$var$BitcountNode.COUNT_TRAILING_ZEROS:
                    baseFn = this._createTrailingZerosBaseLayout(baseMethod, elementType);
                    break;
                case $d89c9137a3d237c2$var$BitcountNode.COUNT_ONE_BITS:
                    baseFn = this._createOneBitsBaseLayout(baseMethod, elementType);
                    break;
            }
            $d89c9137a3d237c2$var$registeredBitcountFunctions[baseMethod] = baseFn;
        }
        let fn = $d89c9137a3d237c2$var$registeredBitcountFunctions[newMethod];
        if (fn === undefined) {
            fn = this._createMainLayout(newMethod, inputType, typeLength, baseFn);
            $d89c9137a3d237c2$var$registeredBitcountFunctions[newMethod] = fn;
        }
        const output = $d89c9137a3d237c2$var$Fn(()=>{
            return fn(aNode);
        });
        return output();
    }
}
$d89c9137a3d237c2$var$BitcountNode.COUNT_TRAILING_ZEROS = 'countTrailingZeros';
$d89c9137a3d237c2$var$BitcountNode.COUNT_LEADING_ZEROS = 'countLeadingZeros';
$d89c9137a3d237c2$var$BitcountNode.COUNT_ONE_BITS = 'countOneBits';
/**
 * Finds the number of consecutive 0 bits from the least significant bit of the input value,
 * which is also the index of the least significant bit of the input value.
 *
 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The input value.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$countTrailingZeros = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$BitcountNode, $d89c9137a3d237c2$var$BitcountNode.COUNT_TRAILING_ZEROS).setParameterLength(1);
/**
 * Finds the number of consecutive 0 bits starting from the most significant bit of the input value.
 *
 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The input value.
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$countLeadingZeros = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$BitcountNode, $d89c9137a3d237c2$var$BitcountNode.COUNT_LEADING_ZEROS).setParameterLength(1);
/**
 * Finds the number of '1' bits set in the input value
 *
 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
 *
 * @tsl
 * @function
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$countOneBits = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$BitcountNode, $d89c9137a3d237c2$var$BitcountNode.COUNT_ONE_BITS).setParameterLength(1);
/**
 * Generates a hash value in the range `[0, 1]` from the given seed.
 *
 * @tsl
 * @function
 * @param {Node<float>} seed - The seed.
 * @return {Node<float>} The hash value.
 */ const $d89c9137a3d237c2$var$hash = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([seed])=>{
    // Taken from https://www.shadertoy.com/view/XlGcRh, originally from pcg-random.org
    const state = seed.toUint().mul(747796405).add(2891336453);
    const word = state.shiftRight(state.shiftRight(28).add(4)).bitXor(state).mul(277803737);
    const result = word.shiftRight(22).bitXor(word);
    return result.toFloat().mul(1 / 2 ** 32); // Convert to range [0, 1)
});
/**
 * A function that remaps the `[0,1]` interval into the `[0,1]` interval.
 * The corners are mapped to `0` and the center to `1`.
 * Reference: {@link https://iquilezles.org/articles/functions/}.
 *
 * @tsl
 * @function
 * @param {Node<float>} x - The value to remap.
 * @param {Node<float>} k - Allows to control the remapping functions shape by rising the parabola to a power `k`.
 * @return {Node<float>} The remapped value.
 */ const $d89c9137a3d237c2$var$parabola = (x, k)=>$d89c9137a3d237c2$var$pow($d89c9137a3d237c2$var$mul(4.0, x.mul($d89c9137a3d237c2$var$sub(1.0, x))), k);
/**
 * A function that remaps the `[0,1]` interval into the `[0,1]` interval.
 * Expands the sides and compresses the center, and keeps `0.5` mapped to `0.5`.
 * Reference: {@link https://iquilezles.org/articles/functions/}.
 *
 * @tsl
 * @function
 * @param {Node<float>} x - The value to remap.
 * @param {Node<float>} k - `k=1` is the identity curve,`k<1` produces the classic `gain()` shape, and `k>1` produces "s" shaped curves.
 * @return {Node<float>} The remapped value.
 */ const $d89c9137a3d237c2$var$gain = (x, k)=>x.lessThan(0.5) ? $d89c9137a3d237c2$var$parabola(x.mul(2.0), k).div(2.0) : $d89c9137a3d237c2$var$sub(1.0, $d89c9137a3d237c2$var$parabola($d89c9137a3d237c2$var$mul($d89c9137a3d237c2$var$sub(1.0, x), 2.0), k).div(2.0));
/**
 * A function that remaps the `[0,1]` interval into the `[0,1]` interval.
 * A generalization of the `parabola()`. Keeps the corners mapped to 0 but allows the control of the shape one either side of the curve.
 * Reference: {@link https://iquilezles.org/articles/functions/}.
 *
 * @tsl
 * @function
 * @param {Node<float>} x - The value to remap.
 * @param {Node<float>} a - First control parameter.
 * @param {Node<float>} b - Second control parameter.
 * @return {Node<float>} The remapped value.
 */ const $d89c9137a3d237c2$var$pcurve = (x, a, b)=>$d89c9137a3d237c2$var$pow($d89c9137a3d237c2$var$div($d89c9137a3d237c2$var$pow(x, a), $d89c9137a3d237c2$var$add($d89c9137a3d237c2$var$pow(x, a), $d89c9137a3d237c2$var$pow($d89c9137a3d237c2$var$sub(1.0, x), b))), 1.0 / a);
/**
 * A phase shifted sinus curve that starts at zero and ends at zero, with bouncing behavior.
 * Reference: {@link https://iquilezles.org/articles/functions/}.
 *
 * @tsl
 * @function
 * @param {Node<float>} x - The value to compute the sin for.
 * @param {Node<float>} k - Controls the amount of bounces.
 * @return {Node<float>} The result value.
 */ const $d89c9137a3d237c2$var$sinc = (x, k)=>$d89c9137a3d237c2$var$sin($d89c9137a3d237c2$var$PI.mul(k.mul(x).sub(1.0))).div($d89c9137a3d237c2$var$PI.mul(k.mul(x).sub(1.0)));
/**
 * This node represents an operation that packs floating-point values of a vector into an unsigned 32-bit integer
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$var$PackFloatNode extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'PackFloatNode';
    }
    /**
	 *
	 * @param {'snorm' | 'unorm' | 'float16'} encoding - The numeric encoding that describes how the float values are mapped to the integer range.
	 * @param {Node} vectorNode - The vector node to be packed
	 */ constructor(encoding, vectorNode){
        super();
        /**
		 * The vector to be packed.
		 *
		 * @type {Node}
		 */ this.vectorNode = vectorNode;
        /**
		 * The numeric encoding.
		 *
		 * @type {string}
		 */ this.encoding = encoding;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPackFloatNode = true;
    }
    getNodeType() {
        return 'uint';
    }
    generate(builder) {
        const inputType = this.vectorNode.getNodeType(builder);
        return `${builder.getFloatPackingMethod(this.encoding)}(${this.vectorNode.build(builder, inputType)})`;
    }
}
/**
 * Converts each component of the normalized float to 16-bit integer values. The results are packed into a single unsigned integer.
 * round(clamp(c, -1, +1) * 32767.0)
 *
 * @tsl
 * @function
 * @param {Node<vec2>} value - The 2-component vector to be packed
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$packSnorm2x16 = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$PackFloatNode, 'snorm').setParameterLength(1);
/**
 * Converts each component of the normalized float to 16-bit integer values. The results are packed into a single unsigned integer.
 * round(clamp(c, 0, +1) * 65535.0)
 *
 * @tsl
 * @function
 * @param {Node<vec2>} value - The 2-component vector to be packed
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$packUnorm2x16 = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$PackFloatNode, 'unorm').setParameterLength(1);
/**
 * Converts each component of the vec2 to 16-bit floating-point values. The results are packed into a single unsigned integer.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} value - The 2-component vector to be packed
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$packHalf2x16 = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$PackFloatNode, 'float16').setParameterLength(1);
/**
 * This node represents an operation that unpacks values from a 32-bit unsigned integer, reinterpreting the results as a floating-point vector
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$var$UnpackFloatNode extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'UnpackFloatNode';
    }
    /**
	 *
	 * @param {'snorm' | 'unorm' | 'float16'} encoding - The numeric encoding that describes how the integer values are mapped to the float range
	 * @param {Node} uintNode - The uint node to be unpacked
	 */ constructor(encoding, uintNode){
        super();
        /**
		 * The unsigned integer to be unpacked.
		 *
		 * @type {Node}
		 */ this.uintNode = uintNode;
        /**
		 * The numeric encoding.
		 *
		 * @type {string}
		 */ this.encoding = encoding;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUnpackFloatNode = true;
    }
    getNodeType() {
        return 'vec2';
    }
    generate(builder) {
        const inputType = this.uintNode.getNodeType(builder);
        return `${builder.getFloatUnpackingMethod(this.encoding)}(${this.uintNode.build(builder, inputType)})`;
    }
}
/**
 * Unpacks a 32-bit unsigned integer into two 16-bit values, interpreted as normalized signed integers. Returns a vec2 with both values.
 *
 * @tsl
 * @function
 * @param {Node<uint>} value - The unsigned integer to be unpacked
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$unpackSnorm2x16 = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$UnpackFloatNode, 'snorm').setParameterLength(1);
/**
 * Unpacks a 32-bit unsigned integer into two 16-bit values, interpreted as normalized unsigned integers. Returns a vec2 with both values.
 *
 * @tsl
 * @function
 * @param {Node<uint>} value - The unsigned integer to be unpacked
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$unpackUnorm2x16 = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$UnpackFloatNode, 'unorm').setParameterLength(1);
/**
 * Unpacks a 32-bit unsigned integer into two 16-bit values, interpreted as 16-bit floating-point numbers. Returns a vec2 with both values.
 *
 * @tsl
 * @function
 * @param {Node<uint>} value - The unsigned integer to be unpacked
 * @returns {Node}
 */ const $d89c9137a3d237c2$var$unpackHalf2x16 = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$UnpackFloatNode, 'float16').setParameterLength(1);
// https://github.com/cabbibo/glsl-tri-noise-3d
const $d89c9137a3d237c2$var$tri = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x])=>{
    return x.fract().sub(.5).abs();
}).setLayout({
    name: 'tri',
    type: 'float',
    inputs: [
        {
            name: 'x',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$tri3 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p])=>{
    return $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$tri(p.z.add($d89c9137a3d237c2$var$tri(p.y.mul(1.)))), $d89c9137a3d237c2$var$tri(p.z.add($d89c9137a3d237c2$var$tri(p.x.mul(1.)))), $d89c9137a3d237c2$var$tri(p.y.add($d89c9137a3d237c2$var$tri(p.x.mul(1.)))));
}).setLayout({
    name: 'tri3',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
/**
 * Generates a noise value from the given position, speed and time parameters.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} position - The position.
 * @param {Node<float>} speed - The speed.
 * @param {Node<float>} time - The time.
 * @return {Node<float>} The generated noise.
 */ const $d89c9137a3d237c2$var$triNoise3D = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([position, speed, time])=>{
    const p = $d89c9137a3d237c2$var$vec3(position).toVar();
    const z = $d89c9137a3d237c2$var$float(1.4).toVar();
    const rz = $d89c9137a3d237c2$var$float(0.0).toVar();
    const bp = $d89c9137a3d237c2$var$vec3(p).toVar();
    $d89c9137a3d237c2$var$Loop({
        start: $d89c9137a3d237c2$var$float(0.0),
        end: $d89c9137a3d237c2$var$float(3.0),
        type: 'float',
        condition: '<='
    }, ()=>{
        const dg = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$tri3(bp.mul(2.0))).toVar();
        p.addAssign(dg.add(time.mul($d89c9137a3d237c2$var$float(0.1).mul(speed))));
        bp.mulAssign(1.8);
        z.mulAssign(1.5);
        p.mulAssign(1.2);
        const t = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$tri(p.z.add($d89c9137a3d237c2$var$tri(p.x.add($d89c9137a3d237c2$var$tri(p.y)))))).toVar();
        rz.addAssign(t.div(z));
        bp.addAssign(0.14);
    });
    return rz;
}).setLayout({
    name: 'triNoise3D',
    type: 'float',
    inputs: [
        {
            name: 'position',
            type: 'vec3'
        },
        {
            name: 'speed',
            type: 'float'
        },
        {
            name: 'time',
            type: 'float'
        }
    ]
});
/**
 * This class allows to define multiple overloaded versions
 * of the same function. Depending on the parameters of the function
 * call, the node picks the best-fit overloaded version.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$83ec1b7751f4e8e2 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'FunctionOverloadingNode';
    }
    /**
	 * Constructs a new function overloading node.
	 *
	 * @param {Array<Function>} functionNodes - Array of `Fn` function definitions.
	 * @param {...Node} parametersNodes - A list of parameter nodes.
	 */ constructor(functionNodes = [], ...parametersNodes){
        super();
        /**
		 * Array of `Fn` function definitions.
		 *
		 * @type {Array<Function>}
		 */ this.functionNodes = functionNodes;
        /**
		 * A list of parameter nodes.
		 *
		 * @type {Array<Node>}
		 */ this.parametersNodes = parametersNodes;
        /**
		 * The selected overloaded function call.
		 *
		 * @private
		 * @type {ShaderCallNodeInternal}
		 */ this._candidateFn = null;
        /**
		 * This node is marked as global.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the function's return type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        const candidateFn = this.getCandidateFn(builder);
        return candidateFn.shaderNode.layout.type;
    }
    /**
	 * Returns the candidate function for the current parameters.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {FunctionNode} The candidate function.
	 */ getCandidateFn(builder) {
        const params = this.parametersNodes;
        let candidateFn = this._candidateFn;
        if (candidateFn === null) {
            let bestCandidateFn = null;
            let bestScore = -1;
            for (const functionNode of this.functionNodes){
                const shaderNode = functionNode.shaderNode;
                const layout = shaderNode.layout;
                if (layout === null) throw new Error('FunctionOverloadingNode: FunctionNode must be a layout.');
                const inputs = layout.inputs;
                if (params.length === inputs.length) {
                    let currentScore = 0;
                    for(let i = 0; i < params.length; i++){
                        const param = params[i];
                        const input = inputs[i];
                        if (param.getNodeType(builder) === input.type) currentScore++;
                    }
                    if (currentScore > bestScore) {
                        bestCandidateFn = functionNode;
                        bestScore = currentScore;
                    }
                }
            }
            this._candidateFn = candidateFn = bestCandidateFn;
        }
        return candidateFn;
    }
    /**
	 * Sets up the node for the current parameters.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node} The setup node.
	 */ setup(builder) {
        const candidateFn = this.getCandidateFn(builder);
        return candidateFn(...this.parametersNodes);
    }
}
const $d89c9137a3d237c2$var$overloadingBaseFn = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$83ec1b7751f4e8e2);
/**
 * TSL function for creating a function overloading node.
 *
 * @tsl
 * @function
 * @param {Array<Function>} functionNodes - Array of `Fn` function definitions.
 * @returns {FunctionOverloadingNode}
 */ const $d89c9137a3d237c2$var$overloadingFn = (functionNodes)=>(...params)=>$d89c9137a3d237c2$var$overloadingBaseFn(functionNodes, ...params);
/**
 * Represents the elapsed time in seconds.
 *
 * @tsl
 * @type {UniformNode<float>}
 */ const $d89c9137a3d237c2$var$time = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform(0).setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate((frame)=>frame.time);
/**
 * Represents the delta time in seconds.
 *
 * @tsl
 * @type {UniformNode<float>}
 */ const $d89c9137a3d237c2$var$deltaTime = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform(0).setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate((frame)=>frame.deltaTime);
/**
 * Represents the current frame ID.
 *
 * @tsl
 * @type {UniformNode<uint>}
 */ const $d89c9137a3d237c2$var$frameId = /*@__PURE__*/ $d89c9137a3d237c2$var$uniform(0, 'uint').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate((frame)=>frame.frameId);
/**
 * Generates a sine wave oscillation based on a timer.
 *
 * @tsl
 * @function
 * @param {Node<float>} t - The timer to generate the oscillation with.
 * @return {Node<float>} The oscillation node.
 */ const $d89c9137a3d237c2$var$oscSine = (t = $d89c9137a3d237c2$var$time)=>t.add(0.75).mul(Math.PI * 2).sin().mul(0.5).add(0.5);
/**
 * Generates a square wave oscillation based on a timer.
 *
 * @tsl
 * @function
 * @param {Node<float>} t - The timer to generate the oscillation with.
 * @return {Node<float>} The oscillation node.
 */ const $d89c9137a3d237c2$var$oscSquare = (t = $d89c9137a3d237c2$var$time)=>t.fract().round();
/**
 * Generates a triangle wave oscillation based on a timer.
 *
 * @tsl
 * @function
 * @param {Node<float>} t - The timer to generate the oscillation with.
 * @return {Node<float>} The oscillation node.
 */ const $d89c9137a3d237c2$var$oscTriangle = (t = $d89c9137a3d237c2$var$time)=>t.add(0.5).fract().mul(2).sub(1).abs();
/**
 * Generates a sawtooth wave oscillation based on a timer.
 *
 * @tsl
 * @function
 * @param {Node<float>} t - The timer to generate the oscillation with.
 * @return {Node<float>} The oscillation node.
 */ const $d89c9137a3d237c2$var$oscSawtooth = (t = $d89c9137a3d237c2$var$time)=>t.fract();
/**
 * Replaces the default UV coordinates used in texture lookups.
 *
 * ```js
 *material.contextNode = replaceDefaultUV( ( textureNode ) => {
 *
 *	// ...
 *	return customUVCoordinates;
 *
 *} );
 *```
 *
 * @tsl
 * @function
 * @param {function(Node):Node<vec2>} callback - A callback that receives the texture node
 * and must return the new uv coordinates.
 * @param {Node} [node=null] - An optional node to which the context will be applied.
 * @return {ContextNode} A context node that replaces the default UV coordinates.
 */ function $d89c9137a3d237c2$var$replaceDefaultUV(callback, node = null) {
    return $d89c9137a3d237c2$var$context(node, {
        getUV: callback
    });
}
/**
 * Rotates the given uv coordinates around a center point
 *
 * @tsl
 * @function
 * @param {Node<vec2>} uv - The uv coordinates.
 * @param {Node<float>} rotation - The rotation defined in radians.
 * @param {Node<vec2>} center - The center of rotation
 * @return {Node<vec2>} The rotated uv coordinates.
 */ const $d89c9137a3d237c2$var$rotateUV = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([uv, rotation, center = $d89c9137a3d237c2$var$vec2(0.5)])=>{
    return $d89c9137a3d237c2$var$rotate(uv.sub(center), rotation).add(center);
});
/**
 * Applies a spherical warping effect to the given uv coordinates.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} uv - The uv coordinates.
 * @param {Node<float>} strength - The strength of the effect.
 * @param {Node<vec2>} center - The center point
 * @return {Node<vec2>} The updated uv coordinates.
 */ const $d89c9137a3d237c2$var$spherizeUV = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([uv, strength, center = $d89c9137a3d237c2$var$vec2(0.5)])=>{
    const delta = uv.sub(center);
    const delta2 = delta.dot(delta);
    const delta4 = delta2.mul(delta2);
    const deltaOffset = delta4.mul(strength);
    return uv.add(delta.mul(deltaOffset));
});
/**
 * This can be used to achieve a billboarding behavior for flat meshes. That means they are
 * oriented always towards the camera.
 *
 * ```js
 * material.vertexNode = billboarding();
 * ```
 *
 * @tsl
 * @function
 * @param {Object} config - The configuration object.
 * @param {?Node<vec3>} [config.position=null] - Can be used to define the vertex positions in world space.
 * @param {boolean} [config.horizontal=true] - Whether to follow the camera rotation horizontally or not.
 * @param {boolean} [config.vertical=false] - Whether to follow the camera rotation vertically or not.
 * @return {Node<vec3>} The updated vertex position in clip space.
 */ const $d89c9137a3d237c2$var$billboarding = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ position: position = null, horizontal: horizontal = true, vertical: vertical = false })=>{
    let worldMatrix;
    if (position !== null) {
        worldMatrix = $d89c9137a3d237c2$var$modelWorldMatrix.toVar();
        worldMatrix[3][0] = position.x;
        worldMatrix[3][1] = position.y;
        worldMatrix[3][2] = position.z;
    } else worldMatrix = $d89c9137a3d237c2$var$modelWorldMatrix;
    const modelViewMatrix = $d89c9137a3d237c2$var$cameraViewMatrix.mul(worldMatrix);
    if ($d89c9137a3d237c2$var$defined(horizontal)) {
        modelViewMatrix[0][0] = $d89c9137a3d237c2$var$modelWorldMatrix[0].length();
        modelViewMatrix[0][1] = 0;
        modelViewMatrix[0][2] = 0;
    }
    if ($d89c9137a3d237c2$var$defined(vertical)) {
        modelViewMatrix[1][0] = 0;
        modelViewMatrix[1][1] = $d89c9137a3d237c2$var$modelWorldMatrix[1].length();
        modelViewMatrix[1][2] = 0;
    }
    modelViewMatrix[2][0] = 0;
    modelViewMatrix[2][1] = 0;
    modelViewMatrix[2][2] = 1;
    return $d89c9137a3d237c2$var$cameraProjectionMatrix.mul(modelViewMatrix).mul($d89c9137a3d237c2$var$positionLocal);
});
/**
 * A special version of a screen uv function that involves a depth comparison
 * when computing the final uvs. The function mitigates visual errors when
 * using viewport texture nodes for refraction purposes. Without this function
 * objects in front of a refractive surface might appear on the refractive surface
 * which is incorrect.
 *
 * @tsl
 * @function
 * @param {?Node<vec2>} uv - Optional uv coordinates. By default `screenUV` is used.
 * @return {Node<vec2>} The update uv coordinates.
 */ const $d89c9137a3d237c2$var$viewportSafeUV = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([uv = null])=>{
    const depth = $d89c9137a3d237c2$var$linearDepth();
    const depthDiff = $d89c9137a3d237c2$var$linearDepth($d89c9137a3d237c2$var$viewportDepthTexture(uv)).sub(depth);
    const finalUV = depthDiff.lessThan(0).select($d89c9137a3d237c2$var$screenUV, uv);
    return finalUV;
});
/**
 * Can be used to compute texture coordinates for animated sprite sheets.
 *
 * ```js
 * const uvNode = spritesheetUV( vec2( 6, 6 ), uv(), time.mul( animationSpeed ) );
 *
 * material.colorNode = texture( spriteSheet, uvNode );
 * ```
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$a78d04ba992dfe63 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'SpriteSheetUVNode';
    }
    /**
	 * Constructs a new sprite sheet uv node.
	 *
	 * @param {Node<vec2>} countNode - The node that defines the number of sprites in the x and y direction (e.g 6x6).
	 * @param {Node<vec2>} [uvNode=uv()] - The uv node.
	 * @param {Node<float>} [frameNode=float()] - The node that defines the current frame/sprite.
	 */ constructor(countNode, uvNode = $d89c9137a3d237c2$var$uv$1(), frameNode = $d89c9137a3d237c2$var$float(0)){
        super('vec2');
        /**
		 * The node that defines the number of sprites in the x and y direction (e.g 6x6).
		 *
		 * @type {Node<vec2>}
		 */ this.countNode = countNode;
        /**
		 * The uv node.
		 *
		 * @type {Node<vec2>}
		 */ this.uvNode = uvNode;
        /**
		 * The node that defines the current frame/sprite.
		 *
		 * @type {Node<float>}
		 */ this.frameNode = frameNode;
    }
    setup() {
        const { frameNode: frameNode, uvNode: uvNode, countNode: countNode } = this;
        const { width: width, height: height } = countNode;
        const frameNum = frameNode.mod(width.mul(height)).floor();
        const column = frameNum.mod(width);
        const row = height.sub(frameNum.add(1).div(width).ceil());
        const scale = countNode.reciprocal();
        const uvFrameOffset = $d89c9137a3d237c2$var$vec2(column, row);
        return uvNode.add(uvFrameOffset).mul(scale);
    }
}
/**
 * TSL function for creating a sprite sheet uv node.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} countNode - The node that defines the number of sprites in the x and y direction (e.g 6x6).
 * @param {?Node<vec2>} [uvNode=uv()] - The uv node.
 * @param {?Node<float>} [frameNode=float()] - The node that defines the current frame/sprite.
 * @returns {SpriteSheetUVNode}
 */ const $d89c9137a3d237c2$var$spritesheetUV = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$a78d04ba992dfe63).setParameterLength(3);
/**
 * TSL function for creating a triplanar textures node.
 *
 * Can be used for triplanar texture mapping.
 *
 * ```js
 * material.colorNode = triplanarTexture( texture( diffuseMap ) );
 * ```
 *
 * @tsl
 * @function
 * @param {Node} textureXNode - First texture node.
 * @param {?Node} [textureYNode=null] - Second texture node. When not set, the shader will sample from `textureXNode` instead.
 * @param {?Node} [textureZNode=null] - Third texture node. When not set, the shader will sample from `textureXNode` instead.
 * @param {?Node<float>} [scaleNode=float(1)] - The scale node.
 * @param {?Node<vec3>} [positionNode=positionLocal] - Vertex positions in local space.
 * @param {?Node<vec3>} [normalNode=normalLocal] - Normals in local space.
 * @returns {Node<vec4>}
 */ const $d89c9137a3d237c2$var$triplanarTextures = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([textureXNode, textureYNode = null, textureZNode = null, scaleNode = $d89c9137a3d237c2$var$float(1), positionNode = $d89c9137a3d237c2$var$positionLocal, normalNode = $d89c9137a3d237c2$var$normalLocal])=>{
    // Reference: https://github.com/keijiro/StandardTriplanar
    // Blending factor of triplanar mapping
    let bf = normalNode.abs().normalize();
    bf = bf.div(bf.dot($d89c9137a3d237c2$var$vec3(1.0)));
    // Triplanar mapping
    const tx = positionNode.yz.mul(scaleNode);
    const ty = positionNode.zx.mul(scaleNode);
    const tz = positionNode.xy.mul(scaleNode);
    // Base color
    const textureX = textureXNode.value;
    const textureY = textureYNode !== null ? textureYNode.value : textureX;
    const textureZ = textureZNode !== null ? textureZNode.value : textureX;
    const cx = $d89c9137a3d237c2$var$texture(textureX, tx).mul(bf.x);
    const cy = $d89c9137a3d237c2$var$texture(textureY, ty).mul(bf.y);
    const cz = $d89c9137a3d237c2$var$texture(textureZ, tz).mul(bf.z);
    return $d89c9137a3d237c2$var$add(cx, cy, cz);
});
/**
 * TSL function for creating a triplanar textures node.
 *
 * @tsl
 * @function
 * @param {Node} textureXNode - First texture node.
 * @param {?Node} [textureYNode=null] - Second texture node. When not set, the shader will sample from `textureXNode` instead.
 * @param {?Node} [textureZNode=null] - Third texture node. When not set, the shader will sample from `textureXNode` instead.
 * @param {?Node<float>} [scaleNode=float(1)] - The scale node.
 * @param {?Node<vec3>} [positionNode=positionLocal] - Vertex positions in local space.
 * @param {?Node<vec3>} [normalNode=normalLocal] - Normals in local space.
 * @returns {Node<vec4>}
 */ const $d89c9137a3d237c2$var$triplanarTexture = (...params)=>$d89c9137a3d237c2$var$triplanarTextures(...params);
const $d89c9137a3d237c2$var$_reflectorPlane = new (0, $329ek.Plane)();
const $d89c9137a3d237c2$var$_normal = new (0, $329ek.Vector3)();
const $d89c9137a3d237c2$var$_reflectorWorldPosition = new (0, $329ek.Vector3)();
const $d89c9137a3d237c2$var$_cameraWorldPosition = new (0, $329ek.Vector3)();
const $d89c9137a3d237c2$var$_rotationMatrix = new (0, $329ek.Matrix4)();
const $d89c9137a3d237c2$var$_lookAtPosition = new (0, $329ek.Vector3)(0, 0, -1);
const $d89c9137a3d237c2$var$clipPlane = new (0, $329ek.Vector4)();
const $d89c9137a3d237c2$var$_view = new (0, $329ek.Vector3)();
const $d89c9137a3d237c2$var$_target = new (0, $329ek.Vector3)();
const $d89c9137a3d237c2$var$_q = new (0, $329ek.Vector4)();
const $d89c9137a3d237c2$var$_size$2 = new (0, $329ek.Vector2)();
const $d89c9137a3d237c2$var$_defaultRT = new (0, $329ek.RenderTarget)();
const $d89c9137a3d237c2$var$_defaultUV = $d89c9137a3d237c2$var$screenUV.flipX();
$d89c9137a3d237c2$var$_defaultRT.depthTexture = new (0, $329ek.DepthTexture)(1, 1);
let $d89c9137a3d237c2$var$_inReflector = false;
/**
 * This node can be used to implement mirror-like flat reflective surfaces.
 *
 * ```js
 * const groundReflector = reflector();
 * material.colorNode = groundReflector;
 *
 * const plane = new Mesh( geometry, material );
 * plane.add( groundReflector.target );
 * ```
 *
 * @augments TextureNode
 */ class $d89c9137a3d237c2$export$69f7e4bb85146c53 extends $d89c9137a3d237c2$export$2dd903bc9e8140bc {
    static get type() {
        return 'ReflectorNode';
    }
    /**
	 * Constructs a new reflector node.
	 *
	 * @param {Object} [parameters={}] - An object holding configuration parameters.
	 * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
	 * @param {number} [parameters.resolutionScale=1] - The resolution scale.
	 * @param {boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
	 * @param {boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
	 * @param {boolean} [parameters.depth=false] - Whether depth data should be generated or not.
	 * @param {number} [parameters.samples] - Anti-Aliasing samples of the internal render-target.
	 * @param {TextureNode} [parameters.defaultTexture] - The default texture node.
	 * @param {ReflectorBaseNode} [parameters.reflector] - The reflector base node.
	 */ constructor(parameters = {}){
        super(parameters.defaultTexture || $d89c9137a3d237c2$var$_defaultRT.texture, $d89c9137a3d237c2$var$_defaultUV);
        /**
		 * A reference to the internal reflector base node which holds the actual implementation.
		 *
		 * @private
		 * @type {ReflectorBaseNode}
		 * @default ReflectorBaseNode
		 */ this._reflectorBaseNode = parameters.reflector || new $d89c9137a3d237c2$var$ReflectorBaseNode(this, parameters);
        /**
		 * A reference to the internal depth node.
		 *
		 * @private
		 * @type {?Node}
		 * @default null
		 */ this._depthNode = null;
        this.setUpdateMatrix(false);
    }
    /**
	 * A reference to the internal reflector node.
	 *
	 * @type {ReflectorBaseNode}
	 */ get reflector() {
        return this._reflectorBaseNode;
    }
    /**
	 * A reference to 3D object the reflector is linked to.
	 *
	 * @type {Object3D}
	 */ get target() {
        return this._reflectorBaseNode.target;
    }
    /**
	 * Returns a node representing the mirror's depth. That can be used
	 * to implement more advanced reflection effects like distance attenuation.
	 *
	 * @return {Node} The depth node.
	 */ getDepthNode() {
        if (this._depthNode === null) {
            if (this._reflectorBaseNode.depth !== true) throw new Error('THREE.ReflectorNode: Depth node can only be requested when the reflector is created with { depth: true }. ');
            this._depthNode = $d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$69f7e4bb85146c53({
                defaultTexture: $d89c9137a3d237c2$var$_defaultRT.depthTexture,
                reflector: this._reflectorBaseNode
            }));
        }
        return this._depthNode;
    }
    setup(builder) {
        // ignore if used in post-processing
        if (!builder.object.isQuadMesh) this._reflectorBaseNode.build(builder);
        return super.setup(builder);
    }
    clone() {
        const newNode = new this.constructor(this.reflectorNode);
        newNode.uvNode = this.uvNode;
        newNode.levelNode = this.levelNode;
        newNode.biasNode = this.biasNode;
        newNode.sampler = this.sampler;
        newNode.depthNode = this.depthNode;
        newNode.compareNode = this.compareNode;
        newNode.gradNode = this.gradNode;
        newNode.offsetNode = this.offsetNode;
        newNode._reflectorBaseNode = this._reflectorBaseNode;
        return newNode;
    }
    /**
	 * Frees internal resources. Should be called when the node is no longer in use.
	 */ dispose() {
        super.dispose();
        this._reflectorBaseNode.dispose();
    }
}
/**
 * Holds the actual implementation of the reflector.
 *
 * TODO: Explain why `ReflectorBaseNode`. Originally the entire logic was implemented
 * in `ReflectorNode`, see #29619.
 *
 * @private
 * @augments Node
 */ class $d89c9137a3d237c2$var$ReflectorBaseNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ReflectorBaseNode';
    }
    /**
	 * Constructs a new reflector base node.
	 *
	 * @param {TextureNode} textureNode - Represents the rendered reflections as a texture node.
	 * @param {Object} [parameters={}] - An object holding configuration parameters.
	 * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
	 * @param {number} [parameters.resolutionScale=1] - The resolution scale.
	 * @param {boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
	 * @param {boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
	 * @param {boolean} [parameters.depth=false] - Whether depth data should be generated or not.
	 * @param {number} [parameters.samples] - Anti-Aliasing samples of the internal render-target.
	 */ constructor(textureNode, parameters = {}){
        super();
        const { target: target = new (0, $329ek.Object3D)(), resolutionScale: resolutionScale = 1, generateMipmaps: generateMipmaps = false, bounces: bounces = true, depth: depth = false, samples: samples = 0 } = parameters;
        /**
		 * Represents the rendered reflections as a texture node.
		 *
		 * @type {TextureNode}
		 */ this.textureNode = textureNode;
        /**
		 * The 3D object the reflector is linked to.
		 *
		 * @type {Object3D}
		 * @default {new Object3D()}
		 */ this.target = target;
        /**
		 * The resolution scale.
		 *
		 * @type {number}
		 * @default {1}
		 */ this.resolutionScale = resolutionScale;
        if (parameters.resolution !== undefined) {
            (0, $329ek.warnOnce)('ReflectorNode: The "resolution" parameter has been renamed to "resolutionScale".'); // @deprecated r180
            this.resolutionScale = parameters.resolution;
        }
        /**
		 * Whether mipmaps should be generated or not.
		 *
		 * @type {boolean}
		 * @default {false}
		 */ this.generateMipmaps = generateMipmaps;
        /**
		 * Whether reflectors can render other reflector nodes or not.
		 *
		 * @type {boolean}
		 * @default {true}
		 */ this.bounces = bounces;
        /**
		 * Whether depth data should be generated or not.
		 *
		 * @type {boolean}
		 * @default {false}
		 */ this.depth = depth;
        /**
		 * The number of anti-aliasing samples for the render-target
		 *
		 * @type {number}
		 * @default {0}
		 */ this.samples = samples;
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.RENDER` when {@link ReflectorBaseNode#bounces}
		 * is `true`. Otherwise it's `NodeUpdateType.FRAME`.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateBeforeType = bounces ? $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER : $d89c9137a3d237c2$export$26f7a8bbd9469530.FRAME;
        /**
		 * Weak map for managing virtual cameras.
		 *
		 * @type {WeakMap<Camera, Camera>}
		 */ this.virtualCameras = new WeakMap();
        /**
		 * Weak map for managing render targets.
		 *
		 * @type {Map<Camera, RenderTarget>}
		 */ this.renderTargets = new Map();
        /**
		 * Force render even if reflector is facing away from camera.
		 *
		 * @type {boolean}
		 * @default {false}
		 */ this.forceUpdate = false;
        /**
		 * Whether the reflector has been rendered or not.
		 *
		 * When the reflector is facing away from the camera,
		 * this flag is set to `false` and the texture will be empty(black).
		 *
		 * @type {boolean}
		 * @default {false}
		 */ this.hasOutput = false;
    }
    /**
	 * Updates the resolution of the internal render target.
	 *
	 * @private
	 * @param {RenderTarget} renderTarget - The render target to resize.
	 * @param {Renderer} renderer - The renderer that is used to determine the new size.
	 */ _updateResolution(renderTarget, renderer) {
        const resolution = this.resolutionScale;
        renderer.getDrawingBufferSize($d89c9137a3d237c2$var$_size$2);
        renderTarget.setSize(Math.round($d89c9137a3d237c2$var$_size$2.width * resolution), Math.round($d89c9137a3d237c2$var$_size$2.height * resolution));
    }
    setup(builder) {
        this._updateResolution($d89c9137a3d237c2$var$_defaultRT, builder.renderer);
        return super.setup(builder);
    }
    /**
	 * Frees internal resources. Should be called when the node is no longer in use.
	 */ dispose() {
        super.dispose();
        for (const renderTarget of this.renderTargets.values())renderTarget.dispose();
    }
    /**
	 * Returns a virtual camera for the given camera. The virtual camera is used to
	 * render the scene from the reflector's view so correct reflections can be produced.
	 *
	 * @param {Camera} camera - The scene's camera.
	 * @return {Camera} The corresponding virtual camera.
	 */ getVirtualCamera(camera) {
        let virtualCamera = this.virtualCameras.get(camera);
        if (virtualCamera === undefined) {
            virtualCamera = camera.clone();
            this.virtualCameras.set(camera, virtualCamera);
        }
        return virtualCamera;
    }
    /**
	 * Returns a render target for the given camera. The reflections are rendered
	 * into this render target.
	 *
	 * @param {Camera} camera - The scene's camera.
	 * @return {RenderTarget} The render target.
	 */ getRenderTarget(camera) {
        let renderTarget = this.renderTargets.get(camera);
        if (renderTarget === undefined) {
            renderTarget = new (0, $329ek.RenderTarget)(0, 0, {
                type: (0, $329ek.HalfFloatType),
                samples: this.samples
            });
            if (this.generateMipmaps === true) {
                renderTarget.texture.minFilter = (0, $329ek.LinearMipMapLinearFilter);
                renderTarget.texture.generateMipmaps = true;
            }
            if (this.depth === true) renderTarget.depthTexture = new (0, $329ek.DepthTexture)();
            this.renderTargets.set(camera, renderTarget);
        }
        return renderTarget;
    }
    updateBefore(frame) {
        if (this.bounces === false && $d89c9137a3d237c2$var$_inReflector) return false;
        $d89c9137a3d237c2$var$_inReflector = true;
        const { scene: scene, camera: camera, renderer: renderer, material: material } = frame;
        const { target: target } = this;
        const virtualCamera = this.getVirtualCamera(camera);
        const renderTarget = this.getRenderTarget(virtualCamera);
        renderer.getDrawingBufferSize($d89c9137a3d237c2$var$_size$2);
        this._updateResolution(renderTarget, renderer);
        //
        $d89c9137a3d237c2$var$_reflectorWorldPosition.setFromMatrixPosition(target.matrixWorld);
        $d89c9137a3d237c2$var$_cameraWorldPosition.setFromMatrixPosition(camera.matrixWorld);
        $d89c9137a3d237c2$var$_rotationMatrix.extractRotation(target.matrixWorld);
        $d89c9137a3d237c2$var$_normal.set(0, 0, 1);
        $d89c9137a3d237c2$var$_normal.applyMatrix4($d89c9137a3d237c2$var$_rotationMatrix);
        $d89c9137a3d237c2$var$_view.subVectors($d89c9137a3d237c2$var$_reflectorWorldPosition, $d89c9137a3d237c2$var$_cameraWorldPosition);
        // Avoid rendering when reflector is facing away unless forcing an update
        const isFacingAway = $d89c9137a3d237c2$var$_view.dot($d89c9137a3d237c2$var$_normal) > 0;
        let needsClear = false;
        if (isFacingAway === true && this.forceUpdate === false) {
            if (this.hasOutput === false) {
                $d89c9137a3d237c2$var$_inReflector = false;
                return;
            }
            needsClear = true;
        }
        $d89c9137a3d237c2$var$_view.reflect($d89c9137a3d237c2$var$_normal).negate();
        $d89c9137a3d237c2$var$_view.add($d89c9137a3d237c2$var$_reflectorWorldPosition);
        $d89c9137a3d237c2$var$_rotationMatrix.extractRotation(camera.matrixWorld);
        $d89c9137a3d237c2$var$_lookAtPosition.set(0, 0, -1);
        $d89c9137a3d237c2$var$_lookAtPosition.applyMatrix4($d89c9137a3d237c2$var$_rotationMatrix);
        $d89c9137a3d237c2$var$_lookAtPosition.add($d89c9137a3d237c2$var$_cameraWorldPosition);
        $d89c9137a3d237c2$var$_target.subVectors($d89c9137a3d237c2$var$_reflectorWorldPosition, $d89c9137a3d237c2$var$_lookAtPosition);
        $d89c9137a3d237c2$var$_target.reflect($d89c9137a3d237c2$var$_normal).negate();
        $d89c9137a3d237c2$var$_target.add($d89c9137a3d237c2$var$_reflectorWorldPosition);
        //
        virtualCamera.coordinateSystem = camera.coordinateSystem;
        virtualCamera.position.copy($d89c9137a3d237c2$var$_view);
        virtualCamera.up.set(0, 1, 0);
        virtualCamera.up.applyMatrix4($d89c9137a3d237c2$var$_rotationMatrix);
        virtualCamera.up.reflect($d89c9137a3d237c2$var$_normal);
        virtualCamera.lookAt($d89c9137a3d237c2$var$_target);
        virtualCamera.near = camera.near;
        virtualCamera.far = camera.far;
        virtualCamera.updateMatrixWorld();
        virtualCamera.projectionMatrix.copy(camera.projectionMatrix);
        // Now update projection matrix with new clip plane, implementing code from: http://www.terathon.com/code/oblique.html
        // Paper explaining this technique: http://www.terathon.com/lengyel/Lengyel-Oblique.pdf
        $d89c9137a3d237c2$var$_reflectorPlane.setFromNormalAndCoplanarPoint($d89c9137a3d237c2$var$_normal, $d89c9137a3d237c2$var$_reflectorWorldPosition);
        $d89c9137a3d237c2$var$_reflectorPlane.applyMatrix4(virtualCamera.matrixWorldInverse);
        $d89c9137a3d237c2$var$clipPlane.set($d89c9137a3d237c2$var$_reflectorPlane.normal.x, $d89c9137a3d237c2$var$_reflectorPlane.normal.y, $d89c9137a3d237c2$var$_reflectorPlane.normal.z, $d89c9137a3d237c2$var$_reflectorPlane.constant);
        const projectionMatrix = virtualCamera.projectionMatrix;
        $d89c9137a3d237c2$var$_q.x = (Math.sign($d89c9137a3d237c2$var$clipPlane.x) + projectionMatrix.elements[8]) / projectionMatrix.elements[0];
        $d89c9137a3d237c2$var$_q.y = (Math.sign($d89c9137a3d237c2$var$clipPlane.y) + projectionMatrix.elements[9]) / projectionMatrix.elements[5];
        $d89c9137a3d237c2$var$_q.z = -1;
        $d89c9137a3d237c2$var$_q.w = (1.0 + projectionMatrix.elements[10]) / projectionMatrix.elements[14];
        // Calculate the scaled plane vector
        $d89c9137a3d237c2$var$clipPlane.multiplyScalar(1.0 / $d89c9137a3d237c2$var$clipPlane.dot($d89c9137a3d237c2$var$_q));
        const clipBias = 0;
        // Replacing the third row of the projection matrix
        projectionMatrix.elements[2] = $d89c9137a3d237c2$var$clipPlane.x;
        projectionMatrix.elements[6] = $d89c9137a3d237c2$var$clipPlane.y;
        projectionMatrix.elements[10] = renderer.coordinateSystem === (0, $329ek.WebGPUCoordinateSystem) ? $d89c9137a3d237c2$var$clipPlane.z - clipBias : $d89c9137a3d237c2$var$clipPlane.z + 1.0 - clipBias;
        projectionMatrix.elements[14] = $d89c9137a3d237c2$var$clipPlane.w;
        //
        this.textureNode.value = renderTarget.texture;
        if (this.depth === true) this.textureNode.getDepthNode().value = renderTarget.depthTexture;
        material.visible = false;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentMRT = renderer.getMRT();
        const currentAutoClear = renderer.autoClear;
        renderer.setMRT(null);
        renderer.setRenderTarget(renderTarget);
        renderer.autoClear = true;
        const previousName = scene.name;
        scene.name = (scene.name || 'Scene') + ' [ Reflector ]'; // TODO: Add bounce index
        if (needsClear) {
            renderer.clear();
            this.hasOutput = false;
        } else {
            renderer.render(scene, virtualCamera);
            this.hasOutput = true;
        }
        scene.name = previousName;
        renderer.setMRT(currentMRT);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.autoClear = currentAutoClear;
        material.visible = true;
        $d89c9137a3d237c2$var$_inReflector = false;
        this.forceUpdate = false;
    }
    /**
	 * The resolution scale.
	 *
	 * @deprecated
	 * @type {number}
	 * @default {1}
	 */ get resolution() {
        (0, $329ek.warnOnce)('ReflectorNode: The "resolution" property has been renamed to "resolutionScale".'); // @deprecated r180
        return this.resolutionScale;
    }
    set resolution(value) {
        (0, $329ek.warnOnce)('ReflectorNode: The "resolution" property has been renamed to "resolutionScale".'); // @deprecated r180
        this.resolutionScale = value;
    }
}
/**
 * TSL function for creating a reflector node.
 *
 * @tsl
 * @function
 * @param {Object} [parameters={}] - An object holding configuration parameters.
 * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
 * @param {number} [parameters.resolution=1] - The resolution scale.
 * @param {boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
 * @param {boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
 * @param {boolean} [parameters.depth=false] - Whether depth data should be generated or not.
 * @param {number} [parameters.samples] - Anti-Aliasing samples of the internal render-target.
 * @param {TextureNode} [parameters.defaultTexture] - The default texture node.
 * @param {ReflectorBaseNode} [parameters.reflector] - The reflector base node.
 * @returns {ReflectorNode}
 */ const $d89c9137a3d237c2$var$reflector = (parameters)=>new $d89c9137a3d237c2$export$69f7e4bb85146c53(parameters);
const $d89c9137a3d237c2$var$_camera = /*@__PURE__*/ new (0, $329ek.OrthographicCamera)(-1, 1, 1, -1, 0, 1);
/**
 * The purpose of this special geometry is to fill the entire viewport with a single triangle.
 *
 * Reference: {@link https://github.com/mrdoob/three.js/pull/21358}
 *
 * @private
 * @augments BufferGeometry
 */ class $d89c9137a3d237c2$var$QuadGeometry extends (0, $329ek.BufferGeometry) {
    /**
	 * Constructs a new quad geometry.
	 *
	 * @param {boolean} [flipY=false] - Whether the uv coordinates should be flipped along the vertical axis or not.
	 */ constructor(flipY = false){
        super();
        const uv = flipY === false ? [
            0,
            -1,
            0,
            1,
            2,
            1
        ] : [
            0,
            2,
            0,
            0,
            2,
            0
        ];
        this.setAttribute('position', new (0, $329ek.Float32BufferAttribute)([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3));
        this.setAttribute('uv', new (0, $329ek.Float32BufferAttribute)(uv, 2));
    }
}
const $d89c9137a3d237c2$var$_geometry = /*@__PURE__*/ new $d89c9137a3d237c2$var$QuadGeometry();
/**
 * This module is a helper for passes which need to render a full
 * screen effect which is quite common in context of post processing.
 *
 * The intended usage is to reuse a single quad mesh for rendering
 * subsequent passes by just reassigning the `material` reference.
 *
 * Note: This module can only be used with `WebGPURenderer`.
 *
 * @augments Mesh
 */ class $d89c9137a3d237c2$export$266ce19fe399ee9a extends (0, $329ek.Mesh) {
    /**
	 * Constructs a new quad mesh.
	 *
	 * @param {?Material} [material=null] - The material to render the quad mesh with.
	 */ constructor(material = null){
        super($d89c9137a3d237c2$var$_geometry, material);
        /**
		 * The camera to render the quad mesh with.
		 *
		 * @type {OrthographicCamera}
		 * @readonly
		 */ this.camera = $d89c9137a3d237c2$var$_camera;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadMesh = true;
    }
    /**
	 * Async version of `render()`.
	 *
	 * @async
	 * @deprecated
	 * @param {Renderer} renderer - The renderer.
	 * @return {Promise} A Promise that resolves when the render has been finished.
	 */ async renderAsync(renderer) {
        (0, $329ek.warnOnce)('QuadMesh: "renderAsync()" has been deprecated. Use "render()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await renderer.init();
        renderer.render(this, $d89c9137a3d237c2$var$_camera);
    }
    /**
	 * Renders the quad mesh
	 *
	 * @param {Renderer} renderer - The renderer.
	 */ render(renderer) {
        renderer.render(this, $d89c9137a3d237c2$var$_camera);
    }
}
const $d89c9137a3d237c2$var$_size$1 = /*@__PURE__*/ new (0, $329ek.Vector2)();
/**
 * `RTTNode` takes another node and uses it with a `QuadMesh` to render into a texture (RTT).
 * This module is especially relevant in context of post processing where certain nodes require
 * texture input for their effects. With the helper function `convertToTexture()` which is based
 * on this module, the node system can automatically ensure texture input if required.
 *
 * @augments TextureNode
 */ class $d89c9137a3d237c2$export$14d053dc5e3b4165 extends $d89c9137a3d237c2$export$2dd903bc9e8140bc {
    static get type() {
        return 'RTTNode';
    }
    /**
	 * Constructs a new RTT node.
	 *
	 * @param {Node} node - The node to render a texture with.
	 * @param {?number} [width=null] - The width of the internal render target. If not width is applied, the render target is automatically resized.
	 * @param {?number} [height=null] - The height of the internal render target.
	 * @param {Object} [options={type:HalfFloatType}] - The options for the internal render target.
	 */ constructor(node, width = null, height = null, options = {
        type: (0, $329ek.HalfFloatType)
    }){
        const renderTarget = new (0, $329ek.RenderTarget)(width, height, options);
        super(renderTarget.texture, $d89c9137a3d237c2$var$uv$1());
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRTTNode = true;
        /**
		 * The node to render a texture with.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The width of the internal render target.
		 * If not width is applied, the render target is automatically resized.
		 *
		 * @type {?number}
		 * @default null
		 */ this.width = width;
        /**
		 * The height of the internal render target.
		 *
		 * @type {?number}
		 * @default null
		 */ this.height = height;
        /**
		 * The pixel ratio
		 *
		 * @type {number}
		 * @default 1
		 */ this.pixelRatio = 1;
        /**
		 * The render target
		 *
		 * @type {RenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * Whether the texture requires an update or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.textureNeedsUpdate = true;
        /**
		 * Whether the texture should automatically be updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
        /**
		 * The node which is used with the quad mesh for RTT.
		 *
		 * @private
		 * @type {Node}
		 * @default null
		 */ this._rttNode = null;
        /**
		 * The internal quad mesh for RTT.
		 *
		 * @private
		 * @type {QuadMesh}
		 */ this._quadMesh = new $d89c9137a3d237c2$export$266ce19fe399ee9a(new $d89c9137a3d237c2$export$caaf3b30a544c946());
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.RENDER` since the node updates
		 * the texture once per render in its {@link RTTNode#updateBefore} method.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateBeforeType = $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER;
    }
    /**
	 * Whether the internal render target should automatically be resized or not.
	 *
	 * @type {boolean}
	 * @readonly
	 * @default true
	 */ get autoResize() {
        return this.width === null;
    }
    setup(builder) {
        this._rttNode = this.node.context(builder.getSharedContext());
        this._quadMesh.material.name = 'RTT';
        this._quadMesh.material.needsUpdate = true;
        return super.setup(builder);
    }
    /**
	 * Sets the size of the internal render target
	 *
	 * @param {number} width - The width to set.
	 * @param {number} height - The width to set.
	 */ setSize(width, height) {
        this.width = width;
        this.height = height;
        const effectiveWidth = width * this.pixelRatio;
        const effectiveHeight = height * this.pixelRatio;
        this.renderTarget.setSize(effectiveWidth, effectiveHeight);
        this.textureNeedsUpdate = true;
    }
    /**
	 * Sets the pixel ratio. This will also resize the render target.
	 *
	 * @param {number} pixelRatio - The pixel ratio to set.
	 */ setPixelRatio(pixelRatio) {
        this.pixelRatio = pixelRatio;
        this.setSize(this.width, this.height);
    }
    updateBefore({ renderer: renderer }) {
        if (this.textureNeedsUpdate === false && this.autoUpdate === false) return;
        this.textureNeedsUpdate = false;
        //
        if (this.autoResize === true) {
            const pixelRatio = renderer.getPixelRatio();
            const size = renderer.getSize($d89c9137a3d237c2$var$_size$1);
            const effectiveWidth = Math.floor(size.width * pixelRatio);
            const effectiveHeight = Math.floor(size.height * pixelRatio);
            if (effectiveWidth !== this.renderTarget.width || effectiveHeight !== this.renderTarget.height) {
                this.renderTarget.setSize(effectiveWidth, effectiveHeight);
                this.textureNeedsUpdate = true;
            }
        }
        //
        let name = 'RTT';
        if (this.node.name) name = this.node.name + ' [ ' + name + ' ]';
        this._quadMesh.material.fragmentNode = this._rttNode;
        this._quadMesh.name = name;
        //
        const currentRenderTarget = renderer.getRenderTarget();
        renderer.setRenderTarget(this.renderTarget);
        this._quadMesh.render(renderer);
        renderer.setRenderTarget(currentRenderTarget);
    }
    clone() {
        const newNode = new $d89c9137a3d237c2$export$2dd903bc9e8140bc(this.value, this.uvNode, this.levelNode);
        newNode.sampler = this.sampler;
        newNode.referenceNode = this;
        return newNode;
    }
}
/**
 * TSL function for creating a RTT node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node to render a texture with.
 * @param {?number} [width=null] - The width of the internal render target. If not width is applied, the render target is automatically resized.
 * @param {?number} [height=null] - The height of the internal render target.
 * @param {Object} [options={type:HalfFloatType}] - The options for the internal render target.
 * @returns {RTTNode}
 */ const $d89c9137a3d237c2$var$rtt = (node, ...params)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$14d053dc5e3b4165($d89c9137a3d237c2$var$nodeObject(node), ...params));
/**
 * TSL function for converting nodes to textures nodes.
 *
 * @tsl
 * @function
 * @param {Node} node - The node to render a texture with.
 * @param {?number} [width=null] - The width of the internal render target. If not width is applied, the render target is automatically resized.
 * @param {?number} [height=null] - The height of the internal render target.
 * @param {Object} [options={type:HalfFloatType}] - The options for the internal render target.
 * @returns {RTTNode}
 */ const $d89c9137a3d237c2$var$convertToTexture = (node, ...params)=>{
    if (node.isSampleNode || node.isTextureNode) return node;
    if (node.isPassNode) return node.getTextureNode();
    return $d89c9137a3d237c2$var$rtt(node, ...params);
};
/**
 * Computes a position in view space based on a fragment's screen position expressed as uv coordinates, the fragments
 * depth value and the camera's inverse projection matrix.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} screenPosition - The fragment's screen position expressed as uv coordinates.
 * @param {Node<float>} depth - The fragment's depth value.
 * @param {Node<mat4>} projectionMatrixInverse - The camera's inverse projection matrix.
 * @return {Node<vec3>} The fragments position in view space.
 */ const $d89c9137a3d237c2$var$getViewPosition = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([screenPosition, depth, projectionMatrixInverse], builder)=>{
    let clipSpacePosition;
    if (builder.renderer.coordinateSystem === (0, $329ek.WebGPUCoordinateSystem)) {
        screenPosition = $d89c9137a3d237c2$var$vec2(screenPosition.x, screenPosition.y.oneMinus()).mul(2.0).sub(1.0);
        clipSpacePosition = $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$vec3(screenPosition, depth), 1.0);
    } else clipSpacePosition = $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$vec3(screenPosition.x, screenPosition.y.oneMinus(), depth).mul(2.0).sub(1.0), 1.0);
    const viewSpacePosition = $d89c9137a3d237c2$var$vec4(projectionMatrixInverse.mul(clipSpacePosition));
    return viewSpacePosition.xyz.div(viewSpacePosition.w);
});
/**
 * Computes a screen position expressed as uv coordinates based on a fragment's position in view space
 * and the camera's projection matrix
 *
 * @tsl
 * @function
 * @param {Node<vec3>} viewPosition - The fragments position in view space.
 * @param {Node<mat4>} projectionMatrix - The camera's projection matrix.
 * @return {Node<vec2>} The fragment's screen position expressed as uv coordinates.
 */ const $d89c9137a3d237c2$var$getScreenPosition = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([viewPosition, projectionMatrix])=>{
    const sampleClipPos = projectionMatrix.mul($d89c9137a3d237c2$var$vec4(viewPosition, 1.0));
    const sampleUv = sampleClipPos.xy.div(sampleClipPos.w).mul(0.5).add(0.5).toVar();
    return $d89c9137a3d237c2$var$vec2(sampleUv.x, sampleUv.y.oneMinus());
});
/**
 * Computes a normal vector based on depth data. Can be used as a fallback when no normal render
 * target is available or if flat surface normals are required.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} uv - The texture coordinate.
 * @param {DepthTexture} depthTexture - The depth texture.
 * @param {Node<mat4>} projectionMatrixInverse - The camera's inverse projection matrix.
 * @return {Node<vec3>} The computed normal vector.
 */ const $d89c9137a3d237c2$var$getNormalFromDepth = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([uv, depthTexture, projectionMatrixInverse])=>{
    const size = $d89c9137a3d237c2$var$textureSize($d89c9137a3d237c2$var$textureLoad(depthTexture));
    const p = $d89c9137a3d237c2$var$ivec2(uv.mul(size)).toVar();
    const c0 = $d89c9137a3d237c2$var$textureLoad(depthTexture, p).toVar();
    const l2 = $d89c9137a3d237c2$var$textureLoad(depthTexture, p.sub($d89c9137a3d237c2$var$ivec2(2, 0))).toVar();
    const l1 = $d89c9137a3d237c2$var$textureLoad(depthTexture, p.sub($d89c9137a3d237c2$var$ivec2(1, 0))).toVar();
    const r1 = $d89c9137a3d237c2$var$textureLoad(depthTexture, p.add($d89c9137a3d237c2$var$ivec2(1, 0))).toVar();
    const r2 = $d89c9137a3d237c2$var$textureLoad(depthTexture, p.add($d89c9137a3d237c2$var$ivec2(2, 0))).toVar();
    const b2 = $d89c9137a3d237c2$var$textureLoad(depthTexture, p.add($d89c9137a3d237c2$var$ivec2(0, 2))).toVar();
    const b1 = $d89c9137a3d237c2$var$textureLoad(depthTexture, p.add($d89c9137a3d237c2$var$ivec2(0, 1))).toVar();
    const t1 = $d89c9137a3d237c2$var$textureLoad(depthTexture, p.sub($d89c9137a3d237c2$var$ivec2(0, 1))).toVar();
    const t2 = $d89c9137a3d237c2$var$textureLoad(depthTexture, p.sub($d89c9137a3d237c2$var$ivec2(0, 2))).toVar();
    const dl = $d89c9137a3d237c2$var$abs($d89c9137a3d237c2$var$sub($d89c9137a3d237c2$var$float(2).mul(l1).sub(l2), c0)).toVar();
    const dr = $d89c9137a3d237c2$var$abs($d89c9137a3d237c2$var$sub($d89c9137a3d237c2$var$float(2).mul(r1).sub(r2), c0)).toVar();
    const db = $d89c9137a3d237c2$var$abs($d89c9137a3d237c2$var$sub($d89c9137a3d237c2$var$float(2).mul(b1).sub(b2), c0)).toVar();
    const dt = $d89c9137a3d237c2$var$abs($d89c9137a3d237c2$var$sub($d89c9137a3d237c2$var$float(2).mul(t1).sub(t2), c0)).toVar();
    const ce = $d89c9137a3d237c2$var$getViewPosition(uv, c0, projectionMatrixInverse).toVar();
    const dpdx = dl.lessThan(dr).select(ce.sub($d89c9137a3d237c2$var$getViewPosition(uv.sub($d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$float(1).div(size.x), 0)), l1, projectionMatrixInverse)), ce.negate().add($d89c9137a3d237c2$var$getViewPosition(uv.add($d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$float(1).div(size.x), 0)), r1, projectionMatrixInverse)));
    const dpdy = db.lessThan(dt).select(ce.sub($d89c9137a3d237c2$var$getViewPosition(uv.add($d89c9137a3d237c2$var$vec2(0, $d89c9137a3d237c2$var$float(1).div(size.y))), b1, projectionMatrixInverse)), ce.negate().add($d89c9137a3d237c2$var$getViewPosition(uv.sub($d89c9137a3d237c2$var$vec2(0, $d89c9137a3d237c2$var$float(1).div(size.y))), t1, projectionMatrixInverse)));
    return $d89c9137a3d237c2$var$normalize($d89c9137a3d237c2$var$cross(dpdx, dpdy));
});
/**
 * Interleaved Gradient Noise (IGN) from Jimenez 2014.
 *
 * IGN has "low discrepancy" resulting in evenly distributed samples. It's superior compared to
 * default white noise, blue noise or Bayer.
 *
 * References:
 * - {@link https://www.iryoku.com/next-generation-post-processing-in-call-of-duty-advanced-warfare/}
 * - {@link https://blog.demofox.org/2022/01/01/interleaved-gradient-noise-a-different-kind-of-low-discrepancy-sequence/}
 *
 * @tsl
 * @function
 * @param {Node<vec2>} position - The input position, usually screen coordinates.
 * @return {Node<float>} The noise value.
 */ const $d89c9137a3d237c2$var$interleavedGradientNoise = $d89c9137a3d237c2$var$Fn(([position])=>{
    return $d89c9137a3d237c2$var$fract($d89c9137a3d237c2$var$float(52.9829189).mul($d89c9137a3d237c2$var$fract($d89c9137a3d237c2$var$dot(position, $d89c9137a3d237c2$var$vec2(0.06711056, 0.00583715)))));
}).setLayout({
    name: 'interleavedGradientNoise',
    type: 'float',
    inputs: [
        {
            name: 'position',
            type: 'vec2'
        }
    ]
});
/**
 * Vogel disk sampling for uniform circular distribution.
 *
 * This function generates sample points distributed uniformly on a disk using the golden angle,
 * resulting in an efficient low-discrepancy sequence for sampling. The rotation parameter (phi)
 * allows randomizing the pattern per-pixel when combined with IGN.
 *
 * @tsl
 * @function
 * @param {Node<int>} sampleIndex - The index of the current sample (0-based).
 * @param {Node<int>} samplesCount - The total number of samples.
 * @param {Node<float>} phi - Rotation angle in radians (typically from IGN * 2π).
 * @return {Node<vec2>} A 2D point on the unit disk.
 */ const $d89c9137a3d237c2$var$vogelDiskSample = $d89c9137a3d237c2$var$Fn(([sampleIndex, samplesCount, phi])=>{
    const goldenAngle = $d89c9137a3d237c2$var$float(2.399963229728653); // 2π * (2 - φ) where φ is golden ratio
    const r = $d89c9137a3d237c2$var$sqrt($d89c9137a3d237c2$var$float(sampleIndex).add(0.5).div($d89c9137a3d237c2$var$float(samplesCount)));
    const theta = $d89c9137a3d237c2$var$float(sampleIndex).mul(goldenAngle).add(phi);
    return $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$cos(theta), $d89c9137a3d237c2$var$sin(theta)).mul(r);
}).setLayout({
    name: 'vogelDiskSample',
    type: 'vec2',
    inputs: [
        {
            name: 'sampleIndex',
            type: 'int'
        },
        {
            name: 'samplesCount',
            type: 'int'
        },
        {
            name: 'phi',
            type: 'float'
        }
    ]
});
/**
 * Class representing a node that samples a value using a provided callback function.
 *
 * @extends Node
 */ class $d89c9137a3d237c2$var$SampleNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    /**
	 * Returns the type of the node.
	 *
	 * @type {string}
	 * @readonly
	 * @static
	 */ static get type() {
        return 'SampleNode';
    }
    /**
	 * Creates an instance of SampleNode.
	 *
	 * @param {Function} callback - The function to be called when sampling. Should accept a UV node and return a value.
	 * @param {?Node<vec2>} [uvNode=null] - The UV node to be used in the texture sampling.
	 */ constructor(callback, uvNode = null){
        super();
        this.callback = callback;
        /**
		 * Represents the texture coordinates.
		 *
		 * @type {?Node<vec2|vec3>}
		 * @default null
		 */ this.uvNode = uvNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSampleNode = true;
    }
    /**
	 * Sets up the node by sampling with the default UV accessor.
	 *
	 * @returns {Node} The result of the callback function when called with the UV node.
	 */ setup() {
        return this.sample($d89c9137a3d237c2$var$uv$1());
    }
    /**
	 * Calls the callback function with the provided UV node.
	 *
	 * @param {Node<vec2>} uv - The UV node or value to be passed to the callback.
	 * @returns {Node} The result of the callback function.
	 */ sample(uv) {
        return this.callback(uv);
    }
}
/**
 * Helper function to create a SampleNode wrapped as a node object.
 *
 * @function
 * @param {Function} callback - The function to be called when sampling. Should accept a UV node and return a value.
 * @param {?Node<vec2>} [uv=null] - The UV node to be used in the texture sampling.
 * @returns {SampleNode} The created SampleNode instance wrapped as a node object.
 */ const $d89c9137a3d237c2$var$sample = (callback, uv = null)=>new $d89c9137a3d237c2$var$SampleNode(callback, $d89c9137a3d237c2$var$nodeObject(uv));
/**
 * EventNode is a node that executes a callback during specific update phases.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$5deccdd1dfcccf57 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'EventNode';
    }
    /**
	 * Creates an EventNode.
	 *
	 * @param {string} eventType - The type of event
	 * @param {Function} callback - The callback to execute on update.
	 */ constructor(eventType, callback){
        super('void');
        this.eventType = eventType;
        this.callback = callback;
        if (eventType === $d89c9137a3d237c2$export$5deccdd1dfcccf57.OBJECT) this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT;
        else if (eventType === $d89c9137a3d237c2$export$5deccdd1dfcccf57.MATERIAL) this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER;
        else if (eventType === $d89c9137a3d237c2$export$5deccdd1dfcccf57.BEFORE_OBJECT) this.updateBeforeType = $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT;
        else if (eventType === $d89c9137a3d237c2$export$5deccdd1dfcccf57.BEFORE_MATERIAL) this.updateBeforeType = $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER;
    }
    update(frame) {
        this.callback(frame);
    }
    updateBefore(frame) {
        this.callback(frame);
    }
}
$d89c9137a3d237c2$export$5deccdd1dfcccf57.OBJECT = 'object';
$d89c9137a3d237c2$export$5deccdd1dfcccf57.MATERIAL = 'material';
$d89c9137a3d237c2$export$5deccdd1dfcccf57.BEFORE_OBJECT = 'beforeObject';
$d89c9137a3d237c2$export$5deccdd1dfcccf57.BEFORE_MATERIAL = 'beforeMaterial';
/**
 * Helper to create an EventNode and add it to the stack.
 *
 * @param {string} type - The event type.
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $d89c9137a3d237c2$var$createEvent = (type, callback)=>new $d89c9137a3d237c2$export$5deccdd1dfcccf57(type, callback).toStack();
/**
 * Creates an event that triggers a function every time an object (Mesh|Sprite) is rendered.
 *
 * The event will be bound to the declared TSL function `Fn()`; it must be declared within a `Fn()` or the JS function call must be inherited from one.
 *
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $d89c9137a3d237c2$var$OnObjectUpdate = (callback)=>$d89c9137a3d237c2$var$createEvent($d89c9137a3d237c2$export$5deccdd1dfcccf57.OBJECT, callback);
/**
 * Creates an event that triggers a function when the first object that uses the material is rendered.
 *
 * The event will be bound to the declared TSL function `Fn()`; it must be declared within a `Fn()` or the JS function call must be inherited from one.
 *
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $d89c9137a3d237c2$var$OnMaterialUpdate = (callback)=>$d89c9137a3d237c2$var$createEvent($d89c9137a3d237c2$export$5deccdd1dfcccf57.MATERIAL, callback);
/**
 * Creates an event that triggers a function before an object (Mesh|Sprite) is updated.
 *
 * The event will be bound to the declared TSL function `Fn()`; it must be declared within a `Fn()` or the JS function call must be inherited from one.
 *
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $d89c9137a3d237c2$var$OnBeforeObjectUpdate = (callback)=>$d89c9137a3d237c2$var$createEvent($d89c9137a3d237c2$export$5deccdd1dfcccf57.BEFORE_OBJECT, callback);
/**
 * Creates an event that triggers a function before the material is updated.
 *
 * The event will be bound to the declared TSL function `Fn()`; it must be declared within a `Fn()` or the JS function call must be inherited from one.
 *
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $d89c9137a3d237c2$var$OnBeforeMaterialUpdate = (callback)=>$d89c9137a3d237c2$var$createEvent($d89c9137a3d237c2$export$5deccdd1dfcccf57.BEFORE_MATERIAL, callback);
/**
 * This special type of instanced buffer attribute is intended for compute shaders.
 * In earlier three.js versions it was only possible to update attribute data
 * on the CPU via JavaScript and then upload the data to the GPU. With the
 * new material system and renderer it is now possible to use compute shaders
 * to compute the data for an attribute more efficiently on the GPU.
 *
 * The idea is to create an instance of this class and provide it as an input
 * to {@link StorageBufferNode}.
 *
 * Note: This type of buffer attribute can only be used with `WebGPURenderer`.
 *
 * @augments InstancedBufferAttribute
 */ class $d89c9137a3d237c2$export$281e97eb7155319a extends (0, $329ek.InstancedBufferAttribute) {
    /**
	 * Constructs a new storage instanced buffer attribute.
	 *
	 * @param {number|TypedArray} count - The item count. It is also valid to pass a typed array as an argument.
	 * The subsequent parameters are then obsolete.
	 * @param {number} itemSize - The item size.
	 * @param {TypedArray.constructor} [typeClass=Float32Array] - A typed array constructor.
	 */ constructor(count, itemSize, typeClass = Float32Array){
        const array = ArrayBuffer.isView(count) ? count : new typeClass(count * itemSize);
        super(array, itemSize);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageInstancedBufferAttribute = true;
    }
}
/**
 * This special type of buffer attribute is intended for compute shaders.
 * In earlier three.js versions it was only possible to update attribute data
 * on the CPU via JavaScript and then upload the data to the GPU. With the
 * new material system and renderer it is now possible to use compute shaders
 * to compute the data for an attribute more efficiently on the GPU.
 *
 * The idea is to create an instance of this class and provide it as an input
 * to {@link StorageBufferNode}.
 *
 * Note: This type of buffer attribute can only be used with `WebGPURenderer`.
 *
 * @augments BufferAttribute
 */ class $d89c9137a3d237c2$export$5eb1a076d3725e22 extends (0, $329ek.BufferAttribute) {
    /**
	 * Constructs a new storage buffer attribute.
	 *
	 * @param {number|TypedArray} count - The item count. It is also valid to pass a typed array as an argument.
	 * The subsequent parameters are then obsolete.
	 * @param {number} itemSize - The item size.
	 * @param {TypedArray.constructor} [typeClass=Float32Array] - A typed array constructor.
	 */ constructor(count, itemSize, typeClass = Float32Array){
        const array = ArrayBuffer.isView(count) ? count : new typeClass(count * itemSize);
        super(array, itemSize);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageBufferAttribute = true;
    }
}
/**
 * TSL function for creating a storage buffer node with a configured `StorageBufferAttribute`.
 *
 * @tsl
 * @function
 * @param {number|TypedArray} count - The data count. It is also valid to pass a typed array as an argument.
 * @param {string|Struct} [type='float'] - The data type.
 * @returns {StorageBufferNode}
 */ const $d89c9137a3d237c2$var$attributeArray = (count, type = 'float')=>{
    let itemSize, typedArray;
    if (type.isStruct === true) {
        itemSize = type.layout.getLength();
        typedArray = $d89c9137a3d237c2$var$getTypedArrayFromType('float');
    } else {
        itemSize = $d89c9137a3d237c2$var$getLengthFromType(type);
        typedArray = $d89c9137a3d237c2$var$getTypedArrayFromType(type);
    }
    const buffer = new $d89c9137a3d237c2$export$5eb1a076d3725e22(count, itemSize, typedArray);
    const node = $d89c9137a3d237c2$var$storage(buffer, type, count);
    return node;
};
/**
 * TSL function for creating a storage buffer node with a configured `StorageInstancedBufferAttribute`.
 *
 * @tsl
 * @function
 * @param {number|TypedArray} count - The data count. It is also valid to pass a typed array as an argument.
 * @param {string|Struct} [type='float'] - The data type.
 * @returns {StorageBufferNode}
 */ const $d89c9137a3d237c2$var$instancedArray = (count, type = 'float')=>{
    let itemSize, typedArray;
    if (type.isStruct === true) {
        itemSize = type.layout.getLength();
        typedArray = $d89c9137a3d237c2$var$getTypedArrayFromType('float');
    } else {
        itemSize = $d89c9137a3d237c2$var$getLengthFromType(type);
        typedArray = $d89c9137a3d237c2$var$getTypedArrayFromType(type);
    }
    const buffer = new $d89c9137a3d237c2$export$281e97eb7155319a(count, itemSize, typedArray);
    const node = $d89c9137a3d237c2$var$storage(buffer, type, count);
    return node;
};
/**
 * A node for representing the uv coordinates of points.
 *
 * Can only be used with a WebGL backend. In WebGPU, point
 * primitives always have the size of one pixel and can thus
 * can't be used as sprite-like objects that display textures.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$5e50f6b6071cd75 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'PointUVNode';
    }
    /**
	 * Constructs a new point uv node.
	 */ constructor(){
        super('vec2');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointUVNode = true;
    }
    generate() {
        return 'vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y )';
    }
}
/**
 * TSL object that represents the uv coordinates of points.
 *
 * @tsl
 * @type {PointUVNode}
 */ const $d89c9137a3d237c2$var$pointUV = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$5e50f6b6071cd75);
const $d89c9137a3d237c2$var$_e1 = /*@__PURE__*/ new (0, $329ek.Euler)();
const $d89c9137a3d237c2$var$_m1 = /*@__PURE__*/ new (0, $329ek.Matrix4)();
/**
 * This module allows access to a collection of scene properties. The following predefined TSL objects
 * are available for easier use:
 *
 * - `backgroundBlurriness`: A node that represents the scene's background blurriness.
 * - `backgroundIntensity`: A node that represents the scene's background intensity.
 * - `backgroundRotation`: A node that represents the scene's background rotation.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$d6c2142c3b4e78d5 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'SceneNode';
    }
    /**
	 * Constructs a new scene node.
	 *
	 * @param {('backgroundBlurriness'|'backgroundIntensity'|'backgroundRotation')} scope - The scope defines the type of scene property that is accessed.
	 * @param {?Scene} [scene=null] - A reference to the scene.
	 */ constructor(scope = $d89c9137a3d237c2$export$d6c2142c3b4e78d5.BACKGROUND_BLURRINESS, scene = null){
        super();
        /**
		 * The scope defines the type of scene property that is accessed.
		 *
		 * @type {('backgroundBlurriness'|'backgroundIntensity'|'backgroundRotation')}
		 */ this.scope = scope;
        /**
		 * A reference to the scene that is going to be accessed.
		 *
		 * @type {?Scene}
		 * @default null
		 */ this.scene = scene;
    }
    /**
	 * Depending on the scope, the method returns a different type of node that represents
	 * the respective scene property.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node} The output node.
	 */ setup(builder) {
        const scope = this.scope;
        const scene = this.scene !== null ? this.scene : builder.scene;
        let output;
        if (scope === $d89c9137a3d237c2$export$d6c2142c3b4e78d5.BACKGROUND_BLURRINESS) output = $d89c9137a3d237c2$var$reference('backgroundBlurriness', 'float', scene);
        else if (scope === $d89c9137a3d237c2$export$d6c2142c3b4e78d5.BACKGROUND_INTENSITY) output = $d89c9137a3d237c2$var$reference('backgroundIntensity', 'float', scene);
        else if (scope === $d89c9137a3d237c2$export$d6c2142c3b4e78d5.BACKGROUND_ROTATION) output = $d89c9137a3d237c2$var$uniform('mat4').setName('backgroundRotation').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(()=>{
            const background = scene.background;
            if (background !== null && background.isTexture && background.mapping !== (0, $329ek.UVMapping)) {
                $d89c9137a3d237c2$var$_e1.copy(scene.backgroundRotation);
                // accommodate left-handed frame
                $d89c9137a3d237c2$var$_e1.x *= -1;
                $d89c9137a3d237c2$var$_e1.y *= -1;
                $d89c9137a3d237c2$var$_e1.z *= -1;
                $d89c9137a3d237c2$var$_m1.makeRotationFromEuler($d89c9137a3d237c2$var$_e1);
            } else $d89c9137a3d237c2$var$_m1.identity();
            return $d89c9137a3d237c2$var$_m1;
        });
        else (0, $329ek.error)('SceneNode: Unknown scope:', scope);
        return output;
    }
}
$d89c9137a3d237c2$export$d6c2142c3b4e78d5.BACKGROUND_BLURRINESS = 'backgroundBlurriness';
$d89c9137a3d237c2$export$d6c2142c3b4e78d5.BACKGROUND_INTENSITY = 'backgroundIntensity';
$d89c9137a3d237c2$export$d6c2142c3b4e78d5.BACKGROUND_ROTATION = 'backgroundRotation';
/**
 * TSL object that represents the scene's background blurriness.
 *
 * @tsl
 * @type {SceneNode}
 */ const $d89c9137a3d237c2$var$backgroundBlurriness = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$d6c2142c3b4e78d5, $d89c9137a3d237c2$export$d6c2142c3b4e78d5.BACKGROUND_BLURRINESS);
/**
 * TSL object that represents the scene's background intensity.
 *
 * @tsl
 * @type {SceneNode}
 */ const $d89c9137a3d237c2$var$backgroundIntensity = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$d6c2142c3b4e78d5, $d89c9137a3d237c2$export$d6c2142c3b4e78d5.BACKGROUND_INTENSITY);
/**
 * TSL object that represents the scene's background rotation.
 *
 * @tsl
 * @type {SceneNode}
 */ const $d89c9137a3d237c2$var$backgroundRotation = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$export$d6c2142c3b4e78d5, $d89c9137a3d237c2$export$d6c2142c3b4e78d5.BACKGROUND_ROTATION);
/**
 * This special version of a texture node can be used to
 * write data into a storage texture with a compute shader.
 *
 * ```js
 * const storageTexture = new THREE.StorageTexture( width, height );
 *
 * const computeTexture = Fn( ( { storageTexture } ) => {
 *
 * 	const posX = instanceIndex.mod( width );
 * 	const posY = instanceIndex.div( width );
 * 	const indexUV = uvec2( posX, posY );
 *
 * 	// generate RGB values
 *
 * 	const r = 1;
 * 	const g = 1;
 * 	const b = 1;
 *
 * 	textureStore( storageTexture, indexUV, vec4( r, g, b, 1 ) ).toWriteOnly();
 *
 * } );
 *
 * const computeNode = computeTexture( { storageTexture } ).compute( width * height );
 * renderer.computeAsync( computeNode );
 * ```
 *
 * This node can only be used with a WebGPU backend.
 *
 * @augments TextureNode
 */ class $d89c9137a3d237c2$export$f9d0185498cbffc2 extends $d89c9137a3d237c2$export$2dd903bc9e8140bc {
    static get type() {
        return 'StorageTextureNode';
    }
    /**
	 * Constructs a new storage texture node.
	 *
	 * @param {StorageTexture} value - The storage texture.
	 * @param {Node<vec2|vec3>} uvNode - The uv node.
	 * @param {?Node} [storeNode=null] - The value node that should be stored in the texture.
	 */ constructor(value, uvNode, storeNode = null){
        super(value, uvNode);
        /**
		 * The value node that should be stored in the texture.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.storeNode = storeNode;
        /**
		 * The mip level to write to for storage textures.
		 *
		 * @type {number}
		 * @default 0
		 */ this.mipLevel = 0;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageTextureNode = true;
        /**
		 * The access type of the texture node.
		 *
		 * @type {string}
		 * @default 'writeOnly'
		 */ this.access = $d89c9137a3d237c2$export$92538c74c63a703d.WRITE_ONLY;
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'storageTexture'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return 'storageTexture';
    }
    setup(builder) {
        super.setup(builder);
        const properties = builder.getNodeProperties(this);
        properties.storeNode = this.storeNode;
        return properties;
    }
    /**
	 * Defines the node access.
	 *
	 * @param {string} value - The node access.
	 * @return {StorageTextureNode} A reference to this node.
	 */ setAccess(value) {
        this.access = value;
        return this;
    }
    /**
	 * Sets the mip level to write to.
	 *
	 * @param {number} level - The mip level.
	 * @return {StorageTextureNode} A reference to this node.
	 */ setMipLevel(level) {
        this.mipLevel = level;
        return this;
    }
    /**
	 * Generates the code snippet of the storage node. If no `storeNode`
	 * is defined, the texture node is generated as normal texture.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} output - The current output.
	 * @return {string} The generated code snippet.
	 */ generate(builder, output) {
        let snippet;
        if (this.storeNode !== null) snippet = this.generateStore(builder);
        else snippet = super.generate(builder, output);
        return snippet;
    }
    /**
	 * Convenience method for configuring a read/write node access.
	 *
	 * @return {StorageTextureNode} A reference to this node.
	 */ toReadWrite() {
        return this.setAccess($d89c9137a3d237c2$export$92538c74c63a703d.READ_WRITE);
    }
    /**
	 * Convenience method for configuring a read-only node access.
	 *
	 * @return {StorageTextureNode} A reference to this node.
	 */ toReadOnly() {
        return this.setAccess($d89c9137a3d237c2$export$92538c74c63a703d.READ_ONLY);
    }
    /**
	 * Convenience method for configuring a write-only node access.
	 *
	 * @return {StorageTextureNode} A reference to this node.
	 */ toWriteOnly() {
        return this.setAccess($d89c9137a3d237c2$export$92538c74c63a703d.WRITE_ONLY);
    }
    /**
	 * Generates the code snippet of the storage texture node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ generateStore(builder) {
        const properties = builder.getNodeProperties(this);
        const { uvNode: uvNode, storeNode: storeNode, depthNode: depthNode } = properties;
        const textureProperty = super.generate(builder, 'property');
        const uvSnippet = uvNode.build(builder, this.value.is3DTexture === true ? 'uvec3' : 'uvec2');
        const storeSnippet = storeNode.build(builder, 'vec4');
        const depthSnippet = depthNode ? depthNode.build(builder, 'int') : null;
        const snippet = builder.generateTextureStore(builder, textureProperty, uvSnippet, depthSnippet, storeSnippet);
        builder.addLineFlowCode(snippet, this);
    }
    clone() {
        const newNode = super.clone();
        newNode.storeNode = this.storeNode;
        newNode.mipLevel = this.mipLevel;
        return newNode;
    }
}
/**
 * TSL function for creating a storage texture node.
 *
 * @tsl
 * @function
 * @param {StorageTexture} value - The storage texture.
 * @param {?Node<vec2|vec3>} uvNode - The uv node.
 * @param {?Node} [storeNode=null] - The value node that should be stored in the texture.
 * @returns {StorageTextureNode}
 */ const $d89c9137a3d237c2$var$storageTexture = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$f9d0185498cbffc2).setParameterLength(1, 3);
/**
 * TODO: Explain difference to `storageTexture()`.
 *
 * @tsl
 * @function
 * @param {StorageTexture} value - The storage texture.
 * @param {Node<vec2|vec3>} uvNode - The uv node.
 * @param {?Node} [storeNode=null] - The value node that should be stored in the texture.
 * @returns {StorageTextureNode}
 */ const $d89c9137a3d237c2$var$textureStore = (value, uvNode, storeNode)=>{
    const node = $d89c9137a3d237c2$var$storageTexture(value, uvNode, storeNode);
    if (storeNode !== null) node.toStack();
    return node;
};
const $d89c9137a3d237c2$var$normal = $d89c9137a3d237c2$var$Fn(({ texture: texture, uv: uv })=>{
    const epsilon = 0.0001;
    const ret = $d89c9137a3d237c2$var$vec3().toVar();
    $d89c9137a3d237c2$var$If(uv.x.lessThan(epsilon), ()=>{
        ret.assign($d89c9137a3d237c2$var$vec3(1, 0, 0));
    }).ElseIf(uv.y.lessThan(epsilon), ()=>{
        ret.assign($d89c9137a3d237c2$var$vec3(0, 1, 0));
    }).ElseIf(uv.z.lessThan(epsilon), ()=>{
        ret.assign($d89c9137a3d237c2$var$vec3(0, 0, 1));
    }).ElseIf(uv.x.greaterThan(1 - epsilon), ()=>{
        ret.assign($d89c9137a3d237c2$var$vec3(-1, 0, 0));
    }).ElseIf(uv.y.greaterThan(1 - epsilon), ()=>{
        ret.assign($d89c9137a3d237c2$var$vec3(0, -1, 0));
    }).ElseIf(uv.z.greaterThan(1 - epsilon), ()=>{
        ret.assign($d89c9137a3d237c2$var$vec3(0, 0, -1));
    }).Else(()=>{
        const step = 0.01;
        const x = texture.sample(uv.add($d89c9137a3d237c2$var$vec3(-step, 0.0, 0.0))).r.sub(texture.sample(uv.add($d89c9137a3d237c2$var$vec3(step, 0.0, 0.0))).r);
        const y = texture.sample(uv.add($d89c9137a3d237c2$var$vec3(0.0, -step, 0.0))).r.sub(texture.sample(uv.add($d89c9137a3d237c2$var$vec3(0.0, step, 0.0))).r);
        const z = texture.sample(uv.add($d89c9137a3d237c2$var$vec3(0.0, 0.0, -step))).r.sub(texture.sample(uv.add($d89c9137a3d237c2$var$vec3(0.0, 0.0, step))).r);
        ret.assign($d89c9137a3d237c2$var$vec3(x, y, z));
    });
    return ret.normalize();
});
/**
 * This type of uniform node represents a 3D texture.
 *
 * @augments TextureNode
 */ class $d89c9137a3d237c2$export$5449572dfc267b6b extends $d89c9137a3d237c2$export$2dd903bc9e8140bc {
    static get type() {
        return 'Texture3DNode';
    }
    /**
	 * Constructs a new 3D texture node.
	 *
	 * @param {Data3DTexture} value - The 3D texture.
	 * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
	 * @param {?Node<int>} [levelNode=null] - The level node.
	 */ constructor(value, uvNode = null, levelNode = null){
        super(value, uvNode, levelNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTexture3DNode = true;
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'texture3D'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return 'texture3D';
    }
    /**
	 * Returns a default uv node which is in context of 3D textures a three-dimensional
	 * uv node.
	 *
	 * @return {Node<vec3>} The default uv node.
	 */ getDefaultUV() {
        return $d89c9137a3d237c2$var$vec3(0.5, 0.5, 0.5);
    }
    /**
	 * Overwritten with an empty implementation since the `updateMatrix` flag is ignored
	 * for 3D textures. The uv transformation matrix is not applied to 3D textures.
	 *
	 * @param {boolean} value - The update toggle.
	 */ setUpdateMatrix() {}
    /**
	 * Overwrites the default implementation to return the unmodified uv node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} uvNode - The uv node to setup.
	 * @return {Node} The unmodified uv node.
	 */ setupUV(builder, uvNode) {
        const texture = this.value;
        if (builder.isFlipY() && (texture.isRenderTargetTexture === true || texture.isFramebufferTexture === true)) {
            if (this.sampler) uvNode = uvNode.flipY();
            else uvNode = uvNode.setY($d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$textureSize(this, this.levelNode).y).sub(uvNode.y).sub(1));
        }
        return uvNode;
    }
    /**
	 * Generates the uv code snippet.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} uvNode - The uv node to generate code for.
	 * @return {string} The generated code snippet.
	 */ generateUV(builder, uvNode) {
        return uvNode.build(builder, this.sampler === true ? 'vec3' : 'ivec3');
    }
    /**
	 * Generates the offset code snippet.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} offsetNode - The offset node to generate code for.
	 * @return {string} The generated code snippet.
	 */ generateOffset(builder, offsetNode) {
        return offsetNode.build(builder, 'ivec3');
    }
    /**
	 * TODO.
	 *
	 * @param {Node<vec3>} uvNode - The uv node .
	 * @return {Node<vec3>} TODO.
	 */ normal(uvNode) {
        return $d89c9137a3d237c2$var$normal({
            texture: this,
            uv: uvNode
        });
    }
}
/**
 * TSL function for creating a 3D texture node.
 *
 * @tsl
 * @function
 * @param {Data3DTexture} value - The 3D texture.
 * @param {?Node<vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @returns {Texture3DNode}
 */ const $d89c9137a3d237c2$var$texture3D = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$5449572dfc267b6b).setParameterLength(1, 3);
/**
 * TSL function for creating a texture node that fetches/loads texels without interpolation.
 *
 * @tsl
 * @function
 * @param {?(Texture|TextureNode)} [value=EmptyTexture] - The texture.
 * @param {?Node<vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {TextureNode}
 */ const $d89c9137a3d237c2$var$texture3DLoad = (...params)=>$d89c9137a3d237c2$var$texture3D(...params).setSampler(false);
/**
 * TSL function for creating a texture node that fetches/loads texels without interpolation.
 *
 * @tsl
 * @function
 * @param {?(Texture|TextureNode)} [value=EmptyTexture] - The texture.
 * @param {?Node<vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @returns {TextureNode}
 */ const $d89c9137a3d237c2$var$texture3DLevel = (value, uvNode, levelNode)=>$d89c9137a3d237c2$var$texture3D(value, uvNode).level(levelNode);
/**
 * A special type of reference node that allows to link values in
 * `userData` fields to node objects.
 * ```js
 * sprite.userData.rotation = 1; // stores individual rotation per sprite
 *
 * const material = new THREE.SpriteNodeMaterial();
 * material.rotationNode = userData( 'rotation', 'float' );
 * ```
 * Since `UserDataNode` is extended from {@link ReferenceNode}, the node value
 * will automatically be updated when the `rotation` user data field changes.
 *
 * @augments ReferenceNode
 */ class $d89c9137a3d237c2$export$5c6a4f8c7fea25ce extends $d89c9137a3d237c2$export$81a720e7e5211d94 {
    static get type() {
        return 'UserDataNode';
    }
    /**
	 * Constructs a new user data node.
	 *
	 * @param {string} property - The property name that should be referenced by the node.
	 * @param {string} inputType - The node data type of the reference.
	 * @param {?Object} [userData=null] - A reference to the `userData` object. If not provided, the `userData` property of the 3D object that uses the node material is evaluated.
	 */ constructor(property, inputType, userData = null){
        super(property, inputType, userData);
        /**
		 * A reference to the `userData` object. If not provided, the `userData`
		 * property of the 3D object that uses the node material is evaluated.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.userData = userData;
    }
    /**
	 * Overwritten to make sure {@link ReferenceNode#reference} points to the correct
	 * `userData` field.
	 *
	 * @param {(NodeFrame|NodeBuilder)} state - The current state to evaluate.
	 * @return {Object} A reference to the `userData` field.
	 */ updateReference(state) {
        this.reference = this.userData !== null ? this.userData : state.object.userData;
        return this.reference;
    }
}
/**
 * TSL function for creating a user data node.
 *
 * @tsl
 * @function
 * @param {string} name - The property name that should be referenced by the node.
 * @param {string} inputType - The node data type of the reference.
 * @param {?Object} userData - A reference to the `userData` object. If not provided, the `userData` property of the 3D object that uses the node material is evaluated.
 * @returns {UserDataNode}
 */ const $d89c9137a3d237c2$var$userData = (name, inputType, userData)=>new $d89c9137a3d237c2$export$5c6a4f8c7fea25ce(name, inputType, userData);
const $d89c9137a3d237c2$var$_objectData = new WeakMap();
/**
 * A node for representing motion or velocity vectors. Foundation
 * for advanced post processing effects like motion blur or TRAA.
 *
 * The node keeps track of the model, view and projection matrices
 * of the previous frame and uses them to compute offsets in NDC space.
 * These offsets represent the final velocity.
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$var$VelocityNode extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'VelocityNode';
    }
    /**
	 * Constructs a new vertex color node.
	 */ constructor(){
        super('vec2');
        /**
		 * The current projection matrix.
		 *
		 * @type {?Matrix4}
		 * @default null
		 */ this.projectionMatrix = null;
        /**
		 * Overwritten since velocity nodes are updated per object.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT;
        /**
		 * Overwritten since velocity nodes save data after the update.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateAfterType = $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT;
        /**
		 * Uniform node representing the previous model matrix in world space.
		 *
		 * @type {UniformNode<mat4>}
		 * @default null
		 */ this.previousModelWorldMatrix = $d89c9137a3d237c2$var$uniform(new (0, $329ek.Matrix4)());
        /**
		 * Uniform node representing the previous projection matrix.
		 *
		 * @type {UniformNode<mat4>}
		 * @default null
		 */ this.previousProjectionMatrix = $d89c9137a3d237c2$var$uniform(new (0, $329ek.Matrix4)()).setGroup($d89c9137a3d237c2$var$renderGroup);
        /**
		 * Uniform node representing the previous view matrix.
		 *
		 * @type {UniformNode<mat4>}
		 * @default null
		 */ this.previousCameraViewMatrix = $d89c9137a3d237c2$var$uniform(new (0, $329ek.Matrix4)());
    }
    /**
	 * Sets the given projection matrix.
	 *
	 * @param {Matrix4} projectionMatrix - The projection matrix to set.
	 */ setProjectionMatrix(projectionMatrix) {
        this.projectionMatrix = projectionMatrix;
    }
    /**
	 * Updates velocity specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update({ frameId: frameId, camera: camera, object: object }) {
        const previousModelMatrix = $d89c9137a3d237c2$var$getPreviousMatrix(object);
        this.previousModelWorldMatrix.value.copy(previousModelMatrix);
        //
        const cameraData = $d89c9137a3d237c2$var$getData(camera);
        if (cameraData.frameId !== frameId) {
            cameraData.frameId = frameId;
            if (cameraData.previousProjectionMatrix === undefined) {
                cameraData.previousProjectionMatrix = new (0, $329ek.Matrix4)();
                cameraData.previousCameraViewMatrix = new (0, $329ek.Matrix4)();
                cameraData.currentProjectionMatrix = new (0, $329ek.Matrix4)();
                cameraData.currentCameraViewMatrix = new (0, $329ek.Matrix4)();
                cameraData.previousProjectionMatrix.copy(this.projectionMatrix || camera.projectionMatrix);
                cameraData.previousCameraViewMatrix.copy(camera.matrixWorldInverse);
            } else {
                cameraData.previousProjectionMatrix.copy(cameraData.currentProjectionMatrix);
                cameraData.previousCameraViewMatrix.copy(cameraData.currentCameraViewMatrix);
            }
            cameraData.currentProjectionMatrix.copy(this.projectionMatrix || camera.projectionMatrix);
            cameraData.currentCameraViewMatrix.copy(camera.matrixWorldInverse);
            this.previousProjectionMatrix.value.copy(cameraData.previousProjectionMatrix);
            this.previousCameraViewMatrix.value.copy(cameraData.previousCameraViewMatrix);
        }
    }
    /**
	 * Overwritten to updated velocity specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ updateAfter({ object: object }) {
        $d89c9137a3d237c2$var$getPreviousMatrix(object).copy(object.matrixWorld);
    }
    /**
	 * Implements the velocity computation based on the previous and current vertex data.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {Node<vec2>} The motion vector.
	 */ setup() {
        const projectionMatrix = this.projectionMatrix === null ? $d89c9137a3d237c2$var$cameraProjectionMatrix : $d89c9137a3d237c2$var$uniform(this.projectionMatrix);
        const previousModelViewMatrix = this.previousCameraViewMatrix.mul(this.previousModelWorldMatrix);
        const clipPositionCurrent = projectionMatrix.mul($d89c9137a3d237c2$var$modelViewMatrix).mul($d89c9137a3d237c2$var$positionLocal);
        const clipPositionPrevious = this.previousProjectionMatrix.mul(previousModelViewMatrix).mul($d89c9137a3d237c2$var$positionPrevious);
        const ndcPositionCurrent = clipPositionCurrent.xy.div(clipPositionCurrent.w);
        const ndcPositionPrevious = clipPositionPrevious.xy.div(clipPositionPrevious.w);
        const velocity = $d89c9137a3d237c2$var$sub(ndcPositionCurrent, ndcPositionPrevious);
        return velocity;
    }
}
function $d89c9137a3d237c2$var$getData(object) {
    let objectData = $d89c9137a3d237c2$var$_objectData.get(object);
    if (objectData === undefined) {
        objectData = {};
        $d89c9137a3d237c2$var$_objectData.set(object, objectData);
    }
    return objectData;
}
function $d89c9137a3d237c2$var$getPreviousMatrix(object, index = 0) {
    const objectData = $d89c9137a3d237c2$var$getData(object);
    let matrix = objectData[index];
    if (matrix === undefined) {
        objectData[index] = matrix = new (0, $329ek.Matrix4)();
        objectData[index].copy(object.matrixWorld);
    }
    return matrix;
}
/**
 * TSL object that represents the velocity of a render pass.
 *
 * @tsl
 * @type {VelocityNode}
 */ const $d89c9137a3d237c2$var$velocity = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeImmutable($d89c9137a3d237c2$var$VelocityNode);
/**
 * Computes a grayscale value for the given RGB color value.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color value to compute the grayscale for.
 * @return {Node<vec3>} The grayscale color.
 */ const $d89c9137a3d237c2$var$grayscale = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color])=>{
    return $d89c9137a3d237c2$var$luminance(color.rgb);
});
/**
 * Super-saturates or desaturates the given RGB color.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The input color.
 * @param {Node<float>} [adjustment=1] - Specifies the amount of the conversion. A value under `1` desaturates the color, a value over `1` super-saturates it.
 * @return {Node<vec3>} The saturated color.
 */ const $d89c9137a3d237c2$var$saturation = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color, adjustment = $d89c9137a3d237c2$var$float(1)])=>{
    return adjustment.mix($d89c9137a3d237c2$var$luminance(color.rgb), color.rgb);
});
/**
 * Selectively enhance the intensity of less saturated RGB colors. Can result
 * in a more natural and visually appealing image with enhanced color depth
 * compared to {@link ColorAdjustment#saturation}.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The input color.
 * @param {Node<float>} [adjustment=1] - Controls the intensity of the vibrance effect.
 * @return {Node<vec3>} The updated color.
 */ const $d89c9137a3d237c2$var$vibrance = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color, adjustment = $d89c9137a3d237c2$var$float(1)])=>{
    const average = $d89c9137a3d237c2$var$add(color.r, color.g, color.b).div(3.0);
    const mx = color.r.max(color.g.max(color.b));
    const amt = mx.sub(average).mul(adjustment).mul(-3);
    return $d89c9137a3d237c2$var$mix(color.rgb, mx, amt);
});
/**
 * Updates the hue component of the given RGB color while preserving its luminance and saturation.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The input color.
 * @param {Node<float>} [adjustment=1] - Defines the degree of hue rotation in radians. A positive value rotates the hue clockwise, while a negative value rotates it counterclockwise.
 * @return {Node<vec3>} The updated color.
 */ const $d89c9137a3d237c2$var$hue = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color, adjustment = $d89c9137a3d237c2$var$float(1)])=>{
    const k = $d89c9137a3d237c2$var$vec3(0.57735, 0.57735, 0.57735);
    const cosAngle = adjustment.cos();
    return $d89c9137a3d237c2$var$vec3(color.rgb.mul(cosAngle).add(k.cross(color.rgb).mul(adjustment.sin()).add(k.mul($d89c9137a3d237c2$var$dot(k, color.rgb).mul(cosAngle.oneMinus())))));
});
/**
 * Computes the luminance for the given RGB color value.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color value to compute the luminance for.
 * @param {?Node<vec3>} luminanceCoefficients - The luminance coefficients. By default predefined values of the current working color space are used.
 * @return {Node<float>} The luminance.
 */ const $d89c9137a3d237c2$var$luminance = (color, luminanceCoefficients = $d89c9137a3d237c2$var$vec3((0, $329ek.ColorManagement).getLuminanceCoefficients(new (0, $329ek.Vector3)())))=>$d89c9137a3d237c2$var$dot(color, luminanceCoefficients);
/**
 * Color Decision List (CDL) v1.2
 *
 * Compact representation of color grading information, defined by slope, offset, power, and
 * saturation. The CDL should be typically be given input in a log space (such as LogC, ACEScc,
 * or AgX Log), and will return output in the same space. Output may require clamping >=0.
 *
 * @tsl
 * @function
 * @param {Node<vec4>} color Input (-Infinity < input < +Infinity)
 * @param {Node<vec3>} slope Slope (0 ≤ slope < +Infinity)
 * @param {Node<vec3>} offset Offset (-Infinity < offset < +Infinity; typically -1 < offset < 1)
 * @param {Node<vec3>} power Power (0 < power < +Infinity)
 * @param {Node<float>} saturation Saturation (0 ≤ saturation < +Infinity; typically 0 ≤ saturation < 4)
 * @param {Node<vec3>} luminanceCoefficients Luminance coefficients for saturation term, typically Rec. 709
 * @return {Node<vec4>} Output, -Infinity < output < +Infinity
 *
 * References:
 * - ASC CDL v1.2
 * - {@link https://blender.stackexchange.com/a/55239/43930}
 * - {@link https://docs.acescentral.com/specifications/acescc/}
 */ const $d89c9137a3d237c2$var$cdl = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color, slope = $d89c9137a3d237c2$var$vec3(1), offset = $d89c9137a3d237c2$var$vec3(0), power = $d89c9137a3d237c2$var$vec3(1), saturation = $d89c9137a3d237c2$var$float(1), // ASC CDL v1.2 explicitly requires Rec. 709 luminance coefficients.
luminanceCoefficients = $d89c9137a3d237c2$var$vec3((0, $329ek.ColorManagement).getLuminanceCoefficients(new (0, $329ek.Vector3)(), (0, $329ek.LinearSRGBColorSpace)))])=>{
    // NOTE: The ASC CDL v1.2 defines a [0, 1] clamp on the slope+offset term, and another on the
    // saturation term. Per the ACEScc specification and Filament, limits may be omitted to support
    // values outside [0, 1], requiring a workaround for negative values in the power expression.
    const luma = color.rgb.dot($d89c9137a3d237c2$var$vec3(luminanceCoefficients));
    const v = $d89c9137a3d237c2$var$max$1(color.rgb.mul(slope).add(offset), 0.0).toVar();
    const pv = v.pow(power).toVar();
    $d89c9137a3d237c2$var$If(v.r.greaterThan(0.0), ()=>{
        v.r.assign(pv.r);
    }); // eslint-disable-line
    $d89c9137a3d237c2$var$If(v.g.greaterThan(0.0), ()=>{
        v.g.assign(pv.g);
    }); // eslint-disable-line
    $d89c9137a3d237c2$var$If(v.b.greaterThan(0.0), ()=>{
        v.b.assign(pv.b);
    }); // eslint-disable-line
    v.assign(luma.add(v.sub(luma).mul(saturation)));
    return $d89c9137a3d237c2$var$vec4(v.rgb, color.a);
});
/**
 * Represents a posterize effect which reduces the number of colors
 * in an image, resulting in a more blocky and stylized appearance.
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$2a458ee668df6c33 extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'PosterizeNode';
    }
    /**
	 * Constructs a new posterize node.
	 *
	 * @param {Node} sourceNode - The input color.
	 * @param {Node} stepsNode - Controls the intensity of the posterization effect. A lower number results in a more blocky appearance.
	 */ constructor(sourceNode, stepsNode){
        super();
        /**
		 * The input color.
		 *
		 * @type {Node}
		 */ this.sourceNode = sourceNode;
        /**
		 * Controls the intensity of the posterization effect. A lower number results in a more blocky appearance.
		 *
		 * @type {Node}
		 */ this.stepsNode = stepsNode;
    }
    setup() {
        const { sourceNode: sourceNode, stepsNode: stepsNode } = this;
        return sourceNode.mul(stepsNode).floor().div(stepsNode);
    }
}
/**
 * TSL function for creating a posterize node.
 *
 * @tsl
 * @function
 * @param {Node} sourceNode - The input color.
 * @param {Node} stepsNode - Controls the intensity of the posterization effect. A lower number results in a more blocky appearance.
 * @returns {PosterizeNode}
 */ const $d89c9137a3d237c2$var$posterize = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$2a458ee668df6c33).setParameterLength(2);
const $d89c9137a3d237c2$var$_size = /*@__PURE__*/ new (0, $329ek.Vector2)();
/**
 * Represents the texture of a pass node.
 *
 * @augments TextureNode
 */ class $d89c9137a3d237c2$var$PassTextureNode extends $d89c9137a3d237c2$export$2dd903bc9e8140bc {
    static get type() {
        return 'PassTextureNode';
    }
    /**
	 * Constructs a new pass texture node.
	 *
	 * @param {PassNode} passNode - The pass node.
	 * @param {Texture} texture - The output texture.
	 */ constructor(passNode, texture){
        super(texture);
        /**
		 * A reference to the pass node.
		 *
		 * @type {PassNode}
		 */ this.passNode = passNode;
        this.setUpdateMatrix(false);
    }
    setup(builder) {
        this.passNode.build(builder);
        return super.setup(builder);
    }
    clone() {
        return new this.constructor(this.passNode, this.value);
    }
}
/**
 * An extension of `PassTextureNode` which allows to manage more than one
 * internal texture. Relevant for the `getPreviousTexture()` related API.
 *
 * @augments PassTextureNode
 */ class $d89c9137a3d237c2$var$PassMultipleTextureNode extends $d89c9137a3d237c2$var$PassTextureNode {
    static get type() {
        return 'PassMultipleTextureNode';
    }
    /**
	 * Constructs a new pass texture node.
	 *
	 * @param {PassNode} passNode - The pass node.
	 * @param {string} textureName - The output texture name.
	 * @param {boolean} [previousTexture=false] - Whether previous frame data should be used or not.
	 */ constructor(passNode, textureName, previousTexture = false){
        // null is passed to the super call since this class does not
        // use an external texture for rendering pass data into. Instead
        // the texture is managed by the pass node itself
        super(passNode, null);
        /**
		 * The output texture name.
		 *
		 * @type {string}
		 */ this.textureName = textureName;
        /**
		 * Whether previous frame data should be used or not.
		 *
		 * @type {boolean}
		 */ this.previousTexture = previousTexture;
    }
    /**
	 * Updates the texture reference of this node.
	 */ updateTexture() {
        this.value = this.previousTexture ? this.passNode.getPreviousTexture(this.textureName) : this.passNode.getTexture(this.textureName);
    }
    setup(builder) {
        this.updateTexture();
        return super.setup(builder);
    }
    clone() {
        const newNode = new this.constructor(this.passNode, this.textureName, this.previousTexture);
        newNode.uvNode = this.uvNode;
        newNode.levelNode = this.levelNode;
        newNode.biasNode = this.biasNode;
        newNode.sampler = this.sampler;
        newNode.depthNode = this.depthNode;
        newNode.compareNode = this.compareNode;
        newNode.gradNode = this.gradNode;
        newNode.offsetNode = this.offsetNode;
        return newNode;
    }
}
/**
 * Represents a render pass (sometimes called beauty pass) in context of post processing.
 * This pass produces a render for the given scene and camera and can provide multiple outputs
 * via MRT for further processing.
 *
 * ```js
 * const postProcessing = new PostProcessing( renderer );
 *
 * const scenePass = pass( scene, camera );
 *
 * postProcessing.outputNode = scenePass;
 * ```
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$export$1a977c3276cbac94 extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'PassNode';
    }
    /**
	 * Constructs a new pass node.
	 *
	 * @param {('color'|'depth')} scope - The scope of the pass. The scope determines whether the node outputs color or depth.
	 * @param {Scene} scene - A reference to the scene.
	 * @param {Camera} camera - A reference to the camera.
	 * @param {Object} options - Options for the internal render target.
	 */ constructor(scope, scene, camera, options = {}){
        super('vec4');
        /**
		 * The scope of the pass. The scope determines whether the node outputs color or depth.
		 *
		 * @type {('color'|'depth')}
		 */ this.scope = scope;
        /**
		 * A reference to the scene.
		 *
		 * @type {Scene}
		 */ this.scene = scene;
        /**
		 * A reference to the camera.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * Options for the internal render target.
		 *
		 * @type {Object}
		 */ this.options = options;
        /**
		 * The pass's pixel ratio. Will be kept automatically kept in sync with the renderer's pixel ratio.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._pixelRatio = 1;
        /**
		 * The pass's pixel width. Will be kept automatically kept in sync with the renderer's width.
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._width = 1;
        /**
		 * The pass's pixel height. Will be kept automatically kept in sync with the renderer's height.
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._height = 1;
        const depthTexture = new (0, $329ek.DepthTexture)();
        depthTexture.isRenderTargetTexture = true;
        //depthTexture.type = FloatType;
        depthTexture.name = 'depth';
        const renderTarget = new (0, $329ek.RenderTarget)(this._width * this._pixelRatio, this._height * this._pixelRatio, {
            type: (0, $329ek.HalfFloatType),
            ...options
        });
        renderTarget.texture.name = 'output';
        renderTarget.depthTexture = depthTexture;
        /**
		 * The pass's render target.
		 *
		 * @type {RenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * An optional override material for the pass.
		 *
		 * @type {Material|null}
		 */ this.overrideMaterial = null;
        /**
		 * Whether the pass is transparent.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transparent = true;
        /**
		 * Whether the pass is opaque.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.opaque = true;
        /**
		 * An optional global context for the pass.
		 *
		 * @type {ContextNode|null}
		 */ this.contextNode = null;
        /**
		 * A cache for the context node.
		 *
		 * @private
		 * @type {?Object}
		 * @default null
		 */ this._contextNodeCache = null;
        /**
		 * A dictionary holding the internal result textures.
		 *
		 * @private
		 * @type {Object<string, Texture>}
		 */ this._textures = {
            output: renderTarget.texture,
            depth: depthTexture
        };
        /**
		 * A dictionary holding the internal texture nodes.
		 *
		 * @private
		 * @type {Object<string, TextureNode>}
		 */ this._textureNodes = {};
        /**
		 * A dictionary holding the internal depth nodes.
		 *
		 * @private
		 * @type {Object}
		 */ this._linearDepthNodes = {};
        /**
		 * A dictionary holding the internal viewZ nodes.
		 *
		 * @private
		 * @type {Object}
		 */ this._viewZNodes = {};
        /**
		 * A dictionary holding the texture data of the previous frame.
		 * Used for computing velocity/motion vectors.
		 *
		 * @private
		 * @type {Object<string, Texture>}
		 */ this._previousTextures = {};
        /**
		 * A dictionary holding the texture nodes of the previous frame.
		 * Used for computing velocity/motion vectors.
		 *
		 * @private
		 * @type {Object<string, TextureNode>}
		 */ this._previousTextureNodes = {};
        /**
		 * The `near` property of the camera as a uniform.
		 *
		 * @private
		 * @type {UniformNode}
		 */ this._cameraNear = $d89c9137a3d237c2$var$uniform(0);
        /**
		 * The `far` property of the camera as a uniform.
		 *
		 * @private
		 * @type {UniformNode}
		 */ this._cameraFar = $d89c9137a3d237c2$var$uniform(0);
        /**
		 * A MRT node configuring the MRT settings.
		 *
		 * @private
		 * @type {?MRTNode}
		 * @default null
		 */ this._mrt = null;
        /**
		 * Layer object for configuring the camera that is used
		 * to produce the pass.
		 *
		 * @private
		 * @type {?Layers}
		 * @default null
		 */ this._layers = null;
        /**
		 * Scales the resolution of the internal render target.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._resolutionScale = 1;
        /**
		 * Custom viewport definition.
		 *
		 * @private
		 * @type {?Vector4}
		 * @default null
		 */ this._viewport = null;
        /**
		 * Custom scissor definition.
		 *
		 * @private
		 * @type {?Vector4}
		 * @default null
		 */ this._scissor = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPassNode = true;
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.FRAME` since the node renders the
		 * scene once per frame in its {@link PassNode#updateBefore} method.
		 *
		 * @type {string}
		 * @default 'frame'
		 */ this.updateBeforeType = $d89c9137a3d237c2$export$26f7a8bbd9469530.FRAME;
        /**
		 * This flag is used for global cache.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
    }
    /**
	 * Sets the resolution scale for the pass.
	 * The resolution scale is a factor that is multiplied with the renderer's width and height.
	 *
	 * @param {number} resolutionScale - The resolution scale to set. A value of `1` means full resolution.
	 * @return {PassNode} A reference to this pass.
	 */ setResolutionScale(resolutionScale) {
        this._resolutionScale = resolutionScale;
        return this;
    }
    /**
	 * Gets the current resolution scale of the pass.
	 *
	 * @return {number} The current resolution scale. A value of `1` means full resolution.
	 */ getResolutionScale() {
        return this._resolutionScale;
    }
    /**
	 * Sets the resolution for the pass.
	 * The resolution is a factor that is multiplied with the renderer's width and height.
	 *
	 * @param {number} resolution - The resolution to set. A value of `1` means full resolution.
	 * @return {PassNode} A reference to this pass.
	 * @deprecated since r181. Use {@link PassNode#setResolutionScale `setResolutionScale()`} instead.
	 */ setResolution(resolution) {
        (0, $329ek.warn)('PassNode: .setResolution() is deprecated. Use .setResolutionScale() instead.');
        return this.setResolutionScale(resolution);
    }
    /**
	 * Gets the current resolution of the pass.
	 *
	 * @return {number} The current resolution. A value of `1` means full resolution.
	 * @deprecated since r181. Use {@link PassNode#getResolutionScale `getResolutionScale()`} instead.
	 */ getResolution() {
        (0, $329ek.warn)('PassNode: .getResolution() is deprecated. Use .getResolutionScale() instead.');
        return this.getResolutionScale();
    }
    /**
	 * Sets the layer configuration that should be used when rendering the pass.
	 *
	 * @param {Layers} layers - The layers object to set.
	 * @return {PassNode} A reference to this pass.
	 */ setLayers(layers) {
        this._layers = layers;
        return this;
    }
    /**
	 * Gets the current layer configuration of the pass.
	 *
	 * @return {?Layers} .
	 */ getLayers() {
        return this._layers;
    }
    /**
	 * Sets the given MRT node to setup MRT for this pass.
	 *
	 * @param {MRTNode} mrt - The MRT object.
	 * @return {PassNode} A reference to this pass.
	 */ setMRT(mrt) {
        this._mrt = mrt;
        return this;
    }
    /**
	 * Returns the current MRT node.
	 *
	 * @return {MRTNode} The current MRT node.
	 */ getMRT() {
        return this._mrt;
    }
    /**
	 * Returns the texture for the given output name.
	 *
	 * @param {string} name - The output name to get the texture for.
	 * @return {Texture} The texture.
	 */ getTexture(name) {
        let texture = this._textures[name];
        if (texture === undefined) {
            const refTexture = this.renderTarget.texture;
            texture = refTexture.clone();
            texture.name = name;
            this._textures[name] = texture;
            this.renderTarget.textures.push(texture);
        }
        return texture;
    }
    /**
	 * Returns the texture holding the data of the previous frame for the given output name.
	 *
	 * @param {string} name - The output name to get the texture for.
	 * @return {Texture} The texture holding the data of the previous frame.
	 */ getPreviousTexture(name) {
        let texture = this._previousTextures[name];
        if (texture === undefined) {
            texture = this.getTexture(name).clone();
            this._previousTextures[name] = texture;
        }
        return texture;
    }
    /**
	 * Switches current and previous textures for the given output name.
	 *
	 * @param {string} name - The output name.
	 */ toggleTexture(name) {
        const prevTexture = this._previousTextures[name];
        if (prevTexture !== undefined) {
            const texture = this._textures[name];
            const index = this.renderTarget.textures.indexOf(texture);
            this.renderTarget.textures[index] = prevTexture;
            this._textures[name] = prevTexture;
            this._previousTextures[name] = texture;
            this._textureNodes[name].updateTexture();
            this._previousTextureNodes[name].updateTexture();
        }
    }
    /**
	 * Returns the texture node for the given output name.
	 *
	 * @param {string} [name='output'] - The output name to get the texture node for.
	 * @return {TextureNode} The texture node.
	 */ getTextureNode(name = 'output') {
        let textureNode = this._textureNodes[name];
        if (textureNode === undefined) {
            textureNode = new $d89c9137a3d237c2$var$PassMultipleTextureNode(this, name);
            textureNode.updateTexture();
            this._textureNodes[name] = textureNode;
        }
        return textureNode;
    }
    /**
	 * Returns the previous texture node for the given output name.
	 *
	 * @param {string} [name='output'] - The output name to get the previous texture node for.
	 * @return {TextureNode} The previous texture node.
	 */ getPreviousTextureNode(name = 'output') {
        let textureNode = this._previousTextureNodes[name];
        if (textureNode === undefined) {
            if (this._textureNodes[name] === undefined) this.getTextureNode(name);
            textureNode = new $d89c9137a3d237c2$var$PassMultipleTextureNode(this, name, true);
            textureNode.updateTexture();
            this._previousTextureNodes[name] = textureNode;
        }
        return textureNode;
    }
    /**
	 * Returns a viewZ node of this pass.
	 *
	 * @param {string} [name='depth'] - The output name to get the viewZ node for. In most cases the default `'depth'` can be used however the parameter exists for custom depth outputs.
	 * @return {Node} The viewZ node.
	 */ getViewZNode(name = 'depth') {
        let viewZNode = this._viewZNodes[name];
        if (viewZNode === undefined) {
            const cameraNear = this._cameraNear;
            const cameraFar = this._cameraFar;
            this._viewZNodes[name] = viewZNode = $d89c9137a3d237c2$var$perspectiveDepthToViewZ(this.getTextureNode(name), cameraNear, cameraFar);
        }
        return viewZNode;
    }
    /**
	 * Returns a linear depth node of this pass.
	 *
	 * @param {string} [name='depth'] - The output name to get the linear depth node for. In most cases the default `'depth'` can be used however the parameter exists for custom depth outputs.
	 * @return {Node} The linear depth node.
	 */ getLinearDepthNode(name = 'depth') {
        let linearDepthNode = this._linearDepthNodes[name];
        if (linearDepthNode === undefined) {
            const cameraNear = this._cameraNear;
            const cameraFar = this._cameraFar;
            const viewZNode = this.getViewZNode(name);
            // TODO: just if ( builder.camera.isPerspectiveCamera )
            this._linearDepthNodes[name] = linearDepthNode = $d89c9137a3d237c2$var$viewZToOrthographicDepth(viewZNode, cameraNear, cameraFar);
        }
        return linearDepthNode;
    }
    /**
	 * Precompiles the pass.
	 *
	 * Note that this method must be called after the pass configuration is complete.
	 * So calls like `setMRT()` and `getTextureNode()` must proceed the precompilation.
	 *
	 * @async
	 * @param {Renderer} renderer - The renderer.
	 * @return {Promise} A Promise that resolves when the compile has been finished.
	 * @see {@link Renderer#compileAsync}
	 */ async compileAsync(renderer) {
        const currentRenderTarget = renderer.getRenderTarget();
        const currentMRT = renderer.getMRT();
        renderer.setRenderTarget(this.renderTarget);
        renderer.setMRT(this._mrt);
        await renderer.compileAsync(this.scene, this.camera);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.setMRT(currentMRT);
    }
    setup({ renderer: renderer }) {
        this.renderTarget.samples = this.options.samples === undefined ? renderer.samples : this.options.samples;
        this.renderTarget.texture.type = renderer.getOutputBufferType();
        return this.scope === $d89c9137a3d237c2$export$1a977c3276cbac94.COLOR ? this.getTextureNode() : this.getLinearDepthNode();
    }
    updateBefore(frame) {
        const { renderer: renderer } = frame;
        const { scene: scene } = this;
        let camera;
        let pixelRatio;
        const outputRenderTarget = renderer.getOutputRenderTarget();
        if (outputRenderTarget && outputRenderTarget.isXRRenderTarget === true) {
            pixelRatio = 1;
            camera = renderer.xr.getCamera();
            renderer.xr.updateCamera(camera);
            $d89c9137a3d237c2$var$_size.set(outputRenderTarget.width, outputRenderTarget.height);
        } else {
            camera = this.camera;
            pixelRatio = renderer.getPixelRatio();
            renderer.getSize($d89c9137a3d237c2$var$_size);
        }
        this._pixelRatio = pixelRatio;
        this.setSize($d89c9137a3d237c2$var$_size.width, $d89c9137a3d237c2$var$_size.height);
        const currentRenderTarget = renderer.getRenderTarget();
        const currentMRT = renderer.getMRT();
        const currentAutoClear = renderer.autoClear;
        const currentTransparent = renderer.transparent;
        const currentOpaque = renderer.opaque;
        const currentMask = camera.layers.mask;
        const currentContextNode = renderer.contextNode;
        const currentOverrideMaterial = scene.overrideMaterial;
        this._cameraNear.value = camera.near;
        this._cameraFar.value = camera.far;
        if (this._layers !== null) camera.layers.mask = this._layers.mask;
        for(const name in this._previousTextures)this.toggleTexture(name);
        if (this.overrideMaterial !== null) scene.overrideMaterial = this.overrideMaterial;
        renderer.setRenderTarget(this.renderTarget);
        renderer.setMRT(this._mrt);
        renderer.autoClear = true;
        renderer.transparent = this.transparent;
        renderer.opaque = this.opaque;
        if (this.contextNode !== null) {
            if (this._contextNodeCache === null || this._contextNodeCache.version !== this.version) this._contextNodeCache = {
                version: this.version,
                context: $d89c9137a3d237c2$var$context({
                    ...renderer.contextNode.getFlowContextData(),
                    ...this.contextNode.getFlowContextData()
                })
            };
            renderer.contextNode = this._contextNodeCache.context;
        }
        const currentSceneName = scene.name;
        scene.name = this.name ? this.name : scene.name;
        renderer.render(scene, camera);
        scene.name = currentSceneName;
        scene.overrideMaterial = currentOverrideMaterial;
        renderer.setRenderTarget(currentRenderTarget);
        renderer.setMRT(currentMRT);
        renderer.autoClear = currentAutoClear;
        renderer.transparent = currentTransparent;
        renderer.opaque = currentOpaque;
        renderer.contextNode = currentContextNode;
        camera.layers.mask = currentMask;
    }
    /**
	 * Sets the size of the pass's render target. Honors the pixel ratio.
	 *
	 * @param {number} width - The width to set.
	 * @param {number} height - The height to set.
	 */ setSize(width, height) {
        this._width = width;
        this._height = height;
        const effectiveWidth = Math.floor(this._width * this._pixelRatio * this._resolutionScale);
        const effectiveHeight = Math.floor(this._height * this._pixelRatio * this._resolutionScale);
        this.renderTarget.setSize(effectiveWidth, effectiveHeight);
        if (this._scissor !== null) this.renderTarget.scissor.copy(this._scissor);
        if (this._viewport !== null) this.renderTarget.viewport.copy(this._viewport);
    }
    /**
	 * This method allows to define the pass's scissor rectangle. By default, the scissor rectangle is kept
	 * in sync with the pass's dimensions. To reverse the process and use auto-sizing again, call the method
	 * with `null` as the single argument.
	 *
	 * @param {?(number | Vector4)} x - The horizontal coordinate for the lower left corner of the box in logical pixel unit.
	 * Instead of passing four arguments, the method also works with a single four-dimensional vector.
	 * @param {number} y - The vertical coordinate for the lower left corner of the box in logical pixel unit.
	 * @param {number} width - The width of the scissor box in logical pixel unit.
	 * @param {number} height - The height of the scissor box in logical pixel unit.
	 */ setScissor(x, y, width, height) {
        if (x === null) this._scissor = null;
        else {
            if (this._scissor === null) this._scissor = new (0, $329ek.Vector4)();
            if (x.isVector4) this._scissor.copy(x);
            else this._scissor.set(x, y, width, height);
            this._scissor.multiplyScalar(this._pixelRatio * this._resolutionScale).floor();
        }
    }
    /**
	 * This method allows to define the pass's viewport. By default, the viewport is kept in sync
	 * with the pass's dimensions. To reverse the process and use auto-sizing again, call the method
	 * with `null` as the single argument.
	 *
	 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
	 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
	 * @param {number} width - The width of the viewport in logical pixel unit.
	 * @param {number} height - The height of the viewport in logical pixel unit.
	 */ setViewport(x, y, width, height) {
        if (x === null) this._viewport = null;
        else {
            if (this._viewport === null) this._viewport = new (0, $329ek.Vector4)();
            if (x.isVector4) this._viewport.copy(x);
            else this._viewport.set(x, y, width, height);
            this._viewport.multiplyScalar(this._pixelRatio * this._resolutionScale).floor();
        }
    }
    /**
	 * Sets the pixel ratio the pass's render target and updates the size.
	 *
	 * @param {number} pixelRatio - The pixel ratio to set.
	 */ setPixelRatio(pixelRatio) {
        this._pixelRatio = pixelRatio;
        this.setSize(this._width, this._height);
    }
    /**
	 * Frees internal resources. Should be called when the node is no longer in use.
	 */ dispose() {
        this.renderTarget.dispose();
    }
}
/**
 * @static
 * @type {'color'}
 * @default 'color'
 */ $d89c9137a3d237c2$export$1a977c3276cbac94.COLOR = 'color';
/**
 * @static
 * @type {'depth'}
 * @default 'depth'
 */ $d89c9137a3d237c2$export$1a977c3276cbac94.DEPTH = 'depth';
/**
 * TSL function for creating a pass node.
 *
 * @tsl
 * @function
 * @param {Scene} scene - A reference to the scene.
 * @param {Camera} camera - A reference to the camera.
 * @param {Object} options - Options for the internal render target.
 * @returns {PassNode}
 */ const $d89c9137a3d237c2$var$pass = (scene, camera, options)=>new $d89c9137a3d237c2$export$1a977c3276cbac94($d89c9137a3d237c2$export$1a977c3276cbac94.COLOR, scene, camera, options);
/**
 * TSL function for creating a pass texture node.
 *
 * @tsl
 * @function
 * @param {PassNode} pass - The pass node.
 * @param {Texture} texture - The output texture.
 * @returns {PassTextureNode}
 */ const $d89c9137a3d237c2$var$passTexture = (pass, texture)=>new $d89c9137a3d237c2$var$PassTextureNode(pass, texture);
/**
 * TSL function for creating a depth pass node.
 *
 * @tsl
 * @function
 * @param {Scene} scene - A reference to the scene.
 * @param {Camera} camera - A reference to the camera.
 * @param {Object} options - Options for the internal render target.
 * @returns {PassNode}
 */ const $d89c9137a3d237c2$var$depthPass = (scene, camera, options)=>new $d89c9137a3d237c2$export$1a977c3276cbac94($d89c9137a3d237c2$export$1a977c3276cbac94.DEPTH, scene, camera, options);
/**
 * Represents a render pass for producing a toon outline effect on compatible objects.
 * Only 3D objects with materials of type `MeshToonMaterial` and `MeshToonNodeMaterial`
 * will receive the outline.
 *
 * ```js
 * const postProcessing = new PostProcessing( renderer );
 *
 * const scenePass = toonOutlinePass( scene, camera );
 *
 * postProcessing.outputNode = scenePass;
 * ```
 * @augments PassNode
 */ class $d89c9137a3d237c2$export$60ef0b3e8999f37 extends $d89c9137a3d237c2$export$1a977c3276cbac94 {
    static get type() {
        return 'ToonOutlinePassNode';
    }
    /**
	 * Constructs a new outline pass node.
	 *
	 * @param {Scene} scene - A reference to the scene.
	 * @param {Camera} camera - A reference to the camera.
	 * @param {Node} colorNode - Defines the outline's color.
	 * @param {Node} thicknessNode - Defines the outline's thickness.
	 * @param {Node} alphaNode - Defines the outline's alpha.
	 */ constructor(scene, camera, colorNode, thicknessNode, alphaNode){
        super($d89c9137a3d237c2$export$1a977c3276cbac94.COLOR, scene, camera);
        /**
		 * Defines the outline's color.
		 *
		 * @type {Node}
		 */ this.colorNode = colorNode;
        /**
		 * Defines the outline's thickness.
		 *
		 * @type {Node}
		 */ this.thicknessNode = thicknessNode;
        /**
		 * Defines the outline's alpha.
		 *
		 * @type {Node}
		 */ this.alphaNode = alphaNode;
        /**
		 * An internal material cache.
		 *
		 * @private
		 * @type {WeakMap<Material, NodeMaterial>}
		 */ this._materialCache = new WeakMap();
        /**
		 * The name of this pass.
		 *
		 * @type {string}
		 * @default 'Outline Pass'
		 */ this.name = 'Outline Pass';
    }
    updateBefore(frame) {
        const { renderer: renderer } = frame;
        const currentRenderObjectFunction = renderer.getRenderObjectFunction();
        renderer.setRenderObjectFunction((object, scene, camera, geometry, material, group, lightsNode, clippingContext)=>{
            // only render outline for supported materials
            if (material.isMeshToonMaterial || material.isMeshToonNodeMaterial) {
                if (material.wireframe === false) {
                    const outlineMaterial = this._getOutlineMaterial(material);
                    renderer.renderObject(object, scene, camera, geometry, outlineMaterial, group, lightsNode, clippingContext);
                }
            }
            // default
            renderer.renderObject(object, scene, camera, geometry, material, group, lightsNode, clippingContext);
        });
        super.updateBefore(frame);
        renderer.setRenderObjectFunction(currentRenderObjectFunction);
    }
    /**
	 * Creates the material used for outline rendering.
	 *
	 * @private
	 * @return {NodeMaterial} The outline material.
	 */ _createMaterial() {
        const material = new $d89c9137a3d237c2$export$caaf3b30a544c946();
        material.isMeshToonOutlineMaterial = true;
        material.name = 'Toon_Outline';
        material.side = (0, $329ek.BackSide);
        // vertex node
        const outlineNormal = $d89c9137a3d237c2$var$normalLocal.negate();
        const mvp = $d89c9137a3d237c2$var$cameraProjectionMatrix.mul($d89c9137a3d237c2$var$modelViewMatrix);
        const ratio = $d89c9137a3d237c2$var$float(1.0); // TODO: support outline thickness ratio for each vertex
        const pos = mvp.mul($d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$positionLocal, 1.0));
        const pos2 = mvp.mul($d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$positionLocal.add(outlineNormal), 1.0));
        const norm = $d89c9137a3d237c2$var$normalize(pos.sub(pos2)); // NOTE: subtract pos2 from pos because BackSide objectNormal is negative
        material.vertexNode = pos.add(norm.mul(this.thicknessNode).mul(pos.w).mul(ratio));
        // color node
        material.colorNode = $d89c9137a3d237c2$var$vec4(this.colorNode, this.alphaNode);
        return material;
    }
    /**
	 * For the given toon material, this method returns a corresponding
	 * outline material.
	 *
	 * @private
	 * @param {(MeshToonMaterial|MeshToonNodeMaterial)} originalMaterial - The toon material.
	 * @return {NodeMaterial} The outline material.
	 */ _getOutlineMaterial(originalMaterial) {
        let outlineMaterial = this._materialCache.get(originalMaterial);
        if (outlineMaterial === undefined) {
            outlineMaterial = this._createMaterial();
            this._materialCache.set(originalMaterial, outlineMaterial);
        }
        return outlineMaterial;
    }
}
/**
 * TSL function for creating a toon outline pass node.
 *
 * @tsl
 * @function
 * @param {Scene} scene - A reference to the scene.
 * @param {Camera} camera - A reference to the camera.
 * @param {Color} color - Defines the outline's color.
 * @param {number} [thickness=0.003] - Defines the outline's thickness.
 * @param {number} [alpha=1] - Defines the outline's alpha.
 * @returns {ToonOutlinePassNode}
 */ const $d89c9137a3d237c2$var$toonOutlinePass = (scene, camera, color = new (0, $329ek.Color)(0, 0, 0), thickness = 0.003, alpha = 1)=>$d89c9137a3d237c2$var$nodeObject(new $d89c9137a3d237c2$export$60ef0b3e8999f37(scene, camera, $d89c9137a3d237c2$var$nodeObject(color), $d89c9137a3d237c2$var$nodeObject(thickness), $d89c9137a3d237c2$var$nodeObject(alpha)));
/**
 * Linear tone mapping, exposure only.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $d89c9137a3d237c2$var$linearToneMapping = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color, exposure])=>{
    return color.mul(exposure).clamp();
}).setLayout({
    name: 'linearToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
/**
 * Reinhard tone mapping.
 *
 * Reference: {@link https://www.cs.utah.edu/docs/techreports/2002/pdf/UUCS-02-001.pdf}
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $d89c9137a3d237c2$var$reinhardToneMapping = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color, exposure])=>{
    color = color.mul(exposure);
    return color.div(color.add(1.0)).clamp();
}).setLayout({
    name: 'reinhardToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
/**
 * Cineon tone mapping.
 *
 * Reference: {@link http://filmicworlds.com/blog/filmic-tonemapping-operators/}
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $d89c9137a3d237c2$var$cineonToneMapping = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color, exposure])=>{
    // filmic operator by Jim Hejl and Richard Burgess-Dawson
    color = color.mul(exposure);
    color = color.sub(0.004).max(0.0);
    const a = color.mul(color.mul(6.2).add(0.5));
    const b = color.mul(color.mul(6.2).add(1.7)).add(0.06);
    return a.div(b).pow(2.2);
}).setLayout({
    name: 'cineonToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
// source: https://github.com/selfshadow/ltc_code/blob/master/webgl/shaders/ltc/ltc_blit.fs
const $d89c9137a3d237c2$var$RRTAndODTFit = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color])=>{
    const a = color.mul(color.add(0.0245786)).sub(0.000090537);
    const b = color.mul(color.add(0.4329510).mul(0.983729)).add(0.238081);
    return a.div(b);
});
/**
 * ACESFilmic tone mapping.
 *
 * Reference: {@link https://github.com/selfshadow/ltc_code/blob/master/webgl/shaders/ltc/ltc_blit.fs}
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $d89c9137a3d237c2$var$acesFilmicToneMapping = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color, exposure])=>{
    // sRGB => XYZ => D65_2_D60 => AP1 => RRT_SAT
    const ACESInputMat = $d89c9137a3d237c2$var$mat3(0.59719, 0.35458, 0.04823, 0.07600, 0.90834, 0.01566, 0.02840, 0.13383, 0.83777);
    // ODT_SAT => XYZ => D60_2_D65 => sRGB
    const ACESOutputMat = $d89c9137a3d237c2$var$mat3(1.60475, -0.53108, -0.07367, -0.10208, 1.10813, -0.00605, -0.00327, -0.07276, 1.07602);
    color = color.mul(exposure).div(0.6);
    color = ACESInputMat.mul(color);
    // Apply RRT and ODT
    color = $d89c9137a3d237c2$var$RRTAndODTFit(color);
    color = ACESOutputMat.mul(color);
    // Clamp to [0, 1]
    return color.clamp();
}).setLayout({
    name: 'acesFilmicToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$LINEAR_REC2020_TO_LINEAR_SRGB = /*@__PURE__*/ $d89c9137a3d237c2$var$mat3($d89c9137a3d237c2$var$vec3(1.6605, -0.1246, -0.0182), $d89c9137a3d237c2$var$vec3(-0.5876, 1.1329, -0.1006), $d89c9137a3d237c2$var$vec3(-0.0728, -0.0083, 1.1187));
const $d89c9137a3d237c2$var$LINEAR_SRGB_TO_LINEAR_REC2020 = /*@__PURE__*/ $d89c9137a3d237c2$var$mat3($d89c9137a3d237c2$var$vec3(0.6274, 0.0691, 0.0164), $d89c9137a3d237c2$var$vec3(0.3293, 0.9195, 0.0880), $d89c9137a3d237c2$var$vec3(0.0433, 0.0113, 0.8956));
const $d89c9137a3d237c2$var$agxDefaultContrastApprox = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x_immutable])=>{
    const x = $d89c9137a3d237c2$var$vec3(x_immutable).toVar();
    const x2 = $d89c9137a3d237c2$var$vec3(x.mul(x)).toVar();
    const x4 = $d89c9137a3d237c2$var$vec3(x2.mul(x2)).toVar();
    return $d89c9137a3d237c2$var$float(15.5).mul(x4.mul(x2)).sub($d89c9137a3d237c2$var$mul(40.14, x4.mul(x))).add($d89c9137a3d237c2$var$mul(31.96, x4).sub($d89c9137a3d237c2$var$mul(6.868, x2.mul(x))).add($d89c9137a3d237c2$var$mul(0.4298, x2).add($d89c9137a3d237c2$var$mul(0.1191, x).sub(0.00232))));
});
/**
 * AgX tone mapping.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $d89c9137a3d237c2$var$agxToneMapping = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color, exposure])=>{
    const colortone = $d89c9137a3d237c2$var$vec3(color).toVar();
    const AgXInsetMatrix = $d89c9137a3d237c2$var$mat3($d89c9137a3d237c2$var$vec3(0.856627153315983, 0.137318972929847, 0.11189821299995), $d89c9137a3d237c2$var$vec3(0.0951212405381588, 0.761241990602591, 0.0767994186031903), $d89c9137a3d237c2$var$vec3(0.0482516061458583, 0.101439036467562, 0.811302368396859));
    const AgXOutsetMatrix = $d89c9137a3d237c2$var$mat3($d89c9137a3d237c2$var$vec3(1.1271005818144368, -0.1413297634984383, -0.14132976349843826), $d89c9137a3d237c2$var$vec3(-0.11060664309660323, 1.157823702216272, -0.11060664309660294), $d89c9137a3d237c2$var$vec3(-0.016493938717834573, -0.016493938717834257, 1.2519364065950405));
    const AgxMinEv = $d89c9137a3d237c2$var$float(-12.47393);
    const AgxMaxEv = $d89c9137a3d237c2$var$float(4.026069);
    colortone.mulAssign(exposure);
    colortone.assign($d89c9137a3d237c2$var$LINEAR_SRGB_TO_LINEAR_REC2020.mul(colortone));
    colortone.assign(AgXInsetMatrix.mul(colortone));
    colortone.assign($d89c9137a3d237c2$var$max$1(colortone, 1e-10));
    colortone.assign($d89c9137a3d237c2$var$log2(colortone));
    colortone.assign(colortone.sub(AgxMinEv).div(AgxMaxEv.sub(AgxMinEv)));
    colortone.assign($d89c9137a3d237c2$var$clamp(colortone, 0.0, 1.0));
    colortone.assign($d89c9137a3d237c2$var$agxDefaultContrastApprox(colortone));
    colortone.assign(AgXOutsetMatrix.mul(colortone));
    colortone.assign($d89c9137a3d237c2$var$pow($d89c9137a3d237c2$var$max$1($d89c9137a3d237c2$var$vec3(0.0), colortone), $d89c9137a3d237c2$var$vec3(2.2)));
    colortone.assign($d89c9137a3d237c2$var$LINEAR_REC2020_TO_LINEAR_SRGB.mul(colortone));
    colortone.assign($d89c9137a3d237c2$var$clamp(colortone, 0.0, 1.0));
    return colortone;
}).setLayout({
    name: 'agxToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
/**
 * Neutral tone mapping.
 *
 * Reference: {@link https://modelviewer.dev/examples/tone-mapping}
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $d89c9137a3d237c2$var$neutralToneMapping = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color, exposure])=>{
    const StartCompression = $d89c9137a3d237c2$var$float(0.76);
    const Desaturation = $d89c9137a3d237c2$var$float(0.15);
    color = color.mul(exposure);
    const x = $d89c9137a3d237c2$var$min$1(color.r, $d89c9137a3d237c2$var$min$1(color.g, color.b));
    const offset = $d89c9137a3d237c2$var$select(x.lessThan(0.08), x.sub($d89c9137a3d237c2$var$mul(6.25, x.mul(x))), 0.04);
    color.subAssign(offset);
    const peak = $d89c9137a3d237c2$var$max$1(color.r, $d89c9137a3d237c2$var$max$1(color.g, color.b));
    $d89c9137a3d237c2$var$If(peak.lessThan(StartCompression), ()=>{
        return color;
    });
    const d = $d89c9137a3d237c2$var$sub(1, StartCompression);
    const newPeak = $d89c9137a3d237c2$var$sub(1, d.mul(d).div(peak.add(d.sub(StartCompression))));
    color.mulAssign(newPeak.div(peak));
    const g = $d89c9137a3d237c2$var$sub(1, $d89c9137a3d237c2$var$div(1, Desaturation.mul(peak.sub(newPeak)).add(1)));
    return $d89c9137a3d237c2$var$mix(color, $d89c9137a3d237c2$var$vec3(newPeak), g);
}).setLayout({
    name: 'neutralToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
/**
 * This class represents native code sections. It is the base
 * class for modules like {@link FunctionNode} which allows to implement
 * functions with native shader languages.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$347eb46a3090e941 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'CodeNode';
    }
    /**
	 * Constructs a new code node.
	 *
	 * @param {string} [code=''] - The native code.
	 * @param {Array<Node>} [includes=[]] - An array of includes.
	 * @param {('js'|'wgsl'|'glsl')} [language=''] - The used language.
	 */ constructor(code = '', includes = [], language = ''){
        super('code');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCodeNode = true;
        /**
		 * This flag is used for global cache.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
        /**
		 * The native code.
		 *
		 * @type {string}
		 * @default ''
		 */ this.code = code;
        /**
		 * An array of includes
		 *
		 * @type {Array<Node>}
		 * @default []
		 */ this.includes = includes;
        /**
		 * The used language.
		 *
		 * @type {('js'|'wgsl'|'glsl')}
		 * @default ''
		 */ this.language = language;
    }
    /**
	 * Sets the includes of this code node.
	 *
	 * @param {Array<Node>} includes - The includes to set.
	 * @return {CodeNode} A reference to this node.
	 */ setIncludes(includes) {
        this.includes = includes;
        return this;
    }
    /**
	 * Returns the includes of this code node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Array<Node>} The includes.
	 */ getIncludes() {
        return this.includes;
    }
    generate(builder) {
        const includes = this.getIncludes(builder);
        for (const include of includes)include.build(builder);
        const nodeCode = builder.getCodeFromNode(this, this.getNodeType(builder));
        nodeCode.code = this.code;
        return nodeCode.code;
    }
    serialize(data) {
        super.serialize(data);
        data.code = this.code;
        data.language = this.language;
    }
    deserialize(data) {
        super.deserialize(data);
        this.code = data.code;
        this.language = data.language;
    }
}
/**
 * TSL function for creating a code node.
 *
 * @tsl
 * @function
 * @param {string} [code] - The native code.
 * @param {?Array<Node>} [includes=[]] - An array of includes.
 * @param {?('js'|'wgsl'|'glsl')} [language=''] - The used language.
 * @returns {CodeNode}
 */ const $d89c9137a3d237c2$var$code = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$347eb46a3090e941).setParameterLength(1, 3);
/**
 * TSL function for creating a JS code node.
 *
 * @tsl
 * @function
 * @param {string} src - The native code.
 * @param {Array<Node>} includes - An array of includes.
 * @returns {CodeNode}
 */ const $d89c9137a3d237c2$var$js = (src, includes)=>$d89c9137a3d237c2$var$code(src, includes, 'js');
/**
 * TSL function for creating a WGSL code node.
 *
 * @tsl
 * @function
 * @param {string} src - The native code.
 * @param {Array<Node>} includes - An array of includes.
 * @returns {CodeNode}
 */ const $d89c9137a3d237c2$var$wgsl = (src, includes)=>$d89c9137a3d237c2$var$code(src, includes, 'wgsl');
/**
 * TSL function for creating a GLSL code node.
 *
 * @tsl
 * @function
 * @param {string} src - The native code.
 * @param {Array<Node>} includes - An array of includes.
 * @returns {CodeNode}
 */ const $d89c9137a3d237c2$var$glsl = (src, includes)=>$d89c9137a3d237c2$var$code(src, includes, 'glsl');
/**
 * This class represents a native shader function. It can be used to implement
 * certain aspects of a node material with native shader code. There are two predefined
 * TSL functions for easier usage.
 *
 * - `wgslFn`: Creates a WGSL function node.
 * - `glslFn`: Creates a GLSL function node.
 *
 * A basic example with one include looks like so:
 *
 * ```js
 * const desaturateWGSLFn = wgslFn( `
 *	fn desaturate( color:vec3<f32> ) -> vec3<f32> {
 *		let lum = vec3<f32>( 0.299, 0.587, 0.114 );
 *		return vec3<f32>( dot( lum, color ) );
 *	}`
 *);
 * const someWGSLFn = wgslFn( `
 *	fn someFn( color:vec3<f32> ) -> vec3<f32> {
 * 		return desaturate( color );
 * 	}
 * `, [ desaturateWGSLFn ] );
 * material.colorNode = someWGSLFn( { color: texture( map ) } );
 *```
 * @augments CodeNode
 */ class $d89c9137a3d237c2$export$f2972be796679c12 extends $d89c9137a3d237c2$export$347eb46a3090e941 {
    static get type() {
        return 'FunctionNode';
    }
    /**
	 * Constructs a new function node.
	 *
	 * @param {string} [code=''] - The native code.
	 * @param {Array<Node>} [includes=[]] - An array of includes.
	 * @param {('js'|'wgsl'|'glsl')} [language=''] - The used language.
	 */ constructor(code = '', includes = [], language = ''){
        super(code, includes, language);
    }
    /**
	 * Returns the type of this function node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The type.
	 */ getNodeType(builder) {
        return this.getNodeFunction(builder).type;
    }
    /**
	 * Returns the type of a member of this function node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The name of the member.
	 * @return {string} The type of the member.
	 */ getMemberType(builder, name) {
        const type = this.getNodeType(builder);
        const structType = builder.getStructTypeNode(type);
        return structType.getMemberType(builder, name);
    }
    /**
	 * Returns the inputs of this function node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Array<NodeFunctionInput>} The inputs.
	 */ getInputs(builder) {
        return this.getNodeFunction(builder).inputs;
    }
    /**
	 * Returns the node function for this function node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {NodeFunction} The node function.
	 */ getNodeFunction(builder) {
        const nodeData = builder.getDataFromNode(this);
        let nodeFunction = nodeData.nodeFunction;
        if (nodeFunction === undefined) {
            nodeFunction = builder.parser.parseFunction(this.code);
            nodeData.nodeFunction = nodeFunction;
        }
        return nodeFunction;
    }
    generate(builder, output) {
        super.generate(builder);
        const nodeFunction = this.getNodeFunction(builder);
        const name = nodeFunction.name;
        const type = nodeFunction.type;
        const nodeCode = builder.getCodeFromNode(this, type);
        if (name !== '') // use a custom property name
        nodeCode.name = name;
        const propertyName = builder.getPropertyName(nodeCode);
        const code = this.getNodeFunction(builder).getCode(propertyName);
        nodeCode.code = code + '\n';
        if (output === 'property') return propertyName;
        else return builder.format(`${propertyName}()`, type, output);
    }
}
const $d89c9137a3d237c2$var$nativeFn = (code, includes = [], language = '')=>{
    for(let i = 0; i < includes.length; i++){
        const include = includes[i];
        // TSL Function: glslFn, wgslFn
        if (typeof include === 'function') includes[i] = include.functionNode;
    }
    const functionNode = new $d89c9137a3d237c2$export$f2972be796679c12(code, includes, language);
    const fn = (...params)=>functionNode.call(...params);
    fn.functionNode = functionNode;
    return fn;
};
const $d89c9137a3d237c2$var$glslFn = (code, includes)=>$d89c9137a3d237c2$var$nativeFn(code, includes, 'glsl');
const $d89c9137a3d237c2$var$wgslFn = (code, includes)=>$d89c9137a3d237c2$var$nativeFn(code, includes, 'wgsl');
/**
 * `ScriptableNode` uses this class to manage script inputs and outputs.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$1cc044adb974a57c extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ScriptableValueNode';
    }
    /**
	 * Constructs a new scriptable node.
	 *
	 * @param {any} [value=null] - The value.
	 */ constructor(value = null){
        super();
        /**
		 * A reference to the value.
		 *
		 * @private
		 * @default null
		 */ this._value = value;
        /**
		 * Depending on the type of `_value`, this property might cache parsed data.
		 *
		 * @private
		 * @default null
		 */ this._cache = null;
        /**
		 * If this node represents an input, this property represents the input type.
		 *
		 * @type {?string}
		 * @default null
		 */ this.inputType = null;
        /**
		 * If this node represents an output, this property represents the output type.
		 *
		 * @type {?string}
		 * @default null
		 */ this.outputType = null;
        /**
		 * An event dispatcher for managing events.
		 *
		 * @type {EventDispatcher}
		 */ this.events = new (0, $329ek.EventDispatcher)();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isScriptableValueNode = true;
    }
    /**
	 * Whether this node represents an output or not.
	 *
	 * @type {boolean}
	 * @readonly
	 * @default true
	 */ get isScriptableOutputNode() {
        return this.outputType !== null;
    }
    set value(val) {
        if (this._value === val) return;
        if (this._cache && this.inputType === 'URL' && this.value.value instanceof ArrayBuffer) {
            URL.revokeObjectURL(this._cache);
            this._cache = null;
        }
        this._value = val;
        this.events.dispatchEvent({
            type: 'change'
        });
        this.refresh();
    }
    /**
	 * The node's value.
	 *
	 * @type {any}
	 */ get value() {
        return this._value;
    }
    /**
	 * Dispatches the `refresh` event.
	 */ refresh() {
        this.events.dispatchEvent({
            type: 'refresh'
        });
    }
    /**
	 * The `value` property usually represents a node or even binary data in form of array buffers.
	 * In this case, this method tries to return the actual value behind the complex type.
	 *
	 * @return {any} The value.
	 */ getValue() {
        const value = this.value;
        if (value && this._cache === null && this.inputType === 'URL' && value.value instanceof ArrayBuffer) this._cache = URL.createObjectURL(new Blob([
            value.value
        ]));
        else if (value && value.value !== null && value.value !== undefined && ((this.inputType === 'URL' || this.inputType === 'String') && typeof value.value === 'string' || this.inputType === 'Number' && typeof value.value === 'number' || this.inputType === 'Vector2' && value.value.isVector2 || this.inputType === 'Vector3' && value.value.isVector3 || this.inputType === 'Vector4' && value.value.isVector4 || this.inputType === 'Color' && value.value.isColor || this.inputType === 'Matrix3' && value.value.isMatrix3 || this.inputType === 'Matrix4' && value.value.isMatrix4)) return value.value;
        return this._cache || value;
    }
    /**
	 * Overwritten since the node type is inferred from the value.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        return this.value && this.value.isNode ? this.value.getNodeType(builder) : 'float';
    }
    setup() {
        return this.value && this.value.isNode ? this.value : $d89c9137a3d237c2$var$float();
    }
    serialize(data) {
        super.serialize(data);
        if (this.value !== null) {
            if (this.inputType === 'ArrayBuffer') data.value = $d89c9137a3d237c2$var$arrayBufferToBase64(this.value);
            else data.value = this.value ? this.value.toJSON(data.meta).uuid : null;
        } else data.value = null;
        data.inputType = this.inputType;
        data.outputType = this.outputType;
    }
    deserialize(data) {
        super.deserialize(data);
        let value = null;
        if (data.value !== null) {
            if (data.inputType === 'ArrayBuffer') value = $d89c9137a3d237c2$var$base64ToArrayBuffer(data.value);
            else if (data.inputType === 'Texture') value = data.meta.textures[data.value];
            else value = data.meta.nodes[data.value] || null;
        }
        this.value = value;
        this.inputType = data.inputType;
        this.outputType = data.outputType;
    }
}
/**
 * TSL function for creating a scriptable value node.
 *
 * @tsl
 * @function
 * @param {any} [value] - The value.
 * @returns {ScriptableValueNode}
 */ const $d89c9137a3d237c2$var$scriptableValue = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$1cc044adb974a57c).setParameterLength(1);
/**
 * A Map-like data structure for managing resources of scriptable nodes.
 *
 * @augments Map
 */ class $d89c9137a3d237c2$var$Resources extends Map {
    get(key, callback = null, ...params) {
        if (this.has(key)) return super.get(key);
        if (callback !== null) {
            const value = callback(...params);
            this.set(key, value);
            return value;
        }
    }
}
class $d89c9137a3d237c2$var$Parameters {
    constructor(scriptableNode){
        this.scriptableNode = scriptableNode;
    }
    get parameters() {
        return this.scriptableNode.parameters;
    }
    get layout() {
        return this.scriptableNode.getLayout();
    }
    getInputLayout(id) {
        return this.scriptableNode.getInputLayout(id);
    }
    get(name) {
        const param = this.parameters[name];
        const value = param ? param.getValue() : null;
        return value;
    }
}
/**
 * Defines the resources (e.g. namespaces) of scriptable nodes.
 *
 * @type {Resources}
 */ const $d89c9137a3d237c2$var$ScriptableNodeResources = new $d89c9137a3d237c2$var$Resources();
/**
 * This type of node allows to implement nodes with custom scripts. The script
 * section is represented as an instance of `CodeNode` written with JavaScript.
 * The script itself must adhere to a specific structure.
 *
 * - main(): Executed once by default and every time `node.needsUpdate` is set.
 * - layout: The layout object defines the script's interface (inputs and outputs).
 *
 * ```js
 * ScriptableNodeResources.set( 'TSL', TSL );
 *
 * const scriptableNode = scriptable( js( `
 * 	layout = {
 * 		outputType: 'node',
 * 		elements: [
 * 			{ name: 'source', inputType: 'node' },
 * 		]
 * 	};
 *
 * 	const { mul, oscSine } = TSL;
 *
 * 	function main() {
 * 		const source = parameters.get( 'source' ) || float();
 * 		return mul( source, oscSine() ) );
 * 	}
 *
 * ` ) );
 *
 * scriptableNode.setParameter( 'source', color( 1, 0, 0 ) );
 *
 * const material = new THREE.MeshBasicNodeMaterial();
 * material.colorNode = scriptableNode;
 * ```
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$60392a967062f8b4 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ScriptableNode';
    }
    /**
	 * Constructs a new scriptable node.
	 *
	 * @param {?CodeNode} [codeNode=null] - The code node.
	 * @param {Object} [parameters={}] - The parameters definition.
	 */ constructor(codeNode = null, parameters = {}){
        super();
        /**
		 * The code node.
		 *
		 * @type {?CodeNode}
		 * @default null
		 */ this.codeNode = codeNode;
        /**
		 * The parameters definition.
		 *
		 * @type {Object}
		 * @default {}
		 */ this.parameters = parameters;
        this._local = new $d89c9137a3d237c2$var$Resources();
        this._output = $d89c9137a3d237c2$var$scriptableValue(null);
        this._outputs = {};
        this._source = this.source;
        this._method = null;
        this._object = null;
        this._value = null;
        this._needsOutputUpdate = true;
        this.onRefresh = this.onRefresh.bind(this);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isScriptableNode = true;
    }
    /**
	 * The source code of the scriptable node.
	 *
	 * @type {string}
	 */ get source() {
        return this.codeNode ? this.codeNode.code : '';
    }
    /**
	 * Sets the reference of a local script variable.
	 *
	 * @param {string} name - The variable name.
	 * @param {Object} value - The reference to set.
	 * @return {Resources} The resource map
	 */ setLocal(name, value) {
        return this._local.set(name, value);
    }
    /**
	 * Gets the value of a local script variable.
	 *
	 * @param {string} name - The variable name.
	 * @return {Object} The value.
	 */ getLocal(name) {
        return this._local.get(name);
    }
    /**
	 * Event listener for the `refresh` event.
	 */ onRefresh() {
        this._refresh();
    }
    /**
	 * Returns an input from the layout with the given id/name.
	 *
	 * @param {string} id - The id/name of the input.
	 * @return {Object} The element entry.
	 */ getInputLayout(id) {
        for (const element of this.getLayout()){
            if (element.inputType && (element.id === id || element.name === id)) return element;
        }
    }
    /**
	 * Returns an output from the layout with the given id/name.
	 *
	 * @param {string} id - The id/name of the output.
	 * @return {Object} The element entry.
	 */ getOutputLayout(id) {
        for (const element of this.getLayout()){
            if (element.outputType && (element.id === id || element.name === id)) return element;
        }
    }
    /**
	 * Defines a script output for the given name and value.
	 *
	 * @param {string} name - The name of the output.
	 * @param {Node} value - The node value.
	 * @return {ScriptableNode} A reference to this node.
	 */ setOutput(name, value) {
        const outputs = this._outputs;
        if (outputs[name] === undefined) outputs[name] = $d89c9137a3d237c2$var$scriptableValue(value);
        else outputs[name].value = value;
        return this;
    }
    /**
	 * Returns a script output for the given name.
	 *
	 * @param {string} name - The name of the output.
	 * @return {ScriptableValueNode} The node value.
	 */ getOutput(name) {
        return this._outputs[name];
    }
    /**
	 * Returns a parameter for the given name
	 *
	 * @param {string} name - The name of the parameter.
	 * @return {ScriptableValueNode} The node value.
	 */ getParameter(name) {
        return this.parameters[name];
    }
    /**
	 * Sets a value for the given parameter name.
	 *
	 * @param {string} name - The parameter name.
	 * @param {any} value - The parameter value.
	 * @return {ScriptableNode} A reference to this node.
	 */ setParameter(name, value) {
        const parameters = this.parameters;
        if (value && value.isScriptableNode) {
            this.deleteParameter(name);
            parameters[name] = value;
            parameters[name].getDefaultOutput().events.addEventListener('refresh', this.onRefresh);
        } else if (value && value.isScriptableValueNode) {
            this.deleteParameter(name);
            parameters[name] = value;
            parameters[name].events.addEventListener('refresh', this.onRefresh);
        } else if (parameters[name] === undefined) {
            parameters[name] = $d89c9137a3d237c2$var$scriptableValue(value);
            parameters[name].events.addEventListener('refresh', this.onRefresh);
        } else parameters[name].value = value;
        return this;
    }
    /**
	 * Returns the value of this node which is the value of
	 * the default output.
	 *
	 * @return {Node} The value.
	 */ getValue() {
        return this.getDefaultOutput().getValue();
    }
    /**
	 * Deletes a parameter from the script.
	 *
	 * @param {string} name - The parameter to remove.
	 * @return {ScriptableNode} A reference to this node.
	 */ deleteParameter(name) {
        let valueNode = this.parameters[name];
        if (valueNode) {
            if (valueNode.isScriptableNode) valueNode = valueNode.getDefaultOutput();
            valueNode.events.removeEventListener('refresh', this.onRefresh);
        }
        return this;
    }
    /**
	 * Deletes all parameters from the script.
	 *
	 * @return {ScriptableNode} A reference to this node.
	 */ clearParameters() {
        for (const name of Object.keys(this.parameters))this.deleteParameter(name);
        this.needsUpdate = true;
        return this;
    }
    /**
	 * Calls a function from the script.
	 *
	 * @param {string} name - The function name.
	 * @param {...any} params - A list of parameters.
	 * @return {any} The result of the function call.
	 */ call(name, ...params) {
        const object = this.getObject();
        const method = object[name];
        if (typeof method === 'function') return method(...params);
    }
    /**
	 * Asynchronously calls a function from the script.
	 *
	 * @param {string} name - The function name.
	 * @param {...any} params - A list of parameters.
	 * @return {Promise<any>} The result of the function call.
	 */ async callAsync(name, ...params) {
        const object = this.getObject();
        const method = object[name];
        if (typeof method === 'function') return method.constructor.name === 'AsyncFunction' ? await method(...params) : method(...params);
    }
    /**
	 * Overwritten since the node types is inferred from the script's output.
	 *
	 * @param {NodeBuilder} builder - The current node builder
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        return this.getDefaultOutputNode().getNodeType(builder);
    }
    /**
	 * Refreshes the script node.
	 *
	 * @param {?string} [output=null] - An optional output.
	 */ refresh(output = null) {
        if (output !== null) this.getOutput(output).refresh();
        else this._refresh();
    }
    /**
	 * Returns an object representation of the script.
	 *
	 * @return {Object} The result object.
	 */ getObject() {
        if (this.needsUpdate) this.dispose();
        if (this._object !== null) return this._object;
        //
        const refresh = ()=>this.refresh();
        const setOutput = (id, value)=>this.setOutput(id, value);
        const parameters = new $d89c9137a3d237c2$var$Parameters(this);
        const THREE = $d89c9137a3d237c2$var$ScriptableNodeResources.get('THREE');
        const TSL = $d89c9137a3d237c2$var$ScriptableNodeResources.get('TSL');
        const method = this.getMethod();
        const params = [
            parameters,
            this._local,
            $d89c9137a3d237c2$var$ScriptableNodeResources,
            refresh,
            setOutput,
            THREE,
            TSL
        ];
        this._object = method(...params);
        const layout = this._object.layout;
        if (layout) {
            if (layout.cache === false) this._local.clear();
            // default output
            this._output.outputType = layout.outputType || null;
            if (Array.isArray(layout.elements)) for (const element of layout.elements){
                const id = element.id || element.name;
                if (element.inputType) {
                    if (this.getParameter(id) === undefined) this.setParameter(id, null);
                    this.getParameter(id).inputType = element.inputType;
                }
                if (element.outputType) {
                    if (this.getOutput(id) === undefined) this.setOutput(id, null);
                    this.getOutput(id).outputType = element.outputType;
                }
            }
        }
        return this._object;
    }
    deserialize(data) {
        super.deserialize(data);
        for(const name in this.parameters){
            let valueNode = this.parameters[name];
            if (valueNode.isScriptableNode) valueNode = valueNode.getDefaultOutput();
            valueNode.events.addEventListener('refresh', this.onRefresh);
        }
    }
    /**
	 * Returns the layout of the script.
	 *
	 * @return {Object} The script's layout.
	 */ getLayout() {
        return this.getObject().layout;
    }
    /**
	 * Returns default node output of the script.
	 *
	 * @return {Node} The default node output.
	 */ getDefaultOutputNode() {
        const output = this.getDefaultOutput().value;
        if (output && output.isNode) return output;
        return $d89c9137a3d237c2$var$float();
    }
    /**
	 * Returns default output of the script.
	 *
	 * @return {ScriptableValueNode} The default output.
	 */ getDefaultOutput() {
        return this._exec()._output;
    }
    /**
	 * Returns a function created from the node's script.
	 *
	 * @return {Function} The function representing the node's code.
	 */ getMethod() {
        if (this.needsUpdate) this.dispose();
        if (this._method !== null) return this._method;
        //
        const parametersProps = [
            'parameters',
            'local',
            'global',
            'refresh',
            'setOutput',
            'THREE',
            'TSL'
        ];
        const interfaceProps = [
            'layout',
            'init',
            'main',
            'dispose'
        ];
        const properties = interfaceProps.join(', ');
        const declarations = 'var ' + properties + '; var output = {};\n';
        const returns = '\nreturn { ...output, ' + properties + ' };';
        const code = declarations + this.codeNode.code + returns;
        //
        this._method = new Function(...parametersProps, code);
        return this._method;
    }
    /**
	 * Frees all internal resources.
	 */ dispose() {
        if (this._method === null) return;
        if (this._object && typeof this._object.dispose === 'function') this._object.dispose();
        this._method = null;
        this._object = null;
        this._source = null;
        this._value = null;
        this._needsOutputUpdate = true;
        this._output.value = null;
        this._outputs = {};
    }
    setup() {
        return this.getDefaultOutputNode();
    }
    getCacheKey(force) {
        const values = [
            $d89c9137a3d237c2$var$hashString(this.source),
            this.getDefaultOutputNode().getCacheKey(force)
        ];
        for(const param in this.parameters)values.push(this.parameters[param].getCacheKey(force));
        return $d89c9137a3d237c2$var$hashArray(values);
    }
    set needsUpdate(value) {
        if (value === true) this.dispose();
    }
    get needsUpdate() {
        return this.source !== this._source;
    }
    /**
	 * Executes the `main` function of the script.
	 *
	 * @private
	 * @return {ScriptableNode} A reference to this node.
	 */ _exec() {
        if (this.codeNode === null) return this;
        if (this._needsOutputUpdate === true) {
            this._value = this.call('main');
            this._needsOutputUpdate = false;
        }
        this._output.value = this._value;
        return this;
    }
    /**
	 * Executes the refresh.
	 *
	 * @private
	 */ _refresh() {
        this.needsUpdate = true;
        this._exec();
        this._output.refresh();
    }
}
/**
 * TSL function for creating a scriptable node.
 *
 * @tsl
 * @function
 * @param {CodeNode} [codeNode] - The code node.
 * @param {?Object} [parameters={}] - The parameters definition.
 * @returns {ScriptableNode}
 */ const $d89c9137a3d237c2$var$scriptable = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$60392a967062f8b4).setParameterLength(1, 2);
/**
 * Returns a node that represents the `z` coordinate in view space
 * for the current fragment. It's a different representation of the
 * default depth value.
 *
 * This value can be part of a computation that defines how the fog
 * density increases when moving away from the camera.
 *
 * @param {NodeBuilder} builder - The current node builder.
 * @return {Node} The viewZ node.
 */ function $d89c9137a3d237c2$var$getViewZNode(builder) {
    let viewZ;
    const getViewZ = builder.context.getViewZ;
    if (getViewZ !== undefined) viewZ = getViewZ(this);
    return (viewZ || $d89c9137a3d237c2$var$positionView.z).negate();
}
/**
 * Constructs a new range factor node.
 *
 * @tsl
 * @function
 * @param {Node} near - Defines the near value.
 * @param {Node} far - Defines the far value.
 */ const $d89c9137a3d237c2$var$rangeFogFactor = $d89c9137a3d237c2$var$Fn(([near, far], builder)=>{
    const viewZ = $d89c9137a3d237c2$var$getViewZNode(builder);
    return $d89c9137a3d237c2$var$smoothstep(near, far, viewZ);
});
/**
 * Represents an exponential squared fog. This type of fog gives
 * a clear view near the camera and a faster than exponentially
 * densening fog farther from the camera.
 *
 * @tsl
 * @function
 * @param {Node} density - Defines the fog density.
 */ const $d89c9137a3d237c2$var$densityFogFactor = $d89c9137a3d237c2$var$Fn(([density], builder)=>{
    const viewZ = $d89c9137a3d237c2$var$getViewZNode(builder);
    return density.mul(density, viewZ, viewZ).negate().exp().oneMinus();
});
/**
 * This class can be used to configure a fog for the scene.
 * Nodes of this type are assigned to `Scene.fogNode`.
 *
 * @tsl
 * @function
 * @param {Node} color - Defines the color of the fog.
 * @param {Node} factor - Defines how the fog is factored in the scene.
 */ const $d89c9137a3d237c2$var$fog = $d89c9137a3d237c2$var$Fn(([color, factor])=>{
    return $d89c9137a3d237c2$var$vec4(factor.toFloat().mix($d89c9137a3d237c2$var$output.rgb, color.toVec3()), $d89c9137a3d237c2$var$output.a);
});
// Deprecated
/**
 * @tsl
 * @function
 * @deprecated since r171. Use `fog( color, rangeFogFactor( near, far ) )` instead.
 *
 * @param {Node} color
 * @param {Node} near
 * @param {Node} far
 * @returns {Function}
 */ function $d89c9137a3d237c2$var$rangeFog(color, near, far) {
    (0, $329ek.warn)('TSL: "rangeFog( color, near, far )" is deprecated. Use "fog( color, rangeFogFactor( near, far ) )" instead.');
    return $d89c9137a3d237c2$var$fog(color, $d89c9137a3d237c2$var$rangeFogFactor(near, far));
}
/**
 * @tsl
 * @function
 * @deprecated since r171. Use `fog( color, densityFogFactor( density ) )` instead.
 *
 * @param {Node} color
 * @param {Node} density
 * @returns {Function}
 */ function $d89c9137a3d237c2$var$densityFog(color, density) {
    (0, $329ek.warn)('TSL: "densityFog( color, density )" is deprecated. Use "fog( color, densityFogFactor( density ) )" instead.');
    return $d89c9137a3d237c2$var$fog(color, $d89c9137a3d237c2$var$densityFogFactor(density));
}
let $d89c9137a3d237c2$var$min = null;
let $d89c9137a3d237c2$var$max = null;
/**
 * `RangeNode` generates random instanced attribute data in a defined range.
 * An exemplary use case for this utility node is to generate random per-instance
 * colors:
 * ```js
 * const material = new MeshBasicNodeMaterial();
 * material.colorNode = range( new Color( 0x000000 ), new Color( 0xFFFFFF ) );
 * const mesh = new InstancedMesh( geometry, material, count );
 * ```
 * @augments Node
 */ class $d89c9137a3d237c2$export$d0e9917d83c120a0 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'RangeNode';
    }
    /**
	 * Constructs a new range node.
	 *
	 * @param {Node<any>} [minNode=float()] - A node defining the lower bound of the range.
	 * @param {Node<any>} [maxNode=float()] - A node defining the upper bound of the range.
	 */ constructor(minNode = $d89c9137a3d237c2$var$float(), maxNode = $d89c9137a3d237c2$var$float()){
        super();
        /**
		 *  A node defining the lower bound of the range.
		 *
		 * @type {Node<any>}
		 * @default float()
		 */ this.minNode = minNode;
        /**
		 *  A node defining the upper bound of the range.
		 *
		 * @type {Node<any>}
		 * @default float()
		 */ this.maxNode = maxNode;
    }
    /**
	 * Returns the vector length which is computed based on the range definition.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {number} The vector length.
	 */ getVectorLength(builder) {
        const minNode = this.getConstNode(this.minNode);
        const maxNode = this.getConstNode(this.maxNode);
        const minLength = builder.getTypeLength($d89c9137a3d237c2$var$getValueType(minNode.value));
        const maxLength = builder.getTypeLength($d89c9137a3d237c2$var$getValueType(maxNode.value));
        return minLength > maxLength ? minLength : maxLength;
    }
    /**
	 * This method is overwritten since the node type is inferred from range definition.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        return builder.object.count > 1 ? builder.getTypeFromLength(this.getVectorLength(builder)) : 'float';
    }
    /**
	 * Returns a constant node from the given node by traversing it.
	 *
	 * @param {Node} node - The node to traverse.
	 * @returns {Node} The constant node, if found.
	 */ getConstNode(node) {
        let output = null;
        node.traverse((n)=>{
            if (n.isConstNode === true) output = n;
        });
        if (output === null) throw new Error('THREE.TSL: No "ConstNode" found in node graph.');
        return output;
    }
    setup(builder) {
        const object = builder.object;
        let output = null;
        if (object.count > 1) {
            const minNode = this.getConstNode(this.minNode);
            const maxNode = this.getConstNode(this.maxNode);
            const minValue = minNode.value;
            const maxValue = maxNode.value;
            const minLength = builder.getTypeLength($d89c9137a3d237c2$var$getValueType(minValue));
            const maxLength = builder.getTypeLength($d89c9137a3d237c2$var$getValueType(maxValue));
            $d89c9137a3d237c2$var$min = $d89c9137a3d237c2$var$min || new (0, $329ek.Vector4)();
            $d89c9137a3d237c2$var$max = $d89c9137a3d237c2$var$max || new (0, $329ek.Vector4)();
            $d89c9137a3d237c2$var$min.setScalar(0);
            $d89c9137a3d237c2$var$max.setScalar(0);
            if (minLength === 1) $d89c9137a3d237c2$var$min.setScalar(minValue);
            else if (minValue.isColor) $d89c9137a3d237c2$var$min.set(minValue.r, minValue.g, minValue.b, 1);
            else $d89c9137a3d237c2$var$min.set(minValue.x, minValue.y, minValue.z || 0, minValue.w || 0);
            if (maxLength === 1) $d89c9137a3d237c2$var$max.setScalar(maxValue);
            else if (maxValue.isColor) $d89c9137a3d237c2$var$max.set(maxValue.r, maxValue.g, maxValue.b, 1);
            else $d89c9137a3d237c2$var$max.set(maxValue.x, maxValue.y, maxValue.z || 0, maxValue.w || 0);
            const stride = 4;
            const length = stride * object.count;
            const array = new Float32Array(length);
            for(let i = 0; i < length; i++){
                const index = i % stride;
                const minElementValue = $d89c9137a3d237c2$var$min.getComponent(index);
                const maxElementValue = $d89c9137a3d237c2$var$max.getComponent(index);
                array[i] = (0, $329ek.MathUtils).lerp(minElementValue, maxElementValue, Math.random());
            }
            const nodeType = this.getNodeType(builder);
            if (object.count <= 4096) output = $d89c9137a3d237c2$var$buffer(array, 'vec4', object.count).element($d89c9137a3d237c2$var$instanceIndex).convert(nodeType);
            else {
                // TODO: Improve anonymous buffer attribute creation removing this part
                const bufferAttribute = new (0, $329ek.InstancedBufferAttribute)(array, 4);
                builder.geometry.setAttribute('__range' + this.id, bufferAttribute);
                output = $d89c9137a3d237c2$var$instancedBufferAttribute(bufferAttribute).convert(nodeType);
            }
        } else output = $d89c9137a3d237c2$var$float(0);
        return output;
    }
}
/**
 * TSL function for creating a range node.
 *
 * @tsl
 * @function
 * @param {Node<any>} [minNode=float()] - A node defining the lower bound of the range.
 * @param {Node<any>} [maxNode=float()] - A node defining the upper bound of the range.
 * @returns {RangeNode}
 */ const $d89c9137a3d237c2$var$range = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$export$d0e9917d83c120a0).setParameterLength(2);
/**
 * `ComputeBuiltinNode` represents a compute-scope builtin value that expose information
 * about the currently running dispatch and/or the device it is running on.
 *
 * This node can only be used with a WebGPU backend.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$var$ComputeBuiltinNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ComputeBuiltinNode';
    }
    /**
	 * Constructs a new compute builtin node.
	 *
	 * @param {string} builtinName - The built-in name.
	 * @param {string} nodeType - The node type.
	 */ constructor(builtinName, nodeType){
        super(nodeType);
        /**
		 * The built-in name.
		 *
		 * @private
		 * @type {string}
		 */ this._builtinName = builtinName;
    }
    /**
	 * This method is overwritten since hash is derived from the built-in name.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The hash.
	 */ getHash(builder) {
        return this.getBuiltinName(builder);
    }
    /**
	 * This method is overwritten since the node type is simply derived from `nodeType`..
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType() {
        return this.nodeType;
    }
    /**
	 * Sets the builtin name.
	 *
	 * @param {string} builtinName - The built-in name.
	 * @return {ComputeBuiltinNode} A reference to this node.
	 */ setBuiltinName(builtinName) {
        this._builtinName = builtinName;
        return this;
    }
    /**
	 * Returns the builtin name.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The builtin name.
	 */ getBuiltinName() {
        return this._builtinName;
    }
    /**
	 * Whether the current node builder has the builtin or not.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {boolean} Whether the builder has the builtin or not.
	 */ hasBuiltin(builder) {
        return builder.hasBuiltin(this._builtinName);
    }
    generate(builder, output) {
        const builtinName = this.getBuiltinName(builder);
        const nodeType = this.getNodeType(builder);
        if (builder.shaderStage === 'compute') return builder.format(builtinName, nodeType, output);
        else {
            (0, $329ek.warn)(`ComputeBuiltinNode: Compute built-in value ${builtinName} can not be accessed in the ${builder.shaderStage} stage`);
            return builder.generateConst(nodeType);
        }
    }
    serialize(data) {
        super.serialize(data);
        data.global = this.global;
        data._builtinName = this._builtinName;
    }
    deserialize(data) {
        super.deserialize(data);
        this.global = data.global;
        this._builtinName = data._builtinName;
    }
}
/**
 * TSL function for creating a compute builtin node.
 *
 * @tsl
 * @function
 * @param {string} name - The built-in name.
 * @param {string} nodeType - The node type.
 * @returns {ComputeBuiltinNode}
 */ const $d89c9137a3d237c2$var$computeBuiltin = (name, nodeType)=>new $d89c9137a3d237c2$var$ComputeBuiltinNode(name, nodeType);
/**
 * Represents the number of workgroups dispatched by the compute shader.
 * ```js
 * // Run 512 invocations/threads with a workgroup size of 128.
 * const computeFn = Fn(() => {
 *
 *     // numWorkgroups.x = 4
 *     storageBuffer.element(0).assign(numWorkgroups.x)
 *
 * })().compute(512, [128]);
 *
 * // Run 512 invocations/threads with the default workgroup size of 64.
 * const computeFn = Fn(() => {
 *
 *     // numWorkgroups.x = 8
 *     storageBuffer.element(0).assign(numWorkgroups.x)
 *
 * })().compute(512);
 * ```
 *
 * @tsl
 * @type {ComputeBuiltinNode<uvec3>}
 */ const $d89c9137a3d237c2$var$numWorkgroups = /*@__PURE__*/ $d89c9137a3d237c2$var$computeBuiltin('numWorkgroups', 'uvec3');
/**
 * Represents the 3-dimensional index of the workgroup the current compute invocation belongs to.
 * ```js
 * // Execute 12 compute threads with a workgroup size of 3.
 * const computeFn = Fn( () => {
 *
 * 	If( workgroupId.x.mod( 2 ).equal( 0 ), () => {
 *
 * 		storageBuffer.element( instanceIndex ).assign( instanceIndex );
 *
 * 	} ).Else( () => {
 *
 * 		storageBuffer.element( instanceIndex ).assign( 0 );
 *
 * 	} );
 *
 * } )().compute( 12, [ 3 ] );
 *
 * // workgroupId.x =  [0, 0, 0, 1, 1, 1, 2, 2, 2, 3, 3, 3];
 * // Buffer Output =  [0, 1, 2, 0, 0, 0, 6, 7, 8, 0, 0, 0];
 * ```
 *
 * @tsl
 * @type {ComputeBuiltinNode<uvec3>}
 */ const $d89c9137a3d237c2$var$workgroupId = /*@__PURE__*/ $d89c9137a3d237c2$var$computeBuiltin('workgroupId', 'uvec3');
/**
 * A non-linearized 3-dimensional representation of the current invocation's position within a 3D global grid.
 *
 * @tsl
 * @type {ComputeBuiltinNode<uvec3>}
 */ const $d89c9137a3d237c2$var$globalId = /*@__PURE__*/ $d89c9137a3d237c2$var$computeBuiltin('globalId', 'uvec3');
/**
 * A non-linearized 3-dimensional representation of the current invocation's position within a 3D workgroup grid.
 *
 * @tsl
 * @type {ComputeBuiltinNode<uvec3>}
 */ const $d89c9137a3d237c2$var$localId = /*@__PURE__*/ $d89c9137a3d237c2$var$computeBuiltin('localId', 'uvec3');
/**
 * A device dependent variable that exposes the size of the current invocation's subgroup.
 *
 * @tsl
 * @type {ComputeBuiltinNode<uint>}
 */ const $d89c9137a3d237c2$var$subgroupSize = /*@__PURE__*/ $d89c9137a3d237c2$var$computeBuiltin('subgroupSize', 'uint');
/**
 * Represents a GPU control barrier that synchronizes compute operations within a given scope.
 *
 * This node can only be used with a WebGPU backend.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$var$BarrierNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    /**
	 * Constructs a new barrier node.
	 *
	 * @param {string} scope - The scope defines the behavior of the node.
	 */ constructor(scope){
        super();
        this.scope = scope;
    }
    generate(builder) {
        const { scope: scope } = this;
        const { renderer: renderer } = builder;
        if (renderer.backend.isWebGLBackend === true) builder.addFlowCode(`\t// ${scope}Barrier \n`);
        else builder.addLineFlowCode(`${scope}Barrier()`, this);
    }
}
/**
 * TSL function for creating a barrier node.
 *
 * @tsl
 * @function
 * @param {string} scope - The scope defines the behavior of the node..
 * @returns {BarrierNode}
 */ const $d89c9137a3d237c2$var$barrier = $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$var$BarrierNode);
/**
 * TSL function for creating a workgroup barrier. All compute shader
 * invocations must wait for each invocation within a workgroup to
 * complete before the barrier can be surpassed.
 *
 * @tsl
 * @function
 * @returns {BarrierNode}
 */ const $d89c9137a3d237c2$var$workgroupBarrier = ()=>$d89c9137a3d237c2$var$barrier('workgroup').toStack();
/**
 * TSL function for creating a storage barrier. All invocations must
 * wait for each access to variables within the 'storage' address space
 * to complete before the barrier can be passed.
 *
 * @tsl
 * @function
 * @returns {BarrierNode}
 */ const $d89c9137a3d237c2$var$storageBarrier = ()=>$d89c9137a3d237c2$var$barrier('storage').toStack();
/**
 * TSL function for creating a texture barrier. All invocations must
 * wait for each access to variables within the 'texture' address space
 * to complete before the barrier can be passed.
 *
 * @tsl
 * @function
 * @returns {BarrierNode}
 */ const $d89c9137a3d237c2$var$textureBarrier = ()=>$d89c9137a3d237c2$var$barrier('texture').toStack();
/**
 * Represents an element of a 'workgroup' scoped buffer.
 *
 * @augments ArrayElementNode
 */ class $d89c9137a3d237c2$var$WorkgroupInfoElementNode extends $d89c9137a3d237c2$export$f2edd1d22bf6d00b {
    /**
	 * Constructs a new workgroup info element node.
	 *
	 * @param {Node} workgroupInfoNode - The workgroup info node.
	 * @param {Node} indexNode - The index node that defines the element access.
	 */ constructor(workgroupInfoNode, indexNode){
        super(workgroupInfoNode, indexNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWorkgroupInfoElementNode = true;
    }
    generate(builder, output) {
        let snippet;
        const isAssignContext = builder.context.assign;
        snippet = super.generate(builder);
        if (isAssignContext !== true) {
            const type = this.getNodeType(builder);
            snippet = builder.format(snippet, type, output);
        }
        // TODO: Possibly activate clip distance index on index access rather than from clipping context
        return snippet;
    }
}
/**
 * A node allowing the user to create a 'workgroup' scoped buffer within the
 * context of a compute shader. Typically, workgroup scoped buffers are
 * created to hold data that is transferred from a global storage scope into
 * a local workgroup scope. For invocations within a workgroup, data
 * access speeds on 'workgroup' scoped buffers can be significantly faster
 * than similar access operations on globally accessible storage buffers.
 *
 * This node can only be used with a WebGPU backend.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$var$WorkgroupInfoNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    /**
	 * Constructs a new buffer scoped to type scope.
	 *
	 * @param {string} scope - TODO.
	 * @param {string} bufferType - The data type of a 'workgroup' scoped buffer element.
	 * @param {number} [bufferCount=0] - The number of elements in the buffer.
	 */ constructor(scope, bufferType, bufferCount = 0){
        super(bufferType);
        /**
		 * The buffer type.
		 *
		 * @type {string}
		 */ this.bufferType = bufferType;
        /**
		 * The buffer count.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bufferCount = bufferCount;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWorkgroupInfoNode = true;
        /**
		 * The data type of the array buffer.
		 *
		 * @type {string}
		 */ this.elementType = bufferType;
        /**
		 * TODO.
		 *
		 * @type {string}
		 */ this.scope = scope;
        /**
		 * The name of the workgroup scoped buffer.
		 *
		 * @type {string}
		 * @default ''
		 */ this.name = '';
    }
    /**
	 * Sets the name of this node.
	 *
	 * @param {string} name - The name to set.
	 * @return {WorkgroupInfoNode} A reference to this node.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the name/label of this node.
	 *
	 * @deprecated
	 * @param {string} name - The name to set.
	 * @return {WorkgroupInfoNode} A reference to this node.
	 */ label(name) {
        (0, $329ek.warn)('TSL: "label()" has been deprecated. Use "setName()" instead.'); // @deprecated r179
        return this.setName(name);
    }
    /**
	 * Sets the scope of this node.
	 *
	 * @param {string} scope - The scope to set.
	 * @return {WorkgroupInfoNode} A reference to this node.
	 */ setScope(scope) {
        this.scope = scope;
        return this;
    }
    /**
	 * The data type of the array buffer.
	 *
	 * @return {string} The element type.
	 */ getElementType() {
        return this.elementType;
    }
    /**
	 * Overwrites the default implementation since the input type
	 * is inferred from the scope.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return `${this.scope}Array`;
    }
    /**
	 * This method can be used to access elements via an index node.
	 *
	 * @param {IndexNode} indexNode - indexNode.
	 * @return {WorkgroupInfoElementNode} A reference to an element.
	 */ element(indexNode) {
        return new $d89c9137a3d237c2$var$WorkgroupInfoElementNode(this, indexNode);
    }
    generate(builder) {
        const name = this.name !== '' ? this.name : `${this.scope}Array_${this.id}`;
        return builder.getScopedArray(name, this.scope.toLowerCase(), this.bufferType, this.bufferCount);
    }
}
/**
 * TSL function for creating a workgroup info node.
 * Creates a new 'workgroup' scoped array buffer.
 *
 * @tsl
 * @function
 * @param {string} type - The data type of a 'workgroup' scoped buffer element.
 * @param {number} [count=0] - The number of elements in the buffer.
 * @returns {WorkgroupInfoNode}
 */ const $d89c9137a3d237c2$var$workgroupArray = (type, count)=>new $d89c9137a3d237c2$var$WorkgroupInfoNode('Workgroup', type, count);
/**
 * `AtomicFunctionNode` represents any function that can operate on atomic variable types
 * within a shader. In an atomic function, any modification to an atomic variable will
 * occur as an indivisible step with a defined order relative to other modifications.
 * Accordingly, even if multiple atomic functions are modifying an atomic variable at once
 * atomic operations will not interfere with each other.
 *
 * This node can only be used with a WebGPU backend.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$var$AtomicFunctionNode extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'AtomicFunctionNode';
    }
    /**
	 * Constructs a new atomic function node.
	 *
	 * @param {string} method - The signature of the atomic function to construct.
	 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
	 * @param {Node} valueNode - The value that mutates the atomic variable.
	 */ constructor(method, pointerNode, valueNode){
        super('uint');
        /**
		 * The signature of the atomic function to construct.
		 *
		 * @type {string}
		 */ this.method = method;
        /**
		 * An atomic variable or element of an atomic buffer.
		 *
		 * @type {Node}
		 */ this.pointerNode = pointerNode;
        /**
		 * A value that modifies the atomic variable.
		 *
		 * @type {Node}
		 */ this.valueNode = valueNode;
        /**
		 * Creates a list of the parents for this node for detecting if the node needs to return a value.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.parents = true;
    }
    /**
	 * Overwrites the default implementation to return the type of
	 * the pointer node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType(builder) {
        return this.pointerNode.getNodeType(builder);
    }
    /**
	 * Overwritten since the node type is inferred from the input type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ getNodeType(builder) {
        return this.getInputType(builder);
    }
    generate(builder) {
        const properties = builder.getNodeProperties(this);
        const parents = properties.parents;
        const method = this.method;
        const type = this.getNodeType(builder);
        const inputType = this.getInputType(builder);
        const a = this.pointerNode;
        const b = this.valueNode;
        const params = [];
        params.push(`&${a.build(builder, inputType)}`);
        if (b !== null) params.push(b.build(builder, inputType));
        const methodSnippet = `${builder.getMethod(method, type)}( ${params.join(', ')} )`;
        const isVoid = parents ? parents.length === 1 && parents[0].isStackNode === true : false;
        if (isVoid) builder.addLineFlowCode(methodSnippet, this);
        else {
            if (properties.constNode === undefined) properties.constNode = $d89c9137a3d237c2$var$expression(methodSnippet, type).toConst();
            return properties.constNode.build(builder);
        }
    }
}
$d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_LOAD = 'atomicLoad';
$d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_STORE = 'atomicStore';
$d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_ADD = 'atomicAdd';
$d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_SUB = 'atomicSub';
$d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_MAX = 'atomicMax';
$d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_MIN = 'atomicMin';
$d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_AND = 'atomicAnd';
$d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_OR = 'atomicOr';
$d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_XOR = 'atomicXor';
/**
 * TSL function for creating an atomic function node.
 *
 * @tsl
 * @function
 * @param {string} method - The signature of the atomic function to construct.
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$atomicNode = $d89c9137a3d237c2$var$nodeProxy($d89c9137a3d237c2$var$AtomicFunctionNode);
/**
 * TSL function for appending an atomic function call into the programmatic flow of a compute shader.
 *
 * @tsl
 * @function
 * @param {string} method - The signature of the atomic function to construct.
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$atomicFunc = (method, pointerNode, valueNode)=>{
    return $d89c9137a3d237c2$var$atomicNode(method, pointerNode, valueNode).toStack();
};
/**
 * Loads the value stored in the atomic variable.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$atomicLoad = (pointerNode)=>$d89c9137a3d237c2$var$atomicFunc($d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_LOAD, pointerNode, null);
/**
 * Stores a value in the atomic variable.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$atomicStore = (pointerNode, valueNode)=>$d89c9137a3d237c2$var$atomicFunc($d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_STORE, pointerNode, valueNode);
/**
 * Increments the value stored in the atomic variable.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$atomicAdd = (pointerNode, valueNode)=>$d89c9137a3d237c2$var$atomicFunc($d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_ADD, pointerNode, valueNode);
/**
 * Decrements the value stored in the atomic variable.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$atomicSub = (pointerNode, valueNode)=>$d89c9137a3d237c2$var$atomicFunc($d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_SUB, pointerNode, valueNode);
/**
 * Stores in an atomic variable the maximum between its current value and a parameter.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$atomicMax = (pointerNode, valueNode)=>$d89c9137a3d237c2$var$atomicFunc($d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_MAX, pointerNode, valueNode);
/**
 * Stores in an atomic variable the minimum between its current value and a parameter.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$atomicMin = (pointerNode, valueNode)=>$d89c9137a3d237c2$var$atomicFunc($d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_MIN, pointerNode, valueNode);
/**
 * Stores in an atomic variable the bitwise AND of its value with a parameter.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$atomicAnd = (pointerNode, valueNode)=>$d89c9137a3d237c2$var$atomicFunc($d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_AND, pointerNode, valueNode);
/**
 * Stores in an atomic variable the bitwise OR of its value with a parameter.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$atomicOr = (pointerNode, valueNode)=>$d89c9137a3d237c2$var$atomicFunc($d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_OR, pointerNode, valueNode);
/**
 * Stores in an atomic variable the bitwise XOR of its value with a parameter.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $d89c9137a3d237c2$var$atomicXor = (pointerNode, valueNode)=>$d89c9137a3d237c2$var$atomicFunc($d89c9137a3d237c2$var$AtomicFunctionNode.ATOMIC_XOR, pointerNode, valueNode);
/**
 * This class represents a set of built in WGSL shader functions that sync
 * synchronously execute an operation across a subgroup, or 'warp', of compute
 * or fragment shader invocations within a workgroup. Typically, these functions
 * will synchronously execute an operation using data from all active invocations
 * within the subgroup, then broadcast that result to all active invocations. In
 * other graphics APIs, subgroup functions are also referred to as wave intrinsics
 * (DirectX/HLSL) or warp intrinsics (CUDA).
 *
 * @augments TempNode
 */ class $d89c9137a3d237c2$var$SubgroupFunctionNode extends $d89c9137a3d237c2$export$bbad94d2cd32d688 {
    static get type() {
        return 'SubgroupFunctionNode';
    }
    /**
	 * Constructs a new function node.
	 *
	 * @param {string} method - The subgroup/wave intrinsic method to construct.
	 * @param {Node} [aNode=null] - The method's first argument.
	 * @param {Node} [bNode=null] - The method's second argument.
	 */ constructor(method, aNode = null, bNode = null){
        super();
        /**
		 * The subgroup/wave intrinsic method to construct.
		 *
		 * @type {string}
		 */ this.method = method;
        /**
		 * The method's first argument.
		 *
		 * @type {Node}
		 */ this.aNode = aNode;
        /**
		 * The method's second argument.
		 *
		 * @type {Node}
		 */ this.bNode = bNode;
    }
    getInputType(builder) {
        const aType = this.aNode ? this.aNode.getNodeType(builder) : null;
        const bType = this.bNode ? this.bNode.getNodeType(builder) : null;
        const aLen = builder.isMatrix(aType) ? 0 : builder.getTypeLength(aType);
        const bLen = builder.isMatrix(bType) ? 0 : builder.getTypeLength(bType);
        if (aLen > bLen) return aType;
        else return bType;
    }
    getNodeType(builder) {
        const method = this.method;
        if (method === $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_ELECT) return 'bool';
        else if (method === $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_BALLOT) return 'uvec4';
        else return this.getInputType(builder);
    }
    generate(builder, output) {
        const method = this.method;
        const type = this.getNodeType(builder);
        const inputType = this.getInputType(builder);
        const a = this.aNode;
        const b = this.bNode;
        const params = [];
        if (method === $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_BROADCAST || method === $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE || method === $d89c9137a3d237c2$var$SubgroupFunctionNode.QUAD_BROADCAST) {
            const bType = b.getNodeType(builder);
            params.push(a.build(builder, type), b.build(builder, bType === 'float' ? 'int' : type));
        } else if (method === $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE_XOR || method === $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE_DOWN || method === $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE_UP) params.push(a.build(builder, type), b.build(builder, 'uint'));
        else {
            if (a !== null) params.push(a.build(builder, inputType));
            if (b !== null) params.push(b.build(builder, inputType));
        }
        const paramsString = params.length === 0 ? '()' : `( ${params.join(', ')} )`;
        return builder.format(`${builder.getMethod(method, type)}${paramsString}`, type, output);
    }
    serialize(data) {
        super.serialize(data);
        data.method = this.method;
    }
    deserialize(data) {
        super.deserialize(data);
        this.method = data.method;
    }
}
// 0 inputs
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_ELECT = 'subgroupElect';
// 1 input
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_BALLOT = 'subgroupBallot';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_ADD = 'subgroupAdd';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_INCLUSIVE_ADD = 'subgroupInclusiveAdd';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_EXCLUSIVE_AND = 'subgroupExclusiveAdd';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_MUL = 'subgroupMul';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_INCLUSIVE_MUL = 'subgroupInclusiveMul';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_EXCLUSIVE_MUL = 'subgroupExclusiveMul';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_AND = 'subgroupAnd';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_OR = 'subgroupOr';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_XOR = 'subgroupXor';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_MIN = 'subgroupMin';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_MAX = 'subgroupMax';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_ALL = 'subgroupAll';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_ANY = 'subgroupAny';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_BROADCAST_FIRST = 'subgroupBroadcastFirst';
$d89c9137a3d237c2$var$SubgroupFunctionNode.QUAD_SWAP_X = 'quadSwapX';
$d89c9137a3d237c2$var$SubgroupFunctionNode.QUAD_SWAP_Y = 'quadSwapY';
$d89c9137a3d237c2$var$SubgroupFunctionNode.QUAD_SWAP_DIAGONAL = 'quadSwapDiagonal';
// 2 inputs
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_BROADCAST = 'subgroupBroadcast';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE = 'subgroupShuffle';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE_XOR = 'subgroupShuffleXor';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE_UP = 'subgroupShuffleUp';
$d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE_DOWN = 'subgroupShuffleDown';
$d89c9137a3d237c2$var$SubgroupFunctionNode.QUAD_BROADCAST = 'quadBroadcast';
/**
 * Returns true if this invocation has the lowest subgroup_invocation_id
 * among active invocations in the subgroup.
 *
 * @tsl
 * @method
 * @return {bool} The result of the computation.
 */ const $d89c9137a3d237c2$var$subgroupElect = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_ELECT).setParameterLength(0);
/**
 * Returns a set of bitfields where the bit corresponding to subgroup_invocation_id
 * is 1 if pred is true for that active invocation and 0 otherwise.
 *
 * @tsl
 * @method
 * @param {bool} pred - A boolean that sets the bit corresponding to the invocations subgroup invocation id.
 * @return {vec4<u32>}- A bitfield corresponding to the pred value of each subgroup invocation.
 */ const $d89c9137a3d237c2$var$subgroupBallot = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_BALLOT).setParameterLength(1);
/**
 * A reduction that adds e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The accumulated result of the reduction operation.
 */ const $d89c9137a3d237c2$var$subgroupAdd = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_ADD).setParameterLength(1);
/**
 * An inclusive scan returning the sum of e for all active invocations with subgroup_invocation_id less than or equal to this invocation.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the inclusive scan by the current invocation.
 * @return {number} The accumulated result of the inclusive scan operation.
 */ const $d89c9137a3d237c2$var$subgroupInclusiveAdd = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_INCLUSIVE_ADD).setParameterLength(1);
/**
 * An exclusive scan that returns the sum of e for all active invocations with subgroup_invocation_id less than this invocation.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the exclusive scan by the current invocation.
 * @return {number} The accumulated result of the exclusive scan operation.
 */ const $d89c9137a3d237c2$var$subgroupExclusiveAdd = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_EXCLUSIVE_AND).setParameterLength(1);
/**
 * A reduction that multiplies e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The accumulated result of the reduction operation.
 */ const $d89c9137a3d237c2$var$subgroupMul = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_MUL).setParameterLength(1);
/**
 * An inclusive scan returning the product of e for all active invocations with subgroup_invocation_id less than or equal to this invocation.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the inclusive scan by the current invocation.
 * @return {number} The accumulated result of the inclusive scan operation.
 */ const $d89c9137a3d237c2$var$subgroupInclusiveMul = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_INCLUSIVE_MUL).setParameterLength(1);
/**
 * An exclusive scan that returns the product of e for all active invocations with subgroup_invocation_id less than this invocation.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the exclusive scan by the current invocation.
 * @return {number} The accumulated result of the exclusive scan operation.
 */ const $d89c9137a3d237c2$var$subgroupExclusiveMul = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_EXCLUSIVE_MUL).setParameterLength(1);
/**
 * A reduction that performs a bitwise and of e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The result of the reduction operation.
 */ const $d89c9137a3d237c2$var$subgroupAnd = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_AND).setParameterLength(1);
/**
 * A reduction that performs a bitwise or of e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The result of the reduction operation.
 */ const $d89c9137a3d237c2$var$subgroupOr = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_OR).setParameterLength(1);
/**
 * A reduction that performs a bitwise xor of e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The result of the reduction operation.
 */ const $d89c9137a3d237c2$var$subgroupXor = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_XOR).setParameterLength(1);
/**
 * A reduction that performs a min of e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The result of the reduction operation.
 */ const $d89c9137a3d237c2$var$subgroupMin = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_MIN).setParameterLength(1);
/**
 * A reduction that performs a max of e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The result of the reduction operation.
 */ const $d89c9137a3d237c2$var$subgroupMax = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_MAX).setParameterLength(1);
/**
 * Returns true if e is true for all active invocations in the subgroup.
 *
 * @tsl
 * @method
 * @return {bool} The result of the computation.
 */ const $d89c9137a3d237c2$var$subgroupAll = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_ALL).setParameterLength(0);
/**
 * Returns true if e is true for any active invocation in the subgroup
 *
 * @tsl
 * @method
 * @return {bool} The result of the computation.
 */ const $d89c9137a3d237c2$var$subgroupAny = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_ANY).setParameterLength(0);
/**
 * Broadcasts e from the active invocation with the lowest subgroup_invocation_id in the subgroup to all other active invocations.
 *
 * @tsl
 * @method
 * @param {number} e - The value to broadcast from the lowest subgroup invocation.
 * @param {number} id - The subgroup invocation to broadcast from.
 * @return {number} The broadcast value.
 */ const $d89c9137a3d237c2$var$subgroupBroadcastFirst = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_BROADCAST_FIRST).setParameterLength(2);
/**
 * Swaps e between invocations in the quad in the X direction.
 *
 * @tsl
 * @method
 * @param {number} e - The value to swap from the current invocation.
 * @return {number} The value received from the swap operation.
 */ const $d89c9137a3d237c2$var$quadSwapX = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.QUAD_SWAP_X).setParameterLength(1);
/**
 * Swaps e between invocations in the quad in the Y direction.
 *
 * @tsl
 * @method
 * @param {number} e - The value to swap from the current invocation.
 * @return {number} The value received from the swap operation.
 */ const $d89c9137a3d237c2$var$quadSwapY = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.QUAD_SWAP_Y).setParameterLength(1);
/**
 * Swaps e between invocations in the quad diagonally.
 *
 * @tsl
 * @method
 * @param {number} e - The value to swap from the current invocation.
 * @return {number} The value received from the swap operation.
 */ const $d89c9137a3d237c2$var$quadSwapDiagonal = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.QUAD_SWAP_DIAGONAL).setParameterLength(1);
/**
 * Broadcasts e from the invocation whose subgroup_invocation_id matches id, to all active invocations.
 *
 * @tsl
 * @method
 * @param {number} e - The value to broadcast from subgroup invocation 'id'.
 * @param {number} id - The subgroup invocation to broadcast from.
 * @return {number} The broadcast value.
 */ const $d89c9137a3d237c2$var$subgroupBroadcast = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_BROADCAST).setParameterLength(2);
/**
 * Returns v from the active invocation whose subgroup_invocation_id matches id
 *
 * @tsl
 * @method
 * @param {number} v - The value to return from subgroup invocation id^mask.
 * @param {number} id - The subgroup invocation which returns the value v.
 * @return {number} The broadcast value.
 */ const $d89c9137a3d237c2$var$subgroupShuffle = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE).setParameterLength(2);
/**
 * Returns v from the active invocation whose subgroup_invocation_id matches subgroup_invocation_id ^ mask.
 *
 * @tsl
 * @method
 * @param {number} v - The value to return from subgroup invocation id^mask.
 * @param {number} mask - A bitmask that determines the target invocation via a XOR operation.
 * @return {number} The broadcast value.
 */ const $d89c9137a3d237c2$var$subgroupShuffleXor = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE_XOR).setParameterLength(2);
/**
 * Returns v from the active invocation whose subgroup_invocation_id matches subgroup_invocation_id - delta
 *
 * @tsl
 * @method
 * @param {number} v - The value to return from subgroup invocation id^mask.
 * @param {number} delta - A value that offsets the current in.
 * @return {number} The broadcast value.
 */ const $d89c9137a3d237c2$var$subgroupShuffleUp = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE_UP).setParameterLength(2);
/**
 * Returns v from the active invocation whose subgroup_invocation_id matches subgroup_invocation_id + delta
 *
 * @tsl
 * @method
 * @param {number} v - The value to return from subgroup invocation id^mask.
 * @param {number} delta - A value that offsets the current subgroup invocation.
 * @return {number} The broadcast value.
 */ const $d89c9137a3d237c2$var$subgroupShuffleDown = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.SUBGROUP_SHUFFLE_DOWN).setParameterLength(2);
/**
 * Broadcasts e from the quad invocation with id equal to id.
 *
 * @tsl
 * @method
 * @param {number} e - The value to broadcast.
 * @return {number} The broadcast value.
 */ const $d89c9137a3d237c2$var$quadBroadcast = /*@__PURE__*/ $d89c9137a3d237c2$var$nodeProxyIntent($d89c9137a3d237c2$var$SubgroupFunctionNode, $d89c9137a3d237c2$var$SubgroupFunctionNode.QUAD_BROADCAST).setParameterLength(1);
let $d89c9137a3d237c2$var$uniformsLib;
function $d89c9137a3d237c2$var$getLightData(light) {
    $d89c9137a3d237c2$var$uniformsLib = $d89c9137a3d237c2$var$uniformsLib || new WeakMap();
    let uniforms = $d89c9137a3d237c2$var$uniformsLib.get(light);
    if (uniforms === undefined) $d89c9137a3d237c2$var$uniformsLib.set(light, uniforms = {});
    return uniforms;
}
/**
 * TSL function for getting a shadow matrix uniform node for the given light.
 *
 * @tsl
 * @function
 * @param {Light} light -The light source.
 * @returns {UniformNode<mat4>} The shadow matrix uniform node.
 */ function $d89c9137a3d237c2$var$lightShadowMatrix(light) {
    const data = $d89c9137a3d237c2$var$getLightData(light);
    return data.shadowMatrix || (data.shadowMatrix = $d89c9137a3d237c2$var$uniform('mat4').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate((frame)=>{
        // normally, shadow matrices are updated in ShadowNode. However, if the shadow matrix is used outside
        // of shadow rendering (like in ProjectorLightNode), the shadow matrix still requires an update
        if (light.castShadow !== true || frame.renderer.shadowMap.enabled === false) {
            if (light.shadow.camera.coordinateSystem !== frame.camera.coordinateSystem) {
                light.shadow.camera.coordinateSystem = frame.camera.coordinateSystem;
                light.shadow.camera.updateProjectionMatrix();
            }
            light.shadow.updateMatrices(light);
        }
        return light.shadow.matrix;
    }));
}
/**
 * TSL function for getting projected uv coordinates for the given light.
 * Relevant when using maps with spot lights.
 *
 * @tsl
 * @function
 * @param {Light} light -The light source.
 * @param {Node<vec3>} [position=positionWorld] -The position to project.
 * @returns {Node<vec3>} The projected uvs.
 */ function $d89c9137a3d237c2$var$lightProjectionUV(light, position = $d89c9137a3d237c2$var$positionWorld) {
    const spotLightCoord = $d89c9137a3d237c2$var$lightShadowMatrix(light).mul(position);
    const projectionUV = spotLightCoord.xyz.div(spotLightCoord.w);
    return projectionUV;
}
/**
 * TSL function for getting the position in world space for the given light.
 *
 * @tsl
 * @function
 * @param {Light} light -The light source.
 * @returns {UniformNode<vec3>} The light's position in world space.
 */ function $d89c9137a3d237c2$var$lightPosition(light) {
    const data = $d89c9137a3d237c2$var$getLightData(light);
    return data.position || (data.position = $d89c9137a3d237c2$var$uniform(new (0, $329ek.Vector3)()).setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate((_, self1)=>self1.value.setFromMatrixPosition(light.matrixWorld)));
}
/**
 * TSL function for getting the light target position in world space for the given light.
 *
 * @tsl
 * @function
 * @param {Light} light -The light source.
 * @returns {UniformNode<vec3>} The light target position in world space.
 */ function $d89c9137a3d237c2$var$lightTargetPosition(light) {
    const data = $d89c9137a3d237c2$var$getLightData(light);
    return data.targetPosition || (data.targetPosition = $d89c9137a3d237c2$var$uniform(new (0, $329ek.Vector3)()).setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate((_, self1)=>self1.value.setFromMatrixPosition(light.target.matrixWorld)));
}
/**
 * TSL function for getting the position in view space for the given light.
 *
 * @tsl
 * @function
 * @param {Light} light - The light source.
 * @returns {UniformNode<vec3>} The light's position in view space.
 */ function $d89c9137a3d237c2$var$lightViewPosition(light) {
    const data = $d89c9137a3d237c2$var$getLightData(light);
    return data.viewPosition || (data.viewPosition = $d89c9137a3d237c2$var$uniform(new (0, $329ek.Vector3)()).setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(({ camera: camera }, self1)=>{
        self1.value = self1.value || new (0, $329ek.Vector3)();
        self1.value.setFromMatrixPosition(light.matrixWorld);
        self1.value.applyMatrix4(camera.matrixWorldInverse);
    }));
}
/**
 * TSL function for getting the light target direction for the given light.
 *
 * @tsl
 * @function
 * @param {Light} light -The light source.
 * @returns {Node<vec3>} The light's target direction.
 */ const $d89c9137a3d237c2$var$lightTargetDirection = (light)=>$d89c9137a3d237c2$var$cameraViewMatrix.transformDirection($d89c9137a3d237c2$var$lightPosition(light).sub($d89c9137a3d237c2$var$lightTargetPosition(light)));
const $d89c9137a3d237c2$var$sortLights = (lights)=>{
    return lights.sort((a, b)=>a.id - b.id);
};
const $d89c9137a3d237c2$var$getLightNodeById = (id, lightNodes)=>{
    for (const lightNode of lightNodes){
        if (lightNode.isAnalyticLightNode && lightNode.light.id === id) return lightNode;
    }
    return null;
};
const $d89c9137a3d237c2$var$_lightsNodeRef = /*@__PURE__*/ new WeakMap();
const $d89c9137a3d237c2$var$_hashData = [];
/**
 * This node represents the scene's lighting and manages the lighting model's life cycle
 * for the current build 3D object. It is responsible for computing the total outgoing
 * light in a given lighting context.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$577c410712851cc4 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'LightsNode';
    }
    /**
	 * Constructs a new lights node.
	 */ constructor(){
        super('vec3');
        /**
		 * A node representing the total diffuse light.
		 *
		 * @type {Node<vec3>}
		 */ this.totalDiffuseNode = $d89c9137a3d237c2$var$property('vec3', 'totalDiffuse');
        /**
		 * A node representing the total specular light.
		 *
		 * @type {Node<vec3>}
		 */ this.totalSpecularNode = $d89c9137a3d237c2$var$property('vec3', 'totalSpecular');
        /**
		 * A node representing the outgoing light.
		 *
		 * @type {Node<vec3>}
		 */ this.outgoingLightNode = $d89c9137a3d237c2$var$property('vec3', 'outgoingLight');
        /**
		 * An array representing the lights in the scene.
		 *
		 * @private
		 * @type {Array<Light>}
		 */ this._lights = [];
        /**
		 * For each light in the scene, this node will create a
		 * corresponding light node.
		 *
		 * @private
		 * @type {?Array<LightingNode>}
		 * @default null
		 */ this._lightNodes = null;
        /**
		 * A hash for identifying the current light nodes setup.
		 *
		 * @private
		 * @type {?string}
		 * @default null
		 */ this._lightNodesHash = null;
        /**
		 * `LightsNode` sets this property to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
    }
    /**
	 * Overwrites the default {@link Node#customCacheKey} implementation by including
	 * light data into the cache key.
	 *
	 * @return {number} The custom cache key.
	 */ customCacheKey() {
        const lights = this._lights;
        for(let i = 0; i < lights.length; i++){
            const light = lights[i];
            $d89c9137a3d237c2$var$_hashData.push(light.id);
            $d89c9137a3d237c2$var$_hashData.push(light.castShadow ? 1 : 0);
            if (light.isSpotLight === true) {
                const hashMap = light.map !== null ? light.map.id : -1;
                const hashColorNode = light.colorNode ? light.colorNode.getCacheKey() : -1;
                $d89c9137a3d237c2$var$_hashData.push(hashMap, hashColorNode);
            }
        }
        const cacheKey = $d89c9137a3d237c2$var$hashArray($d89c9137a3d237c2$var$_hashData);
        $d89c9137a3d237c2$var$_hashData.length = 0;
        return cacheKey;
    }
    /**
	 * Computes a hash value for identifying the current light nodes setup.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {string} The computed hash.
	 */ getHash(builder) {
        if (this._lightNodesHash === null) {
            if (this._lightNodes === null) this.setupLightsNode(builder);
            const hash = [];
            for (const lightNode of this._lightNodes)hash.push(lightNode.getHash());
            this._lightNodesHash = 'lights-' + hash.join(',');
        }
        return this._lightNodesHash;
    }
    analyze(builder) {
        const properties = builder.getNodeProperties(this);
        for (const node of properties.nodes)node.build(builder);
        properties.outputNode.build(builder);
    }
    /**
	 * Creates lighting nodes for each scene light. This makes it possible to further
	 * process lights in the node system.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 */ setupLightsNode(builder) {
        const lightNodes = [];
        const previousLightNodes = this._lightNodes;
        const lights = $d89c9137a3d237c2$var$sortLights(this._lights);
        const nodeLibrary = builder.renderer.library;
        for (const light of lights)if (light.isNode) lightNodes.push($d89c9137a3d237c2$var$nodeObject(light));
        else {
            let lightNode = null;
            if (previousLightNodes !== null) lightNode = $d89c9137a3d237c2$var$getLightNodeById(light.id, previousLightNodes); // reuse existing light node
            if (lightNode === null) {
                // find the corresponding node type for a given light
                const lightNodeClass = nodeLibrary.getLightNodeClass(light.constructor);
                if (lightNodeClass === null) {
                    (0, $329ek.warn)(`LightsNode.setupNodeLights: Light node not found for ${light.constructor.name}`);
                    continue;
                }
                let lightNode = null;
                if (!$d89c9137a3d237c2$var$_lightsNodeRef.has(light)) {
                    lightNode = new lightNodeClass(light);
                    $d89c9137a3d237c2$var$_lightsNodeRef.set(light, lightNode);
                } else lightNode = $d89c9137a3d237c2$var$_lightsNodeRef.get(light);
                lightNodes.push(lightNode);
            }
        }
        this._lightNodes = lightNodes;
    }
    /**
	 * Sets up a direct light in the lighting model.
	 *
	 * @param {Object} builder - The builder object containing the context and stack.
	 * @param {Object} lightNode - The light node.
	 * @param {Object} lightData - The light object containing color and direction properties.
	 */ setupDirectLight(builder, lightNode, lightData) {
        const { lightingModel: lightingModel, reflectedLight: reflectedLight } = builder.context;
        lightingModel.direct({
            ...lightData,
            lightNode: lightNode,
            reflectedLight: reflectedLight
        }, builder);
    }
    setupDirectRectAreaLight(builder, lightNode, lightData) {
        const { lightingModel: lightingModel, reflectedLight: reflectedLight } = builder.context;
        lightingModel.directRectArea({
            ...lightData,
            lightNode: lightNode,
            reflectedLight: reflectedLight
        }, builder);
    }
    /**
	 * Setups the internal lights by building all respective
	 * light nodes.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @param {Array<LightingNode>} lightNodes - An array of lighting nodes.
	 */ setupLights(builder, lightNodes) {
        for (const lightNode of lightNodes)lightNode.build(builder);
    }
    getLightNodes(builder) {
        if (this._lightNodes === null) this.setupLightsNode(builder);
        return this._lightNodes;
    }
    /**
	 * The implementation makes sure that for each light in the scene
	 * there is a corresponding light node. By building the light nodes
	 * and evaluating the lighting model the outgoing light is computed.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {Node<vec3>} A node representing the outgoing light.
	 */ setup(builder) {
        const currentLightsNode = builder.lightsNode;
        builder.lightsNode = this;
        //
        let outgoingLightNode = this.outgoingLightNode;
        const context = builder.context;
        const lightingModel = context.lightingModel;
        const properties = builder.getNodeProperties(this);
        if (lightingModel) {
            const { totalDiffuseNode: totalDiffuseNode, totalSpecularNode: totalSpecularNode } = this;
            context.outgoingLight = outgoingLightNode;
            const stack = builder.addStack();
            //
            properties.nodes = stack.nodes;
            //
            lightingModel.start(builder);
            //
            const { backdrop: backdrop, backdropAlpha: backdropAlpha } = context;
            const { directDiffuse: directDiffuse, directSpecular: directSpecular, indirectDiffuse: indirectDiffuse, indirectSpecular: indirectSpecular } = context.reflectedLight;
            let totalDiffuse = directDiffuse.add(indirectDiffuse);
            if (backdrop !== null) {
                if (backdropAlpha !== null) totalDiffuse = $d89c9137a3d237c2$var$vec3(backdropAlpha.mix(totalDiffuse, backdrop));
                else totalDiffuse = $d89c9137a3d237c2$var$vec3(backdrop);
            }
            totalDiffuseNode.assign(totalDiffuse);
            totalSpecularNode.assign(directSpecular.add(indirectSpecular));
            outgoingLightNode.assign(totalDiffuseNode.add(totalSpecularNode));
            //
            lightingModel.finish(builder);
            //
            outgoingLightNode = outgoingLightNode.bypass(builder.removeStack());
        } else properties.nodes = [];
        //
        builder.lightsNode = currentLightsNode;
        return outgoingLightNode;
    }
    /**
	 * Configures this node with an array of lights.
	 *
	 * @param {Array<Light>} lights - An array of lights.
	 * @return {LightsNode} A reference to this node.
	 */ setLights(lights) {
        this._lights = lights;
        this._lightNodes = null;
        this._lightNodesHash = null;
        return this;
    }
    /**
	 * Returns an array of the scene's lights.
	 *
	 * @return {Array<Light>} The scene's lights.
	 */ getLights() {
        return this._lights;
    }
    /**
	 * Whether the scene has lights or not.
	 *
	 * @type {boolean}
	 */ get hasLights() {
        return this._lights.length > 0;
    }
}
/**
 * TSL function for creating an instance of `LightsNode` and configuring
 * it with the given array of lights.
 *
 * @tsl
 * @function
 * @param {Array<Light>} lights - An array of lights.
 * @return {LightsNode} The created lights node.
 */ const $d89c9137a3d237c2$var$lights = (lights = [])=>new $d89c9137a3d237c2$export$577c410712851cc4().setLights(lights);
/**
 * Base class for all shadow nodes.
 *
 * Shadow nodes encapsulate shadow related logic and are always coupled to lighting nodes.
 * Lighting nodes might share the same shadow node type or use specific ones depending on
 * their requirements.
 *
 * @augments Node
 */ class $d89c9137a3d237c2$export$71d9cb9897322c99 extends $d89c9137a3d237c2$export$85c928794f8d04d4 {
    static get type() {
        return 'ShadowBaseNode';
    }
    /**
	 * Constructs a new shadow base node.
	 *
	 * @param {Light} light - The shadow casting light.
	 */ constructor(light){
        super();
        /**
		 * The shadow casting light.
		 *
		 * @type {Light}
		 */ this.light = light;
        /**
		 * Overwritten since shadows are updated by default per render.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateBeforeType = $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowBaseNode = true;
    }
    /**
	 * Setups the shadow position node which is by default the predefined TSL node object `shadowPositionWorld`.
	 *
	 * @param {NodeBuilder} object - A configuration object that must at least hold a material reference.
	 */ setupShadowPosition({ context: context, material: material }) {
        // Use assign inside an Fn()
        $d89c9137a3d237c2$var$shadowPositionWorld.assign(material.receivedShadowPositionNode || context.shadowPositionWorld || $d89c9137a3d237c2$var$positionWorld);
    }
}
/**
 * TSL object that represents the vertex position in world space during the shadow pass.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $d89c9137a3d237c2$var$shadowPositionWorld = /*@__PURE__*/ $d89c9137a3d237c2$var$property('vec3', 'shadowPositionWorld');
/**
 * Saves the state of the given renderer and stores it into the given state object.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $d89c9137a3d237c2$var$saveRendererState(renderer, state = {}) {
    state.toneMapping = renderer.toneMapping;
    state.toneMappingExposure = renderer.toneMappingExposure;
    state.outputColorSpace = renderer.outputColorSpace;
    state.renderTarget = renderer.getRenderTarget();
    state.activeCubeFace = renderer.getActiveCubeFace();
    state.activeMipmapLevel = renderer.getActiveMipmapLevel();
    state.renderObjectFunction = renderer.getRenderObjectFunction();
    state.pixelRatio = renderer.getPixelRatio();
    state.mrt = renderer.getMRT();
    state.clearColor = renderer.getClearColor(state.clearColor || new (0, $329ek.Color)());
    state.clearAlpha = renderer.getClearAlpha();
    state.autoClear = renderer.autoClear;
    state.scissorTest = renderer.getScissorTest();
    return state;
}
/**
 * Saves the state of the given renderer and stores it into the given state object.
 * Besides, the function also resets the state of the renderer to its default values.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $d89c9137a3d237c2$var$resetRendererState(renderer, state) {
    state = $d89c9137a3d237c2$var$saveRendererState(renderer, state);
    renderer.setMRT(null);
    renderer.setRenderObjectFunction(null);
    renderer.setClearColor(0x000000, 1);
    renderer.autoClear = true;
    return state;
}
/**
 * Restores the state of the given renderer from the given state object.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Object} state - The state to restore.
 */ function $d89c9137a3d237c2$var$restoreRendererState(renderer, state) {
    renderer.toneMapping = state.toneMapping;
    renderer.toneMappingExposure = state.toneMappingExposure;
    renderer.outputColorSpace = state.outputColorSpace;
    renderer.setRenderTarget(state.renderTarget, state.activeCubeFace, state.activeMipmapLevel);
    renderer.setRenderObjectFunction(state.renderObjectFunction);
    renderer.setPixelRatio(state.pixelRatio);
    renderer.setMRT(state.mrt);
    renderer.setClearColor(state.clearColor, state.clearAlpha);
    renderer.autoClear = state.autoClear;
    renderer.setScissorTest(state.scissorTest);
}
/**
 * Saves the state of the given scene and stores it into the given state object.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Scene} scene - The scene.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $d89c9137a3d237c2$var$saveSceneState(scene, state = {}) {
    state.background = scene.background;
    state.backgroundNode = scene.backgroundNode;
    state.overrideMaterial = scene.overrideMaterial;
    return state;
}
/**
 * Saves the state of the given scene and stores it into the given state object.
 * Besides, the function also resets the state of the scene to its default values.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Scene} scene - The scene.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $d89c9137a3d237c2$var$resetSceneState(scene, state) {
    state = $d89c9137a3d237c2$var$saveSceneState(scene, state);
    scene.background = null;
    scene.backgroundNode = null;
    scene.overrideMaterial = null;
    return state;
}
/**
 * Restores the state of the given scene from the given state object.
 *
 * @private
 * @function
 * @param {Scene} scene - The scene.
 * @param {Object} state - The state to restore.
 */ function $d89c9137a3d237c2$var$restoreSceneState(scene, state) {
    scene.background = state.background;
    scene.backgroundNode = state.backgroundNode;
    scene.overrideMaterial = state.overrideMaterial;
}
/**
 * Saves the state of the given renderer and scene and stores it into the given state object.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Scene} scene - The scene.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $d89c9137a3d237c2$var$saveRendererAndSceneState(renderer, scene, state = {}) {
    state = $d89c9137a3d237c2$var$saveRendererState(renderer, state);
    state = $d89c9137a3d237c2$var$saveSceneState(scene, state);
    return state;
}
/**
 * Saves the state of the given renderer and scene and stores it into the given state object.
 * Besides, the function also resets the state of the renderer and scene to its default values.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Scene} scene - The scene.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $d89c9137a3d237c2$var$resetRendererAndSceneState(renderer, scene, state) {
    state = $d89c9137a3d237c2$var$resetRendererState(renderer, state);
    state = $d89c9137a3d237c2$var$resetSceneState(scene, state);
    return state;
}
/**
 * Restores the state of the given renderer and scene from the given state object.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Scene} scene - The scene.
 * @param {Object} state - The state to restore.
 */ function $d89c9137a3d237c2$var$restoreRendererAndSceneState(renderer, scene, state) {
    $d89c9137a3d237c2$var$restoreRendererState(renderer, state);
    $d89c9137a3d237c2$var$restoreSceneState(scene, state);
}
var $d89c9137a3d237c2$export$921fe00ccd8e59c1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    resetRendererAndSceneState: $d89c9137a3d237c2$var$resetRendererAndSceneState,
    resetRendererState: $d89c9137a3d237c2$var$resetRendererState,
    resetSceneState: $d89c9137a3d237c2$var$resetSceneState,
    restoreRendererAndSceneState: $d89c9137a3d237c2$var$restoreRendererAndSceneState,
    restoreRendererState: $d89c9137a3d237c2$var$restoreRendererState,
    restoreSceneState: $d89c9137a3d237c2$var$restoreSceneState,
    saveRendererAndSceneState: $d89c9137a3d237c2$var$saveRendererAndSceneState,
    saveRendererState: $d89c9137a3d237c2$var$saveRendererState,
    saveSceneState: $d89c9137a3d237c2$var$saveSceneState
});
const $d89c9137a3d237c2$var$shadowMaterialLib = /*@__PURE__*/ new WeakMap();
/**
 * A shadow filtering function performing basic filtering. This is in fact an unfiltered version of the shadow map
 * with a binary `[0,1]` result.
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
 * @param {Node<vec3>} inputs.shadowCoord - The shadow coordinates.
 * @return {Node<float>} The filtering result.
 */ const $d89c9137a3d237c2$var$BasicShadowFilter = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ depthTexture: depthTexture, shadowCoord: shadowCoord, depthLayer: depthLayer })=>{
    let basic = $d89c9137a3d237c2$var$texture(depthTexture, shadowCoord.xy).setName('t_basic');
    if (depthTexture.isArrayTexture) basic = basic.depth(depthLayer);
    return basic.compare(shadowCoord.z);
});
/**
 * A shadow filtering function performing PCF filtering with Vogel disk sampling and IGN.
 *
 * Uses 5 samples distributed via Vogel disk pattern, rotated per-pixel using Interleaved
 * Gradient Noise (IGN) to break up banding artifacts. Combined with hardware PCF (4-tap
 * filtering per sample), this effectively provides 20 filtered taps with better distribution.
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
 * @param {Node<vec3>} inputs.shadowCoord - The shadow coordinates.
 * @param {LightShadow} inputs.shadow - The light shadow.
 * @return {Node<float>} The filtering result.
 */ const $d89c9137a3d237c2$var$PCFShadowFilter = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow, depthLayer: depthLayer })=>{
    const depthCompare = (uv, compare)=>{
        let depth = $d89c9137a3d237c2$var$texture(depthTexture, uv);
        if (depthTexture.isArrayTexture) depth = depth.depth(depthLayer);
        return depth.compare(compare);
    };
    const mapSize = $d89c9137a3d237c2$var$reference('mapSize', 'vec2', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
    const radius = $d89c9137a3d237c2$var$reference('radius', 'float', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
    const texelSize = $d89c9137a3d237c2$var$vec2(1).div(mapSize);
    const radiusScaled = radius.mul(texelSize.x);
    // Use IGN to rotate sampling pattern per pixel (phi = IGN * 2π)
    const phi = $d89c9137a3d237c2$var$interleavedGradientNoise($d89c9137a3d237c2$var$screenCoordinate.xy).mul(6.28318530718);
    // 5 samples using Vogel disk distribution
    return $d89c9137a3d237c2$var$add(depthCompare(shadowCoord.xy.add($d89c9137a3d237c2$var$vogelDiskSample(0, 5, phi).mul(radiusScaled)), shadowCoord.z), depthCompare(shadowCoord.xy.add($d89c9137a3d237c2$var$vogelDiskSample(1, 5, phi).mul(radiusScaled)), shadowCoord.z), depthCompare(shadowCoord.xy.add($d89c9137a3d237c2$var$vogelDiskSample(2, 5, phi).mul(radiusScaled)), shadowCoord.z), depthCompare(shadowCoord.xy.add($d89c9137a3d237c2$var$vogelDiskSample(3, 5, phi).mul(radiusScaled)), shadowCoord.z), depthCompare(shadowCoord.xy.add($d89c9137a3d237c2$var$vogelDiskSample(4, 5, phi).mul(radiusScaled)), shadowCoord.z)).mul(0.2);
});
/**
 * A shadow filtering function performing PCF soft filtering.
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
 * @param {Node<vec3>} inputs.shadowCoord - The shadow coordinates.
 * @param {LightShadow} inputs.shadow - The light shadow.
 * @return {Node<float>} The filtering result.
 */ const $d89c9137a3d237c2$var$PCFSoftShadowFilter = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow, depthLayer: depthLayer })=>{
    const depthCompare = (uv, compare)=>{
        let depth = $d89c9137a3d237c2$var$texture(depthTexture, uv);
        if (depthTexture.isArrayTexture) depth = depth.depth(depthLayer);
        return depth.compare(compare);
    };
    const mapSize = $d89c9137a3d237c2$var$reference('mapSize', 'vec2', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
    const texelSize = $d89c9137a3d237c2$var$vec2(1).div(mapSize);
    const dx = texelSize.x;
    const dy = texelSize.y;
    const uv = shadowCoord.xy;
    const f = $d89c9137a3d237c2$var$fract(uv.mul(mapSize).add(0.5));
    uv.subAssign(f.mul(texelSize));
    return $d89c9137a3d237c2$var$add(depthCompare(uv, shadowCoord.z), depthCompare(uv.add($d89c9137a3d237c2$var$vec2(dx, 0)), shadowCoord.z), depthCompare(uv.add($d89c9137a3d237c2$var$vec2(0, dy)), shadowCoord.z), depthCompare(uv.add(texelSize), shadowCoord.z), $d89c9137a3d237c2$var$mix(depthCompare(uv.add($d89c9137a3d237c2$var$vec2(dx.negate(), 0)), shadowCoord.z), depthCompare(uv.add($d89c9137a3d237c2$var$vec2(dx.mul(2), 0)), shadowCoord.z), f.x), $d89c9137a3d237c2$var$mix(depthCompare(uv.add($d89c9137a3d237c2$var$vec2(dx.negate(), dy)), shadowCoord.z), depthCompare(uv.add($d89c9137a3d237c2$var$vec2(dx.mul(2), dy)), shadowCoord.z), f.x), $d89c9137a3d237c2$var$mix(depthCompare(uv.add($d89c9137a3d237c2$var$vec2(0, dy.negate())), shadowCoord.z), depthCompare(uv.add($d89c9137a3d237c2$var$vec2(0, dy.mul(2))), shadowCoord.z), f.y), $d89c9137a3d237c2$var$mix(depthCompare(uv.add($d89c9137a3d237c2$var$vec2(dx, dy.negate())), shadowCoord.z), depthCompare(uv.add($d89c9137a3d237c2$var$vec2(dx, dy.mul(2))), shadowCoord.z), f.y), $d89c9137a3d237c2$var$mix($d89c9137a3d237c2$var$mix(depthCompare(uv.add($d89c9137a3d237c2$var$vec2(dx.negate(), dy.negate())), shadowCoord.z), depthCompare(uv.add($d89c9137a3d237c2$var$vec2(dx.mul(2), dy.negate())), shadowCoord.z), f.x), $d89c9137a3d237c2$var$mix(depthCompare(uv.add($d89c9137a3d237c2$var$vec2(dx.negate(), dy.mul(2))), shadowCoord.z), depthCompare(uv.add($d89c9137a3d237c2$var$vec2(dx.mul(2), dy.mul(2))), shadowCoord.z), f.x), f.y)).mul(1 / 9);
});
/**
 * A shadow filtering function performing VSM filtering.
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
 * @param {Node<vec3>} inputs.shadowCoord - The shadow coordinates.
 * @return {Node<float>} The filtering result.
 */ const $d89c9137a3d237c2$var$VSMShadowFilter = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ depthTexture: depthTexture, shadowCoord: shadowCoord, depthLayer: depthLayer })=>{
    let distribution = $d89c9137a3d237c2$var$texture(depthTexture).sample(shadowCoord.xy);
    if (depthTexture.isArrayTexture) distribution = distribution.depth(depthLayer);
    distribution = distribution.rg;
    const mean = distribution.x;
    const variance = $d89c9137a3d237c2$var$max$1(0.0000001, distribution.y.mul(distribution.y));
    const hardShadow = $d89c9137a3d237c2$var$step(shadowCoord.z, mean);
    // Early return if fully lit
    $d89c9137a3d237c2$var$If(hardShadow.equal(1.0), ()=>{
        return $d89c9137a3d237c2$var$float(1.0);
    });
    // Distance from mean
    const d = shadowCoord.z.sub(mean);
    // Chebyshev's inequality for upper bound on probability
    let p_max = variance.div(variance.add(d.mul(d)));
    // Reduce light bleeding by remapping [amount, 1] to [0, 1]
    p_max = $d89c9137a3d237c2$var$clamp($d89c9137a3d237c2$var$sub(p_max, 0.3).div(0.65));
    return $d89c9137a3d237c2$var$max$1(hardShadow, p_max);
});
//
const $d89c9137a3d237c2$var$linearDistance = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([position, cameraNear, cameraFar])=>{
    let dist = $d89c9137a3d237c2$var$positionWorld.sub(position).length();
    dist = dist.sub(cameraNear).div(cameraFar.sub(cameraNear));
    dist = dist.saturate(); // clamp to [ 0, 1 ]
    return dist;
});
const $d89c9137a3d237c2$var$linearShadowDistance = (light)=>{
    const camera = light.shadow.camera;
    const nearDistance = $d89c9137a3d237c2$var$reference('near', 'float', camera).setGroup($d89c9137a3d237c2$var$renderGroup);
    const farDistance = $d89c9137a3d237c2$var$reference('far', 'float', camera).setGroup($d89c9137a3d237c2$var$renderGroup);
    const referencePosition = $d89c9137a3d237c2$var$objectPosition(light);
    return $d89c9137a3d237c2$var$linearDistance(referencePosition, nearDistance, farDistance);
};
/**
 * Retrieves or creates a shadow material for the given light source.
 *
 * This function checks if a shadow material already exists for the provided light.
 * If not, it creates a new `NodeMaterial` configured for shadow rendering and stores it
 * in the `shadowMaterialLib` for future use.
 *
 * @tsl
 * @function
 * @param {Light} light - The light source for which the shadow material is needed.
 *                         If the light is a point light, a depth node is calculated
 *                         using the linear shadow distance.
 * @returns {NodeMaterial} The shadow material associated with the given light.
 */ const $d89c9137a3d237c2$var$getShadowMaterial = (light)=>{
    let material = $d89c9137a3d237c2$var$shadowMaterialLib.get(light);
    if (material === undefined) {
        const depthNode = light.isPointLight ? $d89c9137a3d237c2$var$linearShadowDistance(light) : null;
        material = new $d89c9137a3d237c2$export$caaf3b30a544c946();
        material.colorNode = $d89c9137a3d237c2$var$vec4(0, 0, 0, 1);
        material.depthNode = depthNode;
        material.isShadowPassMaterial = true; // Use to avoid other overrideMaterial override material.colorNode unintentionally when using material.shadowNode
        material.name = 'ShadowMaterial';
        material.fog = false;
        $d89c9137a3d237c2$var$shadowMaterialLib.set(light, material);
    }
    return material;
};
/**
 * Disposes the shadow material for the given light source.
 *
 * @param {Light} light - The light source.
 */ const $d89c9137a3d237c2$var$disposeShadowMaterial = (light)=>{
    const material = $d89c9137a3d237c2$var$shadowMaterialLib.get(light);
    if (material !== undefined) {
        material.dispose();
        $d89c9137a3d237c2$var$shadowMaterialLib.delete(light);
    }
};
//
const $d89c9137a3d237c2$var$_shadowRenderObjectLibrary = /*@__PURE__*/ new $d89c9137a3d237c2$var$ChainMap();
const $d89c9137a3d237c2$var$_shadowRenderObjectKeys = [];
/**
 * Creates a function to render shadow objects in a scene.
 *
 * @tsl
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {LightShadow} shadow - The light shadow object containing shadow properties.
 * @param {number} shadowType - The type of shadow map (e.g., BasicShadowMap).
 * @param {boolean} useVelocity - Whether to use velocity data for rendering.
 * @return {shadowRenderObjectFunction} A function that renders shadow objects.
 */ const $d89c9137a3d237c2$var$getShadowRenderObjectFunction = (renderer, shadow, shadowType, useVelocity)=>{
    $d89c9137a3d237c2$var$_shadowRenderObjectKeys[0] = renderer;
    $d89c9137a3d237c2$var$_shadowRenderObjectKeys[1] = shadow;
    let renderObjectFunction = $d89c9137a3d237c2$var$_shadowRenderObjectLibrary.get($d89c9137a3d237c2$var$_shadowRenderObjectKeys);
    if (renderObjectFunction === undefined || renderObjectFunction.shadowType !== shadowType || renderObjectFunction.useVelocity !== useVelocity) {
        renderObjectFunction = (object, scene, _camera, geometry, material, group, ...params)=>{
            if (object.castShadow === true || object.receiveShadow && shadowType === (0, $329ek.VSMShadowMap)) {
                if (useVelocity) $d89c9137a3d237c2$var$getDataFromObject(object).useVelocity = true;
                object.onBeforeShadow(renderer, object, _camera, shadow.camera, geometry, scene.overrideMaterial, group);
                renderer.renderObject(object, scene, _camera, geometry, material, group, ...params);
                object.onAfterShadow(renderer, object, _camera, shadow.camera, geometry, scene.overrideMaterial, group);
            }
        };
        renderObjectFunction.shadowType = shadowType;
        renderObjectFunction.useVelocity = useVelocity;
        $d89c9137a3d237c2$var$_shadowRenderObjectLibrary.set($d89c9137a3d237c2$var$_shadowRenderObjectKeys, renderObjectFunction);
    }
    $d89c9137a3d237c2$var$_shadowRenderObjectKeys[0] = null;
    $d89c9137a3d237c2$var$_shadowRenderObjectKeys[1] = null;
    return renderObjectFunction;
};
/**
 * Represents the shader code for the first VSM render pass.
 *
 * @private
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {Node<float>} inputs.samples - The number of samples
 * @param {Node<float>} inputs.radius - The radius.
 * @param {Node<float>} inputs.size - The size.
 * @param {TextureNode} inputs.shadowPass - A reference to the render target's depth data.
 * @return {Node<vec2>} The VSM output.
 */ const $d89c9137a3d237c2$var$VSMPassVertical = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ samples: samples, radius: radius, size: size, shadowPass: shadowPass, depthLayer: depthLayer })=>{
    const mean = $d89c9137a3d237c2$var$float(0).toVar('meanVertical');
    const squaredMean = $d89c9137a3d237c2$var$float(0).toVar('squareMeanVertical');
    const uvStride = samples.lessThanEqual($d89c9137a3d237c2$var$float(1)).select($d89c9137a3d237c2$var$float(0), $d89c9137a3d237c2$var$float(2).div(samples.sub(1)));
    const uvStart = samples.lessThanEqual($d89c9137a3d237c2$var$float(1)).select($d89c9137a3d237c2$var$float(0), $d89c9137a3d237c2$var$float(-1));
    $d89c9137a3d237c2$var$Loop({
        start: $d89c9137a3d237c2$var$int(0),
        end: $d89c9137a3d237c2$var$int(samples),
        type: 'int',
        condition: '<'
    }, ({ i: i })=>{
        const uvOffset = uvStart.add($d89c9137a3d237c2$var$float(i).mul(uvStride));
        let depth = shadowPass.sample($d89c9137a3d237c2$var$add($d89c9137a3d237c2$var$screenCoordinate.xy, $d89c9137a3d237c2$var$vec2(0, uvOffset).mul(radius)).div(size));
        if (shadowPass.value.isArrayTexture) depth = depth.depth(depthLayer);
        depth = depth.x;
        mean.addAssign(depth);
        squaredMean.addAssign(depth.mul(depth));
    });
    mean.divAssign(samples);
    squaredMean.divAssign(samples);
    const std_dev = $d89c9137a3d237c2$var$sqrt(squaredMean.sub(mean.mul(mean)).max(0));
    return $d89c9137a3d237c2$var$vec2(mean, std_dev);
});
/**
 * Represents the shader code for the second VSM render pass.
 *
 * @private
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {Node<float>} inputs.samples - The number of samples
 * @param {Node<float>} inputs.radius - The radius.
 * @param {Node<float>} inputs.size - The size.
 * @param {TextureNode} inputs.shadowPass - The result of the first VSM render pass.
 * @return {Node<vec2>} The VSM output.
 */ const $d89c9137a3d237c2$var$VSMPassHorizontal = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ samples: samples, radius: radius, size: size, shadowPass: shadowPass, depthLayer: depthLayer })=>{
    const mean = $d89c9137a3d237c2$var$float(0).toVar('meanHorizontal');
    const squaredMean = $d89c9137a3d237c2$var$float(0).toVar('squareMeanHorizontal');
    const uvStride = samples.lessThanEqual($d89c9137a3d237c2$var$float(1)).select($d89c9137a3d237c2$var$float(0), $d89c9137a3d237c2$var$float(2).div(samples.sub(1)));
    const uvStart = samples.lessThanEqual($d89c9137a3d237c2$var$float(1)).select($d89c9137a3d237c2$var$float(0), $d89c9137a3d237c2$var$float(-1));
    $d89c9137a3d237c2$var$Loop({
        start: $d89c9137a3d237c2$var$int(0),
        end: $d89c9137a3d237c2$var$int(samples),
        type: 'int',
        condition: '<'
    }, ({ i: i })=>{
        const uvOffset = uvStart.add($d89c9137a3d237c2$var$float(i).mul(uvStride));
        let distribution = shadowPass.sample($d89c9137a3d237c2$var$add($d89c9137a3d237c2$var$screenCoordinate.xy, $d89c9137a3d237c2$var$vec2(uvOffset, 0).mul(radius)).div(size));
        if (shadowPass.value.isArrayTexture) distribution = distribution.depth(depthLayer);
        mean.addAssign(distribution.x);
        squaredMean.addAssign($d89c9137a3d237c2$var$add(distribution.y.mul(distribution.y), distribution.x.mul(distribution.x)));
    });
    mean.divAssign(samples);
    squaredMean.divAssign(samples);
    const std_dev = $d89c9137a3d237c2$var$sqrt(squaredMean.sub(mean.mul(mean)).max(0));
    return $d89c9137a3d237c2$var$vec2(mean, std_dev);
});
const $d89c9137a3d237c2$var$_shadowFilterLib = [
    $d89c9137a3d237c2$var$BasicShadowFilter,
    $d89c9137a3d237c2$var$PCFShadowFilter,
    $d89c9137a3d237c2$var$PCFSoftShadowFilter,
    $d89c9137a3d237c2$var$VSMShadowFilter
];
//
let $d89c9137a3d237c2$var$_rendererState;
const $d89c9137a3d237c2$var$_quadMesh = /*@__PURE__*/ new $d89c9137a3d237c2$export$266ce19fe399ee9a();
/**
 * Represents the default shadow implementation for lighting nodes.
 *
 * @augments ShadowBaseNode
 */ class $d89c9137a3d237c2$export$d4d1a61f129c85f2 extends $d89c9137a3d237c2$export$71d9cb9897322c99 {
    static get type() {
        return 'ShadowNode';
    }
    /**
	 * Constructs a new shadow node.
	 *
	 * @param {Light} light - The shadow casting light.
	 * @param {?LightShadow} [shadow=null] - An optional light shadow.
	 */ constructor(light, shadow = null){
        super(light);
        /**
		 * The light shadow which defines the properties light's
		 * shadow.
		 *
		 * @type {?LightShadow}
		 * @default null
		 */ this.shadow = shadow || light.shadow;
        /**
		 * A reference to the shadow map which is a render target.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.shadowMap = null;
        /**
		 * Only relevant for VSM shadows. Render target for the
		 * first VSM render pass.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.vsmShadowMapVertical = null;
        /**
		 * Only relevant for VSM shadows. Render target for the
		 * second VSM render pass.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.vsmShadowMapHorizontal = null;
        /**
		 * Only relevant for VSM shadows. Node material which
		 * is used to render the first VSM pass.
		 *
		 * @type {?NodeMaterial}
		 * @default null
		 */ this.vsmMaterialVertical = null;
        /**
		 * Only relevant for VSM shadows. Node material which
		 * is used to render the second VSM pass.
		 *
		 * @type {?NodeMaterial}
		 * @default null
		 */ this.vsmMaterialHorizontal = null;
        /**
		 * A reference to the output node which defines the
		 * final result of this shadow node.
		 *
		 * @type {?Node}
		 * @private
		 * @default null
		 */ this._node = null;
        /**
		 * The current shadow map type of this shadow node.
		 *
		 * @type {?number}
		 * @private
		 * @default null
		 */ this._currentShadowType = null;
        /**
		 * A Weak Map holding the current frame ID per camera. Used
		 * to control the update of shadow maps.
		 *
		 * @type {WeakMap<Camera,number>}
		 * @private
		 */ this._cameraFrameId = new WeakMap();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowNode = true;
        /**
		 * This index can be used when overriding setupRenderTarget with a RenderTarget Array to specify the depth layer.
		 *
		 * @type {number}
		 * @readonly
		 * @default true
		 */ this.depthLayer = 0;
    }
    /**
	 * Setups the shadow filtering.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @param {Object} inputs - A configuration object that defines the shadow filtering.
	 * @param {Function} inputs.filterFn - This function defines the filtering type of the shadow map e.g. PCF.
	 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
	 * @param {Node<vec3>} inputs.shadowCoord - Shadow coordinates which are used to sample from the shadow map.
	 * @param {LightShadow} inputs.shadow - The light shadow.
	 * @return {Node<float>} The result node of the shadow filtering.
	 */ setupShadowFilter(builder, { filterFn: filterFn, depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow, depthLayer: depthLayer }) {
        const frustumTest = shadowCoord.x.greaterThanEqual(0).and(shadowCoord.x.lessThanEqual(1)).and(shadowCoord.y.greaterThanEqual(0)).and(shadowCoord.y.lessThanEqual(1)).and(shadowCoord.z.lessThanEqual(1));
        const shadowNode = filterFn({
            depthTexture: depthTexture,
            shadowCoord: shadowCoord,
            shadow: shadow,
            depthLayer: depthLayer
        });
        return frustumTest.select(shadowNode, $d89c9137a3d237c2$var$float(1));
    }
    /**
	 * Setups the shadow coordinates.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @param {Node<vec3>} shadowPosition - A node representing the shadow position.
	 * @return {Node<vec3>} The shadow coordinates.
	 */ setupShadowCoord(builder, shadowPosition) {
        const { shadow: shadow } = this;
        const { renderer: renderer } = builder;
        const bias = $d89c9137a3d237c2$var$reference('bias', 'float', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
        let shadowCoord = shadowPosition;
        let coordZ;
        if (shadow.camera.isOrthographicCamera || renderer.logarithmicDepthBuffer !== true) {
            shadowCoord = shadowCoord.xyz.div(shadowCoord.w);
            coordZ = shadowCoord.z;
            if (renderer.coordinateSystem === (0, $329ek.WebGPUCoordinateSystem)) coordZ = coordZ.mul(2).sub(1); // WebGPU: Conversion [ 0, 1 ] to [ - 1, 1 ]
        } else {
            const w = shadowCoord.w;
            shadowCoord = shadowCoord.xy.div(w); // <-- Only divide X/Y coords since we don't need Z
            // The normally available "cameraNear" and "cameraFar" nodes cannot be used here because they do not get
            // updated to use the shadow camera. So, we have to declare our own "local" ones here.
            // TODO: How do we get the cameraNear/cameraFar nodes to use the shadow camera so we don't have to declare local ones here?
            const cameraNearLocal = $d89c9137a3d237c2$var$reference('near', 'float', shadow.camera).setGroup($d89c9137a3d237c2$var$renderGroup);
            const cameraFarLocal = $d89c9137a3d237c2$var$reference('far', 'float', shadow.camera).setGroup($d89c9137a3d237c2$var$renderGroup);
            coordZ = $d89c9137a3d237c2$var$viewZToLogarithmicDepth(w.negate(), cameraNearLocal, cameraFarLocal);
        }
        shadowCoord = $d89c9137a3d237c2$var$vec3(shadowCoord.x, shadowCoord.y.oneMinus(), coordZ.add(bias));
        return shadowCoord;
    }
    /**
	 * Returns the shadow filtering function for the given shadow type.
	 *
	 * @param {number} type - The shadow type.
	 * @return {Function} The filtering function.
	 */ getShadowFilterFn(type) {
        return $d89c9137a3d237c2$var$_shadowFilterLib[type];
    }
    setupRenderTarget(shadow, builder) {
        const depthTexture = new (0, $329ek.DepthTexture)(shadow.mapSize.width, shadow.mapSize.height);
        depthTexture.name = 'ShadowDepthTexture';
        depthTexture.compareFunction = (0, $329ek.LessCompare);
        const shadowMap = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height);
        shadowMap.texture.name = 'ShadowMap';
        shadowMap.texture.type = shadow.mapType;
        shadowMap.depthTexture = depthTexture;
        return {
            shadowMap: shadowMap,
            depthTexture: depthTexture
        };
    }
    /**
	 * Setups the shadow output node.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {Node<vec3>} The shadow output node.
	 */ setupShadow(builder) {
        const { renderer: renderer, camera: camera } = builder;
        const { light: light, shadow: shadow } = this;
        const shadowMapType = renderer.shadowMap.type;
        const { depthTexture: depthTexture, shadowMap: shadowMap } = this.setupRenderTarget(shadow, builder);
        shadow.camera.coordinateSystem = camera.coordinateSystem;
        shadow.camera.updateProjectionMatrix();
        // VSM
        if (shadowMapType === (0, $329ek.VSMShadowMap) && shadow.isPointLightShadow !== true) {
            depthTexture.compareFunction = null; // VSM does not use textureSampleCompare()/texture2DCompare()
            if (shadowMap.depth > 1) {
                if (!shadowMap._vsmShadowMapVertical) {
                    shadowMap._vsmShadowMapVertical = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height, {
                        format: (0, $329ek.RGFormat),
                        type: (0, $329ek.HalfFloatType),
                        depth: shadowMap.depth,
                        depthBuffer: false
                    });
                    shadowMap._vsmShadowMapVertical.texture.name = 'VSMVertical';
                }
                this.vsmShadowMapVertical = shadowMap._vsmShadowMapVertical;
                if (!shadowMap._vsmShadowMapHorizontal) {
                    shadowMap._vsmShadowMapHorizontal = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height, {
                        format: (0, $329ek.RGFormat),
                        type: (0, $329ek.HalfFloatType),
                        depth: shadowMap.depth,
                        depthBuffer: false
                    });
                    shadowMap._vsmShadowMapHorizontal.texture.name = 'VSMHorizontal';
                }
                this.vsmShadowMapHorizontal = shadowMap._vsmShadowMapHorizontal;
            } else {
                this.vsmShadowMapVertical = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height, {
                    format: (0, $329ek.RGFormat),
                    type: (0, $329ek.HalfFloatType),
                    depthBuffer: false
                });
                this.vsmShadowMapHorizontal = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height, {
                    format: (0, $329ek.RGFormat),
                    type: (0, $329ek.HalfFloatType),
                    depthBuffer: false
                });
            }
            let shadowPassVertical = $d89c9137a3d237c2$var$texture(depthTexture);
            if (depthTexture.isArrayTexture) shadowPassVertical = shadowPassVertical.depth(this.depthLayer);
            let shadowPassHorizontal = $d89c9137a3d237c2$var$texture(this.vsmShadowMapVertical.texture);
            if (depthTexture.isArrayTexture) shadowPassHorizontal = shadowPassHorizontal.depth(this.depthLayer);
            const samples = $d89c9137a3d237c2$var$reference('blurSamples', 'float', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
            const radius = $d89c9137a3d237c2$var$reference('radius', 'float', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
            const size = $d89c9137a3d237c2$var$reference('mapSize', 'vec2', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
            let material = this.vsmMaterialVertical || (this.vsmMaterialVertical = new $d89c9137a3d237c2$export$caaf3b30a544c946());
            material.fragmentNode = $d89c9137a3d237c2$var$VSMPassVertical({
                samples: samples,
                radius: radius,
                size: size,
                shadowPass: shadowPassVertical,
                depthLayer: this.depthLayer
            }).context(builder.getSharedContext());
            material.name = 'VSMVertical';
            material = this.vsmMaterialHorizontal || (this.vsmMaterialHorizontal = new $d89c9137a3d237c2$export$caaf3b30a544c946());
            material.fragmentNode = $d89c9137a3d237c2$var$VSMPassHorizontal({
                samples: samples,
                radius: radius,
                size: size,
                shadowPass: shadowPassHorizontal,
                depthLayer: this.depthLayer
            }).context(builder.getSharedContext());
            material.name = 'VSMHorizontal';
        }
        //
        const shadowIntensity = $d89c9137a3d237c2$var$reference('intensity', 'float', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
        const normalBias = $d89c9137a3d237c2$var$reference('normalBias', 'float', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
        const shadowPosition = $d89c9137a3d237c2$var$lightShadowMatrix(light).mul($d89c9137a3d237c2$var$shadowPositionWorld.add($d89c9137a3d237c2$var$normalWorld.mul(normalBias)));
        const shadowCoord = this.setupShadowCoord(builder, shadowPosition);
        //
        const filterFn = shadow.filterNode || this.getShadowFilterFn(renderer.shadowMap.type) || null;
        if (filterFn === null) throw new Error('THREE.WebGPURenderer: Shadow map type not supported yet.');
        const shadowDepthTexture = shadowMapType === (0, $329ek.VSMShadowMap) && shadow.isPointLightShadow !== true ? this.vsmShadowMapHorizontal.texture : depthTexture;
        const shadowNode = this.setupShadowFilter(builder, {
            filterFn: filterFn,
            shadowTexture: shadowMap.texture,
            depthTexture: shadowDepthTexture,
            shadowCoord: shadowCoord,
            shadow: shadow,
            depthLayer: this.depthLayer
        });
        let shadowColor;
        if (shadowMap.texture.isCubeTexture) // For cube shadow maps (point lights), use cubeTexture with vec3 coordinates
        shadowColor = $d89c9137a3d237c2$var$cubeTexture(shadowMap.texture, shadowCoord.xyz);
        else {
            shadowColor = $d89c9137a3d237c2$var$texture(shadowMap.texture, shadowCoord);
            if (depthTexture.isArrayTexture) shadowColor = shadowColor.depth(this.depthLayer);
        }
        const shadowOutput = $d89c9137a3d237c2$var$mix(1, shadowNode.rgb.mix(shadowColor, 1), shadowIntensity.mul(shadowColor.a)).toVar();
        this.shadowMap = shadowMap;
        this.shadow.map = shadowMap;
        // Shadow Output + Inspector
        const inspectName = `${this.light.type} Shadow [ ${this.light.name || 'ID: ' + this.light.id} ]`;
        return shadowOutput.toInspector(`${inspectName} / Color`, ()=>{
            if (this.shadowMap.texture.isCubeTexture) return $d89c9137a3d237c2$var$cubeTexture(this.shadowMap.texture);
            return $d89c9137a3d237c2$var$texture(this.shadowMap.texture);
        }).toInspector(`${inspectName} / Depth`, ()=>{
            // TODO: Use linear depth
            if (this.shadowMap.texture.isCubeTexture) return $d89c9137a3d237c2$var$cubeTexture(this.shadowMap.texture).r.oneMinus();
            return $d89c9137a3d237c2$var$textureLoad(this.shadowMap.depthTexture, $d89c9137a3d237c2$var$uv$1().mul($d89c9137a3d237c2$var$textureSize($d89c9137a3d237c2$var$texture(this.shadowMap.depthTexture)))).r.oneMinus();
        });
    }
    /**
	 * The implementation performs the setup of the output node. An output is only
	 * produces if shadow mapping is globally enabled in the renderer.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {ShaderCallNodeInternal} The output node.
	 */ setup(builder) {
        if (builder.renderer.shadowMap.enabled === false) return;
        return $d89c9137a3d237c2$var$Fn(()=>{
            const currentShadowType = builder.renderer.shadowMap.type;
            if (this._currentShadowType !== currentShadowType) {
                this._reset();
                this._node = null;
            }
            let node = this._node;
            this.setupShadowPosition(builder);
            if (node === null) {
                this._node = node = this.setupShadow(builder);
                this._currentShadowType = currentShadowType;
            }
            if (builder.material.shadowNode) (0, $329ek.warn)('NodeMaterial: ".shadowNode" is deprecated. Use ".castShadowNode" instead.');
            if (builder.material.receivedShadowNode) node = builder.material.receivedShadowNode(node);
            return node;
        })();
    }
    /**
	 * Renders the shadow. The logic of this function could be included
	 * into {@link ShadowNode#updateShadow} however more specialized shadow
	 * nodes might require a custom shadow map rendering. By having a
	 * dedicated method, it's easier to overwrite the default behavior.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ renderShadow(frame) {
        const { shadow: shadow, shadowMap: shadowMap, light: light } = this;
        const { renderer: renderer, scene: scene } = frame;
        shadow.updateMatrices(light);
        shadowMap.setSize(shadow.mapSize.width, shadow.mapSize.height, shadowMap.depth);
        const currentSceneName = scene.name;
        scene.name = `Shadow Map [ ${light.name || 'ID: ' + light.id} ]`;
        renderer.render(scene, shadow.camera);
        scene.name = currentSceneName;
    }
    /**
	 * Updates the shadow.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ updateShadow(frame) {
        const { shadowMap: shadowMap, light: light, shadow: shadow } = this;
        const { renderer: renderer, scene: scene, camera: camera } = frame;
        const shadowType = renderer.shadowMap.type;
        const depthVersion = shadowMap.depthTexture.version;
        this._depthVersionCached = depthVersion;
        const _shadowCameraLayer = shadow.camera.layers.mask;
        if ((shadow.camera.layers.mask & 0xFFFFFFFE) === 0) shadow.camera.layers.mask = camera.layers.mask;
        const currentRenderObjectFunction = renderer.getRenderObjectFunction();
        const currentMRT = renderer.getMRT();
        const useVelocity = currentMRT ? currentMRT.has('velocity') : false;
        $d89c9137a3d237c2$var$_rendererState = $d89c9137a3d237c2$var$resetRendererAndSceneState(renderer, scene, $d89c9137a3d237c2$var$_rendererState);
        scene.overrideMaterial = $d89c9137a3d237c2$var$getShadowMaterial(light);
        renderer.setRenderObjectFunction($d89c9137a3d237c2$var$getShadowRenderObjectFunction(renderer, shadow, shadowType, useVelocity));
        renderer.setClearColor(0x000000, 0);
        renderer.setRenderTarget(shadowMap);
        this.renderShadow(frame);
        renderer.setRenderObjectFunction(currentRenderObjectFunction);
        // vsm blur pass
        if (shadowType === (0, $329ek.VSMShadowMap) && shadow.isPointLightShadow !== true) this.vsmPass(renderer);
        shadow.camera.layers.mask = _shadowCameraLayer;
        $d89c9137a3d237c2$var$restoreRendererAndSceneState(renderer, scene, $d89c9137a3d237c2$var$_rendererState);
    }
    /**
	 * For VSM additional render passes are required.
	 *
	 * @param {Renderer} renderer - A reference to the current renderer.
	 */ vsmPass(renderer) {
        const { shadow: shadow } = this;
        const depth = this.shadowMap.depth;
        this.vsmShadowMapVertical.setSize(shadow.mapSize.width, shadow.mapSize.height, depth);
        this.vsmShadowMapHorizontal.setSize(shadow.mapSize.width, shadow.mapSize.height, depth);
        renderer.setRenderTarget(this.vsmShadowMapVertical);
        $d89c9137a3d237c2$var$_quadMesh.material = this.vsmMaterialVertical;
        $d89c9137a3d237c2$var$_quadMesh.render(renderer);
        renderer.setRenderTarget(this.vsmShadowMapHorizontal);
        $d89c9137a3d237c2$var$_quadMesh.material = this.vsmMaterialHorizontal;
        $d89c9137a3d237c2$var$_quadMesh.render(renderer);
    }
    /**
	 * Frees the internal resources of this shadow node.
	 */ dispose() {
        this._reset();
        super.dispose();
    }
    /**
	 * Resets the resouce state of this shadow node.
	 *
	 * @private
	 */ _reset() {
        this._currentShadowType = null;
        $d89c9137a3d237c2$var$disposeShadowMaterial(this.light);
        if (this.shadowMap) {
            this.shadowMap.dispose();
            this.shadowMap = null;
        }
        if (this.vsmShadowMapVertical !== null) {
            this.vsmShadowMapVertical.dispose();
            this.vsmShadowMapVertical = null;
            this.vsmMaterialVertical.dispose();
            this.vsmMaterialVertical = null;
        }
        if (this.vsmShadowMapHorizontal !== null) {
            this.vsmShadowMapHorizontal.dispose();
            this.vsmShadowMapHorizontal = null;
            this.vsmMaterialHorizontal.dispose();
            this.vsmMaterialHorizontal = null;
        }
    }
    /**
	 * The implementation performs the update of the shadow map if necessary.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ updateBefore(frame) {
        const { shadow: shadow } = this;
        let needsUpdate = shadow.needsUpdate || shadow.autoUpdate;
        if (needsUpdate) {
            if (this._cameraFrameId[frame.camera] === frame.frameId) needsUpdate = false;
            this._cameraFrameId[frame.camera] = frame.frameId;
        }
        if (needsUpdate) {
            this.updateShadow(frame);
            if (this.shadowMap.depthTexture.version === this._depthVersionCached) shadow.needsUpdate = false;
        }
    }
}
/**
 * Shadow Render Object Function.
 *
 * @function shadowRenderObjectFunction
 * @param {Object3D} object - The 3D object to render.
 * @param {Scene} scene - The scene containing the object.
 * @param {Camera} _camera - The camera used for rendering.
 * @param {BufferGeometry} geometry - The geometry of the object.
 * @param {Material} material - The material of the object.
 * @param {Group} group - The group the object belongs to.
 * @param {...any} params - Additional parameters for rendering.
 */ /**
 * TSL function for creating an instance of `ShadowNode`.
 *
 * @tsl
 * @function
 * @param {Light} light - The shadow casting light.
 * @param {?LightShadow} [shadow] - The light shadow.
 * @return {ShadowNode} The created shadow node.
 */ const $d89c9137a3d237c2$var$shadow = (light, shadow)=>new $d89c9137a3d237c2$export$d4d1a61f129c85f2(light, shadow);
const $d89c9137a3d237c2$var$_clearColor$1 = /*@__PURE__*/ new (0, $329ek.Color)();
const $d89c9137a3d237c2$var$_projScreenMatrix$1 = /*@__PURE__*/ new (0, $329ek.Matrix4)();
const $d89c9137a3d237c2$var$_lightPositionWorld = /*@__PURE__*/ new (0, $329ek.Vector3)();
const $d89c9137a3d237c2$var$_lookTarget = /*@__PURE__*/ new (0, $329ek.Vector3)();
// Cube map face directions and up vectors for point light shadows
// Face order: +X, -X, +Y, -Y, +Z, -Z
// WebGPU coordinate system - Y faces swapped to match texture sampling convention
const $d89c9137a3d237c2$var$_cubeDirectionsWebGPU = [
    /*@__PURE__*/ new (0, $329ek.Vector3)(1, 0, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(-1, 0, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, 1),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, -1)
];
const $d89c9137a3d237c2$var$_cubeUpsWebGPU = [
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, -1),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, 1),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0)
];
// WebGL coordinate system - standard OpenGL convention
const $d89c9137a3d237c2$var$_cubeDirectionsWebGL = [
    /*@__PURE__*/ new (0, $329ek.Vector3)(1, 0, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(-1, 0, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, 1),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, -1)
];
const $d89c9137a3d237c2$var$_cubeUpsWebGL = [
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, 1),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, -1),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0)
];
const $d89c9137a3d237c2$var$BasicPointShadowFilter = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ depthTexture: depthTexture, bd3D: bd3D, dp: dp })=>{
    return $d89c9137a3d237c2$var$cubeTexture(depthTexture, bd3D).compare(dp);
});
/**
 * A shadow filtering function for point lights using Vogel disk sampling and IGN.
 *
 * Uses 5 samples distributed via Vogel disk pattern in tangent space around the
 * sample direction, rotated per-pixel using Interleaved Gradient Noise (IGN).
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {CubeDepthTexture} inputs.depthTexture - A reference to the shadow cube map.
 * @param {Node<vec3>} inputs.bd3D - The normalized direction from light to fragment.
 * @param {Node<float>} inputs.dp - The depth value to compare against.
 * @param {LightShadow} inputs.shadow - The light shadow.
 * @return {Node<float>} The filtering result.
 */ const $d89c9137a3d237c2$var$PointShadowFilter = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ depthTexture: depthTexture, bd3D: bd3D, dp: dp, shadow: shadow })=>{
    const radius = $d89c9137a3d237c2$var$reference('radius', 'float', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
    const mapSize = $d89c9137a3d237c2$var$reference('mapSize', 'vec2', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
    const texelSize = radius.div(mapSize.x);
    // Build a tangent-space coordinate system for applying offsets
    const absDir = $d89c9137a3d237c2$var$abs(bd3D);
    const tangent = $d89c9137a3d237c2$var$normalize($d89c9137a3d237c2$var$cross(bd3D, absDir.x.greaterThan(absDir.z).select($d89c9137a3d237c2$var$vec3(0, 1, 0), $d89c9137a3d237c2$var$vec3(1, 0, 0))));
    const bitangent = $d89c9137a3d237c2$var$cross(bd3D, tangent);
    // Use IGN to rotate sampling pattern per pixel (phi = IGN * 2π)
    const phi = $d89c9137a3d237c2$var$interleavedGradientNoise($d89c9137a3d237c2$var$screenCoordinate.xy).mul(6.28318530718);
    // 5 samples using Vogel disk distribution in tangent space
    const sample0 = $d89c9137a3d237c2$var$vogelDiskSample(0, 5, phi);
    const sample1 = $d89c9137a3d237c2$var$vogelDiskSample(1, 5, phi);
    const sample2 = $d89c9137a3d237c2$var$vogelDiskSample(2, 5, phi);
    const sample3 = $d89c9137a3d237c2$var$vogelDiskSample(3, 5, phi);
    const sample4 = $d89c9137a3d237c2$var$vogelDiskSample(4, 5, phi);
    return $d89c9137a3d237c2$var$cubeTexture(depthTexture, bd3D.add(tangent.mul(sample0.x).add(bitangent.mul(sample0.y)).mul(texelSize))).compare(dp).add($d89c9137a3d237c2$var$cubeTexture(depthTexture, bd3D.add(tangent.mul(sample1.x).add(bitangent.mul(sample1.y)).mul(texelSize))).compare(dp)).add($d89c9137a3d237c2$var$cubeTexture(depthTexture, bd3D.add(tangent.mul(sample2.x).add(bitangent.mul(sample2.y)).mul(texelSize))).compare(dp)).add($d89c9137a3d237c2$var$cubeTexture(depthTexture, bd3D.add(tangent.mul(sample3.x).add(bitangent.mul(sample3.y)).mul(texelSize))).compare(dp)).add($d89c9137a3d237c2$var$cubeTexture(depthTexture, bd3D.add(tangent.mul(sample4.x).add(bitangent.mul(sample4.y)).mul(texelSize))).compare(dp)).mul(0.2);
});
const $d89c9137a3d237c2$var$pointShadowFilter = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ filterFn: filterFn, depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow })=>{
    // for point lights, the uniform @vShadowCoord is re-purposed to hold
    // the vector from the light to the world-space position of the fragment.
    const lightToPosition = shadowCoord.xyz.toVar();
    const lightToPositionLength = lightToPosition.length();
    const cameraNearLocal = $d89c9137a3d237c2$var$uniform('float').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(()=>shadow.camera.near);
    const cameraFarLocal = $d89c9137a3d237c2$var$uniform('float').setGroup($d89c9137a3d237c2$var$renderGroup).onRenderUpdate(()=>shadow.camera.far);
    const bias = $d89c9137a3d237c2$var$reference('bias', 'float', shadow).setGroup($d89c9137a3d237c2$var$renderGroup);
    const result = $d89c9137a3d237c2$var$float(1.0).toVar();
    $d89c9137a3d237c2$var$If(lightToPositionLength.sub(cameraFarLocal).lessThanEqual(0.0).and(lightToPositionLength.sub(cameraNearLocal).greaterThanEqual(0.0)), ()=>{
        // dp = normalized distance from light to fragment position
        const dp = lightToPositionLength.sub(cameraNearLocal).div(cameraFarLocal.sub(cameraNearLocal)).toVar(); // need to clamp?
        dp.addAssign(bias);
        // bd3D = base direction 3D (direction from light to fragment)
        const bd3D = lightToPosition.normalize();
        // percentage-closer filtering using cube texture sampling
        result.assign(filterFn({
            depthTexture: depthTexture,
            bd3D: bd3D,
            dp: dp,
            shadow: shadow
        }));
    });
    return result;
});
/**
 * Represents the shadow implementation for point light nodes.
 *
 * @augments ShadowNode
 */ class $d89c9137a3d237c2$var$PointShadowNode extends $d89c9137a3d237c2$export$d4d1a61f129c85f2 {
    static get type() {
        return 'PointShadowNode';
    }
    /**
	 * Constructs a new point shadow node.
	 *
	 * @param {PointLight} light - The shadow casting point light.
	 * @param {?PointLightShadow} [shadow=null] - An optional point light shadow.
	 */ constructor(light, shadow = null){
        super(light, shadow);
    }
    /**
	 * Overwrites the default implementation to return point light shadow specific
	 * filtering functions.
	 *
	 * @param {number} type - The shadow type.
	 * @return {Function} The filtering function.
	 */ getShadowFilterFn(type) {
        return type === (0, $329ek.BasicShadowMap) ? $d89c9137a3d237c2$var$BasicPointShadowFilter : $d89c9137a3d237c2$var$PointShadowFilter;
    }
    /**
	 * Overwrites the default implementation so the unaltered shadow position is used.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @param {Node<vec3>} shadowPosition - A node representing the shadow position.
	 * @return {Node<vec3>} The shadow coordinates.
	 */ setupShadowCoord(builder, shadowPosition) {
        return shadowPosition;
    }
    /**
	 * Overwrites the default implementation to only use point light specific
	 * shadow filter functions.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @param {Object} inputs - A configuration object that defines the shadow filtering.
	 * @param {Function} inputs.filterFn - This function defines the filtering type of the shadow map e.g. PCF.
	 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's depth texture.
	 * @param {Node<vec3>} inputs.shadowCoord - Shadow coordinates which are used to sample from the shadow map.
	 * @param {LightShadow} inputs.shadow - The light shadow.
	 * @return {Node<float>} The result node of the shadow filtering.
	 */ setupShadowFilter(builder, { filterFn: filterFn, depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow }) {
        return $d89c9137a3d237c2$var$pointShadowFilter({
            filterFn: filterFn,
            depthTexture: depthTexture,
            shadowCoord: shadowCoord,
            shadow: shadow
        });
    }
    /**
	 * Overwrites the default implementation to create a CubeRenderTarget with CubeDepthTexture.
	 *
	 * @param {LightShadow} shadow - The light shadow object.
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {Object} An object containing the shadow map and depth texture.
	 */ setupRenderTarget(shadow, builder) {
        const depthTexture = new (0, $329ek.CubeDepthTexture)(shadow.mapSize.width);
        depthTexture.name = 'PointShadowDepthTexture';
        depthTexture.compareFunction = (0, $329ek.LessCompare);
        const shadowMap = builder.createCubeRenderTarget(shadow.mapSize.width);
        shadowMap.texture.name = 'PointShadowMap';
        shadowMap.depthTexture = depthTexture;
        return {
            shadowMap: shadowMap,
            depthTexture: depthTexture
        };
    }
    /**
	 * Overwrites the default implementation with point light specific
	 * rendering code.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ renderShadow(frame) {
        const { shadow: shadow, shadowMap: shadowMap, light: light } = this;
        const { renderer: renderer, scene: scene } = frame;
        const camera = shadow.camera;
        const shadowMatrix = shadow.matrix;
        // Select cube directions/ups based on coordinate system
        const isWebGPU = renderer.coordinateSystem === (0, $329ek.WebGPUCoordinateSystem);
        const cubeDirections = isWebGPU ? $d89c9137a3d237c2$var$_cubeDirectionsWebGPU : $d89c9137a3d237c2$var$_cubeDirectionsWebGL;
        const cubeUps = isWebGPU ? $d89c9137a3d237c2$var$_cubeUpsWebGPU : $d89c9137a3d237c2$var$_cubeUpsWebGL;
        shadowMap.setSize(shadow.mapSize.width, shadow.mapSize.width);
        //
        const previousAutoClear = renderer.autoClear;
        const previousClearColor = renderer.getClearColor($d89c9137a3d237c2$var$_clearColor$1);
        const previousClearAlpha = renderer.getClearAlpha();
        renderer.autoClear = false;
        renderer.setClearColor(shadow.clearColor, shadow.clearAlpha);
        // Render each cube face
        for(let face = 0; face < 6; face++){
            // Set render target to the specific cube face
            renderer.setRenderTarget(shadowMap, face);
            renderer.clear();
            // Update shadow camera matrices for this face
            const far = light.distance || camera.far;
            if (far !== camera.far) {
                camera.far = far;
                camera.updateProjectionMatrix();
            }
            $d89c9137a3d237c2$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
            camera.position.copy($d89c9137a3d237c2$var$_lightPositionWorld);
            $d89c9137a3d237c2$var$_lookTarget.copy(camera.position);
            $d89c9137a3d237c2$var$_lookTarget.add(cubeDirections[face]);
            camera.up.copy(cubeUps[face]);
            camera.lookAt($d89c9137a3d237c2$var$_lookTarget);
            camera.updateMatrixWorld();
            shadowMatrix.makeTranslation(-$d89c9137a3d237c2$var$_lightPositionWorld.x, -$d89c9137a3d237c2$var$_lightPositionWorld.y, -$d89c9137a3d237c2$var$_lightPositionWorld.z);
            $d89c9137a3d237c2$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            shadow._frustum.setFromProjectionMatrix($d89c9137a3d237c2$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            //
            const currentSceneName = scene.name;
            scene.name = `Point Light Shadow [ ${light.name || 'ID: ' + light.id} ] - Face ${face + 1}`;
            renderer.render(scene, camera);
            scene.name = currentSceneName;
        }
        //
        renderer.autoClear = previousAutoClear;
        renderer.setClearColor(previousClearColor, previousClearAlpha);
    }
}
/**
 * TSL function for creating an instance of `PointShadowNode`.
 *
 * @tsl
 * @function
 * @param {PointLight} light - The shadow casting point light.
 * @param {?PointLightShadow} [shadow=null] - An optional point light shadow.
 * @return {PointShadowNode} The created point shadow node.
 */ const $d89c9137a3d237c2$var$pointShadow = (light, shadow)=>new $d89c9137a3d237c2$var$PointShadowNode(light, shadow);
/**
 * Base class for analytic light nodes.
 *
 * @augments LightingNode
 */ class $d89c9137a3d237c2$export$126552cbaf08eb8 extends $d89c9137a3d237c2$export$3fce9846d62aac91 {
    static get type() {
        return 'AnalyticLightNode';
    }
    /**
	 * Constructs a new analytic light node.
	 *
	 * @param {?Light} [light=null] - The light source.
	 */ constructor(light = null){
        super();
        /**
		 * The light source.
		 *
		 * @type {?Light}
		 * @default null
		 */ this.light = light;
        /**
		 * The light's color value.
		 *
		 * @type {Color}
		 */ this.color = new (0, $329ek.Color)();
        /**
		 * The light's color node. Points to `colorNode` of the light source, if set. Otherwise
		 * it creates a uniform node based on {@link AnalyticLightNode#color}.
		 *
		 * @type {Node}
		 */ this.colorNode = light && light.colorNode || $d89c9137a3d237c2$var$uniform(this.color).setGroup($d89c9137a3d237c2$var$renderGroup);
        /**
		 * This property is used to retain a reference to the original value of {@link AnalyticLightNode#colorNode}.
		 * The final color node is represented by a different node when using shadows.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.baseColorNode = null;
        /**
		 * Represents the light's shadow.
		 *
		 * @type {?ShadowNode}
   		 * @default null
		 */ this.shadowNode = null;
        /**
		 * Represents the light's shadow color.
		 *
		 * @type {?Node}
   		 * @default null
		 */ this.shadowColorNode = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAnalyticLightNode = true;
        /**
		 * Overwritten since analytic light nodes are updated
		 * once per frame.
		 *
		 * @type {string}
		 * @default 'frame'
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.FRAME;
        if (light && light.shadow) {
            this._shadowDisposeListener = ()=>{
                this.disposeShadow();
            };
            light.addEventListener('dispose', this._shadowDisposeListener);
        }
    }
    dispose() {
        if (this._shadowDisposeListener) this.light.removeEventListener('dispose', this._shadowDisposeListener);
        super.dispose();
    }
    /**
	 * Frees internal resources related to shadows.
	 */ disposeShadow() {
        if (this.shadowNode !== null) {
            this.shadowNode.dispose();
            this.shadowNode = null;
        }
        this.shadowColorNode = null;
        if (this.baseColorNode !== null) {
            this.colorNode = this.baseColorNode;
            this.baseColorNode = null;
        }
    }
    getHash() {
        return this.light.uuid;
    }
    /**
	 * Returns a node representing a direction vector which points from the current
	 * position in view space to the light's position in view space.
	 *
	 * @param {NodeBuilder} builder - The builder object used for setting up the light.
	 * @return {Node<vec3>} The light vector node.
	 */ getLightVector(builder) {
        return $d89c9137a3d237c2$var$lightViewPosition(this.light).sub(builder.context.positionView || $d89c9137a3d237c2$var$positionView);
    }
    /**
	 * Sets up the direct lighting for the analytic light node.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The builder object used for setting up the light.
	 * @return {Object|undefined} The direct light data (color and direction).
	 */ setupDirect() {}
    /**
	 * Sets up the direct rect area lighting for the analytic light node.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The builder object used for setting up the light.
	 * @return {Object|undefined} The direct rect area light data.
	 */ setupDirectRectArea() {}
    /**
	 * Setups the shadow node for this light. The method exists so concrete light classes
	 * can setup different types of shadow nodes.
	 *
	 * @return {ShadowNode} The created shadow node.
	 */ setupShadowNode() {
        return $d89c9137a3d237c2$var$shadow(this.light);
    }
    /**
	 * Setups the shadow for this light. This method is only executed if the light
	 * cast shadows and the current build object receives shadows. It incorporates
	 * shadows into the lighting computation.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupShadow(builder) {
        const { renderer: renderer } = builder;
        if (renderer.shadowMap.enabled === false) return;
        let shadowColorNode = this.shadowColorNode;
        if (shadowColorNode === null) {
            const customShadowNode = this.light.shadow.shadowNode;
            let shadowNode;
            if (customShadowNode !== undefined) shadowNode = $d89c9137a3d237c2$var$nodeObject(customShadowNode);
            else shadowNode = this.setupShadowNode();
            this.shadowNode = shadowNode;
            this.shadowColorNode = shadowColorNode = this.colorNode.mul(shadowNode);
            this.baseColorNode = this.colorNode;
        }
        //
        if (builder.context.getShadow) shadowColorNode = builder.context.getShadow(this, builder);
        this.colorNode = shadowColorNode;
    }
    /**
	 * Unlike most other nodes, lighting nodes do not return a output node in {@link Node#setup}.
	 * The main purpose of lighting nodes is to configure the current {@link LightingModel} and/or
	 * invocate the respective interface methods.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        this.colorNode = this.baseColorNode || this.colorNode;
        if (this.light.castShadow) {
            if (builder.object.receiveShadow) this.setupShadow(builder);
        } else if (this.shadowNode !== null) {
            this.shadowNode.dispose();
            this.shadowNode = null;
            this.shadowColorNode = null;
        }
        const directLightData = this.setupDirect(builder);
        const directRectAreaLightData = this.setupDirectRectArea(builder);
        if (directLightData) builder.lightsNode.setupDirectLight(builder, this, directLightData);
        if (directRectAreaLightData) builder.lightsNode.setupDirectRectAreaLight(builder, this, directRectAreaLightData);
    }
    /**
	 * The update method is used to update light uniforms per frame.
	 * Potentially overwritten in concrete light nodes to update light
	 * specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update() {
        const { light: light } = this;
        this.color.copy(light.color).multiplyScalar(light.intensity);
    }
}
/**
 * Represents a `discard` shader operation in TSL.
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {Node<float>} inputs.lightDistance - The distance of the light's position to the current fragment position.
 * @param {Node<float>} inputs.cutoffDistance - The light's cutoff distance.
 * @param {Node<float>} inputs.decayExponent - The light's decay exponent.
 * @return {Node<float>} The distance falloff.
 */ const $d89c9137a3d237c2$var$getDistanceAttenuation = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(({ lightDistance: lightDistance, cutoffDistance: cutoffDistance, decayExponent: decayExponent })=>{
    // based upon Frostbite 3 Moving to Physically-based Rendering
    // page 32, equation 26: E[window1]
    // https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
    const distanceFalloff = lightDistance.pow(decayExponent).max(0.01).reciprocal();
    return cutoffDistance.greaterThan(0).select(distanceFalloff.mul(lightDistance.div(cutoffDistance).pow4().oneMinus().clamp().pow2()), distanceFalloff);
}); // validated
const $d89c9137a3d237c2$var$directPointLight = ({ color: color, lightVector: lightVector, cutoffDistance: cutoffDistance, decayExponent: decayExponent })=>{
    const lightDirection = lightVector.normalize();
    const lightDistance = lightVector.length();
    const attenuation = $d89c9137a3d237c2$var$getDistanceAttenuation({
        lightDistance: lightDistance,
        cutoffDistance: cutoffDistance,
        decayExponent: decayExponent
    });
    const lightColor = color.mul(attenuation);
    return {
        lightDirection: lightDirection,
        lightColor: lightColor
    };
};
/**
 * Module for representing point lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $d89c9137a3d237c2$export$8613ba691750588b extends $d89c9137a3d237c2$export$126552cbaf08eb8 {
    static get type() {
        return 'PointLightNode';
    }
    /**
	 * Constructs a new point light node.
	 *
	 * @param {?PointLight} [light=null] - The point light source.
	 */ constructor(light = null){
        super(light);
        /**
		 * Uniform node representing the cutoff distance.
		 *
		 * @type {UniformNode<float>}
		 */ this.cutoffDistanceNode = $d89c9137a3d237c2$var$uniform(0).setGroup($d89c9137a3d237c2$var$renderGroup);
        /**
		 * Uniform node representing the decay exponent.
		 *
		 * @type {UniformNode<float>}
		 */ this.decayExponentNode = $d89c9137a3d237c2$var$uniform(2).setGroup($d89c9137a3d237c2$var$renderGroup);
    }
    /**
	 * Overwritten to updated point light specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        const { light: light } = this;
        super.update(frame);
        this.cutoffDistanceNode.value = light.distance;
        this.decayExponentNode.value = light.decay;
    }
    /**
	 * Overwritten to setup point light specific shadow.
	 *
	 * @return {PointShadowNode}
	 */ setupShadowNode() {
        return $d89c9137a3d237c2$var$pointShadow(this.light);
    }
    setupDirect(builder) {
        return $d89c9137a3d237c2$var$directPointLight({
            color: this.colorNode,
            lightVector: this.getLightVector(builder),
            cutoffDistance: this.cutoffDistanceNode,
            decayExponent: this.decayExponentNode
        });
    }
}
/**
 * Creates a 2x2 checkerboard pattern that can be used as procedural texture data.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} coord - The uv coordinates.
 * @return {Node<float>} The result data.
 */ const $d89c9137a3d237c2$var$checker = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([coord = $d89c9137a3d237c2$var$uv$1()])=>{
    const uv = coord.mul(2.0);
    const cx = uv.x.floor();
    const cy = uv.y.floor();
    const result = cx.add(cy).mod(2.0);
    return result.sign();
});
/**
 * Generates a circle based on the uv coordinates.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} coord - The uv to generate the circle.
 * @return {Node<float>} The circle shape.
 */ const $d89c9137a3d237c2$var$shapeCircle = $d89c9137a3d237c2$var$Fn(([coord = $d89c9137a3d237c2$var$uv$1()], { renderer: renderer, material: material })=>{
    const len2 = $d89c9137a3d237c2$var$lengthSq(coord.mul(2).sub(1));
    let alpha;
    if (material.alphaToCoverage && renderer.currentSamples > 0) {
        const dlen = $d89c9137a3d237c2$var$float(len2.fwidth()).toVar();
        alpha = $d89c9137a3d237c2$var$smoothstep(dlen.oneMinus(), dlen.add(1), len2).oneMinus();
    } else alpha = $d89c9137a3d237c2$var$select(len2.greaterThan(1.0), 0, 1);
    return alpha;
});
// Three.js Transpiler
// https://raw.githubusercontent.com/AcademySoftwareFoundation/MaterialX/main/libraries/stdlib/genglsl/lib/mx_noise.glsl
const $d89c9137a3d237c2$var$mx_select = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([b_immutable, t_immutable, f_immutable])=>{
    const f = $d89c9137a3d237c2$var$float(f_immutable).toVar();
    const t = $d89c9137a3d237c2$var$float(t_immutable).toVar();
    const b = $d89c9137a3d237c2$var$bool(b_immutable).toVar();
    return $d89c9137a3d237c2$var$select(b, t, f);
}).setLayout({
    name: 'mx_select',
    type: 'float',
    inputs: [
        {
            name: 'b',
            type: 'bool'
        },
        {
            name: 't',
            type: 'float'
        },
        {
            name: 'f',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_negate_if = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([val_immutable, b_immutable])=>{
    const b = $d89c9137a3d237c2$var$bool(b_immutable).toVar();
    const val = $d89c9137a3d237c2$var$float(val_immutable).toVar();
    return $d89c9137a3d237c2$var$select(b, val.negate(), val);
}).setLayout({
    name: 'mx_negate_if',
    type: 'float',
    inputs: [
        {
            name: 'val',
            type: 'float'
        },
        {
            name: 'b',
            type: 'bool'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_floor = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x_immutable])=>{
    const x = $d89c9137a3d237c2$var$float(x_immutable).toVar();
    return $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$floor(x));
}).setLayout({
    name: 'mx_floor',
    type: 'int',
    inputs: [
        {
            name: 'x',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_floorfrac = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x_immutable, i])=>{
    const x = $d89c9137a3d237c2$var$float(x_immutable).toVar();
    i.assign($d89c9137a3d237c2$var$mx_floor(x));
    return x.sub($d89c9137a3d237c2$var$float(i));
});
const $d89c9137a3d237c2$var$mx_bilerp_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, s_immutable, t_immutable])=>{
    const t = $d89c9137a3d237c2$var$float(t_immutable).toVar();
    const s = $d89c9137a3d237c2$var$float(s_immutable).toVar();
    const v3 = $d89c9137a3d237c2$var$float(v3_immutable).toVar();
    const v2 = $d89c9137a3d237c2$var$float(v2_immutable).toVar();
    const v1 = $d89c9137a3d237c2$var$float(v1_immutable).toVar();
    const v0 = $d89c9137a3d237c2$var$float(v0_immutable).toVar();
    const s1 = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$sub(1.0, s)).toVar();
    return $d89c9137a3d237c2$var$sub(1.0, t).mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))));
}).setLayout({
    name: 'mx_bilerp_0',
    type: 'float',
    inputs: [
        {
            name: 'v0',
            type: 'float'
        },
        {
            name: 'v1',
            type: 'float'
        },
        {
            name: 'v2',
            type: 'float'
        },
        {
            name: 'v3',
            type: 'float'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_bilerp_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, s_immutable, t_immutable])=>{
    const t = $d89c9137a3d237c2$var$float(t_immutable).toVar();
    const s = $d89c9137a3d237c2$var$float(s_immutable).toVar();
    const v3 = $d89c9137a3d237c2$var$vec3(v3_immutable).toVar();
    const v2 = $d89c9137a3d237c2$var$vec3(v2_immutable).toVar();
    const v1 = $d89c9137a3d237c2$var$vec3(v1_immutable).toVar();
    const v0 = $d89c9137a3d237c2$var$vec3(v0_immutable).toVar();
    const s1 = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$sub(1.0, s)).toVar();
    return $d89c9137a3d237c2$var$sub(1.0, t).mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))));
}).setLayout({
    name: 'mx_bilerp_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v0',
            type: 'vec3'
        },
        {
            name: 'v1',
            type: 'vec3'
        },
        {
            name: 'v2',
            type: 'vec3'
        },
        {
            name: 'v3',
            type: 'vec3'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_bilerp = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_bilerp_0,
    $d89c9137a3d237c2$var$mx_bilerp_1
]);
const $d89c9137a3d237c2$var$mx_trilerp_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, v4_immutable, v5_immutable, v6_immutable, v7_immutable, s_immutable, t_immutable, r_immutable])=>{
    const r = $d89c9137a3d237c2$var$float(r_immutable).toVar();
    const t = $d89c9137a3d237c2$var$float(t_immutable).toVar();
    const s = $d89c9137a3d237c2$var$float(s_immutable).toVar();
    const v7 = $d89c9137a3d237c2$var$float(v7_immutable).toVar();
    const v6 = $d89c9137a3d237c2$var$float(v6_immutable).toVar();
    const v5 = $d89c9137a3d237c2$var$float(v5_immutable).toVar();
    const v4 = $d89c9137a3d237c2$var$float(v4_immutable).toVar();
    const v3 = $d89c9137a3d237c2$var$float(v3_immutable).toVar();
    const v2 = $d89c9137a3d237c2$var$float(v2_immutable).toVar();
    const v1 = $d89c9137a3d237c2$var$float(v1_immutable).toVar();
    const v0 = $d89c9137a3d237c2$var$float(v0_immutable).toVar();
    const s1 = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$sub(1.0, s)).toVar();
    const t1 = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$sub(1.0, t)).toVar();
    const r1 = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$sub(1.0, r)).toVar();
    return r1.mul(t1.mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))))).add(r.mul(t1.mul(v4.mul(s1).add(v5.mul(s))).add(t.mul(v6.mul(s1).add(v7.mul(s))))));
}).setLayout({
    name: 'mx_trilerp_0',
    type: 'float',
    inputs: [
        {
            name: 'v0',
            type: 'float'
        },
        {
            name: 'v1',
            type: 'float'
        },
        {
            name: 'v2',
            type: 'float'
        },
        {
            name: 'v3',
            type: 'float'
        },
        {
            name: 'v4',
            type: 'float'
        },
        {
            name: 'v5',
            type: 'float'
        },
        {
            name: 'v6',
            type: 'float'
        },
        {
            name: 'v7',
            type: 'float'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        },
        {
            name: 'r',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_trilerp_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, v4_immutable, v5_immutable, v6_immutable, v7_immutable, s_immutable, t_immutable, r_immutable])=>{
    const r = $d89c9137a3d237c2$var$float(r_immutable).toVar();
    const t = $d89c9137a3d237c2$var$float(t_immutable).toVar();
    const s = $d89c9137a3d237c2$var$float(s_immutable).toVar();
    const v7 = $d89c9137a3d237c2$var$vec3(v7_immutable).toVar();
    const v6 = $d89c9137a3d237c2$var$vec3(v6_immutable).toVar();
    const v5 = $d89c9137a3d237c2$var$vec3(v5_immutable).toVar();
    const v4 = $d89c9137a3d237c2$var$vec3(v4_immutable).toVar();
    const v3 = $d89c9137a3d237c2$var$vec3(v3_immutable).toVar();
    const v2 = $d89c9137a3d237c2$var$vec3(v2_immutable).toVar();
    const v1 = $d89c9137a3d237c2$var$vec3(v1_immutable).toVar();
    const v0 = $d89c9137a3d237c2$var$vec3(v0_immutable).toVar();
    const s1 = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$sub(1.0, s)).toVar();
    const t1 = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$sub(1.0, t)).toVar();
    const r1 = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$sub(1.0, r)).toVar();
    return r1.mul(t1.mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))))).add(r.mul(t1.mul(v4.mul(s1).add(v5.mul(s))).add(t.mul(v6.mul(s1).add(v7.mul(s))))));
}).setLayout({
    name: 'mx_trilerp_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v0',
            type: 'vec3'
        },
        {
            name: 'v1',
            type: 'vec3'
        },
        {
            name: 'v2',
            type: 'vec3'
        },
        {
            name: 'v3',
            type: 'vec3'
        },
        {
            name: 'v4',
            type: 'vec3'
        },
        {
            name: 'v5',
            type: 'vec3'
        },
        {
            name: 'v6',
            type: 'vec3'
        },
        {
            name: 'v7',
            type: 'vec3'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        },
        {
            name: 'r',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_trilerp = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_trilerp_0,
    $d89c9137a3d237c2$var$mx_trilerp_1
]);
const $d89c9137a3d237c2$var$mx_gradient_float_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([hash_immutable, x_immutable, y_immutable])=>{
    const y = $d89c9137a3d237c2$var$float(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$float(x_immutable).toVar();
    const hash = $d89c9137a3d237c2$var$uint(hash_immutable).toVar();
    const h = $d89c9137a3d237c2$var$uint(hash.bitAnd($d89c9137a3d237c2$var$uint(7))).toVar();
    const u = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_select(h.lessThan($d89c9137a3d237c2$var$uint(4)), x, y)).toVar();
    const v = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mul(2.0, $d89c9137a3d237c2$var$mx_select(h.lessThan($d89c9137a3d237c2$var$uint(4)), y, x))).toVar();
    return $d89c9137a3d237c2$var$mx_negate_if(u, $d89c9137a3d237c2$var$bool(h.bitAnd($d89c9137a3d237c2$var$uint(1)))).add($d89c9137a3d237c2$var$mx_negate_if(v, $d89c9137a3d237c2$var$bool(h.bitAnd($d89c9137a3d237c2$var$uint(2)))));
}).setLayout({
    name: 'mx_gradient_float_0',
    type: 'float',
    inputs: [
        {
            name: 'hash',
            type: 'uint'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_gradient_float_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([hash_immutable, x_immutable, y_immutable, z_immutable])=>{
    const z = $d89c9137a3d237c2$var$float(z_immutable).toVar();
    const y = $d89c9137a3d237c2$var$float(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$float(x_immutable).toVar();
    const hash = $d89c9137a3d237c2$var$uint(hash_immutable).toVar();
    const h = $d89c9137a3d237c2$var$uint(hash.bitAnd($d89c9137a3d237c2$var$uint(15))).toVar();
    const u = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_select(h.lessThan($d89c9137a3d237c2$var$uint(8)), x, y)).toVar();
    const v = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_select(h.lessThan($d89c9137a3d237c2$var$uint(4)), y, $d89c9137a3d237c2$var$mx_select(h.equal($d89c9137a3d237c2$var$uint(12)).or(h.equal($d89c9137a3d237c2$var$uint(14))), x, z))).toVar();
    return $d89c9137a3d237c2$var$mx_negate_if(u, $d89c9137a3d237c2$var$bool(h.bitAnd($d89c9137a3d237c2$var$uint(1)))).add($d89c9137a3d237c2$var$mx_negate_if(v, $d89c9137a3d237c2$var$bool(h.bitAnd($d89c9137a3d237c2$var$uint(2)))));
}).setLayout({
    name: 'mx_gradient_float_1',
    type: 'float',
    inputs: [
        {
            name: 'hash',
            type: 'uint'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        },
        {
            name: 'z',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_gradient_float = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_gradient_float_0,
    $d89c9137a3d237c2$var$mx_gradient_float_1
]);
const $d89c9137a3d237c2$var$mx_gradient_vec3_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([hash_immutable, x_immutable, y_immutable])=>{
    const y = $d89c9137a3d237c2$var$float(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$float(x_immutable).toVar();
    const hash = $d89c9137a3d237c2$var$uvec3(hash_immutable).toVar();
    return $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_gradient_float(hash.x, x, y), $d89c9137a3d237c2$var$mx_gradient_float(hash.y, x, y), $d89c9137a3d237c2$var$mx_gradient_float(hash.z, x, y));
}).setLayout({
    name: 'mx_gradient_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'hash',
            type: 'uvec3'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_gradient_vec3_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([hash_immutable, x_immutable, y_immutable, z_immutable])=>{
    const z = $d89c9137a3d237c2$var$float(z_immutable).toVar();
    const y = $d89c9137a3d237c2$var$float(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$float(x_immutable).toVar();
    const hash = $d89c9137a3d237c2$var$uvec3(hash_immutable).toVar();
    return $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_gradient_float(hash.x, x, y, z), $d89c9137a3d237c2$var$mx_gradient_float(hash.y, x, y, z), $d89c9137a3d237c2$var$mx_gradient_float(hash.z, x, y, z));
}).setLayout({
    name: 'mx_gradient_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'hash',
            type: 'uvec3'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        },
        {
            name: 'z',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_gradient_vec3 = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_gradient_vec3_0,
    $d89c9137a3d237c2$var$mx_gradient_vec3_1
]);
const $d89c9137a3d237c2$var$mx_gradient_scale2d_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([v_immutable])=>{
    const v = $d89c9137a3d237c2$var$float(v_immutable).toVar();
    return $d89c9137a3d237c2$var$mul(0.6616, v);
}).setLayout({
    name: 'mx_gradient_scale2d_0',
    type: 'float',
    inputs: [
        {
            name: 'v',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_gradient_scale3d_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([v_immutable])=>{
    const v = $d89c9137a3d237c2$var$float(v_immutable).toVar();
    return $d89c9137a3d237c2$var$mul(0.9820, v);
}).setLayout({
    name: 'mx_gradient_scale3d_0',
    type: 'float',
    inputs: [
        {
            name: 'v',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_gradient_scale2d_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([v_immutable])=>{
    const v = $d89c9137a3d237c2$var$vec3(v_immutable).toVar();
    return $d89c9137a3d237c2$var$mul(0.6616, v);
}).setLayout({
    name: 'mx_gradient_scale2d_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_gradient_scale2d = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_gradient_scale2d_0,
    $d89c9137a3d237c2$var$mx_gradient_scale2d_1
]);
const $d89c9137a3d237c2$var$mx_gradient_scale3d_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([v_immutable])=>{
    const v = $d89c9137a3d237c2$var$vec3(v_immutable).toVar();
    return $d89c9137a3d237c2$var$mul(0.9820, v);
}).setLayout({
    name: 'mx_gradient_scale3d_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_gradient_scale3d = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_gradient_scale3d_0,
    $d89c9137a3d237c2$var$mx_gradient_scale3d_1
]);
const $d89c9137a3d237c2$var$mx_rotl32 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x_immutable, k_immutable])=>{
    const k = $d89c9137a3d237c2$var$int(k_immutable).toVar();
    const x = $d89c9137a3d237c2$var$uint(x_immutable).toVar();
    return x.shiftLeft(k).bitOr(x.shiftRight($d89c9137a3d237c2$var$int(32).sub(k)));
}).setLayout({
    name: 'mx_rotl32',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'uint'
        },
        {
            name: 'k',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_bjmix = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([a, b, c])=>{
    a.subAssign(c);
    a.bitXorAssign($d89c9137a3d237c2$var$mx_rotl32(c, $d89c9137a3d237c2$var$int(4)));
    c.addAssign(b);
    b.subAssign(a);
    b.bitXorAssign($d89c9137a3d237c2$var$mx_rotl32(a, $d89c9137a3d237c2$var$int(6)));
    a.addAssign(c);
    c.subAssign(b);
    c.bitXorAssign($d89c9137a3d237c2$var$mx_rotl32(b, $d89c9137a3d237c2$var$int(8)));
    b.addAssign(a);
    a.subAssign(c);
    a.bitXorAssign($d89c9137a3d237c2$var$mx_rotl32(c, $d89c9137a3d237c2$var$int(16)));
    c.addAssign(b);
    b.subAssign(a);
    b.bitXorAssign($d89c9137a3d237c2$var$mx_rotl32(a, $d89c9137a3d237c2$var$int(19)));
    a.addAssign(c);
    c.subAssign(b);
    c.bitXorAssign($d89c9137a3d237c2$var$mx_rotl32(b, $d89c9137a3d237c2$var$int(4)));
    b.addAssign(a);
});
const $d89c9137a3d237c2$var$mx_bjfinal = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([a_immutable, b_immutable, c_immutable])=>{
    const c = $d89c9137a3d237c2$var$uint(c_immutable).toVar();
    const b = $d89c9137a3d237c2$var$uint(b_immutable).toVar();
    const a = $d89c9137a3d237c2$var$uint(a_immutable).toVar();
    c.bitXorAssign(b);
    c.subAssign($d89c9137a3d237c2$var$mx_rotl32(b, $d89c9137a3d237c2$var$int(14)));
    a.bitXorAssign(c);
    a.subAssign($d89c9137a3d237c2$var$mx_rotl32(c, $d89c9137a3d237c2$var$int(11)));
    b.bitXorAssign(a);
    b.subAssign($d89c9137a3d237c2$var$mx_rotl32(a, $d89c9137a3d237c2$var$int(25)));
    c.bitXorAssign(b);
    c.subAssign($d89c9137a3d237c2$var$mx_rotl32(b, $d89c9137a3d237c2$var$int(16)));
    a.bitXorAssign(c);
    a.subAssign($d89c9137a3d237c2$var$mx_rotl32(c, $d89c9137a3d237c2$var$int(4)));
    b.bitXorAssign(a);
    b.subAssign($d89c9137a3d237c2$var$mx_rotl32(a, $d89c9137a3d237c2$var$int(14)));
    c.bitXorAssign(b);
    c.subAssign($d89c9137a3d237c2$var$mx_rotl32(b, $d89c9137a3d237c2$var$int(24)));
    return c;
}).setLayout({
    name: 'mx_bjfinal',
    type: 'uint',
    inputs: [
        {
            name: 'a',
            type: 'uint'
        },
        {
            name: 'b',
            type: 'uint'
        },
        {
            name: 'c',
            type: 'uint'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_bits_to_01 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([bits_immutable])=>{
    const bits = $d89c9137a3d237c2$var$uint(bits_immutable).toVar();
    return $d89c9137a3d237c2$var$float(bits).div($d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$int(0xffffffff))));
}).setLayout({
    name: 'mx_bits_to_01',
    type: 'float',
    inputs: [
        {
            name: 'bits',
            type: 'uint'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_fade = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([t_immutable])=>{
    const t = $d89c9137a3d237c2$var$float(t_immutable).toVar();
    return t.mul(t).mul(t).mul(t.mul(t.mul(6.0).sub(15.0)).add(10.0));
}).setLayout({
    name: 'mx_fade',
    type: 'float',
    inputs: [
        {
            name: 't',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_hash_int_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x_immutable])=>{
    const x = $d89c9137a3d237c2$var$int(x_immutable).toVar();
    const len = $d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$uint(1)).toVar();
    const seed = $d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$int(0xdeadbeef)).add(len.shiftLeft($d89c9137a3d237c2$var$uint(2))).add($d89c9137a3d237c2$var$uint(13))).toVar();
    return $d89c9137a3d237c2$var$mx_bjfinal(seed.add($d89c9137a3d237c2$var$uint(x)), seed, seed);
}).setLayout({
    name: 'mx_hash_int_0',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_hash_int_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x_immutable, y_immutable])=>{
    const y = $d89c9137a3d237c2$var$int(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$int(x_immutable).toVar();
    const len = $d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$uint(2)).toVar();
    const a = $d89c9137a3d237c2$var$uint().toVar(), b = $d89c9137a3d237c2$var$uint().toVar(), c = $d89c9137a3d237c2$var$uint().toVar();
    a.assign(b.assign(c.assign($d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$int(0xdeadbeef)).add(len.shiftLeft($d89c9137a3d237c2$var$uint(2))).add($d89c9137a3d237c2$var$uint(13)))));
    a.addAssign($d89c9137a3d237c2$var$uint(x));
    b.addAssign($d89c9137a3d237c2$var$uint(y));
    return $d89c9137a3d237c2$var$mx_bjfinal(a, b, c);
}).setLayout({
    name: 'mx_hash_int_1',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_hash_int_2 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x_immutable, y_immutable, z_immutable])=>{
    const z = $d89c9137a3d237c2$var$int(z_immutable).toVar();
    const y = $d89c9137a3d237c2$var$int(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$int(x_immutable).toVar();
    const len = $d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$uint(3)).toVar();
    const a = $d89c9137a3d237c2$var$uint().toVar(), b = $d89c9137a3d237c2$var$uint().toVar(), c = $d89c9137a3d237c2$var$uint().toVar();
    a.assign(b.assign(c.assign($d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$int(0xdeadbeef)).add(len.shiftLeft($d89c9137a3d237c2$var$uint(2))).add($d89c9137a3d237c2$var$uint(13)))));
    a.addAssign($d89c9137a3d237c2$var$uint(x));
    b.addAssign($d89c9137a3d237c2$var$uint(y));
    c.addAssign($d89c9137a3d237c2$var$uint(z));
    return $d89c9137a3d237c2$var$mx_bjfinal(a, b, c);
}).setLayout({
    name: 'mx_hash_int_2',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_hash_int_3 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x_immutable, y_immutable, z_immutable, xx_immutable])=>{
    const xx = $d89c9137a3d237c2$var$int(xx_immutable).toVar();
    const z = $d89c9137a3d237c2$var$int(z_immutable).toVar();
    const y = $d89c9137a3d237c2$var$int(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$int(x_immutable).toVar();
    const len = $d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$uint(4)).toVar();
    const a = $d89c9137a3d237c2$var$uint().toVar(), b = $d89c9137a3d237c2$var$uint().toVar(), c = $d89c9137a3d237c2$var$uint().toVar();
    a.assign(b.assign(c.assign($d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$int(0xdeadbeef)).add(len.shiftLeft($d89c9137a3d237c2$var$uint(2))).add($d89c9137a3d237c2$var$uint(13)))));
    a.addAssign($d89c9137a3d237c2$var$uint(x));
    b.addAssign($d89c9137a3d237c2$var$uint(y));
    c.addAssign($d89c9137a3d237c2$var$uint(z));
    $d89c9137a3d237c2$var$mx_bjmix(a, b, c);
    a.addAssign($d89c9137a3d237c2$var$uint(xx));
    return $d89c9137a3d237c2$var$mx_bjfinal(a, b, c);
}).setLayout({
    name: 'mx_hash_int_3',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        },
        {
            name: 'xx',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_hash_int_4 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x_immutable, y_immutable, z_immutable, xx_immutable, yy_immutable])=>{
    const yy = $d89c9137a3d237c2$var$int(yy_immutable).toVar();
    const xx = $d89c9137a3d237c2$var$int(xx_immutable).toVar();
    const z = $d89c9137a3d237c2$var$int(z_immutable).toVar();
    const y = $d89c9137a3d237c2$var$int(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$int(x_immutable).toVar();
    const len = $d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$uint(5)).toVar();
    const a = $d89c9137a3d237c2$var$uint().toVar(), b = $d89c9137a3d237c2$var$uint().toVar(), c = $d89c9137a3d237c2$var$uint().toVar();
    a.assign(b.assign(c.assign($d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$int(0xdeadbeef)).add(len.shiftLeft($d89c9137a3d237c2$var$uint(2))).add($d89c9137a3d237c2$var$uint(13)))));
    a.addAssign($d89c9137a3d237c2$var$uint(x));
    b.addAssign($d89c9137a3d237c2$var$uint(y));
    c.addAssign($d89c9137a3d237c2$var$uint(z));
    $d89c9137a3d237c2$var$mx_bjmix(a, b, c);
    a.addAssign($d89c9137a3d237c2$var$uint(xx));
    b.addAssign($d89c9137a3d237c2$var$uint(yy));
    return $d89c9137a3d237c2$var$mx_bjfinal(a, b, c);
}).setLayout({
    name: 'mx_hash_int_4',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        },
        {
            name: 'xx',
            type: 'int'
        },
        {
            name: 'yy',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_hash_int = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_hash_int_0,
    $d89c9137a3d237c2$var$mx_hash_int_1,
    $d89c9137a3d237c2$var$mx_hash_int_2,
    $d89c9137a3d237c2$var$mx_hash_int_3,
    $d89c9137a3d237c2$var$mx_hash_int_4
]);
const $d89c9137a3d237c2$var$mx_hash_vec3_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x_immutable, y_immutable])=>{
    const y = $d89c9137a3d237c2$var$int(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$int(x_immutable).toVar();
    const h = $d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$mx_hash_int(x, y)).toVar();
    const result = $d89c9137a3d237c2$var$uvec3().toVar();
    result.x.assign(h.bitAnd($d89c9137a3d237c2$var$int(0xFF)));
    result.y.assign(h.shiftRight($d89c9137a3d237c2$var$int(8)).bitAnd($d89c9137a3d237c2$var$int(0xFF)));
    result.z.assign(h.shiftRight($d89c9137a3d237c2$var$int(16)).bitAnd($d89c9137a3d237c2$var$int(0xFF)));
    return result;
}).setLayout({
    name: 'mx_hash_vec3_0',
    type: 'uvec3',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_hash_vec3_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([x_immutable, y_immutable, z_immutable])=>{
    const z = $d89c9137a3d237c2$var$int(z_immutable).toVar();
    const y = $d89c9137a3d237c2$var$int(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$int(x_immutable).toVar();
    const h = $d89c9137a3d237c2$var$uint($d89c9137a3d237c2$var$mx_hash_int(x, y, z)).toVar();
    const result = $d89c9137a3d237c2$var$uvec3().toVar();
    result.x.assign(h.bitAnd($d89c9137a3d237c2$var$int(0xFF)));
    result.y.assign(h.shiftRight($d89c9137a3d237c2$var$int(8)).bitAnd($d89c9137a3d237c2$var$int(0xFF)));
    result.z.assign(h.shiftRight($d89c9137a3d237c2$var$int(16)).bitAnd($d89c9137a3d237c2$var$int(0xFF)));
    return result;
}).setLayout({
    name: 'mx_hash_vec3_1',
    type: 'uvec3',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_hash_vec3 = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_hash_vec3_0,
    $d89c9137a3d237c2$var$mx_hash_vec3_1
]);
const $d89c9137a3d237c2$var$mx_perlin_noise_float_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$vec2(p_immutable).toVar();
    const X = $d89c9137a3d237c2$var$int().toVar(), Y = $d89c9137a3d237c2$var$int().toVar();
    const fx = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_floorfrac(p.x, X)).toVar();
    const fy = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_floorfrac(p.y, Y)).toVar();
    const u = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_fade(fx)).toVar();
    const v = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_fade(fy)).toVar();
    const result = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_bilerp($d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X, Y), fx, fy), $d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X.add($d89c9137a3d237c2$var$int(1)), Y), fx.sub(1.0), fy), $d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X, Y.add($d89c9137a3d237c2$var$int(1))), fx, fy.sub(1.0)), $d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X.add($d89c9137a3d237c2$var$int(1)), Y.add($d89c9137a3d237c2$var$int(1))), fx.sub(1.0), fy.sub(1.0)), u, v)).toVar();
    return $d89c9137a3d237c2$var$mx_gradient_scale2d(result);
}).setLayout({
    name: 'mx_perlin_noise_float_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_perlin_noise_float_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    const X = $d89c9137a3d237c2$var$int().toVar(), Y = $d89c9137a3d237c2$var$int().toVar(), Z = $d89c9137a3d237c2$var$int().toVar();
    const fx = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_floorfrac(p.x, X)).toVar();
    const fy = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_floorfrac(p.y, Y)).toVar();
    const fz = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_floorfrac(p.z, Z)).toVar();
    const u = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_fade(fx)).toVar();
    const v = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_fade(fy)).toVar();
    const w = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_fade(fz)).toVar();
    const result = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_trilerp($d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X, Y, Z), fx, fy, fz), $d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X.add($d89c9137a3d237c2$var$int(1)), Y, Z), fx.sub(1.0), fy, fz), $d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X, Y.add($d89c9137a3d237c2$var$int(1)), Z), fx, fy.sub(1.0), fz), $d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X.add($d89c9137a3d237c2$var$int(1)), Y.add($d89c9137a3d237c2$var$int(1)), Z), fx.sub(1.0), fy.sub(1.0), fz), $d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X, Y, Z.add($d89c9137a3d237c2$var$int(1))), fx, fy, fz.sub(1.0)), $d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X.add($d89c9137a3d237c2$var$int(1)), Y, Z.add($d89c9137a3d237c2$var$int(1))), fx.sub(1.0), fy, fz.sub(1.0)), $d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X, Y.add($d89c9137a3d237c2$var$int(1)), Z.add($d89c9137a3d237c2$var$int(1))), fx, fy.sub(1.0), fz.sub(1.0)), $d89c9137a3d237c2$var$mx_gradient_float($d89c9137a3d237c2$var$mx_hash_int(X.add($d89c9137a3d237c2$var$int(1)), Y.add($d89c9137a3d237c2$var$int(1)), Z.add($d89c9137a3d237c2$var$int(1))), fx.sub(1.0), fy.sub(1.0), fz.sub(1.0)), u, v, w)).toVar();
    return $d89c9137a3d237c2$var$mx_gradient_scale3d(result);
}).setLayout({
    name: 'mx_perlin_noise_float_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_perlin_noise_float = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_perlin_noise_float_0,
    $d89c9137a3d237c2$var$mx_perlin_noise_float_1
]);
const $d89c9137a3d237c2$var$mx_perlin_noise_vec3_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$vec2(p_immutable).toVar();
    const X = $d89c9137a3d237c2$var$int().toVar(), Y = $d89c9137a3d237c2$var$int().toVar();
    const fx = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_floorfrac(p.x, X)).toVar();
    const fy = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_floorfrac(p.y, Y)).toVar();
    const u = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_fade(fx)).toVar();
    const v = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_fade(fy)).toVar();
    const result = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_bilerp($d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X, Y), fx, fy), $d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X.add($d89c9137a3d237c2$var$int(1)), Y), fx.sub(1.0), fy), $d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X, Y.add($d89c9137a3d237c2$var$int(1))), fx, fy.sub(1.0)), $d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X.add($d89c9137a3d237c2$var$int(1)), Y.add($d89c9137a3d237c2$var$int(1))), fx.sub(1.0), fy.sub(1.0)), u, v)).toVar();
    return $d89c9137a3d237c2$var$mx_gradient_scale2d(result);
}).setLayout({
    name: 'mx_perlin_noise_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_perlin_noise_vec3_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    const X = $d89c9137a3d237c2$var$int().toVar(), Y = $d89c9137a3d237c2$var$int().toVar(), Z = $d89c9137a3d237c2$var$int().toVar();
    const fx = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_floorfrac(p.x, X)).toVar();
    const fy = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_floorfrac(p.y, Y)).toVar();
    const fz = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_floorfrac(p.z, Z)).toVar();
    const u = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_fade(fx)).toVar();
    const v = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_fade(fy)).toVar();
    const w = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_fade(fz)).toVar();
    const result = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_trilerp($d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X, Y, Z), fx, fy, fz), $d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X.add($d89c9137a3d237c2$var$int(1)), Y, Z), fx.sub(1.0), fy, fz), $d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X, Y.add($d89c9137a3d237c2$var$int(1)), Z), fx, fy.sub(1.0), fz), $d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X.add($d89c9137a3d237c2$var$int(1)), Y.add($d89c9137a3d237c2$var$int(1)), Z), fx.sub(1.0), fy.sub(1.0), fz), $d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X, Y, Z.add($d89c9137a3d237c2$var$int(1))), fx, fy, fz.sub(1.0)), $d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X.add($d89c9137a3d237c2$var$int(1)), Y, Z.add($d89c9137a3d237c2$var$int(1))), fx.sub(1.0), fy, fz.sub(1.0)), $d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X, Y.add($d89c9137a3d237c2$var$int(1)), Z.add($d89c9137a3d237c2$var$int(1))), fx, fy.sub(1.0), fz.sub(1.0)), $d89c9137a3d237c2$var$mx_gradient_vec3($d89c9137a3d237c2$var$mx_hash_vec3(X.add($d89c9137a3d237c2$var$int(1)), Y.add($d89c9137a3d237c2$var$int(1)), Z.add($d89c9137a3d237c2$var$int(1))), fx.sub(1.0), fy.sub(1.0), fz.sub(1.0)), u, v, w)).toVar();
    return $d89c9137a3d237c2$var$mx_gradient_scale3d(result);
}).setLayout({
    name: 'mx_perlin_noise_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_perlin_noise_vec3 = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_perlin_noise_vec3_0,
    $d89c9137a3d237c2$var$mx_perlin_noise_vec3_1
]);
const $d89c9137a3d237c2$var$mx_cell_noise_float_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$float(p_immutable).toVar();
    const ix = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p)).toVar();
    return $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix));
}).setLayout({
    name: 'mx_cell_noise_float_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_cell_noise_float_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$vec2(p_immutable).toVar();
    const ix = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.x)).toVar();
    const iy = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.y)).toVar();
    return $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy));
}).setLayout({
    name: 'mx_cell_noise_float_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_cell_noise_float_2 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    const ix = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.x)).toVar();
    const iy = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.y)).toVar();
    const iz = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.z)).toVar();
    return $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy, iz));
}).setLayout({
    name: 'mx_cell_noise_float_2',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_cell_noise_float_3 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$vec4(p_immutable).toVar();
    const ix = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.x)).toVar();
    const iy = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.y)).toVar();
    const iz = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.z)).toVar();
    const iw = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.w)).toVar();
    return $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy, iz, iw));
}).setLayout({
    name: 'mx_cell_noise_float_3',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec4'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_cell_noise_float$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_cell_noise_float_0,
    $d89c9137a3d237c2$var$mx_cell_noise_float_1,
    $d89c9137a3d237c2$var$mx_cell_noise_float_2,
    $d89c9137a3d237c2$var$mx_cell_noise_float_3
]);
const $d89c9137a3d237c2$var$mx_cell_noise_vec3_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$float(p_immutable).toVar();
    const ix = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p)).toVar();
    return $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, $d89c9137a3d237c2$var$int(0))), $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, $d89c9137a3d237c2$var$int(1))), $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, $d89c9137a3d237c2$var$int(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_cell_noise_vec3_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$vec2(p_immutable).toVar();
    const ix = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.x)).toVar();
    const iy = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.y)).toVar();
    return $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy, $d89c9137a3d237c2$var$int(0))), $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy, $d89c9137a3d237c2$var$int(1))), $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy, $d89c9137a3d237c2$var$int(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_cell_noise_vec3_2 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    const ix = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.x)).toVar();
    const iy = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.y)).toVar();
    const iz = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.z)).toVar();
    return $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy, iz, $d89c9137a3d237c2$var$int(0))), $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy, iz, $d89c9137a3d237c2$var$int(1))), $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy, iz, $d89c9137a3d237c2$var$int(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_2',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_cell_noise_vec3_3 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable])=>{
    const p = $d89c9137a3d237c2$var$vec4(p_immutable).toVar();
    const ix = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.x)).toVar();
    const iy = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.y)).toVar();
    const iz = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.z)).toVar();
    const iw = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$mx_floor(p.w)).toVar();
    return $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy, iz, iw, $d89c9137a3d237c2$var$int(0))), $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy, iz, iw, $d89c9137a3d237c2$var$int(1))), $d89c9137a3d237c2$var$mx_bits_to_01($d89c9137a3d237c2$var$mx_hash_int(ix, iy, iz, iw, $d89c9137a3d237c2$var$int(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_3',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec4'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_cell_noise_vec3 = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_cell_noise_vec3_0,
    $d89c9137a3d237c2$var$mx_cell_noise_vec3_1,
    $d89c9137a3d237c2$var$mx_cell_noise_vec3_2,
    $d89c9137a3d237c2$var$mx_cell_noise_vec3_3
]);
const $d89c9137a3d237c2$var$mx_fractal_noise_float$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = $d89c9137a3d237c2$var$float(diminish_immutable).toVar();
    const lacunarity = $d89c9137a3d237c2$var$float(lacunarity_immutable).toVar();
    const octaves = $d89c9137a3d237c2$var$int(octaves_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    const result = $d89c9137a3d237c2$var$float(0.0).toVar();
    const amplitude = $d89c9137a3d237c2$var$float(1.0).toVar();
    $d89c9137a3d237c2$var$Loop(octaves, ()=>{
        result.addAssign(amplitude.mul($d89c9137a3d237c2$var$mx_perlin_noise_float(p)));
        amplitude.mulAssign(diminish);
        p.mulAssign(lacunarity);
    });
    return result;
}).setLayout({
    name: 'mx_fractal_noise_float',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_fractal_noise_vec3$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = $d89c9137a3d237c2$var$float(diminish_immutable).toVar();
    const lacunarity = $d89c9137a3d237c2$var$float(lacunarity_immutable).toVar();
    const octaves = $d89c9137a3d237c2$var$int(octaves_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    const result = $d89c9137a3d237c2$var$vec3(0.0).toVar();
    const amplitude = $d89c9137a3d237c2$var$float(1.0).toVar();
    $d89c9137a3d237c2$var$Loop(octaves, ()=>{
        result.addAssign(amplitude.mul($d89c9137a3d237c2$var$mx_perlin_noise_vec3(p)));
        amplitude.mulAssign(diminish);
        p.mulAssign(lacunarity);
    });
    return result;
}).setLayout({
    name: 'mx_fractal_noise_vec3',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_fractal_noise_vec2$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = $d89c9137a3d237c2$var$float(diminish_immutable).toVar();
    const lacunarity = $d89c9137a3d237c2$var$float(lacunarity_immutable).toVar();
    const octaves = $d89c9137a3d237c2$var$int(octaves_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    return $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$mx_fractal_noise_float$1(p, octaves, lacunarity, diminish), $d89c9137a3d237c2$var$mx_fractal_noise_float$1(p.add($d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$int(19), $d89c9137a3d237c2$var$int(193), $d89c9137a3d237c2$var$int(17))), octaves, lacunarity, diminish));
}).setLayout({
    name: 'mx_fractal_noise_vec2',
    type: 'vec2',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_fractal_noise_vec4$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = $d89c9137a3d237c2$var$float(diminish_immutable).toVar();
    const lacunarity = $d89c9137a3d237c2$var$float(lacunarity_immutable).toVar();
    const octaves = $d89c9137a3d237c2$var$int(octaves_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    const c = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_fractal_noise_vec3$1(p, octaves, lacunarity, diminish)).toVar();
    const f = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_fractal_noise_float$1(p.add($d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$int(19), $d89c9137a3d237c2$var$int(193), $d89c9137a3d237c2$var$int(17))), octaves, lacunarity, diminish)).toVar();
    return $d89c9137a3d237c2$var$vec4(c, f);
}).setLayout({
    name: 'mx_fractal_noise_vec4',
    type: 'vec4',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_worley_distance_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, x_immutable, y_immutable, xoff_immutable, yoff_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $d89c9137a3d237c2$var$int(metric_immutable).toVar();
    const jitter = $d89c9137a3d237c2$var$float(jitter_immutable).toVar();
    const yoff = $d89c9137a3d237c2$var$int(yoff_immutable).toVar();
    const xoff = $d89c9137a3d237c2$var$int(xoff_immutable).toVar();
    const y = $d89c9137a3d237c2$var$int(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$int(x_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec2(p_immutable).toVar();
    const tmp = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_cell_noise_vec3($d89c9137a3d237c2$var$vec2(x.add(xoff), y.add(yoff)))).toVar();
    const off = $d89c9137a3d237c2$var$vec2(tmp.x, tmp.y).toVar();
    off.subAssign(0.5);
    off.mulAssign(jitter);
    off.addAssign(0.5);
    const cellpos = $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$float(x), $d89c9137a3d237c2$var$float(y)).add(off)).toVar();
    const diff = $d89c9137a3d237c2$var$vec2(cellpos.sub(p)).toVar();
    $d89c9137a3d237c2$var$If(metric.equal($d89c9137a3d237c2$var$int(2)), ()=>{
        return $d89c9137a3d237c2$var$abs(diff.x).add($d89c9137a3d237c2$var$abs(diff.y));
    });
    $d89c9137a3d237c2$var$If(metric.equal($d89c9137a3d237c2$var$int(3)), ()=>{
        return $d89c9137a3d237c2$var$max$1($d89c9137a3d237c2$var$abs(diff.x), $d89c9137a3d237c2$var$abs(diff.y));
    });
    return $d89c9137a3d237c2$var$dot(diff, diff);
}).setLayout({
    name: 'mx_worley_distance_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'xoff',
            type: 'int'
        },
        {
            name: 'yoff',
            type: 'int'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_worley_distance_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, x_immutable, y_immutable, z_immutable, xoff_immutable, yoff_immutable, zoff_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $d89c9137a3d237c2$var$int(metric_immutable).toVar();
    const jitter = $d89c9137a3d237c2$var$float(jitter_immutable).toVar();
    const zoff = $d89c9137a3d237c2$var$int(zoff_immutable).toVar();
    const yoff = $d89c9137a3d237c2$var$int(yoff_immutable).toVar();
    const xoff = $d89c9137a3d237c2$var$int(xoff_immutable).toVar();
    const z = $d89c9137a3d237c2$var$int(z_immutable).toVar();
    const y = $d89c9137a3d237c2$var$int(y_immutable).toVar();
    const x = $d89c9137a3d237c2$var$int(x_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    const off = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_cell_noise_vec3($d89c9137a3d237c2$var$vec3(x.add(xoff), y.add(yoff), z.add(zoff)))).toVar();
    off.subAssign(0.5);
    off.mulAssign(jitter);
    off.addAssign(0.5);
    const cellpos = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$float(x), $d89c9137a3d237c2$var$float(y), $d89c9137a3d237c2$var$float(z)).add(off)).toVar();
    const diff = $d89c9137a3d237c2$var$vec3(cellpos.sub(p)).toVar();
    $d89c9137a3d237c2$var$If(metric.equal($d89c9137a3d237c2$var$int(2)), ()=>{
        return $d89c9137a3d237c2$var$abs(diff.x).add($d89c9137a3d237c2$var$abs(diff.y)).add($d89c9137a3d237c2$var$abs(diff.z));
    });
    $d89c9137a3d237c2$var$If(metric.equal($d89c9137a3d237c2$var$int(3)), ()=>{
        return $d89c9137a3d237c2$var$max$1($d89c9137a3d237c2$var$abs(diff.x), $d89c9137a3d237c2$var$abs(diff.y), $d89c9137a3d237c2$var$abs(diff.z));
    });
    return $d89c9137a3d237c2$var$dot(diff, diff);
}).setLayout({
    name: 'mx_worley_distance_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        },
        {
            name: 'xoff',
            type: 'int'
        },
        {
            name: 'yoff',
            type: 'int'
        },
        {
            name: 'zoff',
            type: 'int'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_worley_distance = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_worley_distance_0,
    $d89c9137a3d237c2$var$mx_worley_distance_1
]);
const $d89c9137a3d237c2$var$mx_worley_noise_float_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $d89c9137a3d237c2$var$int(metric_immutable).toVar();
    const jitter = $d89c9137a3d237c2$var$float(jitter_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec2(p_immutable).toVar();
    const X = $d89c9137a3d237c2$var$int().toVar(), Y = $d89c9137a3d237c2$var$int().toVar();
    const localpos = $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$mx_floorfrac(p.x, X), $d89c9137a3d237c2$var$mx_floorfrac(p.y, Y)).toVar();
    const sqdist = $d89c9137a3d237c2$var$float(1e6).toVar();
    $d89c9137a3d237c2$var$Loop({
        start: -1,
        end: $d89c9137a3d237c2$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $d89c9137a3d237c2$var$Loop({
            start: -1,
            end: $d89c9137a3d237c2$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            const dist = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_worley_distance(localpos, x, y, X, Y, jitter, metric)).toVar();
            sqdist.assign($d89c9137a3d237c2$var$min$1(sqdist, dist));
        });
    });
    $d89c9137a3d237c2$var$If(metric.equal($d89c9137a3d237c2$var$int(0)), ()=>{
        sqdist.assign($d89c9137a3d237c2$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_float_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_worley_noise_vec2_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $d89c9137a3d237c2$var$int(metric_immutable).toVar();
    const jitter = $d89c9137a3d237c2$var$float(jitter_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec2(p_immutable).toVar();
    const X = $d89c9137a3d237c2$var$int().toVar(), Y = $d89c9137a3d237c2$var$int().toVar();
    const localpos = $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$mx_floorfrac(p.x, X), $d89c9137a3d237c2$var$mx_floorfrac(p.y, Y)).toVar();
    const sqdist = $d89c9137a3d237c2$var$vec2(1e6, 1e6).toVar();
    $d89c9137a3d237c2$var$Loop({
        start: -1,
        end: $d89c9137a3d237c2$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $d89c9137a3d237c2$var$Loop({
            start: -1,
            end: $d89c9137a3d237c2$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            const dist = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_worley_distance(localpos, x, y, X, Y, jitter, metric)).toVar();
            $d89c9137a3d237c2$var$If(dist.lessThan(sqdist.x), ()=>{
                sqdist.y.assign(sqdist.x);
                sqdist.x.assign(dist);
            }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                sqdist.y.assign(dist);
            });
        });
    });
    $d89c9137a3d237c2$var$If(metric.equal($d89c9137a3d237c2$var$int(0)), ()=>{
        sqdist.assign($d89c9137a3d237c2$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec2_0',
    type: 'vec2',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_worley_noise_vec3_0 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $d89c9137a3d237c2$var$int(metric_immutable).toVar();
    const jitter = $d89c9137a3d237c2$var$float(jitter_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec2(p_immutable).toVar();
    const X = $d89c9137a3d237c2$var$int().toVar(), Y = $d89c9137a3d237c2$var$int().toVar();
    const localpos = $d89c9137a3d237c2$var$vec2($d89c9137a3d237c2$var$mx_floorfrac(p.x, X), $d89c9137a3d237c2$var$mx_floorfrac(p.y, Y)).toVar();
    const sqdist = $d89c9137a3d237c2$var$vec3(1e6, 1e6, 1e6).toVar();
    $d89c9137a3d237c2$var$Loop({
        start: -1,
        end: $d89c9137a3d237c2$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $d89c9137a3d237c2$var$Loop({
            start: -1,
            end: $d89c9137a3d237c2$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            const dist = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_worley_distance(localpos, x, y, X, Y, jitter, metric)).toVar();
            $d89c9137a3d237c2$var$If(dist.lessThan(sqdist.x), ()=>{
                sqdist.z.assign(sqdist.y);
                sqdist.y.assign(sqdist.x);
                sqdist.x.assign(dist);
            }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                sqdist.z.assign(sqdist.y);
                sqdist.y.assign(dist);
            }).ElseIf(dist.lessThan(sqdist.z), ()=>{
                sqdist.z.assign(dist);
            });
        });
    });
    $d89c9137a3d237c2$var$If(metric.equal($d89c9137a3d237c2$var$int(0)), ()=>{
        sqdist.assign($d89c9137a3d237c2$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_worley_noise_float_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $d89c9137a3d237c2$var$int(metric_immutable).toVar();
    const jitter = $d89c9137a3d237c2$var$float(jitter_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    const X = $d89c9137a3d237c2$var$int().toVar(), Y = $d89c9137a3d237c2$var$int().toVar(), Z = $d89c9137a3d237c2$var$int().toVar();
    const localpos = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_floorfrac(p.x, X), $d89c9137a3d237c2$var$mx_floorfrac(p.y, Y), $d89c9137a3d237c2$var$mx_floorfrac(p.z, Z)).toVar();
    const sqdist = $d89c9137a3d237c2$var$float(1e6).toVar();
    $d89c9137a3d237c2$var$Loop({
        start: -1,
        end: $d89c9137a3d237c2$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $d89c9137a3d237c2$var$Loop({
            start: -1,
            end: $d89c9137a3d237c2$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            $d89c9137a3d237c2$var$Loop({
                start: -1,
                end: $d89c9137a3d237c2$var$int(1),
                name: 'z',
                condition: '<='
            }, ({ z: z })=>{
                const dist = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_worley_distance(localpos, x, y, z, X, Y, Z, jitter, metric)).toVar();
                sqdist.assign($d89c9137a3d237c2$var$min$1(sqdist, dist));
            });
        });
    });
    $d89c9137a3d237c2$var$If(metric.equal($d89c9137a3d237c2$var$int(0)), ()=>{
        sqdist.assign($d89c9137a3d237c2$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_float_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_worley_noise_float$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_worley_noise_float_0,
    $d89c9137a3d237c2$var$mx_worley_noise_float_1
]);
const $d89c9137a3d237c2$var$mx_worley_noise_vec2_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $d89c9137a3d237c2$var$int(metric_immutable).toVar();
    const jitter = $d89c9137a3d237c2$var$float(jitter_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    const X = $d89c9137a3d237c2$var$int().toVar(), Y = $d89c9137a3d237c2$var$int().toVar(), Z = $d89c9137a3d237c2$var$int().toVar();
    const localpos = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_floorfrac(p.x, X), $d89c9137a3d237c2$var$mx_floorfrac(p.y, Y), $d89c9137a3d237c2$var$mx_floorfrac(p.z, Z)).toVar();
    const sqdist = $d89c9137a3d237c2$var$vec2(1e6, 1e6).toVar();
    $d89c9137a3d237c2$var$Loop({
        start: -1,
        end: $d89c9137a3d237c2$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $d89c9137a3d237c2$var$Loop({
            start: -1,
            end: $d89c9137a3d237c2$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            $d89c9137a3d237c2$var$Loop({
                start: -1,
                end: $d89c9137a3d237c2$var$int(1),
                name: 'z',
                condition: '<='
            }, ({ z: z })=>{
                const dist = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_worley_distance(localpos, x, y, z, X, Y, Z, jitter, metric)).toVar();
                $d89c9137a3d237c2$var$If(dist.lessThan(sqdist.x), ()=>{
                    sqdist.y.assign(sqdist.x);
                    sqdist.x.assign(dist);
                }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                    sqdist.y.assign(dist);
                });
            });
        });
    });
    $d89c9137a3d237c2$var$If(metric.equal($d89c9137a3d237c2$var$int(0)), ()=>{
        sqdist.assign($d89c9137a3d237c2$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec2_1',
    type: 'vec2',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_worley_noise_vec2$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_worley_noise_vec2_0,
    $d89c9137a3d237c2$var$mx_worley_noise_vec2_1
]);
const $d89c9137a3d237c2$var$mx_worley_noise_vec3_1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $d89c9137a3d237c2$var$int(metric_immutable).toVar();
    const jitter = $d89c9137a3d237c2$var$float(jitter_immutable).toVar();
    const p = $d89c9137a3d237c2$var$vec3(p_immutable).toVar();
    const X = $d89c9137a3d237c2$var$int().toVar(), Y = $d89c9137a3d237c2$var$int().toVar(), Z = $d89c9137a3d237c2$var$int().toVar();
    const localpos = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$mx_floorfrac(p.x, X), $d89c9137a3d237c2$var$mx_floorfrac(p.y, Y), $d89c9137a3d237c2$var$mx_floorfrac(p.z, Z)).toVar();
    const sqdist = $d89c9137a3d237c2$var$vec3(1e6, 1e6, 1e6).toVar();
    $d89c9137a3d237c2$var$Loop({
        start: -1,
        end: $d89c9137a3d237c2$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $d89c9137a3d237c2$var$Loop({
            start: -1,
            end: $d89c9137a3d237c2$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            $d89c9137a3d237c2$var$Loop({
                start: -1,
                end: $d89c9137a3d237c2$var$int(1),
                name: 'z',
                condition: '<='
            }, ({ z: z })=>{
                const dist = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$mx_worley_distance(localpos, x, y, z, X, Y, Z, jitter, metric)).toVar();
                $d89c9137a3d237c2$var$If(dist.lessThan(sqdist.x), ()=>{
                    sqdist.z.assign(sqdist.y);
                    sqdist.y.assign(sqdist.x);
                    sqdist.x.assign(dist);
                }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                    sqdist.z.assign(sqdist.y);
                    sqdist.y.assign(dist);
                }).ElseIf(dist.lessThan(sqdist.z), ()=>{
                    sqdist.z.assign(dist);
                });
            });
        });
    });
    $d89c9137a3d237c2$var$If(metric.equal($d89c9137a3d237c2$var$int(0)), ()=>{
        sqdist.assign($d89c9137a3d237c2$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_worley_noise_vec3$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$overloadingFn([
    $d89c9137a3d237c2$var$mx_worley_noise_vec3_0,
    $d89c9137a3d237c2$var$mx_worley_noise_vec3_1
]);
// Unified Noise 2D
const $d89c9137a3d237c2$var$mx_unifiednoise2d$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([noiseType_immutable, texcoord_immutable, freq_immutable, offset_immutable, jitter_immutable, outmin_immutable, outmax_immutable, clampoutput_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const noiseType = $d89c9137a3d237c2$var$int(noiseType_immutable).toVar();
    const texcoord = $d89c9137a3d237c2$var$vec2(texcoord_immutable).toVar();
    const freq = $d89c9137a3d237c2$var$vec2(freq_immutable).toVar();
    const offset = $d89c9137a3d237c2$var$vec2(offset_immutable).toVar();
    const jitter = $d89c9137a3d237c2$var$float(jitter_immutable).toVar();
    const outmin = $d89c9137a3d237c2$var$float(outmin_immutable).toVar();
    const outmax = $d89c9137a3d237c2$var$float(outmax_immutable).toVar();
    const clampoutput = $d89c9137a3d237c2$var$bool(clampoutput_immutable).toVar();
    const octaves = $d89c9137a3d237c2$var$int(octaves_immutable).toVar();
    const lacunarity = $d89c9137a3d237c2$var$float(lacunarity_immutable).toVar();
    const diminish = $d89c9137a3d237c2$var$float(diminish_immutable).toVar();
    // Compute input position
    const p = texcoord.mul(freq).add(offset);
    const result = $d89c9137a3d237c2$var$float(0.0).toVar();
    // Perlin
    $d89c9137a3d237c2$var$If(noiseType.equal($d89c9137a3d237c2$var$int(0)), ()=>{
        result.assign($d89c9137a3d237c2$var$mx_perlin_noise_vec3(p));
    });
    // Cell
    $d89c9137a3d237c2$var$If(noiseType.equal($d89c9137a3d237c2$var$int(1)), ()=>{
        result.assign($d89c9137a3d237c2$var$mx_cell_noise_vec3(p));
    });
    // Worley (metric=0 = euclidean)
    $d89c9137a3d237c2$var$If(noiseType.equal($d89c9137a3d237c2$var$int(2)), ()=>{
        result.assign($d89c9137a3d237c2$var$mx_worley_noise_vec3$1(p, jitter, $d89c9137a3d237c2$var$int(0)));
    });
    // Fractal (use vec3(p, 0.0) for 2D input)
    $d89c9137a3d237c2$var$If(noiseType.equal($d89c9137a3d237c2$var$int(3)), ()=>{
        result.assign($d89c9137a3d237c2$var$mx_fractal_noise_vec3$1($d89c9137a3d237c2$var$vec3(p, 0.0), octaves, lacunarity, diminish));
    });
    // Remap output to [outmin, outmax]
    result.assign(result.mul(outmax.sub(outmin)).add(outmin));
    // Clamp if requested
    $d89c9137a3d237c2$var$If(clampoutput, ()=>{
        result.assign($d89c9137a3d237c2$var$clamp(result, outmin, outmax));
    });
    return result;
}).setLayout({
    name: 'mx_unifiednoise2d',
    type: 'float',
    inputs: [
        {
            name: 'noiseType',
            type: 'int'
        },
        {
            name: 'texcoord',
            type: 'vec2'
        },
        {
            name: 'freq',
            type: 'vec2'
        },
        {
            name: 'offset',
            type: 'vec2'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'outmin',
            type: 'float'
        },
        {
            name: 'outmax',
            type: 'float'
        },
        {
            name: 'clampoutput',
            type: 'bool'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
// Unified Noise 3D
const $d89c9137a3d237c2$var$mx_unifiednoise3d$1 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([noiseType_immutable, position_immutable, freq_immutable, offset_immutable, jitter_immutable, outmin_immutable, outmax_immutable, clampoutput_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const noiseType = $d89c9137a3d237c2$var$int(noiseType_immutable).toVar();
    const position = $d89c9137a3d237c2$var$vec3(position_immutable).toVar();
    const freq = $d89c9137a3d237c2$var$vec3(freq_immutable).toVar();
    const offset = $d89c9137a3d237c2$var$vec3(offset_immutable).toVar();
    const jitter = $d89c9137a3d237c2$var$float(jitter_immutable).toVar();
    const outmin = $d89c9137a3d237c2$var$float(outmin_immutable).toVar();
    const outmax = $d89c9137a3d237c2$var$float(outmax_immutable).toVar();
    const clampoutput = $d89c9137a3d237c2$var$bool(clampoutput_immutable).toVar();
    const octaves = $d89c9137a3d237c2$var$int(octaves_immutable).toVar();
    const lacunarity = $d89c9137a3d237c2$var$float(lacunarity_immutable).toVar();
    const diminish = $d89c9137a3d237c2$var$float(diminish_immutable).toVar();
    // Compute input position
    const p = position.mul(freq).add(offset);
    const result = $d89c9137a3d237c2$var$float(0.0).toVar();
    // Perlin
    $d89c9137a3d237c2$var$If(noiseType.equal($d89c9137a3d237c2$var$int(0)), ()=>{
        result.assign($d89c9137a3d237c2$var$mx_perlin_noise_vec3(p));
    });
    // Cell
    $d89c9137a3d237c2$var$If(noiseType.equal($d89c9137a3d237c2$var$int(1)), ()=>{
        result.assign($d89c9137a3d237c2$var$mx_cell_noise_vec3(p));
    });
    // Worley (metric=0 = euclidean)
    $d89c9137a3d237c2$var$If(noiseType.equal($d89c9137a3d237c2$var$int(2)), ()=>{
        result.assign($d89c9137a3d237c2$var$mx_worley_noise_vec3$1(p, jitter, $d89c9137a3d237c2$var$int(0)));
    });
    // Fractal
    $d89c9137a3d237c2$var$If(noiseType.equal($d89c9137a3d237c2$var$int(3)), ()=>{
        result.assign($d89c9137a3d237c2$var$mx_fractal_noise_vec3$1(p, octaves, lacunarity, diminish));
    });
    // Remap output to [outmin, outmax]
    result.assign(result.mul(outmax.sub(outmin)).add(outmin));
    // Clamp if requested
    $d89c9137a3d237c2$var$If(clampoutput, ()=>{
        result.assign($d89c9137a3d237c2$var$clamp(result, outmin, outmax));
    });
    return result;
}).setLayout({
    name: 'mx_unifiednoise3d',
    type: 'float',
    inputs: [
        {
            name: 'noiseType',
            type: 'int'
        },
        {
            name: 'position',
            type: 'vec3'
        },
        {
            name: 'freq',
            type: 'vec3'
        },
        {
            name: 'offset',
            type: 'vec3'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'outmin',
            type: 'float'
        },
        {
            name: 'outmax',
            type: 'float'
        },
        {
            name: 'clampoutput',
            type: 'bool'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
// Three.js Transpiler
// https://github.com/AcademySoftwareFoundation/MaterialX/blob/main/libraries/stdlib/genglsl/lib/mx_hsv.glsl
const $d89c9137a3d237c2$var$mx_hsvtorgb = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([hsv])=>{
    const s = hsv.y;
    const v = hsv.z;
    const result = $d89c9137a3d237c2$var$vec3().toVar();
    $d89c9137a3d237c2$var$If(s.lessThan(0.0001), ()=>{
        result.assign($d89c9137a3d237c2$var$vec3(v, v, v));
    }).Else(()=>{
        let h = hsv.x;
        h = h.sub($d89c9137a3d237c2$var$floor(h)).mul(6.0).toVar(); // TODO: check what .toVar() is needed in node system cache
        const hi = $d89c9137a3d237c2$var$int($d89c9137a3d237c2$var$trunc(h));
        const f = h.sub($d89c9137a3d237c2$var$float(hi));
        const p = v.mul(s.oneMinus());
        const q = v.mul(s.mul(f).oneMinus());
        const t = v.mul(s.mul(f.oneMinus()).oneMinus());
        $d89c9137a3d237c2$var$If(hi.equal($d89c9137a3d237c2$var$int(0)), ()=>{
            result.assign($d89c9137a3d237c2$var$vec3(v, t, p));
        }).ElseIf(hi.equal($d89c9137a3d237c2$var$int(1)), ()=>{
            result.assign($d89c9137a3d237c2$var$vec3(q, v, p));
        }).ElseIf(hi.equal($d89c9137a3d237c2$var$int(2)), ()=>{
            result.assign($d89c9137a3d237c2$var$vec3(p, v, t));
        }).ElseIf(hi.equal($d89c9137a3d237c2$var$int(3)), ()=>{
            result.assign($d89c9137a3d237c2$var$vec3(p, q, v));
        }).ElseIf(hi.equal($d89c9137a3d237c2$var$int(4)), ()=>{
            result.assign($d89c9137a3d237c2$var$vec3(t, p, v));
        }).Else(()=>{
            result.assign($d89c9137a3d237c2$var$vec3(v, p, q));
        });
    });
    return result;
}).setLayout({
    name: 'mx_hsvtorgb',
    type: 'vec3',
    inputs: [
        {
            name: 'hsv',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_rgbtohsv = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([c_immutable])=>{
    const c = $d89c9137a3d237c2$var$vec3(c_immutable).toVar();
    const r = $d89c9137a3d237c2$var$float(c.x).toVar();
    const g = $d89c9137a3d237c2$var$float(c.y).toVar();
    const b = $d89c9137a3d237c2$var$float(c.z).toVar();
    const mincomp = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$min$1(r, $d89c9137a3d237c2$var$min$1(g, b))).toVar();
    const maxcomp = $d89c9137a3d237c2$var$float($d89c9137a3d237c2$var$max$1(r, $d89c9137a3d237c2$var$max$1(g, b))).toVar();
    const delta = $d89c9137a3d237c2$var$float(maxcomp.sub(mincomp)).toVar();
    const h = $d89c9137a3d237c2$var$float().toVar(), s = $d89c9137a3d237c2$var$float().toVar(), v = $d89c9137a3d237c2$var$float().toVar();
    v.assign(maxcomp);
    $d89c9137a3d237c2$var$If(maxcomp.greaterThan(0.0), ()=>{
        s.assign(delta.div(maxcomp));
    }).Else(()=>{
        s.assign(0.0);
    });
    $d89c9137a3d237c2$var$If(s.lessThanEqual(0.0), ()=>{
        h.assign(0.0);
    }).Else(()=>{
        $d89c9137a3d237c2$var$If(r.greaterThanEqual(maxcomp), ()=>{
            h.assign(g.sub(b).div(delta));
        }).ElseIf(g.greaterThanEqual(maxcomp), ()=>{
            h.assign($d89c9137a3d237c2$var$add(2.0, b.sub(r).div(delta)));
        }).Else(()=>{
            h.assign($d89c9137a3d237c2$var$add(4.0, r.sub(g).div(delta)));
        });
        h.mulAssign(1.0 / 6.0);
        $d89c9137a3d237c2$var$If(h.lessThan(0.0), ()=>{
            h.addAssign(1.0);
        });
    });
    return $d89c9137a3d237c2$var$vec3(h, s, v);
}).setLayout({
    name: 'mx_rgbtohsv',
    type: 'vec3',
    inputs: [
        {
            name: 'c',
            type: 'vec3'
        }
    ]
});
// Three.js Transpiler
// https://github.com/AcademySoftwareFoundation/MaterialX/blob/main/libraries/stdlib/genglsl/lib/mx_transform_color.glsl
const $d89c9137a3d237c2$var$mx_srgb_texture_to_lin_rec709 = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([color_immutable])=>{
    const color = $d89c9137a3d237c2$var$vec3(color_immutable).toVar();
    const isAbove = $d89c9137a3d237c2$var$bvec3($d89c9137a3d237c2$var$greaterThan(color, $d89c9137a3d237c2$var$vec3(0.04045))).toVar();
    const linSeg = $d89c9137a3d237c2$var$vec3(color.div(12.92)).toVar();
    const powSeg = $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$pow($d89c9137a3d237c2$var$max$1(color.add($d89c9137a3d237c2$var$vec3(0.055)), $d89c9137a3d237c2$var$vec3(0.0)).div(1.055), $d89c9137a3d237c2$var$vec3(2.4))).toVar();
    return $d89c9137a3d237c2$var$mix(linSeg, powSeg, isAbove);
}).setLayout({
    name: 'mx_srgb_texture_to_lin_rec709',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        }
    ]
});
const $d89c9137a3d237c2$var$mx_aastep = (threshold, value)=>{
    threshold = $d89c9137a3d237c2$var$float(threshold);
    value = $d89c9137a3d237c2$var$float(value);
    const afwidth = $d89c9137a3d237c2$var$vec2(value.dFdx(), value.dFdy()).length().mul(0.70710678118654757);
    return $d89c9137a3d237c2$var$smoothstep(threshold.sub(afwidth), threshold.add(afwidth), value);
};
const $d89c9137a3d237c2$var$_ramp = (a, b, uv, p)=>$d89c9137a3d237c2$var$mix(a, b, uv[p].clamp());
const $d89c9137a3d237c2$var$mx_ramplr = (valuel, valuer, texcoord = $d89c9137a3d237c2$var$uv$1())=>$d89c9137a3d237c2$var$_ramp(valuel, valuer, texcoord, 'x');
const $d89c9137a3d237c2$var$mx_ramptb = (valuet, valueb, texcoord = $d89c9137a3d237c2$var$uv$1())=>$d89c9137a3d237c2$var$_ramp(valuet, valueb, texcoord, 'y');
// Bilinear ramp: interpolate between four corners (tl, tr, bl, br) using texcoord.x and texcoord.y
const $d89c9137a3d237c2$var$mx_ramp4 = (valuetl, valuetr, valuebl, valuebr, texcoord = $d89c9137a3d237c2$var$uv$1())=>{
    const u = texcoord.x.clamp();
    const v = texcoord.y.clamp();
    const top = $d89c9137a3d237c2$var$mix(valuetl, valuetr, u);
    const bottom = $d89c9137a3d237c2$var$mix(valuebl, valuebr, u);
    return $d89c9137a3d237c2$var$mix(top, bottom, v);
};
const $d89c9137a3d237c2$var$_split = (a, b, center, uv, p)=>$d89c9137a3d237c2$var$mix(a, b, $d89c9137a3d237c2$var$mx_aastep(center, uv[p]));
const $d89c9137a3d237c2$var$mx_splitlr = (valuel, valuer, center, texcoord = $d89c9137a3d237c2$var$uv$1())=>$d89c9137a3d237c2$var$_split(valuel, valuer, center, texcoord, 'x');
const $d89c9137a3d237c2$var$mx_splittb = (valuet, valueb, center, texcoord = $d89c9137a3d237c2$var$uv$1())=>$d89c9137a3d237c2$var$_split(valuet, valueb, center, texcoord, 'y');
const $d89c9137a3d237c2$var$mx_transform_uv = (uv_scale = 1, uv_offset = 0, uv_geo = $d89c9137a3d237c2$var$uv$1())=>uv_geo.mul(uv_scale).add(uv_offset);
const $d89c9137a3d237c2$var$mx_safepower = (in1, in2 = 1)=>{
    in1 = $d89c9137a3d237c2$var$float(in1);
    return in1.abs().pow(in2).mul(in1.sign());
};
const $d89c9137a3d237c2$var$mx_contrast = (input, amount = 1, pivot = .5)=>$d89c9137a3d237c2$var$float(input).sub(pivot).mul(amount).add(pivot);
const $d89c9137a3d237c2$var$mx_noise_float = (texcoord = $d89c9137a3d237c2$var$uv$1(), amplitude = 1, pivot = 0)=>$d89c9137a3d237c2$var$mx_perlin_noise_float(texcoord.convert('vec2|vec3')).mul(amplitude).add(pivot);
//export const mx_noise_vec2 = ( texcoord = uv(), amplitude = 1, pivot = 0 ) => mx_perlin_noise_vec3( texcoord.convert( 'vec2|vec3' ) ).mul( amplitude ).add( pivot );
const $d89c9137a3d237c2$var$mx_noise_vec3 = (texcoord = $d89c9137a3d237c2$var$uv$1(), amplitude = 1, pivot = 0)=>$d89c9137a3d237c2$var$mx_perlin_noise_vec3(texcoord.convert('vec2|vec3')).mul(amplitude).add(pivot);
const $d89c9137a3d237c2$var$mx_noise_vec4 = (texcoord = $d89c9137a3d237c2$var$uv$1(), amplitude = 1, pivot = 0)=>{
    texcoord = texcoord.convert('vec2|vec3'); // overloading type
    const noise_vec4 = $d89c9137a3d237c2$var$vec4($d89c9137a3d237c2$var$mx_perlin_noise_vec3(texcoord), $d89c9137a3d237c2$var$mx_perlin_noise_float(texcoord.add($d89c9137a3d237c2$var$vec2(19, 73))));
    return noise_vec4.mul(amplitude).add(pivot);
};
const $d89c9137a3d237c2$var$mx_unifiednoise2d = (noiseType, texcoord = $d89c9137a3d237c2$var$uv$1(), freq = $d89c9137a3d237c2$var$vec2(1, 1), offset = $d89c9137a3d237c2$var$vec2(0, 0), jitter = 1, outmin = 0, outmax = 1, clampoutput = false, octaves = 1, lacunarity = 2, diminish = .5)=>$d89c9137a3d237c2$var$mx_unifiednoise2d$1(noiseType, texcoord.convert('vec2|vec3'), freq, offset, jitter, outmin, outmax, clampoutput, octaves, lacunarity, diminish);
const $d89c9137a3d237c2$var$mx_unifiednoise3d = (noiseType, texcoord = $d89c9137a3d237c2$var$uv$1(), freq = $d89c9137a3d237c2$var$vec2(1, 1), offset = $d89c9137a3d237c2$var$vec2(0, 0), jitter = 1, outmin = 0, outmax = 1, clampoutput = false, octaves = 1, lacunarity = 2, diminish = .5)=>$d89c9137a3d237c2$var$mx_unifiednoise3d$1(noiseType, texcoord.convert('vec2|vec3'), freq, offset, jitter, outmin, outmax, clampoutput, octaves, lacunarity, diminish);
const $d89c9137a3d237c2$var$mx_worley_noise_float = (texcoord = $d89c9137a3d237c2$var$uv$1(), jitter = 1)=>$d89c9137a3d237c2$var$mx_worley_noise_float$1(texcoord.convert('vec2|vec3'), jitter, $d89c9137a3d237c2$var$int(1));
const $d89c9137a3d237c2$var$mx_worley_noise_vec2 = (texcoord = $d89c9137a3d237c2$var$uv$1(), jitter = 1)=>$d89c9137a3d237c2$var$mx_worley_noise_vec2$1(texcoord.convert('vec2|vec3'), jitter, $d89c9137a3d237c2$var$int(1));
const $d89c9137a3d237c2$var$mx_worley_noise_vec3 = (texcoord = $d89c9137a3d237c2$var$uv$1(), jitter = 1)=>$d89c9137a3d237c2$var$mx_worley_noise_vec3$1(texcoord.convert('vec2|vec3'), jitter, $d89c9137a3d237c2$var$int(1));
const $d89c9137a3d237c2$var$mx_cell_noise_float = (texcoord = $d89c9137a3d237c2$var$uv$1())=>$d89c9137a3d237c2$var$mx_cell_noise_float$1(texcoord.convert('vec2|vec3'));
const $d89c9137a3d237c2$var$mx_fractal_noise_float = (position = $d89c9137a3d237c2$var$uv$1(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>$d89c9137a3d237c2$var$mx_fractal_noise_float$1(position, $d89c9137a3d237c2$var$int(octaves), lacunarity, diminish).mul(amplitude);
const $d89c9137a3d237c2$var$mx_fractal_noise_vec2 = (position = $d89c9137a3d237c2$var$uv$1(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>$d89c9137a3d237c2$var$mx_fractal_noise_vec2$1(position, $d89c9137a3d237c2$var$int(octaves), lacunarity, diminish).mul(amplitude);
const $d89c9137a3d237c2$var$mx_fractal_noise_vec3 = (position = $d89c9137a3d237c2$var$uv$1(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>$d89c9137a3d237c2$var$mx_fractal_noise_vec3$1(position, $d89c9137a3d237c2$var$int(octaves), lacunarity, diminish).mul(amplitude);
const $d89c9137a3d237c2$var$mx_fractal_noise_vec4 = (position = $d89c9137a3d237c2$var$uv$1(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>$d89c9137a3d237c2$var$mx_fractal_noise_vec4$1(position, $d89c9137a3d237c2$var$int(octaves), lacunarity, diminish).mul(amplitude);
// === Moved from MaterialXLoader.js ===
// Math ops
const $d89c9137a3d237c2$var$mx_add = (in1, in2 = $d89c9137a3d237c2$var$float(0))=>$d89c9137a3d237c2$var$add(in1, in2);
const $d89c9137a3d237c2$var$mx_subtract = (in1, in2 = $d89c9137a3d237c2$var$float(0))=>$d89c9137a3d237c2$var$sub(in1, in2);
const $d89c9137a3d237c2$var$mx_multiply = (in1, in2 = $d89c9137a3d237c2$var$float(1))=>$d89c9137a3d237c2$var$mul(in1, in2);
const $d89c9137a3d237c2$var$mx_divide = (in1, in2 = $d89c9137a3d237c2$var$float(1))=>$d89c9137a3d237c2$var$div(in1, in2);
const $d89c9137a3d237c2$var$mx_modulo = (in1, in2 = $d89c9137a3d237c2$var$float(1))=>$d89c9137a3d237c2$var$mod(in1, in2);
const $d89c9137a3d237c2$var$mx_power = (in1, in2 = $d89c9137a3d237c2$var$float(1))=>$d89c9137a3d237c2$var$pow(in1, in2);
const $d89c9137a3d237c2$var$mx_atan2 = (in1 = $d89c9137a3d237c2$var$float(0), in2 = $d89c9137a3d237c2$var$float(1))=>$d89c9137a3d237c2$var$atan(in1, in2);
const $d89c9137a3d237c2$var$mx_timer = ()=>$d89c9137a3d237c2$var$time;
const $d89c9137a3d237c2$var$mx_frame = ()=>$d89c9137a3d237c2$var$frameId;
const $d89c9137a3d237c2$var$mx_invert = (in1, amount = $d89c9137a3d237c2$var$float(1))=>$d89c9137a3d237c2$var$sub(amount, in1);
const $d89c9137a3d237c2$var$mx_ifgreater = (value1, value2, in1, in2)=>value1.greaterThan(value2).mix(in1, in2);
const $d89c9137a3d237c2$var$mx_ifgreatereq = (value1, value2, in1, in2)=>value1.greaterThanEqual(value2).mix(in1, in2);
const $d89c9137a3d237c2$var$mx_ifequal = (value1, value2, in1, in2)=>value1.equal(value2).mix(in1, in2);
// Enhanced separate node to support multi-output referencing (outx, outy, outz, outw)
const $d89c9137a3d237c2$var$mx_separate = (in1, channelOrOut = null)=>{
    if (typeof channelOrOut === 'string') {
        const map = {
            x: 0,
            r: 0,
            y: 1,
            g: 1,
            z: 2,
            b: 2,
            w: 3,
            a: 3
        };
        const c = channelOrOut.replace(/^out/, '').toLowerCase();
        if (map[c] !== undefined) return in1.element(map[c]);
    }
    if (typeof channelOrOut === 'number') return in1.element(channelOrOut);
    if (typeof channelOrOut === 'string' && channelOrOut.length === 1) {
        const map = {
            x: 0,
            r: 0,
            y: 1,
            g: 1,
            z: 2,
            b: 2,
            w: 3,
            a: 3
        };
        if (map[channelOrOut] !== undefined) return in1.element(map[channelOrOut]);
    }
    return in1;
};
const $d89c9137a3d237c2$var$mx_place2d = (texcoord, pivot = $d89c9137a3d237c2$var$vec2(0.5, 0.5), scale = $d89c9137a3d237c2$var$vec2(1, 1), rotate = $d89c9137a3d237c2$var$float(0), offset = $d89c9137a3d237c2$var$vec2(0, 0))=>{
    let uv = texcoord;
    if (pivot) uv = uv.sub(pivot);
    if (scale) uv = uv.mul(scale);
    if (rotate) {
        const rad = rotate.mul(Math.PI / 180.0);
        const cosR = rad.cos();
        const sinR = rad.sin();
        uv = $d89c9137a3d237c2$var$vec2(uv.x.mul(cosR).sub(uv.y.mul(sinR)), uv.x.mul(sinR).add(uv.y.mul(cosR)));
    }
    if (pivot) uv = uv.add(pivot);
    if (offset) uv = uv.add(offset);
    return uv;
};
const $d89c9137a3d237c2$var$mx_rotate2d = (input, amount)=>{
    input = $d89c9137a3d237c2$var$vec2(input);
    amount = $d89c9137a3d237c2$var$float(amount);
    const radians = amount.mul(Math.PI / 180.0);
    return $d89c9137a3d237c2$var$rotate(input, radians);
};
const $d89c9137a3d237c2$var$mx_rotate3d = (input, amount, axis)=>{
    input = $d89c9137a3d237c2$var$vec3(input);
    amount = $d89c9137a3d237c2$var$float(amount);
    axis = $d89c9137a3d237c2$var$vec3(axis);
    const radians = amount.mul(Math.PI / 180.0);
    const nAxis = axis.normalize();
    const cosA = radians.cos();
    const sinA = radians.sin();
    const oneMinusCosA = $d89c9137a3d237c2$var$float(1).sub(cosA);
    const rot = input.mul(cosA).add(nAxis.cross(input).mul(sinA)).add(nAxis.mul(nAxis.dot(input)).mul(oneMinusCosA));
    return rot;
};
const $d89c9137a3d237c2$var$mx_heighttonormal = (input, scale /*, texcoord*/ )=>{
    input = $d89c9137a3d237c2$var$vec3(input);
    scale = $d89c9137a3d237c2$var$float(scale);
    return $d89c9137a3d237c2$var$bumpMap(input, scale);
};
/**
 * This computes a parallax corrected normal which is used for box-projected cube mapping (BPCEM).
 *
 * Reference: {@link https://devlog-martinsh.blogspot.com/2011/09/box-projected-cube-environment-mapping.html}
 *
 * ```js
 * const uvNode = getParallaxCorrectNormal( reflectVector, vec3( 200, 100, 100 ), vec3( 0, - 50, 0 ) );
 * material.envNode = pmremTexture( renderTarget.texture, uvNode );
 * ```
 *
 * @tsl
 * @function
 * @param {Node<vec3>} normal - The normal to correct.
 * @param {Node<vec3>} cubeSize - The cube size should reflect the size of the environment (BPCEM is usually applied in closed environments like rooms).
 * @param {Node<vec3>} cubePos - The cube position.
 * @return {Node<vec3>} The parallax corrected normal.
 */ const $d89c9137a3d237c2$var$getParallaxCorrectNormal = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([normal, cubeSize, cubePos])=>{
    const nDir = $d89c9137a3d237c2$var$normalize(normal).toVar();
    const rbmax = $d89c9137a3d237c2$var$sub($d89c9137a3d237c2$var$float(0.5).mul(cubeSize.sub(cubePos)), $d89c9137a3d237c2$var$positionWorld).div(nDir).toVar();
    const rbmin = $d89c9137a3d237c2$var$sub($d89c9137a3d237c2$var$float(-0.5).mul(cubeSize.sub(cubePos)), $d89c9137a3d237c2$var$positionWorld).div(nDir).toVar();
    const rbminmax = $d89c9137a3d237c2$var$vec3().toVar();
    rbminmax.x = nDir.x.greaterThan($d89c9137a3d237c2$var$float(0)).select(rbmax.x, rbmin.x);
    rbminmax.y = nDir.y.greaterThan($d89c9137a3d237c2$var$float(0)).select(rbmax.y, rbmin.y);
    rbminmax.z = nDir.z.greaterThan($d89c9137a3d237c2$var$float(0)).select(rbmax.z, rbmin.z);
    const correction = $d89c9137a3d237c2$var$min$1(rbminmax.x, rbminmax.y, rbminmax.z).toVar();
    const boxIntersection = $d89c9137a3d237c2$var$positionWorld.add(nDir.mul(correction)).toVar();
    return boxIntersection.sub(cubePos);
});
const $d89c9137a3d237c2$var$getShIrradianceAt = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([normal, shCoefficients])=>{
    // normal is assumed to have unit length
    const x = normal.x, y = normal.y, z = normal.z;
    // band 0
    let result = shCoefficients.element(0).mul(0.886227);
    // band 1
    result = result.add(shCoefficients.element(1).mul(1.023328).mul(y));
    result = result.add(shCoefficients.element(2).mul(1.023328).mul(z));
    result = result.add(shCoefficients.element(3).mul(1.023328).mul(x));
    // band 2
    result = result.add(shCoefficients.element(4).mul(0.858086).mul(x).mul(y));
    result = result.add(shCoefficients.element(5).mul(0.858086).mul(y).mul(z));
    result = result.add(shCoefficients.element(6).mul(z.mul(z).mul(0.743125).sub(0.247708)));
    result = result.add(shCoefficients.element(7).mul(0.858086).mul(x).mul(z));
    result = result.add(shCoefficients.element(8).mul(0.429043).mul($d89c9137a3d237c2$var$mul(x, x).sub($d89c9137a3d237c2$var$mul(y, y))));
    return result;
});
// constants
var $d89c9137a3d237c2$export$d844e3d2f3ba8c41 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BRDF_GGX: $d89c9137a3d237c2$var$BRDF_GGX,
    BRDF_Lambert: $d89c9137a3d237c2$var$BRDF_Lambert,
    BasicPointShadowFilter: $d89c9137a3d237c2$var$BasicPointShadowFilter,
    BasicShadowFilter: $d89c9137a3d237c2$var$BasicShadowFilter,
    Break: $d89c9137a3d237c2$var$Break,
    Const: $d89c9137a3d237c2$var$Const,
    Continue: $d89c9137a3d237c2$var$Continue,
    DFGLUT: $d89c9137a3d237c2$var$DFGLUT,
    D_GGX: $d89c9137a3d237c2$var$D_GGX,
    Discard: $d89c9137a3d237c2$var$Discard,
    EPSILON: $d89c9137a3d237c2$var$EPSILON,
    F_Schlick: $d89c9137a3d237c2$var$F_Schlick,
    Fn: $d89c9137a3d237c2$var$Fn,
    HALF_PI: $d89c9137a3d237c2$var$HALF_PI,
    INFINITY: $d89c9137a3d237c2$var$INFINITY,
    If: $d89c9137a3d237c2$var$If,
    Loop: $d89c9137a3d237c2$var$Loop,
    NodeAccess: $d89c9137a3d237c2$export$92538c74c63a703d,
    NodeShaderStage: $d89c9137a3d237c2$export$9e43649cde3e3072,
    NodeType: $d89c9137a3d237c2$export$f06e977173f1857c,
    NodeUpdateType: $d89c9137a3d237c2$export$26f7a8bbd9469530,
    OnBeforeMaterialUpdate: $d89c9137a3d237c2$var$OnBeforeMaterialUpdate,
    OnBeforeObjectUpdate: $d89c9137a3d237c2$var$OnBeforeObjectUpdate,
    OnMaterialUpdate: $d89c9137a3d237c2$var$OnMaterialUpdate,
    OnObjectUpdate: $d89c9137a3d237c2$var$OnObjectUpdate,
    PCFShadowFilter: $d89c9137a3d237c2$var$PCFShadowFilter,
    PCFSoftShadowFilter: $d89c9137a3d237c2$var$PCFSoftShadowFilter,
    PI: $d89c9137a3d237c2$var$PI,
    PI2: $d89c9137a3d237c2$var$PI2,
    PointShadowFilter: $d89c9137a3d237c2$var$PointShadowFilter,
    Return: $d89c9137a3d237c2$var$Return,
    Schlick_to_F0: $d89c9137a3d237c2$var$Schlick_to_F0,
    ScriptableNodeResources: $d89c9137a3d237c2$var$ScriptableNodeResources,
    ShaderNode: $d89c9137a3d237c2$var$ShaderNode,
    Stack: $d89c9137a3d237c2$var$Stack,
    Switch: $d89c9137a3d237c2$var$Switch,
    TBNViewMatrix: $d89c9137a3d237c2$var$TBNViewMatrix,
    TWO_PI: $d89c9137a3d237c2$var$TWO_PI,
    VSMShadowFilter: $d89c9137a3d237c2$var$VSMShadowFilter,
    V_GGX_SmithCorrelated: $d89c9137a3d237c2$var$V_GGX_SmithCorrelated,
    Var: $d89c9137a3d237c2$var$Var,
    VarIntent: $d89c9137a3d237c2$var$VarIntent,
    abs: $d89c9137a3d237c2$var$abs,
    acesFilmicToneMapping: $d89c9137a3d237c2$var$acesFilmicToneMapping,
    acos: $d89c9137a3d237c2$var$acos,
    add: $d89c9137a3d237c2$var$add,
    addMethodChaining: $d89c9137a3d237c2$var$addMethodChaining,
    addNodeElement: $d89c9137a3d237c2$var$addNodeElement,
    agxToneMapping: $d89c9137a3d237c2$var$agxToneMapping,
    all: $d89c9137a3d237c2$var$all,
    alphaT: $d89c9137a3d237c2$var$alphaT,
    and: $d89c9137a3d237c2$var$and,
    anisotropy: $d89c9137a3d237c2$var$anisotropy,
    anisotropyB: $d89c9137a3d237c2$var$anisotropyB,
    anisotropyT: $d89c9137a3d237c2$var$anisotropyT,
    any: $d89c9137a3d237c2$var$any,
    append: $d89c9137a3d237c2$var$append,
    array: $d89c9137a3d237c2$var$array,
    arrayBuffer: $d89c9137a3d237c2$var$arrayBuffer,
    asin: $d89c9137a3d237c2$var$asin,
    assign: $d89c9137a3d237c2$var$assign,
    atan: $d89c9137a3d237c2$var$atan,
    atan2: $d89c9137a3d237c2$var$atan2,
    atomicAdd: $d89c9137a3d237c2$var$atomicAdd,
    atomicAnd: $d89c9137a3d237c2$var$atomicAnd,
    atomicFunc: $d89c9137a3d237c2$var$atomicFunc,
    atomicLoad: $d89c9137a3d237c2$var$atomicLoad,
    atomicMax: $d89c9137a3d237c2$var$atomicMax,
    atomicMin: $d89c9137a3d237c2$var$atomicMin,
    atomicOr: $d89c9137a3d237c2$var$atomicOr,
    atomicStore: $d89c9137a3d237c2$var$atomicStore,
    atomicSub: $d89c9137a3d237c2$var$atomicSub,
    atomicXor: $d89c9137a3d237c2$var$atomicXor,
    attenuationColor: $d89c9137a3d237c2$var$attenuationColor,
    attenuationDistance: $d89c9137a3d237c2$var$attenuationDistance,
    attribute: $d89c9137a3d237c2$var$attribute,
    attributeArray: $d89c9137a3d237c2$var$attributeArray,
    backgroundBlurriness: $d89c9137a3d237c2$var$backgroundBlurriness,
    backgroundIntensity: $d89c9137a3d237c2$var$backgroundIntensity,
    backgroundRotation: $d89c9137a3d237c2$var$backgroundRotation,
    batch: $d89c9137a3d237c2$var$batch,
    bentNormalView: $d89c9137a3d237c2$var$bentNormalView,
    billboarding: $d89c9137a3d237c2$var$billboarding,
    bitAnd: $d89c9137a3d237c2$var$bitAnd,
    bitNot: $d89c9137a3d237c2$var$bitNot,
    bitOr: $d89c9137a3d237c2$var$bitOr,
    bitXor: $d89c9137a3d237c2$var$bitXor,
    bitangentGeometry: $d89c9137a3d237c2$var$bitangentGeometry,
    bitangentLocal: $d89c9137a3d237c2$var$bitangentLocal,
    bitangentView: $d89c9137a3d237c2$var$bitangentView,
    bitangentWorld: $d89c9137a3d237c2$var$bitangentWorld,
    bitcast: $d89c9137a3d237c2$var$bitcast,
    blendBurn: $d89c9137a3d237c2$var$blendBurn,
    blendColor: $d89c9137a3d237c2$var$blendColor,
    blendDodge: $d89c9137a3d237c2$var$blendDodge,
    blendOverlay: $d89c9137a3d237c2$var$blendOverlay,
    blendScreen: $d89c9137a3d237c2$var$blendScreen,
    blur: $d89c9137a3d237c2$var$blur,
    bool: $d89c9137a3d237c2$var$bool,
    buffer: $d89c9137a3d237c2$var$buffer,
    bufferAttribute: $d89c9137a3d237c2$var$bufferAttribute,
    builtin: $d89c9137a3d237c2$var$builtin,
    builtinAOContext: $d89c9137a3d237c2$var$builtinAOContext,
    builtinShadowContext: $d89c9137a3d237c2$var$builtinShadowContext,
    bumpMap: $d89c9137a3d237c2$var$bumpMap,
    burn: $d89c9137a3d237c2$var$burn,
    bvec2: $d89c9137a3d237c2$var$bvec2,
    bvec3: $d89c9137a3d237c2$var$bvec3,
    bvec4: $d89c9137a3d237c2$var$bvec4,
    bypass: $d89c9137a3d237c2$var$bypass,
    cache: $d89c9137a3d237c2$var$cache,
    call: $d89c9137a3d237c2$var$call,
    cameraFar: $d89c9137a3d237c2$var$cameraFar,
    cameraIndex: $d89c9137a3d237c2$var$cameraIndex,
    cameraNear: $d89c9137a3d237c2$var$cameraNear,
    cameraNormalMatrix: $d89c9137a3d237c2$var$cameraNormalMatrix,
    cameraPosition: $d89c9137a3d237c2$var$cameraPosition,
    cameraProjectionMatrix: $d89c9137a3d237c2$var$cameraProjectionMatrix,
    cameraProjectionMatrixInverse: $d89c9137a3d237c2$var$cameraProjectionMatrixInverse,
    cameraViewMatrix: $d89c9137a3d237c2$var$cameraViewMatrix,
    cameraViewport: $d89c9137a3d237c2$var$cameraViewport,
    cameraWorldMatrix: $d89c9137a3d237c2$var$cameraWorldMatrix,
    cbrt: $d89c9137a3d237c2$var$cbrt,
    cdl: $d89c9137a3d237c2$var$cdl,
    ceil: $d89c9137a3d237c2$var$ceil,
    checker: $d89c9137a3d237c2$var$checker,
    cineonToneMapping: $d89c9137a3d237c2$var$cineonToneMapping,
    clamp: $d89c9137a3d237c2$var$clamp,
    clearcoat: $d89c9137a3d237c2$var$clearcoat,
    clearcoatNormalView: $d89c9137a3d237c2$var$clearcoatNormalView,
    clearcoatRoughness: $d89c9137a3d237c2$var$clearcoatRoughness,
    code: $d89c9137a3d237c2$var$code,
    color: $d89c9137a3d237c2$var$color,
    colorSpaceToWorking: $d89c9137a3d237c2$var$colorSpaceToWorking,
    colorToDirection: $d89c9137a3d237c2$var$colorToDirection,
    compute: $d89c9137a3d237c2$var$compute,
    computeKernel: $d89c9137a3d237c2$var$computeKernel,
    computeSkinning: $d89c9137a3d237c2$var$computeSkinning,
    context: $d89c9137a3d237c2$var$context,
    convert: $d89c9137a3d237c2$var$convert,
    convertColorSpace: $d89c9137a3d237c2$var$convertColorSpace,
    convertToTexture: $d89c9137a3d237c2$var$convertToTexture,
    cos: $d89c9137a3d237c2$var$cos,
    countLeadingZeros: $d89c9137a3d237c2$var$countLeadingZeros,
    countOneBits: $d89c9137a3d237c2$var$countOneBits,
    countTrailingZeros: $d89c9137a3d237c2$var$countTrailingZeros,
    cross: $d89c9137a3d237c2$var$cross,
    cubeTexture: $d89c9137a3d237c2$var$cubeTexture,
    cubeTextureBase: $d89c9137a3d237c2$var$cubeTextureBase,
    dFdx: $d89c9137a3d237c2$var$dFdx,
    dFdy: $d89c9137a3d237c2$var$dFdy,
    dashSize: $d89c9137a3d237c2$var$dashSize,
    debug: $d89c9137a3d237c2$var$debug,
    decrement: $d89c9137a3d237c2$var$decrement,
    decrementBefore: $d89c9137a3d237c2$var$decrementBefore,
    defaultBuildStages: $d89c9137a3d237c2$export$f2213ed98eb895d6,
    defaultShaderStages: $d89c9137a3d237c2$export$565139d2263e2965,
    defined: $d89c9137a3d237c2$var$defined,
    degrees: $d89c9137a3d237c2$var$degrees,
    deltaTime: $d89c9137a3d237c2$var$deltaTime,
    densityFog: $d89c9137a3d237c2$var$densityFog,
    densityFogFactor: $d89c9137a3d237c2$var$densityFogFactor,
    depth: $d89c9137a3d237c2$var$depth,
    depthPass: $d89c9137a3d237c2$var$depthPass,
    determinant: $d89c9137a3d237c2$var$determinant,
    difference: $d89c9137a3d237c2$var$difference,
    diffuseColor: $d89c9137a3d237c2$var$diffuseColor,
    diffuseContribution: $d89c9137a3d237c2$var$diffuseContribution,
    directPointLight: $d89c9137a3d237c2$var$directPointLight,
    directionToColor: $d89c9137a3d237c2$var$directionToColor,
    directionToFaceDirection: $d89c9137a3d237c2$var$directionToFaceDirection,
    dispersion: $d89c9137a3d237c2$var$dispersion,
    disposeShadowMaterial: $d89c9137a3d237c2$var$disposeShadowMaterial,
    distance: $d89c9137a3d237c2$var$distance,
    div: $d89c9137a3d237c2$var$div,
    dodge: $d89c9137a3d237c2$var$dodge,
    dot: $d89c9137a3d237c2$var$dot,
    drawIndex: $d89c9137a3d237c2$var$drawIndex,
    dynamicBufferAttribute: $d89c9137a3d237c2$var$dynamicBufferAttribute,
    element: $d89c9137a3d237c2$var$element,
    emissive: $d89c9137a3d237c2$var$emissive,
    equal: $d89c9137a3d237c2$var$equal,
    equals: $d89c9137a3d237c2$var$equals,
    equirectUV: $d89c9137a3d237c2$var$equirectUV,
    exp: $d89c9137a3d237c2$var$exp,
    exp2: $d89c9137a3d237c2$var$exp2,
    expression: $d89c9137a3d237c2$var$expression,
    faceDirection: $d89c9137a3d237c2$var$faceDirection,
    faceForward: $d89c9137a3d237c2$var$faceForward,
    faceforward: $d89c9137a3d237c2$var$faceforward,
    float: $d89c9137a3d237c2$var$float,
    floatBitsToInt: $d89c9137a3d237c2$var$floatBitsToInt,
    floatBitsToUint: $d89c9137a3d237c2$var$floatBitsToUint,
    floor: $d89c9137a3d237c2$var$floor,
    fog: $d89c9137a3d237c2$var$fog,
    fract: $d89c9137a3d237c2$var$fract,
    frameGroup: $d89c9137a3d237c2$var$frameGroup,
    frameId: $d89c9137a3d237c2$var$frameId,
    frontFacing: $d89c9137a3d237c2$var$frontFacing,
    fwidth: $d89c9137a3d237c2$var$fwidth,
    gain: $d89c9137a3d237c2$var$gain,
    gapSize: $d89c9137a3d237c2$var$gapSize,
    getConstNodeType: $d89c9137a3d237c2$var$getConstNodeType,
    getCurrentStack: $d89c9137a3d237c2$var$getCurrentStack,
    getDirection: $d89c9137a3d237c2$var$getDirection,
    getDistanceAttenuation: $d89c9137a3d237c2$var$getDistanceAttenuation,
    getGeometryRoughness: $d89c9137a3d237c2$var$getGeometryRoughness,
    getNormalFromDepth: $d89c9137a3d237c2$var$getNormalFromDepth,
    getParallaxCorrectNormal: $d89c9137a3d237c2$var$getParallaxCorrectNormal,
    getRoughness: $d89c9137a3d237c2$var$getRoughness,
    getScreenPosition: $d89c9137a3d237c2$var$getScreenPosition,
    getShIrradianceAt: $d89c9137a3d237c2$var$getShIrradianceAt,
    getShadowMaterial: $d89c9137a3d237c2$var$getShadowMaterial,
    getShadowRenderObjectFunction: $d89c9137a3d237c2$var$getShadowRenderObjectFunction,
    getTextureIndex: $d89c9137a3d237c2$var$getTextureIndex,
    getViewPosition: $d89c9137a3d237c2$var$getViewPosition,
    ggxConvolution: $d89c9137a3d237c2$var$ggxConvolution,
    globalId: $d89c9137a3d237c2$var$globalId,
    glsl: $d89c9137a3d237c2$var$glsl,
    glslFn: $d89c9137a3d237c2$var$glslFn,
    grayscale: $d89c9137a3d237c2$var$grayscale,
    greaterThan: $d89c9137a3d237c2$var$greaterThan,
    greaterThanEqual: $d89c9137a3d237c2$var$greaterThanEqual,
    hash: $d89c9137a3d237c2$var$hash,
    highpModelNormalViewMatrix: $d89c9137a3d237c2$var$highpModelNormalViewMatrix,
    highpModelViewMatrix: $d89c9137a3d237c2$var$highpModelViewMatrix,
    hue: $d89c9137a3d237c2$var$hue,
    increment: $d89c9137a3d237c2$var$increment,
    incrementBefore: $d89c9137a3d237c2$var$incrementBefore,
    inspector: $d89c9137a3d237c2$var$inspector,
    instance: $d89c9137a3d237c2$var$instance,
    instanceIndex: $d89c9137a3d237c2$var$instanceIndex,
    instancedArray: $d89c9137a3d237c2$var$instancedArray,
    instancedBufferAttribute: $d89c9137a3d237c2$var$instancedBufferAttribute,
    instancedDynamicBufferAttribute: $d89c9137a3d237c2$var$instancedDynamicBufferAttribute,
    instancedMesh: $d89c9137a3d237c2$var$instancedMesh,
    int: $d89c9137a3d237c2$var$int,
    intBitsToFloat: $d89c9137a3d237c2$var$intBitsToFloat,
    interleavedGradientNoise: $d89c9137a3d237c2$var$interleavedGradientNoise,
    inverse: $d89c9137a3d237c2$var$inverse,
    inverseSqrt: $d89c9137a3d237c2$var$inverseSqrt,
    inversesqrt: $d89c9137a3d237c2$var$inversesqrt,
    invocationLocalIndex: $d89c9137a3d237c2$var$invocationLocalIndex,
    invocationSubgroupIndex: $d89c9137a3d237c2$var$invocationSubgroupIndex,
    ior: $d89c9137a3d237c2$var$ior,
    iridescence: $d89c9137a3d237c2$var$iridescence,
    iridescenceIOR: $d89c9137a3d237c2$var$iridescenceIOR,
    iridescenceThickness: $d89c9137a3d237c2$var$iridescenceThickness,
    isolate: $d89c9137a3d237c2$var$isolate,
    ivec2: $d89c9137a3d237c2$var$ivec2,
    ivec3: $d89c9137a3d237c2$var$ivec3,
    ivec4: $d89c9137a3d237c2$var$ivec4,
    js: $d89c9137a3d237c2$var$js,
    label: $d89c9137a3d237c2$var$label,
    length: $d89c9137a3d237c2$var$length,
    lengthSq: $d89c9137a3d237c2$var$lengthSq,
    lessThan: $d89c9137a3d237c2$var$lessThan,
    lessThanEqual: $d89c9137a3d237c2$var$lessThanEqual,
    lightPosition: $d89c9137a3d237c2$var$lightPosition,
    lightProjectionUV: $d89c9137a3d237c2$var$lightProjectionUV,
    lightShadowMatrix: $d89c9137a3d237c2$var$lightShadowMatrix,
    lightTargetDirection: $d89c9137a3d237c2$var$lightTargetDirection,
    lightTargetPosition: $d89c9137a3d237c2$var$lightTargetPosition,
    lightViewPosition: $d89c9137a3d237c2$var$lightViewPosition,
    lightingContext: $d89c9137a3d237c2$var$lightingContext,
    lights: $d89c9137a3d237c2$var$lights,
    linearDepth: $d89c9137a3d237c2$var$linearDepth,
    linearToneMapping: $d89c9137a3d237c2$var$linearToneMapping,
    localId: $d89c9137a3d237c2$var$localId,
    log: $d89c9137a3d237c2$var$log,
    log2: $d89c9137a3d237c2$var$log2,
    logarithmicDepthToViewZ: $d89c9137a3d237c2$var$logarithmicDepthToViewZ,
    luminance: $d89c9137a3d237c2$var$luminance,
    mat2: $d89c9137a3d237c2$var$mat2,
    mat3: $d89c9137a3d237c2$var$mat3,
    mat4: $d89c9137a3d237c2$var$mat4,
    matcapUV: $d89c9137a3d237c2$var$matcapUV,
    materialAO: $d89c9137a3d237c2$var$materialAO,
    materialAlphaTest: $d89c9137a3d237c2$var$materialAlphaTest,
    materialAnisotropy: $d89c9137a3d237c2$var$materialAnisotropy,
    materialAnisotropyVector: $d89c9137a3d237c2$var$materialAnisotropyVector,
    materialAttenuationColor: $d89c9137a3d237c2$var$materialAttenuationColor,
    materialAttenuationDistance: $d89c9137a3d237c2$var$materialAttenuationDistance,
    materialClearcoat: $d89c9137a3d237c2$var$materialClearcoat,
    materialClearcoatNormal: $d89c9137a3d237c2$var$materialClearcoatNormal,
    materialClearcoatRoughness: $d89c9137a3d237c2$var$materialClearcoatRoughness,
    materialColor: $d89c9137a3d237c2$var$materialColor,
    materialDispersion: $d89c9137a3d237c2$var$materialDispersion,
    materialEmissive: $d89c9137a3d237c2$var$materialEmissive,
    materialEnvIntensity: $d89c9137a3d237c2$var$materialEnvIntensity,
    materialEnvRotation: $d89c9137a3d237c2$var$materialEnvRotation,
    materialIOR: $d89c9137a3d237c2$var$materialIOR,
    materialIridescence: $d89c9137a3d237c2$var$materialIridescence,
    materialIridescenceIOR: $d89c9137a3d237c2$var$materialIridescenceIOR,
    materialIridescenceThickness: $d89c9137a3d237c2$var$materialIridescenceThickness,
    materialLightMap: $d89c9137a3d237c2$var$materialLightMap,
    materialLineDashOffset: $d89c9137a3d237c2$var$materialLineDashOffset,
    materialLineDashSize: $d89c9137a3d237c2$var$materialLineDashSize,
    materialLineGapSize: $d89c9137a3d237c2$var$materialLineGapSize,
    materialLineScale: $d89c9137a3d237c2$var$materialLineScale,
    materialLineWidth: $d89c9137a3d237c2$var$materialLineWidth,
    materialMetalness: $d89c9137a3d237c2$var$materialMetalness,
    materialNormal: $d89c9137a3d237c2$var$materialNormal,
    materialOpacity: $d89c9137a3d237c2$var$materialOpacity,
    materialPointSize: $d89c9137a3d237c2$var$materialPointSize,
    materialReference: $d89c9137a3d237c2$var$materialReference,
    materialReflectivity: $d89c9137a3d237c2$var$materialReflectivity,
    materialRefractionRatio: $d89c9137a3d237c2$var$materialRefractionRatio,
    materialRotation: $d89c9137a3d237c2$var$materialRotation,
    materialRoughness: $d89c9137a3d237c2$var$materialRoughness,
    materialSheen: $d89c9137a3d237c2$var$materialSheen,
    materialSheenRoughness: $d89c9137a3d237c2$var$materialSheenRoughness,
    materialShininess: $d89c9137a3d237c2$var$materialShininess,
    materialSpecular: $d89c9137a3d237c2$var$materialSpecular,
    materialSpecularColor: $d89c9137a3d237c2$var$materialSpecularColor,
    materialSpecularIntensity: $d89c9137a3d237c2$var$materialSpecularIntensity,
    materialSpecularStrength: $d89c9137a3d237c2$var$materialSpecularStrength,
    materialThickness: $d89c9137a3d237c2$var$materialThickness,
    materialTransmission: $d89c9137a3d237c2$var$materialTransmission,
    max: $d89c9137a3d237c2$var$max$1,
    maxMipLevel: $d89c9137a3d237c2$var$maxMipLevel,
    mediumpModelViewMatrix: $d89c9137a3d237c2$var$mediumpModelViewMatrix,
    metalness: $d89c9137a3d237c2$var$metalness,
    min: $d89c9137a3d237c2$var$min$1,
    mix: $d89c9137a3d237c2$var$mix,
    mixElement: $d89c9137a3d237c2$var$mixElement,
    mod: $d89c9137a3d237c2$var$mod,
    modInt: $d89c9137a3d237c2$var$modInt,
    modelDirection: $d89c9137a3d237c2$var$modelDirection,
    modelNormalMatrix: $d89c9137a3d237c2$var$modelNormalMatrix,
    modelPosition: $d89c9137a3d237c2$var$modelPosition,
    modelRadius: $d89c9137a3d237c2$var$modelRadius,
    modelScale: $d89c9137a3d237c2$var$modelScale,
    modelViewMatrix: $d89c9137a3d237c2$var$modelViewMatrix,
    modelViewPosition: $d89c9137a3d237c2$var$modelViewPosition,
    modelViewProjection: $d89c9137a3d237c2$var$modelViewProjection,
    modelWorldMatrix: $d89c9137a3d237c2$var$modelWorldMatrix,
    modelWorldMatrixInverse: $d89c9137a3d237c2$var$modelWorldMatrixInverse,
    morphReference: $d89c9137a3d237c2$var$morphReference,
    mrt: $d89c9137a3d237c2$var$mrt,
    mul: $d89c9137a3d237c2$var$mul,
    mx_aastep: $d89c9137a3d237c2$var$mx_aastep,
    mx_add: $d89c9137a3d237c2$var$mx_add,
    mx_atan2: $d89c9137a3d237c2$var$mx_atan2,
    mx_cell_noise_float: $d89c9137a3d237c2$var$mx_cell_noise_float,
    mx_contrast: $d89c9137a3d237c2$var$mx_contrast,
    mx_divide: $d89c9137a3d237c2$var$mx_divide,
    mx_fractal_noise_float: $d89c9137a3d237c2$var$mx_fractal_noise_float,
    mx_fractal_noise_vec2: $d89c9137a3d237c2$var$mx_fractal_noise_vec2,
    mx_fractal_noise_vec3: $d89c9137a3d237c2$var$mx_fractal_noise_vec3,
    mx_fractal_noise_vec4: $d89c9137a3d237c2$var$mx_fractal_noise_vec4,
    mx_frame: $d89c9137a3d237c2$var$mx_frame,
    mx_heighttonormal: $d89c9137a3d237c2$var$mx_heighttonormal,
    mx_hsvtorgb: $d89c9137a3d237c2$var$mx_hsvtorgb,
    mx_ifequal: $d89c9137a3d237c2$var$mx_ifequal,
    mx_ifgreater: $d89c9137a3d237c2$var$mx_ifgreater,
    mx_ifgreatereq: $d89c9137a3d237c2$var$mx_ifgreatereq,
    mx_invert: $d89c9137a3d237c2$var$mx_invert,
    mx_modulo: $d89c9137a3d237c2$var$mx_modulo,
    mx_multiply: $d89c9137a3d237c2$var$mx_multiply,
    mx_noise_float: $d89c9137a3d237c2$var$mx_noise_float,
    mx_noise_vec3: $d89c9137a3d237c2$var$mx_noise_vec3,
    mx_noise_vec4: $d89c9137a3d237c2$var$mx_noise_vec4,
    mx_place2d: $d89c9137a3d237c2$var$mx_place2d,
    mx_power: $d89c9137a3d237c2$var$mx_power,
    mx_ramp4: $d89c9137a3d237c2$var$mx_ramp4,
    mx_ramplr: $d89c9137a3d237c2$var$mx_ramplr,
    mx_ramptb: $d89c9137a3d237c2$var$mx_ramptb,
    mx_rgbtohsv: $d89c9137a3d237c2$var$mx_rgbtohsv,
    mx_rotate2d: $d89c9137a3d237c2$var$mx_rotate2d,
    mx_rotate3d: $d89c9137a3d237c2$var$mx_rotate3d,
    mx_safepower: $d89c9137a3d237c2$var$mx_safepower,
    mx_separate: $d89c9137a3d237c2$var$mx_separate,
    mx_splitlr: $d89c9137a3d237c2$var$mx_splitlr,
    mx_splittb: $d89c9137a3d237c2$var$mx_splittb,
    mx_srgb_texture_to_lin_rec709: $d89c9137a3d237c2$var$mx_srgb_texture_to_lin_rec709,
    mx_subtract: $d89c9137a3d237c2$var$mx_subtract,
    mx_timer: $d89c9137a3d237c2$var$mx_timer,
    mx_transform_uv: $d89c9137a3d237c2$var$mx_transform_uv,
    mx_unifiednoise2d: $d89c9137a3d237c2$var$mx_unifiednoise2d,
    mx_unifiednoise3d: $d89c9137a3d237c2$var$mx_unifiednoise3d,
    mx_worley_noise_float: $d89c9137a3d237c2$var$mx_worley_noise_float,
    mx_worley_noise_vec2: $d89c9137a3d237c2$var$mx_worley_noise_vec2,
    mx_worley_noise_vec3: $d89c9137a3d237c2$var$mx_worley_noise_vec3,
    negate: $d89c9137a3d237c2$var$negate,
    neutralToneMapping: $d89c9137a3d237c2$var$neutralToneMapping,
    nodeArray: $d89c9137a3d237c2$var$nodeArray,
    nodeImmutable: $d89c9137a3d237c2$var$nodeImmutable,
    nodeObject: $d89c9137a3d237c2$var$nodeObject,
    nodeObjectIntent: $d89c9137a3d237c2$var$nodeObjectIntent,
    nodeObjects: $d89c9137a3d237c2$var$nodeObjects,
    nodeProxy: $d89c9137a3d237c2$var$nodeProxy,
    nodeProxyIntent: $d89c9137a3d237c2$var$nodeProxyIntent,
    normalFlat: $d89c9137a3d237c2$var$normalFlat,
    normalGeometry: $d89c9137a3d237c2$var$normalGeometry,
    normalLocal: $d89c9137a3d237c2$var$normalLocal,
    normalMap: $d89c9137a3d237c2$var$normalMap,
    normalView: $d89c9137a3d237c2$var$normalView,
    normalViewGeometry: $d89c9137a3d237c2$var$normalViewGeometry,
    normalWorld: $d89c9137a3d237c2$var$normalWorld,
    normalWorldGeometry: $d89c9137a3d237c2$var$normalWorldGeometry,
    normalize: $d89c9137a3d237c2$var$normalize,
    not: $d89c9137a3d237c2$var$not,
    notEqual: $d89c9137a3d237c2$var$notEqual,
    numWorkgroups: $d89c9137a3d237c2$var$numWorkgroups,
    objectDirection: $d89c9137a3d237c2$var$objectDirection,
    objectGroup: $d89c9137a3d237c2$var$objectGroup,
    objectPosition: $d89c9137a3d237c2$var$objectPosition,
    objectRadius: $d89c9137a3d237c2$var$objectRadius,
    objectScale: $d89c9137a3d237c2$var$objectScale,
    objectViewPosition: $d89c9137a3d237c2$var$objectViewPosition,
    objectWorldMatrix: $d89c9137a3d237c2$var$objectWorldMatrix,
    oneMinus: $d89c9137a3d237c2$var$oneMinus,
    or: $d89c9137a3d237c2$var$or,
    orthographicDepthToViewZ: $d89c9137a3d237c2$var$orthographicDepthToViewZ,
    oscSawtooth: $d89c9137a3d237c2$var$oscSawtooth,
    oscSine: $d89c9137a3d237c2$var$oscSine,
    oscSquare: $d89c9137a3d237c2$var$oscSquare,
    oscTriangle: $d89c9137a3d237c2$var$oscTriangle,
    output: $d89c9137a3d237c2$var$output,
    outputStruct: $d89c9137a3d237c2$var$outputStruct,
    overlay: $d89c9137a3d237c2$var$overlay,
    overloadingFn: $d89c9137a3d237c2$var$overloadingFn,
    packHalf2x16: $d89c9137a3d237c2$var$packHalf2x16,
    packSnorm2x16: $d89c9137a3d237c2$var$packSnorm2x16,
    packUnorm2x16: $d89c9137a3d237c2$var$packUnorm2x16,
    parabola: $d89c9137a3d237c2$var$parabola,
    parallaxDirection: $d89c9137a3d237c2$var$parallaxDirection,
    parallaxUV: $d89c9137a3d237c2$var$parallaxUV,
    parameter: $d89c9137a3d237c2$var$parameter,
    pass: $d89c9137a3d237c2$var$pass,
    passTexture: $d89c9137a3d237c2$var$passTexture,
    pcurve: $d89c9137a3d237c2$var$pcurve,
    perspectiveDepthToViewZ: $d89c9137a3d237c2$var$perspectiveDepthToViewZ,
    pmremTexture: $d89c9137a3d237c2$var$pmremTexture,
    pointShadow: $d89c9137a3d237c2$var$pointShadow,
    pointUV: $d89c9137a3d237c2$var$pointUV,
    pointWidth: $d89c9137a3d237c2$var$pointWidth,
    positionGeometry: $d89c9137a3d237c2$var$positionGeometry,
    positionLocal: $d89c9137a3d237c2$var$positionLocal,
    positionPrevious: $d89c9137a3d237c2$var$positionPrevious,
    positionView: $d89c9137a3d237c2$var$positionView,
    positionViewDirection: $d89c9137a3d237c2$var$positionViewDirection,
    positionWorld: $d89c9137a3d237c2$var$positionWorld,
    positionWorldDirection: $d89c9137a3d237c2$var$positionWorldDirection,
    posterize: $d89c9137a3d237c2$var$posterize,
    pow: $d89c9137a3d237c2$var$pow,
    pow2: $d89c9137a3d237c2$var$pow2,
    pow3: $d89c9137a3d237c2$var$pow3,
    pow4: $d89c9137a3d237c2$var$pow4,
    premultiplyAlpha: $d89c9137a3d237c2$var$premultiplyAlpha,
    property: $d89c9137a3d237c2$var$property,
    quadBroadcast: $d89c9137a3d237c2$var$quadBroadcast,
    quadSwapDiagonal: $d89c9137a3d237c2$var$quadSwapDiagonal,
    quadSwapX: $d89c9137a3d237c2$var$quadSwapX,
    quadSwapY: $d89c9137a3d237c2$var$quadSwapY,
    radians: $d89c9137a3d237c2$var$radians,
    rand: $d89c9137a3d237c2$var$rand,
    range: $d89c9137a3d237c2$var$range,
    rangeFog: $d89c9137a3d237c2$var$rangeFog,
    rangeFogFactor: $d89c9137a3d237c2$var$rangeFogFactor,
    reciprocal: $d89c9137a3d237c2$var$reciprocal,
    reference: $d89c9137a3d237c2$var$reference,
    referenceBuffer: $d89c9137a3d237c2$var$referenceBuffer,
    reflect: $d89c9137a3d237c2$var$reflect,
    reflectVector: $d89c9137a3d237c2$var$reflectVector,
    reflectView: $d89c9137a3d237c2$var$reflectView,
    reflector: $d89c9137a3d237c2$var$reflector,
    refract: $d89c9137a3d237c2$var$refract,
    refractVector: $d89c9137a3d237c2$var$refractVector,
    refractView: $d89c9137a3d237c2$var$refractView,
    reinhardToneMapping: $d89c9137a3d237c2$var$reinhardToneMapping,
    remap: $d89c9137a3d237c2$var$remap,
    remapClamp: $d89c9137a3d237c2$var$remapClamp,
    renderGroup: $d89c9137a3d237c2$var$renderGroup,
    renderOutput: $d89c9137a3d237c2$var$renderOutput,
    rendererReference: $d89c9137a3d237c2$var$rendererReference,
    replaceDefaultUV: $d89c9137a3d237c2$var$replaceDefaultUV,
    rotate: $d89c9137a3d237c2$var$rotate,
    rotateUV: $d89c9137a3d237c2$var$rotateUV,
    roughness: $d89c9137a3d237c2$var$roughness,
    round: $d89c9137a3d237c2$var$round,
    rtt: $d89c9137a3d237c2$var$rtt,
    sRGBTransferEOTF: $d89c9137a3d237c2$var$sRGBTransferEOTF,
    sRGBTransferOETF: $d89c9137a3d237c2$var$sRGBTransferOETF,
    sample: $d89c9137a3d237c2$var$sample,
    sampler: $d89c9137a3d237c2$var$sampler,
    samplerComparison: $d89c9137a3d237c2$var$samplerComparison,
    saturate: $d89c9137a3d237c2$var$saturate,
    saturation: $d89c9137a3d237c2$var$saturation,
    screen: $d89c9137a3d237c2$var$screen,
    screenCoordinate: $d89c9137a3d237c2$var$screenCoordinate,
    screenDPR: $d89c9137a3d237c2$var$screenDPR,
    screenSize: $d89c9137a3d237c2$var$screenSize,
    screenUV: $d89c9137a3d237c2$var$screenUV,
    scriptable: $d89c9137a3d237c2$var$scriptable,
    scriptableValue: $d89c9137a3d237c2$var$scriptableValue,
    select: $d89c9137a3d237c2$var$select,
    setCurrentStack: $d89c9137a3d237c2$var$setCurrentStack,
    setName: $d89c9137a3d237c2$var$setName,
    shaderStages: $d89c9137a3d237c2$export$48fd793f0255b86a,
    shadow: $d89c9137a3d237c2$var$shadow,
    shadowPositionWorld: $d89c9137a3d237c2$var$shadowPositionWorld,
    shapeCircle: $d89c9137a3d237c2$var$shapeCircle,
    sharedUniformGroup: $d89c9137a3d237c2$var$sharedUniformGroup,
    sheen: $d89c9137a3d237c2$var$sheen,
    sheenRoughness: $d89c9137a3d237c2$var$sheenRoughness,
    shiftLeft: $d89c9137a3d237c2$var$shiftLeft,
    shiftRight: $d89c9137a3d237c2$var$shiftRight,
    shininess: $d89c9137a3d237c2$var$shininess,
    sign: $d89c9137a3d237c2$var$sign,
    sin: $d89c9137a3d237c2$var$sin,
    sinc: $d89c9137a3d237c2$var$sinc,
    skinning: $d89c9137a3d237c2$var$skinning,
    smoothstep: $d89c9137a3d237c2$var$smoothstep,
    smoothstepElement: $d89c9137a3d237c2$var$smoothstepElement,
    specularColor: $d89c9137a3d237c2$var$specularColor,
    specularColorBlended: $d89c9137a3d237c2$var$specularColorBlended,
    specularF90: $d89c9137a3d237c2$var$specularF90,
    spherizeUV: $d89c9137a3d237c2$var$spherizeUV,
    split: $d89c9137a3d237c2$var$split,
    spritesheetUV: $d89c9137a3d237c2$var$spritesheetUV,
    sqrt: $d89c9137a3d237c2$var$sqrt,
    stack: $d89c9137a3d237c2$var$stack,
    step: $d89c9137a3d237c2$var$step,
    stepElement: $d89c9137a3d237c2$var$stepElement,
    storage: $d89c9137a3d237c2$var$storage,
    storageBarrier: $d89c9137a3d237c2$var$storageBarrier,
    storageObject: $d89c9137a3d237c2$var$storageObject,
    storageTexture: $d89c9137a3d237c2$var$storageTexture,
    string: $d89c9137a3d237c2$var$string,
    struct: $d89c9137a3d237c2$var$struct,
    sub: $d89c9137a3d237c2$var$sub,
    subBuild: $d89c9137a3d237c2$var$subBuild,
    subgroupAdd: $d89c9137a3d237c2$var$subgroupAdd,
    subgroupAll: $d89c9137a3d237c2$var$subgroupAll,
    subgroupAnd: $d89c9137a3d237c2$var$subgroupAnd,
    subgroupAny: $d89c9137a3d237c2$var$subgroupAny,
    subgroupBallot: $d89c9137a3d237c2$var$subgroupBallot,
    subgroupBroadcast: $d89c9137a3d237c2$var$subgroupBroadcast,
    subgroupBroadcastFirst: $d89c9137a3d237c2$var$subgroupBroadcastFirst,
    subgroupElect: $d89c9137a3d237c2$var$subgroupElect,
    subgroupExclusiveAdd: $d89c9137a3d237c2$var$subgroupExclusiveAdd,
    subgroupExclusiveMul: $d89c9137a3d237c2$var$subgroupExclusiveMul,
    subgroupInclusiveAdd: $d89c9137a3d237c2$var$subgroupInclusiveAdd,
    subgroupInclusiveMul: $d89c9137a3d237c2$var$subgroupInclusiveMul,
    subgroupIndex: $d89c9137a3d237c2$var$subgroupIndex,
    subgroupMax: $d89c9137a3d237c2$var$subgroupMax,
    subgroupMin: $d89c9137a3d237c2$var$subgroupMin,
    subgroupMul: $d89c9137a3d237c2$var$subgroupMul,
    subgroupOr: $d89c9137a3d237c2$var$subgroupOr,
    subgroupShuffle: $d89c9137a3d237c2$var$subgroupShuffle,
    subgroupShuffleDown: $d89c9137a3d237c2$var$subgroupShuffleDown,
    subgroupShuffleUp: $d89c9137a3d237c2$var$subgroupShuffleUp,
    subgroupShuffleXor: $d89c9137a3d237c2$var$subgroupShuffleXor,
    subgroupSize: $d89c9137a3d237c2$var$subgroupSize,
    subgroupXor: $d89c9137a3d237c2$var$subgroupXor,
    tan: $d89c9137a3d237c2$var$tan,
    tangentGeometry: $d89c9137a3d237c2$var$tangentGeometry,
    tangentLocal: $d89c9137a3d237c2$var$tangentLocal,
    tangentView: $d89c9137a3d237c2$var$tangentView,
    tangentWorld: $d89c9137a3d237c2$var$tangentWorld,
    texture: $d89c9137a3d237c2$var$texture,
    texture3D: $d89c9137a3d237c2$var$texture3D,
    texture3DLevel: $d89c9137a3d237c2$var$texture3DLevel,
    texture3DLoad: $d89c9137a3d237c2$var$texture3DLoad,
    textureBarrier: $d89c9137a3d237c2$var$textureBarrier,
    textureBicubic: $d89c9137a3d237c2$var$textureBicubic,
    textureBicubicLevel: $d89c9137a3d237c2$var$textureBicubicLevel,
    textureCubeUV: $d89c9137a3d237c2$var$textureCubeUV,
    textureLevel: $d89c9137a3d237c2$var$textureLevel,
    textureLoad: $d89c9137a3d237c2$var$textureLoad,
    textureSize: $d89c9137a3d237c2$var$textureSize,
    textureStore: $d89c9137a3d237c2$var$textureStore,
    thickness: $d89c9137a3d237c2$var$thickness,
    time: $d89c9137a3d237c2$var$time,
    toneMapping: $d89c9137a3d237c2$var$toneMapping,
    toneMappingExposure: $d89c9137a3d237c2$var$toneMappingExposure,
    toonOutlinePass: $d89c9137a3d237c2$var$toonOutlinePass,
    transformDirection: $d89c9137a3d237c2$var$transformDirection,
    transformNormal: $d89c9137a3d237c2$var$transformNormal,
    transformNormalToView: $d89c9137a3d237c2$var$transformNormalToView,
    transformedClearcoatNormalView: $d89c9137a3d237c2$var$transformedClearcoatNormalView,
    transformedNormalView: $d89c9137a3d237c2$var$transformedNormalView,
    transformedNormalWorld: $d89c9137a3d237c2$var$transformedNormalWorld,
    transmission: $d89c9137a3d237c2$var$transmission,
    transpose: $d89c9137a3d237c2$var$transpose,
    triNoise3D: $d89c9137a3d237c2$var$triNoise3D,
    triplanarTexture: $d89c9137a3d237c2$var$triplanarTexture,
    triplanarTextures: $d89c9137a3d237c2$var$triplanarTextures,
    trunc: $d89c9137a3d237c2$var$trunc,
    uint: $d89c9137a3d237c2$var$uint,
    uintBitsToFloat: $d89c9137a3d237c2$var$uintBitsToFloat,
    uniform: $d89c9137a3d237c2$var$uniform,
    uniformArray: $d89c9137a3d237c2$var$uniformArray,
    uniformCubeTexture: $d89c9137a3d237c2$var$uniformCubeTexture,
    uniformFlow: $d89c9137a3d237c2$var$uniformFlow,
    uniformGroup: $d89c9137a3d237c2$var$uniformGroup,
    uniformTexture: $d89c9137a3d237c2$var$uniformTexture,
    unpackHalf2x16: $d89c9137a3d237c2$var$unpackHalf2x16,
    unpackNormal: $d89c9137a3d237c2$var$unpackNormal,
    unpackSnorm2x16: $d89c9137a3d237c2$var$unpackSnorm2x16,
    unpackUnorm2x16: $d89c9137a3d237c2$var$unpackUnorm2x16,
    unpremultiplyAlpha: $d89c9137a3d237c2$var$unpremultiplyAlpha,
    userData: $d89c9137a3d237c2$var$userData,
    uv: $d89c9137a3d237c2$var$uv$1,
    uvec2: $d89c9137a3d237c2$var$uvec2,
    uvec3: $d89c9137a3d237c2$var$uvec3,
    uvec4: $d89c9137a3d237c2$var$uvec4,
    varying: $d89c9137a3d237c2$var$varying,
    varyingProperty: $d89c9137a3d237c2$var$varyingProperty,
    vec2: $d89c9137a3d237c2$var$vec2,
    vec3: $d89c9137a3d237c2$var$vec3,
    vec4: $d89c9137a3d237c2$var$vec4,
    vectorComponents: $d89c9137a3d237c2$export$1c0adcb9073b646d,
    velocity: $d89c9137a3d237c2$var$velocity,
    vertexColor: $d89c9137a3d237c2$var$vertexColor,
    vertexIndex: $d89c9137a3d237c2$var$vertexIndex,
    vertexStage: $d89c9137a3d237c2$var$vertexStage,
    vibrance: $d89c9137a3d237c2$var$vibrance,
    viewZToLogarithmicDepth: $d89c9137a3d237c2$var$viewZToLogarithmicDepth,
    viewZToOrthographicDepth: $d89c9137a3d237c2$var$viewZToOrthographicDepth,
    viewZToPerspectiveDepth: $d89c9137a3d237c2$var$viewZToPerspectiveDepth,
    viewport: $d89c9137a3d237c2$var$viewport,
    viewportCoordinate: $d89c9137a3d237c2$var$viewportCoordinate,
    viewportDepthTexture: $d89c9137a3d237c2$var$viewportDepthTexture,
    viewportLinearDepth: $d89c9137a3d237c2$var$viewportLinearDepth,
    viewportMipTexture: $d89c9137a3d237c2$var$viewportMipTexture,
    viewportResolution: $d89c9137a3d237c2$var$viewportResolution,
    viewportSafeUV: $d89c9137a3d237c2$var$viewportSafeUV,
    viewportSharedTexture: $d89c9137a3d237c2$var$viewportSharedTexture,
    viewportSize: $d89c9137a3d237c2$var$viewportSize,
    viewportTexture: $d89c9137a3d237c2$var$viewportTexture,
    viewportUV: $d89c9137a3d237c2$var$viewportUV,
    vogelDiskSample: $d89c9137a3d237c2$var$vogelDiskSample,
    wgsl: $d89c9137a3d237c2$var$wgsl,
    wgslFn: $d89c9137a3d237c2$var$wgslFn,
    workgroupArray: $d89c9137a3d237c2$var$workgroupArray,
    workgroupBarrier: $d89c9137a3d237c2$var$workgroupBarrier,
    workgroupId: $d89c9137a3d237c2$var$workgroupId,
    workingToColorSpace: $d89c9137a3d237c2$var$workingToColorSpace,
    xor: $d89c9137a3d237c2$var$xor
});
const $d89c9137a3d237c2$var$_clearColor = /*@__PURE__*/ new $d89c9137a3d237c2$var$Color4();
/**
 * This renderer module manages the background.
 *
 * @private
 * @augments DataMap
 */ class $d89c9137a3d237c2$var$Background extends $d89c9137a3d237c2$var$DataMap {
    /**
	 * Constructs a new background management component.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {Nodes} nodes - Renderer component for managing nodes related logic.
	 */ constructor(renderer, nodes){
        super();
        /**
		 * The renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {Nodes}
		 */ this.nodes = nodes;
    }
    /**
	 * Updates the background for the given scene. Depending on how `Scene.background`
	 * or `Scene.backgroundNode` are configured, this method might configure a simple clear
	 * or add a mesh to the render list for rendering the background as a textured plane
	 * or skybox.
	 *
	 * @param {Scene} scene - The scene.
	 * @param {RenderList} renderList - The current render list.
	 * @param {RenderContext} renderContext - The current render context.
	 */ update(scene, renderList, renderContext) {
        const renderer = this.renderer;
        const background = this.nodes.getBackgroundNode(scene) || scene.background;
        let forceClear = false;
        if (background === null) {
            // no background settings, use clear color configuration from the renderer
            renderer._clearColor.getRGB($d89c9137a3d237c2$var$_clearColor);
            $d89c9137a3d237c2$var$_clearColor.a = renderer._clearColor.a;
        } else if (background.isColor === true) {
            // background is an opaque color
            background.getRGB($d89c9137a3d237c2$var$_clearColor);
            $d89c9137a3d237c2$var$_clearColor.a = 1;
            forceClear = true;
        } else if (background.isNode === true) {
            const sceneData = this.get(scene);
            const backgroundNode = background;
            $d89c9137a3d237c2$var$_clearColor.copy(renderer._clearColor);
            let backgroundMesh = sceneData.backgroundMesh;
            if (backgroundMesh === undefined) {
                const backgroundMeshNode = $d89c9137a3d237c2$var$vec4(backgroundNode).mul($d89c9137a3d237c2$var$backgroundIntensity).context({
                    // @TODO: Add Texture2D support using node context
                    getUV: ()=>$d89c9137a3d237c2$var$backgroundRotation.mul($d89c9137a3d237c2$var$normalWorldGeometry),
                    getTextureLevel: ()=>$d89c9137a3d237c2$var$backgroundBlurriness
                });
                // when using orthographic cameras, we must scale the skybox sphere
                // up to exceed the dimensions of the camera's viewing box.
                const isOrtho = $d89c9137a3d237c2$var$cameraProjectionMatrix.element(3).element(3).equal(1.0);
                // calculate the orthographic scale
                // projectionMatrix[1][1] is (1 / top). Invert it to get the height and multiply by 3.0
                // (an arbitrary safety factor) to ensure the skybox is large enough to cover the corners
                // of the rectangular screen
                const orthoScale = $d89c9137a3d237c2$var$div(1.0, $d89c9137a3d237c2$var$cameraProjectionMatrix.element(1).element(1)).mul(3.0);
                // compute vertex position
                const modifiedPosition = isOrtho.select($d89c9137a3d237c2$var$positionLocal.mul(orthoScale), $d89c9137a3d237c2$var$positionLocal);
                // By using a w component of 0, the skybox will not translate when the camera moves through the scene
                let viewProj = $d89c9137a3d237c2$var$cameraProjectionMatrix.mul($d89c9137a3d237c2$var$modelViewMatrix.mul($d89c9137a3d237c2$var$vec4(modifiedPosition, 0.0)));
                // force background to far plane so it does not occlude objects
                viewProj = viewProj.setZ(viewProj.w);
                const nodeMaterial = new $d89c9137a3d237c2$export$caaf3b30a544c946();
                nodeMaterial.name = 'Background.material';
                nodeMaterial.side = (0, $329ek.BackSide);
                nodeMaterial.depthTest = false;
                nodeMaterial.depthWrite = false;
                nodeMaterial.allowOverride = false;
                nodeMaterial.fog = false;
                nodeMaterial.lights = false;
                nodeMaterial.vertexNode = viewProj;
                nodeMaterial.colorNode = backgroundMeshNode;
                sceneData.backgroundMeshNode = backgroundMeshNode;
                sceneData.backgroundMesh = backgroundMesh = new (0, $329ek.Mesh)(new (0, $329ek.SphereGeometry)(1, 32, 32), nodeMaterial);
                backgroundMesh.frustumCulled = false;
                backgroundMesh.name = 'Background.mesh';
                function onBackgroundDispose() {
                    background.removeEventListener('dispose', onBackgroundDispose);
                    backgroundMesh.material.dispose();
                    backgroundMesh.geometry.dispose();
                }
                background.addEventListener('dispose', onBackgroundDispose);
            }
            const backgroundCacheKey = backgroundNode.getCacheKey();
            if (sceneData.backgroundCacheKey !== backgroundCacheKey) {
                sceneData.backgroundMeshNode.node = $d89c9137a3d237c2$var$vec4(backgroundNode).mul($d89c9137a3d237c2$var$backgroundIntensity);
                sceneData.backgroundMeshNode.needsUpdate = true;
                backgroundMesh.material.needsUpdate = true;
                sceneData.backgroundCacheKey = backgroundCacheKey;
            }
            renderList.unshift(backgroundMesh, backgroundMesh.geometry, backgroundMesh.material, 0, 0, null, null);
        } else (0, $329ek.error)('Renderer: Unsupported background configuration.', background);
        //
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') $d89c9137a3d237c2$var$_clearColor.set(0, 0, 0, 1);
        else if (environmentBlendMode === 'alpha-blend') $d89c9137a3d237c2$var$_clearColor.set(0, 0, 0, 0);
        //
        if (renderer.autoClear === true || forceClear === true) {
            const clearColorValue = renderContext.clearColorValue;
            clearColorValue.r = $d89c9137a3d237c2$var$_clearColor.r;
            clearColorValue.g = $d89c9137a3d237c2$var$_clearColor.g;
            clearColorValue.b = $d89c9137a3d237c2$var$_clearColor.b;
            clearColorValue.a = $d89c9137a3d237c2$var$_clearColor.a;
            // premultiply alpha
            if (renderer.backend.isWebGLBackend === true || renderer.alpha === true) {
                clearColorValue.r *= clearColorValue.a;
                clearColorValue.g *= clearColorValue.a;
                clearColorValue.b *= clearColorValue.a;
            }
            //
            renderContext.depthClearValue = renderer._clearDepth;
            renderContext.stencilClearValue = renderer._clearStencil;
            renderContext.clearColor = renderer.autoClearColor === true;
            renderContext.clearDepth = renderer.autoClearDepth === true;
            renderContext.clearStencil = renderer.autoClearStencil === true;
        } else {
            renderContext.clearColor = false;
            renderContext.clearDepth = false;
            renderContext.clearStencil = false;
        }
    }
}
let $d89c9137a3d237c2$var$_id$7 = 0;
/**
 * A bind group represents a collection of bindings and thus a collection
 * or resources. Bind groups are assigned to pipelines to provide them
 * with the required resources (like uniform buffers or textures).
 *
 * @private
 */ class $d89c9137a3d237c2$var$BindGroup {
    /**
	 * Constructs a new bind group.
	 *
	 * @param {string} name - The bind group's name.
	 * @param {Array<Binding>} bindings - An array of bindings.
	 * @param {number} index - The group index.
	 * @param {Array<Binding>} bindingsReference - An array of reference bindings.
	 */ constructor(name = '', bindings = [], index = 0, bindingsReference = []){
        /**
		 * The bind group's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * An array of bindings.
		 *
		 * @type {Array<Binding>}
		 */ this.bindings = bindings;
        /**
		 * The group index.
		 *
		 * @type {number}
		 */ this.index = index;
        /**
		 * An array of reference bindings.
		 *
		 * @type {Array<Binding>}
		 */ this.bindingsReference = bindingsReference;
        /**
		 * The group's ID.
		 *
		 * @type {number}
		 */ this.id = $d89c9137a3d237c2$var$_id$7++;
    }
}
/**
 * This module represents the state of a node builder after it was
 * used to build the nodes for a render object. The state holds the
 * results of the build for further processing in the renderer.
 *
 * Render objects with identical cache keys share the same node builder state.
 *
 * @private
 */ class $d89c9137a3d237c2$var$NodeBuilderState {
    /**
	 * Constructs a new node builder state.
	 *
	 * @param {string} vertexShader - The native vertex shader code.
	 * @param {string} fragmentShader - The native fragment shader code.
	 * @param {string} computeShader - The native compute shader code.
	 * @param {Array<NodeAttribute>} nodeAttributes - An array of node attributes.
	 * @param {Array<BindGroup>} bindings - An array of bind groups.
	 * @param {Array<Node>} updateNodes - An array of nodes that implement their `update()` method.
	 * @param {Array<Node>} updateBeforeNodes - An array of nodes that implement their `updateBefore()` method.
	 * @param {Array<Node>} updateAfterNodes - An array of nodes that implement their `updateAfter()` method.
	 * @param {NodeMaterialObserver} observer - A node material observer.
	 * @param {Array<Object>} transforms - An array with transform attribute objects. Only relevant when using compute shaders with WebGL 2.
	 */ constructor(vertexShader, fragmentShader, computeShader, nodeAttributes, bindings, updateNodes, updateBeforeNodes, updateAfterNodes, observer, transforms = []){
        /**
		 * The native vertex shader code.
		 *
		 * @type {string}
		 */ this.vertexShader = vertexShader;
        /**
		 * The native fragment shader code.
		 *
		 * @type {string}
		 */ this.fragmentShader = fragmentShader;
        /**
		 * The native compute shader code.
		 *
		 * @type {string}
		 */ this.computeShader = computeShader;
        /**
		 * An array with transform attribute objects.
		 * Only relevant when using compute shaders with WebGL 2.
		 *
		 * @type {Array<Object>}
		 */ this.transforms = transforms;
        /**
		 * An array of node attributes representing
		 * the attributes of the shaders.
		 *
		 * @type {Array<NodeAttribute>}
		 */ this.nodeAttributes = nodeAttributes;
        /**
		 * An array of bind groups representing the uniform or storage
		 * buffers, texture or samplers of the shader.
		 *
		 * @type {Array<BindGroup>}
		 */ this.bindings = bindings;
        /**
		 * An array of nodes that implement their `update()` method.
		 *
		 * @type {Array<Node>}
		 */ this.updateNodes = updateNodes;
        /**
		 * An array of nodes that implement their `updateBefore()` method.
		 *
		 * @type {Array<Node>}
		 */ this.updateBeforeNodes = updateBeforeNodes;
        /**
		 * An array of nodes that implement their `updateAfter()` method.
		 *
		 * @type {Array<Node>}
		 */ this.updateAfterNodes = updateAfterNodes;
        /**
		 * A node material observer.
		 *
		 * @type {NodeMaterialObserver}
		 */ this.observer = observer;
        /**
		 * How often this state is used by render objects.
		 *
		 * @type {number}
		 */ this.usedTimes = 0;
    }
    /**
	 * This method is used to create a array of bind groups based
	 * on the existing bind groups of this state. Shared groups are
	 * not cloned.
	 *
	 * @return {Array<BindGroup>} A array of bind groups.
	 */ createBindings() {
        const bindings = [];
        for (const instanceGroup of this.bindings){
            const shared = instanceGroup.bindings[0].groupNode.shared; // All bindings in the group must have the same groupNode.
            if (shared !== true) {
                const bindingsGroup = new $d89c9137a3d237c2$var$BindGroup(instanceGroup.name, [], instanceGroup.index, instanceGroup.bindingsReference);
                bindings.push(bindingsGroup);
                for (const instanceBinding of instanceGroup.bindings)bindingsGroup.bindings.push(instanceBinding.clone());
            } else bindings.push(instanceGroup);
        }
        return bindings;
    }
}
/**
 * {@link NodeBuilder} is going to create instances of this class during the build process
 * of nodes. They represent the final shader attributes that are going to be generated
 * by the builder. Arrays of node attributes is maintained in {@link NodeBuilder#attributes}
 * and {@link NodeBuilder#bufferAttributes} for this purpose.
 */ class $d89c9137a3d237c2$export$7a439a3cecb5f184 {
    /**
	 * Constructs a new node attribute.
	 *
	 * @param {string} name - The name of the attribute.
	 * @param {string} type - The type of the attribute.
	 * @param {?Node} node - An optional reference to the node.
	 */ constructor(name, type, node = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeAttribute = true;
        /**
		 * The name of the attribute.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The type of the attribute.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 * An optional reference to the node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.node = node;
    }
}
/**
 * {@link NodeBuilder} is going to create instances of this class during the build process
 * of nodes. They represent the final shader uniforms that are going to be generated
 * by the builder. A dictionary of node uniforms is maintained in {@link NodeBuilder#uniforms}
 * for this purpose.
 */ class $d89c9137a3d237c2$export$68c170317a5fc074 {
    /**
	 * Constructs a new node uniform.
	 *
	 * @param {string} name - The name of the uniform.
	 * @param {string} type - The type of the uniform.
	 * @param {UniformNode} node - An reference to the node.
	 */ constructor(name, type, node){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeUniform = true;
        /**
		 * The name of the uniform.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The type of the uniform.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 * An reference to the node.
		 *
		 * @type {UniformNode}
		 */ this.node = node;
    }
    /**
	 * The value of the uniform node.
	 *
	 * @type {any}
	 */ get value() {
        return this.node.value;
    }
    set value(val) {
        this.node.value = val;
    }
    /**
	 * The id of the uniform node.
	 *
	 * @type {number}
	 */ get id() {
        return this.node.id;
    }
    /**
	 * The uniform node's group.
	 *
	 * @type {UniformGroupNode}
	 */ get groupNode() {
        return this.node.groupNode;
    }
}
/**
 * {@link NodeBuilder} is going to create instances of this class during the build process
 * of nodes. They represent the final shader variables that are going to be generated
 * by the builder. A dictionary of node variables is maintained in {@link NodeBuilder#vars} for
 * this purpose.
 */ class $d89c9137a3d237c2$export$b6d311b93c4db99a {
    /**
	 * Constructs a new node variable.
	 *
	 * @param {string} name - The name of the variable.
	 * @param {string} type - The type of the variable.
	 * @param {boolean} [readOnly=false] - The read-only flag.
	 * @param {?number} [count=null] - The size.
	 */ constructor(name, type, readOnly = false, count = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeVar = true;
        /**
		 * The name of the variable.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The type of the variable.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 *  The read-only flag.
		 *
		 * @type {boolean}
		 */ this.readOnly = readOnly;
        /**
		 * The size.
		 *
		 * @type {?number}
		 */ this.count = count;
    }
}
/**
 * {@link NodeBuilder} is going to create instances of this class during the build process
 * of nodes. They represent the final shader varyings that are going to be generated
 * by the builder. An array of node varyings is maintained in {@link NodeBuilder#varyings} for
 * this purpose.
 *
 * @augments NodeVar
 */ class $d89c9137a3d237c2$export$486c6ccd7c84a9e3 extends $d89c9137a3d237c2$export$b6d311b93c4db99a {
    /**
	 * Constructs a new node varying.
	 *
	 * @param {string} name - The name of the varying.
	 * @param {string} type - The type of the varying.
	 * @param {?string} interpolationType - The interpolation type of the varying.
	 * @param {?string} interpolationSampling - The interpolation sampling type of the varying.
	 */ constructor(name, type, interpolationType = null, interpolationSampling = null){
        super(name, type);
        /**
		 * Whether this varying requires interpolation or not. This property can be used
		 * to check if the varying can be optimized for a variable.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsInterpolation = false;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeVarying = true;
        /**
		 * The interpolation type of the varying data.
		 *
		 * @type {?string}
		 * @default null
		 */ this.interpolationType = interpolationType;
        /**
		 * The interpolation sampling type of varying data.
		 *
		 * @type {?string}
		 * @default null
		 */ this.interpolationSampling = interpolationSampling;
    }
}
/**
 * {@link NodeBuilder} is going to create instances of this class during the build process
 * of nodes. They represent user-defined, native shader code portions that are going to be
 * injected by the builder. A dictionary of node codes is maintained in {@link NodeBuilder#codes}
 * for this purpose.
 */ class $d89c9137a3d237c2$export$46b16f31af73381b {
    /**
	 * Constructs a new code node.
	 *
	 * @param {string} name - The name of the code.
	 * @param {string} type - The node type.
	 * @param {string} [code=''] - The native shader code.
	 */ constructor(name, type, code = ''){
        /**
		 * The name of the code.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The node type.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 * The native shader code.
		 *
		 * @type {string}
		 * @default ''
		 */ this.code = code;
        Object.defineProperty(this, 'isNodeCode', {
            value: true
        });
    }
}
let $d89c9137a3d237c2$var$_id$6 = 0;
/**
 * This utility class is used in {@link NodeBuilder} as an internal
 * cache data structure for node data.
 */ class $d89c9137a3d237c2$export$1d1d74a0a581fcfd {
    /**
	 * Constructs a new node cache.
	 *
	 * @param {?NodeCache} parent - A reference to a parent cache.
	 */ constructor(parent = null){
        /**
		 * The id of the cache.
		 *
		 * @type {number}
		 * @readonly
		 */ this.id = $d89c9137a3d237c2$var$_id$6++;
        /**
		 * A weak map for managing node data.
		 *
		 * @type {WeakMap<Node, Object>}
		 */ this.nodesData = new WeakMap();
        /**
		 * Reference to a parent node cache.
		 *
		 * @type {?NodeCache}
		 * @default null
		 */ this.parent = parent;
    }
    /**
	 * Returns the data for the given node.
	 *
	 * @param {Node} node - The node.
	 * @return {?Object} The data for the node.
	 */ getData(node) {
        let data = this.nodesData.get(node);
        if (data === undefined && this.parent !== null) data = this.parent.getData(node);
        return data;
    }
    /**
	 * Sets the data for a given node.
	 *
	 * @param {Node} node - The node.
	 * @param {Object} data - The data that should be cached.
	 */ setData(node, data) {
        this.nodesData.set(node, data);
    }
}
class $d89c9137a3d237c2$var$StructType {
    constructor(name, members){
        this.name = name;
        this.members = members;
        this.output = false;
    }
}
/**
 * Abstract base class for uniforms.
 *
 * @abstract
 * @private
 */ class $d89c9137a3d237c2$var$Uniform {
    /**
	 * Constructs a new uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {any} value - The uniform's value.
	 */ constructor(name, value){
        /**
		 * The uniform's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The uniform's value.
		 *
		 * @type {any}
		 */ this.value = value;
        /**
		 * Used to build the uniform buffer according to the STD140 layout.
		 * Derived uniforms will set this property to a data type specific
		 * value.
		 *
		 * @type {number}
		 */ this.boundary = 0;
        /**
		 * The item size. Derived uniforms will set this property to a data
		 * type specific value.
		 *
		 * @type {number}
		 */ this.itemSize = 0;
        /**
		 * This property is set by {@link UniformsGroup} and marks
		 * the start position in the uniform buffer.
		 *
		 * @type {number}
		 */ this.offset = 0;
    }
    /**
	 * Sets the uniform's value.
	 *
	 * @param {any} value - The value to set.
	 */ setValue(value) {
        this.value = value;
    }
    /**
	 * Returns the uniform's value.
	 *
	 * @return {any} The value.
	 */ getValue() {
        return this.value;
    }
}
/**
 * Represents a Number uniform.
 *
 * @private
 * @augments Uniform
 */ class $d89c9137a3d237c2$var$NumberUniform extends $d89c9137a3d237c2$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {number} value - The uniform's value.
	 */ constructor(name, value = 0){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNumberUniform = true;
        this.boundary = 4;
        this.itemSize = 1;
    }
}
/**
 * Represents a Vector2 uniform.
 *
 * @private
 * @augments Uniform
 */ class $d89c9137a3d237c2$var$Vector2Uniform extends $d89c9137a3d237c2$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Vector2} value - The uniform's value.
	 */ constructor(name, value = new (0, $329ek.Vector2)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVector2Uniform = true;
        this.boundary = 8;
        this.itemSize = 2;
    }
}
/**
 * Represents a Vector3 uniform.
 *
 * @private
 * @augments Uniform
 */ class $d89c9137a3d237c2$var$Vector3Uniform extends $d89c9137a3d237c2$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Vector3} value - The uniform's value.
	 */ constructor(name, value = new (0, $329ek.Vector3)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVector3Uniform = true;
        this.boundary = 16;
        this.itemSize = 3;
    }
}
/**
 * Represents a Vector4 uniform.
 *
 * @private
 * @augments Uniform
 */ class $d89c9137a3d237c2$var$Vector4Uniform extends $d89c9137a3d237c2$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Vector4} value - The uniform's value.
	 */ constructor(name, value = new (0, $329ek.Vector4)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVector4Uniform = true;
        this.boundary = 16;
        this.itemSize = 4;
    }
}
/**
 * Represents a Color uniform.
 *
 * @private
 * @augments Uniform
 */ class $d89c9137a3d237c2$var$ColorUniform extends $d89c9137a3d237c2$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Color} value - The uniform's value.
	 */ constructor(name, value = new (0, $329ek.Color)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isColorUniform = true;
        this.boundary = 16;
        this.itemSize = 3;
    }
}
/**
 * Represents a Matrix2 uniform.
 *
 * @private
 * @augments Uniform
 */ class $d89c9137a3d237c2$var$Matrix2Uniform extends $d89c9137a3d237c2$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Matrix2} value - The uniform's value.
	 */ constructor(name, value = new (0, $329ek.Matrix2)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMatrix2Uniform = true;
        this.boundary = 8;
        this.itemSize = 4;
    }
}
/**
 * Represents a Matrix3 uniform.
 *
 * @private
 * @augments Uniform
 */ class $d89c9137a3d237c2$var$Matrix3Uniform extends $d89c9137a3d237c2$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Matrix3} value - The uniform's value.
	 */ constructor(name, value = new (0, $329ek.Matrix3)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMatrix3Uniform = true;
        this.boundary = 48;
        this.itemSize = 12;
    }
}
/**
 * Represents a Matrix4 uniform.
 *
 * @private
 * @augments Uniform
 */ class $d89c9137a3d237c2$var$Matrix4Uniform extends $d89c9137a3d237c2$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Matrix4} value - The uniform's value.
	 */ constructor(name, value = new (0, $329ek.Matrix4)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMatrix4Uniform = true;
        this.boundary = 64;
        this.itemSize = 16;
    }
}
/**
 * A special form of Number uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments NumberUniform
 */ class $d89c9137a3d237c2$var$NumberNodeUniform extends $d89c9137a3d237c2$var$NumberUniform {
    /**
	 * Constructs a new node-based Number uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {number} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Vector2 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Vector2Uniform
 */ class $d89c9137a3d237c2$var$Vector2NodeUniform extends $d89c9137a3d237c2$var$Vector2Uniform {
    /**
	 * Constructs a new node-based Vector2 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Vector2} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Vector3 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Vector3Uniform
 */ class $d89c9137a3d237c2$var$Vector3NodeUniform extends $d89c9137a3d237c2$var$Vector3Uniform {
    /**
	 * Constructs a new node-based Vector3 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Vector3} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Vector4 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Vector4Uniform
 */ class $d89c9137a3d237c2$var$Vector4NodeUniform extends $d89c9137a3d237c2$var$Vector4Uniform {
    /**
	 * Constructs a new node-based Vector4 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Vector4} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Color uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments ColorUniform
 */ class $d89c9137a3d237c2$var$ColorNodeUniform extends $d89c9137a3d237c2$var$ColorUniform {
    /**
	 * Constructs a new node-based Color uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Color} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Matrix2 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Matrix2Uniform
 */ class $d89c9137a3d237c2$var$Matrix2NodeUniform extends $d89c9137a3d237c2$var$Matrix2Uniform {
    /**
	 * Constructs a new node-based Matrix2 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Matrix2} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Matrix3 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Matrix3Uniform
 */ class $d89c9137a3d237c2$var$Matrix3NodeUniform extends $d89c9137a3d237c2$var$Matrix3Uniform {
    /**
	 * Constructs a new node-based Matrix3 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Matrix3} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Matrix4 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Matrix4Uniform
 */ class $d89c9137a3d237c2$var$Matrix4NodeUniform extends $d89c9137a3d237c2$var$Matrix4Uniform {
    /**
	 * Constructs a new node-based Matrix4 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Matrix4} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
let $d89c9137a3d237c2$var$_id$5 = 0;
const $d89c9137a3d237c2$var$sharedNodeData = new WeakMap();
const $d89c9137a3d237c2$var$rendererCache = new WeakMap();
const $d89c9137a3d237c2$var$typeFromArray = new Map([
    [
        Int8Array,
        'int'
    ],
    [
        Int16Array,
        'int'
    ],
    [
        Int32Array,
        'int'
    ],
    [
        Uint8Array,
        'uint'
    ],
    [
        Uint16Array,
        'uint'
    ],
    [
        Uint32Array,
        'uint'
    ],
    [
        Float32Array,
        'float'
    ]
]);
const $d89c9137a3d237c2$var$toFloat = (value)=>{
    if (/e/g.test(value)) return String(value).replace(/\+/g, '');
    else {
        value = Number(value);
        return value + (value % 1 ? '' : '.0');
    }
};
/**
 * Base class for builders which generate a shader program based
 * on a 3D object and its node material definition.
 */ class $d89c9137a3d237c2$export$e3bd53a4d3c1a94e {
    /**
	 * Constructs a new node builder.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Renderer} renderer - The current renderer.
	 * @param {NodeParser} parser - A reference to a node parser.
	 */ constructor(object, renderer, parser){
        /**
		 * The 3D object.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The material of the 3D object.
		 *
		 * @type {?Material}
		 */ this.material = object && object.material || null;
        /**
		 * The geometry of the 3D object.
		 *
		 * @type {?BufferGeometry}
		 */ this.geometry = object && object.geometry || null;
        /**
		 * The current renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * A reference to a node parser.
		 *
		 * @type {NodeParser}
		 */ this.parser = parser;
        /**
		 * The scene the 3D object belongs to.
		 *
		 * @type {?Scene}
		 * @default null
		 */ this.scene = null;
        /**
		 * The camera the 3D object is rendered with.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * A list of all nodes the builder is processing
		 * for this 3D object.
		 *
		 * @type {Array<Node>}
		 */ this.nodes = [];
        /**
		 * A list of all sequential nodes.
		 *
		 * @type {Array<Node>}
		 */ this.sequentialNodes = [];
        /**
		 * A list of all nodes which {@link Node#update} method should be executed.
		 *
		 * @type {Array<Node>}
		 */ this.updateNodes = [];
        /**
		 * A list of all nodes which {@link Node#updateBefore} method should be executed.
		 *
		 * @type {Array<Node>}
		 */ this.updateBeforeNodes = [];
        /**
		 * A list of all nodes which {@link Node#updateAfter} method should be executed.
		 *
		 * @type {Array<Node>}
		 */ this.updateAfterNodes = [];
        /**
		 * A dictionary that assigns each node to a unique hash.
		 *
		 * @type {Object<number,Node>}
		 */ this.hashNodes = {};
        /**
		 * A reference to a node material observer.
		 *
		 * @type {?NodeMaterialObserver}
		 * @default null
		 */ this.observer = null;
        /**
		 * A reference to the current lights node.
		 *
		 * @type {?LightsNode}
		 * @default null
		 */ this.lightsNode = null;
        /**
		 * A reference to the current environment node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.environmentNode = null;
        /**
		 * A reference to the current fog node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.fogNode = null;
        /**
		 * The current clipping context.
		 *
		 * @type {?ClippingContext}
		 */ this.clippingContext = null;
        /**
		 * The generated vertex shader.
		 *
		 * @type {?string}
		 */ this.vertexShader = null;
        /**
		 * The generated fragment shader.
		 *
		 * @type {?string}
		 */ this.fragmentShader = null;
        /**
		 * The generated compute shader.
		 *
		 * @type {?string}
		 */ this.computeShader = null;
        /**
		 * Nodes used in the primary flow of code generation.
		 *
		 * @type {Object<string,Array<Node>>}
		 */ this.flowNodes = {
            vertex: [],
            fragment: [],
            compute: []
        };
        /**
		 * Nodes code from `.flowNodes`.
		 *
		 * @type {Object<string,string>}
		 */ this.flowCode = {
            vertex: '',
            fragment: '',
            compute: ''
        };
        /**
		 * This dictionary holds the node uniforms of the builder.
		 * The uniforms are maintained in an array for each shader stage.
		 *
		 * @type {Object}
		 */ this.uniforms = {
            vertex: [],
            fragment: [],
            compute: [],
            index: 0
        };
        /**
		 * This dictionary holds the output structs of the builder.
		 * The structs are maintained in an array for each shader stage.
		 *
		 * @type {Object}
		 */ this.structs = {
            vertex: [],
            fragment: [],
            compute: [],
            index: 0
        };
        /**
		 * This dictionary holds the types of the builder.
		 *
		 * @type {Object}
		 */ this.types = {
            vertex: [],
            fragment: [],
            compute: [],
            index: 0
        };
        /**
		 * This dictionary holds the bindings for each shader stage.
		 *
		 * @type {Object}
		 */ this.bindings = {
            vertex: {},
            fragment: {},
            compute: {}
        };
        /**
		 * This dictionary maintains the binding indices per bind group.
		 *
		 * @type {Object}
		 */ this.bindingsIndexes = {};
        /**
		 * Reference to the array of bind groups.
		 *
		 * @type {?Array<BindGroup>}
		 */ this.bindGroups = null;
        /**
		 * This array holds the node attributes of this builder
		 * created via {@link AttributeNode}.
		 *
		 * @type {Array<NodeAttribute>}
		 */ this.attributes = [];
        /**
		 * This array holds the node attributes of this builder
		 * created via {@link BufferAttributeNode}.
		 *
		 * @type {Array<NodeAttribute>}
		 */ this.bufferAttributes = [];
        /**
		 * This array holds the node varyings of this builder.
		 *
		 * @type {Array<NodeVarying>}
		 */ this.varyings = [];
        /**
		 * This dictionary holds the (native) node codes of this builder.
		 * The codes are maintained in an array for each shader stage.
		 *
		 * @type {Object<string,Array<NodeCode>>}
		 */ this.codes = {};
        /**
		 * This dictionary holds the node variables of this builder.
		 * The variables are maintained in an array for each shader stage.
		 * This dictionary is also used to count the number of variables
		 * according to their type (const, vars).
		 *
		 * @type {Object<string,Array<NodeVar>|number>}
		 */ this.vars = {};
        /**
		 * This dictionary holds the declarations for each shader stage.
		 *
		 * @type {Object}
		 */ this.declarations = {};
        /**
		 * Current code flow.
		 * All code generated in this stack will be stored in `.flow`.
		 *
		 * @type {{code: string}}
		 */ this.flow = {
            code: ''
        };
        /**
		 * A chain of nodes.
		 * Used to check recursive calls in node-graph.
		 *
		 * @type {Array<Node>}
		 */ this.chaining = [];
        /**
		 * The current stack.
		 * This reflects the current process in the code block hierarchy,
		 * it is useful to know if the current process is inside a conditional for example.
		 *
		 * @type {StackNode}
		 */ this.stack = $d89c9137a3d237c2$var$stack();
        /**
		 * List of stack nodes.
		 * The current stack hierarchy is stored in an array.
		 *
		 * @type {Array<StackNode>}
		 */ this.stacks = [];
        /**
		 * A tab value. Used for shader string generation.
		 *
		 * @type {string}
		 * @default '\t'
		 */ this.tab = '\t';
        /**
		 * Reference to the current function node.
		 *
		 * @type {?FunctionNode}
		 * @default null
		 */ this.currentFunctionNode = null;
        /**
		 * The builder's context.
		 *
		 * @type {Object}
		 */ this.context = {
            material: this.material
        };
        /**
		 * The builder's cache.
		 *
		 * @type {NodeCache}
		 */ this.cache = new $d89c9137a3d237c2$export$1d1d74a0a581fcfd();
        /**
		 * Since the {@link NodeBuilder#cache} might be temporarily
		 * overwritten by other caches, this member retains the reference
		 * to the builder's own cache.
		 *
		 * @type {NodeCache}
		 * @default this.cache
		 */ this.globalCache = this.cache;
        this.flowsData = new WeakMap();
        /**
		 * The current shader stage.
		 *
		 * @type {?('vertex'|'fragment'|'compute'|'any')}
		 */ this.shaderStage = null;
        /**
		 * The current build stage.
		 *
		 * @type {?('setup'|'analyze'|'generate')}
		 */ this.buildStage = null;
        /**
		 * The sub-build layers.
		 *
		 * @type {Array<SubBuildNode>}
		 * @default []
		 */ this.subBuildLayers = [];
        /**
		 * The active stack nodes.
		 *
		 * @type {Array<StackNode>}
		 */ this.activeStacks = [];
        /**
		 * The current sub-build TSL function(Fn).
		 *
		 * @type {?string}
		 * @default null
		 */ this.subBuildFn = null;
        /**
		 * The current TSL function(Fn) call node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.fnCall = null;
        Object.defineProperty(this, 'id', {
            value: $d89c9137a3d237c2$var$_id$5++
        });
    }
    /**
	 * Whether the material is opaque or not.
	 *
	 * @return {boolean} Whether the material is opaque or not.
	 */ isOpaque() {
        const material = this.material;
        return material.transparent === false && material.blending === (0, $329ek.NormalBlending) && material.alphaToCoverage === false;
    }
    /**
	 * Returns the bind groups of the current renderer.
	 *
	 * @return {ChainMap} The cache.
	 */ getBindGroupsCache() {
        let bindGroupsCache = $d89c9137a3d237c2$var$rendererCache.get(this.renderer);
        if (bindGroupsCache === undefined) {
            bindGroupsCache = new $d89c9137a3d237c2$var$ChainMap();
            $d89c9137a3d237c2$var$rendererCache.set(this.renderer, bindGroupsCache);
        }
        return bindGroupsCache;
    }
    /**
	 * Factory method for creating an instance of {@link RenderTarget} with the given
	 * dimensions and options.
	 *
	 * @param {number} width - The width of the render target.
	 * @param {number} height - The height of the render target.
	 * @param {Object} options - The options of the render target.
	 * @return {RenderTarget} The render target.
	 */ createRenderTarget(width, height, options) {
        return new (0, $329ek.RenderTarget)(width, height, options);
    }
    /**
	 * Factory method for creating an instance of {@link CubeRenderTarget} with the given
	 * dimensions and options.
	 *
	 * @param {number} size - The size of the cube render target.
	 * @param {Object} options - The options of the cube render target.
	 * @return {CubeRenderTarget} The cube render target.
	 */ createCubeRenderTarget(size, options) {
        return new $d89c9137a3d237c2$var$CubeRenderTarget(size, options);
    }
    /**
	 * Whether the given node is included in the internal array of nodes or not.
	 *
	 * @param {Node} node - The node to test.
	 * @return {boolean} Whether the given node is included in the internal array of nodes or not.
	 */ includes(node) {
        return this.nodes.includes(node);
    }
    /**
	 * Returns the output struct name which is required by
	 * {@link OutputStructNode}.
	 *
	 * @abstract
	 * @return {string} The name of the output struct.
	 */ getOutputStructName() {}
    /**
	 * Returns a bind group for the given group name and binding.
	 *
	 * @private
	 * @param {string} groupName - The group name.
	 * @param {Array<NodeUniformsGroup>} bindings - List of bindings.
	 * @return {BindGroup} The bind group
	 */ _getBindGroup(groupName, bindings) {
        const bindGroupsCache = this.getBindGroupsCache();
        //
        const bindingsArray = [];
        let sharedGroup = true;
        for (const binding of bindings){
            bindingsArray.push(binding);
            sharedGroup = sharedGroup && binding.groupNode.shared !== true;
        }
        //
        let bindGroup;
        if (sharedGroup) {
            bindGroup = bindGroupsCache.get(bindingsArray);
            if (bindGroup === undefined) {
                bindGroup = new $d89c9137a3d237c2$var$BindGroup(groupName, bindingsArray, this.bindingsIndexes[groupName].group, bindingsArray);
                bindGroupsCache.set(bindingsArray, bindGroup);
            }
        } else bindGroup = new $d89c9137a3d237c2$var$BindGroup(groupName, bindingsArray, this.bindingsIndexes[groupName].group, bindingsArray);
        return bindGroup;
    }
    /**
	 * Returns an array of node uniform groups for the given group name and shader stage.
	 *
	 * @param {string} groupName - The group name.
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {Array<NodeUniformsGroup>} The array of node uniform groups.
	 */ getBindGroupArray(groupName, shaderStage) {
        const bindings = this.bindings[shaderStage];
        let bindGroup = bindings[groupName];
        if (bindGroup === undefined) {
            if (this.bindingsIndexes[groupName] === undefined) this.bindingsIndexes[groupName] = {
                binding: 0,
                group: Object.keys(this.bindingsIndexes).length
            };
            bindings[groupName] = bindGroup = [];
        }
        return bindGroup;
    }
    /**
	 * Returns a list bindings of all shader stages separated by groups.
	 *
	 * @return {Array<BindGroup>} The list of bindings.
	 */ getBindings() {
        let bindingsGroups = this.bindGroups;
        if (bindingsGroups === null) {
            const groups = {};
            const bindings = this.bindings;
            for (const shaderStage of $d89c9137a3d237c2$export$48fd793f0255b86a)for(const groupName in bindings[shaderStage]){
                const uniforms = bindings[shaderStage][groupName];
                const groupUniforms = groups[groupName] || (groups[groupName] = []);
                groupUniforms.push(...uniforms);
            }
            bindingsGroups = [];
            for(const groupName in groups){
                const group = groups[groupName];
                const bindingsGroup = this._getBindGroup(groupName, group);
                bindingsGroups.push(bindingsGroup);
            }
            this.bindGroups = bindingsGroups;
        }
        return bindingsGroups;
    }
    /**
	 * Sorts the bind groups and updates {@link NodeBuilder#bindingsIndexes}.
	 */ sortBindingGroups() {
        const bindingsGroups = this.getBindings();
        bindingsGroups.sort((a, b)=>a.bindings[0].groupNode.order - b.bindings[0].groupNode.order);
        for(let i = 0; i < bindingsGroups.length; i++){
            const bindingGroup = bindingsGroups[i];
            this.bindingsIndexes[bindingGroup.name].group = i;
            bindingGroup.index = i;
        }
    }
    /**
	 * The builder maintains each node in a hash-based dictionary.
	 * This method sets the given node (value) with the given hash (key) into this dictionary.
	 *
	 * @param {Node} node - The node to add.
	 * @param {number} hash - The hash of the node.
	 */ setHashNode(node, hash) {
        this.hashNodes[hash] = node;
    }
    /**
	 * Adds a node to this builder.
	 *
	 * @param {Node} node - The node to add.
	 */ addNode(node) {
        if (this.nodes.includes(node) === false) {
            this.nodes.push(node);
            this.setHashNode(node, node.getHash(this));
        }
    }
    /**
	 * It is used to add Nodes that will be used as FRAME and RENDER events,
	 * and need to follow a certain sequence in the calls to work correctly.
	 * This function should be called after 'setup()' in the 'build()' process to ensure that the child nodes are processed first.
	 *
	 * @param {Node} node - The node to add.
	 */ addSequentialNode(node) {
        if (this.sequentialNodes.includes(node) === false) this.sequentialNodes.push(node);
    }
    /**
	 * Checks the update types of nodes
	 */ buildUpdateNodes() {
        for (const node of this.nodes){
            const updateType = node.getUpdateType();
            if (updateType !== $d89c9137a3d237c2$export$26f7a8bbd9469530.NONE) this.updateNodes.push(node);
        }
        for (const node of this.sequentialNodes){
            const updateBeforeType = node.getUpdateBeforeType();
            const updateAfterType = node.getUpdateAfterType();
            if (updateBeforeType !== $d89c9137a3d237c2$export$26f7a8bbd9469530.NONE) this.updateBeforeNodes.push(node);
            if (updateAfterType !== $d89c9137a3d237c2$export$26f7a8bbd9469530.NONE) this.updateAfterNodes.push(node);
        }
    }
    /**
	 * A reference the current node which is the
	 * last node in the chain of nodes.
	 *
	 * @type {Node}
	 */ get currentNode() {
        return this.chaining[this.chaining.length - 1];
    }
    /**
	 * Whether the given texture is filtered or not.
	 *
	 * @param {Texture} texture - The texture to check.
	 * @return {boolean} Whether the given texture is filtered or not.
	 */ isFilteredTexture(texture) {
        return texture.magFilter === (0, $329ek.LinearFilter) || texture.magFilter === (0, $329ek.LinearMipmapNearestFilter) || texture.magFilter === (0, $329ek.NearestMipmapLinearFilter) || texture.magFilter === (0, $329ek.LinearMipmapLinearFilter) || texture.minFilter === (0, $329ek.LinearFilter) || texture.minFilter === (0, $329ek.LinearMipmapNearestFilter) || texture.minFilter === (0, $329ek.NearestMipmapLinearFilter) || texture.minFilter === (0, $329ek.LinearMipmapLinearFilter);
    }
    /**
	 * Adds the given node to the internal node chain.
	 * This is used to check recursive calls in node-graph.
	 *
	 * @param {Node} node - The node to add.
	 */ addChain(node) {
        /*
		if ( this.chaining.indexOf( node ) !== - 1 ) {

			warn( 'Recursive node: ', node );

		}
		*/ this.chaining.push(node);
    }
    /**
	 * Removes the given node from the internal node chain.
	 *
	 * @param {Node} node - The node to remove.
	 */ removeChain(node) {
        const lastChain = this.chaining.pop();
        if (lastChain !== node) throw new Error('NodeBuilder: Invalid node chaining!');
    }
    /**
	 * Returns the native shader method name for a given generic name. E.g.
	 * the method name `textureDimensions` matches the WGSL name but must be
	 * resolved to `textureSize` in GLSL.
	 *
	 * @abstract
	 * @param {string} method - The method name to resolve.
	 * @return {string} The resolved method name.
	 */ getMethod(method) {
        return method;
    }
    /**
	 * Returns the native snippet for a ternary operation. E.g. GLSL would output
	 * a ternary op as `cond ? x : y` whereas WGSL would output it as `select(y, x, cond)`
	 *
	 * @abstract
	 * @param {string} condSnippet - The condition determining which expression gets resolved.
	 * @param {string} ifSnippet - The expression to resolve to if the condition is true.
	 * @param {string} elseSnippet - The expression to resolve to if the condition is false.
	 * @return {string} The resolved method name.
	 */ getTernary() {
        return null;
    }
    /**
	 * Returns a node for the given hash, see {@link NodeBuilder#setHashNode}.
	 *
	 * @param {number} hash - The hash of the node.
	 * @return {Node} The found node.
	 */ getNodeFromHash(hash) {
        return this.hashNodes[hash];
    }
    /**
	 * Adds the Node to a target flow so that it can generate code in the 'generate' process.
	 *
	 * @param {('vertex'|'fragment'|'compute')} shaderStage - The shader stage.
	 * @param {Node} node - The node to add.
	 * @return {Node} The node.
	 */ addFlow(shaderStage, node) {
        this.flowNodes[shaderStage].push(node);
        return node;
    }
    /**
	 * Sets builder's context.
	 *
	 * @param {Object} context - The context to set.
	 */ setContext(context) {
        this.context = context;
    }
    /**
	 * Returns the builder's current context.
	 *
	 * @return {Object} The builder's current context.
	 */ getContext() {
        return this.context;
    }
    /**
	 * Adds context data to the builder's current context.
	 *
	 * @param {Object} context - The context to add.
	 * @return {Object} The previous context.
	 */ addContext(context) {
        const previousContext = this.getContext();
        this.setContext({
            ...this.context,
            ...context
        });
        return previousContext;
    }
    /**
	 * Gets a context used in shader construction that can be shared across different materials.
	 * This is necessary since the renderer cache can reuse shaders generated in one material and use them in another.
	 *
	 * @return {Object} The builder's current context without material.
	 */ getSharedContext() {
        const context = {
            ...this.context
        };
        delete context.material;
        delete context.getUV;
        delete context.getOutput;
        delete context.getTextureLevel;
        delete context.getAO;
        delete context.getShadow;
        return context;
    }
    /**
	 * Sets builder's cache.
	 *
	 * @param {NodeCache} cache - The cache to set.
	 */ setCache(cache) {
        this.cache = cache;
    }
    /**
	 * Returns the builder's current cache.
	 *
	 * @return {NodeCache} The builder's current cache.
	 */ getCache() {
        return this.cache;
    }
    /**
	 * Returns a cache for the given node.
	 *
	 * @param {Node} node - The node.
	 * @param {boolean} [parent=true] - Whether this node refers to a shared parent cache or not.
	 * @return {NodeCache} The cache.
	 */ getCacheFromNode(node, parent = true) {
        const data = this.getDataFromNode(node);
        if (data.cache === undefined) data.cache = new $d89c9137a3d237c2$export$1d1d74a0a581fcfd(parent ? this.getCache() : null);
        return data.cache;
    }
    /**
	 * Whether the requested feature is available or not.
	 *
	 * @abstract
	 * @param {string} name - The requested feature.
	 * @return {boolean} Whether the requested feature is supported or not.
	 */ isAvailable() {
        return false;
    }
    /**
	 * Returns the vertexIndex input variable as a native shader string.
	 *
	 * @abstract
	 * @return {string} The instanceIndex shader string.
	 */ getVertexIndex() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Contextually returns either the vertex stage instance index builtin
	 * or the linearized index of an compute invocation within a grid of workgroups.
	 *
	 * @abstract
	 * @return {string} The instanceIndex shader string.
	 */ getInstanceIndex() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Returns the drawIndex input variable as a native shader string.
	 * Only relevant for WebGL and its `WEBGL_multi_draw` extension.
	 *
	 * @abstract
	 * @return {?string} The drawIndex shader string.
	 */ getDrawIndex() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Returns the frontFacing input variable as a native shader string.
	 *
	 * @abstract
	 * @return {string} The frontFacing shader string.
	 */ getFrontFacing() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Returns the fragCoord input variable as a native shader string.
	 *
	 * @abstract
	 * @return {string} The fragCoord shader string.
	 */ getFragCoord() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Whether to flip texture data along its vertical axis or not. WebGL needs
	 * this method evaluate to `true`, WebGPU to `false`.
	 *
	 * @abstract
	 * @return {boolean} Whether to flip texture data along its vertical axis or not.
	 */ isFlipY() {
        return false;
    }
    /**
	 * Calling this method increases the usage count for the given node by one.
	 *
	 * @param {Node} node - The node to increase the usage count for.
	 * @return {number} The updated usage count.
	 */ increaseUsage(node) {
        const nodeData = this.getDataFromNode(node);
        nodeData.usageCount = nodeData.usageCount === undefined ? 1 : nodeData.usageCount + 1;
        return nodeData.usageCount;
    }
    /**
	 * Generates a texture sample shader string for the given texture data.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The texture property name.
	 * @param {string} uvSnippet - Snippet defining the texture coordinates.
	 * @return {string} The generated shader string.
	 */ generateTexture() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Generates a texture LOD shader string for the given texture data.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The texture property name.
	 * @param {string} uvSnippet - Snippet defining the texture coordinates.
	 * @param {?string} depthSnippet - Snippet defining the 0-based texture array index to sample.
	 * @param {string} levelSnippet - Snippet defining the mip level.
	 * @return {string} The generated shader string.
	 */ generateTextureLod() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Generates the array declaration string.
	 *
	 * @param {string} type - The type.
	 * @param {?number} [count] - The count.
	 * @return {string} The generated value as a shader string.
	 */ generateArrayDeclaration(type, count) {
        return this.getType(type) + '[ ' + count + ' ]';
    }
    /**
	 * Generates the array shader string for the given type and value.
	 *
	 * @param {string} type - The type.
	 * @param {?number} [count] - The count.
	 * @param {?Array<Node>} [values=null] - The default values.
	 * @return {string} The generated value as a shader string.
	 */ generateArray(type, count, values = null) {
        let snippet = this.generateArrayDeclaration(type, count) + '( ';
        for(let i = 0; i < count; i++){
            const value = values ? values[i] : null;
            if (value !== null) snippet += value.build(this, type);
            else snippet += this.generateConst(type);
            if (i < count - 1) snippet += ', ';
        }
        snippet += ' )';
        return snippet;
    }
    /**
	 * Generates the struct shader string.
	 *
	 * @param {string} type - The type.
	 * @param {Array<Object>} [membersLayout] - The count.
	 * @param {?Array<Node>} [values=null] - The default values.
	 * @return {string} The generated value as a shader string.
	 */ generateStruct(type, membersLayout, values = null) {
        const snippets = [];
        for (const member of membersLayout){
            const { name: name, type: type } = member;
            if (values && values[name] && values[name].isNode) snippets.push(values[name].build(this, type));
            else snippets.push(this.generateConst(type));
        }
        return type + '( ' + snippets.join(', ') + ' )';
    }
    /**
	 * Generates the shader string for the given type and value.
	 *
	 * @param {string} type - The type.
	 * @param {?any} [value=null] - The value.
	 * @return {string} The generated value as a shader string.
	 */ generateConst(type, value = null) {
        if (value === null) {
            if (type === 'float' || type === 'int' || type === 'uint') value = 0;
            else if (type === 'bool') value = false;
            else if (type === 'color') value = new (0, $329ek.Color)();
            else if (type === 'vec2' || type === 'uvec2' || type === 'ivec2') value = new (0, $329ek.Vector2)();
            else if (type === 'vec3' || type === 'uvec3' || type === 'ivec3') value = new (0, $329ek.Vector3)();
            else if (type === 'vec4' || type === 'uvec4' || type === 'ivec4') value = new (0, $329ek.Vector4)();
        }
        if (type === 'float') return $d89c9137a3d237c2$var$toFloat(value);
        if (type === 'int') return `${Math.round(value)}`;
        if (type === 'uint') return value >= 0 ? `${Math.round(value)}u` : '0u';
        if (type === 'bool') return value ? 'true' : 'false';
        if (type === 'color') return `${this.getType('vec3')}( ${$d89c9137a3d237c2$var$toFloat(value.r)}, ${$d89c9137a3d237c2$var$toFloat(value.g)}, ${$d89c9137a3d237c2$var$toFloat(value.b)} )`;
        const typeLength = this.getTypeLength(type);
        const componentType = this.getComponentType(type);
        const generateConst = (value)=>this.generateConst(componentType, value);
        if (typeLength === 2) return `${this.getType(type)}( ${generateConst(value.x)}, ${generateConst(value.y)} )`;
        else if (typeLength === 3) return `${this.getType(type)}( ${generateConst(value.x)}, ${generateConst(value.y)}, ${generateConst(value.z)} )`;
        else if (typeLength === 4 && type !== 'mat2') return `${this.getType(type)}( ${generateConst(value.x)}, ${generateConst(value.y)}, ${generateConst(value.z)}, ${generateConst(value.w)} )`;
        else if (typeLength >= 4 && value && (value.isMatrix2 || value.isMatrix3 || value.isMatrix4)) return `${this.getType(type)}( ${value.elements.map(generateConst).join(', ')} )`;
        else if (typeLength > 4) return `${this.getType(type)}()`;
        throw new Error(`NodeBuilder: Type '${type}' not found in generate constant attempt.`);
    }
    /**
	 * It might be necessary to convert certain data types to different ones
	 * so this method can be used to hide the conversion.
	 *
	 * @param {string} type - The type.
	 * @return {string} The updated type.
	 */ getType(type) {
        if (type === 'color') return 'vec3';
        return type;
    }
    /**
	 * Whether the given attribute name is defined in the geometry or not.
	 *
	 * @param {string} name - The attribute name.
	 * @return {boolean} Whether the given attribute name is defined in the geometry.
	 */ hasGeometryAttribute(name) {
        return this.geometry && this.geometry.getAttribute(name) !== undefined;
    }
    /**
	 * Returns a node attribute for the given name and type.
	 *
	 * @param {string} name - The attribute's name.
	 * @param {string} type - The attribute's type.
	 * @return {NodeAttribute} The node attribute.
	 */ getAttribute(name, type) {
        const attributes = this.attributes;
        // find attribute
        for (const attribute of attributes){
            if (attribute.name === name) return attribute;
        }
        // create a new if no exist
        const attribute = new $d89c9137a3d237c2$export$7a439a3cecb5f184(name, type);
        this.registerDeclaration(attribute);
        attributes.push(attribute);
        return attribute;
    }
    /**
	 * Returns for the given node and shader stage the property name for the shader.
	 *
	 * @param {Node} node - The node.
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {string} The property name.
	 */ getPropertyName(node /*, shaderStage*/ ) {
        return node.name;
    }
    /**
	 * Whether the given type is a vector type or not.
	 *
	 * @param {string} type - The type to check.
	 * @return {boolean} Whether the given type is a vector type or not.
	 */ isVector(type) {
        return /vec\d/.test(type);
    }
    /**
	 * Whether the given type is a matrix type or not.
	 *
	 * @param {string} type - The type to check.
	 * @return {boolean} Whether the given type is a matrix type or not.
	 */ isMatrix(type) {
        return /mat\d/.test(type);
    }
    /**
	 * Whether the given type is a reference type or not.
	 *
	 * @param {string} type - The type to check.
	 * @return {boolean} Whether the given type is a reference type or not.
	 */ isReference(type) {
        return type === 'void' || type === 'property' || type === 'sampler' || type === 'samplerComparison' || type === 'texture' || type === 'cubeTexture' || type === 'storageTexture' || type === 'depthTexture' || type === 'texture3D';
    }
    /**
	 * Checks if the given texture requires a manual conversion to the working color space.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture to check.
	 * @return {boolean} Whether the given texture requires a conversion to working color space or not.
	 */ needsToWorkingColorSpace() {
        return false;
    }
    /**
	 * Returns the component type of a given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {string} The component type.
	 */ getComponentTypeFromTexture(texture) {
        const type = texture.type;
        if (texture.isDataTexture) {
            if (type === (0, $329ek.IntType)) return 'int';
            if (type === (0, $329ek.UnsignedIntType)) return 'uint';
        }
        return 'float';
    }
    /**
	 * Returns the element type for a given type.
	 *
	 * @param {string} type - The type.
	 * @return {string} The element type.
	 */ getElementType(type) {
        if (type === 'mat2') return 'vec2';
        if (type === 'mat3') return 'vec3';
        if (type === 'mat4') return 'vec4';
        return this.getComponentType(type);
    }
    /**
	 * Returns the component type for a given type.
	 *
	 * @param {string} type - The type.
	 * @return {string} The component type.
	 */ getComponentType(type) {
        type = this.getVectorType(type);
        if (type === 'float' || type === 'bool' || type === 'int' || type === 'uint') return type;
        const componentType = /(b|i|u|)(vec|mat)([2-4])/.exec(type);
        if (componentType === null) return null;
        if (componentType[1] === 'b') return 'bool';
        if (componentType[1] === 'i') return 'int';
        if (componentType[1] === 'u') return 'uint';
        return 'float';
    }
    /**
	 * Returns the vector type for a given type.
	 *
	 * @param {string} type - The type.
	 * @return {string} The vector type.
	 */ getVectorType(type) {
        if (type === 'color') return 'vec3';
        if (type === 'texture' || type === 'cubeTexture' || type === 'storageTexture' || type === 'texture3D') return 'vec4';
        return type;
    }
    /**
	 * Returns the data type for the given the length and component type.
	 *
	 * @param {number} length - The length.
	 * @param {string} [componentType='float'] - The component type.
	 * @return {string} The type.
	 */ getTypeFromLength(length, componentType = 'float') {
        if (length === 1) return componentType;
        let baseType = $d89c9137a3d237c2$var$getTypeFromLength(length);
        const prefix = componentType === 'float' ? '' : componentType[0];
        // fix edge case for mat2x2 being same size as vec4
        if (/mat2/.test(componentType) === true) baseType = baseType.replace('vec', 'mat');
        return prefix + baseType;
    }
    /**
	 * Returns the type for a given typed array.
	 *
	 * @param {TypedArray} array - The typed array.
	 * @return {string} The type.
	 */ getTypeFromArray(array) {
        return $d89c9137a3d237c2$var$typeFromArray.get(array.constructor);
    }
    /**
	 * Returns the type is an integer type.
	 *
	 * @param {string} type - The type.
	 * @return {boolean} Whether the type is an integer type or not.
	 */ isInteger(type) {
        return /int|uint|(i|u)vec/.test(type);
    }
    /**
	 * Returns the type for a given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 * @return {string} The type.
	 */ getTypeFromAttribute(attribute) {
        let dataAttribute = attribute;
        if (attribute.isInterleavedBufferAttribute) dataAttribute = attribute.data;
        const array = dataAttribute.array;
        const itemSize = attribute.itemSize;
        const normalized = attribute.normalized;
        let arrayType;
        if (!(attribute instanceof (0, $329ek.Float16BufferAttribute)) && normalized !== true) arrayType = this.getTypeFromArray(array);
        return this.getTypeFromLength(itemSize, arrayType);
    }
    /**
	 * Returns the length for the given data type.
	 *
	 * @param {string} type - The data type.
	 * @return {number} The length.
	 */ getTypeLength(type) {
        const vecType = this.getVectorType(type);
        const vecNum = /vec([2-4])/.exec(vecType);
        if (vecNum !== null) return Number(vecNum[1]);
        if (vecType === 'float' || vecType === 'bool' || vecType === 'int' || vecType === 'uint') return 1;
        if (/mat2/.test(type) === true) return 4;
        if (/mat3/.test(type) === true) return 9;
        if (/mat4/.test(type) === true) return 16;
        return 0;
    }
    /**
	 * Returns the vector type for a given matrix type.
	 *
	 * @param {string} type - The matrix type.
	 * @return {string} The vector type.
	 */ getVectorFromMatrix(type) {
        return type.replace('mat', 'vec');
    }
    /**
	 * For a given type this method changes the component type to the
	 * given value. E.g. `vec4` should be changed to the new component type
	 * `uint` which results in `uvec4`.
	 *
	 * @param {string} type - The type.
	 * @param {string} newComponentType - The new component type.
	 * @return {string} The new type.
	 */ changeComponentType(type, newComponentType) {
        return this.getTypeFromLength(this.getTypeLength(type), newComponentType);
    }
    /**
	 * Returns the integer type pendant for the given type.
	 *
	 * @param {string} type - The type.
	 * @return {string} The integer type.
	 */ getIntegerType(type) {
        const componentType = this.getComponentType(type);
        if (componentType === 'int' || componentType === 'uint') return type;
        return this.changeComponentType(type, 'int');
    }
    /**
	 * Adds an active stack to the internal stack.
	 *
	 * @param {StackNode} stack - The stack node to add.
	 */ setActiveStack(stack) {
        this.activeStacks.push(stack);
    }
    /**
	 * Removes the active stack from the internal stack.
	 *
	 * @param {StackNode} stack - The stack node to remove.
	 */ removeActiveStack(stack) {
        if (this.activeStacks[this.activeStacks.length - 1] === stack) this.activeStacks.pop();
        else throw new Error('NodeBuilder: Invalid active stack removal.');
    }
    /**
	 * Returns the active stack.
	 *
	 * @return {StackNode} The active stack.
	 */ getActiveStack() {
        return this.activeStacks[this.activeStacks.length - 1];
    }
    /**
	 * Returns the base stack.
	 *
	 * @return {StackNode} The base stack.
	 */ getBaseStack() {
        return this.activeStacks[0];
    }
    /**
	 * Adds a stack node to the internal stack.
	 *
	 * @return {StackNode} The added stack node.
	 */ addStack() {
        this.stack = $d89c9137a3d237c2$var$stack(this.stack);
        const previousStack = $d89c9137a3d237c2$var$getCurrentStack();
        this.stacks.push(previousStack);
        $d89c9137a3d237c2$var$setCurrentStack(this.stack);
        return this.stack;
    }
    /**
	 * Removes the last stack node from the internal stack.
	 *
	 * @return {StackNode} The removed stack node.
	 */ removeStack() {
        const lastStack = this.stack;
        for (const node of lastStack.nodes){
            const nodeData = this.getDataFromNode(node);
            nodeData.stack = lastStack;
        }
        this.stack = lastStack.parent;
        $d89c9137a3d237c2$var$setCurrentStack(this.stacks.pop());
        return lastStack;
    }
    /**
	 * The builder maintains (cached) data for each node during the building process. This method
	 * can be used to get these data for a specific shader stage and cache.
	 *
	 * @param {Node} node - The node to get the data for.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @param {?NodeCache} cache - An optional cache.
	 * @return {Object} The node data.
	 */ getDataFromNode(node, shaderStage = this.shaderStage, cache = null) {
        cache = cache === null ? node.isGlobal(this) ? this.globalCache : this.cache : cache;
        let nodeData = cache.getData(node);
        if (nodeData === undefined) {
            nodeData = {};
            cache.setData(node, nodeData);
        }
        if (nodeData[shaderStage] === undefined) nodeData[shaderStage] = {};
        //
        let data = nodeData[shaderStage];
        const subBuilds = nodeData.any ? nodeData.any.subBuilds : null;
        const subBuild = this.getClosestSubBuild(subBuilds);
        if (subBuild) {
            if (data.subBuildsCache === undefined) data.subBuildsCache = {};
            data = data.subBuildsCache[subBuild] || (data.subBuildsCache[subBuild] = {});
            data.subBuilds = subBuilds;
        }
        return data;
    }
    /**
	 * Returns the properties for the given node and shader stage.
	 *
	 * Properties are typically used within a build stage to reference a node's
	 * child node or nodes manually assigned to the properties in a separate build stage.
	 * A typical usage pattern for defining nodes manually would be assigning dependency nodes
	 * to the current node's properties in the setup stage and building those properties in the generate stage.
	 *
	 * @param {Node} node - The node to get the properties for.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage='any'] - The shader stage.
	 * @return {Object} The node properties.
	 */ getNodeProperties(node, shaderStage = 'any') {
        const nodeData = this.getDataFromNode(node, shaderStage);
        return nodeData.properties || (nodeData.properties = {
            outputNode: null
        });
    }
    /**
	 * Returns an instance of {@link NodeAttribute} for the given buffer attribute node.
	 *
	 * @param {BufferAttributeNode} node - The buffer attribute node.
	 * @param {string} type - The node type.
	 * @return {NodeAttribute} The node attribute.
	 */ getBufferAttributeFromNode(node, type) {
        const nodeData = this.getDataFromNode(node, 'vertex');
        let bufferAttribute = nodeData.bufferAttribute;
        if (bufferAttribute === undefined) {
            const index = this.uniforms.index++;
            bufferAttribute = new $d89c9137a3d237c2$export$7a439a3cecb5f184('nodeAttribute' + index, type, node);
            this.bufferAttributes.push(bufferAttribute);
            nodeData.bufferAttribute = bufferAttribute;
        }
        return bufferAttribute;
    }
    /**
	 * Returns an instance of {@link StructType} for the given struct name and shader stage
	 * or null if not found.
	 *
	 * @param {string} name - The name of the struct.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @return {?StructType} The struct type or null if not found.
	 */ getStructTypeNode(name, shaderStage = this.shaderStage) {
        return this.types[shaderStage][name] || null;
    }
    /**
	 * Returns an instance of {@link StructType} for the given output struct node.
	 *
	 * @param {OutputStructNode} node - The output struct node.
	 * @param {Array<Object>} membersLayout - The output struct types.
	 * @param {?string} [name=null] - The name of the struct.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @return {StructType} The struct type attribute.
	 */ getStructTypeFromNode(node, membersLayout, name = null, shaderStage = this.shaderStage) {
        const nodeData = this.getDataFromNode(node, shaderStage, this.globalCache);
        let structType = nodeData.structType;
        if (structType === undefined) {
            const index = this.structs.index++;
            if (name === null) name = 'StructType' + index;
            structType = new $d89c9137a3d237c2$var$StructType(name, membersLayout);
            this.structs[shaderStage].push(structType);
            this.types[shaderStage][name] = node;
            nodeData.structType = structType;
        }
        return structType;
    }
    /**
	 * Returns an instance of {@link StructType} for the given output struct node.
	 *
	 * @param {OutputStructNode} node - The output struct node.
	 * @param {Array<Object>} membersLayout - The output struct types.
	 * @return {StructType} The struct type attribute.
	 */ getOutputStructTypeFromNode(node, membersLayout) {
        const structType = this.getStructTypeFromNode(node, membersLayout, 'OutputType', 'fragment');
        structType.output = true;
        return structType;
    }
    /**
	 * Returns an instance of {@link NodeUniform} for the given uniform node.
	 *
	 * @param {UniformNode} node - The uniform node.
	 * @param {string} type - The uniform type.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @param {?string} name - The name of the uniform.
	 * @return {NodeUniform} The node uniform.
	 */ getUniformFromNode(node, type, shaderStage = this.shaderStage, name = null) {
        const nodeData = this.getDataFromNode(node, shaderStage, this.globalCache);
        let nodeUniform = nodeData.uniform;
        if (nodeUniform === undefined) {
            const index = this.uniforms.index++;
            nodeUniform = new $d89c9137a3d237c2$export$68c170317a5fc074(name || 'nodeUniform' + index, type, node);
            this.uniforms[shaderStage].push(nodeUniform);
            this.registerDeclaration(nodeUniform);
            nodeData.uniform = nodeUniform;
        }
        return nodeUniform;
    }
    /**
	 * Returns an instance of {@link NodeVar} for the given variable node.
	 *
	 * @param {VarNode} node - The variable node.
	 * @param {?string} name - The variable's name.
	 * @param {string} [type=node.getNodeType( this )] - The variable's type.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @param {boolean} [readOnly=false] - Whether the variable is read-only or not.
	 *
	 * @return {NodeVar} The node variable.
	 */ getVarFromNode(node, name = null, type = node.getNodeType(this), shaderStage = this.shaderStage, readOnly = false) {
        const nodeData = this.getDataFromNode(node, shaderStage);
        const subBuildVariable = this.getSubBuildProperty('variable', nodeData.subBuilds);
        let nodeVar = nodeData[subBuildVariable];
        if (nodeVar === undefined) {
            const idNS = readOnly ? '_const' : '_var';
            const vars = this.vars[shaderStage] || (this.vars[shaderStage] = []);
            const id = this.vars[idNS] || (this.vars[idNS] = 0);
            if (name === null) {
                name = (readOnly ? 'nodeConst' : 'nodeVar') + id;
                this.vars[idNS]++;
            }
            //
            if (subBuildVariable !== 'variable') name = this.getSubBuildProperty(name, nodeData.subBuilds);
            //
            const count = node.getArrayCount(this);
            nodeVar = new $d89c9137a3d237c2$export$b6d311b93c4db99a(name, type, readOnly, count);
            if (!readOnly) vars.push(nodeVar);
            this.registerDeclaration(nodeVar);
            nodeData[subBuildVariable] = nodeVar;
        }
        return nodeVar;
    }
    /**
	 * Returns whether a Node or its flow is deterministic, useful for use in `const`.
	 *
	 * @param {Node} node - The varying node.
	 * @return {boolean} Returns true if deterministic.
	 */ isDeterministic(node) {
        if (node.isMathNode) return this.isDeterministic(node.aNode) && (node.bNode ? this.isDeterministic(node.bNode) : true) && (node.cNode ? this.isDeterministic(node.cNode) : true);
        else if (node.isOperatorNode) return this.isDeterministic(node.aNode) && (node.bNode ? this.isDeterministic(node.bNode) : true);
        else if (node.isArrayNode) {
            if (node.values !== null) for (const n of node.values){
                if (!this.isDeterministic(n)) return false;
            }
            return true;
        } else if (node.isConstNode) return true;
        return false;
    }
    /**
	 * Returns an instance of {@link NodeVarying} for the given varying node.
	 *
	 * @param {(VaryingNode|PropertyNode)} node - The varying node.
	 * @param {?string} name - The varying's name.
	 * @param {string} [type=node.getNodeType( this )] - The varying's type.
	 * @param {?string} interpolationType - The interpolation type of the varying.
	 * @param {?string} interpolationSampling - The interpolation sampling type of the varying.
	 * @return {NodeVar} The node varying.
	 */ getVaryingFromNode(node, name = null, type = node.getNodeType(this), interpolationType = null, interpolationSampling = null) {
        const nodeData = this.getDataFromNode(node, 'any');
        const subBuildVarying = this.getSubBuildProperty('varying', nodeData.subBuilds);
        let nodeVarying = nodeData[subBuildVarying];
        if (nodeVarying === undefined) {
            const varyings = this.varyings;
            const index = varyings.length;
            if (name === null) name = 'nodeVarying' + index;
            //
            if (subBuildVarying !== 'varying') name = this.getSubBuildProperty(name, nodeData.subBuilds);
            //
            nodeVarying = new $d89c9137a3d237c2$export$486c6ccd7c84a9e3(name, type, interpolationType, interpolationSampling);
            varyings.push(nodeVarying);
            this.registerDeclaration(nodeVarying);
            nodeData[subBuildVarying] = nodeVarying;
        }
        return nodeVarying;
    }
    /**
	 * Registers a node declaration in the current shader stage.
	 *
	 * @param {Object} node - The node to be registered.
	 */ registerDeclaration(node) {
        const shaderStage = this.shaderStage;
        const declarations = this.declarations[shaderStage] || (this.declarations[shaderStage] = {});
        const property = this.getPropertyName(node);
        let index = 1;
        let name = property;
        // Automatically renames the property if the name is already in use.
        while(declarations[name] !== undefined)name = property + '_' + index++;
        if (index > 1) {
            node.name = name;
            (0, $329ek.warn)(`TSL: Declaration name '${property}' of '${node.type}' already in use. Renamed to '${name}'.`);
        }
        declarations[name] = node;
    }
    /**
	 * Returns an instance of {@link NodeCode} for the given code node.
	 *
	 * @param {CodeNode} node - The code node.
	 * @param {string} type - The node type.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @return {NodeCode} The node code.
	 */ getCodeFromNode(node, type, shaderStage = this.shaderStage) {
        const nodeData = this.getDataFromNode(node);
        let nodeCode = nodeData.code;
        if (nodeCode === undefined) {
            const codes = this.codes[shaderStage] || (this.codes[shaderStage] = []);
            const index = codes.length;
            nodeCode = new $d89c9137a3d237c2$export$46b16f31af73381b('nodeCode' + index, type);
            codes.push(nodeCode);
            nodeData.code = nodeCode;
        }
        return nodeCode;
    }
    /**
	 * Adds a code flow based on the code-block hierarchy.

	 * This is used so that code-blocks like If,Else create their variables locally if the Node
	 * is only used inside one of these conditionals in the current shader stage.
	 *
	 * @param {Node} node - The node to add.
	 * @param {Node} nodeBlock - Node-based code-block. Usually 'ConditionalNode'.
	 */ addFlowCodeHierarchy(node, nodeBlock) {
        const { flowCodes: flowCodes, flowCodeBlock: flowCodeBlock } = this.getDataFromNode(node);
        let needsFlowCode = true;
        let nodeBlockHierarchy = nodeBlock;
        while(nodeBlockHierarchy){
            if (flowCodeBlock.get(nodeBlockHierarchy) === true) {
                needsFlowCode = false;
                break;
            }
            nodeBlockHierarchy = this.getDataFromNode(nodeBlockHierarchy).parentNodeBlock;
        }
        if (needsFlowCode) for (const flowCode of flowCodes)this.addLineFlowCode(flowCode);
    }
    /**
	 * Add a inline-code to the current flow code-block.
	 *
	 * @param {Node} node - The node to add.
	 * @param {string} code - The code to add.
	 * @param {Node} nodeBlock - Current ConditionalNode
	 */ addLineFlowCodeBlock(node, code, nodeBlock) {
        const nodeData = this.getDataFromNode(node);
        const flowCodes = nodeData.flowCodes || (nodeData.flowCodes = []);
        const codeBlock = nodeData.flowCodeBlock || (nodeData.flowCodeBlock = new WeakMap());
        flowCodes.push(code);
        codeBlock.set(nodeBlock, true);
    }
    /**
	 * Add a inline-code to the current flow.
	 *
	 * @param {string} code - The code to add.
	 * @param {?Node} [node= null] - Optional Node, can help the system understand if the Node is part of a code-block.
	 * @return {NodeBuilder} A reference to this node builder.
	 */ addLineFlowCode(code, node = null) {
        if (code === '') return this;
        if (node !== null && this.context.nodeBlock) this.addLineFlowCodeBlock(node, code, this.context.nodeBlock);
        code = this.tab + code;
        if (!/;\s*$/.test(code)) code = code + ';\n';
        this.flow.code += code;
        return this;
    }
    /**
	 * Adds a code to the current code flow.
	 *
	 * @param {string} code - Shader code.
	 * @return {NodeBuilder} A reference to this node builder.
	 */ addFlowCode(code) {
        this.flow.code += code;
        return this;
    }
    /**
	 * Add tab in the code that will be generated so that other snippets respect the current tabulation.
	 * Typically used in codes with If,Else.
	 *
	 * @return {NodeBuilder} A reference to this node builder.
	 */ addFlowTab() {
        this.tab += '\t';
        return this;
    }
    /**
	 * Removes a tab.
	 *
	 * @return {NodeBuilder} A reference to this node builder.
	 */ removeFlowTab() {
        this.tab = this.tab.slice(0, -1);
        return this;
    }
    /**
	 * Gets the current flow data based on a Node.
	 *
	 * @param {Node} node - Node that the flow was started.
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {Object} The flow data.
	 */ getFlowData(node /*, shaderStage*/ ) {
        return this.flowsData.get(node);
    }
    /**
	 * Executes the node flow based on a root node to generate the final shader code.
	 *
	 * @param {Node} node - The node to execute.
	 * @return {Object} The code flow.
	 */ flowNode(node) {
        const output = node.getNodeType(this);
        const flowData = this.flowChildNode(node, output);
        this.flowsData.set(node, flowData);
        return flowData;
    }
    /**
	 * Includes a node in the current function node.
	 *
	 * @param {Node} node - The node to include.
	 * @returns {void}
	 */ addInclude(node) {
        if (this.currentFunctionNode !== null) this.currentFunctionNode.includes.push(node);
    }
    /**
	 * Returns the native shader operator name for a given generic name.
	 * It is a similar type of method like {@link NodeBuilder#getMethod}.
	 *
	 * @param {ShaderNodeInternal} shaderNode - The shader node to build the function node with.
	 * @return {FunctionNode} The build function node.
	 */ buildFunctionNode(shaderNode) {
        const fn = new $d89c9137a3d237c2$export$f2972be796679c12();
        const previous = this.currentFunctionNode;
        this.currentFunctionNode = fn;
        fn.code = this.buildFunctionCode(shaderNode);
        this.currentFunctionNode = previous;
        return fn;
    }
    /**
	 * Generates a code flow based on a TSL function: Fn().
	 *
	 * @param {ShaderNodeInternal} shaderNode - A function code will be generated based on the input.
	 * @return {Object}
	 */ flowShaderNode(shaderNode) {
        const layout = shaderNode.layout;
        const inputs = {
            [Symbol.iterator] () {
                let index = 0;
                const values = Object.values(this);
                return {
                    next: ()=>({
                            value: values[index],
                            done: index++ >= values.length
                        })
                };
            }
        };
        for (const input of layout.inputs)inputs[input.name] = new $d89c9137a3d237c2$export$4b5f01ba1aca62ad(input.type, input.name);
        //
        shaderNode.layout = null;
        const callNode = shaderNode.call(inputs);
        const flowData = this.flowStagesNode(callNode, layout.type);
        shaderNode.layout = layout;
        return flowData;
    }
    /**
	 * Executes the node in a specific build stage.
	 *
	 * This function can be used to arbitrarily execute the specified build stage
	 * outside of the standard build process. For instance, if a node's type depends
	 * on properties created by the 'setup' stage, then flowBuildStage(node, 'setup')
	 * can be used to execute the setup build stage and access its generated nodes
	 * before the standard build process begins.
	 *
	 * @param {Node} node - The node to execute.
	 * @param {string} buildStage - The build stage to execute the node in.
	 * @param {?(Node|string)} [output=null] - Expected output type. For example 'vec3'.
	 * @return {?(Node|string)} The result of the node build.
	 */ flowBuildStage(node, buildStage, output = null) {
        const previousBuildStage = this.getBuildStage();
        this.setBuildStage(buildStage);
        const result = node.build(this, output);
        this.setBuildStage(previousBuildStage);
        return result;
    }
    /**
	 * Runs the node flow through all the steps of creation, 'setup', 'analyze', 'generate'.
	 *
	 * @param {Node} node - The node to execute.
	 * @param {?string} output - Expected output type. For example 'vec3'.
	 * @return {Object}
	 */ flowStagesNode(node, output = null) {
        const previousFlow = this.flow;
        const previousVars = this.vars;
        const previousDeclarations = this.declarations;
        const previousCache = this.cache;
        const previousBuildStage = this.buildStage;
        const previousStack = this.stack;
        const flow = {
            code: ''
        };
        this.flow = flow;
        this.vars = {};
        this.declarations = {};
        this.cache = new $d89c9137a3d237c2$export$1d1d74a0a581fcfd();
        this.stack = $d89c9137a3d237c2$var$stack();
        for (const buildStage of $d89c9137a3d237c2$export$f2213ed98eb895d6){
            this.setBuildStage(buildStage);
            flow.result = node.build(this, output);
        }
        flow.vars = this.getVars(this.shaderStage);
        this.flow = previousFlow;
        this.vars = previousVars;
        this.declarations = previousDeclarations;
        this.cache = previousCache;
        this.stack = previousStack;
        this.setBuildStage(previousBuildStage);
        return flow;
    }
    /**
	 * Returns the native shader operator name for a given generic name.
	 * It is a similar type of method like {@link NodeBuilder#getMethod}.
	 *
	 * @abstract
	 * @param {string} op - The operator name to resolve.
	 * @return {?string} The resolved operator name.
	 */ getFunctionOperator() {
        return null;
    }
    /**
	 * Builds the given shader node.
	 *
	 * @abstract
	 * @param {ShaderNodeInternal} shaderNode - The shader node.
	 * @return {string} The function code.
	 */ buildFunctionCode() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Generates a code flow based on a child Node.
	 *
	 * @param {Node} node - The node to execute.
	 * @param {?string} output - Expected output type. For example 'vec3'.
	 * @return {Object} The code flow.
	 */ flowChildNode(node, output = null) {
        const previousFlow = this.flow;
        const flow = {
            code: ''
        };
        this.flow = flow;
        flow.result = node.build(this, output);
        this.flow = previousFlow;
        return flow;
    }
    /**
	 * Executes a flow of code in a different stage.
	 *
	 * Some nodes like `varying()` have the ability to compute code in vertex-stage and
	 * return the value in fragment-stage even if it is being executed in an input fragment.
	 *
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @param {Node} node - The node to execute.
	 * @param {?string} output - Expected output type. For example 'vec3'.
	 * @param {?string} propertyName - The property name to assign the result.
	 * @return {?(Object|Node)} The code flow or node.build() result.
	 */ flowNodeFromShaderStage(shaderStage, node, output = null, propertyName = null) {
        const previousTab = this.tab;
        const previousCache = this.cache;
        const previousShaderStage = this.shaderStage;
        const previousContext = this.context;
        this.setShaderStage(shaderStage);
        const context = {
            ...this.context
        };
        delete context.nodeBlock;
        this.cache = this.globalCache;
        this.tab = '\t';
        this.context = context;
        let result = null;
        if (this.buildStage === 'generate') {
            const flowData = this.flowChildNode(node, output);
            if (propertyName !== null) flowData.code += `${this.tab + propertyName} = ${flowData.result};\n`;
            this.flowCode[shaderStage] = this.flowCode[shaderStage] + flowData.code;
            result = flowData;
        } else result = node.build(this);
        this.setShaderStage(previousShaderStage);
        this.cache = previousCache;
        this.tab = previousTab;
        this.context = previousContext;
        return result;
    }
    /**
	 * Returns an array holding all node attributes of this node builder.
	 *
	 * @return {Array<NodeAttribute>} The node attributes of this builder.
	 */ getAttributesArray() {
        return this.attributes.concat(this.bufferAttributes);
    }
    /**
	 * Returns the attribute definitions as a shader string for the given shader stage.
	 *
	 * @abstract
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {string} The attribute code section.
	 */ getAttributes() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Returns the varying definitions as a shader string for the given shader stage.
	 *
	 * @abstract
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {string} The varying code section.
	 */ getVaryings() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Returns a single variable definition as a shader string for the given variable type and name.
	 *
	 * @param {string} type - The variable's type.
	 * @param {string} name - The variable's name.
	 * @param {?number} [count=null] - The array length.
	 * @return {string} The shader string.
	 */ getVar(type, name, count = null) {
        return `${count !== null ? this.generateArrayDeclaration(type, count) : this.getType(type)} ${name}`;
    }
    /**
	 * Returns the variable definitions as a shader string for the given shader stage.
	 *
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {string} The variable code section.
	 */ getVars(shaderStage) {
        let snippet = '';
        const vars = this.vars[shaderStage];
        if (vars !== undefined) for (const variable of vars)snippet += `${this.getVar(variable.type, variable.name)}; `;
        return snippet;
    }
    /**
	 * Returns the uniform definitions as a shader string for the given shader stage.
	 *
	 * @abstract
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {string} The uniform code section.
	 */ getUniforms() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Returns the native code definitions as a shader string for the given shader stage.
	 *
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {string} The native code section.
	 */ getCodes(shaderStage) {
        const codes = this.codes[shaderStage];
        let code = '';
        if (codes !== undefined) for (const nodeCode of codes)code += nodeCode.code + '\n';
        return code;
    }
    /**
	 * Returns the hash of this node builder.
	 *
	 * @return {string} The hash.
	 */ getHash() {
        return this.vertexShader + this.fragmentShader + this.computeShader;
    }
    /**
	 * Sets the current shader stage.
	 *
	 * @param {?('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage to set.
	 */ setShaderStage(shaderStage) {
        this.shaderStage = shaderStage;
    }
    /**
	 * Returns the current shader stage.
	 *
	 * @return {?('vertex'|'fragment'|'compute'|'any')} The current shader stage.
	 */ getShaderStage() {
        return this.shaderStage;
    }
    /**
	 * Sets the current build stage.
	 *
	 * @param {?('setup'|'analyze'|'generate')} buildStage - The build stage to set.
	 */ setBuildStage(buildStage) {
        this.buildStage = buildStage;
    }
    /**
	 * Returns the current build stage.
	 *
	 * @return {?('setup'|'analyze'|'generate')} The current build stage.
	 */ getBuildStage() {
        return this.buildStage;
    }
    /**
	 * Controls the code build of the shader stages.
	 *
	 * @abstract
	 */ buildCode() {
        (0, $329ek.warn)('Abstract function.');
    }
    /**
	 * Returns the current sub-build layer.
	 *
	 * @return {SubBuildNode} The current sub-build layers.
	 */ get subBuild() {
        return this.subBuildLayers[this.subBuildLayers.length - 1] || null;
    }
    /**
	 * Adds a sub-build layer to the node builder.
	 *
	 * @param {SubBuildNode} subBuild - The sub-build layer to add.
	 */ addSubBuild(subBuild) {
        this.subBuildLayers.push(subBuild);
    }
    /**
	 * Removes the last sub-build layer from the node builder.
	 *
	 * @return {SubBuildNode} The removed sub-build layer.
	 */ removeSubBuild() {
        return this.subBuildLayers.pop();
    }
    /**
	 * Returns the closest sub-build layer for the given data.
	 *
	 * @param {Node|Set<string>|Array<string>} data - The data to get the closest sub-build layer from.
	 * @return {?string} The closest sub-build name or null if none found.
	 */ getClosestSubBuild(data) {
        let subBuilds;
        if (data && data.isNode) {
            if (data.isShaderCallNodeInternal) subBuilds = data.shaderNode.subBuilds;
            else if (data.isStackNode) subBuilds = [
                data.subBuild
            ];
            else subBuilds = this.getDataFromNode(data, 'any').subBuilds;
        } else if (data instanceof Set) subBuilds = [
            ...data
        ];
        else subBuilds = data;
        if (!subBuilds) return null;
        const subBuildLayers = this.subBuildLayers;
        for(let i = subBuilds.length - 1; i >= 0; i--){
            const subBuild = subBuilds[i];
            if (subBuildLayers.includes(subBuild)) return subBuild;
        }
        return null;
    }
    /**
	 * Returns the output node of a sub-build layer.
	 *
	 * @param {Node} node - The node to get the output from.
	 * @return {string} The output node name.
	 */ getSubBuildOutput(node) {
        return this.getSubBuildProperty('outputNode', node);
    }
    /**
	 * Returns the sub-build property name for the given property and node.
	 *
	 * @param {string} [property=''] - The property name.
	 * @param {?Node} [node=null] - The node to get the sub-build from.
	 * @return {string} The sub-build property name.
	 */ getSubBuildProperty(property = '', node = null) {
        let subBuild;
        if (node !== null) subBuild = this.getClosestSubBuild(node);
        else subBuild = this.subBuildFn;
        let result;
        if (subBuild) result = property ? subBuild + '_' + property : subBuild;
        else result = property;
        return result;
    }
    /**
	 * Central build method which controls the build for the given object.
	 *
	 * @return {NodeBuilder} A reference to this node builder.
	 */ build() {
        const { object: object, material: material, renderer: renderer } = this;
        if (material !== null) {
            let nodeMaterial = renderer.library.fromMaterial(material);
            if (nodeMaterial === null) {
                (0, $329ek.error)(`NodeMaterial: Material "${material.type}" is not compatible.`);
                nodeMaterial = new $d89c9137a3d237c2$export$caaf3b30a544c946();
            }
            nodeMaterial.build(this);
        } else this.addFlow('compute', object);
        // setup() -> stage 1: create possible new nodes and/or return an output reference node
        // analyze()   -> stage 2: analyze nodes to possible optimization and validation
        // generate()  -> stage 3: generate shader
        for (const buildStage of $d89c9137a3d237c2$export$f2213ed98eb895d6){
            this.setBuildStage(buildStage);
            if (this.context.vertex && this.context.vertex.isNode) this.flowNodeFromShaderStage('vertex', this.context.vertex);
            for (const shaderStage of $d89c9137a3d237c2$export$48fd793f0255b86a){
                this.setShaderStage(shaderStage);
                const flowNodes = this.flowNodes[shaderStage];
                for (const node of flowNodes)if (buildStage === 'generate') this.flowNode(node);
                else node.build(this);
            }
        }
        this.setBuildStage(null);
        this.setShaderStage(null);
        // stage 4: build code for a specific output
        this.buildCode();
        this.buildUpdateNodes();
        return this;
    }
    /**
	 * Returns shared data object for the given node.
	 *
	 * @param {Node} node - The node to get shared data from.
	 * @return {Object} The shared data.
	 */ getSharedDataFromNode(node) {
        let data = $d89c9137a3d237c2$var$sharedNodeData.get(node);
        if (data === undefined) data = {};
        return data;
    }
    /**
	 * Returns a uniform representation which is later used for UBO generation and rendering.
	 *
	 * @param {NodeUniform} uniformNode - The uniform node.
	 * @param {string} type - The requested type.
	 * @return {Uniform} The uniform.
	 */ getNodeUniform(uniformNode, type) {
        const nodeData = this.getSharedDataFromNode(uniformNode);
        let node = nodeData.cache;
        if (node === undefined) {
            if (type === 'float' || type === 'int' || type === 'uint') node = new $d89c9137a3d237c2$var$NumberNodeUniform(uniformNode);
            else if (type === 'vec2' || type === 'ivec2' || type === 'uvec2') node = new $d89c9137a3d237c2$var$Vector2NodeUniform(uniformNode);
            else if (type === 'vec3' || type === 'ivec3' || type === 'uvec3') node = new $d89c9137a3d237c2$var$Vector3NodeUniform(uniformNode);
            else if (type === 'vec4' || type === 'ivec4' || type === 'uvec4') node = new $d89c9137a3d237c2$var$Vector4NodeUniform(uniformNode);
            else if (type === 'color') node = new $d89c9137a3d237c2$var$ColorNodeUniform(uniformNode);
            else if (type === 'mat2') node = new $d89c9137a3d237c2$var$Matrix2NodeUniform(uniformNode);
            else if (type === 'mat3') node = new $d89c9137a3d237c2$var$Matrix3NodeUniform(uniformNode);
            else if (type === 'mat4') node = new $d89c9137a3d237c2$var$Matrix4NodeUniform(uniformNode);
            else throw new Error(`Uniform "${type}" not implemented.`);
            nodeData.cache = node;
        }
        return node;
    }
    /**
	 * Formats the given shader snippet from a given type into another one. E.g.
	 * this method might be used to convert a simple float string `"1.0"` into a
	 * `vec3` representation: `"vec3<f32>( 1.0 )"`.
	 *
	 * @param {string} snippet - The shader snippet.
	 * @param {string} fromType - The source type.
	 * @param {string} toType - The target type.
	 * @return {string} The updated shader string.
	 */ format(snippet, fromType, toType) {
        fromType = this.getVectorType(fromType);
        toType = this.getVectorType(toType);
        if (fromType === toType || toType === null || this.isReference(toType)) return snippet;
        const fromTypeLength = this.getTypeLength(fromType);
        const toTypeLength = this.getTypeLength(toType);
        if (fromTypeLength === 16 && toTypeLength === 9) return `${this.getType(toType)}( ${snippet}[ 0 ].xyz, ${snippet}[ 1 ].xyz, ${snippet}[ 2 ].xyz )`;
        if (fromTypeLength === 9 && toTypeLength === 4) return `${this.getType(toType)}( ${snippet}[ 0 ].xy, ${snippet}[ 1 ].xy )`;
        if (fromTypeLength > 4) // @TODO: ignore for now
        return snippet;
        if (toTypeLength > 4 || toTypeLength === 0) // @TODO: ignore for now
        return snippet;
        if (fromTypeLength === toTypeLength) return `${this.getType(toType)}( ${snippet} )`;
        if (fromTypeLength > toTypeLength) {
            snippet = toType === 'bool' ? `all( ${snippet} )` : `${snippet}.${'xyz'.slice(0, toTypeLength)}`;
            return this.format(snippet, this.getTypeFromLength(toTypeLength, this.getComponentType(fromType)), toType);
        }
        if (toTypeLength === 4 && fromTypeLength > 1) return `${this.getType(toType)}( ${this.format(snippet, fromType, 'vec3')}, 1.0 )`;
        if (fromTypeLength === 2) return `${this.getType(toType)}( ${this.format(snippet, fromType, 'vec2')}, 0.0 )`;
        if (fromTypeLength === 1 && toTypeLength > 1 && fromType !== this.getComponentType(toType)) // convert a number value to vector type, e.g:
        // vec3( 1u ) -> vec3( float( 1u ) )
        snippet = `${this.getType(this.getComponentType(toType))}( ${snippet} )`;
        return `${this.getType(toType)}( ${snippet} )`; // fromType is float-like
    }
    /**
	 * Returns a signature with the engine's current revision.
	 *
	 * @return {string} The signature.
	 */ getSignature() {
        return `// Three.js r${0, $329ek.REVISION} - Node System\n`;
    }
}
/**
 * Management class for updating nodes. The module tracks metrics like
 * the elapsed time, delta time, the render and frame ID to correctly
 * call the node update methods {@link Node#updateBefore}, {@link Node#update}
 * and {@link Node#updateAfter} depending on the node's configuration.
 */ class $d89c9137a3d237c2$export$20d1e096ab9d190e {
    /**
	 * Constructs a new node fame.
	 */ constructor(){
        /**
		 * The elapsed time in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.time = 0;
        /**
		 * The delta time in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.deltaTime = 0;
        /**
		 * The frame ID.
		 *
		 * @type {number}
		 * @default 0
		 */ this.frameId = 0;
        /**
		 * The render ID.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderId = 0;
        /**
		 * Used to control the {@link Node#update} call.
		 *
		 * @type {WeakMap<Node, Object>}
		 */ this.updateMap = new WeakMap();
        /**
		 * Used to control the {@link Node#updateBefore} call.
		 *
		 * @type {WeakMap<Node, Object>}
		 */ this.updateBeforeMap = new WeakMap();
        /**
		 * Used to control the {@link Node#updateAfter} call.
		 *
		 * @type {WeakMap<Node, Object>}
		 */ this.updateAfterMap = new WeakMap();
        /**
		 * A reference to the current renderer.
		 *
		 * @type {?Renderer}
		 * @default null
		 */ this.renderer = null;
        /**
		 * A reference to the current material.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.material = null;
        /**
		 * A reference to the current camera.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * A reference to the current 3D object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.object = null;
        /**
		 * A reference to the current scene.
		 *
		 * @type {?Scene}
		 * @default null
		 */ this.scene = null;
    }
    /**
	 * Returns a dictionary for a given node and update map which
	 * is used to correctly call node update methods per frame or render.
	 *
	 * @private
	 * @param {WeakMap<Node, Object>} referenceMap - The reference weak map.
	 * @param {Node} nodeRef - The reference to the current node.
	 * @return {Object<string,WeakMap<Object, number>>} The dictionary.
	 */ _getMaps(referenceMap, nodeRef) {
        let maps = referenceMap.get(nodeRef);
        if (maps === undefined) {
            maps = {
                renderId: 0,
                frameId: 0
            };
            referenceMap.set(nodeRef, maps);
        }
        return maps;
    }
    /**
	 * This method executes the {@link Node#updateBefore} for the given node.
	 * It makes sure {@link Node#updateBeforeType} is honored meaning the update
	 * is only executed once per frame, render or object depending on the update
	 * type.
	 *
	 * @param {Node} node - The node that should be updated.
	 */ updateBeforeNode(node) {
        const updateType = node.getUpdateBeforeType();
        const reference = node.updateReference(this);
        if (updateType === $d89c9137a3d237c2$export$26f7a8bbd9469530.FRAME) {
            const nodeUpdateBeforeMap = this._getMaps(this.updateBeforeMap, reference);
            if (nodeUpdateBeforeMap.frameId !== this.frameId) {
                const previousFrameId = nodeUpdateBeforeMap.frameId;
                nodeUpdateBeforeMap.frameId = this.frameId;
                if (node.updateBefore(this) === false) nodeUpdateBeforeMap.frameId = previousFrameId;
            }
        } else if (updateType === $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER) {
            const nodeUpdateBeforeMap = this._getMaps(this.updateBeforeMap, reference);
            if (nodeUpdateBeforeMap.renderId !== this.renderId) {
                const previousRenderId = nodeUpdateBeforeMap.renderId;
                nodeUpdateBeforeMap.renderId = this.renderId;
                if (node.updateBefore(this) === false) nodeUpdateBeforeMap.renderId = previousRenderId;
            }
        } else if (updateType === $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT) node.updateBefore(this);
    }
    /**
	 * This method executes the {@link Node#updateAfter} for the given node.
	 * It makes sure {@link Node#updateAfterType} is honored meaning the update
	 * is only executed once per frame, render or object depending on the update
	 * type.
	 *
	 * @param {Node} node - The node that should be updated.
	 */ updateAfterNode(node) {
        const updateType = node.getUpdateAfterType();
        const reference = node.updateReference(this);
        if (updateType === $d89c9137a3d237c2$export$26f7a8bbd9469530.FRAME) {
            const nodeUpdateAfterMap = this._getMaps(this.updateAfterMap, reference);
            if (nodeUpdateAfterMap.frameId !== this.frameId) {
                if (node.updateAfter(this) !== false) nodeUpdateAfterMap.frameId = this.frameId;
            }
        } else if (updateType === $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER) {
            const nodeUpdateAfterMap = this._getMaps(this.updateAfterMap, reference);
            if (nodeUpdateAfterMap.renderId !== this.renderId) {
                if (node.updateAfter(this) !== false) nodeUpdateAfterMap.renderId = this.renderId;
            }
        } else if (updateType === $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT) node.updateAfter(this);
    }
    /**
	 * This method executes the {@link Node#update} for the given node.
	 * It makes sure {@link Node#updateType} is honored meaning the update
	 * is only executed once per frame, render or object depending on the update
	 * type.
	 *
	 * @param {Node} node - The node that should be updated.
	 */ updateNode(node) {
        const updateType = node.getUpdateType();
        const reference = node.updateReference(this);
        if (updateType === $d89c9137a3d237c2$export$26f7a8bbd9469530.FRAME) {
            const nodeUpdateMap = this._getMaps(this.updateMap, reference);
            if (nodeUpdateMap.frameId !== this.frameId) {
                if (node.update(this) !== false) nodeUpdateMap.frameId = this.frameId;
            }
        } else if (updateType === $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER) {
            const nodeUpdateMap = this._getMaps(this.updateMap, reference);
            if (nodeUpdateMap.renderId !== this.renderId) {
                if (node.update(this) !== false) nodeUpdateMap.renderId = this.renderId;
            }
        } else if (updateType === $d89c9137a3d237c2$export$26f7a8bbd9469530.OBJECT) node.update(this);
    }
    /**
	 * Updates the internal state of the node frame. This method is
	 * called by the renderer in its internal animation loop.
	 */ update() {
        this.frameId++;
        if (this.lastTime === undefined) this.lastTime = performance.now();
        this.deltaTime = (performance.now() - this.lastTime) / 1000;
        this.lastTime = performance.now();
        this.time += this.deltaTime;
    }
}
/**
 * Describes the input of a {@link NodeFunction}.
 */ class $d89c9137a3d237c2$export$9909d560ff36ee5e {
    /**
	 * Constructs a new node function input.
	 *
	 * @param {string} type - The input type.
	 * @param {string} name - The input name.
	 * @param {?number} [count=null] - If the input is an Array, count will be the length.
	 * @param {('in'|'out'|'inout')} [qualifier=''] - The parameter qualifier (only relevant for GLSL).
	 * @param {boolean} [isConst=false] - Whether the input uses a const qualifier or not (only relevant for GLSL).
	 */ constructor(type, name, count = null, qualifier = '', isConst = false){
        /**
		 *  The input type.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 * The input name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * If the input is an Array, count will be the length.
		 *
		 * @type {?number}
		 * @default null
		 */ this.count = count;
        /**
		 *The parameter qualifier (only relevant for GLSL).
		 *
		 * @type {('in'|'out'|'inout')}
		 * @default ''
		 */ this.qualifier = qualifier;
        /**
		 * Whether the input uses a const qualifier or not (only relevant for GLSL).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.isConst = isConst;
    }
}
$d89c9137a3d237c2$export$9909d560ff36ee5e.isNodeFunctionInput = true;
/**
 * Module for representing directional lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $d89c9137a3d237c2$export$6e67a8efcfed4d14 extends $d89c9137a3d237c2$export$126552cbaf08eb8 {
    static get type() {
        return 'DirectionalLightNode';
    }
    /**
	 * Constructs a new directional light node.
	 *
	 * @param {?DirectionalLight} [light=null] - The directional light source.
	 */ constructor(light = null){
        super(light);
    }
    setupDirect() {
        const lightColor = this.colorNode;
        const lightDirection = $d89c9137a3d237c2$var$lightTargetDirection(this.light);
        return {
            lightDirection: lightDirection,
            lightColor: lightColor
        };
    }
}
const $d89c9137a3d237c2$var$_matrix41 = /*@__PURE__*/ new (0, $329ek.Matrix4)();
const $d89c9137a3d237c2$var$_matrix42 = /*@__PURE__*/ new (0, $329ek.Matrix4)();
let $d89c9137a3d237c2$var$_ltcLib = null;
/**
 * Module for representing rect area lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $d89c9137a3d237c2$export$1029ea47a4dd9399 extends $d89c9137a3d237c2$export$126552cbaf08eb8 {
    static get type() {
        return 'RectAreaLightNode';
    }
    /**
	 * Constructs a new rect area light node.
	 *
	 * @param {?RectAreaLight} [light=null] - The rect area light source.
	 */ constructor(light = null){
        super(light);
        /**
		 * Uniform node representing the half height of the are light.
		 *
		 * @type {UniformNode<vec3>}
		 */ this.halfHeight = $d89c9137a3d237c2$var$uniform(new (0, $329ek.Vector3)()).setGroup($d89c9137a3d237c2$var$renderGroup);
        /**
		 * Uniform node representing the half width of the are light.
		 *
		 * @type {UniformNode<vec3>}
		 */ this.halfWidth = $d89c9137a3d237c2$var$uniform(new (0, $329ek.Vector3)()).setGroup($d89c9137a3d237c2$var$renderGroup);
        /**
		 * The `updateType` is set to `NodeUpdateType.RENDER` since the light
		 * relies on `viewMatrix` which might vary per render call.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateType = $d89c9137a3d237c2$export$26f7a8bbd9469530.RENDER;
    }
    /**
	 * Overwritten to updated rect area light specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        super.update(frame);
        const { light: light } = this;
        const viewMatrix = frame.camera.matrixWorldInverse;
        $d89c9137a3d237c2$var$_matrix42.identity();
        $d89c9137a3d237c2$var$_matrix41.copy(light.matrixWorld);
        $d89c9137a3d237c2$var$_matrix41.premultiply(viewMatrix);
        $d89c9137a3d237c2$var$_matrix42.extractRotation($d89c9137a3d237c2$var$_matrix41);
        this.halfWidth.value.set(light.width * 0.5, 0.0, 0.0);
        this.halfHeight.value.set(0.0, light.height * 0.5, 0.0);
        this.halfWidth.value.applyMatrix4($d89c9137a3d237c2$var$_matrix42);
        this.halfHeight.value.applyMatrix4($d89c9137a3d237c2$var$_matrix42);
    }
    setupDirectRectArea(builder) {
        let ltc_1, ltc_2;
        if (builder.isAvailable('float32Filterable')) {
            ltc_1 = $d89c9137a3d237c2$var$texture($d89c9137a3d237c2$var$_ltcLib.LTC_FLOAT_1);
            ltc_2 = $d89c9137a3d237c2$var$texture($d89c9137a3d237c2$var$_ltcLib.LTC_FLOAT_2);
        } else {
            ltc_1 = $d89c9137a3d237c2$var$texture($d89c9137a3d237c2$var$_ltcLib.LTC_HALF_1);
            ltc_2 = $d89c9137a3d237c2$var$texture($d89c9137a3d237c2$var$_ltcLib.LTC_HALF_2);
        }
        const { colorNode: colorNode, light: light } = this;
        const lightPosition = $d89c9137a3d237c2$var$lightViewPosition(light);
        return {
            lightColor: colorNode,
            lightPosition: lightPosition,
            halfWidth: this.halfWidth,
            halfHeight: this.halfHeight,
            ltc_1: ltc_1,
            ltc_2: ltc_2
        };
    }
    /**
	 * Used to configure the internal BRDF approximation texture data.
	 *
	 * @param {RectAreaLightTexturesLib} ltc - The BRDF approximation texture data.
	 */ static setLTC(ltc) {
        $d89c9137a3d237c2$var$_ltcLib = ltc;
    }
}
/**
 * Module for representing spot lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $d89c9137a3d237c2$export$df1aa5fd66541854 extends $d89c9137a3d237c2$export$126552cbaf08eb8 {
    static get type() {
        return 'SpotLightNode';
    }
    /**
	 * Constructs a new spot light node.
	 *
	 * @param {?SpotLight} [light=null] - The spot light source.
	 */ constructor(light = null){
        super(light);
        /**
		 * Uniform node representing the cone cosine.
		 *
		 * @type {UniformNode<float>}
		 */ this.coneCosNode = $d89c9137a3d237c2$var$uniform(0).setGroup($d89c9137a3d237c2$var$renderGroup);
        /**
		 * Uniform node representing the penumbra cosine.
		 *
		 * @type {UniformNode<float>}
		 */ this.penumbraCosNode = $d89c9137a3d237c2$var$uniform(0).setGroup($d89c9137a3d237c2$var$renderGroup);
        /**
		 * Uniform node representing the cutoff distance.
		 *
		 * @type {UniformNode<float>}
		 */ this.cutoffDistanceNode = $d89c9137a3d237c2$var$uniform(0).setGroup($d89c9137a3d237c2$var$renderGroup);
        /**
		 * Uniform node representing the decay exponent.
		 *
		 * @type {UniformNode<float>}
		 */ this.decayExponentNode = $d89c9137a3d237c2$var$uniform(0).setGroup($d89c9137a3d237c2$var$renderGroup);
        /**
		 * Uniform node representing the light color.
		 *
		 * @type {UniformNode<Color>}
		 */ this.colorNode = $d89c9137a3d237c2$var$uniform(this.color).setGroup($d89c9137a3d237c2$var$renderGroup);
    }
    /**
	 * Overwritten to updated spot light specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        super.update(frame);
        const { light: light } = this;
        this.coneCosNode.value = Math.cos(light.angle);
        this.penumbraCosNode.value = Math.cos(light.angle * (1 - light.penumbra));
        this.cutoffDistanceNode.value = light.distance;
        this.decayExponentNode.value = light.decay;
    }
    /**
	 * Computes the spot attenuation for the given angle.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @param {Node<float>} angleCosine - The angle to compute the spot attenuation for.
	 * @return {Node<float>} The spot attenuation.
	 */ getSpotAttenuation(builder, angleCosine) {
        const { coneCosNode: coneCosNode, penumbraCosNode: penumbraCosNode } = this;
        return $d89c9137a3d237c2$var$smoothstep(coneCosNode, penumbraCosNode, angleCosine);
    }
    getLightCoord(builder) {
        const properties = builder.getNodeProperties(this);
        let projectionUV = properties.projectionUV;
        if (projectionUV === undefined) {
            projectionUV = $d89c9137a3d237c2$var$lightProjectionUV(this.light, builder.context.positionWorld);
            properties.projectionUV = projectionUV;
        }
        return projectionUV;
    }
    setupDirect(builder) {
        const { colorNode: colorNode, cutoffDistanceNode: cutoffDistanceNode, decayExponentNode: decayExponentNode, light: light } = this;
        const lightVector = this.getLightVector(builder);
        const lightDirection = lightVector.normalize();
        const angleCos = lightDirection.dot($d89c9137a3d237c2$var$lightTargetDirection(light));
        const spotAttenuation = this.getSpotAttenuation(builder, angleCos);
        const lightDistance = lightVector.length();
        const lightAttenuation = $d89c9137a3d237c2$var$getDistanceAttenuation({
            lightDistance: lightDistance,
            cutoffDistance: cutoffDistanceNode,
            decayExponent: decayExponentNode
        });
        let lightColor = colorNode.mul(spotAttenuation).mul(lightAttenuation);
        let projected, lightCoord;
        if (light.colorNode) {
            lightCoord = this.getLightCoord(builder);
            projected = light.colorNode(lightCoord);
        } else if (light.map) {
            lightCoord = this.getLightCoord(builder);
            projected = $d89c9137a3d237c2$var$texture(light.map, lightCoord.xy).onRenderUpdate(()=>light.map);
        }
        if (projected) {
            const inSpotLightMap = lightCoord.mul(2.).sub(1.).abs().lessThan(1.).all();
            lightColor = inSpotLightMap.select(lightColor.mul(projected), lightColor);
        }
        return {
            lightColor: lightColor,
            lightDirection: lightDirection
        };
    }
}
/**
 * An IES version of the default spot light node.
 *
 * @augments SpotLightNode
 */ class $d89c9137a3d237c2$export$5d7cdca61c24be58 extends $d89c9137a3d237c2$export$df1aa5fd66541854 {
    static get type() {
        return 'IESSpotLightNode';
    }
    /**
	 * Overwrites the default implementation to compute an IES conform spot attenuation.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @param {Node<float>} angleCosine - The angle to compute the spot attenuation for.
	 * @return {Node<float>} The spot attenuation.
	 */ getSpotAttenuation(builder, angleCosine) {
        const iesMap = this.light.iesMap;
        let spotAttenuation = null;
        if (iesMap && iesMap.isTexture === true) {
            const angle = angleCosine.acos().mul(1.0 / Math.PI);
            spotAttenuation = $d89c9137a3d237c2$var$texture(iesMap, $d89c9137a3d237c2$var$vec2(angle, 0), 0).r;
        } else spotAttenuation = super.getSpotAttenuation(angleCosine);
        return spotAttenuation;
    }
}
const $d89c9137a3d237c2$var$sdBox = /*@__PURE__*/ $d89c9137a3d237c2$var$Fn(([p, b])=>{
    const d = p.abs().sub(b);
    return $d89c9137a3d237c2$var$length($d89c9137a3d237c2$var$max$1(d, 0.0)).add($d89c9137a3d237c2$var$min$1($d89c9137a3d237c2$var$max$1(d.x, d.y), 0.0));
});
/**
 * An implementation of a projector light node.
 *
 * @augments SpotLightNode
 */ class $d89c9137a3d237c2$export$e6df2aceb76fe9a0 extends $d89c9137a3d237c2$export$df1aa5fd66541854 {
    static get type() {
        return 'ProjectorLightNode';
    }
    update(frame) {
        super.update(frame);
        const light = this.light;
        this.penumbraCosNode.value = Math.min(Math.cos(light.angle * (1 - light.penumbra)), .99999);
        if (light.aspect === null) {
            let aspect = 1;
            if (light.map !== null) aspect = light.map.width / light.map.height;
            light.shadow.aspect = aspect;
        } else light.shadow.aspect = light.aspect;
    }
    /**
	 * Overwrites the default implementation to compute projection attenuation.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @return {Node<float>} The spot attenuation.
	 */ getSpotAttenuation(builder) {
        const attenuation = $d89c9137a3d237c2$var$float(0);
        const penumbraCos = this.penumbraCosNode;
        // compute the fragment's position in the light's clip space
        const spotLightCoord = $d89c9137a3d237c2$var$lightShadowMatrix(this.light).mul(builder.context.positionWorld || $d89c9137a3d237c2$var$positionWorld);
        // the sign of w determines whether the current fragment is in front or behind the light.
        // to avoid a back-projection, it's important to only compute an attenuation if w is positive
        $d89c9137a3d237c2$var$If(spotLightCoord.w.greaterThan(0), ()=>{
            const projectionUV = spotLightCoord.xyz.div(spotLightCoord.w);
            const boxDist = $d89c9137a3d237c2$var$sdBox(projectionUV.xy.sub($d89c9137a3d237c2$var$vec2(0.5)), $d89c9137a3d237c2$var$vec2(0.5));
            const angleFactor = $d89c9137a3d237c2$var$div(-1, $d89c9137a3d237c2$var$sub(1.0, $d89c9137a3d237c2$var$acos(penumbraCos)).sub(1.0));
            attenuation.assign($d89c9137a3d237c2$var$saturate(boxDist.mul(-2).mul(angleFactor)));
        });
        return attenuation;
    }
}
/**
 * Module for representing ambient lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $d89c9137a3d237c2$export$ade3bbc96c5c4bf1 extends $d89c9137a3d237c2$export$126552cbaf08eb8 {
    static get type() {
        return 'AmbientLightNode';
    }
    /**
	 * Constructs a new ambient light node.
	 *
	 * @param {?AmbientLight} [light=null] - The ambient light source.
	 */ constructor(light = null){
        super(light);
    }
    setup({ context: context }) {
        context.irradiance.addAssign(this.colorNode);
    }
}
/**
 * Module for representing hemisphere lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $d89c9137a3d237c2$export$8c237e4e9b54f548 extends $d89c9137a3d237c2$export$126552cbaf08eb8 {
    static get type() {
        return 'HemisphereLightNode';
    }
    /**
	 * Constructs a new hemisphere light node.
	 *
	 * @param {?HemisphereLight} [light=null] - The hemisphere light source.
	 */ constructor(light = null){
        super(light);
        /**
		 * Uniform node representing the light's position.
		 *
		 * @type {UniformNode<vec3>}
		 */ this.lightPositionNode = $d89c9137a3d237c2$var$lightPosition(light);
        /**
		 * A node representing the light's direction.
		 *
		 * @type {Node<vec3>}
		 */ this.lightDirectionNode = this.lightPositionNode.normalize();
        /**
		 * Uniform node representing the light's ground color.
		 *
		 * @type {UniformNode<vec3>}
		 */ this.groundColorNode = $d89c9137a3d237c2$var$uniform(new (0, $329ek.Color)()).setGroup($d89c9137a3d237c2$var$renderGroup);
    }
    /**
	 * Overwritten to updated hemisphere light specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        const { light: light } = this;
        super.update(frame);
        this.lightPositionNode.object3d = light;
        this.groundColorNode.value.copy(light.groundColor).multiplyScalar(light.intensity);
    }
    setup(builder) {
        const { colorNode: colorNode, groundColorNode: groundColorNode, lightDirectionNode: lightDirectionNode } = this;
        const dotNL = $d89c9137a3d237c2$var$normalWorld.dot(lightDirectionNode);
        const hemiDiffuseWeight = dotNL.mul(0.5).add(0.5);
        const irradiance = $d89c9137a3d237c2$var$mix(groundColorNode, colorNode, hemiDiffuseWeight);
        builder.context.irradiance.addAssign(irradiance);
    }
}
/**
 * Module for representing light probes as nodes.
 *
 * @augments AnalyticLightNode
 */ class $d89c9137a3d237c2$export$c2c4ca9136f2b869 extends $d89c9137a3d237c2$export$126552cbaf08eb8 {
    static get type() {
        return 'LightProbeNode';
    }
    /**
	 * Constructs a new light probe node.
	 *
	 * @param {?LightProbe} [light=null] - The light probe.
	 */ constructor(light = null){
        super(light);
        const array = [];
        for(let i = 0; i < 9; i++)array.push(new (0, $329ek.Vector3)());
        /**
		 * Light probe represented as a uniform of spherical harmonics.
		 *
		 * @type {UniformArrayNode}
		 */ this.lightProbe = $d89c9137a3d237c2$var$uniformArray(array);
    }
    /**
	 * Overwritten to updated light probe specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        const { light: light } = this;
        super.update(frame);
        //
        for(let i = 0; i < 9; i++)this.lightProbe.array[i].copy(light.sh.coefficients[i]).multiplyScalar(light.intensity);
    }
    setup(builder) {
        const irradiance = $d89c9137a3d237c2$var$getShIrradianceAt($d89c9137a3d237c2$var$normalWorld, this.lightProbe);
        builder.context.irradiance.addAssign(irradiance);
    }
}
/**
 * Base class for node parsers. A derived parser must be implemented
 * for each supported native shader language.
 */ class $d89c9137a3d237c2$var$NodeParser {
    /**
	 * The method parses the given native code an returns a node function.
	 *
	 * @abstract
	 * @param {string} source - The native shader code.
	 * @return {NodeFunction} A node function.
	 */ parseFunction() {
        (0, $329ek.warn)('Abstract function.');
    }
}
/**
 * Base class for node functions. A derived module must be implemented
 * for each supported native shader language. Similar to other `Node*` modules,
 * this class is only relevant during the building process and not used
 * in user-level code.
 */ class $d89c9137a3d237c2$var$NodeFunction {
    /**
	 * Constructs a new node function.
	 *
	 * @param {string} type - The node type. This type is the return type of the node function.
	 * @param {Array<NodeFunctionInput>} inputs - The function's inputs.
	 * @param {string} [name=''] - The function's name.
	 * @param {string} [precision=''] - The precision qualifier.
	 */ constructor(type, inputs, name = '', precision = ''){
        /**
		 * The node type. This type is the return type of the node function.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 * The function's inputs.
		 *
		 * @type {Array<NodeFunctionInput>}
		 */ this.inputs = inputs;
        /**
		 * The name of the uniform.
		 *
		 * @type {string}
		 * @default ''
		 */ this.name = name;
        /**
		 * The precision qualifier.
		 *
		 * @type {string}
		 * @default ''
		 */ this.precision = precision;
    }
    /**
	 * This method returns the native code of the node function.
	 *
	 * @abstract
	 * @param {string} name - The function's name.
	 * @return {string} A shader code.
	 */ getCode() {
        (0, $329ek.warn)('Abstract function.');
    }
}
$d89c9137a3d237c2$var$NodeFunction.isNodeFunction = true;
const $d89c9137a3d237c2$var$declarationRegexp$1 = /^\s*(highp|mediump|lowp)?\s*([a-z_0-9]+)\s*([a-z_0-9]+)?\s*\(([\s\S]*?)\)/i;
const $d89c9137a3d237c2$var$propertiesRegexp$1 = /[a-z_0-9]+/ig;
const $d89c9137a3d237c2$var$pragmaMain = '#pragma main';
const $d89c9137a3d237c2$var$parse$1 = (source)=>{
    source = source.trim();
    const pragmaMainIndex = source.indexOf($d89c9137a3d237c2$var$pragmaMain);
    const mainCode = pragmaMainIndex !== -1 ? source.slice(pragmaMainIndex + $d89c9137a3d237c2$var$pragmaMain.length) : source;
    const declaration = mainCode.match($d89c9137a3d237c2$var$declarationRegexp$1);
    if (declaration !== null && declaration.length === 5) {
        // tokenizer
        const inputsCode = declaration[4];
        const propsMatches = [];
        let nameMatch = null;
        while((nameMatch = $d89c9137a3d237c2$var$propertiesRegexp$1.exec(inputsCode)) !== null)propsMatches.push(nameMatch);
        // parser
        const inputs = [];
        let i = 0;
        while(i < propsMatches.length){
            const isConst = propsMatches[i][0] === 'const';
            if (isConst === true) i++;
            let qualifier = propsMatches[i][0];
            if (qualifier === 'in' || qualifier === 'out' || qualifier === 'inout') i++;
            else qualifier = '';
            const type = propsMatches[i++][0];
            let count = Number.parseInt(propsMatches[i][0]);
            if (Number.isNaN(count) === false) i++;
            else count = null;
            const name = propsMatches[i++][0];
            inputs.push(new $d89c9137a3d237c2$export$9909d560ff36ee5e(type, name, count, qualifier, isConst));
        }
        //
        const blockCode = mainCode.substring(declaration[0].length);
        const name = declaration[3] !== undefined ? declaration[3] : '';
        const type = declaration[2];
        const precision = declaration[1] !== undefined ? declaration[1] : '';
        const headerCode = pragmaMainIndex !== -1 ? source.slice(0, pragmaMainIndex) : '';
        return {
            type: type,
            inputs: inputs,
            name: name,
            precision: precision,
            inputsCode: inputsCode,
            blockCode: blockCode,
            headerCode: headerCode
        };
    } else throw new Error('FunctionNode: Function is not a GLSL code.');
};
/**
 * This class represents a GLSL node function.
 *
 * @augments NodeFunction
 */ class $d89c9137a3d237c2$var$GLSLNodeFunction extends $d89c9137a3d237c2$var$NodeFunction {
    /**
	 * Constructs a new GLSL node function.
	 *
	 * @param {string} source - The GLSL source.
	 */ constructor(source){
        const { type: type, inputs: inputs, name: name, precision: precision, inputsCode: inputsCode, blockCode: blockCode, headerCode: headerCode } = $d89c9137a3d237c2$var$parse$1(source);
        super(type, inputs, name, precision);
        this.inputsCode = inputsCode;
        this.blockCode = blockCode;
        this.headerCode = headerCode;
    }
    /**
	 * This method returns the GLSL code of the node function.
	 *
	 * @param {string} [name=this.name] - The function's name.
	 * @return {string} The shader code.
	 */ getCode(name = this.name) {
        let code;
        const blockCode = this.blockCode;
        if (blockCode !== '') {
            const { type: type, inputsCode: inputsCode, headerCode: headerCode, precision: precision } = this;
            let declarationCode = `${type} ${name} ( ${inputsCode.trim()} )`;
            if (precision !== '') declarationCode = `${precision} ${declarationCode}`;
            code = headerCode + declarationCode + blockCode;
        } else // interface function
        code = '';
        return code;
    }
}
/**
 * A GLSL node parser.
 *
 * @augments NodeParser
 */ class $d89c9137a3d237c2$export$18a74e8f50eca178 extends $d89c9137a3d237c2$var$NodeParser {
    /**
	 * The method parses the given GLSL code an returns a node function.
	 *
	 * @param {string} source - The GLSL code.
	 * @return {GLSLNodeFunction} A node function.
	 */ parseFunction(source) {
        return new $d89c9137a3d237c2$var$GLSLNodeFunction(source);
    }
}
const $d89c9137a3d237c2$var$_outputNodeMap = new WeakMap();
const $d89c9137a3d237c2$var$_chainKeys$2 = [];
const $d89c9137a3d237c2$var$_cacheKeyValues = [];
/**
 * This renderer module manages node-related objects and is the
 * primary interface between the renderer and the node system.
 *
 * @private
 * @augments DataMap
 */ class $d89c9137a3d237c2$var$Nodes extends $d89c9137a3d237c2$var$DataMap {
    /**
	 * Constructs a new nodes management component.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {Backend} backend - The renderer's backend.
	 */ constructor(renderer, backend){
        super();
        /**
		 * The renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * The renderer's backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
        /**
		 * The node frame.
		 *
		 * @type {Renderer}
		 */ this.nodeFrame = new $d89c9137a3d237c2$export$20d1e096ab9d190e();
        /**
		 * A cache for managing node builder states.
		 *
		 * @type {Map<number,NodeBuilderState>}
		 */ this.nodeBuilderCache = new Map();
        /**
		 * A cache for managing data cache key data.
		 *
		 * @type {ChainMap}
		 */ this.callHashCache = new $d89c9137a3d237c2$var$ChainMap();
        /**
		 * A cache for managing node uniforms group data.
		 *
		 * @type {ChainMap}
		 */ this.groupsData = new $d89c9137a3d237c2$var$ChainMap();
        /**
		 * A cache for managing node objects of
		 * scene properties like fog or environments.
		 *
		 * @type {Object<string,WeakMap>}
		 */ this.cacheLib = {};
    }
    /**
	 * Returns `true` if the given node uniforms group must be updated or not.
	 *
	 * @param {NodeUniformsGroup} nodeUniformsGroup - The node uniforms group.
	 * @return {boolean} Whether the node uniforms group requires an update or not.
	 */ updateGroup(nodeUniformsGroup) {
        const groupNode = nodeUniformsGroup.groupNode;
        const name = groupNode.name;
        // objectGroup is always updated
        if (name === $d89c9137a3d237c2$var$objectGroup.name) return true;
        // renderGroup is updated once per render/compute call
        if (name === $d89c9137a3d237c2$var$renderGroup.name) {
            const uniformsGroupData = this.get(nodeUniformsGroup);
            const renderId = this.nodeFrame.renderId;
            if (uniformsGroupData.renderId !== renderId) {
                uniformsGroupData.renderId = renderId;
                return true;
            }
            return false;
        }
        // frameGroup is updated once per frame
        if (name === $d89c9137a3d237c2$var$frameGroup.name) {
            const uniformsGroupData = this.get(nodeUniformsGroup);
            const frameId = this.nodeFrame.frameId;
            if (uniformsGroupData.frameId !== frameId) {
                uniformsGroupData.frameId = frameId;
                return true;
            }
            return false;
        }
        // other groups are updated just when groupNode.needsUpdate is true
        $d89c9137a3d237c2$var$_chainKeys$2[0] = groupNode;
        $d89c9137a3d237c2$var$_chainKeys$2[1] = nodeUniformsGroup;
        let groupData = this.groupsData.get($d89c9137a3d237c2$var$_chainKeys$2);
        if (groupData === undefined) this.groupsData.set($d89c9137a3d237c2$var$_chainKeys$2, groupData = {});
        $d89c9137a3d237c2$var$_chainKeys$2.length = 0;
        if (groupData.version !== groupNode.version) {
            groupData.version = groupNode.version;
            return true;
        }
        return false;
    }
    /**
	 * Returns the cache key for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {number} The cache key.
	 */ getForRenderCacheKey(renderObject) {
        return renderObject.initialCacheKey;
    }
    /**
	 * Returns a node builder state for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {NodeBuilderState} The node builder state.
	 */ getForRender(renderObject) {
        const renderObjectData = this.get(renderObject);
        let nodeBuilderState = renderObjectData.nodeBuilderState;
        if (nodeBuilderState === undefined) {
            const { nodeBuilderCache: nodeBuilderCache } = this;
            const cacheKey = this.getForRenderCacheKey(renderObject);
            nodeBuilderState = nodeBuilderCache.get(cacheKey);
            if (nodeBuilderState === undefined) {
                const createNodeBuilder = (material)=>{
                    const nodeBuilder = this.backend.createNodeBuilder(renderObject.object, this.renderer);
                    nodeBuilder.scene = renderObject.scene;
                    nodeBuilder.material = material;
                    nodeBuilder.camera = renderObject.camera;
                    nodeBuilder.context.material = material;
                    nodeBuilder.lightsNode = renderObject.lightsNode;
                    nodeBuilder.environmentNode = this.getEnvironmentNode(renderObject.scene);
                    nodeBuilder.fogNode = this.getFogNode(renderObject.scene);
                    nodeBuilder.clippingContext = renderObject.clippingContext;
                    if (this.renderer.getOutputRenderTarget() ? this.renderer.getOutputRenderTarget().multiview : false) nodeBuilder.enableMultiview();
                    return nodeBuilder;
                };
                let nodeBuilder = createNodeBuilder(renderObject.material);
                try {
                    nodeBuilder.build();
                } catch (e) {
                    nodeBuilder = createNodeBuilder(new $d89c9137a3d237c2$export$caaf3b30a544c946());
                    nodeBuilder.build();
                    (0, $329ek.error)('TSL: ' + e);
                }
                nodeBuilderState = this._createNodeBuilderState(nodeBuilder);
                nodeBuilderCache.set(cacheKey, nodeBuilderState);
            }
            nodeBuilderState.usedTimes++;
            renderObjectData.nodeBuilderState = nodeBuilderState;
        }
        return nodeBuilderState;
    }
    /**
	 * Deletes the given object from the internal data map
	 *
	 * @param {any} object - The object to delete.
	 * @return {?Object} The deleted dictionary.
	 */ delete(object) {
        if (object.isRenderObject) {
            const nodeBuilderState = this.get(object).nodeBuilderState;
            nodeBuilderState.usedTimes--;
            if (nodeBuilderState.usedTimes === 0) this.nodeBuilderCache.delete(this.getForRenderCacheKey(object));
        }
        return super.delete(object);
    }
    /**
	 * Returns a node builder state for the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 * @return {NodeBuilderState} The node builder state.
	 */ getForCompute(computeNode) {
        const computeData = this.get(computeNode);
        let nodeBuilderState = computeData.nodeBuilderState;
        if (nodeBuilderState === undefined) {
            const nodeBuilder = this.backend.createNodeBuilder(computeNode, this.renderer);
            nodeBuilder.build();
            nodeBuilderState = this._createNodeBuilderState(nodeBuilder);
            computeData.nodeBuilderState = nodeBuilderState;
        }
        return nodeBuilderState;
    }
    /**
	 * Creates a node builder state for the given node builder.
	 *
	 * @private
	 * @param {NodeBuilder} nodeBuilder - The node builder.
	 * @return {NodeBuilderState} The node builder state.
	 */ _createNodeBuilderState(nodeBuilder) {
        return new $d89c9137a3d237c2$var$NodeBuilderState(nodeBuilder.vertexShader, nodeBuilder.fragmentShader, nodeBuilder.computeShader, nodeBuilder.getAttributesArray(), nodeBuilder.getBindings(), nodeBuilder.updateNodes, nodeBuilder.updateBeforeNodes, nodeBuilder.updateAfterNodes, nodeBuilder.observer, nodeBuilder.transforms);
    }
    /**
	 * Returns an environment node for the current configured
	 * scene environment.
	 *
	 * @param {Scene} scene - The scene.
	 * @return {Node} A node representing the current scene environment.
	 */ getEnvironmentNode(scene) {
        this.updateEnvironment(scene);
        let environmentNode = null;
        if (scene.environmentNode && scene.environmentNode.isNode) environmentNode = scene.environmentNode;
        else {
            const sceneData = this.get(scene);
            if (sceneData.environmentNode) environmentNode = sceneData.environmentNode;
        }
        return environmentNode;
    }
    /**
	 * Returns a background node for the current configured
	 * scene background.
	 *
	 * @param {Scene} scene - The scene.
	 * @return {Node} A node representing the current scene background.
	 */ getBackgroundNode(scene) {
        this.updateBackground(scene);
        let backgroundNode = null;
        if (scene.backgroundNode && scene.backgroundNode.isNode) backgroundNode = scene.backgroundNode;
        else {
            const sceneData = this.get(scene);
            if (sceneData.backgroundNode) backgroundNode = sceneData.backgroundNode;
        }
        return backgroundNode;
    }
    /**
	 * Returns a fog node for the current configured scene fog.
	 *
	 * @param {Scene} scene - The scene.
	 * @return {Node} A node representing the current scene fog.
	 */ getFogNode(scene) {
        this.updateFog(scene);
        return scene.fogNode || this.get(scene).fogNode || null;
    }
    /**
	 * Returns a cache key for the given scene and lights node.
	 * This key is used by `RenderObject` as a part of the dynamic
	 * cache key (a key that must be checked every time the render
	 * objects is drawn).
	 *
	 * @param {Scene} scene - The scene.
	 * @param {LightsNode} lightsNode - The lights node.
	 * @return {number} The cache key.
	 */ getCacheKey(scene, lightsNode) {
        $d89c9137a3d237c2$var$_chainKeys$2[0] = scene;
        $d89c9137a3d237c2$var$_chainKeys$2[1] = lightsNode;
        const callId = this.renderer.info.calls;
        const cacheKeyData = this.callHashCache.get($d89c9137a3d237c2$var$_chainKeys$2) || {};
        if (cacheKeyData.callId !== callId) {
            const environmentNode = this.getEnvironmentNode(scene);
            const fogNode = this.getFogNode(scene);
            if (lightsNode) $d89c9137a3d237c2$var$_cacheKeyValues.push(lightsNode.getCacheKey(true));
            if (environmentNode) $d89c9137a3d237c2$var$_cacheKeyValues.push(environmentNode.getCacheKey());
            if (fogNode) $d89c9137a3d237c2$var$_cacheKeyValues.push(fogNode.getCacheKey());
            $d89c9137a3d237c2$var$_cacheKeyValues.push(this.renderer.getOutputRenderTarget() && this.renderer.getOutputRenderTarget().multiview ? 1 : 0);
            $d89c9137a3d237c2$var$_cacheKeyValues.push(this.renderer.shadowMap.enabled ? 1 : 0);
            $d89c9137a3d237c2$var$_cacheKeyValues.push(this.renderer.shadowMap.type);
            cacheKeyData.callId = callId;
            cacheKeyData.cacheKey = $d89c9137a3d237c2$var$hashArray($d89c9137a3d237c2$var$_cacheKeyValues);
            this.callHashCache.set($d89c9137a3d237c2$var$_chainKeys$2, cacheKeyData);
            $d89c9137a3d237c2$var$_cacheKeyValues.length = 0;
        }
        $d89c9137a3d237c2$var$_chainKeys$2.length = 0;
        return cacheKeyData.cacheKey;
    }
    /**
	 * A boolean that indicates whether tone mapping should be enabled
	 * or not.
	 *
	 * @type {boolean}
	 */ get isToneMappingState() {
        return this.renderer.getRenderTarget() ? false : true;
    }
    /**
	 * If a scene background is configured, this method makes sure to
	 * represent the background with a corresponding node-based implementation.
	 *
	 * @param {Scene} scene - The scene.
	 */ updateBackground(scene) {
        const sceneData = this.get(scene);
        const background = scene.background;
        if (background) {
            const forceUpdate = scene.backgroundBlurriness === 0 && sceneData.backgroundBlurriness > 0 || scene.backgroundBlurriness > 0 && sceneData.backgroundBlurriness === 0;
            if (sceneData.background !== background || forceUpdate) {
                const backgroundNode = this.getCacheNode('background', background, ()=>{
                    if (background.isCubeTexture === true || background.mapping === (0, $329ek.EquirectangularReflectionMapping) || background.mapping === (0, $329ek.EquirectangularRefractionMapping) || background.mapping === (0, $329ek.CubeUVReflectionMapping)) {
                        if (scene.backgroundBlurriness > 0 || background.mapping === (0, $329ek.CubeUVReflectionMapping)) return $d89c9137a3d237c2$var$pmremTexture(background);
                        else {
                            let envMap;
                            if (background.isCubeTexture === true) envMap = $d89c9137a3d237c2$var$cubeTexture(background);
                            else envMap = $d89c9137a3d237c2$var$texture(background);
                            return $d89c9137a3d237c2$var$cubeMapNode(envMap);
                        }
                    } else if (background.isTexture === true) return $d89c9137a3d237c2$var$texture(background, $d89c9137a3d237c2$var$screenUV.flipY()).setUpdateMatrix(true);
                    else if (background.isColor !== true) (0, $329ek.error)('WebGPUNodes: Unsupported background configuration.', background);
                }, forceUpdate);
                sceneData.backgroundNode = backgroundNode;
                sceneData.background = background;
                sceneData.backgroundBlurriness = scene.backgroundBlurriness;
            }
        } else if (sceneData.backgroundNode) {
            delete sceneData.backgroundNode;
            delete sceneData.background;
        }
    }
    /**
	 * This method is part of the caching of nodes which are used to represents the
	 * scene's background, fog or environment.
	 *
	 * @param {string} type - The type of object to cache.
	 * @param {Object} object - The object.
	 * @param {Function} callback - A callback that produces a node representation for the given object.
	 * @param {boolean} [forceUpdate=false] - Whether an update should be enforced or not.
	 * @return {Node} The node representation.
	 */ getCacheNode(type, object, callback, forceUpdate = false) {
        const nodeCache = this.cacheLib[type] || (this.cacheLib[type] = new WeakMap());
        let node = nodeCache.get(object);
        if (node === undefined || forceUpdate) {
            node = callback();
            nodeCache.set(object, node);
        }
        return node;
    }
    /**
	 * If a scene fog is configured, this method makes sure to
	 * represent the fog with a corresponding node-based implementation.
	 *
	 * @param {Scene} scene - The scene.
	 */ updateFog(scene) {
        const sceneData = this.get(scene);
        const sceneFog = scene.fog;
        if (sceneFog) {
            if (sceneData.fog !== sceneFog) {
                const fogNode = this.getCacheNode('fog', sceneFog, ()=>{
                    if (sceneFog.isFogExp2) {
                        const color = $d89c9137a3d237c2$var$reference('color', 'color', sceneFog).setGroup($d89c9137a3d237c2$var$renderGroup);
                        const density = $d89c9137a3d237c2$var$reference('density', 'float', sceneFog).setGroup($d89c9137a3d237c2$var$renderGroup);
                        return $d89c9137a3d237c2$var$fog(color, $d89c9137a3d237c2$var$densityFogFactor(density));
                    } else if (sceneFog.isFog) {
                        const color = $d89c9137a3d237c2$var$reference('color', 'color', sceneFog).setGroup($d89c9137a3d237c2$var$renderGroup);
                        const near = $d89c9137a3d237c2$var$reference('near', 'float', sceneFog).setGroup($d89c9137a3d237c2$var$renderGroup);
                        const far = $d89c9137a3d237c2$var$reference('far', 'float', sceneFog).setGroup($d89c9137a3d237c2$var$renderGroup);
                        return $d89c9137a3d237c2$var$fog(color, $d89c9137a3d237c2$var$rangeFogFactor(near, far));
                    } else (0, $329ek.error)('Renderer: Unsupported fog configuration.', sceneFog);
                });
                sceneData.fogNode = fogNode;
                sceneData.fog = sceneFog;
            }
        } else {
            delete sceneData.fogNode;
            delete sceneData.fog;
        }
    }
    /**
	 * If a scene environment is configured, this method makes sure to
	 * represent the environment with a corresponding node-based implementation.
	 *
	 * @param {Scene} scene - The scene.
	 */ updateEnvironment(scene) {
        const sceneData = this.get(scene);
        const environment = scene.environment;
        if (environment) {
            if (sceneData.environment !== environment) {
                const environmentNode = this.getCacheNode('environment', environment, ()=>{
                    if (environment.isCubeTexture === true) return $d89c9137a3d237c2$var$cubeTexture(environment);
                    else if (environment.isTexture === true) return $d89c9137a3d237c2$var$texture(environment);
                    else (0, $329ek.error)('Nodes: Unsupported environment configuration.', environment);
                });
                sceneData.environmentNode = environmentNode;
                sceneData.environment = environment;
            }
        } else if (sceneData.environmentNode) {
            delete sceneData.environmentNode;
            delete sceneData.environment;
        }
    }
    getNodeFrame(renderer = this.renderer, scene = null, object = null, camera = null, material = null) {
        const nodeFrame = this.nodeFrame;
        nodeFrame.renderer = renderer;
        nodeFrame.scene = scene;
        nodeFrame.object = object;
        nodeFrame.camera = camera;
        nodeFrame.material = material;
        return nodeFrame;
    }
    getNodeFrameForRender(renderObject) {
        return this.getNodeFrame(renderObject.renderer, renderObject.scene, renderObject.object, renderObject.camera, renderObject.material);
    }
    /**
	 * Returns the current output cache key.
	 *
	 * @return {string} The output cache key.
	 */ getOutputCacheKey() {
        const renderer = this.renderer;
        return renderer.toneMapping + ',' + renderer.currentColorSpace + ',' + renderer.xr.isPresenting;
    }
    /**
	 * Checks if the output configuration (tone mapping and color space) for
	 * the given target has changed.
	 *
	 * @param {Texture} outputTarget - The output target.
	 * @return {boolean} Whether the output configuration has changed or not.
	 */ hasOutputChange(outputTarget) {
        const cacheKey = $d89c9137a3d237c2$var$_outputNodeMap.get(outputTarget);
        return cacheKey !== this.getOutputCacheKey();
    }
    /**
	 * Returns a node that represents the output configuration (tone mapping and
	 * color space) for the current target.
	 *
	 * @param {Texture} outputTarget - The output target.
	 * @return {Node} The output node.
	 */ getOutputNode(outputTarget) {
        const renderer = this.renderer;
        const cacheKey = this.getOutputCacheKey();
        const output = outputTarget.isArrayTexture ? $d89c9137a3d237c2$var$texture3D(outputTarget, $d89c9137a3d237c2$var$vec3($d89c9137a3d237c2$var$screenUV, $d89c9137a3d237c2$var$builtin('gl_ViewID_OVR'))).renderOutput(renderer.toneMapping, renderer.currentColorSpace) : $d89c9137a3d237c2$var$texture(outputTarget, $d89c9137a3d237c2$var$screenUV).renderOutput(renderer.toneMapping, renderer.currentColorSpace);
        $d89c9137a3d237c2$var$_outputNodeMap.set(outputTarget, cacheKey);
        return output;
    }
    /**
	 * Triggers the call of `updateBefore()` methods
	 * for all nodes of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateBefore(renderObject) {
        const nodeBuilder = renderObject.getNodeBuilderState();
        for (const node of nodeBuilder.updateBeforeNodes)// update frame state for each node
        this.getNodeFrameForRender(renderObject).updateBeforeNode(node);
    }
    /**
	 * Triggers the call of `updateAfter()` methods
	 * for all nodes of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateAfter(renderObject) {
        const nodeBuilder = renderObject.getNodeBuilderState();
        for (const node of nodeBuilder.updateAfterNodes)// update frame state for each node
        this.getNodeFrameForRender(renderObject).updateAfterNode(node);
    }
    /**
	 * Triggers the call of `update()` methods
	 * for all nodes of the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 */ updateForCompute(computeNode) {
        const nodeFrame = this.getNodeFrame();
        const nodeBuilder = this.getForCompute(computeNode);
        for (const node of nodeBuilder.updateNodes)nodeFrame.updateNode(node);
    }
    /**
	 * Triggers the call of `update()` methods
	 * for all nodes of the given compute node.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateForRender(renderObject) {
        const nodeFrame = this.getNodeFrameForRender(renderObject);
        const nodeBuilder = renderObject.getNodeBuilderState();
        for (const node of nodeBuilder.updateNodes)nodeFrame.updateNode(node);
    }
    /**
	 * Returns `true` if the given render object requires a refresh.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the given render object requires a refresh or not.
	 */ needsRefresh(renderObject) {
        const nodeFrame = this.getNodeFrameForRender(renderObject);
        const monitor = renderObject.getMonitor();
        return monitor.needsRefresh(renderObject, nodeFrame);
    }
    /**
	 * Frees the internal resources.
	 */ dispose() {
        super.dispose();
        this.nodeFrame = new $d89c9137a3d237c2$export$20d1e096ab9d190e();
        this.nodeBuilderCache = new Map();
        this.cacheLib = {};
    }
}
const $d89c9137a3d237c2$var$_plane = /*@__PURE__*/ new (0, $329ek.Plane)();
/**
 * Represents the state that is used to perform clipping via clipping planes.
 * There is a default clipping context for each render context. When the
 * scene holds instances of `ClippingGroup`, there will be a context for each
 * group.
 *
 * @private
 */ class $d89c9137a3d237c2$var$ClippingContext {
    /**
	 * Constructs a new clipping context.
	 *
	 * @param {?ClippingContext} [parentContext=null] - A reference to the parent clipping context.
	 */ constructor(parentContext = null){
        /**
		 * The clipping context's version.
		 *
		 * @type {number}
		 * @readonly
		 */ this.version = 0;
        /**
		 * Whether the intersection of the clipping planes is used to clip objects, rather than their union.
		 *
		 * @type {?boolean}
		 * @default null
		 */ this.clipIntersection = null;
        /**
		 * The clipping context's cache key.
		 *
		 * @type {string}
		 */ this.cacheKey = '';
        /**
		 * Whether the shadow pass is active or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.shadowPass = false;
        /**
		 * The view normal matrix.
		 *
		 * @type {Matrix3}
		 */ this.viewNormalMatrix = new (0, $329ek.Matrix3)();
        /**
		 * Internal cache for maintaining clipping contexts.
		 *
		 * @type {WeakMap<ClippingGroup,ClippingContext>}
		 */ this.clippingGroupContexts = new WeakMap();
        /**
		 * The intersection planes.
		 *
		 * @type {Array<Vector4>}
		 */ this.intersectionPlanes = [];
        /**
		 * The intersection planes.
		 *
		 * @type {Array<Vector4>}
		 */ this.unionPlanes = [];
        /**
		 * The version of the clipping context's parent context.
		 *
		 * @type {?number}
		 * @readonly
		 */ this.parentVersion = null;
        if (parentContext !== null) {
            this.viewNormalMatrix = parentContext.viewNormalMatrix;
            this.clippingGroupContexts = parentContext.clippingGroupContexts;
            this.shadowPass = parentContext.shadowPass;
            this.viewMatrix = parentContext.viewMatrix;
        }
    }
    /**
	 * Projects the given source clipping planes and writes the result into the
	 * destination array.
	 *
	 * @param {Array<Plane>} source - The source clipping planes.
	 * @param {Array<Vector4>} destination - The destination.
	 * @param {number} offset - The offset.
	 */ projectPlanes(source, destination, offset) {
        const l = source.length;
        for(let i = 0; i < l; i++){
            $d89c9137a3d237c2$var$_plane.copy(source[i]).applyMatrix4(this.viewMatrix, this.viewNormalMatrix);
            const v = destination[offset + i];
            const normal = $d89c9137a3d237c2$var$_plane.normal;
            v.x = -normal.x;
            v.y = -normal.y;
            v.z = -normal.z;
            v.w = $d89c9137a3d237c2$var$_plane.constant;
        }
    }
    /**
	 * Updates the root clipping context of a scene.
	 *
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 */ updateGlobal(scene, camera) {
        this.shadowPass = scene.overrideMaterial !== null && scene.overrideMaterial.isShadowPassMaterial;
        this.viewMatrix = camera.matrixWorldInverse;
        this.viewNormalMatrix.getNormalMatrix(this.viewMatrix);
    }
    /**
	 * Updates the clipping context.
	 *
	 * @param {ClippingContext} parentContext - The parent context.
	 * @param {ClippingGroup} clippingGroup - The clipping group this context belongs to.
	 */ update(parentContext, clippingGroup) {
        let update = false;
        if (parentContext.version !== this.parentVersion) {
            this.intersectionPlanes = Array.from(parentContext.intersectionPlanes);
            this.unionPlanes = Array.from(parentContext.unionPlanes);
            this.parentVersion = parentContext.version;
        }
        if (this.clipIntersection !== clippingGroup.clipIntersection) {
            this.clipIntersection = clippingGroup.clipIntersection;
            if (this.clipIntersection) this.unionPlanes.length = parentContext.unionPlanes.length;
            else this.intersectionPlanes.length = parentContext.intersectionPlanes.length;
        }
        const srcClippingPlanes = clippingGroup.clippingPlanes;
        const l = srcClippingPlanes.length;
        let dstClippingPlanes;
        let offset;
        if (this.clipIntersection) {
            dstClippingPlanes = this.intersectionPlanes;
            offset = parentContext.intersectionPlanes.length;
        } else {
            dstClippingPlanes = this.unionPlanes;
            offset = parentContext.unionPlanes.length;
        }
        if (dstClippingPlanes.length !== offset + l) {
            dstClippingPlanes.length = offset + l;
            for(let i = 0; i < l; i++)dstClippingPlanes[offset + i] = new (0, $329ek.Vector4)();
            update = true;
        }
        this.projectPlanes(srcClippingPlanes, dstClippingPlanes, offset);
        if (update) {
            this.version++;
            this.cacheKey = `${this.intersectionPlanes.length}:${this.unionPlanes.length}`;
        }
    }
    /**
	 * Returns a clipping context for the given clipping group.
	 *
	 * @param {ClippingGroup} clippingGroup - The clipping group.
	 * @return {ClippingContext} The clipping context.
	 */ getGroupContext(clippingGroup) {
        if (this.shadowPass && !clippingGroup.clipShadows) return this;
        let context = this.clippingGroupContexts.get(clippingGroup);
        if (context === undefined) {
            context = new $d89c9137a3d237c2$var$ClippingContext(this);
            this.clippingGroupContexts.set(clippingGroup, context);
        }
        context.update(this, clippingGroup);
        return context;
    }
    /**
	 * The count of union clipping planes.
	 *
	 * @type {number}
	 * @readonly
	 */ get unionClippingCount() {
        return this.unionPlanes.length;
    }
}
/**
 * This module is used to represent render bundles inside the renderer
 * for further processing.
 *
 * @private
 */ class $d89c9137a3d237c2$var$RenderBundle {
    /**
	 * Constructs a new bundle group.
	 *
	 * @param {BundleGroup} bundleGroup - The bundle group.
	 * @param {Camera} camera - The camera the bundle group is rendered with.
	 */ constructor(bundleGroup, camera){
        this.bundleGroup = bundleGroup;
        this.camera = camera;
    }
}
const $d89c9137a3d237c2$var$_chainKeys$1 = [];
/**
 * This renderer module manages render bundles.
 *
 * @private
 */ class $d89c9137a3d237c2$var$RenderBundles {
    /**
	 * Constructs a new render bundle management component.
	 */ constructor(){
        /**
		 * A chain map for maintaining the render bundles.
		 *
		 * @type {ChainMap}
		 */ this.bundles = new $d89c9137a3d237c2$var$ChainMap();
    }
    /**
	 * Returns a render bundle for the given bundle group and camera.
	 *
	 * @param {BundleGroup} bundleGroup - The bundle group.
	 * @param {Camera} camera - The camera the bundle group is rendered with.
	 * @return {RenderBundle} The render bundle.
	 */ get(bundleGroup, camera) {
        const bundles = this.bundles;
        $d89c9137a3d237c2$var$_chainKeys$1[0] = bundleGroup;
        $d89c9137a3d237c2$var$_chainKeys$1[1] = camera;
        let bundle = bundles.get($d89c9137a3d237c2$var$_chainKeys$1);
        if (bundle === undefined) {
            bundle = new $d89c9137a3d237c2$var$RenderBundle(bundleGroup, camera);
            bundles.set($d89c9137a3d237c2$var$_chainKeys$1, bundle);
        }
        $d89c9137a3d237c2$var$_chainKeys$1.length = 0;
        return bundle;
    }
    /**
	 * Frees all internal resources.
	 */ dispose() {
        this.bundles = new $d89c9137a3d237c2$var$ChainMap();
    }
}
/**
 * The purpose of a node library is to assign node implementations
 * to existing library features. In `WebGPURenderer` lights, materials
 * which are not based on `NodeMaterial` as well as tone mapping techniques
 * are implemented with node-based modules.
 *
 * @private
 */ class $d89c9137a3d237c2$var$NodeLibrary {
    /**
	 * Constructs a new node library.
	 */ constructor(){
        /**
		 * A weak map that maps lights to light nodes.
		 *
		 * @type {WeakMap<Light.constructor,AnalyticLightNode.constructor>}
		 */ this.lightNodes = new WeakMap();
        /**
		 * A map that maps materials to node materials.
		 *
		 * @type {Map<string,NodeMaterial.constructor>}
		 */ this.materialNodes = new Map();
        /**
		 * A map that maps tone mapping techniques (constants)
		 * to tone mapping node functions.
		 *
		 * @type {Map<number,Function>}
		 */ this.toneMappingNodes = new Map();
    }
    /**
	 * Returns a matching node material instance for the given material object.
	 *
	 * This method also assigns/copies the properties of the given material object
	 * to the node material. This is done to make sure the current material
	 * configuration carries over to the node version.
	 *
	 * @param {Material} material - A material.
	 * @return {NodeMaterial} The corresponding node material.
	 */ fromMaterial(material) {
        if (material.isNodeMaterial) return material;
        let nodeMaterial = null;
        const nodeMaterialClass = this.getMaterialNodeClass(material.type);
        if (nodeMaterialClass !== null) {
            nodeMaterial = new nodeMaterialClass();
            for(const key in material)nodeMaterial[key] = material[key];
        }
        return nodeMaterial;
    }
    /**
	 * Adds a tone mapping node function for a tone mapping technique (constant).
	 *
	 * @param {Function} toneMappingNode - The tone mapping node function.
	 * @param {number} toneMapping - The tone mapping.
	 */ addToneMapping(toneMappingNode, toneMapping) {
        this.addType(toneMappingNode, toneMapping, this.toneMappingNodes);
    }
    /**
	 * Returns a tone mapping node function for a tone mapping technique (constant).
	 *
	 * @param {number} toneMapping - The tone mapping.
	 * @return {?Function} The tone mapping node function. Returns `null` if no node function is found.
	 */ getToneMappingFunction(toneMapping) {
        return this.toneMappingNodes.get(toneMapping) || null;
    }
    /**
	 * Returns a node material class definition for a material type.
	 *
	 * @param {string} materialType - The material type.
	 * @return {?NodeMaterial.constructor} The node material class definition. Returns `null` if no node material is found.
	 */ getMaterialNodeClass(materialType) {
        return this.materialNodes.get(materialType) || null;
    }
    /**
	 * Adds a node material class definition for a given material type.
	 *
	 * @param {NodeMaterial.constructor} materialNodeClass - The node material class definition.
	 * @param {string} materialClassType - The material type.
	 */ addMaterial(materialNodeClass, materialClassType) {
        this.addType(materialNodeClass, materialClassType, this.materialNodes);
    }
    /**
	 * Returns a light node class definition for a light class definition.
	 *
	 * @param {Light.constructor} light - The light class definition.
	 * @return {?AnalyticLightNode.constructor} The light node class definition. Returns `null` if no light node is found.
	 */ getLightNodeClass(light) {
        return this.lightNodes.get(light) || null;
    }
    /**
	 * Adds a light node class definition for a given light class definition.
	 *
	 * @param {AnalyticLightNode.constructor} lightNodeClass - The light node class definition.
	 * @param {Light.constructor} lightClass - The light class definition.
	 */ addLight(lightNodeClass, lightClass) {
        this.addClass(lightNodeClass, lightClass, this.lightNodes);
    }
    /**
	 * Adds a node class definition for the given type to the provided type library.
	 *
	 * @param {Node.constructor} nodeClass - The node class definition.
	 * @param {number|string} type - The object type.
	 * @param {Map<number|string,Node.constructor>} library - The type library.
	 */ addType(nodeClass, type, library) {
        if (library.has(type)) {
            (0, $329ek.warn)(`Redefinition of node ${type}`);
            return;
        }
        if (typeof nodeClass !== 'function') throw new Error(`Node class ${nodeClass.name} is not a class.`);
        if (typeof type === 'function' || typeof type === 'object') throw new Error(`Base class ${type} is not a class.`);
        library.set(type, nodeClass);
    }
    /**
	 * Adds a node class definition for the given class definition to the provided type library.
	 *
	 * @param {Node.constructor} nodeClass - The node class definition.
	 * @param {Node.constructor} baseClass - The class definition.
	 * @param {WeakMap<Node.constructor, Node.constructor>} library - The type library.
	 */ addClass(nodeClass, baseClass, library) {
        if (library.has(baseClass)) {
            (0, $329ek.warn)(`Redefinition of node ${baseClass.name}`);
            return;
        }
        if (typeof nodeClass !== 'function') throw new Error(`Node class ${nodeClass.name} is not a class.`);
        if (typeof baseClass !== 'function') throw new Error(`Base class ${baseClass.name} is not a class.`);
        library.set(baseClass, nodeClass);
    }
}
const $d89c9137a3d237c2$var$_defaultLights = /*@__PURE__*/ new $d89c9137a3d237c2$export$577c410712851cc4();
const $d89c9137a3d237c2$var$_chainKeys = [];
/**
 * This renderer module manages the lights nodes which are unique
 * per scene and camera combination.
 *
 * The lights node itself is later configured in the render list
 * with the actual lights from the scene.
 *
 * @private
 * @augments ChainMap
 */ class $d89c9137a3d237c2$export$10b79c914aa1f585 extends $d89c9137a3d237c2$var$ChainMap {
    /**
	 * Constructs a lighting management component.
	 */ constructor(){
        super();
    }
    /**
	 * Creates a new lights node for the given array of lights.
	 *
	 * @param {Array<Light>} lights - The render object.
	 * @return {LightsNode} The lights node.
	 */ createNode(lights = []) {
        return new $d89c9137a3d237c2$export$577c410712851cc4().setLights(lights);
    }
    /**
	 * Returns a lights node for the given scene and camera.
	 *
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera.
	 * @return {LightsNode} The lights node.
	 */ getNode(scene, camera) {
        // ignore post-processing
        if (scene.isQuadMesh) return $d89c9137a3d237c2$var$_defaultLights;
        $d89c9137a3d237c2$var$_chainKeys[0] = scene;
        $d89c9137a3d237c2$var$_chainKeys[1] = camera;
        let node = this.get($d89c9137a3d237c2$var$_chainKeys);
        if (node === undefined) {
            node = this.createNode();
            this.set($d89c9137a3d237c2$var$_chainKeys, node);
        }
        $d89c9137a3d237c2$var$_chainKeys.length = 0;
        return node;
    }
}
/**
 * A special type of render target that is used when rendering
 * with the WebXR Device API.
 *
 * @private
 * @augments RenderTarget
 */ class $d89c9137a3d237c2$var$XRRenderTarget extends (0, $329ek.RenderTarget) {
    /**
	 * Constructs a new XR render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {Object} [options={}] - The configuration options.
	 */ constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isXRRenderTarget = true;
        /**
		 * Whether the attachments of the render target
		 * are defined by external textures. This flag is
		 * set to `true` when using the WebXR Layers API.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 */ this._hasExternalTextures = false;
        /**
		 * Whether a depth buffer should automatically be allocated
		 * for this XR render target or not.
		 *
		 * Allocating a depth buffer is the default behavior of XR render
		 * targets. However, when using the WebXR Layers API, this flag
		 * must be set to `false` when the `ignoreDepthValues` property of
		 * the projection layers evaluates to `false`.
		 *
		 * Reference: {@link https://www.w3.org/TR/webxrlayers-1/#dom-xrprojectionlayer-ignoredepthvalues}.
		 *
		 * @private
		 * @type {boolean}
		 * @default true
		 */ this._autoAllocateDepthBuffer = true;
        /**
		 * Whether this render target is associated with a XRWebGLLayer.
		 *
		 * A XRWebGLLayer points to an opaque framebuffer. Basically,
		 * this means that you don't have access to its bound color,
		 * stencil and depth buffers. We need to handle this framebuffer
		 * differently since its textures are always bound.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 * */ this._isOpaqueFramebuffer = false;
    }
    copy(source) {
        super.copy(source);
        this._hasExternalTextures = source._hasExternalTextures;
        this._autoAllocateDepthBuffer = source._autoAllocateDepthBuffer;
        this._isOpaqueFramebuffer = source._isOpaqueFramebuffer;
        return this;
    }
}
const $d89c9137a3d237c2$var$_cameraLPos = /*@__PURE__*/ new (0, $329ek.Vector3)();
const $d89c9137a3d237c2$var$_cameraRPos = /*@__PURE__*/ new (0, $329ek.Vector3)();
/**
 * The XR manager is built on top of the WebXR Device API to
 * manage XR sessions with `WebGPURenderer`.
 *
 * XR is currently only supported with a WebGL 2 backend.
 *
 * @augments EventDispatcher
 */ class $d89c9137a3d237c2$var$XRManager extends (0, $329ek.EventDispatcher) {
    /**
	 * Constructs a new XR manager.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {boolean} [multiview=false] - Enables multiview if the device supports it.
	 */ constructor(renderer, multiview = false){
        super();
        /**
		 * This flag globally enables XR rendering.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.enabled = false;
        /**
		 * Whether the XR device is currently presenting or not.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.isPresenting = false;
        /**
		 * Whether the XR camera should automatically be updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.cameraAutoUpdate = true;
        /**
		 * The renderer.
		 *
		 * @private
		 * @type {Renderer}
		 */ this._renderer = renderer;
        // camera
        /**
		 * Represents the camera for the left eye.
		 *
		 * @private
		 * @type {PerspectiveCamera}
		 */ this._cameraL = new (0, $329ek.PerspectiveCamera)();
        this._cameraL.viewport = new (0, $329ek.Vector4)();
        /**
		 * Represents the camera for the right eye.
		 *
		 * @private
		 * @type {PerspectiveCamera}
		 */ this._cameraR = new (0, $329ek.PerspectiveCamera)();
        this._cameraR.viewport = new (0, $329ek.Vector4)();
        /**
		 * A list of cameras used for rendering the XR views.
		 *
		 * @private
		 * @type {Array<Camera>}
		 */ this._cameras = [
            this._cameraL,
            this._cameraR
        ];
        /**
		 * The main XR camera.
		 *
		 * @private
		 * @type {ArrayCamera}
		 */ this._cameraXR = new (0, $329ek.ArrayCamera)();
        /**
		 * The current near value of the XR camera.
		 *
		 * @private
		 * @type {?number}
		 * @default null
		 */ this._currentDepthNear = null;
        /**
		 * The current far value of the XR camera.
		 *
		 * @private
		 * @type {?number}
		 * @default null
		 */ this._currentDepthFar = null;
        /**
		 * A list of WebXR controllers requested by the application.
		 *
		 * @private
		 * @type {Array<WebXRController>}
		 */ this._controllers = [];
        /**
		 * A list of XR input source. Each input source belongs to
		 * an instance of WebXRController.
		 *
		 * @private
		 * @type {Array<XRInputSource?>}
		 */ this._controllerInputSources = [];
        /**
		 * The XR render target that represents the rendering destination
		 * during an active XR session.
		 *
		 * @private
		 * @type {?RenderTarget}
		 * @default null
		 */ this._xrRenderTarget = null;
        /**
		 * An array holding all the non-projection layers
		 *
		 * @private
		 * @type {Array<Object>}
		 * @default []
		 */ this._layers = [];
        /**
		 * Whether the XR session uses layers.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 */ this._sessionUsesLayers = false;
        /**
		 * Whether the device supports binding gl objects.
		 *
		 * @private
		 * @type {boolean}
		 * @readonly
		 */ this._supportsGlBinding = typeof XRWebGLBinding !== 'undefined';
        this._frameBufferTargets = null;
        /**
		 * Helper function to create native WebXR Layer.
		 *
		 * @private
		 * @type {Function}
		 */ this._createXRLayer = $d89c9137a3d237c2$var$createXRLayer.bind(this);
        /**
		* The current WebGL context.
		*
		* @private
		* @type {?WebGL2RenderingContext}
		* @default null
		*/ this._gl = null;
        /**
		 * The current animation context.
		 *
		 * @private
		 * @type {?Window}
		 * @default null
		 */ this._currentAnimationContext = null;
        /**
		 * The current animation loop.
		 *
		 * @private
		 * @type {?Function}
		 * @default null
		 */ this._currentAnimationLoop = null;
        /**
		 * The current pixel ratio.
		 *
		 * @private
		 * @type {?number}
		 * @default null
		 */ this._currentPixelRatio = null;
        /**
		 * The current size of the renderer's canvas
		 * in logical pixel unit.
		 *
		 * @private
		 * @type {Vector2}
		 */ this._currentSize = new (0, $329ek.Vector2)();
        /**
		 * The default event listener for handling events inside a XR session.
		 *
		 * @private
		 * @type {Function}
		 */ this._onSessionEvent = $d89c9137a3d237c2$var$onSessionEvent.bind(this);
        /**
		 * The event listener for handling the end of a XR session.
		 *
		 * @private
		 * @type {Function}
		 */ this._onSessionEnd = $d89c9137a3d237c2$var$onSessionEnd.bind(this);
        /**
		 * The event listener for handling the `inputsourceschange` event.
		 *
		 * @private
		 * @type {Function}
		 */ this._onInputSourcesChange = $d89c9137a3d237c2$var$onInputSourcesChange.bind(this);
        /**
		 * The animation loop which is used as a replacement for the default
		 * animation loop of the application. It is only used when a XR session
		 * is active.
		 *
		 * @private
		 * @type {Function}
		 */ this._onAnimationFrame = $d89c9137a3d237c2$var$onAnimationFrame.bind(this);
        /**
		 * The current XR reference space.
		 *
		 * @private
		 * @type {?XRReferenceSpace}
		 * @default null
		 */ this._referenceSpace = null;
        /**
		 * The current XR reference space type.
		 *
		 * @private
		 * @type {XRReferenceSpaceType}
		 * @default 'local-floor'
		 */ this._referenceSpaceType = 'local-floor';
        /**
		 * A custom reference space defined by the application.
		 *
		 * @private
		 * @type {?XRReferenceSpace}
		 * @default null
		 */ this._customReferenceSpace = null;
        /**
		 * The framebuffer scale factor.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._framebufferScaleFactor = 1;
        /**
		 * The foveation factor.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._foveation = 1.0;
        /**
		 * A reference to the current XR session.
		 *
		 * @private
		 * @type {?XRSession}
		 * @default null
		 */ this._session = null;
        /**
		 * A reference to the current XR base layer.
		 *
		 * @private
		 * @type {?XRWebGLLayer}
		 * @default null
		 */ this._glBaseLayer = null;
        /**
		 * A reference to the current XR binding.
		 *
		 * @private
		 * @type {?XRWebGLBinding}
		 * @default null
		 */ this._glBinding = null;
        /**
		 * A reference to the current XR projection layer.
		 *
		 * @private
		 * @type {?XRProjectionLayer}
		 * @default null
		 */ this._glProjLayer = null;
        /**
		 * A reference to the current XR frame.
		 *
		 * @private
		 * @type {?XRFrame}
		 * @default null
		 */ this._xrFrame = null;
        /**
		 * Whether the browser supports the APIs necessary to use XRProjectionLayers.
		 *
		 * Note: this does not represent XRSession explicitly requesting
		 * `'layers'` as a feature - see `_sessionUsesLayers` and #30112
		 *
		 * @private
		 * @type {boolean}
		 * @readonly
		 */ this._supportsLayers = this._supportsGlBinding && 'createProjectionLayer' in XRWebGLBinding.prototype; // eslint-disable-line compat/compat
        /**
		 * Whether the usage of multiview has been requested by the application or not.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this._useMultiviewIfPossible = multiview;
        /**
		 * Whether the usage of multiview is actually enabled. This flag only evaluates to `true`
		 * if multiview has been requested by the application and the `OVR_multiview2` is available.
		 *
		 * @private
		 * @type {boolean}
		 * @readonly
		 */ this._useMultiview = false;
    }
    /**
	 * Returns an instance of `THREE.Group` that represents the transformation
	 * of a XR controller in target ray space. The requested controller is defined
	 * by the given index.
	 *
	 * @param {number} index - The index of the XR controller.
	 * @return {Group} A group that represents the controller's transformation.
	 */ getController(index) {
        const controller = this._getController(index);
        return controller.getTargetRaySpace();
    }
    /**
	 * Returns an instance of `THREE.Group` that represents the transformation
	 * of a XR controller in grip space. The requested controller is defined
	 * by the given index.
	 *
	 * @param {number} index - The index of the XR controller.
	 * @return {Group} A group that represents the controller's transformation.
	 */ getControllerGrip(index) {
        const controller = this._getController(index);
        return controller.getGripSpace();
    }
    /**
	 * Returns an instance of `THREE.Group` that represents the transformation
	 * of a XR controller in hand space. The requested controller is defined
	 * by the given index.
	 *
	 * @param {number} index - The index of the XR controller.
	 * @return {Group} A group that represents the controller's transformation.
	 */ getHand(index) {
        const controller = this._getController(index);
        return controller.getHandSpace();
    }
    /**
	 * Returns the foveation value.
	 *
	 * @return {number|undefined} The foveation value. Returns `undefined` if no base or projection layer is defined.
	 */ getFoveation() {
        if (this._glProjLayer === null && this._glBaseLayer === null) return undefined;
        return this._foveation;
    }
    /**
	 * Sets the foveation value.
	 *
	 * @param {number} foveation - A number in the range `[0,1]` where `0` means no foveation (full resolution)
	 * and `1` means maximum foveation (the edges render at lower resolution).
	 */ setFoveation(foveation) {
        this._foveation = foveation;
        if (this._glProjLayer !== null) this._glProjLayer.fixedFoveation = foveation;
        if (this._glBaseLayer !== null && this._glBaseLayer.fixedFoveation !== undefined) this._glBaseLayer.fixedFoveation = foveation;
    }
    /**
	 * Returns the framebuffer scale factor.
	 *
	 * @return {number} The framebuffer scale factor.
	 */ getFramebufferScaleFactor() {
        return this._framebufferScaleFactor;
    }
    /**
	 * Sets the framebuffer scale factor.
	 *
	 * This method can not be used during a XR session.
	 *
	 * @param {number} factor - The framebuffer scale factor.
	 */ setFramebufferScaleFactor(factor) {
        this._framebufferScaleFactor = factor;
        if (this.isPresenting === true) (0, $329ek.warn)('XRManager: Cannot change framebuffer scale while presenting.');
    }
    /**
	 * Returns the reference space type.
	 *
	 * @return {XRReferenceSpaceType} The reference space type.
	 */ getReferenceSpaceType() {
        return this._referenceSpaceType;
    }
    /**
	 * Sets the reference space type.
	 *
	 * This method can not be used during a XR session.
	 *
	 * @param {XRReferenceSpaceType} type - The reference space type.
	 */ setReferenceSpaceType(type) {
        this._referenceSpaceType = type;
        if (this.isPresenting === true) (0, $329ek.warn)('XRManager: Cannot change reference space type while presenting.');
    }
    /**
	 * Returns the XR reference space.
	 *
	 * @return {XRReferenceSpace} The XR reference space.
	 */ getReferenceSpace() {
        return this._customReferenceSpace || this._referenceSpace;
    }
    /**
	 * Sets a custom XR reference space.
	 *
	 * @param {XRReferenceSpace} space - The XR reference space.
	 */ setReferenceSpace(space) {
        this._customReferenceSpace = space;
    }
    /**
	 * Returns the XR camera.
	 *
	 * @return {ArrayCamera} The XR camera.
	 */ getCamera() {
        return this._cameraXR;
    }
    /**
	 * Returns the environment blend mode from the current XR session.
	 *
	 * @return {'opaque'|'additive'|'alpha-blend'|undefined} The environment blend mode. Returns `undefined` when used outside of a XR session.
	 */ getEnvironmentBlendMode() {
        if (this._session !== null) return this._session.environmentBlendMode;
    }
    /**
	 * Returns the current XR binding.
	 *
	 * Creates a new binding if needed and the browser is
	 * capable of doing so.
	 *
	 * @return {?XRWebGLBinding} The XR binding. Returns `null` if one cannot be created.
	 */ getBinding() {
        if (this._glBinding === null && this._supportsGlBinding) this._glBinding = new XRWebGLBinding(this._session, this._gl);
        return this._glBinding;
    }
    /**
	 * Returns the current XR frame.
	 *
	 * @return {?XRFrame} The XR frame. Returns `null` when used outside a XR session.
	 */ getFrame() {
        return this._xrFrame;
    }
    /**
	 * Returns `true` if the engine renders to a multiview target.
	 *
	 * @return {boolean} Whether the engine renders to a multiview render target or not.
	 */ useMultiview() {
        return this._useMultiview;
    }
    /**
	 * This method can be used in XR applications to create a quadratic layer that presents a separate
	 * rendered scene.
	 *
	 * @param {number} width - The width of the layer plane in world units.
	 * @param {number} height - The height of the layer plane in world units.
	 * @param {Vector3} translation - The position/translation of the layer plane in world units.
	 * @param {Quaternion} quaternion - The orientation of the layer plane expressed as a quaternion.
	 * @param {number} pixelwidth - The width of the layer's render target in pixels.
	 * @param {number} pixelheight - The height of the layer's render target in pixels.
	 * @param {Function} rendercall - A callback function that renders the layer. Similar to code in
	 * the default animation loop, this method can be used to update/transform 3D object in the layer's scene.
	 * @param {Object} [attributes={}] - Allows to configure the layer's render target.
	 * @return {Mesh} A mesh representing the quadratic XR layer. This mesh should be added to the XR scene.
	 */ createQuadLayer(width, height, translation, quaternion, pixelwidth, pixelheight, rendercall, attributes = {}) {
        const geometry = new (0, $329ek.PlaneGeometry)(width, height);
        const renderTarget = new $d89c9137a3d237c2$var$XRRenderTarget(pixelwidth, pixelheight, {
            format: (0, $329ek.RGBAFormat),
            type: (0, $329ek.UnsignedByteType),
            depthTexture: new (0, $329ek.DepthTexture)(pixelwidth, pixelheight, attributes.stencil ? (0, $329ek.UnsignedInt248Type) : (0, $329ek.UnsignedIntType), undefined, undefined, undefined, undefined, undefined, undefined, attributes.stencil ? (0, $329ek.DepthStencilFormat) : (0, $329ek.DepthFormat)),
            stencilBuffer: attributes.stencil,
            resolveDepthBuffer: false,
            resolveStencilBuffer: false
        });
        renderTarget._autoAllocateDepthBuffer = true;
        const material = new (0, $329ek.MeshBasicMaterial)({
            color: 0xffffff,
            side: (0, $329ek.FrontSide)
        });
        material.map = renderTarget.texture;
        material.map.offset.y = 1;
        material.map.repeat.y = -1;
        const plane = new (0, $329ek.Mesh)(geometry, material);
        plane.position.copy(translation);
        plane.quaternion.copy(quaternion);
        const layer = {
            type: 'quad',
            width: width,
            height: height,
            translation: translation,
            quaternion: quaternion,
            pixelwidth: pixelwidth,
            pixelheight: pixelheight,
            plane: plane,
            material: material,
            rendercall: rendercall,
            renderTarget: renderTarget
        };
        this._layers.push(layer);
        if (this._session !== null) {
            layer.plane.material = new (0, $329ek.MeshBasicMaterial)({
                color: 0xffffff,
                side: (0, $329ek.FrontSide)
            });
            layer.plane.material.blending = (0, $329ek.CustomBlending);
            layer.plane.material.blendEquation = (0, $329ek.AddEquation);
            layer.plane.material.blendSrc = (0, $329ek.ZeroFactor);
            layer.plane.material.blendDst = (0, $329ek.ZeroFactor);
            layer.xrlayer = this._createXRLayer(layer);
            const xrlayers = this._session.renderState.layers;
            xrlayers.unshift(layer.xrlayer);
            this._session.updateRenderState({
                layers: xrlayers
            });
        } else renderTarget.isXRRenderTarget = false;
        return plane;
    }
    /**
	 * This method can be used in XR applications to create a cylindrical layer that presents a separate
	 * rendered scene.
	 *
	 * @param {number} radius - The radius of the cylinder in world units.
	 * @param {number} centralAngle - The central angle of the cylinder in radians.
	 * @param {number} aspectratio - The aspect ratio.
	 * @param {Vector3} translation - The position/translation of the layer plane in world units.
	 * @param {Quaternion} quaternion - The orientation of the layer plane expressed as a quaternion.
	 * @param {number} pixelwidth - The width of the layer's render target in pixels.
	 * @param {number} pixelheight - The height of the layer's render target in pixels.
	 * @param {Function} rendercall - A callback function that renders the layer. Similar to code in
	 * the default animation loop, this method can be used to update/transform 3D object in the layer's scene.
	 * @param {Object} [attributes={}] - Allows to configure the layer's render target.
	 * @return {Mesh} A mesh representing the cylindrical XR layer. This mesh should be added to the XR scene.
	 */ createCylinderLayer(radius, centralAngle, aspectratio, translation, quaternion, pixelwidth, pixelheight, rendercall, attributes = {}) {
        const geometry = new (0, $329ek.CylinderGeometry)(radius, radius, radius * centralAngle / aspectratio, 64, 64, true, Math.PI - centralAngle / 2, centralAngle);
        const renderTarget = new $d89c9137a3d237c2$var$XRRenderTarget(pixelwidth, pixelheight, {
            format: (0, $329ek.RGBAFormat),
            type: (0, $329ek.UnsignedByteType),
            depthTexture: new (0, $329ek.DepthTexture)(pixelwidth, pixelheight, attributes.stencil ? (0, $329ek.UnsignedInt248Type) : (0, $329ek.UnsignedIntType), undefined, undefined, undefined, undefined, undefined, undefined, attributes.stencil ? (0, $329ek.DepthStencilFormat) : (0, $329ek.DepthFormat)),
            stencilBuffer: attributes.stencil,
            resolveDepthBuffer: false,
            resolveStencilBuffer: false
        });
        renderTarget._autoAllocateDepthBuffer = true;
        const material = new (0, $329ek.MeshBasicMaterial)({
            color: 0xffffff,
            side: (0, $329ek.BackSide)
        });
        material.map = renderTarget.texture;
        material.map.offset.y = 1;
        material.map.repeat.y = -1;
        const plane = new (0, $329ek.Mesh)(geometry, material);
        plane.position.copy(translation);
        plane.quaternion.copy(quaternion);
        const layer = {
            type: 'cylinder',
            radius: radius,
            centralAngle: centralAngle,
            aspectratio: aspectratio,
            translation: translation,
            quaternion: quaternion,
            pixelwidth: pixelwidth,
            pixelheight: pixelheight,
            plane: plane,
            material: material,
            rendercall: rendercall,
            renderTarget: renderTarget
        };
        this._layers.push(layer);
        if (this._session !== null) {
            layer.plane.material = new (0, $329ek.MeshBasicMaterial)({
                color: 0xffffff,
                side: (0, $329ek.BackSide)
            });
            layer.plane.material.blending = (0, $329ek.CustomBlending);
            layer.plane.material.blendEquation = (0, $329ek.AddEquation);
            layer.plane.material.blendSrc = (0, $329ek.ZeroFactor);
            layer.plane.material.blendDst = (0, $329ek.ZeroFactor);
            layer.xrlayer = this._createXRLayer(layer);
            const xrlayers = this._session.renderState.layers;
            xrlayers.unshift(layer.xrlayer);
            this._session.updateRenderState({
                layers: xrlayers
            });
        } else renderTarget.isXRRenderTarget = false;
        return plane;
    }
    /**
	 * Renders the XR layers that have been previously added to the scene.
	 *
	 * This method is usually called in your animation loop before rendering
	 * the actual scene via `renderer.render( scene, camera );`.
	 */ renderLayers() {
        const translationObject = new (0, $329ek.Vector3)();
        const quaternionObject = new (0, $329ek.Quaternion)();
        const renderer = this._renderer;
        const wasPresenting = this.isPresenting;
        const rendererOutputTarget = renderer.getOutputRenderTarget();
        const rendererFramebufferTarget = renderer._frameBufferTarget;
        this.isPresenting = false;
        const rendererSize = new (0, $329ek.Vector2)();
        renderer.getSize(rendererSize);
        const rendererQuad = renderer._quad;
        for (const layer of this._layers){
            layer.renderTarget.isXRRenderTarget = this._session !== null;
            layer.renderTarget._hasExternalTextures = layer.renderTarget.isXRRenderTarget;
            if (layer.renderTarget.isXRRenderTarget && this._sessionUsesLayers) {
                layer.xrlayer.transform = new XRRigidTransform(layer.plane.getWorldPosition(translationObject), layer.plane.getWorldQuaternion(quaternionObject));
                const glSubImage = this._glBinding.getSubImage(layer.xrlayer, this._xrFrame);
                renderer.backend.setXRRenderTargetTextures(layer.renderTarget, glSubImage.colorTexture, undefined);
                renderer._setXRLayerSize(layer.renderTarget.width, layer.renderTarget.height);
                renderer.setOutputRenderTarget(layer.renderTarget);
                renderer.setRenderTarget(null);
                renderer._frameBufferTarget = null;
                this._frameBufferTargets || (this._frameBufferTargets = new WeakMap());
                const { frameBufferTarget: frameBufferTarget, quad: quad } = this._frameBufferTargets.get(layer.renderTarget) || {
                    frameBufferTarget: null,
                    quad: null
                };
                if (!frameBufferTarget) {
                    renderer._quad = new $d89c9137a3d237c2$export$266ce19fe399ee9a(new $d89c9137a3d237c2$export$caaf3b30a544c946());
                    this._frameBufferTargets.set(layer.renderTarget, {
                        frameBufferTarget: renderer._getFrameBufferTarget(),
                        quad: renderer._quad
                    });
                } else {
                    renderer._frameBufferTarget = frameBufferTarget;
                    renderer._quad = quad;
                }
                layer.rendercall();
                renderer._frameBufferTarget = null;
            } else {
                renderer.setRenderTarget(layer.renderTarget);
                layer.rendercall();
            }
        }
        renderer.setRenderTarget(null);
        renderer.setOutputRenderTarget(rendererOutputTarget);
        renderer._frameBufferTarget = rendererFramebufferTarget;
        renderer._setXRLayerSize(rendererSize.x, rendererSize.y);
        renderer._quad = rendererQuad;
        this.isPresenting = wasPresenting;
    }
    /**
	 * Returns the current XR session.
	 *
	 * @return {?XRSession} The XR session. Returns `null` when used outside a XR session.
	 */ getSession() {
        return this._session;
    }
    /**
	 * After a XR session has been requested usually with one of the `*Button` modules, it
	 * is injected into the renderer with this method. This method triggers the start of
	 * the actual XR rendering.
	 *
	 * @async
	 * @param {XRSession} session - The XR session to set.
	 * @return {Promise} A Promise that resolves when the session has been set.
	 */ async setSession(session) {
        const renderer = this._renderer;
        const backend = renderer.backend;
        this._gl = renderer.getContext();
        const gl = this._gl;
        const attributes = gl.getContextAttributes();
        this._session = session;
        if (session !== null) {
            if (backend.isWebGPUBackend === true) throw new Error('THREE.XRManager: XR is currently not supported with a WebGPU backend. Use WebGL by passing "{ forceWebGL: true }" to the constructor of the renderer.');
            session.addEventListener('select', this._onSessionEvent);
            session.addEventListener('selectstart', this._onSessionEvent);
            session.addEventListener('selectend', this._onSessionEvent);
            session.addEventListener('squeeze', this._onSessionEvent);
            session.addEventListener('squeezestart', this._onSessionEvent);
            session.addEventListener('squeezeend', this._onSessionEvent);
            session.addEventListener('end', this._onSessionEnd);
            session.addEventListener('inputsourceschange', this._onInputSourcesChange);
            await backend.makeXRCompatible();
            this._currentPixelRatio = renderer.getPixelRatio();
            renderer.getSize(this._currentSize);
            this._currentAnimationContext = renderer._animation.getContext();
            this._currentAnimationLoop = renderer._animation.getAnimationLoop();
            renderer._animation.stop();
            //
            if (this._supportsLayers === true) {
                // default path using XRProjectionLayer
                let depthFormat = null;
                let depthType = null;
                let glDepthFormat = null;
                if (renderer.depth) {
                    glDepthFormat = renderer.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                    depthFormat = renderer.stencil ? (0, $329ek.DepthStencilFormat) : (0, $329ek.DepthFormat);
                    depthType = renderer.stencil ? (0, $329ek.UnsignedInt248Type) : (0, $329ek.UnsignedIntType);
                }
                const projectionlayerInit = {
                    colorFormat: gl.RGBA8,
                    depthFormat: glDepthFormat,
                    scaleFactor: this._framebufferScaleFactor,
                    clearOnAccess: false
                };
                if (this._useMultiviewIfPossible && renderer.hasFeature('OVR_multiview2')) {
                    projectionlayerInit.textureType = 'texture-array';
                    this._useMultiview = true;
                }
                this._glBinding = this.getBinding();
                const glProjLayer = this._glBinding.createProjectionLayer(projectionlayerInit);
                const layersArray = [
                    glProjLayer
                ];
                this._glProjLayer = glProjLayer;
                renderer.setPixelRatio(1);
                renderer._setXRLayerSize(glProjLayer.textureWidth, glProjLayer.textureHeight);
                const depth = this._useMultiview ? 2 : 1;
                const depthTexture = new (0, $329ek.DepthTexture)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat, depth);
                this._xrRenderTarget = new $d89c9137a3d237c2$var$XRRenderTarget(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                    format: (0, $329ek.RGBAFormat),
                    type: (0, $329ek.UnsignedByteType),
                    colorSpace: renderer.outputColorSpace,
                    depthTexture: depthTexture,
                    stencilBuffer: renderer.stencil,
                    samples: attributes.antialias ? 4 : 0,
                    resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                    resolveStencilBuffer: glProjLayer.ignoreDepthValues === false,
                    depth: this._useMultiview ? 2 : 1,
                    multiview: this._useMultiview
                });
                this._xrRenderTarget._hasExternalTextures = true;
                this._xrRenderTarget.depth = this._useMultiview ? 2 : 1;
                this._sessionUsesLayers = session.enabledFeatures.includes('layers');
                this._referenceSpace = await session.requestReferenceSpace(this.getReferenceSpaceType());
                if (this._sessionUsesLayers) // switch layers to native
                for (const layer of this._layers){
                    // change material so it "punches" out a hole to show the XR Layer.
                    layer.plane.material = new (0, $329ek.MeshBasicMaterial)({
                        color: 0xffffff,
                        side: layer.type === 'cylinder' ? (0, $329ek.BackSide) : (0, $329ek.FrontSide)
                    });
                    layer.plane.material.blending = (0, $329ek.CustomBlending);
                    layer.plane.material.blendEquation = (0, $329ek.AddEquation);
                    layer.plane.material.blendSrc = (0, $329ek.ZeroFactor);
                    layer.plane.material.blendDst = (0, $329ek.ZeroFactor);
                    layer.xrlayer = this._createXRLayer(layer);
                    layersArray.unshift(layer.xrlayer);
                }
                session.updateRenderState({
                    layers: layersArray
                });
            } else {
                // fallback to XRWebGLLayer
                const layerInit = {
                    antialias: renderer.currentSamples > 0,
                    alpha: true,
                    depth: renderer.depth,
                    stencil: renderer.stencil,
                    framebufferScaleFactor: this.getFramebufferScaleFactor()
                };
                const glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                this._glBaseLayer = glBaseLayer;
                session.updateRenderState({
                    baseLayer: glBaseLayer
                });
                renderer.setPixelRatio(1);
                renderer._setXRLayerSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight);
                this._xrRenderTarget = new $d89c9137a3d237c2$var$XRRenderTarget(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                    format: (0, $329ek.RGBAFormat),
                    type: (0, $329ek.UnsignedByteType),
                    colorSpace: renderer.outputColorSpace,
                    stencilBuffer: renderer.stencil,
                    resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                    resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                });
                this._xrRenderTarget._isOpaqueFramebuffer = true;
                this._referenceSpace = await session.requestReferenceSpace(this.getReferenceSpaceType());
            }
            //
            this.setFoveation(this.getFoveation());
            renderer._animation.setAnimationLoop(this._onAnimationFrame);
            renderer._animation.setContext(session);
            renderer._animation.start();
            this.isPresenting = true;
            this.dispatchEvent({
                type: 'sessionstart'
            });
        }
    }
    /**
	 * This method is called by the renderer per frame and updates the XR camera
	 * and it sub cameras based on the given camera. The given camera is the "user"
	 * camera created on application level and used for non-XR rendering.
	 *
	 * @param {PerspectiveCamera} camera - The camera.
	 */ updateCamera(camera) {
        const session = this._session;
        if (session === null) return;
        const depthNear = camera.near;
        const depthFar = camera.far;
        const cameraXR = this._cameraXR;
        const cameraL = this._cameraL;
        const cameraR = this._cameraR;
        cameraXR.near = cameraR.near = cameraL.near = depthNear;
        cameraXR.far = cameraR.far = cameraL.far = depthFar;
        cameraXR.isMultiViewCamera = this._useMultiview;
        if (this._currentDepthNear !== cameraXR.near || this._currentDepthFar !== cameraXR.far) {
            // Note that the new renderState won't apply until the next frame. See #18320
            session.updateRenderState({
                depthNear: cameraXR.near,
                depthFar: cameraXR.far
            });
            this._currentDepthNear = cameraXR.near;
            this._currentDepthFar = cameraXR.far;
        }
        // inherit camera layers and enable eye layers (1 = left, 2 = right)
        cameraXR.layers.mask = camera.layers.mask | 6;
        cameraL.layers.mask = cameraXR.layers.mask & 3;
        cameraR.layers.mask = cameraXR.layers.mask & 5;
        const parent = camera.parent;
        const cameras = cameraXR.cameras;
        $d89c9137a3d237c2$var$updateCamera(cameraXR, parent);
        for(let i = 0; i < cameras.length; i++)$d89c9137a3d237c2$var$updateCamera(cameras[i], parent);
        // update projection matrix for proper view frustum culling
        if (cameras.length === 2) $d89c9137a3d237c2$var$setProjectionFromUnion(cameraXR, cameraL, cameraR);
        else // assume single camera setup (AR)
        cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
        // update user camera and its children
        $d89c9137a3d237c2$var$updateUserCamera(camera, cameraXR, parent);
    }
    /**
	 * Returns a WebXR controller for the given controller index.
	 *
	 * @private
	 * @param {number} index - The controller index.
	 * @return {WebXRController} The XR controller.
	 */ _getController(index) {
        let controller = this._controllers[index];
        if (controller === undefined) {
            controller = new (0, $329ek.WebXRController)();
            this._controllers[index] = controller;
        }
        return controller;
    }
}
/**
 * Assumes 2 cameras that are parallel and share an X-axis, and that
 * the cameras' projection and world matrices have already been set.
 * And that near and far planes are identical for both cameras.
 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
 *
 * @param {ArrayCamera} camera - The camera to update.
 * @param {PerspectiveCamera} cameraL - The left camera.
 * @param {PerspectiveCamera} cameraR - The right camera.
 */ function $d89c9137a3d237c2$var$setProjectionFromUnion(camera, cameraL, cameraR) {
    $d89c9137a3d237c2$var$_cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
    $d89c9137a3d237c2$var$_cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
    const ipd = $d89c9137a3d237c2$var$_cameraLPos.distanceTo($d89c9137a3d237c2$var$_cameraRPos);
    const projL = cameraL.projectionMatrix.elements;
    const projR = cameraR.projectionMatrix.elements;
    // VR systems will have identical far and near planes, and
    // most likely identical top and bottom frustum extents.
    // Use the left camera for these values.
    const near = projL[14] / (projL[10] - 1);
    const far = projL[14] / (projL[10] + 1);
    const topFov = (projL[9] + 1) / projL[5];
    const bottomFov = (projL[9] - 1) / projL[5];
    const leftFov = (projL[8] - 1) / projL[0];
    const rightFov = (projR[8] + 1) / projR[0];
    const left = near * leftFov;
    const right = near * rightFov;
    // Calculate the new camera's position offset from the
    // left camera. xOffset should be roughly half `ipd`.
    const zOffset = ipd / (-leftFov + rightFov);
    const xOffset = zOffset * -leftFov;
    // TODO: Better way to apply this offset?
    cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
    camera.translateX(xOffset);
    camera.translateZ(zOffset);
    camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
    camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
    // Check if the projection uses an infinite far plane.
    if (projL[10] === -1) {
        // Use the projection matrix from the left eye.
        // The camera offset is sufficient to include the view volumes
        // of both eyes (assuming symmetric projections).
        camera.projectionMatrix.copy(cameraL.projectionMatrix);
        camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
    } else {
        // Find the union of the frustum values of the cameras and scale
        // the values so that the near plane's position does not change in world space,
        // although must now be relative to the new union camera.
        const near2 = near + zOffset;
        const far2 = far + zOffset;
        const left2 = left - xOffset;
        const right2 = right + (ipd - xOffset);
        const top2 = topFov * far / far2 * near2;
        const bottom2 = bottomFov * far / far2 * near2;
        camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
    }
}
/**
 * Updates the world matrices for the given camera based on the parent 3D object.
 *
 * @inner
 * @param {Camera} camera - The camera to update.
 * @param {Object3D} parent - The parent 3D object.
 */ function $d89c9137a3d237c2$var$updateCamera(camera, parent) {
    if (parent === null) camera.matrixWorld.copy(camera.matrix);
    else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
    camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
}
/**
 * Updates the given camera with the transformation of the XR camera and parent object.
 *
 * @inner
 * @param {Camera} camera - The camera to update.
 * @param {ArrayCamera} cameraXR - The XR camera.
 * @param {Object3D} parent - The parent 3D object.
 */ function $d89c9137a3d237c2$var$updateUserCamera(camera, cameraXR, parent) {
    if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
    else {
        camera.matrix.copy(parent.matrixWorld);
        camera.matrix.invert();
        camera.matrix.multiply(cameraXR.matrixWorld);
    }
    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
    camera.updateMatrixWorld(true);
    camera.projectionMatrix.copy(cameraXR.projectionMatrix);
    camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
    if (camera.isPerspectiveCamera) {
        camera.fov = (0, $329ek.RAD2DEG) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
        camera.zoom = 1;
    }
}
function $d89c9137a3d237c2$var$onSessionEvent(event) {
    const controllerIndex = this._controllerInputSources.indexOf(event.inputSource);
    if (controllerIndex === -1) return;
    const controller = this._controllers[controllerIndex];
    if (controller !== undefined) {
        const referenceSpace = this.getReferenceSpace();
        controller.update(event.inputSource, event.frame, referenceSpace);
        controller.dispatchEvent({
            type: event.type,
            data: event.inputSource
        });
    }
}
function $d89c9137a3d237c2$var$onSessionEnd() {
    const session = this._session;
    const renderer = this._renderer;
    session.removeEventListener('select', this._onSessionEvent);
    session.removeEventListener('selectstart', this._onSessionEvent);
    session.removeEventListener('selectend', this._onSessionEvent);
    session.removeEventListener('squeeze', this._onSessionEvent);
    session.removeEventListener('squeezestart', this._onSessionEvent);
    session.removeEventListener('squeezeend', this._onSessionEvent);
    session.removeEventListener('end', this._onSessionEnd);
    session.removeEventListener('inputsourceschange', this._onInputSourcesChange);
    for(let i = 0; i < this._controllers.length; i++){
        const inputSource = this._controllerInputSources[i];
        if (inputSource === null) continue;
        this._controllerInputSources[i] = null;
        this._controllers[i].disconnect(inputSource);
    }
    this._currentDepthNear = null;
    this._currentDepthFar = null;
    // restore framebuffer/rendering state
    renderer._resetXRState();
    this._session = null;
    this._xrRenderTarget = null;
    this._glBinding = null;
    this._glBaseLayer = null;
    this._glProjLayer = null;
    // switch layers back to emulated
    if (this._sessionUsesLayers === true) for (const layer of this._layers){
        // Recreate layer render target to reset state
        layer.renderTarget = new $d89c9137a3d237c2$var$XRRenderTarget(layer.pixelwidth, layer.pixelheight, {
            format: (0, $329ek.RGBAFormat),
            type: (0, $329ek.UnsignedByteType),
            depthTexture: new (0, $329ek.DepthTexture)(layer.pixelwidth, layer.pixelheight, layer.stencilBuffer ? (0, $329ek.UnsignedInt248Type) : (0, $329ek.UnsignedIntType), undefined, undefined, undefined, undefined, undefined, undefined, layer.stencilBuffer ? (0, $329ek.DepthStencilFormat) : (0, $329ek.DepthFormat)),
            stencilBuffer: layer.stencilBuffer,
            resolveDepthBuffer: false,
            resolveStencilBuffer: false
        });
        layer.renderTarget.isXRRenderTarget = false;
        layer.plane.material = layer.material;
        layer.material.map = layer.renderTarget.texture;
        layer.material.map.offset.y = 1;
        layer.material.map.repeat.y = -1;
        delete layer.xrlayer;
    }
    //
    this.isPresenting = false;
    this._useMultiview = false;
    renderer._animation.stop();
    renderer._animation.setAnimationLoop(this._currentAnimationLoop);
    renderer._animation.setContext(this._currentAnimationContext);
    renderer._animation.start();
    renderer.setPixelRatio(this._currentPixelRatio);
    renderer.setSize(this._currentSize.width, this._currentSize.height, false);
    this.dispatchEvent({
        type: 'sessionend'
    });
}
function $d89c9137a3d237c2$var$onInputSourcesChange(event) {
    const controllers = this._controllers;
    const controllerInputSources = this._controllerInputSources;
    // Notify disconnected
    for(let i = 0; i < event.removed.length; i++){
        const inputSource = event.removed[i];
        const index = controllerInputSources.indexOf(inputSource);
        if (index >= 0) {
            controllerInputSources[index] = null;
            controllers[index].disconnect(inputSource);
        }
    }
    // Notify connected
    for(let i = 0; i < event.added.length; i++){
        const inputSource = event.added[i];
        let controllerIndex = controllerInputSources.indexOf(inputSource);
        if (controllerIndex === -1) {
            // Assign input source a controller that currently has no input source
            for(let i = 0; i < controllers.length; i++){
                if (i >= controllerInputSources.length) {
                    controllerInputSources.push(inputSource);
                    controllerIndex = i;
                    break;
                } else if (controllerInputSources[i] === null) {
                    controllerInputSources[i] = inputSource;
                    controllerIndex = i;
                    break;
                }
            }
            // If all controllers do currently receive input we ignore new ones
            if (controllerIndex === -1) break;
        }
        const controller = controllers[controllerIndex];
        if (controller) controller.connect(inputSource);
    }
}
// Creation method for native WebXR layers
function $d89c9137a3d237c2$var$createXRLayer(layer) {
    if (layer.type === 'quad') return this._glBinding.createQuadLayer({
        transform: new XRRigidTransform(layer.translation, layer.quaternion),
        width: layer.width / 2,
        height: layer.height / 2,
        space: this._referenceSpace,
        viewPixelWidth: layer.pixelwidth,
        viewPixelHeight: layer.pixelheight,
        clearOnAccess: false
    });
    else return this._glBinding.createCylinderLayer({
        transform: new XRRigidTransform(layer.translation, layer.quaternion),
        radius: layer.radius,
        centralAngle: layer.centralAngle,
        aspectRatio: layer.aspectRatio,
        space: this._referenceSpace,
        viewPixelWidth: layer.pixelwidth,
        viewPixelHeight: layer.pixelheight,
        clearOnAccess: false
    });
}
// Animation Loop
function $d89c9137a3d237c2$var$onAnimationFrame(time, frame) {
    if (frame === undefined) return;
    const cameraXR = this._cameraXR;
    const renderer = this._renderer;
    const backend = renderer.backend;
    const glBaseLayer = this._glBaseLayer;
    const referenceSpace = this.getReferenceSpace();
    const pose = frame.getViewerPose(referenceSpace);
    this._xrFrame = frame;
    if (pose !== null) {
        const views = pose.views;
        if (this._glBaseLayer !== null) backend.setXRTarget(glBaseLayer.framebuffer);
        let cameraXRNeedsUpdate = false;
        // check if it's necessary to rebuild cameraXR's camera list
        if (views.length !== cameraXR.cameras.length) {
            cameraXR.cameras.length = 0;
            cameraXRNeedsUpdate = true;
        }
        for(let i = 0; i < views.length; i++){
            const view = views[i];
            let viewport;
            if (this._supportsLayers === true) {
                const glSubImage = this._glBinding.getViewSubImage(this._glProjLayer, view);
                viewport = glSubImage.viewport;
                // For side-by-side projection, we only produce a single texture for both eyes.
                if (i === 0) backend.setXRRenderTargetTextures(this._xrRenderTarget, glSubImage.colorTexture, this._glProjLayer.ignoreDepthValues && !this._useMultiview ? undefined : glSubImage.depthStencilTexture);
            } else viewport = glBaseLayer.getViewport(view);
            let camera = this._cameras[i];
            if (camera === undefined) {
                camera = new (0, $329ek.PerspectiveCamera)();
                camera.layers.enable(i);
                camera.viewport = new (0, $329ek.Vector4)();
                this._cameras[i] = camera;
            }
            camera.matrix.fromArray(view.transform.matrix);
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.projectionMatrix.fromArray(view.projectionMatrix);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
            if (i === 0) {
                cameraXR.matrix.copy(camera.matrix);
                cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
            }
            if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
        }
        renderer.setOutputRenderTarget(this._xrRenderTarget);
    }
    //
    for(let i = 0; i < this._controllers.length; i++){
        const inputSource = this._controllerInputSources[i];
        const controller = this._controllers[i];
        if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, referenceSpace);
    }
    if (this._currentAnimationLoop) this._currentAnimationLoop(time, frame);
    if (frame.detectedPlanes) this.dispatchEvent({
        type: 'planesdetected',
        data: frame
    });
    this._xrFrame = null;
}
/**
 * CanvasTarget is a class that represents the final output destination of the renderer.
 *
 * @augments EventDispatcher
 */ class $d89c9137a3d237c2$export$f3b3d4d0fe604238 extends (0, $329ek.EventDispatcher) {
    /**
	 * Constructs a new CanvasTarget.
	 *
	 * @param {HTMLCanvasElement|OffscreenCanvas} domElement - The canvas element to render to.
	 */ constructor(domElement){
        super();
        /**
		 * A reference to the canvas element the renderer is drawing to.
		 * This value of this property will automatically be created by
		 * the renderer.
		 *
		 * @type {HTMLCanvasElement|OffscreenCanvas}
		 */ this.domElement = domElement;
        /**
		 * The renderer's pixel ratio.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._pixelRatio = 1;
        /**
		 * The width of the renderer's default framebuffer in logical pixel unit.
		 *
		 * @private
		 * @type {number}
		 */ this._width = this.domElement.width;
        /**
		 * The height of the renderer's default framebuffer in logical pixel unit.
		 *
		 * @private
		 * @type {number}
		 */ this._height = this.domElement.height;
        /**
		 * The viewport of the renderer in logical pixel unit.
		 *
		 * @private
		 * @type {Vector4}
		 */ this._viewport = new (0, $329ek.Vector4)(0, 0, this._width, this._height);
        /**
		 * The scissor rectangle of the renderer in logical pixel unit.
		 *
		 * @private
		 * @type {Vector4}
		 */ this._scissor = new (0, $329ek.Vector4)(0, 0, this._width, this._height);
        /**
		 * Whether the scissor test should be enabled or not.
		 *
		 * @private
		 * @type {boolean}
		 */ this._scissorTest = false;
        /**
		 * The color texture of the default framebuffer.
		 *
		 * @type {FramebufferTexture}
		 */ this.colorTexture = new (0, $329ek.FramebufferTexture)();
        /**
		 * The depth texture of the default framebuffer.
		 *
		 * @type {DepthTexture}
		 */ this.depthTexture = new (0, $329ek.DepthTexture)();
    }
    /**
	 * Returns the pixel ratio.
	 *
	 * @return {number} The pixel ratio.
	 */ getPixelRatio() {
        return this._pixelRatio;
    }
    /**
	 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
	 *
	 * @param {Vector2} target - The method writes the result in this target object.
	 * @return {Vector2} The drawing buffer size.
	 */ getDrawingBufferSize(target) {
        return target.set(this._width * this._pixelRatio, this._height * this._pixelRatio).floor();
    }
    /**
	 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
	 *
	 * @param {Vector2} target - The method writes the result in this target object.
	 * @return {Vector2} The renderer's size in logical pixels.
	 */ getSize(target) {
        return target.set(this._width, this._height);
    }
    /**
	 * Sets the given pixel ratio and resizes the canvas if necessary.
	 *
	 * @param {number} [value=1] - The pixel ratio.
	 */ setPixelRatio(value = 1) {
        if (this._pixelRatio === value) return;
        this._pixelRatio = value;
        this.setSize(this._width, this._height, false);
    }
    /**
	 * This method allows to define the drawing buffer size by specifying
	 * width, height and pixel ratio all at once. The size of the drawing
	 * buffer is computed with this formula:
	 * ```js
	 * size.x = width * pixelRatio;
	 * size.y = height * pixelRatio;
	 * ```
	 *
	 * @param {number} width - The width in logical pixels.
	 * @param {number} height - The height in logical pixels.
	 * @param {number} pixelRatio - The pixel ratio.
	 */ setDrawingBufferSize(width, height, pixelRatio) {
        // Renderer can't be resized while presenting in XR.
        if (this.xr && this.xr.isPresenting) return;
        this._width = width;
        this._height = height;
        this._pixelRatio = pixelRatio;
        this.domElement.width = Math.floor(width * pixelRatio);
        this.domElement.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
        this._dispatchResize();
    }
    /**
	 * Sets the size of the renderer.
	 *
	 * @param {number} width - The width in logical pixels.
	 * @param {number} height - The height in logical pixels.
	 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
	 */ setSize(width, height, updateStyle = true) {
        // Renderer can't be resized while presenting in XR.
        if (this.xr && this.xr.isPresenting) return;
        this._width = width;
        this._height = height;
        this.domElement.width = Math.floor(width * this._pixelRatio);
        this.domElement.height = Math.floor(height * this._pixelRatio);
        if (updateStyle === true) {
            this.domElement.style.width = width + 'px';
            this.domElement.style.height = height + 'px';
        }
        this.setViewport(0, 0, width, height);
        this._dispatchResize();
    }
    /**
	 * Returns the scissor rectangle.
	 *
	 * @param {Vector4} target - The method writes the result in this target object.
	 * @return {Vector4} The scissor rectangle.
	 */ getScissor(target) {
        const scissor = this._scissor;
        target.x = scissor.x;
        target.y = scissor.y;
        target.width = scissor.width;
        target.height = scissor.height;
        return target;
    }
    /**
	 * Defines the scissor rectangle.
	 *
	 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the box in logical pixel unit.
	 * Instead of passing four arguments, the method also works with a single four-dimensional vector.
	 * @param {number} y - The vertical coordinate for the lower left corner of the box in logical pixel unit.
	 * @param {number} width - The width of the scissor box in logical pixel unit.
	 * @param {number} height - The height of the scissor box in logical pixel unit.
	 */ setScissor(x, y, width, height) {
        const scissor = this._scissor;
        if (x.isVector4) scissor.copy(x);
        else scissor.set(x, y, width, height);
    }
    /**
	 * Returns the scissor test value.
	 *
	 * @return {boolean} Whether the scissor test should be enabled or not.
	 */ getScissorTest() {
        return this._scissorTest;
    }
    /**
	 * Defines the scissor test.
	 *
	 * @param {boolean} boolean - Whether the scissor test should be enabled or not.
	 */ setScissorTest(boolean) {
        this._scissorTest = boolean;
    }
    /**
	 * Returns the viewport definition.
	 *
	 * @param {Vector4} target - The method writes the result in this target object.
	 * @return {Vector4} The viewport definition.
	 */ getViewport(target) {
        return target.copy(this._viewport);
    }
    /**
	 * Defines the viewport.
	 *
	 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
	 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
	 * @param {number} width - The width of the viewport in logical pixel unit.
	 * @param {number} height - The height of the viewport in logical pixel unit.
	 * @param {number} minDepth - The minimum depth value of the viewport. WebGPU only.
	 * @param {number} maxDepth - The maximum depth value of the viewport. WebGPU only.
	 */ setViewport(x, y, width, height, minDepth = 0, maxDepth = 1) {
        const viewport = this._viewport;
        if (x.isVector4) viewport.copy(x);
        else viewport.set(x, y, width, height);
        viewport.minDepth = minDepth;
        viewport.maxDepth = maxDepth;
    }
    /**
	 * Dispatches the resize event.
	 *
	 * @private
	 */ _dispatchResize() {
        this.dispatchEvent({
            type: 'resize'
        });
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires RenderTarget#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $d89c9137a3d237c2$var$_scene = /*@__PURE__*/ new (0, $329ek.Scene)();
const $d89c9137a3d237c2$var$_drawingBufferSize = /*@__PURE__*/ new (0, $329ek.Vector2)();
const $d89c9137a3d237c2$var$_screen = /*@__PURE__*/ new (0, $329ek.Vector4)();
const $d89c9137a3d237c2$var$_frustum = /*@__PURE__*/ new (0, $329ek.Frustum)();
const $d89c9137a3d237c2$var$_frustumArray = /*@__PURE__*/ new (0, $329ek.FrustumArray)();
const $d89c9137a3d237c2$var$_projScreenMatrix = /*@__PURE__*/ new (0, $329ek.Matrix4)();
const $d89c9137a3d237c2$var$_vector4 = /*@__PURE__*/ new (0, $329ek.Vector4)();
/**
 * Base class for renderers.
 */ class $d89c9137a3d237c2$var$Renderer {
    /**
	 * Renderer options.
	 *
	 * @typedef {Object} Renderer~Options
	 * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
	 * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
	 * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
	 * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
	 * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
	 * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. This parameter can set to any other integer value than 0
	 * to overwrite the default.
	 * @property {?Function} [getFallback=null] - This callback function can be used to provide a fallback backend, if the primary backend can't be targeted.
	 * @property {number} [outputBufferType=HalfFloatType] - Defines the type of output buffers. The default `HalfFloatType` is recommend for best
	 * quality. To save memory and bandwidth, `UnsignedByteType` might be used. This will reduce rendering quality though.
	 * @property {boolean} [multiview=false] - If set to `true`, the renderer will use multiview during WebXR rendering if supported.
	 */ /**
	 * Constructs a new renderer.
	 *
	 * @param {Backend} backend - The backend the renderer is targeting (e.g. WebGPU or WebGL 2).
	 * @param {Renderer~Options} [parameters] - The configuration parameter.

	 */ constructor(backend, parameters = {}){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderer = true;
        //
        const { logarithmicDepthBuffer: logarithmicDepthBuffer = false, alpha: alpha = true, depth: depth = true, stencil: stencil = false, antialias: antialias = false, samples: samples = 0, getFallback: getFallback = null, outputBufferType: outputBufferType = (0, $329ek.HalfFloatType), multiview: multiview = false } = parameters;
        /**
		 * A reference to the current backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
        /**
		 * Whether the renderer should automatically clear the current rendering target
		 * before execute a `render()` call. The target can be the canvas (default framebuffer)
		 * or the current bound render target (custom framebuffer).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClear = true;
        /**
		 * When `autoClear` is set to `true`, this property defines whether the renderer
		 * should clear the color buffer.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearColor = true;
        /**
		 * When `autoClear` is set to `true`, this property defines whether the renderer
		 * should clear the depth buffer.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearDepth = true;
        /**
		 * When `autoClear` is set to `true`, this property defines whether the renderer
		 * should clear the stencil buffer.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearStencil = true;
        /**
		 * Whether the default framebuffer should be transparent or opaque.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.alpha = alpha;
        /**
		 * Whether logarithmic depth buffer is enabled or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.logarithmicDepthBuffer = logarithmicDepthBuffer;
        /**
		 * Defines the output color space of the renderer.
		 *
		 * @type {string}
		 * @default SRGBColorSpace
		 */ this.outputColorSpace = (0, $329ek.SRGBColorSpace);
        /**
		 * Defines the tone mapping of the renderer.
		 *
		 * @type {number}
		 * @default NoToneMapping
		 */ this.toneMapping = (0, $329ek.NoToneMapping);
        /**
		 * Defines the tone mapping exposure.
		 *
		 * @type {number}
		 * @default 1
		 */ this.toneMappingExposure = 1.0;
        /**
		 * Whether the renderer should sort its render lists or not.
		 *
		 * Note: Sorting is used to attempt to properly render objects that have some degree of transparency.
		 * By definition, sorting objects may not work in all cases. Depending on the needs of application,
		 * it may be necessary to turn off sorting and use other methods to deal with transparency rendering
		 * e.g. manually determining each object's rendering order.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        /**
		 * Whether the default framebuffer should have a depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depth = depth;
        /**
		 * Whether the default framebuffer should have a stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencil = stencil;
        /**
		 * Holds a series of statistical information about the GPU memory
		 * and the rendering process. Useful for debugging and monitoring.
		 *
		 * @type {Info}
		 */ this.info = new $d89c9137a3d237c2$var$Info();
        /**
		 * A global context node that stores override nodes for specific transformations or calculations.
		 * These nodes can be used to replace default behavior in the rendering pipeline.
		 *
		 * @type {ContextNode}
		 * @property {Object} value - The context value object.
		 */ this.contextNode = $d89c9137a3d237c2$var$context();
        /**
		 * The node library defines how certain library objects like materials, lights
		 * or tone mapping functions are mapped to node types. This is required since
		 * although instances of classes like `MeshBasicMaterial` or `PointLight` can
		 * be part of the scene graph, they are internally represented as nodes for
		 * further processing.
		 *
		 * @type {NodeLibrary}
		 */ this.library = new $d89c9137a3d237c2$var$NodeLibrary();
        /**
		 * A map-like data structure for managing lights.
		 *
		 * @type {Lighting}
		 */ this.lighting = new $d89c9137a3d237c2$export$10b79c914aa1f585();
        // internals
        /**
		 * The number of MSAA samples.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._samples = samples || antialias === true ? 4 : 0;
        /**
		 * OnCanvasTargetResize callback function.
		 *
		 * @private
		 * @type {Function}
		 */ this._onCanvasTargetResize = this._onCanvasTargetResize.bind(this);
        /**
		 * The canvas target for rendering.
		 *
		 * @private
		 * @type {CanvasTarget}
		 */ this._canvasTarget = new $d89c9137a3d237c2$export$f3b3d4d0fe604238(backend.getDomElement());
        this._canvasTarget.addEventListener('resize', this._onCanvasTargetResize);
        this._canvasTarget.isDefaultCanvasTarget = true;
        /**
		 * The inspector provides information about the internal renderer state.
		 *
		 * @private
		 * @type {InspectorBase}
		 */ this._inspector = new $d89c9137a3d237c2$export$660a27ce99fa210b();
        this._inspector.setRenderer(this);
        /**
		 * This callback function can be used to provide a fallback backend, if the primary backend can't be targeted.
		 *
		 * @private
		 * @type {?Function}
		 */ this._getFallback = getFallback;
        /**
		 * A reference to a renderer module for managing shader attributes.
		 *
		 * @private
		 * @type {?Attributes}
		 * @default null
		 */ this._attributes = null;
        /**
		 * A reference to a renderer module for managing geometries.
		 *
		 * @private
		 * @type {?Geometries}
		 * @default null
		 */ this._geometries = null;
        /**
		 * A reference to a renderer module for managing node related logic.
		 *
		 * @private
		 * @type {?Nodes}
		 * @default null
		 */ this._nodes = null;
        /**
		 * A reference to a renderer module for managing the internal animation loop.
		 *
		 * @private
		 * @type {?Animation}
		 * @default null
		 */ this._animation = null;
        /**
		 * A reference to a renderer module for managing shader program bindings.
		 *
		 * @private
		 * @type {?Bindings}
		 * @default null
		 */ this._bindings = null;
        /**
		 * A reference to a renderer module for managing render objects.
		 *
		 * @private
		 * @type {?RenderObjects}
		 * @default null
		 */ this._objects = null;
        /**
		 * A reference to a renderer module for managing render and compute pipelines.
		 *
		 * @private
		 * @type {?Pipelines}
		 * @default null
		 */ this._pipelines = null;
        /**
		 * A reference to a renderer module for managing render bundles.
		 *
		 * @private
		 * @type {?RenderBundles}
		 * @default null
		 */ this._bundles = null;
        /**
		 * A reference to a renderer module for managing render lists.
		 *
		 * @private
		 * @type {?RenderLists}
		 * @default null
		 */ this._renderLists = null;
        /**
		 * A reference to a renderer module for managing render contexts.
		 *
		 * @private
		 * @type {?RenderContexts}
		 * @default null
		 */ this._renderContexts = null;
        /**
		 * A reference to a renderer module for managing textures.
		 *
		 * @private
		 * @type {?Textures}
		 * @default null
		 */ this._textures = null;
        /**
		 * A reference to a renderer module for backgrounds.
		 *
		 * @private
		 * @type {?Background}
		 * @default null
		 */ this._background = null;
        /**
		 * This fullscreen quad is used for internal render passes
		 * like the tone mapping and color space output pass.
		 *
		 * @private
		 * @type {QuadMesh}
		 */ this._quad = new $d89c9137a3d237c2$export$266ce19fe399ee9a(new $d89c9137a3d237c2$export$caaf3b30a544c946());
        this._quad.name = 'Output Color Transform';
        this._quad.material.name = 'outputColorTransform';
        /**
		 * A reference to the current render context.
		 *
		 * @private
		 * @type {?RenderContext}
		 * @default null
		 */ this._currentRenderContext = null;
        /**
		 * A custom sort function for the opaque render list.
		 *
		 * @private
		 * @type {?Function}
		 * @default null
		 */ this._opaqueSort = null;
        /**
		 * A custom sort function for the transparent render list.
		 *
		 * @private
		 * @type {?Function}
		 * @default null
		 */ this._transparentSort = null;
        /**
		 * The framebuffer target.
		 *
		 * @private
		 * @type {?RenderTarget}
		 * @default null
		 */ this._frameBufferTarget = null;
        const alphaClear = this.alpha === true ? 0 : 1;
        /**
		 * The clear color value.
		 *
		 * @private
		 * @type {Color4}
		 */ this._clearColor = new $d89c9137a3d237c2$var$Color4(0, 0, 0, alphaClear);
        /**
		 * The clear depth value.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._clearDepth = 1;
        /**
		 * The clear stencil value.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._clearStencil = 0;
        /**
		 * The current render target.
		 *
		 * @private
		 * @type {?RenderTarget}
		 * @default null
		 */ this._renderTarget = null;
        /**
		 * The active cube face.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._activeCubeFace = 0;
        /**
		 * The active mipmap level.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._activeMipmapLevel = 0;
        /**
		 * The current output render target.
		 *
		 * @private
		 * @type {?RenderTarget}
		 * @default null
		 */ this._outputRenderTarget = null;
        /**
		 * The MRT setting.
		 *
		 * @private
		 * @type {?MRTNode}
		 * @default null
		 */ this._mrt = null;
        /**
		 * This function defines how a render object is going
		 * to be rendered.
		 *
		 * @private
		 * @type {?Function}
		 * @default null
		 */ this._renderObjectFunction = null;
        /**
		 * Used to keep track of the current render object function.
		 *
		 * @private
		 * @type {?Function}
		 * @default null
		 */ this._currentRenderObjectFunction = null;
        /**
		 * Used to keep track of the current render bundle.
		 *
		 * @private
		 * @type {?RenderBundle}
		 * @default null
		 */ this._currentRenderBundle = null;
        /**
		 * Next to `_renderObjectFunction()`, this function provides another hook
		 * for influencing the render process of a render object. It is meant for internal
		 * use and only relevant for `compileAsync()` right now. Instead of using
		 * the default logic of `_renderObjectDirect()` which actually draws the render object,
		 * a different function might be used which performs no draw but just the node
		 * and pipeline updates.
		 *
		 * @private
		 * @type {?Function}
		 * @default null
		 */ this._handleObjectFunction = this._renderObjectDirect;
        /**
		 * Indicates whether the device has been lost or not. In WebGL terms, the device
		 * lost is considered as a context lost. When this is set to `true`, rendering
		 * isn't possible anymore.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 */ this._isDeviceLost = false;
        /**
		 * A callback function that defines what should happen when a device/context lost occurs.
		 *
		 * @type {Function}
		 */ this.onDeviceLost = this._onDeviceLost;
        /**
		 * Defines the type of output buffers. The default `HalfFloatType` is recommend for
		 * best quality. To save memory and bandwidth, `UnsignedByteType` might be used.
		 * This will reduce rendering quality though.
		 *
		 * @private
		 * @type {number}
		 * @default HalfFloatType
		 */ this._outputBufferType = outputBufferType;
        /**
		 * A cache for shadow nodes per material
		 *
		 * @private
		 * @type {WeakMap<Material, Object>}
		 */ this._cacheShadowNodes = new WeakMap();
        /**
		 * Whether the renderer has been initialized or not.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 */ this._initialized = false;
        /**
		 * A reference to the promise which initializes the renderer.
		 *
		 * @private
		 * @type {?Promise<this>}
		 * @default null
		 */ this._initPromise = null;
        /**
		 * An array of compilation promises which are used in `compileAsync()`.
		 *
		 * @private
		 * @type {?Array<Promise>}
		 * @default null
		 */ this._compilationPromises = null;
        /**
		 * Whether the renderer should render transparent render objects or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the renderer should render opaque render objects or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.opaque = true;
        /**
		 * Shadow map configuration
		 * @typedef {Object} ShadowMapConfig
		 * @property {boolean} enabled - Whether to globally enable shadows or not.
		 * @property {number} type - The shadow map type.
		 */ /**
		 * The renderer's shadow configuration.
		 *
		 * @type {ShadowMapConfig}
		 */ this.shadowMap = {
            enabled: false,
            type: (0, $329ek.PCFShadowMap)
        };
        /**
		 * XR configuration.
		 * @typedef {Object} XRConfig
		 * @property {boolean} enabled - Whether to globally enable XR or not.
		 */ /**
		 * The renderer's XR manager.
		 *
		 * @type {XRManager}
		 */ this.xr = new $d89c9137a3d237c2$var$XRManager(this, multiview);
        /**
		 * Debug configuration.
		 * @typedef {Object} DebugConfig
		 * @property {boolean} checkShaderErrors - Whether shader errors should be checked or not.
		 * @property {?Function} onShaderError - A callback function that is executed when a shader error happens. Only supported with WebGL 2 right now.
		 * @property {Function} getShaderAsync - Allows the get the raw shader code for the given scene, camera and 3D object.
		 */ /**
		 * The renderer's debug configuration.
		 *
		 * @type {DebugConfig}
		 */ this.debug = {
            checkShaderErrors: true,
            onShaderError: null,
            getShaderAsync: async (scene, camera, object)=>{
                await this.compileAsync(scene, camera);
                const renderList = this._renderLists.get(scene, camera);
                const renderContext = this._renderContexts.get(scene, camera, this._renderTarget, this._mrt);
                const material = scene.overrideMaterial || object.material;
                const renderObject = this._objects.get(object, material, scene, camera, renderList.lightsNode, renderContext, renderContext.clippingContext);
                const { fragmentShader: fragmentShader, vertexShader: vertexShader } = renderObject.getNodeBuilderState();
                return {
                    fragmentShader: fragmentShader,
                    vertexShader: vertexShader
                };
            }
        };
    }
    /**
	 * Initializes the renderer so it is ready for usage.
	 *
	 * @async
	 * @return {Promise<this>} A Promise that resolves when the renderer has been initialized.
	 */ async init() {
        if (this._initPromise !== null) return this._initPromise;
        this._initPromise = new Promise(async (resolve, reject)=>{
            let backend = this.backend;
            try {
                await backend.init(this);
            } catch (error) {
                if (this._getFallback !== null) // try the fallback
                try {
                    this.backend = backend = this._getFallback(error);
                    await backend.init(this);
                } catch (error) {
                    reject(error);
                    return;
                }
                else {
                    reject(error);
                    return;
                }
            }
            this._nodes = new $d89c9137a3d237c2$var$Nodes(this, backend);
            this._animation = new $d89c9137a3d237c2$var$Animation(this, this._nodes, this.info);
            this._attributes = new $d89c9137a3d237c2$var$Attributes(backend);
            this._background = new $d89c9137a3d237c2$var$Background(this, this._nodes);
            this._geometries = new $d89c9137a3d237c2$var$Geometries(this._attributes, this.info);
            this._textures = new $d89c9137a3d237c2$var$Textures(this, backend, this.info);
            this._pipelines = new $d89c9137a3d237c2$var$Pipelines(backend, this._nodes);
            this._bindings = new $d89c9137a3d237c2$var$Bindings(backend, this._nodes, this._textures, this._attributes, this._pipelines, this.info);
            this._objects = new $d89c9137a3d237c2$var$RenderObjects(this, this._nodes, this._geometries, this._pipelines, this._bindings, this.info);
            this._renderLists = new $d89c9137a3d237c2$var$RenderLists(this.lighting);
            this._bundles = new $d89c9137a3d237c2$var$RenderBundles();
            this._renderContexts = new $d89c9137a3d237c2$var$RenderContexts();
            //
            this._animation.start();
            this._initialized = true;
            //
            this._inspector.init();
            //
            resolve(this);
        });
        return this._initPromise;
    }
    /**
	 * A reference to the canvas element the renderer is drawing to.
	 * This value of this property will automatically be created by
	 * the renderer.
	 *
	 * @type {HTMLCanvasElement|OffscreenCanvas}
	 */ get domElement() {
        return this._canvasTarget.domElement;
    }
    /**
	 * The coordinate system of the renderer. The value of this property
	 * depends on the selected backend. Either `THREE.WebGLCoordinateSystem` or
	 * `THREE.WebGPUCoordinateSystem`.
	 *
	 * @readonly
	 * @type {number}
	 */ get coordinateSystem() {
        return this.backend.coordinateSystem;
    }
    /**
	 * Compiles all materials in the given scene. This can be useful to avoid a
	 * phenomenon which is called "shader compilation stutter", which occurs when
	 * rendering an object with a new shader for the first time.
	 *
	 * If you want to add a 3D object to an existing scene, use the third optional
	 * parameter for applying the target scene. Note that the (target) scene's lighting
	 * and environment must be configured before calling this method.
	 *
	 * @async
	 * @param {Object3D} scene - The scene or 3D object to precompile.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {?Scene} targetScene - If the first argument is a 3D object, this parameter must represent the scene the 3D object is going to be added.
	 * @return {Promise} A Promise that resolves when the compile has been finished.
	 */ async compileAsync(scene, camera, targetScene = null) {
        if (this._isDeviceLost === true) return;
        if (this._initialized === false) await this.init();
        // preserve render tree
        const nodeFrame = this._nodes.nodeFrame;
        const previousRenderId = nodeFrame.renderId;
        const previousRenderContext = this._currentRenderContext;
        const previousRenderObjectFunction = this._currentRenderObjectFunction;
        const previousCompilationPromises = this._compilationPromises;
        //
        const sceneRef = scene.isScene === true ? scene : $d89c9137a3d237c2$var$_scene;
        if (targetScene === null) targetScene = scene;
        const renderTarget = this._renderTarget;
        const renderContext = this._renderContexts.get(targetScene, camera, renderTarget, this._mrt);
        const activeMipmapLevel = this._activeMipmapLevel;
        const compilationPromises = [];
        this._currentRenderContext = renderContext;
        this._currentRenderObjectFunction = this.renderObject;
        this._handleObjectFunction = this._createObjectPipeline;
        this._compilationPromises = compilationPromises;
        nodeFrame.renderId++;
        //
        nodeFrame.update();
        //
        renderContext.depth = this.depth;
        renderContext.stencil = this.stencil;
        if (!renderContext.clippingContext) renderContext.clippingContext = new $d89c9137a3d237c2$var$ClippingContext();
        renderContext.clippingContext.updateGlobal(sceneRef, camera);
        //
        sceneRef.onBeforeRender(this, scene, camera, renderTarget);
        //
        const renderList = this._renderLists.get(scene, camera);
        renderList.begin();
        this._projectObject(scene, camera, 0, renderList, renderContext.clippingContext);
        // include lights from target scene
        if (targetScene !== scene) targetScene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) renderList.pushLight(object);
        });
        renderList.finish();
        //
        if (renderTarget !== null) {
            this._textures.updateRenderTarget(renderTarget, activeMipmapLevel);
            const renderTargetData = this._textures.get(renderTarget);
            renderContext.textures = renderTargetData.textures;
            renderContext.depthTexture = renderTargetData.depthTexture;
        } else {
            renderContext.textures = null;
            renderContext.depthTexture = null;
        }
        //
        this._background.update(sceneRef, renderList, renderContext);
        // process render lists
        const opaqueObjects = renderList.opaque;
        const transparentObjects = renderList.transparent;
        const transparentDoublePassObjects = renderList.transparentDoublePass;
        const lightsNode = renderList.lightsNode;
        if (this.opaque === true && opaqueObjects.length > 0) this._renderObjects(opaqueObjects, camera, sceneRef, lightsNode);
        if (this.transparent === true && transparentObjects.length > 0) this._renderTransparents(transparentObjects, transparentDoublePassObjects, camera, sceneRef, lightsNode);
        // restore render tree
        nodeFrame.renderId = previousRenderId;
        this._currentRenderContext = previousRenderContext;
        this._currentRenderObjectFunction = previousRenderObjectFunction;
        this._compilationPromises = previousCompilationPromises;
        this._handleObjectFunction = this._renderObjectDirect;
        // wait for all promises setup by backends awaiting compilation/linking/pipeline creation to complete
        await Promise.all(compilationPromises);
    }
    /**
	 * Renders the scene in an async fashion.
	 *
	 * @async
	 * @deprecated
	 * @param {Object3D} scene - The scene or 3D object to render.
	 * @param {Camera} camera - The camera.
	 * @return {Promise} A Promise that resolves when the render has been finished.
	 */ async renderAsync(scene, camera) {
        (0, $329ek.warnOnce)('Renderer: "renderAsync()" has been deprecated. Use "render()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await this.init();
        this.render(scene, camera);
    }
    /**
	 * Can be used to synchronize CPU operations with GPU tasks. So when this method is called,
	 * the CPU waits for the GPU to complete its operation (e.g. a compute task).
	 *
	 * @async
	 * @deprecated
	 * @return {Promise} A Promise that resolves when synchronization has been finished.
	 */ async waitForGPU() {
        (0, $329ek.error)('Renderer: waitForGPU() has been removed. Read https://github.com/mrdoob/three.js/issues/32012 for more information.');
    }
    //
    set inspector(value) {
        if (this._inspector !== null) this._inspector.setRenderer(null);
        this._inspector = value;
        this._inspector.setRenderer(this);
    }
    /**
	 * The inspector instance. The inspector can be any class that extends from `InspectorBase`.
	 *
	 * @type {InspectorBase}
	 */ get inspector() {
        return this._inspector;
    }
    /**
	 * Enables or disables high precision for model-view and normal-view matrices.
	 * When enabled, will use CPU 64-bit precision for higher precision instead of GPU 32-bit for higher performance.
	 *
	 * NOTE: 64-bit precision is not compatible with `InstancedMesh` and `SkinnedMesh`.
	 *
	 * @param {boolean} value - Whether to enable or disable high precision.
	 * @type {boolean}
	 */ set highPrecision(value) {
        const contextNodeData = this.contextNode.value;
        if (value === true) {
            contextNodeData.modelViewMatrix = $d89c9137a3d237c2$var$highpModelViewMatrix;
            contextNodeData.modelNormalViewMatrix = $d89c9137a3d237c2$var$highpModelNormalViewMatrix;
        } else if (this.highPrecision) {
            delete contextNodeData.modelViewMatrix;
            delete contextNodeData.modelNormalViewMatrix;
        }
    }
    /**
	 * Returns whether high precision is enabled or not.
	 *
	 * @return {boolean} Whether high precision is enabled or not.
	 * @type {boolean}
	 */ get highPrecision() {
        const contextNodeData = this.contextNode.value;
        return contextNodeData.modelViewMatrix === $d89c9137a3d237c2$var$highpModelViewMatrix && contextNodeData.modelNormalViewMatrix === $d89c9137a3d237c2$var$highpModelNormalViewMatrix;
    }
    /**
	 * Sets the given MRT configuration.
	 *
	 * @param {MRTNode} mrt - The MRT node to set.
	 * @return {Renderer} A reference to this renderer.
	 */ setMRT(mrt) {
        this._mrt = mrt;
        return this;
    }
    /**
	 * Returns the MRT configuration.
	 *
	 * @return {MRTNode} The MRT configuration.
	 */ getMRT() {
        return this._mrt;
    }
    /**
	 * Returns the output buffer type.
	 *
	 * @return {number} The output buffer type.
	 */ getOutputBufferType() {
        return this._outputBufferType;
    }
    /**
	 * Returns the output buffer type.
	 *
	 * @deprecated since r182. Use `.getOutputBufferType()` instead.
	 * @return {number} The output buffer type.
	 */ getColorBufferType() {
        (0, $329ek.warnOnce)('Renderer: ".getColorBufferType()" has been renamed to ".getOutputBufferType()".');
        return this.getOutputBufferType();
    }
    /**
	 * Default implementation of the device lost callback.
	 *
	 * @private
	 * @param {Object} info - Information about the context lost.
	 */ _onDeviceLost(info) {
        let errorMessage = `THREE.WebGPURenderer: ${info.api} Device Lost:\n\nMessage: ${info.message}`;
        if (info.reason) errorMessage += `\nReason: ${info.reason}`;
        (0, $329ek.error)(errorMessage);
        this._isDeviceLost = true;
    }
    /**
	 * Renders the given render bundle.
	 *
	 * @private
	 * @param {Object} bundle - Render bundle data.
	 * @param {Scene} sceneRef - The scene the render bundle belongs to.
	 * @param {LightsNode} lightsNode - The lights node.
	 */ _renderBundle(bundle, sceneRef, lightsNode) {
        const { bundleGroup: bundleGroup, camera: camera, renderList: renderList } = bundle;
        const renderContext = this._currentRenderContext;
        //
        const renderBundle = this._bundles.get(bundleGroup, camera);
        const renderBundleData = this.backend.get(renderBundle);
        if (renderBundleData.renderContexts === undefined) renderBundleData.renderContexts = new Set();
        //
        const needsUpdate = bundleGroup.version !== renderBundleData.version;
        const renderBundleNeedsUpdate = renderBundleData.renderContexts.has(renderContext) === false || needsUpdate;
        renderBundleData.renderContexts.add(renderContext);
        if (renderBundleNeedsUpdate) {
            this.backend.beginBundle(renderContext);
            if (renderBundleData.renderObjects === undefined || needsUpdate) renderBundleData.renderObjects = [];
            this._currentRenderBundle = renderBundle;
            const { transparentDoublePass: transparentDoublePassObjects, transparent: transparentObjects, opaque: opaqueObjects } = renderList;
            if (this.opaque === true && opaqueObjects.length > 0) this._renderObjects(opaqueObjects, camera, sceneRef, lightsNode);
            if (this.transparent === true && transparentObjects.length > 0) this._renderTransparents(transparentObjects, transparentDoublePassObjects, camera, sceneRef, lightsNode);
            this._currentRenderBundle = null;
            //
            this.backend.finishBundle(renderContext, renderBundle);
            renderBundleData.version = bundleGroup.version;
        } else {
            const { renderObjects: renderObjects } = renderBundleData;
            for(let i = 0, l = renderObjects.length; i < l; i++){
                const renderObject = renderObjects[i];
                if (this._nodes.needsRefresh(renderObject)) {
                    this._nodes.updateBefore(renderObject);
                    this._nodes.updateForRender(renderObject);
                    this._bindings.updateForRender(renderObject);
                    this._nodes.updateAfter(renderObject);
                }
            }
        }
        this.backend.addBundle(renderContext, renderBundle);
    }
    /**
	 * Renders the scene or 3D object with the given camera. This method can only be called
	 * if the renderer has been initialized. When using `render()` inside an animation loop,
	 * it's guaranteed the renderer will be initialized. The animation loop must be defined
	 * with {@link Renderer#setAnimationLoop} though.
	 *
	 * For all other use cases (like when using on-demand rendering), you must call
	 * {@link Renderer#init} before rendering.
	 *
	 * The target of the method is the default framebuffer (meaning the canvas)
	 * or alternatively a render target when specified via `setRenderTarget()`.
	 *
	 * @param {Object3D} scene - The scene or 3D object to render.
	 * @param {Camera} camera - The camera to render the scene with.
	 */ render(scene, camera) {
        if (this._initialized === false) throw new Error('Renderer: .render() called before the backend is initialized. Use "await renderer.init();" before rendering.');
        this._renderScene(scene, camera);
    }
    /**
	 * Returns whether the renderer has been initialized or not.
	 *
	 * @readonly
	 * @return {boolean} Whether the renderer has been initialized or not.
	 */ get initialized() {
        return this._initialized;
    }
    /**
	 * Returns an internal render target which is used when computing the output tone mapping
	 * and color space conversion. Unlike in `WebGLRenderer`, this is done in a separate render
	 * pass and not inline to achieve more correct results.
	 *
	 * @private
	 * @return {?RenderTarget} The render target. The method returns `null` if no output conversion should be applied.
	 */ _getFrameBufferTarget() {
        const { currentToneMapping: currentToneMapping, currentColorSpace: currentColorSpace } = this;
        const useToneMapping = currentToneMapping !== (0, $329ek.NoToneMapping);
        const useColorSpace = currentColorSpace !== (0, $329ek.ColorManagement).workingColorSpace;
        if (useToneMapping === false && useColorSpace === false) return null;
        const { width: width, height: height } = this.getDrawingBufferSize($d89c9137a3d237c2$var$_drawingBufferSize);
        const { depth: depth, stencil: stencil } = this;
        let frameBufferTarget = this._frameBufferTarget;
        if (frameBufferTarget === null) {
            frameBufferTarget = new (0, $329ek.RenderTarget)(width, height, {
                depthBuffer: depth,
                stencilBuffer: stencil,
                type: this._outputBufferType,
                format: (0, $329ek.RGBAFormat),
                colorSpace: (0, $329ek.ColorManagement).workingColorSpace,
                generateMipmaps: false,
                minFilter: (0, $329ek.LinearFilter),
                magFilter: (0, $329ek.LinearFilter),
                samples: this.samples
            });
            frameBufferTarget.isPostProcessingRenderTarget = true;
            this._frameBufferTarget = frameBufferTarget;
        }
        const outputRenderTarget = this.getOutputRenderTarget();
        frameBufferTarget.depthBuffer = depth;
        frameBufferTarget.stencilBuffer = stencil;
        if (outputRenderTarget !== null) frameBufferTarget.setSize(outputRenderTarget.width, outputRenderTarget.height, outputRenderTarget.depth);
        else frameBufferTarget.setSize(width, height, 1);
        const canvasTarget = this._canvasTarget;
        frameBufferTarget.viewport.copy(canvasTarget._viewport);
        frameBufferTarget.scissor.copy(canvasTarget._scissor);
        frameBufferTarget.viewport.multiplyScalar(canvasTarget._pixelRatio);
        frameBufferTarget.scissor.multiplyScalar(canvasTarget._pixelRatio);
        frameBufferTarget.scissorTest = canvasTarget._scissorTest;
        frameBufferTarget.multiview = outputRenderTarget !== null ? outputRenderTarget.multiview : false;
        frameBufferTarget.resolveDepthBuffer = outputRenderTarget !== null ? outputRenderTarget.resolveDepthBuffer : true;
        frameBufferTarget._autoAllocateDepthBuffer = outputRenderTarget !== null ? outputRenderTarget._autoAllocateDepthBuffer : false;
        return frameBufferTarget;
    }
    /**
	 * Renders the scene or 3D object with the given camera.
	 *
	 * @private
	 * @param {Object3D} scene - The scene or 3D object to render.
	 * @param {Camera} camera - The camera to render the scene with.
	 * @param {boolean} [useFrameBufferTarget=true] - Whether to use a framebuffer target or not.
	 * @return {RenderContext} The current render context.
	 */ _renderScene(scene, camera, useFrameBufferTarget = true) {
        if (this._isDeviceLost === true) return;
        //
        const frameBufferTarget = useFrameBufferTarget ? this._getFrameBufferTarget() : null;
        // preserve render tree
        const nodeFrame = this._nodes.nodeFrame;
        const previousRenderId = nodeFrame.renderId;
        const previousRenderContext = this._currentRenderContext;
        const previousRenderObjectFunction = this._currentRenderObjectFunction;
        //
        const sceneRef = scene.isScene === true ? scene : $d89c9137a3d237c2$var$_scene;
        const outputRenderTarget = this._renderTarget || this._outputRenderTarget;
        const activeCubeFace = this._activeCubeFace;
        const activeMipmapLevel = this._activeMipmapLevel;
        //
        let renderTarget;
        if (frameBufferTarget !== null) {
            renderTarget = frameBufferTarget;
            this.setRenderTarget(renderTarget);
        } else renderTarget = outputRenderTarget;
        //
        const renderContext = this._renderContexts.get(scene, camera, renderTarget, this._mrt);
        this._currentRenderContext = renderContext;
        this._currentRenderObjectFunction = this._renderObjectFunction || this.renderObject;
        //
        this.info.calls++;
        this.info.render.calls++;
        this.info.render.frameCalls++;
        nodeFrame.renderId = this.info.calls;
        //
        this.backend.updateTimeStampUID(renderContext);
        this.inspector.beginRender(this.backend.getTimestampUID(renderContext), scene, camera, renderTarget);
        //
        const coordinateSystem = this.coordinateSystem;
        const xr = this.xr;
        if (camera.coordinateSystem !== coordinateSystem && xr.isPresenting === false) {
            camera.coordinateSystem = coordinateSystem;
            camera.updateProjectionMatrix();
            if (camera.isArrayCamera) for (const subCamera of camera.cameras){
                subCamera.coordinateSystem = coordinateSystem;
                subCamera.updateProjectionMatrix();
            }
        }
        //
        if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
        if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) {
            if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
            camera = xr.getCamera(); // use XR camera for rendering
        }
        //
        const canvasTarget = this._canvasTarget;
        let viewport = canvasTarget._viewport;
        let scissor = canvasTarget._scissor;
        let pixelRatio = canvasTarget._pixelRatio;
        if (renderTarget !== null) {
            viewport = renderTarget.viewport;
            scissor = renderTarget.scissor;
            pixelRatio = 1;
        }
        this.getDrawingBufferSize($d89c9137a3d237c2$var$_drawingBufferSize);
        $d89c9137a3d237c2$var$_screen.set(0, 0, $d89c9137a3d237c2$var$_drawingBufferSize.width, $d89c9137a3d237c2$var$_drawingBufferSize.height);
        const minDepth = viewport.minDepth === undefined ? 0 : viewport.minDepth;
        const maxDepth = viewport.maxDepth === undefined ? 1 : viewport.maxDepth;
        renderContext.viewportValue.copy(viewport).multiplyScalar(pixelRatio).floor();
        renderContext.viewportValue.width >>= activeMipmapLevel;
        renderContext.viewportValue.height >>= activeMipmapLevel;
        renderContext.viewportValue.minDepth = minDepth;
        renderContext.viewportValue.maxDepth = maxDepth;
        renderContext.viewport = renderContext.viewportValue.equals($d89c9137a3d237c2$var$_screen) === false;
        renderContext.scissorValue.copy(scissor).multiplyScalar(pixelRatio).floor();
        renderContext.scissor = canvasTarget._scissorTest && renderContext.scissorValue.equals($d89c9137a3d237c2$var$_screen) === false;
        renderContext.scissorValue.width >>= activeMipmapLevel;
        renderContext.scissorValue.height >>= activeMipmapLevel;
        if (!renderContext.clippingContext) renderContext.clippingContext = new $d89c9137a3d237c2$var$ClippingContext();
        renderContext.clippingContext.updateGlobal(sceneRef, camera);
        //
        sceneRef.onBeforeRender(this, scene, camera, renderTarget);
        //
        const frustum = camera.isArrayCamera ? $d89c9137a3d237c2$var$_frustumArray : $d89c9137a3d237c2$var$_frustum;
        if (!camera.isArrayCamera) {
            $d89c9137a3d237c2$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            frustum.setFromProjectionMatrix($d89c9137a3d237c2$var$_projScreenMatrix, camera.coordinateSystem, camera.reversedDepth);
        }
        const renderList = this._renderLists.get(scene, camera);
        renderList.begin();
        this._projectObject(scene, camera, 0, renderList, renderContext.clippingContext);
        renderList.finish();
        if (this.sortObjects === true) renderList.sort(this._opaqueSort, this._transparentSort);
        //
        if (renderTarget !== null) {
            this._textures.updateRenderTarget(renderTarget, activeMipmapLevel);
            const renderTargetData = this._textures.get(renderTarget);
            renderContext.textures = renderTargetData.textures;
            renderContext.depthTexture = renderTargetData.depthTexture;
            renderContext.width = renderTargetData.width;
            renderContext.height = renderTargetData.height;
            renderContext.renderTarget = renderTarget;
            renderContext.depth = renderTarget.depthBuffer;
            renderContext.stencil = renderTarget.stencilBuffer;
        } else {
            renderContext.textures = null;
            renderContext.depthTexture = null;
            renderContext.width = $d89c9137a3d237c2$var$_drawingBufferSize.width;
            renderContext.height = $d89c9137a3d237c2$var$_drawingBufferSize.height;
            renderContext.depth = this.depth;
            renderContext.stencil = this.stencil;
        }
        renderContext.width >>= activeMipmapLevel;
        renderContext.height >>= activeMipmapLevel;
        renderContext.activeCubeFace = activeCubeFace;
        renderContext.activeMipmapLevel = activeMipmapLevel;
        renderContext.occlusionQueryCount = renderList.occlusionQueryCount;
        //
        renderContext.scissorValue.max($d89c9137a3d237c2$var$_vector4.set(0, 0, 0, 0));
        if (renderContext.scissorValue.x + renderContext.scissorValue.width > renderContext.width) renderContext.scissorValue.width = Math.max(renderContext.width - renderContext.scissorValue.x, 0);
        if (renderContext.scissorValue.y + renderContext.scissorValue.height > renderContext.height) renderContext.scissorValue.height = Math.max(renderContext.height - renderContext.scissorValue.y, 0);
        //
        this._background.update(sceneRef, renderList, renderContext);
        //
        renderContext.camera = camera;
        this.backend.beginRender(renderContext);
        // process render lists
        const { bundles: bundles, lightsNode: lightsNode, transparentDoublePass: transparentDoublePassObjects, transparent: transparentObjects, opaque: opaqueObjects } = renderList;
        if (bundles.length > 0) this._renderBundles(bundles, sceneRef, lightsNode);
        if (this.opaque === true && opaqueObjects.length > 0) this._renderObjects(opaqueObjects, camera, sceneRef, lightsNode);
        if (this.transparent === true && transparentObjects.length > 0) this._renderTransparents(transparentObjects, transparentDoublePassObjects, camera, sceneRef, lightsNode);
        // finish render pass
        this.backend.finishRender(renderContext);
        // restore render tree
        nodeFrame.renderId = previousRenderId;
        this._currentRenderContext = previousRenderContext;
        this._currentRenderObjectFunction = previousRenderObjectFunction;
        //
        if (frameBufferTarget !== null) {
            this.setRenderTarget(outputRenderTarget, activeCubeFace, activeMipmapLevel);
            this._renderOutput(renderTarget);
        }
        //
        sceneRef.onAfterRender(this, scene, camera, renderTarget);
        //
        this.inspector.finishRender(this.backend.getTimestampUID(renderContext));
        //
        return renderContext;
    }
    _setXRLayerSize(width, height) {
        // TODO: Find a better solution to resize the canvas when in XR.
        this._canvasTarget._width = width;
        this._canvasTarget._height = height;
        this.setViewport(0, 0, width, height);
    }
    /**
	 * The output pass performs tone mapping and color space conversion.
	 *
	 * @private
	 * @param {RenderTarget} renderTarget - The current render target.
	 */ _renderOutput(renderTarget) {
        const quad = this._quad;
        if (this._nodes.hasOutputChange(renderTarget.texture)) {
            quad.material.fragmentNode = this._nodes.getOutputNode(renderTarget.texture);
            quad.material.needsUpdate = true;
        }
        // a clear operation clears the intermediate renderTarget texture, but should not update the screen canvas.
        const currentAutoClear = this.autoClear;
        const currentXR = this.xr.enabled;
        this.autoClear = false;
        this.xr.enabled = false;
        this._renderScene(quad, quad.camera, false);
        this.autoClear = currentAutoClear;
        this.xr.enabled = currentXR;
    }
    /**
	 * Returns the maximum available anisotropy for texture filtering.
	 *
	 * @return {number} The maximum available anisotropy.
	 */ getMaxAnisotropy() {
        return this.backend.getMaxAnisotropy();
    }
    /**
	 * Returns the active cube face.
	 *
	 * @return {number} The active cube face.
	 */ getActiveCubeFace() {
        return this._activeCubeFace;
    }
    /**
	 * Returns the active mipmap level.
	 *
	 * @return {number} The active mipmap level.
	 */ getActiveMipmapLevel() {
        return this._activeMipmapLevel;
    }
    /**
	 * Applications are advised to always define the animation loop
	 * with this method and not manually with `requestAnimationFrame()`
	 * for best compatibility.
	 *
	 * @async
	 * @param {?onAnimationCallback} callback - The application's animation loop.
	 * @return {Promise} A Promise that resolves when the set has been executed.
	 */ async setAnimationLoop(callback) {
        if (this._initialized === false) await this.init();
        this._animation.setAnimationLoop(callback);
    }
    /**
	 * Returns the current animation loop callback.
	 *
	 * @return {?Function} The current animation loop callback.
	 */ getAnimationLoop() {
        return this._animation.getAnimationLoop();
    }
    /**
	 * Can be used to transfer buffer data from a storage buffer attribute
	 * from the GPU to the CPU in context of compute shaders.
	 *
	 * @async
	 * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
	 * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync(attribute) {
        return await this.backend.getArrayBufferAsync(attribute);
    }
    /**
	 * Returns the rendering context.
	 *
	 * @return {GPUCanvasContext|WebGL2RenderingContext} The rendering context.
	 */ getContext() {
        return this.backend.getContext();
    }
    /**
	 * Returns the pixel ratio.
	 *
	 * @return {number} The pixel ratio.
	 */ getPixelRatio() {
        return this._canvasTarget.getPixelRatio();
    }
    /**
	 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
	 *
	 * @param {Vector2} target - The method writes the result in this target object.
	 * @return {Vector2} The drawing buffer size.
	 */ getDrawingBufferSize(target) {
        return this._canvasTarget.getDrawingBufferSize(target);
    }
    /**
	 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
	 *
	 * @param {Vector2} target - The method writes the result in this target object.
	 * @return {Vector2} The renderer's size in logical pixels.
	 */ getSize(target) {
        return this._canvasTarget.getSize(target);
    }
    /**
	 * Sets the given pixel ratio and resizes the canvas if necessary.
	 *
	 * @param {number} [value=1] - The pixel ratio.
	 */ setPixelRatio(value = 1) {
        this._canvasTarget.setPixelRatio(value);
    }
    /**
	 * This method allows to define the drawing buffer size by specifying
	 * width, height and pixel ratio all at once. The size of the drawing
	 * buffer is computed with this formula:
	 * ```js
	 * size.x = width * pixelRatio;
	 * size.y = height * pixelRatio;
	 * ```
	 *
	 * @param {number} width - The width in logical pixels.
	 * @param {number} height - The height in logical pixels.
	 * @param {number} pixelRatio - The pixel ratio.
	 */ setDrawingBufferSize(width, height, pixelRatio) {
        // Renderer can't be resized while presenting in XR.
        if (this.xr && this.xr.isPresenting) return;
        this._canvasTarget.setDrawingBufferSize(width, height, pixelRatio);
    }
    /**
	 * Sets the size of the renderer.
	 *
	 * @param {number} width - The width in logical pixels.
	 * @param {number} height - The height in logical pixels.
	 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
	 */ setSize(width, height, updateStyle = true) {
        // Renderer can't be resized while presenting in XR.
        if (this.xr && this.xr.isPresenting) return;
        this._canvasTarget.setSize(width, height, updateStyle);
    }
    /**
	 * Defines a manual sort function for the opaque render list.
	 * Pass `null` to use the default sort.
	 *
	 * @param {Function} method - The sort function.
	 */ setOpaqueSort(method) {
        this._opaqueSort = method;
    }
    /**
	 * Defines a manual sort function for the transparent render list.
	 * Pass `null` to use the default sort.
	 *
	 * @param {Function} method - The sort function.
	 */ setTransparentSort(method) {
        this._transparentSort = method;
    }
    /**
	 * Returns the scissor rectangle.
	 *
	 * @param {Vector4} target - The method writes the result in this target object.
	 * @return {Vector4} The scissor rectangle.
	 */ getScissor(target) {
        return this._canvasTarget.getScissor(target);
    }
    /**
	 * Defines the scissor rectangle.
	 *
	 * @param {number | Vector4} x - The horizontal coordinate for the upper left corner of the box in logical pixel unit.
	 * Instead of passing four arguments, the method also works with a single four-dimensional vector.
	 * @param {number} y - The vertical coordinate for the upper left corner of the box in logical pixel unit.
	 * @param {number} width - The width of the scissor box in logical pixel unit.
	 * @param {number} height - The height of the scissor box in logical pixel unit.
	 */ setScissor(x, y, width, height) {
        this._canvasTarget.setScissor(x, y, width, height);
    }
    /**
	 * Returns the scissor test value.
	 *
	 * @return {boolean} Whether the scissor test should be enabled or not.
	 */ getScissorTest() {
        return this._canvasTarget.getScissorTest();
    }
    /**
	 * Defines the scissor test.
	 *
	 * @param {boolean} boolean - Whether the scissor test should be enabled or not.
	 */ setScissorTest(boolean) {
        this._canvasTarget.setScissorTest(boolean);
        // TODO: Move it to CanvasTarget event listener.
        this.backend.setScissorTest(boolean);
    }
    /**
	 * Returns the viewport definition.
	 *
	 * @param {Vector4} target - The method writes the result in this target object.
	 * @return {Vector4} The viewport definition.
	 */ getViewport(target) {
        return this._canvasTarget.getViewport(target);
    }
    /**
	 * Defines the viewport.
	 *
	 * @param {number | Vector4} x - The horizontal coordinate for the upper left corner of the viewport origin in logical pixel unit.
	 * @param {number} y - The vertical coordinate for the upper left corner of the viewport origin  in logical pixel unit.
	 * @param {number} width - The width of the viewport in logical pixel unit.
	 * @param {number} height - The height of the viewport in logical pixel unit.
	 * @param {number} minDepth - The minimum depth value of the viewport. WebGPU only.
	 * @param {number} maxDepth - The maximum depth value of the viewport. WebGPU only.
	 */ setViewport(x, y, width, height, minDepth = 0, maxDepth = 1) {
        this._canvasTarget.setViewport(x, y, width, height, minDepth, maxDepth);
    }
    /**
	 * Returns the clear color.
	 *
	 * @param {Color} target - The method writes the result in this target object.
	 * @return {Color} The clear color.
	 */ getClearColor(target) {
        return target.copy(this._clearColor);
    }
    /**
	 * Defines the clear color and optionally the clear alpha.
	 *
	 * @param {Color} color - The clear color.
	 * @param {number} [alpha=1] - The clear alpha.
	 */ setClearColor(color, alpha = 1) {
        this._clearColor.set(color);
        this._clearColor.a = alpha;
    }
    /**
	 * Returns the clear alpha.
	 *
	 * @return {number} The clear alpha.
	 */ getClearAlpha() {
        return this._clearColor.a;
    }
    /**
	 * Defines the clear alpha.
	 *
	 * @param {number} alpha - The clear alpha.
	 */ setClearAlpha(alpha) {
        this._clearColor.a = alpha;
    }
    /**
	 * Returns the clear depth.
	 *
	 * @return {number} The clear depth.
	 */ getClearDepth() {
        return this._clearDepth;
    }
    /**
	 * Defines the clear depth.
	 *
	 * @param {number} depth - The clear depth.
	 */ setClearDepth(depth) {
        this._clearDepth = depth;
    }
    /**
	 * Returns the clear stencil.
	 *
	 * @return {number} The clear stencil.
	 */ getClearStencil() {
        return this._clearStencil;
    }
    /**
	 * Defines the clear stencil.
	 *
	 * @param {number} stencil - The clear stencil.
	 */ setClearStencil(stencil) {
        this._clearStencil = stencil;
    }
    /**
	 * This method performs an occlusion query for the given 3D object.
	 * It returns `true` if the given 3D object is fully occluded by other
	 * 3D objects in the scene.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object is fully occluded or not.
	 */ isOccluded(object) {
        const renderContext = this._currentRenderContext;
        return renderContext && this.backend.isOccluded(renderContext, object);
    }
    /**
	 * Performs a manual clear operation. This method ignores `autoClear` properties.
	 *
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 */ clear(color = true, depth = true, stencil = true) {
        if (this._initialized === false) throw new Error('Renderer: .clear() called before the backend is initialized. Use "await renderer.init();" before before using this method.');
        const renderTarget = this._renderTarget || this._getFrameBufferTarget();
        let renderContext = null;
        if (renderTarget !== null) {
            this._textures.updateRenderTarget(renderTarget);
            const renderTargetData = this._textures.get(renderTarget);
            renderContext = this._renderContexts.getForClear(renderTarget);
            renderContext.textures = renderTargetData.textures;
            renderContext.depthTexture = renderTargetData.depthTexture;
            renderContext.width = renderTargetData.width;
            renderContext.height = renderTargetData.height;
            renderContext.renderTarget = renderTarget;
            renderContext.depth = renderTarget.depthBuffer;
            renderContext.stencil = renderTarget.stencilBuffer;
            // #30329
            renderContext.clearColorValue = this.backend.getClearColor();
            renderContext.activeCubeFace = this.getActiveCubeFace();
            renderContext.activeMipmapLevel = this.getActiveMipmapLevel();
        }
        this.backend.clear(color, depth, stencil, renderContext);
        if (renderTarget !== null && this._renderTarget === null) this._renderOutput(renderTarget);
    }
    /**
	 * Performs a manual clear operation of the color buffer. This method ignores `autoClear` properties.
	 */ clearColor() {
        this.clear(true, false, false);
    }
    /**
	 * Performs a manual clear operation of the depth buffer. This method ignores `autoClear` properties.
	 */ clearDepth() {
        this.clear(false, true, false);
    }
    /**
	 * Performs a manual clear operation of the stencil buffer. This method ignores `autoClear` properties.
	 */ clearStencil() {
        this.clear(false, false, true);
    }
    /**
	 * Async version of {@link Renderer#clear}.
	 *
	 * @async
	 * @deprecated
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 * @return {Promise} A Promise that resolves when the clear operation has been executed.
	 */ async clearAsync(color = true, depth = true, stencil = true) {
        (0, $329ek.warnOnce)('Renderer: "clearAsync()" has been deprecated. Use "clear()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await this.init();
        this.clear(color, depth, stencil);
    }
    /**
	 * Async version of {@link Renderer#clearColor}.
	 *
	 * @async
	 * @deprecated
	 * @return {Promise} A Promise that resolves when the clear operation has been executed.
	 */ async clearColorAsync() {
        (0, $329ek.warnOnce)('Renderer: "clearColorAsync()" has been deprecated. Use "clearColor()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        this.clear(true, false, false);
    }
    /**
	 * Async version of {@link Renderer#clearDepth}.
	 *
	 * @async
	 * @deprecated
	 * @return {Promise} A Promise that resolves when the clear operation has been executed.
	 */ async clearDepthAsync() {
        (0, $329ek.warnOnce)('Renderer: "clearDepthAsync()" has been deprecated. Use "clearDepth()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        this.clear(false, true, false);
    }
    /**
	 * Async version of {@link Renderer#clearStencil}.
	 *
	 * @async
	 * @deprecated
	 * @return {Promise} A Promise that resolves when the clear operation has been executed.
	 */ async clearStencilAsync() {
        (0, $329ek.warnOnce)('Renderer: "clearStencilAsync()" has been deprecated. Use "clearStencil()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        this.clear(false, false, true);
    }
    /**
	 * Returns `true` if a framebuffer target is needed to perform tone mapping or color space conversion.
	 * If this is the case, the renderer allocates an internal render target for that purpose.
	 *
	 */ get needsFrameBufferTarget() {
        const useToneMapping = this.currentToneMapping !== (0, $329ek.NoToneMapping);
        const useColorSpace = this.currentColorSpace !== (0, $329ek.ColorManagement).workingColorSpace;
        return useToneMapping || useColorSpace;
    }
    /**
	 * The number of samples used for multi-sample anti-aliasing (MSAA).
	 *
	 * @type {number}
	 * @default 0
	 */ get samples() {
        return this._samples;
    }
    /**
	 * The current number of samples used for multi-sample anti-aliasing (MSAA).
	 *
	 * When rendering to a custom render target, the number of samples of that render target is used.
	 * If the renderer needs an internal framebuffer target for tone mapping or color space conversion,
	 * the number of samples is set to 0.
	 *
	 * @type {number}
	 */ get currentSamples() {
        let samples = this._samples;
        if (this._renderTarget !== null) samples = this._renderTarget.samples;
        else if (this.needsFrameBufferTarget) samples = 0;
        return samples;
    }
    /**
	 * The current tone mapping of the renderer. When not producing screen output,
	 * the tone mapping is always `NoToneMapping`.
	 *
	 * @type {number}
	 */ get currentToneMapping() {
        return this.isOutputTarget ? this.toneMapping : (0, $329ek.NoToneMapping);
    }
    /**
	 * The current color space of the renderer. When not producing screen output,
	 * the color space is always the working color space.
	 *
	 * @type {string}
	 */ get currentColorSpace() {
        return this.isOutputTarget ? this.outputColorSpace : (0, $329ek.ColorManagement).workingColorSpace;
    }
    /**
	 * Returns `true` if the rendering settings are set to screen output.
	 *
	 * @returns {boolean} True if the current render target is the same of output render target or `null`, otherwise false.
	 */ get isOutputTarget() {
        return this._renderTarget === this._outputRenderTarget || this._renderTarget === null;
    }
    /**
	 * Frees all internal resources of the renderer. Call this method if the renderer
	 * is no longer in use by your app.
	 */ dispose() {
        if (this._initialized === true) {
            this.info.dispose();
            this.backend.dispose();
            this._animation.dispose();
            this._objects.dispose();
            this._geometries.dispose();
            this._pipelines.dispose();
            this._nodes.dispose();
            this._bindings.dispose();
            this._renderLists.dispose();
            this._renderContexts.dispose();
            this._textures.dispose();
            if (this._frameBufferTarget !== null) this._frameBufferTarget.dispose();
            Object.values(this.backend.timestampQueryPool).forEach((queryPool)=>{
                if (queryPool !== null) queryPool.dispose();
            });
        }
        this.setRenderTarget(null);
        this.setAnimationLoop(null);
    }
    /**
	 * Sets the given render target. Calling this method means the renderer does not
	 * target the default framebuffer (meaning the canvas) anymore but a custom framebuffer.
	 * Use `null` as the first argument to reset the state.
	 *
	 * @param {?RenderTarget} renderTarget - The render target to set.
	 * @param {number} [activeCubeFace=0] - The active cube face.
	 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
	 */ setRenderTarget(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        this._renderTarget = renderTarget;
        this._activeCubeFace = activeCubeFace;
        this._activeMipmapLevel = activeMipmapLevel;
    }
    /**
	 * Returns the current render target.
	 *
	 * @return {?RenderTarget} The render target. Returns `null` if no render target is set.
	 */ getRenderTarget() {
        return this._renderTarget;
    }
    /**
	 * Sets the output render target for the renderer.
	 *
	 * @param {Object} renderTarget - The render target to set as the output target.
	 */ setOutputRenderTarget(renderTarget) {
        this._outputRenderTarget = renderTarget;
    }
    /**
	 * Returns the current output target.
	 *
	 * @return {?RenderTarget} The current output render target. Returns `null` if no output target is set.
	 */ getOutputRenderTarget() {
        return this._outputRenderTarget;
    }
    /**
	 * Sets the canvas target. The canvas target manages the HTML canvas
	 * or the offscreen canvas the renderer draws into.
	 *
	 * @param {CanvasTarget} canvasTarget - The canvas target.
	 */ setCanvasTarget(canvasTarget) {
        this._canvasTarget.removeEventListener('resize', this._onCanvasTargetResize);
        this._canvasTarget = canvasTarget;
        this._canvasTarget.addEventListener('resize', this._onCanvasTargetResize);
    }
    /**
	 * Returns the current canvas target.
	 *
	 * @return {CanvasTarget} The current canvas target.
	 */ getCanvasTarget() {
        return this._canvasTarget;
    }
    /**
	 * Resets the renderer to the initial state before WebXR started.
	 *
	 * @private
	 */ _resetXRState() {
        this.backend.setXRTarget(null);
        this.setOutputRenderTarget(null);
        this.setRenderTarget(null);
        this._frameBufferTarget.dispose();
        this._frameBufferTarget = null;
    }
    /**
	 * Callback for {@link Renderer#setRenderObjectFunction}.
	 *
	 * @callback renderObjectFunction
	 * @param {Object3D} object - The 3D object.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {BufferGeometry} geometry - The object's geometry.
	 * @param {Material} material - The object's material.
	 * @param {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {LightsNode} lightsNode - The current lights node.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 * @param {?string} [passId=null] - An optional ID for identifying the pass.
	 */ /**
	 * Sets the given render object function. Calling this method overwrites the default implementation
	 * which is {@link Renderer#renderObject}. Defining a custom function can be useful
	 * if you want to modify the way objects are rendered. For example you can define things like "every
	 * object that has material of a certain type should perform a pre-pass with a special overwrite material".
	 * The custom function must always call `renderObject()` in its implementation.
	 *
	 * Use `null` as the first argument to reset the state.
	 *
	 * @param {?renderObjectFunction} renderObjectFunction - The render object function.
	 */ setRenderObjectFunction(renderObjectFunction) {
        this._renderObjectFunction = renderObjectFunction;
    }
    /**
	 * Returns the current render object function.
	 *
	 * @return {?Function} The current render object function. Returns `null` if no function is set.
	 */ getRenderObjectFunction() {
        return this._renderObjectFunction;
    }
    /**
	 * Execute a single or an array of compute nodes. This method can only be called
	 * if the renderer has been initialized.
	 *
	 * @param {Node|Array<Node>} computeNodes - The compute node(s).
	 * @param {number|Array<number>|IndirectStorageBufferAttribute} [dispatchSize=null]
	 * - A single number representing count, or
	 * - An array [x, y, z] representing dispatch size, or
	 * - A IndirectStorageBufferAttribute for indirect dispatch size.
	 * @return {Promise|undefined} A Promise that resolve when the compute has finished. Only returned when the renderer has not been initialized.
	 */ compute(computeNodes, dispatchSize = null) {
        if (this._isDeviceLost === true) return;
        if (this._initialized === false) {
            (0, $329ek.warn)('Renderer: .compute() called before the backend is initialized. Try using .computeAsync() instead.');
            return this.computeAsync(computeNodes, dispatchSize);
        }
        //
        const nodeFrame = this._nodes.nodeFrame;
        const previousRenderId = nodeFrame.renderId;
        //
        this.info.calls++;
        this.info.compute.calls++;
        this.info.compute.frameCalls++;
        nodeFrame.renderId = this.info.calls;
        //
        this.backend.updateTimeStampUID(computeNodes);
        this.inspector.beginCompute(this.backend.getTimestampUID(computeNodes), computeNodes);
        //
        const backend = this.backend;
        const pipelines = this._pipelines;
        const bindings = this._bindings;
        const nodes = this._nodes;
        const computeList = Array.isArray(computeNodes) ? computeNodes : [
            computeNodes
        ];
        if (computeList[0] === undefined || computeList[0].isComputeNode !== true) throw new Error('THREE.Renderer: .compute() expects a ComputeNode.');
        backend.beginCompute(computeNodes);
        for (const computeNode of computeList){
            // onInit
            if (pipelines.has(computeNode) === false) {
                const dispose = ()=>{
                    computeNode.removeEventListener('dispose', dispose);
                    pipelines.delete(computeNode);
                    bindings.deleteForCompute(computeNode);
                    nodes.delete(computeNode);
                };
                computeNode.addEventListener('dispose', dispose);
                //
                const onInitFn = computeNode.onInitFunction;
                if (onInitFn !== null) onInitFn.call(computeNode, {
                    renderer: this
                });
            }
            nodes.updateForCompute(computeNode);
            bindings.updateForCompute(computeNode);
            const computeBindings = bindings.getForCompute(computeNode);
            const computePipeline = pipelines.getForCompute(computeNode, computeBindings);
            backend.compute(computeNodes, computeNode, computeBindings, computePipeline, dispatchSize);
        }
        backend.finishCompute(computeNodes);
        //
        nodeFrame.renderId = previousRenderId;
        //
        this.inspector.finishCompute(this.backend.getTimestampUID(computeNodes));
    }
    /**
	 * Execute a single or an array of compute nodes.
	 *
	 * @async
	 * @param {Node|Array<Node>} computeNodes - The compute node(s).
	 * @param {number|Array<number>|IndirectStorageBufferAttribute} [dispatchSize=null]
	 * - A single number representing count, or
	 * - An array [x, y, z] representing dispatch size, or
	 * - A IndirectStorageBufferAttribute for indirect dispatch size.
	 * @return {Promise} A Promise that resolve when the compute has finished.
	 */ async computeAsync(computeNodes, dispatchSize = null) {
        if (this._initialized === false) await this.init();
        this.compute(computeNodes, dispatchSize);
    }
    /**
	 * Checks if the given feature is supported by the selected backend.
	 *
	 * @async
	 * @deprecated
	 * @param {string} name - The feature's name.
	 * @return {Promise<boolean>} A Promise that resolves with a bool that indicates whether the feature is supported or not.
	 */ async hasFeatureAsync(name) {
        (0, $329ek.warnOnce)('Renderer: "hasFeatureAsync()" has been deprecated. Use "hasFeature()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await this.init();
        return this.hasFeature(name);
    }
    async resolveTimestampsAsync(type = 'render') {
        if (this._initialized === false) await this.init();
        return this.backend.resolveTimestampsAsync(type);
    }
    /**
	 * Checks if the given feature is supported by the selected backend. If the
	 * renderer has not been initialized, this method always returns `false`.
	 *
	 * @param {string} name - The feature's name.
	 * @return {boolean} Whether the feature is supported or not.
	 */ hasFeature(name) {
        if (this._initialized === false) throw new Error('Renderer: .hasFeature() called before the backend is initialized. Use "await renderer.init();" before before using this method.');
        return this.backend.hasFeature(name);
    }
    /**
	 * Returns `true` when the renderer has been initialized.
	 *
	 * @return {boolean} Whether the renderer has been initialized or not.
	 */ hasInitialized() {
        return this._initialized;
    }
    /**
	 * Initializes the given textures. Useful for preloading a texture rather than waiting until first render
	 * (which can cause noticeable lags due to decode and GPU upload overhead).
	 *
	 * @async
	 * @deprecated
	 * @param {Texture} texture - The texture.
	 * @return {Promise} A Promise that resolves when the texture has been initialized.
	 */ async initTextureAsync(texture) {
        (0, $329ek.warnOnce)('Renderer: "initTextureAsync()" has been deprecated. Use "initTexture()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await this.init();
        this.initTexture(texture);
    }
    /**
	 * Initializes the given texture. Useful for preloading a texture rather than waiting until first render
	 * (which can cause noticeable lags due to decode and GPU upload overhead).
	 *
	 * This method can only be used if the renderer has been initialized.
	 *
	 * @param {Texture} texture - The texture.
	 */ initTexture(texture) {
        if (this._initialized === false) throw new Error('Renderer: .initTexture() called before the backend is initialized. Use "await renderer.init();" before before using this method.');
        this._textures.updateTexture(texture);
    }
    /**
	 * Copies the current bound framebuffer into the given texture.
	 *
	 * @param {FramebufferTexture} framebufferTexture - The texture.
	 * @param {?(Vector2|Vector4)} [rectangle=null] - A two or four dimensional vector that defines the rectangular portion of the framebuffer that should be copied.
	 */ copyFramebufferToTexture(framebufferTexture, rectangle = null) {
        if (rectangle !== null) {
            if (rectangle.isVector2) rectangle = $d89c9137a3d237c2$var$_vector4.set(rectangle.x, rectangle.y, framebufferTexture.image.width, framebufferTexture.image.height).floor();
            else if (rectangle.isVector4) rectangle = $d89c9137a3d237c2$var$_vector4.copy(rectangle).floor();
            else {
                (0, $329ek.error)('Renderer.copyFramebufferToTexture: Invalid rectangle.');
                return;
            }
        } else rectangle = $d89c9137a3d237c2$var$_vector4.set(0, 0, framebufferTexture.image.width, framebufferTexture.image.height);
        //
        let renderContext = this._currentRenderContext;
        let renderTarget;
        if (renderContext !== null) renderTarget = renderContext.renderTarget;
        else {
            renderTarget = this._renderTarget || this._getFrameBufferTarget();
            if (renderTarget !== null) {
                this._textures.updateRenderTarget(renderTarget);
                renderContext = this._textures.get(renderTarget);
            }
        }
        //
        this._textures.updateTexture(framebufferTexture, {
            renderTarget: renderTarget
        });
        this.backend.copyFramebufferToTexture(framebufferTexture, renderContext, rectangle);
        this._inspector.copyFramebufferToTexture(framebufferTexture);
    }
    /**
	 * Copies data of the given source texture into a destination texture.
	 *
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 * @param {Box2|Box3} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
	 * @param {Vector2|Vector3} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
	 * @param {number} [srcLevel=0] - The source mip level to copy from.
	 * @param {number} [dstLevel=0] - The destination mip level to copy to.
	 */ copyTextureToTexture(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = 0) {
        this._textures.updateTexture(srcTexture);
        this._textures.updateTexture(dstTexture);
        this.backend.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, srcLevel, dstLevel);
        this._inspector.copyTextureToTexture(srcTexture, dstTexture);
    }
    /**
	 * Reads pixel data from the given render target.
	 *
	 * @async
	 * @param {RenderTarget} renderTarget - The render target to read from.
	 * @param {number} x - The `x` coordinate of the copy region's origin.
	 * @param {number} y - The `y` coordinate of the copy region's origin.
	 * @param {number} width - The width of the copy region.
	 * @param {number} height - The height of the copy region.
	 * @param {number} [textureIndex=0] - The texture index of a MRT render target.
	 * @param {number} [faceIndex=0] - The active cube face index.
	 * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
	 */ async readRenderTargetPixelsAsync(renderTarget, x, y, width, height, textureIndex = 0, faceIndex = 0) {
        return this.backend.copyTextureToBuffer(renderTarget.textures[textureIndex], x, y, width, height, faceIndex);
    }
    /**
	 * Analyzes the given 3D object's hierarchy and builds render lists from the
	 * processed hierarchy.
	 *
	 * @private
	 * @param {Object3D} object - The 3D object to process (usually a scene).
	 * @param {Camera} camera - The camera the object is rendered with.
	 * @param {number} groupOrder - The group order is derived from the `renderOrder` of groups and is used to group 3D objects within groups.
	 * @param {RenderList} renderList - The current render list.
	 * @param {ClippingContext} clippingContext - The current clipping context.
	 */ _projectObject(object, camera, groupOrder, renderList, clippingContext) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) {
                groupOrder = object.renderOrder;
                if (object.isClippingGroup && object.enabled) clippingContext = clippingContext.getGroupContext(object);
            } else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) renderList.pushLight(object);
            else if (object.isSprite) {
                const frustum = camera.isArrayCamera ? $d89c9137a3d237c2$var$_frustumArray : $d89c9137a3d237c2$var$_frustum;
                if (!object.frustumCulled || frustum.intersectsSprite(object, camera)) {
                    if (this.sortObjects === true) $d89c9137a3d237c2$var$_vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4($d89c9137a3d237c2$var$_projScreenMatrix);
                    const { geometry: geometry, material: material } = object;
                    if (material.visible) renderList.push(object, geometry, material, groupOrder, $d89c9137a3d237c2$var$_vector4.z, null, clippingContext);
                }
            } else if (object.isLineLoop) (0, $329ek.error)('Renderer: Objects of type THREE.LineLoop are not supported. Please use THREE.Line or THREE.LineSegments.');
            else if (object.isMesh || object.isLine || object.isPoints) {
                const frustum = camera.isArrayCamera ? $d89c9137a3d237c2$var$_frustumArray : $d89c9137a3d237c2$var$_frustum;
                if (!object.frustumCulled || frustum.intersectsObject(object, camera)) {
                    const { geometry: geometry, material: material } = object;
                    if (this.sortObjects === true) {
                        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                        $d89c9137a3d237c2$var$_vector4.copy(geometry.boundingSphere.center).applyMatrix4(object.matrixWorld).applyMatrix4($d89c9137a3d237c2$var$_projScreenMatrix);
                    }
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) renderList.push(object, geometry, groupMaterial, groupOrder, $d89c9137a3d237c2$var$_vector4.z, group, clippingContext);
                        }
                    } else if (material.visible) renderList.push(object, geometry, material, groupOrder, $d89c9137a3d237c2$var$_vector4.z, null, clippingContext);
                }
            }
        }
        if (object.isBundleGroup === true && this.backend.beginBundle !== undefined) {
            const baseRenderList = renderList;
            // replace render list
            renderList = this._renderLists.get(object, camera);
            renderList.begin();
            baseRenderList.pushBundle({
                bundleGroup: object,
                camera: camera,
                renderList: renderList
            });
            renderList.finish();
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this._projectObject(children[i], camera, groupOrder, renderList, clippingContext);
    }
    /**
	 * Renders the given render bundles.
	 *
	 * @private
	 * @param {Array<Object>} bundles - Array with render bundle data.
	 * @param {Scene} sceneRef - The scene the render bundles belong to.
	 * @param {LightsNode} lightsNode - The current lights node.
	 */ _renderBundles(bundles, sceneRef, lightsNode) {
        for (const bundle of bundles)this._renderBundle(bundle, sceneRef, lightsNode);
    }
    /**
	 * Renders the transparent objects from the given render lists.
	 *
	 * @private
	 * @param {Array<Object>} renderList - The transparent render list.
	 * @param {Array<Object>} doublePassList - The list of transparent objects which require a double pass (e.g. because of transmission).
	 * @param {Camera} camera - The camera the render list should be rendered with.
	 * @param {Scene} scene - The scene the render list belongs to.
	 * @param {LightsNode} lightsNode - The current lights node.
	 */ _renderTransparents(renderList, doublePassList, camera, scene, lightsNode) {
        if (doublePassList.length > 0) {
            // render back side
            for (const { material: material } of doublePassList)material.side = (0, $329ek.BackSide);
            this._renderObjects(doublePassList, camera, scene, lightsNode, 'backSide');
            // render front side
            for (const { material: material } of doublePassList)material.side = (0, $329ek.FrontSide);
            this._renderObjects(renderList, camera, scene, lightsNode);
            // restore
            for (const { material: material } of doublePassList)material.side = (0, $329ek.DoubleSide);
        } else this._renderObjects(renderList, camera, scene, lightsNode);
    }
    /**
	 * Renders the objects from the given render list.
	 *
	 * @private
	 * @param {Array<Object>} renderList - The render list.
	 * @param {Camera} camera - The camera the render list should be rendered with.
	 * @param {Scene} scene - The scene the render list belongs to.
	 * @param {LightsNode} lightsNode - The current lights node.
	 * @param {?string} [passId=null] - An optional ID for identifying the pass.
	 */ _renderObjects(renderList, camera, scene, lightsNode, passId = null) {
        for(let i = 0, il = renderList.length; i < il; i++){
            const { object: object, geometry: geometry, material: material, group: group, clippingContext: clippingContext } = renderList[i];
            this._currentRenderObjectFunction(object, scene, camera, geometry, material, group, lightsNode, clippingContext, passId);
        }
    }
    /**
	 * Retrieves shadow nodes for the given material. This is used to setup shadow passes.
	 * The result is cached per material and updated when the material's version changes.
	 *
	 * @private
	 * @param {Material} material
	 * @returns {Object} - The shadow nodes for the material.
	 */ _getShadowNodes(material) {
        const version = material.version;
        let cache = this._cacheShadowNodes.get(material);
        if (cache === undefined || cache.version !== version) {
            const hasMap = material.map !== null;
            const hasColorNode = material.colorNode && material.colorNode.isNode;
            const hasCastShadowNode = material.castShadowNode && material.castShadowNode.isNode;
            let positionNode = null;
            let colorNode = null;
            let depthNode = null;
            if (hasMap || hasColorNode || hasCastShadowNode) {
                let shadowRGB;
                let shadowAlpha;
                if (hasCastShadowNode) {
                    shadowRGB = material.castShadowNode.rgb;
                    shadowAlpha = material.castShadowNode.a;
                } else {
                    shadowRGB = $d89c9137a3d237c2$var$vec3(0);
                    shadowAlpha = $d89c9137a3d237c2$var$float(1);
                }
                if (hasMap) shadowAlpha = shadowAlpha.mul($d89c9137a3d237c2$var$reference('map', 'texture', material).a);
                if (hasColorNode) shadowAlpha = shadowAlpha.mul(material.colorNode.a);
                colorNode = $d89c9137a3d237c2$var$vec4(shadowRGB, shadowAlpha);
            }
            if (material.depthNode && material.depthNode.isNode) depthNode = material.depthNode;
            if (material.castShadowPositionNode && material.castShadowPositionNode.isNode) positionNode = material.castShadowPositionNode;
            else if (material.positionNode && material.positionNode.isNode) positionNode = material.positionNode;
            cache = {
                version: version,
                colorNode: colorNode,
                depthNode: depthNode,
                positionNode: positionNode
            };
            this._cacheShadowNodes.set(material, cache);
        }
        return cache;
    }
    /**
	 * This method represents the default render object function that manages the render lifecycle
	 * of the object.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {BufferGeometry} geometry - The object's geometry.
	 * @param {Material} material - The object's material.
	 * @param {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {LightsNode} lightsNode - The current lights node.
	 * @param {?ClippingContext} clippingContext - The clipping context.
	 * @param {?string} [passId=null] - An optional ID for identifying the pass.
	 */ renderObject(object, scene, camera, geometry, material, group, lightsNode, clippingContext = null, passId = null) {
        let materialOverride = false;
        let materialColorNode;
        let materialDepthNode;
        let materialPositionNode;
        let materialSide;
        //
        object.onBeforeRender(this, scene, camera, geometry, material, group);
        //
        if (material.allowOverride === true && scene.overrideMaterial !== null) {
            const overrideMaterial = scene.overrideMaterial;
            materialOverride = true;
            // store original nodes
            materialColorNode = scene.overrideMaterial.colorNode;
            materialDepthNode = scene.overrideMaterial.depthNode;
            materialPositionNode = scene.overrideMaterial.positionNode;
            materialSide = scene.overrideMaterial.side;
            if (material.positionNode && material.positionNode.isNode) overrideMaterial.positionNode = material.positionNode;
            overrideMaterial.alphaTest = material.alphaTest;
            overrideMaterial.alphaMap = material.alphaMap;
            overrideMaterial.transparent = material.transparent || material.transmission > 0 || material.transmissionNode && material.transmissionNode.isNode || material.backdropNode && material.backdropNode.isNode;
            if (overrideMaterial.isShadowPassMaterial) {
                const { colorNode: colorNode, depthNode: depthNode, positionNode: positionNode } = this._getShadowNodes(material);
                overrideMaterial.side = material.shadowSide === null ? material.side : material.shadowSide;
                if (colorNode !== null) overrideMaterial.colorNode = colorNode;
                if (depthNode !== null) overrideMaterial.depthNode = depthNode;
                if (positionNode !== null) overrideMaterial.positionNode = positionNode;
            }
            material = overrideMaterial;
        }
        //
        if (material.transparent === true && material.side === (0, $329ek.DoubleSide) && material.forceSinglePass === false) {
            material.side = (0, $329ek.BackSide);
            this._handleObjectFunction(object, material, scene, camera, lightsNode, group, clippingContext, 'backSide'); // create backSide pass id
            material.side = (0, $329ek.FrontSide);
            this._handleObjectFunction(object, material, scene, camera, lightsNode, group, clippingContext, passId); // use default pass id
            material.side = (0, $329ek.DoubleSide);
        } else this._handleObjectFunction(object, material, scene, camera, lightsNode, group, clippingContext, passId);
        //
        if (materialOverride) {
            scene.overrideMaterial.colorNode = materialColorNode;
            scene.overrideMaterial.depthNode = materialDepthNode;
            scene.overrideMaterial.positionNode = materialPositionNode;
            scene.overrideMaterial.side = materialSide;
        }
        //
        object.onAfterRender(this, scene, camera, geometry, material, group);
    }
    /**
	 * This method represents the default `_handleObjectFunction` implementation which creates
	 * a render object from the given data and performs the draw command with the selected backend.
	 *
	 * @private
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The object's material.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {LightsNode} lightsNode - The current lights node.
	 * @param {?{start: number, count: number}} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 * @param {string} [passId] - An optional ID for identifying the pass.
	 */ _renderObjectDirect(object, material, scene, camera, lightsNode, group, clippingContext, passId) {
        const renderObject = this._objects.get(object, material, scene, camera, lightsNode, this._currentRenderContext, clippingContext, passId);
        renderObject.drawRange = object.geometry.drawRange;
        renderObject.group = group;
        //
        const needsRefresh = this._nodes.needsRefresh(renderObject);
        if (needsRefresh) {
            this._nodes.updateBefore(renderObject);
            this._geometries.updateForRender(renderObject);
            this._nodes.updateForRender(renderObject);
            this._bindings.updateForRender(renderObject);
        }
        this._pipelines.updateForRender(renderObject);
        //
        if (this._currentRenderBundle !== null) {
            const renderBundleData = this.backend.get(this._currentRenderBundle);
            renderBundleData.renderObjects.push(renderObject);
            renderObject.bundle = this._currentRenderBundle.bundleGroup;
        }
        this.backend.draw(renderObject, this.info);
        if (needsRefresh) this._nodes.updateAfter(renderObject);
    }
    /**
	 * A different implementation for `_handleObjectFunction` which only makes sure the object is ready for rendering.
	 * Used in `compileAsync()`.
	 *
	 * @private
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The object's material.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {LightsNode} lightsNode - The current lights node.
	 * @param {?{start: number, count: number}} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 * @param {string} [passId] - An optional ID for identifying the pass.
	 */ _createObjectPipeline(object, material, scene, camera, lightsNode, group, clippingContext, passId) {
        const renderObject = this._objects.get(object, material, scene, camera, lightsNode, this._currentRenderContext, clippingContext, passId);
        renderObject.drawRange = object.geometry.drawRange;
        renderObject.group = group;
        //
        this._nodes.updateBefore(renderObject);
        this._geometries.updateForRender(renderObject);
        this._nodes.updateForRender(renderObject);
        this._bindings.updateForRender(renderObject);
        this._pipelines.getForRender(renderObject, this._compilationPromises);
        this._nodes.updateAfter(renderObject);
    }
    /**
	 * Callback when the canvas has been resized.
	 *
	 * @private
	 */ _onCanvasTargetResize() {
        if (this._initialized) this.backend.updateSize();
    }
    /**
	 * Alias for `compileAsync()`.
	 *
	 * @method
	 * @param {Object3D} scene - The scene or 3D object to precompile.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Scene} targetScene - If the first argument is a 3D object, this parameter must represent the scene the 3D object is going to be added.
	 * @return {function(Object3D, Camera, ?Scene): Promise|undefined} A Promise that resolves when the compile has been finished.
	 */ get compile() {
        return this.compileAsync;
    }
}
/**
 * A binding represents the connection between a resource (like a texture, sampler
 * or uniform buffer) and the resource definition in a shader stage.
 *
 * This module is an abstract base class for all concrete bindings types.
 *
 * @abstract
 * @private
 */ class $d89c9137a3d237c2$var$Binding {
    /**
	 * Constructs a new binding.
	 *
	 * @param {string} [name=''] - The binding's name.
	 */ constructor(name = ''){
        /**
		 * The binding's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * A bitmask that defines in what shader stages the
		 * binding's resource is accessible.
		 *
		 * @type {number}
		 */ this.visibility = 0;
    }
    /**
	 * Makes sure binding's resource is visible for the given shader stage.
	 *
	 * @param {number} visibility - The shader stage.
	 */ setVisibility(visibility) {
        this.visibility |= visibility;
    }
    /**
	 * The shader stages in which the binding's resource is visible.
	 *
	 * @return {number} The visibility bitmask.
	 */ getVisibility() {
        return this.visibility;
    }
    /**
	 * Clones the binding.
	 *
	 * @return {Binding} The cloned binding.
	 */ clone() {
        return Object.assign(new this.constructor(), this);
    }
}
/**
 * This function is usually called with the length in bytes of an array buffer.
 * It returns an padded value which ensure chunk size alignment according to STD140 layout.
 *
 * @function
 * @param {number} floatLength - The buffer length.
 * @return {number} The padded length.
 */ function $d89c9137a3d237c2$var$getFloatLength(floatLength) {
    // ensure chunk size alignment (STD140 layout)
    return floatLength + ($d89c9137a3d237c2$var$GPU_CHUNK_BYTES - floatLength % $d89c9137a3d237c2$var$GPU_CHUNK_BYTES) % $d89c9137a3d237c2$var$GPU_CHUNK_BYTES;
}
/**
 * Represents a buffer binding type.
 *
 * @private
 * @abstract
 * @augments Binding
 */ class $d89c9137a3d237c2$var$Buffer extends $d89c9137a3d237c2$var$Binding {
    /**
	 * Constructs a new buffer.
	 *
	 * @param {string} name - The buffer's name.
	 * @param {TypedArray} [buffer=null] - The buffer.
	 */ constructor(name, buffer = null){
        super(name);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBuffer = true;
        /**
		 * The bytes per element.
		 *
		 * @type {number}
		 */ this.bytesPerElement = Float32Array.BYTES_PER_ELEMENT;
        /**
		 * A reference to the internal buffer.
		 *
		 * @private
		 * @type {TypedArray}
		 */ this._buffer = buffer;
        /**
		 * An array of update ranges.
		 *
		 * @private
		 * @type {Array<{start: number, count: number}>}
		 */ this._updateRanges = [];
    }
    /**
	 * The array of update ranges.
	 *
	 * @type {Array<{start: number, count: number}>}
	 */ get updateRanges() {
        return this._updateRanges;
    }
    /**
	 * Adds an update range.
	 *
	 * @param {number} start - The start index.
	 * @param {number} count - The number of elements.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears all update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * The buffer's byte length.
	 *
	 * @type {number}
	 * @readonly
	 */ get byteLength() {
        return $d89c9137a3d237c2$var$getFloatLength(this._buffer.byteLength);
    }
    /**
	 * A reference to the internal buffer.
	 *
	 * @type {Float32Array}
	 * @readonly
	 */ get buffer() {
        return this._buffer;
    }
    /**
	 * Updates the binding.
	 *
	 * @return {boolean} Whether the buffer has been updated and must be
	 * uploaded to the GPU.
	 */ update() {
        return true;
    }
}
/**
 * Represents a uniform buffer binding type.
 *
 * @private
 * @augments Buffer
 */ class $d89c9137a3d237c2$var$UniformBuffer extends $d89c9137a3d237c2$var$Buffer {
    /**
	 * Constructs a new uniform buffer.
	 *
	 * @param {string} name - The buffer's name.
	 * @param {TypedArray} [buffer=null] - The buffer.
	 */ constructor(name, buffer = null){
        super(name, buffer);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformBuffer = true;
    }
}
let $d89c9137a3d237c2$var$_id$4 = 0;
/**
 * A special form of uniform buffer binding type.
 * It's buffer value is managed by a node object.
 *
 * @private
 * @augments UniformBuffer
 */ class $d89c9137a3d237c2$var$NodeUniformBuffer extends $d89c9137a3d237c2$var$UniformBuffer {
    /**
	 * Constructs a new node-based uniform buffer.
	 *
	 * @param {BufferNode} nodeUniform - The uniform buffer node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 */ constructor(nodeUniform, groupNode){
        super('UniformBuffer_' + $d89c9137a3d237c2$var$_id$4++, nodeUniform ? nodeUniform.value : null);
        /**
		 * The uniform buffer node.
		 *
		 * @type {BufferNode}
		 */ this.nodeUniform = nodeUniform;
        /**
		 * The uniform group node.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = groupNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeUniformBuffer = true;
    }
    /**
	 * The array of update ranges.
	 *
	 * @param {Array<{start: number, count: number}>} value - The update ranges.
	 */ set updateRanges(value) {
        this.nodeUniform.updateRanges = value;
    }
    /**
	 * The array of update ranges.
	 *
	 * @type {Array<{start: number, count: number}>}
	 */ get updateRanges() {
        return this.nodeUniform.updateRanges;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.nodeUniform.addUpdateRange(start, count);
    }
    /**
	 * Clears all update ranges.
	 */ clearUpdateRanges() {
        this.nodeUniform.clearUpdateRanges();
    }
    /**
	 * The uniform buffer.
	 *
	 * @type {Float32Array}
	 */ get buffer() {
        return this.nodeUniform.value;
    }
}
/**
 * This class represents a uniform buffer binding but with
 * an API that allows to maintain individual uniform objects.
 *
 * @private
 * @augments UniformBuffer
 */ class $d89c9137a3d237c2$var$UniformsGroup extends $d89c9137a3d237c2$var$UniformBuffer {
    /**
	 * Constructs a new uniforms group.
	 *
	 * @param {string} name - The group's name.
	 */ constructor(name){
        super(name);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformsGroup = true;
        /**
		 * An array with the raw uniform values.
		 *
		 * @private
		 * @type {?Array<number>}
		 * @default null
		 */ this._values = null;
        /**
		 * An array of uniform objects.
		 *
		 * The order of uniforms in this array must match the order of uniforms in the shader.
		 *
		 * @type {Array<Uniform>}
		 */ this.uniforms = [];
    }
    /**
	 * Adds a uniform to this group.
	 *
	 * @param {Uniform} uniform - The uniform to add.
	 * @return {UniformsGroup} A reference to this group.
	 */ addUniform(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    /**
	 * Removes a uniform from this group.
	 *
	 * @param {Uniform} uniform - The uniform to remove.
	 * @return {UniformsGroup} A reference to this group.
	 */ removeUniform(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    /**
	 * An array with the raw uniform values.
	 *
	 * @type {Array<number>}
	 */ get values() {
        if (this._values === null) this._values = Array.from(this.buffer);
        return this._values;
    }
    /**
	 * A Float32 array buffer with the uniform values.
	 *
	 * @type {Float32Array}
	 */ get buffer() {
        let buffer = this._buffer;
        if (buffer === null) {
            const byteLength = this.byteLength;
            buffer = new Float32Array(new ArrayBuffer(byteLength));
            this._buffer = buffer;
        }
        return buffer;
    }
    /**
	 * The byte length of the buffer with correct buffer alignment.
	 *
	 * @type {number}
	 */ get byteLength() {
        const bytesPerElement = this.bytesPerElement;
        let offset = 0; // global buffer offset in bytes
        for(let i = 0, l = this.uniforms.length; i < l; i++){
            const uniform = this.uniforms[i];
            const boundary = uniform.boundary;
            const itemSize = uniform.itemSize * bytesPerElement; // size of the uniform in bytes
            const chunkOffset = offset % $d89c9137a3d237c2$var$GPU_CHUNK_BYTES; // offset in the current chunk
            const chunkPadding = chunkOffset % boundary; // required padding to match boundary
            const chunkStart = chunkOffset + chunkPadding; // start position in the current chunk for the data
            offset += chunkPadding;
            // Check for chunk overflow
            if (chunkStart !== 0 && $d89c9137a3d237c2$var$GPU_CHUNK_BYTES - chunkStart < itemSize) // Add padding to the end of the chunk
            offset += $d89c9137a3d237c2$var$GPU_CHUNK_BYTES - chunkStart;
            uniform.offset = offset / bytesPerElement;
            offset += itemSize;
        }
        return Math.ceil(offset / $d89c9137a3d237c2$var$GPU_CHUNK_BYTES) * $d89c9137a3d237c2$var$GPU_CHUNK_BYTES;
    }
    /**
	 * Updates this group by updating each uniform object of
	 * the internal uniform list. The uniform objects check if their
	 * values has actually changed so this method only returns
	 * `true` if there is a real value change.
	 *
	 * @return {boolean} Whether the uniforms have been updated and
	 * must be uploaded to the GPU.
	 */ update() {
        let updated = false;
        for (const uniform of this.uniforms)if (this.updateByType(uniform) === true) updated = true;
        return updated;
    }
    /**
	 * Updates a given uniform by calling an update method matching
	 * the uniforms type.
	 *
	 * @param {Uniform} uniform - The uniform to update.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateByType(uniform) {
        if (uniform.isNumberUniform) return this.updateNumber(uniform);
        if (uniform.isVector2Uniform) return this.updateVector2(uniform);
        if (uniform.isVector3Uniform) return this.updateVector3(uniform);
        if (uniform.isVector4Uniform) return this.updateVector4(uniform);
        if (uniform.isColorUniform) return this.updateColor(uniform);
        if (uniform.isMatrix3Uniform) return this.updateMatrix3(uniform);
        if (uniform.isMatrix4Uniform) return this.updateMatrix4(uniform);
        (0, $329ek.error)('WebGPUUniformsGroup: Unsupported uniform type.', uniform);
    }
    /**
	 * Updates a given Number uniform.
	 *
	 * @param {NumberUniform} uniform - The Number uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateNumber(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        const type = uniform.getType();
        if (a[offset] !== v) {
            const b = this._getBufferForType(type);
            b[offset] = a[offset] = v;
            updated = true;
        }
        return updated;
    }
    /**
	 * Updates a given Vector2 uniform.
	 *
	 * @param {Vector2Uniform} uniform - The Vector2 uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateVector2(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        const type = uniform.getType();
        if (a[offset + 0] !== v.x || a[offset + 1] !== v.y) {
            const b = this._getBufferForType(type);
            b[offset + 0] = a[offset + 0] = v.x;
            b[offset + 1] = a[offset + 1] = v.y;
            updated = true;
        }
        return updated;
    }
    /**
	 * Updates a given Vector3 uniform.
	 *
	 * @param {Vector3Uniform} uniform - The Vector3 uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateVector3(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        const type = uniform.getType();
        if (a[offset + 0] !== v.x || a[offset + 1] !== v.y || a[offset + 2] !== v.z) {
            const b = this._getBufferForType(type);
            b[offset + 0] = a[offset + 0] = v.x;
            b[offset + 1] = a[offset + 1] = v.y;
            b[offset + 2] = a[offset + 2] = v.z;
            updated = true;
        }
        return updated;
    }
    /**
	 * Updates a given Vector4 uniform.
	 *
	 * @param {Vector4Uniform} uniform - The Vector4 uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateVector4(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        const type = uniform.getType();
        if (a[offset + 0] !== v.x || a[offset + 1] !== v.y || a[offset + 2] !== v.z || a[offset + 4] !== v.w) {
            const b = this._getBufferForType(type);
            b[offset + 0] = a[offset + 0] = v.x;
            b[offset + 1] = a[offset + 1] = v.y;
            b[offset + 2] = a[offset + 2] = v.z;
            b[offset + 3] = a[offset + 3] = v.w;
            updated = true;
        }
        return updated;
    }
    /**
	 * Updates a given Color uniform.
	 *
	 * @param {ColorUniform} uniform - The Color uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateColor(uniform) {
        let updated = false;
        const a = this.values;
        const c = uniform.getValue();
        const offset = uniform.offset;
        if (a[offset + 0] !== c.r || a[offset + 1] !== c.g || a[offset + 2] !== c.b) {
            const b = this.buffer;
            b[offset + 0] = a[offset + 0] = c.r;
            b[offset + 1] = a[offset + 1] = c.g;
            b[offset + 2] = a[offset + 2] = c.b;
            updated = true;
        }
        return updated;
    }
    /**
	 * Updates a given Matrix3 uniform.
	 *
	 * @param {Matrix3Uniform} uniform - The Matrix3 uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateMatrix3(uniform) {
        let updated = false;
        const a = this.values;
        const e = uniform.getValue().elements;
        const offset = uniform.offset;
        if (a[offset + 0] !== e[0] || a[offset + 1] !== e[1] || a[offset + 2] !== e[2] || a[offset + 4] !== e[3] || a[offset + 5] !== e[4] || a[offset + 6] !== e[5] || a[offset + 8] !== e[6] || a[offset + 9] !== e[7] || a[offset + 10] !== e[8]) {
            const b = this.buffer;
            b[offset + 0] = a[offset + 0] = e[0];
            b[offset + 1] = a[offset + 1] = e[1];
            b[offset + 2] = a[offset + 2] = e[2];
            b[offset + 4] = a[offset + 4] = e[3];
            b[offset + 5] = a[offset + 5] = e[4];
            b[offset + 6] = a[offset + 6] = e[5];
            b[offset + 8] = a[offset + 8] = e[6];
            b[offset + 9] = a[offset + 9] = e[7];
            b[offset + 10] = a[offset + 10] = e[8];
            updated = true;
        }
        return updated;
    }
    /**
	 * Updates a given Matrix4 uniform.
	 *
	 * @param {Matrix4Uniform} uniform - The Matrix4 uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateMatrix4(uniform) {
        let updated = false;
        const a = this.values;
        const e = uniform.getValue().elements;
        const offset = uniform.offset;
        if ($d89c9137a3d237c2$var$arraysEqual(a, e, offset) === false) {
            const b = this.buffer;
            b.set(e, offset);
            $d89c9137a3d237c2$var$setArray(a, e, offset);
            updated = true;
        }
        return updated;
    }
    /**
	 * Returns a typed array that matches the given data type.
	 *
	 * @private
	 * @param {string} type - The data type.
	 * @return {TypedArray} The typed array.
	 */ _getBufferForType(type) {
        if (type === 'int' || type === 'ivec2' || type === 'ivec3' || type === 'ivec4') return new Int32Array(this.buffer.buffer);
        if (type === 'uint' || type === 'uvec2' || type === 'uvec3' || type === 'uvec4') return new Uint32Array(this.buffer.buffer);
        return this.buffer;
    }
}
/**
 * Sets the values of the second array to the first array.
 *
 * @private
 * @param {TypedArray} a - The first array.
 * @param {TypedArray} b - The second array.
 * @param {number} offset - An index offset for the first array.
 */ function $d89c9137a3d237c2$var$setArray(a, b, offset) {
    for(let i = 0, l = b.length; i < l; i++)a[offset + i] = b[i];
}
/**
 * Returns `true` if the given arrays are equal.
 *
 * @private
 * @param {TypedArray} a - The first array.
 * @param {TypedArray} b - The second array.
 * @param {number} offset - An index offset for the first array.
 * @return {boolean} Whether the given arrays are equal or not.
 */ function $d89c9137a3d237c2$var$arraysEqual(a, b, offset) {
    for(let i = 0, l = b.length; i < l; i++){
        if (a[offset + i] !== b[i]) return false;
    }
    return true;
}
let $d89c9137a3d237c2$var$_id$3 = 0;
/**
 * A special form of uniforms group that represents
 * the individual uniforms as node-based uniforms.
 *
 * @private
 * @augments UniformsGroup
 */ class $d89c9137a3d237c2$var$NodeUniformsGroup extends $d89c9137a3d237c2$var$UniformsGroup {
    /**
	 * Constructs a new node-based uniforms group.
	 *
	 * @param {string} name - The group's name.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 */ constructor(name, groupNode){
        super(name);
        /**
		 * The group's ID.
		 *
		 * @type {number}
		 */ this.id = $d89c9137a3d237c2$var$_id$3++;
        /**
		 * The uniform group node.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = groupNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeUniformsGroup = true;
    }
}
/**
 * Represents a sampler binding type.
 *
 * @private
 * @augments Binding
 */ class $d89c9137a3d237c2$var$Sampler extends $d89c9137a3d237c2$var$Binding {
    /**
	 * Constructs a new sampler.
	 *
	 * @param {string} name - The samplers's name.
	 * @param {?Texture} texture - The texture this binding is referring to.
	 */ constructor(name, texture){
        super(name);
        /**
		 * The texture the sampler is referring to.
		 *
		 * @private
		 * @type {?Texture}
		 */ this._texture = null;
        /**
		 * An event listener which is added to {@link texture}'s dispose event.
		 *
		 * @private
		 * @type {Function}
		 */ this._onTextureDispose = ()=>{
            this.generation = null;
            this.version = 0;
        };
        // Assignment to the texture via a setter must occur after "_onTextureDispose" is initialized.
        this.texture = texture;
        /**
		 * The binding's version.
		 *
		 * @type {number}
		 */ this.version = texture ? texture.version : 0;
        /**
		 * The binding's generation which is an additional version
		 * qualifier.
		 *
		 * @type {?number}
		 * @default null
		 */ this.generation = null;
        /**
		 * The binding's sampler key.
		 *
		 * @type {string}
		 * @default ''
		 */ this.samplerKey = '';
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSampler = true;
    }
    /**
	 * Sets the texture of this sampler.
	 *
	 * @param {Texture} value - The texture to set.
	 */ set texture(value) {
        if (this._texture === value) return;
        if (this._texture) this._texture.removeEventListener('dispose', this._onTextureDispose);
        this._texture = value;
        this.generation = null;
        this.version = 0;
        if (this._texture) this._texture.addEventListener('dispose', this._onTextureDispose);
    }
    /**
	 * Gets the texture of this sampler.
	 * @return {?Texture} The texture.
	 */ get texture() {
        return this._texture;
    }
    /**
	 * Updates the binding.
	 *
	 * @return {boolean} Whether the texture has been updated and must be
	 * uploaded to the GPU.
	 */ update() {
        const { texture: texture, version: version } = this;
        if (version !== texture.version) {
            this.version = texture.version;
            return true;
        }
        return false;
    }
    clone() {
        const clonedSampler = super.clone();
        // fix dispose handler for cloned instances
        // TODO: Find better solution, see #31747
        clonedSampler._texture = null;
        clonedSampler._onTextureDispose = ()=>{
            clonedSampler.generation = null;
            clonedSampler.version = 0;
        };
        clonedSampler.texture = this.texture;
        return clonedSampler;
    }
}
let $d89c9137a3d237c2$var$_id$2 = 0;
/**
 * Represents a sampled texture binding type.
 *
 * @private
 * @augments Sampler
 */ class $d89c9137a3d237c2$var$SampledTexture extends $d89c9137a3d237c2$var$Sampler {
    /**
	 * Constructs a new sampled texture.
	 *
	 * @param {string} name - The sampled texture's name.
	 * @param {?Texture} texture - The texture this binding is referring to.
	 */ constructor(name, texture){
        super(name, texture);
        /**
		 * This identifier.
		 *
		 * @type {number}
		 */ this.id = $d89c9137a3d237c2$var$_id$2++;
        /**
		 * Whether the texture is a storage texture or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.store = false;
        /**
		 * The mip level to bind for storage textures.
		 *
		 * @type {number}
		 * @default 0
		 */ this.mipLevel = 0;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSampledTexture = true;
    }
}
/**
 * A special form of sampled texture binding type.
 * It's texture value is managed by a node object.
 *
 * @private
 * @augments SampledTexture
 */ class $d89c9137a3d237c2$var$NodeSampledTexture extends $d89c9137a3d237c2$var$SampledTexture {
    /**
	 * Constructs a new node-based sampled texture.
	 *
	 * @param {string} name - The textures's name.
	 * @param {TextureNode} textureNode - The texture node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 * @param {?string} [access=null] - The access type.
	 */ constructor(name, textureNode, groupNode, access = null){
        super(name, textureNode ? textureNode.value : null);
        /**
		 * The texture node.
		 *
		 * @type {TextureNode}
		 */ this.textureNode = textureNode;
        /**
		 * The uniform group node.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = groupNode;
        /**
		 * The access type.
		 *
		 * @type {?string}
		 * @default null
		 */ this.access = access;
    }
    /**
	 * Updates the binding.
	 *
	 * @return {boolean} Whether the texture has been updated and must be
	 * uploaded to the GPU.
	 */ update() {
        const { textureNode: textureNode } = this;
        if (this.texture !== textureNode.value) {
            this.texture = textureNode.value;
            return true;
        }
        return super.update();
    }
}
/**
 * A special form of sampled cube texture binding type.
 * It's texture value is managed by a node object.
 *
 * @private
 * @augments NodeSampledTexture
 */ class $d89c9137a3d237c2$var$NodeSampledCubeTexture extends $d89c9137a3d237c2$var$NodeSampledTexture {
    /**
	 * Constructs a new node-based sampled cube texture.
	 *
	 * @param {string} name - The textures's name.
	 * @param {TextureNode} textureNode - The texture node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 * @param {?string} [access=null] - The access type.
	 */ constructor(name, textureNode, groupNode, access = null){
        super(name, textureNode, groupNode, access);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSampledCubeTexture = true;
    }
}
/**
 * A special form of sampled 3D texture binding type.
 * It's texture value is managed by a node object.
 *
 * @private
 * @augments NodeSampledTexture
 */ class $d89c9137a3d237c2$var$NodeSampledTexture3D extends $d89c9137a3d237c2$var$NodeSampledTexture {
    /**
	 * Constructs a new node-based sampled 3D texture.
	 *
	 * @param {string} name - The textures's name.
	 * @param {TextureNode} textureNode - The texture node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 * @param {?string} [access=null] - The access type.
	 */ constructor(name, textureNode, groupNode, access = null){
        super(name, textureNode, groupNode, access);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSampledTexture3D = true;
    }
}
const $d89c9137a3d237c2$var$glslPolyfills = {
    bitcast_int_uint: new $d89c9137a3d237c2$export$347eb46a3090e941(/* glsl */ 'uint tsl_bitcast_int_to_uint ( int x ) { return floatBitsToUint( intBitsToFloat ( x ) ); }'),
    bitcast_uint_int: new $d89c9137a3d237c2$export$347eb46a3090e941(/* glsl */ 'uint tsl_bitcast_uint_to_int ( uint x ) { return floatBitsToInt( uintBitsToFloat ( x ) ); }')
};
const $d89c9137a3d237c2$var$glslMethods = {
    textureDimensions: 'textureSize',
    equals: 'equal',
    bitcast_float_int: 'floatBitsToInt',
    bitcast_int_float: 'intBitsToFloat',
    bitcast_uint_float: 'uintBitsToFloat',
    bitcast_float_uint: 'floatBitsToUint',
    bitcast_uint_int: 'tsl_bitcast_uint_to_int',
    bitcast_int_uint: 'tsl_bitcast_int_to_uint',
    floatpack_snorm_2x16: 'packSnorm2x16',
    floatpack_unorm_2x16: 'packUnorm2x16',
    floatpack_float16_2x16: 'packHalf2x16',
    floatunpack_snorm_2x16: 'unpackSnorm2x16',
    floatunpack_unorm_2x16: 'unpackUnorm2x16',
    floatunpack_float16_2x16: 'unpackHalf2x16'
};
const $d89c9137a3d237c2$var$precisionLib = {
    low: 'lowp',
    medium: 'mediump',
    high: 'highp'
};
const $d89c9137a3d237c2$var$supports$1 = {
    swizzleAssign: true,
    storageBuffer: false
};
const $d89c9137a3d237c2$var$interpolationTypeMap = {
    perspective: 'smooth',
    linear: 'noperspective'
};
const $d89c9137a3d237c2$var$interpolationModeMap = {
    'centroid': 'centroid'
};
const $d89c9137a3d237c2$var$defaultPrecisions = `
precision highp float;
precision highp int;
precision highp sampler2D;
precision highp sampler3D;
precision highp samplerCube;
precision highp sampler2DArray;

precision highp usampler2D;
precision highp usampler3D;
precision highp usamplerCube;
precision highp usampler2DArray;

precision highp isampler2D;
precision highp isampler3D;
precision highp isamplerCube;
precision highp isampler2DArray;

precision lowp sampler2DShadow;
precision lowp sampler2DArrayShadow;
precision lowp samplerCubeShadow;
`;
/**
 * A node builder targeting GLSL.
 *
 * This module generates GLSL shader code from node materials and also
 * generates the respective bindings and vertex buffer definitions. These
 * data are later used by the renderer to create render and compute pipelines
 * for render objects.
 *
 * @augments NodeBuilder
 */ class $d89c9137a3d237c2$var$GLSLNodeBuilder extends $d89c9137a3d237c2$export$e3bd53a4d3c1a94e {
    /**
	 * Constructs a new GLSL node builder renderer.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Renderer} renderer - The renderer.
	 */ constructor(object, renderer){
        super(object, renderer, new $d89c9137a3d237c2$export$18a74e8f50eca178());
        /**
		 * A dictionary holds for each shader stage ('vertex', 'fragment', 'compute')
		 * another dictionary which manages UBOs per group ('render','frame','object').
		 *
		 * @type {Object<string,Object<string,NodeUniformsGroup>>}
		 */ this.uniformGroups = {};
        /**
		 * An array that holds objects defining the varying and attribute data in
		 * context of Transform Feedback.
		 *
		 * @type {Array<Object<string,AttributeNode|string>>}
		 */ this.transforms = [];
        /**
		 * A dictionary that holds for each shader stage a Map of used extensions.
		 *
		 * @type {Object<string,Map<string,Object>>}
		 */ this.extensions = {};
        /**
		 * A dictionary that holds for each shader stage an Array of used builtins.
		 *
		 * @type {Object<string,Array<string>>}
		 */ this.builtins = {
            vertex: [],
            fragment: [],
            compute: []
        };
    }
    /**
	 * Checks if the given texture requires a manual conversion to the working color space.
	 *
	 * @param {Texture} texture - The texture to check.
	 * @return {boolean} Whether the given texture requires a conversion to working color space or not.
	 */ needsToWorkingColorSpace(texture) {
        return texture.isVideoTexture === true && texture.colorSpace !== (0, $329ek.NoColorSpace);
    }
    /**
	 * Includes the given method name into the current
	 * function node.
	 *
	 * @private
	 * @param {string} name - The method name to include.
	 * @return {CodeNode} The respective code node.
	 */ _include(name) {
        const codeNode = $d89c9137a3d237c2$var$glslPolyfills[name];
        codeNode.build(this);
        this.addInclude(codeNode);
        return codeNode;
    }
    /**
	 * Returns the native shader method name for a given generic name.
	 *
	 * @param {string} method - The method name to resolve.
	 * @return {string} The resolved GLSL method name.
	 */ getMethod(method) {
        if ($d89c9137a3d237c2$var$glslPolyfills[method] !== undefined) this._include(method);
        return $d89c9137a3d237c2$var$glslMethods[method] || method;
    }
    /**
	 * Returns the bitcast method name for a given input and outputType.
	 *
	 * @param {string} type - The output type to bitcast to.
	 * @param {string} inputType - The input type of the.
	 * @return {string} The resolved WGSL bitcast invocation.
	 */ getBitcastMethod(type, inputType) {
        return this.getMethod(`bitcast_${inputType}_${type}`);
    }
    /**
	 * Returns the float packing method name for a given numeric encoding.
	 *
	 * @param {string} encoding - The numeric encoding that describes how the float values are mapped to the integer range.
	 * @returns {string} The resolved GLSL float packing method name.
	 */ getFloatPackingMethod(encoding) {
        return this.getMethod(`floatpack_${encoding}_2x16`);
    }
    /**
	 * Returns the float unpacking method name for a given numeric encoding.
	 *
	 * @param {string} encoding - The numeric encoding that describes how the integer values are mapped to the float range.
	 * @returns {string} The resolved GLSL float unpacking method name.
	 */ getFloatUnpackingMethod(encoding) {
        return this.getMethod(`floatunpack_${encoding}_2x16`);
    }
    /**
	 * Returns the native snippet for a ternary operation.
	 *
	 * @param {string} condSnippet - The condition determining which expression gets resolved.
	 * @param {string} ifSnippet - The expression to resolve to if the condition is true.
	 * @param {string} elseSnippet - The expression to resolve to if the condition is false.
	 * @return {string} The resolved method name.
	 */ getTernary(condSnippet, ifSnippet, elseSnippet) {
        return `${condSnippet} ? ${ifSnippet} : ${elseSnippet}`;
    }
    /**
	 * Returns the output struct name. Not relevant for GLSL.
	 *
	 * @return {string}
	 */ getOutputStructName() {
        return '';
    }
    /**
	 * Builds the given shader node.
	 *
	 * @param {ShaderNodeInternal} shaderNode - The shader node.
	 * @return {string} The GLSL function code.
	 */ buildFunctionCode(shaderNode) {
        const layout = shaderNode.layout;
        const flowData = this.flowShaderNode(shaderNode);
        const parameters = [];
        for (const input of layout.inputs)parameters.push(this.getType(input.type) + ' ' + input.name);
        //
        const code = `${this.getType(layout.type)} ${layout.name}( ${parameters.join(', ')} ) {

	${flowData.vars}

${flowData.code}
	return ${flowData.result};

}`;
        //
        return code;
    }
    /**
	 * Setups the Pixel Buffer Object (PBO) for the given storage
	 * buffer node.
	 *
	 * @param {StorageBufferNode} storageBufferNode - The storage buffer node.
	 */ setupPBO(storageBufferNode) {
        const attribute = storageBufferNode.value;
        if (attribute.pbo === undefined) {
            const originalArray = attribute.array;
            const numElements = attribute.count * attribute.itemSize;
            const { itemSize: itemSize } = attribute;
            const isInteger = attribute.array.constructor.name.toLowerCase().includes('int');
            let format = isInteger ? (0, $329ek.RedIntegerFormat) : (0, $329ek.RedFormat);
            if (itemSize === 2) format = isInteger ? (0, $329ek.RGIntegerFormat) : (0, $329ek.RGFormat);
            else if (itemSize === 3) format = isInteger ? (0, $329ek.RGBIntegerFormat) : (0, $329ek.RGBFormat);
            else if (itemSize === 4) format = isInteger ? (0, $329ek.RGBAIntegerFormat) : (0, $329ek.RGBAFormat);
            const typeMap = {
                Float32Array: (0, $329ek.FloatType),
                Uint8Array: (0, $329ek.UnsignedByteType),
                Uint16Array: (0, $329ek.UnsignedShortType),
                Uint32Array: (0, $329ek.UnsignedIntType),
                Int8Array: (0, $329ek.ByteType),
                Int16Array: (0, $329ek.ShortType),
                Int32Array: (0, $329ek.IntType),
                Uint8ClampedArray: (0, $329ek.UnsignedByteType)
            };
            const width = Math.pow(2, Math.ceil(Math.log2(Math.sqrt(numElements / itemSize))));
            let height = Math.ceil(numElements / itemSize / width);
            if (width * height * itemSize < numElements) height++; // Ensure enough space
            const newSize = width * height * itemSize;
            const newArray = new originalArray.constructor(newSize);
            newArray.set(originalArray, 0);
            attribute.array = newArray;
            const pboTexture = new (0, $329ek.DataTexture)(attribute.array, width, height, format, typeMap[attribute.array.constructor.name] || (0, $329ek.FloatType));
            pboTexture.needsUpdate = true;
            pboTexture.isPBOTexture = true;
            const pbo = new $d89c9137a3d237c2$export$2dd903bc9e8140bc(pboTexture, null, null);
            pbo.setPrecision('high');
            attribute.pboNode = pbo;
            attribute.pbo = pbo.value;
            this.getUniformFromNode(attribute.pboNode, 'texture', this.shaderStage, this.context.nodeName);
        }
    }
    /**
	 * Returns a GLSL snippet that represents the property name of the given node.
	 *
	 * @param {Node} node - The node.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The property name.
	 */ getPropertyName(node, shaderStage = this.shaderStage) {
        if (node.isNodeUniform && node.node.isTextureNode !== true && node.node.isBufferNode !== true) return shaderStage.charAt(0) + '_' + node.name;
        return super.getPropertyName(node, shaderStage);
    }
    /**
	 * Setups the Pixel Buffer Object (PBO) for the given storage
	 * buffer node.
	 *
	 * @param {StorageArrayElementNode} storageArrayElementNode - The storage array element node.
	 * @return {string} The property name.
	 */ generatePBO(storageArrayElementNode) {
        const { node: node, indexNode: indexNode } = storageArrayElementNode;
        const attribute = node.value;
        if (this.renderer.backend.has(attribute)) {
            const attributeData = this.renderer.backend.get(attribute);
            attributeData.pbo = attribute.pbo;
        }
        const nodeUniform = this.getUniformFromNode(attribute.pboNode, 'texture', this.shaderStage, this.context.nodeName);
        const textureName = this.getPropertyName(nodeUniform);
        this.increaseUsage(indexNode); // force cache generate to be used as index in x,y
        const indexSnippet = indexNode.build(this, 'uint');
        const elementNodeData = this.getDataFromNode(storageArrayElementNode);
        let propertyName = elementNodeData.propertyName;
        if (propertyName === undefined) {
            // property element
            const nodeVar = this.getVarFromNode(storageArrayElementNode);
            propertyName = this.getPropertyName(nodeVar);
            // property size
            const bufferNodeData = this.getDataFromNode(node);
            let propertySizeName = bufferNodeData.propertySizeName;
            if (propertySizeName === undefined) {
                propertySizeName = propertyName + 'Size';
                this.getVarFromNode(node, propertySizeName, 'uint');
                this.addLineFlowCode(`${propertySizeName} = uint( textureSize( ${textureName}, 0 ).x )`, storageArrayElementNode);
                bufferNodeData.propertySizeName = propertySizeName;
            }
            //
            const { itemSize: itemSize } = attribute;
            const channel = '.' + $d89c9137a3d237c2$export$1c0adcb9073b646d.join('').slice(0, itemSize);
            const uvSnippet = `ivec2(${indexSnippet} % ${propertySizeName}, ${indexSnippet} / ${propertySizeName})`;
            const snippet = this.generateTextureLoad(null, textureName, uvSnippet, '0', null, null);
            //
            let prefix = 'vec4';
            if (attribute.pbo.type === (0, $329ek.UnsignedIntType)) prefix = 'uvec4';
            else if (attribute.pbo.type === (0, $329ek.IntType)) prefix = 'ivec4';
            this.addLineFlowCode(`${propertyName} = ${prefix}(${snippet})${channel}`, storageArrayElementNode);
            elementNodeData.propertyName = propertyName;
        }
        return propertyName;
    }
    /**
	 * Generates the GLSL snippet that reads a single texel from a texture without sampling or filtering.
	 *
	 * @param {?Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvIndexSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} levelSnippet - A GLSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {?string} depthSnippet - A GLSL snippet that represents the 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The GLSL snippet.
	 */ generateTextureLoad(texture, textureProperty, uvIndexSnippet, levelSnippet, depthSnippet, offsetSnippet) {
        if (levelSnippet === null) levelSnippet = '0';
        let snippet;
        if (depthSnippet) {
            if (offsetSnippet) snippet = `texelFetchOffset( ${textureProperty}, ivec3( ${uvIndexSnippet}, ${depthSnippet} ), ${levelSnippet}, ${offsetSnippet} )`;
            else snippet = `texelFetch( ${textureProperty}, ivec3( ${uvIndexSnippet}, ${depthSnippet} ), ${levelSnippet} )`;
        } else if (offsetSnippet) snippet = `texelFetchOffset( ${textureProperty}, ${uvIndexSnippet}, ${levelSnippet}, ${offsetSnippet} )`;
        else snippet = `texelFetch( ${textureProperty}, ${uvIndexSnippet}, ${levelSnippet} )`;
        if (texture !== null && texture.isDepthTexture) snippet += '.x';
        return snippet;
    }
    /**
	 * Generates the GLSL snippet for sampling/loading the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} depthSnippet -  A GLSL snippet that represents the 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The GLSL snippet.
	 */ generateTexture(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet) {
        if (depthSnippet) uvSnippet = `vec3( ${uvSnippet}, ${depthSnippet} )`;
        if (texture.isDepthTexture) {
            if (offsetSnippet) return `textureOffset( ${textureProperty}, ${uvSnippet}, ${offsetSnippet} ).x`;
            return `texture( ${textureProperty}, ${uvSnippet} ).x`;
        }
        if (offsetSnippet) return `textureOffset( ${textureProperty}, ${uvSnippet}, ${offsetSnippet} )`;
        return `texture( ${textureProperty}, ${uvSnippet} )`;
    }
    /**
	 * Generates the GLSL snippet when sampling textures with explicit mip level.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {string} levelSnippet - A GLSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The GLSL snippet.
	 */ generateTextureLevel(texture, textureProperty, uvSnippet, levelSnippet, offsetSnippet) {
        if (offsetSnippet) return `textureLodOffset( ${textureProperty}, ${uvSnippet}, ${levelSnippet}, ${offsetSnippet} )`;
        return `textureLod( ${textureProperty}, ${uvSnippet}, ${levelSnippet} )`;
    }
    /**
	 * Generates the GLSL snippet when sampling textures with a bias to the mip level.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {string} biasSnippet - A GLSL snippet that represents the bias to apply to the mip level before sampling.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The GLSL snippet.
	 */ generateTextureBias(texture, textureProperty, uvSnippet, biasSnippet, offsetSnippet) {
        if (offsetSnippet) return `textureOffset( ${textureProperty}, ${uvSnippet}, ${offsetSnippet}, ${biasSnippet} )`;
        return `texture( ${textureProperty}, ${uvSnippet}, ${biasSnippet} )`;
    }
    /**
	 * Generates the GLSL snippet for sampling/loading the given texture using explicit gradients.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {Array<string>} gradSnippet - An array holding both gradient GLSL snippets.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The GLSL snippet.
	 */ generateTextureGrad(texture, textureProperty, uvSnippet, gradSnippet, offsetSnippet) {
        if (offsetSnippet) return `textureGradOffset( ${textureProperty}, ${uvSnippet}, ${gradSnippet[0]}, ${gradSnippet[1]}, ${offsetSnippet} )`;
        return `textureGrad( ${textureProperty}, ${uvSnippet}, ${gradSnippet[0]}, ${gradSnippet[1]} )`;
    }
    /**
	 * Generates the GLSL snippet for sampling a depth texture and comparing the sampled depth values
	 * against a reference value.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {string} compareSnippet -  A GLSL snippet that represents the reference value.
	 * @param {?string} depthSnippet - A GLSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The GLSL snippet.
	 */ generateTextureCompare(texture, textureProperty, uvSnippet, compareSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') {
            // Cube shadow maps use vec4(direction, compareValue)
            if (texture.isCubeTexture) return `texture( ${textureProperty}, vec4( ${uvSnippet}, ${compareSnippet} ) )`;
            if (depthSnippet) {
                if (offsetSnippet) return `textureOffset( ${textureProperty}, vec4( ${uvSnippet}, ${depthSnippet}, ${compareSnippet} ), ${offsetSnippet} )`;
                return `texture( ${textureProperty}, vec4( ${uvSnippet}, ${depthSnippet}, ${compareSnippet} ) )`;
            }
            if (offsetSnippet) return `textureOffset( ${textureProperty}, vec3( ${uvSnippet}, ${compareSnippet} ), ${offsetSnippet} )`;
            return `texture( ${textureProperty}, vec3( ${uvSnippet}, ${compareSnippet} ) )`;
        } else (0, $329ek.error)(`WebGPURenderer: THREE.DepthTexture.compareFunction() does not support ${shaderStage} shader.`);
    }
    /**
	 * Returns the variables of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the variables.
	 */ getVars(shaderStage) {
        const snippets = [];
        const vars = this.vars[shaderStage];
        if (vars !== undefined) for (const variable of vars)snippets.push(`${this.getVar(variable.type, variable.name, variable.count)};`);
        return snippets.join('\n\t');
    }
    /**
	 * Returns the uniforms of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the uniforms.
	 */ getUniforms(shaderStage) {
        const uniforms = this.uniforms[shaderStage];
        const bindingSnippets = [];
        const uniformGroups = {};
        for (const uniform of uniforms){
            let snippet = null;
            let group = false;
            if (uniform.type === 'texture' || uniform.type === 'texture3D') {
                const texture = uniform.node.value;
                let typePrefix = '';
                if (texture.isDataTexture === true || texture.isData3DTexture === true) {
                    if (texture.type === (0, $329ek.UnsignedIntType)) typePrefix = 'u';
                    else if (texture.type === (0, $329ek.IntType)) typePrefix = 'i';
                }
                if (uniform.type === 'texture3D' && texture.isArrayTexture === false) snippet = `${typePrefix}sampler3D ${uniform.name};`;
                else if (texture.compareFunction) {
                    if (texture.isArrayTexture === true) snippet = `sampler2DArrayShadow ${uniform.name};`;
                    else snippet = `sampler2DShadow ${uniform.name};`;
                } else if (texture.isArrayTexture === true || texture.isDataArrayTexture === true || texture.isCompressedArrayTexture === true) snippet = `${typePrefix}sampler2DArray ${uniform.name};`;
                else snippet = `${typePrefix}sampler2D ${uniform.name};`;
            } else if (uniform.type === 'cubeTexture') snippet = `samplerCube ${uniform.name};`;
            else if (uniform.type === 'cubeDepthTexture') snippet = `samplerCubeShadow ${uniform.name};`;
            else if (uniform.type === 'buffer') {
                const bufferNode = uniform.node;
                const bufferType = this.getType(bufferNode.bufferType);
                const bufferCount = bufferNode.bufferCount;
                const bufferCountSnippet = bufferCount > 0 ? bufferCount : '';
                snippet = `${bufferNode.name} {\n\t${bufferType} ${uniform.name}[${bufferCountSnippet}];\n};\n`;
            } else {
                const vectorType = this.getVectorType(uniform.type);
                snippet = `${vectorType} ${this.getPropertyName(uniform, shaderStage)};`;
                group = true;
            }
            const precision = uniform.node.precision;
            if (precision !== null) snippet = $d89c9137a3d237c2$var$precisionLib[precision] + ' ' + snippet;
            if (group) {
                snippet = '\t' + snippet;
                const groupName = uniform.groupNode.name;
                const groupSnippets = uniformGroups[groupName] || (uniformGroups[groupName] = []);
                groupSnippets.push(snippet);
            } else {
                snippet = 'uniform ' + snippet;
                bindingSnippets.push(snippet);
            }
        }
        let output = '';
        for(const name in uniformGroups){
            const groupSnippets = uniformGroups[name];
            output += this._getGLSLUniformStruct(shaderStage + '_' + name, groupSnippets.join('\n')) + '\n';
        }
        output += bindingSnippets.join('\n');
        return output;
    }
    /**
	 * Returns the type for a given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 * @return {string} The type.
	 */ getTypeFromAttribute(attribute) {
        let nodeType = super.getTypeFromAttribute(attribute);
        if (/^[iu]/.test(nodeType) && attribute.gpuType !== (0, $329ek.IntType)) {
            let dataAttribute = attribute;
            if (attribute.isInterleavedBufferAttribute) dataAttribute = attribute.data;
            const array = dataAttribute.array;
            if ((array instanceof Uint32Array || array instanceof Int32Array) === false) nodeType = nodeType.slice(1);
        }
        return nodeType;
    }
    /**
	 * Returns the shader attributes of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the shader attributes.
	 */ getAttributes(shaderStage) {
        let snippet = '';
        if (shaderStage === 'vertex' || shaderStage === 'compute') {
            const attributes = this.getAttributesArray();
            let location = 0;
            for (const attribute of attributes)snippet += `layout( location = ${location++} ) in ${attribute.type} ${attribute.name};\n`;
        }
        return snippet;
    }
    /**
	 * Returns the members of the given struct type node as a GLSL string.
	 *
	 * @param {StructTypeNode} struct - The struct type node.
	 * @return {string} The GLSL snippet that defines the struct members.
	 */ getStructMembers(struct) {
        const snippets = [];
        for (const member of struct.members)snippets.push(`\t${member.type} ${member.name};`);
        return snippets.join('\n');
    }
    /**
	 * Returns the structs of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the structs.
	 */ getStructs(shaderStage) {
        const snippets = [];
        const structs = this.structs[shaderStage];
        const outputSnippet = [];
        for (const struct of structs){
            if (struct.output) for (const member of struct.members)outputSnippet.push(`layout( location = ${member.index} ) out ${member.type} ${member.name};`);
            else {
                let snippet = 'struct ' + struct.name + ' {\n';
                snippet += this.getStructMembers(struct);
                snippet += '\n};\n';
                snippets.push(snippet);
            }
        }
        if (outputSnippet.length === 0) outputSnippet.push('layout( location = 0 ) out vec4 fragColor;');
        return '\n' + outputSnippet.join('\n') + '\n\n' + snippets.join('\n');
    }
    /**
	 * Returns the varyings of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the varyings.
	 */ getVaryings(shaderStage) {
        let snippet = '';
        const varyings = this.varyings;
        if (shaderStage === 'vertex' || shaderStage === 'compute') for (const varying of varyings){
            if (shaderStage === 'compute') varying.needsInterpolation = true;
            const type = this.getType(varying.type);
            if (varying.needsInterpolation) {
                if (varying.interpolationType) {
                    const interpolationType = $d89c9137a3d237c2$var$interpolationTypeMap[varying.interpolationType] || varying.interpolationType;
                    const sampling = $d89c9137a3d237c2$var$interpolationModeMap[varying.interpolationSampling] || '';
                    snippet += `${interpolationType} ${sampling} out ${type} ${varying.name};\n`;
                } else {
                    const flat = type.includes('int') || type.includes('uv') || type.includes('iv') ? 'flat ' : '';
                    snippet += `${flat}out ${type} ${varying.name};\n`;
                }
            } else snippet += `${type} ${varying.name};\n`; // generate variable (no varying required)
        }
        else if (shaderStage === 'fragment') {
            for (const varying of varyings)if (varying.needsInterpolation) {
                const type = this.getType(varying.type);
                if (varying.interpolationType) {
                    const interpolationType = $d89c9137a3d237c2$var$interpolationTypeMap[varying.interpolationType] || varying.interpolationType;
                    const sampling = $d89c9137a3d237c2$var$interpolationModeMap[varying.interpolationSampling] || '';
                    snippet += `${interpolationType} ${sampling} in ${type} ${varying.name};\n`;
                } else {
                    const flat = type.includes('int') || type.includes('uv') || type.includes('iv') ? 'flat ' : '';
                    snippet += `${flat}in ${type} ${varying.name};\n`;
                }
            }
        }
        for (const builtin of this.builtins[shaderStage])snippet += `${builtin};\n`;
        return snippet;
    }
    /**
	 * Returns the vertex index builtin.
	 *
	 * @return {string} The vertex index.
	 */ getVertexIndex() {
        return 'uint( gl_VertexID )';
    }
    /**
	 * Contextually returns either the vertex stage instance index builtin
	 * or the linearized index of an compute invocation within a grid of workgroups.
	 *
	 * @return {string} The instance index.
	 */ getInstanceIndex() {
        return 'uint( gl_InstanceID )';
    }
    /**
	 * Returns a builtin representing the index of an invocation within its workgroup.
	 *
	 * @return {string} The invocation local index.
	 */ getInvocationLocalIndex() {
        const workgroupSize = this.object.workgroupSize;
        const size = workgroupSize.reduce((acc, curr)=>acc * curr, 1);
        return `uint( gl_InstanceID ) % ${size}u`;
    }
    /**
	 * Returns a builtin representing the size of a subgroup within the current shader.
	 */ getSubgroupSize() {
        (0, $329ek.error)('GLSLNodeBuilder: WebGLBackend does not support the subgroupSize node');
    }
    /**
	 * Returns a builtin representing the index of an invocation within its subgroup.
	 */ getInvocationSubgroupIndex() {
        (0, $329ek.error)('GLSLNodeBuilder: WebGLBackend does not support the invocationSubgroupIndex node');
    }
    /**
	 * Returns a builtin representing the index of the current invocation's subgroup within its workgroup.
	 */ getSubgroupIndex() {
        (0, $329ek.error)('GLSLNodeBuilder: WebGLBackend does not support the subgroupIndex node');
    }
    /**
	 * Returns the draw index builtin.
	 *
	 * @return {?string} The drawIndex shader string. Returns `null` if `WEBGL_multi_draw` isn't supported by the device.
	 */ getDrawIndex() {
        const extensions = this.renderer.backend.extensions;
        if (extensions.has('WEBGL_multi_draw')) return 'uint( gl_DrawID )';
        return null;
    }
    /**
	 * Returns the front facing builtin.
	 *
	 * @return {string} The front facing builtin.
	 */ getFrontFacing() {
        return 'gl_FrontFacing';
    }
    /**
	 * Returns the frag coord builtin.
	 *
	 * @return {string} The frag coord builtin.
	 */ getFragCoord() {
        return 'gl_FragCoord.xy';
    }
    /**
	 * Returns the frag depth builtin.
	 *
	 * @return {string} The frag depth builtin.
	 */ getFragDepth() {
        return 'gl_FragDepth';
    }
    /**
	 * Enables the given extension.
	 *
	 * @param {string} name - The extension name.
	 * @param {string} behavior - The extension behavior.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage.
	 */ enableExtension(name, behavior, shaderStage = this.shaderStage) {
        const map = this.extensions[shaderStage] || (this.extensions[shaderStage] = new Map());
        if (map.has(name) === false) map.set(name, {
            name: name,
            behavior: behavior
        });
    }
    /**
	 * Returns the enabled extensions of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the enabled extensions.
	 */ getExtensions(shaderStage) {
        const snippets = [];
        if (shaderStage === 'vertex') {
            const ext = this.renderer.backend.extensions;
            const isBatchedMesh = this.object.isBatchedMesh;
            if (isBatchedMesh && ext.has('WEBGL_multi_draw')) this.enableExtension('GL_ANGLE_multi_draw', 'require', shaderStage);
        }
        const extensions = this.extensions[shaderStage];
        if (extensions !== undefined) for (const { name: name, behavior: behavior } of extensions.values())snippets.push(`#extension ${name} : ${behavior}`);
        return snippets.join('\n');
    }
    /**
	 * Returns the clip distances builtin.
	 *
	 * @return {string} The clip distances builtin.
	 */ getClipDistance() {
        return 'gl_ClipDistance';
    }
    /**
	 * Whether the requested feature is available or not.
	 *
	 * @param {string} name - The requested feature.
	 * @return {boolean} Whether the requested feature is supported or not.
	 */ isAvailable(name) {
        let result = $d89c9137a3d237c2$var$supports$1[name];
        if (result === undefined) {
            let extensionName;
            result = false;
            switch(name){
                case 'float32Filterable':
                    extensionName = 'OES_texture_float_linear';
                    break;
                case 'clipDistance':
                    extensionName = 'WEBGL_clip_cull_distance';
                    break;
            }
            if (extensionName !== undefined) {
                const extensions = this.renderer.backend.extensions;
                if (extensions.has(extensionName)) {
                    extensions.get(extensionName);
                    result = true;
                }
            }
            $d89c9137a3d237c2$var$supports$1[name] = result;
        }
        return result;
    }
    /**
	 * Whether to flip texture data along its vertical axis or not.
	 *
	 * @return {boolean} Returns always `true` in context of GLSL.
	 */ isFlipY() {
        return true;
    }
    /**
	 * Enables hardware clipping.
	 *
	 * @param {string} planeCount - The clipping plane count.
	 */ enableHardwareClipping(planeCount) {
        this.enableExtension('GL_ANGLE_clip_cull_distance', 'require');
        this.builtins['vertex'].push(`out float gl_ClipDistance[ ${planeCount} ]`);
    }
    /**
	 * Enables multiview.
	 */ enableMultiview() {
        this.enableExtension('GL_OVR_multiview2', 'require', 'fragment');
        this.enableExtension('GL_OVR_multiview2', 'require', 'vertex');
        this.builtins['vertex'].push('layout(num_views = 2) in');
    }
    /**
	 * Registers a transform in context of Transform Feedback.
	 *
	 * @param {string} varyingName - The varying name.
	 * @param {AttributeNode} attributeNode - The attribute node.
	 */ registerTransform(varyingName, attributeNode) {
        this.transforms.push({
            varyingName: varyingName,
            attributeNode: attributeNode
        });
    }
    /**
	 * Returns the transforms of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the transforms.
	 */ getTransforms() {
        const transforms = this.transforms;
        let snippet = '';
        for(let i = 0; i < transforms.length; i++){
            const transform = transforms[i];
            const attributeName = this.getPropertyName(transform.attributeNode);
            if (attributeName) snippet += `${transform.varyingName} = ${attributeName};\n\t`;
        }
        return snippet;
    }
    /**
	 * Returns a GLSL struct based on the given name and variables.
	 *
	 * @private
	 * @param {string} name - The struct name.
	 * @param {string} vars - The struct variables.
	 * @return {string} The GLSL snippet representing a struct.
	 */ _getGLSLUniformStruct(name, vars) {
        return `
layout( std140 ) uniform ${name} {
${vars}
};`;
    }
    /**
	 * Returns a GLSL vertex shader based on the given shader data.
	 *
	 * @private
	 * @param {Object} shaderData - The shader data.
	 * @return {string} The vertex shader.
	 */ _getGLSLVertexCode(shaderData) {
        return `#version 300 es

${this.getSignature()}

// extensions
${shaderData.extensions}

// precision
${$d89c9137a3d237c2$var$defaultPrecisions}

// uniforms
${shaderData.uniforms}

// varyings
${shaderData.varyings}

// attributes
${shaderData.attributes}

// codes
${shaderData.codes}

void main() {

	// vars
	${shaderData.vars}

	// transforms
	${shaderData.transforms}

	// flow
	${shaderData.flow}

	gl_PointSize = 1.0;

}
`;
    }
    /**
	 * Returns a GLSL fragment shader based on the given shader data.
	 *
	 * @private
	 * @param {Object} shaderData - The shader data.
	 * @return {string} The vertex shader.
	 */ _getGLSLFragmentCode(shaderData) {
        return `#version 300 es

${this.getSignature()}

// extensions
${shaderData.extensions}

// precision
${$d89c9137a3d237c2$var$defaultPrecisions}

// structs
${shaderData.structs}

// uniforms
${shaderData.uniforms}

// varyings
${shaderData.varyings}

// codes
${shaderData.codes}

void main() {

	// vars
	${shaderData.vars}

	// flow
	${shaderData.flow}

}
`;
    }
    /**
	 * Controls the code build of the shader stages.
	 */ buildCode() {
        const shadersData = this.material !== null ? {
            fragment: {},
            vertex: {}
        } : {
            compute: {}
        };
        this.sortBindingGroups();
        for(const shaderStage in shadersData){
            let flow = '// code\n\n';
            flow += this.flowCode[shaderStage];
            const flowNodes = this.flowNodes[shaderStage];
            const mainNode = flowNodes[flowNodes.length - 1];
            for (const node of flowNodes){
                const flowSlotData = this.getFlowData(node /*, shaderStage*/ );
                const slotName = node.name;
                if (slotName) {
                    if (flow.length > 0) flow += '\n';
                    flow += `\t// flow -> ${slotName}\n\t`;
                }
                flow += `${flowSlotData.code}\n\t`;
                if (node === mainNode && shaderStage !== 'compute') {
                    flow += '// result\n\t';
                    if (shaderStage === 'vertex') {
                        flow += 'gl_Position = ';
                        flow += `${flowSlotData.result};`;
                    } else if (shaderStage === 'fragment') {
                        if (!node.outputNode.isOutputStructNode) {
                            flow += 'fragColor = ';
                            flow += `${flowSlotData.result};`;
                        }
                    }
                }
            }
            const stageData = shadersData[shaderStage];
            stageData.extensions = this.getExtensions(shaderStage);
            stageData.uniforms = this.getUniforms(shaderStage);
            stageData.attributes = this.getAttributes(shaderStage);
            stageData.varyings = this.getVaryings(shaderStage);
            stageData.vars = this.getVars(shaderStage);
            stageData.structs = this.getStructs(shaderStage);
            stageData.codes = this.getCodes(shaderStage);
            stageData.transforms = this.getTransforms(shaderStage);
            stageData.flow = flow;
        }
        if (this.material !== null) {
            this.vertexShader = this._getGLSLVertexCode(shadersData.vertex);
            this.fragmentShader = this._getGLSLFragmentCode(shadersData.fragment);
        } else this.computeShader = this._getGLSLVertexCode(shadersData.compute);
    }
    /**
	 * This method is one of the more important ones since it's responsible
	 * for generating a matching binding instance for the given uniform node.
	 *
	 * These bindings are later used in the renderer to create bind groups
	 * and layouts.
	 *
	 * @param {UniformNode} node - The uniform node.
	 * @param {string} type - The node data type.
	 * @param {string} shaderStage - The shader stage.
	 * @param {?string} [name=null] - An optional uniform name.
	 * @return {NodeUniform} The node uniform object.
	 */ getUniformFromNode(node, type, shaderStage, name = null) {
        const uniformNode = super.getUniformFromNode(node, type, shaderStage, name);
        const nodeData = this.getDataFromNode(node, shaderStage, this.globalCache);
        let uniformGPU = nodeData.uniformGPU;
        if (uniformGPU === undefined) {
            const group = node.groupNode;
            const groupName = group.name;
            const bindings = this.getBindGroupArray(groupName, shaderStage);
            if (type === 'texture') {
                uniformGPU = new $d89c9137a3d237c2$var$NodeSampledTexture(uniformNode.name, uniformNode.node, group);
                bindings.push(uniformGPU);
            } else if (type === 'cubeTexture' || type === 'cubeDepthTexture') {
                uniformGPU = new $d89c9137a3d237c2$var$NodeSampledCubeTexture(uniformNode.name, uniformNode.node, group);
                bindings.push(uniformGPU);
            } else if (type === 'texture3D') {
                uniformGPU = new $d89c9137a3d237c2$var$NodeSampledTexture3D(uniformNode.name, uniformNode.node, group);
                bindings.push(uniformGPU);
            } else if (type === 'buffer') {
                uniformNode.name = `buffer${node.id}`;
                const sharedData = this.getSharedDataFromNode(node);
                let buffer = sharedData.buffer;
                if (buffer === undefined) {
                    node.name = `NodeBuffer_${node.id}`;
                    buffer = new $d89c9137a3d237c2$var$NodeUniformBuffer(node, group);
                    buffer.name = node.name;
                    sharedData.buffer = buffer;
                }
                bindings.push(buffer);
                uniformGPU = buffer;
            } else {
                const uniformsStage = this.uniformGroups[shaderStage] || (this.uniformGroups[shaderStage] = {});
                let uniformsGroup = uniformsStage[groupName];
                if (uniformsGroup === undefined) {
                    uniformsGroup = new $d89c9137a3d237c2$var$NodeUniformsGroup(shaderStage + '_' + groupName, group);
                    //uniformsGroup.setVisibility( gpuShaderStageLib[ shaderStage ] );
                    uniformsStage[groupName] = uniformsGroup;
                    bindings.push(uniformsGroup);
                }
                uniformGPU = this.getNodeUniform(uniformNode, type);
                uniformsGroup.addUniform(uniformGPU);
            }
            nodeData.uniformGPU = uniformGPU;
        }
        return uniformNode;
    }
}
let $d89c9137a3d237c2$var$_vector2 = null;
let $d89c9137a3d237c2$var$_color4 = null;
/**
 * Most of the rendering related logic is implemented in the
 * {@link Renderer} module and related management components.
 * Sometimes it is required though to execute commands which are
 * specific to the current 3D backend (which is WebGPU or WebGL 2).
 * This abstract base class defines an interface that encapsulates
 * all backend-related logic. Derived classes for each backend must
 * implement the interface.
 *
 * @abstract
 * @private
 */ class $d89c9137a3d237c2$var$Backend {
    /**
	 * Constructs a new backend.
	 *
	 * @param {Object} parameters - An object holding parameters for the backend.
	 */ constructor(parameters = {}){
        /**
		 * The parameters of the backend.
		 *
		 * @type {Object}
		 */ this.parameters = Object.assign({}, parameters);
        /**
		 * This weak map holds backend-specific data of objects
		 * like textures, attributes or render targets.
		 *
		 * @type {WeakMap<Object, Object>}
		 */ this.data = new WeakMap();
        /**
		 * A reference to the renderer.
		 *
		 * @type {?Renderer}
		 * @default null
		 */ this.renderer = null;
        /**
		 * A reference to the canvas element the renderer is drawing to.
		 *
		 * @type {?(HTMLCanvasElement|OffscreenCanvas)}
		 * @default null
		 */ this.domElement = null;
        /**
		 * A reference to the timestamp query pool.
   		 *
   		 * @type {{render: ?TimestampQueryPool, compute: ?TimestampQueryPool}}
		 */ this.timestampQueryPool = {
            [(0, $329ek.TimestampQuery).RENDER]: null,
            [(0, $329ek.TimestampQuery).COMPUTE]: null
        };
        /**
		 * Whether to track timestamps with a Timestamp Query API or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.trackTimestamp = parameters.trackTimestamp === true;
    }
    /**
	 * Initializes the backend so it is ready for usage. Concrete backends
	 * are supposed to implement their rendering context creation and related
	 * operations in this method.
	 *
	 * @async
	 * @param {Renderer} renderer - The renderer.
	 * @return {Promise} A Promise that resolves when the backend has been initialized.
	 */ async init(renderer) {
        this.renderer = renderer;
    }
    /**
	 * The coordinate system of the backend.
	 *
	 * @abstract
	 * @type {number}
	 * @readonly
	 */ get coordinateSystem() {}
    // render context
    /**
	 * This method is executed at the beginning of a render call and
	 * can be used by the backend to prepare the state for upcoming
	 * draw calls.
	 *
	 * @abstract
	 * @param {RenderContext} renderContext - The render context.
	 */ beginRender() {}
    /**
	 * This method is executed at the end of a render call and
	 * can be used by the backend to finalize work after draw
	 * calls.
	 *
	 * @abstract
	 * @param {RenderContext} renderContext - The render context.
	 */ finishRender() {}
    /**
	 * This method is executed at the beginning of a compute call and
	 * can be used by the backend to prepare the state for upcoming
	 * compute tasks.
	 *
	 * @abstract
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ beginCompute() {}
    /**
	 * This method is executed at the end of a compute call and
	 * can be used by the backend to finalize work after compute
	 * tasks.
	 *
	 * @abstract
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ finishCompute() {}
    // render object
    /**
	 * Executes a draw command for the given render object.
	 *
	 * @abstract
	 * @param {RenderObject} renderObject - The render object to draw.
	 * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
	 */ draw() {}
    // compute node
    /**
	 * Executes a compute command for the given compute node.
	 *
	 * @abstract
	 * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
	 * @param {Node} computeNode - The compute node.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @param {ComputePipeline} computePipeline - The compute pipeline.
	 */ compute() {}
    // program
    /**
	 * Creates a shader program from the given programmable stage.
	 *
	 * @abstract
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ createProgram() {}
    /**
	 * Destroys the shader program of the given programmable stage.
	 *
	 * @abstract
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ destroyProgram() {}
    // bindings
    /**
	 * Creates bindings from the given bind group definition.
	 *
	 * @abstract
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ createBindings() {}
    /**
	 * Updates the given bind group definition.
	 *
	 * @abstract
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ updateBindings() {}
    /**
	 * Updates a buffer binding.
	 *
	 * @abstract
	 * @param {Buffer} binding - The buffer binding to update.
	 */ updateBinding() {}
    // pipeline
    /**
	 * Creates a render pipeline for the given render object.
	 *
	 * @abstract
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
	 */ createRenderPipeline() {}
    /**
	 * Creates a compute pipeline for the given compute node.
	 *
	 * @abstract
	 * @param {ComputePipeline} computePipeline - The compute pipeline.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 */ createComputePipeline() {}
    // cache key
    /**
	 * Returns `true` if the render pipeline requires an update.
	 *
	 * @abstract
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the render pipeline requires an update or not.
	 */ needsRenderUpdate() {}
    /**
	 * Returns a cache key that is used to identify render pipelines.
	 *
	 * @abstract
	 * @param {RenderObject} renderObject - The render object.
	 * @return {string} The cache key.
	 */ getRenderCacheKey() {}
    // node builder
    /**
	 * Returns a node builder for the given render object.
	 *
	 * @abstract
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Renderer} renderer - The renderer.
	 * @return {NodeBuilder} The node builder.
	 */ createNodeBuilder() {}
    // textures
    /**
	 * Updates a GPU sampler for the given texture.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture to update the sampler for.
	 * @return {string} The current sampler key.
	 */ updateSampler() {}
    /**
	 * Creates a default texture for the given texture that can be used
	 * as a placeholder until the actual texture is ready for usage.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture to create a default texture for.
	 */ createDefaultTexture() {}
    /**
	 * Defines a texture on the GPU for the given texture object.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ createTexture() {}
    /**
	 * Uploads the updated texture data to the GPU.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ updateTexture() {}
    /**
	 * Generates mipmaps for the given texture.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 */ generateMipmaps() {}
    /**
	 * Destroys the GPU data for the given texture object.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
	 */ destroyTexture() {}
    /**
	 * Returns texture data as a typed array.
	 *
	 * @abstract
	 * @async
	 * @param {Texture} texture - The texture to copy.
	 * @param {number} x - The x coordinate of the copy origin.
	 * @param {number} y - The y coordinate of the copy origin.
	 * @param {number} width - The width of the copy.
	 * @param {number} height - The height of the copy.
	 * @param {number} faceIndex - The face index.
	 * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
	 */ async copyTextureToBuffer() {}
    /**
	 * Copies data of the given source texture to the given destination texture.
	 *
	 * @abstract
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
	 * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
	 * @param {number} [srcLevel=0] - The source mip level to copy from.
	 * @param {number} [dstLevel=0] - The destination mip level to copy to.
	 */ copyTextureToTexture() {}
    /**
	* Copies the current bound framebuffer to the given texture.
	*
	* @abstract
	* @param {Texture} texture - The destination texture.
	* @param {RenderContext} renderContext - The render context.
	* @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
	*/ copyFramebufferToTexture() {}
    // attributes
    /**
	 * Creates the GPU buffer of a shader attribute.
	 *
	 * @abstract
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createAttribute() {}
    /**
	 * Creates the GPU buffer of an indexed shader attribute.
	 *
	 * @abstract
	 * @param {BufferAttribute} attribute - The indexed buffer attribute.
	 */ createIndexAttribute() {}
    /**
	 * Creates the GPU buffer of a storage attribute.
	 *
	 * @abstract
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createStorageAttribute() {}
    /**
	 * Updates the GPU buffer of a shader attribute.
	 *
	 * @abstract
	 * @param {BufferAttribute} attribute - The buffer attribute to update.
	 */ updateAttribute() {}
    /**
	 * Destroys the GPU buffer of a shader attribute.
	 *
	 * @abstract
	 * @param {BufferAttribute} attribute - The buffer attribute to destroy.
	 */ destroyAttribute() {}
    // canvas
    /**
	 * Returns the backend's rendering context.
	 *
	 * @abstract
	 * @return {Object} The rendering context.
	 */ getContext() {}
    /**
	 * Backends can use this method if they have to run
	 * logic when the renderer gets resized.
	 *
	 * @abstract
	 */ updateSize() {}
    /**
	 * Updates the viewport with the values from the given render context.
	 *
	 * @abstract
	 * @param {RenderContext} renderContext - The render context.
	 */ updateViewport() {}
    // utils
    /**
	 * Updates a unique identifier for the given render context that can be used
	 * to allocate resources like occlusion queries or timestamp queries.
	 *
	 * @param {RenderContext|ComputeNode} abstractRenderContext - The render context.
	 */ updateTimeStampUID(abstractRenderContext) {
        const contextData = this.get(abstractRenderContext);
        const frame = this.renderer.info.frame;
        let prefix;
        if (abstractRenderContext.isComputeNode === true) prefix = 'c:' + this.renderer.info.compute.frameCalls;
        else prefix = 'r:' + this.renderer.info.render.frameCalls;
        contextData.timestampUID = prefix + ':' + abstractRenderContext.id + ':f' + frame;
    }
    /**
	 * Returns a unique identifier for the given render context that can be used
	 * to allocate resources like occlusion queries or timestamp queries.
	 *
	 * @param {RenderContext|ComputeNode} abstractRenderContext - The render context.
	 * @return {string} The unique identifier.
	 */ getTimestampUID(abstractRenderContext) {
        return this.get(abstractRenderContext).timestampUID;
    }
    /**
	 * Returns all timestamp frames for the given type.
	 *
	 * @param {string} type - The type of the time stamp.
	 * @return {Array<number>} The timestamp frames.
	 */ getTimestampFrames(type) {
        const queryPool = this.timestampQueryPool[type];
        return queryPool ? queryPool.getTimestampFrames() : [];
    }
    /**
	 * Returns the query pool for the given uid.
	 *
	 * @param {string} uid - The unique identifier.
	 * @return {TimestampQueryPool} The query pool.
	 */ _getQueryPool(uid) {
        const type = uid.startsWith('c:') ? (0, $329ek.TimestampQuery).COMPUTE : (0, $329ek.TimestampQuery).RENDER;
        const queryPool = this.timestampQueryPool[type];
        return queryPool;
    }
    /**
	 * Returns the timestamp for the given uid.
	 *
	 * @param {string} uid - The unique identifier.
	 * @return {number} The timestamp.
	 */ getTimestamp(uid) {
        const queryPool = this._getQueryPool(uid);
        return queryPool.getTimestamp(uid);
    }
    /**
	 * Returns `true` if a timestamp for the given uid is available.
	 *
	 * @param {string} uid - The unique identifier.
	 * @return {boolean} Whether the timestamp is available or not.
	 */ hasTimestamp(uid) {
        const queryPool = this._getQueryPool(uid);
        return queryPool.hasTimestamp(uid);
    }
    /**
	 * Returns `true` if the given 3D object is fully occluded by other
	 * 3D objects in the scene. Backends must implement this method by using
	 * a Occlusion Query API.
	 *
	 * @abstract
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object is fully occluded or not.
	 */ isOccluded() {}
    /**
	 * Resolves the time stamp for the given render context and type.
	 *
	 * @async
	 * @abstract
	 * @param {string} [type='render'] - The type of the time stamp.
	 * @return {Promise<number>} A Promise that resolves with the time stamp.
	 */ async resolveTimestampsAsync(type = 'render') {
        if (!this.trackTimestamp) {
            (0, $329ek.warnOnce)('WebGPURenderer: Timestamp tracking is disabled.');
            return;
        }
        const queryPool = this.timestampQueryPool[type];
        if (!queryPool) return;
        const duration = await queryPool.resolveQueriesAsync();
        this.renderer.info[type].timestamp = duration;
        return duration;
    }
    /**
	 * This method performs a readback operation by moving buffer data from
	 * a storage buffer attribute from the GPU to the CPU.
	 *
	 * @async
	 * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
	 * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync() {}
    /**
	 * Checks if the given feature is supported by the backend.
	 *
	 * @async
	 * @abstract
	 * @param {string} name - The feature's name.
	 * @return {Promise<boolean>} A Promise that resolves with a bool that indicates whether the feature is supported or not.
	 */ async hasFeatureAsync() {}
    /**
	 * Checks if the given feature is supported  by the backend.
	 *
	 * @abstract
	 * @param {string} name - The feature's name.
	 * @return {boolean} Whether the feature is supported or not.
	 */ hasFeature() {}
    /**
	 * Returns the maximum anisotropy texture filtering value.
	 *
	 * @abstract
	 * @return {number} The maximum anisotropy texture filtering value.
	 */ getMaxAnisotropy() {}
    /**
	 * Returns the drawing buffer size.
	 *
	 * @return {Vector2} The drawing buffer size.
	 */ getDrawingBufferSize() {
        $d89c9137a3d237c2$var$_vector2 = $d89c9137a3d237c2$var$_vector2 || new (0, $329ek.Vector2)();
        return this.renderer.getDrawingBufferSize($d89c9137a3d237c2$var$_vector2);
    }
    /**
	 * Defines the scissor test.
	 *
	 * @abstract
	 * @param {boolean} boolean - Whether the scissor test should be enabled or not.
	 */ setScissorTest() {}
    /**
	 * Returns the clear color and alpha into a single
	 * color object.
	 *
	 * @return {Color4} The clear color.
	 */ getClearColor() {
        const renderer = this.renderer;
        $d89c9137a3d237c2$var$_color4 = $d89c9137a3d237c2$var$_color4 || new $d89c9137a3d237c2$var$Color4();
        renderer.getClearColor($d89c9137a3d237c2$var$_color4);
        $d89c9137a3d237c2$var$_color4.getRGB($d89c9137a3d237c2$var$_color4);
        return $d89c9137a3d237c2$var$_color4;
    }
    /**
	 * Returns the DOM element. If no DOM element exists, the backend
	 * creates a new one.
	 *
	 * @return {HTMLCanvasElement} The DOM element.
	 */ getDomElement() {
        let domElement = this.domElement;
        if (domElement === null) {
            domElement = this.parameters.canvas !== undefined ? this.parameters.canvas : (0, $329ek.createCanvasElement)();
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in domElement) domElement.setAttribute('data-engine', `three.js r${(0, $329ek.REVISION)} webgpu`);
            this.domElement = domElement;
        }
        return domElement;
    }
    /**
	 * Sets a dictionary for the given object into the
	 * internal data structure.
	 *
	 * @param {Object} object - The object.
	 * @param {Object} value - The dictionary to set.
	 */ set(object, value) {
        this.data.set(object, value);
    }
    /**
	 * Returns the dictionary for the given object.
	 *
	 * @param {Object} object - The object.
	 * @return {Object} The object's dictionary.
	 */ get(object) {
        let map = this.data.get(object);
        if (map === undefined) {
            map = {};
            this.data.set(object, map);
        }
        return map;
    }
    /**
	 * Checks if the given object has a dictionary
	 * with data defined.
	 *
	 * @param {Object} object - The object.
	 * @return {boolean} Whether a dictionary for the given object as been defined or not.
	 */ has(object) {
        return this.data.has(object);
    }
    /**
	 * Deletes an object from the internal data structure.
	 *
	 * @param {Object} object - The object to delete.
	 */ delete(object) {
        this.data.delete(object);
    }
    /**
	 * Delete GPU data associated with a bind group.
	 *
	 * @abstract
	 * @param {BindGroup} bindGroup - The bind group.
	 */ deleteBindGroupData() {}
    /**
	 * Frees internal resources.
	 *
	 * @abstract
	 */ dispose() {}
}
let $d89c9137a3d237c2$var$_id$1 = 0;
/**
 * This module is internally used in context of compute shaders.
 * This type of shader is not natively supported in WebGL 2 and
 * thus implemented via Transform Feedback. `DualAttributeData`
 * manages the related data.
 *
 * @private
 */ class $d89c9137a3d237c2$var$DualAttributeData {
    constructor(attributeData, dualBuffer){
        this.buffers = [
            attributeData.bufferGPU,
            dualBuffer
        ];
        this.type = attributeData.type;
        this.bufferType = attributeData.bufferType;
        this.pbo = attributeData.pbo;
        this.byteLength = attributeData.byteLength;
        this.bytesPerElement = attributeData.BYTES_PER_ELEMENT;
        this.version = attributeData.version;
        this.isInteger = attributeData.isInteger;
        this.activeBufferIndex = 0;
        this.baseId = attributeData.id;
    }
    get id() {
        return `${this.baseId}|${this.activeBufferIndex}`;
    }
    get bufferGPU() {
        return this.buffers[this.activeBufferIndex];
    }
    get transformBuffer() {
        return this.buffers[this.activeBufferIndex ^ 1];
    }
    switchBuffers() {
        this.activeBufferIndex ^= 1;
    }
}
/**
 * A WebGL 2 backend utility module for managing shader attributes.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGLAttributeUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
    }
    /**
	 * Creates the GPU buffer for the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 * @param {GLenum } bufferType - A flag that indicates the buffer type and thus binding point target.
	 */ createAttribute(attribute, bufferType) {
        const backend = this.backend;
        const { gl: gl } = backend;
        const array = attribute.array;
        const usage = attribute.usage || gl.STATIC_DRAW;
        const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
        const bufferData = backend.get(bufferAttribute);
        let bufferGPU = bufferData.bufferGPU;
        if (bufferGPU === undefined) {
            bufferGPU = this._createBuffer(gl, bufferType, array, usage);
            bufferData.bufferGPU = bufferGPU;
            bufferData.bufferType = bufferType;
            bufferData.version = bufferAttribute.version;
        }
        //attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (typeof Float16Array !== 'undefined' && array instanceof Float16Array) type = gl.HALF_FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLBackend: Unsupported buffer data format: ' + array);
        let attributeData = {
            bufferGPU: bufferGPU,
            bufferType: bufferType,
            type: type,
            byteLength: array.byteLength,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            pbo: attribute.pbo,
            isInteger: type === gl.INT || type === gl.UNSIGNED_INT || attribute.gpuType === (0, $329ek.IntType),
            id: $d89c9137a3d237c2$var$_id$1++
        };
        if (attribute.isStorageBufferAttribute || attribute.isStorageInstancedBufferAttribute) {
            // create buffer for transform feedback use
            const bufferGPUDual = this._createBuffer(gl, bufferType, array, usage);
            attributeData = new $d89c9137a3d237c2$var$DualAttributeData(attributeData, bufferGPUDual);
        }
        backend.set(attribute, attributeData);
    }
    /**
	 * Updates the GPU buffer of the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ updateAttribute(attribute) {
        const backend = this.backend;
        const { gl: gl } = backend;
        const array = attribute.array;
        const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
        const bufferData = backend.get(bufferAttribute);
        const bufferType = bufferData.bufferType;
        const updateRanges = attribute.isInterleavedBufferAttribute ? attribute.data.updateRanges : attribute.updateRanges;
        gl.bindBuffer(bufferType, bufferData.bufferGPU);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            bufferAttribute.clearUpdateRanges();
        }
        gl.bindBuffer(bufferType, null);
        bufferData.version = bufferAttribute.version;
    }
    /**
	 * Destroys the GPU buffer of the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ destroyAttribute(attribute) {
        const backend = this.backend;
        const { gl: gl } = backend;
        if (attribute.isInterleavedBufferAttribute) backend.delete(attribute.data);
        const attributeData = backend.get(attribute);
        gl.deleteBuffer(attributeData.bufferGPU);
        backend.delete(attribute);
    }
    /**
	 * This method performs a readback operation by moving buffer data from
	 * a storage buffer attribute from the GPU to the CPU.
	 *
	 * @async
	 * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
	 * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync(attribute) {
        const backend = this.backend;
        const { gl: gl } = backend;
        const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
        const { bufferGPU: bufferGPU } = backend.get(bufferAttribute);
        const array = attribute.array;
        const byteLength = array.byteLength;
        gl.bindBuffer(gl.COPY_READ_BUFFER, bufferGPU);
        const writeBuffer = gl.createBuffer();
        gl.bindBuffer(gl.COPY_WRITE_BUFFER, writeBuffer);
        gl.bufferData(gl.COPY_WRITE_BUFFER, byteLength, gl.STREAM_READ);
        gl.copyBufferSubData(gl.COPY_READ_BUFFER, gl.COPY_WRITE_BUFFER, 0, 0, byteLength);
        await backend.utils._clientWaitAsync();
        const dstBuffer = new attribute.array.constructor(array.length);
        // Ensure the buffer is bound before reading
        gl.bindBuffer(gl.COPY_WRITE_BUFFER, writeBuffer);
        gl.getBufferSubData(gl.COPY_WRITE_BUFFER, 0, dstBuffer);
        gl.deleteBuffer(writeBuffer);
        gl.bindBuffer(gl.COPY_READ_BUFFER, null);
        gl.bindBuffer(gl.COPY_WRITE_BUFFER, null);
        return dstBuffer.buffer;
    }
    /**
	 * Creates a WebGL buffer with the given data.
	 *
	 * @private
	 * @param {WebGL2RenderingContext} gl - The rendering context.
	 * @param {GLenum } bufferType - A flag that indicates the buffer type and thus binding point target.
	 * @param {TypedArray} array - The array of the buffer attribute.
	 * @param {GLenum} usage - The usage.
	 * @return {WebGLBuffer} The WebGL buffer.
	 */ _createBuffer(gl, bufferType, array, usage) {
        const bufferGPU = gl.createBuffer();
        gl.bindBuffer(bufferType, bufferGPU);
        gl.bufferData(bufferType, array, usage);
        gl.bindBuffer(bufferType, null);
        return bufferGPU;
    }
}
let $d89c9137a3d237c2$var$equationToGL, $d89c9137a3d237c2$var$factorToGL;
/**
 * A WebGL 2 backend utility module for managing the WebGL state.
 *
 * The major goal of this module is to reduce the number of state changes
 * by caching the WEbGL state with a series of variables. In this way, the
 * renderer only executes state change commands when necessary which
 * improves the overall performance.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGLState {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
        /**
		 * A reference to the rendering context.
		 *
		 * @type {WebGL2RenderingContext}
		 */ this.gl = this.backend.gl;
        // Below properties are intended to cache
        // the WebGL state and are not explicitly
        // documented for convenience reasons.
        this.enabled = {};
        this.currentFlipSided = null;
        this.currentCullFace = null;
        this.currentProgram = null;
        this.currentBlendingEnabled = false;
        this.currentBlending = null;
        this.currentBlendSrc = null;
        this.currentBlendDst = null;
        this.currentBlendSrcAlpha = null;
        this.currentBlendDstAlpha = null;
        this.currentPremultipledAlpha = null;
        this.currentPolygonOffsetFactor = null;
        this.currentPolygonOffsetUnits = null;
        this.currentColorMask = null;
        this.currentDepthFunc = null;
        this.currentDepthMask = null;
        this.currentStencilFunc = null;
        this.currentStencilRef = null;
        this.currentStencilFuncMask = null;
        this.currentStencilFail = null;
        this.currentStencilZFail = null;
        this.currentStencilZPass = null;
        this.currentStencilMask = null;
        this.currentLineWidth = null;
        this.currentClippingPlanes = 0;
        this.currentVAO = null;
        this.currentIndex = null;
        this.currentBoundFramebuffers = {};
        this.currentDrawbuffers = new WeakMap();
        this.maxTextures = this.gl.getParameter(this.gl.MAX_TEXTURE_IMAGE_UNITS);
        this.currentTextureSlot = null;
        this.currentBoundTextures = {};
        this.currentBoundBufferBases = {};
        this._init();
    }
    /**
	 * Inits the state of the utility.
	 *
	 * @private
	 */ _init() {
        const gl = this.gl;
        // Store only WebGL constants here.
        $d89c9137a3d237c2$var$equationToGL = {
            [(0, $329ek.AddEquation)]: gl.FUNC_ADD,
            [(0, $329ek.SubtractEquation)]: gl.FUNC_SUBTRACT,
            [(0, $329ek.ReverseSubtractEquation)]: gl.FUNC_REVERSE_SUBTRACT
        };
        $d89c9137a3d237c2$var$factorToGL = {
            [(0, $329ek.ZeroFactor)]: gl.ZERO,
            [(0, $329ek.OneFactor)]: gl.ONE,
            [(0, $329ek.SrcColorFactor)]: gl.SRC_COLOR,
            [(0, $329ek.SrcAlphaFactor)]: gl.SRC_ALPHA,
            [(0, $329ek.SrcAlphaSaturateFactor)]: gl.SRC_ALPHA_SATURATE,
            [(0, $329ek.DstColorFactor)]: gl.DST_COLOR,
            [(0, $329ek.DstAlphaFactor)]: gl.DST_ALPHA,
            [(0, $329ek.OneMinusSrcColorFactor)]: gl.ONE_MINUS_SRC_COLOR,
            [(0, $329ek.OneMinusSrcAlphaFactor)]: gl.ONE_MINUS_SRC_ALPHA,
            [(0, $329ek.OneMinusDstColorFactor)]: gl.ONE_MINUS_DST_COLOR,
            [(0, $329ek.OneMinusDstAlphaFactor)]: gl.ONE_MINUS_DST_ALPHA
        };
        const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
        const viewportParam = gl.getParameter(gl.VIEWPORT);
        this.currentScissor = new (0, $329ek.Vector4)().fromArray(scissorParam);
        this.currentViewport = new (0, $329ek.Vector4)().fromArray(viewportParam);
        this._tempVec4 = new (0, $329ek.Vector4)();
    }
    /**
	 * Enables the given WebGL capability.
	 *
	 * This method caches the capability state so
	 * `gl.enable()` is only called when necessary.
	 *
	 * @param {GLenum} id - The capability to enable.
	 */ enable(id) {
        const { enabled: enabled } = this;
        if (enabled[id] !== true) {
            this.gl.enable(id);
            enabled[id] = true;
        }
    }
    /**
	 * Disables the given WebGL capability.
	 *
	 * This method caches the capability state so
	 * `gl.disable()` is only called when necessary.
	 *
	 * @param {GLenum} id - The capability to enable.
	 */ disable(id) {
        const { enabled: enabled } = this;
        if (enabled[id] !== false) {
            this.gl.disable(id);
            enabled[id] = false;
        }
    }
    /**
	 * Specifies whether polygons are front- or back-facing
	 * by setting the winding orientation.
	 *
	 * This method caches the state so `gl.frontFace()` is only
	 * called when necessary.
	 *
	 * @param {boolean} flipSided - Whether triangles flipped their sides or not.
	 */ setFlipSided(flipSided) {
        if (this.currentFlipSided !== flipSided) {
            const { gl: gl } = this;
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            this.currentFlipSided = flipSided;
        }
    }
    /**
	 * Specifies whether or not front- and/or back-facing
	 * polygons can be culled.
	 *
	 * This method caches the state so `gl.cullFace()` is only
	 * called when necessary.
	 *
	 * @param {number} cullFace - Defines which polygons are candidates for culling.
	 */ setCullFace(cullFace) {
        const { gl: gl } = this;
        if (cullFace !== (0, $329ek.CullFaceNone)) {
            this.enable(gl.CULL_FACE);
            if (cullFace !== this.currentCullFace) {
                if (cullFace === (0, $329ek.CullFaceBack)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $329ek.CullFaceFront)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else this.disable(gl.CULL_FACE);
        this.currentCullFace = cullFace;
    }
    /**
	 * Specifies the width of line primitives.
	 *
	 * This method caches the state so `gl.lineWidth()` is only
	 * called when necessary.
	 *
	 * @param {number} width - The line width.
	 */ setLineWidth(width) {
        const { currentLineWidth: currentLineWidth, gl: gl } = this;
        if (width !== currentLineWidth) {
            gl.lineWidth(width);
            this.currentLineWidth = width;
        }
    }
    setMRTBlending(textures) {
        const gl = this.gl;
        const drawBuffersIndexedExt = this.backend.drawBuffersIndexedExt;
        if (!drawBuffersIndexedExt) return;
        for(let i = 1; i < textures.length; i++)// use opaque blending for additional render targets
        drawBuffersIndexedExt.blendFuncSeparateiOES(i, gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
    }
    /**
	 * Defines the blending.
	 *
	 * This method caches the state so `gl.blendEquation()`, `gl.blendEquationSeparate()`,
	 * `gl.blendFunc()` and  `gl.blendFuncSeparate()` are only called when necessary.
	 *
	 * @param {number} blending - The blending type.
	 * @param {number} blendEquation - The blending equation.
	 * @param {number} blendSrc - Only relevant for custom blending. The RGB source blending factor.
	 * @param {number} blendDst - Only relevant for custom blending. The RGB destination blending factor.
	 * @param {number} blendEquationAlpha - Only relevant for custom blending. The blending equation for alpha.
	 * @param {number} blendSrcAlpha - Only relevant for custom blending. The alpha source blending factor.
	 * @param {number} blendDstAlpha - Only relevant for custom blending. The alpha destination blending factor.
	 * @param {boolean} premultipliedAlpha - Whether premultiplied alpha is enabled or not.
	 */ setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        const { gl: gl } = this;
        if (blending === (0, $329ek.NoBlending)) {
            if (this.currentBlendingEnabled === true) {
                this.disable(gl.BLEND);
                this.currentBlendingEnabled = false;
            }
            return;
        }
        if (this.currentBlendingEnabled === false) {
            this.enable(gl.BLEND);
            this.currentBlendingEnabled = true;
        }
        if (blending !== (0, $329ek.CustomBlending)) {
            if (blending !== this.currentBlending || premultipliedAlpha !== this.currentPremultipledAlpha) {
                if (this.currentBlendEquation !== (0, $329ek.AddEquation) || this.currentBlendEquationAlpha !== (0, $329ek.AddEquation)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    this.currentBlendEquation = (0, $329ek.AddEquation);
                    this.currentBlendEquationAlpha = (0, $329ek.AddEquation);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $329ek.NormalBlending:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $329ek.AdditiveBlending:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $329ek.SubtractiveBlending:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $329ek.MultiplyBlending:
                        gl.blendFuncSeparate(gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                        break;
                    default:
                        (0, $329ek.error)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $329ek.NormalBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $329ek.AdditiveBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
                        break;
                    case 0, $329ek.SubtractiveBlending:
                        (0, $329ek.error)('WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true');
                        break;
                    case 0, $329ek.MultiplyBlending:
                        (0, $329ek.error)('WebGLState: MultiplyBlending requires material.premultipliedAlpha = true');
                        break;
                    default:
                        (0, $329ek.error)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                this.currentBlendSrc = null;
                this.currentBlendDst = null;
                this.currentBlendSrcAlpha = null;
                this.currentBlendDstAlpha = null;
                this.currentBlending = blending;
                this.currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== this.currentBlendEquation || blendEquationAlpha !== this.currentBlendEquationAlpha) {
            gl.blendEquationSeparate($d89c9137a3d237c2$var$equationToGL[blendEquation], $d89c9137a3d237c2$var$equationToGL[blendEquationAlpha]);
            this.currentBlendEquation = blendEquation;
            this.currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== this.currentBlendSrc || blendDst !== this.currentBlendDst || blendSrcAlpha !== this.currentBlendSrcAlpha || blendDstAlpha !== this.currentBlendDstAlpha) {
            gl.blendFuncSeparate($d89c9137a3d237c2$var$factorToGL[blendSrc], $d89c9137a3d237c2$var$factorToGL[blendDst], $d89c9137a3d237c2$var$factorToGL[blendSrcAlpha], $d89c9137a3d237c2$var$factorToGL[blendDstAlpha]);
            this.currentBlendSrc = blendSrc;
            this.currentBlendDst = blendDst;
            this.currentBlendSrcAlpha = blendSrcAlpha;
            this.currentBlendDstAlpha = blendDstAlpha;
        }
        this.currentBlending = blending;
        this.currentPremultipledAlpha = false;
    }
    /**
	 * Specifies whether colors can be written when rendering
	 * into a framebuffer or not.
	 *
	 * This method caches the state so `gl.colorMask()` is only
	 * called when necessary.
	 *
	 * @param {boolean} colorMask - The color mask.
	 */ setColorMask(colorMask) {
        if (this.currentColorMask !== colorMask) {
            this.gl.colorMask(colorMask, colorMask, colorMask, colorMask);
            this.currentColorMask = colorMask;
        }
    }
    /**
	 * Specifies whether the depth test is enabled or not.
	 *
	 * @param {boolean} depthTest - Whether the depth test is enabled or not.
	 */ setDepthTest(depthTest) {
        const { gl: gl } = this;
        if (depthTest) this.enable(gl.DEPTH_TEST);
        else this.disable(gl.DEPTH_TEST);
    }
    /**
	 * Specifies whether depth values can be written when rendering
	 * into a framebuffer or not.
	 *
	 * This method caches the state so `gl.depthMask()` is only
	 * called when necessary.
	 *
	 * @param {boolean} depthMask - The depth mask.
	 */ setDepthMask(depthMask) {
        if (this.currentDepthMask !== depthMask) {
            this.gl.depthMask(depthMask);
            this.currentDepthMask = depthMask;
        }
    }
    /**
	 * Specifies the depth compare function.
	 *
	 * This method caches the state so `gl.depthFunc()` is only
	 * called when necessary.
	 *
	 * @param {number} depthFunc - The depth compare function.
	 */ setDepthFunc(depthFunc) {
        if (this.currentDepthFunc !== depthFunc) {
            const { gl: gl } = this;
            switch(depthFunc){
                case 0, $329ek.NeverDepth:
                    gl.depthFunc(gl.NEVER);
                    break;
                case 0, $329ek.AlwaysDepth:
                    gl.depthFunc(gl.ALWAYS);
                    break;
                case 0, $329ek.LessDepth:
                    gl.depthFunc(gl.LESS);
                    break;
                case 0, $329ek.LessEqualDepth:
                    gl.depthFunc(gl.LEQUAL);
                    break;
                case 0, $329ek.EqualDepth:
                    gl.depthFunc(gl.EQUAL);
                    break;
                case 0, $329ek.GreaterEqualDepth:
                    gl.depthFunc(gl.GEQUAL);
                    break;
                case 0, $329ek.GreaterDepth:
                    gl.depthFunc(gl.GREATER);
                    break;
                case 0, $329ek.NotEqualDepth:
                    gl.depthFunc(gl.NOTEQUAL);
                    break;
                default:
                    gl.depthFunc(gl.LEQUAL);
            }
            this.currentDepthFunc = depthFunc;
        }
    }
    /**
	 * Specifies the scissor box.
	 *
	 * @param {number} x - The x-coordinate of the lower left corner of the viewport.
	 * @param {number} y - The y-coordinate of the lower left corner of the viewport.
	 * @param {number} width - The width of the viewport.
	 * @param {number} height - The height of the viewport.
	 *
	 */ scissor(x, y, width, height) {
        const scissor = this._tempVec4.set(x, y, width, height);
        if (this.currentScissor.equals(scissor) === false) {
            const { gl: gl } = this;
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            this.currentScissor.copy(scissor);
        }
    }
    /**
	 * Specifies the viewport.
	 *
	 * @param {number} x - The x-coordinate of the lower left corner of the viewport.
	 * @param {number} y - The y-coordinate of the lower left corner of the viewport.
	 * @param {number} width - The width of the viewport.
	 * @param {number} height - The height of the viewport.
	 *
	 */ viewport(x, y, width, height) {
        const viewport = this._tempVec4.set(x, y, width, height);
        if (this.currentViewport.equals(viewport) === false) {
            const { gl: gl } = this;
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            this.currentViewport.copy(viewport);
        }
    }
    /**
	 * Defines the scissor test.
	 *
	 * @param {boolean} boolean - Whether the scissor test should be enabled or not.
	 */ setScissorTest(boolean) {
        const gl = this.gl;
        if (boolean) this.enable(gl.SCISSOR_TEST);
        else this.disable(gl.SCISSOR_TEST);
    }
    /**
	 * Specifies whether the stencil test is enabled or not.
	 *
	 * @param {boolean} stencilTest - Whether the stencil test is enabled or not.
	 */ setStencilTest(stencilTest) {
        const { gl: gl } = this;
        if (stencilTest) this.enable(gl.STENCIL_TEST);
        else this.disable(gl.STENCIL_TEST);
    }
    /**
	 * Specifies whether stencil values can be written when rendering
	 * into a framebuffer or not.
	 *
	 * This method caches the state so `gl.stencilMask()` is only
	 * called when necessary.
	 *
	 * @param {boolean} stencilMask - The stencil mask.
	 */ setStencilMask(stencilMask) {
        if (this.currentStencilMask !== stencilMask) {
            this.gl.stencilMask(stencilMask);
            this.currentStencilMask = stencilMask;
        }
    }
    /**
	 * Specifies whether the stencil test functions.
	 *
	 * This method caches the state so `gl.stencilFunc()` is only
	 * called when necessary.
	 *
	 * @param {number} stencilFunc - The stencil compare function.
	 * @param {number} stencilRef - The reference value for the stencil test.
	 * @param {number} stencilMask - A bit-wise mask that is used to AND the reference value and the stored stencil value when the test is done.
	 */ setStencilFunc(stencilFunc, stencilRef, stencilMask) {
        if (this.currentStencilFunc !== stencilFunc || this.currentStencilRef !== stencilRef || this.currentStencilFuncMask !== stencilMask) {
            this.gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
            this.currentStencilFunc = stencilFunc;
            this.currentStencilRef = stencilRef;
            this.currentStencilFuncMask = stencilMask;
        }
    }
    /**
	 * Specifies whether the stencil test operation.
	 *
	 * This method caches the state so `gl.stencilOp()` is only
	 * called when necessary.
	 *
	 * @param {number} stencilFail - The function to use when the stencil test fails.
	 * @param {number} stencilZFail - The function to use when the stencil test passes, but the depth test fail.
	 * @param {number} stencilZPass - The function to use when both the stencil test and the depth test pass,
	 * or when the stencil test passes and there is no depth buffer or depth testing is disabled.
	 */ setStencilOp(stencilFail, stencilZFail, stencilZPass) {
        if (this.currentStencilFail !== stencilFail || this.currentStencilZFail !== stencilZFail || this.currentStencilZPass !== stencilZPass) {
            this.gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
            this.currentStencilFail = stencilFail;
            this.currentStencilZFail = stencilZFail;
            this.currentStencilZPass = stencilZPass;
        }
    }
    /**
	 * Configures the WebGL state for the given material.
	 *
	 * @param {Material} material - The material to configure the state for.
	 * @param {number} frontFaceCW - Whether the front faces are counter-clockwise or not.
	 * @param {number} hardwareClippingPlanes - The number of hardware clipping planes.
	 */ setMaterial(material, frontFaceCW, hardwareClippingPlanes) {
        const { gl: gl } = this;
        material.side === (0, $329ek.DoubleSide) ? this.disable(gl.CULL_FACE) : this.enable(gl.CULL_FACE);
        let flipSided = material.side === (0, $329ek.BackSide);
        if (frontFaceCW) flipSided = !flipSided;
        this.setFlipSided(flipSided);
        material.blending === (0, $329ek.NormalBlending) && material.transparent === false ? this.setBlending((0, $329ek.NoBlending)) : this.setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        this.setDepthFunc(material.depthFunc);
        this.setDepthTest(material.depthTest);
        this.setDepthMask(material.depthWrite);
        this.setColorMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        this.setStencilTest(stencilWrite);
        if (stencilWrite) {
            this.setStencilMask(material.stencilWriteMask);
            this.setStencilFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            this.setStencilOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        this.setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true && this.backend.renderer.currentSamples > 0 ? this.enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : this.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        if (hardwareClippingPlanes > 0) {
            if (this.currentClippingPlanes !== hardwareClippingPlanes) {
                const CLIP_DISTANCE0_WEBGL = 0x3000;
                for(let i = 0; i < 8; i++)if (i < hardwareClippingPlanes) this.enable(CLIP_DISTANCE0_WEBGL + i);
                else this.disable(CLIP_DISTANCE0_WEBGL + i);
            }
        }
    }
    /**
	 * Specifies the polygon offset.
	 *
	 * This method caches the state so `gl.polygonOffset()` is only
	 * called when necessary.
	 *
	 * @param {boolean} polygonOffset - Whether polygon offset is enabled or not.
	 * @param {number} factor - The scale factor for the variable depth offset for each polygon.
	 * @param {number} units - The multiplier by which an implementation-specific value is multiplied with to create a constant depth offset.
	 */ setPolygonOffset(polygonOffset, factor, units) {
        const { gl: gl } = this;
        if (polygonOffset) {
            this.enable(gl.POLYGON_OFFSET_FILL);
            if (this.currentPolygonOffsetFactor !== factor || this.currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                this.currentPolygonOffsetFactor = factor;
                this.currentPolygonOffsetUnits = units;
            }
        } else this.disable(gl.POLYGON_OFFSET_FILL);
    }
    /**
	 * Defines the usage of the given WebGL program.
	 *
	 * This method caches the state so `gl.useProgram()` is only
	 * called when necessary.
	 *
	 * @param {WebGLProgram} program - The WebGL program to use.
	 * @return {boolean} Whether a program change has been executed or not.
	 */ useProgram(program) {
        if (this.currentProgram !== program) {
            this.gl.useProgram(program);
            this.currentProgram = program;
            return true;
        }
        return false;
    }
    /**
	 * Sets the vertex state by binding the given VAO and element buffer.
	 *
	 * @param {WebGLVertexArrayObject} vao - The VAO.
	 * @param {?WebGLBuffer} indexBuffer - The index buffer.
	 * @return {boolean} Whether a vertex state has been changed or not.
	 */ setVertexState(vao, indexBuffer = null) {
        const gl = this.gl;
        if (this.currentVAO !== vao || this.currentIndex !== indexBuffer) {
            gl.bindVertexArray(vao);
            if (indexBuffer !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
            this.currentVAO = vao;
            this.currentIndex = indexBuffer;
            return true;
        }
        return false;
    }
    /**
	 * Resets the vertex array state by resetting the VAO and element buffer.
	 */ resetVertexState() {
        const gl = this.gl;
        gl.bindVertexArray(null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        this.currentVAO = null;
        this.currentIndex = null;
    }
    // framebuffer
    /**
	 * Binds the given framebuffer.
	 *
	 * This method caches the state so `gl.bindFramebuffer()` is only
	 * called when necessary.
	 *
	 * @param {number} target - The binding point (target).
	 * @param {WebGLFramebuffer} framebuffer - The WebGL framebuffer to bind.
	 * @return {boolean} Whether a bind has been executed or not.
	 */ bindFramebuffer(target, framebuffer) {
        const { gl: gl, currentBoundFramebuffers: currentBoundFramebuffers } = this;
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    /**
	 * Defines draw buffers to which fragment colors are written into.
	 * Configures the MRT setup of custom framebuffers.
	 *
	 * This method caches the state so `gl.drawBuffers()` is only
	 * called when necessary.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {WebGLFramebuffer} framebuffer - The WebGL framebuffer.
	 */ drawBuffers(renderContext, framebuffer) {
        const { gl: gl } = this;
        let drawBuffers = [];
        let needsUpdate = false;
        if (renderContext.textures !== null) {
            drawBuffers = this.currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                this.currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderContext.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    // texture
    /**
	 * Makes the given texture unit active.
	 *
	 * This method caches the state so `gl.activeTexture()` is only
	 * called when necessary.
	 *
	 * @param {number} webglSlot - The texture unit to make active.
	 */ activeTexture(webglSlot) {
        const { gl: gl, currentTextureSlot: currentTextureSlot, maxTextures: maxTextures } = this;
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            this.currentTextureSlot = webglSlot;
        }
    }
    /**
	 * Binds the given WebGL texture to a target.
	 *
	 * This method caches the state so `gl.bindTexture()` is only
	 * called when necessary.
	 *
	 * @param {number} webglType - The binding point (target).
	 * @param {WebGLTexture} webglTexture - The WebGL texture to bind.
	 * @param {number} webglSlot - The texture.
	 */ bindTexture(webglType, webglTexture, webglSlot) {
        const { gl: gl, currentTextureSlot: currentTextureSlot, currentBoundTextures: currentBoundTextures, maxTextures: maxTextures } = this;
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                this.currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    /**
	 * Binds a given WebGL buffer to a given binding point (target) at a given index.
	 *
	 * This method caches the state so `gl.bindBufferBase()` is only
	 * called when necessary.
	 *
	 * @param {number} target - The target for the bind operation.
	 * @param {number} index - The index of the target.
	 * @param {WebGLBuffer} buffer - The WebGL buffer.
	 * @return {boolean} Whether a bind has been executed or not.
	 */ bindBufferBase(target, index, buffer) {
        const { gl: gl } = this;
        const key = `${target}-${index}`;
        if (this.currentBoundBufferBases[key] !== buffer) {
            gl.bindBufferBase(target, index, buffer);
            this.currentBoundBufferBases[key] = buffer;
            return true;
        }
        return false;
    }
    /**
	 * Unbinds the current bound texture.
	 *
	 * This method caches the state so `gl.bindTexture()` is only
	 * called when necessary.
	 */ unbindTexture() {
        const { gl: gl, currentTextureSlot: currentTextureSlot, currentBoundTextures: currentBoundTextures } = this;
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
}
/**
 * A WebGL 2 backend utility module with common helpers.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGLUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
        /**
		 * A reference to the rendering context.
		 *
		 * @type {WebGL2RenderingContext}
		 */ this.gl = this.backend.gl;
        /**
		 * A reference to a backend module holding extension-related
		 * utility functions.
		 *
		 * @type {WebGLExtensions}
		 */ this.extensions = backend.extensions;
    }
    /**
	 * Converts the given three.js constant into a WebGL constant.
	 * The method currently supports the conversion of texture formats
	 * and types.
	 *
	 * @param {number} p - The three.js constant.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 * @return {?number} The corresponding WebGL constant.
	 */ convert(p, colorSpace = (0, $329ek.NoColorSpace)) {
        const { gl: gl, extensions: extensions } = this;
        let extension;
        const transfer = (0, $329ek.ColorManagement).getTransfer(colorSpace);
        if (p === (0, $329ek.UnsignedByteType)) return gl.UNSIGNED_BYTE;
        if (p === (0, $329ek.UnsignedShort4444Type)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $329ek.UnsignedShort5551Type)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $329ek.UnsignedInt5999Type)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $329ek.UnsignedInt101111Type)) return gl.UNSIGNED_INT_10F_11F_11F_REV;
        if (p === (0, $329ek.ByteType)) return gl.BYTE;
        if (p === (0, $329ek.ShortType)) return gl.SHORT;
        if (p === (0, $329ek.UnsignedShortType)) return gl.UNSIGNED_SHORT;
        if (p === (0, $329ek.IntType)) return gl.INT;
        if (p === (0, $329ek.UnsignedIntType)) return gl.UNSIGNED_INT;
        if (p === (0, $329ek.FloatType)) return gl.FLOAT;
        if (p === (0, $329ek.HalfFloatType)) return gl.HALF_FLOAT;
        if (p === (0, $329ek.AlphaFormat)) return gl.ALPHA;
        if (p === (0, $329ek.RGBFormat)) return gl.RGB;
        if (p === (0, $329ek.RGBAFormat)) return gl.RGBA;
        if (p === (0, $329ek.DepthFormat)) return gl.DEPTH_COMPONENT;
        if (p === (0, $329ek.DepthStencilFormat)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $329ek.RedFormat)) return gl.RED;
        if (p === (0, $329ek.RedIntegerFormat)) return gl.RED_INTEGER;
        if (p === (0, $329ek.RGFormat)) return gl.RG;
        if (p === (0, $329ek.RGIntegerFormat)) return gl.RG_INTEGER;
        if (p === (0, $329ek.RGBAIntegerFormat)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $329ek.RGB_S3TC_DXT1_Format) || p === (0, $329ek.RGBA_S3TC_DXT1_Format) || p === (0, $329ek.RGBA_S3TC_DXT3_Format) || p === (0, $329ek.RGBA_S3TC_DXT5_Format)) {
            if (transfer === (0, $329ek.SRGBTransfer)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $329ek.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $329ek.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $329ek.RGB_PVRTC_4BPPV1_Format) || p === (0, $329ek.RGB_PVRTC_2BPPV1_Format) || p === (0, $329ek.RGBA_PVRTC_4BPPV1_Format) || p === (0, $329ek.RGBA_PVRTC_2BPPV1_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $329ek.RGB_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $329ek.RGB_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $329ek.RGBA_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $329ek.RGBA_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $329ek.RGB_ETC1_Format) || p === (0, $329ek.RGB_ETC2_Format) || p === (0, $329ek.RGBA_ETC2_EAC_Format) || p === (0, $329ek.R11_EAC_Format) || p === (0, $329ek.SIGNED_R11_EAC_Format) || p === (0, $329ek.RG11_EAC_Format) || p === (0, $329ek.SIGNED_RG11_EAC_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $329ek.RGB_ETC1_Format) || p === (0, $329ek.RGB_ETC2_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $329ek.RGBA_ETC2_EAC_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
                if (p === (0, $329ek.R11_EAC_Format)) return extension.COMPRESSED_R11_EAC;
                if (p === (0, $329ek.SIGNED_R11_EAC_Format)) return extension.COMPRESSED_SIGNED_R11_EAC;
                if (p === (0, $329ek.RG11_EAC_Format)) return extension.COMPRESSED_RG11_EAC;
                if (p === (0, $329ek.SIGNED_RG11_EAC_Format)) return extension.COMPRESSED_SIGNED_RG11_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $329ek.RGBA_ASTC_4x4_Format) || p === (0, $329ek.RGBA_ASTC_5x4_Format) || p === (0, $329ek.RGBA_ASTC_5x5_Format) || p === (0, $329ek.RGBA_ASTC_6x5_Format) || p === (0, $329ek.RGBA_ASTC_6x6_Format) || p === (0, $329ek.RGBA_ASTC_8x5_Format) || p === (0, $329ek.RGBA_ASTC_8x6_Format) || p === (0, $329ek.RGBA_ASTC_8x8_Format) || p === (0, $329ek.RGBA_ASTC_10x5_Format) || p === (0, $329ek.RGBA_ASTC_10x6_Format) || p === (0, $329ek.RGBA_ASTC_10x8_Format) || p === (0, $329ek.RGBA_ASTC_10x10_Format) || p === (0, $329ek.RGBA_ASTC_12x10_Format) || p === (0, $329ek.RGBA_ASTC_12x12_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $329ek.RGBA_ASTC_4x4_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $329ek.RGBA_ASTC_5x4_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $329ek.RGBA_ASTC_5x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_6x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_6x6_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $329ek.RGBA_ASTC_8x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_8x6_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $329ek.RGBA_ASTC_8x8_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x6_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x8_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x10_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $329ek.RGBA_ASTC_12x10_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $329ek.RGBA_ASTC_12x12_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $329ek.RGBA_BPTC_Format)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $329ek.RGBA_BPTC_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $329ek.RED_RGTC1_Format) || p === (0, $329ek.SIGNED_RED_RGTC1_Format) || p === (0, $329ek.RED_GREEN_RGTC2_Format) || p === (0, $329ek.SIGNED_RED_GREEN_RGTC2_Format)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $329ek.RED_RGTC1_Format)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $329ek.SIGNED_RED_RGTC1_Format)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $329ek.RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $329ek.SIGNED_RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $329ek.UnsignedInt248Type)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    /**
	 * This method can be used to synchronize the CPU with the GPU by waiting until
	 * ongoing GPU commands have been completed.
	 *
	 * @private
	 * @return {Promise} A promise that resolves when all ongoing GPU commands have been completed.
	 */ _clientWaitAsync() {
        const { gl: gl } = this;
        const sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
        gl.flush();
        return new Promise((resolve, reject)=>{
            function test() {
                const res = gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0);
                if (res === gl.WAIT_FAILED) {
                    gl.deleteSync(sync);
                    reject();
                    return;
                }
                if (res === gl.TIMEOUT_EXPIRED) {
                    requestAnimationFrame(test);
                    return;
                }
                gl.deleteSync(sync);
                resolve();
            }
            test();
        });
    }
}
let $d89c9137a3d237c2$var$initialized = false, $d89c9137a3d237c2$var$wrappingToGL, $d89c9137a3d237c2$var$filterToGL, $d89c9137a3d237c2$var$compareToGL;
/**
 * A WebGL 2 backend utility module for managing textures.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGLTextureUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
        /**
		 * A reference to the rendering context.
		 *
		 * @type {WebGL2RenderingContext}
		 */ this.gl = backend.gl;
        /**
		 * A reference to a backend module holding extension-related
		 * utility functions.
		 *
		 * @type {WebGLExtensions}
		 */ this.extensions = backend.extensions;
        /**
		 * A dictionary for managing default textures. The key
		 * is the binding point (target), the value the WEbGL texture object.
		 *
		 * @type {Object<GLenum,WebGLTexture>}
		 */ this.defaultTextures = {};
        /**
		 * A scratch framebuffer used for attaching the source texture in
		 * {@link copyTextureToTexture}.
		 *
		 * @private
		 * @type {?WebGLFramebuffer}
		 */ this._srcFramebuffer = null;
        /**
		 * A scratch framebuffer used for attaching the destination texture in
		 * {@link copyTextureToTexture}.
		 *
		 * @private
		 * @type {?WebGLFramebuffer}
		 */ this._dstFramebuffer = null;
        if ($d89c9137a3d237c2$var$initialized === false) {
            this._init();
            $d89c9137a3d237c2$var$initialized = true;
        }
    }
    /**
	 * Inits the state of the utility.
	 *
	 * @private
	 */ _init() {
        const gl = this.gl;
        // Store only WebGL constants here.
        $d89c9137a3d237c2$var$wrappingToGL = {
            [(0, $329ek.RepeatWrapping)]: gl.REPEAT,
            [(0, $329ek.ClampToEdgeWrapping)]: gl.CLAMP_TO_EDGE,
            [(0, $329ek.MirroredRepeatWrapping)]: gl.MIRRORED_REPEAT
        };
        $d89c9137a3d237c2$var$filterToGL = {
            [(0, $329ek.NearestFilter)]: gl.NEAREST,
            [(0, $329ek.NearestMipmapNearestFilter)]: gl.NEAREST_MIPMAP_NEAREST,
            [(0, $329ek.NearestMipmapLinearFilter)]: gl.NEAREST_MIPMAP_LINEAR,
            [(0, $329ek.LinearFilter)]: gl.LINEAR,
            [(0, $329ek.LinearMipmapNearestFilter)]: gl.LINEAR_MIPMAP_NEAREST,
            [(0, $329ek.LinearMipmapLinearFilter)]: gl.LINEAR_MIPMAP_LINEAR
        };
        $d89c9137a3d237c2$var$compareToGL = {
            [(0, $329ek.NeverCompare)]: gl.NEVER,
            [(0, $329ek.AlwaysCompare)]: gl.ALWAYS,
            [(0, $329ek.LessCompare)]: gl.LESS,
            [(0, $329ek.LessEqualCompare)]: gl.LEQUAL,
            [(0, $329ek.EqualCompare)]: gl.EQUAL,
            [(0, $329ek.GreaterEqualCompare)]: gl.GEQUAL,
            [(0, $329ek.GreaterCompare)]: gl.GREATER,
            [(0, $329ek.NotEqualCompare)]: gl.NOTEQUAL
        };
    }
    /**
	 * Returns the native texture type for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {GLenum} The native texture type.
	 */ getGLTextureType(texture) {
        const { gl: gl } = this;
        let glTextureType;
        if (texture.isCubeTexture === true) glTextureType = gl.TEXTURE_CUBE_MAP;
        else if (texture.isArrayTexture === true || texture.isDataArrayTexture === true || texture.isCompressedArrayTexture === true) glTextureType = gl.TEXTURE_2D_ARRAY;
        else if (texture.isData3DTexture === true) glTextureType = gl.TEXTURE_3D;
        else glTextureType = gl.TEXTURE_2D;
        return glTextureType;
    }
    /**
	 * Returns the native texture type for the given texture.
	 *
	 * @param {?string} internalFormatName - The internal format name. When `null`, the internal format is derived from the subsequent parameters.
	 * @param {GLenum} glFormat - The WebGL format.
	 * @param {GLenum} glType - The WebGL type.
	 * @param {string} colorSpace - The texture's color space.
	 * @param {boolean} [forceLinearTransfer=false] - Whether to force a linear transfer or not.
	 * @return {GLenum} The internal format.
	 */ getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
        const { gl: gl, extensions: extensions } = this;
        if (internalFormatName !== null) {
            if (gl[internalFormatName] !== undefined) return gl[internalFormatName];
            (0, $329ek.warn)('WebGLBackend: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === gl.RED) {
            if (glType === gl.FLOAT) internalFormat = gl.R32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.R16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.R8;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.R16;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.R32UI;
            if (glType === gl.BYTE) internalFormat = gl.R8I;
            if (glType === gl.SHORT) internalFormat = gl.R16I;
            if (glType === gl.INT) internalFormat = gl.R32I;
        }
        if (glFormat === gl.RED_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.R8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.R16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.R32UI;
            if (glType === gl.BYTE) internalFormat = gl.R8I;
            if (glType === gl.SHORT) internalFormat = gl.R16I;
            if (glType === gl.INT) internalFormat = gl.R32I;
        }
        if (glFormat === gl.RG) {
            if (glType === gl.FLOAT) internalFormat = gl.RG32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.RG16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RG8;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RG16;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RG32UI;
            if (glType === gl.BYTE) internalFormat = gl.RG8I;
            if (glType === gl.SHORT) internalFormat = gl.RG16I;
            if (glType === gl.INT) internalFormat = gl.RG32I;
        }
        if (glFormat === gl.RG_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RG8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RG16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RG32UI;
            if (glType === gl.BYTE) internalFormat = gl.RG8I;
            if (glType === gl.SHORT) internalFormat = gl.RG16I;
            if (glType === gl.INT) internalFormat = gl.RG32I;
        }
        if (glFormat === gl.RGB) {
            const transfer = forceLinearTransfer ? (0, $329ek.LinearTransfer) : (0, $329ek.ColorManagement).getTransfer(colorSpace);
            if (glType === gl.FLOAT) internalFormat = gl.RGB32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.RGB16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RGB8;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RGB16;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RGB32UI;
            if (glType === gl.BYTE) internalFormat = gl.RGB8I;
            if (glType === gl.SHORT) internalFormat = gl.RGB16I;
            if (glType === gl.INT) internalFormat = gl.RGB32I;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $329ek.SRGBTransfer) ? gl.SRGB8 : gl.RGB8;
            if (glType === gl.UNSIGNED_SHORT_5_6_5) internalFormat = gl.RGB565;
            if (glType === gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = gl.RGB5_A1;
            if (glType === gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = gl.RGB4;
            if (glType === gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = gl.RGB9_E5;
            if (glType === gl.UNSIGNED_INT_10F_11F_11F_REV) internalFormat = gl.R11F_G11F_B10F;
        }
        if (glFormat === gl.RGB_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RGB8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RGB16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RGB32UI;
            if (glType === gl.BYTE) internalFormat = gl.RGB8I;
            if (glType === gl.SHORT) internalFormat = gl.RGB16I;
            if (glType === gl.INT) internalFormat = gl.RGB32I;
        }
        if (glFormat === gl.RGBA) {
            const transfer = forceLinearTransfer ? (0, $329ek.LinearTransfer) : (0, $329ek.ColorManagement).getTransfer(colorSpace);
            if (glType === gl.FLOAT) internalFormat = gl.RGBA32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.RGBA16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RGBA8;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RGBA16;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RGBA32UI;
            if (glType === gl.BYTE) internalFormat = gl.RGBA8I;
            if (glType === gl.SHORT) internalFormat = gl.RGBA16I;
            if (glType === gl.INT) internalFormat = gl.RGBA32I;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $329ek.SRGBTransfer) ? gl.SRGB8_ALPHA8 : gl.RGBA8;
            if (glType === gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = gl.RGBA4;
            if (glType === gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = gl.RGB5_A1;
        }
        if (glFormat === gl.RGBA_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RGBA8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RGBA16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RGBA32UI;
            if (glType === gl.BYTE) internalFormat = gl.RGBA8I;
            if (glType === gl.SHORT) internalFormat = gl.RGBA16I;
            if (glType === gl.INT) internalFormat = gl.RGBA32I;
        }
        if (glFormat === gl.DEPTH_COMPONENT) {
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.DEPTH_COMPONENT16;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.DEPTH_COMPONENT24;
            if (glType === gl.FLOAT) internalFormat = gl.DEPTH_COMPONENT32F;
        }
        if (glFormat === gl.DEPTH_STENCIL) {
            if (glType === gl.UNSIGNED_INT_24_8) internalFormat = gl.DEPTH24_STENCIL8;
        }
        if (internalFormat === gl.R16F || internalFormat === gl.R32F || internalFormat === gl.RG16F || internalFormat === gl.RG32F || internalFormat === gl.RGBA16F || internalFormat === gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    /**
	 * Sets the texture parameters for the given texture.
	 *
	 * @param {GLenum} textureType - The texture type.
	 * @param {Texture} texture - The texture.
	 */ setTextureParameters(textureType, texture) {
        const { gl: gl, extensions: extensions, backend: backend } = this;
        const workingPrimaries = (0, $329ek.ColorManagement).getPrimaries((0, $329ek.ColorManagement).workingColorSpace);
        const texturePrimaries = texture.colorSpace === (0, $329ek.NoColorSpace) ? null : (0, $329ek.ColorManagement).getPrimaries(texture.colorSpace);
        const unpackConversion = texture.colorSpace === (0, $329ek.NoColorSpace) || workingPrimaries === texturePrimaries ? gl.NONE : gl.BROWSER_DEFAULT_WEBGL;
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
        gl.texParameteri(textureType, gl.TEXTURE_WRAP_S, $d89c9137a3d237c2$var$wrappingToGL[texture.wrapS]);
        gl.texParameteri(textureType, gl.TEXTURE_WRAP_T, $d89c9137a3d237c2$var$wrappingToGL[texture.wrapT]);
        if (textureType === gl.TEXTURE_3D || textureType === gl.TEXTURE_2D_ARRAY) // WebGL 2 does not support wrapping for depth 2D array textures
        {
            if (!texture.isArrayTexture) gl.texParameteri(textureType, gl.TEXTURE_WRAP_R, $d89c9137a3d237c2$var$wrappingToGL[texture.wrapR]);
        }
        gl.texParameteri(textureType, gl.TEXTURE_MAG_FILTER, $d89c9137a3d237c2$var$filterToGL[texture.magFilter]);
        const hasMipmaps = texture.mipmaps !== undefined && texture.mipmaps.length > 0;
        // follow WebGPU backend mapping for texture filtering
        const minFilter = texture.minFilter === (0, $329ek.LinearFilter) && hasMipmaps ? (0, $329ek.LinearMipmapLinearFilter) : texture.minFilter;
        gl.texParameteri(textureType, gl.TEXTURE_MIN_FILTER, $d89c9137a3d237c2$var$filterToGL[minFilter]);
        if (texture.compareFunction) {
            gl.texParameteri(textureType, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
            gl.texParameteri(textureType, gl.TEXTURE_COMPARE_FUNC, $d89c9137a3d237c2$var$compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $329ek.NearestFilter)) return;
            if (texture.minFilter !== (0, $329ek.NearestMipmapLinearFilter) && texture.minFilter !== (0, $329ek.LinearMipmapLinearFilter)) return;
            if (texture.type === (0, $329ek.FloatType) && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
            if (texture.anisotropy > 1) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, backend.getMaxAnisotropy()));
            }
        }
    }
    /**
	 * Creates a default texture for the given texture that can be used
	 * as a placeholder until the actual texture is ready for usage.
	 *
	 * @param {Texture} texture - The texture to create a default texture for.
	 */ createDefaultTexture(texture) {
        const { gl: gl, backend: backend, defaultTextures: defaultTextures } = this;
        const glTextureType = this.getGLTextureType(texture);
        let textureGPU = defaultTextures[glTextureType];
        if (textureGPU === undefined) {
            textureGPU = gl.createTexture();
            backend.state.bindTexture(glTextureType, textureGPU);
            gl.texParameteri(glTextureType, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(glTextureType, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            // gl.texImage2D( glTextureType, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );
            defaultTextures[glTextureType] = textureGPU;
        }
        backend.set(texture, {
            textureGPU: textureGPU,
            glTextureType: glTextureType
        });
    }
    /**
	 * Defines a texture on the GPU for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 * @return {undefined}
	 */ createTexture(texture, options) {
        const { gl: gl, backend: backend } = this;
        const { levels: levels, width: width, height: height, depth: depth } = options;
        const glFormat = backend.utils.convert(texture.format, texture.colorSpace);
        const glType = backend.utils.convert(texture.type);
        const glInternalFormat = this.getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
        const textureGPU = gl.createTexture();
        const glTextureType = this.getGLTextureType(texture);
        backend.state.bindTexture(glTextureType, textureGPU);
        this.setTextureParameters(glTextureType, texture);
        if (texture.isArrayTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) gl.texStorage3D(gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, width, height, depth);
        else if (texture.isData3DTexture) gl.texStorage3D(gl.TEXTURE_3D, levels, glInternalFormat, width, height, depth);
        else if (!texture.isVideoTexture) gl.texStorage2D(glTextureType, levels, glInternalFormat, width, height);
        backend.set(texture, {
            textureGPU: textureGPU,
            glTextureType: glTextureType,
            glFormat: glFormat,
            glType: glType,
            glInternalFormat: glInternalFormat
        });
    }
    /**
	 * Uploads texture buffer data to the GPU memory.
	 *
	 * @param {WebGLBuffer} buffer - The buffer data.
	 * @param {Texture} texture - The texture,
	 */ copyBufferToTexture(buffer, texture) {
        const { gl: gl, backend: backend } = this;
        const { textureGPU: textureGPU, glTextureType: glTextureType, glFormat: glFormat, glType: glType } = backend.get(texture);
        const { width: width, height: height } = texture.source.data;
        gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, buffer);
        backend.state.bindTexture(glTextureType, textureGPU);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.texSubImage2D(glTextureType, 0, 0, 0, width, height, glFormat, glType, 0);
        gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, null);
        backend.state.unbindTexture();
    // debug
    // const framebuffer = gl.createFramebuffer();
    // backend.state.bindFramebuffer( gl.FRAMEBUFFER, framebuffer );
    // gl.framebufferTexture2D( gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, glTextureType, textureGPU, 0 );
    // const readout = new Float32Array( width * height * 4 );
    // const altFormat = gl.getParameter( gl.IMPLEMENTATION_COLOR_READ_FORMAT );
    // const altType = gl.getParameter( gl.IMPLEMENTATION_COLOR_READ_TYPE );
    // gl.readPixels( 0, 0, width, height, altFormat, altType, readout );
    // backend.state.bindFramebuffer( gl.FRAMEBUFFER, null );
    // log( readout );
    }
    /**
	 * Uploads the updated texture data to the GPU.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ updateTexture(texture, options) {
        const { gl: gl } = this;
        const { width: width, height: height } = options;
        const { textureGPU: textureGPU, glTextureType: glTextureType, glFormat: glFormat, glType: glType, glInternalFormat: glInternalFormat } = this.backend.get(texture);
        if (texture.isRenderTargetTexture || textureGPU === undefined /* unsupported texture format */ ) return;
        this.backend.state.bindTexture(glTextureType, textureGPU);
        this.setTextureParameters(glTextureType, texture);
        if (texture.isCompressedTexture) {
            const mipmaps = texture.mipmaps;
            const image = options.image;
            for(let i = 0; i < mipmaps.length; i++){
                const mipmap = mipmaps[i];
                if (texture.isCompressedArrayTexture) {
                    if (texture.format !== gl.RGBA) {
                        if (glFormat !== null) gl.compressedTexSubImage3D(gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                        else (0, $329ek.warn)('WebGLBackend: Attempt to load unsupported compressed texture format in .uploadTexture()');
                    } else gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                } else if (glFormat !== null) gl.compressedTexSubImage2D(gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                else (0, $329ek.warn)('WebGLBackend: Unsupported compressed texture format');
            }
        } else if (texture.isCubeTexture) {
            const images = options.images;
            const mipmaps = texture.mipmaps;
            for(let i = 0; i < 6; i++){
                const image = $d89c9137a3d237c2$var$getImage(images[i]);
                gl.texSubImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, width, height, glFormat, glType, image);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    const image = $d89c9137a3d237c2$var$getImage(mipmap.images[i]);
                    gl.texSubImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, image.width, image.height, glFormat, glType, image);
                }
            }
        } else if (texture.isDataArrayTexture || texture.isArrayTexture) {
            const image = options.image;
            if (texture.layerUpdates.size > 0) {
                const layerByteLength = (0, $329ek.getByteLength)(image.width, image.height, texture.format, texture.type);
                for (const layerIndex of texture.layerUpdates){
                    const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                    gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                }
                texture.clearLayerUpdates();
            } else gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
        } else if (texture.isData3DTexture) {
            const image = options.image;
            gl.texSubImage3D(gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
        } else if (texture.isVideoTexture) {
            texture.update();
            gl.texImage2D(glTextureType, 0, glInternalFormat, glFormat, glType, options.image);
        } else {
            const mipmaps = texture.mipmaps;
            if (mipmaps.length > 0) for(let i = 0, il = mipmaps.length; i < il; i++){
                const mipmap = mipmaps[i];
                const image = $d89c9137a3d237c2$var$getImage(mipmap);
                gl.texSubImage2D(glTextureType, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, image);
            }
            else {
                const image = $d89c9137a3d237c2$var$getImage(options.image);
                gl.texSubImage2D(glTextureType, 0, 0, 0, width, height, glFormat, glType, image);
            }
        }
    }
    /**
	 * Generates mipmaps for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 */ generateMipmaps(texture) {
        const { gl: gl, backend: backend } = this;
        const { textureGPU: textureGPU, glTextureType: glTextureType } = backend.get(texture);
        backend.state.bindTexture(glTextureType, textureGPU);
        gl.generateMipmap(glTextureType);
    }
    /**
	 * Deallocates the render buffers of the given render target.
	 *
	 * @param {RenderTarget} renderTarget - The render target.
	 */ deallocateRenderBuffers(renderTarget) {
        const { gl: gl, backend: backend } = this;
        // remove framebuffer reference
        if (renderTarget) {
            const renderContextData = backend.get(renderTarget);
            renderContextData.renderBufferStorageSetup = undefined;
            if (renderContextData.framebuffers) {
                for(const cacheKey in renderContextData.framebuffers)gl.deleteFramebuffer(renderContextData.framebuffers[cacheKey]);
                delete renderContextData.framebuffers;
            }
            if (renderContextData.depthRenderbuffer) {
                gl.deleteRenderbuffer(renderContextData.depthRenderbuffer);
                delete renderContextData.depthRenderbuffer;
            }
            if (renderContextData.stencilRenderbuffer) {
                gl.deleteRenderbuffer(renderContextData.stencilRenderbuffer);
                delete renderContextData.stencilRenderbuffer;
            }
            if (renderContextData.msaaFrameBuffer) {
                gl.deleteFramebuffer(renderContextData.msaaFrameBuffer);
                delete renderContextData.msaaFrameBuffer;
            }
            if (renderContextData.msaaRenderbuffers) {
                for(let i = 0; i < renderContextData.msaaRenderbuffers.length; i++)gl.deleteRenderbuffer(renderContextData.msaaRenderbuffers[i]);
                delete renderContextData.msaaRenderbuffers;
            }
        }
    }
    /**
	 * Destroys the GPU data for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
	 */ destroyTexture(texture, isDefaultTexture = false) {
        const { gl: gl, backend: backend } = this;
        const { textureGPU: textureGPU, renderTarget: renderTarget } = backend.get(texture);
        this.deallocateRenderBuffers(renderTarget);
        if (isDefaultTexture === false) gl.deleteTexture(textureGPU);
        backend.delete(texture);
    }
    /**
	 * Copies data of the given source texture to the given destination texture.
	 *
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
	 * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
	 * @param {number} [srcLevel=0] - The source mip level to copy from.
	 * @param {number} [dstLevel=0] - The destination mip level to copy to.
	 */ copyTextureToTexture(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = 0) {
        const { gl: gl, backend: backend } = this;
        const { state: state } = this.backend;
        const { textureGPU: dstTextureGPU, glTextureType: glTextureType, glType: glType, glFormat: glFormat } = backend.get(dstTexture);
        state.bindTexture(glTextureType, dstTextureGPU);
        // gather the necessary dimensions to copy
        let width, height, depth, minX, minY, minZ;
        let dstX, dstY, dstZ;
        const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
        if (srcRegion !== null) {
            width = srcRegion.max.x - srcRegion.min.x;
            height = srcRegion.max.y - srcRegion.min.y;
            depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
            minX = srcRegion.min.x;
            minY = srcRegion.min.y;
            minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
        } else {
            const levelScale = Math.pow(2, -srcLevel);
            width = Math.floor(image.width * levelScale);
            height = Math.floor(image.height * levelScale);
            if (srcTexture.isDataArrayTexture || srcTexture.isArrayTexture) depth = image.depth;
            else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
            else depth = 1;
            minX = 0;
            minY = 0;
            minZ = 0;
        }
        if (dstPosition !== null) {
            dstX = dstPosition.x;
            dstY = dstPosition.y;
            dstZ = dstPosition.z;
        } else {
            dstX = 0;
            dstY = 0;
            dstZ = 0;
        }
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
        // used for copying data from cpu
        const currentUnpackRowLen = gl.getParameter(gl.UNPACK_ROW_LENGTH);
        const currentUnpackImageHeight = gl.getParameter(gl.UNPACK_IMAGE_HEIGHT);
        const currentUnpackSkipPixels = gl.getParameter(gl.UNPACK_SKIP_PIXELS);
        const currentUnpackSkipRows = gl.getParameter(gl.UNPACK_SKIP_ROWS);
        const currentUnpackSkipImages = gl.getParameter(gl.UNPACK_SKIP_IMAGES);
        gl.pixelStorei(gl.UNPACK_ROW_LENGTH, image.width);
        gl.pixelStorei(gl.UNPACK_IMAGE_HEIGHT, image.height);
        gl.pixelStorei(gl.UNPACK_SKIP_PIXELS, minX);
        gl.pixelStorei(gl.UNPACK_SKIP_ROWS, minY);
        gl.pixelStorei(gl.UNPACK_SKIP_IMAGES, minZ);
        // set up the src texture
        const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture || dstTexture.isArrayTexture;
        const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture || dstTexture.isArrayTexture;
        if (srcTexture.isDepthTexture) {
            const srcTextureData = backend.get(srcTexture);
            const dstTextureData = backend.get(dstTexture);
            const srcRenderContextData = backend.get(srcTextureData.renderTarget);
            const dstRenderContextData = backend.get(dstTextureData.renderTarget);
            const srcFramebuffer = srcRenderContextData.framebuffers[srcTextureData.cacheKey];
            const dstFramebuffer = dstRenderContextData.framebuffers[dstTextureData.cacheKey];
            state.bindFramebuffer(gl.READ_FRAMEBUFFER, srcFramebuffer);
            state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, dstFramebuffer);
            for(let i = 0; i < depth; i++){
                // if the source or destination are a 3d target then a layer needs to be bound
                if (isSrc3D) {
                    gl.framebufferTextureLayer(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, srcTextureData.textureGPU, srcLevel, minZ + i);
                    gl.framebufferTextureLayer(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, dstTextureGPU, dstLevel, dstZ + i);
                }
                gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, gl.DEPTH_BUFFER_BIT, gl.NEAREST);
            }
            state.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || backend.has(srcTexture)) {
            // get the appropriate frame buffers
            const srcTextureData = backend.get(srcTexture);
            if (this._srcFramebuffer === null) this._srcFramebuffer = gl.createFramebuffer();
            if (this._dstFramebuffer === null) this._dstFramebuffer = gl.createFramebuffer();
            // bind the frame buffer targets
            state.bindFramebuffer(gl.READ_FRAMEBUFFER, this._srcFramebuffer);
            state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this._dstFramebuffer);
            for(let i = 0; i < depth; i++){
                // assign the correct layers and mip maps to the frame buffers
                if (isSrc3D) gl.framebufferTextureLayer(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, srcTextureData.textureGPU, srcLevel, minZ + i);
                else gl.framebufferTexture2D(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, srcTextureData.textureGPU, srcLevel);
                if (isDst3D) gl.framebufferTextureLayer(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, dstTextureGPU, dstLevel, dstZ + i);
                else gl.framebufferTexture2D(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, dstTextureGPU, dstLevel);
                // copy the data using the fastest function that can achieve the copy
                if (srcLevel !== 0) gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, gl.COLOR_BUFFER_BIT, gl.NEAREST);
                else if (isDst3D) gl.copyTexSubImage3D(glTextureType, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
                else gl.copyTexSubImage2D(glTextureType, dstLevel, dstX, dstY, minX, minY, width, height);
            }
            // unbind read, draw buffers
            state.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        } else if (isDst3D) {
            // copy data into the 3d texture
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) gl.texSubImage3D(glTextureType, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
            else if (dstTexture.isCompressedArrayTexture) gl.compressedTexSubImage3D(glTextureType, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
            else gl.texSubImage3D(glTextureType, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
        } else {
            // copy data into the 2d texture
            if (srcTexture.isDataTexture) gl.texSubImage2D(gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
            else if (srcTexture.isCompressedTexture) gl.compressedTexSubImage2D(gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
            else gl.texSubImage2D(gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
        }
        // reset values
        gl.pixelStorei(gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
        gl.pixelStorei(gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
        gl.pixelStorei(gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
        gl.pixelStorei(gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
        gl.pixelStorei(gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
        // Generate mipmaps only when copying level 0
        if (dstLevel === 0 && dstTexture.generateMipmaps) gl.generateMipmap(glTextureType);
        state.unbindTexture();
    }
    /**
	 * Copies the current bound framebuffer to the given texture.
	 *
	 * @param {Texture} texture - The destination texture.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
	 */ copyFramebufferToTexture(texture, renderContext, rectangle) {
        const { gl: gl } = this;
        const { state: state } = this.backend;
        const { textureGPU: textureGPU } = this.backend.get(texture);
        const { x: x, y: y, z: width, w: height } = rectangle;
        const requireDrawFrameBuffer = texture.isDepthTexture === true || renderContext.renderTarget && renderContext.renderTarget.samples > 0;
        const srcHeight = renderContext.renderTarget ? renderContext.renderTarget.height : this.backend.getDrawingBufferSize().y;
        if (requireDrawFrameBuffer) {
            const partial = x !== 0 || y !== 0;
            let mask;
            let attachment;
            if (texture.isDepthTexture === true) {
                mask = gl.DEPTH_BUFFER_BIT;
                attachment = gl.DEPTH_ATTACHMENT;
                if (renderContext.stencil) mask |= gl.STENCIL_BUFFER_BIT;
            } else {
                mask = gl.COLOR_BUFFER_BIT;
                attachment = gl.COLOR_ATTACHMENT0;
            }
            if (partial) {
                const renderTargetContextData = this.backend.get(renderContext.renderTarget);
                const fb = renderTargetContextData.framebuffers[renderContext.getCacheKey()];
                const msaaFrameBuffer = renderTargetContextData.msaaFrameBuffer;
                state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fb);
                state.bindFramebuffer(gl.READ_FRAMEBUFFER, msaaFrameBuffer);
                const flippedY = srcHeight - y - height;
                gl.blitFramebuffer(x, flippedY, x + width, flippedY + height, x, flippedY, x + width, flippedY + height, mask, gl.NEAREST);
                state.bindFramebuffer(gl.READ_FRAMEBUFFER, fb);
                state.bindTexture(gl.TEXTURE_2D, textureGPU);
                gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, 0, 0, x, flippedY, width, height);
                state.unbindTexture();
            } else {
                const fb = gl.createFramebuffer();
                state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fb);
                gl.framebufferTexture2D(gl.DRAW_FRAMEBUFFER, attachment, gl.TEXTURE_2D, textureGPU, 0);
                gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, gl.NEAREST);
                gl.deleteFramebuffer(fb);
            }
        } else {
            state.bindTexture(gl.TEXTURE_2D, textureGPU);
            gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, 0, 0, x, srcHeight - height - y, width, height);
            state.unbindTexture();
        }
        if (texture.generateMipmaps) this.generateMipmaps(texture);
        this.backend._setFramebuffer(renderContext);
    }
    /**
	 * SetupS storage for internal depth/stencil buffers and bind to correct framebuffer.
	 *
	 * @param {WebGLRenderbuffer} renderbuffer - The render buffer.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {number} samples - The MSAA sample count.
	 * @param {boolean} [useMultisampledRTT=false] - Whether to use WEBGL_multisampled_render_to_texture or not.
	 */ setupRenderBufferStorage(renderbuffer, renderContext, samples, useMultisampledRTT = false) {
        const { gl: gl } = this;
        const renderTarget = renderContext.renderTarget;
        const { depthTexture: depthTexture, depthBuffer: depthBuffer, stencilBuffer: stencilBuffer, width: width, height: height } = renderTarget;
        gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
        if (depthBuffer && !stencilBuffer) {
            let glInternalFormat = gl.DEPTH_COMPONENT24;
            if (useMultisampledRTT === true) {
                const multisampledRTTExt = this.extensions.get('WEBGL_multisampled_render_to_texture');
                multisampledRTTExt.renderbufferStorageMultisampleEXT(gl.RENDERBUFFER, renderTarget.samples, glInternalFormat, width, height);
            } else if (samples > 0) {
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === gl.FLOAT) glInternalFormat = gl.DEPTH_COMPONENT32F;
                }
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, glInternalFormat, width, height);
            } else gl.renderbufferStorage(gl.RENDERBUFFER, glInternalFormat, width, height);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, renderbuffer);
        } else if (depthBuffer && stencilBuffer) {
            if (samples > 0) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, gl.DEPTH24_STENCIL8, width, height);
            else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, renderbuffer);
        }
        gl.bindRenderbuffer(gl.RENDERBUFFER, null);
    }
    /**
	 * Returns texture data as a typed array.
	 *
	 * @async
	 * @param {Texture} texture - The texture to copy.
	 * @param {number} x - The x coordinate of the copy origin.
	 * @param {number} y - The y coordinate of the copy origin.
	 * @param {number} width - The width of the copy.
	 * @param {number} height - The height of the copy.
	 * @param {number} faceIndex - The face index.
	 * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
	 */ async copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        const { backend: backend, gl: gl } = this;
        const { textureGPU: textureGPU, glFormat: glFormat, glType: glType } = this.backend.get(texture);
        const fb = gl.createFramebuffer();
        backend.state.bindFramebuffer(gl.READ_FRAMEBUFFER, fb);
        const target = texture.isCubeTexture ? gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex : gl.TEXTURE_2D;
        gl.framebufferTexture2D(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, target, textureGPU, 0);
        const typedArrayType = this._getTypedArrayType(glType);
        const bytesPerTexel = this._getBytesPerTexel(glType, glFormat);
        const elementCount = width * height;
        const byteLength = elementCount * bytesPerTexel;
        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buffer);
        gl.bufferData(gl.PIXEL_PACK_BUFFER, byteLength, gl.STREAM_READ);
        gl.readPixels(x, y, width, height, glFormat, glType, 0);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
        await backend.utils._clientWaitAsync();
        const dstBuffer = new typedArrayType(byteLength / typedArrayType.BYTES_PER_ELEMENT);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buffer);
        gl.getBufferSubData(gl.PIXEL_PACK_BUFFER, 0, dstBuffer);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
        backend.state.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.deleteFramebuffer(fb);
        return dstBuffer;
    }
    /**
	 * Returns the corresponding typed array type for the given WebGL data type.
	 *
	 * @private
	 * @param {GLenum} glType - The WebGL data type.
	 * @return {TypedArray.constructor} The typed array type.
	 */ _getTypedArrayType(glType) {
        const { gl: gl } = this;
        if (glType === gl.UNSIGNED_BYTE) return Uint8Array;
        if (glType === gl.UNSIGNED_SHORT_4_4_4_4) return Uint16Array;
        if (glType === gl.UNSIGNED_SHORT_5_5_5_1) return Uint16Array;
        if (glType === gl.UNSIGNED_SHORT_5_6_5) return Uint16Array;
        if (glType === gl.UNSIGNED_SHORT) return Uint16Array;
        if (glType === gl.UNSIGNED_INT) return Uint32Array;
        if (glType === gl.HALF_FLOAT) return Uint16Array;
        if (glType === gl.FLOAT) return Float32Array;
        throw new Error(`Unsupported WebGL type: ${glType}`);
    }
    /**
	 * Returns the bytes-per-texel value for the given WebGL data type and texture format.
	 *
	 * @private
	 * @param {GLenum} glType - The WebGL data type.
	 * @param {GLenum} glFormat - The WebGL texture format.
	 * @return {number} The bytes-per-texel.
	 */ _getBytesPerTexel(glType, glFormat) {
        const { gl: gl } = this;
        let bytesPerComponent = 0;
        if (glType === gl.UNSIGNED_BYTE) bytesPerComponent = 1;
        if (glType === gl.UNSIGNED_SHORT_4_4_4_4 || glType === gl.UNSIGNED_SHORT_5_5_5_1 || glType === gl.UNSIGNED_SHORT_5_6_5 || glType === gl.UNSIGNED_SHORT || glType === gl.HALF_FLOAT) bytesPerComponent = 2;
        if (glType === gl.UNSIGNED_INT || glType === gl.FLOAT) bytesPerComponent = 4;
        if (glFormat === gl.RGBA) return bytesPerComponent * 4;
        if (glFormat === gl.RGB) return bytesPerComponent * 3;
        if (glFormat === gl.ALPHA) return bytesPerComponent;
    }
    /**
	 * Frees the internal resources.
	 */ dispose() {
        const { gl: gl } = this;
        if (this._srcFramebuffer !== null) gl.deleteFramebuffer(this._srcFramebuffer);
        if (this._dstFramebuffer !== null) gl.deleteFramebuffer(this._dstFramebuffer);
    }
}
function $d89c9137a3d237c2$var$getImage(source) {
    if (source.isDataTexture) return source.image.data;
    else if (typeof HTMLImageElement !== 'undefined' && source instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && source instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && source instanceof ImageBitmap || typeof OffscreenCanvas !== 'undefined' && source instanceof OffscreenCanvas) return source;
    return source.data;
}
/**
 * A WebGL 2 backend utility module for managing extensions.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGLExtensions {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
        /**
		 * A reference to the rendering context.
		 *
		 * @type {WebGL2RenderingContext}
		 */ this.gl = this.backend.gl;
        /**
		 * A list with all the supported WebGL extensions.
		 *
		 * @type {Array<string>}
		 */ this.availableExtensions = this.gl.getSupportedExtensions();
        /**
		 * A dictionary with requested WebGL extensions.
		 * The key is the name of the extension, the value
		 * the requested extension object.
		 *
		 * @type {Object<string,Object>}
		 */ this.extensions = {};
    }
    /**
	 * Returns the extension object for the given extension name.
	 *
	 * @param {string} name - The extension name.
	 * @return {Object} The extension object.
	 */ get(name) {
        let extension = this.extensions[name];
        if (extension === undefined) {
            extension = this.gl.getExtension(name);
            this.extensions[name] = extension;
        }
        return extension;
    }
    /**
	 * Returns `true` if the requested extension is available.
	 *
	 * @param {string} name - The extension name.
	 * @return {boolean} Whether the given extension is available or not.
	 */ has(name) {
        return this.availableExtensions.includes(name);
    }
}
/**
 * A WebGL 2 backend utility module for managing the device's capabilities.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGLCapabilities {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
        /**
		 * This value holds the cached max anisotropy value.
		 *
		 * @type {?number}
		 * @default null
		 */ this.maxAnisotropy = null;
    }
    /**
	 * Returns the maximum anisotropy texture filtering value. This value
	 * depends on the device and is reported by the `EXT_texture_filter_anisotropic`
	 * WebGL extension.
	 *
	 * @return {number} The maximum anisotropy texture filtering value.
	 */ getMaxAnisotropy() {
        if (this.maxAnisotropy !== null) return this.maxAnisotropy;
        const gl = this.backend.gl;
        const extensions = this.backend.extensions;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            this.maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else this.maxAnisotropy = 0;
        return this.maxAnisotropy;
    }
}
const $d89c9137a3d237c2$var$GLFeatureName = {
    'WEBGL_multi_draw': 'WEBGL_multi_draw',
    'WEBGL_compressed_texture_astc': 'texture-compression-astc',
    'WEBGL_compressed_texture_etc': 'texture-compression-etc2',
    'WEBGL_compressed_texture_etc1': 'texture-compression-etc1',
    'WEBGL_compressed_texture_pvrtc': 'texture-compression-pvrtc',
    'WEBGL_compressed_texture_s3tc': 'texture-compression-s3tc',
    'EXT_texture_compression_bptc': 'texture-compression-bc',
    'EXT_disjoint_timer_query_webgl2': 'timestamp-query',
    'OVR_multiview2': 'OVR_multiview2'
};
class $d89c9137a3d237c2$var$WebGLBufferRenderer {
    constructor(backend){
        this.gl = backend.gl;
        this.extensions = backend.extensions;
        this.info = backend.renderer.info;
        this.mode = null;
        this.index = 0;
        this.type = null;
        this.object = null;
    }
    render(start, count) {
        const { gl: gl, mode: mode, object: object, type: type, info: info, index: index } = this;
        if (index !== 0) gl.drawElements(mode, count, type, start);
        else gl.drawArrays(mode, start, count);
        info.update(object, count, 1);
    }
    renderInstances(start, count, primcount) {
        const { gl: gl, mode: mode, type: type, index: index, object: object, info: info } = this;
        if (primcount === 0) return;
        if (index !== 0) gl.drawElementsInstanced(mode, count, type, start, primcount);
        else gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(object, count, primcount);
    }
    renderMultiDraw(starts, counts, drawCount) {
        const { extensions: extensions, mode: mode, object: object, info: info } = this;
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < drawCount; i++)this.render(starts[i], counts[i]);
        else {
            if (this.index !== 0) extension.multiDrawElementsWEBGL(mode, counts, 0, this.type, starts, 0, drawCount);
            else extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i];
            info.update(object, elementCount, 1);
        }
    }
    renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        const { extensions: extensions, mode: mode, object: object, info: info } = this;
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < drawCount; i++)this.renderInstances(starts[i], counts[i], primcount[i]);
        else {
            if (this.index !== 0) extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, this.type, starts, 0, primcount, 0, drawCount);
            else extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(object, elementCount, 1);
        }
    }
}
/**
 * Abstract base class of a timestamp query pool.
 *
 * @abstract
 */ class $d89c9137a3d237c2$var$TimestampQueryPool {
    /**
	 * Creates a new timestamp query pool.
	 *
	 * @param {number} [maxQueries=256] - Maximum number of queries this pool can hold.
	 */ constructor(maxQueries = 256){
        /**
		 * Whether to track timestamps or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.trackTimestamp = true;
        /**
		 * Maximum number of queries this pool can hold.
		 *
		 * @type {number}
		 * @default 256
		 */ this.maxQueries = maxQueries;
        /**
		 * How many queries allocated so far.
		 *
		 * @type {number}
		 * @default 0
		 */ this.currentQueryIndex = 0;
        /**
		 * Tracks offsets for different contexts.
		 *
		 * @type {Map<string, number>}
		 */ this.queryOffsets = new Map();
        /**
		 * Whether the pool has been disposed or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.isDisposed = false;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.lastValue = 0;
        /**
		 * Stores all timestamp frames.
		 *
		 * @type {Array<number>}
		 */ this.frames = [];
        /**
		 * TODO
		 *
		 * @type {boolean}
		 * @default false
		 */ this.pendingResolve = false;
        /**
		 * Stores the latest timestamp for each render context.
		 *
		 * @type {Map<string, number>}
		 */ this.timestamps = new Map();
    }
    /**
	 * Returns all timestamp frames.
	 *
	 * @return {Array<number>} The timestamp frames.
	 */ getTimestampFrames() {
        return this.frames;
    }
    /**
	 * Returns the timestamp for a given render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @return {?number} The timestamp, or undefined if not available.
	 */ getTimestamp(uid) {
        let timestamp = this.timestamps.get(uid);
        if (timestamp === undefined) {
            (0, $329ek.warn)(`TimestampQueryPool: No timestamp available for uid ${uid}.`);
            timestamp = 0;
        }
        return timestamp;
    }
    /**
	 * Returns whether a timestamp is available for a given render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @return {boolean} True if a timestamp is available, false otherwise.
	 */ hasTimestamp(uid) {
        return this.timestamps.has(uid);
    }
    /**
	 * Allocate queries for a specific uid.
	 *
	 * @abstract
	 * @param {string} uid - A unique identifier for the render context.
	 * @param {number} frameId - The current frame identifier.
	 * @returns {?number}
	 */ allocateQueriesForContext() {}
    /**
	 * Resolve all timestamps and return data (or process them).
	 *
	 * @abstract
	 * @async
	 * @returns {Promise<number>|number} The resolved timestamp value.
	 */ async resolveQueriesAsync() {}
    /**
	 * Dispose of the query pool.
	 *
	 * @abstract
	 */ dispose() {}
}
/**
 * Manages a pool of WebGL timestamp queries for performance measurement.
 * Handles creation, execution, and resolution of timer queries using WebGL extensions.
 *
 * @augments TimestampQueryPool
 */ class $d89c9137a3d237c2$var$WebGLTimestampQueryPool extends $d89c9137a3d237c2$var$TimestampQueryPool {
    /**
	 * Creates a new WebGL timestamp query pool.
	 *
	 * @param {WebGLRenderingContext|WebGL2RenderingContext} gl - The WebGL context.
	 * @param {string} type - The type identifier for this query pool.
	 * @param {number} [maxQueries=2048] - Maximum number of queries this pool can hold.
	 */ constructor(gl, type, maxQueries = 2048){
        super(maxQueries);
        this.gl = gl;
        this.type = type;
        // Check for timer query extensions
        this.ext = gl.getExtension('EXT_disjoint_timer_query_webgl2') || gl.getExtension('EXT_disjoint_timer_query');
        if (!this.ext) {
            (0, $329ek.warn)('EXT_disjoint_timer_query not supported; timestamps will be disabled.');
            this.trackTimestamp = false;
            return;
        }
        // Create query objects
        this.queries = [];
        for(let i = 0; i < this.maxQueries; i++)this.queries.push(gl.createQuery());
        this.activeQuery = null;
        this.queryStates = new Map(); // Track state of each query: 'inactive', 'started', 'ended'
    }
    /**
	 * Allocates a pair of queries for a given render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @returns {?number} The base offset for the allocated queries, or null if allocation failed.
	 */ allocateQueriesForContext(uid) {
        if (!this.trackTimestamp) return null;
        // Check if we have enough space for a new query pair
        if (this.currentQueryIndex + 2 > this.maxQueries) {
            (0, $329ek.warnOnce)(`WebGPUTimestampQueryPool [${this.type}]: Maximum number of queries exceeded, when using trackTimestamp it is necessary to resolves the queries via renderer.resolveTimestampsAsync( THREE.TimestampQuery.${this.type.toUpperCase()} ).`);
            return null;
        }
        const baseOffset = this.currentQueryIndex;
        this.currentQueryIndex += 2;
        // Initialize query states
        this.queryStates.set(baseOffset, 'inactive');
        this.queryOffsets.set(uid, baseOffset);
        return baseOffset;
    }
    /**
	 * Begins a timestamp query for the specified render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 */ beginQuery(uid) {
        if (!this.trackTimestamp || this.isDisposed) return;
        const baseOffset = this.queryOffsets.get(uid);
        if (baseOffset == null) return;
        // Don't start a new query if there's an active one
        if (this.activeQuery !== null) return;
        const query = this.queries[baseOffset];
        if (!query) return;
        try {
            // Only begin if query is inactive
            if (this.queryStates.get(baseOffset) === 'inactive') {
                this.gl.beginQuery(this.ext.TIME_ELAPSED_EXT, query);
                this.activeQuery = baseOffset;
                this.queryStates.set(baseOffset, 'started');
            }
        } catch (e) {
            (0, $329ek.error)('Error in beginQuery:', e);
            this.activeQuery = null;
            this.queryStates.set(baseOffset, 'inactive');
        }
    }
    /**
	 * Ends the active timestamp query for the specified render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 */ endQuery(uid) {
        if (!this.trackTimestamp || this.isDisposed) return;
        const baseOffset = this.queryOffsets.get(uid);
        if (baseOffset == null) return;
        // Only end if this is the active query
        if (this.activeQuery !== baseOffset) return;
        try {
            this.gl.endQuery(this.ext.TIME_ELAPSED_EXT);
            this.queryStates.set(baseOffset, 'ended');
            this.activeQuery = null;
        } catch (e) {
            (0, $329ek.error)('Error in endQuery:', e);
            // Reset state on error
            this.queryStates.set(baseOffset, 'inactive');
            this.activeQuery = null;
        }
    }
    /**
	 * Asynchronously resolves all completed queries and returns the total duration.
	 *
	 * @async
	 * @returns {Promise<number>} The total duration in milliseconds, or the last valid value if resolution fails.
	 */ async resolveQueriesAsync() {
        if (!this.trackTimestamp || this.pendingResolve) return this.lastValue;
        this.pendingResolve = true;
        try {
            // Wait for all ended queries to complete
            const resolvePromises = new Map();
            for (const [uid, baseOffset] of this.queryOffsets){
                const state = this.queryStates.get(baseOffset);
                if (state === 'ended') {
                    const query = this.queries[baseOffset];
                    resolvePromises.set(uid, this.resolveQuery(query));
                }
            }
            if (resolvePromises.size === 0) return this.lastValue;
            //
            const framesDuration = {};
            const frames = [];
            for (const [uid, promise] of resolvePromises){
                const match = uid.match(/^(.*):f(\d+)$/);
                const frame = parseInt(match[2]);
                if (frames.includes(frame) === false) frames.push(frame);
                if (framesDuration[frame] === undefined) framesDuration[frame] = 0;
                const duration = await promise;
                this.timestamps.set(uid, duration);
                framesDuration[frame] += duration;
            }
            // Return the total duration of the last frame
            const totalDuration = framesDuration[frames[frames.length - 1]];
            // Store the last valid result
            this.lastValue = totalDuration;
            this.frames = frames;
            // Reset states
            this.currentQueryIndex = 0;
            this.queryOffsets.clear();
            this.queryStates.clear();
            this.activeQuery = null;
            return totalDuration;
        } catch (e) {
            (0, $329ek.error)('Error resolving queries:', e);
            return this.lastValue;
        } finally{
            this.pendingResolve = false;
        }
    }
    /**
	 * Resolves a single query, checking for completion and disjoint operation.
	 *
	 * @async
	 * @param {WebGLQuery} query - The query object to resolve.
	 * @returns {Promise<number>} The elapsed time in milliseconds.
	 */ async resolveQuery(query) {
        return new Promise((resolve)=>{
            if (this.isDisposed) {
                resolve(this.lastValue);
                return;
            }
            let timeoutId;
            let isResolved = false;
            const cleanup = ()=>{
                if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = null;
                }
            };
            const finalizeResolution = (value)=>{
                if (!isResolved) {
                    isResolved = true;
                    cleanup();
                    resolve(value);
                }
            };
            const checkQuery = ()=>{
                if (this.isDisposed) {
                    finalizeResolution(this.lastValue);
                    return;
                }
                try {
                    // Check if the GPU timer was disjoint (i.e., timing was unreliable)
                    const disjoint = this.gl.getParameter(this.ext.GPU_DISJOINT_EXT);
                    if (disjoint) {
                        finalizeResolution(this.lastValue);
                        return;
                    }
                    const available = this.gl.getQueryParameter(query, this.gl.QUERY_RESULT_AVAILABLE);
                    if (!available) {
                        timeoutId = setTimeout(checkQuery, 1);
                        return;
                    }
                    const elapsed = this.gl.getQueryParameter(query, this.gl.QUERY_RESULT);
                    resolve(Number(elapsed) / 1e6); // Convert nanoseconds to milliseconds
                } catch (e) {
                    (0, $329ek.error)('Error checking query:', e);
                    resolve(this.lastValue);
                }
            };
            checkQuery();
        });
    }
    /**
	 * Releases all resources held by this query pool.
	 * This includes deleting all query objects and clearing internal state.
	 */ dispose() {
        if (this.isDisposed) return;
        this.isDisposed = true;
        if (!this.trackTimestamp) return;
        for (const query of this.queries)this.gl.deleteQuery(query);
        this.queries = [];
        this.queryStates.clear();
        this.queryOffsets.clear();
        this.lastValue = 0;
        this.activeQuery = null;
    }
}
/**
 * A backend implementation targeting WebGL 2.
 *
 * @private
 * @augments Backend
 */ class $d89c9137a3d237c2$var$WebGLBackend extends $d89c9137a3d237c2$var$Backend {
    /**
	 * WebGLBackend options.
	 *
	 * @typedef {Object} WebGLBackend~Options
	 * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
	 * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
	 * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
	 * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
	 * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
	 * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0 to overwrite the default.
	 * @property {boolean} [forceWebGL=false] - If set to `true`, the renderer uses a WebGL 2 backend no matter if WebGPU is supported or not.
	 * @property {WebGL2RenderingContext} [context=undefined] - A WebGL 2 rendering context.
	 */ /**
	 * Constructs a new WebGPU backend.
	 *
	 * @param {WebGLBackend~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        super(parameters);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLBackend = true;
        /**
		 * A reference to a backend module holding shader attribute-related
		 * utility functions.
		 *
		 * @type {?WebGLAttributeUtils}
		 * @default null
		 */ this.attributeUtils = null;
        /**
		 * A reference to a backend module holding extension-related
		 * utility functions.
		 *
		 * @type {?WebGLExtensions}
		 * @default null
		 */ this.extensions = null;
        /**
		 * A reference to a backend module holding capability-related
		 * utility functions.
		 *
		 * @type {?WebGLCapabilities}
		 * @default null
		 */ this.capabilities = null;
        /**
		 * A reference to a backend module holding texture-related
		 * utility functions.
		 *
		 * @type {?WebGLTextureUtils}
		 * @default null
		 */ this.textureUtils = null;
        /**
		 * A reference to a backend module holding renderer-related
		 * utility functions.
		 *
		 * @type {?WebGLBufferRenderer}
		 * @default null
		 */ this.bufferRenderer = null;
        /**
		 * A reference to the rendering context.
		 *
		 * @type {?WebGL2RenderingContext}
		 * @default null
		 */ this.gl = null;
        /**
		 * A reference to a backend module holding state-related
		 * utility functions.
		 *
		 * @type {?WebGLState}
		 * @default null
		 */ this.state = null;
        /**
		 * A reference to a backend module holding common
		 * utility functions.
		 *
		 * @type {?WebGLUtils}
		 * @default null
		 */ this.utils = null;
        /**
		 * Dictionary for caching VAOs.
		 *
		 * @type {Object<string,WebGLVertexArrayObject>}
		 */ this.vaoCache = {};
        /**
		 * Dictionary for caching transform feedback objects.
		 *
		 * @type {Object<string,WebGLTransformFeedback>}
		 */ this.transformFeedbackCache = {};
        /**
		 * Controls if `gl.RASTERIZER_DISCARD` should be enabled or not.
		 * Only relevant when using compute shaders.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.discard = false;
        /**
		 * A reference to the `EXT_disjoint_timer_query_webgl2` extension. `null` if the
		 * device does not support the extension.
		 *
		 * @type {?EXTDisjointTimerQueryWebGL2}
		 * @default null
		 */ this.disjoint = null;
        /**
		* A reference to the `KHR_parallel_shader_compile` extension. `null` if the
		* device does not support the extension.
		*
		* @type {?KHRParallelShaderCompile}
		* @default null
		*/ this.parallel = null;
        /**
		 * A reference to the current render context.
		 *
		 * @private
		 * @type {RenderContext}
		 * @default null
		 */ this._currentContext = null;
        /**
		 * A unique collection of bindings.
		 *
		 * @private
		 * @type {WeakSet<Array<BindGroup>>}
		 */ this._knownBindings = new WeakSet();
        /**
		 * Whether the device supports framebuffers invalidation or not.
		 *
		 * @private
		 * @type {boolean}
		 */ this._supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
        /**
		 * The target framebuffer when rendering with
		 * the WebXR device API.
		 *
		 * @private
		 * @type {?WebGLFramebuffer}
		 * @default null
		 */ this._xrFramebuffer = null;
    }
    /**
	 * Initializes the backend so it is ready for usage.
	 *
	 * @param {Renderer} renderer - The renderer.
	 */ init(renderer) {
        super.init(renderer);
        //
        const parameters = this.parameters;
        const contextAttributes = {
            antialias: renderer.currentSamples > 0,
            alpha: true,
            depth: renderer.depth,
            stencil: renderer.stencil
        };
        const glContext = parameters.context !== undefined ? parameters.context : renderer.domElement.getContext('webgl2', contextAttributes);
        function onContextLost(event) {
            event.preventDefault();
            const contextLossInfo = {
                api: 'WebGL',
                message: event.statusMessage || 'Unknown reason',
                reason: null,
                originalEvent: event
            };
            renderer.onDeviceLost(contextLossInfo);
        }
        this._onContextLost = onContextLost;
        renderer.domElement.addEventListener('webglcontextlost', onContextLost, false);
        this.gl = glContext;
        this.extensions = new $d89c9137a3d237c2$var$WebGLExtensions(this);
        this.capabilities = new $d89c9137a3d237c2$var$WebGLCapabilities(this);
        this.attributeUtils = new $d89c9137a3d237c2$var$WebGLAttributeUtils(this);
        this.textureUtils = new $d89c9137a3d237c2$var$WebGLTextureUtils(this);
        this.bufferRenderer = new $d89c9137a3d237c2$var$WebGLBufferRenderer(this);
        this.state = new $d89c9137a3d237c2$var$WebGLState(this);
        this.utils = new $d89c9137a3d237c2$var$WebGLUtils(this);
        this.extensions.get('EXT_color_buffer_float');
        this.extensions.get('WEBGL_clip_cull_distance');
        this.extensions.get('OES_texture_float_linear');
        this.extensions.get('EXT_color_buffer_half_float');
        this.extensions.get('WEBGL_multisampled_render_to_texture');
        this.extensions.get('WEBGL_render_shared_exponent');
        this.extensions.get('WEBGL_multi_draw');
        this.extensions.get('OVR_multiview2');
        this.disjoint = this.extensions.get('EXT_disjoint_timer_query_webgl2');
        this.parallel = this.extensions.get('KHR_parallel_shader_compile');
        this.drawBuffersIndexedExt = this.extensions.get('OES_draw_buffers_indexed');
    }
    /**
	 * The coordinate system of the backend.
	 *
	 * @type {number}
	 * @readonly
	 */ get coordinateSystem() {
        return 0, $329ek.WebGLCoordinateSystem;
    }
    /**
	 * This method performs a readback operation by moving buffer data from
	 * a storage buffer attribute from the GPU to the CPU.
	 *
	 * @async
	 * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
	 * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync(attribute) {
        return await this.attributeUtils.getArrayBufferAsync(attribute);
    }
    /**
	 * Ensures the backend is XR compatible.
	 *
	 * @async
	 * @return {Promise} A Promise that resolve when the renderer is XR compatible.
	 */ async makeXRCompatible() {
        const attributes = this.gl.getContextAttributes();
        if (attributes.xrCompatible !== true) await this.gl.makeXRCompatible();
    }
    /**
	 * Sets the XR rendering destination.
	 *
	 * @param {WebGLFramebuffer} xrFramebuffer - The XR framebuffer.
	 */ setXRTarget(xrFramebuffer) {
        this._xrFramebuffer = xrFramebuffer;
    }
    /**
	 * Configures the given XR render target with external textures.
	 *
	 * This method is only relevant when using the WebXR Layers API.
	 *
	 * @param {XRRenderTarget} renderTarget - The XR render target.
	 * @param {WebGLTexture} colorTexture - A native color texture.
	 * @param {?WebGLTexture} [depthTexture=null] - A native depth texture.
	 */ setXRRenderTargetTextures(renderTarget, colorTexture, depthTexture = null) {
        const gl = this.gl;
        this.set(renderTarget.texture, {
            textureGPU: colorTexture,
            glInternalFormat: gl.RGBA8
        }); // see #24698 why RGBA8 and not SRGB8_ALPHA8 is used
        if (depthTexture !== null) {
            const glInternalFormat = renderTarget.stencilBuffer ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
            this.set(renderTarget.depthTexture, {
                textureGPU: depthTexture,
                glInternalFormat: glInternalFormat
            });
            // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth texture.
            if (this.extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTarget._autoAllocateDepthBuffer === true && renderTarget.multiview === false) (0, $329ek.warn)('WebGLBackend: Render-to-texture extension was disabled because an external texture was provided');
            renderTarget._autoAllocateDepthBuffer = false;
        }
    }
    /**
	 * Inits a time stamp query for the given render context.
	 *
	 * @param {string} type - The type of the timestamp query.
	 * @param {string} uid - A unique identifier for the timestamp query.
	 */ initTimestampQuery(type, uid) {
        if (!this.disjoint || !this.trackTimestamp) return;
        if (!this.timestampQueryPool[type]) // TODO: Variable maxQueries?
        this.timestampQueryPool[type] = new $d89c9137a3d237c2$var$WebGLTimestampQueryPool(this.gl, type, 2048);
        const timestampQueryPool = this.timestampQueryPool[type];
        const baseOffset = timestampQueryPool.allocateQueriesForContext(uid);
        if (baseOffset !== null) timestampQueryPool.beginQuery(uid);
    }
    // timestamp utils
    /**
	 * Prepares the timestamp buffer.
	 *
	 * @param {string} type - The type of the timestamp query.
	 * @param {string} uid - A unique identifier for the timestamp query.
	 */ prepareTimestampBuffer(type, uid) {
        if (!this.disjoint || !this.trackTimestamp) return;
        const timestampQueryPool = this.timestampQueryPool[type];
        timestampQueryPool.endQuery(uid);
    }
    /**
	 * Returns the backend's rendering context.
	 *
	 * @return {WebGL2RenderingContext} The rendering context.
	 */ getContext() {
        return this.gl;
    }
    /**
	 * This method is executed at the beginning of a render call and prepares
	 * the WebGL state for upcoming render calls
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ beginRender(renderContext) {
        const { state: state } = this;
        const renderContextData = this.get(renderContext);
        //
        if (renderContext.viewport) this.updateViewport(renderContext);
        else {
            const { width: width, height: height } = this.getDrawingBufferSize();
            state.viewport(0, 0, width, height);
        }
        if (renderContext.scissor) {
            const { x: x, y: y, width: width, height: height } = renderContext.scissorValue;
            state.scissor(x, renderContext.height - height - y, width, height);
        }
        //
        this.initTimestampQuery((0, $329ek.TimestampQuery).RENDER, this.getTimestampUID(renderContext));
        renderContextData.previousContext = this._currentContext;
        this._currentContext = renderContext;
        this._setFramebuffer(renderContext);
        this.clear(renderContext.clearColor, renderContext.clearDepth, renderContext.clearStencil, renderContext, false);
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        if (occlusionQueryCount > 0) {
            // Get a reference to the array of objects with queries. The renderContextData property
            // can be changed by another render pass before the async reading of all previous queries complete
            renderContextData.currentOcclusionQueries = renderContextData.occlusionQueries;
            renderContextData.currentOcclusionQueryObjects = renderContextData.occlusionQueryObjects;
            renderContextData.lastOcclusionObject = null;
            renderContextData.occlusionQueries = new Array(occlusionQueryCount);
            renderContextData.occlusionQueryObjects = new Array(occlusionQueryCount);
            renderContextData.occlusionQueryIndex = 0;
        }
    }
    /**
	 * This method is executed at the end of a render call and finalizes work
	 * after draw calls.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ finishRender(renderContext) {
        const { gl: gl, state: state } = this;
        const renderContextData = this.get(renderContext);
        const previousContext = renderContextData.previousContext;
        state.resetVertexState();
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        if (occlusionQueryCount > 0) {
            if (occlusionQueryCount > renderContextData.occlusionQueryIndex) gl.endQuery(gl.ANY_SAMPLES_PASSED);
            this.resolveOccludedAsync(renderContext);
        }
        const textures = renderContext.textures;
        if (textures !== null) for(let i = 0; i < textures.length; i++){
            const texture = textures[i];
            if (texture.generateMipmaps) this.generateMipmaps(texture);
        }
        this._currentContext = previousContext;
        this._resolveRenderTarget(renderContext);
        if (previousContext !== null) {
            this._setFramebuffer(previousContext);
            if (previousContext.viewport) this.updateViewport(previousContext);
            else {
                const { width: width, height: height } = this.getDrawingBufferSize();
                state.viewport(0, 0, width, height);
            }
        }
        this.prepareTimestampBuffer((0, $329ek.TimestampQuery).RENDER, this.getTimestampUID(renderContext));
    }
    /**
	 * This method processes the result of occlusion queries and writes it
	 * into render context data.
	 *
	 * @async
	 * @param {RenderContext} renderContext - The render context.
	 */ resolveOccludedAsync(renderContext) {
        const renderContextData = this.get(renderContext);
        // handle occlusion query results
        const { currentOcclusionQueries: currentOcclusionQueries, currentOcclusionQueryObjects: currentOcclusionQueryObjects } = renderContextData;
        if (currentOcclusionQueries && currentOcclusionQueryObjects) {
            const occluded = new WeakSet();
            const { gl: gl } = this;
            renderContextData.currentOcclusionQueryObjects = null;
            renderContextData.currentOcclusionQueries = null;
            const check = ()=>{
                let completed = 0;
                // check all queries and requeue as appropriate
                for(let i = 0; i < currentOcclusionQueries.length; i++){
                    const query = currentOcclusionQueries[i];
                    if (query === null) continue;
                    if (gl.getQueryParameter(query, gl.QUERY_RESULT_AVAILABLE)) {
                        if (gl.getQueryParameter(query, gl.QUERY_RESULT) === 0) occluded.add(currentOcclusionQueryObjects[i]);
                        currentOcclusionQueries[i] = null;
                        gl.deleteQuery(query);
                        completed++;
                    }
                }
                if (completed < currentOcclusionQueries.length) requestAnimationFrame(check);
                else renderContextData.occluded = occluded;
            };
            check();
        }
    }
    /**
	 * Returns `true` if the given 3D object is fully occluded by other
	 * 3D objects in the scene.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object is fully occluded or not.
	 */ isOccluded(renderContext, object) {
        const renderContextData = this.get(renderContext);
        return renderContextData.occluded && renderContextData.occluded.has(object);
    }
    /**
	 * Updates the viewport with the values from the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ updateViewport(renderContext) {
        const { state: state } = this;
        const { x: x, y: y, width: width, height: height } = renderContext.viewportValue;
        state.viewport(x, renderContext.height - height - y, width, height);
    }
    /**
	 * Defines the scissor test.
	 *
	 * @param {boolean} boolean - Whether the scissor test should be enabled or not.
	 */ setScissorTest(boolean) {
        const state = this.state;
        state.setScissorTest(boolean);
    }
    /**
	 * Returns the clear color and alpha into a single
	 * color object.
	 *
	 * @return {Color4} The clear color.
	 */ getClearColor() {
        const clearColor = super.getClearColor();
        // Since the canvas is always created with alpha: true,
        // WebGL must always premultiply the clear color.
        clearColor.r *= clearColor.a;
        clearColor.g *= clearColor.a;
        clearColor.b *= clearColor.a;
        return clearColor;
    }
    /**
	 * Performs a clear operation.
	 *
	 * @param {boolean} color - Whether the color buffer should be cleared or not.
	 * @param {boolean} depth - Whether the depth buffer should be cleared or not.
	 * @param {boolean} stencil - Whether the stencil buffer should be cleared or not.
	 * @param {?Object} [descriptor=null] - The render context of the current set render target.
	 * @param {boolean} [setFrameBuffer=true] - Controls whether the intermediate framebuffer should be set or not.
	 * @param {boolean} [resolveRenderTarget=true] - Controls whether an active render target should be resolved
	 * or not. Only relevant for explicit clears.
	 */ clear(color, depth, stencil, descriptor = null, setFrameBuffer = true, resolveRenderTarget = true) {
        const { gl: gl, renderer: renderer } = this;
        if (descriptor === null) {
            const clearColor = this.getClearColor();
            descriptor = {
                textures: null,
                clearColorValue: clearColor
            };
        }
        //
        let clear = 0;
        if (color) clear |= gl.COLOR_BUFFER_BIT;
        if (depth) clear |= gl.DEPTH_BUFFER_BIT;
        if (stencil) clear |= gl.STENCIL_BUFFER_BIT;
        if (clear !== 0) {
            let clearColor;
            if (descriptor.clearColorValue) clearColor = descriptor.clearColorValue;
            else clearColor = this.getClearColor();
            const clearDepth = renderer.getClearDepth();
            const clearStencil = renderer.getClearStencil();
            if (depth) this.state.setDepthMask(true);
            if (descriptor.textures === null) {
                gl.clearColor(clearColor.r, clearColor.g, clearColor.b, clearColor.a);
                gl.clear(clear);
            } else {
                if (setFrameBuffer) this._setFramebuffer(descriptor);
                if (color) {
                    for(let i = 0; i < descriptor.textures.length; i++)if (i === 0) gl.clearBufferfv(gl.COLOR, i, [
                        clearColor.r,
                        clearColor.g,
                        clearColor.b,
                        clearColor.a
                    ]);
                    else gl.clearBufferfv(gl.COLOR, i, [
                        0,
                        0,
                        0,
                        1
                    ]);
                }
                if (depth && stencil) gl.clearBufferfi(gl.DEPTH_STENCIL, 0, clearDepth, clearStencil);
                else if (depth) gl.clearBufferfv(gl.DEPTH, 0, [
                    clearDepth
                ]);
                else if (stencil) gl.clearBufferiv(gl.STENCIL, 0, [
                    clearStencil
                ]);
                if (setFrameBuffer && resolveRenderTarget) this._resolveRenderTarget(descriptor);
            }
        }
    }
    /**
	 * This method is executed at the beginning of a compute call and
	 * prepares the state for upcoming compute tasks.
	 *
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ beginCompute(computeGroup) {
        const { state: state, gl: gl } = this;
        //
        state.bindFramebuffer(gl.FRAMEBUFFER, null);
        this.initTimestampQuery((0, $329ek.TimestampQuery).COMPUTE, this.getTimestampUID(computeGroup));
    }
    /**
	 * Executes a compute command for the given compute node.
	 *
	 * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
	 * @param {Node} computeNode - The compute node.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @param {ComputePipeline} pipeline - The compute pipeline.
	 * @param {?number} [count=null] - The count of compute invocations. If `null`, the count is determined by the compute node.
	 */ compute(computeGroup, computeNode, bindings, pipeline, count = null) {
        const { state: state, gl: gl } = this;
        if (this.discard === false) {
            // required here to handle async behaviour of render.compute()
            state.enable(gl.RASTERIZER_DISCARD);
            this.discard = true;
        }
        const { programGPU: programGPU, transformBuffers: transformBuffers, attributes: attributes } = this.get(pipeline);
        const vaoKey = this._getVaoKey(attributes);
        const vaoGPU = this.vaoCache[vaoKey];
        if (vaoGPU === undefined) this.vaoCache[vaoKey] = this._createVao(attributes);
        else state.setVertexState(vaoGPU);
        state.useProgram(programGPU);
        this._bindUniforms(bindings);
        const transformFeedbackGPU = this._getTransformFeedback(transformBuffers);
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, transformFeedbackGPU);
        gl.beginTransformFeedback(gl.POINTS);
        count = count !== null ? count : computeNode.count;
        if (Array.isArray(count)) {
            (0, $329ek.warnOnce)('WebGLBackend.compute(): The count parameter must be a single number, not an array.');
            count = count[0];
        } else if (count && typeof count === 'object' && count.isIndirectStorageBufferAttribute) {
            (0, $329ek.warnOnce)('WebGLBackend.compute(): The count parameter must be a single number, not IndirectStorageBufferAttribute');
            count = computeNode.count;
        }
        if (attributes[0].isStorageInstancedBufferAttribute) gl.drawArraysInstanced(gl.POINTS, 0, 1, count);
        else gl.drawArrays(gl.POINTS, 0, count);
        gl.endTransformFeedback();
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
        // switch active buffers
        for(let i = 0; i < transformBuffers.length; i++){
            const dualAttributeData = transformBuffers[i];
            if (dualAttributeData.pbo && this.has(dualAttributeData.pbo)) this.textureUtils.copyBufferToTexture(dualAttributeData.transformBuffer, dualAttributeData.pbo);
            dualAttributeData.switchBuffers();
        }
    }
    /**
	 * This method is executed at the end of a compute call and
	 * finalizes work after compute tasks.
	 *
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ finishCompute(computeGroup) {
        const { state: state, gl: gl } = this;
        this.discard = false;
        state.disable(gl.RASTERIZER_DISCARD);
        this.prepareTimestampBuffer((0, $329ek.TimestampQuery).COMPUTE, this.getTimestampUID(computeGroup));
        if (this._currentContext) this._setFramebuffer(this._currentContext);
    }
    /**
	 * Internal to determine if the current render target is a render target array with depth 2D array texture.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {boolean} Whether the render target is a render target array with depth 2D array texture.
	 *
	 * @private
	 */ _isRenderCameraDepthArray(renderContext) {
        return renderContext.depthTexture && renderContext.depthTexture.isArrayTexture && renderContext.camera.isArrayCamera;
    }
    /**
	 * Executes a draw command for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object to draw.
	 * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
	 */ draw(renderObject /*, info*/ ) {
        const { object: object, pipeline: pipeline, material: material, context: context, hardwareClippingPlanes: hardwareClippingPlanes } = renderObject;
        const { programGPU: programGPU } = this.get(pipeline);
        const { gl: gl, state: state } = this;
        const contextData = this.get(context);
        const drawParams = renderObject.getDrawParameters();
        if (drawParams === null) return;
        //
        this._bindUniforms(renderObject.getBindings());
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        state.setMaterial(material, frontFaceCW, hardwareClippingPlanes);
        if (context.textures !== null && context.textures.length > 1) state.setMRTBlending(context.textures);
        state.useProgram(programGPU);
        // vertex state
        const attributes = renderObject.getAttributes();
        const attributesData = this.get(attributes);
        let vaoGPU = attributesData.vaoGPU;
        if (vaoGPU === undefined) {
            const vaoKey = this._getVaoKey(attributes);
            vaoGPU = this.vaoCache[vaoKey];
            if (vaoGPU === undefined) {
                vaoGPU = this._createVao(attributes);
                this.vaoCache[vaoKey] = vaoGPU;
                attributesData.vaoGPU = vaoGPU;
            }
        }
        const index = renderObject.getIndex();
        const indexGPU = index !== null ? this.get(index).bufferGPU : null;
        state.setVertexState(vaoGPU, indexGPU);
        //
        const lastObject = contextData.lastOcclusionObject;
        if (lastObject !== object && lastObject !== undefined) {
            if (lastObject !== null && lastObject.occlusionTest === true) {
                gl.endQuery(gl.ANY_SAMPLES_PASSED);
                contextData.occlusionQueryIndex++;
            }
            if (object.occlusionTest === true) {
                const query = gl.createQuery();
                gl.beginQuery(gl.ANY_SAMPLES_PASSED, query);
                contextData.occlusionQueries[contextData.occlusionQueryIndex] = query;
                contextData.occlusionQueryObjects[contextData.occlusionQueryIndex] = object;
            }
            contextData.lastOcclusionObject = object;
        }
        //
        const renderer = this.bufferRenderer;
        if (object.isPoints) renderer.mode = gl.POINTS;
        else if (object.isLineSegments) renderer.mode = gl.LINES;
        else if (object.isLine) renderer.mode = gl.LINE_STRIP;
        else if (object.isLineLoop) renderer.mode = gl.LINE_LOOP;
        else if (material.wireframe === true) {
            state.setLineWidth(material.wireframeLinewidth * this.renderer.getPixelRatio());
            renderer.mode = gl.LINES;
        } else renderer.mode = gl.TRIANGLES;
        //
        const { vertexCount: vertexCount, instanceCount: instanceCount } = drawParams;
        let { firstVertex: firstVertex } = drawParams;
        renderer.object = object;
        if (index !== null) {
            firstVertex *= index.array.BYTES_PER_ELEMENT;
            const indexData = this.get(index);
            renderer.index = index.count;
            renderer.type = indexData.type;
        } else renderer.index = 0;
        const draw = ()=>{
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) {
                    // @deprecated, r174
                    (0, $329ek.warnOnce)('WebGLBackend: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.');
                    renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                } else if (!this.hasFeature('WEBGL_multi_draw')) (0, $329ek.warnOnce)('WebGLBackend: WEBGL_multi_draw not supported.');
                else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (instanceCount > 1) renderer.renderInstances(firstVertex, vertexCount, instanceCount);
            else renderer.render(firstVertex, vertexCount);
        };
        if (renderObject.camera.isArrayCamera === true && renderObject.camera.cameras.length > 0 && renderObject.camera.isMultiViewCamera === false) {
            const cameraData = this.get(renderObject.camera);
            const cameras = renderObject.camera.cameras;
            const cameraIndex = renderObject.getBindingGroup('cameraIndex').bindings[0];
            if (cameraData.indexesGPU === undefined || cameraData.indexesGPU.length !== cameras.length) {
                const data = new Uint32Array([
                    0,
                    0,
                    0,
                    0
                ]);
                const indexesGPU = [];
                for(let i = 0, len = cameras.length; i < len; i++){
                    const bufferGPU = gl.createBuffer();
                    data[0] = i;
                    gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
                    gl.bufferData(gl.UNIFORM_BUFFER, data, gl.STATIC_DRAW);
                    indexesGPU.push(bufferGPU);
                }
                cameraData.indexesGPU = indexesGPU; // TODO: Create a global library for this
            }
            const cameraIndexData = this.get(cameraIndex);
            const pixelRatio = this.renderer.getPixelRatio();
            const renderTarget = this._currentContext.renderTarget;
            const isRenderCameraDepthArray = this._isRenderCameraDepthArray(this._currentContext);
            const prevActiveCubeFace = this._currentContext.activeCubeFace;
            if (isRenderCameraDepthArray) {
                // Clear the depth texture
                const textureData = this.get(renderTarget.depthTexture);
                if (textureData.clearedRenderId !== this.renderer._nodes.nodeFrame.renderId) {
                    textureData.clearedRenderId = this.renderer._nodes.nodeFrame.renderId;
                    const { stencilBuffer: stencilBuffer } = renderTarget;
                    for(let i = 0, len = cameras.length; i < len; i++){
                        this.renderer._activeCubeFace = i;
                        this._currentContext.activeCubeFace = i;
                        this._setFramebuffer(this._currentContext);
                        this.clear(false, true, stencilBuffer, this._currentContext, false, false);
                    }
                    this.renderer._activeCubeFace = prevActiveCubeFace;
                    this._currentContext.activeCubeFace = prevActiveCubeFace;
                }
            }
            for(let i = 0, len = cameras.length; i < len; i++){
                const subCamera = cameras[i];
                if (object.layers.test(subCamera.layers)) {
                    if (isRenderCameraDepthArray) {
                        // Update the active layer
                        this.renderer._activeCubeFace = i;
                        this._currentContext.activeCubeFace = i;
                        this._setFramebuffer(this._currentContext);
                    }
                    const vp = subCamera.viewport;
                    if (vp !== undefined) {
                        const x = vp.x * pixelRatio;
                        const y = vp.y * pixelRatio;
                        const width = vp.width * pixelRatio;
                        const height = vp.height * pixelRatio;
                        state.viewport(Math.floor(x), Math.floor(renderObject.context.height - height - y), Math.floor(width), Math.floor(height));
                    }
                    state.bindBufferBase(gl.UNIFORM_BUFFER, cameraIndexData.index, cameraData.indexesGPU[i]);
                    draw();
                }
                this._currentContext.activeCubeFace = prevActiveCubeFace;
                this.renderer._activeCubeFace = prevActiveCubeFace;
            }
        } else draw();
    }
    /**
	 * Explain why always null is returned.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the render pipeline requires an update or not.
	 */ needsRenderUpdate() {
        return false;
    }
    /**
	 * Explain why no cache key is computed.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {string} The cache key.
	 */ getRenderCacheKey() {
        return '';
    }
    // textures
    /**
	 * Creates a default texture for the given texture that can be used
	 * as a placeholder until the actual texture is ready for usage.
	 *
	 * @param {Texture} texture - The texture to create a default texture for.
	 */ createDefaultTexture(texture) {
        this.textureUtils.createDefaultTexture(texture);
    }
    /**
	 * Defines a texture on the GPU for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ createTexture(texture, options) {
        this.textureUtils.createTexture(texture, options);
    }
    /**
	 * Uploads the updated texture data to the GPU.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ updateTexture(texture, options) {
        this.textureUtils.updateTexture(texture, options);
    }
    /**
	 * Generates mipmaps for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 */ generateMipmaps(texture) {
        this.textureUtils.generateMipmaps(texture);
    }
    /**
	 * Destroys the GPU data for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
	 */ destroyTexture(texture, isDefaultTexture = false) {
        this.textureUtils.destroyTexture(texture, isDefaultTexture);
    }
    /**
	 * Returns texture data as a typed array.
	 *
	 * @async
	 * @param {Texture} texture - The texture to copy.
	 * @param {number} x - The x coordinate of the copy origin.
	 * @param {number} y - The y coordinate of the copy origin.
	 * @param {number} width - The width of the copy.
	 * @param {number} height - The height of the copy.
	 * @param {number} faceIndex - The face index.
	 * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
	 */ async copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        return this.textureUtils.copyTextureToBuffer(texture, x, y, width, height, faceIndex);
    }
    /**
	 * This method does nothing since WebGL 2 has no concept of samplers.
	 *
	 * @param {Texture} texture - The texture to update the sampler for.
	 * @return {string} The current sampler key.
	 */ updateSampler() {
        return '';
    }
    // node builder
    /**
	 * Returns a node builder for the given render object.
	 *
	 * @param {RenderObject} object - The render object.
	 * @param {Renderer} renderer - The renderer.
	 * @return {GLSLNodeBuilder} The node builder.
	 */ createNodeBuilder(object, renderer) {
        return new $d89c9137a3d237c2$var$GLSLNodeBuilder(object, renderer);
    }
    // program
    /**
	 * Creates a shader program from the given programmable stage.
	 *
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ createProgram(program) {
        const gl = this.gl;
        const { stage: stage, code: code } = program;
        const shader = stage === 'fragment' ? gl.createShader(gl.FRAGMENT_SHADER) : gl.createShader(gl.VERTEX_SHADER);
        gl.shaderSource(shader, code);
        gl.compileShader(shader);
        this.set(program, {
            shaderGPU: shader
        });
    }
    /**
	 * Destroys the shader program of the given programmable stage.
	 *
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ destroyProgram(program) {
        this.delete(program);
    }
    /**
	 * Creates a render pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
	 */ createRenderPipeline(renderObject, promises) {
        const gl = this.gl;
        const pipeline = renderObject.pipeline;
        // Program
        const { fragmentProgram: fragmentProgram, vertexProgram: vertexProgram } = pipeline;
        const programGPU = gl.createProgram();
        const fragmentShader = this.get(fragmentProgram).shaderGPU;
        const vertexShader = this.get(vertexProgram).shaderGPU;
        gl.attachShader(programGPU, fragmentShader);
        gl.attachShader(programGPU, vertexShader);
        gl.linkProgram(programGPU);
        this.set(pipeline, {
            programGPU: programGPU,
            fragmentShader: fragmentShader,
            vertexShader: vertexShader
        });
        if (promises !== null && this.parallel) {
            const p = new Promise((resolve /*, reject*/ )=>{
                const parallel = this.parallel;
                const checkStatus = ()=>{
                    if (gl.getProgramParameter(programGPU, parallel.COMPLETION_STATUS_KHR)) {
                        this._completeCompile(renderObject, pipeline);
                        resolve();
                    } else requestAnimationFrame(checkStatus);
                };
                checkStatus();
            });
            promises.push(p);
            return;
        }
        this._completeCompile(renderObject, pipeline);
    }
    /**
	 * Formats the source code of error messages.
	 *
	 * @private
	 * @param {string} string - The code.
	 * @param {number} errorLine - The error line.
	 * @return {string} The formatted code.
	 */ _handleSource(string, errorLine) {
        const lines = string.split('\n');
        const lines2 = [];
        const from = Math.max(errorLine - 6, 0);
        const to = Math.min(errorLine + 6, lines.length);
        for(let i = from; i < to; i++){
            const line = i + 1;
            lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
        }
        return lines2.join('\n');
    }
    /**
	 * Gets the shader compilation errors from the info log.
	 *
	 * @private
	 * @param {WebGL2RenderingContext} gl - The rendering context.
	 * @param {WebGLShader} shader - The WebGL shader object.
	 * @param {string} type - The shader type.
	 * @return {string} The shader errors.
	 */ _getShaderErrors(gl, shader, type) {
        const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
        const shaderInfoLog = gl.getShaderInfoLog(shader) || '';
        const errors = shaderInfoLog.trim();
        if (status && errors === '') return '';
        const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
        if (errorMatches) {
            const errorLine = parseInt(errorMatches[1]);
            return type.toUpperCase() + '\n\n' + errors + '\n\n' + this._handleSource(gl.getShaderSource(shader), errorLine);
        } else return errors;
    }
    /**
	 * Logs shader compilation errors.
	 *
	 * @private
	 * @param {WebGLProgram} programGPU - The WebGL program.
	 * @param {WebGLShader} glFragmentShader - The fragment shader as a native WebGL shader object.
	 * @param {WebGLShader} glVertexShader - The vertex shader as a native WebGL shader object.
	 */ _logProgramError(programGPU, glFragmentShader, glVertexShader) {
        if (this.renderer.debug.checkShaderErrors) {
            const gl = this.gl;
            const programInfoLog = gl.getProgramInfoLog(programGPU) || '';
            const programLog = programInfoLog.trim();
            if (gl.getProgramParameter(programGPU, gl.LINK_STATUS) === false) {
                if (typeof this.renderer.debug.onShaderError === 'function') this.renderer.debug.onShaderError(gl, programGPU, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = this._getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = this._getShaderErrors(gl, glFragmentShader, 'fragment');
                    (0, $329ek.error)('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(programGPU, gl.VALIDATE_STATUS) + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') (0, $329ek.warn)('WebGLProgram: Program Info Log:', programLog);
        }
    }
    /**
	 * Completes the shader program setup for the given render object.
	 *
	 * @private
	 * @param {RenderObject} renderObject - The render object.
	 * @param {RenderPipeline} pipeline - The render pipeline.
	 */ _completeCompile(renderObject, pipeline) {
        const { state: state, gl: gl } = this;
        const pipelineData = this.get(pipeline);
        const { programGPU: programGPU, fragmentShader: fragmentShader, vertexShader: vertexShader } = pipelineData;
        if (gl.getProgramParameter(programGPU, gl.LINK_STATUS) === false) this._logProgramError(programGPU, fragmentShader, vertexShader);
        state.useProgram(programGPU);
        // Bindings
        const bindings = renderObject.getBindings();
        this._setupBindings(bindings, programGPU);
        //
        this.set(pipeline, {
            programGPU: programGPU
        });
    }
    /**
	 * Creates a compute pipeline for the given compute node.
	 *
	 * @param {ComputePipeline} computePipeline - The compute pipeline.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 */ createComputePipeline(computePipeline, bindings) {
        const { state: state, gl: gl } = this;
        // Program
        const fragmentProgram = {
            stage: 'fragment',
            code: '#version 300 es\nprecision highp float;\nvoid main() {}'
        };
        this.createProgram(fragmentProgram);
        const { computeProgram: computeProgram } = computePipeline;
        const programGPU = gl.createProgram();
        const fragmentShader = this.get(fragmentProgram).shaderGPU;
        const vertexShader = this.get(computeProgram).shaderGPU;
        const transforms = computeProgram.transforms;
        const transformVaryingNames = [];
        const transformAttributeNodes = [];
        for(let i = 0; i < transforms.length; i++){
            const transform = transforms[i];
            transformVaryingNames.push(transform.varyingName);
            transformAttributeNodes.push(transform.attributeNode);
        }
        gl.attachShader(programGPU, fragmentShader);
        gl.attachShader(programGPU, vertexShader);
        gl.transformFeedbackVaryings(programGPU, transformVaryingNames, gl.SEPARATE_ATTRIBS);
        gl.linkProgram(programGPU);
        if (gl.getProgramParameter(programGPU, gl.LINK_STATUS) === false) this._logProgramError(programGPU, fragmentShader, vertexShader);
        state.useProgram(programGPU);
        // Bindings
        this._setupBindings(bindings, programGPU);
        const attributeNodes = computeProgram.attributes;
        const attributes = [];
        const transformBuffers = [];
        for(let i = 0; i < attributeNodes.length; i++){
            const attribute = attributeNodes[i].node.attribute;
            attributes.push(attribute);
            if (!this.has(attribute)) this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
        }
        for(let i = 0; i < transformAttributeNodes.length; i++){
            const attribute = transformAttributeNodes[i].attribute;
            if (!this.has(attribute)) this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
            const attributeData = this.get(attribute);
            transformBuffers.push(attributeData);
        }
        //
        this.set(computePipeline, {
            programGPU: programGPU,
            transformBuffers: transformBuffers,
            attributes: attributes
        });
    }
    /**
	 * Creates bindings from the given bind group definition.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ createBindings(bindGroup, bindings /*, cacheIndex, version*/ ) {
        if (this._knownBindings.has(bindings) === false) {
            this._knownBindings.add(bindings);
            let uniformBuffers = 0;
            let textures = 0;
            for (const bindGroup of bindings){
                this.set(bindGroup, {
                    textures: textures,
                    uniformBuffers: uniformBuffers
                });
                for (const binding of bindGroup.bindings){
                    if (binding.isUniformBuffer) uniformBuffers++;
                    if (binding.isSampledTexture) textures++;
                }
            }
        }
        this.updateBindings(bindGroup, bindings);
    }
    /**
	 * Updates the given bind group definition.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ updateBindings(bindGroup /*, bindings, cacheIndex, version*/ ) {
        const { gl: gl } = this;
        const bindGroupData = this.get(bindGroup);
        let i = bindGroupData.uniformBuffers;
        let t = bindGroupData.textures;
        for (const binding of bindGroup.bindings){
            const map = this.get(binding);
            if (binding.isUniformsGroup || binding.isUniformBuffer) {
                const array = binding.buffer;
                let { bufferGPU: bufferGPU } = this.get(array);
                if (bufferGPU === undefined) {
                    // create
                    bufferGPU = gl.createBuffer();
                    gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
                    gl.bufferData(gl.UNIFORM_BUFFER, array.byteLength, gl.DYNAMIC_DRAW);
                    this.set(array, {
                        bufferGPU: bufferGPU
                    });
                } else gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
                // update
                const updateRanges = binding.updateRanges;
                gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
                if (updateRanges.length === 0) gl.bufferData(gl.UNIFORM_BUFFER, array, gl.DYNAMIC_DRAW);
                else {
                    const isTyped = (0, $329ek.isTypedArray)(array);
                    const byteOffsetFactor = isTyped ? 1 : array.BYTES_PER_ELEMENT;
                    for(let i = 0, l = updateRanges.length; i < l; i++){
                        const range = updateRanges[i];
                        const dataOffset = range.start * byteOffsetFactor;
                        const size = range.count * byteOffsetFactor;
                        const bufferOffset = dataOffset * (isTyped ? array.BYTES_PER_ELEMENT : 1); // bufferOffset is always in bytes
                        gl.bufferSubData(gl.UNIFORM_BUFFER, bufferOffset, array, dataOffset, size);
                    }
                }
                map.index = i++;
                map.bufferGPU = bufferGPU;
                this.set(binding, map);
            } else if (binding.isSampledTexture) {
                const { textureGPU: textureGPU, glTextureType: glTextureType } = this.get(binding.texture);
                map.index = t++;
                map.textureGPU = textureGPU;
                map.glTextureType = glTextureType;
                this.set(binding, map);
            }
        }
    }
    /**
	 * Updates a buffer binding.
	 *
	 *  @param {Buffer} binding - The buffer binding to update.
	 */ updateBinding(binding) {
        const gl = this.gl;
        if (binding.isUniformsGroup || binding.isUniformBuffer) {
            const bindingData = this.get(binding);
            const bufferGPU = bindingData.bufferGPU;
            const array = binding.buffer;
            const updateRanges = binding.updateRanges;
            gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
            if (updateRanges.length === 0) gl.bufferData(gl.UNIFORM_BUFFER, array, gl.DYNAMIC_DRAW);
            else {
                const isTyped = (0, $329ek.isTypedArray)(array);
                const byteOffsetFactor = isTyped ? 1 : array.BYTES_PER_ELEMENT;
                for(let i = 0, l = updateRanges.length; i < l; i++){
                    const range = updateRanges[i];
                    const dataOffset = range.start * byteOffsetFactor;
                    const size = range.count * byteOffsetFactor;
                    const bufferOffset = dataOffset * (isTyped ? array.BYTES_PER_ELEMENT : 1); // bufferOffset is always in bytes
                    gl.bufferSubData(gl.UNIFORM_BUFFER, bufferOffset, array, dataOffset, size);
                }
            }
        }
    }
    // attributes
    /**
	 * Creates the GPU buffer of an indexed shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The indexed buffer attribute.
	 */ createIndexAttribute(attribute) {
        const gl = this.gl;
        this.attributeUtils.createAttribute(attribute, gl.ELEMENT_ARRAY_BUFFER);
    }
    /**
	 * Creates the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createAttribute(attribute) {
        if (this.has(attribute)) return;
        const gl = this.gl;
        this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
    }
    /**
	 * Creates the GPU buffer of a storage attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createStorageAttribute(attribute) {
        if (this.has(attribute)) return;
        const gl = this.gl;
        this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
    }
    /**
	 * Updates the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute to update.
	 */ updateAttribute(attribute) {
        this.attributeUtils.updateAttribute(attribute);
    }
    /**
	 * Destroys the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute to destroy.
	 */ destroyAttribute(attribute) {
        this.attributeUtils.destroyAttribute(attribute);
    }
    /**
	 * Checks if the given feature is supported  by the backend.
	 *
	 * @param {string} name - The feature's name.
	 * @return {boolean} Whether the feature is supported or not.
	 */ hasFeature(name) {
        const keysMatching = Object.keys($d89c9137a3d237c2$var$GLFeatureName).filter((key)=>$d89c9137a3d237c2$var$GLFeatureName[key] === name);
        const extensions = this.extensions;
        for(let i = 0; i < keysMatching.length; i++){
            if (extensions.has(keysMatching[i])) return true;
        }
        return false;
    }
    /**
	 * Returns the maximum anisotropy texture filtering value.
	 *
	 * @return {number} The maximum anisotropy texture filtering value.
	 */ getMaxAnisotropy() {
        return this.capabilities.getMaxAnisotropy();
    }
    /**
	 * Copies data of the given source texture to the given destination texture.
	 *
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
	 * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
	 * @param {number} [srcLevel=0] - The source mip level to copy from.
	 * @param {number} [dstLevel=0] - The destination mip level to copy to.
	 */ copyTextureToTexture(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = 0) {
        this.textureUtils.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, srcLevel, dstLevel);
    }
    /**
	 * Copies the current bound framebuffer to the given texture.
	 *
	 * @param {Texture} texture - The destination texture.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
	 */ copyFramebufferToTexture(texture, renderContext, rectangle) {
        this.textureUtils.copyFramebufferToTexture(texture, renderContext, rectangle);
    }
    /**
	 * Configures the active framebuffer from the given render context.
	 *
	 * @private
	 * @param {RenderContext} descriptor - The render context.
	 */ _setFramebuffer(descriptor) {
        const { gl: gl, state: state } = this;
        let currentFrameBuffer = null;
        if (descriptor.textures !== null) {
            const renderTarget = descriptor.renderTarget;
            const renderTargetContextData = this.get(renderTarget);
            const { samples: samples, depthBuffer: depthBuffer, stencilBuffer: stencilBuffer } = renderTarget;
            const isCube = renderTarget.isWebGLCubeRenderTarget === true;
            const isRenderTarget3D = renderTarget.isRenderTarget3D === true;
            const isRenderTargetArray = renderTarget.depth > 1;
            const isXRRenderTarget = renderTarget.isXRRenderTarget === true;
            const _hasExternalTextures = isXRRenderTarget === true && renderTarget._hasExternalTextures === true;
            let msaaFb = renderTargetContextData.msaaFrameBuffer;
            let depthRenderbuffer = renderTargetContextData.depthRenderbuffer;
            const multisampledRTTExt = this.extensions.get('WEBGL_multisampled_render_to_texture');
            const multiviewExt = this.extensions.get('OVR_multiview2');
            const useMultisampledRTT = this._useMultisampledExtension(renderTarget);
            const cacheKey = $d89c9137a3d237c2$var$getCacheKey(descriptor);
            let fb;
            if (isCube) {
                renderTargetContextData.cubeFramebuffers || (renderTargetContextData.cubeFramebuffers = {});
                fb = renderTargetContextData.cubeFramebuffers[cacheKey];
            } else if (isXRRenderTarget && _hasExternalTextures === false) fb = this._xrFramebuffer;
            else {
                renderTargetContextData.framebuffers || (renderTargetContextData.framebuffers = {});
                fb = renderTargetContextData.framebuffers[cacheKey];
            }
            if (fb === undefined) {
                fb = gl.createFramebuffer();
                state.bindFramebuffer(gl.FRAMEBUFFER, fb);
                const textures = descriptor.textures;
                const depthInvalidationArray = [];
                if (isCube) {
                    renderTargetContextData.cubeFramebuffers[cacheKey] = fb;
                    const { textureGPU: textureGPU } = this.get(textures[0]);
                    const cubeFace = this.renderer._activeCubeFace;
                    const mipLevel = this.renderer._activeMipmapLevel;
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_CUBE_MAP_POSITIVE_X + cubeFace, textureGPU, mipLevel);
                } else {
                    renderTargetContextData.framebuffers[cacheKey] = fb;
                    for(let i = 0; i < textures.length; i++){
                        const texture = textures[i];
                        const textureData = this.get(texture);
                        textureData.renderTarget = descriptor.renderTarget;
                        textureData.cacheKey = cacheKey; // required for copyTextureToTexture()
                        const attachment = gl.COLOR_ATTACHMENT0 + i;
                        if (renderTarget.multiview) multiviewExt.framebufferTextureMultisampleMultiviewOVR(gl.FRAMEBUFFER, attachment, textureData.textureGPU, 0, samples, 0, 2);
                        else if (isRenderTarget3D || isRenderTargetArray) {
                            const layer = this.renderer._activeCubeFace;
                            const mipLevel = this.renderer._activeMipmapLevel;
                            gl.framebufferTextureLayer(gl.FRAMEBUFFER, attachment, textureData.textureGPU, mipLevel, layer);
                        } else if (useMultisampledRTT) multisampledRTTExt.framebufferTexture2DMultisampleEXT(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, textureData.textureGPU, 0, samples);
                        else {
                            const mipLevel = this.renderer._activeMipmapLevel;
                            gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, textureData.textureGPU, mipLevel);
                        }
                    }
                }
                const depthStyle = stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                if (renderTarget._autoAllocateDepthBuffer === true) {
                    const renderbuffer = gl.createRenderbuffer();
                    this.textureUtils.setupRenderBufferStorage(renderbuffer, descriptor, 0, useMultisampledRTT);
                    renderTargetContextData.xrDepthRenderbuffer = renderbuffer;
                    depthInvalidationArray.push(stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT);
                    gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
                    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, depthStyle, gl.RENDERBUFFER, renderbuffer);
                } else if (descriptor.depthTexture !== null) {
                    depthInvalidationArray.push(stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT);
                    const textureData = this.get(descriptor.depthTexture);
                    textureData.renderTarget = descriptor.renderTarget;
                    textureData.cacheKey = cacheKey; // required for copyTextureToTexture()
                    if (renderTarget.multiview) multiviewExt.framebufferTextureMultisampleMultiviewOVR(gl.FRAMEBUFFER, depthStyle, textureData.textureGPU, 0, samples, 0, 2);
                    else if (_hasExternalTextures && useMultisampledRTT) multisampledRTTExt.framebufferTexture2DMultisampleEXT(gl.FRAMEBUFFER, depthStyle, gl.TEXTURE_2D, textureData.textureGPU, 0, samples);
                    else {
                        if (descriptor.depthTexture.isArrayTexture) {
                            const layer = this.renderer._activeCubeFace;
                            gl.framebufferTextureLayer(gl.FRAMEBUFFER, depthStyle, textureData.textureGPU, 0, layer);
                        } else if (descriptor.depthTexture.isCubeTexture) {
                            const cubeFace = this.renderer._activeCubeFace;
                            gl.framebufferTexture2D(gl.FRAMEBUFFER, depthStyle, gl.TEXTURE_CUBE_MAP_POSITIVE_X + cubeFace, textureData.textureGPU, 0);
                        } else gl.framebufferTexture2D(gl.FRAMEBUFFER, depthStyle, gl.TEXTURE_2D, textureData.textureGPU, 0);
                    }
                }
                renderTargetContextData.depthInvalidationArray = depthInvalidationArray;
            } else {
                const isRenderCameraDepthArray = this._isRenderCameraDepthArray(descriptor);
                if (isRenderCameraDepthArray) {
                    state.bindFramebuffer(gl.FRAMEBUFFER, fb);
                    const layer = this.renderer._activeCubeFace;
                    const depthData = this.get(descriptor.depthTexture);
                    const depthStyle = stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                    gl.framebufferTextureLayer(gl.FRAMEBUFFER, depthStyle, depthData.textureGPU, 0, layer);
                }
                // rebind external XR textures
                if ((isXRRenderTarget || useMultisampledRTT || renderTarget.multiview) && renderTarget._isOpaqueFramebuffer !== true) {
                    state.bindFramebuffer(gl.FRAMEBUFFER, fb);
                    // rebind color
                    const textureData = this.get(descriptor.textures[0]);
                    if (renderTarget.multiview) multiviewExt.framebufferTextureMultisampleMultiviewOVR(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, textureData.textureGPU, 0, samples, 0, 2);
                    else if (useMultisampledRTT) multisampledRTTExt.framebufferTexture2DMultisampleEXT(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, textureData.textureGPU, 0, samples);
                    else gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, textureData.textureGPU, 0);
                    // rebind depth
                    const depthStyle = stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                    if (renderTarget._autoAllocateDepthBuffer === true) {
                        const renderbuffer = renderTargetContextData.xrDepthRenderbuffer;
                        gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
                        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, depthStyle, gl.RENDERBUFFER, renderbuffer);
                    } else {
                        const textureData = this.get(descriptor.depthTexture);
                        if (renderTarget.multiview) multiviewExt.framebufferTextureMultisampleMultiviewOVR(gl.FRAMEBUFFER, depthStyle, textureData.textureGPU, 0, samples, 0, 2);
                        else if (useMultisampledRTT) multisampledRTTExt.framebufferTexture2DMultisampleEXT(gl.FRAMEBUFFER, depthStyle, gl.TEXTURE_2D, textureData.textureGPU, 0, samples);
                        else gl.framebufferTexture2D(gl.FRAMEBUFFER, depthStyle, gl.TEXTURE_2D, textureData.textureGPU, 0);
                    }
                }
            }
            if (samples > 0 && useMultisampledRTT === false && !renderTarget.multiview) {
                if (msaaFb === undefined) {
                    const invalidationArray = [];
                    msaaFb = gl.createFramebuffer();
                    state.bindFramebuffer(gl.FRAMEBUFFER, msaaFb);
                    const msaaRenderbuffers = [];
                    const textures = descriptor.textures;
                    for(let i = 0; i < textures.length; i++){
                        msaaRenderbuffers[i] = gl.createRenderbuffer();
                        gl.bindRenderbuffer(gl.RENDERBUFFER, msaaRenderbuffers[i]);
                        invalidationArray.push(gl.COLOR_ATTACHMENT0 + i);
                        const texture = descriptor.textures[i];
                        const textureData = this.get(texture);
                        gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, textureData.glInternalFormat, descriptor.width, descriptor.height);
                        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.RENDERBUFFER, msaaRenderbuffers[i]);
                    }
                    gl.bindRenderbuffer(gl.RENDERBUFFER, null);
                    renderTargetContextData.msaaFrameBuffer = msaaFb;
                    renderTargetContextData.msaaRenderbuffers = msaaRenderbuffers;
                    if (depthBuffer && depthRenderbuffer === undefined) {
                        depthRenderbuffer = gl.createRenderbuffer();
                        this.textureUtils.setupRenderBufferStorage(depthRenderbuffer, descriptor, samples);
                        renderTargetContextData.depthRenderbuffer = depthRenderbuffer;
                        const depthStyle = stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                        invalidationArray.push(depthStyle);
                    }
                    renderTargetContextData.invalidationArray = invalidationArray;
                }
                currentFrameBuffer = renderTargetContextData.msaaFrameBuffer;
            } else currentFrameBuffer = fb;
            state.drawBuffers(descriptor, fb);
        }
        state.bindFramebuffer(gl.FRAMEBUFFER, currentFrameBuffer);
    }
    /**
	 * Computes the VAO key for the given index and attributes.
	 *
	 * @private
	 * @param {Array<BufferAttribute>} attributes - An array of buffer attributes.
	 * @return {string} The VAO key.
	 */ _getVaoKey(attributes) {
        let key = '';
        for(let i = 0; i < attributes.length; i++){
            const attributeData = this.get(attributes[i]);
            key += ':' + attributeData.id;
        }
        return key;
    }
    /**
	 * Creates a VAO from the index and attributes.
	 *
	 * @private
	 * @param {Array<BufferAttribute>} attributes - An array of buffer attributes.
	 * @return {Object} The VAO data.
	 */ _createVao(attributes) {
        const { gl: gl } = this;
        const vaoGPU = gl.createVertexArray();
        gl.bindVertexArray(vaoGPU);
        for(let i = 0; i < attributes.length; i++){
            const attribute = attributes[i];
            const attributeData = this.get(attribute);
            gl.bindBuffer(gl.ARRAY_BUFFER, attributeData.bufferGPU);
            gl.enableVertexAttribArray(i);
            let stride, offset;
            if (attribute.isInterleavedBufferAttribute === true) {
                stride = attribute.data.stride * attributeData.bytesPerElement;
                offset = attribute.offset * attributeData.bytesPerElement;
            } else {
                stride = 0;
                offset = 0;
            }
            if (attributeData.isInteger) gl.vertexAttribIPointer(i, attribute.itemSize, attributeData.type, stride, offset);
            else gl.vertexAttribPointer(i, attribute.itemSize, attributeData.type, attribute.normalized, stride, offset);
            if (attribute.isInstancedBufferAttribute && !attribute.isInterleavedBufferAttribute) gl.vertexAttribDivisor(i, attribute.meshPerAttribute);
            else if (attribute.isInterleavedBufferAttribute && attribute.data.isInstancedInterleavedBuffer) gl.vertexAttribDivisor(i, attribute.data.meshPerAttribute);
        }
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return vaoGPU;
    }
    /**
	 * Creates a transform feedback from the given transform buffers.
	 *
	 * @private
	 * @param {Array<DualAttributeData>} transformBuffers - The transform buffers.
	 * @return {WebGLTransformFeedback} The transform feedback.
	 */ _getTransformFeedback(transformBuffers) {
        let key = '';
        for(let i = 0; i < transformBuffers.length; i++)key += ':' + transformBuffers[i].id;
        let transformFeedbackGPU = this.transformFeedbackCache[key];
        if (transformFeedbackGPU !== undefined) return transformFeedbackGPU;
        const { gl: gl } = this;
        transformFeedbackGPU = gl.createTransformFeedback();
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, transformFeedbackGPU);
        for(let i = 0; i < transformBuffers.length; i++){
            const attributeData = transformBuffers[i];
            gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, i, attributeData.transformBuffer);
        }
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
        this.transformFeedbackCache[key] = transformFeedbackGPU;
        return transformFeedbackGPU;
    }
    /**
	 * Setups the given bindings.
	 *
	 * @private
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @param {WebGLProgram} programGPU - The WebGL program.
	 */ _setupBindings(bindings, programGPU) {
        const gl = this.gl;
        for (const bindGroup of bindings)for (const binding of bindGroup.bindings){
            const bindingData = this.get(binding);
            const index = bindingData.index;
            if (binding.isUniformsGroup || binding.isUniformBuffer) {
                const location = gl.getUniformBlockIndex(programGPU, binding.name);
                gl.uniformBlockBinding(programGPU, location, index);
            } else if (binding.isSampledTexture) {
                const location = gl.getUniformLocation(programGPU, binding.name);
                gl.uniform1i(location, index);
            }
        }
    }
    /**
	 * Binds the given uniforms.
	 *
	 * @private
	 * @param {Array<BindGroup>} bindings - The bindings.
	 */ _bindUniforms(bindings) {
        const { gl: gl, state: state } = this;
        for (const bindGroup of bindings)for (const binding of bindGroup.bindings){
            const bindingData = this.get(binding);
            const index = bindingData.index;
            if (binding.isUniformsGroup || binding.isUniformBuffer) // TODO USE bindBufferRange to group multiple uniform buffers
            state.bindBufferBase(gl.UNIFORM_BUFFER, index, bindingData.bufferGPU);
            else if (binding.isSampledTexture) state.bindTexture(bindingData.glTextureType, bindingData.textureGPU, gl.TEXTURE0 + index);
        }
    }
    /**
	 * The method ensures multisampled render targets are resolved.
	 *
	 * @private
	 * @param {RenderContext} renderContext - The render context.
	 */ _resolveRenderTarget(renderContext) {
        const { gl: gl, state: state } = this;
        const renderTarget = renderContext.renderTarget;
        if (renderContext.textures !== null && renderTarget) {
            const renderTargetContextData = this.get(renderTarget);
            if (renderTarget.samples > 0 && this._useMultisampledExtension(renderTarget) === false) {
                const fb = renderTargetContextData.framebuffers[renderContext.getCacheKey()];
                let mask = gl.COLOR_BUFFER_BIT;
                if (renderTarget.resolveDepthBuffer) {
                    if (renderTarget.depthBuffer) mask |= gl.DEPTH_BUFFER_BIT;
                    if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= gl.STENCIL_BUFFER_BIT;
                }
                const msaaFrameBuffer = renderTargetContextData.msaaFrameBuffer;
                const msaaRenderbuffers = renderTargetContextData.msaaRenderbuffers;
                const textures = renderContext.textures;
                const isMRT = textures.length > 1;
                state.bindFramebuffer(gl.READ_FRAMEBUFFER, msaaFrameBuffer);
                state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fb);
                if (isMRT) // blitFramebuffer() can only copy/resolve the first color attachment of a framebuffer. When using MRT,
                // the engine temporarily removes all attachments and then configures each attachment for the resolve.
                for(let i = 0; i < textures.length; i++){
                    gl.framebufferRenderbuffer(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.RENDERBUFFER, null);
                    gl.framebufferTexture2D(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.TEXTURE_2D, null, 0);
                }
                for(let i = 0; i < textures.length; i++){
                    if (isMRT) {
                        // configure attachment for resolve
                        const { textureGPU: textureGPU } = this.get(textures[i]);
                        gl.framebufferRenderbuffer(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, msaaRenderbuffers[i]);
                        gl.framebufferTexture2D(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, textureGPU, 0);
                    }
                    if (renderContext.scissor) {
                        const { x: x, y: y, width: width, height: height } = renderContext.scissorValue;
                        const viewY = renderContext.height - height - y;
                        gl.blitFramebuffer(x, viewY, x + width, viewY + height, x, viewY, x + width, viewY + height, mask, gl.NEAREST);
                    } else gl.blitFramebuffer(0, 0, renderContext.width, renderContext.height, 0, 0, renderContext.width, renderContext.height, mask, gl.NEAREST);
                }
                if (isMRT) // restore attachments
                for(let i = 0; i < textures.length; i++){
                    const { textureGPU: textureGPU } = this.get(textures[i]);
                    gl.framebufferRenderbuffer(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.RENDERBUFFER, msaaRenderbuffers[i]);
                    gl.framebufferTexture2D(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.TEXTURE_2D, textureGPU, 0);
                }
                if (this._supportsInvalidateFramebuffer === true) gl.invalidateFramebuffer(gl.READ_FRAMEBUFFER, renderTargetContextData.invalidationArray);
            } else if (renderTarget.resolveDepthBuffer === false && renderTargetContextData.framebuffers) {
                const fb = renderTargetContextData.framebuffers[renderContext.getCacheKey()];
                state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fb);
                gl.invalidateFramebuffer(gl.DRAW_FRAMEBUFFER, renderTargetContextData.depthInvalidationArray);
            }
        }
    }
    /**
	 * Returns `true` if the `WEBGL_multisampled_render_to_texture` extension
	 * should be used when MSAA is enabled.
	 *
	 * @private
	 * @param {RenderTarget} renderTarget - The render target that should be multisampled.
	 * @return {boolean} Whether to use the `WEBGL_multisampled_render_to_texture` extension for MSAA or not.
	 */ _useMultisampledExtension(renderTarget) {
        if (renderTarget.multiview === true) return true;
        return renderTarget.samples > 0 && this.extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTarget._autoAllocateDepthBuffer !== false;
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        if (this.textureUtils !== null) this.textureUtils.dispose();
        const extension = this.extensions.get('WEBGL_lose_context');
        if (extension) extension.loseContext();
        this.renderer.domElement.removeEventListener('webglcontextlost', this._onContextLost);
    }
}
const $d89c9137a3d237c2$var$GPUPrimitiveTopology = {
    PointList: 'point-list',
    LineList: 'line-list',
    LineStrip: 'line-strip',
    TriangleList: 'triangle-list',
    TriangleStrip: 'triangle-strip'
};
const $d89c9137a3d237c2$var$GPUShaderStage = typeof self !== 'undefined' ? self.GPUShaderStage : {
    VERTEX: 1,
    FRAGMENT: 2,
    COMPUTE: 4
};
const $d89c9137a3d237c2$var$GPUCompareFunction = {
    Never: 'never',
    Less: 'less',
    Equal: 'equal',
    LessEqual: 'less-equal',
    Greater: 'greater',
    NotEqual: 'not-equal',
    GreaterEqual: 'greater-equal',
    Always: 'always'
};
const $d89c9137a3d237c2$var$GPUStoreOp = {
    Store: 'store'
};
const $d89c9137a3d237c2$var$GPULoadOp = {
    Load: 'load',
    Clear: 'clear'
};
const $d89c9137a3d237c2$var$GPUFrontFace = {
    CCW: 'ccw',
    CW: 'cw'
};
const $d89c9137a3d237c2$var$GPUCullMode = {
    None: 'none',
    Back: 'back'
};
const $d89c9137a3d237c2$var$GPUIndexFormat = {
    Uint16: 'uint16',
    Uint32: 'uint32'
};
const $d89c9137a3d237c2$var$GPUTextureFormat = {
    // 8-bit formats
    R8Unorm: 'r8unorm',
    R8Snorm: 'r8snorm',
    R8Uint: 'r8uint',
    R8Sint: 'r8sint',
    // 16-bit formats
    R16Uint: 'r16uint',
    R16Sint: 'r16sint',
    R16Float: 'r16float',
    RG8Unorm: 'rg8unorm',
    RG8Snorm: 'rg8snorm',
    RG8Uint: 'rg8uint',
    RG8Sint: 'rg8sint',
    // 32-bit formats
    R32Uint: 'r32uint',
    R32Sint: 'r32sint',
    R32Float: 'r32float',
    RG16Uint: 'rg16uint',
    RG16Sint: 'rg16sint',
    RG16Float: 'rg16float',
    RGBA8Unorm: 'rgba8unorm',
    RGBA8UnormSRGB: 'rgba8unorm-srgb',
    RGBA8Snorm: 'rgba8snorm',
    RGBA8Uint: 'rgba8uint',
    RGBA8Sint: 'rgba8sint',
    BGRA8Unorm: 'bgra8unorm',
    BGRA8UnormSRGB: 'bgra8unorm-srgb',
    // Packed 32-bit formats
    RGB9E5UFloat: 'rgb9e5ufloat',
    RGB10A2Unorm: 'rgb10a2unorm',
    RG11B10UFloat: 'rg11b10ufloat',
    // 64-bit formats
    RG32Uint: 'rg32uint',
    RG32Sint: 'rg32sint',
    RG32Float: 'rg32float',
    RGBA16Uint: 'rgba16uint',
    RGBA16Sint: 'rgba16sint',
    RGBA16Float: 'rgba16float',
    // 128-bit formats
    RGBA32Uint: 'rgba32uint',
    RGBA32Sint: 'rgba32sint',
    RGBA32Float: 'rgba32float',
    Depth16Unorm: 'depth16unorm',
    Depth24Plus: 'depth24plus',
    Depth24PlusStencil8: 'depth24plus-stencil8',
    Depth32Float: 'depth32float',
    // 'depth32float-stencil8' extension
    Depth32FloatStencil8: 'depth32float-stencil8',
    // BC compressed formats usable if 'texture-compression-bc' is both
    // supported by the device/user agent and enabled in requestDevice.
    BC1RGBAUnorm: 'bc1-rgba-unorm',
    BC1RGBAUnormSRGB: 'bc1-rgba-unorm-srgb',
    BC2RGBAUnorm: 'bc2-rgba-unorm',
    BC2RGBAUnormSRGB: 'bc2-rgba-unorm-srgb',
    BC3RGBAUnorm: 'bc3-rgba-unorm',
    BC3RGBAUnormSRGB: 'bc3-rgba-unorm-srgb',
    BC4RUnorm: 'bc4-r-unorm',
    BC4RSnorm: 'bc4-r-snorm',
    BC5RGUnorm: 'bc5-rg-unorm',
    BC5RGSnorm: 'bc5-rg-snorm',
    BC6HRGBUFloat: 'bc6h-rgb-ufloat',
    BC6HRGBFloat: 'bc6h-rgb-float',
    BC7RGBAUnorm: 'bc7-rgba-unorm',
    BC7RGBAUnormSRGB: 'bc7-rgba-unorm-srgb',
    // ETC2 compressed formats usable if 'texture-compression-etc2' is both
    // supported by the device/user agent and enabled in requestDevice.
    ETC2RGB8Unorm: 'etc2-rgb8unorm',
    ETC2RGB8UnormSRGB: 'etc2-rgb8unorm-srgb',
    ETC2RGB8A1Unorm: 'etc2-rgb8a1unorm',
    ETC2RGB8A1UnormSRGB: 'etc2-rgb8a1unorm-srgb',
    ETC2RGBA8Unorm: 'etc2-rgba8unorm',
    ETC2RGBA8UnormSRGB: 'etc2-rgba8unorm-srgb',
    EACR11Unorm: 'eac-r11unorm',
    EACR11Snorm: 'eac-r11snorm',
    EACRG11Unorm: 'eac-rg11unorm',
    EACRG11Snorm: 'eac-rg11snorm',
    // ASTC compressed formats usable if 'texture-compression-astc' is both
    // supported by the device/user agent and enabled in requestDevice.
    ASTC4x4Unorm: 'astc-4x4-unorm',
    ASTC4x4UnormSRGB: 'astc-4x4-unorm-srgb',
    ASTC5x4Unorm: 'astc-5x4-unorm',
    ASTC5x4UnormSRGB: 'astc-5x4-unorm-srgb',
    ASTC5x5Unorm: 'astc-5x5-unorm',
    ASTC5x5UnormSRGB: 'astc-5x5-unorm-srgb',
    ASTC6x5Unorm: 'astc-6x5-unorm',
    ASTC6x5UnormSRGB: 'astc-6x5-unorm-srgb',
    ASTC6x6Unorm: 'astc-6x6-unorm',
    ASTC6x6UnormSRGB: 'astc-6x6-unorm-srgb',
    ASTC8x5Unorm: 'astc-8x5-unorm',
    ASTC8x5UnormSRGB: 'astc-8x5-unorm-srgb',
    ASTC8x6Unorm: 'astc-8x6-unorm',
    ASTC8x6UnormSRGB: 'astc-8x6-unorm-srgb',
    ASTC8x8Unorm: 'astc-8x8-unorm',
    ASTC8x8UnormSRGB: 'astc-8x8-unorm-srgb',
    ASTC10x5Unorm: 'astc-10x5-unorm',
    ASTC10x5UnormSRGB: 'astc-10x5-unorm-srgb',
    ASTC10x6Unorm: 'astc-10x6-unorm',
    ASTC10x6UnormSRGB: 'astc-10x6-unorm-srgb',
    ASTC10x8Unorm: 'astc-10x8-unorm',
    ASTC10x8UnormSRGB: 'astc-10x8-unorm-srgb',
    ASTC10x10Unorm: 'astc-10x10-unorm',
    ASTC10x10UnormSRGB: 'astc-10x10-unorm-srgb',
    ASTC12x10Unorm: 'astc-12x10-unorm',
    ASTC12x10UnormSRGB: 'astc-12x10-unorm-srgb',
    ASTC12x12Unorm: 'astc-12x12-unorm',
    ASTC12x12UnormSRGB: 'astc-12x12-unorm-srgb'
};
const $d89c9137a3d237c2$var$GPUAddressMode = {
    ClampToEdge: 'clamp-to-edge',
    Repeat: 'repeat',
    MirrorRepeat: 'mirror-repeat'
};
const $d89c9137a3d237c2$var$GPUFilterMode = {
    Linear: 'linear',
    Nearest: 'nearest'
};
const $d89c9137a3d237c2$var$GPUBlendFactor = {
    Zero: 'zero',
    One: 'one',
    Src: 'src',
    OneMinusSrc: 'one-minus-src',
    SrcAlpha: 'src-alpha',
    OneMinusSrcAlpha: 'one-minus-src-alpha',
    Dst: 'dst',
    OneMinusDst: 'one-minus-dst',
    DstAlpha: 'dst-alpha',
    OneMinusDstAlpha: 'one-minus-dst-alpha',
    SrcAlphaSaturated: 'src-alpha-saturated',
    Constant: 'constant',
    OneMinusConstant: 'one-minus-constant'
};
const $d89c9137a3d237c2$var$GPUBlendOperation = {
    Add: 'add',
    Subtract: 'subtract',
    ReverseSubtract: 'reverse-subtract',
    Min: 'min',
    Max: 'max'
};
const $d89c9137a3d237c2$var$GPUColorWriteFlags = {
    None: 0,
    All: 0xF
};
const $d89c9137a3d237c2$var$GPUStencilOperation = {
    Keep: 'keep',
    Zero: 'zero',
    Replace: 'replace',
    Invert: 'invert',
    IncrementClamp: 'increment-clamp',
    DecrementClamp: 'decrement-clamp',
    IncrementWrap: 'increment-wrap',
    DecrementWrap: 'decrement-wrap'
};
const $d89c9137a3d237c2$var$GPUBufferBindingType = {
    Storage: 'storage',
    ReadOnlyStorage: 'read-only-storage'
};
const $d89c9137a3d237c2$var$GPUStorageTextureAccess = {
    WriteOnly: 'write-only',
    ReadOnly: 'read-only',
    ReadWrite: 'read-write'
};
const $d89c9137a3d237c2$var$GPUSamplerBindingType = {
    NonFiltering: 'non-filtering',
    Comparison: 'comparison'
};
const $d89c9137a3d237c2$var$GPUTextureSampleType = {
    Float: 'float',
    UnfilterableFloat: 'unfilterable-float',
    Depth: 'depth',
    SInt: 'sint',
    UInt: 'uint'
};
const $d89c9137a3d237c2$var$GPUTextureDimension = {
    TwoD: '2d',
    ThreeD: '3d'
};
const $d89c9137a3d237c2$var$GPUTextureViewDimension = {
    TwoD: '2d',
    TwoDArray: '2d-array',
    Cube: 'cube',
    ThreeD: '3d'
};
const $d89c9137a3d237c2$var$GPUTextureAspect = {
    All: 'all'
};
const $d89c9137a3d237c2$var$GPUInputStepMode = {
    Vertex: 'vertex',
    Instance: 'instance'
};
const $d89c9137a3d237c2$var$GPUFeatureName = {
    CoreFeaturesAndLimits: 'core-features-and-limits',
    DepthClipControl: 'depth-clip-control',
    Depth32FloatStencil8: 'depth32float-stencil8',
    TextureCompressionBC: 'texture-compression-bc',
    TextureCompressionBCSliced3D: 'texture-compression-bc-sliced-3d',
    TextureCompressionETC2: 'texture-compression-etc2',
    TextureCompressionASTC: 'texture-compression-astc',
    TextureCompressionASTCSliced3D: 'texture-compression-astc-sliced-3d',
    TimestampQuery: 'timestamp-query',
    IndirectFirstInstance: 'indirect-first-instance',
    ShaderF16: 'shader-f16',
    RG11B10UFloat: 'rg11b10ufloat-renderable',
    BGRA8UNormStorage: 'bgra8unorm-storage',
    Float32Filterable: 'float32-filterable',
    Float32Blendable: 'float32-blendable',
    ClipDistances: 'clip-distances',
    DualSourceBlending: 'dual-source-blending',
    Subgroups: 'subgroups',
    TextureFormatsTier1: 'texture-formats-tier1',
    TextureFormatsTier2: 'texture-formats-tier2'
};
const $d89c9137a3d237c2$var$GPUFeatureMap = {
    'texture-compression-s3tc': 'texture-compression-bc',
    'texture-compression-etc1': 'texture-compression-etc2'
};
/**
 * A special form of sampler binding type.
 * It's texture value is managed by a node object.
 *
 * @private
 * @augments Sampler
 */ class $d89c9137a3d237c2$var$NodeSampler extends $d89c9137a3d237c2$var$Sampler {
    /**
	 * Constructs a new node-based sampler.
	 *
	 * @param {string} name - The samplers's name.
	 * @param {TextureNode} textureNode - The texture node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 */ constructor(name, textureNode, groupNode){
        super(name, textureNode ? textureNode.value : null);
        /**
		 * The texture node.
		 *
		 * @type {TextureNode}
		 */ this.textureNode = textureNode;
        /**
		 * The uniform group node.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = groupNode;
    }
    /**
	 * Updates the texture value of this sampler.
	 *
	 * @return {boolean} Whether the sampler needs an update or not.
	 */ update() {
        const { textureNode: textureNode } = this;
        if (this.texture !== textureNode.value) {
            this.texture = textureNode.value;
            return true;
        }
        return super.update();
    }
}
/**
 * Represents a storage buffer binding type.
 *
 * @private
 * @augments Buffer
 */ class $d89c9137a3d237c2$var$StorageBuffer extends $d89c9137a3d237c2$var$Buffer {
    /**
	 * Constructs a new uniform buffer.
	 *
	 * @param {string} name - The buffer's name.
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ constructor(name, attribute){
        super(name, attribute ? attribute.array : null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {BufferAttribute}
		 */ this.attribute = attribute;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageBuffer = true;
    }
}
let $d89c9137a3d237c2$var$_id = 0;
/**
 * A special form of storage buffer binding type.
 * It's buffer value is managed by a node object.
 *
 * @private
 * @augments StorageBuffer
 */ class $d89c9137a3d237c2$var$NodeStorageBuffer extends $d89c9137a3d237c2$var$StorageBuffer {
    /**
	 * Constructs a new node-based storage buffer.
	 *
	 * @param {StorageBufferNode} nodeUniform - The storage buffer node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 */ constructor(nodeUniform, groupNode){
        super('StorageBuffer_' + $d89c9137a3d237c2$var$_id++, nodeUniform ? nodeUniform.value : null);
        /**
		 * The node uniform.
		 *
		 * @type {StorageBufferNode}
		 */ this.nodeUniform = nodeUniform;
        /**
		 * The access type.
		 *
		 * @type {string}
		 */ this.access = nodeUniform ? nodeUniform.access : $d89c9137a3d237c2$export$92538c74c63a703d.READ_WRITE;
        /**
		 * The uniform group node.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = groupNode;
    }
    /**
	 * The storage buffer.
	 *
	 * @type {BufferAttribute}
	 */ get buffer() {
        return this.nodeUniform.value;
    }
}
/**
 * A WebGPU backend utility module used by {@link WebGPUTextureUtils}.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGPUTexturePassUtils extends $d89c9137a3d237c2$var$DataMap {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {GPUDevice} device - The WebGPU device.
	 */ constructor(device){
        super();
        /**
		 * The WebGPU device.
		 *
		 * @type {GPUDevice}
		 */ this.device = device;
        const mipmapVertexSource = `
struct VarysStruct {
	@builtin( position ) Position: vec4<f32>,
	@location( 0 ) vTex : vec2<f32>
};

@vertex
fn main( @builtin( vertex_index ) vertexIndex : u32 ) -> VarysStruct {

	var Varys : VarysStruct;

	var pos = array< vec2<f32>, 4 >(
		vec2<f32>( -1.0,  1.0 ),
		vec2<f32>(  1.0,  1.0 ),
		vec2<f32>( -1.0, -1.0 ),
		vec2<f32>(  1.0, -1.0 )
	);

	var tex = array< vec2<f32>, 4 >(
		vec2<f32>( 0.0, 0.0 ),
		vec2<f32>( 1.0, 0.0 ),
		vec2<f32>( 0.0, 1.0 ),
		vec2<f32>( 1.0, 1.0 )
	);

	Varys.vTex = tex[ vertexIndex ];
	Varys.Position = vec4<f32>( pos[ vertexIndex ], 0.0, 1.0 );

	return Varys;

}
`;
        const mipmapFragmentSource = `
@group( 0 ) @binding( 0 )
var imgSampler : sampler;

@group( 0 ) @binding( 1 )
var img : texture_2d<f32>;

@fragment
fn main( @location( 0 ) vTex : vec2<f32> ) -> @location( 0 ) vec4<f32> {

	return textureSample( img, imgSampler, vTex );

}
`;
        const flipYFragmentSource = `
@group( 0 ) @binding( 0 )
var imgSampler : sampler;

@group( 0 ) @binding( 1 )
var img : texture_2d<f32>;

@fragment
fn main( @location( 0 ) vTex : vec2<f32> ) -> @location( 0 ) vec4<f32> {

	return textureSample( img, imgSampler, vec2( vTex.x, 1.0 - vTex.y ) );

}
`;
        /**
		 * The mipmap GPU sampler.
		 *
		 * @type {GPUSampler}
		 */ this.mipmapSampler = device.createSampler({
            minFilter: $d89c9137a3d237c2$var$GPUFilterMode.Linear
        });
        /**
		 * The flipY GPU sampler.
		 *
		 * @type {GPUSampler}
		 */ this.flipYSampler = device.createSampler({
            minFilter: $d89c9137a3d237c2$var$GPUFilterMode.Nearest
        }); //@TODO?: Consider using textureLoad()
        /**
		 * A cache for GPU render pipelines used for copy/transfer passes.
		 * Every texture format requires a unique pipeline.
		 *
		 * @type {Object<string,GPURenderPipeline>}
		 */ this.transferPipelines = {};
        /**
		 * A cache for GPU render pipelines used for flipY passes.
		 * Every texture format requires a unique pipeline.
		 *
		 * @type {Object<string,GPURenderPipeline>}
		 */ this.flipYPipelines = {};
        /**
		 * The mipmap vertex shader module.
		 *
		 * @type {GPUShaderModule}
		 */ this.mipmapVertexShaderModule = device.createShaderModule({
            label: 'mipmapVertex',
            code: mipmapVertexSource
        });
        /**
		 * The mipmap fragment shader module.
		 *
		 * @type {GPUShaderModule}
		 */ this.mipmapFragmentShaderModule = device.createShaderModule({
            label: 'mipmapFragment',
            code: mipmapFragmentSource
        });
        /**
		 * The flipY fragment shader module.
		 *
		 * @type {GPUShaderModule}
		 */ this.flipYFragmentShaderModule = device.createShaderModule({
            label: 'flipYFragment',
            code: flipYFragmentSource
        });
    }
    /**
	 * Returns a render pipeline for the internal copy render pass. The pass
	 * requires a unique render pipeline for each texture format.
	 *
	 * @param {string} format - The GPU texture format
	 * @return {GPURenderPipeline} The GPU render pipeline.
	 */ getTransferPipeline(format) {
        let pipeline = this.transferPipelines[format];
        if (pipeline === undefined) {
            pipeline = this.device.createRenderPipeline({
                label: `mipmap-${format}`,
                vertex: {
                    module: this.mipmapVertexShaderModule,
                    entryPoint: 'main'
                },
                fragment: {
                    module: this.mipmapFragmentShaderModule,
                    entryPoint: 'main',
                    targets: [
                        {
                            format: format
                        }
                    ]
                },
                primitive: {
                    topology: $d89c9137a3d237c2$var$GPUPrimitiveTopology.TriangleStrip,
                    stripIndexFormat: $d89c9137a3d237c2$var$GPUIndexFormat.Uint32
                },
                layout: 'auto'
            });
            this.transferPipelines[format] = pipeline;
        }
        return pipeline;
    }
    /**
	 * Returns a render pipeline for the flipY render pass. The pass
	 * requires a unique render pipeline for each texture format.
	 *
	 * @param {string} format - The GPU texture format
	 * @return {GPURenderPipeline} The GPU render pipeline.
	 */ getFlipYPipeline(format) {
        let pipeline = this.flipYPipelines[format];
        if (pipeline === undefined) {
            pipeline = this.device.createRenderPipeline({
                label: `flipY-${format}`,
                vertex: {
                    module: this.mipmapVertexShaderModule,
                    entryPoint: 'main'
                },
                fragment: {
                    module: this.flipYFragmentShaderModule,
                    entryPoint: 'main',
                    targets: [
                        {
                            format: format
                        }
                    ]
                },
                primitive: {
                    topology: $d89c9137a3d237c2$var$GPUPrimitiveTopology.TriangleStrip,
                    stripIndexFormat: $d89c9137a3d237c2$var$GPUIndexFormat.Uint32
                },
                layout: 'auto'
            });
            this.flipYPipelines[format] = pipeline;
        }
        return pipeline;
    }
    /**
	 * Flip the contents of the given GPU texture along its vertical axis.
	 *
	 * @param {GPUTexture} textureGPU - The GPU texture object.
	 * @param {Object} textureGPUDescriptor - The texture descriptor.
	 * @param {number} [baseArrayLayer=0] - The index of the first array layer accessible to the texture view.
	 */ flipY(textureGPU, textureGPUDescriptor, baseArrayLayer = 0) {
        const format = textureGPUDescriptor.format;
        const { width: width, height: height } = textureGPUDescriptor.size;
        const transferPipeline = this.getTransferPipeline(format);
        const flipYPipeline = this.getFlipYPipeline(format);
        const tempTexture = this.device.createTexture({
            size: {
                width: width,
                height: height,
                depthOrArrayLayers: 1
            },
            format: format,
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING
        });
        const srcView = textureGPU.createView({
            baseMipLevel: 0,
            mipLevelCount: 1,
            dimension: $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoD,
            baseArrayLayer: baseArrayLayer
        });
        const dstView = tempTexture.createView({
            baseMipLevel: 0,
            mipLevelCount: 1,
            dimension: $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoD,
            baseArrayLayer: 0
        });
        const commandEncoder = this.device.createCommandEncoder({});
        const pass = (pipeline, sourceView, destinationView)=>{
            const bindGroupLayout = pipeline.getBindGroupLayout(0); // @TODO: Consider making this static.
            const bindGroup = this.device.createBindGroup({
                layout: bindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: this.flipYSampler
                    },
                    {
                        binding: 1,
                        resource: sourceView
                    }
                ]
            });
            const passEncoder = commandEncoder.beginRenderPass({
                colorAttachments: [
                    {
                        view: destinationView,
                        loadOp: $d89c9137a3d237c2$var$GPULoadOp.Clear,
                        storeOp: $d89c9137a3d237c2$var$GPUStoreOp.Store,
                        clearValue: [
                            0,
                            0,
                            0,
                            0
                        ]
                    }
                ]
            });
            passEncoder.setPipeline(pipeline);
            passEncoder.setBindGroup(0, bindGroup);
            passEncoder.draw(4, 1, 0, 0);
            passEncoder.end();
        };
        pass(transferPipeline, srcView, dstView);
        pass(flipYPipeline, dstView, srcView);
        this.device.queue.submit([
            commandEncoder.finish()
        ]);
        tempTexture.destroy();
    }
    /**
	 * Generates mipmaps for the given GPU texture.
	 *
	 * @param {GPUTexture} textureGPU - The GPU texture object.
	 * @param {Object} textureGPUDescriptor - The texture descriptor.
	 * @param {number} [baseArrayLayer=0] - The index of the first array layer accessible to the texture view.
	 * @param {?GPUCommandEncoder} [encoder=null] - An optional command encoder used to generate mipmaps.
	 */ generateMipmaps(textureGPU, textureGPUDescriptor, baseArrayLayer = 0, encoder = null) {
        const textureData = this.get(textureGPU);
        if (textureData.layers === undefined) textureData.layers = [];
        const passes = textureData.layers[baseArrayLayer] || this._mipmapCreateBundles(textureGPU, textureGPUDescriptor, baseArrayLayer);
        const commandEncoder = encoder || this.device.createCommandEncoder({
            label: 'mipmapEncoder'
        });
        this._mipmapRunBundles(commandEncoder, passes);
        if (encoder === null) this.device.queue.submit([
            commandEncoder.finish()
        ]);
        textureData.layers[baseArrayLayer] = passes;
    }
    /**
	 * Since multiple copy render passes are required to generate mipmaps, the passes
	 * are managed as render bundles to improve performance.
	 *
	 * @param {GPUTexture} textureGPU - The GPU texture object.
	 * @param {Object} textureGPUDescriptor - The texture descriptor.
	 * @param {number} baseArrayLayer - The index of the first array layer accessible to the texture view.
	 * @return {Array<Object>} An array of render bundles.
	 */ _mipmapCreateBundles(textureGPU, textureGPUDescriptor, baseArrayLayer) {
        const pipeline = this.getTransferPipeline(textureGPUDescriptor.format);
        const bindGroupLayout = pipeline.getBindGroupLayout(0); // @TODO: Consider making this static.
        let srcView = textureGPU.createView({
            baseMipLevel: 0,
            mipLevelCount: 1,
            dimension: $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoD,
            baseArrayLayer: baseArrayLayer
        });
        const passes = [];
        for(let i = 1; i < textureGPUDescriptor.mipLevelCount; i++){
            const bindGroup = this.device.createBindGroup({
                layout: bindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: this.mipmapSampler
                    },
                    {
                        binding: 1,
                        resource: srcView
                    }
                ]
            });
            const dstView = textureGPU.createView({
                baseMipLevel: i,
                mipLevelCount: 1,
                dimension: $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoD,
                baseArrayLayer: baseArrayLayer
            });
            const passDescriptor = {
                colorAttachments: [
                    {
                        view: dstView,
                        loadOp: $d89c9137a3d237c2$var$GPULoadOp.Clear,
                        storeOp: $d89c9137a3d237c2$var$GPUStoreOp.Store,
                        clearValue: [
                            0,
                            0,
                            0,
                            0
                        ]
                    }
                ]
            };
            const passEncoder = this.device.createRenderBundleEncoder({
                colorFormats: [
                    textureGPUDescriptor.format
                ]
            });
            passEncoder.setPipeline(pipeline);
            passEncoder.setBindGroup(0, bindGroup);
            passEncoder.draw(4, 1, 0, 0);
            passes.push({
                renderBundles: [
                    passEncoder.finish()
                ],
                passDescriptor: passDescriptor
            });
            srcView = dstView;
        }
        return passes;
    }
    /**
	 * Executes the render bundles.
	 *
	 * @param {GPUCommandEncoder} commandEncoder - The GPU command encoder.
	 * @param {Array<Object>} passes - An array of render bundles.
	 */ _mipmapRunBundles(commandEncoder, passes) {
        const levels = passes.length;
        for(let i = 0; i < levels; i++){
            const pass = passes[i];
            const passEncoder = commandEncoder.beginRenderPass(pass.passDescriptor);
            passEncoder.executeBundles(pass.renderBundles);
            passEncoder.end();
        }
    }
}
const $d89c9137a3d237c2$var$_compareToWebGPU = {
    [(0, $329ek.NeverCompare)]: 'never',
    [(0, $329ek.LessCompare)]: 'less',
    [(0, $329ek.EqualCompare)]: 'equal',
    [(0, $329ek.LessEqualCompare)]: 'less-equal',
    [(0, $329ek.GreaterCompare)]: 'greater',
    [(0, $329ek.GreaterEqualCompare)]: 'greater-equal',
    [(0, $329ek.AlwaysCompare)]: 'always',
    [(0, $329ek.NotEqualCompare)]: 'not-equal'
};
const $d89c9137a3d237c2$var$_flipMap = [
    0,
    1,
    3,
    2,
    4,
    5
];
/**
 * A WebGPU backend utility module for managing textures.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGPUTextureUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGPUBackend} backend - The WebGPU backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGPU backend.
		 *
		 * @type {WebGPUBackend}
		 */ this.backend = backend;
        /**
		 * A reference to the pass utils.
		 *
		 * @type {?WebGPUTexturePassUtils}
		 * @default null
		 */ this._passUtils = null;
        /**
		 * A dictionary for managing default textures. The key
		 * is the texture format, the value the texture object.
		 *
		 * @type {Object<string,Texture>}
		 */ this.defaultTexture = {};
        /**
		 * A dictionary for managing default cube textures. The key
		 * is the texture format, the value the texture object.
		 *
		 * @type {Object<string,CubeTexture>}
		 */ this.defaultCubeTexture = {};
        /**
		 * A default video frame.
		 *
		 * @type {?VideoFrame}
		 * @default null
		 */ this.defaultVideoFrame = null;
        /**
		 * A cache of shared texture samplers.
		 *
		 * @type {Map<string, Object>}
		 */ this._samplerCache = new Map();
    }
    /**
	 * Creates a GPU sampler for the given texture.
	 *
	 * @param {Texture} texture - The texture to create the sampler for.
	 * @return {string} The current sampler key.
	 */ updateSampler(texture) {
        const backend = this.backend;
        const samplerKey = texture.minFilter + '-' + texture.magFilter + '-' + texture.wrapS + '-' + texture.wrapT + '-' + (texture.wrapR || '0') + '-' + texture.anisotropy + '-' + (texture.compareFunction || 0);
        let samplerData = this._samplerCache.get(samplerKey);
        if (samplerData === undefined) {
            const samplerDescriptorGPU = {
                addressModeU: this._convertAddressMode(texture.wrapS),
                addressModeV: this._convertAddressMode(texture.wrapT),
                addressModeW: this._convertAddressMode(texture.wrapR),
                magFilter: this._convertFilterMode(texture.magFilter),
                minFilter: this._convertFilterMode(texture.minFilter),
                mipmapFilter: this._convertFilterMode(texture.minFilter),
                maxAnisotropy: 1
            };
            // anisotropy can only be used when all filter modes are set to linear.
            if (samplerDescriptorGPU.magFilter === $d89c9137a3d237c2$var$GPUFilterMode.Linear && samplerDescriptorGPU.minFilter === $d89c9137a3d237c2$var$GPUFilterMode.Linear && samplerDescriptorGPU.mipmapFilter === $d89c9137a3d237c2$var$GPUFilterMode.Linear) samplerDescriptorGPU.maxAnisotropy = texture.anisotropy;
            if (texture.isDepthTexture && texture.compareFunction !== null) samplerDescriptorGPU.compare = $d89c9137a3d237c2$var$_compareToWebGPU[texture.compareFunction];
            const sampler = backend.device.createSampler(samplerDescriptorGPU);
            samplerData = {
                sampler: sampler,
                usedTimes: 0
            };
            this._samplerCache.set(samplerKey, samplerData);
        }
        const textureData = backend.get(texture);
        if (textureData.sampler !== samplerData.sampler) {
            // check if previous sampler is unused so it can be deleted
            if (textureData.sampler !== undefined) {
                const oldSamplerData = this._samplerCache.get(textureData.samplerKey);
                oldSamplerData.usedTimes--;
                if (oldSamplerData.usedTimes === 0) this._samplerCache.delete(textureData.samplerKey);
            }
            // update to new sampler data
            textureData.samplerKey = samplerKey;
            textureData.sampler = samplerData.sampler;
            samplerData.usedTimes++;
        }
        return samplerKey;
    }
    /**
	 * Creates a default texture for the given texture that can be used
	 * as a placeholder until the actual texture is ready for usage.
	 *
	 * @param {Texture} texture - The texture to create a default texture for.
	 */ createDefaultTexture(texture) {
        let textureGPU;
        const format = $d89c9137a3d237c2$var$getFormat(texture);
        if (texture.isCubeTexture) textureGPU = this._getDefaultCubeTextureGPU(format);
        else textureGPU = this._getDefaultTextureGPU(format);
        this.backend.get(texture).texture = textureGPU;
    }
    /**
	 * Defines a texture on the GPU for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ createTexture(texture, options = {}) {
        const backend = this.backend;
        const textureData = backend.get(texture);
        if (textureData.initialized) throw new Error('WebGPUTextureUtils: Texture already initialized.');
        if (texture.isExternalTexture) {
            textureData.texture = texture.sourceTexture;
            textureData.initialized = true;
            return;
        }
        if (options.needsMipmaps === undefined) options.needsMipmaps = false;
        if (options.levels === undefined) options.levels = 1;
        if (options.depth === undefined) options.depth = 1;
        const { width: width, height: height, depth: depth, levels: levels } = options;
        if (texture.isFramebufferTexture) {
            if (options.renderTarget) options.format = this.backend.utils.getCurrentColorFormat(options.renderTarget);
            else options.format = this.backend.utils.getPreferredCanvasFormat();
        }
        const dimension = this._getDimension(texture);
        const format = texture.internalFormat || options.format || $d89c9137a3d237c2$var$getFormat(texture, backend.device);
        textureData.format = format;
        const { samples: samples, primarySamples: primarySamples, isMSAA: isMSAA } = backend.utils.getTextureSampleData(texture);
        let usage = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC;
        if (texture.isStorageTexture === true) usage |= GPUTextureUsage.STORAGE_BINDING;
        if (texture.isCompressedTexture !== true && texture.isCompressedArrayTexture !== true && format !== $d89c9137a3d237c2$var$GPUTextureFormat.RGB9E5UFloat) usage |= GPUTextureUsage.RENDER_ATTACHMENT;
        const textureDescriptorGPU = {
            label: texture.name,
            size: {
                width: width,
                height: height,
                depthOrArrayLayers: depth
            },
            mipLevelCount: levels,
            sampleCount: primarySamples,
            dimension: dimension,
            format: format,
            usage: usage
        };
        // texture creation
        if (format === undefined) {
            (0, $329ek.warn)('WebGPURenderer: Texture format not supported.');
            this.createDefaultTexture(texture);
            return;
        }
        if (texture.isCubeTexture) textureDescriptorGPU.textureBindingViewDimension = $d89c9137a3d237c2$var$GPUTextureViewDimension.Cube;
        textureData.texture = backend.device.createTexture(textureDescriptorGPU);
        if (isMSAA) {
            const msaaTextureDescriptorGPU = Object.assign({}, textureDescriptorGPU);
            msaaTextureDescriptorGPU.label = msaaTextureDescriptorGPU.label + '-msaa';
            msaaTextureDescriptorGPU.sampleCount = samples;
            msaaTextureDescriptorGPU.mipLevelCount = 1; // See https://www.w3.org/TR/webgpu/#texture-creation
            textureData.msaaTexture = backend.device.createTexture(msaaTextureDescriptorGPU);
        }
        textureData.initialized = true;
        textureData.textureDescriptorGPU = textureDescriptorGPU;
    }
    /**
	 * Destroys the GPU data for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
	 */ destroyTexture(texture, isDefaultTexture = false) {
        const backend = this.backend;
        const textureData = backend.get(texture);
        if (textureData.texture !== undefined && isDefaultTexture === false) textureData.texture.destroy();
        if (textureData.msaaTexture !== undefined) textureData.msaaTexture.destroy();
        backend.delete(texture);
    }
    /**
	 * Generates mipmaps for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {?GPUCommandEncoder} [encoder=null] - An optional command encoder used to generate mipmaps.
	 */ generateMipmaps(texture, encoder = null) {
        const textureData = this.backend.get(texture);
        if (texture.isCubeTexture) for(let i = 0; i < 6; i++)this._generateMipmaps(textureData.texture, textureData.textureDescriptorGPU, i, encoder);
        else {
            const depth = texture.image.depth || 1;
            for(let i = 0; i < depth; i++)this._generateMipmaps(textureData.texture, textureData.textureDescriptorGPU, i, encoder);
        }
    }
    /**
	 * Returns the color buffer representing the color
	 * attachment of the default framebuffer.
	 *
	 * @return {GPUTexture} The color buffer.
	 */ getColorBuffer() {
        const backend = this.backend;
        const canvasTarget = backend.renderer.getCanvasTarget();
        const { width: width, height: height } = backend.getDrawingBufferSize();
        const samples = backend.renderer.currentSamples;
        const colorTexture = canvasTarget.colorTexture;
        const colorTextureData = backend.get(colorTexture);
        if (colorTexture.width === width && colorTexture.height === height && colorTexture.samples === samples) return colorTextureData.texture;
        // recreate
        let colorBuffer = colorTextureData.texture;
        if (colorBuffer) colorBuffer.destroy();
        colorBuffer = backend.device.createTexture({
            label: 'colorBuffer',
            size: {
                width: width,
                height: height,
                depthOrArrayLayers: 1
            },
            sampleCount: backend.utils.getSampleCount(backend.renderer.currentSamples),
            format: backend.utils.getPreferredCanvasFormat(),
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC
        });
        //
        colorTexture.source.width = width;
        colorTexture.source.height = height;
        colorTexture.samples = samples;
        colorTextureData.texture = colorBuffer;
        return colorBuffer;
    }
    /**
	 * Returns the depth buffer representing the depth
	 * attachment of the default framebuffer.
	 *
	 * @param {boolean} [depth=true] - Whether depth is enabled or not.
	 * @param {boolean} [stencil=false] -  Whether stencil is enabled or not.
	 * @return {GPUTexture} The depth buffer.
	 */ getDepthBuffer(depth = true, stencil = false) {
        const backend = this.backend;
        const canvasTarget = backend.renderer.getCanvasTarget();
        const { width: width, height: height } = backend.getDrawingBufferSize();
        const samples = backend.renderer.currentSamples;
        const depthTexture = canvasTarget.depthTexture;
        if (depthTexture.width === width && depthTexture.height === height && depthTexture.samples === samples && depthTexture.depth === depth && depthTexture.stencil === stencil) return backend.get(depthTexture).texture;
        //
        const depthTextureGPU = backend.get(depthTexture).texture;
        let format, type;
        if (stencil) {
            format = (0, $329ek.DepthStencilFormat);
            type = (0, $329ek.UnsignedInt248Type);
        } else if (depth) {
            format = (0, $329ek.DepthFormat);
            type = (0, $329ek.UnsignedIntType);
        }
        if (depthTextureGPU !== undefined) {
            if (depthTexture.image.width === width && depthTexture.image.height === height && depthTexture.format === format && depthTexture.type === type && depthTexture.samples === samples) return depthTextureGPU;
            this.destroyTexture(depthTexture);
        }
        // recreate
        depthTexture.name = 'depthBuffer';
        depthTexture.format = format;
        depthTexture.type = type;
        depthTexture.image.width = width;
        depthTexture.image.height = height;
        depthTexture.samples = samples;
        this.createTexture(depthTexture, {
            width: width,
            height: height
        });
        return backend.get(depthTexture).texture;
    }
    /**
	 * Uploads the updated texture data to the GPU.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ updateTexture(texture, options) {
        const textureData = this.backend.get(texture);
        const mipmaps = texture.mipmaps;
        const { textureDescriptorGPU: textureDescriptorGPU } = textureData;
        if (texture.isRenderTargetTexture || textureDescriptorGPU === undefined /* unsupported texture format */ ) return;
        // transfer texture data
        if (texture.isDataTexture) {
            if (mipmaps.length > 0) for(let i = 0, il = mipmaps.length; i < il; i++){
                const mipmap = mipmaps[i];
                this._copyBufferToTexture(mipmap, textureData.texture, textureDescriptorGPU, 0, texture.flipY, 0, i);
            }
            else this._copyBufferToTexture(options.image, textureData.texture, textureDescriptorGPU, 0, texture.flipY);
        } else if (texture.isArrayTexture || texture.isDataArrayTexture || texture.isData3DTexture) for(let i = 0; i < options.image.depth; i++)this._copyBufferToTexture(options.image, textureData.texture, textureDescriptorGPU, i, texture.flipY, i);
        else if (texture.isCompressedTexture || texture.isCompressedArrayTexture) this._copyCompressedBufferToTexture(texture.mipmaps, textureData.texture, textureDescriptorGPU);
        else if (texture.isCubeTexture) this._copyCubeMapToTexture(texture, textureData.texture, textureDescriptorGPU);
        else {
            if (mipmaps.length > 0) for(let i = 0, il = mipmaps.length; i < il; i++){
                const mipmap = mipmaps[i];
                this._copyImageToTexture(mipmap, textureData.texture, textureDescriptorGPU, 0, texture.flipY, texture.premultiplyAlpha, i);
            }
            else this._copyImageToTexture(options.image, textureData.texture, textureDescriptorGPU, 0, texture.flipY, texture.premultiplyAlpha);
        }
        //
        textureData.version = texture.version;
    }
    /**
	 * Returns texture data as a typed array.
	 *
	 * @async
	 * @param {Texture} texture - The texture to copy.
	 * @param {number} x - The x coordinate of the copy origin.
	 * @param {number} y - The y coordinate of the copy origin.
	 * @param {number} width - The width of the copy.
	 * @param {number} height - The height of the copy.
	 * @param {number} faceIndex - The face index.
	 * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
	 */ async copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        const device = this.backend.device;
        const textureData = this.backend.get(texture);
        const textureGPU = textureData.texture;
        const format = textureData.textureDescriptorGPU.format;
        const bytesPerTexel = this._getBytesPerTexel(format);
        let bytesPerRow = width * bytesPerTexel;
        bytesPerRow = Math.ceil(bytesPerRow / 256) * 256; // Align to 256 bytes
        const readBuffer = device.createBuffer({
            size: (height - 1) * bytesPerRow + width * bytesPerTexel,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        });
        const encoder = device.createCommandEncoder();
        encoder.copyTextureToBuffer({
            texture: textureGPU,
            origin: {
                x: x,
                y: y,
                z: faceIndex
            }
        }, {
            buffer: readBuffer,
            bytesPerRow: bytesPerRow
        }, {
            width: width,
            height: height
        });
        const typedArrayType = this._getTypedArrayType(format);
        device.queue.submit([
            encoder.finish()
        ]);
        await readBuffer.mapAsync(GPUMapMode.READ);
        const buffer = readBuffer.getMappedRange();
        return new typedArrayType(buffer);
    }
    /**
	 * Frees all internal resources.
	 */ dispose() {
        this._samplerCache.clear();
    }
    /**
	 * Returns the default GPU texture for the given format.
	 *
	 * @private
	 * @param {string} format - The GPU format.
	 * @return {GPUTexture} The GPU texture.
	 */ _getDefaultTextureGPU(format) {
        let defaultTexture = this.defaultTexture[format];
        if (defaultTexture === undefined) {
            const texture = new (0, $329ek.Texture)();
            texture.minFilter = (0, $329ek.NearestFilter);
            texture.magFilter = (0, $329ek.NearestFilter);
            this.createTexture(texture, {
                width: 1,
                height: 1,
                format: format
            });
            this.defaultTexture[format] = defaultTexture = texture;
        }
        return this.backend.get(defaultTexture).texture;
    }
    /**
	 * Returns the default GPU cube texture for the given format.
	 *
	 * @private
	 * @param {string} format - The GPU format.
	 * @return {GPUTexture} The GPU texture.
	 */ _getDefaultCubeTextureGPU(format) {
        let defaultCubeTexture = this.defaultCubeTexture[format];
        if (defaultCubeTexture === undefined) {
            const texture = new (0, $329ek.CubeTexture)();
            texture.minFilter = (0, $329ek.NearestFilter);
            texture.magFilter = (0, $329ek.NearestFilter);
            this.createTexture(texture, {
                width: 1,
                height: 1,
                depth: 6
            });
            this.defaultCubeTexture[format] = defaultCubeTexture = texture;
        }
        return this.backend.get(defaultCubeTexture).texture;
    }
    /**
	 * Uploads cube texture image data to the GPU memory.
	 *
	 * @private
	 * @param {CubeTexture} texture - The cube texture.
	 * @param {GPUTexture} textureGPU - The GPU texture.
	 * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
	 */ _copyCubeMapToTexture(texture, textureGPU, textureDescriptorGPU) {
        const images = texture.images;
        const mipmaps = texture.mipmaps;
        for(let i = 0; i < 6; i++){
            const image = images[i];
            const flipIndex = texture.flipY === true ? $d89c9137a3d237c2$var$_flipMap[i] : i;
            if (image.isDataTexture) this._copyBufferToTexture(image.image, textureGPU, textureDescriptorGPU, flipIndex, texture.flipY);
            else this._copyImageToTexture(image, textureGPU, textureDescriptorGPU, flipIndex, texture.flipY, texture.premultiplyAlpha);
            for(let j = 0; j < mipmaps.length; j++){
                const mipmap = mipmaps[j];
                const image = mipmap.images[i];
                if (image.isDataTexture) this._copyBufferToTexture(image.image, textureGPU, textureDescriptorGPU, flipIndex, texture.flipY, 0, j + 1);
                else this._copyImageToTexture(image, textureGPU, textureDescriptorGPU, flipIndex, texture.flipY, texture.premultiplyAlpha, j + 1);
            }
        }
    }
    /**
	 * Uploads texture image data to the GPU memory.
	 *
	 * @private
	 * @param {HTMLImageElement|ImageBitmap|HTMLCanvasElement} image - The image data.
	 * @param {GPUTexture} textureGPU - The GPU texture.
	 * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
	 * @param {number} originDepth - The origin depth.
	 * @param {boolean} flipY - Whether to flip texture data along their vertical axis or not.
	 * @param {boolean} premultiplyAlpha - Whether the texture should have its RGB channels premultiplied by the alpha channel or not.
	 * @param {number} [mipLevel=0] - The mip level where the data should be copied to.
	 */ _copyImageToTexture(image, textureGPU, textureDescriptorGPU, originDepth, flipY, premultiplyAlpha, mipLevel = 0) {
        const device = this.backend.device;
        const width = mipLevel > 0 ? image.width : textureDescriptorGPU.size.width;
        const height = mipLevel > 0 ? image.height : textureDescriptorGPU.size.height;
        try {
            device.queue.copyExternalImageToTexture({
                source: image,
                flipY: flipY
            }, {
                texture: textureGPU,
                mipLevel: mipLevel,
                origin: {
                    x: 0,
                    y: 0,
                    z: originDepth
                },
                premultipliedAlpha: premultiplyAlpha
            }, {
                width: width,
                height: height,
                depthOrArrayLayers: 1
            });
        // try/catch has been added to fix bad video frame data on certain devices, see #32391
        } catch (_) {}
    }
    /**
	 * Returns the pass utils singleton.
	 *
	 * @private
	 * @return {WebGPUTexturePassUtils} The utils instance.
	 */ _getPassUtils() {
        let passUtils = this._passUtils;
        if (passUtils === null) this._passUtils = passUtils = new $d89c9137a3d237c2$var$WebGPUTexturePassUtils(this.backend.device);
        return passUtils;
    }
    /**
	 * Generates mipmaps for the given GPU texture.
	 *
	 * @private
	 * @param {GPUTexture} textureGPU - The GPU texture object.
	 * @param {Object} textureDescriptorGPU - The texture descriptor.
	 * @param {number} [baseArrayLayer=0] - The index of the first array layer accessible to the texture view.
	 * @param {?GPUCommandEncoder} [encoder=null] - An optional command encoder used to generate mipmaps.
	 */ _generateMipmaps(textureGPU, textureDescriptorGPU, baseArrayLayer = 0, encoder = null) {
        this._getPassUtils().generateMipmaps(textureGPU, textureDescriptorGPU, baseArrayLayer, encoder);
    }
    /**
	 * Flip the contents of the given GPU texture along its vertical axis.
	 *
	 * @private
	 * @param {GPUTexture} textureGPU - The GPU texture object.
	 * @param {Object} textureDescriptorGPU - The texture descriptor.
	 * @param {number} [originDepth=0] - The origin depth.
	 */ _flipY(textureGPU, textureDescriptorGPU, originDepth = 0) {
        this._getPassUtils().flipY(textureGPU, textureDescriptorGPU, originDepth);
    }
    /**
	 * Uploads texture buffer data to the GPU memory.
	 *
	 * @private
	 * @param {Object} image - An object defining the image buffer data.
	 * @param {GPUTexture} textureGPU - The GPU texture.
	 * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
	 * @param {number} originDepth - The origin depth.
	 * @param {boolean} flipY - Whether to flip texture data along their vertical axis or not.
	 * @param {number} [depth=0] - The depth offset when copying array or 3D texture data.
	 * @param {number} [mipLevel=0] - The mip level where the data should be copied to.
	 */ _copyBufferToTexture(image, textureGPU, textureDescriptorGPU, originDepth, flipY, depth = 0, mipLevel = 0) {
        // @TODO: Consider to use GPUCommandEncoder.copyBufferToTexture()
        // @TODO: Consider to support valid buffer layouts with other formats like RGB
        const device = this.backend.device;
        const data = image.data;
        const bytesPerTexel = this._getBytesPerTexel(textureDescriptorGPU.format);
        const bytesPerRow = image.width * bytesPerTexel;
        device.queue.writeTexture({
            texture: textureGPU,
            mipLevel: mipLevel,
            origin: {
                x: 0,
                y: 0,
                z: originDepth
            }
        }, data, {
            offset: image.width * image.height * bytesPerTexel * depth,
            bytesPerRow: bytesPerRow
        }, {
            width: image.width,
            height: image.height,
            depthOrArrayLayers: 1
        });
        if (flipY === true) this._flipY(textureGPU, textureDescriptorGPU, originDepth);
    }
    /**
	 * Uploads compressed texture data to the GPU memory.
	 *
	 * @private
	 * @param {Array<Object>} mipmaps - An array with mipmap data.
	 * @param {GPUTexture} textureGPU - The GPU texture.
	 * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
	 */ _copyCompressedBufferToTexture(mipmaps, textureGPU, textureDescriptorGPU) {
        // @TODO: Consider to use GPUCommandEncoder.copyBufferToTexture()
        const device = this.backend.device;
        const blockData = this._getBlockData(textureDescriptorGPU.format);
        const isArrayTexture = textureDescriptorGPU.size.depthOrArrayLayers > 1;
        for(let i = 0; i < mipmaps.length; i++){
            const mipmap = mipmaps[i];
            const width = mipmap.width;
            const height = mipmap.height;
            const depth = isArrayTexture ? textureDescriptorGPU.size.depthOrArrayLayers : 1;
            const bytesPerRow = Math.ceil(width / blockData.width) * blockData.byteLength;
            const bytesPerImage = bytesPerRow * Math.ceil(height / blockData.height);
            for(let j = 0; j < depth; j++)device.queue.writeTexture({
                texture: textureGPU,
                mipLevel: i,
                origin: {
                    x: 0,
                    y: 0,
                    z: j
                }
            }, mipmap.data, {
                offset: j * bytesPerImage,
                bytesPerRow: bytesPerRow,
                rowsPerImage: Math.ceil(height / blockData.height)
            }, {
                width: Math.ceil(width / blockData.width) * blockData.width,
                height: Math.ceil(height / blockData.height) * blockData.height,
                depthOrArrayLayers: 1
            });
        }
    }
    /**
	 * This method is only relevant for compressed texture formats. It returns a block
	 * data descriptor for the given GPU compressed texture format.
	 *
	 * @private
	 * @param {string} format - The GPU compressed texture format.
	 * @return {Object} The block data descriptor.
	 */ _getBlockData(format) {
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.BC1RGBAUnorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.BC1RGBAUnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        }; // DXT1
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.BC2RGBAUnorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.BC2RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // DXT3
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.BC3RGBAUnorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.BC3RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // DXT5
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.BC4RUnorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.BC4RSnorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        }; // RGTC1
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.BC5RGUnorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.BC5RGSnorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // RGTC2
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.BC6HRGBUFloat || format === $d89c9137a3d237c2$var$GPUTextureFormat.BC6HRGBFloat) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // BPTC (float)
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.BC7RGBAUnorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.BC7RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // BPTC (unorm)
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ETC2RGB8Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ETC2RGB8UnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ETC2RGB8A1Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ETC2RGB8A1UnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ETC2RGBA8Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ETC2RGBA8UnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.EACR11Unorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.EACR11Snorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.EACRG11Unorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.EACRG11Snorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC4x4Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC4x4UnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC5x4Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC5x4UnormSRGB) return {
            byteLength: 16,
            width: 5,
            height: 4
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC5x5Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC5x5UnormSRGB) return {
            byteLength: 16,
            width: 5,
            height: 5
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC6x5Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC6x5UnormSRGB) return {
            byteLength: 16,
            width: 6,
            height: 5
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC6x6Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC6x6UnormSRGB) return {
            byteLength: 16,
            width: 6,
            height: 6
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x5Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x5UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 5
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x6Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x6UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 6
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x8Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x8UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 8
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x5Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x5UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 5
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x6Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x6UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 6
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x8Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x8UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 8
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x10Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x10UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 10
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC12x10Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC12x10UnormSRGB) return {
            byteLength: 16,
            width: 12,
            height: 10
        };
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC12x12Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.ASTC12x12UnormSRGB) return {
            byteLength: 16,
            width: 12,
            height: 12
        };
    }
    /**
	 * Converts the three.js uv wrapping constants to GPU address mode constants.
	 *
	 * @private
	 * @param {number} value - The three.js constant defining a uv wrapping mode.
	 * @return {string} The GPU address mode.
	 */ _convertAddressMode(value) {
        let addressMode = $d89c9137a3d237c2$var$GPUAddressMode.ClampToEdge;
        if (value === (0, $329ek.RepeatWrapping)) addressMode = $d89c9137a3d237c2$var$GPUAddressMode.Repeat;
        else if (value === (0, $329ek.MirroredRepeatWrapping)) addressMode = $d89c9137a3d237c2$var$GPUAddressMode.MirrorRepeat;
        return addressMode;
    }
    /**
	 * Converts the three.js filter constants to GPU filter constants.
	 *
	 * @private
	 * @param {number} value - The three.js constant defining a filter mode.
	 * @return {string} The GPU filter mode.
	 */ _convertFilterMode(value) {
        let filterMode = $d89c9137a3d237c2$var$GPUFilterMode.Linear;
        if (value === (0, $329ek.NearestFilter) || value === (0, $329ek.NearestMipmapNearestFilter) || value === (0, $329ek.NearestMipmapLinearFilter)) filterMode = $d89c9137a3d237c2$var$GPUFilterMode.Nearest;
        return filterMode;
    }
    /**
	 * Returns the bytes-per-texel value for the given GPU texture format.
	 *
	 * @private
	 * @param {string} format - The GPU texture format.
	 * @return {number} The bytes-per-texel.
	 */ _getBytesPerTexel(format) {
        // 8-bit formats
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R8Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.R8Snorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.R8Uint || format === $d89c9137a3d237c2$var$GPUTextureFormat.R8Sint) return 1;
        // 16-bit formats
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R16Uint || format === $d89c9137a3d237c2$var$GPUTextureFormat.R16Sint || format === $d89c9137a3d237c2$var$GPUTextureFormat.R16Float || format === $d89c9137a3d237c2$var$GPUTextureFormat.RG8Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.RG8Snorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.RG8Uint || format === $d89c9137a3d237c2$var$GPUTextureFormat.RG8Sint) return 2;
        // 32-bit formats
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R32Uint || format === $d89c9137a3d237c2$var$GPUTextureFormat.R32Sint || format === $d89c9137a3d237c2$var$GPUTextureFormat.R32Float || format === $d89c9137a3d237c2$var$GPUTextureFormat.RG16Uint || format === $d89c9137a3d237c2$var$GPUTextureFormat.RG16Sint || format === $d89c9137a3d237c2$var$GPUTextureFormat.RG16Float || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8UnormSRGB || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8Snorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8Uint || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8Sint || format === $d89c9137a3d237c2$var$GPUTextureFormat.BGRA8Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.BGRA8UnormSRGB || // Packed 32-bit formats
        format === $d89c9137a3d237c2$var$GPUTextureFormat.RGB9E5UFloat || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGB10A2Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.RG11B10UFloat || format === $d89c9137a3d237c2$var$GPUTextureFormat.Depth32Float || format === $d89c9137a3d237c2$var$GPUTextureFormat.Depth24Plus || format === $d89c9137a3d237c2$var$GPUTextureFormat.Depth24PlusStencil8 || format === $d89c9137a3d237c2$var$GPUTextureFormat.Depth32FloatStencil8) return 4;
        // 64-bit formats
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG32Uint || format === $d89c9137a3d237c2$var$GPUTextureFormat.RG32Sint || format === $d89c9137a3d237c2$var$GPUTextureFormat.RG32Float || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA16Uint || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA16Sint || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA16Float) return 8;
        // 128-bit formats
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA32Uint || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA32Sint || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA32Float) return 16;
    }
    /**
	 * Returns the corresponding typed array type for the given GPU texture format.
	 *
	 * @private
	 * @param {string} format - The GPU texture format.
	 * @return {TypedArray.constructor} The typed array type.
	 */ _getTypedArrayType(format) {
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R8Uint) return Uint8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R8Sint) return Int8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R8Unorm) return Uint8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R8Snorm) return Int8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG8Uint) return Uint8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG8Sint) return Int8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG8Unorm) return Uint8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG8Snorm) return Int8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8Uint) return Uint8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8Sint) return Int8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8UnormSRGB) return Uint8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8Snorm) return Int8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R16Uint) return Uint16Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R16Sint) return Int16Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG16Uint) return Uint16Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG16Sint) return Int16Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA16Uint) return Uint16Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA16Sint) return Int16Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R16Float) return Uint16Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG16Float) return Uint16Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA16Float) return Uint16Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R32Uint) return Uint32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R32Sint) return Int32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.R32Float) return Float32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG32Uint) return Uint32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG32Sint) return Int32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG32Float) return Float32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA32Uint) return Uint32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA32Sint) return Int32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGBA32Float) return Float32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.BGRA8Unorm || format === $d89c9137a3d237c2$var$GPUTextureFormat.BGRA8UnormSRGB) return Uint8Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGB10A2Unorm) return Uint32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RGB9E5UFloat) return Uint32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.RG11B10UFloat) return Uint32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.Depth32Float) return Float32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.Depth24Plus) return Uint32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.Depth24PlusStencil8) return Uint32Array;
        if (format === $d89c9137a3d237c2$var$GPUTextureFormat.Depth32FloatStencil8) return Float32Array;
    }
    /**
	 * Returns the GPU dimensions for the given texture.
	 *
	 * @private
	 * @param {Texture} texture - The texture.
	 * @return {string} The GPU dimension.
	 */ _getDimension(texture) {
        let dimension;
        if (texture.is3DTexture || texture.isData3DTexture) dimension = $d89c9137a3d237c2$var$GPUTextureDimension.ThreeD;
        else dimension = $d89c9137a3d237c2$var$GPUTextureDimension.TwoD;
        return dimension;
    }
}
/**
 * Returns the GPU format for the given texture.
 *
 * @param {Texture} texture - The texture.
 * @param {?GPUDevice} [device=null] - The GPU device which is used for feature detection.
 * It is not necessary to apply the device for most formats.
 * @return {string} The GPU format.
 */ function $d89c9137a3d237c2$var$getFormat(texture, device = null) {
    const format = texture.format;
    const type = texture.type;
    const colorSpace = texture.colorSpace;
    const transfer = (0, $329ek.ColorManagement).getTransfer(colorSpace);
    let formatGPU;
    if (texture.isCompressedTexture === true || texture.isCompressedArrayTexture === true) switch(format){
        case 0, $329ek.RGB_S3TC_DXT1_Format:
        case 0, $329ek.RGBA_S3TC_DXT1_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.BC1RGBAUnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.BC1RGBAUnorm;
            break;
        case 0, $329ek.RGBA_S3TC_DXT3_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.BC2RGBAUnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.BC2RGBAUnorm;
            break;
        case 0, $329ek.RGBA_S3TC_DXT5_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.BC3RGBAUnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.BC3RGBAUnorm;
            break;
        case 0, $329ek.RED_RGTC1_Format:
            formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.BC4RUnorm;
            break;
        case 0, $329ek.SIGNED_RED_RGTC1_Format:
            formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.BC4RSnorm;
            break;
        case 0, $329ek.RED_GREEN_RGTC2_Format:
            formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.BC5RGUnorm;
            break;
        case 0, $329ek.SIGNED_RED_GREEN_RGTC2_Format:
            formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.BC5RGSnorm;
            break;
        case 0, $329ek.RGBA_BPTC_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.BC7RGBAUnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.BC7RGBAUnorm;
            break;
        case 0, $329ek.RGB_ETC2_Format:
        case 0, $329ek.RGB_ETC1_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ETC2RGB8UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ETC2RGB8Unorm;
            break;
        case 0, $329ek.RGBA_ETC2_EAC_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ETC2RGBA8UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ETC2RGBA8Unorm;
            break;
        case 0, $329ek.R11_EAC_Format:
            formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.EACR11Unorm;
            break;
        case 0, $329ek.SIGNED_R11_EAC_Format:
            formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.EACR11Snorm;
            break;
        case 0, $329ek.RG11_EAC_Format:
            formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.EACRG11Unorm;
            break;
        case 0, $329ek.SIGNED_RG11_EAC_Format:
            formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.EACRG11Snorm;
            break;
        case 0, $329ek.RGBA_ASTC_4x4_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC4x4UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC4x4Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_5x4_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC5x4UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC5x4Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_5x5_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC5x5UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC5x5Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_6x5_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC6x5UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC6x5Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_6x6_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC6x6UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC6x6Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_8x5_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x5UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x5Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_8x6_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x6UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x6Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_8x8_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x8UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC8x8Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_10x5_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x5UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x5Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_10x6_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x6UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x6Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_10x8_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x8UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x8Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_10x10_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x10UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC10x10Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_12x10_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC12x10UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC12x10Unorm;
            break;
        case 0, $329ek.RGBA_ASTC_12x12_Format:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.ASTC12x12UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.ASTC12x12Unorm;
            break;
        case 0, $329ek.RGBAFormat:
            formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8Unorm;
            break;
        default:
            (0, $329ek.error)('WebGPURenderer: Unsupported texture format.', format);
    }
    else switch(format){
        case 0, $329ek.RGBAFormat:
            switch(type){
                case 0, $329ek.ByteType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8Snorm;
                    break;
                case 0, $329ek.ShortType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RGBA16Sint;
                    break;
                case 0, $329ek.UnsignedShortType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RGBA16Uint;
                    break;
                case 0, $329ek.UnsignedIntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RGBA32Uint;
                    break;
                case 0, $329ek.IntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RGBA32Sint;
                    break;
                case 0, $329ek.UnsignedByteType:
                    formatGPU = transfer === (0, $329ek.SRGBTransfer) ? $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8UnormSRGB : $d89c9137a3d237c2$var$GPUTextureFormat.RGBA8Unorm;
                    break;
                case 0, $329ek.HalfFloatType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RGBA16Float;
                    break;
                case 0, $329ek.FloatType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RGBA32Float;
                    break;
                default:
                    (0, $329ek.error)('WebGPURenderer: Unsupported texture type with RGBAFormat.', type);
            }
            break;
        case 0, $329ek.RGBFormat:
            switch(type){
                case 0, $329ek.UnsignedInt5999Type:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RGB9E5UFloat;
                    break;
                case 0, $329ek.UnsignedInt101111Type:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RG11B10UFloat;
                    break;
                default:
                    (0, $329ek.error)('WebGPURenderer: Unsupported texture type with RGBFormat.', type);
            }
            break;
        case 0, $329ek.RedFormat:
            switch(type){
                case 0, $329ek.ByteType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.R8Snorm;
                    break;
                case 0, $329ek.ShortType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.R16Sint;
                    break;
                case 0, $329ek.UnsignedShortType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.R16Uint;
                    break;
                case 0, $329ek.UnsignedIntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.R32Uint;
                    break;
                case 0, $329ek.IntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.R32Sint;
                    break;
                case 0, $329ek.UnsignedByteType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.R8Unorm;
                    break;
                case 0, $329ek.HalfFloatType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.R16Float;
                    break;
                case 0, $329ek.FloatType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.R32Float;
                    break;
                default:
                    (0, $329ek.error)('WebGPURenderer: Unsupported texture type with RedFormat.', type);
            }
            break;
        case 0, $329ek.RGFormat:
            switch(type){
                case 0, $329ek.ByteType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RG8Snorm;
                    break;
                case 0, $329ek.ShortType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RG16Sint;
                    break;
                case 0, $329ek.UnsignedShortType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RG16Uint;
                    break;
                case 0, $329ek.UnsignedIntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RG32Uint;
                    break;
                case 0, $329ek.IntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RG32Sint;
                    break;
                case 0, $329ek.UnsignedByteType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RG8Unorm;
                    break;
                case 0, $329ek.HalfFloatType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RG16Float;
                    break;
                case 0, $329ek.FloatType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RG32Float;
                    break;
                default:
                    (0, $329ek.error)('WebGPURenderer: Unsupported texture type with RGFormat.', type);
            }
            break;
        case 0, $329ek.DepthFormat:
            switch(type){
                case 0, $329ek.UnsignedShortType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.Depth16Unorm;
                    break;
                case 0, $329ek.UnsignedIntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.Depth24Plus;
                    break;
                case 0, $329ek.FloatType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.Depth32Float;
                    break;
                default:
                    (0, $329ek.error)('WebGPURenderer: Unsupported texture type with DepthFormat.', type);
            }
            break;
        case 0, $329ek.DepthStencilFormat:
            switch(type){
                case 0, $329ek.UnsignedInt248Type:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.Depth24PlusStencil8;
                    break;
                case 0, $329ek.FloatType:
                    if (device && device.features.has($d89c9137a3d237c2$var$GPUFeatureName.Depth32FloatStencil8) === false) (0, $329ek.error)('WebGPURenderer: Depth textures with DepthStencilFormat + FloatType can only be used with the "depth32float-stencil8" GPU feature.');
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.Depth32FloatStencil8;
                    break;
                default:
                    (0, $329ek.error)('WebGPURenderer: Unsupported texture type with DepthStencilFormat.', type);
            }
            break;
        case 0, $329ek.RedIntegerFormat:
            switch(type){
                case 0, $329ek.IntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.R32Sint;
                    break;
                case 0, $329ek.UnsignedIntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.R32Uint;
                    break;
                default:
                    (0, $329ek.error)('WebGPURenderer: Unsupported texture type with RedIntegerFormat.', type);
            }
            break;
        case 0, $329ek.RGIntegerFormat:
            switch(type){
                case 0, $329ek.IntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RG32Sint;
                    break;
                case 0, $329ek.UnsignedIntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RG32Uint;
                    break;
                default:
                    (0, $329ek.error)('WebGPURenderer: Unsupported texture type with RGIntegerFormat.', type);
            }
            break;
        case 0, $329ek.RGBAIntegerFormat:
            switch(type){
                case 0, $329ek.IntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RGBA32Sint;
                    break;
                case 0, $329ek.UnsignedIntType:
                    formatGPU = $d89c9137a3d237c2$var$GPUTextureFormat.RGBA32Uint;
                    break;
                default:
                    (0, $329ek.error)('WebGPURenderer: Unsupported texture type with RGBAIntegerFormat.', type);
            }
            break;
        default:
            (0, $329ek.error)('WebGPURenderer: Unsupported texture format.', format);
    }
    return formatGPU;
}
const $d89c9137a3d237c2$var$declarationRegexp = /^[fn]*\s*([a-z_0-9]+)?\s*\(([\s\S]*?)\)\s*[\-\>]*\s*([a-z_0-9]+(?:<[\s\S]+?>)?)/i;
const $d89c9137a3d237c2$var$propertiesRegexp = /([a-z_0-9]+)\s*:\s*([a-z_0-9]+(?:<[\s\S]+?>)?)/ig;
const $d89c9137a3d237c2$var$wgslTypeLib$1 = {
    'f32': 'float',
    'i32': 'int',
    'u32': 'uint',
    'bool': 'bool',
    'vec2<f32>': 'vec2',
    'vec2<i32>': 'ivec2',
    'vec2<u32>': 'uvec2',
    'vec2<bool>': 'bvec2',
    'vec2f': 'vec2',
    'vec2i': 'ivec2',
    'vec2u': 'uvec2',
    'vec2b': 'bvec2',
    'vec3<f32>': 'vec3',
    'vec3<i32>': 'ivec3',
    'vec3<u32>': 'uvec3',
    'vec3<bool>': 'bvec3',
    'vec3f': 'vec3',
    'vec3i': 'ivec3',
    'vec3u': 'uvec3',
    'vec3b': 'bvec3',
    'vec4<f32>': 'vec4',
    'vec4<i32>': 'ivec4',
    'vec4<u32>': 'uvec4',
    'vec4<bool>': 'bvec4',
    'vec4f': 'vec4',
    'vec4i': 'ivec4',
    'vec4u': 'uvec4',
    'vec4b': 'bvec4',
    'mat2x2<f32>': 'mat2',
    'mat2x2f': 'mat2',
    'mat3x3<f32>': 'mat3',
    'mat3x3f': 'mat3',
    'mat4x4<f32>': 'mat4',
    'mat4x4f': 'mat4',
    'sampler': 'sampler',
    'texture_1d': 'texture',
    'texture_2d': 'texture',
    'texture_2d_array': 'texture',
    'texture_multisampled_2d': 'cubeTexture',
    'texture_depth_2d': 'depthTexture',
    'texture_depth_2d_array': 'depthTexture',
    'texture_depth_multisampled_2d': 'depthTexture',
    'texture_depth_cube': 'depthTexture',
    'texture_depth_cube_array': 'depthTexture',
    'texture_3d': 'texture3D',
    'texture_cube': 'cubeTexture',
    'texture_cube_array': 'cubeTexture',
    'texture_storage_1d': 'storageTexture',
    'texture_storage_2d': 'storageTexture',
    'texture_storage_2d_array': 'storageTexture',
    'texture_storage_3d': 'storageTexture'
};
const $d89c9137a3d237c2$var$parse = (source)=>{
    source = source.trim();
    const declaration = source.match($d89c9137a3d237c2$var$declarationRegexp);
    if (declaration !== null && declaration.length === 4) {
        const inputsCode = declaration[2];
        const propsMatches = [];
        let match = null;
        while((match = $d89c9137a3d237c2$var$propertiesRegexp.exec(inputsCode)) !== null)propsMatches.push({
            name: match[1],
            type: match[2]
        });
        // Process matches to correctly pair names and types
        const inputs = [];
        for(let i = 0; i < propsMatches.length; i++){
            const { name: name, type: type } = propsMatches[i];
            let resolvedType = type;
            if (resolvedType.startsWith('ptr')) resolvedType = 'pointer';
            else {
                if (resolvedType.startsWith('texture')) resolvedType = type.split('<')[0];
                resolvedType = $d89c9137a3d237c2$var$wgslTypeLib$1[resolvedType];
            }
            inputs.push(new $d89c9137a3d237c2$export$9909d560ff36ee5e(resolvedType, name));
        }
        const blockCode = source.substring(declaration[0].length);
        const outputType = declaration[3] || 'void';
        const name = declaration[1] !== undefined ? declaration[1] : '';
        const type = $d89c9137a3d237c2$var$wgslTypeLib$1[outputType] || outputType;
        return {
            type: type,
            inputs: inputs,
            name: name,
            inputsCode: inputsCode,
            blockCode: blockCode,
            outputType: outputType
        };
    } else throw new Error('FunctionNode: Function is not a WGSL code.');
};
/**
 * This class represents a WSL node function.
 *
 * @augments NodeFunction
 */ class $d89c9137a3d237c2$var$WGSLNodeFunction extends $d89c9137a3d237c2$var$NodeFunction {
    /**
	 * Constructs a new WGSL node function.
	 *
	 * @param {string} source - The WGSL source.
	 */ constructor(source){
        const { type: type, inputs: inputs, name: name, inputsCode: inputsCode, blockCode: blockCode, outputType: outputType } = $d89c9137a3d237c2$var$parse(source);
        super(type, inputs, name);
        this.inputsCode = inputsCode;
        this.blockCode = blockCode;
        this.outputType = outputType;
    }
    /**
	 * This method returns the WGSL code of the node function.
	 *
	 * @param {string} [name=this.name] - The function's name.
	 * @return {string} The shader code.
	 */ getCode(name = this.name) {
        const outputType = this.outputType !== 'void' ? '-> ' + this.outputType : '';
        return `fn ${name} ( ${this.inputsCode.trim()} ) ${outputType}` + this.blockCode;
    }
}
/**
 * A WGSL node parser.
 *
 * @augments NodeParser
 */ class $d89c9137a3d237c2$var$WGSLNodeParser extends $d89c9137a3d237c2$var$NodeParser {
    /**
	 * The method parses the given WGSL code an returns a node function.
	 *
	 * @param {string} source - The WGSL code.
	 * @return {WGSLNodeFunction} A node function.
	 */ parseFunction(source) {
        return new $d89c9137a3d237c2$var$WGSLNodeFunction(source);
    }
}
const $d89c9137a3d237c2$var$accessNames = {
    [$d89c9137a3d237c2$export$92538c74c63a703d.READ_ONLY]: 'read',
    [$d89c9137a3d237c2$export$92538c74c63a703d.WRITE_ONLY]: 'write',
    [$d89c9137a3d237c2$export$92538c74c63a703d.READ_WRITE]: 'read_write'
};
const $d89c9137a3d237c2$var$wrapNames = {
    [(0, $329ek.RepeatWrapping)]: 'repeat',
    [(0, $329ek.ClampToEdgeWrapping)]: 'clamp',
    [(0, $329ek.MirroredRepeatWrapping)]: 'mirror'
};
const $d89c9137a3d237c2$var$gpuShaderStageLib = {
    'vertex': $d89c9137a3d237c2$var$GPUShaderStage.VERTEX,
    'fragment': $d89c9137a3d237c2$var$GPUShaderStage.FRAGMENT,
    'compute': $d89c9137a3d237c2$var$GPUShaderStage.COMPUTE
};
const $d89c9137a3d237c2$var$supports = {
    instance: true,
    swizzleAssign: false,
    storageBuffer: true
};
const $d89c9137a3d237c2$var$wgslFnOpLib = {
    '^^': 'tsl_xor'
};
const $d89c9137a3d237c2$var$wgslTypeLib = {
    float: 'f32',
    int: 'i32',
    uint: 'u32',
    bool: 'bool',
    color: 'vec3<f32>',
    vec2: 'vec2<f32>',
    ivec2: 'vec2<i32>',
    uvec2: 'vec2<u32>',
    bvec2: 'vec2<bool>',
    vec3: 'vec3<f32>',
    ivec3: 'vec3<i32>',
    uvec3: 'vec3<u32>',
    bvec3: 'vec3<bool>',
    vec4: 'vec4<f32>',
    ivec4: 'vec4<i32>',
    uvec4: 'vec4<u32>',
    bvec4: 'vec4<bool>',
    mat2: 'mat2x2<f32>',
    mat3: 'mat3x3<f32>',
    mat4: 'mat4x4<f32>'
};
const $d89c9137a3d237c2$var$wgslCodeCache = {};
const $d89c9137a3d237c2$var$wgslPolyfill = {
    tsl_xor: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_xor( a : bool, b : bool ) -> bool { return ( a || b ) && !( a && b ); }'),
    mod_float: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_mod_float( x : f32, y : f32 ) -> f32 { return x - y * floor( x / y ); }'),
    mod_vec2: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_mod_vec2( x : vec2f, y : vec2f ) -> vec2f { return x - y * floor( x / y ); }'),
    mod_vec3: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_mod_vec3( x : vec3f, y : vec3f ) -> vec3f { return x - y * floor( x / y ); }'),
    mod_vec4: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_mod_vec4( x : vec4f, y : vec4f ) -> vec4f { return x - y * floor( x / y ); }'),
    equals_bool: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_equals_bool( a : bool, b : bool ) -> bool { return a == b; }'),
    equals_bvec2: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_equals_bvec2( a : vec2f, b : vec2f ) -> vec2<bool> { return vec2<bool>( a.x == b.x, a.y == b.y ); }'),
    equals_bvec3: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_equals_bvec3( a : vec3f, b : vec3f ) -> vec3<bool> { return vec3<bool>( a.x == b.x, a.y == b.y, a.z == b.z ); }'),
    equals_bvec4: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_equals_bvec4( a : vec4f, b : vec4f ) -> vec4<bool> { return vec4<bool>( a.x == b.x, a.y == b.y, a.z == b.z, a.w == b.w ); }'),
    repeatWrapping_float: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_repeatWrapping_float( coord: f32 ) -> f32 { return fract( coord ); }'),
    mirrorWrapping_float: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_mirrorWrapping_float( coord: f32 ) -> f32 { let mirrored = fract( coord * 0.5 ) * 2.0; return 1.0 - abs( 1.0 - mirrored ); }'),
    clampWrapping_float: new $d89c9137a3d237c2$export$347eb46a3090e941('fn tsl_clampWrapping_float( coord: f32 ) -> f32 { return clamp( coord, 0.0, 1.0 ); }'),
    biquadraticTexture: new $d89c9137a3d237c2$export$347eb46a3090e941(/* wgsl */ `
fn tsl_biquadraticTexture( map : texture_2d<f32>, coord : vec2f, iRes : vec2u, level : u32 ) -> vec4f {

	let res = vec2f( iRes );

	let uvScaled = coord * res;
	let uvWrapping = ( ( uvScaled % res ) + res ) % res;

	// https://www.shadertoy.com/view/WtyXRy

	let uv = uvWrapping - 0.5;
	let iuv = floor( uv );
	let f = fract( uv );

	let rg1 = textureLoad( map, vec2u( iuv + vec2( 0.5, 0.5 ) ) % iRes, level );
	let rg2 = textureLoad( map, vec2u( iuv + vec2( 1.5, 0.5 ) ) % iRes, level );
	let rg3 = textureLoad( map, vec2u( iuv + vec2( 0.5, 1.5 ) ) % iRes, level );
	let rg4 = textureLoad( map, vec2u( iuv + vec2( 1.5, 1.5 ) ) % iRes, level );

	return mix( mix( rg1, rg2, f.x ), mix( rg3, rg4, f.x ), f.y );

}
`)
};
const $d89c9137a3d237c2$var$wgslMethods = {
    dFdx: 'dpdx',
    dFdy: '- dpdy',
    mod_float: 'tsl_mod_float',
    mod_vec2: 'tsl_mod_vec2',
    mod_vec3: 'tsl_mod_vec3',
    mod_vec4: 'tsl_mod_vec4',
    equals_bool: 'tsl_equals_bool',
    equals_bvec2: 'tsl_equals_bvec2',
    equals_bvec3: 'tsl_equals_bvec3',
    equals_bvec4: 'tsl_equals_bvec4',
    inversesqrt: 'inverseSqrt',
    bitcast: 'bitcast<f32>',
    floatpack_snorm_2x16: 'pack2x16snorm',
    floatpack_unorm_2x16: 'pack2x16unorm',
    floatpack_float16_2x16: 'pack2x16float',
    floatunpack_snorm_2x16: 'unpack2x16snorm',
    floatunpack_unorm_2x16: 'unpack2x16unorm',
    floatunpack_float16_2x16: 'unpack2x16float'
};
//
let $d89c9137a3d237c2$var$diagnostics = '';
if ((typeof navigator !== 'undefined' && /Firefox|Deno/g.test(navigator.userAgent)) !== true) $d89c9137a3d237c2$var$diagnostics += 'diagnostic( off, derivative_uniformity );\n';
/**
 * A node builder targeting WGSL.
 *
 * This module generates WGSL shader code from node materials and also
 * generates the respective bindings and vertex buffer definitions. These
 * data are later used by the renderer to create render and compute pipelines
 * for render objects.
 *
 * @augments NodeBuilder
 */ class $d89c9137a3d237c2$var$WGSLNodeBuilder extends $d89c9137a3d237c2$export$e3bd53a4d3c1a94e {
    /**
	 * Constructs a new WGSL node builder renderer.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Renderer} renderer - The renderer.
	 */ constructor(object, renderer){
        super(object, renderer, new $d89c9137a3d237c2$var$WGSLNodeParser());
        /**
		 * A dictionary that holds for each shader stage ('vertex', 'fragment', 'compute')
		 * another dictionary which manages UBOs per group ('render','frame','object').
		 *
		 * @type {Object<string,Object<string,NodeUniformsGroup>>}
		 */ this.uniformGroups = {};
        /**
		 * A dictionary that holds for each shader stage a Map of builtins.
		 *
		 * @type {Object<string,Map<string,Object>>}
		 */ this.builtins = {};
        /**
		 * A dictionary that holds for each shader stage a Set of directives.
		 *
		 * @type {Object<string,Set<string>>}
		 */ this.directives = {};
        /**
		 * A map for managing scope arrays. Only relevant for when using
		 * {@link WorkgroupInfoNode} in context of compute shaders.
		 *
		 * @type {Map<string,Object>}
		 */ this.scopedArrays = new Map();
    }
    /**
	 * Generates the WGSL snippet for sampled textures.
	 *
	 * @private
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ _generateTextureSample(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') {
            if (depthSnippet) {
                if (offsetSnippet) return `textureSample( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${offsetSnippet} )`;
                return `textureSample( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet} )`;
            } else {
                if (offsetSnippet) return `textureSample( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${offsetSnippet} )`;
                return `textureSample( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet} )`;
            }
        } else return this.generateTextureSampleLevel(texture, textureProperty, uvSnippet, '0', depthSnippet);
    }
    /**
	 * Generates the WGSL snippet when sampling textures with explicit mip level.
	 *
	 * @private
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The WGSL snippet.
	 */ generateTextureSampleLevel(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, offsetSnippet) {
        if (this.isUnfilterable(texture) === false) {
            if (offsetSnippet) return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${levelSnippet}, ${offsetSnippet} )`;
            return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${levelSnippet} )`;
        } else if (this.isFilteredTexture(texture)) return this.generateFilteredTexture(texture, textureProperty, uvSnippet, offsetSnippet, levelSnippet);
        else return this.generateTextureLod(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, levelSnippet);
    }
    /**
	 * Generates a wrap function used in context of textures.
	 *
	 * @param {Texture} texture - The texture to generate the function for.
	 * @return {string} The name of the generated function.
	 */ generateWrapFunction(texture) {
        const functionName = `tsl_coord_${$d89c9137a3d237c2$var$wrapNames[texture.wrapS]}S_${$d89c9137a3d237c2$var$wrapNames[texture.wrapT]}_${texture.is3DTexture || texture.isData3DTexture ? '3d' : '2d'}T`;
        let nodeCode = $d89c9137a3d237c2$var$wgslCodeCache[functionName];
        if (nodeCode === undefined) {
            const includes = [];
            // For 3D textures, use vec3f; for texture arrays, keep vec2f since array index is separate
            const coordType = texture.is3DTexture || texture.isData3DTexture ? 'vec3f' : 'vec2f';
            let code = `fn ${functionName}( coord : ${coordType} ) -> ${coordType} {\n\n\treturn ${coordType}(\n`;
            const addWrapSnippet = (wrap, axis)=>{
                if (wrap === (0, $329ek.RepeatWrapping)) {
                    includes.push($d89c9137a3d237c2$var$wgslPolyfill.repeatWrapping_float);
                    code += `\t\ttsl_repeatWrapping_float( coord.${axis} )`;
                } else if (wrap === (0, $329ek.ClampToEdgeWrapping)) {
                    includes.push($d89c9137a3d237c2$var$wgslPolyfill.clampWrapping_float);
                    code += `\t\ttsl_clampWrapping_float( coord.${axis} )`;
                } else if (wrap === (0, $329ek.MirroredRepeatWrapping)) {
                    includes.push($d89c9137a3d237c2$var$wgslPolyfill.mirrorWrapping_float);
                    code += `\t\ttsl_mirrorWrapping_float( coord.${axis} )`;
                } else {
                    code += `\t\tcoord.${axis}`;
                    (0, $329ek.warn)(`WebGPURenderer: Unsupported texture wrap type "${wrap}" for vertex shader.`);
                }
            };
            addWrapSnippet(texture.wrapS, 'x');
            code += ',\n';
            addWrapSnippet(texture.wrapT, 'y');
            if (texture.is3DTexture || texture.isData3DTexture) {
                code += ',\n';
                addWrapSnippet(texture.wrapR, 'z');
            }
            code += '\n\t);\n\n}\n';
            $d89c9137a3d237c2$var$wgslCodeCache[functionName] = nodeCode = new $d89c9137a3d237c2$export$347eb46a3090e941(code, includes);
        }
        nodeCode.build(this);
        return functionName;
    }
    /**
	 * Generates the array declaration string.
	 *
	 * @param {string} type - The type.
	 * @param {?number} [count] - The count.
	 * @return {string} The generated value as a shader string.
	 */ generateArrayDeclaration(type, count) {
        return `array< ${this.getType(type)}, ${count} >`;
    }
    /**
	 * Generates a WGSL variable that holds the texture dimension of the given texture.
	 * It also returns information about the number of layers (elements) of an arrayed
	 * texture as well as the cube face count of cube textures.
	 *
	 * @param {Texture} texture - The texture to generate the function for.
	 * @param {string} textureProperty - The name of the video texture uniform in the shader.
	 * @param {string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @return {string} The name of the dimension variable.
	 */ generateTextureDimension(texture, textureProperty, levelSnippet) {
        const textureData = this.getDataFromNode(texture, this.shaderStage, this.globalCache);
        if (textureData.dimensionsSnippet === undefined) textureData.dimensionsSnippet = {};
        let textureDimensionNode = textureData.dimensionsSnippet[levelSnippet];
        if (textureData.dimensionsSnippet[levelSnippet] === undefined) {
            let textureDimensionsParams;
            let dimensionType;
            const { primarySamples: primarySamples } = this.renderer.backend.utils.getTextureSampleData(texture);
            const isMultisampled = primarySamples > 1;
            if (texture.is3DTexture || texture.isData3DTexture) dimensionType = 'vec3<u32>';
            else // Regular 2D textures, depth textures, etc.
            dimensionType = 'vec2<u32>';
            // Build parameters string based on texture type and multisampling
            if (isMultisampled || texture.isStorageTexture) textureDimensionsParams = textureProperty;
            else textureDimensionsParams = `${textureProperty}${levelSnippet ? `, u32( ${levelSnippet} )` : ''}`;
            textureDimensionNode = new $d89c9137a3d237c2$export$fec192598c332c7e(new $d89c9137a3d237c2$export$e59ba5d29a1947fc(`textureDimensions( ${textureDimensionsParams} )`, dimensionType));
            textureData.dimensionsSnippet[levelSnippet] = textureDimensionNode;
            if (texture.isArrayTexture || texture.isDataArrayTexture || texture.is3DTexture || texture.isData3DTexture) textureData.arrayLayerCount = new $d89c9137a3d237c2$export$fec192598c332c7e(new $d89c9137a3d237c2$export$e59ba5d29a1947fc(`textureNumLayers(${textureProperty})`, 'u32'));
            // For cube textures, we know it's always 6 faces
            if (texture.isTextureCube) textureData.cubeFaceCount = new $d89c9137a3d237c2$export$fec192598c332c7e(new $d89c9137a3d237c2$export$e59ba5d29a1947fc('6u', 'u32'));
        }
        return textureDimensionNode.build(this);
    }
    /**
	 * Generates the WGSL snippet for a manual filtered texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [levelSnippet='0u'] - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @return {string} The WGSL snippet.
	 */ generateFilteredTexture(texture, textureProperty, uvSnippet, offsetSnippet, levelSnippet = '0u') {
        this._include('biquadraticTexture');
        const wrapFunction = this.generateWrapFunction(texture);
        const textureDimension = this.generateTextureDimension(texture, textureProperty, levelSnippet);
        if (offsetSnippet) uvSnippet = `${uvSnippet} + vec2<f32>(${offsetSnippet}) / ${textureDimension}`;
        return `tsl_biquadraticTexture( ${textureProperty}, ${wrapFunction}( ${uvSnippet} ), ${textureDimension}, u32( ${levelSnippet} ) )`;
    }
    /**
	 * Generates the WGSL snippet for a texture lookup with explicit level-of-detail.
	 * Since it's a lookup, no sampling or filtering is applied.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [levelSnippet='0u'] - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @return {string} The WGSL snippet.
	 */ generateTextureLod(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, levelSnippet = '0u') {
        const wrapFunction = this.generateWrapFunction(texture);
        const textureDimension = this.generateTextureDimension(texture, textureProperty, levelSnippet);
        const vecType = texture.is3DTexture || texture.isData3DTexture ? 'vec3' : 'vec2';
        if (offsetSnippet) uvSnippet = `${uvSnippet} + ${vecType}<f32>(${offsetSnippet}) / ${vecType}<f32>( ${textureDimension} )`;
        const coordSnippet = `${vecType}<u32>( ${wrapFunction}( ${uvSnippet} ) * ${vecType}<f32>( ${textureDimension} ) )`;
        return this.generateTextureLoad(texture, textureProperty, coordSnippet, levelSnippet, depthSnippet, null);
    }
    /**
	 * Generates the WGSL snippet that reads a single texel from a texture without sampling or filtering.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvIndexSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The WGSL snippet.
	 */ generateTextureLoad(texture, textureProperty, uvIndexSnippet, levelSnippet, depthSnippet, offsetSnippet) {
        if (levelSnippet === null) levelSnippet = '0u';
        if (offsetSnippet) uvIndexSnippet = `${uvIndexSnippet} + ${offsetSnippet}`;
        let snippet;
        if (depthSnippet) snippet = `textureLoad( ${textureProperty}, ${uvIndexSnippet}, ${depthSnippet}, u32( ${levelSnippet} ) )`;
        else {
            snippet = `textureLoad( ${textureProperty}, ${uvIndexSnippet}, u32( ${levelSnippet} ) )`;
            if (this.renderer.backend.compatibilityMode && texture.isDepthTexture) snippet += '.x';
        }
        return snippet;
    }
    /**
	 * Generates the WGSL snippet that writes a single texel to a texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvIndexSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {string} valueSnippet - A WGSL snippet that represent the new texel value.
	 * @return {string} The WGSL snippet.
	 */ generateTextureStore(texture, textureProperty, uvIndexSnippet, depthSnippet, valueSnippet) {
        let snippet;
        if (depthSnippet) snippet = `textureStore( ${textureProperty}, ${uvIndexSnippet}, ${depthSnippet}, ${valueSnippet} )`;
        else snippet = `textureStore( ${textureProperty}, ${uvIndexSnippet}, ${valueSnippet} )`;
        return snippet;
    }
    /**
	 * Returns `true` if the sampled values of the given texture should be compared against a reference value.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {boolean} Whether the sampled values of the given texture should be compared against a reference value or not.
	 */ isSampleCompare(texture) {
        return texture.isDepthTexture === true && texture.compareFunction !== null;
    }
    /**
	 * Returns `true` if the given texture is unfilterable.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {boolean} Whether the given texture is unfilterable or not.
	 */ isUnfilterable(texture) {
        return this.getComponentTypeFromTexture(texture) !== 'float' || !this.isAvailable('float32Filterable') && texture.isDataTexture === true && texture.type === (0, $329ek.FloatType) || this.isSampleCompare(texture) === false && texture.minFilter === (0, $329ek.NearestFilter) && texture.magFilter === (0, $329ek.NearestFilter) || this.renderer.backend.utils.getTextureSampleData(texture).primarySamples > 1;
    }
    /**
	 * Generates the WGSL snippet for sampling/loading the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ generateTexture(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        let snippet = null;
        if (this.isUnfilterable(texture)) snippet = this.generateTextureLod(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, '0', shaderStage);
        else snippet = this._generateTextureSample(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, shaderStage);
        return snippet;
    }
    /**
	 * Generates the WGSL snippet for sampling/loading the given texture using explicit gradients.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {Array<string>} gradSnippet - An array holding both gradient WGSL snippets.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ generateTextureGrad(texture, textureProperty, uvSnippet, gradSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') {
            // TODO handle i32 or u32 --> uvSnippet, array_index: A, ddx, ddy
            if (offsetSnippet) return `textureSampleGrad( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet},  ${gradSnippet[0]}, ${gradSnippet[1]}, ${offsetSnippet} )`;
            return `textureSampleGrad( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet},  ${gradSnippet[0]}, ${gradSnippet[1]} )`;
        } else (0, $329ek.error)(`WebGPURenderer: THREE.TextureNode.gradient() does not support ${shaderStage} shader.`);
    }
    /**
	 * Generates the WGSL snippet for sampling a depth texture and comparing the sampled depth values
	 * against a reference value.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {string} compareSnippet -  A WGSL snippet that represents the reference value.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ generateTextureCompare(texture, textureProperty, uvSnippet, compareSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') {
            if (texture.isDepthTexture === true && texture.isArrayTexture === true) {
                if (offsetSnippet) return `textureSampleCompare( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${compareSnippet}, ${offsetSnippet} )`;
                return `textureSampleCompare( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${compareSnippet} )`;
            }
            if (offsetSnippet) return `textureSampleCompare( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${compareSnippet}, ${offsetSnippet} )`;
            return `textureSampleCompare( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${compareSnippet} )`;
        } else (0, $329ek.error)(`WebGPURenderer: THREE.DepthTexture.compareFunction() does not support ${shaderStage} shader.`);
    }
    /**
	 * Generates the WGSL snippet when sampling textures with explicit mip level.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ generateTextureLevel(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, offsetSnippet) {
        if (this.isUnfilterable(texture) === false) {
            if (offsetSnippet) return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${levelSnippet}, ${offsetSnippet} )`;
            return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${levelSnippet} )`;
        } else if (this.isFilteredTexture(texture)) return this.generateFilteredTexture(texture, textureProperty, uvSnippet, offsetSnippet, levelSnippet);
        else return this.generateTextureLod(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, levelSnippet);
    }
    /**
	 * Generates the WGSL snippet when sampling textures with a bias to the mip level.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {string} biasSnippet - A WGSL snippet that represents the bias to apply to the mip level before sampling.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ generateTextureBias(texture, textureProperty, uvSnippet, biasSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') {
            if (offsetSnippet) return `textureSampleBias( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${biasSnippet}, ${offsetSnippet} )`;
            return `textureSampleBias( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${biasSnippet} )`;
        } else (0, $329ek.error)(`WebGPURenderer: THREE.TextureNode.biasNode does not support ${shaderStage} shader.`);
    }
    /**
	 * Returns a WGSL snippet that represents the property name of the given node.
	 *
	 * @param {Node} node - The node.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The property name.
	 */ getPropertyName(node, shaderStage = this.shaderStage) {
        if (node.isNodeVarying === true && node.needsInterpolation === true) {
            if (shaderStage === 'vertex') return `varyings.${node.name}`;
        } else if (node.isNodeUniform === true) {
            const name = node.name;
            const type = node.type;
            if (type === 'texture' || type === 'cubeTexture' || type === 'cubeDepthTexture' || type === 'storageTexture' || type === 'texture3D') return name;
            else if (type === 'buffer' || type === 'storageBuffer' || type === 'indirectStorageBuffer') {
                if (this.isCustomStruct(node)) return name;
                return name + '.value';
            } else return node.groupNode.name + '.' + name;
        }
        return super.getPropertyName(node);
    }
    /**
	 * Returns the output struct name.
	 *
	 * @return {string} The name of the output struct.
	 */ getOutputStructName() {
        return 'output';
    }
    /**
	 * Returns the native shader operator name for a given generic name.
	 *
	 * @param {string} op - The operator name to resolve.
	 * @return {?string} The resolved operator name.
	 */ getFunctionOperator(op) {
        const fnOp = $d89c9137a3d237c2$var$wgslFnOpLib[op];
        if (fnOp !== undefined) {
            this._include(fnOp);
            return fnOp;
        }
        return null;
    }
    /**
	 * Returns the node access for the given node and shader stage.
	 *
	 * @param {StorageTextureNode|StorageBufferNode} node - The storage node.
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The node access.
	 */ getNodeAccess(node, shaderStage) {
        if (shaderStage !== 'compute') {
            if (node.isAtomic === true) {
                (0, $329ek.warn)('WebGPURenderer: Atomic operations are only supported in compute shaders.');
                return $d89c9137a3d237c2$export$92538c74c63a703d.READ_WRITE;
            }
            return $d89c9137a3d237c2$export$92538c74c63a703d.READ_ONLY;
        }
        return node.access;
    }
    /**
	 * Returns A WGSL snippet representing the storage access.
	 *
	 * @param {StorageTextureNode|StorageBufferNode} node - The storage node.
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet representing the storage access.
	 */ getStorageAccess(node, shaderStage) {
        return $d89c9137a3d237c2$var$accessNames[this.getNodeAccess(node, shaderStage)];
    }
    /**
	 * This method is one of the more important ones since it's responsible
	 * for generating a matching binding instance for the given uniform node.
	 *
	 * These bindings are later used in the renderer to create bind groups
	 * and layouts.
	 *
	 * @param {UniformNode} node - The uniform node.
	 * @param {string} type - The node data type.
	 * @param {string} shaderStage - The shader stage.
	 * @param {?string} [name=null] - An optional uniform name.
	 * @return {NodeUniform} The node uniform object.
	 */ getUniformFromNode(node, type, shaderStage, name = null) {
        const uniformNode = super.getUniformFromNode(node, type, shaderStage, name);
        const nodeData = this.getDataFromNode(node, shaderStage, this.globalCache);
        if (nodeData.uniformGPU === undefined) {
            let uniformGPU;
            const group = node.groupNode;
            const groupName = group.name;
            const bindings = this.getBindGroupArray(groupName, shaderStage);
            if (type === 'texture' || type === 'cubeTexture' || type === 'cubeDepthTexture' || type === 'storageTexture' || type === 'texture3D') {
                let texture = null;
                const access = this.getNodeAccess(node, shaderStage);
                if (type === 'texture' || type === 'storageTexture') {
                    if (node.value.is3DTexture === true) texture = new $d89c9137a3d237c2$var$NodeSampledTexture3D(uniformNode.name, uniformNode.node, group, access);
                    else texture = new $d89c9137a3d237c2$var$NodeSampledTexture(uniformNode.name, uniformNode.node, group, access);
                } else if (type === 'cubeTexture' || type === 'cubeDepthTexture') texture = new $d89c9137a3d237c2$var$NodeSampledCubeTexture(uniformNode.name, uniformNode.node, group, access);
                else if (type === 'texture3D') texture = new $d89c9137a3d237c2$var$NodeSampledTexture3D(uniformNode.name, uniformNode.node, group, access);
                texture.store = node.isStorageTextureNode === true;
                texture.mipLevel = texture.store ? node.mipLevel : 0;
                texture.setVisibility($d89c9137a3d237c2$var$gpuShaderStageLib[shaderStage]);
                if (this.isUnfilterable(node.value) === false && texture.store === false) {
                    const sampler = new $d89c9137a3d237c2$var$NodeSampler(`${uniformNode.name}_sampler`, uniformNode.node, group);
                    sampler.setVisibility($d89c9137a3d237c2$var$gpuShaderStageLib[shaderStage]);
                    bindings.push(sampler, texture);
                    uniformGPU = [
                        sampler,
                        texture
                    ];
                } else {
                    bindings.push(texture);
                    uniformGPU = [
                        texture
                    ];
                }
            } else if (type === 'buffer' || type === 'storageBuffer' || type === 'indirectStorageBuffer') {
                const sharedData = this.getSharedDataFromNode(node);
                let buffer = sharedData.buffer;
                if (buffer === undefined) {
                    const bufferClass = type === 'buffer' ? $d89c9137a3d237c2$var$NodeUniformBuffer : $d89c9137a3d237c2$var$NodeStorageBuffer;
                    buffer = new bufferClass(node, group);
                    sharedData.buffer = buffer;
                }
                buffer.setVisibility(buffer.getVisibility() | $d89c9137a3d237c2$var$gpuShaderStageLib[shaderStage]);
                bindings.push(buffer);
                uniformGPU = buffer;
                uniformNode.name = name ? name : 'NodeBuffer_' + uniformNode.id;
            } else {
                const uniformsStage = this.uniformGroups[shaderStage] || (this.uniformGroups[shaderStage] = {});
                let uniformsGroup = uniformsStage[groupName];
                if (uniformsGroup === undefined) {
                    uniformsGroup = new $d89c9137a3d237c2$var$NodeUniformsGroup(groupName, group);
                    uniformsGroup.setVisibility($d89c9137a3d237c2$var$gpuShaderStageLib[shaderStage]);
                    uniformsStage[groupName] = uniformsGroup;
                    bindings.push(uniformsGroup);
                }
                uniformGPU = this.getNodeUniform(uniformNode, type);
                uniformsGroup.addUniform(uniformGPU);
            }
            nodeData.uniformGPU = uniformGPU;
        }
        return uniformNode;
    }
    /**
	 * This method should be used whenever builtins are required in nodes.
	 * The internal builtins data structure will make sure builtins are
	 * defined in the WGSL source.
	 *
	 * @param {string} name - The builtin name.
	 * @param {string} property - The property name.
	 * @param {string} type - The node data type.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The property name.
	 */ getBuiltin(name, property, type, shaderStage = this.shaderStage) {
        const map = this.builtins[shaderStage] || (this.builtins[shaderStage] = new Map());
        if (map.has(name) === false) map.set(name, {
            name: name,
            property: property,
            type: type
        });
        return property;
    }
    /**
	 * Returns `true` if the given builtin is defined in the given shader stage.
	 *
	 * @param {string} name - The builtin name.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {boolean} Whether the given builtin is defined in the given shader stage or not.
	 */ hasBuiltin(name, shaderStage = this.shaderStage) {
        return this.builtins[shaderStage] !== undefined && this.builtins[shaderStage].has(name);
    }
    /**
	 * Returns the vertex index builtin.
	 *
	 * @return {string} The vertex index.
	 */ getVertexIndex() {
        if (this.shaderStage === 'vertex') return this.getBuiltin('vertex_index', 'vertexIndex', 'u32', 'attribute');
        return 'vertexIndex';
    }
    /**
	 * Builds the given shader node.
	 *
	 * @param {ShaderNodeInternal} shaderNode - The shader node.
	 * @return {string} The WGSL function code.
	 */ buildFunctionCode(shaderNode) {
        const layout = shaderNode.layout;
        const flowData = this.flowShaderNode(shaderNode);
        const parameters = [];
        for (const input of layout.inputs)parameters.push(input.name + ' : ' + this.getType(input.type));
        //
        let code = `fn ${layout.name}( ${parameters.join(', ')} ) -> ${this.getType(layout.type)} {
${flowData.vars}
${flowData.code}
`;
        if (flowData.result) code += `\treturn ${flowData.result};\n`;
        code += '\n}\n';
        //
        return code;
    }
    /**
	 * Contextually returns either the vertex stage instance index builtin
	 * or the linearized index of an compute invocation within a grid of workgroups.
	 *
	 * @return {string} The instance index.
	 */ getInstanceIndex() {
        if (this.shaderStage === 'vertex') return this.getBuiltin('instance_index', 'instanceIndex', 'u32', 'attribute');
        return 'instanceIndex';
    }
    /**
	 * Returns a builtin representing the index of a compute invocation within the scope of a workgroup load.
	 *
	 * @return {string} The invocation local index.
	 */ getInvocationLocalIndex() {
        return this.getBuiltin('local_invocation_index', 'invocationLocalIndex', 'u32', 'attribute');
    }
    /**
	 * Returns a builtin representing the size of a subgroup within the current shader.
	 *
	 * @return {string} The subgroup size.
	 */ getSubgroupSize() {
        this.enableSubGroups();
        return this.getBuiltin('subgroup_size', 'subgroupSize', 'u32', 'attribute');
    }
    /**
	 * Returns a builtin representing the index of a compute invocation within the scope of a subgroup.
	 *
	 * @return {string} The invocation subgroup index.
	 */ getInvocationSubgroupIndex() {
        this.enableSubGroups();
        return this.getBuiltin('subgroup_invocation_id', 'invocationSubgroupIndex', 'u32', 'attribute');
    }
    /**
	 * Returns a builtin representing the index of a compute invocation's subgroup within its workgroup.
	 *
	 * @return {string} The subgroup index.
	 */ getSubgroupIndex() {
        this.enableSubGroups();
        return this.getBuiltin('subgroup_id', 'subgroupIndex', 'u32', 'attribute');
    }
    /**
	 * Overwritten as a NOP since this method is intended for the WebGL 2 backend.
	 *
	 * @return {null} Null.
	 */ getDrawIndex() {
        return null;
    }
    /**
	 * Returns the front facing builtin.
	 *
	 * @return {string} The front facing builtin.
	 */ getFrontFacing() {
        return this.getBuiltin('front_facing', 'isFront', 'bool');
    }
    /**
	 * Returns the frag coord builtin.
	 *
	 * @return {string} The frag coord builtin.
	 */ getFragCoord() {
        return this.getBuiltin('position', 'fragCoord', 'vec4<f32>') + '.xy';
    }
    /**
	 * Returns the frag depth builtin.
	 *
	 * @return {string} The frag depth builtin.
	 */ getFragDepth() {
        return 'output.' + this.getBuiltin('frag_depth', 'depth', 'f32', 'output');
    }
    /**
	 * Returns the clip distances builtin.
	 *
	 * @return {string} The clip distances builtin.
	 */ getClipDistance() {
        return 'varyings.hw_clip_distances';
    }
    /**
	 * Whether to flip texture data along its vertical axis or not.
	 *
	 * @return {boolean} Returns always `false` in context of WGSL.
	 */ isFlipY() {
        return false;
    }
    /**
	 * Enables the given directive for the given shader stage.
	 *
	 * @param {string} name - The directive name.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage to enable the directive for.
	 */ enableDirective(name, shaderStage = this.shaderStage) {
        const stage = this.directives[shaderStage] || (this.directives[shaderStage] = new Set());
        stage.add(name);
    }
    /**
	 * Returns the directives of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} A WGSL snippet that enables the directives of the given stage.
	 */ getDirectives(shaderStage) {
        const snippets = [];
        const directives = this.directives[shaderStage];
        if (directives !== undefined) for (const directive of directives)snippets.push(`enable ${directive};`);
        return snippets.join('\n');
    }
    /**
	 * Enables the 'subgroups' directive.
	 */ enableSubGroups() {
        this.enableDirective('subgroups');
    }
    /**
	 * Enables the 'subgroups-f16' directive.
	 */ enableSubgroupsF16() {
        this.enableDirective('subgroups-f16');
    }
    /**
	 * Enables the 'clip_distances' directive.
	 */ enableClipDistances() {
        this.enableDirective('clip_distances');
    }
    /**
	 * Enables the 'f16' directive.
	 */ enableShaderF16() {
        this.enableDirective('f16');
    }
    /**
	 * Enables the 'dual_source_blending' directive.
	 */ enableDualSourceBlending() {
        this.enableDirective('dual_source_blending');
    }
    /**
	 * Enables hardware clipping.
	 *
	 * @param {string} planeCount - The clipping plane count.
	 */ enableHardwareClipping(planeCount) {
        this.enableClipDistances();
        this.getBuiltin('clip_distances', 'hw_clip_distances', `array<f32, ${planeCount} >`, 'vertex');
    }
    /**
	 * Returns the builtins of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} A WGSL snippet that represents the builtins of the given stage.
	 */ getBuiltins(shaderStage) {
        const snippets = [];
        const builtins = this.builtins[shaderStage];
        if (builtins !== undefined) for (const { name: name, property: property, type: type } of builtins.values())snippets.push(`@builtin( ${name} ) ${property} : ${type}`);
        return snippets.join(',\n\t');
    }
    /**
	 * This method should be used when a new scoped buffer is used in context of
	 * compute shaders. It adds the array to the internal data structure which is
	 * later used to generate the respective WGSL.
	 *
	 * @param {string} name - The array name.
	 * @param {string} scope - The scope.
	 * @param {string} bufferType - The buffer type.
	 * @param {string} bufferCount - The buffer count.
	 * @return {string} The array name.
	 */ getScopedArray(name, scope, bufferType, bufferCount) {
        if (this.scopedArrays.has(name) === false) this.scopedArrays.set(name, {
            name: name,
            scope: scope,
            bufferType: bufferType,
            bufferCount: bufferCount
        });
        return name;
    }
    /**
	 * Returns the scoped arrays of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string|undefined} The WGSL snippet that defines the scoped arrays.
	 * Returns `undefined` when used in the vertex or fragment stage.
	 */ getScopedArrays(shaderStage) {
        if (shaderStage !== 'compute') return;
        const snippets = [];
        for (const { name: name, scope: scope, bufferType: bufferType, bufferCount: bufferCount } of this.scopedArrays.values()){
            const type = this.getType(bufferType);
            snippets.push(`var<${scope}> ${name}: array< ${type}, ${bufferCount} >;`);
        }
        return snippets.join('\n');
    }
    /**
	 * Returns the shader attributes of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet that defines the shader attributes.
	 */ getAttributes(shaderStage) {
        const snippets = [];
        if (shaderStage === 'compute') {
            this.getBuiltin('global_invocation_id', 'globalId', 'vec3<u32>', 'attribute');
            this.getBuiltin('workgroup_id', 'workgroupId', 'vec3<u32>', 'attribute');
            this.getBuiltin('local_invocation_id', 'localId', 'vec3<u32>', 'attribute');
            this.getBuiltin('num_workgroups', 'numWorkgroups', 'vec3<u32>', 'attribute');
            if (this.renderer.hasFeature('subgroups')) {
                this.enableDirective('subgroups', shaderStage);
                this.getBuiltin('subgroup_size', 'subgroupSize', 'u32', 'attribute');
            }
        }
        if (shaderStage === 'vertex' || shaderStage === 'compute') {
            const builtins = this.getBuiltins('attribute');
            if (builtins) snippets.push(builtins);
            const attributes = this.getAttributesArray();
            for(let index = 0, length = attributes.length; index < length; index++){
                const attribute = attributes[index];
                const name = attribute.name;
                const type = this.getType(attribute.type);
                snippets.push(`@location( ${index} ) ${name} : ${type}`);
            }
        }
        return snippets.join(',\n\t');
    }
    /**
	 * Returns the members of the given struct type node as a WGSL string.
	 *
	 * @param {StructTypeNode} struct - The struct type node.
	 * @return {string} The WGSL snippet that defines the struct members.
	 */ getStructMembers(struct) {
        const snippets = [];
        for (const member of struct.members){
            const prefix = struct.output ? '@location( ' + member.index + ' ) ' : '';
            let type = this.getType(member.type);
            if (member.atomic) type = 'atomic< ' + type + ' >';
            snippets.push(`\t${prefix + member.name} : ${type}`);
        }
        if (struct.output) snippets.push(`\t${this.getBuiltins('output')}`);
        return snippets.join(',\n');
    }
    /**
	 * Returns the structs of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet that defines the structs.
	 */ getStructs(shaderStage) {
        let result = '';
        const structs = this.structs[shaderStage];
        if (structs.length > 0) {
            const snippets = [];
            for (const struct of structs){
                let snippet = `struct ${struct.name} {\n`;
                snippet += this.getStructMembers(struct);
                snippet += '\n};';
                snippets.push(snippet);
            }
            result = '\n' + snippets.join('\n\n') + '\n';
        }
        return result;
    }
    /**
	 * Returns a WGSL string representing a variable.
	 *
	 * @param {string} type - The variable's type.
	 * @param {string} name - The variable's name.
	 * @param {?number} [count=null] - The array length.
	 * @return {string} The WGSL snippet that defines a variable.
	 */ getVar(type, name, count = null) {
        let snippet = `var ${name} : `;
        if (count !== null) snippet += this.generateArrayDeclaration(type, count);
        else snippet += this.getType(type);
        return snippet;
    }
    /**
	 * Returns the variables of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet that defines the variables.
	 */ getVars(shaderStage) {
        const snippets = [];
        const vars = this.vars[shaderStage];
        if (vars !== undefined) for (const variable of vars)snippets.push(`\t${this.getVar(variable.type, variable.name, variable.count)};`);
        return `\n${snippets.join('\n')}\n`;
    }
    /**
	 * Returns the varyings of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet that defines the varyings.
	 */ getVaryings(shaderStage) {
        const snippets = [];
        if (shaderStage === 'vertex') this.getBuiltin('position', 'Vertex', 'vec4<f32>', 'vertex');
        if (shaderStage === 'vertex' || shaderStage === 'fragment') {
            const varyings = this.varyings;
            const vars = this.vars[shaderStage];
            for(let index = 0; index < varyings.length; index++){
                const varying = varyings[index];
                if (varying.needsInterpolation) {
                    let attributesSnippet = `@location( ${index} )`;
                    if (varying.interpolationType) {
                        const samplingSnippet = varying.interpolationSampling !== null ? `, ${varying.interpolationSampling} )` : ' )';
                        attributesSnippet += ` @interpolate( ${varying.interpolationType}${samplingSnippet}`;
                    // Otherwise, optimize interpolation when sensible
                    } else if (/^(int|uint|ivec|uvec)/.test(varying.type)) attributesSnippet += ` @interpolate( ${this.renderer.backend.compatibilityMode ? 'flat, either' : 'flat'} )`;
                    snippets.push(`${attributesSnippet} ${varying.name} : ${this.getType(varying.type)}`);
                } else if (shaderStage === 'vertex' && vars.includes(varying) === false) vars.push(varying);
            }
        }
        const builtins = this.getBuiltins(shaderStage);
        if (builtins) snippets.push(builtins);
        const code = snippets.join(',\n\t');
        return shaderStage === 'vertex' ? this._getWGSLStruct('VaryingsStruct', '\t' + code) : code;
    }
    isCustomStruct(nodeUniform) {
        const attribute = nodeUniform.value;
        const bufferNode = nodeUniform.node;
        const isAttributeStructType = (attribute.isBufferAttribute || attribute.isInstancedBufferAttribute) && bufferNode.structTypeNode !== null;
        const isStructArray = bufferNode.value && bufferNode.value.array && typeof bufferNode.value.itemSize === 'number' && bufferNode.value.array.length > bufferNode.value.itemSize;
        return isAttributeStructType && !isStructArray;
    }
    /**
	 * Returns the uniforms of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet that defines the uniforms.
	 */ getUniforms(shaderStage) {
        const uniforms = this.uniforms[shaderStage];
        const bindingSnippets = [];
        const bufferSnippets = [];
        const structSnippets = [];
        const uniformGroups = {};
        for (const uniform of uniforms){
            const groupName = uniform.groupNode.name;
            const uniformIndexes = this.bindingsIndexes[groupName];
            if (uniform.type === 'texture' || uniform.type === 'cubeTexture' || uniform.type === 'cubeDepthTexture' || uniform.type === 'storageTexture' || uniform.type === 'texture3D') {
                const texture = uniform.node.value;
                if (this.isUnfilterable(texture) === false && uniform.node.isStorageTextureNode !== true) {
                    if (this.isSampleCompare(texture)) bindingSnippets.push(`@binding( ${uniformIndexes.binding++} ) @group( ${uniformIndexes.group} ) var ${uniform.name}_sampler : sampler_comparison;`);
                    else bindingSnippets.push(`@binding( ${uniformIndexes.binding++} ) @group( ${uniformIndexes.group} ) var ${uniform.name}_sampler : sampler;`);
                }
                let textureType;
                let multisampled = '';
                const { primarySamples: primarySamples } = this.renderer.backend.utils.getTextureSampleData(texture);
                if (primarySamples > 1) multisampled = '_multisampled';
                if (texture.isCubeTexture === true && texture.isDepthTexture === true) textureType = 'texture_depth_cube';
                else if (texture.isCubeTexture === true) textureType = 'texture_cube<f32>';
                else if (texture.isDepthTexture === true) {
                    if (this.renderer.backend.compatibilityMode && texture.compareFunction === null) textureType = `texture${multisampled}_2d<f32>`;
                    else textureType = `texture_depth${multisampled}_2d${texture.isArrayTexture === true ? '_array' : ''}`;
                } else if (uniform.node.isStorageTextureNode === true) {
                    const format = $d89c9137a3d237c2$var$getFormat(texture);
                    const access = this.getStorageAccess(uniform.node, shaderStage);
                    const is3D = uniform.node.value.is3DTexture;
                    const isArrayTexture = uniform.node.value.isArrayTexture;
                    const dimension = is3D ? '3d' : `2d${isArrayTexture ? '_array' : ''}`;
                    textureType = `texture_storage_${dimension}<${format}, ${access}>`;
                } else if (texture.isArrayTexture === true || texture.isDataArrayTexture === true || texture.isCompressedArrayTexture === true) textureType = 'texture_2d_array<f32>';
                else if (texture.is3DTexture === true || texture.isData3DTexture === true) textureType = 'texture_3d<f32>';
                else {
                    const componentPrefix = this.getComponentTypeFromTexture(texture).charAt(0);
                    textureType = `texture${multisampled}_2d<${componentPrefix}32>`;
                }
                bindingSnippets.push(`@binding( ${uniformIndexes.binding++} ) @group( ${uniformIndexes.group} ) var ${uniform.name} : ${textureType};`);
            } else if (uniform.type === 'buffer' || uniform.type === 'storageBuffer' || uniform.type === 'indirectStorageBuffer') {
                const bufferNode = uniform.node;
                const bufferType = this.getType(bufferNode.getNodeType(this));
                const bufferCount = bufferNode.bufferCount;
                const bufferCountSnippet = bufferCount > 0 && uniform.type === 'buffer' ? ', ' + bufferCount : '';
                const bufferAccessMode = bufferNode.isStorageBufferNode ? `storage, ${this.getStorageAccess(bufferNode, shaderStage)}` : 'uniform';
                if (this.isCustomStruct(uniform)) bufferSnippets.push(`@binding( ${uniformIndexes.binding++} ) @group( ${uniformIndexes.group} ) var<${bufferAccessMode}> ${uniform.name} : ${bufferType};`);
                else {
                    const bufferTypeSnippet = bufferNode.isAtomic ? `atomic<${bufferType}>` : `${bufferType}`;
                    const bufferSnippet = `\tvalue : array< ${bufferTypeSnippet}${bufferCountSnippet} >`;
                    bufferSnippets.push(this._getWGSLStructBinding(uniform.name, bufferSnippet, bufferAccessMode, uniformIndexes.binding++, uniformIndexes.group));
                }
            } else {
                const vectorType = this.getType(this.getVectorType(uniform.type));
                const groupName = uniform.groupNode.name;
                const group = uniformGroups[groupName] || (uniformGroups[groupName] = {
                    index: uniformIndexes.binding++,
                    id: uniformIndexes.group,
                    snippets: []
                });
                group.snippets.push(`\t${uniform.name} : ${vectorType}`);
            }
        }
        for(const name in uniformGroups){
            const group = uniformGroups[name];
            structSnippets.push(this._getWGSLStructBinding(name, group.snippets.join(',\n'), 'uniform', group.index, group.id));
        }
        const code = [
            ...bindingSnippets,
            ...bufferSnippets,
            ...structSnippets
        ].join('\n');
        return code;
    }
    /**
	 * Controls the code build of the shader stages.
	 */ buildCode() {
        const shadersData = this.material !== null ? {
            fragment: {},
            vertex: {}
        } : {
            compute: {}
        };
        this.sortBindingGroups();
        for(const shaderStage in shadersData){
            this.shaderStage = shaderStage;
            const stageData = shadersData[shaderStage];
            stageData.uniforms = this.getUniforms(shaderStage);
            stageData.attributes = this.getAttributes(shaderStage);
            stageData.varyings = this.getVaryings(shaderStage);
            stageData.structs = this.getStructs(shaderStage);
            stageData.vars = this.getVars(shaderStage);
            stageData.codes = this.getCodes(shaderStage);
            stageData.directives = this.getDirectives(shaderStage);
            stageData.scopedArrays = this.getScopedArrays(shaderStage);
            //
            let flow = '// code\n\n';
            flow += this.flowCode[shaderStage];
            const flowNodes = this.flowNodes[shaderStage];
            const mainNode = flowNodes[flowNodes.length - 1];
            const outputNode = mainNode.outputNode;
            const isOutputStruct = outputNode !== undefined && outputNode.isOutputStructNode === true;
            for (const node of flowNodes){
                const flowSlotData = this.getFlowData(node /*, shaderStage*/ );
                const slotName = node.name;
                if (slotName) {
                    if (flow.length > 0) flow += '\n';
                    flow += `\t// flow -> ${slotName}\n`;
                }
                flow += `${flowSlotData.code}\n\t`;
                if (node === mainNode && shaderStage !== 'compute') {
                    flow += '// result\n\n\t';
                    if (shaderStage === 'vertex') flow += `varyings.Vertex = ${flowSlotData.result};`;
                    else if (shaderStage === 'fragment') {
                        if (isOutputStruct) {
                            stageData.returnType = outputNode.getNodeType(this);
                            stageData.structs += 'var<private> output : ' + stageData.returnType + ';';
                            flow += `return ${flowSlotData.result};`;
                        } else {
                            let structSnippet = '\t@location(0) color: vec4<f32>';
                            const builtins = this.getBuiltins('output');
                            if (builtins) structSnippet += ',\n\t' + builtins;
                            stageData.returnType = 'OutputStruct';
                            stageData.structs += this._getWGSLStruct('OutputStruct', structSnippet);
                            stageData.structs += '\nvar<private> output : OutputStruct;';
                            flow += `output.color = ${flowSlotData.result};\n\n\treturn output;`;
                        }
                    }
                }
            }
            stageData.flow = flow;
        }
        this.shaderStage = null;
        if (this.material !== null) {
            this.vertexShader = this._getWGSLVertexCode(shadersData.vertex);
            this.fragmentShader = this._getWGSLFragmentCode(shadersData.fragment);
        } else {
            // Early strictly validated in computeNode
            const workgroupSize = this.object.workgroupSize;
            this.computeShader = this._getWGSLComputeCode(shadersData.compute, workgroupSize);
        }
    }
    /**
	 * Returns the native shader method name for a given generic name.
	 *
	 * @param {string} method - The method name to resolve.
	 * @param {?string} [output=null] - An optional output.
	 * @return {string} The resolved WGSL method name.
	 */ getMethod(method, output = null) {
        let wgslMethod;
        if (output !== null) wgslMethod = this._getWGSLMethod(method + '_' + output);
        if (wgslMethod === undefined) wgslMethod = this._getWGSLMethod(method);
        return wgslMethod || method;
    }
    /**
	 * Returns the bitcast method name for a given input and outputType.
	 *
	 * @param {string} type - The output type to bitcast to.
	 * @return {string} The resolved WGSL bitcast invocation.
	 */ getBitcastMethod(type) {
        const dataType = this.getType(type);
        return `bitcast<${dataType}>`;
    }
    /**
	 * Returns the float packing method name for a given numeric encoding.
	 *
	 * @param {string} encoding - The numeric encoding that describes how the float values are mapped to the integer range.
	 * @returns {string} The resolve WGSL float packing method name.
	 */ getFloatPackingMethod(encoding) {
        return this.getMethod(`floatpack_${encoding}_2x16`);
    }
    /**
	 * Returns the float unpacking method name for a given numeric encoding.
	 *
	 * @param {string} encoding - The numeric encoding that describes how the integer values are mapped to the float range.
	 * @returns {string} The resolve WGSL float unpacking method name.
	 */ getFloatUnpackingMethod(encoding) {
        return this.getMethod(`floatunpack_${encoding}_2x16`);
    }
    /**
	 * Returns the native snippet for a ternary operation.
	 *
	 * @param {string} condSnippet - The condition determining which expression gets resolved.
	 * @param {string} ifSnippet - The expression to resolve to if the condition is true.
	 * @param {string} elseSnippet - The expression to resolve to if the condition is false.
	 * @return {string} The resolved method name.
	 */ getTernary(condSnippet, ifSnippet, elseSnippet) {
        return `select( ${elseSnippet}, ${ifSnippet}, ${condSnippet} )`;
    }
    /**
	 * Returns the WGSL type of the given node data type.
	 *
	 * @param {string} type - The node data type.
	 * @return {string} The WGSL type.
	 */ getType(type) {
        return $d89c9137a3d237c2$var$wgslTypeLib[type] || type;
    }
    /**
	 * Whether the requested feature is available or not.
	 *
	 * @param {string} name - The requested feature.
	 * @return {boolean} Whether the requested feature is supported or not.
	 */ isAvailable(name) {
        let result = $d89c9137a3d237c2$var$supports[name];
        if (result === undefined) {
            if (name === 'float32Filterable') result = this.renderer.hasFeature('float32-filterable');
            else if (name === 'clipDistance') result = this.renderer.hasFeature('clip-distances');
            $d89c9137a3d237c2$var$supports[name] = result;
        }
        return result;
    }
    /**
	 * Returns the native shader method name for a given generic name.
	 *
	 * @private
	 * @param {string} method - The method name to resolve.
	 * @return {string} The resolved WGSL method name.
	 */ _getWGSLMethod(method) {
        if ($d89c9137a3d237c2$var$wgslPolyfill[method] !== undefined) this._include(method);
        return $d89c9137a3d237c2$var$wgslMethods[method];
    }
    /**
	 * Includes the given method name into the current
	 * function node.
	 *
	 * @private
	 * @param {string} name - The method name to include.
	 * @return {CodeNode} The respective code node.
	 */ _include(name) {
        const codeNode = $d89c9137a3d237c2$var$wgslPolyfill[name];
        codeNode.build(this);
        this.addInclude(codeNode);
        return codeNode;
    }
    /**
	 * Returns a WGSL vertex shader based on the given shader data.
	 *
	 * @private
	 * @param {Object} shaderData - The shader data.
	 * @return {string} The vertex shader.
	 */ _getWGSLVertexCode(shaderData) {
        return `${this.getSignature()}
// directives
${shaderData.directives}

// structs
${shaderData.structs}

// uniforms
${shaderData.uniforms}

// varyings
${shaderData.varyings}
var<private> varyings : VaryingsStruct;

// codes
${shaderData.codes}

@vertex
fn main( ${shaderData.attributes} ) -> VaryingsStruct {

	// vars
	${shaderData.vars}

	// flow
	${shaderData.flow}

	return varyings;

}
`;
    }
    /**
	 * Returns a WGSL fragment shader based on the given shader data.
	 *
	 * @private
	 * @param {Object} shaderData - The shader data.
	 * @return {string} The vertex shader.
	 */ _getWGSLFragmentCode(shaderData) {
        return `${this.getSignature()}
// global
${$d89c9137a3d237c2$var$diagnostics}

// structs
${shaderData.structs}

// uniforms
${shaderData.uniforms}

// codes
${shaderData.codes}

@fragment
fn main( ${shaderData.varyings} ) -> ${shaderData.returnType} {

	// vars
	${shaderData.vars}

	// flow
	${shaderData.flow}

}
`;
    }
    /**
	 * Returns a WGSL compute shader based on the given shader data.
	 *
	 * @private
	 * @param {Object} shaderData - The shader data.
	 * @param {string} workgroupSize - The workgroup size.
	 * @return {string} The vertex shader.
	 */ _getWGSLComputeCode(shaderData, workgroupSize) {
        const [workgroupSizeX, workgroupSizeY, workgroupSizeZ] = workgroupSize;
        return `${this.getSignature()}
// directives
${shaderData.directives}

// system
var<private> instanceIndex : u32;

// locals
${shaderData.scopedArrays}

// structs
${shaderData.structs}

// uniforms
${shaderData.uniforms}

// codes
${shaderData.codes}

@compute @workgroup_size( ${workgroupSizeX}, ${workgroupSizeY}, ${workgroupSizeZ} )
fn main( ${shaderData.attributes} ) {

	// system
	instanceIndex = globalId.x
		+ globalId.y * ( ${workgroupSizeX} * numWorkgroups.x )
		+ globalId.z * ( ${workgroupSizeX} * numWorkgroups.x ) * ( ${workgroupSizeY} * numWorkgroups.y );

	// vars
	${shaderData.vars}

	// flow
	${shaderData.flow}

}
`;
    }
    /**
	 * Returns a WGSL struct based on the given name and variables.
	 *
	 * @private
	 * @param {string} name - The struct name.
	 * @param {string} vars - The struct variables.
	 * @return {string} The WGSL snippet representing a struct.
	 */ _getWGSLStruct(name, vars) {
        return `
struct ${name} {
${vars}
};`;
    }
    /**
	 * Returns a WGSL struct binding.
	 *
	 * @private
	 * @param {string} name - The struct name.
	 * @param {string} vars - The struct variables.
	 * @param {string} access - The access.
	 * @param {number} [binding=0] - The binding index.
	 * @param {number} [group=0] - The group index.
	 * @return {string} The WGSL snippet representing a struct binding.
	 */ _getWGSLStructBinding(name, vars, access, binding = 0, group = 0) {
        const structName = name + 'Struct';
        const structSnippet = this._getWGSLStruct(structName, vars);
        return `${structSnippet}
@binding( ${binding} ) @group( ${group} )
var<${access}> ${name} : ${structName};`;
    }
}
/**
 * A WebGPU backend utility module with common helpers.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGPUUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGPUBackend} backend - The WebGPU backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGPU backend.
		 *
		 * @type {WebGPUBackend}
		 */ this.backend = backend;
    }
    /**
	 * Returns the depth/stencil GPU format for the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {string} The depth/stencil GPU texture format.
	 */ getCurrentDepthStencilFormat(renderContext) {
        let format;
        if (renderContext.depthTexture !== null) format = this.getTextureFormatGPU(renderContext.depthTexture);
        else if (renderContext.depth && renderContext.stencil) format = $d89c9137a3d237c2$var$GPUTextureFormat.Depth24PlusStencil8;
        else if (renderContext.depth) format = $d89c9137a3d237c2$var$GPUTextureFormat.Depth24Plus;
        return format;
    }
    /**
	 * Returns the GPU format for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {string} The GPU texture format.
	 */ getTextureFormatGPU(texture) {
        return this.backend.get(texture).format;
    }
    /**
	 * Returns an object that defines the multi-sampling state of the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {Object} The multi-sampling state.
	 */ getTextureSampleData(texture) {
        let samples;
        if (texture.isFramebufferTexture) samples = 1;
        else if (texture.isDepthTexture && !texture.renderTarget) {
            const renderer = this.backend.renderer;
            const renderTarget = renderer.getRenderTarget();
            samples = renderTarget ? renderTarget.samples : renderer.currentSamples;
        } else if (texture.renderTarget) samples = texture.renderTarget.samples;
        samples = samples || 1;
        const isMSAA = samples > 1 && texture.renderTarget !== null && texture.isDepthTexture !== true && texture.isFramebufferTexture !== true;
        const primarySamples = isMSAA ? 1 : samples;
        return {
            samples: samples,
            primarySamples: primarySamples,
            isMSAA: isMSAA
        };
    }
    /**
	 * Returns the default color attachment's GPU format of the current render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {string} The GPU texture format of the default color attachment.
	 */ getCurrentColorFormat(renderContext) {
        let format;
        if (renderContext.textures !== null) format = this.getTextureFormatGPU(renderContext.textures[0]);
        else format = this.getPreferredCanvasFormat(); // default context format
        return format;
    }
    /**
	 * Returns the GPU formats of all color attachments of the current render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {Array<string>} The GPU texture formats of all color attachments.
	 */ getCurrentColorFormats(renderContext) {
        if (renderContext.textures !== null) return renderContext.textures.map((t)=>this.getTextureFormatGPU(t));
        else return [
            this.getPreferredCanvasFormat()
        ]; // default context format
    }
    /**
	 * Returns the output color space of the current render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {string} The output color space.
	 */ getCurrentColorSpace(renderContext) {
        if (renderContext.textures !== null) return renderContext.textures[0].colorSpace;
        return this.backend.renderer.outputColorSpace;
    }
    /**
	 * Returns GPU primitive topology for the given object and material.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The material.
	 * @return {string} The GPU primitive topology.
	 */ getPrimitiveTopology(object, material) {
        if (object.isPoints) return $d89c9137a3d237c2$var$GPUPrimitiveTopology.PointList;
        else if (object.isLineSegments || object.isMesh && material.wireframe === true) return $d89c9137a3d237c2$var$GPUPrimitiveTopology.LineList;
        else if (object.isLine) return $d89c9137a3d237c2$var$GPUPrimitiveTopology.LineStrip;
        else if (object.isMesh) return $d89c9137a3d237c2$var$GPUPrimitiveTopology.TriangleList;
    }
    /**
	 * Returns a modified sample count from the given sample count value.
	 *
	 * That is required since WebGPU only supports either 1 or 4.
	 *
	 * @param {number} sampleCount - The input sample count.
	 * @return {number} The (potentially updated) output sample count.
	 */ getSampleCount(sampleCount) {
        return sampleCount >= 4 ? 4 : 1;
    }
    /**
	 * Returns the sample count of the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {number} The sample count.
	 */ getSampleCountRenderContext(renderContext) {
        if (renderContext.textures !== null) return this.getSampleCount(renderContext.sampleCount);
        return this.getSampleCount(this.backend.renderer.currentSamples);
    }
    /**
	 * Returns the preferred canvas format.
	 *
	 * There is a separate method for this so it's possible to
	 * honor edge cases for specific devices.
	 *
	 * @return {string} The GPU texture format of the canvas.
	 */ getPreferredCanvasFormat() {
        const parameters = this.backend.parameters;
        const bufferType = parameters.outputType;
        if (bufferType === undefined) return navigator.gpu.getPreferredCanvasFormat();
        else if (bufferType === (0, $329ek.UnsignedByteType)) return $d89c9137a3d237c2$var$GPUTextureFormat.BGRA8Unorm;
        else if (bufferType === (0, $329ek.HalfFloatType)) return $d89c9137a3d237c2$var$GPUTextureFormat.RGBA16Float;
        else throw new Error('Unsupported output buffer type.');
    }
}
const $d89c9137a3d237c2$var$typedArraysToVertexFormatPrefix = new Map([
    [
        Int8Array,
        [
            'sint8',
            'snorm8'
        ]
    ],
    [
        Uint8Array,
        [
            'uint8',
            'unorm8'
        ]
    ],
    [
        Int16Array,
        [
            'sint16',
            'snorm16'
        ]
    ],
    [
        Uint16Array,
        [
            'uint16',
            'unorm16'
        ]
    ],
    [
        Int32Array,
        [
            'sint32',
            'snorm32'
        ]
    ],
    [
        Uint32Array,
        [
            'uint32',
            'unorm32'
        ]
    ],
    [
        Float32Array,
        [
            'float32'
        ]
    ]
]);
if (typeof Float16Array !== 'undefined') $d89c9137a3d237c2$var$typedArraysToVertexFormatPrefix.set(Float16Array, [
    'float16'
]);
const $d89c9137a3d237c2$var$typedAttributeToVertexFormatPrefix = new Map([
    [
        (0, $329ek.Float16BufferAttribute),
        [
            'float16'
        ]
    ]
]);
const $d89c9137a3d237c2$var$typeArraysToVertexFormatPrefixForItemSize1 = new Map([
    [
        Int32Array,
        'sint32'
    ],
    [
        Int16Array,
        'sint32'
    ],
    [
        Uint32Array,
        'uint32'
    ],
    [
        Uint16Array,
        'uint32'
    ],
    [
        Float32Array,
        'float32'
    ]
]);
/**
 * A WebGPU backend utility module for managing shader attributes.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGPUAttributeUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGPUBackend} backend - The WebGPU backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGPU backend.
		 *
		 * @type {WebGPUBackend}
		 */ this.backend = backend;
    }
    /**
	 * Creates the GPU buffer for the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 * @param {GPUBufferUsage} usage - A flag that indicates how the buffer may be used after its creation.
	 */ createAttribute(attribute, usage) {
        const bufferAttribute = this._getBufferAttribute(attribute);
        const backend = this.backend;
        const bufferData = backend.get(bufferAttribute);
        let buffer = bufferData.buffer;
        if (buffer === undefined) {
            const device = backend.device;
            let array = bufferAttribute.array;
            // patch for INT16 and UINT16
            if (attribute.normalized === false) {
                if (array.constructor === Int16Array || array.constructor === Int8Array) array = new Int32Array(array);
                else if (array.constructor === Uint16Array || array.constructor === Uint8Array) {
                    array = new Uint32Array(array);
                    if (usage & GPUBufferUsage.INDEX) {
                        for(let i = 0; i < array.length; i++)if (array[i] === 0xffff) array[i] = 0xffffffff; // use correct primitive restart index
                    }
                }
            }
            bufferAttribute.array = array;
            if ((bufferAttribute.isStorageBufferAttribute || bufferAttribute.isStorageInstancedBufferAttribute) && bufferAttribute.itemSize === 3) {
                array = new array.constructor(bufferAttribute.count * 4);
                for(let i = 0; i < bufferAttribute.count; i++)array.set(bufferAttribute.array.subarray(i * 3, i * 3 + 3), i * 4);
                // Update BufferAttribute
                bufferAttribute.itemSize = 4;
                bufferAttribute.array = array;
                bufferData._force3to4BytesAlignment = true;
            }
            // ensure 4 byte alignment
            const byteLength = array.byteLength;
            const size = byteLength + (4 - byteLength % 4) % 4;
            buffer = device.createBuffer({
                label: bufferAttribute.name,
                size: size,
                usage: usage,
                mappedAtCreation: true
            });
            new array.constructor(buffer.getMappedRange()).set(array);
            buffer.unmap();
            bufferData.buffer = buffer;
        }
    }
    /**
	 * Updates the GPU buffer of the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ updateAttribute(attribute) {
        const bufferAttribute = this._getBufferAttribute(attribute);
        const backend = this.backend;
        const device = backend.device;
        const bufferData = backend.get(bufferAttribute);
        const buffer = backend.get(bufferAttribute).buffer;
        let array = bufferAttribute.array;
        //  if storage buffer ensure 4 byte alignment
        if (bufferData._force3to4BytesAlignment === true) {
            array = new array.constructor(bufferAttribute.count * 4);
            for(let i = 0; i < bufferAttribute.count; i++)array.set(bufferAttribute.array.subarray(i * 3, i * 3 + 3), i * 4);
            bufferAttribute.array = array;
        }
        const updateRanges = bufferAttribute.updateRanges;
        if (updateRanges.length === 0) // Not using update ranges
        device.queue.writeBuffer(buffer, 0, array, 0);
        else {
            const isTyped = (0, $329ek.isTypedArray)(array);
            const byteOffsetFactor = isTyped ? 1 : array.BYTES_PER_ELEMENT;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                let dataOffset, size;
                if (bufferData._force3to4BytesAlignment === true) {
                    const vertexStart = Math.floor(range.start / 3);
                    const vertexCount = Math.ceil(range.count / 3);
                    dataOffset = vertexStart * 4 * byteOffsetFactor;
                    size = vertexCount * 4 * byteOffsetFactor;
                } else {
                    dataOffset = range.start * byteOffsetFactor;
                    size = range.count * byteOffsetFactor;
                }
                const bufferOffset = dataOffset * (isTyped ? array.BYTES_PER_ELEMENT : 1); // bufferOffset is always in bytes
                device.queue.writeBuffer(buffer, bufferOffset, array, dataOffset, size);
            }
            bufferAttribute.clearUpdateRanges();
        }
    }
    /**
	 * This method creates the vertex buffer layout data which are
	 * require when creating a render pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {Array<Object>} An array holding objects which describe the vertex buffer layout.
	 */ createShaderVertexBuffers(renderObject) {
        const attributes = renderObject.getAttributes();
        const vertexBuffers = new Map();
        for(let slot = 0; slot < attributes.length; slot++){
            const geometryAttribute = attributes[slot];
            const bytesPerElement = geometryAttribute.array.BYTES_PER_ELEMENT;
            const bufferAttribute = this._getBufferAttribute(geometryAttribute);
            let vertexBufferLayout = vertexBuffers.get(bufferAttribute);
            if (vertexBufferLayout === undefined) {
                let arrayStride, stepMode;
                if (geometryAttribute.isInterleavedBufferAttribute === true) {
                    arrayStride = geometryAttribute.data.stride * bytesPerElement;
                    stepMode = geometryAttribute.data.isInstancedInterleavedBuffer ? $d89c9137a3d237c2$var$GPUInputStepMode.Instance : $d89c9137a3d237c2$var$GPUInputStepMode.Vertex;
                } else {
                    arrayStride = geometryAttribute.itemSize * bytesPerElement;
                    stepMode = geometryAttribute.isInstancedBufferAttribute ? $d89c9137a3d237c2$var$GPUInputStepMode.Instance : $d89c9137a3d237c2$var$GPUInputStepMode.Vertex;
                }
                // patch for INT16 and UINT16
                if (geometryAttribute.normalized === false && (geometryAttribute.array.constructor === Int16Array || geometryAttribute.array.constructor === Uint16Array)) arrayStride = 4;
                vertexBufferLayout = {
                    arrayStride: arrayStride,
                    attributes: [],
                    stepMode: stepMode
                };
                vertexBuffers.set(bufferAttribute, vertexBufferLayout);
            }
            const format = this._getVertexFormat(geometryAttribute);
            const offset = geometryAttribute.isInterleavedBufferAttribute === true ? geometryAttribute.offset * bytesPerElement : 0;
            vertexBufferLayout.attributes.push({
                shaderLocation: slot,
                offset: offset,
                format: format
            });
        }
        return Array.from(vertexBuffers.values());
    }
    /**
	 * Destroys the GPU buffer of the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ destroyAttribute(attribute) {
        const backend = this.backend;
        const data = backend.get(this._getBufferAttribute(attribute));
        data.buffer.destroy();
        backend.delete(attribute);
    }
    /**
	 * This method performs a readback operation by moving buffer data from
	 * a storage buffer attribute from the GPU to the CPU.
	 *
	 * @async
	 * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
	 * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync(attribute) {
        const backend = this.backend;
        const device = backend.device;
        const data = backend.get(this._getBufferAttribute(attribute));
        const bufferGPU = data.buffer;
        const size = bufferGPU.size;
        const readBufferGPU = device.createBuffer({
            label: `${attribute.name}_readback`,
            size: size,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        });
        const cmdEncoder = device.createCommandEncoder({
            label: `readback_encoder_${attribute.name}`
        });
        cmdEncoder.copyBufferToBuffer(bufferGPU, 0, readBufferGPU, 0, size);
        const gpuCommands = cmdEncoder.finish();
        device.queue.submit([
            gpuCommands
        ]);
        await readBufferGPU.mapAsync(GPUMapMode.READ);
        const arrayBuffer = readBufferGPU.getMappedRange();
        const dstBuffer = new attribute.array.constructor(arrayBuffer.slice(0));
        readBufferGPU.unmap();
        return dstBuffer.buffer;
    }
    /**
	 * Returns the vertex format of the given buffer attribute.
	 *
	 * @private
	 * @param {BufferAttribute} geometryAttribute - The buffer attribute.
	 * @return {string|undefined} The vertex format (e.g. 'float32x3').
	 */ _getVertexFormat(geometryAttribute) {
        const { itemSize: itemSize, normalized: normalized } = geometryAttribute;
        const ArrayType = geometryAttribute.array.constructor;
        const AttributeType = geometryAttribute.constructor;
        let format;
        if (itemSize === 1) format = $d89c9137a3d237c2$var$typeArraysToVertexFormatPrefixForItemSize1.get(ArrayType);
        else {
            const prefixOptions = $d89c9137a3d237c2$var$typedAttributeToVertexFormatPrefix.get(AttributeType) || $d89c9137a3d237c2$var$typedArraysToVertexFormatPrefix.get(ArrayType);
            const prefix = prefixOptions[normalized ? 1 : 0];
            if (prefix) {
                const bytesPerUnit = ArrayType.BYTES_PER_ELEMENT * itemSize;
                const paddedBytesPerUnit = Math.floor((bytesPerUnit + 3) / 4) * 4;
                const paddedItemSize = paddedBytesPerUnit / ArrayType.BYTES_PER_ELEMENT;
                if (paddedItemSize % 1) throw new Error('THREE.WebGPUAttributeUtils: Bad vertex format item size.');
                format = `${prefix}x${paddedItemSize}`;
            }
        }
        if (!format) (0, $329ek.error)('WebGPUAttributeUtils: Vertex format not supported yet.');
        return format;
    }
    /**
	 * Utility method for handling interleaved buffer attributes correctly.
	 * To process them, their `InterleavedBuffer` is returned.
	 *
	 * @private
	 * @param {BufferAttribute} attribute - The attribute.
	 * @return {BufferAttribute|InterleavedBuffer}
	 */ _getBufferAttribute(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return attribute;
    }
}
/**
 * Class representing a WebGPU bind group layout.
 *
 * @private
 */ class $d89c9137a3d237c2$var$BindGroupLayout {
    /**
	 * Constructs a new layout.
	 *
	 * @param {GPUBindGroupLayout} layoutGPU - A GPU Bind Group Layout.
	 */ constructor(layoutGPU){
        /**
		 * The current GPUBindGroupLayout.
		 *
		 * @type {GPUBindGroupLayout}
		 */ this.layoutGPU = layoutGPU;
        /**
		 * The number of bind groups that use this layout.
		 *
		 * @type {number}
		 */ this.usedTimes = 0;
    }
}
/**
 * A WebGPU backend utility module for managing bindings.
 *
 * When reading the documentation it's helpful to keep in mind that
 * all class definitions starting with 'GPU*' are modules from the
 * WebGPU API. So for example `BindGroup` is a class from the engine
 * whereas `GPUBindGroup` is a class from WebGPU.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGPUBindingUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGPUBackend} backend - The WebGPU backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGPU backend.
		 *
		 * @type {WebGPUBackend}
		 */ this.backend = backend;
        /**
		 * A cache that maps combinations of layout entries to existing bind group layouts.
		 *
		 * @private
		 * @type {Map<string, BindGroupLayout>}
		 */ this._bindGroupLayoutCache = new Map();
    }
    /**
	 * Creates a GPU bind group layout for the given bind group.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @return {GPUBindGroupLayout} The GPU bind group layout.
	 */ createBindingsLayout(bindGroup) {
        const backend = this.backend;
        const device = backend.device;
        const bindingsData = backend.get(bindGroup);
        // check if the the bind group already has a layout
        if (bindingsData.layout) return bindingsData.layout.layoutGPU;
        // if not, assing one
        const entries = this._createLayoutEntries(bindGroup);
        const bindGroupLayoutKey = JSON.stringify(entries);
        // try to find an existing layout in the cache
        let bindGroupLayout = this._bindGroupLayoutCache.get(bindGroupLayoutKey);
        // if not create a new one
        if (bindGroupLayout === undefined) {
            bindGroupLayout = new $d89c9137a3d237c2$var$BindGroupLayout(device.createBindGroupLayout({
                entries: entries
            }));
            this._bindGroupLayoutCache.set(bindGroupLayoutKey, bindGroupLayout);
        }
        bindGroupLayout.usedTimes++;
        bindingsData.layout = bindGroupLayout;
        bindingsData.layoutKey = bindGroupLayoutKey;
        return bindGroupLayout.layoutGPU;
    }
    /**
	 * Creates bindings from the given bind group definition.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ createBindings(bindGroup, bindings, cacheIndex, version = 0) {
        const { backend: backend } = this;
        const bindingsData = backend.get(bindGroup);
        // setup (static) binding layout and (dynamic) binding group
        const bindLayoutGPU = this.createBindingsLayout(bindGroup);
        let bindGroupGPU;
        if (cacheIndex > 0) {
            if (bindingsData.groups === undefined) {
                bindingsData.groups = [];
                bindingsData.versions = [];
            }
            if (bindingsData.versions[cacheIndex] === version) bindGroupGPU = bindingsData.groups[cacheIndex];
        }
        if (bindGroupGPU === undefined) {
            bindGroupGPU = this.createBindGroup(bindGroup, bindLayoutGPU);
            if (cacheIndex > 0) {
                bindingsData.groups[cacheIndex] = bindGroupGPU;
                bindingsData.versions[cacheIndex] = version;
            }
        }
        bindingsData.group = bindGroupGPU;
    }
    /**
	 * Updates a buffer binding.
	 *
	 *  @param {Buffer} binding - The buffer binding to update.
	 */ updateBinding(binding) {
        const backend = this.backend;
        const device = backend.device;
        const array = binding.buffer; // cpu
        const buffer = backend.get(binding).buffer; // gpu
        const updateRanges = binding.updateRanges;
        if (updateRanges.length === 0) device.queue.writeBuffer(buffer, 0, array, 0);
        else {
            const isTyped = (0, $329ek.isTypedArray)(array);
            const byteOffsetFactor = isTyped ? 1 : array.BYTES_PER_ELEMENT;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                const dataOffset = range.start * byteOffsetFactor;
                const size = range.count * byteOffsetFactor;
                const bufferOffset = dataOffset * (isTyped ? array.BYTES_PER_ELEMENT : 1); // bufferOffset is always in bytes
                device.queue.writeBuffer(buffer, bufferOffset, array, dataOffset, size);
            }
            binding.clearUpdateRanges();
        }
    }
    /**
	 * Creates a GPU bind group for the camera index.
	 *
	 * @param {Uint32Array} data - The index data.
	 * @param {GPUBindGroupLayout} layoutGPU - The GPU bind group layout.
	 * @return {GPUBindGroup} The GPU bind group.
	 */ createBindGroupIndex(data, layoutGPU) {
        const backend = this.backend;
        const device = backend.device;
        const usage = GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST;
        const index = data[0];
        const buffer = device.createBuffer({
            label: 'bindingCameraIndex_' + index,
            size: 16,
            usage: usage
        });
        device.queue.writeBuffer(buffer, 0, data, 0);
        const entries = [
            {
                binding: 0,
                resource: {
                    buffer: buffer
                }
            }
        ];
        return device.createBindGroup({
            label: 'bindGroupCameraIndex_' + index,
            layout: layoutGPU,
            entries: entries
        });
    }
    /**
	 * Creates a GPU bind group for the given bind group and GPU layout.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {GPUBindGroupLayout} layoutGPU - The GPU bind group layout.
	 * @return {GPUBindGroup} The GPU bind group.
	 */ createBindGroup(bindGroup, layoutGPU) {
        const backend = this.backend;
        const device = backend.device;
        let bindingPoint = 0;
        const entriesGPU = [];
        for (const binding of bindGroup.bindings){
            if (binding.isUniformBuffer) {
                const bindingData = backend.get(binding);
                if (bindingData.buffer === undefined) {
                    const byteLength = binding.byteLength;
                    const usage = GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST;
                    const visibilities = [];
                    if (binding.visibility & $d89c9137a3d237c2$var$GPUShaderStage.VERTEX) visibilities.push('vertex');
                    if (binding.visibility & $d89c9137a3d237c2$var$GPUShaderStage.FRAGMENT) visibilities.push('fragment');
                    if (binding.visibility & $d89c9137a3d237c2$var$GPUShaderStage.COMPUTE) visibilities.push('compute');
                    const bufferVisibility = `(${visibilities.join(',')})`;
                    const bufferGPU = device.createBuffer({
                        label: `bindingBuffer${binding.id}_${binding.name}_${bufferVisibility}`,
                        size: byteLength,
                        usage: usage
                    });
                    bindingData.buffer = bufferGPU;
                }
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: {
                        buffer: bindingData.buffer
                    }
                });
            } else if (binding.isStorageBuffer) {
                const bindingData = backend.get(binding);
                if (bindingData.buffer === undefined) {
                    const attribute = binding.attribute;
                    //const usage = GPUBufferUsage.STORAGE | GPUBufferUsage.VERTEX | /*GPUBufferUsage.COPY_SRC |*/ GPUBufferUsage.COPY_DST;
                    //backend.attributeUtils.createAttribute( attribute, usage ); // @TODO: Move it to universal renderer
                    bindingData.buffer = backend.get(attribute).buffer;
                }
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: {
                        buffer: bindingData.buffer
                    }
                });
            } else if (binding.isSampledTexture) {
                const textureData = backend.get(binding.texture);
                let resourceGPU;
                if (textureData.externalTexture !== undefined) resourceGPU = device.importExternalTexture({
                    source: textureData.externalTexture
                });
                else {
                    const mipLevelCount = binding.store ? 1 : textureData.texture.mipLevelCount;
                    const baseMipLevel = binding.store ? binding.mipLevel : 0;
                    let propertyName = `view-${textureData.texture.width}-${textureData.texture.height}`;
                    if (textureData.texture.depthOrArrayLayers > 1) propertyName += `-${textureData.texture.depthOrArrayLayers}`;
                    propertyName += `-${mipLevelCount}-${baseMipLevel}`;
                    resourceGPU = textureData[propertyName];
                    if (resourceGPU === undefined) {
                        const aspectGPU = $d89c9137a3d237c2$var$GPUTextureAspect.All;
                        let dimensionViewGPU;
                        if (binding.isSampledCubeTexture) dimensionViewGPU = $d89c9137a3d237c2$var$GPUTextureViewDimension.Cube;
                        else if (binding.isSampledTexture3D) dimensionViewGPU = $d89c9137a3d237c2$var$GPUTextureViewDimension.ThreeD;
                        else if (binding.texture.isArrayTexture || binding.texture.isDataArrayTexture || binding.texture.isCompressedArrayTexture) dimensionViewGPU = $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoDArray;
                        else dimensionViewGPU = $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoD;
                        resourceGPU = textureData[propertyName] = textureData.texture.createView({
                            aspect: aspectGPU,
                            dimension: dimensionViewGPU,
                            mipLevelCount: mipLevelCount,
                            baseMipLevel: baseMipLevel
                        });
                    }
                }
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: resourceGPU
                });
            } else if (binding.isSampler) {
                const textureGPU = backend.get(binding.texture);
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: textureGPU.sampler
                });
            }
            bindingPoint++;
        }
        return device.createBindGroup({
            label: 'bindGroup_' + bindGroup.name,
            layout: layoutGPU,
            entries: entriesGPU
        });
    }
    /**
	 * Creates a GPU bind group layout entries for the given bind group.
	 *
	 * @private
	 * @param {BindGroup} bindGroup - The bind group.
	 * @return {Array<GPUBindGroupLayoutEntry>} The GPU bind group layout entries.
	 */ _createLayoutEntries(bindGroup) {
        const entries = [];
        let index = 0;
        for (const binding of bindGroup.bindings){
            const backend = this.backend;
            const bindingGPU = {
                binding: index,
                visibility: binding.visibility
            };
            if (binding.isUniformBuffer || binding.isStorageBuffer) {
                const buffer = {}; // GPUBufferBindingLayout
                if (binding.isStorageBuffer) {
                    if (binding.visibility & $d89c9137a3d237c2$var$GPUShaderStage.COMPUTE) {
                        // compute
                        if (binding.access === $d89c9137a3d237c2$export$92538c74c63a703d.READ_WRITE || binding.access === $d89c9137a3d237c2$export$92538c74c63a703d.WRITE_ONLY) buffer.type = $d89c9137a3d237c2$var$GPUBufferBindingType.Storage;
                        else buffer.type = $d89c9137a3d237c2$var$GPUBufferBindingType.ReadOnlyStorage;
                    } else buffer.type = $d89c9137a3d237c2$var$GPUBufferBindingType.ReadOnlyStorage;
                }
                bindingGPU.buffer = buffer;
            } else if (binding.isSampledTexture && binding.store) {
                const storageTexture = {}; // GPUStorageTextureBindingLayout
                storageTexture.format = this.backend.get(binding.texture).texture.format;
                const access = binding.access;
                if (access === $d89c9137a3d237c2$export$92538c74c63a703d.READ_WRITE) storageTexture.access = $d89c9137a3d237c2$var$GPUStorageTextureAccess.ReadWrite;
                else if (access === $d89c9137a3d237c2$export$92538c74c63a703d.WRITE_ONLY) storageTexture.access = $d89c9137a3d237c2$var$GPUStorageTextureAccess.WriteOnly;
                else storageTexture.access = $d89c9137a3d237c2$var$GPUStorageTextureAccess.ReadOnly;
                if (binding.texture.isArrayTexture) storageTexture.viewDimension = $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoDArray;
                else if (binding.texture.is3DTexture) storageTexture.viewDimension = $d89c9137a3d237c2$var$GPUTextureViewDimension.ThreeD;
                bindingGPU.storageTexture = storageTexture;
            } else if (binding.isSampledTexture) {
                const texture = {}; // GPUTextureBindingLayout
                const { primarySamples: primarySamples } = backend.utils.getTextureSampleData(binding.texture);
                if (primarySamples > 1) {
                    texture.multisampled = true;
                    if (!binding.texture.isDepthTexture) texture.sampleType = $d89c9137a3d237c2$var$GPUTextureSampleType.UnfilterableFloat;
                }
                if (binding.texture.isDepthTexture) {
                    if (backend.compatibilityMode && binding.texture.compareFunction === null) texture.sampleType = $d89c9137a3d237c2$var$GPUTextureSampleType.UnfilterableFloat;
                    else texture.sampleType = $d89c9137a3d237c2$var$GPUTextureSampleType.Depth;
                } else if (binding.texture.isDataTexture || binding.texture.isDataArrayTexture || binding.texture.isData3DTexture) {
                    const type = binding.texture.type;
                    if (type === (0, $329ek.IntType)) texture.sampleType = $d89c9137a3d237c2$var$GPUTextureSampleType.SInt;
                    else if (type === (0, $329ek.UnsignedIntType)) texture.sampleType = $d89c9137a3d237c2$var$GPUTextureSampleType.UInt;
                    else if (type === (0, $329ek.FloatType)) {
                        if (this.backend.hasFeature('float32-filterable')) texture.sampleType = $d89c9137a3d237c2$var$GPUTextureSampleType.Float;
                        else texture.sampleType = $d89c9137a3d237c2$var$GPUTextureSampleType.UnfilterableFloat;
                    }
                }
                if (binding.isSampledCubeTexture) texture.viewDimension = $d89c9137a3d237c2$var$GPUTextureViewDimension.Cube;
                else if (binding.texture.isArrayTexture || binding.texture.isDataArrayTexture || binding.texture.isCompressedArrayTexture) texture.viewDimension = $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoDArray;
                else if (binding.isSampledTexture3D) texture.viewDimension = $d89c9137a3d237c2$var$GPUTextureViewDimension.ThreeD;
                bindingGPU.texture = texture;
            } else if (binding.isSampler) {
                const sampler = {}; // GPUSamplerBindingLayout
                if (binding.texture.isDepthTexture) {
                    if (binding.texture.compareFunction !== null) sampler.type = $d89c9137a3d237c2$var$GPUSamplerBindingType.Comparison;
                    else if (backend.compatibilityMode) sampler.type = $d89c9137a3d237c2$var$GPUSamplerBindingType.NonFiltering;
                }
                bindingGPU.sampler = sampler;
            } else (0, $329ek.error)(`WebGPUBindingUtils: Unsupported binding "${binding}".`);
            entries.push(bindingGPU);
            index++;
        }
        return entries;
    }
    /**
	 * Delete the data associated with a bind group.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 */ deleteBindGroupData(bindGroup) {
        const { backend: backend } = this;
        const bindingsData = backend.get(bindGroup);
        if (bindingsData.layout) {
            bindingsData.layout.usedTimes--;
            if (bindingsData.layout.usedTimes === 0) this._bindGroupLayoutCache.delete(bindingsData.layoutKey);
            bindingsData.layout = undefined;
            bindingsData.layoutKey = undefined;
        }
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this._bindGroupLayoutCache.clear();
    }
}
/**
 * A WebGPU backend utility module for managing pipelines.
 *
 * @private
 */ class $d89c9137a3d237c2$var$WebGPUPipelineUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGPUBackend} backend - The WebGPU backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGPU backend.
		 *
		 * @type {WebGPUBackend}
		 */ this.backend = backend;
        /**
		 * A Weak Map that tracks the active pipeline for render or compute passes.
		 *
		 * @private
		 * @type {WeakMap<(GPURenderPassEncoder|GPUComputePassEncoder),(GPURenderPipeline|GPUComputePipeline)>}
		 */ this._activePipelines = new WeakMap();
    }
    /**
	 * Sets the given pipeline for the given pass. The method makes sure to only set the
	 * pipeline when necessary.
	 *
	 * @param {(GPURenderPassEncoder|GPUComputePassEncoder)} pass - The pass encoder.
	 * @param {(GPURenderPipeline|GPUComputePipeline)} pipeline - The pipeline.
	 */ setPipeline(pass, pipeline) {
        const currentPipeline = this._activePipelines.get(pass);
        if (currentPipeline !== pipeline) {
            pass.setPipeline(pipeline);
            this._activePipelines.set(pass, pipeline);
        }
    }
    /**
	 * Returns the sample count derived from the given render context.
	 *
	 * @private
	 * @param {RenderContext} renderContext - The render context.
	 * @return {number} The sample count.
	 */ _getSampleCount(renderContext) {
        return this.backend.utils.getSampleCountRenderContext(renderContext);
    }
    /**
	 * Creates a render pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
	 */ createRenderPipeline(renderObject, promises) {
        const { object: object, material: material, geometry: geometry, pipeline: pipeline } = renderObject;
        const { vertexProgram: vertexProgram, fragmentProgram: fragmentProgram } = pipeline;
        const backend = this.backend;
        const device = backend.device;
        const utils = backend.utils;
        const pipelineData = backend.get(pipeline);
        // bind group layouts
        const bindGroupLayouts = [];
        for (const bindGroup of renderObject.getBindings()){
            const bindingsData = backend.get(bindGroup);
            const { layoutGPU: layoutGPU } = bindingsData.layout;
            bindGroupLayouts.push(layoutGPU);
        }
        // vertex buffers
        const vertexBuffers = backend.attributeUtils.createShaderVertexBuffers(renderObject);
        // blending
        let blending;
        if (material.blending !== (0, $329ek.NoBlending) && (material.blending !== (0, $329ek.NormalBlending) || material.transparent !== false)) blending = this._getBlending(material);
        // stencil
        let stencilFront = {};
        if (material.stencilWrite === true) stencilFront = {
            compare: this._getStencilCompare(material),
            failOp: this._getStencilOperation(material.stencilFail),
            depthFailOp: this._getStencilOperation(material.stencilZFail),
            passOp: this._getStencilOperation(material.stencilZPass)
        };
        const colorWriteMask = this._getColorWriteMask(material);
        const targets = [];
        if (renderObject.context.textures !== null) {
            const textures = renderObject.context.textures;
            for(let i = 0; i < textures.length; i++){
                const colorFormat = utils.getTextureFormatGPU(textures[i]);
                if (i === 0) targets.push({
                    format: colorFormat,
                    blend: blending,
                    writeMask: colorWriteMask
                });
                else targets.push({
                    format: colorFormat,
                    writeMask: colorWriteMask
                });
            }
        } else {
            const colorFormat = utils.getCurrentColorFormat(renderObject.context);
            targets.push({
                format: colorFormat,
                blend: blending,
                writeMask: colorWriteMask
            });
        }
        const vertexModule = backend.get(vertexProgram).module;
        const fragmentModule = backend.get(fragmentProgram).module;
        const primitiveState = this._getPrimitiveState(object, geometry, material);
        const depthCompare = this._getDepthCompare(material);
        const depthStencilFormat = utils.getCurrentDepthStencilFormat(renderObject.context);
        const sampleCount = this._getSampleCount(renderObject.context);
        const pipelineDescriptor = {
            label: `renderPipeline_${material.name || material.type}_${material.id}`,
            vertex: Object.assign({}, vertexModule, {
                buffers: vertexBuffers
            }),
            fragment: Object.assign({}, fragmentModule, {
                targets: targets
            }),
            primitive: primitiveState,
            multisample: {
                count: sampleCount,
                alphaToCoverageEnabled: material.alphaToCoverage && sampleCount > 1
            },
            layout: device.createPipelineLayout({
                bindGroupLayouts: bindGroupLayouts
            })
        };
        const depthStencil = {};
        const renderDepth = renderObject.context.depth;
        const renderStencil = renderObject.context.stencil;
        if (renderDepth === true || renderStencil === true) {
            if (renderDepth === true) {
                depthStencil.format = depthStencilFormat;
                depthStencil.depthWriteEnabled = material.depthWrite;
                depthStencil.depthCompare = depthCompare;
            }
            if (renderStencil === true) {
                depthStencil.stencilFront = stencilFront;
                depthStencil.stencilBack = {}; // three.js does not provide an API to configure the back function (gl.stencilFuncSeparate() was never used)
                depthStencil.stencilReadMask = material.stencilFuncMask;
                depthStencil.stencilWriteMask = material.stencilWriteMask;
            }
            if (material.polygonOffset === true) {
                depthStencil.depthBias = material.polygonOffsetUnits;
                depthStencil.depthBiasSlopeScale = material.polygonOffsetFactor;
                depthStencil.depthBiasClamp = 0; // three.js does not provide an API to configure this value
            }
            pipelineDescriptor.depthStencil = depthStencil;
        }
        // create pipeline
        device.pushErrorScope('validation');
        if (promises === null) {
            pipelineData.pipeline = device.createRenderPipeline(pipelineDescriptor);
            device.popErrorScope().then((err)=>{
                if (err !== null) {
                    pipelineData.error = true;
                    (0, $329ek.error)(err.message);
                }
            });
        } else {
            const p = new Promise(async (resolve /*, reject*/ )=>{
                try {
                    pipelineData.pipeline = await device.createRenderPipelineAsync(pipelineDescriptor);
                } catch (err) {}
                const errorScope = await device.popErrorScope();
                if (errorScope !== null) {
                    pipelineData.error = true;
                    (0, $329ek.error)(errorScope.message);
                }
                resolve();
            });
            promises.push(p);
        }
    }
    /**
	 * Creates GPU render bundle encoder for the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {?string} [label='renderBundleEncoder'] - The label.
	 * @return {GPURenderBundleEncoder} The GPU render bundle encoder.
	 */ createBundleEncoder(renderContext, label = 'renderBundleEncoder') {
        const backend = this.backend;
        const { utils: utils, device: device } = backend;
        const depthStencilFormat = utils.getCurrentDepthStencilFormat(renderContext);
        const colorFormats = utils.getCurrentColorFormats(renderContext);
        const sampleCount = this._getSampleCount(renderContext);
        const descriptor = {
            label: label,
            colorFormats: colorFormats,
            depthStencilFormat: depthStencilFormat,
            sampleCount: sampleCount
        };
        return device.createRenderBundleEncoder(descriptor);
    }
    /**
	 * Creates a compute pipeline for the given compute node.
	 *
	 * @param {ComputePipeline} pipeline - The compute pipeline.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 */ createComputePipeline(pipeline, bindings) {
        const backend = this.backend;
        const device = backend.device;
        const computeProgram = backend.get(pipeline.computeProgram).module;
        const pipelineGPU = backend.get(pipeline);
        // bind group layouts
        const bindGroupLayouts = [];
        for (const bindingsGroup of bindings){
            const bindingsData = backend.get(bindingsGroup);
            const { layoutGPU: layoutGPU } = bindingsData.layout;
            bindGroupLayouts.push(layoutGPU);
        }
        pipelineGPU.pipeline = device.createComputePipeline({
            compute: computeProgram,
            layout: device.createPipelineLayout({
                bindGroupLayouts: bindGroupLayouts
            })
        });
    }
    /**
	 * Returns the blending state as a descriptor object required
	 * for the pipeline creation.
	 *
	 * @private
	 * @param {Material} material - The material.
	 * @return {Object} The blending state.
	 */ _getBlending(material) {
        let color, alpha;
        const blending = material.blending;
        const blendSrc = material.blendSrc;
        const blendDst = material.blendDst;
        const blendEquation = material.blendEquation;
        if (blending === (0, $329ek.CustomBlending)) {
            const blendSrcAlpha = material.blendSrcAlpha !== null ? material.blendSrcAlpha : blendSrc;
            const blendDstAlpha = material.blendDstAlpha !== null ? material.blendDstAlpha : blendDst;
            const blendEquationAlpha = material.blendEquationAlpha !== null ? material.blendEquationAlpha : blendEquation;
            color = {
                srcFactor: this._getBlendFactor(blendSrc),
                dstFactor: this._getBlendFactor(blendDst),
                operation: this._getBlendOperation(blendEquation)
            };
            alpha = {
                srcFactor: this._getBlendFactor(blendSrcAlpha),
                dstFactor: this._getBlendFactor(blendDstAlpha),
                operation: this._getBlendOperation(blendEquationAlpha)
            };
        } else {
            const premultipliedAlpha = material.premultipliedAlpha;
            const setBlend = (srcRGB, dstRGB, srcAlpha, dstAlpha)=>{
                color = {
                    srcFactor: srcRGB,
                    dstFactor: dstRGB,
                    operation: $d89c9137a3d237c2$var$GPUBlendOperation.Add
                };
                alpha = {
                    srcFactor: srcAlpha,
                    dstFactor: dstAlpha,
                    operation: $d89c9137a3d237c2$var$GPUBlendOperation.Add
                };
            };
            if (premultipliedAlpha) switch(blending){
                case 0, $329ek.NormalBlending:
                    setBlend($d89c9137a3d237c2$var$GPUBlendFactor.One, $d89c9137a3d237c2$var$GPUBlendFactor.OneMinusSrcAlpha, $d89c9137a3d237c2$var$GPUBlendFactor.One, $d89c9137a3d237c2$var$GPUBlendFactor.OneMinusSrcAlpha);
                    break;
                case 0, $329ek.AdditiveBlending:
                    setBlend($d89c9137a3d237c2$var$GPUBlendFactor.One, $d89c9137a3d237c2$var$GPUBlendFactor.One, $d89c9137a3d237c2$var$GPUBlendFactor.One, $d89c9137a3d237c2$var$GPUBlendFactor.One);
                    break;
                case 0, $329ek.SubtractiveBlending:
                    setBlend($d89c9137a3d237c2$var$GPUBlendFactor.Zero, $d89c9137a3d237c2$var$GPUBlendFactor.OneMinusSrc, $d89c9137a3d237c2$var$GPUBlendFactor.Zero, $d89c9137a3d237c2$var$GPUBlendFactor.One);
                    break;
                case 0, $329ek.MultiplyBlending:
                    setBlend($d89c9137a3d237c2$var$GPUBlendFactor.Dst, $d89c9137a3d237c2$var$GPUBlendFactor.OneMinusSrcAlpha, $d89c9137a3d237c2$var$GPUBlendFactor.Zero, $d89c9137a3d237c2$var$GPUBlendFactor.One);
                    break;
            }
            else switch(blending){
                case 0, $329ek.NormalBlending:
                    setBlend($d89c9137a3d237c2$var$GPUBlendFactor.SrcAlpha, $d89c9137a3d237c2$var$GPUBlendFactor.OneMinusSrcAlpha, $d89c9137a3d237c2$var$GPUBlendFactor.One, $d89c9137a3d237c2$var$GPUBlendFactor.OneMinusSrcAlpha);
                    break;
                case 0, $329ek.AdditiveBlending:
                    setBlend($d89c9137a3d237c2$var$GPUBlendFactor.SrcAlpha, $d89c9137a3d237c2$var$GPUBlendFactor.One, $d89c9137a3d237c2$var$GPUBlendFactor.One, $d89c9137a3d237c2$var$GPUBlendFactor.One);
                    break;
                case 0, $329ek.SubtractiveBlending:
                    (0, $329ek.error)('WebGPURenderer: SubtractiveBlending requires material.premultipliedAlpha = true');
                    break;
                case 0, $329ek.MultiplyBlending:
                    (0, $329ek.error)('WebGPURenderer: MultiplyBlending requires material.premultipliedAlpha = true');
                    break;
            }
        }
        if (color !== undefined && alpha !== undefined) return {
            color: color,
            alpha: alpha
        };
        else (0, $329ek.error)('WebGPURenderer: Invalid blending: ', blending);
    }
    /**
	 * Returns the GPU blend factor which is required for the pipeline creation.
	 *
	 * @private
	 * @param {number} blend - The blend factor as a three.js constant.
	 * @return {string} The GPU blend factor.
	 */ _getBlendFactor(blend) {
        let blendFactor;
        switch(blend){
            case 0, $329ek.ZeroFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.Zero;
                break;
            case 0, $329ek.OneFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.One;
                break;
            case 0, $329ek.SrcColorFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.Src;
                break;
            case 0, $329ek.OneMinusSrcColorFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.OneMinusSrc;
                break;
            case 0, $329ek.SrcAlphaFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.SrcAlpha;
                break;
            case 0, $329ek.OneMinusSrcAlphaFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.OneMinusSrcAlpha;
                break;
            case 0, $329ek.DstColorFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.Dst;
                break;
            case 0, $329ek.OneMinusDstColorFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.OneMinusDst;
                break;
            case 0, $329ek.DstAlphaFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.DstAlpha;
                break;
            case 0, $329ek.OneMinusDstAlphaFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.OneMinusDstAlpha;
                break;
            case 0, $329ek.SrcAlphaSaturateFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.SrcAlphaSaturated;
                break;
            case $d89c9137a3d237c2$var$BlendColorFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.Constant;
                break;
            case $d89c9137a3d237c2$var$OneMinusBlendColorFactor:
                blendFactor = $d89c9137a3d237c2$var$GPUBlendFactor.OneMinusConstant;
                break;
            default:
                (0, $329ek.error)('WebGPURenderer: Blend factor not supported.', blend);
        }
        return blendFactor;
    }
    /**
	 * Returns the GPU stencil compare function which is required for the pipeline creation.
	 *
	 * @private
	 * @param {Material} material - The material.
	 * @return {string} The GPU stencil compare function.
	 */ _getStencilCompare(material) {
        let stencilCompare;
        const stencilFunc = material.stencilFunc;
        switch(stencilFunc){
            case 0, $329ek.NeverStencilFunc:
                stencilCompare = $d89c9137a3d237c2$var$GPUCompareFunction.Never;
                break;
            case 0, $329ek.AlwaysStencilFunc:
                stencilCompare = $d89c9137a3d237c2$var$GPUCompareFunction.Always;
                break;
            case 0, $329ek.LessStencilFunc:
                stencilCompare = $d89c9137a3d237c2$var$GPUCompareFunction.Less;
                break;
            case 0, $329ek.LessEqualStencilFunc:
                stencilCompare = $d89c9137a3d237c2$var$GPUCompareFunction.LessEqual;
                break;
            case 0, $329ek.EqualStencilFunc:
                stencilCompare = $d89c9137a3d237c2$var$GPUCompareFunction.Equal;
                break;
            case 0, $329ek.GreaterEqualStencilFunc:
                stencilCompare = $d89c9137a3d237c2$var$GPUCompareFunction.GreaterEqual;
                break;
            case 0, $329ek.GreaterStencilFunc:
                stencilCompare = $d89c9137a3d237c2$var$GPUCompareFunction.Greater;
                break;
            case 0, $329ek.NotEqualStencilFunc:
                stencilCompare = $d89c9137a3d237c2$var$GPUCompareFunction.NotEqual;
                break;
            default:
                (0, $329ek.error)('WebGPURenderer: Invalid stencil function.', stencilFunc);
        }
        return stencilCompare;
    }
    /**
	 * Returns the GPU stencil operation which is required for the pipeline creation.
	 *
	 * @private
	 * @param {number} op - A three.js constant defining the stencil operation.
	 * @return {string} The GPU stencil operation.
	 */ _getStencilOperation(op) {
        let stencilOperation;
        switch(op){
            case 0, $329ek.KeepStencilOp:
                stencilOperation = $d89c9137a3d237c2$var$GPUStencilOperation.Keep;
                break;
            case 0, $329ek.ZeroStencilOp:
                stencilOperation = $d89c9137a3d237c2$var$GPUStencilOperation.Zero;
                break;
            case 0, $329ek.ReplaceStencilOp:
                stencilOperation = $d89c9137a3d237c2$var$GPUStencilOperation.Replace;
                break;
            case 0, $329ek.InvertStencilOp:
                stencilOperation = $d89c9137a3d237c2$var$GPUStencilOperation.Invert;
                break;
            case 0, $329ek.IncrementStencilOp:
                stencilOperation = $d89c9137a3d237c2$var$GPUStencilOperation.IncrementClamp;
                break;
            case 0, $329ek.DecrementStencilOp:
                stencilOperation = $d89c9137a3d237c2$var$GPUStencilOperation.DecrementClamp;
                break;
            case 0, $329ek.IncrementWrapStencilOp:
                stencilOperation = $d89c9137a3d237c2$var$GPUStencilOperation.IncrementWrap;
                break;
            case 0, $329ek.DecrementWrapStencilOp:
                stencilOperation = $d89c9137a3d237c2$var$GPUStencilOperation.DecrementWrap;
                break;
            default:
                (0, $329ek.error)('WebGPURenderer: Invalid stencil operation.', stencilOperation);
        }
        return stencilOperation;
    }
    /**
	 * Returns the GPU blend operation which is required for the pipeline creation.
	 *
	 * @private
	 * @param {number} blendEquation - A three.js constant defining the blend equation.
	 * @return {string} The GPU blend operation.
	 */ _getBlendOperation(blendEquation) {
        let blendOperation;
        switch(blendEquation){
            case 0, $329ek.AddEquation:
                blendOperation = $d89c9137a3d237c2$var$GPUBlendOperation.Add;
                break;
            case 0, $329ek.SubtractEquation:
                blendOperation = $d89c9137a3d237c2$var$GPUBlendOperation.Subtract;
                break;
            case 0, $329ek.ReverseSubtractEquation:
                blendOperation = $d89c9137a3d237c2$var$GPUBlendOperation.ReverseSubtract;
                break;
            case 0, $329ek.MinEquation:
                blendOperation = $d89c9137a3d237c2$var$GPUBlendOperation.Min;
                break;
            case 0, $329ek.MaxEquation:
                blendOperation = $d89c9137a3d237c2$var$GPUBlendOperation.Max;
                break;
            default:
                (0, $329ek.error)('WebGPUPipelineUtils: Blend equation not supported.', blendEquation);
        }
        return blendOperation;
    }
    /**
	 * Returns the primitive state as a descriptor object required
	 * for the pipeline creation.
	 *
	 * @private
	 * @param {Object3D} object - The 3D object.
	 * @param {BufferGeometry} geometry - The geometry.
	 * @param {Material} material - The material.
	 * @return {Object} The primitive state.
	 */ _getPrimitiveState(object, geometry, material) {
        const descriptor = {};
        const utils = this.backend.utils;
        //
        descriptor.topology = utils.getPrimitiveTopology(object, material);
        if (geometry.index !== null && object.isLine === true && object.isLineSegments !== true) descriptor.stripIndexFormat = geometry.index.array instanceof Uint16Array ? $d89c9137a3d237c2$var$GPUIndexFormat.Uint16 : $d89c9137a3d237c2$var$GPUIndexFormat.Uint32;
        //
        let flipSided = material.side === (0, $329ek.BackSide);
        if (object.isMesh && object.matrixWorld.determinant() < 0) flipSided = !flipSided;
        descriptor.frontFace = flipSided === true ? $d89c9137a3d237c2$var$GPUFrontFace.CW : $d89c9137a3d237c2$var$GPUFrontFace.CCW;
        //
        descriptor.cullMode = material.side === (0, $329ek.DoubleSide) ? $d89c9137a3d237c2$var$GPUCullMode.None : $d89c9137a3d237c2$var$GPUCullMode.Back;
        return descriptor;
    }
    /**
	 * Returns the GPU color write mask which is required for the pipeline creation.
	 *
	 * @private
	 * @param {Material} material - The material.
	 * @return {number} The GPU color write mask.
	 */ _getColorWriteMask(material) {
        return material.colorWrite === true ? $d89c9137a3d237c2$var$GPUColorWriteFlags.All : $d89c9137a3d237c2$var$GPUColorWriteFlags.None;
    }
    /**
	 * Returns the GPU depth compare function which is required for the pipeline creation.
	 *
	 * @private
	 * @param {Material} material - The material.
	 * @return {string} The GPU depth compare function.
	 */ _getDepthCompare(material) {
        let depthCompare;
        if (material.depthTest === false) depthCompare = $d89c9137a3d237c2$var$GPUCompareFunction.Always;
        else {
            const depthFunc = material.depthFunc;
            switch(depthFunc){
                case 0, $329ek.NeverDepth:
                    depthCompare = $d89c9137a3d237c2$var$GPUCompareFunction.Never;
                    break;
                case 0, $329ek.AlwaysDepth:
                    depthCompare = $d89c9137a3d237c2$var$GPUCompareFunction.Always;
                    break;
                case 0, $329ek.LessDepth:
                    depthCompare = $d89c9137a3d237c2$var$GPUCompareFunction.Less;
                    break;
                case 0, $329ek.LessEqualDepth:
                    depthCompare = $d89c9137a3d237c2$var$GPUCompareFunction.LessEqual;
                    break;
                case 0, $329ek.EqualDepth:
                    depthCompare = $d89c9137a3d237c2$var$GPUCompareFunction.Equal;
                    break;
                case 0, $329ek.GreaterEqualDepth:
                    depthCompare = $d89c9137a3d237c2$var$GPUCompareFunction.GreaterEqual;
                    break;
                case 0, $329ek.GreaterDepth:
                    depthCompare = $d89c9137a3d237c2$var$GPUCompareFunction.Greater;
                    break;
                case 0, $329ek.NotEqualDepth:
                    depthCompare = $d89c9137a3d237c2$var$GPUCompareFunction.NotEqual;
                    break;
                default:
                    (0, $329ek.error)('WebGPUPipelineUtils: Invalid depth function.', depthFunc);
            }
        }
        return depthCompare;
    }
}
/**
 * Manages a pool of WebGPU timestamp queries for performance measurement.
 * Extends the base TimestampQueryPool to provide WebGPU-specific implementation.
 *
 * @augments TimestampQueryPool
 */ class $d89c9137a3d237c2$var$WebGPUTimestampQueryPool extends $d89c9137a3d237c2$var$TimestampQueryPool {
    /**
	 * Creates a new WebGPU timestamp query pool.
	 *
	 * @param {GPUDevice} device - The WebGPU device to create queries on.
	 * @param {string} type - The type identifier for this query pool.
	 * @param {number} [maxQueries=2048] - Maximum number of queries this pool can hold.
	 */ constructor(device, type, maxQueries = 2048){
        super(maxQueries);
        this.device = device;
        this.type = type;
        this.querySet = this.device.createQuerySet({
            type: 'timestamp',
            count: this.maxQueries,
            label: `queryset_global_timestamp_${type}`
        });
        const bufferSize = this.maxQueries * 8;
        this.resolveBuffer = this.device.createBuffer({
            label: `buffer_timestamp_resolve_${type}`,
            size: bufferSize,
            usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
        });
        this.resultBuffer = this.device.createBuffer({
            label: `buffer_timestamp_result_${type}`,
            size: bufferSize,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        });
    }
    /**
	 * Allocates a pair of queries for a given render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @returns {?number} The base offset for the allocated queries, or null if allocation failed.
	 */ allocateQueriesForContext(uid) {
        if (!this.trackTimestamp || this.isDisposed) return null;
        if (this.currentQueryIndex + 2 > this.maxQueries) {
            (0, $329ek.warnOnce)(`WebGPUTimestampQueryPool [${this.type}]: Maximum number of queries exceeded, when using trackTimestamp it is necessary to resolves the queries via renderer.resolveTimestampsAsync( THREE.TimestampQuery.${this.type.toUpperCase()} ).`);
            return null;
        }
        const baseOffset = this.currentQueryIndex;
        this.currentQueryIndex += 2;
        this.queryOffsets.set(uid, baseOffset);
        return baseOffset;
    }
    /**
	 * Asynchronously resolves all pending queries and returns the total duration.
	 * If there's already a pending resolve operation, returns that promise instead.
	 *
	 * @async
	 * @returns {Promise<number>} The total duration in milliseconds, or the last valid value if resolution fails.
	 */ async resolveQueriesAsync() {
        if (!this.trackTimestamp || this.currentQueryIndex === 0 || this.isDisposed) return this.lastValue;
        if (this.pendingResolve) return this.pendingResolve;
        this.pendingResolve = this._resolveQueries();
        try {
            const result = await this.pendingResolve;
            return result;
        } finally{
            this.pendingResolve = null;
        }
    }
    /**
	 * Internal method to resolve queries and calculate total duration.
	 *
	 * @async
	 * @private
	 * @returns {Promise<number>} The total duration in milliseconds.
	 */ async _resolveQueries() {
        if (this.isDisposed) return this.lastValue;
        try {
            if (this.resultBuffer.mapState !== 'unmapped') return this.lastValue;
            const currentOffsets = new Map(this.queryOffsets);
            const queryCount = this.currentQueryIndex;
            const bytesUsed = queryCount * 8;
            // Reset state before GPU work
            this.currentQueryIndex = 0;
            this.queryOffsets.clear();
            const commandEncoder = this.device.createCommandEncoder();
            commandEncoder.resolveQuerySet(this.querySet, 0, queryCount, this.resolveBuffer, 0);
            commandEncoder.copyBufferToBuffer(this.resolveBuffer, 0, this.resultBuffer, 0, bytesUsed);
            const commandBuffer = commandEncoder.finish();
            this.device.queue.submit([
                commandBuffer
            ]);
            if (this.resultBuffer.mapState !== 'unmapped') return this.lastValue;
            // Create and track the mapping operation
            await this.resultBuffer.mapAsync(GPUMapMode.READ, 0, bytesUsed);
            if (this.isDisposed) {
                if (this.resultBuffer.mapState === 'mapped') this.resultBuffer.unmap();
                return this.lastValue;
            }
            //
            const times = new BigUint64Array(this.resultBuffer.getMappedRange(0, bytesUsed));
            const framesDuration = {};
            const frames = [];
            for (const [uid, baseOffset] of currentOffsets){
                const match = uid.match(/^(.*):f(\d+)$/);
                const frame = parseInt(match[2]);
                if (frames.includes(frame) === false) frames.push(frame);
                if (framesDuration[frame] === undefined) framesDuration[frame] = 0;
                const startTime = times[baseOffset];
                const endTime = times[baseOffset + 1];
                const duration = Number(endTime - startTime) / 1e6;
                this.timestamps.set(uid, duration);
                framesDuration[frame] += duration;
            }
            // Return the total duration of the last frame
            const totalDuration = framesDuration[frames[frames.length - 1]];
            this.resultBuffer.unmap();
            this.lastValue = totalDuration;
            this.frames = frames;
            return totalDuration;
        } catch (e) {
            (0, $329ek.error)('Error resolving queries:', e);
            if (this.resultBuffer.mapState === 'mapped') this.resultBuffer.unmap();
            return this.lastValue;
        }
    }
    /**
	 * Dispose of the query pool.
	 *
	 * @async
	 * @returns {Promise} A Promise that resolves when the dispose has been executed.
	 */ async dispose() {
        if (this.isDisposed) return;
        this.isDisposed = true;
        // Wait for pending resolve operation
        if (this.pendingResolve) try {
            await this.pendingResolve;
        } catch (e) {
            (0, $329ek.error)('Error waiting for pending resolve:', e);
        }
        // Ensure buffer is unmapped before destroying
        if (this.resultBuffer && this.resultBuffer.mapState === 'mapped') try {
            this.resultBuffer.unmap();
        } catch (e) {
            (0, $329ek.error)('Error unmapping buffer:', e);
        }
        // Destroy resources
        if (this.querySet) {
            this.querySet.destroy();
            this.querySet = null;
        }
        if (this.resolveBuffer) {
            this.resolveBuffer.destroy();
            this.resolveBuffer = null;
        }
        if (this.resultBuffer) {
            this.resultBuffer.destroy();
            this.resultBuffer = null;
        }
        this.queryOffsets.clear();
        this.pendingResolve = null;
    }
}
/*// debugger tools
import 'https://greggman.github.io/webgpu-avoid-redundant-state-setting/webgpu-check-redundant-state-setting.js';
//*/ /**
 * A backend implementation targeting WebGPU.
 *
 * @private
 * @augments Backend
 */ class $d89c9137a3d237c2$var$WebGPUBackend extends $d89c9137a3d237c2$var$Backend {
    /**
	 * WebGPUBackend options.
	 *
	 * @typedef {Object} WebGPUBackend~Options
	 * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
	 * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
	 * @property {boolean} [compatibilityMode=false] - Whether the backend should be in compatibility mode or not.
	 * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
	 * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
	 * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
	 * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0 to overwrite the default.
	 * @property {boolean} [forceWebGL=false] - If set to `true`, the renderer uses a WebGL 2 backend no matter if WebGPU is supported or not.
	 * @property {boolean} [trackTimestamp=false] - Whether to track timestamps with a Timestamp Query API or not.
	 * @property {string} [powerPreference=undefined] - The power preference.
	 * @property {Object} [requiredLimits=undefined] - Specifies the limits that are required by the device request. The request will fail if the adapter cannot provide these limits.
	 * @property {GPUDevice} [device=undefined] - If there is an existing GPU device on app level, it can be passed to the renderer as a parameter.
	 * @property {number} [outputType=undefined] - Texture type for output to canvas. By default, device's preferred format is used; other formats may incur overhead.
	 */ /**
	 * Constructs a new WebGPU backend.
	 *
	 * @param {WebGPUBackend~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        super(parameters);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGPUBackend = true;
        // some parameters require default values other than "undefined"
        this.parameters.alpha = parameters.alpha === undefined ? true : parameters.alpha;
        this.parameters.compatibilityMode = parameters.compatibilityMode === undefined ? false : parameters.compatibilityMode;
        this.parameters.requiredLimits = parameters.requiredLimits === undefined ? {} : parameters.requiredLimits;
        /**
		 * Indicates whether the backend is in compatibility mode or not.
		 * @type {boolean}
		 * @default false
		 */ this.compatibilityMode = this.parameters.compatibilityMode;
        /**
		 * A reference to the device.
		 *
		 * @type {?GPUDevice}
		 * @default null
		 */ this.device = null;
        /**
		 * A reference to the default render pass descriptor.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.defaultRenderPassdescriptor = null;
        /**
		 * A reference to a backend module holding common utility functions.
		 *
		 * @type {WebGPUUtils}
		 */ this.utils = new $d89c9137a3d237c2$var$WebGPUUtils(this);
        /**
		 * A reference to a backend module holding shader attribute-related
		 * utility functions.
		 *
		 * @type {WebGPUAttributeUtils}
		 */ this.attributeUtils = new $d89c9137a3d237c2$var$WebGPUAttributeUtils(this);
        /**
		 * A reference to a backend module holding shader binding-related
		 * utility functions.
		 *
		 * @type {WebGPUBindingUtils}
		 */ this.bindingUtils = new $d89c9137a3d237c2$var$WebGPUBindingUtils(this);
        /**
		 * A reference to a backend module holding shader pipeline-related
		 * utility functions.
		 *
		 * @type {WebGPUPipelineUtils}
		 */ this.pipelineUtils = new $d89c9137a3d237c2$var$WebGPUPipelineUtils(this);
        /**
		 * A reference to a backend module holding shader texture-related
		 * utility functions.
		 *
		 * @type {WebGPUTextureUtils}
		 */ this.textureUtils = new $d89c9137a3d237c2$var$WebGPUTextureUtils(this);
        /**
		 * A map that manages the resolve buffers for occlusion queries.
		 *
		 * @type {Map<number,GPUBuffer>}
		 */ this.occludedResolveCache = new Map();
    }
    /**
	 * Initializes the backend so it is ready for usage.
	 *
	 * @async
	 * @param {Renderer} renderer - The renderer.
	 * @return {Promise} A Promise that resolves when the backend has been initialized.
	 */ async init(renderer) {
        await super.init(renderer);
        //
        const parameters = this.parameters;
        // create the device if it is not passed with parameters
        let device;
        if (parameters.device === undefined) {
            const adapterOptions = {
                powerPreference: parameters.powerPreference,
                featureLevel: parameters.compatibilityMode ? 'compatibility' : undefined
            };
            const adapter = typeof navigator !== 'undefined' ? await navigator.gpu.requestAdapter(adapterOptions) : null;
            if (adapter === null) throw new Error('WebGPUBackend: Unable to create WebGPU adapter.');
            // feature support
            const features = Object.values($d89c9137a3d237c2$var$GPUFeatureName);
            const supportedFeatures = [];
            for (const name of features)if (adapter.features.has(name)) supportedFeatures.push(name);
            const deviceDescriptor = {
                requiredFeatures: supportedFeatures,
                requiredLimits: parameters.requiredLimits
            };
            device = await adapter.requestDevice(deviceDescriptor);
        } else device = parameters.device;
        device.lost.then((info)=>{
            if (info.reason === 'destroyed') return;
            const deviceLossInfo = {
                api: 'WebGPU',
                message: info.message || 'Unknown reason',
                reason: info.reason || null,
                originalEvent: info
            };
            renderer.onDeviceLost(deviceLossInfo);
        });
        this.device = device;
        this.trackTimestamp = this.trackTimestamp && this.hasFeature($d89c9137a3d237c2$var$GPUFeatureName.TimestampQuery);
        this.updateSize();
    }
    /**
	 * A reference to the context.
	 *
	 * @type {?GPUCanvasContext}
	 * @default null
	 */ get context() {
        const canvasTarget = this.renderer.getCanvasTarget();
        const canvasData = this.get(canvasTarget);
        let context = canvasData.context;
        if (context === undefined) {
            const parameters = this.parameters;
            if (canvasTarget.isDefaultCanvasTarget === true && parameters.context !== undefined) context = parameters.context;
            else context = canvasTarget.domElement.getContext('webgpu');
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvasTarget.domElement) canvasTarget.domElement.setAttribute('data-engine', `three.js r${(0, $329ek.REVISION)} webgpu`);
            const alphaMode = parameters.alpha ? 'premultiplied' : 'opaque';
            const toneMappingMode = parameters.outputType === (0, $329ek.HalfFloatType) ? 'extended' : 'standard';
            context.configure({
                device: this.device,
                format: this.utils.getPreferredCanvasFormat(),
                usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
                alphaMode: alphaMode,
                toneMapping: {
                    mode: toneMappingMode
                }
            });
            canvasData.context = context;
        }
        return context;
    }
    /**
	 * The coordinate system of the backend.
	 *
	 * @type {number}
	 * @readonly
	 */ get coordinateSystem() {
        return 0, $329ek.WebGPUCoordinateSystem;
    }
    /**
	 * This method performs a readback operation by moving buffer data from
	 * a storage buffer attribute from the GPU to the CPU.
	 *
	 * @async
	 * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
	 * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync(attribute) {
        return await this.attributeUtils.getArrayBufferAsync(attribute);
    }
    /**
	 * Returns the backend's rendering context.
	 *
	 * @return {GPUCanvasContext} The rendering context.
	 */ getContext() {
        return this.context;
    }
    /**
	 * Returns the default render pass descriptor.
	 *
	 * In WebGPU, the default framebuffer must be configured
	 * like custom framebuffers so the backend needs a render
	 * pass descriptor even when rendering directly to screen.
	 *
	 * @private
	 * @return {Object} The render pass descriptor.
	 */ _getDefaultRenderPassDescriptor() {
        const renderer = this.renderer;
        const canvasTarget = renderer.getCanvasTarget();
        const canvasData = this.get(canvasTarget);
        const samples = renderer.currentSamples;
        let descriptor = canvasData.descriptor;
        if (descriptor === undefined || canvasData.samples !== samples) {
            descriptor = {
                colorAttachments: [
                    {
                        view: null
                    }
                ]
            };
            if (renderer.depth === true || renderer.stencil === true) descriptor.depthStencilAttachment = {
                view: this.textureUtils.getDepthBuffer(renderer.depth, renderer.stencil).createView()
            };
            const colorAttachment = descriptor.colorAttachments[0];
            if (samples > 0) colorAttachment.view = this.textureUtils.getColorBuffer().createView();
            else colorAttachment.resolveTarget = undefined;
            canvasData.descriptor = descriptor;
            canvasData.samples = samples;
        }
        const colorAttachment = descriptor.colorAttachments[0];
        if (samples > 0) colorAttachment.resolveTarget = this.context.getCurrentTexture().createView();
        else colorAttachment.view = this.context.getCurrentTexture().createView();
        return descriptor;
    }
    /**
	 * Internal to determine if the current render target is a render target array with depth 2D array texture.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {boolean} Whether the render target is a render target array with depth 2D array texture.
	 *
	 * @private
	 */ _isRenderCameraDepthArray(renderContext) {
        return renderContext.depthTexture && renderContext.depthTexture.image.depth > 1 && renderContext.camera.isArrayCamera;
    }
    /**
	 * Returns the render pass descriptor for the given render context.
	 *
	 * @private
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object} colorAttachmentsConfig - Configuration object for the color attachments.
	 * @return {Object} The render pass descriptor.
	 */ _getRenderPassDescriptor(renderContext, colorAttachmentsConfig = {}) {
        const renderTarget = renderContext.renderTarget;
        const renderTargetData = this.get(renderTarget);
        let descriptors = renderTargetData.descriptors;
        if (descriptors === undefined || renderTargetData.width !== renderTarget.width || renderTargetData.height !== renderTarget.height || renderTargetData.samples !== renderTarget.samples) {
            descriptors = {};
            renderTargetData.descriptors = descriptors;
        }
        const cacheKey = renderContext.getCacheKey();
        let descriptorBase = descriptors[cacheKey];
        if (descriptorBase === undefined) {
            const textures = renderContext.textures;
            const textureViews = [];
            let sliceIndex;
            const isRenderCameraDepthArray = this._isRenderCameraDepthArray(renderContext);
            for(let i = 0; i < textures.length; i++){
                const textureData = this.get(textures[i]);
                const viewDescriptor = {
                    label: `colorAttachment_${i}`,
                    baseMipLevel: renderContext.activeMipmapLevel,
                    mipLevelCount: 1,
                    baseArrayLayer: renderContext.activeCubeFace,
                    arrayLayerCount: 1,
                    dimension: $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoD
                };
                if (renderTarget.isRenderTarget3D) {
                    sliceIndex = renderContext.activeCubeFace;
                    viewDescriptor.baseArrayLayer = 0;
                    viewDescriptor.dimension = $d89c9137a3d237c2$var$GPUTextureViewDimension.ThreeD;
                    viewDescriptor.depthOrArrayLayers = textures[i].image.depth;
                } else if (renderTarget.isRenderTarget && textures[i].image.depth > 1) {
                    if (isRenderCameraDepthArray === true) {
                        const cameras = renderContext.camera.cameras;
                        for(let layer = 0; layer < cameras.length; layer++){
                            const layerViewDescriptor = {
                                ...viewDescriptor,
                                baseArrayLayer: layer,
                                arrayLayerCount: 1,
                                dimension: $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoD
                            };
                            const textureView = textureData.texture.createView(layerViewDescriptor);
                            textureViews.push({
                                view: textureView,
                                resolveTarget: undefined,
                                depthSlice: undefined
                            });
                        }
                    } else {
                        viewDescriptor.dimension = $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoDArray;
                        viewDescriptor.depthOrArrayLayers = textures[i].image.depth;
                    }
                }
                if (isRenderCameraDepthArray !== true) {
                    const textureView = textureData.texture.createView(viewDescriptor);
                    let view, resolveTarget;
                    if (textureData.msaaTexture !== undefined) {
                        view = textureData.msaaTexture.createView();
                        resolveTarget = textureView;
                    } else {
                        view = textureView;
                        resolveTarget = undefined;
                    }
                    textureViews.push({
                        view: view,
                        resolveTarget: resolveTarget,
                        depthSlice: sliceIndex
                    });
                }
            }
            descriptorBase = {
                textureViews: textureViews
            };
            if (renderContext.depth) {
                const depthTextureData = this.get(renderContext.depthTexture);
                const options = {};
                if (renderContext.depthTexture.isArrayTexture || renderContext.depthTexture.isCubeTexture) {
                    options.dimension = $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoD;
                    options.arrayLayerCount = 1;
                    options.baseArrayLayer = renderContext.activeCubeFace;
                }
                descriptorBase.depthStencilView = depthTextureData.texture.createView(options);
            }
            descriptors[cacheKey] = descriptorBase;
            renderTargetData.width = renderTarget.width;
            renderTargetData.height = renderTarget.height;
            renderTargetData.samples = renderTarget.samples;
            renderTargetData.activeMipmapLevel = renderContext.activeMipmapLevel;
            renderTargetData.activeCubeFace = renderContext.activeCubeFace;
        }
        const descriptor = {
            colorAttachments: []
        };
        // Apply dynamic properties to cached views
        for(let i = 0; i < descriptorBase.textureViews.length; i++){
            const viewInfo = descriptorBase.textureViews[i];
            let clearValue = {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            };
            if (i === 0 && colorAttachmentsConfig.clearValue) clearValue = colorAttachmentsConfig.clearValue;
            descriptor.colorAttachments.push({
                view: viewInfo.view,
                depthSlice: viewInfo.depthSlice,
                resolveTarget: viewInfo.resolveTarget,
                loadOp: colorAttachmentsConfig.loadOp || $d89c9137a3d237c2$var$GPULoadOp.Load,
                storeOp: colorAttachmentsConfig.storeOp || $d89c9137a3d237c2$var$GPUStoreOp.Store,
                clearValue: clearValue
            });
        }
        if (descriptorBase.depthStencilView) descriptor.depthStencilAttachment = {
            view: descriptorBase.depthStencilView
        };
        return descriptor;
    }
    /**
	 * This method is executed at the beginning of a render call and prepares
	 * the WebGPU state for upcoming render calls
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ beginRender(renderContext) {
        const renderContextData = this.get(renderContext);
        //
        const device = this.device;
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        let occlusionQuerySet;
        if (occlusionQueryCount > 0) {
            if (renderContextData.currentOcclusionQuerySet) renderContextData.currentOcclusionQuerySet.destroy();
            if (renderContextData.currentOcclusionQueryBuffer) renderContextData.currentOcclusionQueryBuffer.destroy();
            // Get a reference to the array of objects with queries. The renderContextData property
            // can be changed by another render pass before the buffer.mapAsyc() completes.
            renderContextData.currentOcclusionQuerySet = renderContextData.occlusionQuerySet;
            renderContextData.currentOcclusionQueryBuffer = renderContextData.occlusionQueryBuffer;
            renderContextData.currentOcclusionQueryObjects = renderContextData.occlusionQueryObjects;
            //
            occlusionQuerySet = device.createQuerySet({
                type: 'occlusion',
                count: occlusionQueryCount,
                label: `occlusionQuerySet_${renderContext.id}`
            });
            renderContextData.occlusionQuerySet = occlusionQuerySet;
            renderContextData.occlusionQueryIndex = 0;
            renderContextData.occlusionQueryObjects = new Array(occlusionQueryCount);
            renderContextData.lastOcclusionObject = null;
        }
        let descriptor;
        if (renderContext.textures === null) descriptor = this._getDefaultRenderPassDescriptor();
        else descriptor = this._getRenderPassDescriptor(renderContext, {
            loadOp: $d89c9137a3d237c2$var$GPULoadOp.Load
        });
        this.initTimestampQuery((0, $329ek.TimestampQuery).RENDER, this.getTimestampUID(renderContext), descriptor);
        descriptor.occlusionQuerySet = occlusionQuerySet;
        const depthStencilAttachment = descriptor.depthStencilAttachment;
        if (renderContext.textures !== null) {
            const colorAttachments = descriptor.colorAttachments;
            for(let i = 0; i < colorAttachments.length; i++){
                const colorAttachment = colorAttachments[i];
                if (renderContext.clearColor) {
                    colorAttachment.clearValue = i === 0 ? renderContext.clearColorValue : {
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 1
                    };
                    colorAttachment.loadOp = $d89c9137a3d237c2$var$GPULoadOp.Clear;
                } else colorAttachment.loadOp = $d89c9137a3d237c2$var$GPULoadOp.Load;
                colorAttachment.storeOp = $d89c9137a3d237c2$var$GPUStoreOp.Store;
            }
        } else {
            const colorAttachment = descriptor.colorAttachments[0];
            if (renderContext.clearColor) {
                colorAttachment.clearValue = renderContext.clearColorValue;
                colorAttachment.loadOp = $d89c9137a3d237c2$var$GPULoadOp.Clear;
            } else colorAttachment.loadOp = $d89c9137a3d237c2$var$GPULoadOp.Load;
            colorAttachment.storeOp = $d89c9137a3d237c2$var$GPUStoreOp.Store;
        }
        //
        if (renderContext.depth) {
            if (renderContext.clearDepth) {
                depthStencilAttachment.depthClearValue = renderContext.clearDepthValue;
                depthStencilAttachment.depthLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Clear;
            } else depthStencilAttachment.depthLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Load;
            depthStencilAttachment.depthStoreOp = $d89c9137a3d237c2$var$GPUStoreOp.Store;
        }
        if (renderContext.stencil) {
            if (renderContext.clearStencil) {
                depthStencilAttachment.stencilClearValue = renderContext.clearStencilValue;
                depthStencilAttachment.stencilLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Clear;
            } else depthStencilAttachment.stencilLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Load;
            depthStencilAttachment.stencilStoreOp = $d89c9137a3d237c2$var$GPUStoreOp.Store;
        }
        //
        const encoder = device.createCommandEncoder({
            label: 'renderContext_' + renderContext.id
        });
        // shadow arrays - prepare bundle encoders for each camera in an array camera
        if (this._isRenderCameraDepthArray(renderContext) === true) {
            const cameras = renderContext.camera.cameras;
            if (!renderContextData.layerDescriptors || renderContextData.layerDescriptors.length !== cameras.length) this._createDepthLayerDescriptors(renderContext, renderContextData, descriptor, cameras);
            else this._updateDepthLayerDescriptors(renderContext, renderContextData, cameras);
            // Create bundle encoders for each layer
            renderContextData.bundleEncoders = [];
            renderContextData.bundleSets = [];
            // Create separate bundle encoders for each camera in the array
            for(let i = 0; i < cameras.length; i++){
                const bundleEncoder = this.pipelineUtils.createBundleEncoder(renderContext, 'renderBundleArrayCamera_' + i);
                // Initialize state tracking for this bundle
                const bundleSets = {
                    attributes: {},
                    bindingGroups: [],
                    pipeline: null,
                    index: null
                };
                renderContextData.bundleEncoders.push(bundleEncoder);
                renderContextData.bundleSets.push(bundleSets);
            }
            // We'll complete the bundles in finishRender
            renderContextData.currentPass = null;
        } else {
            const currentPass = encoder.beginRenderPass(descriptor);
            renderContextData.currentPass = currentPass;
            if (renderContext.viewport) this.updateViewport(renderContext);
            if (renderContext.scissor) this.updateScissor(renderContext);
        }
        //
        renderContextData.descriptor = descriptor;
        renderContextData.encoder = encoder;
        renderContextData.currentSets = {
            attributes: {},
            bindingGroups: [],
            pipeline: null,
            index: null
        };
        renderContextData.renderBundles = [];
    }
    /**
	 * This method creates layer descriptors for each camera in an array camera
	 * to prepare for rendering to a depth array texture.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object} renderContextData - The render context data.
	 * @param {Object} descriptor  - The render pass descriptor.
	 * @param {ArrayCamera} cameras - The array camera.
	 *
	 * @private
	 */ _createDepthLayerDescriptors(renderContext, renderContextData, descriptor, cameras) {
        const depthStencilAttachment = descriptor.depthStencilAttachment;
        renderContextData.layerDescriptors = [];
        const depthTextureData = this.get(renderContext.depthTexture);
        if (!depthTextureData.viewCache) depthTextureData.viewCache = [];
        for(let i = 0; i < cameras.length; i++){
            const layerDescriptor = {
                ...descriptor,
                colorAttachments: [
                    {
                        ...descriptor.colorAttachments[0],
                        view: descriptor.colorAttachments[i].view
                    }
                ]
            };
            if (descriptor.depthStencilAttachment) {
                const layerIndex = i;
                if (!depthTextureData.viewCache[layerIndex]) depthTextureData.viewCache[layerIndex] = depthTextureData.texture.createView({
                    dimension: $d89c9137a3d237c2$var$GPUTextureViewDimension.TwoD,
                    baseArrayLayer: i,
                    arrayLayerCount: 1
                });
                layerDescriptor.depthStencilAttachment = {
                    view: depthTextureData.viewCache[layerIndex],
                    depthLoadOp: depthStencilAttachment.depthLoadOp || $d89c9137a3d237c2$var$GPULoadOp.Clear,
                    depthStoreOp: depthStencilAttachment.depthStoreOp || $d89c9137a3d237c2$var$GPUStoreOp.Store,
                    depthClearValue: depthStencilAttachment.depthClearValue || 1.0
                };
                if (renderContext.stencil) {
                    layerDescriptor.depthStencilAttachment.stencilLoadOp = depthStencilAttachment.stencilLoadOp;
                    layerDescriptor.depthStencilAttachment.stencilStoreOp = depthStencilAttachment.stencilStoreOp;
                    layerDescriptor.depthStencilAttachment.stencilClearValue = depthStencilAttachment.stencilClearValue;
                }
            } else layerDescriptor.depthStencilAttachment = {
                ...depthStencilAttachment
            };
            renderContextData.layerDescriptors.push(layerDescriptor);
        }
    }
    /**
	 * This method updates the layer descriptors for each camera in an array camera
	 * to prepare for rendering to a depth array texture.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object} renderContextData - The render context data.
	 * @param {ArrayCamera} cameras - The array camera.
	 *
	 */ _updateDepthLayerDescriptors(renderContext, renderContextData, cameras) {
        for(let i = 0; i < cameras.length; i++){
            const layerDescriptor = renderContextData.layerDescriptors[i];
            if (layerDescriptor.depthStencilAttachment) {
                const depthAttachment = layerDescriptor.depthStencilAttachment;
                if (renderContext.depth) {
                    if (renderContext.clearDepth) {
                        depthAttachment.depthClearValue = renderContext.clearDepthValue;
                        depthAttachment.depthLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Clear;
                    } else depthAttachment.depthLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Load;
                }
                if (renderContext.stencil) {
                    if (renderContext.clearStencil) {
                        depthAttachment.stencilClearValue = renderContext.clearStencilValue;
                        depthAttachment.stencilLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Clear;
                    } else depthAttachment.stencilLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Load;
                }
            }
        }
    }
    /**
	 * This method is executed at the end of a render call and finalizes work
	 * after draw calls.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ finishRender(renderContext) {
        const renderContextData = this.get(renderContext);
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        if (renderContextData.renderBundles.length > 0) renderContextData.currentPass.executeBundles(renderContextData.renderBundles);
        if (occlusionQueryCount > renderContextData.occlusionQueryIndex) renderContextData.currentPass.endOcclusionQuery();
        // shadow arrays - Execute bundles for each layer
        const encoder = renderContextData.encoder;
        if (this._isRenderCameraDepthArray(renderContext) === true) {
            const bundles = [];
            for(let i = 0; i < renderContextData.bundleEncoders.length; i++){
                const bundleEncoder = renderContextData.bundleEncoders[i];
                bundles.push(bundleEncoder.finish());
            }
            for(let i = 0; i < renderContextData.layerDescriptors.length; i++)if (i < bundles.length) {
                const layerDescriptor = renderContextData.layerDescriptors[i];
                const renderPass = encoder.beginRenderPass(layerDescriptor);
                if (renderContext.viewport) {
                    const { x: x, y: y, width: width, height: height, minDepth: minDepth, maxDepth: maxDepth } = renderContext.viewportValue;
                    renderPass.setViewport(x, y, width, height, minDepth, maxDepth);
                }
                if (renderContext.scissor) {
                    const { x: x, y: y, width: width, height: height } = renderContext.scissorValue;
                    renderPass.setScissorRect(x, y, width, height);
                }
                renderPass.executeBundles([
                    bundles[i]
                ]);
                renderPass.end();
            }
        } else if (renderContextData.currentPass) renderContextData.currentPass.end();
        if (occlusionQueryCount > 0) {
            const bufferSize = occlusionQueryCount * 8; // 8 byte entries for query results
            //
            let queryResolveBuffer = this.occludedResolveCache.get(bufferSize);
            if (queryResolveBuffer === undefined) {
                queryResolveBuffer = this.device.createBuffer({
                    size: bufferSize,
                    usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
                });
                this.occludedResolveCache.set(bufferSize, queryResolveBuffer);
            }
            //
            const readBuffer = this.device.createBuffer({
                size: bufferSize,
                usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
            });
            // two buffers required here - WebGPU doesn't allow usage of QUERY_RESOLVE & MAP_READ to be combined
            renderContextData.encoder.resolveQuerySet(renderContextData.occlusionQuerySet, 0, occlusionQueryCount, queryResolveBuffer, 0);
            renderContextData.encoder.copyBufferToBuffer(queryResolveBuffer, 0, readBuffer, 0, bufferSize);
            renderContextData.occlusionQueryBuffer = readBuffer;
            //
            this.resolveOccludedAsync(renderContext);
        }
        this.device.queue.submit([
            renderContextData.encoder.finish()
        ]);
        //
        if (renderContext.textures !== null) {
            const textures = renderContext.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                if (texture.generateMipmaps === true) this.textureUtils.generateMipmaps(texture);
            }
        }
    }
    /**
	 * Returns `true` if the given 3D object is fully occluded by other
	 * 3D objects in the scene.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object is fully occluded or not.
	 */ isOccluded(renderContext, object) {
        const renderContextData = this.get(renderContext);
        return renderContextData.occluded && renderContextData.occluded.has(object);
    }
    /**
	 * This method processes the result of occlusion queries and writes it
	 * into render context data.
	 *
	 * @async
	 * @param {RenderContext} renderContext - The render context.
	 * @return {Promise} A Promise that resolves when the occlusion query results have been processed.
	 */ async resolveOccludedAsync(renderContext) {
        const renderContextData = this.get(renderContext);
        // handle occlusion query results
        const { currentOcclusionQueryBuffer: currentOcclusionQueryBuffer, currentOcclusionQueryObjects: currentOcclusionQueryObjects } = renderContextData;
        if (currentOcclusionQueryBuffer && currentOcclusionQueryObjects) {
            const occluded = new WeakSet();
            renderContextData.currentOcclusionQueryObjects = null;
            renderContextData.currentOcclusionQueryBuffer = null;
            await currentOcclusionQueryBuffer.mapAsync(GPUMapMode.READ);
            const buffer = currentOcclusionQueryBuffer.getMappedRange();
            const results = new BigUint64Array(buffer);
            for(let i = 0; i < currentOcclusionQueryObjects.length; i++)if (results[i] === BigInt(0)) occluded.add(currentOcclusionQueryObjects[i]);
            currentOcclusionQueryBuffer.destroy();
            renderContextData.occluded = occluded;
        }
    }
    /**
	 * Updates the viewport with the values from the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ updateViewport(renderContext) {
        const { currentPass: currentPass } = this.get(renderContext);
        const { x: x, y: y, width: width, height: height, minDepth: minDepth, maxDepth: maxDepth } = renderContext.viewportValue;
        currentPass.setViewport(x, y, width, height, minDepth, maxDepth);
    }
    /**
	 * Updates the scissor with the values from the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ updateScissor(renderContext) {
        const { currentPass: currentPass } = this.get(renderContext);
        const { x: x, y: y, width: width, height: height } = renderContext.scissorValue;
        currentPass.setScissorRect(x, y, width, height);
    }
    /**
	 * Returns the clear color and alpha into a single
	 * color object.
	 *
	 * @return {Color4} The clear color.
	 */ getClearColor() {
        const clearColor = super.getClearColor();
        // only premultiply alpha when alphaMode is "premultiplied"
        if (this.renderer.alpha === true) {
            clearColor.r *= clearColor.a;
            clearColor.g *= clearColor.a;
            clearColor.b *= clearColor.a;
        }
        return clearColor;
    }
    /**
	 * Performs a clear operation.
	 *
	 * @param {boolean} color - Whether the color buffer should be cleared or not.
	 * @param {boolean} depth - Whether the depth buffer should be cleared or not.
	 * @param {boolean} stencil - Whether the stencil buffer should be cleared or not.
	 * @param {?RenderContext} [renderTargetContext=null] - The render context of the current set render target.
	 */ clear(color, depth, stencil, renderTargetContext = null) {
        const device = this.device;
        const renderer = this.renderer;
        let colorAttachments = [];
        let depthStencilAttachment;
        let clearValue;
        let supportsDepth;
        let supportsStencil;
        if (color) {
            const clearColor = this.getClearColor();
            clearValue = {
                r: clearColor.r,
                g: clearColor.g,
                b: clearColor.b,
                a: clearColor.a
            };
        }
        if (renderTargetContext === null) {
            supportsDepth = renderer.depth;
            supportsStencil = renderer.stencil;
            const descriptor = this._getDefaultRenderPassDescriptor();
            if (color) {
                colorAttachments = descriptor.colorAttachments;
                const colorAttachment = colorAttachments[0];
                colorAttachment.clearValue = clearValue;
                colorAttachment.loadOp = $d89c9137a3d237c2$var$GPULoadOp.Clear;
                colorAttachment.storeOp = $d89c9137a3d237c2$var$GPUStoreOp.Store;
            }
            if (supportsDepth || supportsStencil) depthStencilAttachment = descriptor.depthStencilAttachment;
        } else {
            supportsDepth = renderTargetContext.depth;
            supportsStencil = renderTargetContext.stencil;
            const clearConfig = {
                loadOp: color ? $d89c9137a3d237c2$var$GPULoadOp.Clear : $d89c9137a3d237c2$var$GPULoadOp.Load,
                clearValue: color ? clearValue : undefined
            };
            if (supportsDepth) {
                clearConfig.depthLoadOp = depth ? $d89c9137a3d237c2$var$GPULoadOp.Clear : $d89c9137a3d237c2$var$GPULoadOp.Load;
                clearConfig.depthClearValue = depth ? renderer.getClearDepth() : undefined;
                clearConfig.depthStoreOp = $d89c9137a3d237c2$var$GPUStoreOp.Store;
            }
            if (supportsStencil) {
                clearConfig.stencilLoadOp = stencil ? $d89c9137a3d237c2$var$GPULoadOp.Clear : $d89c9137a3d237c2$var$GPULoadOp.Load;
                clearConfig.stencilClearValue = stencil ? renderer.getClearStencil() : undefined;
                clearConfig.stencilStoreOp = $d89c9137a3d237c2$var$GPUStoreOp.Store;
            }
            const descriptor = this._getRenderPassDescriptor(renderTargetContext, clearConfig);
            colorAttachments = descriptor.colorAttachments;
            depthStencilAttachment = descriptor.depthStencilAttachment;
        }
        if (supportsDepth && depthStencilAttachment) {
            if (depth) {
                depthStencilAttachment.depthLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Clear;
                depthStencilAttachment.depthClearValue = renderer.getClearDepth();
                depthStencilAttachment.depthStoreOp = $d89c9137a3d237c2$var$GPUStoreOp.Store;
            } else {
                depthStencilAttachment.depthLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Load;
                depthStencilAttachment.depthStoreOp = $d89c9137a3d237c2$var$GPUStoreOp.Store;
            }
        }
        //
        if (supportsStencil && depthStencilAttachment) {
            if (stencil) {
                depthStencilAttachment.stencilLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Clear;
                depthStencilAttachment.stencilClearValue = renderer.getClearStencil();
                depthStencilAttachment.stencilStoreOp = $d89c9137a3d237c2$var$GPUStoreOp.Store;
            } else {
                depthStencilAttachment.stencilLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Load;
                depthStencilAttachment.stencilStoreOp = $d89c9137a3d237c2$var$GPUStoreOp.Store;
            }
        }
        //
        const encoder = device.createCommandEncoder({
            label: 'clear'
        });
        const currentPass = encoder.beginRenderPass({
            colorAttachments: colorAttachments,
            depthStencilAttachment: depthStencilAttachment
        });
        currentPass.end();
        device.queue.submit([
            encoder.finish()
        ]);
    }
    // compute
    /**
	 * This method is executed at the beginning of a compute call and
	 * prepares the state for upcoming compute tasks.
	 *
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ beginCompute(computeGroup) {
        const groupGPU = this.get(computeGroup);
        //
        const descriptor = {
            label: 'computeGroup_' + computeGroup.id
        };
        this.initTimestampQuery((0, $329ek.TimestampQuery).COMPUTE, this.getTimestampUID(computeGroup), descriptor);
        groupGPU.cmdEncoderGPU = this.device.createCommandEncoder({
            label: 'computeGroup_' + computeGroup.id
        });
        groupGPU.passEncoderGPU = groupGPU.cmdEncoderGPU.beginComputePass(descriptor);
    }
    /**
	 * Executes a compute command for the given compute node.
	 *
	 * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
	 * @param {Node} computeNode - The compute node.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @param {ComputePipeline} pipeline - The compute pipeline.
	 * @param {number|Array<number>|IndirectStorageBufferAttribute} [dispatchSize=null]
	 * - A single number representing count, or
	 * - An array [x, y, z] representing dispatch size, or
	 * - A IndirectStorageBufferAttribute for indirect dispatch size.
	 */ compute(computeGroup, computeNode, bindings, pipeline, dispatchSize = null) {
        const computeNodeData = this.get(computeNode);
        const { passEncoderGPU: passEncoderGPU } = this.get(computeGroup);
        // pipeline
        const pipelineGPU = this.get(pipeline).pipeline;
        this.pipelineUtils.setPipeline(passEncoderGPU, pipelineGPU);
        // bind groups
        for(let i = 0, l = bindings.length; i < l; i++){
            const bindGroup = bindings[i];
            const bindingsData = this.get(bindGroup);
            passEncoderGPU.setBindGroup(i, bindingsData.group);
        }
        if (dispatchSize === null) dispatchSize = computeNode.count;
        // When the dispatchSize is set with a StorageBuffer from the GPU.
        if (dispatchSize && typeof dispatchSize === 'object' && dispatchSize.isIndirectStorageBufferAttribute) {
            const dispatchBuffer = this.get(dispatchSize).buffer;
            passEncoderGPU.dispatchWorkgroupsIndirect(dispatchBuffer, 0);
            return;
        }
        if (typeof dispatchSize === 'number') {
            // If a single number is given, we calculate the dispatch size based on the workgroup size
            const count = dispatchSize;
            if (computeNodeData.dispatchSize === undefined || computeNodeData.count !== count) {
                // cache dispatch size to avoid recalculating it every time
                computeNodeData.dispatchSize = [
                    0,
                    1,
                    1
                ];
                computeNodeData.count = count;
                const workgroupSize = computeNode.workgroupSize;
                let size = workgroupSize[0];
                for(let i = 1; i < workgroupSize.length; i++)size *= workgroupSize[i];
                const dispatchCount = Math.ceil(count / size);
                //
                const maxComputeWorkgroupsPerDimension = this.device.limits.maxComputeWorkgroupsPerDimension;
                dispatchSize = [
                    dispatchCount,
                    1,
                    1
                ];
                if (dispatchCount > maxComputeWorkgroupsPerDimension) {
                    dispatchSize[0] = Math.min(dispatchCount, maxComputeWorkgroupsPerDimension);
                    dispatchSize[1] = Math.ceil(dispatchCount / maxComputeWorkgroupsPerDimension);
                }
                computeNodeData.dispatchSize = dispatchSize;
            }
            dispatchSize = computeNodeData.dispatchSize;
        }
        //
        passEncoderGPU.dispatchWorkgroups(dispatchSize[0], dispatchSize[1] || 1, dispatchSize[2] || 1);
    }
    /**
	 * This method is executed at the end of a compute call and
	 * finalizes work after compute tasks.
	 *
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ finishCompute(computeGroup) {
        const groupData = this.get(computeGroup);
        groupData.passEncoderGPU.end();
        this.device.queue.submit([
            groupData.cmdEncoderGPU.finish()
        ]);
    }
    // render object
    /**
	 * Executes a draw command for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object to draw.
	 * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
	 */ draw(renderObject, info) {
        const { object: object, material: material, context: context, pipeline: pipeline } = renderObject;
        const bindings = renderObject.getBindings();
        const renderContextData = this.get(context);
        const pipelineData = this.get(pipeline);
        const pipelineGPU = pipelineData.pipeline;
        if (pipelineData.error === true) return;
        const index = renderObject.getIndex();
        const hasIndex = index !== null;
        const drawParams = renderObject.getDrawParameters();
        if (drawParams === null) return;
        // pipeline
        const setPipelineAndBindings = (passEncoderGPU, currentSets)=>{
            // pipeline
            this.pipelineUtils.setPipeline(passEncoderGPU, pipelineGPU);
            currentSets.pipeline = pipelineGPU;
            // bind groups
            const currentBindingGroups = currentSets.bindingGroups;
            for(let i = 0, l = bindings.length; i < l; i++){
                const bindGroup = bindings[i];
                const bindingsData = this.get(bindGroup);
                if (currentBindingGroups[bindGroup.index] !== bindGroup.id) {
                    passEncoderGPU.setBindGroup(bindGroup.index, bindingsData.group);
                    currentBindingGroups[bindGroup.index] = bindGroup.id;
                }
            }
            // attributes
            // index
            if (hasIndex === true) {
                if (currentSets.index !== index) {
                    const buffer = this.get(index).buffer;
                    const indexFormat = index.array instanceof Uint16Array ? $d89c9137a3d237c2$var$GPUIndexFormat.Uint16 : $d89c9137a3d237c2$var$GPUIndexFormat.Uint32;
                    passEncoderGPU.setIndexBuffer(buffer, indexFormat);
                    currentSets.index = index;
                }
            }
            // vertex buffers
            const vertexBuffers = renderObject.getVertexBuffers();
            for(let i = 0, l = vertexBuffers.length; i < l; i++){
                const vertexBuffer = vertexBuffers[i];
                if (currentSets.attributes[i] !== vertexBuffer) {
                    const buffer = this.get(vertexBuffer).buffer;
                    passEncoderGPU.setVertexBuffer(i, buffer);
                    currentSets.attributes[i] = vertexBuffer;
                }
            }
            // stencil
            if (context.stencil === true && material.stencilWrite === true && renderContextData.currentStencilRef !== material.stencilRef) {
                passEncoderGPU.setStencilReference(material.stencilRef);
                renderContextData.currentStencilRef = material.stencilRef;
            }
        };
        // Define draw function
        const draw = (passEncoderGPU, currentSets)=>{
            setPipelineAndBindings(passEncoderGPU, currentSets);
            if (object.isBatchedMesh === true) {
                const starts = object._multiDrawStarts;
                const counts = object._multiDrawCounts;
                const drawCount = object._multiDrawCount;
                const drawInstances = object._multiDrawInstances;
                if (drawInstances !== null) // @deprecated, r174
                (0, $329ek.warnOnce)('WebGPUBackend: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.');
                for(let i = 0; i < drawCount; i++){
                    const count = drawInstances ? drawInstances[i] : 1;
                    const firstInstance = count > 1 ? 0 : i;
                    if (hasIndex === true) passEncoderGPU.drawIndexed(counts[i], count, starts[i] / index.array.BYTES_PER_ELEMENT, 0, firstInstance);
                    else passEncoderGPU.draw(counts[i], count, starts[i], firstInstance);
                    info.update(object, counts[i], count);
                }
            } else if (hasIndex === true) {
                const { vertexCount: indexCount, instanceCount: instanceCount, firstVertex: firstIndex } = drawParams;
                const indirect = renderObject.getIndirect();
                if (indirect !== null) {
                    const buffer = this.get(indirect).buffer;
                    const indirectOffset = renderObject.getIndirectOffset();
                    const indirectOffsets = Array.isArray(indirectOffset) ? indirectOffset : [
                        indirectOffset
                    ];
                    for(let i = 0; i < indirectOffsets.length; i++)passEncoderGPU.drawIndexedIndirect(buffer, indirectOffsets[i]);
                } else passEncoderGPU.drawIndexed(indexCount, instanceCount, firstIndex, 0, 0);
                info.update(object, indexCount, instanceCount);
            } else {
                const { vertexCount: vertexCount, instanceCount: instanceCount, firstVertex: firstVertex } = drawParams;
                const indirect = renderObject.getIndirect();
                if (indirect !== null) {
                    const buffer = this.get(indirect).buffer;
                    const indirectOffset = renderObject.getIndirectOffset();
                    const indirectOffsets = Array.isArray(indirectOffset) ? indirectOffset : [
                        indirectOffset
                    ];
                    for(let i = 0; i < indirectOffsets.length; i++)passEncoderGPU.drawIndirect(buffer, indirectOffsets[i]);
                } else passEncoderGPU.draw(vertexCount, instanceCount, firstVertex, 0);
                info.update(object, vertexCount, instanceCount);
            }
        };
        if (renderObject.camera.isArrayCamera && renderObject.camera.cameras.length > 0) {
            const cameraData = this.get(renderObject.camera);
            const cameras = renderObject.camera.cameras;
            const cameraIndex = renderObject.getBindingGroup('cameraIndex');
            if (cameraData.indexesGPU === undefined || cameraData.indexesGPU.length !== cameras.length) {
                const bindingsData = this.get(cameraIndex);
                const indexesGPU = [];
                const data = new Uint32Array([
                    0,
                    0,
                    0,
                    0
                ]);
                for(let i = 0, len = cameras.length; i < len; i++){
                    data[0] = i;
                    const { layoutGPU: layoutGPU } = bindingsData.layout;
                    const bindGroupIndex = this.bindingUtils.createBindGroupIndex(data, layoutGPU);
                    indexesGPU.push(bindGroupIndex);
                }
                cameraData.indexesGPU = indexesGPU; // TODO: Create a global library for this
            }
            const pixelRatio = this.renderer.getPixelRatio();
            for(let i = 0, len = cameras.length; i < len; i++){
                const subCamera = cameras[i];
                if (object.layers.test(subCamera.layers)) {
                    const vp = subCamera.viewport;
                    let pass = renderContextData.currentPass;
                    let sets = renderContextData.currentSets;
                    if (renderContextData.bundleEncoders) {
                        const bundleEncoder = renderContextData.bundleEncoders[i];
                        const bundleSets = renderContextData.bundleSets[i];
                        pass = bundleEncoder;
                        sets = bundleSets;
                    }
                    if (vp) pass.setViewport(Math.floor(vp.x * pixelRatio), Math.floor(vp.y * pixelRatio), Math.floor(vp.width * pixelRatio), Math.floor(vp.height * pixelRatio), context.viewportValue.minDepth, context.viewportValue.maxDepth);
                    // Set camera index binding for this layer
                    if (cameraIndex && cameraData.indexesGPU) {
                        pass.setBindGroup(cameraIndex.index, cameraData.indexesGPU[i]);
                        sets.bindingGroups[cameraIndex.index] = cameraIndex.id;
                    }
                    draw(pass, sets);
                }
            }
        } else // Regular single camera rendering
        if (renderContextData.currentPass) {
            // Handle occlusion queries
            if (renderContextData.occlusionQuerySet !== undefined) {
                const lastObject = renderContextData.lastOcclusionObject;
                if (lastObject !== object) {
                    if (lastObject !== null && lastObject.occlusionTest === true) {
                        renderContextData.currentPass.endOcclusionQuery();
                        renderContextData.occlusionQueryIndex++;
                    }
                    if (object.occlusionTest === true) {
                        renderContextData.currentPass.beginOcclusionQuery(renderContextData.occlusionQueryIndex);
                        renderContextData.occlusionQueryObjects[renderContextData.occlusionQueryIndex] = object;
                    }
                    renderContextData.lastOcclusionObject = object;
                }
            }
            draw(renderContextData.currentPass, renderContextData.currentSets);
        }
    }
    // cache key
    /**
	 * Returns `true` if the render pipeline requires an update.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the render pipeline requires an update or not.
	 */ needsRenderUpdate(renderObject) {
        const data = this.get(renderObject);
        const { object: object, material: material } = renderObject;
        const utils = this.utils;
        const sampleCount = utils.getSampleCountRenderContext(renderObject.context);
        const colorSpace = utils.getCurrentColorSpace(renderObject.context);
        const colorFormat = utils.getCurrentColorFormat(renderObject.context);
        const depthStencilFormat = utils.getCurrentDepthStencilFormat(renderObject.context);
        const primitiveTopology = utils.getPrimitiveTopology(object, material);
        let needsUpdate = false;
        if (data.material !== material || data.materialVersion !== material.version || data.transparent !== material.transparent || data.blending !== material.blending || data.premultipliedAlpha !== material.premultipliedAlpha || data.blendSrc !== material.blendSrc || data.blendDst !== material.blendDst || data.blendEquation !== material.blendEquation || data.blendSrcAlpha !== material.blendSrcAlpha || data.blendDstAlpha !== material.blendDstAlpha || data.blendEquationAlpha !== material.blendEquationAlpha || data.colorWrite !== material.colorWrite || data.depthWrite !== material.depthWrite || data.depthTest !== material.depthTest || data.depthFunc !== material.depthFunc || data.stencilWrite !== material.stencilWrite || data.stencilFunc !== material.stencilFunc || data.stencilFail !== material.stencilFail || data.stencilZFail !== material.stencilZFail || data.stencilZPass !== material.stencilZPass || data.stencilFuncMask !== material.stencilFuncMask || data.stencilWriteMask !== material.stencilWriteMask || data.side !== material.side || data.alphaToCoverage !== material.alphaToCoverage || data.sampleCount !== sampleCount || data.colorSpace !== colorSpace || data.colorFormat !== colorFormat || data.depthStencilFormat !== depthStencilFormat || data.primitiveTopology !== primitiveTopology || data.clippingContextCacheKey !== renderObject.clippingContextCacheKey) {
            data.material = material;
            data.materialVersion = material.version;
            data.transparent = material.transparent;
            data.blending = material.blending;
            data.premultipliedAlpha = material.premultipliedAlpha;
            data.blendSrc = material.blendSrc;
            data.blendDst = material.blendDst;
            data.blendEquation = material.blendEquation;
            data.blendSrcAlpha = material.blendSrcAlpha;
            data.blendDstAlpha = material.blendDstAlpha;
            data.blendEquationAlpha = material.blendEquationAlpha;
            data.colorWrite = material.colorWrite;
            data.depthWrite = material.depthWrite;
            data.depthTest = material.depthTest;
            data.depthFunc = material.depthFunc;
            data.stencilWrite = material.stencilWrite;
            data.stencilFunc = material.stencilFunc;
            data.stencilFail = material.stencilFail;
            data.stencilZFail = material.stencilZFail;
            data.stencilZPass = material.stencilZPass;
            data.stencilFuncMask = material.stencilFuncMask;
            data.stencilWriteMask = material.stencilWriteMask;
            data.side = material.side;
            data.alphaToCoverage = material.alphaToCoverage;
            data.sampleCount = sampleCount;
            data.colorSpace = colorSpace;
            data.colorFormat = colorFormat;
            data.depthStencilFormat = depthStencilFormat;
            data.primitiveTopology = primitiveTopology;
            data.clippingContextCacheKey = renderObject.clippingContextCacheKey;
            needsUpdate = true;
        }
        return needsUpdate;
    }
    /**
	 * Returns a cache key that is used to identify render pipelines.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {string} The cache key.
	 */ getRenderCacheKey(renderObject) {
        const { object: object, material: material } = renderObject;
        const utils = this.utils;
        const renderContext = renderObject.context;
        // meshes with negative scale have a different frontFace render pipeline
        // descriptor value so the following must be honored in the cache key
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        return [
            material.transparent,
            material.blending,
            material.premultipliedAlpha,
            material.blendSrc,
            material.blendDst,
            material.blendEquation,
            material.blendSrcAlpha,
            material.blendDstAlpha,
            material.blendEquationAlpha,
            material.colorWrite,
            material.depthWrite,
            material.depthTest,
            material.depthFunc,
            material.stencilWrite,
            material.stencilFunc,
            material.stencilFail,
            material.stencilZFail,
            material.stencilZPass,
            material.stencilFuncMask,
            material.stencilWriteMask,
            material.side,
            frontFaceCW,
            utils.getSampleCountRenderContext(renderContext),
            utils.getCurrentColorSpace(renderContext),
            utils.getCurrentColorFormat(renderContext),
            utils.getCurrentDepthStencilFormat(renderContext),
            utils.getPrimitiveTopology(object, material),
            renderObject.getGeometryCacheKey(),
            renderObject.clippingContextCacheKey
        ].join();
    }
    // textures
    /**
	 * Updates a GPU sampler for the given texture.
	 *
	 * @param {Texture} texture - The texture to update the sampler for.
	 * @return {string} The current sampler key.
	 */ updateSampler(texture) {
        return this.textureUtils.updateSampler(texture);
    }
    /**
	 * Creates a default texture for the given texture that can be used
	 * as a placeholder until the actual texture is ready for usage.
	 *
	 * @param {Texture} texture - The texture to create a default texture for.
	 * @return {boolean} Whether the sampler has been updated or not.
	 */ createDefaultTexture(texture) {
        return this.textureUtils.createDefaultTexture(texture);
    }
    /**
	 * Defines a texture on the GPU for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ createTexture(texture, options) {
        this.textureUtils.createTexture(texture, options);
    }
    /**
	 * Uploads the updated texture data to the GPU.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ updateTexture(texture, options) {
        this.textureUtils.updateTexture(texture, options);
    }
    /**
	 * Generates mipmaps for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 */ generateMipmaps(texture) {
        this.textureUtils.generateMipmaps(texture);
    }
    /**
	 * Destroys the GPU data for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
	 */ destroyTexture(texture, isDefaultTexture = false) {
        this.textureUtils.destroyTexture(texture, isDefaultTexture);
    }
    /**
	 * Returns texture data as a typed array.
	 *
	 * @async
	 * @param {Texture} texture - The texture to copy.
	 * @param {number} x - The x coordinate of the copy origin.
	 * @param {number} y - The y coordinate of the copy origin.
	 * @param {number} width - The width of the copy.
	 * @param {number} height - The height of the copy.
	 * @param {number} faceIndex - The face index.
	 * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
	 */ async copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        return this.textureUtils.copyTextureToBuffer(texture, x, y, width, height, faceIndex);
    }
    /**
	 * Inits a time stamp query for the given render context.
	 *
	 * @param {string} type - The type of the timestamp query (e.g. 'render', 'compute').
	 * @param {number} uid - Unique id for the context (e.g. render context id).
	 * @param {Object} descriptor - The query descriptor.
	 */ initTimestampQuery(type, uid, descriptor) {
        if (!this.trackTimestamp) return;
        if (!this.timestampQueryPool[type]) // TODO: Variable maxQueries?
        this.timestampQueryPool[type] = new $d89c9137a3d237c2$var$WebGPUTimestampQueryPool(this.device, type, 2048);
        const timestampQueryPool = this.timestampQueryPool[type];
        const baseOffset = timestampQueryPool.allocateQueriesForContext(uid);
        descriptor.timestampWrites = {
            querySet: timestampQueryPool.querySet,
            beginningOfPassWriteIndex: baseOffset,
            endOfPassWriteIndex: baseOffset + 1
        };
    }
    // node builder
    /**
	 * Returns a node builder for the given render object.
	 *
	 * @param {RenderObject} object - The render object.
	 * @param {Renderer} renderer - The renderer.
	 * @return {WGSLNodeBuilder} The node builder.
	 */ createNodeBuilder(object, renderer) {
        return new $d89c9137a3d237c2$var$WGSLNodeBuilder(object, renderer);
    }
    // program
    /**
	 * Creates a shader program from the given programmable stage.
	 *
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ createProgram(program) {
        const programGPU = this.get(program);
        programGPU.module = {
            module: this.device.createShaderModule({
                code: program.code,
                label: program.stage + (program.name !== '' ? `_${program.name}` : '')
            }),
            entryPoint: 'main'
        };
    }
    /**
	 * Destroys the shader program of the given programmable stage.
	 *
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ destroyProgram(program) {
        this.delete(program);
    }
    // pipelines
    /**
	 * Creates a render pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
	 */ createRenderPipeline(renderObject, promises) {
        this.pipelineUtils.createRenderPipeline(renderObject, promises);
    }
    /**
	 * Creates a compute pipeline for the given compute node.
	 *
	 * @param {ComputePipeline} computePipeline - The compute pipeline.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 */ createComputePipeline(computePipeline, bindings) {
        this.pipelineUtils.createComputePipeline(computePipeline, bindings);
    }
    /**
	 * Prepares the state for encoding render bundles.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ beginBundle(renderContext) {
        const renderContextData = this.get(renderContext);
        renderContextData._currentPass = renderContextData.currentPass;
        renderContextData._currentSets = renderContextData.currentSets;
        renderContextData.currentSets = {
            attributes: {},
            bindingGroups: [],
            pipeline: null,
            index: null
        };
        renderContextData.currentPass = this.pipelineUtils.createBundleEncoder(renderContext);
    }
    /**
	 * After processing render bundles this method finalizes related work.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {RenderBundle} bundle - The render bundle.
	 */ finishBundle(renderContext, bundle) {
        const renderContextData = this.get(renderContext);
        const bundleEncoder = renderContextData.currentPass;
        const bundleGPU = bundleEncoder.finish();
        this.get(bundle).bundleGPU = bundleGPU;
        // restore render pass state
        renderContextData.currentSets = renderContextData._currentSets;
        renderContextData.currentPass = renderContextData._currentPass;
    }
    /**
	 * Adds a render bundle to the render context data.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {RenderBundle} bundle - The render bundle to add.
	 */ addBundle(renderContext, bundle) {
        const renderContextData = this.get(renderContext);
        renderContextData.renderBundles.push(this.get(bundle).bundleGPU);
    }
    // bindings
    /**
	 * Creates bindings from the given bind group definition.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ createBindings(bindGroup, bindings, cacheIndex, version) {
        this.bindingUtils.createBindings(bindGroup, bindings, cacheIndex, version);
    }
    /**
	 * Updates the given bind group definition.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ updateBindings(bindGroup, bindings, cacheIndex, version) {
        this.bindingUtils.createBindings(bindGroup, bindings, cacheIndex, version);
    }
    /**
	 * Updates a buffer binding.
	 *
	 *  @param {Buffer} binding - The buffer binding to update.
	 */ updateBinding(binding) {
        this.bindingUtils.updateBinding(binding);
    }
    /**
	 * Delete data associated with the current bind group.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 */ deleteBindGroupData(bindGroup) {
        this.bindingUtils.deleteBindGroupData(bindGroup);
    }
    // attributes
    /**
	 * Creates the buffer of an indexed shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The indexed buffer attribute.
	 */ createIndexAttribute(attribute) {
        let usage = GPUBufferUsage.INDEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST;
        if (attribute.isStorageBufferAttribute || attribute.isStorageInstancedBufferAttribute) usage |= GPUBufferUsage.STORAGE;
        this.attributeUtils.createAttribute(attribute, usage);
    }
    /**
	 * Creates the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createAttribute(attribute) {
        this.attributeUtils.createAttribute(attribute, GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    /**
	 * Creates the GPU buffer of a storage attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createStorageAttribute(attribute) {
        this.attributeUtils.createAttribute(attribute, GPUBufferUsage.STORAGE | GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    /**
	 * Creates the GPU buffer of an indirect storage attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createIndirectStorageAttribute(attribute) {
        this.attributeUtils.createAttribute(attribute, GPUBufferUsage.STORAGE | GPUBufferUsage.INDIRECT | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    /**
	 * Updates the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute to update.
	 */ updateAttribute(attribute) {
        this.attributeUtils.updateAttribute(attribute);
    }
    /**
	 * Destroys the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute to destroy.
	 */ destroyAttribute(attribute) {
        this.attributeUtils.destroyAttribute(attribute);
    }
    // canvas
    /**
	 * Triggers an update of the default render pass descriptor.
	 */ updateSize() {
        this.delete(this.renderer.getCanvasTarget());
    }
    // utils public
    /**
	 * Returns the maximum anisotropy texture filtering value.
	 *
	 * @return {number} The maximum anisotropy texture filtering value.
	 */ getMaxAnisotropy() {
        return 16;
    }
    /**
	 * Checks if the given feature is supported by the backend.
	 *
	 * @param {string} name - The feature's name.
	 * @return {boolean} Whether the feature is supported or not.
	 */ hasFeature(name) {
        if ($d89c9137a3d237c2$var$GPUFeatureMap[name] !== undefined) name = $d89c9137a3d237c2$var$GPUFeatureMap[name];
        return this.device.features.has(name);
    }
    /**
	 * Copies data of the given source texture to the given destination texture.
	 *
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
	 * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
	 * @param {number} [srcLevel=0] - The mipmap level to copy.
	 * @param {number} [dstLevel=0] - The destination mip level to copy to.
	 */ copyTextureToTexture(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = 0) {
        let dstX = 0;
        let dstY = 0;
        let dstZ = 0;
        let srcX = 0;
        let srcY = 0;
        let srcZ = 0;
        let srcWidth = srcTexture.image.width;
        let srcHeight = srcTexture.image.height;
        let srcDepth = 1;
        if (srcRegion !== null) {
            if (srcRegion.isBox3 === true) {
                srcX = srcRegion.min.x;
                srcY = srcRegion.min.y;
                srcZ = srcRegion.min.z;
                srcWidth = srcRegion.max.x - srcRegion.min.x;
                srcHeight = srcRegion.max.y - srcRegion.min.y;
                srcDepth = srcRegion.max.z - srcRegion.min.z;
            } else {
                // Assume it's a Box2
                srcX = srcRegion.min.x;
                srcY = srcRegion.min.y;
                srcWidth = srcRegion.max.x - srcRegion.min.x;
                srcHeight = srcRegion.max.y - srcRegion.min.y;
                srcDepth = 1;
            }
        }
        if (dstPosition !== null) {
            dstX = dstPosition.x;
            dstY = dstPosition.y;
            dstZ = dstPosition.z || 0;
        }
        const encoder = this.device.createCommandEncoder({
            label: 'copyTextureToTexture_' + srcTexture.id + '_' + dstTexture.id
        });
        const sourceGPU = this.get(srcTexture).texture;
        const destinationGPU = this.get(dstTexture).texture;
        encoder.copyTextureToTexture({
            texture: sourceGPU,
            mipLevel: srcLevel,
            origin: {
                x: srcX,
                y: srcY,
                z: srcZ
            }
        }, {
            texture: destinationGPU,
            mipLevel: dstLevel,
            origin: {
                x: dstX,
                y: dstY,
                z: dstZ
            }
        }, [
            srcWidth,
            srcHeight,
            srcDepth
        ]);
        this.device.queue.submit([
            encoder.finish()
        ]);
        if (dstLevel === 0 && dstTexture.generateMipmaps) this.textureUtils.generateMipmaps(dstTexture);
    }
    /**
	 * Copies the current bound framebuffer to the given texture.
	 *
	 * @param {Texture} texture - The destination texture.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
	 */ copyFramebufferToTexture(texture, renderContext, rectangle) {
        const renderContextData = this.get(renderContext);
        let sourceGPU = null;
        if (renderContext.renderTarget) {
            if (texture.isDepthTexture) sourceGPU = this.get(renderContext.depthTexture).texture;
            else sourceGPU = this.get(renderContext.textures[0]).texture;
        } else if (texture.isDepthTexture) sourceGPU = this.textureUtils.getDepthBuffer(renderContext.depth, renderContext.stencil);
        else sourceGPU = this.context.getCurrentTexture();
        const destinationGPU = this.get(texture).texture;
        if (sourceGPU.format !== destinationGPU.format) {
            (0, $329ek.error)('WebGPUBackend: copyFramebufferToTexture: Source and destination formats do not match.', sourceGPU.format, destinationGPU.format);
            return;
        }
        let encoder;
        if (renderContextData.currentPass) {
            renderContextData.currentPass.end();
            encoder = renderContextData.encoder;
        } else encoder = this.device.createCommandEncoder({
            label: 'copyFramebufferToTexture_' + texture.id
        });
        encoder.copyTextureToTexture({
            texture: sourceGPU,
            origin: [
                rectangle.x,
                rectangle.y,
                0
            ]
        }, {
            texture: destinationGPU
        }, [
            rectangle.z,
            rectangle.w
        ]);
        // mipmaps must be genereated with the same encoder otherwise the copied texture data
        // might be out-of-sync, see #31768
        if (texture.generateMipmaps) this.textureUtils.generateMipmaps(texture, encoder);
        if (renderContextData.currentPass) {
            const { descriptor: descriptor } = renderContextData;
            for(let i = 0; i < descriptor.colorAttachments.length; i++)descriptor.colorAttachments[i].loadOp = $d89c9137a3d237c2$var$GPULoadOp.Load;
            if (renderContext.depth) descriptor.depthStencilAttachment.depthLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Load;
            if (renderContext.stencil) descriptor.depthStencilAttachment.stencilLoadOp = $d89c9137a3d237c2$var$GPULoadOp.Load;
            renderContextData.currentPass = encoder.beginRenderPass(descriptor);
            renderContextData.currentSets = {
                attributes: {},
                bindingGroups: [],
                pipeline: null,
                index: null
            };
            if (renderContext.viewport) this.updateViewport(renderContext);
            if (renderContext.scissor) this.updateScissor(renderContext);
        } else this.device.queue.submit([
            encoder.finish()
        ]);
    }
    dispose() {
        this.bindingUtils.dispose();
        this.textureUtils.dispose();
        if (this.occludedResolveCache) {
            for (const buffer of this.occludedResolveCache.values())buffer.destroy();
            this.occludedResolveCache.clear();
        }
        if (this.timestampQueryPool) {
            for (const queryPool of Object.values(this.timestampQueryPool))if (queryPool !== null) queryPool.dispose();
        }
        if (this.parameters.device === undefined && this.device !== null) this.device.destroy();
    }
}
/**
 * A IES version of {@link SpotLight}. Can only be used with {@link WebGPURenderer}.
 *
 * @augments SpotLight
 */ class $d89c9137a3d237c2$export$667dbe87cac0f9fb extends (0, $329ek.SpotLight) {
    /**
	 * Constructs a new IES spot light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance, angle, penumbra, decay){
        super(color, intensity, distance, angle, penumbra, decay);
        /**
		 * TODO
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iesMap = null;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.iesMap = source.iesMap;
        return this;
    }
}
/**
 * A projector light version of {@link SpotLight}. Can only be used with {@link WebGPURenderer}.
 *
 * @augments SpotLight
 */ class $d89c9137a3d237c2$export$89b0247b4dafcd44 extends (0, $329ek.SpotLight) {
    /**
	 * Constructs a new projector light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance, angle, penumbra, decay){
        super(color, intensity, distance, angle, penumbra, decay);
        /**
		 * Aspect ratio of the light. Set to `null` to use the texture aspect ratio.
		 *
		 * @type {?number}
		 * @default null
		 */ this.aspect = null;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.aspect = source.aspect;
        return this;
    }
}
/**
 * This version of a node library represents the standard version
 * used in {@link WebGPURenderer}. It maps lights, tone mapping
 * techniques and materials to node-based implementations.
 *
 * @private
 * @augments NodeLibrary
 */ class $d89c9137a3d237c2$var$StandardNodeLibrary extends $d89c9137a3d237c2$var$NodeLibrary {
    /**
	 * Constructs a new standard node library.
	 */ constructor(){
        super();
        this.addMaterial($d89c9137a3d237c2$export$eb6f457467ca986e, 'MeshPhongMaterial');
        this.addMaterial($d89c9137a3d237c2$export$92edd3f060e85562, 'MeshStandardMaterial');
        this.addMaterial($d89c9137a3d237c2$export$f336706882be0d39, 'MeshPhysicalMaterial');
        this.addMaterial($d89c9137a3d237c2$export$2dd2c8d143c7c392, 'MeshToonMaterial');
        this.addMaterial($d89c9137a3d237c2$export$14d4a26075247662, 'MeshBasicMaterial');
        this.addMaterial($d89c9137a3d237c2$export$ca28182707938248, 'MeshLambertMaterial');
        this.addMaterial($d89c9137a3d237c2$export$57e770545986d2b1, 'MeshNormalMaterial');
        this.addMaterial($d89c9137a3d237c2$export$f7d65f3d82d7b0b0, 'MeshMatcapMaterial');
        this.addMaterial($d89c9137a3d237c2$export$511219d03f927a3f, 'LineBasicMaterial');
        this.addMaterial($d89c9137a3d237c2$export$19c85750bbe979a0, 'LineDashedMaterial');
        this.addMaterial($d89c9137a3d237c2$export$986cd66fa4ca801b, 'PointsMaterial');
        this.addMaterial($d89c9137a3d237c2$export$80f4e36249294380, 'SpriteMaterial');
        this.addMaterial($d89c9137a3d237c2$export$6ba7483788b75e55, 'ShadowMaterial');
        this.addLight($d89c9137a3d237c2$export$8613ba691750588b, (0, $329ek.PointLight));
        this.addLight($d89c9137a3d237c2$export$6e67a8efcfed4d14, (0, $329ek.DirectionalLight));
        this.addLight($d89c9137a3d237c2$export$1029ea47a4dd9399, (0, $329ek.RectAreaLight));
        this.addLight($d89c9137a3d237c2$export$df1aa5fd66541854, (0, $329ek.SpotLight));
        this.addLight($d89c9137a3d237c2$export$ade3bbc96c5c4bf1, (0, $329ek.AmbientLight));
        this.addLight($d89c9137a3d237c2$export$8c237e4e9b54f548, (0, $329ek.HemisphereLight));
        this.addLight($d89c9137a3d237c2$export$c2c4ca9136f2b869, (0, $329ek.LightProbe));
        this.addLight($d89c9137a3d237c2$export$5d7cdca61c24be58, $d89c9137a3d237c2$export$667dbe87cac0f9fb);
        this.addLight($d89c9137a3d237c2$export$e6df2aceb76fe9a0, $d89c9137a3d237c2$export$89b0247b4dafcd44);
        this.addToneMapping($d89c9137a3d237c2$var$linearToneMapping, (0, $329ek.LinearToneMapping));
        this.addToneMapping($d89c9137a3d237c2$var$reinhardToneMapping, (0, $329ek.ReinhardToneMapping));
        this.addToneMapping($d89c9137a3d237c2$var$cineonToneMapping, (0, $329ek.CineonToneMapping));
        this.addToneMapping($d89c9137a3d237c2$var$acesFilmicToneMapping, (0, $329ek.ACESFilmicToneMapping));
        this.addToneMapping($d89c9137a3d237c2$var$agxToneMapping, (0, $329ek.AgXToneMapping));
        this.addToneMapping($d89c9137a3d237c2$var$neutralToneMapping, (0, $329ek.NeutralToneMapping));
    }
}
/*
const debugHandler = {

	get: function ( target, name ) {

		// Add |update
		if ( /^(create|destroy)/.test( name ) ) log( 'WebGPUBackend.' + name );

		return target[ name ];

	}

};
*/ /**
 * This renderer is the new alternative of `WebGLRenderer`. `WebGPURenderer` has the ability
 * to target different backends. By default, the renderer tries to use a WebGPU backend if the
 * browser supports WebGPU. If not, `WebGPURenderer` falls backs to a WebGL 2 backend.
 *
 * @augments Renderer
 */ class $d89c9137a3d237c2$export$19fd8015bd4822d4 extends $d89c9137a3d237c2$var$Renderer {
    /**
	 * WebGPURenderer options.
	 *
	 * @typedef {Object} WebGPURenderer~Options
	 * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
	 * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
	 * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
	 * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
	 * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
	 * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0 to overwrite the default.
	 * @property {boolean} [forceWebGL=false] - If set to `true`, the renderer uses a WebGL 2 backend no matter if WebGPU is supported or not.
	 * @property {boolean} [multiview=false] - If set to `true`, the renderer will use multiview during WebXR rendering if supported.
	 * @property {number} [outputType=undefined] - Texture type for output to canvas. By default, device's preferred format is used; other formats may incur overhead.
	 * @property {number} [outputBufferType=HalfFloatType] - Defines the type of output buffers. The default `HalfFloatType` is recommend for best
	 * quality. To save memory and bandwidth, `UnsignedByteType` might be used. This will reduce rendering quality though.
	 */ /**
	 * Constructs a new WebGPU renderer.
	 *
	 * @param {WebGPURenderer~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        let BackendClass;
        if (parameters.forceWebGL) BackendClass = $d89c9137a3d237c2$var$WebGLBackend;
        else {
            BackendClass = $d89c9137a3d237c2$var$WebGPUBackend;
            parameters.getFallback = ()=>{
                (0, $329ek.warn)('WebGPURenderer: WebGPU is not available, running under WebGL2 backend.');
                return new $d89c9137a3d237c2$var$WebGLBackend(parameters);
            };
        }
        const backend = new BackendClass(parameters);
        //super( new Proxy( backend, debugHandler ) );
        super(backend, parameters);
        /**
		 * The generic default value is overwritten with the
		 * standard node library for type mapping.
		 *
		 * @type {StandardNodeLibrary}
		 */ this.library = new $d89c9137a3d237c2$var$StandardNodeLibrary();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGPURenderer = true;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
}
/**
 * A specialized group which enables applications access to the
 * Render Bundle API of WebGPU. The group with all its descendant nodes
 * are considered as one render bundle and processed as such by
 * the renderer.
 *
 * This module is only fully supported by `WebGPURenderer` with a WebGPU backend.
 * With a WebGL backend, the group can technically be rendered but without
 * any performance improvements.
 *
 * @augments Group
 */ class $d89c9137a3d237c2$export$e04febd15a99bd94 extends (0, $329ek.Group) {
    /**
	 * Constructs a new bundle group.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBundleGroup = true;
        /**
		 * This property is only relevant for detecting types
		 * during serialization/deserialization. It should always
		 * match the class name.
		 *
		 * @type {string}
		 * @readonly
		 * @default 'BundleGroup'
		 */ this.type = 'BundleGroup';
        /**
		 * Whether the bundle is static or not. When set to `true`, the structure
		 * is assumed to be static and does not change. E.g. no new objects are
		 * added to the group
		 *
		 * If a change is required, an update can still be forced by setting the
		 * `needsUpdate` flag to `true`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.static = true;
        /**
		 * The bundle group's version.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
    }
    /**
	 * Set this property to `true` when the bundle group has changed.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
/**
 * This module is responsible to manage the post processing setups in apps.
 * You usually create a single instance of this class and use it to define
 * the output of your post processing effect chain.
 * ```js
 * const postProcessing = new PostProcessing( renderer );
 *
 * const scenePass = pass( scene, camera );
 *
 * postProcessing.outputNode = scenePass;
 * ```
 *
 * Note: This module can only be used with `WebGPURenderer`.
 */ class $d89c9137a3d237c2$export$6eafee11db0bd883 {
    /**
	 * Constructs a new post processing management module.
	 *
	 * @param {Renderer} renderer - A reference to the renderer.
	 * @param {Node<vec4>} outputNode - An optional output node.
	 */ constructor(renderer, outputNode = $d89c9137a3d237c2$var$vec4(0, 0, 1, 1)){
        /**
		 * A reference to the renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * A node which defines the final output of the post
		 * processing. This is usually the last node in a chain
		 * of effect nodes.
		 *
		 * @type {Node<vec4>}
		 */ this.outputNode = outputNode;
        /**
		 * Whether the default output tone mapping and color
		 * space transformation should be enabled or not.
		 *
		 * It is enabled by default by it must be disabled when
		 * effects must be executed after tone mapping and color
		 * space conversion. A typical example is FXAA which
		 * requires sRGB input.
		 *
		 * When set to `false`, the app must control the output
		 * transformation with `RenderOutputNode`.
		 *
		 * ```js
		 * const outputPass = renderOutput( scenePass );
		 * ```
		 *
		 * @type {boolean}
		 */ this.outputColorTransform = true;
        /**
		 * Must be set to `true` when the output node changes.
		 *
		 * @type {Node<vec4>}
		 */ this.needsUpdate = true;
        const material = new $d89c9137a3d237c2$export$caaf3b30a544c946();
        material.name = 'PostProcessing';
        /**
		 * The full screen quad that is used to render
		 * the effects.
		 *
		 * @private
		 * @type {QuadMesh}
		 */ this._quadMesh = new $d89c9137a3d237c2$export$266ce19fe399ee9a(material);
        this._quadMesh.name = 'Post-Processing';
        /**
		 * The context of the post processing stack.
		 *
		 * @private
		 * @type {?Object}
		 * @default null
		 */ this._context = null;
    }
    /**
	 * When `PostProcessing` is used to apply post processing effects,
	 * the application must use this version of `render()` inside
	 * its animation loop (not the one from the renderer).
	 */ render() {
        const renderer = this.renderer;
        this._update();
        if (this._context.onBeforePostProcessing !== null) this._context.onBeforePostProcessing();
        const toneMapping = renderer.toneMapping;
        const outputColorSpace = renderer.outputColorSpace;
        renderer.toneMapping = (0, $329ek.NoToneMapping);
        renderer.outputColorSpace = (0, $329ek.ColorManagement).workingColorSpace;
        //
        const currentXR = renderer.xr.enabled;
        renderer.xr.enabled = false;
        this._quadMesh.render(renderer);
        renderer.xr.enabled = currentXR;
        //
        renderer.toneMapping = toneMapping;
        renderer.outputColorSpace = outputColorSpace;
        if (this._context.onAfterPostProcessing !== null) this._context.onAfterPostProcessing();
    }
    /**
	 * Returns the current context of the post processing stack.
	 *
	 * @readonly
	 * @type {?Object}
	 */ get context() {
        return this._context;
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this._quadMesh.material.dispose();
    }
    /**
	 * Updates the state of the module.
	 *
	 * @private
	 */ _update() {
        if (this.needsUpdate === true) {
            const renderer = this.renderer;
            const toneMapping = renderer.toneMapping;
            const outputColorSpace = renderer.outputColorSpace;
            const context = {
                postProcessing: this,
                onBeforePostProcessing: null,
                onAfterPostProcessing: null
            };
            let outputNode = this.outputNode;
            if (this.outputColorTransform === true) {
                outputNode = outputNode.context(context);
                outputNode = $d89c9137a3d237c2$var$renderOutput(outputNode, toneMapping, outputColorSpace);
            } else {
                context.toneMapping = toneMapping;
                context.outputColorSpace = outputColorSpace;
                outputNode = outputNode.context(context);
            }
            this._context = context;
            this._quadMesh.material.fragmentNode = outputNode;
            this._quadMesh.material.needsUpdate = true;
            this.needsUpdate = false;
        }
    }
    /**
	 * When `PostProcessing` is used to apply post processing effects,
	 * the application must use this version of `renderAsync()` inside
	 * its animation loop (not the one from the renderer).
	 *
	 * @async
	 * @deprecated
	 * @return {Promise} A Promise that resolves when the render has been finished.
	 */ async renderAsync() {
        (0, $329ek.warnOnce)('PostProcessing: "renderAsync()" has been deprecated. Use "render()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await this.renderer.init();
        this.render();
    }
}
/**
 * This special type of texture is intended for compute shaders.
 * It can be used to compute the data of a texture with a compute shader.
 *
 * Note: This type of texture can only be used with `WebGPURenderer`
 * and a WebGPU backend.
 *
 * @augments Texture
 */ class $d89c9137a3d237c2$export$31c2478de2390334 extends (0, $329ek.Texture) {
    /**
	 * Constructs a new storage texture.
	 *
	 * @param {number} [width=1] - The storage texture's width.
	 * @param {number} [height=1] - The storage texture's height.
	 */ constructor(width = 1, height = 1){
        super();
        /**
		 * The image object which just represents the texture's dimension.
		 *
		 * @type {{width: number, height: number}}
		 */ this.image = {
            width: width,
            height: height
        };
        /**
		 * The default `magFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.magFilter = (0, $329ek.LinearFilter);
        /**
		 * The default `minFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.minFilter = (0, $329ek.LinearFilter);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageTexture = true;
        /**
		 * When `true`, mipmaps will be auto-generated after compute writes.
		 * When `false`, mipmaps must be written manually via compute shaders.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.mipmapsAutoUpdate = true;
    }
    /**
	 * Sets the size of the storage texture.
	 *
	 * @param {number} width - The new width of the storage texture.
	 * @param {number} height - The new height of the storage texture.
	 */ setSize(width, height) {
        if (this.image.width !== width || this.image.height !== height) {
            this.image.width = width;
            this.image.height = height;
            this.dispose();
        }
    }
}
/**
 * This special type of texture is intended for compute shaders.
 * It can be used to compute the data of a texture with a compute shader.
 *
 * Note: This type of texture can only be used with `WebGPURenderer`
 * and a WebGPU backend.
 *
 * @augments Texture
 */ class $d89c9137a3d237c2$export$8372ed547e6486b6 extends (0, $329ek.Texture) {
    /**
	 * Constructs a new storage texture.
	 *
	 * @param {number} [width=1] - The storage texture's width.
	 * @param {number} [height=1] - The storage texture's height.
	 * @param {number} [depth=1] - The storage texture's depth.
	 */ constructor(width = 1, height = 1, depth = 1){
        super();
        //inherited from texture. Must be false for 3DTexture
        this.isArrayTexture = false;
        /**
		 * The image object which just represents the texture's dimension.
		 *
		 * @type {{width: number, height: number, depth: number}}
		 */ this.image = {
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * The default `magFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.magFilter = (0, $329ek.LinearFilter);
        /**
		 * The default `minFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.minFilter = (0, $329ek.LinearFilter);
        /**
		 * This defines how the texture is wrapped in the depth direction and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {number}
		 */ this.wrapR = (0, $329ek.ClampToEdgeWrapping);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageTexture = true;
        /**
		 * Indicates whether this texture is a 3D texture.
		 *
		 * @type {boolean}
		 *
		 */ this.is3DTexture = true;
    }
    /**
	 * Sets the size of the storage 3d texture.
	 *
	 * @param {number} width - The new width of the storage texture.
	 * @param {number} height - The new height of the storage texture.
	 * @param {number} depth - The new depth of the storage texture.
	 */ setSize(width, height, depth) {
        if (this.image.width !== width || this.image.height !== height || this.image.depth !== depth) {
            this.image.width = width;
            this.image.height = height;
            this.image.depth = depth;
            this.dispose();
        }
    }
}
/**
 * This special type of texture is intended for compute shaders.
 * It can be used to compute the data of a texture with a compute shader.
 *
 * Note: This type of texture can only be used with `WebGPURenderer`
 * and a WebGPU backend.
 *
 * @augments Texture
 */ class $d89c9137a3d237c2$export$3c647e796d9064bc extends (0, $329ek.Texture) {
    /**
	 * Constructs a new storage texture.
	 *
	 * @param {number} [width=1] - The storage texture's width.
	 * @param {number} [height=1] - The storage texture's height.
	 * @param {number} [depth=1] - The storage texture's depth.
	 */ constructor(width = 1, height = 1, depth = 1){
        super();
        //inherited from texture
        this.isArrayTexture = true;
        /**
		 * The image object which just represents the texture's dimension.
		 *
		 * @type {{width: number, height: number, depth: number}}
		 */ this.image = {
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * The default `magFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.magFilter = (0, $329ek.LinearFilter);
        /**
		 * The default `minFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.minFilter = (0, $329ek.LinearFilter);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageTexture = true;
    }
    /**
	 * Sets the size of the storage array texture.
	 *
	 * @param {number} width - The new width of the storage texture.
	 * @param {number} height - The new height of the storage texture.
	 * @param {number} depth - The new depth of the storage texture.
	 */ setSize(width, height, depth) {
        if (this.image.width !== width || this.image.height !== height || this.image.depth !== depth) {
            this.image.width = width;
            this.image.height = height;
            this.image.depth = depth;
            this.dispose();
        }
    }
}
/**
 * This special type of buffer attribute is intended for compute shaders.
 * It can be used to encode draw parameters for indirect draw calls.
 *
 * Note: This type of buffer attribute can only be used with `WebGPURenderer`
 * and a WebGPU backend.
 *
 * @augments StorageBufferAttribute
 */ class $d89c9137a3d237c2$export$5f124751e00a3c7e extends $d89c9137a3d237c2$export$5eb1a076d3725e22 {
    /**
	 * Constructs a new storage buffer attribute.
	 *
	 * @param {number|Uint32Array} count - The item count. It is also valid to pass a `Uint32Array` as an argument.
	 * The subsequent parameter is then obsolete.
	 * @param {number} itemSize - The item size.
	 */ constructor(count, itemSize){
        super(count, itemSize, Uint32Array);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isIndirectStorageBufferAttribute = true;
    }
}
/**
 * A loader for loading node objects in the three.js JSON Object/Scene format.
 *
 * @augments Loader
 */ class $d89c9137a3d237c2$export$f768aec11625a454 extends (0, $329ek.Loader) {
    /**
	 * Constructs a new node loader.
	 *
	 * @param {LoadingManager} [manager] - A reference to a loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * Represents a dictionary of textures.
		 *
		 * @type {Object<string,Texture>}
		 */ this.textures = {};
        /**
		 * Represents a dictionary of node types.
		 *
		 * @type {Object<string,Node.constructor>}
		 */ this.nodes = {};
    }
    /**
	 * Loads the node definitions from the given URL.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {Function} onLoad - Will be called when load completes.
	 * @param {Function} onProgress - Will be called while load progresses.
	 * @param {Function} onError - Will be called when errors are thrown during the loading process.
	 */ load(url, onLoad, onProgress, onError) {
        const loader = new (0, $329ek.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, (text)=>{
            try {
                onLoad(this.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else (0, $329ek.error)(e);
                this.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parse the node dependencies for the loaded node.
	 *
	 * @param {Array<Object>} [json] - The JSON definition
	 * @return {Object<string,Node>} A dictionary with node dependencies.
	 */ parseNodes(json) {
        const nodes = {};
        if (json !== undefined) {
            for (const nodeJSON of json){
                const { uuid: uuid, type: type } = nodeJSON;
                nodes[uuid] = this.createNodeFromType(type);
                nodes[uuid].uuid = uuid;
            }
            const meta = {
                nodes: nodes,
                textures: this.textures
            };
            for (const nodeJSON of json){
                nodeJSON.meta = meta;
                const node = nodes[nodeJSON.uuid];
                node.deserialize(nodeJSON);
                delete nodeJSON.meta;
            }
        }
        return nodes;
    }
    /**
	 * Parses the node from the given JSON.
	 *
	 * @param {Object} json - The JSON definition
	 * @param {string} json.type - The node type.
	 * @param {string} json.uuid - The node UUID.
	 * @param {Array<Object>} [json.nodes] - The node dependencies.
	 * @param {Object} [json.meta] - The meta data.
	 * @return {Node} The parsed node.
	 */ parse(json) {
        const node = this.createNodeFromType(json.type);
        node.uuid = json.uuid;
        const nodes = this.parseNodes(json.nodes);
        const meta = {
            nodes: nodes,
            textures: this.textures
        };
        json.meta = meta;
        node.deserialize(json);
        delete json.meta;
        return node;
    }
    /**
	 * Defines the dictionary of textures.
	 *
	 * @param {Object<string,Texture>} value - The texture library defines as `<uuid,texture>`.
	 * @return {NodeLoader} A reference to this loader.
	 */ setTextures(value) {
        this.textures = value;
        return this;
    }
    /**
	 * Defines the dictionary of node types.
	 *
	 * @param {Object<string,Node.constructor>} value - The node library defined as `<classname,class>`.
	 * @return {NodeLoader} A reference to this loader.
	 */ setNodes(value) {
        this.nodes = value;
        return this;
    }
    /**
	 * Creates a node object from the given type.
	 *
	 * @param {string} type - The node type.
	 * @return {Node} The created node instance.
	 */ createNodeFromType(type) {
        if (this.nodes[type] === undefined) {
            (0, $329ek.error)('NodeLoader: Node type not found:', type);
            return $d89c9137a3d237c2$var$float();
        }
        return new this.nodes[type]();
    }
}
/**
 * A special type of material loader for loading node materials.
 *
 * @augments MaterialLoader
 */ class $d89c9137a3d237c2$export$2cf76db1a8c42c86 extends (0, $329ek.MaterialLoader) {
    /**
	 * Constructs a new node material loader.
	 *
	 * @param {LoadingManager} [manager] - A reference to a loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * Represents a dictionary of node types.
		 *
		 * @type {Object<string,Node.constructor>}
		 */ this.nodes = {};
        /**
		 * Represents a dictionary of node material types.
		 *
		 * @type {Object<string,NodeMaterial.constructor>}
		 */ this.nodeMaterials = {};
    }
    /**
	 * Parses the node material from the given JSON.
	 *
	 * @param {Object} json - The JSON definition
	 * @return {NodeMaterial}. The parsed material.
	 */ parse(json) {
        const material = super.parse(json);
        const nodes = this.nodes;
        const inputNodes = json.inputNodes;
        for(const property in inputNodes){
            const uuid = inputNodes[property];
            material[property] = nodes[uuid];
        }
        return material;
    }
    /**
	 * Defines the dictionary of node types.
	 *
	 * @param {Object<string,Node.constructor>} value - The node library defined as `<classname,class>`.
	 * @return {NodeLoader} A reference to this loader.
	 */ setNodes(value) {
        this.nodes = value;
        return this;
    }
    /**
	 * Defines the dictionary of node material types.
	 *
	 * @param {Object<string,NodeMaterial.constructor>} value - The node material library defined as `<classname,class>`.
	 * @return {NodeLoader} A reference to this loader.
	 */ setNodeMaterials(value) {
        this.nodeMaterials = value;
        return this;
    }
    /**
	 * Creates a node material from the given type.
	 *
	 * @param {string} type - The node material type.
	 * @return {Node} The created node material instance.
	 */ createMaterialFromType(type) {
        const materialClass = this.nodeMaterials[type];
        if (materialClass !== undefined) return new materialClass();
        return super.createMaterialFromType(type);
    }
}
/**
 * A special type of object loader for loading 3D objects using
 * node materials.
 *
 * @augments ObjectLoader
 */ class $d89c9137a3d237c2$export$e6dfc9c3655ca55d extends (0, $329ek.ObjectLoader) {
    /**
	 * Constructs a new node object loader.
	 *
	 * @param {LoadingManager} [manager] - A reference to a loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * Represents a dictionary of node types.
		 *
		 * @type {Object<string,Node.constructor>}
		 */ this.nodes = {};
        /**
		 * Represents a dictionary of node material types.
		 *
		 * @type {Object<string,NodeMaterial.constructor>}
		 */ this.nodeMaterials = {};
        /**
		 * A reference to hold the `nodes` JSON property.
		 *
		 * @private
		 * @type {?Object[]}
		 */ this._nodesJSON = null;
    }
    /**
	 * Defines the dictionary of node types.
	 *
	 * @param {Object<string,Node.constructor>} value - The node library defined as `<classname,class>`.
	 * @return {NodeObjectLoader} A reference to this loader.
	 */ setNodes(value) {
        this.nodes = value;
        return this;
    }
    /**
	 * Defines the dictionary of node material types.
	 *
	 * @param {Object<string,NodeMaterial.constructor>} value - The node material library defined as `<classname,class>`.
	 * @return {NodeObjectLoader} A reference to this loader.
	 */ setNodeMaterials(value) {
        this.nodeMaterials = value;
        return this;
    }
    /**
	 * Parses the node objects from the given JSON.
	 *
	 * @param {Object} json - The JSON definition
	 * @param {Function} onLoad - The onLoad callback function.
	 * @return {Object3D}. The parsed 3D object.
	 */ parse(json, onLoad) {
        this._nodesJSON = json.nodes;
        const data = super.parse(json, onLoad);
        this._nodesJSON = null; // dispose
        return data;
    }
    /**
	 * Parses the node objects from the given JSON and textures.
	 *
	 * @param {Object[]} json - The JSON definition
	 * @param {Object<string,Texture>} textures - The texture library.
	 * @return {Object<string,Node>}. The parsed nodes.
	 */ parseNodes(json, textures) {
        if (json !== undefined) {
            const loader = new $d89c9137a3d237c2$export$f768aec11625a454();
            loader.setNodes(this.nodes);
            loader.setTextures(textures);
            return loader.parseNodes(json);
        }
        return {};
    }
    /**
	 * Parses the node objects from the given JSON and textures.
	 *
	 * @param {Object} json - The JSON definition
	 * @param {Object<string,Texture>} textures - The texture library.
	 * @return {Object<string,NodeMaterial>}. The parsed materials.
	 */ parseMaterials(json, textures) {
        const materials = {};
        if (json !== undefined) {
            const nodes = this.parseNodes(this._nodesJSON, textures);
            const loader = new $d89c9137a3d237c2$export$2cf76db1a8c42c86();
            loader.setTextures(textures);
            loader.setNodes(nodes);
            loader.setNodeMaterials(this.nodeMaterials);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                materials[data.uuid] = loader.parse(data);
            }
        }
        return materials;
    }
}
/**
 * In earlier three.js versions, clipping was defined globally
 * on the renderer or on material level. This special version of
 * `THREE.Group` allows to encode the clipping state into the scene
 * graph. Meaning if you create an instance of this group, all
 * descendant 3D objects will be affected by the respective clipping
 * planes.
 *
 * Note: `ClippingGroup` can only be used with `WebGPURenderer`.
 *
 * @augments Group
 */ class $d89c9137a3d237c2$export$f4cfbc80e09ad28c extends (0, $329ek.Group) {
    /**
	 * Constructs a new clipping group.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isClippingGroup = true;
        /**
		 * An array with clipping planes.
		 *
		 * @type {Array<Plane>}
		 */ this.clippingPlanes = [];
        /**
		 * Whether clipping should be enabled or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * Whether the intersection of the clipping planes is used to clip objects, rather than their union.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipIntersection = false;
        /**
		 * Whether shadows should be clipped or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipShadows = false;
    }
}

});

parcelRegister("jKwRh", function(module, exports) {

$parcel$export(module.exports, "CharacterState", () => $e60bcd291a6e9aed$export$f2e6b371e93925c7);
$parcel$export(module.exports, "CreationTool", () => $e60bcd291a6e9aed$export$4a5f7b09ca822d8c);
$parcel$export(module.exports, "CC3Loader", () => $e60bcd291a6e9aed$export$ad2b5f000abbc959);
$parcel$export(module.exports, "AvaturnLoader", () => $e60bcd291a6e9aed$export$323f6f3f401dfadc);
$parcel$export(module.exports, "AvatarSDKLoader", () => $e60bcd291a6e9aed$export$dbb172dd5b84295d);
$parcel$export(module.exports, "Character", () => $e60bcd291a6e9aed$export$cb68cc2163cd3f1);

var $329ek = parcelRequire("329ek");parcelRequire("iB18M");
var $329ek = parcelRequire("329ek");

var $1W96c = parcelRequire("1W96c");

var $ltPx4 = parcelRequire("ltPx4");

var $eraQQ = parcelRequire("eraQQ");

var $5RusT = parcelRequire("5RusT");

var $bQavx = parcelRequire("bQavx");

var $7UhSE = parcelRequire("7UhSE");
var $e60bcd291a6e9aed$var$il = Object.defineProperty;
var $e60bcd291a6e9aed$var$iI = (G)=>{
    throw TypeError(G);
};
var $e60bcd291a6e9aed$var$dl = (G, I, g)=>I in G ? $e60bcd291a6e9aed$var$il(G, I, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: g
    }) : G[I] = g;
var $e60bcd291a6e9aed$var$c = (G, I, g)=>$e60bcd291a6e9aed$var$dl(G, typeof I != "symbol" ? I + "" : I, g), $e60bcd291a6e9aed$var$cl = (G, I, g)=>I.has(G) || $e60bcd291a6e9aed$var$iI("Cannot " + g);
var $e60bcd291a6e9aed$var$kg = (G, I, g)=>I.has(G) ? $e60bcd291a6e9aed$var$iI("Cannot add the same private member more than once") : I instanceof WeakSet ? I.add(G) : I.set(G, g);
var $e60bcd291a6e9aed$var$Q = (G, I, g)=>($e60bcd291a6e9aed$var$cl(G, I, "access private method"), g);
var $e60bcd291a6e9aed$var$$ = /* @__PURE__ */ ((G)=>(G.none = "none", G.mixamo = "mixamo", G.actorcore = "actorcore", G.cc4 = "cc4", G))($e60bcd291a6e9aed$var$$ || {}), $e60bcd291a6e9aed$var$ag = /* @__PURE__ */ ((G)=>(G.frequently = "frequently", G.often = "often", G.sometimes = "sometimes", G.occasionaly = "occasionaly", G.rarely = "rarely", G))($e60bcd291a6e9aed$var$ag || {}), $e60bcd291a6e9aed$export$f2e6b371e93925c7 = /* @__PURE__ */ ((G)=>(G[G.idle = 1] = "idle", G[G.waiting = 2] = "waiting", G[G.listening = 3] = "listening", G[G.speaking = 4] = "speaking", G))($e60bcd291a6e9aed$export$f2e6b371e93925c7 || {}), $e60bcd291a6e9aed$export$4a5f7b09ca822d8c = /* @__PURE__ */ ((G)=>(G[G.cc3 = 1] = "cc3", G[G.avatarsdk = 2] = "avatarsdk", G[G.avaturn = 3] = "avaturn", G))($e60bcd291a6e9aed$export$4a5f7b09ca822d8c || {});
const $e60bcd291a6e9aed$var$YI = {
    attributes: [
        "id",
        "characterid",
        "composition"
    ],
    contents: [
        "any"
    ]
}, $e60bcd291a6e9aed$var$KI = {
    attributes: null,
    contents: [
        "any"
    ]
}, $e60bcd291a6e9aed$var$RI = {
    attributes: null,
    contents: [
        "synchronize",
        "before",
        "after"
    ]
}, $e60bcd291a6e9aed$var$wI = {
    attributes: null,
    contents: [
        "sync"
    ]
}, $e60bcd291a6e9aed$var$LI = {
    attributes: [
        "ref"
    ],
    contents: [
        "sync"
    ]
}, $e60bcd291a6e9aed$var$FI = {
    attributes: [
        "ref"
    ],
    contents: [
        "sync"
    ]
}, $e60bcd291a6e9aed$var$JI = {
    attributes: [
        "ref"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$NI = {
    attributes: [
        "id",
        "duration",
        "start",
        "end"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$vI = {
    attributes: [
        "id",
        "au",
        "side",
        "amount",
        "start",
        "attackpeak",
        "relax",
        "end"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$rI = {
    attributes: [
        "au",
        "side",
        "amount"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$kI = {
    attributes: [
        "id",
        "amount",
        "overshoot",
        "start",
        "attackpeak",
        "relax",
        "end"
    ],
    contents: [
        "lexeme",
        "facs"
    ]
}, $e60bcd291a6e9aed$var$zI = {
    attributes: [
        "id",
        "amount",
        "start",
        "end"
    ],
    contents: [
        "lexeme",
        "facs"
    ]
}, $e60bcd291a6e9aed$var$MI = {
    attributes: [
        "id",
        "lexeme",
        "amount",
        "start",
        "attackpeak",
        "relax",
        "end"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$QI = {
    attributes: [
        "id",
        "target",
        "influence",
        "offsetangle",
        "offsetdirection",
        "start",
        "ready",
        "relax",
        "end"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$UI = {
    attributes: [
        "id",
        "target",
        "influence",
        "offsetangle",
        "offsetdirection",
        "start",
        "end"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$DI = {
    attributes: [
        "id",
        "lexeme",
        "mode",
        "start",
        "ready",
        "strokestart",
        "stroke",
        "strokeend",
        "relax",
        "end"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$TI = {
    attributes: [
        "id",
        "target",
        "mode",
        "start",
        "ready",
        "strokestart",
        "stroke",
        "strokeend",
        "relax",
        "end"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$xI = {
    attributes: [
        "id",
        "lexeme",
        "repetition",
        "amount",
        "start",
        "ready",
        "strokestart",
        "stroke",
        "strokeend",
        "relax",
        "end"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$EI = {
    attributes: [
        "id",
        "target",
        "start",
        "end"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$jI = {
    attributes: [
        "id",
        "target",
        "manner",
        "start",
        "end"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$fI = {
    attributes: [
        "id",
        "start",
        "ready",
        "relax",
        "end"
    ],
    contents: [
        "stance",
        "pose"
    ]
}, $e60bcd291a6e9aed$var$PI = {
    attributes: [
        "id",
        "start",
        "end"
    ],
    contents: [
        "stance",
        "pose"
    ]
}, $e60bcd291a6e9aed$var$qI = {
    attributes: [
        "type"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$OI = {
    attributes: [
        "part",
        "lexeme"
    ],
    contents: null
}, $e60bcd291a6e9aed$var$_I = {
    attributes: [
        "id",
        "start",
        "end",
        "part",
        "lexeme"
    ],
    contents: [
        "text"
    ]
}, $e60bcd291a6e9aed$var$$I = [
    "start",
    "ready",
    "strokestart",
    "stroke",
    "strokeend",
    "relax",
    "end"
], $e60bcd291a6e9aed$var$gC = [
    "start",
    "ready",
    "strokestart",
    "stroke",
    "strokeend",
    "relax",
    "end"
], $e60bcd291a6e9aed$var$IC = [
    "start",
    "ready",
    "strokestart",
    "stroke",
    "strokeend",
    "relax",
    "end"
], $e60bcd291a6e9aed$var$CC = [
    "start",
    "ready",
    "strokestart",
    "stroke",
    "strokeend",
    "relax",
    "end"
], $e60bcd291a6e9aed$var$yg = {
    bml: $e60bcd291a6e9aed$var$YI,
    required: $e60bcd291a6e9aed$var$KI,
    constraint: $e60bcd291a6e9aed$var$RI,
    synchronize: $e60bcd291a6e9aed$var$wI,
    before: $e60bcd291a6e9aed$var$LI,
    after: $e60bcd291a6e9aed$var$FI,
    sync: $e60bcd291a6e9aed$var$JI,
    wait: $e60bcd291a6e9aed$var$NI,
    facefacs: $e60bcd291a6e9aed$var$vI,
    facs: $e60bcd291a6e9aed$var$rI,
    face: $e60bcd291a6e9aed$var$kI,
    faceshift: $e60bcd291a6e9aed$var$zI,
    facelexeme: $e60bcd291a6e9aed$var$MI,
    gaze: $e60bcd291a6e9aed$var$QI,
    gazeshift: $e60bcd291a6e9aed$var$UI,
    gesture: $e60bcd291a6e9aed$var$DI,
    pointing: $e60bcd291a6e9aed$var$TI,
    head: $e60bcd291a6e9aed$var$xI,
    headdirectionshift: $e60bcd291a6e9aed$var$EI,
    locomotion: $e60bcd291a6e9aed$var$jI,
    posture: $e60bcd291a6e9aed$var$fI,
    postureshift: $e60bcd291a6e9aed$var$PI,
    stance: $e60bcd291a6e9aed$var$qI,
    pose: $e60bcd291a6e9aed$var$OI,
    speech: $e60bcd291a6e9aed$var$_I,
    torso: $e60bcd291a6e9aed$var$$I,
    body: $e60bcd291a6e9aed$var$gC,
    legs: $e60bcd291a6e9aed$var$IC,
    lips: $e60bcd291a6e9aed$var$CC
}, $e60bcd291a6e9aed$export$7bb8ef5c9b50e94d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    after: $e60bcd291a6e9aed$var$FI,
    before: $e60bcd291a6e9aed$var$LI,
    bml: $e60bcd291a6e9aed$var$YI,
    body: $e60bcd291a6e9aed$var$gC,
    constraint: $e60bcd291a6e9aed$var$RI,
    default: $e60bcd291a6e9aed$var$yg,
    face: $e60bcd291a6e9aed$var$kI,
    facefacs: $e60bcd291a6e9aed$var$vI,
    facelexeme: $e60bcd291a6e9aed$var$MI,
    faceshift: $e60bcd291a6e9aed$var$zI,
    facs: $e60bcd291a6e9aed$var$rI,
    gaze: $e60bcd291a6e9aed$var$QI,
    gazeshift: $e60bcd291a6e9aed$var$UI,
    gesture: $e60bcd291a6e9aed$var$DI,
    head: $e60bcd291a6e9aed$var$xI,
    headdirectionshift: $e60bcd291a6e9aed$var$EI,
    legs: $e60bcd291a6e9aed$var$IC,
    lips: $e60bcd291a6e9aed$var$CC,
    locomotion: $e60bcd291a6e9aed$var$jI,
    pointing: $e60bcd291a6e9aed$var$TI,
    pose: $e60bcd291a6e9aed$var$OI,
    posture: $e60bcd291a6e9aed$var$fI,
    postureshift: $e60bcd291a6e9aed$var$PI,
    required: $e60bcd291a6e9aed$var$KI,
    speech: $e60bcd291a6e9aed$var$_I,
    stance: $e60bcd291a6e9aed$var$qI,
    sync: $e60bcd291a6e9aed$var$JI,
    synchronize: $e60bcd291a6e9aed$var$wI,
    torso: $e60bcd291a6e9aed$var$$I,
    wait: $e60bcd291a6e9aed$var$NI
}, Symbol.toStringTag, {
    value: "Module"
}));
class $e60bcd291a6e9aed$var$pg extends $329ek.MeshPhysicalMaterial {
    constructor(g){
        super();
        $e60bcd291a6e9aed$var$c(this, "isSkinMaterial");
        $e60bcd291a6e9aed$var$c(this, "microNormalMap");
        $e60bcd291a6e9aed$var$c(this, "microMaskNormalMap");
        $e60bcd291a6e9aed$var$c(this, "microNormalScale");
        $e60bcd291a6e9aed$var$c(this, "cavityScale");
        $e60bcd291a6e9aed$var$c(this, "cavityMap");
        $e60bcd291a6e9aed$var$c(this, "cavityStrength");
        $e60bcd291a6e9aed$var$c(this, "_internalShader");
        this.isSkinMaterial = !0, this.microNormalMap = g.microNormalMap ? g.microNormalMap : null, this.microMaskNormalMap = g.microMaskNormalMap ? g.microMaskNormalMap : null, this.microNormalScale = g.microNormalScale ? g.microNormalScale : new $329ek.Vector2(30, 30), this.cavityScale = g.cavityScale ? g.cavityScale : new $329ek.Vector2(5, 5), this.cavityMap = g.cavityMap ? g.cavityMap : null, this.cavityStrength = g.cavityStrength ? g.cavityStrength : 0.35, this.setValues(g);
    }
    onBeforeRender(g, C, l, A, B, o) {
        this.updateInternalUniforms();
    }
    updateInternalUniforms() {
        this._internalShader && (this.microNormalMap !== this._internalShader.uniforms.microNormalMap.value && (this._internalShader.uniforms.microNormalMap.value = this.microNormalMap), this.microMaskNormalMap !== this._internalShader.uniforms.microMaskNormalMap.value && (this._internalShader.uniforms.microMaskNormalMap.value = this.microMaskNormalMap), this.microNormalScale !== this._internalShader.uniforms.microNormalScale.value && (this._internalShader.uniforms.microNormalScale.value = this.microNormalScale), this.cavityMap !== this._internalShader.uniforms.cavityMap.value && (this._internalShader.uniforms.cavityMap.value = this.cavityMap), this.cavityStrength !== this._internalShader.uniforms.cavityStrength.value && (this._internalShader.uniforms.cavityStrength.value = this.cavityStrength), this.cavityScale !== this._internalShader.uniforms.cavityScale.value && (this._internalShader.uniforms.cavityScale.value = this.cavityScale));
    }
    onBeforeCompile(g) {
        this._internalShader = g, g.uniforms.microNormalMap = {
            value: this.microNormalMap
        }, g.uniforms.microMaskNormalMap = {
            value: this.microMaskNormalMap
        }, g.uniforms.microNormalScale = {
            value: this.microNormalScale
        }, g.uniforms.cavityMap = {
            value: this.cavityMap
        }, g.uniforms.cavityStrength = {
            value: this.cavityStrength
        }, g.uniforms.cavityScale = {
            value: this.cavityScale
        }, g.vertexShader = g.vertexShader.replace("#include <uv_vertex>", /* glsl */ `
        #include <uv_vertex>
        vUvMicro = uv * microNormalScale;
        vUvCavity = uv * cavityScale;`), g.vertexShader = g.vertexShader.replace("#include <common>", /* glsl */ `
          #include <common>
          uniform vec2 microNormalScale;
          uniform vec2 cavityScale;
          varying vec2 vUvCavity;
          varying vec2 vUvMicro;`), g.fragmentShader = g.fragmentShader.replace("void main() {", /* glsl */ `

            uniform sampler2D microNormalMap;
            uniform sampler2D microMaskNormalMap;
            uniform sampler2D cavityMap;
            uniform float cavityStrength;
            uniform vec2 cavityScale;
            varying vec2 vUv;
            varying vec2 vUvMicro;
            varying vec2 vUvCavity;
  
            // Function to blend two normal maps
          vec3 blendNormalMaps(vec3 normal1, vec3 normal2, float maskColor) {
            return mix(normal1, normal2, maskColor);
          }
  
            void main() {
            `), g.fragmentShader = g.fragmentShader.replace("#include <normal_fragment_maps>", /* glsl */ `
          #include <normal_fragment_maps>
          
          // Sample the micro normal map
          float maskColor = texture2D(microMaskNormalMap, vNormalMapUv ).r;
          vec3 microNormal = texture2D(microNormalMap, vUvMicro).rgb * 2.0 - 1.0;
          microNormal.xy *= normalScale;
          microNormal = normalize( tbn * microNormal );
          // Blend the classic and micro normal maps
          normal = mix(normal, microNormal, maskColor);
          `), g.fragmentShader = g.fragmentShader.replace("#include <tonemapping_fragment>", /* glsl */ `
          float cavityColor = texture2D(cavityMap, vUvCavity).r;
          //float cavityFinal = min(1.0,(cavityStrength+cavityColor * (1.0-cavityStrength)));
          float cavityFinal = mix(cavityColor, 1.0, 1.0 - cavityStrength);
          gl_FragColor.rgb =  gl_FragColor.rgb * cavityFinal;
          #include <tonemapping_fragment>`);
    }
    updateRenderTargets() {}
}
class $e60bcd291a6e9aed$var$L {
}
$e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$L, "gltfLoader", new (0, $5RusT.GLTFLoader)()), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$L, "fbxLoader", new (0, $ltPx4.FBXLoader)()), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$L, "dracoLoader", new (0, $eraQQ.DRACOLoader)()), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$L, "textureLoader", new $329ek.TextureLoader());
$e60bcd291a6e9aed$var$L.dracoLoader.setDecoderPath("https://cdn.retorik.ai/bodyengine-three/draco/");
$e60bcd291a6e9aed$var$L.gltfLoader.setDRACOLoader($e60bcd291a6e9aed$var$L.dracoLoader);
$e60bcd291a6e9aed$var$L.gltfLoader.setMeshoptDecoder((0, $bQavx.MeshoptDecoder));
const $e60bcd291a6e9aed$var$N = class N extends $329ek.Loader {
    constructor(g){
        super(g);
        $e60bcd291a6e9aed$var$c(this, "textureLoader", null);
    }
    load(g, C, l, A) {
        const B = this;
        B.path === "" ? $329ek.LoaderUtils.extractUrlBase(g) : B.path;
        const o = g.replace(".fbx", ".fbm/"), i = g.replace(".fbx", ".json"), Z = new (0, $ltPx4.FBXLoader)(this.manager);
        Z.setPath(B.path), Z.setResourcePath(o), Z.load(g, async (b)=>{
            try {
                C(await B.autoSetup(b, i));
            } catch (a) {
                A ? A(a) : console.error(a), B.manager.itemError(g);
            }
        }, l, A);
    }
    loadAsync(g, C) {
        const l = this;
        return new Promise((A, B)=>{
            l.load(g, A, C, B);
        });
    }
    async autoSetup(g, C) {
        const l = $329ek.LoaderUtils.extractUrlBase(C), A = C.slice(l.length, C.length - 5), o = await new $e60bcd291a6e9aed$var$ml(this.manager).setCrossOrigin(this.crossOrigin).loadAsync(C);
        return this.textureLoader = new $329ek.TextureLoader(this.manager).setPath(l).setCrossOrigin(this.crossOrigin).setRequestHeader(this.requestHeader), await this.setupMeshes(g, o[A].Object[A].Meshes), g;
    }
    async setupMeshes(g, C) {
        var B, o;
        g.up = new $329ek.Vector3(0, 1, 0), g.rotateX(-(Math.PI / 2));
        const l = [];
        g.traverse((i)=>{
            i.isMesh && l.push(i);
        });
        const A = [];
        for(const i in C){
            const Z = l.find((b)=>b.name.includes(i));
            if (Z && (((o = (B = Z == null ? void 0 : Z.geometry) == null ? void 0 : B.attributes) == null ? void 0 : o.uv) !== void 0 && (Z.geometry.attributes.uv2 = Z.geometry.attributes.uv), Z.frustumCulled = !1, Z.material !== void 0)) {
                const b = C[i].Materials;
                if (Object.keys(b).length > 1) for(const a in b){
                    const m = Z.material.findIndex((e)=>e.name == a);
                    A.push(new Promise((e, s)=>{
                        this.setupMaterial(Z.material[m], b[a]).then((u)=>{
                            Z.material[m] = u, (a.toUpperCase().includes("HAIR") || a.toUpperCase().includes("FRONT")) && this.setDoublePassForHairForMultiMaterial(Z, m), e();
                        });
                    }));
                }
                else A.push(new Promise((a, m)=>{
                    this.setupMaterial(Z.material, b[Object.keys(b)[0]]).then((e)=>{
                        Z.material = e;
                        const s = Object.keys(b)[0];
                        (s.toUpperCase().includes("HAIR") || s.toUpperCase().includes("FRONT")) && this.setDoublePassForHairForSimpleMaterial(Z), a();
                    });
                }));
            }
        }
        await Promise.all(A);
    }
    async setSkinMaterial(g) {
        N.cavityMap === void 0 && (N.cavityMap = await $e60bcd291a6e9aed$var$L.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/cavity.jpg").catch((C)=>{
            console.warn("Can't load cavity map :", C);
        }), N.cavityMap && (N.cavityMap.wrapS = N.cavityMap.wrapT = $329ek.RepeatWrapping, N.cavityMap = N.cavityMap)), g.cavityMap = N.cavityMap, g.reflectivity = 0.25, g.transmissionMap && (g.transmission = 0.5), g.attenuationDistance = 1e-3, g.thickness = 0.02, g.attenuationColor = new $329ek.Color(0.8, 0.4, 0.3), g.microNormalScale = new $329ek.Vector2(28, 28), g.cavityScale = new $329ek.Vector2(20, 20), g.cavityStrength = 0.5;
    }
    async setSkinBodyMaterial(g) {
        N.cavityMap === void 0 && (N.cavityMap = await $e60bcd291a6e9aed$var$L.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/cavity.jpg").catch((C)=>{
            console.warn("Can't load cavity map :", C);
        }), N.cavityMap && (N.cavityMap.wrapS = N.cavityMap.wrapT = $329ek.RepeatWrapping, N.cavityMap = N.cavityMap)), g.cavityMap = N.cavityMap, g.reflectivity = 0.25, g.transmissionMap && (g.transmission = 0.5), g.attenuationDistance = 1e-3, g.thickness = 0.02, g.attenuationColor = new $329ek.Color(0.8, 0.4, 0.3), g.microNormalScale = new $329ek.Vector2(45, 45), g.cavityScale = new $329ek.Vector2(33, 33), g.cavityStrength = 0.5;
    }
    setDoublePassForHairForMultiMaterial(g, C) {
        const l = g.parent, A = g.material[C], B = new $329ek.MeshBasicMaterial({
            color: 0
        });
        B.visible = !1;
        const o = g.clone(), i = g.clone();
        g.name = "Hair", o.name = "HairClone", i.name = "Hair2Clone", A.onBeforeCompile = (a)=>{
            a.fragmentShader = a.fragmentShader.replace("#include <alphamap_fragment>", (0, $1W96c.ShaderChunk).alphamap_fragment.replace("diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g", "diffuseColor.a *= min(1.0, 0.10+texture2D( alphaMap, vAlphaMapUv ).g)"));
        }, g.frustumCulled = o.frustumCulled = !1, A.alphaTest = A.reflectivity = A.specularIntensity = A.sheen = 0, A.side = $329ek.DoubleSide, A.depthWrite = A.alphaHash = !1, A.premultipliedAlpha = A.transparent = !0, A.alphaToCoverage = !1, o.material[C] = A.clone(), i.material[C] = A.clone();
        const Z = o.material[C], b = i.material[C];
        A.opacity = 0.2, Z.opacity = 1, Z.alphaToCoverage = !1, b.transparent = b.alphaToCoverage = !0, b.alphaHash = !1, b.depthWrite = !0, b.alphaTest = 0, g.renderOrder = 1, o.renderOrder = 3, i.renderOrder = 2, l.add(o), l.add(i);
        for(let a = 0; a < o.material.length; a++)a !== C && (o.material[a] = B);
        for(let a = 0; a < i.material.length; a++)a !== C && (i.material[a] = B);
    }
    setDoublePassForHairForSimpleMaterial(g) {
        const C = g.parent, l = g.material, A = g.clone();
        l.onBeforeCompile = (o)=>{
            o.fragmentShader = o.fragmentShader.replace("#include <alphamap_fragment>", (0, $1W96c.ShaderChunk).alphamap_fragment.replace("diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g", "diffuseColor.a *= min(1.0, 0.10+texture2D( alphaMap, vAlphaMapUv ).g)"));
        }, g.frustumCulled = A.frustumCulled = !1, l.alphaTest = l.reflectivity = l.specularIntensity = l.sheen = 0, l.side = $329ek.DoubleSide, l.alphaToCoverage = l.depthWrite = l.alphaHash = l.transparent = !1, l.premultipliedAlpha = l.transparent = !0, A.material = l.clone();
        const B = A.material;
        l.opacity = 0.33, B.opacity = 1, g.renderOrder = 1, A.renderOrder = 2, C.add(A);
    }
    async setupMaterial(g, C) {
        var A, B, o, i, Z, b, a, m, e, s, u, W;
        let l;
        if (g.name.includes("Skin_Arm") || g.name.includes("Skin_Leg") || g.name.includes("Skin_Body") ? l = new $e60bcd291a6e9aed$var$pg({
            side: $329ek.DoubleSide
        }) : g.name.includes("Skin_Head") ? l = new $e60bcd291a6e9aed$var$pg({
            side: $329ek.DoubleSide
        }) : l = new $329ek.MeshPhysicalMaterial(), l.name = g.name, l.ior = 1.45, l.sheen = 0.5, l.sheenRoughness = 1, C["Two Side"] ? l.side = $329ek.DoubleSide : l.side = $329ek.FrontSide, C["Diffuse Color"]) {
            const y = C["Diffuse Color"];
            l.color.setRGB(1 * y[0] / 255, 1 * y[1] / 255, 1 * y[2] / 255);
        }
        if (C.Textures["Base Color"] && C.Textures["Base Color"]["Base Path"] !== "") {
            const y = C.Textures["Base Color"], h = await ((A = this.textureLoader) == null ? void 0 : A.loadAsync(y["Texture Path"]).catch((n)=>{
                console.warn("Can't load Base Color map :", n);
            }));
            h && (h.anisotropy = 4, h.colorSpace = $329ek.SRGBColorSpace, h.wrapS = $329ek.RepeatWrapping, h.wrapT = $329ek.RepeatWrapping, l.map = h);
        }
        if (C.Textures.Metallic && C.Textures.Metallic["Texture Path"] !== "") {
            const y = C.Textures.Metallic, h = await ((B = this.textureLoader) == null ? void 0 : B.loadAsync(y["Texture Path"]).catch((n)=>{
                console.warn("Can't load Metallic map :", n);
            }));
            h ? (h.anisotropy = 4, h.colorSpace = $329ek.NoColorSpace, h.wrapS = $329ek.RepeatWrapping, h.wrapT = $329ek.RepeatWrapping, l.name.includes("Cornea") && (l.clearcoat = 1, l.clearcoatRoughness = 0.15), l.name.includes("Std_Eye_") && (l.clearcoatRoughness = 0.03), l.metalnessMap = h, l.metalness = y.Strength / 100) : l.metalness = 0;
        }
        if (C.Textures.Specular && C.Textures.Specular["Texture Path"] !== "") {
            const y = C.Textures.Specular, h = await ((o = this.textureLoader) == null ? void 0 : o.loadAsync(y["Texture Path"]).catch((n)=>{
                console.warn("Can't load Specular map :", n);
            }));
            if (h) {
                if (h.anisotropy = 4, h.colorSpace = $329ek.NoColorSpace, h.wrapS = $329ek.RepeatWrapping, h.wrapT = $329ek.RepeatWrapping, C["Specular Color"]) {
                    const n = C["Specular Color"];
                    l.specularColor.setRGB(1 * n[0] / 255, 1 * n[1] / 255, 1 * n[2] / 255);
                }
                l.specularColorMap = h, l.specularIntensity = y.Strength / 100, l.specularIntensityMap = h;
            }
        }
        if (C.Textures.Opacity && C.Textures.Opacity["Texture Path"] !== "") {
            const y = C.Textures.Opacity, h = await ((i = this.textureLoader) == null ? void 0 : i.loadAsync(y["Texture Path"]).catch((p)=>{
                console.warn("Can't load Alpha map :", p);
            }));
            h && (h.anisotropy = 4, h.colorSpace = $329ek.NoColorSpace, h.format = $329ek.RGBAFormat, h.wrapS = $329ek.RepeatWrapping, h.wrapT = $329ek.RepeatWrapping, l.alphaMap = h);
            let n = 0, H = g.opacity, F = !0;
            (l.name.toUpperCase().includes("SCALP") || l.name.toUpperCase().includes("BASE")) && (n = 0, l.alphaToCoverage = !1), (l.name.toUpperCase().includes("HAIR") || l.name.toUpperCase().includes("FRONT")) && (n = 0, l.alphaToCoverage = !1, F = !0, l.alphaHash = !1, l.depthWrite = !1, H = 1), l.name.toUpperCase().includes("EYELASH") && (l.depthWrite = !1), l.name.includes("Brow_Transparency") && (n = 0, l.alphaToCoverage = !0, F = !1, l.alphaHash = !0, l.depthWrite = !0, H = 1), l.name.includes("Brow_Base_Transparency") && (n = 0, l.alphaToCoverage = !0, H = 1), l.name.includes("Eyelash") && (n = 0, H = 0.75, F = !0), l.name.includes("Eye_Occlusion") && (l.visible = !1), l.alphaTest = n, l.opacity = H * y.Strength / 100, l.transparent = F;
        }
        if (C.Textures.Displacement && C.Textures.Displacement["Texture Path"] !== "") {
            const y = C.Textures.Displacement, h = await ((Z = this.textureLoader) == null ? void 0 : Z.loadAsync(y["Texture Path"]).catch((n)=>{
                console.warn("Can't load Displacement map :", n);
            }));
            h && (h.anisotropy = 4, h.colorSpace = $329ek.NoColorSpace, h.wrapS = $329ek.RepeatWrapping, h.wrapT = $329ek.RepeatWrapping, l.displacementMap = h, l.displacementBias = 0, l.displacementScale = 0.5);
        }
        if (C.Textures.Roughness && C.Textures.Roughness["Texture Path"] !== "") {
            const y = C.Textures.Roughness, h = await ((b = this.textureLoader) == null ? void 0 : b.loadAsync(y["Texture Path"]).catch((n)=>{
                console.warn("Can't load Roughness map :", n);
            }));
            h ? (h.anisotropy = 4, h.format = $329ek.RGBAFormat, h.colorSpace = $329ek.NoColorSpace, h.wrapS = $329ek.RepeatWrapping, h.wrapT = $329ek.RepeatWrapping, l.roughnessMap = h, l.roughness = y.Strength / 100) : l.roughness = 1;
        }
        if (C.Textures.Normal && C.Textures.Normal["Texture Path"] !== "") {
            const y = C.Textures.Normal, h = await ((a = this.textureLoader) == null ? void 0 : a.loadAsync(y["Texture Path"]).catch((n)=>{
                console.warn("Can't load Normal map :", n);
            }));
            h && (h.anisotropy = 4, h.colorSpace = $329ek.NoColorSpace, h.format = $329ek.RGBAFormat, h.wrapS = $329ek.RepeatWrapping, h.wrapT = $329ek.RepeatWrapping, l.normalScale = new $329ek.Vector2(y.Strength / 100, -y.Strength / 100), l.normalMap = h);
        }
        if (C.Textures.AO && C.Textures.AO["Texture Path"] !== "") {
            const y = C.Textures.AO, h = await ((m = this.textureLoader) == null ? void 0 : m.loadAsync(y["Texture Path"]).catch((n)=>{
                console.warn("Can't load AO map :", n);
            }));
            h && (h.anisotropy = 4, h.colorSpace = $329ek.SRGBColorSpace, h.wrapS = $329ek.RepeatWrapping, h.wrapT = $329ek.RepeatWrapping, h.channel = 1, l.aoMap = h, l.aoMapIntensity = 0.5 * y.Strength / 100);
        }
        if (C.Textures.Glow && C.Textures.Glow["Texture Path"] !== "") {
            const y = C.Textures.Glow, h = await ((e = this.textureLoader) == null ? void 0 : e.loadAsync(y["Texture Path"]).catch((n)=>{
                console.warn("Can't load Glow map :", n);
            }));
            h && (h.anisotropy = 4, h.wrapS = $329ek.RepeatWrapping, h.wrapT = $329ek.RepeatWrapping, l.emissiveMap = h, l.emissiveIntensity = 1 * y.Strength / 100, l.emissive = new $329ek.Color(16777215));
        }
        if (C["Custom Shader"] && (C["Custom Shader"]["Shader Name"] === "RLHead" || C["Custom Shader"]["Shader Name"] === "RLSkin")) {
            const y = await ((s = this.textureLoader) == null ? void 0 : s.loadAsync(C["Custom Shader"].Image["Transmission Map"]["Texture Path"]).catch((H)=>{
                console.warn("Can't load Transmission map :", H);
            }));
            y && (y.anisotropy = 4, y.wrapS = $329ek.RepeatWrapping, y.wrapT = $329ek.RepeatWrapping, l.transmissionMap = y, l.transmission = 1, l.reflectivity = 0.5);
            const h = await ((u = this.textureLoader) == null ? void 0 : u.loadAsync(C["Custom Shader"].Image.MicroNormalMask["Texture Path"]).catch((H)=>{
                console.warn("Can't load Transmission map :", H);
            }));
            h && (h.anisotropy = 4, h.wrapS = $329ek.RepeatWrapping, h.wrapT = $329ek.RepeatWrapping, l.microMaskNormalMap = h);
            const n = await ((W = this.textureLoader) == null ? void 0 : W.loadAsync(C["Custom Shader"].Image.MicroNormal["Texture Path"]).catch((H)=>{
                console.warn("Can't load Transmission map :", H);
            }));
            n && (n.anisotropy = 4, n.wrapS = $329ek.RepeatWrapping, n.wrapT = $329ek.RepeatWrapping, l.microNormalMap = n);
        }
        return (g.name.includes("Skin_Arm") || g.name.includes("Skin_Leg") || g.name.includes("Skin_Body")) && this.setSkinBodyMaterial(l), g.name.includes("Skin_Head") && this.setSkinMaterial(l), l;
    }
    setupPhysics(g, C) {}
};
$e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$N, "cavityMap"), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$N, "microNormalMap");
let $e60bcd291a6e9aed$export$ad2b5f000abbc959 = $e60bcd291a6e9aed$var$N;
class $e60bcd291a6e9aed$var$ml extends $329ek.Loader {
    constructor(I){
        super(I);
    }
    load(I, g, C, l) {
        const A = this;
        A.path === "" ? $329ek.LoaderUtils.extractUrlBase(I) : A.path;
        const B = new $329ek.FileLoader(this.manager);
        B.setPath(A.path), B.setRequestHeader(A.requestHeader), B.setWithCredentials(A.withCredentials), B.load(I, (o)=>{
            try {
                g(A.parse(o));
            } catch (i) {
                l ? l(i) : console.error(i), A.manager.itemError(I);
            }
        }, C, l);
    }
    async loadAsync(I, g) {
        const C = this;
        C.path === "" ? $329ek.LoaderUtils.extractUrlBase(I) : C.path;
        const l = new $329ek.FileLoader(this.manager);
        l.setPath(C.path), l.setRequestHeader(C.requestHeader), l.setWithCredentials(C.withCredentials);
        const A = await l.loadAsync(I, g);
        return C.parse(A);
    }
    parse(I) {
        return JSON.parse(I);
    }
}
const $e60bcd291a6e9aed$var$r = class r extends $329ek.Loader {
    constructor(I){
        super(I);
    }
    load(I, g, C, l) {
        $e60bcd291a6e9aed$var$L.gltfLoader.load(I, (A)=>{
            this.setMaterial(A.scene).then(()=>{
                g(A.scene);
            });
        }, C, l);
    }
    loadAsync(I, g) {
        const C = this;
        return new Promise((l, A)=>{
            C.load(I, l, g, A);
        });
    }
    async setMaterial(I) {
        const g = [];
        I.traverse((o)=>{
            var i;
            if (o.isMesh) {
                o.castShadow = o.receiveShadow = !0, g.push(o);
                for(const Z in o.material)Z.toUpperCase().includes("MAP") && (i = o.material[Z]) != null && i.anisotropy && (o.material[Z].anisotropy = 8);
            }
        });
        const C = g.find((o)=>o.name.includes("Head_Mesh")), l = g.find((o)=>o.name.includes("avaturn_hair_1")), A = g.find((o)=>o.name.includes("avaturn_hair_0"));
        if (A) {
            const o = A.clone(), i = A.clone();
            o.material = A.material.clone(), i.material = A.material.clone(), A.material.transparent = !0, A.material.depthWrite = !1, A.material.alphaTest = 0, A.parent.add(o), i.material.transparent = i.material.alphaToCoverage = !0, i.material.alphaHash = !1, i.material.depthWrite = !0, i.material.alphaTest = 0, A.parent.add(i), A.renderOrder = 1, i.renderOrder = 2, o.renderOrder = 3;
        }
        const B = g.find((o)=>o.name.includes("Eye_Mesh"));
        C && await this.setHead(C), l && await this.setHair(l), B && await this.setEye(B);
    }
    setEye(I) {
        I.material.roughnessMap = null, I.material.roughness = 1;
        const g = I.clone();
        g.geometry = I.geometry.clone(), g.geometry.translate(0, 0, 1e-3), g.material = g.material = new $329ek.MeshPhysicalMaterial({
            color: new $329ek.Color(0.5, 0.5, 0.5),
            metalness: 0,
            roughness: 0,
            transmission: 1,
            transparent: !0,
            opacity: 0.5,
            side: $329ek.FrontSide
        }), I.parent.add(g);
    }
    async setHair(I) {
        const g = I.material;
        g.alphaTest = g.reflectivity = g.specularIntensity = g.sheen = 0, g.side = $329ek.DoubleSide, g.alphaHash = !1, g.premultipliedAlpha = !1, g.alphaToCoverage = !1;
        const C = I.clone(), l = I.clone();
        C.material = I.material.clone(), g.onBeforeCompile = (o)=>{
            o.fragmentShader = o.fragmentShader.replace("#include <alphamap_fragment>", (0, $1W96c.ShaderChunk).alphamap_fragment.replace("diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g", "diffuseColor.a *= min(1.0, 0.10+texture2D( alphaMap, vAlphaMapUv ).g)"));
        }, l.material = I.material.clone(), I.name = "Hair", C.name = "HairClone", l.name = "Hair2Clone";
        const A = C.material;
        A.name = "HairMaterialClone";
        const B = l.material;
        B.name = "HairMaterial2Clone", g.opacity = 0.3, A.opacity = 0.5, B.transparent = B.alphaToCoverage = !0, B.alphaHash = !1, B.depthWrite = !1, B.alphaTest = 0, I.renderOrder = 1, C.renderOrder = 3, l.renderOrder = 2, I.parent.add(C), I.parent.add(l);
    }
    async setHead(I) {
        r.cavityMap || (r.cavityMap = await $e60bcd291a6e9aed$var$L.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/cavity.jpg"), r.cavityMap.wrapS = r.cavityMap.wrapT = $329ek.RepeatWrapping), r.microMap || (r.microMap = await $e60bcd291a6e9aed$var$L.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/micro.jpg"), r.microMap.wrapS = r.microMap.wrapT = $329ek.RepeatWrapping), r.microNormalMaskMap || (r.microNormalMaskMap = await $e60bcd291a6e9aed$var$L.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/normalMask.jpg"), r.microNormalMaskMap.flipY = !0);
        const g = new $e60bcd291a6e9aed$var$pg({
            color: I.material.color,
            metalness: I.material.metalness,
            roughness: I.material.roughness,
            map: I.material.map,
            normalMap: I.material.normalMap,
            normalScale: I.material.normalScale,
            roughnessMap: I.material.roughnessMap,
            metalnessMap: I.material.metalnessMap,
            side: $329ek.DoubleSide,
            cavityMap: r.cavityMap,
            attenuationDistance: 1e-3,
            thickness: 1e-3,
            attenuationColor: new $329ek.Color(0.8, 0.4, 0.3),
            microNormalScale: new $329ek.Vector2(50, 50),
            microNormalMap: r.microMap,
            microMaskNormalMap: r.microNormalMaskMap,
            cavityStrength: 0.7,
            cavityScale: new $329ek.Vector2(20, 20)
        });
        I.material = g;
    }
};
$e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$r, "cavityMap"), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$r, "microMap"), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$r, "microNormalMaskMap");
let $e60bcd291a6e9aed$export$323f6f3f401dfadc = $e60bcd291a6e9aed$var$r;
const $e60bcd291a6e9aed$var$k = class k extends $329ek.Loader {
    constructor(I){
        super(I);
    }
    load(I, g, C, l) {
        $e60bcd291a6e9aed$var$L.gltfLoader.load(I, (A)=>{
            this.setMaterial(A.scene).then(()=>{
                g(A.scene);
            });
        }, C, l);
    }
    loadAsync(I, g) {
        const C = this;
        return new Promise((l, A)=>{
            C.load(I, l, g, A);
        });
    }
    async setMaterial(I) {
        const g = [];
        I.castShadow = I.receiveShadow = !0, I.traverse((b)=>{
            var a;
            b.castShadow = b.receiveShadow = !0, b.isMesh && (g.push(b), b.material.premultipliedAlpha = !1);
            for(const m in b.material)m.toUpperCase().includes("MAP") && (a = b.material[m]) != null && a.anisotropy && (b.material[m].anisotropy = 8);
        });
        const C = g.filter((b)=>b.name.includes("Cornea")), l = g.find((b)=>b.name.includes("AvatarHead")), A = g.find((b)=>b.name.includes("haircut")), B = g.find((b)=>b.name.includes("AvatarLeftEyeball")), o = g.find((b)=>b.name.includes("AvatarRightEyeball")), i = g.find((b)=>b.name.includes("AvatarEyelashes")), Z = g.find((b)=>b.name.includes("glasses"));
        C.forEach((b)=>{
            b.visible = !1;
        }), Z && (Z.castShadow = !1), l && await this.setHead(l), A && await this.setHair(A), B && await this.setEye(B), o && await this.setEye(o), i && (i.material.transparent = !1, i.material.alphaHash = !0, i.material.depthWrite = !0, i.material.side = $329ek.DoubleSide, i.material.opacity = 1, i.material.premultipliedAlpha = !1);
    }
    setEye(I) {
        var l;
        const g = I.clone();
        g.material.premultipliedAlpha = !1, g.geometry = I.geometry.clone();
        const C = (l = g.geometry.boundingBox) == null ? void 0 : l.getCenter(new $329ek.Vector3());
        g.geometry.translate(-C.x, -C.y, -C.z), g.geometry.rotateX(Math.PI / 2), g.geometry.translate(C.x, C.y, C.z), g.geometry.translate(0, 0, 1e-3), g.material = new $329ek.MeshPhysicalMaterial({
            color: new $329ek.Color(1, 1, 1),
            metalness: 0,
            roughness: 0.05,
            // avoid GI blowout on perfectly smooth transmissive surfaces
            opacity: 0.8,
            transmission: 1,
            transparent: !0,
            side: $329ek.FrontSide,
            premultipliedAlpha: !1
        }), I.parent.add(g);
    }
    async setHair(I) {
        I.material.alphaTest = I.material.reflectivity = I.material.specularIntensity = I.material.sheen = 0, I.material = new $329ek.MeshPhysicalMaterial({
            color: I.material.color,
            metalness: I.material.metalness,
            roughness: I.material.roughness,
            map: I.material.map,
            normalMap: I.material.normalMap,
            normalScale: I.material.normalScale,
            roughnessMap: I.material.roughnessMap,
            metalnessMap: I.material.metalnessMap,
            side: $329ek.DoubleSide,
            transparent: I.material.transparent,
            alphaTest: I.material.alphaTest,
            alphaMap: I.material.alphaMap,
            opacity: I.material.opacity,
            specularColor: new $329ek.Color(1, 1, 1),
            sheen: 0.2,
            sheenRoughness: 0.5,
            sheenColor: new $329ek.Color(1, 1, 1)
        }), I.material.premultipliedAlpha = !1;
        const g = I.material;
        g.side = $329ek.DoubleSide, g.depthWrite = g.transparent = !1, g.transparent = !0, g.alphaToCoverage = !1;
        const C = I.clone();
        C.material = I.material.clone(), C.geometry = I.geometry.clone(), I.name = "Hair", C.name = "Hair2Clone";
        const l = C.material;
        l.side = $329ek.FrontSide, l.alphaToCoverage = !0, l.depthWrite = !0, I.renderOrder = 1, C.renderOrder = 3, I.parent.add(C);
    }
    async setHead(I) {
        k.cavityMap || (k.cavityMap = await $e60bcd291a6e9aed$var$L.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/cavity.jpg"), k.cavityMap.wrapS = k.cavityMap.wrapT = $329ek.RepeatWrapping), k.microMap || (k.microMap = await $e60bcd291a6e9aed$var$L.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/micro.jpg"), k.microMap.wrapS = k.microMap.wrapT = $329ek.RepeatWrapping), k.microNormalMaskMap || (k.microNormalMaskMap = await $e60bcd291a6e9aed$var$L.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/normalMask.jpg"), k.microNormalMaskMap.flipY = !0);
        const g = new $e60bcd291a6e9aed$var$pg({
            color: I.material.color,
            metalness: I.material.metalness,
            roughness: I.material.roughness,
            map: I.material.map,
            normalMap: I.material.normalMap,
            normalScale: I.material.normalScale,
            roughnessMap: I.material.roughnessMap,
            metalnessMap: I.material.metalnessMap,
            specularMap: I.material.specularMap,
            specularIntensity: I.material.specularIntensity,
            specularColor: I.material.specularColor,
            side: $329ek.DoubleSide,
            cavityMap: k.cavityMap,
            attenuationDistance: 1e-3,
            thickness: 1e-3,
            attenuationColor: new $329ek.Color(0.8, 0.4, 0.3),
            microNormalScale: new $329ek.Vector2(50, 50),
            microNormalMap: k.microMap,
            microMaskNormalMap: k.microNormalMaskMap,
            cavityStrength: 0.7,
            cavityScale: new $329ek.Vector2(20, 20)
        });
        I.material = g;
    }
};
$e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$k, "cavityMap"), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$k, "microMap"), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$k, "microNormalMaskMap");
let $e60bcd291a6e9aed$export$dbb172dd5b84295d = $e60bcd291a6e9aed$var$k;
var $e60bcd291a6e9aed$var$lC = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: !0,
    timelineOffset: 0
}, $e60bcd291a6e9aed$var$xg = {
    duration: 1e3,
    delay: 0,
    endDelay: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
}, $e60bcd291a6e9aed$var$hl = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "perspective",
    "matrix",
    "matrix3d"
], $e60bcd291a6e9aed$var$Yg = {
    CSS: {},
    springs: {}
};
function $e60bcd291a6e9aed$var$gg(G, I, g) {
    return Math.min(Math.max(G, I), g);
}
function $e60bcd291a6e9aed$var$ng(G, I) {
    return G.indexOf(I) > -1;
}
function $e60bcd291a6e9aed$var$zg(G, I) {
    return G.apply(null, I);
}
var $e60bcd291a6e9aed$var$X = {
    arr: function(G) {
        return Array.isArray(G);
    },
    obj: function(G) {
        return $e60bcd291a6e9aed$var$ng(Object.prototype.toString.call(G), "Object");
    },
    pth: function(G) {
        return $e60bcd291a6e9aed$var$X.obj(G) && G.hasOwnProperty("totalLength");
    },
    svg: function(G) {
        return G instanceof SVGElement;
    },
    inp: function(G) {
        return G instanceof HTMLInputElement;
    },
    dom: function(G) {
        return G.nodeType || $e60bcd291a6e9aed$var$X.svg(G);
    },
    str: function(G) {
        return typeof G == "string";
    },
    fnc: function(G) {
        return typeof G == "function";
    },
    und: function(G) {
        return typeof G > "u";
    },
    nil: function(G) {
        return $e60bcd291a6e9aed$var$X.und(G) || G === null;
    },
    hex: function(G) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(G);
    },
    rgb: function(G) {
        return /^rgb/.test(G);
    },
    hsl: function(G) {
        return /^hsl/.test(G);
    },
    col: function(G) {
        return $e60bcd291a6e9aed$var$X.hex(G) || $e60bcd291a6e9aed$var$X.rgb(G) || $e60bcd291a6e9aed$var$X.hsl(G);
    },
    key: function(G) {
        return !$e60bcd291a6e9aed$var$lC.hasOwnProperty(G) && !$e60bcd291a6e9aed$var$xg.hasOwnProperty(G) && G !== "targets" && G !== "keyframes";
    }
};
function $e60bcd291a6e9aed$var$AC(G) {
    var I = /\(([^)]+)\)/.exec(G);
    return I ? I[1].split(",").map(function(g) {
        return parseFloat(g);
    }) : [];
}
function $e60bcd291a6e9aed$var$GC(G, I) {
    var g = $e60bcd291a6e9aed$var$AC(G), C = $e60bcd291a6e9aed$var$gg($e60bcd291a6e9aed$var$X.und(g[0]) ? 1 : g[0], 0.1, 100), l = $e60bcd291a6e9aed$var$gg($e60bcd291a6e9aed$var$X.und(g[1]) ? 100 : g[1], 0.1, 100), A = $e60bcd291a6e9aed$var$gg($e60bcd291a6e9aed$var$X.und(g[2]) ? 10 : g[2], 0.1, 100), B = $e60bcd291a6e9aed$var$gg($e60bcd291a6e9aed$var$X.und(g[3]) ? 0 : g[3], 0.1, 100), o = Math.sqrt(l / C), i = A / (2 * Math.sqrt(l * C)), Z = i < 1 ? o * Math.sqrt(1 - i * i) : 0, b = 1, a = i < 1 ? (i * o + -B) / Z : -B + o;
    function m(s) {
        var u = I ? I * s / 1e3 : s;
        return i < 1 ? u = Math.exp(-u * i * o) * (b * Math.cos(Z * u) + a * Math.sin(Z * u)) : u = (b + a * u) * Math.exp(-u * o), s === 0 || s === 1 ? s : 1 - u;
    }
    function e() {
        var s = $e60bcd291a6e9aed$var$Yg.springs[G];
        if (s) return s;
        for(var u = 1 / 6, W = 0, y = 0;;)if (W += u, m(W) === 1) {
            if (y++, y >= 16) break;
        } else y = 0;
        var h = W * u * 1e3;
        return $e60bcd291a6e9aed$var$Yg.springs[G] = h, h;
    }
    return I ? m : e;
}
function $e60bcd291a6e9aed$var$el(G) {
    return G === void 0 && (G = 10), function(I) {
        return Math.ceil($e60bcd291a6e9aed$var$gg(I, 1e-6, 1) * G) * (1 / G);
    };
}
var $e60bcd291a6e9aed$var$sl = function() {
    var G = 11, I = 1 / (G - 1);
    function g(b, a) {
        return 1 - 3 * a + 3 * b;
    }
    function C(b, a) {
        return 3 * a - 6 * b;
    }
    function l(b) {
        return 3 * b;
    }
    function A(b, a, m) {
        return ((g(a, m) * b + C(a, m)) * b + l(a)) * b;
    }
    function B(b, a, m) {
        return 3 * g(a, m) * b * b + 2 * C(a, m) * b + l(a);
    }
    function o(b, a, m, e, s) {
        var u, W, y = 0;
        do W = a + (m - a) / 2, u = A(W, e, s) - b, u > 0 ? m = W : a = W;
        while (Math.abs(u) > 1e-7 && ++y < 10);
        return W;
    }
    function i(b, a, m, e) {
        for(var s = 0; s < 4; ++s){
            var u = B(a, m, e);
            if (u === 0) return a;
            var W = A(a, m, e) - b;
            a -= W / u;
        }
        return a;
    }
    function Z(b, a, m, e) {
        if (!(0 <= b && b <= 1 && 0 <= m && m <= 1)) return;
        var s = new Float32Array(G);
        if (b !== a || m !== e) for(var u = 0; u < G; ++u)s[u] = A(u * I, b, m);
        function W(y) {
            for(var h = 0, n = 1, H = G - 1; n !== H && s[n] <= y; ++n)h += I;
            --n;
            var F = (y - s[n]) / (s[n + 1] - s[n]), p = h + F * I, f = B(p, b, m);
            return f >= 1e-3 ? i(y, p, b, m) : f === 0 ? p : o(y, h, h + I, b, m);
        }
        return function(y) {
            return b === a && m === e || y === 0 || y === 1 ? y : A(W(y), a, e);
        };
    }
    return Z;
}(), $e60bcd291a6e9aed$var$BC = function() {
    var G = {
        linear: function() {
            return function(C) {
                return C;
            };
        }
    }, I = {
        Sine: function() {
            return function(C) {
                return 1 - Math.cos(C * Math.PI / 2);
            };
        },
        Expo: function() {
            return function(C) {
                return C ? Math.pow(2, 10 * C - 10) : 0;
            };
        },
        Circ: function() {
            return function(C) {
                return 1 - Math.sqrt(1 - C * C);
            };
        },
        Back: function() {
            return function(C) {
                return C * C * (3 * C - 2);
            };
        },
        Bounce: function() {
            return function(C) {
                for(var l, A = 4; C < ((l = Math.pow(2, --A)) - 1) / 11;);
                return 1 / Math.pow(4, 3 - A) - 7.5625 * Math.pow((l * 3 - 2) / 22 - C, 2);
            };
        },
        Elastic: function(C, l) {
            C === void 0 && (C = 1), l === void 0 && (l = 0.5);
            var A = $e60bcd291a6e9aed$var$gg(C, 1, 10), B = $e60bcd291a6e9aed$var$gg(l, 0.1, 2);
            return function(o) {
                return o === 0 || o === 1 ? o : -A * Math.pow(2, 10 * (o - 1)) * Math.sin((o - 1 - B / (Math.PI * 2) * Math.asin(1 / A)) * (Math.PI * 2) / B);
            };
        }
    }, g = [
        "Quad",
        "Cubic",
        "Quart",
        "Quint"
    ];
    return g.forEach(function(C, l) {
        I[C] = function() {
            return function(A) {
                return Math.pow(A, l + 2);
            };
        };
    }), Object.keys(I).forEach(function(C) {
        var l = I[C];
        G["easeIn" + C] = l, G["easeOut" + C] = function(A, B) {
            return function(o) {
                return 1 - l(A, B)(1 - o);
            };
        }, G["easeInOut" + C] = function(A, B) {
            return function(o) {
                return o < 0.5 ? l(A, B)(o * 2) / 2 : 1 - l(A, B)(o * -2 + 2) / 2;
            };
        }, G["easeOutIn" + C] = function(A, B) {
            return function(o) {
                return o < 0.5 ? (1 - l(A, B)(1 - o * 2)) / 2 : (l(A, B)(o * 2 - 1) + 1) / 2;
            };
        };
    }), G;
}();
function $e60bcd291a6e9aed$var$Eg(G, I) {
    if ($e60bcd291a6e9aed$var$X.fnc(G)) return G;
    var g = G.split("(")[0], C = $e60bcd291a6e9aed$var$BC[g], l = $e60bcd291a6e9aed$var$AC(G);
    switch(g){
        case "spring":
            return $e60bcd291a6e9aed$var$GC(G, I);
        case "cubicBezier":
            return $e60bcd291a6e9aed$var$zg($e60bcd291a6e9aed$var$sl, l);
        case "steps":
            return $e60bcd291a6e9aed$var$zg($e60bcd291a6e9aed$var$el, l);
        default:
            return $e60bcd291a6e9aed$var$zg(C, l);
    }
}
function $e60bcd291a6e9aed$var$iC(G) {
    try {
        var I = document.querySelectorAll(G);
        return I;
    } catch  {
        return;
    }
}
function $e60bcd291a6e9aed$var$wg(G, I) {
    for(var g = G.length, C = arguments.length >= 2 ? arguments[1] : void 0, l = [], A = 0; A < g; A++)if (A in G) {
        var B = G[A];
        I.call(C, B, A, G) && l.push(B);
    }
    return l;
}
function $e60bcd291a6e9aed$var$Lg(G) {
    return G.reduce(function(I, g) {
        return I.concat($e60bcd291a6e9aed$var$X.arr(g) ? $e60bcd291a6e9aed$var$Lg(g) : g);
    }, []);
}
function $e60bcd291a6e9aed$var$bI(G) {
    return $e60bcd291a6e9aed$var$X.arr(G) ? G : ($e60bcd291a6e9aed$var$X.str(G) && (G = $e60bcd291a6e9aed$var$iC(G) || G), G instanceof NodeList || G instanceof HTMLCollection ? [].slice.call(G) : [
        G
    ]);
}
function $e60bcd291a6e9aed$var$jg(G, I) {
    return G.some(function(g) {
        return g === I;
    });
}
function $e60bcd291a6e9aed$var$fg(G) {
    var I = {};
    for(var g in G)I[g] = G[g];
    return I;
}
function $e60bcd291a6e9aed$var$Ug(G, I) {
    var g = $e60bcd291a6e9aed$var$fg(G);
    for(var C in G)g[C] = I.hasOwnProperty(C) ? I[C] : G[C];
    return g;
}
function $e60bcd291a6e9aed$var$Fg(G, I) {
    var g = $e60bcd291a6e9aed$var$fg(G);
    for(var C in I)g[C] = $e60bcd291a6e9aed$var$X.und(G[C]) ? I[C] : G[C];
    return g;
}
function $e60bcd291a6e9aed$var$yl(G) {
    var I = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(G);
    return I ? "rgba(" + I[1] + ",1)" : G;
}
function $e60bcd291a6e9aed$var$ul(G) {
    var I = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, g = G.replace(I, function(o, i, Z, b) {
        return i + i + Z + Z + b + b;
    }), C = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(g), l = parseInt(C[1], 16), A = parseInt(C[2], 16), B = parseInt(C[3], 16);
    return "rgba(" + l + "," + A + "," + B + ",1)";
}
function $e60bcd291a6e9aed$var$Wl(G) {
    var I = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(G) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(G), g = parseInt(I[1], 10) / 360, C = parseInt(I[2], 10) / 100, l = parseInt(I[3], 10) / 100, A = I[4] || 1;
    function B(m, e, s) {
        return s < 0 && (s += 1), s > 1 && (s -= 1), s < 1 / 6 ? m + (e - m) * 6 * s : s < 0.5 ? e : s < 2 / 3 ? m + (e - m) * (2 / 3 - s) * 6 : m;
    }
    var o, i, Z;
    if (C == 0) o = i = Z = l;
    else {
        var b = l < 0.5 ? l * (1 + C) : l + C - l * C, a = 2 * l - b;
        o = B(a, b, g + 1 / 3), i = B(a, b, g), Z = B(a, b, g - 1 / 3);
    }
    return "rgba(" + o * 255 + "," + i * 255 + "," + Z * 255 + "," + A + ")";
}
function $e60bcd291a6e9aed$var$nl(G) {
    if ($e60bcd291a6e9aed$var$X.rgb(G)) return $e60bcd291a6e9aed$var$yl(G);
    if ($e60bcd291a6e9aed$var$X.hex(G)) return $e60bcd291a6e9aed$var$ul(G);
    if ($e60bcd291a6e9aed$var$X.hsl(G)) return $e60bcd291a6e9aed$var$Wl(G);
}
function $e60bcd291a6e9aed$var$Gg(G) {
    var I = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(G);
    if (I) return I[1];
}
function $e60bcd291a6e9aed$var$tl(G) {
    if ($e60bcd291a6e9aed$var$ng(G, "translate") || G === "perspective") return "px";
    if ($e60bcd291a6e9aed$var$ng(G, "rotate") || $e60bcd291a6e9aed$var$ng(G, "skew")) return "deg";
}
function $e60bcd291a6e9aed$var$Dg(G, I) {
    return $e60bcd291a6e9aed$var$X.fnc(G) ? G(I.target, I.id, I.total) : G;
}
function $e60bcd291a6e9aed$var$Ig(G, I) {
    return G.getAttribute(I);
}
function $e60bcd291a6e9aed$var$Pg(G, I, g) {
    var C = $e60bcd291a6e9aed$var$Gg(I);
    if ($e60bcd291a6e9aed$var$jg([
        g,
        "deg",
        "rad",
        "turn"
    ], C)) return I;
    var l = $e60bcd291a6e9aed$var$Yg.CSS[I + g];
    if (!$e60bcd291a6e9aed$var$X.und(l)) return l;
    var A = 100, B = document.createElement(G.tagName), o = G.parentNode && G.parentNode !== document ? G.parentNode : document.body;
    o.appendChild(B), B.style.position = "absolute", B.style.width = A + g;
    var i = A / B.offsetWidth;
    o.removeChild(B);
    var Z = i * parseFloat(I);
    return $e60bcd291a6e9aed$var$Yg.CSS[I + g] = Z, Z;
}
function $e60bcd291a6e9aed$var$dC(G, I, g) {
    if (I in G.style) {
        var C = I.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), l = G.style[I] || getComputedStyle(G).getPropertyValue(C) || "0";
        return g ? $e60bcd291a6e9aed$var$Pg(G, l, g) : l;
    }
}
function $e60bcd291a6e9aed$var$qg(G, I) {
    if ($e60bcd291a6e9aed$var$X.dom(G) && !$e60bcd291a6e9aed$var$X.inp(G) && (!$e60bcd291a6e9aed$var$X.nil($e60bcd291a6e9aed$var$Ig(G, I)) || $e60bcd291a6e9aed$var$X.svg(G) && G[I])) return "attribute";
    if ($e60bcd291a6e9aed$var$X.dom(G) && $e60bcd291a6e9aed$var$jg($e60bcd291a6e9aed$var$hl, I)) return "transform";
    if ($e60bcd291a6e9aed$var$X.dom(G) && I !== "transform" && $e60bcd291a6e9aed$var$dC(G, I)) return "css";
    if (G[I] != null) return "object";
}
function $e60bcd291a6e9aed$var$cC(G) {
    if ($e60bcd291a6e9aed$var$X.dom(G)) {
        for(var I = G.style.transform || "", g = /(\w+)\(([^)]*)\)/g, C = /* @__PURE__ */ new Map(), l; l = g.exec(I);)C.set(l[1], l[2]);
        return C;
    }
}
function $e60bcd291a6e9aed$var$Xl(G, I, g, C) {
    var l = $e60bcd291a6e9aed$var$ng(I, "scale") ? 1 : 0 + $e60bcd291a6e9aed$var$tl(I), A = $e60bcd291a6e9aed$var$cC(G).get(I) || l;
    return g && (g.transforms.list.set(I, A), g.transforms.last = I), C ? $e60bcd291a6e9aed$var$Pg(G, A, C) : A;
}
function $e60bcd291a6e9aed$var$Og(G, I, g, C) {
    switch($e60bcd291a6e9aed$var$qg(G, I)){
        case "transform":
            return $e60bcd291a6e9aed$var$Xl(G, I, C, g);
        case "css":
            return $e60bcd291a6e9aed$var$dC(G, I, g);
        case "attribute":
            return $e60bcd291a6e9aed$var$Ig(G, I);
        default:
            return G[I] || 0;
    }
}
function $e60bcd291a6e9aed$var$_g(G, I) {
    var g = /^(\*=|\+=|-=)/.exec(G);
    if (!g) return G;
    var C = $e60bcd291a6e9aed$var$Gg(G) || 0, l = parseFloat(I), A = parseFloat(G.replace(g[0], ""));
    switch(g[0][0]){
        case "+":
            return l + A + C;
        case "-":
            return l - A + C;
        case "*":
            return l * A + C;
    }
}
function $e60bcd291a6e9aed$var$oC(G, I) {
    if ($e60bcd291a6e9aed$var$X.col(G)) return $e60bcd291a6e9aed$var$nl(G);
    if (/\s/g.test(G)) return G;
    var g = $e60bcd291a6e9aed$var$Gg(G), C = g ? G.substr(0, G.length - g.length) : G;
    return I ? C + I : C;
}
function $e60bcd291a6e9aed$var$$g(G, I) {
    return Math.sqrt(Math.pow(I.x - G.x, 2) + Math.pow(I.y - G.y, 2));
}
function $e60bcd291a6e9aed$var$Vl(G) {
    return Math.PI * 2 * $e60bcd291a6e9aed$var$Ig(G, "r");
}
function $e60bcd291a6e9aed$var$Hl(G) {
    return $e60bcd291a6e9aed$var$Ig(G, "width") * 2 + $e60bcd291a6e9aed$var$Ig(G, "height") * 2;
}
function $e60bcd291a6e9aed$var$Sl(G) {
    return $e60bcd291a6e9aed$var$$g({
        x: $e60bcd291a6e9aed$var$Ig(G, "x1"),
        y: $e60bcd291a6e9aed$var$Ig(G, "y1")
    }, {
        x: $e60bcd291a6e9aed$var$Ig(G, "x2"),
        y: $e60bcd291a6e9aed$var$Ig(G, "y2")
    });
}
function $e60bcd291a6e9aed$var$bC(G) {
    for(var I = G.points, g = 0, C, l = 0; l < I.numberOfItems; l++){
        var A = I.getItem(l);
        l > 0 && (g += $e60bcd291a6e9aed$var$$g(C, A)), C = A;
    }
    return g;
}
function $e60bcd291a6e9aed$var$pl(G) {
    var I = G.points;
    return $e60bcd291a6e9aed$var$bC(G) + $e60bcd291a6e9aed$var$$g(I.getItem(I.numberOfItems - 1), I.getItem(0));
}
function $e60bcd291a6e9aed$var$ZC(G) {
    if (G.getTotalLength) return G.getTotalLength();
    switch(G.tagName.toLowerCase()){
        case "circle":
            return $e60bcd291a6e9aed$var$Vl(G);
        case "rect":
            return $e60bcd291a6e9aed$var$Hl(G);
        case "line":
            return $e60bcd291a6e9aed$var$Sl(G);
        case "polyline":
            return $e60bcd291a6e9aed$var$bC(G);
        case "polygon":
            return $e60bcd291a6e9aed$var$pl(G);
    }
}
function $e60bcd291a6e9aed$var$Yl(G) {
    var I = $e60bcd291a6e9aed$var$ZC(G);
    return G.setAttribute("stroke-dasharray", I), I;
}
function $e60bcd291a6e9aed$var$Kl(G) {
    for(var I = G.parentNode; $e60bcd291a6e9aed$var$X.svg(I) && $e60bcd291a6e9aed$var$X.svg(I.parentNode);)I = I.parentNode;
    return I;
}
function $e60bcd291a6e9aed$var$aC(G, I) {
    var g = I || {}, C = g.el || $e60bcd291a6e9aed$var$Kl(G), l = C.getBoundingClientRect(), A = $e60bcd291a6e9aed$var$Ig(C, "viewBox"), B = l.width, o = l.height, i = g.viewBox || (A ? A.split(" ") : [
        0,
        0,
        B,
        o
    ]);
    return {
        el: C,
        viewBox: i,
        x: i[0] / 1,
        y: i[1] / 1,
        w: B,
        h: o,
        vW: i[2],
        vH: i[3]
    };
}
function $e60bcd291a6e9aed$var$Rl(G, I) {
    var g = $e60bcd291a6e9aed$var$X.str(G) ? $e60bcd291a6e9aed$var$iC(G)[0] : G, C = I || 100;
    return function(l) {
        return {
            property: l,
            el: g,
            svg: $e60bcd291a6e9aed$var$aC(g),
            totalLength: $e60bcd291a6e9aed$var$ZC(g) * (C / 100)
        };
    };
}
function $e60bcd291a6e9aed$var$wl(G, I, g) {
    function C(b) {
        b === void 0 && (b = 0);
        var a = I + b >= 1 ? I + b : 0;
        return G.el.getPointAtLength(a);
    }
    var l = $e60bcd291a6e9aed$var$aC(G.el, G.svg), A = C(), B = C(-1), o = C(1), i = g ? 1 : l.w / l.vW, Z = g ? 1 : l.h / l.vH;
    switch(G.property){
        case "x":
            return (A.x - l.x) * i;
        case "y":
            return (A.y - l.y) * Z;
        case "angle":
            return Math.atan2(o.y - B.y, o.x - B.x) * 180 / Math.PI;
    }
}
function $e60bcd291a6e9aed$var$ZI(G, I) {
    var g = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g, C = $e60bcd291a6e9aed$var$oC($e60bcd291a6e9aed$var$X.pth(G) ? G.totalLength : G, I) + "";
    return {
        original: C,
        numbers: C.match(g) ? C.match(g).map(Number) : [
            0
        ],
        strings: $e60bcd291a6e9aed$var$X.str(G) || I ? C.split(g) : []
    };
}
function $e60bcd291a6e9aed$var$gI(G) {
    var I = G ? $e60bcd291a6e9aed$var$Lg($e60bcd291a6e9aed$var$X.arr(G) ? G.map($e60bcd291a6e9aed$var$bI) : $e60bcd291a6e9aed$var$bI(G)) : [];
    return $e60bcd291a6e9aed$var$wg(I, function(g, C, l) {
        return l.indexOf(g) === C;
    });
}
function $e60bcd291a6e9aed$var$mC(G) {
    var I = $e60bcd291a6e9aed$var$gI(G);
    return I.map(function(g, C) {
        return {
            target: g,
            id: C,
            total: I.length,
            transforms: {
                list: $e60bcd291a6e9aed$var$cC(g)
            }
        };
    });
}
function $e60bcd291a6e9aed$var$Ll(G, I) {
    var g = $e60bcd291a6e9aed$var$fg(I);
    if (/^spring/.test(g.easing) && (g.duration = $e60bcd291a6e9aed$var$GC(g.easing)), $e60bcd291a6e9aed$var$X.arr(G)) {
        var C = G.length, l = C === 2 && !$e60bcd291a6e9aed$var$X.obj(G[0]);
        l ? G = {
            value: G
        } : $e60bcd291a6e9aed$var$X.fnc(I.duration) || (g.duration = I.duration / C);
    }
    var A = $e60bcd291a6e9aed$var$X.arr(G) ? G : [
        G
    ];
    return A.map(function(B, o) {
        var i = $e60bcd291a6e9aed$var$X.obj(B) && !$e60bcd291a6e9aed$var$X.pth(B) ? B : {
            value: B
        };
        return $e60bcd291a6e9aed$var$X.und(i.delay) && (i.delay = o ? 0 : I.delay), $e60bcd291a6e9aed$var$X.und(i.endDelay) && (i.endDelay = o === A.length - 1 ? I.endDelay : 0), i;
    }).map(function(B) {
        return $e60bcd291a6e9aed$var$Fg(B, g);
    });
}
function $e60bcd291a6e9aed$var$Fl(G) {
    for(var I = $e60bcd291a6e9aed$var$wg($e60bcd291a6e9aed$var$Lg(G.map(function(A) {
        return Object.keys(A);
    })), function(A) {
        return $e60bcd291a6e9aed$var$X.key(A);
    }).reduce(function(A, B) {
        return A.indexOf(B) < 0 && A.push(B), A;
    }, []), g = {}, C = function(A) {
        var B = I[A];
        g[B] = G.map(function(o) {
            var i = {};
            for(var Z in o)$e60bcd291a6e9aed$var$X.key(Z) ? Z == B && (i.value = o[Z]) : i[Z] = o[Z];
            return i;
        });
    }, l = 0; l < I.length; l++)C(l);
    return g;
}
function $e60bcd291a6e9aed$var$Jl(G, I) {
    var g = [], C = I.keyframes;
    C && (I = $e60bcd291a6e9aed$var$Fg($e60bcd291a6e9aed$var$Fl(C), I));
    for(var l in I)$e60bcd291a6e9aed$var$X.key(l) && g.push({
        name: l,
        tweens: $e60bcd291a6e9aed$var$Ll(I[l], G)
    });
    return g;
}
function $e60bcd291a6e9aed$var$Nl(G, I) {
    var g = {};
    for(var C in G){
        var l = $e60bcd291a6e9aed$var$Dg(G[C], I);
        $e60bcd291a6e9aed$var$X.arr(l) && (l = l.map(function(A) {
            return $e60bcd291a6e9aed$var$Dg(A, I);
        }), l.length === 1 && (l = l[0])), g[C] = l;
    }
    return g.duration = parseFloat(g.duration), g.delay = parseFloat(g.delay), g;
}
function $e60bcd291a6e9aed$var$vl(G, I) {
    var g;
    return G.tweens.map(function(C) {
        var l = $e60bcd291a6e9aed$var$Nl(C, I), A = l.value, B = $e60bcd291a6e9aed$var$X.arr(A) ? A[1] : A, o = $e60bcd291a6e9aed$var$Gg(B), i = $e60bcd291a6e9aed$var$Og(I.target, G.name, o, I), Z = g ? g.to.original : i, b = $e60bcd291a6e9aed$var$X.arr(A) ? A[0] : Z, a = $e60bcd291a6e9aed$var$Gg(b) || $e60bcd291a6e9aed$var$Gg(i), m = o || a;
        return $e60bcd291a6e9aed$var$X.und(B) && (B = Z), l.from = $e60bcd291a6e9aed$var$ZI(b, m), l.to = $e60bcd291a6e9aed$var$ZI($e60bcd291a6e9aed$var$_g(B, b), m), l.start = g ? g.end : 0, l.end = l.start + l.delay + l.duration + l.endDelay, l.easing = $e60bcd291a6e9aed$var$Eg(l.easing, l.duration), l.isPath = $e60bcd291a6e9aed$var$X.pth(A), l.isPathTargetInsideSVG = l.isPath && $e60bcd291a6e9aed$var$X.svg(I.target), l.isColor = $e60bcd291a6e9aed$var$X.col(l.from.original), l.isColor && (l.round = 1), g = l, l;
    });
}
var $e60bcd291a6e9aed$var$hC = {
    css: function(G, I, g) {
        return G.style[I] = g;
    },
    attribute: function(G, I, g) {
        return G.setAttribute(I, g);
    },
    object: function(G, I, g) {
        return G[I] = g;
    },
    transform: function(G, I, g, C, l) {
        if (C.list.set(I, g), I === C.last || l) {
            var A = "";
            C.list.forEach(function(B, o) {
                A += o + "(" + B + ") ";
            }), G.style.transform = A;
        }
    }
};
function $e60bcd291a6e9aed$var$eC(G, I) {
    var g = $e60bcd291a6e9aed$var$mC(G);
    g.forEach(function(C) {
        for(var l in I){
            var A = $e60bcd291a6e9aed$var$Dg(I[l], C), B = C.target, o = $e60bcd291a6e9aed$var$Gg(A), i = $e60bcd291a6e9aed$var$Og(B, l, o, C), Z = o || $e60bcd291a6e9aed$var$Gg(i), b = $e60bcd291a6e9aed$var$_g($e60bcd291a6e9aed$var$oC(A, Z), i), a = $e60bcd291a6e9aed$var$qg(B, l);
            $e60bcd291a6e9aed$var$hC[a](B, l, b, C.transforms, !0);
        }
    });
}
function $e60bcd291a6e9aed$var$rl(G, I) {
    var g = $e60bcd291a6e9aed$var$qg(G.target, I.name);
    if (g) {
        var C = $e60bcd291a6e9aed$var$vl(I, G), l = C[C.length - 1];
        return {
            type: g,
            property: I.name,
            animatable: G,
            tweens: C,
            duration: l.end,
            delay: C[0].delay,
            endDelay: l.endDelay
        };
    }
}
function $e60bcd291a6e9aed$var$kl(G, I) {
    return $e60bcd291a6e9aed$var$wg($e60bcd291a6e9aed$var$Lg(G.map(function(g) {
        return I.map(function(C) {
            return $e60bcd291a6e9aed$var$rl(g, C);
        });
    })), function(g) {
        return !$e60bcd291a6e9aed$var$X.und(g);
    });
}
function $e60bcd291a6e9aed$var$sC(G, I) {
    var g = G.length, C = function(A) {
        return A.timelineOffset ? A.timelineOffset : 0;
    }, l = {};
    return l.duration = g ? Math.max.apply(Math, G.map(function(A) {
        return C(A) + A.duration;
    })) : I.duration, l.delay = g ? Math.min.apply(Math, G.map(function(A) {
        return C(A) + A.delay;
    })) : I.delay, l.endDelay = g ? l.duration - Math.max.apply(Math, G.map(function(A) {
        return C(A) + A.duration - A.endDelay;
    })) : I.endDelay, l;
}
var $e60bcd291a6e9aed$var$aI = 0;
function $e60bcd291a6e9aed$var$zl(G) {
    var I = $e60bcd291a6e9aed$var$Ug($e60bcd291a6e9aed$var$lC, G), g = $e60bcd291a6e9aed$var$Ug($e60bcd291a6e9aed$var$xg, G), C = $e60bcd291a6e9aed$var$Jl(g, G), l = $e60bcd291a6e9aed$var$mC(G.targets), A = $e60bcd291a6e9aed$var$kl(l, C), B = $e60bcd291a6e9aed$var$sC(A, g), o = $e60bcd291a6e9aed$var$aI;
    return $e60bcd291a6e9aed$var$aI++, $e60bcd291a6e9aed$var$Fg(I, {
        id: o,
        children: [],
        animatables: l,
        animations: A,
        duration: B.duration,
        delay: B.delay,
        endDelay: B.endDelay
    });
}
var $e60bcd291a6e9aed$var$O = [], $e60bcd291a6e9aed$var$yC = function() {
    var G;
    function I() {
        !G && (!$e60bcd291a6e9aed$var$mI() || !$e60bcd291a6e9aed$var$V.suspendWhenDocumentHidden) && $e60bcd291a6e9aed$var$O.length > 0 && (G = requestAnimationFrame(g));
    }
    function g(l) {
        for(var A = $e60bcd291a6e9aed$var$O.length, B = 0; B < A;){
            var o = $e60bcd291a6e9aed$var$O[B];
            o.paused ? ($e60bcd291a6e9aed$var$O.splice(B, 1), A--) : (o.tick(l), B++);
        }
        G = B > 0 ? requestAnimationFrame(g) : void 0;
    }
    function C() {
        $e60bcd291a6e9aed$var$V.suspendWhenDocumentHidden && ($e60bcd291a6e9aed$var$mI() ? G = cancelAnimationFrame(G) : ($e60bcd291a6e9aed$var$O.forEach(function(l) {
            return l._onDocumentVisibility();
        }), $e60bcd291a6e9aed$var$yC()));
    }
    return typeof document < "u" && document.addEventListener("visibilitychange", C), I;
}();
function $e60bcd291a6e9aed$var$mI() {
    return !!document && document.hidden;
}
function $e60bcd291a6e9aed$var$V(G) {
    G === void 0 && (G = {});
    var I = 0, g = 0, C = 0, l, A = 0, B = null;
    function o(h) {
        var n = window.Promise && new Promise(function(H) {
            return B = H;
        });
        return h.finished = n, n;
    }
    var i = $e60bcd291a6e9aed$var$zl(G);
    o(i);
    function Z() {
        var h = i.direction;
        h !== "alternate" && (i.direction = h !== "normal" ? "normal" : "reverse"), i.reversed = !i.reversed, l.forEach(function(n) {
            return n.reversed = i.reversed;
        });
    }
    function b(h) {
        return i.reversed ? i.duration - h : h;
    }
    function a() {
        I = 0, g = b(i.currentTime) * (1 / $e60bcd291a6e9aed$var$V.speed);
    }
    function m(h, n) {
        n && n.seek(h - n.timelineOffset);
    }
    function e(h) {
        if (i.reversePlayback) for(var H = A; H--;)m(h, l[H]);
        else for(var n = 0; n < A; n++)m(h, l[n]);
    }
    function s(h) {
        for(var n = 0, H = i.animations, F = H.length; n < F;){
            var p = H[n], f = p.animatable, dg = p.tweens, Bg = dg.length - 1, R = dg[Bg];
            Bg && (R = $e60bcd291a6e9aed$var$wg(dg, function(Bl) {
                return h < Bl.end;
            })[0] || R);
            for(var E = $e60bcd291a6e9aed$var$gg(h - R.start - R.delay, 0, R.duration) / R.duration, _ = isNaN(E) ? 1 : R.easing(E), P = R.to.strings, Ng = R.round, vg = [], Gl = R.to.numbers.length, Zg = void 0, mg = 0; mg < Gl; mg++){
                var hg = void 0, lI = R.to.numbers[mg], AI = R.from.numbers[mg] || 0;
                R.isPath ? hg = $e60bcd291a6e9aed$var$wl(R.value, _ * lI, R.isPathTargetInsideSVG) : hg = AI + _ * (lI - AI), Ng && (R.isColor && mg > 2 || (hg = Math.round(hg * Ng) / Ng)), vg.push(hg);
            }
            var GI = P.length;
            if (!GI) Zg = vg[0];
            else {
                Zg = P[0];
                for(var eg = 0; eg < GI; eg++){
                    P[eg];
                    var BI = P[eg + 1], rg = vg[eg];
                    isNaN(rg) || (BI ? Zg += rg + BI : Zg += rg + " ");
                }
            }
            $e60bcd291a6e9aed$var$hC[p.type](f.target, p.property, Zg, f.transforms), p.currentValue = Zg, n++;
        }
    }
    function u(h) {
        i[h] && !i.passThrough && i[h](i);
    }
    function W() {
        i.remaining && i.remaining !== !0 && i.remaining--;
    }
    function y(h) {
        var n = i.duration, H = i.delay, F = n - i.endDelay, p = b(h);
        i.progress = $e60bcd291a6e9aed$var$gg(p / n * 100, 0, 100), i.reversePlayback = p < i.currentTime, l && e(p), !i.began && i.currentTime > 0 && (i.began = !0, u("begin")), !i.loopBegan && i.currentTime > 0 && (i.loopBegan = !0, u("loopBegin")), p <= H && i.currentTime !== 0 && s(0), (p >= F && i.currentTime !== n || !n) && s(n), p > H && p < F ? (i.changeBegan || (i.changeBegan = !0, i.changeCompleted = !1, u("changeBegin")), u("change"), s(p)) : i.changeBegan && (i.changeCompleted = !0, i.changeBegan = !1, u("changeComplete")), i.currentTime = $e60bcd291a6e9aed$var$gg(p, 0, n), i.began && u("update"), h >= n && (g = 0, W(), i.remaining ? (I = C, u("loopComplete"), i.loopBegan = !1, i.direction === "alternate" && Z()) : (i.paused = !0, i.completed || (i.completed = !0, u("loopComplete"), u("complete"), !i.passThrough && "Promise" in window && (B(), o(i)))));
    }
    return i.reset = function() {
        var h = i.direction;
        i.passThrough = !1, i.currentTime = 0, i.progress = 0, i.paused = !0, i.began = !1, i.loopBegan = !1, i.changeBegan = !1, i.completed = !1, i.changeCompleted = !1, i.reversePlayback = !1, i.reversed = h === "reverse", i.remaining = i.loop, l = i.children, A = l.length;
        for(var n = A; n--;)i.children[n].reset();
        (i.reversed && i.loop !== !0 || h === "alternate" && i.loop === 1) && i.remaining++, s(i.reversed ? i.duration : 0);
    }, i._onDocumentVisibility = a, i.set = function(h, n) {
        return $e60bcd291a6e9aed$var$eC(h, n), i;
    }, i.tick = function(h) {
        C = h, I || (I = C), y((C + (g - I)) * $e60bcd291a6e9aed$var$V.speed);
    }, i.seek = function(h) {
        y(b(h));
    }, i.pause = function() {
        i.paused = !0, a();
    }, i.play = function() {
        i.paused && (i.completed && i.reset(), i.paused = !1, $e60bcd291a6e9aed$var$O.push(i), a(), $e60bcd291a6e9aed$var$yC());
    }, i.reverse = function() {
        Z(), i.completed = !i.reversed, a();
    }, i.restart = function() {
        i.reset(), i.play();
    }, i.remove = function(h) {
        var n = $e60bcd291a6e9aed$var$gI(h);
        $e60bcd291a6e9aed$var$uC(n, i);
    }, i.reset(), i.autoplay && i.play(), i;
}
function $e60bcd291a6e9aed$var$hI(G, I) {
    for(var g = I.length; g--;)$e60bcd291a6e9aed$var$jg(G, I[g].animatable.target) && I.splice(g, 1);
}
function $e60bcd291a6e9aed$var$uC(G, I) {
    var g = I.animations, C = I.children;
    $e60bcd291a6e9aed$var$hI(G, g);
    for(var l = C.length; l--;){
        var A = C[l], B = A.animations;
        $e60bcd291a6e9aed$var$hI(G, B), !B.length && !A.children.length && C.splice(l, 1);
    }
    !g.length && !C.length && I.pause();
}
function $e60bcd291a6e9aed$var$Ml(G) {
    for(var I = $e60bcd291a6e9aed$var$gI(G), g = $e60bcd291a6e9aed$var$O.length; g--;){
        var C = $e60bcd291a6e9aed$var$O[g];
        $e60bcd291a6e9aed$var$uC(I, C);
    }
}
function $e60bcd291a6e9aed$var$Ql(G, I) {
    I === void 0 && (I = {});
    var g = I.direction || "normal", C = I.easing ? $e60bcd291a6e9aed$var$Eg(I.easing) : null, l = I.grid, A = I.axis, B = I.from || 0, o = B === "first", i = B === "center", Z = B === "last", b = $e60bcd291a6e9aed$var$X.arr(G), a = parseFloat(b ? G[0] : G), m = b ? parseFloat(G[1]) : 0, e = $e60bcd291a6e9aed$var$Gg(b ? G[1] : G) || 0, s = I.start || 0 + (b ? a : 0), u = [], W = 0;
    return function(y, h, n) {
        if (o && (B = 0), i && (B = (n - 1) / 2), Z && (B = n - 1), !u.length) {
            for(var H = 0; H < n; H++){
                if (!l) u.push(Math.abs(B - H));
                else {
                    var F = i ? (l[0] - 1) / 2 : B % l[0], p = i ? (l[1] - 1) / 2 : Math.floor(B / l[0]), f = H % l[0], dg = Math.floor(H / l[0]), Bg = F - f, R = p - dg, E = Math.sqrt(Bg * Bg + R * R);
                    A === "x" && (E = -Bg), A === "y" && (E = -R), u.push(E);
                }
                W = Math.max.apply(Math, u);
            }
            C && (u = u.map(function(P) {
                return C(P / W) * W;
            })), g === "reverse" && (u = u.map(function(P) {
                return A ? P < 0 ? P * -1 : -P : Math.abs(W - P);
            }));
        }
        var _ = b ? (m - a) / W : a;
        return s + _ * (Math.round(u[h] * 100) / 100) + e;
    };
}
function $e60bcd291a6e9aed$var$Ul(G) {
    G === void 0 && (G = {});
    var I = $e60bcd291a6e9aed$var$V(G);
    return I.duration = 0, I.add = function(g, C) {
        var l = $e60bcd291a6e9aed$var$O.indexOf(I), A = I.children;
        l > -1 && $e60bcd291a6e9aed$var$O.splice(l, 1);
        function B(m) {
            m.passThrough = !0;
        }
        for(var o = 0; o < A.length; o++)B(A[o]);
        var i = $e60bcd291a6e9aed$var$Fg(g, $e60bcd291a6e9aed$var$Ug($e60bcd291a6e9aed$var$xg, G));
        i.targets = i.targets || G.targets;
        var Z = I.duration;
        i.autoplay = !1, i.direction = I.direction, i.timelineOffset = $e60bcd291a6e9aed$var$X.und(C) ? Z : $e60bcd291a6e9aed$var$_g(C, Z), B(I), I.seek(i.timelineOffset);
        var b = $e60bcd291a6e9aed$var$V(i);
        B(b), A.push(b);
        var a = $e60bcd291a6e9aed$var$sC(A, G);
        return I.delay = a.delay, I.endDelay = a.endDelay, I.duration = a.duration, I.seek(0), I.reset(), I.autoplay && I.play(), I;
    }, I;
}
$e60bcd291a6e9aed$var$V.version = "3.2.1";
$e60bcd291a6e9aed$var$V.speed = 1;
$e60bcd291a6e9aed$var$V.suspendWhenDocumentHidden = !0;
$e60bcd291a6e9aed$var$V.running = $e60bcd291a6e9aed$var$O;
$e60bcd291a6e9aed$var$V.remove = $e60bcd291a6e9aed$var$Ml;
$e60bcd291a6e9aed$var$V.get = $e60bcd291a6e9aed$var$Og;
$e60bcd291a6e9aed$var$V.set = $e60bcd291a6e9aed$var$eC;
$e60bcd291a6e9aed$var$V.convertPx = $e60bcd291a6e9aed$var$Pg;
$e60bcd291a6e9aed$var$V.path = $e60bcd291a6e9aed$var$Rl;
$e60bcd291a6e9aed$var$V.setDashoffset = $e60bcd291a6e9aed$var$Yl;
$e60bcd291a6e9aed$var$V.stagger = $e60bcd291a6e9aed$var$Ql;
$e60bcd291a6e9aed$var$V.timeline = $e60bcd291a6e9aed$var$Ul;
$e60bcd291a6e9aed$var$V.easing = $e60bcd291a6e9aed$var$Eg;
$e60bcd291a6e9aed$var$V.penner = $e60bcd291a6e9aed$var$BC;
$e60bcd291a6e9aed$var$V.random = function(G, I) {
    return Math.floor(Math.random() * (I - G + 1)) + G;
};
const $e60bcd291a6e9aed$var$Dl = {
    fast: 2
}, $e60bcd291a6e9aed$var$Tl = {
    short: 150
}, $e60bcd291a6e9aed$var$WC = [
    "eyeBlinkLeft",
    "eyeBlinkRight"
], $e60bcd291a6e9aed$var$xl = [
    "Eye_Blink_L",
    "Eye_Blink_R"
];
class $e60bcd291a6e9aed$export$9a8101b0ef6e4fc {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "_morphTargets");
        $e60bcd291a6e9aed$var$c(this, "_blinkAnime", null);
        $e60bcd291a6e9aed$var$c(this, "_blink", {
            value: 0
        });
        $e60bcd291a6e9aed$var$c(this, "_started", !1);
        $e60bcd291a6e9aed$var$c(this, "duration");
        $e60bcd291a6e9aed$var$c(this, "blinkSpeed");
        this._morphTargets = (I == null ? void 0 : I.morphTargets) || [], this.duration = (I == null ? void 0 : I.blinkDuration) ?? $e60bcd291a6e9aed$var$Tl.short, this.blinkSpeed = (I == null ? void 0 : I.blinkSpeed) ?? $e60bcd291a6e9aed$var$Dl.fast, this.start();
    }
    _initAnimation() {
        const I = this;
        function g() {
            const C = 0.75 + Math.random() * 0.2, l = I.duration * 0.75 + Math.random() * (I.duration * 0.5);
            I._blinkAnime = $e60bcd291a6e9aed$var$V({
                targets: [
                    I._blink
                ],
                keyframes: [
                    {
                        value: C,
                        duration: l * 1 / 2,
                        easing: "easeInQuad"
                    },
                    // Return to 0 in 100ms
                    {
                        value: C,
                        duration: l * 1 / 2,
                        easing: "linear"
                    },
                    // Stay at target for 2 seconds
                    {
                        value: 0,
                        duration: l * 1 / 2,
                        easing: "easeOutQuad"
                    }
                ],
                duration: I.duration,
                delay: (Math.random() * I.blinkSpeed + I.blinkSpeed) * 1e3,
                loop: !1,
                complete: g
            });
        }
        g();
    }
    start() {
        this._started = !0, this._initAnimation();
    }
    stop() {
        var I;
        (I = this._blinkAnime) == null || I.pause(), this._blinkAnime = null, this._blink = {
            value: 0
        }, this._started = !1;
    }
    update(I) {
        var C;
        const g = [];
        return this._started && ((C = this._blinkAnime) == null || C.tick(I), this._morphTargets.forEach((l)=>{
            g.push({
                name: l,
                value: 0.05 + this._blink.value
            });
        })), g;
    }
}
class $e60bcd291a6e9aed$export$ba3ec05c1c74c275 {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "_morphTargets");
        $e60bcd291a6e9aed$var$c(this, "_mesh");
        $e60bcd291a6e9aed$var$c(this, "_startTimeMs", 0);
        $e60bcd291a6e9aed$var$c(this, "_visemeIntensity", 1);
        $e60bcd291a6e9aed$var$c(this, "_duration", 200);
        $e60bcd291a6e9aed$var$c(this, "_durationThreshold", 0.04);
        $e60bcd291a6e9aed$var$c(this, "_visemeDataArray", []);
        $e60bcd291a6e9aed$var$c(this, "_segments", []);
        $e60bcd291a6e9aed$var$c(this, "_currentSegmentIndex", 0);
        $e60bcd291a6e9aed$var$c(this, "_timeout", null);
        $e60bcd291a6e9aed$var$c(this, "_type");
        /** Cached references to SkinnedMesh nodes that have morphTargetDictionary. */ $e60bcd291a6e9aed$var$c(this, "_skinnedMeshes", []);
        /**
     * Pending morph-target values computed during update().
     * Instead of writing directly to morphTargetInfluences, values are stored
     * here and later consumed by the GlobalManager's MorphTargetAccumulator.
     */ $e60bcd291a6e9aed$var$c(this, "_pendingValues", /* @__PURE__ */ new Map());
        if (this._mesh = I.lipSyncMesh, this._morphTargets = I.lipSyncTargets, I.lipSyncVisemeIntensity) this._visemeIntensity = I.lipSyncVisemeIntensity;
        else switch(I.type){
            case $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.avatarsdk:
                this._visemeIntensity = 0.6;
                break;
            case $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.avaturn:
                this._visemeIntensity = 0.55;
                break;
            case $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.cc3:
            default:
                this._visemeIntensity = 0.6;
                break;
        }
        this._type = I.type, this._resolveSkinnedMeshes();
    }
    // ─────────────────────────────────────────────────────────────────────────────
    // Public API
    // ─────────────────────────────────────────────────────────────────────────────
    update(I) {
        if (!this._segments.length || !this.isStarted) {
            if (this._pendingValues.size > 0) for (const A of this._pendingValues.keys())this._pendingValues.set(A, 0);
            return;
        }
        const g = (performance.now() - this._startTimeMs) / 1e3;
        for(; this._currentSegmentIndex < this._segments.length && g >= this._segments[this._currentSegmentIndex].endSec;)this._currentSegmentIndex++;
        if (this._currentSegmentIndex >= this._segments.length) {
            if (this._pendingValues.size > 0) for (const A of this._pendingValues.keys())this._pendingValues.set(A, 0);
            return;
        }
        const C = this._segments[this._currentSegmentIndex];
        if (g < C.startSec) return;
        const l = (g - C.startSec) / C.duration;
        this._applySegment(C, l);
    }
    start() {
        this._startTimeMs = performance.now(), this._resolveSkinnedMeshes();
    }
    stop() {
        this._startTimeMs = 0, this._visemeDataArray = [], this._segments = [], this._currentSegmentIndex = 0, this._pendingValues.clear();
    }
    /**
   * Return morph-target values computed during the last update() call
   * and clear the internal buffer.  Called by the GlobalManager to feed
   * the MorphTargetAccumulator.
   */ getPendingValues() {
        const I = new Map(this._pendingValues);
        return this._pendingValues.clear(), I;
    }
    get isStarted() {
        return this._startTimeMs !== 0;
    }
    get visemeIntensity() {
        return this._visemeIntensity;
    }
    set visemeIntensity(I) {
        this._visemeIntensity = I;
    }
    /**
   * Add a silence at the end of the speech to get the mouth back in default position after the speech.
   * @param {number} intensity morph target deformation intensity
   */ _triggerTimeoutForLastViseme(I) {
        this._timeout && clearTimeout(this._timeout), this._timeout = setTimeout(()=>{
            this._visemeDataArray[this._visemeDataArray.length - 1] && this.PlayVisemeAsync("sil", this._visemeDataArray[this._visemeDataArray.length - 1].offset + this._duration / 1e3, I, !0);
        }, 1e3);
    }
    async PlayVisemeAsync(I, g, C, l) {
        if (this._morphTargets) {
            const A = this._morphTargets[I], B = C || this._visemeIntensity;
            if (A != null) {
                const i = {
                    data: A.map((b)=>({
                            morphTargetName: b.morphTargetName,
                            value: b.value * B
                        })),
                    offset: l ? g || 0 : (g || 0) / 1e3
                };
                this._visemeDataArray.push(i);
                const Z = this._visemeDataArray.length - 2;
                if (this._visemeDataArray.length > 1) {
                    const b = this._visemeDataArray[Z], a = Z ? this._visemeDataArray[Z - 1] : {
                        data: this._morphTargets.sil,
                        offset: 0
                    }, m = i.offset - b.offset;
                    if (m < this._durationThreshold) this._visemeDataArray.pop();
                    else {
                        const e = m > 1 && I === "sil", s = this._buildSegment(b.offset, b.offset + m, m, [
                            a,
                            b,
                            i
                        ], e);
                        s.targets.size > 0 && this._segments.push(s);
                    }
                }
            }
            !l && this._triggerTimeoutForLastViseme(B);
        }
    }
    // ─────────────────────────────────────────────────────────────────────────────
    // Private helpers
    // ─────────────────────────────────────────────────────────────────────────────
    /** Walk the mesh hierarchy once and cache all SkinnedMesh references. */ _resolveSkinnedMeshes() {
        this._skinnedMeshes = [], this._mesh.traverse((I)=>{
            I.type === "SkinnedMesh" && I.morphTargetDictionary !== void 0 && this._skinnedMeshes.push(I);
        });
    }
    /** Pre-compute a segment with per-mesh, per-morphTarget keyframe data. */ _buildSegment(I, g, C, l, A) {
        const B = A ? [
            0,
            0.25 / C,
            (C - 0.25) / C,
            1
        ] : [
            0,
            0.5,
            1
        ], o = /* @__PURE__ */ new Map();
        for (const i of this._skinnedMeshes){
            const Z = i.morphTargetDictionary, b = [];
            for(let a = 0; a < l[1].data.length; a++){
                const m = l[1].data[a];
                if (!("morphTargetName" in m) || !(m.morphTargetName in Z)) continue;
                const e = A ? [
                    (l[0].data[a].value + m.value) / 2,
                    m.value,
                    m.value,
                    (m.value + l[2].data[a].value) / 2
                ] : [
                    (l[0].data[a].value + m.value) / 2,
                    m.value,
                    (m.value + l[2].data[a].value) / 2
                ];
                Math.max(...e) !== 0 && b.push({
                    morphTargetName: m.morphTargetName,
                    times: B,
                    values: e
                });
            }
            b.length > 0 && o.set(i.name, b);
        }
        return {
            startSec: I,
            endSec: g,
            duration: C,
            targets: o
        };
    }
    /**
   * Interpolate a smooth-step value between keyframes and store in pending values buffer.
   * @param segment The segment to apply.
   * @param tNorm Normalised time within the segment (0–1).
   */ _applySegment(I, g) {
        for (const C of this._skinnedMeshes){
            const l = I.targets.get(C.name);
            if (!l) continue;
            const A = C.morphTargetDictionary;
            for (const B of l){
                if (!(B.morphTargetName in A)) continue;
                const o = B.times, i = B.values;
                let Z;
                if (g <= o[0]) Z = i[0];
                else if (g >= o[o.length - 1]) Z = i[i.length - 1];
                else {
                    let b = 0;
                    for(let e = 0; e < o.length - 1; e++)if (g >= o[e] && g < o[e + 1]) {
                        b = e;
                        break;
                    }
                    const a = (g - o[b]) / (o[b + 1] - o[b]), m = a * a * (3 - 2 * a);
                    Z = i[b] + (i[b + 1] - i[b]) * m;
                }
                this._pendingValues.set(B.morphTargetName, Z);
            }
        }
    }
}
const $e60bcd291a6e9aed$export$6315ee6db616dc28 = [
    {
        name: "eyeBlinkLeft",
        offset: 0,
        scale: 0
    },
    {
        name: "eyeLookDownLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "eyeLookInLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "eyeLookOutLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "eyeLookUpLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "eyeSquintLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "eyeWideLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "eyeBlinkRight",
        offset: 0,
        scale: 0
    },
    {
        name: "eyeLookDownRight",
        offset: 0,
        scale: 1
    },
    {
        name: "eyeLookInRight",
        offset: 0,
        scale: 1
    },
    {
        name: "eyeLookOutRight",
        offset: 0,
        scale: 1
    },
    {
        name: "eyeLookUpRight",
        offset: 0,
        scale: 1
    },
    {
        name: "eyeSquintRight",
        offset: 0,
        scale: 1
    },
    {
        name: "eyeWideRight",
        offset: 0,
        scale: 1
    },
    {
        name: "jawForward",
        offset: 0,
        scale: 1
    },
    {
        name: "jawLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "jawRight",
        offset: 0,
        scale: 1
    },
    {
        name: "jawOpen",
        offset: 0,
        scale: 1.15
    },
    {
        name: "mouthClose",
        offset: 0,
        scale: 1.1
    },
    {
        name: "mouthFunnel",
        offset: 0,
        scale: 1.1
    },
    {
        name: "mouthPucker",
        offset: 0,
        scale: 1.1
    },
    {
        name: "mouthLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthRight",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthSmileLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthSmileRight",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthFrownLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthFrownRight",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthDimpleLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthDimpleRight",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthStretchLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthStretchRight",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthRollLower",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthRollUpper",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthShrugLower",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthShrugUpper",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthPressLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthPressRight",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthLowerDownLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthLowerDownRight",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthUpperUpLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "mouthUpperUpRight",
        offset: 0,
        scale: 1
    },
    {
        name: "browDownLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "browDownRight",
        offset: 0,
        scale: 1
    },
    {
        name: "browInnerUp",
        offset: 0,
        scale: 1
    },
    {
        name: "browOuterUpLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "browOuterUpRight",
        offset: 0,
        scale: 1
    },
    {
        name: "cheekPuff",
        offset: 0,
        scale: 1
    },
    {
        name: "cheekSquintLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "cheekSquintRight",
        offset: 0,
        scale: 1
    },
    {
        name: "noseSneerLeft",
        offset: 0,
        scale: 1
    },
    {
        name: "noseSneerRight",
        offset: 0,
        scale: 1
    },
    {
        name: "tongueOut",
        offset: 0,
        scale: 1
    }
], $e60bcd291a6e9aed$var$Pl = [
    "AvatarHead",
    "AvatarTeethLower"
];
class $e60bcd291a6e9aed$export$a3635db1f361732f {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "_mesh");
        $e60bcd291a6e9aed$var$c(this, "_blendshapeConfigs");
        $e60bcd291a6e9aed$var$c(this, "_configMap");
        $e60bcd291a6e9aed$var$c(this, "_targetMeshNames");
        /** Cached references to the SkinnedMesh nodes we drive (resolved once at start). */ $e60bcd291a6e9aed$var$c(this, "_skinnedMeshes", []);
        /** Wall-clock timestamp (ms) captured on start(), used as time origin. */ $e60bcd291a6e9aed$var$c(this, "_startTimeMs", 0);
        $e60bcd291a6e9aed$var$c(this, "_frames", []);
        $e60bcd291a6e9aed$var$c(this, "_segments", []);
        $e60bcd291a6e9aed$var$c(this, "_currentSegmentIndex", 0);
        /** Exponential moving average factor for temporal smoothing (0 = none, 1 = max). */ $e60bcd291a6e9aed$var$c(this, "_smoothingAlpha");
        /** Last smoothed blendshape values per blendshape name. */ $e60bcd291a6e9aed$var$c(this, "_lastSmoothedValues", /* @__PURE__ */ new Map());
        /** Duration in seconds for the end-of-animation fade-out to zero. */ $e60bcd291a6e9aed$var$c(this, "_fadeOutDurationSec");
        /** True while the post-animation fade-out is running. */ $e60bcd291a6e9aed$var$c(this, "_isFadingOut", !1);
        /** Wall-clock timestamp (ms) when the fade-out started. */ $e60bcd291a6e9aed$var$c(this, "_fadeOutStartMs", 0);
        /** Per-blendshape values captured at the start of the fade-out. */ $e60bcd291a6e9aed$var$c(this, "_fadeOutStartValues", /* @__PURE__ */ new Map());
        /**
     * Pending morph-target values computed during update().
     * Instead of writing directly to morphTargetInfluences, values are stored
     * here and later consumed by the GlobalManager's MorphTargetAccumulator.
     */ $e60bcd291a6e9aed$var$c(this, "_pendingValues", /* @__PURE__ */ new Map());
        this._mesh = I.mesh, this._blendshapeConfigs = I.blendshapeConfigs ?? $e60bcd291a6e9aed$export$6315ee6db616dc28, this._targetMeshNames = I.targetMeshNames ?? $e60bcd291a6e9aed$var$Pl, this._configMap = new Map(this._blendshapeConfigs.map((g)=>[
                g.name,
                g
            ])), this._smoothingAlpha = I.smoothingAlpha ?? 0.5, this._fadeOutDurationSec = I.fadeOutDurationSec ?? 0.3, this._resolveSkinnedMeshes();
    }
    // ─────────────────────────────────────────────────────────────────────────────
    // Public API
    // ─────────────────────────────────────────────────────────────────────────────
    /** Record the current wall-clock time as the playback reference point. Must be called before adding frames. */ start() {
        this._startTimeMs = performance.now(), this._isFadingOut = !1, this._fadeOutStartMs = 0, this._fadeOutStartValues.clear(), this._lastSmoothedValues.clear(), this._resolveSkinnedMeshes();
    }
    /** Stop playback and reset all state. */ stop() {
        this._resetBlendshapes(), this._startTimeMs = 0, this._isFadingOut = !1, this._fadeOutStartMs = 0, this._fadeOutStartValues.clear(), this._frames = [], this._segments = [], this._currentSegmentIndex = 0, this._lastSmoothedValues.clear();
    }
    /**
   * Return morph-target values computed during the last update() call
   * and clear the internal buffer.  Called by the GlobalManager to feed
   * the MorphTargetAccumulator.
   */ getPendingValues() {
        const I = new Map(this._pendingValues);
        return this._pendingValues.clear(), I;
    }
    /** Whether playback has been started (i.e. start() was called). */ get isStarted() {
        return this._startTimeMs !== 0;
    }
    /**
   * Must be called every frame.
   * Interpolates morph target influences directly based on wall-clock time.
   *
   * @param _deltaTime Unused – kept for API compatibility. Timing is derived from performance.now().
   */ update(I) {
        if (this._isFadingOut) {
            const B = (performance.now() - this._fadeOutStartMs) / 1e3;
            if (B >= this._fadeOutDurationSec) this._resetBlendshapes(), this._isFadingOut = !1, this._fadeOutStartValues.clear();
            else {
                const o = B / this._fadeOutDurationSec, i = o * o * (3 - 2 * o);
                this._applyFadeOut(i);
            }
            return;
        }
        if (!this._segments.length || this._currentSegmentIndex >= this._segments.length) return;
        const g = (performance.now() - this._startTimeMs) / 1e3;
        let C = null;
        for(; this._currentSegmentIndex < this._segments.length && g >= this._segments[this._currentSegmentIndex].endSec;)C = this._segments[this._currentSegmentIndex], this._currentSegmentIndex++;
        if (C && this._applySegment(C, 1), this._currentSegmentIndex >= this._segments.length) {
            this._fadeOutDurationSec > 0 ? this._startFadeOut() : this._resetBlendshapes();
            return;
        }
        const l = this._segments[this._currentSegmentIndex];
        if (g < l.startSec) return;
        const A = (g - l.startSec) / l.duration;
        this._applySegment(l, A);
    }
    /**
   * Add a blendshape keyframe. Once a second frame is available the manager
   * automatically creates and schedules a transition segment from the previous
   * frame to this one.
   *
   * @param data Blendshape keyframe data.
   */ async PlayBlendShapeAsync(I) {
        if (this._smoothFrame(I), this._frames.push(I), this._frames.length < 2) return;
        const g = this._frames.length, C = this._frames[g - 2], l = this._frames[g - 1], A = C.timestamp_ms / 1e3 + 0.1, B = l.timestamp_ms / 1e3 + 0.1, o = B - A;
        if (o <= 0) return;
        const i = g >= 3 ? this._frames[g - 3].blendshapes : C.blendshapes, Z = C.blendshapes, b = l.blendshapes, a = l.blendshapes, m = this._buildSegment(A, B, o, i, Z, b, a);
        m.targets.size !== 0 && this._segments.push(m);
    }
    // ─────────────────────────────────────────────────────────────────────────────
    // Private helpers
    // ─────────────────────────────────────────────────────────────────────────────
    /** Walk the mesh hierarchy once and cache all target SkinnedMesh references. */ _resolveSkinnedMeshes() {
        this._skinnedMeshes = [], this._mesh.traverse((I)=>{
            if (I.type === "SkinnedMesh" && this._targetMeshNames.includes(I.name)) {
                const g = I;
                g.morphTargetDictionary && g.morphTargetInfluences && this._skinnedMeshes.push(g);
            }
        });
    }
    /**
   * Apply per-blendshape config (scale + offset) to a raw value.
   * Returns null when the blendshape should be skipped (scale === 0 or unknown).
   */ _applyConfig(I, g) {
        const C = this._configMap.get(I);
        return !C || C.scale === 0 ? null : g * C.scale + C.offset;
    }
    /**
   * Pre-compute a segment with per-mesh, per-blendshape Catmull-Rom control points.
   * p0/p3 provide tangent context; the spline interpolates from p1 → p2.
   */ _buildSegment(I, g, C, l, A, B, o) {
        const i = /* @__PURE__ */ new Set([
            ...Object.keys(A),
            ...Object.keys(B)
        ]), Z = /* @__PURE__ */ new Map();
        for (const b of this._skinnedMeshes){
            const a = b.morphTargetDictionary, m = /* @__PURE__ */ new Map();
            for (const e of i){
                if (!(e in a)) continue;
                const s = this._applyConfig(e, l[e] ?? 0), u = this._applyConfig(e, A[e] ?? 0), W = this._applyConfig(e, B[e] ?? 0), y = this._applyConfig(e, o[e] ?? 0);
                if (u === null && W === null) continue;
                const h = s ?? 0, n = u ?? 0, H = W ?? 0, F = y ?? 0;
                h === 0 && n === 0 && H === 0 && F === 0 || m.set(e, [
                    h,
                    n,
                    H,
                    F
                ]);
            }
            m.size > 0 && Z.set(b.name, m);
        }
        return {
            startSec: I,
            endSec: g,
            duration: C,
            targets: Z
        };
    }
    /**
   * Evaluate a Catmull-Rom spline at parameter t ∈ [0, 1].
   * Interpolates from p1 → p2 with p0 and p3 as tangent guides.
   */ _catmullRom(I, g, C, l, A) {
        const B = I * I, o = B * I;
        return 0.5 * (2 * C + (-g + l) * I + (2 * g - 5 * C + 4 * l - A) * B + (-g + 3 * C - 3 * l + A) * o);
    }
    /**
   * Apply EMA (exponential moving average) smoothing to a frame's blendshape values.
   * Mutates the frame in place. Reduces high-frequency jitter from wav2arkit / similar
   * models to produce more natural, fluid mouth movement.
   */ _smoothFrame(I) {
        if (!(this._smoothingAlpha <= 0)) for (const [g, C] of Object.entries(I.blendshapes)){
            const l = this._lastSmoothedValues.get(g);
            if (l !== void 0) {
                const A = (1 - this._smoothingAlpha) * C + this._smoothingAlpha * l;
                I.blendshapes[g] = A, this._lastSmoothedValues.set(g, A);
            } else this._lastSmoothedValues.set(g, C);
        }
    }
    /**
   * Capture pending values and begin the fade-out phase.
   * Called once the last animation segment has been fully consumed.
   */ _startFadeOut() {
        this._fadeOutStartValues.clear();
        for (const [I, g] of this._pendingValues)g !== 0 && this._fadeOutStartValues.set(I, g);
        this._fadeOutStartMs = performance.now(), this._isFadingOut = !0;
    }
    /**
   * Lerp pending values from their fade-out start values toward zero.
   * @param t Smooth-step progress in [0, 1] (0 = start values, 1 = zero).
   */ _applyFadeOut(I) {
        for (const [g, C] of this._fadeOutStartValues)this._pendingValues.set(g, C * (1 - I));
    }
    /** Set all managed blendshapes to zero in the pending values buffer. */ _resetBlendshapes() {
        for (const [I, g] of this._configMap)g.scale !== 0 && this._pendingValues.set(I, 0);
    }
    /** Compute Catmull-Rom interpolated values and store in pending buffer. */ _applySegment(I, g) {
        for (const C of this._skinnedMeshes){
            const l = I.targets.get(C.name);
            if (l) for (const [A, [B, o, i, Z]] of l)this._pendingValues.set(A, Math.min(1, Math.max(0, this._catmullRom(g, B, o, i, Z))));
        }
    }
}
const $e60bcd291a6e9aed$export$c38d8101a67063f = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 1
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 1
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $e60bcd291a6e9aed$export$ea59c84969665c7c = [], $e60bcd291a6e9aed$export$25fccd43e8196762 = [], $e60bcd291a6e9aed$export$a6fd2d01f226d644 = [
    {
        index: 1,
        strength: 0.36
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0.56
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0.37
    }
], $e60bcd291a6e9aed$export$8f182db482bc89c3 = [], $e60bcd291a6e9aed$export$aeaac050cc876b58 = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0.8
    },
    {
        index: 5,
        strength: 0.3
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0.3
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0.8
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 1
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $e60bcd291a6e9aed$export$a864bdb43284193c = [], $e60bcd291a6e9aed$export$89c815ea520f43f5 = [], $e60bcd291a6e9aed$export$23ccf9b3ad4ad239 = [
    {
        index: 1,
        strength: 1
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 1
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0.8
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $e60bcd291a6e9aed$export$c41b9c59be84ddce = [], $e60bcd291a6e9aed$export$48d40904c00d4f5a = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0.6
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0.6
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 1
    },
    {
        index: 16,
        strength: 1
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $e60bcd291a6e9aed$export$27cb4717cdee4a4f = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 1,
        side: "left"
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $e60bcd291a6e9aed$export$5a483e95b03efb20 = [], $e60bcd291a6e9aed$export$a19619d4461fe6b = [
    {
        index: 1,
        strength: 1
    },
    {
        index: 2,
        strength: 1
    },
    {
        index: 4,
        strength: 1
    },
    {
        index: 5,
        strength: 1
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 1
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 1
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 1
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $e60bcd291a6e9aed$export$dccd303124cb4f61 = [], $e60bcd291a6e9aed$export$30f254f48e313d97 = [], $e60bcd291a6e9aed$export$fc9b767b0b03a2c5 = [
    {
        index: 1,
        strength: 1
    },
    {
        index: 2,
        strength: 1
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 1
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 1
    },
    {
        index: 26,
        strength: 1
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $e60bcd291a6e9aed$export$4a5a17342c52aab5 = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0.8
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 1
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0.4
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $e60bcd291a6e9aed$export$a4867fe9454f37a8 = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $e60bcd291a6e9aed$export$5fd798d8cf720e75 = {
    joy: $e60bcd291a6e9aed$export$c38d8101a67063f,
    anger: $e60bcd291a6e9aed$export$aeaac050cc876b58,
    contempt: $e60bcd291a6e9aed$export$27cb4717cdee4a4f,
    disgust: $e60bcd291a6e9aed$export$48d40904c00d4f5a,
    dislike: $e60bcd291a6e9aed$export$30f254f48e313d97,
    distress: $e60bcd291a6e9aed$export$5a483e95b03efb20,
    fear: $e60bcd291a6e9aed$export$a19619d4461fe6b,
    frustration: $e60bcd291a6e9aed$export$89c815ea520f43f5,
    guilt: $e60bcd291a6e9aed$export$a864bdb43284193c,
    hope: $e60bcd291a6e9aed$export$25fccd43e8196762,
    love: $e60bcd291a6e9aed$export$a6fd2d01f226d644,
    pride: $e60bcd291a6e9aed$export$ea59c84969665c7c,
    regret: $e60bcd291a6e9aed$export$dccd303124cb4f61,
    relief: $e60bcd291a6e9aed$export$8f182db482bc89c3,
    sadness: $e60bcd291a6e9aed$export$23ccf9b3ad4ad239,
    shame: $e60bcd291a6e9aed$export$c41b9c59be84ddce,
    smile: $e60bcd291a6e9aed$export$4a5a17342c52aab5,
    surprise: $e60bcd291a6e9aed$export$fc9b767b0b03a2c5,
    neutral: $e60bcd291a6e9aed$export$a4867fe9454f37a8
}, $e60bcd291a6e9aed$var$mA = [
    1,
    2
], $e60bcd291a6e9aed$var$Mg = [
    5,
    45
], $e60bcd291a6e9aed$var$hA = [
    10,
    12,
    14,
    15,
    16,
    17,
    18,
    20,
    22,
    23,
    24,
    25,
    26,
    28
], $e60bcd291a6e9aed$var$eA = {
    emotion: 0,
    intensity: 0
}, $e60bcd291a6e9aed$var$sA = {
    inner: 0,
    outer: 0
};
class $e60bcd291a6e9aed$export$7520be563876830 {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "_globalManager");
        $e60bcd291a6e9aed$var$c(this, "_actionUnitToMorphTarget");
        $e60bcd291a6e9aed$var$c(this, "_eyesRelatedMorphTargets", []);
        $e60bcd291a6e9aed$var$c(this, "_baseMorphTargetData", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_defaultBaseMorphTargetData", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_alpha", 0.5);
        $e60bcd291a6e9aed$var$c(this, "_parent");
        $e60bcd291a6e9aed$var$c(this, "_defaultIntensity", 50);
        $e60bcd291a6e9aed$var$c(this, "_defaultFadeInDuration", 250);
        $e60bcd291a6e9aed$var$c(this, "_defaultFadeOutDuration", 250);
        $e60bcd291a6e9aed$var$c(this, "_playingFacialAnimation", !1);
        $e60bcd291a6e9aed$var$c(this, "_randomSmileMinIntensity", 10);
        $e60bcd291a6e9aed$var$c(this, "_randomSmileMaxIntensity", 50);
        $e60bcd291a6e9aed$var$c(this, "_currentAction", null);
        $e60bcd291a6e9aed$var$c(this, "_numberOfPlayingActions", 0);
        $e60bcd291a6e9aed$var$c(this, "_releaseBlinkManager", !1);
        $e60bcd291a6e9aed$var$c(this, "_lipsAnime", null);
        $e60bcd291a6e9aed$var$c(this, "_eyeBrowsAnime", null);
        $e60bcd291a6e9aed$var$c(this, "_randomLipsData", $e60bcd291a6e9aed$var$eA);
        $e60bcd291a6e9aed$var$c(this, "_randomEyeBrowsData", $e60bcd291a6e9aed$var$sA);
        $e60bcd291a6e9aed$var$c(this, "_lipsAnimeStopped", !0);
        $e60bcd291a6e9aed$var$c(this, "_eyeBrowsAnimeStopped", !0);
        this._globalManager = I.globalManager, this._parent = I.parent, this._actionUnitToMorphTarget = I.FACS, $e60bcd291a6e9aed$var$Mg.forEach((g)=>{
            var l;
            const C = (l = this._actionUnitToMorphTarget[g]) == null ? void 0 : l.both;
            C && (this._eyesRelatedMorphTargets = [
                ...this._eyesRelatedMorphTargets,
                ...C
            ]);
        }), this._parent.traverse((g)=>{
            if (g.type === "SkinnedMesh" && g.morphTargetDictionary !== void 0) {
                const C = g, l = C.morphTargetDictionary, A = C.morphTargetInfluences;
                l && A != null && A.length && Array.from(Object.keys(l)).forEach((B)=>{
                    C.morphTargetInfluences && C.morphTargetDictionary && (C.morphTargetInfluences[C.morphTargetDictionary[B]] = 0), !this._eyesRelatedMorphTargets.includes(B) && this._defaultBaseMorphTargetData.set(B, 0);
                });
            }
        }), this._baseMorphTargetData = new Map(this._defaultBaseMorphTargetData), this._globalManager.animationMixer.addEventListener("finished", (g)=>{
            g.action.getClip().name.startsWith("actionUnits") && (this._numberOfPlayingActions--, this._numberOfPlayingActions === 0 && (this._playingFacialAnimation = !1, this._releaseBlinkManager && (this._globalManager.eyeBlinkManager.start(), this._releaseBlinkManager = !1)), setTimeout(()=>{
                g.action.stop();
            }, 40));
        });
    }
    _initLipsAnimation() {
        const I = this;
        I._lipsAnimeStopped = !1;
        const g = ()=>{
            I._lipsAnime = $e60bcd291a6e9aed$var$V({
                targets: I._randomLipsData,
                emotion: ()=>0,
                intensity: ()=>Math.round(I._randomSmileMinIntensity + Math.random() * (I._randomSmileMaxIntensity - I._randomSmileMinIntensity)),
                delay: ()=>(0.5 + Math.random() * 2.5) * 1e3,
                duration: $e60bcd291a6e9aed$var$V.random(250, 750),
                autoplay: !0,
                complete: g,
                easing: "linear"
            });
        };
        g();
    }
    _stopLipsAnimation() {
        var C;
        const I = this;
        I._lipsAnimeStopped = !0, (C = I._lipsAnime) == null || C.pause(), I._lipsAnime = null, (()=>{
            I._lipsAnime = $e60bcd291a6e9aed$var$V({
                targets: I._randomLipsData,
                emotion: ()=>0,
                intensity: ()=>0,
                duration: I._defaultFadeOutDuration,
                autoplay: !0,
                complete: ()=>{
                    I._lipsAnime = null;
                },
                easing: "linear"
            });
        })();
    }
    _initEyeBrowsAnimation() {
        const I = this;
        I._eyeBrowsAnimeStopped = !1;
        const g = ()=>{
            I._eyeBrowsAnime = $e60bcd291a6e9aed$var$V({
                targets: I._randomEyeBrowsData,
                inner: ()=>Math.round(Math.random() * 50),
                outer: ()=>Math.round(Math.random() * 50),
                delay: ()=>(0.5 + Math.random() * 1.5) * 1e3,
                duration: $e60bcd291a6e9aed$var$V.random(150, 300),
                autoplay: !0,
                complete: g,
                easing: "linear"
            });
        };
        g();
    }
    _stopEyeBrowsAnimation() {
        var C;
        const I = this;
        I._eyeBrowsAnimeStopped = !0, (C = I._eyeBrowsAnime) == null || C.pause(), I._eyeBrowsAnime = null, (()=>{
            I._eyeBrowsAnime = $e60bcd291a6e9aed$var$V({
                targets: I._randomEyeBrowsData,
                inner: ()=>0,
                outer: ()=>0,
                duration: 200,
                autoplay: !0,
                complete: ()=>{
                    I._eyeBrowsAnime = null;
                },
                easing: "linear"
            });
        })();
    }
    update(I, g, C) {
        var B, o;
        (B = this._lipsAnime) == null || B.tick(I), (o = this._eyeBrowsAnime) == null || o.tick(I);
        const l = [], A = /* @__PURE__ */ new Map();
        if (this._parent.traverse((i)=>{
            if (i.type === "SkinnedMesh" && i.morphTargetDictionary !== void 0) {
                const Z = i.morphTargetDictionary, b = i.morphTargetInfluences;
                Z && b != null && b.length && Array.from(Object.keys(Z)).forEach((a)=>{
                    const m = b[Z[a]];
                    !this._eyesRelatedMorphTargets.includes(a) && A.set(a, m);
                });
            }
        }), g != null && g.length) !this._lipsAnimeStopped && this._stopLipsAnimation(), !this._eyeBrowsAnimeStopped && this._stopEyeBrowsAnimation(), g.forEach((i)=>{
            const Z = this._actionUnitToMorphTarget[i.index], b = i.side && Z[i.side] || Z.both;
            b == null || b.forEach((a)=>{
                const m = A.has(a) && A.get(a) || 0;
                let e = 0;
                const s = i.index === 45 ? 1.5 : 1;
                i.index === 45 ? e = Math.min(s, i.strength) : e = Math.min(s, this._alpha * i.strength + (1 - this._alpha) * m), l.push({
                    name: a,
                    value: e
                });
            });
        });
        else if (this._playingFacialAnimation) !this._lipsAnimeStopped && this._stopLipsAnimation(), !this._eyeBrowsAnimeStopped && this._stopEyeBrowsAnimation(), this._baseMorphTargetData = new Map(A);
        else {
            const i = new Map(this._baseMorphTargetData);
            for (const [Z, b] of i)!Z.toLowerCase().includes("brow") && !Z.toLowerCase().includes("mouth") && i.delete(Z);
            if (C === $e60bcd291a6e9aed$export$f2e6b371e93925c7.speaking) {
                this._eyeBrowsAnimeStopped && this._initEyeBrowsAnimation(), !this._lipsAnimeStopped && this._stopLipsAnimation();
                const Z = [
                    ...i.keys()
                ];
                for (const b of Z)b.toLowerCase().includes("viseme") && i.delete(b);
            } else {
                this._lipsAnimeStopped && this._initLipsAnimation(), !this._eyeBrowsAnimeStopped && this._stopEyeBrowsAnimation();
                const Z = this._randomLipsData.intensity / 100;
                (this._randomLipsData.emotion === 0 ? $e60bcd291a6e9aed$export$4a5a17342c52aab5 : $e60bcd291a6e9aed$export$a4867fe9454f37a8).forEach((a)=>{
                    if ($e60bcd291a6e9aed$var$hA.includes(a.index)) {
                        const m = this._actionUnitToMorphTarget[a.index], e = a.side && m[a.side] || m.both;
                        e == null || e.forEach((s)=>{
                            const u = this._baseMorphTargetData.get(s) || 0, W = A.get(s) || 0, y = (this._alpha * a.strength + (1 - this._alpha) * W) * Z;
                            i.set(s, Math.max(y, u));
                        });
                    }
                });
            }
            $e60bcd291a6e9aed$var$mA.forEach((Z)=>{
                const a = this._actionUnitToMorphTarget[Z].both, m = (Z === 1 ? this._randomEyeBrowsData.inner : this._randomEyeBrowsData.outer) / 100;
                a == null || a.forEach((e)=>{
                    const s = this._baseMorphTargetData.get(e) || 0, u = A.get(e) || 0, W = this._alpha * m + (1 - this._alpha) * u;
                    i.set(e, Math.max(W, s));
                });
            }), Array.from(i).forEach(([Z, b])=>{
                l.push({
                    name: Z,
                    value: b
                });
            });
        }
        return l;
    }
    _handleClip(I, g, C, l) {
        var B;
        const A = this._globalManager.animationMixer.clipAction(I);
        A.setLoop($329ek.LoopOnce, 1), g && (A.clampWhenFinished = !0), C && (this._globalManager.eyeBlinkManager.stop(), this._releaseBlinkManager = !0), A.play(), this._numberOfPlayingActions++, l && ((B = this._currentAction) == null || B.stop()), this._currentAction = A;
    }
    /**
   * Play a single facial animation and keep it or release it after some time.
   * @param {FacialAnimationData} data
   */ playFacialAnimation(I) {
        setTimeout(()=>{
            this._playingFacialAnimation = !0;
            let g = !1;
            const C = [];
            this._parent.traverse((l)=>{
                l.type === "SkinnedMesh" && l.morphTargetDictionary !== void 0 && I.AU.forEach((A)=>{
                    $e60bcd291a6e9aed$var$Mg.includes(A.index) && (g = !0);
                    const B = this._actionUnitToMorphTarget[A.index], o = A.side && B[A.side] || B.both, i = l;
                    o.forEach((Z)=>{
                        if (i.morphTargetDictionary && i.morphTargetInfluences && Z in i.morphTargetDictionary) {
                            const b = i.morphTargetInfluences[i.morphTargetDictionary[Z]], m = [
                                0,
                                (I.fadeInDuration || this._defaultFadeInDuration) / 1e3
                            ];
                            if (I.releaseAfterDuration) {
                                const u = (I.fadeInDuration || this._defaultFadeInDuration) / 1e3 + (I.releaseAfterDuration || 0) / 1e3, W = (I.fadeInDuration || this._defaultFadeInDuration) / 1e3 + (I.fadeOutDuration || this._defaultFadeOutDuration) / 1e3 + (I.releaseAfterDuration || 0) / 1e3;
                                m.push(u, W);
                            }
                            const e = A.strength * (I.intensity || this._defaultIntensity) / 100, s = I.releaseAfterDuration ? [
                                b,
                                e,
                                e,
                                b
                            ] : [
                                b,
                                e
                            ];
                            C.push(new $329ek.NumberKeyframeTrack(`${l.name}.morphTargetInfluences[${Z}]`, m, s, $329ek.InterpolateLinear));
                        }
                    });
                });
            }), this._handleClip(new $329ek.AnimationClip(`actionUnits${Date.now()}`, -1, C, $329ek.NormalAnimationBlendMode), !!I.keepAlive, g, !0);
        }, I.delay || 0);
    }
    /**
   * Process the timeline of the block to get the array of times at which the values will change
   * @param {Timeline} timeline timeline of this block
   * @param {number} strength value to be attained by the related morphtarget
   * @returns {Array<number>}
   */ _processTimeline(I, g) {
        const C = [], l = [];
        return I.start !== void 0 && (I.attackpeak && (C.push(I.attackpeak - I.start), l.push(g)), I.relax && (C.push(I.relax - I.start), l.push(g))), {
            processedTimes: C,
            processedValues: l
        };
    }
    updateFacialAnimation(I, g) {
        this._playingFacialAnimation = !0;
        let C = !1;
        const l = [];
        this._parent.traverse((A)=>{
            A.type === "SkinnedMesh" && A.morphTargetDictionary !== void 0 && I.forEach((B)=>{
                $e60bcd291a6e9aed$var$Mg.includes(B.index) && (C = !0);
                const o = this._actionUnitToMorphTarget[B.index], i = B.side && o[B.side] || o.both, Z = A;
                i.forEach((b)=>{
                    if (Z.morphTargetDictionary && Z.morphTargetInfluences && b in Z.morphTargetDictionary) {
                        const a = Z.morphTargetInfluences[Z.morphTargetDictionary[b]];
                        let m = [], e = [];
                        if (B.shift) {
                            if (B.timeline) {
                                const { processedTimes: s, processedValues: u } = this._processTimeline(B.timeline, B.strength);
                                s.length ? (m = [
                                    0,
                                    ...s,
                                    B.duration || g
                                ], e = [
                                    a,
                                    ...u,
                                    B.strength
                                ]) : (m = [
                                    0,
                                    B.duration || g
                                ], e = [
                                    a,
                                    B.strength
                                ]);
                            } else m = [
                                0,
                                B.duration || g
                            ], e = [
                                a,
                                B.strength
                            ];
                        } else if (B.timeline) {
                            const { processedTimes: s, processedValues: u } = this._processTimeline(B.timeline, B.strength);
                            s.length ? (m = [
                                0,
                                ...s,
                                B.duration || g
                            ], e = [
                                a,
                                ...u,
                                a
                            ]) : (m = [
                                0,
                                this._defaultFadeInDuration / 1e3,
                                (B.duration || g) - this._defaultFadeOutDuration / 1e3,
                                B.duration || g
                            ], e = [
                                a,
                                B.strength,
                                B.strength,
                                a
                            ]);
                        } else m = [
                            0,
                            g / 2,
                            g
                        ], e = [
                            a,
                            B.strength,
                            a
                        ];
                        l.push(new $329ek.NumberKeyframeTrack(`${A.name}.morphTargetInfluences[${b}]`, m, e, $329ek.InterpolateLinear));
                    }
                });
            });
        }), this._handleClip(new $329ek.AnimationClip(`actionUnits${Date.now()}`, g, l, $329ek.NormalAnimationBlendMode), !0, C, !1);
    }
    setRandomSmileIntensity(I, g) {
        I <= g ? (this._randomSmileMinIntensity = I, this._randomSmileMaxIntensity = g) : (this._randomSmileMinIntensity = g, this._randomSmileMaxIntensity = I);
    }
}
let $e60bcd291a6e9aed$export$d0571fb8a1e015e7 = class {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "bones", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "obj");
        I && this.from(I);
    }
    from(I) {
        this.obj = I;
        const g = I.bones;
        let C, l, A, B;
        for (const o of g){
            o.updateMatrixWorld(!0);
            for (C of $e60bcd291a6e9aed$var$tA)if (A = C.test(o.name)) {
                l = this.bones.get(A), B = this.obj.bones.findIndex((i)=>i.id == o.id), l ? l && C.isChain && l.push(B, o) : this.bones.set(A, new $e60bcd291a6e9aed$export$52f5384bbd73bac3(o, B));
                break;
            }
        }
    }
    getBoneMap(I) {
        return this.bones.get(I);
    }
    getBoneIndex(I) {
        const g = this.bones.get(I);
        return g ? g.items[0].index : -1;
    }
    getBones(I) {
        const g = this.obj.bones, C = [];
        let l, A;
        for (const B of I)if (l = this.bones.get(B), l) for (A of l.items)C.push(g[A.index]);
        else console.warn("Bonemap.getBones - Bone not found", B);
        return C.length >= I.length ? C : null;
    }
    getChestBone() {
        const I = this.obj.bones, g = [], C = this.bones.get("spine");
        return C && g.push(I[C.lastIndex]), g.length > 0 ? g : null;
    }
}, $e60bcd291a6e9aed$export$52f5384bbd73bac3 = class {
    constructor(I, g){
        $e60bcd291a6e9aed$var$c(this, "items", []);
        I && this.push(g, I);
    }
    push(I, g) {
        return this.items.push({
            index: I,
            name: g.name
        }), this;
    }
    get isChain() {
        return this.items.length > 1;
    }
    get count() {
        return this.items.length;
    }
    get index() {
        return this.items.length ? this.items[0].index : 0;
    }
    get lastIndex() {
        return this.items.length ? this.items[this.items.length - 1].index : 0;
    }
}, $e60bcd291a6e9aed$var$z = class {
    constructor(I, g, C, l, A = !1){
        $e60bcd291a6e9aed$var$c(this, "name");
        $e60bcd291a6e9aed$var$c(this, "isLR");
        $e60bcd291a6e9aed$var$c(this, "isChain");
        $e60bcd291a6e9aed$var$c(this, "reFind");
        $e60bcd291a6e9aed$var$c(this, "reExclude");
        this.name = I, this.isLR = g, this.isChain = A, this.reFind = new RegExp(C, "i"), l && (this.reExclude = new RegExp(l, "i"));
    }
    test(I) {
        return !this.reFind.test(I) || this.reExclude && this.reExclude.test(I) ? null : this.isLR && $e60bcd291a6e9aed$var$WA.test(I) ? this.name + "_l" : this.isLR && $e60bcd291a6e9aed$var$nA.test(I) ? this.name + "_r" : this.name;
    }
};
const $e60bcd291a6e9aed$var$WA = new RegExp("\\.l|left|_l", "i"), $e60bcd291a6e9aed$var$nA = new RegExp("\\.r|right|_r", "i"), $e60bcd291a6e9aed$var$tA = [
    new $e60bcd291a6e9aed$var$z("thigh", !0, "thigh|upleg|upperleg", "twist"),
    //upleg | upperleg
    new $e60bcd291a6e9aed$var$z("shin", !0, "shin|leg|calf", "up|twist"),
    new $e60bcd291a6e9aed$var$z("foot", !0, "foot"),
    new $e60bcd291a6e9aed$var$z("toe", !0, "toebase"),
    new $e60bcd291a6e9aed$var$z("shoulder", !0, "clavicle|shoulder"),
    new $e60bcd291a6e9aed$var$z("upperarm", !0, "(upper.*arm|arm)", "fore|twist|lower"),
    new $e60bcd291a6e9aed$var$z("forearm", !0, "forearm|arm", "up|twist"),
    new $e60bcd291a6e9aed$var$z("hand", !0, "hand", "thumb|index|middle|ring|pinky"),
    new $e60bcd291a6e9aed$var$z("head", !1, "head"),
    new $e60bcd291a6e9aed$var$z("neck", !1, "neck*d*", void 0, !0),
    new $e60bcd291a6e9aed$var$z("hip", !1, "hips*|pelvis", void 0, !1),
    new $e60bcd291a6e9aed$var$z("root", !1, "root"),
    new $e60bcd291a6e9aed$var$z("spine", !1, "waist|spine*d*|chest", void 0, !0),
    new $e60bcd291a6e9aed$var$z("thumb", !0, "thumb*d*", "toe", !0),
    new $e60bcd291a6e9aed$var$z("index", !0, "index*d*", "toe", !0),
    new $e60bcd291a6e9aed$var$z("middle", !0, "middle*d*|mid*d", "toe", !0),
    new $e60bcd291a6e9aed$var$z("ring", !0, "ring*d*", "toe", !0),
    new $e60bcd291a6e9aed$var$z("pinky", !0, "pinky*d*", "toe", !0)
];
function $e60bcd291a6e9aed$var$XA(G) {
    return G.set(1 / G.x, 1 / G.y, 1 / G.z), G;
}
function $e60bcd291a6e9aed$var$eI(G) {
    const I = new $329ek.Quaternion(), C = 1 / G.lengthSq();
    return I.x = -G.x * C, I.y = -G.y * C, I.z = -G.z * C, I.w = G.w * C, I;
}
function $e60bcd291a6e9aed$var$VA(G) {
    const I = new $329ek.Quaternion();
    return I.x = -G.x, I.y = -G.y, I.z = -G.z, I.w = -G.w, I;
}
class $e60bcd291a6e9aed$var$Xg {
    constructor(I, g){
        // #region MAIN
        $e60bcd291a6e9aed$var$c(this, "srcIndex", -1);
        // Bone index in source tpose
        $e60bcd291a6e9aed$var$c(this, "tarIndex", -1);
        // Bone index in target tpose
        $e60bcd291a6e9aed$var$c(this, "qSrcParent", new $329ek.Quaternion());
        // Cache the bone's parent worldspace rotation
        $e60bcd291a6e9aed$var$c(this, "qTarParent", new $329ek.Quaternion());
        // Cache tpose parent worldspace rotation, to make it easy to transform Tar WS to Tar LS
        $e60bcd291a6e9aed$var$c(this, "qDotCheck", new $329ek.Quaternion());
        // Cache the src bone worldspace rotation for DOT Check
        $e60bcd291a6e9aed$var$c(this, "qSrcToTar", new $329ek.Quaternion());
        // Handles transformation from Src Worldspace to Tar Worldspace
        $e60bcd291a6e9aed$var$c(this, "qTarToSrc", new $329ek.Quaternion());
        this.srcIndex = I, this.tarIndex = g;
    }
    // #endregion
    bind(I, g) {
        var A;
        const C = I.bones[this.srcIndex], l = g.bones[this.tarIndex];
        return this.qDotCheck.copy(C.getWorldQuaternion(new $329ek.Quaternion())), (A = C.parent) == null || A.updateMatrixWorld(!0), this.qSrcParent.copy(C.parent !== null ? C.parent.getWorldQuaternion(new $329ek.Quaternion()) : new $329ek.Quaternion()), this.qTarParent.copy($e60bcd291a6e9aed$var$eI(l.parent !== null ? l.parent.getWorldQuaternion(new $329ek.Quaternion()) : new $329ek.Quaternion())), this.qSrcToTar.copy($e60bcd291a6e9aed$var$eI(C.getWorldQuaternion(new $329ek.Quaternion()))), this.qSrcToTar.multiply(l.getWorldQuaternion(new $329ek.Quaternion())), this;
    }
}
class $e60bcd291a6e9aed$export$b8d19200dd410785 {
    constructor(){
        $e60bcd291a6e9aed$var$c(this, "links", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "srcPose");
        $e60bcd291a6e9aed$var$c(this, "tarPose");
        $e60bcd291a6e9aed$var$c(this, "srcHip", new $329ek.Vector3());
        $e60bcd291a6e9aed$var$c(this, "tarHip", new $329ek.Vector3());
        $e60bcd291a6e9aed$var$c(this, "hipScale", 1);
        $e60bcd291a6e9aed$var$c(this, "firstFrame", !0);
    }
    bindTPoses(I, g) {
        this.srcPose = I, this.tarPose = g, this.srcPose.updateMatrixWorld(!0), this.tarPose.updateMatrixWorld(!0);
        const C = new $e60bcd291a6e9aed$export$d0571fb8a1e015e7(I.skeleton), l = new $e60bcd291a6e9aed$export$d0571fb8a1e015e7(g.skeleton);
        let A;
        for (const [o, i] of C.bones)if (A = l.bones.get(o), !!A) {
            if (A.isChain || i.isChain) {
                const Z = i.count - 1, b = A.count - 1;
                this.links.set(o + "_first", new $e60bcd291a6e9aed$var$Xg(i.index, A.index).bind(I.skeleton, g.skeleton)), this.links.set(o + "_last", new $e60bcd291a6e9aed$var$Xg(i.items[Z].index, A.items[b].index).bind(I.skeleton, g.skeleton));
                for(let a = 1; a <= Math.min(Z - 1, b - 1); a++)this.links.set(o + "_" + a, new $e60bcd291a6e9aed$var$Xg(i.items[a].index, A.items[a].index).bind(I.skeleton, g.skeleton));
            } else this.links.set(o, new $e60bcd291a6e9aed$var$Xg(i.index, A.index).bind(I.skeleton, g.skeleton));
        }
        const B = this.links.get("hip");
        if (B) {
            const o = I.skeleton.bones[B.srcIndex], i = g.skeleton.bones[B.tarIndex];
            this.srcHip.copy(o.getWorldPosition(new $329ek.Vector3())), this.tarHip.copy(i.position);
        }
        return this;
    }
    // #region CALCULATIONS
    retargetPose() {
        var A;
        const I = new $329ek.Quaternion();
        let g, C, l;
        for (g of this.links.values())C = this.srcPose.skeleton.bones[g.srcIndex], l = this.tarPose.skeleton.bones[g.tarIndex], I.multiplyQuaternions(g.qSrcParent, C.quaternion), I.dot(g.qDotCheck) < 0 ? I.multiply($e60bcd291a6e9aed$var$VA(g.qSrcToTar)) : I.multiply(g.qSrcToTar), l.quaternion.multiplyQuaternions(g.qTarParent, I);
        if (g = this.links.get("hip"), g) {
            C = this.srcPose.skeleton.bones[g.srcIndex], l = this.tarPose.skeleton.bones[g.tarIndex], C.getWorldScale(new $329ek.Vector3());
            const B = l.getWorldScale(new $329ek.Vector3());
            l.position.copy(C.getWorldPosition(new $329ek.Vector3()).sub(this.srcHip)), l.position.divide(B), l.position.applyQuaternion((A = l.parent) == null ? void 0 : A.getWorldQuaternion(new $329ek.Quaternion()).invert()), l.position.add(this.tarHip);
        }
    }
    // #endregion
    reset() {
        this.links = /* @__PURE__ */ new Map(), this.srcHip = new $329ek.Vector3(), this.tarHip = new $329ek.Vector3(), this.hipScale = 1;
    }
}
const $e60bcd291a6e9aed$var$Vg = "https://cdn.retorik.ai/bodyengine-three/animations/cc4/female/standing/", $e60bcd291a6e9aed$var$HA = {
    [$e60bcd291a6e9aed$var$ag.frequently]: 0.4,
    [$e60bcd291a6e9aed$var$ag.often]: 0.3,
    [$e60bcd291a6e9aed$var$ag.sometimes]: 0.15,
    [$e60bcd291a6e9aed$var$ag.occasionaly]: 0.1,
    [$e60bcd291a6e9aed$var$ag.rarely]: 0.05
}, $e60bcd291a6e9aed$var$Ag = class Ag {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "state", Ag.isIdle);
        $e60bcd291a6e9aed$var$c(this, "enabled", !1);
        $e60bcd291a6e9aed$var$c(this, "hitbox");
        $e60bcd291a6e9aed$var$c(this, "raycaster", new $329ek.Raycaster());
        $e60bcd291a6e9aed$var$c(this, "mesh");
        $e60bcd291a6e9aed$var$c(this, "camera");
        $e60bcd291a6e9aed$var$c(this, "orbitControls");
        $e60bcd291a6e9aed$var$c(this, "direction", {
            front: !1,
            back: !1,
            left: !1,
            right: !1,
            sprint: !1,
            jump: !1
        });
        $e60bcd291a6e9aed$var$c(this, "walkDirection", new $329ek.Vector3());
        $e60bcd291a6e9aed$var$c(this, "finalDirection", new $329ek.Vector3());
        $e60bcd291a6e9aed$var$c(this, "rotateAngle", new $329ek.Vector3(0, 1, 0));
        $e60bcd291a6e9aed$var$c(this, "rotateQuaternion", new $329ek.Quaternion());
        $e60bcd291a6e9aed$var$c(this, "cameraTarget", new $329ek.Vector3());
        // CONSTANT DATA
        $e60bcd291a6e9aed$var$c(this, "runVelocity", 10);
        $e60bcd291a6e9aed$var$c(this, "walkVelocity", 4);
        // groupID: number;
        $e60bcd291a6e9aed$var$c(this, "path", []);
        $e60bcd291a6e9aed$var$c(this, "navMesh");
        $e60bcd291a6e9aed$var$c(this, "navMeshGroup");
        $e60bcd291a6e9aed$var$c(this, "graphHelper");
        $e60bcd291a6e9aed$var$c(this, "currentRegion");
        this.mesh = I, window.addEventListener("keydown", (g)=>{
            switch(g.code){
                case "ShiftLeft":
                    this.direction.sprint = !0;
                    break;
                case "ArrowUp":
                case "KeyW":
                    this.direction.front = !0;
                    break;
                case "ArrowLeft":
                case "KeyA":
                    this.direction.left = !0;
                    break;
                case "ArrowDown":
                case "KeyS":
                    this.direction.back = !0;
                    break;
                case "ArrowRight":
                case "KeyD":
                    this.direction.right = !0;
                    break;
            }
        }), window.addEventListener("keyup", (g)=>{
            switch(g.code){
                case "ShiftLeft":
                    this.direction.sprint = !1;
                    break;
                case "ArrowUp":
                case "KeyW":
                    this.direction.front = !1;
                    break;
                case "ArrowLeft":
                case "KeyA":
                    this.direction.left = !1;
                    break;
                case "ArrowDown":
                case "KeyS":
                    this.direction.back = !1;
                    break;
                case "ArrowRight":
                case "KeyD":
                    this.direction.right = !1;
                    break;
            }
        });
    }
    init(I) {
        console.log(I), I && I.enabled && (this.enabled = !0), this.camera = I.camera, this.orbitControls = I.orbitControls, this.hitbox = I.hitbox;
    }
    // Pathfinding to the position passed
    goTo(I) {
        if (this.mesh && this.hitbox) {
            const g = this.mesh.position.clone();
            g.y += 0.2, this.raycaster.set(g, new $329ek.Vector3(0, -1, 0));
            let C = this.raycaster.intersectObjects([
                this.hitbox
            ], !0);
            C.length && g.copy(C[0].point), I.y += 0.2, this.raycaster.set(I, new $329ek.Vector3(0, -1, 0)), C = this.raycaster.intersectObjects([
                this.hitbox
            ], !0), C.length && I.copy(C[0].point), this.path = this.navMesh.findPath(g, I);
        }
    }
    // Check if a key is pressed on keyboard
    getIsAKeyPressed() {
        return this.direction.front || this.direction.back || this.direction.left || this.direction.right;
    }
    // Get direction the avatar should be facing based on the keys pressed
    getDirectionOffset() {
        let I = 0;
        return this.direction.back ? this.direction.right ? I = Math.PI / 4 : this.direction.left ? I = -Math.PI / 4 : I = 0 : this.direction.front ? this.direction.right ? I = Math.PI / 2 + Math.PI / 4 : this.direction.left ? I = -Math.PI / 2 - Math.PI / 4 : I = Math.PI : this.direction.right ? I = Math.PI / 2 : this.direction.left && (I = -Math.PI / 2), I;
    }
    // Update the avatar position based on the keys pressed 
    update(I) {
        if (!(!this.enabled || !this.navMesh || !this.mesh)) {
            if (this.path.length) {
                const C = this.path[0].clone().sub(this.mesh.position);
                if (C.length() > 0.05) {
                    C.normalize(), this.mesh.position.add(C.multiplyScalar(I * this.walkVelocity));
                    const l = this.mesh.position.clone().add(C);
                    l.y = this.mesh.position.y, this.mesh.lookAt(l), this.mesh.position.y += 0.2, this.raycaster.set(this.mesh.position, new $329ek.Vector3(0, -1, 0));
                    const A = this.hitbox ? this.raycaster.intersectObjects([
                        this.hitbox
                    ], !0) : [];
                    A.length && this.mesh.position.copy(A[0].point);
                } else this.path.shift();
            } else if (this.camera) {
                const g = Math.atan2(this.camera.position.x - this.mesh.position.x, this.camera.position.z - this.mesh.position.z);
                if (this.getIsAKeyPressed()) {
                    const b = this.getDirectionOffset();
                    this.rotateQuaternion.setFromAxisAngle(this.rotateAngle, g + b), this.mesh.quaternion.rotateTowards(this.rotateQuaternion, 0.25), this.camera.getWorldDirection(this.walkDirection), this.walkDirection.y = 0, this.walkDirection.normalize(), this.walkDirection.applyAxisAngle(this.rotateAngle, b), this.walkDirection.multiplyScalar(-1), this.state = this.direction.sprint ? Ag.isRunnning : Ag.isWalking;
                } else this.walkDirection.multiplyScalar(0.7), this.state = Ag.isIdle;
                const C = this.direction.sprint ? this.runVelocity : this.walkVelocity, l = this.camera.position.clone().sub(this.mesh.position);
                this.finalDirection = this.walkDirection.clone(), this.finalDirection.multiplyScalar(C * I);
                let A = this.mesh.position.clone();
                this.raycaster.set(A.clone().add(new $329ek.Vector3(0, 0.5, 0)), new $329ek.Vector3(0, -1, 0));
                const B = this.hitbox ? this.raycaster.intersectObjects([
                    this.hitbox
                ], !0) : [];
                B.length && (A = B[0].point);
                const o = A.clone(), i = A.add(this.finalDirection), Z = o.clone().lerp(i, 1 + 0.2 / o.distanceTo(i));
                this.navMesh.getRegionForPoint(Z, this.navMesh.epsilonContainsTest) && (this.mesh.position.copy(i), this.currentRegion = this.navMesh.clampMovement(this.currentRegion, o, i, this.mesh.position)), this.updateCameraTarget(l);
            }
        }
    }
    // Make the camera follow the avatar
    updateCameraTarget(I) {
        this.camera && this.mesh && this.orbitControls && (this.camera.position.copy(this.mesh.position).add(I), this.cameraTarget.x = this.mesh.position.x, this.cameraTarget.y = this.mesh.position.y + 1, this.cameraTarget.z = this.mesh.position.z, this.orbitControls.target = this.cameraTarget, this.orbitControls.update());
    }
};
$e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$Ag, "isRunnning", "running"), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$Ag, "isWalking", "walking"), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$Ag, "isIdle", "idle");
let $e60bcd291a6e9aed$var$bg = $e60bcd291a6e9aed$var$Ag;
class $e60bcd291a6e9aed$var$SA extends $329ek.AnimationMixer {
    constructor(g){
        super(g.rootObject);
        $e60bcd291a6e9aed$var$c(this, "_animationActions", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_idleAnimationActions", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_explainAnimationActions", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_otherAnimationActions", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_inhaleAnimationAction", null);
        $e60bcd291a6e9aed$var$c(this, "_exhaleAnimationAction", null);
        $e60bcd291a6e9aed$var$c(this, "_currentAnimationActions", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_idleFrequencyData", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_explainFrequencyData", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_commonFrequencyData", null);
        $e60bcd291a6e9aed$var$c(this, "_fadeDuration", 0.5);
        $e60bcd291a6e9aed$var$c(this, "_fastFadeDuration", 0.25);
        $e60bcd291a6e9aed$var$c(this, "_breathingEffectiveWeight", 0.5);
        $e60bcd291a6e9aed$var$c(this, "_autoAnimate", !0);
        $e60bcd291a6e9aed$var$c(this, "_breathing", !0);
        $e60bcd291a6e9aed$var$c(this, "_state", $e60bcd291a6e9aed$export$f2e6b371e93925c7.idle);
        $e60bcd291a6e9aed$var$c(this, "_movingState", $e60bcd291a6e9aed$var$bg.isIdle);
        $e60bcd291a6e9aed$var$c(this, "_timerForAutoAnimation", null);
        $e60bcd291a6e9aed$var$c(this, "changeState", (g)=>{
            let C = null;
            this._state === $e60bcd291a6e9aed$export$f2e6b371e93925c7.speaking ? C = this.getRandom(0) : g === $e60bcd291a6e9aed$export$f2e6b371e93925c7.speaking && (C = this.getRandom(1)), C && this.autoAnimate && this.playAnimationAction(C), this.state = g;
        });
        $e60bcd291a6e9aed$var$c(this, "getRandom", (g, C)=>{
            var A, B;
            let l = /* @__PURE__ */ new Map();
            switch(g){
                case 0:
                    if (!((A = this._idleAnimationActions) != null && A.size)) return null;
                    l = this._idleFrequencyData;
                    break;
                case 1:
                    if (!((B = this._explainAnimationActions) != null && B.size)) return null;
                    l = this._explainFrequencyData;
                    break;
                default:
                    return null;
            }
            if (this._commonFrequencyData) {
                const o = (this._commonFrequencyData.maxCumulativeWeight || 1) * Math.random(), i = this._commonFrequencyData.cumulativeWeights.filter((b, a)=>{
                    var m;
                    return this._commonFrequencyData && ((m = l.get(this._commonFrequencyData.weights[a])) == null ? void 0 : m.length);
                }), Z = i.find((b)=>b >= o) || i.reverse().find((b)=>b < o);
                if (Z !== void 0) {
                    const b = this._commonFrequencyData.weights[this._commonFrequencyData.cumulativeWeights.indexOf(Z)];
                    let a = l.get(b);
                    if (a != null && a.length) {
                        C != null && C.length && a.length > C.length && (a = a.filter((e)=>!C.includes(e)));
                        const m = a[Math.floor(Math.random() * (a.length - 1))];
                        return this._animationActions.get(m) || null;
                    }
                }
            }
            return null;
        });
        g.fadeDuration && (this._fadeDuration = g.fadeDuration);
        const C = g.animationWeights || $e60bcd291a6e9aed$var$HA, l = [
            C.rarely,
            C.occasionaly,
            C.sometimes,
            C.often,
            C.frequently
        ], A = [];
        let B = 0;
        l.forEach((o)=>{
            B += o, A.push(B);
        }), this._commonFrequencyData = {
            animationWeights: C,
            weights: l,
            cumulativeWeights: A,
            maxCumulativeWeight: A[A.length - 1]
        }, this.addEventListener("loop", (o)=>{
            var i, Z;
            if (o.action.getClip().name.includes("inhale")) (i = this._inhaleAnimationAction) == null || i.fadeOut(this._fadeDuration), setTimeout(()=>{
                var b;
                (b = this._exhaleAnimationAction) == null || b.reset().fadeIn(this._fadeDuration).play();
            }, 500);
            else if (o.action.getClip().name.includes("exhale")) (Z = this._exhaleAnimationAction) == null || Z.fadeOut(this._fadeDuration), setTimeout(()=>{
                var b;
                (b = this._inhaleAnimationAction) == null || b.reset().fadeIn(this._fadeDuration).play();
            }, 1500);
            else if (o.action.getClip().name.startsWith("bml_")) {
                const b = this._currentAnimationActions.get(o.action.getClip().name);
                if (b) {
                    if (this._currentAnimationActions.size === 1 && this._autoAnimate) {
                        const a = this.getRandom(this._state === $e60bcd291a6e9aed$export$f2e6b371e93925c7.speaking ? 1 : 0);
                        a && (this._timerForAutoAnimation && clearTimeout(this._timerForAutoAnimation), this._timerForAutoAnimation = setTimeout(()=>{
                            a.reset().fadeIn(this._fadeDuration).play(), this._currentAnimationActions.set(a.getClip().name, a);
                        }, 1e3));
                    }
                    this.stopAnimation(b.getClip().name);
                }
            } else if (this._autoAnimate) {
                let b = null;
                switch(this._movingState){
                    case $e60bcd291a6e9aed$var$bg.isRunnning:
                        b = this._otherAnimationActions.get("running") || null;
                        break;
                    case $e60bcd291a6e9aed$var$bg.isWalking:
                        b = this._otherAnimationActions.get("walking") || null;
                        break;
                    case $e60bcd291a6e9aed$var$bg.isIdle:
                    default:
                        const a = [];
                        this._currentAnimationActions.forEach((m, e)=>a.push(e.toLowerCase())), b = this.getRandom(this._state === $e60bcd291a6e9aed$export$f2e6b371e93925c7.speaking ? 1 : 0, a);
                        break;
                }
                b && (this._currentAnimationActions.has(b == null ? void 0 : b.getClip().name) ? b == null || b.reset().play() : (b == null || b.reset().fadeIn(this._fadeDuration).play(), this.stopAnimations(), this._currentAnimationActions.set(b == null ? void 0 : b.getClip().name, b)));
            }
        }), this.addEventListener("finished", (o)=>{
            if (!this._autoAnimate) return;
            const i = this.getRandom(this._state === $e60bcd291a6e9aed$export$f2e6b371e93925c7.speaking ? 1 : 0);
            i && (this._currentAnimationActions.has(i == null ? void 0 : i.getClip().name) ? i == null || i.reset().play() : (this.stopAnimations(), i == null || i.reset().fadeIn(this._fadeDuration).play(), this._currentAnimationActions.set(i == null ? void 0 : i.getClip().name, i)));
        }), setInterval(()=>{
            if (!this._autoAnimate) return;
            const o = this._currentAnimationActions.entries().next().value, i = o ? o[1] : void 0;
            (i == null ? void 0 : i.time) === 0 && i.play();
        }, 5e3);
    }
    get autoAnimate() {
        return this._autoAnimate;
    }
    set autoAnimate(g) {
        this._autoAnimate = g;
    }
    get breathing() {
        return this._breathing;
    }
    set breathing(g) {
        this._breathing = g;
    }
    get speaking() {
        return this._state === $e60bcd291a6e9aed$export$f2e6b371e93925c7.speaking;
    }
    get state() {
        return this._state;
    }
    set state(g) {
        this._state = g;
    }
    get movingState() {
        return this._movingState;
    }
    set movingState(g) {
        this._movingState = g;
    }
    addAnimation(g, C = "often") {
        var B, o, i, Z;
        const l = this.clipAction(g);
        l.setLoop($329ek.LoopPingPong, 2), l.clampWhenFinished = !0;
        const A = ((B = this._commonFrequencyData) == null ? void 0 : B.animationWeights[C]) || ((o = this._commonFrequencyData) == null ? void 0 : o.animationWeights.often);
        if (this._animationActions.set(g.name, l), g.name.toLowerCase().includes("idle")) {
            this._idleAnimationActions.set(g.name, l);
            const b = this._idleFrequencyData.get(A);
            b != null && b.length ? this._idleFrequencyData.set(A, [
                ...b,
                g.name
            ]) : this._idleFrequencyData.set(A, [
                g.name
            ]);
        } else if (g.name.toLowerCase().includes("explain")) {
            this._explainAnimationActions.set(g.name, l);
            const b = this._explainFrequencyData.get(A);
            b != null && b.length ? this._explainFrequencyData.set(A, [
                ...b,
                g.name
            ]) : this._explainFrequencyData.set(A, [
                g.name
            ]);
        } else this._otherAnimationActions.set(g.name, l);
        if (this._autoAnimate && !this._currentAnimationActions.size && ((i = this._idleAnimationActions) == null ? void 0 : i.size) > 1 && ((Z = this._explainAnimationActions) == null ? void 0 : Z.size) > 1) {
            const b = this.getRandom(this._state === $e60bcd291a6e9aed$export$f2e6b371e93925c7.speaking ? 1 : 0);
            b && (this._currentAnimationActions.set(b.getClip().name, b), b.reset().play());
        }
    }
    /**
   * Start breathing animation that will continue on its own.
   */ startBreathing() {
        var g;
        (g = this._inhaleAnimationAction) == null || g.reset().play(), this._breathing = !0;
    }
    /**
   * Stop breathing animation.
   */ stopBreathing() {
        var g, C;
        (g = this._inhaleAnimationAction) == null || g.stop(), (C = this._exhaleAnimationAction) == null || C.stop(), this._breathing = !1;
    }
    /**
   * Add the special breathing animation. We receive an inhaling animation, copy its reversed tracks to get an exhaling one, and play them successively.
   * @param {THREE.AnimationClip} inhaleClip animation clip containing the inhaling animation.
   */ addBreathingAnimation(g) {
        const C = [];
        for(let A = g.tracks.length - 1; A >= 0; A--)C.push(g.tracks[A]);
        const l = new $329ek.AnimationClip("exhaleClip", -1, C, $329ek.NormalAnimationBlendMode);
        $329ek.AnimationUtils.makeClipAdditive(l), this._exhaleAnimationAction = this.clipAction(l), this._exhaleAnimationAction.setLoop($329ek.LoopPingPong, 1 / 0), this._exhaleAnimationAction.setEffectiveWeight(this._breathingEffectiveWeight), g.name = "inhaleClip", $329ek.AnimationUtils.makeClipAdditive(g), this._inhaleAnimationAction = this.clipAction(g), this._inhaleAnimationAction.setLoop($329ek.LoopPingPong, 1 / 0), this._inhaleAnimationAction.reset().play();
    }
    getAllAnimations() {
        const g = /* @__PURE__ */ new Map();
        return this._animationActions.forEach((C, l)=>{
            g.set(l, C.getClip());
        }), g;
    }
    /**
   * Get an array containing the names of all the animations stored inside the AnimationMixer.
   * @returns {Array<string>}
   */ getAllAnimationNames() {
        return [
            ...this._animationActions.keys()
        ];
    }
    /**
   * Conditionnaly fades out the current playing animations and fades in the animation to be played in 0.5s.
   * @param {string} name name of the stored AnimAtionAction that should be played. Can be retrieved by using getAllAnimationsNames().
   * @param {boolean | undefined} keepOtherAnimationsAlive true to keep already playing animations alive.
   */ playAnimation(g, C) {
        this._timerForAutoAnimation && clearTimeout(this._timerForAutoAnimation);
        const l = this._animationActions.get(g);
        l && (this._currentAnimationActions.size ? (l.reset().fadeIn(this._fadeDuration).play(), !C && this.stopAnimations()) : l.play(), this._currentAnimationActions.set(g, l));
    }
    /**
   * Conditionnaly fades out the current playing animations and fades in the animation to be played in 0.5s.
   * @param {THREE.AnimationAction} action AnimAtionAction that should be played.
   * @param {boolean | undefined} keepOtherAnimationsAlive true to keep already playing animations alive.
   */ playAnimationAction(g, C) {
        this._timerForAutoAnimation && clearTimeout(this._timerForAutoAnimation), this._currentAnimationActions.size ? (g.reset().fadeIn(this._fadeDuration).play(), !C && this.stopAnimations()) : g.play(), this._currentAnimationActions.set(g.getClip().name, g);
    }
    /**
   * Stop all the currently playing animations.
   */ stopAnimations() {
        if (this._currentAnimationActions.size) {
            const g = [];
            this._currentAnimationActions.forEach((C, l)=>{
                const A = this._currentAnimationActions.get(l);
                A && (A.halt(this._fadeDuration / 10).fadeOut(this._fadeDuration), g.push(A), this._currentAnimationActions.delete(l));
            }), setTimeout(()=>{
                g.forEach((C)=>{
                    C.stop();
                });
            }, this._fadeDuration * 1e3);
        }
    }
    /**
   * Stop a playing animation by name
   * @param {string} name name of the animation to stop.
   */ stopAnimation(g, C) {
        const l = this._currentAnimationActions.get(g);
        l && (l.halt(this._fadeDuration / 10).fadeOut(C ? this._fastFadeDuration : this._fadeDuration), this._currentAnimationActions.delete(g), setTimeout(()=>{
            l.stop();
        }, (C ? this._fastFadeDuration : this._fadeDuration) * 1e3));
    }
    update(g) {
        return super.update(g), this;
    }
}
class $e60bcd291a6e9aed$var$pA {
    constructor(I, g){
        $e60bcd291a6e9aed$var$c(this, "_worker");
        I instanceof Worker ? this._worker = I : this._worker = new Worker(I, g);
    }
    postMessage(I, g) {
        g ? this._worker.postMessage(I, g) : this._worker.postMessage(I);
    }
    terminate() {
        this._worker.terminate();
    }
    async postMessageAsync(I, g = [], C = ()=>{}) {
        return new Promise((l, A)=>{
            this._worker.onmessage = (B)=>{
                l(B.data), this._worker.onmessage = null;
            }, this._worker.onerror = (B)=>A(B), this._worker.postMessage(I, g);
        });
    }
}
const $e60bcd291a6e9aed$var$VC = "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", $e60bcd291a6e9aed$var$YA = (G)=>Uint8Array.from(atob(G), (I)=>I.charCodeAt(0)), $e60bcd291a6e9aed$var$sI = typeof self < "u" && self.Blob && new Blob([
    "URL.revokeObjectURL(import.meta.url);",
    $e60bcd291a6e9aed$var$YA($e60bcd291a6e9aed$var$VC)
], {
    type: "text/javascript;charset=utf-8"
});
function $e60bcd291a6e9aed$var$KA(G) {
    let I;
    try {
        if (I = $e60bcd291a6e9aed$var$sI && (self.URL || self.webkitURL).createObjectURL($e60bcd291a6e9aed$var$sI), !I) throw "";
        const g = new Worker(I, {
            type: "module",
            name: G == null ? void 0 : G.name
        });
        return g.addEventListener("error", ()=>{
            (self.URL || self.webkitURL).revokeObjectURL(I);
        }), g;
    } catch  {
        return new Worker("data:text/javascript;base64," + $e60bcd291a6e9aed$var$VC, {
            type: "module",
            name: G == null ? void 0 : G.name
        });
    }
}
const $e60bcd291a6e9aed$var$RA = new RegExp("((spine)|(shoulder))+", "i"), $e60bcd291a6e9aed$var$yI = new RegExp("((neck)|(head)|(eye)|(facial)|(jaw)|(tongue)|(teeth))+", "i");
class $e60bcd291a6e9aed$export$42d239a7180b47de {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "_armature");
        $e60bcd291a6e9aed$var$c(this, "_mesh");
        $e60bcd291a6e9aed$var$c(this, "_targetMesh");
        $e60bcd291a6e9aed$var$c(this, "_retarget", new $e60bcd291a6e9aed$export$b8d19200dd410785());
        $e60bcd291a6e9aed$var$c(this, "_fadeDuration", 0.5);
        $e60bcd291a6e9aed$var$c(this, "_needsRetargeting", !0);
        $e60bcd291a6e9aed$var$c(this, "_animationOverride", !0);
        $e60bcd291a6e9aed$var$c(this, "controllableManager");
        $e60bcd291a6e9aed$var$c(this, "worker");
        $e60bcd291a6e9aed$var$c(this, "animationMixer", null);
        I.animationOverride !== void 0 && (this._animationOverride = I.animationOverride), this._armature = I.sourceMesh, this._mesh = I.mesh, this._targetMesh = I.targetMesh, this.animationMixer = new $e60bcd291a6e9aed$var$SA({
            rootObject: this._armature,
            fadeDuration: this._fadeDuration,
            animationWeights: I.animationWeights
        }), this._retarget.bindTPoses(this._armature, this._targetMesh), this.controllableManager = new $e60bcd291a6e9aed$var$bg(this._mesh), this.worker = new $e60bcd291a6e9aed$var$pA(new $e60bcd291a6e9aed$var$KA());
    }
    playAnimation(I) {
        var g;
        (g = this.animationMixer) == null || g.playAnimation(I);
    }
    /**
   * Stop an animation by its name
   * @param {string} name name of the animation to stop
   * @param {boolean | undefined} fast if the animation should be stopped faster than normal (base : 0.25s instead of 0.5s)
   */ stopAnimation(I, g) {
        var C;
        (C = this.animationMixer) == null || C.stopAnimation(I, g);
    }
    /**
   * Stop all currently playing animations
   */ stopAnimations() {
        var I;
        (I = this.animationMixer) == null || I.stopAnimations();
    }
    enableCoreAutoAnimate() {
        this.animationMixer && (this.animationMixer.autoAnimate = !0);
    }
    disableCoreAutoAnimate() {
        this.animationMixer && (this.animationMixer.autoAnimate = !1);
    }
    enableBreathing() {
        var I;
        (I = this.animationMixer) == null || I.startBreathing();
    }
    disableBreathing() {
        var I;
        (I = this.animationMixer) == null || I.stopBreathing();
    }
    /**
   * Add a retorik animation. No need of retargeting the clip source to the basic armature.
   * @param retorikAnimation THREE.Group : animation data
   * @param name string | undefined : name other than the animation clip's one if wanted
   */ addAnimation(I, g) {
        var l;
        const C = I.animations[0];
        g && (C.name = g), (l = this.animationMixer) == null || l.addAnimation(C);
    }
    /**
   * Add a mixamo animation. Need to retarget the clip source to the basic armature.
   * @param mixamoAnimation THREE.Group : animation data
   * @param name string | undefined : name other than the animation clip's one if wanted
   */ async addMixamoAnimation(I) {
        var l;
        const g = await this.worker.postMessageAsync({
            type: "retargetMixamo",
            clip: I.url,
            name: I.name
        }), C = $329ek.AnimationClip.parse(g.retargetedClip);
        if (I.returnClip) return C;
        {
            const A = C, B = C.tracks;
            this._animationOverride && (A.tracks = B.filter((o)=>!o.name.split(".")[1].match($e60bcd291a6e9aed$var$yI))), (l = this.animationMixer) == null || l.addAnimation(A, I.frequency);
        }
        return null;
    }
    /**
   * Add a CC4 animation. Need to retarget the clip source to the basic armature.
   * @param CC4Animation THREE.Group : animation data
   * @param name string | undefined : name other than the animation clip's one if wanted
   */ async addCC4Animation(I) {
        var l;
        const g = await this.worker.postMessageAsync({
            type: "retargetCC4",
            clip: I.url,
            name: I.name
        }), C = $329ek.AnimationClip.parse(g.retargetedClip);
        if (I.returnClip) return C;
        {
            const A = C, B = C.tracks;
            this._animationOverride && (A.tracks = B.filter((o)=>!o.name.split(".")[1].match($e60bcd291a6e9aed$var$yI))), (l = this.animationMixer) == null || l.addAnimation(A, I.frequency);
        }
        return null;
    }
    getAllAnimationNames() {
        return this.animationMixer ? this.animationMixer.getAllAnimationNames() : [];
    }
    addBreathingAnimation(I, g) {
        const C = I.animations[0];
        C.name = "breathing";
        const l = C.tracks;
        switch(C.tracks = l.filter((A)=>A.name.split(".")[0].match($e60bcd291a6e9aed$var$RA)), g){
            case $e60bcd291a6e9aed$var$$.cc4:
                C.tracks.forEach((A)=>{
                    A.name.toLowerCase().includes("rightshoulder") ? A.name = A.name.replace("mixamorigRightShoulder", "CC_Base_R_Clavicle") : A.name.toLowerCase().includes("leftshoulder") ? A.name = A.name.replace("mixamorigLeftShoulder", "CC_Base_L_Clavicle") : A.name.toLowerCase().includes("spine2") ? A.name = A.name.replace("mixamorigSpine2", "CC_Base_Spine02") : A.name.toLowerCase().includes("spine1") ? A.name = A.name.replace("mixamorigSpine1", "CC_Base_Spine02") : A.name.toLowerCase().includes("spine") && (A.name = A.name.replace("mixamorigSpine", "CC_Base_Waist"));
                });
                break;
            case $e60bcd291a6e9aed$var$$.mixamo:
                this._needsRetargeting || C.tracks.forEach((A)=>{
                    A.name = A.name.replace("mixamorig", "");
                });
            case $e60bcd291a6e9aed$var$$.none:
        }
        $329ek.AnimationUtils.makeClipAdditive(C);
    }
    getAllAnimations() {
        return this.animationMixer ? this.animationMixer.getAllAnimations() : /* @__PURE__ */ new Map();
    }
    update(I, g) {
        this.animationMixer && (this.controllableManager && (this.controllableManager.update(I), this.animationMixer.movingState = this.controllableManager.state), this.animationMixer.state !== g && this.animationMixer.changeState(g), this.animationMixer.update(I), this._needsRetargeting && (this._armature.updateMatrixWorld(!0), this._retarget.retargetPose(), this._targetMesh.updateWorldMatrix(!0, !0)));
    }
}
class $e60bcd291a6e9aed$export$28ad399fb4435dc0 {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "_globalManager");
        $e60bcd291a6e9aed$var$c(this, "_headBone");
        $e60bcd291a6e9aed$var$c(this, "_bones", []);
        $e60bcd291a6e9aed$var$c(this, "_nbBones", 0);
        $e60bcd291a6e9aed$var$c(this, "_previousRotations", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_alpha", 0.75);
        // Data for looking at a specific point
        $e60bcd291a6e9aed$var$c(this, "_lookAt", null);
        $e60bcd291a6e9aed$var$c(this, "_defaultFadeDuration", 1e3);
        $e60bcd291a6e9aed$var$c(this, "_defaultReleaseDuration", 2e3);
        $e60bcd291a6e9aed$var$c(this, "_playingHeadAnimation", !1);
        $e60bcd291a6e9aed$var$c(this, "_lastTarget", null);
        $e60bcd291a6e9aed$var$c(this, "_oldTarget", null);
        $e60bcd291a6e9aed$var$c(this, "_durationTransitionTarget", 750);
        $e60bcd291a6e9aed$var$c(this, "_timeTransitionTarget", 0);
        $e60bcd291a6e9aed$var$c(this, "_camera", null);
        $e60bcd291a6e9aed$var$c(this, "_movementAnime", null);
        $e60bcd291a6e9aed$var$c(this, "_baseBoneRotations", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_boneRotation", new $329ek.Vector3(0, 0, 0));
        $e60bcd291a6e9aed$var$c(this, "_limitBoneRotationInRadians", new $329ek.Vector3(0.6981317008, // 40 degrees
        1.0471975512, // 60 degrees
        0.6981317008));
        this._globalManager = I.globalManager, this._headBone = I.parent.getObjectByName(I.headBone), I.bones.forEach((g)=>{
            this._bones.push(I.parent.getObjectByName(g));
        }), this._bones.push(this._headBone), this._bones.forEach((g)=>{
            this._baseBoneRotations.set(g.name, g.rotation.clone()), this._previousRotations.set(g.name, g.rotation.clone());
        }), this._nbBones = this._bones.length, this._limitBoneRotationInRadians = new $329ek.Vector3(this._limitBoneRotationInRadians.x / this._nbBones, this._limitBoneRotationInRadians.y / this._nbBones, this._limitBoneRotationInRadians.z / this._nbBones), this._globalManager.animationMixer.addEventListener("finished", (g)=>{
            g.action.getClip().name.startsWith("headPose") && (this._playingHeadAnimation = !1, setTimeout(()=>{
                g.action.stop();
            }, 40));
        }), this._globalManager.animationMixer.addEventListener("loop", (g)=>{
            const C = g.action.getClip();
            C.name.startsWith("headPose_shifted_") && (C.tracks.forEach((l)=>{
                const A = l.name.split(".")[0], B = l.values.slice(l.values.length - 4), o = new $329ek.Euler().setFromQuaternion(new $329ek.Quaternion(B[0], B[1], B[2], B[3]));
                this._baseBoneRotations.set(A, o), this._previousRotations.set(A, o);
            }), this._boneRotation = new $329ek.Vector3(0, 0, 0), this._initAnimation(), this._playingHeadAnimation = !1, setTimeout(()=>{
                g.action.stop();
            }, 40));
        }), this._initAnimation();
    }
    _calculateTargetRotation(I) {
        const g = new $329ek.Vector3(0, 0, 0), C = this._headBone.quaternion.clone();
        return I && (this._headBone.lookAt(I), this._headBone.quaternion.copy(this._headBone.quaternion.clone().slerp(C, 0.5))), this._bones.forEach((l)=>{
            const A = this._baseBoneRotations.get(l.name) || new $329ek.Euler(0, 0, 0), B = new $329ek.Euler();
            B.setFromQuaternion(l.quaternion.clone()), g.x += B.x - A.x, g.y += B.y - A.y, g.z += B.z - A.z;
        }), this._headBone.quaternion.copy(C), new $329ek.Vector3(g.x / this._nbBones, g.y / this._nbBones, g.z / this._nbBones);
    }
    _initAnimation() {
        const I = this, g = ()=>{
            const C = $329ek.MathUtils.degToRad(-5 + Math.random() * 10) / I._nbBones, l = $329ek.MathUtils.degToRad(-25 + Math.random() * 50) / I._nbBones, A = $329ek.MathUtils.degToRad(-25 + Math.random() * 50) / I._nbBones, B = $e60bcd291a6e9aed$var$V.random(2e3, 2500), o = $e60bcd291a6e9aed$var$V.random(2e3, 3e3);
            I._movementAnime = $e60bcd291a6e9aed$var$V({
                targets: I._boneRotation,
                keyframes: [
                    {
                        x: C,
                        y: l,
                        z: A,
                        duration: B * 0.5
                    },
                    {
                        x: C,
                        y: l,
                        z: A,
                        duration: B * 0.5
                    },
                    {
                        x: 0,
                        y: 0,
                        z: 0,
                        duration: o * 0.5
                    },
                    {
                        x: 0,
                        y: 0,
                        z: 0,
                        duration: o
                    }
                ],
                autoplay: !1,
                complete: g,
                easing: "easeInOutQuad"
            });
        };
        g();
    }
    _initLookAtCamera() {
        const I = this;
        I._lookAt = !0;
        const g = ()=>{
            const C = $329ek.MathUtils.degToRad(-2 + Math.random() * 5) / I._nbBones, l = $329ek.MathUtils.degToRad(-5 + Math.random() * 10) / I._nbBones, A = $329ek.MathUtils.degToRad(-5 + Math.random() * 10) / I._nbBones, B = $e60bcd291a6e9aed$var$V.random(2e3, 2500), o = $e60bcd291a6e9aed$var$V.random(2e3, 3e3);
            I._movementAnime = $e60bcd291a6e9aed$var$V({
                targets: I._boneRotation,
                keyframes: [
                    {
                        x: C,
                        y: l,
                        z: A,
                        duration: B * 0.5
                    },
                    {
                        x: C,
                        y: l,
                        z: A,
                        duration: B * 0.5
                    },
                    {
                        x: 0,
                        y: 0,
                        z: 0,
                        duration: o * 0.5
                    },
                    {
                        x: 0,
                        y: 0,
                        z: 0,
                        duration: o
                    }
                ],
                autoplay: !1,
                complete: g,
                easing: "easeInOutQuad"
            });
        };
        g();
    }
    _initReleaseLookAt(I) {
        const g = this, C = (B)=>{
            g._lookAt = !1, g._movementAnime = $e60bcd291a6e9aed$var$V({
                targets: g._boneRotation,
                x: [
                    B.x,
                    0
                ],
                y: [
                    B.y,
                    0
                ],
                z: [
                    B.z,
                    0
                ],
                duration: I,
                autoplay: !0,
                complete: ()=>{
                    g._initAnimation();
                },
                easing: "easeInOutSine"
            });
        }, l = g._previousRotations.get(g._bones[0].name), A = g._baseBoneRotations.get(g._bones[0].name);
        l && A && C(new $329ek.Vector3(l.x - A.x, l.y - A.y, l.z - A.z));
    }
    _initLookAtAndSteady(I) {
        const g = this, C = (B)=>{
            g._lookAt = !1, g._movementAnime = $e60bcd291a6e9aed$var$V({
                targets: g._boneRotation,
                x: [
                    B.x,
                    0
                ],
                y: [
                    B.y,
                    0
                ],
                z: [
                    B.z,
                    0
                ],
                duration: I,
                autoplay: !0,
                complete: ()=>g._movementAnime = null,
                easing: "easeInOutSine"
            });
        }, l = g._previousRotations.get(g._bones[0].name), A = g._baseBoneRotations.get(g._bones[0].name);
        l && A && C(new $329ek.Vector3(l.x - A.x, l.y - A.y, l.z - A.z));
    }
    addHeadPoseSequence(I) {
        const g = I.fps || 25, l = (I.duration || I.data.length / g) / I.data.length, A = [];
        for(let o = 0; o < I.data.length; o++)A.push(o * l);
        const B = new Array();
        I.data.forEach((o)=>{
            this._bones.forEach((i)=>{
                const Z = this._previousRotations.get(i.name);
                if (Z) {
                    const b = this._alpha * (o.x / this._bones.length) + (1 - this._alpha) * Z.x, a = -this._alpha * (o.y / this._bones.length) + (1 - this._alpha) * Z.y, m = -this._alpha * (o.z / this._bones.length) + (1 - this._alpha) * Z.z, e = new $329ek.Euler(b, a, m, "XYZ"), s = new $329ek.Quaternion(), u = new $329ek.Quaternion(), W = new $329ek.Quaternion();
                    s.setFromEuler(Z), u.setFromEuler(new $329ek.Euler((Z.x + b) / 2, (Z.y + a) / 2, (Z.z + m) / 2, "XYZ")), W.setFromEuler(e);
                    const y = new $329ek.QuaternionKeyframeTrack(`${i.name}.quaternion`, A, [
                        ...s.toArray(),
                        ...u.toArray(),
                        ...W.toArray()
                    ], $329ek.InterpolateLinear);
                    B.push(y), this._previousRotations.set(i.name, new $329ek.Euler(b, a, m, "XYZ"));
                }
            });
        });
    }
    _calculateRotationWithLimits(I, g) {
        const C = I.clone();
        Math.abs(I.y - g.y) > this._limitBoneRotationInRadians.y && (I.y - g.y > 0 ? C.y = g.y + this._limitBoneRotationInRadians.y : C.y = g.y - this._limitBoneRotationInRadians.y);
        const l = (1 - Math.abs(C.y - g.y) / this._limitBoneRotationInRadians.y) * this._limitBoneRotationInRadians.x;
        Math.abs(I.x - g.x) > l && (I.x - g.x > 0 ? C.x = g.x + l : C.x = g.x - l);
        const A = Math.min(l, (1 - Math.abs(C.x - g.x) / this._limitBoneRotationInRadians.x) * this._limitBoneRotationInRadians.z);
        return Math.abs(I.z - g.z) > A && (I.z - g.z > 0 ? C.z = g.z + A : C.z = g.z - A), C.z = g.z, C;
    }
    update(I, g, C) {
        var A;
        const l = [];
        if (!this._playingHeadAnimation) {
            if ((A = this._movementAnime) == null || A.tick(I), g) this._bones.forEach((B)=>{
                const o = this._previousRotations.get(B.name), i = this._baseBoneRotations.get(B.name);
                if (o && i) {
                    const Z = this._alpha * (i.x + g.x / this._bones.length) + (1 - this._alpha) * o.x, b = -(this._alpha * (i.y + g.y / this._bones.length) + (1 - this._alpha) * o.y), a = -(this._alpha * (i.z + g.z / this._bones.length) + (1 - this._alpha) * o.z), m = new $329ek.Quaternion().setFromEuler(o), e = new $329ek.Quaternion().setFromEuler(new $329ek.Euler(Z, b, a, "XYZ"));
                    l.push({
                        name: B.name,
                        value: [
                            ...m.toArray(),
                            ...e.toArray()
                        ]
                    }), this._previousRotations.set(B.name, new $329ek.Euler(Z, b, a, "XYZ"));
                }
            });
            else if (this._boneRotation) {
                const B = new $329ek.Object3D();
                B.position.set(0, 1.6, 2);
                const o = this._boneRotation.clone(), i = C || (this._camera ? this._camera : B), Z = i.position.clone();
                if (this._lookAt) {
                    if (this._lastTarget !== i) {
                        if (this._timeTransitionTarget = performance.now() + this._durationTransitionTarget, !this._lastTarget) {
                            const b = new $329ek.Vector3();
                            this._headBone.getWorldPosition(b);
                            const a = new $329ek.Vector3();
                            this._headBone.getWorldDirection(a), a.add(b), B.position.set(a.x, a.y, a.z), this._lastTarget = B;
                        }
                        Z.copy(this._lastTarget.position.clone().lerp(i.position.clone(), 1 / this._durationTransitionTarget)), this._oldTarget = this._lastTarget, this._lastTarget = i;
                    }
                    if (this._timeTransitionTarget > performance.now() && this._oldTarget) {
                        const b = this._easeInOutSine();
                        Z.copy(this._oldTarget.position.clone().lerp(i.position.clone(), b));
                    }
                    if (C) {
                        const b = this._calculateTargetRotation(Z);
                        o.add(b);
                    } else if (this._camera) {
                        const b = this._calculateTargetRotation(Z);
                        o.add(b);
                    }
                }
                this._bones.forEach((b)=>{
                    const a = this._previousRotations.get(b.name), m = this._baseBoneRotations.get(b.name);
                    if (a && m) {
                        const e = new $329ek.Vector3(this._alpha * (m.x + o.x) + (1 - this._alpha) * a.x, this._alpha * (m.y + o.y) + (1 - this._alpha) * a.y, this._alpha * (m.z + o.z) + (1 - this._alpha) * a.z), s = this._calculateRotationWithLimits(e, m), u = new $329ek.Euler(s.x, s.y, s.z, "XYZ"), W = new $329ek.Quaternion().setFromEuler(a), y = new $329ek.Quaternion().setFromEuler(u);
                        l.push({
                            name: b.name,
                            value: [
                                ...W.toArray(),
                                ...y.toArray()
                            ]
                        }), this._previousRotations.set(b.name, u);
                    }
                });
            }
        }
        return l;
    }
    _easeInOutSine() {
        const I = performance.now(), g = 1 - (this._timeTransitionTarget - I) / this._durationTransitionTarget, C = Math.min(1, Math.max(0, g));
        return -(Math.cos(Math.PI * C) - 1) / 2;
    }
    /**
   * Stop looking at a target.
   * @param {number | undefined} fadeDuration time in milliseconds to get back to base position. Default 1000.
   */ releaseLookAt(I) {
        var g;
        this._lastTarget = null, this._oldTarget = null, this._timeTransitionTarget = 0, this._lookAt !== null && ((g = this._movementAnime) == null || g.pause(), this._initReleaseLookAt(I || this._defaultFadeDuration));
    }
    /**
   * Look at the target and get back to normal after some time.
   * @param {THREE.Camera} target camera to which the face will look at.
   * @param {number | undefined} fadeInDuration time in milliseconds to go from the current position to the look at position. Default 1000.
   * @param {number | undefined} fadeOutDuration time in milliseconds to get back to base position. Default 1000.
   * @param {number | undefined} releaseAfterDuration time in milliseconds after which the animation gets back to base position. Default 2000.
   */ lookAtAndRelease(I, g, C, l) {
        this.lookAtAndKeep(I), setTimeout(()=>{
            this.releaseLookAt(C || this._defaultFadeDuration);
        }, l || this._defaultReleaseDuration);
    }
    /**
   * Look at the target camera and then keep looking at it until release.
   * @param {THREE.Camera} target camera to which the face will keep looking at.
   * @param {number | undefined} fadeDuration time in milliseconds to go from the current position to the look at position. Default 1000.
   */ lookAtAndKeep(I) {
        var g;
        this._camera = I, (g = this._movementAnime) == null || g.pause(), this._initLookAtCamera();
    }
    lookAtAndSteady(I) {
        var g;
        this._camera = I, (g = this._movementAnime) == null || g.pause(), this._initLookAtAndSteady(this._defaultFadeDuration);
    }
    _processTimeline(I, g, C, l) {
        var n, H, F;
        const A = new $329ek.Quaternion().setFromEuler(g), B = new $329ek.Quaternion().setFromEuler(new $329ek.Euler(g.x + 1e-3, g.y + 1e-3, g.z, "XYZ")), o = [
            0
        ];
        let i = [
            ...A.toArray()
        ];
        const Z = I.planes.indexOf("x"), b = I.planes.indexOf("y"), a = I.planes.indexOf("z"), m = Z > -1 ? {
            max: g.x + $329ek.MathUtils.degToRad(I.upperlimit[Z] / this._nbBones),
            min: (n = I.lowerlimit) != null && n.length ? g.x + $329ek.MathUtils.degToRad(I.lowerlimit[Z]) : 0
        } : void 0, e = b > -1 ? {
            max: g.y + $329ek.MathUtils.degToRad(I.upperlimit[b] / this._nbBones),
            min: (H = I.lowerlimit) != null && H.length ? g.y + $329ek.MathUtils.degToRad(I.lowerlimit[b]) : 0
        } : void 0, s = a > -1 ? {
            max: g.z + $329ek.MathUtils.degToRad(I.upperlimit[a] / this._nbBones),
            min: (F = I.lowerlimit) != null && F.length ? g.z + $329ek.MathUtils.degToRad(I.lowerlimit[a]) : 0
        } : void 0, u = this._calculateRotationWithLimits(new $329ek.Vector3((m == null ? void 0 : m.max) === void 0 ? g.x : m.max, (e == null ? void 0 : e.max) === void 0 ? g.y : e.max, (s == null ? void 0 : s.max) === void 0 ? g.z : s.max), C), W = new $329ek.Quaternion().setFromEuler(new $329ek.Euler(u.x, u.y, u.z, "XYZ")), y = this._calculateRotationWithLimits(new $329ek.Vector3((m == null ? void 0 : m.min) === void 0 ? g.x : m.min, (e == null ? void 0 : e.min) === void 0 ? g.y : e.min, (s == null ? void 0 : s.min) === void 0 ? g.z : s.min), C), h = new $329ek.Quaternion().setFromEuler(new $329ek.Euler(y.x, y.y, y.z, "XYZ"));
        if (I.shift) o.push(l), i = [
            ...i,
            ...W.toArray()
        ];
        else if (I.timeline.start !== void 0 && I.timeline.end !== void 0) {
            if (I.timeline.ready && (o.push(I.timeline.ready - I.timeline.start), i = [
                ...i,
                ...B.toArray()
            ]), I.forthAndBack) {
                if (i = [
                    ...i,
                    ...W.toArray()
                ], i = [
                    ...i,
                    ...h.toArray()
                ], I.timeline.strokestart && I.timeline.strokeend) o.push(I.timeline.strokestart - I.timeline.start), o.push(I.timeline.strokeend - I.timeline.start);
                else {
                    const p = I.timeline.ready ? I.timeline.ready - I.timeline.start : 0, f = (I.timeline.relax ? I.timeline.relax - I.timeline.start : l) - p;
                    o.push(p + f / 4), o.push(p + f * 3 / 4);
                }
            } else if (i = [
                ...i,
                ...W.toArray()
            ], I.timeline.strokestart && I.timeline.strokeend) {
                o.push(I.timeline.strokestart - I.timeline.start), o.push(I.timeline.strokeend - I.timeline.start);
                const p = new $329ek.Quaternion(W.x + 1e-3, W.y + 1e-3, W.z, W.w);
                i = [
                    ...i,
                    ...p.toArray()
                ];
            } else I.timeline.stroke ? o.push(I.timeline.stroke - I.timeline.start) : I.timeline.ready ? I.timeline.relax ? o.push(I.timeline.ready - I.timeline.start + (I.timeline.relax - I.timeline.ready) / 2) : o.push(I.timeline.ready - I.timeline.start + (I.timeline.end - I.timeline.ready) / 2) : I.timeline.relax ? o.push((I.timeline.relax - I.timeline.start) / 2) : o.push(l / 2);
            I.timeline.relax && (o.push(I.timeline.relax - I.timeline.start), i = [
                ...i,
                ...B.toArray()
            ]), o.push(l), i = [
                ...i,
                ...A.toArray()
            ];
        }
        return {
            processedTimes: o,
            processedValues: i
        };
    }
    _handleClip(I, g, C) {
        const l = this._globalManager.animationMixer.clipAction(I);
        C ? l.setLoop($329ek.LoopPingPong, 2) : (l.setLoop($329ek.LoopRepeat, g), l.setEffectiveTimeScale(g)), l.clampWhenFinished = !0, l.play();
    }
    updateHeadPosition(I, g) {
        var l;
        if (this._playingHeadAnimation = !0, (l = this._movementAnime) == null || l.pause(), I.shift) {
            this._movementAnime = null;
            const A = this._calculateTargetRotation(new $329ek.Vector3(I.upperlimit[0], I.upperlimit[1], I.upperlimit[2]));
            I.upperlimit = [
                $329ek.MathUtils.radToDeg(A.x),
                $329ek.MathUtils.radToDeg(A.y),
                $329ek.MathUtils.radToDeg(A.z)
            ];
        }
        const C = [];
        I.timeline && (this._bones.forEach((A)=>{
            const B = this._previousRotations.get(A.name);
            if (B) {
                const { processedTimes: o, processedValues: i } = this._processTimeline(I, B, this._baseBoneRotations.get(A.name), g);
                C.push(new $329ek.QuaternionKeyframeTrack(`${A.name}.quaternion`, o, i, $329ek.InterpolateLinear));
            }
        }), C.length && this._handleClip(new $329ek.AnimationClip(`headPose${I.shift ? "_shifted_" : ""}${Date.now()}`, g, C, $329ek.NormalAnimationBlendMode), I.repetition, I.shift));
    }
}
const $e60bcd291a6e9aed$var$cg = 10, $e60bcd291a6e9aed$var$og = 20;
class $e60bcd291a6e9aed$export$471af857ad6f5b2b {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "_bones");
        $e60bcd291a6e9aed$var$c(this, "_headBone");
        $e60bcd291a6e9aed$var$c(this, "_morphTargets", null);
        $e60bcd291a6e9aed$var$c(this, "_leftEyePreviousRotation");
        $e60bcd291a6e9aed$var$c(this, "_leftEyeOriginRotation");
        $e60bcd291a6e9aed$var$c(this, "_leftEyeOriginQuaternion");
        $e60bcd291a6e9aed$var$c(this, "_rightEyeOriginQuaternion");
        $e60bcd291a6e9aed$var$c(this, "_rightEyePreviousRotation");
        $e60bcd291a6e9aed$var$c(this, "_rightEyeOriginRotation");
        $e60bcd291a6e9aed$var$c(this, "_camera", null);
        $e60bcd291a6e9aed$var$c(this, "_lookAt", !1);
        $e60bcd291a6e9aed$var$c(this, "_type");
        $e60bcd291a6e9aed$var$c(this, "_lastTarget", null);
        $e60bcd291a6e9aed$var$c(this, "_oldTarget", null);
        $e60bcd291a6e9aed$var$c(this, "_durationTransitionTarget", 750);
        $e60bcd291a6e9aed$var$c(this, "_timeTransitionTarget", 0);
        $e60bcd291a6e9aed$var$c(this, "_saccadeAnime", null);
        $e60bcd291a6e9aed$var$c(this, "_eyeRotation", new $329ek.Euler(0, 0, 0));
        this._bones = {
            left: I.parent.getObjectByName(I.bones[0]),
            right: I.parent.getObjectByName(I.bones[1])
        }, this._headBone = I.parent.getObjectByName(I.headBone), I.morphTargets && (this._morphTargets = I.morphTargets), this._type = I.type, this._leftEyePreviousRotation = this._bones.left.rotation.clone(), this._leftEyeOriginRotation = this._bones.left.rotation.clone(), this._leftEyeOriginQuaternion = this._bones.left.quaternion.clone(), this._rightEyeOriginQuaternion = this._bones.right.quaternion.clone(), this._rightEyePreviousRotation = this._bones.right.rotation.clone(), this._rightEyeOriginRotation = this._bones.right.rotation.clone(), this._eyeRotation = new $329ek.Euler($329ek.MathUtils.degToRad(-$e60bcd291a6e9aed$var$cg / 2 + Math.random() * $e60bcd291a6e9aed$var$cg), $329ek.MathUtils.degToRad(-$e60bcd291a6e9aed$var$og + Math.random() * $e60bcd291a6e9aed$var$og), 0), this._initAnimation();
    }
    _initAnimation() {
        const I = this;
        function g() {
            const C = $e60bcd291a6e9aed$var$V.random(1500, 2e3), l = $e60bcd291a6e9aed$var$V.random(3e3, 3500), A = I._eyeRotation.x, B = $329ek.MathUtils.degToRad(-$e60bcd291a6e9aed$var$cg / 2 + Math.random() * $e60bcd291a6e9aed$var$cg), o = Math.abs(A - B) > $329ek.MathUtils.degToRad($e60bcd291a6e9aed$var$cg / 2) ? (A + B) / 2 : B, i = I._eyeRotation.y, Z = $329ek.MathUtils.degToRad(-$e60bcd291a6e9aed$var$og / 2 + Math.random() * $e60bcd291a6e9aed$var$og), b = Math.abs(i - Z) > $329ek.MathUtils.degToRad($e60bcd291a6e9aed$var$og / 2) ? (i + Z) / 2 : Z;
            I._saccadeAnime = $e60bcd291a6e9aed$var$V({
                targets: [
                    I._eyeRotation
                ],
                keyframes: [
                    {
                        x: o,
                        y: b,
                        duration: C * 0.05
                    },
                    // Move to target in 100ms
                    {
                        x: o,
                        y: b,
                        duration: C * 0.95,
                        easing: "linear"
                    },
                    // Stay at target for 2 seconds
                    {
                        x: 0,
                        y: 0,
                        duration: l * 0.05
                    },
                    // Return to 0 in 100ms
                    {
                        x: 0,
                        y: 0,
                        duration: l * 0.95,
                        easing: "linear"
                    }
                ],
                autoplay: !1,
                easing: "easeInOutQuad",
                complete: g
            });
        }
        g();
    }
    _initLookAtAndSteady() {
        const I = this;
        function g() {
            I._saccadeAnime = $e60bcd291a6e9aed$var$V({
                targets: [
                    I._eyeRotation
                ],
                keyframes: [
                    {
                        x: 0,
                        y: 0,
                        duration: 100
                    }
                ],
                autoplay: !0,
                easing: "easeInOutQuad",
                complete: ()=>{
                    I._saccadeAnime = null;
                }
            });
        }
        g();
    }
    updateRotations(I, g) {
        const C = [], l = new $329ek.Vector3(I.left.x, I.left.y, I.left.z), A = new $329ek.Vector3(I.right.x, I.right.y, I.right.z), B = new $329ek.Quaternion().setFromEuler(this._leftEyePreviousRotation), o = new $329ek.Quaternion().setFromEuler(new $329ek.Euler(l.x, l.y, l.z, "XYZ"));
        return C.push({
            name: this._bones.left.name,
            value: [
                ...B.toArray(),
                ...o.toArray()
            ]
        }), B.setFromEuler(this._rightEyePreviousRotation), o.setFromEuler(new $329ek.Euler(A.x, A.y, A.z, "XYZ")), C.push({
            name: this._bones.right.name,
            value: [
                ...B.toArray(),
                ...o.toArray()
            ]
        }), this._leftEyePreviousRotation = new $329ek.Euler(l.x, l.y, l.z, "XYZ"), this._rightEyePreviousRotation = new $329ek.Euler(A.x, A.y, A.z, "XYZ"), C;
    }
    updateMorphTargets(I) {
        const g = [];
        let C = 1, l = 1;
        const A = new $329ek.Euler().setFromQuaternion(this._bones.left.quaternion.clone().multiply(this._leftEyeOriginQuaternion.clone().invert())), B = new $329ek.Euler().setFromQuaternion(this._bones.right.quaternion.clone().multiply(this._rightEyeOriginQuaternion.clone().invert()));
        let o = 0, i = 0, Z = 0, b = 0;
        switch(this._type){
            case $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.cc3:
                o = A.x, i = -A.z, Z = B.x, b = -B.z, C = 0.5, l = 0.35;
                break;
            case $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.avatarsdk:
                o = A.y, i = -A.x, Z = B.y, b = -B.x, l = 0.25, C = 0.3;
                break;
            case $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.avaturn:
                o = A.y, i = -A.x, Z = B.y, b = -B.x, C = 1, l = 0.4;
                break;
        }
        return this._morphTargets && (g.push({
            name: o > 0 ? this._morphTargets.left.out : this._morphTargets.left.in,
            value: $329ek.MathUtils.radToDeg(Math.abs(o)) / ($e60bcd291a6e9aed$var$cg / 2) * l
        }), g.push({
            name: o > 0 ? this._morphTargets.left.in : this._morphTargets.left.out,
            value: 0
        }), g.push({
            name: i > 0 ? this._morphTargets.left.up : this._morphTargets.left.down,
            value: $329ek.MathUtils.radToDeg(Math.abs(i)) / ($e60bcd291a6e9aed$var$og / 2) * C
        }), g.push({
            name: i > 0 ? this._morphTargets.left.down : this._morphTargets.left.up,
            value: 0
        }), g.push({
            name: Z > 0 ? this._morphTargets.right.in : this._morphTargets.right.out,
            value: $329ek.MathUtils.radToDeg(Math.abs(Z)) / ($e60bcd291a6e9aed$var$cg / 2) * l
        }), g.push({
            name: Z > 0 ? this._morphTargets.right.out : this._morphTargets.right.in,
            value: 0
        }), g.push({
            name: b > 0 ? this._morphTargets.right.up : this._morphTargets.right.down,
            value: $329ek.MathUtils.radToDeg(Math.abs(b)) / ($e60bcd291a6e9aed$var$og / 2) * C
        }), g.push({
            name: b > 0 ? this._morphTargets.right.down : this._morphTargets.right.up,
            value: 0
        })), g;
    }
    update(I, g, C, l) {
        var b, a, m;
        const A = this._bones.left.quaternion.clone().multiply(new $329ek.Quaternion().setFromEuler(this._eyeRotation).invert()), B = this._bones.right.quaternion.clone().multiply(new $329ek.Quaternion().setFromEuler(this._eyeRotation).invert());
        (b = this._saccadeAnime) != null && b.paused ? (a = this._saccadeAnime) == null || a.play() : (m = this._saccadeAnime) == null || m.tick(I);
        let o = {
            left: new $329ek.Euler(this._eyeRotation.x + this._leftEyeOriginRotation.x, this._eyeRotation.y + this._leftEyeOriginRotation.y, this._eyeRotation.z + this._leftEyeOriginRotation.z),
            right: new $329ek.Euler(this._eyeRotation.x + this._rightEyeOriginRotation.x, this._eyeRotation.y + this._rightEyeOriginRotation.y, this._eyeRotation.z + this._rightEyeOriginRotation.z)
        };
        if (this._lookAt && (this._camera || l)) {
            const e = new $329ek.Object3D();
            e.position.set(0, 1.6, 2);
            const s = l || (this._camera ? this._camera : e), u = s.position.clone();
            if (this._lastTarget !== s) {
                if (this._timeTransitionTarget = performance.now() + this._durationTransitionTarget, !this._lastTarget) {
                    const E = new $329ek.Vector3();
                    this._bones.left.getWorldPosition(E);
                    const _ = new $329ek.Vector3();
                    this._bones.left.getWorldDirection(_), _.add(E), e.position.set(_.x, _.y, _.z), this._lastTarget = e;
                }
                u.copy(this._lastTarget.position.clone().lerp(s.position.clone(), 1 / this._durationTransitionTarget)), this._oldTarget = this._lastTarget, this._lastTarget = s;
            }
            if (this._timeTransitionTarget > performance.now() && this._oldTarget) {
                const E = this._easeInOutSine();
                u.copy(this._oldTarget.position.clone().lerp(s.position.clone(), E));
            }
            const W = new $329ek.Euler(), y = new $329ek.Euler(), h = new $329ek.Quaternion();
            C.forEach((E)=>{
                h.multiply(new $329ek.Quaternion().fromArray(E.value).invert());
            });
            const n = new $329ek.Vector3(), H = new $329ek.Vector3();
            this._bones.left.getWorldPosition(n), this._bones.right.getWorldPosition(H);
            const F = n.clone().lerp(H, 0.5), p = u.clone().sub(F).normalize().multiplyScalar(0.07), f = u.clone().add(p.clone().applyEuler(new $329ek.Euler(0, Math.PI / 2, 0))), dg = u.clone().add(p.clone().applyEuler(new $329ek.Euler(0, -Math.PI / 2, 0)));
            switch(this._bones.left.lookAt(f.clone()), this._bones.left.quaternion.multiply(h), this._bones.right.lookAt(dg.clone()), this._bones.right.quaternion.multiply(h), this._type){
                case $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.cc3:
                    this._bones.left.rotation.y += Math.PI / 2.5, this._bones.right.rotation.y += Math.PI / 2.5, this._bones.left.rotation.x = Math.max(Math.min(this._bones.left.rotation.x, -Math.PI * 1 / 3), -Math.PI * 2 / 3), this._bones.right.rotation.x = Math.max(Math.min(this._bones.right.rotation.x, -Math.PI * 1 / 3), -Math.PI * 2 / 3), this._bones.left.rotation.y = Math.max(Math.min(this._bones.left.rotation.y, Math.PI / 2.5 + Math.PI / 5), Math.PI / 2.5 - Math.PI / 5), this._bones.right.rotation.y = Math.max(Math.min(this._bones.right.rotation.y, Math.PI / 2.5 + Math.PI / 5), Math.PI / 2.5 - Math.PI / 5);
                    break;
                case $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.avatarsdk:
                case $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.avaturn:
                    this._bones.left.rotation.x = Math.max(Math.min(this._bones.left.rotation.x, Math.PI / 8), 0), this._bones.right.rotation.x = Math.max(Math.min(this._bones.right.rotation.x, Math.PI / 8), 0), this._bones.left.rotation.y = Math.max(Math.min(this._bones.left.rotation.y, Math.PI / 6), -Math.PI / 6), this._bones.right.rotation.y = Math.max(Math.min(this._bones.right.rotation.y, Math.PI / 6), -Math.PI / 6);
                    break;
            }
            const Bg = this._bones.left.quaternion.clone(), R = this._bones.right.quaternion.clone();
            this._bones.left.quaternion.copy(A), this._bones.right.quaternion.copy(B), W.setFromQuaternion(Bg), W.x += this._eyeRotation.x, W.y += this._eyeRotation.y, W.z += this._eyeRotation.z, y.setFromQuaternion(R), y.x += this._eyeRotation.x, y.y += this._eyeRotation.y, y.z += this._eyeRotation.z, o = {
                left: W,
                right: y
            };
        } else g && (o = {
            left: new $329ek.Euler(this._leftEyeOriginRotation.x + g.left.x, +this._leftEyeOriginRotation.y + g.left.y, +this._leftEyeOriginRotation.z + g.left.z),
            right: new $329ek.Euler(this._rightEyeOriginRotation.x + g.right.x, this._rightEyeOriginRotation.y + g.right.y, this._rightEyeOriginRotation.z + g.right.z)
        });
        const i = this.updateRotations(o, !!g);
        return [
            this.updateMorphTargets(o),
            i
        ];
    }
    _easeInOutSine() {
        const I = performance.now(), g = 1 - (this._timeTransitionTarget - I) / this._durationTransitionTarget, C = Math.min(1, Math.max(0, g));
        return -(Math.cos(Math.PI * C) - 1) / 2;
    }
    releaseLookAt() {
        this._lastTarget = null, this._oldTarget = null, this._timeTransitionTarget = 0, this._lookAt = !1, this._saccadeAnime === null && this._initAnimation();
    }
    lookAtAndKeep(I) {
        this._lookAt = !0, this._camera = I;
    }
    lookAtAndSteady(I) {
        var g;
        this._camera = I, (g = this._saccadeAnime) == null || g.pause(), this._initLookAtAndSteady();
    }
}
class $e60bcd291a6e9aed$var$HC {
    constructor(I, g){
        $e60bcd291a6e9aed$var$c(this, "id", "");
        $e60bcd291a6e9aed$var$c(this, "type");
        $e60bcd291a6e9aed$var$c(this, "parentId");
        $e60bcd291a6e9aed$var$c(this, "attributes", []);
        $e60bcd291a6e9aed$var$c(this, "syncPoints", []);
        $e60bcd291a6e9aed$var$c(this, "timeline", {});
        this.type = I, this.parentId = g;
    }
    updateTimeline(I, g) {
        this.timeline = {
            ...this.timeline,
            [I]: g
        };
    }
}
var $e60bcd291a6e9aed$var$v = /* @__PURE__ */ ((G)=>(G.START = "start", G.READY = "ready", G.STROKESTART = "strokestart", G.STROKE = "stroke", G.STROKEEND = "strokeend", G.RELAX = "relax", G.END = "end", G.ATTACKPEAK = "attackpeak", G))($e60bcd291a6e9aed$var$v || {}), $e60bcd291a6e9aed$var$t = /* @__PURE__ */ ((G)=>(G.DURATION = "duration", G.LEXEME = "lexeme", G.AMOUNT = "amount", G.AU = "au", G.SIDE = "side", G.TARGET = "target", G.INFLUENCE = "influence", G.OFFSETANGLE = "offsetdngle", G.OFFSETDIRECTION = "offsetdirection", G.OVERSHOOT = "overshoot", G.MODE = "mode", G.REPETITION = "repetition", G.MANNER = "manner", G.PART = "part", G.TYPE = "type", G))($e60bcd291a6e9aed$var$t || {}), $e60bcd291a6e9aed$var$S = /* @__PURE__ */ ((G)=>(G.BML = "bml", G.CONSTRAINT = "constraint", G.SYNCHRONIZE = "synchronize", G.BEFORE = "before", G.AFTER = "after", G.WAIT = "wait", G.FACE = "face", G.FACELEXEME = "facelexeme", G.FACEFACS = "facefacs", G.FACESHIFT = "faceshift", G.GAZE = "gaze", G.GAZESHIFT = "gazeshift", G.GESTURE = "gesture", G.POINTING = "pointing", G.HEAD = "head", G.HEADDIRECTIONSHIFT = "headdirectionshift", G.LOCOMOTION = "locomotion", G.POSTURE = "posture", G.POSTURESHIFT = "postureshift", G.SPEECH = "speech", G.OTHER = "other", G))($e60bcd291a6e9aed$var$S || {}), $e60bcd291a6e9aed$var$J = /* @__PURE__ */ ((G)=>(G.SYNC = "sync", G.STANCE = "stance", G.POSE = "pose", G.TEXT = "text", G.LEXEME = "lexeme", G.FACS = "facs", G))($e60bcd291a6e9aed$var$J || {}), $e60bcd291a6e9aed$var$ug = /* @__PURE__ */ ((G)=>(G[G.MERGE = 0] = "MERGE", G[G.APPEND = 1] = "APPEND", G[G.REPLACE = 2] = "REPLACE", G))($e60bcd291a6e9aed$var$ug || {});
class $e60bcd291a6e9aed$var$tg {
    constructor(I, g){
        $e60bcd291a6e9aed$var$c(this, "id");
        $e60bcd291a6e9aed$var$c(this, "bmlParentId");
        $e60bcd291a6e9aed$var$c(this, "parentId");
        $e60bcd291a6e9aed$var$c(this, "syncReference");
        $e60bcd291a6e9aed$var$c(this, "referenceId");
        $e60bcd291a6e9aed$var$c(this, "referenceParentId");
        $e60bcd291a6e9aed$var$c(this, "referenceSyncRef");
        $e60bcd291a6e9aed$var$c(this, "additionalTime");
        $e60bcd291a6e9aed$var$c(this, "triggerTime");
        this.bmlParentId = I.bmlParentId, this.parentId = I.parentId, this.syncReference = I.syncReference.toLowerCase(), this.referenceId = I.referenceId, this.referenceParentId = I.referenceParentId, this.referenceSyncRef = I.referenceSyncRef, this.additionalTime = I.additionalTime, this.triggerTime = I.triggerTime, I.syncReference === $e60bcd291a6e9aed$var$v.START && !I.referenceId && g && (this.referenceId = g, this.referenceSyncRef = $e60bcd291a6e9aed$var$v.START), this.id = `${this.bmlParentId}_${this.parentId}_${this.syncReference}`;
    }
    update(I, g, C) {
        const l = {
            ended: !1,
            updateTimeline: void 0
        };
        return this.triggerTime === void 0 && C !== void 0 && (this.triggerTime = this.additionalTime ? C + this.additionalTime : C, l.updateTimeline = this.triggerTime), this.triggerTime !== void 0 ? l.ended = this.triggerTime <= I : (g.forEach((A)=>{
            this.referenceParentId ? this.referenceParentId === A.blockParentId && this.referenceId === A.blockId && this.referenceSyncRef === A.syncRef && (this.additionalTime ? this.triggerTime = I + this.additionalTime : l.ended = !0) : this.referenceId === A.blockId && this.referenceSyncRef === A.syncRef && (this.additionalTime ? this.triggerTime = I + this.additionalTime : l.ended = !0);
        }), l.updateTimeline = this.triggerTime), l;
    }
}
class $e60bcd291a6e9aed$var$Jg extends $e60bcd291a6e9aed$var$HC {
    constructor(g, C){
        var A;
        super(g.type, C);
        $e60bcd291a6e9aed$var$c(this, "shift", !1);
        const l = (A = g.attributes.find((B)=>B.name === "id")) == null ? void 0 : A.value;
        this.id = typeof l == "string" ? l : `${l}`;
    }
}
class $e60bcd291a6e9aed$var$JA extends $e60bcd291a6e9aed$var$Jg {
    constructor(g, C, l){
        super({
            type: $e60bcd291a6e9aed$var$J.POSE,
            attributes: []
        }, C);
        $e60bcd291a6e9aed$var$c(this, "part", "");
        $e60bcd291a6e9aed$var$c(this, "lexeme", "");
        $e60bcd291a6e9aed$var$c(this, "parentAttributes", []);
        this.id = `${C}_pose_${Date.now()}`, this.parentAttributes = l, g.forEach((A)=>{
            switch(A.name){
                case $e60bcd291a6e9aed$var$t.PART:
                    this.part = A.value;
                    break;
                case $e60bcd291a6e9aed$var$t.LEXEME:
                    this.lexeme = A.value;
                    break;
            }
        });
    }
}
class $e60bcd291a6e9aed$var$NA extends $e60bcd291a6e9aed$var$Jg {
    constructor(g, C, l){
        var A;
        super({
            type: $e60bcd291a6e9aed$var$J.STANCE,
            attributes: []
        }, C);
        $e60bcd291a6e9aed$var$c(this, "lowType");
        $e60bcd291a6e9aed$var$c(this, "parentAttributes", []);
        this.id = `${C}_stance_${Date.now()}`, this.parentAttributes = l, this.lowType = (A = g.find((B)=>B.name === $e60bcd291a6e9aed$var$t.TYPE)) == null ? void 0 : A.value;
    }
}
class $e60bcd291a6e9aed$var$vA extends $e60bcd291a6e9aed$var$Jg {
    constructor(g, C, l){
        var A;
        super({
            type: $e60bcd291a6e9aed$var$J.LEXEME,
            attributes: []
        }, C);
        $e60bcd291a6e9aed$var$c(this, "lexeme");
        $e60bcd291a6e9aed$var$c(this, "parentAttributes", []);
        this.id = `${C}_lexeme_${Date.now()}`, this.parentAttributes = l, this.lexeme = (A = g.find((B)=>B.name === $e60bcd291a6e9aed$var$t.LEXEME)) == null ? void 0 : A.value;
    }
}
class $e60bcd291a6e9aed$var$rA extends $e60bcd291a6e9aed$var$Jg {
    constructor(g, C, l){
        super({
            type: $e60bcd291a6e9aed$var$J.FACS,
            attributes: []
        }, C);
        $e60bcd291a6e9aed$var$c(this, "au", 0);
        $e60bcd291a6e9aed$var$c(this, "side", "BOTH");
        $e60bcd291a6e9aed$var$c(this, "amount", 1);
        $e60bcd291a6e9aed$var$c(this, "parentAttributes", []);
        this.id = `${C}_facs_${Date.now()}`, this.parentAttributes = l, [
            ...g,
            ...l
        ].forEach((A)=>{
            switch(A.name){
                case $e60bcd291a6e9aed$var$t.AU:
                    {
                        const B = typeof A.value == "number" ? A.value : parseFloat(A.value);
                        !isNaN(B) && (this.au = B);
                        break;
                    }
                case $e60bcd291a6e9aed$var$t.SIDE:
                    this.side = A.value.toLowerCase();
                    break;
                case $e60bcd291a6e9aed$var$t.AMOUNT:
                    {
                        const B = typeof A.value == "number" ? A.value : parseFloat(A.value);
                        !isNaN(B) && (this.amount = B);
                        break;
                    }
            }
        });
    }
}
class $e60bcd291a6e9aed$var$T extends $e60bcd291a6e9aed$var$HC {
    constructor(g, C){
        super(g.type, C);
        $e60bcd291a6e9aed$var$c(this, "childrenElements");
        $e60bcd291a6e9aed$var$c(this, "childrenBlocks", []);
        this.childrenElements = g.children || [];
        const l = g.attributes.find((A)=>A.name === "id");
        this.id = l ? typeof l.value == "string" ? l.value : `${l.value}` : "", g.attributes.forEach((A)=>{
            switch(A.name){
                case $e60bcd291a6e9aed$var$v.READY:
                case $e60bcd291a6e9aed$var$v.START:
                case $e60bcd291a6e9aed$var$v.STROKESTART:
                case $e60bcd291a6e9aed$var$v.STROKE:
                case $e60bcd291a6e9aed$var$v.STROKEEND:
                case $e60bcd291a6e9aed$var$v.END:
                case $e60bcd291a6e9aed$var$v.RELAX:
                case $e60bcd291a6e9aed$var$v.ATTACKPEAK:
                    this._createSyncPoint(A, C);
            }
        });
    }
    _parseValue(g) {
        let C = this.parentId || "", l, A = $e60bcd291a6e9aed$var$v.START, B;
        if (typeof g == "string") {
            const o = parseFloat(g);
            if (!isNaN(o)) B = o;
            else {
                const i = g.split(":");
                if (i.length === 2) {
                    if (C = i[0], i[1].includes("+") || i[1].includes("-")) {
                        const Z = i[1].includes("+") ? "+" : "-", b = i[1].split(Z);
                        A = b[0].replaceAll(" ", "");
                        const a = parseFloat(b[1].replaceAll(" ", ""));
                        !isNaN(a) && (B = a);
                    } else A = i[1];
                } else if (i.length === 3) {
                    if (l = i[0], C = i[1], i[2].includes("+") || i[2].includes("-")) {
                        const Z = i[2].includes("+") ? "+" : "-", b = i[2].split(Z);
                        A = b[0].replaceAll(" ", "");
                        const a = parseFloat(b[1].replaceAll(" ", ""));
                        !isNaN(a) && (B = a);
                    } else A = i[2];
                }
            }
        } else B = g;
        return {
            referenceId: C,
            referenceParentId: l,
            referenceSyncRef: A,
            additionalTime: B
        };
    }
    _createSyncPoint(g, C) {
        const { referenceId: l, referenceParentId: A, referenceSyncRef: B, additionalTime: o } = this._parseValue(g.value), i = {
            bmlParentId: C,
            parentId: this.id,
            syncReference: g.name,
            referenceId: l,
            referenceParentId: A,
            referenceSyncRef: B,
            additionalTime: o
        };
        this.syncPoints.push(new $e60bcd291a6e9aed$var$tg(i, this.parentId));
    }
    /**
   * For each parent's syncpoint, duplicate it for each child
   */ _createSyncPointForChildren() {
        this.childrenBlocks.length && this.syncPoints.length && this.childrenBlocks.forEach((g)=>{
            const C = [];
            this.syncPoints.forEach((l)=>{
                C.push(new $e60bcd291a6e9aed$var$tg({
                    ...l,
                    parentId: g.id
                }, this.id));
            }), g.syncPoints = C;
        });
    }
    /**
   * Low level block creation function
   * @param {LowLevelBlockData} data
   * @param {string | undefined} parentId
   * @returns {Block | undefined}
   */ _createLowLevelBlock(g, C, l) {
        switch(g.type){
            case $e60bcd291a6e9aed$var$J.FACS:
                return new $e60bcd291a6e9aed$var$rA(g.attributes, C, l);
            case $e60bcd291a6e9aed$var$J.LEXEME:
                return new $e60bcd291a6e9aed$var$vA(g.attributes, C, l);
            case $e60bcd291a6e9aed$var$J.POSE:
                return new $e60bcd291a6e9aed$var$JA(g.attributes, C, l);
            case $e60bcd291a6e9aed$var$J.STANCE:
                return new $e60bcd291a6e9aed$var$NA(g.attributes, C, l);
            case $e60bcd291a6e9aed$var$J.SYNC:
            case $e60bcd291a6e9aed$var$J.TEXT:
            default:
                return;
        }
    }
    processChildren() {
        this.childrenElements.length && (this.childrenElements.forEach((g)=>{
            const C = g.tagName.toLowerCase();
            if (Object.values($e60bcd291a6e9aed$var$J).includes(C)) {
                const l = [];
                g.getAttributeNames().forEach((B)=>{
                    l.push({
                        name: B,
                        value: g.getAttribute(B) || 0
                    });
                });
                const A = this._createLowLevelBlock({
                    type: C,
                    attributes: l
                }, this.id, this.attributes);
                A && (A.shift = this.type.toLowerCase().includes("shift"), this.childrenBlocks.push(A));
            }
        }), this._createSyncPointForChildren());
    }
}
class $e60bcd291a6e9aed$var$kA extends $e60bcd291a6e9aed$var$T {
    constructor(g){
        super({
            attributes: [],
            ...g
        }, g.id);
        $e60bcd291a6e9aed$var$c(this, "characterId");
        $e60bcd291a6e9aed$var$c(this, "composition", $e60bcd291a6e9aed$var$ug.MERGE);
        if (g.characterId && (this.characterId = g.characterId), g.composition) switch(g.composition.toLowerCase()){
            case "merge":
                this.composition = $e60bcd291a6e9aed$var$ug.MERGE;
                const l = {
                    parentId: g.id || "root",
                    syncReference: $e60bcd291a6e9aed$var$v.START,
                    referenceId: "",
                    referenceParentId: "",
                    referenceSyncRef: "",
                    triggerTime: g.currentGlobalTimer
                };
                this.updateTimeline("start", g.currentGlobalTimer), this.syncPoints.push(new $e60bcd291a6e9aed$var$tg(l, this.parentId));
                break;
            case "append":
                this.composition = $e60bcd291a6e9aed$var$ug.APPEND;
                break;
            case "replace":
                this.composition = $e60bcd291a6e9aed$var$ug.REPLACE, g.killAllCurrentTasks();
                break;
        }
        const C = {
            parentId: g.id || "root",
            syncReference: $e60bcd291a6e9aed$var$v.START,
            referenceId: "",
            referenceParentId: "",
            referenceSyncRef: "",
            triggerTime: g.currentGlobalTimer
        };
        this.updateTimeline("start", g.currentGlobalTimer), this.syncPoints.push(new $e60bcd291a6e9aed$var$tg(C, this.parentId));
    }
}
class $e60bcd291a6e9aed$var$zA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "text", "");
        if (g.children && g.children.length === 1 && g.children[0].tagName === $e60bcd291a6e9aed$var$J.TEXT) {
            const l = g.children[0];
            this.text = l.innerHTML;
        }
    }
}
class $e60bcd291a6e9aed$var$MA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        var B;
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "duration");
        const l = (B = g.attributes.find((o)=>o.name === $e60bcd291a6e9aed$var$t.DURATION)) == null ? void 0 : B.value;
        if (this.duration = typeof l == "string" ? parseFloat(l) : l, this.attributes.push({
            name: $e60bcd291a6e9aed$var$t.DURATION,
            value: this.duration || 0
        }), !g.attributes.find((o)=>o.name === $e60bcd291a6e9aed$var$v.END) && this.duration) {
            const o = {
                parentId: this.id,
                syncReference: $e60bcd291a6e9aed$var$v.END,
                referenceId: this.id,
                referenceParentId: this.parentId,
                referenceSyncRef: $e60bcd291a6e9aed$var$v.START,
                additionalTime: this.duration
            };
            this.syncPoints.push(new $e60bcd291a6e9aed$var$tg(o));
        }
    }
}
class $e60bcd291a6e9aed$var$QA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "amount", 1);
        $e60bcd291a6e9aed$var$c(this, "overshoot", 0);
        g.attributes.forEach((l)=>{
            const A = typeof l.value == "number" ? l.value : parseFloat(l.value);
            switch(l.name){
                case $e60bcd291a6e9aed$var$t.AMOUNT:
                    !isNaN(A) && (this.amount = A), this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.AMOUNT,
                        value: this.amount
                    });
                    break;
                case $e60bcd291a6e9aed$var$t.OVERSHOOT:
                    !isNaN(A) && (this.overshoot = A), this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.OVERSHOOT,
                        value: this.overshoot
                    });
                    break;
            }
        });
    }
}
class $e60bcd291a6e9aed$var$UA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "au", 0);
        $e60bcd291a6e9aed$var$c(this, "side", "BOTH");
        $e60bcd291a6e9aed$var$c(this, "amount", 1);
        $e60bcd291a6e9aed$var$c(this, "overshoot", 0);
        g.attributes.forEach((l)=>{
            switch(l.name){
                case $e60bcd291a6e9aed$var$t.SIDE:
                    this.side = l.value.toLowerCase(), this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.SIDE,
                        value: this.side
                    });
                    break;
                case $e60bcd291a6e9aed$var$t.AU:
                    {
                        const A = typeof l.value == "number" ? l.value : parseFloat(l.value);
                        !isNaN(A) && (this.au = A), this.attributes.push({
                            name: $e60bcd291a6e9aed$var$t.AU,
                            value: this.au
                        });
                        break;
                    }
                case $e60bcd291a6e9aed$var$t.AMOUNT:
                    {
                        const A = typeof l.value == "number" ? l.value : parseFloat(l.value);
                        !isNaN(A) && (this.amount = A), this.attributes.push({
                            name: $e60bcd291a6e9aed$var$t.AMOUNT,
                            value: this.amount
                        });
                        break;
                    }
                case $e60bcd291a6e9aed$var$t.OVERSHOOT:
                    {
                        const A = typeof l.value == "number" ? l.value : parseFloat(l.value);
                        !isNaN(A) && (this.overshoot = A), this.attributes.push({
                            name: $e60bcd291a6e9aed$var$t.OVERSHOOT,
                            value: this.overshoot
                        });
                        break;
                    }
            }
        });
    }
}
class $e60bcd291a6e9aed$var$DA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "lexeme", "");
        $e60bcd291a6e9aed$var$c(this, "amount", 1);
        $e60bcd291a6e9aed$var$c(this, "overshoot", 0);
        g.attributes.forEach((l)=>{
            switch(l.name){
                case $e60bcd291a6e9aed$var$t.LEXEME:
                    this.lexeme = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.LEXEME,
                        value: this.lexeme
                    });
                    break;
                case $e60bcd291a6e9aed$var$t.AMOUNT:
                    {
                        const A = typeof l.value == "number" ? l.value : parseFloat(l.value);
                        !isNaN(A) && (this.amount = A), this.attributes.push({
                            name: $e60bcd291a6e9aed$var$t.AMOUNT,
                            value: this.amount
                        });
                        break;
                    }
                case $e60bcd291a6e9aed$var$t.OVERSHOOT:
                    {
                        const A = typeof l.value == "number" ? l.value : parseFloat(l.value);
                        !isNaN(A) && (this.overshoot = A), this.attributes.push({
                            name: $e60bcd291a6e9aed$var$t.OVERSHOOT,
                            value: this.overshoot
                        });
                        break;
                    }
            }
        });
    }
}
class $e60bcd291a6e9aed$var$TA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "amount", 1);
        g.attributes.forEach((l)=>{
            switch(l.name){
                case $e60bcd291a6e9aed$var$t.AMOUNT:
                    {
                        const A = typeof l.value == "number" ? l.value : parseFloat(l.value);
                        !isNaN(A) && (this.amount = A), this.attributes.push({
                            name: $e60bcd291a6e9aed$var$t.AMOUNT,
                            value: this.amount
                        });
                        break;
                    }
            }
        });
    }
}
class $e60bcd291a6e9aed$var$xA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "target", "");
        $e60bcd291a6e9aed$var$c(this, "influence", "");
        $e60bcd291a6e9aed$var$c(this, "offsetAngle", 0);
        $e60bcd291a6e9aed$var$c(this, "offsetDirection", "RIGHT");
        g.attributes.forEach((l)=>{
            switch(l.name){
                case $e60bcd291a6e9aed$var$t.TARGET:
                    this.target = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.TARGET,
                        value: this.target
                    });
                    break;
                case $e60bcd291a6e9aed$var$t.INFLUENCE:
                    this.influence = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.INFLUENCE,
                        value: this.influence
                    });
                    break;
                case $e60bcd291a6e9aed$var$t.OFFSETANGLE:
                    {
                        const A = typeof l.value == "number" ? l.value : parseFloat(l.value);
                        !isNaN(A) && (this.offsetAngle = A), this.attributes.push({
                            name: $e60bcd291a6e9aed$var$t.OFFSETANGLE,
                            value: this.offsetAngle
                        });
                        break;
                    }
                case $e60bcd291a6e9aed$var$t.OFFSETDIRECTION:
                    this.offsetDirection = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.OFFSETDIRECTION,
                        value: this.offsetDirection
                    });
                    break;
            }
        });
    }
}
class $e60bcd291a6e9aed$var$EA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "target", "");
        $e60bcd291a6e9aed$var$c(this, "influence");
        $e60bcd291a6e9aed$var$c(this, "offsetAngle", 0);
        $e60bcd291a6e9aed$var$c(this, "offsetDirection", "RIGHT");
        g.attributes.forEach((l)=>{
            switch(l.name){
                case $e60bcd291a6e9aed$var$t.TARGET:
                    this.target = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.TARGET,
                        value: this.target
                    });
                    break;
                case $e60bcd291a6e9aed$var$t.INFLUENCE:
                    this.influence = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.INFLUENCE,
                        value: this.influence
                    });
                    break;
                case $e60bcd291a6e9aed$var$t.OFFSETANGLE:
                    {
                        const A = typeof l.value == "number" ? l.value : parseFloat(l.value);
                        !isNaN(A) && (this.offsetAngle = A), this.attributes.push({
                            name: $e60bcd291a6e9aed$var$t.OFFSETANGLE,
                            value: this.offsetAngle
                        });
                        break;
                    }
                case $e60bcd291a6e9aed$var$t.OFFSETDIRECTION:
                    this.offsetDirection = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.OFFSETDIRECTION,
                        value: this.offsetDirection
                    });
                    break;
            }
        });
    }
}
class $e60bcd291a6e9aed$var$jA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "mode");
        $e60bcd291a6e9aed$var$c(this, "lexeme", "");
        g.attributes.forEach((l)=>{
            switch(l.name){
                case $e60bcd291a6e9aed$var$t.MODE:
                    this.mode = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.MODE,
                        value: this.mode
                    });
                    break;
                case $e60bcd291a6e9aed$var$t.LEXEME:
                    this.lexeme = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.LEXEME,
                        value: this.lexeme
                    });
                    break;
            }
        });
    }
}
class $e60bcd291a6e9aed$var$fA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "mode");
        $e60bcd291a6e9aed$var$c(this, "target");
        g.attributes.forEach((l)=>{
            switch(l.name){
                case $e60bcd291a6e9aed$var$t.MODE:
                    this.mode = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.MODE,
                        value: this.mode
                    });
                    break;
                case $e60bcd291a6e9aed$var$t.TARGET:
                    this.target = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.TARGET,
                        value: this.target
                    });
                    break;
            }
        });
    }
}
class $e60bcd291a6e9aed$var$PA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "lexeme", "");
        $e60bcd291a6e9aed$var$c(this, "repetition", 1);
        $e60bcd291a6e9aed$var$c(this, "amount", 1);
        g.attributes.forEach((l)=>{
            switch(l.name){
                case $e60bcd291a6e9aed$var$t.LEXEME:
                    this.lexeme = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.LEXEME,
                        value: this.lexeme
                    });
                    break;
                case $e60bcd291a6e9aed$var$t.REPETITION:
                    {
                        const A = typeof l.value == "number" ? l.value : parseFloat(l.value);
                        !isNaN(A) && (this.repetition = A), this.attributes.push({
                            name: $e60bcd291a6e9aed$var$t.REPETITION,
                            value: this.repetition
                        });
                        break;
                    }
                case $e60bcd291a6e9aed$var$t.AMOUNT:
                    {
                        const A = typeof l.value == "number" ? l.value : parseFloat(l.value);
                        !isNaN(A) && (this.amount = A), this.attributes.push({
                            name: $e60bcd291a6e9aed$var$t.AMOUNT,
                            value: this.amount
                        });
                        break;
                    }
            }
        });
    }
}
class $e60bcd291a6e9aed$var$qA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "target", "");
        g.attributes.forEach((l)=>{
            switch(l.name){
                case $e60bcd291a6e9aed$var$t.TARGET:
                    this.target = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.TARGET,
                        value: this.target
                    });
                    break;
            }
        });
    }
}
class $e60bcd291a6e9aed$var$OA extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "target", "");
        $e60bcd291a6e9aed$var$c(this, "manner");
        g.attributes.forEach((l)=>{
            switch(l.name){
                case $e60bcd291a6e9aed$var$t.TARGET:
                    this.target = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.TARGET,
                        value: this.target
                    });
                    break;
                case $e60bcd291a6e9aed$var$t.MANNER:
                    this.manner = l.value, this.attributes.push({
                        name: $e60bcd291a6e9aed$var$t.MANNER,
                        value: this.manner
                    });
                    break;
            }
        });
    }
}
class $e60bcd291a6e9aed$var$_A extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "stance");
        $e60bcd291a6e9aed$var$c(this, "poses");
    }
}
class $e60bcd291a6e9aed$var$$A extends $e60bcd291a6e9aed$var$T {
    constructor(g, C){
        super(g, C);
        $e60bcd291a6e9aed$var$c(this, "stance");
        $e60bcd291a6e9aed$var$c(this, "poses");
    }
}
class $e60bcd291a6e9aed$var$gG {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "parentRealizer");
        $e60bcd291a6e9aed$var$c(this, "parsedBlocks");
        this.parentRealizer = I, this.parsedBlocks = [];
    }
    /**
   * Block creation function for any type of tag
   * @param {RootAttribute | BlockData} data
   * @param {string | undefined} parentId
   * @returns {Block}
   */ _createBlock(I, g) {
        switch(I.type){
            case $e60bcd291a6e9aed$var$S.BML:
                return new $e60bcd291a6e9aed$var$kA(I);
            case $e60bcd291a6e9aed$var$S.WAIT:
                return new $e60bcd291a6e9aed$var$MA(I, g);
            case $e60bcd291a6e9aed$var$S.FACE:
                return new $e60bcd291a6e9aed$var$QA(I, g);
            case $e60bcd291a6e9aed$var$S.FACEFACS:
                return new $e60bcd291a6e9aed$var$UA(I, g);
            case $e60bcd291a6e9aed$var$S.FACELEXEME:
                return new $e60bcd291a6e9aed$var$DA(I, g);
            case $e60bcd291a6e9aed$var$S.FACESHIFT:
                return new $e60bcd291a6e9aed$var$TA(I, g);
            case $e60bcd291a6e9aed$var$S.GAZE:
                return new $e60bcd291a6e9aed$var$xA(I, g);
            case $e60bcd291a6e9aed$var$S.GAZESHIFT:
                return new $e60bcd291a6e9aed$var$EA(I, g);
            case $e60bcd291a6e9aed$var$S.GESTURE:
                return new $e60bcd291a6e9aed$var$jA(I, g);
            case $e60bcd291a6e9aed$var$S.POINTING:
                return new $e60bcd291a6e9aed$var$fA(I, g);
            case $e60bcd291a6e9aed$var$S.HEAD:
                return new $e60bcd291a6e9aed$var$PA(I, g);
            case $e60bcd291a6e9aed$var$S.HEADDIRECTIONSHIFT:
                return new $e60bcd291a6e9aed$var$qA(I, g);
            case $e60bcd291a6e9aed$var$S.LOCOMOTION:
                return new $e60bcd291a6e9aed$var$OA(I, g);
            case $e60bcd291a6e9aed$var$S.POSTURE:
                return new $e60bcd291a6e9aed$var$_A(I, g);
            case $e60bcd291a6e9aed$var$S.POSTURESHIFT:
                return new $e60bcd291a6e9aed$var$$A(I, g);
            case $e60bcd291a6e9aed$var$S.SPEECH:
                return new $e60bcd291a6e9aed$var$zA(I, g);
            default:
                return;
        }
    }
    /**
   * Process any tag other than `<bml>` to create a corresponding Block
   * @param {string} parentId
   * @param {Element} child
   * @returns {Block}
   */ _processChild(I, g) {
        const C = g.tagName.toLowerCase();
        if ($e60bcd291a6e9aed$var$yg[C]) {
            const l = $e60bcd291a6e9aed$var$yg[C].attributes, A = $e60bcd291a6e9aed$var$yg[C].contents, B = [];
            g.getAttributeNames().filter((i)=>l.includes(i.toLowerCase())).forEach((i)=>B.push({
                    name: i.toLowerCase(),
                    value: g.getAttribute(i) || 0
                }));
            const o = [];
            return A && g.hasChildNodes() && Array.from(g.children).forEach((i)=>{
                A.includes(i.tagName) && o.push(i);
            }), this._createBlock({
                type: C,
                attributes: B,
                children: o
            }, I);
        }
    }
    /**
   * Process a `<bml>` tag to create a BmlBlock
   * @param {Element} root
   * @param {number} currentGlobalTimer
   * @returns {Block}
   */ _processRoot(I) {
        const g = {
            id: void 0,
            type: $e60bcd291a6e9aed$var$S.BML,
            characterId: void 0,
            composition: void 0,
            currentGlobalTimer: this.parentRealizer.globalTimer,
            killAllCurrentTasks: this.parentRealizer.onKillAll
        };
        return I.getAttributeNames().filter((C)=>$e60bcd291a6e9aed$var$yg.bml.attributes.includes(C)).forEach((C)=>g[C] = I.getAttribute(C)), this._createBlock(g);
    }
    /**
   * Check if the data are enclosed in a single `<bml>` tag or if there are several `<bml>` tags to process, and 
   * call processRoot and processChild to create the cooresponding array of Block
   * @param {HTMLElement} rootElement
   * @param {number} currentGlobalTimer current global timer from the bml realizer to update timelines accordingly when creating a bmlblock
   * @returns {Array<Block> | null}
   */ _parseXML(I) {
        const g = [], C = I.getElementsByTagName("bml");
        if (C.length) Array.from(C).forEach((l)=>{
            const A = l.getAttribute("id"), B = this._processRoot(l);
            B && g.push(B), Array.from(l.children).forEach((o)=>{
                var Z;
                const i = A ? this._processChild(A, o) : void 0;
                i && (g.push(i), i.processChildren(), (Z = i.childrenBlocks) == null || Z.forEach((b)=>{
                    g.push(b);
                }));
            });
        });
        else if (I.tagName === "bml" && I.childElementCount) {
            const l = I.getAttribute("id"), A = this._processRoot(I);
            A && g.push(A), Array.from(I.children).forEach((B)=>{
                var i;
                const o = l ? this._processChild(l, B) : void 0;
                o && (g.push(o), o.processChildren(), (i = o.childrenBlocks) == null || i.forEach((Z)=>{
                    g.push(Z);
                }));
            });
        }
        return g.length ? g : null;
    }
    /**
   * Parse an XMLDocument or a string to create the corresponding Blocks and SyncPoints used by the Realizer 
   * @param {string | XMLDocument} bmlDocument
   * @returns {Array<Block> | null}
   */ parse(I) {
        if (typeof I == "string") {
            const C = new DOMParser().parseFromString(I, "text/xml").documentElement;
            return this._parseXML(C);
        } else if (typeof I === XMLDocument.toString()) return this._parseXML(I.documentElement);
        return null;
    }
}
const $e60bcd291a6e9aed$var$IG = [
    $e60bcd291a6e9aed$var$S.FACEFACS,
    $e60bcd291a6e9aed$var$S.FACELEXEME,
    $e60bcd291a6e9aed$var$S.FACESHIFT,
    $e60bcd291a6e9aed$var$J.FACS,
    $e60bcd291a6e9aed$var$J.LEXEME
];
class $e60bcd291a6e9aed$var$CG {
    constructor(I, g, C){
        $e60bcd291a6e9aed$var$c(this, "parser");
        $e60bcd291a6e9aed$var$c(this, "bmlBlocks", []);
        $e60bcd291a6e9aed$var$c(this, "syncPoints", []);
        $e60bcd291a6e9aed$var$c(this, "finishedTasks", []);
        $e60bcd291a6e9aed$var$c(this, "globalTimer", 0);
        $e60bcd291a6e9aed$var$c(this, "_started", !1);
        $e60bcd291a6e9aed$var$c(this, "onFinish", ()=>{});
        $e60bcd291a6e9aed$var$c(this, "onKillAll", this.flush);
        this.parser = new $e60bcd291a6e9aed$var$gG(this), g && (this.onFinish = g), C && (this.onKillAll = ()=>{
            C(), this.flush();
        }), I && this.parse(I);
    }
    get started() {
        return this._started;
    }
    parse(I) {
        const g = this.parser.parse(I);
        if (g && (this.bmlBlocks = [
            ...this.bmlBlocks,
            ...g
        ]), this.bmlBlocks.length) {
            let C = [
                ...this.syncPoints
            ];
            this.bmlBlocks.forEach((l)=>{
                l.syncPoints.length && (C = [
                    ...C,
                    ...l.syncPoints
                ]);
            }), this.syncPoints = C;
        }
        !this._started && this.start();
    }
    update(I) {
        if (this._started) {
            this.globalTimer += I;
            let g = !1, C = [];
            const l = [];
            for(; !g;)g = !0, C = [], this.syncPoints.forEach((A)=>{
                var Z;
                let B;
                A.triggerTime === void 0 && (B = this.syncPoints.find((b)=>b.id === `${A.referenceParentId || A.bmlParentId}_${A.referenceId}_${A.referenceSyncRef}`));
                const { ended: o, updateTimeline: i } = A.update(this.globalTimer, this.finishedTasks, B == null ? void 0 : B.triggerTime);
                if (i !== void 0) {
                    const b = this.bmlBlocks.find((a)=>a.id === A.parentId);
                    b == null || b.updateTimeline(A.syncReference, i);
                }
                if (o) {
                    g = !1;
                    const b = {
                        blockType: ((Z = this.bmlBlocks.find((a)=>a.id === A.parentId)) == null ? void 0 : Z.type) || $e60bcd291a6e9aed$var$S.OTHER,
                        blockId: A.parentId,
                        syncRef: A.syncReference
                    };
                    this.finishedTasks.push(b), l.push(b);
                } else C.push(A);
            }), this.syncPoints = [
                ...C
            ];
            if (l.length) {
                console.log("Finished tasks : ", l);
                const A = [];
                l.forEach((B)=>{
                    $e60bcd291a6e9aed$var$IG.includes(B.blockType) ? B.syncRef === $e60bcd291a6e9aed$var$v.START && A.push(B) : this.onFinish(B);
                }), A.length && console.log("Au array : ", A), A.length && this.onFinish(A);
            }
        }
    }
    start() {
        this._started || (this._started = !0, this.globalTimer = 0, this.update(0));
    }
    flush() {
        this.bmlBlocks = [], this.syncPoints = [], this.finishedTasks = [];
    }
    reset() {
        this._started = !1, this.flush(), this.globalTimer = 0;
    }
}
const $e60bcd291a6e9aed$var$SC = {
    au: [
        1,
        4
    ],
    side: "both"
}, $e60bcd291a6e9aed$var$pC = {
    au: [
        1,
        2
    ],
    side: "both"
}, $e60bcd291a6e9aed$var$YC = {
    au: [
        1,
        2
    ],
    side: "left"
}, $e60bcd291a6e9aed$var$KC = {
    au: [
        1,
        2
    ],
    side: "right"
}, $e60bcd291a6e9aed$var$RC = {
    au: [
        4
    ],
    side: "both"
}, $e60bcd291a6e9aed$var$wC = {
    au: [
        4
    ],
    side: "left"
}, $e60bcd291a6e9aed$var$LC = {
    au: [
        4
    ],
    side: "right"
}, $e60bcd291a6e9aed$var$FC = {
    au: [
        15
    ],
    side: "both"
}, $e60bcd291a6e9aed$var$JC = {
    au: [
        15
    ],
    side: "left"
}, $e60bcd291a6e9aed$var$NC = {
    au: [
        15
    ],
    side: "right"
}, $e60bcd291a6e9aed$var$vC = {
    au: [
        12
    ],
    side: "both"
}, $e60bcd291a6e9aed$var$rC = {
    au: [
        12
    ],
    side: "left"
}, $e60bcd291a6e9aed$var$kC = {
    au: [
        12
    ],
    side: "right"
}, $e60bcd291a6e9aed$var$zC = {
    au: [
        25,
        26
    ],
    side: null
}, $e60bcd291a6e9aed$var$MC = {
    au: [
        25
    ],
    side: null
}, $e60bcd291a6e9aed$var$QC = {
    au: [
        5,
        7
    ],
    side: null
}, $e60bcd291a6e9aed$var$UC = {
    au: [
        45
    ],
    side: null
}, $e60bcd291a6e9aed$var$lG = {
    OBLIQUE_BROWS: $e60bcd291a6e9aed$var$SC,
    RAISE_BROWS: $e60bcd291a6e9aed$var$pC,
    RAISE_LEFT_BROW: $e60bcd291a6e9aed$var$YC,
    RAISE_RIGHT_BROW: $e60bcd291a6e9aed$var$KC,
    LOWER_BROWS: $e60bcd291a6e9aed$var$RC,
    LOWER_LEFT_BROW: $e60bcd291a6e9aed$var$wC,
    LOWER_RIGHT_BROW: $e60bcd291a6e9aed$var$LC,
    LOWER_MOUTH_CORNERS: $e60bcd291a6e9aed$var$FC,
    LOWER_LEFT_MOUTH_CORNER: $e60bcd291a6e9aed$var$JC,
    LOWER_RIGHT_MOUTH_CORNER: $e60bcd291a6e9aed$var$NC,
    RAISE_MOUTH_CORNERS: $e60bcd291a6e9aed$var$vC,
    RAISE_LEFT_MOUTH_CORNER: $e60bcd291a6e9aed$var$rC,
    RAISE_RIGHT_MOUTH_CORNER: $e60bcd291a6e9aed$var$kC,
    OPEN_MOUTH: $e60bcd291a6e9aed$var$zC,
    OPEN_LIPS: $e60bcd291a6e9aed$var$MC,
    WIDEN_EYES: $e60bcd291a6e9aed$var$QC,
    CLOSE_EYES: $e60bcd291a6e9aed$var$UC
}, $e60bcd291a6e9aed$var$uI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    CLOSE_EYES: $e60bcd291a6e9aed$var$UC,
    LOWER_BROWS: $e60bcd291a6e9aed$var$RC,
    LOWER_LEFT_BROW: $e60bcd291a6e9aed$var$wC,
    LOWER_LEFT_MOUTH_CORNER: $e60bcd291a6e9aed$var$JC,
    LOWER_MOUTH_CORNERS: $e60bcd291a6e9aed$var$FC,
    LOWER_RIGHT_BROW: $e60bcd291a6e9aed$var$LC,
    LOWER_RIGHT_MOUTH_CORNER: $e60bcd291a6e9aed$var$NC,
    OBLIQUE_BROWS: $e60bcd291a6e9aed$var$SC,
    OPEN_LIPS: $e60bcd291a6e9aed$var$MC,
    OPEN_MOUTH: $e60bcd291a6e9aed$var$zC,
    RAISE_BROWS: $e60bcd291a6e9aed$var$pC,
    RAISE_LEFT_BROW: $e60bcd291a6e9aed$var$YC,
    RAISE_LEFT_MOUTH_CORNER: $e60bcd291a6e9aed$var$rC,
    RAISE_MOUTH_CORNERS: $e60bcd291a6e9aed$var$vC,
    RAISE_RIGHT_BROW: $e60bcd291a6e9aed$var$KC,
    RAISE_RIGHT_MOUTH_CORNER: $e60bcd291a6e9aed$var$kC,
    WIDEN_EYES: $e60bcd291a6e9aed$var$QC,
    default: $e60bcd291a6e9aed$var$lG
}, Symbol.toStringTag, {
    value: "Module"
})), $e60bcd291a6e9aed$var$DC = {
    planes: [
        "x"
    ],
    upperlimit: [
        25
    ]
}, $e60bcd291a6e9aed$var$TC = {
    planes: [
        "y"
    ],
    upperlimit: [
        20
    ],
    lowerlimit: [
        -20
    ],
    forthAndBack: !0
}, $e60bcd291a6e9aed$var$xC = {
    planes: [
        "z"
    ],
    upperlimit: [
        20
    ],
    lowerlimit: [
        -20
    ]
}, $e60bcd291a6e9aed$var$EC = {
    planes: [
        "y"
    ],
    upperlimit: [
        25
    ]
}, $e60bcd291a6e9aed$var$jC = {
    planes: [
        "y"
    ],
    upperlimit: [
        25
    ]
}, $e60bcd291a6e9aed$var$fC = {
    planes: [
        "x"
    ],
    upperlimit: [
        20
    ]
}, $e60bcd291a6e9aed$var$PC = {
    planes: [
        "x"
    ],
    upperlimit: [
        20
    ]
}, $e60bcd291a6e9aed$var$AG = {
    NOD: $e60bcd291a6e9aed$var$DC,
    SHAKE: $e60bcd291a6e9aed$var$TC,
    TILT: $e60bcd291a6e9aed$var$xC,
    MOVE_LEFT: $e60bcd291a6e9aed$var$EC,
    MOVE_RIGHT: $e60bcd291a6e9aed$var$jC,
    MOVE_UP: $e60bcd291a6e9aed$var$fC,
    MOVE_DOWN: $e60bcd291a6e9aed$var$PC
}, $e60bcd291a6e9aed$var$WI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    MOVE_DOWN: $e60bcd291a6e9aed$var$PC,
    MOVE_LEFT: $e60bcd291a6e9aed$var$EC,
    MOVE_RIGHT: $e60bcd291a6e9aed$var$jC,
    MOVE_UP: $e60bcd291a6e9aed$var$fC,
    NOD: $e60bcd291a6e9aed$var$DC,
    SHAKE: $e60bcd291a6e9aed$var$TC,
    TILT: $e60bcd291a6e9aed$var$xC,
    default: $e60bcd291a6e9aed$var$AG
}, Symbol.toStringTag, {
    value: "Module"
})), $e60bcd291a6e9aed$var$GG = new RegExp("((leftshoulder)|(leftarm)|(leftforearm)|(lefthand))+", "i"), $e60bcd291a6e9aed$var$BG = new RegExp("((rightshoulder)|(rightarm)|(rightforearm)|(righthand))+", "i"), $e60bcd291a6e9aed$var$nI = "https://cdn.retorik.ai/bodyengine-three/animations/bml/", $e60bcd291a6e9aed$var$tI = {
    left: {
        x: 2,
        y: 1,
        z: 1
    },
    right: {
        x: -2,
        y: 1,
        z: 1
    }
};
class $e60bcd291a6e9aed$export$f9531379b7476954 {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "_realizer", null);
        $e60bcd291a6e9aed$var$c(this, "_globalManager");
        $e60bcd291a6e9aed$var$c(this, "_animationClipMap", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_animationActionMap", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "_playingAnimations", /* @__PURE__ */ new Map());
        this._realizer = new $e60bcd291a6e9aed$var$CG(void 0, (g)=>this.handleBreakPoint(g), ()=>this.killAllPlayingAnimations()), this._globalManager = I;
    }
    get animationActionMap() {
        return this._animationActionMap;
    }
    _removeTracksAndMakeAction(I) {
        var C, l, A;
        let g;
        return I.name.includes("_BG") ? g = $e60bcd291a6e9aed$var$GG : I.name.includes("_BD") && (g = $e60bcd291a6e9aed$var$BG), g && (I.tracks = I.tracks.filter((B)=>g.test(B.name))), this._animationClipMap.set(I.name, I), (A = (l = (C = this._globalManager) == null ? void 0 : C.animationManager) == null ? void 0 : l.animationMixer) == null ? void 0 : A.clipAction(I);
    }
    async loadAnimations(I) {
        const g = await fetch(`${$e60bcd291a6e9aed$var$nI}list.json`).then((l)=>l.json()), C = [];
        g.forEach((l)=>{
            C.push({
                url: `${$e60bcd291a6e9aed$var$nI}${l[0]}`,
                name: l[0].split(".")[0]
            });
        });
        for (const l of C)await new Promise(async (A, B)=>{
            var Z, b;
            const o = {
                url: l.url,
                name: void 0,
                returnClip: !0
            }, i = await ((b = (Z = this._globalManager) == null ? void 0 : Z.animationManager) == null ? void 0 : b.addCC4Animation(o));
            if (i) {
                i.name = `bml_${l.name}`;
                const a = this._removeTracksAndMakeAction(i);
                a && (a.setLoop($329ek.LoopPingPong, 2), a.clampWhenFinished = !0, this._animationActionMap.set(i.name, {
                    action: a,
                    defaultDuration: i.duration
                }));
            }
            A();
        });
        return !0;
    }
    _handleFaceFacs(I) {
        var l;
        let g = 0;
        const C = [];
        I.forEach((A)=>{
            var o, i, Z, b, a, m;
            const B = (o = this._realizer) == null ? void 0 : o.bmlBlocks.find((e)=>e.id === A.blockId);
            if (B) {
                const e = B.timeline.start !== void 0 && B.timeline.end !== void 0 && B.timeline.end > B.timeline.start ? B.timeline.end - B.timeline.start : 0;
                switch(e > g && (g = e), B.type){
                    case $e60bcd291a6e9aed$var$S.FACEFACS:
                        {
                            const s = B;
                            C.push({
                                index: s.au,
                                strength: s.amount || 0,
                                side: ((i = s.side) == null ? void 0 : i.toLowerCase()) || void 0,
                                duration: e,
                                timeline: s.timeline
                            });
                            break;
                        }
                    case $e60bcd291a6e9aed$var$J.FACS:
                        {
                            const s = B;
                            C.push({
                                index: s.au,
                                strength: s.amount || 0,
                                side: ((Z = s.side) == null ? void 0 : Z.toLowerCase()) || void 0,
                                duration: e,
                                timeline: s.timeline,
                                shift: s.shift
                            });
                            break;
                        }
                    case $e60bcd291a6e9aed$var$S.FACELEXEME:
                        {
                            const s = B, u = $e60bcd291a6e9aed$var$uI[s.lexeme];
                            (b = u == null ? void 0 : u.au) != null && b.length && u.au.forEach((W)=>{
                                var y;
                                C.push({
                                    index: W,
                                    strength: s.amount || 0,
                                    side: ((y = u.side) == null ? void 0 : y.toLowerCase()) || void 0,
                                    duration: e,
                                    timeline: s.timeline
                                });
                            });
                            break;
                        }
                    case $e60bcd291a6e9aed$var$J.LEXEME:
                        {
                            const s = B, u = $e60bcd291a6e9aed$var$uI[s.lexeme];
                            if ((a = u == null ? void 0 : u.au) != null && a.length) {
                                const W = (m = s.parentAttributes.find((y)=>y.name === "amount")) == null ? void 0 : m.value;
                                u.au.forEach((y)=>{
                                    var h;
                                    C.push({
                                        index: y,
                                        strength: typeof W == "number" ? W : 0,
                                        side: ((h = u.side) == null ? void 0 : h.toLowerCase()) || void 0,
                                        duration: e,
                                        timeline: s.timeline,
                                        shift: s.shift
                                    });
                                });
                            }
                            break;
                        }
                }
            }
        }), (l = this._globalManager) == null || l.FACSManager.updateFacialAnimation(C, g);
    }
    _handleHead(I, g) {
        var C, l, A;
        if (I.lexeme && $e60bcd291a6e9aed$var$WI[I.lexeme]) {
            const B = $e60bcd291a6e9aed$var$WI[I.lexeme];
            if (I.amount) for(let o = 0; o < B.planes.length; o++)B.upperlimit[o] *= I.amount, (C = B.lowerlimit) != null && C.length && (B.lowerlimit[o] *= I.amount);
            (A = (l = this._globalManager) == null ? void 0 : l.headPoseManager) == null || A.updateHeadPosition({
                ...B,
                repetition: I.repetition,
                timeline: I.timeline
            }, g);
        }
    }
    _handleHeadDirection(I, g) {
        var C, l;
        if (I.target && $e60bcd291a6e9aed$var$tI[I.target]) {
            const A = $e60bcd291a6e9aed$var$tI[I.target], B = {
                planes: [
                    "x",
                    "y",
                    "z"
                ],
                upperlimit: [
                    A.x,
                    A.y,
                    A.z
                ]
            };
            (l = (C = this._globalManager) == null ? void 0 : C.headPoseManager) == null || l.updateHeadPosition({
                ...B,
                repetition: 1,
                timeline: I.timeline,
                shift: !0
            }, g);
        }
    }
    _handlePointing(I, g, C, l) {
        var B, o, i, Z, b, a, m, e, s, u;
        let A = "";
        if (C) switch(C.toLowerCase()){
            case "up":
                A = "bml_gestureup";
                break;
            case "upright":
                A = "bml_gestureupright";
                break;
            case "upleft":
                A = "bml_gestureupleft";
                break;
            case "down":
                A = "bml_gesturedown";
                break;
            case "downright":
                A = "bml_gesturedownright";
                break;
            case "downleft":
                A = "bml_gesturedownleft";
                break;
            case "left":
                A = "bml_gestureleft";
                break;
            case "right":
                A = "bml_gestureright";
                break;
            case "user":
                A = "bml_gestureuser2";
                break;
            case "me":
                A = "bml_gestureme2";
                break;
        }
        if (A) {
            let W;
            switch(g == null ? void 0 : g.toLowerCase()){
                case "left_hand":
                    W = (B = this._animationClipMap.get(A + "_BG")) == null ? void 0 : B.clone();
                    break;
                case "right_hand":
                    W = (o = this._animationClipMap.get(A + "_BD")) == null ? void 0 : o.clone();
                    break;
                case "both_hands":
                    const y = (i = this._animationClipMap.get(A + "_BG")) == null ? void 0 : i.clone(), h = (Z = this._animationClipMap.get(A + "_BD")) == null ? void 0 : Z.clone();
                    y && h && (W = new $329ek.AnimationClip(A + "_BOTH", Math.max(y.duration, h.duration), [
                        ...y.tracks,
                        ...h.tracks
                    ], $329ek.NormalAnimationBlendMode));
                    break;
                default:
                    W = (b = this._animationClipMap.get(A + "_BD")) == null ? void 0 : b.clone();
                    break;
            }
            if (W) {
                this._playingAnimations.size && $329ek.AnimationUtils.makeClipAdditive(W);
                const y = (e = (m = (a = this._globalManager) == null ? void 0 : a.animationManager) == null ? void 0 : m.animationMixer) == null ? void 0 : e.clipAction(W);
                y && (y.setLoop($329ek.LoopPingPong, 2), y.clampWhenFinished = !0, l && y.setDuration(l), (u = (s = this._globalManager) == null ? void 0 : s.animationManager.animationMixer) == null || u.playAnimationAction(y, !!this._playingAnimations.size), this._playingAnimations.set(I, y.getClip().name));
            }
        }
    }
    _handleStartTask(I) {
        var C, l;
        const g = (C = this._realizer) == null ? void 0 : C.bmlBlocks.find((A)=>A.id === I.blockId);
        if (g && g.timeline.start) {
            const A = g.timeline.end, B = A && (l = this._realizer) != null && l.globalTimer ? A - g.timeline.start : 0;
            switch(g.type){
                case $e60bcd291a6e9aed$var$S.FACE:
                case $e60bcd291a6e9aed$var$S.FACESHIFT:
                    break;
                case $e60bcd291a6e9aed$var$S.FACEFACS:
                case $e60bcd291a6e9aed$var$S.FACELEXEME:
                    break;
                case $e60bcd291a6e9aed$var$S.GAZE:
                case $e60bcd291a6e9aed$var$S.GAZESHIFT:
                case $e60bcd291a6e9aed$var$S.GESTURE:
                case $e60bcd291a6e9aed$var$S.HEAD:
                    this._handleHead(g, B);
                    break;
                case $e60bcd291a6e9aed$var$S.HEADDIRECTIONSHIFT:
                    this._handleHeadDirection(g, B);
                    break;
                case $e60bcd291a6e9aed$var$S.LOCOMOTION:
                    break;
                case $e60bcd291a6e9aed$var$S.POINTING:
                    this._handlePointing(I.blockId, g.mode, g.target, B);
                    break;
                case $e60bcd291a6e9aed$var$S.POSTURE:
                case $e60bcd291a6e9aed$var$S.POSTURESHIFT:
                    break;
                case $e60bcd291a6e9aed$var$S.SPEECH:
                case $e60bcd291a6e9aed$var$S.WAIT:
                    break;
                case $e60bcd291a6e9aed$var$J.FACS:
                case $e60bcd291a6e9aed$var$J.LEXEME:
                    break;
                case $e60bcd291a6e9aed$var$J.POSE:
                case $e60bcd291a6e9aed$var$J.STANCE:
                    break;
            }
        }
    }
    _handleEndTask(I) {
        this._playingAnimations.has(I.blockId) && this._playingAnimations.delete(I.blockId);
    }
    killAllPlayingAnimations() {
        this._playingAnimations.size && (this._playingAnimations.forEach((I)=>{
            var g, C;
            (C = (g = this._globalManager) == null ? void 0 : g.animationManager) == null || C.stopAnimation(I, !0);
        }), this._playingAnimations = /* @__PURE__ */ new Map());
    }
    handleBreakPoint(I) {
        if (Array.isArray(I)) this._handleFaceFacs(I);
        else switch(I.syncRef){
            case $e60bcd291a6e9aed$var$v.START:
                this._handleStartTask(I);
                break;
            case $e60bcd291a6e9aed$var$v.END:
                this._handleEndTask(I);
                break;
        }
    }
    parse(I) {
        var g;
        I && ((g = this._realizer) == null || g.parse(I));
    }
    update(I) {
        var g;
        (g = this._realizer) == null || g.update(I);
    }
}
class $e60bcd291a6e9aed$export$2576c57b80b9d210 {
    constructor(I, g = 60){
        /** morphName → managerName → contribution */ $e60bcd291a6e9aed$var$c(this, "_contributions", /* @__PURE__ */ new Map());
        /** Cached skinned mesh references. */ $e60bcd291a6e9aed$var$c(this, "_skinnedMeshes", []);
        /** Per-mesh exclusion set: meshName → Set<morphName>. */ $e60bcd291a6e9aed$var$c(this, "_excludedMorphsPerMesh", /* @__PURE__ */ new Map());
        /** Morph targets that require temporal smoothing this frame. */ $e60bcd291a6e9aed$var$c(this, "_smoothMorphs", /* @__PURE__ */ new Set());
        /**
     * Controls the speed of the exponential smoothing applied to morphs
     * marked with `smooth = true`.  Higher values converge faster.
     *
     * At 60 fps (dt ≈ 0.0167 s) with the default value of 60:
     *   lerp factor per frame ≈ 0.63 → reaches 95 % of target in ~3 frames (~50 ms).
     * At 30 fps (dt ≈ 0.033 s):
     *   lerp factor per frame ≈ 0.86 → reaches 98 % in ~2 frames (~66 ms).
     */ $e60bcd291a6e9aed$var$c(this, "_smoothingSpeed");
        this._smoothingSpeed = g, this._resolveSkinnedMeshes(I);
    }
    /** Re-scan the mesh hierarchy for SkinnedMesh nodes. */ refreshMeshes(I) {
        this._resolveSkinnedMeshes(I);
    }
    /**
   * Prevent specific morph targets from being applied on a given mesh.
   * Useful for e.g. the Avaturn Eye_Mesh gaze flicker workaround.
   */ excludeMorphsOnMesh(I, g) {
        const C = this._excludedMorphsPerMesh.get(I);
        C ? g.forEach((l)=>C.add(l)) : this._excludedMorphsPerMesh.set(I, new Set(g));
    }
    /**
   * Record a manager's desired value for a morph target this frame.
   *
   * @param managerName  Unique string identifying the source manager (e.g. "blendshape", "lipsync", "facs").
   * @param morphName    Name of the morph target (must match `morphTargetDictionary` keys).
   * @param value        Desired value for this morph target (typically 0–1).
   * @param weight       Multiplier applied to the value during resolution (default 1).
   * @param priority     Higher priority contributions are resolved first (default 0).
   * @param blendMode    "override" sets a base value; "additive" adds on top (default "override").
   * @param smooth       When true, the resolved value is exponentially interpolated from
   *                     the current mesh value toward the target, preventing abrupt pops.
   *                     Managers that already provide their own interpolation (e.g.
   *                     BlendshapeManager, LipSyncManager) should leave this false.
   */ set(I, g, C, l = 1, A = 0, B = "override", o = !1) {
        let i = this._contributions.get(g);
        i || (i = /* @__PURE__ */ new Map(), this._contributions.set(g, i)), i.set(I, {
            value: C,
            weight: l,
            priority: A,
            blendMode: B
        }), o && this._smoothMorphs.add(g);
    }
    /**
   * Compute final morph-target values and write them to all matching
   * SkinnedMesh nodes.  Clears all contributions afterwards.
   *
   * For morph targets marked as `smooth`, the value is exponentially
   * interpolated from the current mesh value toward the resolved target.
   * This replicates the implicit temporal smoothing that the old
   * `NumberKeyframeTrack` approach provided via the AnimationMixer.
   *
   * @param deltaTime  Frame delta in **seconds** — used to compute a
   *                   framerate-independent lerp factor for smooth morphs.
   *                   Pass 0 (or omit) to disable smoothing entirely.
   */ resolve(I = 0) {
        const g = I > 0 ? 1 - Math.exp(-this._smoothingSpeed * I) : 1;
        for (const [C, l] of this._contributions){
            const A = [
                ...l.entries()
            ].sort((Z, b)=>b[1].priority - Z[1].priority);
            let B = 0, o = !1;
            for (const [, Z] of A)Z.blendMode === "override" && !o ? (B = Z.value * Z.weight, o = !0) : Z.blendMode === "additive" && (B += Z.value * Z.weight);
            B = Math.max(0, Math.min(1, B));
            const i = this._smoothMorphs.has(C) && g < 1;
            for (const Z of this._skinnedMeshes){
                const b = this._excludedMorphsPerMesh.get(Z.name);
                if (b != null && b.has(C)) continue;
                const a = Z.morphTargetDictionary, m = Z.morphTargetInfluences, e = a[C];
                if (e !== void 0) {
                    if (i) {
                        const s = m[e];
                        m[e] = s + (B - s) * g;
                    } else m[e] = B;
                }
            }
        }
        this._contributions.clear(), this._smoothMorphs.clear();
    }
    _resolveSkinnedMeshes(I) {
        this._skinnedMeshes = [], I.traverse((g)=>{
            g.type === "SkinnedMesh" && g.morphTargetDictionary && g.morphTargetInfluences && this._skinnedMeshes.push(g);
        });
    }
}
const $e60bcd291a6e9aed$var$qC = {
    left: {
        up: "eyeLookUpLeft",
        down: "eyeLookDownLeft",
        in: "eyeLookInLeft",
        out: "eyeLookOutLeft"
    },
    right: {
        up: "eyeLookUpRight",
        down: "eyeLookDownRight",
        in: "eyeLookInRight",
        out: "eyeLookOutRight"
    }
}, $e60bcd291a6e9aed$var$cG = [
    "eyeLookUpLeft",
    "eyeLookDownLeft",
    "eyeLookInLeft",
    "eyeLookOutLeft",
    "eyeLookUpRight",
    "eyeLookDownRight",
    "eyeLookInRight",
    "eyeLookOutRight"
], $e60bcd291a6e9aed$var$oG = {
    left: {
        up: "Eye_L_Look_Up",
        down: "Eye_L_Look_Down",
        in: "Eye_L_Look_R",
        out: "Eye_L_Look_L"
    },
    right: {
        up: "Eye_R_Look_Up",
        down: "Eye_R_Look_Down",
        in: "Eye_R_Look_L",
        out: "Eye_R_Look_R"
    }
}, $e60bcd291a6e9aed$var$OC = [
    "LeftEye",
    "RightEye"
], $e60bcd291a6e9aed$var$bG = [
    "CC_Base_L_Eye",
    "CC_Base_R_Eye"
];
class $e60bcd291a6e9aed$var$ZG {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "BreathingMeshs", []);
        $e60bcd291a6e9aed$var$c(this, "NoBreathingMeshs", []);
        $e60bcd291a6e9aed$var$c(this, "_breathAnime", null);
        $e60bcd291a6e9aed$var$c(this, "_breath", {
            x: 1,
            y: 1,
            z: 1
        });
        $e60bcd291a6e9aed$var$c(this, "_started", !1);
        $e60bcd291a6e9aed$var$c(this, "duration", 4e3);
        $e60bcd291a6e9aed$var$c(this, "breathSpeed", 1);
        I.traverse((g)=>{
            g.isBone && g.name.toLowerCase().includes("spine") && g.children.length > 0 && g.name !== g.parent.name && this.BreathingMeshs.push(g);
        }), I.traverse((g)=>{
            if (g.isBone && g.name.toLowerCase().includes("spine")) for (const C of g.children)C.name.toLowerCase().includes("spine") || this.NoBreathingMeshs.push(C);
        }), this.BreathingMeshs = [
            ...new Set(this.BreathingMeshs)
        ], this.NoBreathingMeshs = [
            ...new Set(this.NoBreathingMeshs)
        ], this.breathSpeed = this.breathSpeed, this.start();
    }
    _initAnimation() {
        const I = this;
        function g() {
            I.duration = $e60bcd291a6e9aed$var$V.random(3e3, 4e3);
            const C = I.BreathingMeshs.length;
            I._breathAnime = $e60bcd291a6e9aed$var$V({
                targets: [
                    I._breath
                ],
                keyframes: [
                    // Inhale: gentle rise (40 % of total duration)
                    {
                        x: 1 + 0.08 / C,
                        y: 1 + 0.04 / C,
                        z: 1 + 0.12 / C,
                        duration: I.duration * 0.35,
                        easing: "easeInOutSine"
                    },
                    // Hold inhale briefly
                    {
                        x: 1 + 0.08 / C,
                        y: 1 + 0.04 / C,
                        z: 1 + 0.12 / C,
                        duration: I.duration * 0.05,
                        easing: "linear"
                    },
                    // Exhale: slower descent (55 % of total duration)
                    {
                        x: 1,
                        y: 1,
                        z: 1,
                        duration: I.duration * 0.5,
                        easing: "easeInOutSine"
                    },
                    // Hold exhale briefly
                    {
                        x: 1,
                        y: 1,
                        z: 1,
                        duration: I.duration * 0.1,
                        easing: "linear"
                    }
                ],
                loop: !1,
                easing: "linear",
                complete: g
            });
        }
        g();
    }
    start() {
        this._started = !0, this._initAnimation();
    }
    stop() {
        var I;
        (I = this._breathAnime) == null || I.pause(), this._breathAnime = null, this._breath = {
            x: 1,
            y: 1,
            z: 1
        }, this._started = !1;
    }
    update(I) {
        var C;
        const g = [];
        if (this._started) {
            (C = this._breathAnime) == null || C.tick(I);
            for (const l of this.BreathingMeshs)g.push({
                name: l.name,
                value: [
                    l.scale.x,
                    l.scale.y,
                    l.scale.z,
                    1 + (this._breath.x - 1) / this.BreathingMeshs.length,
                    1 + (this._breath.y - 1) / this.BreathingMeshs.length,
                    1 + (this._breath.z - 1) / this.BreathingMeshs.length
                ]
            });
            for (const l of this.NoBreathingMeshs)g.push({
                name: l.name,
                value: [
                    l.scale.x,
                    l.scale.y,
                    l.scale.z,
                    1 / this._breath.x,
                    1 / this._breath.y,
                    1 / this._breath.z
                ]
            });
        }
        return g;
    }
}
class $e60bcd291a6e9aed$export$2e8f4e992a20e5c {
    // 100 ms
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "_mesh");
        $e60bcd291a6e9aed$var$c(this, "animationMixer");
        $e60bcd291a6e9aed$var$c(this, "lipSyncManager");
        $e60bcd291a6e9aed$var$c(this, "blendshapeManager");
        $e60bcd291a6e9aed$var$c(this, "animationManager");
        $e60bcd291a6e9aed$var$c(this, "eyeBlinkManager");
        $e60bcd291a6e9aed$var$c(this, "breathingManager");
        $e60bcd291a6e9aed$var$c(this, "FACSManager");
        $e60bcd291a6e9aed$var$c(this, "gazeManager");
        $e60bcd291a6e9aed$var$c(this, "headPoseManager");
        $e60bcd291a6e9aed$var$c(this, "bmlManager", null);
        $e60bcd291a6e9aed$var$c(this, "animationOverride", !0);
        $e60bcd291a6e9aed$var$c(this, "useBlendshapeManager", !0);
        $e60bcd291a6e9aed$var$c(this, "_fps", 25);
        $e60bcd291a6e9aed$var$c(this, "_times", [
            0,
            1 / this._fps
        ]);
        $e60bcd291a6e9aed$var$c(this, "_lastTimestamp", 0);
        $e60bcd291a6e9aed$var$c(this, "_lastTargetChangeTimestamp", 0);
        $e60bcd291a6e9aed$var$c(this, "_target", null);
        $e60bcd291a6e9aed$var$c(this, "_durationTargetChange", 0);
        $e60bcd291a6e9aed$var$c(this, "_animationClip", new $329ek.AnimationClip("globalClip", -1, [], $329ek.NormalAnimationBlendMode));
        $e60bcd291a6e9aed$var$c(this, "_animationAction", null);
        /** Centralised morph-target accumulator – replaces direct mesh writes. */ $e60bcd291a6e9aed$var$c(this, "_accumulator");
        /** Maximum acceptable frame delta (seconds). Larger deltas are clamped. */ $e60bcd291a6e9aed$var$c(this, "_maxDeltaTime", 0.1);
        this._mesh = I.mesh, I.animationOverride !== void 0 && (this.animationOverride = I.animationOverride), this.useBlendshapeManager = !!I.useBlendshapeManager, this.animationMixer = new $329ek.AnimationMixer(this._mesh), this._accumulator = new $e60bcd291a6e9aed$export$2576c57b80b9d210(this._mesh), this._accumulator.excludeMorphsOnMesh("Eye_Mesh", $e60bcd291a6e9aed$var$cG), this.lipSyncManager = new $e60bcd291a6e9aed$export$ba3ec05c1c74c275({
            lipSyncTargets: I.lipSyncTargets,
            lipSyncMesh: this._mesh,
            type: I.type,
            lipSyncVisemeIntensity: I.lipSyncVisemeIntensity
        }), this.blendshapeManager = new $e60bcd291a6e9aed$export$a3635db1f361732f({
            mesh: this._mesh,
            targetMeshNames: I.blendshapeTargets
        }), this.animationManager = new $e60bcd291a6e9aed$export$42d239a7180b47de(I), this.breathingManager = new $e60bcd291a6e9aed$var$ZG(this._mesh), this.eyeBlinkManager = new $e60bcd291a6e9aed$export$9a8101b0ef6e4fc({
            morphTargets: I.blinkTargets
        }), this.gazeManager = new $e60bcd291a6e9aed$export$471af857ad6f5b2b({
            ...I.gazeData,
            parent: this._mesh,
            type: I.type,
            headBone: I.headPoseData.headBone
        }), this.FACSManager = new $e60bcd291a6e9aed$export$7520be563876830({
            FACS: I.FACS,
            parent: this._mesh,
            globalManager: this
        }), this.headPoseManager = new $e60bcd291a6e9aed$export$28ad399fb4435dc0({
            ...I.headPoseData,
            parent: this._mesh,
            globalManager: this
        }), I.enableBmlManager && (this.bmlManager = new $e60bcd291a6e9aed$export$f9531379b7476954(this));
    }
    /**
   * Stop looking at a target.
   * @param {number | undefined} fadeDuration time in milliseconds to get back to base position. Default 1000.
   */ releaseLookAt(I) {
        var g;
        this.headPoseManager.releaseLookAt(I), (g = this.gazeManager) == null || g.releaseLookAt();
    }
    /**
   * Look at the target and get back to normal after some time.
   * @param {THREE.Camera} target camera to which the face will look at.
   * @param {number | undefined} fadeInDuration time in milliseconds to go from the current position to the look at position. Default 1000.
   * @param {number | undefined} fadeOutDuration time in milliseconds to get back to base position. Default 1000.
   * @param {number | undefined} releaseAfterDuration time in milliseconds after which the animation gets back to base position. Default 2000.
   */ lookAtAndRelease(I, g, C, l) {
        this.headPoseManager.lookAtAndRelease(I, g, C, l);
    }
    /**
   * Look at the target camera and then keep looking at it until release.
   * @param {THREE.Camera} target camera to which the face will keep looking at.
   * @param {number | undefined} fadeDuration time in milliseconds to go from the current position to the look at position. Default 1000.
   */ lookAtAndKeep(I) {
        var g, C;
        (g = this.headPoseManager) == null || g.lookAtAndKeep(I), (C = this.gazeManager) == null || C.lookAtAndKeep(I);
    }
    lookAtAndSteady(I) {
        var g, C;
        (g = this.headPoseManager) == null || g.lookAtAndSteady(I), (C = this.gazeManager) == null || C.lookAtAndSteady(I);
    }
    update(I) {
        var e, s, u;
        const g = I.characterState || $e60bcd291a6e9aed$export$f2e6b371e93925c7.idle, C = Math.min(I.deltaTime, this._maxDeltaTime);
        if ((e = this.bmlManager) == null || e.update(C), !this.useBlendshapeManager && this.lipSyncManager.update(C), this.useBlendshapeManager && this.blendshapeManager.update(C), this.animationManager.update(C, g), (s = I.targets) != null && s.length && performance.now() - this._lastTargetChangeTimestamp > this._durationTargetChange && (this._lastTargetChangeTimestamp = performance.now(), this._durationTargetChange = 3e3 + Math.random() * 2e3, this._target = I.targets[Math.floor(Math.random() * I.targets.length)]), this.useBlendshapeManager) {
            const W = this.blendshapeManager.getPendingValues();
            for (const [y, h] of W)this._accumulator.set("blendshape", y, h, 1, 9, "override");
        } else {
            const W = this.lipSyncManager.getPendingValues();
            for (const [y, h] of W)this._accumulator.set("lipsync", y, h, 1, 10, "override");
        }
        const l = !this.animationOverride || (u = I.AU) != null && u.length ? [] : this.eyeBlinkManager.update(I.timestamp), A = this.animationOverride ? this.breathingManager.update(I.timestamp) : [], B = this.animationOverride && !this.useBlendshapeManager ? this.FACSManager.update(I.timestamp, I.AU, g) : [], o = this.animationOverride ? this.headPoseManager.update(I.timestamp, I.headPose || null, this._target) : [], i = this.animationOverride ? this.gazeManager.update(I.timestamp, I.gaze || null, o, this._target) : [
            [],
            []
        ];
        for (const W of l)this._accumulator.set("eyeblink", W.name, W.value, 1, 8, "override", !0);
        for (const W of B)this._accumulator.set("facs", W.name, W.value, 1, 5, "additive", !0);
        for (const W of i[0])this._accumulator.set("gaze", W.name, W.value, 1, 4, "additive", !0);
        this._accumulator.resolve(C);
        const Z = [], b = [
            ...i[1],
            ...o
        ], a = [
            ...A
        ], m = Math.min((I.timestamp - this._lastTimestamp) / 1e3, this._maxDeltaTime);
        this._lastTimestamp = I.timestamp, b.forEach((W)=>{
            Z.push(new $329ek.QuaternionKeyframeTrack(`${W.name}.quaternion`, this._times, W.value, $329ek.InterpolateLinear));
        }), a.forEach((W)=>{
            Z.push(new $329ek.VectorKeyframeTrack(`${W.name}.scale`, this._times, W.value, $329ek.InterpolateLinear));
        }), this.animationMixer.uncacheClip(this._animationClip), this.animationMixer.uncacheAction(this._animationClip), this._animationClip.tracks = Z, this._animationClip.duration = m, this._animationAction = this.animationMixer.clipAction(this._animationClip), this._animationAction.setLoop($329ek.LoopOnce, 1), this._animationAction.clampWhenFinished = !0, this._animationAction.reset().play(), this.animationMixer.update(C);
    }
}
const $e60bcd291a6e9aed$var$sg = new $329ek.Vector3(1, 0, 0), $e60bcd291a6e9aed$var$mG = new $329ek.Vector3(-1, 0, 0), $e60bcd291a6e9aed$var$Hg = new $329ek.Vector3(0, 1, 0), $e60bcd291a6e9aed$var$XI = new $329ek.Vector3(0, -1, 0), $e60bcd291a6e9aed$var$Sg = new $329ek.Vector3(0, 0, 1), $e60bcd291a6e9aed$var$VI = new $329ek.Vector3(0, 0, -1), $e60bcd291a6e9aed$var$x = class x {
    // X
    // #endregion
    // #region MAIN
    constructor(I){
        // Standard WorldSpace Dir
        $e60bcd291a6e9aed$var$c(this, "swing");
        // Y
        $e60bcd291a6e9aed$var$c(this, "twist");
        // Z
        $e60bcd291a6e9aed$var$c(this, "ortho");
        this.swing = $e60bcd291a6e9aed$var$Hg.clone(), this.twist = $e60bcd291a6e9aed$var$Sg.clone(), this.ortho = $e60bcd291a6e9aed$var$sg.clone(), I && this.copy(I);
    }
    // #endregion
    // #region METHODS
    /** Get new BoneAxes with quaternion applied */ getFromQuat(I, g = new x()) {
        return g.copy(this).applyQuat(I);
    }
    copy(I) {
        return this.swing.copy(I.swing), this.twist.copy(I.twist), this.ortho.copy(I.ortho), this;
    }
    /** Apply rotation on current axes directions */ applyQuat(I) {
        return this.swing.copy(this.swing.clone().applyQuaternion(I)).normalize(), this.twist.copy(this.twist.clone().applyQuaternion(I)).normalize(), this.ortho.copy(this.ortho.clone().applyQuaternion(I)).normalize(), this;
    }
    /** Set a quaternion direction set. For swing-twist ik rotations
   * please make sure the quaternion passed in are inverted first
   * when your looking to support qi axes.
   */ setQuatDirections(I, g = x.UFR) {
        switch(g){
            case x.UFR:
                this.swing.copy($e60bcd291a6e9aed$var$Hg.clone().applyQuaternion(I)), this.twist.copy($e60bcd291a6e9aed$var$Sg.clone().applyQuaternion(I)), this.ortho.copy($e60bcd291a6e9aed$var$sg.clone().applyQuaternion(I));
                break;
            case x.RBD:
                this.swing.copy($e60bcd291a6e9aed$var$sg.clone().applyQuaternion(I)), this.twist.copy($e60bcd291a6e9aed$var$VI.clone().applyQuaternion(I)), this.ortho.copy($e60bcd291a6e9aed$var$XI.clone().applyQuaternion(I));
                break;
            case x.LBU:
                this.swing.copy($e60bcd291a6e9aed$var$mG.clone().applyQuaternion(I)), this.twist.copy($e60bcd291a6e9aed$var$VI.clone().applyQuaternion(I)), this.ortho.copy($e60bcd291a6e9aed$var$Hg.clone().applyQuaternion(I));
                break;
            case x.DFR:
                this.swing.copy($e60bcd291a6e9aed$var$XI.clone().applyQuaternion(I)), this.twist.copy($e60bcd291a6e9aed$var$Sg.clone().applyQuaternion(I)), this.ortho.copy($e60bcd291a6e9aed$var$sg.clone().applyQuaternion(I));
                break;
            case x.FUR:
                this.swing.copy($e60bcd291a6e9aed$var$Sg.clone().applyQuaternion(I)), this.twist.copy($e60bcd291a6e9aed$var$Hg.clone().applyQuaternion(I)), this.ortho.copy($e60bcd291a6e9aed$var$sg.clone().applyQuaternion(I));
                break;
        }
        return this.swing.normalize(), this.twist.normalize(), this.ortho.normalize(), this;
    }
};
// #region STATIC
// SWING-TWIST-ORTHO - What is Forward - Up - Left
$e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$x, "UFR", 0), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$x, "RBD", 1), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$x, "LBU", 2), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$x, "DFR", 3), $e60bcd291a6e9aed$var$c($e60bcd291a6e9aed$var$x, "FUR", 4);
let $e60bcd291a6e9aed$export$be5856d46fc68aa2 = $e60bcd291a6e9aed$var$x;
class $e60bcd291a6e9aed$export$e1e19287bd7f8138 {
    constructor(){
        // #region MAIN
        $e60bcd291a6e9aed$var$c(this, "hasChanged", !1);
        $e60bcd291a6e9aed$var$c(this, "tMode", 0);
        // Initial Target : Position or Direction
        $e60bcd291a6e9aed$var$c(this, "pMode", 0);
        // Initial Pole   : Position or Direction
        $e60bcd291a6e9aed$var$c(this, "deltaMove", new $329ek.Vector3());
        // How much to move a bone
        $e60bcd291a6e9aed$var$c(this, "endPos", new $329ek.Vector3());
        // Target Position
        $e60bcd291a6e9aed$var$c(this, "startPos", new $329ek.Vector3());
        // Origin Position
        $e60bcd291a6e9aed$var$c(this, "polePos", new $329ek.Vector3());
        // Position of Pole
        $e60bcd291a6e9aed$var$c(this, "dist", 0);
        // Distance from Origin & Target Position
        $e60bcd291a6e9aed$var$c(this, "swing", new $329ek.Vector3());
        // To Target Direction or end-start position
        $e60bcd291a6e9aed$var$c(this, "twist", new $329ek.Vector3());
        // To Pole Direction or Orth direction of swing
        $e60bcd291a6e9aed$var$c(this, "ortho", new $329ek.Vector3());
        //  Ortho direction between for swing & twist
        $e60bcd291a6e9aed$var$c(this, "lenScale", -1);
        // How to scale the swing direction when computing IK Target Position
        $e60bcd291a6e9aed$var$c(this, "altSwing", new $329ek.Vector3());
        // Second set of SwingTwist Directions
        $e60bcd291a6e9aed$var$c(this, "altTwist", new $329ek.Vector3());
        // ... used just for SwingTwistEnds Solver
        $e60bcd291a6e9aed$var$c(this, "pworld", new $329ek.Matrix4());
        // Parent Bone WS Transform
        $e60bcd291a6e9aed$var$c(this, "rworld", new $329ek.Matrix4());
    }
    // Root Bone WS Transform
    // #endregion
    // #region SETTERS
    setPositions(I, g) {
        return this.hasChanged = !0, this.tMode = 0, this.pMode = 0, this.endPos.copy(I), g && this.polePos.copy(g), this;
    }
    setPolePos(I) {
        return this.hasChanged = !0, this.pMode = 0, this.polePos.copy(I), this;
    }
    setDirections(I, g, C) {
        return this.hasChanged = !0, this.swing.copy(I.clone()), this.tMode = 1, g ? (this.twist.copy(g.clone()), this.pMode = 1) : this.pMode = 0, C && (this.lenScale = C), this;
    }
    setAltDirections(I, g) {
        return this.hasChanged = !0, this.altSwing.copy(I.clone()), this.altTwist.copy(g.clone()), this;
    }
    setPoleDir(I) {
        return this.hasChanged = !0, this.pMode = 1, this.twist.copy(I), this;
    }
    setDeltaMove(I, g = 1) {
        return this.deltaMove.copy(I).multiplyScalar(g), this.hasChanged = !0, this;
    }
    // #endregion
    // #region METHODS
    resolveTarget(I, g) {
        this.pworld.copy(g.getBoneByName(I.links[0].name).parent.matrixWorld), this.rworld.copy(this.pworld.clone()).multiply(I.links[0].bind);
        const C = new $329ek.Vector3();
        this.pworld.decompose(C, new $329ek.Quaternion(), new $329ek.Vector3());
        const l = new $329ek.Vector3();
        this.rworld.decompose(l, new $329ek.Quaternion(), new $329ek.Vector3()), new $329ek.Vector3().subVectors(C, l).normalize();
        const A = new $329ek.Vector3();
        switch(this.rworld.decompose(A, new $329ek.Quaternion(), new $329ek.Vector3()), this.tMode){
            case 0:
                this.startPos.copy(A), this.swing.subVectors(this.endPos, this.startPos), this.dist = this.swing.length(), this.swing.normalize();
                break;
            case 1:
                this.dist = this.lenScale >= 0 ? this.lenScale * I.len : I.len, this.startPos.copy(A), this.endPos.copy(this.swing).multiplyScalar(this.dist).add(A);
                break;
        }
        switch(this.pMode){
            case 0:
                this.twist.subVectors(this.polePos, this.startPos), this.ortho.crossVectors(this.twist, this.swing).normalize(), this.twist.crossVectors(this.swing, this.ortho).normalize();
                break;
        }
        return this.hasChanged = !1, this;
    }
    // #endregion
    alignTwist(I, g, C) {
        return C.crossVectors(g, I).crossVectors(I, C), C;
    }
}
class $e60bcd291a6e9aed$export$5555935956265a1d {
    constructor(I, g = -1){
        $e60bcd291a6e9aed$var$c(this, "index", -1);
        // Bone Index
        $e60bcd291a6e9aed$var$c(this, "pindex", -1);
        // Parent Bone Index
        $e60bcd291a6e9aed$var$c(this, "len", 0);
        // Computed Length of the bone in chain
        $e60bcd291a6e9aed$var$c(this, "axes", new $e60bcd291a6e9aed$export$be5856d46fc68aa2());
        // IK May need alternative axis directions
        $e60bcd291a6e9aed$var$c(this, "bind", new $329ek.Matrix4());
        // Bind Link to a specific pose, localspace transform
        $e60bcd291a6e9aed$var$c(this, "name");
        this.name = I.name, this.bind.copy(I.matrix.clone()), g !== -1 && this.axes.setQuatDirections(I.getWorldQuaternion(new $329ek.Quaternion()).invert(), g);
    }
}
class $e60bcd291a6e9aed$export$c610d2fb0b28b5a6 {
    // Length of the chain
    constructor(I, g = -1){
        // #region MAIN
        $e60bcd291a6e9aed$var$c(this, "links", []);
        // List of linked bones
        $e60bcd291a6e9aed$var$c(this, "len", 0);
        I && this.setBones(I, g);
    }
    // #endregion
    // #region GETTERS // SETTERS
    get lastLink() {
        return this.links[this.links.length - 1];
    }
    get firstLink() {
        return this.links[0];
    }
    setBones(I, g = -1) {
        this.links.length = 0, this.len = 0;
        for (const l of I)this.links.push(new $e60bcd291a6e9aed$export$5555935956265a1d(l, g));
        const C = I.length - 1;
        for(let l = 1; l <= C; l++)this.links[l - 1].len = I[l].getWorldPosition(new $329ek.Vector3()).distanceTo(I[l - 1].getWorldPosition(new $329ek.Vector3())), this.len += this.links[l - 1].len;
        return this;
    }
    /** Reset linked bones with the bind transfrom saved in the chain */ resetPoseLocal(I, g = 0, C = -1) {
        C < 0 && (C = this.links.length - 1);
        let l;
        for(let A = g; A <= C; A++){
            l = this.links[A];
            const B = new $329ek.Quaternion();
            l.bind.decompose(new $329ek.Vector3(), B, new $329ek.Vector3());
            const o = I.getBoneByName(l.name);
            o && o.quaternion.copy(B);
        }
        return this;
    }
}
function $e60bcd291a6e9aed$var$Kg(G, I) {
    const g = new $329ek.Vector3().copy(G.clone()).dot(I);
    let C = new $329ek.Quaternion();
    if (g < -0.999999) {
        const l = new $329ek.Vector3().crossVectors(new $329ek.Vector3(-1, 0, 0), G);
        l.len < 1e-6 && l.copy(new $329ek.Vector3(0, 1, 0).cross(G)), C.setFromAxisAngle(l.normalize(), Math.PI);
    } else if (g > 0.999999) C.set(0, 0, 0, 1);
    else {
        const l = G.clone().cross(I);
        C.set(l.x, l.y, l.z, 1 + g), C.normalize();
    }
    return C;
}
function $e60bcd291a6e9aed$export$e16674758e97d907(G, I, g, C) {
    const l = I.links[0], A = new $329ek.Vector3();
    let B = new $329ek.Quaternion(), o = new $329ek.Quaternion();
    G.rworld.decompose(new $329ek.Vector3(), B, new $329ek.Vector3()), G.pworld.decompose(new $329ek.Vector3(), o, new $329ek.Vector3()), A.copy(l.axes.swing).applyQuaternion(B);
    const i = $e60bcd291a6e9aed$var$Kg(A, G.swing).multiply(B);
    if (A.copy(l.axes.twist).applyQuaternion(i), G.twist.clone().dot(A) < 0.999999) {
        const b = $e60bcd291a6e9aed$var$Kg(A, G.twist);
        b.clone().dot(i) < 0 && (b.x *= -1, b.y *= -1, b.z *= -1, b.w *= -1), i.premultiply(b);
    }
    i.premultiply(o.invert()), g.getBoneByName(l.name).quaternion.copy(i);
}
function $e60bcd291a6e9aed$var$HI(G, I, g) {
    const C = (G ** 2 + I ** 2 - g ** 2) / (2 * G * I);
    return Math.acos(Math.min(1, Math.max(-1, C)));
}
function $e60bcd291a6e9aed$export$2339b41f56709eb6(G, I, g, C) {
    const l = I.links[0], A = I.links[1], B = g.getBoneByName(l.name);
    let o = new $329ek.Quaternion(), i = new $329ek.Vector3(), Z = new $329ek.Vector3(), b = new $329ek.Quaternion(), a = new $329ek.Vector3(), m = new $329ek.Vector3();
    G.rworld.decompose(i, o, Z), G.pworld.decompose(a, b, m);
    const e = new $329ek.Quaternion().multiplyQuaternions(b, B.quaternion), s = new $329ek.Vector3().copy(l.axes.ortho).applyQuaternion(e);
    let u = $e60bcd291a6e9aed$var$HI(l.len, G.dist, A.len);
    e.premultiply(new $329ek.Quaternion().setFromAxisAngle(s, -u)).premultiply(b.clone().invert()), g.getBoneByName(l.name).quaternion.copy(e);
    const W = g.getBoneByName(A.name).parent.getWorldQuaternion(new $329ek.Quaternion()), y = new $329ek.Quaternion();
    A.bind.decompose(new $329ek.Vector3(), y, new $329ek.Vector3()), u = Math.PI - $e60bcd291a6e9aed$var$HI(l.len, A.len, G.dist), e.multiplyQuaternions(W, y).premultiply(new $329ek.Quaternion().setFromAxisAngle(s, u)).premultiply(W.clone().invert()), g.getBoneByName(A.name).quaternion.copy(e);
}
function $e60bcd291a6e9aed$export$6ff9e5a41fe0e728(G, I, g) {
    const C = I.links.length - 1;
    let l, A;
    for(let B = 0; B <= C; B++){
        A = I.links[B], l = B / C;
        let o = new $329ek.Quaternion(), i = new $329ek.Vector3(), Z = new $329ek.Vector3();
        g.getBoneByName(A.name).parent.matrixWorld.decompose(i, o, Z);
        let b = new $329ek.Quaternion(), a = new $329ek.Vector3(), m = new $329ek.Vector3();
        A.bind.decompose(a, b, m);
        let e = g.getBoneByName(A.name).parent.matrixWorld.clone().multiply(A.bind), s = new $329ek.Vector3(), u = new $329ek.Quaternion(), W = new $329ek.Vector3();
        e.decompose(s, u, W);
        let y = G.swing.clone().lerp(G.altSwing, l).normalize(), h = new $329ek.Vector3().copy(A.axes.swing).applyQuaternion(u), n = $e60bcd291a6e9aed$var$Kg(h, y).multiply(u);
        y = G.twist.clone().lerp(G.altTwist, l).normalize(), h = new $329ek.Vector3().copy(A.axes.twist).applyQuaternion(n);
        let H = $e60bcd291a6e9aed$var$Kg(h, y).multiply(n).premultiply(o.clone().invert());
        g.getBoneByName(A.name).quaternion.copy(H);
    }
}
function $e60bcd291a6e9aed$export$135253387f1f3ce7(G, I, g) {
    const C = I.firstLink;
    let l = C.bind, B = g.getBoneByName(C.name).parent.matrixWorld.clone().multiply(l), o = new $329ek.Vector3();
    B.decompose(o, new $329ek.Quaternion(), new $329ek.Vector3()), o.add(G.deltaMove), g.getBoneByName(C.name).position.copy(o);
}
function $e60bcd291a6e9aed$export$19e7c020c43c1afb(G, I, g) {
    G.resolveTarget(I, g), $e60bcd291a6e9aed$export$e16674758e97d907(G, I, g), $e60bcd291a6e9aed$export$135253387f1f3ce7(G, I, g);
}
function $e60bcd291a6e9aed$export$dcd7ff141fb1435c(G, I, g) {
    G.resolveTarget(I, g), $e60bcd291a6e9aed$export$e16674758e97d907(G, I, g);
}
function $e60bcd291a6e9aed$export$27f0fbbf90c25675(G, I, g, C) {
    G.resolveTarget(I, g), $e60bcd291a6e9aed$export$e16674758e97d907(G, I, g), G.dist >= I.len ? I.resetPoseLocal(g, 1) : $e60bcd291a6e9aed$export$2339b41f56709eb6(G, I, g);
}
class $e60bcd291a6e9aed$var$VG {
    constructor(I){
        $e60bcd291a6e9aed$var$c(this, "bones", /* @__PURE__ */ new Map());
        $e60bcd291a6e9aed$var$c(this, "obj");
        I && this.from(I);
    }
    from(I) {
        this.obj = I;
        const g = I.bones;
        let C, l, A, B;
        for (const o of g){
            o.updateMatrixWorld(!0);
            for (C of $e60bcd291a6e9aed$var$YG)if (A = C.test(o.name)) {
                l = this.bones.get(A), B = this.obj.bones.findIndex((i)=>i.id == o.id), l ? l && C.isChain && l.push(B, o) : this.bones.set(A, new $e60bcd291a6e9aed$var$HG(o, B));
                break;
            }
        }
    }
    getBoneMap(I) {
        return this.bones.get(I);
    }
    getBoneIndex(I) {
        const g = this.bones.get(I);
        return g ? g.items[0].index : -1;
    }
    getBones(I) {
        const g = this.obj.bones, C = [];
        let l, A;
        for (const B of I)if (l = this.bones.get(B), l) for (A of l.items)C.push(g[A.index]);
        else console.warn("Bonemap.getBones - Bone not found", B);
        return C.length >= I.length ? C : null;
    }
    getBoneNames(I) {
        const g = [];
        let C, l;
        for (const A of I)if (C = this.bones.get(A)) for (l of C.items)g.push(l.name);
        else return console.warn("Bonemap.getBoneNames - Bone not found", A), null;
        return g;
    }
    getChestBone() {
        const I = this.obj.bones, g = [], C = this.bones.get("spine");
        return C && g.push(I[C.lastIndex]), g.length > 0 ? g : null;
    }
}
class $e60bcd291a6e9aed$var$HG {
    constructor(I, g){
        $e60bcd291a6e9aed$var$c(this, "items", []);
        I && this.push(g, I);
    }
    push(I, g) {
        return this.items.push({
            index: I,
            name: g.name
        }), this;
    }
    get isChain() {
        return this.items.length > 1;
    }
    get count() {
        return this.items.length;
    }
    get index() {
        return this.items.length ? this.items[0].index : 0;
    }
    get lastIndex() {
        return this.items.length ? this.items[this.items.length - 1].index : 0;
    }
}
class $e60bcd291a6e9aed$var$M {
    constructor(I, g, C, l, A = !1){
        $e60bcd291a6e9aed$var$c(this, "name");
        $e60bcd291a6e9aed$var$c(this, "isLR");
        $e60bcd291a6e9aed$var$c(this, "isChain");
        $e60bcd291a6e9aed$var$c(this, "reFind");
        $e60bcd291a6e9aed$var$c(this, "reExclude");
        this.name = I, this.isLR = g, this.isChain = A, this.reFind = new RegExp(C, "i"), l && (this.reExclude = new RegExp(l, "i"));
    }
    test(I) {
        return !this.reFind.test(I) || this.reExclude && this.reExclude.test(I) ? null : this.isLR && $e60bcd291a6e9aed$var$SG.test(I) ? this.name + "_l" : this.isLR && $e60bcd291a6e9aed$var$pG.test(I) ? this.name + "_r" : this.name;
    }
}
const $e60bcd291a6e9aed$var$SG = new RegExp("\\.l|left|_l", "i"), $e60bcd291a6e9aed$var$pG = new RegExp("\\.r|right|_r", "i"), $e60bcd291a6e9aed$var$YG = [
    new $e60bcd291a6e9aed$var$M("thigh", !0, "thigh|upleg|upperleg", "twist"),
    //upleg | upperleg
    new $e60bcd291a6e9aed$var$M("shin", !0, "shin|leg|calf", "up|twist"),
    new $e60bcd291a6e9aed$var$M("foot", !0, "foot"),
    new $e60bcd291a6e9aed$var$M("toe", !0, "toebase"),
    new $e60bcd291a6e9aed$var$M("shoulder", !0, "clavicle|shoulder"),
    new $e60bcd291a6e9aed$var$M("upperarm", !0, "(upper.*arm|arm)", "fore|twist|lower"),
    new $e60bcd291a6e9aed$var$M("forearm", !0, "forearm|arm", "up|twist"),
    new $e60bcd291a6e9aed$var$M("hand", !0, "hand", "thumb|index|middle|ring|pinky"),
    new $e60bcd291a6e9aed$var$M("head", !1, "head"),
    new $e60bcd291a6e9aed$var$M("neck", !1, "neck", void 0, !0),
    new $e60bcd291a6e9aed$var$M("hip", !1, "hips*|pelvis", void 0, !1),
    new $e60bcd291a6e9aed$var$M("root", !1, "root"),
    new $e60bcd291a6e9aed$var$M("spine", !1, "waist|spine*d*|chest", void 0, !0),
    new $e60bcd291a6e9aed$var$M("thumb", !0, "thumb*d*", "toe", !0),
    new $e60bcd291a6e9aed$var$M("index", !0, "index*d*", "toe", !0),
    new $e60bcd291a6e9aed$var$M("middle", !0, "middle*d*|mid*d", "toe", !0),
    new $e60bcd291a6e9aed$var$M("ring", !0, "ring*d*", "toe", !0),
    new $e60bcd291a6e9aed$var$M("pinky", !0, "pinky*d*", "toe", !0)
], $e60bcd291a6e9aed$var$KG = {
    root: $e60bcd291a6e9aed$export$19e7c020c43c1afb,
    look: $e60bcd291a6e9aed$export$dcd7ff141fb1435c,
    limb: $e60bcd291a6e9aed$export$27f0fbbf90c25675,
    swingchain: $e60bcd291a6e9aed$export$6ff9e5a41fe0e728
};
class $e60bcd291a6e9aed$var$RG {
    // IK Bone Chain
    constructor(I, g = 0){
        // #region MAIN
        $e60bcd291a6e9aed$var$c(this, "name", "");
        // Help to identify which limb to access
        $e60bcd291a6e9aed$var$c(this, "order", 0);
        // Order this set should execute in
        $e60bcd291a6e9aed$var$c(this, "target", new $e60bcd291a6e9aed$export$e1e19287bd7f8138());
        // Handles IK Target data solvers will use
        // target2  : IKTarget | null  = null;
        $e60bcd291a6e9aed$var$c(this, "solver");
        // Any IK Solver
        $e60bcd291a6e9aed$var$c(this, "chain");
        this.name = I, this.order = g;
    }
    /** Set bones using the current TPose to store bind & axes information */ setBones(I, g, C = $e60bcd291a6e9aed$export$be5856d46fc68aa2.UFR) {
        const l = [];
        for(let A = 0; A < I.length; A++){
            const B = g.getBoneByName(I[A]);
            B && l.push(B);
        }
        return this.chain = new $e60bcd291a6e9aed$export$c610d2fb0b28b5a6(l, C), this;
    }
    /** set which solver to be executed using the target onto the chain */ setSolver(I) {
        return this.solver = typeof I == "string" ? $e60bcd291a6e9aed$var$KG[I] : I, this;
    }
    // #endregion
    updatePose(I, g) {
        this.solver(this.target, this.chain, I, g);
    }
}
var $e60bcd291a6e9aed$var$Rg, $e60bcd291a6e9aed$var$_C;
class $e60bcd291a6e9aed$var$wG {
    // Working Pose
    constructor(I){
        $e60bcd291a6e9aed$var$kg(this, $e60bcd291a6e9aed$var$Rg);
        // #region MAIN
        $e60bcd291a6e9aed$var$c(this, "sets", []);
        // Collection of Chained Bones
        $e60bcd291a6e9aed$var$c(this, "names", {});
        // Names to Index Mapping
        $e60bcd291a6e9aed$var$c(this, "pose");
        // Default Executor, Will use IKSet.order to determine execution order
        $e60bcd291a6e9aed$var$c(this, "executor", (I, g)=>{
            for (const C of this.sets)C.target.endPos.lengthSq() !== 0 && C.updatePose(this.pose, g);
        });
        this.pose = I.clone();
    }
    // #endregion
    // #region SETUP
    addSet(I) {
        if (I = Object.assign({
            order: 0,
            name: "",
            bones: [],
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.UFR,
            solver: "look"
        }, I), I.bones.length === 0) return this;
        I.name || (I.name = "set" + this.sets.length);
        const g = new $e60bcd291a6e9aed$var$RG(I.name, I.order).setBones(I.bones, this.pose, I.axes).setSolver(I.solver);
        return this.sets.push(g), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$Rg, $e60bcd291a6e9aed$var$_C).call(this), this;
    }
    // #endregion
    // #region GETTERS / SETTERS
    getSet(I) {
        return this.sets[this.names[I]];
    }
    getEndPosition(I) {
        const g = this.sets[this.names[I]], C = this.pose.getBoneByName(g.chain.lastLink.name);
        return C ? C.getWorldPosition(new $329ek.Vector3()) : new $329ek.Vector3();
    }
    setTargetPositions(I, g, C) {
        const l = this.sets[this.names[I]];
        return l ? l.target.setPositions(g, C) : console.log("Setting target name not found", I), this;
    }
    // #endregion
    // #region EXECUTION
    runSolvers(I) {
        return this.executor(this, I), this;
    }
}
$e60bcd291a6e9aed$var$Rg = new WeakSet(), /** Sort IKSet collection & update name-index mapping */ $e60bcd291a6e9aed$var$_C = function() {
    this.sets.sort((I, g)=>I.order === g.order ? 0 : I.order < g.order ? -1 : 1);
    for(let I = 0; I < this.sets.length; I++)this.names[this.sets[I].name] = I;
};
class $e60bcd291a6e9aed$export$9ead20f582ebf362 extends $e60bcd291a6e9aed$var$wG {
    // Track how far character stands off the ground + for IK Scaling
    constructor(g, C = !0){
        super(g);
        // #region MAIN
        $e60bcd291a6e9aed$var$c(this, "hipHeight", 0);
        if (C) {
            const l = new $e60bcd291a6e9aed$var$VG(this.pose);
            this.setLeftShoulder(l.getBoneNames([
                "shoulder_l"
            ])), this.setRightShoulder(l.getBoneNames([
                "shoulder_r"
            ])), this.setLeftArm(l.getBoneNames([
                "upperarm_l",
                "forearm_l",
                "hand_l"
            ])), this.setRightArm(l.getBoneNames([
                "upperarm_r",
                "forearm_r",
                "hand_r"
            ])), this.setLeftLeg(l.getBoneNames([
                "thigh_l",
                "shin_l",
                "foot_l"
            ])), this.setRightLeg(l.getBoneNames([
                "thigh_r",
                "shin_r",
                "foot_r"
            ])), this.setLeftFoot(l.getBoneNames([
                "foot_l"
            ])), this.setRightFoot(l.getBoneNames([
                "foot_r"
            ])), this.setLeftHand(l.getBoneNames([
                "hand_l"
            ])), this.setLeftHandThumb(l.getBoneNames([
                "thumb_l"
            ])), this.setLeftHandIndex(l.getBoneNames([
                "index_l"
            ])), this.setLeftHandMiddle(l.getBoneNames([
                "middle_l"
            ])), this.setLeftHandRing(l.getBoneNames([
                "ring_l"
            ])), this.setLeftHandPinky(l.getBoneNames([
                "pinky_l"
            ])), this.setRightHand(l.getBoneNames([
                "hand_r"
            ])), this.setRightHandThumb(l.getBoneNames([
                "thumb_r"
            ])), this.setRightHandIndex(l.getBoneNames([
                "index_r"
            ])), this.setRightHandMiddle(l.getBoneNames([
                "middle_r"
            ])), this.setRightHandRing(l.getBoneNames([
                "ring_r"
            ])), this.setRightHandPinky(l.getBoneNames([
                "pinky_r"
            ])), this.setSpine(l.getBoneNames([
                "spine"
            ])), this.setHead(l.getBoneNames([
                "head"
            ])), this.setHip(l.getBoneNames([
                "hip"
            ]));
        }
    }
    // #endregion
    // #region ARM CHAINS
    get leftArm() {
        return this.sets[this.names.arm_l];
    }
    setLeftArm(g) {
        return g && this.addSet({
            name: "arm_l",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.RBD,
            order: 10
        }), this;
    }
    get leftShoulder() {
        return this.sets[this.names.shoulder_l];
    }
    setLeftShoulder(g) {
        return g && this.addSet({
            name: "shoulder_l",
            solver: "look",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.RBD,
            order: 11
        }), this;
    }
    get leftHand() {
        return this.sets[this.names.hand_l];
    }
    setLeftHand(g) {
        return g && this.addSet({
            name: "hand_l",
            solver: "look",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.RBD,
            order: 12
        }), this;
    }
    get leftHandThumb() {
        return this.sets[this.names.thumb_l];
    }
    setLeftHandThumb(g) {
        return g && this.addSet({
            name: "thumb_l",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 13
        }), this;
    }
    get leftHandIndex() {
        return this.sets[this.names.index_l];
    }
    setLeftHandIndex(g) {
        return g && this.addSet({
            name: "index_l",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 13
        }), this;
    }
    get leftHandMiddle() {
        return this.sets[this.names.middle_l];
    }
    setLeftHandMiddle(g) {
        return g && this.addSet({
            name: "middle_l",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 13
        }), this;
    }
    get leftHandRing() {
        return this.sets[this.names.ring_l];
    }
    setLeftHandRing(g) {
        return g && this.addSet({
            name: "ring_l",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 13
        }), this;
    }
    get leftHandPinky() {
        return this.sets[this.names.pinky_l];
    }
    setLeftHandPinky(g) {
        return g && this.addSet({
            name: "pinky_l",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 13
        }), this;
    }
    get rightArm() {
        return this.sets[this.names.arm_r];
    }
    setRightArm(g) {
        return g && this.addSet({
            name: "arm_r",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 10
        }), this;
    }
    get rightShoulder() {
        return this.sets[this.names.shoulder_r];
    }
    setRightShoulder(g) {
        return g && this.addSet({
            name: "shoulder_r",
            solver: "look",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 11
        }), this;
    }
    get rightHand() {
        return this.sets[this.names.hand_r];
    }
    setRightHand(g) {
        return g && this.addSet({
            name: "hand_r",
            solver: "look",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 12
        }), this;
    }
    get rightHandThumb() {
        return this.sets[this.names.thumb_r];
    }
    setRightHandThumb(g) {
        return g && this.addSet({
            name: "thumb_r",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 13
        }), this;
    }
    get rightHandIndex() {
        return this.sets[this.names.index_r];
    }
    setRightHandIndex(g) {
        return g && this.addSet({
            name: "index_r",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 13
        }), this;
    }
    get rightHandMiddle() {
        return this.sets[this.names.middle_r];
    }
    setRightHandMiddle(g) {
        return g && this.addSet({
            name: "middle_r",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 13
        }), this;
    }
    get rightHandRing() {
        return this.sets[this.names.ring_r];
    }
    setRightHandRing(g) {
        return g && this.addSet({
            name: "ring_r",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 13
        }), this;
    }
    get rightHandPinky() {
        return this.sets[this.names.pinky_r];
    }
    setRightHandPinky(g) {
        return g && this.addSet({
            name: "pinky_r",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.LBU,
            order: 13
        }), this;
    }
    // #endregion
    // #region LEG CHAINS
    // Note : Reserve 8 for Toes
    get leftLeg() {
        return this.sets[this.names.leg_l];
    }
    setLeftLeg(g) {
        return g && this.addSet({
            name: "leg_l",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.DFR,
            order: 6
        }), this;
    }
    get leftFoot() {
        return this.sets[this.names.foot_l];
    }
    setLeftFoot(g) {
        return g && this.addSet({
            name: "foot_l",
            solver: "look",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.FUR,
            order: 7
        }), this;
    }
    get rightLeg() {
        return this.sets[this.names.leg_r];
    }
    setRightLeg(g) {
        return g && this.addSet({
            name: "leg_r",
            solver: "limb",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.DFR,
            order: 6
        }), this;
    }
    get rightFoot() {
        return this.sets[this.names.foot_r];
    }
    setRightFoot(g) {
        return g && this.addSet({
            name: "foot_r",
            solver: "look",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.FUR,
            order: 7
        }), this;
    }
    // #endregion
    // #region CENTER LINE
    get hip() {
        return this.sets[this.names.hip];
    }
    setHip(g) {
        if (g) {
            this.addSet({
                name: "hip",
                solver: "root",
                bones: g,
                axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.FUR,
                order: 1
            });
            const C = this.pose.getBoneByName(this.hip.chain.firstLink.name);
            this.hipHeight = C.getWorldPosition(new $329ek.Vector3()).y;
        }
        return this;
    }
    get spine() {
        return this.sets[this.names.spine];
    }
    setSpine(g) {
        return g && this.addSet({
            name: "spine",
            solver: "swingchain",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.UFR,
            order: 2
        }), this;
    }
    get head() {
        return this.sets[this.names.head];
    }
    setHead(g) {
        return g && this.addSet({
            name: "head",
            solver: "look",
            bones: g,
            axes: $e60bcd291a6e9aed$export$be5856d46fc68aa2.FUR,
            order: 3
        }), this;
    }
}
class $e60bcd291a6e9aed$export$8c19c43e20aa52f4 {
    constructor(){
        $e60bcd291a6e9aed$var$c(this, "hip", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3(),
            deltaPos: new $329ek.Vector3(),
            bindHeight: 0
        });
        $e60bcd291a6e9aed$var$c(this, "spine", {
            startSwing: new $329ek.Vector3(),
            startTwist: new $329ek.Vector3(),
            endSwing: new $329ek.Vector3(),
            endTwist: new $329ek.Vector3()
        });
        $e60bcd291a6e9aed$var$c(this, "head", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3()
        });
        $e60bcd291a6e9aed$var$c(this, "armR", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3(),
            lenScale: 0
        });
        $e60bcd291a6e9aed$var$c(this, "armL", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3(),
            lenScale: 0
        });
        $e60bcd291a6e9aed$var$c(this, "legR", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3(),
            lenScale: 0
        });
        $e60bcd291a6e9aed$var$c(this, "legL", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3(),
            lenScale: 0
        });
        $e60bcd291a6e9aed$var$c(this, "footR", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3()
        });
        $e60bcd291a6e9aed$var$c(this, "footL", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3()
        });
        $e60bcd291a6e9aed$var$c(this, "shoulderR", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3()
        });
        $e60bcd291a6e9aed$var$c(this, "handR", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3()
        });
        $e60bcd291a6e9aed$var$c(this, "shoulderL", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3()
        });
        $e60bcd291a6e9aed$var$c(this, "handL", {
            swing: new $329ek.Vector3(),
            twist: new $329ek.Vector3()
        });
    }
}
var $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$$C, $e60bcd291a6e9aed$var$Wg, $e60bcd291a6e9aed$var$gl, $e60bcd291a6e9aed$var$lg, $e60bcd291a6e9aed$var$Il;
class $e60bcd291a6e9aed$export$fef079ecc522d363 {
    // #endregion
    constructor(){
        $e60bcd291a6e9aed$var$kg(this, $e60bcd291a6e9aed$var$w);
        // #region MAIN
        $e60bcd291a6e9aed$var$c(this, "ikpose", new $e60bcd291a6e9aed$export$8c19c43e20aa52f4());
        $e60bcd291a6e9aed$var$c(this, "rig");
        this.rig = new $e60bcd291a6e9aed$export$9ead20f582ebf362(new $329ek.Skeleton());
    }
    // #region SETUP
    setSourceTPose(I) {
        return this.rig = new $e60bcd291a6e9aed$export$9ead20f582ebf362(I), this;
    }
    // #endregion
    // #region ANIMATE
    updatePose() {
        return $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$$C).call(this), this;
    }
    // #endregion
    solve() {
        this.rig.executor(this.rig, null);
    }
    // #region APPLY
    applyIkPoseToRig(I, g = new $329ek.Vector3()) {
        const C = this.ikpose;
        return I.hip.target.setDirections(C.hip.swing, C.hip.twist).setDeltaMove(C.hip.deltaPos, Math.abs(I.hipHeight / C.hip.bindHeight)), I.spine.target.setDirections(C.spine.startSwing, C.spine.startTwist).setAltDirections(C.spine.endSwing, C.spine.endTwist), I.head.target.setDirections(C.head.swing, C.head.twist), I.leftLeg.target.setDirections(C.legL.swing, C.legL.twist, C.legL.lenScale), I.leftFoot.target.setDirections(C.footL.swing, C.footL.twist), I.rightLeg.target.setDirections(C.legR.swing, C.legR.twist, C.legR.lenScale), I.rightFoot.target.setDirections(C.footR.swing, C.footR.twist), I.leftArm.target.setDirections(C.armL.swing, C.armL.twist, C.armL.lenScale), I.leftHand.target.setDirections(C.handL.swing, C.handL.twist), I.leftShoulder.target.setDirections(C.shoulderL.swing, C.shoulderL.twist), I.rightShoulder.target.setDirections(C.shoulderR.swing, C.shoulderR.twist), I.rightArm.target.setDirections(C.armR.swing, C.armR.twist, C.armR.lenScale), I.rightHand.target.setDirections(C.handR.swing, C.handR.twist), this;
    }
}
$e60bcd291a6e9aed$var$w = new WeakSet(), // #region RETARGET
$e60bcd291a6e9aed$var$$C = function() {
    const I = this.rig, g = this.ikpose;
    $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$Wg).call(this, I.leftArm.chain, g.armL), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$Wg).call(this, I.rightArm.chain, g.armR), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$Wg).call(this, I.leftLeg.chain, g.legL), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$Wg).call(this, I.rightLeg.chain, g.legR), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$gl).call(this, I.spine.chain, g.spine), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$lg).call(this, I.head.chain, g.head), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$lg).call(this, I.leftFoot.chain, g.footL), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$lg).call(this, I.rightFoot.chain, g.footR), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$lg).call(this, I.leftHand.chain, g.handL), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$lg).call(this, I.rightHand.chain, g.handR), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$lg).call(this, I.leftShoulder.chain, g.shoulderL), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$lg).call(this, I.rightShoulder.chain, g.shoulderR), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$lg).call(this, I.hip.chain, g.hip), $e60bcd291a6e9aed$var$Q(this, $e60bcd291a6e9aed$var$w, $e60bcd291a6e9aed$var$Il).call(this, I.hip.chain, g.hip);
}, /** Data from Limb Solver */ $e60bcd291a6e9aed$var$Wg = function(I, g) {
    const C = new $329ek.Vector3();
    this.rig.pose.bones;
    const l = g.swing, A = g.twist, B = I.firstLink, o = this.rig.pose.getBoneByName(B.name), i = this.rig.pose.getBoneByName(I.lastLink.name);
    l.subVectors(i.getWorldPosition(new $329ek.Vector3()), o.getWorldPosition(new $329ek.Vector3())), g.lenScale = l.length() / I.len, l.normalize(), A.copy(B.axes.twist.clone().applyQuaternion(o.getWorldQuaternion(new $329ek.Quaternion()))), C.crossVectors(A, l), A.crossVectors(l, C).normalize();
}, /** Only useful for spine data utilizing two axis rotation */ $e60bcd291a6e9aed$var$gl = function(I, g) {
    let C = I.firstLink, l = this.rig.pose.getBoneByName(C.name);
    g.startSwing.copy(C.axes.swing.clone().applyQuaternion(l.getWorldQuaternion(new $329ek.Quaternion()))).normalize(), g.startTwist.copy(C.axes.twist.clone().applyQuaternion(l.getWorldQuaternion(new $329ek.Quaternion()))).normalize(), C = I.lastLink, l = this.rig.pose.getBoneByName(C.name), g.endSwing.copy(C.axes.swing.clone().applyQuaternion(l.getWorldQuaternion(new $329ek.Quaternion()))).normalize(), g.endTwist.copy(C.axes.twist.clone().applyQuaternion(l.getWorldQuaternion(new $329ek.Quaternion()))).normalize();
}, /** Simple Axis Rotation : Head, Hips, Hands, Feet */ $e60bcd291a6e9aed$var$lg = function(I, g) {
    const C = I.firstLink, l = this.rig.pose.getBoneByName(C.name);
    g.swing.copy(C.axes.swing.clone().applyQuaternion(l.getWorldQuaternion(new $329ek.Quaternion()))).normalize(), g.twist.copy(C.axes.twist.clone().applyQuaternion(l.getWorldQuaternion(new $329ek.Quaternion()))).normalize();
}, /** Used for HIP / ROOT Delta Translation */ $e60bcd291a6e9aed$var$Il = function(I, g) {
    var i;
    const C = I.firstLink, l = this.rig.pose.getBoneByName(C.name), A = l, B = (i = l == null ? void 0 : l.parent) == null ? void 0 : i.matrixWorld.clone().multiply(C.bind), o = new $329ek.Vector3();
    B == null || B.decompose(o, new $329ek.Quaternion(), new $329ek.Vector3()), A && g.deltaPos.subVectors(A.getWorldPosition(new $329ek.Vector3()), o), g.bindHeight = this.rig.hipHeight;
};
class $e60bcd291a6e9aed$var$U {
    constructor(I, g, C){
        // #region MAIN
        $e60bcd291a6e9aed$var$c(this, "rot", new $329ek.Quaternion());
        $e60bcd291a6e9aed$var$c(this, "pos", new $329ek.Vector3(0));
        $e60bcd291a6e9aed$var$c(this, "scl", new $329ek.Vector3(1));
        I instanceof $e60bcd291a6e9aed$var$U ? this.copy(I) : I && g && C && this.set(I, g, C);
    }
    // #endregion
    // #region SETTERS / GETTERS
    reset() {
        return this.rot.identity(), this.pos.set(0, 0, 0), this.scl.set(1, 1, 1), this;
    }
    copy(I) {
        return this.rot.copy(I.rot), this.pos.copy(I.pos), this.scl.copy(I.scl), this;
    }
    set(I, g, C) {
        return I && this.rot.copy(I), g && this.pos.copy(g), C && this.scl.copy(C), this;
    }
    clone() {
        return new $e60bcd291a6e9aed$var$U(this);
    }
    mul(I, g, C) {
        return I instanceof $e60bcd291a6e9aed$var$U && (g = I.pos, C = I.scl, I = I.rot), I && g && (this.pos.add(this.scl.clone().multiply(g).applyQuaternion(this.rot)), C && this.scl.multiply(C), this.rot.multiply(I)), this;
    }
    premultiply(I, g, C) {
        return I instanceof $e60bcd291a6e9aed$var$U && (g = I.pos, C = I.scl, I = I.rot), !I || !g || !C ? this : (this.pos.multiply(C).applyQuaternion(I).add(g), C && this.scl.multiply(C), this.rot.premultiply(I), this);
    }
    addPos(I, g = !1) {
        return g ? this.pos.add(I.clone().applyQuaternion(this.rot)) : this.pos.add(I.clone().multiply(this.scl).applyQuaternion(this.rot)), this;
    }
    // #endregion
    // #region FROM OPERATORS
    fromMul(I, g) {
        const C = I.scl.clone().multiply(g.pos).applyQuaternion(I.rot);
        return this.pos = I.pos.clone().add(C), this.scl = I.scl.clone().multiply(g.scl), this.rot = I.rot.clone().multiply(g.rot), this;
    }
    fromInvert(I) {
        return this.rot = I.rot.invert(), this.scl = $e60bcd291a6e9aed$var$XA(I.scl.clone()), this.pos = I.pos.clone().negate().multiply(this.scl).applyQuaternion(this.rot), this;
    }
    // #endregion
    // #region TRANSFORMATION
    transformVec3(I, g) {
        return (g || I).clone().multiply(this.scl).applyQuaternion(this.rot).add(this.pos);
    }
    // #endregion
    static fromObject3D(I) {
        return new $e60bcd291a6e9aed$var$U(I.quaternion, I.position, I.scale);
    }
    static fromWorlObject3D(I) {
        const g = new $329ek.Quaternion(), C = new $329ek.Vector3(), l = new $329ek.Vector3();
        return I.getWorldQuaternion(g), I.getWorldPosition(C), I.getWorldScale(l), new $e60bcd291a6e9aed$var$U(g, C, l);
    }
}
class $e60bcd291a6e9aed$var$CI {
    // Source pose that this pose came from
    constructor(I){
        // #region MAIN
        $e60bcd291a6e9aed$var$c(this, "arm");
        $e60bcd291a6e9aed$var$c(this, "offset", new $e60bcd291a6e9aed$var$U());
        // Additional offset transformation to apply to pose root
        $e60bcd291a6e9aed$var$c(this, "linkedBone");
        // This skeleton extends another skeleton
        $e60bcd291a6e9aed$var$c(this, "bones", new Array());
        // Bone transformation heirarchy
        $e60bcd291a6e9aed$var$c(this, "srcPose");
        if (I && (this.arm = I), I != null && I.bones) for(let g = 0; g < I.bones.length; g++)this.bones.push(I.bones[g].clone());
    }
    // #endregion
    // #region GETTERS
    getBone(I) {
        switch(typeof I){
            case "string":
                return this.arm.getBoneByName(I) || null;
            case "number":
                return this.bones[I];
        }
        return null;
    }
    getBones(I) {
        const g = [];
        let C;
        for (const l of I)(C = this.getBone(l)) && g.push(C);
        return g;
    }
    clone() {
        const I = new $e60bcd291a6e9aed$var$CI();
        I.arm = this.arm, I.offset.copy(this.offset);
        for (const g of this.bones)I.bones.push(g.clone());
        return I;
    }
    getWorldTailPos(I, g = new $329ek.Vector3()) {
        const C = this.getBone(I);
        return C && $e60bcd291a6e9aed$var$U.fromWorlObject3D(C).transformVec3(g.set(0, 0, 0)), g;
    }
    // #endregion
    // #region SETTERS
    setLocalPos(I, g) {
        const C = this.getBone(I);
        return C && C.position.copy(g), this;
    }
    setLocalRot(I, g) {
        const C = this.getBone(I);
        return C && C.quaternion.copy(g), this;
    }
    copy(I) {
        const g = this.bones.length;
        this.srcPose = I;
        for(let C = 0; C < g; C++)this.bones[C].matrix.copy(I.bones[C].matrix), this.bones[C].matrixWorld.copy(I.bones[C].matrixWorld);
        return this;
    }
    // #endregion
    // #region COMPUTE
    updateWorld() {
        for (const I of this.bones){
            const g = $e60bcd291a6e9aed$var$U.fromObject3D(I), C = $e60bcd291a6e9aed$var$U.fromWorlObject3D(I);
            I.parent !== null ? C.fromMul($e60bcd291a6e9aed$var$U.fromWorlObject3D(I.parent), g) : (C.fromMul(this.offset, g), this.linkedBone && C.premultiply($e60bcd291a6e9aed$var$U.fromWorlObject3D(this.linkedBone)));
        }
        return this;
    }
    getWorldRotation(I, g = new $329ek.Quaternion()) {
        let C = this.getBone(I);
        if (!C) return I === -1 ? g.copy(this.offset.rot) : console.error("Pose.getWorldRotation - bone not found", I), g;
        for(g.copy(C.quaternion); C && C.userData.pindex >= 0;)C = this.bones[C.userData.pindex], g.premultiply(C.quaternion);
        return g.premultiply(this.offset.rot), this.linkedBone && g.premultiply(this.linkedBone.getWorldQuaternion(new $329ek.Quaternion())), g;
    }
    getWorldTransform(I, g = new $e60bcd291a6e9aed$var$U()) {
        const C = this.getBone(I);
        if (!C) return I === -1 ? g.copy(this.offset) : console.error("Pose.getWorldTransform - bone not found", I), g;
        for(g.copy($e60bcd291a6e9aed$var$U.fromObject3D(C)); C.parent !== null;)g.premultiply($e60bcd291a6e9aed$var$U.fromObject3D(C.parent));
        return g.premultiply(this.offset), this.linkedBone && g.premultiply($e60bcd291a6e9aed$var$U.fromWorlObject3D(this.linkedBone)), g;
    }
    getWorldPosition(I, g = new $329ek.Vector3()) {
        return g.copy(this.getWorldTransform(I).pos);
    }
    getWorldScale(I, g = new $329ek.Vector3()) {
        return g.copy(this.getWorldTransform(I).scl);
    }
    getWorldQuaternion(I, g = new $329ek.Quaternion()) {
        return g.copy(this.getWorldTransform(I).rot);
    }
    // #endregion
    // #region OPERATIONS
    rotLocal(I, g, C = 0) {
        const l = this.getBone(I);
        if (l) switch(C){
            case 1:
                l.rotateY(g * Math.PI / 180);
                break;
            case 2:
                l.rotateZ(g * Math.PI / 180);
                break;
            default:
                l.rotateX(g * Math.PI / 180);
                break;
        }
        else console.warn("Bone not found, ", I);
        return this;
    }
    rotWorld(I, g, C = "x") {
        const l = this.getBone(I);
        if (l) {
            const A = this.getWorldQuaternion(I), B = A.clone().multiply(l.quaternion), o = C == "y" ? new $329ek.Vector3(0, 1, 0) : C == "z" ? new $329ek.Vector3(0, 0, 1) : new $329ek.Vector3(1, 0, 0);
            l.applyQuaternion(B.premultiply(new $329ek.Quaternion().setFromAxisAngle(o, g * Math.PI / 180)).premultiply(A).invert());
        } else console.error("Pose.rotWorld - bone not found", I);
        return this;
    }
    moveLocal(I, g) {
        const C = this.getBone(I);
        return C ? C.position.add(g) : console.warn("Pose.moveLocal - bone not found, ", I), this;
    }
    posLocal(I, g) {
        const C = this.getBone(I);
        return C ? C.position.copy(g) : console.warn("Pose.posLocal - bone not found, ", I), this;
    }
    sclLocal(I, g) {
        const C = this.getBone(I);
        return C ? g instanceof $329ek.Vector3 ? C.scale.copy(g) : typeof g == "number" && C.scale.set(g, g, g) : console.warn("Pose.sclLocal - bone not found, ", I), this;
    }
}
class $e60bcd291a6e9aed$export$d12076831286cd4f extends $329ek.SkeletonHelper {
    constructor(g){
        var C;
        super(g);
        $e60bcd291a6e9aed$var$c(this, "_boneMap");
        $e60bcd291a6e9aed$var$c(this, "object");
        $e60bcd291a6e9aed$var$c(this, "_skeleton");
        this.object = g, this._skeleton = new $329ek.Skeleton(this.bones);
        for (const l of this._skeleton.bones)l.userData.index = this._skeleton.bones.indexOf(l), (C = l.parent) != null && C.isBone && (l.userData.pindex = this._skeleton.bones.indexOf(l.parent));
        this._boneMap = new $e60bcd291a6e9aed$export$d0571fb8a1e015e7(this._skeleton);
    }
    get skeleton() {
        return this._skeleton;
    }
    set skeleton(g) {
        this._skeleton = g;
    }
    clone(g) {
        const C = $7UhSE.clone(this.object);
        return console.log("clone", C), new $e60bcd291a6e9aed$export$d12076831286cd4f(C);
    }
    newPose(g = !1) {
        const C = new $e60bcd291a6e9aed$var$CI(this.skeleton);
        return g ? C.updateWorld() : C;
    }
    alignArmature(g) {
        new $e60bcd291a6e9aed$export$b8d19200dd410785().bindTPoses(g, this), this.updateMatrixWorld(!0);
    }
}
const $e60bcd291a6e9aed$var$K = 1, $e60bcd291a6e9aed$var$FG = {
    sil: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    PP: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    FF: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    TH: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    DD: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    kk: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    CH: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    SS: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    nn: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    RR: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    aa: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    E: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    I: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    O: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    U: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: $e60bcd291a6e9aed$var$K
        }
    ]
}, $e60bcd291a6e9aed$var$JG = {
    sil: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    PP: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 1
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    FF: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 1
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.075
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    TH: [
        {
            morphTargetName: "V_Open",
            value: 0.205
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.205
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.705
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0.455
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 1
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0.202
        }
    ],
    DD: [
        {
            morphTargetName: "V_Open",
            value: 0.071
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.071
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.606
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.062
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0.609
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0.702
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0.205
        }
    ],
    kk: [
        {
            morphTargetName: "V_Open",
            value: 0.065
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.065
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.801
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.019
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    CH: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 1
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    SS: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0.202
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 1
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    nn: [
        {
            morphTargetName: "V_Open",
            value: 0.071
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.071
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.606
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0.609
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0.702
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0.205
        }
    ],
    RR: [
        {
            morphTargetName: "V_Open",
            value: 0.109
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.109
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0.91
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.0604
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0.509
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0.509
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0.102
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0.354
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    aa: [
        {
            morphTargetName: "V_Open",
            value: 1
        },
        {
            morphTargetName: "Jaw_Open",
            value: 1
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.3
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    E: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 1
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.91
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    I: [
        {
            morphTargetName: "V_Open",
            value: 0.152
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.152
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.705
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.047
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    O: [
        {
            morphTargetName: "V_Open",
            value: 0.606
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.606
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0.804
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.183
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    U: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0.804
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ]
}, $e60bcd291a6e9aed$var$NG = {
    sil: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    PP: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    FF: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    TH: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    DD: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    kk: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    CH: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    SS: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    nn: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    RR: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    aa: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    E: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    I: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    O: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: $e60bcd291a6e9aed$var$K
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    U: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: $e60bcd291a6e9aed$var$K
        }
    ]
}, $e60bcd291a6e9aed$var$Cl = {
    1: {
        both: [
            "browInnerUp"
        ]
    },
    2: {
        left: [
            "browOuterUpLeft"
        ],
        right: [
            "browOuterUpRight"
        ],
        both: [
            "browOuterUpLeft",
            "browOuterUpRight"
        ]
    },
    4: {
        left: [
            "browDownLeft"
        ],
        right: [
            "browDownRight"
        ],
        both: [
            "browDownLeft",
            "browDownRight"
        ]
    },
    5: {
        left: [
            "eyeWideLeft"
        ],
        right: [
            "eyeWideRight"
        ],
        both: [
            "eyeWideLeft",
            "eyeWideRight"
        ]
    },
    6: {
        left: [
            "cheekSquintLeft"
        ],
        right: [
            "cheekSquintRight"
        ],
        both: [
            "cheekSquintLeft",
            "cheekSquintRight"
        ]
    },
    7: {
        left: [
            "eyeSquintLeft"
        ],
        right: [
            "eyeSquintRight"
        ],
        both: [
            "eyeSquintLeft",
            "eyeSquintRight"
        ]
    },
    9: {
        left: [
            "noseSneerLeft"
        ],
        right: [
            "noseSneerRight"
        ],
        both: [
            "noseSneerLeft",
            "noseSneerRight"
        ]
    },
    10: {
        left: [
            "mouthUpperUpLeft"
        ],
        right: [
            "mouthUpperUpRight"
        ],
        both: [
            "mouthUpperUpLeft",
            "mouthUpperUpRight"
        ]
    },
    12: {
        left: [
            "mouthSmileLeft"
        ],
        right: [
            "mouthSmileRight"
        ],
        both: [
            "mouthSmileLeft",
            "mouthSmileRight"
        ]
    },
    14: {
        left: [
            "mouthDimpleLeft"
        ],
        right: [
            "mouthDimpleRight"
        ],
        both: [
            "mouthDimpleLeft",
            "mouthDimpleRight"
        ]
    },
    15: {
        left: [
            "mouthFrownLeft"
        ],
        right: [
            "mouthFrownRight"
        ],
        both: [
            "mouthFrownLeft",
            "mouthFrownRight"
        ]
    },
    16: {
        left: [
            "mouthLowerDownLeft"
        ],
        right: [
            "mouthLowerDownRight"
        ],
        both: [
            "mouthLowerDownLeft",
            "mouthLowerDownRight"
        ]
    },
    17: {
        both: [
            "mouthShrugLower"
        ]
    },
    18: {
        both: [
            "mouthPucker"
        ]
    },
    20: {
        left: [
            "mouthStretchLeft"
        ],
        right: [
            "mouthStretchRight"
        ],
        both: [
            "mouthStretchLeft",
            "mouthStretchRight"
        ]
    },
    22: {
        both: [
            "mouthFunnel"
        ]
    },
    23: {
        both: []
    },
    24: {
        left: [
            "mouthPressLeft"
        ],
        right: [
            "mouthPressRigh"
        ],
        both: [
            "mouthPressLeft",
            "mouthPressRight"
        ]
    },
    25: {
        both: []
    },
    26: {
        both: [
            "jawOpen"
        ]
    },
    28: {
        both: [
            "mouthRollLower",
            "mouthRollUpper"
        ]
    },
    45: {
        left: [
            "eyeBlinkLeft"
        ],
        right: [
            "eyeBlinkRight"
        ],
        both: [
            "eyeBlinkLeft",
            "eyeBlinkRight"
        ]
    }
}, $e60bcd291a6e9aed$var$vG = {
    1: {
        left: [
            "Brow_Raise_Inner_L"
        ],
        right: [
            "Brow_Raise_Inner_R"
        ],
        both: [
            "Brow_Raise_Inner_L",
            "Brow_Raise_Inner_R"
        ]
    },
    2: {
        left: [
            "Brow_Raise_Outer_L"
        ],
        right: [
            "Brow_Raise_Outer_R"
        ],
        both: [
            "Brow_Raise_Outer_L",
            "Brow_Raise_Outer_R"
        ]
    },
    4: {
        left: [
            "Brow_Drop_L"
        ],
        right: [
            "Brow_Drop_R"
        ],
        both: [
            "Brow_Drop_L",
            "Brow_Drop_R"
        ]
    },
    5: {
        left: [
            "Eye_Wide_L"
        ],
        right: [
            "Eye_Wide_R"
        ],
        both: [
            "Eye_Wide_L",
            "Eye_Wide_R"
        ]
    },
    6: {
        left: [
            "Cheek_Raise_L"
        ],
        right: [
            "Cheek_Raise_R"
        ],
        both: [
            "Cheek_Raise_L",
            "Cheek_Raise_R"
        ]
    },
    7: {
        left: [
            "Eye_Squint_L"
        ],
        right: [
            "Eye_Squint_R"
        ],
        both: [
            "Eye_Squint_L",
            "Eye_Squint_R"
        ]
    },
    9: {
        left: [
            "Nose_Sneer_L"
        ],
        right: [
            "Nose_Sneer_R"
        ],
        both: [
            "Nose_Sneer_L",
            "Nose_Sneer_R"
        ]
    },
    10: {
        left: [
            "Mouth_Upper_L"
        ],
        right: [
            "Mouth_Upper_R"
        ],
        both: [
            "Mouth_Upper_L",
            "Mouth_Upper_R"
        ]
    },
    12: {
        left: [
            "Mouth_Smile_L"
        ],
        right: [
            "Mouth_Smile_R"
        ],
        both: [
            "Mouth_Smile_L",
            "Mouth_Smile_R"
        ]
    },
    14: {
        left: [
            "Mouth_Dimple_L"
        ],
        right: [
            "Mouth_Dimple_R"
        ],
        both: [
            "Mouth_Dimple_L",
            "Mouth_Dimple_R"
        ]
    },
    15: {
        left: [
            "Mouth_Frown_L"
        ],
        right: [
            "Mouth_Frown_R"
        ],
        both: [
            "Mouth_Frown_L",
            "Mouth_Frown_R"
        ]
    },
    16: {
        left: [
            "Mouth_Down_Lower_L"
        ],
        right: [
            "Mouth_Down_Lower_R"
        ],
        both: [
            "Mouth_Down_Lower_L",
            "Mouth_Down_Lower_R"
        ]
    },
    17: {
        both: [
            "Mouth_Shrug_Lower"
        ]
    },
    18: {
        left: [
            "Mouth_Pucker_Up_L",
            "Mouth_Pucker_Down_L"
        ],
        right: [
            "Mouth_Pucker_Up_R",
            "Mouth_Pucker_Up_R"
        ],
        both: [
            "Mouth_Pucker_Up_L",
            "Mouth_Pucker_Down_L",
            "Mouth_Pucker_Up_R",
            "Mouth_Pucker_Up_R"
        ]
    },
    20: {
        left: [
            "Mouth_Stretch_L"
        ],
        right: [
            "Mouth_Stretch_R"
        ],
        both: [
            "Mouth_Stretch_L",
            "Mouth_Stretch_R"
        ]
    },
    22: {
        left: [
            "Mouth_Funnel_Up_L",
            "Mouth_Funnel_Down_L"
        ],
        right: [
            "Mouth_Funnel_Up_R",
            "Mouth_Funnel_Down_R"
        ],
        both: [
            "Mouth_Funnel_Up_L",
            "Mouth_Funnel_Up_R",
            "Mouth_Funnel_Down_L",
            "Mouth_Funnel_Down_R"
        ]
    },
    23: {
        left: [
            "Mouth_Tighten_L"
        ],
        right: [
            "Mouth_Tighten_R"
        ],
        both: [
            "Mouth_Tighten_L",
            "Mouth_Tighten_R"
        ]
    },
    24: {
        left: [
            "Mouth_Press_L"
        ],
        right: [
            "Mouth_Press_R"
        ],
        both: [
            "Mouth_Press_L",
            "Mouth_Press_R"
        ]
    },
    25: {
        both: [
            "Mouth_Down"
        ]
    },
    26: {
        both: [
            "Jaw_Open"
        ]
    },
    28: {
        left: [
            "Mouth_Roll_In_Upper_L",
            "Mouth_Roll_In_Lower_L"
        ],
        right: [
            "Mouth_Roll_In_Upper_R",
            "Mouth_Roll_In_Lower_R"
        ],
        both: [
            "Mouth_Roll_In_Upper_L",
            "Mouth_Roll_In_Upper_R",
            "Mouth_Roll_In_Lower_L",
            "Mouth_Roll_In_Lower_R"
        ]
    },
    45: {
        left: [
            "Eye_Blink_L"
        ],
        right: [
            "Eye_Blink_R"
        ],
        both: [
            "Eye_Blink_L",
            "Eye_Blink_R"
        ],
        limit: 1
    }
}, $e60bcd291a6e9aed$var$ll = [
    "Neck"
], $e60bcd291a6e9aed$var$rG = [
    "CC_Base_NeckTwist01"
], $e60bcd291a6e9aed$var$Al = "Head", $e60bcd291a6e9aed$var$kG = "CC_Base_Head", $e60bcd291a6e9aed$var$zG = [
    "AvatarHead",
    "AvatarTeethLower"
], $e60bcd291a6e9aed$var$MG = [
    "Head_Mesh",
    "Teeth_Mesh",
    "Tongue_Mesh"
], $e60bcd291a6e9aed$var$QG = [
    "CC_Base_Body"
], $e60bcd291a6e9aed$var$UG = {
    lipSyncTargets: $e60bcd291a6e9aed$var$FG,
    blendshapeTargets: $e60bcd291a6e9aed$var$zG,
    blinkTargets: $e60bcd291a6e9aed$var$WC,
    gazeData: {
        bones: $e60bcd291a6e9aed$var$OC,
        morphTargets: $e60bcd291a6e9aed$var$qC
    },
    FACS: $e60bcd291a6e9aed$var$Cl,
    headPoseData: {
        bones: $e60bcd291a6e9aed$var$ll,
        headBone: $e60bcd291a6e9aed$var$Al
    }
}, $e60bcd291a6e9aed$var$DG = {
    lipSyncTargets: $e60bcd291a6e9aed$var$JG,
    blendshapeTargets: $e60bcd291a6e9aed$var$QG,
    blinkTargets: $e60bcd291a6e9aed$var$xl,
    gazeData: {
        bones: $e60bcd291a6e9aed$var$bG,
        morphTargets: $e60bcd291a6e9aed$var$oG
    },
    FACS: $e60bcd291a6e9aed$var$vG,
    headPoseData: {
        bones: $e60bcd291a6e9aed$var$rG,
        headBone: $e60bcd291a6e9aed$var$kG
    }
}, $e60bcd291a6e9aed$var$TG = {
    lipSyncTargets: $e60bcd291a6e9aed$var$NG,
    blendshapeTargets: $e60bcd291a6e9aed$var$MG,
    blinkTargets: $e60bcd291a6e9aed$var$WC,
    gazeData: {
        bones: $e60bcd291a6e9aed$var$OC,
        morphTargets: $e60bcd291a6e9aed$var$qC
    },
    FACS: $e60bcd291a6e9aed$var$Cl,
    headPoseData: {
        bones: $e60bcd291a6e9aed$var$ll,
        headBone: $e60bcd291a6e9aed$var$Al
    }
}, $e60bcd291a6e9aed$var$Cg = {
    content: "  ----    Retorik Licence missing or not available    ----  ",
    width: 300,
    height: 169,
    rotation: 29.5,
    fontStyle: "normal",
    fontWeight: "normal",
    fontColor: "rgba(0,0,0,0.2)",
    fontSize: 14,
    fontFamily: "sans-serif"
};
class $e60bcd291a6e9aed$var$xG {
    constructor(I, g){
        $e60bcd291a6e9aed$var$c(this, "htmlDivElement", null);
        const C = document.createElement("canvas"), l = C.getContext("2d");
        if (l) {
            const A = window.devicePixelRatio || 1, B = $e60bcd291a6e9aed$var$Cg.height * A, o = Number($e60bcd291a6e9aed$var$Cg.fontSize) * A, i = `${$e60bcd291a6e9aed$var$Cg.width * A}px`, Z = `${B}px`;
            C.setAttribute("width", i), C.setAttribute("height", Z), l.rotate(Math.PI / 180 * $e60bcd291a6e9aed$var$Cg.rotation), l.font = `${$e60bcd291a6e9aed$var$Cg.fontStyle} normal ${$e60bcd291a6e9aed$var$Cg.fontWeight} ${o}px/${B}px ${$e60bcd291a6e9aed$var$Cg.fontFamily}`, l.fillStyle = $e60bcd291a6e9aed$var$Cg.fontColor, l.fillText($e60bcd291a6e9aed$var$Cg.content, 0, 0);
            const b = document.createElement("div");
            b.style.position = "absolute", b.style.top = "0px", b.style.width = `${I}px`, b.style.height = `${g}px`, b.style.zIndex = "9999", b.style.pointerEvents = "none", b.style.backgroundImage = `url(${C.toDataURL()})`, b.style.backgroundRepeat = "repeat", this.htmlDivElement = b;
        }
    }
}
class $e60bcd291a6e9aed$export$cb68cc2163cd3f1 extends $329ek.Object3D {
    constructor(g){
        var C, l;
        super();
        $e60bcd291a6e9aed$var$c(this, "_globalManager");
        $e60bcd291a6e9aed$var$c(this, "_controller");
        $e60bcd291a6e9aed$var$c(this, "onAnimationsLoaded");
        if (this._controller = g.controller || null, this._globalManager = new $e60bcd291a6e9aed$export$2e8f4e992a20e5c({
            ...g
        }), this.onAnimationsLoaded = g.onAnimationsLoaded || null, this.add(g.mesh), this.init(g.animationsUrl || $e60bcd291a6e9aed$var$Vg, g.debug), g.license) console.log("Retorik Bodyengine-Three > license found");
        else {
            console.log("Retorik Bodyengine-Three > no license provided");
            let A = Array.from(document.getElementsByTagName("canvas")).find((B)=>B.getAttribute("data-engine") !== null);
            if (!A) {
                const B = (C = Array.from(document.querySelectorAll("*")).find((o)=>o.shadowRoot)) == null ? void 0 : C.shadowRoot;
                B && (A = Array.from(B.querySelectorAll("canvas")).find((o)=>o.getAttribute("data-engine") !== null));
            }
            if (A) {
                const B = new $e60bcd291a6e9aed$var$xG(A.width, A.height);
                B.htmlDivElement && ((l = A.parentElement) == null || l.appendChild(B.htmlDivElement));
            }
        }
    }
    get globalManager() {
        return this._globalManager;
    }
    get lipSyncManager() {
        return this._globalManager.lipSyncManager;
    }
    get blendshapeManager() {
        return this._globalManager.blendshapeManager;
    }
    get animationManager() {
        return this._globalManager.animationManager;
    }
    get eyeBlinkManager() {
        return this._globalManager.eyeBlinkManager;
    }
    get gazeManager() {
        return this._globalManager.gazeManager;
    }
    get FACSManager() {
        return this._globalManager.FACSManager;
    }
    get headPoseManager() {
        return this._globalManager.headPoseManager;
    }
    get bmlManager() {
        return this._globalManager.bmlManager;
    }
    static logDebug(g) {
        console.log(`* @davi-ai/bodyengine-three debug : ${g.text} `, g.value);
    }
    async init(g, C) {
        var A, B;
        typeof g == "string" && (g = [
            g
        ]), C && $e60bcd291a6e9aed$export$cb68cc2163cd3f1.logDebug({
            text: "animations url",
            value: g
        });
        const l = [];
        for (const o of g){
            const i = await fetch(`${o}list.json`).then((Z)=>Z.json());
            C && $e60bcd291a6e9aed$export$cb68cc2163cd3f1.logDebug({
                text: "animation list fetched",
                value: i
            }), i.forEach((Z)=>{
                l.push({
                    url: `${o}${Z[0]}`,
                    from: $e60bcd291a6e9aed$var$$[Z[1]],
                    frequency: Z.length > 2 ? Z[2] : void 0
                });
            });
        }
        C && $e60bcd291a6e9aed$export$cb68cc2163cd3f1.logDebug({
            text: "array of animations to load",
            value: l
        }), l.length ? await this.addAnimationsFromUrls(l, $e60bcd291a6e9aed$var$$.none) : (A = this.onAnimationsLoaded) == null || A.call(this), this._controller && ((B = this._globalManager.animationManager.controllableManager) == null || B.init(this._controller));
    }
    update(g) {
        this._globalManager.update(g);
    }
    static async loadArmatures() {
        return {
            armature: await $e60bcd291a6e9aed$var$L.gltfLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/armatures/armaturetest.glb")
        };
    }
    static async fromCharacterCreator(g) {
        const C = g.animationsUrl || $e60bcd291a6e9aed$var$Vg;
        return g.mesh.getObjectByName("CC_Base_L_Clavicle").rotation.z += 0.025, g.mesh.getObjectByName("CC_Base_R_Clavicle").rotation.z -= 0.025, g.mesh.getObjectByName("CC_Base_L_Thumb1").rotation.z -= Math.PI / 8, g.mesh.getObjectByName("CC_Base_L_Thumb1").rotation.x -= Math.PI / 12, g.mesh.getObjectByName("CC_Base_R_Thumb1").rotation.z += Math.PI / 8, g.mesh.getObjectByName("CC_Base_R_Thumb1").rotation.x -= Math.PI / 12, new Promise(async function(l) {
            const { armature: A } = await $e60bcd291a6e9aed$export$cb68cc2163cd3f1.loadArmatures();
            g.debug && $e60bcd291a6e9aed$export$cb68cc2163cd3f1.logDebug({
                text: "armature loaded",
                value: A
            });
            try {
                const B = new $e60bcd291a6e9aed$export$cb68cc2163cd3f1({
                    ...g,
                    sourceMesh: new $e60bcd291a6e9aed$export$d12076831286cd4f(A.scene.children[0]),
                    targetMesh: new $e60bcd291a6e9aed$export$d12076831286cd4f(g.mesh),
                    animationsUrl: C,
                    ...$e60bcd291a6e9aed$var$DG,
                    type: $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.cc3
                });
                g.debug && $e60bcd291a6e9aed$export$cb68cc2163cd3f1.logDebug({
                    text: "resolve character",
                    value: B
                }), l(B);
            } catch (B) {
                console.warn(B), l(null);
            }
        });
    }
    static async fromAvatarSDK(g) {
        const C = g.animationsUrl || $e60bcd291a6e9aed$var$Vg;
        return g.mesh.getObjectByName("LeftShoulder").position.y -= 0.015, g.mesh.getObjectByName("RightShoulder").position.y -= 0.015, g.mesh.getObjectByName("LeftArm").rotation.x -= 0.05, g.mesh.getObjectByName("RightArm").rotation.x -= 0.05, g.mesh.getObjectByName("LeftHandThumb1").rotation.y += 0.5, g.mesh.getObjectByName("LeftHandThumb1").rotation.z -= 0.25, g.mesh.getObjectByName("RightHandThumb1").rotation.y -= 0.5, g.mesh.getObjectByName("RightHandThumb1").rotation.z += 0.25, g.mesh.getObjectByName("LeftFoot").rotation.x -= 0.05, g.mesh.getObjectByName("RightFoot").rotation.x -= 0.05, g.gender === "male" && (g.mesh.getObjectByName("LeftFoot").rotation.z -= 0.35, g.mesh.getObjectByName("RightFoot").rotation.z += 0.35), new Promise(async function(l) {
            const { armature: A } = await $e60bcd291a6e9aed$export$cb68cc2163cd3f1.loadArmatures();
            g.debug && $e60bcd291a6e9aed$export$cb68cc2163cd3f1.logDebug({
                text: "armature loaded",
                value: A
            });
            try {
                const B = new $e60bcd291a6e9aed$export$cb68cc2163cd3f1({
                    ...g,
                    sourceMesh: new $e60bcd291a6e9aed$export$d12076831286cd4f(A.scene),
                    targetMesh: new $e60bcd291a6e9aed$export$d12076831286cd4f(g.mesh),
                    animationsUrl: C,
                    ...$e60bcd291a6e9aed$var$UG,
                    type: $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.avatarsdk
                });
                g.debug && $e60bcd291a6e9aed$export$cb68cc2163cd3f1.logDebug({
                    text: "resolve character",
                    value: B
                }), l(B);
            } catch (B) {
                console.warn(B), l(null);
            }
        });
    }
    static async fromAvaturn(g) {
        const C = g.animationsUrl || $e60bcd291a6e9aed$var$Vg;
        return g.mesh.getObjectByName("LeftShoulder").position.y -= 0.015, g.mesh.getObjectByName("RightShoulder").position.y -= 0.015, new Promise(async function(l) {
            const { armature: A } = await $e60bcd291a6e9aed$export$cb68cc2163cd3f1.loadArmatures();
            g.debug && $e60bcd291a6e9aed$export$cb68cc2163cd3f1.logDebug({
                text: "armature loaded",
                value: A
            });
            const B = new $e60bcd291a6e9aed$export$cb68cc2163cd3f1({
                ...g,
                sourceMesh: new $e60bcd291a6e9aed$export$d12076831286cd4f(A.scene),
                targetMesh: new $e60bcd291a6e9aed$export$d12076831286cd4f(g.mesh),
                animationsUrl: C,
                ...$e60bcd291a6e9aed$var$TG,
                type: $e60bcd291a6e9aed$export$4a5f7b09ca822d8c.avaturn
            });
            g.debug && $e60bcd291a6e9aed$export$cb68cc2163cd3f1.logDebug({
                text: "resolve character",
                value: B
            }), l(B);
        });
    }
    //////////////////////////// ANIMATION UTILS /////////////////////////////////////
    /**
   * Add one animation to the animationManager
   * @param {AnimationData} data
   */ async addAnimationFromUrl(g) {
        var C;
        try {
            const l = ((C = g.url.split("/").pop()) == null ? void 0 : C.split(".")) || "";
            if (l.length !== 2) throw new Error(`invalid animation url : ${g.url}`);
            let A = new $329ek.Group();
            const B = {
                url: g.url,
                name: l[0],
                returnClip: !1,
                frequency: g.frequency
            };
            switch(g.from){
                case $e60bcd291a6e9aed$var$$.mixamo:
                    await this._globalManager.animationManager.addMixamoAnimation(B);
                    break;
                case $e60bcd291a6e9aed$var$$.actorcore:
                case $e60bcd291a6e9aed$var$$.cc4:
                    await this._globalManager.animationManager.addCC4Animation(B);
                    break;
                case $e60bcd291a6e9aed$var$$.none:
                default:
                    switch(l[1]){
                        case "fbx":
                            A = await $e60bcd291a6e9aed$var$L.fbxLoader.loadAsync(g.url);
                            break;
                        case "glb":
                            {
                                const o = await $e60bcd291a6e9aed$var$L.gltfLoader.loadAsync(g.url);
                                o.scene.animations = o.animations, A = o.scene;
                                break;
                            }
                    }
                    return A;
            }
        } catch (l) {
            console.error(l);
        }
        return null;
    }
    static async overrideArmatureAvatarSDK(g, C, l) {
        var s, u, W;
        const B = (await $e60bcd291a6e9aed$var$L.gltfLoader.loadAsync(g)).scene, o = [], i = C.getObjectByName("AvatarBody").skeleton.bones.map((y)=>y.name);
        for (const y of i)B.getObjectByName(y) && o.push(B.getObjectByName(y));
        C.updateMatrixWorld();
        let Z = new $329ek.Box3().setFromObject(C), b = new $329ek.Vector3();
        Z.getSize(b);
        const a = new $329ek.Skeleton(o), m = C.getObjectByName("Hips");
        m && ((s = C.getObjectByName("AvatarRoot")) == null || s.remove(m));
        const e = (u = B.getObjectByName("AvatarRoot")) == null ? void 0 : u.children[0];
        e && ((W = C.getObjectByName("AvatarRoot")) == null || W.attach(e)), C.traverse((y)=>{
            y.type === "SkinnedMesh" && (y.skeleton = a, y.bind(a));
        }), Z = new $329ek.Box3().setFromObject(C), b = new $329ek.Vector3(), Z.getSize(b);
    }
    static setTPose(g, C, l) {
        const A = [];
        g.traverse((B)=>{
            if (B.isSkinnedMesh) {
                const o = B.skeleton.bones;
                for(const i in C){
                    const Z = o.find((b)=>b.name === i);
                    !Z || A.includes(Z.uuid) || (A.push(Z.uuid), Z.rotation.x += C[i].x, Z.rotation.y += C[i].y, Z.rotation.z += C[i].z);
                }
            }
        });
    }
    /**
   * Add several animations to the animationManager
   * @param {Array<AnimationData>} data
   */ async addAnimationsFromUrls(g, C) {
        var B, o, i, Z;
        const l = g.filter((b)=>b.url.includes("idle")).splice(0, 2), A = g.filter((b)=>b.url.includes("explain")).splice(0, 2);
        g = g.filter((b)=>!l.includes(b) && !A.includes(b));
        for (const b of l)await new Promise((a, m)=>{
            this.addAnimationFromUrl(b).then(()=>a()).catch((e)=>m(e));
        });
        for (const b of A)await new Promise((a, m)=>{
            this.addAnimationFromUrl(b).then(()=>a()).catch((e)=>m(e));
        });
        (B = this._globalManager) != null && B.bmlManager && await ((i = (o = this._globalManager) == null ? void 0 : o.bmlManager) == null ? void 0 : i.loadAnimations(this.addAnimationFromUrl)), (Z = this.onAnimationsLoaded) == null || Z.call(this);
        for (const b of g)await new Promise((a, m)=>{
            this.addAnimationFromUrl(b).then(()=>a()).catch((e)=>m(e));
        });
    }
    playDefaultIdleAnimation() {
        const C = this.getAllAnimationNames().find((l)=>l.includes("idle"));
        C && this._globalManager.animationManager.playAnimation(C);
    }
    showAllAnimations() {
        const g = this.getAllAnimationNames();
        this.testAnimations(g, 0);
    }
    testAnimations(g, C) {
        this._globalManager.animationManager.playAnimation(g[C]), setTimeout(()=>{
            this.testAnimations(g, C === g.length - 1 ? 0 : C + 1);
        }, 3e3);
    }
    stopAnimation() {
        this._globalManager.animationManager.stopAnimations();
    }
    playAnimation(g) {
        this._globalManager.animationManager.playAnimation(g);
    }
    getAllAnimationNames() {
        return this._globalManager.animationManager.getAllAnimationNames();
    }
    getAllAnimations() {
        return this._globalManager.animationManager.getAllAnimations();
    }
}

});
parcelRegister("1W96c", function(module, exports) {

$parcel$export(module.exports, "ShaderChunk", () => $169244187a3eb47b$export$955f9f2e84c43c8b);
$parcel$export(module.exports, "UniformsLib", () => $169244187a3eb47b$export$6643083551874bf5);
$parcel$export(module.exports, "ShaderLib", () => $169244187a3eb47b$export$bee4a7d47f8f5014);
$parcel$export(module.exports, "PMREMGenerator", () => $169244187a3eb47b$export$6add42717753e221);
$parcel$export(module.exports, "WebGLUtils", () => $169244187a3eb47b$export$ddaebcad857649a8);
$parcel$export(module.exports, "WebGLRenderer", () => $169244187a3eb47b$export$f6cc00ef28d7cf97);
$parcel$export(module.exports, "AdditiveAnimationBlendMode", () => (parcelRequire("329ek")).AdditiveAnimationBlendMode);
$parcel$export(module.exports, "AlwaysStencilFunc", () => (parcelRequire("329ek")).AlwaysStencilFunc);
$parcel$export(module.exports, "AmbientLight", () => (parcelRequire("329ek")).AmbientLight);
$parcel$export(module.exports, "AnimationAction", () => (parcelRequire("329ek")).AnimationAction);
$parcel$export(module.exports, "AnimationClip", () => (parcelRequire("329ek")).AnimationClip);
$parcel$export(module.exports, "AnimationLoader", () => (parcelRequire("329ek")).AnimationLoader);
$parcel$export(module.exports, "AnimationMixer", () => (parcelRequire("329ek")).AnimationMixer);
$parcel$export(module.exports, "AnimationObjectGroup", () => (parcelRequire("329ek")).AnimationObjectGroup);
$parcel$export(module.exports, "AnimationUtils", () => (parcelRequire("329ek")).AnimationUtils);
$parcel$export(module.exports, "ArcCurve", () => (parcelRequire("329ek")).ArcCurve);
$parcel$export(module.exports, "ArrowHelper", () => (parcelRequire("329ek")).ArrowHelper);
$parcel$export(module.exports, "AttachedBindMode", () => (parcelRequire("329ek")).AttachedBindMode);
$parcel$export(module.exports, "Audio", () => (parcelRequire("329ek")).Audio);
$parcel$export(module.exports, "AudioAnalyser", () => (parcelRequire("329ek")).AudioAnalyser);
$parcel$export(module.exports, "AudioContext", () => (parcelRequire("329ek")).AudioContext);
$parcel$export(module.exports, "AudioListener", () => (parcelRequire("329ek")).AudioListener);
$parcel$export(module.exports, "AudioLoader", () => (parcelRequire("329ek")).AudioLoader);
$parcel$export(module.exports, "AxesHelper", () => (parcelRequire("329ek")).AxesHelper);
$parcel$export(module.exports, "BasicDepthPacking", () => (parcelRequire("329ek")).BasicDepthPacking);
$parcel$export(module.exports, "BasicShadowMap", () => (parcelRequire("329ek")).BasicShadowMap);
$parcel$export(module.exports, "BatchedMesh", () => (parcelRequire("329ek")).BatchedMesh);
$parcel$export(module.exports, "Bone", () => (parcelRequire("329ek")).Bone);
$parcel$export(module.exports, "BooleanKeyframeTrack", () => (parcelRequire("329ek")).BooleanKeyframeTrack);
$parcel$export(module.exports, "Box2", () => (parcelRequire("329ek")).Box2);
$parcel$export(module.exports, "Box3", () => (parcelRequire("329ek")).Box3);
$parcel$export(module.exports, "Box3Helper", () => (parcelRequire("329ek")).Box3Helper);
$parcel$export(module.exports, "BoxHelper", () => (parcelRequire("329ek")).BoxHelper);
$parcel$export(module.exports, "BufferGeometryLoader", () => (parcelRequire("329ek")).BufferGeometryLoader);
$parcel$export(module.exports, "Cache", () => (parcelRequire("329ek")).Cache);
$parcel$export(module.exports, "Camera", () => (parcelRequire("329ek")).Camera);
$parcel$export(module.exports, "CameraHelper", () => (parcelRequire("329ek")).CameraHelper);
$parcel$export(module.exports, "CanvasTexture", () => (parcelRequire("329ek")).CanvasTexture);
$parcel$export(module.exports, "CapsuleGeometry", () => (parcelRequire("329ek")).CapsuleGeometry);
$parcel$export(module.exports, "CatmullRomCurve3", () => (parcelRequire("329ek")).CatmullRomCurve3);
$parcel$export(module.exports, "CircleGeometry", () => (parcelRequire("329ek")).CircleGeometry);
$parcel$export(module.exports, "Clock", () => (parcelRequire("329ek")).Clock);
$parcel$export(module.exports, "ColorKeyframeTrack", () => (parcelRequire("329ek")).ColorKeyframeTrack);
$parcel$export(module.exports, "CompressedArrayTexture", () => (parcelRequire("329ek")).CompressedArrayTexture);
$parcel$export(module.exports, "CompressedCubeTexture", () => (parcelRequire("329ek")).CompressedCubeTexture);
$parcel$export(module.exports, "CompressedTexture", () => (parcelRequire("329ek")).CompressedTexture);
$parcel$export(module.exports, "CompressedTextureLoader", () => (parcelRequire("329ek")).CompressedTextureLoader);
$parcel$export(module.exports, "ConeGeometry", () => (parcelRequire("329ek")).ConeGeometry);
$parcel$export(module.exports, "Controls", () => (parcelRequire("329ek")).Controls);
$parcel$export(module.exports, "CubeCamera", () => (parcelRequire("329ek")).CubeCamera);
$parcel$export(module.exports, "CubeTextureLoader", () => (parcelRequire("329ek")).CubeTextureLoader);
$parcel$export(module.exports, "CubicBezierCurve", () => (parcelRequire("329ek")).CubicBezierCurve);
$parcel$export(module.exports, "CubicBezierCurve3", () => (parcelRequire("329ek")).CubicBezierCurve3);
$parcel$export(module.exports, "CubicInterpolant", () => (parcelRequire("329ek")).CubicInterpolant);
$parcel$export(module.exports, "CullFaceFrontBack", () => (parcelRequire("329ek")).CullFaceFrontBack);
$parcel$export(module.exports, "Curve", () => (parcelRequire("329ek")).Curve);
$parcel$export(module.exports, "CurvePath", () => (parcelRequire("329ek")).CurvePath);
$parcel$export(module.exports, "CylinderGeometry", () => (parcelRequire("329ek")).CylinderGeometry);
$parcel$export(module.exports, "Cylindrical", () => (parcelRequire("329ek")).Cylindrical);
$parcel$export(module.exports, "DataTextureLoader", () => (parcelRequire("329ek")).DataTextureLoader);
$parcel$export(module.exports, "DataUtils", () => (parcelRequire("329ek")).DataUtils);
$parcel$export(module.exports, "DecrementStencilOp", () => (parcelRequire("329ek")).DecrementStencilOp);
$parcel$export(module.exports, "DecrementWrapStencilOp", () => (parcelRequire("329ek")).DecrementWrapStencilOp);
$parcel$export(module.exports, "DefaultLoadingManager", () => (parcelRequire("329ek")).DefaultLoadingManager);
$parcel$export(module.exports, "DetachedBindMode", () => (parcelRequire("329ek")).DetachedBindMode);
$parcel$export(module.exports, "DirectionalLight", () => (parcelRequire("329ek")).DirectionalLight);
$parcel$export(module.exports, "DirectionalLightHelper", () => (parcelRequire("329ek")).DirectionalLightHelper);
$parcel$export(module.exports, "DiscreteInterpolant", () => (parcelRequire("329ek")).DiscreteInterpolant);
$parcel$export(module.exports, "DodecahedronGeometry", () => (parcelRequire("329ek")).DodecahedronGeometry);
$parcel$export(module.exports, "DynamicCopyUsage", () => (parcelRequire("329ek")).DynamicCopyUsage);
$parcel$export(module.exports, "DynamicDrawUsage", () => (parcelRequire("329ek")).DynamicDrawUsage);
$parcel$export(module.exports, "DynamicReadUsage", () => (parcelRequire("329ek")).DynamicReadUsage);
$parcel$export(module.exports, "EdgesGeometry", () => (parcelRequire("329ek")).EdgesGeometry);
$parcel$export(module.exports, "EllipseCurve", () => (parcelRequire("329ek")).EllipseCurve);
$parcel$export(module.exports, "EqualStencilFunc", () => (parcelRequire("329ek")).EqualStencilFunc);
$parcel$export(module.exports, "ExtrudeGeometry", () => (parcelRequire("329ek")).ExtrudeGeometry);
$parcel$export(module.exports, "FileLoader", () => (parcelRequire("329ek")).FileLoader);
$parcel$export(module.exports, "Float16BufferAttribute", () => (parcelRequire("329ek")).Float16BufferAttribute);
$parcel$export(module.exports, "Fog", () => (parcelRequire("329ek")).Fog);
$parcel$export(module.exports, "FogExp2", () => (parcelRequire("329ek")).FogExp2);
$parcel$export(module.exports, "FramebufferTexture", () => (parcelRequire("329ek")).FramebufferTexture);
$parcel$export(module.exports, "FrustumArray", () => (parcelRequire("329ek")).FrustumArray);
$parcel$export(module.exports, "GLBufferAttribute", () => (parcelRequire("329ek")).GLBufferAttribute);
$parcel$export(module.exports, "GLSL1", () => (parcelRequire("329ek")).GLSL1);
$parcel$export(module.exports, "GreaterEqualStencilFunc", () => (parcelRequire("329ek")).GreaterEqualStencilFunc);
$parcel$export(module.exports, "GreaterStencilFunc", () => (parcelRequire("329ek")).GreaterStencilFunc);
$parcel$export(module.exports, "GridHelper", () => (parcelRequire("329ek")).GridHelper);
$parcel$export(module.exports, "Group", () => (parcelRequire("329ek")).Group);
$parcel$export(module.exports, "HemisphereLight", () => (parcelRequire("329ek")).HemisphereLight);
$parcel$export(module.exports, "HemisphereLightHelper", () => (parcelRequire("329ek")).HemisphereLightHelper);
$parcel$export(module.exports, "IcosahedronGeometry", () => (parcelRequire("329ek")).IcosahedronGeometry);
$parcel$export(module.exports, "ImageBitmapLoader", () => (parcelRequire("329ek")).ImageBitmapLoader);
$parcel$export(module.exports, "ImageLoader", () => (parcelRequire("329ek")).ImageLoader);
$parcel$export(module.exports, "ImageUtils", () => (parcelRequire("329ek")).ImageUtils);
$parcel$export(module.exports, "IncrementStencilOp", () => (parcelRequire("329ek")).IncrementStencilOp);
$parcel$export(module.exports, "IncrementWrapStencilOp", () => (parcelRequire("329ek")).IncrementWrapStencilOp);
$parcel$export(module.exports, "InstancedBufferAttribute", () => (parcelRequire("329ek")).InstancedBufferAttribute);
$parcel$export(module.exports, "InstancedBufferGeometry", () => (parcelRequire("329ek")).InstancedBufferGeometry);
$parcel$export(module.exports, "InstancedInterleavedBuffer", () => (parcelRequire("329ek")).InstancedInterleavedBuffer);
$parcel$export(module.exports, "InstancedMesh", () => (parcelRequire("329ek")).InstancedMesh);
$parcel$export(module.exports, "Int16BufferAttribute", () => (parcelRequire("329ek")).Int16BufferAttribute);
$parcel$export(module.exports, "Int32BufferAttribute", () => (parcelRequire("329ek")).Int32BufferAttribute);
$parcel$export(module.exports, "Int8BufferAttribute", () => (parcelRequire("329ek")).Int8BufferAttribute);
$parcel$export(module.exports, "InterleavedBuffer", () => (parcelRequire("329ek")).InterleavedBuffer);
$parcel$export(module.exports, "InterleavedBufferAttribute", () => (parcelRequire("329ek")).InterleavedBufferAttribute);
$parcel$export(module.exports, "Interpolant", () => (parcelRequire("329ek")).Interpolant);
$parcel$export(module.exports, "InterpolateDiscrete", () => (parcelRequire("329ek")).InterpolateDiscrete);
$parcel$export(module.exports, "InterpolateLinear", () => (parcelRequire("329ek")).InterpolateLinear);
$parcel$export(module.exports, "InterpolateSmooth", () => (parcelRequire("329ek")).InterpolateSmooth);
$parcel$export(module.exports, "InterpolationSamplingMode", () => (parcelRequire("329ek")).InterpolationSamplingMode);
$parcel$export(module.exports, "InterpolationSamplingType", () => (parcelRequire("329ek")).InterpolationSamplingType);
$parcel$export(module.exports, "InvertStencilOp", () => (parcelRequire("329ek")).InvertStencilOp);
$parcel$export(module.exports, "KeepStencilOp", () => (parcelRequire("329ek")).KeepStencilOp);
$parcel$export(module.exports, "KeyframeTrack", () => (parcelRequire("329ek")).KeyframeTrack);
$parcel$export(module.exports, "LOD", () => (parcelRequire("329ek")).LOD);
$parcel$export(module.exports, "LatheGeometry", () => (parcelRequire("329ek")).LatheGeometry);
$parcel$export(module.exports, "LessEqualStencilFunc", () => (parcelRequire("329ek")).LessEqualStencilFunc);
$parcel$export(module.exports, "LessStencilFunc", () => (parcelRequire("329ek")).LessStencilFunc);
$parcel$export(module.exports, "Light", () => (parcelRequire("329ek")).Light);
$parcel$export(module.exports, "LightProbe", () => (parcelRequire("329ek")).LightProbe);
$parcel$export(module.exports, "Line", () => (parcelRequire("329ek")).Line);
$parcel$export(module.exports, "Line3", () => (parcelRequire("329ek")).Line3);
$parcel$export(module.exports, "LineBasicMaterial", () => (parcelRequire("329ek")).LineBasicMaterial);
$parcel$export(module.exports, "LineCurve", () => (parcelRequire("329ek")).LineCurve);
$parcel$export(module.exports, "LineCurve3", () => (parcelRequire("329ek")).LineCurve3);
$parcel$export(module.exports, "LineDashedMaterial", () => (parcelRequire("329ek")).LineDashedMaterial);
$parcel$export(module.exports, "LineLoop", () => (parcelRequire("329ek")).LineLoop);
$parcel$export(module.exports, "LineSegments", () => (parcelRequire("329ek")).LineSegments);
$parcel$export(module.exports, "LinearInterpolant", () => (parcelRequire("329ek")).LinearInterpolant);
$parcel$export(module.exports, "LinearMipMapLinearFilter", () => (parcelRequire("329ek")).LinearMipMapLinearFilter);
$parcel$export(module.exports, "LinearMipMapNearestFilter", () => (parcelRequire("329ek")).LinearMipMapNearestFilter);
$parcel$export(module.exports, "Loader", () => (parcelRequire("329ek")).Loader);
$parcel$export(module.exports, "LoaderUtils", () => (parcelRequire("329ek")).LoaderUtils);
$parcel$export(module.exports, "LoadingManager", () => (parcelRequire("329ek")).LoadingManager);
$parcel$export(module.exports, "LoopOnce", () => (parcelRequire("329ek")).LoopOnce);
$parcel$export(module.exports, "LoopPingPong", () => (parcelRequire("329ek")).LoopPingPong);
$parcel$export(module.exports, "LoopRepeat", () => (parcelRequire("329ek")).LoopRepeat);
$parcel$export(module.exports, "MOUSE", () => (parcelRequire("329ek")).MOUSE);
$parcel$export(module.exports, "Material", () => (parcelRequire("329ek")).Material);
$parcel$export(module.exports, "MaterialLoader", () => (parcelRequire("329ek")).MaterialLoader);
$parcel$export(module.exports, "MathUtils", () => (parcelRequire("329ek")).MathUtils);
$parcel$export(module.exports, "Matrix2", () => (parcelRequire("329ek")).Matrix2);
$parcel$export(module.exports, "MeshLambertMaterial", () => (parcelRequire("329ek")).MeshLambertMaterial);
$parcel$export(module.exports, "MeshMatcapMaterial", () => (parcelRequire("329ek")).MeshMatcapMaterial);
$parcel$export(module.exports, "MeshNormalMaterial", () => (parcelRequire("329ek")).MeshNormalMaterial);
$parcel$export(module.exports, "MeshPhongMaterial", () => (parcelRequire("329ek")).MeshPhongMaterial);
$parcel$export(module.exports, "MeshPhysicalMaterial", () => (parcelRequire("329ek")).MeshPhysicalMaterial);
$parcel$export(module.exports, "MeshStandardMaterial", () => (parcelRequire("329ek")).MeshStandardMaterial);
$parcel$export(module.exports, "MeshToonMaterial", () => (parcelRequire("329ek")).MeshToonMaterial);
$parcel$export(module.exports, "NearestMipMapLinearFilter", () => (parcelRequire("329ek")).NearestMipMapLinearFilter);
$parcel$export(module.exports, "NearestMipMapNearestFilter", () => (parcelRequire("329ek")).NearestMipMapNearestFilter);
$parcel$export(module.exports, "NeverStencilFunc", () => (parcelRequire("329ek")).NeverStencilFunc);
$parcel$export(module.exports, "NoNormalPacking", () => (parcelRequire("329ek")).NoNormalPacking);
$parcel$export(module.exports, "NormalAnimationBlendMode", () => (parcelRequire("329ek")).NormalAnimationBlendMode);
$parcel$export(module.exports, "NormalGAPacking", () => (parcelRequire("329ek")).NormalGAPacking);
$parcel$export(module.exports, "NormalRGPacking", () => (parcelRequire("329ek")).NormalRGPacking);
$parcel$export(module.exports, "NotEqualStencilFunc", () => (parcelRequire("329ek")).NotEqualStencilFunc);
$parcel$export(module.exports, "NumberKeyframeTrack", () => (parcelRequire("329ek")).NumberKeyframeTrack);
$parcel$export(module.exports, "Object3D", () => (parcelRequire("329ek")).Object3D);
$parcel$export(module.exports, "ObjectLoader", () => (parcelRequire("329ek")).ObjectLoader);
$parcel$export(module.exports, "OctahedronGeometry", () => (parcelRequire("329ek")).OctahedronGeometry);
$parcel$export(module.exports, "Path", () => (parcelRequire("329ek")).Path);
$parcel$export(module.exports, "PlaneHelper", () => (parcelRequire("329ek")).PlaneHelper);
$parcel$export(module.exports, "PointLight", () => (parcelRequire("329ek")).PointLight);
$parcel$export(module.exports, "PointLightHelper", () => (parcelRequire("329ek")).PointLightHelper);
$parcel$export(module.exports, "Points", () => (parcelRequire("329ek")).Points);
$parcel$export(module.exports, "PointsMaterial", () => (parcelRequire("329ek")).PointsMaterial);
$parcel$export(module.exports, "PolarGridHelper", () => (parcelRequire("329ek")).PolarGridHelper);
$parcel$export(module.exports, "PolyhedronGeometry", () => (parcelRequire("329ek")).PolyhedronGeometry);
$parcel$export(module.exports, "PositionalAudio", () => (parcelRequire("329ek")).PositionalAudio);
$parcel$export(module.exports, "PropertyBinding", () => (parcelRequire("329ek")).PropertyBinding);
$parcel$export(module.exports, "PropertyMixer", () => (parcelRequire("329ek")).PropertyMixer);
$parcel$export(module.exports, "QuadraticBezierCurve", () => (parcelRequire("329ek")).QuadraticBezierCurve);
$parcel$export(module.exports, "QuadraticBezierCurve3", () => (parcelRequire("329ek")).QuadraticBezierCurve3);
$parcel$export(module.exports, "Quaternion", () => (parcelRequire("329ek")).Quaternion);
$parcel$export(module.exports, "QuaternionKeyframeTrack", () => (parcelRequire("329ek")).QuaternionKeyframeTrack);
$parcel$export(module.exports, "QuaternionLinearInterpolant", () => (parcelRequire("329ek")).QuaternionLinearInterpolant);
$parcel$export(module.exports, "RGBADepthPacking", () => (parcelRequire("329ek")).RGBADepthPacking);
$parcel$export(module.exports, "RGBDepthPacking", () => (parcelRequire("329ek")).RGBDepthPacking);
$parcel$export(module.exports, "RGBIntegerFormat", () => (parcelRequire("329ek")).RGBIntegerFormat);
$parcel$export(module.exports, "RGDepthPacking", () => (parcelRequire("329ek")).RGDepthPacking);
$parcel$export(module.exports, "Ray", () => (parcelRequire("329ek")).Ray);
$parcel$export(module.exports, "Raycaster", () => (parcelRequire("329ek")).Raycaster);
$parcel$export(module.exports, "RectAreaLight", () => (parcelRequire("329ek")).RectAreaLight);
$parcel$export(module.exports, "RenderTarget", () => (parcelRequire("329ek")).RenderTarget);
$parcel$export(module.exports, "RenderTarget3D", () => (parcelRequire("329ek")).RenderTarget3D);
$parcel$export(module.exports, "ReplaceStencilOp", () => (parcelRequire("329ek")).ReplaceStencilOp);
$parcel$export(module.exports, "RingGeometry", () => (parcelRequire("329ek")).RingGeometry);
$parcel$export(module.exports, "Scene", () => (parcelRequire("329ek")).Scene);
$parcel$export(module.exports, "ShadowMaterial", () => (parcelRequire("329ek")).ShadowMaterial);
$parcel$export(module.exports, "Shape", () => (parcelRequire("329ek")).Shape);
$parcel$export(module.exports, "ShapeGeometry", () => (parcelRequire("329ek")).ShapeGeometry);
$parcel$export(module.exports, "ShapePath", () => (parcelRequire("329ek")).ShapePath);
$parcel$export(module.exports, "ShapeUtils", () => (parcelRequire("329ek")).ShapeUtils);
$parcel$export(module.exports, "Skeleton", () => (parcelRequire("329ek")).Skeleton);
$parcel$export(module.exports, "SkeletonHelper", () => (parcelRequire("329ek")).SkeletonHelper);
$parcel$export(module.exports, "SkinnedMesh", () => (parcelRequire("329ek")).SkinnedMesh);
$parcel$export(module.exports, "Source", () => (parcelRequire("329ek")).Source);
$parcel$export(module.exports, "Sphere", () => (parcelRequire("329ek")).Sphere);
$parcel$export(module.exports, "SphereGeometry", () => (parcelRequire("329ek")).SphereGeometry);
$parcel$export(module.exports, "Spherical", () => (parcelRequire("329ek")).Spherical);
$parcel$export(module.exports, "SphericalHarmonics3", () => (parcelRequire("329ek")).SphericalHarmonics3);
$parcel$export(module.exports, "SplineCurve", () => (parcelRequire("329ek")).SplineCurve);
$parcel$export(module.exports, "SpotLight", () => (parcelRequire("329ek")).SpotLight);
$parcel$export(module.exports, "SpotLightHelper", () => (parcelRequire("329ek")).SpotLightHelper);
$parcel$export(module.exports, "Sprite", () => (parcelRequire("329ek")).Sprite);
$parcel$export(module.exports, "SpriteMaterial", () => (parcelRequire("329ek")).SpriteMaterial);
$parcel$export(module.exports, "StaticCopyUsage", () => (parcelRequire("329ek")).StaticCopyUsage);
$parcel$export(module.exports, "StaticDrawUsage", () => (parcelRequire("329ek")).StaticDrawUsage);
$parcel$export(module.exports, "StaticReadUsage", () => (parcelRequire("329ek")).StaticReadUsage);
$parcel$export(module.exports, "StereoCamera", () => (parcelRequire("329ek")).StereoCamera);
$parcel$export(module.exports, "StreamCopyUsage", () => (parcelRequire("329ek")).StreamCopyUsage);
$parcel$export(module.exports, "StreamDrawUsage", () => (parcelRequire("329ek")).StreamDrawUsage);
$parcel$export(module.exports, "StreamReadUsage", () => (parcelRequire("329ek")).StreamReadUsage);
$parcel$export(module.exports, "StringKeyframeTrack", () => (parcelRequire("329ek")).StringKeyframeTrack);
$parcel$export(module.exports, "TOUCH", () => (parcelRequire("329ek")).TOUCH);
$parcel$export(module.exports, "TetrahedronGeometry", () => (parcelRequire("329ek")).TetrahedronGeometry);
$parcel$export(module.exports, "TextureLoader", () => (parcelRequire("329ek")).TextureLoader);
$parcel$export(module.exports, "TextureUtils", () => (parcelRequire("329ek")).TextureUtils);
$parcel$export(module.exports, "Timer", () => (parcelRequire("329ek")).Timer);
$parcel$export(module.exports, "TimestampQuery", () => (parcelRequire("329ek")).TimestampQuery);
$parcel$export(module.exports, "TorusGeometry", () => (parcelRequire("329ek")).TorusGeometry);
$parcel$export(module.exports, "TorusKnotGeometry", () => (parcelRequire("329ek")).TorusKnotGeometry);
$parcel$export(module.exports, "Triangle", () => (parcelRequire("329ek")).Triangle);
$parcel$export(module.exports, "TriangleFanDrawMode", () => (parcelRequire("329ek")).TriangleFanDrawMode);
$parcel$export(module.exports, "TriangleStripDrawMode", () => (parcelRequire("329ek")).TriangleStripDrawMode);
$parcel$export(module.exports, "TrianglesDrawMode", () => (parcelRequire("329ek")).TrianglesDrawMode);
$parcel$export(module.exports, "TubeGeometry", () => (parcelRequire("329ek")).TubeGeometry);
$parcel$export(module.exports, "UVMapping", () => (parcelRequire("329ek")).UVMapping);
$parcel$export(module.exports, "Uint8BufferAttribute", () => (parcelRequire("329ek")).Uint8BufferAttribute);
$parcel$export(module.exports, "Uint8ClampedBufferAttribute", () => (parcelRequire("329ek")).Uint8ClampedBufferAttribute);
$parcel$export(module.exports, "Uniform", () => (parcelRequire("329ek")).Uniform);
$parcel$export(module.exports, "UniformsGroup", () => (parcelRequire("329ek")).UniformsGroup);
$parcel$export(module.exports, "VectorKeyframeTrack", () => (parcelRequire("329ek")).VectorKeyframeTrack);
$parcel$export(module.exports, "VideoFrameTexture", () => (parcelRequire("329ek")).VideoFrameTexture);
$parcel$export(module.exports, "VideoTexture", () => (parcelRequire("329ek")).VideoTexture);
$parcel$export(module.exports, "WebGL3DRenderTarget", () => (parcelRequire("329ek")).WebGL3DRenderTarget);
$parcel$export(module.exports, "WebGLArrayRenderTarget", () => (parcelRequire("329ek")).WebGLArrayRenderTarget);
$parcel$export(module.exports, "WebGPUCoordinateSystem", () => (parcelRequire("329ek")).WebGPUCoordinateSystem);
$parcel$export(module.exports, "WireframeGeometry", () => (parcelRequire("329ek")).WireframeGeometry);
$parcel$export(module.exports, "WrapAroundEnding", () => (parcelRequire("329ek")).WrapAroundEnding);
$parcel$export(module.exports, "ZeroCurvatureEnding", () => (parcelRequire("329ek")).ZeroCurvatureEnding);
$parcel$export(module.exports, "ZeroSlopeEnding", () => (parcelRequire("329ek")).ZeroSlopeEnding);
$parcel$export(module.exports, "ZeroStencilOp", () => (parcelRequire("329ek")).ZeroStencilOp);
$parcel$export(module.exports, "getConsoleFunction", () => (parcelRequire("329ek")).getConsoleFunction);
$parcel$export(module.exports, "setConsoleFunction", () => (parcelRequire("329ek")).setConsoleFunction);
$parcel$export(module.exports, "ACESFilmicToneMapping", () => (parcelRequire("329ek")).ACESFilmicToneMapping);
$parcel$export(module.exports, "AddEquation", () => (parcelRequire("329ek")).AddEquation);
$parcel$export(module.exports, "AddOperation", () => (parcelRequire("329ek")).AddOperation);
$parcel$export(module.exports, "AdditiveBlending", () => (parcelRequire("329ek")).AdditiveBlending);
$parcel$export(module.exports, "AgXToneMapping", () => (parcelRequire("329ek")).AgXToneMapping);
$parcel$export(module.exports, "AlphaFormat", () => (parcelRequire("329ek")).AlphaFormat);
$parcel$export(module.exports, "AlwaysCompare", () => (parcelRequire("329ek")).AlwaysCompare);
$parcel$export(module.exports, "AlwaysDepth", () => (parcelRequire("329ek")).AlwaysDepth);
$parcel$export(module.exports, "ArrayCamera", () => (parcelRequire("329ek")).ArrayCamera);
$parcel$export(module.exports, "BackSide", () => (parcelRequire("329ek")).BackSide);
$parcel$export(module.exports, "BoxGeometry", () => (parcelRequire("329ek")).BoxGeometry);
$parcel$export(module.exports, "BufferAttribute", () => (parcelRequire("329ek")).BufferAttribute);
$parcel$export(module.exports, "BufferGeometry", () => (parcelRequire("329ek")).BufferGeometry);
$parcel$export(module.exports, "ByteType", () => (parcelRequire("329ek")).ByteType);
$parcel$export(module.exports, "CineonToneMapping", () => (parcelRequire("329ek")).CineonToneMapping);
$parcel$export(module.exports, "ClampToEdgeWrapping", () => (parcelRequire("329ek")).ClampToEdgeWrapping);
$parcel$export(module.exports, "Color", () => (parcelRequire("329ek")).Color);
$parcel$export(module.exports, "ColorManagement", () => (parcelRequire("329ek")).ColorManagement);
$parcel$export(module.exports, "ConstantAlphaFactor", () => (parcelRequire("329ek")).ConstantAlphaFactor);
$parcel$export(module.exports, "ConstantColorFactor", () => (parcelRequire("329ek")).ConstantColorFactor);
$parcel$export(module.exports, "CubeDepthTexture", () => (parcelRequire("329ek")).CubeDepthTexture);
$parcel$export(module.exports, "CubeReflectionMapping", () => (parcelRequire("329ek")).CubeReflectionMapping);
$parcel$export(module.exports, "CubeRefractionMapping", () => (parcelRequire("329ek")).CubeRefractionMapping);
$parcel$export(module.exports, "CubeTexture", () => (parcelRequire("329ek")).CubeTexture);
$parcel$export(module.exports, "CubeUVReflectionMapping", () => (parcelRequire("329ek")).CubeUVReflectionMapping);
$parcel$export(module.exports, "CullFaceBack", () => (parcelRequire("329ek")).CullFaceBack);
$parcel$export(module.exports, "CullFaceFront", () => (parcelRequire("329ek")).CullFaceFront);
$parcel$export(module.exports, "CullFaceNone", () => (parcelRequire("329ek")).CullFaceNone);
$parcel$export(module.exports, "CustomBlending", () => (parcelRequire("329ek")).CustomBlending);
$parcel$export(module.exports, "CustomToneMapping", () => (parcelRequire("329ek")).CustomToneMapping);
$parcel$export(module.exports, "Data3DTexture", () => (parcelRequire("329ek")).Data3DTexture);
$parcel$export(module.exports, "DataArrayTexture", () => (parcelRequire("329ek")).DataArrayTexture);
$parcel$export(module.exports, "DataTexture", () => (parcelRequire("329ek")).DataTexture);
$parcel$export(module.exports, "DepthFormat", () => (parcelRequire("329ek")).DepthFormat);
$parcel$export(module.exports, "DepthStencilFormat", () => (parcelRequire("329ek")).DepthStencilFormat);
$parcel$export(module.exports, "DepthTexture", () => (parcelRequire("329ek")).DepthTexture);
$parcel$export(module.exports, "DoubleSide", () => (parcelRequire("329ek")).DoubleSide);
$parcel$export(module.exports, "DstAlphaFactor", () => (parcelRequire("329ek")).DstAlphaFactor);
$parcel$export(module.exports, "DstColorFactor", () => (parcelRequire("329ek")).DstColorFactor);
$parcel$export(module.exports, "EqualCompare", () => (parcelRequire("329ek")).EqualCompare);
$parcel$export(module.exports, "EqualDepth", () => (parcelRequire("329ek")).EqualDepth);
$parcel$export(module.exports, "EquirectangularReflectionMapping", () => (parcelRequire("329ek")).EquirectangularReflectionMapping);
$parcel$export(module.exports, "EquirectangularRefractionMapping", () => (parcelRequire("329ek")).EquirectangularRefractionMapping);
$parcel$export(module.exports, "Euler", () => (parcelRequire("329ek")).Euler);
$parcel$export(module.exports, "EventDispatcher", () => (parcelRequire("329ek")).EventDispatcher);
$parcel$export(module.exports, "ExternalTexture", () => (parcelRequire("329ek")).ExternalTexture);
$parcel$export(module.exports, "Float32BufferAttribute", () => (parcelRequire("329ek")).Float32BufferAttribute);
$parcel$export(module.exports, "FloatType", () => (parcelRequire("329ek")).FloatType);
$parcel$export(module.exports, "FrontSide", () => (parcelRequire("329ek")).FrontSide);
$parcel$export(module.exports, "Frustum", () => (parcelRequire("329ek")).Frustum);
$parcel$export(module.exports, "GLSL3", () => (parcelRequire("329ek")).GLSL3);
$parcel$export(module.exports, "GreaterCompare", () => (parcelRequire("329ek")).GreaterCompare);
$parcel$export(module.exports, "GreaterDepth", () => (parcelRequire("329ek")).GreaterDepth);
$parcel$export(module.exports, "GreaterEqualCompare", () => (parcelRequire("329ek")).GreaterEqualCompare);
$parcel$export(module.exports, "GreaterEqualDepth", () => (parcelRequire("329ek")).GreaterEqualDepth);
$parcel$export(module.exports, "HalfFloatType", () => (parcelRequire("329ek")).HalfFloatType);
$parcel$export(module.exports, "IntType", () => (parcelRequire("329ek")).IntType);
$parcel$export(module.exports, "Layers", () => (parcelRequire("329ek")).Layers);
$parcel$export(module.exports, "LessCompare", () => (parcelRequire("329ek")).LessCompare);
$parcel$export(module.exports, "LessDepth", () => (parcelRequire("329ek")).LessDepth);
$parcel$export(module.exports, "LessEqualCompare", () => (parcelRequire("329ek")).LessEqualCompare);
$parcel$export(module.exports, "LessEqualDepth", () => (parcelRequire("329ek")).LessEqualDepth);
$parcel$export(module.exports, "LinearFilter", () => (parcelRequire("329ek")).LinearFilter);
$parcel$export(module.exports, "LinearMipmapLinearFilter", () => (parcelRequire("329ek")).LinearMipmapLinearFilter);
$parcel$export(module.exports, "LinearMipmapNearestFilter", () => (parcelRequire("329ek")).LinearMipmapNearestFilter);
$parcel$export(module.exports, "LinearSRGBColorSpace", () => (parcelRequire("329ek")).LinearSRGBColorSpace);
$parcel$export(module.exports, "LinearToneMapping", () => (parcelRequire("329ek")).LinearToneMapping);
$parcel$export(module.exports, "LinearTransfer", () => (parcelRequire("329ek")).LinearTransfer);
$parcel$export(module.exports, "Matrix3", () => (parcelRequire("329ek")).Matrix3);
$parcel$export(module.exports, "Matrix4", () => (parcelRequire("329ek")).Matrix4);
$parcel$export(module.exports, "MaxEquation", () => (parcelRequire("329ek")).MaxEquation);
$parcel$export(module.exports, "Mesh", () => (parcelRequire("329ek")).Mesh);
$parcel$export(module.exports, "MeshBasicMaterial", () => (parcelRequire("329ek")).MeshBasicMaterial);
$parcel$export(module.exports, "MeshDepthMaterial", () => (parcelRequire("329ek")).MeshDepthMaterial);
$parcel$export(module.exports, "MeshDistanceMaterial", () => (parcelRequire("329ek")).MeshDistanceMaterial);
$parcel$export(module.exports, "MinEquation", () => (parcelRequire("329ek")).MinEquation);
$parcel$export(module.exports, "MirroredRepeatWrapping", () => (parcelRequire("329ek")).MirroredRepeatWrapping);
$parcel$export(module.exports, "MixOperation", () => (parcelRequire("329ek")).MixOperation);
$parcel$export(module.exports, "MultiplyBlending", () => (parcelRequire("329ek")).MultiplyBlending);
$parcel$export(module.exports, "MultiplyOperation", () => (parcelRequire("329ek")).MultiplyOperation);
$parcel$export(module.exports, "NearestFilter", () => (parcelRequire("329ek")).NearestFilter);
$parcel$export(module.exports, "NearestMipmapLinearFilter", () => (parcelRequire("329ek")).NearestMipmapLinearFilter);
$parcel$export(module.exports, "NearestMipmapNearestFilter", () => (parcelRequire("329ek")).NearestMipmapNearestFilter);
$parcel$export(module.exports, "NeutralToneMapping", () => (parcelRequire("329ek")).NeutralToneMapping);
$parcel$export(module.exports, "NeverCompare", () => (parcelRequire("329ek")).NeverCompare);
$parcel$export(module.exports, "NeverDepth", () => (parcelRequire("329ek")).NeverDepth);
$parcel$export(module.exports, "NoBlending", () => (parcelRequire("329ek")).NoBlending);
$parcel$export(module.exports, "NoColorSpace", () => (parcelRequire("329ek")).NoColorSpace);
$parcel$export(module.exports, "NoToneMapping", () => (parcelRequire("329ek")).NoToneMapping);
$parcel$export(module.exports, "NormalBlending", () => (parcelRequire("329ek")).NormalBlending);
$parcel$export(module.exports, "NotEqualCompare", () => (parcelRequire("329ek")).NotEqualCompare);
$parcel$export(module.exports, "NotEqualDepth", () => (parcelRequire("329ek")).NotEqualDepth);
$parcel$export(module.exports, "ObjectSpaceNormalMap", () => (parcelRequire("329ek")).ObjectSpaceNormalMap);
$parcel$export(module.exports, "OneFactor", () => (parcelRequire("329ek")).OneFactor);
$parcel$export(module.exports, "OneMinusConstantAlphaFactor", () => (parcelRequire("329ek")).OneMinusConstantAlphaFactor);
$parcel$export(module.exports, "OneMinusConstantColorFactor", () => (parcelRequire("329ek")).OneMinusConstantColorFactor);
$parcel$export(module.exports, "OneMinusDstAlphaFactor", () => (parcelRequire("329ek")).OneMinusDstAlphaFactor);
$parcel$export(module.exports, "OneMinusDstColorFactor", () => (parcelRequire("329ek")).OneMinusDstColorFactor);
$parcel$export(module.exports, "OneMinusSrcAlphaFactor", () => (parcelRequire("329ek")).OneMinusSrcAlphaFactor);
$parcel$export(module.exports, "OneMinusSrcColorFactor", () => (parcelRequire("329ek")).OneMinusSrcColorFactor);
$parcel$export(module.exports, "OrthographicCamera", () => (parcelRequire("329ek")).OrthographicCamera);
$parcel$export(module.exports, "PCFShadowMap", () => (parcelRequire("329ek")).PCFShadowMap);
$parcel$export(module.exports, "PCFSoftShadowMap", () => (parcelRequire("329ek")).PCFSoftShadowMap);
$parcel$export(module.exports, "PerspectiveCamera", () => (parcelRequire("329ek")).PerspectiveCamera);
$parcel$export(module.exports, "Plane", () => (parcelRequire("329ek")).Plane);
$parcel$export(module.exports, "PlaneGeometry", () => (parcelRequire("329ek")).PlaneGeometry);
$parcel$export(module.exports, "R11_EAC_Format", () => (parcelRequire("329ek")).R11_EAC_Format);
$parcel$export(module.exports, "RED_GREEN_RGTC2_Format", () => (parcelRequire("329ek")).RED_GREEN_RGTC2_Format);
$parcel$export(module.exports, "RED_RGTC1_Format", () => (parcelRequire("329ek")).RED_RGTC1_Format);
$parcel$export(module.exports, "REVISION", () => (parcelRequire("329ek")).REVISION);
$parcel$export(module.exports, "RG11_EAC_Format", () => (parcelRequire("329ek")).RG11_EAC_Format);
$parcel$export(module.exports, "RGBAFormat", () => (parcelRequire("329ek")).RGBAFormat);
$parcel$export(module.exports, "RGBAIntegerFormat", () => (parcelRequire("329ek")).RGBAIntegerFormat);
$parcel$export(module.exports, "RGBA_ASTC_10x10_Format", () => (parcelRequire("329ek")).RGBA_ASTC_10x10_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x5_Format", () => (parcelRequire("329ek")).RGBA_ASTC_10x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x6_Format", () => (parcelRequire("329ek")).RGBA_ASTC_10x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x8_Format", () => (parcelRequire("329ek")).RGBA_ASTC_10x8_Format);
$parcel$export(module.exports, "RGBA_ASTC_12x10_Format", () => (parcelRequire("329ek")).RGBA_ASTC_12x10_Format);
$parcel$export(module.exports, "RGBA_ASTC_12x12_Format", () => (parcelRequire("329ek")).RGBA_ASTC_12x12_Format);
$parcel$export(module.exports, "RGBA_ASTC_4x4_Format", () => (parcelRequire("329ek")).RGBA_ASTC_4x4_Format);
$parcel$export(module.exports, "RGBA_ASTC_5x4_Format", () => (parcelRequire("329ek")).RGBA_ASTC_5x4_Format);
$parcel$export(module.exports, "RGBA_ASTC_5x5_Format", () => (parcelRequire("329ek")).RGBA_ASTC_5x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_6x5_Format", () => (parcelRequire("329ek")).RGBA_ASTC_6x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_6x6_Format", () => (parcelRequire("329ek")).RGBA_ASTC_6x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x5_Format", () => (parcelRequire("329ek")).RGBA_ASTC_8x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x6_Format", () => (parcelRequire("329ek")).RGBA_ASTC_8x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x8_Format", () => (parcelRequire("329ek")).RGBA_ASTC_8x8_Format);
$parcel$export(module.exports, "RGBA_BPTC_Format", () => (parcelRequire("329ek")).RGBA_BPTC_Format);
$parcel$export(module.exports, "RGBA_ETC2_EAC_Format", () => (parcelRequire("329ek")).RGBA_ETC2_EAC_Format);
$parcel$export(module.exports, "RGBA_PVRTC_2BPPV1_Format", () => (parcelRequire("329ek")).RGBA_PVRTC_2BPPV1_Format);
$parcel$export(module.exports, "RGBA_PVRTC_4BPPV1_Format", () => (parcelRequire("329ek")).RGBA_PVRTC_4BPPV1_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT1_Format", () => (parcelRequire("329ek")).RGBA_S3TC_DXT1_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT3_Format", () => (parcelRequire("329ek")).RGBA_S3TC_DXT3_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT5_Format", () => (parcelRequire("329ek")).RGBA_S3TC_DXT5_Format);
$parcel$export(module.exports, "RGBFormat", () => (parcelRequire("329ek")).RGBFormat);
$parcel$export(module.exports, "RGB_BPTC_SIGNED_Format", () => (parcelRequire("329ek")).RGB_BPTC_SIGNED_Format);
$parcel$export(module.exports, "RGB_BPTC_UNSIGNED_Format", () => (parcelRequire("329ek")).RGB_BPTC_UNSIGNED_Format);
$parcel$export(module.exports, "RGB_ETC1_Format", () => (parcelRequire("329ek")).RGB_ETC1_Format);
$parcel$export(module.exports, "RGB_ETC2_Format", () => (parcelRequire("329ek")).RGB_ETC2_Format);
$parcel$export(module.exports, "RGB_PVRTC_2BPPV1_Format", () => (parcelRequire("329ek")).RGB_PVRTC_2BPPV1_Format);
$parcel$export(module.exports, "RGB_PVRTC_4BPPV1_Format", () => (parcelRequire("329ek")).RGB_PVRTC_4BPPV1_Format);
$parcel$export(module.exports, "RGB_S3TC_DXT1_Format", () => (parcelRequire("329ek")).RGB_S3TC_DXT1_Format);
$parcel$export(module.exports, "RGFormat", () => (parcelRequire("329ek")).RGFormat);
$parcel$export(module.exports, "RGIntegerFormat", () => (parcelRequire("329ek")).RGIntegerFormat);
$parcel$export(module.exports, "RawShaderMaterial", () => (parcelRequire("329ek")).RawShaderMaterial);
$parcel$export(module.exports, "RedFormat", () => (parcelRequire("329ek")).RedFormat);
$parcel$export(module.exports, "RedIntegerFormat", () => (parcelRequire("329ek")).RedIntegerFormat);
$parcel$export(module.exports, "ReinhardToneMapping", () => (parcelRequire("329ek")).ReinhardToneMapping);
$parcel$export(module.exports, "RepeatWrapping", () => (parcelRequire("329ek")).RepeatWrapping);
$parcel$export(module.exports, "ReverseSubtractEquation", () => (parcelRequire("329ek")).ReverseSubtractEquation);
$parcel$export(module.exports, "SIGNED_R11_EAC_Format", () => (parcelRequire("329ek")).SIGNED_R11_EAC_Format);
$parcel$export(module.exports, "SIGNED_RED_GREEN_RGTC2_Format", () => (parcelRequire("329ek")).SIGNED_RED_GREEN_RGTC2_Format);
$parcel$export(module.exports, "SIGNED_RED_RGTC1_Format", () => (parcelRequire("329ek")).SIGNED_RED_RGTC1_Format);
$parcel$export(module.exports, "SIGNED_RG11_EAC_Format", () => (parcelRequire("329ek")).SIGNED_RG11_EAC_Format);
$parcel$export(module.exports, "SRGBColorSpace", () => (parcelRequire("329ek")).SRGBColorSpace);
$parcel$export(module.exports, "SRGBTransfer", () => (parcelRequire("329ek")).SRGBTransfer);
$parcel$export(module.exports, "ShaderMaterial", () => (parcelRequire("329ek")).ShaderMaterial);
$parcel$export(module.exports, "ShortType", () => (parcelRequire("329ek")).ShortType);
$parcel$export(module.exports, "SrcAlphaFactor", () => (parcelRequire("329ek")).SrcAlphaFactor);
$parcel$export(module.exports, "SrcAlphaSaturateFactor", () => (parcelRequire("329ek")).SrcAlphaSaturateFactor);
$parcel$export(module.exports, "SrcColorFactor", () => (parcelRequire("329ek")).SrcColorFactor);
$parcel$export(module.exports, "SubtractEquation", () => (parcelRequire("329ek")).SubtractEquation);
$parcel$export(module.exports, "SubtractiveBlending", () => (parcelRequire("329ek")).SubtractiveBlending);
$parcel$export(module.exports, "TangentSpaceNormalMap", () => (parcelRequire("329ek")).TangentSpaceNormalMap);
$parcel$export(module.exports, "Texture", () => (parcelRequire("329ek")).Texture);
$parcel$export(module.exports, "Uint16BufferAttribute", () => (parcelRequire("329ek")).Uint16BufferAttribute);
$parcel$export(module.exports, "Uint32BufferAttribute", () => (parcelRequire("329ek")).Uint32BufferAttribute);
$parcel$export(module.exports, "UniformsUtils", () => (parcelRequire("329ek")).UniformsUtils);
$parcel$export(module.exports, "UnsignedByteType", () => (parcelRequire("329ek")).UnsignedByteType);
$parcel$export(module.exports, "UnsignedInt101111Type", () => (parcelRequire("329ek")).UnsignedInt101111Type);
$parcel$export(module.exports, "UnsignedInt248Type", () => (parcelRequire("329ek")).UnsignedInt248Type);
$parcel$export(module.exports, "UnsignedInt5999Type", () => (parcelRequire("329ek")).UnsignedInt5999Type);
$parcel$export(module.exports, "UnsignedIntType", () => (parcelRequire("329ek")).UnsignedIntType);
$parcel$export(module.exports, "UnsignedShort4444Type", () => (parcelRequire("329ek")).UnsignedShort4444Type);
$parcel$export(module.exports, "UnsignedShort5551Type", () => (parcelRequire("329ek")).UnsignedShort5551Type);
$parcel$export(module.exports, "UnsignedShortType", () => (parcelRequire("329ek")).UnsignedShortType);
$parcel$export(module.exports, "VSMShadowMap", () => (parcelRequire("329ek")).VSMShadowMap);
$parcel$export(module.exports, "Vector2", () => (parcelRequire("329ek")).Vector2);
$parcel$export(module.exports, "Vector3", () => (parcelRequire("329ek")).Vector3);
$parcel$export(module.exports, "Vector4", () => (parcelRequire("329ek")).Vector4);
$parcel$export(module.exports, "WebGLCoordinateSystem", () => (parcelRequire("329ek")).WebGLCoordinateSystem);
$parcel$export(module.exports, "WebGLCubeRenderTarget", () => (parcelRequire("329ek")).WebGLCubeRenderTarget);
$parcel$export(module.exports, "WebGLRenderTarget", () => (parcelRequire("329ek")).WebGLRenderTarget);
$parcel$export(module.exports, "WebXRController", () => (parcelRequire("329ek")).WebXRController);
$parcel$export(module.exports, "ZeroFactor", () => (parcelRequire("329ek")).ZeroFactor);
$parcel$export(module.exports, "createCanvasElement", () => (parcelRequire("329ek")).createCanvasElement);
$parcel$export(module.exports, "error", () => (parcelRequire("329ek")).error);
$parcel$export(module.exports, "log", () => (parcelRequire("329ek")).log);
$parcel$export(module.exports, "warn", () => (parcelRequire("329ek")).warn);
$parcel$export(module.exports, "warnOnce", () => (parcelRequire("329ek")).warnOnce);
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
var $329ek = parcelRequire("329ek");
function $169244187a3eb47b$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $169244187a3eb47b$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (typeof Float16Array !== 'undefined' && array instanceof Float16Array) type = gl.HALF_FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var $169244187a3eb47b$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $169244187a3eb47b$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $169244187a3eb47b$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $169244187a3eb47b$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $169244187a3eb47b$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $169244187a3eb47b$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $169244187a3eb47b$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $169244187a3eb47b$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $169244187a3eb47b$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";
var $169244187a3eb47b$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $169244187a3eb47b$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $169244187a3eb47b$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $169244187a3eb47b$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $169244187a3eb47b$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $169244187a3eb47b$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $169244187a3eb47b$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $169244187a3eb47b$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $169244187a3eb47b$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $169244187a3eb47b$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $169244187a3eb47b$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $169244187a3eb47b$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $169244187a3eb47b$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $169244187a3eb47b$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";
var $169244187a3eb47b$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $169244187a3eb47b$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $169244187a3eb47b$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $169244187a3eb47b$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $169244187a3eb47b$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $169244187a3eb47b$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $169244187a3eb47b$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $169244187a3eb47b$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $169244187a3eb47b$var$colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $169244187a3eb47b$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $169244187a3eb47b$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n#endif";
var $169244187a3eb47b$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $169244187a3eb47b$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $169244187a3eb47b$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $169244187a3eb47b$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $169244187a3eb47b$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $169244187a3eb47b$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $169244187a3eb47b$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $169244187a3eb47b$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $169244187a3eb47b$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $169244187a3eb47b$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $169244187a3eb47b$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $169244187a3eb47b$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $169244187a3eb47b$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $169244187a3eb47b$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $169244187a3eb47b$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $169244187a3eb47b$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $169244187a3eb47b$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $169244187a3eb47b$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.metalness = metalnessFactor;\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = vec3( 0.04 );\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $169244187a3eb47b$var$lights_physical_pars_fragment = "uniform sampler2D dfgLUT;\nstruct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tvec3 diffuseContribution;\n\tvec3 specularColor;\n\tvec3 specularColorBlended;\n\tfloat roughness;\n\tfloat metalness;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t\tvec3 iridescenceFresnelDielectric;\n\t\tvec3 iridescenceFresnelMetallic;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn v;\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColorBlended;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat rInv = 1.0 / ( roughness + 0.1 );\n\tfloat a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;\n\tfloat b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;\n\tfloat DG = exp( a * dotNV + b );\n\treturn saturate( DG );\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nvec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 dfgV = texture2D( dfgLUT, vec2( material.roughness, dotNV ) ).rg;\n\tvec2 dfgL = texture2D( dfgLUT, vec2( material.roughness, dotNL ) ).rg;\n\tvec3 FssEss_V = material.specularColorBlended * dfgV.x + material.specularF90 * dfgV.y;\n\tvec3 FssEss_L = material.specularColorBlended * dfgL.x + material.specularF90 * dfgL.y;\n\tfloat Ess_V = dfgV.x + dfgV.y;\n\tfloat Ess_L = dfgL.x + dfgL.y;\n\tfloat Ems_V = 1.0 - Ess_V;\n\tfloat Ems_L = 1.0 - Ess_L;\n\tvec3 Favg = material.specularColorBlended + ( 1.0 - material.specularColorBlended ) * 0.047619;\n\tvec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg + EPSILON );\n\tfloat compensationFactor = Ems_V * Ems_L;\n\tvec3 multiScatter = Fms * compensationFactor;\n\treturn singleScatter + multiScatter;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColorBlended * t2.x + ( vec3( 1.0 ) - material.specularColorBlended ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n \n \t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n \n \t\tfloat sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n \t\tfloat sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );\n \n \t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );\n \n \t\tirradiance *= sheenEnergyComp;\n \n \t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution );\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tdiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectDiffuse += diffuse;\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;\n \t#endif\n\tvec3 singleScatteringDielectric = vec3( 0.0 );\n\tvec3 multiScatteringDielectric = vec3( 0.0 );\n\tvec3 singleScatteringMetallic = vec3( 0.0 );\n\tvec3 multiScatteringMetallic = vec3( 0.0 );\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnelDielectric, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceFresnelMetallic, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#endif\n\tvec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );\n\tvec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );\n\tvec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;\n\tvec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tvec3 indirectSpecular = radiance * singleScattering;\n\tindirectSpecular += multiScattering * cosineWeightedIrradiance;\n\tvec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tindirectSpecular *= sheenEnergyComp;\n\t\tindirectDiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectSpecular += indirectSpecular;\n\treflectedLight.indirectDiffuse += indirectDiffuse;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $169244187a3eb47b$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );\n\t\tmaterial.iridescenceFresnel = mix( material.iridescenceFresnelDielectric, material.iridescenceFresnelMetallic, material.metalness );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $169244187a3eb47b$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $169244187a3eb47b$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $169244187a3eb47b$var$logdepthbuf_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $169244187a3eb47b$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $169244187a3eb47b$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $169244187a3eb47b$var$logdepthbuf_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $169244187a3eb47b$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $169244187a3eb47b$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $169244187a3eb47b$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $169244187a3eb47b$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $169244187a3eb47b$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $169244187a3eb47b$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $169244187a3eb47b$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $169244187a3eb47b$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $169244187a3eb47b$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $169244187a3eb47b$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $169244187a3eb47b$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $169244187a3eb47b$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $169244187a3eb47b$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $169244187a3eb47b$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $169244187a3eb47b$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $169244187a3eb47b$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $169244187a3eb47b$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $169244187a3eb47b$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $169244187a3eb47b$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $169244187a3eb47b$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $169244187a3eb47b$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $169244187a3eb47b$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $169244187a3eb47b$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $169244187a3eb47b$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $169244187a3eb47b$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $169244187a3eb47b$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $169244187a3eb47b$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $169244187a3eb47b$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $169244187a3eb47b$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $169244187a3eb47b$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\t\t\tuniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat interleavedGradientNoise( vec2 position ) {\n\t\t\treturn fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );\n\t\t}\n\t\tvec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {\n\t\t\tconst float goldenAngle = 2.399963229728653;\n\t\t\tfloat r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );\n\t\t\tfloat theta = float( sampleIndex ) * goldenAngle + phi;\n\t\t\treturn vec2( cos( theta ), sin( theta ) ) * r;\n\t\t}\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\tshadowCoord.z += shadowBias;\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\t\tfloat radius = shadowRadius * texelSize.x;\n\t\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * 6.28318530718;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )\n\t\t\t\t) * 0.2;\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\tshadowCoord.z += shadowBias;\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;\n\t\t\t\tfloat mean = distribution.x;\n\t\t\t\tfloat variance = distribution.y * distribution.y;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tfloat hard_shadow = step( mean, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tfloat hard_shadow = step( shadowCoord.z, mean );\n\t\t\t\t#endif\n\t\t\t\tif ( hard_shadow == 1.0 ) {\n\t\t\t\t\tshadow = 1.0;\n\t\t\t\t} else {\n\t\t\t\t\tvariance = max( variance, 0.0000001 );\n\t\t\t\t\tfloat d = shadowCoord.z - mean;\n\t\t\t\t\tfloat p_max = variance / ( variance + d * d );\n\t\t\t\t\tp_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );\n\t\t\t\t\tshadow = max( hard_shadow, p_max );\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#else\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\tshadowCoord.z += shadowBias;\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tfloat depth = texture2D( shadowMap, shadowCoord.xy ).r;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tshadow = step( depth, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tshadow = step( shadowCoord.z, depth );\n\t\t\t\t#endif\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\tfloat getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\tdp += shadowBias;\n\t\t\tfloat texelSize = shadowRadius / shadowMapSize.x;\n\t\t\tvec3 absDir = abs( bd3D );\n\t\t\tvec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );\n\t\t\ttangent = normalize( cross( bd3D, tangent ) );\n\t\t\tvec3 bitangent = cross( bd3D, tangent );\n\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * 6.28318530718;\n\t\t\tshadow = (\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 0, 5, phi ).x + bitangent * vogelDiskSample( 0, 5, phi ).y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 1, 5, phi ).x + bitangent * vogelDiskSample( 1, 5, phi ).y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 2, 5, phi ).x + bitangent * vogelDiskSample( 2, 5, phi ).y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 3, 5, phi ).x + bitangent * vogelDiskSample( 3, 5, phi ).y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 4, 5, phi ).x + bitangent * vogelDiskSample( 4, 5, phi ).y ) * texelSize, dp ) )\n\t\t\t) * 0.2;\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\tfloat getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\tdp += shadowBias;\n\t\t\tfloat depth = textureCube( shadowMap, bd3D ).r;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tshadow = step( depth, dp );\n\t\t\t#else\n\t\t\t\tshadow = step( dp, depth );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#endif\n\t#endif\n#endif";
var $169244187a3eb47b$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $169244187a3eb47b$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $169244187a3eb47b$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $169244187a3eb47b$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $169244187a3eb47b$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $169244187a3eb47b$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $169244187a3eb47b$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $169244187a3eb47b$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $169244187a3eb47b$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $169244187a3eb47b$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $169244187a3eb47b$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $169244187a3eb47b$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $169244187a3eb47b$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $169244187a3eb47b$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $169244187a3eb47b$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $169244187a3eb47b$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $169244187a3eb47b$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $169244187a3eb47b$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $169244187a3eb47b$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $169244187a3eb47b$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $169244187a3eb47b$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $169244187a3eb47b$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $169244187a3eb47b$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $169244187a3eb47b$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $169244187a3eb47b$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\tfloat fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n\t#else\n\t\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n\t#endif\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
const $169244187a3eb47b$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $169244187a3eb47b$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );\n}";
const $169244187a3eb47b$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $169244187a3eb47b$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $169244187a3eb47b$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $169244187a3eb47b$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $169244187a3eb47b$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $169244187a3eb47b$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $169244187a3eb47b$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $169244187a3eb47b$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n \n\t\toutgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;\n \n \t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $169244187a3eb47b$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $169244187a3eb47b$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $169244187a3eb47b$export$955f9f2e84c43c8b = {
    alphahash_fragment: $169244187a3eb47b$var$alphahash_fragment,
    alphahash_pars_fragment: $169244187a3eb47b$var$alphahash_pars_fragment,
    alphamap_fragment: $169244187a3eb47b$var$alphamap_fragment,
    alphamap_pars_fragment: $169244187a3eb47b$var$alphamap_pars_fragment,
    alphatest_fragment: $169244187a3eb47b$var$alphatest_fragment,
    alphatest_pars_fragment: $169244187a3eb47b$var$alphatest_pars_fragment,
    aomap_fragment: $169244187a3eb47b$var$aomap_fragment,
    aomap_pars_fragment: $169244187a3eb47b$var$aomap_pars_fragment,
    batching_pars_vertex: $169244187a3eb47b$var$batching_pars_vertex,
    batching_vertex: $169244187a3eb47b$var$batching_vertex,
    begin_vertex: $169244187a3eb47b$var$begin_vertex,
    beginnormal_vertex: $169244187a3eb47b$var$beginnormal_vertex,
    bsdfs: $169244187a3eb47b$var$bsdfs,
    iridescence_fragment: $169244187a3eb47b$var$iridescence_fragment,
    bumpmap_pars_fragment: $169244187a3eb47b$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $169244187a3eb47b$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $169244187a3eb47b$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $169244187a3eb47b$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $169244187a3eb47b$var$clipping_planes_vertex,
    color_fragment: $169244187a3eb47b$var$color_fragment,
    color_pars_fragment: $169244187a3eb47b$var$color_pars_fragment,
    color_pars_vertex: $169244187a3eb47b$var$color_pars_vertex,
    color_vertex: $169244187a3eb47b$var$color_vertex,
    common: $169244187a3eb47b$var$common,
    cube_uv_reflection_fragment: $169244187a3eb47b$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $169244187a3eb47b$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $169244187a3eb47b$var$displacementmap_pars_vertex,
    displacementmap_vertex: $169244187a3eb47b$var$displacementmap_vertex,
    emissivemap_fragment: $169244187a3eb47b$var$emissivemap_fragment,
    emissivemap_pars_fragment: $169244187a3eb47b$var$emissivemap_pars_fragment,
    colorspace_fragment: $169244187a3eb47b$var$colorspace_fragment,
    colorspace_pars_fragment: $169244187a3eb47b$var$colorspace_pars_fragment,
    envmap_fragment: $169244187a3eb47b$var$envmap_fragment,
    envmap_common_pars_fragment: $169244187a3eb47b$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $169244187a3eb47b$var$envmap_pars_fragment,
    envmap_pars_vertex: $169244187a3eb47b$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $169244187a3eb47b$var$envmap_physical_pars_fragment,
    envmap_vertex: $169244187a3eb47b$var$envmap_vertex,
    fog_vertex: $169244187a3eb47b$var$fog_vertex,
    fog_pars_vertex: $169244187a3eb47b$var$fog_pars_vertex,
    fog_fragment: $169244187a3eb47b$var$fog_fragment,
    fog_pars_fragment: $169244187a3eb47b$var$fog_pars_fragment,
    gradientmap_pars_fragment: $169244187a3eb47b$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $169244187a3eb47b$var$lightmap_pars_fragment,
    lights_lambert_fragment: $169244187a3eb47b$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $169244187a3eb47b$var$lights_lambert_pars_fragment,
    lights_pars_begin: $169244187a3eb47b$var$lights_pars_begin,
    lights_toon_fragment: $169244187a3eb47b$var$lights_toon_fragment,
    lights_toon_pars_fragment: $169244187a3eb47b$var$lights_toon_pars_fragment,
    lights_phong_fragment: $169244187a3eb47b$var$lights_phong_fragment,
    lights_phong_pars_fragment: $169244187a3eb47b$var$lights_phong_pars_fragment,
    lights_physical_fragment: $169244187a3eb47b$var$lights_physical_fragment,
    lights_physical_pars_fragment: $169244187a3eb47b$var$lights_physical_pars_fragment,
    lights_fragment_begin: $169244187a3eb47b$var$lights_fragment_begin,
    lights_fragment_maps: $169244187a3eb47b$var$lights_fragment_maps,
    lights_fragment_end: $169244187a3eb47b$var$lights_fragment_end,
    logdepthbuf_fragment: $169244187a3eb47b$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $169244187a3eb47b$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $169244187a3eb47b$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $169244187a3eb47b$var$logdepthbuf_vertex,
    map_fragment: $169244187a3eb47b$var$map_fragment,
    map_pars_fragment: $169244187a3eb47b$var$map_pars_fragment,
    map_particle_fragment: $169244187a3eb47b$var$map_particle_fragment,
    map_particle_pars_fragment: $169244187a3eb47b$var$map_particle_pars_fragment,
    metalnessmap_fragment: $169244187a3eb47b$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $169244187a3eb47b$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $169244187a3eb47b$var$morphinstance_vertex,
    morphcolor_vertex: $169244187a3eb47b$var$morphcolor_vertex,
    morphnormal_vertex: $169244187a3eb47b$var$morphnormal_vertex,
    morphtarget_pars_vertex: $169244187a3eb47b$var$morphtarget_pars_vertex,
    morphtarget_vertex: $169244187a3eb47b$var$morphtarget_vertex,
    normal_fragment_begin: $169244187a3eb47b$var$normal_fragment_begin,
    normal_fragment_maps: $169244187a3eb47b$var$normal_fragment_maps,
    normal_pars_fragment: $169244187a3eb47b$var$normal_pars_fragment,
    normal_pars_vertex: $169244187a3eb47b$var$normal_pars_vertex,
    normal_vertex: $169244187a3eb47b$var$normal_vertex,
    normalmap_pars_fragment: $169244187a3eb47b$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $169244187a3eb47b$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $169244187a3eb47b$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $169244187a3eb47b$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $169244187a3eb47b$var$iridescence_pars_fragment,
    opaque_fragment: $169244187a3eb47b$var$opaque_fragment,
    packing: $169244187a3eb47b$var$packing,
    premultiplied_alpha_fragment: $169244187a3eb47b$var$premultiplied_alpha_fragment,
    project_vertex: $169244187a3eb47b$var$project_vertex,
    dithering_fragment: $169244187a3eb47b$var$dithering_fragment,
    dithering_pars_fragment: $169244187a3eb47b$var$dithering_pars_fragment,
    roughnessmap_fragment: $169244187a3eb47b$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $169244187a3eb47b$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $169244187a3eb47b$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $169244187a3eb47b$var$shadowmap_pars_vertex,
    shadowmap_vertex: $169244187a3eb47b$var$shadowmap_vertex,
    shadowmask_pars_fragment: $169244187a3eb47b$var$shadowmask_pars_fragment,
    skinbase_vertex: $169244187a3eb47b$var$skinbase_vertex,
    skinning_pars_vertex: $169244187a3eb47b$var$skinning_pars_vertex,
    skinning_vertex: $169244187a3eb47b$var$skinning_vertex,
    skinnormal_vertex: $169244187a3eb47b$var$skinnormal_vertex,
    specularmap_fragment: $169244187a3eb47b$var$specularmap_fragment,
    specularmap_pars_fragment: $169244187a3eb47b$var$specularmap_pars_fragment,
    tonemapping_fragment: $169244187a3eb47b$var$tonemapping_fragment,
    tonemapping_pars_fragment: $169244187a3eb47b$var$tonemapping_pars_fragment,
    transmission_fragment: $169244187a3eb47b$var$transmission_fragment,
    transmission_pars_fragment: $169244187a3eb47b$var$transmission_pars_fragment,
    uv_pars_fragment: $169244187a3eb47b$var$uv_pars_fragment,
    uv_pars_vertex: $169244187a3eb47b$var$uv_pars_vertex,
    uv_vertex: $169244187a3eb47b$var$uv_vertex,
    worldpos_vertex: $169244187a3eb47b$var$worldpos_vertex,
    background_vert: $169244187a3eb47b$var$vertex$h,
    background_frag: $169244187a3eb47b$var$fragment$h,
    backgroundCube_vert: $169244187a3eb47b$var$vertex$g,
    backgroundCube_frag: $169244187a3eb47b$var$fragment$g,
    cube_vert: $169244187a3eb47b$var$vertex$f,
    cube_frag: $169244187a3eb47b$var$fragment$f,
    depth_vert: $169244187a3eb47b$var$vertex$e,
    depth_frag: $169244187a3eb47b$var$fragment$e,
    distance_vert: $169244187a3eb47b$var$vertex$d,
    distance_frag: $169244187a3eb47b$var$fragment$d,
    equirect_vert: $169244187a3eb47b$var$vertex$c,
    equirect_frag: $169244187a3eb47b$var$fragment$c,
    linedashed_vert: $169244187a3eb47b$var$vertex$b,
    linedashed_frag: $169244187a3eb47b$var$fragment$b,
    meshbasic_vert: $169244187a3eb47b$var$vertex$a,
    meshbasic_frag: $169244187a3eb47b$var$fragment$a,
    meshlambert_vert: $169244187a3eb47b$var$vertex$9,
    meshlambert_frag: $169244187a3eb47b$var$fragment$9,
    meshmatcap_vert: $169244187a3eb47b$var$vertex$8,
    meshmatcap_frag: $169244187a3eb47b$var$fragment$8,
    meshnormal_vert: $169244187a3eb47b$var$vertex$7,
    meshnormal_frag: $169244187a3eb47b$var$fragment$7,
    meshphong_vert: $169244187a3eb47b$var$vertex$6,
    meshphong_frag: $169244187a3eb47b$var$fragment$6,
    meshphysical_vert: $169244187a3eb47b$var$vertex$5,
    meshphysical_frag: $169244187a3eb47b$var$fragment$5,
    meshtoon_vert: $169244187a3eb47b$var$vertex$4,
    meshtoon_frag: $169244187a3eb47b$var$fragment$4,
    points_vert: $169244187a3eb47b$var$vertex$3,
    points_frag: $169244187a3eb47b$var$fragment$3,
    shadow_vert: $169244187a3eb47b$var$vertex$2,
    shadow_frag: $169244187a3eb47b$var$fragment$2,
    sprite_vert: $169244187a3eb47b$var$vertex$1,
    sprite_frag: $169244187a3eb47b$var$fragment$1
};
// Uniforms library for shared webgl shaders
const $169244187a3eb47b$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $329ek.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        },
        dfgLUT: {
            value: null
        } // DFG LUT for physically-based rendering
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        normalScale: {
            value: /*@__PURE__*/ new (0, $329ek.Vector2)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new (0, $329ek.Color)(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $329ek.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $329ek.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new (0, $329ek.Vector2)(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $169244187a3eb47b$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.specularmap,
            $169244187a3eb47b$export$6643083551874bf5.envmap,
            $169244187a3eb47b$export$6643083551874bf5.aomap,
            $169244187a3eb47b$export$6643083551874bf5.lightmap,
            $169244187a3eb47b$export$6643083551874bf5.fog
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.specularmap,
            $169244187a3eb47b$export$6643083551874bf5.envmap,
            $169244187a3eb47b$export$6643083551874bf5.aomap,
            $169244187a3eb47b$export$6643083551874bf5.lightmap,
            $169244187a3eb47b$export$6643083551874bf5.emissivemap,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            $169244187a3eb47b$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.specularmap,
            $169244187a3eb47b$export$6643083551874bf5.envmap,
            $169244187a3eb47b$export$6643083551874bf5.aomap,
            $169244187a3eb47b$export$6643083551874bf5.lightmap,
            $169244187a3eb47b$export$6643083551874bf5.emissivemap,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            $169244187a3eb47b$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.envmap,
            $169244187a3eb47b$export$6643083551874bf5.aomap,
            $169244187a3eb47b$export$6643083551874bf5.lightmap,
            $169244187a3eb47b$export$6643083551874bf5.emissivemap,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            $169244187a3eb47b$export$6643083551874bf5.roughnessmap,
            $169244187a3eb47b$export$6643083551874bf5.metalnessmap,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            $169244187a3eb47b$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.aomap,
            $169244187a3eb47b$export$6643083551874bf5.lightmap,
            $169244187a3eb47b$export$6643083551874bf5.emissivemap,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            $169244187a3eb47b$export$6643083551874bf5.gradientmap,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            $169244187a3eb47b$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.points,
            $169244187a3eb47b$export$6643083551874bf5.fog
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.sprite,
            $169244187a3eb47b$export$6643083551874bf5.fog
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            }
        },
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.equirect_frag
    },
    distance: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new (0, $329ek.Vector3)()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.distance_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.distance_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.lights,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.shadow_frag
    }
};
$169244187a3eb47b$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
        $169244187a3eb47b$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new (0, $329ek.Vector2)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new (0, $329ek.Vector2)()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new (0, $329ek.Color)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new (0, $329ek.Vector2)()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            }
        }
    ]),
    vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphysical_frag
};
const $169244187a3eb47b$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $169244187a3eb47b$var$_e1$1 = /*@__PURE__*/ new (0, $329ek.Euler)();
const $169244187a3eb47b$var$_m1$1 = /*@__PURE__*/ new (0, $329ek.Matrix4)();
function $169244187a3eb47b$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new (0, $329ek.Color)(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === (0, $329ek.CubeUVReflectionMapping))) {
            if (boxMesh === undefined) {
                boxMesh = new (0, $329ek.Mesh)(new (0, $329ek.BoxGeometry)(1, 1, 1), new (0, $329ek.ShaderMaterial)({
                    name: 'BackgroundCubeMaterial',
                    uniforms: (0, $329ek.cloneUniforms)($169244187a3eb47b$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $169244187a3eb47b$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $169244187a3eb47b$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: (0, $329ek.BackSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $169244187a3eb47b$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $169244187a3eb47b$var$_e1$1.x *= -1;
            $169244187a3eb47b$var$_e1$1.y *= -1;
            $169244187a3eb47b$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $169244187a3eb47b$var$_e1$1.y *= -1;
                $169244187a3eb47b$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($169244187a3eb47b$var$_m1$1.makeRotationFromEuler($169244187a3eb47b$var$_e1$1));
            boxMesh.material.toneMapped = (0, $329ek.ColorManagement).getTransfer(background.colorSpace) !== (0, $329ek.SRGBTransfer);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new (0, $329ek.Mesh)(new (0, $329ek.PlaneGeometry)(2, 2), new (0, $329ek.ShaderMaterial)({
                    name: 'BackgroundMaterial',
                    uniforms: (0, $329ek.cloneUniforms)($169244187a3eb47b$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $169244187a3eb47b$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $169244187a3eb47b$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: (0, $329ek.FrontSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = (0, $329ek.ColorManagement).getTransfer(background.colorSpace) !== (0, $329ek.SRGBTransfer);
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($169244187a3eb47b$var$_rgb, (0, $329ek.getUnlitUniformColorSpace)(renderer));
        state.buffers.color.setClear($169244187a3eb47b$var$_rgb.r, $169244187a3eb47b$var$_rgb.g, $169244187a3eb47b$var$_rgb.b, alpha, premultipliedAlpha);
    }
    function dispose() {
        if (boxMesh !== undefined) {
            boxMesh.geometry.dispose();
            boxMesh.material.dispose();
            boxMesh = undefined;
        }
        if (planeMesh !== undefined) {
            planeMesh.geometry.dispose();
            planeMesh.material.dispose();
            planeMesh = undefined;
        }
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList,
        dispose: dispose
    };
}
function $169244187a3eb47b$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === (0, $329ek.IntType);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $169244187a3eb47b$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $169244187a3eb47b$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== (0, $329ek.RGBAFormat) && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === (0, $329ek.HalfFloatType) && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== (0, $329ek.UnsignedByteType) && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== (0, $329ek.FloatType) && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        (0, $329ek.warn)('WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reversedDepthBuffer = parameters.reversedDepthBuffer === true && extensions.has('EXT_clip_control');
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    const samples = gl.getParameter(gl.SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reversedDepthBuffer: reversedDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        maxSamples: maxSamples,
        samples: samples
    };
}
function $169244187a3eb47b$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new (0, $329ek.Plane)(), viewNormalMatrix = new (0, $329ek.Matrix3)(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $169244187a3eb47b$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === (0, $329ek.EquirectangularReflectionMapping)) texture.mapping = (0, $329ek.CubeReflectionMapping);
        else if (mapping === (0, $329ek.EquirectangularRefractionMapping)) texture.mapping = (0, $329ek.CubeRefractionMapping);
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === (0, $329ek.EquirectangularReflectionMapping) || mapping === (0, $329ek.EquirectangularRefractionMapping)) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new (0, $329ek.WebGLCubeRenderTarget)(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $169244187a3eb47b$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips.
// Used for scene blur in fromScene() method.
const $169244187a3eb47b$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
// Used for scene blur in fromScene() method.
const $169244187a3eb47b$var$MAX_SAMPLES = 20;
// GGX VNDF importance sampling configuration
const $169244187a3eb47b$var$GGX_SAMPLES = 256;
const $169244187a3eb47b$var$_flatCamera = /*@__PURE__*/ new (0, $329ek.OrthographicCamera)();
const $169244187a3eb47b$var$_clearColor = /*@__PURE__*/ new (0, $329ek.Color)();
let $169244187a3eb47b$var$_oldTarget = null;
let $169244187a3eb47b$var$_oldActiveCubeFace = 0;
let $169244187a3eb47b$var$_oldActiveMipmapLevel = 0;
let $169244187a3eb47b$var$_oldXrEnabled = false;
const $169244187a3eb47b$var$_origin = /*@__PURE__*/ new (0, $329ek.Vector3)();
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * The prefiltering uses GGX VNDF (Visible Normal Distribution Function)
 * importance sampling based on "Sampling the GGX Distribution of Visible Normals"
 * (Heitz, 2018) to generate environment maps that accurately match the GGX BRDF
 * used in material rendering for physically-based image-based lighting.
 */ class $169244187a3eb47b$export$6add42717753e221 {
    /**
	 * Constructs a new PMREM generator.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 */ constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._sizeLods = [];
        this._sigmas = [];
        this._lodMeshes = [];
        this._backgroundBox = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._blurMaterial = null;
        this._ggxMaterial = null;
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety.
	 *
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.position=origin] - The position of the internal cube camera that renders the scene.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        const { size: size = 256, position: position = $169244187a3eb47b$var$_origin } = options;
        $169244187a3eb47b$var$_oldTarget = this._renderer.getRenderTarget();
        $169244187a3eb47b$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $169244187a3eb47b$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $169244187a3eb47b$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(size);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $169244187a3eb47b$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $169244187a3eb47b$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
        if (this._backgroundBox !== null) {
            this._backgroundBox.geometry.dispose();
            this._backgroundBox.material.dispose();
        }
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._ggxMaterial !== null) this._ggxMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodMeshes.length; i++)this._lodMeshes[i].geometry.dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($169244187a3eb47b$var$_oldTarget, $169244187a3eb47b$var$_oldActiveCubeFace, $169244187a3eb47b$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $169244187a3eb47b$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $169244187a3eb47b$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === (0, $329ek.CubeReflectionMapping) || texture.mapping === (0, $329ek.CubeRefractionMapping)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $169244187a3eb47b$var$_oldTarget = this._renderer.getRenderTarget();
        $169244187a3eb47b$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $169244187a3eb47b$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $169244187a3eb47b$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: (0, $329ek.LinearFilter),
            minFilter: (0, $329ek.LinearFilter),
            generateMipmaps: false,
            type: (0, $329ek.HalfFloatType),
            format: (0, $329ek.RGBAFormat),
            colorSpace: (0, $329ek.LinearSRGBColorSpace),
            depthBuffer: false
        };
        const cubeUVRenderTarget = $169244187a3eb47b$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $169244187a3eb47b$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = $169244187a3eb47b$var$_createPlanes(_lodMax));
            this._blurMaterial = $169244187a3eb47b$var$_getBlurShader(_lodMax, width, height);
            this._ggxMaterial = $169244187a3eb47b$var$_getGGXShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const mesh = new (0, $329ek.Mesh)(new (0, $329ek.BufferGeometry)(), material);
        this._renderer.compile(mesh, $169244187a3eb47b$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new (0, $329ek.PerspectiveCamera)(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($169244187a3eb47b$var$_clearColor);
        renderer.toneMapping = (0, $329ek.NoToneMapping);
        renderer.autoClear = false;
        // https://github.com/mrdoob/three.js/issues/31413#issuecomment-3095966812
        const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        if (reversedDepthBuffer) {
            renderer.setRenderTarget(cubeUVRenderTarget);
            renderer.clearDepth();
            renderer.setRenderTarget(null);
        }
        if (this._backgroundBox === null) this._backgroundBox = new (0, $329ek.Mesh)(new (0, $329ek.BoxGeometry)(), new (0, $329ek.MeshBasicMaterial)({
            name: 'PMREM.Background',
            side: (0, $329ek.BackSide),
            depthWrite: false,
            depthTest: false
        }));
        const backgroundBox = this._backgroundBox;
        const backgroundMaterial = backgroundBox.material;
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($169244187a3eb47b$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
            }
            const size = this._cubeSize;
            $169244187a3eb47b$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, $329ek.CubeReflectionMapping) || texture.mapping === (0, $329ek.CubeRefractionMapping);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $169244187a3eb47b$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $169244187a3eb47b$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = this._lodMeshes[0];
        mesh.material = material;
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $169244187a3eb47b$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $169244187a3eb47b$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodMeshes.length;
        // Use GGX VNDF importance sampling
        for(let i = 1; i < n; i++)this._applyGGXFilter(cubeUVRenderTarget, i - 1, i);
        renderer.autoClear = autoClear;
    }
    /**
	 * Applies GGX VNDF importance sampling filter to generate a prefiltered environment map.
	 * Uses Monte Carlo integration with VNDF importance sampling to accurately represent the
	 * GGX BRDF for physically-based rendering. Reads from the previous LOD level and
	 * applies incremental roughness filtering to avoid over-blurring.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn - Source LOD level to read from
	 * @param {number} lodOut - Target LOD level to write to
	 */ _applyGGXFilter(cubeUVRenderTarget, lodIn, lodOut) {
        const renderer = this._renderer;
        const pingPongRenderTarget = this._pingPongRenderTarget;
        const ggxMaterial = this._ggxMaterial;
        const ggxMesh = this._lodMeshes[lodOut];
        ggxMesh.material = ggxMaterial;
        const ggxUniforms = ggxMaterial.uniforms;
        // Calculate incremental roughness between LOD levels
        const targetRoughness = lodOut / (this._lodMeshes.length - 1);
        const sourceRoughness = lodIn / (this._lodMeshes.length - 1);
        const incrementalRoughness = Math.sqrt(targetRoughness * targetRoughness - sourceRoughness * sourceRoughness);
        // Apply blur strength mapping for better quality across the roughness range
        const blurStrength = 0.0 + targetRoughness * 1.25;
        const adjustedRoughness = incrementalRoughness * blurStrength;
        // Calculate viewport position based on output LOD level
        const { _lodMax: _lodMax } = this;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $169244187a3eb47b$var$LOD_MIN ? lodOut - _lodMax + $169244187a3eb47b$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        // Read from previous LOD with incremental roughness
        ggxUniforms['envMap'].value = cubeUVRenderTarget.texture;
        ggxUniforms['roughness'].value = adjustedRoughness;
        ggxUniforms['mipInt'].value = _lodMax - lodIn; // Sample from input LOD
        $169244187a3eb47b$var$_setViewport(pingPongRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(pingPongRenderTarget);
        renderer.render(ggxMesh, $169244187a3eb47b$var$_flatCamera);
        // Copy from pingPong back to cubeUV (simple direct copy)
        ggxUniforms['envMap'].value = pingPongRenderTarget.texture;
        ggxUniforms['roughness'].value = 0.0; // Direct copy
        ggxUniforms['mipInt'].value = _lodMax - lodOut; // Read from the level we just wrote
        $169244187a3eb47b$var$_setViewport(cubeUVRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(ggxMesh, $169244187a3eb47b$var$_flatCamera);
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * Used for initial scene blur in fromScene() method when sigma > 0.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn
	 * @param {number} lodOut
	 * @param {number} sigma
	 * @param {Vector3} [poleAxis]
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') (0, $329ek.error)('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = this._lodMeshes[lodOut];
        blurMesh.material = blurMaterial;
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $169244187a3eb47b$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $169244187a3eb47b$var$MAX_SAMPLES;
        if (samples > $169244187a3eb47b$var$MAX_SAMPLES) (0, $329ek.warn)(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$169244187a3eb47b$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $169244187a3eb47b$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $169244187a3eb47b$var$LOD_MIN ? lodOut - _lodMax + $169244187a3eb47b$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $169244187a3eb47b$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $169244187a3eb47b$var$_flatCamera);
    }
}
function $169244187a3eb47b$var$_createPlanes(lodMax) {
    const sizeLods = [];
    const sigmas = [];
    const lodMeshes = [];
    let lod = lodMax;
    const totalLods = lodMax - $169244187a3eb47b$var$LOD_MIN + 1 + $169244187a3eb47b$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $169244187a3eb47b$var$LOD_MIN) sigma = $169244187a3eb47b$var$EXTRA_LOD_SIGMA[i - lodMax + $169244187a3eb47b$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new (0, $329ek.BufferGeometry)();
        planes.setAttribute('position', new (0, $329ek.BufferAttribute)(position, positionSize));
        planes.setAttribute('uv', new (0, $329ek.BufferAttribute)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $329ek.BufferAttribute)(faceIndex, faceIndexSize));
        lodMeshes.push(new (0, $329ek.Mesh)(planes, null));
        if (lod > $169244187a3eb47b$var$LOD_MIN) lod--;
    }
    return {
        lodMeshes: lodMeshes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $169244187a3eb47b$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new (0, $329ek.WebGLRenderTarget)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $329ek.CubeUVReflectionMapping);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $169244187a3eb47b$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $169244187a3eb47b$var$_getGGXShader(lodMax, width, height) {
    const shaderMaterial = new (0, $329ek.ShaderMaterial)({
        name: 'PMREMGGXConvolution',
        defines: {
            'GGX_SAMPLES': $169244187a3eb47b$var$GGX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'roughness': {
                value: 0.0
            },
            'mipInt': {
                value: 0
            }
        },
        vertexShader: $169244187a3eb47b$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision highp float;
			precision highp int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform float roughness;
			uniform float mipInt;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			#define PI 3.14159265359

			// Van der Corput radical inverse
			float radicalInverse_VdC(uint bits) {
				bits = (bits << 16u) | (bits >> 16u);
				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
				return float(bits) * 2.3283064365386963e-10; // / 0x100000000
			}

			// Hammersley sequence
			vec2 hammersley(uint i, uint N) {
				return vec2(float(i) / float(N), radicalInverse_VdC(i));
			}

			// GGX VNDF importance sampling (Eric Heitz 2018)
			// "Sampling the GGX Distribution of Visible Normals"
			// https://jcgt.org/published/0007/04/01/
			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {
				float alpha = roughness * roughness;

				// Section 3.2: Transform view direction to hemisphere configuration
				vec3 Vh = normalize(vec3(alpha * V.x, alpha * V.y, V.z));

				// Section 4.1: Orthonormal basis
				float lensq = Vh.x * Vh.x + Vh.y * Vh.y;
				vec3 T1 = lensq > 0.0 ? vec3(-Vh.y, Vh.x, 0.0) / sqrt(lensq) : vec3(1.0, 0.0, 0.0);
				vec3 T2 = cross(Vh, T1);

				// Section 4.2: Parameterization of projected area
				float r = sqrt(Xi.x);
				float phi = 2.0 * PI * Xi.y;
				float t1 = r * cos(phi);
				float t2 = r * sin(phi);
				float s = 0.5 * (1.0 + Vh.z);
				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;

				// Section 4.3: Reprojection onto hemisphere
				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * Vh;

				// Section 3.4: Transform back to ellipsoid configuration
				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));
			}

			void main() {
				vec3 N = normalize(vOutputDirection);
				vec3 V = N; // Assume view direction equals normal for pre-filtering

				vec3 prefilteredColor = vec3(0.0);
				float totalWeight = 0.0;

				// For very low roughness, just sample the environment directly
				if (roughness < 0.001) {
					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);
					return;
				}

				// Tangent space basis for VNDF sampling
				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);
				vec3 tangent = normalize(cross(up, N));
				vec3 bitangent = cross(N, tangent);

				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {
					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));

					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)
					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);

					// Transform H back to world space
					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);
					vec3 L = normalize(2.0 * dot(V, H) * H - V);

					float NdotL = max(dot(N, L), 0.0);

					if(NdotL > 0.0) {
						// Sample environment at fixed mip level
						// VNDF importance sampling handles the distribution filtering
						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);

						// Weight by NdotL for the split-sum approximation
						// VNDF PDF naturally accounts for the visible microfacet distribution
						prefilteredColor += sampleColor * NdotL;
						totalWeight += NdotL;
					}
				}

				if (totalWeight > 0.0) {
					prefilteredColor = prefilteredColor / totalWeight;
				}

				gl_FragColor = vec4(prefilteredColor, 1.0);
			}
		`,
        blending: (0, $329ek.NoBlending),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $169244187a3eb47b$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($169244187a3eb47b$var$MAX_SAMPLES);
    const poleAxis = new (0, $329ek.Vector3)(0, 1, 0);
    const shaderMaterial = new (0, $329ek.ShaderMaterial)({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $169244187a3eb47b$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $169244187a3eb47b$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: (0, $329ek.NoBlending),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $169244187a3eb47b$var$_getEquirectMaterial() {
    return new (0, $329ek.ShaderMaterial)({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $169244187a3eb47b$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: (0, $329ek.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function $169244187a3eb47b$var$_getCubemapMaterial() {
    return new (0, $329ek.ShaderMaterial)({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $169244187a3eb47b$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: (0, $329ek.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function $169244187a3eb47b$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $169244187a3eb47b$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === (0, $329ek.EquirectangularReflectionMapping) || mapping === (0, $329ek.EquirectangularRefractionMapping);
            const isCubeMap = mapping === (0, $329ek.CubeReflectionMapping) || mapping === (0, $329ek.CubeRefractionMapping);
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = cubeUVmaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $169244187a3eb47b$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $169244187a3eb47b$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $169244187a3eb47b$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        const extension = gl.getExtension(name);
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) (0, $329ek.warnOnce)('WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $169244187a3eb47b$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ((0, $329ek.arrayNeedsUint32)(indices) ? (0, $329ek.Uint32BufferAttribute) : (0, $329ek.Uint16BufferAttribute))(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $169244187a3eb47b$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $169244187a3eb47b$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                (0, $329ek.error)('WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $169244187a3eb47b$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new (0, $329ek.Vector4)();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new (0, $329ek.DataArrayTexture)(buffer, width, height, morphTargetsCount);
            texture.type = (0, $329ek.FloatType);
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new (0, $329ek.Vector2)(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $169244187a3eb47b$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
const $169244187a3eb47b$var$toneMappingMap = {
    [(0, $329ek.LinearToneMapping)]: 'LINEAR_TONE_MAPPING',
    [(0, $329ek.ReinhardToneMapping)]: 'REINHARD_TONE_MAPPING',
    [(0, $329ek.CineonToneMapping)]: 'CINEON_TONE_MAPPING',
    [(0, $329ek.ACESFilmicToneMapping)]: 'ACES_FILMIC_TONE_MAPPING',
    [(0, $329ek.AgXToneMapping)]: 'AGX_TONE_MAPPING',
    [(0, $329ek.NeutralToneMapping)]: 'NEUTRAL_TONE_MAPPING',
    [(0, $329ek.CustomToneMapping)]: 'CUSTOM_TONE_MAPPING'
};
function $169244187a3eb47b$var$WebGLOutput(type, width, height, depth, stencil) {
    // render targets for scene and post-processing
    const targetA = new (0, $329ek.WebGLRenderTarget)(width, height, {
        type: type,
        depthBuffer: depth,
        stencilBuffer: stencil
    });
    const targetB = new (0, $329ek.WebGLRenderTarget)(width, height, {
        type: (0, $329ek.HalfFloatType),
        depthBuffer: false,
        stencilBuffer: false
    });
    // create fullscreen triangle geometry
    const geometry = new (0, $329ek.BufferGeometry)();
    geometry.setAttribute('position', new (0, $329ek.Float32BufferAttribute)([
        -1,
        3,
        0,
        -1,
        -1,
        0,
        3,
        -1,
        0
    ], 3));
    geometry.setAttribute('uv', new (0, $329ek.Float32BufferAttribute)([
        0,
        2,
        0,
        0,
        2,
        0
    ], 2));
    // create output material with tone mapping support
    const material = new (0, $329ek.RawShaderMaterial)({
        uniforms: {
            tDiffuse: {
                value: null
            }
        },
        vertexShader: /* glsl */ `
			precision highp float;

			uniform mat4 modelViewMatrix;
			uniform mat4 projectionMatrix;

			attribute vec3 position;
			attribute vec2 uv;

			varying vec2 vUv;

			void main() {
				vUv = uv;
				gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
			}`,
        fragmentShader: /* glsl */ `
			precision highp float;

			uniform sampler2D tDiffuse;

			varying vec2 vUv;

			#include <tonemapping_pars_fragment>
			#include <colorspace_pars_fragment>

			void main() {
				gl_FragColor = texture2D( tDiffuse, vUv );

				#ifdef LINEAR_TONE_MAPPING
					gl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );
				#elif defined( REINHARD_TONE_MAPPING )
					gl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );
				#elif defined( CINEON_TONE_MAPPING )
					gl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );
				#elif defined( ACES_FILMIC_TONE_MAPPING )
					gl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );
				#elif defined( AGX_TONE_MAPPING )
					gl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );
				#elif defined( NEUTRAL_TONE_MAPPING )
					gl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );
				#elif defined( CUSTOM_TONE_MAPPING )
					gl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );
				#endif

				#ifdef SRGB_TRANSFER
					gl_FragColor = sRGBTransferOETF( gl_FragColor );
				#endif
			}`,
        depthTest: false,
        depthWrite: false
    });
    const mesh = new (0, $329ek.Mesh)(geometry, material);
    const camera = new (0, $329ek.OrthographicCamera)(-1, 1, 1, -1, 0, 1);
    let _outputColorSpace = null;
    let _outputToneMapping = null;
    let _isCompositing = false;
    let _savedToneMapping;
    let _savedRenderTarget = null;
    let _effects = [];
    let _hasRenderPass = false;
    this.setSize = function(width, height) {
        targetA.setSize(width, height);
        targetB.setSize(width, height);
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.setSize) effect.setSize(width, height);
        }
    };
    this.setEffects = function(effects) {
        _effects = effects;
        _hasRenderPass = _effects.length > 0 && _effects[0].isRenderPass === true;
        const width = targetA.width;
        const height = targetA.height;
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.setSize) effect.setSize(width, height);
        }
    };
    this.begin = function(renderer, renderTarget) {
        // Don't begin during compositing phase (post-processing effects call render())
        if (_isCompositing) return false;
        if (renderer.toneMapping === (0, $329ek.NoToneMapping) && _effects.length === 0) return false;
        _savedRenderTarget = renderTarget;
        // resize internal buffers to match render target (e.g. XR resolution)
        if (renderTarget !== null) {
            const width = renderTarget.width;
            const height = renderTarget.height;
            if (targetA.width !== width || targetA.height !== height) this.setSize(width, height);
        }
        // if first effect is a RenderPass, it will set its own render target
        if (_hasRenderPass === false) renderer.setRenderTarget(targetA);
        // disable tone mapping during render - it will be applied in end()
        _savedToneMapping = renderer.toneMapping;
        renderer.toneMapping = (0, $329ek.NoToneMapping);
        return true;
    };
    this.hasRenderPass = function() {
        return _hasRenderPass;
    };
    this.end = function(renderer, deltaTime) {
        // restore tone mapping
        renderer.toneMapping = _savedToneMapping;
        _isCompositing = true;
        // run post-processing effects
        let readBuffer = targetA;
        let writeBuffer = targetB;
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.enabled === false) continue;
            effect.render(renderer, writeBuffer, readBuffer, deltaTime);
            if (effect.needsSwap !== false) {
                const temp = readBuffer;
                readBuffer = writeBuffer;
                writeBuffer = temp;
            }
        }
        // update output material defines if settings changed
        if (_outputColorSpace !== renderer.outputColorSpace || _outputToneMapping !== renderer.toneMapping) {
            _outputColorSpace = renderer.outputColorSpace;
            _outputToneMapping = renderer.toneMapping;
            material.defines = {};
            if ((0, $329ek.ColorManagement).getTransfer(_outputColorSpace) === (0, $329ek.SRGBTransfer)) material.defines.SRGB_TRANSFER = '';
            const toneMapping = $169244187a3eb47b$var$toneMappingMap[_outputToneMapping];
            if (toneMapping) material.defines[toneMapping] = '';
            material.needsUpdate = true;
        }
        // final output to canvas (or XR render target)
        material.uniforms.tDiffuse.value = readBuffer.texture;
        renderer.setRenderTarget(_savedRenderTarget);
        renderer.render(mesh, camera);
        _savedRenderTarget = null;
        _isCompositing = false;
    };
    this.isCompositing = function() {
        return _isCompositing;
    };
    this.dispose = function() {
        targetA.dispose();
        targetB.dispose();
        geometry.dispose();
        material.dispose();
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $169244187a3eb47b$var$emptyTexture = /*@__PURE__*/ new (0, $329ek.Texture)();
const $169244187a3eb47b$var$emptyShadowTexture = /*@__PURE__*/ new (0, $329ek.DepthTexture)(1, 1);
const $169244187a3eb47b$var$emptyArrayTexture = /*@__PURE__*/ new (0, $329ek.DataArrayTexture)();
const $169244187a3eb47b$var$empty3dTexture = /*@__PURE__*/ new (0, $329ek.Data3DTexture)();
const $169244187a3eb47b$var$emptyCubeTexture = /*@__PURE__*/ new (0, $329ek.CubeTexture)();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $169244187a3eb47b$var$arrayCacheF32 = [];
const $169244187a3eb47b$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $169244187a3eb47b$var$mat4array = new Float32Array(16);
const $169244187a3eb47b$var$mat3array = new Float32Array(9);
const $169244187a3eb47b$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $169244187a3eb47b$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $169244187a3eb47b$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $169244187a3eb47b$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $169244187a3eb47b$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $169244187a3eb47b$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $169244187a3eb47b$var$allocTexUnits(textures, n) {
    let r = $169244187a3eb47b$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $169244187a3eb47b$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $169244187a3eb47b$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $169244187a3eb47b$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $169244187a3eb47b$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, elements)) return;
        $169244187a3eb47b$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $169244187a3eb47b$var$mat2array);
        $169244187a3eb47b$var$copyArray(cache, elements);
    }
}
function $169244187a3eb47b$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, elements)) return;
        $169244187a3eb47b$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $169244187a3eb47b$var$mat3array);
        $169244187a3eb47b$var$copyArray(cache, elements);
    }
}
function $169244187a3eb47b$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, elements)) return;
        $169244187a3eb47b$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $169244187a3eb47b$var$mat4array);
        $169244187a3eb47b$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $169244187a3eb47b$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $169244187a3eb47b$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $169244187a3eb47b$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $169244187a3eb47b$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $169244187a3eb47b$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $169244187a3eb47b$var$emptyShadowTexture.compareFunction = textures.isReversedDepthBuffer() ? (0, $329ek.GreaterEqualCompare) : (0, $329ek.LessEqualCompare);
        emptyTexture2D = $169244187a3eb47b$var$emptyShadowTexture;
    } else emptyTexture2D = $169244187a3eb47b$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $169244187a3eb47b$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $169244187a3eb47b$var$empty3dTexture, unit);
}
function $169244187a3eb47b$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $169244187a3eb47b$var$emptyCubeTexture, unit);
}
function $169244187a3eb47b$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $169244187a3eb47b$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $169244187a3eb47b$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $169244187a3eb47b$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $169244187a3eb47b$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $169244187a3eb47b$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $169244187a3eb47b$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $169244187a3eb47b$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $169244187a3eb47b$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $169244187a3eb47b$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $169244187a3eb47b$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $169244187a3eb47b$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $169244187a3eb47b$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $169244187a3eb47b$var$setValueV4i; // _VEC4
        case 0x1405:
            return $169244187a3eb47b$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $169244187a3eb47b$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $169244187a3eb47b$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $169244187a3eb47b$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $169244187a3eb47b$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $169244187a3eb47b$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $169244187a3eb47b$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $169244187a3eb47b$var$setValueT2DArray1;
    }
}
// Array of scalars
function $169244187a3eb47b$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $169244187a3eb47b$var$setValueV2fArray(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $169244187a3eb47b$var$setValueV3fArray(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $169244187a3eb47b$var$setValueV4fArray(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $169244187a3eb47b$var$setValueM2Array(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $169244187a3eb47b$var$setValueM3Array(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $169244187a3eb47b$var$setValueM4Array(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $169244187a3eb47b$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $169244187a3eb47b$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $169244187a3eb47b$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $169244187a3eb47b$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $169244187a3eb47b$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $169244187a3eb47b$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $169244187a3eb47b$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $169244187a3eb47b$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $169244187a3eb47b$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $169244187a3eb47b$var$allocTexUnits(textures, n);
    if (!$169244187a3eb47b$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $169244187a3eb47b$var$copyArray(cache, units);
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) emptyTexture2D = $169244187a3eb47b$var$emptyShadowTexture;
    else emptyTexture2D = $169244187a3eb47b$var$emptyTexture;
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || emptyTexture2D, units[i]);
}
function $169244187a3eb47b$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $169244187a3eb47b$var$allocTexUnits(textures, n);
    if (!$169244187a3eb47b$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $169244187a3eb47b$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $169244187a3eb47b$var$empty3dTexture, units[i]);
}
function $169244187a3eb47b$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $169244187a3eb47b$var$allocTexUnits(textures, n);
    if (!$169244187a3eb47b$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $169244187a3eb47b$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $169244187a3eb47b$var$emptyCubeTexture, units[i]);
}
function $169244187a3eb47b$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $169244187a3eb47b$var$allocTexUnits(textures, n);
    if (!$169244187a3eb47b$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $169244187a3eb47b$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $169244187a3eb47b$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $169244187a3eb47b$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $169244187a3eb47b$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $169244187a3eb47b$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $169244187a3eb47b$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $169244187a3eb47b$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $169244187a3eb47b$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $169244187a3eb47b$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $169244187a3eb47b$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $169244187a3eb47b$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $169244187a3eb47b$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $169244187a3eb47b$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $169244187a3eb47b$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $169244187a3eb47b$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $169244187a3eb47b$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $169244187a3eb47b$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $169244187a3eb47b$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $169244187a3eb47b$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $169244187a3eb47b$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $169244187a3eb47b$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $169244187a3eb47b$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $169244187a3eb47b$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $169244187a3eb47b$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $169244187a3eb47b$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $169244187a3eb47b$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $169244187a3eb47b$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $169244187a3eb47b$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $169244187a3eb47b$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $169244187a3eb47b$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $169244187a3eb47b$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $169244187a3eb47b$var$RePathPart.exec(path), matchEnd = $169244187a3eb47b$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $169244187a3eb47b$var$addUniform(container, subscript === undefined ? new $169244187a3eb47b$var$SingleUniform(id, activeInfo, addr) : new $169244187a3eb47b$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $169244187a3eb47b$var$StructuredUniform(id);
                $169244187a3eb47b$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $169244187a3eb47b$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $169244187a3eb47b$var$parseUniform(info, addr, this);
        }
        // Sort uniforms to prioritize shadow samplers first (for optimal texture unit allocation)
        const shadowSamplers = [];
        const otherUniforms = [];
        for (const u of this.seq)if (u.type === gl.SAMPLER_2D_SHADOW || u.type === gl.SAMPLER_CUBE_SHADOW || u.type === gl.SAMPLER_2D_ARRAY_SHADOW) shadowSamplers.push(u);
        else otherUniforms.push(u);
        if (shadowSamplers.length > 0) this.seq = shadowSamplers.concat(otherUniforms);
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $169244187a3eb47b$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $169244187a3eb47b$var$COMPLETION_STATUS_KHR = 0x91B1;
let $169244187a3eb47b$var$programIdCount = 0;
function $169244187a3eb47b$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
const $169244187a3eb47b$var$_m0 = /*@__PURE__*/ new (0, $329ek.Matrix3)();
function $169244187a3eb47b$var$getEncodingComponents(colorSpace) {
    (0, $329ek.ColorManagement)._getMatrix($169244187a3eb47b$var$_m0, (0, $329ek.ColorManagement).workingColorSpace, colorSpace);
    const encodingMatrix = `mat3( ${$169244187a3eb47b$var$_m0.elements.map((v)=>v.toFixed(4))} )`;
    switch((0, $329ek.ColorManagement).getTransfer(colorSpace)){
        case 0, $329ek.LinearTransfer:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case 0, $329ek.SRGBTransfer:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            (0, $329ek.warn)('WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function $169244187a3eb47b$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const shaderInfoLog = gl.getShaderInfoLog(shader) || '';
    const errors = shaderInfoLog.trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $169244187a3eb47b$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $169244187a3eb47b$var$getTexelEncodingFunction(functionName, colorSpace) {
    const components = $169244187a3eb47b$var$getEncodingComponents(colorSpace);
    return [
        `vec4 ${functionName}( vec4 value ) {`,
        `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
        '}'
    ].join('\n');
}
const $169244187a3eb47b$var$toneMappingFunctions = {
    [(0, $329ek.LinearToneMapping)]: 'Linear',
    [(0, $329ek.ReinhardToneMapping)]: 'Reinhard',
    [(0, $329ek.CineonToneMapping)]: 'Cineon',
    [(0, $329ek.ACESFilmicToneMapping)]: 'ACESFilmic',
    [(0, $329ek.AgXToneMapping)]: 'AgX',
    [(0, $329ek.NeutralToneMapping)]: 'Neutral',
    [(0, $329ek.CustomToneMapping)]: 'Custom'
};
function $169244187a3eb47b$var$getToneMappingFunction(functionName, toneMapping) {
    const toneMappingName = $169244187a3eb47b$var$toneMappingFunctions[toneMapping];
    if (toneMappingName === undefined) {
        (0, $329ek.warn)('WebGLProgram: Unsupported toneMapping:', toneMapping);
        return 'vec3 ' + functionName + '( vec3 color ) { return LinearToneMapping( color ); }';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
const $169244187a3eb47b$var$_v0 = /*@__PURE__*/ new (0, $329ek.Vector3)();
function $169244187a3eb47b$var$getLuminanceFunction() {
    (0, $329ek.ColorManagement).getLuminanceCoefficients($169244187a3eb47b$var$_v0);
    const r = $169244187a3eb47b$var$_v0.x.toFixed(4);
    const g = $169244187a3eb47b$var$_v0.y.toFixed(4);
    const b = $169244187a3eb47b$var$_v0.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $169244187a3eb47b$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($169244187a3eb47b$var$filterEmptyLine).join('\n');
}
function $169244187a3eb47b$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $169244187a3eb47b$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // log( 'WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $169244187a3eb47b$var$filterEmptyLine(string) {
    return string !== '';
}
function $169244187a3eb47b$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $169244187a3eb47b$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $169244187a3eb47b$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $169244187a3eb47b$var$resolveIncludes(string) {
    return string.replace($169244187a3eb47b$var$includePattern, $169244187a3eb47b$var$includeReplacer);
}
const $169244187a3eb47b$var$shaderChunkMap = new Map();
function $169244187a3eb47b$var$includeReplacer(match, include) {
    let string = $169244187a3eb47b$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $169244187a3eb47b$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $169244187a3eb47b$export$955f9f2e84c43c8b[newInclude];
            (0, $329ek.warn)('WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $169244187a3eb47b$var$resolveIncludes(string);
}
// Unroll Loops
const $169244187a3eb47b$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $169244187a3eb47b$var$unrollLoops(string) {
    return string.replace($169244187a3eb47b$var$unrollLoopPattern, $169244187a3eb47b$var$loopReplacer);
}
function $169244187a3eb47b$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $169244187a3eb47b$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
const $169244187a3eb47b$var$shadowMapTypeDefines = {
    [(0, $329ek.PCFShadowMap)]: 'SHADOWMAP_TYPE_PCF',
    [(0, $329ek.VSMShadowMap)]: 'SHADOWMAP_TYPE_VSM'
};
function $169244187a3eb47b$var$generateShadowMapTypeDefine(parameters) {
    return $169244187a3eb47b$var$shadowMapTypeDefines[parameters.shadowMapType] || 'SHADOWMAP_TYPE_BASIC';
}
const $169244187a3eb47b$var$envMapTypeDefines = {
    [(0, $329ek.CubeReflectionMapping)]: 'ENVMAP_TYPE_CUBE',
    [(0, $329ek.CubeRefractionMapping)]: 'ENVMAP_TYPE_CUBE',
    [(0, $329ek.CubeUVReflectionMapping)]: 'ENVMAP_TYPE_CUBE_UV'
};
function $169244187a3eb47b$var$generateEnvMapTypeDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_TYPE_CUBE';
    return $169244187a3eb47b$var$envMapTypeDefines[parameters.envMapMode] || 'ENVMAP_TYPE_CUBE';
}
const $169244187a3eb47b$var$envMapModeDefines = {
    [(0, $329ek.CubeRefractionMapping)]: 'ENVMAP_MODE_REFRACTION'
};
function $169244187a3eb47b$var$generateEnvMapModeDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_MODE_REFLECTION';
    return $169244187a3eb47b$var$envMapModeDefines[parameters.envMapMode] || 'ENVMAP_MODE_REFLECTION';
}
const $169244187a3eb47b$var$envMapBlendingDefines = {
    [(0, $329ek.MultiplyOperation)]: 'ENVMAP_BLENDING_MULTIPLY',
    [(0, $329ek.MixOperation)]: 'ENVMAP_BLENDING_MIX',
    [(0, $329ek.AddOperation)]: 'ENVMAP_BLENDING_ADD'
};
function $169244187a3eb47b$var$generateEnvMapBlendingDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_BLENDING_NONE';
    return $169244187a3eb47b$var$envMapBlendingDefines[parameters.combine] || 'ENVMAP_BLENDING_NONE';
}
function $169244187a3eb47b$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $169244187a3eb47b$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $169244187a3eb47b$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $169244187a3eb47b$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $169244187a3eb47b$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $169244187a3eb47b$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $169244187a3eb47b$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $169244187a3eb47b$var$generateVertexExtensions(parameters);
    const customDefines = $169244187a3eb47b$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($169244187a3eb47b$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($169244187a3eb47b$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $169244187a3eb47b$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGARITHMIC_DEPTH_BUFFER' : '',
            parameters.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($169244187a3eb47b$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $169244187a3eb47b$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGARITHMIC_DEPTH_BUFFER' : '',
            parameters.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== (0, $329ek.NoToneMapping) ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== (0, $329ek.NoToneMapping) ? $169244187a3eb47b$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== (0, $329ek.NoToneMapping) ? $169244187a3eb47b$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $169244187a3eb47b$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $169244187a3eb47b$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $169244187a3eb47b$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($169244187a3eb47b$var$filterEmptyLine).join('\n');
    }
    vertexShader = $169244187a3eb47b$var$resolveIncludes(vertexShader);
    vertexShader = $169244187a3eb47b$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $169244187a3eb47b$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $169244187a3eb47b$var$resolveIncludes(fragmentShader);
    fragmentShader = $169244187a3eb47b$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $169244187a3eb47b$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $169244187a3eb47b$var$unrollLoops(vertexShader);
    fragmentShader = $169244187a3eb47b$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === (0, $329ek.GLSL3) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === (0, $329ek.GLSL3) ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // log( '*VERTEX*', vertexGlsl );
    // log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $169244187a3eb47b$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $169244187a3eb47b$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programInfoLog = gl.getProgramInfoLog(program) || '';
            const vertexShaderInfoLog = gl.getShaderInfoLog(glVertexShader) || '';
            const fragmentShaderInfoLog = gl.getShaderInfoLog(glFragmentShader) || '';
            const programLog = programInfoLog.trim();
            const vertexLog = vertexShaderInfoLog.trim();
            const fragmentLog = fragmentShaderInfoLog.trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $169244187a3eb47b$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = $169244187a3eb47b$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    (0, $329ek.error)('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') (0, $329ek.warn)('WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $169244187a3eb47b$var$WebGLUniforms(gl, program);
        cachedAttributes = $169244187a3eb47b$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $169244187a3eb47b$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $169244187a3eb47b$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $169244187a3eb47b$var$_id = 0;
class $169244187a3eb47b$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $169244187a3eb47b$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $169244187a3eb47b$var$WebGLShaderStage {
    constructor(code){
        this.id = $169244187a3eb47b$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $169244187a3eb47b$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new (0, $329ek.Layers)();
    const _customShaders = new $169244187a3eb47b$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const programsMap = new Map();
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distance',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === (0, $329ek.CubeUVReflectionMapping) ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) (0, $329ek.warn)('WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $169244187a3eb47b$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = (0, $329ek.NoToneMapping);
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : (0, $329ek.LinearSRGBColorSpace),
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === (0, $329ek.ObjectSpaceNormalMap),
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === (0, $329ek.TangentSpaceNormalMap),
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === (0, $329ek.NormalBlending) && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true && material.wireframe === false,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reversedDepthBuffer: reversedDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && (0, $329ek.ColorManagement).getTransfer(material.map.colorSpace) === (0, $329ek.SRGBTransfer),
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && (0, $329ek.ColorManagement).getTransfer(material.emissiveMap.colorSpace) === (0, $329ek.SRGBTransfer),
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === (0, $329ek.DoubleSide),
            flipSided: material.side === (0, $329ek.BackSide),
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.instancing) _programLayers.enable(0);
        if (parameters.instancingColor) _programLayers.enable(1);
        if (parameters.instancingMorph) _programLayers.enable(2);
        if (parameters.matcap) _programLayers.enable(3);
        if (parameters.envMap) _programLayers.enable(4);
        if (parameters.normalMapObjectSpace) _programLayers.enable(5);
        if (parameters.normalMapTangentSpace) _programLayers.enable(6);
        if (parameters.clearcoat) _programLayers.enable(7);
        if (parameters.iridescence) _programLayers.enable(8);
        if (parameters.alphaTest) _programLayers.enable(9);
        if (parameters.vertexColors) _programLayers.enable(10);
        if (parameters.vertexAlphas) _programLayers.enable(11);
        if (parameters.vertexUv1s) _programLayers.enable(12);
        if (parameters.vertexUv2s) _programLayers.enable(13);
        if (parameters.vertexUv3s) _programLayers.enable(14);
        if (parameters.vertexTangents) _programLayers.enable(15);
        if (parameters.anisotropy) _programLayers.enable(16);
        if (parameters.alphaHash) _programLayers.enable(17);
        if (parameters.batching) _programLayers.enable(18);
        if (parameters.dispersion) _programLayers.enable(19);
        if (parameters.batchingColor) _programLayers.enable(20);
        if (parameters.gradientMap) _programLayers.enable(21);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reversedDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $169244187a3eb47b$export$bee4a7d47f8f5014[shaderID];
            uniforms = (0, $329ek.UniformsUtils).clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program = programsMap.get(cacheKey);
        if (program !== undefined) ++program.usedTimes;
        else {
            program = new $169244187a3eb47b$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
            programsMap.set(cacheKey, program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Remove from map
            programsMap.delete(program.cacheKey);
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $169244187a3eb47b$var$WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $169244187a3eb47b$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $169244187a3eb47b$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $169244187a3eb47b$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $169244187a3eb47b$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $169244187a3eb47b$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $169244187a3eb47b$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $169244187a3eb47b$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $169244187a3eb47b$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $169244187a3eb47b$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $169244187a3eb47b$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new (0, $329ek.Vector3)(),
                        color: new (0, $329ek.Color)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new (0, $329ek.Vector3)(),
                        direction: new (0, $329ek.Vector3)(),
                        color: new (0, $329ek.Color)(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new (0, $329ek.Vector3)(),
                        color: new (0, $329ek.Color)(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new (0, $329ek.Vector3)(),
                        skyColor: new (0, $329ek.Color)(),
                        groundColor: new (0, $329ek.Color)()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new (0, $329ek.Color)(),
                        position: new (0, $329ek.Vector3)(),
                        halfWidth: new (0, $329ek.Vector3)(),
                        halfHeight: new (0, $329ek.Vector3)()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $169244187a3eb47b$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $329ek.Vector2)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $329ek.Vector2)()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $329ek.Vector2)(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $169244187a3eb47b$var$nextVersion = 0;
function $169244187a3eb47b$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $169244187a3eb47b$var$WebGLLights(extensions) {
    const cache = new $169244187a3eb47b$var$UniformsCache();
    const shadowCache = $169244187a3eb47b$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new (0, $329ek.Vector3)());
    const vector3 = new (0, $329ek.Vector3)();
    const matrix4 = new (0, $329ek.Matrix4)();
    const matrix42 = new (0, $329ek.Matrix4)();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($169244187a3eb47b$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            let shadowMap = null;
            if (light.shadow && light.shadow.map) {
                if (light.shadow.map.texture.format === (0, $329ek.RGFormat)) // VSM uses color texture with blurred mean/std_dev
                shadowMap = light.shadow.map.texture;
                else // Other types use depth texture
                shadowMap = light.shadow.map.depthTexture || light.shadow.map.texture;
            }
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $169244187a3eb47b$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $169244187a3eb47b$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $169244187a3eb47b$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $169244187a3eb47b$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $169244187a3eb47b$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $169244187a3eb47b$var$WebGLRenderState(extensions) {
    const lights = new $169244187a3eb47b$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $169244187a3eb47b$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $169244187a3eb47b$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $169244187a3eb47b$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $169244187a3eb47b$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $169244187a3eb47b$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );\n\tgl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );\n}";
const $169244187a3eb47b$var$_cubeDirections = [
    /*@__PURE__*/ new (0, $329ek.Vector3)(1, 0, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(-1, 0, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, 1),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, -1)
];
const $169244187a3eb47b$var$_cubeUps = [
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, 1),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, 0, -1),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, $329ek.Vector3)(0, -1, 0)
];
const $169244187a3eb47b$var$_projScreenMatrix = /*@__PURE__*/ new (0, $329ek.Matrix4)();
const $169244187a3eb47b$var$_lightPositionWorld = /*@__PURE__*/ new (0, $329ek.Vector3)();
const $169244187a3eb47b$var$_lookTarget = /*@__PURE__*/ new (0, $329ek.Vector3)();
function $169244187a3eb47b$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new (0, $329ek.Frustum)();
    const _shadowMapSize = new (0, $329ek.Vector2)(), _viewportSize = new (0, $329ek.Vector2)(), _viewport = new (0, $329ek.Vector4)(), _depthMaterial = new (0, $329ek.MeshDepthMaterial)(), _distanceMaterial = new (0, $329ek.MeshDistanceMaterial)(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [(0, $329ek.FrontSide)]: (0, $329ek.BackSide),
        [(0, $329ek.BackSide)]: (0, $329ek.FrontSide),
        [(0, $329ek.DoubleSide)]: (0, $329ek.DoubleSide)
    };
    const shadowMaterialVertical = new (0, $329ek.ShaderMaterial)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, $329ek.Vector2)()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $169244187a3eb47b$var$vertex,
        fragmentShader: $169244187a3eb47b$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new (0, $329ek.BufferGeometry)();
    fullScreenTri.setAttribute('position', new (0, $329ek.BufferAttribute)(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new (0, $329ek.Mesh)(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = (0, $329ek.PCFShadowMap);
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        if (lights.type === (0, $329ek.PCFSoftShadowMap)) {
            (0, $329ek.warn)('WebGLShadowMap: PCFSoftShadowMap has been deprecated. Using PCFShadowMap instead.');
            lights.type = (0, $329ek.PCFShadowMap);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending((0, $329ek.NoBlending));
        if (_state.buffers.depth.getReversed() === true) _state.buffers.color.setClear(0, 0, 0, 0);
        else _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const typeChanged = _previousType !== this.type;
        // When shadow map type changes, materials need recompilation because sampler types change
        // (sampler2DShadow for PCF vs sampler2D for Basic)
        if (typeChanged) scene.traverse(function(object) {
            if (object.material) {
                if (Array.isArray(object.material)) object.material.forEach((mat)=>mat.needsUpdate = true);
                else object.material.needsUpdate = true;
            }
        });
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                (0, $329ek.warn)('WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || typeChanged === true) {
                if (shadow.map !== null) {
                    if (shadow.map.depthTexture !== null) {
                        shadow.map.depthTexture.dispose();
                        shadow.map.depthTexture = null;
                    }
                    shadow.map.dispose();
                }
                if (this.type === (0, $329ek.VSMShadowMap)) {
                    if (light.isPointLight) {
                        (0, $329ek.warn)('WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.');
                        continue;
                    }
                    shadow.map = new (0, $329ek.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y, {
                        format: (0, $329ek.RGFormat),
                        type: (0, $329ek.HalfFloatType),
                        minFilter: (0, $329ek.LinearFilter),
                        magFilter: (0, $329ek.LinearFilter),
                        generateMipmaps: false
                    });
                    shadow.map.texture.name = light.name + '.shadowMap';
                    // Native depth texture for VSM - depth is captured here, then blurred into the color texture
                    shadow.map.depthTexture = new (0, $329ek.DepthTexture)(_shadowMapSize.x, _shadowMapSize.y, (0, $329ek.FloatType));
                    shadow.map.depthTexture.name = light.name + '.shadowMapDepth';
                    shadow.map.depthTexture.format = (0, $329ek.DepthFormat);
                    shadow.map.depthTexture.compareFunction = null; // For regular sampling (not shadow comparison)
                    shadow.map.depthTexture.minFilter = (0, $329ek.NearestFilter);
                    shadow.map.depthTexture.magFilter = (0, $329ek.NearestFilter);
                } else {
                    if (light.isPointLight) {
                        shadow.map = new (0, $329ek.WebGLCubeRenderTarget)(_shadowMapSize.x);
                        shadow.map.depthTexture = new (0, $329ek.CubeDepthTexture)(_shadowMapSize.x, (0, $329ek.UnsignedIntType));
                    } else {
                        shadow.map = new (0, $329ek.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y);
                        shadow.map.depthTexture = new (0, $329ek.DepthTexture)(_shadowMapSize.x, _shadowMapSize.y, (0, $329ek.UnsignedIntType));
                    }
                    shadow.map.depthTexture.name = light.name + '.shadowMap';
                    shadow.map.depthTexture.format = (0, $329ek.DepthFormat);
                    const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
                    if (this.type === (0, $329ek.PCFShadowMap)) {
                        shadow.map.depthTexture.compareFunction = reversedDepthBuffer ? (0, $329ek.GreaterEqualCompare) : (0, $329ek.LessEqualCompare);
                        shadow.map.depthTexture.minFilter = (0, $329ek.LinearFilter);
                        shadow.map.depthTexture.magFilter = (0, $329ek.LinearFilter);
                    } else {
                        shadow.map.depthTexture.compareFunction = null;
                        shadow.map.depthTexture.minFilter = (0, $329ek.NearestFilter);
                        shadow.map.depthTexture.magFilter = (0, $329ek.NearestFilter);
                    }
                }
                shadow.camera.updateProjectionMatrix();
            }
            // For cube render targets (PointLights), render all 6 faces. Otherwise, render once.
            const faceCount = shadow.map.isWebGLCubeRenderTarget ? 6 : 1;
            for(let face = 0; face < faceCount; face++){
                // For cube render targets, render to each face separately
                if (shadow.map.isWebGLCubeRenderTarget) {
                    renderer.setRenderTarget(shadow.map, face);
                    renderer.clear();
                } else {
                    // For 2D render targets, use viewports
                    if (face === 0) {
                        renderer.setRenderTarget(shadow.map);
                        renderer.clear();
                    }
                    const viewport = shadow.getViewport(face);
                    _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                    _state.viewport(_viewport);
                }
                if (light.isPointLight) {
                    const camera = shadow.camera;
                    const shadowMatrix = shadow.matrix;
                    const far = light.distance || camera.far;
                    if (far !== camera.far) {
                        camera.far = far;
                        camera.updateProjectionMatrix();
                    }
                    $169244187a3eb47b$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
                    camera.position.copy($169244187a3eb47b$var$_lightPositionWorld);
                    $169244187a3eb47b$var$_lookTarget.copy(camera.position);
                    $169244187a3eb47b$var$_lookTarget.add($169244187a3eb47b$var$_cubeDirections[face]);
                    camera.up.copy($169244187a3eb47b$var$_cubeUps[face]);
                    camera.lookAt($169244187a3eb47b$var$_lookTarget);
                    camera.updateMatrixWorld();
                    shadowMatrix.makeTranslation(-$169244187a3eb47b$var$_lightPositionWorld.x, -$169244187a3eb47b$var$_lightPositionWorld.y, -$169244187a3eb47b$var$_lightPositionWorld.z);
                    $169244187a3eb47b$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                    shadow._frustum.setFromProjectionMatrix($169244187a3eb47b$var$_projScreenMatrix, camera.coordinateSystem, camera.reversedDepth);
                } else shadow.updateMatrices(light);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === (0, $329ek.VSMShadowMap)) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new (0, $329ek.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y, {
            format: (0, $329ek.RGFormat),
            type: (0, $329ek.HalfFloatType)
        });
        // vertical pass - read from native depth texture
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.depthTexture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0 || material.alphaToCoverage === true) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === (0, $329ek.VSMShadowMap)) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaToCoverage === true ? 0.5 : material.alphaTest; // approximate alphaToCoverage by using a fixed alphaTest value
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === (0, $329ek.VSMShadowMap)) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
const $169244187a3eb47b$var$reversedFuncs = {
    [(0, $329ek.NeverDepth)]: (0, $329ek.AlwaysDepth),
    [(0, $329ek.LessDepth)]: (0, $329ek.GreaterDepth),
    [(0, $329ek.EqualDepth)]: (0, $329ek.NotEqualDepth),
    [(0, $329ek.LessEqualDepth)]: (0, $329ek.GreaterEqualDepth),
    [(0, $329ek.AlwaysDepth)]: (0, $329ek.NeverDepth),
    [(0, $329ek.GreaterDepth)]: (0, $329ek.LessDepth),
    [(0, $329ek.NotEqualDepth)]: (0, $329ek.EqualDepth),
    [(0, $329ek.GreaterEqualDepth)]: (0, $329ek.LessEqualDepth)
};
function $169244187a3eb47b$var$WebGLState(gl, extensions) {
    function ColorBuffer() {
        let locked = false;
        const color = new (0, $329ek.Vector4)();
        let currentColorMask = null;
        const currentColorClear = new (0, $329ek.Vector4)(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentReversed = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setReversed: function(reversed) {
                if (currentReversed !== reversed) {
                    const ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    currentReversed = reversed;
                    const oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
            },
            getReversed: function() {
                return currentReversed;
            },
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentReversed) depthFunc = $169244187a3eb47b$var$reversedFuncs[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case 0, $329ek.NeverDepth:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case 0, $329ek.AlwaysDepth:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case 0, $329ek.LessDepth:
                            gl.depthFunc(gl.LESS);
                            break;
                        case 0, $329ek.LessEqualDepth:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case 0, $329ek.EqualDepth:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case 0, $329ek.GreaterEqualDepth:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case 0, $329ek.GreaterDepth:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case 0, $329ek.NotEqualDepth:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    if (currentReversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                currentReversed = false;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new (0, $329ek.Color)(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new (0, $329ek.Vector4)().fromArray(scissorParam);
    const currentViewport = new (0, $329ek.Vector4)().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc((0, $329ek.LessEqualDepth));
    setFlipSided(false);
    setCullFace((0, $329ek.CullFaceBack));
    enable(gl.CULL_FACE);
    setBlending((0, $329ek.NoBlending));
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [(0, $329ek.AddEquation)]: gl.FUNC_ADD,
        [(0, $329ek.SubtractEquation)]: gl.FUNC_SUBTRACT,
        [(0, $329ek.ReverseSubtractEquation)]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[0, $329ek.MinEquation] = gl.MIN;
    equationToGL[0, $329ek.MaxEquation] = gl.MAX;
    const factorToGL = {
        [(0, $329ek.ZeroFactor)]: gl.ZERO,
        [(0, $329ek.OneFactor)]: gl.ONE,
        [(0, $329ek.SrcColorFactor)]: gl.SRC_COLOR,
        [(0, $329ek.SrcAlphaFactor)]: gl.SRC_ALPHA,
        [(0, $329ek.SrcAlphaSaturateFactor)]: gl.SRC_ALPHA_SATURATE,
        [(0, $329ek.DstColorFactor)]: gl.DST_COLOR,
        [(0, $329ek.DstAlphaFactor)]: gl.DST_ALPHA,
        [(0, $329ek.OneMinusSrcColorFactor)]: gl.ONE_MINUS_SRC_COLOR,
        [(0, $329ek.OneMinusSrcAlphaFactor)]: gl.ONE_MINUS_SRC_ALPHA,
        [(0, $329ek.OneMinusDstColorFactor)]: gl.ONE_MINUS_DST_COLOR,
        [(0, $329ek.OneMinusDstAlphaFactor)]: gl.ONE_MINUS_DST_ALPHA,
        [(0, $329ek.ConstantColorFactor)]: gl.CONSTANT_COLOR,
        [(0, $329ek.OneMinusConstantColorFactor)]: gl.ONE_MINUS_CONSTANT_COLOR,
        [(0, $329ek.ConstantAlphaFactor)]: gl.CONSTANT_ALPHA,
        [(0, $329ek.OneMinusConstantAlphaFactor)]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === (0, $329ek.NoBlending)) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== (0, $329ek.CustomBlending)) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== (0, $329ek.AddEquation) || currentBlendEquationAlpha !== (0, $329ek.AddEquation)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = (0, $329ek.AddEquation);
                    currentBlendEquationAlpha = (0, $329ek.AddEquation);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $329ek.NormalBlending:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $329ek.AdditiveBlending:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $329ek.SubtractiveBlending:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $329ek.MultiplyBlending:
                        gl.blendFuncSeparate(gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                        break;
                    default:
                        (0, $329ek.error)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $329ek.NormalBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $329ek.AdditiveBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
                        break;
                    case 0, $329ek.SubtractiveBlending:
                        (0, $329ek.error)('WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true');
                        break;
                    case 0, $329ek.MultiplyBlending:
                        (0, $329ek.error)('WebGLState: MultiplyBlending requires material.premultipliedAlpha = true');
                        break;
                    default:
                        (0, $329ek.error)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === (0, $329ek.DoubleSide) ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === (0, $329ek.BackSide);
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === (0, $329ek.NormalBlending) && material.transparent === false ? setBlending((0, $329ek.NoBlending)) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== (0, $329ek.CullFaceNone)) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === (0, $329ek.CullFaceBack)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $329ek.CullFaceFront)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D(...arguments);
        } catch (e) {
            (0, $329ek.error)('WebGLState:', e);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D(...arguments);
        } catch (e) {
            (0, $329ek.error)('WebGLState:', e);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D(...arguments);
        } catch (e) {
            (0, $329ek.error)('WebGLState:', e);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D(...arguments);
        } catch (e) {
            (0, $329ek.error)('WebGLState:', e);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D(...arguments);
        } catch (e) {
            (0, $329ek.error)('WebGLState:', e);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D(...arguments);
        } catch (e) {
            (0, $329ek.error)('WebGLState:', e);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D(...arguments);
        } catch (e) {
            (0, $329ek.error)('WebGLState:', e);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D(...arguments);
        } catch (e) {
            (0, $329ek.error)('WebGLState:', e);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D(...arguments);
        } catch (e) {
            (0, $329ek.error)('WebGLState:', e);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D(...arguments);
        } catch (e) {
            (0, $329ek.error)('WebGLState:', e);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new (0, $329ek.Color)(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $169244187a3eb47b$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new (0, $329ek.Vector2)();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? new OffscreenCanvas(width, height) : (0, $329ek.createElementNS)('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                (0, $329ek.warn)('WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) (0, $329ek.warn)('WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            (0, $329ek.warn)('WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
            if (glType === _gl.UNSIGNED_INT_10F_11F_11F_REV) internalFormat = _gl.R11F_G11F_B10F;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? (0, $329ek.LinearTransfer) : (0, $329ek.ColorManagement).getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $329ek.SRGBTransfer) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === (0, $329ek.UnsignedIntType) || depthType === (0, $329ek.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === (0, $329ek.FloatType)) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === (0, $329ek.UnsignedShortType)) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                (0, $329ek.warn)('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === (0, $329ek.UnsignedIntType) || depthType === (0, $329ek.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === (0, $329ek.FloatType)) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === (0, $329ek.UnsignedShortType)) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== (0, $329ek.NearestFilter) && texture.minFilter !== (0, $329ek.LinearFilter)) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) (0, $329ek.warn)('WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.isExternalTexture !== true && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) (0, $329ek.warn)('WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) (0, $329ek.warn)('WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        } else if (texture.isExternalTexture) textureProperties.__webglTexture = texture.sourceTexture ? texture.sourceTexture : null;
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        } else if (texture.isExternalTexture) textureProperties.__webglTexture = texture.sourceTexture ? texture.sourceTexture : null;
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isCubeDepthTexture !== true && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [(0, $329ek.RepeatWrapping)]: _gl.REPEAT,
        [(0, $329ek.ClampToEdgeWrapping)]: _gl.CLAMP_TO_EDGE,
        [(0, $329ek.MirroredRepeatWrapping)]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [(0, $329ek.NearestFilter)]: _gl.NEAREST,
        [(0, $329ek.NearestMipmapNearestFilter)]: _gl.NEAREST_MIPMAP_NEAREST,
        [(0, $329ek.NearestMipmapLinearFilter)]: _gl.NEAREST_MIPMAP_LINEAR,
        [(0, $329ek.LinearFilter)]: _gl.LINEAR,
        [(0, $329ek.LinearMipmapNearestFilter)]: _gl.LINEAR_MIPMAP_NEAREST,
        [(0, $329ek.LinearMipmapLinearFilter)]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [(0, $329ek.NeverCompare)]: _gl.NEVER,
        [(0, $329ek.AlwaysCompare)]: _gl.ALWAYS,
        [(0, $329ek.LessCompare)]: _gl.LESS,
        [(0, $329ek.LessEqualCompare)]: _gl.LEQUAL,
        [(0, $329ek.EqualCompare)]: _gl.EQUAL,
        [(0, $329ek.GreaterEqualCompare)]: _gl.GEQUAL,
        [(0, $329ek.GreaterCompare)]: _gl.GREATER,
        [(0, $329ek.NotEqualCompare)]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === (0, $329ek.FloatType) && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === (0, $329ek.LinearFilter) || texture.magFilter === (0, $329ek.LinearMipmapNearestFilter) || texture.magFilter === (0, $329ek.NearestMipmapLinearFilter) || texture.magFilter === (0, $329ek.LinearMipmapLinearFilter) || texture.minFilter === (0, $329ek.LinearFilter) || texture.minFilter === (0, $329ek.LinearMipmapNearestFilter) || texture.minFilter === (0, $329ek.NearestMipmapLinearFilter) || texture.minFilter === (0, $329ek.LinearMipmapLinearFilter))) (0, $329ek.warn)('WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $329ek.NearestFilter)) return;
            if (texture.minFilter !== (0, $329ek.NearestMipmapLinearFilter) && texture.minFilter !== (0, $329ek.LinearMipmapLinearFilter)) return;
            if (texture.type === (0, $329ek.FloatType) && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function getRow(index, rowLength, componentStride) {
        return Math.floor(Math.floor(index / componentStride) / rowLength);
    }
    function updateTexture(texture, image, glFormat, glType) {
        const componentStride = 4; // only RGBA supported
        const updateRanges = texture.updateRanges;
        if (updateRanges.length === 0) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.texSubImage2D`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // Only merge if in the same row and overlapping/adjacent
                const previousEnd = previousRange.start + previousRange.count;
                const currentRow = getRow(range.start, image.width, componentStride);
                const previousRow = getRow(previousRange.start, image.width, componentStride);
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousEnd + 1 && currentRow === previousRow && getRow(range.start + range.count - 1, image.width, componentStride) === currentRow // ensure range doesn't spill
                ) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                const pixelStart = Math.floor(range.start / componentStride);
                const pixelCount = Math.ceil(range.count / componentStride);
                const x = pixelStart % image.width;
                const y = Math.floor(pixelStart / image.width);
                // Assumes update ranges refer to contiguous memory
                const width = pixelCount;
                const height = 1;
                _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, x);
                _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, y);
                state.texSubImage2D(_gl.TEXTURE_2D, 0, x, y, width, height, glFormat, glType, image.data);
            }
            texture.clearUpdateRanges();
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $329ek.ColorManagement).getPrimaries((0, $329ek.ColorManagement).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $329ek.NoColorSpace) ? null : (0, $329ek.ColorManagement).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $329ek.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === (0, $329ek.DepthStencilFormat), texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) updateTexture(texture, image, glFormat, glType);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $329ek.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = (0, $329ek.getByteLength)(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else (0, $329ek.warn)('WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $329ek.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else (0, $329ek.warn)('WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = (0, $329ek.getByteLength)(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $329ek.ColorManagement).getPrimaries((0, $329ek.ColorManagement).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $329ek.NoColorSpace) ? null : (0, $329ek.ColorManagement).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $329ek.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== (0, $329ek.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else (0, $329ek.warn)('WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, useMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
            else if (useMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget, cubeFace) {
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        const textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        if (isCube) {
            // For cube depth textures, initialize and bind without uploading image data
            if (textureProperties.__webglInit === undefined) {
                textureProperties.__webglInit = true;
                renderTarget.depthTexture.addEventListener('dispose', onTextureDispose);
            }
            // Only create and allocate storage once
            if (textureProperties.__webglTexture === undefined) {
                textureProperties.__webglTexture = _gl.createTexture();
                state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_CUBE_MAP, renderTarget.depthTexture);
                // Allocate storage for all 6 faces with correct depth texture format
                const glFormat = utils.convert(renderTarget.depthTexture.format);
                const glType = utils.convert(renderTarget.depthTexture.type);
                // Use proper internal format for depth textures
                let glInternalFormat;
                if (renderTarget.depthTexture.format === (0, $329ek.DepthFormat)) glInternalFormat = _gl.DEPTH_COMPONENT24;
                else if (renderTarget.depthTexture.format === (0, $329ek.DepthStencilFormat)) glInternalFormat = _gl.DEPTH24_STENCIL8;
                for(let i = 0; i < 6; i++)_gl.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
            }
        } else setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = textureProperties.__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        const glTextureType = isCube ? _gl.TEXTURE_CUBE_MAP_POSITIVE_X + cubeFace : _gl.TEXTURE_2D;
        const glAttachmentType = renderTarget.depthTexture.format === (0, $329ek.DepthStencilFormat) ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
        if (renderTarget.depthTexture.format === (0, $329ek.DepthFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === (0, $329ek.DepthStencilFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) // For cube render targets with depth texture, setup each face
            for(let i = 0; i < 6; i++)setupDepthTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, i);
            else {
                const mipmaps = renderTarget.texture.mipmaps;
                if (mipmaps && mipmaps.length > 0) setupDepthTexture(renderTargetProperties.__webglFramebuffer[0], renderTarget, 0);
                else setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget, 0);
            }
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            const mipmaps = renderTarget.texture.mipmaps;
            if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
            else state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                let glTextureType = _gl.TEXTURE_2D;
                if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                state.bindTexture(glTextureType, attachmentProperties.__webglTexture);
                setTextureParameters(glTextureType, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, glTextureType, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(glTextureType);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const targetType = getTargetType(renderTarget);
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                const mipmaps = renderTarget.texture.mipmaps;
                if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
                else state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== (0, $329ek.LinearSRGBColorSpace) && colorSpace !== (0, $329ek.NoColorSpace)) {
            // sRGB
            if ((0, $329ek.ColorManagement).getTransfer(colorSpace) === (0, $329ek.SRGBTransfer)) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== (0, $329ek.RGBAFormat) || type !== (0, $329ek.UnsignedByteType)) (0, $329ek.warn)('WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else (0, $329ek.error)('WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
    this.isReversedDepthBuffer = function() {
        return state.buffers.depth.getReversed();
    };
}
function $169244187a3eb47b$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace = (0, $329ek.NoColorSpace)) {
        let extension;
        const transfer = (0, $329ek.ColorManagement).getTransfer(colorSpace);
        if (p === (0, $329ek.UnsignedByteType)) return gl.UNSIGNED_BYTE;
        if (p === (0, $329ek.UnsignedShort4444Type)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $329ek.UnsignedShort5551Type)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $329ek.UnsignedInt5999Type)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $329ek.UnsignedInt101111Type)) return gl.UNSIGNED_INT_10F_11F_11F_REV;
        if (p === (0, $329ek.ByteType)) return gl.BYTE;
        if (p === (0, $329ek.ShortType)) return gl.SHORT;
        if (p === (0, $329ek.UnsignedShortType)) return gl.UNSIGNED_SHORT;
        if (p === (0, $329ek.IntType)) return gl.INT;
        if (p === (0, $329ek.UnsignedIntType)) return gl.UNSIGNED_INT;
        if (p === (0, $329ek.FloatType)) return gl.FLOAT;
        if (p === (0, $329ek.HalfFloatType)) return gl.HALF_FLOAT;
        if (p === (0, $329ek.AlphaFormat)) return gl.ALPHA;
        if (p === (0, $329ek.RGBFormat)) return gl.RGB;
        if (p === (0, $329ek.RGBAFormat)) return gl.RGBA;
        if (p === (0, $329ek.DepthFormat)) return gl.DEPTH_COMPONENT;
        if (p === (0, $329ek.DepthStencilFormat)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $329ek.RedFormat)) return gl.RED;
        if (p === (0, $329ek.RedIntegerFormat)) return gl.RED_INTEGER;
        if (p === (0, $329ek.RGFormat)) return gl.RG;
        if (p === (0, $329ek.RGIntegerFormat)) return gl.RG_INTEGER;
        if (p === (0, $329ek.RGBAIntegerFormat)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $329ek.RGB_S3TC_DXT1_Format) || p === (0, $329ek.RGBA_S3TC_DXT1_Format) || p === (0, $329ek.RGBA_S3TC_DXT3_Format) || p === (0, $329ek.RGBA_S3TC_DXT5_Format)) {
            if (transfer === (0, $329ek.SRGBTransfer)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $329ek.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $329ek.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $329ek.RGB_PVRTC_4BPPV1_Format) || p === (0, $329ek.RGB_PVRTC_2BPPV1_Format) || p === (0, $329ek.RGBA_PVRTC_4BPPV1_Format) || p === (0, $329ek.RGBA_PVRTC_2BPPV1_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $329ek.RGB_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $329ek.RGB_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $329ek.RGBA_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $329ek.RGBA_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $329ek.RGB_ETC1_Format) || p === (0, $329ek.RGB_ETC2_Format) || p === (0, $329ek.RGBA_ETC2_EAC_Format) || p === (0, $329ek.R11_EAC_Format) || p === (0, $329ek.SIGNED_R11_EAC_Format) || p === (0, $329ek.RG11_EAC_Format) || p === (0, $329ek.SIGNED_RG11_EAC_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $329ek.RGB_ETC1_Format) || p === (0, $329ek.RGB_ETC2_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $329ek.RGBA_ETC2_EAC_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
                if (p === (0, $329ek.R11_EAC_Format)) return extension.COMPRESSED_R11_EAC;
                if (p === (0, $329ek.SIGNED_R11_EAC_Format)) return extension.COMPRESSED_SIGNED_R11_EAC;
                if (p === (0, $329ek.RG11_EAC_Format)) return extension.COMPRESSED_RG11_EAC;
                if (p === (0, $329ek.SIGNED_RG11_EAC_Format)) return extension.COMPRESSED_SIGNED_RG11_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $329ek.RGBA_ASTC_4x4_Format) || p === (0, $329ek.RGBA_ASTC_5x4_Format) || p === (0, $329ek.RGBA_ASTC_5x5_Format) || p === (0, $329ek.RGBA_ASTC_6x5_Format) || p === (0, $329ek.RGBA_ASTC_6x6_Format) || p === (0, $329ek.RGBA_ASTC_8x5_Format) || p === (0, $329ek.RGBA_ASTC_8x6_Format) || p === (0, $329ek.RGBA_ASTC_8x8_Format) || p === (0, $329ek.RGBA_ASTC_10x5_Format) || p === (0, $329ek.RGBA_ASTC_10x6_Format) || p === (0, $329ek.RGBA_ASTC_10x8_Format) || p === (0, $329ek.RGBA_ASTC_10x10_Format) || p === (0, $329ek.RGBA_ASTC_12x10_Format) || p === (0, $329ek.RGBA_ASTC_12x12_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $329ek.RGBA_ASTC_4x4_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $329ek.RGBA_ASTC_5x4_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $329ek.RGBA_ASTC_5x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_6x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_6x6_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $329ek.RGBA_ASTC_8x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_8x6_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $329ek.RGBA_ASTC_8x8_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x6_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x8_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x10_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $329ek.RGBA_ASTC_12x10_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $329ek.RGBA_ASTC_12x12_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $329ek.RGBA_BPTC_Format) || p === (0, $329ek.RGB_BPTC_SIGNED_Format) || p === (0, $329ek.RGB_BPTC_UNSIGNED_Format)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $329ek.RGBA_BPTC_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === (0, $329ek.RGB_BPTC_SIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === (0, $329ek.RGB_BPTC_UNSIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $329ek.RED_RGTC1_Format) || p === (0, $329ek.SIGNED_RED_RGTC1_Format) || p === (0, $329ek.RED_GREEN_RGTC2_Format) || p === (0, $329ek.SIGNED_RED_GREEN_RGTC2_Format)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $329ek.RED_RGTC1_Format)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $329ek.SIGNED_RED_RGTC1_Format)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $329ek.RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $329ek.SIGNED_RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $329ek.UnsignedInt248Type)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
const $169244187a3eb47b$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $169244187a3eb47b$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
/**
 * A XR module that manages the access to the Depth Sensing API.
 */ class $169244187a3eb47b$var$WebXRDepthSensing {
    /**
	 * Constructs a new depth sensing module.
	 */ constructor(){
        /**
		 * An opaque texture representing the depth of the user's environment.
		 *
		 * @type {?ExternalTexture}
		 */ this.texture = null;
        /**
		 * A plane mesh for visualizing the depth texture.
		 *
		 * @type {?Mesh}
		 */ this.mesh = null;
        /**
		 * The depth near value.
		 *
		 * @type {number}
		 */ this.depthNear = 0;
        /**
		 * The depth near far.
		 *
		 * @type {number}
		 */ this.depthFar = 0;
    }
    /**
	 * Inits the depth sensing module
	 *
	 * @param {XRWebGLDepthInformation} depthData - The XR depth data.
	 * @param {XRRenderState} renderState - The XR render state.
	 */ init(depthData, renderState) {
        if (this.texture === null) {
            const texture = new (0, $329ek.ExternalTexture)(depthData.texture);
            if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    /**
	 * Returns a plane mesh that visualizes the depth texture.
	 *
	 * @param {ArrayCamera} cameraXR - The XR camera.
	 * @return {?Mesh} The plane mesh.
	 */ getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new (0, $329ek.ShaderMaterial)({
                    vertexShader: $169244187a3eb47b$var$_occlusion_vertex,
                    fragmentShader: $169244187a3eb47b$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new (0, $329ek.Mesh)(new (0, $329ek.PlaneGeometry)(20, 20), material);
            }
        }
        return this.mesh;
    }
    /**
	 * Resets the module
	 */ reset() {
        this.texture = null;
        this.mesh = null;
    }
    /**
	 * Returns a texture representing the depth of the user's environment.
	 *
	 * @return {?ExternalTexture} The depth texture.
	 */ getDepthTexture() {
        return this.texture;
    }
}
/**
 * This class represents an abstraction of the WebXR Device API and is
 * internally used by {@link WebGLRenderer}. `WebXRManager` also provides a public
 * interface that allows users to enable/disable XR and perform XR related
 * tasks like for instance retrieving controllers.
 *
 * @augments EventDispatcher
 * @hideconstructor
 */ class $169244187a3eb47b$var$WebXRManager extends (0, $329ek.EventDispatcher) {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGL2RenderingContext} gl - The rendering context.
	 */ constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const supportsGlBinding = typeof XRWebGLBinding !== 'undefined';
        const depthSensing = new $169244187a3eb47b$var$WebXRDepthSensing();
        const cameraAccessTextures = {};
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new (0, $329ek.Vector2)();
        let currentPixelRatio = null;
        //
        const cameraL = new (0, $329ek.PerspectiveCamera)();
        cameraL.viewport = new (0, $329ek.Vector4)();
        const cameraR = new (0, $329ek.PerspectiveCamera)();
        cameraR.viewport = new (0, $329ek.Vector4)();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new (0, $329ek.ArrayCamera)();
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        /**
		 * Whether the manager's XR camera should be automatically updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.cameraAutoUpdate = true;
        /**
		 * This flag notifies the renderer to be ready for XR rendering. Set it to `true`
		 * if you are going to use XR in your app.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.enabled = false;
        /**
		 * Whether XR presentation is active or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPresenting = false;
        /**
		 * Returns a group representing the `target ray` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `target ray` space.
		 */ this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $329ek.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        /**
		 * Returns a group representing the `grip` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * Note: If you want to show something in the user's hand AND offer a
		 * pointing ray at the same time, you'll want to attached the handheld object
		 * to the group returned by `getControllerGrip()` and the ray to the
		 * group returned by `getController()`. The idea is to have two
		 * different groups in two different coordinate spaces for the same WebXR
		 * controller.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `grip` space.
		 */ this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $329ek.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        /**
		 * Returns a group representing the `hand` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `hand` space.
		 */ this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $329ek.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            for(const key in cameraAccessTextures)delete cameraAccessTextures[key];
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        /**
		 * Sets the framebuffer scale factor.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {number} value - The framebuffer scale factor.
		 */ this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) (0, $329ek.warn)('WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        /**
		 * Sets the reference space type. Can be used to configure a spatial relationship with the user's physical
		 * environment. Depending on how the user moves in 3D space, setting an appropriate reference space can
		 * improve tracking. Default is `local-floor`. Valid values can be found here
		 * https://developer.mozilla.org/en-US/docs/Web/API/XRReferenceSpace#reference_space_types.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {string} value - The reference space type.
		 */ this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) (0, $329ek.warn)('WebXRManager: Cannot change reference space type while presenting.');
        };
        /**
		 * Returns the XR reference space.
		 *
		 * @return {XRReferenceSpace} The XR reference space.
		 */ this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        /**
		 * Sets a custom XR reference space.
		 *
		 * @param {XRReferenceSpace} space - The XR reference space.
		 */ this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        /**
		 * Returns the current base layer.
		 *
		 * This is an `XRProjectionLayer` when the targeted XR device supports the
		 * WebXR Layers API, or an `XRWebGLLayer` otherwise.
		 *
		 * @return {?(XRWebGLLayer|XRProjectionLayer)} The XR base layer.
		 */ this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        /**
		 * Returns the current XR binding.
		 *
		 * Creates a new binding if needed and the browser is
		 * capable of doing so.
		 *
		 * @return {?XRWebGLBinding} The XR binding. Returns `null` if one cannot be created.
		 */ this.getBinding = function() {
            if (glBinding === null && supportsGlBinding) glBinding = new XRWebGLBinding(session, gl);
            return glBinding;
        };
        /**
		 * Returns the current XR frame.
		 *
		 * @return {?XRFrame} The XR frame. Returns `null` when used outside a XR session.
		 */ this.getFrame = function() {
            return xrFrame;
        };
        /**
		 * Returns the current XR session.
		 *
		 * @return {?XRSession} The XR session. Returns `null` when used outside a XR session.
		 */ this.getSession = function() {
            return session;
        };
        /**
		 * After a XR session has been requested usually with one of the `*Button` modules, it
		 * is injected into the renderer with this method. This method triggers the start of
		 * the actual XR rendering.
		 *
		 * @async
		 * @param {XRSession} value - The XR session to set.
		 * @return {Promise} A Promise that resolves when the session has been set.
		 */ this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                // Check that the browser implements the necessary APIs to use an
                // XRProjectionLayer rather than an XRWebGLLayer
                const supportsLayers = supportsGlBinding && 'createProjectionLayer' in XRWebGLBinding.prototype;
                if (!supportsLayers) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new (0, $329ek.WebGLRenderTarget)(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: (0, $329ek.RGBAFormat),
                        type: (0, $329ek.UnsignedByteType),
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil,
                        resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? (0, $329ek.DepthStencilFormat) : (0, $329ek.DepthFormat);
                        depthType = attributes.stencil ? (0, $329ek.UnsignedInt248Type) : (0, $329ek.UnsignedIntType);
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = this.getBinding();
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new (0, $329ek.WebGLRenderTarget)(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: (0, $329ek.RGBAFormat),
                        type: (0, $329ek.UnsignedByteType),
                        depthTexture: new (0, $329ek.DepthTexture)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        /**
		 * Returns the environment blend mode from the current XR session.
		 *
		 * @return {'opaque'|'additive'|'alpha-blend'|undefined} The environment blend mode. Returns `undefined` when used outside of a XR session.
		 */ this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        /**
		 * Returns the current depth texture computed via depth sensing.
		 *
		 * See {@link WebXRDepthSensing#getDepthTexture}.
		 *
		 * @return {?Texture} The depth texture.
		 */ this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new (0, $329ek.Vector3)();
        const cameraRPos = new (0, $329ek.Vector3)();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 *
		 * @param {ArrayCamera} camera - The camera to update.
		 * @param {PerspectiveCamera} cameraL - The left camera.
		 * @param {PerspectiveCamera} cameraR - The right camera.
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        /**
		 * Updates the state of the XR camera. Use this method on app level if you
		 * set `cameraAutoUpdate` to `false`. The method requires the non-XR
		 * camera of the scene as a parameter. The passed in camera's transformation
		 * is automatically adjusted to the position of the XR camera when calling
		 * this method.
		 *
		 * @param {Camera} camera - The camera.
		 */ this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            // inherit camera layers and enable eye layers (1 = left, 2 = right)
            cameraXR.layers.mask = camera.layers.mask | 6;
            cameraL.layers.mask = cameraXR.layers.mask & 3;
            cameraR.layers.mask = cameraXR.layers.mask & 5;
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = (0, $329ek.RAD2DEG) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        /**
		 * Returns an instance of {@link ArrayCamera} which represents the XR camera
		 * of the active XR session. For each view it holds a separate camera object.
		 *
		 * The camera's `fov` is currently not used and does not reflect the fov of
		 * the XR camera. If you need the fov on app level, you have to compute in
		 * manually from the XR camera's projection matrices.
		 *
		 * @return {ArrayCamera} The XR camera.
		 */ this.getCamera = function() {
            return cameraXR;
        };
        /**
		 * Returns the amount of foveation used by the XR compositor for the projection layer.
		 *
		 * @return {number|undefined} The amount of foveation.
		 */ this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        /**
		 * Sets the foveation value.
		 *
		 * @param {number} value - A number in the range `[0,1]` where `0` means no foveation (full resolution)
		 * and `1` means maximum foveation (the edges render at lower resolution).
		 */ this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        /**
		 * Returns `true` if depth sensing is supported.
		 *
		 * @return {boolean} Whether depth sensing is supported or not.
		 */ this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        /**
		 * Returns the depth sensing mesh.
		 *
		 * See {@link WebXRDepthSensing#getMesh}.
		 *
		 * @return {Mesh} The depth sensing mesh.
		 */ this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        /**
		 * Retrieves an opaque texture from the view-aligned {@link XRCamera}.
		 * Only available during the current animation loop.
		 *
		 * @param {XRCamera} xrCamera - The camera to query.
		 * @return {?Texture} An opaque texture representing the current raw camera frame.
		 */ this.getCameraTexture = function(xrCamera) {
            return cameraAccessTextures[xrCamera];
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new (0, $329ek.PerspectiveCamera)();
                        camera.layers.enable(i);
                        camera.viewport = new (0, $329ek.Vector4)();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                const gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes('depth-sensing') && session.depthUsage == 'gpu-optimized';
                if (gpuDepthSensingEnabled && supportsGlBinding) {
                    glBinding = scope.getBinding();
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(depthData, session.renderState);
                }
                const cameraAccessEnabled = enabledFeatures && enabledFeatures.includes('camera-access');
                if (cameraAccessEnabled && supportsGlBinding) {
                    renderer.state.unbindTexture();
                    glBinding = scope.getBinding();
                    for(let i = 0; i < views.length; i++){
                        const camera = views[i].camera;
                        if (camera) {
                            let cameraTex = cameraAccessTextures[camera];
                            if (!cameraTex) {
                                cameraTex = new (0, $329ek.ExternalTexture)();
                                cameraAccessTextures[camera] = cameraTex;
                            }
                            const glTexture = glBinding.getCameraImage(camera);
                            cameraTex.sourceTexture = glTexture;
                        }
                    }
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $169244187a3eb47b$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $169244187a3eb47b$var$_e1 = /*@__PURE__*/ new (0, $329ek.Euler)();
const $169244187a3eb47b$var$_m1 = /*@__PURE__*/ new (0, $329ek.Matrix4)();
function $169244187a3eb47b$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, (0, $329ek.getUnlitUniformColorSpace)(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === (0, $329ek.BackSide)) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === (0, $329ek.BackSide)) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $169244187a3eb47b$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $169244187a3eb47b$var$_e1.x *= -1;
            $169244187a3eb47b$var$_e1.y *= -1;
            $169244187a3eb47b$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $169244187a3eb47b$var$_e1.y *= -1;
                $169244187a3eb47b$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($169244187a3eb47b$var$_m1.makeRotationFromEuler($169244187a3eb47b$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === (0, $329ek.BackSide)) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $169244187a3eb47b$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        (0, $329ek.error)('WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) (0, $329ek.warn)('WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else (0, $329ek.warn)('WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
/**
 * Precomputed DFG LUT for Image-Based Lighting
 * Resolution: 16x16
 * Samples: 4096 per texel
 * Format: RG16F (2 half floats per texel: scale, bias)
 */ const $169244187a3eb47b$var$DATA = new Uint16Array([
    0x30b5,
    0x3ad1,
    0x314c,
    0x3a4d,
    0x33d2,
    0x391c,
    0x35ef,
    0x3828,
    0x37f3,
    0x36a6,
    0x38d1,
    0x3539,
    0x3979,
    0x3410,
    0x39f8,
    0x3252,
    0x3a53,
    0x30f0,
    0x3a94,
    0x2fc9,
    0x3abf,
    0x2e35,
    0x3ada,
    0x2d05,
    0x3ae8,
    0x2c1f,
    0x3aed,
    0x2ae0,
    0x3aea,
    0x29d1,
    0x3ae1,
    0x28ff,
    0x3638,
    0x38e4,
    0x364a,
    0x38ce,
    0x3699,
    0x385e,
    0x374e,
    0x372c,
    0x3839,
    0x35a4,
    0x38dc,
    0x3462,
    0x396e,
    0x32c4,
    0x39de,
    0x3134,
    0x3a2b,
    0x3003,
    0x3a59,
    0x2e3a,
    0x3a6d,
    0x2ce1,
    0x3a6e,
    0x2bba,
    0x3a5f,
    0x2a33,
    0x3a49,
    0x290a,
    0x3a2d,
    0x2826,
    0x3a0a,
    0x26e8,
    0x3894,
    0x36d7,
    0x3897,
    0x36c9,
    0x38a3,
    0x3675,
    0x38bc,
    0x35ac,
    0x38ee,
    0x349c,
    0x393e,
    0x3332,
    0x3997,
    0x3186,
    0x39e2,
    0x3038,
    0x3a13,
    0x2e75,
    0x3a29,
    0x2cf5,
    0x3a2d,
    0x2bac,
    0x3a21,
    0x29ff,
    0x3a04,
    0x28bc,
    0x39dc,
    0x2790,
    0x39ad,
    0x261a,
    0x3978,
    0x24fa,
    0x39ac,
    0x34a8,
    0x39ac,
    0x34a3,
    0x39ae,
    0x3480,
    0x39ae,
    0x3423,
    0x39b1,
    0x330e,
    0x39c2,
    0x31a9,
    0x39e0,
    0x3063,
    0x39fc,
    0x2eb5,
    0x3a0c,
    0x2d1d,
    0x3a14,
    0x2bcf,
    0x3a07,
    0x29ff,
    0x39e9,
    0x28a3,
    0x39be,
    0x273c,
    0x3989,
    0x25b3,
    0x394a,
    0x2488,
    0x3907,
    0x2345,
    0x3a77,
    0x3223,
    0x3a76,
    0x321f,
    0x3a73,
    0x3204,
    0x3a6a,
    0x31b3,
    0x3a58,
    0x3114,
    0x3a45,
    0x303b,
    0x3a34,
    0x2eb6,
    0x3a26,
    0x2d31,
    0x3a1e,
    0x2bef,
    0x3a0b,
    0x2a0d,
    0x39ec,
    0x28a1,
    0x39c0,
    0x271b,
    0x3987,
    0x2580,
    0x3944,
    0x2449,
    0x38fa,
    0x22bd,
    0x38ac,
    0x2155,
    0x3b07,
    0x2fca,
    0x3b06,
    0x2fca,
    0x3b00,
    0x2fb8,
    0x3af4,
    0x2f7c,
    0x3adb,
    0x2eea,
    0x3ab4,
    0x2e00,
    0x3a85,
    0x2cec,
    0x3a5e,
    0x2bc5,
    0x3a36,
    0x2a00,
    0x3a0d,
    0x2899,
    0x39dc,
    0x2707,
    0x39a0,
    0x2562,
    0x395a,
    0x2424,
    0x390b,
    0x2268,
    0x38b7,
    0x20fd,
    0x385f,
    0x1fd1,
    0x3b69,
    0x2cb9,
    0x3b68,
    0x2cbb,
    0x3b62,
    0x2cbb,
    0x3b56,
    0x2cae,
    0x3b3b,
    0x2c78,
    0x3b0d,
    0x2c0a,
    0x3acf,
    0x2ae3,
    0x3a92,
    0x2998,
    0x3a54,
    0x2867,
    0x3a17,
    0x26d0,
    0x39d3,
    0x253c,
    0x3989,
    0x2402,
    0x3935,
    0x2226,
    0x38dc,
    0x20bd,
    0x387d,
    0x1f54,
    0x381d,
    0x1db3,
    0x3ba9,
    0x296b,
    0x3ba8,
    0x296f,
    0x3ba3,
    0x297b,
    0x3b98,
    0x2987,
    0x3b7f,
    0x2976,
    0x3b4e,
    0x2927,
    0x3b0e,
    0x2895,
    0x3ac2,
    0x27b7,
    0x3a73,
    0x263b,
    0x3a23,
    0x24e7,
    0x39d0,
    0x239b,
    0x3976,
    0x21d9,
    0x3917,
    0x207e,
    0x38b2,
    0x1ee7,
    0x384b,
    0x1d53,
    0x37c7,
    0x1c1e,
    0x3bd2,
    0x25cb,
    0x3bd1,
    0x25d3,
    0x3bcd,
    0x25f0,
    0x3bc2,
    0x261f,
    0x3bad,
    0x2645,
    0x3b7d,
    0x262d,
    0x3b3e,
    0x25c4,
    0x3aec,
    0x250f,
    0x3a93,
    0x243a,
    0x3a32,
    0x22ce,
    0x39d0,
    0x215b,
    0x3969,
    0x202a,
    0x38fe,
    0x1e6e,
    0x388f,
    0x1cf1,
    0x381f,
    0x1b9b,
    0x3762,
    0x19dd,
    0x3be9,
    0x21ab,
    0x3be9,
    0x21b7,
    0x3be5,
    0x21e5,
    0x3bdd,
    0x2241,
    0x3bc9,
    0x22a7,
    0x3ba0,
    0x22ec,
    0x3b62,
    0x22cd,
    0x3b0f,
    0x2247,
    0x3aae,
    0x2175,
    0x3a44,
    0x2088,
    0x39d4,
    0x1f49,
    0x3960,
    0x1dbe,
    0x38e9,
    0x1c77,
    0x3870,
    0x1ae8,
    0x37f1,
    0x1953,
    0x3708,
    0x181b,
    0x3bf6,
    0x1cea,
    0x3bf6,
    0x1cfb,
    0x3bf3,
    0x1d38,
    0x3bec,
    0x1dbd,
    0x3bda,
    0x1e7c,
    0x3bb7,
    0x1f25,
    0x3b7d,
    0x1f79,
    0x3b2c,
    0x1f4c,
    0x3ac6,
    0x1ea6,
    0x3a55,
    0x1dbb,
    0x39da,
    0x1cbd,
    0x395a,
    0x1b9d,
    0x38d8,
    0x1a00,
    0x3855,
    0x18ac,
    0x37ab,
    0x173c,
    0x36b7,
    0x1598,
    0x3bfc,
    0x1736,
    0x3bfc,
    0x1759,
    0x3bf9,
    0x17e7,
    0x3bf4,
    0x1896,
    0x3be4,
    0x1997,
    0x3bc6,
    0x1aa8,
    0x3b91,
    0x1b84,
    0x3b43,
    0x1bd2,
    0x3ade,
    0x1b8a,
    0x3a65,
    0x1acd,
    0x39e2,
    0x19d3,
    0x3957,
    0x18cd,
    0x38ca,
    0x17b3,
    0x383e,
    0x1613,
    0x376d,
    0x14bf,
    0x366f,
    0x135e,
    0x3bff,
    0x101b,
    0x3bff,
    0x1039,
    0x3bfc,
    0x10c8,
    0x3bf9,
    0x1226,
    0x3bea,
    0x1428,
    0x3bcf,
    0x1584,
    0x3b9f,
    0x16c5,
    0x3b54,
    0x179a,
    0x3af0,
    0x17ce,
    0x3a76,
    0x1771,
    0x39ea,
    0x16a4,
    0x3956,
    0x15a7,
    0x38bf,
    0x14a7,
    0x3829,
    0x1379,
    0x3735,
    0x11ea,
    0x362d,
    0x10a1,
    0x3c00,
    0x061b,
    0x3c00,
    0x066a,
    0x3bfe,
    0x081c,
    0x3bfa,
    0x0a4c,
    0x3bed,
    0x0d16,
    0x3bd5,
    0x0fb3,
    0x3ba9,
    0x114d,
    0x3b63,
    0x127c,
    0x3b01,
    0x132f,
    0x3a85,
    0x1344,
    0x39f4,
    0x12d2,
    0x3957,
    0x120d,
    0x38b5,
    0x1122,
    0x3817,
    0x103c,
    0x3703,
    0x0ed3,
    0x35f0,
    0x0d6d,
    0x3c00,
    0x007a,
    0x3c00,
    0x0089,
    0x3bfe,
    0x011d,
    0x3bfb,
    0x027c,
    0x3bf0,
    0x04fa,
    0x3bda,
    0x0881,
    0x3bb1,
    0x0acd,
    0x3b6f,
    0x0c97,
    0x3b10,
    0x0d7b,
    0x3a93,
    0x0df1,
    0x39fe,
    0x0def,
    0x3959,
    0x0d8a,
    0x38af,
    0x0ce9,
    0x3808,
    0x0c31,
    0x36d5,
    0x0af0,
    0x35b9,
    0x09a3,
    0x3c00,
    0x0000,
    0x3c00,
    0x0001,
    0x3bff,
    0x0015,
    0x3bfb,
    0x0059,
    0x3bf2,
    0x00fd,
    0x3bdd,
    0x01df,
    0x3bb7,
    0x031c,
    0x3b79,
    0x047c,
    0x3b1d,
    0x05d4,
    0x3aa0,
    0x06d5,
    0x3a08,
    0x075a,
    0x395d,
    0x075e,
    0x38aa,
    0x06f7,
    0x37f4,
    0x0648,
    0x36ac,
    0x0576,
    0x3586,
    0x049f
]);
let $169244187a3eb47b$var$lut = null;
function $169244187a3eb47b$var$getDFGLUT() {
    if ($169244187a3eb47b$var$lut === null) {
        $169244187a3eb47b$var$lut = new (0, $329ek.DataTexture)($169244187a3eb47b$var$DATA, 16, 16, (0, $329ek.RGFormat), (0, $329ek.HalfFloatType));
        $169244187a3eb47b$var$lut.name = 'DFG_LUT';
        $169244187a3eb47b$var$lut.minFilter = (0, $329ek.LinearFilter);
        $169244187a3eb47b$var$lut.magFilter = (0, $329ek.LinearFilter);
        $169244187a3eb47b$var$lut.wrapS = (0, $329ek.ClampToEdgeWrapping);
        $169244187a3eb47b$var$lut.wrapT = (0, $329ek.ClampToEdgeWrapping);
        $169244187a3eb47b$var$lut.generateMipmaps = false;
        $169244187a3eb47b$var$lut.needsUpdate = true;
    }
    return $169244187a3eb47b$var$lut;
}
/**
 * This renderer uses WebGL 2 to display scenes.
 *
 * WebGL 1 is not supported since `r163`.
 */ class $169244187a3eb47b$export$f6cc00ef28d7cf97 {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        const { canvas: canvas = (0, $329ek.createCanvasElement)(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false, reversedDepthBuffer: reversedDepthBuffer = false, outputBufferType: outputBufferType = (0, $329ek.UnsignedByteType) } = parameters;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const _outputBufferType = outputBufferType;
        const INTEGER_FORMATS = new Set([
            (0, $329ek.RGBAIntegerFormat),
            (0, $329ek.RGIntegerFormat),
            (0, $329ek.RedIntegerFormat)
        ]);
        const UNSIGNED_TYPES = new Set([
            (0, $329ek.UnsignedByteType),
            (0, $329ek.UnsignedIntType),
            (0, $329ek.UnsignedShortType),
            (0, $329ek.UnsignedInt248Type),
            (0, $329ek.UnsignedShort4444Type),
            (0, $329ek.UnsignedShort5551Type)
        ]);
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // internal render target for non-UnsignedByteType color buffer
        let output = null;
        // public properties
        /**
		 * A canvas where the renderer draws its output.This is automatically created by the renderer
		 * in the constructor (if not provided already); you just need to add it to your page like so:
		 * ```js
		 * document.body.appendChild( renderer.domElement );
		 * ```
		 *
		 * @type {HTMLCanvasElement|OffscreenCanvas}
		 */ this.domElement = canvas;
        /**
		 * A object with debug configuration settings.
		 *
		 * - `checkShaderErrors`: If it is `true`, defines whether material shader programs are
		 * checked for errors during compilation and linkage process. It may be useful to disable
		 * this check in production for performance gain. It is strongly recommended to keep these
		 * checks enabled during development. If the shader does not compile and link - it will not
		 * work and associated material will not render.
		 * - `onShaderError(gl, program, glVertexShader,glFragmentShader)`: A callback function that
		 * can be used for custom error reporting. The callback receives the WebGL context, an instance
		 * of WebGLProgram as well two instances of WebGLShader representing the vertex and fragment shader.
		 * Assigning a custom function disables the default error reporting.
		 *
		 * @type {Object}
		 */ this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled.
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        /**
		 * Whether the renderer should automatically clear its output before rendering a frame or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClear = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the color buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearColor = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearDepth = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearStencil = true;
        // scene graph
        /**
		 * Whether the renderer should sort objects or not.
		 *
		 * Note: Sorting is used to attempt to properly render objects that have some
		 * degree of transparency. By definition, sorting objects may not work in all
		 * cases. Depending on the needs of application, it may be necessary to turn
		 * off sorting and use other methods to deal with transparency rendering e.g.
		 * manually determining each object's rendering order.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        // user-defined clipping
        /**
		 * User-defined clipping planes specified in world space. These planes apply globally.
		 * Points in space whose dot product with the plane is negative are cut away.
		 *
		 * @type {Array<Plane>}
		 */ this.clippingPlanes = [];
        /**
		 * Whether the renderer respects object-level clipping planes or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.localClippingEnabled = false;
        // tone mapping
        /**
		 * The tone mapping technique of the renderer.
		 *
		 * @type {(NoToneMapping|LinearToneMapping|ReinhardToneMapping|CineonToneMapping|ACESFilmicToneMapping|CustomToneMapping|AgXToneMapping|NeutralToneMapping)}
		 * @default NoToneMapping
		 */ this.toneMapping = (0, $329ek.NoToneMapping);
        /**
		 * Exposure level of tone mapping.
		 *
		 * @type {number}
		 * @default 1
		 */ this.toneMappingExposure = 1.0;
        // transmission
        /**
		 * The normalized resolution scale for the transmission render target, measured in percentage
		 * of viewport dimensions. Lowering this value can result in significant performance improvements
		 * when using {@link MeshPhysicalMaterial#transmission}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.transmissionResolutionScale = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        this._outputColorSpace = (0, $329ek.SRGBColorSpace);
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new (0, $329ek.Vector4)();
        const _currentScissor = new (0, $329ek.Vector4)();
        let _currentScissorTest = null;
        const _currentClearColor = new (0, $329ek.Color)(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new (0, $329ek.Vector4)(0, 0, _width, _height);
        const _scissor = new (0, $329ek.Vector4)(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new (0, $329ek.Frustum)();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // camera matrices cache
        const _projScreenMatrix = new (0, $329ek.Matrix4)();
        const _vector3 = new (0, $329ek.Vector3)();
        const _vector4 = new (0, $329ek.Vector4)();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${(0, $329ek.REVISION)}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (e) {
            (0, $329ek.error)('WebGLRenderer: ' + e.message);
            throw e;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $169244187a3eb47b$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $169244187a3eb47b$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $169244187a3eb47b$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $169244187a3eb47b$var$WebGLState(_gl, extensions);
            if (capabilities.reversedDepthBuffer && reversedDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $169244187a3eb47b$var$WebGLInfo(_gl);
            properties = new $169244187a3eb47b$var$WebGLProperties();
            textures = new $169244187a3eb47b$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $169244187a3eb47b$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $169244187a3eb47b$var$WebGLCubeUVMaps(_this);
            attributes = new $169244187a3eb47b$var$WebGLAttributes(_gl);
            bindingStates = new $169244187a3eb47b$var$WebGLBindingStates(_gl, attributes);
            geometries = new $169244187a3eb47b$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $169244187a3eb47b$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $169244187a3eb47b$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $169244187a3eb47b$var$WebGLClipping(properties);
            programCache = new $169244187a3eb47b$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $169244187a3eb47b$var$WebGLMaterials(_this, properties);
            renderLists = new $169244187a3eb47b$var$WebGLRenderLists();
            renderStates = new $169244187a3eb47b$var$WebGLRenderStates(extensions);
            background = new $169244187a3eb47b$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $169244187a3eb47b$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $169244187a3eb47b$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $169244187a3eb47b$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $169244187a3eb47b$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            /**
			 * Holds details about the capabilities of the current rendering context.
			 *
			 * @name WebGLRenderer#capabilities
			 * @type {WebGLRenderer~Capabilities}
			 */ _this.capabilities = capabilities;
            /**
			 * Provides methods for retrieving and testing WebGL extensions.
			 *
			 * - `get(extensionName:string)`: Used to check whether a WebGL extension is supported
			 * and return the extension object if available.
			 * - `has(extensionName:string)`: returns `true` if the extension is supported.
			 *
			 * @name WebGLRenderer#extensions
			 * @type {Object}
			 */ _this.extensions = extensions;
            /**
			 * Used to track properties of other objects like native WebGL objects.
			 *
			 * @name WebGLRenderer#properties
			 * @type {Object}
			 */ _this.properties = properties;
            /**
			 * Manages the render lists of the renderer.
			 *
			 * @name WebGLRenderer#renderLists
			 * @type {Object}
			 */ _this.renderLists = renderLists;
            /**
			 * Interface for managing shadows.
			 *
			 * @name WebGLRenderer#shadowMap
			 * @type {WebGLRenderer~ShadowMap}
			 */ _this.shadowMap = shadowMap;
            /**
			 * Interface for managing the WebGL state.
			 *
			 * @name WebGLRenderer#state
			 * @type {Object}
			 */ _this.state = state;
            /**
			 * Holds a series of statistical information about the GPU memory
			 * and the rendering process. Useful for debugging and monitoring.
			 *
			 * By default these data are reset at each render call but when having
			 * multiple render passes per frame (e.g. when using post processing) it can
			 * be preferred to reset with a custom pattern. First, set `autoReset` to
			 * `false`.
			 * ```js
			 * renderer.info.autoReset = false;
			 * ```
			 * Call `reset()` whenever you have finished to render a single frame.
			 * ```js
			 * renderer.info.reset();
			 * ```
			 *
			 * @name WebGLRenderer#info
			 * @type {WebGLRenderer~Info}
			 */ _this.info = info;
        }
        initGLContext();
        // initialize internal render target for non-UnsignedByteType color buffer
        if (_outputBufferType !== (0, $329ek.UnsignedByteType)) output = new $169244187a3eb47b$var$WebGLOutput(_outputBufferType, canvas.width, canvas.height, depth, stencil);
        // xr
        const xr = new $169244187a3eb47b$var$WebXRManager(_this, _gl);
        /**
		 * A reference to the XR manager.
		 *
		 * @type {WebXRManager}
		 */ this.xr = xr;
        /**
		 * Returns the rendering context.
		 *
		 * @return {WebGL2RenderingContext} The rendering context.
		 */ this.getContext = function() {
            return _gl;
        };
        /**
		 * Returns the rendering context attributes.
		 *
		 * @return {WebGLContextAttributes} The rendering context attributes.
		 */ this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        /**
		 * Simulates a loss of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        /**
		 * Simulates a restore of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        /**
		 * Returns the pixel ratio.
		 *
		 * @return {number} The pixel ratio.
		 */ this.getPixelRatio = function() {
            return _pixelRatio;
        };
        /**
		 * Sets the given pixel ratio and resizes the canvas if necessary.
		 *
		 * @param {number} value - The pixel ratio.
		 */ this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        /**
		 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The renderer's size in logical pixels.
		 */ this.getSize = function(target) {
            return target.set(_width, _height);
        };
        /**
		 * Resizes the output canvas to (width, height) with device pixel ratio taken
		 * into account, and also sets the viewport to fit that size, starting in (0,
		 * 0). Setting `updateStyle` to false prevents any style changes to the output canvas.
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
		 */ this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                (0, $329ek.warn)('WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            if (output !== null) output.setSize(canvas.width, canvas.height);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The drawing buffer size.
		 */ this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        /**
		 * This method allows to define the drawing buffer size by specifying
		 * width, height and pixel ratio all at once. The size of the drawing
		 * buffer is computed with this formula:
		 * ```js
		 * size.x = width * pixelRatio;
		 * size.y = height * pixelRatio;
		 * ```
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {number} pixelRatio - The pixel ratio.
		 */ this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Sets the post-processing effects to be applied after rendering.
		 *
		 * @param {Array} effects - An array of post-processing effects.
		 */ this.setEffects = function(effects) {
            if (_outputBufferType === (0, $329ek.UnsignedByteType)) {
                console.error('THREE.WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.');
                return;
            }
            if (effects) {
                for(let i = 0; i < effects.length; i++)if (effects[i].isOutputPass === true) {
                    console.warn('THREE.WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.');
                    break;
                }
            }
            output.setEffects(effects || []);
        };
        /**
		 * Returns the current viewport definition.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The current viewport definition.
		 */ this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        /**
		 * Returns the viewport definition.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The viewport definition.
		 */ this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        /**
		 * Sets the viewport to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the viewport.
		 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
		 * @param {number} width - The width of the viewport in logical pixel unit.
		 * @param {number} height - The height of the viewport in logical pixel unit.
		 */ this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns the scissor region.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The scissor region.
		 */ this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        /**
		 * Sets the scissor region to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the scissor region origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the scissor region.
		 * @param {number} y - The vertical coordinate for the lower left corner of the scissor region origin  in logical pixel unit.
		 * @param {number} width - The width of the scissor region in logical pixel unit.
		 * @param {number} height - The height of the scissor region in logical pixel unit.
		 */ this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns `true` if the scissor test is enabled.
		 *
		 * @return {boolean} Whether the scissor test is enabled or not.
		 */ this.getScissorTest = function() {
            return _scissorTest;
        };
        /**
		 * Enable or disable the scissor test. When this is enabled, only the pixels
		 * within the defined scissor area will be affected by further renderer
		 * actions.
		 *
		 * @param {boolean} boolean - Whether the scissor test is enabled or not.
		 */ this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        /**
		 * Sets a custom opaque sort function for the render lists. Pass `null`
		 * to use the default `painterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        /**
		 * Sets a custom transparent sort function for the render lists. Pass `null`
		 * to use the default `reversePainterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        /**
		 * Returns the clear color.
		 *
		 * @param {Color} target - The method writes the result in this target object.
		 * @return {Color} The clear color.
		 */ this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        /**
		 * Sets the clear color and alpha.
		 *
		 * @param {Color} color - The clear color.
		 * @param {number} [alpha=1] - The clear alpha.
		 */ this.setClearColor = function() {
            background.setClearColor(...arguments);
        };
        /**
		 * Returns the clear alpha. Ranges within `[0,1]`.
		 *
		 * @return {number} The clear alpha.
		 */ this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        /**
		 * Sets the clear alpha.
		 *
		 * @param {number} alpha - The clear alpha.
		 */ this.setClearAlpha = function() {
            background.setClearAlpha(...arguments);
        };
        /**
		 * Tells the renderer to clear its color, depth or stencil drawing buffer(s).
		 * This method initializes the buffers to the current clear color values.
		 *
		 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
		 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
		 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
		 */ this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = INTEGER_FORMATS.has(targetFormat);
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = UNSIGNED_TYPES.has(targetType);
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        /**
		 * Clears the color buffer. Equivalent to calling `renderer.clear( true, false, false )`.
		 */ this.clearColor = function() {
            this.clear(true, false, false);
        };
        /**
		 * Clears the depth buffer. Equivalent to calling `renderer.clear( false, true, false )`.
		 */ this.clearDepth = function() {
            this.clear(false, true, false);
        };
        /**
		 * Clears the stencil buffer. Equivalent to calling `renderer.clear( false, false, true )`.
		 */ this.clearStencil = function() {
            this.clear(false, false, true);
        };
        /**
		 * Frees the GPU-related resources allocated by this instance. Call this
		 * method whenever this instance is no longer used in your app.
		 */ this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            background.dispose();
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            (0, $329ek.log)('WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            (0, $329ek.log)('WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            (0, $329ek.error)('WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) {
                    // @deprecated, r174
                    (0, $329ek.warnOnce)('WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.');
                    renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                } else if (!extensions.get('WEBGL_multi_draw')) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === (0, $329ek.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, $329ek.BackSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $329ek.FrontSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $329ek.DoubleSide);
            } else getProgram(material, scene, object);
        }
        /**
		 * Compiles all materials in the scene with the camera. This is useful to precompile shaders
		 * before the first rendering. If you want to add a 3D object to an existing scene, use the third
		 * optional parameter for applying the target scene.
		 *
		 * Note that the (target) scene's lighting and environment must be configured before calling this method.
		 *
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Set<Material>} The precompiled materials.
		 */ this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            currentRenderState = renderStateStack.pop();
            return materials;
        };
        // compileAsync
        /**
		 * Asynchronous version of {@link WebGLRenderer#compile}.
		 *
		 * This method makes use of the `KHR_parallel_shader_compile` WebGL extension. Hence,
		 * it is recommended to use this version of `compile()` whenever possible.
		 *
		 * @async
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Promise} A Promise that resolves when the given scene can be rendered without unnecessary stalling due to shader compilation.
		 */ this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $169244187a3eb47b$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        /**
		 * Applications are advised to always define the animation loop
		 * with this method and not manually with `requestAnimationFrame()`
		 * for best compatibility.
		 *
		 * @param {?onAnimationCallback} callback - The application's animation loop.
		 */ this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        /**
		 * Renders the given scene (or other type of 3D object) using the given camera.
		 *
		 * The render is done to a previously specified render target set by calling {@link WebGLRenderer#setRenderTarget}
		 * or to the canvas as usual.
		 *
		 * By default render buffers are cleared before rendering but you can prevent
		 * this by setting the property `autoClear` to `false`. If you want to prevent
		 * only certain buffers being cleared you can `autoClearColor`, `autoClearDepth`
		 * or `autoClearStencil` to `false`. To force a clear, use {@link WebGLRenderer#clear}.
		 *
		 * @param {Object3D} scene - The scene to render.
		 * @param {Camera} camera - The camera.
		 */ this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                (0, $329ek.error)('WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // use internal render target for HalfFloatType color buffer (only when tone mapping is enabled)
            const isXRPresenting = xr.enabled === true && xr.isPresenting === true;
            const useOutput = output !== null && (_currentRenderTarget === null || isXRPresenting) && output.begin(_this, _currentRenderTarget);
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true && (output === null || output.isCompositing() === false)) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix, (0, $329ek.WebGLCoordinateSystem), camera.reversedDepth);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene (skip if first effect is a render pass - it will render the scene itself)
            const skipSceneRender = useOutput && output.hasRenderPass();
            if (skipSceneRender === false) {
                const opaqueObjects = currentRenderList.opaque;
                const transmissiveObjects = currentRenderList.transmissive;
                currentRenderState.setupLights();
                if (camera.isArrayCamera) {
                    const cameras = camera.cameras;
                    if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                        const camera2 = cameras[i];
                        renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                    }
                    if (_renderBackground) background.render(scene);
                    for(let i = 0, l = cameras.length; i < l; i++){
                        const camera2 = cameras[i];
                        renderScene(currentRenderList, scene, camera2, camera2.viewport);
                    }
                } else {
                    if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                    if (_renderBackground) background.render(scene);
                    renderScene(currentRenderList, scene, camera);
                }
            }
            //
            if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            // copy from internal render target to canvas using fullscreen quad
            if (useOutput) output.end(_this);
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const { opaque: opaqueObjects, transmissive: transmissiveObjects, transparent: transparentObjects } = currentRenderList;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) {
                const hasHalfFloatSupport = extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float');
                currentRenderState.state.transmissionRenderTarget[camera.id] = new (0, $329ek.WebGLRenderTarget)(1, 1, {
                    generateMipmaps: true,
                    type: hasHalfFloatSupport ? (0, $329ek.HalfFloatType) : (0, $329ek.UnsignedByteType),
                    minFilter: (0, $329ek.LinearMipmapLinearFilter),
                    samples: capabilities.samples,
                    stencilBuffer: stencil,
                    resolveDepthBuffer: false,
                    resolveStencilBuffer: false,
                    colorSpace: (0, $329ek.ColorManagement).workingColorSpace
                });
            // debug
            /*
				const geometry = new PlaneGeometry();
				const material = new MeshBasicMaterial( { map: _transmissionRenderTarget.texture } );

				const mesh = new Mesh( geometry, material );
				scene.add( mesh );
				*/ }
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
            //
            const currentRenderTarget = _this.getRenderTarget();
            const currentActiveCubeFace = _this.getActiveCubeFace();
            const currentActiveMipmapLevel = _this.getActiveMipmapLevel();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = (0, $329ek.NoToneMapping);
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const { object: object, geometry: geometry, material: material, group: group } = renderItem;
                    if (material.side === (0, $329ek.DoubleSide) && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = (0, $329ek.BackSide);
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const { object: object, geometry: geometry, group: group } = renderItem;
                let material = renderItem.material;
                if (material.allowOverride === true && overrideMaterial !== null) material = overrideMaterial;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === (0, $329ek.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, $329ek.BackSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $329ek.FrontSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $329ek.DoubleSide);
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $169244187a3eb47b$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : (0, $329ek.LinearSRGBColorSpace);
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = (0, $329ek.NoToneMapping);
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                const reversedDepthBuffer = state.buffers.depth.getReversed();
                if (reversedDepthBuffer && camera.reversedDepth !== true) {
                    camera._reversedDepth = true;
                    camera.updateProjectionMatrix();
                }
                p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // Pre-allocate texture units for shadow samplers before setting data textures
            if (materialProperties.needsLights) {
                // Set shadow map uniforms first to ensure they get the first texture units
                if (lights.state.directionalShadowMap.length > 0) p_uniforms.setValue(_gl, 'directionalShadowMap', lights.state.directionalShadowMap, textures);
                if (lights.state.spotShadowMap.length > 0) p_uniforms.setValue(_gl, 'spotShadowMap', lights.state.spotShadowMap, textures);
                if (lights.state.pointShadowMap.length > 0) p_uniforms.setValue(_gl, 'pointShadowMap', lights.state.pointShadowMap, textures);
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            // Set DFG LUT for physically-based materials
            if (m_uniforms.dfgLUT !== undefined) m_uniforms.dfgLUT.value = $169244187a3eb47b$var$getDFGLUT();
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $169244187a3eb47b$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $169244187a3eb47b$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        /**
		 * Returns the active cube face.
		 *
		 * @return {number} The active cube face.
		 */ this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        /**
		 * Returns the active mipmap level.
		 *
		 * @return {number} The active mipmap level.
		 */ this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        /**
		 * Returns the active render target.
		 *
		 * @return {?WebGLRenderTarget} The active render target. Returns `null` if no render target
		 * is currently set.
		 */ this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__autoAllocateDepthBuffer = renderTarget.resolveDepthBuffer === false;
            if (renderTargetProperties.__autoAllocateDepthBuffer === false) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            renderTargetProperties.__useRenderToTexture = false;
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = renderTargetProperties.__autoAllocateDepthBuffer ? undefined : depthTexture;
            renderTargetProperties.__hasExternalTextures = true;
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        const _scratchFrameBuffer = _gl.createFramebuffer();
        /**
		 * Sets the active rendertarget.
		 *
		 * @param {?WebGLRenderTarget} renderTarget - The render target to set. When `null` is given,
		 * the canvas is set as the active render target instead.
		 * @param {number} [activeCubeFace=0] - The active cube face when using a cube render target.
		 * Indicates the z layer to render in to when using 3D or array render targets.
		 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
		 */ this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // Externally-managed framebuffer (e.g. XR)
                    // Bind to the stored framebuffer (may be null for default, or a WebGLFramebuffer)
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _currentViewport.copy(renderTarget.viewport);
                    _currentScissor.copy(renderTarget.scissor);
                    _currentScissorTest = renderTarget.scissorTest;
                    state.viewport(_currentViewport);
                    state.scissor(_currentScissor);
                    state.setScissorTest(_currentScissorTest);
                    _currentMaterialId = -1;
                    return;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            // Use a scratch frame buffer if rendering to a mip level to avoid depth buffers
            // being bound that are different sizes.
            if (activeMipmapLevel !== 0) framebuffer = _scratchFrameBuffer;
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const layer = activeCubeFace;
                for(let i = 0; i < renderTarget.textures.length; i++){
                    const textureProperties = properties.get(renderTarget.textures[i]);
                    _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, textureProperties.__webglTexture, activeMipmapLevel, layer);
                }
            } else if (renderTarget !== null && activeMipmapLevel !== 0) {
                // Only bind the frame buffer if we are using a scratch frame buffer to render to a mipmap.
                // If we rebind the texture when using a multi sample buffer then an error about inconsistent samples will be thrown.
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        /**
		 * Reads the pixel data from the given render target into the given buffer.
		 *
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 */ this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                (0, $329ek.error)('WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        (0, $329ek.error)('WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        (0, $329ek.error)('WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                        // when using MRT, select the correct color buffer for the subsequent read command
                        if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                        _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                    }
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        /**
		 * Asynchronous, non-blocking version of {@link WebGLRenderer#readRenderTargetPixels}.
		 *
		 * It is recommended to use this version of `readRenderTargetPixels()` whenever possible.
		 *
		 * @async
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
		 */ this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    // set the active frame buffer to the one we want to read
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                    if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                    const glBuffer = _gl.createBuffer();
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                    // when using MRT, select the correct color buffer for the subsequent read command
                    if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                    // reset the frame buffer to the currently set buffer before waiting
                    const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                    // check if the commands have finished every 8 ms
                    const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    _gl.flush();
                    await (0, $329ek.probeAsync)(_gl, sync, 4);
                    // read the data and delete the buffer
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                    _gl.deleteBuffer(glBuffer);
                    _gl.deleteSync(sync);
                    return buffer;
                } else throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
            }
        };
        /**
		 * Copies pixels from the current bound framebuffer into the given texture.
		 *
		 * @param {FramebufferTexture} texture - The texture.
		 * @param {?Vector2} [position=null] - The start position of the copy operation.
		 * @param {number} [level=0] - The mip level. The default represents the base mip.
		 */ this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        const _srcFramebuffer = _gl.createFramebuffer();
        const _dstFramebuffer = _gl.createFramebuffer();
        /**
		 * Copies data of the given source texture into a destination texture.
		 *
		 * When using render target textures as `srcTexture` and `dstTexture`, you must make sure both render targets are initialized
		 * {@link WebGLRenderer#initRenderTarget}.
		 *
		 * @param {Texture} srcTexture - The source texture.
		 * @param {Texture} dstTexture - The destination texture.
		 * @param {?(Box2|Box3)} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
		 * @param {?(Vector2|Vector3)} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
		 * @param {number} [srcLevel=0] - The source mipmap level to copy.
		 * @param {?number} [dstLevel=null] - The destination mipmap level.
		 */ this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = null) {
            // support the previous signature with just a single dst mipmap level
            if (dstLevel === null) {
                if (srcLevel !== 0) {
                    // @deprecated, r171
                    (0, $329ek.warnOnce)('WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.');
                    dstLevel = srcLevel;
                    srcLevel = 0;
                } else dstLevel = 0;
            }
            // gather the necessary dimensions to copy
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                const levelScale = Math.pow(2, -srcLevel);
                width = Math.floor(image.width * levelScale);
                height = Math.floor(image.height * levelScale);
                if (srcTexture.isDataArrayTexture) depth = image.depth;
                else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
                else depth = 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isDepthTexture) {
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) {
                        _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                        _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
                    }
                    _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
                // get the appropriate frame buffers
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                // bind the frame buffer targets
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
                for(let i = 0; i < depth; i++){
                    // assign the correct layers and mip maps to the frame buffers
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i);
                    else _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
                    if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i);
                    else _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
                    // copy the data using the fastest function that can achieve the copy
                    if (srcLevel !== 0) _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
                    else if (isDst3D) _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
                }
                // unbind read, draw buffers
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (dstLevel === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        /**
		 * Initializes the given WebGLRenderTarget memory. Useful for initializing a render target so data
		 * can be copied into it using {@link WebGLRenderer#copyTextureToTexture} before it has been
		 * rendered to.
		 *
		 * @param {WebGLRenderTarget} target - The render target.
		 */ this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        /**
		 * Initializes the given texture. Useful for preloading a texture rather than waiting until first
		 * render (which can cause noticeable lags due to decode and GPU upload overhead).
		 *
		 * @param {Texture} texture - The texture.
		 */ this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        /**
		 * Can be used to reset the internal WebGL state. This method is mostly
		 * relevant for applications which share a single WebGL context across
		 * multiple WebGL libraries.
		 */ this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    /**
	 * Defines the coordinate system of the renderer.
	 *
	 * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
	 *
	 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
	 * @default WebGLCoordinateSystem
	 * @readonly
	 */ get coordinateSystem() {
        return 0, $329ek.WebGLCoordinateSystem;
    }
    /**
	 * Defines the output color space of the renderer.
	 *
	 * @type {SRGBColorSpace|LinearSRGBColorSpace}
	 * @default SRGBColorSpace
	 */ get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace) {
        this._outputColorSpace = colorSpace;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = (0, $329ek.ColorManagement)._getDrawingBufferColorSpace(colorSpace);
        gl.unpackColorSpace = (0, $329ek.ColorManagement)._getUnpackColorSpace();
    }
}

});

parcelRegister("ltPx4", function(module, exports) {

$parcel$export(module.exports, "FBXLoader", () => $fa3447b093a231bb$export$60c52e42bb04b96);

var $329ek = parcelRequire("329ek");parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");

var $kb6vH = parcelRequire("kb6vH");

var $iTkPg = parcelRequire("iTkPg");
let $fa3447b093a231bb$var$fbxTree;
let $fa3447b093a231bb$var$connections;
let $fa3447b093a231bb$var$sceneGraph;
/**
 * A loader for the FBX format.
 *
 * Requires FBX file to be >= 7.0 and in ASCII or >= 6400 in Binary format.
 * Versions lower than this may load but will probably have errors.
 *
 * Needs Support:
 * - Morph normals / blend shape normals
 *
 * FBX format references:
 * - [C++ SDK reference](https://help.autodesk.com/view/FBX/2017/ENU/?guid=__cpp_ref_index_html)
 *
 * Binary format specification:
 * - [FBX binary file format specification](https://code.blender.org/2013/08/fbx-binary-file-format-specification/)
 *
 * ```js
 * const loader = new FBXLoader();
 * const object = await loader.loadAsync( 'models/fbx/stanford-bunny.fbx' );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 * @three_import import { FBXLoader } from 'three/addons/loaders/FBXLoader.js';
 */ class $fa3447b093a231bb$export$60c52e42bb04b96 extends (0, $329ek.Loader) {
    /**
	 * Constructs a new FBX loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded FBX asset
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Group)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = scope.path === '' ? (0, $329ek.LoaderUtils).extractUrlBase(url) : scope.path;
        const loader = new (0, $329ek.FileLoader)(this.manager);
        loader.setPath(scope.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            try {
                onLoad(scope.parse(buffer, path));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given FBX data and returns the resulting group.
	 *
	 * @param {ArrayBuffer} FBXBuffer - The raw FBX data as an array buffer.
	 * @param {string} path - The URL base path.
	 * @return {Group} An object representing the parsed asset.
	 */ parse(FBXBuffer, path) {
        if ($fa3447b093a231bb$var$isFbxFormatBinary(FBXBuffer)) $fa3447b093a231bb$var$fbxTree = new $fa3447b093a231bb$var$BinaryParser().parse(FBXBuffer);
        else {
            const FBXText = $fa3447b093a231bb$var$convertArrayBufferToString(FBXBuffer);
            if (!$fa3447b093a231bb$var$isFbxFormatASCII(FBXText)) throw new Error('THREE.FBXLoader: Unknown format.');
            if ($fa3447b093a231bb$var$getFbxVersion(FBXText) < 7000) throw new Error('THREE.FBXLoader: FBX version not supported, FileVersion: ' + $fa3447b093a231bb$var$getFbxVersion(FBXText));
            $fa3447b093a231bb$var$fbxTree = new $fa3447b093a231bb$var$TextParser().parse(FBXText);
        }
        // console.log( fbxTree );
        const textureLoader = new (0, $329ek.TextureLoader)(this.manager).setPath(this.resourcePath || path).setCrossOrigin(this.crossOrigin);
        return new $fa3447b093a231bb$var$FBXTreeParser(textureLoader, this.manager).parse($fa3447b093a231bb$var$fbxTree);
    }
}
// Parse the FBXTree object returned by the BinaryParser or TextParser and return a Group
class $fa3447b093a231bb$var$FBXTreeParser {
    constructor(textureLoader, manager){
        this.textureLoader = textureLoader;
        this.manager = manager;
    }
    parse() {
        $fa3447b093a231bb$var$connections = this.parseConnections();
        const images = this.parseImages();
        const textures = this.parseTextures(images);
        const materials = this.parseMaterials(textures);
        const deformers = this.parseDeformers();
        const geometryMap = new $fa3447b093a231bb$var$GeometryParser().parse(deformers);
        this.parseScene(deformers, geometryMap, materials);
        return $fa3447b093a231bb$var$sceneGraph;
    }
    // Parses FBXTree.Connections which holds parent-child connections between objects (e.g. material -> texture, model->geometry )
    // and details the connection type
    parseConnections() {
        const connectionMap = new Map();
        if ('Connections' in $fa3447b093a231bb$var$fbxTree) {
            const rawConnections = $fa3447b093a231bb$var$fbxTree.Connections.connections;
            rawConnections.forEach(function(rawConnection) {
                const fromID = rawConnection[0];
                const toID = rawConnection[1];
                const relationship = rawConnection[2];
                if (!connectionMap.has(fromID)) connectionMap.set(fromID, {
                    parents: [],
                    children: []
                });
                const parentRelationship = {
                    ID: toID,
                    relationship: relationship
                };
                connectionMap.get(fromID).parents.push(parentRelationship);
                if (!connectionMap.has(toID)) connectionMap.set(toID, {
                    parents: [],
                    children: []
                });
                const childRelationship = {
                    ID: fromID,
                    relationship: relationship
                };
                connectionMap.get(toID).children.push(childRelationship);
            });
        }
        return connectionMap;
    }
    // Parse FBXTree.Objects.Video for embedded image data
    // These images are connected to textures in FBXTree.Objects.Textures
    // via FBXTree.Connections.
    parseImages() {
        const images = {};
        const blobs = {};
        if ('Video' in $fa3447b093a231bb$var$fbxTree.Objects) {
            const videoNodes = $fa3447b093a231bb$var$fbxTree.Objects.Video;
            for(const nodeID in videoNodes){
                const videoNode = videoNodes[nodeID];
                const id = parseInt(nodeID);
                images[id] = videoNode.RelativeFilename || videoNode.Filename;
                // raw image data is in videoNode.Content
                if ('Content' in videoNode) {
                    const arrayBufferContent = videoNode.Content instanceof ArrayBuffer && videoNode.Content.byteLength > 0;
                    const base64Content = typeof videoNode.Content === 'string' && videoNode.Content !== '';
                    if (arrayBufferContent || base64Content) {
                        const image = this.parseImage(videoNodes[nodeID]);
                        blobs[videoNode.RelativeFilename || videoNode.Filename] = image;
                    }
                }
            }
        }
        for(const id in images){
            const filename = images[id];
            if (blobs[filename] !== undefined) images[id] = blobs[filename];
            else images[id] = images[id].split('\\').pop();
        }
        return images;
    }
    // Parse embedded image data in FBXTree.Video.Content
    parseImage(videoNode) {
        const content = videoNode.Content;
        const fileName = videoNode.RelativeFilename || videoNode.Filename;
        const extension = fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase();
        let type;
        switch(extension){
            case 'bmp':
                type = 'image/bmp';
                break;
            case 'jpg':
            case 'jpeg':
                type = 'image/jpeg';
                break;
            case 'png':
                type = 'image/png';
                break;
            case 'tif':
                type = 'image/tiff';
                break;
            case 'tga':
                if (this.manager.getHandler('.tga') === null) console.warn('FBXLoader: TGA loader not found, skipping ', fileName);
                type = 'image/tga';
                break;
            case 'webp':
                type = 'image/webp';
                break;
            default:
                console.warn('FBXLoader: Image type "' + extension + '" is not supported.');
                return;
        }
        if (typeof content === 'string') return 'data:' + type + ';base64,' + content;
        else {
            const array = new Uint8Array(content);
            return window.URL.createObjectURL(new Blob([
                array
            ], {
                type: type
            }));
        }
    }
    // Parse nodes in FBXTree.Objects.Texture
    // These contain details such as UV scaling, cropping, rotation etc and are connected
    // to images in FBXTree.Objects.Video
    parseTextures(images) {
        const textureMap = new Map();
        if ('Texture' in $fa3447b093a231bb$var$fbxTree.Objects) {
            const textureNodes = $fa3447b093a231bb$var$fbxTree.Objects.Texture;
            for(const nodeID in textureNodes){
                const texture = this.parseTexture(textureNodes[nodeID], images);
                textureMap.set(parseInt(nodeID), texture);
            }
        }
        return textureMap;
    }
    // Parse individual node in FBXTree.Objects.Texture
    parseTexture(textureNode, images) {
        const texture = this.loadTexture(textureNode, images);
        texture.ID = textureNode.id;
        texture.name = textureNode.attrName;
        const wrapModeU = textureNode.WrapModeU;
        const wrapModeV = textureNode.WrapModeV;
        const valueU = wrapModeU !== undefined ? wrapModeU.value : 0;
        const valueV = wrapModeV !== undefined ? wrapModeV.value : 0;
        // http://download.autodesk.com/us/fbx/SDKdocs/FBX_SDK_Help/files/fbxsdkref/class_k_fbx_texture.html#889640e63e2e681259ea81061b85143a
        // 0: repeat(default), 1: clamp
        texture.wrapS = valueU === 0 ? (0, $329ek.RepeatWrapping) : (0, $329ek.ClampToEdgeWrapping);
        texture.wrapT = valueV === 0 ? (0, $329ek.RepeatWrapping) : (0, $329ek.ClampToEdgeWrapping);
        if ('Scaling' in textureNode) {
            const values = textureNode.Scaling.value;
            texture.repeat.x = values[0];
            texture.repeat.y = values[1];
        }
        if ('Translation' in textureNode) {
            const values = textureNode.Translation.value;
            texture.offset.x = values[0];
            texture.offset.y = values[1];
        }
        return texture;
    }
    // load a texture specified as a blob or data URI, or via an external URL using TextureLoader
    loadTexture(textureNode, images) {
        const extension = textureNode.FileName.split('.').pop().toLowerCase();
        let loader = this.manager.getHandler(`.${extension}`);
        if (loader === null) loader = this.textureLoader;
        const loaderPath = loader.path;
        if (!loaderPath) loader.setPath(this.textureLoader.path);
        const children = $fa3447b093a231bb$var$connections.get(textureNode.id).children;
        let fileName;
        if (children !== undefined && children.length > 0 && images[children[0].ID] !== undefined) {
            fileName = images[children[0].ID];
            if (fileName.indexOf('blob:') === 0 || fileName.indexOf('data:') === 0) loader.setPath(undefined);
        }
        if (fileName === undefined) {
            console.warn('FBXLoader: Undefined filename, creating placeholder texture.');
            return new (0, $329ek.Texture)();
        }
        const texture = loader.load(fileName);
        // revert to initial path
        loader.setPath(loaderPath);
        return texture;
    }
    // Parse nodes in FBXTree.Objects.Material
    parseMaterials(textureMap) {
        const materialMap = new Map();
        if ('Material' in $fa3447b093a231bb$var$fbxTree.Objects) {
            const materialNodes = $fa3447b093a231bb$var$fbxTree.Objects.Material;
            for(const nodeID in materialNodes){
                const material = this.parseMaterial(materialNodes[nodeID], textureMap);
                if (material !== null) materialMap.set(parseInt(nodeID), material);
            }
        }
        return materialMap;
    }
    // Parse single node in FBXTree.Objects.Material
    // Materials are connected to texture maps in FBXTree.Objects.Textures
    // FBX format currently only supports Lambert and Phong shading models
    parseMaterial(materialNode, textureMap) {
        const ID = materialNode.id;
        const name = materialNode.attrName;
        let type = materialNode.ShadingModel;
        // Case where FBX wraps shading model in property object.
        if (typeof type === 'object') type = type.value;
        // Ignore unused materials which don't have any connections.
        if (!$fa3447b093a231bb$var$connections.has(ID)) return null;
        const parameters = this.parseParameters(materialNode, textureMap, ID);
        let material;
        switch(type.toLowerCase()){
            case 'phong':
                material = new (0, $329ek.MeshPhongMaterial)();
                break;
            case 'lambert':
                material = new (0, $329ek.MeshLambertMaterial)();
                break;
            default:
                console.warn('THREE.FBXLoader: unknown material type "%s". Defaulting to MeshPhongMaterial.', type);
                material = new (0, $329ek.MeshPhongMaterial)();
                break;
        }
        material.setValues(parameters);
        material.name = name;
        return material;
    }
    // Parse FBX material and return parameters suitable for a three.js material
    // Also parse the texture map and return any textures associated with the material
    parseParameters(materialNode, textureMap, ID) {
        const parameters = {};
        if (materialNode.BumpFactor) parameters.bumpScale = materialNode.BumpFactor.value;
        if (materialNode.Diffuse) parameters.color = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(materialNode.Diffuse.value), (0, $329ek.SRGBColorSpace));
        else if (materialNode.DiffuseColor && (materialNode.DiffuseColor.type === 'Color' || materialNode.DiffuseColor.type === 'ColorRGB')) // The blender exporter exports diffuse here instead of in materialNode.Diffuse
        parameters.color = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(materialNode.DiffuseColor.value), (0, $329ek.SRGBColorSpace));
        if (materialNode.DisplacementFactor) parameters.displacementScale = materialNode.DisplacementFactor.value;
        if (materialNode.Emissive) parameters.emissive = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(materialNode.Emissive.value), (0, $329ek.SRGBColorSpace));
        else if (materialNode.EmissiveColor && (materialNode.EmissiveColor.type === 'Color' || materialNode.EmissiveColor.type === 'ColorRGB')) // The blender exporter exports emissive color here instead of in materialNode.Emissive
        parameters.emissive = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(materialNode.EmissiveColor.value), (0, $329ek.SRGBColorSpace));
        if (materialNode.EmissiveFactor) parameters.emissiveIntensity = parseFloat(materialNode.EmissiveFactor.value);
        // the transparency handling is implemented based on Blender/Unity's approach: https://github.com/sobotka/blender-addons/blob/7d80f2f97161fc8e353a657b179b9aa1f8e5280b/io_scene_fbx/import_fbx.py#L1444-L1459
        parameters.opacity = 1 - (materialNode.TransparencyFactor ? parseFloat(materialNode.TransparencyFactor.value) : 0);
        if (parameters.opacity === 1 || parameters.opacity === 0) {
            parameters.opacity = materialNode.Opacity ? parseFloat(materialNode.Opacity.value) : null;
            if (parameters.opacity === null) parameters.opacity = 1 - (materialNode.TransparentColor ? parseFloat(materialNode.TransparentColor.value[0]) : 0);
        }
        if (parameters.opacity < 1.0) parameters.transparent = true;
        if (materialNode.ReflectionFactor) parameters.reflectivity = materialNode.ReflectionFactor.value;
        if (materialNode.Shininess) parameters.shininess = materialNode.Shininess.value;
        if (materialNode.Specular) parameters.specular = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(materialNode.Specular.value), (0, $329ek.SRGBColorSpace));
        else if (materialNode.SpecularColor && materialNode.SpecularColor.type === 'Color') // The blender exporter exports specular color here instead of in materialNode.Specular
        parameters.specular = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(materialNode.SpecularColor.value), (0, $329ek.SRGBColorSpace));
        const scope = this;
        $fa3447b093a231bb$var$connections.get(ID).children.forEach(function(child) {
            const type = child.relationship;
            switch(type){
                case 'Bump':
                    parameters.bumpMap = scope.getTexture(textureMap, child.ID);
                    break;
                case 'Maya|TEX_ao_map':
                    parameters.aoMap = scope.getTexture(textureMap, child.ID);
                    break;
                case 'DiffuseColor':
                case 'Maya|TEX_color_map':
                    parameters.map = scope.getTexture(textureMap, child.ID);
                    if (parameters.map !== undefined) parameters.map.colorSpace = (0, $329ek.SRGBColorSpace);
                    break;
                case 'DisplacementColor':
                    parameters.displacementMap = scope.getTexture(textureMap, child.ID);
                    break;
                case 'EmissiveColor':
                    parameters.emissiveMap = scope.getTexture(textureMap, child.ID);
                    if (parameters.emissiveMap !== undefined) parameters.emissiveMap.colorSpace = (0, $329ek.SRGBColorSpace);
                    break;
                case 'NormalMap':
                case 'Maya|TEX_normal_map':
                    parameters.normalMap = scope.getTexture(textureMap, child.ID);
                    break;
                case 'ReflectionColor':
                    parameters.envMap = scope.getTexture(textureMap, child.ID);
                    if (parameters.envMap !== undefined) {
                        parameters.envMap.mapping = (0, $329ek.EquirectangularReflectionMapping);
                        parameters.envMap.colorSpace = (0, $329ek.SRGBColorSpace);
                    }
                    break;
                case 'SpecularColor':
                    parameters.specularMap = scope.getTexture(textureMap, child.ID);
                    if (parameters.specularMap !== undefined) parameters.specularMap.colorSpace = (0, $329ek.SRGBColorSpace);
                    break;
                case 'TransparentColor':
                case 'TransparencyFactor':
                    parameters.alphaMap = scope.getTexture(textureMap, child.ID);
                    parameters.transparent = true;
                    break;
                case 'AmbientColor':
                case 'ShininessExponent':
                case 'SpecularFactor':
                case 'VectorDisplacementColor':
                default:
                    console.warn('THREE.FBXLoader: %s map is not supported in three.js, skipping texture.', type);
                    break;
            }
        });
        return parameters;
    }
    // get a texture from the textureMap for use by a material.
    getTexture(textureMap, id) {
        // if the texture is a layered texture, just use the first layer and issue a warning
        if ('LayeredTexture' in $fa3447b093a231bb$var$fbxTree.Objects && id in $fa3447b093a231bb$var$fbxTree.Objects.LayeredTexture) {
            console.warn('THREE.FBXLoader: layered textures are not supported in three.js. Discarding all but first layer.');
            id = $fa3447b093a231bb$var$connections.get(id).children[0].ID;
        }
        return textureMap.get(id);
    }
    // Parse nodes in FBXTree.Objects.Deformer
    // Deformer node can contain skinning or Vertex Cache animation data, however only skinning is supported here
    // Generates map of Skeleton-like objects for use later when generating and binding skeletons.
    parseDeformers() {
        const skeletons = {};
        const morphTargets = {};
        if ('Deformer' in $fa3447b093a231bb$var$fbxTree.Objects) {
            const DeformerNodes = $fa3447b093a231bb$var$fbxTree.Objects.Deformer;
            for(const nodeID in DeformerNodes){
                const deformerNode = DeformerNodes[nodeID];
                const relationships = $fa3447b093a231bb$var$connections.get(parseInt(nodeID));
                if (deformerNode.attrType === 'Skin') {
                    const skeleton = this.parseSkeleton(relationships, DeformerNodes);
                    skeleton.ID = nodeID;
                    if (relationships.parents.length > 1) console.warn('THREE.FBXLoader: skeleton attached to more than one geometry is not supported.');
                    skeleton.geometryID = relationships.parents[0].ID;
                    skeletons[nodeID] = skeleton;
                } else if (deformerNode.attrType === 'BlendShape') {
                    const morphTarget = {
                        id: nodeID
                    };
                    morphTarget.rawTargets = this.parseMorphTargets(relationships, DeformerNodes);
                    morphTarget.id = nodeID;
                    if (relationships.parents.length > 1) console.warn('THREE.FBXLoader: morph target attached to more than one geometry is not supported.');
                    morphTargets[nodeID] = morphTarget;
                }
            }
        }
        return {
            skeletons: skeletons,
            morphTargets: morphTargets
        };
    }
    // Parse single nodes in FBXTree.Objects.Deformer
    // The top level skeleton node has type 'Skin' and sub nodes have type 'Cluster'
    // Each skin node represents a skeleton and each cluster node represents a bone
    parseSkeleton(relationships, deformerNodes) {
        const rawBones = [];
        relationships.children.forEach(function(child) {
            const boneNode = deformerNodes[child.ID];
            if (boneNode.attrType !== 'Cluster') return;
            const rawBone = {
                ID: child.ID,
                indices: [],
                weights: [],
                transformLink: new (0, $329ek.Matrix4)().fromArray(boneNode.TransformLink.a)
            };
            if ('Indexes' in boneNode) {
                rawBone.indices = boneNode.Indexes.a;
                rawBone.weights = boneNode.Weights.a;
            }
            rawBones.push(rawBone);
        });
        return {
            rawBones: rawBones,
            bones: []
        };
    }
    // The top level morph deformer node has type "BlendShape" and sub nodes have type "BlendShapeChannel"
    parseMorphTargets(relationships, deformerNodes) {
        const rawMorphTargets = [];
        for(let i = 0; i < relationships.children.length; i++){
            const child = relationships.children[i];
            const morphTargetNode = deformerNodes[child.ID];
            const rawMorphTarget = {
                name: morphTargetNode.attrName,
                initialWeight: morphTargetNode.DeformPercent,
                id: morphTargetNode.id,
                fullWeights: morphTargetNode.FullWeights.a
            };
            if (morphTargetNode.attrType !== 'BlendShapeChannel') return;
            rawMorphTarget.geoID = $fa3447b093a231bb$var$connections.get(parseInt(child.ID)).children.filter(function(child) {
                return child.relationship === undefined;
            })[0].ID;
            rawMorphTargets.push(rawMorphTarget);
        }
        return rawMorphTargets;
    }
    // create the main Group() to be returned by the loader
    parseScene(deformers, geometryMap, materialMap) {
        $fa3447b093a231bb$var$sceneGraph = new (0, $329ek.Group)();
        const modelMap = this.parseModels(deformers.skeletons, geometryMap, materialMap);
        const modelNodes = $fa3447b093a231bb$var$fbxTree.Objects.Model;
        const scope = this;
        modelMap.forEach(function(model) {
            const modelNode = modelNodes[model.ID];
            scope.setLookAtProperties(model, modelNode);
            const parentConnections = $fa3447b093a231bb$var$connections.get(model.ID).parents;
            parentConnections.forEach(function(connection) {
                const parent = modelMap.get(connection.ID);
                if (parent !== undefined) parent.add(model);
            });
            if (model.parent === null) $fa3447b093a231bb$var$sceneGraph.add(model);
        });
        this.bindSkeleton(deformers.skeletons, geometryMap, modelMap);
        this.addGlobalSceneSettings();
        $fa3447b093a231bb$var$sceneGraph.traverse(function(node) {
            if (node.userData.transformData) {
                if (node.parent) {
                    node.userData.transformData.parentMatrix = node.parent.matrix;
                    node.userData.transformData.parentMatrixWorld = node.parent.matrixWorld;
                }
                const transform = $fa3447b093a231bb$var$generateTransform(node.userData.transformData);
                node.applyMatrix4(transform);
                node.updateWorldMatrix();
            }
        });
        const animations = new $fa3447b093a231bb$var$AnimationParser().parse();
        // if all the models where already combined in a single group, just return that
        if ($fa3447b093a231bb$var$sceneGraph.children.length === 1 && $fa3447b093a231bb$var$sceneGraph.children[0].isGroup) {
            $fa3447b093a231bb$var$sceneGraph.children[0].animations = animations;
            $fa3447b093a231bb$var$sceneGraph = $fa3447b093a231bb$var$sceneGraph.children[0];
        }
        $fa3447b093a231bb$var$sceneGraph.animations = animations;
    }
    // parse nodes in FBXTree.Objects.Model
    parseModels(skeletons, geometryMap, materialMap) {
        const modelMap = new Map();
        const modelNodes = $fa3447b093a231bb$var$fbxTree.Objects.Model;
        for(const nodeID in modelNodes){
            const id = parseInt(nodeID);
            const node = modelNodes[nodeID];
            const relationships = $fa3447b093a231bb$var$connections.get(id);
            let model = this.buildSkeleton(relationships, skeletons, id, node.attrName);
            if (!model) {
                switch(node.attrType){
                    case 'Camera':
                        model = this.createCamera(relationships);
                        break;
                    case 'Light':
                        model = this.createLight(relationships);
                        break;
                    case 'Mesh':
                        model = this.createMesh(relationships, geometryMap, materialMap);
                        break;
                    case 'NurbsCurve':
                        model = this.createCurve(relationships, geometryMap);
                        break;
                    case 'LimbNode':
                    case 'Root':
                        model = new (0, $329ek.Bone)();
                        break;
                    case 'Null':
                    default:
                        model = new (0, $329ek.Group)();
                        break;
                }
                model.name = node.attrName ? (0, $329ek.PropertyBinding).sanitizeNodeName(node.attrName) : '';
                model.userData.originalName = node.attrName;
                model.ID = id;
            }
            this.getTransformData(model, node);
            modelMap.set(id, model);
        }
        return modelMap;
    }
    buildSkeleton(relationships, skeletons, id, name) {
        let bone = null;
        relationships.parents.forEach(function(parent) {
            for(const ID in skeletons){
                const skeleton = skeletons[ID];
                skeleton.rawBones.forEach(function(rawBone, i) {
                    if (rawBone.ID === parent.ID) {
                        const subBone = bone;
                        bone = new (0, $329ek.Bone)();
                        bone.matrixWorld.copy(rawBone.transformLink);
                        // set name and id here - otherwise in cases where "subBone" is created it will not have a name / id
                        bone.name = name ? (0, $329ek.PropertyBinding).sanitizeNodeName(name) : '';
                        bone.userData.originalName = name;
                        bone.ID = id;
                        skeleton.bones[i] = bone;
                        // In cases where a bone is shared between multiple meshes
                        // duplicate the bone here and add it as a child of the first bone
                        if (subBone !== null) bone.add(subBone);
                    }
                });
            }
        });
        return bone;
    }
    // create a PerspectiveCamera or OrthographicCamera
    createCamera(relationships) {
        let model;
        let cameraAttribute;
        relationships.children.forEach(function(child) {
            const attr = $fa3447b093a231bb$var$fbxTree.Objects.NodeAttribute[child.ID];
            if (attr !== undefined) cameraAttribute = attr;
        });
        if (cameraAttribute === undefined) model = new (0, $329ek.Object3D)();
        else {
            let type = 0;
            if (cameraAttribute.CameraProjectionType !== undefined && cameraAttribute.CameraProjectionType.value === 1) type = 1;
            let nearClippingPlane = 1;
            if (cameraAttribute.NearPlane !== undefined) nearClippingPlane = cameraAttribute.NearPlane.value / 1000;
            let farClippingPlane = 1000;
            if (cameraAttribute.FarPlane !== undefined) farClippingPlane = cameraAttribute.FarPlane.value / 1000;
            let width = window.innerWidth;
            let height = window.innerHeight;
            if (cameraAttribute.AspectWidth !== undefined && cameraAttribute.AspectHeight !== undefined) {
                width = cameraAttribute.AspectWidth.value;
                height = cameraAttribute.AspectHeight.value;
            }
            const aspect = width / height;
            let fov = 45;
            if (cameraAttribute.FieldOfView !== undefined) fov = cameraAttribute.FieldOfView.value;
            const focalLength = cameraAttribute.FocalLength ? cameraAttribute.FocalLength.value : null;
            switch(type){
                case 0:
                    model = new (0, $329ek.PerspectiveCamera)(fov, aspect, nearClippingPlane, farClippingPlane);
                    if (focalLength !== null) model.setFocalLength(focalLength);
                    break;
                case 1:
                    console.warn('THREE.FBXLoader: Orthographic cameras not supported yet.');
                    model = new (0, $329ek.Object3D)();
                    break;
                default:
                    console.warn('THREE.FBXLoader: Unknown camera type ' + type + '.');
                    model = new (0, $329ek.Object3D)();
                    break;
            }
        }
        return model;
    }
    // Create a DirectionalLight, PointLight or SpotLight
    createLight(relationships) {
        let model;
        let lightAttribute;
        relationships.children.forEach(function(child) {
            const attr = $fa3447b093a231bb$var$fbxTree.Objects.NodeAttribute[child.ID];
            if (attr !== undefined) lightAttribute = attr;
        });
        if (lightAttribute === undefined) model = new (0, $329ek.Object3D)();
        else {
            let type;
            // LightType can be undefined for Point lights
            if (lightAttribute.LightType === undefined) type = 0;
            else type = lightAttribute.LightType.value;
            let color = 0xffffff;
            if (lightAttribute.Color !== undefined) color = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(lightAttribute.Color.value), (0, $329ek.SRGBColorSpace));
            let intensity = lightAttribute.Intensity === undefined ? 1 : lightAttribute.Intensity.value / 100;
            // light disabled
            if (lightAttribute.CastLightOnObject !== undefined && lightAttribute.CastLightOnObject.value === 0) intensity = 0;
            let distance = 0;
            if (lightAttribute.FarAttenuationEnd !== undefined) {
                if (lightAttribute.EnableFarAttenuation !== undefined && lightAttribute.EnableFarAttenuation.value === 0) distance = 0;
                else distance = lightAttribute.FarAttenuationEnd.value;
            }
            // TODO: could this be calculated linearly from FarAttenuationStart to FarAttenuationEnd?
            const decay = 1;
            switch(type){
                case 0:
                    model = new (0, $329ek.PointLight)(color, intensity, distance, decay);
                    break;
                case 1:
                    model = new (0, $329ek.DirectionalLight)(color, intensity);
                    break;
                case 2:
                    let angle = Math.PI / 3;
                    if (lightAttribute.InnerAngle !== undefined) angle = (0, $329ek.MathUtils).degToRad(lightAttribute.InnerAngle.value);
                    let penumbra = 0;
                    if (lightAttribute.OuterAngle !== undefined) {
                        // TODO: this is not correct - FBX calculates outer and inner angle in degrees
                        // with OuterAngle > InnerAngle && OuterAngle <= Math.PI
                        // while three.js uses a penumbra between (0, 1) to attenuate the inner angle
                        penumbra = (0, $329ek.MathUtils).degToRad(lightAttribute.OuterAngle.value);
                        penumbra = Math.max(penumbra, 1);
                    }
                    model = new (0, $329ek.SpotLight)(color, intensity, distance, angle, penumbra, decay);
                    break;
                default:
                    console.warn('THREE.FBXLoader: Unknown light type ' + lightAttribute.LightType.value + ', defaulting to a PointLight.');
                    model = new (0, $329ek.PointLight)(color, intensity);
                    break;
            }
            if (lightAttribute.CastShadows !== undefined && lightAttribute.CastShadows.value === 1) model.castShadow = true;
        }
        return model;
    }
    createMesh(relationships, geometryMap, materialMap) {
        let model;
        let geometry = null;
        let material = null;
        const materials = [];
        // get geometry and materials(s) from connections
        relationships.children.forEach(function(child) {
            if (geometryMap.has(child.ID)) geometry = geometryMap.get(child.ID);
            if (materialMap.has(child.ID)) materials.push(materialMap.get(child.ID));
        });
        if (materials.length > 1) material = materials;
        else if (materials.length > 0) material = materials[0];
        else {
            material = new (0, $329ek.MeshPhongMaterial)({
                name: (0, $329ek.Loader).DEFAULT_MATERIAL_NAME,
                color: 0xcccccc
            });
            materials.push(material);
        }
        if ('color' in geometry.attributes) materials.forEach(function(material) {
            material.vertexColors = true;
        });
        // Sanitization: If geometry has groups, then it must match the provided material array.
        // If not, we need to clean up the `group.materialIndex` properties inside the groups and point at a (new) default material.
        // This isn't well defined; Unity creates default material, while Blender implicitly uses the previous material in the list.
        if (geometry.groups.length > 0) {
            let needsDefaultMaterial = false;
            for(let i = 0, il = geometry.groups.length; i < il; i++){
                const group = geometry.groups[i];
                if (group.materialIndex < 0 || group.materialIndex >= materials.length) {
                    group.materialIndex = materials.length;
                    needsDefaultMaterial = true;
                }
            }
            if (needsDefaultMaterial) {
                const defaultMaterial = new (0, $329ek.MeshPhongMaterial)();
                materials.push(defaultMaterial);
            }
        }
        if (geometry.FBX_Deformer) {
            model = new (0, $329ek.SkinnedMesh)(geometry, material);
            model.normalizeSkinWeights();
        } else model = new (0, $329ek.Mesh)(geometry, material);
        return model;
    }
    createCurve(relationships, geometryMap) {
        const geometry = relationships.children.reduce(function(geo, child) {
            if (geometryMap.has(child.ID)) geo = geometryMap.get(child.ID);
            return geo;
        }, null);
        // FBX does not list materials for Nurbs lines, so we'll just put our own in here.
        const material = new (0, $329ek.LineBasicMaterial)({
            name: (0, $329ek.Loader).DEFAULT_MATERIAL_NAME,
            color: 0x3300ff,
            linewidth: 1
        });
        return new (0, $329ek.Line)(geometry, material);
    }
    // parse the model node for transform data
    getTransformData(model, modelNode) {
        const transformData = {};
        if ('InheritType' in modelNode) transformData.inheritType = parseInt(modelNode.InheritType.value);
        if ('RotationOrder' in modelNode) transformData.eulerOrder = $fa3447b093a231bb$var$getEulerOrder(modelNode.RotationOrder.value);
        else transformData.eulerOrder = $fa3447b093a231bb$var$getEulerOrder(0);
        if ('Lcl_Translation' in modelNode) transformData.translation = modelNode.Lcl_Translation.value;
        if ('PreRotation' in modelNode) transformData.preRotation = modelNode.PreRotation.value;
        if ('Lcl_Rotation' in modelNode) transformData.rotation = modelNode.Lcl_Rotation.value;
        if ('PostRotation' in modelNode) transformData.postRotation = modelNode.PostRotation.value;
        if ('Lcl_Scaling' in modelNode) transformData.scale = modelNode.Lcl_Scaling.value;
        if ('ScalingOffset' in modelNode) transformData.scalingOffset = modelNode.ScalingOffset.value;
        if ('ScalingPivot' in modelNode) transformData.scalingPivot = modelNode.ScalingPivot.value;
        if ('RotationOffset' in modelNode) transformData.rotationOffset = modelNode.RotationOffset.value;
        if ('RotationPivot' in modelNode) transformData.rotationPivot = modelNode.RotationPivot.value;
        model.userData.transformData = transformData;
    }
    setLookAtProperties(model, modelNode) {
        if ('LookAtProperty' in modelNode) {
            const children = $fa3447b093a231bb$var$connections.get(model.ID).children;
            children.forEach(function(child) {
                if (child.relationship === 'LookAtProperty') {
                    const lookAtTarget = $fa3447b093a231bb$var$fbxTree.Objects.Model[child.ID];
                    if ('Lcl_Translation' in lookAtTarget) {
                        const pos = lookAtTarget.Lcl_Translation.value;
                        // DirectionalLight, SpotLight
                        if (model.target !== undefined) {
                            model.target.position.fromArray(pos);
                            $fa3447b093a231bb$var$sceneGraph.add(model.target);
                        } else model.lookAt(new (0, $329ek.Vector3)().fromArray(pos));
                    }
                }
            });
        }
    }
    bindSkeleton(skeletons, geometryMap, modelMap) {
        const bindMatrices = this.parsePoseNodes();
        for(const ID in skeletons){
            const skeleton = skeletons[ID];
            const parents = $fa3447b093a231bb$var$connections.get(parseInt(skeleton.ID)).parents;
            parents.forEach(function(parent) {
                if (geometryMap.has(parent.ID)) {
                    const geoID = parent.ID;
                    const geoRelationships = $fa3447b093a231bb$var$connections.get(geoID);
                    geoRelationships.parents.forEach(function(geoConnParent) {
                        if (modelMap.has(geoConnParent.ID)) {
                            const model = modelMap.get(geoConnParent.ID);
                            model.bind(new (0, $329ek.Skeleton)(skeleton.bones), bindMatrices[geoConnParent.ID]);
                        }
                    });
                }
            });
        }
    }
    parsePoseNodes() {
        const bindMatrices = {};
        if ('Pose' in $fa3447b093a231bb$var$fbxTree.Objects) {
            const BindPoseNode = $fa3447b093a231bb$var$fbxTree.Objects.Pose;
            for(const nodeID in BindPoseNode)if (BindPoseNode[nodeID].attrType === 'BindPose' && BindPoseNode[nodeID].NbPoseNodes > 0) {
                const poseNodes = BindPoseNode[nodeID].PoseNode;
                if (Array.isArray(poseNodes)) poseNodes.forEach(function(poseNode) {
                    bindMatrices[poseNode.Node] = new (0, $329ek.Matrix4)().fromArray(poseNode.Matrix.a);
                });
                else bindMatrices[poseNodes.Node] = new (0, $329ek.Matrix4)().fromArray(poseNodes.Matrix.a);
            }
        }
        return bindMatrices;
    }
    addGlobalSceneSettings() {
        if ('GlobalSettings' in $fa3447b093a231bb$var$fbxTree) {
            if ('AmbientColor' in $fa3447b093a231bb$var$fbxTree.GlobalSettings) {
                // Parse ambient color - if it's not set to black (default), create an ambient light
                const ambientColor = $fa3447b093a231bb$var$fbxTree.GlobalSettings.AmbientColor.value;
                const r = ambientColor[0];
                const g = ambientColor[1];
                const b = ambientColor[2];
                if (r !== 0 || g !== 0 || b !== 0) {
                    const color = new (0, $329ek.Color)().setRGB(r, g, b, (0, $329ek.SRGBColorSpace));
                    $fa3447b093a231bb$var$sceneGraph.add(new (0, $329ek.AmbientLight)(color, 1));
                }
            }
            if ('UnitScaleFactor' in $fa3447b093a231bb$var$fbxTree.GlobalSettings) $fa3447b093a231bb$var$sceneGraph.userData.unitScaleFactor = $fa3447b093a231bb$var$fbxTree.GlobalSettings.UnitScaleFactor.value;
        }
    }
}
// parse Geometry data from FBXTree and return map of BufferGeometries
class $fa3447b093a231bb$var$GeometryParser {
    constructor(){
        this.negativeMaterialIndices = false;
    }
    // Parse nodes in FBXTree.Objects.Geometry
    parse(deformers) {
        const geometryMap = new Map();
        if ('Geometry' in $fa3447b093a231bb$var$fbxTree.Objects) {
            const geoNodes = $fa3447b093a231bb$var$fbxTree.Objects.Geometry;
            for(const nodeID in geoNodes){
                const relationships = $fa3447b093a231bb$var$connections.get(parseInt(nodeID));
                const geo = this.parseGeometry(relationships, geoNodes[nodeID], deformers);
                geometryMap.set(parseInt(nodeID), geo);
            }
        }
        // report warnings
        if (this.negativeMaterialIndices === true) console.warn('THREE.FBXLoader: The FBX file contains invalid (negative) material indices. The asset might not render as expected.');
        return geometryMap;
    }
    // Parse single node in FBXTree.Objects.Geometry
    parseGeometry(relationships, geoNode, deformers) {
        switch(geoNode.attrType){
            case 'Mesh':
                return this.parseMeshGeometry(relationships, geoNode, deformers);
            case 'NurbsCurve':
                return this.parseNurbsGeometry(geoNode);
        }
    }
    // Parse single node mesh geometry in FBXTree.Objects.Geometry
    parseMeshGeometry(relationships, geoNode, deformers) {
        const skeletons = deformers.skeletons;
        const morphTargets = [];
        const modelNodes = relationships.parents.map(function(parent) {
            return $fa3447b093a231bb$var$fbxTree.Objects.Model[parent.ID];
        });
        // don't create geometry if it is not associated with any models
        if (modelNodes.length === 0) return;
        const skeleton = relationships.children.reduce(function(skeleton, child) {
            if (skeletons[child.ID] !== undefined) skeleton = skeletons[child.ID];
            return skeleton;
        }, null);
        relationships.children.forEach(function(child) {
            if (deformers.morphTargets[child.ID] !== undefined) morphTargets.push(deformers.morphTargets[child.ID]);
        });
        // Assume one model and get the preRotation from that
        // if there is more than one model associated with the geometry this may cause problems
        const modelNode = modelNodes[0];
        const transformData = {};
        if ('RotationOrder' in modelNode) transformData.eulerOrder = $fa3447b093a231bb$var$getEulerOrder(modelNode.RotationOrder.value);
        if ('InheritType' in modelNode) transformData.inheritType = parseInt(modelNode.InheritType.value);
        if ('GeometricTranslation' in modelNode) transformData.translation = modelNode.GeometricTranslation.value;
        if ('GeometricRotation' in modelNode) transformData.rotation = modelNode.GeometricRotation.value;
        if ('GeometricScaling' in modelNode) transformData.scale = modelNode.GeometricScaling.value;
        const transform = $fa3447b093a231bb$var$generateTransform(transformData);
        return this.genGeometry(geoNode, skeleton, morphTargets, transform);
    }
    // Generate a BufferGeometry from a node in FBXTree.Objects.Geometry
    genGeometry(geoNode, skeleton, morphTargets, preTransform) {
        const geo = new (0, $329ek.BufferGeometry)();
        if (geoNode.attrName) geo.name = geoNode.attrName;
        const geoInfo = this.parseGeoNode(geoNode, skeleton);
        const buffers = this.genBuffers(geoInfo);
        const positionAttribute = new (0, $329ek.Float32BufferAttribute)(buffers.vertex, 3);
        positionAttribute.applyMatrix4(preTransform);
        geo.setAttribute('position', positionAttribute);
        if (buffers.colors.length > 0) geo.setAttribute('color', new (0, $329ek.Float32BufferAttribute)(buffers.colors, 3));
        if (skeleton) {
            geo.setAttribute('skinIndex', new (0, $329ek.Uint16BufferAttribute)(buffers.weightsIndices, 4));
            geo.setAttribute('skinWeight', new (0, $329ek.Float32BufferAttribute)(buffers.vertexWeights, 4));
            // used later to bind the skeleton to the model
            geo.FBX_Deformer = skeleton;
        }
        if (buffers.normal.length > 0) {
            const normalMatrix = new (0, $329ek.Matrix3)().getNormalMatrix(preTransform);
            const normalAttribute = new (0, $329ek.Float32BufferAttribute)(buffers.normal, 3);
            normalAttribute.applyNormalMatrix(normalMatrix);
            geo.setAttribute('normal', normalAttribute);
        }
        buffers.uvs.forEach(function(uvBuffer, i) {
            const name = i === 0 ? 'uv' : `uv${i}`;
            geo.setAttribute(name, new (0, $329ek.Float32BufferAttribute)(buffers.uvs[i], 2));
        });
        if (geoInfo.material && geoInfo.material.mappingType !== 'AllSame') {
            // Convert the material indices of each vertex into rendering groups on the geometry.
            let prevMaterialIndex = buffers.materialIndex[0];
            let startIndex = 0;
            buffers.materialIndex.forEach(function(currentIndex, i) {
                if (currentIndex !== prevMaterialIndex) {
                    geo.addGroup(startIndex, i - startIndex, prevMaterialIndex);
                    prevMaterialIndex = currentIndex;
                    startIndex = i;
                }
            });
            // the loop above doesn't add the last group, do that here.
            if (geo.groups.length > 0) {
                const lastGroup = geo.groups[geo.groups.length - 1];
                const lastIndex = lastGroup.start + lastGroup.count;
                if (lastIndex !== buffers.materialIndex.length) geo.addGroup(lastIndex, buffers.materialIndex.length - lastIndex, prevMaterialIndex);
            }
            // case where there are multiple materials but the whole geometry is only
            // using one of them
            if (geo.groups.length === 0) geo.addGroup(0, buffers.materialIndex.length, buffers.materialIndex[0]);
        }
        this.addMorphTargets(geo, geoNode, morphTargets, preTransform);
        return geo;
    }
    parseGeoNode(geoNode, skeleton) {
        const geoInfo = {};
        geoInfo.vertexPositions = geoNode.Vertices !== undefined ? geoNode.Vertices.a : [];
        geoInfo.vertexIndices = geoNode.PolygonVertexIndex !== undefined ? geoNode.PolygonVertexIndex.a : [];
        if (geoNode.LayerElementColor && geoNode.LayerElementColor[0].Colors) geoInfo.color = this.parseVertexColors(geoNode.LayerElementColor[0]);
        if (geoNode.LayerElementMaterial) geoInfo.material = this.parseMaterialIndices(geoNode.LayerElementMaterial[0]);
        if (geoNode.LayerElementNormal) geoInfo.normal = this.parseNormals(geoNode.LayerElementNormal[0]);
        if (geoNode.LayerElementUV) {
            geoInfo.uv = [];
            let i = 0;
            while(geoNode.LayerElementUV[i]){
                if (geoNode.LayerElementUV[i].UV) geoInfo.uv.push(this.parseUVs(geoNode.LayerElementUV[i]));
                i++;
            }
        }
        geoInfo.weightTable = {};
        if (skeleton !== null) {
            geoInfo.skeleton = skeleton;
            skeleton.rawBones.forEach(function(rawBone, i) {
                // loop over the bone's vertex indices and weights
                rawBone.indices.forEach(function(index, j) {
                    if (geoInfo.weightTable[index] === undefined) geoInfo.weightTable[index] = [];
                    geoInfo.weightTable[index].push({
                        id: i,
                        weight: rawBone.weights[j]
                    });
                });
            });
        }
        return geoInfo;
    }
    genBuffers(geoInfo) {
        const buffers = {
            vertex: [],
            normal: [],
            colors: [],
            uvs: [],
            materialIndex: [],
            vertexWeights: [],
            weightsIndices: []
        };
        let polygonIndex = 0;
        let faceLength = 0;
        let displayedWeightsWarning = false;
        // these will hold data for a single face
        let facePositionIndexes = [];
        let faceNormals = [];
        let faceColors = [];
        let faceUVs = [];
        let faceWeights = [];
        let faceWeightIndices = [];
        const scope = this;
        geoInfo.vertexIndices.forEach(function(vertexIndex, polygonVertexIndex) {
            let materialIndex;
            let endOfFace = false;
            // Face index and vertex index arrays are combined in a single array
            // A cube with quad faces looks like this:
            // PolygonVertexIndex: *24 {
            //  a: 0, 1, 3, -3, 2, 3, 5, -5, 4, 5, 7, -7, 6, 7, 1, -1, 1, 7, 5, -4, 6, 0, 2, -5
            //  }
            // Negative numbers mark the end of a face - first face here is 0, 1, 3, -3
            // to find index of last vertex bit shift the index: ^ - 1
            if (vertexIndex < 0) {
                vertexIndex = vertexIndex ^ -1; // equivalent to ( x * -1 ) - 1
                endOfFace = true;
            }
            let weightIndices = [];
            let weights = [];
            facePositionIndexes.push(vertexIndex * 3, vertexIndex * 3 + 1, vertexIndex * 3 + 2);
            if (geoInfo.color) {
                const data = $fa3447b093a231bb$var$getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.color);
                faceColors.push(data[0], data[1], data[2]);
            }
            if (geoInfo.skeleton) {
                if (geoInfo.weightTable[vertexIndex] !== undefined) geoInfo.weightTable[vertexIndex].forEach(function(wt) {
                    weights.push(wt.weight);
                    weightIndices.push(wt.id);
                });
                if (weights.length > 4) {
                    if (!displayedWeightsWarning) {
                        console.warn('THREE.FBXLoader: Vertex has more than 4 skinning weights assigned to vertex. Deleting additional weights.');
                        displayedWeightsWarning = true;
                    }
                    const wIndex = [
                        0,
                        0,
                        0,
                        0
                    ];
                    const Weight = [
                        0,
                        0,
                        0,
                        0
                    ];
                    weights.forEach(function(weight, weightIndex) {
                        let currentWeight = weight;
                        let currentIndex = weightIndices[weightIndex];
                        Weight.forEach(function(comparedWeight, comparedWeightIndex, comparedWeightArray) {
                            if (currentWeight > comparedWeight) {
                                comparedWeightArray[comparedWeightIndex] = currentWeight;
                                currentWeight = comparedWeight;
                                const tmp = wIndex[comparedWeightIndex];
                                wIndex[comparedWeightIndex] = currentIndex;
                                currentIndex = tmp;
                            }
                        });
                    });
                    weightIndices = wIndex;
                    weights = Weight;
                }
                // if the weight array is shorter than 4 pad with 0s
                while(weights.length < 4){
                    weights.push(0);
                    weightIndices.push(0);
                }
                for(let i = 0; i < 4; ++i){
                    faceWeights.push(weights[i]);
                    faceWeightIndices.push(weightIndices[i]);
                }
            }
            if (geoInfo.normal) {
                const data = $fa3447b093a231bb$var$getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.normal);
                faceNormals.push(data[0], data[1], data[2]);
            }
            if (geoInfo.material && geoInfo.material.mappingType !== 'AllSame') {
                materialIndex = $fa3447b093a231bb$var$getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.material)[0];
                if (materialIndex < 0) {
                    scope.negativeMaterialIndices = true;
                    materialIndex = 0; // fallback
                }
            }
            if (geoInfo.uv) geoInfo.uv.forEach(function(uv, i) {
                const data = $fa3447b093a231bb$var$getData(polygonVertexIndex, polygonIndex, vertexIndex, uv);
                if (faceUVs[i] === undefined) faceUVs[i] = [];
                faceUVs[i].push(data[0]);
                faceUVs[i].push(data[1]);
            });
            faceLength++;
            if (endOfFace) {
                scope.genFace(buffers, geoInfo, facePositionIndexes, materialIndex, faceNormals, faceColors, faceUVs, faceWeights, faceWeightIndices, faceLength);
                polygonIndex++;
                faceLength = 0;
                // reset arrays for the next face
                facePositionIndexes = [];
                faceNormals = [];
                faceColors = [];
                faceUVs = [];
                faceWeights = [];
                faceWeightIndices = [];
            }
        });
        return buffers;
    }
    // See https://www.khronos.org/opengl/wiki/Calculating_a_Surface_Normal
    getNormalNewell(vertices) {
        const normal = new (0, $329ek.Vector3)(0.0, 0.0, 0.0);
        for(let i = 0; i < vertices.length; i++){
            const current = vertices[i];
            const next = vertices[(i + 1) % vertices.length];
            normal.x += (current.y - next.y) * (current.z + next.z);
            normal.y += (current.z - next.z) * (current.x + next.x);
            normal.z += (current.x - next.x) * (current.y + next.y);
        }
        normal.normalize();
        return normal;
    }
    getNormalTangentAndBitangent(vertices) {
        const normalVector = this.getNormalNewell(vertices);
        // Avoid up being equal or almost equal to normalVector
        const up = Math.abs(normalVector.z) > 0.5 ? new (0, $329ek.Vector3)(0.0, 1.0, 0.0) : new (0, $329ek.Vector3)(0.0, 0.0, 1.0);
        const tangent = up.cross(normalVector).normalize();
        const bitangent = normalVector.clone().cross(tangent).normalize();
        return {
            normal: normalVector,
            tangent: tangent,
            bitangent: bitangent
        };
    }
    flattenVertex(vertex, normalTangent, normalBitangent) {
        return new (0, $329ek.Vector2)(vertex.dot(normalTangent), vertex.dot(normalBitangent));
    }
    // Generate data for a single face in a geometry. If the face is a quad then split it into 2 tris
    genFace(buffers, geoInfo, facePositionIndexes, materialIndex, faceNormals, faceColors, faceUVs, faceWeights, faceWeightIndices, faceLength) {
        let triangles;
        if (faceLength > 3) {
            // Triangulate n-gon using earcut
            const vertices = [];
            // in morphing scenario vertexPositions represent morphPositions
            // while baseVertexPositions represent the original geometry's positions
            const positions = geoInfo.baseVertexPositions || geoInfo.vertexPositions;
            for(let i = 0; i < facePositionIndexes.length; i += 3)vertices.push(new (0, $329ek.Vector3)(positions[facePositionIndexes[i]], positions[facePositionIndexes[i + 1]], positions[facePositionIndexes[i + 2]]));
            const { tangent: tangent, bitangent: bitangent } = this.getNormalTangentAndBitangent(vertices);
            const triangulationInput = [];
            for (const vertex of vertices)triangulationInput.push(this.flattenVertex(vertex, tangent, bitangent));
            // When vertices is an array of [0,0,0] elements (which is the case for vertices not participating in morph)
            // the triangulationInput will be an array of [0,0] elements
            // resulting in an array of 0 triangles being returned from ShapeUtils.triangulateShape
            // leading to not pushing into buffers.vertex the redundant vertices (the vertices that are not morphed).
            // That's why, in order to support morphing scenario, "positions" is looking first for baseVertexPositions,
            // so that we don't end up with an array of 0 triangles for the faces not participating in morph.
            triangles = (0, $329ek.ShapeUtils).triangulateShape(triangulationInput, []);
        } else // Regular triangle, skip earcut triangulation step
        triangles = [
            [
                0,
                1,
                2
            ]
        ];
        for (const [i0, i1, i2] of triangles){
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i0 * 3]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i0 * 3 + 1]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i0 * 3 + 2]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i1 * 3]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i1 * 3 + 1]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i1 * 3 + 2]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i2 * 3]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i2 * 3 + 1]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i2 * 3 + 2]]);
            if (geoInfo.skeleton) {
                buffers.vertexWeights.push(faceWeights[i0 * 4]);
                buffers.vertexWeights.push(faceWeights[i0 * 4 + 1]);
                buffers.vertexWeights.push(faceWeights[i0 * 4 + 2]);
                buffers.vertexWeights.push(faceWeights[i0 * 4 + 3]);
                buffers.vertexWeights.push(faceWeights[i1 * 4]);
                buffers.vertexWeights.push(faceWeights[i1 * 4 + 1]);
                buffers.vertexWeights.push(faceWeights[i1 * 4 + 2]);
                buffers.vertexWeights.push(faceWeights[i1 * 4 + 3]);
                buffers.vertexWeights.push(faceWeights[i2 * 4]);
                buffers.vertexWeights.push(faceWeights[i2 * 4 + 1]);
                buffers.vertexWeights.push(faceWeights[i2 * 4 + 2]);
                buffers.vertexWeights.push(faceWeights[i2 * 4 + 3]);
                buffers.weightsIndices.push(faceWeightIndices[i0 * 4]);
                buffers.weightsIndices.push(faceWeightIndices[i0 * 4 + 1]);
                buffers.weightsIndices.push(faceWeightIndices[i0 * 4 + 2]);
                buffers.weightsIndices.push(faceWeightIndices[i0 * 4 + 3]);
                buffers.weightsIndices.push(faceWeightIndices[i1 * 4]);
                buffers.weightsIndices.push(faceWeightIndices[i1 * 4 + 1]);
                buffers.weightsIndices.push(faceWeightIndices[i1 * 4 + 2]);
                buffers.weightsIndices.push(faceWeightIndices[i1 * 4 + 3]);
                buffers.weightsIndices.push(faceWeightIndices[i2 * 4]);
                buffers.weightsIndices.push(faceWeightIndices[i2 * 4 + 1]);
                buffers.weightsIndices.push(faceWeightIndices[i2 * 4 + 2]);
                buffers.weightsIndices.push(faceWeightIndices[i2 * 4 + 3]);
            }
            if (geoInfo.color) {
                buffers.colors.push(faceColors[i0 * 3]);
                buffers.colors.push(faceColors[i0 * 3 + 1]);
                buffers.colors.push(faceColors[i0 * 3 + 2]);
                buffers.colors.push(faceColors[i1 * 3]);
                buffers.colors.push(faceColors[i1 * 3 + 1]);
                buffers.colors.push(faceColors[i1 * 3 + 2]);
                buffers.colors.push(faceColors[i2 * 3]);
                buffers.colors.push(faceColors[i2 * 3 + 1]);
                buffers.colors.push(faceColors[i2 * 3 + 2]);
            }
            if (geoInfo.material && geoInfo.material.mappingType !== 'AllSame') {
                buffers.materialIndex.push(materialIndex);
                buffers.materialIndex.push(materialIndex);
                buffers.materialIndex.push(materialIndex);
            }
            if (geoInfo.normal) {
                buffers.normal.push(faceNormals[i0 * 3]);
                buffers.normal.push(faceNormals[i0 * 3 + 1]);
                buffers.normal.push(faceNormals[i0 * 3 + 2]);
                buffers.normal.push(faceNormals[i1 * 3]);
                buffers.normal.push(faceNormals[i1 * 3 + 1]);
                buffers.normal.push(faceNormals[i1 * 3 + 2]);
                buffers.normal.push(faceNormals[i2 * 3]);
                buffers.normal.push(faceNormals[i2 * 3 + 1]);
                buffers.normal.push(faceNormals[i2 * 3 + 2]);
            }
            if (geoInfo.uv) geoInfo.uv.forEach(function(uv, j) {
                if (buffers.uvs[j] === undefined) buffers.uvs[j] = [];
                buffers.uvs[j].push(faceUVs[j][i0 * 2]);
                buffers.uvs[j].push(faceUVs[j][i0 * 2 + 1]);
                buffers.uvs[j].push(faceUVs[j][i1 * 2]);
                buffers.uvs[j].push(faceUVs[j][i1 * 2 + 1]);
                buffers.uvs[j].push(faceUVs[j][i2 * 2]);
                buffers.uvs[j].push(faceUVs[j][i2 * 2 + 1]);
            });
        }
    }
    addMorphTargets(parentGeo, parentGeoNode, morphTargets, preTransform) {
        if (morphTargets.length === 0) return;
        parentGeo.morphTargetsRelative = true;
        parentGeo.morphAttributes.position = [];
        // parentGeo.morphAttributes.normal = []; // not implemented
        const scope = this;
        morphTargets.forEach(function(morphTarget) {
            morphTarget.rawTargets.forEach(function(rawTarget) {
                const morphGeoNode = $fa3447b093a231bb$var$fbxTree.Objects.Geometry[rawTarget.geoID];
                if (morphGeoNode !== undefined) scope.genMorphGeometry(parentGeo, parentGeoNode, morphGeoNode, preTransform, rawTarget.name);
            });
        });
    }
    // a morph geometry node is similar to a standard  node, and the node is also contained
    // in FBXTree.Objects.Geometry, however it can only have attributes for position, normal
    // and a special attribute Index defining which vertices of the original geometry are affected
    // Normal and position attributes only have data for the vertices that are affected by the morph
    genMorphGeometry(parentGeo, parentGeoNode, morphGeoNode, preTransform, name) {
        const basePositions = parentGeoNode.Vertices !== undefined ? parentGeoNode.Vertices.a : [];
        const baseIndices = parentGeoNode.PolygonVertexIndex !== undefined ? parentGeoNode.PolygonVertexIndex.a : [];
        const morphPositionsSparse = morphGeoNode.Vertices !== undefined ? morphGeoNode.Vertices.a : [];
        const morphIndices = morphGeoNode.Indexes !== undefined ? morphGeoNode.Indexes.a : [];
        const length = parentGeo.attributes.position.count * 3;
        const morphPositions = new Float32Array(length);
        for(let i = 0; i < morphIndices.length; i++){
            const morphIndex = morphIndices[i] * 3;
            morphPositions[morphIndex] = morphPositionsSparse[i * 3];
            morphPositions[morphIndex + 1] = morphPositionsSparse[i * 3 + 1];
            morphPositions[morphIndex + 2] = morphPositionsSparse[i * 3 + 2];
        }
        // TODO: add morph normal support
        const morphGeoInfo = {
            vertexIndices: baseIndices,
            vertexPositions: morphPositions,
            baseVertexPositions: basePositions
        };
        const morphBuffers = this.genBuffers(morphGeoInfo);
        const positionAttribute = new (0, $329ek.Float32BufferAttribute)(morphBuffers.vertex, 3);
        positionAttribute.name = name || morphGeoNode.attrName;
        positionAttribute.applyMatrix4(preTransform);
        parentGeo.morphAttributes.position.push(positionAttribute);
    }
    // Parse normal from FBXTree.Objects.Geometry.LayerElementNormal if it exists
    parseNormals(NormalNode) {
        const mappingType = NormalNode.MappingInformationType;
        const referenceType = NormalNode.ReferenceInformationType;
        const buffer = NormalNode.Normals.a;
        let indexBuffer = [];
        if (referenceType === 'IndexToDirect') {
            if ('NormalIndex' in NormalNode) indexBuffer = NormalNode.NormalIndex.a;
            else if ('NormalsIndex' in NormalNode) indexBuffer = NormalNode.NormalsIndex.a;
        }
        return {
            dataSize: 3,
            buffer: buffer,
            indices: indexBuffer,
            mappingType: mappingType,
            referenceType: referenceType
        };
    }
    // Parse UVs from FBXTree.Objects.Geometry.LayerElementUV if it exists
    parseUVs(UVNode) {
        const mappingType = UVNode.MappingInformationType;
        const referenceType = UVNode.ReferenceInformationType;
        const buffer = UVNode.UV.a;
        let indexBuffer = [];
        if (referenceType === 'IndexToDirect') indexBuffer = UVNode.UVIndex.a;
        return {
            dataSize: 2,
            buffer: buffer,
            indices: indexBuffer,
            mappingType: mappingType,
            referenceType: referenceType
        };
    }
    // Parse Vertex Colors from FBXTree.Objects.Geometry.LayerElementColor if it exists
    parseVertexColors(ColorNode) {
        const mappingType = ColorNode.MappingInformationType;
        const referenceType = ColorNode.ReferenceInformationType;
        const buffer = ColorNode.Colors.a;
        let indexBuffer = [];
        if (referenceType === 'IndexToDirect') indexBuffer = ColorNode.ColorIndex.a;
        for(let i = 0, c = new (0, $329ek.Color)(); i < buffer.length; i += 4){
            c.fromArray(buffer, i);
            (0, $329ek.ColorManagement).colorSpaceToWorking(c, (0, $329ek.SRGBColorSpace));
            c.toArray(buffer, i);
        }
        return {
            dataSize: 4,
            buffer: buffer,
            indices: indexBuffer,
            mappingType: mappingType,
            referenceType: referenceType
        };
    }
    // Parse mapping and material data in FBXTree.Objects.Geometry.LayerElementMaterial if it exists
    parseMaterialIndices(MaterialNode) {
        const mappingType = MaterialNode.MappingInformationType;
        const referenceType = MaterialNode.ReferenceInformationType;
        if (mappingType === 'NoMappingInformation') return {
            dataSize: 1,
            buffer: [
                0
            ],
            indices: [
                0
            ],
            mappingType: 'AllSame',
            referenceType: referenceType
        };
        const materialIndexBuffer = MaterialNode.Materials.a;
        // Since materials are stored as indices, there's a bit of a mismatch between FBX and what
        // we expect.So we create an intermediate buffer that points to the index in the buffer,
        // for conforming with the other functions we've written for other data.
        const materialIndices = [];
        for(let i = 0; i < materialIndexBuffer.length; ++i)materialIndices.push(i);
        return {
            dataSize: 1,
            buffer: materialIndexBuffer,
            indices: materialIndices,
            mappingType: mappingType,
            referenceType: referenceType
        };
    }
    // Generate a NurbGeometry from a node in FBXTree.Objects.Geometry
    parseNurbsGeometry(geoNode) {
        const order = parseInt(geoNode.Order);
        if (isNaN(order)) {
            console.error('THREE.FBXLoader: Invalid Order %s given for geometry ID: %s', geoNode.Order, geoNode.id);
            return new (0, $329ek.BufferGeometry)();
        }
        const degree = order - 1;
        const knots = geoNode.KnotVector.a;
        const controlPoints = [];
        const pointsValues = geoNode.Points.a;
        for(let i = 0, l = pointsValues.length; i < l; i += 4)controlPoints.push(new (0, $329ek.Vector4)().fromArray(pointsValues, i));
        let startKnot, endKnot;
        if (geoNode.Form === 'Closed') controlPoints.push(controlPoints[0]);
        else if (geoNode.Form === 'Periodic') {
            startKnot = degree;
            endKnot = knots.length - 1 - startKnot;
            for(let i = 0; i < degree; ++i)controlPoints.push(controlPoints[i]);
        }
        const curve = new (0, $iTkPg.NURBSCurve)(degree, knots, controlPoints, startKnot, endKnot);
        const points = curve.getPoints(controlPoints.length * 12);
        return new (0, $329ek.BufferGeometry)().setFromPoints(points);
    }
}
// parse animation data from FBXTree
class $fa3447b093a231bb$var$AnimationParser {
    // take raw animation clips and turn them into three.js animation clips
    parse() {
        const animationClips = [];
        const rawClips = this.parseClips();
        if (rawClips !== undefined) for(const key in rawClips){
            const rawClip = rawClips[key];
            const clip = this.addClip(rawClip);
            animationClips.push(clip);
        }
        return animationClips;
    }
    parseClips() {
        // since the actual transformation data is stored in FBXTree.Objects.AnimationCurve,
        // if this is undefined we can safely assume there are no animations
        if ($fa3447b093a231bb$var$fbxTree.Objects.AnimationCurve === undefined) return undefined;
        const curveNodesMap = this.parseAnimationCurveNodes();
        this.parseAnimationCurves(curveNodesMap);
        const layersMap = this.parseAnimationLayers(curveNodesMap);
        const rawClips = this.parseAnimStacks(layersMap);
        return rawClips;
    }
    // parse nodes in FBXTree.Objects.AnimationCurveNode
    // each AnimationCurveNode holds data for an animation transform for a model (e.g. left arm rotation )
    // and is referenced by an AnimationLayer
    parseAnimationCurveNodes() {
        const rawCurveNodes = $fa3447b093a231bb$var$fbxTree.Objects.AnimationCurveNode;
        const curveNodesMap = new Map();
        for(const nodeID in rawCurveNodes){
            const rawCurveNode = rawCurveNodes[nodeID];
            if (rawCurveNode.attrName.match(/S|R|T|DeformPercent/) !== null) {
                const curveNode = {
                    id: rawCurveNode.id,
                    attr: rawCurveNode.attrName,
                    curves: {}
                };
                curveNodesMap.set(curveNode.id, curveNode);
            }
        }
        return curveNodesMap;
    }
    // parse nodes in FBXTree.Objects.AnimationCurve and connect them up to
    // previously parsed AnimationCurveNodes. Each AnimationCurve holds data for a single animated
    // axis ( e.g. times and values of x rotation)
    parseAnimationCurves(curveNodesMap) {
        const rawCurves = $fa3447b093a231bb$var$fbxTree.Objects.AnimationCurve;
        // TODO: Many values are identical up to roundoff error, but won't be optimised
        // e.g. position times: [0, 0.4, 0. 8]
        // position values: [7.23538335023477e-7, 93.67518615722656, -0.9982695579528809, 7.23538335023477e-7, 93.67518615722656, -0.9982695579528809, 7.235384487103147e-7, 93.67520904541016, -0.9982695579528809]
        // clearly, this should be optimised to
        // times: [0], positions [7.23538335023477e-7, 93.67518615722656, -0.9982695579528809]
        // this shows up in nearly every FBX file, and generally time array is length > 100
        for(const nodeID in rawCurves){
            const animationCurve = {
                id: rawCurves[nodeID].id,
                times: rawCurves[nodeID].KeyTime.a.map($fa3447b093a231bb$var$convertFBXTimeToSeconds),
                values: rawCurves[nodeID].KeyValueFloat.a
            };
            const relationships = $fa3447b093a231bb$var$connections.get(animationCurve.id);
            if (relationships !== undefined) {
                const animationCurveID = relationships.parents[0].ID;
                const animationCurveRelationship = relationships.parents[0].relationship;
                if (animationCurveRelationship.match(/X/)) curveNodesMap.get(animationCurveID).curves['x'] = animationCurve;
                else if (animationCurveRelationship.match(/Y/)) curveNodesMap.get(animationCurveID).curves['y'] = animationCurve;
                else if (animationCurveRelationship.match(/Z/)) curveNodesMap.get(animationCurveID).curves['z'] = animationCurve;
                else if (animationCurveRelationship.match(/DeformPercent/) && curveNodesMap.has(animationCurveID)) curveNodesMap.get(animationCurveID).curves['morph'] = animationCurve;
            }
        }
    }
    // parse nodes in FBXTree.Objects.AnimationLayer. Each layers holds references
    // to various AnimationCurveNodes and is referenced by an AnimationStack node
    // note: theoretically a stack can have multiple layers, however in practice there always seems to be one per stack
    parseAnimationLayers(curveNodesMap) {
        const rawLayers = $fa3447b093a231bb$var$fbxTree.Objects.AnimationLayer;
        const layersMap = new Map();
        for(const nodeID in rawLayers){
            const layerCurveNodes = [];
            const connection = $fa3447b093a231bb$var$connections.get(parseInt(nodeID));
            if (connection !== undefined) {
                // all the animationCurveNodes used in the layer
                const children = connection.children;
                children.forEach(function(child, i) {
                    if (curveNodesMap.has(child.ID)) {
                        const curveNode = curveNodesMap.get(child.ID);
                        // check that the curves are defined for at least one axis, otherwise ignore the curveNode
                        if (curveNode.curves.x !== undefined || curveNode.curves.y !== undefined || curveNode.curves.z !== undefined) {
                            if (layerCurveNodes[i] === undefined) {
                                const modelID = $fa3447b093a231bb$var$connections.get(child.ID).parents.filter(function(parent) {
                                    return parent.relationship !== undefined;
                                })[0].ID;
                                if (modelID !== undefined) {
                                    const rawModel = $fa3447b093a231bb$var$fbxTree.Objects.Model[modelID.toString()];
                                    if (rawModel === undefined) {
                                        console.warn('THREE.FBXLoader: Encountered a unused curve.', child);
                                        return;
                                    }
                                    const node = {
                                        modelName: rawModel.attrName ? (0, $329ek.PropertyBinding).sanitizeNodeName(rawModel.attrName) : '',
                                        ID: rawModel.id,
                                        initialPosition: [
                                            0,
                                            0,
                                            0
                                        ],
                                        initialRotation: [
                                            0,
                                            0,
                                            0
                                        ],
                                        initialScale: [
                                            1,
                                            1,
                                            1
                                        ]
                                    };
                                    $fa3447b093a231bb$var$sceneGraph.traverse(function(child) {
                                        if (child.ID === rawModel.id) {
                                            node.transform = child.matrix;
                                            if (child.userData.transformData) node.eulerOrder = child.userData.transformData.eulerOrder;
                                        }
                                    });
                                    if (!node.transform) node.transform = new (0, $329ek.Matrix4)();
                                    // if the animated model is pre rotated, we'll have to apply the pre rotations to every
                                    // animation value as well
                                    if ('PreRotation' in rawModel) node.preRotation = rawModel.PreRotation.value;
                                    if ('PostRotation' in rawModel) node.postRotation = rawModel.PostRotation.value;
                                    layerCurveNodes[i] = node;
                                }
                            }
                            if (layerCurveNodes[i]) layerCurveNodes[i][curveNode.attr] = curveNode;
                        } else if (curveNode.curves.morph !== undefined) {
                            if (layerCurveNodes[i] === undefined) {
                                const deformerID = $fa3447b093a231bb$var$connections.get(child.ID).parents.filter(function(parent) {
                                    return parent.relationship !== undefined;
                                })[0].ID;
                                const morpherID = $fa3447b093a231bb$var$connections.get(deformerID).parents[0].ID;
                                const geoID = $fa3447b093a231bb$var$connections.get(morpherID).parents[0].ID;
                                // assuming geometry is not used in more than one model
                                const modelID = $fa3447b093a231bb$var$connections.get(geoID).parents[0].ID;
                                const rawModel = $fa3447b093a231bb$var$fbxTree.Objects.Model[modelID];
                                const node = {
                                    modelName: rawModel.attrName ? (0, $329ek.PropertyBinding).sanitizeNodeName(rawModel.attrName) : '',
                                    morphName: $fa3447b093a231bb$var$fbxTree.Objects.Deformer[deformerID].attrName
                                };
                                layerCurveNodes[i] = node;
                            }
                            layerCurveNodes[i][curveNode.attr] = curveNode;
                        }
                    }
                });
                layersMap.set(parseInt(nodeID), layerCurveNodes);
            }
        }
        return layersMap;
    }
    // parse nodes in FBXTree.Objects.AnimationStack. These are the top level node in the animation
    // hierarchy. Each Stack node will be used to create an AnimationClip
    parseAnimStacks(layersMap) {
        const rawStacks = $fa3447b093a231bb$var$fbxTree.Objects.AnimationStack;
        // connect the stacks (clips) up to the layers
        const rawClips = {};
        for(const nodeID in rawStacks){
            const children = $fa3447b093a231bb$var$connections.get(parseInt(nodeID)).children;
            if (children.length > 1) // it seems like stacks will always be associated with a single layer. But just in case there are files
            // where there are multiple layers per stack, we'll display a warning
            console.warn('THREE.FBXLoader: Encountered an animation stack with multiple layers, this is currently not supported. Ignoring subsequent layers.');
            const layer = layersMap.get(children[0].ID);
            rawClips[nodeID] = {
                name: rawStacks[nodeID].attrName,
                layer: layer
            };
        }
        return rawClips;
    }
    addClip(rawClip) {
        let tracks = [];
        const scope = this;
        rawClip.layer.forEach(function(rawTracks) {
            tracks = tracks.concat(scope.generateTracks(rawTracks));
        });
        return new (0, $329ek.AnimationClip)(rawClip.name, -1, tracks);
    }
    generateTracks(rawTracks) {
        const tracks = [];
        let initialPosition = new (0, $329ek.Vector3)();
        let initialScale = new (0, $329ek.Vector3)();
        if (rawTracks.transform) rawTracks.transform.decompose(initialPosition, new (0, $329ek.Quaternion)(), initialScale);
        initialPosition = initialPosition.toArray();
        initialScale = initialScale.toArray();
        if (rawTracks.T !== undefined && Object.keys(rawTracks.T.curves).length > 0) {
            const positionTrack = this.generateVectorTrack(rawTracks.modelName, rawTracks.T.curves, initialPosition, 'position');
            if (positionTrack !== undefined) tracks.push(positionTrack);
        }
        if (rawTracks.R !== undefined && Object.keys(rawTracks.R.curves).length > 0) {
            const rotationTrack = this.generateRotationTrack(rawTracks.modelName, rawTracks.R.curves, rawTracks.preRotation, rawTracks.postRotation, rawTracks.eulerOrder);
            if (rotationTrack !== undefined) tracks.push(rotationTrack);
        }
        if (rawTracks.S !== undefined && Object.keys(rawTracks.S.curves).length > 0) {
            const scaleTrack = this.generateVectorTrack(rawTracks.modelName, rawTracks.S.curves, initialScale, 'scale');
            if (scaleTrack !== undefined) tracks.push(scaleTrack);
        }
        if (rawTracks.DeformPercent !== undefined) {
            const morphTrack = this.generateMorphTrack(rawTracks);
            if (morphTrack !== undefined) tracks.push(morphTrack);
        }
        return tracks;
    }
    generateVectorTrack(modelName, curves, initialValue, type) {
        const times = this.getTimesForAllAxes(curves);
        const values = this.getKeyframeTrackValues(times, curves, initialValue);
        return new (0, $329ek.VectorKeyframeTrack)(modelName + '.' + type, times, values);
    }
    generateRotationTrack(modelName, curves, preRotation, postRotation, eulerOrder) {
        let times;
        let values;
        if (curves.x !== undefined && curves.y !== undefined && curves.z !== undefined) {
            const result = this.interpolateRotations(curves.x, curves.y, curves.z, eulerOrder);
            times = result[0];
            values = result[1];
        }
        // For Maya models using "Joint Orient", Euler order only applies to rotation, not pre/post-rotations
        const defaultEulerOrder = $fa3447b093a231bb$var$getEulerOrder(0);
        if (preRotation !== undefined) {
            preRotation = preRotation.map((0, $329ek.MathUtils).degToRad);
            preRotation.push(defaultEulerOrder);
            preRotation = new (0, $329ek.Euler)().fromArray(preRotation);
            preRotation = new (0, $329ek.Quaternion)().setFromEuler(preRotation);
        }
        if (postRotation !== undefined) {
            postRotation = postRotation.map((0, $329ek.MathUtils).degToRad);
            postRotation.push(defaultEulerOrder);
            postRotation = new (0, $329ek.Euler)().fromArray(postRotation);
            postRotation = new (0, $329ek.Quaternion)().setFromEuler(postRotation).invert();
        }
        const quaternion = new (0, $329ek.Quaternion)();
        const euler = new (0, $329ek.Euler)();
        const quaternionValues = [];
        if (!values || !times) return new (0, $329ek.QuaternionKeyframeTrack)(modelName + '.quaternion', [
            0
        ], [
            0
        ]);
        for(let i = 0; i < values.length; i += 3){
            euler.set(values[i], values[i + 1], values[i + 2], eulerOrder);
            quaternion.setFromEuler(euler);
            if (preRotation !== undefined) quaternion.premultiply(preRotation);
            if (postRotation !== undefined) quaternion.multiply(postRotation);
            // Check unroll
            if (i > 2) {
                const prevQuat = new (0, $329ek.Quaternion)().fromArray(quaternionValues, (i - 3) / 3 * 4);
                if (prevQuat.dot(quaternion) < 0) quaternion.set(-quaternion.x, -quaternion.y, -quaternion.z, -quaternion.w);
            }
            quaternion.toArray(quaternionValues, i / 3 * 4);
        }
        return new (0, $329ek.QuaternionKeyframeTrack)(modelName + '.quaternion', times, quaternionValues);
    }
    generateMorphTrack(rawTracks) {
        const curves = rawTracks.DeformPercent.curves.morph;
        const values = curves.values.map(function(val) {
            return val / 100;
        });
        const morphNum = $fa3447b093a231bb$var$sceneGraph.getObjectByName(rawTracks.modelName).morphTargetDictionary[rawTracks.morphName];
        return new (0, $329ek.NumberKeyframeTrack)(rawTracks.modelName + '.morphTargetInfluences[' + morphNum + ']', curves.times, values);
    }
    // For all animated objects, times are defined separately for each axis
    // Here we'll combine the times into one sorted array without duplicates
    getTimesForAllAxes(curves) {
        let times = [];
        // first join together the times for each axis, if defined
        if (curves.x !== undefined) times = times.concat(curves.x.times);
        if (curves.y !== undefined) times = times.concat(curves.y.times);
        if (curves.z !== undefined) times = times.concat(curves.z.times);
        // then sort them
        times = times.sort(function(a, b) {
            return a - b;
        });
        // and remove duplicates
        if (times.length > 1) {
            let targetIndex = 1;
            let lastValue = times[0];
            for(let i = 1; i < times.length; i++){
                const currentValue = times[i];
                if (currentValue !== lastValue) {
                    times[targetIndex] = currentValue;
                    lastValue = currentValue;
                    targetIndex++;
                }
            }
            times = times.slice(0, targetIndex);
        }
        return times;
    }
    getKeyframeTrackValues(times, curves, initialValue) {
        const prevValue = initialValue;
        const values = [];
        let xIndex = -1;
        let yIndex = -1;
        let zIndex = -1;
        times.forEach(function(time) {
            if (curves.x) xIndex = curves.x.times.indexOf(time);
            if (curves.y) yIndex = curves.y.times.indexOf(time);
            if (curves.z) zIndex = curves.z.times.indexOf(time);
            // if there is an x value defined for this frame, use that
            if (xIndex !== -1) {
                const xValue = curves.x.values[xIndex];
                values.push(xValue);
                prevValue[0] = xValue;
            } else // otherwise use the x value from the previous frame
            values.push(prevValue[0]);
            if (yIndex !== -1) {
                const yValue = curves.y.values[yIndex];
                values.push(yValue);
                prevValue[1] = yValue;
            } else values.push(prevValue[1]);
            if (zIndex !== -1) {
                const zValue = curves.z.values[zIndex];
                values.push(zValue);
                prevValue[2] = zValue;
            } else values.push(prevValue[2]);
        });
        return values;
    }
    // Rotations are defined as Euler angles which can have values  of any size
    // These will be converted to quaternions which don't support values greater than
    // PI, so we'll interpolate large rotations
    interpolateRotations(curvex, curvey, curvez, eulerOrder) {
        const times = [];
        const values = [];
        // Add first frame
        times.push(curvex.times[0]);
        values.push((0, $329ek.MathUtils).degToRad(curvex.values[0]));
        values.push((0, $329ek.MathUtils).degToRad(curvey.values[0]));
        values.push((0, $329ek.MathUtils).degToRad(curvez.values[0]));
        for(let i = 1; i < curvex.values.length; i++){
            const initialValue = [
                curvex.values[i - 1],
                curvey.values[i - 1],
                curvez.values[i - 1]
            ];
            if (isNaN(initialValue[0]) || isNaN(initialValue[1]) || isNaN(initialValue[2])) continue;
            const initialValueRad = initialValue.map((0, $329ek.MathUtils).degToRad);
            const currentValue = [
                curvex.values[i],
                curvey.values[i],
                curvez.values[i]
            ];
            if (isNaN(currentValue[0]) || isNaN(currentValue[1]) || isNaN(currentValue[2])) continue;
            const currentValueRad = currentValue.map((0, $329ek.MathUtils).degToRad);
            const valuesSpan = [
                currentValue[0] - initialValue[0],
                currentValue[1] - initialValue[1],
                currentValue[2] - initialValue[2]
            ];
            const absoluteSpan = [
                Math.abs(valuesSpan[0]),
                Math.abs(valuesSpan[1]),
                Math.abs(valuesSpan[2])
            ];
            if (absoluteSpan[0] >= 180 || absoluteSpan[1] >= 180 || absoluteSpan[2] >= 180) {
                const maxAbsSpan = Math.max(...absoluteSpan);
                const numSubIntervals = maxAbsSpan / 180;
                const E1 = new (0, $329ek.Euler)(...initialValueRad, eulerOrder);
                const E2 = new (0, $329ek.Euler)(...currentValueRad, eulerOrder);
                const Q1 = new (0, $329ek.Quaternion)().setFromEuler(E1);
                const Q2 = new (0, $329ek.Quaternion)().setFromEuler(E2);
                // Check unroll
                if (Q1.dot(Q2)) Q2.set(-Q2.x, -Q2.y, -Q2.z, -Q2.w);
                // Interpolate
                const initialTime = curvex.times[i - 1];
                const timeSpan = curvex.times[i] - initialTime;
                const Q = new (0, $329ek.Quaternion)();
                const E = new (0, $329ek.Euler)();
                for(let t = 0; t < 1; t += 1 / numSubIntervals){
                    Q.copy(Q1.clone().slerp(Q2.clone(), t));
                    times.push(initialTime + t * timeSpan);
                    E.setFromQuaternion(Q, eulerOrder);
                    values.push(E.x);
                    values.push(E.y);
                    values.push(E.z);
                }
            } else {
                times.push(curvex.times[i]);
                values.push((0, $329ek.MathUtils).degToRad(curvex.values[i]));
                values.push((0, $329ek.MathUtils).degToRad(curvey.values[i]));
                values.push((0, $329ek.MathUtils).degToRad(curvez.values[i]));
            }
        }
        return [
            times,
            values
        ];
    }
}
// parse an FBX file in ASCII format
class $fa3447b093a231bb$var$TextParser {
    getPrevNode() {
        return this.nodeStack[this.currentIndent - 2];
    }
    getCurrentNode() {
        return this.nodeStack[this.currentIndent - 1];
    }
    getCurrentProp() {
        return this.currentProp;
    }
    pushStack(node) {
        this.nodeStack.push(node);
        this.currentIndent += 1;
    }
    popStack() {
        this.nodeStack.pop();
        this.currentIndent -= 1;
    }
    setCurrentProp(val, name) {
        this.currentProp = val;
        this.currentPropName = name;
    }
    parse(text) {
        this.currentIndent = 0;
        this.allNodes = new $fa3447b093a231bb$var$FBXTree();
        this.nodeStack = [];
        this.currentProp = [];
        this.currentPropName = '';
        const scope = this;
        const split = text.split(/[\r\n]+/);
        split.forEach(function(line, i) {
            const matchComment = line.match(/^[\s\t]*;/);
            const matchEmpty = line.match(/^[\s\t]*$/);
            if (matchComment || matchEmpty) return;
            const matchBeginning = line.match('^\\t{' + scope.currentIndent + '}(\\w+):(.*){', '');
            const matchProperty = line.match('^\\t{' + scope.currentIndent + '}(\\w+):[\\s\\t\\r\\n](.*)');
            const matchEnd = line.match('^\\t{' + (scope.currentIndent - 1) + '}}');
            if (matchBeginning) scope.parseNodeBegin(line, matchBeginning);
            else if (matchProperty) scope.parseNodeProperty(line, matchProperty, split[++i]);
            else if (matchEnd) scope.popStack();
            else if (line.match(/^[^\s\t}]/)) // large arrays are split over multiple lines terminated with a ',' character
            // if this is encountered the line needs to be joined to the previous line
            scope.parseNodePropertyContinued(line);
        });
        return this.allNodes;
    }
    parseNodeBegin(line, property) {
        const nodeName = property[1].trim().replace(/^"/, '').replace(/"$/, '');
        const nodeAttrs = property[2].split(',').map(function(attr) {
            return attr.trim().replace(/^"/, '').replace(/"$/, '');
        });
        const node = {
            name: nodeName
        };
        const attrs = this.parseNodeAttr(nodeAttrs);
        const currentNode = this.getCurrentNode();
        // a top node
        if (this.currentIndent === 0) this.allNodes.add(nodeName, node);
        else {
            // if the subnode already exists, append it
            if (nodeName in currentNode) {
                // special case Pose needs PoseNodes as an array
                if (nodeName === 'PoseNode') currentNode.PoseNode.push(node);
                else if (currentNode[nodeName].id !== undefined) {
                    currentNode[nodeName] = {};
                    currentNode[nodeName][currentNode[nodeName].id] = currentNode[nodeName];
                }
                if (attrs.id !== '') currentNode[nodeName][attrs.id] = node;
            } else if (typeof attrs.id === 'number') {
                currentNode[nodeName] = {};
                currentNode[nodeName][attrs.id] = node;
            } else if (nodeName !== 'Properties70') {
                if (nodeName === 'PoseNode') currentNode[nodeName] = [
                    node
                ];
                else currentNode[nodeName] = node;
            }
        }
        if (typeof attrs.id === 'number') node.id = attrs.id;
        if (attrs.name !== '') node.attrName = attrs.name;
        if (attrs.type !== '') node.attrType = attrs.type;
        this.pushStack(node);
    }
    parseNodeAttr(attrs) {
        let id = attrs[0];
        if (attrs[0] !== '') {
            id = parseInt(attrs[0]);
            if (isNaN(id)) id = attrs[0];
        }
        let name = '', type = '';
        if (attrs.length > 1) {
            name = attrs[1].replace(/^(\w+)::/, '');
            type = attrs[2];
        }
        return {
            id: id,
            name: name,
            type: type
        };
    }
    parseNodeProperty(line, property, contentLine) {
        let propName = property[1].replace(/^"/, '').replace(/"$/, '').trim();
        let propValue = property[2].replace(/^"/, '').replace(/"$/, '').trim();
        // for special case: base64 image data follows "Content: ," line
        //	Content: ,
        //	 "/9j/4RDaRXhpZgAATU0A..."
        if (propName === 'Content' && propValue === ',') propValue = contentLine.replace(/"/g, '').replace(/,$/, '').trim();
        const currentNode = this.getCurrentNode();
        const parentName = currentNode.name;
        if (parentName === 'Properties70') {
            this.parseNodeSpecialProperty(line, propName, propValue);
            return;
        }
        // Connections
        if (propName === 'C') {
            const connProps = propValue.split(',').slice(1);
            const from = parseInt(connProps[0]);
            const to = parseInt(connProps[1]);
            let rest = propValue.split(',').slice(3);
            rest = rest.map(function(elem) {
                return elem.trim().replace(/^"/, '');
            });
            propName = 'connections';
            propValue = [
                from,
                to
            ];
            $fa3447b093a231bb$var$append(propValue, rest);
            if (currentNode[propName] === undefined) currentNode[propName] = [];
        }
        // Node
        if (propName === 'Node') currentNode.id = propValue;
        // connections
        if (propName in currentNode && Array.isArray(currentNode[propName])) currentNode[propName].push(propValue);
        else if (propName !== 'a') currentNode[propName] = propValue;
        else currentNode.a = propValue;
        this.setCurrentProp(currentNode, propName);
        // convert string to array, unless it ends in ',' in which case more will be added to it
        if (propName === 'a' && propValue.slice(-1) !== ',') currentNode.a = $fa3447b093a231bb$var$parseNumberArray(propValue);
    }
    parseNodePropertyContinued(line) {
        const currentNode = this.getCurrentNode();
        currentNode.a += line;
        // if the line doesn't end in ',' we have reached the end of the property value
        // so convert the string to an array
        if (line.slice(-1) !== ',') currentNode.a = $fa3447b093a231bb$var$parseNumberArray(currentNode.a);
    }
    // parse "Property70"
    parseNodeSpecialProperty(line, propName, propValue) {
        // split this
        // P: "Lcl Scaling", "Lcl Scaling", "", "A",1,1,1
        // into array like below
        // ["Lcl Scaling", "Lcl Scaling", "", "A", "1,1,1" ]
        const props = propValue.split('",').map(function(prop) {
            return prop.trim().replace(/^\"/, '').replace(/\s/, '_');
        });
        const innerPropName = props[0];
        const innerPropType1 = props[1];
        const innerPropType2 = props[2];
        const innerPropFlag = props[3];
        let innerPropValue = props[4];
        // cast values where needed, otherwise leave as strings
        switch(innerPropType1){
            case 'int':
            case 'enum':
            case 'bool':
            case 'ULongLong':
            case 'double':
            case 'Number':
            case 'FieldOfView':
                innerPropValue = parseFloat(innerPropValue);
                break;
            case 'Color':
            case 'ColorRGB':
            case 'Vector3D':
            case 'Lcl_Translation':
            case 'Lcl_Rotation':
            case 'Lcl_Scaling':
                innerPropValue = $fa3447b093a231bb$var$parseNumberArray(innerPropValue);
                break;
        }
        // CAUTION: these props must append to parent's parent
        this.getPrevNode()[innerPropName] = {
            'type': innerPropType1,
            'type2': innerPropType2,
            'flag': innerPropFlag,
            'value': innerPropValue
        };
        this.setCurrentProp(this.getPrevNode(), innerPropName);
    }
}
// Parse an FBX file in Binary format
class $fa3447b093a231bb$var$BinaryParser {
    parse(buffer) {
        const reader = new $fa3447b093a231bb$var$BinaryReader(buffer);
        reader.skip(23); // skip magic 23 bytes
        const version = reader.getUint32();
        if (version < 6400) throw new Error('THREE.FBXLoader: FBX version not supported, FileVersion: ' + version);
        const allNodes = new $fa3447b093a231bb$var$FBXTree();
        while(!this.endOfContent(reader)){
            const node = this.parseNode(reader, version);
            if (node !== null) allNodes.add(node.name, node);
        }
        return allNodes;
    }
    // Check if reader has reached the end of content.
    endOfContent(reader) {
        // footer size: 160bytes + 16-byte alignment padding
        // - 16bytes: magic
        // - padding til 16-byte alignment (at least 1byte?)
        //	(seems like some exporters embed fixed 15 or 16bytes?)
        // - 4bytes: magic
        // - 4bytes: version
        // - 120bytes: zero
        // - 16bytes: magic
        if (reader.size() % 16 === 0) return (reader.getOffset() + 160 + 16 & -16) >= reader.size();
        else return reader.getOffset() + 160 + 16 >= reader.size();
    }
    // recursively parse nodes until the end of the file is reached
    parseNode(reader, version) {
        const node = {};
        // The first three data sizes depends on version.
        const endOffset = version >= 7500 ? reader.getUint64() : reader.getUint32();
        const numProperties = version >= 7500 ? reader.getUint64() : reader.getUint32();
        version >= 7500 ? reader.getUint64() : reader.getUint32(); // the returned propertyListLen is not used
        const nameLen = reader.getUint8();
        const name = reader.getString(nameLen);
        // Regards this node as NULL-record if endOffset is zero
        if (endOffset === 0) return null;
        const propertyList = [];
        for(let i = 0; i < numProperties; i++)propertyList.push(this.parseProperty(reader));
        // Regards the first three elements in propertyList as id, attrName, and attrType
        const id = propertyList.length > 0 ? propertyList[0] : '';
        const attrName = propertyList.length > 1 ? propertyList[1] : '';
        const attrType = propertyList.length > 2 ? propertyList[2] : '';
        // check if this node represents just a single property
        // like (name, 0) set or (name2, [0, 1, 2]) set of {name: 0, name2: [0, 1, 2]}
        node.singleProperty = numProperties === 1 && reader.getOffset() === endOffset ? true : false;
        while(endOffset > reader.getOffset()){
            const subNode = this.parseNode(reader, version);
            if (subNode !== null) this.parseSubNode(name, node, subNode);
        }
        node.propertyList = propertyList; // raw property list used by parent
        if (typeof id === 'number') node.id = id;
        if (attrName !== '') node.attrName = attrName;
        if (attrType !== '') node.attrType = attrType;
        if (name !== '') node.name = name;
        return node;
    }
    parseSubNode(name, node, subNode) {
        // special case: child node is single property
        if (subNode.singleProperty === true) {
            const value = subNode.propertyList[0];
            if (Array.isArray(value)) {
                node[subNode.name] = subNode;
                subNode.a = value;
            } else node[subNode.name] = value;
        } else if (name === 'Connections' && subNode.name === 'C') {
            const array = [];
            subNode.propertyList.forEach(function(property, i) {
                // first Connection is FBX type (OO, OP, etc.). We'll discard these
                if (i !== 0) array.push(property);
            });
            if (node.connections === undefined) node.connections = [];
            node.connections.push(array);
        } else if (subNode.name === 'Properties70') {
            const keys = Object.keys(subNode);
            keys.forEach(function(key) {
                node[key] = subNode[key];
            });
        } else if (name === 'Properties70' && subNode.name === 'P') {
            let innerPropName = subNode.propertyList[0];
            let innerPropType1 = subNode.propertyList[1];
            const innerPropType2 = subNode.propertyList[2];
            const innerPropFlag = subNode.propertyList[3];
            let innerPropValue;
            if (innerPropName.indexOf('Lcl ') === 0) innerPropName = innerPropName.replace('Lcl ', 'Lcl_');
            if (innerPropType1.indexOf('Lcl ') === 0) innerPropType1 = innerPropType1.replace('Lcl ', 'Lcl_');
            if (innerPropType1 === 'Color' || innerPropType1 === 'ColorRGB' || innerPropType1 === 'Vector' || innerPropType1 === 'Vector3D' || innerPropType1.indexOf('Lcl_') === 0) innerPropValue = [
                subNode.propertyList[4],
                subNode.propertyList[5],
                subNode.propertyList[6]
            ];
            else innerPropValue = subNode.propertyList[4];
            // this will be copied to parent, see above
            node[innerPropName] = {
                'type': innerPropType1,
                'type2': innerPropType2,
                'flag': innerPropFlag,
                'value': innerPropValue
            };
        } else if (node[subNode.name] === undefined) {
            if (typeof subNode.id === 'number') {
                node[subNode.name] = {};
                node[subNode.name][subNode.id] = subNode;
            } else node[subNode.name] = subNode;
        } else {
            if (subNode.name === 'PoseNode') {
                if (!Array.isArray(node[subNode.name])) node[subNode.name] = [
                    node[subNode.name]
                ];
                node[subNode.name].push(subNode);
            } else if (node[subNode.name][subNode.id] === undefined) node[subNode.name][subNode.id] = subNode;
        }
    }
    parseProperty(reader) {
        const type = reader.getString(1);
        let length;
        switch(type){
            case 'C':
                return reader.getBoolean();
            case 'D':
                return reader.getFloat64();
            case 'F':
                return reader.getFloat32();
            case 'I':
                return reader.getInt32();
            case 'L':
                return reader.getInt64();
            case 'R':
                length = reader.getUint32();
                return reader.getArrayBuffer(length);
            case 'S':
                length = reader.getUint32();
                return reader.getString(length);
            case 'Y':
                return reader.getInt16();
            case 'b':
            case 'c':
            case 'd':
            case 'f':
            case 'i':
            case 'l':
                const arrayLength = reader.getUint32();
                const encoding = reader.getUint32(); // 0: non-compressed, 1: compressed
                const compressedLength = reader.getUint32();
                if (encoding === 0) switch(type){
                    case 'b':
                    case 'c':
                        return reader.getBooleanArray(arrayLength);
                    case 'd':
                        return reader.getFloat64Array(arrayLength);
                    case 'f':
                        return reader.getFloat32Array(arrayLength);
                    case 'i':
                        return reader.getInt32Array(arrayLength);
                    case 'l':
                        return reader.getInt64Array(arrayLength);
                }
                const data = $kb6vH.unzlibSync(new Uint8Array(reader.getArrayBuffer(compressedLength)));
                const reader2 = new $fa3447b093a231bb$var$BinaryReader(data.buffer);
                switch(type){
                    case 'b':
                    case 'c':
                        return reader2.getBooleanArray(arrayLength);
                    case 'd':
                        return reader2.getFloat64Array(arrayLength);
                    case 'f':
                        return reader2.getFloat32Array(arrayLength);
                    case 'i':
                        return reader2.getInt32Array(arrayLength);
                    case 'l':
                        return reader2.getInt64Array(arrayLength);
                }
                break; // cannot happen but is required by the DeepScan
            default:
                throw new Error('THREE.FBXLoader: Unknown property type ' + type);
        }
    }
}
class $fa3447b093a231bb$var$BinaryReader {
    constructor(buffer, littleEndian){
        this.dv = new DataView(buffer);
        this.offset = 0;
        this.littleEndian = littleEndian !== undefined ? littleEndian : true;
        this._textDecoder = new TextDecoder();
    }
    getOffset() {
        return this.offset;
    }
    size() {
        return this.dv.buffer.byteLength;
    }
    skip(length) {
        this.offset += length;
    }
    // seems like true/false representation depends on exporter.
    // true: 1 or 'Y'(=0x59), false: 0 or 'T'(=0x54)
    // then sees LSB.
    getBoolean() {
        return (this.getUint8() & 1) === 1;
    }
    getBooleanArray(size) {
        const a = [];
        for(let i = 0; i < size; i++)a.push(this.getBoolean());
        return a;
    }
    getUint8() {
        const value = this.dv.getUint8(this.offset);
        this.offset += 1;
        return value;
    }
    getInt16() {
        const value = this.dv.getInt16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    getInt32() {
        const value = this.dv.getInt32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    getInt32Array(size) {
        const a = [];
        for(let i = 0; i < size; i++)a.push(this.getInt32());
        return a;
    }
    getUint32() {
        const value = this.dv.getUint32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    // JavaScript doesn't support 64-bit integer so calculate this here
    // 1 << 32 will return 1 so using multiply operation instead here.
    // There's a possibility that this method returns wrong value if the value
    // is out of the range between Number.MAX_SAFE_INTEGER and Number.MIN_SAFE_INTEGER.
    // TODO: safely handle 64-bit integer
    getInt64() {
        let low, high;
        if (this.littleEndian) {
            low = this.getUint32();
            high = this.getUint32();
        } else {
            high = this.getUint32();
            low = this.getUint32();
        }
        // calculate negative value
        if (high & 0x80000000) {
            high = ~high & 0xFFFFFFFF;
            low = ~low & 0xFFFFFFFF;
            if (low === 0xFFFFFFFF) high = high + 1 & 0xFFFFFFFF;
            low = low + 1 & 0xFFFFFFFF;
            return -(high * 0x100000000 + low);
        }
        return high * 0x100000000 + low;
    }
    getInt64Array(size) {
        const a = [];
        for(let i = 0; i < size; i++)a.push(this.getInt64());
        return a;
    }
    // Note: see getInt64() comment
    getUint64() {
        let low, high;
        if (this.littleEndian) {
            low = this.getUint32();
            high = this.getUint32();
        } else {
            high = this.getUint32();
            low = this.getUint32();
        }
        return high * 0x100000000 + low;
    }
    getFloat32() {
        const value = this.dv.getFloat32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    getFloat32Array(size) {
        const a = [];
        for(let i = 0; i < size; i++)a.push(this.getFloat32());
        return a;
    }
    getFloat64() {
        const value = this.dv.getFloat64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    getFloat64Array(size) {
        const a = [];
        for(let i = 0; i < size; i++)a.push(this.getFloat64());
        return a;
    }
    getArrayBuffer(size) {
        const value = this.dv.buffer.slice(this.offset, this.offset + size);
        this.offset += size;
        return value;
    }
    getString(size) {
        const start = this.offset;
        let a = new Uint8Array(this.dv.buffer, start, size);
        this.skip(size);
        const nullByte = a.indexOf(0);
        if (nullByte >= 0) a = new Uint8Array(this.dv.buffer, start, nullByte);
        return this._textDecoder.decode(a);
    }
}
// FBXTree holds a representation of the FBX data, returned by the TextParser ( FBX ASCII format)
// and BinaryParser( FBX Binary format)
class $fa3447b093a231bb$var$FBXTree {
    add(key, val) {
        this[key] = val;
    }
}
// ************** UTILITY FUNCTIONS **************
function $fa3447b093a231bb$var$isFbxFormatBinary(buffer) {
    const CORRECT = 'Kaydara\u0020FBX\u0020Binary\u0020\u0020\0';
    return buffer.byteLength >= CORRECT.length && CORRECT === $fa3447b093a231bb$var$convertArrayBufferToString(buffer, 0, CORRECT.length);
}
function $fa3447b093a231bb$var$isFbxFormatASCII(text) {
    const CORRECT = [
        'K',
        'a',
        'y',
        'd',
        'a',
        'r',
        'a',
        '\\',
        'F',
        'B',
        'X',
        '\\',
        'B',
        'i',
        'n',
        'a',
        'r',
        'y',
        '\\',
        '\\'
    ];
    let cursor = 0;
    function read(offset) {
        const result = text[offset - 1];
        text = text.slice(cursor + offset);
        cursor++;
        return result;
    }
    for(let i = 0; i < CORRECT.length; ++i){
        const num = read(1);
        if (num === CORRECT[i]) return false;
    }
    return true;
}
function $fa3447b093a231bb$var$getFbxVersion(text) {
    const versionRegExp = /FBXVersion: (\d+)/;
    const match = text.match(versionRegExp);
    if (match) {
        const version = parseInt(match[1]);
        return version;
    }
    throw new Error('THREE.FBXLoader: Cannot find the version number for the file given.');
}
// Converts FBX ticks into real time seconds.
function $fa3447b093a231bb$var$convertFBXTimeToSeconds(time) {
    return time / 46186158000;
}
const $fa3447b093a231bb$var$dataArray = [];
// extracts the data from the correct position in the FBX array based on indexing type
function $fa3447b093a231bb$var$getData(polygonVertexIndex, polygonIndex, vertexIndex, infoObject) {
    let index;
    switch(infoObject.mappingType){
        case 'ByPolygonVertex':
            index = polygonVertexIndex;
            break;
        case 'ByPolygon':
            index = polygonIndex;
            break;
        case 'ByVertice':
            index = vertexIndex;
            break;
        case 'AllSame':
            index = infoObject.indices[0];
            break;
        default:
            console.warn('THREE.FBXLoader: unknown attribute mapping type ' + infoObject.mappingType);
    }
    if (infoObject.referenceType === 'IndexToDirect') index = infoObject.indices[index];
    const from = index * infoObject.dataSize;
    const to = from + infoObject.dataSize;
    return $fa3447b093a231bb$var$slice($fa3447b093a231bb$var$dataArray, infoObject.buffer, from, to);
}
const $fa3447b093a231bb$var$tempEuler = new (0, $329ek.Euler)();
const $fa3447b093a231bb$var$tempVec = new (0, $329ek.Vector3)();
// generate transformation from FBX transform data
// ref: https://help.autodesk.com/view/FBX/2017/ENU/?guid=__files_GUID_10CDD63C_79C1_4F2D_BB28_AD2BE65A02ED_htm
// ref: http://docs.autodesk.com/FBX/2014/ENU/FBX-SDK-Documentation/index.html?url=cpp_ref/_transformations_2main_8cxx-example.html,topicNumber=cpp_ref__transformations_2main_8cxx_example_htmlfc10a1e1-b18d-4e72-9dc0-70d0f1959f5e
function $fa3447b093a231bb$var$generateTransform(transformData) {
    const lTranslationM = new (0, $329ek.Matrix4)();
    const lPreRotationM = new (0, $329ek.Matrix4)();
    const lRotationM = new (0, $329ek.Matrix4)();
    const lPostRotationM = new (0, $329ek.Matrix4)();
    const lScalingM = new (0, $329ek.Matrix4)();
    const lScalingPivotM = new (0, $329ek.Matrix4)();
    const lScalingOffsetM = new (0, $329ek.Matrix4)();
    const lRotationOffsetM = new (0, $329ek.Matrix4)();
    const lRotationPivotM = new (0, $329ek.Matrix4)();
    const lParentGX = new (0, $329ek.Matrix4)();
    const lParentLX = new (0, $329ek.Matrix4)();
    const lGlobalT = new (0, $329ek.Matrix4)();
    const inheritType = transformData.inheritType ? transformData.inheritType : 0;
    if (transformData.translation) lTranslationM.setPosition($fa3447b093a231bb$var$tempVec.fromArray(transformData.translation));
    // For Maya models using "Joint Orient", Euler order only applies to rotation, not pre/post-rotations
    const defaultEulerOrder = $fa3447b093a231bb$var$getEulerOrder(0);
    if (transformData.preRotation) {
        const array = transformData.preRotation.map((0, $329ek.MathUtils).degToRad);
        array.push(defaultEulerOrder);
        lPreRotationM.makeRotationFromEuler($fa3447b093a231bb$var$tempEuler.fromArray(array));
    }
    if (transformData.rotation) {
        const array = transformData.rotation.map((0, $329ek.MathUtils).degToRad);
        array.push(transformData.eulerOrder || defaultEulerOrder);
        lRotationM.makeRotationFromEuler($fa3447b093a231bb$var$tempEuler.fromArray(array));
    }
    if (transformData.postRotation) {
        const array = transformData.postRotation.map((0, $329ek.MathUtils).degToRad);
        array.push(defaultEulerOrder);
        lPostRotationM.makeRotationFromEuler($fa3447b093a231bb$var$tempEuler.fromArray(array));
        lPostRotationM.invert();
    }
    if (transformData.scale) lScalingM.scale($fa3447b093a231bb$var$tempVec.fromArray(transformData.scale));
    // Pivots and offsets
    if (transformData.scalingOffset) lScalingOffsetM.setPosition($fa3447b093a231bb$var$tempVec.fromArray(transformData.scalingOffset));
    if (transformData.scalingPivot) lScalingPivotM.setPosition($fa3447b093a231bb$var$tempVec.fromArray(transformData.scalingPivot));
    if (transformData.rotationOffset) lRotationOffsetM.setPosition($fa3447b093a231bb$var$tempVec.fromArray(transformData.rotationOffset));
    if (transformData.rotationPivot) lRotationPivotM.setPosition($fa3447b093a231bb$var$tempVec.fromArray(transformData.rotationPivot));
    // parent transform
    if (transformData.parentMatrixWorld) {
        lParentLX.copy(transformData.parentMatrix);
        lParentGX.copy(transformData.parentMatrixWorld);
    }
    const lLRM = lPreRotationM.clone().multiply(lRotationM).multiply(lPostRotationM);
    // Global Rotation
    const lParentGRM = new (0, $329ek.Matrix4)();
    lParentGRM.extractRotation(lParentGX);
    // Global Shear*Scaling
    const lParentTM = new (0, $329ek.Matrix4)();
    lParentTM.copyPosition(lParentGX);
    const lParentGRSM = lParentTM.clone().invert().multiply(lParentGX);
    const lParentGSM = lParentGRM.clone().invert().multiply(lParentGRSM);
    const lLSM = lScalingM;
    const lGlobalRS = new (0, $329ek.Matrix4)();
    if (inheritType === 0) lGlobalRS.copy(lParentGRM).multiply(lLRM).multiply(lParentGSM).multiply(lLSM);
    else if (inheritType === 1) lGlobalRS.copy(lParentGRM).multiply(lParentGSM).multiply(lLRM).multiply(lLSM);
    else {
        const lParentLSM = new (0, $329ek.Matrix4)().scale(new (0, $329ek.Vector3)().setFromMatrixScale(lParentLX));
        const lParentLSM_inv = lParentLSM.clone().invert();
        const lParentGSM_noLocal = lParentGSM.clone().multiply(lParentLSM_inv);
        lGlobalRS.copy(lParentGRM).multiply(lLRM).multiply(lParentGSM_noLocal).multiply(lLSM);
    }
    const lRotationPivotM_inv = lRotationPivotM.clone().invert();
    const lScalingPivotM_inv = lScalingPivotM.clone().invert();
    // Calculate the local transform matrix
    let lTransform = lTranslationM.clone().multiply(lRotationOffsetM).multiply(lRotationPivotM).multiply(lPreRotationM).multiply(lRotationM).multiply(lPostRotationM).multiply(lRotationPivotM_inv).multiply(lScalingOffsetM).multiply(lScalingPivotM).multiply(lScalingM).multiply(lScalingPivotM_inv);
    const lLocalTWithAllPivotAndOffsetInfo = new (0, $329ek.Matrix4)().copyPosition(lTransform);
    const lGlobalTranslation = lParentGX.clone().multiply(lLocalTWithAllPivotAndOffsetInfo);
    lGlobalT.copyPosition(lGlobalTranslation);
    lTransform = lGlobalT.clone().multiply(lGlobalRS);
    // from global to local
    lTransform.premultiply(lParentGX.invert());
    return lTransform;
}
// Returns the three.js intrinsic Euler order corresponding to FBX extrinsic Euler order
// ref: http://help.autodesk.com/view/FBX/2017/ENU/?guid=__cpp_ref_class_fbx_euler_html
function $fa3447b093a231bb$var$getEulerOrder(order) {
    order = order || 0;
    const enums = [
        'ZYX',
        'YZX',
        'XZY',
        'ZXY',
        'YXZ',
        'XYZ'
    ];
    if (order === 6) {
        console.warn('THREE.FBXLoader: unsupported Euler Order: Spherical XYZ. Animations and rotations may be incorrect.');
        return enums[0];
    }
    return enums[order];
}
// Parses comma separated list of numbers and returns them an array.
// Used internally by the TextParser
function $fa3447b093a231bb$var$parseNumberArray(value) {
    const array = value.split(',').map(function(val) {
        return parseFloat(val);
    });
    return array;
}
function $fa3447b093a231bb$var$convertArrayBufferToString(buffer, from, to) {
    if (from === undefined) from = 0;
    if (to === undefined) to = buffer.byteLength;
    return new TextDecoder().decode(new Uint8Array(buffer, from, to));
}
function $fa3447b093a231bb$var$append(a, b) {
    for(let i = 0, j = a.length, l = b.length; i < l; i++, j++)a[j] = b[i];
}
function $fa3447b093a231bb$var$slice(a, b, from, to) {
    for(let i = from, j = 0; i < to; i++, j++)a[j] = b[i];
    return a;
}

});
parcelRegister("kb6vH", function(module, exports) {

$parcel$export(module.exports, "unzlibSync", () => $eb09e2865ff9090f$export$9ec8134f0f1b9fc6);
/*!
fflate - fast JavaScript compression/decompression
<https://101arrowz.github.io/fflate>
Licensed under MIT. https://github.com/101arrowz/fflate/blob/master/LICENSE
version 0.8.2
*/ // DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $eb09e2865ff9090f$var$ch2 = {};
var $eb09e2865ff9090f$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($eb09e2865ff9090f$var$ch2[id] || ($eb09e2865ff9090f$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $eb09e2865ff9090f$var$u8 = Uint8Array, $eb09e2865ff9090f$var$u16 = Uint16Array, $eb09e2865ff9090f$var$i32 = Int32Array;
// fixed length extra bits
var $eb09e2865ff9090f$var$fleb = new $eb09e2865ff9090f$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $eb09e2865ff9090f$var$fdeb = new $eb09e2865ff9090f$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $eb09e2865ff9090f$var$clim = new $eb09e2865ff9090f$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $eb09e2865ff9090f$var$freb = function(eb, start) {
    var b = new $eb09e2865ff9090f$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $eb09e2865ff9090f$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $eb09e2865ff9090f$var$_a = $eb09e2865ff9090f$var$freb($eb09e2865ff9090f$var$fleb, 2), $eb09e2865ff9090f$var$fl = $eb09e2865ff9090f$var$_a.b, $eb09e2865ff9090f$var$revfl = $eb09e2865ff9090f$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$eb09e2865ff9090f$var$fl[28] = 258, $eb09e2865ff9090f$var$revfl[258] = 28;
var $eb09e2865ff9090f$var$_b = $eb09e2865ff9090f$var$freb($eb09e2865ff9090f$var$fdeb, 0), $eb09e2865ff9090f$var$fd = $eb09e2865ff9090f$var$_b.b, $eb09e2865ff9090f$var$revfd = $eb09e2865ff9090f$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $eb09e2865ff9090f$var$rev = new $eb09e2865ff9090f$var$u16(32768);
for(var $eb09e2865ff9090f$var$i = 0; $eb09e2865ff9090f$var$i < 32768; ++$eb09e2865ff9090f$var$i){
    // reverse table algorithm from SO
    var $eb09e2865ff9090f$var$x = ($eb09e2865ff9090f$var$i & 0xAAAA) >> 1 | ($eb09e2865ff9090f$var$i & 0x5555) << 1;
    $eb09e2865ff9090f$var$x = ($eb09e2865ff9090f$var$x & 0xCCCC) >> 2 | ($eb09e2865ff9090f$var$x & 0x3333) << 2;
    $eb09e2865ff9090f$var$x = ($eb09e2865ff9090f$var$x & 0xF0F0) >> 4 | ($eb09e2865ff9090f$var$x & 0x0F0F) << 4;
    $eb09e2865ff9090f$var$rev[$eb09e2865ff9090f$var$i] = (($eb09e2865ff9090f$var$x & 0xFF00) >> 8 | ($eb09e2865ff9090f$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $eb09e2865ff9090f$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $eb09e2865ff9090f$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $eb09e2865ff9090f$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $eb09e2865ff9090f$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$eb09e2865ff9090f$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $eb09e2865ff9090f$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $eb09e2865ff9090f$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $eb09e2865ff9090f$var$flt = new $eb09e2865ff9090f$var$u8(288);
for(var $eb09e2865ff9090f$var$i = 0; $eb09e2865ff9090f$var$i < 144; ++$eb09e2865ff9090f$var$i)$eb09e2865ff9090f$var$flt[$eb09e2865ff9090f$var$i] = 8;
for(var $eb09e2865ff9090f$var$i = 144; $eb09e2865ff9090f$var$i < 256; ++$eb09e2865ff9090f$var$i)$eb09e2865ff9090f$var$flt[$eb09e2865ff9090f$var$i] = 9;
for(var $eb09e2865ff9090f$var$i = 256; $eb09e2865ff9090f$var$i < 280; ++$eb09e2865ff9090f$var$i)$eb09e2865ff9090f$var$flt[$eb09e2865ff9090f$var$i] = 7;
for(var $eb09e2865ff9090f$var$i = 280; $eb09e2865ff9090f$var$i < 288; ++$eb09e2865ff9090f$var$i)$eb09e2865ff9090f$var$flt[$eb09e2865ff9090f$var$i] = 8;
// fixed distance tree
var $eb09e2865ff9090f$var$fdt = new $eb09e2865ff9090f$var$u8(32);
for(var $eb09e2865ff9090f$var$i = 0; $eb09e2865ff9090f$var$i < 32; ++$eb09e2865ff9090f$var$i)$eb09e2865ff9090f$var$fdt[$eb09e2865ff9090f$var$i] = 5;
// fixed length map
var $eb09e2865ff9090f$var$flm = /*#__PURE__*/ $eb09e2865ff9090f$var$hMap($eb09e2865ff9090f$var$flt, 9, 0), $eb09e2865ff9090f$var$flrm = /*#__PURE__*/ $eb09e2865ff9090f$var$hMap($eb09e2865ff9090f$var$flt, 9, 1);
// fixed distance map
var $eb09e2865ff9090f$var$fdm = /*#__PURE__*/ $eb09e2865ff9090f$var$hMap($eb09e2865ff9090f$var$fdt, 5, 0), $eb09e2865ff9090f$var$fdrm = /*#__PURE__*/ $eb09e2865ff9090f$var$hMap($eb09e2865ff9090f$var$fdt, 5, 1);
// find max of array
var $eb09e2865ff9090f$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $eb09e2865ff9090f$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $eb09e2865ff9090f$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $eb09e2865ff9090f$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $eb09e2865ff9090f$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $eb09e2865ff9090f$var$u8(v.subarray(s, e));
};
var $eb09e2865ff9090f$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $eb09e2865ff9090f$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $eb09e2865ff9090f$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $eb09e2865ff9090f$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $eb09e2865ff9090f$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $eb09e2865ff9090f$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $eb09e2865ff9090f$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $eb09e2865ff9090f$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $eb09e2865ff9090f$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $eb09e2865ff9090f$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $eb09e2865ff9090f$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $eb09e2865ff9090f$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $eb09e2865ff9090f$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $eb09e2865ff9090f$var$flrm, dm = $eb09e2865ff9090f$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $eb09e2865ff9090f$var$bits(dat, pos, 31) + 257, hcLen = $eb09e2865ff9090f$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $eb09e2865ff9090f$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $eb09e2865ff9090f$var$u8(tl);
                // code length tree
                var clt = new $eb09e2865ff9090f$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$eb09e2865ff9090f$var$clim[i]] = $eb09e2865ff9090f$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $eb09e2865ff9090f$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $eb09e2865ff9090f$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$eb09e2865ff9090f$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $eb09e2865ff9090f$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $eb09e2865ff9090f$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $eb09e2865ff9090f$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $eb09e2865ff9090f$var$max(lt);
                // max dist bits
                dbt = $eb09e2865ff9090f$var$max(dt);
                lm = $eb09e2865ff9090f$var$hMap(lt, lbt, 1);
                dm = $eb09e2865ff9090f$var$hMap(dt, dbt, 1);
            } else $eb09e2865ff9090f$var$err(1);
            if (pos > tbts) {
                if (noSt) $eb09e2865ff9090f$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$eb09e2865ff9090f$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $eb09e2865ff9090f$var$err(0);
                break;
            }
            if (!c) $eb09e2865ff9090f$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $eb09e2865ff9090f$var$fleb[i];
                    add = $eb09e2865ff9090f$var$bits(dat, pos, (1 << b) - 1) + $eb09e2865ff9090f$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$eb09e2865ff9090f$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $eb09e2865ff9090f$var$err(3);
                pos += d & 15;
                var dt = $eb09e2865ff9090f$var$fd[dsym];
                if (dsym > 3) {
                    var b = $eb09e2865ff9090f$var$fdeb[dsym];
                    dt += $eb09e2865ff9090f$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $eb09e2865ff9090f$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $eb09e2865ff9090f$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $eb09e2865ff9090f$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $eb09e2865ff9090f$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $eb09e2865ff9090f$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $eb09e2865ff9090f$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $eb09e2865ff9090f$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $eb09e2865ff9090f$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $eb09e2865ff9090f$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $eb09e2865ff9090f$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $eb09e2865ff9090f$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $eb09e2865ff9090f$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($eb09e2865ff9090f$var$ln(n.l, l, d + 1), $eb09e2865ff9090f$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $eb09e2865ff9090f$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $eb09e2865ff9090f$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $eb09e2865ff9090f$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $eb09e2865ff9090f$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $eb09e2865ff9090f$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $eb09e2865ff9090f$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $eb09e2865ff9090f$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $eb09e2865ff9090f$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $eb09e2865ff9090f$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $eb09e2865ff9090f$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $eb09e2865ff9090f$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $eb09e2865ff9090f$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $eb09e2865ff9090f$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$eb09e2865ff9090f$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $eb09e2865ff9090f$var$clen(lf, $eb09e2865ff9090f$var$flt) + $eb09e2865ff9090f$var$clen(df, $eb09e2865ff9090f$var$fdt) + eb;
    var dtlen = $eb09e2865ff9090f$var$clen(lf, dlt) + $eb09e2865ff9090f$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $eb09e2865ff9090f$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $eb09e2865ff9090f$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $eb09e2865ff9090f$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $eb09e2865ff9090f$var$hMap(dlt, mlb, 0), ll = dlt, dm = $eb09e2865ff9090f$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $eb09e2865ff9090f$var$hMap(lct, mlcb, 0);
        $eb09e2865ff9090f$var$wbits(out, p, nlc - 257);
        $eb09e2865ff9090f$var$wbits(out, p + 5, ndc - 1);
        $eb09e2865ff9090f$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$eb09e2865ff9090f$var$wbits(out, p + 3 * i, lct[$eb09e2865ff9090f$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $eb09e2865ff9090f$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $eb09e2865ff9090f$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $eb09e2865ff9090f$var$flm, ll = $eb09e2865ff9090f$var$flt, dm = $eb09e2865ff9090f$var$fdm, dl = $eb09e2865ff9090f$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $eb09e2865ff9090f$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $eb09e2865ff9090f$var$wbits(out, p, sym >> 23 & 31), p += $eb09e2865ff9090f$var$fleb[len];
            var dst = sym & 31;
            $eb09e2865ff9090f$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $eb09e2865ff9090f$var$wbits16(out, p, sym >> 5 & 8191), p += $eb09e2865ff9090f$var$fdeb[dst];
        } else $eb09e2865ff9090f$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $eb09e2865ff9090f$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $eb09e2865ff9090f$var$deo = /*#__PURE__*/ new $eb09e2865ff9090f$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $eb09e2865ff9090f$var$et = /*#__PURE__*/ new $eb09e2865ff9090f$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $eb09e2865ff9090f$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $eb09e2865ff9090f$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $eb09e2865ff9090f$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $eb09e2865ff9090f$var$u16(32768), head = st.h || new $eb09e2865ff9090f$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $eb09e2865ff9090f$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $eb09e2865ff9090f$var$u16(288), df = new $eb09e2865ff9090f$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $eb09e2865ff9090f$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $eb09e2865ff9090f$var$revfl[l] << 18 | $eb09e2865ff9090f$var$revfd[d];
                    var lin = $eb09e2865ff9090f$var$revfl[l] & 31, din = $eb09e2865ff9090f$var$revfd[d] & 31;
                    eb += $eb09e2865ff9090f$var$fleb[lin] + $eb09e2865ff9090f$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $eb09e2865ff9090f$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $eb09e2865ff9090f$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $eb09e2865ff9090f$var$slc(o, 0, pre + $eb09e2865ff9090f$var$shft(pos) + post);
};
// CRC32 table
var $eb09e2865ff9090f$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $eb09e2865ff9090f$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $eb09e2865ff9090f$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $eb09e2865ff9090f$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $eb09e2865ff9090f$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $eb09e2865ff9090f$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $eb09e2865ff9090f$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $eb09e2865ff9090f$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $eb09e2865ff9090f$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $eb09e2865ff9090f$var$ch = [];
// clone bufs
var $eb09e2865ff9090f$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $eb09e2865ff9090f$var$wrkr = function(fns, init, id, cb) {
    if (!$eb09e2865ff9090f$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $eb09e2865ff9090f$var$wcln(fns[i], fnStr, td_1);
        $eb09e2865ff9090f$var$ch[id] = {
            c: $eb09e2865ff9090f$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $eb09e2865ff9090f$var$mrg({}, $eb09e2865ff9090f$var$ch[id].e);
    return $eb09e2865ff9090f$var$wk($eb09e2865ff9090f$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $eb09e2865ff9090f$var$cbfs(td), cb);
};
// base async inflate fn
var $eb09e2865ff9090f$var$bInflt = function() {
    return [
        $eb09e2865ff9090f$var$u8,
        $eb09e2865ff9090f$var$u16,
        $eb09e2865ff9090f$var$i32,
        $eb09e2865ff9090f$var$fleb,
        $eb09e2865ff9090f$var$fdeb,
        $eb09e2865ff9090f$var$clim,
        $eb09e2865ff9090f$var$fl,
        $eb09e2865ff9090f$var$fd,
        $eb09e2865ff9090f$var$flrm,
        $eb09e2865ff9090f$var$fdrm,
        $eb09e2865ff9090f$var$rev,
        $eb09e2865ff9090f$var$ec,
        $eb09e2865ff9090f$var$hMap,
        $eb09e2865ff9090f$var$max,
        $eb09e2865ff9090f$var$bits,
        $eb09e2865ff9090f$var$bits16,
        $eb09e2865ff9090f$var$shft,
        $eb09e2865ff9090f$var$slc,
        $eb09e2865ff9090f$var$err,
        $eb09e2865ff9090f$var$inflt,
        $eb09e2865ff9090f$export$90366d8b308ba94a,
        $eb09e2865ff9090f$var$pbf,
        $eb09e2865ff9090f$var$gopt
    ];
};
var $eb09e2865ff9090f$var$bDflt = function() {
    return [
        $eb09e2865ff9090f$var$u8,
        $eb09e2865ff9090f$var$u16,
        $eb09e2865ff9090f$var$i32,
        $eb09e2865ff9090f$var$fleb,
        $eb09e2865ff9090f$var$fdeb,
        $eb09e2865ff9090f$var$clim,
        $eb09e2865ff9090f$var$revfl,
        $eb09e2865ff9090f$var$revfd,
        $eb09e2865ff9090f$var$flm,
        $eb09e2865ff9090f$var$flt,
        $eb09e2865ff9090f$var$fdm,
        $eb09e2865ff9090f$var$fdt,
        $eb09e2865ff9090f$var$rev,
        $eb09e2865ff9090f$var$deo,
        $eb09e2865ff9090f$var$et,
        $eb09e2865ff9090f$var$hMap,
        $eb09e2865ff9090f$var$wbits,
        $eb09e2865ff9090f$var$wbits16,
        $eb09e2865ff9090f$var$hTree,
        $eb09e2865ff9090f$var$ln,
        $eb09e2865ff9090f$var$lc,
        $eb09e2865ff9090f$var$clen,
        $eb09e2865ff9090f$var$wfblk,
        $eb09e2865ff9090f$var$wblk,
        $eb09e2865ff9090f$var$shft,
        $eb09e2865ff9090f$var$slc,
        $eb09e2865ff9090f$var$dflt,
        $eb09e2865ff9090f$var$dopt,
        $eb09e2865ff9090f$export$21533ff51b8a0b4a,
        $eb09e2865ff9090f$var$pbf
    ];
};
// gzip extra
var $eb09e2865ff9090f$var$gze = function() {
    return [
        $eb09e2865ff9090f$var$gzh,
        $eb09e2865ff9090f$var$gzhl,
        $eb09e2865ff9090f$var$wbytes,
        $eb09e2865ff9090f$var$crc,
        $eb09e2865ff9090f$var$crct
    ];
};
// gunzip extra
var $eb09e2865ff9090f$var$guze = function() {
    return [
        $eb09e2865ff9090f$var$gzs,
        $eb09e2865ff9090f$var$gzl
    ];
};
// zlib extra
var $eb09e2865ff9090f$var$zle = function() {
    return [
        $eb09e2865ff9090f$var$zlh,
        $eb09e2865ff9090f$var$wbytes,
        $eb09e2865ff9090f$var$adler
    ];
};
// unzlib extra
var $eb09e2865ff9090f$var$zule = function() {
    return [
        $eb09e2865ff9090f$var$zls
    ];
};
// post buf
var $eb09e2865ff9090f$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $eb09e2865ff9090f$var$gopt = function(o) {
    return o && {
        out: o.size && new $eb09e2865ff9090f$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $eb09e2865ff9090f$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $eb09e2865ff9090f$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $eb09e2865ff9090f$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $eb09e2865ff9090f$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $eb09e2865ff9090f$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $eb09e2865ff9090f$var$err(5);
        if (t) strm.ondata($eb09e2865ff9090f$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $eb09e2865ff9090f$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $eb09e2865ff9090f$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $eb09e2865ff9090f$var$b8 = function(d, b) {
    return $eb09e2865ff9090f$var$b4(d, b) + $eb09e2865ff9090f$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $eb09e2865ff9090f$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $eb09e2865ff9090f$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $eb09e2865ff9090f$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $eb09e2865ff9090f$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $eb09e2865ff9090f$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $eb09e2865ff9090f$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $eb09e2865ff9090f$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $eb09e2865ff9090f$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $eb09e2865ff9090f$var$adler();
        h.p(o.dictionary);
        $eb09e2865ff9090f$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $eb09e2865ff9090f$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $eb09e2865ff9090f$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $eb09e2865ff9090f$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $eb09e2865ff9090f$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $eb09e2865ff9090f$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $eb09e2865ff9090f$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($eb09e2865ff9090f$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $eb09e2865ff9090f$var$err(5);
        if (this.s.l) $eb09e2865ff9090f$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $eb09e2865ff9090f$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $eb09e2865ff9090f$var$err(5);
        if (this.s.l) $eb09e2865ff9090f$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $eb09e2865ff9090f$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $eb09e2865ff9090f$var$astrmify([
            $eb09e2865ff9090f$var$bDflt,
            function() {
                return [
                    $eb09e2865ff9090f$var$astrm,
                    $eb09e2865ff9090f$export$ae157b6234afe138
                ];
            }
        ], this, $eb09e2865ff9090f$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $eb09e2865ff9090f$export$ae157b6234afe138(ev.data);
            onmessage = $eb09e2865ff9090f$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $eb09e2865ff9090f$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $eb09e2865ff9090f$var$err(7);
    return $eb09e2865ff9090f$var$cbify(data, opts, [
        $eb09e2865ff9090f$var$bDflt
    ], function(ev) {
        return $eb09e2865ff9090f$var$pbf($eb09e2865ff9090f$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $eb09e2865ff9090f$export$21533ff51b8a0b4a(data, opts) {
    return $eb09e2865ff9090f$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $eb09e2865ff9090f$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $eb09e2865ff9090f$var$u8(32768);
        this.p = new $eb09e2865ff9090f$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $eb09e2865ff9090f$var$err(5);
        if (this.d) $eb09e2865ff9090f$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $eb09e2865ff9090f$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $eb09e2865ff9090f$var$inflt(this.p, this.s, this.o);
        this.ondata($eb09e2865ff9090f$var$slc(dt, bts, this.s.b), this.d);
        this.o = $eb09e2865ff9090f$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $eb09e2865ff9090f$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $eb09e2865ff9090f$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $eb09e2865ff9090f$var$astrmify([
            $eb09e2865ff9090f$var$bInflt,
            function() {
                return [
                    $eb09e2865ff9090f$var$astrm,
                    $eb09e2865ff9090f$export$d1de70a877d6e43c
                ];
            }
        ], this, $eb09e2865ff9090f$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $eb09e2865ff9090f$export$d1de70a877d6e43c(ev.data);
            onmessage = $eb09e2865ff9090f$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $eb09e2865ff9090f$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $eb09e2865ff9090f$var$err(7);
    return $eb09e2865ff9090f$var$cbify(data, opts, [
        $eb09e2865ff9090f$var$bInflt
    ], function(ev) {
        return $eb09e2865ff9090f$var$pbf($eb09e2865ff9090f$export$90366d8b308ba94a(ev.data[0], $eb09e2865ff9090f$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $eb09e2865ff9090f$export$90366d8b308ba94a(data, opts) {
    return $eb09e2865ff9090f$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $eb09e2865ff9090f$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $eb09e2865ff9090f$var$crc();
        this.l = 0;
        this.v = 1;
        $eb09e2865ff9090f$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $eb09e2865ff9090f$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $eb09e2865ff9090f$var$dopt(c, this.o, this.v && $eb09e2865ff9090f$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $eb09e2865ff9090f$var$gzh(raw, this.o), this.v = 0;
        if (f) $eb09e2865ff9090f$var$wbytes(raw, raw.length - 8, this.c.d()), $eb09e2865ff9090f$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $eb09e2865ff9090f$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $eb09e2865ff9090f$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $eb09e2865ff9090f$var$astrmify([
            $eb09e2865ff9090f$var$bDflt,
            $eb09e2865ff9090f$var$gze,
            function() {
                return [
                    $eb09e2865ff9090f$var$astrm,
                    $eb09e2865ff9090f$export$ae157b6234afe138,
                    $eb09e2865ff9090f$export$8e4b66d280bf8342
                ];
            }
        ], this, $eb09e2865ff9090f$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $eb09e2865ff9090f$export$8e4b66d280bf8342(ev.data);
            onmessage = $eb09e2865ff9090f$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $eb09e2865ff9090f$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $eb09e2865ff9090f$var$err(7);
    return $eb09e2865ff9090f$var$cbify(data, opts, [
        $eb09e2865ff9090f$var$bDflt,
        $eb09e2865ff9090f$var$gze,
        function() {
            return [
                $eb09e2865ff9090f$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $eb09e2865ff9090f$var$pbf($eb09e2865ff9090f$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $eb09e2865ff9090f$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $eb09e2865ff9090f$var$crc(), l = data.length;
    c.p(data);
    var d = $eb09e2865ff9090f$var$dopt(data, opts, $eb09e2865ff9090f$var$gzhl(opts), 8), s = d.length;
    return $eb09e2865ff9090f$var$gzh(d, opts), $eb09e2865ff9090f$var$wbytes(d, s - 8, c.d()), $eb09e2865ff9090f$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $eb09e2865ff9090f$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $eb09e2865ff9090f$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $eb09e2865ff9090f$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $eb09e2865ff9090f$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $eb09e2865ff9090f$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $eb09e2865ff9090f$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $eb09e2865ff9090f$var$u8(0);
            this.push(new $eb09e2865ff9090f$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $eb09e2865ff9090f$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $eb09e2865ff9090f$var$astrmify([
            $eb09e2865ff9090f$var$bInflt,
            $eb09e2865ff9090f$var$guze,
            function() {
                return [
                    $eb09e2865ff9090f$var$astrm,
                    $eb09e2865ff9090f$export$d1de70a877d6e43c,
                    $eb09e2865ff9090f$export$4cb607de6db70415
                ];
            }
        ], this, $eb09e2865ff9090f$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $eb09e2865ff9090f$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $eb09e2865ff9090f$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $eb09e2865ff9090f$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $eb09e2865ff9090f$var$err(7);
    return $eb09e2865ff9090f$var$cbify(data, opts, [
        $eb09e2865ff9090f$var$bInflt,
        $eb09e2865ff9090f$var$guze,
        function() {
            return [
                $eb09e2865ff9090f$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $eb09e2865ff9090f$var$pbf($eb09e2865ff9090f$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $eb09e2865ff9090f$export$c80456f7aaba691c(data, opts) {
    var st = $eb09e2865ff9090f$var$gzs(data);
    if (st + 8 > data.length) $eb09e2865ff9090f$var$err(6, 'invalid gzip data');
    return $eb09e2865ff9090f$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $eb09e2865ff9090f$var$u8($eb09e2865ff9090f$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $eb09e2865ff9090f$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $eb09e2865ff9090f$var$adler();
        this.v = 1;
        $eb09e2865ff9090f$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $eb09e2865ff9090f$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $eb09e2865ff9090f$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $eb09e2865ff9090f$var$zlh(raw, this.o), this.v = 0;
        if (f) $eb09e2865ff9090f$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $eb09e2865ff9090f$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $eb09e2865ff9090f$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $eb09e2865ff9090f$var$astrmify([
            $eb09e2865ff9090f$var$bDflt,
            $eb09e2865ff9090f$var$zle,
            function() {
                return [
                    $eb09e2865ff9090f$var$astrm,
                    $eb09e2865ff9090f$export$ae157b6234afe138,
                    $eb09e2865ff9090f$export$4187ccf2467013b9
                ];
            }
        ], this, $eb09e2865ff9090f$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $eb09e2865ff9090f$export$4187ccf2467013b9(ev.data);
            onmessage = $eb09e2865ff9090f$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $eb09e2865ff9090f$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $eb09e2865ff9090f$var$err(7);
    return $eb09e2865ff9090f$var$cbify(data, opts, [
        $eb09e2865ff9090f$var$bDflt,
        $eb09e2865ff9090f$var$zle,
        function() {
            return [
                $eb09e2865ff9090f$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $eb09e2865ff9090f$var$pbf($eb09e2865ff9090f$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $eb09e2865ff9090f$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $eb09e2865ff9090f$var$adler();
    a.p(data);
    var d = $eb09e2865ff9090f$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $eb09e2865ff9090f$var$zlh(d, opts), $eb09e2865ff9090f$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $eb09e2865ff9090f$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $eb09e2865ff9090f$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $eb09e2865ff9090f$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($eb09e2865ff9090f$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $eb09e2865ff9090f$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $eb09e2865ff9090f$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $eb09e2865ff9090f$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $eb09e2865ff9090f$var$astrmify([
            $eb09e2865ff9090f$var$bInflt,
            $eb09e2865ff9090f$var$zule,
            function() {
                return [
                    $eb09e2865ff9090f$var$astrm,
                    $eb09e2865ff9090f$export$d1de70a877d6e43c,
                    $eb09e2865ff9090f$export$af2424f875ff1b17
                ];
            }
        ], this, $eb09e2865ff9090f$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $eb09e2865ff9090f$export$af2424f875ff1b17(ev.data);
            onmessage = $eb09e2865ff9090f$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $eb09e2865ff9090f$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $eb09e2865ff9090f$var$err(7);
    return $eb09e2865ff9090f$var$cbify(data, opts, [
        $eb09e2865ff9090f$var$bInflt,
        $eb09e2865ff9090f$var$zule,
        function() {
            return [
                $eb09e2865ff9090f$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $eb09e2865ff9090f$var$pbf($eb09e2865ff9090f$export$9ec8134f0f1b9fc6(ev.data[0], $eb09e2865ff9090f$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $eb09e2865ff9090f$export$9ec8134f0f1b9fc6(data, opts) {
    return $eb09e2865ff9090f$var$inflt(data.subarray($eb09e2865ff9090f$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $eb09e2865ff9090f$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $eb09e2865ff9090f$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $eb09e2865ff9090f$export$4cb607de6db70415;
        this.I = $eb09e2865ff9090f$export$d1de70a877d6e43c;
        this.Z = $eb09e2865ff9090f$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $eb09e2865ff9090f$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $eb09e2865ff9090f$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $eb09e2865ff9090f$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $eb09e2865ff9090f$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $eb09e2865ff9090f$export$d5adcdd968132151;
        this.I = $eb09e2865ff9090f$export$fff8358d6dbaa9cc;
        this.Z = $eb09e2865ff9090f$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $eb09e2865ff9090f$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $eb09e2865ff9090f$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $eb09e2865ff9090f$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $eb09e2865ff9090f$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $eb09e2865ff9090f$export$cae1ce83fe4a1782(data, opts, cb) : $eb09e2865ff9090f$export$ca7cbb494e731274(data, opts, cb);
}
function $eb09e2865ff9090f$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $eb09e2865ff9090f$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $eb09e2865ff9090f$export$90366d8b308ba94a(data, opts) : $eb09e2865ff9090f$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $eb09e2865ff9090f$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $eb09e2865ff9090f$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $eb09e2865ff9090f$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $eb09e2865ff9090f$var$u8(0),
                op
            ];
            $eb09e2865ff9090f$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $eb09e2865ff9090f$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $eb09e2865ff9090f$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $eb09e2865ff9090f$var$tds = 0;
try {
    $eb09e2865ff9090f$var$td.decode($eb09e2865ff9090f$var$et, {
        stream: true
    });
    $eb09e2865ff9090f$var$tds = 1;
} catch (e) {}
// decode UTF8
var $eb09e2865ff9090f$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $eb09e2865ff9090f$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $eb09e2865ff9090f$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($eb09e2865ff9090f$var$tds) this.t = new TextDecoder();
        else this.p = $eb09e2865ff9090f$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $eb09e2865ff9090f$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $eb09e2865ff9090f$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $eb09e2865ff9090f$var$err(4);
        var dat = new $eb09e2865ff9090f$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $eb09e2865ff9090f$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $eb09e2865ff9090f$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $eb09e2865ff9090f$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $eb09e2865ff9090f$var$err(5);
        if (this.d) $eb09e2865ff9090f$var$err(4);
        this.ondata($eb09e2865ff9090f$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $eb09e2865ff9090f$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $eb09e2865ff9090f$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($eb09e2865ff9090f$var$te) return $eb09e2865ff9090f$var$te.encode(str);
    var l = str.length;
    var ar = new $eb09e2865ff9090f$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $eb09e2865ff9090f$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $eb09e2865ff9090f$var$slc(ar, 0, ai);
}
function $eb09e2865ff9090f$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($eb09e2865ff9090f$var$td) return $eb09e2865ff9090f$var$td.decode(dat);
    else {
        var _a = $eb09e2865ff9090f$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $eb09e2865ff9090f$var$err(8);
        return s;
    }
}
// deflate bit flag
var $eb09e2865ff9090f$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $eb09e2865ff9090f$var$slzh = function(d, b) {
    return b + 30 + $eb09e2865ff9090f$var$b2(d, b + 26) + $eb09e2865ff9090f$var$b2(d, b + 28);
};
// read zip header
var $eb09e2865ff9090f$var$zh = function(d, b, z) {
    var fnl = $eb09e2865ff9090f$var$b2(d, b + 28), fn = $eb09e2865ff9090f$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($eb09e2865ff9090f$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $eb09e2865ff9090f$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $eb09e2865ff9090f$var$z64e(d, es) : [
        bs,
        $eb09e2865ff9090f$var$b4(d, b + 24),
        $eb09e2865ff9090f$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $eb09e2865ff9090f$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $eb09e2865ff9090f$var$b2(d, b + 30) + $eb09e2865ff9090f$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $eb09e2865ff9090f$var$z64e = function(d, b) {
    for(; $eb09e2865ff9090f$var$b2(d, b) != 1; b += 4 + $eb09e2865ff9090f$var$b2(d, b + 2));
    return [
        $eb09e2865ff9090f$var$b8(d, b + 12),
        $eb09e2865ff9090f$var$b8(d, b + 4),
        $eb09e2865ff9090f$var$b8(d, b + 20)
    ];
};
// extra field length
var $eb09e2865ff9090f$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $eb09e2865ff9090f$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $eb09e2865ff9090f$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $eb09e2865ff9090f$var$exfl(ex);
    $eb09e2865ff9090f$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $eb09e2865ff9090f$var$err(10);
    $eb09e2865ff9090f$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $eb09e2865ff9090f$var$wbytes(d, b, f.crc);
        $eb09e2865ff9090f$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $eb09e2865ff9090f$var$wbytes(d, b + 8, f.size);
    }
    $eb09e2865ff9090f$var$wbytes(d, b + 12, fl);
    $eb09e2865ff9090f$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $eb09e2865ff9090f$var$wbytes(d, b, col);
        $eb09e2865ff9090f$var$wbytes(d, b + 6, f.attrs);
        $eb09e2865ff9090f$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $eb09e2865ff9090f$var$wbytes(d, b, +k);
        $eb09e2865ff9090f$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $eb09e2865ff9090f$var$wzf = function(o, b, c, d, e) {
    $eb09e2865ff9090f$var$wbytes(o, b, 0x6054B50); // skip disk
    $eb09e2865ff9090f$var$wbytes(o, b + 8, c);
    $eb09e2865ff9090f$var$wbytes(o, b + 10, c);
    $eb09e2865ff9090f$var$wbytes(o, b + 12, d);
    $eb09e2865ff9090f$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $eb09e2865ff9090f$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $eb09e2865ff9090f$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $eb09e2865ff9090f$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $eb09e2865ff9090f$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $eb09e2865ff9090f$export$2b25194e1767ea06.call(this, filename);
        this.d = new $eb09e2865ff9090f$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $eb09e2865ff9090f$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $eb09e2865ff9090f$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $eb09e2865ff9090f$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $eb09e2865ff9090f$export$2b25194e1767ea06.call(this, filename);
        this.d = new $eb09e2865ff9090f$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $eb09e2865ff9090f$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $eb09e2865ff9090f$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $eb09e2865ff9090f$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $eb09e2865ff9090f$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($eb09e2865ff9090f$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $eb09e2865ff9090f$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $eb09e2865ff9090f$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $eb09e2865ff9090f$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($eb09e2865ff9090f$var$err(11, 0, 1), null, false);
            var header = new $eb09e2865ff9090f$var$u8(hl_1);
            $eb09e2865ff9090f$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $eb09e2865ff9090f$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $eb09e2865ff9090f$var$u8(16);
                        $eb09e2865ff9090f$var$wbytes(dd, 0, 0x8074B50);
                        $eb09e2865ff9090f$var$wbytes(dd, 4, file.crc);
                        $eb09e2865ff9090f$var$wbytes(dd, 8, cl_1);
                        $eb09e2865ff9090f$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($eb09e2865ff9090f$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $eb09e2865ff9090f$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $eb09e2865ff9090f$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $eb09e2865ff9090f$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $eb09e2865ff9090f$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $eb09e2865ff9090f$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $eb09e2865ff9090f$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $eb09e2865ff9090f$var$err(7);
    var r = {};
    $eb09e2865ff9090f$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $eb09e2865ff9090f$var$mt(function() {
            cb(a, b);
        });
    };
    $eb09e2865ff9090f$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $eb09e2865ff9090f$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $eb09e2865ff9090f$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $eb09e2865ff9090f$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $eb09e2865ff9090f$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $eb09e2865ff9090f$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $eb09e2865ff9090f$var$crc(), size = file.length;
        c.p(file);
        var f = $eb09e2865ff9090f$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $eb09e2865ff9090f$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $eb09e2865ff9090f$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $eb09e2865ff9090f$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($eb09e2865ff9090f$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $eb09e2865ff9090f$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($eb09e2865ff9090f$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $eb09e2865ff9090f$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $eb09e2865ff9090f$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $eb09e2865ff9090f$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $eb09e2865ff9090f$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $eb09e2865ff9090f$var$exfl(p.extra);
        if (s > 65535) $eb09e2865ff9090f$var$err(11);
        var d = compression ? $eb09e2865ff9090f$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $eb09e2865ff9090f$var$crc();
        c.p(file);
        files.push($eb09e2865ff9090f$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $eb09e2865ff9090f$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $eb09e2865ff9090f$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $eb09e2865ff9090f$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $eb09e2865ff9090f$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $eb09e2865ff9090f$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $eb09e2865ff9090f$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $eb09e2865ff9090f$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $eb09e2865ff9090f$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $eb09e2865ff9090f$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $eb09e2865ff9090f$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $eb09e2865ff9090f$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $eb09e2865ff9090f$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $eb09e2865ff9090f$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $eb09e2865ff9090f$export$93f81d5bbbb7c6bf
        };
        this.p = $eb09e2865ff9090f$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $eb09e2865ff9090f$var$err(5);
        if (!this.p) $eb09e2865ff9090f$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $eb09e2865ff9090f$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $eb09e2865ff9090f$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $eb09e2865ff9090f$var$b2(buf, i + 6), cmp_1 = $eb09e2865ff9090f$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $eb09e2865ff9090f$var$b2(buf, i + 26), es = $eb09e2865ff9090f$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $eb09e2865ff9090f$var$b4(buf, i + 18), su_1 = $eb09e2865ff9090f$var$b4(buf, i + 22);
                        var fn_1 = $eb09e2865ff9090f$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $eb09e2865ff9090f$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $eb09e2865ff9090f$var$err(5);
                                if (!sc_1) file_1.ondata(null, $eb09e2865ff9090f$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($eb09e2865ff9090f$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($eb09e2865ff9090f$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $eb09e2865ff9090f$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($eb09e2865ff9090f$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $eb09e2865ff9090f$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $eb09e2865ff9090f$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $eb09e2865ff9090f$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $eb09e2865ff9090f$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $eb09e2865ff9090f$var$mt(function() {
            cb(a, b);
        });
    };
    $eb09e2865ff9090f$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $eb09e2865ff9090f$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($eb09e2865ff9090f$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $eb09e2865ff9090f$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $eb09e2865ff9090f$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $eb09e2865ff9090f$var$b4(data, e - 12);
            z = $eb09e2865ff9090f$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $eb09e2865ff9090f$var$b4(data, ze + 32);
                o = $eb09e2865ff9090f$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $eb09e2865ff9090f$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $eb09e2865ff9090f$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $eb09e2865ff9090f$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $eb09e2865ff9090f$export$90366d8b308ba94a(infl, {
                            out: new $eb09e2865ff9090f$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($eb09e2865ff9090f$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($eb09e2865ff9090f$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $eb09e2865ff9090f$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $eb09e2865ff9090f$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $eb09e2865ff9090f$var$err(13);
    var c = $eb09e2865ff9090f$var$b2(data, e + 8);
    if (!c) return {};
    var o = $eb09e2865ff9090f$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $eb09e2865ff9090f$var$b4(data, e - 12);
        z = $eb09e2865ff9090f$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $eb09e2865ff9090f$var$b4(data, ze + 32);
            o = $eb09e2865ff9090f$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $eb09e2865ff9090f$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $eb09e2865ff9090f$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $eb09e2865ff9090f$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $eb09e2865ff9090f$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $eb09e2865ff9090f$var$u8(su)
            });
            else $eb09e2865ff9090f$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}

});

parcelRegister("iTkPg", function(module, exports) {

$parcel$export(module.exports, "NURBSCurve", () => $dc0d84a39d811584$export$12efb26d7429b049);

var $329ek = parcelRequire("329ek");parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");

var $hCQv5 = parcelRequire("hCQv5");
/**
 * This class represents a NURBS curve.
 *
 * Implementation is based on `(x, y [, z=0 [, w=1]])` control points with `w=weight`.
 *
 * @augments Curve
 * @three_import import { NURBSCurve } from 'three/addons/curves/NURBSCurve.js';
 */ class $dc0d84a39d811584$export$12efb26d7429b049 extends (0, $329ek.Curve) {
    /**
	 * Constructs a new NURBS curve.
	 *
	 * @param {number} degree - The NURBS degree.
	 * @param {Array<number>} knots - The knots as a flat array of numbers.
	 * @param {Array<Vector2|Vector3|Vector4>} controlPoints - An array holding control points.
	 * @param {number} [startKnot] - Index of the start knot into the `knots` array.
	 * @param {number} [endKnot] - Index of the end knot into the `knots` array.
	 */ constructor(degree, knots, controlPoints, startKnot, endKnot){
        super();
        const knotsLength = knots ? knots.length - 1 : 0;
        const pointsLength = controlPoints ? controlPoints.length : 0;
        /**
		 * The NURBS degree.
		 *
		 * @type {number}
		 */ this.degree = degree;
        /**
		 * The knots as a flat array of numbers.
		 *
		 * @type {Array<number>}
		 */ this.knots = knots;
        /**
		 * An array of control points.
		 *
		 * @type {Array<Vector4>}
		 */ this.controlPoints = [];
        /**
		 * Index of the start knot into the `knots` array.
		 *
		 * @type {number}
		 */ this.startKnot = startKnot || 0;
        /**
		 * Index of the end knot into the `knots` array.
		 *
		 * @type {number}
		 */ this.endKnot = endKnot || knotsLength;
        for(let i = 0; i < pointsLength; ++i){
            // ensure Vector4 for control points
            const point = controlPoints[i];
            this.controlPoints[i] = new (0, $329ek.Vector4)(point.x, point.y, point.z, point.w);
        }
    }
    /**
	 * This method returns a vector in 3D space for the given interpolation factor.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new (0, $329ek.Vector3)()) {
        const point = optionalTarget;
        const u = this.knots[this.startKnot] + t * (this.knots[this.endKnot] - this.knots[this.startKnot]); // linear mapping t->u
        // following results in (wx, wy, wz, w) homogeneous point
        const hpoint = $hCQv5.calcBSplinePoint(this.degree, this.knots, this.controlPoints, u);
        if (hpoint.w !== 1.0) // project to 3D space: (wx, wy, wz, w) -> (x, y, z, 1)
        hpoint.divideScalar(hpoint.w);
        return point.set(hpoint.x, hpoint.y, hpoint.z);
    }
    /**
	 * Returns a unit vector tangent for the given interpolation factor.
	 *
	 * @param {number} t - The interpolation factor.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The tangent vector.
	 */ getTangent(t, optionalTarget = new (0, $329ek.Vector3)()) {
        const tangent = optionalTarget;
        const u = this.knots[0] + t * (this.knots[this.knots.length - 1] - this.knots[0]);
        const ders = $hCQv5.calcNURBSDerivatives(this.degree, this.knots, this.controlPoints, u, 1);
        tangent.copy(ders[1]).normalize();
        return tangent;
    }
    toJSON() {
        const data = super.toJSON();
        data.degree = this.degree;
        data.knots = [
            ...this.knots
        ];
        data.controlPoints = this.controlPoints.map((p)=>p.toArray());
        data.startKnot = this.startKnot;
        data.endKnot = this.endKnot;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.degree = json.degree;
        this.knots = [
            ...json.knots
        ];
        this.controlPoints = json.controlPoints.map((p)=>new (0, $329ek.Vector4)(p[0], p[1], p[2], p[3]));
        this.startKnot = json.startKnot;
        this.endKnot = json.endKnot;
        return this;
    }
}

});
parcelRegister("hCQv5", function(module, exports) {

$parcel$export(module.exports, "calcBSplinePoint", () => $cd4eb5c823bfdc38$export$3672a5d5ca534534);
$parcel$export(module.exports, "calcNURBSDerivatives", () => $cd4eb5c823bfdc38$export$692f68f163c8f6b);
parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
/**
 * @module NURBSUtils
 * @three_import import * as NURBSUtils from 'three/addons/curves/NURBSUtils.js';
 */ /**
 * Finds knot vector span.
 *
 * @param {number} p - The degree.
 * @param {number} u - The parametric value.
 * @param {Array<number>} U - The knot vector.
 * @return {number} The span.
 */ function $cd4eb5c823bfdc38$export$5d44f085c0641ab4(p, u, U) {
    const n = U.length - p - 1;
    if (u >= U[n]) return n - 1;
    if (u <= U[p]) return p;
    let low = p;
    let high = n;
    let mid = Math.floor((low + high) / 2);
    while(u < U[mid] || u >= U[mid + 1]){
        if (u < U[mid]) high = mid;
        else low = mid;
        mid = Math.floor((low + high) / 2);
    }
    return mid;
}
/**
 * Calculates basis functions. See The NURBS Book, page 70, algorithm A2.2.
 *
 * @param {number} span - The span in which `u` lies.
 * @param {number} u - The parametric value.
 * @param {number} p - The degree.
 * @param {Array<number>} U - The knot vector.
 * @return {Array<number>} Array[p+1] with basis functions values.
 */ function $cd4eb5c823bfdc38$export$bbebd61f407f7f41(span, u, p, U) {
    const N = [];
    const left = [];
    const right = [];
    N[0] = 1.0;
    for(let j = 1; j <= p; ++j){
        left[j] = u - U[span + 1 - j];
        right[j] = U[span + j] - u;
        let saved = 0.0;
        for(let r = 0; r < j; ++r){
            const rv = right[r + 1];
            const lv = left[j - r];
            const temp = N[r] / (rv + lv);
            N[r] = saved + rv * temp;
            saved = lv * temp;
        }
        N[j] = saved;
    }
    return N;
}
/**
 * Calculates B-Spline curve points. See The NURBS Book, page 82, algorithm A3.1.
 *
 * @param {number} p - The degree of the B-Spline.
 * @param {Array<number>} U - The knot vector.
 * @param {Array<Vector4>} P - The control points
 * @param {number} u - The parametric point.
 * @return {Vector4} The point for given `u`.
 */ function $cd4eb5c823bfdc38$export$3672a5d5ca534534(p, U, P, u) {
    const span = $cd4eb5c823bfdc38$export$5d44f085c0641ab4(p, u, U);
    const N = $cd4eb5c823bfdc38$export$bbebd61f407f7f41(span, u, p, U);
    const C = new (0, $329ek.Vector4)(0, 0, 0, 0);
    for(let j = 0; j <= p; ++j){
        const point = P[span - p + j];
        const Nj = N[j];
        const wNj = point.w * Nj;
        C.x += point.x * wNj;
        C.y += point.y * wNj;
        C.z += point.z * wNj;
        C.w += point.w * Nj;
    }
    return C;
}
/**
 * Calculates basis functions derivatives. See The NURBS Book, page 72, algorithm A2.3.
 *
 * @param {number} span - The span in which `u` lies.
 * @param {number} u - The parametric point.
 * @param {number} p - The degree.
 * @param {number} n - number of derivatives to calculate
 * @param {Array<number>} U - The knot vector.
 * @return {Array<Array<number>>} An array[n+1][p+1] with basis functions derivatives.
 */ function $cd4eb5c823bfdc38$export$70bfab2ede47286(span, u, p, n, U) {
    const zeroArr = [];
    for(let i = 0; i <= p; ++i)zeroArr[i] = 0.0;
    const ders = [];
    for(let i = 0; i <= n; ++i)ders[i] = zeroArr.slice(0);
    const ndu = [];
    for(let i = 0; i <= p; ++i)ndu[i] = zeroArr.slice(0);
    ndu[0][0] = 1.0;
    const left = zeroArr.slice(0);
    const right = zeroArr.slice(0);
    for(let j = 1; j <= p; ++j){
        left[j] = u - U[span + 1 - j];
        right[j] = U[span + j] - u;
        let saved = 0.0;
        for(let r = 0; r < j; ++r){
            const rv = right[r + 1];
            const lv = left[j - r];
            ndu[j][r] = rv + lv;
            const temp = ndu[r][j - 1] / ndu[j][r];
            ndu[r][j] = saved + rv * temp;
            saved = lv * temp;
        }
        ndu[j][j] = saved;
    }
    for(let j = 0; j <= p; ++j)ders[0][j] = ndu[j][p];
    for(let r = 0; r <= p; ++r){
        let s1 = 0;
        let s2 = 1;
        const a = [];
        for(let i = 0; i <= p; ++i)a[i] = zeroArr.slice(0);
        a[0][0] = 1.0;
        for(let k = 1; k <= n; ++k){
            let d = 0.0;
            const rk = r - k;
            const pk = p - k;
            if (r >= k) {
                a[s2][0] = a[s1][0] / ndu[pk + 1][rk];
                d = a[s2][0] * ndu[rk][pk];
            }
            const j1 = rk >= -1 ? 1 : -rk;
            const j2 = r - 1 <= pk ? k - 1 : p - r;
            for(let j = j1; j <= j2; ++j){
                a[s2][j] = (a[s1][j] - a[s1][j - 1]) / ndu[pk + 1][rk + j];
                d += a[s2][j] * ndu[rk + j][pk];
            }
            if (r <= pk) {
                a[s2][k] = -a[s1][k - 1] / ndu[pk + 1][r];
                d += a[s2][k] * ndu[r][pk];
            }
            ders[k][r] = d;
            const j = s1;
            s1 = s2;
            s2 = j;
        }
    }
    let r = p;
    for(let k = 1; k <= n; ++k){
        for(let j = 0; j <= p; ++j)ders[k][j] *= r;
        r *= p - k;
    }
    return ders;
}
/**
 * Calculates derivatives of a B-Spline. See The NURBS Book, page 93, algorithm A3.2.
 *
 * @param {number} p - The degree.
 * @param {Array<number>} U - The knot vector.
 * @param {Array<Vector4>} P - The control points
 * @param {number} u - The parametric point.
 * @param {number} nd - The number of derivatives.
 * @return {Array<Vector4>} An array[d+1] with derivatives.
 */ function $cd4eb5c823bfdc38$export$ae5bff7435823e13(p, U, P, u, nd) {
    const du = nd < p ? nd : p;
    const CK = [];
    const span = $cd4eb5c823bfdc38$export$5d44f085c0641ab4(p, u, U);
    const nders = $cd4eb5c823bfdc38$export$70bfab2ede47286(span, u, p, du, U);
    const Pw = [];
    for(let i = 0; i < P.length; ++i){
        const point = P[i].clone();
        const w = point.w;
        point.x *= w;
        point.y *= w;
        point.z *= w;
        Pw[i] = point;
    }
    for(let k = 0; k <= du; ++k){
        const point = Pw[span - p].clone().multiplyScalar(nders[k][0]);
        for(let j = 1; j <= p; ++j)point.add(Pw[span - p + j].clone().multiplyScalar(nders[k][j]));
        CK[k] = point;
    }
    for(let k = du + 1; k <= nd + 1; ++k)CK[k] = new (0, $329ek.Vector4)(0, 0, 0);
    return CK;
}
/**
 * Calculates "K over I".
 *
 * @param {number} k - The K value.
 * @param {number} i - The I value.
 * @return {number} k!/(i!(k-i)!)
 */ function $cd4eb5c823bfdc38$export$3c88b91ac9312187(k, i) {
    let nom = 1;
    for(let j = 2; j <= k; ++j)nom *= j;
    let denom = 1;
    for(let j = 2; j <= i; ++j)denom *= j;
    for(let j = 2; j <= k - i; ++j)denom *= j;
    return nom / denom;
}
/**
 * Calculates derivatives (0-nd) of rational curve. See The NURBS Book, page 127, algorithm A4.2.
 *
 * @param {Array<Vector4>} Pders - Array with derivatives.
 * @return {Array<Vector3>} An array with derivatives for rational curve.
 */ function $cd4eb5c823bfdc38$export$66805edec2c1a55d(Pders) {
    const nd = Pders.length;
    const Aders = [];
    const wders = [];
    for(let i = 0; i < nd; ++i){
        const point = Pders[i];
        Aders[i] = new (0, $329ek.Vector3)(point.x, point.y, point.z);
        wders[i] = point.w;
    }
    const CK = [];
    for(let k = 0; k < nd; ++k){
        const v = Aders[k].clone();
        for(let i = 1; i <= k; ++i)v.sub(CK[k - i].clone().multiplyScalar($cd4eb5c823bfdc38$export$3c88b91ac9312187(k, i) * wders[i]));
        CK[k] = v.divideScalar(wders[0]);
    }
    return CK;
}
/**
 * Calculates NURBS curve derivatives. See The NURBS Book, page 127, algorithm A4.2.
 *
 * @param {number} p - The degree.
 * @param {Array<number>} U - The knot vector.
 * @param {Array<Vector4>} P - The control points in homogeneous space.
 * @param {number} u - The parametric point.
 * @param {number} nd - The number of derivatives.
 * @return {Array<Vector3>} array with derivatives for rational curve.
 */ function $cd4eb5c823bfdc38$export$692f68f163c8f6b(p, U, P, u, nd) {
    const Pders = $cd4eb5c823bfdc38$export$ae5bff7435823e13(p, U, P, u, nd);
    return $cd4eb5c823bfdc38$export$66805edec2c1a55d(Pders);
}
/**
 * Calculates a rational B-Spline surface point. See The NURBS Book, page 134, algorithm A4.3.
 *
 * @param {number} p - The first degree of B-Spline surface.
 * @param {number} q - The second degree of B-Spline surface.
 * @param {Array<number>} U - The first knot vector.
 * @param {Array<number>} V - The second knot vector.
 * @param {Array<Array<Vector4>>} P - The control points in homogeneous space.
 * @param {number} u - The first parametric point.
 * @param {number} v - The second parametric point.
 * @param {Vector3} target - The target vector.
 */ function $cd4eb5c823bfdc38$export$6574b03464941be7(p, q, U, V, P, u, v, target) {
    const uspan = $cd4eb5c823bfdc38$export$5d44f085c0641ab4(p, u, U);
    const vspan = $cd4eb5c823bfdc38$export$5d44f085c0641ab4(q, v, V);
    const Nu = $cd4eb5c823bfdc38$export$bbebd61f407f7f41(uspan, u, p, U);
    const Nv = $cd4eb5c823bfdc38$export$bbebd61f407f7f41(vspan, v, q, V);
    const temp = [];
    for(let l = 0; l <= q; ++l){
        temp[l] = new (0, $329ek.Vector4)(0, 0, 0, 0);
        for(let k = 0; k <= p; ++k){
            const point = P[uspan - p + k][vspan - q + l].clone();
            const w = point.w;
            point.x *= w;
            point.y *= w;
            point.z *= w;
            temp[l].add(point.multiplyScalar(Nu[k]));
        }
    }
    const Sw = new (0, $329ek.Vector4)(0, 0, 0, 0);
    for(let l = 0; l <= q; ++l)Sw.add(temp[l].multiplyScalar(Nv[l]));
    Sw.divideScalar(Sw.w);
    target.set(Sw.x, Sw.y, Sw.z);
}
/**
 * Calculates a rational B-Spline volume point. See The NURBS Book, page 134, algorithm A4.3.
 *
 * @param {number} p - The first degree of B-Spline surface.
 * @param {number} q - The second degree of B-Spline surface.
 * @param {number} r - The third degree of B-Spline surface.
 * @param {Array<number>} U - The first knot vector.
 * @param {Array<number>} V - The second knot vector.
 * @param {Array<number>} W - The third knot vector.
 * @param {Array<Array<Array<Vector4>>>} P - The control points in homogeneous space.
 * @param {number} u - The first parametric point.
 * @param {number} v - The second parametric point.
 * @param {number} w - The third parametric point.
 * @param {Vector3} target - The target vector.
 */ function $cd4eb5c823bfdc38$export$6557862bbd4bd02b(p, q, r, U, V, W, P, u, v, w, target) {
    const uspan = $cd4eb5c823bfdc38$export$5d44f085c0641ab4(p, u, U);
    const vspan = $cd4eb5c823bfdc38$export$5d44f085c0641ab4(q, v, V);
    const wspan = $cd4eb5c823bfdc38$export$5d44f085c0641ab4(r, w, W);
    const Nu = $cd4eb5c823bfdc38$export$bbebd61f407f7f41(uspan, u, p, U);
    const Nv = $cd4eb5c823bfdc38$export$bbebd61f407f7f41(vspan, v, q, V);
    const Nw = $cd4eb5c823bfdc38$export$bbebd61f407f7f41(wspan, w, r, W);
    const temp = [];
    for(let m = 0; m <= r; ++m){
        temp[m] = [];
        for(let l = 0; l <= q; ++l){
            temp[m][l] = new (0, $329ek.Vector4)(0, 0, 0, 0);
            for(let k = 0; k <= p; ++k){
                const point = P[uspan - p + k][vspan - q + l][wspan - r + m].clone();
                const w = point.w;
                point.x *= w;
                point.y *= w;
                point.z *= w;
                temp[m][l].add(point.multiplyScalar(Nu[k]));
            }
        }
    }
    const Sw = new (0, $329ek.Vector4)(0, 0, 0, 0);
    for(let m = 0; m <= r; ++m)for(let l = 0; l <= q; ++l)Sw.add(temp[m][l].multiplyScalar(Nw[m]).multiplyScalar(Nv[l]));
    Sw.divideScalar(Sw.w);
    target.set(Sw.x, Sw.y, Sw.z);
}

});



parcelRegister("eraQQ", function(module, exports) {

$parcel$export(module.exports, "DRACOLoader", () => $a82c012ab1615050$export$45c25de53be259ac);
parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
var $329ek = parcelRequire("329ek");
const $a82c012ab1615050$var$_taskCache = new WeakMap();
/**
 * A loader for the Draco format.
 *
 * [Draco](https://google.github.io/draco/) is an open source library for compressing
 * and decompressing 3D meshes and point clouds. Compressed geometry can be significantly smaller,
 * at the cost of additional decoding time on the client device.
 *
 * Standalone Draco files have a `.drc` extension, and contain vertex positions, normals, colors,
 * and other attributes. Draco files do not contain materials, textures, animation, or node hierarchies –
 * to use these features, embed Draco geometry inside of a glTF file. A normal glTF file can be converted
 * to a Draco-compressed glTF file using [glTF-Pipeline](https://github.com/CesiumGS/gltf-pipeline).
 * When using Draco with glTF, an instance of `DRACOLoader` will be used internally by {@link GLTFLoader}.
 *
 * It is recommended to create one DRACOLoader instance and reuse it to avoid loading and creating
 * multiple decoder instances.
 *
 * `DRACOLoader` will automatically use either the JS or the WASM decoding library, based on
 * browser capabilities.
 *
 * ```js
 * const loader = new DRACOLoader();
 * loader.setDecoderPath( '/examples/jsm/libs/draco/' );
 *
 * const geometry = await dracoLoader.loadAsync( 'models/draco/bunny.drc' );
 * geometry.computeVertexNormals(); // optional
 *
 * dracoLoader.dispose();
 * ```
 *
 * @augments Loader
 * @three_import import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
 */ class $a82c012ab1615050$export$45c25de53be259ac extends (0, $329ek.Loader) {
    /**
	 * Constructs a new Draco loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        this.decoderPath = '';
        this.decoderConfig = {};
        this.decoderBinary = null;
        this.decoderPending = null;
        this.workerLimit = 4;
        this.workerPool = [];
        this.workerNextTaskID = 1;
        this.workerSourceURL = '';
        this.defaultAttributeIDs = {
            position: 'POSITION',
            normal: 'NORMAL',
            color: 'COLOR',
            uv: 'TEX_COORD'
        };
        this.defaultAttributeTypes = {
            position: 'Float32Array',
            normal: 'Float32Array',
            color: 'Float32Array',
            uv: 'Float32Array'
        };
    }
    /**
	 * Provides configuration for the decoder libraries. Configuration cannot be changed after decoding begins.
	 *
	 * @param {string} path - The decoder path.
	 * @return {DRACOLoader} A reference to this loader.
	 */ setDecoderPath(path) {
        this.decoderPath = path;
        return this;
    }
    /**
	 * Provides configuration for the decoder libraries. Configuration cannot be changed after decoding begins.
	 *
	 * @param {{type:('js'|'wasm')}} config - The decoder config.
	 * @return {DRACOLoader} A reference to this loader.
	 */ setDecoderConfig(config) {
        this.decoderConfig = config;
        return this;
    }
    /**
	 * Sets the maximum number of Web Workers to be used during decoding.
	 * A lower limit may be preferable if workers are also for other tasks in the application.
	 *
	 * @param {number} workerLimit - The worker limit.
	 * @return {DRACOLoader} A reference to this loader.
	 */ setWorkerLimit(workerLimit) {
        this.workerLimit = workerLimit;
        return this;
    }
    /**
	 * Starts loading from the given URL and passes the loaded Draco asset
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(BufferGeometry)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const loader = new (0, $329ek.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, (buffer)=>{
            this.parse(buffer, onLoad, onError);
        }, onProgress, onError);
    }
    /**
	 * Parses the given Draco data.
	 *
	 * @param {ArrayBuffer} buffer - The raw Draco data as an array buffer.
	 * @param {function(BufferGeometry)} onLoad - Executed when the loading/parsing process has been finished.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ parse(buffer, onLoad, onError = ()=>{}) {
        this.decodeDracoFile(buffer, onLoad, null, null, (0, $329ek.SRGBColorSpace), onError).catch(onError);
    }
    //
    decodeDracoFile(buffer, callback, attributeIDs, attributeTypes, vertexColorSpace = (0, $329ek.LinearSRGBColorSpace), onError = ()=>{}) {
        const taskConfig = {
            attributeIDs: attributeIDs || this.defaultAttributeIDs,
            attributeTypes: attributeTypes || this.defaultAttributeTypes,
            useUniqueIDs: !!attributeIDs,
            vertexColorSpace: vertexColorSpace
        };
        return this.decodeGeometry(buffer, taskConfig).then(callback).catch(onError);
    }
    decodeGeometry(buffer, taskConfig) {
        const taskKey = JSON.stringify(taskConfig);
        // Check for an existing task using this buffer. A transferred buffer cannot be transferred
        // again from this thread.
        if ($a82c012ab1615050$var$_taskCache.has(buffer)) {
            const cachedTask = $a82c012ab1615050$var$_taskCache.get(buffer);
            if (cachedTask.key === taskKey) return cachedTask.promise;
            else if (buffer.byteLength === 0) // Technically, it would be possible to wait for the previous task to complete,
            // transfer the buffer back, and decode again with the second configuration. That
            // is complex, and I don't know of any reason to decode a Draco buffer twice in
            // different ways, so this is left unimplemented.
            throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        //
        let worker;
        const taskID = this.workerNextTaskID++;
        const taskCost = buffer.byteLength;
        // Obtain a worker and assign a task, and construct a geometry instance
        // when the task completes.
        const geometryPending = this._getWorker(taskID, taskCost).then((_worker)=>{
            worker = _worker;
            return new Promise((resolve, reject)=>{
                worker._callbacks[taskID] = {
                    resolve: resolve,
                    reject: reject
                };
                worker.postMessage({
                    type: 'decode',
                    id: taskID,
                    taskConfig: taskConfig,
                    buffer: buffer
                }, [
                    buffer
                ]);
            // this.debug();
            });
        }).then((message)=>this._createGeometry(message.geometry));
        // Remove task from the task list.
        // Note: replaced '.finally()' with '.catch().then()' block - iOS 11 support (#19416)
        geometryPending.catch(()=>true).then(()=>{
            if (worker && taskID) this._releaseTask(worker, taskID);
        });
        // Cache the task result.
        $a82c012ab1615050$var$_taskCache.set(buffer, {
            key: taskKey,
            promise: geometryPending
        });
        return geometryPending;
    }
    _createGeometry(geometryData) {
        const geometry = new (0, $329ek.BufferGeometry)();
        if (geometryData.index) geometry.setIndex(new (0, $329ek.BufferAttribute)(geometryData.index.array, 1));
        for(let i = 0; i < geometryData.attributes.length; i++){
            const { name: name, array: array, itemSize: itemSize, stride: stride, vertexColorSpace: vertexColorSpace } = geometryData.attributes[i];
            let attribute;
            if (itemSize === stride) attribute = new (0, $329ek.BufferAttribute)(array, itemSize);
            else {
                const buffer = new (0, $329ek.InterleavedBuffer)(array, stride);
                attribute = new (0, $329ek.InterleavedBufferAttribute)(buffer, itemSize, 0);
            }
            if (name === 'color') {
                this._assignVertexColorSpace(attribute, vertexColorSpace);
                attribute.normalized = array instanceof Float32Array === false;
            }
            geometry.setAttribute(name, attribute);
        }
        return geometry;
    }
    _assignVertexColorSpace(attribute, inputColorSpace) {
        // While .drc files do not specify colorspace, the only 'official' tooling
        // is PLY and OBJ converters, which use sRGB. We'll assume sRGB when a .drc
        // file is passed into .load() or .parse(). GLTFLoader uses internal APIs
        // to decode geometry, and vertex colors are already Linear-sRGB in there.
        if (inputColorSpace !== (0, $329ek.SRGBColorSpace)) return;
        const _color = new (0, $329ek.Color)();
        for(let i = 0, il = attribute.count; i < il; i++){
            _color.fromBufferAttribute(attribute, i);
            (0, $329ek.ColorManagement).colorSpaceToWorking(_color, (0, $329ek.SRGBColorSpace));
            attribute.setXYZ(i, _color.r, _color.g, _color.b);
        }
    }
    _loadLibrary(url, responseType) {
        const loader = new (0, $329ek.FileLoader)(this.manager);
        loader.setPath(this.decoderPath);
        loader.setResponseType(responseType);
        loader.setWithCredentials(this.withCredentials);
        return new Promise((resolve, reject)=>{
            loader.load(url, resolve, undefined, reject);
        });
    }
    preload() {
        this._initDecoder();
        return this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        const useJS = typeof WebAssembly !== 'object' || this.decoderConfig.type === 'js';
        const librariesPending = [];
        if (useJS) librariesPending.push(this._loadLibrary('draco_decoder.js', 'text'));
        else {
            librariesPending.push(this._loadLibrary('draco_wasm_wrapper.js', 'text'));
            librariesPending.push(this._loadLibrary('draco_decoder.wasm', 'arraybuffer'));
        }
        this.decoderPending = Promise.all(librariesPending).then((libraries)=>{
            const jsContent = libraries[0];
            if (!useJS) this.decoderConfig.wasmBinary = libraries[1];
            const fn = $a82c012ab1615050$var$DRACOWorker.toString();
            const body = [
                '/* draco decoder */',
                jsContent,
                '',
                '/* worker */',
                fn.substring(fn.indexOf('{') + 1, fn.lastIndexOf('}'))
            ].join('\n');
            this.workerSourceURL = URL.createObjectURL(new Blob([
                body
            ]));
        });
        return this.decoderPending;
    }
    _getWorker(taskID, taskCost) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                const worker = new Worker(this.workerSourceURL);
                worker._callbacks = {};
                worker._taskCosts = {};
                worker._taskLoad = 0;
                worker.postMessage({
                    type: 'init',
                    decoderConfig: this.decoderConfig
                });
                worker.onmessage = function(e) {
                    const message = e.data;
                    switch(message.type){
                        case 'decode':
                            worker._callbacks[message.id].resolve(message);
                            break;
                        case 'error':
                            worker._callbacks[message.id].reject(message);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + message.type + '"');
                    }
                };
                this.workerPool.push(worker);
            } else this.workerPool.sort(function(a, b) {
                return a._taskLoad > b._taskLoad ? -1 : 1;
            });
            const worker = this.workerPool[this.workerPool.length - 1];
            worker._taskCosts[taskID] = taskCost;
            worker._taskLoad += taskCost;
            return worker;
        });
    }
    _releaseTask(worker, taskID) {
        worker._taskLoad -= worker._taskCosts[taskID];
        delete worker._callbacks[taskID];
        delete worker._taskCosts[taskID];
    }
    debug() {
        console.log('Task load: ', this.workerPool.map((worker)=>worker._taskLoad));
    }
    dispose() {
        for(let i = 0; i < this.workerPool.length; ++i)this.workerPool[i].terminate();
        this.workerPool.length = 0;
        if (this.workerSourceURL !== '') URL.revokeObjectURL(this.workerSourceURL);
        return this;
    }
}
/* WEB WORKER */ function $a82c012ab1615050$var$DRACOWorker() {
    let decoderConfig;
    let decoderPending;
    onmessage = function(e) {
        const message = e.data;
        switch(message.type){
            case 'init':
                decoderConfig = message.decoderConfig;
                decoderPending = new Promise(function(resolve /*, reject*/ ) {
                    decoderConfig.onModuleLoaded = function(draco) {
                        // Module is Promise-like. Wrap before resolving to avoid loop.
                        resolve({
                            draco: draco
                        });
                    };
                    DracoDecoderModule(decoderConfig); // eslint-disable-line no-undef
                });
                break;
            case 'decode':
                const buffer = message.buffer;
                const taskConfig = message.taskConfig;
                decoderPending.then((module)=>{
                    const draco = module.draco;
                    const decoder = new draco.Decoder();
                    try {
                        const geometry = decodeGeometry(draco, decoder, new Int8Array(buffer), taskConfig);
                        const buffers = geometry.attributes.map((attr)=>attr.array.buffer);
                        if (geometry.index) buffers.push(geometry.index.array.buffer);
                        self.postMessage({
                            type: 'decode',
                            id: message.id,
                            geometry: geometry
                        }, buffers);
                    } catch (error) {
                        console.error(error);
                        self.postMessage({
                            type: 'error',
                            id: message.id,
                            error: error.message
                        });
                    } finally{
                        draco.destroy(decoder);
                    }
                });
                break;
        }
    };
    function decodeGeometry(draco, decoder, array, taskConfig) {
        const attributeIDs = taskConfig.attributeIDs;
        const attributeTypes = taskConfig.attributeTypes;
        let dracoGeometry;
        let decodingStatus;
        const geometryType = decoder.GetEncodedGeometryType(array);
        if (geometryType === draco.TRIANGULAR_MESH) {
            dracoGeometry = new draco.Mesh();
            decodingStatus = decoder.DecodeArrayToMesh(array, array.byteLength, dracoGeometry);
        } else if (geometryType === draco.POINT_CLOUD) {
            dracoGeometry = new draco.PointCloud();
            decodingStatus = decoder.DecodeArrayToPointCloud(array, array.byteLength, dracoGeometry);
        } else throw new Error('THREE.DRACOLoader: Unexpected geometry type.');
        if (!decodingStatus.ok() || dracoGeometry.ptr === 0) throw new Error('THREE.DRACOLoader: Decoding failed: ' + decodingStatus.error_msg());
        const geometry = {
            index: null,
            attributes: []
        };
        // Gather all vertex attributes.
        for(const attributeName in attributeIDs){
            const attributeType = self[attributeTypes[attributeName]];
            let attribute;
            let attributeID;
            // A Draco file may be created with default vertex attributes, whose attribute IDs
            // are mapped 1:1 from their semantic name (POSITION, NORMAL, ...). Alternatively,
            // a Draco file may contain a custom set of attributes, identified by known unique
            // IDs. glTF files always do the latter, and `.drc` files typically do the former.
            if (taskConfig.useUniqueIDs) {
                attributeID = attributeIDs[attributeName];
                attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
            } else {
                attributeID = decoder.GetAttributeId(dracoGeometry, draco[attributeIDs[attributeName]]);
                if (attributeID === -1) continue;
                attribute = decoder.GetAttribute(dracoGeometry, attributeID);
            }
            const attributeResult = decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute);
            if (attributeName === 'color') attributeResult.vertexColorSpace = taskConfig.vertexColorSpace;
            geometry.attributes.push(attributeResult);
        }
        // Add index.
        if (geometryType === draco.TRIANGULAR_MESH) geometry.index = decodeIndex(draco, decoder, dracoGeometry);
        draco.destroy(dracoGeometry);
        return geometry;
    }
    function decodeIndex(draco, decoder, dracoGeometry) {
        const numFaces = dracoGeometry.num_faces();
        const numIndices = numFaces * 3;
        const byteLength = numIndices * 4;
        const ptr = draco._malloc(byteLength);
        decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
        const index = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
        draco._free(ptr);
        return {
            array: index,
            itemSize: 1
        };
    }
    function decodeAttribute(draco, decoder, dracoGeometry, attributeName, TypedArray, attribute) {
        const count = dracoGeometry.num_points();
        const itemSize = attribute.num_components();
        const dracoDataType = getDracoDataType(draco, TypedArray);
        // Reference: https://registry.khronos.org/glTF/specs/2.0/glTF-2.0.html#data-alignment
        const srcByteStride = itemSize * TypedArray.BYTES_PER_ELEMENT;
        const dstByteStride = Math.ceil(srcByteStride / 4) * 4;
        const dstStride = dstByteStride / TypedArray.BYTES_PER_ELEMENT;
        const srcByteLength = count * srcByteStride;
        const dstByteLength = count * dstByteStride;
        const ptr = draco._malloc(srcByteLength);
        decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dracoDataType, srcByteLength, ptr);
        const srcArray = new TypedArray(draco.HEAPF32.buffer, ptr, srcByteLength / TypedArray.BYTES_PER_ELEMENT);
        let dstArray;
        if (srcByteStride === dstByteStride) // THREE.BufferAttribute
        dstArray = srcArray.slice();
        else {
            // THREE.InterleavedBufferAttribute
            dstArray = new TypedArray(dstByteLength / TypedArray.BYTES_PER_ELEMENT);
            let dstOffset = 0;
            for(let i = 0, il = srcArray.length; i < il; i++){
                for(let j = 0; j < itemSize; j++)dstArray[dstOffset + j] = srcArray[i * itemSize + j];
                dstOffset += dstStride;
            }
        }
        draco._free(ptr);
        return {
            name: attributeName,
            count: count,
            itemSize: itemSize,
            array: dstArray,
            stride: dstStride
        };
    }
    function getDracoDataType(draco, TypedArray) {
        switch(TypedArray){
            case Float32Array:
                return draco.DT_FLOAT32;
            case Int8Array:
                return draco.DT_INT8;
            case Int16Array:
                return draco.DT_INT16;
            case Int32Array:
                return draco.DT_INT32;
            case Uint8Array:
                return draco.DT_UINT8;
            case Uint16Array:
                return draco.DT_UINT16;
            case Uint32Array:
                return draco.DT_UINT32;
        }
    }
}

});

parcelRegister("5RusT", function(module, exports) {

$parcel$export(module.exports, "GLTFLoader", () => $444988b50996c98e$export$aa93f11e7884f0f4);

var $329ek = parcelRequire("329ek");parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");

var $2hEtH = parcelRequire("2hEtH");
/**
 * A loader for the glTF 2.0 format.
 *
 * [glTF](https://www.khronos.org/gltf/} (GL Transmission Format) is an [open format specification]{@link https://github.com/KhronosGroup/glTF/tree/main/specification/2.0)
 * for efficient delivery and loading of 3D content. Assets may be provided either in JSON (.gltf) or binary (.glb)
 * format. External files store textures (.jpg, .png) and additional binary data (.bin). A glTF asset may deliver
 * one or more scenes, including meshes, materials, textures, skins, skeletons, morph targets, animations, lights,
 * and/or cameras.
 *
 * `GLTFLoader` uses {@link ImageBitmapLoader} whenever possible. Be advised that image bitmaps are not
 * automatically GC-collected when they are no longer referenced, and they require special handling during
 * the disposal process.
 *
 * `GLTFLoader` supports the following glTF 2.0 extensions:
 * - KHR_draco_mesh_compression
 * - KHR_materials_clearcoat
 * - KHR_materials_dispersion
 * - KHR_materials_ior
 * - KHR_materials_specular
 * - KHR_materials_transmission
 * - KHR_materials_iridescence
 * - KHR_materials_unlit
 * - KHR_materials_volume
 * - KHR_mesh_quantization
 * - KHR_lights_punctual
 * - KHR_texture_basisu
 * - KHR_texture_transform
 * - EXT_texture_webp
 * - EXT_meshopt_compression
 * - EXT_mesh_gpu_instancing
 *
 * The following glTF 2.0 extension is supported by an external user plugin:
 * - [KHR_materials_variants](https://github.com/takahirox/three-gltf-extensions)
 * - [MSFT_texture_dds](https://github.com/takahirox/three-gltf-extensions)
 * - [KHR_animation_pointer](https://github.com/needle-tools/three-animation-pointer)
 * - [NEEDLE_progressive](https://github.com/needle-tools/gltf-progressive)
 *
 * ```js
 * const loader = new GLTFLoader();
 *
 * // Optional: Provide a DRACOLoader instance to decode compressed mesh data
 * const dracoLoader = new DRACOLoader();
 * dracoLoader.setDecoderPath( '/examples/jsm/libs/draco/' );
 * loader.setDRACOLoader( dracoLoader );
 *
 * const gltf = await loader.loadAsync( 'models/gltf/duck/duck.gltf' );
 * scene.add( gltf.scene );
 * ```
 *
 * @augments Loader
 * @three_import import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
 */ class $444988b50996c98e$export$aa93f11e7884f0f4 extends (0, $329ek.Loader) {
    /**
	 * Constructs a new glTF loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMaterialsDispersionExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMaterialsAnisotropyExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMaterialsBumpExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new $444988b50996c98e$var$GLTFMeshGpuInstancing(parser);
        });
    }
    /**
	 * Starts loading from the given URL and passes the loaded glTF asset
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        let resourcePath;
        if (this.resourcePath !== '') resourcePath = this.resourcePath;
        else if (this.path !== '') {
            // If a base path is set, resources will be relative paths from that plus the relative path of the gltf file
            // Example  path = 'https://my-cnd-server.com/', url = 'assets/models/model.gltf'
            // resourcePath = 'https://my-cnd-server.com/assets/models/'
            // referenced resource 'model.bin' will be loaded from 'https://my-cnd-server.com/assets/models/model.bin'
            // referenced resource '../textures/texture.png' will be loaded from 'https://my-cnd-server.com/assets/textures/texture.png'
            const relativeUrl = (0, $329ek.LoaderUtils).extractUrlBase(url);
            resourcePath = (0, $329ek.LoaderUtils).resolveURL(relativeUrl, this.path);
        } else resourcePath = (0, $329ek.LoaderUtils).extractUrlBase(url);
        // Tells the LoadingManager to track an extra item, which resolves after
        // the model is fully loaded. This means the count of items loaded will
        // be incorrect, but ensures manager.onLoad() does not fire early.
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, $329ek.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    /**
	 * Sets the given Draco loader to this loader. Required for decoding assets
	 * compressed with the `KHR_draco_mesh_compression` extension.
	 *
	 * @param {DRACOLoader} dracoLoader - The Draco loader to set.
	 * @return {GLTFLoader} A reference to this loader.
	 */ setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    /**
	 * Sets the given KTX2 loader to this loader. Required for loading KTX2
	 * compressed textures.
	 *
	 * @param {KTX2Loader} ktx2Loader - The KTX2 loader to set.
	 * @return {GLTFLoader} A reference to this loader.
	 */ setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    /**
	 * Sets the given meshopt decoder. Required for decoding assets
	 * compressed with the `EXT_meshopt_compression` extension.
	 *
	 * @param {Object} meshoptDecoder - The meshopt decoder to set.
	 * @return {GLTFLoader} A reference to this loader.
	 */ setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    /**
	 * Registers a plugin callback. This API is internally used to implement the various
	 * glTF extensions but can also used by third-party code to add additional logic
	 * to the loader.
	 *
	 * @param {function(parser:GLTFParser)} callback - The callback function to register.
	 * @return {GLTFLoader} A reference to this loader.
	 */ register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    /**
	 * Unregisters a plugin callback.
	 *
	 * @param {Function} callback - The callback function to unregister.
	 * @return {GLTFLoader} A reference to this loader.
	 */ unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    /**
	 * Parses the given FBX data and returns the resulting group.
	 *
	 * @param {string|ArrayBuffer} data - The raw glTF data.
	 * @param {string} path - The URL base path.
	 * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        const textDecoder = new TextDecoder();
        if (typeof data === 'string') json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = textDecoder.decode(new Uint8Array(data, 0, 4));
            if (magic === $444988b50996c98e$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[$444988b50996c98e$var$EXTENSIONS.KHR_BINARY_GLTF] = new $444988b50996c98e$var$GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[$444988b50996c98e$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse(textDecoder.decode(data));
        } else json = data;
        if (json.asset === undefined || json.asset.version[0] < 2) {
            if (onError) onError(new Error('THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.'));
            return;
        }
        const parser = new $444988b50996c98e$var$GLTFParser(json, {
            path: path || this.resourcePath || '',
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            if (!plugin.name) console.error('THREE.GLTFLoader: Invalid plugin found: missing name');
            plugins[plugin.name] = plugin;
            // Workaround to avoid determining as unknown extension
            // in addUnknownExtensionsToUserData().
            // Remove this workaround if we move all the existing
            // extension handlers to plugin system
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new $444988b50996c98e$var$GLTFMaterialsUnlitExtension();
                    break;
                case $444988b50996c98e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new $444988b50996c98e$var$GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case $444988b50996c98e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new $444988b50996c98e$var$GLTFTextureTransformExtension();
                    break;
                case $444988b50996c98e$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new $444988b50996c98e$var$GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    /**
	 * Async version of {@link GLTFLoader#parse}.
	 *
	 * @async
	 * @param {string|ArrayBuffer} data - The raw glTF data.
	 * @param {string} path - The URL base path.
	 * @return {Promise<GLTFLoader~LoadObject>} A Promise that resolves with the loaded glTF when the parsing has been finished.
	 */ parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
}
/* GLTFREGISTRY */ function $444988b50996c98e$var$GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
/*********************************/ /********** EXTENSIONS ***********/ /*********************************/ const $444988b50996c98e$var$EXTENSIONS = {
    KHR_BINARY_GLTF: 'KHR_binary_glTF',
    KHR_DRACO_MESH_COMPRESSION: 'KHR_draco_mesh_compression',
    KHR_LIGHTS_PUNCTUAL: 'KHR_lights_punctual',
    KHR_MATERIALS_CLEARCOAT: 'KHR_materials_clearcoat',
    KHR_MATERIALS_DISPERSION: 'KHR_materials_dispersion',
    KHR_MATERIALS_IOR: 'KHR_materials_ior',
    KHR_MATERIALS_SHEEN: 'KHR_materials_sheen',
    KHR_MATERIALS_SPECULAR: 'KHR_materials_specular',
    KHR_MATERIALS_TRANSMISSION: 'KHR_materials_transmission',
    KHR_MATERIALS_IRIDESCENCE: 'KHR_materials_iridescence',
    KHR_MATERIALS_ANISOTROPY: 'KHR_materials_anisotropy',
    KHR_MATERIALS_UNLIT: 'KHR_materials_unlit',
    KHR_MATERIALS_VOLUME: 'KHR_materials_volume',
    KHR_TEXTURE_BASISU: 'KHR_texture_basisu',
    KHR_TEXTURE_TRANSFORM: 'KHR_texture_transform',
    KHR_MESH_QUANTIZATION: 'KHR_mesh_quantization',
    KHR_MATERIALS_EMISSIVE_STRENGTH: 'KHR_materials_emissive_strength',
    EXT_MATERIALS_BUMP: 'EXT_materials_bump',
    EXT_TEXTURE_WEBP: 'EXT_texture_webp',
    EXT_TEXTURE_AVIF: 'EXT_texture_avif',
    EXT_MESHOPT_COMPRESSION: 'EXT_meshopt_compression',
    EXT_MESH_GPU_INSTANCING: 'EXT_mesh_gpu_instancing'
};
/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 *
 * @private
 */ class $444988b50996c98e$var$GLTFLightsExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        // Object3D instance caches
        this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = 'light:' + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, $329ek.Color)(0xffffff);
        if (lightDef.color !== undefined) color.setRGB(lightDef.color[0], lightDef.color[1], lightDef.color[2], (0, $329ek.LinearSRGBColorSpace));
        const range = lightDef.range !== undefined ? lightDef.range : 0;
        switch(lightDef.type){
            case 'directional':
                lightNode = new (0, $329ek.DirectionalLight)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case 'point':
                lightNode = new (0, $329ek.PointLight)(color);
                lightNode.distance = range;
                break;
            case 'spot':
                lightNode = new (0, $329ek.SpotLight)(color);
                lightNode.distance = range;
                // Handle spotlight properties.
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error('THREE.GLTFLoader: Unexpected light type: ' + lightDef.type);
        }
        // Some lights (e.g. spot) default to a position other than the origin. Reset the position
        // here, because node-level parsing will only override position if explicitly specified.
        lightNode.position.set(0, 0, 0);
        $444988b50996c98e$var$assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || 'light_' + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== 'light') return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self1 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === undefined) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self1.cache, lightIndex, light);
        });
    }
}
/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $329ek.MeshBasicMaterial;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, $329ek.Color)(1.0, 1.0, 1.0);
        materialParams.opacity = 1.0;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], (0, $329ek.LinearSRGBColorSpace));
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, (0, $329ek.SRGBColorSpace)));
        }
        return Promise.all(pending);
    }
}
/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== undefined) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
}
/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsClearcoatExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $329ek.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== undefined) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'clearcoatMap', extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== undefined) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'clearcoatRoughnessMap', extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== undefined) {
            pending.push(parser.assignTexture(materialParams, 'clearcoatNormalMap', extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== undefined) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, $329ek.Vector2)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
}
/**
 * Materials dispersion Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_dispersion
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsDispersionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_DISPERSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $329ek.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.dispersion = extension.dispersion !== undefined ? extension.dispersion : 0;
        return Promise.resolve();
    }
}
/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsIridescenceExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $329ek.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== undefined) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'iridescenceMap', extension.iridescenceTexture));
        if (extension.iridescenceIor !== undefined) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === undefined) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== undefined) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== undefined) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'iridescenceThicknessMap', extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
}
/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsSheenExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $329ek.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, $329ek.Color)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== undefined) {
            const colorFactor = extension.sheenColorFactor;
            materialParams.sheenColor.setRGB(colorFactor[0], colorFactor[1], colorFactor[2], (0, $329ek.LinearSRGBColorSpace));
        }
        if (extension.sheenRoughnessFactor !== undefined) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'sheenColorMap', extension.sheenColorTexture, (0, $329ek.SRGBColorSpace)));
        if (extension.sheenRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'sheenRoughnessMap', extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
}
/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsTransmissionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $329ek.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== undefined) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'transmissionMap', extension.transmissionTexture));
        return Promise.all(pending);
    }
}
/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsVolumeExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $329ek.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'thicknessMap', extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, $329ek.Color)().setRGB(colorArray[0], colorArray[1], colorArray[2], (0, $329ek.LinearSRGBColorSpace));
        return Promise.all(pending);
    }
}
/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsIorExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $329ek.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;
        return Promise.resolve();
    }
}
/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsSpecularExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $329ek.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;
        if (extension.specularTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'specularIntensityMap', extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, $329ek.Color)().setRGB(colorArray[0], colorArray[1], colorArray[2], (0, $329ek.LinearSRGBColorSpace));
        if (extension.specularColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'specularColorMap', extension.specularColorTexture, (0, $329ek.SRGBColorSpace)));
        return Promise.all(pending);
    }
}
/**
 * Materials bump Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/EXT_materials_bump
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsBumpExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.EXT_MATERIALS_BUMP;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $329ek.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.bumpScale = extension.bumpFactor !== undefined ? extension.bumpFactor : 1.0;
        if (extension.bumpTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'bumpMap', extension.bumpTexture));
        return Promise.all(pending);
    }
}
/**
 * Materials anisotropy Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_anisotropy
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMaterialsAnisotropyExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $329ek.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.anisotropyStrength !== undefined) materialParams.anisotropy = extension.anisotropyStrength;
        if (extension.anisotropyRotation !== undefined) materialParams.anisotropyRotation = extension.anisotropyRotation;
        if (extension.anisotropyTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'anisotropyMap', extension.anisotropyTexture));
        return Promise.all(pending);
    }
}
/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 *
 * @private
 */ class $444988b50996c98e$var$GLTFTextureBasisUExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error('THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures');
            else // Assumes that the extension is optional and that a fallback texture is present
            return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 *
 * @private
 */ class $444988b50996c98e$var$GLTFTextureWebPExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.EXT_TEXTURE_WEBP;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 *
 * @private
 */ class $444988b50996c98e$var$GLTFTextureAVIFExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $444988b50996c98e$var$EXTENSIONS.EXT_TEXTURE_AVIF;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMeshoptCompression {
    constructor(parser){
        this.name = $444988b50996c98e$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency('buffer', extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error('THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files');
                else // Assumes that the extension is optional and that fallback buffer data is present
                return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res) {
                    return res.buffer;
                });
                else // Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
                return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
}
/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMeshGpuInstancing {
    constructor(parser){
        this.name = $444988b50996c98e$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        // No Points or Lines + Instancing support yet
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== $444988b50996c98e$var$WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== $444988b50996c98e$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== $444988b50996c98e$var$WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        // @TODO: Can we support InstancedMesh + SkinnedMesh?
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency('accessor', attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count; // All attribute counts should be same
            const instancedMeshes = [];
            for (const mesh of meshes){
                // Temporal variables
                const m = new (0, $329ek.Matrix4)();
                const p = new (0, $329ek.Vector3)();
                const q = new (0, $329ek.Quaternion)();
                const s = new (0, $329ek.Vector3)(1, 1, 1);
                const instancedMesh = new (0, $329ek.InstancedMesh)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                // Add instance attributes to the geometry, excluding TRS.
                for(const attributeName in attributes){
                    if (attributeName === '_COLOR_0') {
                        const attr = attributes[attributeName];
                        instancedMesh.instanceColor = new (0, $329ek.InstancedBufferAttribute)(attr.array, attr.itemSize, attr.normalized);
                    } else if (attributeName !== 'TRANSLATION' && attributeName !== 'ROTATION' && attributeName !== 'SCALE') mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                }
                // Just in case
                (0, $329ek.Object3D).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
}
/* BINARY EXTENSION */ const $444988b50996c98e$var$BINARY_EXTENSION_HEADER_MAGIC = 'glTF';
const $444988b50996c98e$var$BINARY_EXTENSION_HEADER_LENGTH = 12;
const $444988b50996c98e$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 0x4E4F534A,
    BIN: 0x004E4942
};
class $444988b50996c98e$var$GLTFBinaryExtension {
    constructor(data){
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, $444988b50996c98e$var$BINARY_EXTENSION_HEADER_LENGTH);
        const textDecoder = new TextDecoder();
        this.header = {
            magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== $444988b50996c98e$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error('THREE.GLTFLoader: Unsupported glTF-Binary header.');
        else if (this.header.version < 2.0) throw new Error('THREE.GLTFLoader: Legacy binary file detected.');
        const chunkContentsLength = this.header.length - $444988b50996c98e$var$BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, $444988b50996c98e$var$BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === $444988b50996c98e$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, $444988b50996c98e$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = textDecoder.decode(contentArray);
            } else if (chunkType === $444988b50996c98e$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = $444988b50996c98e$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            // Clients must ignore chunks with unknown types.
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error('THREE.GLTFLoader: JSON content not found.');
    }
}
/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 *
 * @private
 */ class $444988b50996c98e$var$GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error('THREE.GLTFLoader: No DRACOLoader instance provided.');
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = $444988b50996c98e$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = $444988b50996c98e$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== undefined) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = $444988b50996c98e$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency('bufferView', bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve, reject) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== undefined) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap, (0, $329ek.LinearSRGBColorSpace), reject);
            });
        });
    }
}
/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 *
 * @private
 */ class $444988b50996c98e$var$GLTFTextureTransformExtension {
    constructor(){
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
        if ((transform.texCoord === undefined || transform.texCoord === texture.channel) && transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) // See https://github.com/mrdoob/three.js/issues/21819.
        return texture;
        texture = texture.clone();
        if (transform.texCoord !== undefined) texture.channel = transform.texCoord;
        if (transform.offset !== undefined) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== undefined) texture.rotation = transform.rotation;
        if (transform.scale !== undefined) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
}
/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 *
 * @private
 */ class $444988b50996c98e$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $444988b50996c98e$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
/*********************************/ /********** INTERPOLATION ********/ /*********************************/ // Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
class $444988b50996c98e$var$GLTFCubicSplineInterpolant extends (0, $329ek.Interpolant) {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
        // Copies a sample value to the result buffer. See description of glTF
        // CUBICSPLINE values layout in interpolate_() function below.
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        // Layout of keyframe output values for CUBICSPLINE animations:
        //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride]; // splineVertex_k
            const m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
            const p1 = values[offset1 + i + stride]; // splineVertex_k+1
            const m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
}
const $444988b50996c98e$var$_quaternion = new (0, $329ek.Quaternion)();
class $444988b50996c98e$var$GLTFCubicSplineQuaternionInterpolant extends $444988b50996c98e$var$GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        $444988b50996c98e$var$_quaternion.fromArray(result).normalize().toArray(result);
        return result;
    }
}
/*********************************/ /********** INTERNALS ************/ /*********************************/ /* CONSTANTS */ const $444988b50996c98e$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const $444988b50996c98e$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const $444988b50996c98e$var$WEBGL_FILTERS = {
    9728: (0, $329ek.NearestFilter),
    9729: (0, $329ek.LinearFilter),
    9984: (0, $329ek.NearestMipmapNearestFilter),
    9985: (0, $329ek.LinearMipmapNearestFilter),
    9986: (0, $329ek.NearestMipmapLinearFilter),
    9987: (0, $329ek.LinearMipmapLinearFilter)
};
const $444988b50996c98e$var$WEBGL_WRAPPINGS = {
    33071: (0, $329ek.ClampToEdgeWrapping),
    33648: (0, $329ek.MirroredRepeatWrapping),
    10497: (0, $329ek.RepeatWrapping)
};
const $444988b50996c98e$var$WEBGL_TYPE_SIZES = {
    'SCALAR': 1,
    'VEC2': 2,
    'VEC3': 3,
    'VEC4': 4,
    'MAT2': 4,
    'MAT3': 9,
    'MAT4': 16
};
const $444988b50996c98e$var$ATTRIBUTES = {
    POSITION: 'position',
    NORMAL: 'normal',
    TANGENT: 'tangent',
    TEXCOORD_0: 'uv',
    TEXCOORD_1: 'uv1',
    TEXCOORD_2: 'uv2',
    TEXCOORD_3: 'uv3',
    COLOR_0: 'color',
    WEIGHTS_0: 'skinWeight',
    JOINTS_0: 'skinIndex'
};
const $444988b50996c98e$var$PATH_PROPERTIES = {
    scale: 'scale',
    translation: 'position',
    rotation: 'quaternion',
    weights: 'morphTargetInfluences'
};
const $444988b50996c98e$var$INTERPOLATION = {
    CUBICSPLINE: undefined,
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $329ek.InterpolateLinear),
    STEP: (0, $329ek.InterpolateDiscrete)
};
const $444988b50996c98e$var$ALPHA_MODES = {
    OPAQUE: 'OPAQUE',
    MASK: 'MASK',
    BLEND: 'BLEND'
};
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 *
 * @private
 * @param {Object<string, Material>} cache
 * @return {Material}
 */ function $444988b50996c98e$var$createDefaultMaterial(cache) {
    if (cache['DefaultMaterial'] === undefined) cache['DefaultMaterial'] = new (0, $329ek.MeshStandardMaterial)({
        color: 0xFFFFFF,
        emissive: 0x000000,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, $329ek.FrontSide)
    });
    return cache['DefaultMaterial'];
}
function $444988b50996c98e$var$addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    // Add unknown glTF extensions to an object's userData.
    for(const name in objectDef.extensions)if (knownExtensions[name] === undefined) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
/**
 *
 * @private
 * @param {Object3D|Material|BufferGeometry|Object|AnimationClip} object
 * @param {GLTF.definition} gltfDef
 */ function $444988b50996c98e$var$assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== undefined) {
        if (typeof gltfDef.extras === 'object') Object.assign(object.userData, gltfDef.extras);
        else console.warn('THREE.GLTFLoader: Ignoring primitive type .extras, ' + gltfDef.extras);
    }
}
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @private
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $444988b50996c98e$var$addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== undefined) hasMorphPosition = true;
        if (target.NORMAL !== undefined) hasMorphNormal = true;
        if (target.COLOR_0 !== undefined) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== undefined ? parser.getDependency('accessor', target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== undefined ? parser.getDependency('accessor', target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== undefined ? parser.getDependency('accessor', target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
/**
 *
 * @private
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */ function $444988b50996c98e$var$updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== undefined) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    // .extras has user-defined data, so check that .extras.targetNames is an array.
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn('THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.');
    }
}
function $444988b50996c98e$var$createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[$444988b50996c98e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) geometryKey = 'draco:' + dracoExtension.bufferView + ':' + dracoExtension.indices + ':' + $444988b50996c98e$var$createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ':' + $444988b50996c98e$var$createAttributesKey(primitiveDef.attributes) + ':' + primitiveDef.mode;
    if (primitiveDef.targets !== undefined) for(let i = 0, il = primitiveDef.targets.length; i < il; i++)geometryKey += ':' + $444988b50996c98e$var$createAttributesKey(primitiveDef.targets[i]);
    return geometryKey;
}
function $444988b50996c98e$var$createAttributesKey(attributes) {
    let attributesKey = '';
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ':' + attributes[keys[i]] + ';';
    return attributesKey;
}
function $444988b50996c98e$var$getNormalizedComponentScale(constructor) {
    // Reference:
    // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error('THREE.GLTFLoader: Unsupported normalized accessor component type.');
    }
}
function $444988b50996c98e$var$getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return 'image/jpeg';
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return 'image/webp';
    if (uri.search(/\.ktx2($|\?)/i) > 0 || uri.search(/^data\:image\/ktx2/) === 0) return 'image/ktx2';
    return 'image/png';
}
const $444988b50996c98e$var$_identityMatrix = new (0, $329ek.Matrix4)();
/* GLTF PARSER */ class $444988b50996c98e$var$GLTFParser {
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        // loader object cache
        this.cache = new $444988b50996c98e$var$GLTFRegistry();
        // associations between Three.js objects and glTF elements
        this.associations = new Map();
        // BufferGeometry caching
        this.primitiveCache = {};
        // Node cache
        this.nodeCache = {};
        // Object3D instance caches
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        // Track node names, to ensure no duplicates
        this.nodeNamesUsed = {};
        // Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
        // expensive work of uploading a texture to the GPU off the main thread.
        let isSafari = false;
        let safariVersion = -1;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== 'undefined') {
            const userAgent = navigator.userAgent;
            isSafari = /^((?!chrome|android).)*safari/i.test(userAgent) === true;
            const safariMatch = userAgent.match(/Version\/(\d+)/);
            safariVersion = isSafari && safariMatch ? parseInt(safariMatch[1], 10) : -1;
            isFirefox = userAgent.indexOf('Firefox') > -1;
            firefoxVersion = isFirefox ? userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === 'undefined' || isSafari && safariVersion < 17 || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, $329ek.TextureLoader)(this.options.manager);
        else this.textureLoader = new (0, $329ek.ImageBitmapLoader)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, $329ek.FileLoader)(this.options.manager);
        this.fileLoader.setResponseType('arraybuffer');
        if (this.options.crossOrigin === 'use-credentials') this.fileLoader.setWithCredentials(true);
    }
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        // Clear the loader cache
        this.cache.removeAll();
        this.nodeCache = {};
        // Mark the special nodes/meshes in json for efficient parse
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies('scene'),
                parser.getDependencies('animation'),
                parser.getDependencies('camera')
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser: parser,
                userData: {}
            };
            $444988b50996c98e$var$addUnknownExtensionsToUserData(extensions, result, json);
            $444988b50996c98e$var$assignExtrasToUserData(result, json);
            return Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                for (const scene of result.scenes)scene.updateMatrixWorld();
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
	 * Marks the special nodes/meshes in json for efficient parse.
	 *
	 * @private
	 */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        // Nothing in the node definition indicates whether it is a Bone or an
        // Object3D. Use the skins' joint references to mark bones.
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        // Iterate over all nodes, marking references to shared resources,
        // as well as skeleton joints.
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== undefined) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                // Nothing in the mesh definition indicates whether it is
                // a SkinnedMesh or Mesh. Use the node's mesh reference
                // to mark SkinnedMesh if node has skin.
                if (nodeDef.skin !== undefined) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== undefined) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
	 * Counts references to shared node / Object3D resources. These resources
	 * can be reused, or "instantiated", at multiple nodes in the scene
	 * hierarchy. Mesh, Camera, and Light instances are instantiated and must
	 * be marked. Non-scenegraph resources (like Materials, Geometries, and
	 * Textures) can be reused directly and are not marked here.
	 *
	 * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
	 *
	 * @private
	 * @param {Object} cache
	 * @param {Object3D} index
	 */ _addNodeRef(cache, index) {
        if (index === undefined) return;
        if (cache.refs[index] === undefined) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /**
	 * Returns a reference to a shared resource, cloning it if necessary.
	 *
	 * @private
	 * @param {Object} cache
	 * @param {number} index
	 * @param {Object} object
	 * @return {Object}
	 */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        // Propagates mappings to the cloned object, prevents mappings on the
        // original object from being lost.
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += '_instance_' + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
	 * Requests the specified dependency asynchronously, with caching.
	 *
	 * @private
	 * @param {string} type
	 * @param {number} index
	 * @return {Promise<Object3D|Material|Texture|AnimationClip|ArrayBuffer|Object>}
	 */ getDependency(type, index) {
        const cacheKey = type + ':' + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case 'scene':
                    dependency = this.loadScene(index);
                    break;
                case 'node':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case 'mesh':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case 'accessor':
                    dependency = this.loadAccessor(index);
                    break;
                case 'bufferView':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case 'buffer':
                    dependency = this.loadBuffer(index);
                    break;
                case 'material':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case 'texture':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case 'skin':
                    dependency = this.loadSkin(index);
                    break;
                case 'animation':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case 'camera':
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error('Unknown type: ' + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
	 * Requests all dependencies of the specified type asynchronously, with caching.
	 *
	 * @private
	 * @param {string} type
	 * @return {Promise<Array<Object>>}
	 */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === 'mesh' ? 'es' : 's')] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 *
	 * @private
	 * @param {number} bufferIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== 'arraybuffer') throw new Error('THREE.GLTFLoader: ' + bufferDef.type + ' buffer type is not supported.');
        // If present, GLB container is required to be the first buffer.
        if (bufferDef.uri === undefined && bufferIndex === 0) return Promise.resolve(this.extensions[$444988b50996c98e$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            loader.load((0, $329ek.LoaderUtils).resolveURL(bufferDef.uri, options.path), resolve, undefined, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 *
	 * @private
	 * @param {number} bufferViewIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency('buffer', bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
	 *
	 * @private
	 * @param {number} accessorIndex
	 * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
	 */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {
            const itemSize = $444988b50996c98e$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $444988b50996c98e$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, $329ek.BufferAttribute)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== undefined) pendingBufferViews.push(this.getDependency('bufferView', accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== undefined) {
            pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = $444988b50996c98e$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $444988b50996c98e$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            // The buffer is not interleaved if the stride is the item size in bytes.
            if (byteStride && byteStride !== itemBytes) {
                // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
                // This makes sure that IBA.count reflects accessor.count properly
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = 'InterleavedBuffer:' + accessorDef.bufferView + ':' + accessorDef.componentType + ':' + ibSlice + ':' + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    // Integer parameters to IB/IBA are in array elements, not bytes.
                    ib = new (0, $329ek.InterleavedBuffer)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, $329ek.InterleavedBufferAttribute)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, $329ek.BufferAttribute)(array, itemSize, normalized);
            }
            // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
            if (accessorDef.sparse !== undefined) {
                const itemSizeIndices = $444988b50996c98e$var$WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = $444988b50996c98e$var$WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                bufferAttribute = new (0, $329ek.BufferAttribute)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                // Ignore normalized since we copy from sparse
                bufferAttribute.normalized = false;
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error('THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.');
                }
                bufferAttribute.normalized = normalized;
            }
            return bufferAttribute;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
	 *
	 * @private
	 * @param {number} textureIndex
	 * @return {Promise<?Texture>}
	 */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const handler = options.manager.getHandler(sourceDef.uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ':' + textureDef.sampler;
        if (this.textureCache[cacheKey]) // See https://github.com/mrdoob/three.js/issues/21559.
        return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || '';
            if (texture.name === '' && typeof sourceDef.uri === 'string' && sourceDef.uri.startsWith('data:image/') === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = $444988b50996c98e$var$WEBGL_FILTERS[sampler.magFilter] || (0, $329ek.LinearFilter);
            texture.minFilter = $444988b50996c98e$var$WEBGL_FILTERS[sampler.minFilter] || (0, $329ek.LinearMipmapLinearFilter);
            texture.wrapS = $444988b50996c98e$var$WEBGL_WRAPPINGS[sampler.wrapS] || (0, $329ek.RepeatWrapping);
            texture.wrapT = $444988b50996c98e$var$WEBGL_WRAPPINGS[sampler.wrapT] || (0, $329ek.RepeatWrapping);
            texture.generateMipmaps = !texture.isCompressedTexture && texture.minFilter !== (0, $329ek.NearestFilter) && texture.minFilter !== (0, $329ek.LinearFilter);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== undefined) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || '';
        let isObjectURL = false;
        if (sourceDef.bufferView !== undefined) // Load binary image data from bufferView, if provided.
        sourceURI = parser.getDependency('bufferView', sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === undefined) throw new Error('THREE.GLTFLoader: Image ' + sourceIndex + ' is missing URI and bufferView');
        const promise = Promise.resolve(sourceURI).then(function(sourceURI) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, $329ek.Texture)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, $329ek.LoaderUtils).resolveURL(sourceURI, options.path), onLoad, undefined, reject);
            });
        }).then(function(texture) {
            // Clean up resources and configure Texture.
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            $444988b50996c98e$var$assignExtrasToUserData(texture, sourceDef);
            texture.userData.mimeType = sourceDef.mimeType || $444988b50996c98e$var$getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error('THREE.GLTFLoader: Couldn\'t load texture', sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
	 * Asynchronously assigns a texture to the given material parameters.
	 *
	 * @private
	 * @param {Object} materialParams
	 * @param {string} mapName
	 * @param {Object} mapDef
	 * @param {string} [colorSpace]
	 * @return {Promise<Texture>}
	 */ assignTexture(materialParams, mapName, mapDef, colorSpace) {
        const parser = this;
        return this.getDependency('texture', mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== undefined && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[$444988b50996c98e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== undefined ? mapDef.extensions[$444988b50996c98e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[$444988b50996c98e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (colorSpace !== undefined) texture.colorSpace = colorSpace;
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
	 * Assigns final material to a Mesh, Line, or Points instance. The instance
	 * already has a material (generated from the glTF material options alone)
	 * but reuse of the same glTF material may require multiple threejs materials
	 * to accommodate different primitive types, defines, etc. New materials will
	 * be created if necessary, and reused from a cache.
	 *
	 * @private
	 * @param {Object3D} mesh Mesh, Line, or Points instance.
	 */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === undefined;
        const useVertexColors = geometry.attributes.color !== undefined;
        const useFlatShading = geometry.attributes.normal === undefined;
        if (mesh.isPoints) {
            const cacheKey = 'PointsMaterial:' + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, $329ek.PointsMaterial)();
                (0, $329ek.Material).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = 'LineBasicMaterial:' + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, $329ek.LineBasicMaterial)();
                (0, $329ek.Material).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        // Clone the material if it will be modified
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = 'ClonedMaterial:' + material.uuid + ':';
            if (useDerivativeTangents) cacheKey += 'derivative-tangents:';
            if (useVertexColors) cacheKey += 'vertex-colors:';
            if (useFlatShading) cacheKey += 'flat-shading:';
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    // https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, $329ek.MeshStandardMaterial;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
	 *
	 * @private
	 * @param {number} materialIndex
	 * @return {Promise<Material>}
	 */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[$444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[$444988b50996c98e$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            // Specification:
            // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, $329ek.Color)(1.0, 1.0, 1.0);
            materialParams.opacity = 1.0;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], (0, $329ek.LinearSRGBColorSpace));
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, (0, $329ek.SRGBColorSpace)));
            materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
            materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;
            if (metallicRoughness.metallicRoughnessTexture !== undefined) {
                pending.push(parser.assignTexture(materialParams, 'metalnessMap', metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, 'roughnessMap', metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, $329ek.DoubleSide);
        const alphaMode = materialDef.alphaMode || $444988b50996c98e$var$ALPHA_MODES.OPAQUE;
        if (alphaMode === $444988b50996c98e$var$ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            // See: https://github.com/mrdoob/three.js/issues/17706
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === $444988b50996c98e$var$ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== undefined && materialType !== (0, $329ek.MeshBasicMaterial)) {
            pending.push(parser.assignTexture(materialParams, 'normalMap', materialDef.normalTexture));
            materialParams.normalScale = new (0, $329ek.Vector2)(1, 1);
            if (materialDef.normalTexture.scale !== undefined) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== undefined && materialType !== (0, $329ek.MeshBasicMaterial)) {
            pending.push(parser.assignTexture(materialParams, 'aoMap', materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== undefined) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== undefined && materialType !== (0, $329ek.MeshBasicMaterial)) {
            const emissiveFactor = materialDef.emissiveFactor;
            materialParams.emissive = new (0, $329ek.Color)().setRGB(emissiveFactor[0], emissiveFactor[1], emissiveFactor[2], (0, $329ek.LinearSRGBColorSpace));
        }
        if (materialDef.emissiveTexture !== undefined && materialType !== (0, $329ek.MeshBasicMaterial)) pending.push(parser.assignTexture(materialParams, 'emissiveMap', materialDef.emissiveTexture, (0, $329ek.SRGBColorSpace)));
        return Promise.all(pending).then(function() {
            const material = new materialType(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            $444988b50996c98e$var$assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) $444988b50996c98e$var$addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /**
	 * When Object3D instances are targeted by animation, they need unique names.
	 *
	 * @private
	 * @param {string} originalName
	 * @return {string}
	 */ createUniqueName(originalName) {
        const sanitizedName = (0, $329ek.PropertyBinding).sanitizeNodeName(originalName || '');
        if (sanitizedName in this.nodeNamesUsed) return sanitizedName + '_' + ++this.nodeNamesUsed[sanitizedName];
        else {
            this.nodeNamesUsed[sanitizedName] = 0;
            return sanitizedName;
        }
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
	 *
	 * Creates BufferGeometries from primitives.
	 *
	 * @private
	 * @param {Array<GLTF.Primitive>} primitives
	 * @return {Promise<Array<BufferGeometry>>}
	 */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[$444988b50996c98e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return $444988b50996c98e$var$addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = $444988b50996c98e$var$createPrimitiveKey(primitive);
            // See if we've already created this geometry
            const cached = cache[cacheKey];
            if (cached) // Use the cached geometry if it exists
            pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[$444988b50996c98e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) // Use DRACO geometry if available
                geometryPromise = createDracoPrimitive(primitive);
                else // Otherwise create a new geometry
                geometryPromise = $444988b50996c98e$var$addPrimitiveAttributes(new (0, $329ek.BufferGeometry)(), primitive, parser);
                // Cache this geometry
                cache[cacheKey] = {
                    primitive: primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
	 *
	 * @private
	 * @param {number} meshIndex
	 * @return {Promise<Group|Mesh|SkinnedMesh|Line|Points>}
	 */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === undefined ? $444988b50996c98e$var$createDefaultMaterial(this.cache) : this.getDependency('material', primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                // 1. create Mesh
                let mesh;
                const material = materials[i];
                if (primitive.mode === $444988b50996c98e$var$WEBGL_CONSTANTS.TRIANGLES || primitive.mode === $444988b50996c98e$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === $444988b50996c98e$var$WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {
                    // .isSkinnedMesh isn't in glTF spec. See ._markDefs()
                    mesh = meshDef.isSkinnedMesh === true ? new (0, $329ek.SkinnedMesh)(geometry, material) : new (0, $329ek.Mesh)(geometry, material);
                    if (mesh.isSkinnedMesh === true) // normalize skin weights to fix malformed assets (see #15319)
                    mesh.normalizeSkinWeights();
                    if (primitive.mode === $444988b50996c98e$var$WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, $2hEtH.toTrianglesDrawMode)(mesh.geometry, (0, $329ek.TriangleStripDrawMode));
                    else if (primitive.mode === $444988b50996c98e$var$WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, $2hEtH.toTrianglesDrawMode)(mesh.geometry, (0, $329ek.TriangleFanDrawMode));
                } else if (primitive.mode === $444988b50996c98e$var$WEBGL_CONSTANTS.LINES) mesh = new (0, $329ek.LineSegments)(geometry, material);
                else if (primitive.mode === $444988b50996c98e$var$WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, $329ek.Line)(geometry, material);
                else if (primitive.mode === $444988b50996c98e$var$WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, $329ek.LineLoop)(geometry, material);
                else if (primitive.mode === $444988b50996c98e$var$WEBGL_CONSTANTS.POINTS) mesh = new (0, $329ek.Points)(geometry, material);
                else throw new Error('THREE.GLTFLoader: Primitive mode unsupported: ' + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) $444988b50996c98e$var$updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || 'mesh_' + meshIndex);
                $444988b50996c98e$var$assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) $444988b50996c98e$var$addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) {
                if (meshDef.extensions) $444988b50996c98e$var$addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
                return meshes[0];
            }
            const group = new (0, $329ek.Group)();
            if (meshDef.extensions) $444988b50996c98e$var$addUnknownExtensionsToUserData(extensions, group, meshDef);
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
	 *
	 * @private
	 * @param {number} cameraIndex
	 * @return {Promise<Camera>|undefined}
	 */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn('THREE.GLTFLoader: Missing camera parameters.');
            return;
        }
        if (cameraDef.type === 'perspective') camera = new (0, $329ek.PerspectiveCamera)((0, $329ek.MathUtils).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === 'orthographic') camera = new (0, $329ek.OrthographicCamera)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        $444988b50996c98e$var$assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
	 *
	 * @private
	 * @param {number} skinIndex
	 * @return {Promise<Skeleton>}
	 */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== undefined) pending.push(this.getDependency('accessor', skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            // Note that bones (joint nodes) may or may not be in the
            // scene graph at this time.
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, $329ek.Matrix4)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, $329ek.Skeleton)(bones, boneInverses);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
	 *
	 * @private
	 * @param {number} animationIndex
	 * @return {Promise<AnimationClip>}
	 */ loadAnimation(animationIndex) {
        const json = this.json;
        const parser = this;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : 'animation_' + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === undefined) continue;
            pendingNodes.push(this.getDependency('node', name));
            pendingInputAccessors.push(this.getDependency('accessor', input));
            pendingOutputAccessors.push(this.getDependency('accessor', output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === undefined) continue;
                if (node.updateMatrix) node.updateMatrix();
                const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
                if (createdTracks) for(let k = 0; k < createdTracks.length; k++)tracks.push(createdTracks[k]);
            }
            const animation = new (0, $329ek.AnimationClip)(animationName, undefined, tracks);
            $444988b50996c98e$var$assignExtrasToUserData(animation, animationDef);
            return animation;
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === undefined) return null;
        return parser.getDependency('mesh', nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            // if weights are provided on the node, override weights on the mesh.
            if (nodeDef.weights !== undefined) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
	 *
	 * @private
	 * @param {number} nodeIndex
	 * @return {Promise<Object3D>}
	 */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency('node', childrenDef[i]));
        const skeletonPending = nodeDef.skin === undefined ? Promise.resolve(null) : parser.getDependency('skin', nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) // This full traverse should be fine because
            // child glTF nodes have not been added to this node yet.
            node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, $444988b50996c98e$var$_identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        // This method is called from .loadNode() and .loadSkin().
        // Cache a node to avoid duplication.
        if (this.nodeCache[nodeIndex] !== undefined) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        // reserve node's name before its dependencies, so the root has the intended name.
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : '';
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== undefined) pending.push(parser.getDependency('camera', nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            // .isBone isn't in glTF spec. See ._markDefs
            if (nodeDef.isBone === true) node = new (0, $329ek.Bone)();
            else if (objects.length > 1) node = new (0, $329ek.Group)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, $329ek.Object3D)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            $444988b50996c98e$var$assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) $444988b50996c98e$var$addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== undefined) {
                const matrix = new (0, $329ek.Matrix4)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== undefined) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== undefined) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== undefined) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            else if (nodeDef.mesh !== undefined && parser.meshCache.refs[nodeDef.mesh] > 1) {
                const mapping = parser.associations.get(node);
                parser.associations.set(node, {
                    ...mapping
                });
            }
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
	 *
	 * @private
	 * @param {number} sceneIndex
	 * @return {Promise<Group>}
	 */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        // Loader returns Group, not Scene.
        // See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
        const scene = new (0, $329ek.Group)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        $444988b50996c98e$var$assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) $444988b50996c98e$var$addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency('node', nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            // Removes dangling associations, associations that reference a node that
            // didn't make it into the scene.
            const reduceAssociations = (node)=>{
                const reducedAssociations = new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, $329ek.Material) || key instanceof (0, $329ek.Texture)) reducedAssociations.set(key, value);
                node.traverse((node)=>{
                    const mappings = parser.associations.get(node);
                    if (mappings != null) reducedAssociations.set(node, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
    _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
        const tracks = [];
        const targetName = node.name ? node.name : node.uuid;
        const targetNames = [];
        if ($444988b50996c98e$var$PATH_PROPERTIES[target.path] === $444988b50996c98e$var$PATH_PROPERTIES.weights) node.traverse(function(object) {
            if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
        });
        else targetNames.push(targetName);
        let TypedKeyframeTrack;
        switch($444988b50996c98e$var$PATH_PROPERTIES[target.path]){
            case $444988b50996c98e$var$PATH_PROPERTIES.weights:
                TypedKeyframeTrack = (0, $329ek.NumberKeyframeTrack);
                break;
            case $444988b50996c98e$var$PATH_PROPERTIES.rotation:
                TypedKeyframeTrack = (0, $329ek.QuaternionKeyframeTrack);
                break;
            case $444988b50996c98e$var$PATH_PROPERTIES.translation:
            case $444988b50996c98e$var$PATH_PROPERTIES.scale:
                TypedKeyframeTrack = (0, $329ek.VectorKeyframeTrack);
                break;
            default:
                switch(outputAccessor.itemSize){
                    case 1:
                        TypedKeyframeTrack = (0, $329ek.NumberKeyframeTrack);
                        break;
                    case 2:
                    case 3:
                    default:
                        TypedKeyframeTrack = (0, $329ek.VectorKeyframeTrack);
                        break;
                }
                break;
        }
        const interpolation = sampler.interpolation !== undefined ? $444988b50996c98e$var$INTERPOLATION[sampler.interpolation] : (0, $329ek.InterpolateLinear);
        const outputArray = this._getArrayFromAccessor(outputAccessor);
        for(let j = 0, jl = targetNames.length; j < jl; j++){
            const track = new TypedKeyframeTrack(targetNames[j] + '.' + $444988b50996c98e$var$PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
            // Override interpolation with custom factory method.
            if (sampler.interpolation === 'CUBICSPLINE') this._createCubicSplineTrackInterpolant(track);
            tracks.push(track);
        }
        return tracks;
    }
    _getArrayFromAccessor(accessor) {
        let outputArray = accessor.array;
        if (accessor.normalized) {
            const scale = $444988b50996c98e$var$getNormalizedComponentScale(outputArray.constructor);
            const scaled = new Float32Array(outputArray.length);
            for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
            outputArray = scaled;
        }
        return outputArray;
    }
    _createCubicSplineTrackInterpolant(track) {
        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
            // A CUBICSPLINE keyframe in glTF has three output values for each input value,
            // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
            // must be divided by three to get the interpolant's sampleSize argument.
            const interpolantType = this instanceof (0, $329ek.QuaternionKeyframeTrack) ? $444988b50996c98e$var$GLTFCubicSplineQuaternionInterpolant : $444988b50996c98e$var$GLTFCubicSplineInterpolant;
            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
        };
        // Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
    }
}
/**
 *
 * @private
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */ function $444988b50996c98e$var$computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, $329ek.Box3)();
    if (attributes.POSITION !== undefined) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
        if (min !== undefined && max !== undefined) {
            box.set(new (0, $329ek.Vector3)(min[0], min[1], min[2]), new (0, $329ek.Vector3)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = $444988b50996c98e$var$getNormalizedComponentScale($444988b50996c98e$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== undefined) {
        const maxDisplacement = new (0, $329ek.Vector3)();
        const vector = new (0, $329ek.Vector3)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== undefined) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
                if (min !== undefined && max !== undefined) {
                    // we need to get max of absolute components because target weight is [-1,1]
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = $444988b50996c98e$var$getNormalizedComponentScale($444988b50996c98e$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    // Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
                    // to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
                    // are used to implement key-frame animations and as such only two are active at a time - this results in very large
                    // boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
                    maxDisplacement.max(vector);
                } else console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
            }
        }
        // As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, $329ek.Sphere)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
/**
 *
 * @private
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $444988b50996c98e$var$addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency('accessor', accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = $444988b50996c98e$var$ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        // Skip attributes already provided by e.g. Draco extension.
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== undefined && !geometry.index) {
        const accessor = parser.getDependency('accessor', primitiveDef.indices).then(function(accessor) {
            geometry.setIndex(accessor);
        });
        pending.push(accessor);
    }
    if ((0, $329ek.ColorManagement).workingColorSpace !== (0, $329ek.LinearSRGBColorSpace) && 'COLOR_0' in attributes) console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${(0, $329ek.ColorManagement).workingColorSpace}" not supported.`);
    $444988b50996c98e$var$assignExtrasToUserData(geometry, primitiveDef);
    $444988b50996c98e$var$computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== undefined ? $444988b50996c98e$var$addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}

});
parcelRegister("2hEtH", function(module, exports) {

$parcel$export(module.exports, "toTrianglesDrawMode", () => $1a9c916379444bcc$export$5492ca6e5c0c7aa0);
parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
var $329ek = parcelRequire("329ek");
/**
 * @module BufferGeometryUtils
 * @three_import import * as BufferGeometryUtils from 'three/addons/utils/BufferGeometryUtils.js';
 */ /**
 * Computes vertex tangents using the MikkTSpace algorithm. MikkTSpace generates the same tangents consistently,
 * and is used in most modelling tools and normal map bakers. Use MikkTSpace for materials with normal maps,
 * because inconsistent tangents may lead to subtle visual issues in the normal map, particularly around mirrored
 * UV seams.
 *
 * In comparison to this method, {@link BufferGeometry#computeTangents} (a custom algorithm) generates tangents that
 * probably will not match the tangents in other software. The custom algorithm is sufficient for general use with a
 * custom material, and may be faster than MikkTSpace.
 *
 * Returns the original BufferGeometry. Indexed geometries will be de-indexed. Requires position, normal, and uv attributes.
 *
 * @param {BufferGeometry} geometry - The geometry to compute tangents for.
 * @param {Object} MikkTSpace - Instance of `examples/jsm/libs/mikktspace.module.js`, or `mikktspace` npm package.
 * Await `MikkTSpace.ready` before use.
 * @param {boolean} [negateSign=true] - Whether to negate the sign component (.w) of each tangent.
 * Required for normal map conventions in some formats, including glTF.
 * @return {BufferGeometry} The updated geometry.
 */ function $1a9c916379444bcc$export$676e3e70c930f774(geometry, MikkTSpace, negateSign = true) {
    if (!MikkTSpace || !MikkTSpace.isReady) throw new Error('BufferGeometryUtils: Initialized MikkTSpace library required.');
    if (!geometry.hasAttribute('position') || !geometry.hasAttribute('normal') || !geometry.hasAttribute('uv')) throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
    function getAttributeArray(attribute) {
        if (attribute.normalized || attribute.isInterleavedBufferAttribute) {
            const dstArray = new Float32Array(attribute.count * attribute.itemSize);
            for(let i = 0, j = 0; i < attribute.count; i++){
                dstArray[j++] = attribute.getX(i);
                dstArray[j++] = attribute.getY(i);
                if (attribute.itemSize > 2) dstArray[j++] = attribute.getZ(i);
            }
            return dstArray;
        }
        if (attribute.array instanceof Float32Array) return attribute.array;
        return new Float32Array(attribute.array);
    }
    // MikkTSpace algorithm requires non-indexed input.
    const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;
    // Compute vertex tangents.
    const tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));
    // Texture coordinate convention of glTF differs from the apparent
    // default of the MikkTSpace library; .w component must be flipped.
    if (negateSign) for(let i = 3; i < tangents.length; i += 4)tangents[i] *= -1;
    //
    _geometry.setAttribute('tangent', new (0, $329ek.BufferAttribute)(tangents, 4));
    if (geometry !== _geometry) geometry.copy(_geometry);
    return geometry;
}
/**
 * Merges a set of geometries into a single instance. All geometries must have compatible attributes.
 *
 * @param {Array<BufferGeometry>} geometries - The geometries to merge.
 * @param {boolean} [useGroups=false] - Whether to use groups or not.
 * @return {?BufferGeometry} The merged geometry. Returns `null` if the merge does not succeed.
 */ function $1a9c916379444bcc$export$f06f69b3bf41d25c(geometries, useGroups = false) {
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $329ek.BufferGeometry)();
    let offset = 0;
    for(let i = 0; i < geometries.length; ++i){
        const geometry = geometries[i];
        let attributesCount = 0;
        // ensure that all geometries are indexed, or none
        if (isIndexed !== (geometry.index !== null)) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.');
            return null;
        }
        // gather attributes, exit early if they're different
        for(const name in geometry.attributes){
            if (!attributesUsed.has(name)) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === undefined) attributes[name] = [];
            attributes[name].push(geometry.attributes[name]);
            attributesCount++;
        }
        // ensure geometries have the same number of attributes
        if (attributesCount !== attributesUsed.size) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. Make sure all geometries have the same number of attributes.');
            return null;
        }
        // gather morph attributes, exit early if they're different
        if (morphTargetsRelative !== geometry.morphTargetsRelative) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. .morphTargetsRelative must be consistent throughout all geometries.');
            return null;
        }
        for(const name in geometry.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '.  .morphAttributes must be consistent throughout all geometries.');
                return null;
            }
            if (morphAttributes[name] === undefined) morphAttributes[name] = [];
            morphAttributes[name].push(geometry.morphAttributes[name]);
        }
        if (useGroups) {
            let count;
            if (isIndexed) count = geometry.index.count;
            else if (geometry.attributes.position !== undefined) count = geometry.attributes.position.count;
            else {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. The geometry must have either an index or a position attribute');
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    }
    // merge indices
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        for(let i = 0; i < geometries.length; ++i){
            const index = geometries[i].index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geometries[i].attributes.position.count;
        }
        mergedGeometry.setIndex(mergedIndex);
    }
    // merge attributes
    for(const name in attributes){
        const mergedAttribute = $1a9c916379444bcc$export$9f98db6234c4bd78(attributes[name]);
        if (!mergedAttribute) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' attribute.');
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    // merge morph attributes
    for(const name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $1a9c916379444bcc$export$9f98db6234c4bd78(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' morphAttribute.');
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
}
/**
 * Merges a set of attributes into a single instance. All attributes must have compatible properties and types.
 * Instances of {@link InterleavedBufferAttribute} are not supported.
 *
 * @param {Array<BufferAttribute>} attributes - The attributes to merge.
 * @return {?BufferAttribute} The merged attribute. Returns `null` if the merge does not succeed.
 */ function $1a9c916379444bcc$export$9f98db6234c4bd78(attributes) {
    let TypedArray;
    let itemSize;
    let normalized;
    let gpuType = -1;
    let arrayLength = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.');
            return null;
        }
        if (itemSize === undefined) itemSize = attribute.itemSize;
        if (itemSize !== attribute.itemSize) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.');
            return null;
        }
        if (normalized === undefined) normalized = attribute.normalized;
        if (normalized !== attribute.normalized) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.');
            return null;
        }
        if (gpuType === -1) gpuType = attribute.gpuType;
        if (gpuType !== attribute.gpuType) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes.');
            return null;
        }
        arrayLength += attribute.count * itemSize;
    }
    const array = new TypedArray(arrayLength);
    const result = new (0, $329ek.BufferAttribute)(array, itemSize, normalized);
    let offset = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (attribute.isInterleavedBufferAttribute) {
            const tupleOffset = offset / itemSize;
            for(let j = 0, l = attribute.count; j < l; j++)for(let c = 0; c < itemSize; c++){
                const value = attribute.getComponent(j, c);
                result.setComponent(j + tupleOffset, c, value);
            }
        } else array.set(attribute.array, offset);
        offset += attribute.count * itemSize;
    }
    if (gpuType !== undefined) result.gpuType = gpuType;
    return result;
}
/**
 * Performs a deep clone of the given buffer attribute.
 *
 * @param {BufferAttribute} attribute - The attribute to clone.
 * @return {BufferAttribute} The cloned attribute.
 */ function $1a9c916379444bcc$export$4848639a9adff548(attribute) {
    if (attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute) return $1a9c916379444bcc$export$4b7aa2f2134b7e19(attribute);
    if (attribute.isInstancedBufferAttribute) return new (0, $329ek.InstancedBufferAttribute)().copy(attribute);
    return new (0, $329ek.BufferAttribute)().copy(attribute);
}
/**
 * Interleaves a set of attributes and returns a new array of corresponding attributes that share a
 * single {@link InterleavedBuffer} instance. All attributes must have compatible types.
 *
 * @param {Array<BufferAttribute>} attributes - The attributes to interleave.
 * @return {?Array<InterleavedBufferAttribute>} An array of interleaved attributes. If interleave does not succeed, the method returns `null`.
 */ function $1a9c916379444bcc$export$308f9509e428a845(attributes) {
    // Interleaves the provided attributes into an InterleavedBuffer and returns
    // a set of InterleavedBufferAttributes for each attribute
    let TypedArray;
    let arrayLength = 0;
    let stride = 0;
    // calculate the length and type of the interleavedBuffer
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error('AttributeBuffers of different types cannot be interleaved');
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    // Create the set of buffer attributes
    const interleavedBuffer = new (0, $329ek.InterleavedBuffer)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        'getX',
        'getY',
        'getZ',
        'getW'
    ];
    const setters = [
        'setX',
        'setY',
        'setZ',
        'setW'
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $329ek.InterleavedBufferAttribute)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        // Move the data for each attribute into the new interleavedBuffer
        // at the appropriate offset
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++)iba[setters[k]](c, attribute[getters[k]](c));
    }
    return res;
}
/**
 * Returns a new, non-interleaved version of the given attribute.
 *
 * @param {InterleavedBufferAttribute} attribute - The interleaved attribute.
 * @return {BufferAttribute} The non-interleaved attribute.
 */ function $1a9c916379444bcc$export$4b7aa2f2134b7e19(attribute) {
    const cons = attribute.data.array.constructor;
    const count = attribute.count;
    const itemSize = attribute.itemSize;
    const normalized = attribute.normalized;
    const array = new cons(count * itemSize);
    let newAttribute;
    if (attribute.isInstancedInterleavedBufferAttribute) newAttribute = new (0, $329ek.InstancedBufferAttribute)(array, itemSize, normalized, attribute.meshPerAttribute);
    else newAttribute = new (0, $329ek.BufferAttribute)(array, itemSize, normalized);
    for(let i = 0; i < count; i++){
        newAttribute.setX(i, attribute.getX(i));
        if (itemSize >= 2) newAttribute.setY(i, attribute.getY(i));
        if (itemSize >= 3) newAttribute.setZ(i, attribute.getZ(i));
        if (itemSize >= 4) newAttribute.setW(i, attribute.getW(i));
    }
    return newAttribute;
}
/**
 * Deinterleaves all attributes on the given geometry.
 *
 * @param {BufferGeometry} geometry - The geometry to deinterleave.
 */ function $1a9c916379444bcc$export$e7413b17bfaaa80b(geometry) {
    const attributes = geometry.attributes;
    const morphTargets = geometry.morphTargets;
    const attrMap = new Map();
    for(const key in attributes){
        const attr = attributes[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $1a9c916379444bcc$export$4b7aa2f2134b7e19(attr));
            attributes[key] = attrMap.get(attr);
        }
    }
    for(const key in morphTargets){
        const attr = morphTargets[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $1a9c916379444bcc$export$4b7aa2f2134b7e19(attr));
            morphTargets[key] = attrMap.get(attr);
        }
    }
}
/**
 * Returns the amount of bytes used by all attributes to represent the geometry.
 *
 * @param {BufferGeometry} geometry - The geometry.
 * @return {number} The estimate bytes used.
 */ function $1a9c916379444bcc$export$35bee7999e19754d(geometry) {
    // Return the estimated memory used by this geometry in bytes
    // Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
    // for InterleavedBufferAttributes.
    let mem = 0;
    for(const name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
/**
 * Returns a new geometry with vertices for which all similar vertex attributes (within tolerance) are merged.
 *
 * @param {BufferGeometry} geometry - The geometry to merge vertices for.
 * @param {number} [tolerance=1e-4] - The tolerance value.
 * @return {BufferGeometry} - The new geometry with merged vertices.
 */ function $1a9c916379444bcc$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    // Generate an index buffer if the geometry doesn't have one, or optimize it
    // if it's already available.
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute('position');
    const vertexCount = indices ? indices.count : positions.count;
    // next value for triangle indices
    let nextIndex = 0;
    // attributes and new attribute arrays
    const attributeNames = Object.keys(geometry.attributes);
    const tmpAttributes = {};
    const tmpMorphAttributes = {};
    const newIndices = [];
    const getters = [
        'getX',
        'getY',
        'getZ',
        'getW'
    ];
    const setters = [
        'setX',
        'setY',
        'setZ',
        'setW'
    ];
    // Initialize the arrays, allocating space conservatively. Extra
    // space will be trimmed in the last step.
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const attr = geometry.attributes[name];
        tmpAttributes[name] = new attr.constructor(new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);
        const morphAttributes = geometry.morphAttributes[name];
        if (morphAttributes) {
            if (!tmpMorphAttributes[name]) tmpMorphAttributes[name] = [];
            morphAttributes.forEach((morphAttr, i)=>{
                const array = new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize);
                tmpMorphAttributes[name][i] = new morphAttr.constructor(array, morphAttr.itemSize, morphAttr.normalized);
            });
        }
    }
    // convert the error tolerance to an amount of decimal places to truncate to
    const halfTolerance = tolerance * 0.5;
    const exponent = Math.log10(1 / tolerance);
    const hashMultiplier = Math.pow(10, exponent);
    const hashAdditive = halfTolerance * hashMultiplier;
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        // Generate a hash for the vertex attributes at the current index 'i'
        let hash = '';
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)// double tilde truncates the decimal value
            hash += `${~~(attribute[getters[k]](index) * hashMultiplier + hashAdditive)},`;
        }
        // Add another reference to the vertex if it's already
        // used by another index
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            // copy data to the new index in the temporary attributes
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttributes = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newArray = tmpAttributes[name];
                const newMorphArrays = tmpMorphAttributes[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    const setterFunc = setters[k];
                    newArray[setterFunc](nextIndex, attribute[getterFunc](index));
                    if (morphAttributes) for(let m = 0, ml = morphAttributes.length; m < ml; m++)newMorphArrays[m][setterFunc](nextIndex, morphAttributes[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    // generate result BufferGeometry
    const result = geometry.clone();
    for(const name in geometry.attributes){
        const tmpAttribute = tmpAttributes[name];
        result.setAttribute(name, new tmpAttribute.constructor(tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));
        if (!(name in tmpMorphAttributes)) continue;
        for(let j = 0; j < tmpMorphAttributes[name].length; j++){
            const tmpMorphAttribute = tmpMorphAttributes[name][j];
            result.morphAttributes[name][j] = new tmpMorphAttribute.constructor(tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
        }
    }
    // indices
    result.setIndex(newIndices);
    return result;
}
/**
 * Returns a new indexed geometry based on `TrianglesDrawMode` draw mode.
 * This mode corresponds to the `gl.TRIANGLES` primitive in WebGL.
 *
 * @param {BufferGeometry} geometry - The geometry to convert.
 * @param {number} drawMode - The current draw mode.
 * @return {BufferGeometry} The new geometry using `TrianglesDrawMode`.
 */ function $1a9c916379444bcc$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $329ek.TrianglesDrawMode)) {
        console.warn('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.');
        return geometry;
    }
    if (drawMode === (0, $329ek.TriangleFanDrawMode) || drawMode === (0, $329ek.TriangleStripDrawMode)) {
        let index = geometry.getIndex();
        // generate index if not present
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute('position');
            if (position !== undefined) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.');
                return geometry;
            }
        }
        //
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (drawMode === (0, $329ek.TriangleFanDrawMode)) // gl.TRIANGLE_FAN
        for(let i = 1; i <= numberOfTriangles; i++){
            newIndices.push(index.getX(0));
            newIndices.push(index.getX(i));
            newIndices.push(index.getX(i + 1));
        }
        else {
            // gl.TRIANGLE_STRIP
            for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i + 2));
            } else {
                newIndices.push(index.getX(i + 2));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i));
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.');
        // build final geometry
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:', drawMode);
        return geometry;
    }
}
/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 *
 * Helpful for Raytracing or Decals (i.e. a `DecalGeometry` applied to a morphed Object with a `BufferGeometry`
 * will use the original `BufferGeometry`, not the morphed/skinned one, generating an incorrect result.
 * Using this function to create a shadow `Object3`D the `DecalGeometry` can be correctly generated).
 *
 * @param {Mesh|Line|Points} object - The 3D object to compute morph attributes for.
 * @return {Object} An object with original position/normal attributes and morphed ones.
 */ function $1a9c916379444bcc$export$29e54e2e4ab904e7(object) {
    const _vA = new (0, $329ek.Vector3)();
    const _vB = new (0, $329ek.Vector3)();
    const _vC = new (0, $329ek.Vector3)();
    const _tempA = new (0, $329ek.Vector3)();
    const _tempB = new (0, $329ek.Vector3)();
    const _tempC = new (0, $329ek.Vector3)();
    const _morphA = new (0, $329ek.Vector3)();
    const _morphB = new (0, $329ek.Vector3)();
    const _morphC = new (0, $329ek.Vector3)();
    function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a);
        _vB.fromBufferAttribute(attribute, b);
        _vC.fromBufferAttribute(attribute, c);
        const morphInfluences = object.morphTargetInfluences;
        if (morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const influence = morphInfluences[i];
                const morph = morphAttribute[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a);
                _tempB.fromBufferAttribute(morph, b);
                _tempC.fromBufferAttribute(morph, c);
                if (morphTargetsRelative) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object.isSkinnedMesh) {
            object.applyBoneTransform(a, _vA);
            object.applyBoneTransform(b, _vB);
            object.applyBoneTransform(c, _vC);
        }
        modifiedAttributeArray[a * 3 + 0] = _vA.x;
        modifiedAttributeArray[a * 3 + 1] = _vA.y;
        modifiedAttributeArray[a * 3 + 2] = _vA.z;
        modifiedAttributeArray[b * 3 + 0] = _vB.x;
        modifiedAttributeArray[b * 3 + 1] = _vB.y;
        modifiedAttributeArray[b * 3 + 2] = _vB.z;
        modifiedAttributeArray[c * 3 + 0] = _vC.x;
        modifiedAttributeArray[c * 3 + 1] = _vC.y;
        modifiedAttributeArray[c * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        // indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else {
        // non-indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $329ek.Float32BufferAttribute)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $329ek.Float32BufferAttribute)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
/**
 * Merges the {@link BufferGeometry#groups} for the given geometry.
 *
 * @param {BufferGeometry} geometry - The geometry to modify.
 * @return {BufferGeometry} - The updated geometry
 */ function $1a9c916379444bcc$export$8babbf41197098b1(geometry) {
    if (geometry.groups.length === 0) {
        console.warn('THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.');
        return geometry;
    }
    let groups = geometry.groups;
    // sort groups by material index
    groups = groups.sort((a, b)=>{
        if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;
        return a.start - b.start;
    });
    // create index for non-indexed geometries
    if (geometry.getIndex() === null) {
        const positionAttribute = geometry.getAttribute('position');
        const indices = [];
        for(let i = 0; i < positionAttribute.count; i += 3)indices.push(i, i + 1, i + 2);
        geometry.setIndex(indices);
    }
    // sort index
    const index = geometry.getIndex();
    const newIndices = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        const groupStart = group.start;
        const groupLength = groupStart + group.count;
        for(let j = groupStart; j < groupLength; j++)newIndices.push(index.getX(j));
    }
    geometry.dispose(); // Required to force buffer recreation
    geometry.setIndex(newIndices);
    // update groups indices
    let start = 0;
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        group.start = start;
        start += group.count;
    }
    // merge groups
    let currentGroup = groups[0];
    geometry.groups = [
        currentGroup
    ];
    for(let i = 1; i < groups.length; i++){
        const group = groups[i];
        if (currentGroup.materialIndex === group.materialIndex) currentGroup.count += group.count;
        else {
            currentGroup = group;
            geometry.groups.push(currentGroup);
        }
    }
    return geometry;
}
/**
 * Modifies the supplied geometry if it is non-indexed, otherwise creates a new,
 * non-indexed geometry. Returns the geometry with smooth normals everywhere except
 * faces that meet at an angle greater than the crease angle.
 *
 * @param {BufferGeometry} geometry - The geometry to modify.
 * @param {number} [creaseAngle=Math.PI/3] - The crease angle in radians.
 * @return {BufferGeometry} - The updated geometry
 */ function $1a9c916379444bcc$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 1e2;
    // reusable vectors
    const verts = [
        new (0, $329ek.Vector3)(),
        new (0, $329ek.Vector3)(),
        new (0, $329ek.Vector3)()
    ];
    const tempVec1 = new (0, $329ek.Vector3)();
    const tempVec2 = new (0, $329ek.Vector3)();
    const tempNorm = new (0, $329ek.Vector3)();
    const tempNorm2 = new (0, $329ek.Vector3)();
    // hashes a vector
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    // BufferGeometry.toNonIndexed() warns if the geometry is non-indexed
    // and returns the original geometry
    const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    // find all the normals shared by commonly located vertices
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        // add the normal to the map for all vertices
        const normal = new (0, $329ek.Vector3)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    // average normals from all vertices that share a common location if they are within the
    // provided crease threshold
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $329ek.BufferAttribute)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        // get the face normal for this vertex
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        // average all normals that meet the threshold and set the normal value
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute('normal', normAttr);
    return resultGeometry;
}

});


parcelRegister("bQavx", function(module, exports) {

$parcel$export(module.exports, "MeshoptDecoder", () => $89ecb3a3b5ca3ba1$export$1111800106ba519a);
// This file is part of meshoptimizer library and is distributed under the terms of MIT License.
// Copyright (C) 2016-2024, by Arseny Kapoulkine (arseny.kapoulkine@gmail.com)
var $89ecb3a3b5ca3ba1$export$1111800106ba519a = function() {
    // Built with clang version 18.1.2
    // Built from meshoptimizer 0.22
    var wasm_base = 'b9H79Tebbbe8Fv9Gbb9Gvuuuuueu9Giuuub9Geueu9Giuuueuikqbeeedddillviebeoweuec:q:Odkr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbeY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVbdE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbiL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtblK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbol79IV9Rbrq;w8Wqdbk;esezu8Jjjjjbcj;eb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Radz1jjjbhwcj;abad9Uc;WFbGgocjdaocjd6EhDaicefhocbhqdnindndndnaeaq9nmbaDaeaq9RaqaDfae6Egkcsfglcl4cifcd4hxalc9WGgmTmecbhPawcjdfhsaohzinaraz9Rax6mvarazaxfgo9RcK6mvczhlcbhHinalgic9WfgOawcj;cbffhldndndndndnazaOco4fRbbaHcoG4ciGPlbedibkal9cb83ibalcwf9cb83ibxikalaoRblaoRbbgOco4gAaAciSgAE86bbawcj;cbfaifglcGfaoclfaAfgARbbaOcl4ciGgCaCciSgCE86bbalcVfaAaCfgARbbaOcd4ciGgCaCciSgCE86bbalc7faAaCfgARbbaOciGgOaOciSgOE86bbalctfaAaOfgARbbaoRbegOco4gCaCciSgCE86bbalc91faAaCfgARbbaOcl4ciGgCaCciSgCE86bbalc4faAaCfgARbbaOcd4ciGgCaCciSgCE86bbalc93faAaCfgARbbaOciGgOaOciSgOE86bbalc94faAaOfgARbbaoRbdgOco4gCaCciSgCE86bbalc95faAaCfgARbbaOcl4ciGgCaCciSgCE86bbalc96faAaCfgARbbaOcd4ciGgCaCciSgCE86bbalc97faAaCfgARbbaOciGgOaOciSgOE86bbalc98faAaOfgORbbaoRbigoco4gAaAciSgAE86bbalc99faOaAfgORbbaocl4ciGgAaAciSgAE86bbalc9:faOaAfgORbbaocd4ciGgAaAciSgAE86bbalcufaOaAfglRbbaociGgoaociSgoE86bbalaofhoxdkalaoRbwaoRbbgOcl4gAaAcsSgAE86bbawcj;cbfaifglcGfaocwfaAfgARbbaOcsGgOaOcsSgOE86bbalcVfaAaOfgORbbaoRbegAcl4gCaCcsSgCE86bbalc7faOaCfgORbbaAcsGgAaAcsSgAE86bbalctfaOaAfgORbbaoRbdgAcl4gCaCcsSgCE86bbalc91faOaCfgORbbaAcsGgAaAcsSgAE86bbalc4faOaAfgORbbaoRbigAcl4gCaCcsSgCE86bbalc93faOaCfgORbbaAcsGgAaAcsSgAE86bbalc94faOaAfgORbbaoRblgAcl4gCaCcsSgCE86bbalc95faOaCfgORbbaAcsGgAaAcsSgAE86bbalc96faOaAfgORbbaoRbvgAcl4gCaCcsSgCE86bbalc97faOaCfgORbbaAcsGgAaAcsSgAE86bbalc98faOaAfgORbbaoRbogAcl4gCaCcsSgCE86bbalc99faOaCfgORbbaAcsGgAaAcsSgAE86bbalc9:faOaAfgORbbaoRbrgocl4gAaAcsSgAE86bbalcufaOaAfglRbbaocsGgoaocsSgoE86bbalaofhoxekalao8Pbb83bbalcwfaocwf8Pbb83bbaoczfhokdnaiam9pmbaHcdfhHaiczfhlarao9RcL0mekkaiam6mvaoTmvdnakTmbawaPfRbbhHawcj;cbfhlashiakhOinaialRbbgzce4cbazceG9R7aHfgH86bbaiadfhialcefhlaOcufgOmbkkascefhsaohzaPcefgPad9hmbxikkcbc99arao9Radcaadca0ESEhoxlkaoaxad2fhCdnakmbadhlinaoTmlarao9Rax6mlaoaxfhoalcufglmbkaChoxekcbhmawcjdfhAinarao9Rax6miawamfRbbhHawcj;cbfhlaAhiakhOinaialRbbgzce4cbazceG9R7aHfgH86bbaiadfhialcefhlaOcufgOmbkaAcefhAaoaxfhoamcefgmad9hmbkaChokabaqad2fawcjdfakad2z1jjjb8Aawawcjdfakcufad2fadz1jjjb8Aakaqfhqaombkc9:hoxekc9:hokavcj;ebf8Kjjjjbaok;cseHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgwce0mbavc;abfcFecjez:jjjjb8AavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhDaicefgqarfhidnaeTmbcmcsawceSEhkcbhxcbhmcbhPcbhwcbhlindnaiaD9nmbc9:hoxikdndnaqRbbgoc;Ve0mbavc;abfalaocu7gscl4fcsGcitfgzydlhrazydbhzdnaocsGgHak9pmbavawasfcsGcdtfydbaxaHEhoaHThsdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkaxasfhxcdhHavawcdtfaoBdbawasfhwcehsalhOxdkdndnaHcsSmbaHc987aHamffcefhoxekaicefhoai8SbbgHcFeGhsdndnaHcu9mmbaohixekaicvfhiascFbGhscrhHdninao8SbbgOcFbGaHtasVhsaOcu9kmeaocefhoaHcrfgHc8J9hmbxdkkaocefhikasce4cbasceG9R7amfhokdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkcdhHavawcdtfaoBdbcehsawcefhwalhOaohmxekdnaocpe0mbaxcefgHavawaDaocsGfRbbgocl49RcsGcdtfydbaocz6gzEhravawao9RcsGcdtfydbaHazfgAaocsGgHEhoaHThCdndnadcd9hmbabaPcetfgHax87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHaxBdbaHcwfaoBdbaHclfarBdbkcdhsavawcdtfaxBdbavawcefgwcsGcdtfarBdbcihHavc;abfalcitfgOaxBdlaOarBdbavawazfgwcsGcdtfaoBdbalcefcsGhOawaCfhwaxhzaAaCfhxxekaxcbaiRbbgOEgzaoc;:eSgHfhraOcsGhCaOcl4hAdndnaOcs0mbarcefhoxekarhoavawaA9RcsGcdtfydbhrkdndnaCmbaocefhxxekaohxavawaO9RcsGcdtfydbhokdndnaHTmbaicefhHxekaicdfhHai8SbegscFeGhzdnascu9kmbaicofhXazcFbGhzcrhidninaH8SbbgscFbGaitazVhzascu9kmeaHcefhHaicrfgic8J9hmbkaXhHxekaHcefhHkazce4cbazceG9R7amfgmhzkdndnaAcsSmbaHhsxekaHcefhsaH8SbbgicFeGhrdnaicu9kmbaHcvfhXarcFbGhrcrhidninas8SbbgHcFbGaitarVhraHcu9kmeascefhsaicrfgic8J9hmbkaXhsxekascefhskarce4cbarceG9R7amfgmhrkdndnaCcsSmbashixekascefhias8SbbgocFeGhHdnaocu9kmbascvfhXaHcFbGhHcrhodninai8SbbgscFbGaotaHVhHascu9kmeaicefhiaocrfgoc8J9hmbkaXhixekaicefhikaHce4cbaHceG9R7amfgmhokdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkcdhsavawcdtfazBdbavawcefgwcsGcdtfarBdbcihHavc;abfalcitfgXazBdlaXarBdbavawaOcz6aAcsSVfgwcsGcdtfaoBdbawaCTaCcsSVfhwalcefcsGhOkaqcefhqavc;abfaOcitfgOarBdlaOaoBdbavc;abfalasfcsGcitfgraoBdlarazBdbawcsGhwalaHfcsGhlaPcifgPae6mbkkcbc99aiaDSEhokavc;aef8Kjjjjbaok:flevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaic8Etc8F91aicd47avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaic8Etc8F91aicd47avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:Lvoeue99dud99eud99dndnadcl9hmbaeTmeindndnabcdfgd8Sbb:Yab8Sbbgi:Ygl:l:tabcefgv8Sbbgo:Ygr:l:tgwJbb;:9cawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai86bbdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad86bbdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad86bbabclfhbaecufgembxdkkaeTmbindndnabclfgd8Ueb:Yab8Uebgi:Ygl:l:tabcdfgv8Uebgo:Ygr:l:tgwJb;:FSawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai87ebdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad87ebdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad87ebabcwfhbaecufgembkkk;oiliui99iue99dnaeTmbcbhiabhlindndnJ;Zl81Zalcof8UebgvciV:Y:vgoal8Ueb:YNgrJb;:FSNJbbbZJbbb:;arJbbbb9GEMgw:lJbbb9p9DTmbaw:OhDxekcjjjj94hDkalclf8Uebhqalcdf8UebhkabaiavcefciGfcetfaD87ebdndnaoak:YNgwJb;:FSNJbbbZJbbb:;awJbbbb9GEMgx:lJbbb9p9DTmbax:OhDxekcjjjj94hDkabaiavciGfgkcd7cetfaD87ebdndnaoaq:YNgoJb;:FSNJbbbZJbbb:;aoJbbbb9GEMgx:lJbbb9p9DTmbax:OhDxekcjjjj94hDkabaiavcufciGfcetfaD87ebdndnJbbjZararN:tawawN:taoaoN:tgrJbbbbarJbbbb9GE:rJb;:FSNJbbbZMgr:lJbbb9p9DTmbar:Ohvxekcjjjj94hvkabakcetfav87ebalcwfhlaiclfhiaecufgembkkk9mbdnadcd4ae2gdTmbinababydbgecwtcw91:Yaece91cjjj98Gcjjj;8if::NUdbabclfhbadcufgdmbkkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaik;LeeeudndnaeabVciGTmbabhixekdndnadcz9pmbabhixekabhiinaiaeydbBdbaiclfaeclfydbBdbaicwfaecwfydbBdbaicxfaecxfydbBdbaeczfheaiczfhiadc9Wfgdcs0mbkkadcl6mbinaiaeydbBdbaeclfheaiclfhiadc98fgdci0mbkkdnadTmbinaiaeRbb86bbaicefhiaecefheadcufgdmbkkabk;aeedudndnabciGTmbabhixekaecFeGc:b:c:ew2hldndnadcz9pmbabhixekabhiinaialBdbaicxfalBdbaicwfalBdbaiclfalBdbaiczfhiadc9Wfgdcs0mbkkadcl6mbinaialBdbaiclfhiadc98fgdci0mbkkdnadTmbinaiae86bbaicefhiadcufgdmbkkabkkkebcjwklzNbb'; // embed! base
    var wasm_simd = 'b9H79TebbbeKl9Gbb9Gvuuuuueu9Giuuub9Geueuikqbbebeedddilve9Weeeviebeoweuec:q:6dkr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbdY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVblE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtboK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbrL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbwl79IV9RbDq:p9sqlbzik9:evu8Jjjjjbcz9Rhbcbheincbhdcbhiinabcwfadfaicjuaead4ceGglE86bbaialfhiadcefgdcw9hmbkaec:q:yjjbfai86bbaecitc:q1jjbfab8Piw83ibaecefgecjd9hmbkk:N8JlHud97euo978Jjjjjbcj;kb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Rad;8qbbcj;abad9UhlaicefhodnaeTmbadTmbalc;WFbGglcjdalcjd6EhwcbhDinawaeaD9RaDawfae6Egqcsfglc9WGgkci2hxakcethmalcl4cifcd4hPabaDad2fhsakc;ab6hzcbhHincbhOaohAdndninaraA9RaP6meavcj;cbfaOak2fhCaAaPfhocbhidnazmbarao9Rc;Gb6mbcbhlinaCalfhidndndndndnaAalco4fRbbgXciGPlbedibkaipxbbbbbbbbbbbbbbbbpklbxikaiaopbblaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbaoclfaYpQbfaKc:q:yjjbfRbbfhoxdkaiaopbbwaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbaocwfaYpQbfaKc:q:yjjbfRbbfhoxekaiaopbbbpklbaoczfhokdndndndndnaXcd4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklzxikaiaopbblaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzaoclfaYpQbfaKc:q:yjjbfRbbfhoxdkaiaopbbwaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzaocwfaYpQbfaKc:q:yjjbfRbbfhoxekaiaopbbbpklzaoczfhokdndndndndnaXcl4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklaxikaiaopbblaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaaoclfaYpQbfaKc:q:yjjbfRbbfhoxdkaiaopbbwaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaaocwfaYpQbfaKc:q:yjjbfRbbfhoxekaiaopbbbpklaaoczfhokdndndndndnaXco4Plbedibkaipxbbbbbbbbbbbbbbbbpkl8WxikaiaopbblaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WaoclfaYpQbfaXc:q:yjjbfRbbfhoxdkaiaopbbwaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WaocwfaYpQbfaXc:q:yjjbfRbbfhoxekaiaopbbbpkl8Waoczfhokalc;abfhialcjefak0meaihlarao9Rc;Fb0mbkkdnaiak9pmbaici4hlinarao9RcK6miaCaifhXdndndndndnaAaico4fRbbalcoG4ciGPlbedibkaXpxbbbbbbbbbbbbbbbbpkbbxikaXaopbblaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkbbaoclfaYpQbfaKc:q:yjjbfRbbfhoxdkaXaopbbwaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkbbaocwfaYpQbfaKc:q:yjjbfRbbfhoxekaXaopbbbpkbbaoczfhokalcdfhlaiczfgiak6mbkkaoTmeaohAaOcefgOclSmdxbkkc9:hoxlkdnakTmbavcjdfaHfhiavaHfpbdbhYcbhXinaiavcj;cbfaXfglpblbgLcep9TaLpxeeeeeeeeeeeeeeeegQp9op9Hp9rgLalakfpblbg8Acep9Ta8AaQp9op9Hp9rg8ApmbzeHdOiAlCvXoQrLgEalamfpblbg3cep9Ta3aQp9op9Hp9rg3alaxfpblbg5cep9Ta5aQp9op9Hp9rg5pmbzeHdOiAlCvXoQrLg8EpmbezHdiOAlvCXorQLgQaQpmbedibedibedibediaYp9UgYp9AdbbaiadfglaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaladfglaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaladfglaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaladfglaYaEa8EpmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaladfglaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaladfglaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaladfglaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaladfglaYaLa8ApmwKDYq8AkEx3m5P8Es8FgLa3a5pmwKDYq8AkEx3m5P8Es8Fg8ApmbezHdiOAlvCXorQLgQaQpmbedibedibedibedip9UgYp9AdbbaladfglaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaladfglaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaladfglaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaladfglaYaLa8ApmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaladfglaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaladfglaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaladfglaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaladfhiaXczfgXak6mbkkaHclfgHad6mbkasavcjdfaqad2;8qbbavavcjdfaqcufad2fad;8qbbaqaDfgDae6mbkkcbc99arao9Radcaadca0ESEhokavcj;kbf8Kjjjjbaokwbz:bjjjbk::seHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgwce0mbavc;abfcFecje;8kbavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhDaicefgqarfhidnaeTmbcmcsawceSEhkcbhxcbhmcbhPcbhwcbhlindnaiaD9nmbc9:hoxikdndnaqRbbgoc;Ve0mbavc;abfalaocu7gscl4fcsGcitfgzydlhrazydbhzdnaocsGgHak9pmbavawasfcsGcdtfydbaxaHEhoaHThsdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkaxasfhxcdhHavawcdtfaoBdbawasfhwcehsalhOxdkdndnaHcsSmbaHc987aHamffcefhoxekaicefhoai8SbbgHcFeGhsdndnaHcu9mmbaohixekaicvfhiascFbGhscrhHdninao8SbbgOcFbGaHtasVhsaOcu9kmeaocefhoaHcrfgHc8J9hmbxdkkaocefhikasce4cbasceG9R7amfhokdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkcdhHavawcdtfaoBdbcehsawcefhwalhOaohmxekdnaocpe0mbaxcefgHavawaDaocsGfRbbgocl49RcsGcdtfydbaocz6gzEhravawao9RcsGcdtfydbaHazfgAaocsGgHEhoaHThCdndnadcd9hmbabaPcetfgHax87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHaxBdbaHcwfaoBdbaHclfarBdbkcdhsavawcdtfaxBdbavawcefgwcsGcdtfarBdbcihHavc;abfalcitfgOaxBdlaOarBdbavawazfgwcsGcdtfaoBdbalcefcsGhOawaCfhwaxhzaAaCfhxxekaxcbaiRbbgOEgzaoc;:eSgHfhraOcsGhCaOcl4hAdndnaOcs0mbarcefhoxekarhoavawaA9RcsGcdtfydbhrkdndnaCmbaocefhxxekaohxavawaO9RcsGcdtfydbhokdndnaHTmbaicefhHxekaicdfhHai8SbegscFeGhzdnascu9kmbaicofhXazcFbGhzcrhidninaH8SbbgscFbGaitazVhzascu9kmeaHcefhHaicrfgic8J9hmbkaXhHxekaHcefhHkazce4cbazceG9R7amfgmhzkdndnaAcsSmbaHhsxekaHcefhsaH8SbbgicFeGhrdnaicu9kmbaHcvfhXarcFbGhrcrhidninas8SbbgHcFbGaitarVhraHcu9kmeascefhsaicrfgic8J9hmbkaXhsxekascefhskarce4cbarceG9R7amfgmhrkdndnaCcsSmbashixekascefhias8SbbgocFeGhHdnaocu9kmbascvfhXaHcFbGhHcrhodninai8SbbgscFbGaotaHVhHascu9kmeaicefhiaocrfgoc8J9hmbkaXhixekaicefhikaHce4cbaHceG9R7amfgmhokdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkcdhsavawcdtfazBdbavawcefgwcsGcdtfarBdbcihHavc;abfalcitfgXazBdlaXarBdbavawaOcz6aAcsSVfgwcsGcdtfaoBdbawaCTaCcsSVfhwalcefcsGhOkaqcefhqavc;abfaOcitfgOarBdlaOaoBdbavc;abfalasfcsGcitfgraoBdlarazBdbawcsGhwalaHfcsGhlaPcifgPae6mbkkcbc99aiaDSEhokavc;aef8Kjjjjbaok:flevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaic8Etc8F91aicd47avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaic8Etc8F91aicd47avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:wPliuo97eue978Jjjjjbca9Rhiaec98Ghldndnadcl9hmbdnalTmbcbhvabhdinadadpbbbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpkbbadczfhdavclfgval6mbkkalaeSmeaipxbbbbbbbbbbbbbbbbgqpklbaiabalcdtfgdaeciGglcdtgv;8qbbdnalTmbaiaipblbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDaqp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpklbkadaiav;8qbbskdnalTmbcbhvabhdinadczfgxaxpbbbgopxbbbbbbFFbbbbbbFFgkp9oadpbbbgDaopmbediwDqkzHOAKY8AEgwczp:Reczp:Sep;6egraDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eawczp:Sep;6egwp;Gearp;Gep;Kep;Legopxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegrpxb;:FSb;:FSb;:FSb;:FSararp;Meaoaop;Meawaqawamp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFFbbFFbbFFbbFFbbp9oaoawp;Meaqp;Keczp:Rep9qgoarawp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogrpmwDKYqk8AExm35Ps8E8Fp9qpkbbadaDakp9oaoarpmbezHdiOAlvCXorQLp9qpkbbadcafhdavclfgval6mbkkalaeSmbaiaeciGgvcitgdfcbcaad9R;8kbaiabalcitfglad;8qbbdnavTmbaiaipblzgopxbbbbbbFFbbbbbbFFgkp9oaipblbgDaopmbediwDqkzHOAKY8AEgwczp:Reczp:Sep;6egraDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eawczp:Sep;6egwp;Gearp;Gep;Kep;Legopxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegrpxb;:FSb;:FSb;:FSb;:FSararp;Meaoaop;Meawaqawamp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFFbbFFbbFFbbFFbbp9oaoawp;Meaqp;Keczp:Rep9qgoarawp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogrpmwDKYqk8AExm35Ps8E8Fp9qpklzaiaDakp9oaoarpmbezHdiOAlvCXorQLp9qpklbkalaiad;8qbbkk;4wllue97euv978Jjjjjbc8W9Rhidnaec98GglTmbcbhvabhoinaiaopbbbgraoczfgwpbbbgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklbaopxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaDakp;Mearp;Keamp9oaqakp;Mearp;Keczp:Rep9qgkpmbezHdiOAlvCXorQLgrp5baipblbpEb:T:j83ibaocwfarp5eaipblbpEe:T:j83ibawaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblbpEd:T:j83ibaocKfakp5eaipblbpEi:T:j83ibaocafhoavclfgval6mbkkdnalaeSmbaiaeciGgvcitgofcbcaao9R;8kbaiabalcitfgwao;8qbbdnavTmbaiaipblbgraipblzgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklaaipxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaDakp;Mearp;Keamp9oaqakp;Mearp;Keczp:Rep9qgkpmbezHdiOAlvCXorQLgrp5baipblapEb:T:j83ibaiarp5eaipblapEe:T:j83iwaiaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblapEd:T:j83izaiakp5eaipblapEi:T:j83iKkawaiao;8qbbkk:Pddiue978Jjjjjbc;ab9Rhidnadcd4ae2glc98GgvTmbcbheabhdinadadpbbbgocwp:Recwp:Sep;6eaocep:SepxbbjFbbjFbbjFbbjFp9opxbbjZbbjZbbjZbbjZp:Uep;Mepkbbadczfhdaeclfgeav6mbkkdnavalSmbaialciGgecdtgdVcbc;abad9R;8kbaiabavcdtfgvad;8qbbdnaeTmbaiaipblbgocwp:Recwp:Sep;6eaocep:SepxbbjFbbjFbbjFbbjFp9opxbbjZbbjZbbjZbbjZp:Uep;Mepklbkavaiad;8qbbkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaikkkebcjwklz:Dbb'; // embed! simd
    var detector = new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        3,
        2,
        0,
        0,
        5,
        3,
        1,
        0,
        1,
        12,
        1,
        0,
        10,
        22,
        2,
        12,
        0,
        65,
        0,
        65,
        0,
        65,
        0,
        252,
        10,
        0,
        0,
        11,
        7,
        0,
        65,
        0,
        253,
        15,
        26,
        11
    ]);
    var wasmpack = new Uint8Array([
        32,
        0,
        65,
        2,
        1,
        106,
        34,
        33,
        3,
        128,
        11,
        4,
        13,
        64,
        6,
        253,
        10,
        7,
        15,
        116,
        127,
        5,
        8,
        12,
        40,
        16,
        19,
        54,
        20,
        9,
        27,
        255,
        113,
        17,
        42,
        67,
        24,
        23,
        146,
        148,
        18,
        14,
        22,
        45,
        70,
        69,
        56,
        114,
        101,
        21,
        25,
        63,
        75,
        136,
        108,
        28,
        118,
        29,
        73,
        115
    ]);
    if (typeof WebAssembly !== 'object') return {
        supported: false
    };
    var wasm = WebAssembly.validate(detector) ? unpack(wasm_simd) : unpack(wasm_base);
    var instance;
    var ready = WebAssembly.instantiate(wasm, {}).then(function(result) {
        instance = result.instance;
        instance.exports.__wasm_call_ctors();
    });
    function unpack(data) {
        var result = new Uint8Array(data.length);
        for(var i = 0; i < data.length; ++i){
            var ch = data.charCodeAt(i);
            result[i] = ch > 96 ? ch - 97 : ch > 64 ? ch - 39 : ch + 4;
        }
        var write = 0;
        for(var i = 0; i < data.length; ++i)result[write++] = result[i] < 60 ? wasmpack[result[i]] : (result[i] - 60) * 64 + result[++i];
        return result.buffer.slice(0, write);
    }
    function decode(instance, fun, target, count, size, source, filter) {
        var sbrk = instance.exports.sbrk;
        var count4 = count + 3 & -4;
        var tp = sbrk(count4 * size);
        var sp = sbrk(source.length);
        var heap = new Uint8Array(instance.exports.memory.buffer);
        heap.set(source, sp);
        var res = fun(tp, count, size, sp, source.length);
        if (res == 0 && filter) filter(tp, count4, size);
        target.set(heap.subarray(tp, tp + count * size));
        sbrk(tp - sbrk(0));
        if (res != 0) throw new Error('Malformed buffer data: ' + res);
    }
    var filters = {
        NONE: '',
        OCTAHEDRAL: 'meshopt_decodeFilterOct',
        QUATERNION: 'meshopt_decodeFilterQuat',
        EXPONENTIAL: 'meshopt_decodeFilterExp'
    };
    var decoders = {
        ATTRIBUTES: 'meshopt_decodeVertexBuffer',
        TRIANGLES: 'meshopt_decodeIndexBuffer',
        INDICES: 'meshopt_decodeIndexSequence'
    };
    var workers = [];
    var requestId = 0;
    function createWorker(url) {
        var worker = {
            object: new Worker(url),
            pending: 0,
            requests: {}
        };
        worker.object.onmessage = function(event) {
            var data = event.data;
            worker.pending -= data.count;
            worker.requests[data.id][data.action](data.value);
            delete worker.requests[data.id];
        };
        return worker;
    }
    function initWorkers(count) {
        var source = 'self.ready = WebAssembly.instantiate(new Uint8Array([' + new Uint8Array(wasm) + ']), {})' + '.then(function(result) { result.instance.exports.__wasm_call_ctors(); return result.instance; });' + 'self.onmessage = ' + workerProcess.name + ';' + decode.toString() + workerProcess.toString();
        var blob = new Blob([
            source
        ], {
            type: 'text/javascript'
        });
        var url = URL.createObjectURL(blob);
        for(var i = workers.length; i < count; ++i)workers[i] = createWorker(url);
        for(var i = count; i < workers.length; ++i)workers[i].object.postMessage({});
        workers.length = count;
        URL.revokeObjectURL(url);
    }
    function decodeWorker(count, size, source, mode, filter) {
        var worker = workers[0];
        for(var i = 1; i < workers.length; ++i)if (workers[i].pending < worker.pending) worker = workers[i];
        return new Promise(function(resolve, reject) {
            var data = new Uint8Array(source);
            var id = ++requestId;
            worker.pending += count;
            worker.requests[id] = {
                resolve: resolve,
                reject: reject
            };
            worker.object.postMessage({
                id: id,
                count: count,
                size: size,
                source: data,
                mode: mode,
                filter: filter
            }, [
                data.buffer
            ]);
        });
    }
    function workerProcess(event) {
        var data = event.data;
        if (!data.id) return self.close();
        self.ready.then(function(instance) {
            try {
                var target = new Uint8Array(data.count * data.size);
                decode(instance, instance.exports[data.mode], target, data.count, data.size, data.source, instance.exports[data.filter]);
                self.postMessage({
                    id: data.id,
                    count: data.count,
                    action: 'resolve',
                    value: target
                }, [
                    target.buffer
                ]);
            } catch (error) {
                self.postMessage({
                    id: data.id,
                    count: data.count,
                    action: 'reject',
                    value: error
                });
            }
        });
    }
    return {
        ready: ready,
        supported: true,
        useWorkers: function(count) {
            initWorkers(count);
        },
        decodeVertexBuffer: function(target, count, size, source, filter) {
            decode(instance, instance.exports.meshopt_decodeVertexBuffer, target, count, size, source, instance.exports[filters[filter]]);
        },
        decodeIndexBuffer: function(target, count, size, source) {
            decode(instance, instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
        },
        decodeIndexSequence: function(target, count, size, source) {
            decode(instance, instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
        },
        decodeGltfBuffer: function(target, count, size, source, mode, filter) {
            decode(instance, instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
        },
        decodeGltfBufferAsync: function(count, size, source, mode, filter) {
            if (workers.length > 0) return decodeWorker(count, size, source, decoders[mode], filters[filter]);
            return ready.then(function() {
                var target = new Uint8Array(count * size);
                decode(instance, instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
                return target;
            });
        }
    };
}();

});

parcelRegister("7UhSE", function(module, exports) {

$parcel$export(module.exports, "clone", () => $5c1ba207eb142762$export$9cd59f9826255e47);

var $329ek = parcelRequire("329ek");parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
/**
 * @module SkeletonUtils
 * @three_import import * as SkeletonUtils from 'three/addons/utils/SkeletonUtils.js';
 */ function $5c1ba207eb142762$var$getBoneName(bone, options) {
    if (options.getBoneName !== undefined) return options.getBoneName(bone);
    return options.names[bone.name];
}
/**
 * Retargets the skeleton from the given source 3D object to the
 * target 3D object.
 *
 * @param {Object3D} target - The target 3D object.
 * @param {Object3D} source - The source 3D object.
 * @param {module:SkeletonUtils~RetargetOptions} options - The options.
 */ function $5c1ba207eb142762$export$47f99c3a75ea10cc(target, source, options = {}) {
    const quat = new (0, $329ek.Quaternion)(), scale = new (0, $329ek.Vector3)(), relativeMatrix = new (0, $329ek.Matrix4)(), globalMatrix = new (0, $329ek.Matrix4)();
    options.preserveBoneMatrix = options.preserveBoneMatrix !== undefined ? options.preserveBoneMatrix : true;
    options.preserveBonePositions = options.preserveBonePositions !== undefined ? options.preserveBonePositions : true;
    options.useTargetMatrix = options.useTargetMatrix !== undefined ? options.useTargetMatrix : false;
    options.hip = options.hip !== undefined ? options.hip : 'hip';
    options.hipInfluence = options.hipInfluence !== undefined ? options.hipInfluence : new (0, $329ek.Vector3)(1, 1, 1);
    options.scale = options.scale !== undefined ? options.scale : 1;
    options.names = options.names || {};
    const sourceBones = source.isObject3D ? source.skeleton.bones : $5c1ba207eb142762$var$getBones(source), bones = target.isObject3D ? target.skeleton.bones : $5c1ba207eb142762$var$getBones(target);
    let bone, name, boneTo, bonesPosition;
    // reset bones
    if (target.isObject3D) target.skeleton.pose();
    else {
        options.useTargetMatrix = true;
        options.preserveBoneMatrix = false;
    }
    if (options.preserveBonePositions) {
        bonesPosition = [];
        for(let i = 0; i < bones.length; i++)bonesPosition.push(bones[i].position.clone());
    }
    if (options.preserveBoneMatrix) {
        // reset matrix
        target.updateMatrixWorld();
        target.matrixWorld.identity();
        // reset children matrix
        for(let i = 0; i < target.children.length; ++i)target.children[i].updateMatrixWorld(true);
    }
    for(let i = 0; i < bones.length; ++i){
        bone = bones[i];
        name = $5c1ba207eb142762$var$getBoneName(bone, options);
        boneTo = $5c1ba207eb142762$var$getBoneByName(name, sourceBones);
        globalMatrix.copy(bone.matrixWorld);
        if (boneTo) {
            boneTo.updateMatrixWorld();
            if (options.useTargetMatrix) relativeMatrix.copy(boneTo.matrixWorld);
            else {
                relativeMatrix.copy(target.matrixWorld).invert();
                relativeMatrix.multiply(boneTo.matrixWorld);
            }
            // ignore scale to extract rotation
            scale.setFromMatrixScale(relativeMatrix);
            relativeMatrix.scale(scale.set(1 / scale.x, 1 / scale.y, 1 / scale.z));
            // apply to global matrix
            globalMatrix.makeRotationFromQuaternion(quat.setFromRotationMatrix(relativeMatrix));
            if (target.isObject3D) {
                if (options.localOffsets) {
                    if (options.localOffsets[bone.name]) globalMatrix.multiply(options.localOffsets[bone.name]);
                }
            }
            globalMatrix.copyPosition(relativeMatrix);
        }
        if (name === options.hip) {
            globalMatrix.elements[12] *= options.scale * options.hipInfluence.x;
            globalMatrix.elements[13] *= options.scale * options.hipInfluence.y;
            globalMatrix.elements[14] *= options.scale * options.hipInfluence.z;
            if (options.hipPosition !== undefined) {
                globalMatrix.elements[12] += options.hipPosition.x * options.scale;
                globalMatrix.elements[13] += options.hipPosition.y * options.scale;
                globalMatrix.elements[14] += options.hipPosition.z * options.scale;
            }
        }
        if (bone.parent) {
            bone.matrix.copy(bone.parent.matrixWorld).invert();
            bone.matrix.multiply(globalMatrix);
        } else bone.matrix.copy(globalMatrix);
        bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
        bone.updateMatrixWorld();
    }
    if (options.preserveBonePositions) for(let i = 0; i < bones.length; ++i){
        bone = bones[i];
        name = $5c1ba207eb142762$var$getBoneName(bone, options) || bone.name;
        if (name !== options.hip) bone.position.copy(bonesPosition[i]);
    }
    if (options.preserveBoneMatrix) // restore matrix
    target.updateMatrixWorld(true);
}
/**
 * Retargets the animation clip of the source object to the
 * target 3D object.
 *
 * @param {Object3D} target - The target 3D object.
 * @param {Object3D} source - The source 3D object.
 * @param {AnimationClip} clip - The animation clip.
 * @param {module:SkeletonUtils~RetargetOptions} options - The options.
 * @return {AnimationClip} The retargeted animation clip.
 */ function $5c1ba207eb142762$export$1d27fe37cc46e00b(target, source, clip, options = {}) {
    options.useFirstFramePosition = options.useFirstFramePosition !== undefined ? options.useFirstFramePosition : false;
    // Calculate the fps from the source clip based on the track with the most frames, unless fps is already provided.
    options.fps = options.fps !== undefined ? options.fps : Math.max(...clip.tracks.map((track)=>track.times.length)) / clip.duration;
    options.names = options.names || [];
    if (!source.isObject3D) source = $5c1ba207eb142762$var$getHelperFromSkeleton(source);
    const numFrames = Math.round(clip.duration * (options.fps / 1000) * 1000), delta = clip.duration / (numFrames - 1), convertedTracks = [], mixer = new (0, $329ek.AnimationMixer)(source), bones = $5c1ba207eb142762$var$getBones(target.skeleton), boneDatas = [];
    let positionOffset, bone, boneTo, boneData, name;
    mixer.clipAction(clip).play();
    // trim
    let start = 0, end = numFrames;
    if (options.trim !== undefined) {
        start = Math.round(options.trim[0] * options.fps);
        end = Math.min(Math.round(options.trim[1] * options.fps), numFrames) - start;
        mixer.update(options.trim[0]);
    } else mixer.update(0);
    source.updateMatrixWorld();
    //
    for(let frame = 0; frame < end; ++frame){
        const time = frame * delta;
        $5c1ba207eb142762$export$47f99c3a75ea10cc(target, source, options);
        for(let j = 0; j < bones.length; ++j){
            bone = bones[j];
            name = $5c1ba207eb142762$var$getBoneName(bone, options) || bone.name;
            boneTo = $5c1ba207eb142762$var$getBoneByName(name, source.skeleton);
            if (boneTo) {
                boneData = boneDatas[j] = boneDatas[j] || {
                    bone: bone
                };
                if (options.hip === name) {
                    if (!boneData.pos) boneData.pos = {
                        times: new Float32Array(end),
                        values: new Float32Array(end * 3)
                    };
                    if (options.useFirstFramePosition) {
                        if (frame === 0) positionOffset = bone.position.clone();
                        bone.position.sub(positionOffset);
                    }
                    boneData.pos.times[frame] = time;
                    bone.position.toArray(boneData.pos.values, frame * 3);
                }
                if (!boneData.quat) boneData.quat = {
                    times: new Float32Array(end),
                    values: new Float32Array(end * 4)
                };
                boneData.quat.times[frame] = time;
                bone.quaternion.toArray(boneData.quat.values, frame * 4);
            }
        }
        if (frame === end - 2) // last mixer update before final loop iteration
        // make sure we do not go over or equal to clip duration
        mixer.update(delta - 0.0000001);
        else mixer.update(delta);
        source.updateMatrixWorld();
    }
    for(let i = 0; i < boneDatas.length; ++i){
        boneData = boneDatas[i];
        if (boneData) {
            if (boneData.pos) convertedTracks.push(new (0, $329ek.VectorKeyframeTrack)('.bones[' + boneData.bone.name + '].position', boneData.pos.times, boneData.pos.values));
            convertedTracks.push(new (0, $329ek.QuaternionKeyframeTrack)('.bones[' + boneData.bone.name + '].quaternion', boneData.quat.times, boneData.quat.values));
        }
    }
    mixer.uncacheAction(clip);
    return new (0, $329ek.AnimationClip)(clip.name, -1, convertedTracks);
}
/**
 * Clones the given 3D object and its descendants, ensuring that any `SkinnedMesh` instances are
 * correctly associated with their bones. Bones are also cloned, and must be descendants of the
 * object passed to this method. Other data, like geometries and materials, are reused by reference.
 *
 * @param {Object3D} source - The 3D object to clone.
 * @return {Object3D} The cloned 3D object.
 */ function $5c1ba207eb142762$export$9cd59f9826255e47(source) {
    const sourceLookup = new Map();
    const cloneLookup = new Map();
    const clone = source.clone();
    $5c1ba207eb142762$var$parallelTraverse(source, clone, function(sourceNode, clonedNode) {
        sourceLookup.set(clonedNode, sourceNode);
        cloneLookup.set(sourceNode, clonedNode);
    });
    clone.traverse(function(node) {
        if (!node.isSkinnedMesh) return;
        const clonedMesh = node;
        const sourceMesh = sourceLookup.get(node);
        const sourceBones = sourceMesh.skeleton.bones;
        clonedMesh.skeleton = sourceMesh.skeleton.clone();
        clonedMesh.bindMatrix.copy(sourceMesh.bindMatrix);
        clonedMesh.skeleton.bones = sourceBones.map(function(bone) {
            return cloneLookup.get(bone);
        });
        clonedMesh.bind(clonedMesh.skeleton, clonedMesh.bindMatrix);
    });
    return clone;
}
// internal helper
function $5c1ba207eb142762$var$getBoneByName(name, skeleton) {
    for(let i = 0, bones = $5c1ba207eb142762$var$getBones(skeleton); i < bones.length; i++){
        if (name === bones[i].name) return bones[i];
    }
}
function $5c1ba207eb142762$var$getBones(skeleton) {
    return Array.isArray(skeleton) ? skeleton : skeleton.bones;
}
function $5c1ba207eb142762$var$getHelperFromSkeleton(skeleton) {
    const source = new (0, $329ek.SkeletonHelper)(skeleton.bones[0]);
    source.skeleton = skeleton;
    return source;
}
function $5c1ba207eb142762$var$parallelTraverse(a, b, callback) {
    callback(a, b);
    for(let i = 0; i < a.children.length; i++)$5c1ba207eb142762$var$parallelTraverse(a.children[i], b.children[i], callback);
}

});


parcelRegister("dhXas", function(module, exports) {

$parcel$export(module.exports, "AdaptiveDpr", () => $027f242adfc068c7$export$f54e12427ace2f47);

var $bxRTa = parcelRequire("bxRTa");

var $9sE5i = parcelRequire("9sE5i");
function $027f242adfc068c7$export$f54e12427ace2f47({ pixelated: pixelated }) {
    const gl = (0, $9sE5i.D)((state)=>state.gl);
    const active = (0, $9sE5i.D)((state)=>state.internal.active);
    const current = (0, $9sE5i.D)((state)=>state.performance.current);
    const initialDpr = (0, $9sE5i.D)((state)=>state.viewport.initialDpr);
    const setDpr = (0, $9sE5i.D)((state)=>state.setDpr);
    // Restore initial pixelratio on unmount
    $bxRTa.useEffect(()=>{
        const domElement = gl.domElement;
        return ()=>{
            if (active) setDpr(initialDpr);
            if (pixelated && domElement) domElement.style.imageRendering = 'auto';
        };
    }, []);
    // Set adaptive pixelratio
    $bxRTa.useEffect(()=>{
        setDpr(current * initialDpr);
        if (pixelated && gl.domElement) gl.domElement.style.imageRendering = current === 1 ? 'auto' : 'pixelated';
    }, [
        current
    ]);
    return null;
}

});
parcelRegister("9sE5i", function(module, exports) {

$parcel$export(module.exports, "e", () => $6e35d282b90a18e7$export$f1e1789686576879);
$parcel$export(module.exports, "i", () => $6e35d282b90a18e7$export$23f2a1d2818174ef);
$parcel$export(module.exports, "a", () => $6e35d282b90a18e7$export$407448d2b89b1813);
$parcel$export(module.exports, "u", () => $6e35d282b90a18e7$export$3b14a55fb2447963);
$parcel$export(module.exports, "B", () => $6e35d282b90a18e7$export$ef35774e6d314e91);
$parcel$export(module.exports, "E", () => $6e35d282b90a18e7$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "o", () => $6e35d282b90a18e7$export$ae1af26003f05816);
$parcel$export(module.exports, "D", () => $6e35d282b90a18e7$export$96f57966bedc81b4);
$parcel$export(module.exports, "F", () => $6e35d282b90a18e7$export$d66501df72047452);
$parcel$export(module.exports, "H", () => $6e35d282b90a18e7$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "k", () => $6e35d282b90a18e7$export$342063e11d6c3cad);
$parcel$export(module.exports, "b", () => $6e35d282b90a18e7$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "d", () => $6e35d282b90a18e7$export$4368d992c4eafac0);
$parcel$export(module.exports, "h", () => $6e35d282b90a18e7$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $6e35d282b90a18e7$export$db3b6bfb95261072);
parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
var $1W96c = parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");

var $bxRTa = parcelRequire("bxRTa");

var $hlfVD = parcelRequire("hlfVD");

var $asyYL = parcelRequire("asyYL");

var $6hydE = parcelRequire("6hydE");

var $fl9nK = parcelRequire("fl9nK");

var $3Rjoy = parcelRequire("3Rjoy");

var $axy3F = parcelRequire("axy3F");
var $6e35d282b90a18e7$export$625550452a3fa3ec = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
const $6e35d282b90a18e7$var$catalogue = {};
const $6e35d282b90a18e7$export$f1e1789686576879 = (objects)=>void Object.assign($6e35d282b90a18e7$var$catalogue, objects);
function $6e35d282b90a18e7$var$createRenderer(_roots, _getEventPriority) {
    function createInstance(type, { args: args = [], attach: attach, ...props }, root) {
        let name = `${type[0].toUpperCase()}${type.slice(1)}`;
        let instance;
        if (type === 'primitive') {
            if (props.object === undefined) throw new Error("R3F: Primitives without 'object' are invalid!");
            const object = props.object;
            instance = $6e35d282b90a18e7$var$prepare(object, {
                type: type,
                root: root,
                attach: attach,
                primitive: true
            });
        } else {
            const target = $6e35d282b90a18e7$var$catalogue[name];
            if (!target) throw new Error(`R3F: ${name} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`);
            // Throw if an object or literal was passed for args
            if (!Array.isArray(args)) throw new Error('R3F: The args prop must be an array!');
            // Instanciate new object, link it to the root
            // Append memoized props with args so it's not forgotten
            instance = $6e35d282b90a18e7$var$prepare(new target(...args), {
                type: type,
                root: root,
                attach: attach,
                // Save args in case we need to reconstruct later for HMR
                memoizedProps: {
                    args: args
                }
            });
        }
        // Auto-attach geometries and materials
        if (instance.__r3f.attach === undefined) {
            if (instance.isBufferGeometry) instance.__r3f.attach = 'geometry';
            else if (instance.isMaterial) instance.__r3f.attach = 'material';
        }
        // It should NOT call onUpdate on object instanciation, because it hasn't been added to the
        // view yet. If the callback relies on references for instance, they won't be ready yet, this is
        // why it passes "true" here
        // There is no reason to apply props to injects
        if (name !== 'inject') $6e35d282b90a18e7$var$applyProps$1(instance, props);
        return instance;
    }
    function appendChild(parentInstance, child) {
        let added = false;
        if (child) {
            var _child$__r3f, _parentInstance$__r3f;
            // The attach attribute implies that the object attaches itself on the parent
            if ((_child$__r3f = child.__r3f) != null && _child$__r3f.attach) $6e35d282b90a18e7$var$attach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                // add in the usual parent-child way
                parentInstance.add(child);
                added = true;
            }
            // This is for anything that used attach, and for non-Object3Ds that don't get attached to props;
            // that is, anything that's a child in React but not a child in the scenegraph.
            if (!added) (_parentInstance$__r3f = parentInstance.__r3f) == null || _parentInstance$__r3f.objects.push(child);
            if (!child.__r3f) $6e35d282b90a18e7$var$prepare(child, {});
            child.__r3f.parent = parentInstance;
            $6e35d282b90a18e7$var$updateInstance(child);
            $6e35d282b90a18e7$var$invalidateInstance(child);
        }
    }
    function insertBefore(parentInstance, child, beforeChild) {
        let added = false;
        if (child) {
            var _child$__r3f2, _parentInstance$__r3f2;
            if ((_child$__r3f2 = child.__r3f) != null && _child$__r3f2.attach) $6e35d282b90a18e7$var$attach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                child.parent = parentInstance;
                child.dispatchEvent({
                    type: 'added'
                });
                parentInstance.dispatchEvent({
                    type: 'childadded',
                    child: child
                });
                const restSiblings = parentInstance.children.filter((sibling)=>sibling !== child);
                const index = restSiblings.indexOf(beforeChild);
                parentInstance.children = [
                    ...restSiblings.slice(0, index),
                    child,
                    ...restSiblings.slice(index)
                ];
                added = true;
            }
            if (!added) (_parentInstance$__r3f2 = parentInstance.__r3f) == null || _parentInstance$__r3f2.objects.push(child);
            if (!child.__r3f) $6e35d282b90a18e7$var$prepare(child, {});
            child.__r3f.parent = parentInstance;
            $6e35d282b90a18e7$var$updateInstance(child);
            $6e35d282b90a18e7$var$invalidateInstance(child);
        }
    }
    function removeRecursive(array, parent, dispose = false) {
        if (array) [
            ...array
        ].forEach((child)=>removeChild(parent, child, dispose));
    }
    function removeChild(parentInstance, child, dispose) {
        if (child) {
            var _parentInstance$__r3f3, _child$__r3f3, _child$__r3f5;
            // Clear the parent reference
            if (child.__r3f) child.__r3f.parent = null;
            // Remove child from the parents objects
            if ((_parentInstance$__r3f3 = parentInstance.__r3f) != null && _parentInstance$__r3f3.objects) parentInstance.__r3f.objects = parentInstance.__r3f.objects.filter((x)=>x !== child);
            // Remove attachment
            if ((_child$__r3f3 = child.__r3f) != null && _child$__r3f3.attach) $6e35d282b90a18e7$var$detach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                var _child$__r3f4;
                parentInstance.remove(child);
                // @ts-expect-error
                // Remove interactivity on the initial root
                if ((_child$__r3f4 = child.__r3f) != null && _child$__r3f4.root) $6e35d282b90a18e7$var$removeInteractivity($6e35d282b90a18e7$var$findInitialRoot(child), child);
            }
            // Allow objects to bail out of recursive dispose altogether by passing dispose={null}
            // Never dispose of primitives because their state may be kept outside of React!
            // In order for an object to be able to dispose it has to have
            //   - a dispose method,
            //   - it cannot be a <primitive object={...} />
            //   - it cannot be a THREE.Scene, because three has broken it's own api
            //
            // Since disposal is recursive, we can check the optional dispose arg, which will be undefined
            // when the reconciler calls it, but then carry our own check recursively
            const isPrimitive = (_child$__r3f5 = child.__r3f) == null ? void 0 : _child$__r3f5.primitive;
            const shouldDispose = !isPrimitive && (dispose === undefined ? child.dispose !== null : dispose);
            // Remove nested child objects. Primitives should not have objects and children that are
            // attached to them declaratively ...
            if (!isPrimitive) {
                var _child$__r3f6;
                removeRecursive((_child$__r3f6 = child.__r3f) == null ? void 0 : _child$__r3f6.objects, child, shouldDispose);
                removeRecursive(child.children, child, shouldDispose);
            }
            // Remove references
            delete child.__r3f;
            // Dispose item whenever the reconciler feels like it
            if (shouldDispose && child.dispose && child.type !== 'Scene') {
                const callback = ()=>{
                    try {
                        child.dispose();
                    } catch (e) {
                    /* ... */ }
                };
                // Schedule async at runtime, flush sync in testing
                if (typeof IS_REACT_ACT_ENVIRONMENT === 'undefined') (0, $axy3F.unstable_scheduleCallback)((0, $axy3F.unstable_IdlePriority), callback);
                else callback();
            }
            $6e35d282b90a18e7$var$invalidateInstance(parentInstance);
        }
    }
    function switchInstance(instance, type, newProps, fiber) {
        var _instance$__r3f;
        const parent = (_instance$__r3f = instance.__r3f) == null ? void 0 : _instance$__r3f.parent;
        if (!parent) return;
        const newInstance = createInstance(type, newProps, instance.__r3f.root);
        // https://github.com/pmndrs/react-three-fiber/issues/1348
        // When args change the instance has to be re-constructed, which then
        // forces r3f to re-parent the children and non-scene objects
        if (instance.children) {
            for (const child of instance.children)if (child.__r3f) appendChild(newInstance, child);
            instance.children = instance.children.filter((child)=>!child.__r3f);
        }
        instance.__r3f.objects.forEach((child)=>appendChild(newInstance, child));
        instance.__r3f.objects = [];
        if (!instance.__r3f.autoRemovedBeforeAppend) removeChild(parent, instance);
        if (newInstance.parent) newInstance.__r3f.autoRemovedBeforeAppend = true;
        appendChild(parent, newInstance);
        // Re-bind event handlers on the initial root
        if (newInstance.raycast && newInstance.__r3f.eventCount) {
            const rootState = $6e35d282b90a18e7$var$findInitialRoot(newInstance).getState();
            rootState.internal.interaction.push(newInstance);
        }
        [
            fiber,
            fiber.alternate
        ].forEach((fiber)=>{
            if (fiber !== null) {
                fiber.stateNode = newInstance;
                if (fiber.ref) {
                    if (typeof fiber.ref === 'function') fiber.ref(newInstance);
                    else fiber.ref.current = newInstance;
                }
            }
        });
    }
    // Don't handle text instances, make it no-op
    const handleTextInstance = ()=>{};
    const reconciler = (0, (/*@__PURE__*/$parcel$interopDefault($3Rjoy)))({
        createInstance: createInstance,
        removeChild: removeChild,
        appendChild: appendChild,
        appendInitialChild: appendChild,
        insertBefore: insertBefore,
        supportsMutation: true,
        isPrimaryRenderer: false,
        supportsPersistence: false,
        supportsHydration: false,
        noTimeout: -1,
        appendChildToContainer: (container, child)=>{
            if (!child) return;
            // Don't append to unmounted container
            const scene = container.getState().scene;
            if (!scene.__r3f) return;
            // Link current root to the default scene
            scene.__r3f.root = container;
            appendChild(scene, child);
        },
        removeChildFromContainer: (container, child)=>{
            if (!child) return;
            removeChild(container.getState().scene, child);
        },
        insertInContainerBefore: (container, child, beforeChild)=>{
            if (!child || !beforeChild) return;
            // Don't append to unmounted container
            const scene = container.getState().scene;
            if (!scene.__r3f) return;
            insertBefore(scene, child, beforeChild);
        },
        getRootHostContext: ()=>null,
        getChildHostContext: (parentHostContext)=>parentHostContext,
        finalizeInitialChildren (instance) {
            var _instance$__r3f2;
            const localState = (_instance$__r3f2 = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f2 : {};
            // https://github.com/facebook/react/issues/20271
            // Returning true will trigger commitMount
            return Boolean(localState.handlers);
        },
        prepareUpdate (instance, _type, oldProps, newProps) {
            var _instance$__r3f3;
            const localState = (_instance$__r3f3 = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f3 : {};
            // Create diff-sets
            if (localState.primitive && newProps.object && newProps.object !== instance) return [
                true
            ];
            else {
                // This is a data object, let's extract critical information about it
                const { args: argsNew = [], children: cN, ...restNew } = newProps;
                const { args: argsOld = [], children: cO, ...restOld } = oldProps;
                // Throw if an object or literal was passed for args
                if (!Array.isArray(argsNew)) throw new Error('R3F: the args prop must be an array!');
                // If it has new props or arguments, then it needs to be re-instantiated
                if (argsNew.some((value, index)=>value !== argsOld[index])) return [
                    true
                ];
                // Create a diff-set, flag if there are any changes
                const diff = $6e35d282b90a18e7$var$diffProps(instance, restNew, restOld, true);
                if (diff.changes.length) return [
                    false,
                    diff
                ];
                // Otherwise do not touch the instance
                return null;
            }
        },
        commitUpdate (instance, [reconstruct, diff], type, _oldProps, newProps, fiber) {
            // Reconstruct when args or <primitive object={...} have changes
            if (reconstruct) switchInstance(instance, type, newProps, fiber);
            else $6e35d282b90a18e7$var$applyProps$1(instance, diff);
        },
        commitMount (instance, _type, _props, _int) {
            var _instance$__r3f4;
            // https://github.com/facebook/react/issues/20271
            // This will make sure events are only added once to the central container on the initial root
            const localState = (_instance$__r3f4 = instance.__r3f) != null ? _instance$__r3f4 : {};
            if (instance.raycast && localState.handlers && localState.eventCount) $6e35d282b90a18e7$var$findInitialRoot(instance).getState().internal.interaction.push(instance);
        },
        getPublicInstance: (instance)=>instance,
        prepareForCommit: ()=>null,
        preparePortalMount: (container)=>$6e35d282b90a18e7$var$prepare(container.getState().scene),
        resetAfterCommit: ()=>{},
        shouldSetTextContent: ()=>false,
        clearContainer: ()=>false,
        hideInstance (instance) {
            var _instance$__r3f5;
            // Detach while the instance is hidden
            const { attach: type, parent: parent } = (_instance$__r3f5 = instance.__r3f) != null ? _instance$__r3f5 : {};
            if (type && parent) $6e35d282b90a18e7$var$detach(parent, instance, type);
            if (instance.isObject3D) instance.visible = false;
            $6e35d282b90a18e7$var$invalidateInstance(instance);
        },
        unhideInstance (instance, props) {
            var _instance$__r3f6;
            // Re-attach when the instance is unhidden
            const { attach: type, parent: parent } = (_instance$__r3f6 = instance.__r3f) != null ? _instance$__r3f6 : {};
            if (type && parent) $6e35d282b90a18e7$var$attach(parent, instance, type);
            if (instance.isObject3D && props.visible == null || props.visible) instance.visible = true;
            $6e35d282b90a18e7$var$invalidateInstance(instance);
        },
        createTextInstance: handleTextInstance,
        hideTextInstance: handleTextInstance,
        unhideTextInstance: handleTextInstance,
        // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r916356874
        // @ts-expect-error
        getCurrentEventPriority: ()=>_getEventPriority ? _getEventPriority() : (0, $hlfVD.DefaultEventPriority),
        beforeActiveInstanceBlur: ()=>{},
        afterActiveInstanceBlur: ()=>{},
        detachDeletedInstance: ()=>{},
        now: typeof performance !== 'undefined' && $6e35d282b90a18e7$var$is.fun(performance.now) ? performance.now : $6e35d282b90a18e7$var$is.fun(Date.now) ? Date.now : ()=>0,
        // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r920883503
        scheduleTimeout: $6e35d282b90a18e7$var$is.fun(setTimeout) ? setTimeout : undefined,
        cancelTimeout: $6e35d282b90a18e7$var$is.fun(clearTimeout) ? clearTimeout : undefined
    });
    return {
        reconciler: reconciler,
        applyProps: $6e35d282b90a18e7$var$applyProps$1
    };
}
var $6e35d282b90a18e7$var$_window$document, $6e35d282b90a18e7$var$_window$navigator;
/**
 * Returns `true` with correct TS type inference if an object has a configurable color space (since r152).
 */ const $6e35d282b90a18e7$var$hasColorSpace = (object)=>'colorSpace' in object || 'outputColorSpace' in object;
/**
 * The current THREE.ColorManagement instance, if present.
 */ const $6e35d282b90a18e7$var$getColorManagement = ()=>{
    var _ColorManagement;
    return (_ColorManagement = $6e35d282b90a18e7$var$catalogue.ColorManagement) != null ? _ColorManagement : null;
};
const $6e35d282b90a18e7$var$isOrthographicCamera = (def)=>def && def.isOrthographicCamera;
const $6e35d282b90a18e7$export$23f2a1d2818174ef = (obj)=>obj && obj.hasOwnProperty('current');
/**
 * An SSR-friendly useLayoutEffect.
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect elsewhere.
 *
 * @see https://github.com/facebook/react/issues/14927
 */ const $6e35d282b90a18e7$export$407448d2b89b1813 = typeof window !== 'undefined' && (($6e35d282b90a18e7$var$_window$document = window.document) != null && $6e35d282b90a18e7$var$_window$document.createElement || (($6e35d282b90a18e7$var$_window$navigator = window.navigator) == null ? void 0 : $6e35d282b90a18e7$var$_window$navigator.product) === 'ReactNative') ? $bxRTa.useLayoutEffect : $bxRTa.useEffect;
function $6e35d282b90a18e7$export$3b14a55fb2447963(fn) {
    const ref = $bxRTa.useRef(fn);
    $6e35d282b90a18e7$export$407448d2b89b1813(()=>void (ref.current = fn), [
        fn
    ]);
    return ref;
}
function $6e35d282b90a18e7$export$ef35774e6d314e91({ set: set }) {
    $6e35d282b90a18e7$export$407448d2b89b1813(()=>{
        set(new Promise(()=>null));
        return ()=>set(false);
    }, [
        set
    ]);
    return null;
}
class $6e35d282b90a18e7$export$a9c23c6ac3fc3eca extends $bxRTa.Component {
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
    }
    componentDidCatch(err) {
        this.props.set(err);
    }
    render() {
        return this.state.error ? null : this.props.children;
    }
}
$6e35d282b90a18e7$export$a9c23c6ac3fc3eca.getDerivedStateFromError = ()=>({
        error: true
    });
const $6e35d282b90a18e7$var$DEFAULT = '__default';
const $6e35d282b90a18e7$var$DEFAULTS = new Map();
const $6e35d282b90a18e7$var$isDiffSet = (def)=>def && !!def.memoized && !!def.changes;
function $6e35d282b90a18e7$var$calculateDpr(dpr) {
    var _window$devicePixelRa;
    // Err on the side of progress by assuming 2x dpr if we can't detect it
    // This will happen in workers where window is defined but dpr isn't.
    const target = typeof window !== 'undefined' ? (_window$devicePixelRa = window.devicePixelRatio) != null ? _window$devicePixelRa : 2 : 1;
    return Array.isArray(dpr) ? Math.min(Math.max(dpr[0], target), dpr[1]) : dpr;
}
/**
 * Returns instance root state
 */ const $6e35d282b90a18e7$export$efccba1c4a2ef57b = (obj)=>{
    var _r3f;
    return (_r3f = obj.__r3f) == null ? void 0 : _r3f.root.getState();
};
/**
 * Returns the instances initial (outmost) root
 */ function $6e35d282b90a18e7$var$findInitialRoot(child) {
    let root = child.__r3f.root;
    while(root.getState().previousRoot)root = root.getState().previousRoot;
    return root;
}
// A collection of compare functions
const $6e35d282b90a18e7$var$is = {
    obj: (a)=>a === Object(a) && !$6e35d282b90a18e7$var$is.arr(a) && typeof a !== 'function',
    fun: (a)=>typeof a === 'function',
    str: (a)=>typeof a === 'string',
    num: (a)=>typeof a === 'number',
    boo: (a)=>typeof a === 'boolean',
    und: (a)=>a === void 0,
    arr: (a)=>Array.isArray(a),
    equ (a, b, { arrays: arrays = 'shallow', objects: objects = 'reference', strict: strict = true } = {}) {
        // Wrong type or one of the two undefined, doesn't match
        if (typeof a !== typeof b || !!a !== !!b) return false;
        // Atomic, just compare a against b
        if ($6e35d282b90a18e7$var$is.str(a) || $6e35d282b90a18e7$var$is.num(a) || $6e35d282b90a18e7$var$is.boo(a)) return a === b;
        const isObj = $6e35d282b90a18e7$var$is.obj(a);
        if (isObj && objects === 'reference') return a === b;
        const isArr = $6e35d282b90a18e7$var$is.arr(a);
        if (isArr && arrays === 'reference') return a === b;
        // Array or Object, shallow compare first to see if it's a match
        if ((isArr || isObj) && a === b) return true;
        // Last resort, go through keys
        let i;
        // Check if a has all the keys of b
        for(i in a)if (!(i in b)) return false;
        // Check if values between keys match
        if (isObj && arrays === 'shallow' && objects === 'shallow') {
            for(i in strict ? b : a)if (!$6e35d282b90a18e7$var$is.equ(a[i], b[i], {
                strict: strict,
                objects: 'reference'
            })) return false;
        } else {
            for(i in strict ? b : a)if (a[i] !== b[i]) return false;
        }
        // If i is undefined
        if ($6e35d282b90a18e7$var$is.und(i)) {
            // If both arrays are empty we consider them equal
            if (isArr && a.length === 0 && b.length === 0) return true;
            // If both objects are empty we consider them equal
            if (isObj && Object.keys(a).length === 0 && Object.keys(b).length === 0) return true;
            // Otherwise match them by value
            if (a !== b) return false;
        }
        return true;
    }
};
/**
 * Collects nodes and materials from a THREE.Object3D.
 */ function $6e35d282b90a18e7$export$4a5767248b18ef41(object) {
    const data = {
        nodes: {},
        materials: {}
    };
    if (object) object.traverse((obj)=>{
        if (obj.name) data.nodes[obj.name] = obj;
        if (obj.material && !data.materials[obj.material.name]) data.materials[obj.material.name] = obj.material;
    });
    return data;
}
// Disposes an object and all its properties
function $6e35d282b90a18e7$export$882b5998b3b9117c(obj) {
    if (obj.dispose && obj.type !== 'Scene') obj.dispose();
    for(const p in obj){
        p.dispose == null || p.dispose();
        delete obj[p];
    }
}
// Each object in the scene carries a small LocalState descriptor
function $6e35d282b90a18e7$var$prepare(object, state) {
    const instance = object;
    instance.__r3f = {
        type: '',
        root: null,
        previousAttach: null,
        memoizedProps: {},
        eventCount: 0,
        handlers: {},
        objects: [],
        parent: null,
        ...state
    };
    return object;
}
function $6e35d282b90a18e7$var$resolve(instance, key) {
    let target = instance;
    if (key.includes('-')) {
        const entries = key.split('-');
        const last = entries.pop();
        target = entries.reduce((acc, key)=>acc[key], instance);
        return {
            target: target,
            key: last
        };
    } else return {
        target: target,
        key: key
    };
}
// Checks if a dash-cased string ends with an integer
const $6e35d282b90a18e7$var$INDEX_REGEX = /-\d+$/;
function $6e35d282b90a18e7$var$attach(parent, child, type) {
    if ($6e35d282b90a18e7$var$is.str(type)) {
        // If attaching into an array (foo-0), create one
        if ($6e35d282b90a18e7$var$INDEX_REGEX.test(type)) {
            const root = type.replace($6e35d282b90a18e7$var$INDEX_REGEX, '');
            const { target: target, key: key } = $6e35d282b90a18e7$var$resolve(parent, root);
            if (!Array.isArray(target[key])) target[key] = [];
        }
        const { target: target, key: key } = $6e35d282b90a18e7$var$resolve(parent, type);
        child.__r3f.previousAttach = target[key];
        target[key] = child;
    } else child.__r3f.previousAttach = type(parent, child);
}
function $6e35d282b90a18e7$var$detach(parent, child, type) {
    var _child$__r3f, _child$__r3f2;
    if ($6e35d282b90a18e7$var$is.str(type)) {
        const { target: target, key: key } = $6e35d282b90a18e7$var$resolve(parent, type);
        const previous = child.__r3f.previousAttach;
        // When the previous value was undefined, it means the value was never set to begin with
        if (previous === undefined) delete target[key];
        else target[key] = previous;
    } else (_child$__r3f = child.__r3f) == null || _child$__r3f.previousAttach == null || _child$__r3f.previousAttach(parent, child);
    (_child$__r3f2 = child.__r3f) == null || delete _child$__r3f2.previousAttach;
}
// This function prepares a set of changes to be applied to the instance
function $6e35d282b90a18e7$var$diffProps(instance, { children: cN, key: kN, ref: rN, ...props }, { children: cP, key: kP, ref: rP, ...previous } = {}, remove = false) {
    const localState = instance.__r3f;
    const entries = Object.entries(props);
    const changes = [];
    // Catch removed props, prepend them so they can be reset or removed
    if (remove) {
        const previousKeys = Object.keys(previous);
        for(let i = 0; i < previousKeys.length; i++)if (!props.hasOwnProperty(previousKeys[i])) entries.unshift([
            previousKeys[i],
            $6e35d282b90a18e7$var$DEFAULT + 'remove'
        ]);
    }
    entries.forEach(([key, value])=>{
        var _instance$__r3f;
        // Bail out on primitive object
        if ((_instance$__r3f = instance.__r3f) != null && _instance$__r3f.primitive && key === 'object') return;
        // When props match bail out
        if ($6e35d282b90a18e7$var$is.equ(value, previous[key])) return;
        // Collect handlers and bail out
        if (/^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/.test(key)) return changes.push([
            key,
            value,
            true,
            []
        ]);
        // Split dashed props
        let entries = [];
        if (key.includes('-')) entries = key.split('-');
        changes.push([
            key,
            value,
            false,
            entries
        ]);
        // Reset pierced props
        for(const prop in props){
            const value = props[prop];
            if (prop.startsWith(`${key}-`)) changes.push([
                prop,
                value,
                false,
                prop.split('-')
            ]);
        }
    });
    const memoized = {
        ...props
    };
    if (localState != null && localState.memoizedProps && localState != null && localState.memoizedProps.args) memoized.args = localState.memoizedProps.args;
    if (localState != null && localState.memoizedProps && localState != null && localState.memoizedProps.attach) memoized.attach = localState.memoizedProps.attach;
    return {
        memoized: memoized,
        changes: changes
    };
}
const $6e35d282b90a18e7$var$__DEV__ = false;
// This function applies a set of changes to the instance
function $6e35d282b90a18e7$var$applyProps$1(instance, data) {
    var _instance$__r3f2;
    // Filter equals, events and reserved props
    const localState = instance.__r3f;
    const root = localState == null ? void 0 : localState.root;
    const rootState = root == null ? void 0 : root.getState == null ? void 0 : root.getState();
    const { memoized: memoized, changes: changes } = $6e35d282b90a18e7$var$isDiffSet(data) ? data : $6e35d282b90a18e7$var$diffProps(instance, data);
    const prevHandlers = localState == null ? void 0 : localState.eventCount;
    // Prepare memoized props
    if (instance.__r3f) instance.__r3f.memoizedProps = memoized;
    for(let i = 0; i < changes.length; i++){
        let [key, value, isEvent, keys] = changes[i];
        // Alias (output)encoding => (output)colorSpace (since r152)
        // https://github.com/pmndrs/react-three-fiber/pull/2829
        if ($6e35d282b90a18e7$var$hasColorSpace(instance)) {
            const sRGBEncoding = 3001;
            const SRGBColorSpace = 'srgb';
            const LinearSRGBColorSpace = 'srgb-linear';
            if (key === 'encoding') {
                key = 'colorSpace';
                value = value === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
            } else if (key === 'outputEncoding') {
                key = 'outputColorSpace';
                value = value === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
            }
        }
        let currentInstance = instance;
        let targetProp = currentInstance[key];
        // Revolve dashed props
        if (keys.length) {
            targetProp = keys.reduce((acc, key)=>acc[key], instance);
            // If the target is atomic, it forces us to switch the root
            if (!(targetProp && targetProp.set)) {
                const [name, ...reverseEntries] = keys.reverse();
                currentInstance = reverseEntries.reverse().reduce((acc, key)=>acc[key], instance);
                key = name;
            }
        }
        // https://github.com/mrdoob/three.js/issues/21209
        // HMR/fast-refresh relies on the ability to cancel out props, but threejs
        // has no means to do this. Hence we curate a small collection of value-classes
        // with their respective constructor/set arguments
        // For removed props, try to set default values, if possible
        if (value === $6e35d282b90a18e7$var$DEFAULT + 'remove') {
            if (currentInstance.constructor) {
                // create a blank slate of the instance and copy the particular parameter.
                let ctor = $6e35d282b90a18e7$var$DEFAULTS.get(currentInstance.constructor);
                if (!ctor) {
                    // @ts-expect-error
                    ctor = new currentInstance.constructor();
                    $6e35d282b90a18e7$var$DEFAULTS.set(currentInstance.constructor, ctor);
                }
                value = ctor[key];
            } else // instance does not have constructor, just set it to 0
            value = 0;
        }
        // Deal with pointer events ...
        if (isEvent && localState) {
            if (value) localState.handlers[key] = value;
            else delete localState.handlers[key];
            localState.eventCount = Object.keys(localState.handlers).length;
        } else if (targetProp && targetProp.set && (targetProp.copy || targetProp instanceof $329ek.Layers)) {
            // If value is an array
            if (Array.isArray(value)) {
                if (targetProp.fromArray) targetProp.fromArray(value);
                else targetProp.set(...value);
            } else if (targetProp.copy && value && value.constructor && // Some environments may break strict identity checks by duplicating versions of three.js.
            // Loosen to unminified names, ignoring descendents.
            // https://github.com/pmndrs/react-three-fiber/issues/2856
            // TODO: fix upstream and remove in v9
            ($6e35d282b90a18e7$var$__DEV__ ? targetProp.constructor.name === value.constructor.name : targetProp.constructor === value.constructor)) targetProp.copy(value);
            else if (value !== undefined) {
                var _targetProp;
                const isColor = (_targetProp = targetProp) == null ? void 0 : _targetProp.isColor;
                // Allow setting array scalars
                if (!isColor && targetProp.setScalar) targetProp.setScalar(value);
                else if (targetProp instanceof $329ek.Layers && value instanceof $329ek.Layers) targetProp.mask = value.mask;
                else targetProp.set(value);
                // For versions of three which don't support THREE.ColorManagement,
                // Auto-convert sRGB colors
                // https://github.com/pmndrs/react-three-fiber/issues/344
                if (!$6e35d282b90a18e7$var$getColorManagement() && rootState && !rootState.linear && isColor) targetProp.convertSRGBToLinear();
            }
        // Else, just overwrite the value
        } else {
            var _currentInstance$key;
            currentInstance[key] = value;
            // Auto-convert sRGB textures, for now ...
            // https://github.com/pmndrs/react-three-fiber/issues/344
            if ((_currentInstance$key = currentInstance[key]) != null && _currentInstance$key.isTexture && // sRGB textures must be RGBA8 since r137 https://github.com/mrdoob/three.js/pull/23129
            currentInstance[key].format === $329ek.RGBAFormat && currentInstance[key].type === $329ek.UnsignedByteType && rootState) {
                const texture = currentInstance[key];
                if ($6e35d282b90a18e7$var$hasColorSpace(texture) && $6e35d282b90a18e7$var$hasColorSpace(rootState.gl)) texture.colorSpace = rootState.gl.outputColorSpace;
                else texture.encoding = rootState.gl.outputEncoding;
            }
        }
        $6e35d282b90a18e7$var$invalidateInstance(instance);
    }
    if (localState && localState.parent && instance.raycast && prevHandlers !== localState.eventCount) {
        // Get the initial root state's internals
        const internal = $6e35d282b90a18e7$var$findInitialRoot(instance).getState().internal;
        // Pre-emptively remove the instance from the interaction manager
        const index = internal.interaction.indexOf(instance);
        if (index > -1) internal.interaction.splice(index, 1);
        // Add the instance to the interaction manager only when it has handlers
        if (localState.eventCount) internal.interaction.push(instance);
    }
    // Call the update lifecycle when it is being updated, but only when it is part of the scene.
    // Skip updates to the `onUpdate` prop itself
    const isCircular = changes.length === 1 && changes[0][0] === 'onUpdate';
    if (!isCircular && changes.length && (_instance$__r3f2 = instance.__r3f) != null && _instance$__r3f2.parent) $6e35d282b90a18e7$var$updateInstance(instance);
    return instance;
}
function $6e35d282b90a18e7$var$invalidateInstance(instance) {
    var _instance$__r3f3, _instance$__r3f3$root;
    const state = (_instance$__r3f3 = instance.__r3f) == null ? void 0 : (_instance$__r3f3$root = _instance$__r3f3.root) == null ? void 0 : _instance$__r3f3$root.getState == null ? void 0 : _instance$__r3f3$root.getState();
    if (state && state.internal.frames === 0) state.invalidate();
}
function $6e35d282b90a18e7$var$updateInstance(instance) {
    instance.onUpdate == null || instance.onUpdate(instance);
}
function $6e35d282b90a18e7$var$updateCamera(camera, size) {
    // https://github.com/pmndrs/react-three-fiber/issues/92
    // Do not mess with the camera if it belongs to the user
    if (!camera.manual) {
        if ($6e35d282b90a18e7$var$isOrthographicCamera(camera)) {
            camera.left = size.width / -2;
            camera.right = size.width / 2;
            camera.top = size.height / 2;
            camera.bottom = size.height / -2;
        } else camera.aspect = size.width / size.height;
        camera.updateProjectionMatrix();
        // https://github.com/pmndrs/react-three-fiber/issues/178
        // Update matrix world since the renderer is a frame late
        camera.updateMatrixWorld();
    }
}
function $6e35d282b90a18e7$var$makeId(event) {
    return (event.eventObject || event.object).uuid + '/' + event.index + event.instanceId;
}
// https://github.com/facebook/react/tree/main/packages/react-reconciler#getcurrenteventpriority
// Gives React a clue as to how import the current interaction is
function $6e35d282b90a18e7$var$getEventPriority() {
    var _globalScope$event;
    // Get a handle to the current global scope in window and worker contexts if able
    // https://github.com/pmndrs/react-three-fiber/pull/2493
    const globalScope = typeof self !== 'undefined' && self || typeof window !== 'undefined' && window;
    if (!globalScope) return 0, $hlfVD.DefaultEventPriority;
    const name = (_globalScope$event = globalScope.event) == null ? void 0 : _globalScope$event.type;
    switch(name){
        case 'click':
        case 'contextmenu':
        case 'dblclick':
        case 'pointercancel':
        case 'pointerdown':
        case 'pointerup':
            return 0, $hlfVD.DiscreteEventPriority;
        case 'pointermove':
        case 'pointerout':
        case 'pointerover':
        case 'pointerenter':
        case 'pointerleave':
        case 'wheel':
            return 0, $hlfVD.ContinuousEventPriority;
        default:
            return 0, $hlfVD.DefaultEventPriority;
    }
}
/**
 * Release pointer captures.
 * This is called by releasePointerCapture in the API, and when an object is removed.
 */ function $6e35d282b90a18e7$var$releaseInternalPointerCapture(capturedMap, obj, captures, pointerId) {
    const captureData = captures.get(obj);
    if (captureData) {
        captures.delete(obj);
        // If this was the last capturing object for this pointer
        if (captures.size === 0) {
            capturedMap.delete(pointerId);
            captureData.target.releasePointerCapture(pointerId);
        }
    }
}
function $6e35d282b90a18e7$var$removeInteractivity(store, object) {
    const { internal: internal } = store.getState();
    // Removes every trace of an object from the data store
    internal.interaction = internal.interaction.filter((o)=>o !== object);
    internal.initialHits = internal.initialHits.filter((o)=>o !== object);
    internal.hovered.forEach((value, key)=>{
        if (value.eventObject === object || value.object === object) // Clear out intersects, they are outdated by now
        internal.hovered.delete(key);
    });
    internal.capturedMap.forEach((captures, pointerId)=>{
        $6e35d282b90a18e7$var$releaseInternalPointerCapture(internal.capturedMap, object, captures, pointerId);
    });
}
function $6e35d282b90a18e7$export$2d1720544b23b823(store) {
    /** Calculates delta */ function calculateDistance(event) {
        const { internal: internal } = store.getState();
        const dx = event.offsetX - internal.initialClick[0];
        const dy = event.offsetY - internal.initialClick[1];
        return Math.round(Math.sqrt(dx * dx + dy * dy));
    }
    /** Returns true if an instance has a valid pointer-event registered, this excludes scroll, clicks etc */ function filterPointerEvents(objects) {
        return objects.filter((obj)=>[
                'Move',
                'Over',
                'Enter',
                'Out',
                'Leave'
            ].some((name)=>{
                var _r3f;
                return (_r3f = obj.__r3f) == null ? void 0 : _r3f.handlers['onPointer' + name];
            }));
    }
    function intersect(event, filter) {
        const state = store.getState();
        const duplicates = new Set();
        const intersections = [];
        // Allow callers to eliminate event objects
        const eventsObjects = filter ? filter(state.internal.interaction) : state.internal.interaction;
        // Reset all raycaster cameras to undefined
        for(let i = 0; i < eventsObjects.length; i++){
            const state = $6e35d282b90a18e7$export$efccba1c4a2ef57b(eventsObjects[i]);
            if (state) state.raycaster.camera = undefined;
        }
        if (!state.previousRoot) // Make sure root-level pointer and ray are set up
        state.events.compute == null || state.events.compute(event, state);
        function handleRaycast(obj) {
            const state = $6e35d282b90a18e7$export$efccba1c4a2ef57b(obj);
            // Skip event handling when noEvents is set, or when the raycasters camera is null
            if (!state || !state.events.enabled || state.raycaster.camera === null) return [];
            // When the camera is undefined we have to call the event layers update function
            if (state.raycaster.camera === undefined) {
                var _state$previousRoot;
                state.events.compute == null || state.events.compute(event, state, (_state$previousRoot = state.previousRoot) == null ? void 0 : _state$previousRoot.getState());
                // If the camera is still undefined we have to skip this layer entirely
                if (state.raycaster.camera === undefined) state.raycaster.camera = null;
            }
            // Intersect object by object
            return state.raycaster.camera ? state.raycaster.intersectObject(obj, true) : [];
        }
        // Collect events
        let hits = eventsObjects// Intersect objects
        .flatMap(handleRaycast)// Sort by event priority and distance
        .sort((a, b)=>{
            const aState = $6e35d282b90a18e7$export$efccba1c4a2ef57b(a.object);
            const bState = $6e35d282b90a18e7$export$efccba1c4a2ef57b(b.object);
            if (!aState || !bState) return a.distance - b.distance;
            return bState.events.priority - aState.events.priority || a.distance - b.distance;
        })// Filter out duplicates
        .filter((item)=>{
            const id = $6e35d282b90a18e7$var$makeId(item);
            if (duplicates.has(id)) return false;
            duplicates.add(id);
            return true;
        });
        // https://github.com/mrdoob/three.js/issues/16031
        // Allow custom userland intersect sort order, this likely only makes sense on the root filter
        if (state.events.filter) hits = state.events.filter(hits, state);
        // Bubble up the events, find the event source (eventObject)
        for (const hit of hits){
            let eventObject = hit.object;
            // Bubble event up
            while(eventObject){
                var _r3f2;
                if ((_r3f2 = eventObject.__r3f) != null && _r3f2.eventCount) intersections.push({
                    ...hit,
                    eventObject: eventObject
                });
                eventObject = eventObject.parent;
            }
        }
        // If the interaction is captured, make all capturing targets part of the intersect.
        if ('pointerId' in event && state.internal.capturedMap.has(event.pointerId)) {
            for (let captureData of state.internal.capturedMap.get(event.pointerId).values())if (!duplicates.has($6e35d282b90a18e7$var$makeId(captureData.intersection))) intersections.push(captureData.intersection);
        }
        return intersections;
    }
    /**  Handles intersections by forwarding them to handlers */ function handleIntersects(intersections, event, delta, callback) {
        const rootState = store.getState();
        // If anything has been found, forward it to the event listeners
        if (intersections.length) {
            const localState = {
                stopped: false
            };
            for (const hit of intersections){
                const state = $6e35d282b90a18e7$export$efccba1c4a2ef57b(hit.object) || rootState;
                const { raycaster: raycaster, pointer: pointer, camera: camera, internal: internal } = state;
                const unprojectedPoint = new $329ek.Vector3(pointer.x, pointer.y, 0).unproject(camera);
                const hasPointerCapture = (id)=>{
                    var _internal$capturedMap, _internal$capturedMap2;
                    return (_internal$capturedMap = (_internal$capturedMap2 = internal.capturedMap.get(id)) == null ? void 0 : _internal$capturedMap2.has(hit.eventObject)) != null ? _internal$capturedMap : false;
                };
                const setPointerCapture = (id)=>{
                    const captureData = {
                        intersection: hit,
                        target: event.target
                    };
                    if (internal.capturedMap.has(id)) // if the pointerId was previously captured, we add the hit to the
                    // event capturedMap.
                    internal.capturedMap.get(id).set(hit.eventObject, captureData);
                    else // if the pointerId was not previously captured, we create a map
                    // containing the hitObject, and the hit. hitObject is used for
                    // faster access.
                    internal.capturedMap.set(id, new Map([
                        [
                            hit.eventObject,
                            captureData
                        ]
                    ]));
                    event.target.setPointerCapture(id);
                };
                const releasePointerCapture = (id)=>{
                    const captures = internal.capturedMap.get(id);
                    if (captures) $6e35d282b90a18e7$var$releaseInternalPointerCapture(internal.capturedMap, hit.eventObject, captures, id);
                };
                // Add native event props
                let extractEventProps = {};
                // This iterates over the event's properties including the inherited ones. Native PointerEvents have most of their props as getters which are inherited, but polyfilled PointerEvents have them all as their own properties (i.e. not inherited). We can't use Object.keys() or Object.entries() as they only return "own" properties; nor Object.getPrototypeOf(event) as that *doesn't* return "own" properties, only inherited ones.
                for(let prop in event){
                    let property = event[prop];
                    // Only copy over atomics, leave functions alone as these should be
                    // called as event.nativeEvent.fn()
                    if (typeof property !== 'function') extractEventProps[prop] = property;
                }
                let raycastEvent = {
                    ...hit,
                    ...extractEventProps,
                    pointer: pointer,
                    intersections: intersections,
                    stopped: localState.stopped,
                    delta: delta,
                    unprojectedPoint: unprojectedPoint,
                    ray: raycaster.ray,
                    camera: camera,
                    // Hijack stopPropagation, which just sets a flag
                    stopPropagation () {
                        // https://github.com/pmndrs/react-three-fiber/issues/596
                        // Events are not allowed to stop propagation if the pointer has been captured
                        const capturesForPointer = 'pointerId' in event && internal.capturedMap.get(event.pointerId);
                        // We only authorize stopPropagation...
                        if (// ...if this pointer hasn't been captured
                        !capturesForPointer || // ... or if the hit object is capturing the pointer
                        capturesForPointer.has(hit.eventObject)) {
                            raycastEvent.stopped = localState.stopped = true;
                            // Propagation is stopped, remove all other hover records
                            // An event handler is only allowed to flush other handlers if it is hovered itself
                            if (internal.hovered.size && Array.from(internal.hovered.values()).find((i)=>i.eventObject === hit.eventObject)) {
                                // Objects cannot flush out higher up objects that have already caught the event
                                const higher = intersections.slice(0, intersections.indexOf(hit));
                                cancelPointer([
                                    ...higher,
                                    hit
                                ]);
                            }
                        }
                    },
                    // there should be a distinction between target and currentTarget
                    target: {
                        hasPointerCapture: hasPointerCapture,
                        setPointerCapture: setPointerCapture,
                        releasePointerCapture: releasePointerCapture
                    },
                    currentTarget: {
                        hasPointerCapture: hasPointerCapture,
                        setPointerCapture: setPointerCapture,
                        releasePointerCapture: releasePointerCapture
                    },
                    nativeEvent: event
                };
                // Call subscribers
                callback(raycastEvent);
                // Event bubbling may be interrupted by stopPropagation
                if (localState.stopped === true) break;
            }
        }
        return intersections;
    }
    function cancelPointer(intersections) {
        const { internal: internal } = store.getState();
        for (const hoveredObj of internal.hovered.values())// When no objects were hit or the the hovered object wasn't found underneath the cursor
        // we call onPointerOut and delete the object from the hovered-elements map
        if (!intersections.length || !intersections.find((hit)=>hit.object === hoveredObj.object && hit.index === hoveredObj.index && hit.instanceId === hoveredObj.instanceId)) {
            const eventObject = hoveredObj.eventObject;
            const instance = eventObject.__r3f;
            const handlers = instance == null ? void 0 : instance.handlers;
            internal.hovered.delete($6e35d282b90a18e7$var$makeId(hoveredObj));
            if (instance != null && instance.eventCount) {
                // Clear out intersects, they are outdated by now
                const data = {
                    ...hoveredObj,
                    intersections: intersections
                };
                handlers.onPointerOut == null || handlers.onPointerOut(data);
                handlers.onPointerLeave == null || handlers.onPointerLeave(data);
            }
        }
    }
    function pointerMissed(event, objects) {
        for(let i = 0; i < objects.length; i++){
            const instance = objects[i].__r3f;
            instance == null || instance.handlers.onPointerMissed == null || instance.handlers.onPointerMissed(event);
        }
    }
    function handlePointer(name) {
        // Deal with cancelation
        switch(name){
            case 'onPointerLeave':
            case 'onPointerCancel':
                return ()=>cancelPointer([]);
            case 'onLostPointerCapture':
                return (event)=>{
                    const { internal: internal } = store.getState();
                    if ('pointerId' in event && internal.capturedMap.has(event.pointerId)) // If the object event interface had onLostPointerCapture, we'd call it here on every
                    // object that's getting removed. We call it on the next frame because onLostPointerCapture
                    // fires before onPointerUp. Otherwise pointerUp would never be called if the event didn't
                    // happen in the object it originated from, leaving components in a in-between state.
                    requestAnimationFrame(()=>{
                        // Only release if pointer-up didn't do it already
                        if (internal.capturedMap.has(event.pointerId)) {
                            internal.capturedMap.delete(event.pointerId);
                            cancelPointer([]);
                        }
                    });
                };
        }
        // Any other pointer goes here ...
        return function handleEvent(event) {
            const { onPointerMissed: onPointerMissed, internal: internal } = store.getState();
            // prepareRay(event)
            internal.lastEvent.current = event;
            // Get fresh intersects
            const isPointerMove = name === 'onPointerMove';
            const isClickEvent = name === 'onClick' || name === 'onContextMenu' || name === 'onDoubleClick';
            const filter = isPointerMove ? filterPointerEvents : undefined;
            const hits = intersect(event, filter);
            const delta = isClickEvent ? calculateDistance(event) : 0;
            // Save initial coordinates on pointer-down
            if (name === 'onPointerDown') {
                internal.initialClick = [
                    event.offsetX,
                    event.offsetY
                ];
                internal.initialHits = hits.map((hit)=>hit.eventObject);
            }
            // If a click yields no results, pass it back to the user as a miss
            // Missed events have to come first in order to establish user-land side-effect clean up
            if (isClickEvent && !hits.length) {
                if (delta <= 2) {
                    pointerMissed(event, internal.interaction);
                    if (onPointerMissed) onPointerMissed(event);
                }
            }
            // Take care of unhover
            if (isPointerMove) cancelPointer(hits);
            function onIntersect(data) {
                const eventObject = data.eventObject;
                const instance = eventObject.__r3f;
                const handlers = instance == null ? void 0 : instance.handlers;
                // Check presence of handlers
                if (!(instance != null && instance.eventCount)) return;
                /*
        MAYBE TODO, DELETE IF NOT: 
          Check if the object is captured, captured events should not have intersects running in parallel
          But wouldn't it be better to just replace capturedMap with a single entry?
          Also, are we OK with straight up making picking up multiple objects impossible?
          
        const pointerId = (data as ThreeEvent<PointerEvent>).pointerId        
        if (pointerId !== undefined) {
          const capturedMeshSet = internal.capturedMap.get(pointerId)
          if (capturedMeshSet) {
            const captured = capturedMeshSet.get(eventObject)
            if (captured && captured.localState.stopped) return
          }
        }*/ if (isPointerMove) {
                    // Move event ...
                    if (handlers.onPointerOver || handlers.onPointerEnter || handlers.onPointerOut || handlers.onPointerLeave) {
                        // When enter or out is present take care of hover-state
                        const id = $6e35d282b90a18e7$var$makeId(data);
                        const hoveredItem = internal.hovered.get(id);
                        if (!hoveredItem) {
                            // If the object wasn't previously hovered, book it and call its handler
                            internal.hovered.set(id, data);
                            handlers.onPointerOver == null || handlers.onPointerOver(data);
                            handlers.onPointerEnter == null || handlers.onPointerEnter(data);
                        } else if (hoveredItem.stopped) // If the object was previously hovered and stopped, we shouldn't allow other items to proceed
                        data.stopPropagation();
                    }
                    // Call mouse move
                    handlers.onPointerMove == null || handlers.onPointerMove(data);
                } else {
                    // All other events ...
                    const handler = handlers[name];
                    if (handler) // Forward all events back to their respective handlers with the exception of click events,
                    // which must use the initial target
                    {
                        if (!isClickEvent || internal.initialHits.includes(eventObject)) {
                            // Missed events have to come first
                            pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                            // Now call the handler
                            handler(data);
                        }
                    } else // Trigger onPointerMissed on all elements that have pointer over/out handlers, but not click and weren't hit
                    if (isClickEvent && internal.initialHits.includes(eventObject)) pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                }
            }
            handleIntersects(hits, event, delta, onIntersect);
        };
    }
    return {
        handlePointer: handlePointer
    };
}
// Keys that shouldn't be copied between R3F stores
const $6e35d282b90a18e7$var$privateKeys = [
    'set',
    'get',
    'setSize',
    'setFrameloop',
    'setDpr',
    'events',
    'invalidate',
    'advance',
    'size',
    'viewport'
];
const $6e35d282b90a18e7$var$isRenderer = (def)=>!!(def != null && def.render);
const $6e35d282b90a18e7$export$39b482c5e57630a8 = /*#__PURE__*/ $bxRTa.createContext(null);
const $6e35d282b90a18e7$var$createStore = (invalidate, advance)=>{
    const rootState = (0, $asyYL.default)((set, get)=>{
        const position = new $329ek.Vector3();
        const defaultTarget = new $329ek.Vector3();
        const tempTarget = new $329ek.Vector3();
        function getCurrentViewport(camera = get().camera, target = defaultTarget, size = get().size) {
            const { width: width, height: height, top: top, left: left } = size;
            const aspect = width / height;
            if (target.isVector3) tempTarget.copy(target);
            else tempTarget.set(...target);
            const distance = camera.getWorldPosition(position).distanceTo(tempTarget);
            if ($6e35d282b90a18e7$var$isOrthographicCamera(camera)) return {
                width: width / camera.zoom,
                height: height / camera.zoom,
                top: top,
                left: left,
                factor: 1,
                distance: distance,
                aspect: aspect
            };
            else {
                const fov = camera.fov * Math.PI / 180; // convert vertical fov to radians
                const h = 2 * Math.tan(fov / 2) * distance; // visible height
                const w = h * (width / height);
                return {
                    width: w,
                    height: h,
                    top: top,
                    left: left,
                    factor: width / w,
                    distance: distance,
                    aspect: aspect
                };
            }
        }
        let performanceTimeout = undefined;
        const setPerformanceCurrent = (current)=>set((state)=>({
                    performance: {
                        ...state.performance,
                        current: current
                    }
                }));
        const pointer = new $329ek.Vector2();
        const rootState = {
            set: set,
            get: get,
            // Mock objects that have to be configured
            gl: null,
            camera: null,
            raycaster: null,
            events: {
                priority: 1,
                enabled: true,
                connected: false
            },
            xr: null,
            scene: null,
            invalidate: (frames = 1)=>invalidate(get(), frames),
            advance: (timestamp, runGlobalEffects)=>advance(timestamp, runGlobalEffects, get()),
            legacy: false,
            linear: false,
            flat: false,
            controls: null,
            clock: new $329ek.Clock(),
            pointer: pointer,
            mouse: pointer,
            frameloop: 'always',
            onPointerMissed: undefined,
            performance: {
                current: 1,
                min: 0.5,
                max: 1,
                debounce: 200,
                regress: ()=>{
                    const state = get();
                    // Clear timeout
                    if (performanceTimeout) clearTimeout(performanceTimeout);
                    // Set lower bound performance
                    if (state.performance.current !== state.performance.min) setPerformanceCurrent(state.performance.min);
                    // Go back to upper bound performance after a while unless something regresses meanwhile
                    performanceTimeout = setTimeout(()=>setPerformanceCurrent(get().performance.max), state.performance.debounce);
                }
            },
            size: {
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                updateStyle: false
            },
            viewport: {
                initialDpr: 0,
                dpr: 0,
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                aspect: 0,
                distance: 0,
                factor: 0,
                getCurrentViewport: getCurrentViewport
            },
            setEvents: (events)=>set((state)=>({
                        ...state,
                        events: {
                            ...state.events,
                            ...events
                        }
                    })),
            setSize: (width, height, updateStyle, top, left)=>{
                const camera = get().camera;
                const size = {
                    width: width,
                    height: height,
                    top: top || 0,
                    left: left || 0,
                    updateStyle: updateStyle
                };
                set((state)=>({
                        size: size,
                        viewport: {
                            ...state.viewport,
                            ...getCurrentViewport(camera, defaultTarget, size)
                        }
                    }));
            },
            setDpr: (dpr)=>set((state)=>{
                    const resolved = $6e35d282b90a18e7$var$calculateDpr(dpr);
                    return {
                        viewport: {
                            ...state.viewport,
                            dpr: resolved,
                            initialDpr: state.viewport.initialDpr || resolved
                        }
                    };
                }),
            setFrameloop: (frameloop = 'always')=>{
                const clock = get().clock;
                // if frameloop === "never" clock.elapsedTime is updated using advance(timestamp)
                clock.stop();
                clock.elapsedTime = 0;
                if (frameloop !== 'never') {
                    clock.start();
                    clock.elapsedTime = 0;
                }
                set(()=>({
                        frameloop: frameloop
                    }));
            },
            previousRoot: undefined,
            internal: {
                active: false,
                priority: 0,
                frames: 0,
                lastEvent: /*#__PURE__*/ $bxRTa.createRef(),
                interaction: [],
                hovered: new Map(),
                subscribers: [],
                initialClick: [
                    0,
                    0
                ],
                initialHits: [],
                capturedMap: new Map(),
                subscribe: (ref, priority, store)=>{
                    const internal = get().internal;
                    // If this subscription was given a priority, it takes rendering into its own hands
                    // For that reason we switch off automatic rendering and increase the manual flag
                    // As long as this flag is positive there can be no internal rendering at all
                    // because there could be multiple render subscriptions
                    internal.priority = internal.priority + (priority > 0 ? 1 : 0);
                    internal.subscribers.push({
                        ref: ref,
                        priority: priority,
                        store: store
                    });
                    // Register subscriber and sort layers from lowest to highest, meaning,
                    // highest priority renders last (on top of the other frames)
                    internal.subscribers = internal.subscribers.sort((a, b)=>a.priority - b.priority);
                    return ()=>{
                        const internal = get().internal;
                        if (internal != null && internal.subscribers) {
                            // Decrease manual flag if this subscription had a priority
                            internal.priority = internal.priority - (priority > 0 ? 1 : 0);
                            // Remove subscriber from list
                            internal.subscribers = internal.subscribers.filter((s)=>s.ref !== ref);
                        }
                    };
                }
            }
        };
        return rootState;
    });
    const state = rootState.getState();
    let oldSize = state.size;
    let oldDpr = state.viewport.dpr;
    let oldCamera = state.camera;
    rootState.subscribe(()=>{
        const { camera: camera, size: size, viewport: viewport, gl: gl, set: set } = rootState.getState();
        // Resize camera and renderer on changes to size and pixelratio
        if (size.width !== oldSize.width || size.height !== oldSize.height || viewport.dpr !== oldDpr) {
            var _size$updateStyle;
            oldSize = size;
            oldDpr = viewport.dpr;
            // Update camera & renderer
            $6e35d282b90a18e7$var$updateCamera(camera, size);
            gl.setPixelRatio(viewport.dpr);
            const updateStyle = (_size$updateStyle = size.updateStyle) != null ? _size$updateStyle : typeof HTMLCanvasElement !== 'undefined' && gl.domElement instanceof HTMLCanvasElement;
            gl.setSize(size.width, size.height, updateStyle);
        }
        // Update viewport once the camera changes
        if (camera !== oldCamera) {
            oldCamera = camera;
            // Update viewport
            set((state)=>({
                    viewport: {
                        ...state.viewport,
                        ...state.viewport.getCurrentViewport(camera)
                    }
                }));
        }
    });
    // Invalidate on any change
    rootState.subscribe((state)=>invalidate(state));
    // Return root state
    return rootState;
};
function $6e35d282b90a18e7$var$createSubs(callback, subs) {
    const sub = {
        callback: callback
    };
    subs.add(sub);
    return ()=>void subs.delete(sub);
}
let $6e35d282b90a18e7$var$i;
let $6e35d282b90a18e7$var$globalEffects = new Set();
let $6e35d282b90a18e7$var$globalAfterEffects = new Set();
let $6e35d282b90a18e7$var$globalTailEffects = new Set();
/**
 * Adds a global render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addEffect
 */ const $6e35d282b90a18e7$export$ae1af26003f05816 = (callback)=>$6e35d282b90a18e7$var$createSubs(callback, $6e35d282b90a18e7$var$globalEffects);
/**
 * Adds a global after-render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addAfterEffect
 */ const $6e35d282b90a18e7$export$ffb5f4729a158638 = (callback)=>$6e35d282b90a18e7$var$createSubs(callback, $6e35d282b90a18e7$var$globalAfterEffects);
/**
 * Adds a global callback which is called when rendering stops.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addTail
 */ const $6e35d282b90a18e7$export$9e5f44173e64f162 = (callback)=>$6e35d282b90a18e7$var$createSubs(callback, $6e35d282b90a18e7$var$globalTailEffects);
function $6e35d282b90a18e7$var$run(effects, timestamp) {
    if (!effects.size) return;
    for (const { callback: callback } of effects.values())callback(timestamp);
}
function $6e35d282b90a18e7$export$2408f22a0fab9ae5(type, timestamp) {
    switch(type){
        case 'before':
            return $6e35d282b90a18e7$var$run($6e35d282b90a18e7$var$globalEffects, timestamp);
        case 'after':
            return $6e35d282b90a18e7$var$run($6e35d282b90a18e7$var$globalAfterEffects, timestamp);
        case 'tail':
            return $6e35d282b90a18e7$var$run($6e35d282b90a18e7$var$globalTailEffects, timestamp);
    }
}
let $6e35d282b90a18e7$var$subscribers;
let $6e35d282b90a18e7$var$subscription;
function $6e35d282b90a18e7$var$render$1(timestamp, state, frame) {
    // Run local effects
    let delta = state.clock.getDelta();
    // In frameloop='never' mode, clock times are updated using the provided timestamp
    if (state.frameloop === 'never' && typeof timestamp === 'number') {
        delta = timestamp - state.clock.elapsedTime;
        state.clock.oldTime = state.clock.elapsedTime;
        state.clock.elapsedTime = timestamp;
    }
    // Call subscribers (useFrame)
    $6e35d282b90a18e7$var$subscribers = state.internal.subscribers;
    for($6e35d282b90a18e7$var$i = 0; $6e35d282b90a18e7$var$i < $6e35d282b90a18e7$var$subscribers.length; $6e35d282b90a18e7$var$i++){
        $6e35d282b90a18e7$var$subscription = $6e35d282b90a18e7$var$subscribers[$6e35d282b90a18e7$var$i];
        $6e35d282b90a18e7$var$subscription.ref.current($6e35d282b90a18e7$var$subscription.store.getState(), delta, frame);
    }
    // Render content
    if (!state.internal.priority && state.gl.render) state.gl.render(state.scene, state.camera);
    // Decrease frame count
    state.internal.frames = Math.max(0, state.internal.frames - 1);
    return state.frameloop === 'always' ? 1 : state.internal.frames;
}
function $6e35d282b90a18e7$var$createLoop(roots) {
    let running = false;
    let useFrameInProgress = false;
    let repeat;
    let frame;
    let state;
    function loop(timestamp) {
        frame = requestAnimationFrame(loop);
        running = true;
        repeat = 0;
        // Run effects
        $6e35d282b90a18e7$export$2408f22a0fab9ae5('before', timestamp);
        // Render all roots
        useFrameInProgress = true;
        for (const root of roots.values()){
            var _state$gl$xr;
            state = root.store.getState();
            // If the frameloop is invalidated, do not run another frame
            if (state.internal.active && (state.frameloop === 'always' || state.internal.frames > 0) && !((_state$gl$xr = state.gl.xr) != null && _state$gl$xr.isPresenting)) repeat += $6e35d282b90a18e7$var$render$1(timestamp, state);
        }
        useFrameInProgress = false;
        // Run after-effects
        $6e35d282b90a18e7$export$2408f22a0fab9ae5('after', timestamp);
        // Stop the loop if nothing invalidates it
        if (repeat === 0) {
            // Tail call effects, they are called when rendering stops
            $6e35d282b90a18e7$export$2408f22a0fab9ae5('tail', timestamp);
            // Flag end of operation
            running = false;
            return cancelAnimationFrame(frame);
        }
    }
    function invalidate(state, frames = 1) {
        var _state$gl$xr2;
        if (!state) return roots.forEach((root)=>invalidate(root.store.getState(), frames));
        if ((_state$gl$xr2 = state.gl.xr) != null && _state$gl$xr2.isPresenting || !state.internal.active || state.frameloop === 'never') return;
        if (frames > 1) // legacy support for people using frames parameters
        // Increase frames, do not go higher than 60
        state.internal.frames = Math.min(60, state.internal.frames + frames);
        else if (useFrameInProgress) //called from within a useFrame, it means the user wants an additional frame
        state.internal.frames = 2;
        else //the user need a new frame, no need to increment further than 1
        state.internal.frames = 1;
        // If the render-loop isn't active, start it
        if (!running) {
            running = true;
            requestAnimationFrame(loop);
        }
    }
    function advance(timestamp, runGlobalEffects = true, state, frame) {
        if (runGlobalEffects) $6e35d282b90a18e7$export$2408f22a0fab9ae5('before', timestamp);
        if (!state) for (const root of roots.values())$6e35d282b90a18e7$var$render$1(timestamp, root.store.getState());
        else $6e35d282b90a18e7$var$render$1(timestamp, state, frame);
        if (runGlobalEffects) $6e35d282b90a18e7$export$2408f22a0fab9ae5('after', timestamp);
    }
    return {
        loop: loop,
        invalidate: invalidate,
        advance: advance
    };
}
/**
 * Exposes an object's {@link LocalState}.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#useInstanceHandle
 *
 * **Note**: this is an escape hatch to react-internal fields. Expect this to change significantly between versions.
 */ function $6e35d282b90a18e7$export$ebd11618f299a286(ref) {
    const instance = $bxRTa.useRef(null);
    $6e35d282b90a18e7$export$407448d2b89b1813(()=>void (instance.current = ref.current.__r3f), [
        ref
    ]);
    return instance;
}
function $6e35d282b90a18e7$export$e7094788287c5e9b() {
    const store = $bxRTa.useContext($6e35d282b90a18e7$export$39b482c5e57630a8);
    if (!store) throw new Error('R3F: Hooks can only be used within the Canvas component!');
    return store;
}
/**
 * Accesses R3F's internal state, containing renderer, canvas, scene, etc.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usethree
 */ function $6e35d282b90a18e7$export$96f57966bedc81b4(selector = (state)=>state, equalityFn) {
    return $6e35d282b90a18e7$export$e7094788287c5e9b()(selector, equalityFn);
}
/**
 * Executes a callback before render in a shared frame loop.
 * Can order effects with render priority or manually render with a positive priority.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useframe
 */ function $6e35d282b90a18e7$export$d66501df72047452(callback, renderPriority = 0) {
    const store = $6e35d282b90a18e7$export$e7094788287c5e9b();
    const subscribe = store.getState().internal.subscribe;
    // Memoize ref
    const ref = $6e35d282b90a18e7$export$3b14a55fb2447963(callback);
    // Subscribe on mount, unsubscribe on unmount
    $6e35d282b90a18e7$export$407448d2b89b1813(()=>subscribe(ref, renderPriority, store), [
        renderPriority,
        subscribe,
        store
    ]);
    return null;
}
/**
 * Returns a node graph of an object with named nodes & materials.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usegraph
 */ function $6e35d282b90a18e7$export$2329c99376c9d0a4(object) {
    return $bxRTa.useMemo(()=>$6e35d282b90a18e7$export$4a5767248b18ef41(object), [
        object
    ]);
}
const $6e35d282b90a18e7$var$memoizedLoaders = new WeakMap();
function $6e35d282b90a18e7$var$loadingFn(extensions, onProgress) {
    return function(Proto, ...input) {
        // Construct new loader and run extensions
        let loader = $6e35d282b90a18e7$var$memoizedLoaders.get(Proto);
        if (!loader) {
            loader = new Proto();
            $6e35d282b90a18e7$var$memoizedLoaders.set(Proto, loader);
        }
        if (extensions) extensions(loader);
        // Go through the urls and load them
        return Promise.all(input.map((input)=>new Promise((res, reject)=>loader.load(input, (data)=>{
                    if (data.scene) Object.assign(data, $6e35d282b90a18e7$export$4a5767248b18ef41(data.scene));
                    res(data);
                }, onProgress, (error)=>reject(new Error(`Could not load ${input}: ${error == null ? void 0 : error.message}`))))));
    };
}
/**
 * Synchronously loads and caches assets with a three loader.
 *
 * Note: this hook's caller must be wrapped with `React.Suspense`
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useloader
 */ function $6e35d282b90a18e7$export$7f8ddf7c7c20b3cd(Proto, input, extensions, onProgress) {
    // Use suspense to load async assets
    const keys = Array.isArray(input) ? input : [
        input
    ];
    const results = (0, $6hydE.suspend)($6e35d282b90a18e7$var$loadingFn(extensions, onProgress), [
        Proto,
        ...keys
    ], {
        equal: $6e35d282b90a18e7$var$is.equ
    });
    // Return the object/s
    return Array.isArray(input) ? results : results[0];
}
/**
 * Preloads an asset into cache as a side-effect.
 */ $6e35d282b90a18e7$export$7f8ddf7c7c20b3cd.preload = function(Proto, input, extensions) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $6hydE.preload)($6e35d282b90a18e7$var$loadingFn(extensions), [
        Proto,
        ...keys
    ]);
};
/**
 * Removes a loaded asset from cache.
 */ $6e35d282b90a18e7$export$7f8ddf7c7c20b3cd.clear = function(Proto, input) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $6hydE.clear)([
        Proto,
        ...keys
    ]);
};
const $6e35d282b90a18e7$export$df995fae86a55f06 = new Map();
const { invalidate: $6e35d282b90a18e7$export$953cecd6e717a553, advance: $6e35d282b90a18e7$export$7ccc53e8f1e7dfc5 } = $6e35d282b90a18e7$var$createLoop($6e35d282b90a18e7$export$df995fae86a55f06);
const { reconciler: $6e35d282b90a18e7$export$35e795649ee09318, applyProps: $6e35d282b90a18e7$export$342063e11d6c3cad } = $6e35d282b90a18e7$var$createRenderer($6e35d282b90a18e7$export$df995fae86a55f06, $6e35d282b90a18e7$var$getEventPriority);
const $6e35d282b90a18e7$var$shallowLoose = {
    objects: 'shallow',
    strict: false
};
const $6e35d282b90a18e7$var$createRendererInstance = (gl, canvas)=>{
    const customRenderer = typeof gl === 'function' ? gl(canvas) : gl;
    if ($6e35d282b90a18e7$var$isRenderer(customRenderer)) return customRenderer;
    else return new $1W96c.WebGLRenderer({
        powerPreference: 'high-performance',
        canvas: canvas,
        antialias: true,
        alpha: true,
        ...gl
    });
};
function $6e35d282b90a18e7$var$computeInitialSize(canvas, defaultSize) {
    const defaultStyle = typeof HTMLCanvasElement !== 'undefined' && canvas instanceof HTMLCanvasElement;
    if (defaultSize) {
        const { width: width, height: height, top: top, left: left, updateStyle: updateStyle = defaultStyle } = defaultSize;
        return {
            width: width,
            height: height,
            top: top,
            left: left,
            updateStyle: updateStyle
        };
    } else if (typeof HTMLCanvasElement !== 'undefined' && canvas instanceof HTMLCanvasElement && canvas.parentElement) {
        const { width: width, height: height, top: top, left: left } = canvas.parentElement.getBoundingClientRect();
        return {
            width: width,
            height: height,
            top: top,
            left: left,
            updateStyle: defaultStyle
        };
    } else if (typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return {
        width: canvas.width,
        height: canvas.height,
        top: 0,
        left: 0,
        updateStyle: defaultStyle
    };
    return {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    };
}
function $6e35d282b90a18e7$export$8b22cf2602fb60ce(canvas) {
    // Check against mistaken use of createRoot
    const prevRoot = $6e35d282b90a18e7$export$df995fae86a55f06.get(canvas);
    const prevFiber = prevRoot == null ? void 0 : prevRoot.fiber;
    const prevStore = prevRoot == null ? void 0 : prevRoot.store;
    if (prevRoot) console.warn('R3F.createRoot should only be called once!');
    // Report when an error was detected in a previous render
    // https://github.com/pmndrs/react-three-fiber/pull/2261
    const logRecoverableError = typeof reportError === 'function' ? // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : // In older browsers and test environments, fallback to console.error.
    console.error;
    // Create store
    const store = prevStore || $6e35d282b90a18e7$var$createStore($6e35d282b90a18e7$export$953cecd6e717a553, $6e35d282b90a18e7$export$7ccc53e8f1e7dfc5);
    // Create renderer
    const fiber = prevFiber || $6e35d282b90a18e7$export$35e795649ee09318.createContainer(store, (0, $hlfVD.ConcurrentRoot), null, false, null, '', logRecoverableError, null);
    // Map it
    if (!prevRoot) $6e35d282b90a18e7$export$df995fae86a55f06.set(canvas, {
        fiber: fiber,
        store: store
    });
    // Locals
    let onCreated;
    let configured = false;
    let lastCamera;
    return {
        configure (props = {}) {
            let { gl: glConfig, size: propsSize, scene: sceneOptions, events: events, onCreated: onCreatedCallback, shadows: shadows = false, linear: linear = false, flat: flat = false, legacy: legacy = false, orthographic: orthographic = false, frameloop: frameloop = 'always', dpr: dpr = [
                1,
                2
            ], performance: performance1, raycaster: raycastOptions, camera: cameraOptions, onPointerMissed: onPointerMissed } = props;
            let state = store.getState();
            // Set up renderer (one time only!)
            let gl = state.gl;
            if (!state.gl) state.set({
                gl: gl = $6e35d282b90a18e7$var$createRendererInstance(glConfig, canvas)
            });
            // Set up raycaster (one time only!)
            let raycaster = state.raycaster;
            if (!raycaster) state.set({
                raycaster: raycaster = new $329ek.Raycaster()
            });
            // Set raycaster options
            const { params: params, ...options } = raycastOptions || {};
            if (!$6e35d282b90a18e7$var$is.equ(options, raycaster, $6e35d282b90a18e7$var$shallowLoose)) $6e35d282b90a18e7$export$342063e11d6c3cad(raycaster, {
                ...options
            });
            if (!$6e35d282b90a18e7$var$is.equ(params, raycaster.params, $6e35d282b90a18e7$var$shallowLoose)) $6e35d282b90a18e7$export$342063e11d6c3cad(raycaster, {
                params: {
                    ...raycaster.params,
                    ...params
                }
            });
            // Create default camera, don't overwrite any user-set state
            if (!state.camera || state.camera === lastCamera && !$6e35d282b90a18e7$var$is.equ(lastCamera, cameraOptions, $6e35d282b90a18e7$var$shallowLoose)) {
                lastCamera = cameraOptions;
                const isCamera = cameraOptions instanceof $329ek.Camera;
                const camera = isCamera ? cameraOptions : orthographic ? new $329ek.OrthographicCamera(0, 0, 0, 0, 0.1, 1000) : new $329ek.PerspectiveCamera(75, 0, 0.1, 1000);
                if (!isCamera) {
                    camera.position.z = 5;
                    if (cameraOptions) {
                        $6e35d282b90a18e7$export$342063e11d6c3cad(camera, cameraOptions);
                        // Preserve user-defined frustum if possible
                        // https://github.com/pmndrs/react-three-fiber/issues/3160
                        if ('aspect' in cameraOptions || 'left' in cameraOptions || 'right' in cameraOptions || 'bottom' in cameraOptions || 'top' in cameraOptions) {
                            camera.manual = true;
                            camera.updateProjectionMatrix();
                        }
                    }
                    // Always look at center by default
                    if (!state.camera && !(cameraOptions != null && cameraOptions.rotation)) camera.lookAt(0, 0, 0);
                }
                state.set({
                    camera: camera
                });
                // Configure raycaster
                // https://github.com/pmndrs/react-xr/issues/300
                raycaster.camera = camera;
            }
            // Set up scene (one time only!)
            if (!state.scene) {
                let scene;
                if (sceneOptions != null && sceneOptions.isScene) scene = sceneOptions;
                else {
                    scene = new $329ek.Scene();
                    if (sceneOptions) $6e35d282b90a18e7$export$342063e11d6c3cad(scene, sceneOptions);
                }
                state.set({
                    scene: $6e35d282b90a18e7$var$prepare(scene)
                });
            }
            // Set up XR (one time only!)
            if (!state.xr) {
                var _gl$xr;
                // Handle frame behavior in WebXR
                const handleXRFrame = (timestamp, frame)=>{
                    const state = store.getState();
                    if (state.frameloop === 'never') return;
                    $6e35d282b90a18e7$export$7ccc53e8f1e7dfc5(timestamp, true, state, frame);
                };
                // Toggle render switching on session
                const handleSessionChange = ()=>{
                    const state = store.getState();
                    state.gl.xr.enabled = state.gl.xr.isPresenting;
                    state.gl.xr.setAnimationLoop(state.gl.xr.isPresenting ? handleXRFrame : null);
                    if (!state.gl.xr.isPresenting) $6e35d282b90a18e7$export$953cecd6e717a553(state);
                };
                // WebXR session manager
                const xr = {
                    connect () {
                        const gl = store.getState().gl;
                        gl.xr.addEventListener('sessionstart', handleSessionChange);
                        gl.xr.addEventListener('sessionend', handleSessionChange);
                    },
                    disconnect () {
                        const gl = store.getState().gl;
                        gl.xr.removeEventListener('sessionstart', handleSessionChange);
                        gl.xr.removeEventListener('sessionend', handleSessionChange);
                    }
                };
                // Subscribe to WebXR session events
                if (typeof ((_gl$xr = gl.xr) == null ? void 0 : _gl$xr.addEventListener) === 'function') xr.connect();
                state.set({
                    xr: xr
                });
            }
            // Set shadowmap
            if (gl.shadowMap) {
                const oldEnabled = gl.shadowMap.enabled;
                const oldType = gl.shadowMap.type;
                gl.shadowMap.enabled = !!shadows;
                if ($6e35d282b90a18e7$var$is.boo(shadows)) gl.shadowMap.type = $329ek.PCFSoftShadowMap;
                else if ($6e35d282b90a18e7$var$is.str(shadows)) {
                    var _types$shadows;
                    const types = {
                        basic: $329ek.BasicShadowMap,
                        percentage: $329ek.PCFShadowMap,
                        soft: $329ek.PCFSoftShadowMap,
                        variance: $329ek.VSMShadowMap
                    };
                    gl.shadowMap.type = (_types$shadows = types[shadows]) != null ? _types$shadows : $329ek.PCFSoftShadowMap;
                } else if ($6e35d282b90a18e7$var$is.obj(shadows)) Object.assign(gl.shadowMap, shadows);
                if (oldEnabled !== gl.shadowMap.enabled || oldType !== gl.shadowMap.type) gl.shadowMap.needsUpdate = true;
            }
            // Safely set color management if available.
            // Avoid accessing THREE.ColorManagement to play nice with older versions
            const ColorManagement = $6e35d282b90a18e7$var$getColorManagement();
            if (ColorManagement) {
                if ('enabled' in ColorManagement) ColorManagement.enabled = !legacy;
                else if ('legacyMode' in ColorManagement) ColorManagement.legacyMode = legacy;
            }
            if (!configured) {
                // Set color space and tonemapping preferences, once
                const LinearEncoding = 3000;
                const sRGBEncoding = 3001;
                $6e35d282b90a18e7$export$342063e11d6c3cad(gl, {
                    outputEncoding: linear ? LinearEncoding : sRGBEncoding,
                    toneMapping: flat ? $329ek.NoToneMapping : $329ek.ACESFilmicToneMapping
                });
            }
            // Update color management state
            if (state.legacy !== legacy) state.set(()=>({
                    legacy: legacy
                }));
            if (state.linear !== linear) state.set(()=>({
                    linear: linear
                }));
            if (state.flat !== flat) state.set(()=>({
                    flat: flat
                }));
            // Set gl props
            if (glConfig && !$6e35d282b90a18e7$var$is.fun(glConfig) && !$6e35d282b90a18e7$var$isRenderer(glConfig) && !$6e35d282b90a18e7$var$is.equ(glConfig, gl, $6e35d282b90a18e7$var$shallowLoose)) $6e35d282b90a18e7$export$342063e11d6c3cad(gl, glConfig);
            // Store events internally
            if (events && !state.events.handlers) state.set({
                events: events(store)
            });
            // Check size, allow it to take on container bounds initially
            const size = $6e35d282b90a18e7$var$computeInitialSize(canvas, propsSize);
            if (!$6e35d282b90a18e7$var$is.equ(size, state.size, $6e35d282b90a18e7$var$shallowLoose)) state.setSize(size.width, size.height, size.updateStyle, size.top, size.left);
            // Check pixelratio
            if (dpr && state.viewport.dpr !== $6e35d282b90a18e7$var$calculateDpr(dpr)) state.setDpr(dpr);
            // Check frameloop
            if (state.frameloop !== frameloop) state.setFrameloop(frameloop);
            // Check pointer missed
            if (!state.onPointerMissed) state.set({
                onPointerMissed: onPointerMissed
            });
            // Check performance
            if (performance1 && !$6e35d282b90a18e7$var$is.equ(performance1, state.performance, $6e35d282b90a18e7$var$shallowLoose)) state.set((state)=>({
                    performance: {
                        ...state.performance,
                        ...performance1
                    }
                }));
            // Set locals
            onCreated = onCreatedCallback;
            configured = true;
            return this;
        },
        render (children) {
            // The root has to be configured before it can be rendered
            if (!configured) this.configure();
            $6e35d282b90a18e7$export$35e795649ee09318.updateContainer(/*#__PURE__*/ (0, $fl9nK.jsx)($6e35d282b90a18e7$var$Provider, {
                store: store,
                children: children,
                onCreated: onCreated,
                rootElement: canvas
            }), fiber, null, ()=>undefined);
            return store;
        },
        unmount () {
            $6e35d282b90a18e7$export$4368d992c4eafac0(canvas);
        }
    };
}
function $6e35d282b90a18e7$export$43caf9889c228507(children, canvas, config) {
    console.warn('R3F.render is no longer supported in React 18. Use createRoot instead!');
    const root = $6e35d282b90a18e7$export$8b22cf2602fb60ce(canvas);
    root.configure(config);
    return root.render(children);
}
function $6e35d282b90a18e7$var$Provider({ store: store, children: children, onCreated: onCreated, rootElement: rootElement }) {
    $6e35d282b90a18e7$export$407448d2b89b1813(()=>{
        const state = store.getState();
        // Flag the canvas active, rendering will now begin
        state.set((state)=>({
                internal: {
                    ...state.internal,
                    active: true
                }
            }));
        // Notifiy that init is completed, the scene graph exists, but nothing has yet rendered
        if (onCreated) onCreated(state);
        // Connect events to the targets parent, this is done to ensure events are registered on
        // a shared target, and not on the canvas itself
        if (!store.getState().events.connected) state.events.connect == null || state.events.connect(rootElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)($6e35d282b90a18e7$export$39b482c5e57630a8.Provider, {
        value: store,
        children: children
    });
}
function $6e35d282b90a18e7$export$4368d992c4eafac0(canvas, callback) {
    const root = $6e35d282b90a18e7$export$df995fae86a55f06.get(canvas);
    const fiber = root == null ? void 0 : root.fiber;
    if (fiber) {
        const state = root == null ? void 0 : root.store.getState();
        if (state) state.internal.active = false;
        $6e35d282b90a18e7$export$35e795649ee09318.updateContainer(null, fiber, null, ()=>{
            if (state) setTimeout(()=>{
                try {
                    var _state$gl, _state$gl$renderLists, _state$gl2, _state$gl3;
                    state.events.disconnect == null || state.events.disconnect();
                    (_state$gl = state.gl) == null || (_state$gl$renderLists = _state$gl.renderLists) == null || _state$gl$renderLists.dispose == null || _state$gl$renderLists.dispose();
                    (_state$gl2 = state.gl) == null || _state$gl2.forceContextLoss == null || _state$gl2.forceContextLoss();
                    if ((_state$gl3 = state.gl) != null && _state$gl3.xr) state.xr.disconnect();
                    $6e35d282b90a18e7$export$882b5998b3b9117c(state);
                    $6e35d282b90a18e7$export$df995fae86a55f06.delete(canvas);
                    if (callback) callback(canvas);
                } catch (e) {
                /* ... */ }
            }, 500);
        });
    }
}
function $6e35d282b90a18e7$export$dda1d9f60106f0e9(children, container, state) {
    return /*#__PURE__*/ (0, $fl9nK.jsx)($6e35d282b90a18e7$var$Portal, {
        children: children,
        container: container,
        state: state
    }, container.uuid);
}
function $6e35d282b90a18e7$var$Portal({ state: state = {}, children: children, container: container }) {
    /** This has to be a component because it would not be able to call useThree/useStore otherwise since
   *  if this is our environment, then we are not in r3f's renderer but in react-dom, it would trigger
   *  the "R3F hooks can only be used within the Canvas component!" warning:
   *  <Canvas>
   *    {createPortal(...)} */ const { events: events, size: size, ...rest } = state;
    const previousRoot = $6e35d282b90a18e7$export$e7094788287c5e9b();
    const [raycaster] = $bxRTa.useState(()=>new $329ek.Raycaster());
    const [pointer] = $bxRTa.useState(()=>new $329ek.Vector2());
    const inject = $bxRTa.useCallback((rootState, injectState)=>{
        const intersect = {
            ...rootState
        }; // all prev state props
        // Only the fields of "rootState" that do not differ from injectState
        // Some props should be off-limits
        // Otherwise filter out the props that are different and let the inject layer take precedence
        Object.keys(rootState).forEach((key)=>{
            if (// Some props should be off-limits
            $6e35d282b90a18e7$var$privateKeys.includes(key) || // Otherwise filter out the props that are different and let the inject layer take precedence
            // Unless the inject layer props is undefined, then we keep the root layer
            rootState[key] !== injectState[key] && injectState[key]) delete intersect[key];
        });
        let viewport = undefined;
        if (injectState && size) {
            const camera = injectState.camera;
            // Calculate the override viewport, if present
            viewport = rootState.viewport.getCurrentViewport(camera, new $329ek.Vector3(), size);
            // Update the portal camera, if it differs from the previous layer
            if (camera !== rootState.camera) $6e35d282b90a18e7$var$updateCamera(camera, size);
        }
        return {
            // The intersect consists of the previous root state
            ...intersect,
            // Portals have their own scene, which forms the root, a raycaster and a pointer
            scene: container,
            raycaster: raycaster,
            pointer: pointer,
            mouse: pointer,
            previousRoot: // Their previous root is the layer before it
            previousRoot,
            // Events, size and viewport can be overridden by the inject layer
            events: {
                ...rootState.events,
                ...injectState == null ? void 0 : injectState.events,
                ...events
            },
            size: {
                ...rootState.size,
                ...size
            },
            viewport: {
                ...rootState.viewport,
                ...viewport
            },
            ...rest
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        state
    ]);
    const [usePortalStore] = $bxRTa.useState(()=>{
        // Create a mirrored store, based on the previous root with a few overrides ...
        const previousState = previousRoot.getState();
        const store = (0, $asyYL.default)((set, get)=>({
                ...previousState,
                scene: container,
                raycaster: raycaster,
                pointer: pointer,
                mouse: pointer,
                previousRoot: previousRoot,
                events: {
                    ...previousState.events,
                    ...events
                },
                size: {
                    ...previousState.size,
                    ...size
                },
                ...rest,
                set: // Set and get refer to this root-state
                set,
                get: get,
                // Layers are allowed to override events
                setEvents: (events)=>set((state)=>({
                            ...state,
                            events: {
                                ...state.events,
                                ...events
                            }
                        }))
            }));
        return store;
    });
    $bxRTa.useEffect(()=>{
        // Subscribe to previous root-state and copy changes over to the mirrored portal-state
        const unsub = previousRoot.subscribe((prev)=>usePortalStore.setState((state)=>inject(prev, state)));
        return ()=>{
            unsub();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inject
    ]);
    $bxRTa.useEffect(()=>{
        usePortalStore.setState((injectState)=>inject(previousRoot.getState(), injectState));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inject
    ]);
    $bxRTa.useEffect(()=>{
        return ()=>{
            usePortalStore.destroy();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fl9nK.Fragment), {
        children: $6e35d282b90a18e7$export$35e795649ee09318.createPortal(/*#__PURE__*/ (0, $fl9nK.jsx)($6e35d282b90a18e7$export$39b482c5e57630a8.Provider, {
            value: usePortalStore,
            children: children
        }), usePortalStore, null)
    });
}
/**
 * Force React to flush any updates inside the provided callback synchronously and immediately.
 * All the same caveats documented for react-dom's `flushSync` apply here (see https://react.dev/reference/react-dom/flushSync).
 * Nevertheless, sometimes one needs to render synchronously, for example to keep DOM and 3D changes in lock-step without
 * having to revert to a non-React solution.
 */ function $6e35d282b90a18e7$export$90a7f3efeed30595(fn) {
    // `flushSync` implementation only takes one argument. I don't know what's up with the type declaration for it.
    return $6e35d282b90a18e7$export$35e795649ee09318.flushSync(fn, undefined);
}
$6e35d282b90a18e7$export$35e795649ee09318.injectIntoDevTools({
    bundleType: 0,
    rendererPackageName: '@react-three/fiber',
    version: $bxRTa.version
});
const $6e35d282b90a18e7$export$d141bba7fdc215a3 = $bxRTa.unstable_act;
const $6e35d282b90a18e7$var$DOM_EVENTS = {
    onClick: [
        'click',
        false
    ],
    onContextMenu: [
        'contextmenu',
        false
    ],
    onDoubleClick: [
        'dblclick',
        false
    ],
    onWheel: [
        'wheel',
        true
    ],
    onPointerDown: [
        'pointerdown',
        true
    ],
    onPointerUp: [
        'pointerup',
        true
    ],
    onPointerLeave: [
        'pointerleave',
        true
    ],
    onPointerMove: [
        'pointermove',
        true
    ],
    onPointerCancel: [
        'pointercancel',
        true
    ],
    onLostPointerCapture: [
        'lostpointercapture',
        true
    ]
};
/** Default R3F event manager for web */ function $6e35d282b90a18e7$export$db3b6bfb95261072(store) {
    const { handlePointer: handlePointer } = $6e35d282b90a18e7$export$2d1720544b23b823(store);
    return {
        priority: 1,
        enabled: true,
        compute (event, state, previous) {
            // https://github.com/pmndrs/react-three-fiber/pull/782
            // Events trigger outside of canvas when moved, use offsetX/Y by default and allow overrides
            state.pointer.set(event.offsetX / state.size.width * 2 - 1, -(event.offsetY / state.size.height) * 2 + 1);
            state.raycaster.setFromCamera(state.pointer, state.camera);
        },
        connected: undefined,
        handlers: Object.keys($6e35d282b90a18e7$var$DOM_EVENTS).reduce((acc, key)=>({
                ...acc,
                [key]: handlePointer(key)
            }), {}),
        update: ()=>{
            var _internal$lastEvent;
            const { events: events, internal: internal } = store.getState();
            if ((_internal$lastEvent = internal.lastEvent) != null && _internal$lastEvent.current && events.handlers) events.handlers.onPointerMove(internal.lastEvent.current);
        },
        connect: (target)=>{
            var _events$handlers;
            const { set: set, events: events } = store.getState();
            events.disconnect == null || events.disconnect();
            set((state)=>({
                    events: {
                        ...state.events,
                        connected: target
                    }
                }));
            Object.entries((_events$handlers = events.handlers) != null ? _events$handlers : []).forEach(([name, event])=>{
                const [eventName, passive] = $6e35d282b90a18e7$var$DOM_EVENTS[name];
                target.addEventListener(eventName, event, {
                    passive: passive
                });
            });
        },
        disconnect: ()=>{
            const { set: set, events: events } = store.getState();
            if (events.connected) {
                var _events$handlers2;
                Object.entries((_events$handlers2 = events.handlers) != null ? _events$handlers2 : []).forEach(([name, event])=>{
                    if (events && events.connected instanceof HTMLElement) {
                        const [eventName] = $6e35d282b90a18e7$var$DOM_EVENTS[name];
                        events.connected.removeEventListener(eventName, event);
                    }
                });
                set((state)=>({
                        events: {
                            ...state.events,
                            connected: undefined
                        }
                    }));
            }
        }
    };
}

});
parcelRegister("hlfVD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iiXnn"));

});
parcelRegister("iiXnn", function(module, exports) {

$parcel$export(module.exports, "ConcurrentRoot", () => $d537f74d83625fef$export$816aac48d41c2f81, (v) => $d537f74d83625fef$export$816aac48d41c2f81 = v);
$parcel$export(module.exports, "ContinuousEventPriority", () => $d537f74d83625fef$export$3bb88615cd12cb3b, (v) => $d537f74d83625fef$export$3bb88615cd12cb3b = v);
$parcel$export(module.exports, "DefaultEventPriority", () => $d537f74d83625fef$export$d46163d5c045f347, (v) => $d537f74d83625fef$export$d46163d5c045f347 = v);
$parcel$export(module.exports, "DiscreteEventPriority", () => $d537f74d83625fef$export$8ee75c97f0333f15, (v) => $d537f74d83625fef$export$8ee75c97f0333f15 = v);
$parcel$export(module.exports, "IdleEventPriority", () => $d537f74d83625fef$export$d1c113b83e1f881a, (v) => $d537f74d83625fef$export$d1c113b83e1f881a = v);
$parcel$export(module.exports, "LegacyRoot", () => $d537f74d83625fef$export$ff78c4883554845d, (v) => $d537f74d83625fef$export$ff78c4883554845d = v);
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d537f74d83625fef$export$816aac48d41c2f81;
var $d537f74d83625fef$export$3bb88615cd12cb3b;
var $d537f74d83625fef$export$d46163d5c045f347;
var $d537f74d83625fef$export$8ee75c97f0333f15;
var $d537f74d83625fef$export$d1c113b83e1f881a;
var $d537f74d83625fef$export$ff78c4883554845d;
'use strict';
$d537f74d83625fef$export$816aac48d41c2f81 = 1;
$d537f74d83625fef$export$3bb88615cd12cb3b = 4;
$d537f74d83625fef$export$d46163d5c045f347 = 16;
$d537f74d83625fef$export$8ee75c97f0333f15 = 1;
$d537f74d83625fef$export$d1c113b83e1f881a = 536870912;
$d537f74d83625fef$export$ff78c4883554845d = 0;

});


parcelRegister("asyYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $79d7a70378953990$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
function $79d7a70378953990$var$createStore(createState) {
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (nextState !== state) {
            const previousState = state;
            state = replace ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const subscribeWithSelector = (listener, selector = getState, equalityFn = Object.is)=>{
        console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
        let currentSlice = selector(state);
        function listenerToAdd() {
            const nextSlice = selector(state);
            if (!equalityFn(currentSlice, nextSlice)) {
                const previousSlice = currentSlice;
                listener(currentSlice = nextSlice, previousSlice);
            }
        }
        listeners.add(listenerToAdd);
        return ()=>listeners.delete(listenerToAdd);
    };
    const subscribe = (listener, selector, equalityFn)=>{
        if (selector || equalityFn) return subscribeWithSelector(listener, selector, equalityFn);
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>listeners.clear();
    const api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
}
const $79d7a70378953990$var$isSSR = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
const $79d7a70378953990$var$useIsomorphicLayoutEffect = $79d7a70378953990$var$isSSR ? (0, $bxRTa.useEffect) : (0, $bxRTa.useLayoutEffect);
function $79d7a70378953990$export$2e2bcd8739ae039(createState) {
    const api = typeof createState === "function" ? $79d7a70378953990$var$createStore(createState) : createState;
    const useStore = (selector = api.getState, equalityFn = Object.is)=>{
        const [, forceUpdate] = (0, $bxRTa.useReducer)((c)=>c + 1, 0);
        const state = api.getState();
        const stateRef = (0, $bxRTa.useRef)(state);
        const selectorRef = (0, $bxRTa.useRef)(selector);
        const equalityFnRef = (0, $bxRTa.useRef)(equalityFn);
        const erroredRef = (0, $bxRTa.useRef)(false);
        const currentSliceRef = (0, $bxRTa.useRef)();
        if (currentSliceRef.current === void 0) currentSliceRef.current = selector(state);
        let newStateSlice;
        let hasNewStateSlice = false;
        if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
            newStateSlice = selector(state);
            hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
        }
        $79d7a70378953990$var$useIsomorphicLayoutEffect(()=>{
            if (hasNewStateSlice) currentSliceRef.current = newStateSlice;
            stateRef.current = state;
            selectorRef.current = selector;
            equalityFnRef.current = equalityFn;
            erroredRef.current = false;
        });
        const stateBeforeSubscriptionRef = (0, $bxRTa.useRef)(state);
        $79d7a70378953990$var$useIsomorphicLayoutEffect(()=>{
            const listener = ()=>{
                try {
                    const nextState = api.getState();
                    const nextStateSlice = selectorRef.current(nextState);
                    if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
                        stateRef.current = nextState;
                        currentSliceRef.current = nextStateSlice;
                        forceUpdate();
                    }
                } catch (error) {
                    erroredRef.current = true;
                    forceUpdate();
                }
            };
            const unsubscribe = api.subscribe(listener);
            if (api.getState() !== stateBeforeSubscriptionRef.current) listener();
            return unsubscribe;
        }, []);
        const sliceToReturn = hasNewStateSlice ? newStateSlice : currentSliceRef.current;
        (0, $bxRTa.useDebugValue)(sliceToReturn);
        return sliceToReturn;
    };
    Object.assign(useStore, api);
    useStore[Symbol.iterator] = function() {
        console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
        const items = [
            useStore,
            api
        ];
        return {
            next () {
                const done = items.length <= 0;
                return {
                    value: items.shift(),
                    done: done
                };
            }
        };
    };
    return useStore;
}

});

parcelRegister("6hydE", function(module, exports) {

$parcel$export(module.exports, "suspend", () => $492edfd96628a62b$export$a1428c8f7ba796e8);
$parcel$export(module.exports, "preload", () => $492edfd96628a62b$export$513ccb98c53b8039);
$parcel$export(module.exports, "clear", () => $492edfd96628a62b$export$42ffd38884aecdac);
const $492edfd96628a62b$var$isPromise = (promise)=>typeof promise === 'object' && typeof promise.then === 'function';
const $492edfd96628a62b$var$globalCache = [];
function $492edfd96628a62b$var$shallowEqualArrays(arrA, arrB, equal = (a, b)=>a === b) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++)if (!equal(arrA[i], arrB[i])) return false;
    return true;
}
function $492edfd96628a62b$var$query(fn, keys = null, preload = false, config = {}) {
    // If no keys were given, the function is the key
    if (keys === null) keys = [
        fn
    ];
    for (const entry of $492edfd96628a62b$var$globalCache)// Find a match
    if ($492edfd96628a62b$var$shallowEqualArrays(keys, entry.keys, entry.equal)) {
        // If we're pre-loading and the element is present, just return
        if (preload) return undefined; // If an error occurred, throw
        if (Object.prototype.hasOwnProperty.call(entry, 'error')) throw entry.error; // If a response was successful, return
        if (Object.prototype.hasOwnProperty.call(entry, 'response')) {
            if (config.lifespan && config.lifespan > 0) {
                if (entry.timeout) clearTimeout(entry.timeout);
                entry.timeout = setTimeout(entry.remove, config.lifespan);
            }
            return entry.response;
        } // If the promise is still unresolved, throw
        if (!preload) throw entry.promise;
    }
     // The request is new or has changed.
    const entry = {
        keys: keys,
        equal: config.equal,
        remove: ()=>{
            const index = $492edfd96628a62b$var$globalCache.indexOf(entry);
            if (index !== -1) $492edfd96628a62b$var$globalCache.splice(index, 1);
        },
        promise: ($492edfd96628a62b$var$isPromise(fn) ? fn : fn(...keys) // When it resolves, store its value
        ).then((response)=>{
            entry.response = response; // Remove the entry in time if a lifespan was given
            if (config.lifespan && config.lifespan > 0) entry.timeout = setTimeout(entry.remove, config.lifespan);
        }) // Store caught errors, they will be thrown in the render-phase to bubble into an error-bound
        .catch((error)=>entry.error = error)
    }; // Register the entry
    $492edfd96628a62b$var$globalCache.push(entry); // And throw the promise, this yields control back to React
    if (!preload) throw entry.promise;
    return undefined;
}
const $492edfd96628a62b$export$a1428c8f7ba796e8 = (fn, keys, config)=>$492edfd96628a62b$var$query(fn, keys, false, config);
const $492edfd96628a62b$export$513ccb98c53b8039 = (fn, keys, config)=>void $492edfd96628a62b$var$query(fn, keys, true, config);
const $492edfd96628a62b$export$4d3fb11e950abb9e = (keys)=>{
    var _globalCache$find;
    return (_globalCache$find = $492edfd96628a62b$var$globalCache.find((entry)=>$492edfd96628a62b$var$shallowEqualArrays(keys, entry.keys, entry.equal))) == null ? void 0 : _globalCache$find.response;
};
const $492edfd96628a62b$export$42ffd38884aecdac = (keys)=>{
    if (keys === undefined || keys.length === 0) $492edfd96628a62b$var$globalCache.splice(0, $492edfd96628a62b$var$globalCache.length);
    else {
        const entry = $492edfd96628a62b$var$globalCache.find((entry)=>$492edfd96628a62b$var$shallowEqualArrays(keys, entry.keys, entry.equal));
        if (entry) entry.remove();
    }
};

});

parcelRegister("3Rjoy", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kOlZL"));

});
parcelRegister("kOlZL", function(module, exports) {
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 

module.exports = function $$$reconciler($$$hostConfig) {
    var exports = {};
    'use strict';
    var aa = (parcelRequire("bxRTa")), ba = (parcelRequire("axy3F")), ca = Object.assign;
    function n(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var ea = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, fa = Symbol.for("react.element"), ha = Symbol.for("react.portal"), ia = Symbol.for("react.fragment"), ja = Symbol.for("react.strict_mode"), ka = Symbol.for("react.profiler"), la = Symbol.for("react.provider"), ma = Symbol.for("react.context"), na = Symbol.for("react.forward_ref"), oa = Symbol.for("react.suspense"), pa = Symbol.for("react.suspense_list"), qa = Symbol.for("react.memo"), ra = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    Symbol.for("react.debug_trace_mode");
    var sa = Symbol.for("react.offscreen");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.cache");
    Symbol.for("react.tracing_marker");
    var ta = Symbol.iterator;
    function ua(a) {
        if (null === a || "object" !== typeof a) return null;
        a = ta && a[ta] || a["@@iterator"];
        return "function" === typeof a ? a : null;
    }
    function va(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case ia:
                return "Fragment";
            case ha:
                return "Portal";
            case ka:
                return "Profiler";
            case ja:
                return "StrictMode";
            case oa:
                return "Suspense";
            case pa:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case ma:
                return (a.displayName || "Context") + ".Consumer";
            case la:
                return (a._context.displayName || "Context") + ".Provider";
            case na:
                var b = a.render;
                a = a.displayName;
                a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
                return a;
            case qa:
                return b = a.displayName || null, null !== b ? b : va(a.type) || "Memo";
            case ra:
                b = a._payload;
                a = a._init;
                try {
                    return va(a(b));
                } catch (c) {}
        }
        return null;
    }
    function xa(a) {
        var b = a.type;
        switch(a.tag){
            case 24:
                return "Cache";
            case 9:
                return (b.displayName || "Context") + ".Consumer";
            case 10:
                return (b._context.displayName || "Context") + ".Provider";
            case 18:
                return "DehydratedFragment";
            case 11:
                return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 5:
                return b;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return va(b);
            case 8:
                return b === ja ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
                if ("function" === typeof b) return b.displayName || b.name || null;
                if ("string" === typeof b) return b;
        }
        return null;
    }
    function ya(a) {
        var b = a, c = a;
        if (a.alternate) for(; b.return;)b = b.return;
        else {
            a = b;
            do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
            while (a);
        }
        return 3 === b.tag ? c : null;
    }
    function za(a) {
        if (ya(a) !== a) throw Error(n(188));
    }
    function Aa(a) {
        var b = a.alternate;
        if (!b) {
            b = ya(a);
            if (null === b) throw Error(n(188));
            return b !== a ? null : a;
        }
        for(var c = a, d = b;;){
            var e = c.return;
            if (null === e) break;
            var f = e.alternate;
            if (null === f) {
                d = e.return;
                if (null !== d) {
                    c = d;
                    continue;
                }
                break;
            }
            if (e.child === f.child) {
                for(f = e.child; f;){
                    if (f === c) return za(e), a;
                    if (f === d) return za(e), b;
                    f = f.sibling;
                }
                throw Error(n(188));
            }
            if (c.return !== d.return) c = e, d = f;
            else {
                for(var g = !1, h = e.child; h;){
                    if (h === c) {
                        g = !0;
                        c = e;
                        d = f;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = e;
                        c = f;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) {
                    for(h = f.child; h;){
                        if (h === c) {
                            g = !0;
                            c = f;
                            d = e;
                            break;
                        }
                        if (h === d) {
                            g = !0;
                            d = f;
                            c = e;
                            break;
                        }
                        h = h.sibling;
                    }
                    if (!g) throw Error(n(189));
                }
            }
            if (c.alternate !== d) throw Error(n(190));
        }
        if (3 !== c.tag) throw Error(n(188));
        return c.stateNode.current === c ? a : b;
    }
    function Ba(a) {
        a = Aa(a);
        return null !== a ? Ca(a) : null;
    }
    function Ca(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            var b = Ca(a);
            if (null !== b) return b;
            a = a.sibling;
        }
        return null;
    }
    function Da(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            if (4 !== a.tag) {
                var b = Da(a);
                if (null !== b) return b;
            }
            a = a.sibling;
        }
        return null;
    }
    var Ea = Array.isArray, Fa = $$$hostConfig.getPublicInstance, Ga = $$$hostConfig.getRootHostContext, Ha = $$$hostConfig.getChildHostContext, Ia = $$$hostConfig.prepareForCommit, Ja = $$$hostConfig.resetAfterCommit, Ka = $$$hostConfig.createInstance, La = $$$hostConfig.appendInitialChild, Ma = $$$hostConfig.finalizeInitialChildren, Na = $$$hostConfig.prepareUpdate, Oa = $$$hostConfig.shouldSetTextContent, Pa = $$$hostConfig.createTextInstance, Qa = $$$hostConfig.scheduleTimeout, Ra = $$$hostConfig.cancelTimeout, Sa = $$$hostConfig.noTimeout, Ta = $$$hostConfig.isPrimaryRenderer, Ua = $$$hostConfig.supportsMutation, Va = $$$hostConfig.supportsPersistence, p = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.preparePortalMount, Ya = $$$hostConfig.getCurrentEventPriority, Za = $$$hostConfig.detachDeletedInstance, $a = $$$hostConfig.supportsMicrotasks, ab = $$$hostConfig.scheduleMicrotask, bb = $$$hostConfig.supportsTestSelectors, cb = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Db = $$$hostConfig.cloneHiddenInstance, Eb = $$$hostConfig.cloneHiddenTextInstance, Fb = $$$hostConfig.canHydrateInstance, Gb = $$$hostConfig.canHydrateTextInstance, Hb = $$$hostConfig.canHydrateSuspenseInstance, Ib = $$$hostConfig.isSuspenseInstancePending, Jb = $$$hostConfig.isSuspenseInstanceFallback, Kb = $$$hostConfig.registerSuspenseInstanceRetry, Lb = $$$hostConfig.getNextHydratableSibling, Mb = $$$hostConfig.getFirstHydratableChild, Nb = $$$hostConfig.getFirstHydratableChildWithinContainer, Ob = $$$hostConfig.getFirstHydratableChildWithinSuspenseInstance, Pb = $$$hostConfig.hydrateInstance, Qb = $$$hostConfig.hydrateTextInstance, Rb = $$$hostConfig.hydrateSuspenseInstance, Sb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Tb = $$$hostConfig.commitHydratedContainer, Ub = $$$hostConfig.commitHydratedSuspenseInstance, Vb = $$$hostConfig.clearSuspenseBoundary, Wb = $$$hostConfig.clearSuspenseBoundaryFromContainer, Xb = $$$hostConfig.shouldDeleteUnhydratedTailInstances, Yb = $$$hostConfig.didNotMatchHydratedContainerTextInstance, Zb = $$$hostConfig.didNotMatchHydratedTextInstance, $b;
    function ac(a) {
        if (void 0 === $b) try {
            throw Error();
        } catch (c) {
            var b = c.stack.trim().match(/\n( *(at )?)/);
            $b = b && b[1] || "";
        }
        return "\n" + $b + a;
    }
    var bc = !1;
    function cc(a, b) {
        if (!a || bc) return "";
        bc = !0;
        var c = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (b) {
                if (b = function() {
                    throw Error();
                }, Object.defineProperty(b.prototype, "props", {
                    set: function() {
                        throw Error();
                    }
                }), "object" === typeof Reflect && Reflect.construct) {
                    try {
                        Reflect.construct(b, []);
                    } catch (l) {
                        var d = l;
                    }
                    Reflect.construct(a, [], b);
                } else {
                    try {
                        b.call();
                    } catch (l) {
                        d = l;
                    }
                    a.call(b.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (l) {
                    d = l;
                }
                a();
            }
        } catch (l) {
            if (l && d && "string" === typeof l.stack) {
                for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
                for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                    if (1 !== g || 1 !== h) {
                        do if (g--, h--, 0 > h || e[g] !== f[h]) {
                            var k = "\n" + e[g].replace(" at new ", " at ");
                            a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                            return k;
                        }
                        while (1 <= g && 0 <= h);
                    }
                    break;
                }
            }
        } finally{
            bc = !1, Error.prepareStackTrace = c;
        }
        return (a = a ? a.displayName || a.name : "") ? ac(a) : "";
    }
    var dc = Object.prototype.hasOwnProperty, ec = [], fc = -1;
    function gc(a) {
        return {
            current: a
        };
    }
    function x(a) {
        0 > fc || (a.current = ec[fc], ec[fc] = null, fc--);
    }
    function y(a, b) {
        fc++;
        ec[fc] = a.current;
        a.current = b;
    }
    var hc = {}, A = gc(hc), B = gc(!1), ic = hc;
    function jc(a, b) {
        var c = a.type.contextTypes;
        if (!c) return hc;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
        var e = {}, f;
        for(f in c)e[f] = b[f];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
        return e;
    }
    function C(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
    }
    function kc() {
        x(B);
        x(A);
    }
    function lc(a, b, c) {
        if (A.current !== hc) throw Error(n(168));
        y(A, b);
        y(B, c);
    }
    function mc(a, b, c) {
        var d = a.stateNode;
        b = b.childContextTypes;
        if ("function" !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for(var e in d)if (!(e in b)) throw Error(n(108, xa(a) || "Unknown", e));
        return ca({}, c, d);
    }
    function nc(a) {
        a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || hc;
        ic = A.current;
        y(A, a);
        y(B, B.current);
        return !0;
    }
    function oc(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(n(169));
        c ? (a = mc(a, b, ic), d.__reactInternalMemoizedMergedChildContext = a, x(B), x(A), y(A, a)) : x(B);
        y(B, c);
    }
    var qc = Math.clz32 ? Math.clz32 : pc, rc = Math.log, sc = Math.LN2;
    function pc(a) {
        a >>>= 0;
        return 0 === a ? 32 : 31 - (rc(a) / sc | 0) | 0;
    }
    var tc = 64, uc = 4194304;
    function vc(a) {
        switch(a & -a){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return a & 4194240;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return a & 130023424;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 1073741824;
            default:
                return a;
        }
    }
    function wc(a, b) {
        var c = a.pendingLanes;
        if (0 === c) return 0;
        var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
        if (0 !== g) {
            var h = g & ~e;
            0 !== h ? d = vc(h) : (f &= g, 0 !== f && (d = vc(f)));
        } else g = c & ~e, 0 !== g ? d = vc(g) : 0 !== f && (d = vc(f));
        if (0 === d) return 0;
        if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
        0 !== (d & 4) && (d |= c & 16);
        b = a.entangledLanes;
        if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - qc(b), e = 1 << c, d |= a[c], b &= ~e;
        return d;
    }
    function xc(a, b) {
        switch(a){
            case 1:
            case 2:
            case 4:
                return b + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return b + 5E3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return -1;
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function yc(a, b) {
        for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
            var g = 31 - qc(f), h = 1 << g, k = e[g];
            if (-1 === k) {
                if (0 === (h & c) || 0 !== (h & d)) e[g] = xc(h, b);
            } else k <= b && (a.expiredLanes |= h);
            f &= ~h;
        }
    }
    function zc(a) {
        a = a.pendingLanes & -1073741825;
        return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
    }
    function Ac(a) {
        for(var b = [], c = 0; 31 > c; c++)b.push(a);
        return b;
    }
    function Bc(a, b, c) {
        a.pendingLanes |= b;
        536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
        a = a.eventTimes;
        b = 31 - qc(b);
        a[b] = c;
    }
    function Cc(a, b) {
        var c = a.pendingLanes & ~b;
        a.pendingLanes = b;
        a.suspendedLanes = 0;
        a.pingedLanes = 0;
        a.expiredLanes &= b;
        a.mutableReadLanes &= b;
        a.entangledLanes &= b;
        b = a.entanglements;
        var d = a.eventTimes;
        for(a = a.expirationTimes; 0 < c;){
            var e = 31 - qc(c), f = 1 << e;
            b[e] = 0;
            d[e] = -1;
            a[e] = -1;
            c &= ~f;
        }
    }
    function Dc(a, b) {
        var c = a.entangledLanes |= b;
        for(a = a.entanglements; c;){
            var d = 31 - qc(c), e = 1 << d;
            e & b | a[d] & b && (a[d] |= b);
            c &= ~e;
        }
    }
    var D = 0;
    function Ec(a) {
        a &= -a;
        return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
    }
    var Fc = ba.unstable_scheduleCallback, Gc = ba.unstable_cancelCallback, Hc = ba.unstable_shouldYield, Ic = ba.unstable_requestPaint, E = ba.unstable_now, Jc = ba.unstable_ImmediatePriority, Kc = ba.unstable_UserBlockingPriority, Lc = ba.unstable_NormalPriority, Mc = ba.unstable_IdlePriority, Nc = null, Oc = null;
    function Pc(a) {
        if (Oc && "function" === typeof Oc.onCommitFiberRoot) try {
            Oc.onCommitFiberRoot(Nc, a, void 0, 128 === (a.current.flags & 128));
        } catch (b) {}
    }
    function Qc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var Rc = "function" === typeof Object.is ? Object.is : Qc, Sc = null, Tc = !1, Uc = !1;
    function Vc(a) {
        null === Sc ? Sc = [
            a
        ] : Sc.push(a);
    }
    function Wc(a) {
        Tc = !0;
        Vc(a);
    }
    function Xc() {
        if (!Uc && null !== Sc) {
            Uc = !0;
            var a = 0, b = D;
            try {
                var c = Sc;
                for(D = 1; a < c.length; a++){
                    var d = c[a];
                    do d = d(!0);
                    while (null !== d);
                }
                Sc = null;
                Tc = !1;
            } catch (e) {
                throw null !== Sc && (Sc = Sc.slice(a + 1)), Fc(Jc, Xc), e;
            } finally{
                D = b, Uc = !1;
            }
        }
        return null;
    }
    var Yc = ea.ReactCurrentBatchConfig;
    function Zc(a, b) {
        if (Rc(a, b)) return !0;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for(d = 0; d < c.length; d++){
            var e = c[d];
            if (!dc.call(b, e) || !Rc(a[e], b[e])) return !1;
        }
        return !0;
    }
    function $c(a) {
        switch(a.tag){
            case 5:
                return ac(a.type);
            case 16:
                return ac("Lazy");
            case 13:
                return ac("Suspense");
            case 19:
                return ac("SuspenseList");
            case 0:
            case 2:
            case 15:
                return a = cc(a.type, !1), a;
            case 11:
                return a = cc(a.type.render, !1), a;
            case 1:
                return a = cc(a.type, !0), a;
            default:
                return "";
        }
    }
    function ad(a, b) {
        if (a && a.defaultProps) {
            b = ca({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    var bd = gc(null), cd = null, dd = null, ed = null;
    function fd() {
        ed = dd = cd = null;
    }
    function gd(a, b, c) {
        Ta ? (y(bd, b._currentValue), b._currentValue = c) : (y(bd, b._currentValue2), b._currentValue2 = c);
    }
    function hd(a) {
        var b = bd.current;
        x(bd);
        Ta ? a._currentValue = b : a._currentValue2 = b;
    }
    function id(a, b, c) {
        for(; null !== a;){
            var d = a.alternate;
            (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
            if (a === c) break;
            a = a.return;
        }
    }
    function jd(a, b) {
        cd = a;
        ed = dd = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (kd = !0), a.firstContext = null);
    }
    function ld(a) {
        var b = Ta ? a._currentValue : a._currentValue2;
        if (ed !== a) {
            if (a = {
                context: a,
                memoizedValue: b,
                next: null
            }, null === dd) {
                if (null === cd) throw Error(n(308));
                dd = a;
                cd.dependencies = {
                    lanes: 0,
                    firstContext: a
                };
            } else dd = dd.next = a;
        }
        return b;
    }
    var md = null, nd = !1;
    function od(a) {
        a.updateQueue = {
            baseState: a.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: 0
            },
            effects: null
        };
    }
    function pd(a, b) {
        a = a.updateQueue;
        b.updateQueue === a && (b.updateQueue = {
            baseState: a.baseState,
            firstBaseUpdate: a.firstBaseUpdate,
            lastBaseUpdate: a.lastBaseUpdate,
            shared: a.shared,
            effects: a.effects
        });
    }
    function qd(a, b) {
        return {
            eventTime: a,
            lane: b,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function rd(a, b) {
        var c = a.updateQueue;
        null !== c && (c = c.shared, null !== F && 0 !== (a.mode & 1) && 0 === (G & 2) ? (a = c.interleaved, null === a ? (b.next = b, null === md ? md = [
            c
        ] : md.push(c)) : (b.next = a.next, a.next = b), c.interleaved = b) : (a = c.pending, null === a ? b.next = b : (b.next = a.next, a.next = b), c.pending = b));
    }
    function sd(a, b, c) {
        b = b.updateQueue;
        if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Dc(a, c);
        }
    }
    function td(a, b) {
        var c = a.updateQueue, d = a.alternate;
        if (null !== d && (d = d.updateQueue, c === d)) {
            var e = null, f = null;
            c = c.firstBaseUpdate;
            if (null !== c) {
                do {
                    var g = {
                        eventTime: c.eventTime,
                        lane: c.lane,
                        tag: c.tag,
                        payload: c.payload,
                        callback: c.callback,
                        next: null
                    };
                    null === f ? e = f = g : f = f.next = g;
                    c = c.next;
                }while (null !== c);
                null === f ? e = f = b : f = f.next = b;
            } else e = f = b;
            c = {
                baseState: d.baseState,
                firstBaseUpdate: e,
                lastBaseUpdate: f,
                shared: d.shared,
                effects: d.effects
            };
            a.updateQueue = c;
            return;
        }
        a = c.lastBaseUpdate;
        null === a ? c.firstBaseUpdate = b : a.next = b;
        c.lastBaseUpdate = b;
    }
    function ud(a, b, c, d) {
        var e = a.updateQueue;
        nd = !1;
        var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
        if (null !== h) {
            e.shared.pending = null;
            var k = h, l = k.next;
            k.next = null;
            null === g ? f = l : g.next = l;
            g = k;
            var m = a.alternate;
            null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
        }
        if (null !== f) {
            var v = e.baseState;
            g = 0;
            m = l = k = null;
            h = f;
            do {
                var r = h.lane, z = h.eventTime;
                if ((d & r) === r) {
                    null !== m && (m = m.next = {
                        eventTime: z,
                        lane: 0,
                        tag: h.tag,
                        payload: h.payload,
                        callback: h.callback,
                        next: null
                    });
                    a: {
                        var q = a, N = h;
                        r = b;
                        z = c;
                        switch(N.tag){
                            case 1:
                                q = N.payload;
                                if ("function" === typeof q) {
                                    v = q.call(z, v, r);
                                    break a;
                                }
                                v = q;
                                break a;
                            case 3:
                                q.flags = q.flags & -65537 | 128;
                            case 0:
                                q = N.payload;
                                r = "function" === typeof q ? q.call(z, v, r) : q;
                                if (null === r || void 0 === r) break a;
                                v = ca({}, v, r);
                                break a;
                            case 2:
                                nd = !0;
                        }
                    }
                    null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                        h
                    ] : r.push(h));
                } else z = {
                    eventTime: z,
                    lane: r,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                }, null === m ? (l = m = z, k = v) : m = m.next = z, g |= r;
                h = h.next;
                if (null === h) {
                    if (h = e.shared.pending, null === h) break;
                    else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
                }
            }while (1);
            null === m && (k = v);
            e.baseState = k;
            e.firstBaseUpdate = l;
            e.lastBaseUpdate = m;
            b = e.shared.interleaved;
            if (null !== b) {
                e = b;
                do g |= e.lane, e = e.next;
                while (e !== b);
            } else null === f && (e.shared.lanes = 0);
            vd |= g;
            a.lanes = g;
            a.memoizedState = v;
        }
    }
    function wd(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a) for(b = 0; b < a.length; b++){
            var d = a[b], e = d.callback;
            if (null !== e) {
                d.callback = null;
                d = c;
                if ("function" !== typeof e) throw Error(n(191, e));
                e.call(d);
            }
        }
    }
    var xd = (new aa.Component).refs;
    function yd(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : ca({}, b, c);
        a.memoizedState = c;
        0 === a.lanes && (a.updateQueue.baseState = c);
    }
    var Bd = {
        isMounted: function(a) {
            return (a = a._reactInternals) ? ya(a) === a : !1;
        },
        enqueueSetState: function(a, b, c) {
            a = a._reactInternals;
            var d = H(), e = zd(a), f = qd(d, e);
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            rd(a, f);
            b = Ad(a, e, d);
            null !== b && sd(b, a, e);
        },
        enqueueReplaceState: function(a, b, c) {
            a = a._reactInternals;
            var d = H(), e = zd(a), f = qd(d, e);
            f.tag = 1;
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            rd(a, f);
            b = Ad(a, e, d);
            null !== b && sd(b, a, e);
        },
        enqueueForceUpdate: function(a, b) {
            a = a._reactInternals;
            var c = H(), d = zd(a), e = qd(c, d);
            e.tag = 2;
            void 0 !== b && null !== b && (e.callback = b);
            rd(a, e);
            b = Ad(a, d, c);
            null !== b && sd(b, a, d);
        }
    };
    function Cd(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Zc(c, d) || !Zc(e, f) : !0;
    }
    function Dd(a, b, c) {
        var d = !1, e = hc;
        var f = b.contextType;
        "object" === typeof f && null !== f ? f = ld(f) : (e = C(b) ? ic : A.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? jc(a, e) : hc);
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = Bd;
        a.stateNode = b;
        b._reactInternals = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
        return b;
    }
    function Ed(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && Bd.enqueueReplaceState(b, b.state, null);
    }
    function Fd(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = xd;
        od(a);
        var f = b.contextType;
        "object" === typeof f && null !== f ? e.context = ld(f) : (f = C(b) ? ic : A.current, e.context = jc(a, f));
        e.state = a.memoizedState;
        f = b.getDerivedStateFromProps;
        "function" === typeof f && (yd(a, b, f, c), e.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Bd.enqueueReplaceState(e, e.state, null), ud(a, c, e, d), e.state = a.memoizedState);
        "function" === typeof e.componentDidMount && (a.flags |= 4194308);
    }
    var Gd = [], Hd = 0, Id = null, Jd = 0, Kd = [], Ld = 0, Md = null, Nd = 1, Od = "";
    function Pd(a, b) {
        Gd[Hd++] = Jd;
        Gd[Hd++] = Id;
        Id = a;
        Jd = b;
    }
    function Qd(a, b, c) {
        Kd[Ld++] = Nd;
        Kd[Ld++] = Od;
        Kd[Ld++] = Md;
        Md = a;
        var d = Nd;
        a = Od;
        var e = 32 - qc(d) - 1;
        d &= ~(1 << e);
        c += 1;
        var f = 32 - qc(b) + e;
        if (30 < f) {
            var g = e - e % 5;
            f = (d & (1 << g) - 1).toString(32);
            d >>= g;
            e -= g;
            Nd = 1 << 32 - qc(b) + e | c << e | d;
            Od = f + a;
        } else Nd = 1 << f | c << e | d, Od = a;
    }
    function Rd(a) {
        null !== a.return && (Pd(a, 1), Qd(a, 1, 0));
    }
    function Sd(a) {
        for(; a === Id;)Id = Gd[--Hd], Gd[Hd] = null, Jd = Gd[--Hd], Gd[Hd] = null;
        for(; a === Md;)Md = Kd[--Ld], Kd[Ld] = null, Od = Kd[--Ld], Kd[Ld] = null, Nd = Kd[--Ld], Kd[Ld] = null;
    }
    var Td = null, Ud = null, I = !1, Vd = !1, Wd = null;
    function Xd(a, b) {
        var c = Yd(5, null, null, 0);
        c.elementType = "DELETED";
        c.stateNode = b;
        c.return = a;
        b = a.deletions;
        null === b ? (a.deletions = [
            c
        ], a.flags |= 16) : b.push(c);
    }
    function Zd(a, b) {
        switch(a.tag){
            case 5:
                return b = Fb(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, Td = a, Ud = Mb(b), !0) : !1;
            case 6:
                return b = Gb(b, a.pendingProps), null !== b ? (a.stateNode = b, Td = a, Ud = null, !0) : !1;
            case 13:
                b = Hb(b);
                if (null !== b) {
                    var c = null !== Md ? {
                        id: Nd,
                        overflow: Od
                    } : null;
                    a.memoizedState = {
                        dehydrated: b,
                        treeContext: c,
                        retryLane: 1073741824
                    };
                    c = Yd(18, null, null, 0);
                    c.stateNode = b;
                    c.return = a;
                    a.child = c;
                    Td = a;
                    Ud = null;
                    return !0;
                }
                return !1;
            default:
                return !1;
        }
    }
    function $d(a) {
        return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
    }
    function ae(a) {
        if (I) {
            var b = Ud;
            if (b) {
                var c = b;
                if (!Zd(a, b)) {
                    if ($d(a)) throw Error(n(418));
                    b = Lb(c);
                    var d = Td;
                    b && Zd(a, b) ? Xd(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, Td = a);
                }
            } else {
                if ($d(a)) throw Error(n(418));
                a.flags = a.flags & -4097 | 2;
                I = !1;
                Td = a;
            }
        }
    }
    function be(a) {
        for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
        Td = a;
    }
    function ce(a) {
        if (!p || a !== Td) return !1;
        if (!I) return be(a), I = !0, !1;
        if (3 !== a.tag && (5 !== a.tag || Xb(a.type) && !Oa(a.type, a.memoizedProps))) {
            var b = Ud;
            if (b) {
                if ($d(a)) {
                    for(a = Ud; a;)a = Lb(a);
                    throw Error(n(418));
                }
                for(; b;)Xd(a, b), b = Lb(b);
            }
        }
        be(a);
        if (13 === a.tag) {
            if (!p) throw Error(n(316));
            a = a.memoizedState;
            a = null !== a ? a.dehydrated : null;
            if (!a) throw Error(n(317));
            Ud = Sb(a);
        } else Ud = Td ? Lb(a.stateNode) : null;
        return !0;
    }
    function de() {
        p && (Ud = Td = null, Vd = I = !1);
    }
    function ee(a) {
        null === Wd ? Wd = [
            a
        ] : Wd.push(a);
    }
    function fe(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
            if (c._owner) {
                c = c._owner;
                if (c) {
                    if (1 !== c.tag) throw Error(n(309));
                    var d = c.stateNode;
                }
                if (!d) throw Error(n(147, a));
                var e = d, f = "" + a;
                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
                b = function(a) {
                    var b = e.refs;
                    b === xd && (b = e.refs = {});
                    null === a ? delete b[f] : b[f] = a;
                };
                b._stringRef = f;
                return b;
            }
            if ("string" !== typeof a) throw Error(n(284));
            if (!c._owner) throw Error(n(290, a));
        }
        return a;
    }
    function ge(a, b) {
        a = Object.prototype.toString.call(b);
        throw Error(n(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
    }
    function he(a) {
        var b = a._init;
        return b(a._payload);
    }
    function ie(a) {
        function b(b, c) {
            if (a) {
                var d = b.deletions;
                null === d ? (b.deletions = [
                    c
                ], b.flags |= 16) : d.push(c);
            }
        }
        function c(c, d) {
            if (!a) return null;
            for(; null !== d;)b(c, d), d = d.sibling;
            return null;
        }
        function d(a, b) {
            for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
            return a;
        }
        function e(a, b) {
            a = je(a, b);
            a.index = 0;
            a.sibling = null;
            return a;
        }
        function f(b, c, d) {
            b.index = d;
            if (!a) return b.flags |= 1048576, c;
            d = b.alternate;
            if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
            b.flags |= 2;
            return c;
        }
        function g(b) {
            a && null === b.alternate && (b.flags |= 2);
            return b;
        }
        function h(a, b, c, d) {
            if (null === b || 6 !== b.tag) return b = ke(c, a.mode, d), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function k(a, b, c, d) {
            var f = c.type;
            if (f === ia) return m(a, b, c.props.children, d, c.key);
            if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === ra && he(f) === b.type)) return d = e(b, c.props), d.ref = fe(a, b, c), d.return = a, d;
            d = le(c.type, c.key, c.props, null, a.mode, d);
            d.ref = fe(a, b, c);
            d.return = a;
            return d;
        }
        function l(a, b, c, d) {
            if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = me(c, a.mode, d), b.return = a, b;
            b = e(b, c.children || []);
            b.return = a;
            return b;
        }
        function m(a, b, c, d, f) {
            if (null === b || 7 !== b.tag) return b = ne(c, a.mode, d, f), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function v(a, b, c) {
            if ("string" === typeof b && "" !== b || "number" === typeof b) return b = ke("" + b, a.mode, c), b.return = a, b;
            if ("object" === typeof b && null !== b) {
                switch(b.$$typeof){
                    case fa:
                        return c = le(b.type, b.key, b.props, null, a.mode, c), c.ref = fe(a, null, b), c.return = a, c;
                    case ha:
                        return b = me(b, a.mode, c), b.return = a, b;
                    case ra:
                        var d = b._init;
                        return v(a, d(b._payload), c);
                }
                if (Ea(b) || ua(b)) return b = ne(b, a.mode, c, null), b.return = a, b;
                ge(a, b);
            }
            return null;
        }
        function r(a, b, c, d) {
            var e = null !== b ? b.key : null;
            if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
            if ("object" === typeof c && null !== c) {
                switch(c.$$typeof){
                    case fa:
                        return c.key === e ? k(a, b, c, d) : null;
                    case ha:
                        return c.key === e ? l(a, b, c, d) : null;
                    case ra:
                        return e = c._init, r(a, b, e(c._payload), d);
                }
                if (Ea(c) || ua(c)) return null !== e ? null : m(a, b, c, d, null);
                ge(a, c);
            }
            return null;
        }
        function z(a, b, c, d, e) {
            if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
            if ("object" === typeof d && null !== d) {
                switch(d.$$typeof){
                    case fa:
                        return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                    case ha:
                        return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                    case ra:
                        var f = d._init;
                        return z(a, b, c, f(d._payload), e);
                }
                if (Ea(d) || ua(d)) return a = a.get(c) || null, m(b, a, d, e, null);
                ge(b, d);
            }
            return null;
        }
        function q(e, g, h, k) {
            for(var l = null, m = null, w = g, u = g = 0, t = null; null !== w && u < h.length; u++){
                w.index > u ? (t = w, w = null) : t = w.sibling;
                var q = r(e, w, h[u], k);
                if (null === q) {
                    null === w && (w = t);
                    break;
                }
                a && w && null === q.alternate && b(e, w);
                g = f(q, g, u);
                null === m ? l = q : m.sibling = q;
                m = q;
                w = t;
            }
            if (u === h.length) return c(e, w), I && Pd(e, u), l;
            if (null === w) {
                for(; u < h.length; u++)w = v(e, h[u], k), null !== w && (g = f(w, g, u), null === m ? l = w : m.sibling = w, m = w);
                I && Pd(e, u);
                return l;
            }
            for(w = d(e, w); u < h.length; u++)t = z(w, e, u, h[u], k), null !== t && (a && null !== t.alternate && w.delete(null === t.key ? u : t.key), g = f(t, g, u), null === m ? l = t : m.sibling = t, m = t);
            a && w.forEach(function(a) {
                return b(e, a);
            });
            I && Pd(e, u);
            return l;
        }
        function N(e, g, h, k) {
            var l = ua(h);
            if ("function" !== typeof l) throw Error(n(150));
            h = l.call(h);
            if (null == h) throw Error(n(151));
            for(var w = l = null, m = g, u = g = 0, q = null, t = h.next(); null !== m && !t.done; u++, t = h.next()){
                m.index > u ? (q = m, m = null) : q = m.sibling;
                var V = r(e, m, t.value, k);
                if (null === V) {
                    null === m && (m = q);
                    break;
                }
                a && m && null === V.alternate && b(e, m);
                g = f(V, g, u);
                null === w ? l = V : w.sibling = V;
                w = V;
                m = q;
            }
            if (t.done) return c(e, m), I && Pd(e, u), l;
            if (null === m) {
                for(; !t.done; u++, t = h.next())t = v(e, t.value, k), null !== t && (g = f(t, g, u), null === w ? l = t : w.sibling = t, w = t);
                I && Pd(e, u);
                return l;
            }
            for(m = d(e, m); !t.done; u++, t = h.next())t = z(m, e, u, t.value, k), null !== t && (a && null !== t.alternate && m.delete(null === t.key ? u : t.key), g = f(t, g, u), null === w ? l = t : w.sibling = t, w = t);
            a && m.forEach(function(a) {
                return b(e, a);
            });
            I && Pd(e, u);
            return l;
        }
        function da(a, d, f, h) {
            "object" === typeof f && null !== f && f.type === ia && null === f.key && (f = f.props.children);
            if ("object" === typeof f && null !== f) {
                switch(f.$$typeof){
                    case fa:
                        a: {
                            for(var k = f.key, l = d; null !== l;){
                                if (l.key === k) {
                                    k = f.type;
                                    if (k === ia) {
                                        if (7 === l.tag) {
                                            c(a, l.sibling);
                                            d = e(l, f.props.children);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                    } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === ra && he(k) === l.type) {
                                        c(a, l.sibling);
                                        d = e(l, f.props);
                                        d.ref = fe(a, l, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    c(a, l);
                                    break;
                                } else b(a, l);
                                l = l.sibling;
                            }
                            f.type === ia ? (d = ne(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = le(f.type, f.key, f.props, null, a.mode, h), h.ref = fe(a, d, f), h.return = a, a = h);
                        }
                        return g(a);
                    case ha:
                        a: {
                            for(l = f.key; null !== d;){
                                if (d.key === l) {
                                    if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                        c(a, d.sibling);
                                        d = e(d, f.children || []);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, d);
                                        break;
                                    }
                                } else b(a, d);
                                d = d.sibling;
                            }
                            d = me(f, a.mode, h);
                            d.return = a;
                            a = d;
                        }
                        return g(a);
                    case ra:
                        return l = f._init, da(a, d, l(f._payload), h);
                }
                if (Ea(f)) return q(a, d, f, h);
                if (ua(f)) return N(a, d, f, h);
                ge(a, f);
            }
            return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = ke(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
        }
        return da;
    }
    var oe = ie(!0), pe = ie(!1), qe = {}, re = gc(qe), se = gc(qe), te = gc(qe);
    function ue(a) {
        if (a === qe) throw Error(n(174));
        return a;
    }
    function ve(a, b) {
        y(te, b);
        y(se, a);
        y(re, qe);
        a = Ga(b);
        x(re);
        y(re, a);
    }
    function we() {
        x(re);
        x(se);
        x(te);
    }
    function xe(a) {
        var b = ue(te.current), c = ue(re.current);
        b = Ha(c, a.type, b);
        c !== b && (y(se, a), y(re, b));
    }
    function ye(a) {
        se.current === a && (x(re), x(se));
    }
    var J = gc(0);
    function ze(a) {
        for(var b = a; null !== b;){
            if (13 === b.tag) {
                var c = b.memoizedState;
                if (null !== c && (c = c.dehydrated, null === c || Ib(c) || Jb(c))) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                if (0 !== (b.flags & 128)) return b;
            } else if (null !== b.child) {
                b.child.return = b;
                b = b.child;
                continue;
            }
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
        return null;
    }
    var Ae = [];
    function Be() {
        for(var a = 0; a < Ae.length; a++){
            var b = Ae[a];
            Ta ? b._workInProgressVersionPrimary = null : b._workInProgressVersionSecondary = null;
        }
        Ae.length = 0;
    }
    var Ce = ea.ReactCurrentDispatcher, De = ea.ReactCurrentBatchConfig, Ee = 0, K = null, L = null, M = null, Fe = !1, Ge = !1, He = 0, Ie = 0;
    function O() {
        throw Error(n(321));
    }
    function Je(a, b) {
        if (null === b) return !1;
        for(var c = 0; c < b.length && c < a.length; c++)if (!Rc(a[c], b[c])) return !1;
        return !0;
    }
    function Ke(a, b, c, d, e, f) {
        Ee = f;
        K = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.lanes = 0;
        Ce.current = null === a || null === a.memoizedState ? Le : Me;
        a = c(d, e);
        if (Ge) {
            f = 0;
            do {
                Ge = !1;
                He = 0;
                if (25 <= f) throw Error(n(301));
                f += 1;
                M = L = null;
                b.updateQueue = null;
                Ce.current = Ne;
                a = c(d, e);
            }while (Ge);
        }
        Ce.current = Oe;
        b = null !== L && null !== L.next;
        Ee = 0;
        M = L = K = null;
        Fe = !1;
        if (b) throw Error(n(300));
        return a;
    }
    function Pe() {
        var a = 0 !== He;
        He = 0;
        return a;
    }
    function Qe() {
        var a = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === M ? K.memoizedState = M = a : M = M.next = a;
        return M;
    }
    function Re() {
        if (null === L) {
            var a = K.alternate;
            a = null !== a ? a.memoizedState : null;
        } else a = L.next;
        var b = null === M ? K.memoizedState : M.next;
        if (null !== b) M = b, L = a;
        else {
            if (null === a) throw Error(n(310));
            L = a;
            a = {
                memoizedState: L.memoizedState,
                baseState: L.baseState,
                baseQueue: L.baseQueue,
                queue: L.queue,
                next: null
            };
            null === M ? K.memoizedState = M = a : M = M.next = a;
        }
        return M;
    }
    function Se(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function Te(a) {
        var b = Re(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = L, e = d.baseQueue, f = c.pending;
        if (null !== f) {
            if (null !== e) {
                var g = e.next;
                e.next = f.next;
                f.next = g;
            }
            d.baseQueue = e = f;
            c.pending = null;
        }
        if (null !== e) {
            f = e.next;
            d = d.baseState;
            var h = g = null, k = null, l = f;
            do {
                var m = l.lane;
                if ((Ee & m) === m) null !== k && (k = k.next = {
                    lane: 0,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
                else {
                    var v = {
                        lane: m,
                        action: l.action,
                        hasEagerState: l.hasEagerState,
                        eagerState: l.eagerState,
                        next: null
                    };
                    null === k ? (h = k = v, g = d) : k = k.next = v;
                    K.lanes |= m;
                    vd |= m;
                }
                l = l.next;
            }while (null !== l && l !== f);
            null === k ? g = d : k.next = h;
            Rc(d, b.memoizedState) || (kd = !0);
            b.memoizedState = d;
            b.baseState = g;
            b.baseQueue = k;
            c.lastRenderedState = d;
        }
        a = c.interleaved;
        if (null !== a) {
            e = a;
            do f = e.lane, K.lanes |= f, vd |= f, e = e.next;
            while (e !== a);
        } else null === e && (c.lanes = 0);
        return [
            b.memoizedState,
            c.dispatch
        ];
    }
    function Ue(a) {
        var b = Re(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch, e = c.pending, f = b.memoizedState;
        if (null !== e) {
            c.pending = null;
            var g = e = e.next;
            do f = a(f, g.action), g = g.next;
            while (g !== e);
            Rc(f, b.memoizedState) || (kd = !0);
            b.memoizedState = f;
            null === b.baseQueue && (b.baseState = f);
            c.lastRenderedState = f;
        }
        return [
            f,
            d
        ];
    }
    function Ve() {}
    function We(a, b) {
        var c = K, d = Re(), e = b(), f = !Rc(d.memoizedState, e);
        f && (d.memoizedState = e, kd = !0);
        d = d.queue;
        Xe(Ye.bind(null, c, d, a), [
            a
        ]);
        if (d.getSnapshot !== b || f || null !== M && M.memoizedState.tag & 1) {
            c.flags |= 2048;
            Ze(9, $e.bind(null, c, d, e, b), void 0, null);
            if (null === F) throw Error(n(349));
            0 !== (Ee & 30) || af(c, b, e);
        }
        return e;
    }
    function af(a, b, c) {
        a.flags |= 16384;
        a = {
            getSnapshot: b,
            value: c
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.stores = [
            a
        ]) : (c = b.stores, null === c ? b.stores = [
            a
        ] : c.push(a));
    }
    function $e(a, b, c, d) {
        b.value = c;
        b.getSnapshot = d;
        bf(b) && Ad(a, 1, -1);
    }
    function Ye(a, b, c) {
        return c(function() {
            bf(b) && Ad(a, 1, -1);
        });
    }
    function bf(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
            var c = b();
            return !Rc(a, c);
        } catch (d) {
            return !0;
        }
    }
    function cf(a) {
        var b = Qe();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: Se,
            lastRenderedState: a
        };
        b.queue = a;
        a = a.dispatch = df.bind(null, K, a);
        return [
            b.memoizedState,
            a
        ];
    }
    function Ze(a, b, c, d) {
        a = {
            tag: a,
            create: b,
            destroy: c,
            deps: d,
            next: null
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
        return a;
    }
    function ef() {
        return Re().memoizedState;
    }
    function ff(a, b, c, d) {
        var e = Qe();
        K.flags |= a;
        e.memoizedState = Ze(1 | b, c, void 0, void 0 === d ? null : d);
    }
    function gf(a, b, c, d) {
        var e = Re();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== L) {
            var g = L.memoizedState;
            f = g.destroy;
            if (null !== d && Je(d, g.deps)) {
                e.memoizedState = Ze(b, c, f, d);
                return;
            }
        }
        K.flags |= a;
        e.memoizedState = Ze(1 | b, c, f, d);
    }
    function hf(a, b) {
        return ff(8390656, 8, a, b);
    }
    function Xe(a, b) {
        return gf(2048, 8, a, b);
    }
    function jf(a, b) {
        return gf(4, 2, a, b);
    }
    function kf(a, b) {
        return gf(4, 4, a, b);
    }
    function lf(a, b) {
        if ("function" === typeof b) return a = a(), b(a), function() {
            b(null);
        };
        if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
            b.current = null;
        };
    }
    function mf(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return gf(4, 4, lf.bind(null, b, a), c);
    }
    function nf() {}
    function of(a, b) {
        var c = Re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Je(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function pf(a, b) {
        var c = Re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Je(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function qf(a, b) {
        var c = D;
        D = 0 !== c && 4 > c ? c : 4;
        a(!0);
        var d = De.transition;
        De.transition = {};
        try {
            a(!1), b();
        } finally{
            D = c, De.transition = d;
        }
    }
    function rf() {
        return Re().memoizedState;
    }
    function sf(a, b, c) {
        var d = zd(a);
        c = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        tf(a) ? uf(b, c) : (vf(a, b, c), c = H(), a = Ad(a, d, c), null !== a && wf(a, b, d));
    }
    function df(a, b, c) {
        var d = zd(a), e = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (tf(a)) uf(b, e);
        else {
            vf(a, b, e);
            var f = a.alternate;
            if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
                var g = b.lastRenderedState, h = f(g, c);
                e.hasEagerState = !0;
                e.eagerState = h;
                if (Rc(h, g)) return;
            } catch (k) {} finally{}
            c = H();
            a = Ad(a, d, c);
            null !== a && wf(a, b, d);
        }
    }
    function tf(a) {
        var b = a.alternate;
        return a === K || null !== b && b === K;
    }
    function uf(a, b) {
        Ge = Fe = !0;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
    function vf(a, b, c) {
        null !== F && 0 !== (a.mode & 1) && 0 === (G & 2) ? (a = b.interleaved, null === a ? (c.next = c, null === md ? md = [
            b
        ] : md.push(b)) : (c.next = a.next, a.next = c), b.interleaved = c) : (a = b.pending, null === a ? c.next = c : (c.next = a.next, a.next = c), b.pending = c);
    }
    function wf(a, b, c) {
        if (0 !== (c & 4194240)) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Dc(a, c);
        }
    }
    var Oe = {
        readContext: ld,
        useCallback: O,
        useContext: O,
        useEffect: O,
        useImperativeHandle: O,
        useInsertionEffect: O,
        useLayoutEffect: O,
        useMemo: O,
        useReducer: O,
        useRef: O,
        useState: O,
        useDebugValue: O,
        useDeferredValue: O,
        useTransition: O,
        useMutableSource: O,
        useSyncExternalStore: O,
        useId: O,
        unstable_isNewReconciler: !1
    }, Le = {
        readContext: ld,
        useCallback: function(a, b) {
            Qe().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        },
        useContext: ld,
        useEffect: hf,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return ff(4194308, 4, lf.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return ff(4194308, 4, a, b);
        },
        useInsertionEffect: function(a, b) {
            return ff(4, 2, a, b);
        },
        useMemo: function(a, b) {
            var c = Qe();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: function(a, b, c) {
            var d = Qe();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: a,
                lastRenderedState: b
            };
            d.queue = a;
            a = a.dispatch = sf.bind(null, K, a);
            return [
                d.memoizedState,
                a
            ];
        },
        useRef: function(a) {
            var b = Qe();
            a = {
                current: a
            };
            return b.memoizedState = a;
        },
        useState: cf,
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = cf(a), c = b[0], d = b[1];
            hf(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = cf(!1), b = a[0];
            a = qf.bind(null, a[1]);
            Qe().memoizedState = a;
            return [
                b,
                a
            ];
        },
        useMutableSource: function() {},
        useSyncExternalStore: function(a, b, c) {
            var d = K, e = Qe();
            if (I) {
                if (void 0 === c) throw Error(n(407));
                c = c();
            } else {
                c = b();
                if (null === F) throw Error(n(349));
                0 !== (Ee & 30) || af(d, b, c);
            }
            e.memoizedState = c;
            var f = {
                value: c,
                getSnapshot: b
            };
            e.queue = f;
            hf(Ye.bind(null, d, f, a), [
                a
            ]);
            d.flags |= 2048;
            Ze(9, $e.bind(null, d, f, c, b), void 0, null);
            return c;
        },
        useId: function() {
            var a = Qe(), b = F.identifierPrefix;
            if (I) {
                var c = Od;
                var d = Nd;
                c = (d & ~(1 << 32 - qc(d) - 1)).toString(32) + c;
                b = ":" + b + "R" + c;
                c = He++;
                0 < c && (b += "H" + c.toString(32));
                b += ":";
            } else c = Ie++, b = ":" + b + "r" + c.toString(32) + ":";
            return a.memoizedState = b;
        },
        unstable_isNewReconciler: !1
    }, Me = {
        readContext: ld,
        useCallback: of,
        useContext: ld,
        useEffect: Xe,
        useImperativeHandle: mf,
        useInsertionEffect: jf,
        useLayoutEffect: kf,
        useMemo: pf,
        useReducer: Te,
        useRef: ef,
        useState: function() {
            return Te(Se);
        },
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = Te(Se), c = b[0], d = b[1];
            Xe(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = Te(Se)[0], b = Re().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Ve,
        useSyncExternalStore: We,
        useId: rf,
        unstable_isNewReconciler: !1
    }, Ne = {
        readContext: ld,
        useCallback: of,
        useContext: ld,
        useEffect: Xe,
        useImperativeHandle: mf,
        useInsertionEffect: jf,
        useLayoutEffect: kf,
        useMemo: pf,
        useReducer: Ue,
        useRef: ef,
        useState: function() {
            return Ue(Se);
        },
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = Ue(Se), c = b[0], d = b[1];
            Xe(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = Ue(Se)[0], b = Re().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Ve,
        useSyncExternalStore: We,
        useId: rf,
        unstable_isNewReconciler: !1
    };
    function xf(a, b) {
        try {
            var c = "", d = b;
            do c += $c(d), d = d.return;
            while (d);
            var e = c;
        } catch (f) {
            e = "\nError generating stack: " + f.message + "\n" + f.stack;
        }
        return {
            value: a,
            source: b,
            stack: e
        };
    }
    function yf(a, b) {
        try {
            console.error(b.value);
        } catch (c) {
            setTimeout(function() {
                throw c;
            });
        }
    }
    var zf = "function" === typeof WeakMap ? WeakMap : Map;
    function Af(a, b, c) {
        c = qd(-1, c);
        c.tag = 3;
        c.payload = {
            element: null
        };
        var d = b.value;
        c.callback = function() {
            Bf || (Bf = !0, Cf = d);
            yf(a, b);
        };
        return c;
    }
    function Df(a, b, c) {
        c = qd(-1, c);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
            var e = b.value;
            c.payload = function() {
                return d(e);
            };
            c.callback = function() {
                yf(a, b);
            };
        }
        var f = a.stateNode;
        null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
            yf(a, b);
            "function" !== typeof d && (null === Ef ? Ef = new Set([
                this
            ]) : Ef.add(this));
            var c = b.stack;
            this.componentDidCatch(b.value, {
                componentStack: null !== c ? c : ""
            });
        });
        return c;
    }
    function Ff(a, b, c) {
        var d = a.pingCache;
        if (null === d) {
            d = a.pingCache = new zf;
            var e = new Set;
            d.set(b, e);
        } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
        e.has(c) || (e.add(c), a = Gf.bind(null, a, b, c), b.then(a, a));
    }
    function Hf(a) {
        do {
            var b;
            if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
            if (b) return a;
            a = a.return;
        }while (null !== a);
        return null;
    }
    function If(a, b, c, d, e) {
        if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = qd(-1, 1), b.tag = 2, rd(c, b))), c.lanes |= 1), a;
        a.flags |= 65536;
        a.lanes = e;
        return a;
    }
    function Jf(a) {
        a.flags |= 4;
    }
    function Kf(a, b) {
        if (null !== a && a.child === b.child) return !0;
        if (0 !== (b.flags & 16)) return !1;
        for(a = b.child; null !== a;){
            if (0 !== (a.flags & 12854) || 0 !== (a.subtreeFlags & 12854)) return !1;
            a = a.sibling;
        }
        return !0;
    }
    var Lf, Mf, Nf, Of;
    if (Ua) Lf = function(a, b) {
        for(var c = b.child; null !== c;){
            if (5 === c.tag || 6 === c.tag) La(a, c.stateNode);
            else if (4 !== c.tag && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }, Mf = function() {}, Nf = function(a, b, c, d, e) {
        a = a.memoizedProps;
        if (a !== d) {
            var f = b.stateNode, g = ue(re.current);
            c = Na(f, c, a, d, e, g);
            (b.updateQueue = c) && Jf(b);
        }
    }, Of = function(a, b, c, d) {
        c !== d && Jf(b);
    };
    else if (Va) {
        Lf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    La(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), La(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), Lf(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        var Pf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    Ab(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), Ab(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), Pf(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        Mf = function(a, b) {
            var c = b.stateNode;
            if (!Kf(a, b)) {
                a = c.containerInfo;
                var d = zb(a);
                Pf(d, b, !1, !1);
                c.pendingChildren = d;
                Jf(b);
                Bb(a, d);
            }
        };
        Nf = function(a, b, c, d, e) {
            var f = a.stateNode, g = a.memoizedProps;
            if ((a = Kf(a, b)) && g === d) b.stateNode = f;
            else {
                var h = b.stateNode, k = ue(re.current), l = null;
                g !== d && (l = Na(h, c, g, d, e, k));
                a && null === l ? b.stateNode = f : (f = yb(f, l, c, g, d, b, a, h), Ma(f, c, d, e, k) && Jf(b), b.stateNode = f, a ? Jf(b) : Lf(f, b, !1, !1));
            }
        };
        Of = function(a, b, c, d) {
            c !== d ? (a = ue(te.current), c = ue(re.current), b.stateNode = Pa(d, a, c, b), Jf(b)) : b.stateNode = a.stateNode;
        };
    } else Mf = function() {}, Nf = function() {}, Of = function() {};
    function Qf(a, b) {
        if (!I) switch(a.tailMode){
            case "hidden":
                b = a.tail;
                for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                null === c ? a.tail = null : c.sibling = null;
                break;
            case "collapsed":
                c = a.tail;
                for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
    }
    function P(a) {
        var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
        if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
        else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
        a.subtreeFlags |= d;
        a.childLanes = c;
        return b;
    }
    function Rf(a, b, c) {
        var d = b.pendingProps;
        Sd(b);
        switch(b.tag){
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return P(b), null;
            case 1:
                return C(b.type) && kc(), P(b), null;
            case 3:
                d = b.stateNode;
                we();
                x(B);
                x(A);
                Be();
                d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
                if (null === a || null === a.child) ce(b) ? Jf(b) : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== Wd && (Sf(Wd), Wd = null));
                Mf(a, b);
                P(b);
                return null;
            case 5:
                ye(b);
                c = ue(te.current);
                var e = b.type;
                if (null !== a && null != b.stateNode) Nf(a, b, e, d, c), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                else {
                    if (!d) {
                        if (null === b.stateNode) throw Error(n(166));
                        P(b);
                        return null;
                    }
                    a = ue(re.current);
                    if (ce(b)) {
                        if (!p) throw Error(n(175));
                        a = Pb(b.stateNode, b.type, b.memoizedProps, c, a, b, !Vd);
                        b.updateQueue = a;
                        null !== a && Jf(b);
                    } else {
                        var f = Ka(e, d, c, a, b);
                        Lf(f, b, !1, !1);
                        b.stateNode = f;
                        Ma(f, e, d, c, a) && Jf(b);
                    }
                    null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                }
                P(b);
                return null;
            case 6:
                if (a && null != b.stateNode) Of(a, b, a.memoizedProps, d);
                else {
                    if ("string" !== typeof d && null === b.stateNode) throw Error(n(166));
                    a = ue(te.current);
                    c = ue(re.current);
                    if (ce(b)) {
                        if (!p) throw Error(n(176));
                        a = b.stateNode;
                        d = b.memoizedProps;
                        if (c = Qb(a, d, b, !Vd)) {
                            if (e = Td, null !== e) switch(f = 0 !== (e.mode & 1), e.tag){
                                case 3:
                                    Yb(e.stateNode.containerInfo, a, d, f);
                                    break;
                                case 5:
                                    Zb(e.type, e.memoizedProps, e.stateNode, a, d, f);
                            }
                        }
                        c && Jf(b);
                    } else b.stateNode = Pa(d, a, c, b);
                }
                P(b);
                return null;
            case 13:
                x(J);
                d = b.memoizedState;
                if (I && null !== Ud && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) {
                    for(a = Ud; a;)a = Lb(a);
                    de();
                    b.flags |= 98560;
                    return b;
                }
                if (null !== d && null !== d.dehydrated) {
                    d = ce(b);
                    if (null === a) {
                        if (!d) throw Error(n(318));
                        if (!p) throw Error(n(344));
                        a = b.memoizedState;
                        a = null !== a ? a.dehydrated : null;
                        if (!a) throw Error(n(317));
                        Rb(a, b);
                    } else de(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    P(b);
                    return null;
                }
                null !== Wd && (Sf(Wd), Wd = null);
                if (0 !== (b.flags & 128)) return b.lanes = c, b;
                d = null !== d;
                c = !1;
                null === a ? ce(b) : c = null !== a.memoizedState;
                d && !c && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (J.current & 1) ? 0 === Q && (Q = 3) : Tf()));
                null !== b.updateQueue && (b.flags |= 4);
                P(b);
                return null;
            case 4:
                return we(), Mf(a, b), null === a && Xa(b.stateNode.containerInfo), P(b), null;
            case 10:
                return hd(b.type._context), P(b), null;
            case 17:
                return C(b.type) && kc(), P(b), null;
            case 19:
                x(J);
                e = b.memoizedState;
                if (null === e) return P(b), null;
                d = 0 !== (b.flags & 128);
                f = e.rendering;
                if (null === f) {
                    if (d) Qf(e, !1);
                    else {
                        if (0 !== Q || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                            f = ze(a);
                            if (null !== f) {
                                b.flags |= 128;
                                Qf(e, !1);
                                a = f.updateQueue;
                                null !== a && (b.updateQueue = a, b.flags |= 4);
                                b.subtreeFlags = 0;
                                a = c;
                                for(d = b.child; null !== d;)c = d, e = a, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = e, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, e = f.dependencies, c.dependencies = null === e ? null : {
                                    lanes: e.lanes,
                                    firstContext: e.firstContext
                                }), d = d.sibling;
                                y(J, J.current & 1 | 2);
                                return b.child;
                            }
                            a = a.sibling;
                        }
                        null !== e.tail && E() > Uf && (b.flags |= 128, d = !0, Qf(e, !1), b.lanes = 4194304);
                    }
                } else {
                    if (!d) {
                        if (a = ze(f), null !== a) {
                            if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), Qf(e, !0), null === e.tail && "hidden" === e.tailMode && !f.alternate && !I) return P(b), null;
                        } else 2 * E() - e.renderingStartTime > Uf && 1073741824 !== c && (b.flags |= 128, d = !0, Qf(e, !1), b.lanes = 4194304);
                    }
                    e.isBackwards ? (f.sibling = b.child, b.child = f) : (a = e.last, null !== a ? a.sibling = f : b.child = f, e.last = f);
                }
                if (null !== e.tail) return b = e.tail, e.rendering = b, e.tail = b.sibling, e.renderingStartTime = E(), b.sibling = null, a = J.current, y(J, d ? a & 1 | 2 : a & 1), b;
                P(b);
                return null;
            case 22:
            case 23:
                return Vf(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (Wf & 1073741824) && (P(b), Ua && b.subtreeFlags & 6 && (b.flags |= 8192)) : P(b), null;
            case 24:
                return null;
            case 25:
                return null;
        }
        throw Error(n(156, b.tag));
    }
    var Xf = ea.ReactCurrentOwner, kd = !1;
    function R(a, b, c, d) {
        b.child = null === a ? pe(b, null, c, d) : oe(b, a.child, c, d);
    }
    function Yf(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        jd(b, e);
        d = Ke(a, b, c, d, f, e);
        c = Pe();
        if (null !== a && !kd) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zf(a, b, e);
        I && c && Rd(b);
        b.flags |= 1;
        R(a, b, d, e);
        return b.child;
    }
    function $f(a, b, c, d, e) {
        if (null === a) {
            var f = c.type;
            if ("function" === typeof f && !ag(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bg(a, b, f, d, e);
            a = le(c.type, null, d, b, b.mode, e);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        f = a.child;
        if (0 === (a.lanes & e)) {
            var g = f.memoizedProps;
            c = c.compare;
            c = null !== c ? c : Zc;
            if (c(g, d) && a.ref === b.ref) return Zf(a, b, e);
        }
        b.flags |= 1;
        a = je(f, d);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    function bg(a, b, c, d, e) {
        if (null !== a && Zc(a.memoizedProps, d) && a.ref === b.ref) {
            if (kd = !1, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (kd = !0);
            else return b.lanes = a.lanes, Zf(a, b, e);
        }
        return cg(a, b, c, d, e);
    }
    function dg(a, b, c) {
        var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
        if ("hidden" === d.mode) {
            if (0 === (b.mode & 1)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, y(eg, Wf), Wf |= c;
            else if (0 !== (c & 1073741824)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, d = null !== f ? f.baseLanes : c, y(eg, Wf), Wf |= d;
            else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null
            }, b.updateQueue = null, y(eg, Wf), Wf |= a, null;
        } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, y(eg, Wf), Wf |= d;
        R(a, b, e, c);
        return b.child;
    }
    function fg(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
    }
    function cg(a, b, c, d, e) {
        var f = C(c) ? ic : A.current;
        f = jc(b, f);
        jd(b, e);
        c = Ke(a, b, c, d, f, e);
        d = Pe();
        if (null !== a && !kd) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zf(a, b, e);
        I && d && Rd(b);
        b.flags |= 1;
        R(a, b, c, e);
        return b.child;
    }
    function gg(a, b, c, d, e) {
        if (C(c)) {
            var f = !0;
            nc(b);
        } else f = !1;
        jd(b, e);
        if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Dd(b, c, d), Fd(b, c, d, e), d = !0;
        else if (null === a) {
            var g = b.stateNode, h = b.memoizedProps;
            g.props = h;
            var k = g.context, l = c.contextType;
            "object" === typeof l && null !== l ? l = ld(l) : (l = C(c) ? ic : A.current, l = jc(b, l));
            var m = c.getDerivedStateFromProps, v = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
            v || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ed(b, g, d, l);
            nd = !1;
            var r = b.memoizedState;
            g.state = r;
            ud(b, d, g, e);
            k = b.memoizedState;
            h !== d || r !== k || B.current || nd ? ("function" === typeof m && (yd(b, c, m, d), k = b.memoizedState), (h = nd || Cd(b, c, h, d, r, k, l)) ? (v || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
        } else {
            g = b.stateNode;
            pd(a, b);
            h = b.memoizedProps;
            l = b.type === b.elementType ? h : ad(b.type, h);
            g.props = l;
            v = b.pendingProps;
            r = g.context;
            k = c.contextType;
            "object" === typeof k && null !== k ? k = ld(k) : (k = C(c) ? ic : A.current, k = jc(b, k));
            var z = c.getDerivedStateFromProps;
            (m = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== v || r !== k) && Ed(b, g, d, k);
            nd = !1;
            r = b.memoizedState;
            g.state = r;
            ud(b, d, g, e);
            var q = b.memoizedState;
            h !== v || r !== q || B.current || nd ? ("function" === typeof z && (yd(b, c, z, d), q = b.memoizedState), (l = nd || Cd(b, c, l, d, r, q, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, q, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, q, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = q), g.props = d, g.state = q, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
        }
        return hg(a, b, c, d, f, e);
    }
    function hg(a, b, c, d, e, f) {
        fg(a, b);
        var g = 0 !== (b.flags & 128);
        if (!d && !g) return e && oc(b, c, !1), Zf(a, b, f);
        d = b.stateNode;
        Xf.current = b;
        var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.flags |= 1;
        null !== a && g ? (b.child = oe(b, a.child, null, f), b.child = oe(b, null, h, f)) : R(a, b, h, f);
        b.memoizedState = d.state;
        e && oc(b, c, !0);
        return b.child;
    }
    function ig(a) {
        var b = a.stateNode;
        b.pendingContext ? lc(a, b.pendingContext, b.pendingContext !== b.context) : b.context && lc(a, b.context, !1);
        ve(a, b.containerInfo);
    }
    function jg(a, b, c, d, e) {
        de();
        ee(e);
        b.flags |= 256;
        R(a, b, c, d);
        return b.child;
    }
    var kg = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
    };
    function lg(a) {
        return {
            baseLanes: a,
            cachePool: null
        };
    }
    function mg(a, b, c) {
        var d = b.pendingProps, e = J.current, f = !1, g = 0 !== (b.flags & 128), h;
        (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
        if (h) f = !0, b.flags &= -129;
        else if (null === a || null !== a.memoizedState) e |= 1;
        y(J, e & 1);
        if (null === a) {
            ae(b);
            a = b.memoizedState;
            if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : Jb(a) ? b.lanes = 8 : b.lanes = 1073741824, null;
            e = d.children;
            a = d.fallback;
            return f ? (d = b.mode, f = b.child, e = {
                mode: "hidden",
                children: e
            }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = e) : f = ng(e, d, 0, null), a = ne(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = lg(c), b.memoizedState = kg, a) : og(b, e);
        }
        e = a.memoizedState;
        if (null !== e) {
            h = e.dehydrated;
            if (null !== h) {
                if (g) {
                    if (b.flags & 256) return b.flags &= -257, pg(a, b, c, Error(n(422)));
                    if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
                    f = d.fallback;
                    e = b.mode;
                    d = ng({
                        mode: "visible",
                        children: d.children
                    }, e, 0, null);
                    f = ne(f, e, c, null);
                    f.flags |= 2;
                    d.return = b;
                    f.return = b;
                    d.sibling = f;
                    b.child = d;
                    0 !== (b.mode & 1) && oe(b, a.child, null, c);
                    b.child.memoizedState = lg(c);
                    b.memoizedState = kg;
                    return f;
                }
                if (0 === (b.mode & 1)) b = pg(a, b, c, null);
                else if (Jb(h)) b = pg(a, b, c, Error(n(419)));
                else if (d = 0 !== (c & a.childLanes), kd || d) {
                    d = F;
                    if (null !== d) {
                        switch(c & -c){
                            case 4:
                                f = 2;
                                break;
                            case 16:
                                f = 8;
                                break;
                            case 64:
                            case 128:
                            case 256:
                            case 512:
                            case 1024:
                            case 2048:
                            case 4096:
                            case 8192:
                            case 16384:
                            case 32768:
                            case 65536:
                            case 131072:
                            case 262144:
                            case 524288:
                            case 1048576:
                            case 2097152:
                            case 4194304:
                            case 8388608:
                            case 16777216:
                            case 33554432:
                            case 67108864:
                                f = 32;
                                break;
                            case 536870912:
                                f = 268435456;
                                break;
                            default:
                                f = 0;
                        }
                        d = 0 !== (f & (d.suspendedLanes | c)) ? 0 : f;
                        0 !== d && d !== e.retryLane && (e.retryLane = d, Ad(a, d, -1));
                    }
                    Tf();
                    b = pg(a, b, c, Error(n(421)));
                } else Ib(h) ? (b.flags |= 128, b.child = a.child, b = qg.bind(null, a), Kb(h, b), b = null) : (c = e.treeContext, p && (Ud = Ob(h), Td = b, I = !0, Wd = null, Vd = !1, null !== c && (Kd[Ld++] = Nd, Kd[Ld++] = Od, Kd[Ld++] = Md, Nd = c.id, Od = c.overflow, Md = b)), b = og(b, b.pendingProps.children), b.flags |= 4096);
                return b;
            }
            if (f) return d = rg(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? lg(c) : {
                baseLanes: e.baseLanes | c,
                cachePool: null
            }, f.childLanes = a.childLanes & ~c, b.memoizedState = kg, d;
            c = sg(a, b, d.children, c);
            b.memoizedState = null;
            return c;
        }
        if (f) return d = rg(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? lg(c) : {
            baseLanes: e.baseLanes | c,
            cachePool: null
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = kg, d;
        c = sg(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    function og(a, b) {
        b = ng({
            mode: "visible",
            children: b
        }, a.mode, 0, null);
        b.return = a;
        return a.child = b;
    }
    function sg(a, b, c, d) {
        var e = a.child;
        a = e.sibling;
        c = je(e, {
            mode: "visible",
            children: c
        });
        0 === (b.mode & 1) && (c.lanes = d);
        c.return = b;
        c.sibling = null;
        null !== a && (d = b.deletions, null === d ? (b.deletions = [
            a
        ], b.flags |= 16) : d.push(a));
        return b.child = c;
    }
    function rg(a, b, c, d, e) {
        var f = b.mode;
        a = a.child;
        var g = a.sibling, h = {
            mode: "hidden",
            children: c
        };
        0 === (f & 1) && b.child !== a ? (c = b.child, c.childLanes = 0, c.pendingProps = h, b.deletions = null) : (c = je(a, h), c.subtreeFlags = a.subtreeFlags & 14680064);
        null !== g ? d = je(g, d) : (d = ne(d, f, e, null), d.flags |= 2);
        d.return = b;
        c.return = b;
        c.sibling = d;
        b.child = c;
        return d;
    }
    function pg(a, b, c, d) {
        null !== d && ee(d);
        oe(b, a.child, null, c);
        a = og(b, b.pendingProps.children);
        a.flags |= 2;
        b.memoizedState = null;
        return a;
    }
    function tg(a, b, c) {
        a.lanes |= b;
        var d = a.alternate;
        null !== d && (d.lanes |= b);
        id(a.return, b, c);
    }
    function ug(a, b, c, d, e) {
        var f = a.memoizedState;
        null === f ? a.memoizedState = {
            isBackwards: b,
            rendering: null,
            renderingStartTime: 0,
            last: d,
            tail: c,
            tailMode: e
        } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
    }
    function vg(a, b, c) {
        var d = b.pendingProps, e = d.revealOrder, f = d.tail;
        R(a, b, d.children, c);
        d = J.current;
        if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
        else {
            if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
                if (13 === a.tag) null !== a.memoizedState && tg(a, c, b);
                else if (19 === a.tag) tg(a, c, b);
                else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === b) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === b) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            d &= 1;
        }
        y(J, d);
        if (0 === (b.mode & 1)) b.memoizedState = null;
        else switch(e){
            case "forwards":
                c = b.child;
                for(e = null; null !== c;)a = c.alternate, null !== a && null === ze(a) && (e = c), c = c.sibling;
                c = e;
                null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                ug(b, !1, e, c, f);
                break;
            case "backwards":
                c = null;
                e = b.child;
                for(b.child = null; null !== e;){
                    a = e.alternate;
                    if (null !== a && null === ze(a)) {
                        b.child = e;
                        break;
                    }
                    a = e.sibling;
                    e.sibling = c;
                    c = e;
                    e = a;
                }
                ug(b, !0, c, null, f);
                break;
            case "together":
                ug(b, !1, null, null, void 0);
                break;
            default:
                b.memoizedState = null;
        }
        return b.child;
    }
    function Zf(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        vd |= b.lanes;
        if (0 === (c & b.childLanes)) return null;
        if (null !== a && b.child !== a.child) throw Error(n(153));
        if (null !== b.child) {
            a = b.child;
            c = je(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = je(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    function wg(a, b, c) {
        switch(b.tag){
            case 3:
                ig(b);
                de();
                break;
            case 5:
                xe(b);
                break;
            case 1:
                C(b.type) && nc(b);
                break;
            case 4:
                ve(b, b.stateNode.containerInfo);
                break;
            case 10:
                gd(b, b.type._context, b.memoizedProps.value);
                break;
            case 13:
                var d = b.memoizedState;
                if (null !== d) {
                    if (null !== d.dehydrated) return y(J, J.current & 1), b.flags |= 128, null;
                    if (0 !== (c & b.child.childLanes)) return mg(a, b, c);
                    y(J, J.current & 1);
                    a = Zf(a, b, c);
                    return null !== a ? a.sibling : null;
                }
                y(J, J.current & 1);
                break;
            case 19:
                d = 0 !== (c & b.childLanes);
                if (0 !== (a.flags & 128)) {
                    if (d) return vg(a, b, c);
                    b.flags |= 128;
                }
                var e = b.memoizedState;
                null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                y(J, J.current);
                if (d) break;
                else return null;
            case 22:
            case 23:
                return b.lanes = 0, dg(a, b, c);
        }
        return Zf(a, b, c);
    }
    function xg(a, b) {
        Sd(b);
        switch(b.tag){
            case 1:
                return C(b.type) && kc(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 3:
                return we(), x(B), x(A), Be(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
            case 5:
                return ye(b), null;
            case 13:
                x(J);
                a = b.memoizedState;
                if (null !== a && null !== a.dehydrated) {
                    if (null === b.alternate) throw Error(n(340));
                    de();
                }
                a = b.flags;
                return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 19:
                return x(J), null;
            case 4:
                return we(), null;
            case 10:
                return hd(b.type._context), null;
            case 22:
            case 23:
                return Vf(), null;
            case 24:
                return null;
            default:
                return null;
        }
    }
    var yg = !1, zg = !1, Ag = "function" === typeof WeakSet ? WeakSet : Set, S = null;
    function Bg(a, b) {
        var c = a.ref;
        if (null !== c) {
            if ("function" === typeof c) try {
                c(null);
            } catch (d) {
                T(a, b, d);
            }
            else c.current = null;
        }
    }
    function Cg(a, b, c) {
        try {
            c();
        } catch (d) {
            T(a, b, d);
        }
    }
    var Dg = !1;
    function Eg(a, b) {
        Ia(a.containerInfo);
        for(S = b; null !== S;)if (a = S, b = a.child, 0 !== (a.subtreeFlags & 1028) && null !== b) b.return = a, S = b;
        else for(; null !== S;){
            a = S;
            try {
                var c = a.alternate;
                if (0 !== (a.flags & 1024)) switch(a.tag){
                    case 0:
                    case 11:
                    case 15:
                        break;
                    case 1:
                        if (null !== c) {
                            var d = c.memoizedProps, e = c.memoizedState, f = a.stateNode, g = f.getSnapshotBeforeUpdate(a.elementType === a.type ? d : ad(a.type, d), e);
                            f.__reactInternalSnapshotBeforeUpdate = g;
                        }
                        break;
                    case 3:
                        Ua && xb(a.stateNode.containerInfo);
                        break;
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        break;
                    default:
                        throw Error(n(163));
                }
            } catch (h) {
                T(a, a.return, h);
            }
            b = a.sibling;
            if (null !== b) {
                b.return = a.return;
                S = b;
                break;
            }
            S = a.return;
        }
        c = Dg;
        Dg = !1;
        return c;
    }
    function Fg(a, b, c) {
        var d = b.updateQueue;
        d = null !== d ? d.lastEffect : null;
        if (null !== d) {
            var e = d = d.next;
            do {
                if ((e.tag & a) === a) {
                    var f = e.destroy;
                    e.destroy = void 0;
                    void 0 !== f && Cg(b, c, f);
                }
                e = e.next;
            }while (e !== d);
        }
    }
    function Gg(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
            var c = b = b.next;
            do {
                if ((c.tag & a) === a) {
                    var d = c.create;
                    c.destroy = d();
                }
                c = c.next;
            }while (c !== b);
        }
    }
    function Hg(a) {
        var b = a.ref;
        if (null !== b) {
            var c = a.stateNode;
            switch(a.tag){
                case 5:
                    a = Fa(c);
                    break;
                default:
                    a = c;
            }
            "function" === typeof b ? b(a) : b.current = a;
        }
    }
    function Ig(a, b, c) {
        if (Oc && "function" === typeof Oc.onCommitFiberUnmount) try {
            Oc.onCommitFiberUnmount(Nc, b);
        } catch (g) {}
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                a = b.updateQueue;
                if (null !== a && (a = a.lastEffect, null !== a)) {
                    var d = a = a.next;
                    do {
                        var e = d, f = e.destroy;
                        e = e.tag;
                        void 0 !== f && (0 !== (e & 2) ? Cg(b, c, f) : 0 !== (e & 4) && Cg(b, c, f));
                        d = d.next;
                    }while (d !== a);
                }
                break;
            case 1:
                Bg(b, c);
                a = b.stateNode;
                if ("function" === typeof a.componentWillUnmount) try {
                    a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
                } catch (g) {
                    T(b, c, g);
                }
                break;
            case 5:
                Bg(b, c);
                break;
            case 4:
                Ua ? Jg(a, b, c) : Va && Va && (b = b.stateNode.containerInfo, c = zb(b), Cb(b, c));
        }
    }
    function Kg(a, b, c) {
        for(var d = b;;)if (Ig(a, d, c), null === d.child || Ua && 4 === d.tag) {
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
            }
            d.sibling.return = d.return;
            d = d.sibling;
        } else d.child.return = d, d = d.child;
    }
    function Lg(a) {
        var b = a.alternate;
        null !== b && (a.alternate = null, Lg(b));
        a.child = null;
        a.deletions = null;
        a.sibling = null;
        5 === a.tag && (b = a.stateNode, null !== b && Za(b));
        a.stateNode = null;
        a.return = null;
        a.dependencies = null;
        a.memoizedProps = null;
        a.memoizedState = null;
        a.pendingProps = null;
        a.stateNode = null;
        a.updateQueue = null;
    }
    function Mg(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }
    function Ng(a) {
        a: for(;;){
            for(; null === a.sibling;){
                if (null === a.return || Mg(a.return)) return null;
                a = a.return;
            }
            a.sibling.return = a.return;
            for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
                if (a.flags & 2) continue a;
                if (null === a.child || 4 === a.tag) continue a;
                else a.child.return = a, a = a.child;
            }
            if (!(a.flags & 2)) return a.stateNode;
        }
    }
    function Og(a) {
        if (Ua) {
            a: {
                for(var b = a.return; null !== b;){
                    if (Mg(b)) break a;
                    b = b.return;
                }
                throw Error(n(160));
            }
            var c = b;
            switch(c.tag){
                case 5:
                    b = c.stateNode;
                    c.flags & 32 && (sb(b), c.flags &= -33);
                    c = Ng(a);
                    Pg(a, c, b);
                    break;
                case 3:
                case 4:
                    b = c.stateNode.containerInfo;
                    c = Ng(a);
                    Qg(a, c, b);
                    break;
                default:
                    throw Error(n(161));
            }
        }
    }
    function Qg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? pb(c, a, b) : kb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Qg(a, b, c), a = a.sibling; null !== a;)Qg(a, b, c), a = a.sibling;
    }
    function Pg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? ob(c, a, b) : jb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Pg(a, b, c), a = a.sibling; null !== a;)Pg(a, b, c), a = a.sibling;
    }
    function Jg(a, b, c) {
        for(var d = b, e = !1, f, g;;){
            if (!e) {
                e = d.return;
                a: for(;;){
                    if (null === e) throw Error(n(160));
                    f = e.stateNode;
                    switch(e.tag){
                        case 5:
                            g = !1;
                            break a;
                        case 3:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                        case 4:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                    }
                    e = e.return;
                }
                e = !0;
            }
            if (5 === d.tag || 6 === d.tag) Kg(a, d, c), g ? rb(f, d.stateNode) : qb(f, d.stateNode);
            else if (18 === d.tag) g ? Wb(f, d.stateNode) : Vb(f, d.stateNode);
            else if (4 === d.tag) {
                if (null !== d.child) {
                    f = d.stateNode.containerInfo;
                    g = !0;
                    d.child.return = d;
                    d = d.child;
                    continue;
                }
            } else if (Ig(a, d, c), null !== d.child) {
                d.child.return = d;
                d = d.child;
                continue;
            }
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
                4 === d.tag && (e = !1);
            }
            d.sibling.return = d.return;
            d = d.sibling;
        }
    }
    function Rg(a, b) {
        if (Ua) {
            switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    Fg(3, b, b.return);
                    Gg(3, b);
                    Fg(5, b, b.return);
                    return;
                case 1:
                    return;
                case 5:
                    var c = b.stateNode;
                    if (null != c) {
                        var d = b.memoizedProps;
                        a = null !== a ? a.memoizedProps : d;
                        var e = b.type, f = b.updateQueue;
                        b.updateQueue = null;
                        null !== f && nb(c, f, e, a, d, b);
                    }
                    return;
                case 6:
                    if (null === b.stateNode) throw Error(n(162));
                    c = b.memoizedProps;
                    lb(b.stateNode, null !== a ? a.memoizedProps : c, c);
                    return;
                case 3:
                    p && null !== a && a.memoizedState.isDehydrated && Tb(b.stateNode.containerInfo);
                    return;
                case 12:
                    return;
                case 13:
                    Sg(b);
                    return;
                case 19:
                    Sg(b);
                    return;
                case 17:
                    return;
            }
            throw Error(n(163));
        }
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                Fg(3, b, b.return);
                Gg(3, b);
                Fg(5, b, b.return);
                return;
            case 12:
                return;
            case 13:
                Sg(b);
                return;
            case 19:
                Sg(b);
                return;
            case 3:
                p && null !== a && a.memoizedState.isDehydrated && Tb(b.stateNode.containerInfo);
                break;
            case 22:
            case 23:
                return;
        }
        a: if (Va) {
            switch(b.tag){
                case 1:
                case 5:
                case 6:
                    break a;
                case 3:
                case 4:
                    b = b.stateNode;
                    Cb(b.containerInfo, b.pendingChildren);
                    break a;
            }
            throw Error(n(163));
        }
    }
    function Sg(a) {
        var b = a.updateQueue;
        if (null !== b) {
            a.updateQueue = null;
            var c = a.stateNode;
            null === c && (c = a.stateNode = new Ag);
            b.forEach(function(b) {
                var d = Tg.bind(null, a, b);
                c.has(b) || (c.add(b), b.then(d, d));
            });
        }
    }
    function Ug(a, b) {
        for(S = b; null !== S;){
            b = S;
            var c = b.deletions;
            if (null !== c) for(var d = 0; d < c.length; d++){
                var e = c[d];
                try {
                    var f = a;
                    Ua ? Jg(f, e, b) : Kg(f, e, b);
                    var g = e.alternate;
                    null !== g && (g.return = null);
                    e.return = null;
                } catch (wa) {
                    T(e, b, wa);
                }
            }
            c = b.child;
            if (0 !== (b.subtreeFlags & 12854) && null !== c) c.return = b, S = c;
            else for(; null !== S;){
                b = S;
                try {
                    var h = b.flags;
                    h & 32 && Ua && sb(b.stateNode);
                    if (h & 512) {
                        var k = b.alternate;
                        if (null !== k) {
                            var l = k.ref;
                            null !== l && ("function" === typeof l ? l(null) : l.current = null);
                        }
                    }
                    if (h & 8192) switch(b.tag){
                        case 13:
                            if (null !== b.memoizedState) {
                                var m = b.alternate;
                                if (null === m || null === m.memoizedState) Vg = E();
                            }
                            break;
                        case 22:
                            var v = null !== b.memoizedState, r = b.alternate, z = null !== r && null !== r.memoizedState;
                            c = b;
                            if (Ua) {
                                a: if (d = c, e = v, f = null, Ua) for(var q = d;;){
                                    if (5 === q.tag) {
                                        if (null === f) {
                                            f = q;
                                            var N = q.stateNode;
                                            e ? tb(N) : vb(q.stateNode, q.memoizedProps);
                                        }
                                    } else if (6 === q.tag) {
                                        if (null === f) {
                                            var da = q.stateNode;
                                            e ? ub(da) : wb(da, q.memoizedProps);
                                        }
                                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === d) && null !== q.child) {
                                        q.child.return = q;
                                        q = q.child;
                                        continue;
                                    }
                                    if (q === d) break;
                                    for(; null === q.sibling;){
                                        if (null === q.return || q.return === d) break a;
                                        f === q && (f = null);
                                        q = q.return;
                                    }
                                    f === q && (f = null);
                                    q.sibling.return = q.return;
                                    q = q.sibling;
                                }
                            }
                            if (v && !z && 0 !== (c.mode & 1)) {
                                S = c;
                                for(var t = c.child; null !== t;){
                                    for(c = S = t; null !== S;){
                                        d = S;
                                        var w = d.child;
                                        switch(d.tag){
                                            case 0:
                                            case 11:
                                            case 14:
                                            case 15:
                                                Fg(4, d, d.return);
                                                break;
                                            case 1:
                                                Bg(d, d.return);
                                                var u = d.stateNode;
                                                if ("function" === typeof u.componentWillUnmount) {
                                                    var V = d.return;
                                                    try {
                                                        u.props = d.memoizedProps, u.state = d.memoizedState, u.componentWillUnmount();
                                                    } catch (wa) {
                                                        T(d, V, wa);
                                                    }
                                                }
                                                break;
                                            case 5:
                                                Bg(d, d.return);
                                                break;
                                            case 22:
                                                if (null !== d.memoizedState) {
                                                    Wg(c);
                                                    continue;
                                                }
                                        }
                                        null !== w ? (w.return = d, S = w) : Wg(c);
                                    }
                                    t = t.sibling;
                                }
                            }
                    }
                    switch(h & 4102){
                        case 2:
                            Og(b);
                            b.flags &= -3;
                            break;
                        case 6:
                            Og(b);
                            b.flags &= -3;
                            Rg(b.alternate, b);
                            break;
                        case 4096:
                            b.flags &= -4097;
                            break;
                        case 4100:
                            b.flags &= -4097;
                            Rg(b.alternate, b);
                            break;
                        case 4:
                            Rg(b.alternate, b);
                    }
                } catch (wa) {
                    T(b, b.return, wa);
                }
                c = b.sibling;
                if (null !== c) {
                    c.return = b.return;
                    S = c;
                    break;
                }
                S = b.return;
            }
        }
    }
    function Xg(a, b, c) {
        S = a;
        Yg(a, b, c);
    }
    function Yg(a, b, c) {
        for(var d = 0 !== (a.mode & 1); null !== S;){
            var e = S, f = e.child;
            if (22 === e.tag && d) {
                var g = null !== e.memoizedState || yg;
                if (!g) {
                    var h = e.alternate, k = null !== h && null !== h.memoizedState || zg;
                    h = yg;
                    var l = zg;
                    yg = g;
                    if ((zg = k) && !l) for(S = e; null !== S;)g = S, k = g.child, 22 === g.tag && null !== g.memoizedState ? Zg(e) : null !== k ? (k.return = g, S = k) : Zg(e);
                    for(; null !== f;)S = f, Yg(f, b, c), f = f.sibling;
                    S = e;
                    yg = h;
                    zg = l;
                }
                $g(a, b, c);
            } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, S = f) : $g(a, b, c);
        }
    }
    function $g(a) {
        for(; null !== S;){
            var b = S;
            if (0 !== (b.flags & 8772)) {
                var c = b.alternate;
                try {
                    if (0 !== (b.flags & 8772)) switch(b.tag){
                        case 0:
                        case 11:
                        case 15:
                            zg || Gg(5, b);
                            break;
                        case 1:
                            var d = b.stateNode;
                            if (b.flags & 4 && !zg) {
                                if (null === c) d.componentDidMount();
                                else {
                                    var e = b.elementType === b.type ? c.memoizedProps : ad(b.type, c.memoizedProps);
                                    d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var f = b.updateQueue;
                            null !== f && wd(b, f, d);
                            break;
                        case 3:
                            var g = b.updateQueue;
                            if (null !== g) {
                                c = null;
                                if (null !== b.child) switch(b.child.tag){
                                    case 5:
                                        c = Fa(b.child.stateNode);
                                        break;
                                    case 1:
                                        c = b.child.stateNode;
                                }
                                wd(b, g, c);
                            }
                            break;
                        case 5:
                            var h = b.stateNode;
                            null === c && b.flags & 4 && mb(h, b.type, b.memoizedProps, b);
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            if (p && null === b.memoizedState) {
                                var k = b.alternate;
                                if (null !== k) {
                                    var l = k.memoizedState;
                                    if (null !== l) {
                                        var m = l.dehydrated;
                                        null !== m && Ub(m);
                                    }
                                }
                            }
                            break;
                        case 19:
                        case 17:
                        case 21:
                        case 22:
                        case 23:
                            break;
                        default:
                            throw Error(n(163));
                    }
                    zg || b.flags & 512 && Hg(b);
                } catch (v) {
                    T(b, b.return, v);
                }
            }
            if (b === a) {
                S = null;
                break;
            }
            c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                S = c;
                break;
            }
            S = b.return;
        }
    }
    function Wg(a) {
        for(; null !== S;){
            var b = S;
            if (b === a) {
                S = null;
                break;
            }
            var c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                S = c;
                break;
            }
            S = b.return;
        }
    }
    function Zg(a) {
        for(; null !== S;){
            var b = S;
            try {
                switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        var c = b.return;
                        try {
                            Gg(4, b);
                        } catch (k) {
                            T(b, c, k);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if ("function" === typeof d.componentDidMount) {
                            var e = b.return;
                            try {
                                d.componentDidMount();
                            } catch (k) {
                                T(b, e, k);
                            }
                        }
                        var f = b.return;
                        try {
                            Hg(b);
                        } catch (k) {
                            T(b, f, k);
                        }
                        break;
                    case 5:
                        var g = b.return;
                        try {
                            Hg(b);
                        } catch (k) {
                            T(b, g, k);
                        }
                }
            } catch (k) {
                T(b, b.return, k);
            }
            if (b === a) {
                S = null;
                break;
            }
            var h = b.sibling;
            if (null !== h) {
                h.return = b.return;
                S = h;
                break;
            }
            S = b.return;
        }
    }
    var ah = 0, bh = 1, ch = 2, dh = 3, eh = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var fh = Symbol.for;
        ah = fh("selector.component");
        bh = fh("selector.has_pseudo_class");
        ch = fh("selector.role");
        dh = fh("selector.test_id");
        eh = fh("selector.text");
    }
    function gh(a) {
        var b = Wa(a);
        if (null != b) {
            if ("string" !== typeof b.memoizedProps["data-testname"]) throw Error(n(364));
            return b;
        }
        a = cb(a);
        if (null === a) throw Error(n(362));
        return a.stateNode.current;
    }
    function hh(a, b) {
        switch(b.$$typeof){
            case ah:
                if (a.type === b.value) return !0;
                break;
            case bh:
                a: {
                    b = b.value;
                    a = [
                        a,
                        0
                    ];
                    for(var c = 0; c < a.length;){
                        var d = a[c++], e = a[c++], f = b[e];
                        if (5 !== d.tag || !fb(d)) {
                            for(; null != f && hh(d, f);)e++, f = b[e];
                            if (e === b.length) {
                                b = !0;
                                break a;
                            } else for(d = d.child; null !== d;)a.push(d, e), d = d.sibling;
                        }
                    }
                    b = !1;
                }
                return b;
            case ch:
                if (5 === a.tag && gb(a.stateNode, b.value)) return !0;
                break;
            case eh:
                if (5 === a.tag || 6 === a.tag) {
                    if (a = eb(a), null !== a && 0 <= a.indexOf(b.value)) return !0;
                }
                break;
            case dh:
                if (5 === a.tag && (a = a.memoizedProps["data-testname"], "string" === typeof a && a.toLowerCase() === b.value.toLowerCase())) return !0;
                break;
            default:
                throw Error(n(365));
        }
        return !1;
    }
    function ih(a) {
        switch(a.$$typeof){
            case ah:
                return "<" + (va(a.value) || "Unknown") + ">";
            case bh:
                return ":has(" + (ih(a) || "") + ")";
            case ch:
                return '[role="' + a.value + '"]';
            case eh:
                return '"' + a.value + '"';
            case dh:
                return '[data-testname="' + a.value + '"]';
            default:
                throw Error(n(365));
        }
    }
    function jh(a, b) {
        var c = [];
        a = [
            a,
            0
        ];
        for(var d = 0; d < a.length;){
            var e = a[d++], f = a[d++], g = b[f];
            if (5 !== e.tag || !fb(e)) {
                for(; null != g && hh(e, g);)f++, g = b[f];
                if (f === b.length) c.push(e);
                else for(e = e.child; null !== e;)a.push(e, f), e = e.sibling;
            }
        }
        return c;
    }
    function kh(a, b) {
        if (!bb) throw Error(n(363));
        a = gh(a);
        a = jh(a, b);
        b = [];
        a = Array.from(a);
        for(var c = 0; c < a.length;){
            var d = a[c++];
            if (5 === d.tag) fb(d) || b.push(d.stateNode);
            else for(d = d.child; null !== d;)a.push(d), d = d.sibling;
        }
        return b;
    }
    var lh = Math.ceil, mh = ea.ReactCurrentDispatcher, nh = ea.ReactCurrentOwner, U = ea.ReactCurrentBatchConfig, G = 0, F = null, W = null, X = 0, Wf = 0, eg = gc(0), Q = 0, oh = null, vd = 0, ph = 0, qh = 0, rh = null, Y = null, Vg = 0, Uf = Infinity;
    function sh() {
        Uf = E() + 500;
    }
    var Bf = !1, Cf = null, Ef = null, th = !1, uh = null, vh = 0, wh = 0, xh = null, yh = -1, zh = 0;
    function H() {
        return 0 !== (G & 6) ? E() : -1 !== yh ? yh : yh = E();
    }
    function zd(a) {
        if (0 === (a.mode & 1)) return 1;
        if (0 !== (G & 2) && 0 !== X) return X & -X;
        if (null !== Yc.transition) return 0 === zh && (a = tc, tc <<= 1, 0 === (tc & 4194240) && (tc = 64), zh = a), zh;
        a = D;
        return 0 !== a ? a : Ya();
    }
    function Ad(a, b, c) {
        if (50 < wh) throw wh = 0, xh = null, Error(n(185));
        var d = Ah(a, b);
        if (null === d) return null;
        Bc(d, b, c);
        if (0 === (G & 2) || d !== F) d === F && (0 === (G & 2) && (ph |= b), 4 === Q && Bh(d, X)), Z(d, c), 1 === b && 0 === G && 0 === (a.mode & 1) && (sh(), Tc && Xc());
        return d;
    }
    function Ah(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        c = a;
        for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
        return 3 === c.tag ? c.stateNode : null;
    }
    function Z(a, b) {
        var c = a.callbackNode;
        yc(a, b);
        var d = wc(a, a === F ? X : 0);
        if (0 === d) null !== c && Gc(c), a.callbackNode = null, a.callbackPriority = 0;
        else if (b = d & -d, a.callbackPriority !== b) {
            null != c && Gc(c);
            if (1 === b) 0 === a.tag ? Wc(Ch.bind(null, a)) : Vc(Ch.bind(null, a)), $a ? ab(function() {
                0 === G && Xc();
            }) : Fc(Jc, Xc), c = null;
            else {
                switch(Ec(d)){
                    case 1:
                        c = Jc;
                        break;
                    case 4:
                        c = Kc;
                        break;
                    case 16:
                        c = Lc;
                        break;
                    case 536870912:
                        c = Mc;
                        break;
                    default:
                        c = Lc;
                }
                c = Dh(c, Eh.bind(null, a));
            }
            a.callbackPriority = b;
            a.callbackNode = c;
        }
    }
    function Eh(a, b) {
        yh = -1;
        zh = 0;
        if (0 !== (G & 6)) throw Error(n(327));
        var c = a.callbackNode;
        if (Fh() && a.callbackNode !== c) return null;
        var d = wc(a, a === F ? X : 0);
        if (0 === d) return null;
        if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Gh(a, d);
        else {
            b = d;
            var e = G;
            G |= 2;
            var f = Hh();
            if (F !== a || X !== b) sh(), Ih(a, b);
            for(;;)try {
                Jh();
                break;
            } catch (h) {
                Kh(a, h);
            }
            fd();
            mh.current = f;
            G = e;
            null !== W ? b = 0 : (F = null, X = 0, b = Q);
        }
        if (0 !== b) {
            2 === b && (e = zc(a), 0 !== e && (d = e, b = Lh(a, e)));
            if (1 === b) throw c = oh, Ih(a, 0), Bh(a, d), Z(a, E()), c;
            if (6 === b) Bh(a, d);
            else {
                e = a.current.alternate;
                if (0 === (d & 30) && !Mh(e) && (b = Gh(a, d), 2 === b && (f = zc(a), 0 !== f && (d = f, b = Lh(a, f))), 1 === b)) throw c = oh, Ih(a, 0), Bh(a, d), Z(a, E()), c;
                a.finishedWork = e;
                a.finishedLanes = d;
                switch(b){
                    case 0:
                    case 1:
                        throw Error(n(345));
                    case 2:
                        Nh(a, Y);
                        break;
                    case 3:
                        Bh(a, d);
                        if ((d & 130023424) === d && (b = Vg + 500 - E(), 10 < b)) {
                            if (0 !== wc(a, 0)) break;
                            e = a.suspendedLanes;
                            if ((e & d) !== d) {
                                H();
                                a.pingedLanes |= a.suspendedLanes & e;
                                break;
                            }
                            a.timeoutHandle = Qa(Nh.bind(null, a, Y), b);
                            break;
                        }
                        Nh(a, Y);
                        break;
                    case 4:
                        Bh(a, d);
                        if ((d & 4194240) === d) break;
                        b = a.eventTimes;
                        for(e = -1; 0 < d;){
                            var g = 31 - qc(d);
                            f = 1 << g;
                            g = b[g];
                            g > e && (e = g);
                            d &= ~f;
                        }
                        d = e;
                        d = E() - d;
                        d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lh(d / 1960)) - d;
                        if (10 < d) {
                            a.timeoutHandle = Qa(Nh.bind(null, a, Y), d);
                            break;
                        }
                        Nh(a, Y);
                        break;
                    case 5:
                        Nh(a, Y);
                        break;
                    default:
                        throw Error(n(329));
                }
            }
        }
        Z(a, E());
        return a.callbackNode === c ? Eh.bind(null, a) : null;
    }
    function Lh(a, b) {
        var c = rh;
        a.current.memoizedState.isDehydrated && (Ih(a, b).flags |= 256);
        a = Gh(a, b);
        2 !== a && (b = Y, Y = c, null !== b && Sf(b));
        return a;
    }
    function Sf(a) {
        null === Y ? Y = a : Y.push.apply(Y, a);
    }
    function Mh(a) {
        for(var b = a;;){
            if (b.flags & 16384) {
                var c = b.updateQueue;
                if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                    var e = c[d], f = e.getSnapshot;
                    e = e.value;
                    try {
                        if (!Rc(f(), e)) return !1;
                    } catch (g) {
                        return !1;
                    }
                }
            }
            c = b.child;
            if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
            else {
                if (b === a) break;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) return !0;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return !0;
    }
    function Bh(a, b) {
        b &= ~qh;
        b &= ~ph;
        a.suspendedLanes |= b;
        a.pingedLanes &= ~b;
        for(a = a.expirationTimes; 0 < b;){
            var c = 31 - qc(b), d = 1 << c;
            a[c] = -1;
            b &= ~d;
        }
    }
    function Ch(a) {
        if (0 !== (G & 6)) throw Error(n(327));
        Fh();
        var b = wc(a, 0);
        if (0 === (b & 1)) return Z(a, E()), null;
        var c = Gh(a, b);
        if (0 !== a.tag && 2 === c) {
            var d = zc(a);
            0 !== d && (b = d, c = Lh(a, d));
        }
        if (1 === c) throw c = oh, Ih(a, 0), Bh(a, b), Z(a, E()), c;
        if (6 === c) throw Error(n(345));
        a.finishedWork = a.current.alternate;
        a.finishedLanes = b;
        Nh(a, Y);
        Z(a, E());
        return null;
    }
    function Oh(a) {
        null !== uh && 0 === uh.tag && 0 === (G & 6) && Fh();
        var b = G;
        G |= 1;
        var c = U.transition, d = D;
        try {
            if (U.transition = null, D = 1, a) return a();
        } finally{
            D = d, U.transition = c, G = b, 0 === (G & 6) && Xc();
        }
    }
    function Vf() {
        Wf = eg.current;
        x(eg);
    }
    function Ih(a, b) {
        a.finishedWork = null;
        a.finishedLanes = 0;
        var c = a.timeoutHandle;
        c !== Sa && (a.timeoutHandle = Sa, Ra(c));
        if (null !== W) for(c = W.return; null !== c;){
            var d = c;
            Sd(d);
            switch(d.tag){
                case 1:
                    d = d.type.childContextTypes;
                    null !== d && void 0 !== d && kc();
                    break;
                case 3:
                    we();
                    x(B);
                    x(A);
                    Be();
                    break;
                case 5:
                    ye(d);
                    break;
                case 4:
                    we();
                    break;
                case 13:
                    x(J);
                    break;
                case 19:
                    x(J);
                    break;
                case 10:
                    hd(d.type._context);
                    break;
                case 22:
                case 23:
                    Vf();
            }
            c = c.return;
        }
        F = a;
        W = a = je(a.current, null);
        X = Wf = b;
        Q = 0;
        oh = null;
        qh = ph = vd = 0;
        Y = rh = null;
        if (null !== md) {
            for(b = 0; b < md.length; b++)if (c = md[b], d = c.interleaved, null !== d) {
                c.interleaved = null;
                var e = d.next, f = c.pending;
                if (null !== f) {
                    var g = f.next;
                    f.next = e;
                    d.next = g;
                }
                c.pending = d;
            }
            md = null;
        }
        return a;
    }
    function Kh(a, b) {
        do {
            var c = W;
            try {
                fd();
                Ce.current = Oe;
                if (Fe) {
                    for(var d = K.memoizedState; null !== d;){
                        var e = d.queue;
                        null !== e && (e.pending = null);
                        d = d.next;
                    }
                    Fe = !1;
                }
                Ee = 0;
                M = L = K = null;
                Ge = !1;
                He = 0;
                nh.current = null;
                if (null === c || null === c.return) {
                    Q = 1;
                    oh = b;
                    W = null;
                    break;
                }
                a: {
                    var f = a, g = c.return, h = c, k = b;
                    b = X;
                    h.flags |= 32768;
                    if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                        var l = k, m = h, v = m.tag;
                        if (0 === (m.mode & 1) && (0 === v || 11 === v || 15 === v)) {
                            var r = m.alternate;
                            r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                        }
                        var z = Hf(g);
                        if (null !== z) {
                            z.flags &= -257;
                            If(z, g, h, f, b);
                            z.mode & 1 && Ff(f, l, b);
                            b = z;
                            k = l;
                            var q = b.updateQueue;
                            if (null === q) {
                                var N = new Set;
                                N.add(k);
                                b.updateQueue = N;
                            } else q.add(k);
                            break a;
                        } else {
                            if (0 === (b & 1)) {
                                Ff(f, l, b);
                                Tf();
                                break a;
                            }
                            k = Error(n(426));
                        }
                    } else if (I && h.mode & 1) {
                        var da = Hf(g);
                        if (null !== da) {
                            0 === (da.flags & 65536) && (da.flags |= 256);
                            If(da, g, h, f, b);
                            ee(k);
                            break a;
                        }
                    }
                    f = k;
                    4 !== Q && (Q = 2);
                    null === rh ? rh = [
                        f
                    ] : rh.push(f);
                    k = xf(k, h);
                    h = g;
                    do {
                        switch(h.tag){
                            case 3:
                                h.flags |= 65536;
                                b &= -b;
                                h.lanes |= b;
                                var t = Af(h, k, b);
                                td(h, t);
                                break a;
                            case 1:
                                f = k;
                                var w = h.type, u = h.stateNode;
                                if (0 === (h.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ef || !Ef.has(u)))) {
                                    h.flags |= 65536;
                                    b &= -b;
                                    h.lanes |= b;
                                    var V = Df(h, f, b);
                                    td(h, V);
                                    break a;
                                }
                        }
                        h = h.return;
                    }while (null !== h);
                }
                Ph(c);
            } catch (wa) {
                b = wa;
                W === c && null !== c && (W = c = c.return);
                continue;
            }
            break;
        }while (1);
    }
    function Hh() {
        var a = mh.current;
        mh.current = Oe;
        return null === a ? Oe : a;
    }
    function Tf() {
        if (0 === Q || 3 === Q || 2 === Q) Q = 4;
        null === F || 0 === (vd & 268435455) && 0 === (ph & 268435455) || Bh(F, X);
    }
    function Gh(a, b) {
        var c = G;
        G |= 2;
        var d = Hh();
        F === a && X === b || Ih(a, b);
        for(;;)try {
            Qh();
            break;
        } catch (e) {
            Kh(a, e);
        }
        fd();
        G = c;
        mh.current = d;
        if (null !== W) throw Error(n(261));
        F = null;
        X = 0;
        return Q;
    }
    function Qh() {
        for(; null !== W;)Rh(W);
    }
    function Jh() {
        for(; null !== W && !Hc();)Rh(W);
    }
    function Rh(a) {
        var b = Sh(a.alternate, a, Wf);
        a.memoizedProps = a.pendingProps;
        null === b ? Ph(a) : W = b;
        nh.current = null;
    }
    function Ph(a) {
        var b = a;
        do {
            var c = b.alternate;
            a = b.return;
            if (0 === (b.flags & 32768)) {
                if (c = Rf(c, b, Wf), null !== c) {
                    W = c;
                    return;
                }
            } else {
                c = xg(c, b);
                if (null !== c) {
                    c.flags &= 32767;
                    W = c;
                    return;
                }
                if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
                else {
                    Q = 6;
                    W = null;
                    return;
                }
            }
            b = b.sibling;
            if (null !== b) {
                W = b;
                return;
            }
            W = b = a;
        }while (null !== b);
        0 === Q && (Q = 5);
    }
    function Nh(a, b) {
        var c = D, d = U.transition;
        try {
            U.transition = null, D = 1, Th(a, b, c);
        } finally{
            U.transition = d, D = c;
        }
        return null;
    }
    function Th(a, b, c) {
        do Fh();
        while (null !== uh);
        if (0 !== (G & 6)) throw Error(n(327));
        var d = a.finishedWork, e = a.finishedLanes;
        if (null === d) return null;
        a.finishedWork = null;
        a.finishedLanes = 0;
        if (d === a.current) throw Error(n(177));
        a.callbackNode = null;
        a.callbackPriority = 0;
        var f = d.lanes | d.childLanes;
        Cc(a, f);
        a === F && (W = F = null, X = 0);
        0 === (d.subtreeFlags & 2064) && 0 === (d.flags & 2064) || th || (th = !0, Dh(Lc, function() {
            Fh();
            return null;
        }));
        f = 0 !== (d.flags & 15990);
        if (0 !== (d.subtreeFlags & 15990) || f) {
            f = U.transition;
            U.transition = null;
            var g = D;
            D = 1;
            var h = G;
            G |= 4;
            nh.current = null;
            Eg(a, d);
            Ug(a, d, e);
            Ja(a.containerInfo);
            a.current = d;
            Xg(d, a, e);
            Ic();
            G = h;
            D = g;
            U.transition = f;
        } else a.current = d;
        th && (th = !1, uh = a, vh = e);
        f = a.pendingLanes;
        0 === f && (Ef = null);
        Pc(d.stateNode, c);
        Z(a, E());
        if (null !== b) for(c = a.onRecoverableError, d = 0; d < b.length; d++)c(b[d]);
        if (Bf) throw Bf = !1, a = Cf, Cf = null, a;
        0 !== (vh & 1) && 0 !== a.tag && Fh();
        f = a.pendingLanes;
        0 !== (f & 1) ? a === xh ? wh++ : (wh = 0, xh = a) : wh = 0;
        Xc();
        return null;
    }
    function Fh() {
        if (null !== uh) {
            var a = Ec(vh), b = U.transition, c = D;
            try {
                U.transition = null;
                D = 16 > a ? 16 : a;
                if (null === uh) var d = !1;
                else {
                    a = uh;
                    uh = null;
                    vh = 0;
                    if (0 !== (G & 6)) throw Error(n(331));
                    var e = G;
                    G |= 4;
                    for(S = a.current; null !== S;){
                        var f = S, g = f.child;
                        if (0 !== (S.flags & 16)) {
                            var h = f.deletions;
                            if (null !== h) {
                                for(var k = 0; k < h.length; k++){
                                    var l = h[k];
                                    for(S = l; null !== S;){
                                        var m = S;
                                        switch(m.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                Fg(8, m, f);
                                        }
                                        var v = m.child;
                                        if (null !== v) v.return = m, S = v;
                                        else for(; null !== S;){
                                            m = S;
                                            var r = m.sibling, z = m.return;
                                            Lg(m);
                                            if (m === l) {
                                                S = null;
                                                break;
                                            }
                                            if (null !== r) {
                                                r.return = z;
                                                S = r;
                                                break;
                                            }
                                            S = z;
                                        }
                                    }
                                }
                                var q = f.alternate;
                                if (null !== q) {
                                    var N = q.child;
                                    if (null !== N) {
                                        q.child = null;
                                        do {
                                            var da = N.sibling;
                                            N.sibling = null;
                                            N = da;
                                        }while (null !== N);
                                    }
                                }
                                S = f;
                            }
                        }
                        if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, S = g;
                        else b: for(; null !== S;){
                            f = S;
                            if (0 !== (f.flags & 2048)) switch(f.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Fg(9, f, f.return);
                            }
                            var t = f.sibling;
                            if (null !== t) {
                                t.return = f.return;
                                S = t;
                                break b;
                            }
                            S = f.return;
                        }
                    }
                    var w = a.current;
                    for(S = w; null !== S;){
                        g = S;
                        var u = g.child;
                        if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, S = u;
                        else b: for(g = w; null !== S;){
                            h = S;
                            if (0 !== (h.flags & 2048)) try {
                                switch(h.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Gg(9, h);
                                }
                            } catch (wa) {
                                T(h, h.return, wa);
                            }
                            if (h === g) {
                                S = null;
                                break b;
                            }
                            var V = h.sibling;
                            if (null !== V) {
                                V.return = h.return;
                                S = V;
                                break b;
                            }
                            S = h.return;
                        }
                    }
                    G = e;
                    Xc();
                    if (Oc && "function" === typeof Oc.onPostCommitFiberRoot) try {
                        Oc.onPostCommitFiberRoot(Nc, a);
                    } catch (wa) {}
                    d = !0;
                }
                return d;
            } finally{
                D = c, U.transition = b;
            }
        }
        return !1;
    }
    function Uh(a, b, c) {
        b = xf(c, b);
        b = Af(a, b, 1);
        rd(a, b);
        b = H();
        a = Ah(a, 1);
        null !== a && (Bc(a, 1, b), Z(a, b));
    }
    function T(a, b, c) {
        if (3 === a.tag) Uh(a, a, c);
        else for(; null !== b;){
            if (3 === b.tag) {
                Uh(b, a, c);
                break;
            } else if (1 === b.tag) {
                var d = b.stateNode;
                if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ef || !Ef.has(d))) {
                    a = xf(c, a);
                    a = Df(b, a, 1);
                    rd(b, a);
                    a = H();
                    b = Ah(b, 1);
                    null !== b && (Bc(b, 1, a), Z(b, a));
                    break;
                }
            }
            b = b.return;
        }
    }
    function Gf(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        b = H();
        a.pingedLanes |= a.suspendedLanes & c;
        F === a && (X & c) === c && (4 === Q || 3 === Q && (X & 130023424) === X && 500 > E() - Vg ? Ih(a, 0) : qh |= c);
        Z(a, b);
    }
    function Vh(a, b) {
        0 === b && (0 === (a.mode & 1) ? b = 1 : (b = uc, uc <<= 1, 0 === (uc & 130023424) && (uc = 4194304)));
        var c = H();
        a = Ah(a, b);
        null !== a && (Bc(a, b, c), Z(a, c));
    }
    function qg(a) {
        var b = a.memoizedState, c = 0;
        null !== b && (c = b.retryLane);
        Vh(a, c);
    }
    function Tg(a, b) {
        var c = 0;
        switch(a.tag){
            case 13:
                var d = a.stateNode;
                var e = a.memoizedState;
                null !== e && (c = e.retryLane);
                break;
            case 19:
                d = a.stateNode;
                break;
            default:
                throw Error(n(314));
        }
        null !== d && d.delete(b);
        Vh(a, c);
    }
    var Sh;
    Sh = function(a, b, c) {
        if (null !== a) {
            if (a.memoizedProps !== b.pendingProps || B.current) kd = !0;
            else {
                if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return kd = !1, wg(a, b, c);
                kd = 0 !== (a.flags & 131072) ? !0 : !1;
            }
        } else kd = !1, I && 0 !== (b.flags & 1048576) && Qd(b, Jd, b.index);
        b.lanes = 0;
        switch(b.tag){
            case 2:
                var d = b.type;
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                var e = jc(b, A.current);
                jd(b, c);
                e = Ke(null, b, d, a, e, c);
                var f = Pe();
                b.flags |= 1;
                "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, C(d) ? (f = !0, nc(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, od(b), e.updater = Bd, b.stateNode = e, e._reactInternals = b, Fd(b, d, a, c), b = hg(null, b, d, !0, f, c)) : (b.tag = 0, I && f && Rd(b), R(null, b, e, c), b = b.child);
                return b;
            case 16:
                d = b.elementType;
                a: {
                    null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                    a = b.pendingProps;
                    e = d._init;
                    d = e(d._payload);
                    b.type = d;
                    e = b.tag = Wh(d);
                    a = ad(d, a);
                    switch(e){
                        case 0:
                            b = cg(null, b, d, a, c);
                            break a;
                        case 1:
                            b = gg(null, b, d, a, c);
                            break a;
                        case 11:
                            b = Yf(null, b, d, a, c);
                            break a;
                        case 14:
                            b = $f(null, b, d, ad(d.type, a), c);
                            break a;
                    }
                    throw Error(n(306, d, ""));
                }
                return b;
            case 0:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), cg(a, b, d, e, c);
            case 1:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), gg(a, b, d, e, c);
            case 3:
                a: {
                    ig(b);
                    if (null === a) throw Error(n(387));
                    d = b.pendingProps;
                    f = b.memoizedState;
                    e = f.element;
                    pd(a, b);
                    ud(b, d, null, c);
                    var g = b.memoizedState;
                    d = g.element;
                    if (p && f.isDehydrated) {
                        if (f = {
                            element: d,
                            isDehydrated: !1,
                            cache: g.cache,
                            transitions: g.transitions
                        }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                            e = Error(n(423));
                            b = jg(a, b, d, c, e);
                            break a;
                        } else if (d !== e) {
                            e = Error(n(424));
                            b = jg(a, b, d, c, e);
                            break a;
                        } else for(p && (Ud = Nb(b.stateNode.containerInfo), Td = b, I = !0, Wd = null, Vd = !1), c = pe(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                    } else {
                        de();
                        if (d === e) {
                            b = Zf(a, b, c);
                            break a;
                        }
                        R(a, b, d, c);
                    }
                    b = b.child;
                }
                return b;
            case 5:
                return xe(b), null === a && ae(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Oa(d, e) ? g = null : null !== f && Oa(d, f) && (b.flags |= 32), fg(a, b), R(a, b, g, c), b.child;
            case 6:
                return null === a && ae(b), null;
            case 13:
                return mg(a, b, c);
            case 4:
                return ve(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = oe(b, null, d, c) : R(a, b, d, c), b.child;
            case 11:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), Yf(a, b, d, e, c);
            case 7:
                return R(a, b, b.pendingProps, c), b.child;
            case 8:
                return R(a, b, b.pendingProps.children, c), b.child;
            case 12:
                return R(a, b, b.pendingProps.children, c), b.child;
            case 10:
                a: {
                    d = b.type._context;
                    e = b.pendingProps;
                    f = b.memoizedProps;
                    g = e.value;
                    gd(b, d, g);
                    if (null !== f) {
                        if (Rc(f.value, g)) {
                            if (f.children === e.children && !B.current) {
                                b = Zf(a, b, c);
                                break a;
                            }
                        } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                            var h = f.dependencies;
                            if (null !== h) {
                                g = f.child;
                                for(var k = h.firstContext; null !== k;){
                                    if (k.context === d) {
                                        if (1 === f.tag) {
                                            k = qd(-1, c & -c);
                                            k.tag = 2;
                                            var l = f.updateQueue;
                                            if (null !== l) {
                                                l = l.shared;
                                                var m = l.pending;
                                                null === m ? k.next = k : (k.next = m.next, m.next = k);
                                                l.pending = k;
                                            }
                                        }
                                        f.lanes |= c;
                                        k = f.alternate;
                                        null !== k && (k.lanes |= c);
                                        id(f.return, c, b);
                                        h.lanes |= c;
                                        break;
                                    }
                                    k = k.next;
                                }
                            } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                            else if (18 === f.tag) {
                                g = f.return;
                                if (null === g) throw Error(n(341));
                                g.lanes |= c;
                                h = g.alternate;
                                null !== h && (h.lanes |= c);
                                id(g, c, b);
                                g = f.sibling;
                            } else g = f.child;
                            if (null !== g) g.return = f;
                            else for(g = f; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                f = g.sibling;
                                if (null !== f) {
                                    f.return = g.return;
                                    g = f;
                                    break;
                                }
                                g = g.return;
                            }
                            f = g;
                        }
                    }
                    R(a, b, e.children, c);
                    b = b.child;
                }
                return b;
            case 9:
                return e = b.type, d = b.pendingProps.children, jd(b, c), e = ld(e), d = d(e), b.flags |= 1, R(a, b, d, c), b.child;
            case 14:
                return d = b.type, e = ad(d, b.pendingProps), e = ad(d.type, e), $f(a, b, d, e, c);
            case 15:
                return bg(a, b, b.type, b.pendingProps, c);
            case 17:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, C(d) ? (a = !0, nc(b)) : a = !1, jd(b, c), Dd(b, d, e), Fd(b, d, e, c), hg(null, b, d, !0, a, c);
            case 19:
                return vg(a, b, c);
            case 22:
                return dg(a, b, c);
        }
        throw Error(n(156, b.tag));
    };
    function Dh(a, b) {
        return Fc(a, b);
    }
    function Xh(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function Yd(a, b, c, d) {
        return new Xh(a, b, c, d);
    }
    function ag(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
    }
    function Wh(a) {
        if ("function" === typeof a) return ag(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
            a = a.$$typeof;
            if (a === na) return 11;
            if (a === qa) return 14;
        }
        return 2;
    }
    function je(a, b) {
        var c = a.alternate;
        null === c ? (c = Yd(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
        c.flags = a.flags & 14680064;
        c.childLanes = a.childLanes;
        c.lanes = a.lanes;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
            lanes: b.lanes,
            firstContext: b.firstContext
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
    }
    function le(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ("function" === typeof a) ag(a) && (g = 1);
        else if ("string" === typeof a) g = 5;
        else a: switch(a){
            case ia:
                return ne(c.children, e, f, b);
            case ja:
                g = 8;
                e |= 8;
                break;
            case ka:
                return a = Yd(12, c, b, e | 2), a.elementType = ka, a.lanes = f, a;
            case oa:
                return a = Yd(13, c, b, e), a.elementType = oa, a.lanes = f, a;
            case pa:
                return a = Yd(19, c, b, e), a.elementType = pa, a.lanes = f, a;
            case sa:
                return ng(c, e, f, b);
            default:
                if ("object" === typeof a && null !== a) switch(a.$$typeof){
                    case la:
                        g = 10;
                        break a;
                    case ma:
                        g = 9;
                        break a;
                    case na:
                        g = 11;
                        break a;
                    case qa:
                        g = 14;
                        break a;
                    case ra:
                        g = 16;
                        d = null;
                        break a;
                }
                throw Error(n(130, null == a ? a : typeof a, ""));
        }
        b = Yd(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.lanes = f;
        return b;
    }
    function ne(a, b, c, d) {
        a = Yd(7, a, d, b);
        a.lanes = c;
        return a;
    }
    function ng(a, b, c, d) {
        a = Yd(22, a, d, b);
        a.elementType = sa;
        a.lanes = c;
        a.stateNode = {};
        return a;
    }
    function ke(a, b, c) {
        a = Yd(6, a, null, b);
        a.lanes = c;
        return a;
    }
    function me(a, b, c) {
        b = Yd(4, null !== a.children ? a.children : [], a.key, b);
        b.lanes = c;
        b.stateNode = {
            containerInfo: a.containerInfo,
            pendingChildren: null,
            implementation: a.implementation
        };
        return b;
    }
    function Yh(a, b, c, d, e) {
        this.tag = b;
        this.containerInfo = a;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = Sa;
        this.callbackNode = this.pendingContext = this.context = null;
        this.callbackPriority = 0;
        this.eventTimes = Ac(0);
        this.expirationTimes = Ac(-1);
        this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = Ac(0);
        this.identifierPrefix = d;
        this.onRecoverableError = e;
        p && (this.mutableSourceEagerHydrationData = null);
    }
    function Zh(a, b, c, d, e, f, g, h, k) {
        a = new Yh(a, b, c, h, k);
        1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
        f = Yd(3, null, null, b);
        a.current = f;
        f.stateNode = a;
        f.memoizedState = {
            element: d,
            isDehydrated: c,
            cache: null,
            transitions: null
        };
        od(f);
        return a;
    }
    function $h(a) {
        if (!a) return hc;
        a = a._reactInternals;
        a: {
            if (ya(a) !== a || 1 !== a.tag) throw Error(n(170));
            var b = a;
            do {
                switch(b.tag){
                    case 3:
                        b = b.stateNode.context;
                        break a;
                    case 1:
                        if (C(b.type)) {
                            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                            break a;
                        }
                }
                b = b.return;
            }while (null !== b);
            throw Error(n(171));
        }
        if (1 === a.tag) {
            var c = a.type;
            if (C(c)) return mc(a, c, b);
        }
        return b;
    }
    function ai(a) {
        var b = a._reactInternals;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error(n(188));
            a = Object.keys(a).join(",");
            throw Error(n(268, a));
        }
        a = Ba(b);
        return null === a ? null : a.stateNode;
    }
    function bi(a, b) {
        a = a.memoizedState;
        if (null !== a && null !== a.dehydrated) {
            var c = a.retryLane;
            a.retryLane = 0 !== c && c < b ? c : b;
        }
    }
    function ci(a, b) {
        bi(a, b);
        (a = a.alternate) && bi(a, b);
    }
    function di(a) {
        a = Ba(a);
        return null === a ? null : a.stateNode;
    }
    function ei() {
        return null;
    }
    exports.attemptContinuousHydration = function(a) {
        if (13 === a.tag) {
            var b = H();
            Ad(a, 134217728, b);
            ci(a, 134217728);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(a) {
        if (13 === a.tag) {
            var b = H(), c = zd(a);
            Ad(a, c, b);
            ci(a, c);
        }
    };
    exports.attemptSynchronousHydration = function(a) {
        switch(a.tag){
            case 3:
                var b = a.stateNode;
                if (b.current.memoizedState.isDehydrated) {
                    var c = vc(b.pendingLanes);
                    0 !== c && (Dc(b, c | 1), Z(b, E()), 0 === (G & 6) && (sh(), Xc()));
                }
                break;
            case 13:
                var d = H();
                Oh(function() {
                    return Ad(a, 1, d);
                });
                ci(a, 1);
        }
    };
    exports.batchedUpdates = function(a, b) {
        var c = G;
        G |= 1;
        try {
            return a(b);
        } finally{
            G = c, 0 === G && (sh(), Tc && Xc());
        }
    };
    exports.createComponentSelector = function(a) {
        return {
            $$typeof: ah,
            value: a
        };
    };
    exports.createContainer = function(a, b, c, d, e, f, g) {
        return Zh(a, b, !1, null, c, d, e, f, g);
    };
    exports.createHasPseudoClassSelector = function(a) {
        return {
            $$typeof: bh,
            value: a
        };
    };
    exports.createHydrationContainer = function(a, b, c, d, e, f, g, h, k) {
        a = Zh(c, d, !0, a, e, f, g, h, k);
        a.context = $h(null);
        c = a.current;
        d = H();
        e = zd(c);
        f = qd(d, e);
        f.callback = void 0 !== b && null !== b ? b : null;
        rd(c, f);
        a.current.lanes = e;
        Bc(a, e, d);
        Z(a, d);
        return a;
    };
    exports.createPortal = function(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: ha,
            key: null == d ? null : "" + d,
            children: a,
            containerInfo: b,
            implementation: c
        };
    };
    exports.createRoleSelector = function(a) {
        return {
            $$typeof: ch,
            value: a
        };
    };
    exports.createTestNameSelector = function(a) {
        return {
            $$typeof: dh,
            value: a
        };
    };
    exports.createTextSelector = function(a) {
        return {
            $$typeof: eh,
            value: a
        };
    };
    exports.deferredUpdates = function(a) {
        var b = D, c = U.transition;
        try {
            return U.transition = null, D = 16, a();
        } finally{
            D = b, U.transition = c;
        }
    };
    exports.discreteUpdates = function(a, b, c, d, e) {
        var f = D, g = U.transition;
        try {
            return U.transition = null, D = 1, a(b, c, d, e);
        } finally{
            D = f, U.transition = g, 0 === G && sh();
        }
    };
    exports.findAllNodes = kh;
    exports.findBoundingRects = function(a, b) {
        if (!bb) throw Error(n(363));
        b = kh(a, b);
        a = [];
        for(var c = 0; c < b.length; c++)a.push(db(b[c]));
        for(b = a.length - 1; 0 < b; b--){
            c = a[b];
            for(var d = c.x, e = d + c.width, f = c.y, g = f + c.height, h = b - 1; 0 <= h; h--)if (b !== h) {
                var k = a[h], l = k.x, m = l + k.width, v = k.y, r = v + k.height;
                if (d >= l && f >= v && e <= m && g <= r) {
                    a.splice(b, 1);
                    break;
                } else if (!(d !== l || c.width !== k.width || r < f || v > g)) {
                    v > f && (k.height += v - f, k.y = f);
                    r < g && (k.height = g - v);
                    a.splice(b, 1);
                    break;
                } else if (!(f !== v || c.height !== k.height || m < d || l > e)) {
                    l > d && (k.width += l - d, k.x = d);
                    m < e && (k.width = e - l);
                    a.splice(b, 1);
                    break;
                }
            }
        }
        return a;
    };
    exports.findHostInstance = ai;
    exports.findHostInstanceWithNoPortals = function(a) {
        a = Aa(a);
        a = null !== a ? Da(a) : null;
        return null === a ? null : a.stateNode;
    };
    exports.findHostInstanceWithWarning = function(a) {
        return ai(a);
    };
    exports.flushControlled = function(a) {
        var b = G;
        G |= 1;
        var c = U.transition, d = D;
        try {
            U.transition = null, D = 1, a();
        } finally{
            D = d, U.transition = c, G = b, 0 === G && (sh(), Xc());
        }
    };
    exports.flushPassiveEffects = Fh;
    exports.flushSync = Oh;
    exports.focusWithin = function(a, b) {
        if (!bb) throw Error(n(363));
        a = gh(a);
        b = jh(a, b);
        b = Array.from(b);
        for(a = 0; a < b.length;){
            var c = b[a++];
            if (!fb(c)) {
                if (5 === c.tag && hb(c.stateNode)) return !0;
                for(c = c.child; null !== c;)b.push(c), c = c.sibling;
            }
        }
        return !1;
    };
    exports.getCurrentUpdatePriority = function() {
        return D;
    };
    exports.getFindAllNodesFailureDescription = function(a, b) {
        if (!bb) throw Error(n(363));
        var c = 0, d = [];
        a = [
            gh(a),
            0
        ];
        for(var e = 0; e < a.length;){
            var f = a[e++], g = a[e++], h = b[g];
            if (5 !== f.tag || !fb(f)) {
                if (hh(f, h) && (d.push(ih(h)), g++, g > c && (c = g)), g < b.length) for(f = f.child; null !== f;)a.push(f, g), f = f.sibling;
            }
        }
        if (c < b.length) {
            for(a = []; c < b.length; c++)a.push(ih(b[c]));
            return "findAllNodes was able to match part of the selector:\n  " + (d.join(" > ") + "\n\nNo matching component was found for:\n  ") + a.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(a) {
        a = a.current;
        if (!a.child) return null;
        switch(a.child.tag){
            case 5:
                return Fa(a.child.stateNode);
            default:
                return a.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function(a) {
        a = {
            bundleType: a.bundleType,
            version: a.version,
            rendererPackageName: a.rendererPackageName,
            rendererConfig: a.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: ea.ReactCurrentDispatcher,
            findHostInstanceByFiber: di,
            findFiberByHostInstance: a.findFiberByHostInstance || ei,
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.0.0-fc46dba67-20220329"
        };
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) a = !1;
        else {
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (b.isDisabled || !b.supportsFiber) a = !0;
            else {
                try {
                    Nc = b.inject(a), Oc = b;
                } catch (c) {}
                a = b.checkDCE ? !0 : !1;
            }
        }
        return a;
    };
    exports.isAlreadyRendering = function() {
        return !1;
    };
    exports.observeVisibleRects = function(a, b, c, d) {
        if (!bb) throw Error(n(363));
        a = kh(a, b);
        var e = ib(a, c, d).disconnect;
        return {
            disconnect: function() {
                e();
            }
        };
    };
    exports.registerMutableSourceForHydration = function(a, b) {
        var c = b._getVersion;
        c = c(b._source);
        null == a.mutableSourceEagerHydrationData ? a.mutableSourceEagerHydrationData = [
            b,
            c
        ] : a.mutableSourceEagerHydrationData.push(b, c);
    };
    exports.runWithPriority = function(a, b) {
        var c = D;
        try {
            return D = a, b();
        } finally{
            D = c;
        }
    };
    exports.shouldError = function() {
        return null;
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.updateContainer = function(a, b, c, d) {
        var e = b.current, f = H(), g = zd(e);
        c = $h(c);
        null === b.context ? b.context = c : b.pendingContext = c;
        b = qd(f, g);
        b.payload = {
            element: a
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        rd(e, b);
        a = Ad(e, g, f);
        null !== a && sd(a, e, g);
        return g;
    };
    return exports;
};

});
parcelRegister("axy3F", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lUgwH"));

});
parcelRegister("lUgwH", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $ff2ba5be39a5d650$export$c4744153514ff05d, (v) => $ff2ba5be39a5d650$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $ff2ba5be39a5d650$export$3e506c1ccc9cc1a7, (v) => $ff2ba5be39a5d650$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $ff2ba5be39a5d650$export$e26fe2ed2fa76875, (v) => $ff2ba5be39a5d650$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $ff2ba5be39a5d650$export$502329bbf4b505b1, (v) => $ff2ba5be39a5d650$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $ff2ba5be39a5d650$export$6e3807111c4874c4, (v) => $ff2ba5be39a5d650$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $ff2ba5be39a5d650$export$c27134553091fb3a, (v) => $ff2ba5be39a5d650$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $ff2ba5be39a5d650$export$33ee1acdc04fd2a2, (v) => $ff2ba5be39a5d650$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $ff2ba5be39a5d650$export$b00a404bbd5edef2, (v) => $ff2ba5be39a5d650$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $ff2ba5be39a5d650$export$8352ce38b91d0c62, (v) => $ff2ba5be39a5d650$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $ff2ba5be39a5d650$export$d66a1c1c77bd778b, (v) => $ff2ba5be39a5d650$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $ff2ba5be39a5d650$export$d3dfb8e4810cb555, (v) => $ff2ba5be39a5d650$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $ff2ba5be39a5d650$export$839f9183b0465a69, (v) => $ff2ba5be39a5d650$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $ff2ba5be39a5d650$export$72fdf0e06517287b, (v) => $ff2ba5be39a5d650$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $ff2ba5be39a5d650$export$4b844e58a3e414b4, (v) => $ff2ba5be39a5d650$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $ff2ba5be39a5d650$export$816d2913ae6b83b1, (v) => $ff2ba5be39a5d650$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $ff2ba5be39a5d650$export$61bcfe829111a1d0, (v) => $ff2ba5be39a5d650$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $ff2ba5be39a5d650$export$7ee8c9beb337bc3f, (v) => $ff2ba5be39a5d650$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $ff2ba5be39a5d650$export$b5836b71941fa3ed, (v) => $ff2ba5be39a5d650$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $ff2ba5be39a5d650$export$cf845f2c119da08a, (v) => $ff2ba5be39a5d650$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ff2ba5be39a5d650$export$c4744153514ff05d;
var $ff2ba5be39a5d650$export$3e506c1ccc9cc1a7;
var $ff2ba5be39a5d650$export$e26fe2ed2fa76875;
var $ff2ba5be39a5d650$export$502329bbf4b505b1;
var $ff2ba5be39a5d650$export$6e3807111c4874c4;
var $ff2ba5be39a5d650$export$c27134553091fb3a;
var $ff2ba5be39a5d650$export$33ee1acdc04fd2a2;
var $ff2ba5be39a5d650$export$b00a404bbd5edef2;
var $ff2ba5be39a5d650$export$8352ce38b91d0c62;
var $ff2ba5be39a5d650$export$d66a1c1c77bd778b;
var $ff2ba5be39a5d650$export$d3dfb8e4810cb555;
var $ff2ba5be39a5d650$export$839f9183b0465a69;
var $ff2ba5be39a5d650$export$72fdf0e06517287b;
var $ff2ba5be39a5d650$export$4b844e58a3e414b4;
var $ff2ba5be39a5d650$export$816d2913ae6b83b1;
var $ff2ba5be39a5d650$export$61bcfe829111a1d0;
var $ff2ba5be39a5d650$export$7ee8c9beb337bc3f;
var $ff2ba5be39a5d650$export$b5836b71941fa3ed;
var $ff2ba5be39a5d650$export$cf845f2c119da08a;
'use strict';
function $ff2ba5be39a5d650$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $ff2ba5be39a5d650$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ff2ba5be39a5d650$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $ff2ba5be39a5d650$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $ff2ba5be39a5d650$var$g(C, c)) n < e && 0 > $ff2ba5be39a5d650$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $ff2ba5be39a5d650$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $ff2ba5be39a5d650$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ff2ba5be39a5d650$var$l = performance;
    $ff2ba5be39a5d650$export$c4744153514ff05d = function() {
        return $ff2ba5be39a5d650$var$l.now();
    };
} else {
    var $ff2ba5be39a5d650$var$p = Date, $ff2ba5be39a5d650$var$q = $ff2ba5be39a5d650$var$p.now();
    $ff2ba5be39a5d650$export$c4744153514ff05d = function() {
        return $ff2ba5be39a5d650$var$p.now() - $ff2ba5be39a5d650$var$q;
    };
}
var $ff2ba5be39a5d650$var$r = [], $ff2ba5be39a5d650$var$t = [], $ff2ba5be39a5d650$var$u = 1, $ff2ba5be39a5d650$var$v = null, $ff2ba5be39a5d650$var$y = 3, $ff2ba5be39a5d650$var$z = !1, $ff2ba5be39a5d650$var$A = !1, $ff2ba5be39a5d650$var$B = !1, $ff2ba5be39a5d650$var$D = "function" === typeof setTimeout ? setTimeout : null, $ff2ba5be39a5d650$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $ff2ba5be39a5d650$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $ff2ba5be39a5d650$var$G(a) {
    for(var b = $ff2ba5be39a5d650$var$h($ff2ba5be39a5d650$var$t); null !== b;){
        if (null === b.callback) $ff2ba5be39a5d650$var$k($ff2ba5be39a5d650$var$t);
        else if (b.startTime <= a) $ff2ba5be39a5d650$var$k($ff2ba5be39a5d650$var$t), b.sortIndex = b.expirationTime, $ff2ba5be39a5d650$var$f($ff2ba5be39a5d650$var$r, b);
        else break;
        b = $ff2ba5be39a5d650$var$h($ff2ba5be39a5d650$var$t);
    }
}
function $ff2ba5be39a5d650$var$H(a) {
    $ff2ba5be39a5d650$var$B = !1;
    $ff2ba5be39a5d650$var$G(a);
    if (!$ff2ba5be39a5d650$var$A) {
        if (null !== $ff2ba5be39a5d650$var$h($ff2ba5be39a5d650$var$r)) $ff2ba5be39a5d650$var$A = !0, $ff2ba5be39a5d650$var$I($ff2ba5be39a5d650$var$J);
        else {
            var b = $ff2ba5be39a5d650$var$h($ff2ba5be39a5d650$var$t);
            null !== b && $ff2ba5be39a5d650$var$K($ff2ba5be39a5d650$var$H, b.startTime - a);
        }
    }
}
function $ff2ba5be39a5d650$var$J(a, b) {
    $ff2ba5be39a5d650$var$A = !1;
    $ff2ba5be39a5d650$var$B && ($ff2ba5be39a5d650$var$B = !1, $ff2ba5be39a5d650$var$E($ff2ba5be39a5d650$var$L), $ff2ba5be39a5d650$var$L = -1);
    $ff2ba5be39a5d650$var$z = !0;
    var c = $ff2ba5be39a5d650$var$y;
    try {
        $ff2ba5be39a5d650$var$G(b);
        for($ff2ba5be39a5d650$var$v = $ff2ba5be39a5d650$var$h($ff2ba5be39a5d650$var$r); null !== $ff2ba5be39a5d650$var$v && (!($ff2ba5be39a5d650$var$v.expirationTime > b) || a && !$ff2ba5be39a5d650$var$M());){
            var d = $ff2ba5be39a5d650$var$v.callback;
            if ("function" === typeof d) {
                $ff2ba5be39a5d650$var$v.callback = null;
                $ff2ba5be39a5d650$var$y = $ff2ba5be39a5d650$var$v.priorityLevel;
                var e = d($ff2ba5be39a5d650$var$v.expirationTime <= b);
                b = $ff2ba5be39a5d650$export$c4744153514ff05d();
                "function" === typeof e ? $ff2ba5be39a5d650$var$v.callback = e : $ff2ba5be39a5d650$var$v === $ff2ba5be39a5d650$var$h($ff2ba5be39a5d650$var$r) && $ff2ba5be39a5d650$var$k($ff2ba5be39a5d650$var$r);
                $ff2ba5be39a5d650$var$G(b);
            } else $ff2ba5be39a5d650$var$k($ff2ba5be39a5d650$var$r);
            $ff2ba5be39a5d650$var$v = $ff2ba5be39a5d650$var$h($ff2ba5be39a5d650$var$r);
        }
        if (null !== $ff2ba5be39a5d650$var$v) var w = !0;
        else {
            var m = $ff2ba5be39a5d650$var$h($ff2ba5be39a5d650$var$t);
            null !== m && $ff2ba5be39a5d650$var$K($ff2ba5be39a5d650$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $ff2ba5be39a5d650$var$v = null, $ff2ba5be39a5d650$var$y = c, $ff2ba5be39a5d650$var$z = !1;
    }
}
var $ff2ba5be39a5d650$var$N = !1, $ff2ba5be39a5d650$var$O = null, $ff2ba5be39a5d650$var$L = -1, $ff2ba5be39a5d650$var$P = 5, $ff2ba5be39a5d650$var$Q = -1;
function $ff2ba5be39a5d650$var$M() {
    return $ff2ba5be39a5d650$export$c4744153514ff05d() - $ff2ba5be39a5d650$var$Q < $ff2ba5be39a5d650$var$P ? !1 : !0;
}
function $ff2ba5be39a5d650$var$R() {
    if (null !== $ff2ba5be39a5d650$var$O) {
        var a = $ff2ba5be39a5d650$export$c4744153514ff05d();
        $ff2ba5be39a5d650$var$Q = a;
        var b = !0;
        try {
            b = $ff2ba5be39a5d650$var$O(!0, a);
        } finally{
            b ? $ff2ba5be39a5d650$var$S() : ($ff2ba5be39a5d650$var$N = !1, $ff2ba5be39a5d650$var$O = null);
        }
    } else $ff2ba5be39a5d650$var$N = !1;
}
var $ff2ba5be39a5d650$var$S;
if ("function" === typeof $ff2ba5be39a5d650$var$F) $ff2ba5be39a5d650$var$S = function() {
    $ff2ba5be39a5d650$var$F($ff2ba5be39a5d650$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ff2ba5be39a5d650$var$T = new MessageChannel, $ff2ba5be39a5d650$var$U = $ff2ba5be39a5d650$var$T.port2;
    $ff2ba5be39a5d650$var$T.port1.onmessage = $ff2ba5be39a5d650$var$R;
    $ff2ba5be39a5d650$var$S = function() {
        $ff2ba5be39a5d650$var$U.postMessage(null);
    };
} else $ff2ba5be39a5d650$var$S = function() {
    $ff2ba5be39a5d650$var$D($ff2ba5be39a5d650$var$R, 0);
};
function $ff2ba5be39a5d650$var$I(a) {
    $ff2ba5be39a5d650$var$O = a;
    $ff2ba5be39a5d650$var$N || ($ff2ba5be39a5d650$var$N = !0, $ff2ba5be39a5d650$var$S());
}
function $ff2ba5be39a5d650$var$K(a, b) {
    $ff2ba5be39a5d650$var$L = $ff2ba5be39a5d650$var$D(function() {
        a($ff2ba5be39a5d650$export$c4744153514ff05d());
    }, b);
}
$ff2ba5be39a5d650$export$3e506c1ccc9cc1a7 = 5;
$ff2ba5be39a5d650$export$e26fe2ed2fa76875 = 1;
$ff2ba5be39a5d650$export$502329bbf4b505b1 = 4;
$ff2ba5be39a5d650$export$6e3807111c4874c4 = 3;
$ff2ba5be39a5d650$export$c27134553091fb3a = null;
$ff2ba5be39a5d650$export$33ee1acdc04fd2a2 = 2;
$ff2ba5be39a5d650$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ff2ba5be39a5d650$export$8352ce38b91d0c62 = function() {
    $ff2ba5be39a5d650$var$A || $ff2ba5be39a5d650$var$z || ($ff2ba5be39a5d650$var$A = !0, $ff2ba5be39a5d650$var$I($ff2ba5be39a5d650$var$J));
};
$ff2ba5be39a5d650$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ff2ba5be39a5d650$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$ff2ba5be39a5d650$export$d3dfb8e4810cb555 = function() {
    return $ff2ba5be39a5d650$var$y;
};
$ff2ba5be39a5d650$export$839f9183b0465a69 = function() {
    return $ff2ba5be39a5d650$var$h($ff2ba5be39a5d650$var$r);
};
$ff2ba5be39a5d650$export$72fdf0e06517287b = function(a) {
    switch($ff2ba5be39a5d650$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ff2ba5be39a5d650$var$y;
    }
    var c = $ff2ba5be39a5d650$var$y;
    $ff2ba5be39a5d650$var$y = b;
    try {
        return a();
    } finally{
        $ff2ba5be39a5d650$var$y = c;
    }
};
$ff2ba5be39a5d650$export$4b844e58a3e414b4 = function() {};
$ff2ba5be39a5d650$export$816d2913ae6b83b1 = function() {};
$ff2ba5be39a5d650$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ff2ba5be39a5d650$var$y;
    $ff2ba5be39a5d650$var$y = a;
    try {
        return b();
    } finally{
        $ff2ba5be39a5d650$var$y = c;
    }
};
$ff2ba5be39a5d650$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ff2ba5be39a5d650$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $ff2ba5be39a5d650$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $ff2ba5be39a5d650$var$f($ff2ba5be39a5d650$var$t, a), null === $ff2ba5be39a5d650$var$h($ff2ba5be39a5d650$var$r) && a === $ff2ba5be39a5d650$var$h($ff2ba5be39a5d650$var$t) && ($ff2ba5be39a5d650$var$B ? ($ff2ba5be39a5d650$var$E($ff2ba5be39a5d650$var$L), $ff2ba5be39a5d650$var$L = -1) : $ff2ba5be39a5d650$var$B = !0, $ff2ba5be39a5d650$var$K($ff2ba5be39a5d650$var$H, c - d))) : (a.sortIndex = e, $ff2ba5be39a5d650$var$f($ff2ba5be39a5d650$var$r, a), $ff2ba5be39a5d650$var$A || $ff2ba5be39a5d650$var$z || ($ff2ba5be39a5d650$var$A = !0, $ff2ba5be39a5d650$var$I($ff2ba5be39a5d650$var$J)));
    return a;
};
$ff2ba5be39a5d650$export$b5836b71941fa3ed = $ff2ba5be39a5d650$var$M;
$ff2ba5be39a5d650$export$cf845f2c119da08a = function(a) {
    var b = $ff2ba5be39a5d650$var$y;
    return function() {
        var c = $ff2ba5be39a5d650$var$y;
        $ff2ba5be39a5d650$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ff2ba5be39a5d650$var$y = c;
        }
    };
};

});






parcelRegister("c4Vvr", function(module, exports) {

$parcel$export(module.exports, "CameraControls", () => $8cb27747bfd3a995$export$9f7b01b6c21c3faf);

var $d65Jq = parcelRequire("d65Jq");

var $329ek = parcelRequire("329ek");parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("3gAAP");
var $9sE5i = parcelRequire("9sE5i");
var $9sE5i = parcelRequire("9sE5i");

var $fynI5 = parcelRequire("fynI5");
const $8cb27747bfd3a995$export$9f7b01b6c21c3faf = /* @__PURE__ */ (0, $bxRTa.forwardRef)((props, ref)=>{
    // useMemo is used here instead of useEffect, otherwise the useMemo below runs first and throws
    (0, $bxRTa.useMemo)(()=>{
        // to allow for tree shaking, we only import the subset of THREE that is used by camera-controls
        // see https://github.com/yomotsu/camera-controls#important
        const subsetOfTHREE = {
            Box3: $329ek.Box3,
            MathUtils: {
                clamp: (0, $329ek.MathUtils).clamp
            },
            Matrix4: $329ek.Matrix4,
            Quaternion: $329ek.Quaternion,
            Raycaster: $329ek.Raycaster,
            Sphere: $329ek.Sphere,
            Spherical: $329ek.Spherical,
            Vector2: $329ek.Vector2,
            Vector3: $329ek.Vector3,
            Vector4: $329ek.Vector4
        };
        (0, $fynI5.default).install({
            THREE: subsetOfTHREE
        });
        (0, $9sE5i.e)({
            CameraControlsImpl: $fynI5.default
        });
    }, []);
    const { camera: camera, domElement: domElement, makeDefault: makeDefault, onStart: onStart, onEnd: onEnd, onChange: onChange, regress: regress, ...restProps } = props;
    const defaultCamera = (0, $9sE5i.D)((state)=>state.camera);
    const gl = (0, $9sE5i.D)((state)=>state.gl);
    const invalidate = (0, $9sE5i.D)((state)=>state.invalidate);
    const events = (0, $9sE5i.D)((state)=>state.events);
    const setEvents = (0, $9sE5i.D)((state)=>state.setEvents);
    const set = (0, $9sE5i.D)((state)=>state.set);
    const get = (0, $9sE5i.D)((state)=>state.get);
    const performance = (0, $9sE5i.D)((state)=>state.performance);
    const explCamera = camera || defaultCamera;
    const explDomElement = domElement || events.connected || gl.domElement;
    const controls = (0, $bxRTa.useMemo)(()=>new (0, $fynI5.default)(explCamera), [
        explCamera
    ]);
    (0, $9sE5i.F)((state, delta)=>{
        if (controls.enabled) controls.update(delta);
    }, -1);
    (0, $bxRTa.useEffect)(()=>{
        controls.connect(explDomElement);
        return ()=>void controls.disconnect();
    }, [
        explDomElement,
        controls
    ]);
    (0, $bxRTa.useEffect)(()=>{
        const callback = (e)=>{
            invalidate();
            if (regress) performance.regress();
            if (onChange) onChange(e);
        };
        const onStartCb = (e)=>{
            if (onStart) onStart(e);
        };
        const onEndCb = (e)=>{
            if (onEnd) onEnd(e);
        };
        controls.addEventListener('update', callback);
        controls.addEventListener('controlstart', onStartCb);
        controls.addEventListener('controlend', onEndCb);
        controls.addEventListener('control', callback);
        controls.addEventListener('transitionstart', callback);
        controls.addEventListener('wake', callback);
        return ()=>{
            controls.removeEventListener('update', callback);
            controls.removeEventListener('controlstart', onStartCb);
            controls.removeEventListener('controlend', onEndCb);
            controls.removeEventListener('control', callback);
            controls.removeEventListener('transitionstart', callback);
            controls.removeEventListener('wake', callback);
        };
    }, [
        controls,
        onStart,
        onEnd,
        invalidate,
        setEvents,
        regress,
        onChange
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (makeDefault) {
            const old = get().controls;
            set({
                controls: controls
            });
            return ()=>set({
                    controls: old
                });
        }
    }, [
        makeDefault,
        controls
    ]);
    return /*#__PURE__*/ $bxRTa.createElement("primitive", (0, $d65Jq.default)({
        ref: ref,
        object: controls
    }, restProps));
});

});
parcelRegister("d65Jq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9890481a5cdfbb7b$export$2e2bcd8739ae039);
function $9890481a5cdfbb7b$export$2e2bcd8739ae039() {
    return $9890481a5cdfbb7b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9890481a5cdfbb7b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("3gAAP", function(module, exports) {

$parcel$export(module.exports, "Canvas", () => $260f405379533f62$export$8d01c972ee8b14a9);
$parcel$export(module.exports, "extend", () => (parcelRequire("9sE5i")).e);

var $9sE5i = parcelRequire("9sE5i");

var $bxRTa = parcelRequire("bxRTa");

var $1W96c = parcelRequire("1W96c");

var $hAnCZ = parcelRequire("hAnCZ");

var $95UpF = parcelRequire("95UpF");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("hlfVD");


parcelRequire("3Rjoy");
parcelRequire("axy3F");
const $260f405379533f62$var$CanvasImpl = /*#__PURE__*/ $bxRTa.forwardRef(function Canvas({ children: children, fallback: fallback, resize: resize, style: style, gl: gl, events: events = (0, $9sE5i.c), eventSource: eventSource, eventPrefix: eventPrefix, shadows: shadows, linear: linear, flat: flat, legacy: legacy, orthographic: orthographic, frameloop: frameloop, dpr: dpr, performance: performance, raycaster: raycaster, camera: camera, scene: scene, onPointerMissed: onPointerMissed, onCreated: onCreated, ...props }, forwardedRef) {
    // Create a known catalogue of Threejs-native elements
    // This will include the entire THREE namespace by default, users can extend
    // their own elements by using the createRoot API instead
    $bxRTa.useMemo(()=>(0, $9sE5i.e)($1W96c), []);
    const Bridge = (0, $95UpF.useContextBridge)();
    const [containerRef, containerRect] = (0, $hAnCZ.default)({
        scroll: true,
        debounce: {
            scroll: 50,
            resize: 0
        },
        ...resize
    });
    const canvasRef = $bxRTa.useRef(null);
    const divRef = $bxRTa.useRef(null);
    $bxRTa.useImperativeHandle(forwardedRef, ()=>canvasRef.current);
    const handlePointerMissed = (0, $9sE5i.u)(onPointerMissed);
    const [block, setBlock] = $bxRTa.useState(false);
    const [error, setError] = $bxRTa.useState(false);
    // Suspend this component if block is a promise (2nd run)
    if (block) throw block;
    // Throw exception outwards if anything within canvas throws
    if (error) throw error;
    const root = $bxRTa.useRef(null);
    (0, $9sE5i.a)(()=>{
        const canvas = canvasRef.current;
        if (containerRect.width > 0 && containerRect.height > 0 && canvas) {
            if (!root.current) root.current = (0, $9sE5i.b)(canvas);
            root.current.configure({
                gl: gl,
                events: events,
                shadows: shadows,
                linear: linear,
                flat: flat,
                legacy: legacy,
                orthographic: orthographic,
                frameloop: frameloop,
                dpr: dpr,
                performance: performance,
                raycaster: raycaster,
                camera: camera,
                scene: scene,
                size: containerRect,
                // Pass mutable reference to onPointerMissed so it's free to update
                onPointerMissed: (...args)=>handlePointerMissed.current == null ? void 0 : handlePointerMissed.current(...args),
                onCreated: (state)=>{
                    // Connect to event source
                    state.events.connect == null || state.events.connect(eventSource ? (0, $9sE5i.i)(eventSource) ? eventSource.current : eventSource : divRef.current);
                    // Set up compute function
                    if (eventPrefix) state.setEvents({
                        compute: (event, state)=>{
                            const x = event[eventPrefix + 'X'];
                            const y = event[eventPrefix + 'Y'];
                            state.pointer.set(x / state.size.width * 2 - 1, -(y / state.size.height) * 2 + 1);
                            state.raycaster.setFromCamera(state.pointer, state.camera);
                        }
                    });
                    // Call onCreated callback
                    onCreated == null || onCreated(state);
                }
            });
            root.current.render(/*#__PURE__*/ (0, $fl9nK.jsx)(Bridge, {
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9sE5i.E), {
                    set: setError,
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)($bxRTa.Suspense, {
                        fallback: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9sE5i.B), {
                            set: setBlock
                        }),
                        children: children != null ? children : null
                    })
                })
            }));
        }
    });
    $bxRTa.useEffect(()=>{
        const canvas = canvasRef.current;
        if (canvas) return ()=>(0, $9sE5i.d)(canvas);
    }, []);
    // When the event source is not this div, we need to set pointer-events to none
    // Or else the canvas will block events from reaching the event source
    const pointerEvents = eventSource ? 'none' : 'auto';
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        ref: divRef,
        style: {
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            pointerEvents: pointerEvents,
            ...style
        },
        ...props,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            ref: containerRef,
            style: {
                width: '100%',
                height: '100%'
            },
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("canvas", {
                ref: canvasRef,
                style: {
                    display: 'block'
                },
                children: fallback
            })
        })
    });
});
/**
 * A DOM canvas which accepts threejs elements as children.
 * @see https://docs.pmnd.rs/react-three-fiber/api/canvas
 */ const $260f405379533f62$export$8d01c972ee8b14a9 = /*#__PURE__*/ $bxRTa.forwardRef(function CanvasWrapper(props, ref) {
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $95UpF.FiberProvider), {
        children: /*#__PURE__*/ (0, $fl9nK.jsx)($260f405379533f62$var$CanvasImpl, {
            ...props,
            ref: ref
        })
    });
});

});
parcelRegister("hAnCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd820700c5b54a0$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
function $ccd820700c5b54a0$var$g(n, t) {
    let o;
    return (...i)=>{
        window.clearTimeout(o), o = window.setTimeout(()=>n(...i), t);
    };
}
function $ccd820700c5b54a0$export$2e2bcd8739ae039({ debounce: n, scroll: t, polyfill: o, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const a = o || (typeof window == "undefined" ? class {
    } : window.ResizeObserver);
    if (!a) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [c, h] = (0, $bxRTa.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), e = (0, $bxRTa.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: c,
        orientationHandler: null
    }), d = n ? typeof n == "number" ? n : n.scroll : null, f = n ? typeof n == "number" ? n : n.resize : null, w = (0, $bxRTa.useRef)(!1);
    (0, $bxRTa.useEffect)(()=>(w.current = !0, ()=>void (w.current = !1)));
    const [z, m, s] = (0, $bxRTa.useMemo)(()=>{
        const r = ()=>{
            if (!e.current.element) return;
            const { left: y, top: C, width: H, height: O, bottom: S, right: x, x: B, y: R } = e.current.element.getBoundingClientRect(), l = {
                left: y,
                top: C,
                width: H,
                height: O,
                bottom: S,
                right: x,
                x: B,
                y: R
            };
            e.current.element instanceof HTMLElement && i && (l.height = e.current.element.offsetHeight, l.width = e.current.element.offsetWidth), Object.freeze(l), w.current && !$ccd820700c5b54a0$var$D(e.current.lastBounds, l) && h(e.current.lastBounds = l);
        };
        return [
            r,
            f ? $ccd820700c5b54a0$var$g(r, f) : r,
            d ? $ccd820700c5b54a0$var$g(r, d) : r
        ];
    }, [
        h,
        i,
        d,
        f
    ]);
    function v() {
        e.current.scrollContainers && (e.current.scrollContainers.forEach((r)=>r.removeEventListener("scroll", s, !0)), e.current.scrollContainers = null), e.current.resizeObserver && (e.current.resizeObserver.disconnect(), e.current.resizeObserver = null), e.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e.current.orientationHandler));
    }
    function b() {
        e.current.element && (e.current.resizeObserver = new a(s), e.current.resizeObserver.observe(e.current.element), t && e.current.scrollContainers && e.current.scrollContainers.forEach((r)=>r.addEventListener("scroll", s, {
                capture: !0,
                passive: !0
            })), e.current.orientationHandler = ()=>{
            s();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e.current.orientationHandler));
    }
    const L = (r)=>{
        !r || r === e.current.element || (v(), e.current.element = r, e.current.scrollContainers = $ccd820700c5b54a0$var$E(r), b());
    };
    return $ccd820700c5b54a0$var$X(s, !!t), $ccd820700c5b54a0$var$W(m), (0, $bxRTa.useEffect)(()=>{
        v(), b();
    }, [
        t,
        s,
        m
    ]), (0, $bxRTa.useEffect)(()=>v, []), [
        L,
        c,
        z
    ];
}
function $ccd820700c5b54a0$var$W(n) {
    (0, $bxRTa.useEffect)(()=>{
        const t = n;
        return window.addEventListener("resize", t), ()=>void window.removeEventListener("resize", t);
    }, [
        n
    ]);
}
function $ccd820700c5b54a0$var$X(n, t) {
    (0, $bxRTa.useEffect)(()=>{
        if (t) {
            const o = n;
            return window.addEventListener("scroll", o, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", o, !0);
        }
    }, [
        n,
        t
    ]);
}
function $ccd820700c5b54a0$var$E(n) {
    const t = [];
    if (!n || n === document.body) return t;
    const { overflow: o, overflowX: i, overflowY: a } = window.getComputedStyle(n);
    return [
        o,
        i,
        a
    ].some((c)=>c === "auto" || c === "scroll") && t.push(n), [
        ...t,
        ...$ccd820700c5b54a0$var$E(n.parentElement)
    ];
}
const $ccd820700c5b54a0$var$k = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], $ccd820700c5b54a0$var$D = (n, t)=>$ccd820700c5b54a0$var$k.every((o)=>n[o] === t[o]);

});

parcelRegister("95UpF", function(module, exports) {

$parcel$export(module.exports, "FiberProvider", () => $69f0571dffc516ed$export$5a20fcbfd44d38b7);
$parcel$export(module.exports, "useContextBridge", () => $69f0571dffc516ed$export$39579d26c695d393);

var $bxRTa = parcelRequire("bxRTa");
var $69f0571dffc516ed$var$__defProp = Object.defineProperty;
var $69f0571dffc516ed$var$__defProps = Object.defineProperties;
var $69f0571dffc516ed$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $69f0571dffc516ed$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $69f0571dffc516ed$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $69f0571dffc516ed$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $69f0571dffc516ed$var$__defNormalProp = (obj, key, value)=>key in obj ? $69f0571dffc516ed$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $69f0571dffc516ed$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($69f0571dffc516ed$var$__hasOwnProp.call(b, prop)) $69f0571dffc516ed$var$__defNormalProp(a, prop, b[prop]);
    if ($69f0571dffc516ed$var$__getOwnPropSymbols) {
        for (var prop of $69f0571dffc516ed$var$__getOwnPropSymbols(b))if ($69f0571dffc516ed$var$__propIsEnum.call(b, prop)) $69f0571dffc516ed$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $69f0571dffc516ed$var$__spreadProps = (a, b)=>$69f0571dffc516ed$var$__defProps(a, $69f0571dffc516ed$var$__getOwnPropDescs(b));
var $69f0571dffc516ed$var$_a, $69f0571dffc516ed$var$_b;
const $69f0571dffc516ed$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && ((($69f0571dffc516ed$var$_a = window.document) == null ? void 0 : $69f0571dffc516ed$var$_a.createElement) || (($69f0571dffc516ed$var$_b = window.navigator) == null ? void 0 : $69f0571dffc516ed$var$_b.product) === "ReactNative") ? $bxRTa.useLayoutEffect : $bxRTa.useEffect;
function $69f0571dffc516ed$export$e2f435051054a3fd(fiber, ascending, selector) {
    if (!fiber) return;
    if (selector(fiber) === true) return fiber;
    let child = ascending ? fiber.return : fiber.child;
    while(child){
        const match = $69f0571dffc516ed$export$e2f435051054a3fd(child, ascending, selector);
        if (match) return match;
        child = ascending ? null : child.sibling;
    }
}
function $69f0571dffc516ed$var$wrapContext(context) {
    try {
        return Object.defineProperties(context, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch (_) {
        return context;
    }
}
const $69f0571dffc516ed$var$error = console.error;
console.error = function() {
    const message = [
        ...arguments
    ].join("");
    if ((message == null ? void 0 : message.startsWith("Warning:")) && message.includes("useContext")) {
        console.error = $69f0571dffc516ed$var$error;
        return;
    }
    return $69f0571dffc516ed$var$error.apply(this, arguments);
};
const $69f0571dffc516ed$var$FiberContext = $69f0571dffc516ed$var$wrapContext($bxRTa.createContext(null));
class $69f0571dffc516ed$export$5a20fcbfd44d38b7 extends $bxRTa.Component {
    render() {
        return /* @__PURE__ */ $bxRTa.createElement($69f0571dffc516ed$var$FiberContext.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
function $69f0571dffc516ed$export$69c8591d5df5c7d6() {
    const root = $bxRTa.useContext($69f0571dffc516ed$var$FiberContext);
    if (root === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const id = $bxRTa.useId();
    const fiber = $bxRTa.useMemo(()=>{
        for (const maybeFiber of [
            root,
            root == null ? void 0 : root.alternate
        ]){
            if (!maybeFiber) continue;
            const fiber2 = $69f0571dffc516ed$export$e2f435051054a3fd(maybeFiber, false, (node)=>{
                let state = node.memoizedState;
                while(state){
                    if (state.memoizedState === id) return true;
                    state = state.next;
                }
            });
            if (fiber2) return fiber2;
        }
    }, [
        root,
        id
    ]);
    return fiber;
}
function $69f0571dffc516ed$export$b537cf6ebaf7ff54() {
    const fiber = $69f0571dffc516ed$export$69c8591d5df5c7d6();
    const root = $bxRTa.useMemo(()=>$69f0571dffc516ed$export$e2f435051054a3fd(fiber, true, (node)=>{
            var _a2;
            return ((_a2 = node.stateNode) == null ? void 0 : _a2.containerInfo) != null;
        }), [
        fiber
    ]);
    return root == null ? void 0 : root.stateNode.containerInfo;
}
function $69f0571dffc516ed$export$aec415ac1d7388b6(type) {
    const fiber = $69f0571dffc516ed$export$69c8591d5df5c7d6();
    const childRef = $bxRTa.useRef();
    $69f0571dffc516ed$var$useIsomorphicLayoutEffect(()=>{
        var _a2;
        childRef.current = (_a2 = $69f0571dffc516ed$export$e2f435051054a3fd(fiber, false, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return childRef;
}
function $69f0571dffc516ed$export$b57c9fdd1434988b(type) {
    const fiber = $69f0571dffc516ed$export$69c8591d5df5c7d6();
    const parentRef = $bxRTa.useRef();
    $69f0571dffc516ed$var$useIsomorphicLayoutEffect(()=>{
        var _a2;
        parentRef.current = (_a2 = $69f0571dffc516ed$export$e2f435051054a3fd(fiber, true, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return parentRef;
}
function $69f0571dffc516ed$export$8859381a76e56404() {
    const fiber = $69f0571dffc516ed$export$69c8591d5df5c7d6();
    const [contextMap] = $bxRTa.useState(()=>/* @__PURE__ */ new Map());
    contextMap.clear();
    let node = fiber;
    while(node){
        if (node.type && typeof node.type === "object") {
            const enableRenderableContext = node.type._context === void 0 && node.type.Provider === node.type;
            const context = enableRenderableContext ? node.type : node.type._context;
            if (context && context !== $69f0571dffc516ed$var$FiberContext && !contextMap.has(context)) contextMap.set(context, $bxRTa.useContext($69f0571dffc516ed$var$wrapContext(context)));
        }
        node = node.return;
    }
    return contextMap;
}
function $69f0571dffc516ed$export$39579d26c695d393() {
    const contextMap = $69f0571dffc516ed$export$8859381a76e56404();
    return $bxRTa.useMemo(()=>Array.from(contextMap.keys()).reduce((Prev, context)=>(props)=>/* @__PURE__ */ $bxRTa.createElement(Prev, null, /* @__PURE__ */ $bxRTa.createElement(context.Provider, $69f0571dffc516ed$var$__spreadProps($69f0571dffc516ed$var$__spreadValues({}, props), {
                    value: contextMap.get(context)
                }))), (props)=>/* @__PURE__ */ $bxRTa.createElement($69f0571dffc516ed$export$5a20fcbfd44d38b7, $69f0571dffc516ed$var$__spreadValues({}, props))), [
        contextMap
    ]);
}

});


parcelRegister("fynI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b52c6c537f7b0cc8$export$2e2bcd8739ae039);
/*!
 * camera-controls
 * https://github.com/yomotsu/camera-controls
 * (c) 2017 @yomotsu
 * Released under the MIT License.
 */ // see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons#value
const $b52c6c537f7b0cc8$var$MOUSE_BUTTON = {
    LEFT: 1,
    RIGHT: 2,
    MIDDLE: 4
};
const $b52c6c537f7b0cc8$var$ACTION = Object.freeze({
    NONE: 0,
    ROTATE: 1,
    TRUCK: 2,
    SCREEN_PAN: 4,
    OFFSET: 8,
    DOLLY: 16,
    ZOOM: 32,
    TOUCH_ROTATE: 64,
    TOUCH_TRUCK: 128,
    TOUCH_SCREEN_PAN: 256,
    TOUCH_OFFSET: 512,
    TOUCH_DOLLY: 1024,
    TOUCH_ZOOM: 2048,
    TOUCH_DOLLY_TRUCK: 4096,
    TOUCH_DOLLY_SCREEN_PAN: 8192,
    TOUCH_DOLLY_OFFSET: 16384,
    TOUCH_DOLLY_ROTATE: 32768,
    TOUCH_ZOOM_TRUCK: 65536,
    TOUCH_ZOOM_OFFSET: 131072,
    TOUCH_ZOOM_SCREEN_PAN: 262144,
    TOUCH_ZOOM_ROTATE: 524288
});
const $b52c6c537f7b0cc8$var$DOLLY_DIRECTION = {
    NONE: 0,
    IN: 1,
    OUT: -1
};
function $b52c6c537f7b0cc8$var$isPerspectiveCamera(camera) {
    return camera.isPerspectiveCamera;
}
function $b52c6c537f7b0cc8$var$isOrthographicCamera(camera) {
    return camera.isOrthographicCamera;
}
const $b52c6c537f7b0cc8$var$PI_2 = Math.PI * 2;
const $b52c6c537f7b0cc8$var$PI_HALF = Math.PI / 2;
const $b52c6c537f7b0cc8$var$EPSILON = 1e-5;
const $b52c6c537f7b0cc8$var$DEG2RAD = Math.PI / 180;
function $b52c6c537f7b0cc8$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $b52c6c537f7b0cc8$var$approxZero(number, error = $b52c6c537f7b0cc8$var$EPSILON) {
    return Math.abs(number) < error;
}
function $b52c6c537f7b0cc8$var$approxEquals(a, b, error = $b52c6c537f7b0cc8$var$EPSILON) {
    return $b52c6c537f7b0cc8$var$approxZero(a - b, error);
}
function $b52c6c537f7b0cc8$var$roundToStep(value, step) {
    return Math.round(value / step) * step;
}
function $b52c6c537f7b0cc8$var$infinityToMaxNumber(value) {
    if (isFinite(value)) return value;
    if (value < 0) return -Number.MAX_VALUE;
    return Number.MAX_VALUE;
}
function $b52c6c537f7b0cc8$var$maxNumberToInfinity(value) {
    if (Math.abs(value) < Number.MAX_VALUE) return value;
    return value * Infinity;
}
// https://docs.unity3d.com/ScriptReference/Mathf.SmoothDamp.html
// https://github.com/Unity-Technologies/UnityCsReference/blob/a2bdfe9b3c4cd4476f44bf52f848063bfaf7b6b9/Runtime/Export/Math/Mathf.cs#L308
function $b52c6c537f7b0cc8$var$smoothDamp(current, target, currentVelocityRef, smoothTime, maxSpeed = Infinity, deltaTime) {
    // Based on Game Programming Gems 4 Chapter 1.10
    smoothTime = Math.max(0.0001, smoothTime);
    const omega = 2 / smoothTime;
    const x = omega * deltaTime;
    const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
    let change = current - target;
    const originalTo = target;
    // Clamp maximum speed
    const maxChange = maxSpeed * smoothTime;
    change = $b52c6c537f7b0cc8$var$clamp(change, -maxChange, maxChange);
    target = current - change;
    const temp = (currentVelocityRef.value + omega * change) * deltaTime;
    currentVelocityRef.value = (currentVelocityRef.value - omega * temp) * exp;
    let output = target + (change + temp) * exp;
    // Prevent overshooting
    if (originalTo - current > 0.0 === output > originalTo) {
        output = originalTo;
        currentVelocityRef.value = (output - originalTo) / deltaTime;
    }
    return output;
}
// https://docs.unity3d.com/ScriptReference/Vector3.SmoothDamp.html
// https://github.com/Unity-Technologies/UnityCsReference/blob/a2bdfe9b3c4cd4476f44bf52f848063bfaf7b6b9/Runtime/Export/Math/Vector3.cs#L97
function $b52c6c537f7b0cc8$var$smoothDampVec3(current, target, currentVelocityRef, smoothTime, maxSpeed = Infinity, deltaTime, out) {
    // Based on Game Programming Gems 4 Chapter 1.10
    smoothTime = Math.max(0.0001, smoothTime);
    const omega = 2 / smoothTime;
    const x = omega * deltaTime;
    const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
    let targetX = target.x;
    let targetY = target.y;
    let targetZ = target.z;
    let changeX = current.x - targetX;
    let changeY = current.y - targetY;
    let changeZ = current.z - targetZ;
    const originalToX = targetX;
    const originalToY = targetY;
    const originalToZ = targetZ;
    // Clamp maximum speed
    const maxChange = maxSpeed * smoothTime;
    const maxChangeSq = maxChange * maxChange;
    const magnitudeSq = changeX * changeX + changeY * changeY + changeZ * changeZ;
    if (magnitudeSq > maxChangeSq) {
        const magnitude = Math.sqrt(magnitudeSq);
        changeX = changeX / magnitude * maxChange;
        changeY = changeY / magnitude * maxChange;
        changeZ = changeZ / magnitude * maxChange;
    }
    targetX = current.x - changeX;
    targetY = current.y - changeY;
    targetZ = current.z - changeZ;
    const tempX = (currentVelocityRef.x + omega * changeX) * deltaTime;
    const tempY = (currentVelocityRef.y + omega * changeY) * deltaTime;
    const tempZ = (currentVelocityRef.z + omega * changeZ) * deltaTime;
    currentVelocityRef.x = (currentVelocityRef.x - omega * tempX) * exp;
    currentVelocityRef.y = (currentVelocityRef.y - omega * tempY) * exp;
    currentVelocityRef.z = (currentVelocityRef.z - omega * tempZ) * exp;
    out.x = targetX + (changeX + tempX) * exp;
    out.y = targetY + (changeY + tempY) * exp;
    out.z = targetZ + (changeZ + tempZ) * exp;
    // Prevent overshooting
    const origMinusCurrentX = originalToX - current.x;
    const origMinusCurrentY = originalToY - current.y;
    const origMinusCurrentZ = originalToZ - current.z;
    const outMinusOrigX = out.x - originalToX;
    const outMinusOrigY = out.y - originalToY;
    const outMinusOrigZ = out.z - originalToZ;
    if (origMinusCurrentX * outMinusOrigX + origMinusCurrentY * outMinusOrigY + origMinusCurrentZ * outMinusOrigZ > 0) {
        out.x = originalToX;
        out.y = originalToY;
        out.z = originalToZ;
        currentVelocityRef.x = (out.x - originalToX) / deltaTime;
        currentVelocityRef.y = (out.y - originalToY) / deltaTime;
        currentVelocityRef.z = (out.z - originalToZ) / deltaTime;
    }
    return out;
}
function $b52c6c537f7b0cc8$var$extractClientCoordFromEvent(pointers, out) {
    out.set(0, 0);
    pointers.forEach((pointer)=>{
        out.x += pointer.clientX;
        out.y += pointer.clientY;
    });
    out.x /= pointers.length;
    out.y /= pointers.length;
}
function $b52c6c537f7b0cc8$var$notSupportedInOrthographicCamera(camera, message) {
    if ($b52c6c537f7b0cc8$var$isOrthographicCamera(camera)) {
        console.warn(`${message} is not supported in OrthographicCamera`);
        return true;
    }
    return false;
}
class $b52c6c537f7b0cc8$export$ec8b666c5fe2c75a {
    constructor(){
        this._listeners = {};
    }
    /**
     * Adds the specified event listener.
     * @param type event name
     * @param listener handler function
     * @category Methods
     */ addEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    /**
     * Presence of the specified event listener.
     * @param type event name
     * @param listener handler function
     * @category Methods
     */ hasEventListener(type, listener) {
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    /**
     * Removes the specified event listener
     * @param type event name
     * @param listener handler function
     * @category Methods
     */ removeEventListener(type, listener) {
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
     * Removes all event listeners
     * @param type event name
     * @category Methods
     */ removeAllEventListeners(type) {
        if (!type) {
            this._listeners = {};
            return;
        }
        if (Array.isArray(this._listeners[type])) this._listeners[type].length = 0;
    }
    /**
     * Fire an event type.
     * @param event DispatcherEvent
     * @category Methods
     */ dispatchEvent(event) {
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
        }
    }
}
var $b52c6c537f7b0cc8$var$_a;
const $b52c6c537f7b0cc8$var$VERSION = '2.10.1'; // will be replaced with `version` in package.json during the build process.
const $b52c6c537f7b0cc8$var$TOUCH_DOLLY_FACTOR = 1 / 8;
const $b52c6c537f7b0cc8$var$isMac = /Mac/.test(($b52c6c537f7b0cc8$var$_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || $b52c6c537f7b0cc8$var$_a === void 0 ? void 0 : $b52c6c537f7b0cc8$var$_a.platform);
let $b52c6c537f7b0cc8$var$THREE;
let $b52c6c537f7b0cc8$var$_ORIGIN;
let $b52c6c537f7b0cc8$var$_AXIS_Y;
let $b52c6c537f7b0cc8$var$_AXIS_Z;
let $b52c6c537f7b0cc8$var$_v2;
let $b52c6c537f7b0cc8$var$_v3A;
let $b52c6c537f7b0cc8$var$_v3B;
let $b52c6c537f7b0cc8$var$_v3C;
let $b52c6c537f7b0cc8$var$_cameraDirection;
let $b52c6c537f7b0cc8$var$_xColumn;
let $b52c6c537f7b0cc8$var$_yColumn;
let $b52c6c537f7b0cc8$var$_zColumn;
let $b52c6c537f7b0cc8$var$_deltaTarget;
let $b52c6c537f7b0cc8$var$_deltaOffset;
let $b52c6c537f7b0cc8$var$_sphericalA;
let $b52c6c537f7b0cc8$var$_sphericalB;
let $b52c6c537f7b0cc8$var$_box3A;
let $b52c6c537f7b0cc8$var$_box3B;
let $b52c6c537f7b0cc8$var$_sphere;
let $b52c6c537f7b0cc8$var$_quaternionA;
let $b52c6c537f7b0cc8$var$_quaternionB;
let $b52c6c537f7b0cc8$var$_rotationMatrix;
let $b52c6c537f7b0cc8$var$_raycaster;
class $b52c6c537f7b0cc8$export$2e2bcd8739ae039 extends $b52c6c537f7b0cc8$export$ec8b666c5fe2c75a {
    /**
     * Injects THREE as the dependency. You can then proceed to use CameraControls.
     *
     * e.g
     * ```javascript
     * CameraControls.install( { THREE: THREE } );
     * ```
     *
     * Note: If you do not wish to use enter three.js to reduce file size(tree-shaking for example), make a subset to install.
     *
     * ```js
     * import {
     * 	Vector2,
     * 	Vector3,
     * 	Vector4,
     * 	Quaternion,
     * 	Matrix4,
     * 	Spherical,
     * 	Box3,
     * 	Sphere,
     * 	Raycaster,
     * 	MathUtils,
     * } from 'three';
     *
     * const subsetOfTHREE = {
     * 	Vector2   : Vector2,
     * 	Vector3   : Vector3,
     * 	Vector4   : Vector4,
     * 	Quaternion: Quaternion,
     * 	Matrix4   : Matrix4,
     * 	Spherical : Spherical,
     * 	Box3      : Box3,
     * 	Sphere    : Sphere,
     * 	Raycaster : Raycaster,
     * };

     * CameraControls.install( { THREE: subsetOfTHREE } );
     * ```
     * @category Statics
     */ static install(libs) {
        $b52c6c537f7b0cc8$var$THREE = libs.THREE;
        $b52c6c537f7b0cc8$var$_ORIGIN = Object.freeze(new $b52c6c537f7b0cc8$var$THREE.Vector3(0, 0, 0));
        $b52c6c537f7b0cc8$var$_AXIS_Y = Object.freeze(new $b52c6c537f7b0cc8$var$THREE.Vector3(0, 1, 0));
        $b52c6c537f7b0cc8$var$_AXIS_Z = Object.freeze(new $b52c6c537f7b0cc8$var$THREE.Vector3(0, 0, 1));
        $b52c6c537f7b0cc8$var$_v2 = new $b52c6c537f7b0cc8$var$THREE.Vector2();
        $b52c6c537f7b0cc8$var$_v3A = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        $b52c6c537f7b0cc8$var$_v3B = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        $b52c6c537f7b0cc8$var$_v3C = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        $b52c6c537f7b0cc8$var$_cameraDirection = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        $b52c6c537f7b0cc8$var$_xColumn = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        $b52c6c537f7b0cc8$var$_yColumn = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        $b52c6c537f7b0cc8$var$_zColumn = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        $b52c6c537f7b0cc8$var$_deltaTarget = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        $b52c6c537f7b0cc8$var$_deltaOffset = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        $b52c6c537f7b0cc8$var$_sphericalA = new $b52c6c537f7b0cc8$var$THREE.Spherical();
        $b52c6c537f7b0cc8$var$_sphericalB = new $b52c6c537f7b0cc8$var$THREE.Spherical();
        $b52c6c537f7b0cc8$var$_box3A = new $b52c6c537f7b0cc8$var$THREE.Box3();
        $b52c6c537f7b0cc8$var$_box3B = new $b52c6c537f7b0cc8$var$THREE.Box3();
        $b52c6c537f7b0cc8$var$_sphere = new $b52c6c537f7b0cc8$var$THREE.Sphere();
        $b52c6c537f7b0cc8$var$_quaternionA = new $b52c6c537f7b0cc8$var$THREE.Quaternion();
        $b52c6c537f7b0cc8$var$_quaternionB = new $b52c6c537f7b0cc8$var$THREE.Quaternion();
        $b52c6c537f7b0cc8$var$_rotationMatrix = new $b52c6c537f7b0cc8$var$THREE.Matrix4();
        $b52c6c537f7b0cc8$var$_raycaster = new $b52c6c537f7b0cc8$var$THREE.Raycaster();
    }
    /**
     * list all ACTIONs
     * @category Statics
     */ static get ACTION() {
        return $b52c6c537f7b0cc8$var$ACTION;
    }
    /**
     * @deprecated Use `cameraControls.mouseButtons.left = CameraControls.ACTION.SCREEN_PAN` instead.
     */ set verticalDragToForward(_) {
        console.warn('camera-controls: `verticalDragToForward` was removed. Use `mouseButtons.left = CameraControls.ACTION.SCREEN_PAN` instead.');
    }
    /**
     * Creates a `CameraControls` instance.
     *
     * Note:
     * You **must install** three.js before using camera-controls. see [#install](#install)
     * Not doing so will lead to runtime errors (`undefined` references to THREE).
     *
     * e.g.
     * ```
     * CameraControls.install( { THREE } );
     * const cameraControls = new CameraControls( camera, domElement );
     * ```
     *
     * @param camera A `THREE.PerspectiveCamera` or `THREE.OrthographicCamera` to be controlled.
     * @param domElement A `HTMLElement` for the draggable area, usually `renderer.domElement`.
     * @category Constructor
     */ constructor(camera, domElement){
        super();
        /**
         * Minimum vertical angle in radians.
         * The angle has to be between `0` and `.maxPolarAngle` inclusive.
         * The default value is `0`.
         *
         * e.g.
         * ```
         * cameraControls.maxPolarAngle = 0;
         * ```
         * @category Properties
         */ this.minPolarAngle = 0; // radians
        /**
         * Maximum vertical angle in radians.
         * The angle has to be between `.maxPolarAngle` and `Math.PI` inclusive.
         * The default value is `Math.PI`.
         *
         * e.g.
         * ```
         * cameraControls.maxPolarAngle = Math.PI;
         * ```
         * @category Properties
         */ this.maxPolarAngle = Math.PI; // radians
        /**
         * Minimum horizontal angle in radians.
         * The angle has to be less than `.maxAzimuthAngle`.
         * The default value is `- Infinity`.
         *
         * e.g.
         * ```
         * cameraControls.minAzimuthAngle = - Infinity;
         * ```
         * @category Properties
         */ this.minAzimuthAngle = -Infinity; // radians
        /**
         * Maximum horizontal angle in radians.
         * The angle has to be greater than `.minAzimuthAngle`.
         * The default value is `Infinity`.
         *
         * e.g.
         * ```
         * cameraControls.maxAzimuthAngle = Infinity;
         * ```
         * @category Properties
         */ this.maxAzimuthAngle = Infinity; // radians
        // How far you can dolly in and out ( PerspectiveCamera only )
        /**
         * Minimum distance for dolly. The value must be higher than `0`. Default is `Number.EPSILON`.
         * PerspectiveCamera only.
         * @category Properties
         */ this.minDistance = Number.EPSILON;
        /**
         * Maximum distance for dolly. The value must be higher than `minDistance`. Default is `Infinity`.
         * PerspectiveCamera only.
         * @category Properties
         */ this.maxDistance = Infinity;
        /**
         * `true` to enable Infinity Dolly for wheel and pinch. Use this with `minDistance` and `maxDistance`
         * If the Dolly distance is less (or over) than the `minDistance` (or `maxDistance`), `infinityDolly` will keep the distance and pushes the target position instead.
         * @category Properties
         */ this.infinityDolly = false;
        /**
         * Minimum camera zoom.
         * @category Properties
         */ this.minZoom = 0.01;
        /**
         * Maximum camera zoom.
         * @category Properties
         */ this.maxZoom = Infinity;
        /**
         * Approximate time in seconds to reach the target. A smaller value will reach the target faster.
         * @category Properties
         */ this.smoothTime = 0.25;
        /**
         * the smoothTime while dragging
         * @category Properties
         */ this.draggingSmoothTime = 0.125;
        /**
         * Max transition speed in unit-per-seconds
         * @category Properties
         */ this.maxSpeed = Infinity;
        /**
         * Speed of azimuth (horizontal) rotation.
         * @category Properties
         */ this.azimuthRotateSpeed = 1.0;
        /**
         * Speed of polar (vertical) rotation.
         * @category Properties
         */ this.polarRotateSpeed = 1.0;
        /**
         * Speed of mouse-wheel dollying.
         * @category Properties
         */ this.dollySpeed = 1.0;
        /**
         * `true` to invert direction when dollying or zooming via drag
         * @category Properties
         */ this.dollyDragInverted = false;
        /**
         * Speed of drag for truck and pedestal.
         * @category Properties
         */ this.truckSpeed = 2.0;
        /**
         * `true` to enable Dolly-in to the mouse cursor coords.
         * @category Properties
         */ this.dollyToCursor = false;
        /**
         * @category Properties
         */ this.dragToOffset = false;
        /**
         * Friction ratio of the boundary.
         * @category Properties
         */ this.boundaryFriction = 0.0;
        /**
         * Controls how soon the `rest` event fires as the camera slows.
         * @category Properties
         */ this.restThreshold = 0.01;
        /**
         * An array of Meshes to collide with camera.
         * Be aware colliderMeshes may decrease performance. The collision test uses 4 raycasters from the camera since the near plane has 4 corners.
         * @category Properties
         */ this.colliderMeshes = [];
        /**
         * Force cancel user dragging.
         * @category Methods
         */ // cancel will be overwritten in the constructor.
        this.cancel = ()=>{};
        this._enabled = true;
        this._state = $b52c6c537f7b0cc8$var$ACTION.NONE;
        this._viewport = null;
        this._changedDolly = 0;
        this._changedZoom = 0;
        this._hasRested = true;
        this._boundaryEnclosesCamera = false;
        this._needsUpdate = true;
        this._updatedLastTime = false;
        this._elementRect = new DOMRect();
        this._isDragging = false;
        this._dragNeedsUpdate = true;
        this._activePointers = [];
        this._lockedPointer = null;
        this._interactiveArea = new DOMRect(0, 0, 1, 1);
        // Use draggingSmoothTime over smoothTime while true.
        // set automatically true on user-dragging start.
        // set automatically false on programmable methods call.
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        this._isUserControllingOffset = false;
        this._isUserControllingZoom = false;
        this._lastDollyDirection = $b52c6c537f7b0cc8$var$DOLLY_DIRECTION.NONE;
        // velocities for smoothDamp
        this._thetaVelocity = {
            value: 0
        };
        this._phiVelocity = {
            value: 0
        };
        this._radiusVelocity = {
            value: 0
        };
        this._targetVelocity = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        this._focalOffsetVelocity = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        this._zoomVelocity = {
            value: 0
        };
        this._truckInternal = (deltaX, deltaY, dragToOffset, screenSpacePanning)=>{
            let truckX;
            let pedestalY;
            if ($b52c6c537f7b0cc8$var$isPerspectiveCamera(this._camera)) {
                const offset = $b52c6c537f7b0cc8$var$_v3A.copy(this._camera.position).sub(this._target);
                // half of the fov is center to top of screen
                const fov = this._camera.getEffectiveFOV() * $b52c6c537f7b0cc8$var$DEG2RAD;
                const targetDistance = offset.length() * Math.tan(fov * 0.5);
                truckX = this.truckSpeed * deltaX * targetDistance / this._elementRect.height;
                pedestalY = this.truckSpeed * deltaY * targetDistance / this._elementRect.height;
            } else if ($b52c6c537f7b0cc8$var$isOrthographicCamera(this._camera)) {
                const camera = this._camera;
                truckX = this.truckSpeed * deltaX * (camera.right - camera.left) / camera.zoom / this._elementRect.width;
                pedestalY = this.truckSpeed * deltaY * (camera.top - camera.bottom) / camera.zoom / this._elementRect.height;
            } else return;
            if (screenSpacePanning) {
                dragToOffset ? this.setFocalOffset(this._focalOffsetEnd.x + truckX, this._focalOffsetEnd.y, this._focalOffsetEnd.z, true) : this.truck(truckX, 0, true);
                this.forward(-pedestalY, true);
            } else dragToOffset ? this.setFocalOffset(this._focalOffsetEnd.x + truckX, this._focalOffsetEnd.y + pedestalY, this._focalOffsetEnd.z, true) : this.truck(truckX, pedestalY, true);
        };
        this._rotateInternal = (deltaX, deltaY)=>{
            const theta = $b52c6c537f7b0cc8$var$PI_2 * this.azimuthRotateSpeed * deltaX / this._elementRect.height; // divide by *height* to refer the resolution
            const phi = $b52c6c537f7b0cc8$var$PI_2 * this.polarRotateSpeed * deltaY / this._elementRect.height;
            this.rotate(theta, phi, true);
        };
        this._dollyInternal = (delta, x, y)=>{
            const dollyScale = Math.pow(0.95, -delta * this.dollySpeed);
            const lastDistance = this._sphericalEnd.radius;
            const distance = this._sphericalEnd.radius * dollyScale;
            const clampedDistance = $b52c6c537f7b0cc8$var$clamp(distance, this.minDistance, this.maxDistance);
            const overflowedDistance = clampedDistance - distance;
            if (this.infinityDolly && this.dollyToCursor) this._dollyToNoClamp(distance, true);
            else if (this.infinityDolly && !this.dollyToCursor) {
                this.dollyInFixed(overflowedDistance, true);
                this._dollyToNoClamp(clampedDistance, true);
            } else this._dollyToNoClamp(clampedDistance, true);
            if (this.dollyToCursor) {
                this._changedDolly += (this.infinityDolly ? distance : clampedDistance) - lastDistance;
                this._dollyControlCoord.set(x, y);
            }
            this._lastDollyDirection = Math.sign(-delta);
        };
        this._zoomInternal = (delta, x, y)=>{
            const zoomScale = Math.pow(0.95, delta * this.dollySpeed);
            const lastZoom = this._zoom;
            const zoom = this._zoom * zoomScale;
            // for both PerspectiveCamera and OrthographicCamera
            this.zoomTo(zoom, true);
            if (this.dollyToCursor) {
                this._changedZoom += zoom - lastZoom;
                this._dollyControlCoord.set(x, y);
            }
        };
        // Check if the user has installed THREE
        if (typeof $b52c6c537f7b0cc8$var$THREE === 'undefined') console.error('camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information.');
        this._camera = camera;
        this._yAxisUpSpace = new $b52c6c537f7b0cc8$var$THREE.Quaternion().setFromUnitVectors(this._camera.up, $b52c6c537f7b0cc8$var$_AXIS_Y);
        this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert();
        this._state = $b52c6c537f7b0cc8$var$ACTION.NONE;
        // the location
        this._target = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        this._targetEnd = this._target.clone();
        this._focalOffset = new $b52c6c537f7b0cc8$var$THREE.Vector3();
        this._focalOffsetEnd = this._focalOffset.clone();
        // rotation
        this._spherical = new $b52c6c537f7b0cc8$var$THREE.Spherical().setFromVector3($b52c6c537f7b0cc8$var$_v3A.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace));
        this._sphericalEnd = this._spherical.clone();
        this._lastDistance = this._spherical.radius;
        this._zoom = this._camera.zoom;
        this._zoomEnd = this._zoom;
        this._lastZoom = this._zoom;
        // collisionTest uses nearPlane.s
        this._nearPlaneCorners = [
            new $b52c6c537f7b0cc8$var$THREE.Vector3(),
            new $b52c6c537f7b0cc8$var$THREE.Vector3(),
            new $b52c6c537f7b0cc8$var$THREE.Vector3(),
            new $b52c6c537f7b0cc8$var$THREE.Vector3()
        ];
        this._updateNearPlaneCorners();
        // Target cannot move outside of this box
        this._boundary = new $b52c6c537f7b0cc8$var$THREE.Box3(new $b52c6c537f7b0cc8$var$THREE.Vector3(-Infinity, -Infinity, -Infinity), new $b52c6c537f7b0cc8$var$THREE.Vector3(Infinity, Infinity, Infinity));
        // reset
        this._cameraUp0 = this._camera.up.clone();
        this._target0 = this._target.clone();
        this._position0 = this._camera.position.clone();
        this._zoom0 = this._zoom;
        this._focalOffset0 = this._focalOffset.clone();
        this._dollyControlCoord = new $b52c6c537f7b0cc8$var$THREE.Vector2();
        // configs
        this.mouseButtons = {
            left: $b52c6c537f7b0cc8$var$ACTION.ROTATE,
            middle: $b52c6c537f7b0cc8$var$ACTION.DOLLY,
            right: $b52c6c537f7b0cc8$var$ACTION.TRUCK,
            wheel: $b52c6c537f7b0cc8$var$isPerspectiveCamera(this._camera) ? $b52c6c537f7b0cc8$var$ACTION.DOLLY : $b52c6c537f7b0cc8$var$isOrthographicCamera(this._camera) ? $b52c6c537f7b0cc8$var$ACTION.ZOOM : $b52c6c537f7b0cc8$var$ACTION.NONE
        };
        this.touches = {
            one: $b52c6c537f7b0cc8$var$ACTION.TOUCH_ROTATE,
            two: $b52c6c537f7b0cc8$var$isPerspectiveCamera(this._camera) ? $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_TRUCK : $b52c6c537f7b0cc8$var$isOrthographicCamera(this._camera) ? $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_TRUCK : $b52c6c537f7b0cc8$var$ACTION.NONE,
            three: $b52c6c537f7b0cc8$var$ACTION.TOUCH_TRUCK
        };
        const dragStartPosition = new $b52c6c537f7b0cc8$var$THREE.Vector2();
        const lastDragPosition = new $b52c6c537f7b0cc8$var$THREE.Vector2();
        const dollyStart = new $b52c6c537f7b0cc8$var$THREE.Vector2();
        const onPointerDown = (event)=>{
            if (!this._enabled || !this._domElement) return;
            if (this._interactiveArea.left !== 0 || this._interactiveArea.top !== 0 || this._interactiveArea.width !== 1 || this._interactiveArea.height !== 1) {
                const elRect = this._domElement.getBoundingClientRect();
                const left = event.clientX / elRect.width;
                const top = event.clientY / elRect.height;
                // check if the interactiveArea contains the drag start position.
                if (left < this._interactiveArea.left || left > this._interactiveArea.right || top < this._interactiveArea.top || top > this._interactiveArea.bottom) return;
            }
            // Don't call `event.preventDefault()` on the pointerdown event
            // to keep receiving pointermove evens outside dragging iframe
            // https://taye.me/blog/tips/2015/11/16/mouse-drag-outside-iframe/
            const mouseButton = event.pointerType !== 'mouse' ? null : (event.buttons & $b52c6c537f7b0cc8$var$MOUSE_BUTTON.LEFT) === $b52c6c537f7b0cc8$var$MOUSE_BUTTON.LEFT ? $b52c6c537f7b0cc8$var$MOUSE_BUTTON.LEFT : (event.buttons & $b52c6c537f7b0cc8$var$MOUSE_BUTTON.MIDDLE) === $b52c6c537f7b0cc8$var$MOUSE_BUTTON.MIDDLE ? $b52c6c537f7b0cc8$var$MOUSE_BUTTON.MIDDLE : (event.buttons & $b52c6c537f7b0cc8$var$MOUSE_BUTTON.RIGHT) === $b52c6c537f7b0cc8$var$MOUSE_BUTTON.RIGHT ? $b52c6c537f7b0cc8$var$MOUSE_BUTTON.RIGHT : null;
            if (mouseButton !== null) {
                const zombiePointer = this._findPointerByMouseButton(mouseButton);
                zombiePointer && this._disposePointer(zombiePointer);
            }
            if ((event.buttons & $b52c6c537f7b0cc8$var$MOUSE_BUTTON.LEFT) === $b52c6c537f7b0cc8$var$MOUSE_BUTTON.LEFT && this._lockedPointer) return;
            const pointer = {
                pointerId: event.pointerId,
                clientX: event.clientX,
                clientY: event.clientY,
                deltaX: 0,
                deltaY: 0,
                mouseButton: mouseButton
            };
            this._activePointers.push(pointer);
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, {
                passive: false
            });
            this._domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
            this._domElement.ownerDocument.addEventListener('pointermove', onPointerMove, {
                passive: false
            });
            this._domElement.ownerDocument.addEventListener('pointerup', onPointerUp);
            this._isDragging = true;
            startDragging(event);
        };
        const onPointerMove = (event)=>{
            if (event.cancelable) event.preventDefault();
            const pointerId = event.pointerId;
            const pointer = this._lockedPointer || this._findPointerById(pointerId);
            if (!pointer) return;
            pointer.clientX = event.clientX;
            pointer.clientY = event.clientY;
            pointer.deltaX = event.movementX;
            pointer.deltaY = event.movementY;
            this._state = 0;
            if (event.pointerType === 'touch') switch(this._activePointers.length){
                case 1:
                    this._state = this.touches.one;
                    break;
                case 2:
                    this._state = this.touches.two;
                    break;
                case 3:
                    this._state = this.touches.three;
                    break;
            }
            else {
                if (!this._isDragging && this._lockedPointer || this._isDragging && (event.buttons & $b52c6c537f7b0cc8$var$MOUSE_BUTTON.LEFT) === $b52c6c537f7b0cc8$var$MOUSE_BUTTON.LEFT) this._state = this._state | this.mouseButtons.left;
                if (this._isDragging && (event.buttons & $b52c6c537f7b0cc8$var$MOUSE_BUTTON.MIDDLE) === $b52c6c537f7b0cc8$var$MOUSE_BUTTON.MIDDLE) this._state = this._state | this.mouseButtons.middle;
                if (this._isDragging && (event.buttons & $b52c6c537f7b0cc8$var$MOUSE_BUTTON.RIGHT) === $b52c6c537f7b0cc8$var$MOUSE_BUTTON.RIGHT) this._state = this._state | this.mouseButtons.right;
            }
            dragging();
        };
        const onPointerUp = (event)=>{
            const pointer = this._findPointerById(event.pointerId);
            if (pointer && pointer === this._lockedPointer) return;
            pointer && this._disposePointer(pointer);
            if (event.pointerType === 'touch') switch(this._activePointers.length){
                case 0:
                    this._state = $b52c6c537f7b0cc8$var$ACTION.NONE;
                    break;
                case 1:
                    this._state = this.touches.one;
                    break;
                case 2:
                    this._state = this.touches.two;
                    break;
                case 3:
                    this._state = this.touches.three;
                    break;
            }
            else this._state = $b52c6c537f7b0cc8$var$ACTION.NONE;
            endDragging();
        };
        let lastScrollTimeStamp = -1;
        const onMouseWheel = (event)=>{
            if (!this._domElement) return;
            if (!this._enabled || this.mouseButtons.wheel === $b52c6c537f7b0cc8$var$ACTION.NONE) return;
            if (this._interactiveArea.left !== 0 || this._interactiveArea.top !== 0 || this._interactiveArea.width !== 1 || this._interactiveArea.height !== 1) {
                const elRect = this._domElement.getBoundingClientRect();
                const left = event.clientX / elRect.width;
                const top = event.clientY / elRect.height;
                // check if the interactiveArea contains the drag start position.
                if (left < this._interactiveArea.left || left > this._interactiveArea.right || top < this._interactiveArea.top || top > this._interactiveArea.bottom) return;
            }
            event.preventDefault();
            if (this.dollyToCursor || this.mouseButtons.wheel === $b52c6c537f7b0cc8$var$ACTION.ROTATE || this.mouseButtons.wheel === $b52c6c537f7b0cc8$var$ACTION.TRUCK) {
                const now = performance.now();
                // only need to fire this at scroll start.
                if (lastScrollTimeStamp - now < 1000) this._getClientRect(this._elementRect);
                lastScrollTimeStamp = now;
            }
            // Ref: https://github.com/cedricpinson/osgjs/blob/00e5a7e9d9206c06fdde0436e1d62ab7cb5ce853/sources/osgViewer/input/source/InputSourceMouse.js#L89-L103
            const deltaYFactor = $b52c6c537f7b0cc8$var$isMac ? -1 : -3;
            // Checks event.ctrlKey to detect multi-touch gestures on a trackpad.
            const delta = event.deltaMode === 1 || event.ctrlKey ? event.deltaY / deltaYFactor : event.deltaY / (deltaYFactor * 10);
            const x = this.dollyToCursor ? (event.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
            const y = this.dollyToCursor ? (event.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
            switch(this.mouseButtons.wheel){
                case $b52c6c537f7b0cc8$var$ACTION.ROTATE:
                    this._rotateInternal(event.deltaX, event.deltaY);
                    this._isUserControllingRotate = true;
                    break;
                case $b52c6c537f7b0cc8$var$ACTION.TRUCK:
                    this._truckInternal(event.deltaX, event.deltaY, false, false);
                    this._isUserControllingTruck = true;
                    break;
                case $b52c6c537f7b0cc8$var$ACTION.SCREEN_PAN:
                    this._truckInternal(event.deltaX, event.deltaY, false, true);
                    this._isUserControllingTruck = true;
                    break;
                case $b52c6c537f7b0cc8$var$ACTION.OFFSET:
                    this._truckInternal(event.deltaX, event.deltaY, true, false);
                    this._isUserControllingOffset = true;
                    break;
                case $b52c6c537f7b0cc8$var$ACTION.DOLLY:
                    this._dollyInternal(-delta, x, y);
                    this._isUserControllingDolly = true;
                    break;
                case $b52c6c537f7b0cc8$var$ACTION.ZOOM:
                    this._zoomInternal(-delta, x, y);
                    this._isUserControllingZoom = true;
                    break;
            }
            this.dispatchEvent({
                type: 'control'
            });
        };
        const onContextMenu = (event)=>{
            if (!this._domElement || !this._enabled) return;
            // contextmenu event is fired right after pointerdown
            // remove attached handlers and active pointer, if interrupted by contextmenu.
            if (this.mouseButtons.right === $b52c6c537f7b0cc8$export$2e2bcd8739ae039.ACTION.NONE) {
                const pointerId = event instanceof PointerEvent ? event.pointerId : 0;
                const pointer = this._findPointerById(pointerId);
                pointer && this._disposePointer(pointer);
                // eslint-disable-next-line no-undef
                this._domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, {
                    passive: false
                });
                this._domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
                return;
            }
            event.preventDefault();
        };
        const startDragging = (event)=>{
            if (!this._enabled) return;
            $b52c6c537f7b0cc8$var$extractClientCoordFromEvent(this._activePointers, $b52c6c537f7b0cc8$var$_v2);
            this._getClientRect(this._elementRect);
            dragStartPosition.copy($b52c6c537f7b0cc8$var$_v2);
            lastDragPosition.copy($b52c6c537f7b0cc8$var$_v2);
            const isMultiTouch = this._activePointers.length >= 2;
            if (isMultiTouch) {
                // 2 finger pinch
                const dx = $b52c6c537f7b0cc8$var$_v2.x - this._activePointers[1].clientX;
                const dy = $b52c6c537f7b0cc8$var$_v2.y - this._activePointers[1].clientY;
                const distance = Math.sqrt(dx * dx + dy * dy);
                dollyStart.set(0, distance);
                // center coords of 2 finger truck
                const x = (this._activePointers[0].clientX + this._activePointers[1].clientX) * 0.5;
                const y = (this._activePointers[0].clientY + this._activePointers[1].clientY) * 0.5;
                lastDragPosition.set(x, y);
            }
            this._state = 0;
            if (!event) {
                if (this._lockedPointer) this._state = this._state | this.mouseButtons.left;
            } else if ('pointerType' in event && event.pointerType === 'touch') switch(this._activePointers.length){
                case 1:
                    this._state = this.touches.one;
                    break;
                case 2:
                    this._state = this.touches.two;
                    break;
                case 3:
                    this._state = this.touches.three;
                    break;
            }
            else {
                if (!this._lockedPointer && (event.buttons & $b52c6c537f7b0cc8$var$MOUSE_BUTTON.LEFT) === $b52c6c537f7b0cc8$var$MOUSE_BUTTON.LEFT) this._state = this._state | this.mouseButtons.left;
                if ((event.buttons & $b52c6c537f7b0cc8$var$MOUSE_BUTTON.MIDDLE) === $b52c6c537f7b0cc8$var$MOUSE_BUTTON.MIDDLE) this._state = this._state | this.mouseButtons.middle;
                if ((event.buttons & $b52c6c537f7b0cc8$var$MOUSE_BUTTON.RIGHT) === $b52c6c537f7b0cc8$var$MOUSE_BUTTON.RIGHT) this._state = this._state | this.mouseButtons.right;
            }
            // stop current movement on drag start
            // - rotate
            if ((this._state & $b52c6c537f7b0cc8$var$ACTION.ROTATE) === $b52c6c537f7b0cc8$var$ACTION.ROTATE || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ROTATE) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ROTATE || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_ROTATE) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_ROTATE || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_ROTATE) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_ROTATE) {
                this._sphericalEnd.theta = this._spherical.theta;
                this._sphericalEnd.phi = this._spherical.phi;
                this._thetaVelocity.value = 0;
                this._phiVelocity.value = 0;
            }
            // - truck and screen-pan
            if ((this._state & $b52c6c537f7b0cc8$var$ACTION.TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.SCREEN_PAN || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_SCREEN_PAN || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_SCREEN_PAN || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_SCREEN_PAN) {
                this._targetEnd.copy(this._target);
                this._targetVelocity.set(0, 0, 0);
            }
            // - dolly
            if ((this._state & $b52c6c537f7b0cc8$var$ACTION.DOLLY) === $b52c6c537f7b0cc8$var$ACTION.DOLLY || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_SCREEN_PAN || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_OFFSET) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_OFFSET || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_ROTATE) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_ROTATE) {
                this._sphericalEnd.radius = this._spherical.radius;
                this._radiusVelocity.value = 0;
            }
            // - zoom
            if ((this._state & $b52c6c537f7b0cc8$var$ACTION.ZOOM) === $b52c6c537f7b0cc8$var$ACTION.ZOOM || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_SCREEN_PAN || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_OFFSET) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_OFFSET || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_ROTATE) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_ROTATE) {
                this._zoomEnd = this._zoom;
                this._zoomVelocity.value = 0;
            }
            // - offset
            if ((this._state & $b52c6c537f7b0cc8$var$ACTION.OFFSET) === $b52c6c537f7b0cc8$var$ACTION.OFFSET || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_OFFSET) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_OFFSET || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_OFFSET) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_OFFSET || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_OFFSET) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_OFFSET) {
                this._focalOffsetEnd.copy(this._focalOffset);
                this._focalOffsetVelocity.set(0, 0, 0);
            }
            this.dispatchEvent({
                type: 'controlstart'
            });
        };
        const dragging = ()=>{
            if (!this._enabled || !this._dragNeedsUpdate) return;
            this._dragNeedsUpdate = false;
            $b52c6c537f7b0cc8$var$extractClientCoordFromEvent(this._activePointers, $b52c6c537f7b0cc8$var$_v2);
            // When pointer lock is enabled clientX, clientY, screenX, and screenY remain 0.
            // If pointer lock is enabled, use the Delta directory, and assume active-pointer is not multiple.
            const isPointerLockActive = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement;
            const lockedPointer = isPointerLockActive ? this._lockedPointer || this._activePointers[0] : null;
            const deltaX = lockedPointer ? -lockedPointer.deltaX : lastDragPosition.x - $b52c6c537f7b0cc8$var$_v2.x;
            const deltaY = lockedPointer ? -lockedPointer.deltaY : lastDragPosition.y - $b52c6c537f7b0cc8$var$_v2.y;
            lastDragPosition.copy($b52c6c537f7b0cc8$var$_v2);
            // rotate
            if ((this._state & $b52c6c537f7b0cc8$var$ACTION.ROTATE) === $b52c6c537f7b0cc8$var$ACTION.ROTATE || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ROTATE) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ROTATE || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_ROTATE) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_ROTATE || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_ROTATE) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_ROTATE) {
                this._rotateInternal(deltaX, deltaY);
                this._isUserControllingRotate = true;
            }
            // mouse dolly or zoom
            if ((this._state & $b52c6c537f7b0cc8$var$ACTION.DOLLY) === $b52c6c537f7b0cc8$var$ACTION.DOLLY || (this._state & $b52c6c537f7b0cc8$var$ACTION.ZOOM) === $b52c6c537f7b0cc8$var$ACTION.ZOOM) {
                const dollyX = this.dollyToCursor ? (dragStartPosition.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
                const dollyY = this.dollyToCursor ? (dragStartPosition.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                const dollyDirection = this.dollyDragInverted ? -1 : 1;
                if ((this._state & $b52c6c537f7b0cc8$var$ACTION.DOLLY) === $b52c6c537f7b0cc8$var$ACTION.DOLLY) {
                    this._dollyInternal(dollyDirection * deltaY * $b52c6c537f7b0cc8$var$TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingDolly = true;
                } else {
                    this._zoomInternal(dollyDirection * deltaY * $b52c6c537f7b0cc8$var$TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingZoom = true;
                }
            }
            // touch dolly or zoom
            if ((this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_SCREEN_PAN || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_SCREEN_PAN || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_OFFSET) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_OFFSET || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_OFFSET) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_OFFSET || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_ROTATE) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_ROTATE || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_ROTATE) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_ROTATE) {
                const dx = $b52c6c537f7b0cc8$var$_v2.x - this._activePointers[1].clientX;
                const dy = $b52c6c537f7b0cc8$var$_v2.y - this._activePointers[1].clientY;
                const distance = Math.sqrt(dx * dx + dy * dy);
                const dollyDelta = dollyStart.y - distance;
                dollyStart.set(0, distance);
                const dollyX = this.dollyToCursor ? (lastDragPosition.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
                const dollyY = this.dollyToCursor ? (lastDragPosition.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                if ((this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_ROTATE) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_ROTATE || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_SCREEN_PAN || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_OFFSET) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_OFFSET) {
                    this._dollyInternal(dollyDelta * $b52c6c537f7b0cc8$var$TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingDolly = true;
                } else {
                    this._zoomInternal(dollyDelta * $b52c6c537f7b0cc8$var$TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingZoom = true;
                }
            }
            // truck
            if ((this._state & $b52c6c537f7b0cc8$var$ACTION.TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_TRUCK || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_TRUCK) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_TRUCK) {
                this._truckInternal(deltaX, deltaY, false, false);
                this._isUserControllingTruck = true;
            }
            // screen-pan
            if ((this._state & $b52c6c537f7b0cc8$var$ACTION.SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.SCREEN_PAN || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_SCREEN_PAN || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_SCREEN_PAN || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_SCREEN_PAN) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_SCREEN_PAN) {
                this._truckInternal(deltaX, deltaY, false, true);
                this._isUserControllingTruck = true;
            }
            // offset
            if ((this._state & $b52c6c537f7b0cc8$var$ACTION.OFFSET) === $b52c6c537f7b0cc8$var$ACTION.OFFSET || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_OFFSET) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_OFFSET || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_OFFSET) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_DOLLY_OFFSET || (this._state & $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_OFFSET) === $b52c6c537f7b0cc8$var$ACTION.TOUCH_ZOOM_OFFSET) {
                this._truckInternal(deltaX, deltaY, true, false);
                this._isUserControllingOffset = true;
            }
            this.dispatchEvent({
                type: 'control'
            });
        };
        const endDragging = ()=>{
            $b52c6c537f7b0cc8$var$extractClientCoordFromEvent(this._activePointers, $b52c6c537f7b0cc8$var$_v2);
            lastDragPosition.copy($b52c6c537f7b0cc8$var$_v2);
            this._dragNeedsUpdate = false;
            if (this._activePointers.length === 0 || this._activePointers.length === 1 && this._activePointers[0] === this._lockedPointer) this._isDragging = false;
            if (this._activePointers.length === 0 && this._domElement) {
                // eslint-disable-next-line no-undef
                this._domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, {
                    passive: false
                });
                this._domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
                this.dispatchEvent({
                    type: 'controlend'
                });
            }
        };
        this.lockPointer = ()=>{
            if (!this._enabled || !this._domElement) return;
            this.cancel();
            // Element.requestPointerLock is allowed to happen without any pointer active - create a faux one for compatibility with controls
            this._lockedPointer = {
                pointerId: -1,
                clientX: 0,
                clientY: 0,
                deltaX: 0,
                deltaY: 0,
                mouseButton: null
            };
            this._activePointers.push(this._lockedPointer);
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, {
                passive: false
            });
            this._domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
            this._domElement.requestPointerLock();
            this._domElement.ownerDocument.addEventListener('pointerlockchange', onPointerLockChange);
            this._domElement.ownerDocument.addEventListener('pointerlockerror', onPointerLockError);
            this._domElement.ownerDocument.addEventListener('pointermove', onPointerMove, {
                passive: false
            });
            this._domElement.ownerDocument.addEventListener('pointerup', onPointerUp);
            startDragging();
        };
        this.unlockPointer = ()=>{
            var _a, _b, _c;
            if (this._lockedPointer !== null) {
                this._disposePointer(this._lockedPointer);
                this._lockedPointer = null;
            }
            (_a = this._domElement) === null || _a === void 0 || _a.ownerDocument.exitPointerLock();
            (_b = this._domElement) === null || _b === void 0 || _b.ownerDocument.removeEventListener('pointerlockchange', onPointerLockChange);
            (_c = this._domElement) === null || _c === void 0 || _c.ownerDocument.removeEventListener('pointerlockerror', onPointerLockError);
            this.cancel();
        };
        const onPointerLockChange = ()=>{
            const isPointerLockActive = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement;
            if (!isPointerLockActive) this.unlockPointer();
        };
        const onPointerLockError = ()=>{
            this.unlockPointer();
        };
        this._addAllEventListeners = (domElement)=>{
            this._domElement = domElement;
            this._domElement.style.touchAction = 'none';
            this._domElement.style.userSelect = 'none';
            this._domElement.style.webkitUserSelect = 'none';
            this._domElement.addEventListener('pointerdown', onPointerDown);
            this._domElement.addEventListener('pointercancel', onPointerUp);
            this._domElement.addEventListener('wheel', onMouseWheel, {
                passive: false
            });
            this._domElement.addEventListener('contextmenu', onContextMenu);
        };
        this._removeAllEventListeners = ()=>{
            if (!this._domElement) return;
            this._domElement.style.touchAction = '';
            this._domElement.style.userSelect = '';
            this._domElement.style.webkitUserSelect = '';
            this._domElement.removeEventListener('pointerdown', onPointerDown);
            this._domElement.removeEventListener('pointercancel', onPointerUp);
            // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener#matching_event_listeners_for_removal
            // > it's probably wise to use the same values used for the call to `addEventListener()` when calling `removeEventListener()`
            // see https://github.com/microsoft/TypeScript/issues/32912#issuecomment-522142969
            // eslint-disable-next-line no-undef
            this._domElement.removeEventListener('wheel', onMouseWheel, {
                passive: false
            });
            this._domElement.removeEventListener('contextmenu', onContextMenu);
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, {
                passive: false
            });
            this._domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
            this._domElement.ownerDocument.removeEventListener('pointerlockchange', onPointerLockChange);
            this._domElement.ownerDocument.removeEventListener('pointerlockerror', onPointerLockError);
        };
        this.cancel = ()=>{
            if (this._state === $b52c6c537f7b0cc8$var$ACTION.NONE) return;
            this._state = $b52c6c537f7b0cc8$var$ACTION.NONE;
            this._activePointers.length = 0;
            endDragging();
        };
        if (domElement) this.connect(domElement);
        this.update(0);
    }
    /**
     * The camera to be controlled
     * @category Properties
     */ get camera() {
        return this._camera;
    }
    set camera(camera) {
        this._camera = camera;
        this.updateCameraUp();
        this._camera.updateProjectionMatrix();
        this._updateNearPlaneCorners();
        this._needsUpdate = true;
    }
    /**
     * Whether or not the controls are enabled.
     * `false` to disable user dragging/touch-move, but all methods works.
     * @category Properties
     */ get enabled() {
        return this._enabled;
    }
    set enabled(enabled) {
        this._enabled = enabled;
        if (!this._domElement) return;
        if (enabled) {
            this._domElement.style.touchAction = 'none';
            this._domElement.style.userSelect = 'none';
            this._domElement.style.webkitUserSelect = 'none';
        } else {
            this.cancel();
            this._domElement.style.touchAction = '';
            this._domElement.style.userSelect = '';
            this._domElement.style.webkitUserSelect = '';
        }
    }
    /**
     * Returns `true` if the controls are active updating.
     * readonly value.
     * @category Properties
     */ get active() {
        return !this._hasRested;
    }
    /**
     * Getter for the current `ACTION`.
     * readonly value.
     * @category Properties
     */ get currentAction() {
        return this._state;
    }
    /**
     * get/set Current distance.
     * @category Properties
     */ get distance() {
        return this._spherical.radius;
    }
    set distance(distance) {
        if (this._spherical.radius === distance && this._sphericalEnd.radius === distance) return;
        this._spherical.radius = distance;
        this._sphericalEnd.radius = distance;
        this._needsUpdate = true;
    }
    // horizontal angle
    /**
     * get/set the azimuth angle (horizontal) in radians.
     * Every 360 degrees turn is added to `.azimuthAngle` value, which is accumulative.
     * @category Properties
     */ get azimuthAngle() {
        return this._spherical.theta;
    }
    set azimuthAngle(azimuthAngle) {
        if (this._spherical.theta === azimuthAngle && this._sphericalEnd.theta === azimuthAngle) return;
        this._spherical.theta = azimuthAngle;
        this._sphericalEnd.theta = azimuthAngle;
        this._needsUpdate = true;
    }
    // vertical angle
    /**
     * get/set the polar angle (vertical) in radians.
     * @category Properties
     */ get polarAngle() {
        return this._spherical.phi;
    }
    set polarAngle(polarAngle) {
        if (this._spherical.phi === polarAngle && this._sphericalEnd.phi === polarAngle) return;
        this._spherical.phi = polarAngle;
        this._sphericalEnd.phi = polarAngle;
        this._needsUpdate = true;
    }
    /**
     * Whether camera position should be enclosed in the boundary or not.
     * @category Properties
     */ get boundaryEnclosesCamera() {
        return this._boundaryEnclosesCamera;
    }
    set boundaryEnclosesCamera(boundaryEnclosesCamera) {
        this._boundaryEnclosesCamera = boundaryEnclosesCamera;
        this._needsUpdate = true;
    }
    /**
     * Set drag-start, touches and wheel enable area in the domElement.
     * each values are between `0` and `1` inclusive, where `0` is left/top and `1` is right/bottom of the screen.
     * e.g. `{ x: 0, y: 0, width: 1, height: 1 }` for entire area.
     * @category Properties
     */ set interactiveArea(interactiveArea) {
        this._interactiveArea.width = $b52c6c537f7b0cc8$var$clamp(interactiveArea.width, 0, 1);
        this._interactiveArea.height = $b52c6c537f7b0cc8$var$clamp(interactiveArea.height, 0, 1);
        this._interactiveArea.x = $b52c6c537f7b0cc8$var$clamp(interactiveArea.x, 0, 1 - this._interactiveArea.width);
        this._interactiveArea.y = $b52c6c537f7b0cc8$var$clamp(interactiveArea.y, 0, 1 - this._interactiveArea.height);
    }
    /**
     * Adds the specified event listener.
     * Applicable event types (which is `K`) are:
     * | Event name          | Timing |
     * | ------------------- | ------ |
     * | `'controlstart'`    | When the user starts to control the camera via mouse / touches. ¹ |
     * | `'control'`         | When the user controls the camera (dragging). |
     * | `'controlend'`      | When the user ends to control the camera. ¹ |
     * | `'transitionstart'` | When any kind of transition starts, either user control or using a method with `enableTransition = true` |
     * | `'update'`          | When the camera position is updated. |
     * | `'wake'`            | When the camera starts moving. |
     * | `'rest'`            | When the camera movement is below `.restThreshold` ². |
     * | `'sleep'`           | When the camera end moving. |
     *
     * 1. `mouseButtons.wheel` (Mouse wheel control) does not emit `'controlstart'` and `'controlend'`. `mouseButtons.wheel` uses scroll-event internally, and scroll-event happens intermittently. That means "start" and "end" cannot be detected.
     * 2. Due to damping, `sleep` will usually fire a few seconds after the camera _appears_ to have stopped moving. If you want to do something (e.g. enable UI, perform another transition) at the point when the camera has stopped, you probably want the `rest` event. This can be fine tuned using the `.restThreshold` parameter. See the [Rest and Sleep Example](https://yomotsu.github.io/camera-controls/examples/rest-and-sleep.html).
     *
     * e.g.
     * ```
     * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
     * ```
     * @param type event name
     * @param listener handler function
     * @category Methods
     */ addEventListener(type, listener) {
        super.addEventListener(type, listener);
    }
    /**
     * Removes the specified event listener
     * e.g.
     * ```
     * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
     * ```
     * @param type event name
     * @param listener handler function
     * @category Methods
     */ removeEventListener(type, listener) {
        super.removeEventListener(type, listener);
    }
    /**
     * Rotate azimuthal angle(horizontal) and polar angle(vertical).
     * Every value is added to the current value.
     * @param azimuthAngle Azimuth rotate angle. In radian.
     * @param polarAngle Polar rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ rotate(azimuthAngle, polarAngle, enableTransition = false) {
        return this.rotateTo(this._sphericalEnd.theta + azimuthAngle, this._sphericalEnd.phi + polarAngle, enableTransition);
    }
    /**
     * Rotate azimuthal angle(horizontal) to the given angle and keep the same polar angle(vertical) target.
     *
     * e.g.
     * ```
     * cameraControls.rotateAzimuthTo( 30 * THREE.MathUtils.DEG2RAD, true );
     * ```
     * @param azimuthAngle Azimuth rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ rotateAzimuthTo(azimuthAngle, enableTransition = false) {
        return this.rotateTo(azimuthAngle, this._sphericalEnd.phi, enableTransition);
    }
    /**
     * Rotate polar angle(vertical) to the given angle and keep the same azimuthal angle(horizontal) target.
     *
     * e.g.
     * ```
     * cameraControls.rotatePolarTo( 30 * THREE.MathUtils.DEG2RAD, true );
     * ```
     * @param polarAngle Polar rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ rotatePolarTo(polarAngle, enableTransition = false) {
        return this.rotateTo(this._sphericalEnd.theta, polarAngle, enableTransition);
    }
    /**
     * Rotate azimuthal angle(horizontal) and polar angle(vertical) to the given angle.
     * Camera view will rotate over the orbit pivot absolutely:
     *
     * azimuthAngle
     * ```
     *       0º
     *         \
     * 90º -----+----- -90º
     *           \
     *           180º
     * ```
     * | direction | angle                  |
     * | --------- | ---------------------- |
     * | front     | 0º                     |
     * | left      | 90º (`Math.PI / 2`)    |
     * | right     | -90º (`- Math.PI / 2`) |
     * | back      | 180º (`Math.PI`)       |
     *
     * polarAngle
     * ```
     *     180º
     *      |
     *      90º
     *      |
     *      0º
     * ```
     * | direction            | angle                  |
     * | -------------------- | ---------------------- |
     * | top/sky              | 180º (`Math.PI`)       |
     * | horizontal from view | 90º (`Math.PI / 2`)    |
     * | bottom/floor         | 0º                     |
     *
     * @param azimuthAngle Azimuth rotate angle to. In radian.
     * @param polarAngle Polar rotate angle to. In radian.
     * @param enableTransition  Whether to move smoothly or immediately
     * @category Methods
     */ rotateTo(azimuthAngle, polarAngle, enableTransition = false) {
        this._isUserControllingRotate = false;
        const theta = $b52c6c537f7b0cc8$var$clamp(azimuthAngle, this.minAzimuthAngle, this.maxAzimuthAngle);
        const phi = $b52c6c537f7b0cc8$var$clamp(polarAngle, this.minPolarAngle, this.maxPolarAngle);
        this._sphericalEnd.theta = theta;
        this._sphericalEnd.phi = phi;
        this._sphericalEnd.makeSafe();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._spherical.theta = this._sphericalEnd.theta;
            this._spherical.phi = this._sphericalEnd.phi;
        }
        const resolveImmediately = !enableTransition || $b52c6c537f7b0cc8$var$approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Dolly in/out camera position.
     * @param distance Distance of dollyIn. Negative number for dollyOut.
     * @param enableTransition Whether to move smoothly or immediately.
     * @category Methods
     */ dolly(distance, enableTransition = false) {
        return this.dollyTo(this._sphericalEnd.radius - distance, enableTransition);
    }
    /**
     * Dolly in/out camera position to given distance.
     * @param distance Distance of dolly.
     * @param enableTransition Whether to move smoothly or immediately.
     * @category Methods
     */ dollyTo(distance, enableTransition = false) {
        this._isUserControllingDolly = false;
        this._lastDollyDirection = $b52c6c537f7b0cc8$var$DOLLY_DIRECTION.NONE;
        this._changedDolly = 0;
        return this._dollyToNoClamp($b52c6c537f7b0cc8$var$clamp(distance, this.minDistance, this.maxDistance), enableTransition);
    }
    _dollyToNoClamp(distance, enableTransition = false) {
        const lastRadius = this._sphericalEnd.radius;
        const hasCollider = this.colliderMeshes.length >= 1;
        if (hasCollider) {
            const maxDistanceByCollisionTest = this._collisionTest();
            const isCollided = $b52c6c537f7b0cc8$var$approxEquals(maxDistanceByCollisionTest, this._spherical.radius);
            const isDollyIn = lastRadius > distance;
            if (!isDollyIn && isCollided) return Promise.resolve();
            this._sphericalEnd.radius = Math.min(distance, maxDistanceByCollisionTest);
        } else this._sphericalEnd.radius = distance;
        this._needsUpdate = true;
        if (!enableTransition) this._spherical.radius = this._sphericalEnd.radius;
        const resolveImmediately = !enableTransition || $b52c6c537f7b0cc8$var$approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Dolly in, but does not change the distance between the target and the camera, and moves the target position instead.
     * Specify a negative value for dolly out.
     * @param distance Distance of dolly.
     * @param enableTransition Whether to move smoothly or immediately.
     * @category Methods
     */ dollyInFixed(distance, enableTransition = false) {
        this._targetEnd.add(this._getCameraDirection($b52c6c537f7b0cc8$var$_cameraDirection).multiplyScalar(distance));
        if (!enableTransition) this._target.copy(this._targetEnd);
        const resolveImmediately = !enableTransition || $b52c6c537f7b0cc8$var$approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._target.z, this._targetEnd.z, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Zoom in/out camera. The value is added to camera zoom.
     * Limits set with `.minZoom` and `.maxZoom`
     * @param zoomStep zoom scale
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ zoom(zoomStep, enableTransition = false) {
        return this.zoomTo(this._zoomEnd + zoomStep, enableTransition);
    }
    /**
     * Zoom in/out camera to given scale. The value overwrites camera zoom.
     * Limits set with .minZoom and .maxZoom
     * @param zoom
     * @param enableTransition
     * @category Methods
     */ zoomTo(zoom, enableTransition = false) {
        this._isUserControllingZoom = false;
        this._zoomEnd = $b52c6c537f7b0cc8$var$clamp(zoom, this.minZoom, this.maxZoom);
        this._needsUpdate = true;
        if (!enableTransition) this._zoom = this._zoomEnd;
        const resolveImmediately = !enableTransition || $b52c6c537f7b0cc8$var$approxEquals(this._zoom, this._zoomEnd, this.restThreshold);
        this._changedZoom = 0;
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * @deprecated `pan()` has been renamed to `truck()`
     * @category Methods
     */ pan(x, y, enableTransition = false) {
        console.warn('`pan` has been renamed to `truck`');
        return this.truck(x, y, enableTransition);
    }
    /**
     * Truck and pedestal camera using current azimuthal angle
     * @param x Horizontal translate amount
     * @param y Vertical translate amount
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ truck(x, y, enableTransition = false) {
        this._camera.updateMatrix();
        $b52c6c537f7b0cc8$var$_xColumn.setFromMatrixColumn(this._camera.matrix, 0);
        $b52c6c537f7b0cc8$var$_yColumn.setFromMatrixColumn(this._camera.matrix, 1);
        $b52c6c537f7b0cc8$var$_xColumn.multiplyScalar(x);
        $b52c6c537f7b0cc8$var$_yColumn.multiplyScalar(-y);
        const offset = $b52c6c537f7b0cc8$var$_v3A.copy($b52c6c537f7b0cc8$var$_xColumn).add($b52c6c537f7b0cc8$var$_yColumn);
        const to = $b52c6c537f7b0cc8$var$_v3B.copy(this._targetEnd).add(offset);
        return this.moveTo(to.x, to.y, to.z, enableTransition);
    }
    /**
     * Move forward / backward.
     * @param distance Amount to move forward / backward. Negative value to move backward
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ forward(distance, enableTransition = false) {
        $b52c6c537f7b0cc8$var$_v3A.setFromMatrixColumn(this._camera.matrix, 0);
        $b52c6c537f7b0cc8$var$_v3A.crossVectors(this._camera.up, $b52c6c537f7b0cc8$var$_v3A);
        $b52c6c537f7b0cc8$var$_v3A.multiplyScalar(distance);
        const to = $b52c6c537f7b0cc8$var$_v3B.copy(this._targetEnd).add($b52c6c537f7b0cc8$var$_v3A);
        return this.moveTo(to.x, to.y, to.z, enableTransition);
    }
    /**
     * Move up / down.
     * @param height Amount to move up / down. Negative value to move down
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ elevate(height, enableTransition = false) {
        $b52c6c537f7b0cc8$var$_v3A.copy(this._camera.up).multiplyScalar(height);
        return this.moveTo(this._targetEnd.x + $b52c6c537f7b0cc8$var$_v3A.x, this._targetEnd.y + $b52c6c537f7b0cc8$var$_v3A.y, this._targetEnd.z + $b52c6c537f7b0cc8$var$_v3A.z, enableTransition);
    }
    /**
     * Move target position to given point.
     * @param x x coord to move center position
     * @param y y coord to move center position
     * @param z z coord to move center position
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ moveTo(x, y, z, enableTransition = false) {
        this._isUserControllingTruck = false;
        const offset = $b52c6c537f7b0cc8$var$_v3A.set(x, y, z).sub(this._targetEnd);
        this._encloseToBoundary(this._targetEnd, offset, this.boundaryFriction);
        this._needsUpdate = true;
        if (!enableTransition) this._target.copy(this._targetEnd);
        const resolveImmediately = !enableTransition || $b52c6c537f7b0cc8$var$approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._target.z, this._targetEnd.z, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Look in the given point direction.
     * @param x point x.
     * @param y point y.
     * @param z point z.
     * @param enableTransition Whether to move smoothly or immediately.
     * @returns Transition end promise
     * @category Methods
     */ lookInDirectionOf(x, y, z, enableTransition = false) {
        const point = $b52c6c537f7b0cc8$var$_v3A.set(x, y, z);
        const direction = point.sub(this._targetEnd).normalize();
        const position = direction.multiplyScalar(-this._sphericalEnd.radius).add(this._targetEnd);
        return this.setPosition(position.x, position.y, position.z, enableTransition);
    }
    /**
     * Fit the viewport to the box or the bounding box of the object, using the nearest axis. paddings are in unit.
     * set `cover: true` to fill enter screen.
     * e.g.
     * ```
     * cameraControls.fitToBox( myMesh );
     * ```
     * @param box3OrObject Axis aligned bounding box to fit the view.
     * @param enableTransition Whether to move smoothly or immediately.
     * @param options | `<object>` { cover: boolean, paddingTop: number, paddingLeft: number, paddingBottom: number, paddingRight: number }
     * @returns Transition end promise
     * @category Methods
     */ fitToBox(box3OrObject, enableTransition, { cover: cover = false, paddingLeft: paddingLeft = 0, paddingRight: paddingRight = 0, paddingBottom: paddingBottom = 0, paddingTop: paddingTop = 0 } = {}) {
        const promises = [];
        const aabb = box3OrObject.isBox3 ? $b52c6c537f7b0cc8$var$_box3A.copy(box3OrObject) : $b52c6c537f7b0cc8$var$_box3A.setFromObject(box3OrObject);
        if (aabb.isEmpty()) {
            console.warn('camera-controls: fitTo() cannot be used with an empty box. Aborting');
            Promise.resolve();
        }
        // round to closest axis ( forward | backward | right | left | top | bottom )
        const theta = $b52c6c537f7b0cc8$var$roundToStep(this._sphericalEnd.theta, $b52c6c537f7b0cc8$var$PI_HALF);
        const phi = $b52c6c537f7b0cc8$var$roundToStep(this._sphericalEnd.phi, $b52c6c537f7b0cc8$var$PI_HALF);
        promises.push(this.rotateTo(theta, phi, enableTransition));
        const normal = $b52c6c537f7b0cc8$var$_v3A.setFromSpherical(this._sphericalEnd).normalize();
        const rotation = $b52c6c537f7b0cc8$var$_quaternionA.setFromUnitVectors(normal, $b52c6c537f7b0cc8$var$_AXIS_Z);
        const viewFromPolar = $b52c6c537f7b0cc8$var$approxEquals(Math.abs(normal.y), 1);
        if (viewFromPolar) rotation.multiply($b52c6c537f7b0cc8$var$_quaternionB.setFromAxisAngle($b52c6c537f7b0cc8$var$_AXIS_Y, theta));
        rotation.multiply(this._yAxisUpSpaceInverse);
        // make oriented bounding box
        const bb = $b52c6c537f7b0cc8$var$_box3B.makeEmpty();
        // left bottom back corner
        $b52c6c537f7b0cc8$var$_v3B.copy(aabb.min).applyQuaternion(rotation);
        bb.expandByPoint($b52c6c537f7b0cc8$var$_v3B);
        // right bottom back corner
        $b52c6c537f7b0cc8$var$_v3B.copy(aabb.min).setX(aabb.max.x).applyQuaternion(rotation);
        bb.expandByPoint($b52c6c537f7b0cc8$var$_v3B);
        // left top back corner
        $b52c6c537f7b0cc8$var$_v3B.copy(aabb.min).setY(aabb.max.y).applyQuaternion(rotation);
        bb.expandByPoint($b52c6c537f7b0cc8$var$_v3B);
        // right top back corner
        $b52c6c537f7b0cc8$var$_v3B.copy(aabb.max).setZ(aabb.min.z).applyQuaternion(rotation);
        bb.expandByPoint($b52c6c537f7b0cc8$var$_v3B);
        // left bottom front corner
        $b52c6c537f7b0cc8$var$_v3B.copy(aabb.min).setZ(aabb.max.z).applyQuaternion(rotation);
        bb.expandByPoint($b52c6c537f7b0cc8$var$_v3B);
        // right bottom front corner
        $b52c6c537f7b0cc8$var$_v3B.copy(aabb.max).setY(aabb.min.y).applyQuaternion(rotation);
        bb.expandByPoint($b52c6c537f7b0cc8$var$_v3B);
        // left top front corner
        $b52c6c537f7b0cc8$var$_v3B.copy(aabb.max).setX(aabb.min.x).applyQuaternion(rotation);
        bb.expandByPoint($b52c6c537f7b0cc8$var$_v3B);
        // right top front corner
        $b52c6c537f7b0cc8$var$_v3B.copy(aabb.max).applyQuaternion(rotation);
        bb.expandByPoint($b52c6c537f7b0cc8$var$_v3B);
        // add padding
        bb.min.x -= paddingLeft;
        bb.min.y -= paddingBottom;
        bb.max.x += paddingRight;
        bb.max.y += paddingTop;
        rotation.setFromUnitVectors($b52c6c537f7b0cc8$var$_AXIS_Z, normal);
        if (viewFromPolar) rotation.premultiply($b52c6c537f7b0cc8$var$_quaternionB.invert());
        rotation.premultiply(this._yAxisUpSpace);
        const bbSize = bb.getSize($b52c6c537f7b0cc8$var$_v3A);
        const center = bb.getCenter($b52c6c537f7b0cc8$var$_v3B).applyQuaternion(rotation);
        if ($b52c6c537f7b0cc8$var$isPerspectiveCamera(this._camera)) {
            const distance = this.getDistanceToFitBox(bbSize.x, bbSize.y, bbSize.z, cover);
            promises.push(this.moveTo(center.x, center.y, center.z, enableTransition));
            promises.push(this.dollyTo(distance, enableTransition));
            promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        } else if ($b52c6c537f7b0cc8$var$isOrthographicCamera(this._camera)) {
            const camera = this._camera;
            const width = camera.right - camera.left;
            const height = camera.top - camera.bottom;
            const zoom = cover ? Math.max(width / bbSize.x, height / bbSize.y) : Math.min(width / bbSize.x, height / bbSize.y);
            promises.push(this.moveTo(center.x, center.y, center.z, enableTransition));
            promises.push(this.zoomTo(zoom, enableTransition));
            promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        }
        return Promise.all(promises);
    }
    /**
     * Fit the viewport to the sphere or the bounding sphere of the object.
     * @param sphereOrMesh
     * @param enableTransition
     * @category Methods
     */ fitToSphere(sphereOrMesh, enableTransition) {
        const promises = [];
        const isObject3D = 'isObject3D' in sphereOrMesh;
        const boundingSphere = isObject3D ? $b52c6c537f7b0cc8$export$2e2bcd8739ae039.createBoundingSphere(sphereOrMesh, $b52c6c537f7b0cc8$var$_sphere) : $b52c6c537f7b0cc8$var$_sphere.copy(sphereOrMesh);
        promises.push(this.moveTo(boundingSphere.center.x, boundingSphere.center.y, boundingSphere.center.z, enableTransition));
        if ($b52c6c537f7b0cc8$var$isPerspectiveCamera(this._camera)) {
            const distanceToFit = this.getDistanceToFitSphere(boundingSphere.radius);
            promises.push(this.dollyTo(distanceToFit, enableTransition));
        } else if ($b52c6c537f7b0cc8$var$isOrthographicCamera(this._camera)) {
            const width = this._camera.right - this._camera.left;
            const height = this._camera.top - this._camera.bottom;
            const diameter = 2 * boundingSphere.radius;
            const zoom = Math.min(width / diameter, height / diameter);
            promises.push(this.zoomTo(zoom, enableTransition));
        }
        promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        return Promise.all(promises);
    }
    /**
     * Look at the `target` from the `position`.
     * @param positionX
     * @param positionY
     * @param positionZ
     * @param targetX
     * @param targetY
     * @param targetZ
     * @param enableTransition
     * @category Methods
     */ setLookAt(positionX, positionY, positionZ, targetX, targetY, targetZ, enableTransition = false) {
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        this._lastDollyDirection = $b52c6c537f7b0cc8$var$DOLLY_DIRECTION.NONE;
        this._changedDolly = 0;
        const target = $b52c6c537f7b0cc8$var$_v3B.set(targetX, targetY, targetZ);
        const position = $b52c6c537f7b0cc8$var$_v3A.set(positionX, positionY, positionZ);
        this._targetEnd.copy(target);
        this._sphericalEnd.setFromVector3(position.sub(target).applyQuaternion(this._yAxisUpSpace));
        this.normalizeRotations();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._target.copy(this._targetEnd);
            this._spherical.copy(this._sphericalEnd);
        }
        const resolveImmediately = !enableTransition || $b52c6c537f7b0cc8$var$approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._target.z, this._targetEnd.z, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Similar to setLookAt, but it interpolates between two states.
     * @param positionAX
     * @param positionAY
     * @param positionAZ
     * @param targetAX
     * @param targetAY
     * @param targetAZ
     * @param positionBX
     * @param positionBY
     * @param positionBZ
     * @param targetBX
     * @param targetBY
     * @param targetBZ
     * @param t
     * @param enableTransition
     * @category Methods
     */ lerpLookAt(positionAX, positionAY, positionAZ, targetAX, targetAY, targetAZ, positionBX, positionBY, positionBZ, targetBX, targetBY, targetBZ, t, enableTransition = false) {
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        this._lastDollyDirection = $b52c6c537f7b0cc8$var$DOLLY_DIRECTION.NONE;
        this._changedDolly = 0;
        const targetA = $b52c6c537f7b0cc8$var$_v3A.set(targetAX, targetAY, targetAZ);
        const positionA = $b52c6c537f7b0cc8$var$_v3B.set(positionAX, positionAY, positionAZ);
        $b52c6c537f7b0cc8$var$_sphericalA.setFromVector3(positionA.sub(targetA).applyQuaternion(this._yAxisUpSpace));
        const targetB = $b52c6c537f7b0cc8$var$_v3C.set(targetBX, targetBY, targetBZ);
        const positionB = $b52c6c537f7b0cc8$var$_v3B.set(positionBX, positionBY, positionBZ);
        $b52c6c537f7b0cc8$var$_sphericalB.setFromVector3(positionB.sub(targetB).applyQuaternion(this._yAxisUpSpace));
        this._targetEnd.copy(targetA.lerp(targetB, t)); // tricky
        const deltaTheta = $b52c6c537f7b0cc8$var$_sphericalB.theta - $b52c6c537f7b0cc8$var$_sphericalA.theta;
        const deltaPhi = $b52c6c537f7b0cc8$var$_sphericalB.phi - $b52c6c537f7b0cc8$var$_sphericalA.phi;
        const deltaRadius = $b52c6c537f7b0cc8$var$_sphericalB.radius - $b52c6c537f7b0cc8$var$_sphericalA.radius;
        this._sphericalEnd.set($b52c6c537f7b0cc8$var$_sphericalA.radius + deltaRadius * t, $b52c6c537f7b0cc8$var$_sphericalA.phi + deltaPhi * t, $b52c6c537f7b0cc8$var$_sphericalA.theta + deltaTheta * t);
        this.normalizeRotations();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._target.copy(this._targetEnd);
            this._spherical.copy(this._sphericalEnd);
        }
        const resolveImmediately = !enableTransition || $b52c6c537f7b0cc8$var$approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._target.z, this._targetEnd.z, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Set angle and distance by given position.
     * An alias of `setLookAt()`, without target change. Thus keep gazing at the current target
     * @param positionX
     * @param positionY
     * @param positionZ
     * @param enableTransition
     * @category Methods
     */ setPosition(positionX, positionY, positionZ, enableTransition = false) {
        return this.setLookAt(positionX, positionY, positionZ, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, enableTransition);
    }
    /**
     * Set the target position where gaze at.
     * An alias of `setLookAt()`, without position change. Thus keep the same position.
     * @param targetX
     * @param targetY
     * @param targetZ
     * @param enableTransition
     * @category Methods
     */ setTarget(targetX, targetY, targetZ, enableTransition = false) {
        const pos = this.getPosition($b52c6c537f7b0cc8$var$_v3A);
        const promise = this.setLookAt(pos.x, pos.y, pos.z, targetX, targetY, targetZ, enableTransition);
        // see https://github.com/yomotsu/camera-controls/issues/335
        this._sphericalEnd.phi = $b52c6c537f7b0cc8$var$clamp(this._sphericalEnd.phi, this.minPolarAngle, this.maxPolarAngle);
        return promise;
    }
    /**
     * Set focal offset using the screen parallel coordinates. z doesn't affect in Orthographic as with Dolly.
     * @param x
     * @param y
     * @param z
     * @param enableTransition
     * @category Methods
     */ setFocalOffset(x, y, z, enableTransition = false) {
        this._isUserControllingOffset = false;
        this._focalOffsetEnd.set(x, y, z);
        this._needsUpdate = true;
        if (!enableTransition) this._focalOffset.copy(this._focalOffsetEnd);
        const resolveImmediately = !enableTransition || $b52c6c537f7b0cc8$var$approxEquals(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) && $b52c6c537f7b0cc8$var$approxEquals(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Set orbit point without moving the camera.
     * SHOULD NOT RUN DURING ANIMATIONS. `setOrbitPoint()` will immediately fix the positions.
     * @param targetX
     * @param targetY
     * @param targetZ
     * @category Methods
     */ setOrbitPoint(targetX, targetY, targetZ) {
        this._camera.updateMatrixWorld();
        $b52c6c537f7b0cc8$var$_xColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 0);
        $b52c6c537f7b0cc8$var$_yColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 1);
        $b52c6c537f7b0cc8$var$_zColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
        const position = $b52c6c537f7b0cc8$var$_v3A.set(targetX, targetY, targetZ);
        const distance = position.distanceTo(this._camera.position);
        const cameraToPoint = position.sub(this._camera.position);
        $b52c6c537f7b0cc8$var$_xColumn.multiplyScalar(cameraToPoint.x);
        $b52c6c537f7b0cc8$var$_yColumn.multiplyScalar(cameraToPoint.y);
        $b52c6c537f7b0cc8$var$_zColumn.multiplyScalar(cameraToPoint.z);
        $b52c6c537f7b0cc8$var$_v3A.copy($b52c6c537f7b0cc8$var$_xColumn).add($b52c6c537f7b0cc8$var$_yColumn).add($b52c6c537f7b0cc8$var$_zColumn);
        $b52c6c537f7b0cc8$var$_v3A.z = $b52c6c537f7b0cc8$var$_v3A.z + distance;
        this.dollyTo(distance, false);
        this.setFocalOffset(-$b52c6c537f7b0cc8$var$_v3A.x, $b52c6c537f7b0cc8$var$_v3A.y, -$b52c6c537f7b0cc8$var$_v3A.z, false);
        this.moveTo(targetX, targetY, targetZ, false);
    }
    /**
     * Set the boundary box that encloses the target of the camera. box3 is in THREE.Box3
     * @param box3
     * @category Methods
     */ setBoundary(box3) {
        if (!box3) {
            this._boundary.min.set(-Infinity, -Infinity, -Infinity);
            this._boundary.max.set(Infinity, Infinity, Infinity);
            this._needsUpdate = true;
            return;
        }
        this._boundary.copy(box3);
        this._boundary.clampPoint(this._targetEnd, this._targetEnd);
        this._needsUpdate = true;
    }
    /**
     * Set (or unset) the current viewport.
     * Set this when you want to use renderer viewport and .dollyToCursor feature at the same time.
     * @param viewportOrX
     * @param y
     * @param width
     * @param height
     * @category Methods
     */ setViewport(viewportOrX, y, width, height) {
        if (viewportOrX === null) {
            this._viewport = null;
            return;
        }
        this._viewport = this._viewport || new $b52c6c537f7b0cc8$var$THREE.Vector4();
        if (typeof viewportOrX === 'number') this._viewport.set(viewportOrX, y, width, height);
        else this._viewport.copy(viewportOrX);
    }
    /**
     * Calculate the distance to fit the box.
     * @param width box width
     * @param height box height
     * @param depth box depth
     * @returns distance
     * @category Methods
     */ getDistanceToFitBox(width, height, depth, cover = false) {
        if ($b52c6c537f7b0cc8$var$notSupportedInOrthographicCamera(this._camera, 'getDistanceToFitBox')) return this._spherical.radius;
        const boundingRectAspect = width / height;
        const fov = this._camera.getEffectiveFOV() * $b52c6c537f7b0cc8$var$DEG2RAD;
        const aspect = this._camera.aspect;
        const heightToFit = (cover ? boundingRectAspect > aspect : boundingRectAspect < aspect) ? height : width / aspect;
        return heightToFit * 0.5 / Math.tan(fov * 0.5) + depth * 0.5;
    }
    /**
     * Calculate the distance to fit the sphere.
     * @param radius sphere radius
     * @returns distance
     * @category Methods
     */ getDistanceToFitSphere(radius) {
        if ($b52c6c537f7b0cc8$var$notSupportedInOrthographicCamera(this._camera, 'getDistanceToFitSphere')) return this._spherical.radius;
        // https://stackoverflow.com/a/44849975
        const vFOV = this._camera.getEffectiveFOV() * $b52c6c537f7b0cc8$var$DEG2RAD;
        const hFOV = Math.atan(Math.tan(vFOV * 0.5) * this._camera.aspect) * 2;
        const fov = 1 < this._camera.aspect ? vFOV : hFOV;
        return radius / Math.sin(fov * 0.5);
    }
    /**
     * Returns the orbit center position, where the camera looking at.
     * @param out The receiving Vector3 instance to copy the result
     * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
     * @category Methods
     */ getTarget(out, receiveEndValue = true) {
        const _out = !!out && out.isVector3 ? out : new $b52c6c537f7b0cc8$var$THREE.Vector3();
        return _out.copy(receiveEndValue ? this._targetEnd : this._target);
    }
    /**
     * Returns the camera position.
     * @param out The receiving Vector3 instance to copy the result
     * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
     * @category Methods
     */ getPosition(out, receiveEndValue = true) {
        const _out = !!out && out.isVector3 ? out : new $b52c6c537f7b0cc8$var$THREE.Vector3();
        return _out.setFromSpherical(receiveEndValue ? this._sphericalEnd : this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(receiveEndValue ? this._targetEnd : this._target);
    }
    /**
     * Returns the spherical coordinates of the orbit.
     * @param out The receiving Spherical instance to copy the result
     * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
     * @category Methods
     */ getSpherical(out, receiveEndValue = true) {
        const _out = out || new $b52c6c537f7b0cc8$var$THREE.Spherical();
        return _out.copy(receiveEndValue ? this._sphericalEnd : this._spherical);
    }
    /**
     * Returns the focal offset, which is how much the camera appears to be translated in screen parallel coordinates.
     * @param out The receiving Vector3 instance to copy the result
     * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
     * @category Methods
     */ getFocalOffset(out, receiveEndValue = true) {
        const _out = !!out && out.isVector3 ? out : new $b52c6c537f7b0cc8$var$THREE.Vector3();
        return _out.copy(receiveEndValue ? this._focalOffsetEnd : this._focalOffset);
    }
    /**
     * Normalize camera azimuth angle rotation between 0 and 360 degrees.
     * @category Methods
     */ normalizeRotations() {
        this._sphericalEnd.theta = this._sphericalEnd.theta % $b52c6c537f7b0cc8$var$PI_2;
        if (this._sphericalEnd.theta < 0) this._sphericalEnd.theta += $b52c6c537f7b0cc8$var$PI_2;
        this._spherical.theta += $b52c6c537f7b0cc8$var$PI_2 * Math.round((this._sphericalEnd.theta - this._spherical.theta) / $b52c6c537f7b0cc8$var$PI_2);
    }
    /**
     * stop all transitions.
     */ stop() {
        this._focalOffset.copy(this._focalOffsetEnd);
        this._target.copy(this._targetEnd);
        this._spherical.copy(this._sphericalEnd);
        this._zoom = this._zoomEnd;
    }
    /**
     * Reset all rotation and position to defaults.
     * @param enableTransition
     * @category Methods
     */ reset(enableTransition = false) {
        if (!$b52c6c537f7b0cc8$var$approxEquals(this._camera.up.x, this._cameraUp0.x) || !$b52c6c537f7b0cc8$var$approxEquals(this._camera.up.y, this._cameraUp0.y) || !$b52c6c537f7b0cc8$var$approxEquals(this._camera.up.z, this._cameraUp0.z)) {
            this._camera.up.copy(this._cameraUp0);
            const position = this.getPosition($b52c6c537f7b0cc8$var$_v3A);
            this.updateCameraUp();
            this.setPosition(position.x, position.y, position.z);
        }
        const promises = [
            this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, enableTransition),
            this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, enableTransition),
            this.zoomTo(this._zoom0, enableTransition)
        ];
        return Promise.all(promises);
    }
    /**
     * Set current camera position as the default position.
     * @category Methods
     */ saveState() {
        this._cameraUp0.copy(this._camera.up);
        this.getTarget(this._target0);
        this.getPosition(this._position0);
        this._zoom0 = this._zoom;
        this._focalOffset0.copy(this._focalOffset);
    }
    /**
     * Sync camera-up direction.
     * When camera-up vector is changed, `.updateCameraUp()` must be called.
     * @category Methods
     */ updateCameraUp() {
        this._yAxisUpSpace.setFromUnitVectors(this._camera.up, $b52c6c537f7b0cc8$var$_AXIS_Y);
        this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
    }
    /**
     * Apply current camera-up direction to the camera.
     * The orbit system will be re-initialized with the current position.
     * @category Methods
     */ applyCameraUp() {
        const cameraDirection = $b52c6c537f7b0cc8$var$_v3A.subVectors(this._target, this._camera.position).normalize();
        // So first find the vector off to the side, orthogonal to both this.object.up and
        // the "view" vector.
        const side = $b52c6c537f7b0cc8$var$_v3B.crossVectors(cameraDirection, this._camera.up);
        // Then find the vector orthogonal to both this "side" vector and the "view" vector.
        // This vector will be the new "up" vector.
        this._camera.up.crossVectors(side, cameraDirection).normalize();
        this._camera.updateMatrixWorld();
        const position = this.getPosition($b52c6c537f7b0cc8$var$_v3A);
        this.updateCameraUp();
        this.setPosition(position.x, position.y, position.z);
    }
    /**
     * Update camera position and directions.
     * This should be called in your tick loop every time, and returns true if re-rendering is needed.
     * @param delta
     * @returns updated
     * @category Methods
     */ update(delta) {
        const deltaTheta = this._sphericalEnd.theta - this._spherical.theta;
        const deltaPhi = this._sphericalEnd.phi - this._spherical.phi;
        const deltaRadius = this._sphericalEnd.radius - this._spherical.radius;
        const deltaTarget = $b52c6c537f7b0cc8$var$_deltaTarget.subVectors(this._targetEnd, this._target);
        const deltaOffset = $b52c6c537f7b0cc8$var$_deltaOffset.subVectors(this._focalOffsetEnd, this._focalOffset);
        const deltaZoom = this._zoomEnd - this._zoom;
        // update theta
        if ($b52c6c537f7b0cc8$var$approxZero(deltaTheta)) {
            this._thetaVelocity.value = 0;
            this._spherical.theta = this._sphericalEnd.theta;
        } else {
            const smoothTime = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.theta = $b52c6c537f7b0cc8$var$smoothDamp(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, smoothTime, Infinity, delta);
            this._needsUpdate = true;
        }
        // update phi
        if ($b52c6c537f7b0cc8$var$approxZero(deltaPhi)) {
            this._phiVelocity.value = 0;
            this._spherical.phi = this._sphericalEnd.phi;
        } else {
            const smoothTime = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.phi = $b52c6c537f7b0cc8$var$smoothDamp(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, smoothTime, Infinity, delta);
            this._needsUpdate = true;
        }
        // update distance
        if ($b52c6c537f7b0cc8$var$approxZero(deltaRadius)) {
            this._radiusVelocity.value = 0;
            this._spherical.radius = this._sphericalEnd.radius;
        } else {
            const smoothTime = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.radius = $b52c6c537f7b0cc8$var$smoothDamp(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, smoothTime, this.maxSpeed, delta);
            this._needsUpdate = true;
        }
        // update target position
        if ($b52c6c537f7b0cc8$var$approxZero(deltaTarget.x) && $b52c6c537f7b0cc8$var$approxZero(deltaTarget.y) && $b52c6c537f7b0cc8$var$approxZero(deltaTarget.z)) {
            this._targetVelocity.set(0, 0, 0);
            this._target.copy(this._targetEnd);
        } else {
            const smoothTime = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
            $b52c6c537f7b0cc8$var$smoothDampVec3(this._target, this._targetEnd, this._targetVelocity, smoothTime, this.maxSpeed, delta, this._target);
            this._needsUpdate = true;
        }
        // update focalOffset
        if ($b52c6c537f7b0cc8$var$approxZero(deltaOffset.x) && $b52c6c537f7b0cc8$var$approxZero(deltaOffset.y) && $b52c6c537f7b0cc8$var$approxZero(deltaOffset.z)) {
            this._focalOffsetVelocity.set(0, 0, 0);
            this._focalOffset.copy(this._focalOffsetEnd);
        } else {
            const smoothTime = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
            $b52c6c537f7b0cc8$var$smoothDampVec3(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, smoothTime, this.maxSpeed, delta, this._focalOffset);
            this._needsUpdate = true;
        }
        // update zoom
        if ($b52c6c537f7b0cc8$var$approxZero(deltaZoom)) {
            this._zoomVelocity.value = 0;
            this._zoom = this._zoomEnd;
        } else {
            const smoothTime = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
            this._zoom = $b52c6c537f7b0cc8$var$smoothDamp(this._zoom, this._zoomEnd, this._zoomVelocity, smoothTime, Infinity, delta);
        }
        if (this.dollyToCursor) {
            if ($b52c6c537f7b0cc8$var$isPerspectiveCamera(this._camera) && this._changedDolly !== 0) {
                const dollyControlAmount = this._spherical.radius - this._lastDistance;
                const camera = this._camera;
                const cameraDirection = this._getCameraDirection($b52c6c537f7b0cc8$var$_cameraDirection);
                const planeX = $b52c6c537f7b0cc8$var$_v3A.copy(cameraDirection).cross(camera.up).normalize();
                if (planeX.lengthSq() === 0) planeX.x = 1.0;
                const planeY = $b52c6c537f7b0cc8$var$_v3B.crossVectors(planeX, cameraDirection);
                const worldToScreen = this._sphericalEnd.radius * Math.tan(camera.getEffectiveFOV() * $b52c6c537f7b0cc8$var$DEG2RAD * 0.5);
                const prevRadius = this._sphericalEnd.radius - dollyControlAmount;
                const lerpRatio = (prevRadius - this._sphericalEnd.radius) / this._sphericalEnd.radius;
                const cursor = $b52c6c537f7b0cc8$var$_v3C.copy(this._targetEnd).add(planeX.multiplyScalar(this._dollyControlCoord.x * worldToScreen * camera.aspect)).add(planeY.multiplyScalar(this._dollyControlCoord.y * worldToScreen));
                const newTargetEnd = $b52c6c537f7b0cc8$var$_v3A.copy(this._targetEnd).lerp(cursor, lerpRatio);
                const isMin = this._lastDollyDirection === $b52c6c537f7b0cc8$var$DOLLY_DIRECTION.IN && this._spherical.radius <= this.minDistance;
                const isMax = this._lastDollyDirection === $b52c6c537f7b0cc8$var$DOLLY_DIRECTION.OUT && this.maxDistance <= this._spherical.radius;
                if (this.infinityDolly && (isMin || isMax)) {
                    this._sphericalEnd.radius -= dollyControlAmount;
                    this._spherical.radius -= dollyControlAmount;
                    const dollyAmount = $b52c6c537f7b0cc8$var$_v3B.copy(cameraDirection).multiplyScalar(-dollyControlAmount);
                    newTargetEnd.add(dollyAmount);
                }
                // target position may be moved beyond boundary.
                this._boundary.clampPoint(newTargetEnd, newTargetEnd);
                const targetEndDiff = $b52c6c537f7b0cc8$var$_v3B.subVectors(newTargetEnd, this._targetEnd);
                this._targetEnd.copy(newTargetEnd);
                this._target.add(targetEndDiff);
                this._changedDolly -= dollyControlAmount;
                if ($b52c6c537f7b0cc8$var$approxZero(this._changedDolly)) this._changedDolly = 0;
            } else if ($b52c6c537f7b0cc8$var$isOrthographicCamera(this._camera) && this._changedZoom !== 0) {
                const dollyControlAmount = this._zoom - this._lastZoom;
                const camera = this._camera;
                const worldCursorPosition = $b52c6c537f7b0cc8$var$_v3A.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera);
                const quaternion = $b52c6c537f7b0cc8$var$_v3B.set(0, 0, -1).applyQuaternion(camera.quaternion);
                const cursor = $b52c6c537f7b0cc8$var$_v3C.copy(worldCursorPosition).add(quaternion.multiplyScalar(-worldCursorPosition.dot(camera.up)));
                const prevZoom = this._zoom - dollyControlAmount;
                const lerpRatio = -(prevZoom - this._zoom) / this._zoom;
                // find the "distance" (aka plane constant in three.js) of Plane
                // from a given position (this._targetEnd) and normal vector (cameraDirection)
                // https://www.maplesoft.com/support/help/maple/view.aspx?path=MathApps%2FEquationOfAPlaneNormal#bkmrk0
                const cameraDirection = this._getCameraDirection($b52c6c537f7b0cc8$var$_cameraDirection);
                const prevPlaneConstant = this._targetEnd.dot(cameraDirection);
                const newTargetEnd = $b52c6c537f7b0cc8$var$_v3A.copy(this._targetEnd).lerp(cursor, lerpRatio);
                const newPlaneConstant = newTargetEnd.dot(cameraDirection);
                // Pull back the camera depth that has moved, to be the camera stationary as zoom
                const pullBack = cameraDirection.multiplyScalar(newPlaneConstant - prevPlaneConstant);
                newTargetEnd.sub(pullBack);
                // target position may be moved beyond boundary.
                this._boundary.clampPoint(newTargetEnd, newTargetEnd);
                const targetEndDiff = $b52c6c537f7b0cc8$var$_v3B.subVectors(newTargetEnd, this._targetEnd);
                this._targetEnd.copy(newTargetEnd);
                this._target.add(targetEndDiff);
                // this._target.copy( this._targetEnd );
                this._changedZoom -= dollyControlAmount;
                if ($b52c6c537f7b0cc8$var$approxZero(this._changedZoom)) this._changedZoom = 0;
            }
        }
        if (this._camera.zoom !== this._zoom) {
            this._camera.zoom = this._zoom;
            this._camera.updateProjectionMatrix();
            this._updateNearPlaneCorners();
            this._needsUpdate = true;
        }
        this._dragNeedsUpdate = true;
        // collision detection
        const maxDistance = this._collisionTest();
        this._spherical.radius = Math.min(this._spherical.radius, maxDistance);
        // decompose spherical to the camera position
        this._spherical.makeSafe();
        this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target);
        this._camera.lookAt(this._target);
        // set offset after the orbit movement
        const affectOffset = !$b52c6c537f7b0cc8$var$approxZero(this._focalOffset.x) || !$b52c6c537f7b0cc8$var$approxZero(this._focalOffset.y) || !$b52c6c537f7b0cc8$var$approxZero(this._focalOffset.z);
        if (affectOffset) {
            $b52c6c537f7b0cc8$var$_xColumn.setFromMatrixColumn(this._camera.matrix, 0);
            $b52c6c537f7b0cc8$var$_yColumn.setFromMatrixColumn(this._camera.matrix, 1);
            $b52c6c537f7b0cc8$var$_zColumn.setFromMatrixColumn(this._camera.matrix, 2);
            $b52c6c537f7b0cc8$var$_xColumn.multiplyScalar(this._focalOffset.x);
            $b52c6c537f7b0cc8$var$_yColumn.multiplyScalar(-this._focalOffset.y);
            $b52c6c537f7b0cc8$var$_zColumn.multiplyScalar(this._focalOffset.z); // notice: z-offset will not affect in Orthographic.
            $b52c6c537f7b0cc8$var$_v3A.copy($b52c6c537f7b0cc8$var$_xColumn).add($b52c6c537f7b0cc8$var$_yColumn).add($b52c6c537f7b0cc8$var$_zColumn);
            this._camera.position.add($b52c6c537f7b0cc8$var$_v3A);
            this._camera.updateMatrixWorld();
        }
        if (this._boundaryEnclosesCamera) this._encloseToBoundary(this._camera.position.copy(this._target), $b52c6c537f7b0cc8$var$_v3A.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1.0);
        const updated = this._needsUpdate;
        if (updated && !this._updatedLastTime) {
            this._hasRested = false;
            this.dispatchEvent({
                type: 'wake'
            });
            this.dispatchEvent({
                type: 'update'
            });
        } else if (updated) {
            this.dispatchEvent({
                type: 'update'
            });
            if ($b52c6c537f7b0cc8$var$approxZero(deltaTheta, this.restThreshold) && $b52c6c537f7b0cc8$var$approxZero(deltaPhi, this.restThreshold) && $b52c6c537f7b0cc8$var$approxZero(deltaRadius, this.restThreshold) && $b52c6c537f7b0cc8$var$approxZero(deltaTarget.x, this.restThreshold) && $b52c6c537f7b0cc8$var$approxZero(deltaTarget.y, this.restThreshold) && $b52c6c537f7b0cc8$var$approxZero(deltaTarget.z, this.restThreshold) && $b52c6c537f7b0cc8$var$approxZero(deltaOffset.x, this.restThreshold) && $b52c6c537f7b0cc8$var$approxZero(deltaOffset.y, this.restThreshold) && $b52c6c537f7b0cc8$var$approxZero(deltaOffset.z, this.restThreshold) && $b52c6c537f7b0cc8$var$approxZero(deltaZoom, this.restThreshold) && !this._hasRested) {
                this._hasRested = true;
                this.dispatchEvent({
                    type: 'rest'
                });
            }
        } else if (!updated && this._updatedLastTime) this.dispatchEvent({
            type: 'sleep'
        });
        this._lastDistance = this._spherical.radius;
        this._lastZoom = this._zoom;
        this._updatedLastTime = updated;
        this._needsUpdate = false;
        return updated;
    }
    /**
     * Get all state in JSON string
     * @category Methods
     */ toJSON() {
        return JSON.stringify({
            enabled: this._enabled,
            minDistance: this.minDistance,
            maxDistance: $b52c6c537f7b0cc8$var$infinityToMaxNumber(this.maxDistance),
            minZoom: this.minZoom,
            maxZoom: $b52c6c537f7b0cc8$var$infinityToMaxNumber(this.maxZoom),
            minPolarAngle: this.minPolarAngle,
            maxPolarAngle: $b52c6c537f7b0cc8$var$infinityToMaxNumber(this.maxPolarAngle),
            minAzimuthAngle: $b52c6c537f7b0cc8$var$infinityToMaxNumber(this.minAzimuthAngle),
            maxAzimuthAngle: $b52c6c537f7b0cc8$var$infinityToMaxNumber(this.maxAzimuthAngle),
            smoothTime: this.smoothTime,
            draggingSmoothTime: this.draggingSmoothTime,
            dollySpeed: this.dollySpeed,
            truckSpeed: this.truckSpeed,
            dollyToCursor: this.dollyToCursor,
            target: this._targetEnd.toArray(),
            position: $b52c6c537f7b0cc8$var$_v3A.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
            zoom: this._zoomEnd,
            focalOffset: this._focalOffsetEnd.toArray(),
            target0: this._target0.toArray(),
            position0: this._position0.toArray(),
            zoom0: this._zoom0,
            focalOffset0: this._focalOffset0.toArray()
        });
    }
    /**
     * Reproduce the control state with JSON. enableTransition is where anim or not in a boolean.
     * @param json
     * @param enableTransition
     * @category Methods
     */ fromJSON(json, enableTransition = false) {
        const obj = JSON.parse(json);
        this.enabled = obj.enabled;
        this.minDistance = obj.minDistance;
        this.maxDistance = $b52c6c537f7b0cc8$var$maxNumberToInfinity(obj.maxDistance);
        this.minZoom = obj.minZoom;
        this.maxZoom = $b52c6c537f7b0cc8$var$maxNumberToInfinity(obj.maxZoom);
        this.minPolarAngle = obj.minPolarAngle;
        this.maxPolarAngle = $b52c6c537f7b0cc8$var$maxNumberToInfinity(obj.maxPolarAngle);
        this.minAzimuthAngle = $b52c6c537f7b0cc8$var$maxNumberToInfinity(obj.minAzimuthAngle);
        this.maxAzimuthAngle = $b52c6c537f7b0cc8$var$maxNumberToInfinity(obj.maxAzimuthAngle);
        this.smoothTime = obj.smoothTime;
        this.draggingSmoothTime = obj.draggingSmoothTime;
        this.dollySpeed = obj.dollySpeed;
        this.truckSpeed = obj.truckSpeed;
        this.dollyToCursor = obj.dollyToCursor;
        this._target0.fromArray(obj.target0);
        this._position0.fromArray(obj.position0);
        this._zoom0 = obj.zoom0;
        this._focalOffset0.fromArray(obj.focalOffset0);
        this.moveTo(obj.target[0], obj.target[1], obj.target[2], enableTransition);
        $b52c6c537f7b0cc8$var$_sphericalA.setFromVector3($b52c6c537f7b0cc8$var$_v3A.fromArray(obj.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace));
        this.rotateTo($b52c6c537f7b0cc8$var$_sphericalA.theta, $b52c6c537f7b0cc8$var$_sphericalA.phi, enableTransition);
        this.dollyTo($b52c6c537f7b0cc8$var$_sphericalA.radius, enableTransition);
        this.zoomTo(obj.zoom, enableTransition);
        this.setFocalOffset(obj.focalOffset[0], obj.focalOffset[1], obj.focalOffset[2], enableTransition);
        this._needsUpdate = true;
    }
    /**
     * Attach all internal event handlers to enable drag control.
     * @category Methods
     */ connect(domElement) {
        if (this._domElement) {
            console.warn('camera-controls is already connected.');
            return;
        }
        domElement.setAttribute('data-camera-controls-version', $b52c6c537f7b0cc8$var$VERSION);
        this._addAllEventListeners(domElement);
        this._getClientRect(this._elementRect);
    }
    /**
     * Detach all internal event handlers to disable drag control.
     */ disconnect() {
        this.cancel();
        this._removeAllEventListeners();
        if (this._domElement) {
            this._domElement.removeAttribute('data-camera-controls-version');
            this._domElement = undefined;
        }
    }
    /**
     * Dispose the cameraControls instance itself, remove all eventListeners.
     * @category Methods
     */ dispose() {
        // remove all user event listeners
        this.removeAllEventListeners();
        // remove all internal event listeners
        this.disconnect();
    }
    // it's okay to expose public though
    _getTargetDirection(out) {
        // divide by distance to normalize, lighter than `Vector3.prototype.normalize()`
        return out.setFromSpherical(this._spherical).divideScalar(this._spherical.radius).applyQuaternion(this._yAxisUpSpaceInverse);
    }
    // it's okay to expose public though
    _getCameraDirection(out) {
        return this._getTargetDirection(out).negate();
    }
    _findPointerById(pointerId) {
        return this._activePointers.find((activePointer)=>activePointer.pointerId === pointerId);
    }
    _findPointerByMouseButton(mouseButton) {
        return this._activePointers.find((activePointer)=>activePointer.mouseButton === mouseButton);
    }
    _disposePointer(pointer) {
        this._activePointers.splice(this._activePointers.indexOf(pointer), 1);
    }
    _encloseToBoundary(position, offset, friction) {
        const offsetLength2 = offset.lengthSq();
        if (offsetLength2 === 0.0) return position;
        // See: https://twitter.com/FMS_Cat/status/1106508958640988161
        const newTarget = $b52c6c537f7b0cc8$var$_v3B.copy(offset).add(position); // target
        const clampedTarget = this._boundary.clampPoint(newTarget, $b52c6c537f7b0cc8$var$_v3C); // clamped target
        const deltaClampedTarget = clampedTarget.sub(newTarget); // newTarget -> clampedTarget
        const deltaClampedTargetLength2 = deltaClampedTarget.lengthSq(); // squared length of deltaClampedTarget
        if (deltaClampedTargetLength2 === 0.0) return position.add(offset);
        else if (deltaClampedTargetLength2 === offsetLength2) return position;
        else if (friction === 0.0) return position.add(offset).add(deltaClampedTarget);
        else {
            const offsetFactor = 1.0 + friction * deltaClampedTargetLength2 / offset.dot(deltaClampedTarget);
            return position.add($b52c6c537f7b0cc8$var$_v3B.copy(offset).multiplyScalar(offsetFactor)).add(deltaClampedTarget.multiplyScalar(1.0 - friction));
        }
    }
    _updateNearPlaneCorners() {
        if ($b52c6c537f7b0cc8$var$isPerspectiveCamera(this._camera)) {
            const camera = this._camera;
            const near = camera.near;
            const fov = camera.getEffectiveFOV() * $b52c6c537f7b0cc8$var$DEG2RAD;
            const heightHalf = Math.tan(fov * 0.5) * near; // near plain half height
            const widthHalf = heightHalf * camera.aspect; // near plain half width
            this._nearPlaneCorners[0].set(-widthHalf, -heightHalf, 0);
            this._nearPlaneCorners[1].set(widthHalf, -heightHalf, 0);
            this._nearPlaneCorners[2].set(widthHalf, heightHalf, 0);
            this._nearPlaneCorners[3].set(-widthHalf, heightHalf, 0);
        } else if ($b52c6c537f7b0cc8$var$isOrthographicCamera(this._camera)) {
            const camera = this._camera;
            const zoomInv = 1 / camera.zoom;
            const left = camera.left * zoomInv;
            const right = camera.right * zoomInv;
            const top = camera.top * zoomInv;
            const bottom = camera.bottom * zoomInv;
            this._nearPlaneCorners[0].set(left, top, 0);
            this._nearPlaneCorners[1].set(right, top, 0);
            this._nearPlaneCorners[2].set(right, bottom, 0);
            this._nearPlaneCorners[3].set(left, bottom, 0);
        }
    }
    // lateUpdate
    _collisionTest() {
        let distance = Infinity;
        const hasCollider = this.colliderMeshes.length >= 1;
        if (!hasCollider) return distance;
        if ($b52c6c537f7b0cc8$var$notSupportedInOrthographicCamera(this._camera, '_collisionTest')) return distance;
        const rayDirection = this._getTargetDirection($b52c6c537f7b0cc8$var$_cameraDirection);
        $b52c6c537f7b0cc8$var$_rotationMatrix.lookAt($b52c6c537f7b0cc8$var$_ORIGIN, rayDirection, this._camera.up);
        for(let i = 0; i < 4; i++){
            const nearPlaneCorner = $b52c6c537f7b0cc8$var$_v3B.copy(this._nearPlaneCorners[i]);
            nearPlaneCorner.applyMatrix4($b52c6c537f7b0cc8$var$_rotationMatrix);
            const origin = $b52c6c537f7b0cc8$var$_v3C.addVectors(this._target, nearPlaneCorner);
            $b52c6c537f7b0cc8$var$_raycaster.set(origin, rayDirection);
            $b52c6c537f7b0cc8$var$_raycaster.far = this._spherical.radius + 1;
            const intersects = $b52c6c537f7b0cc8$var$_raycaster.intersectObjects(this.colliderMeshes);
            if (intersects.length !== 0 && intersects[0].distance < distance) distance = intersects[0].distance;
        }
        return distance;
    }
    /**
     * Get its client rect and package into given `DOMRect` .
     */ _getClientRect(target) {
        if (!this._domElement) return;
        const rect = this._domElement.getBoundingClientRect();
        target.x = rect.left;
        target.y = rect.top;
        if (this._viewport) {
            target.x += this._viewport.x;
            target.y += rect.height - this._viewport.w - this._viewport.y;
            target.width = this._viewport.z;
            target.height = this._viewport.w;
        } else {
            target.width = rect.width;
            target.height = rect.height;
        }
        return target;
    }
    _createOnRestPromise(resolveImmediately) {
        if (resolveImmediately) return Promise.resolve();
        this._hasRested = false;
        this.dispatchEvent({
            type: 'transitionstart'
        });
        return new Promise((resolve)=>{
            const onResolve = ()=>{
                this.removeEventListener('rest', onResolve);
                resolve();
            };
            this.addEventListener('rest', onResolve);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _addAllEventListeners(_domElement) {}
    _removeAllEventListeners() {}
    /**
     * backward compatible
     * @deprecated use smoothTime (in seconds) instead
     * @category Properties
     */ get dampingFactor() {
        console.warn('.dampingFactor has been deprecated. use smoothTime (in seconds) instead.');
        return 0;
    }
    /**
     * backward compatible
     * @deprecated use smoothTime (in seconds) instead
     * @category Properties
     */ set dampingFactor(_) {
        console.warn('.dampingFactor has been deprecated. use smoothTime (in seconds) instead.');
    }
    /**
     * backward compatible
     * @deprecated use draggingSmoothTime (in seconds) instead
     * @category Properties
     */ get draggingDampingFactor() {
        console.warn('.draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.');
        return 0;
    }
    /**
     * backward compatible
     * @deprecated use draggingSmoothTime (in seconds) instead
     * @category Properties
     */ set draggingDampingFactor(_) {
        console.warn('.draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.');
    }
    static createBoundingSphere(object3d, out = new $b52c6c537f7b0cc8$var$THREE.Sphere()) {
        const boundingSphere = out;
        const center = boundingSphere.center;
        $b52c6c537f7b0cc8$var$_box3A.makeEmpty();
        // find the center
        object3d.traverseVisible((object)=>{
            if (!object.isMesh) return;
            $b52c6c537f7b0cc8$var$_box3A.expandByObject(object);
        });
        $b52c6c537f7b0cc8$var$_box3A.getCenter(center);
        // find the radius
        let maxRadiusSq = 0;
        object3d.traverseVisible((object)=>{
            if (!object.isMesh) return;
            const mesh = object;
            if (!mesh.geometry) return;
            const geometry = mesh.geometry.clone();
            geometry.applyMatrix4(mesh.matrixWorld);
            const bufferGeometry = geometry;
            const position = bufferGeometry.attributes.position;
            for(let i = 0, l = position.count; i < l; i++){
                $b52c6c537f7b0cc8$var$_v3A.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($b52c6c537f7b0cc8$var$_v3A));
            }
        });
        boundingSphere.radius = Math.sqrt(maxRadiusSq);
        return boundingSphere;
    }
}

});


parcelRegister("60WrR", function(module, exports) {

$parcel$export(module.exports, "Environment", () => $461014c910066417$export$7dc6752a22ab011a);

var $d65Jq = parcelRequire("d65Jq");

var $bxRTa = parcelRequire("bxRTa");

var $9sE5i = parcelRequire("9sE5i");parcelRequire("3gAAP");
var $9sE5i = parcelRequire("9sE5i");
parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
var $329ek = parcelRequire("329ek");

var $38vQL = parcelRequire("38vQL");

var $bFXuo = parcelRequire("bFXuo");
const $461014c910066417$var$isRef = (obj)=>obj.current && obj.current.isScene;
const $461014c910066417$var$resolveScene = (scene)=>$461014c910066417$var$isRef(scene) ? scene.current : scene;
function $461014c910066417$var$setEnvProps(background, scene, defaultScene, texture, sceneProps = {}) {
    var _sceneProps$blur, _target$backgroundRot, _target$backgroundRot2, _target$environmentRo, _target$environmentRo2;
    // defaults
    sceneProps = {
        backgroundBlurriness: (_sceneProps$blur = sceneProps.blur) !== null && _sceneProps$blur !== void 0 ? _sceneProps$blur : 0,
        backgroundIntensity: 1,
        backgroundRotation: [
            0,
            0,
            0
        ],
        environmentIntensity: 1,
        environmentRotation: [
            0,
            0,
            0
        ],
        ...sceneProps
    };
    const target = $461014c910066417$var$resolveScene(scene || defaultScene);
    const oldbg = target.background;
    const oldenv = target.environment;
    const oldSceneProps = {
        // @ts-ignore
        backgroundBlurriness: target.backgroundBlurriness,
        // @ts-ignore
        backgroundIntensity: target.backgroundIntensity,
        // @ts-ignore
        backgroundRotation: (_target$backgroundRot = (_target$backgroundRot2 = target.backgroundRotation) == null || _target$backgroundRot2.clone == null ? void 0 : _target$backgroundRot2.clone()) !== null && _target$backgroundRot !== void 0 ? _target$backgroundRot : [
            0,
            0,
            0
        ],
        // @ts-ignore
        environmentIntensity: target.environmentIntensity,
        // @ts-ignore
        environmentRotation: (_target$environmentRo = (_target$environmentRo2 = target.environmentRotation) == null || _target$environmentRo2.clone == null ? void 0 : _target$environmentRo2.clone()) !== null && _target$environmentRo !== void 0 ? _target$environmentRo : [
            0,
            0,
            0
        ]
    };
    if (background !== 'only') target.environment = texture;
    if (background) target.background = texture;
    (0, $9sE5i.k)(target, sceneProps);
    return ()=>{
        if (background !== 'only') target.environment = oldenv;
        if (background) target.background = oldbg;
        (0, $9sE5i.k)(target, oldSceneProps);
    };
}
function $461014c910066417$export$5d2a45dffef53508({ scene: scene, background: background = false, map: map, ...config }) {
    const defaultScene = (0, $9sE5i.D)((state)=>state.scene);
    $bxRTa.useLayoutEffect(()=>{
        if (map) return $461014c910066417$var$setEnvProps(background, scene, defaultScene, map, config);
    });
    return null;
}
function $461014c910066417$export$1480799530c0b477({ background: background = false, scene: scene, blur: blur, backgroundBlurriness: backgroundBlurriness, backgroundIntensity: backgroundIntensity, backgroundRotation: backgroundRotation, environmentIntensity: environmentIntensity, environmentRotation: environmentRotation, ...rest }) {
    const texture = (0, $bFXuo.useEnvironment)(rest);
    const defaultScene = (0, $9sE5i.D)((state)=>state.scene);
    $bxRTa.useLayoutEffect(()=>{
        return $461014c910066417$var$setEnvProps(background, scene, defaultScene, texture, {
            blur: blur,
            backgroundBlurriness: backgroundBlurriness,
            backgroundIntensity: backgroundIntensity,
            backgroundRotation: backgroundRotation,
            environmentIntensity: environmentIntensity,
            environmentRotation: environmentRotation
        });
    });
    return null;
}
function $461014c910066417$export$fad6a10e29ccfe2a({ children: children, near: near = 1, far: far = 1000, resolution: resolution = 256, frames: frames = 1, map: map, background: background = false, blur: blur, backgroundBlurriness: backgroundBlurriness, backgroundIntensity: backgroundIntensity, backgroundRotation: backgroundRotation, environmentIntensity: environmentIntensity, environmentRotation: environmentRotation, scene: scene, files: files, path: path, preset: preset, extensions: extensions }) {
    const gl = (0, $9sE5i.D)((state)=>state.gl);
    const defaultScene = (0, $9sE5i.D)((state)=>state.scene);
    const camera = $bxRTa.useRef(null);
    const [virtualScene] = $bxRTa.useState(()=>new (0, $329ek.Scene)());
    const fbo = $bxRTa.useMemo(()=>{
        const fbo = new (0, $329ek.WebGLCubeRenderTarget)(resolution);
        fbo.texture.type = (0, $329ek.HalfFloatType);
        return fbo;
    }, [
        resolution
    ]);
    $bxRTa.useLayoutEffect(()=>{
        if (frames === 1) camera.current.update(gl, virtualScene);
        return $461014c910066417$var$setEnvProps(background, scene, defaultScene, fbo.texture, {
            blur: blur,
            backgroundBlurriness: backgroundBlurriness,
            backgroundIntensity: backgroundIntensity,
            backgroundRotation: backgroundRotation,
            environmentIntensity: environmentIntensity,
            environmentRotation: environmentRotation
        });
    }, [
        children,
        virtualScene,
        fbo.texture,
        scene,
        defaultScene,
        background,
        frames,
        gl
    ]);
    let count = 1;
    (0, $9sE5i.F)(()=>{
        if (frames === Infinity || count < frames) {
            camera.current.update(gl, virtualScene);
            count++;
        }
    });
    return /*#__PURE__*/ $bxRTa.createElement($bxRTa.Fragment, null, (0, $9sE5i.h)(/*#__PURE__*/ $bxRTa.createElement($bxRTa.Fragment, null, children, /*#__PURE__*/ $bxRTa.createElement("cubeCamera", {
        ref: camera,
        args: [
            near,
            far,
            fbo
        ]
    }), files || preset ? /*#__PURE__*/ $bxRTa.createElement($461014c910066417$export$1480799530c0b477, {
        background: true,
        files: files,
        preset: preset,
        path: path,
        extensions: extensions
    }) : map ? /*#__PURE__*/ $bxRTa.createElement($461014c910066417$export$5d2a45dffef53508, {
        background: true,
        map: map,
        extensions: extensions
    }) : null), virtualScene));
}
function $461014c910066417$var$EnvironmentGround(props) {
    var _props$ground, _props$ground2, _scale, _props$ground3;
    const textureDefault = (0, $bFXuo.useEnvironment)(props);
    const texture = props.map || textureDefault;
    $bxRTa.useMemo(()=>(0, $9sE5i.e)({
            GroundProjectedEnvImpl: (0, $38vQL.GroundProjectedEnv)
        }), []);
    const args = $bxRTa.useMemo(()=>[
            texture
        ], [
        texture
    ]);
    const height = (_props$ground = props.ground) == null ? void 0 : _props$ground.height;
    const radius = (_props$ground2 = props.ground) == null ? void 0 : _props$ground2.radius;
    const scale = (_scale = (_props$ground3 = props.ground) == null ? void 0 : _props$ground3.scale) !== null && _scale !== void 0 ? _scale : 1000;
    return /*#__PURE__*/ $bxRTa.createElement($bxRTa.Fragment, null, /*#__PURE__*/ $bxRTa.createElement($461014c910066417$export$5d2a45dffef53508, (0, $d65Jq.default)({}, props, {
        map: texture
    })), /*#__PURE__*/ $bxRTa.createElement("groundProjectedEnvImpl", {
        args: args,
        scale: scale,
        height: height,
        radius: radius
    }));
}
function $461014c910066417$export$7dc6752a22ab011a(props) {
    return props.ground ? /*#__PURE__*/ $bxRTa.createElement($461014c910066417$var$EnvironmentGround, props) : props.map ? /*#__PURE__*/ $bxRTa.createElement($461014c910066417$export$5d2a45dffef53508, props) : props.children ? /*#__PURE__*/ $bxRTa.createElement($461014c910066417$export$fad6a10e29ccfe2a, props) : /*#__PURE__*/ $bxRTa.createElement($461014c910066417$export$1480799530c0b477, props);
}

});
parcelRegister("38vQL", function(module, exports) {

$parcel$export(module.exports, "GroundProjectedEnv", () => $248ad32f9edd51b9$export$a8dfc348093aebdf);
parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
var $329ek = parcelRequire("329ek");

var $aEzEK = parcelRequire("aEzEK");
const $248ad32f9edd51b9$var$isCubeTexture = (def)=>def && def.isCubeTexture;
class $248ad32f9edd51b9$export$a8dfc348093aebdf extends (0, $329ek.Mesh) {
    constructor(texture, options){
        var _a, _b;
        const isCubeMap = $248ad32f9edd51b9$var$isCubeTexture(texture);
        const w = (_b = isCubeMap ? (_a = texture.image[0]) == null ? void 0 : _a.width : texture.image.width) != null ? _b : 1024;
        const cubeSize = w / 4;
        const _lodMax = Math.floor(Math.log2(cubeSize));
        const _cubeSize = Math.pow(2, _lodMax);
        const width = 3 * Math.max(_cubeSize, 112);
        const height = 4 * _cubeSize;
        const defines = [
            isCubeMap ? "#define ENVMAP_TYPE_CUBE" : "",
            `#define CUBEUV_TEXEL_WIDTH ${1 / width}`,
            `#define CUBEUV_TEXEL_HEIGHT ${1 / height}`,
            `#define CUBEUV_MAX_MIP ${_lodMax}.0`
        ];
        const vertexShader = /* glsl */ `
        varying vec3 vWorldPosition;
        void main() 
        {
            vec4 worldPosition = ( modelMatrix * vec4( position, 1.0 ) );
            vWorldPosition = worldPosition.xyz;
            
            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
        `;
        const fragmentShader = defines.join("\n") + /* glsl */ `
        #define ENVMAP_TYPE_CUBE_UV
        varying vec3 vWorldPosition;
        uniform float radius;
        uniform float height;
        uniform float angle;
        #ifdef ENVMAP_TYPE_CUBE
            uniform samplerCube map;
        #else
            uniform sampler2D map;
        #endif
        // From: https://www.shadertoy.com/view/4tsBD7
        float diskIntersectWithBackFaceCulling( vec3 ro, vec3 rd, vec3 c, vec3 n, float r ) 
        {
            float d = dot ( rd, n );
            
            if( d > 0.0 ) { return 1e6; }
            
            vec3  o = ro - c;
            float t = - dot( n, o ) / d;
            vec3  q = o + rd * t;
            
            return ( dot( q, q ) < r * r ) ? t : 1e6;
        }
        // From: https://www.iquilezles.org/www/articles/intersectors/intersectors.htm
        float sphereIntersect( vec3 ro, vec3 rd, vec3 ce, float ra ) 
        {
            vec3 oc = ro - ce;
            float b = dot( oc, rd );
            float c = dot( oc, oc ) - ra * ra;
            float h = b * b - c;
            
            if( h < 0.0 ) { return -1.0; }
            
            h = sqrt( h );
            
            return - b + h;
        }
        vec3 project() 
        {
            vec3 p = normalize( vWorldPosition );
            vec3 camPos = cameraPosition;
            camPos.y -= height;
            float intersection = sphereIntersect( camPos, p, vec3( 0.0 ), radius );
            if( intersection > 0.0 ) {
                
                vec3 h = vec3( 0.0, - height, 0.0 );
                float intersection2 = diskIntersectWithBackFaceCulling( camPos, p, h, vec3( 0.0, 1.0, 0.0 ), radius );
                p = ( camPos + min( intersection, intersection2 ) * p ) / radius;
            } else {
                p = vec3( 0.0, 1.0, 0.0 );
            }
            return p;
        }
        #include <common>
        #include <cube_uv_reflection_fragment>
        void main() 
        {
            vec3 projectedWorldPosition = project();
            
            #ifdef ENVMAP_TYPE_CUBE
                vec3 outcolor = textureCube( map, projectedWorldPosition ).rgb;
            #else
                vec3 direction = normalize( projectedWorldPosition );
                vec2 uv = equirectUv( direction );
                vec3 outcolor = texture2D( map, uv ).rgb;
            #endif
            gl_FragColor = vec4( outcolor, 1.0 );
            #include <tonemapping_fragment>
            #include <${(0, $aEzEK.version) >= 154 ? "colorspace_fragment" : "encodings_fragment"}>
        }
        `;
        const uniforms = {
            map: {
                value: texture
            },
            height: {
                value: (options == null ? void 0 : options.height) || 15
            },
            radius: {
                value: (options == null ? void 0 : options.radius) || 100
            }
        };
        const geometry = new (0, $329ek.IcosahedronGeometry)(1, 16);
        const material = new (0, $329ek.ShaderMaterial)({
            uniforms: uniforms,
            fragmentShader: fragmentShader,
            vertexShader: vertexShader,
            side: (0, $329ek.DoubleSide)
        });
        super(geometry, material);
    }
    set radius(radius) {
        this.material.uniforms.radius.value = radius;
    }
    get radius() {
        return this.material.uniforms.radius.value;
    }
    set height(height) {
        this.material.uniforms.height.value = height;
    }
    get height() {
        return this.material.uniforms.height.value;
    }
}

});
parcelRegister("aEzEK", function(module, exports) {

$parcel$export(module.exports, "version", () => $7c194c6692cfc79e$export$83d89fbfd8236492);
parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
const $7c194c6692cfc79e$export$83d89fbfd8236492 = /* @__PURE__ */ (()=>parseInt((0, $329ek.REVISION).replace(/\D+/g, "")))();

});


parcelRegister("bFXuo", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $8801ab612cfd18b4$export$ea7ed2425832167d);

var $9sE5i = parcelRequire("9sE5i");
parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
var $329ek = parcelRequire("329ek");

var $1MEVq = parcelRequire("1MEVq");
var $eIqiV = parcelRequire("eIqiV");

var $cCefG = parcelRequire("cCefG");

var $8Y7Uk = parcelRequire("8Y7Uk");

var $9cQkE = parcelRequire("9cQkE");

var $bxRTa = parcelRequire("bxRTa");
const $8801ab612cfd18b4$var$CUBEMAP_ROOT = 'https://raw.githack.com/pmndrs/drei-assets/456060a26bbeb8fdf79326f224b6d99b8bcce736/hdri/';
const $8801ab612cfd18b4$var$isArray = (arr)=>Array.isArray(arr);
const $8801ab612cfd18b4$var$defaultFiles = [
    '/px.png',
    '/nx.png',
    '/py.png',
    '/ny.png',
    '/pz.png',
    '/nz.png'
];
function $8801ab612cfd18b4$export$ea7ed2425832167d({ files: files = $8801ab612cfd18b4$var$defaultFiles, path: path = '', preset: preset, encoding: encoding, extensions: extensions } = {}) {
    let loader = null;
    let multiFile = false;
    if (preset) {
        $8801ab612cfd18b4$var$validatePreset(preset);
        files = (0, $8Y7Uk.presetsObj)[preset];
        path = $8801ab612cfd18b4$var$CUBEMAP_ROOT;
    }
    // Everything else
    multiFile = $8801ab612cfd18b4$var$isArray(files);
    const { extension: extension, isCubemap: isCubemap } = $8801ab612cfd18b4$var$getExtension(files);
    loader = $8801ab612cfd18b4$var$getLoader(extension);
    if (!loader) throw new Error('useEnvironment: Unrecognized file extension: ' + files);
    const gl = (0, $9sE5i.D)((state)=>state.gl);
    (0, $bxRTa.useLayoutEffect)(()=>{
        // Only required for gainmap
        if (extension !== 'webp' && extension !== 'jpg' && extension !== 'jpeg') return;
        function clearGainmapTexture() {
            (0, $9sE5i.H).clear(// @ts-expect-error
            loader, multiFile ? [
                files
            ] : files);
        }
        gl.domElement.addEventListener('webglcontextlost', clearGainmapTexture, {
            once: true
        });
    }, [
        files,
        gl.domElement
    ]);
    const loaderResult = (0, $9sE5i.H)(// @ts-expect-error
    loader, multiFile ? [
        files
    ] : files, (loader)=>{
        // Gainmap requires a renderer
        if (extension === 'webp' || extension === 'jpg' || extension === 'jpeg') loader.setRenderer(gl);
        loader.setPath == null || loader.setPath(path);
        if (extensions) extensions(loader);
    });
    let texture = multiFile ? // @ts-ignore
    loaderResult[0] : loaderResult;
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'webp') {
        var _renderTarget;
        texture = (_renderTarget = texture.renderTarget) == null ? void 0 : _renderTarget.texture;
    }
    texture.mapping = isCubemap ? (0, $329ek.CubeReflectionMapping) : (0, $329ek.EquirectangularReflectionMapping);
    if ('colorSpace' in texture) texture.colorSpace = (encoding !== null && encoding !== void 0 ? encoding : isCubemap) ? 'srgb' : 'srgb-linear';
    else texture.encoding = (encoding !== null && encoding !== void 0 ? encoding : isCubemap) ? (0, $9cQkE.sRGBEncoding) : (0, $9cQkE.LinearEncoding);
    return texture;
}
const $8801ab612cfd18b4$var$preloadDefaultOptions = {
    files: $8801ab612cfd18b4$var$defaultFiles,
    path: '',
    preset: undefined,
    extensions: undefined
};
$8801ab612cfd18b4$export$ea7ed2425832167d.preload = (preloadOptions)=>{
    const options = {
        ...$8801ab612cfd18b4$var$preloadDefaultOptions,
        ...preloadOptions
    };
    let { files: files, path: path = '' } = options;
    const { preset: preset, extensions: extensions } = options;
    if (preset) {
        $8801ab612cfd18b4$var$validatePreset(preset);
        files = (0, $8Y7Uk.presetsObj)[preset];
        path = $8801ab612cfd18b4$var$CUBEMAP_ROOT;
    }
    const { extension: extension } = $8801ab612cfd18b4$var$getExtension(files);
    if (extension === 'webp' || extension === 'jpg' || extension === 'jpeg') throw new Error('useEnvironment: Preloading gainmaps is not supported');
    const loader = $8801ab612cfd18b4$var$getLoader(extension);
    if (!loader) throw new Error('useEnvironment: Unrecognized file extension: ' + files);
    (0, $9sE5i.H).preload(// @ts-expect-error
    loader, $8801ab612cfd18b4$var$isArray(files) ? [
        files
    ] : files, (loader)=>{
        loader.setPath == null || loader.setPath(path);
        if (extensions) extensions(loader);
    });
};
const $8801ab612cfd18b4$var$clearDefaultOptins = {
    files: $8801ab612cfd18b4$var$defaultFiles,
    preset: undefined
};
$8801ab612cfd18b4$export$ea7ed2425832167d.clear = (clearOptions)=>{
    const options = {
        ...$8801ab612cfd18b4$var$clearDefaultOptins,
        ...clearOptions
    };
    let { files: files } = options;
    const { preset: preset } = options;
    if (preset) {
        $8801ab612cfd18b4$var$validatePreset(preset);
        files = (0, $8Y7Uk.presetsObj)[preset];
    }
    const { extension: extension } = $8801ab612cfd18b4$var$getExtension(files);
    const loader = $8801ab612cfd18b4$var$getLoader(extension);
    if (!loader) throw new Error('useEnvironment: Unrecognized file extension: ' + files);
    (0, $9sE5i.H).clear(// @ts-expect-error
    loader, $8801ab612cfd18b4$var$isArray(files) ? [
        files
    ] : files);
};
function $8801ab612cfd18b4$var$validatePreset(preset) {
    if (!(preset in (0, $8Y7Uk.presetsObj))) throw new Error('Preset must be one of: ' + Object.keys((0, $8Y7Uk.presetsObj)).join(', '));
}
function $8801ab612cfd18b4$var$getExtension(files) {
    var _firstEntry$split$pop;
    const isCubemap = $8801ab612cfd18b4$var$isArray(files) && files.length === 6;
    const isGainmap = $8801ab612cfd18b4$var$isArray(files) && files.length === 3 && files.some((file)=>file.endsWith('json'));
    const firstEntry = $8801ab612cfd18b4$var$isArray(files) ? files[0] : files;
    // Everything else
    const extension = isCubemap ? 'cube' : isGainmap ? 'webp' : firstEntry.startsWith('data:application/exr') ? 'exr' : firstEntry.startsWith('data:application/hdr') ? 'hdr' : firstEntry.startsWith('data:image/jpeg') ? 'jpg' : (_firstEntry$split$pop = firstEntry.split('.').pop()) == null || (_firstEntry$split$pop = _firstEntry$split$pop.split('?')) == null || (_firstEntry$split$pop = _firstEntry$split$pop.shift()) == null ? void 0 : _firstEntry$split$pop.toLowerCase();
    return {
        extension: extension,
        isCubemap: isCubemap,
        isGainmap: isGainmap
    };
}
function $8801ab612cfd18b4$var$getLoader(extension) {
    const loader = extension === 'cube' ? (0, $329ek.CubeTextureLoader) : extension === 'hdr' ? (0, $eIqiV.RGBELoader) : extension === 'exr' ? (0, $1MEVq.EXRLoader) : extension === 'jpg' || extension === 'jpeg' ? (0, $cCefG.HDRJPGLoader) : extension === 'webp' ? (0, $cCefG.GainMapLoader) : null;
    return loader;
}

});
parcelRegister("1MEVq", function(module, exports) {

$parcel$export(module.exports, "EXRLoader", () => $14ca05092b28fea2$export$ccf20607163eaf96);

var $329ek = parcelRequire("329ek");parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");

var $6Z1WP = parcelRequire("6Z1WP");

var $aEzEK = parcelRequire("aEzEK");
const $14ca05092b28fea2$var$hasColorSpace = (0, $aEzEK.version) >= 152;
class $14ca05092b28fea2$export$ccf20607163eaf96 extends (0, $329ek.DataTextureLoader) {
    constructor(manager){
        super(manager);
        this.type = (0, $329ek.HalfFloatType);
    }
    parse(buffer) {
        const USHORT_RANGE = 65536;
        const BITMAP_SIZE = USHORT_RANGE >> 3;
        const HUF_ENCBITS = 16;
        const HUF_DECBITS = 14;
        const HUF_ENCSIZE = (1 << HUF_ENCBITS) + 1;
        const HUF_DECSIZE = 1 << HUF_DECBITS;
        const HUF_DECMASK = HUF_DECSIZE - 1;
        const NBITS = 16;
        const A_OFFSET = 1 << NBITS - 1;
        const MOD_MASK = (1 << NBITS) - 1;
        const SHORT_ZEROCODE_RUN = 59;
        const LONG_ZEROCODE_RUN = 63;
        const SHORTEST_LONG_RUN = 2 + LONG_ZEROCODE_RUN - SHORT_ZEROCODE_RUN;
        const ULONG_SIZE = 8;
        const FLOAT32_SIZE = 4;
        const INT32_SIZE = 4;
        const INT16_SIZE = 2;
        const INT8_SIZE = 1;
        const STATIC_HUFFMAN = 0;
        const DEFLATE = 1;
        const UNKNOWN = 0;
        const LOSSY_DCT = 1;
        const RLE = 2;
        const logBase = Math.pow(2.7182818, 2.2);
        function reverseLutFromBitmap(bitmap, lut) {
            var k = 0;
            for(var i = 0; i < USHORT_RANGE; ++i)if (i == 0 || bitmap[i >> 3] & 1 << (i & 7)) lut[k++] = i;
            var n = k - 1;
            while(k < USHORT_RANGE)lut[k++] = 0;
            return n;
        }
        function hufClearDecTable(hdec) {
            for(var i = 0; i < HUF_DECSIZE; i++){
                hdec[i] = {};
                hdec[i].len = 0;
                hdec[i].lit = 0;
                hdec[i].p = null;
            }
        }
        const getBitsReturn = {
            l: 0,
            c: 0,
            lc: 0
        };
        function getBits(nBits, c, lc, uInt8Array2, inOffset) {
            while(lc < nBits){
                c = c << 8 | parseUint8Array(uInt8Array2, inOffset);
                lc += 8;
            }
            lc -= nBits;
            getBitsReturn.l = c >> lc & (1 << nBits) - 1;
            getBitsReturn.c = c;
            getBitsReturn.lc = lc;
        }
        const hufTableBuffer = new Array(59);
        function hufCanonicalCodeTable(hcode) {
            for(var i = 0; i <= 58; ++i)hufTableBuffer[i] = 0;
            for(var i = 0; i < HUF_ENCSIZE; ++i)hufTableBuffer[hcode[i]] += 1;
            var c = 0;
            for(var i = 58; i > 0; --i){
                var nc = c + hufTableBuffer[i] >> 1;
                hufTableBuffer[i] = c;
                c = nc;
            }
            for(var i = 0; i < HUF_ENCSIZE; ++i){
                var l = hcode[i];
                if (l > 0) hcode[i] = l | hufTableBuffer[l]++ << 6;
            }
        }
        function hufUnpackEncTable(uInt8Array2, inDataView, inOffset, ni, im, iM, hcode) {
            var p = inOffset;
            var c = 0;
            var lc = 0;
            for(; im <= iM; im++){
                if (p.value - inOffset.value > ni) return false;
                getBits(6, c, lc, uInt8Array2, p);
                var l = getBitsReturn.l;
                c = getBitsReturn.c;
                lc = getBitsReturn.lc;
                hcode[im] = l;
                if (l == LONG_ZEROCODE_RUN) {
                    if (p.value - inOffset.value > ni) throw "Something wrong with hufUnpackEncTable";
                    getBits(8, c, lc, uInt8Array2, p);
                    var zerun = getBitsReturn.l + SHORTEST_LONG_RUN;
                    c = getBitsReturn.c;
                    lc = getBitsReturn.lc;
                    if (im + zerun > iM + 1) throw "Something wrong with hufUnpackEncTable";
                    while(zerun--)hcode[im++] = 0;
                    im--;
                } else if (l >= SHORT_ZEROCODE_RUN) {
                    var zerun = l - SHORT_ZEROCODE_RUN + 2;
                    if (im + zerun > iM + 1) throw "Something wrong with hufUnpackEncTable";
                    while(zerun--)hcode[im++] = 0;
                    im--;
                }
            }
            hufCanonicalCodeTable(hcode);
        }
        function hufLength(code) {
            return code & 63;
        }
        function hufCode(code) {
            return code >> 6;
        }
        function hufBuildDecTable(hcode, im, iM, hdecod) {
            for(; im <= iM; im++){
                var c = hufCode(hcode[im]);
                var l = hufLength(hcode[im]);
                if (c >> l) throw "Invalid table entry";
                if (l > HUF_DECBITS) {
                    var pl = hdecod[c >> l - HUF_DECBITS];
                    if (pl.len) throw "Invalid table entry";
                    pl.lit++;
                    if (pl.p) {
                        var p = pl.p;
                        pl.p = new Array(pl.lit);
                        for(var i = 0; i < pl.lit - 1; ++i)pl.p[i] = p[i];
                    } else pl.p = new Array(1);
                    pl.p[pl.lit - 1] = im;
                } else if (l) {
                    var plOffset = 0;
                    for(var i = 1 << HUF_DECBITS - l; i > 0; i--){
                        var pl = hdecod[(c << HUF_DECBITS - l) + plOffset];
                        if (pl.len || pl.p) throw "Invalid table entry";
                        pl.len = l;
                        pl.lit = im;
                        plOffset++;
                    }
                }
            }
            return true;
        }
        const getCharReturn = {
            c: 0,
            lc: 0
        };
        function getChar(c, lc, uInt8Array2, inOffset) {
            c = c << 8 | parseUint8Array(uInt8Array2, inOffset);
            lc += 8;
            getCharReturn.c = c;
            getCharReturn.lc = lc;
        }
        const getCodeReturn = {
            c: 0,
            lc: 0
        };
        function getCode(po, rlc, c, lc, uInt8Array2, inDataView, inOffset, outBuffer, outBufferOffset, outBufferEndOffset) {
            if (po == rlc) {
                if (lc < 8) {
                    getChar(c, lc, uInt8Array2, inOffset);
                    c = getCharReturn.c;
                    lc = getCharReturn.lc;
                }
                lc -= 8;
                var cs = c >> lc;
                var cs = new Uint8Array([
                    cs
                ])[0];
                if (outBufferOffset.value + cs > outBufferEndOffset) return false;
                var s = outBuffer[outBufferOffset.value - 1];
                while(cs-- > 0)outBuffer[outBufferOffset.value++] = s;
            } else if (outBufferOffset.value < outBufferEndOffset) outBuffer[outBufferOffset.value++] = po;
            else return false;
            getCodeReturn.c = c;
            getCodeReturn.lc = lc;
        }
        function UInt16(value) {
            return value & 65535;
        }
        function Int16(value) {
            var ref = UInt16(value);
            return ref > 32767 ? ref - 65536 : ref;
        }
        const wdec14Return = {
            a: 0,
            b: 0
        };
        function wdec14(l, h) {
            var ls = Int16(l);
            var hs = Int16(h);
            var hi = hs;
            var ai = ls + (hi & 1) + (hi >> 1);
            var as = ai;
            var bs = ai - hi;
            wdec14Return.a = as;
            wdec14Return.b = bs;
        }
        function wdec16(l, h) {
            var m = UInt16(l);
            var d = UInt16(h);
            var bb = m - (d >> 1) & MOD_MASK;
            var aa = d + bb - A_OFFSET & MOD_MASK;
            wdec14Return.a = aa;
            wdec14Return.b = bb;
        }
        function wav2Decode(buffer2, j, nx, ox, ny, oy, mx) {
            var w14 = mx < 16384;
            var n = nx > ny ? ny : nx;
            var p = 1;
            var p2;
            while(p <= n)p <<= 1;
            p >>= 1;
            p2 = p;
            p >>= 1;
            while(p >= 1){
                var py = 0;
                var ey = py + oy * (ny - p2);
                var oy1 = oy * p;
                var oy2 = oy * p2;
                var ox1 = ox * p;
                var ox2 = ox * p2;
                var i00, i01, i10, i11;
                for(; py <= ey; py += oy2){
                    var px = py;
                    var ex = py + ox * (nx - p2);
                    for(; px <= ex; px += ox2){
                        var p01 = px + ox1;
                        var p10 = px + oy1;
                        var p11 = p10 + ox1;
                        if (w14) {
                            wdec14(buffer2[px + j], buffer2[p10 + j]);
                            i00 = wdec14Return.a;
                            i10 = wdec14Return.b;
                            wdec14(buffer2[p01 + j], buffer2[p11 + j]);
                            i01 = wdec14Return.a;
                            i11 = wdec14Return.b;
                            wdec14(i00, i01);
                            buffer2[px + j] = wdec14Return.a;
                            buffer2[p01 + j] = wdec14Return.b;
                            wdec14(i10, i11);
                            buffer2[p10 + j] = wdec14Return.a;
                            buffer2[p11 + j] = wdec14Return.b;
                        } else {
                            wdec16(buffer2[px + j], buffer2[p10 + j]);
                            i00 = wdec14Return.a;
                            i10 = wdec14Return.b;
                            wdec16(buffer2[p01 + j], buffer2[p11 + j]);
                            i01 = wdec14Return.a;
                            i11 = wdec14Return.b;
                            wdec16(i00, i01);
                            buffer2[px + j] = wdec14Return.a;
                            buffer2[p01 + j] = wdec14Return.b;
                            wdec16(i10, i11);
                            buffer2[p10 + j] = wdec14Return.a;
                            buffer2[p11 + j] = wdec14Return.b;
                        }
                    }
                    if (nx & p) {
                        var p10 = px + oy1;
                        if (w14) wdec14(buffer2[px + j], buffer2[p10 + j]);
                        else wdec16(buffer2[px + j], buffer2[p10 + j]);
                        i00 = wdec14Return.a;
                        buffer2[p10 + j] = wdec14Return.b;
                        buffer2[px + j] = i00;
                    }
                }
                if (ny & p) {
                    var px = py;
                    var ex = py + ox * (nx - p2);
                    for(; px <= ex; px += ox2){
                        var p01 = px + ox1;
                        if (w14) wdec14(buffer2[px + j], buffer2[p01 + j]);
                        else wdec16(buffer2[px + j], buffer2[p01 + j]);
                        i00 = wdec14Return.a;
                        buffer2[p01 + j] = wdec14Return.b;
                        buffer2[px + j] = i00;
                    }
                }
                p2 = p;
                p >>= 1;
            }
            return py;
        }
        function hufDecode(encodingTable, decodingTable, uInt8Array2, inDataView, inOffset, ni, rlc, no, outBuffer, outOffset) {
            var c = 0;
            var lc = 0;
            var outBufferEndOffset = no;
            var inOffsetEnd = Math.trunc(inOffset.value + (ni + 7) / 8);
            while(inOffset.value < inOffsetEnd){
                getChar(c, lc, uInt8Array2, inOffset);
                c = getCharReturn.c;
                lc = getCharReturn.lc;
                while(lc >= HUF_DECBITS){
                    var index = c >> lc - HUF_DECBITS & HUF_DECMASK;
                    var pl = decodingTable[index];
                    if (pl.len) {
                        lc -= pl.len;
                        getCode(pl.lit, rlc, c, lc, uInt8Array2, inDataView, inOffset, outBuffer, outOffset, outBufferEndOffset);
                        c = getCodeReturn.c;
                        lc = getCodeReturn.lc;
                    } else {
                        if (!pl.p) throw "hufDecode issues";
                        var j;
                        for(j = 0; j < pl.lit; j++){
                            var l = hufLength(encodingTable[pl.p[j]]);
                            while(lc < l && inOffset.value < inOffsetEnd){
                                getChar(c, lc, uInt8Array2, inOffset);
                                c = getCharReturn.c;
                                lc = getCharReturn.lc;
                            }
                            if (lc >= l) {
                                if (hufCode(encodingTable[pl.p[j]]) == (c >> lc - l & (1 << l) - 1)) {
                                    lc -= l;
                                    getCode(pl.p[j], rlc, c, lc, uInt8Array2, inDataView, inOffset, outBuffer, outOffset, outBufferEndOffset);
                                    c = getCodeReturn.c;
                                    lc = getCodeReturn.lc;
                                    break;
                                }
                            }
                        }
                        if (j == pl.lit) throw "hufDecode issues";
                    }
                }
            }
            var i = 8 - ni & 7;
            c >>= i;
            lc -= i;
            while(lc > 0){
                var pl = decodingTable[c << HUF_DECBITS - lc & HUF_DECMASK];
                if (pl.len) {
                    lc -= pl.len;
                    getCode(pl.lit, rlc, c, lc, uInt8Array2, inDataView, inOffset, outBuffer, outOffset, outBufferEndOffset);
                    c = getCodeReturn.c;
                    lc = getCodeReturn.lc;
                } else throw "hufDecode issues";
            }
            return true;
        }
        function hufUncompress(uInt8Array2, inDataView, inOffset, nCompressed, outBuffer, nRaw) {
            var outOffset = {
                value: 0
            };
            var initialInOffset = inOffset.value;
            var im = parseUint32(inDataView, inOffset);
            var iM = parseUint32(inDataView, inOffset);
            inOffset.value += 4;
            var nBits = parseUint32(inDataView, inOffset);
            inOffset.value += 4;
            if (im < 0 || im >= HUF_ENCSIZE || iM < 0 || iM >= HUF_ENCSIZE) throw "Something wrong with HUF_ENCSIZE";
            var freq = new Array(HUF_ENCSIZE);
            var hdec = new Array(HUF_DECSIZE);
            hufClearDecTable(hdec);
            var ni = nCompressed - (inOffset.value - initialInOffset);
            hufUnpackEncTable(uInt8Array2, inDataView, inOffset, ni, im, iM, freq);
            if (nBits > 8 * (nCompressed - (inOffset.value - initialInOffset))) throw "Something wrong with hufUncompress";
            hufBuildDecTable(freq, im, iM, hdec);
            hufDecode(freq, hdec, uInt8Array2, inDataView, inOffset, nBits, iM, nRaw, outBuffer, outOffset);
        }
        function applyLut(lut, data, nData) {
            for(var i = 0; i < nData; ++i)data[i] = lut[data[i]];
        }
        function predictor(source) {
            for(var t = 1; t < source.length; t++){
                var d = source[t - 1] + source[t] - 128;
                source[t] = d;
            }
        }
        function interleaveScalar(source, out) {
            var t1 = 0;
            var t2 = Math.floor((source.length + 1) / 2);
            var s = 0;
            var stop = source.length - 1;
            while(true){
                if (s > stop) break;
                out[s++] = source[t1++];
                if (s > stop) break;
                out[s++] = source[t2++];
            }
        }
        function decodeRunLength(source) {
            var size = source.byteLength;
            var out = new Array();
            var p = 0;
            var reader = new DataView(source);
            while(size > 0){
                var l = reader.getInt8(p++);
                if (l < 0) {
                    var count = -l;
                    size -= count + 1;
                    for(var i = 0; i < count; i++)out.push(reader.getUint8(p++));
                } else {
                    var count = l;
                    size -= 2;
                    var value = reader.getUint8(p++);
                    for(var i = 0; i < count + 1; i++)out.push(value);
                }
            }
            return out;
        }
        function lossyDctDecode(cscSet, rowPtrs, channelData, acBuffer, dcBuffer, outBuffer) {
            var dataView = new DataView(outBuffer.buffer);
            var width = channelData[cscSet.idx[0]].width;
            var height = channelData[cscSet.idx[0]].height;
            var numComp = 3;
            var numFullBlocksX = Math.floor(width / 8);
            var numBlocksX = Math.ceil(width / 8);
            var numBlocksY = Math.ceil(height / 8);
            var leftoverX = width - (numBlocksX - 1) * 8;
            var leftoverY = height - (numBlocksY - 1) * 8;
            var currAcComp = {
                value: 0
            };
            var currDcComp = new Array(numComp);
            var dctData = new Array(numComp);
            var halfZigBlock = new Array(numComp);
            var rowBlock = new Array(numComp);
            var rowOffsets = new Array(numComp);
            for(let comp2 = 0; comp2 < numComp; ++comp2){
                rowOffsets[comp2] = rowPtrs[cscSet.idx[comp2]];
                currDcComp[comp2] = comp2 < 1 ? 0 : currDcComp[comp2 - 1] + numBlocksX * numBlocksY;
                dctData[comp2] = new Float32Array(64);
                halfZigBlock[comp2] = new Uint16Array(64);
                rowBlock[comp2] = new Uint16Array(numBlocksX * 64);
            }
            for(let blocky = 0; blocky < numBlocksY; ++blocky){
                var maxY = 8;
                if (blocky == numBlocksY - 1) maxY = leftoverY;
                var maxX = 8;
                for(let blockx = 0; blockx < numBlocksX; ++blockx){
                    if (blockx == numBlocksX - 1) maxX = leftoverX;
                    for(let comp2 = 0; comp2 < numComp; ++comp2){
                        halfZigBlock[comp2].fill(0);
                        halfZigBlock[comp2][0] = dcBuffer[currDcComp[comp2]++];
                        unRleAC(currAcComp, acBuffer, halfZigBlock[comp2]);
                        unZigZag(halfZigBlock[comp2], dctData[comp2]);
                        dctInverse(dctData[comp2]);
                    }
                    csc709Inverse(dctData);
                    for(let comp2 = 0; comp2 < numComp; ++comp2)convertToHalf(dctData[comp2], rowBlock[comp2], blockx * 64);
                }
                let offset2 = 0;
                for(let comp2 = 0; comp2 < numComp; ++comp2){
                    const type2 = channelData[cscSet.idx[comp2]].type;
                    for(let y2 = 8 * blocky; y2 < 8 * blocky + maxY; ++y2){
                        offset2 = rowOffsets[comp2][y2];
                        for(let blockx = 0; blockx < numFullBlocksX; ++blockx){
                            const src = blockx * 64 + (y2 & 7) * 8;
                            dataView.setUint16(offset2 + 0 * INT16_SIZE * type2, rowBlock[comp2][src + 0], true);
                            dataView.setUint16(offset2 + 1 * INT16_SIZE * type2, rowBlock[comp2][src + 1], true);
                            dataView.setUint16(offset2 + 2 * INT16_SIZE * type2, rowBlock[comp2][src + 2], true);
                            dataView.setUint16(offset2 + 3 * INT16_SIZE * type2, rowBlock[comp2][src + 3], true);
                            dataView.setUint16(offset2 + 4 * INT16_SIZE * type2, rowBlock[comp2][src + 4], true);
                            dataView.setUint16(offset2 + 5 * INT16_SIZE * type2, rowBlock[comp2][src + 5], true);
                            dataView.setUint16(offset2 + 6 * INT16_SIZE * type2, rowBlock[comp2][src + 6], true);
                            dataView.setUint16(offset2 + 7 * INT16_SIZE * type2, rowBlock[comp2][src + 7], true);
                            offset2 += 8 * INT16_SIZE * type2;
                        }
                    }
                    if (numFullBlocksX != numBlocksX) for(let y2 = 8 * blocky; y2 < 8 * blocky + maxY; ++y2){
                        const offset3 = rowOffsets[comp2][y2] + 8 * numFullBlocksX * INT16_SIZE * type2;
                        const src = numFullBlocksX * 64 + (y2 & 7) * 8;
                        for(let x2 = 0; x2 < maxX; ++x2)dataView.setUint16(offset3 + x2 * INT16_SIZE * type2, rowBlock[comp2][src + x2], true);
                    }
                }
            }
            var halfRow = new Uint16Array(width);
            var dataView = new DataView(outBuffer.buffer);
            for(var comp = 0; comp < numComp; ++comp){
                channelData[cscSet.idx[comp]].decoded = true;
                var type = channelData[cscSet.idx[comp]].type;
                if (channelData[comp].type != 2) continue;
                for(var y = 0; y < height; ++y){
                    const offset2 = rowOffsets[comp][y];
                    for(var x = 0; x < width; ++x)halfRow[x] = dataView.getUint16(offset2 + x * INT16_SIZE * type, true);
                    for(var x = 0; x < width; ++x)dataView.setFloat32(offset2 + x * INT16_SIZE * type, decodeFloat16(halfRow[x]), true);
                }
            }
        }
        function unRleAC(currAcComp, acBuffer, halfZigBlock) {
            var acValue;
            var dctComp = 1;
            while(dctComp < 64){
                acValue = acBuffer[currAcComp.value];
                if (acValue == 65280) dctComp = 64;
                else if (acValue >> 8 == 255) dctComp += acValue & 255;
                else {
                    halfZigBlock[dctComp] = acValue;
                    dctComp++;
                }
                currAcComp.value++;
            }
        }
        function unZigZag(src, dst) {
            dst[0] = decodeFloat16(src[0]);
            dst[1] = decodeFloat16(src[1]);
            dst[2] = decodeFloat16(src[5]);
            dst[3] = decodeFloat16(src[6]);
            dst[4] = decodeFloat16(src[14]);
            dst[5] = decodeFloat16(src[15]);
            dst[6] = decodeFloat16(src[27]);
            dst[7] = decodeFloat16(src[28]);
            dst[8] = decodeFloat16(src[2]);
            dst[9] = decodeFloat16(src[4]);
            dst[10] = decodeFloat16(src[7]);
            dst[11] = decodeFloat16(src[13]);
            dst[12] = decodeFloat16(src[16]);
            dst[13] = decodeFloat16(src[26]);
            dst[14] = decodeFloat16(src[29]);
            dst[15] = decodeFloat16(src[42]);
            dst[16] = decodeFloat16(src[3]);
            dst[17] = decodeFloat16(src[8]);
            dst[18] = decodeFloat16(src[12]);
            dst[19] = decodeFloat16(src[17]);
            dst[20] = decodeFloat16(src[25]);
            dst[21] = decodeFloat16(src[30]);
            dst[22] = decodeFloat16(src[41]);
            dst[23] = decodeFloat16(src[43]);
            dst[24] = decodeFloat16(src[9]);
            dst[25] = decodeFloat16(src[11]);
            dst[26] = decodeFloat16(src[18]);
            dst[27] = decodeFloat16(src[24]);
            dst[28] = decodeFloat16(src[31]);
            dst[29] = decodeFloat16(src[40]);
            dst[30] = decodeFloat16(src[44]);
            dst[31] = decodeFloat16(src[53]);
            dst[32] = decodeFloat16(src[10]);
            dst[33] = decodeFloat16(src[19]);
            dst[34] = decodeFloat16(src[23]);
            dst[35] = decodeFloat16(src[32]);
            dst[36] = decodeFloat16(src[39]);
            dst[37] = decodeFloat16(src[45]);
            dst[38] = decodeFloat16(src[52]);
            dst[39] = decodeFloat16(src[54]);
            dst[40] = decodeFloat16(src[20]);
            dst[41] = decodeFloat16(src[22]);
            dst[42] = decodeFloat16(src[33]);
            dst[43] = decodeFloat16(src[38]);
            dst[44] = decodeFloat16(src[46]);
            dst[45] = decodeFloat16(src[51]);
            dst[46] = decodeFloat16(src[55]);
            dst[47] = decodeFloat16(src[60]);
            dst[48] = decodeFloat16(src[21]);
            dst[49] = decodeFloat16(src[34]);
            dst[50] = decodeFloat16(src[37]);
            dst[51] = decodeFloat16(src[47]);
            dst[52] = decodeFloat16(src[50]);
            dst[53] = decodeFloat16(src[56]);
            dst[54] = decodeFloat16(src[59]);
            dst[55] = decodeFloat16(src[61]);
            dst[56] = decodeFloat16(src[35]);
            dst[57] = decodeFloat16(src[36]);
            dst[58] = decodeFloat16(src[48]);
            dst[59] = decodeFloat16(src[49]);
            dst[60] = decodeFloat16(src[57]);
            dst[61] = decodeFloat16(src[58]);
            dst[62] = decodeFloat16(src[62]);
            dst[63] = decodeFloat16(src[63]);
        }
        function dctInverse(data) {
            const a = 0.5 * Math.cos(0.7853975);
            const b = 0.5 * Math.cos(3.14159 / 16);
            const c = 0.5 * Math.cos(3.14159 / 8);
            const d = 0.5 * Math.cos(3 * 3.14159 / 16);
            const e = 0.5 * Math.cos(0.981746875);
            const f = 0.5 * Math.cos(3 * 3.14159 / 8);
            const g = 0.5 * Math.cos(1.374445625);
            var alpha = new Array(4);
            var beta = new Array(4);
            var theta = new Array(4);
            var gamma = new Array(4);
            for(var row = 0; row < 8; ++row){
                var rowPtr = row * 8;
                alpha[0] = c * data[rowPtr + 2];
                alpha[1] = f * data[rowPtr + 2];
                alpha[2] = c * data[rowPtr + 6];
                alpha[3] = f * data[rowPtr + 6];
                beta[0] = b * data[rowPtr + 1] + d * data[rowPtr + 3] + e * data[rowPtr + 5] + g * data[rowPtr + 7];
                beta[1] = d * data[rowPtr + 1] - g * data[rowPtr + 3] - b * data[rowPtr + 5] - e * data[rowPtr + 7];
                beta[2] = e * data[rowPtr + 1] - b * data[rowPtr + 3] + g * data[rowPtr + 5] + d * data[rowPtr + 7];
                beta[3] = g * data[rowPtr + 1] - e * data[rowPtr + 3] + d * data[rowPtr + 5] - b * data[rowPtr + 7];
                theta[0] = a * (data[rowPtr + 0] + data[rowPtr + 4]);
                theta[3] = a * (data[rowPtr + 0] - data[rowPtr + 4]);
                theta[1] = alpha[0] + alpha[3];
                theta[2] = alpha[1] - alpha[2];
                gamma[0] = theta[0] + theta[1];
                gamma[1] = theta[3] + theta[2];
                gamma[2] = theta[3] - theta[2];
                gamma[3] = theta[0] - theta[1];
                data[rowPtr + 0] = gamma[0] + beta[0];
                data[rowPtr + 1] = gamma[1] + beta[1];
                data[rowPtr + 2] = gamma[2] + beta[2];
                data[rowPtr + 3] = gamma[3] + beta[3];
                data[rowPtr + 4] = gamma[3] - beta[3];
                data[rowPtr + 5] = gamma[2] - beta[2];
                data[rowPtr + 6] = gamma[1] - beta[1];
                data[rowPtr + 7] = gamma[0] - beta[0];
            }
            for(var column = 0; column < 8; ++column){
                alpha[0] = c * data[16 + column];
                alpha[1] = f * data[16 + column];
                alpha[2] = c * data[48 + column];
                alpha[3] = f * data[48 + column];
                beta[0] = b * data[8 + column] + d * data[24 + column] + e * data[40 + column] + g * data[56 + column];
                beta[1] = d * data[8 + column] - g * data[24 + column] - b * data[40 + column] - e * data[56 + column];
                beta[2] = e * data[8 + column] - b * data[24 + column] + g * data[40 + column] + d * data[56 + column];
                beta[3] = g * data[8 + column] - e * data[24 + column] + d * data[40 + column] - b * data[56 + column];
                theta[0] = a * (data[column] + data[32 + column]);
                theta[3] = a * (data[column] - data[32 + column]);
                theta[1] = alpha[0] + alpha[3];
                theta[2] = alpha[1] - alpha[2];
                gamma[0] = theta[0] + theta[1];
                gamma[1] = theta[3] + theta[2];
                gamma[2] = theta[3] - theta[2];
                gamma[3] = theta[0] - theta[1];
                data[0 + column] = gamma[0] + beta[0];
                data[8 + column] = gamma[1] + beta[1];
                data[16 + column] = gamma[2] + beta[2];
                data[24 + column] = gamma[3] + beta[3];
                data[32 + column] = gamma[3] - beta[3];
                data[40 + column] = gamma[2] - beta[2];
                data[48 + column] = gamma[1] - beta[1];
                data[56 + column] = gamma[0] - beta[0];
            }
        }
        function csc709Inverse(data) {
            for(var i = 0; i < 64; ++i){
                var y = data[0][i];
                var cb = data[1][i];
                var cr = data[2][i];
                data[0][i] = y + 1.5747 * cr;
                data[1][i] = y - 0.1873 * cb - 0.4682 * cr;
                data[2][i] = y + 1.8556 * cb;
            }
        }
        function convertToHalf(src, dst, idx) {
            for(var i = 0; i < 64; ++i)dst[idx + i] = (0, $329ek.DataUtils).toHalfFloat(toLinear(src[i]));
        }
        function toLinear(float) {
            if (float <= 1) return Math.sign(float) * Math.pow(Math.abs(float), 2.2);
            else return Math.sign(float) * Math.pow(logBase, Math.abs(float) - 1);
        }
        function uncompressRAW(info) {
            return new DataView(info.array.buffer, info.offset.value, info.size);
        }
        function uncompressRLE(info) {
            var compressed = info.viewer.buffer.slice(info.offset.value, info.offset.value + info.size);
            var rawBuffer = new Uint8Array(decodeRunLength(compressed));
            var tmpBuffer = new Uint8Array(rawBuffer.length);
            predictor(rawBuffer);
            interleaveScalar(rawBuffer, tmpBuffer);
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressZIP(info) {
            var compressed = info.array.slice(info.offset.value, info.offset.value + info.size);
            var rawBuffer = (0, $6Z1WP.unzlibSync)(compressed);
            var tmpBuffer = new Uint8Array(rawBuffer.length);
            predictor(rawBuffer);
            interleaveScalar(rawBuffer, tmpBuffer);
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressPIZ(info) {
            var inDataView = info.viewer;
            var inOffset = {
                value: info.offset.value
            };
            var outBuffer = new Uint16Array(info.width * info.scanlineBlockSize * (info.channels * info.type));
            var bitmap = new Uint8Array(BITMAP_SIZE);
            var outBufferEnd = 0;
            var pizChannelData = new Array(info.channels);
            for(var i = 0; i < info.channels; i++){
                pizChannelData[i] = {};
                pizChannelData[i]["start"] = outBufferEnd;
                pizChannelData[i]["end"] = pizChannelData[i]["start"];
                pizChannelData[i]["nx"] = info.width;
                pizChannelData[i]["ny"] = info.lines;
                pizChannelData[i]["size"] = info.type;
                outBufferEnd += pizChannelData[i].nx * pizChannelData[i].ny * pizChannelData[i].size;
            }
            var minNonZero = parseUint16(inDataView, inOffset);
            var maxNonZero = parseUint16(inDataView, inOffset);
            if (maxNonZero >= BITMAP_SIZE) throw "Something is wrong with PIZ_COMPRESSION BITMAP_SIZE";
            if (minNonZero <= maxNonZero) for(var i = 0; i < maxNonZero - minNonZero + 1; i++)bitmap[i + minNonZero] = parseUint8(inDataView, inOffset);
            var lut = new Uint16Array(USHORT_RANGE);
            var maxValue = reverseLutFromBitmap(bitmap, lut);
            var length = parseUint32(inDataView, inOffset);
            hufUncompress(info.array, inDataView, inOffset, length, outBuffer, outBufferEnd);
            for(var i = 0; i < info.channels; ++i){
                var cd = pizChannelData[i];
                for(var j = 0; j < pizChannelData[i].size; ++j)wav2Decode(outBuffer, cd.start + j, cd.nx, cd.size, cd.ny, cd.nx * cd.size, maxValue);
            }
            applyLut(lut, outBuffer, outBufferEnd);
            var tmpOffset2 = 0;
            var tmpBuffer = new Uint8Array(outBuffer.buffer.byteLength);
            for(var y = 0; y < info.lines; y++)for(var c = 0; c < info.channels; c++){
                var cd = pizChannelData[c];
                var n = cd.nx * cd.size;
                var cp = new Uint8Array(outBuffer.buffer, cd.end * INT16_SIZE, n * INT16_SIZE);
                tmpBuffer.set(cp, tmpOffset2);
                tmpOffset2 += n * INT16_SIZE;
                cd.end += n;
            }
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressPXR(info) {
            var compressed = info.array.slice(info.offset.value, info.offset.value + info.size);
            var rawBuffer = (0, $6Z1WP.unzlibSync)(compressed);
            const sz = info.lines * info.channels * info.width;
            const tmpBuffer = info.type == 1 ? new Uint16Array(sz) : new Uint32Array(sz);
            let tmpBufferEnd = 0;
            let writePtr = 0;
            const ptr = new Array(4);
            for(let y = 0; y < info.lines; y++)for(let c = 0; c < info.channels; c++){
                let pixel = 0;
                switch(info.type){
                    case 1:
                        ptr[0] = tmpBufferEnd;
                        ptr[1] = ptr[0] + info.width;
                        tmpBufferEnd = ptr[1] + info.width;
                        for(let j = 0; j < info.width; ++j){
                            const diff = rawBuffer[ptr[0]++] << 8 | rawBuffer[ptr[1]++];
                            pixel += diff;
                            tmpBuffer[writePtr] = pixel;
                            writePtr++;
                        }
                        break;
                    case 2:
                        ptr[0] = tmpBufferEnd;
                        ptr[1] = ptr[0] + info.width;
                        ptr[2] = ptr[1] + info.width;
                        tmpBufferEnd = ptr[2] + info.width;
                        for(let j = 0; j < info.width; ++j){
                            const diff = rawBuffer[ptr[0]++] << 24 | rawBuffer[ptr[1]++] << 16 | rawBuffer[ptr[2]++] << 8;
                            pixel += diff;
                            tmpBuffer[writePtr] = pixel;
                            writePtr++;
                        }
                        break;
                }
            }
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressDWA(info) {
            var inDataView = info.viewer;
            var inOffset = {
                value: info.offset.value
            };
            var outBuffer = new Uint8Array(info.width * info.lines * (info.channels * info.type * INT16_SIZE));
            var dwaHeader = {
                version: parseInt64(inDataView, inOffset),
                unknownUncompressedSize: parseInt64(inDataView, inOffset),
                unknownCompressedSize: parseInt64(inDataView, inOffset),
                acCompressedSize: parseInt64(inDataView, inOffset),
                dcCompressedSize: parseInt64(inDataView, inOffset),
                rleCompressedSize: parseInt64(inDataView, inOffset),
                rleUncompressedSize: parseInt64(inDataView, inOffset),
                rleRawSize: parseInt64(inDataView, inOffset),
                totalAcUncompressedCount: parseInt64(inDataView, inOffset),
                totalDcUncompressedCount: parseInt64(inDataView, inOffset),
                acCompression: parseInt64(inDataView, inOffset)
            };
            if (dwaHeader.version < 2) throw "EXRLoader.parse: " + EXRHeader.compression + " version " + dwaHeader.version + " is unsupported";
            var channelRules = new Array();
            var ruleSize = parseUint16(inDataView, inOffset) - INT16_SIZE;
            while(ruleSize > 0){
                var name = parseNullTerminatedString(inDataView.buffer, inOffset);
                var value = parseUint8(inDataView, inOffset);
                var compression = value >> 2 & 3;
                var csc = (value >> 4) - 1;
                var index = new Int8Array([
                    csc
                ])[0];
                var type = parseUint8(inDataView, inOffset);
                channelRules.push({
                    name: name,
                    index: index,
                    type: type,
                    compression: compression
                });
                ruleSize -= name.length + 3;
            }
            var channels = EXRHeader.channels;
            var channelData = new Array(info.channels);
            for(var i = 0; i < info.channels; ++i){
                var cd = channelData[i] = {};
                var channel = channels[i];
                cd.name = channel.name;
                cd.compression = UNKNOWN;
                cd.decoded = false;
                cd.type = channel.pixelType;
                cd.pLinear = channel.pLinear;
                cd.width = info.width;
                cd.height = info.lines;
            }
            var cscSet = {
                idx: new Array(3)
            };
            for(var offset2 = 0; offset2 < info.channels; ++offset2){
                var cd = channelData[offset2];
                for(var i = 0; i < channelRules.length; ++i){
                    var rule = channelRules[i];
                    if (cd.name == rule.name) {
                        cd.compression = rule.compression;
                        if (rule.index >= 0) cscSet.idx[rule.index] = offset2;
                        cd.offset = offset2;
                    }
                }
            }
            if (dwaHeader.acCompressedSize > 0) switch(dwaHeader.acCompression){
                case STATIC_HUFFMAN:
                    var acBuffer = new Uint16Array(dwaHeader.totalAcUncompressedCount);
                    hufUncompress(info.array, inDataView, inOffset, dwaHeader.acCompressedSize, acBuffer, dwaHeader.totalAcUncompressedCount);
                    break;
                case DEFLATE:
                    var compressed = info.array.slice(inOffset.value, inOffset.value + dwaHeader.totalAcUncompressedCount);
                    var data = (0, $6Z1WP.unzlibSync)(compressed);
                    var acBuffer = new Uint16Array(data.buffer);
                    inOffset.value += dwaHeader.totalAcUncompressedCount;
                    break;
            }
            if (dwaHeader.dcCompressedSize > 0) {
                var zlibInfo = {
                    array: info.array,
                    offset: inOffset,
                    size: dwaHeader.dcCompressedSize
                };
                var dcBuffer = new Uint16Array(uncompressZIP(zlibInfo).buffer);
                inOffset.value += dwaHeader.dcCompressedSize;
            }
            if (dwaHeader.rleRawSize > 0) {
                var compressed = info.array.slice(inOffset.value, inOffset.value + dwaHeader.rleCompressedSize);
                var data = (0, $6Z1WP.unzlibSync)(compressed);
                var rleBuffer = decodeRunLength(data.buffer);
                inOffset.value += dwaHeader.rleCompressedSize;
            }
            var outBufferEnd = 0;
            var rowOffsets = new Array(channelData.length);
            for(var i = 0; i < rowOffsets.length; ++i)rowOffsets[i] = new Array();
            for(var y = 0; y < info.lines; ++y)for(var chan = 0; chan < channelData.length; ++chan){
                rowOffsets[chan].push(outBufferEnd);
                outBufferEnd += channelData[chan].width * info.type * INT16_SIZE;
            }
            lossyDctDecode(cscSet, rowOffsets, channelData, acBuffer, dcBuffer, outBuffer);
            for(var i = 0; i < channelData.length; ++i){
                var cd = channelData[i];
                if (cd.decoded) continue;
                switch(cd.compression){
                    case RLE:
                        var row = 0;
                        var rleOffset = 0;
                        for(var y = 0; y < info.lines; ++y){
                            var rowOffsetBytes = rowOffsets[i][row];
                            for(var x = 0; x < cd.width; ++x){
                                for(var byte = 0; byte < INT16_SIZE * cd.type; ++byte)outBuffer[rowOffsetBytes++] = rleBuffer[rleOffset + byte * cd.width * cd.height];
                                rleOffset++;
                            }
                            row++;
                        }
                        break;
                    case LOSSY_DCT:
                    default:
                        throw "EXRLoader.parse: unsupported channel compression";
                }
            }
            return new DataView(outBuffer.buffer);
        }
        function parseNullTerminatedString(buffer2, offset2) {
            var uintBuffer = new Uint8Array(buffer2);
            var endOffset = 0;
            while(uintBuffer[offset2.value + endOffset] != 0)endOffset += 1;
            var stringValue = new TextDecoder().decode(uintBuffer.slice(offset2.value, offset2.value + endOffset));
            offset2.value = offset2.value + endOffset + 1;
            return stringValue;
        }
        function parseFixedLengthString(buffer2, offset2, size) {
            var stringValue = new TextDecoder().decode(new Uint8Array(buffer2).slice(offset2.value, offset2.value + size));
            offset2.value = offset2.value + size;
            return stringValue;
        }
        function parseRational(dataView, offset2) {
            var x = parseInt32(dataView, offset2);
            var y = parseUint32(dataView, offset2);
            return [
                x,
                y
            ];
        }
        function parseTimecode(dataView, offset2) {
            var x = parseUint32(dataView, offset2);
            var y = parseUint32(dataView, offset2);
            return [
                x,
                y
            ];
        }
        function parseInt32(dataView, offset2) {
            var Int32 = dataView.getInt32(offset2.value, true);
            offset2.value = offset2.value + INT32_SIZE;
            return Int32;
        }
        function parseUint32(dataView, offset2) {
            var Uint32 = dataView.getUint32(offset2.value, true);
            offset2.value = offset2.value + INT32_SIZE;
            return Uint32;
        }
        function parseUint8Array(uInt8Array2, offset2) {
            var Uint8 = uInt8Array2[offset2.value];
            offset2.value = offset2.value + INT8_SIZE;
            return Uint8;
        }
        function parseUint8(dataView, offset2) {
            var Uint8 = dataView.getUint8(offset2.value);
            offset2.value = offset2.value + INT8_SIZE;
            return Uint8;
        }
        const parseInt64 = function(dataView, offset2) {
            let int;
            if ("getBigInt64" in DataView.prototype) int = Number(dataView.getBigInt64(offset2.value, true));
            else int = dataView.getUint32(offset2.value + 4, true) + Number(dataView.getUint32(offset2.value, true) << 32);
            offset2.value += ULONG_SIZE;
            return int;
        };
        function parseFloat32(dataView, offset2) {
            var float = dataView.getFloat32(offset2.value, true);
            offset2.value += FLOAT32_SIZE;
            return float;
        }
        function decodeFloat32(dataView, offset2) {
            return (0, $329ek.DataUtils).toHalfFloat(parseFloat32(dataView, offset2));
        }
        function decodeFloat16(binary) {
            var exponent = (binary & 31744) >> 10, fraction = binary & 1023;
            return (binary >> 15 ? -1 : 1) * (exponent ? exponent === 31 ? fraction ? NaN : Infinity : Math.pow(2, exponent - 15) * (1 + fraction / 1024) : 6103515625e-14 * (fraction / 1024));
        }
        function parseUint16(dataView, offset2) {
            var Uint16 = dataView.getUint16(offset2.value, true);
            offset2.value += INT16_SIZE;
            return Uint16;
        }
        function parseFloat16(buffer2, offset2) {
            return decodeFloat16(parseUint16(buffer2, offset2));
        }
        function parseChlist(dataView, buffer2, offset2, size) {
            var startOffset = offset2.value;
            var channels = [];
            while(offset2.value < startOffset + size - 1){
                var name = parseNullTerminatedString(buffer2, offset2);
                var pixelType = parseInt32(dataView, offset2);
                var pLinear = parseUint8(dataView, offset2);
                offset2.value += 3;
                var xSampling = parseInt32(dataView, offset2);
                var ySampling = parseInt32(dataView, offset2);
                channels.push({
                    name: name,
                    pixelType: pixelType,
                    pLinear: pLinear,
                    xSampling: xSampling,
                    ySampling: ySampling
                });
            }
            offset2.value += 1;
            return channels;
        }
        function parseChromaticities(dataView, offset2) {
            var redX = parseFloat32(dataView, offset2);
            var redY = parseFloat32(dataView, offset2);
            var greenX = parseFloat32(dataView, offset2);
            var greenY = parseFloat32(dataView, offset2);
            var blueX = parseFloat32(dataView, offset2);
            var blueY = parseFloat32(dataView, offset2);
            var whiteX = parseFloat32(dataView, offset2);
            var whiteY = parseFloat32(dataView, offset2);
            return {
                redX: redX,
                redY: redY,
                greenX: greenX,
                greenY: greenY,
                blueX: blueX,
                blueY: blueY,
                whiteX: whiteX,
                whiteY: whiteY
            };
        }
        function parseCompression(dataView, offset2) {
            var compressionCodes = [
                "NO_COMPRESSION",
                "RLE_COMPRESSION",
                "ZIPS_COMPRESSION",
                "ZIP_COMPRESSION",
                "PIZ_COMPRESSION",
                "PXR24_COMPRESSION",
                "B44_COMPRESSION",
                "B44A_COMPRESSION",
                "DWAA_COMPRESSION",
                "DWAB_COMPRESSION"
            ];
            var compression = parseUint8(dataView, offset2);
            return compressionCodes[compression];
        }
        function parseBox2i(dataView, offset2) {
            var xMin = parseUint32(dataView, offset2);
            var yMin = parseUint32(dataView, offset2);
            var xMax = parseUint32(dataView, offset2);
            var yMax = parseUint32(dataView, offset2);
            return {
                xMin: xMin,
                yMin: yMin,
                xMax: xMax,
                yMax: yMax
            };
        }
        function parseLineOrder(dataView, offset2) {
            var lineOrders = [
                "INCREASING_Y"
            ];
            var lineOrder = parseUint8(dataView, offset2);
            return lineOrders[lineOrder];
        }
        function parseV2f(dataView, offset2) {
            var x = parseFloat32(dataView, offset2);
            var y = parseFloat32(dataView, offset2);
            return [
                x,
                y
            ];
        }
        function parseV3f(dataView, offset2) {
            var x = parseFloat32(dataView, offset2);
            var y = parseFloat32(dataView, offset2);
            var z = parseFloat32(dataView, offset2);
            return [
                x,
                y,
                z
            ];
        }
        function parseValue(dataView, buffer2, offset2, type, size) {
            if (type === "string" || type === "stringvector" || type === "iccProfile") return parseFixedLengthString(buffer2, offset2, size);
            else if (type === "chlist") return parseChlist(dataView, buffer2, offset2, size);
            else if (type === "chromaticities") return parseChromaticities(dataView, offset2);
            else if (type === "compression") return parseCompression(dataView, offset2);
            else if (type === "box2i") return parseBox2i(dataView, offset2);
            else if (type === "lineOrder") return parseLineOrder(dataView, offset2);
            else if (type === "float") return parseFloat32(dataView, offset2);
            else if (type === "v2f") return parseV2f(dataView, offset2);
            else if (type === "v3f") return parseV3f(dataView, offset2);
            else if (type === "int") return parseInt32(dataView, offset2);
            else if (type === "rational") return parseRational(dataView, offset2);
            else if (type === "timecode") return parseTimecode(dataView, offset2);
            else if (type === "preview") {
                offset2.value += size;
                return "skipped";
            } else {
                offset2.value += size;
                return void 0;
            }
        }
        function parseHeader(dataView, buffer2, offset2) {
            const EXRHeader2 = {};
            if (dataView.getUint32(0, true) != 20000630) throw "THREE.EXRLoader: provided file doesn't appear to be in OpenEXR format.";
            EXRHeader2.version = dataView.getUint8(4);
            const spec = dataView.getUint8(5);
            EXRHeader2.spec = {
                singleTile: !!(spec & 2),
                longName: !!(spec & 4),
                deepFormat: !!(spec & 8),
                multiPart: !!(spec & 16)
            };
            offset2.value = 8;
            var keepReading = true;
            while(keepReading){
                var attributeName = parseNullTerminatedString(buffer2, offset2);
                if (attributeName == 0) keepReading = false;
                else {
                    var attributeType = parseNullTerminatedString(buffer2, offset2);
                    var attributeSize = parseUint32(dataView, offset2);
                    var attributeValue = parseValue(dataView, buffer2, offset2, attributeType, attributeSize);
                    if (attributeValue === void 0) console.warn(`EXRLoader.parse: skipped unknown header attribute type '${attributeType}'.`);
                    else EXRHeader2[attributeName] = attributeValue;
                }
            }
            if ((spec & -5) != 0) {
                console.error("EXRHeader:", EXRHeader2);
                throw "THREE.EXRLoader: provided file is currently unsupported.";
            }
            return EXRHeader2;
        }
        function setupDecoder(EXRHeader2, dataView, uInt8Array2, offset2, outputType) {
            const EXRDecoder2 = {
                size: 0,
                viewer: dataView,
                array: uInt8Array2,
                offset: offset2,
                width: EXRHeader2.dataWindow.xMax - EXRHeader2.dataWindow.xMin + 1,
                height: EXRHeader2.dataWindow.yMax - EXRHeader2.dataWindow.yMin + 1,
                channels: EXRHeader2.channels.length,
                bytesPerLine: null,
                lines: null,
                inputSize: null,
                type: EXRHeader2.channels[0].pixelType,
                uncompress: null,
                getter: null,
                format: null,
                [$14ca05092b28fea2$var$hasColorSpace ? "colorSpace" : "encoding"]: null
            };
            switch(EXRHeader2.compression){
                case "NO_COMPRESSION":
                    EXRDecoder2.lines = 1;
                    EXRDecoder2.uncompress = uncompressRAW;
                    break;
                case "RLE_COMPRESSION":
                    EXRDecoder2.lines = 1;
                    EXRDecoder2.uncompress = uncompressRLE;
                    break;
                case "ZIPS_COMPRESSION":
                    EXRDecoder2.lines = 1;
                    EXRDecoder2.uncompress = uncompressZIP;
                    break;
                case "ZIP_COMPRESSION":
                    EXRDecoder2.lines = 16;
                    EXRDecoder2.uncompress = uncompressZIP;
                    break;
                case "PIZ_COMPRESSION":
                    EXRDecoder2.lines = 32;
                    EXRDecoder2.uncompress = uncompressPIZ;
                    break;
                case "PXR24_COMPRESSION":
                    EXRDecoder2.lines = 16;
                    EXRDecoder2.uncompress = uncompressPXR;
                    break;
                case "DWAA_COMPRESSION":
                    EXRDecoder2.lines = 32;
                    EXRDecoder2.uncompress = uncompressDWA;
                    break;
                case "DWAB_COMPRESSION":
                    EXRDecoder2.lines = 256;
                    EXRDecoder2.uncompress = uncompressDWA;
                    break;
                default:
                    throw "EXRLoader.parse: " + EXRHeader2.compression + " is unsupported";
            }
            EXRDecoder2.scanlineBlockSize = EXRDecoder2.lines;
            if (EXRDecoder2.type == 1) switch(outputType){
                case 0, $329ek.FloatType:
                    EXRDecoder2.getter = parseFloat16;
                    EXRDecoder2.inputSize = INT16_SIZE;
                    break;
                case 0, $329ek.HalfFloatType:
                    EXRDecoder2.getter = parseUint16;
                    EXRDecoder2.inputSize = INT16_SIZE;
                    break;
            }
            else if (EXRDecoder2.type == 2) switch(outputType){
                case 0, $329ek.FloatType:
                    EXRDecoder2.getter = parseFloat32;
                    EXRDecoder2.inputSize = FLOAT32_SIZE;
                    break;
                case 0, $329ek.HalfFloatType:
                    EXRDecoder2.getter = decodeFloat32;
                    EXRDecoder2.inputSize = FLOAT32_SIZE;
            }
            else throw "EXRLoader.parse: unsupported pixelType " + EXRDecoder2.type + " for " + EXRHeader2.compression + ".";
            EXRDecoder2.blockCount = (EXRHeader2.dataWindow.yMax + 1) / EXRDecoder2.scanlineBlockSize;
            for(var i = 0; i < EXRDecoder2.blockCount; i++)parseInt64(dataView, offset2);
            EXRDecoder2.outputChannels = EXRDecoder2.channels == 3 ? 4 : EXRDecoder2.channels;
            const size = EXRDecoder2.width * EXRDecoder2.height * EXRDecoder2.outputChannels;
            switch(outputType){
                case 0, $329ek.FloatType:
                    EXRDecoder2.byteArray = new Float32Array(size);
                    if (EXRDecoder2.channels < EXRDecoder2.outputChannels) EXRDecoder2.byteArray.fill(1, 0, size);
                    break;
                case 0, $329ek.HalfFloatType:
                    EXRDecoder2.byteArray = new Uint16Array(size);
                    if (EXRDecoder2.channels < EXRDecoder2.outputChannels) EXRDecoder2.byteArray.fill(15360, 0, size);
                    break;
                default:
                    console.error("THREE.EXRLoader: unsupported type: ", outputType);
                    break;
            }
            EXRDecoder2.bytesPerLine = EXRDecoder2.width * EXRDecoder2.inputSize * EXRDecoder2.channels;
            if (EXRDecoder2.outputChannels == 4) EXRDecoder2.format = (0, $329ek.RGBAFormat);
            else EXRDecoder2.format = (0, $329ek.RedFormat);
            if ($14ca05092b28fea2$var$hasColorSpace) EXRDecoder2.colorSpace = "srgb-linear";
            else EXRDecoder2.encoding = 3e3;
            return EXRDecoder2;
        }
        const bufferDataView = new DataView(buffer);
        const uInt8Array = new Uint8Array(buffer);
        const offset = {
            value: 0
        };
        const EXRHeader = parseHeader(bufferDataView, buffer, offset);
        const EXRDecoder = setupDecoder(EXRHeader, bufferDataView, uInt8Array, offset, this.type);
        const tmpOffset = {
            value: 0
        };
        const channelOffsets = {
            R: 0,
            G: 1,
            B: 2,
            A: 3,
            Y: 0
        };
        for(let scanlineBlockIdx = 0; scanlineBlockIdx < EXRDecoder.height / EXRDecoder.scanlineBlockSize; scanlineBlockIdx++){
            const line = parseUint32(bufferDataView, offset);
            EXRDecoder.size = parseUint32(bufferDataView, offset);
            EXRDecoder.lines = line + EXRDecoder.scanlineBlockSize > EXRDecoder.height ? EXRDecoder.height - line : EXRDecoder.scanlineBlockSize;
            const isCompressed = EXRDecoder.size < EXRDecoder.lines * EXRDecoder.bytesPerLine;
            const viewer = isCompressed ? EXRDecoder.uncompress(EXRDecoder) : uncompressRAW(EXRDecoder);
            offset.value += EXRDecoder.size;
            for(let line_y = 0; line_y < EXRDecoder.scanlineBlockSize; line_y++){
                const true_y = line_y + scanlineBlockIdx * EXRDecoder.scanlineBlockSize;
                if (true_y >= EXRDecoder.height) break;
                for(let channelID = 0; channelID < EXRDecoder.channels; channelID++){
                    const cOff = channelOffsets[EXRHeader.channels[channelID].name];
                    for(let x = 0; x < EXRDecoder.width; x++){
                        tmpOffset.value = (line_y * (EXRDecoder.channels * EXRDecoder.width) + channelID * EXRDecoder.width + x) * EXRDecoder.inputSize;
                        const outIndex = (EXRDecoder.height - 1 - true_y) * (EXRDecoder.width * EXRDecoder.outputChannels) + x * EXRDecoder.outputChannels + cOff;
                        EXRDecoder.byteArray[outIndex] = EXRDecoder.getter(viewer, tmpOffset);
                    }
                }
            }
        }
        return {
            header: EXRHeader,
            width: EXRDecoder.width,
            height: EXRDecoder.height,
            data: EXRDecoder.byteArray,
            format: EXRDecoder.format,
            [$14ca05092b28fea2$var$hasColorSpace ? "colorSpace" : "encoding"]: EXRDecoder[$14ca05092b28fea2$var$hasColorSpace ? "colorSpace" : "encoding"],
            type: this.type
        };
    }
    setDataType(value) {
        this.type = value;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        function onLoadCallback(texture, texData) {
            if ($14ca05092b28fea2$var$hasColorSpace) texture.colorSpace = texData.colorSpace;
            else texture.encoding = texData.encoding;
            texture.minFilter = (0, $329ek.LinearFilter);
            texture.magFilter = (0, $329ek.LinearFilter);
            texture.generateMipmaps = false;
            texture.flipY = false;
            if (onLoad) onLoad(texture, texData);
        }
        return super.load(url, onLoadCallback, onProgress, onError);
    }
}

});
parcelRegister("6Z1WP", function(module, exports) {

$parcel$export(module.exports, "unzlibSync", () => $5159f36830dce55a$export$9ec8134f0f1b9fc6);
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $5159f36830dce55a$var$ch2 = {};
var $5159f36830dce55a$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($5159f36830dce55a$var$ch2[id] || ($5159f36830dce55a$var$ch2[id] = URL.createObjectURL(new Blob([
        c
    ], {
        type: 'text/javascript'
    }))));
    w.onerror = function(e) {
        return cb(e.error, null);
    };
    w.onmessage = function(e) {
        return cb(null, e.data);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $5159f36830dce55a$var$u8 = Uint8Array, $5159f36830dce55a$var$u16 = Uint16Array, $5159f36830dce55a$var$u32 = Uint32Array;
// fixed length extra bits
var $5159f36830dce55a$var$fleb = new $5159f36830dce55a$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
// see fleb note
var $5159f36830dce55a$var$fdeb = new $5159f36830dce55a$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $5159f36830dce55a$var$clim = new $5159f36830dce55a$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $5159f36830dce55a$var$freb = function(eb, start) {
    var b = new $5159f36830dce55a$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $5159f36830dce55a$var$u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var $5159f36830dce55a$var$_a = $5159f36830dce55a$var$freb($5159f36830dce55a$var$fleb, 2), $5159f36830dce55a$var$fl = $5159f36830dce55a$var$_a[0], $5159f36830dce55a$var$revfl = $5159f36830dce55a$var$_a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$5159f36830dce55a$var$fl[28] = 258, $5159f36830dce55a$var$revfl[258] = 28;
var $5159f36830dce55a$var$_b = $5159f36830dce55a$var$freb($5159f36830dce55a$var$fdeb, 0), $5159f36830dce55a$var$fd = $5159f36830dce55a$var$_b[0], $5159f36830dce55a$var$revfd = $5159f36830dce55a$var$_b[1];
// map of value to reverse (assuming 16 bits)
var $5159f36830dce55a$var$rev = new $5159f36830dce55a$var$u16(32768);
for(var $5159f36830dce55a$var$i = 0; $5159f36830dce55a$var$i < 32768; ++$5159f36830dce55a$var$i){
    // reverse table algorithm from SO
    var $5159f36830dce55a$var$x = ($5159f36830dce55a$var$i & 0xAAAA) >>> 1 | ($5159f36830dce55a$var$i & 0x5555) << 1;
    $5159f36830dce55a$var$x = ($5159f36830dce55a$var$x & 0xCCCC) >>> 2 | ($5159f36830dce55a$var$x & 0x3333) << 2;
    $5159f36830dce55a$var$x = ($5159f36830dce55a$var$x & 0xF0F0) >>> 4 | ($5159f36830dce55a$var$x & 0x0F0F) << 4;
    $5159f36830dce55a$var$rev[$5159f36830dce55a$var$i] = (($5159f36830dce55a$var$x & 0xFF00) >>> 8 | ($5159f36830dce55a$var$x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $5159f36830dce55a$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $5159f36830dce55a$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $5159f36830dce55a$var$u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $5159f36830dce55a$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$5159f36830dce55a$var$rev[v] >>> rvb] = sv;
        }
    } else {
        co = new $5159f36830dce55a$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $5159f36830dce55a$var$rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $5159f36830dce55a$var$flt = new $5159f36830dce55a$var$u8(288);
for(var $5159f36830dce55a$var$i = 0; $5159f36830dce55a$var$i < 144; ++$5159f36830dce55a$var$i)$5159f36830dce55a$var$flt[$5159f36830dce55a$var$i] = 8;
for(var $5159f36830dce55a$var$i = 144; $5159f36830dce55a$var$i < 256; ++$5159f36830dce55a$var$i)$5159f36830dce55a$var$flt[$5159f36830dce55a$var$i] = 9;
for(var $5159f36830dce55a$var$i = 256; $5159f36830dce55a$var$i < 280; ++$5159f36830dce55a$var$i)$5159f36830dce55a$var$flt[$5159f36830dce55a$var$i] = 7;
for(var $5159f36830dce55a$var$i = 280; $5159f36830dce55a$var$i < 288; ++$5159f36830dce55a$var$i)$5159f36830dce55a$var$flt[$5159f36830dce55a$var$i] = 8;
// fixed distance tree
var $5159f36830dce55a$var$fdt = new $5159f36830dce55a$var$u8(32);
for(var $5159f36830dce55a$var$i = 0; $5159f36830dce55a$var$i < 32; ++$5159f36830dce55a$var$i)$5159f36830dce55a$var$fdt[$5159f36830dce55a$var$i] = 5;
// fixed length map
var $5159f36830dce55a$var$flm = /*#__PURE__*/ $5159f36830dce55a$var$hMap($5159f36830dce55a$var$flt, 9, 0), $5159f36830dce55a$var$flrm = /*#__PURE__*/ $5159f36830dce55a$var$hMap($5159f36830dce55a$var$flt, 9, 1);
// fixed distance map
var $5159f36830dce55a$var$fdm = /*#__PURE__*/ $5159f36830dce55a$var$hMap($5159f36830dce55a$var$fdt, 5, 0), $5159f36830dce55a$var$fdrm = /*#__PURE__*/ $5159f36830dce55a$var$hMap($5159f36830dce55a$var$fdt, 5, 1);
// find max of array
var $5159f36830dce55a$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $5159f36830dce55a$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $5159f36830dce55a$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $5159f36830dce55a$var$shft = function(p) {
    return (p / 8 | 0) + (p & 7 && 1);
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $5159f36830dce55a$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v instanceof $5159f36830dce55a$var$u16 ? $5159f36830dce55a$var$u16 : v instanceof $5159f36830dce55a$var$u32 ? $5159f36830dce55a$var$u32 : $5159f36830dce55a$var$u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
// expands raw DEFLATE data
var $5159f36830dce55a$var$inflt = function(dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || st && !st.l && sl < 5) return buf || new $5159f36830dce55a$var$u8(0);
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new $5159f36830dce55a$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $5159f36830dce55a$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = $5159f36830dce55a$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $5159f36830dce55a$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $5159f36830dce55a$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) throw 'unexpected EOF';
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            } else if (type == 1) lm = $5159f36830dce55a$var$flrm, dm = $5159f36830dce55a$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $5159f36830dce55a$var$bits(dat, pos, 31) + 257, hcLen = $5159f36830dce55a$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $5159f36830dce55a$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $5159f36830dce55a$var$u8(tl);
                // code length tree
                var clt = new $5159f36830dce55a$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$5159f36830dce55a$var$clim[i]] = $5159f36830dce55a$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $5159f36830dce55a$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $5159f36830dce55a$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$5159f36830dce55a$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $5159f36830dce55a$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $5159f36830dce55a$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $5159f36830dce55a$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $5159f36830dce55a$var$max(lt);
                // max dist bits
                dbt = $5159f36830dce55a$var$max(dt);
                lm = $5159f36830dce55a$var$hMap(lt, lbt, 1);
                dm = $5159f36830dce55a$var$hMap(dt, dbt, 1);
            } else throw 'invalid block type';
            if (pos > tbts) {
                if (noSt) throw 'unexpected EOF';
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$5159f36830dce55a$var$bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) throw 'unexpected EOF';
                break;
            }
            if (!c) throw 'invalid length/literal';
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $5159f36830dce55a$var$fleb[i];
                    add = $5159f36830dce55a$var$bits(dat, pos, (1 << b) - 1) + $5159f36830dce55a$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$5159f36830dce55a$var$bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) throw 'invalid distance';
                pos += d & 15;
                var dt = $5159f36830dce55a$var$fd[dsym];
                if (dsym > 3) {
                    var b = $5159f36830dce55a$var$fdeb[dsym];
                    dt += $5159f36830dce55a$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) throw 'unexpected EOF';
                    break;
                }
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : $5159f36830dce55a$var$slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $5159f36830dce55a$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $5159f36830dce55a$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var $5159f36830dce55a$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        $5159f36830dce55a$var$et,
        0
    ];
    if (s == 1) {
        var v = new $5159f36830dce55a$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $5159f36830dce55a$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $5159f36830dce55a$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new $5159f36830dce55a$var$u8(tr),
        mbt
    ];
};
// get the max length and assign length codes
var $5159f36830dce55a$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($5159f36830dce55a$var$ln(n.l, l, d + 1), $5159f36830dce55a$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $5159f36830dce55a$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $5159f36830dce55a$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
// calculate the length of output from tree, code lengths
var $5159f36830dce55a$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $5159f36830dce55a$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $5159f36830dce55a$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $5159f36830dce55a$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $5159f36830dce55a$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $5159f36830dce55a$var$hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = $5159f36830dce55a$var$hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = $5159f36830dce55a$var$lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = $5159f36830dce55a$var$lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new $5159f36830dce55a$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = $5159f36830dce55a$var$hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$5159f36830dce55a$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $5159f36830dce55a$var$clen(lf, $5159f36830dce55a$var$flt) + $5159f36830dce55a$var$clen(df, $5159f36830dce55a$var$fdt) + eb;
    var dtlen = $5159f36830dce55a$var$clen(lf, dlt) + $5159f36830dce55a$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $5159f36830dce55a$var$clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return $5159f36830dce55a$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $5159f36830dce55a$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $5159f36830dce55a$var$hMap(dlt, mlb, 0), ll = dlt, dm = $5159f36830dce55a$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $5159f36830dce55a$var$hMap(lct, mlcb, 0);
        $5159f36830dce55a$var$wbits(out, p, nlc - 257);
        $5159f36830dce55a$var$wbits(out, p + 5, ndc - 1);
        $5159f36830dce55a$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$5159f36830dce55a$var$wbits(out, p + 3 * i, lct[$5159f36830dce55a$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $5159f36830dce55a$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $5159f36830dce55a$var$wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = $5159f36830dce55a$var$flm, ll = $5159f36830dce55a$var$flt, dm = $5159f36830dce55a$var$fdm, dl = $5159f36830dce55a$var$fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        $5159f36830dce55a$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) $5159f36830dce55a$var$wbits(out, p, syms[i] >>> 23 & 31), p += $5159f36830dce55a$var$fleb[len];
        var dst = syms[i] & 31;
        $5159f36830dce55a$var$wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) $5159f36830dce55a$var$wbits16(out, p, syms[i] >>> 5 & 8191), p += $5159f36830dce55a$var$fdeb[dst];
    } else $5159f36830dce55a$var$wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    $5159f36830dce55a$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $5159f36830dce55a$var$deo = /*#__PURE__*/ new $5159f36830dce55a$var$u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $5159f36830dce55a$var$et = /*#__PURE__*/ new $5159f36830dce55a$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $5159f36830dce55a$var$dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new $5159f36830dce55a$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        // end
        var e = i + 65535;
        if (e < s) // write full block
        pos = $5159f36830dce55a$var$wfblk(w, pos, dat.subarray(i, e));
        else {
            // write final block
            w[i] = lst;
            pos = $5159f36830dce55a$var$wfblk(w, pos, dat.subarray(i, s));
        }
    }
    else {
        var opt = $5159f36830dce55a$var$deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new $5159f36830dce55a$var$u16(32768), head = new $5159f36830dce55a$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $5159f36830dce55a$var$u32(25000);
        // length/literal freq   distance freq
        var lf = new $5159f36830dce55a$var$u16(288), df = new $5159f36830dce55a$var$u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            // hash value
            // deopt when i > s - 3 - at end, deopt acceptable
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = $5159f36830dce55a$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $5159f36830dce55a$var$revfl[l] << 18 | $5159f36830dce55a$var$revfd[d];
                    var lin = $5159f36830dce55a$var$revfl[l] & 31, din = $5159f36830dce55a$var$revfd[d] & 31;
                    eb += $5159f36830dce55a$var$fleb[lin] + $5159f36830dce55a$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = $5159f36830dce55a$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst && pos & 7) pos = $5159f36830dce55a$var$wfblk(w, pos + 1, $5159f36830dce55a$var$et);
    }
    return $5159f36830dce55a$var$slc(o, 0, pre + $5159f36830dce55a$var$shft(pos) + post);
};
// CRC32 table
var $5159f36830dce55a$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $5159f36830dce55a$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $5159f36830dce55a$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Alder32
var $5159f36830dce55a$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | a >>> 8 << 16 | (b & 255) << 8 | b >>> 8;
        }
    };
};
// deflate with opts
var $5159f36830dce55a$var$dopt = function(dat, opt, pre, post, st) {
    return $5159f36830dce55a$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var $5159f36830dce55a$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $5159f36830dce55a$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/ /g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [
        fnStr,
        td
    ];
};
var $5159f36830dce55a$var$ch = [];
// clone bufs
var $5159f36830dce55a$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k] instanceof $5159f36830dce55a$var$u8 || v[k] instanceof $5159f36830dce55a$var$u16 || v[k] instanceof $5159f36830dce55a$var$u32) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $5159f36830dce55a$var$wrkr = function(fns, init, id, cb) {
    var _a;
    if (!$5159f36830dce55a$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)_a = $5159f36830dce55a$var$wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        $5159f36830dce55a$var$ch[id] = $5159f36830dce55a$var$wcln(fns[m], fnStr, td_1);
    }
    var td = $5159f36830dce55a$var$mrg({}, $5159f36830dce55a$var$ch[id][1]);
    return $5159f36830dce55a$var$wk($5159f36830dce55a$var$ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $5159f36830dce55a$var$cbfs(td), cb);
};
// base async inflate fn
var $5159f36830dce55a$var$bInflt = function() {
    return [
        $5159f36830dce55a$var$u8,
        $5159f36830dce55a$var$u16,
        $5159f36830dce55a$var$u32,
        $5159f36830dce55a$var$fleb,
        $5159f36830dce55a$var$fdeb,
        $5159f36830dce55a$var$clim,
        $5159f36830dce55a$var$fl,
        $5159f36830dce55a$var$fd,
        $5159f36830dce55a$var$flrm,
        $5159f36830dce55a$var$fdrm,
        $5159f36830dce55a$var$rev,
        $5159f36830dce55a$var$hMap,
        $5159f36830dce55a$var$max,
        $5159f36830dce55a$var$bits,
        $5159f36830dce55a$var$bits16,
        $5159f36830dce55a$var$shft,
        $5159f36830dce55a$var$slc,
        $5159f36830dce55a$var$inflt,
        $5159f36830dce55a$export$90366d8b308ba94a,
        $5159f36830dce55a$var$pbf,
        $5159f36830dce55a$var$gu8
    ];
};
var $5159f36830dce55a$var$bDflt = function() {
    return [
        $5159f36830dce55a$var$u8,
        $5159f36830dce55a$var$u16,
        $5159f36830dce55a$var$u32,
        $5159f36830dce55a$var$fleb,
        $5159f36830dce55a$var$fdeb,
        $5159f36830dce55a$var$clim,
        $5159f36830dce55a$var$revfl,
        $5159f36830dce55a$var$revfd,
        $5159f36830dce55a$var$flm,
        $5159f36830dce55a$var$flt,
        $5159f36830dce55a$var$fdm,
        $5159f36830dce55a$var$fdt,
        $5159f36830dce55a$var$rev,
        $5159f36830dce55a$var$deo,
        $5159f36830dce55a$var$et,
        $5159f36830dce55a$var$hMap,
        $5159f36830dce55a$var$wbits,
        $5159f36830dce55a$var$wbits16,
        $5159f36830dce55a$var$hTree,
        $5159f36830dce55a$var$ln,
        $5159f36830dce55a$var$lc,
        $5159f36830dce55a$var$clen,
        $5159f36830dce55a$var$wfblk,
        $5159f36830dce55a$var$wblk,
        $5159f36830dce55a$var$shft,
        $5159f36830dce55a$var$slc,
        $5159f36830dce55a$var$dflt,
        $5159f36830dce55a$var$dopt,
        $5159f36830dce55a$export$21533ff51b8a0b4a,
        $5159f36830dce55a$var$pbf
    ];
};
// gzip extra
var $5159f36830dce55a$var$gze = function() {
    return [
        $5159f36830dce55a$var$gzh,
        $5159f36830dce55a$var$gzhl,
        $5159f36830dce55a$var$wbytes,
        $5159f36830dce55a$var$crc,
        $5159f36830dce55a$var$crct
    ];
};
// gunzip extra
var $5159f36830dce55a$var$guze = function() {
    return [
        $5159f36830dce55a$var$gzs,
        $5159f36830dce55a$var$gzl
    ];
};
// zlib extra
var $5159f36830dce55a$var$zle = function() {
    return [
        $5159f36830dce55a$var$zlh,
        $5159f36830dce55a$var$wbytes,
        $5159f36830dce55a$var$adler
    ];
};
// unzlib extra
var $5159f36830dce55a$var$zule = function() {
    return [
        $5159f36830dce55a$var$zlv
    ];
};
// post buf
var $5159f36830dce55a$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get u8
var $5159f36830dce55a$var$gu8 = function(o) {
    return o && o.size && new $5159f36830dce55a$var$u8(o.size);
};
// async helper
var $5159f36830dce55a$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $5159f36830dce55a$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $5159f36830dce55a$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var $5159f36830dce55a$var$astrmify = function(fns, strm, opts, init, id) {
    var t;
    var w = $5159f36830dce55a$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (t) throw 'stream finished';
        if (!strm.ondata) throw 'no stream handler';
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var $5159f36830dce55a$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $5159f36830dce55a$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $5159f36830dce55a$var$b8 = function(d, b) {
    return $5159f36830dce55a$var$b4(d, b) + $5159f36830dce55a$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $5159f36830dce55a$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $5159f36830dce55a$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $5159f36830dce55a$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $5159f36830dce55a$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) throw 'invalid gzip data';
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $5159f36830dce55a$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $5159f36830dce55a$var$gzhl = function(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var $5159f36830dce55a$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var $5159f36830dce55a$var$zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) throw 'invalid zlib data';
    if (d[1] & 32) throw 'invalid zlib data: preset dictionaries not supported';
};
function $5159f36830dce55a$var$AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */ var $5159f36830dce55a$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($5159f36830dce55a$var$dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (this.d) throw 'stream finished';
        if (!this.ondata) throw 'no stream handler';
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $5159f36830dce55a$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $5159f36830dce55a$var$astrmify([
            $5159f36830dce55a$var$bDflt,
            function() {
                return [
                    $5159f36830dce55a$var$astrm,
                    $5159f36830dce55a$export$ae157b6234afe138
                ];
            }
        ], this, $5159f36830dce55a$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $5159f36830dce55a$export$ae157b6234afe138(ev.data);
            onmessage = $5159f36830dce55a$var$astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();
function $5159f36830dce55a$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $5159f36830dce55a$var$cbify(data, opts, [
        $5159f36830dce55a$var$bDflt
    ], function(ev) {
        return $5159f36830dce55a$var$pbf($5159f36830dce55a$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $5159f36830dce55a$export$21533ff51b8a0b4a(data, opts) {
    return $5159f36830dce55a$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $5159f36830dce55a$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */ function Inflate(cb) {
        this.s = {};
        this.p = new $5159f36830dce55a$var$u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function(c) {
        if (this.d) throw 'stream finished';
        if (!this.ondata) throw 'no stream handler';
        var l = this.p.length;
        var n = new $5159f36830dce55a$var$u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function(final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = $5159f36830dce55a$var$inflt(this.p, this.o, this.s);
        this.ondata($5159f36830dce55a$var$slc(dt, bts, this.s.b), this.d);
        this.o = $5159f36830dce55a$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $5159f36830dce55a$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $5159f36830dce55a$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncInflate(cb) {
        this.ondata = cb;
        $5159f36830dce55a$var$astrmify([
            $5159f36830dce55a$var$bInflt,
            function() {
                return [
                    $5159f36830dce55a$var$astrm,
                    $5159f36830dce55a$export$d1de70a877d6e43c
                ];
            }
        ], this, 0, function() {
            var strm = new $5159f36830dce55a$export$d1de70a877d6e43c();
            onmessage = $5159f36830dce55a$var$astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();
function $5159f36830dce55a$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $5159f36830dce55a$var$cbify(data, opts, [
        $5159f36830dce55a$var$bInflt
    ], function(ev) {
        return $5159f36830dce55a$var$pbf($5159f36830dce55a$export$90366d8b308ba94a(ev.data[0], $5159f36830dce55a$var$gu8(ev.data[1])));
    }, 1, cb);
}
function $5159f36830dce55a$export$90366d8b308ba94a(data, out) {
    return $5159f36830dce55a$var$inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $5159f36830dce55a$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $5159f36830dce55a$var$crc();
        this.l = 0;
        this.v = 1;
        $5159f36830dce55a$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        $5159f36830dce55a$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = $5159f36830dce55a$var$dopt(c, this.o, this.v && $5159f36830dce55a$var$gzhl(this.o), f && 8, !f);
        if (this.v) $5159f36830dce55a$var$gzh(raw, this.o), this.v = 0;
        if (f) $5159f36830dce55a$var$wbytes(raw, raw.length - 8, this.c.d()), $5159f36830dce55a$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $5159f36830dce55a$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $5159f36830dce55a$var$astrmify([
            $5159f36830dce55a$var$bDflt,
            $5159f36830dce55a$var$gze,
            function() {
                return [
                    $5159f36830dce55a$var$astrm,
                    $5159f36830dce55a$export$ae157b6234afe138,
                    $5159f36830dce55a$export$8e4b66d280bf8342
                ];
            }
        ], this, $5159f36830dce55a$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $5159f36830dce55a$export$8e4b66d280bf8342(ev.data);
            onmessage = $5159f36830dce55a$var$astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();
function $5159f36830dce55a$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $5159f36830dce55a$var$cbify(data, opts, [
        $5159f36830dce55a$var$bDflt,
        $5159f36830dce55a$var$gze,
        function() {
            return [
                $5159f36830dce55a$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $5159f36830dce55a$var$pbf($5159f36830dce55a$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $5159f36830dce55a$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $5159f36830dce55a$var$crc(), l = data.length;
    c.p(data);
    var d = $5159f36830dce55a$var$dopt(data, opts, $5159f36830dce55a$var$gzhl(opts), 8), s = d.length;
    return $5159f36830dce55a$var$gzh(d, opts), $5159f36830dce55a$var$wbytes(d, s - 8, c.d()), $5159f36830dce55a$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */ var $5159f36830dce55a$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */ function Gunzip(cb) {
        this.v = 1;
        $5159f36830dce55a$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $5159f36830dce55a$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            var s = this.p.length > 3 ? $5159f36830dce55a$var$gzs(this.p) : 4;
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) throw 'invalid gzip stream';
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $5159f36830dce55a$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming GZIP decompression
 */ var $5159f36830dce55a$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncGunzip(cb) {
        this.ondata = cb;
        $5159f36830dce55a$var$astrmify([
            $5159f36830dce55a$var$bInflt,
            $5159f36830dce55a$var$guze,
            function() {
                return [
                    $5159f36830dce55a$var$astrm,
                    $5159f36830dce55a$export$d1de70a877d6e43c,
                    $5159f36830dce55a$export$4cb607de6db70415
                ];
            }
        ], this, 0, function() {
            var strm = new $5159f36830dce55a$export$4cb607de6db70415();
            onmessage = $5159f36830dce55a$var$astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}();
function $5159f36830dce55a$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $5159f36830dce55a$var$cbify(data, opts, [
        $5159f36830dce55a$var$bInflt,
        $5159f36830dce55a$var$guze,
        function() {
            return [
                $5159f36830dce55a$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $5159f36830dce55a$var$pbf($5159f36830dce55a$export$c80456f7aaba691c(ev.data[0]));
    }, 3, cb);
}
function $5159f36830dce55a$export$c80456f7aaba691c(data, out) {
    return $5159f36830dce55a$var$inflt(data.subarray($5159f36830dce55a$var$gzs(data), -8), out || new $5159f36830dce55a$var$u8($5159f36830dce55a$var$gzl(data)));
}
/**
 * Streaming Zlib compression
 */ var $5159f36830dce55a$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $5159f36830dce55a$var$adler();
        this.v = 1;
        $5159f36830dce55a$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        $5159f36830dce55a$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        this.c.p(c);
        var raw = $5159f36830dce55a$var$dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) $5159f36830dce55a$var$zlh(raw, this.o), this.v = 0;
        if (f) $5159f36830dce55a$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $5159f36830dce55a$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $5159f36830dce55a$var$astrmify([
            $5159f36830dce55a$var$bDflt,
            $5159f36830dce55a$var$zle,
            function() {
                return [
                    $5159f36830dce55a$var$astrm,
                    $5159f36830dce55a$export$ae157b6234afe138,
                    $5159f36830dce55a$export$4187ccf2467013b9
                ];
            }
        ], this, $5159f36830dce55a$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $5159f36830dce55a$export$4187ccf2467013b9(ev.data);
            onmessage = $5159f36830dce55a$var$astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();
function $5159f36830dce55a$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $5159f36830dce55a$var$cbify(data, opts, [
        $5159f36830dce55a$var$bDflt,
        $5159f36830dce55a$var$zle,
        function() {
            return [
                $5159f36830dce55a$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $5159f36830dce55a$var$pbf($5159f36830dce55a$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $5159f36830dce55a$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $5159f36830dce55a$var$adler();
    a.p(data);
    var d = $5159f36830dce55a$var$dopt(data, opts, 2, 4);
    return $5159f36830dce55a$var$zlh(d, opts), $5159f36830dce55a$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $5159f36830dce55a$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */ function Unzlib(cb) {
        this.v = 1;
        $5159f36830dce55a$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $5159f36830dce55a$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) throw 'invalid zlib stream';
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $5159f36830dce55a$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $5159f36830dce55a$export$cf6668790220dcad = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncUnzlib(cb) {
        this.ondata = cb;
        $5159f36830dce55a$var$astrmify([
            $5159f36830dce55a$var$bInflt,
            $5159f36830dce55a$var$zule,
            function() {
                return [
                    $5159f36830dce55a$var$astrm,
                    $5159f36830dce55a$export$d1de70a877d6e43c,
                    $5159f36830dce55a$export$af2424f875ff1b17
                ];
            }
        ], this, 0, function() {
            var strm = new $5159f36830dce55a$export$af2424f875ff1b17();
            onmessage = $5159f36830dce55a$var$astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();
function $5159f36830dce55a$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $5159f36830dce55a$var$cbify(data, opts, [
        $5159f36830dce55a$var$bInflt,
        $5159f36830dce55a$var$zule,
        function() {
            return [
                $5159f36830dce55a$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $5159f36830dce55a$var$pbf($5159f36830dce55a$export$9ec8134f0f1b9fc6(ev.data[0], $5159f36830dce55a$var$gu8(ev.data[1])));
    }, 5, cb);
}
function $5159f36830dce55a$export$9ec8134f0f1b9fc6(data, out) {
    return $5159f36830dce55a$var$inflt(($5159f36830dce55a$var$zlv(data), data.subarray(2, -4)), out);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $5159f36830dce55a$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */ function Decompress(cb) {
        this.G = $5159f36830dce55a$export$4cb607de6db70415;
        this.I = $5159f36830dce55a$export$d1de70a877d6e43c;
        this.Z = $5159f36830dce55a$export$af2424f875ff1b17;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no stream handler';
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $5159f36830dce55a$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $5159f36830dce55a$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */ function AsyncDecompress(cb) {
        this.G = $5159f36830dce55a$export$d5adcdd968132151;
        this.I = $5159f36830dce55a$export$fff8358d6dbaa9cc;
        this.Z = $5159f36830dce55a$export$cf6668790220dcad;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        $5159f36830dce55a$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $5159f36830dce55a$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $5159f36830dce55a$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $5159f36830dce55a$export$cae1ce83fe4a1782(data, opts, cb) : $5159f36830dce55a$export$ca7cbb494e731274(data, opts, cb);
}
function $5159f36830dce55a$export$c4bdbbbc9a4faabe(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $5159f36830dce55a$export$c80456f7aaba691c(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $5159f36830dce55a$export$90366d8b308ba94a(data, out) : $5159f36830dce55a$export$9ec8134f0f1b9fc6(data, out);
}
// flatten a directory structure
var $5159f36830dce55a$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k;
        if (val instanceof $5159f36830dce55a$var$u8) t[n] = [
            val,
            o
        ];
        else if (Array.isArray(val)) t[n] = [
            val[0],
            $5159f36830dce55a$var$mrg(o, val[1])
        ];
        else $5159f36830dce55a$var$fltn(val, n + '/', t, o);
    }
};
// text encoder
var $5159f36830dce55a$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $5159f36830dce55a$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $5159f36830dce55a$var$tds = 0;
try {
    $5159f36830dce55a$var$td.decode($5159f36830dce55a$var$et, {
        stream: true
    });
    $5159f36830dce55a$var$tds = 1;
} catch (e) {}
// decode UTF8
var $5159f36830dce55a$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return [
            r,
            $5159f36830dce55a$var$slc(d, i - 1)
        ];
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $5159f36830dce55a$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($5159f36830dce55a$var$tds) this.t = new TextDecoder();
        else this.p = $5159f36830dce55a$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no callback';
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) throw 'invalid utf-8 data';
                this.t = null;
            }
            return;
        }
        if (!this.p) throw 'stream finished';
        var dat = new $5159f36830dce55a$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $5159f36830dce55a$var$dutf8(dat), ch = _a[0], np = _a[1];
        if (final) {
            if (np.length) throw 'invalid utf-8 data';
            this.p = null;
        } else this.p = np;
        this.ondata(ch, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $5159f36830dce55a$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no callback';
        if (this.d) throw 'stream finished';
        this.ondata($5159f36830dce55a$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $5159f36830dce55a$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $5159f36830dce55a$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($5159f36830dce55a$var$te) return $5159f36830dce55a$var$te.encode(str);
    var l = str.length;
    var ar = new $5159f36830dce55a$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $5159f36830dce55a$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $5159f36830dce55a$var$slc(ar, 0, ai);
}
function $5159f36830dce55a$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($5159f36830dce55a$var$td) return $5159f36830dce55a$var$td.decode(dat);
    else {
        var _a = $5159f36830dce55a$var$dutf8(dat), out = _a[0], ext = _a[1];
        if (ext.length) throw 'invalid utf-8 data';
        return out;
    }
}
// deflate bit flag
var $5159f36830dce55a$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $5159f36830dce55a$var$slzh = function(d, b) {
    return b + 30 + $5159f36830dce55a$var$b2(d, b + 26) + $5159f36830dce55a$var$b2(d, b + 28);
};
// read zip header
var $5159f36830dce55a$var$zh = function(d, b, z) {
    var fnl = $5159f36830dce55a$var$b2(d, b + 28), fn = $5159f36830dce55a$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($5159f36830dce55a$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $5159f36830dce55a$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $5159f36830dce55a$var$z64e(d, es) : [
        bs,
        $5159f36830dce55a$var$b4(d, b + 24),
        $5159f36830dce55a$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $5159f36830dce55a$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $5159f36830dce55a$var$b2(d, b + 30) + $5159f36830dce55a$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $5159f36830dce55a$var$z64e = function(d, b) {
    for(; $5159f36830dce55a$var$b2(d, b) != 1; b += 4 + $5159f36830dce55a$var$b2(d, b + 2));
    return [
        $5159f36830dce55a$var$b8(d, b + 12),
        $5159f36830dce55a$var$b8(d, b + 4),
        $5159f36830dce55a$var$b8(d, b + 20)
    ];
};
// extra field length
var $5159f36830dce55a$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) throw 'extra field too long';
        le += l + 4;
    }
    return le;
};
// write zip header
var $5159f36830dce55a$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $5159f36830dce55a$var$exfl(ex);
    $5159f36830dce55a$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c == null && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) throw 'date not in range 1980-2099';
    $5159f36830dce55a$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1), b += 4;
    if (c != null) {
        $5159f36830dce55a$var$wbytes(d, b, f.crc);
        $5159f36830dce55a$var$wbytes(d, b + 4, c);
        $5159f36830dce55a$var$wbytes(d, b + 8, f.size);
    }
    $5159f36830dce55a$var$wbytes(d, b + 12, fl);
    $5159f36830dce55a$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $5159f36830dce55a$var$wbytes(d, b, col);
        $5159f36830dce55a$var$wbytes(d, b + 6, f.attrs);
        $5159f36830dce55a$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $5159f36830dce55a$var$wbytes(d, b, +k);
        $5159f36830dce55a$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $5159f36830dce55a$var$wzf = function(o, b, c, d, e) {
    $5159f36830dce55a$var$wbytes(o, b, 0x6054B50); // skip disk
    $5159f36830dce55a$var$wbytes(o, b + 8, c);
    $5159f36830dce55a$var$wbytes(o, b + 10, c);
    $5159f36830dce55a$var$wbytes(o, b + 12, d);
    $5159f36830dce55a$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $5159f36830dce55a$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $5159f36830dce55a$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no callback - add to ZIP archive before pushing';
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $5159f36830dce55a$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $5159f36830dce55a$export$2b25194e1767ea06.call(this, filename);
        this.d = new $5159f36830dce55a$export$ae157b6234afe138(opts, function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $5159f36830dce55a$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $5159f36830dce55a$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $5159f36830dce55a$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $5159f36830dce55a$export$2b25194e1767ea06.call(this, filename);
        this.d = new $5159f36830dce55a$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $5159f36830dce55a$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $5159f36830dce55a$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $5159f36830dce55a$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this_1 = this;
        if (this.d & 2) throw 'stream finished';
        var f = $5159f36830dce55a$export$366b39a6daa8ed7a(file.filename), fl = f.length;
        var com = file.comment, o = com && $5159f36830dce55a$export$366b39a6daa8ed7a(com);
        var u = fl != file.filename.length || o && com.length != o.length;
        var hl = fl + $5159f36830dce55a$var$exfl(file.extra) + 30;
        if (fl > 65535) throw 'filename too long';
        var header = new $5159f36830dce55a$var$u8(hl);
        $5159f36830dce55a$var$wzh(header, 0, file, f, u);
        var chks = [
            header
        ];
        var pAll = function() {
            for(var _i = 0, chks_1 = chks; _i < chks_1.length; _i++){
                var chk = chks_1[_i];
                _this_1.ondata(null, chk, false);
            }
            chks = [];
        };
        var tr = this.d;
        this.d = 0;
        var ind = this.u.length;
        var uf = $5159f36830dce55a$var$mrg(file, {
            f: f,
            u: u,
            o: o,
            t: function() {
                if (file.terminate) file.terminate();
            },
            r: function() {
                pAll();
                if (tr) {
                    var nxt = _this_1.u[ind + 1];
                    if (nxt) nxt.r();
                    else _this_1.d = 1;
                }
                tr = 1;
            }
        });
        var cl = 0;
        file.ondata = function(err, dat, final) {
            if (err) {
                _this_1.ondata(err, dat, final);
                _this_1.terminate();
            } else {
                cl += dat.length;
                chks.push(dat);
                if (final) {
                    var dd = new $5159f36830dce55a$var$u8(16);
                    $5159f36830dce55a$var$wbytes(dd, 0, 0x8074B50);
                    $5159f36830dce55a$var$wbytes(dd, 4, file.crc);
                    $5159f36830dce55a$var$wbytes(dd, 8, cl);
                    $5159f36830dce55a$var$wbytes(dd, 12, file.size);
                    chks.push(dd);
                    uf.c = cl, uf.b = hl + cl + 16, uf.crc = file.crc, uf.size = file.size;
                    if (tr) uf.r();
                    tr = 1;
                } else if (tr) pAll();
            }
        };
        this.u.push(uf);
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this_1 = this;
        if (this.d & 2) {
            if (this.d & 1) throw 'stream finishing';
            throw 'stream finished';
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this_1.d & 1)) return;
                _this_1.u.splice(-1, 1);
                _this_1.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $5159f36830dce55a$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $5159f36830dce55a$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $5159f36830dce55a$var$wzh(out, bt, f, f.f, f.u, f.c, l, f.o);
            bt += 46 + f.f.length + $5159f36830dce55a$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $5159f36830dce55a$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $5159f36830dce55a$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    var r = {};
    $5159f36830dce55a$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbf = function() {
        var out = new $5159f36830dce55a$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $5159f36830dce55a$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $5159f36830dce55a$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $5159f36830dce55a$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cb(e, null);
            }
        }
        $5159f36830dce55a$var$wzf(out, o, files.length, cdl, oe);
        cb(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $5159f36830dce55a$var$crc(), size = file.length;
        c.p(file);
        var f = $5159f36830dce55a$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $5159f36830dce55a$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $5159f36830dce55a$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                var l = d.length;
                files[i] = $5159f36830dce55a$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl('filename too long', null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $5159f36830dce55a$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($5159f36830dce55a$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $5159f36830dce55a$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $5159f36830dce55a$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $5159f36830dce55a$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $5159f36830dce55a$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $5159f36830dce55a$var$exfl(p.extra);
        if (s > 65535) throw 'filename too long';
        var d = compression ? $5159f36830dce55a$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $5159f36830dce55a$var$crc();
        c.p(file);
        files.push($5159f36830dce55a$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $5159f36830dce55a$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $5159f36830dce55a$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $5159f36830dce55a$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $5159f36830dce55a$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $5159f36830dce55a$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $5159f36830dce55a$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $5159f36830dce55a$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this_1 = this;
        this.i = new $5159f36830dce55a$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, data, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $5159f36830dce55a$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) this.i = new $5159f36830dce55a$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        else {
            this.i = new $5159f36830dce55a$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $5159f36830dce55a$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $5159f36830dce55a$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $5159f36830dce55a$export$93f81d5bbbb7c6bf
        };
        this.p = $5159f36830dce55a$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this_1 = this;
        if (!this.onfile) throw 'no callback';
        if (!this.p) throw 'stream finished';
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $5159f36830dce55a$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $5159f36830dce55a$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $5159f36830dce55a$var$b2(buf, i + 6), cmp_1 = $5159f36830dce55a$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $5159f36830dce55a$var$b2(buf, i + 26), es = $5159f36830dce55a$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_2 = [];
                        this_1.k.unshift(chks_2);
                        f = 2;
                        var sc_1 = $5159f36830dce55a$var$b4(buf, i + 18), su_1 = $5159f36830dce55a$var$b4(buf, i + 22);
                        var fn_1 = $5159f36830dce55a$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $5159f36830dce55a$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) throw 'no callback';
                                if (!sc_1) file_1.ondata(null, $5159f36830dce55a$var$et, true);
                                else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr) throw 'unknown compression type ' + cmp_1;
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_3 = chks_2; _i < chks_3.length; _i++){
                                        var dat = chks_3[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_2 && _this_1.c) _this_1.d = d_1;
                                    else d_1.push($5159f36830dce55a$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $5159f36830dce55a$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($5159f36830dce55a$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) throw 'invalid zip file';
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
function $5159f36830dce55a$export$23c8d3f8757cab88(data, cb) {
    if (typeof cb != 'function') throw 'no callback';
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var e = data.length - 22;
    for(; $5159f36830dce55a$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cb('invalid zip file', null);
        return;
    }
    var lft = $5159f36830dce55a$var$b2(data, e + 8);
    if (!lft) cb(null, {});
    var c = lft;
    var o = $5159f36830dce55a$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $5159f36830dce55a$var$b4(data, e - 12);
        if ($5159f36830dce55a$var$b4(data, e) != 0x6064B50) {
            cb('invalid zip file', null);
            return;
        }
        c = lft = $5159f36830dce55a$var$b4(data, e + 32);
        o = $5159f36830dce55a$var$b4(data, e + 48);
    }
    var _loop_3 = function(i) {
        var _a = $5159f36830dce55a$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $5159f36830dce55a$var$slzh(data, off);
        o = no;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                files[fn] = d;
                if (!--lft) cb(null, files);
            }
        };
        if (!c_1) cbl(null, $5159f36830dce55a$var$slc(data, b, b + sc));
        else if (c_1 == 8) {
            var infl = data.subarray(b, b + sc);
            if (sc < 320000) try {
                cbl(null, $5159f36830dce55a$export$90366d8b308ba94a(infl, new $5159f36830dce55a$var$u8(su)));
            } catch (e) {
                cbl(e, null);
            }
            else term.push($5159f36830dce55a$export$cae1ce83fe4a1782(infl, {
                size: su
            }, cbl));
        } else cbl('unknown compression type ' + c_1, null);
    };
    for(var i = 0; i < c; ++i)_loop_3(i);
    return tAll;
}
function $5159f36830dce55a$export$c757709326bb5901(data) {
    var files = {};
    var e = data.length - 22;
    for(; $5159f36830dce55a$var$b4(data, e) != 0x6054B50; --e){
        if (!e || data.length - e > 65558) throw 'invalid zip file';
    }
    var c = $5159f36830dce55a$var$b2(data, e + 8);
    if (!c) return {};
    var o = $5159f36830dce55a$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $5159f36830dce55a$var$b4(data, e - 12);
        if ($5159f36830dce55a$var$b4(data, e) != 0x6064B50) throw 'invalid zip file';
        c = $5159f36830dce55a$var$b4(data, e + 32);
        o = $5159f36830dce55a$var$b4(data, e + 48);
    }
    for(var i = 0; i < c; ++i){
        var _a = $5159f36830dce55a$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $5159f36830dce55a$var$slzh(data, off);
        o = no;
        if (!c_2) files[fn] = $5159f36830dce55a$var$slc(data, b, b + sc);
        else if (c_2 == 8) files[fn] = $5159f36830dce55a$export$90366d8b308ba94a(data.subarray(b, b + sc), new $5159f36830dce55a$var$u8(su));
        else throw 'unknown compression type ' + c_2;
    }
    return files;
}

});


parcelRegister("eIqiV", function(module, exports) {

$parcel$export(module.exports, "RGBELoader", () => $ab69943c09727be5$export$d076a711b55c758a);

var $329ek = parcelRequire("329ek");parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
class $ab69943c09727be5$export$d076a711b55c758a extends (0, $329ek.DataTextureLoader) {
    constructor(manager){
        super(manager);
        this.type = (0, $329ek.HalfFloatType);
    }
    // adapted from http://www.graphics.cornell.edu/~bjw/rgbe.html
    parse(buffer) {
        const rgbe_read_error = 1, rgbe_write_error = 2, rgbe_format_error = 3, rgbe_memory_error = 4, rgbe_error = function(rgbe_error_code, msg) {
            switch(rgbe_error_code){
                case rgbe_read_error:
                    throw new Error("THREE.RGBELoader: Read Error: " + (msg || ""));
                case rgbe_write_error:
                    throw new Error("THREE.RGBELoader: Write Error: " + (msg || ""));
                case rgbe_format_error:
                    throw new Error("THREE.RGBELoader: Bad File Format: " + (msg || ""));
                default:
                case rgbe_memory_error:
                    throw new Error("THREE.RGBELoader: Memory Error: " + (msg || ""));
            }
        }, RGBE_VALID_PROGRAMTYPE = 1, RGBE_VALID_FORMAT = 2, RGBE_VALID_DIMENSIONS = 4, NEWLINE = "\n", fgets = function(buffer2, lineLimit, consume) {
            const chunkSize = 128;
            lineLimit = !lineLimit ? 1024 : lineLimit;
            let p = buffer2.pos, i = -1, len = 0, s = "", chunk = String.fromCharCode.apply(null, new Uint16Array(buffer2.subarray(p, p + chunkSize)));
            while(0 > (i = chunk.indexOf(NEWLINE)) && len < lineLimit && p < buffer2.byteLength){
                s += chunk;
                len += chunk.length;
                p += chunkSize;
                chunk += String.fromCharCode.apply(null, new Uint16Array(buffer2.subarray(p, p + chunkSize)));
            }
            if (-1 < i) {
                if (false !== consume) buffer2.pos += len + i + 1;
                return s + chunk.slice(0, i);
            }
            return false;
        }, RGBE_ReadHeader = function(buffer2) {
            const magic_token_re = /^#\?(\S+)/, gamma_re = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/, exposure_re = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/, format_re = /^\s*FORMAT=(\S+)\s*$/, dimensions_re = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/, header = {
                valid: 0,
                string: "",
                comments: "",
                programtype: "RGBE",
                format: "",
                gamma: 1,
                exposure: 1,
                width: 0,
                height: 0
            };
            let line, match;
            if (buffer2.pos >= buffer2.byteLength || !(line = fgets(buffer2))) rgbe_error(rgbe_read_error, "no header found");
            if (!(match = line.match(magic_token_re))) rgbe_error(rgbe_format_error, "bad initial token");
            header.valid |= RGBE_VALID_PROGRAMTYPE;
            header.programtype = match[1];
            header.string += line + "\n";
            while(true){
                line = fgets(buffer2);
                if (false === line) break;
                header.string += line + "\n";
                if ("#" === line.charAt(0)) {
                    header.comments += line + "\n";
                    continue;
                }
                if (match = line.match(gamma_re)) header.gamma = parseFloat(match[1]);
                if (match = line.match(exposure_re)) header.exposure = parseFloat(match[1]);
                if (match = line.match(format_re)) {
                    header.valid |= RGBE_VALID_FORMAT;
                    header.format = match[1];
                }
                if (match = line.match(dimensions_re)) {
                    header.valid |= RGBE_VALID_DIMENSIONS;
                    header.height = parseInt(match[1], 10);
                    header.width = parseInt(match[2], 10);
                }
                if (header.valid & RGBE_VALID_FORMAT && header.valid & RGBE_VALID_DIMENSIONS) break;
            }
            if (!(header.valid & RGBE_VALID_FORMAT)) rgbe_error(rgbe_format_error, "missing format specifier");
            if (!(header.valid & RGBE_VALID_DIMENSIONS)) rgbe_error(rgbe_format_error, "missing image size specifier");
            return header;
        }, RGBE_ReadPixels_RLE = function(buffer2, w2, h2) {
            const scanline_width = w2;
            if (// run length encoding is not allowed so read flat
            scanline_width < 8 || scanline_width > 32767 || // this file is not run length encoded
            2 !== buffer2[0] || 2 !== buffer2[1] || buffer2[2] & 128) return new Uint8Array(buffer2);
            if (scanline_width !== (buffer2[2] << 8 | buffer2[3])) rgbe_error(rgbe_format_error, "wrong scanline width");
            const data_rgba = new Uint8Array(4 * w2 * h2);
            if (!data_rgba.length) rgbe_error(rgbe_memory_error, "unable to allocate buffer space");
            let offset = 0, pos = 0;
            const ptr_end = 4 * scanline_width;
            const rgbeStart = new Uint8Array(4);
            const scanline_buffer = new Uint8Array(ptr_end);
            let num_scanlines = h2;
            while(num_scanlines > 0 && pos < buffer2.byteLength){
                if (pos + 4 > buffer2.byteLength) rgbe_error(rgbe_read_error);
                rgbeStart[0] = buffer2[pos++];
                rgbeStart[1] = buffer2[pos++];
                rgbeStart[2] = buffer2[pos++];
                rgbeStart[3] = buffer2[pos++];
                if (2 != rgbeStart[0] || 2 != rgbeStart[1] || (rgbeStart[2] << 8 | rgbeStart[3]) != scanline_width) rgbe_error(rgbe_format_error, "bad rgbe scanline format");
                let ptr = 0, count;
                while(ptr < ptr_end && pos < buffer2.byteLength){
                    count = buffer2[pos++];
                    const isEncodedRun = count > 128;
                    if (isEncodedRun) count -= 128;
                    if (0 === count || ptr + count > ptr_end) rgbe_error(rgbe_format_error, "bad scanline data");
                    if (isEncodedRun) {
                        const byteValue = buffer2[pos++];
                        for(let i = 0; i < count; i++)scanline_buffer[ptr++] = byteValue;
                    } else {
                        scanline_buffer.set(buffer2.subarray(pos, pos + count), ptr);
                        ptr += count;
                        pos += count;
                    }
                }
                const l = scanline_width;
                for(let i = 0; i < l; i++){
                    let off = 0;
                    data_rgba[offset] = scanline_buffer[i + off];
                    off += scanline_width;
                    data_rgba[offset + 1] = scanline_buffer[i + off];
                    off += scanline_width;
                    data_rgba[offset + 2] = scanline_buffer[i + off];
                    off += scanline_width;
                    data_rgba[offset + 3] = scanline_buffer[i + off];
                    offset += 4;
                }
                num_scanlines--;
            }
            return data_rgba;
        };
        const RGBEByteToRGBFloat = function(sourceArray, sourceOffset, destArray, destOffset) {
            const e = sourceArray[sourceOffset + 3];
            const scale = Math.pow(2, e - 128) / 255;
            destArray[destOffset + 0] = sourceArray[sourceOffset + 0] * scale;
            destArray[destOffset + 1] = sourceArray[sourceOffset + 1] * scale;
            destArray[destOffset + 2] = sourceArray[sourceOffset + 2] * scale;
            destArray[destOffset + 3] = 1;
        };
        const RGBEByteToRGBHalf = function(sourceArray, sourceOffset, destArray, destOffset) {
            const e = sourceArray[sourceOffset + 3];
            const scale = Math.pow(2, e - 128) / 255;
            destArray[destOffset + 0] = (0, $329ek.DataUtils).toHalfFloat(Math.min(sourceArray[sourceOffset + 0] * scale, 65504));
            destArray[destOffset + 1] = (0, $329ek.DataUtils).toHalfFloat(Math.min(sourceArray[sourceOffset + 1] * scale, 65504));
            destArray[destOffset + 2] = (0, $329ek.DataUtils).toHalfFloat(Math.min(sourceArray[sourceOffset + 2] * scale, 65504));
            destArray[destOffset + 3] = (0, $329ek.DataUtils).toHalfFloat(1);
        };
        const byteArray = new Uint8Array(buffer);
        byteArray.pos = 0;
        const rgbe_header_info = RGBE_ReadHeader(byteArray);
        const w = rgbe_header_info.width, h = rgbe_header_info.height, image_rgba_data = RGBE_ReadPixels_RLE(byteArray.subarray(byteArray.pos), w, h);
        let data, type;
        let numElements;
        switch(this.type){
            case 0, $329ek.FloatType:
                numElements = image_rgba_data.length / 4;
                const floatArray = new Float32Array(numElements * 4);
                for(let j = 0; j < numElements; j++)RGBEByteToRGBFloat(image_rgba_data, j * 4, floatArray, j * 4);
                data = floatArray;
                type = (0, $329ek.FloatType);
                break;
            case 0, $329ek.HalfFloatType:
                numElements = image_rgba_data.length / 4;
                const halfArray = new Uint16Array(numElements * 4);
                for(let j = 0; j < numElements; j++)RGBEByteToRGBHalf(image_rgba_data, j * 4, halfArray, j * 4);
                data = halfArray;
                type = (0, $329ek.HalfFloatType);
                break;
            default:
                throw new Error("THREE.RGBELoader: Unsupported type: " + this.type);
        }
        return {
            width: w,
            height: h,
            data: data,
            header: rgbe_header_info.string,
            gamma: rgbe_header_info.gamma,
            exposure: rgbe_header_info.exposure,
            type: type
        };
    }
    setDataType(value) {
        this.type = value;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        function onLoadCallback(texture, texData) {
            switch(texture.type){
                case 0, $329ek.FloatType:
                case 0, $329ek.HalfFloatType:
                    if ("colorSpace" in texture) texture.colorSpace = "srgb-linear";
                    else texture.encoding = 3e3;
                    texture.minFilter = (0, $329ek.LinearFilter);
                    texture.magFilter = (0, $329ek.LinearFilter);
                    texture.generateMipmaps = false;
                    texture.flipY = true;
                    break;
            }
            if (onLoad) onLoad(texture, texData);
        }
        return super.load(url, onLoadCallback, onProgress, onError);
    }
}

});

parcelRegister("cCefG", function(module, exports) {

$parcel$export(module.exports, "GainMapLoader", () => $92f416c6e1734f45$export$79004d1af8c8c9b7);
$parcel$export(module.exports, "HDRJPGLoader", () => $92f416c6e1734f45$export$1204838c7449706d);
/**
 * @monogrid/gainmap-js v3.4.0
 * With ❤️, by MONOGRID <gainmap@monogrid.com>
 */ 
var $6SP1O = parcelRequire("6SP1O");

var $cCXpJ = parcelRequire("cCXpJ");

var $329ek = parcelRequire("329ek");parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
var $1W96c = parcelRequire("1W96c");
const $92f416c6e1734f45$var$vertexShader = /* glsl */ `
varying vec2 vUv;

void main() {
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;
const $92f416c6e1734f45$var$fragmentShader = /* glsl */ `
// min half float value
#define HALF_FLOAT_MIN vec3( -65504, -65504, -65504 )
// max half float value
#define HALF_FLOAT_MAX vec3( 65504, 65504, 65504 )

uniform sampler2D sdr;
uniform sampler2D gainMap;
uniform vec3 gamma;
uniform vec3 offsetHdr;
uniform vec3 offsetSdr;
uniform vec3 gainMapMin;
uniform vec3 gainMapMax;
uniform float weightFactor;

varying vec2 vUv;

void main() {
  vec3 rgb = texture2D( sdr, vUv ).rgb;
  vec3 recovery = texture2D( gainMap, vUv ).rgb;
  vec3 logRecovery = pow( recovery, gamma );
  vec3 logBoost = gainMapMin * ( 1.0 - logRecovery ) + gainMapMax * logRecovery;
  vec3 hdrColor = (rgb + offsetSdr) * exp2( logBoost * weightFactor ) - offsetHdr;
  vec3 clampedHdrColor = max( HALF_FLOAT_MIN, min( HALF_FLOAT_MAX, hdrColor ));
  gl_FragColor = vec4( clampedHdrColor , 1.0 );
}
`;
/**
 * A Material which is able to decode the Gainmap into a full HDR Representation
 *
 * @category Materials
 * @group Materials
 */ class $92f416c6e1734f45$export$e02cd6fd4585498a extends (0, $329ek.ShaderMaterial) {
    _maxDisplayBoost;
    _hdrCapacityMin;
    _hdrCapacityMax;
    /**
     *
     * @param params
     */ constructor({ gamma: gamma, offsetHdr: offsetHdr, offsetSdr: offsetSdr, gainMapMin: gainMapMin, gainMapMax: gainMapMax, maxDisplayBoost: maxDisplayBoost, hdrCapacityMin: hdrCapacityMin, hdrCapacityMax: hdrCapacityMax, sdr: sdr, gainMap: gainMap }){
        super({
            name: 'GainMapDecoderMaterial',
            vertexShader: $92f416c6e1734f45$var$vertexShader,
            fragmentShader: $92f416c6e1734f45$var$fragmentShader,
            uniforms: {
                sdr: {
                    value: sdr
                },
                gainMap: {
                    value: gainMap
                },
                gamma: {
                    value: new (0, $329ek.Vector3)(1.0 / gamma[0], 1.0 / gamma[1], 1.0 / gamma[2])
                },
                offsetHdr: {
                    value: new (0, $329ek.Vector3)().fromArray(offsetHdr)
                },
                offsetSdr: {
                    value: new (0, $329ek.Vector3)().fromArray(offsetSdr)
                },
                gainMapMin: {
                    value: new (0, $329ek.Vector3)().fromArray(gainMapMin)
                },
                gainMapMax: {
                    value: new (0, $329ek.Vector3)().fromArray(gainMapMax)
                },
                weightFactor: {
                    value: (Math.log2(maxDisplayBoost) - hdrCapacityMin) / (hdrCapacityMax - hdrCapacityMin)
                }
            },
            blending: (0, $329ek.NoBlending),
            depthTest: false,
            depthWrite: false
        });
        this._maxDisplayBoost = maxDisplayBoost;
        this._hdrCapacityMin = hdrCapacityMin;
        this._hdrCapacityMax = hdrCapacityMax;
        this.needsUpdate = true;
        this.uniformsNeedUpdate = true;
    }
    get sdr() {
        return this.uniforms.sdr.value;
    }
    set sdr(value) {
        this.uniforms.sdr.value = value;
    }
    get gainMap() {
        return this.uniforms.gainMap.value;
    }
    set gainMap(value) {
        this.uniforms.gainMap.value = value;
    }
    /**
     * @see {@link GainMapMetadata.offsetHdr}
     */ get offsetHdr() {
        return this.uniforms.offsetHdr.value.toArray();
    }
    set offsetHdr(value) {
        this.uniforms.offsetHdr.value.fromArray(value);
    }
    /**
     * @see {@link GainMapMetadata.offsetSdr}
     */ get offsetSdr() {
        return this.uniforms.offsetSdr.value.toArray();
    }
    set offsetSdr(value) {
        this.uniforms.offsetSdr.value.fromArray(value);
    }
    /**
     * @see {@link GainMapMetadata.gainMapMin}
     */ get gainMapMin() {
        return this.uniforms.gainMapMin.value.toArray();
    }
    set gainMapMin(value) {
        this.uniforms.gainMapMin.value.fromArray(value);
    }
    /**
     * @see {@link GainMapMetadata.gainMapMax}
     */ get gainMapMax() {
        return this.uniforms.gainMapMax.value.toArray();
    }
    set gainMapMax(value) {
        this.uniforms.gainMapMax.value.fromArray(value);
    }
    /**
     * @see {@link GainMapMetadata.gamma}
     */ get gamma() {
        const g = this.uniforms.gamma.value;
        return [
            1 / g.x,
            1 / g.y,
            1 / g.z
        ];
    }
    set gamma(value) {
        const g = this.uniforms.gamma.value;
        g.x = 1.0 / value[0];
        g.y = 1.0 / value[1];
        g.z = 1.0 / value[2];
    }
    /**
     * @see {@link GainMapMetadata.hdrCapacityMin}
     * @remarks Logarithmic space
     */ get hdrCapacityMin() {
        return this._hdrCapacityMin;
    }
    set hdrCapacityMin(value) {
        this._hdrCapacityMin = value;
        this.calculateWeight();
    }
    /**
     * @see {@link GainMapMetadata.hdrCapacityMin}
     * @remarks Logarithmic space
     */ get hdrCapacityMax() {
        return this._hdrCapacityMax;
    }
    set hdrCapacityMax(value) {
        this._hdrCapacityMax = value;
        this.calculateWeight();
    }
    /**
     * @see {@link GainmapDecodingParameters.maxDisplayBoost}
     * @remarks Non Logarithmic space
     */ get maxDisplayBoost() {
        return this._maxDisplayBoost;
    }
    set maxDisplayBoost(value) {
        this._maxDisplayBoost = Math.max(1, Math.min(65504, value));
        this.calculateWeight();
    }
    calculateWeight() {
        const val = (Math.log2(this._maxDisplayBoost) - this._hdrCapacityMin) / (this._hdrCapacityMax - this._hdrCapacityMin);
        this.uniforms.weightFactor.value = Math.max(0, Math.min(1, val));
    }
}
const $92f416c6e1734f45$var$decodeImpl = (0, $cCXpJ.c)({
    renderer: (0, $1W96c.WebGLRenderer),
    createMaterial: (params)=>new $92f416c6e1734f45$export$e02cd6fd4585498a(params),
    createQuadRenderer: (params)=>new (0, $6SP1O.Q)(params)
});
/**
 * Decodes a gain map using a WebGL RenderTarget
 *
 * @category Decoding Functions
 * @group Decoding Functions
 * @example
 * import { decode } from '@monogrid/gainmap-js'
 * import {
 *   Mesh,
 *   MeshBasicMaterial,
 *   PerspectiveCamera,
 *   PlaneGeometry,
 *   Scene,
 *   TextureLoader,
 *   WebGLRenderer
 * } from 'three'
 *
 * const renderer = new WebGLRenderer()
 *
 * const textureLoader = new TextureLoader()
 *
 * // load SDR Representation
 * const sdr = await textureLoader.loadAsync('sdr.jpg')
 * // load Gain map recovery image
 * const gainMap = await textureLoader.loadAsync('gainmap.jpg')
 * // load metadata
 * const metadata = await (await fetch('metadata.json')).json()
 *
 * const result = decode({
 *   sdr,
 *   gainMap,
 *   // this allows to use `result.renderTarget.texture` directly
 *   renderer,
 *   // this will restore the full HDR range
 *   maxDisplayBoost: Math.pow(2, metadata.hdrCapacityMax),
 *   ...metadata
 * })
 *
 * const scene = new Scene()
 * // `result` can be used to populate a Texture
 * const mesh = new Mesh(
 *   new PlaneGeometry(),
 *   new MeshBasicMaterial({ map: result.renderTarget.texture })
 * )
 * scene.add(mesh)
 * renderer.render(scene, new PerspectiveCamera())
 *
 * // result must be manually disposed
 * // when you are done using it
 * result.dispose()
 *
 * @param params
 * @returns
 * @throws {Error} if the WebGLRenderer fails to render the gain map
 */ const $92f416c6e1734f45$export$2f872c0f2117be69 = (params)=>{
    // Ensure renderer is defined for the base function
    if (!params.renderer) throw new Error('Renderer is required for decode function');
    const quadRenderer = $92f416c6e1734f45$var$decodeImpl({
        ...params,
        renderer: params.renderer
    });
    try {
        quadRenderer.render();
    } catch (e) {
        quadRenderer.disposeOnDemandRenderer();
        throw e;
    }
    return quadRenderer;
};
/**
 * Base class for WebGL loaders
 * @template TUrl - The type of URL used to load resources
 */ class $92f416c6e1734f45$var$LoaderBaseWebGL extends (0, $cCXpJ.L) {
    constructor(renderer, manager){
        super({
            renderer: renderer,
            createMaterial: (params)=>new $92f416c6e1734f45$export$e02cd6fd4585498a(params),
            createQuadRenderer: (params)=>new (0, $6SP1O.Q)(params)
        }, manager);
    }
    /**
     * @private
     * @param quadRenderer
     * @param metadata
     * @param sdrBuffer
     * @param gainMapBuffer
     */ async render(quadRenderer, metadata, sdrBuffer, gainMapBuffer) {
        const { sdrImage: sdrImage, gainMapImage: gainMapImage, needsFlip: needsFlip } = await this.processImages(sdrBuffer, gainMapBuffer, 'flipY');
        const { gainMap: gainMap, sdr: sdr } = this.createTextures(sdrImage, gainMapImage, needsFlip);
        this.updateQuadRenderer(quadRenderer, sdrImage, gainMap, sdr, metadata);
        quadRenderer.render();
    }
}
/**
 * A Three.js Loader for the gain map format.
 *
 * @category Loaders
 * @group Loaders
 *
 * @example
 * import { GainMapLoader } from '@monogrid/gainmap-js'
 * import {
 *   EquirectangularReflectionMapping,
 *   Mesh,
 *   MeshBasicMaterial,
 *   PerspectiveCamera,
 *   PlaneGeometry,
 *   Scene,
 *   WebGLRenderer
 * } from 'three'
 *
 * const renderer = new WebGLRenderer()
 *
 * const loader = new GainMapLoader(renderer)
 *   .setRenderTargetOptions({ mapping: EquirectangularReflectionMapping })
 *
 * const result = await loader.loadAsync(['sdr.jpeg', 'gainmap.jpeg', 'metadata.json'])
 * // `result` can be used to populate a Texture
 *
 * const scene = new Scene()
 * const mesh = new Mesh(
 *   new PlaneGeometry(),
 *   new MeshBasicMaterial({ map: result.renderTarget.texture })
 * )
 * scene.add(mesh)
 * renderer.render(scene, new PerspectiveCamera())
 *
 * // Starting from three.js r159
 * // `result.renderTarget.texture` can
 * // also be used as Equirectangular scene background
 * //
 * // it was previously needed to convert it
 * // to a DataTexture with `result.toDataTexture()`
 * scene.background = result.renderTarget.texture
 *
 * // result must be manually disposed
 * // when you are done using it
 * result.dispose()
 *
 */ class $92f416c6e1734f45$export$79004d1af8c8c9b7 extends $92f416c6e1734f45$var$LoaderBaseWebGL {
    /**
     * Loads a gainmap using separate data
     * * sdr image
     * * gain map image
     * * metadata json
     *
     * useful for webp gain maps
     *
     * @param urls An array in the form of [sdr.jpg, gainmap.jpg, metadata.json]
     * @param onLoad Load complete callback, will receive the result
     * @param onProgress Progress callback, will receive a `ProgressEvent`
     * @param onError Error callback
     * @returns
     */ load([sdrUrl, gainMapUrl, metadataUrl], onLoad, onProgress, onError) {
        const quadRenderer = this.prepareQuadRenderer();
        let sdr;
        let gainMap;
        let metadata;
        const loadCheck = async ()=>{
            if (sdr && gainMap && metadata) {
                // solves #16
                try {
                    await this.render(quadRenderer, metadata, sdr, gainMap);
                } catch (error) {
                    this.manager.itemError(sdrUrl);
                    this.manager.itemError(gainMapUrl);
                    this.manager.itemError(metadataUrl);
                    if (typeof onError === 'function') onError(error);
                    quadRenderer.disposeOnDemandRenderer();
                    return;
                }
                if (typeof onLoad === 'function') onLoad(quadRenderer);
                this.manager.itemEnd(sdrUrl);
                this.manager.itemEnd(gainMapUrl);
                this.manager.itemEnd(metadataUrl);
                quadRenderer.disposeOnDemandRenderer();
            }
        };
        let sdrLengthComputable = true;
        let sdrTotal = 0;
        let sdrLoaded = 0;
        let gainMapLengthComputable = true;
        let gainMapTotal = 0;
        let gainMapLoaded = 0;
        let metadataLengthComputable = true;
        let metadataTotal = 0;
        let metadataLoaded = 0;
        const progressHandler = ()=>{
            if (typeof onProgress === 'function') {
                const total = sdrTotal + gainMapTotal + metadataTotal;
                const loaded = sdrLoaded + gainMapLoaded + metadataLoaded;
                const lengthComputable = sdrLengthComputable && gainMapLengthComputable && metadataLengthComputable;
                onProgress(new ProgressEvent('progress', {
                    lengthComputable: lengthComputable,
                    loaded: loaded,
                    total: total
                }));
            }
        };
        this.manager.itemStart(sdrUrl);
        this.manager.itemStart(gainMapUrl);
        this.manager.itemStart(metadataUrl);
        const sdrLoader = new (0, $329ek.FileLoader)(this._internalLoadingManager);
        sdrLoader.setResponseType('arraybuffer');
        sdrLoader.setRequestHeader(this.requestHeader);
        sdrLoader.setPath(this.path);
        sdrLoader.setWithCredentials(this.withCredentials);
        sdrLoader.load(sdrUrl, async (buffer)=>{
            /* istanbul ignore if
             this condition exists only because of three.js types + strict mode
            */ if (typeof buffer === 'string') throw new Error('Invalid sdr buffer');
            sdr = buffer;
            await loadCheck();
        }, (e)=>{
            sdrLengthComputable = e.lengthComputable;
            sdrLoaded = e.loaded;
            sdrTotal = e.total;
            progressHandler();
        }, (error)=>{
            this.manager.itemError(sdrUrl);
            if (typeof onError === 'function') onError(error);
        });
        const gainMapLoader = new (0, $329ek.FileLoader)(this._internalLoadingManager);
        gainMapLoader.setResponseType('arraybuffer');
        gainMapLoader.setRequestHeader(this.requestHeader);
        gainMapLoader.setPath(this.path);
        gainMapLoader.setWithCredentials(this.withCredentials);
        gainMapLoader.load(gainMapUrl, async (buffer)=>{
            /* istanbul ignore if
             this condition exists only because of three.js types + strict mode
            */ if (typeof buffer === 'string') throw new Error('Invalid gainmap buffer');
            gainMap = buffer;
            await loadCheck();
        }, (e)=>{
            gainMapLengthComputable = e.lengthComputable;
            gainMapLoaded = e.loaded;
            gainMapTotal = e.total;
            progressHandler();
        }, (error)=>{
            this.manager.itemError(gainMapUrl);
            if (typeof onError === 'function') onError(error);
        });
        const metadataLoader = new (0, $329ek.FileLoader)(this._internalLoadingManager);
        // metadataLoader.setResponseType('json')
        metadataLoader.setRequestHeader(this.requestHeader);
        metadataLoader.setPath(this.path);
        metadataLoader.setWithCredentials(this.withCredentials);
        metadataLoader.load(metadataUrl, async (json)=>{
            /* istanbul ignore if
             this condition exists only because of three.js types + strict mode
            */ if (typeof json !== 'string') throw new Error('Invalid metadata string');
            // TODO: implement check on JSON file and remove this eslint disable
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            metadata = JSON.parse(json);
            await loadCheck();
        }, (e)=>{
            metadataLengthComputable = e.lengthComputable;
            metadataLoaded = e.loaded;
            metadataTotal = e.total;
            progressHandler();
        }, (error)=>{
            this.manager.itemError(metadataUrl);
            if (typeof onError === 'function') onError(error);
        });
        return quadRenderer;
    }
}
/**
 * A Three.js Loader for a JPEG with embedded gainmap metadata.
 *
 * @category Loaders
 * @group Loaders
 *
 * @example
 * import { HDRJPGLoader } from '@monogrid/gainmap-js'
 * import {
 *   EquirectangularReflectionMapping,
 *   Mesh,
 *   MeshBasicMaterial,
 *   PerspectiveCamera,
 *   PlaneGeometry,
 *   Scene,
 *   WebGLRenderer
 * } from 'three'
 *
 * const renderer = new WebGLRenderer()
 *
 * const loader = new HDRJPGLoader(renderer)
 *   .setRenderTargetOptions({ mapping: EquirectangularReflectionMapping })
 *
 * const result = await loader.loadAsync('gainmap.jpeg')
 * // `result` can be used to populate a Texture
 *
 * const scene = new Scene()
 * const mesh = new Mesh(
 *   new PlaneGeometry(),
 *   new MeshBasicMaterial({ map: result.renderTarget.texture })
 * )
 * scene.add(mesh)
 * renderer.render(scene, new PerspectiveCamera())
 *
 * // Starting from three.js r159
 * // `result.renderTarget.texture` can
 * // also be used as Equirectangular scene background
 * //
 * // it was previously needed to convert it
 * // to a DataTexture with `result.toDataTexture()`
 * scene.background = result.renderTarget.texture
 *
 * // result must be manually disposed
 * // when you are done using it
 * result.dispose()
 *
 */ class $92f416c6e1734f45$export$1204838c7449706d extends $92f416c6e1734f45$var$LoaderBaseWebGL {
    /**
     * Loads a JPEG containing gain map metadata
     * Renders a normal SDR image if gainmap data is not found
     *
     * @param url Path to a JPEG file containing embedded gain map metadata
     * @param onLoad Load complete callback, will receive the result
     * @param onProgress Progress callback, will receive a `ProgressEvent`
     * @param onError Error callback
     * @returns
     */ load(url, onLoad, onProgress, onError) {
        const quadRenderer = this.prepareQuadRenderer();
        const loader = new (0, $329ek.FileLoader)(this._internalLoadingManager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(this.withCredentials);
        this.manager.itemStart(url);
        loader.load(url, async (jpeg)=>{
            /* istanbul ignore if
             this condition exists only because of three.js types + strict mode
            */ if (typeof jpeg === 'string') throw new Error('Invalid buffer, received [string], was expecting [ArrayBuffer]');
            const jpegBuffer = new Uint8Array(jpeg);
            let sdrJPEG;
            let gainMapJPEG;
            let metadata;
            try {
                const extractionResult = await (0, $cCXpJ.e)(jpegBuffer);
                // gain map is successfully reconstructed
                sdrJPEG = extractionResult.sdr;
                gainMapJPEG = extractionResult.gainMap;
                metadata = extractionResult.metadata;
            } catch (e) {
                // render the SDR version if this is not a gainmap
                if (e instanceof (0, $cCXpJ.X) || e instanceof (0, $cCXpJ.G)) {
                    console.warn(`Failure to reconstruct an HDR image from ${url}: Gain map metadata not found in the file, HDRJPGLoader will render the SDR jpeg`);
                    metadata = {
                        gainMapMin: [
                            0,
                            0,
                            0
                        ],
                        gainMapMax: [
                            1,
                            1,
                            1
                        ],
                        gamma: [
                            1,
                            1,
                            1
                        ],
                        hdrCapacityMin: 0,
                        hdrCapacityMax: 1,
                        offsetHdr: [
                            0,
                            0,
                            0
                        ],
                        offsetSdr: [
                            0,
                            0,
                            0
                        ]
                    };
                    sdrJPEG = jpegBuffer;
                } else throw e;
            }
            // solves #16
            try {
                await this.render(quadRenderer, metadata, sdrJPEG.buffer, gainMapJPEG?.buffer);
            } catch (error) {
                this.manager.itemError(url);
                if (typeof onError === 'function') onError(error);
                quadRenderer.disposeOnDemandRenderer();
                return;
            }
            if (typeof onLoad === 'function') onLoad(quadRenderer);
            this.manager.itemEnd(url);
            quadRenderer.disposeOnDemandRenderer();
        }, onProgress, (error)=>{
            this.manager.itemError(url);
            if (typeof onError === 'function') onError(error);
        });
        return quadRenderer;
    }
}

});
parcelRegister("6SP1O", function(module, exports) {

$parcel$export(module.exports, "Q", () => $502f5e58f1e23a75$export$3722cfe417b6ed86);
/**
 * @monogrid/gainmap-js v3.4.0
 * With ❤️, by MONOGRID <gainmap@monogrid.com>
 */ parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
var $1W96c = parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
const $502f5e58f1e23a75$var$getBufferForType = (type, width, height)=>{
    let out;
    switch(type){
        case 0, $329ek.UnsignedByteType:
            out = new Uint8ClampedArray(width * height * 4);
            break;
        case 0, $329ek.HalfFloatType:
            out = new Uint16Array(width * height * 4);
            break;
        case 0, $329ek.UnsignedIntType:
            out = new Uint32Array(width * height * 4);
            break;
        case 0, $329ek.ByteType:
            out = new Int8Array(width * height * 4);
            break;
        case 0, $329ek.ShortType:
            out = new Int16Array(width * height * 4);
            break;
        case 0, $329ek.IntType:
            out = new Int32Array(width * height * 4);
            break;
        case 0, $329ek.FloatType:
            out = new Float32Array(width * height * 4);
            break;
        default:
            throw new Error('Unsupported data type');
    }
    return out;
};
let $502f5e58f1e23a75$var$_canReadPixelsResult;
/**
 * Test if this browser implementation can correctly read pixels from the specified
 * Render target type.
 *
 * Runs only once
 *
 * @param type
 * @param renderer
 * @param camera
 * @param renderTargetOptions
 * @returns
 */ const $502f5e58f1e23a75$var$canReadPixels = (type, renderer, camera, renderTargetOptions)=>{
    if ($502f5e58f1e23a75$var$_canReadPixelsResult !== undefined) return $502f5e58f1e23a75$var$_canReadPixelsResult;
    const testRT = new (0, $329ek.WebGLRenderTarget)(1, 1, renderTargetOptions);
    renderer.setRenderTarget(testRT);
    const mesh = new (0, $329ek.Mesh)(new (0, $329ek.PlaneGeometry)(), new (0, $329ek.MeshBasicMaterial)({
        color: 0xffffff
    }));
    renderer.render(mesh, camera);
    renderer.setRenderTarget(null);
    const out = $502f5e58f1e23a75$var$getBufferForType(type, testRT.width, testRT.height);
    renderer.readRenderTargetPixels(testRT, 0, 0, testRT.width, testRT.height, out);
    testRT.dispose();
    mesh.geometry.dispose();
    mesh.material.dispose();
    $502f5e58f1e23a75$var$_canReadPixelsResult = out[0] !== 0;
    return $502f5e58f1e23a75$var$_canReadPixelsResult;
};
/**
 * Utility class used for rendering a texture with a material
 *
 * @category Core
 * @group Core
 */ class $502f5e58f1e23a75$export$3722cfe417b6ed86 {
    _renderer;
    _rendererIsDisposable = false;
    _material;
    _scene;
    _camera;
    _quad;
    _renderTarget;
    _width;
    _height;
    _type;
    _colorSpace;
    _supportsReadPixels = true;
    /**
     * Constructs a new QuadRenderer
     *
     * @param options Parameters for this QuadRenderer
     */ constructor(options){
        this._width = options.width;
        this._height = options.height;
        this._type = options.type;
        this._colorSpace = options.colorSpace;
        const rtOptions = {
            // fixed options
            format: (0, $329ek.RGBAFormat),
            depthBuffer: false,
            stencilBuffer: false,
            // user options
            type: this._type,
            colorSpace: this._colorSpace,
            anisotropy: options.renderTargetOptions?.anisotropy !== undefined ? options.renderTargetOptions?.anisotropy : 1,
            generateMipmaps: options.renderTargetOptions?.generateMipmaps !== undefined ? options.renderTargetOptions?.generateMipmaps : false,
            magFilter: options.renderTargetOptions?.magFilter !== undefined ? options.renderTargetOptions?.magFilter : (0, $329ek.LinearFilter),
            minFilter: options.renderTargetOptions?.minFilter !== undefined ? options.renderTargetOptions?.minFilter : (0, $329ek.LinearFilter),
            samples: options.renderTargetOptions?.samples !== undefined ? options.renderTargetOptions?.samples : undefined,
            wrapS: options.renderTargetOptions?.wrapS !== undefined ? options.renderTargetOptions?.wrapS : (0, $329ek.ClampToEdgeWrapping),
            wrapT: options.renderTargetOptions?.wrapT !== undefined ? options.renderTargetOptions?.wrapT : (0, $329ek.ClampToEdgeWrapping)
        };
        this._material = options.material;
        if (options.renderer) this._renderer = options.renderer;
        else {
            this._renderer = $502f5e58f1e23a75$export$3722cfe417b6ed86.instantiateRenderer();
            this._rendererIsDisposable = true;
        }
        this._scene = new (0, $329ek.Scene)();
        this._camera = new (0, $329ek.OrthographicCamera)();
        this._camera.position.set(0, 0, 10);
        this._camera.left = -0.5;
        this._camera.right = 0.5;
        this._camera.top = 0.5;
        this._camera.bottom = -0.5;
        this._camera.updateProjectionMatrix();
        if (!$502f5e58f1e23a75$var$canReadPixels(this._type, this._renderer, this._camera, rtOptions)) {
            let alternativeType;
            switch(this._type){
                case 0, $329ek.HalfFloatType:
                    alternativeType = this._renderer.extensions.has('EXT_color_buffer_float') ? (0, $329ek.FloatType) : undefined;
                    break;
            }
            if (alternativeType !== undefined) {
                console.warn(`This browser does not support reading pixels from ${this._type} RenderTargets, switching to ${(0, $329ek.FloatType)}`);
                this._type = alternativeType;
            } else {
                this._supportsReadPixels = false;
                console.warn('This browser dos not support toArray or toDataTexture, calls to those methods will result in an error thrown');
            }
        }
        this._quad = new (0, $329ek.Mesh)(new (0, $329ek.PlaneGeometry)(), this._material);
        this._quad.geometry.computeBoundingBox();
        this._scene.add(this._quad);
        this._renderTarget = new (0, $329ek.WebGLRenderTarget)(this.width, this.height, rtOptions);
        this._renderTarget.texture.mapping = options.renderTargetOptions?.mapping !== undefined ? options.renderTargetOptions?.mapping : (0, $329ek.UVMapping);
    }
    /**
     * Instantiates a temporary renderer
     *
     * @returns
     */ static instantiateRenderer() {
        const renderer = new (0, $1W96c.WebGLRenderer)();
        renderer.setSize(128, 128);
        // renderer.outputColorSpace = SRGBColorSpace
        // renderer.toneMapping = LinearToneMapping
        // renderer.debug.checkShaderErrors = false
        // this._rendererIsDisposable = true
        return renderer;
    }
    /**
     * Renders the input texture using the specified material
     */ render = ()=>{
        this._renderer.setRenderTarget(this._renderTarget);
        try {
            this._renderer.render(this._scene, this._camera);
        } catch (e) {
            this._renderer.setRenderTarget(null);
            throw e;
        }
        this._renderer.setRenderTarget(null);
    };
    /**
     * Obtains a Buffer containing the rendered texture.
     *
     * @throws Error if the browser cannot read pixels from this RenderTarget type.
     * @returns a TypedArray containing RGBA values from this renderer
     */ toArray() {
        if (!this._supportsReadPixels) throw new Error('Can\'t read pixels in this browser');
        const out = $502f5e58f1e23a75$var$getBufferForType(this._type, this._width, this._height);
        this._renderer.readRenderTargetPixels(this._renderTarget, 0, 0, this._width, this._height, out);
        return out;
    }
    /**
     * Performs a readPixel operation in the renderTarget
     * and returns a DataTexture containing the read data
     *
     * @param options options
     * @returns
     */ toDataTexture(options) {
        const returnValue = new (0, $329ek.DataTexture)(// fixed values
        this.toArray(), this.width, this.height, (0, $329ek.RGBAFormat), this._type, // user values
        options?.mapping || (0, $329ek.UVMapping), options?.wrapS || (0, $329ek.ClampToEdgeWrapping), options?.wrapT || (0, $329ek.ClampToEdgeWrapping), options?.magFilter || (0, $329ek.LinearFilter), options?.minFilter || (0, $329ek.LinearFilter), options?.anisotropy || 1, // fixed value
        (0, $329ek.LinearSRGBColorSpace));
        // set this afterwards, we can't set it in constructor
        returnValue.generateMipmaps = options?.generateMipmaps !== undefined ? options?.generateMipmaps : false;
        return returnValue;
    }
    /**
     * If using a disposable renderer, it will dispose it.
     */ disposeOnDemandRenderer() {
        this._renderer.setRenderTarget(null);
        if (this._rendererIsDisposable) {
            this._renderer.dispose();
            this._renderer.forceContextLoss();
        }
    }
    /**
     * Will dispose of **all** assets used by this renderer.
     *
     *
     * @param disposeRenderTarget will dispose of the renderTarget which will not be usable later
     * set this to true if you passed the `renderTarget.texture` to a `PMREMGenerator`
     * or are otherwise done with it.
     *
     * @example
     * ```js
     * const loader = new HDRJPGLoader(renderer)
     * const result = await loader.loadAsync('gainmap.jpeg')
     * const mesh = new Mesh(geometry, new MeshBasicMaterial({ map: result.renderTarget.texture }) )
     * // DO NOT dispose the renderTarget here,
     * // it is used directly in the material
     * result.dispose()
     * ```
     *
     * @example
     * ```js
     * const loader = new HDRJPGLoader(renderer)
     * const pmremGenerator = new PMREMGenerator( renderer );
     * const result = await loader.loadAsync('gainmap.jpeg')
     * const envMap = pmremGenerator.fromEquirectangular(result.renderTarget.texture)
     * const mesh = new Mesh(geometry, new MeshStandardMaterial({ envMap }) )
     * // renderTarget can be disposed here
     * // because it was used to generate a PMREM texture
     * result.dispose(true)
     * ```
     */ dispose(disposeRenderTarget) {
        this.disposeOnDemandRenderer();
        if (disposeRenderTarget) this.renderTarget.dispose();
        // dispose shader material texture uniforms
        if (this.material instanceof (0, $329ek.ShaderMaterial)) Object.values(this.material.uniforms).forEach((v)=>{
            if (v.value instanceof (0, $329ek.Texture)) v.value.dispose();
        });
        // dispose other material properties
        Object.values(this.material).forEach((value)=>{
            if (value instanceof (0, $329ek.Texture)) value.dispose();
        });
        this.material.dispose();
        this._quad.geometry.dispose();
    }
    /**
     * Width of the texture
     */ get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
        this._renderTarget.setSize(this._width, this._height);
    }
    /**
     * Height of the texture
     */ get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
        this._renderTarget.setSize(this._width, this._height);
    }
    /**
     * The renderer used
     */ get renderer() {
        return this._renderer;
    }
    /**
     * The `WebGLRenderTarget` used.
     */ get renderTarget() {
        return this._renderTarget;
    }
    set renderTarget(value) {
        this._renderTarget = value;
        this._width = value.width;
        this._height = value.height;
    // this._type = value.texture.type
    }
    /**
     * The `Material` used.
     */ get material() {
        return this._material;
    }
    /**
     *
     */ get type() {
        return this._type;
    }
    get colorSpace() {
        return this._colorSpace;
    }
}

});

parcelRegister("cCXpJ", function(module, exports) {

$parcel$export(module.exports, "c", () => $93171f073c442768$export$db3b6bfb95261072);
$parcel$export(module.exports, "G", () => $93171f073c442768$export$2329c99376c9d0a4);
$parcel$export(module.exports, "X", () => $93171f073c442768$export$78acf4525d8a74c4);
$parcel$export(module.exports, "e", () => $93171f073c442768$export$f1e1789686576879);
$parcel$export(module.exports, "L", () => $93171f073c442768$export$61196ced6d74a310);
/**
 * @monogrid/gainmap-js v3.4.0
 * With ❤️, by MONOGRID <gainmap@monogrid.com>
 */ parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
var $329ek = parcelRequire("329ek");
/**
 * Shared decode implementation factory
 * Creates a decode function that prepares a QuadRenderer with the given parameters
 */ function $93171f073c442768$export$db3b6bfb95261072(config) {
    return (params)=>{
        const { sdr: sdr, gainMap: gainMap, renderer: renderer } = params;
        if (sdr.colorSpace !== (0, $329ek.SRGBColorSpace)) {
            console.warn('SDR Colorspace needs to be *SRGBColorSpace*, setting it automatically');
            sdr.colorSpace = (0, $329ek.SRGBColorSpace);
        }
        sdr.needsUpdate = true;
        if (gainMap.colorSpace !== (0, $329ek.LinearSRGBColorSpace)) {
            console.warn('Gainmap Colorspace needs to be *LinearSRGBColorSpace*, setting it automatically');
            gainMap.colorSpace = (0, $329ek.LinearSRGBColorSpace);
        }
        gainMap.needsUpdate = true;
        const material = config.createMaterial({
            ...params,
            sdr: sdr,
            gainMap: gainMap
        });
        const quadRenderer = config.createQuadRenderer({
            width: sdr.image.width,
            height: sdr.image.height,
            type: (0, $329ek.HalfFloatType),
            colorSpace: (0, $329ek.LinearSRGBColorSpace),
            material: material,
            renderer: renderer,
            renderTargetOptions: params.renderTargetOptions
        });
        return quadRenderer;
    };
}
class $93171f073c442768$export$2329c99376c9d0a4 extends Error {
}
class $93171f073c442768$export$78acf4525d8a74c4 extends Error {
}
const $93171f073c442768$var$getXMLValue = (xml, tag, defaultValue)=>{
    // Check for attribute format first: tag="value"
    const attributeMatch = new RegExp(`${tag}="([^"]*)"`, 'i').exec(xml);
    if (attributeMatch) return attributeMatch[1];
    // Check for tag format: <tag>value</tag> or <tag><rdf:li>value</rdf:li>...</tag>
    const tagMatch = new RegExp(`<${tag}[^>]*>([\\s\\S]*?)</${tag}>`, 'i').exec(xml);
    if (tagMatch) {
        // Check if it contains rdf:li elements
        const liValues = tagMatch[1].match(/<rdf:li>([^<]*)<\/rdf:li>/g);
        if (liValues && liValues.length === 3) return liValues.map((v)=>v.replace(/<\/?rdf:li>/g, ''));
        return tagMatch[1].trim();
    }
    if (defaultValue !== undefined) return defaultValue;
    throw new Error(`Can't find ${tag} in gainmap metadata`);
};
const $93171f073c442768$export$407448d2b89b1813 = (input)=>{
    let str;
    // support node test environment
    if (typeof TextDecoder !== 'undefined') str = new TextDecoder().decode(input);
    else str = input.toString();
    let start = str.indexOf('<x:xmpmeta');
    while(start !== -1){
        const end = str.indexOf('x:xmpmeta>', start);
        const xmpBlock = str.slice(start, end + 10);
        try {
            const gainMapMin = $93171f073c442768$var$getXMLValue(xmpBlock, 'hdrgm:GainMapMin', '0');
            const gainMapMax = $93171f073c442768$var$getXMLValue(xmpBlock, 'hdrgm:GainMapMax');
            const gamma = $93171f073c442768$var$getXMLValue(xmpBlock, 'hdrgm:Gamma', '1');
            const offsetSDR = $93171f073c442768$var$getXMLValue(xmpBlock, 'hdrgm:OffsetSDR', '0.015625');
            const offsetHDR = $93171f073c442768$var$getXMLValue(xmpBlock, 'hdrgm:OffsetHDR', '0.015625');
            // These are always attributes, so we can use a simpler regex
            const hdrCapacityMinMatch = /hdrgm:HDRCapacityMin="([^"]*)"/.exec(xmpBlock);
            const hdrCapacityMin = hdrCapacityMinMatch ? hdrCapacityMinMatch[1] : '0';
            const hdrCapacityMaxMatch = /hdrgm:HDRCapacityMax="([^"]*)"/.exec(xmpBlock);
            if (!hdrCapacityMaxMatch) throw new Error('Incomplete gainmap metadata');
            const hdrCapacityMax = hdrCapacityMaxMatch[1];
            return {
                gainMapMin: Array.isArray(gainMapMin) ? gainMapMin.map((v)=>parseFloat(v)) : [
                    parseFloat(gainMapMin),
                    parseFloat(gainMapMin),
                    parseFloat(gainMapMin)
                ],
                gainMapMax: Array.isArray(gainMapMax) ? gainMapMax.map((v)=>parseFloat(v)) : [
                    parseFloat(gainMapMax),
                    parseFloat(gainMapMax),
                    parseFloat(gainMapMax)
                ],
                gamma: Array.isArray(gamma) ? gamma.map((v)=>parseFloat(v)) : [
                    parseFloat(gamma),
                    parseFloat(gamma),
                    parseFloat(gamma)
                ],
                offsetSdr: Array.isArray(offsetSDR) ? offsetSDR.map((v)=>parseFloat(v)) : [
                    parseFloat(offsetSDR),
                    parseFloat(offsetSDR),
                    parseFloat(offsetSDR)
                ],
                offsetHdr: Array.isArray(offsetHDR) ? offsetHDR.map((v)=>parseFloat(v)) : [
                    parseFloat(offsetHDR),
                    parseFloat(offsetHDR),
                    parseFloat(offsetHDR)
                ],
                hdrCapacityMin: parseFloat(hdrCapacityMin),
                hdrCapacityMax: parseFloat(hdrCapacityMax)
            };
        } catch (e) {
        // Continue searching for another xmpmeta block if this one fails
        }
        start = str.indexOf('<x:xmpmeta', end);
    }
};
/**
 * MPF Extractor (Multi Picture Format Extractor)
 * By Henrik S Nilsson 2019
 *
 * Extracts images stored in images based on the MPF format (found here: https://www.cipa.jp/e/std/std-sec.html
 * under "CIPA DC-007-Translation-2021 Multi-Picture Format"
 *
 * Overly commented, and without intention of being complete or production ready.
 * Created to extract depth maps from iPhone images, and to learn about image metadata.
 * Kudos to: Phil Harvey (exiftool), Jaume Sanchez (android-lens-blur-depth-extractor)
 */ class $93171f073c442768$export$3a1a48c8f6ef640e {
    options;
    constructor(options){
        this.options = {
            debug: options && options.debug !== undefined ? options.debug : false,
            extractFII: options && options.extractFII !== undefined ? options.extractFII : true,
            extractNonFII: options && options.extractNonFII !== undefined ? options.extractNonFII : true
        };
    }
    extract(imageArrayBuffer) {
        return new Promise((resolve, reject)=>{
            const debug = this.options.debug;
            const dataView = new DataView(imageArrayBuffer.buffer);
            // If you're executing this line on a big endian machine, it'll be reversed.
            // bigEnd further down though, refers to the endianness of the image itself.
            if (dataView.getUint16(0) !== 0xffd8) {
                reject(new Error('Not a valid jpeg'));
                return;
            }
            const length = dataView.byteLength;
            let offset = 2;
            let loops = 0;
            let marker; // APP# marker
            while(offset < length){
                if (++loops > 250) {
                    reject(new Error(`Found no marker after ${loops} loops \u{1F635}`));
                    return;
                }
                if (dataView.getUint8(offset) !== 0xff) {
                    reject(new Error(`Not a valid marker at offset 0x${offset.toString(16)}, found: 0x${dataView.getUint8(offset).toString(16)}`));
                    return;
                }
                marker = dataView.getUint8(offset + 1);
                if (debug) console.log(`Marker: ${marker.toString(16)}`);
                if (marker === 0xe2) {
                    if (debug) console.log('Found APP2 marker (0xffe2)');
                    // Works for iPhone 8 Plus, X, and XSMax. Or any photos of MPF format.
                    // Great way to visualize image information in html is using Exiftool. E.g.:
                    // ./exiftool.exe -htmldump -wantTrailer photo.jpg > photo.html
                    const formatPt = offset + 4;
                    /*
                     *  Structure of the MP Format Identifier
                     *
                     *  Offset Addr.  | Code (Hex)  | Description
                     *  +00             ff            Marker Prefix      <-- offset
                     *  +01             e2            APP2
                     *  +02             #n            APP2 Field Length
                     *  +03             #n            APP2 Field Length
                     *  +04             4d            'M'                <-- formatPt
                     *  +05             50            'P'
                     *  +06             46            'F'
                     *  +07             00            NULL
                     *                                                   <-- tiffOffset
                     */ if (dataView.getUint32(formatPt) === 0x4d504600) {
                        // Found MPF tag, so we start dig out sub images
                        const tiffOffset = formatPt + 4;
                        let bigEnd; // Endianness from TIFF header
                        // Test for TIFF validity and endianness
                        // 0x4949 and 0x4D4D ('II' and 'MM') marks Little Endian and Big Endian
                        if (dataView.getUint16(tiffOffset) === 0x4949) bigEnd = false;
                        else if (dataView.getUint16(tiffOffset) === 0x4d4d) bigEnd = true;
                        else {
                            reject(new Error('No valid endianness marker found in TIFF header'));
                            return;
                        }
                        if (dataView.getUint16(tiffOffset + 2, !bigEnd) !== 0x002a) {
                            reject(new Error('Not valid TIFF data! (no 0x002A marker)'));
                            return;
                        }
                        // 32 bit number stating the offset from the start of the 8 Byte MP Header
                        // to MP Index IFD Least possible value is thus 8 (means 0 offset)
                        const firstIFDOffset = dataView.getUint32(tiffOffset + 4, !bigEnd);
                        if (firstIFDOffset < 0x00000008) {
                            reject(new Error('Not valid TIFF data! (First offset less than 8)'));
                            return;
                        }
                        // Move ahead to MP Index IFD
                        // Assume we're at the first IFD, so firstIFDOffset points to
                        // MP Index IFD and not MP Attributes IFD. (If we try extract from a sub image,
                        // we fail silently here due to this assumption)
                        // Count (2 Byte) | MP Index Fields a.k.a. MP Entries (count * 12 Byte) | Offset of Next IFD (4 Byte)
                        const dirStart = tiffOffset + firstIFDOffset; // Start of IFD (Image File Directory)
                        const count = dataView.getUint16(dirStart, !bigEnd); // Count of MPEntries (2 Byte)
                        // Extract info from MPEntries (starting after Count)
                        const entriesStart = dirStart + 2;
                        let numberOfImages = 0;
                        for(let i = entriesStart; i < entriesStart + 12 * count; i += 12)// Each entry is 12 Bytes long
                        // Check MP Index IFD tags, here we only take tag 0xb001 = Number of images
                        if (dataView.getUint16(i, !bigEnd) === 0xb001) // stored in Last 4 bytes of its 12 Byte entry.
                        numberOfImages = dataView.getUint32(i + 8, !bigEnd);
                        const nextIFDOffsetLen = 4; // 4 Byte offset field that appears after MP Index IFD tags
                        const MPImageListValPt = dirStart + 2 + count * 12 + nextIFDOffsetLen;
                        const images = [];
                        for(let i = MPImageListValPt; i < MPImageListValPt + numberOfImages * 16; i += 16){
                            const image = {
                                MPType: dataView.getUint32(i, !bigEnd),
                                size: dataView.getUint32(i + 4, !bigEnd),
                                // This offset is specified relative to the address of the MP Endian
                                // field in the MP Header, unless the image is a First Individual Image,
                                // in which case the value of the offset shall be NULL (0x00000000).
                                dataOffset: dataView.getUint32(i + 8, !bigEnd),
                                dependantImages: dataView.getUint32(i + 12, !bigEnd),
                                start: -1,
                                end: -1,
                                isFII: false
                            };
                            if (!image.dataOffset) {
                                // dataOffset is 0x00000000 for First Individual Image
                                image.start = 0;
                                image.isFII = true;
                            } else {
                                image.start = tiffOffset + image.dataOffset;
                                image.isFII = false;
                            }
                            image.end = image.start + image.size;
                            images.push(image);
                        }
                        if (this.options.extractNonFII && images.length) {
                            const bufferBlob = new Blob([
                                dataView
                            ]);
                            const imgs = [];
                            for (const image of images){
                                if (image.isFII && !this.options.extractFII) continue; // Skip FII
                                const imageBlob = bufferBlob.slice(image.start, image.end + 1, 'image/jpeg');
                                // we don't need this
                                // const imageUrl = URL.createObjectURL(imageBlob)
                                // image.img = document.createElement('img')
                                // image.img.src = imageUrl
                                imgs.push(imageBlob);
                            }
                            resolve(imgs);
                        }
                    }
                }
                offset += 2 + dataView.getUint16(offset + 2);
            }
        });
    }
}
/**
 * Extracts XMP Metadata and the gain map recovery image
 * from a single JPEG file.
 *
 * @category Decoding Functions
 * @group Decoding Functions
 * @param jpegFile an `Uint8Array` containing and encoded JPEG file
 * @returns an sdr `Uint8Array` compressed in JPEG, a gainMap `Uint8Array` compressed in JPEG and the XMP parsed XMP metadata
 * @throws Error if XMP Metadata is not found
 * @throws Error if Gain map image is not found
 * @example
 * import { FileLoader } from 'three'
 * import { extractGainmapFromJPEG } from '@monogrid/gainmap-js'
 *
 * const jpegFile = await new FileLoader()
 *  .setResponseType('arraybuffer')
 *  .loadAsync('image.jpg')
 *
 * const { sdr, gainMap, metadata } = extractGainmapFromJPEG(jpegFile)
 */ const $93171f073c442768$export$f1e1789686576879 = async (jpegFile)=>{
    const metadata = $93171f073c442768$export$407448d2b89b1813(jpegFile);
    if (!metadata) throw new $93171f073c442768$export$78acf4525d8a74c4('Gain map XMP metadata not found');
    const mpfExtractor = new $93171f073c442768$export$3a1a48c8f6ef640e({
        extractFII: true,
        extractNonFII: true
    });
    const images = await mpfExtractor.extract(jpegFile);
    if (images.length !== 2) throw new $93171f073c442768$export$2329c99376c9d0a4('Gain map recovery image not found');
    return {
        sdr: new Uint8Array(await images[0].arrayBuffer()),
        gainMap: new Uint8Array(await images[1].arrayBuffer()),
        metadata: metadata
    };
};
/**
 * private function, async get image from blob
 *
 * @param blob
 * @returns
 */ const $93171f073c442768$var$getHTMLImageFromBlob = (blob)=>{
    return new Promise((resolve, reject)=>{
        const img = document.createElement('img');
        img.onload = ()=>{
            resolve(img);
        };
        // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
        img.onerror = (e)=>{
            reject(e);
        };
        img.src = URL.createObjectURL(blob);
    });
};
/**
 * Shared base class for loaders that extracts common logic
 */ class $93171f073c442768$export$61196ced6d74a310 extends (0, $329ek.Loader) {
    _renderer;
    _renderTargetOptions;
    _internalLoadingManager;
    _config;
    constructor(config, manager){
        super(manager);
        this._config = config;
        if (config.renderer) this._renderer = config.renderer;
        this._internalLoadingManager = new (0, $329ek.LoadingManager)();
    }
    setRenderer(renderer) {
        this._renderer = renderer;
        return this;
    }
    setRenderTargetOptions(options) {
        this._renderTargetOptions = options;
        return this;
    }
    prepareQuadRenderer() {
        if (!this._renderer) console.warn('WARNING: A Renderer was not passed to this Loader constructor or in setRenderer, the result of this Loader will need to be converted to a Data Texture with toDataTexture() before you can use it in your renderer.');
        const material = this._config.createMaterial({
            gainMapMax: [
                1,
                1,
                1
            ],
            gainMapMin: [
                0,
                0,
                0
            ],
            gamma: [
                1,
                1,
                1
            ],
            offsetHdr: [
                1,
                1,
                1
            ],
            offsetSdr: [
                1,
                1,
                1
            ],
            hdrCapacityMax: 1,
            hdrCapacityMin: 0,
            maxDisplayBoost: 1,
            gainMap: new (0, $329ek.Texture)(),
            sdr: new (0, $329ek.Texture)()
        });
        return this._config.createQuadRenderer({
            width: 16,
            height: 16,
            type: (0, $329ek.HalfFloatType),
            colorSpace: (0, $329ek.LinearSRGBColorSpace),
            material: material,
            renderer: this._renderer,
            renderTargetOptions: this._renderTargetOptions
        });
    }
    async processImages(sdrBuffer, gainMapBuffer, imageOrientation) {
        const gainMapBlob = gainMapBuffer ? new Blob([
            gainMapBuffer
        ], {
            type: 'image/jpeg'
        }) : undefined;
        const sdrBlob = new Blob([
            sdrBuffer
        ], {
            type: 'image/jpeg'
        });
        let sdrImage;
        let gainMapImage;
        let needsFlip = false;
        if (typeof createImageBitmap === 'undefined') {
            const res = await Promise.all([
                gainMapBlob ? $93171f073c442768$var$getHTMLImageFromBlob(gainMapBlob) : Promise.resolve(undefined),
                $93171f073c442768$var$getHTMLImageFromBlob(sdrBlob)
            ]);
            gainMapImage = res[0];
            sdrImage = res[1];
            needsFlip = imageOrientation === 'flipY';
        } else {
            const res = await Promise.all([
                gainMapBlob ? createImageBitmap(gainMapBlob, {
                    imageOrientation: imageOrientation || 'flipY'
                }) : Promise.resolve(undefined),
                createImageBitmap(sdrBlob, {
                    imageOrientation: imageOrientation || 'flipY'
                })
            ]);
            gainMapImage = res[0];
            sdrImage = res[1];
        }
        return {
            sdrImage: sdrImage,
            gainMapImage: gainMapImage,
            needsFlip: needsFlip
        };
    }
    createTextures(sdrImage, gainMapImage, needsFlip) {
        const gainMap = new (0, $329ek.Texture)(gainMapImage || new ImageData(2, 2), (0, $329ek.UVMapping), (0, $329ek.ClampToEdgeWrapping), (0, $329ek.ClampToEdgeWrapping), (0, $329ek.LinearFilter), (0, $329ek.LinearMipMapLinearFilter), (0, $329ek.RGBAFormat), (0, $329ek.UnsignedByteType), 1, (0, $329ek.LinearSRGBColorSpace));
        gainMap.flipY = needsFlip;
        gainMap.needsUpdate = true;
        const sdr = new (0, $329ek.Texture)(sdrImage, (0, $329ek.UVMapping), (0, $329ek.ClampToEdgeWrapping), (0, $329ek.ClampToEdgeWrapping), (0, $329ek.LinearFilter), (0, $329ek.LinearMipMapLinearFilter), (0, $329ek.RGBAFormat), (0, $329ek.UnsignedByteType), 1, (0, $329ek.SRGBColorSpace));
        sdr.flipY = needsFlip;
        sdr.needsUpdate = true;
        return {
            gainMap: gainMap,
            sdr: sdr
        };
    }
    updateQuadRenderer(quadRenderer, sdrImage, gainMap, sdr, metadata) {
        quadRenderer.width = sdrImage.width;
        quadRenderer.height = sdrImage.height;
        quadRenderer.material.gainMap = gainMap;
        quadRenderer.material.sdr = sdr;
        quadRenderer.material.gainMapMin = metadata.gainMapMin;
        quadRenderer.material.gainMapMax = metadata.gainMapMax;
        quadRenderer.material.offsetHdr = metadata.offsetHdr;
        quadRenderer.material.offsetSdr = metadata.offsetSdr;
        quadRenderer.material.gamma = metadata.gamma;
        quadRenderer.material.hdrCapacityMin = metadata.hdrCapacityMin;
        quadRenderer.material.hdrCapacityMax = metadata.hdrCapacityMax;
        quadRenderer.material.maxDisplayBoost = Math.pow(2, metadata.hdrCapacityMax);
        quadRenderer.material.needsUpdate = true;
    }
}

});


parcelRegister("8Y7Uk", function(module, exports) {

$parcel$export(module.exports, "presetsObj", () => $687a0f93f3533767$export$b32137689bbc87ef);
const $687a0f93f3533767$export$b32137689bbc87ef = {
    apartment: 'lebombo_1k.hdr',
    city: 'potsdamer_platz_1k.hdr',
    dawn: 'kiara_1_dawn_1k.hdr',
    forest: 'forest_slope_1k.hdr',
    lobby: 'st_fagans_interior_1k.hdr',
    night: 'dikhololo_night_1k.hdr',
    park: 'rooitou_park_1k.hdr',
    studio: 'studio_small_03_1k.hdr',
    sunset: 'venice_sunset_1k.hdr',
    warehouse: 'empty_warehouse_01_1k.hdr'
};

});

parcelRegister("9cQkE", function(module, exports) {

$parcel$export(module.exports, "LinearEncoding", () => $6b3dd41c9b20e0f8$export$7207336e4151a112);
$parcel$export(module.exports, "sRGBEncoding", () => $6b3dd41c9b20e0f8$export$f32388edbb32674);
/**
 * Sets `BufferAttribute.updateRange` since r159.
 */ const $6b3dd41c9b20e0f8$export$7493a2e33011a8ee = (attribute, updateRange)=>{
    if ('updateRanges' in attribute) // r159
    // @ts-ignore
    attribute.updateRanges[0] = updateRange;
    else attribute.updateRange = updateRange;
};
const $6b3dd41c9b20e0f8$export$7207336e4151a112 = 3000;
const $6b3dd41c9b20e0f8$export$f32388edbb32674 = 3001;

});



parcelRegister("7Ur5h", function(module, exports) {

$parcel$export(module.exports, "PerspectiveCamera", () => $5c22c5ba338ab513$export$74e4ae24825f68d7);

var $d65Jq = parcelRequire("d65Jq");

var $bxRTa = parcelRequire("bxRTa");

var $9sE5i = parcelRequire("9sE5i");

var $ggRCE = parcelRequire("ggRCE");
const $5c22c5ba338ab513$var$isFunction = (node)=>typeof node === 'function';
const $5c22c5ba338ab513$export$74e4ae24825f68d7 = /* @__PURE__ */ $bxRTa.forwardRef(({ envMap: envMap, resolution: resolution = 256, frames: frames = Infinity, makeDefault: makeDefault, children: children, ...props }, ref)=>{
    const set = (0, $9sE5i.D)(({ set: set })=>set);
    const camera = (0, $9sE5i.D)(({ camera: camera })=>camera);
    const size = (0, $9sE5i.D)(({ size: size })=>size);
    const cameraRef = $bxRTa.useRef(null);
    $bxRTa.useImperativeHandle(ref, ()=>cameraRef.current, []);
    const groupRef = $bxRTa.useRef(null);
    const fbo = (0, $ggRCE.useFBO)(resolution);
    $bxRTa.useLayoutEffect(()=>{
        if (!props.manual) cameraRef.current.aspect = size.width / size.height;
    }, [
        size,
        props
    ]);
    $bxRTa.useLayoutEffect(()=>{
        cameraRef.current.updateProjectionMatrix();
    });
    let count = 0;
    let oldEnvMap = null;
    const functional = $5c22c5ba338ab513$var$isFunction(children);
    (0, $9sE5i.F)((state)=>{
        if (functional && (frames === Infinity || count < frames)) {
            groupRef.current.visible = false;
            state.gl.setRenderTarget(fbo);
            oldEnvMap = state.scene.background;
            if (envMap) state.scene.background = envMap;
            state.gl.render(state.scene, cameraRef.current);
            state.scene.background = oldEnvMap;
            state.gl.setRenderTarget(null);
            groupRef.current.visible = true;
            count++;
        }
    });
    $bxRTa.useLayoutEffect(()=>{
        if (makeDefault) {
            const oldCam = camera;
            set(()=>({
                    camera: cameraRef.current
                }));
            return ()=>set(()=>({
                        camera: oldCam
                    }));
        }
    // The camera should not be part of the dependency list because this components camera is a stable reference
    // that must exchange the default, and clean up after itself on unmount.
    }, [
        cameraRef,
        makeDefault,
        set
    ]);
    return /*#__PURE__*/ $bxRTa.createElement($bxRTa.Fragment, null, /*#__PURE__*/ $bxRTa.createElement("perspectiveCamera", (0, $d65Jq.default)({
        ref: cameraRef
    }, props), !functional && children), /*#__PURE__*/ $bxRTa.createElement("group", {
        ref: groupRef
    }, functional && children(fbo.texture)));
});

});
parcelRegister("ggRCE", function(module, exports) {

$parcel$export(module.exports, "useFBO", () => $bd87bc450571f0a0$export$46efc781def3def7);

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");

var $9sE5i = parcelRequire("9sE5i");
// TODO: consume this from three >r154 when SemVer allows
// 👇 uncomment when TS version supports function overloads
// export function useFBO(settings?: FBOSettings)
function $bd87bc450571f0a0$export$46efc781def3def7(/** Width in pixels, or settings (will render fullscreen by default) */ width, /** Height in pixels */ height, /**Settings */ settings) {
    const size = (0, $9sE5i.D)((state)=>state.size);
    const viewport = (0, $9sE5i.D)((state)=>state.viewport);
    const _width = typeof width === 'number' ? width : size.width * viewport.dpr;
    const _height = typeof height === 'number' ? height : size.height * viewport.dpr;
    const _settings = (typeof width === 'number' ? settings : width) || {};
    const { samples: samples = 0, depth: depth, ...targetSettings } = _settings;
    const target = $bxRTa.useMemo(()=>{
        const target = new $329ek.WebGLRenderTarget(_width, _height, {
            minFilter: $329ek.LinearFilter,
            magFilter: $329ek.LinearFilter,
            type: $329ek.HalfFloatType,
            ...targetSettings
        });
        if (depth) target.depthTexture = new $329ek.DepthTexture(_width, _height, $329ek.FloatType);
        target.samples = samples;
        return target;
    }, []);
    $bxRTa.useLayoutEffect(()=>{
        target.setSize(_width, _height);
        if (samples) target.samples = samples;
    }, [
        samples,
        target,
        _width,
        _height
    ]);
    $bxRTa.useEffect(()=>{
        return ()=>target.dispose();
    }, []);
    return target;
}
const $bd87bc450571f0a0$export$30db5cdfa645f68a = ({ children: children, width: width, height: height, ...settings })=>{
    const target = $bd87bc450571f0a0$export$46efc781def3def7(width, height, settings);
    return /*#__PURE__*/ $bxRTa.createElement($bxRTa.Fragment, null, children == null ? void 0 : children(target));
};

});


parcelRegister("8f92r", function(module, exports) {

$parcel$export(module.exports, "useDetectGPU", () => $6006bc4901852333$export$ea10e78a8479535d);

var $bxRTa = parcelRequire("bxRTa");

var $6KzM1 = parcelRequire("6KzM1");

var $6hydE = parcelRequire("6hydE");
const $6006bc4901852333$export$ea10e78a8479535d = (props)=>(0, $6hydE.suspend)(()=>(0, $6KzM1.getGPUTier)(props), [
        'useDetectGPU'
    ]);
function $6006bc4901852333$export$9528dbda94be0f92({ children: children, ...options }) {
    const result = $6006bc4901852333$export$ea10e78a8479535d(options);
    return /*#__PURE__*/ $bxRTa.createElement($bxRTa.Fragment, null, children == null ? void 0 : children(result));
}

});
parcelRegister("6KzM1", function(module, exports) {

$parcel$export(module.exports, "getGPUTier", () => $4ea2c9d5d847799f$export$3c749a0234c63713);
function $4ea2c9d5d847799f$var$e(e, t, r, n) {
    return new (r || (r = Promise))(function(o, a) {
        function i(e) {
            try {
                d(n.next(e));
            } catch (e) {
                a(e);
            }
        }
        function c(e) {
            try {
                d(n.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function d(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                e(t);
            })).then(i, c);
        }
        d((n = n.apply(e, t || [])).next());
    });
}
"function" == typeof SuppressedError && SuppressedError;
const $4ea2c9d5d847799f$var$t = [
    "geforce 320m",
    "geforce 8600",
    "geforce 8600m gt",
    "geforce 8800 gs",
    "geforce 8800 gt",
    "geforce 9400",
    "geforce 9400m g",
    "geforce 9400m",
    "geforce 9600m gt",
    "geforce 9600m",
    "geforce fx go5200",
    "geforce gt 120",
    "geforce gt 130",
    "geforce gt 330m",
    "geforce gtx 285",
    "google swiftshader",
    "intel g41",
    "intel g45",
    "intel gma 4500mhd",
    "intel gma x3100",
    "intel hd 3000",
    "intel q45",
    "legacy",
    "mali-2",
    "mali-3",
    "mali-4",
    "quadro fx 1500",
    "quadro fx 4",
    "quadro fx 5",
    "radeon hd 2400",
    "radeon hd 2600",
    "radeon hd 4670",
    "radeon hd 4850",
    "radeon hd 4870",
    "radeon hd 5670",
    "radeon hd 5750",
    "radeon hd 6290",
    "radeon hd 6300",
    "radeon hd 6310",
    "radeon hd 6320",
    "radeon hd 6490m",
    "radeon hd 6630m",
    "radeon hd 6750m",
    "radeon hd 6770m",
    "radeon hd 6970m",
    "sgx 543",
    "sgx543"
];
function $4ea2c9d5d847799f$var$r(e) {
    return e = e.toLowerCase().replace(/.*angle ?\((.+)\)(?: on vulkan [0-9.]+)?$/i, "$1").replace(/\s(\d{1,2}gb|direct3d.+$)|\(r\)| \([^)]+\)$/g, "").replace(/(?:vulkan|opengl) \d+\.\d+(?:\.\d+)?(?: \((.*)\))?/, "$1");
}
const $4ea2c9d5d847799f$var$n = "undefined" == typeof window, $4ea2c9d5d847799f$var$o = (()=>{
    if ($4ea2c9d5d847799f$var$n) return;
    const { userAgent: e, platform: t, maxTouchPoints: r } = window.navigator, o = /(iphone|ipod|ipad)/i.test(e), a = "iPad" === t || "MacIntel" === t && r > 0 && !window.MSStream;
    return {
        isIpad: a,
        isMobile: /android/i.test(e) || o || a,
        isSafari12: /Version\/12.+Safari/.test(e),
        isFirefox: /Firefox/.test(e)
    };
})();
function $4ea2c9d5d847799f$var$a(e, t, r) {
    if (!r) return [
        t
    ];
    const n = function(e) {
        const t = "\n    precision highp float;\n    attribute vec3 aPosition;\n    varying float vvv;\n    void main() {\n      vvv = 0.31622776601683794;\n      gl_Position = vec4(aPosition, 1.0);\n    }\n  ", r = "\n    precision highp float;\n    varying float vvv;\n    void main() {\n      vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * vvv;\n      enc = fract(enc);\n      enc -= enc.yzww * vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 0.0);\n      gl_FragColor = enc;\n    }\n  ", n = e.createShader(35633), o = e.createShader(35632), a = e.createProgram();
        if (!(o && n && a)) return;
        e.shaderSource(n, t), e.shaderSource(o, r), e.compileShader(n), e.compileShader(o), e.attachShader(a, n), e.attachShader(a, o), e.linkProgram(a), e.detachShader(a, n), e.detachShader(a, o), e.deleteShader(n), e.deleteShader(o), e.useProgram(a);
        const i = e.createBuffer();
        e.bindBuffer(34962, i), e.bufferData(34962, new Float32Array([
            -1,
            -1,
            0,
            3,
            -1,
            0,
            -1,
            3,
            0
        ]), 35044);
        const c = e.getAttribLocation(a, "aPosition");
        e.vertexAttribPointer(c, 3, 5126, !1, 0, 0), e.enableVertexAttribArray(c), e.clearColor(1, 1, 1, 1), e.clear(16384), e.viewport(0, 0, 1, 1), e.drawArrays(4, 0, 3);
        const d = new Uint8Array(4);
        return e.readPixels(0, 0, 1, 1, 6408, 5121, d), e.deleteProgram(a), e.deleteBuffer(i), d.join("");
    }(e), a = "801621810", i = "8016218135", c = "80162181161", d = (null == $4ea2c9d5d847799f$var$o ? void 0 : $4ea2c9d5d847799f$var$o.isIpad) ? [
        [
            "a7",
            c,
            12
        ],
        [
            "a8",
            i,
            15
        ],
        [
            "a8x",
            i,
            15
        ],
        [
            "a9",
            i,
            15
        ],
        [
            "a9x",
            i,
            15
        ],
        [
            "a10",
            i,
            15
        ],
        [
            "a10x",
            i,
            15
        ],
        [
            "a12",
            a,
            15
        ],
        [
            "a12x",
            a,
            15
        ],
        [
            "a12z",
            a,
            15
        ],
        [
            "a14",
            a,
            15
        ],
        [
            "a15",
            a,
            15
        ],
        [
            "m1",
            a,
            15
        ],
        [
            "m2",
            a,
            15
        ]
    ] : [
        [
            "a7",
            c,
            12
        ],
        [
            "a8",
            i,
            12
        ],
        [
            "a9",
            i,
            15
        ],
        [
            "a10",
            i,
            15
        ],
        [
            "a11",
            a,
            15
        ],
        [
            "a12",
            a,
            15
        ],
        [
            "a13",
            a,
            15
        ],
        [
            "a14",
            a,
            15
        ],
        [
            "a15",
            a,
            15
        ],
        [
            "a16",
            a,
            15
        ],
        [
            "a17",
            a,
            15
        ]
    ];
    let l;
    "80162181255" === n ? l = d.filter(([, , e])=>e >= 14) : (l = d.filter(([, e])=>e === n), l.length || (l = d));
    return l.map(([e])=>`apple ${e} gpu`);
}
class $4ea2c9d5d847799f$var$i extends Error {
    constructor(e){
        super(e), Object.setPrototypeOf(this, new.target.prototype);
    }
}
const $4ea2c9d5d847799f$var$c = [], $4ea2c9d5d847799f$var$d = [];
function $4ea2c9d5d847799f$var$l(e, t) {
    if (e === t) return 0;
    const r = e;
    e.length > t.length && (e = t, t = r);
    let n = e.length, o = t.length;
    for(; n > 0 && e.charCodeAt(~-n) === t.charCodeAt(~-o);)n--, o--;
    let a, i = 0;
    for(; i < n && e.charCodeAt(i) === t.charCodeAt(i);)i++;
    if (n -= i, o -= i, 0 === n) return o;
    let l, s, f = 0, u = 0, g = 0;
    for(; u < n;)$4ea2c9d5d847799f$var$d[u] = e.charCodeAt(i + u), $4ea2c9d5d847799f$var$c[u] = ++u;
    for(; g < o;)for(a = t.charCodeAt(i + g), l = g++, f = g, u = 0; u < n; u++)s = a === $4ea2c9d5d847799f$var$d[u] ? l : l + 1, l = $4ea2c9d5d847799f$var$c[u], f = $4ea2c9d5d847799f$var$c[u] = l > f ? s > f ? f + 1 : s : s > l ? l + 1 : s;
    return f;
}
function $4ea2c9d5d847799f$var$s(e) {
    return null != e;
}
const $4ea2c9d5d847799f$export$3c749a0234c63713 = ({ mobileTiers: c = [
    0,
    15,
    30,
    60
], desktopTiers: d = [
    0,
    15,
    30,
    60
], override: f = {}, glContext: u, failIfMajorPerformanceCaveat: g = !1, benchmarksURL: h = "https://unpkg.com/detect-gpu@5.0.70/dist/benchmarks" } = {})=>$4ea2c9d5d847799f$var$e(void 0, void 0, void 0, function*() {
        const p = {};
        if ($4ea2c9d5d847799f$var$n) return {
            tier: 0,
            type: "SSR"
        };
        const { isIpad: m = !!(null == $4ea2c9d5d847799f$var$o ? void 0 : $4ea2c9d5d847799f$var$o.isIpad), isMobile: v = !!(null == $4ea2c9d5d847799f$var$o ? void 0 : $4ea2c9d5d847799f$var$o.isMobile), screenSize: w = window.screen, loadBenchmarks: x = (t)=>$4ea2c9d5d847799f$var$e(void 0, void 0, void 0, function*() {
                const e = yield fetch(`${h}/${t}`).then((e)=>e.json());
                if (parseInt(e.shift().split(".")[0], 10) < 4) throw new $4ea2c9d5d847799f$var$i("Detect GPU benchmark data is out of date. Please update to version 4x");
                return e;
            }) } = f;
        let { renderer: A } = f;
        const P = (e, t, r, n, o)=>({
                device: o,
                fps: n,
                gpu: r,
                isMobile: v,
                tier: e,
                type: t
            });
        let S, b = "";
        if (A) A = $4ea2c9d5d847799f$var$r(A), S = [
            A
        ];
        else {
            const e = u || function(e, t = !1) {
                const r = {
                    alpha: !1,
                    antialias: !1,
                    depth: !1,
                    failIfMajorPerformanceCaveat: t,
                    powerPreference: "high-performance",
                    stencil: !1
                };
                e && delete r.powerPreference;
                const n = window.document.createElement("canvas"), o = n.getContext("webgl", r) || n.getContext("experimental-webgl", r);
                return null != o ? o : void 0;
            }(null == $4ea2c9d5d847799f$var$o ? void 0 : $4ea2c9d5d847799f$var$o.isSafari12, g);
            if (!e) return P(0, "WEBGL_UNSUPPORTED");
            const t = (null == $4ea2c9d5d847799f$var$o ? void 0 : $4ea2c9d5d847799f$var$o.isFirefox) ? null : e.getExtension("WEBGL_debug_renderer_info");
            if (A = t ? e.getParameter(t.UNMASKED_RENDERER_WEBGL) : e.getParameter(e.RENDERER), !A) return P(1, "FALLBACK");
            b = A, A = $4ea2c9d5d847799f$var$r(A), S = function(e, t, r) {
                return "apple gpu" === t ? $4ea2c9d5d847799f$var$a(e, t, r) : [
                    t
                ];
            }(e, A, v);
        }
        const E = (yield Promise.all(S.map(function(t) {
            var r;
            return $4ea2c9d5d847799f$var$e(this, void 0, void 0, function*() {
                const e = ((e)=>{
                    const t = v ? [
                        "adreno",
                        "apple",
                        "mali-t",
                        "mali",
                        "nvidia",
                        "powervr",
                        "samsung"
                    ] : [
                        "intel",
                        "apple",
                        "amd",
                        "radeon",
                        "nvidia",
                        "geforce",
                        "adreno"
                    ];
                    for (const r of t)if (e.includes(r)) return r;
                })(t);
                if (!e) return;
                const n = `${v ? "m" : "d"}-${e}${m ? "-ipad" : ""}.json`, o = p[n] = null !== (r = p[n]) && void 0 !== r ? r : x(n);
                let a;
                try {
                    a = yield o;
                } catch (e) {
                    if (e instanceof $4ea2c9d5d847799f$var$i) throw e;
                    return;
                }
                const c = function(e) {
                    var t;
                    const r = (e = e.replace(/\([^)]+\)/, "")).match(/\d+/) || e.match(/(\W|^)([A-Za-z]{1,3})(\W|$)/g);
                    return null !== (t = null == r ? void 0 : r.join("").replace(/\W|amd/g, "")) && void 0 !== t ? t : "";
                }(t);
                let d = a.filter(([, e])=>e === c);
                d.length || (d = a.filter(([e])=>e.includes(t)));
                const s = d.length;
                if (0 === s) return;
                const f = t.split(/[.,()\[\]/\s]/g).sort().filter((e, t, r)=>0 === t || e !== r[t - 1]).join(" ");
                let u, [g, , , , h] = s > 1 ? d.map((e)=>[
                        e,
                        $4ea2c9d5d847799f$var$l(f, e[2])
                    ]).sort(([, e], [, t])=>e - t)[0][0] : d[0], A = Number.MAX_VALUE;
                const { devicePixelRatio: P } = window, S = w.width * P * w.height * P;
                for (const e of h){
                    const [t, r] = e, n = t * r, o = Math.abs(S - n);
                    o < A && (A = o, u = e);
                }
                if (!u) return;
                const [, , b, E] = u;
                return [
                    A,
                    b,
                    g,
                    E
                ];
            });
        }))).filter($4ea2c9d5d847799f$var$s).sort(([e = Number.MAX_VALUE, t], [r = Number.MAX_VALUE, n])=>e === r ? t - n : e - r);
        if (!E.length) {
            const e = $4ea2c9d5d847799f$var$t.find((e)=>A.includes(e));
            return e ? P(0, "BLOCKLISTED", e) : P(1, "FALLBACK", `${A} (${b})`);
        }
        const [, y, C, L] = E[0];
        if (-1 === y) return P(0, "BLOCKLISTED", C, y, L);
        const M = v ? c : d;
        let $ = 0;
        for(let e = 0; e < M.length; e++)y >= M[e] && ($ = e);
        return P($, "BENCHMARK", C, y, L);
    });

});


parcelRegister("9HfWD", function(module, exports) {
module.exports = "data:text/javascript;base64,LyogSW1wbGVtZW50YXRpb24gb2YgdGhlIEF1ZGlvV29ya2xldFByb2Nlc3Nvcg0KIGh0dHBzOi8vd2ViYXVkaW8uZ2l0aHViLmlvL3dlYi1hdWRpby1hcGkvI2F1ZGlvd29ya2xldA0KIFRoaXMgZmlsZSB3aWxsIGJlIGxvYWRlZCBvbmx5IGluIHJlY2VudCBicm93c2VycyB0aGF0IHN1cHBvcnRzIEF1ZGlvIHdvcmtsZXQgaXQgaXMNCiBjdXJyZW50bHkgaW4ganMgYmVjYXVzZSBpdCBuZWVkcyB0byBiZSBpbiBlczYgKi8NCmNsYXNzIFNwZWVjaFByb2Nlc3NvciBleHRlbmRzIEF1ZGlvV29ya2xldFByb2Nlc3NvciB7DQogIGNvbnN0cnVjdG9yKG9wdGlvbnMpIHsNCiAgICAvLyBUaGUgc3VwZXIgY29uc3RydWN0b3IgY2FsbCBpcyByZXF1aXJlZC4NCiAgICBzdXBlcihvcHRpb25zKTsNCiAgfQ0KDQogIHByb2Nlc3MoaW5wdXRzLCBvdXRwdXRzKSB7DQogICAgY29uc3QgaW5wdXQgPSBpbnB1dHNbMF07DQogICAgY29uc3Qgb3V0cHV0ID0gW107IC8vIE1ha2Ugc3VyZSBvdXRwdXQgYXJyYXkgY2FuIGJlIGFzc2lnbmVkIHRvDQogICAgZm9yIChsZXQgY2hhbm5lbCA9IDA7IGNoYW5uZWwgPCBpbnB1dC5sZW5ndGg7IGNoYW5uZWwgKz0gMSkgew0KICAgICAgb3V0cHV0W2NoYW5uZWxdID0gaW5wdXRbY2hhbm5lbF07DQogICAgfQ0KICAgIHRoaXMucG9ydC5wb3N0TWVzc2FnZShvdXRwdXRbMF0pOw0KICAgIHJldHVybiB0cnVlOw0KICB9DQp9DQoNCnJlZ2lzdGVyUHJvY2Vzc29yKCdzcGVlY2gtcHJvY2Vzc29yJywgU3BlZWNoUHJvY2Vzc29yKTsNCg==";

});


var $a9dc203da3e30d69$exports = {};
$parcel$extendImportMap({
    "77Gze": "background.bf75fd73.webp",
    "9tXeG": "PrintingPreview.7dd36bc9.js",
    "6NCfb": "HistoryList.c8b55360.js",
    "9GKrX": "LanguageChoice.d2624ba8.js",
    "k0VAd": "AttachmentDetail.97b08346.js",
    "iTlMv": "FullScreenImage.60e5140a.js",
    "aSHJY": "Weather.9746ef6b.js",
    "hvc5r": "Weather.28afdebc.js",
    "dqy4I": "CustomView.b1422294.js",
    "dDfpQ": "Emergency.4c71afbd.js",
    "7ySv0": "MapContainer.8ab1b90e.js",
    "fboBS": "LittleWeatherContainer.5741bd9f.js",
    "lBnLP": "NewsContainer.613ded87.js",
    "cby9Y": "ThreeJsWrapper.30ba4051.js",
    "5iA6N": "ThreeJsWrapper.5c474599.js",
    "bVNjP": "SpiritEngineWrapper.9b097915.js",
    "7kS9u": "VeilleManager.77862f59.js",
    "f7mOL": "dist.c6f09181.js",
    "6cK4D": "layers.760a0456.png",
    "h4HcL": "layers-2x.b7b89169.png",
    "cenFb": "marker-icon.3f7d3721.png"
});


var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
var $84b6f0871d6ab47a$export$882461b6382ed46c;
var $84b6f0871d6ab47a$export$757ceba2d55c277e;
'use strict';

var $aRBoq = parcelRequire("aRBoq");
var $84b6f0871d6ab47a$var$i;
$84b6f0871d6ab47a$export$882461b6382ed46c = $aRBoq.createRoot;
$84b6f0871d6ab47a$export$757ceba2d55c277e = $aRBoq.hydrateRoot;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $kdMEA = parcelRequire("kdMEA");
const $a48ceaed86644192$var$processBaseURI = (baseURI)=>{
    if (baseURI?.length) {
        if (baseURI.indexOf(`${(0, $kdMEA.webchatTokenRetrievalAddress)}`) > -1) {
            console.warn('Retorik Framework > "/K2.ContentFields.WebChat/api/GetWebchatToken" endpoint for directline token retrieval is deprecated and will be removed in the next versions of Retorik Studio');
            baseURI = baseURI.replace(`${(0, $kdMEA.webchatTokenRetrievalAddress)}`, '');
        }
    }
    return baseURI;
};
var $a48ceaed86644192$export$2e2bcd8739ae039 = $a48ceaed86644192$var$processBaseURI;



var $kdMEA = parcelRequire("kdMEA");
const $2bd72e8e785aeb0f$var$processPrefix = (prefix)=>{
    switch(prefix){
        case 'dev':
            return 0, $kdMEA.studioRetorikDev;
        case 'staging':
        case 'preview':
            return 0, $kdMEA.studioRetorikStaging;
        case 'experimental':
            return 0, $kdMEA.studioRetorikExperimental;
        default:
            return 0, $kdMEA.studioRetorik;
    }
};
var $2bd72e8e785aeb0f$export$2e2bcd8739ae039 = $2bd72e8e785aeb0f$var$processPrefix;


/**
 * Get the base address from the incoming data.
 * The cases are :
 * - addressData.baseURI only : return this baseURI after removing the deprecated data
 * - addressData.baseURI + addressData.tenant : return the concatenation of this 2 values separated by '/'
 * - addressData.tenant only (with or without addressData.prefix) : process the prefix and return the processed data with the tenant
 * @param {AddressData} addressData
 * @returns {string}
 */ const $39912af9dc3f41d7$var$getBaseAddress = (addressData)=>{
    if (addressData.baseURI?.length) {
        if (addressData.tenant?.length) return `${addressData.baseURI}/${addressData.tenant}/`;
        else return (0, $a48ceaed86644192$export$2e2bcd8739ae039)(addressData.baseURI);
    } else {
        const tempBaseUri = (0, $2bd72e8e785aeb0f$export$2e2bcd8739ae039)(addressData.prefix);
        return `${tempBaseUri}/${addressData.tenant}/`;
    }
};
var $39912af9dc3f41d7$export$2e2bcd8739ae039 = $39912af9dc3f41d7$var$getBaseAddress;



var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");
const $7b2cab4dfcfe505d$var$InputOutputHandler = ({ instanceId: instanceId })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isMicrophoneAllowed = (0, $5FZWK.useSelector)((state)=>state.speechReducer.isMicrophoneAllowed);
    const isMicrophoneAllowedRef = (0, $bxRTa.useRef)(isMicrophoneAllowed);
    const handleCustomEvent = (event, method)=>{
        // Check if an instance id is given to use this method in a single instance of Retorik Framework when there are several
        const checkInstanceId = event.detail?.instanceId ? instanceId ? event.detail.instanceId === instanceId : false : true;
        if (checkInstanceId) try {
            event.detail?.values?.length ? dispatch(method(event.detail.values[0])) : dispatch(method());
        } catch (e) {
            console.error(`Retorik Framework > failed to use ${method}`);
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        isMicrophoneAllowedRef.current = isMicrophoneAllowed;
    }, [
        isMicrophoneAllowed
    ]);
    // Use refs to get updated states in native javascript events
    const handleToggleMicrophone = ()=>{
        isMicrophoneAllowedRef.current ? $7b2cab4dfcfe505d$export$39fcdeae376856e7() : dispatch((0, $cto9a.storeActions).speech.askPermission());
    };
    (0, $bxRTa.useEffect)(()=>{
        // Widget store events
        document.addEventListener('retorik_openWidget', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).widget.openWidget));
        document.addEventListener('retorik_closeWidget', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).widget.closeWidget));
        document.addEventListener('retorik_toggleWidget', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).widget.toggleWidget));
        document.addEventListener('retorik_toggleDisplay', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).widget.toggleDisplay));
        // Utils store events
        document.addEventListener('retorik_showAgent', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).utils.showAgent));
        document.addEventListener('retorik_hideAgent', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).utils.hideAgent));
        document.addEventListener('retorik_resetUtilsStore', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).utils.resetUtilsStore));
        document.addEventListener('retorik_lockClickedButton', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).utils.lockClickedButton));
        document.addEventListener('retorik_setCurrentCustomView', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).utils.setCurrentCustomView));
        document.addEventListener('retorik_setCurrentSubView', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).utils.setCurrentSubView));
        document.addEventListener('retorik_setModalFullscreenContent', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).utils.setModalFullscreenContent));
        document.addEventListener('retorik_addDetailedAttachmentTrigger', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).utils.addDetailedAttachmentTrigger));
        document.addEventListener('retorik_setDashboardOpened', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).utils.setDashboardOpened));
        // Locale store events
        document.addEventListener('retorik_setLocale', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).locale.setLocale));
        document.addEventListener('retorik_resetLocaleStore', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).locale.resetLocaleStore));
        document.addEventListener('retorik_addDumpedLanguageFallback', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).locale.addDumpedLanguageFallback));
        document.addEventListener('retorik_addReplacementLocale', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).locale.addReplacementLocale));
        // Adaptive cards store events
        document.addEventListener('retorik_setValue', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).adaptiveCard.setValue));
        document.addEventListener('retorik_setCurrentId', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).adaptiveCard.setCurrentId));
        document.addEventListener('retorik_setToggleValue', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).adaptiveCard.setToggleValue));
        document.addEventListener('retorik_addCurrentToggleId', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).adaptiveCard.addCurrentToggleId));
        document.addEventListener('retorik_resetAdaptiveCardStore', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).adaptiveCard.resetAdaptiveCardStore));
        // View store utils
        document.addEventListener('retorik_setVisibility', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).view.setVisibility));
        document.addEventListener('retorik_toggleVisibility', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).view.toggleVisibility));
        // Speech store utils
        document.addEventListener('retorik_setActiveRecognitionState', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).speech.setActiveRecognitionState));
        document.addEventListener('retorik_cancelCurrentUtterance', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).speech.cancelCurrentUtterance));
        document.addEventListener('retorik_toggleMicrophone', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).speech.toggleMicrophone));
        document.addEventListener('retorik_setMuted', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).speech.setMuted));
        document.addEventListener('retorik_setMode', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).speech.setMode));
        document.addEventListener('retorik_playExternalSynthesis', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).speech.playExternalSynthesis));
        document.addEventListener('retorik_resetSpeechStore', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).speech.resetSpeechStore));
        // Retorik store utils
        document.addEventListener('retorik_setDisplaySubtitles', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).retorik.setDisplaySubtitles));
        document.addEventListener('retorik_toggleSubtitles', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).retorik.toggleSubtitles));
        document.addEventListener('retorik_setAgentData', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).retorik.setAgentData));
        document.addEventListener('retorik_setLoaderClosed', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).retorik.setLoaderClosed));
        document.addEventListener('retorik_resetRetorikStore', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).retorik.resetRetorikStore));
        // Activity store utils
        document.addEventListener('retorik_resetActivityStore', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).activity.resetActivityStore));
        // Directline store utils
        document.addEventListener('retorik_sendMessage', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).directline.sendMessage));
        document.addEventListener('retorik_sendEvent', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).directline.sendEvent));
        document.addEventListener('retorik_pauseConversation', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).directline.pauseConversation));
        document.addEventListener('retorik_resumeConversation', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).directline.resumeConversation));
        document.addEventListener('retorik_sendMessageToChatbot', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).directline.sendMessageToChatbot));
        document.addEventListener('retorik_addExternalActivityHandler', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).directline.addExternalActivityHandler));
        document.addEventListener('retorik_setExternalActivityHandlers', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).directline.setExternalActivityHandlers));
        document.addEventListener('retorik_resetDirectlineStore', (e)=>handleCustomEvent(e, (0, $cto9a.storeActions).directline.resetDirectlineStore));
        return ()=>{
            document.removeEventListener('retorik_openWidget', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$a1c83309c736819f));
            document.removeEventListener('retorik_closeWidget', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$d27f1b0993b666c));
            document.removeEventListener('retorik_toggleWidget', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$77c0ba4d0d97cee5));
            document.removeEventListener('retorik_toggleDisplay', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$f0e9d14ede4c01bd));
            document.removeEventListener('retorik_showAgent', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$ae67eb518a2aae74));
            document.removeEventListener('retorik_hideAgent', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$e73dbd7ba351e3e));
            document.removeEventListener('retorik_resetUtilsStore', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$93b55f822ac81934));
            document.removeEventListener('retorik_lockClickedButton', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$5d55805fc8a86c05));
            document.removeEventListener('retorik_setCurrentCustomView', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$5a678fd51bd89633));
            document.removeEventListener('retorik_setCurrentSubView', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$f0c096b4ecd7115d));
            document.removeEventListener('retorik_sendActivity', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$d4c8c6daac289378));
            document.removeEventListener('retorik_setModalFullscreenContent', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$4317154639841e84));
            document.removeEventListener('retorik_addDetailedAttachmentTrigger', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$d1f60bb847ecc604));
            document.removeEventListener('retorik_setDashboardOpened', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$bbd7c92fc378d660));
            document.removeEventListener('retorik_setLocale', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$c8aadf3621e41efb));
            document.removeEventListener('retorik_resetLocaleStore', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$3118ae18000e2700));
            document.removeEventListener('retorik_addDumpedLanguageFallback', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$5f8965892c631504));
            document.removeEventListener('retorik_addReplacementLocale', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$8de7f8944486b1fb));
            document.removeEventListener('retorik_setValue', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$80746c6bc6142fc8));
            document.removeEventListener('retorik_setCurrentId', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$a619c8fe018044c1));
            document.removeEventListener('retorik_setToggleValue', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$7fc8a028c7b38ace));
            document.removeEventListener('retorik_addCurrentToggleId', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$ff456dc518e4aa26));
            document.removeEventListener('retorik_resetAdaptiveCardStore', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$64bb98402f29970));
            document.removeEventListener('retorik_setVisibility', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$2c64211ecf98e50d));
            document.removeEventListener('retorik_toggleVisibility', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$7396a2167c7f755e));
            document.removeEventListener('retorik_setActiveRecognitionState', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$45913366c4ba414f));
            document.removeEventListener('retorik_cancelCurrentUtterance', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$f3aaae0c8197c567));
            document.removeEventListener('retorik_toggleMicrophone', handleToggleMicrophone);
            document.removeEventListener('retorik_setMuted', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$a1680ba91cc9be33));
            document.removeEventListener('retorik_playExternalSynthesis', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$99dcb7840cd85481));
            document.removeEventListener('retorik_resetSpeechStore', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$b6d2196a3ce412d8));
            document.removeEventListener('retorik_setDisplaySubtitles', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$708f3eb1d5828832));
            document.removeEventListener('retorik_toggleSubtitles', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$3fa7f3a227fc16cb));
            document.removeEventListener('retorik_setAgentData', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$a72b80ff363563a1));
            document.removeEventListener('retorik_setMode', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$d4f039427a1beff1));
            document.removeEventListener('retorik_setLoaderClosed', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$982d69b78a955aaf));
            document.removeEventListener('retorik_resetRetorikStore', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$cd85ac4858c7290c));
            document.removeEventListener('retorik_resetActivityStore', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$b7b23f8e09258fa6));
            document.removeEventListener('retorik_sendMessage', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$465cb47180de50f0));
            document.removeEventListener('retorik_sendEvent', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$7329bcdc3edcd90e));
            document.removeEventListener('retorik_pauseConversation', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$7431bc5a5c7c9317));
            document.removeEventListener('retorik_resumeConversation', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$cceb853b29df842));
            document.removeEventListener('retorik_sendMessageToChatbot', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$255ebd0ca6bfba88));
            document.removeEventListener('retorik_addExternalActivityHandler', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$28afdcc603412603));
            document.removeEventListener('retorik_setExternalActivityHandlers', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$2c7ae0f34657d605));
            document.removeEventListener('retorik_resetDirectlineStore', (e)=>handleCustomEvent(e, $7b2cab4dfcfe505d$export$8f3b2f6aa8e2c248));
        };
    }, []);
    return null;
};
var $7b2cab4dfcfe505d$export$2e2bcd8739ae039 = $7b2cab4dfcfe505d$var$InputOutputHandler;
const $7b2cab4dfcfe505d$var$eventDispatch = (name, values, instanceId)=>{
    document.dispatchEvent(new CustomEvent(name, {
        detail: {
            instanceId: instanceId,
            values: values
        }
    }));
};
// Widget utils
const $7b2cab4dfcfe505d$export$a1c83309c736819f = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_openWidget', [], instanceId);
const $7b2cab4dfcfe505d$export$d27f1b0993b666c = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_closeWidget', [], instanceId);
const $7b2cab4dfcfe505d$export$77c0ba4d0d97cee5 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_toggleWidget', [], instanceId);
const $7b2cab4dfcfe505d$export$f0e9d14ede4c01bd = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_toggleDisplay', [], instanceId);
// Utils utils
const $7b2cab4dfcfe505d$export$ae67eb518a2aae74 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_showAgent', [], instanceId);
const $7b2cab4dfcfe505d$export$e73dbd7ba351e3e = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_hideAgent', [], instanceId);
const $7b2cab4dfcfe505d$export$93b55f822ac81934 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetUtilsStore', [], instanceId);
const $7b2cab4dfcfe505d$export$5d55805fc8a86c05 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_lockClickedButton', [], instanceId);
const $7b2cab4dfcfe505d$export$5a678fd51bd89633 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setCurrentCustomView', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$f0c096b4ecd7115d = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setCurrentSubView', [
        value
    ], instanceId);
/**
 * deprecated since v3.2.6
 */ const $7b2cab4dfcfe505d$export$d4c8c6daac289378 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_sendActivity', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$d1f60bb847ecc604 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_addDetailedAttachmentTrigger', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$4317154639841e84 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setModalFullscreenContent', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$bbd7c92fc378d660 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setDashboardOpened', [
        value
    ], instanceId);
// Locale utils
const $7b2cab4dfcfe505d$export$c8aadf3621e41efb = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setLocale', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$3118ae18000e2700 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetLocaleStore', [], instanceId);
const $7b2cab4dfcfe505d$export$5f8965892c631504 = (key, value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_addDumpedLanguageFallback', [
        {
            key: key,
            value: value
        }
    ], instanceId);
const $7b2cab4dfcfe505d$export$8de7f8944486b1fb = (key, value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_addReplacementLocale', [
        {
            key: key,
            value: value
        }
    ], instanceId);
// Adaptive cards utils
const $7b2cab4dfcfe505d$export$80746c6bc6142fc8 = (id, value)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setValue', [
        {
            id: id,
            value: value
        }
    ], undefined);
const $7b2cab4dfcfe505d$export$a619c8fe018044c1 = (value)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setCurrentId', [
        value
    ], undefined);
const $7b2cab4dfcfe505d$export$7fc8a028c7b38ace = (id, value)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setToggleValue', [
        {
            id: id,
            value: value
        }
    ], undefined);
const $7b2cab4dfcfe505d$export$ff456dc518e4aa26 = (id, defaultValue)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_addCurrentToggleId', [
        {
            id: id,
            defaultValue: defaultValue
        }
    ], undefined);
const $7b2cab4dfcfe505d$export$64bb98402f29970 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetAdaptiveCardStore', [], instanceId);
// View utils
const $7b2cab4dfcfe505d$export$2c64211ecf98e50d = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setVisibility', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$7396a2167c7f755e = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_toggleVisibility', [], instanceId);
// Speech utils
const $7b2cab4dfcfe505d$export$45913366c4ba414f = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setActiveRecognitionState', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$f3aaae0c8197c567 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_cancelCurrentUtterance', [], instanceId);
const $7b2cab4dfcfe505d$export$39fcdeae376856e7 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_toggleMicrophone', [], instanceId);
const $7b2cab4dfcfe505d$export$a1680ba91cc9be33 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setMuted', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$99dcb7840cd85481 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_playExternalSynthesis', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$b6d2196a3ce412d8 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetSpeechStore', [], instanceId);
// Retorik utils
const $7b2cab4dfcfe505d$export$708f3eb1d5828832 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setDisplaySubtitles', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$3fa7f3a227fc16cb = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_toggleSubtitles', [], instanceId);
const $7b2cab4dfcfe505d$export$a72b80ff363563a1 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setAgentData', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$d4f039427a1beff1 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setMode', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$982d69b78a955aaf = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setLoaderClosed', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$cd85ac4858c7290c = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetRetorikStore', [], instanceId);
// Activity utils
const $7b2cab4dfcfe505d$export$b7b23f8e09258fa6 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetActivityStore', [], instanceId);
// Directline utils
const $7b2cab4dfcfe505d$export$465cb47180de50f0 = (text, value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_sendMessage', [
        {
            text: text,
            value: value
        }
    ], instanceId);
const $7b2cab4dfcfe505d$export$7329bcdc3edcd90e = (name, value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_sendEvent', [
        {
            name: name,
            value: value
        }
    ], instanceId);
const $7b2cab4dfcfe505d$export$7431bc5a5c7c9317 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_pauseConversation', [], instanceId);
const $7b2cab4dfcfe505d$export$cceb853b29df842 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resumeConversation', [], instanceId);
const $7b2cab4dfcfe505d$export$255ebd0ca6bfba88 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_sendMessageToChatbot', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$28afdcc603412603 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_addExternalActivityHandler', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$2c7ae0f34657d605 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setExternalActivityHandlers', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$8f3b2f6aa8e2c248 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetDirectlineStore', [], instanceId);



var $kdMEA = parcelRequire("kdMEA");
const $03d227dac7928361$export$c8eb837c49d83ee5 = [
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-LY',
    'ar-MA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-SY',
    'ar-TN',
    'ar-YE',
    'bg-BG',
    'ca-ES',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'de-AT',
    'de-CH',
    'el-GR',
    'en-US',
    'en-AU',
    'en-CA',
    'en-GB',
    'en-HK',
    'en-IE',
    'en-IN',
    'en-KE',
    'en-NG',
    'en-NZ',
    'en-PH',
    'en-SG',
    'en-TZ',
    'en-ZA',
    'es-ES',
    'es-AR',
    'es-BO',
    'es-CL',
    'es-CO',
    'es-CR',
    'es-CU',
    'es-DO',
    'es-EC',
    'es-GQ',
    'es-GT',
    'es-HN',
    'es-MX',
    'es-NI',
    'es-PA',
    'es-PE',
    'es-PR',
    'es-PY',
    'es-SV',
    'es-US',
    'es-UY',
    'es-VE',
    'fi-FI',
    'fr-FR',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'gu-IN',
    'he-IL',
    'hi-IN',
    'hr-HR',
    'hu-HU',
    'id-ID',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'mr-IN',
    'ms-MY',
    'nb-NO',
    'nl-NL',
    'nl-BE',
    'pl-PL',
    'pt-PT',
    'pt-BR',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sl-SI',
    'sv-SE',
    'sw-TZ',
    'ta-IN',
    'ta-LK',
    'ta-MY',
    'ta-SG',
    'te-IN',
    'th-TH',
    'tr-TR',
    'uk-UA',
    'ur-PK',
    'ur-IN',
    'vi-VN',
    'zh-CN',
    'zh-HK',
    'zh-TW'
];
const $03d227dac7928361$export$9a6594216df9de73 = [
    'af-ZA',
    'am-ET',
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-LY',
    'ar-MA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-SY',
    'ar-TN',
    'ar-YE',
    'as-IN',
    'az-AZ',
    'bg-BG',
    'bn-BD',
    'bn-IN',
    'bs-BA',
    'ca-ES',
    'cs-CZ',
    'cy-GB',
    'da-DK',
    'de-AT',
    'de-CH',
    'de-DE',
    'el-GR',
    'en-AU',
    'en-CA',
    'en-GB',
    'en-HK',
    'en-IE',
    'en-IN',
    'en-KE',
    'en-NG',
    'en-NZ',
    'en-PH',
    'en-SG',
    'en-TZ',
    'en-US',
    'en-ZA',
    'es-AR',
    'es-BO',
    'es-CL',
    'es-CO',
    'es-CR',
    'es-CU',
    'es-DO',
    'es-EC',
    'es-ES',
    'es-GQ',
    'es-GT',
    'es-HN',
    'es-MX',
    'es-NI',
    'es-PA',
    'es-PE',
    'es-PR',
    'es-PY',
    'es-SV',
    'es-US',
    'es-UY',
    'es-VE',
    'et-EE',
    'eu-ES',
    'fa-IR',
    'fi-FI',
    'fil-PH',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'fr-FR',
    'ga-IE',
    'gl-ES',
    'gu-IN',
    'he-IL',
    'hi-IN',
    'hr-HR',
    'hu-HU',
    'hy-AM',
    'id-ID',
    'is-IS',
    'it-IT',
    'iu-CANS-CA',
    'iu-LATN-CA',
    'ja-JP',
    'jv-ID',
    'ka-GE',
    'kk-KZ',
    'km-KH',
    'kn-IN',
    'ko-KR',
    'lo-LA',
    'lt-LT',
    'lv-LV',
    'mk-MK',
    'ml-IN',
    'mn-MN',
    'mr-IN',
    'ms-MY',
    'mt-MT',
    'my-MM',
    'nb-NO',
    'ne-NP',
    'nl-BE',
    'nl-NL',
    'or-IN',
    'pa-IN',
    'pl-PL',
    'ps-AF',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'si-LK',
    'sk-SK',
    'sl-SI',
    'so-SO',
    'sq-AL',
    'sr-LATN-RS',
    'sr-RS',
    'su-ID',
    'sv-SE',
    'sw-KE',
    'sw-TZ',
    'ta-IN',
    'ta-LK',
    'ta-MY',
    'ta-SG',
    'te-IN',
    'th-TH',
    'tr-TR',
    'uk-UA',
    'ur-IN',
    'ur-PK',
    'uz-UZ',
    'vi-VN',
    'wuu-CN',
    'yue-CN',
    'zh-CN',
    'zh-CN-GUANGXI',
    'zh-CN-henan',
    'zh-CN-liaoning',
    'zh-CN-shaanxi',
    'zh-CN-shandong',
    'zh-CN-sichuan',
    'zh-HK',
    'zh-TW',
    'zu-ZA'
];
const $03d227dac7928361$export$5faa65939df15b6b = [
    'ar-AE',
    'ar-EG',
    'ar-SA',
    'ca-ES',
    'cs-CZ',
    'da-DK',
    'de-AT',
    'de-CH',
    'de-DE',
    'en-CA',
    'en-GB',
    'en-HK',
    'en-IE',
    'en-IN',
    'en-US',
    'es-ES',
    'es-MX',
    'fi-FI',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'fr-FR',
    'hi-IN',
    'hu-HU',
    'id-ID',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NO',
    'nl-BE',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ru-RU',
    'sv-SE',
    'th-TH',
    'tr-TR',
    'zh-CN',
    'zh-HK',
    'zh-TW'
];



var $fzVhJ = parcelRequire("fzVhJ");
const $de28171980b2041e$var$fetchAvailableLanguages = async (baseAddress, needVisemes)=>{
    const fullAddress = `${baseAddress}api/graphql?query={siteCultures{culture,default}}`;
    const languages = await fetch(fullAddress).then((res)=>res.json()).then((json)=>{
        if (!json.data?.siteCultures?.length) return 0, $kdMEA.DEFAULT_LANGUAGE_DATA;
        const { processedDefaultLanguage: processedDefaultLanguage, processedSupported: processedSupported } = $de28171980b2041e$export$92cb25ec092104e6(json.data.siteCultures.find((siteCulture)=>siteCulture.default)?.culture || json.data.siteCultures[0].culture, json.data.siteCultures.map((siteCulture)=>siteCulture.culture), needVisemes);
        return {
            all: processedSupported,
            default: processedDefaultLanguage
        };
    }).catch((error)=>{
        console.log(error);
        return 0, $kdMEA.DEFAULT_LANGUAGE_DATA;
    });
    return languages;
};
const $de28171980b2041e$export$92cb25ec092104e6 = (defaultLanguage, supported, needVisemes)=>{
    const allowedLocales = needVisemes ? (0, $03d227dac7928361$export$c8eb837c49d83ee5) : (0, $03d227dac7928361$export$9a6594216df9de73);
    let processedDefaultLanguage = allowedLocales.includes(defaultLanguage) ? defaultLanguage : 'fr-FR';
    const processedSupported = [];
    supported.forEach((culture)=>{
        // Fallback mechanism if the language code is not supported by Microsoft cognitive services
        if (!allowedLocales.includes(culture)) {
            const l = culture.split('-')[0];
            const otherLocalesFromSameLanguage = supported.filter((localeCode)=>localeCode.startsWith(`${l}-`)).find((locale)=>allowedLocales.includes(locale));
            // If we do find another locale code that contains the same language and is available for speech services, we dump the one that we are testing
            // Otherwise, we add the first available in the list of allowed ones if there is one of the same language.
            if (otherLocalesFromSameLanguage) {
                // If the dumped language is the default one, change it with the fallback one
                culture === defaultLanguage && (processedDefaultLanguage = otherLocalesFromSameLanguage);
                (0, $7b2cab4dfcfe505d$export$8de7f8944486b1fb)(culture, otherLocalesFromSameLanguage);
                console.log(`Retorik Framework > invalid locale "${culture}" was dumped because an existing locale for this language was found ("${otherLocalesFromSameLanguage}").`);
            } else {
                const fallback = allowedLocales.find((locale)=>locale.startsWith(`${l}-`));
                if (fallback) {
                    processedSupported.push(fallback);
                    // If the dumped language is the default one, change it with the fallback one
                    culture === defaultLanguage && (processedDefaultLanguage = fallback);
                    // We keep a relation between the dumped one and the replacement one in "dumpedLanguageFallback" to re-inject the dumped one in the activities so that Retorik Studio
                    // gets the same one as the one we fetched and not the replacement one
                    (0, $7b2cab4dfcfe505d$export$5f8965892c631504)(fallback, culture);
                    (0, $7b2cab4dfcfe505d$export$8de7f8944486b1fb)(culture, fallback);
                    console.log(`Retorik Framework > invalid locale "${culture}" was replaced by "${fallback}".`);
                } else console.log(`Retorik Framework > invalid locale "${culture}" was dumped and no replacement was found for this language.`);
            }
        } else processedSupported.push(culture);
    });
    return {
        processedDefaultLanguage: processedDefaultLanguage,
        processedSupported: processedSupported
    };
};
const $de28171980b2041e$export$4186cc8c38f709fe = async (baseAddress)=>{
    const fullAddress = `${baseAddress}api/graphql?query={siteCultures{culture,default}}`;
    const language = await fetch(fullAddress).then((res)=>res.json()).then((json)=>{
        if (!json.data?.siteCultures?.length) return (0, $kdMEA.DEFAULT_LANGUAGE_DATA).default;
        const culturesData = {
            all: json.data.siteCultures.map((siteCulture)=>siteCulture.culture),
            default: json.data.siteCultures.find((siteCulture)=>siteCulture.default)?.culture || json.data.siteCultures[0].culture
        };
        return (0, $fzVhJ.checkLocale)(culturesData, undefined);
    }).catch((error)=>{
        console.log(error);
        return (0, $kdMEA.DEFAULT_LANGUAGE_DATA).default;
    });
    return language;
};
var $de28171980b2041e$export$2e2bcd8739ae039 = $de28171980b2041e$var$fetchAvailableLanguages;



var $kdMEA = parcelRequire("kdMEA");
const $af55b6b5b4f24adb$var$getRetorikConfigs = async (props, baseAddress)=>{
    const retorikProps = {
        ...props
    };
    let res = null;
    const fullAddress = `${baseAddress}api/integration/framework`;
    try {
        const response = await fetch(fullAddress);
        const json = await response.json();
        res = $af55b6b5b4f24adb$var$processJson(json, retorikProps, baseAddress);
    } catch (error) {
        console.log('Retorik Framework > error when fetching integration endpoint : ', error);
    }
    return res;
};
const $af55b6b5b4f24adb$var$processJsonToGetWidgetConfiguration = async (json)=>{
    const widgetData = json.widgetButton;
    if (widgetData) {
        let buttonImageUrl = undefined;
        // If needed, get an image to display in the button : manual config > fetched config > fetched character
        if (!widgetData.hideButtonThumbnail) {
            if (json.buttonThumbnail) buttonImageUrl = json.buttonThumbnail;
            else if (json.personnage) try {
                const url = json.personnage.indexOf('http') === -1 ? `${0, $kdMEA.CDNCharactersAddress}/${json.personnage}` : json.personnage;
                const characterPortraitFilename = await fetch(`${url}${url.endsWith('/') ? '' : '/'}manifest.json?v=${Date.now()}`).then((response)=>response.json()).then((json)=>json.portrait);
                characterPortraitFilename && (buttonImageUrl = `${url}${url.endsWith('/') ? '' : '/'}${characterPortraitFilename}`);
            } catch (error) {
                console.log('Retorik Framework > error while fetching character data : ', error);
            }
        }
        // Calculate the top / left parts of the button and the frame depending on the given position
        let buttonTop = undefined;
        let frameTop = undefined;
        let buttonLeft = undefined;
        let frameLeft = undefined;
        // Top part
        if ([
            'top-right',
            'top-left'
        ].includes(widgetData.position)) {
            buttonTop = `${widgetData.offsetY}px`;
            frameTop = `${widgetData.offsetY}px`;
        } else if ([
            'center-left',
            'center-right'
        ].includes(widgetData.position)) {
            buttonTop = `${window.innerHeight / 2 - 20 + widgetData.offsetY}px`;
            // Get the top position of the frame : half the window's height minus half the default widget's size (630px) plus the offseet
            frameTop = `${window.innerHeight / 2 - 315 + widgetData.offsetY}px`;
        }
        // Left part
        if ([
            'top-left',
            'bottom-left',
            'center-left'
        ].includes(widgetData.position)) {
            buttonLeft = `${widgetData.offsetX}px`;
            frameLeft = `${widgetData.offsetX}px`;
        } else if (widgetData.position === 'bottom-center') {
            // Max button width = 200px, we substract half this amount
            buttonLeft = `${window.innerWidth / 2 - 100 + widgetData.offsetX}px`;
            // Get the left position of the frame : half the window's width minus half the default widget's width (400px) plus the offset
            frameLeft = `${window.innerWidth / 2 - 200 + widgetData.offsetX}px`;
        }
        // Get the other positions depending on the given position
        const bottom = [
            'bottom-right',
            'bottom-left',
            'bottom-center'
        ].includes(widgetData.position) ? `${widgetData.offsetY}px` : undefined;
        const right = [
            'top-right',
            'bottom-right',
            'center-right'
        ].includes(widgetData.position) ? `${widgetData.offsetX}px` : buttonLeft === undefined ? '0px' : undefined;
        const widgetConfiguration = {
            width: 400,
            button: {
                display: true,
                text: {
                    content: widgetData.text,
                    color: widgetData.colors?.default?.text,
                    colorHover: widgetData.colors?.hover?.text,
                    bold: false,
                    maxWidth: 200 // not available in fetched configuration : base = 200px
                },
                image: {
                    hide: widgetData.hideButtonThumbnail,
                    url: buttonImageUrl,
                    position: 'left',
                    height: undefined,
                    marginY: true // not available in fetched configuration : base = true
                },
                border: {
                    color: widgetData.colors?.default?.border,
                    colorHover: widgetData.colors?.hover?.border,
                    thickness: widgetData.borderThickness,
                    rounded: widgetData.roundedEdges
                },
                background: {
                    color: widgetData.colors?.default?.background,
                    colorHover: widgetData.colors?.hover?.background
                },
                position: {
                    top: buttonTop,
                    bottom: bottom,
                    left: buttonLeft,
                    right: right
                }
            },
            large: {
                width: undefined,
                height: '630px',
                border: {
                    color: undefined,
                    rounded: undefined,
                    thickness: undefined
                },
                position: {
                    top: frameTop,
                    bottom: bottom,
                    left: frameLeft,
                    right: right
                }
            },
            thumbnail: undefined
        };
        return widgetConfiguration;
    }
    return undefined;
};
const $af55b6b5b4f24adb$export$398ec931dbe747c1 = async (baseAddress, locale)=>{
    const dataToReturn = {
        integrationMode: 'fullscreen',
        widgetConfiguration: undefined
    };
    try {
        const response = await fetch(`${baseAddress}api/integration/framework?culture=${locale}`);
        const json = await response.json();
        const fetchedIntegrationMode = json.integrationMode;
        if (fetchedIntegrationMode === 'widget') {
            dataToReturn.integrationMode = 'widget';
            dataToReturn.widgetConfiguration = await $af55b6b5b4f24adb$var$processJsonToGetWidgetConfiguration(json);
        }
    } catch (error) {
        console.log('Retorik Framework > error when fetching integration endpoint : ', error);
    }
    return dataToReturn;
};
const $af55b6b5b4f24adb$export$a6f1a8eda244b334 = async (baseAddress, locale)=>{
    try {
        const response = await fetch(`${baseAddress}api/integration/framework?culture=${locale}`);
        const json = await response.json();
        return await $af55b6b5b4f24adb$var$processJsonToGetWidgetConfiguration(json);
    } catch (error) {
        console.log('Retorik Framework > error when fetching integration endpoint : ', error);
        return undefined;
    }
};
const $af55b6b5b4f24adb$var$getAddressWithoutTenant = (address, tenant)=>{
    if (tenant && address.indexOf(`/${tenant}`)) address = address.replace(`/${tenant}`, '');
    if (address.endsWith('/')) return address.slice(0, -1);
    return address;
};
var $130716087dbfbbd5$exports = {};
$130716087dbfbbd5$exports = $parcel$resolve("77Gze");



const $af55b6b5b4f24adb$var$processJson = (json, retorikProps, baseAddress)=>{
    if (json) {
        // Get full address for backgrounds & logo
        let logo, background, newsBackground, personnage;
        if (json.personnage) {
            if (json.personnage.indexOf('http') === -1) personnage = `${0, $kdMEA.CDNCharactersAddress}/${json.personnage}`;
            else personnage = json.personnage;
        } else personnage = `${0, $kdMEA.CDNCharactersAddress}/long-shot/zahra`;
        const addressWithoutTenant = $af55b6b5b4f24adb$var$getAddressWithoutTenant(baseAddress, retorikProps.addressData.tenant);
        if (json.logo) logo = `${addressWithoutTenant}${json.logo}`;
        if (json.background?.length) background = `${addressWithoutTenant}${json.background}`;
        else background = new URL($130716087dbfbbd5$exports);
        if (json.newsBackground?.length) newsBackground = `${addressWithoutTenant}${json.newsBackground}`;
        else newsBackground = new URL($130716087dbfbbd5$exports);
        // Handle size & height : string or number
        let size = json.agentSize || undefined;
        if (json.agentSize && !isNaN(+json.agentSize)) size = +json.agentSize // convert to int
        ;
        let height = json.agentHeight || undefined;
        if (json.agentHeight && !isNaN(+json.agentHeight)) height = +json.agentHeight // convert to int
        ;
        // For widget
        // Handle size & height : string or number
        let sizeWidget = json.agentSizeWidget || json.agentSize || undefined;
        if (json.agentSizeWidget && !isNaN(+json.agentSizeWidget)) sizeWidget = +json.agentSizeWidget // convert to int
        ;
        let heightWidget = json.agentHeightWidget || json.agentHeight || undefined;
        if (json.agentHeightWidget && !isNaN(+json.agentHeightWidget)) heightWidget = +json.agentHeightWidget // convert to int
        ;
        // Process token endpoint from manual configuration and incoming data
        let tokenEndpoint = '';
        if (retorikProps.addressData?.directline?.tokenEndpoint) tokenEndpoint = retorikProps.addressData.directline.tokenEndpoint;
        else if (retorikProps.addressData?.baseURI?.includes((0, $kdMEA.webchatTokenRetrievalAddress))) tokenEndpoint = retorikProps.addressData.baseURI;
        else if (json.directLine_tokenEndpoint) tokenEndpoint = json.directLine_tokenEndpoint;
        else tokenEndpoint = `${baseAddress}${0, $kdMEA.webchatTokenRetrievalAddress}`;
        // Prevent passive speech recognition if no name was given for the character.
        // Used for retrocompatibility since v2.0.4
        if (!json.characterName && json.speechRecognitionOptions) json.speechRecognitionOptions.enableContinuousRecognitionOnAllDevices = false, json.speechRecognitionOptions.enableContinuousRecognitionOn = undefined;
        const props = {
            config: {
                fullSize: undefined,
                isUsedOnBorne: undefined,
                hideParametersButtonInMenu: json.hideParametersButtonInMenu,
                locales: {
                    getDefaultFromBrowser: undefined
                },
                position: {
                    searchForLocation: json.detectLocation,
                    latitude: undefined,
                    longitude: undefined,
                    city: undefined,
                    country: undefined
                },
                subtitles: json.subtitles,
                subtitlesPosition: json.subtitlesPosition,
                logo: json.logo ? {
                    src: logo
                } : undefined,
                answerpanel: undefined,
                skipWelcome: json.skipWelcome,
                preventExpectedInputHint: json.preventExpectedInputHint,
                pagination: undefined,
                remote: undefined,
                languageChoiceBottom: undefined,
                companyName: json.companyName,
                companyNameLocalized: undefined,
                subCompanyMessage: json.subCompanyMessage,
                subCompanyMessageLocalized: undefined,
                loaderInformationTexts: {
                    text: {
                        top: json.textModeHomeTitle,
                        bottom: json.textModeHomeSubtitle
                    },
                    vocal: {
                        top: json.voiceModeHomeTitle,
                        bottom: json.voiceModeHomeSubtitle
                    }
                },
                loaderInformationTextsLocalized: {
                    text: {
                        top: json.textModeHomeTitleLocalized,
                        bottom: json.textModeHomeSubtitleLocalized
                    },
                    vocal: {
                        top: json.voiceModeHomeTitleLocalized,
                        bottom: json.voiceModeHomeSubtitleLocalized
                    }
                },
                hideRetorikLogo: json.hideRetorikLogo,
                baseMenu: undefined,
                customMenu: undefined,
                subMenu: undefined,
                menu: json.menu,
                hideMenu: json.hideMenu,
                hideControls: json.hideControls,
                doNotDetectDeviceFromUserAgent: json.doNotDetectDeviceFromUserAgent,
                enableConversationCookie: json.enableConversationCookie,
                conversationCookieMaxAge: json.conversationCookieMaxAge,
                enableTelemetry: json.enableTelemetry,
                allowSwitchLayout: json.allowSwitchLayout,
                forceMobileView: json.forceMobileFullScreenLayout,
                enableSpeechCaching: json.enableSpeechCaching,
                speechRecognitionOptions: {
                    timerBeforeSpeechEnd: json.speechRecognitionOptions?.timerBeforeSpeechEnd,
                    enableActivationSound: json.speechRecognitionOptions?.enableActivationSound,
                    enableSendMessageOnMicrophoneClose: json.speechRecognitionOptions?.enableSendMessageOnMicrophoneClose,
                    enableContinuousRecognitionOnAllDevices: json.speechRecognitionOptions?.enableContinuousRecognitionOnAllDevices,
                    enableContinuousRecognitionOn: json.speechRecognitionOptions?.enableContinuousRecognitionOn,
                    wakeWords: json.speechRecognitionOptions?.wakeWords,
                    grammars: json.speechRecognitionOptions?.grammars,
                    inputHintBehaviour: json.speechRecognitionOptions?.inputHintBehaviour
                },
                speechSynthesisOptions: json.speechSynthesisOptions,
                enableDocumentPrinting: undefined,
                disableSpeechMode: json.disableSpeechMode,
                disableTextMode: json.disableTextMode,
                disableSound: json.disableSound,
                disableHistory: json.disableHistory,
                disableSubtitles: json.disableSubtitles,
                timerForFilterSelectionListMode: undefined,
                // Pattern != null means not null nor undefined
                useOldRemote: json.useOldRemote != null ? json.useOldRemote : true,
                preventVirtualKeyboard: undefined,
                channelData: json.channelData
            },
            viewsConfig: {
                homeRoute: 'home',
                webcamRotation: undefined,
                views: {
                    home: {
                        background: {
                            style: 'image',
                            image: background,
                            video: undefined,
                            webcam: undefined
                        }
                    },
                    news: {
                        intervalInSeconds: json.newsConfig?.intervalInSeconds || 2,
                        loop: true,
                        openingVideo: json.newsConfig?.openingVideo,
                        endingVideo: json.newsConfig?.endingVideo,
                        background: {
                            style: 'image',
                            image: newsBackground,
                            video: undefined,
                            webcam: undefined
                        },
                        showMenu: undefined,
                        bannerTitle: json.newsConfig?.bannerTitle,
                        bannerTitleLocalized: undefined,
                        removeTitleFromTextToSpeak: json.newsConfig?.removeTitleFromTextToSpeak,
                        removeSubtitleFromTextToSpeak: json.newsConfig?.removeSubtitleFromTextToSpeak,
                        bannerPosition: json.newsConfig?.bannerPosition,
                        mediaPosition: json.newsConfig?.mediaPosition
                    }
                }
            },
            veilleConfig: {
                enabled: json.veilleConfig?.enabled,
                delayBeforeLaunchInSeconds: json.veilleConfig?.delayBeforeLaunchInSeconds,
                killConversationOnLaunch: json.veilleConfig?.killConversationOnLaunch,
                autoExitFromWebcam: json.veilleConfig?.autoExitFromWebcam,
                views: {
                    news: {
                        enabled: json.veilleConfig?.views?.news?.enabled,
                        muted: json.veilleConfig?.views?.news?.muted
                    },
                    screenSaver: {
                        enabled: json.veilleConfig?.views?.screenSaver?.enabled,
                        url: json.veilleConfig?.views?.screenSaver?.url,
                        timerBeforeSwitchInSeconds: json.veilleConfig?.views?.screenSaver?.timerBeforeSwitchInSeconds
                    },
                    slideShow: {
                        enabled: json.veilleConfig?.views?.slideShow?.enabled,
                        urls: json.veilleConfig?.views?.slideShow?.urls,
                        timerBeforeSwitchInSeconds: json.veilleConfig?.views?.slideShow?.timerBeforeSwitchInSeconds
                    }
                }
            },
            mapConfig: {
                mapCenter: json.mapConfig?.mapCenter,
                limitAroundCenter: json.mapConfig?.limitAroundCenter,
                settings: {
                    categories: json.mapConfig?.settings?.categories,
                    hospitalityCategories: json.mapConfig?.settings?.hospitalityCategories ? {
                        afaire: {
                            display: !!json.mapConfig?.settings?.hospitalityCategories?.afaire?.display,
                            color: json.mapConfig?.settings?.hospitalityCategories?.afaire?.color,
                            label: json.mapConfig?.settings?.hospitalityCategories?.afaire?.label,
                            localizedLabel: undefined
                        },
                        avoir: {
                            display: !!json.mapConfig?.settings?.hospitalityCategories?.avoir?.display,
                            color: json.mapConfig?.settings?.hospitalityCategories?.avoir?.color,
                            label: json.mapConfig?.settings?.hospitalityCategories?.avoir?.label,
                            localizedLabel: undefined
                        },
                        hebergement: {
                            display: !!json.mapConfig?.settings?.hospitalityCategories?.hebergement?.display,
                            color: json.mapConfig?.settings?.hospitalityCategories?.hebergement?.color,
                            label: json.mapConfig?.settings?.hospitalityCategories?.hebergement?.label,
                            localizedLabel: undefined
                        },
                        produit: {
                            display: !!json.mapConfig?.settings?.hospitalityCategories?.produit?.display,
                            color: json.mapConfig?.settings?.hospitalityCategories?.produit?.color,
                            label: json.mapConfig?.settings?.hospitalityCategories?.produit?.label,
                            localizedLabel: undefined
                        },
                        restaurant: {
                            display: !!json.mapConfig?.settings?.hospitalityCategories?.restaurant?.display,
                            color: json.mapConfig?.settings?.hospitalityCategories?.restaurant?.color,
                            label: json.mapConfig?.settings?.hospitalityCategories?.restaurant?.label,
                            localizedLabel: undefined
                        },
                        service: {
                            display: !!json.mapConfig?.settings?.hospitalityCategories?.service?.display,
                            color: json.mapConfig?.settings?.hospitalityCategories?.service?.color,
                            label: json.mapConfig?.settings?.hospitalityCategories?.service?.label,
                            localizedLabel: undefined
                        }
                    } : undefined,
                    showFilter: json.mapConfig?.settings?.showFilter
                }
            },
            chatbotData: {
                size: size,
                height: height
            },
            chatbotDataWidget: {
                size: sizeWidget,
                height: heightWidget
            },
            agentData: {
                url: personnage,
                name: json.characterName,
                animationsUrl: json.animationsUrl || undefined,
                portrait: json.widgetButton?.agentThumbnail || undefined
            },
            ponyfillFactoryCredentials: {
                region: json.voiceCredentialsRegion,
                subscriptionKey: json.voiceCredentialsSubscriptionKey,
                speechRecognitionHostnamesRecord: json.speechRecognizerHosts,
                speechRecognitionHostname: undefined,
                speechSynthesisHostname: json.speechSynthesizerHost
            },
            addressData: {
                ...retorikProps.addressData,
                directline: {
                    tokenEndpoint: tokenEndpoint,
                    address: retorikProps.addressData?.directline?.address || json.directLine_address || (0, $kdMEA.defaultDirectLineAddress)
                }
            },
            userData: retorikProps.userData,
            customVoice: {
                voice: json.voice,
                gender: undefined
            },
            colors: {
                theme: json.colorSettings.theme,
                primary: json.colorSettings.primary,
                secondary: json.colorSettings.secondary,
                black: json.colorSettings.black,
                whereToEatColor: json.colorSettings.whereToEatColor,
                whereToSleepColor: json.colorSettings.whereToSleepColor,
                tobeSeenColor: json.colorSettings.tobeSeenColor,
                tobeDoneColor: json.colorSettings.tobeDoneColor,
                localProductsColor: json.colorSettings.localProductsColor,
                servicesColor: json.colorSettings.servicesColor,
                companyName: json.colorSettings.companyName,
                agendaColor: json.colorSettings.agendaColor,
                occupantColor: json.colorSettings.occupantColor,
                loader: {
                    animation: json.colorSettings.loader?.animation,
                    background: json.colorSettings.loader?.background,
                    text: json.colorSettings.loader?.text,
                    toggle: {
                        text: json.colorSettings.loader?.toggle?.text,
                        background: json.colorSettings.loader?.toggle?.background
                    },
                    button: {
                        background: {
                            default: json.colorSettings.loader?.button?.background?.default,
                            hover: json.colorSettings.loader?.button?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.loader?.button?.border?.default,
                            hover: json.colorSettings.loader?.button?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.loader?.button?.text?.default,
                            hover: json.colorSettings.loader?.button?.text?.hover
                        }
                    }
                },
                card: {
                    frame: {
                        background: json.colorSettings.card?.frame?.background,
                        border: json.colorSettings.card?.frame?.border,
                        text: json.colorSettings.card?.frame?.text
                    },
                    button: {
                        background: {
                            default: json.colorSettings.card?.button?.background?.default,
                            hover: json.colorSettings.card?.button?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.card?.button?.border?.default,
                            hover: json.colorSettings.card?.button?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.card?.button?.text?.default,
                            hover: json.colorSettings.card?.button?.text?.hover
                        }
                    },
                    discoverButton: {
                        background: {
                            default: json.colorSettings.card?.discoverButton?.background?.default,
                            hover: json.colorSettings.card?.discoverButton?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.card?.discoverButton?.border?.default,
                            hover: json.colorSettings.card?.discoverButton?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.card?.discoverButton?.text?.default,
                            hover: json.colorSettings.card?.discoverButton?.text?.hover
                        }
                    }
                },
                textMode: {
                    panel: {
                        background: json.colorSettings.textMode?.panel?.background,
                        border: json.colorSettings.textMode?.panel?.border,
                        conversationUser: json.colorSettings.textMode?.panel?.conversationUser,
                        conversationBot: json.colorSettings.textMode?.panel?.conversationBot,
                        backgroundUser: json.colorSettings.textMode?.panel?.backgroundUser,
                        backgroundBot: json.colorSettings.textMode?.panel?.backgroundBot
                    }
                },
                vocalMode: {
                    subtitles: {
                        text: json.colorSettings.vocalMode?.subtitles?.text,
                        background: json.colorSettings.vocalMode?.subtitles?.background
                    }
                },
                formInput: {
                    text: {
                        default: json.colorSettings.formInput?.inputText?.default,
                        hover: json.colorSettings.formInput?.inputText?.hover
                    },
                    inputRadioCheckbox: {
                        unchecked: {
                            background: json.colorSettings.formInput?.inputRadioCheckbox?.unchecked?.background,
                            border: json.colorSettings.formInput?.inputRadioCheckbox?.unchecked?.border
                        },
                        checked: {
                            background: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.background,
                            border: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.border,
                            item: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.item
                        }
                    },
                    inputButton: {
                        background: {
                            default: json.colorSettings.formInput?.inputButton?.background?.default,
                            hover: json.colorSettings.formInput?.inputButton?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.formInput?.inputButton?.border?.default,
                            hover: json.colorSettings.formInput?.inputButton?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.formInput?.inputButton?.text?.default,
                            hover: json.colorSettings.formInput?.inputButton?.text?.hover
                        }
                    },
                    likert: {
                        default: json.colorSettings.formInput?.likert?.default,
                        hover: json.colorSettings.formInput?.likert?.hover
                    }
                }
            },
            defaultMode: json.defaultMode,
            skipLoader: json.skipLoader,
            // Language data
            defaultCulture: json.defaultCulture,
            supportedCultures: json.supportedCultures,
            // Other data
            customScripts: json.customScripts,
            customCSS: json.customCSS,
            features: json.features
        };
        return props;
    }
    return null;
};
var $af55b6b5b4f24adb$export$2e2bcd8739ae039 = $af55b6b5b4f24adb$var$getRetorikConfigs;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $cto9a = parcelRequire("cto9a");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $4ea6937c26364827$export$a4ad2735b021c132 = '1.9.1';


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
const $cdf3d274d518d8a9$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $cdf3d274d518d8a9$export$a5733a4d26a1ec61(ownVersion) {
    const acceptedVersions = new Set([
        ownVersion
    ]);
    const rejectedVersions = new Set();
    const myVersionMatch = ownVersion.match($cdf3d274d518d8a9$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return ()=>false;
    const ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        const globalVersionMatch = globalVersion.match($cdf3d274d518d8a9$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        const globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
const $cdf3d274d518d8a9$export$7fc0d8c3ab188c4c = $cdf3d274d518d8a9$export$a5733a4d26a1ec61((0, $4ea6937c26364827$export$a4ad2735b021c132));


const $cb65aacd6001f05d$var$major = (0, $4ea6937c26364827$export$a4ad2735b021c132).split('.')[0];
const $cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for(`opentelemetry.js.api.${$cb65aacd6001f05d$var$major}`);
const $cb65aacd6001f05d$var$_global = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};
function $cb65aacd6001f05d$export$d586ae880b433238(type, instance, diag, allowOverride = false) {
    var _a;
    const api = $cb65aacd6001f05d$var$_global[$cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $cb65aacd6001f05d$var$_global[$cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $4ea6937c26364827$export$a4ad2735b021c132)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        const err = new Error(`@opentelemetry/api: Attempted duplicate registration of API: ${type}`);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $4ea6937c26364827$export$a4ad2735b021c132)) {
        // All registered APIs must be of the same version exactly
        const err = new Error(`@opentelemetry/api: Registration of version v${api.version} for ${type} does not match previously registered API v${(0, $4ea6937c26364827$export$a4ad2735b021c132)}`);
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug(`@opentelemetry/api: Registered a global for ${type} v${(0, $4ea6937c26364827$export$a4ad2735b021c132)}.`);
    return true;
}
function $cb65aacd6001f05d$export$a4e55266d2135a7f(type) {
    var _a, _b;
    const globalVersion = (_a = $cb65aacd6001f05d$var$_global[$cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $cdf3d274d518d8a9$export$7fc0d8c3ab188c4c)(globalVersion)) return;
    return (_b = $cb65aacd6001f05d$var$_global[$cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $cb65aacd6001f05d$export$d42ac835f38d1fb2(type, diag) {
    diag.debug(`@opentelemetry/api: Unregistering a global for ${type} v${(0, $4ea6937c26364827$export$a4ad2735b021c132)}.`);
    const api = $cb65aacd6001f05d$var$_global[$cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}


class $15342f087d708314$export$b4bccc12f5b13129 {
    constructor(props){
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    debug(...args) {
        return $15342f087d708314$var$logProxy('debug', this._namespace, args);
    }
    error(...args) {
        return $15342f087d708314$var$logProxy('error', this._namespace, args);
    }
    info(...args) {
        return $15342f087d708314$var$logProxy('info', this._namespace, args);
    }
    warn(...args) {
        return $15342f087d708314$var$logProxy('warn', this._namespace, args);
    }
    verbose(...args) {
        return $15342f087d708314$var$logProxy('verbose', this._namespace, args);
    }
}
function $15342f087d708314$var$logProxy(funcName, namespace, args) {
    const logger = (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)('diag');
    // shortcut if logger not set
    if (!logger) return;
    return logger[funcName](namespace, ...args);
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $3a4c386570d64094$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($3a4c386570d64094$export$b7d7b4c0f3c95263 || ($3a4c386570d64094$export$b7d7b4c0f3c95263 = {}));


function $991a5e37aa3ab931$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).NONE) maxLevel = (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).NONE;
    else if (maxLevel > (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).ALL) maxLevel = (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        const theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).ERROR),
        warn: _filterFunc('warn', (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).WARN),
        info: _filterFunc('info', (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).INFO),
        debug: _filterFunc('debug', (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).DEBUG),
        verbose: _filterFunc('verbose', (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).VERBOSE)
    };
}




const $91fa7e10f60a5297$var$API_NAME = 'diag';
class $91fa7e10f60a5297$export$5c8937ffc688cfd3 {
    /** Get the singleton instance of the DiagAPI API */ static instance() {
        if (!this._instance) this._instance = new $91fa7e10f60a5297$export$5c8937ffc688cfd3();
        return this._instance;
    }
    /**
     * Private internal constructor
     * @private
     */ constructor(){
        function _logProxy(funcName) {
            return function(...args) {
                const logger = (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName](...args);
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        const self = this;
        // DiagAPI specific functions
        const setLogger = (logger, optionsOrLogLevel = {
            logLevel: (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).INFO
        })=>{
            var _a, _b, _c;
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                const err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            const oldLogger = (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)('diag');
            const newLogger = (0, $991a5e37aa3ab931$export$9a9cc475abb19689)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                const stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn(`Current logger will be overwritten from ${stack}`);
                newLogger.warn(`Current logger will overwrite one already registered from ${stack}`);
            }
            return (0, $cb65aacd6001f05d$export$d586ae880b433238)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = ()=>{
            (0, $cb65aacd6001f05d$export$d42ac835f38d1fb2)($91fa7e10f60a5297$var$API_NAME, self);
        };
        self.createComponentLogger = (options)=>{
            return new (0, $15342f087d708314$export$b4bccc12f5b13129)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ class $4de9a0bcf3d630bc$export$b8c511fa1a5f4987 {
    constructor(entries){
        this._entries = entries ? new Map(entries) : new Map();
    }
    getEntry(key) {
        const entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    }
    getAllEntries() {
        return Array.from(this._entries.entries());
    }
    setEntry(key, entry) {
        const newBaggage = new $4de9a0bcf3d630bc$export$b8c511fa1a5f4987(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    }
    removeEntry(key) {
        const newBaggage = new $4de9a0bcf3d630bc$export$b8c511fa1a5f4987(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    }
    removeEntries(...keys) {
        const newBaggage = new $4de9a0bcf3d630bc$export$b8c511fa1a5f4987(this._entries);
        for (const key of keys)newBaggage._entries.delete(key);
        return newBaggage;
    }
    clear() {
        return new $4de9a0bcf3d630bc$export$b8c511fa1a5f4987();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ const $4b9ec98449e85b40$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');


const $6435a4ae4b78a9aa$var$diag = (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance();
function $6435a4ae4b78a9aa$export$1034a425c7384452(entries = {}) {
    return new (0, $4de9a0bcf3d630bc$export$b8c511fa1a5f4987)(new Map(Object.entries(entries)));
}
function $6435a4ae4b78a9aa$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $6435a4ae4b78a9aa$var$diag.error(`Cannot create baggage metadata from unknown type: ${typeof str}`);
        str = '';
    }
    return {
        __TYPE__: (0, $4b9ec98449e85b40$export$92dd2fe8ddb5cb7),
        toString () {
            return str;
        }
    };
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Get a key to uniquely identify a context value
 *
 * @since 1.0.0
 */ function $a50b1446b3c4bd0a$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
class $a50b1446b3c4bd0a$var$BaseContext {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ constructor(parentContext){
        // for minification
        const self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = (key)=>self._currentContext.get(key);
        self.setValue = (key, value)=>{
            const context = new $a50b1446b3c4bd0a$var$BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = (key)=>{
            const context = new $a50b1446b3c4bd0a$var$BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
}
const $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc = new $a50b1446b3c4bd0a$var$BaseContext();




/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ class $59cde47689e48f33$export$c23c6f85dd4fc1e9 {
    constructor(){}
    /**
     * @see {@link Meter.createGauge}
     */ createGauge(_name, _options) {
        return $59cde47689e48f33$export$dd01300aacbcec1c;
    }
    /**
     * @see {@link Meter.createHistogram}
     */ createHistogram(_name, _options) {
        return $59cde47689e48f33$export$689c32a6a552e1a6;
    }
    /**
     * @see {@link Meter.createCounter}
     */ createCounter(_name, _options) {
        return $59cde47689e48f33$export$e6d19fe5233efc54;
    }
    /**
     * @see {@link Meter.createUpDownCounter}
     */ createUpDownCounter(_name, _options) {
        return $59cde47689e48f33$export$2f189cd99d2b7429;
    }
    /**
     * @see {@link Meter.createObservableGauge}
     */ createObservableGauge(_name, _options) {
        return $59cde47689e48f33$export$ea67e3c6ff624776;
    }
    /**
     * @see {@link Meter.createObservableCounter}
     */ createObservableCounter(_name, _options) {
        return $59cde47689e48f33$export$163422b94c3edbcb;
    }
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ createObservableUpDownCounter(_name, _options) {
        return $59cde47689e48f33$export$5b8be9ab17b673b3;
    }
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ addBatchObservableCallback(_callback, _observables) {}
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ removeBatchObservableCallback(_callback) {}
}
class $59cde47689e48f33$export$834a616d1cf278b {
}
class $59cde47689e48f33$export$b556ba0f560c45b extends $59cde47689e48f33$export$834a616d1cf278b {
    add(_value, _attributes) {}
}
class $59cde47689e48f33$export$df09a35db160df98 extends $59cde47689e48f33$export$834a616d1cf278b {
    add(_value, _attributes) {}
}
class $59cde47689e48f33$export$b7f4a3c7ea16c24 extends $59cde47689e48f33$export$834a616d1cf278b {
    record(_value, _attributes) {}
}
class $59cde47689e48f33$export$ef064c3e0426c607 extends $59cde47689e48f33$export$834a616d1cf278b {
    record(_value, _attributes) {}
}
class $59cde47689e48f33$export$a5a3e7829c289482 {
    addCallback(_callback) {}
    removeCallback(_callback) {}
}
class $59cde47689e48f33$export$7a7e4b169d5c93a8 extends $59cde47689e48f33$export$a5a3e7829c289482 {
}
class $59cde47689e48f33$export$6990a2f90809ffc1 extends $59cde47689e48f33$export$a5a3e7829c289482 {
}
class $59cde47689e48f33$export$3ec3555bc6f693a4 extends $59cde47689e48f33$export$a5a3e7829c289482 {
}
const $59cde47689e48f33$export$65e277d35235a01f = new $59cde47689e48f33$export$c23c6f85dd4fc1e9();
const $59cde47689e48f33$export$e6d19fe5233efc54 = new $59cde47689e48f33$export$b556ba0f560c45b();
const $59cde47689e48f33$export$dd01300aacbcec1c = new $59cde47689e48f33$export$b7f4a3c7ea16c24();
const $59cde47689e48f33$export$689c32a6a552e1a6 = new $59cde47689e48f33$export$ef064c3e0426c607();
const $59cde47689e48f33$export$2f189cd99d2b7429 = new $59cde47689e48f33$export$df09a35db160df98();
const $59cde47689e48f33$export$163422b94c3edbcb = new $59cde47689e48f33$export$7a7e4b169d5c93a8();
const $59cde47689e48f33$export$ea67e3c6ff624776 = new $59cde47689e48f33$export$6990a2f90809ffc1();
const $59cde47689e48f33$export$5b8be9ab17b673b3 = new $59cde47689e48f33$export$3ec3555bc6f693a4();
function $59cde47689e48f33$export$bc3a498ccbb5c2b5() {
    return $59cde47689e48f33$export$65e277d35235a01f;
}






/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @deprecated use the one declared in @opentelemetry/sdk-trace-base instead.
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 *
 * @since 1.0.0
 */ var $4be02e1161967f43$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($4be02e1161967f43$export$94df7a7a96a92f7b || ($4be02e1161967f43$export$94df7a7a96a92f7b = {}));


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @since 1.0.0
 */ var $d03364baa5302116$export$4da4ea8145910e8b;
(function(SpanKind) {
    /** Default value. Indicates that the span is used internally. */ SpanKind[SpanKind["INTERNAL"] = 0] = "INTERNAL";
    /**
     * Indicates that the span covers server-side handling of an RPC or other
     * remote request.
     */ SpanKind[SpanKind["SERVER"] = 1] = "SERVER";
    /**
     * Indicates that the span covers the client-side wrapper around an RPC or
     * other remote request.
     */ SpanKind[SpanKind["CLIENT"] = 2] = "CLIENT";
    /**
     * Indicates that the span describes producer sending a message to a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["PRODUCER"] = 3] = "PRODUCER";
    /**
     * Indicates that the span describes consumer receiving a message from a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["CONSUMER"] = 4] = "CONSUMER";
})($d03364baa5302116$export$4da4ea8145910e8b || ($d03364baa5302116$export$4da4ea8145910e8b = {}));


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * An enumeration of status codes.
 *
 * @since 1.0.0
 */ var $873e79d0391b734f$export$1e28dd9b5d01db83;
(function(SpanStatusCode) {
    /**
     * The default status.
     */ SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    /**
     * The operation has been validated by an Application developer or
     * Operator to have completed successfully.
     */ SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    /**
     * The operation contains an error.
     */ SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})($873e79d0391b734f$export$1e28dd9b5d01db83 || ($873e79d0391b734f$export$1e28dd9b5d01db83 = {}));


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @since 1.0.0
 */ var $974e5505212bea35$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($974e5505212bea35$export$bf9049ad2b0883ff || ($974e5505212bea35$export$bf9049ad2b0883ff = {}));



/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
const $9c9f5532a1cced84$export$55cc39fb0d4bb4c0 = '0000000000000000';
const $9c9f5532a1cced84$export$22be96e88d95e128 = '00000000000000000000000000000000';
const $9c9f5532a1cced84$export$8591e4c852b66703 = {
    traceId: $9c9f5532a1cced84$export$22be96e88d95e128,
    spanId: $9c9f5532a1cced84$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $974e5505212bea35$export$bf9049ad2b0883ff).NONE
};


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $c6fe789a2f964f1e$export$972d28f7c6a8c6c7 {
    constructor(spanContext = (0, $9c9f5532a1cced84$export$8591e4c852b66703)){
        this._spanContext = spanContext;
    }
    // Returns a SpanContext.
    spanContext() {
        return this._spanContext;
    }
    // By default does nothing
    setAttribute(_key, _value) {
        return this;
    }
    // By default does nothing
    setAttributes(_attributes) {
        return this;
    }
    // By default does nothing
    addEvent(_name, _attributes) {
        return this;
    }
    addLink(_link) {
        return this;
    }
    addLinks(_links) {
        return this;
    }
    // By default does nothing
    setStatus(_status) {
        return this;
    }
    // By default does nothing
    updateName(_name) {
        return this;
    }
    // By default does nothing
    end(_endTime) {}
    // isRecording always returns false for NonRecordingSpan.
    isRecording() {
        return false;
    }
    // By default does nothing
    recordException(_exception, _time) {}
}


// Valid characters (0-9, a-f, A-F) are marked as 1.
const $a89fc3550e8ac673$var$isHex = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1
]);
function $a89fc3550e8ac673$var$isValidHex(id, length) {
    // As of 1.9.0 the id was allowed to be a non-string value,
    // even though it was not possible in the types.
    if (typeof id !== 'string' || id.length !== length) return false;
    let r = 0;
    for(let i = 0; i < id.length; i += 4)r += ($a89fc3550e8ac673$var$isHex[id.charCodeAt(i)] | 0) + ($a89fc3550e8ac673$var$isHex[id.charCodeAt(i + 1)] | 0) + ($a89fc3550e8ac673$var$isHex[id.charCodeAt(i + 2)] | 0) + ($a89fc3550e8ac673$var$isHex[id.charCodeAt(i + 3)] | 0);
    return r === length;
}
function $a89fc3550e8ac673$export$29dd34cf1269f6da(traceId) {
    return $a89fc3550e8ac673$var$isValidHex(traceId, 32) && traceId !== (0, $9c9f5532a1cced84$export$22be96e88d95e128);
}
function $a89fc3550e8ac673$export$8e51c6d8f0586aff(spanId) {
    return $a89fc3550e8ac673$var$isValidHex(spanId, 16) && spanId !== (0, $9c9f5532a1cced84$export$55cc39fb0d4bb4c0);
}
function $a89fc3550e8ac673$export$e4373b9a2c09216c(spanContext) {
    return $a89fc3550e8ac673$export$29dd34cf1269f6da(spanContext.traceId) && $a89fc3550e8ac673$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $a89fc3550e8ac673$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $c6fe789a2f964f1e$export$972d28f7c6a8c6c7)(spanContext);
}



/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $214efc9333dd7c65$export$a27e5df35d1539a6 {
    active() {
        return 0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc;
    }
    with(_context, fn, thisArg, ...args) {
        return fn.call(thisArg, ...args);
    }
    bind(_context, target) {
        return target;
    }
    enable() {
        return this;
    }
    disable() {
        return this;
    }
}




const $f78ae9f272172c4f$var$API_NAME = 'context';
const $f78ae9f272172c4f$var$NOOP_CONTEXT_MANAGER = new (0, $214efc9333dd7c65$export$a27e5df35d1539a6)();
class $f78ae9f272172c4f$export$4148866f0a453927 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
    /** Get the singleton instance of the Context API */ static getInstance() {
        if (!this._instance) this._instance = new $f78ae9f272172c4f$export$4148866f0a453927();
        return this._instance;
    }
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ setGlobalContextManager(contextManager) {
        return (0, $cb65aacd6001f05d$export$d586ae880b433238)($f78ae9f272172c4f$var$API_NAME, contextManager, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    }
    /**
     * Get the currently active context
     */ active() {
        return this._getContextManager().active();
    }
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        return this._getContextManager().with(context, fn, thisArg, ...args);
    }
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ bind(context, target) {
        return this._getContextManager().bind(context, target);
    }
    _getContextManager() {
        return (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)($f78ae9f272172c4f$var$API_NAME) || $f78ae9f272172c4f$var$NOOP_CONTEXT_MANAGER;
    }
    /** Disable and remove the global context manager */ disable() {
        this._getContextManager().disable();
        (0, $cb65aacd6001f05d$export$d42ac835f38d1fb2)($f78ae9f272172c4f$var$API_NAME, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    }
}


const $e8248f70bfae46d0$export$a078c61943f9dbbe = (0, $f78ae9f272172c4f$export$4148866f0a453927).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

const $83ffbea8f4ffb90a$export$c042e7c2f59bc046 = (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance();


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $9a9fe8e6a3e425da$export$51c513ea08316108 {
    getMeter(_name, _version, _options) {
        return 0, $59cde47689e48f33$export$65e277d35235a01f;
    }
}
const $9a9fe8e6a3e425da$export$d21fe83355c56e18 = new $9a9fe8e6a3e425da$export$51c513ea08316108();




const $a1d106e73864165d$var$API_NAME = 'metrics';
class $a1d106e73864165d$export$1339f6eb6111c638 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
    /** Get the singleton instance of the Metrics API */ static getInstance() {
        if (!this._instance) this._instance = new $a1d106e73864165d$export$1339f6eb6111c638();
        return this._instance;
    }
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ setGlobalMeterProvider(provider) {
        return (0, $cb65aacd6001f05d$export$d586ae880b433238)($a1d106e73864165d$var$API_NAME, provider, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    }
    /**
     * Returns the global meter provider.
     */ getMeterProvider() {
        return (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)($a1d106e73864165d$var$API_NAME) || (0, $9a9fe8e6a3e425da$export$d21fe83355c56e18);
    }
    /**
     * Returns a meter from the global meter provider.
     */ getMeter(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    }
    /** Remove the global meter provider */ disable() {
        (0, $cb65aacd6001f05d$export$d42ac835f38d1fb2)($a1d106e73864165d$var$API_NAME, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    }
}


const $33f59e57c604672a$export$b0c5c2fac8144e54 = (0, $a1d106e73864165d$export$1339f6eb6111c638).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ class $892f4a4d90464324$export$8356c7eb3af7963b {
    /** Noop inject function does nothing */ inject(_context, _carrier) {}
    /** Noop extract function does nothing and returns the input context */ extract(context, _carrier) {
        return context;
    }
    fields() {
        return [];
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @since 1.0.0
 */ const $d10b952398cf50ca$export$a0f575f55f38720a = {
    get (carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys (carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
const $d10b952398cf50ca$export$f70f1d111fccf1c1 = {
    set (carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * Baggage key
 */ const $a9b1d6be0fbb4573$var$BAGGAGE_KEY = (0, $a50b1446b3c4bd0a$export$b8c322c5a7cfce78)('OpenTelemetry Baggage Key');
function $a9b1d6be0fbb4573$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($a9b1d6be0fbb4573$var$BAGGAGE_KEY) || undefined;
}
function $a9b1d6be0fbb4573$export$120a1756099436ee() {
    return $a9b1d6be0fbb4573$export$f3bffa0b5dd10d1e((0, $f78ae9f272172c4f$export$4148866f0a453927).getInstance().active());
}
function $a9b1d6be0fbb4573$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($a9b1d6be0fbb4573$var$BAGGAGE_KEY, baggage);
}
function $a9b1d6be0fbb4573$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($a9b1d6be0fbb4573$var$BAGGAGE_KEY);
}




const $b514db26be7b5f30$var$API_NAME = 'propagation';
const $b514db26be7b5f30$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $892f4a4d90464324$export$8356c7eb3af7963b)();
class $b514db26be7b5f30$export$471eda0a6213cac9 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
        this.createBaggage = (0, $6435a4ae4b78a9aa$export$1034a425c7384452);
        this.getBaggage = (0, $a9b1d6be0fbb4573$export$f3bffa0b5dd10d1e);
        this.getActiveBaggage = (0, $a9b1d6be0fbb4573$export$120a1756099436ee);
        this.setBaggage = (0, $a9b1d6be0fbb4573$export$adc9ca19eab3f500);
        this.deleteBaggage = (0, $a9b1d6be0fbb4573$export$4ca3a8a743c9f633);
    }
    /** Get the singleton instance of the Propagator API */ static getInstance() {
        if (!this._instance) this._instance = new $b514db26be7b5f30$export$471eda0a6213cac9();
        return this._instance;
    }
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ setGlobalPropagator(propagator) {
        return (0, $cb65aacd6001f05d$export$d586ae880b433238)($b514db26be7b5f30$var$API_NAME, propagator, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    }
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ inject(context, carrier, setter = (0, $d10b952398cf50ca$export$f70f1d111fccf1c1)) {
        return this._getGlobalPropagator().inject(context, carrier, setter);
    }
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ extract(context, carrier, getter = (0, $d10b952398cf50ca$export$a0f575f55f38720a)) {
        return this._getGlobalPropagator().extract(context, carrier, getter);
    }
    /**
     * Return a list of all fields which may be used by the propagator.
     */ fields() {
        return this._getGlobalPropagator().fields();
    }
    /** Remove the global propagator */ disable() {
        (0, $cb65aacd6001f05d$export$d42ac835f38d1fb2)($b514db26be7b5f30$var$API_NAME, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    }
    _getGlobalPropagator() {
        return (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)($b514db26be7b5f30$var$API_NAME) || $b514db26be7b5f30$var$NOOP_TEXT_MAP_PROPAGATOR;
    }
}


const $c76b4b4057b01033$export$3e49040daa9dba20 = (0, $b514db26be7b5f30$export$471eda0a6213cac9).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * span key
 */ const $131eed9e3bc823e4$var$SPAN_KEY = (0, $a50b1446b3c4bd0a$export$b8c322c5a7cfce78)('OpenTelemetry Context Key SPAN');
function $131eed9e3bc823e4$export$246e04ba06066af1(context) {
    return context.getValue($131eed9e3bc823e4$var$SPAN_KEY) || undefined;
}
function $131eed9e3bc823e4$export$1be426a8e585c83e() {
    return $131eed9e3bc823e4$export$246e04ba06066af1((0, $f78ae9f272172c4f$export$4148866f0a453927).getInstance().active());
}
function $131eed9e3bc823e4$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($131eed9e3bc823e4$var$SPAN_KEY, span);
}
function $131eed9e3bc823e4$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($131eed9e3bc823e4$var$SPAN_KEY);
}
function $131eed9e3bc823e4$export$c90bf5428c14cdb1(context, spanContext) {
    return $131eed9e3bc823e4$export$8ab2f2e6ee8ed0a8(context, new (0, $c6fe789a2f964f1e$export$972d28f7c6a8c6c7)(spanContext));
}
function $131eed9e3bc823e4$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $131eed9e3bc823e4$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}




const $8382ff7c95656cd7$var$contextApi = (0, $f78ae9f272172c4f$export$4148866f0a453927).getInstance();
class $8382ff7c95656cd7$export$714c1036cabcd223 {
    // startSpan starts a noop span.
    startSpan(name, options, context = $8382ff7c95656cd7$var$contextApi.active()) {
        const root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $c6fe789a2f964f1e$export$972d28f7c6a8c6c7)();
        const parentFromContext = context && (0, $131eed9e3bc823e4$export$1a635f8f0b912781)(context);
        if ($8382ff7c95656cd7$var$isSpanContext(parentFromContext) && (0, $a89fc3550e8ac673$export$e4373b9a2c09216c)(parentFromContext)) return new (0, $c6fe789a2f964f1e$export$972d28f7c6a8c6c7)(parentFromContext);
        else return new (0, $c6fe789a2f964f1e$export$972d28f7c6a8c6c7)();
    }
    startActiveSpan(name, arg2, arg3, arg4) {
        let opts;
        let ctx;
        let fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        const parentContext = ctx !== null && ctx !== void 0 ? ctx : $8382ff7c95656cd7$var$contextApi.active();
        const span = this.startSpan(name, opts, parentContext);
        const contextWithSpanSet = (0, $131eed9e3bc823e4$export$8ab2f2e6ee8ed0a8)(parentContext, span);
        return $8382ff7c95656cd7$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    }
}
function $8382ff7c95656cd7$var$isSpanContext(spanContext) {
    return spanContext !== null && typeof spanContext === 'object' && 'spanId' in spanContext && typeof spanContext['spanId'] === 'string' && 'traceId' in spanContext && typeof spanContext['traceId'] === 'string' && 'traceFlags' in spanContext && typeof spanContext['traceFlags'] === 'number';
}


const $570c3749fe6786e1$var$NOOP_TRACER = new (0, $8382ff7c95656cd7$export$714c1036cabcd223)();
class $570c3749fe6786e1$export$df2c38268c6bb6b3 {
    constructor(provider, name, version, options){
        this._provider = provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    startSpan(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    }
    startActiveSpan(_name, _options, _context, _fn) {
        const tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    }
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ _getTracer() {
        if (this._delegate) return this._delegate;
        const tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $570c3749fe6786e1$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $15a573b8ffe13d1f$export$87d8e93756f9e86e {
    getTracer(_name, _version, _options) {
        return new (0, $8382ff7c95656cd7$export$714c1036cabcd223)();
    }
}


const $281ea616e9eb9c84$var$NOOP_TRACER_PROVIDER = new (0, $15a573b8ffe13d1f$export$87d8e93756f9e86e)();
class $281ea616e9eb9c84$export$4137aabcb4254962 {
    /**
     * Get a {@link ProxyTracer}
     */ getTracer(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $570c3749fe6786e1$export$df2c38268c6bb6b3)(this, name, version, options);
    }
    getDelegate() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $281ea616e9eb9c84$var$NOOP_TRACER_PROVIDER;
    }
    /**
     * Set the delegate tracer provider
     */ setDelegate(delegate) {
        this._delegate = delegate;
    }
    getDelegateTracer(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    }
}





const $ab4d31e36b2e74b9$var$API_NAME = 'trace';
class $ab4d31e36b2e74b9$export$2cccde6fcc7b568a {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
        this._proxyTracerProvider = new (0, $281ea616e9eb9c84$export$4137aabcb4254962)();
        this.wrapSpanContext = (0, $a89fc3550e8ac673$export$c19cc0f1911bdb85);
        this.isSpanContextValid = (0, $a89fc3550e8ac673$export$e4373b9a2c09216c);
        this.deleteSpan = (0, $131eed9e3bc823e4$export$a6bbfe9a17f7941c);
        this.getSpan = (0, $131eed9e3bc823e4$export$246e04ba06066af1);
        this.getActiveSpan = (0, $131eed9e3bc823e4$export$1be426a8e585c83e);
        this.getSpanContext = (0, $131eed9e3bc823e4$export$1a635f8f0b912781);
        this.setSpan = (0, $131eed9e3bc823e4$export$8ab2f2e6ee8ed0a8);
        this.setSpanContext = (0, $131eed9e3bc823e4$export$c90bf5428c14cdb1);
    }
    /** Get the singleton instance of the Trace API */ static getInstance() {
        if (!this._instance) this._instance = new $ab4d31e36b2e74b9$export$2cccde6fcc7b568a();
        return this._instance;
    }
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ setGlobalTracerProvider(provider) {
        const success = (0, $cb65aacd6001f05d$export$d586ae880b433238)($ab4d31e36b2e74b9$var$API_NAME, this._proxyTracerProvider, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    }
    /**
     * Returns the global tracer provider.
     */ getTracerProvider() {
        return (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)($ab4d31e36b2e74b9$var$API_NAME) || this._proxyTracerProvider;
    }
    /**
     * Returns a tracer from the global tracer provider.
     */ getTracer(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    }
    /** Remove the global tracer provider */ disable() {
        (0, $cb65aacd6001f05d$export$d42ac835f38d1fb2)($ab4d31e36b2e74b9$var$API_NAME, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
        this._proxyTracerProvider = new (0, $281ea616e9eb9c84$export$4137aabcb4254962)();
    }
}


const $a1569335aa614ed8$export$357889f174732d38 = (0, $ab4d31e36b2e74b9$export$2cccde6fcc7b568a).getInstance();


var // Default export.
$00524e035e1e9c07$export$2e2bcd8739ae039 = {
    context: $e8248f70bfae46d0$export$a078c61943f9dbbe,
    diag: $83ffbea8f4ffb90a$export$c042e7c2f59bc046,
    metrics: $33f59e57c604672a$export$b0c5c2fac8144e54,
    propagation: $c76b4b4057b01033$export$3e49040daa9dba20,
    trace: $a1569335aa614ed8$export$357889f174732d38
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d760faa28735d56a$export$a756c21bf453f1b5 {
    _delegate;
    constructor(_delegate){
        this._delegate = _delegate;
    }
    /**
     * Export items.
     * @param items
     * @param resultCallback
     */ export(items, resultCallback) {
        this._delegate.export(items, resultCallback);
    }
    forceFlush() {
        return this._delegate.forceFlush();
    }
    shutdown() {
        return this._delegate.shutdown();
    }
}


function $f997fc8cbaa9a43a$export$edd172c6c83c39cc(resource) {
    return {
        attributes: $f997fc8cbaa9a43a$export$b6255b619acd6709(resource.attributes),
        droppedAttributesCount: 0
    };
}
function $f997fc8cbaa9a43a$export$5a2377b8e90dd1bf(scope) {
    return {
        name: scope.name,
        version: scope.version
    };
}
function $f997fc8cbaa9a43a$export$b6255b619acd6709(attributes) {
    return Object.keys(attributes).map((key)=>$f997fc8cbaa9a43a$export$155f69accf533147(key, attributes[key]));
}
function $f997fc8cbaa9a43a$export$155f69accf533147(key, value) {
    return {
        key: key,
        value: $f997fc8cbaa9a43a$export$9544ab3c60b2d8ce(value)
    };
}
function $f997fc8cbaa9a43a$export$9544ab3c60b2d8ce(value) {
    const t = typeof value;
    if (t === 'string') return {
        stringValue: value
    };
    if (t === 'number') {
        if (!Number.isInteger(value)) return {
            doubleValue: value
        };
        return {
            intValue: value
        };
    }
    if (t === 'boolean') return {
        boolValue: value
    };
    if (value instanceof Uint8Array) return {
        bytesValue: value
    };
    if (Array.isArray(value)) return {
        arrayValue: {
            values: value.map($f997fc8cbaa9a43a$export$9544ab3c60b2d8ce)
        }
    };
    if (t === 'object' && value != null) return {
        kvlistValue: {
            values: Object.entries(value).map(([k, v])=>$f997fc8cbaa9a43a$export$155f69accf533147(k, v))
        }
    };
    return {};
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $02b2267f7388e0c4$export$b22daef4119238cd = performance;


const $bd29e81cd70a2732$var$NANOSECOND_DIGITS = 9;
const $bd29e81cd70a2732$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
const $bd29e81cd70a2732$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $bd29e81cd70a2732$var$NANOSECOND_DIGITS_IN_MILLIS);
const $bd29e81cd70a2732$var$SECOND_TO_NANOSECONDS = Math.pow(10, $bd29e81cd70a2732$var$NANOSECOND_DIGITS);
function $bd29e81cd70a2732$export$e7ec5c82995537b1(epochMillis) {
    const epochSeconds = epochMillis / 1000;
    // Decimals only.
    const seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    const nanos = Math.round(epochMillis % 1000 * $bd29e81cd70a2732$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $bd29e81cd70a2732$export$e752b05e58096a2f() {
    let timeOrigin = (0, $02b2267f7388e0c4$export$b22daef4119238cd).timeOrigin;
    if (typeof timeOrigin !== 'number') {
        const perf = (0, $02b2267f7388e0c4$export$b22daef4119238cd);
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function $bd29e81cd70a2732$export$24b3f7dcd2848fa8(performanceNow) {
    const timeOrigin = $bd29e81cd70a2732$export$e7ec5c82995537b1($bd29e81cd70a2732$export$e752b05e58096a2f());
    const now = $bd29e81cd70a2732$export$e7ec5c82995537b1(typeof performanceNow === 'number' ? performanceNow : (0, $02b2267f7388e0c4$export$b22daef4119238cd).now());
    return $bd29e81cd70a2732$export$f07bb1dbc72184c3(timeOrigin, now);
}
function $bd29e81cd70a2732$export$5f4c8a8ba0e36226(time) {
    // process.hrtime
    if ($bd29e81cd70a2732$export$390c59432f173a9f(time)) return time;
    else if (typeof time === 'number') {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < $bd29e81cd70a2732$export$e752b05e58096a2f()) return $bd29e81cd70a2732$export$24b3f7dcd2848fa8(time);
        else // epoch milliseconds or performance.timeOrigin
        return $bd29e81cd70a2732$export$e7ec5c82995537b1(time);
    } else if (time instanceof Date) return $bd29e81cd70a2732$export$e7ec5c82995537b1(time.getTime());
    else throw TypeError('Invalid input type');
}
function $bd29e81cd70a2732$export$b783ad6617389e3e(startTime, endTime) {
    let seconds = endTime[0] - startTime[0];
    let nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += $bd29e81cd70a2732$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $bd29e81cd70a2732$export$973c1c4fad6103e(time) {
    const precision = $bd29e81cd70a2732$var$NANOSECOND_DIGITS;
    const tmp = `${'0'.repeat(precision)}${time[1]}Z`;
    const nanoString = tmp.substring(tmp.length - precision - 1);
    const date = new Date(time[0] * 1000).toISOString();
    return date.replace('000Z', nanoString);
}
function $bd29e81cd70a2732$export$2d91441ae30ebcfc(time) {
    return time[0] * $bd29e81cd70a2732$var$SECOND_TO_NANOSECONDS + time[1];
}
function $bd29e81cd70a2732$export$30b3706e4e35edf0(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function $bd29e81cd70a2732$export$95601fd64fa689b7(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function $bd29e81cd70a2732$export$390c59432f173a9f(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === 'number' && typeof value[1] === 'number';
}
function $bd29e81cd70a2732$export$a5e58227c317ebb9(value) {
    return $bd29e81cd70a2732$export$390c59432f173a9f(value) || typeof value === 'number' || value instanceof Date;
}
function $bd29e81cd70a2732$export$f07bb1dbc72184c3(time1, time2) {
    const out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    // Nanoseconds
    if (out[1] >= $bd29e81cd70a2732$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $bd29e81cd70a2732$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $583ea382cfa01d2c$var$intValue(charCode) {
    // 0-9
    if (charCode >= 48 && charCode <= 57) return charCode - 48;
    // a-f
    if (charCode >= 97 && charCode <= 102) return charCode - 87;
    // A-F
    return charCode - 55;
}
function $583ea382cfa01d2c$export$f7e0d8803cecbdc0(hexStr) {
    const buf = new Uint8Array(hexStr.length / 2);
    let offset = 0;
    for(let i = 0; i < hexStr.length; i += 2){
        const hi = $583ea382cfa01d2c$var$intValue(hexStr.charCodeAt(i));
        const lo = $583ea382cfa01d2c$var$intValue(hexStr.charCodeAt(i + 1));
        buf[offset++] = hi << 4 | lo;
    }
    return buf;
}


function $1e4cc20e2041671a$export$93fd2c60d7ab39e5(hrTime) {
    const NANOSECONDS = BigInt(1000000000);
    return BigInt(hrTime[0]) * NANOSECONDS + BigInt(hrTime[1]);
}
function $1e4cc20e2041671a$export$25fa08d6f84e69de(value) {
    const low = Number(BigInt.asUintN(32, value));
    const high = Number(BigInt.asUintN(32, value >> BigInt(32)));
    return {
        low: low,
        high: high
    };
}
function $1e4cc20e2041671a$export$9aa1c44d160043e3(hrTime) {
    const nanos = $1e4cc20e2041671a$export$93fd2c60d7ab39e5(hrTime);
    return $1e4cc20e2041671a$export$25fa08d6f84e69de(nanos);
}
function $1e4cc20e2041671a$export$91e61e5f118af2ed(hrTime) {
    const nanos = $1e4cc20e2041671a$export$93fd2c60d7ab39e5(hrTime);
    return nanos.toString();
}
const $1e4cc20e2041671a$var$encodeTimestamp = typeof BigInt !== 'undefined' ? $1e4cc20e2041671a$export$91e61e5f118af2ed : (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc);
function $1e4cc20e2041671a$var$identity(value) {
    return value;
}
function $1e4cc20e2041671a$var$optionalHexToBinary(str) {
    if (str === undefined) return undefined;
    return (0, $583ea382cfa01d2c$export$f7e0d8803cecbdc0)(str);
}
const $1e4cc20e2041671a$var$DEFAULT_ENCODER = {
    encodeHrTime: $1e4cc20e2041671a$export$9aa1c44d160043e3,
    encodeSpanContext: (0, $583ea382cfa01d2c$export$f7e0d8803cecbdc0),
    encodeOptionalSpanContext: $1e4cc20e2041671a$var$optionalHexToBinary
};
function $1e4cc20e2041671a$export$2d50162b78680823(options) {
    if (options === undefined) return $1e4cc20e2041671a$var$DEFAULT_ENCODER;
    const useLongBits = options.useLongBits ?? true;
    const useHex = options.useHex ?? false;
    return {
        encodeHrTime: useLongBits ? $1e4cc20e2041671a$export$9aa1c44d160043e3 : $1e4cc20e2041671a$var$encodeTimestamp,
        encodeSpanContext: useHex ? $1e4cc20e2041671a$var$identity : (0, $583ea382cfa01d2c$export$f7e0d8803cecbdc0),
        encodeOptionalSpanContext: useHex ? $1e4cc20e2041671a$var$identity : $1e4cc20e2041671a$var$optionalHexToBinary
    };
}


function $ef1583dc7b078b5f$export$8c81c8011901e012(span, encoder) {
    const ctx = span.spanContext();
    const status = span.status;
    const parentSpanId = span.parentSpanContext?.spanId ? encoder.encodeSpanContext(span.parentSpanContext?.spanId) : undefined;
    return {
        traceId: encoder.encodeSpanContext(ctx.traceId),
        spanId: encoder.encodeSpanContext(ctx.spanId),
        parentSpanId: parentSpanId,
        traceState: ctx.traceState?.serialize(),
        name: span.name,
        // Span kind is offset by 1 because the API does not define a value for unset
        kind: span.kind == null ? 0 : span.kind + 1,
        startTimeUnixNano: encoder.encodeHrTime(span.startTime),
        endTimeUnixNano: encoder.encodeHrTime(span.endTime),
        attributes: (0, $f997fc8cbaa9a43a$export$b6255b619acd6709)(span.attributes),
        droppedAttributesCount: span.droppedAttributesCount,
        events: span.events.map((event)=>$ef1583dc7b078b5f$export$c0221297e49388cc(event, encoder)),
        droppedEventsCount: span.droppedEventsCount,
        status: {
            // API and proto enums share the same values
            code: status.code,
            message: status.message
        },
        links: span.links.map((link)=>$ef1583dc7b078b5f$export$d40a678c50e6f4f2(link, encoder)),
        droppedLinksCount: span.droppedLinksCount
    };
}
function $ef1583dc7b078b5f$export$d40a678c50e6f4f2(link, encoder) {
    return {
        attributes: link.attributes ? (0, $f997fc8cbaa9a43a$export$b6255b619acd6709)(link.attributes) : [],
        spanId: encoder.encodeSpanContext(link.context.spanId),
        traceId: encoder.encodeSpanContext(link.context.traceId),
        traceState: link.context.traceState?.serialize(),
        droppedAttributesCount: link.droppedAttributesCount || 0
    };
}
function $ef1583dc7b078b5f$export$c0221297e49388cc(timedEvent, encoder) {
    return {
        attributes: timedEvent.attributes ? (0, $f997fc8cbaa9a43a$export$b6255b619acd6709)(timedEvent.attributes) : [],
        name: timedEvent.name,
        timeUnixNano: encoder.encodeHrTime(timedEvent.time),
        droppedAttributesCount: timedEvent.droppedAttributesCount || 0
    };
}
function $ef1583dc7b078b5f$export$4bd5e67fadfa9fe0(spans, options) {
    const encoder = (0, $1e4cc20e2041671a$export$2d50162b78680823)(options);
    return {
        resourceSpans: $ef1583dc7b078b5f$var$spanRecordsToResourceSpans(spans, encoder)
    };
}
function $ef1583dc7b078b5f$var$createResourceMap(readableSpans) {
    const resourceMap = new Map();
    for (const record of readableSpans){
        let ilsMap = resourceMap.get(record.resource);
        if (!ilsMap) {
            ilsMap = new Map();
            resourceMap.set(record.resource, ilsMap);
        }
        // TODO this is duplicated in basic tracer. Consolidate on a common helper in core
        const instrumentationScopeKey = `${record.instrumentationScope.name}@${record.instrumentationScope.version || ''}:${record.instrumentationScope.schemaUrl || ''}`;
        let records = ilsMap.get(instrumentationScopeKey);
        if (!records) {
            records = [];
            ilsMap.set(instrumentationScopeKey, records);
        }
        records.push(record);
    }
    return resourceMap;
}
function $ef1583dc7b078b5f$var$spanRecordsToResourceSpans(readableSpans, encoder) {
    const resourceMap = $ef1583dc7b078b5f$var$createResourceMap(readableSpans);
    const out = [];
    const entryIterator = resourceMap.entries();
    let entry = entryIterator.next();
    while(!entry.done){
        const [resource, ilmMap] = entry.value;
        const scopeResourceSpans = [];
        const ilmIterator = ilmMap.values();
        let ilmEntry = ilmIterator.next();
        while(!ilmEntry.done){
            const scopeSpans = ilmEntry.value;
            if (scopeSpans.length > 0) {
                const spans = scopeSpans.map((readableSpan)=>$ef1583dc7b078b5f$export$8c81c8011901e012(readableSpan, encoder));
                scopeResourceSpans.push({
                    scope: (0, $f997fc8cbaa9a43a$export$5a2377b8e90dd1bf)(scopeSpans[0].instrumentationScope),
                    spans: spans,
                    schemaUrl: scopeSpans[0].instrumentationScope.schemaUrl
                });
            }
            ilmEntry = ilmIterator.next();
        }
        // TODO SDK types don't provide resource schema URL at this time
        const transformedSpans = {
            resource: (0, $f997fc8cbaa9a43a$export$edd172c6c83c39cc)(resource),
            scopeSpans: scopeResourceSpans,
            schemaUrl: undefined
        };
        out.push(transformedSpans);
        entry = entryIterator.next();
    }
    return out;
}


const $09e9215285e32b8e$export$dfba2b8376f2d3f5 = {
    serializeRequest: (arg)=>{
        const request = (0, $ef1583dc7b078b5f$export$4bd5e67fadfa9fe0)(arg, {
            useHex: true,
            useLongBits: false
        });
        const encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: (arg)=>{
        const decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    }
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ac78d7cba247b951$var$MAX_ATTEMPTS = 5;
const $ac78d7cba247b951$var$INITIAL_BACKOFF = 1000;
const $ac78d7cba247b951$var$MAX_BACKOFF = 5000;
const $ac78d7cba247b951$var$BACKOFF_MULTIPLIER = 1.5;
const $ac78d7cba247b951$var$JITTER = 0.2;
/**
 * Get a pseudo-random jitter that falls in the range of [-JITTER, +JITTER]
 */ function $ac78d7cba247b951$var$getJitter() {
    return Math.random() * (2 * $ac78d7cba247b951$var$JITTER) - $ac78d7cba247b951$var$JITTER;
}
class $ac78d7cba247b951$var$RetryingTransport {
    _transport;
    constructor(_transport){
        this._transport = _transport;
    }
    retry(data, timeoutMillis, inMillis) {
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this._transport.send(data, timeoutMillis).then(resolve, reject);
            }, inMillis);
        });
    }
    async send(data, timeoutMillis) {
        const deadline = Date.now() + timeoutMillis;
        let result = await this._transport.send(data, timeoutMillis);
        let attempts = $ac78d7cba247b951$var$MAX_ATTEMPTS;
        let nextBackoff = $ac78d7cba247b951$var$INITIAL_BACKOFF;
        while(result.status === 'retryable' && attempts > 0){
            attempts--;
            // use maximum of computed backoff and 0 to avoid negative timeouts
            const backoff = Math.max(Math.min(nextBackoff, $ac78d7cba247b951$var$MAX_BACKOFF) + $ac78d7cba247b951$var$getJitter(), 0);
            nextBackoff = nextBackoff * $ac78d7cba247b951$var$BACKOFF_MULTIPLIER;
            const retryInMillis = result.retryInMillis ?? backoff;
            // return when expected retry time is after the export deadline.
            const remainingTimeoutMillis = deadline - Date.now();
            if (retryInMillis > remainingTimeoutMillis) return result;
            result = await this.retry(data, remainingTimeoutMillis, retryInMillis);
        }
        return result;
    }
    shutdown() {
        return this._transport.shutdown();
    }
}
function $ac78d7cba247b951$export$2a8528aedd03b24e(options) {
    return new $ac78d7cba247b951$var$RetryingTransport(options.transport);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $16602b3eace45b8b$export$bc409a649b31360b(statusCode) {
    const retryCodes = [
        429,
        502,
        503,
        504
    ];
    return retryCodes.includes(statusCode);
}
function $16602b3eace45b8b$export$4e009558974ad065(retryAfter) {
    if (retryAfter == null) return undefined;
    const seconds = Number.parseInt(retryAfter, 10);
    if (Number.isInteger(seconds)) return seconds > 0 ? seconds * 1000 : -1;
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After#directives
    const delay = new Date(retryAfter).getTime() - Date.now();
    if (delay >= 0) return delay;
    return 0;
}


class $cb09ba48eefe1474$var$XhrTransport {
    _parameters;
    constructor(_parameters){
        this._parameters = _parameters;
    }
    send(data, timeoutMillis) {
        return new Promise((resolve)=>{
            const xhr = new XMLHttpRequest();
            xhr.timeout = timeoutMillis;
            xhr.open('POST', this._parameters.url);
            const headers = this._parameters.headers();
            Object.entries(headers).forEach(([k, v])=>{
                xhr.setRequestHeader(k, v);
            });
            xhr.ontimeout = (_)=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request timed out')
                });
            };
            xhr.onreadystatechange = ()=>{
                if (xhr.status >= 200 && xhr.status <= 299) {
                    (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug('XHR success');
                    resolve({
                        status: 'success'
                    });
                } else if (xhr.status && (0, $16602b3eace45b8b$export$bc409a649b31360b)(xhr.status)) resolve({
                    status: 'retryable',
                    retryInMillis: (0, $16602b3eace45b8b$export$4e009558974ad065)(xhr.getResponseHeader('Retry-After'))
                });
                else if (xhr.status !== 0) resolve({
                    status: 'failure',
                    error: new Error('XHR request failed with non-retryable status')
                });
            };
            xhr.onabort = ()=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request aborted')
                });
            };
            xhr.onerror = ()=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request errored')
                });
            };
            xhr.send(data);
        });
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $cb09ba48eefe1474$export$8ab960d599ca0ecc(parameters) {
    return new $cb09ba48eefe1474$var$XhrTransport(parameters);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $e365c701f3b23db0$var$SendBeaconTransport {
    _params;
    constructor(_params){
        this._params = _params;
    }
    send(data) {
        return new Promise((resolve)=>{
            if (navigator.sendBeacon(this._params.url, new Blob([
                data
            ], {
                type: this._params.blobType
            }))) {
                // no way to signal retry, treat everything as success
                (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug('SendBeacon success');
                resolve({
                    status: 'success'
                });
            } else resolve({
                status: 'failure',
                error: new Error('SendBeacon failed')
            });
        });
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $e365c701f3b23db0$export$ef075750bfec2f31(parameters) {
    return new $e365c701f3b23db0$var$SendBeaconTransport(parameters);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $7975234183610ba3$var$BoundedQueueExportPromiseHandler {
    _concurrencyLimit;
    _sendingPromises = [];
    /**
     * @param concurrencyLimit maximum promises allowed in a queue at the same time.
     */ constructor(concurrencyLimit){
        this._concurrencyLimit = concurrencyLimit;
    }
    pushPromise(promise) {
        if (this.hasReachedLimit()) throw new Error('Concurrency Limit reached');
        this._sendingPromises.push(promise);
        const popPromise = ()=>{
            const index = this._sendingPromises.indexOf(promise);
            this._sendingPromises.splice(index, 1);
        };
        promise.then(popPromise, popPromise);
    }
    hasReachedLimit() {
        return this._sendingPromises.length >= this._concurrencyLimit;
    }
    async awaitAll() {
        await Promise.all(this._sendingPromises);
    }
}
function $7975234183610ba3$export$1de3d1a6b8cb6545(options) {
    return new $7975234183610ba3$var$BoundedQueueExportPromiseHandler(options.concurrencyLimit);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})($34c176c5ab8c4038$export$ee0fe4df4ef0f3a1 || ($34c176c5ab8c4038$export$ee0fe4df4ef0f3a1 = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for handling error
 */ class $781829fe643e04c6$export$26c718c16cda30c6 extends Error {
    code;
    name = 'OTLPExporterError';
    data;
    constructor(message, code, data){
        super(message);
        this.data = data;
        this.code = code;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $3e4caea9b02a862b$var$isPartialSuccessResponse(response) {
    return Object.prototype.hasOwnProperty.call(response, 'partialSuccess');
}
function $3e4caea9b02a862b$export$b6a88465884baecf() {
    return {
        handleResponse (response) {
            // Partial success MUST never be an empty object according the specification
            // see https://opentelemetry.io/docs/specs/otlp/#partial-success
            if (response == null || !$3e4caea9b02a862b$var$isPartialSuccessResponse(response) || response.partialSuccess == null || Object.keys(response.partialSuccess).length === 0) return;
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('Received Partial Success response:', JSON.stringify(response.partialSuccess));
        }
    };
}



class $18e73005dd8bbe6d$var$OTLPExportDelegate {
    _transport;
    _serializer;
    _responseHandler;
    _promiseQueue;
    _timeout;
    _diagLogger;
    constructor(_transport, _serializer, _responseHandler, _promiseQueue, _timeout){
        this._transport = _transport;
        this._serializer = _serializer;
        this._responseHandler = _responseHandler;
        this._promiseQueue = _promiseQueue;
        this._timeout = _timeout;
        this._diagLogger = (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).createComponentLogger({
            namespace: 'OTLPExportDelegate'
        });
    }
    export(internalRepresentation, resultCallback) {
        this._diagLogger.debug('items to be sent', internalRepresentation);
        // don't do any work if too many exports are in progress.
        if (this._promiseQueue.hasReachedLimit()) {
            resultCallback({
                code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error('Concurrent export limit reached')
            });
            return;
        }
        const serializedRequest = this._serializer.serializeRequest(internalRepresentation);
        if (serializedRequest == null) {
            resultCallback({
                code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error('Nothing to send')
            });
            return;
        }
        this._promiseQueue.pushPromise(this._transport.send(serializedRequest, this._timeout).then((response)=>{
            if (response.status === 'success') {
                if (response.data != null) try {
                    this._responseHandler.handleResponse(this._serializer.deserializeResponse(response.data));
                } catch (e) {
                    this._diagLogger.warn('Export succeeded but could not deserialize response - is the response specification compliant?', e, response.data);
                }
                // No matter the response, we can consider the export still successful.
                resultCallback({
                    code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).SUCCESS
                });
                return;
            } else if (response.status === 'failure' && response.error) {
                resultCallback({
                    code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                    error: response.error
                });
                return;
            } else if (response.status === 'retryable') resultCallback({
                code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                error: new (0, $781829fe643e04c6$export$26c718c16cda30c6)('Export failed with retryable status')
            });
            else resultCallback({
                code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                error: new (0, $781829fe643e04c6$export$26c718c16cda30c6)('Export failed with unknown error')
            });
        }, (reason)=>resultCallback({
                code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                error: reason
            })));
    }
    forceFlush() {
        return this._promiseQueue.awaitAll();
    }
    async shutdown() {
        this._diagLogger.debug('shutdown started');
        await this.forceFlush();
        this._transport.shutdown();
    }
}
function $18e73005dd8bbe6d$export$40ae898156a6d951(components, settings) {
    return new $18e73005dd8bbe6d$var$OTLPExportDelegate(components.transport, components.serializer, (0, $3e4caea9b02a862b$export$b6a88465884baecf)(), components.promiseHandler, settings.timeout);
}


function $7d0c02cecc294225$export$8874016870239da4(options, serializer, transport) {
    return (0, $18e73005dd8bbe6d$export$40ae898156a6d951)({
        transport: transport,
        serializer: serializer,
        promiseHandler: (0, $7975234183610ba3$export$1de3d1a6b8cb6545)(options)
    }, {
        timeout: options.timeoutMillis
    });
}


function $d7324b86b9a13b6b$export$f1ed08af29ca92a7(options, serializer) {
    return (0, $7d0c02cecc294225$export$8874016870239da4)(options, serializer, (0, $ac78d7cba247b951$export$2a8528aedd03b24e)({
        transport: (0, $cb09ba48eefe1474$export$8ab960d599ca0ecc)(options)
    }));
}
function $d7324b86b9a13b6b$export$5b68ba408d750db3(options, serializer) {
    return (0, $7d0c02cecc294225$export$8874016870239da4)(options, serializer, (0, $ac78d7cba247b951$export$2a8528aedd03b24e)({
        transport: (0, $e365c701f3b23db0$export$ef075750bfec2f31)({
            url: options.url,
            blobType: options.headers()['Content-Type']
        })
    }));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $21d798075bdc6ad7$export$c7dc25f7ba3fe11a(timeoutMillis) {
    if (Number.isFinite(timeoutMillis) && timeoutMillis > 0) return timeoutMillis;
    throw new Error(`Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '${timeoutMillis}')`);
}
function $21d798075bdc6ad7$export$c37a46ab59261386(headers) {
    if (headers == null) return undefined;
    return ()=>headers;
}
function $21d798075bdc6ad7$export$f0204f09cd0066b(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    return {
        timeoutMillis: $21d798075bdc6ad7$export$c7dc25f7ba3fe11a(userProvidedConfiguration.timeoutMillis ?? fallbackConfiguration.timeoutMillis ?? defaultConfiguration.timeoutMillis),
        concurrencyLimit: userProvidedConfiguration.concurrencyLimit ?? fallbackConfiguration.concurrencyLimit ?? defaultConfiguration.concurrencyLimit,
        compression: userProvidedConfiguration.compression ?? fallbackConfiguration.compression ?? defaultConfiguration.compression
    };
}
function $21d798075bdc6ad7$export$cd8c80b353c895f4() {
    return {
        timeoutMillis: 10000,
        concurrencyLimit: 30,
        compression: 'none'
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $9ee10f6ead5df449$export$4144cc9174bc6a0(partialHeaders) {
    return ()=>{
        const headers = {};
        Object.entries(partialHeaders?.() ?? {}).forEach(([key, value])=>{
            if (typeof value !== 'undefined') headers[key] = String(value);
            else (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Header "${key}" has invalid value (${value}) and will be ignored`);
        });
        return headers;
    };
}


function $7b3472f7b9490a7f$var$mergeHeaders(userProvidedHeaders, fallbackHeaders, defaultHeaders) {
    const requiredHeaders = {
        ...defaultHeaders()
    };
    const headers = {};
    return ()=>{
        // add fallback ones first
        if (fallbackHeaders != null) Object.assign(headers, fallbackHeaders());
        // override with user-provided ones
        if (userProvidedHeaders != null) Object.assign(headers, userProvidedHeaders());
        // override required ones.
        return Object.assign(headers, requiredHeaders);
    };
}
function $7b3472f7b9490a7f$var$validateUserProvidedUrl(url) {
    if (url == null) return undefined;
    try {
        new URL(url);
        return url;
    } catch (e) {
        throw new Error(`Configuration: Could not parse user-provided export URL: '${url}'`);
    }
}
function $7b3472f7b9490a7f$export$dae543ef16d16f76(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    return {
        ...(0, $21d798075bdc6ad7$export$f0204f09cd0066b)(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration),
        headers: $7b3472f7b9490a7f$var$mergeHeaders((0, $9ee10f6ead5df449$export$4144cc9174bc6a0)(userProvidedConfiguration.headers), fallbackConfiguration.headers, defaultConfiguration.headers),
        url: $7b3472f7b9490a7f$var$validateUserProvidedUrl(userProvidedConfiguration.url) ?? fallbackConfiguration.url ?? defaultConfiguration.url,
        agentOptions: userProvidedConfiguration.agentOptions ?? fallbackConfiguration.agentOptions ?? defaultConfiguration.agentOptions
    };
}
function $7b3472f7b9490a7f$export$ed5dc921e0200ace(requiredHeaders, signalResourcePath) {
    return {
        ...(0, $21d798075bdc6ad7$export$cd8c80b353c895f4)(),
        headers: ()=>requiredHeaders,
        url: 'http://localhost:4318/' + signalResourcePath,
        agentOptions: {
            keepAlive: true
        }
    };
}



function $4308ed00514410df$export$816c85190fdd0ca8(config, signalResourcePath, requiredHeaders) {
    return (0, $7b3472f7b9490a7f$export$dae543ef16d16f76)({
        url: config.url,
        timeoutMillis: config.timeoutMillis,
        headers: (0, $21d798075bdc6ad7$export$c37a46ab59261386)(config.headers),
        concurrencyLimit: config.concurrencyLimit
    }, {}, (0, $7b3472f7b9490a7f$export$ed5dc921e0200ace)(requiredHeaders, signalResourcePath));
}


function $4431ff953a4e960b$export$f0b482136e1f7b30(config, serializer, signalResourcePath, requiredHeaders) {
    const useXhr = !!config.headers || typeof navigator.sendBeacon !== 'function';
    const options = (0, $4308ed00514410df$export$816c85190fdd0ca8)(config, signalResourcePath, requiredHeaders);
    if (useXhr) return (0, $d7324b86b9a13b6b$export$f1ed08af29ca92a7)(options, serializer);
    else return (0, $d7324b86b9a13b6b$export$5b68ba408d750db3)(options, serializer);
}


class $392d64385d8e7a6b$export$f73dc942b4b27de3 extends (0, $d760faa28735d56a$export$a756c21bf453f1b5) {
    constructor(config = {}){
        super((0, $4431ff953a4e960b$export$f0b482136e1f7b30)(config, (0, $09e9215285e32b8e$export$dfba2b8376f2d3f5), 'v1/traces', {
            'Content-Type': 'application/json'
        }));
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ class $343ee5eade167bb1$export$85f6557964517f1a {
    _promise;
    _resolve;
    _reject;
    constructor(){
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    get promise() {
        return this._promise;
    }
    resolve(val) {
        this._resolve(val);
    }
    reject(err) {
        this._reject(err);
    }
}


class $febbb558a26756d8$export$c1f52ab4952184cd {
    _isCalled = false;
    _deferred = new (0, $343ee5eade167bb1$export$85f6557964517f1a)();
    _callback;
    _that;
    constructor(callback, that){
        this._callback = callback;
        this._that = that;
    }
    get isCalled() {
        return this._isCalled;
    }
    get promise() {
        return this._deferred.promise;
    }
    call(...args) {
        if (!this._isCalled) {
            this._isCalled = true;
            try {
                Promise.resolve(this._callback.call(this._that, ...args)).then((val)=>this._deferred.resolve(val), (err)=>this._deferred.reject(err));
            } catch (err) {
                this._deferred.reject(err);
            }
        }
        return this._deferred.promise;
    }
}

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ var $1c410abe0ad0a4e0$export$ee0fe4df4ef0f3a1;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})($1c410abe0ad0a4e0$export$ee0fe4df4ef0f3a1 || ($1c410abe0ad0a4e0$export$ee0fe4df4ef0f3a1 = {}));

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ function $10b6553ede829f91$export$c1cd528968868329(_) {
    return undefined;
}
function $10b6553ede829f91$export$9d8f36a7ac8db58c(_) {
    return undefined;
}
function $10b6553ede829f91$export$9d6c13e44580559c(_) {
    return undefined;
}
function $10b6553ede829f91$export$a18720db12f89f06(_) {
    return undefined;
}

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
function $d3457759b0be0e45$export$cd67a16f6d11e5bd() {
    return (ex)=>{
        (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error($d3457759b0be0e45$var$stringifyException(ex));
    };
}
/**
 * Converts an exception into a string representation
 * @param {Exception} ex
 */ function $d3457759b0be0e45$var$stringifyException(ex) {
    if (typeof ex === 'string') return ex;
    else return JSON.stringify($d3457759b0be0e45$var$flattenException(ex));
}
/**
 * Flattens an exception into key-value pairs by traversing the prototype chain
 * and coercing values to strings. Duplicate properties will not be overwritten;
 * the first insert wins.
 */ function $d3457759b0be0e45$var$flattenException(ex) {
    const result = {};
    let current = ex;
    while(current !== null){
        Object.getOwnPropertyNames(current).forEach((propertyName)=>{
            if (result[propertyName]) return;
            const value = current[propertyName];
            if (value) result[propertyName] = String(value);
        });
        current = Object.getPrototypeOf(current);
    }
    return result;
}


/** The global error handler delegate */ let $f91d2054c9c9eae4$var$delegateHandler = (0, $d3457759b0be0e45$export$cd67a16f6d11e5bd)();
function $f91d2054c9c9eae4$export$bdff946829732435(handler) {
    $f91d2054c9c9eae4$var$delegateHandler = handler;
}
function $f91d2054c9c9eae4$export$54c6946fc34b7cc2(ex) {
    try {
        $f91d2054c9c9eae4$var$delegateHandler(ex);
    } catch  {} // eslint-disable-line no-empty
}

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
const $471a7169b32a4714$var$SUPPRESS_TRACING_KEY = (0, $a50b1446b3c4bd0a$export$b8c322c5a7cfce78)('OpenTelemetry SDK Context Key SUPPRESS_TRACING');
function $471a7169b32a4714$export$869298f9835abc68(context) {
    return context.setValue($471a7169b32a4714$var$SUPPRESS_TRACING_KEY, true);
}
function $471a7169b32a4714$export$a8cb26cef1019d30(context) {
    return context.deleteValue($471a7169b32a4714$var$SUPPRESS_TRACING_KEY);
}
function $471a7169b32a4714$export$7d5f2376f7cf513(context) {
    return context.getValue($471a7169b32a4714$var$SUPPRESS_TRACING_KEY) === true;
}


class $4169b44abe7f1185$export$54ea939f5d39e8a2 {
    _maxExportBatchSize;
    _maxQueueSize;
    _scheduledDelayMillis;
    _exportTimeoutMillis;
    _exporter;
    _isExporting = false;
    _finishedSpans = [];
    _timer;
    _shutdownOnce;
    _droppedSpansCount = 0;
    constructor(exporter, config){
        this._exporter = exporter;
        this._maxExportBatchSize = typeof config?.maxExportBatchSize === 'number' ? config.maxExportBatchSize : (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_BSP_MAX_EXPORT_BATCH_SIZE') ?? 512;
        this._maxQueueSize = typeof config?.maxQueueSize === 'number' ? config.maxQueueSize : (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_BSP_MAX_QUEUE_SIZE') ?? 2048;
        this._scheduledDelayMillis = typeof config?.scheduledDelayMillis === 'number' ? config.scheduledDelayMillis : (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_BSP_SCHEDULE_DELAY') ?? 5000;
        this._exportTimeoutMillis = typeof config?.exportTimeoutMillis === 'number' ? config.exportTimeoutMillis : (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_BSP_EXPORT_TIMEOUT') ?? 30000;
        this._shutdownOnce = new (0, $febbb558a26756d8$export$c1f52ab4952184cd)(this._shutdown, this);
        if (this._maxExportBatchSize > this._maxQueueSize) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize');
            this._maxExportBatchSize = this._maxQueueSize;
        }
    }
    forceFlush() {
        if (this._shutdownOnce.isCalled) return this._shutdownOnce.promise;
        return this._flushAll();
    }
    // does nothing.
    onStart(_span, _parentContext) {}
    onEnd(span) {
        if (this._shutdownOnce.isCalled) return;
        if ((span.spanContext().traceFlags & (0, $974e5505212bea35$export$bf9049ad2b0883ff).SAMPLED) === 0) return;
        this._addToBuffer(span);
    }
    shutdown() {
        return this._shutdownOnce.call();
    }
    _shutdown() {
        return Promise.resolve().then(()=>{
            return this.onShutdown();
        }).then(()=>{
            return this._flushAll();
        }).then(()=>{
            return this._exporter.shutdown();
        });
    }
    /** Add a span in the buffer. */ _addToBuffer(span) {
        if (this._finishedSpans.length >= this._maxQueueSize) {
            // limit reached, drop span
            if (this._droppedSpansCount === 0) (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug('maxQueueSize reached, dropping spans');
            this._droppedSpansCount++;
            return;
        }
        if (this._droppedSpansCount > 0) {
            // some spans were dropped, log once with count of spans dropped
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Dropped ${this._droppedSpansCount} spans because maxQueueSize reached`);
            this._droppedSpansCount = 0;
        }
        this._finishedSpans.push(span);
        this._maybeStartTimer();
    }
    /**
     * Send all spans to the exporter respecting the batch size limit
     * This function is used only on forceFlush or shutdown,
     * for all other cases _flush should be used
     * */ _flushAll() {
        return new Promise((resolve, reject)=>{
            const promises = [];
            // calculate number of batches
            const count = Math.ceil(this._finishedSpans.length / this._maxExportBatchSize);
            for(let i = 0, j = count; i < j; i++)promises.push(this._flushOneBatch());
            Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    _flushOneBatch() {
        this._clearTimer();
        if (this._finishedSpans.length === 0) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            const timer = setTimeout(()=>{
                // don't wait anymore for export, this way the next batch can start
                reject(new Error('Timeout'));
            }, this._exportTimeoutMillis);
            // prevent downstream exporter calls from generating spans
            (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).with((0, $471a7169b32a4714$export$869298f9835abc68)((0, $e8248f70bfae46d0$export$a078c61943f9dbbe).active()), ()=>{
                // Reset the finished spans buffer here because the next invocations of the _flush method
                // could pass the same finished spans to the exporter if the buffer is cleared
                // outside the execution of this callback.
                let spans;
                if (this._finishedSpans.length <= this._maxExportBatchSize) {
                    spans = this._finishedSpans;
                    this._finishedSpans = [];
                } else spans = this._finishedSpans.splice(0, this._maxExportBatchSize);
                const doExport = ()=>this._exporter.export(spans, (result)=>{
                        clearTimeout(timer);
                        if (result.code === (0, $1c410abe0ad0a4e0$export$ee0fe4df4ef0f3a1).SUCCESS) resolve();
                        else reject(result.error ?? new Error('BatchSpanProcessor: span export failed'));
                    });
                let pendingResources = null;
                for(let i = 0, len = spans.length; i < len; i++){
                    const span = spans[i];
                    if (span.resource.asyncAttributesPending && span.resource.waitForAsyncAttributes) {
                        pendingResources ??= [];
                        pendingResources.push(span.resource.waitForAsyncAttributes());
                    }
                }
                // Avoid scheduling a promise to make the behavior more predictable and easier to test
                if (pendingResources === null) doExport();
                else Promise.all(pendingResources).then(doExport, (err)=>{
                    (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(err);
                    reject(err);
                });
            });
        });
    }
    _maybeStartTimer() {
        if (this._isExporting) return;
        const flush = ()=>{
            this._isExporting = true;
            this._flushOneBatch().finally(()=>{
                this._isExporting = false;
                if (this._finishedSpans.length > 0) {
                    this._clearTimer();
                    this._maybeStartTimer();
                }
            }).catch((e)=>{
                this._isExporting = false;
                (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(e);
            });
        };
        // we only wait if the queue doesn't have enough elements yet
        if (this._finishedSpans.length >= this._maxExportBatchSize) return flush();
        if (this._timer !== undefined) return;
        this._timer = setTimeout(()=>flush(), this._scheduledDelayMillis);
        // depending on runtime, this may be a 'number' or NodeJS.Timeout
        if (typeof this._timer !== 'number') this._timer.unref();
    }
    _clearTimer() {
        if (this._timer !== undefined) {
            clearTimeout(this._timer);
            this._timer = undefined;
        }
    }
}



class $09d39f20801a455d$export$237547059fd543f9 extends (0, $4169b44abe7f1185$export$54ea939f5d39e8a2) {
    _visibilityChangeListener;
    _pageHideListener;
    constructor(_exporter, config){
        super(_exporter, config);
        this.onInit(config);
    }
    onInit(config) {
        if (config?.disableAutoFlushOnDocumentHide !== true && typeof document !== 'undefined') {
            this._visibilityChangeListener = ()=>{
                if (document.visibilityState === 'hidden') this.forceFlush().catch((error)=>{
                    (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(error);
                });
            };
            this._pageHideListener = ()=>{
                this.forceFlush().catch((error)=>{
                    (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(error);
                });
            };
            document.addEventListener('visibilitychange', this._visibilityChangeListener);
            // use 'pagehide' event as a fallback for Safari; see https://bugs.webkit.org/show_bug.cgi?id=116769
            document.addEventListener('pagehide', this._pageHideListener);
        }
    }
    onShutdown() {
        if (typeof document !== 'undefined') {
            if (this._visibilityChangeListener) document.removeEventListener('visibilitychange', this._visibilityChangeListener);
            if (this._pageHideListener) document.removeEventListener('pagehide', this._pageHideListener);
        }
    }
}

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * based on lodash in order to support esm builds without esModuleInterop.
 * lodash is using MIT License.
 **/ const $0ae6a14fd51bcf82$var$objectTag = '[object Object]';
const $0ae6a14fd51bcf82$var$nullTag = '[object Null]';
const $0ae6a14fd51bcf82$var$undefinedTag = '[object Undefined]';
const $0ae6a14fd51bcf82$var$funcProto = Function.prototype;
const $0ae6a14fd51bcf82$var$funcToString = $0ae6a14fd51bcf82$var$funcProto.toString;
const $0ae6a14fd51bcf82$var$objectCtorString = $0ae6a14fd51bcf82$var$funcToString.call(Object);
const $0ae6a14fd51bcf82$var$getPrototypeOf = Object.getPrototypeOf;
const $0ae6a14fd51bcf82$var$objectProto = Object.prototype;
const $0ae6a14fd51bcf82$var$hasOwnProperty = $0ae6a14fd51bcf82$var$objectProto.hasOwnProperty;
const $0ae6a14fd51bcf82$var$symToStringTag = Symbol ? Symbol.toStringTag : undefined;
const $0ae6a14fd51bcf82$var$nativeObjectToString = $0ae6a14fd51bcf82$var$objectProto.toString;
function $0ae6a14fd51bcf82$export$53b83ca8eaab0383(value) {
    if (!$0ae6a14fd51bcf82$var$isObjectLike(value) || $0ae6a14fd51bcf82$var$baseGetTag(value) !== $0ae6a14fd51bcf82$var$objectTag) return false;
    const proto = $0ae6a14fd51bcf82$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = $0ae6a14fd51bcf82$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0ae6a14fd51bcf82$var$funcToString.call(Ctor) === $0ae6a14fd51bcf82$var$objectCtorString;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0ae6a14fd51bcf82$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $0ae6a14fd51bcf82$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $0ae6a14fd51bcf82$var$undefinedTag : $0ae6a14fd51bcf82$var$nullTag;
    return $0ae6a14fd51bcf82$var$symToStringTag && $0ae6a14fd51bcf82$var$symToStringTag in Object(value) ? $0ae6a14fd51bcf82$var$getRawTag(value) : $0ae6a14fd51bcf82$var$objectToString(value);
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $0ae6a14fd51bcf82$var$getRawTag(value) {
    const isOwn = $0ae6a14fd51bcf82$var$hasOwnProperty.call(value, $0ae6a14fd51bcf82$var$symToStringTag), tag = value[$0ae6a14fd51bcf82$var$symToStringTag];
    let unmasked = false;
    try {
        value[$0ae6a14fd51bcf82$var$symToStringTag] = undefined;
        unmasked = true;
    } catch  {
    // silence
    }
    const result = $0ae6a14fd51bcf82$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$0ae6a14fd51bcf82$var$symToStringTag] = tag;
        else delete value[$0ae6a14fd51bcf82$var$symToStringTag];
    }
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $0ae6a14fd51bcf82$var$objectToString(value) {
    return $0ae6a14fd51bcf82$var$nativeObjectToString.call(value);
}


const $13d6a7eb020acf9f$var$MAX_LEVEL = 20;
function $13d6a7eb020acf9f$export$4950aa0f605343fb(...args) {
    let result = args.shift();
    const objects = new WeakMap();
    while(args.length > 0)result = $13d6a7eb020acf9f$var$mergeTwoObjects(result, args.shift(), 0, objects);
    return result;
}
function $13d6a7eb020acf9f$var$takeValue(value) {
    if ($13d6a7eb020acf9f$var$isArray(value)) return value.slice();
    return value;
}
/**
 * Merges two objects
 * @param one - first object
 * @param two - second object
 * @param level - current deep level
 * @param objects - objects holder that has been already referenced - to prevent
 * cyclic dependency
 */ function $13d6a7eb020acf9f$var$mergeTwoObjects(one, two, level = 0, objects) {
    let result;
    if (level > $13d6a7eb020acf9f$var$MAX_LEVEL) return undefined;
    level++;
    if ($13d6a7eb020acf9f$var$isPrimitive(one) || $13d6a7eb020acf9f$var$isPrimitive(two) || $13d6a7eb020acf9f$var$isFunction(two)) result = $13d6a7eb020acf9f$var$takeValue(two);
    else if ($13d6a7eb020acf9f$var$isArray(one)) {
        result = one.slice();
        if ($13d6a7eb020acf9f$var$isArray(two)) for(let i = 0, j = two.length; i < j; i++)result.push($13d6a7eb020acf9f$var$takeValue(two[i]));
        else if ($13d6a7eb020acf9f$var$isObject(two)) {
            const keys = Object.keys(two);
            for(let i = 0, j = keys.length; i < j; i++){
                const key = keys[i];
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
                result[key] = $13d6a7eb020acf9f$var$takeValue(two[key]);
            }
        }
    } else if ($13d6a7eb020acf9f$var$isObject(one)) {
        if ($13d6a7eb020acf9f$var$isObject(two)) {
            if (!$13d6a7eb020acf9f$var$shouldMerge(one, two)) return two;
            result = Object.assign({}, one);
            const keys = Object.keys(two);
            for(let i = 0, j = keys.length; i < j; i++){
                const key = keys[i];
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
                const twoValue = two[key];
                if ($13d6a7eb020acf9f$var$isPrimitive(twoValue)) {
                    if (typeof twoValue === 'undefined') delete result[key];
                    else // result[key] = takeValue(twoValue);
                    result[key] = twoValue;
                } else {
                    const obj1 = result[key];
                    const obj2 = twoValue;
                    if ($13d6a7eb020acf9f$var$wasObjectReferenced(one, key, objects) || $13d6a7eb020acf9f$var$wasObjectReferenced(two, key, objects)) delete result[key];
                    else {
                        if ($13d6a7eb020acf9f$var$isObject(obj1) && $13d6a7eb020acf9f$var$isObject(obj2)) {
                            const arr1 = objects.get(obj1) || [];
                            const arr2 = objects.get(obj2) || [];
                            arr1.push({
                                obj: one,
                                key: key
                            });
                            arr2.push({
                                obj: two,
                                key: key
                            });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = $13d6a7eb020acf9f$var$mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        } else result = two;
    }
    return result;
}
/**
 * Function to check if object has been already reference
 * @param obj
 * @param key
 * @param objects
 */ function $13d6a7eb020acf9f$var$wasObjectReferenced(obj, key, objects) {
    const arr = objects.get(obj[key]) || [];
    for(let i = 0, j = arr.length; i < j; i++){
        const info = arr[i];
        if (info.key === key && info.obj === obj) return true;
    }
    return false;
}
function $13d6a7eb020acf9f$var$isArray(value) {
    return Array.isArray(value);
}
function $13d6a7eb020acf9f$var$isFunction(value) {
    return typeof value === 'function';
}
function $13d6a7eb020acf9f$var$isObject(value) {
    return !$13d6a7eb020acf9f$var$isPrimitive(value) && !$13d6a7eb020acf9f$var$isArray(value) && !$13d6a7eb020acf9f$var$isFunction(value) && typeof value === 'object';
}
function $13d6a7eb020acf9f$var$isPrimitive(value) {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'undefined' || value instanceof Date || value instanceof RegExp || value === null;
}
function $13d6a7eb020acf9f$var$shouldMerge(one, two) {
    if (!(0, $0ae6a14fd51bcf82$export$53b83ca8eaab0383)(one) || !(0, $0ae6a14fd51bcf82$export$53b83ca8eaab0383)(two)) return false;
    return true;
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $5b2a4f91df455610$export$a4ad2735b021c132 = '2.7.1';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ //----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates/registry/stable/attributes.ts.j2
//----------------------------------------------------------------------------------------------------------
/**
 * ASP.NET Core exception middleware handling result.
 *
 * @example handled
 * @example unhandled
 */ const $d77970ee83c3563c$export$f82340eb6f7ee4fc = 'aspnetcore.diagnostics.exception.result';
const $d77970ee83c3563c$export$cda1f266e1fc5b3f = "aborted";
const $d77970ee83c3563c$export$f59ec205fdfe6400 = "handled";
const $d77970ee83c3563c$export$b427e935fd6651ab = "skipped";
const $d77970ee83c3563c$export$7a0c380cad26f867 = "unhandled";
const $d77970ee83c3563c$export$e15ee6ced4b4d793 = 'aspnetcore.diagnostics.handler.type';
const $d77970ee83c3563c$export$d6be6e9a073ccba5 = 'aspnetcore.rate_limiting.policy';
const $d77970ee83c3563c$export$df376702a339c094 = 'aspnetcore.rate_limiting.result';
const $d77970ee83c3563c$export$e160ee3fb23dd21e = "acquired";
const $d77970ee83c3563c$export$336cf096763833a3 = "endpoint_limiter";
const $d77970ee83c3563c$export$ee99d6c8d66ba053 = "global_limiter";
const $d77970ee83c3563c$export$d4525b0bcb1802a6 = "request_canceled";
const $d77970ee83c3563c$export$746fc3f900d45c45 = 'aspnetcore.request.is_unhandled';
const $d77970ee83c3563c$export$bcd5f0f8484c3bc0 = 'aspnetcore.routing.is_fallback';
const $d77970ee83c3563c$export$d181153b8bdfa0b6 = 'aspnetcore.routing.match_status';
const $d77970ee83c3563c$export$ca7f093befa342d4 = "failure";
const $d77970ee83c3563c$export$ae1a39d3a4050746 = "success";
const $d77970ee83c3563c$export$f25890d1e3848156 = 'aspnetcore.user.is_authenticated';
const $d77970ee83c3563c$export$d68d146ff79c04a8 = 'client.address';
const $d77970ee83c3563c$export$98967a53baad5eec = 'client.port';
const $d77970ee83c3563c$export$5285ee03db771e5b = 'code.column.number';
const $d77970ee83c3563c$export$ac9d6c9a41211595 = 'code.file.path';
const $d77970ee83c3563c$export$fd34f7e1f0c418fc = 'code.function.name';
const $d77970ee83c3563c$export$ccc16b040f2d3c68 = 'code.line.number';
const $d77970ee83c3563c$export$84cf154ace206984 = 'code.stacktrace';
const $d77970ee83c3563c$export$f3ebe872053c9886 = 'db.collection.name';
const $d77970ee83c3563c$export$354f27025f67a12d = 'db.namespace';
const $d77970ee83c3563c$export$899baaeb75956560 = 'db.operation.batch.size';
const $d77970ee83c3563c$export$32ff3b5ea8eeed5d = 'db.operation.name';
const $d77970ee83c3563c$export$ebef2908cb0508b2 = 'db.query.summary';
const $d77970ee83c3563c$export$dc45382793fd9c73 = 'db.query.text';
const $d77970ee83c3563c$export$5f1e82edb68082a5 = 'db.response.status_code';
const $d77970ee83c3563c$export$59730bfffb801deb = 'db.stored_procedure.name';
const $d77970ee83c3563c$export$e092ac179da1bacb = 'db.system.name';
const $d77970ee83c3563c$export$33a9d0e8e2693338 = "mariadb";
const $d77970ee83c3563c$export$e0e77e85ab698795 = "microsoft.sql_server";
const $d77970ee83c3563c$export$6b580327d217ab17 = "mysql";
const $d77970ee83c3563c$export$de5fcd2a0648ea59 = "postgresql";
const $d77970ee83c3563c$export$50d2ae8f0fe53654 = 'dotnet.gc.heap.generation';
const $d77970ee83c3563c$export$53c7cec226bbc008 = "gen0";
const $d77970ee83c3563c$export$16eba2d1cd3c6aae = "gen1";
const $d77970ee83c3563c$export$53cbcd4ebe9fed52 = "gen2";
const $d77970ee83c3563c$export$73025750a790bd80 = "loh";
const $d77970ee83c3563c$export$92f06dbb8b8e4efb = "poh";
const $d77970ee83c3563c$export$27bc5d0fa190eb39 = 'error.type';
const $d77970ee83c3563c$export$c00e2e224ae81dcc = "_OTHER";
const $d77970ee83c3563c$export$5afa65f3c67a6da5 = 'exception.escaped';
const $d77970ee83c3563c$export$ab4513c1b55519b5 = 'exception.message';
const $d77970ee83c3563c$export$9b74e4928364b671 = 'exception.stacktrace';
const $d77970ee83c3563c$export$85da07cb5d867763 = 'exception.type';
const $d77970ee83c3563c$export$6dc05c1a4ea7d452 = (key)=>`http.request.header.${key}`;
const $d77970ee83c3563c$export$c950c48d651d36f6 = 'http.request.method';
const $d77970ee83c3563c$export$475d0b6904c72522 = "_OTHER";
const $d77970ee83c3563c$export$1d0475e0429ecc7a = "CONNECT";
const $d77970ee83c3563c$export$f5009fc3b2e116f6 = "DELETE";
const $d77970ee83c3563c$export$b37eb57f1c0ae17e = "GET";
const $d77970ee83c3563c$export$cfad2d23aef0a595 = "HEAD";
const $d77970ee83c3563c$export$ffb5e83a22c8414 = "OPTIONS";
const $d77970ee83c3563c$export$c4e10ea4e2b3375 = "PATCH";
const $d77970ee83c3563c$export$ca259afc8ad50e83 = "POST";
const $d77970ee83c3563c$export$a8e9778ce76ecdaa = "PUT";
const $d77970ee83c3563c$export$81cc82dc1804c06e = "TRACE";
const $d77970ee83c3563c$export$b4706f4398125cd2 = 'http.request.method_original';
const $d77970ee83c3563c$export$44a2b6455db2b082 = 'http.request.resend_count';
const $d77970ee83c3563c$export$a3227fcde36256b7 = (key)=>`http.response.header.${key}`;
const $d77970ee83c3563c$export$4f9cc9c1e7b4e832 = 'http.response.status_code';
const $d77970ee83c3563c$export$ee724a749950397e = 'http.route';
const $d77970ee83c3563c$export$9633601338584456 = 'jvm.gc.action';
const $d77970ee83c3563c$export$81a9f72367df0211 = 'jvm.gc.name';
const $d77970ee83c3563c$export$27fb7cfe62c0cad7 = 'jvm.memory.pool.name';
const $d77970ee83c3563c$export$c9dfa04abbde6209 = 'jvm.memory.type';
const $d77970ee83c3563c$export$5eceb6c6d9c4a2b1 = "heap";
const $d77970ee83c3563c$export$fb42d239cc164326 = "non_heap";
const $d77970ee83c3563c$export$b9f4735680b4c618 = 'jvm.thread.daemon';
const $d77970ee83c3563c$export$49cfe86a143a90f4 = 'jvm.thread.state';
const $d77970ee83c3563c$export$4d1c8eb785b37946 = "blocked";
const $d77970ee83c3563c$export$438d3b92d604d3c1 = "new";
const $d77970ee83c3563c$export$efbf4822176b787e = "runnable";
const $d77970ee83c3563c$export$10d62496862243a3 = "terminated";
const $d77970ee83c3563c$export$54c3957659069067 = "timed_waiting";
const $d77970ee83c3563c$export$97de93f28bd98f0c = "waiting";
const $d77970ee83c3563c$export$122a3f3d92b58f2d = 'network.local.address';
const $d77970ee83c3563c$export$dd3d00f8681df0ce = 'network.local.port';
const $d77970ee83c3563c$export$28b7676252843fab = 'network.peer.address';
const $d77970ee83c3563c$export$9fb532b0fee2b1f1 = 'network.peer.port';
const $d77970ee83c3563c$export$dee59b686a2846ec = 'network.protocol.name';
const $d77970ee83c3563c$export$d98f8d975600c0d0 = 'network.protocol.version';
const $d77970ee83c3563c$export$7616c996937a34bc = 'network.transport';
const $d77970ee83c3563c$export$f4431576993bcf7a = "pipe";
const $d77970ee83c3563c$export$169e124b418d088f = "quic";
const $d77970ee83c3563c$export$26ef76391bdfab1b = "tcp";
const $d77970ee83c3563c$export$a1d89d523a38f571 = "udp";
const $d77970ee83c3563c$export$19b3a90274118dec = "unix";
const $d77970ee83c3563c$export$9ce893eda94da085 = 'network.type';
const $d77970ee83c3563c$export$1c0032dd042c0036 = "ipv4";
const $d77970ee83c3563c$export$2e20616f92e0c61 = "ipv6";
const $d77970ee83c3563c$export$c0272561abab91e2 = 'otel.scope.name';
const $d77970ee83c3563c$export$f34b883f266e7940 = 'otel.scope.version';
const $d77970ee83c3563c$export$1ce3678560a98f66 = 'otel.status_code';
const $d77970ee83c3563c$export$91e9746558fdb3eb = "ERROR";
const $d77970ee83c3563c$export$88d70046bd134963 = "OK";
const $d77970ee83c3563c$export$bb722bc34dbbae55 = 'otel.status_description';
const $d77970ee83c3563c$export$a5acaa0dbc823e02 = 'server.address';
const $d77970ee83c3563c$export$b7822882ad829476 = 'server.port';
const $d77970ee83c3563c$export$fedb46f20ac6c2b4 = 'service.instance.id';
const $d77970ee83c3563c$export$84187ab40ae4fa9c = 'service.name';
const $d77970ee83c3563c$export$346d211229c82ddc = 'service.namespace';
const $d77970ee83c3563c$export$262ef07bab967f36 = 'service.version';
const $d77970ee83c3563c$export$d52213f71e0d6fe9 = 'signalr.connection.status';
const $d77970ee83c3563c$export$1941a43dd05c1796 = "app_shutdown";
const $d77970ee83c3563c$export$339985f783caddd3 = "normal_closure";
const $d77970ee83c3563c$export$5dbce0c170853f5d = "timeout";
const $d77970ee83c3563c$export$344eec4d4360b8c9 = 'signalr.transport';
const $d77970ee83c3563c$export$c9ad321a279e5110 = "long_polling";
const $d77970ee83c3563c$export$ade38f22da951337 = "server_sent_events";
const $d77970ee83c3563c$export$cb9a023ecee30642 = "web_sockets";
const $d77970ee83c3563c$export$f0cc9f40fa472996 = 'telemetry.sdk.language';
const $d77970ee83c3563c$export$76253579e9fea8e3 = "cpp";
const $d77970ee83c3563c$export$4163d8f19c62acfe = "dotnet";
const $d77970ee83c3563c$export$d735f65160d35019 = "erlang";
const $d77970ee83c3563c$export$1dde175b7d1c8a44 = "go";
const $d77970ee83c3563c$export$73150af2f1f383fa = "java";
const $d77970ee83c3563c$export$1b3cb919ea0daa1c = "nodejs";
const $d77970ee83c3563c$export$1a3ac4d13e9292be = "php";
const $d77970ee83c3563c$export$5734868f06d7b5c8 = "python";
const $d77970ee83c3563c$export$b7bb3f8171ef2aa3 = "ruby";
const $d77970ee83c3563c$export$713f4fffa2875054 = "rust";
const $d77970ee83c3563c$export$8d08f2cb0d9fd722 = "swift";
const $d77970ee83c3563c$export$2f063992689fdf64 = "webjs";
const $d77970ee83c3563c$export$8f719441032e7a01 = 'telemetry.sdk.name';
const $d77970ee83c3563c$export$5fe5e8dd061ec635 = 'telemetry.sdk.version';
const $d77970ee83c3563c$export$f00e0b7bc579cfe4 = 'url.fragment';
const $d77970ee83c3563c$export$ef7da4fb774e8a84 = 'url.full';
const $d77970ee83c3563c$export$36f670b9709ab2f8 = 'url.path';
const $d77970ee83c3563c$export$55ce97b387061dd1 = 'url.query';
const $d77970ee83c3563c$export$d1d5ca1ca02801e6 = 'url.scheme';
const $d77970ee83c3563c$export$11d4f8ef7be26b3d = 'user_agent.original';


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * The name of the runtime of this process.
 *
 * @example OpenJDK Runtime Environment
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 */ const $b03d57a2b73f253b$export$ad06ab84cf3d9d79 = 'process.runtime.name';


const $a43a32f76182233d$export$3c44663382dce232 = {
    [(0, $d77970ee83c3563c$export$8f719441032e7a01)]: 'opentelemetry',
    [(0, $b03d57a2b73f253b$export$ad06ab84cf3d9d79)]: 'browser',
    [(0, $d77970ee83c3563c$export$f0cc9f40fa472996)]: (0, $d77970ee83c3563c$export$2f063992689fdf64),
    [(0, $d77970ee83c3563c$export$5fe5e8dd061ec635)]: (0, $5b2a4f91df455610$export$a4ad2735b021c132)
};



/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ let $8d7f305478eb0c3b$var$serviceName;
function $8d7f305478eb0c3b$export$b8c2abd2a6cf7c10() {
    if ($8d7f305478eb0c3b$var$serviceName === undefined) try {
        const argv0 = globalThis.process.argv0;
        $8d7f305478eb0c3b$var$serviceName = argv0 ? `unknown_service:${argv0}` : 'unknown_service';
    } catch  {
        $8d7f305478eb0c3b$var$serviceName = 'unknown_service';
    }
    return $8d7f305478eb0c3b$var$serviceName;
}
function $8d7f305478eb0c3b$export$806b6b8db57a3723() {
    $8d7f305478eb0c3b$var$serviceName = undefined;
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ const $4709fdbdf22bd726$export$ae936b9d47e5870e = (val)=>{
    return val !== null && typeof val === 'object' && typeof val.then === 'function';
};


class $f5d296ad825fd0d7$var$ResourceImpl {
    _rawAttributes;
    _asyncAttributesPending = false;
    _schemaUrl;
    _memoizedAttributes;
    static FromAttributeList(attributes, options) {
        const res = new $f5d296ad825fd0d7$var$ResourceImpl({}, options);
        res._rawAttributes = $f5d296ad825fd0d7$var$guardedRawAttributes(attributes);
        res._asyncAttributesPending = attributes.filter(([_, val])=>(0, $4709fdbdf22bd726$export$ae936b9d47e5870e)(val)).length > 0;
        return res;
    }
    constructor(/**
     * A dictionary of attributes with string keys and values that provide
     * information about the entity as numbers, strings or booleans
     * TODO: Consider to add check/validation on attributes.
     */ resource, options){
        const attributes = resource.attributes ?? {};
        this._rawAttributes = Object.entries(attributes).map(([k, v])=>{
            if ((0, $4709fdbdf22bd726$export$ae936b9d47e5870e)(v)) // side-effect
            this._asyncAttributesPending = true;
            return [
                k,
                v
            ];
        });
        this._rawAttributes = $f5d296ad825fd0d7$var$guardedRawAttributes(this._rawAttributes);
        this._schemaUrl = $f5d296ad825fd0d7$var$validateSchemaUrl(options?.schemaUrl);
    }
    get asyncAttributesPending() {
        return this._asyncAttributesPending;
    }
    async waitForAsyncAttributes() {
        if (!this.asyncAttributesPending) return;
        for(let i = 0; i < this._rawAttributes.length; i++){
            const [k, v] = this._rawAttributes[i];
            this._rawAttributes[i] = [
                k,
                (0, $4709fdbdf22bd726$export$ae936b9d47e5870e)(v) ? await v : v
            ];
        }
        this._asyncAttributesPending = false;
    }
    get attributes() {
        if (this.asyncAttributesPending) (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error('Accessing resource attributes before async attributes settled');
        if (this._memoizedAttributes) return this._memoizedAttributes;
        const attrs = {};
        for (const [k, v] of this._rawAttributes){
            if ((0, $4709fdbdf22bd726$export$ae936b9d47e5870e)(v)) {
                (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug(`Unsettled resource attribute ${k} skipped`);
                continue;
            }
            if (v != null) attrs[k] ??= v;
        }
        // only memoize output if all attributes are settled
        if (!this._asyncAttributesPending) this._memoizedAttributes = attrs;
        return attrs;
    }
    getRawAttributes() {
        return this._rawAttributes;
    }
    get schemaUrl() {
        return this._schemaUrl;
    }
    merge(resource) {
        if (resource == null) return this;
        // Order is important
        // Spec states incoming attributes override existing attributes
        const mergedSchemaUrl = $f5d296ad825fd0d7$var$mergeSchemaUrl(this, resource);
        const mergedOptions = mergedSchemaUrl ? {
            schemaUrl: mergedSchemaUrl
        } : undefined;
        return $f5d296ad825fd0d7$var$ResourceImpl.FromAttributeList([
            ...resource.getRawAttributes(),
            ...this.getRawAttributes()
        ], mergedOptions);
    }
}
function $f5d296ad825fd0d7$export$bb0fe4e7060febbf(attributes, options) {
    return $f5d296ad825fd0d7$var$ResourceImpl.FromAttributeList(Object.entries(attributes), options);
}
function $f5d296ad825fd0d7$export$4d462f2e58ee368a(detectedResource, options) {
    return new $f5d296ad825fd0d7$var$ResourceImpl(detectedResource, options);
}
function $f5d296ad825fd0d7$export$6ed870441802d126() {
    return $f5d296ad825fd0d7$export$bb0fe4e7060febbf({});
}
function $f5d296ad825fd0d7$export$522a862cad1b0abc() {
    return $f5d296ad825fd0d7$export$bb0fe4e7060febbf({
        [(0, $d77970ee83c3563c$export$84187ab40ae4fa9c)]: (0, $8d7f305478eb0c3b$export$b8c2abd2a6cf7c10)(),
        [(0, $d77970ee83c3563c$export$f0cc9f40fa472996)]: (0, $a43a32f76182233d$export$3c44663382dce232)[0, $d77970ee83c3563c$export$f0cc9f40fa472996],
        [(0, $d77970ee83c3563c$export$8f719441032e7a01)]: (0, $a43a32f76182233d$export$3c44663382dce232)[0, $d77970ee83c3563c$export$8f719441032e7a01],
        [(0, $d77970ee83c3563c$export$5fe5e8dd061ec635)]: (0, $a43a32f76182233d$export$3c44663382dce232)[0, $d77970ee83c3563c$export$5fe5e8dd061ec635]
    });
}
function $f5d296ad825fd0d7$var$guardedRawAttributes(attributes) {
    return attributes.map(([k, v])=>{
        if ((0, $4709fdbdf22bd726$export$ae936b9d47e5870e)(v)) return [
            k,
            v.catch((err)=>{
                (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug('promise rejection for resource attribute: %s - %s', k, err);
                return undefined;
            })
        ];
        return [
            k,
            v
        ];
    });
}
function $f5d296ad825fd0d7$var$validateSchemaUrl(schemaUrl) {
    if (typeof schemaUrl === 'string' || schemaUrl === undefined) return schemaUrl;
    (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('Schema URL must be string or undefined, got %s. Schema URL will be ignored.', schemaUrl);
    return undefined;
}
function $f5d296ad825fd0d7$var$mergeSchemaUrl(old, updating) {
    const oldSchemaUrl = old?.schemaUrl;
    const updatingSchemaUrl = updating?.schemaUrl;
    const isOldEmpty = oldSchemaUrl === undefined || oldSchemaUrl === '';
    const isUpdatingEmpty = updatingSchemaUrl === undefined || updatingSchemaUrl === '';
    if (isOldEmpty) return updatingSchemaUrl;
    if (isUpdatingEmpty) return oldSchemaUrl;
    if (oldSchemaUrl === updatingSchemaUrl) return oldSchemaUrl;
    (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('Schema URL merge conflict: old resource has "%s", updating resource has "%s". Resulting resource will have undefined Schema URL.', oldSchemaUrl, updatingSchemaUrl);
    return undefined;
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
function $ebedf3725a996547$export$b0663eba150d60c9(attributes) {
    const out = {};
    if (typeof attributes !== 'object' || attributes == null) return out;
    for(const key in attributes){
        if (!Object.prototype.hasOwnProperty.call(attributes, key)) continue;
        if (!$ebedf3725a996547$export$d3dd8ead6a0318c3(key)) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Invalid attribute key: ${key}`);
            continue;
        }
        const val = attributes[key];
        if (!$ebedf3725a996547$export$1daad3d2aacf48c5(val)) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Invalid attribute value set for key: ${key}`);
            continue;
        }
        if (Array.isArray(val)) out[key] = val.slice();
        else out[key] = val;
    }
    return out;
}
function $ebedf3725a996547$export$d3dd8ead6a0318c3(key) {
    return typeof key === 'string' && key !== '';
}
function $ebedf3725a996547$export$1daad3d2aacf48c5(val) {
    if (val == null) return true;
    if (Array.isArray(val)) return $ebedf3725a996547$var$isHomogeneousAttributeValueArray(val);
    return $ebedf3725a996547$var$isValidPrimitiveAttributeValueType(typeof val);
}
function $ebedf3725a996547$var$isHomogeneousAttributeValueArray(arr) {
    let type;
    for (const element of arr){
        // null/undefined elements are allowed
        if (element == null) continue;
        const elementType = typeof element;
        if (elementType === type) continue;
        if (!type) {
            if ($ebedf3725a996547$var$isValidPrimitiveAttributeValueType(elementType)) {
                type = elementType;
                continue;
            }
            // encountered an invalid primitive
            return false;
        }
        return false;
    }
    return true;
}
function $ebedf3725a996547$var$isValidPrimitiveAttributeValueType(valType) {
    switch(valType){
        case 'number':
        case 'boolean':
        case 'string':
            return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 


const $3cae43e231665f13$export$b22daef4119238cd = performance;


const $3b7d94c9e2749488$var$NANOSECOND_DIGITS = 9;
const $3b7d94c9e2749488$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
const $3b7d94c9e2749488$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $3b7d94c9e2749488$var$NANOSECOND_DIGITS_IN_MILLIS);
const $3b7d94c9e2749488$var$SECOND_TO_NANOSECONDS = Math.pow(10, $3b7d94c9e2749488$var$NANOSECOND_DIGITS);
function $3b7d94c9e2749488$export$e7ec5c82995537b1(epochMillis) {
    const epochSeconds = epochMillis / 1000;
    // Decimals only.
    const seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    const nanos = Math.round(epochMillis % 1000 * $3b7d94c9e2749488$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $3b7d94c9e2749488$export$e752b05e58096a2f() {
    return (0, $3cae43e231665f13$export$b22daef4119238cd).timeOrigin;
}
function $3b7d94c9e2749488$export$24b3f7dcd2848fa8(performanceNow) {
    const timeOrigin = $3b7d94c9e2749488$export$e7ec5c82995537b1((0, $3cae43e231665f13$export$b22daef4119238cd).timeOrigin);
    const now = $3b7d94c9e2749488$export$e7ec5c82995537b1(typeof performanceNow === 'number' ? performanceNow : (0, $3cae43e231665f13$export$b22daef4119238cd).now());
    return $3b7d94c9e2749488$export$f07bb1dbc72184c3(timeOrigin, now);
}
function $3b7d94c9e2749488$export$5f4c8a8ba0e36226(time) {
    // process.hrtime
    if ($3b7d94c9e2749488$export$390c59432f173a9f(time)) return time;
    else if (typeof time === 'number') {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < (0, $3cae43e231665f13$export$b22daef4119238cd).timeOrigin) return $3b7d94c9e2749488$export$24b3f7dcd2848fa8(time);
        else // epoch milliseconds or performance.timeOrigin
        return $3b7d94c9e2749488$export$e7ec5c82995537b1(time);
    } else if (time instanceof Date) return $3b7d94c9e2749488$export$e7ec5c82995537b1(time.getTime());
    else throw TypeError('Invalid input type');
}
function $3b7d94c9e2749488$export$b783ad6617389e3e(startTime, endTime) {
    let seconds = endTime[0] - startTime[0];
    let nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += $3b7d94c9e2749488$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $3b7d94c9e2749488$export$973c1c4fad6103e(time) {
    const precision = $3b7d94c9e2749488$var$NANOSECOND_DIGITS;
    const tmp = `${'0'.repeat(precision)}${time[1]}Z`;
    const nanoString = tmp.substring(tmp.length - precision - 1);
    const date = new Date(time[0] * 1000).toISOString();
    return date.replace('000Z', nanoString);
}
function $3b7d94c9e2749488$export$2d91441ae30ebcfc(time) {
    return time[0] * $3b7d94c9e2749488$var$SECOND_TO_NANOSECONDS + time[1];
}
function $3b7d94c9e2749488$export$30b3706e4e35edf0(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function $3b7d94c9e2749488$export$95601fd64fa689b7(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function $3b7d94c9e2749488$export$390c59432f173a9f(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === 'number' && typeof value[1] === 'number';
}
function $3b7d94c9e2749488$export$a5e58227c317ebb9(value) {
    return $3b7d94c9e2749488$export$390c59432f173a9f(value) || typeof value === 'number' || value instanceof Date;
}
function $3b7d94c9e2749488$export$f07bb1dbc72184c3(time1, time2) {
    const out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    // Nanoseconds
    if (out[1] >= $3b7d94c9e2749488$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $3b7d94c9e2749488$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}



/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Event name definitions
const $1ecab79120c00c83$export$a0fff09a5370d06f = 'exception';


class $38fde56e89775176$export$7b15d0c2dba75760 {
    // Below properties are included to implement ReadableSpan for export
    // purposes but are not intended to be written-to directly.
    _spanContext;
    kind;
    parentSpanContext;
    attributes = {};
    links = [];
    events = [];
    startTime;
    resource;
    instrumentationScope;
    _droppedAttributesCount = 0;
    _droppedEventsCount = 0;
    _droppedLinksCount = 0;
    _attributesCount = 0;
    name;
    status = {
        code: (0, $873e79d0391b734f$export$1e28dd9b5d01db83).UNSET
    };
    endTime = [
        0,
        0
    ];
    _ended = false;
    _duration = [
        -1,
        -1
    ];
    _spanProcessor;
    _spanLimits;
    _attributeValueLengthLimit;
    _recordEndMetrics;
    _performanceStartTime;
    _performanceOffset;
    _startTimeProvided;
    /**
     * Constructs a new SpanImpl instance.
     */ constructor(opts){
        const now = Date.now();
        this._spanContext = opts.spanContext;
        this._performanceStartTime = (0, $3cae43e231665f13$export$b22daef4119238cd).now();
        this._performanceOffset = now - (this._performanceStartTime + (0, $3cae43e231665f13$export$b22daef4119238cd).timeOrigin);
        this._startTimeProvided = opts.startTime != null;
        this._spanLimits = opts.spanLimits;
        this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit ?? 0;
        this._spanProcessor = opts.spanProcessor;
        this.name = opts.name;
        this.parentSpanContext = opts.parentSpanContext;
        this.kind = opts.kind;
        if (opts.links) for (const link of opts.links)this.addLink(link);
        this.startTime = this._getTime(opts.startTime ?? now);
        this.resource = opts.resource;
        this.instrumentationScope = opts.scope;
        this._recordEndMetrics = opts.recordEndMetrics;
        if (opts.attributes != null) this.setAttributes(opts.attributes);
        this._spanProcessor.onStart(this, opts.context);
    }
    spanContext() {
        return this._spanContext;
    }
    setAttribute(key, value) {
        if (value == null || this._isSpanEnded()) return this;
        if (key.length === 0) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Invalid attribute key: ${key}`);
            return this;
        }
        if (!(0, $ebedf3725a996547$export$1daad3d2aacf48c5)(value)) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Invalid attribute value set for key: ${key}`);
            return this;
        }
        const { attributeCountLimit: attributeCountLimit } = this._spanLimits;
        const isNewKey = !Object.prototype.hasOwnProperty.call(this.attributes, key);
        if (attributeCountLimit !== undefined && this._attributesCount >= attributeCountLimit && isNewKey) {
            this._droppedAttributesCount++;
            return this;
        }
        this.attributes[key] = this._truncateToSize(value);
        if (isNewKey) this._attributesCount++;
        return this;
    }
    setAttributes(attributes) {
        for(const key in attributes)if (Object.prototype.hasOwnProperty.call(attributes, key)) this.setAttribute(key, attributes[key]);
        return this;
    }
    /**
     *
     * @param name Span Name
     * @param [attributesOrStartTime] Span attributes or start time
     *     if type is {@type TimeInput} and 3rd param is undefined
     * @param [timeStamp] Specified time stamp for the event
     */ addEvent(name, attributesOrStartTime, timeStamp) {
        if (this._isSpanEnded()) return this;
        const { eventCountLimit: eventCountLimit } = this._spanLimits;
        if (eventCountLimit === 0) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('No events allowed.');
            this._droppedEventsCount++;
            return this;
        }
        if (eventCountLimit !== undefined && this.events.length >= eventCountLimit) {
            if (this._droppedEventsCount === 0) (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug('Dropping extra events.');
            this.events.shift();
            this._droppedEventsCount++;
        }
        if ((0, $3b7d94c9e2749488$export$a5e58227c317ebb9)(attributesOrStartTime)) {
            if (!(0, $3b7d94c9e2749488$export$a5e58227c317ebb9)(timeStamp)) timeStamp = attributesOrStartTime;
            attributesOrStartTime = undefined;
        }
        const sanitized = (0, $ebedf3725a996547$export$b0663eba150d60c9)(attributesOrStartTime);
        const { attributePerEventCountLimit: attributePerEventCountLimit } = this._spanLimits;
        const attributes = {};
        let droppedAttributesCount = 0;
        let eventAttributesCount = 0;
        for(const attr in sanitized){
            if (!Object.prototype.hasOwnProperty.call(sanitized, attr)) continue;
            const attrVal = sanitized[attr];
            if (attributePerEventCountLimit !== undefined && eventAttributesCount >= attributePerEventCountLimit) {
                droppedAttributesCount++;
                continue;
            }
            attributes[attr] = this._truncateToSize(attrVal);
            eventAttributesCount++;
        }
        this.events.push({
            name: name,
            attributes: attributes,
            time: this._getTime(timeStamp),
            droppedAttributesCount: droppedAttributesCount
        });
        return this;
    }
    addLink(link) {
        if (this._isSpanEnded()) return this;
        const { linkCountLimit: linkCountLimit } = this._spanLimits;
        if (linkCountLimit === 0) {
            this._droppedLinksCount++;
            return this;
        }
        if (linkCountLimit !== undefined && this.links.length >= linkCountLimit) {
            if (this._droppedLinksCount === 0) (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug('Dropping extra links.');
            this.links.shift();
            this._droppedLinksCount++;
        }
        const { attributePerLinkCountLimit: attributePerLinkCountLimit } = this._spanLimits;
        const sanitized = (0, $ebedf3725a996547$export$b0663eba150d60c9)(link.attributes);
        const attributes = {};
        let droppedAttributesCount = 0;
        let linkAttributesCount = 0;
        for(const attr in sanitized){
            if (!Object.prototype.hasOwnProperty.call(sanitized, attr)) continue;
            const attrVal = sanitized[attr];
            if (attributePerLinkCountLimit !== undefined && linkAttributesCount >= attributePerLinkCountLimit) {
                droppedAttributesCount++;
                continue;
            }
            attributes[attr] = this._truncateToSize(attrVal);
            linkAttributesCount++;
        }
        const processedLink = {
            context: link.context
        };
        if (linkAttributesCount > 0) processedLink.attributes = attributes;
        if (droppedAttributesCount > 0) processedLink.droppedAttributesCount = droppedAttributesCount;
        this.links.push(processedLink);
        return this;
    }
    addLinks(links) {
        for (const link of links)this.addLink(link);
        return this;
    }
    setStatus(status) {
        if (this._isSpanEnded()) return this;
        if (status.code === (0, $873e79d0391b734f$export$1e28dd9b5d01db83).UNSET) return this;
        if (this.status.code === (0, $873e79d0391b734f$export$1e28dd9b5d01db83).OK) return this;
        const newStatus = {
            code: status.code
        };
        // When using try-catch, the caught "error" is of type `any`. When then assigning `any` to `status.message`,
        // TypeScript will not error. While this can happen during use of any API, it is more common on Span#setStatus()
        // as it's likely used in a catch-block. Therefore, we validate if `status.message` is actually a string, null, or
        // undefined to avoid an incorrect type causing issues downstream.
        if (status.code === (0, $873e79d0391b734f$export$1e28dd9b5d01db83).ERROR) {
            if (typeof status.message === 'string') newStatus.message = status.message;
            else if (status.message != null) (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Dropping invalid status.message of type '${typeof status.message}', expected 'string'`);
        }
        this.status = newStatus;
        return this;
    }
    updateName(name) {
        if (this._isSpanEnded()) return this;
        this.name = name;
        return this;
    }
    end(endTime) {
        if (this._isSpanEnded()) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error(`${this.name} ${this._spanContext.traceId}-${this._spanContext.spanId} - You can only call end() on a span once.`);
            return;
        }
        this.endTime = this._getTime(endTime);
        this._duration = (0, $3b7d94c9e2749488$export$b783ad6617389e3e)(this.startTime, this.endTime);
        if (this._duration[0] < 0) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.', this.startTime, this.endTime);
            this.endTime = this.startTime.slice();
            this._duration = [
                0,
                0
            ];
        }
        if (this._droppedEventsCount > 0) (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Dropped ${this._droppedEventsCount} events because eventCountLimit reached`);
        if (this._droppedLinksCount > 0) (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Dropped ${this._droppedLinksCount} links because linkCountLimit reached`);
        if (this._spanProcessor.onEnding) this._spanProcessor.onEnding(this);
        this._recordEndMetrics?.();
        this._ended = true;
        this._spanProcessor.onEnd(this);
    }
    _getTime(inp) {
        if (typeof inp === 'number' && inp <= (0, $3cae43e231665f13$export$b22daef4119238cd).now()) // must be a performance timestamp
        // apply correction and convert to hrtime
        return (0, $3b7d94c9e2749488$export$24b3f7dcd2848fa8)(inp + this._performanceOffset);
        if (typeof inp === 'number') return (0, $3b7d94c9e2749488$export$e7ec5c82995537b1)(inp);
        if (inp instanceof Date) return (0, $3b7d94c9e2749488$export$e7ec5c82995537b1)(inp.getTime());
        if ((0, $3b7d94c9e2749488$export$390c59432f173a9f)(inp)) return inp;
        if (this._startTimeProvided) // if user provided a time for the start manually
        // we can't use duration to calculate event/end times
        return (0, $3b7d94c9e2749488$export$e7ec5c82995537b1)(Date.now());
        const msDuration = (0, $3cae43e231665f13$export$b22daef4119238cd).now() - this._performanceStartTime;
        return (0, $3b7d94c9e2749488$export$f07bb1dbc72184c3)(this.startTime, (0, $3b7d94c9e2749488$export$e7ec5c82995537b1)(msDuration));
    }
    isRecording() {
        return this._ended === false;
    }
    recordException(exception, time) {
        const attributes = {};
        if (typeof exception === 'string') attributes[0, $d77970ee83c3563c$export$ab4513c1b55519b5] = exception;
        else if (exception) {
            if (exception.code) attributes[0, $d77970ee83c3563c$export$85da07cb5d867763] = exception.code.toString();
            else if (exception.name) attributes[0, $d77970ee83c3563c$export$85da07cb5d867763] = exception.name;
            if (exception.message) attributes[0, $d77970ee83c3563c$export$ab4513c1b55519b5] = exception.message;
            if (exception.stack) attributes[0, $d77970ee83c3563c$export$9b74e4928364b671] = exception.stack;
        }
        // these are minimum requirements from spec
        if (attributes[0, $d77970ee83c3563c$export$85da07cb5d867763] || attributes[0, $d77970ee83c3563c$export$ab4513c1b55519b5]) this.addEvent((0, $1ecab79120c00c83$export$a0fff09a5370d06f), attributes, time);
        else (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Failed to record an exception ${exception}`);
    }
    get duration() {
        return this._duration;
    }
    get ended() {
        return this._ended;
    }
    get droppedAttributesCount() {
        return this._droppedAttributesCount;
    }
    get droppedEventsCount() {
        return this._droppedEventsCount;
    }
    get droppedLinksCount() {
        return this._droppedLinksCount;
    }
    _isSpanEnded() {
        if (this._ended) {
            const error = new Error(`Operation attempted on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`);
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Cannot execute the operation on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`, error);
        }
        return this._ended;
    }
    // Utility function to truncate given value within size
    // for value type of string, will truncate to given limit
    // for type of non-string, will return same value
    _truncateToLimitUtil(value, limit) {
        if (value.length <= limit) return value;
        return value.substring(0, limit);
    }
    /**
     * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
     * return string with truncated to {@code attributeValueLengthLimit} characters
     *
     * If the given attribute value is array of strings then
     * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
     *
     * Otherwise return same Attribute {@code value}
     *
     * @param value Attribute value
     * @returns truncated attribute value if required, otherwise same value
     */ _truncateToSize(value) {
        const limit = this._attributeValueLengthLimit;
        // Check limit
        if (limit <= 0) {
            // Negative values are invalid, so do not truncate
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Attribute value limit must be positive, got ${limit}`);
            return value;
        }
        // String
        if (typeof value === 'string') return this._truncateToLimitUtil(value, limit);
        // Array of strings
        if (Array.isArray(value)) return value.map((val)=>typeof val === 'string' ? this._truncateToLimitUtil(val, limit) : val);
        // Other types, no need to apply value length limit
        return value;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $9e1b4e663c9889e9$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($9e1b4e663c9889e9$export$94df7a7a96a92f7b || ($9e1b4e663c9889e9$export$94df7a7a96a92f7b = {}));


class $db3ff6a2c664450e$export$abc5f11618c4d6a3 {
    shouldSample() {
        return {
            decision: (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).NOT_RECORD
        };
    }
    toString() {
        return 'AlwaysOffSampler';
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $f0144350595f9729$export$653f832afb4ffa27 {
    shouldSample() {
        return {
            decision: (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED
        };
    }
    toString() {
        return 'AlwaysOnSampler';
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 



class $4c6db2f48508c435$export$2bc0b1b09c2e3b47 {
    _root;
    _remoteParentSampled;
    _remoteParentNotSampled;
    _localParentSampled;
    _localParentNotSampled;
    constructor(config){
        this._root = config.root;
        if (!this._root) {
            (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(new Error('ParentBasedSampler must have a root sampler configured'));
            this._root = new (0, $f0144350595f9729$export$653f832afb4ffa27)();
        }
        this._remoteParentSampled = config.remoteParentSampled ?? new (0, $f0144350595f9729$export$653f832afb4ffa27)();
        this._remoteParentNotSampled = config.remoteParentNotSampled ?? new (0, $db3ff6a2c664450e$export$abc5f11618c4d6a3)();
        this._localParentSampled = config.localParentSampled ?? new (0, $f0144350595f9729$export$653f832afb4ffa27)();
        this._localParentNotSampled = config.localParentNotSampled ?? new (0, $db3ff6a2c664450e$export$abc5f11618c4d6a3)();
    }
    shouldSample(context, traceId, spanName, spanKind, attributes, links) {
        const parentContext = (0, $a1569335aa614ed8$export$357889f174732d38).getSpanContext(context);
        if (!parentContext || !(0, $a89fc3550e8ac673$export$e4373b9a2c09216c)(parentContext)) return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & (0, $974e5505212bea35$export$bf9049ad2b0883ff).SAMPLED) return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & (0, $974e5505212bea35$export$bf9049ad2b0883ff).SAMPLED) return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    }
    toString() {
        return `ParentBased{root=${this._root.toString()}, remoteParentSampled=${this._remoteParentSampled.toString()}, remoteParentNotSampled=${this._remoteParentNotSampled.toString()}, localParentSampled=${this._localParentSampled.toString()}, localParentNotSampled=${this._localParentNotSampled.toString()}}`;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 

class $32a5444161ac9353$export$f1624f887f708bbf {
    _ratio;
    _upperBound;
    constructor(ratio = 0){
        this._ratio = this._normalize(ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    shouldSample(context, traceId) {
        return {
            decision: (0, $a89fc3550e8ac673$export$29dd34cf1269f6da)(traceId) && this._accumulate(traceId) < this._upperBound ? (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED : (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).NOT_RECORD
        };
    }
    toString() {
        return `TraceIdRatioBased{${this._ratio}}`;
    }
    _normalize(ratio) {
        if (typeof ratio !== 'number' || isNaN(ratio)) return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    }
    _accumulate(traceId) {
        let accumulation = 0;
        for(let i = 0; i < 32; i += 8){
            let part = 0;
            for(let j = 0; j < 8; j++){
                const c = traceId.charCodeAt(i + j);
                // Convert hex char code to value: '0'-'9' -> 0-9, 'a'-'f' -> 10-15, 'A'-'F' -> 10-15
                const v = c < 58 ? c - 48 : c < 71 ? c - 55 : c - 87;
                part = part << 4 | v;
            }
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    }
}


var $9da0721ed781558b$var$TracesSamplerValues;
(function(TracesSamplerValues) {
    TracesSamplerValues["AlwaysOff"] = "always_off";
    TracesSamplerValues["AlwaysOn"] = "always_on";
    TracesSamplerValues["ParentBasedAlwaysOff"] = "parentbased_always_off";
    TracesSamplerValues["ParentBasedAlwaysOn"] = "parentbased_always_on";
    TracesSamplerValues["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
    TracesSamplerValues["TraceIdRatio"] = "traceidratio";
})($9da0721ed781558b$var$TracesSamplerValues || ($9da0721ed781558b$var$TracesSamplerValues = {}));
const $9da0721ed781558b$var$DEFAULT_RATIO = 1;
function $9da0721ed781558b$export$d25a2c2f78a5e968() {
    return {
        sampler: $9da0721ed781558b$export$534308d7e73f0e71(),
        forceFlushTimeoutMillis: 30000,
        generalLimits: {
            attributeValueLengthLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? 128
        },
        spanLimits: {
            attributeValueLengthLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ?? 128,
            linkCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_LINK_COUNT_LIMIT') ?? 128,
            eventCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_EVENT_COUNT_LIMIT') ?? 128,
            attributePerEventCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT') ?? 128,
            attributePerLinkCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT') ?? 128
        }
    };
}
function $9da0721ed781558b$export$534308d7e73f0e71() {
    const sampler = (0, $10b6553ede829f91$export$c1cd528968868329)('OTEL_TRACES_SAMPLER') ?? $9da0721ed781558b$var$TracesSamplerValues.ParentBasedAlwaysOn;
    switch(sampler){
        case $9da0721ed781558b$var$TracesSamplerValues.AlwaysOn:
            return new (0, $f0144350595f9729$export$653f832afb4ffa27)();
        case $9da0721ed781558b$var$TracesSamplerValues.AlwaysOff:
            return new (0, $db3ff6a2c664450e$export$abc5f11618c4d6a3)();
        case $9da0721ed781558b$var$TracesSamplerValues.ParentBasedAlwaysOn:
            return new (0, $4c6db2f48508c435$export$2bc0b1b09c2e3b47)({
                root: new (0, $f0144350595f9729$export$653f832afb4ffa27)()
            });
        case $9da0721ed781558b$var$TracesSamplerValues.ParentBasedAlwaysOff:
            return new (0, $4c6db2f48508c435$export$2bc0b1b09c2e3b47)({
                root: new (0, $db3ff6a2c664450e$export$abc5f11618c4d6a3)()
            });
        case $9da0721ed781558b$var$TracesSamplerValues.TraceIdRatio:
            return new (0, $32a5444161ac9353$export$f1624f887f708bbf)($9da0721ed781558b$var$getSamplerProbabilityFromEnv());
        case $9da0721ed781558b$var$TracesSamplerValues.ParentBasedTraceIdRatio:
            return new (0, $4c6db2f48508c435$export$2bc0b1b09c2e3b47)({
                root: new (0, $32a5444161ac9353$export$f1624f887f708bbf)($9da0721ed781558b$var$getSamplerProbabilityFromEnv())
            });
        default:
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER value "${sampler}" invalid, defaulting to "${$9da0721ed781558b$var$TracesSamplerValues.ParentBasedAlwaysOn}".`);
            return new (0, $4c6db2f48508c435$export$2bc0b1b09c2e3b47)({
                root: new (0, $f0144350595f9729$export$653f832afb4ffa27)()
            });
    }
}
function $9da0721ed781558b$var$getSamplerProbabilityFromEnv() {
    const probability = (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_TRACES_SAMPLER_ARG');
    if (probability == null) {
        (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER_ARG is blank, defaulting to ${$9da0721ed781558b$var$DEFAULT_RATIO}.`);
        return $9da0721ed781558b$var$DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER_ARG=${probability} was given, but it is out of range ([0..1]), defaulting to ${$9da0721ed781558b$var$DEFAULT_RATIO}.`);
        return $9da0721ed781558b$var$DEFAULT_RATIO;
    }
    return probability;
}



const $62df14f081748e93$export$6ad612be99f9ed48 = 128;
const $62df14f081748e93$export$d9446f3c1c12def1 = Infinity;
function $62df14f081748e93$export$7ec1ebcfa9d8bd6a(userConfig) {
    const perInstanceDefaults = {
        sampler: (0, $9da0721ed781558b$export$534308d7e73f0e71)()
    };
    const DEFAULT_CONFIG = (0, $9da0721ed781558b$export$d25a2c2f78a5e968)();
    const target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
function $62df14f081748e93$export$9f9fb435f8494555(userConfig) {
    const spanLimits = Object.assign({}, userConfig.spanLimits);
    /**
     * Reassign span attribute count limit to use first non null value defined by user or use default value
     */ spanLimits.attributeCountLimit = userConfig.spanLimits?.attributeCountLimit ?? userConfig.generalLimits?.attributeCountLimit ?? (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ?? (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? $62df14f081748e93$export$6ad612be99f9ed48;
    /**
     * Reassign span attribute value length limit to use first non null value defined by user or use default value
     */ spanLimits.attributeValueLengthLimit = userConfig.spanLimits?.attributeValueLengthLimit ?? userConfig.generalLimits?.attributeValueLengthLimit ?? (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? $62df14f081748e93$export$d9446f3c1c12def1;
    return Object.assign({}, userConfig, {
        spanLimits: spanLimits
    });
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ const $2f32cfe3d924eea7$var$TRACE_ID_BYTES = 16;
const $2f32cfe3d924eea7$var$SPAN_ID_BYTES = 8;
const $2f32cfe3d924eea7$var$TRACE_BUFFER = new Uint8Array($2f32cfe3d924eea7$var$TRACE_ID_BYTES);
const $2f32cfe3d924eea7$var$SPAN_BUFFER = new Uint8Array($2f32cfe3d924eea7$var$SPAN_ID_BYTES);
// Byte-to-hex lookup is faster than toString(16) in browsers
const $2f32cfe3d924eea7$var$HEX = Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Fills buffer with random bytes, ensuring at least one is non-zero
 * per W3C Trace Context spec.
 */ function $2f32cfe3d924eea7$var$randomFill(buf) {
    for(let i = 0; i < buf.length; i++)buf[i] = Math.random() * 256 >>> 0;
    // Ensure non-zero
    for(let i = 0; i < buf.length; i++){
        if (buf[i] > 0) return;
    }
    buf[buf.length - 1] = 1;
}
function $2f32cfe3d924eea7$var$toHex(buf) {
    let hex = '';
    for(let i = 0; i < buf.length; i++)hex += $2f32cfe3d924eea7$var$HEX[buf[i]];
    return hex;
}
class $2f32cfe3d924eea7$export$97307207ef48da75 {
    /**
     * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
     * characters corresponding to 128 bits.
     */ generateTraceId() {
        $2f32cfe3d924eea7$var$randomFill($2f32cfe3d924eea7$var$TRACE_BUFFER);
        return $2f32cfe3d924eea7$var$toHex($2f32cfe3d924eea7$var$TRACE_BUFFER);
    }
    /**
     * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
     * characters corresponding to 64 bits.
     */ generateSpanId() {
        $2f32cfe3d924eea7$var$randomFill($2f32cfe3d924eea7$var$SPAN_BUFFER);
        return $2f32cfe3d924eea7$var$toHex($2f32cfe3d924eea7$var$SPAN_BUFFER);
    }
}



/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * Determines whether the span has a parent span, and if so, [whether it is a remote parent](https://opentelemetry.io/docs/specs/otel/trace/api/#isremote)
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 */ const $fa0d58093ae498d1$export$190c0dcbbd1976dc = 'otel.span.parent.origin';
const $fa0d58093ae498d1$export$45656fc405501e95 = 'otel.span.sampling_result';
const $fa0d58093ae498d1$export$d208cf7c95329204 = 'otel.sdk.span.live';
const $fa0d58093ae498d1$export$78513c92dcf9089e = 'otel.sdk.span.started';


class $f50184d1fdf4c682$export$c01f8c250afd9925 {
    startedSpans;
    liveSpans;
    constructor(meter){
        this.startedSpans = meter.createCounter((0, $fa0d58093ae498d1$export$78513c92dcf9089e), {
            unit: '{span}',
            description: 'The number of created spans.'
        });
        this.liveSpans = meter.createUpDownCounter((0, $fa0d58093ae498d1$export$d208cf7c95329204), {
            unit: '{span}',
            description: 'The number of currently live spans.'
        });
    }
    startSpan(parentSpanCtx, samplingDecision) {
        const samplingDecisionStr = $f50184d1fdf4c682$var$samplingDecisionToString(samplingDecision);
        this.startedSpans.add(1, {
            [(0, $fa0d58093ae498d1$export$190c0dcbbd1976dc)]: $f50184d1fdf4c682$var$parentOrigin(parentSpanCtx),
            [(0, $fa0d58093ae498d1$export$45656fc405501e95)]: samplingDecisionStr
        });
        if (samplingDecision === (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).NOT_RECORD) return ()=>{};
        const liveSpanAttributes = {
            [(0, $fa0d58093ae498d1$export$45656fc405501e95)]: samplingDecisionStr
        };
        this.liveSpans.add(1, liveSpanAttributes);
        return ()=>{
            this.liveSpans.add(-1, liveSpanAttributes);
        };
    }
}
function $f50184d1fdf4c682$var$parentOrigin(parentSpanContext) {
    if (!parentSpanContext) return 'none';
    if (parentSpanContext.isRemote) return 'remote';
    return 'local';
}
function $f50184d1fdf4c682$var$samplingDecisionToString(decision) {
    switch(decision){
        case (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED:
            return 'RECORD_AND_SAMPLE';
        case (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).RECORD:
            return 'RECORD_ONLY';
        case (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).NOT_RECORD:
            return 'DROP';
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $4e6e434d3ad5f16a$export$a4ad2735b021c132 = '2.7.1';


class $16238f2d0abda630$export$c4b9363e2fc65361 {
    _sampler;
    _generalLimits;
    _spanLimits;
    _idGenerator;
    instrumentationScope;
    _resource;
    _spanProcessor;
    _tracerMetrics;
    /**
     * Constructs a new Tracer instance.
     */ constructor(instrumentationScope, config, resource, spanProcessor){
        const localConfig = (0, $62df14f081748e93$export$7ec1ebcfa9d8bd6a)(config);
        this._sampler = localConfig.sampler;
        this._generalLimits = localConfig.generalLimits;
        this._spanLimits = localConfig.spanLimits;
        this._idGenerator = config.idGenerator || new (0, $2f32cfe3d924eea7$export$97307207ef48da75)();
        this._resource = resource;
        this._spanProcessor = spanProcessor;
        this.instrumentationScope = instrumentationScope;
        const meter = localConfig.meterProvider ? localConfig.meterProvider.getMeter('@opentelemetry/sdk-trace', (0, $4e6e434d3ad5f16a$export$a4ad2735b021c132)) : $59cde47689e48f33$export$bc3a498ccbb5c2b5();
        this._tracerMetrics = new (0, $f50184d1fdf4c682$export$c01f8c250afd9925)(meter);
    }
    /**
     * Starts a new Span or returns the default NoopSpan based on the sampling
     * decision.
     */ startSpan(name, options = {}, context = $e8248f70bfae46d0$export$a078c61943f9dbbe.active()) {
        // remove span from context in case a root span is requested via options
        if (options.root) context = $a1569335aa614ed8$export$357889f174732d38.deleteSpan(context);
        const parentSpan = $a1569335aa614ed8$export$357889f174732d38.getSpan(context);
        if ((0, $471a7169b32a4714$export$7d5f2376f7cf513)(context)) {
            $83ffbea8f4ffb90a$export$c042e7c2f59bc046.debug('Instrumentation suppressed, returning Noop Span');
            const nonRecordingSpan = $a1569335aa614ed8$export$357889f174732d38.wrapSpanContext($9c9f5532a1cced84$export$8591e4c852b66703);
            return nonRecordingSpan;
        }
        const parentSpanContext = parentSpan?.spanContext();
        const spanId = this._idGenerator.generateSpanId();
        let validParentSpanContext;
        let traceId;
        let traceState;
        if (!parentSpanContext || !$a1569335aa614ed8$export$357889f174732d38.isSpanContextValid(parentSpanContext)) // New root span.
        traceId = this._idGenerator.generateTraceId();
        else {
            // New child span.
            traceId = parentSpanContext.traceId;
            traceState = parentSpanContext.traceState;
            validParentSpanContext = parentSpanContext;
        }
        const spanKind = options.kind ?? $d03364baa5302116$export$4da4ea8145910e8b.INTERNAL;
        const links = (options.links ?? []).map((link)=>{
            return {
                context: link.context,
                attributes: (0, $ebedf3725a996547$export$b0663eba150d60c9)(link.attributes)
            };
        });
        const attributes = (0, $ebedf3725a996547$export$b0663eba150d60c9)(options.attributes);
        // make sampling decision
        const samplingResult = this._sampler.shouldSample(context, traceId, name, spanKind, attributes, links);
        const recordEndMetrics = this._tracerMetrics.startSpan(parentSpanContext, samplingResult.decision);
        traceState = samplingResult.traceState ?? traceState;
        const traceFlags = samplingResult.decision === $4be02e1161967f43$export$94df7a7a96a92f7b.RECORD_AND_SAMPLED ? $974e5505212bea35$export$bf9049ad2b0883ff.SAMPLED : $974e5505212bea35$export$bf9049ad2b0883ff.NONE;
        const spanContext = {
            traceId: traceId,
            spanId: spanId,
            traceFlags: traceFlags,
            traceState: traceState
        };
        if (samplingResult.decision === $4be02e1161967f43$export$94df7a7a96a92f7b.NOT_RECORD) {
            $83ffbea8f4ffb90a$export$c042e7c2f59bc046.debug('Recording is off, propagating context in a non-recording span');
            const nonRecordingSpan = $a1569335aa614ed8$export$357889f174732d38.wrapSpanContext(spanContext);
            return nonRecordingSpan;
        }
        // Set initial span attributes. The attributes object may have been mutated
        // by the sampler, so we sanitize the merged attributes before setting them.
        const initAttributes = (0, $ebedf3725a996547$export$b0663eba150d60c9)(Object.assign(attributes, samplingResult.attributes));
        const span = new (0, $38fde56e89775176$export$7b15d0c2dba75760)({
            resource: this._resource,
            scope: this.instrumentationScope,
            context: context,
            spanContext: spanContext,
            name: name,
            kind: spanKind,
            links: links,
            parentSpanContext: validParentSpanContext,
            attributes: initAttributes,
            startTime: options.startTime,
            spanProcessor: this._spanProcessor,
            spanLimits: this._spanLimits,
            recordEndMetrics: recordEndMetrics
        });
        return span;
    }
    startActiveSpan(name, arg2, arg3, arg4) {
        let opts;
        let ctx;
        let fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        const parentContext = ctx ?? $e8248f70bfae46d0$export$a078c61943f9dbbe.active();
        const span = this.startSpan(name, opts, parentContext);
        const contextWithSpanSet = $a1569335aa614ed8$export$357889f174732d38.setSpan(parentContext, span);
        return $e8248f70bfae46d0$export$a078c61943f9dbbe.with(contextWithSpanSet, fn, undefined, span);
    }
    /** Returns the active {@link GeneralLimits}. */ getGeneralLimits() {
        return this._generalLimits;
    }
    /** Returns the active {@link SpanLimits}. */ getSpanLimits() {
        return this._spanLimits;
    }
}



/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $050933715781aed5$export$3012fe5a49154394 {
    _spanProcessors;
    constructor(spanProcessors){
        this._spanProcessors = spanProcessors;
    }
    forceFlush() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.forceFlush());
        return new Promise((resolve)=>{
            Promise.all(promises).then(()=>{
                resolve();
            }).catch((error)=>{
                (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(error || new Error('MultiSpanProcessor: forceFlush failed'));
                resolve();
            });
        });
    }
    onStart(span, context) {
        for (const spanProcessor of this._spanProcessors)spanProcessor.onStart(span, context);
    }
    onEnding(span) {
        for (const spanProcessor of this._spanProcessors)if (spanProcessor.onEnding) spanProcessor.onEnding(span);
    }
    onEnd(span) {
        for (const spanProcessor of this._spanProcessors)spanProcessor.onEnd(span);
    }
    shutdown() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.shutdown());
        return new Promise((resolve, reject)=>{
            Promise.all(promises).then(()=>{
                resolve();
            }, reject);
        });
    }
}



var $710ba7bf983224dc$export$11a85395fcf5a7f0;
(function(ForceFlushState) {
    ForceFlushState[ForceFlushState["resolved"] = 0] = "resolved";
    ForceFlushState[ForceFlushState["timeout"] = 1] = "timeout";
    ForceFlushState[ForceFlushState["error"] = 2] = "error";
    ForceFlushState[ForceFlushState["unresolved"] = 3] = "unresolved";
})($710ba7bf983224dc$export$11a85395fcf5a7f0 || ($710ba7bf983224dc$export$11a85395fcf5a7f0 = {}));
class $710ba7bf983224dc$export$1f2f0f67f5ecff3b {
    _config;
    _tracers = new Map();
    _resource;
    _activeSpanProcessor;
    constructor(config = {}){
        const mergedConfig = (0, $13d6a7eb020acf9f$export$4950aa0f605343fb)({}, (0, $9da0721ed781558b$export$d25a2c2f78a5e968)(), (0, $62df14f081748e93$export$9f9fb435f8494555)(config));
        this._resource = mergedConfig.resource ?? (0, $f5d296ad825fd0d7$export$522a862cad1b0abc)();
        this._config = Object.assign({}, mergedConfig, {
            resource: this._resource
        });
        const spanProcessors = [];
        if (config.spanProcessors?.length) spanProcessors.push(...config.spanProcessors);
        this._activeSpanProcessor = new (0, $050933715781aed5$export$3012fe5a49154394)(spanProcessors);
    }
    getTracer(name, version, options) {
        const key = `${name}@${version || ''}:${options?.schemaUrl || ''}`;
        if (!this._tracers.has(key)) this._tracers.set(key, new (0, $16238f2d0abda630$export$c4b9363e2fc65361)({
            name: name,
            version: version,
            schemaUrl: options?.schemaUrl
        }, this._config, this._resource, this._activeSpanProcessor));
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this._tracers.get(key);
    }
    forceFlush() {
        const timeout = this._config.forceFlushTimeoutMillis;
        const promises = this._activeSpanProcessor['_spanProcessors'].map((spanProcessor)=>{
            return new Promise((resolve)=>{
                let state;
                const timeoutInterval = setTimeout(()=>{
                    resolve(new Error(`Span processor did not completed within timeout period of ${timeout} ms`));
                    state = $710ba7bf983224dc$export$11a85395fcf5a7f0.timeout;
                }, timeout);
                spanProcessor.forceFlush().then(()=>{
                    clearTimeout(timeoutInterval);
                    if (state !== $710ba7bf983224dc$export$11a85395fcf5a7f0.timeout) {
                        state = $710ba7bf983224dc$export$11a85395fcf5a7f0.resolved;
                        resolve(state);
                    }
                }).catch((error)=>{
                    clearTimeout(timeoutInterval);
                    state = $710ba7bf983224dc$export$11a85395fcf5a7f0.error;
                    resolve(error);
                });
            });
        });
        return new Promise((resolve, reject)=>{
            Promise.all(promises).then((results)=>{
                const errors = results.filter((result)=>result !== $710ba7bf983224dc$export$11a85395fcf5a7f0.resolved);
                if (errors.length > 0) reject(errors);
                else resolve();
            }).catch((error)=>reject([
                    error
                ]));
        });
    }
    shutdown() {
        return this._activeSpanProcessor.shutdown();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $b63f1664080b1a3e$export$3dfe62dd209faf13 {
    /**
     * whether the context manager is enabled or not
     */ _enabled = false;
    /**
     * Keeps the reference to current context
     */ _currentContext = (0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc);
    /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc), target) {
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
     * Returns the active context
     */ active() {
        return this._currentContext;
    }
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
     * Disable the context manager (clears the current context)
     */ disable() {
        this._currentContext = (0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc);
        this._enabled = false;
        return this;
    }
    /**
     * Enables the context manager and creates a default(root) context
     */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc);
        return this;
    }
    /**
     * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
     * The context will be set as active
     * @param context
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
}



/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $76b3906e377ff08a$export$4beb26f46770357f {
    _propagators;
    _fields;
    /**
     * Construct a composite propagator from a list of propagators.
     *
     * @param [config] Configuration object for composite propagator
     */ constructor(config = {}){
        this._propagators = config.propagators ?? [];
        const fields = new Set();
        for (const propagator of this._propagators){
            // older propagators may not have fields function, null check to be sure
            const propagatorFields = typeof propagator.fields === 'function' ? propagator.fields() : [];
            for (const field of propagatorFields)fields.add(field);
        }
        this._fields = Array.from(fields);
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same carrier key, the propagator later in the list
     * will "win".
     *
     * @param context Context to inject
     * @param carrier Carrier into which context will be injected
     */ inject(context, carrier, setter) {
        for (const propagator of this._propagators)try {
            propagator.inject(context, carrier, setter);
        } catch (err) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Failed to inject with ${propagator.constructor.name}. Err: ${err.message}`);
        }
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same context key, the propagator later in the list
     * will "win".
     *
     * @param context Context to add values to
     * @param carrier Carrier from which to extract context
     */ extract(context, carrier, getter) {
        return this._propagators.reduce((ctx, propagator)=>{
            try {
                return propagator.extract(ctx, carrier, getter);
            } catch (err) {
                (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Failed to extract with ${propagator.constructor.name}. Err: ${err.message}`);
            }
            return ctx;
        }, context);
    }
    fields() {
        // return a new array so our fields cannot be modified
        return this._fields.slice();
    }
}

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ const $fbacfa4ef56ce949$export$3043215ef908d54f = '=';
const $fbacfa4ef56ce949$export$393a3f9e6e76438 = ';';
const $fbacfa4ef56ce949$export$1ab471785c2cf557 = ',';
const $fbacfa4ef56ce949$export$a6199dd4fe419e69 = 'baggage';
const $fbacfa4ef56ce949$export$9a50757016085e99 = 180;
const $fbacfa4ef56ce949$export$c7d9e39bb295c1f = 4096;
const $fbacfa4ef56ce949$export$dd0527bee1f518e7 = 8192;




function $689905a4a385e271$export$790fc82b2ff5bf87(keyPairs) {
    return keyPairs.reduce((hValue, current)=>{
        const value = `${hValue}${hValue !== '' ? (0, $fbacfa4ef56ce949$export$1ab471785c2cf557) : ''}${current}`;
        return value.length > (0, $fbacfa4ef56ce949$export$dd0527bee1f518e7) ? hValue : value;
    }, '');
}
function $689905a4a385e271$export$ed4c06f0919b1951(baggage) {
    return baggage.getAllEntries().map(([key, value])=>{
        let entry = `${encodeURIComponent(key)}=${encodeURIComponent(value.value)}`;
        // include opaque metadata if provided
        // NOTE: we intentionally don't URI-encode the metadata - that responsibility falls on the metadata implementation
        if (value.metadata !== undefined) entry += (0, $fbacfa4ef56ce949$export$393a3f9e6e76438) + value.metadata.toString();
        return entry;
    });
}
function $689905a4a385e271$export$62659c450b08e504(entry) {
    if (!entry) return;
    const metadataSeparatorIndex = entry.indexOf((0, $fbacfa4ef56ce949$export$393a3f9e6e76438));
    const keyPairPart = metadataSeparatorIndex === -1 ? entry : entry.substring(0, metadataSeparatorIndex);
    const separatorIndex = keyPairPart.indexOf((0, $fbacfa4ef56ce949$export$3043215ef908d54f));
    if (separatorIndex <= 0) return;
    const rawKey = keyPairPart.substring(0, separatorIndex).trim();
    const rawValue = keyPairPart.substring(separatorIndex + 1).trim();
    if (!rawKey || !rawValue) return;
    let key;
    let value;
    try {
        key = decodeURIComponent(rawKey);
        value = decodeURIComponent(rawValue);
    } catch  {
        return;
    }
    let metadata;
    if (metadataSeparatorIndex !== -1 && metadataSeparatorIndex < entry.length - 1) {
        const metadataString = entry.substring(metadataSeparatorIndex + 1);
        metadata = (0, $6435a4ae4b78a9aa$export$c491cedc1b2b6e9e)(metadataString);
    }
    return {
        key: key,
        value: value,
        metadata: metadata
    };
}
function $689905a4a385e271$export$1259660ed6830e21(value) {
    const result = {};
    if (typeof value === 'string' && value.length > 0) value.split((0, $fbacfa4ef56ce949$export$1ab471785c2cf557)).forEach((entry)=>{
        const keyPair = $689905a4a385e271$export$62659c450b08e504(entry);
        if (keyPair !== undefined && keyPair.value.length > 0) result[keyPair.key] = keyPair.value;
    });
    return result;
}


class $e8cd774804f15da5$export$604bcc7f2bff6bb {
    inject(context, carrier, setter) {
        const baggage = (0, $c76b4b4057b01033$export$3e49040daa9dba20).getBaggage(context);
        if (!baggage || (0, $471a7169b32a4714$export$7d5f2376f7cf513)(context)) return;
        const keyPairs = (0, $689905a4a385e271$export$ed4c06f0919b1951)(baggage).filter((pair)=>{
            return pair.length <= (0, $fbacfa4ef56ce949$export$c7d9e39bb295c1f);
        }).slice(0, (0, $fbacfa4ef56ce949$export$9a50757016085e99));
        const headerValue = (0, $689905a4a385e271$export$790fc82b2ff5bf87)(keyPairs);
        if (headerValue.length > 0) setter.set(carrier, (0, $fbacfa4ef56ce949$export$a6199dd4fe419e69), headerValue);
    }
    extract(context, carrier, getter) {
        const headerValue = getter.get(carrier, (0, $fbacfa4ef56ce949$export$a6199dd4fe419e69));
        const baggageString = Array.isArray(headerValue) ? headerValue.join((0, $fbacfa4ef56ce949$export$1ab471785c2cf557)) : headerValue;
        if (!baggageString) return context;
        const baggage = {};
        if (baggageString.length === 0) return context;
        const pairs = baggageString.split((0, $fbacfa4ef56ce949$export$1ab471785c2cf557));
        pairs.forEach((entry)=>{
            const keyPair = (0, $689905a4a385e271$export$62659c450b08e504)(entry);
            if (keyPair) {
                const baggageEntry = {
                    value: keyPair.value
                };
                if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) return context;
        return (0, $c76b4b4057b01033$export$3e49040daa9dba20).setBaggage(context, (0, $c76b4b4057b01033$export$3e49040daa9dba20).createBaggage(baggage));
    }
    fields() {
        return [
            (0, $fbacfa4ef56ce949$export$a6199dd4fe419e69)
        ];
    }
}

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ const $d1957f4cd46ea820$var$VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
const $d1957f4cd46ea820$var$VALID_KEY = `[a-z]${$d1957f4cd46ea820$var$VALID_KEY_CHAR_RANGE}{0,255}`;
const $d1957f4cd46ea820$var$VALID_VENDOR_KEY = `[a-z0-9]${$d1957f4cd46ea820$var$VALID_KEY_CHAR_RANGE}{0,240}@[a-z]${$d1957f4cd46ea820$var$VALID_KEY_CHAR_RANGE}{0,13}`;
const $d1957f4cd46ea820$var$VALID_KEY_REGEX = new RegExp(`^(?:${$d1957f4cd46ea820$var$VALID_KEY}|${$d1957f4cd46ea820$var$VALID_VENDOR_KEY})$`);
const $d1957f4cd46ea820$var$VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
const $d1957f4cd46ea820$var$INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function $d1957f4cd46ea820$export$469cc9c479301ba6(key) {
    return $d1957f4cd46ea820$var$VALID_KEY_REGEX.test(key);
}
function $d1957f4cd46ea820$export$b76e9316566cc26e(value) {
    return $d1957f4cd46ea820$var$VALID_VALUE_BASE_REGEX.test(value) && !$d1957f4cd46ea820$var$INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}


const $94923c0d7cbee9c3$var$MAX_TRACE_STATE_ITEMS = 32;
const $94923c0d7cbee9c3$var$MAX_TRACE_STATE_LEN = 512;
const $94923c0d7cbee9c3$var$LIST_MEMBERS_SEPARATOR = ',';
const $94923c0d7cbee9c3$var$LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
class $94923c0d7cbee9c3$export$b0addedc390b67c2 {
    _length;
    _rawTraceState;
    _internalState;
    constructor(rawTraceState){
        this._rawTraceState = typeof rawTraceState === 'string' ? rawTraceState : '';
        this._length = this._rawTraceState.length;
    }
    set(key, value) {
        if (!(0, $d1957f4cd46ea820$export$469cc9c479301ba6)(key) || !(0, $d1957f4cd46ea820$export$b76e9316566cc26e)(value)) return this;
        const currState = this._getState();
        const currValue = currState.get(key);
        // Get the new length depending if we already have a value or not
        // - for existing keys we add the difference between the length of the values
        // - for new keys is the key & value lenght plus
        //   - +1 for the key/value splitter
        //   - +1 for the separator if there are other keys
        let newLength = this._length;
        if (typeof currValue === 'string') newLength += value.length - currValue.length;
        else newLength += key.length + value.length + (currState.size > 0 ? 2 : 1);
        if (newLength > $94923c0d7cbee9c3$var$MAX_TRACE_STATE_LEN) return this;
        const newState = new Map(currState);
        newState.delete(key);
        newState.set(key, value);
        return this._fromState(newState, newLength);
    }
    unset(key) {
        const currState = this._getState();
        const currValue = currState.get(key);
        // No need to create a new instance if the key does not exist
        if (typeof currValue !== 'string') return this;
        // Get the new length depending if we already have a value or not
        // - for existing keys we substract key and value length plus
        //   - +1 for the key/value splitter
        //   - +1 for the separator if there are other keys
        let newLength = this._length - (key.length + currValue.length + 1);
        if (currState.size > 1) // remove separator from length if there's no key or only one.
        newLength = newLength - 1;
        const newState = new Map(currState);
        newState.delete(key);
        return this._fromState(newState, newLength);
    }
    get(key) {
        const currState = this._getState();
        return currState.get(key);
    }
    serialize() {
        // Maps put new entries at the end. We prepend the seralized entry
        // to get the right order according to the spec (updated members go 1st)
        let serialized = '';
        let index = 0;
        for (const entry of this._getState()){
            if (index > 0) serialized = $94923c0d7cbee9c3$var$LIST_MEMBERS_SEPARATOR + serialized;
            serialized = `${entry[0]}${$94923c0d7cbee9c3$var$LIST_MEMBER_KEY_VALUE_SPLITTER}${entry[1]}` + serialized;
            index++;
        }
        return serialized;
    }
    _getState() {
        if (this._internalState) return this._internalState;
        // Not parsed yet, lets do it
        const vendorMembers = this._rawTraceState.split($94923c0d7cbee9c3$var$LIST_MEMBERS_SEPARATOR);
        // This Map will have the order reversed
        const vendorEntries = new Map();
        let currentLength = 0;
        for (const member of vendorMembers){
            const m = member.trim();
            const idx = m.indexOf($94923c0d7cbee9c3$var$LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (idx === -1) continue;
            const key = m.slice(0, idx);
            const value = m.slice(idx + 1);
            if (!(0, $d1957f4cd46ea820$export$469cc9c479301ba6)(key) || !(0, $d1957f4cd46ea820$export$b76e9316566cc26e)(value)) continue;
            // Skip if adding the new member exceeds the length
            const futureLength = currentLength + m.length + (vendorEntries.size > 0 ? 1 : 0);
            if (futureLength > $94923c0d7cbee9c3$var$MAX_TRACE_STATE_LEN) continue;
            // All good, add it
            vendorEntries.set(key, value);
            currentLength = futureLength;
            // Check if we reached the max items
            if (vendorEntries.size >= $94923c0d7cbee9c3$var$MAX_TRACE_STATE_ITEMS) break;
        }
        // Now we set the length & the Map in the right order
        this._length = currentLength;
        this._internalState = new Map(Array.from(vendorEntries.entries()).reverse());
        return this._internalState;
    }
    _fromState(state, length) {
        const traceState = Object.create($94923c0d7cbee9c3$export$b0addedc390b67c2.prototype);
        traceState._internalState = state;
        traceState._length = length;
        return traceState;
    }
}


const $053891bfb7ff6443$export$830e05fa2746348 = 'traceparent';
const $053891bfb7ff6443$export$2b12ed38dcfae2ae = 'tracestate';
const $053891bfb7ff6443$var$VERSION = '00';
const $053891bfb7ff6443$var$VERSION_PART = '(?!ff)[\\da-f]{2}';
const $053891bfb7ff6443$var$TRACE_ID_PART = '(?![0]{32})[\\da-f]{32}';
const $053891bfb7ff6443$var$PARENT_ID_PART = '(?![0]{16})[\\da-f]{16}';
const $053891bfb7ff6443$var$FLAGS_PART = '[\\da-f]{2}';
const $053891bfb7ff6443$var$TRACE_PARENT_REGEX = new RegExp(`^\\s?(${$053891bfb7ff6443$var$VERSION_PART})-(${$053891bfb7ff6443$var$TRACE_ID_PART})-(${$053891bfb7ff6443$var$PARENT_ID_PART})-(${$053891bfb7ff6443$var$FLAGS_PART})(-.*)?\\s?$`);
function $053891bfb7ff6443$export$f4d87f8901a93f5d(traceParent) {
    const match = $053891bfb7ff6443$var$TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    // According to the specification the implementation should be compatible
    // with future versions. If there are more parts, we only reject it if it's using version 00
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    if (match[1] === '00' && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
class $053891bfb7ff6443$export$737c747d043a1f7b {
    inject(context, carrier, setter) {
        const spanContext = (0, $a1569335aa614ed8$export$357889f174732d38).getSpanContext(context);
        if (!spanContext || (0, $471a7169b32a4714$export$7d5f2376f7cf513)(context) || !(0, $a89fc3550e8ac673$export$e4373b9a2c09216c)(spanContext)) return;
        const traceParent = `${$053891bfb7ff6443$var$VERSION}-${spanContext.traceId}-${spanContext.spanId}-0${Number(spanContext.traceFlags || (0, $974e5505212bea35$export$bf9049ad2b0883ff).NONE).toString(16)}`;
        setter.set(carrier, $053891bfb7ff6443$export$830e05fa2746348, traceParent);
        if (spanContext.traceState) setter.set(carrier, $053891bfb7ff6443$export$2b12ed38dcfae2ae, spanContext.traceState.serialize());
    }
    extract(context, carrier, getter) {
        const traceParentHeader = getter.get(carrier, $053891bfb7ff6443$export$830e05fa2746348);
        if (!traceParentHeader) return context;
        const traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== 'string') return context;
        const spanContext = $053891bfb7ff6443$export$f4d87f8901a93f5d(traceParent);
        if (!spanContext) return context;
        spanContext.isRemote = true;
        const traceStateHeader = getter.get(carrier, $053891bfb7ff6443$export$2b12ed38dcfae2ae);
        if (traceStateHeader) {
            // If more than one `tracestate` header is found, we merge them into a
            // single header.
            const state = Array.isArray(traceStateHeader) ? traceStateHeader.join(',') : traceStateHeader;
            spanContext.traceState = new (0, $94923c0d7cbee9c3$export$b0addedc390b67c2)(typeof state === 'string' ? state : undefined);
        }
        return (0, $a1569335aa614ed8$export$357889f174732d38).setSpanContext(context, spanContext);
    }
    fields() {
        return [
            $053891bfb7ff6443$export$830e05fa2746348,
            $053891bfb7ff6443$export$2b12ed38dcfae2ae
        ];
    }
}


function $bebde9d422ce0bc5$var$setupContextManager(contextManager) {
    // null means 'do not register'
    if (contextManager === null) return;
    // undefined means 'register default'
    if (contextManager === undefined) {
        const defaultContextManager = new (0, $b63f1664080b1a3e$export$3dfe62dd209faf13)();
        defaultContextManager.enable();
        (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).setGlobalContextManager(defaultContextManager);
        return;
    }
    contextManager.enable();
    (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).setGlobalContextManager(contextManager);
}
function $bebde9d422ce0bc5$var$setupPropagator(propagator) {
    // null means 'do not register'
    if (propagator === null) return;
    // undefined means 'register default'
    if (propagator === undefined) {
        (0, $c76b4b4057b01033$export$3e49040daa9dba20).setGlobalPropagator(new (0, $76b3906e377ff08a$export$4beb26f46770357f)({
            propagators: [
                new (0, $053891bfb7ff6443$export$737c747d043a1f7b)(),
                new (0, $e8cd774804f15da5$export$604bcc7f2bff6bb)()
            ]
        }));
        return;
    }
    (0, $c76b4b4057b01033$export$3e49040daa9dba20).setGlobalPropagator(propagator);
}
class $bebde9d422ce0bc5$export$a785009afeee3453 extends (0, $710ba7bf983224dc$export$1f2f0f67f5ecff3b) {
    /**
     * Constructs a new Tracer instance.
     * @param config Web Tracer config
     */ constructor(config = {}){
        super(config);
    }
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */ register(config = {}) {
        (0, $a1569335aa614ed8$export$357889f174732d38).setGlobalTracerProvider(this);
        $bebde9d422ce0bc5$var$setupPropagator(config.propagator);
        $bebde9d422ce0bc5$var$setupContextManager(config.contextManager);
    }
}




/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 




/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api and
// @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
const $a28b402d42900208$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};


const $05013fa1f9162463$export$be5e405504011951 = Symbol.for('io.opentelemetry.js.api.logs');
const $05013fa1f9162463$export$fb1208122242c205 = (0, $a28b402d42900208$export$5c524ddf7208c00c);
function $05013fa1f9162463$export$bf9e00ce1090794f(requiredVersion, instance, fallback) {
    return (version)=>version === requiredVersion ? instance : fallback;
}
const $05013fa1f9162463$export$41e8763f7160bb4 = 1;


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9673c718054f4a12$export$d16ba98760c74dd5 {
    emit(_logRecord) {}
}
const $9673c718054f4a12$export$f5681b99b7ff4eb3 = new $9673c718054f4a12$export$d16ba98760c74dd5();


class $7c1cd101c067953c$export$8d7f6fb42e615208 {
    getLogger(_name, _version, _options) {
        return new (0, $9673c718054f4a12$export$d16ba98760c74dd5)();
    }
}
const $7c1cd101c067953c$export$ade97358fd6ba8df = new $7c1cd101c067953c$export$8d7f6fb42e615208();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $fd304e339819fa77$export$ed6b4cba4dd55d4b {
    constructor(_provider, name, version, options){
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    /**
     * Emit a log record. This method should only be used by log appenders.
     *
     * @param logRecord
     */ emit(logRecord) {
        this._getLogger().emit(logRecord);
    }
    /**
     * Try to get a logger from the proxy logger provider.
     * If the proxy logger provider has no delegate, return a noop logger.
     */ _getLogger() {
        if (this._delegate) return this._delegate;
        const logger = this._provider.getDelegateLogger(this.name, this.version, this.options);
        if (!logger) return 0, $9673c718054f4a12$export$f5681b99b7ff4eb3;
        this._delegate = logger;
        return this._delegate;
    }
}


class $a3c7d36eae4f51f3$export$f72276fc3bc2aaa4 {
    getLogger(name, version, options) {
        var _a;
        return (_a = this.getDelegateLogger(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $fd304e339819fa77$export$ed6b4cba4dd55d4b)(this, name, version, options);
    }
    getDelegate() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : (0, $7c1cd101c067953c$export$ade97358fd6ba8df);
    }
    /**
     * Set the delegate logger provider
     */ setDelegate(delegate) {
        this._delegate = delegate;
    }
    getDelegateLogger(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getLogger(name, version, options);
    }
}


class $5df2ce5aaebec81d$export$f8e63508eb6a0fc1 {
    constructor(){
        this._proxyLoggerProvider = new (0, $a3c7d36eae4f51f3$export$f72276fc3bc2aaa4)();
    }
    static getInstance() {
        if (!this._instance) this._instance = new $5df2ce5aaebec81d$export$f8e63508eb6a0fc1();
        return this._instance;
    }
    setGlobalLoggerProvider(provider) {
        if ((0, $05013fa1f9162463$export$fb1208122242c205)[0, $05013fa1f9162463$export$be5e405504011951]) return this.getLoggerProvider();
        (0, $05013fa1f9162463$export$fb1208122242c205)[0, $05013fa1f9162463$export$be5e405504011951] = (0, $05013fa1f9162463$export$bf9e00ce1090794f)((0, $05013fa1f9162463$export$41e8763f7160bb4), provider, (0, $7c1cd101c067953c$export$ade97358fd6ba8df));
        this._proxyLoggerProvider.setDelegate(provider);
        return provider;
    }
    /**
     * Returns the global logger provider.
     *
     * @returns LoggerProvider
     */ getLoggerProvider() {
        var _a, _b;
        return (_b = (_a = (0, $05013fa1f9162463$export$fb1208122242c205)[0, $05013fa1f9162463$export$be5e405504011951]) === null || _a === void 0 ? void 0 : _a.call((0, $05013fa1f9162463$export$fb1208122242c205), (0, $05013fa1f9162463$export$41e8763f7160bb4))) !== null && _b !== void 0 ? _b : this._proxyLoggerProvider;
    }
    /**
     * Returns a logger from the global logger provider.
     *
     * @returns Logger
     */ getLogger(name, version, options) {
        return this.getLoggerProvider().getLogger(name, version, options);
    }
    /** Remove the global logger provider */ disable() {
        delete (0, $05013fa1f9162463$export$fb1208122242c205)[0, $05013fa1f9162463$export$be5e405504011951];
        this._proxyLoggerProvider = new (0, $a3c7d36eae4f51f3$export$f72276fc3bc2aaa4)();
    }
}


const $4c324fea8a388f6e$export$fa0831f497706bad = (0, $5df2ce5aaebec81d$export$f8e63508eb6a0fc1).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Enable instrumentations
 * @param instrumentations
 * @param tracerProvider
 * @param meterProvider
 */ function $5979010bab2f60f6$export$56a6415128a54b1(instrumentations, tracerProvider, meterProvider, loggerProvider) {
    for(let i = 0, j = instrumentations.length; i < j; i++){
        const instrumentation = instrumentations[i];
        if (tracerProvider) instrumentation.setTracerProvider(tracerProvider);
        if (meterProvider) instrumentation.setMeterProvider(meterProvider);
        if (loggerProvider && instrumentation.setLoggerProvider) instrumentation.setLoggerProvider(loggerProvider);
        // instrumentations have been already enabled during creation
        // so enable only if user prevented that by setting enabled to false
        // this is to prevent double enabling but when calling register all
        // instrumentations should be now enabled
        if (!instrumentation.getConfig().enabled) instrumentation.enable();
    }
}
function $5979010bab2f60f6$export$c7d87b302116dc69(instrumentations) {
    instrumentations.forEach((instrumentation)=>instrumentation.disable());
}


function $2c0724552941680d$export$fc0a1ca5231d826a(options) {
    const tracerProvider = options.tracerProvider || (0, $a1569335aa614ed8$export$357889f174732d38).getTracerProvider();
    const meterProvider = options.meterProvider || (0, $33f59e57c604672a$export$b0c5c2fac8144e54).getMeterProvider();
    const loggerProvider = options.loggerProvider || (0, $4c324fea8a388f6e$export$fa0831f497706bad).getLoggerProvider();
    const instrumentations = options.instrumentations?.flat() ?? [];
    (0, $5979010bab2f60f6$export$56a6415128a54b1)(instrumentations, tracerProvider, meterProvider, loggerProvider);
    return ()=>{
        (0, $5979010bab2f60f6$export$c7d87b302116dc69)(instrumentations);
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $f5e92f458368ef7c$exports = {};
'use strict';
function $f5e92f458368ef7c$var$isFunction(funktion) {
    return typeof funktion === 'function';
}
// Default to complaining loudly when things don't go according to plan.
var $f5e92f458368ef7c$var$logger = console.error.bind(console);
// Sets a property on an object, preserving its enumerability.
// This function assumes that the property is already writable.
function $f5e92f458368ef7c$var$defineProperty(obj, name, value) {
    var enumerable = !!obj[name] && obj.propertyIsEnumerable(name);
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value
    });
}
// Keep initialization idempotent.
function $f5e92f458368ef7c$var$shimmer(options) {
    if (options && options.logger) {
        if (!$f5e92f458368ef7c$var$isFunction(options.logger)) $f5e92f458368ef7c$var$logger("new logger isn't a function, not replacing");
        else $f5e92f458368ef7c$var$logger = options.logger;
    }
}
function $f5e92f458368ef7c$var$wrap(nodule, name, wrapper) {
    if (!nodule || !nodule[name]) {
        $f5e92f458368ef7c$var$logger('no original function ' + name + ' to wrap');
        return;
    }
    if (!wrapper) {
        $f5e92f458368ef7c$var$logger('no wrapper function');
        $f5e92f458368ef7c$var$logger(new Error().stack);
        return;
    }
    if (!$f5e92f458368ef7c$var$isFunction(nodule[name]) || !$f5e92f458368ef7c$var$isFunction(wrapper)) {
        $f5e92f458368ef7c$var$logger('original object and wrapper must be functions');
        return;
    }
    var original = nodule[name];
    var wrapped = wrapper(original, name);
    $f5e92f458368ef7c$var$defineProperty(wrapped, '__original', original);
    $f5e92f458368ef7c$var$defineProperty(wrapped, '__unwrap', function() {
        if (nodule[name] === wrapped) $f5e92f458368ef7c$var$defineProperty(nodule, name, original);
    });
    $f5e92f458368ef7c$var$defineProperty(wrapped, '__wrapped', true);
    $f5e92f458368ef7c$var$defineProperty(nodule, name, wrapped);
    return wrapped;
}
function $f5e92f458368ef7c$var$massWrap(nodules, names, wrapper) {
    if (!nodules) {
        $f5e92f458368ef7c$var$logger('must provide one or more modules to patch');
        $f5e92f458368ef7c$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $f5e92f458368ef7c$var$logger('must provide one or more functions to wrap on modules');
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            $f5e92f458368ef7c$var$wrap(nodule, name, wrapper);
        });
    });
}
function $f5e92f458368ef7c$var$unwrap(nodule, name) {
    if (!nodule || !nodule[name]) {
        $f5e92f458368ef7c$var$logger('no function to unwrap.');
        $f5e92f458368ef7c$var$logger(new Error().stack);
        return;
    }
    if (!nodule[name].__unwrap) $f5e92f458368ef7c$var$logger('no original to unwrap to -- has ' + name + ' already been unwrapped?');
    else return nodule[name].__unwrap();
}
function $f5e92f458368ef7c$var$massUnwrap(nodules, names) {
    if (!nodules) {
        $f5e92f458368ef7c$var$logger('must provide one or more modules to patch');
        $f5e92f458368ef7c$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $f5e92f458368ef7c$var$logger('must provide one or more functions to unwrap on modules');
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            $f5e92f458368ef7c$var$unwrap(nodule, name);
        });
    });
}
$f5e92f458368ef7c$var$shimmer.wrap = $f5e92f458368ef7c$var$wrap;
$f5e92f458368ef7c$var$shimmer.massWrap = $f5e92f458368ef7c$var$massWrap;
$f5e92f458368ef7c$var$shimmer.unwrap = $f5e92f458368ef7c$var$unwrap;
$f5e92f458368ef7c$var$shimmer.massUnwrap = $f5e92f458368ef7c$var$massUnwrap;
$f5e92f458368ef7c$exports = $f5e92f458368ef7c$var$shimmer;


class $b92650621f404eb3$export$74c31cfd4e541b89 {
    instrumentationName;
    instrumentationVersion;
    _config = {};
    _tracer;
    _meter;
    _logger;
    _diag;
    constructor(instrumentationName, instrumentationVersion, config){
        this.instrumentationName = instrumentationName;
        this.instrumentationVersion = instrumentationVersion;
        this.setConfig(config);
        this._diag = (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).createComponentLogger({
            namespace: instrumentationName
        });
        this._tracer = (0, $a1569335aa614ed8$export$357889f174732d38).getTracer(instrumentationName, instrumentationVersion);
        this._meter = (0, $33f59e57c604672a$export$b0c5c2fac8144e54).getMeter(instrumentationName, instrumentationVersion);
        this._logger = (0, $4c324fea8a388f6e$export$fa0831f497706bad).getLogger(instrumentationName, instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Api to wrap instrumented method */ _wrap = $f5e92f458368ef7c$exports.wrap;
    /* Api to unwrap instrumented methods */ _unwrap = $f5e92f458368ef7c$exports.unwrap;
    /* Api to mass wrap instrumented method */ _massWrap = $f5e92f458368ef7c$exports.massWrap;
    /* Api to mass unwrap instrumented methods */ _massUnwrap = $f5e92f458368ef7c$exports.massUnwrap;
    /* Returns meter */ get meter() {
        return this._meter;
    }
    /**
     * Sets MeterProvider to this plugin
     * @param meterProvider
     */ setMeterProvider(meterProvider) {
        this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Returns logger */ get logger() {
        return this._logger;
    }
    /**
     * Sets LoggerProvider to this plugin
     * @param loggerProvider
     */ setLoggerProvider(loggerProvider) {
        this._logger = loggerProvider.getLogger(this.instrumentationName, this.instrumentationVersion);
    }
    /**
     * @experimental
     *
     * Get module definitions defined by {@link init}.
     * This can be used for experimental compile-time instrumentation.
     *
     * @returns an array of {@link InstrumentationModuleDefinition}
     */ getModuleDefinitions() {
        const initResult = this.init() ?? [];
        if (!Array.isArray(initResult)) return [
            initResult
        ];
        return initResult;
    }
    /**
     * Sets the new metric instruments with the current Meter.
     */ _updateMetricInstruments() {
        return;
    }
    /* Returns InstrumentationConfig */ getConfig() {
        return this._config;
    }
    /**
     * Sets InstrumentationConfig to this plugin
     * @param config
     */ setConfig(config) {
        // copy config first level properties to ensure they are immutable.
        // nested properties are not copied, thus are mutable from the outside.
        this._config = {
            enabled: true,
            ...config
        };
    }
    /**
     * Sets TraceProvider to this plugin
     * @param tracerProvider
     */ setTracerProvider(tracerProvider) {
        this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
    }
    /* Returns tracer */ get tracer() {
        return this._tracer;
    }
    /**
     * Execute span customization hook, if configured, and log any errors.
     * Any semantics of the trigger and info are defined by the specific instrumentation.
     * @param hookHandler The optional hook handler which the user has configured via instrumentation config
     * @param triggerName The name of the trigger for executing the hook for logging purposes
     * @param span The span to which the hook should be applied
     * @param info The info object to be passed to the hook, with useful data the hook may use
     */ _runSpanCustomizationHook(hookHandler, triggerName, span, info) {
        if (!hookHandler) return;
        try {
            hookHandler(span, info);
        } catch (e) {
            this._diag.error(`Error running span customization hook due to exception in handler`, {
                triggerName: triggerName
            }, e);
        }
    }
}


class $be89eb9a2ed8d8a6$export$436b1c2bf7e9756b extends (0, $b92650621f404eb3$export$74c31cfd4e541b89) {
    constructor(instrumentationName, instrumentationVersion, config){
        super(instrumentationName, instrumentationVersion, config);
        if (this._config.enabled) this.enable();
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * function to execute patched function and being able to catch errors
 * @param execute - function to be executed
 * @param onFinish - callback to run when execute finishes
 */ function $e5045196367e2654$export$fdff7e10f8ca069e(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = execute();
    } catch (e) {
        error = e;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
async function $e5045196367e2654$export$75852fe3c08f1502(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = await execute();
    } catch (e) {
        error = e;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
function $e5045196367e2654$export$ec0fd572751979bc(func) {
    return typeof func === 'function' && typeof func.__original === 'function' && typeof func.__unwrap === 'function' && func.__wrapped === true;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
const $cf2085415f7cd9be$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a5b2d9a21101d5ac$export$c2a944331f80ae92(url, urlToMatch) {
    if (typeof urlToMatch === 'string') return url === urlToMatch;
    else return !!url.match(urlToMatch);
}
function $a5b2d9a21101d5ac$export$172b5a1c42a6f83d(url, ignoredUrls) {
    if (!ignoredUrls) return false;
    for (const ignoreUrl of ignoredUrls){
        if ($a5b2d9a21101d5ac$export$c2a944331f80ae92(url, ignoreUrl)) return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $07a8fc58179c2fd8$export$74be52df2d6fd28c;
(function(PerformanceTimingNames) {
    PerformanceTimingNames["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames["CONNECT_START"] = "connectStart";
    PerformanceTimingNames["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames["FETCH_START"] = "fetchStart";
    PerformanceTimingNames["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames["REQUEST_START"] = "requestStart";
    PerformanceTimingNames["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames["START_TIME"] = "startTime";
    PerformanceTimingNames["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames["UNLOAD_EVENT_START"] = "unloadEventStart";
})($07a8fc58179c2fd8$export$74be52df2d6fd28c || ($07a8fc58179c2fd8$export$74be52df2d6fd28c = {}));



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a const map from the given values
 * @param values - An array of values to be used as keys and values in the map.
 * @returns A populated version of the map with the values and keys derived from the values.
 */ /*#__NO_SIDE_EFFECTS__*/ function $af8983c0f76bcdfa$export$8796db7ca257d576(values) {
    // eslint-disable-next-line prefer-const, @typescript-eslint/no-explicit-any
    let res = {};
    const len = values.length;
    for(let lp = 0; lp < len; lp++){
        const val = values[lp];
        if (val) res[String(val).toUpperCase().replace(/[-.]/g, '_')] = val;
    }
    return res;
}


//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates//templates/SemanticAttributes.ts.j2
//----------------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------------
// Constant values for SemanticAttributes
//----------------------------------------------------------------------------------------------------------
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_AWS_LAMBDA_INVOKED_ARN = 'aws.lambda.invoked_arn';
const $6feacf3bb3931a8f$var$TMP_DB_SYSTEM = 'db.system';
const $6feacf3bb3931a8f$var$TMP_DB_CONNECTION_STRING = 'db.connection_string';
const $6feacf3bb3931a8f$var$TMP_DB_USER = 'db.user';
const $6feacf3bb3931a8f$var$TMP_DB_JDBC_DRIVER_CLASSNAME = 'db.jdbc.driver_classname';
const $6feacf3bb3931a8f$var$TMP_DB_NAME = 'db.name';
const $6feacf3bb3931a8f$var$TMP_DB_STATEMENT = 'db.statement';
const $6feacf3bb3931a8f$var$TMP_DB_OPERATION = 'db.operation';
const $6feacf3bb3931a8f$var$TMP_DB_MSSQL_INSTANCE_NAME = 'db.mssql.instance_name';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_KEYSPACE = 'db.cassandra.keyspace';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_PAGE_SIZE = 'db.cassandra.page_size';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL = 'db.cassandra.consistency_level';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_TABLE = 'db.cassandra.table';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_IDEMPOTENCE = 'db.cassandra.idempotence';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = 'db.cassandra.speculative_execution_count';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_ID = 'db.cassandra.coordinator.id';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_DC = 'db.cassandra.coordinator.dc';
const $6feacf3bb3931a8f$var$TMP_DB_HBASE_NAMESPACE = 'db.hbase.namespace';
const $6feacf3bb3931a8f$var$TMP_DB_REDIS_DATABASE_INDEX = 'db.redis.database_index';
const $6feacf3bb3931a8f$var$TMP_DB_MONGODB_COLLECTION = 'db.mongodb.collection';
const $6feacf3bb3931a8f$var$TMP_DB_SQL_TABLE = 'db.sql.table';
const $6feacf3bb3931a8f$var$TMP_EXCEPTION_TYPE = 'exception.type';
const $6feacf3bb3931a8f$var$TMP_EXCEPTION_MESSAGE = 'exception.message';
const $6feacf3bb3931a8f$var$TMP_EXCEPTION_STACKTRACE = 'exception.stacktrace';
const $6feacf3bb3931a8f$var$TMP_EXCEPTION_ESCAPED = 'exception.escaped';
const $6feacf3bb3931a8f$var$TMP_FAAS_TRIGGER = 'faas.trigger';
const $6feacf3bb3931a8f$var$TMP_FAAS_EXECUTION = 'faas.execution';
const $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_COLLECTION = 'faas.document.collection';
const $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_OPERATION = 'faas.document.operation';
const $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_TIME = 'faas.document.time';
const $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_NAME = 'faas.document.name';
const $6feacf3bb3931a8f$var$TMP_FAAS_TIME = 'faas.time';
const $6feacf3bb3931a8f$var$TMP_FAAS_CRON = 'faas.cron';
const $6feacf3bb3931a8f$var$TMP_FAAS_COLDSTART = 'faas.coldstart';
const $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_NAME = 'faas.invoked_name';
const $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_PROVIDER = 'faas.invoked_provider';
const $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_REGION = 'faas.invoked_region';
const $6feacf3bb3931a8f$var$TMP_NET_TRANSPORT = 'net.transport';
const $6feacf3bb3931a8f$var$TMP_NET_PEER_IP = 'net.peer.ip';
const $6feacf3bb3931a8f$var$TMP_NET_PEER_PORT = 'net.peer.port';
const $6feacf3bb3931a8f$var$TMP_NET_PEER_NAME = 'net.peer.name';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_IP = 'net.host.ip';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_PORT = 'net.host.port';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_NAME = 'net.host.name';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_TYPE = 'net.host.connection.type';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_SUBTYPE = 'net.host.connection.subtype';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_NAME = 'net.host.carrier.name';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MCC = 'net.host.carrier.mcc';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MNC = 'net.host.carrier.mnc';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_ICC = 'net.host.carrier.icc';
const $6feacf3bb3931a8f$var$TMP_PEER_SERVICE = 'peer.service';
const $6feacf3bb3931a8f$var$TMP_ENDUSER_ID = 'enduser.id';
const $6feacf3bb3931a8f$var$TMP_ENDUSER_ROLE = 'enduser.role';
const $6feacf3bb3931a8f$var$TMP_ENDUSER_SCOPE = 'enduser.scope';
const $6feacf3bb3931a8f$var$TMP_THREAD_ID = 'thread.id';
const $6feacf3bb3931a8f$var$TMP_THREAD_NAME = 'thread.name';
const $6feacf3bb3931a8f$var$TMP_CODE_FUNCTION = 'code.function';
const $6feacf3bb3931a8f$var$TMP_CODE_NAMESPACE = 'code.namespace';
const $6feacf3bb3931a8f$var$TMP_CODE_FILEPATH = 'code.filepath';
const $6feacf3bb3931a8f$var$TMP_CODE_LINENO = 'code.lineno';
const $6feacf3bb3931a8f$var$TMP_HTTP_METHOD = 'http.method';
const $6feacf3bb3931a8f$var$TMP_HTTP_URL = 'http.url';
const $6feacf3bb3931a8f$var$TMP_HTTP_TARGET = 'http.target';
const $6feacf3bb3931a8f$var$TMP_HTTP_HOST = 'http.host';
const $6feacf3bb3931a8f$var$TMP_HTTP_SCHEME = 'http.scheme';
const $6feacf3bb3931a8f$var$TMP_HTTP_STATUS_CODE = 'http.status_code';
const $6feacf3bb3931a8f$var$TMP_HTTP_FLAVOR = 'http.flavor';
const $6feacf3bb3931a8f$var$TMP_HTTP_USER_AGENT = 'http.user_agent';
const $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH = 'http.request_content_length';
const $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = 'http.request_content_length_uncompressed';
const $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH = 'http.response_content_length';
const $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = 'http.response_content_length_uncompressed';
const $6feacf3bb3931a8f$var$TMP_HTTP_SERVER_NAME = 'http.server_name';
const $6feacf3bb3931a8f$var$TMP_HTTP_ROUTE = 'http.route';
const $6feacf3bb3931a8f$var$TMP_HTTP_CLIENT_IP = 'http.client_ip';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_NAMES = 'aws.dynamodb.table_names';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY = 'aws.dynamodb.consumed_capacity';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = 'aws.dynamodb.item_collection_metrics';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = 'aws.dynamodb.provisioned_read_capacity';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = 'aws.dynamodb.provisioned_write_capacity';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSISTENT_READ = 'aws.dynamodb.consistent_read';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROJECTION = 'aws.dynamodb.projection';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LIMIT = 'aws.dynamodb.limit';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET = 'aws.dynamodb.attributes_to_get';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_INDEX_NAME = 'aws.dynamodb.index_name';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SELECT = 'aws.dynamodb.select';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = 'aws.dynamodb.global_secondary_indexes';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = 'aws.dynamodb.local_secondary_indexes';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = 'aws.dynamodb.exclusive_start_table';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_COUNT = 'aws.dynamodb.table_count';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCAN_FORWARD = 'aws.dynamodb.scan_forward';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SEGMENT = 'aws.dynamodb.segment';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS = 'aws.dynamodb.total_segments';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_COUNT = 'aws.dynamodb.count';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCANNED_COUNT = 'aws.dynamodb.scanned_count';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = 'aws.dynamodb.attribute_definitions';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = 'aws.dynamodb.global_secondary_index_updates';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_SYSTEM = 'messaging.system';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION = 'messaging.destination';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION_KIND = 'messaging.destination_kind';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_TEMP_DESTINATION = 'messaging.temp_destination';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL = 'messaging.protocol';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL_VERSION = 'messaging.protocol_version';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_URL = 'messaging.url';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_ID = 'messaging.message_id';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_CONVERSATION_ID = 'messaging.conversation_id';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = 'messaging.message_payload_size_bytes';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = 'messaging.message_payload_compressed_size_bytes';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_OPERATION = 'messaging.operation';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_CONSUMER_ID = 'messaging.consumer_id';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY = 'messaging.rabbitmq.routing_key';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY = 'messaging.kafka.message_key';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP = 'messaging.kafka.consumer_group';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CLIENT_ID = 'messaging.kafka.client_id';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_PARTITION = 'messaging.kafka.partition';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_TOMBSTONE = 'messaging.kafka.tombstone';
const $6feacf3bb3931a8f$var$TMP_RPC_SYSTEM = 'rpc.system';
const $6feacf3bb3931a8f$var$TMP_RPC_SERVICE = 'rpc.service';
const $6feacf3bb3931a8f$var$TMP_RPC_METHOD = 'rpc.method';
const $6feacf3bb3931a8f$var$TMP_RPC_GRPC_STATUS_CODE = 'rpc.grpc.status_code';
const $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_VERSION = 'rpc.jsonrpc.version';
const $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_REQUEST_ID = 'rpc.jsonrpc.request_id';
const $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_CODE = 'rpc.jsonrpc.error_code';
const $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_MESSAGE = 'rpc.jsonrpc.error_message';
const $6feacf3bb3931a8f$var$TMP_MESSAGE_TYPE = 'message.type';
const $6feacf3bb3931a8f$var$TMP_MESSAGE_ID = 'message.id';
const $6feacf3bb3931a8f$var$TMP_MESSAGE_COMPRESSED_SIZE = 'message.compressed_size';
const $6feacf3bb3931a8f$var$TMP_MESSAGE_UNCOMPRESSED_SIZE = 'message.uncompressed_size';
const $6feacf3bb3931a8f$export$170bb395abfdb74 = $6feacf3bb3931a8f$var$TMP_AWS_LAMBDA_INVOKED_ARN;
const $6feacf3bb3931a8f$export$4d8f9683caa766fd = $6feacf3bb3931a8f$var$TMP_DB_SYSTEM;
const $6feacf3bb3931a8f$export$d367aaf68e61a0d5 = $6feacf3bb3931a8f$var$TMP_DB_CONNECTION_STRING;
const $6feacf3bb3931a8f$export$310240ea93b3fe22 = $6feacf3bb3931a8f$var$TMP_DB_USER;
const $6feacf3bb3931a8f$export$aa8b483f52799ba9 = $6feacf3bb3931a8f$var$TMP_DB_JDBC_DRIVER_CLASSNAME;
const $6feacf3bb3931a8f$export$d1ee0266d0ce708f = $6feacf3bb3931a8f$var$TMP_DB_NAME;
const $6feacf3bb3931a8f$export$ce244300665216c6 = $6feacf3bb3931a8f$var$TMP_DB_STATEMENT;
const $6feacf3bb3931a8f$export$dfb6a782675c717b = $6feacf3bb3931a8f$var$TMP_DB_OPERATION;
const $6feacf3bb3931a8f$export$ce5040faeb6d8f08 = $6feacf3bb3931a8f$var$TMP_DB_MSSQL_INSTANCE_NAME;
const $6feacf3bb3931a8f$export$e241e7101e6d4783 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_KEYSPACE;
const $6feacf3bb3931a8f$export$8823a63ac409681b = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_PAGE_SIZE;
const $6feacf3bb3931a8f$export$b838c3d1859a7260 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL;
const $6feacf3bb3931a8f$export$3f3068d83ae4cca5 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_TABLE;
const $6feacf3bb3931a8f$export$17334025dcb96205 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_IDEMPOTENCE;
const $6feacf3bb3931a8f$export$a63f22381e3297f2 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT;
const $6feacf3bb3931a8f$export$e06ccece5268ed3 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_ID;
const $6feacf3bb3931a8f$export$ab77f08d0cc7144 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_DC;
const $6feacf3bb3931a8f$export$f83bf50700108cdb = $6feacf3bb3931a8f$var$TMP_DB_HBASE_NAMESPACE;
const $6feacf3bb3931a8f$export$f9c9b189f60bce02 = $6feacf3bb3931a8f$var$TMP_DB_REDIS_DATABASE_INDEX;
const $6feacf3bb3931a8f$export$b73e684c351bf304 = $6feacf3bb3931a8f$var$TMP_DB_MONGODB_COLLECTION;
const $6feacf3bb3931a8f$export$5b02e077c84b0dc7 = $6feacf3bb3931a8f$var$TMP_DB_SQL_TABLE;
const $6feacf3bb3931a8f$export$ecc84ea0f5a24384 = $6feacf3bb3931a8f$var$TMP_EXCEPTION_TYPE;
const $6feacf3bb3931a8f$export$ff69507dfa9dcf0c = $6feacf3bb3931a8f$var$TMP_EXCEPTION_MESSAGE;
const $6feacf3bb3931a8f$export$d9432f0c350b687d = $6feacf3bb3931a8f$var$TMP_EXCEPTION_STACKTRACE;
const $6feacf3bb3931a8f$export$4d3c212dd7c75f9d = $6feacf3bb3931a8f$var$TMP_EXCEPTION_ESCAPED;
const $6feacf3bb3931a8f$export$7e853a3dbd95b3a2 = $6feacf3bb3931a8f$var$TMP_FAAS_TRIGGER;
const $6feacf3bb3931a8f$export$68a5b08142e33c1d = $6feacf3bb3931a8f$var$TMP_FAAS_EXECUTION;
const $6feacf3bb3931a8f$export$f4b6288b42b8d4f8 = $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_COLLECTION;
const $6feacf3bb3931a8f$export$7e6d28b35ab8e751 = $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_OPERATION;
const $6feacf3bb3931a8f$export$b36094664197ebd9 = $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_TIME;
const $6feacf3bb3931a8f$export$2401d669e1b7f304 = $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_NAME;
const $6feacf3bb3931a8f$export$4630b1edb758007c = $6feacf3bb3931a8f$var$TMP_FAAS_TIME;
const $6feacf3bb3931a8f$export$4358b4189d5aa75e = $6feacf3bb3931a8f$var$TMP_FAAS_CRON;
const $6feacf3bb3931a8f$export$18a88fa49bf141a8 = $6feacf3bb3931a8f$var$TMP_FAAS_COLDSTART;
const $6feacf3bb3931a8f$export$ba620de28d483834 = $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_NAME;
const $6feacf3bb3931a8f$export$1ac1158b40ce77df = $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_PROVIDER;
const $6feacf3bb3931a8f$export$e8b3f54186b03f93 = $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_REGION;
const $6feacf3bb3931a8f$export$958ce88767ff5cae = $6feacf3bb3931a8f$var$TMP_NET_TRANSPORT;
const $6feacf3bb3931a8f$export$5f5e19d7784bcab5 = $6feacf3bb3931a8f$var$TMP_NET_PEER_IP;
const $6feacf3bb3931a8f$export$83ab392b303d5cc4 = $6feacf3bb3931a8f$var$TMP_NET_PEER_PORT;
const $6feacf3bb3931a8f$export$869dc6e245da8a3c = $6feacf3bb3931a8f$var$TMP_NET_PEER_NAME;
const $6feacf3bb3931a8f$export$8363f5dd3626d1c7 = $6feacf3bb3931a8f$var$TMP_NET_HOST_IP;
const $6feacf3bb3931a8f$export$7c05177443136588 = $6feacf3bb3931a8f$var$TMP_NET_HOST_PORT;
const $6feacf3bb3931a8f$export$67ebd91e5927c9b6 = $6feacf3bb3931a8f$var$TMP_NET_HOST_NAME;
const $6feacf3bb3931a8f$export$b4399aff72c58221 = $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_TYPE;
const $6feacf3bb3931a8f$export$29124138bf62c161 = $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_SUBTYPE;
const $6feacf3bb3931a8f$export$a1a35234333f42fa = $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_NAME;
const $6feacf3bb3931a8f$export$593e7f806b5bd9d0 = $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MCC;
const $6feacf3bb3931a8f$export$92c4882b0877ce0 = $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MNC;
const $6feacf3bb3931a8f$export$7158946157fdda52 = $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_ICC;
const $6feacf3bb3931a8f$export$706484bff197aa2f = $6feacf3bb3931a8f$var$TMP_PEER_SERVICE;
const $6feacf3bb3931a8f$export$37fdcbb3cc34507a = $6feacf3bb3931a8f$var$TMP_ENDUSER_ID;
const $6feacf3bb3931a8f$export$7486a34c0c780913 = $6feacf3bb3931a8f$var$TMP_ENDUSER_ROLE;
const $6feacf3bb3931a8f$export$c531f20a7a107be = $6feacf3bb3931a8f$var$TMP_ENDUSER_SCOPE;
const $6feacf3bb3931a8f$export$96304c684b1fe5bd = $6feacf3bb3931a8f$var$TMP_THREAD_ID;
const $6feacf3bb3931a8f$export$b1c76a722c30a73e = $6feacf3bb3931a8f$var$TMP_THREAD_NAME;
const $6feacf3bb3931a8f$export$f5b0a970f81eb82 = $6feacf3bb3931a8f$var$TMP_CODE_FUNCTION;
const $6feacf3bb3931a8f$export$ebd9bc6b684ae79f = $6feacf3bb3931a8f$var$TMP_CODE_NAMESPACE;
const $6feacf3bb3931a8f$export$f5c7dbf024e089b1 = $6feacf3bb3931a8f$var$TMP_CODE_FILEPATH;
const $6feacf3bb3931a8f$export$9bc82da636767e36 = $6feacf3bb3931a8f$var$TMP_CODE_LINENO;
const $6feacf3bb3931a8f$export$5ec7d06d671a3fbe = $6feacf3bb3931a8f$var$TMP_HTTP_METHOD;
const $6feacf3bb3931a8f$export$2f4ef7e39c2be395 = $6feacf3bb3931a8f$var$TMP_HTTP_URL;
const $6feacf3bb3931a8f$export$5284fc3356124326 = $6feacf3bb3931a8f$var$TMP_HTTP_TARGET;
const $6feacf3bb3931a8f$export$547e24d3f59a53ea = $6feacf3bb3931a8f$var$TMP_HTTP_HOST;
const $6feacf3bb3931a8f$export$a2928efa45f0acf4 = $6feacf3bb3931a8f$var$TMP_HTTP_SCHEME;
const $6feacf3bb3931a8f$export$d381c7525d715413 = $6feacf3bb3931a8f$var$TMP_HTTP_STATUS_CODE;
const $6feacf3bb3931a8f$export$1e443919b8f6a42e = $6feacf3bb3931a8f$var$TMP_HTTP_FLAVOR;
const $6feacf3bb3931a8f$export$7472b18f42d2d02f = $6feacf3bb3931a8f$var$TMP_HTTP_USER_AGENT;
const $6feacf3bb3931a8f$export$616f2909238995e9 = $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH;
const $6feacf3bb3931a8f$export$4352992cf528a286 = $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED;
const $6feacf3bb3931a8f$export$58d4fbfe35e08be0 = $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH;
const $6feacf3bb3931a8f$export$b9d3e41cd56c56cc = $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED;
const $6feacf3bb3931a8f$export$ae4c9cf5cd38f75e = $6feacf3bb3931a8f$var$TMP_HTTP_SERVER_NAME;
const $6feacf3bb3931a8f$export$391e30d1bcbfedd6 = $6feacf3bb3931a8f$var$TMP_HTTP_ROUTE;
const $6feacf3bb3931a8f$export$f21601c3f29048e9 = $6feacf3bb3931a8f$var$TMP_HTTP_CLIENT_IP;
const $6feacf3bb3931a8f$export$22c9c5cd37ccec8d = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_NAMES;
const $6feacf3bb3931a8f$export$636d932d69359471 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY;
const $6feacf3bb3931a8f$export$79414a2a1b36e0e4 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS;
const $6feacf3bb3931a8f$export$a17bc449a5f10183 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY;
const $6feacf3bb3931a8f$export$6d8e225848319009 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY;
const $6feacf3bb3931a8f$export$2daa7ca667f19522 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSISTENT_READ;
const $6feacf3bb3931a8f$export$d04f1e16b6682958 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROJECTION;
const $6feacf3bb3931a8f$export$9017e26d3dee82a7 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LIMIT;
const $6feacf3bb3931a8f$export$734476f2cddb4e = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET;
const $6feacf3bb3931a8f$export$6ffa6129be32f13f = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_INDEX_NAME;
const $6feacf3bb3931a8f$export$e439ba599235e943 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SELECT;
const $6feacf3bb3931a8f$export$691e052bf6ec1b50 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES;
const $6feacf3bb3931a8f$export$4a8114ba4973adf9 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES;
const $6feacf3bb3931a8f$export$3d3dcdb04b37b602 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE;
const $6feacf3bb3931a8f$export$a3ed03c10bfca049 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_COUNT;
const $6feacf3bb3931a8f$export$70f2263412a5d6f8 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCAN_FORWARD;
const $6feacf3bb3931a8f$export$cc291bca867c839c = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SEGMENT;
const $6feacf3bb3931a8f$export$2bd41520dd577767 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS;
const $6feacf3bb3931a8f$export$e3002f59defbb848 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_COUNT;
const $6feacf3bb3931a8f$export$338ee58c976503fa = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCANNED_COUNT;
const $6feacf3bb3931a8f$export$9ef2d520d3111ebb = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS;
const $6feacf3bb3931a8f$export$50eb8413f579535b = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES;
const $6feacf3bb3931a8f$export$e907440d5c8aa7ea = $6feacf3bb3931a8f$var$TMP_MESSAGING_SYSTEM;
const $6feacf3bb3931a8f$export$331bf1abb96af02c = $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION;
const $6feacf3bb3931a8f$export$ca3944a0a0fdb278 = $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION_KIND;
const $6feacf3bb3931a8f$export$b1f595d071164a5c = $6feacf3bb3931a8f$var$TMP_MESSAGING_TEMP_DESTINATION;
const $6feacf3bb3931a8f$export$734e634f7ff28b65 = $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL;
const $6feacf3bb3931a8f$export$62c96eec39d4f8fa = $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL_VERSION;
const $6feacf3bb3931a8f$export$8185788dec47d17c = $6feacf3bb3931a8f$var$TMP_MESSAGING_URL;
const $6feacf3bb3931a8f$export$6465ca78c6aedebd = $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_ID;
const $6feacf3bb3931a8f$export$9e29dbd41c4d02d5 = $6feacf3bb3931a8f$var$TMP_MESSAGING_CONVERSATION_ID;
const $6feacf3bb3931a8f$export$ded3a3185a1522d5 = $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES;
const $6feacf3bb3931a8f$export$c42edeca94088e4d = $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES;
const $6feacf3bb3931a8f$export$b0a29003262c7994 = $6feacf3bb3931a8f$var$TMP_MESSAGING_OPERATION;
const $6feacf3bb3931a8f$export$283c55d09fbdb92c = $6feacf3bb3931a8f$var$TMP_MESSAGING_CONSUMER_ID;
const $6feacf3bb3931a8f$export$78385ca43d0e8556 = $6feacf3bb3931a8f$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY;
const $6feacf3bb3931a8f$export$b6969aab3cf94e74 = $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY;
const $6feacf3bb3931a8f$export$45eb738152aa5dd4 = $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP;
const $6feacf3bb3931a8f$export$bc66f788b071fbad = $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CLIENT_ID;
const $6feacf3bb3931a8f$export$ff4aad497ab5213e = $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_PARTITION;
const $6feacf3bb3931a8f$export$256d25d7635b3a79 = $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_TOMBSTONE;
const $6feacf3bb3931a8f$export$8b1a1f43d7106aea = $6feacf3bb3931a8f$var$TMP_RPC_SYSTEM;
const $6feacf3bb3931a8f$export$7eb60929eaa797de = $6feacf3bb3931a8f$var$TMP_RPC_SERVICE;
const $6feacf3bb3931a8f$export$c6d175d5e9b8105b = $6feacf3bb3931a8f$var$TMP_RPC_METHOD;
const $6feacf3bb3931a8f$export$ccc8405c8a911fb7 = $6feacf3bb3931a8f$var$TMP_RPC_GRPC_STATUS_CODE;
const $6feacf3bb3931a8f$export$ce0f2ec42ba79570 = $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_VERSION;
const $6feacf3bb3931a8f$export$2e981273bb2873ea = $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_REQUEST_ID;
const $6feacf3bb3931a8f$export$214058615970c3e4 = $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_CODE;
const $6feacf3bb3931a8f$export$2ad4f2a86baa9b1e = $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_MESSAGE;
const $6feacf3bb3931a8f$export$e6c57355a990f7ee = $6feacf3bb3931a8f$var$TMP_MESSAGE_TYPE;
const $6feacf3bb3931a8f$export$ba8e66ad5476d59f = $6feacf3bb3931a8f$var$TMP_MESSAGE_ID;
const $6feacf3bb3931a8f$export$16f3d59837418b1f = $6feacf3bb3931a8f$var$TMP_MESSAGE_COMPRESSED_SIZE;
const $6feacf3bb3931a8f$export$4b889081ab98b61 = $6feacf3bb3931a8f$var$TMP_MESSAGE_UNCOMPRESSED_SIZE;
const $6feacf3bb3931a8f$export$949e366c5c69d2e9 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_AWS_LAMBDA_INVOKED_ARN,
    $6feacf3bb3931a8f$var$TMP_DB_SYSTEM,
    $6feacf3bb3931a8f$var$TMP_DB_CONNECTION_STRING,
    $6feacf3bb3931a8f$var$TMP_DB_USER,
    $6feacf3bb3931a8f$var$TMP_DB_JDBC_DRIVER_CLASSNAME,
    $6feacf3bb3931a8f$var$TMP_DB_NAME,
    $6feacf3bb3931a8f$var$TMP_DB_STATEMENT,
    $6feacf3bb3931a8f$var$TMP_DB_OPERATION,
    $6feacf3bb3931a8f$var$TMP_DB_MSSQL_INSTANCE_NAME,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_KEYSPACE,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_PAGE_SIZE,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_TABLE,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_IDEMPOTENCE,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_ID,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_DC,
    $6feacf3bb3931a8f$var$TMP_DB_HBASE_NAMESPACE,
    $6feacf3bb3931a8f$var$TMP_DB_REDIS_DATABASE_INDEX,
    $6feacf3bb3931a8f$var$TMP_DB_MONGODB_COLLECTION,
    $6feacf3bb3931a8f$var$TMP_DB_SQL_TABLE,
    $6feacf3bb3931a8f$var$TMP_EXCEPTION_TYPE,
    $6feacf3bb3931a8f$var$TMP_EXCEPTION_MESSAGE,
    $6feacf3bb3931a8f$var$TMP_EXCEPTION_STACKTRACE,
    $6feacf3bb3931a8f$var$TMP_EXCEPTION_ESCAPED,
    $6feacf3bb3931a8f$var$TMP_FAAS_TRIGGER,
    $6feacf3bb3931a8f$var$TMP_FAAS_EXECUTION,
    $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_COLLECTION,
    $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_OPERATION,
    $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_TIME,
    $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_NAME,
    $6feacf3bb3931a8f$var$TMP_FAAS_TIME,
    $6feacf3bb3931a8f$var$TMP_FAAS_CRON,
    $6feacf3bb3931a8f$var$TMP_FAAS_COLDSTART,
    $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_NAME,
    $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_PROVIDER,
    $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_REGION,
    $6feacf3bb3931a8f$var$TMP_NET_TRANSPORT,
    $6feacf3bb3931a8f$var$TMP_NET_PEER_IP,
    $6feacf3bb3931a8f$var$TMP_NET_PEER_PORT,
    $6feacf3bb3931a8f$var$TMP_NET_PEER_NAME,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_IP,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_PORT,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_NAME,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_TYPE,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_SUBTYPE,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_NAME,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MCC,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MNC,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_ICC,
    $6feacf3bb3931a8f$var$TMP_PEER_SERVICE,
    $6feacf3bb3931a8f$var$TMP_ENDUSER_ID,
    $6feacf3bb3931a8f$var$TMP_ENDUSER_ROLE,
    $6feacf3bb3931a8f$var$TMP_ENDUSER_SCOPE,
    $6feacf3bb3931a8f$var$TMP_THREAD_ID,
    $6feacf3bb3931a8f$var$TMP_THREAD_NAME,
    $6feacf3bb3931a8f$var$TMP_CODE_FUNCTION,
    $6feacf3bb3931a8f$var$TMP_CODE_NAMESPACE,
    $6feacf3bb3931a8f$var$TMP_CODE_FILEPATH,
    $6feacf3bb3931a8f$var$TMP_CODE_LINENO,
    $6feacf3bb3931a8f$var$TMP_HTTP_METHOD,
    $6feacf3bb3931a8f$var$TMP_HTTP_URL,
    $6feacf3bb3931a8f$var$TMP_HTTP_TARGET,
    $6feacf3bb3931a8f$var$TMP_HTTP_HOST,
    $6feacf3bb3931a8f$var$TMP_HTTP_SCHEME,
    $6feacf3bb3931a8f$var$TMP_HTTP_STATUS_CODE,
    $6feacf3bb3931a8f$var$TMP_HTTP_FLAVOR,
    $6feacf3bb3931a8f$var$TMP_HTTP_USER_AGENT,
    $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH,
    $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED,
    $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH,
    $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED,
    $6feacf3bb3931a8f$var$TMP_HTTP_SERVER_NAME,
    $6feacf3bb3931a8f$var$TMP_HTTP_ROUTE,
    $6feacf3bb3931a8f$var$TMP_HTTP_CLIENT_IP,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_NAMES,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSISTENT_READ,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROJECTION,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LIMIT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_INDEX_NAME,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SELECT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_COUNT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCAN_FORWARD,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SEGMENT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_COUNT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCANNED_COUNT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_SYSTEM,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION_KIND,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_TEMP_DESTINATION,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL_VERSION,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_URL,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_ID,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_CONVERSATION_ID,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_OPERATION,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_CONSUMER_ID,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CLIENT_ID,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_PARTITION,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_TOMBSTONE,
    $6feacf3bb3931a8f$var$TMP_RPC_SYSTEM,
    $6feacf3bb3931a8f$var$TMP_RPC_SERVICE,
    $6feacf3bb3931a8f$var$TMP_RPC_METHOD,
    $6feacf3bb3931a8f$var$TMP_RPC_GRPC_STATUS_CODE,
    $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_VERSION,
    $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_REQUEST_ID,
    $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_CODE,
    $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_MESSAGE,
    $6feacf3bb3931a8f$var$TMP_MESSAGE_TYPE,
    $6feacf3bb3931a8f$var$TMP_MESSAGE_ID,
    $6feacf3bb3931a8f$var$TMP_MESSAGE_COMPRESSED_SIZE,
    $6feacf3bb3931a8f$var$TMP_MESSAGE_UNCOMPRESSED_SIZE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbSystemValues enum definition
 *
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_OTHER_SQL = 'other_sql';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MSSQL = 'mssql';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MYSQL = 'mysql';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ORACLE = 'oracle';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DB2 = 'db2';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POSTGRESQL = 'postgresql';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDSHIFT = 'redshift';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HIVE = 'hive';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE = 'cloudscape';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HSQLDB = 'hsqldb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PROGRESS = 'progress';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MAXDB = 'maxdb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HANADB = 'hanadb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INGRES = 'ingres';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIRSTSQL = 'firstsql';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_EDB = 'edb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CACHE = 'cache';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ADABAS = 'adabas';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIREBIRD = 'firebird';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DERBY = 'derby';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FILEMAKER = 'filemaker';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INFORMIX = 'informix';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INSTANTDB = 'instantdb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INTERBASE = 'interbase';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MARIADB = 'mariadb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NETEZZA = 'netezza';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PERVASIVE = 'pervasive';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POINTBASE = 'pointbase';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SQLITE = 'sqlite';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SYBASE = 'sybase';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_TERADATA = 'teradata';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_VERTICA = 'vertica';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_H2 = 'h2';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COLDFUSION = 'coldfusion';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CASSANDRA = 'cassandra';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HBASE = 'hbase';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MONGODB = 'mongodb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDIS = 'redis';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHBASE = 'couchbase';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHDB = 'couchdb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COSMOSDB = 'cosmosdb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DYNAMODB = 'dynamodb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NEO4J = 'neo4j';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_GEODE = 'geode';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH = 'elasticsearch';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MEMCACHED = 'memcached';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COCKROACHDB = 'cockroachdb';
const $6feacf3bb3931a8f$export$a8dac6c506518069 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_OTHER_SQL;
const $6feacf3bb3931a8f$export$ea0447329a58abf0 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MSSQL;
const $6feacf3bb3931a8f$export$f10ddff4d378463e = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MYSQL;
const $6feacf3bb3931a8f$export$1187a6d6f356ed08 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ORACLE;
const $6feacf3bb3931a8f$export$c99652dcdf96b994 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DB2;
const $6feacf3bb3931a8f$export$fa83a16930a97d3b = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POSTGRESQL;
const $6feacf3bb3931a8f$export$502f4a0041906d71 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDSHIFT;
const $6feacf3bb3931a8f$export$9ca2599ef62580aa = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HIVE;
const $6feacf3bb3931a8f$export$910728553bdc4f2 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE;
const $6feacf3bb3931a8f$export$927252a026981dbc = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HSQLDB;
const $6feacf3bb3931a8f$export$1d4496dd2fb6e5bf = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PROGRESS;
const $6feacf3bb3931a8f$export$eeac513ec469c0cd = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MAXDB;
const $6feacf3bb3931a8f$export$accdcd0fb0e8e3f2 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HANADB;
const $6feacf3bb3931a8f$export$3dcc190bf239314c = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INGRES;
const $6feacf3bb3931a8f$export$ff4c8094bbcf5fa7 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIRSTSQL;
const $6feacf3bb3931a8f$export$3277e5141d071eb2 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_EDB;
const $6feacf3bb3931a8f$export$4a79cae41e08a0dd = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CACHE;
const $6feacf3bb3931a8f$export$cf3b85811d34c73b = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ADABAS;
const $6feacf3bb3931a8f$export$48eca9ca7c84a995 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIREBIRD;
const $6feacf3bb3931a8f$export$bc5d7654a3e6dc01 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DERBY;
const $6feacf3bb3931a8f$export$422940b84b884f99 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FILEMAKER;
const $6feacf3bb3931a8f$export$a49658a36841921 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INFORMIX;
const $6feacf3bb3931a8f$export$dd1bda064bc12f55 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INSTANTDB;
const $6feacf3bb3931a8f$export$3845f6f803a923b1 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INTERBASE;
const $6feacf3bb3931a8f$export$1b74fece6a0567e8 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MARIADB;
const $6feacf3bb3931a8f$export$8fc04abe03bce8d5 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NETEZZA;
const $6feacf3bb3931a8f$export$f9406b4f00b760b4 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PERVASIVE;
const $6feacf3bb3931a8f$export$5bc787da6daf8e9c = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POINTBASE;
const $6feacf3bb3931a8f$export$92e0362f5610565 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SQLITE;
const $6feacf3bb3931a8f$export$ec03fbd64421b165 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SYBASE;
const $6feacf3bb3931a8f$export$486b763280f7312f = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_TERADATA;
const $6feacf3bb3931a8f$export$424b3c529411045a = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_VERTICA;
const $6feacf3bb3931a8f$export$5b4c7807bd4e54d0 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_H2;
const $6feacf3bb3931a8f$export$998c3a6fdfbcf7df = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COLDFUSION;
const $6feacf3bb3931a8f$export$dc18027519a667a3 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CASSANDRA;
const $6feacf3bb3931a8f$export$a3cbb4bc103ae284 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HBASE;
const $6feacf3bb3931a8f$export$b1615e3bbcf0dea5 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MONGODB;
const $6feacf3bb3931a8f$export$e236e209844f1272 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDIS;
const $6feacf3bb3931a8f$export$a3861a07874f1889 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHBASE;
const $6feacf3bb3931a8f$export$f84afd1ccf7f622f = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHDB;
const $6feacf3bb3931a8f$export$408510df30ac38f0 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COSMOSDB;
const $6feacf3bb3931a8f$export$f704654eab77c7c7 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DYNAMODB;
const $6feacf3bb3931a8f$export$5eea4c4dfe97cf90 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NEO4J;
const $6feacf3bb3931a8f$export$f6740c7ce8d8a59 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_GEODE;
const $6feacf3bb3931a8f$export$25d0355c3ecc82d5 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH;
const $6feacf3bb3931a8f$export$3566ede46e0a8a41 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MEMCACHED;
const $6feacf3bb3931a8f$export$2844c6dfa3d1660a = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COCKROACHDB;
const $6feacf3bb3931a8f$export$53ce5c6571db6866 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_OTHER_SQL,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MSSQL,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MYSQL,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ORACLE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DB2,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POSTGRESQL,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDSHIFT,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HIVE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HSQLDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PROGRESS,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MAXDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HANADB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INGRES,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIRSTSQL,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_EDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CACHE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ADABAS,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIREBIRD,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DERBY,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FILEMAKER,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INFORMIX,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INSTANTDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INTERBASE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MARIADB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NETEZZA,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PERVASIVE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POINTBASE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SQLITE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SYBASE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_TERADATA,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_VERTICA,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_H2,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COLDFUSION,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CASSANDRA,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HBASE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MONGODB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDIS,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHBASE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COSMOSDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DYNAMODB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NEO4J,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_GEODE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MEMCACHED,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COCKROACHDB
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbCassandraConsistencyLevelValues enum definition
 *
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL = 'all';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = 'each_quorum';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = 'quorum';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = 'local_quorum';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE = 'one';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO = 'two';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE = 'three';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = 'local_one';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY = 'any';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = 'serial';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = 'local_serial';
const $6feacf3bb3931a8f$export$8c965dbb4c30de17 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL;
const $6feacf3bb3931a8f$export$28269849572f223a = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM;
const $6feacf3bb3931a8f$export$c31be6925d18faf4 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM;
const $6feacf3bb3931a8f$export$dd2d046c43b425dc = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM;
const $6feacf3bb3931a8f$export$d567e6085f609657 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE;
const $6feacf3bb3931a8f$export$2638f2ef2b3637ea = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO;
const $6feacf3bb3931a8f$export$444dff27642c23a3 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE;
const $6feacf3bb3931a8f$export$be0e7a9b9b7460eb = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE;
const $6feacf3bb3931a8f$export$9cda430306f12b08 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY;
const $6feacf3bb3931a8f$export$79a04d8aacdacbe9 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL;
const $6feacf3bb3931a8f$export$42bf18043dacb777 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL;
const $6feacf3bb3931a8f$export$a6eeaa6fe6488373 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasTriggerValues enum definition
 *
 * Type of the trigger on which the function is executed.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_DATASOURCE = 'datasource';
const $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_HTTP = 'http';
const $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_PUBSUB = 'pubsub';
const $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_TIMER = 'timer';
const $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_OTHER = 'other';
const $6feacf3bb3931a8f$export$a116a6c98ad82a77 = $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_DATASOURCE;
const $6feacf3bb3931a8f$export$1b8130a1d4406030 = $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_HTTP;
const $6feacf3bb3931a8f$export$2c3c25968f77e7b3 = $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_PUBSUB;
const $6feacf3bb3931a8f$export$f1adafe5047573a = $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_TIMER;
const $6feacf3bb3931a8f$export$2aa5343c84c7d0a6 = $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_OTHER;
const $6feacf3bb3931a8f$export$8bd13b593ef4858d = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_DATASOURCE,
    $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_HTTP,
    $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_PUBSUB,
    $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_TIMER,
    $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_OTHER
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasDocumentOperationValues enum definition
 *
 * Describes the type of the operation that was performed on the data.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT = 'insert';
const $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT = 'edit';
const $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE = 'delete';
const $6feacf3bb3931a8f$export$58594a32d0721c01 = $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT;
const $6feacf3bb3931a8f$export$fb5981e11be92c91 = $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT;
const $6feacf3bb3931a8f$export$8617289d67ca4e43 = $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE;
const $6feacf3bb3931a8f$export$d6463783e5bb27f9 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT,
    $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT,
    $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasInvokedProviderValues enum definition
 *
 * The cloud provider of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.provider` resource attribute of the invoked function.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = 'alibaba_cloud';
const $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS = 'aws';
const $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE = 'azure';
const $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP = 'gcp';
const $6feacf3bb3931a8f$export$a7a256059bf89bd1 = $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD;
const $6feacf3bb3931a8f$export$8716f61e9f3c2aeb = $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS;
const $6feacf3bb3931a8f$export$ec924dafe3d951e3 = $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE;
const $6feacf3bb3931a8f$export$40370ddcd5c5f6d7 = $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP;
const $6feacf3bb3931a8f$export$668b545a1de0448 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD,
    $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS,
    $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE,
    $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetTransportValues enum definition
 *
 * Transport protocol used. See note below.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_TCP = 'ip_tcp';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_UDP = 'ip_udp';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP = 'ip';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_UNIX = 'unix';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_PIPE = 'pipe';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_INPROC = 'inproc';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_OTHER = 'other';
const $6feacf3bb3931a8f$export$98ad64057f1fab9f = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_TCP;
const $6feacf3bb3931a8f$export$efc9b6ce6290a881 = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_UDP;
const $6feacf3bb3931a8f$export$f3aeea475f2d61eb = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP;
const $6feacf3bb3931a8f$export$2ff43587ce3a6428 = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_UNIX;
const $6feacf3bb3931a8f$export$8a59379768b7dcc2 = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_PIPE;
const $6feacf3bb3931a8f$export$24d541ca01c48083 = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_INPROC;
const $6feacf3bb3931a8f$export$61986d2ea3f68e4 = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_OTHER;
const $6feacf3bb3931a8f$export$3818cf83a3542239 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_TCP,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_UDP,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_UNIX,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_PIPE,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_INPROC,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_OTHER
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionTypeValues enum definition
 *
 * The internet connection type currently being used by the host.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI = 'wifi';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED = 'wired';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL = 'cell';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = 'unavailable';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = 'unknown';
const $6feacf3bb3931a8f$export$9f02ba1730e68d64 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI;
const $6feacf3bb3931a8f$export$ff976cfa645183ea = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED;
const $6feacf3bb3931a8f$export$9dac5d5db0d7302d = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL;
const $6feacf3bb3931a8f$export$856320690b0a4ede = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE;
const $6feacf3bb3931a8f$export$b93b5033f8372e2b = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN;
const $6feacf3bb3931a8f$export$a5c9a789b3c34827 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionSubtypeValues enum definition
 *
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = 'gprs';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = 'edge';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = 'umts';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = 'cdma';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = 'evdo_0';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = 'evdo_a';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = 'cdma2000_1xrtt';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = 'hsdpa';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = 'hsupa';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = 'hspa';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = 'iden';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = 'evdo_b';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE = 'lte';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = 'ehrpd';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = 'hspap';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM = 'gsm';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = 'td_scdma';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = 'iwlan';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR = 'nr';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = 'nrnsa';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = 'lte_ca';
const $6feacf3bb3931a8f$export$b3928d079bcf0650 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS;
const $6feacf3bb3931a8f$export$869e5d9e2d7d058f = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE;
const $6feacf3bb3931a8f$export$4fb8dba98d516457 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS;
const $6feacf3bb3931a8f$export$4c80eef388ebaccf = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA;
const $6feacf3bb3931a8f$export$fa867825f37e79db = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0;
const $6feacf3bb3931a8f$export$27a67e3163ce1ca1 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A;
const $6feacf3bb3931a8f$export$64eea596575c6ac7 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT;
const $6feacf3bb3931a8f$export$ac76a80a244a93c4 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA;
const $6feacf3bb3931a8f$export$1f6c75de7c7b16c8 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA;
const $6feacf3bb3931a8f$export$546b89c4781a174b = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA;
const $6feacf3bb3931a8f$export$76ada84046ded2cf = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN;
const $6feacf3bb3931a8f$export$cbc44b2ef04c23f2 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B;
const $6feacf3bb3931a8f$export$7df810136272d3ca = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE;
const $6feacf3bb3931a8f$export$6d0261a99bb34b75 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD;
const $6feacf3bb3931a8f$export$f5609166f18e0da4 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP;
const $6feacf3bb3931a8f$export$bb1d1d2dc1514ff9 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM;
const $6feacf3bb3931a8f$export$f39e3589dec1b486 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA;
const $6feacf3bb3931a8f$export$2ea90d5cadafeb66 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN;
const $6feacf3bb3931a8f$export$dacf20f714c7dfe3 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR;
const $6feacf3bb3931a8f$export$3057d75e98c27a82 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA;
const $6feacf3bb3931a8f$export$ac7da250598a79b7 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA;
const $6feacf3bb3931a8f$export$2f6476d8343c332 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for HttpFlavorValues enum definition
 *
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_0 = '1.0';
const $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_1 = '1.1';
const $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_2_0 = '2.0';
const $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_SPDY = 'SPDY';
const $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_QUIC = 'QUIC';
const $6feacf3bb3931a8f$export$a5eaf604e08c3278 = $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_0;
const $6feacf3bb3931a8f$export$90c81a0909f2ae50 = $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_1;
const $6feacf3bb3931a8f$export$76fedb424c637ab1 = $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_2_0;
const $6feacf3bb3931a8f$export$64a9fa17294d693a = $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_SPDY;
const $6feacf3bb3931a8f$export$71f9f90e022dd018 = $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_QUIC;
const $6feacf3bb3931a8f$export$98fa65d23b3ad768 = {
    HTTP_1_0: $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_0,
    HTTP_1_1: $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_1,
    HTTP_2_0: $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_2_0,
    SPDY: $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_SPDY,
    QUIC: $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_QUIC
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingDestinationKindValues enum definition
 *
 * The kind of message destination.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE = 'queue';
const $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC = 'topic';
const $6feacf3bb3931a8f$export$3c00656cec2b971b = $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE;
const $6feacf3bb3931a8f$export$5b3434288d57e9db = $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC;
const $6feacf3bb3931a8f$export$c97cf0959c06f2eb = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE,
    $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingOperationValues enum definition
 *
 * A string identifying the kind of message consumption as defined in the [Operation names](#operation-names) section above. If the operation is &#34;send&#34;, this attribute MUST NOT be set, since the operation can be inferred from the span kind in that case.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE = 'receive';
const $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS = 'process';
const $6feacf3bb3931a8f$export$84220b734749f5b0 = $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE;
const $6feacf3bb3931a8f$export$e4e81e41cac54813 = $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS;
const $6feacf3bb3931a8f$export$4a89c511599cd2ec = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE,
    $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for RpcGrpcStatusCodeValues enum definition
 *
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OK = 0;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED = 1;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN = 2;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = 3;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = 4;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND = 5;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = 6;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = 7;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = 8;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = 9;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED = 10;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = 11;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = 12;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL = 13;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = 14;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS = 15;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = 16;
const $6feacf3bb3931a8f$export$949d8f2733439fe0 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OK;
const $6feacf3bb3931a8f$export$3ab4e217bae3a065 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED;
const $6feacf3bb3931a8f$export$82114f8ba92008f1 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN;
const $6feacf3bb3931a8f$export$4747f09ec996ed1a = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT;
const $6feacf3bb3931a8f$export$2f64e796efee7806 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED;
const $6feacf3bb3931a8f$export$c2b894d36cd1d993 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND;
const $6feacf3bb3931a8f$export$e675f9346907cdbf = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS;
const $6feacf3bb3931a8f$export$ee7173f54f1f7e52 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED;
const $6feacf3bb3931a8f$export$a2e4b937aa6d8799 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED;
const $6feacf3bb3931a8f$export$ef9ed8d6d4e5cd73 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION;
const $6feacf3bb3931a8f$export$5186c1c5a9145ea6 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED;
const $6feacf3bb3931a8f$export$e67583738364c597 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE;
const $6feacf3bb3931a8f$export$90f86b1e23bb678f = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED;
const $6feacf3bb3931a8f$export$133efbe81a3e3b7a = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL;
const $6feacf3bb3931a8f$export$8d87e3aaaab1d8c1 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE;
const $6feacf3bb3931a8f$export$2acca698ff2f1632 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS;
const $6feacf3bb3931a8f$export$fc7c44549e950bf = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED;
const $6feacf3bb3931a8f$export$759a06c32b696c70 = {
    OK: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OK,
    CANCELLED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED,
    UNKNOWN: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN,
    INVALID_ARGUMENT: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT,
    DEADLINE_EXCEEDED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED,
    NOT_FOUND: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND,
    ALREADY_EXISTS: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS,
    PERMISSION_DENIED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED,
    RESOURCE_EXHAUSTED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED,
    FAILED_PRECONDITION: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION,
    ABORTED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED,
    OUT_OF_RANGE: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE,
    UNIMPLEMENTED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED,
    INTERNAL: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL,
    UNAVAILABLE: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE,
    DATA_LOSS: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS,
    UNAUTHENTICATED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessageTypeValues enum definition
 *
 * Whether this is a received or sent message.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_SENT = 'SENT';
const $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_RECEIVED = 'RECEIVED';
const $6feacf3bb3931a8f$export$10fb24096e4ea8a3 = $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_SENT;
const $6feacf3bb3931a8f$export$e520006d57a4745f = $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_RECEIVED;
const $6feacf3bb3931a8f$export$c83b17f5976c727c = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_SENT,
    $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_RECEIVED
]);


// Used to normalize relative URLs
let $7aa841ad0014104b$var$urlNormalizingAnchor;
function $7aa841ad0014104b$var$getUrlNormalizingAnchor() {
    if (!$7aa841ad0014104b$var$urlNormalizingAnchor) $7aa841ad0014104b$var$urlNormalizingAnchor = document.createElement('a');
    return $7aa841ad0014104b$var$urlNormalizingAnchor;
}
function $7aa841ad0014104b$export$94df19ecb868bc1a(obj, key) {
    return key in obj;
}
function $7aa841ad0014104b$export$7e5e8f17966d37d1(span, performanceName, entries, ignoreZeros = true) {
    if ($7aa841ad0014104b$export$94df19ecb868bc1a(entries, performanceName) && typeof entries[performanceName] === 'number' && !(ignoreZeros && entries[performanceName] === 0)) return span.addEvent(performanceName, entries[performanceName]);
    return undefined;
}
function $7aa841ad0014104b$export$e2385716cf129455(span, resource, ignoreNetworkEvents = false, ignoreZeros) {
    if (ignoreZeros === undefined) ignoreZeros = resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).START_TIME] !== 0;
    if (!ignoreNetworkEvents) {
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).DOMAIN_LOOKUP_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).DOMAIN_LOOKUP_END, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).CONNECT_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).SECURE_CONNECTION_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).CONNECT_END, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).REQUEST_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_END, resource, ignoreZeros);
    }
    const encodedLength = resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).ENCODED_BODY_SIZE];
    if (encodedLength !== undefined) span.setAttribute((0, $6feacf3bb3931a8f$export$58d4fbfe35e08be0), encodedLength);
    const decodedLength = resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).DECODED_BODY_SIZE];
    // Spec: Not set if transport encoding not used (in which case encoded and decoded sizes match)
    if (decodedLength !== undefined && encodedLength !== decodedLength) span.setAttribute((0, $6feacf3bb3931a8f$export$b9d3e41cd56c56cc), decodedLength);
}
function $7aa841ad0014104b$export$5d17283e524de23c(filteredResources) {
    return filteredResources.slice().sort((a, b)=>{
        const valueA = a[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START];
        const valueB = b[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
/** Returns the origin if present (if in browser context). */ function $7aa841ad0014104b$var$getOrigin() {
    return typeof location !== 'undefined' ? location.origin : undefined;
}
function $7aa841ad0014104b$export$cdcba7438a7553e8(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources = new WeakSet(), initiatorType) {
    // de-relativize the URL before usage (does no harm to absolute URLs)
    const parsedSpanUrl = $7aa841ad0014104b$export$7a5253c0f62e0150(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    const filteredResources = $7aa841ad0014104b$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: undefined
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    const sorted = $7aa841ad0014104b$export$5d17283e524de23c(filteredResources);
    if (parsedSpanUrl.origin !== $7aa841ad0014104b$var$getOrigin() && sorted.length > 1) {
        let corsPreFlightRequest = sorted[0];
        let mainRequest = $7aa841ad0014104b$var$findMainRequest(sorted, corsPreFlightRequest[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_END], endTimeHR);
        const responseEnd = corsPreFlightRequest[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_END];
        const fetchStart = mainRequest[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START];
        // no corsPreFlightRequest
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = undefined;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
/**
 * Will find the main request skipping the cors pre flight requests
 * @param resources
 * @param corsPreFlightRequestEndTime
 * @param spanEndTimeHR
 */ function $7aa841ad0014104b$var$findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    const spanEndTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)(spanEndTimeHR);
    const minTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)((0, $bd29e81cd70a2732$export$5f4c8a8ba0e36226)(corsPreFlightRequestEndTime));
    let mainRequest = resources[1];
    let bestGap;
    const length = resources.length;
    for(let i = 1; i < length; i++){
        const resource = resources[i];
        const resourceStartTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)((0, $bd29e81cd70a2732$export$5f4c8a8ba0e36226)(resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)((0, $bd29e81cd70a2732$export$5f4c8a8ba0e36226)(resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_END]));
        const currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
/**
 * Filter all resources that has started and finished according to span start time and end time.
 *     It will return the closest resource to a start time
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 */ function $7aa841ad0014104b$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    const startTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)(startTimeHR);
    const endTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)(endTimeHR);
    let filteredResources = resources.filter((resource)=>{
        const resourceStartTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)((0, $bd29e81cd70a2732$export$5f4c8a8ba0e36226)(resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)((0, $bd29e81cd70a2732$export$5f4c8a8ba0e36226)(resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || 'xmlhttprequest') && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter((resource)=>{
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function $7aa841ad0014104b$export$7a5253c0f62e0150(url) {
    if (typeof URL === 'function') return new URL(url, typeof document !== 'undefined' ? document.baseURI : typeof location !== 'undefined' // Some JS runtimes (e.g. Deno) don't define this
     ? location.href : undefined);
    const element = $7aa841ad0014104b$var$getUrlNormalizingAnchor();
    element.href = url;
    return element;
}
function $7aa841ad0014104b$export$6535eb414fa2c8b6(url) {
    const urlLike = $7aa841ad0014104b$export$7a5253c0f62e0150(url);
    return urlLike.href;
}
function $7aa841ad0014104b$export$fabdebd274ccbd1c(target, optimised) {
    if (target.nodeType === Node.DOCUMENT_NODE) return '/';
    const targetValue = $7aa841ad0014104b$var$getNodeValue(target, optimised);
    if (optimised && targetValue.indexOf('@id') > 0) return targetValue;
    let xpath = '';
    if (target.parentNode) xpath += $7aa841ad0014104b$export$fabdebd274ccbd1c(target.parentNode, false);
    xpath += targetValue;
    return xpath;
}
/**
 * get node index within the siblings
 * @param target
 */ function $7aa841ad0014104b$var$getNodeIndex(target) {
    if (!target.parentNode) return 0;
    const allowedTypes = [
        target.nodeType
    ];
    if (target.nodeType === Node.CDATA_SECTION_NODE) allowedTypes.push(Node.TEXT_NODE);
    let elements = Array.from(target.parentNode.childNodes);
    elements = elements.filter((element)=>{
        const localName = element.localName;
        return allowedTypes.indexOf(element.nodeType) >= 0 && localName === target.localName;
    });
    if (elements.length >= 1) return elements.indexOf(target) + 1; // xpath starts from 1
    // if there are no other similar child xpath doesn't need index
    return 0;
}
/**
 * get node value for xpath
 * @param target
 * @param optimised
 */ function $7aa841ad0014104b$var$getNodeValue(target, optimised) {
    const nodeType = target.nodeType;
    const index = $7aa841ad0014104b$var$getNodeIndex(target);
    let nodeValue = '';
    if (nodeType === Node.ELEMENT_NODE) {
        const id = target.getAttribute('id');
        if (optimised && id) return `//*[@id="${id}"]`;
        nodeValue = target.localName;
    } else if (nodeType === Node.TEXT_NODE || nodeType === Node.CDATA_SECTION_NODE) nodeValue = 'text()';
    else if (nodeType === Node.COMMENT_NODE) nodeValue = 'comment()';
    else return '';
    // if index is 1 it can be omitted in xpath
    if (nodeValue && index > 1) return `/${nodeValue}[${index}]`;
    return `/${nodeValue}`;
}
function $7aa841ad0014104b$export$c6501d7e56a5b40a(spanUrl, propagateTraceHeaderCorsUrls) {
    let propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === 'string' || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    const parsedSpanUrl = $7aa841ad0014104b$export$7a5253c0f62e0150(spanUrl);
    if (parsedSpanUrl.origin === $7aa841ad0014104b$var$getOrigin()) return true;
    else return propagateTraceHeaderUrls.some((propagateTraceHeaderUrl)=>(0, $a5b2d9a21101d5ac$export$c2a944331f80ae92)(spanUrl, propagateTraceHeaderUrl));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */ var $e240ff5b2bfa826f$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["COMPONENT"] = "component";
    AttributeNames["HTTP_ERROR_NAME"] = "http.error_name";
    AttributeNames["HTTP_STATUS_TEXT"] = "http.status_text";
})($e240ff5b2bfa826f$export$668754fb61dd076c || ($e240ff5b2bfa826f$export$668754fb61dd076c = {}));



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Much of the logic here overlaps with the same utils file in opentelemetry-instrumentation-xml-http-request
// These may be unified in the future.

const $34ff7089573fc4f7$var$DIAG_LOGGER = $83ffbea8f4ffb90a$export$c042e7c2f59bc046.createComponentLogger({
    namespace: '@opentelemetry/opentelemetry-instrumentation-fetch/utils'
});
function $34ff7089573fc4f7$export$71d292fa56cdb7b9(...args) {
    if (args[0] instanceof URL || typeof args[0] === 'string') {
        const requestInit = args[1];
        if (!requestInit?.body) return Promise.resolve();
        if (requestInit.body instanceof ReadableStream) {
            const { body: body, length: length } = $34ff7089573fc4f7$var$_getBodyNonDestructively(requestInit.body);
            requestInit.body = body;
            return length;
        } else return Promise.resolve($34ff7089573fc4f7$export$e6a57dee760266dc(requestInit.body));
    } else {
        const info = args[0];
        if (!info?.body) return Promise.resolve();
        return info.clone().text().then((t)=>$34ff7089573fc4f7$var$getByteLength(t));
    }
}
function $34ff7089573fc4f7$var$_getBodyNonDestructively(body) {
    // can't read a ReadableStream without destroying it
    // but we CAN pipe it through and return a new ReadableStream
    // some (older) platforms don't expose the pipeThrough method and in that scenario, we're out of luck;
    //   there's no way to read the stream without consuming it.
    if (!body.pipeThrough) {
        $34ff7089573fc4f7$var$DIAG_LOGGER.warn('Platform has ReadableStream but not pipeThrough!');
        return {
            body: body,
            length: Promise.resolve(undefined)
        };
    }
    let length = 0;
    let resolveLength;
    const lengthPromise = new Promise((resolve)=>{
        resolveLength = resolve;
    });
    const transform = new TransformStream({
        start () {},
        async transform (chunk, controller) {
            const bytearray = await chunk;
            length += bytearray.byteLength;
            controller.enqueue(chunk);
        },
        flush () {
            resolveLength(length);
        }
    });
    return {
        body: body.pipeThrough(transform),
        length: lengthPromise
    };
}
function $34ff7089573fc4f7$var$isDocument(value) {
    return typeof Document !== 'undefined' && value instanceof Document;
}
function $34ff7089573fc4f7$export$e6a57dee760266dc(body) {
    if ($34ff7089573fc4f7$var$isDocument(body)) return new XMLSerializer().serializeToString(document).length;
    // XMLHttpRequestBodyInit expands to the following:
    if (typeof body === 'string') return $34ff7089573fc4f7$var$getByteLength(body);
    if (body instanceof Blob) return body.size;
    if (body instanceof FormData) return $34ff7089573fc4f7$var$getFormDataSize(body);
    if (body instanceof URLSearchParams) return $34ff7089573fc4f7$var$getByteLength(body.toString());
    // ArrayBuffer | ArrayBufferView
    if (body.byteLength !== undefined) return body.byteLength;
    $34ff7089573fc4f7$var$DIAG_LOGGER.warn('unknown body type');
    return undefined;
}
const $34ff7089573fc4f7$var$TEXT_ENCODER = new TextEncoder();
function $34ff7089573fc4f7$var$getByteLength(s) {
    return $34ff7089573fc4f7$var$TEXT_ENCODER.encode(s).byteLength;
}
function $34ff7089573fc4f7$var$getFormDataSize(formData) {
    let size = 0;
    for (const [key, value] of formData.entries()){
        size += key.length;
        if (value instanceof Blob) size += value.size;
        else size += value.length;
    }
    return size;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $7270322fd21e146f$export$a4ad2735b021c132 = '0.200.0';


// how long to wait for observer to collect information about resources
// this is needed as event "load" is called before observer
// hard to say how long it should really wait, seems like 300ms is
// safe enough
const $2ca417de41fd3f3d$var$OBSERVER_WAIT_TIME_MS = 300;
const $2ca417de41fd3f3d$var$isNode = false;
class $2ca417de41fd3f3d$export$f922a490458c98a8 extends (0, $be89eb9a2ed8d8a6$export$436b1c2bf7e9756b) {
    component = 'fetch';
    version = (0, $7270322fd21e146f$export$a4ad2735b021c132);
    moduleName = this.component;
    _usedResources = new WeakSet();
    _tasksCount = 0;
    constructor(config = {}){
        super('@opentelemetry/instrumentation-fetch', (0, $7270322fd21e146f$export$a4ad2735b021c132), config);
    }
    init() {}
    /**
     * Add cors pre flight child span
     * @param span
     * @param corsPreFlightRequest
     */ _addChildSpan(span, corsPreFlightRequest) {
        const childSpan = this.tracer.startSpan('CORS Preflight', {
            startTime: corsPreFlightRequest[$07a8fc58179c2fd8$export$74be52df2d6fd28c.FETCH_START]
        }, $a1569335aa614ed8$export$357889f174732d38.setSpan($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), span));
        $7aa841ad0014104b$export$e2385716cf129455(childSpan, corsPreFlightRequest, this.getConfig().ignoreNetworkEvents);
        childSpan.end(corsPreFlightRequest[$07a8fc58179c2fd8$export$74be52df2d6fd28c.RESPONSE_END]);
    }
    /**
     * Adds more attributes to span just before ending it
     * @param span
     * @param response
     */ _addFinalSpanAttributes(span, response) {
        const parsedUrl = $7aa841ad0014104b$export$7a5253c0f62e0150(response.url);
        span.setAttribute((0, $6feacf3bb3931a8f$export$d381c7525d715413), response.status);
        if (response.statusText != null) span.setAttribute((0, $e240ff5b2bfa826f$export$668754fb61dd076c).HTTP_STATUS_TEXT, response.statusText);
        span.setAttribute((0, $6feacf3bb3931a8f$export$547e24d3f59a53ea), parsedUrl.host);
        span.setAttribute((0, $6feacf3bb3931a8f$export$a2928efa45f0acf4), parsedUrl.protocol.replace(':', ''));
        if (typeof navigator !== 'undefined') span.setAttribute((0, $6feacf3bb3931a8f$export$7472b18f42d2d02f), navigator.userAgent);
    }
    /**
     * Add headers
     * @param options
     * @param spanUrl
     */ _addHeaders(options, spanUrl) {
        if (!$7aa841ad0014104b$export$c6501d7e56a5b40a(spanUrl, this.getConfig().propagateTraceHeaderCorsUrls)) {
            const headers = {};
            $c76b4b4057b01033$export$3e49040daa9dba20.inject($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), headers);
            if (Object.keys(headers).length > 0) this._diag.debug('headers inject skipped due to CORS policy');
            return;
        }
        if (options instanceof Request) $c76b4b4057b01033$export$3e49040daa9dba20.inject($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else if (options.headers instanceof Headers) $c76b4b4057b01033$export$3e49040daa9dba20.inject($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else if (options.headers instanceof Map) $c76b4b4057b01033$export$3e49040daa9dba20.inject($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else {
            const headers = {};
            $c76b4b4057b01033$export$3e49040daa9dba20.inject($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), headers);
            options.headers = Object.assign({}, headers, options.headers || {});
        }
    }
    /**
     * Clears the resource timings and all resources assigned with spans
     *     when {@link FetchPluginConfig.clearTimingResources} is
     *     set to true (default false)
     * @private
     */ _clearResources() {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            performance.clearResourceTimings();
            this._usedResources = new WeakSet();
        }
    }
    /**
     * Creates a new span
     * @param url
     * @param options
     */ _createSpan(url, options = {}) {
        if ($a5b2d9a21101d5ac$export$172b5a1c42a6f83d(url, this.getConfig().ignoreUrls)) {
            this._diag.debug('ignoring span as url matches ignored url');
            return;
        }
        const method = (options.method || 'GET').toUpperCase();
        const spanName = `HTTP ${method}`;
        return this.tracer.startSpan(spanName, {
            kind: $d03364baa5302116$export$4da4ea8145910e8b.CLIENT,
            attributes: {
                [(0, $e240ff5b2bfa826f$export$668754fb61dd076c).COMPONENT]: this.moduleName,
                [(0, $6feacf3bb3931a8f$export$5ec7d06d671a3fbe)]: method,
                [(0, $6feacf3bb3931a8f$export$2f4ef7e39c2be395)]: url
            }
        });
    }
    /**
     * Finds appropriate resource and add network events to the span
     * @param span
     * @param resourcesObserver
     * @param endTime
     */ _findResourceAndAddNetworkEvents(span, resourcesObserver, endTime) {
        let resources = resourcesObserver.entries;
        if (!resources.length) {
            if (!performance.getEntriesByType) return;
            // fallback - either Observer is not available or it took longer
            // then OBSERVER_WAIT_TIME_MS and observer didn't collect enough
            // information
            resources = performance.getEntriesByType('resource');
        }
        const resource = $7aa841ad0014104b$export$cdcba7438a7553e8(resourcesObserver.spanUrl, resourcesObserver.startTime, endTime, resources, this._usedResources, 'fetch');
        if (resource.mainRequest) {
            const mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            const corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            $7aa841ad0014104b$export$e2385716cf129455(span, mainRequest, this.getConfig().ignoreNetworkEvents);
        }
    }
    /**
     * Marks certain [resource]{@link PerformanceResourceTiming} when information
     * from this is used to add events to span.
     * This is done to avoid reusing the same resource again for next span
     * @param resource
     */ _markResourceAsUsed(resource) {
        this._usedResources.add(resource);
    }
    /**
     * Finish span, add attributes, network events etc.
     * @param span
     * @param spanData
     * @param response
     */ _endSpan(span, spanData, response) {
        const endTime = $bd29e81cd70a2732$export$e7ec5c82995537b1(Date.now());
        const performanceEndTime = $bd29e81cd70a2732$export$24b3f7dcd2848fa8();
        this._addFinalSpanAttributes(span, response);
        setTimeout(()=>{
            spanData.observer?.disconnect();
            this._findResourceAndAddNetworkEvents(span, spanData, performanceEndTime);
            this._tasksCount--;
            this._clearResources();
            span.end(endTime);
        }, $2ca417de41fd3f3d$var$OBSERVER_WAIT_TIME_MS);
    }
    /**
     * Patches the constructor of fetch
     */ _patchConstructor() {
        return (original)=>{
            const plugin = this;
            return function patchConstructor(...args) {
                const self = this;
                const url = $7aa841ad0014104b$export$7a5253c0f62e0150(args[0] instanceof Request ? args[0].url : String(args[0])).href;
                const options = args[0] instanceof Request ? args[0] : args[1] || {};
                const createdSpan = plugin._createSpan(url, options);
                if (!createdSpan) return original.apply(this, args);
                const spanData = plugin._prepareSpanData(url);
                if (plugin.getConfig().measureRequestSize) (0, $34ff7089573fc4f7$export$71d292fa56cdb7b9)(...args).then((length)=>{
                    if (!length) return;
                    createdSpan.setAttribute((0, $6feacf3bb3931a8f$export$4352992cf528a286), length);
                }).catch((error)=>{
                    plugin._diag.warn('getFetchBodyLength', error);
                });
                function endSpanOnError(span, error) {
                    plugin._applyAttributesAfterFetch(span, options, error);
                    plugin._endSpan(span, spanData, {
                        status: error.status || 0,
                        statusText: error.message,
                        url: url
                    });
                }
                function endSpanOnSuccess(span, response) {
                    plugin._applyAttributesAfterFetch(span, options, response);
                    if (response.status >= 200 && response.status < 400) plugin._endSpan(span, spanData, response);
                    else plugin._endSpan(span, spanData, {
                        status: response.status,
                        statusText: response.statusText,
                        url: url
                    });
                }
                function onSuccess(span, resolve, response) {
                    try {
                        const resClone = response.clone();
                        const body = resClone.body;
                        if (body) {
                            const reader = body.getReader();
                            const read = ()=>{
                                reader.read().then(({ done: done })=>{
                                    if (done) endSpanOnSuccess(span, response);
                                    else read();
                                }, (error)=>{
                                    endSpanOnError(span, error);
                                });
                            };
                            read();
                        } else // some older browsers don't have .body implemented
                        endSpanOnSuccess(span, response);
                    } finally{
                        resolve(response);
                    }
                }
                function onError(span, reject, error) {
                    try {
                        endSpanOnError(span, error);
                    } finally{
                        reject(error);
                    }
                }
                return new Promise((resolve, reject)=>{
                    return $e8248f70bfae46d0$export$a078c61943f9dbbe.with($a1569335aa614ed8$export$357889f174732d38.setSpan($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), createdSpan), ()=>{
                        plugin._addHeaders(options, url);
                        // Important to execute "_callRequestHook" after "_addHeaders", allowing the consumer code to override the request headers.
                        plugin._callRequestHook(createdSpan, options);
                        plugin._tasksCount++;
                        // TypeScript complains about arrow function captured a this typed as globalThis
                        // ts(7041)
                        return original.apply(self, options instanceof Request ? [
                            options
                        ] : [
                            url,
                            options
                        ]).then(onSuccess.bind(self, createdSpan, resolve), onError.bind(self, createdSpan, reject));
                    });
                });
            };
        };
    }
    _applyAttributesAfterFetch(span, request, result) {
        const applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (applyCustomAttributesOnSpan) (0, $e5045196367e2654$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span, request, result), (error)=>{
            if (!error) return;
            this._diag.error('applyCustomAttributesOnSpan', error);
        }, true);
    }
    _callRequestHook(span, request) {
        const requestHook = this.getConfig().requestHook;
        if (requestHook) (0, $e5045196367e2654$export$fdff7e10f8ca069e)(()=>requestHook(span, request), (error)=>{
            if (!error) return;
            this._diag.error('requestHook', error);
        }, true);
    }
    /**
     * Prepares a span data - needed later for matching appropriate network
     *     resources
     * @param spanUrl
     */ _prepareSpanData(spanUrl) {
        const startTime = $bd29e81cd70a2732$export$24b3f7dcd2848fa8();
        const entries = [];
        if (typeof PerformanceObserver !== 'function') return {
            entries: entries,
            startTime: startTime,
            spanUrl: spanUrl
        };
        const observer = new PerformanceObserver((list)=>{
            const perfObsEntries = list.getEntries();
            perfObsEntries.forEach((entry)=>{
                if (entry.initiatorType === 'fetch' && entry.name === spanUrl) entries.push(entry);
            });
        });
        observer.observe({
            entryTypes: [
                'resource'
            ]
        });
        return {
            entries: entries,
            observer: observer,
            startTime: startTime,
            spanUrl: spanUrl
        };
    }
    /**
     * implements enable function
     */ enable() {
        if ($2ca417de41fd3f3d$var$isNode) {
            // Node.js v18+ *does* have a global `fetch()`, but this package does not
            // support instrumenting it.
            this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
            return;
        }
        if ((0, $e5045196367e2654$export$ec0fd572751979bc)(fetch)) {
            this._unwrap((0, $cf2085415f7cd9be$export$5c524ddf7208c00c), 'fetch');
            this._diag.debug('removing previous patch for constructor');
        }
        this._wrap((0, $cf2085415f7cd9be$export$5c524ddf7208c00c), 'fetch', this._patchConstructor());
    }
    /**
     * implements unpatch function
     */ disable() {
        if ($2ca417de41fd3f3d$var$isNode) return;
        this._unwrap((0, $cf2085415f7cd9be$export$5c524ddf7208c00c), 'fetch');
        this._usedResources = new WeakSet();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $2a3b8ba89960fe51$var$SUPPRESS_TRACING_KEY = (0, $a50b1446b3c4bd0a$export$b8c322c5a7cfce78)('OpenTelemetry SDK Context Key SUPPRESS_TRACING');
function $2a3b8ba89960fe51$export$869298f9835abc68(context) {
    return context.setValue($2a3b8ba89960fe51$var$SUPPRESS_TRACING_KEY, true);
}
function $2a3b8ba89960fe51$export$a8cb26cef1019d30(context) {
    return context.deleteValue($2a3b8ba89960fe51$var$SUPPRESS_TRACING_KEY);
}
function $2a3b8ba89960fe51$export$7d5f2376f7cf513(context) {
    return context.getValue($2a3b8ba89960fe51$var$SUPPRESS_TRACING_KEY) === true;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1615a6b145770120$var$VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
const $1615a6b145770120$var$VALID_KEY = `[a-z]${$1615a6b145770120$var$VALID_KEY_CHAR_RANGE}{0,255}`;
const $1615a6b145770120$var$VALID_VENDOR_KEY = `[a-z0-9]${$1615a6b145770120$var$VALID_KEY_CHAR_RANGE}{0,240}@[a-z]${$1615a6b145770120$var$VALID_KEY_CHAR_RANGE}{0,13}`;
const $1615a6b145770120$var$VALID_KEY_REGEX = new RegExp(`^(?:${$1615a6b145770120$var$VALID_KEY}|${$1615a6b145770120$var$VALID_VENDOR_KEY})$`);
const $1615a6b145770120$var$VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
const $1615a6b145770120$var$INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function $1615a6b145770120$export$469cc9c479301ba6(key) {
    return $1615a6b145770120$var$VALID_KEY_REGEX.test(key);
}
function $1615a6b145770120$export$b76e9316566cc26e(value) {
    return $1615a6b145770120$var$VALID_VALUE_BASE_REGEX.test(value) && !$1615a6b145770120$var$INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}


const $9c2d70aad95d92da$var$MAX_TRACE_STATE_ITEMS = 32;
const $9c2d70aad95d92da$var$MAX_TRACE_STATE_LEN = 512;
const $9c2d70aad95d92da$var$LIST_MEMBERS_SEPARATOR = ',';
const $9c2d70aad95d92da$var$LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
class $9c2d70aad95d92da$export$b0addedc390b67c2 {
    _internalState = new Map();
    constructor(rawTraceState){
        if (rawTraceState) this._parse(rawTraceState);
    }
    set(key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        const traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState.delete(key);
        traceState._internalState.set(key, value);
        return traceState;
    }
    unset(key) {
        const traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    }
    get(key) {
        return this._internalState.get(key);
    }
    serialize() {
        return this._keys().reduce((agg, key)=>{
            agg.push(key + $9c2d70aad95d92da$var$LIST_MEMBER_KEY_VALUE_SPLITTER + this.get(key));
            return agg;
        }, []).join($9c2d70aad95d92da$var$LIST_MEMBERS_SEPARATOR);
    }
    _parse(rawTraceState) {
        if (rawTraceState.length > $9c2d70aad95d92da$var$MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split($9c2d70aad95d92da$var$LIST_MEMBERS_SEPARATOR).reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
        .reduce((agg, part)=>{
            const listMember = part.trim(); // Optional Whitespace (OWS) handling
            const i = listMember.indexOf($9c2d70aad95d92da$var$LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                const key = listMember.slice(0, i);
                const value = listMember.slice(i + 1, part.length);
                if ((0, $1615a6b145770120$export$469cc9c479301ba6)(key) && (0, $1615a6b145770120$export$b76e9316566cc26e)(value)) agg.set(key, value);
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > $9c2d70aad95d92da$var$MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse() // Use reverse same as original tracestate parse chain
        .slice(0, $9c2d70aad95d92da$var$MAX_TRACE_STATE_ITEMS));
    }
    _keys() {
        return Array.from(this._internalState.keys()).reverse();
    }
    _clone() {
        const traceState = new $9c2d70aad95d92da$export$b0addedc390b67c2();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    }
}


const $d133ac16ab96276c$export$830e05fa2746348 = 'traceparent';
const $d133ac16ab96276c$export$2b12ed38dcfae2ae = 'tracestate';
const $d133ac16ab96276c$var$VERSION = '00';
const $d133ac16ab96276c$var$VERSION_PART = '(?!ff)[\\da-f]{2}';
const $d133ac16ab96276c$var$TRACE_ID_PART = '(?![0]{32})[\\da-f]{32}';
const $d133ac16ab96276c$var$PARENT_ID_PART = '(?![0]{16})[\\da-f]{16}';
const $d133ac16ab96276c$var$FLAGS_PART = '[\\da-f]{2}';
const $d133ac16ab96276c$var$TRACE_PARENT_REGEX = new RegExp(`^\\s?(${$d133ac16ab96276c$var$VERSION_PART})-(${$d133ac16ab96276c$var$TRACE_ID_PART})-(${$d133ac16ab96276c$var$PARENT_ID_PART})-(${$d133ac16ab96276c$var$FLAGS_PART})(-.*)?\\s?$`);
function $d133ac16ab96276c$export$f4d87f8901a93f5d(traceParent) {
    const match = $d133ac16ab96276c$var$TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    // According to the specification the implementation should be compatible
    // with future versions. If there are more parts, we only reject it if it's using version 00
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    if (match[1] === '00' && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
class $d133ac16ab96276c$export$737c747d043a1f7b {
    inject(context, carrier, setter) {
        const spanContext = (0, $a1569335aa614ed8$export$357889f174732d38).getSpanContext(context);
        if (!spanContext || (0, $2a3b8ba89960fe51$export$7d5f2376f7cf513)(context) || !(0, $a89fc3550e8ac673$export$e4373b9a2c09216c)(spanContext)) return;
        const traceParent = `${$d133ac16ab96276c$var$VERSION}-${spanContext.traceId}-${spanContext.spanId}-0${Number(spanContext.traceFlags || (0, $974e5505212bea35$export$bf9049ad2b0883ff).NONE).toString(16)}`;
        setter.set(carrier, $d133ac16ab96276c$export$830e05fa2746348, traceParent);
        if (spanContext.traceState) setter.set(carrier, $d133ac16ab96276c$export$2b12ed38dcfae2ae, spanContext.traceState.serialize());
    }
    extract(context, carrier, getter) {
        const traceParentHeader = getter.get(carrier, $d133ac16ab96276c$export$830e05fa2746348);
        if (!traceParentHeader) return context;
        const traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== 'string') return context;
        const spanContext = $d133ac16ab96276c$export$f4d87f8901a93f5d(traceParent);
        if (!spanContext) return context;
        spanContext.isRemote = true;
        const traceStateHeader = getter.get(carrier, $d133ac16ab96276c$export$2b12ed38dcfae2ae);
        if (traceStateHeader) {
            // If more than one `tracestate` header is found, we merge them into a
            // single header.
            const state = Array.isArray(traceStateHeader) ? traceStateHeader.join(',') : traceStateHeader;
            spanContext.traceState = new (0, $9c2d70aad95d92da$export$b0addedc390b67c2)(typeof state === 'string' ? state : undefined);
        }
        return (0, $a1569335aa614ed8$export$357889f174732d38).setSpanContext(context, spanContext);
    }
    fields() {
        return [
            $d133ac16ab96276c$export$830e05fa2746348,
            $d133ac16ab96276c$export$2b12ed38dcfae2ae
        ];
    }
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ var $e8d17355ab785685$export$74be52df2d6fd28c;
(function(PerformanceTimingNames) {
    PerformanceTimingNames["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames["CONNECT_START"] = "connectStart";
    PerformanceTimingNames["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames["FETCH_START"] = "fetchStart";
    PerformanceTimingNames["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames["REQUEST_START"] = "requestStart";
    PerformanceTimingNames["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames["START_TIME"] = "startTime";
    PerformanceTimingNames["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames["UNLOAD_EVENT_START"] = "unloadEventStart";
})($e8d17355ab785685$export$74be52df2d6fd28c || ($e8d17355ab785685$export$74be52df2d6fd28c = {}));


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ function $b1593213f4b74563$export$c2a944331f80ae92(url, urlToMatch) {
    if (typeof urlToMatch === 'string') return url === urlToMatch;
    else return !!url.match(urlToMatch);
}
function $b1593213f4b74563$export$172b5a1c42a6f83d(url, ignoredUrls) {
    if (!ignoredUrls) return false;
    for (const ignoreUrl of ignoredUrls){
        if ($b1593213f4b74563$export$c2a944331f80ae92(url, ignoreUrl)) return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * Deprecated, use `http.response.header.<key>` instead.
 *
 * @example 3495
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 *
 * @deprecated Replaced by `http.response.header.<key>`.
 */ const $2049f7584b342f39$export$237bc893b534cd8c = 'http.response_content_length';
const $2049f7584b342f39$export$651dae55eea4b228 = 'http.response_content_length_uncompressed';


// Used to normalize relative URLs
let $59ebb463b0007a01$var$urlNormalizingAnchor;
function $59ebb463b0007a01$var$getUrlNormalizingAnchor() {
    if (!$59ebb463b0007a01$var$urlNormalizingAnchor) $59ebb463b0007a01$var$urlNormalizingAnchor = document.createElement('a');
    return $59ebb463b0007a01$var$urlNormalizingAnchor;
}
function $59ebb463b0007a01$export$94df19ecb868bc1a(obj, key) {
    return key in obj;
}
function $59ebb463b0007a01$export$7e5e8f17966d37d1(span, performanceName, entries, ignoreZeros = true) {
    if ($59ebb463b0007a01$export$94df19ecb868bc1a(entries, performanceName) && typeof entries[performanceName] === 'number' && !(ignoreZeros && entries[performanceName] === 0)) return span.addEvent(performanceName, entries[performanceName]);
    return undefined;
}
function $59ebb463b0007a01$export$e2385716cf129455(span, resource, ignoreNetworkEvents = false, ignoreZeros, skipOldSemconvContentLengthAttrs) {
    if (ignoreZeros === undefined) ignoreZeros = resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).START_TIME] !== 0;
    if (!ignoreNetworkEvents) {
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOMAIN_LOOKUP_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOMAIN_LOOKUP_END, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).CONNECT_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).SECURE_CONNECTION_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).CONNECT_END, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).REQUEST_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END, resource, ignoreZeros);
    }
    if (!skipOldSemconvContentLengthAttrs) {
        // This block adds content-length-related span attributes using the
        // *old* HTTP semconv (v1.7.0).
        const encodedLength = resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).ENCODED_BODY_SIZE];
        if (encodedLength !== undefined) span.setAttribute((0, $2049f7584b342f39$export$237bc893b534cd8c), encodedLength);
        const decodedLength = resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).DECODED_BODY_SIZE];
        // Spec: Not set if transport encoding not used (in which case encoded and decoded sizes match)
        if (decodedLength !== undefined && encodedLength !== decodedLength) span.setAttribute((0, $2049f7584b342f39$export$651dae55eea4b228), decodedLength);
    }
}
function $59ebb463b0007a01$export$5d17283e524de23c(filteredResources) {
    return filteredResources.slice().sort((a, b)=>{
        const valueA = a[(0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START];
        const valueB = b[(0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
/** Returns the origin if present (if in browser context). */ function $59ebb463b0007a01$var$getOrigin() {
    return typeof location !== 'undefined' ? location.origin : undefined;
}
function $59ebb463b0007a01$export$cdcba7438a7553e8(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources = new WeakSet(), initiatorType) {
    // de-relativize the URL before usage (does no harm to absolute URLs)
    const parsedSpanUrl = $59ebb463b0007a01$export$7a5253c0f62e0150(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    const filteredResources = $59ebb463b0007a01$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: undefined
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    const sorted = $59ebb463b0007a01$export$5d17283e524de23c(filteredResources);
    if (parsedSpanUrl.origin !== $59ebb463b0007a01$var$getOrigin() && sorted.length > 1) {
        let corsPreFlightRequest = sorted[0];
        let mainRequest = $59ebb463b0007a01$var$findMainRequest(sorted, corsPreFlightRequest[(0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END], endTimeHR);
        const responseEnd = corsPreFlightRequest[(0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END];
        const fetchStart = mainRequest[(0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START];
        // no corsPreFlightRequest
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = undefined;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
/**
 * Will find the main request skipping the cors pre flight requests
 * @param resources
 * @param corsPreFlightRequestEndTime
 * @param spanEndTimeHR
 */ function $59ebb463b0007a01$var$findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    const spanEndTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)(spanEndTimeHR);
    const minTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)((0, $3b7d94c9e2749488$export$5f4c8a8ba0e36226)(corsPreFlightRequestEndTime));
    let mainRequest = resources[1];
    let bestGap;
    const length = resources.length;
    for(let i = 1; i < length; i++){
        const resource = resources[i];
        const resourceStartTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)((0, $3b7d94c9e2749488$export$5f4c8a8ba0e36226)(resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)((0, $3b7d94c9e2749488$export$5f4c8a8ba0e36226)(resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END]));
        const currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
/**
 * Filter all resources that has started and finished according to span start time and end time.
 *     It will return the closest resource to a start time
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 */ function $59ebb463b0007a01$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    const startTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)(startTimeHR);
    const endTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)(endTimeHR);
    let filteredResources = resources.filter((resource)=>{
        const resourceStartTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)((0, $3b7d94c9e2749488$export$5f4c8a8ba0e36226)(resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)((0, $3b7d94c9e2749488$export$5f4c8a8ba0e36226)(resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || 'xmlhttprequest') && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter((resource)=>{
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function $59ebb463b0007a01$export$7a5253c0f62e0150(url) {
    if (typeof URL === 'function') return new URL(url, typeof document !== 'undefined' ? document.baseURI : typeof location !== 'undefined' // Some JS runtimes (e.g. Deno) don't define this
     ? location.href : undefined);
    const element = $59ebb463b0007a01$var$getUrlNormalizingAnchor();
    element.href = url;
    return element;
}
function $59ebb463b0007a01$export$6535eb414fa2c8b6(url) {
    const urlLike = $59ebb463b0007a01$export$7a5253c0f62e0150(url);
    return urlLike.href;
}
function $59ebb463b0007a01$export$fabdebd274ccbd1c(target, optimised) {
    if (target.nodeType === Node.DOCUMENT_NODE) return '/';
    const targetValue = $59ebb463b0007a01$var$getNodeValue(target, optimised);
    if (optimised && targetValue.indexOf('@id') > 0) return targetValue;
    let xpath = '';
    if (target.parentNode) xpath += $59ebb463b0007a01$export$fabdebd274ccbd1c(target.parentNode, optimised);
    xpath += targetValue;
    return xpath;
}
/**
 * get node index within the siblings
 * @param target
 */ function $59ebb463b0007a01$var$getNodeIndex(target) {
    if (!target.parentNode) return 0;
    const allowedTypes = [
        target.nodeType
    ];
    if (target.nodeType === Node.CDATA_SECTION_NODE) allowedTypes.push(Node.TEXT_NODE);
    let elements = Array.from(target.parentNode.childNodes);
    elements = elements.filter((element)=>{
        const localName = element.localName;
        return allowedTypes.indexOf(element.nodeType) >= 0 && localName === target.localName;
    });
    if (elements.length >= 1) return elements.indexOf(target) + 1; // xpath starts from 1
    // if there are no other similar child xpath doesn't need index
    return 0;
}
/**
 * get node value for xpath
 * @param target
 * @param optimised
 */ function $59ebb463b0007a01$var$getNodeValue(target, optimised) {
    const nodeType = target.nodeType;
    const index = $59ebb463b0007a01$var$getNodeIndex(target);
    let nodeValue = '';
    if (nodeType === Node.ELEMENT_NODE) {
        const id = target.getAttribute('id');
        if (optimised && id) return `//*[@id="${id}"]`;
        nodeValue = target.localName;
    } else if (nodeType === Node.TEXT_NODE || nodeType === Node.CDATA_SECTION_NODE) nodeValue = 'text()';
    else if (nodeType === Node.COMMENT_NODE) nodeValue = 'comment()';
    else return '';
    // if index is 1 it can be omitted in xpath
    if (nodeValue && index > 1) return `/${nodeValue}[${index}]`;
    return `/${nodeValue}`;
}
function $59ebb463b0007a01$export$c6501d7e56a5b40a(spanUrl, propagateTraceHeaderCorsUrls) {
    let propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === 'string' || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    const parsedSpanUrl = $59ebb463b0007a01$export$7a5253c0f62e0150(spanUrl);
    if (parsedSpanUrl.origin === $59ebb463b0007a01$var$getOrigin()) return true;
    else return propagateTraceHeaderUrls.some((propagateTraceHeaderUrl)=>(0, $b1593213f4b74563$export$c2a944331f80ae92)(spanUrl, propagateTraceHeaderUrl));
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $20dfdf021ac74c82$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["DOCUMENT_LOAD"] = "documentLoad";
    AttributeNames["DOCUMENT_FETCH"] = "documentFetch";
    AttributeNames["RESOURCE_FETCH"] = "resourceFetch";
})($20dfdf021ac74c82$export$668754fb61dd076c || ($20dfdf021ac74c82$export$668754fb61dd076c = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $46e2973adff74f29$export$4a03ffab3315ee34 = '0.45.0';
const $46e2973adff74f29$export$b8b9d90f9e5bd72b = '@opentelemetry/instrumentation-document-load';



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d97c9a01d142b989$export$3fd36d65bf762270;
(function(EventNames) {
    EventNames["FIRST_PAINT"] = "firstPaint";
    EventNames["FIRST_CONTENTFUL_PAINT"] = "firstContentfulPaint";
})($d97c9a01d142b989$export$3fd36d65bf762270 || ($d97c9a01d142b989$export$3fd36d65bf762270 = {}));


const $ff864c8153add48a$export$1edb6265ef1ecc26 = ()=>{
    const entries = {};
    const performanceNavigationTiming = (0, $02b2267f7388e0c4$export$b22daef4119238cd).getEntriesByType?.('navigation')[0];
    if (performanceNavigationTiming) {
        const keys = Object.values((0, $e8d17355ab785685$export$74be52df2d6fd28c));
        keys.forEach((key)=>{
            if ((0, $59ebb463b0007a01$export$94df19ecb868bc1a)(performanceNavigationTiming, key)) {
                const value = performanceNavigationTiming[key];
                if (typeof value === 'number') entries[key] = value;
            }
        });
    } else {
        // // fallback to previous version
        const perf = (0, $02b2267f7388e0c4$export$b22daef4119238cd);
        const performanceTiming = perf.timing;
        if (performanceTiming) {
            const keys = Object.values((0, $e8d17355ab785685$export$74be52df2d6fd28c));
            keys.forEach((key)=>{
                if ((0, $59ebb463b0007a01$export$94df19ecb868bc1a)(performanceTiming, key)) {
                    const value = performanceTiming[key];
                    if (typeof value === 'number') entries[key] = value;
                }
            });
        }
    }
    return entries;
};
const $ff864c8153add48a$var$performancePaintNames = {
    'first-paint': (0, $d97c9a01d142b989$export$3fd36d65bf762270).FIRST_PAINT,
    'first-contentful-paint': (0, $d97c9a01d142b989$export$3fd36d65bf762270).FIRST_CONTENTFUL_PAINT
};
const $ff864c8153add48a$export$dbffc7a51b89acf6 = (span)=>{
    const performancePaintTiming = (0, $02b2267f7388e0c4$export$b22daef4119238cd).getEntriesByType?.('paint');
    if (performancePaintTiming) performancePaintTiming.forEach(({ name: name, startTime: startTime })=>{
        if ((0, $59ebb463b0007a01$export$94df19ecb868bc1a)($ff864c8153add48a$var$performancePaintNames, name)) span.addEvent($ff864c8153add48a$var$performancePaintNames[name], startTime);
    });
};


class $2d936f74e3529f90$export$381e8ef2e310d2c3 extends (0, $be89eb9a2ed8d8a6$export$436b1c2bf7e9756b) {
    component = 'document-load';
    version = '1';
    moduleName = this.component;
    constructor(config = {}){
        super((0, $46e2973adff74f29$export$b8b9d90f9e5bd72b), (0, $46e2973adff74f29$export$4a03ffab3315ee34), config);
    }
    init() {}
    /**
     * callback to be executed when page is loaded
     */ _onDocumentLoaded() {
        // Timeout is needed as load event doesn't have yet the performance metrics for loadEnd.
        // Support for event "loadend" is very limited and cannot be used
        window.setTimeout(()=>{
            this._collectPerformance();
        });
    }
    /**
     * Adds spans for all resources
     * @param rootSpan
     */ _addResourcesSpans(rootSpan) {
        const resources = (0, $02b2267f7388e0c4$export$b22daef4119238cd).getEntriesByType?.('resource');
        if (resources) resources.forEach((resource)=>{
            this._initResourceSpan(resource, rootSpan);
        });
    }
    /**
     * Collects information about performance and creates appropriate spans
     */ _collectPerformance() {
        const metaElement = Array.from(document.getElementsByTagName('meta')).find((e)=>e.getAttribute('name') === (0, $d133ac16ab96276c$export$830e05fa2746348));
        const entries = (0, $ff864c8153add48a$export$1edb6265ef1ecc26)();
        const traceparent = metaElement && metaElement.content || '';
        (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).with((0, $c76b4b4057b01033$export$3e49040daa9dba20).extract((0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc), {
            traceparent: traceparent
        }), ()=>{
            const rootSpan = this._startSpan((0, $20dfdf021ac74c82$export$668754fb61dd076c).DOCUMENT_LOAD, (0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START, entries);
            if (!rootSpan) return;
            (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).with((0, $a1569335aa614ed8$export$357889f174732d38).setSpan((0, $e8248f70bfae46d0$export$a078c61943f9dbbe).active(), rootSpan), ()=>{
                const fetchSpan = this._startSpan((0, $20dfdf021ac74c82$export$668754fb61dd076c).DOCUMENT_FETCH, (0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START, entries);
                if (fetchSpan) {
                    fetchSpan.setAttribute((0, $6feacf3bb3931a8f$export$2f4ef7e39c2be395), location.href);
                    (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).with((0, $a1569335aa614ed8$export$357889f174732d38).setSpan((0, $e8248f70bfae46d0$export$a078c61943f9dbbe).active(), fetchSpan), ()=>{
                        if (!this.getConfig().ignoreNetworkEvents) (0, $59ebb463b0007a01$export$e2385716cf129455)(fetchSpan, entries);
                        this._addCustomAttributesOnSpan(fetchSpan, this.getConfig().applyCustomAttributesOnSpan?.documentFetch);
                        this._endSpan(fetchSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END, entries);
                    });
                }
            });
            rootSpan.setAttribute((0, $6feacf3bb3931a8f$export$2f4ef7e39c2be395), location.href);
            rootSpan.setAttribute((0, $6feacf3bb3931a8f$export$7472b18f42d2d02f), navigator.userAgent);
            this._addResourcesSpans(rootSpan);
            if (!this.getConfig().ignoreNetworkEvents) {
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).UNLOAD_EVENT_START, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).UNLOAD_EVENT_END, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOM_INTERACTIVE, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOM_CONTENT_LOADED_EVENT_START, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOM_CONTENT_LOADED_EVENT_END, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOM_COMPLETE, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).LOAD_EVENT_START, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).LOAD_EVENT_END, entries);
            }
            if (!this.getConfig().ignorePerformancePaintEvents) (0, $ff864c8153add48a$export$dbffc7a51b89acf6)(rootSpan);
            this._addCustomAttributesOnSpan(rootSpan, this.getConfig().applyCustomAttributesOnSpan?.documentLoad);
            this._endSpan(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).LOAD_EVENT_END, entries);
        });
    }
    /**
     * Helper function for ending span
     * @param span
     * @param performanceName name of performance entry for time end
     * @param entries
     */ _endSpan(span, performanceName, entries) {
        // span can be undefined when entries are missing the certain performance - the span will not be created
        if (span) {
            if ((0, $59ebb463b0007a01$export$94df19ecb868bc1a)(entries, performanceName)) span.end(entries[performanceName]);
            else // just end span
            span.end();
        }
    }
    /**
     * Creates and ends a span with network information about resource added as timed events
     * @param resource
     * @param parentSpan
     */ _initResourceSpan(resource, parentSpan) {
        const span = this._startSpan((0, $20dfdf021ac74c82$export$668754fb61dd076c).RESOURCE_FETCH, (0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START, resource, parentSpan);
        if (span) {
            span.setAttribute((0, $6feacf3bb3931a8f$export$2f4ef7e39c2be395), resource.name);
            if (!this.getConfig().ignoreNetworkEvents) (0, $59ebb463b0007a01$export$e2385716cf129455)(span, resource);
            this._addCustomAttributesOnResourceSpan(span, resource, this.getConfig().applyCustomAttributesOnSpan?.resourceFetch);
            this._endSpan(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END, resource);
        }
    }
    /**
     * Helper function for starting a span
     * @param spanName name of span
     * @param performanceName name of performance entry for time start
     * @param entries
     * @param parentSpan
     */ _startSpan(spanName, performanceName, entries, parentSpan) {
        if ((0, $59ebb463b0007a01$export$94df19ecb868bc1a)(entries, performanceName) && typeof entries[performanceName] === 'number') {
            const span = this.tracer.startSpan(spanName, {
                startTime: entries[performanceName]
            }, parentSpan ? (0, $a1569335aa614ed8$export$357889f174732d38).setSpan((0, $e8248f70bfae46d0$export$a078c61943f9dbbe).active(), parentSpan) : undefined);
            return span;
        }
        return undefined;
    }
    /**
     * executes callback {_onDocumentLoaded} when the page is loaded
     */ _waitForPageLoad() {
        if (window.document.readyState === 'complete') this._onDocumentLoaded();
        else {
            this._onDocumentLoaded = this._onDocumentLoaded.bind(this);
            window.addEventListener('load', this._onDocumentLoaded);
        }
    }
    /**
     * adds custom attributes to root span if configured
     */ _addCustomAttributesOnSpan(span, applyCustomAttributesOnSpan) {
        if (applyCustomAttributesOnSpan) (0, $e5045196367e2654$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span), (error)=>{
            if (!error) return;
            this._diag.error('addCustomAttributesOnSpan', error);
        }, true);
    }
    /**
     * adds custom attributes to span if configured
     */ _addCustomAttributesOnResourceSpan(span, resource, applyCustomAttributesOnSpan) {
        if (applyCustomAttributesOnSpan) (0, $e5045196367e2654$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span, resource), (error)=>{
            if (!error) return;
            this._diag.error('addCustomAttributesOnResourceSpan', error);
        }, true);
    }
    /**
     * implements enable function
     */ enable() {
        // remove previously attached load to avoid adding the same event twice
        // in case of multiple enable calling.
        window.removeEventListener('load', this._onDocumentLoaded);
        this._waitForPageLoad();
    }
    /**
     * implements disable function
     */ disable() {
        window.removeEventListener('load', this._onDocumentLoaded);
    }
}








var $5FZWK = parcelRequire("5FZWK");

var $kdMEA = parcelRequire("kdMEA");

var $2rYkD = parcelRequire("2rYkD");

var $3RB0m = parcelRequire("3RB0m");
const $f6050bdd136b78fe$var$TelemetryContextDefaultValues = {
    enabled: true,
    sendTrace: ()=>{},
    sendErrorTrace: ()=>{}
};
const $f6050bdd136b78fe$export$7b6b7bc4acb29126 = /*#__PURE__*/ (0, $bxRTa.createContext)($f6050bdd136b78fe$var$TelemetryContextDefaultValues);
function $f6050bdd136b78fe$export$a15d15518a3ec33d() {
    return (0, $bxRTa.useContext)($f6050bdd136b78fe$export$7b6b7bc4acb29126);
}
function $f6050bdd136b78fe$export$bb3ea6dd2428edb6({ children: children }) {
    const userId = (0, $5FZWK.useSelector)((state)=>state.directlineReducer.userId);
    const conversationId = (0, $5FZWK.useSelector)((state)=>state.activityReducer.conversationId);
    const enabled = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.enableTelemetry);
    const addressData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.addressData);
    const lastActivity = (0, $5FZWK.useSelector)((state)=>state.activityReducer.lastActivity);
    const botStreamingActivities = (0, $5FZWK.useSelector)((state)=>state.activityReducer.botStreamingActivities);
    const tracerRef = (0, $bxRTa.useRef)(undefined);
    const lastUserActivityRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (enabled !== false) {
            const exporter = new (0, $392d64385d8e7a6b$export$f73dc942b4b27de3)({
                url: (0, $kdMEA.telemetryAddress),
                headers: {},
                concurrencyLimit: 1
            });
            let serviceNamespace = '';
            switch(addressData.prefix){
                case 'dev':
                    serviceNamespace = 'retorik-dev';
                    break;
                case 'staging':
                case 'preview':
                    serviceNamespace = 'retorik-preview';
                    break;
                case 'experimental':
                    serviceNamespace = 'retorik-experimental';
                    break;
                default:
                    serviceNamespace = 'retorik-prod';
                    break;
            }
            // Create resource with custom parameters used globally in uptrace
            const resource = (0, $f5d296ad825fd0d7$export$522a862cad1b0abc)().merge((0, $f5d296ad825fd0d7$export$bb0fe4e7060febbf)({
                [(0, $d77970ee83c3563c$export$84187ab40ae4fa9c)]: 'retorik-framework',
                ['davi.retorik.activity.conversation.id']: conversationId,
                ['service_namespace']: serviceNamespace,
                ['retorik_framework_version']: (0, $3RB0m.version),
                ['user_id']: userId
            }));
            const processor = new (0, $09d39f20801a455d$export$237547059fd543f9)(exporter);
            const provider = new (0, $bebde9d422ce0bc5$export$a785009afeee3453)({
                resource: resource,
                spanProcessors: [
                    processor
                ]
            });
            provider.register();
            // Add common attributes to each span for better tracing
            (0, $2c0724552941680d$export$fc0a1ca5231d826a)({
                instrumentations: [
                    new (0, $2ca417de41fd3f3d$export$f922a490458c98a8)(),
                    new (0, $2d936f74e3529f90$export$381e8ef2e310d2c3)()
                ]
            });
            tracerRef.current = (0, $00524e035e1e9c07$export$2e2bcd8739ae039).trace.getTracer('retorik-framework');
        } else tracerRef.current = undefined;
    }, [
        enabled,
        userId,
        conversationId,
        addressData,
        (0, $3RB0m.version)
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (lastActivity) lastActivity.from.role === 'user' ? handleUserActivity(lastActivity) : handleBotActivity(lastActivity);
    }, [
        lastActivity
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (lastUserActivityRef.current) {
            const temp = botStreamingActivities[lastUserActivityRef.current.id];
            temp?.length === 1 && handleBotActivity(temp[0]);
        }
    }, [
        botStreamingActivities
    ]);
    const handleUserActivity = (activity)=>{
        // Only handle message activites and event activities waiting for an answer, nothing for typing ones
        if (activity.type === 'message' || activity.type === 'event' && !(0, $kdMEA.nonResponseInducingEvents).find((eventName)=>activity.name?.toLowerCase().includes(eventName))) lastUserActivityRef.current = {
            id: activity.id,
            time: Date.now()
        };
    };
    const handleBotActivity = (activity)=>{
        // Do nothing for bring-up messages and non-streaming events
        if (lastUserActivityRef.current && (activity.type === 'message' || activity.name?.toLocaleLowerCase() === 'davi.streammessageactivity') && activity.label?.toLowerCase() !== 'davi.bringupmessage' && activity.replyToId === lastUserActivityRef.current.id) {
            sendTrace((0, $2rYkD.TraceType).message, {
                activityId: activity.id,
                userActivity: lastUserActivityRef.current
            });
            lastUserActivityRef.current = null;
        }
    };
    const sendTrace = (type, data)=>{
        if (tracerRef.current && type) {
            const parameters = data?.activityId ? {
                'davi.retorik.activity.id': data.activityId
            } : {};
            let startTime = 0;
            switch(type){
                case (0, $2rYkD.TraceType).message:
                    if (data?.userActivity) startTime = data?.userActivity.time;
                    break;
                case (0, $2rYkD.TraceType).utteranceStart:
                case (0, $2rYkD.TraceType).utteranceEnd:
                    parameters.text = data?.text;
                    break;
            }
            const span = tracerRef.current.startSpan(type, startTime ? {
                startTime: startTime
            } : undefined);
            span.setStatus({
                code: (0, $873e79d0391b734f$export$1e28dd9b5d01db83).OK
            });
            span.setAttributes(parameters);
            span.end();
        }
    };
    const sendErrorTrace = (error)=>{
        if (tracerRef.current) {
            const span = tracerRef.current.startSpan('Error');
            span.recordException(error);
            span.setStatus({
                code: (0, $873e79d0391b734f$export$1e28dd9b5d01db83).ERROR,
                message: `${error.message}`
            });
            span.end();
        }
    };
    const value = (0, $bxRTa.useMemo)(()=>({
            enabled: enabled,
            sendTrace: sendTrace,
            sendErrorTrace: sendErrorTrace
        }), [
        enabled
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)($f6050bdd136b78fe$export$7b6b7bc4acb29126.Provider, {
        value: value,
        children: children
    });
}



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $bxRTa = parcelRequire("bxRTa");
'use client';
const $d65cae6753790fc6$export$b16d9fb1a22de840 = (0, $bxRTa.createContext)(null);
const $d65cae6753790fc6$var$initialState = {
    didCatch: false,
    error: null
};
class $d65cae6753790fc6$export$e926676385687eaf extends (0, $bxRTa.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $d65cae6753790fc6$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($d65cae6753790fc6$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $d65cae6753790fc6$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($d65cae6753790fc6$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $bxRTa.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $bxRTa.createElement)($d65cae6753790fc6$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $d65cae6753790fc6$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $d65cae6753790fc6$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $d65cae6753790fc6$export$c052f6604b7d51fe() {
    const context = (0, $bxRTa.useContext)($d65cae6753790fc6$export$b16d9fb1a22de840);
    $d65cae6753790fc6$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $bxRTa.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $bxRTa.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $d65cae6753790fc6$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $bxRTa.forwardRef)((props, ref)=>(0, $bxRTa.createElement)($d65cae6753790fc6$export$e926676385687eaf, errorBoundaryProps, (0, $bxRTa.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
const $4f2286a4170005b4$var$ErrorFallback = ({ resetErrorBoundary: resetErrorBoundary })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const handleReset = ()=>{
        resetErrorBoundary();
        window.location.reload();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-uppercase",
                children: translation.error.title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                onClick: handleReset,
                className: "rf-border rf-px-4",
                children: translation.error.button
            })
        ]
    });
};
var $4f2286a4170005b4$export$2e2bcd8739ae039 = $4f2286a4170005b4$var$ErrorFallback;


const $88f116d8e86f389c$var$ErrorCollector = ({ children: children })=>{
    const { sendErrorTrace: sendErrorTrace } = (0, $f6050bdd136b78fe$export$a15d15518a3ec33d)();
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d65cae6753790fc6$export$e926676385687eaf), {
        FallbackComponent: (0, $4f2286a4170005b4$export$2e2bcd8739ae039),
        onError: sendErrorTrace,
        children: children
    });
};
var $88f116d8e86f389c$export$2e2bcd8739ae039 = $88f116d8e86f389c$var$ErrorCollector;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
const $2a260f07721a6a05$var$ExternalHooksHandler = ({ instanceId: instanceId })=>{
    const askedForKioskParametersOpening = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.askedForKioskParametersOpening);
    const unlockClickedButton = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.unlockClickedButton);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    const retorikEvent = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.retorikEvent);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const currentValue = (0, $5FZWK.useSelector)((state)=>state.adaptiveCardReducer.currentValue);
    const values = (0, $5FZWK.useSelector)((state)=>state.adaptiveCardReducer.values);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const isWidget = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isWidget);
    const isTactile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isTactile);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const activeRecognitionState = (0, $5FZWK.useSelector)((state)=>state.speechReducer.activeRecognitionState);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const muted = (0, $5FZWK.useSelector)((state)=>state.speechReducer.muted);
    const loaderClosed = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.loaderClosed);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const conversationId = (0, $5FZWK.useSelector)((state)=>state.activityReducer.conversationId);
    const retrievingConversation = (0, $5FZWK.useSelector)((state)=>state.activityReducer.retrievingConversation);
    const askedForKioskParametersOpeningRef = (0, $bxRTa.useRef)(askedForKioskParametersOpening);
    const unlockClickedButtonRef = (0, $bxRTa.useRef)(unlockClickedButton);
    const currentSubViewRef = (0, $bxRTa.useRef)(currentSubView);
    const retorikEventRef = (0, $bxRTa.useRef)(retorikEvent);
    const localeRef = (0, $bxRTa.useRef)(locale);
    const isRTLRef = (0, $bxRTa.useRef)(isRTL);
    const translationRef = (0, $bxRTa.useRef)(translation);
    const currentValueRef = (0, $bxRTa.useRef)(currentValue);
    const valuesRef = (0, $bxRTa.useRef)(values);
    const isMobileRef = (0, $bxRTa.useRef)(isMobile);
    const isWidgetRef = (0, $bxRTa.useRef)(isWidget);
    const isTactileRef = (0, $bxRTa.useRef)(isTactile);
    const themeColorsRef = (0, $bxRTa.useRef)(themeColors);
    const activeRecognitionStateRef = (0, $bxRTa.useRef)(activeRecognitionState);
    const modeRef = (0, $bxRTa.useRef)(mode);
    const mutedRef = (0, $bxRTa.useRef)(muted);
    const loaderClosedRef = (0, $bxRTa.useRef)(loaderClosed);
    const configurationRef = (0, $bxRTa.useRef)(configuration);
    const isUsedOnBorneRef = (0, $bxRTa.useRef)(undefined);
    const inputHintBehaviourRef = (0, $bxRTa.useRef)(undefined);
    const enableDocumentPrintingRef = (0, $bxRTa.useRef)(false);
    const conversationIdRef = (0, $bxRTa.useRef)(conversationId);
    const retrievingConversationRef = (0, $bxRTa.useRef)(retrievingConversation);
    const eventDispatch = (name, value)=>{
        document.dispatchEvent(new CustomEvent(name, {
            detail: {
                instanceId: instanceId,
                value: value
            }
        }));
    };
    (0, $bxRTa.useEffect)(()=>{
        askedForKioskParametersOpeningRef.current = askedForKioskParametersOpening;
        eventDispatch('retorik_askedForKioskParametersOpening', askedForKioskParametersOpening);
    }, [
        askedForKioskParametersOpening
    ]);
    (0, $bxRTa.useEffect)(()=>{
        unlockClickedButtonRef.current = unlockClickedButton;
        eventDispatch('retorik_unlockClickedButton', unlockClickedButton);
    }, [
        unlockClickedButton
    ]);
    (0, $bxRTa.useEffect)(()=>{
        currentSubViewRef.current = currentSubView;
        eventDispatch('retorik_currentSubView', currentSubView);
    }, [
        currentSubView
    ]);
    (0, $bxRTa.useEffect)(()=>{
        retorikEventRef.current = retorikEvent;
        eventDispatch('retorik_retorikEvent', retorikEvent);
    }, [
        retorikEvent
    ]);
    (0, $bxRTa.useEffect)(()=>{
        localeRef.current = locale;
        eventDispatch('retorik_locale', locale);
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isRTLRef.current = isRTL;
        eventDispatch('retorik_isRTL', isRTL);
    }, [
        isRTL
    ]);
    (0, $bxRTa.useEffect)(()=>{
        translationRef.current = translation;
        eventDispatch('retorik_translation', translation);
    }, [
        translation
    ]);
    (0, $bxRTa.useEffect)(()=>{
        currentValueRef.current = currentValue;
        eventDispatch('retorik_currentValue', currentValue);
    }, [
        currentValue
    ]);
    (0, $bxRTa.useEffect)(()=>{
        valuesRef.current = values;
        eventDispatch('retorik_values', values);
    }, [
        values
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isMobileRef.current = isMobile;
        eventDispatch('retorik_isMobile', isMobile);
    }, [
        isMobile
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isWidgetRef.current = isWidget;
        eventDispatch('retorik_isWidget', isWidget);
    }, [
        isWidget
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isTactileRef.current = isTactile;
        eventDispatch('retorik_isTactile', isTactile);
    }, [
        isTactile
    ]);
    (0, $bxRTa.useEffect)(()=>{
        themeColorsRef.current = themeColors;
        eventDispatch('retorik_themeColors', themeColors);
    }, [
        themeColors
    ]);
    (0, $bxRTa.useEffect)(()=>{
        activeRecognitionStateRef.current = activeRecognitionState;
        eventDispatch('retorik_activeRecognitionState', activeRecognitionState);
    }, [
        activeRecognitionState
    ]);
    (0, $bxRTa.useEffect)(()=>{
        modeRef.current = mode;
        eventDispatch('retorik_mode', mode);
    }, [
        mode
    ]);
    (0, $bxRTa.useEffect)(()=>{
        mutedRef.current = muted;
        eventDispatch('retorik_muted', muted);
    }, [
        muted
    ]);
    (0, $bxRTa.useEffect)(()=>{
        loaderClosedRef.current = loaderClosed;
        eventDispatch('retorik_loaderClosed', loaderClosed);
    }, [
        loaderClosed
    ]);
    (0, $bxRTa.useEffect)(()=>{
        configurationRef.current = configuration;
        eventDispatch('retorik_configuration', configuration);
    }, [
        configuration
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isUsedOnBorneRef.current = configuration.isUsedOnBorne;
        eventDispatch('retorik_isUsedOnBorne', configuration.isUsedOnBorne);
    }, [
        configuration.isUsedOnBorne
    ]);
    (0, $bxRTa.useEffect)(()=>{
        inputHintBehaviourRef.current = configuration.speechRecognitionOptions?.inputHintBehaviour;
        eventDispatch('retorik_inputHintBehaviour', configuration.speechRecognitionOptions?.inputHintBehaviour);
    }, [
        configuration.speechRecognitionOptions?.inputHintBehaviour
    ]);
    (0, $bxRTa.useEffect)(()=>{
        enableDocumentPrintingRef.current = configuration.enableDocumentPrinting;
        eventDispatch('retorik_enableDocumentPrinting', configuration.enableDocumentPrinting);
    }, [
        configuration.enableDocumentPrinting
    ]);
    (0, $bxRTa.useEffect)(()=>{
        conversationIdRef.current = conversationId;
        eventDispatch('retorik_conversationId', conversationId);
    }, [
        conversationId
    ]);
    (0, $bxRTa.useEffect)(()=>{
        retrievingConversationRef.current = retrievingConversation;
        eventDispatch('retorik_retrievingConversation', retrievingConversation);
    }, [
        retrievingConversation
    ]);
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_call_askedForKioskParametersOpening', ()=>eventDispatch('retorik_askedForKioskParametersOpening', askedForKioskParametersOpeningRef.current));
        document.addEventListener('retorik_call_unlockClickedButton', ()=>eventDispatch('retorik_unlockClickedButton', unlockClickedButtonRef.current));
        document.addEventListener('retorik_call_currentSubView', ()=>eventDispatch('retorik_currentSubView', currentSubViewRef.current));
        document.addEventListener('retorik_call_retorikEvent', ()=>eventDispatch('retorik_retorikEvent', retorikEventRef.current));
        document.addEventListener('retorik_call_locale', ()=>eventDispatch('retorik_locale', localeRef.current));
        document.addEventListener('retorik_call_isRTL', ()=>eventDispatch('retorik_isRTL', isRTLRef.current));
        document.addEventListener('retorik_call_translation', ()=>eventDispatch('retorik_translation', translationRef.current));
        document.addEventListener('retorik_call_currentValue', ()=>eventDispatch('retorik_currentValue', currentValueRef.current));
        document.addEventListener('retorik_call_values', ()=>eventDispatch('retorik_values', valuesRef.current));
        document.addEventListener('retorik_call_isMobile', ()=>eventDispatch('retorik_isMobile', isMobileRef.current));
        document.addEventListener('retorik_call_isWidget', ()=>eventDispatch('retorik_isWidget', isWidgetRef.current));
        document.addEventListener('retorik_call_isTactile', ()=>eventDispatch('retorik_isTactile', isTactileRef.current));
        document.addEventListener('retorik_call_themeColors', ()=>eventDispatch('retorik_themeColors', themeColorsRef.current));
        document.addEventListener('retorik_call_activeRecognitionState', ()=>eventDispatch('retorik_activeRecognitionState', activeRecognitionStateRef.current));
        document.addEventListener('retorik_call_mode', ()=>eventDispatch('retorik_mode', modeRef.current));
        document.addEventListener('retorik_call_muted', ()=>eventDispatch('retorik_muted', mutedRef.current));
        document.addEventListener('retorik_call_loaderClosed', ()=>eventDispatch('retorik_loaderClosed', loaderClosedRef.current));
        document.addEventListener('retorik_call_configuration', ()=>eventDispatch('retorik_configuration', configurationRef.current));
        document.addEventListener('retorik_call_isUsedOnBorne', ()=>eventDispatch('retorik_isUsedOnBorne', isUsedOnBorneRef.current));
        document.addEventListener('retorik_call_inputHintBehaviour', ()=>eventDispatch('retorik_inputHintBehaviour', inputHintBehaviourRef.current));
        document.addEventListener('retorik_call_enableDocumentPrinting', ()=>eventDispatch('retorik_enableDocumentPrinting', enableDocumentPrintingRef.current));
        document.addEventListener('retorik_call_conversationId', ()=>eventDispatch('retorik_conversationId', conversationIdRef.current));
        document.addEventListener('retorik_call_retrievingConversation', ()=>eventDispatch('retorik_retrievingConversation', retrievingConversationRef.current));
        return ()=>{
            document.removeEventListener('retorik_call_askedForKioskParametersOpening', ()=>eventDispatch('retorik_askedForKioskParametersOpening', askedForKioskParametersOpeningRef.current));
            document.removeEventListener('retorik_call_unlockClickedButton', ()=>eventDispatch('retorik_unlockClickedButton', unlockClickedButtonRef.current));
            document.removeEventListener('retorik_call_currentSubView', ()=>eventDispatch('retorik_currentSubView', currentSubViewRef.current));
            document.removeEventListener('retorik_call_retorikEvent', ()=>eventDispatch('retorik_retorikEvent', retorikEventRef.current));
            document.removeEventListener('retorik_call_locale', ()=>eventDispatch('retorik_locale', localeRef.current));
            document.removeEventListener('retorik_call_isRTL', ()=>eventDispatch('retorik_isRTL', isRTLRef.current));
            document.removeEventListener('retorik_call_translation', ()=>eventDispatch('retorik_translation', translationRef.current));
            document.removeEventListener('retorik_call_currentValue', ()=>eventDispatch('retorik_currentValue', currentValueRef.current));
            document.removeEventListener('retorik_call_values', ()=>eventDispatch('retorik_values', valuesRef.current));
            document.removeEventListener('retorik_call_isMobile', ()=>eventDispatch('retorik_isMobile', isMobileRef.current));
            document.removeEventListener('retorik_call_isWidget', ()=>eventDispatch('retorik_isWidget', isWidgetRef.current));
            document.removeEventListener('retorik_call_isTactile', ()=>eventDispatch('retorik_isTactile', isTactileRef.current));
            document.removeEventListener('retorik_call_themeColors', ()=>eventDispatch('retorik_themeColors', themeColorsRef.current));
            document.removeEventListener('retorik_call_activeRecognitionState', ()=>eventDispatch('retorik_activeRecognitionState', activeRecognitionStateRef.current));
            document.removeEventListener('retorik_call_mode', ()=>eventDispatch('retorik_mode', modeRef.current));
            document.removeEventListener('retorik_call_muted', ()=>eventDispatch('retorik_muted', mutedRef.current));
            document.removeEventListener('retorik_call_loaderClosed', ()=>eventDispatch('retorik_loaderClosed', loaderClosedRef.current));
            document.removeEventListener('retorik_call_configuration', ()=>eventDispatch('retorik_configuration', configurationRef.current));
            document.removeEventListener('retorik_call_isUsedOnBorne', ()=>eventDispatch('retorik_isUsedOnBorne', isUsedOnBorneRef.current));
            document.removeEventListener('retorik_call_inputHintBehaviour', ()=>eventDispatch('retorik_inputHintBehaviour', inputHintBehaviourRef.current));
            document.removeEventListener('retorik_call_enableDocumentPrinting', ()=>eventDispatch('retorik_enableDocumentPrinting', enableDocumentPrintingRef.current));
            document.removeEventListener('retorik_call_conversationId', ()=>eventDispatch('retorik_conversationId', conversationIdRef.current));
            document.removeEventListener('retorik_call_retrievingConversation', ()=>eventDispatch('retorik_retrievingConversation', retrievingConversationRef.current));
        };
    }, []);
    return null;
};
var $2a260f07721a6a05$export$2e2bcd8739ae039 = $2a260f07721a6a05$var$ExternalHooksHandler;


const $bd43c48bdb8caf5f$var$GlobalProvider = ({ instanceId: instanceId, children: children })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7b2cab4dfcfe505d$export$2e2bcd8739ae039), {
                instanceId: instanceId
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2a260f07721a6a05$export$2e2bcd8739ae039), {
                instanceId: instanceId
            }),
            children
        ]
    });
};
var $bd43c48bdb8caf5f$export$2e2bcd8739ae039 = $bd43c48bdb8caf5f$var$GlobalProvider;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $aRBoq = parcelRequire("aRBoq");
var $cdcf57c966d5787f$export$83d89fbfd8236492;
var $cdcf57c966d5787f$export$80e7718417253a51;
var $cdcf57c966d5787f$export$eb3a06aef9e6ee51;
var $cdcf57c966d5787f$export$307591e98609eddd;
var $cdcf57c966d5787f$export$b23711c915539651;
var $cdcf57c966d5787f$export$7020a3240b287705;
'use strict';
var $cdcf57c966d5787f$var$l, $cdcf57c966d5787f$var$s;

$cdcf57c966d5787f$var$l = (parcelRequire("i2BIy"));

$cdcf57c966d5787f$var$s = (parcelRequire("3TORS"));
$cdcf57c966d5787f$export$83d89fbfd8236492 = $cdcf57c966d5787f$var$l.version;
$cdcf57c966d5787f$export$80e7718417253a51 = $cdcf57c966d5787f$var$l.renderToString;
$cdcf57c966d5787f$export$eb3a06aef9e6ee51 = $cdcf57c966d5787f$var$l.renderToStaticMarkup;
$cdcf57c966d5787f$export$307591e98609eddd = $cdcf57c966d5787f$var$l.renderToNodeStream;
$cdcf57c966d5787f$export$b23711c915539651 = $cdcf57c966d5787f$var$l.renderToStaticNodeStream;
$cdcf57c966d5787f$export$7020a3240b287705 = $cdcf57c966d5787f$var$s.renderToReadableStream;



var $2ARZ1 = parcelRequire("2ARZ1");
var $d3b255846a013166$var$f = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $d3b255846a013166$var$p(e, r) {
    return e(r = {
        exports: {}
    }, r.exports), r.exports;
}
var $d3b255846a013166$var$d = $d3b255846a013166$var$p(function(e) {
    !function(r) {
        var t = function(e, r, n) {
            if (!u(r) || s(r) || f(r) || p(r) || i(r)) return r;
            var o, a = 0, c = 0;
            if (l(r)) for(o = [], c = r.length; a < c; a++)o.push(t(e, r[a], n));
            else for(var d in o = {}, r)Object.prototype.hasOwnProperty.call(r, d) && (o[e(d, n)] = t(e, r[d], n));
            return o;
        }, n = function(e) {
            return d(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(e, r) {
                return r ? r.toUpperCase() : "";
            })).substr(0, 1).toLowerCase() + e.substr(1);
        }, o = function(e) {
            var r = n(e);
            return r.substr(0, 1).toUpperCase() + r.substr(1);
        }, a = function(e, r) {
            return (function(e, r) {
                var t = (r = r || {}).separator || "_", n = r.split || /(?=[A-Z])/;
                return e.split(n).join(t);
            })(e, r).toLowerCase();
        }, c = Object.prototype.toString, i = function(e) {
            return "function" == typeof e;
        }, u = function(e) {
            return e === Object(e);
        }, l = function(e) {
            return "[object Array]" == c.call(e);
        }, s = function(e) {
            return "[object Date]" == c.call(e);
        }, f = function(e) {
            return "[object RegExp]" == c.call(e);
        }, p = function(e) {
            return "[object Boolean]" == c.call(e);
        }, d = function(e) {
            return (e -= 0) == e;
        }, y = function(e, r) {
            var t = r && "process" in r ? r.process : r;
            return "function" != typeof t ? e : function(r, n) {
                return t(r, e, n);
            };
        }, h = {
            camelize: n,
            decamelize: a,
            pascalize: o,
            depascalize: a,
            camelizeKeys: function(e, r) {
                return t(y(n, r), e);
            },
            decamelizeKeys: function(e, r) {
                return t(y(a, r), e, r);
            },
            pascalizeKeys: function(e, r) {
                return t(y(o, r), e);
            },
            depascalizeKeys: function() {
                return this.decamelizeKeys.apply(this, arguments);
            }
        };
        e.exports ? e.exports = h : r.humps = h;
    }($d3b255846a013166$var$f);
}).decamelize;
var $d3b255846a013166$var$y = function(e) {
    if (Array.isArray(e)) return e;
};
var $d3b255846a013166$var$h = function(e, r) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var t = [], n = !0, o = !1, a = void 0;
        try {
            for(var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (t.push(c.value), !r || t.length !== r); n = !0);
        } catch (e) {
            o = !0, a = e;
        } finally{
            try {
                n || null == i.return || i.return();
            } finally{
                if (o) throw a;
            }
        }
        return t;
    }
};
var $d3b255846a013166$var$v = function(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
    return n;
};
var $d3b255846a013166$var$m = function(e, r) {
    if (e) {
        if ("string" == typeof e) return $d3b255846a013166$var$v(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d3b255846a013166$var$v(e, r) : void 0;
    }
};
var $d3b255846a013166$var$b = function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var $d3b255846a013166$var$g = function(e, r) {
    return $d3b255846a013166$var$y(e) || $d3b255846a013166$var$h(e, r) || $d3b255846a013166$var$m(e, r) || $d3b255846a013166$var$b();
}, $d3b255846a013166$var$S = $d3b255846a013166$var$p(function(e) {
    function r() {
        return e.exports = r = Object.assign || function(e) {
            for(var r = 1; r < arguments.length; r++){
                var t = arguments[r];
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }
            return e;
        }, r.apply(this, arguments);
    }
    e.exports = r;
});
var $d3b255846a013166$var$w = function(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)t = a[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
    return o;
};
var $d3b255846a013166$var$O = function(e, r) {
    if (null == e) return {};
    var t, n, o = $d3b255846a013166$var$w(e, r);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for(n = 0; n < a.length; n++)t = a[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
    }
    return o;
};
var $d3b255846a013166$var$j = (0, $bxRTa.createContext)(null);
function $d3b255846a013166$var$x(r) {
    var t = r.children, n = void 0 === t ? "" : t, o = $d3b255846a013166$var$O(r, [
        "children"
    ]);
    return "string" != typeof n && (n = (0, $cdcf57c966d5787f$export$80e7718417253a51)(n)), (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("template", $d3b255846a013166$var$S({}, o, {
        dangerouslySetInnerHTML: {
            __html: n
        }
    }));
}
function $d3b255846a013166$var$z(e) {
    var r = e.root, t = e.children;
    return (0, $aRBoq.createPortal)(void 0 === t ? null : t, r);
}
function $d3b255846a013166$var$E(n) {
    var i = (0, $bxRTa.forwardRef)(function(o, i) {
        var u, l, s = o.mode, f = void 0 === s ? "open" : s, p = o.delegatesFocus, d = void 0 !== p && p, y = o.styleSheets, h = void 0 === y ? [] : y, v = o.ssr, m = void 0 !== v && v, b = o.children, w = $d3b255846a013166$var$O(o, [
            "mode",
            "delegatesFocus",
            "styleSheets",
            "ssr",
            "children"
        ]), E = (l = (0, $bxRTa.useRef)((u = i) && u.current), (0, $bxRTa.useEffect)(function() {
            u && (u.current = l.current);
        }, [
            u
        ]), l), T = (0, $bxRTa.useState)(null), A = $d3b255846a013166$var$g(T, 2), C = A[0], P = A[1], F = "node_".concat(f).concat(d);
        return (0, $bxRTa.useLayoutEffect)(function() {
            if (E.current) try {
                if ("function" == typeof i && i(E.current), m) {
                    var e = E.current.shadowRoot;
                    return void P(e);
                }
                var r = E.current.attachShadow({
                    mode: f,
                    delegatesFocus: d
                });
                h.length > 0 && (r.adoptedStyleSheets = h), P(r);
            } catch (e) {
                !function(e) {
                    var r = e.error, t = e.styleSheets, n = e.root;
                    switch(r.name){
                        case "NotSupportedError":
                            t.length > 0 && (n.adoptedStyleSheets = t);
                            break;
                        default:
                            throw r;
                    }
                }({
                    error: e,
                    styleSheets: h,
                    root: C
                });
            }
        }, [
            i,
            E,
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement(n.tag, $d3b255846a013166$var$S({
            key: F,
            ref: E
        }, w), (C || m) && (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d3b255846a013166$var$j.Provider, {
            value: C
        }, m ? (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d3b255846a013166$var$x, {
            shadowroot: f,
            shadowrootmode: f
        }, n.render({
            root: C,
            ssr: m,
            children: b
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d3b255846a013166$var$z, {
            root: C
        }, n.render({
            root: C,
            ssr: m,
            children: b
        })))));
    });
    return i.propTypes = {
        mode: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOf([
            "open",
            "closed"
        ]),
        delegatesFocus: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        styleSheets: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(globalThis.CSSStyleSheet)),
        ssr: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).node
    }, i;
}
$d3b255846a013166$var$x.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).node
    ])
}, $d3b255846a013166$var$z.propTypes = {
    root: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).node
};
var $d3b255846a013166$var$T = new Map;
function $d3b255846a013166$export$64d45095031fa749() {
    return (0, $bxRTa.useContext)($d3b255846a013166$var$j);
}
function $d3b255846a013166$export$7865d0c7f908de6b() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "core", t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function(e) {
        return e.children;
    };
    return new Proxy(e, {
        get: function(e, n) {
            var o = $d3b255846a013166$var$d(n, {
                separator: "-"
            }), a = "".concat(r, "-").concat(o);
            return $d3b255846a013166$var$T.has(a) || $d3b255846a013166$var$T.set(a, $d3b255846a013166$var$E({
                tag: o,
                render: t
            })), $d3b255846a013166$var$T.get(a);
        }
    });
}
var $d3b255846a013166$var$P = $d3b255846a013166$export$7865d0c7f908de6b();
var $d3b255846a013166$export$2e2bcd8739ae039 = $d3b255846a013166$var$P;



var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
var $614775580864565d$exports = {};
$614775580864565d$exports = "*,:before,:after,::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border:0 solid}:before,:after{--tw-content:\"\"}html,:host{-webkit-text-size-adjust:100%;tab-size:4;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent;font-family:Calibri,sans-serif;line-height:1.5}body{line-height:inherit;margin:0}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-feature-settings:normal;font-variation-settings:normal;font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-feature-settings:inherit;font-variation-settings:inherit;font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:#0000;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{margin:0;padding:0;list-style:none}dialog{padding:0}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}.rf-pointer-events-none{pointer-events:none}.rf-pointer-events-auto{pointer-events:auto}.rf-visible{visibility:visible}.rf-invisible{visibility:hidden}.rf-fixed{position:fixed}.rf-absolute{position:absolute}.rf-relative{position:relative}.-rf-left-6{left:-1.5rem}.-rf-top-2{top:-.5rem}.-rf-top-4{top:-1rem}.-rf-top-6{top:-1.5rem}.-rf-top-\\[1\\.15rem\\]{top:-1.15rem}.rf-bottom-0{bottom:0}.rf-bottom-1{bottom:.25rem}.rf-bottom-1\\/4{bottom:25%}.rf-bottom-10{bottom:2.5rem}.rf-bottom-2{bottom:.5rem}.rf-bottom-4{bottom:1rem}.rf-bottom-8{bottom:2rem}.rf-bottom-\\[calc\\(100\\%\\+2rem\\)\\]{bottom:calc(100% + 2rem)}.rf-left-0{left:0}.rf-left-1{left:.25rem}.rf-left-1\\/2{left:50%}.rf-left-12{left:3rem}.rf-left-2{left:.5rem}.rf-left-32{left:8rem}.rf-left-4{left:1rem}.rf-left-8{left:2rem}.rf-left-\\[calc\\(100\\%\\+1rem\\)\\]{left:calc(100% + 1rem)}.rf-left-\\[calc\\(50\\%-3rem\\)\\]{left:calc(50% - 3rem)}.rf-right-0{right:0}.rf-right-1{right:.25rem}.rf-right-10{right:2.5rem}.rf-right-12{right:3rem}.rf-right-2{right:.5rem}.rf-right-3{right:.75rem}.rf-right-4{right:1rem}.rf-right-6{right:1.5rem}.rf-right-8{right:2rem}.rf-right-9{right:2.25rem}.rf-right-\\[calc\\(100\\%\\+1rem\\)\\]{right:calc(100% + 1rem)}.rf-top-0{top:0}.rf-top-1{top:.25rem}.rf-top-1\\/2{top:50%}.rf-top-1\\/3{top:33.3333%}.rf-top-110{top:110%}.rf-top-2{top:.5rem}.rf-top-4{top:1rem}.rf-top-8{top:2rem}.rf-top-\\[0\\.125rem\\]{top:.125rem}.rf-top-\\[calc\\(100\\%\\+1rem\\)\\]{top:calc(100% + 1rem)}.rf-top-\\[calc\\(50\\%-3rem\\)\\]{top:calc(50% - 3rem)}.rf-z-\\[10\\]{z-index:10}.rf-z-\\[19\\]{z-index:19}.rf-z-\\[1\\]{z-index:1}.rf-z-\\[2\\]{z-index:2}.rf-z-\\[3\\]{z-index:3}.rf-z-\\[4\\]{z-index:4}.rf-z-\\[5\\]{z-index:5}.rf-z-agent{z-index:1}.rf-z-exitwidget{z-index:55}.rf-z-modal{z-index:50}.rf-z-overlay{z-index:40}.rf-z-ui{z-index:20}.rf-z-util{z-index:2}.rf-col-span-1{grid-column:span 1/span 1}.rf-col-span-2{grid-column:span 2/span 2}.rf-col-span-3{grid-column:span 3/span 3}.rf-col-span-4{grid-column:span 4/span 4}.rf-col-span-full{grid-column:1/-1}.rf-col-start-1{grid-column-start:1}.rf-col-start-3{grid-column-start:3}.rf-col-start-4{grid-column-start:4}.rf-col-start-5{grid-column-start:5}.rf-col-end-2{grid-column-end:2}.rf-col-end-9{grid-column-end:9}.rf-row-span-1{grid-row:span 1/span 1}.rf-row-span-2{grid-row:span 2/span 2}.rf-row-span-full{grid-row:1/-1}.rf-row-start-1{grid-row-start:1}.rf-row-start-12{grid-row-start:12}.rf-row-end-2{grid-row-end:2}.rf-row-end-3{grid-row-end:3}.rf-float-right{float:right}.rf-m-0{margin:0}.rf-m-4{margin:1rem}.rf-m-auto{margin:auto}.-rf-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.-rf-mx-8{margin-left:-2rem;margin-right:-2rem}.rf-mx-0{margin-left:0;margin-right:0}.rf-mx-2{margin-left:.5rem;margin-right:.5rem}.rf-mx-3{margin-left:.75rem;margin-right:.75rem}.rf-mx-4{margin-left:1rem;margin-right:1rem}.rf-mx-8{margin-left:2rem;margin-right:2rem}.rf-mx-auto{margin-left:auto;margin-right:auto}.rf-my-1{margin-top:.25rem;margin-bottom:.25rem}.rf-my-2{margin-top:.5rem;margin-bottom:.5rem}.rf-my-4{margin-top:1rem;margin-bottom:1rem}.rf-my-auto{margin-top:auto;margin-bottom:auto}.rf-mb-1{margin-bottom:.25rem}.rf-mb-16{margin-bottom:4rem}.rf-mb-2{margin-bottom:.5rem}.rf-mb-26{margin-bottom:6.5rem}.rf-mb-3{margin-bottom:.75rem}.rf-mb-30{margin-bottom:7.5rem}.rf-mb-4{margin-bottom:1rem}.rf-mb-5{margin-bottom:1.25rem}.rf-mb-6{margin-bottom:1.5rem}.rf-mb-8{margin-bottom:2rem}.rf-mb-\\[15vh\\]{margin-bottom:15vh}.rf-ml-1{margin-left:.25rem}.rf-ml-16{margin-left:4rem}.rf-ml-2{margin-left:.5rem}.rf-ml-4{margin-left:1rem}.rf-ml-6{margin-left:1.5rem}.rf-mr-1{margin-right:.25rem}.rf-mr-2{margin-right:.5rem}.rf-mr-3{margin-right:.75rem}.rf-mr-4{margin-right:1rem}.rf-mr-5{margin-right:1.25rem}.rf-mt-1{margin-top:.25rem}.rf-mt-10{margin-top:2.5rem}.rf-mt-2{margin-top:.5rem}.rf-mt-4{margin-top:1rem}.rf-mt-5{margin-top:1.25rem}.rf-mt-8{margin-top:2rem}.rf-mt-\\[0\\.2rem\\]{margin-top:.2rem}.rf-mt-\\[25vh\\]{margin-top:25vh}.rf-mt-auto{margin-top:auto}.rf-box-border{box-sizing:border-box}.rf-line-clamp-1{-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-2{-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-inline{display:inline}.rf-flex{display:flex}.rf-grid{display:grid}.rf-hidden{display:none}.rf-aspect-\\[4\\/3\\]{aspect-ratio:4/3}.rf-aspect-square{aspect-ratio:1}.rf-aspect-video{aspect-ratio:16/9}.rf-h-0{height:0}.rf-h-1\\/2{height:50%}.rf-h-1\\/3{height:33.3333%}.rf-h-10{height:2.5rem}.rf-h-12{height:3rem}.rf-h-14{height:3.5rem}.rf-h-16{height:4rem}.rf-h-18{height:4.5rem}.rf-h-2{height:.5rem}.rf-h-2\\/3{height:66.6667%}.rf-h-2\\/5{height:40%}.rf-h-24{height:6rem}.rf-h-3{height:.75rem}.rf-h-3\\/10{height:30%}.rf-h-32{height:8rem}.rf-h-36{height:9rem}.rf-h-4{height:1rem}.rf-h-48{height:12rem}.rf-h-5{height:1.25rem}.rf-h-6{height:1.5rem}.rf-h-7{height:1.75rem}.rf-h-8{height:2rem}.rf-h-80{height:20rem}.rf-h-9{height:2.25rem}.rf-h-\\[0\\.875rem\\]{height:.875rem}.rf-h-\\[1\\.25rem\\]{height:1.25rem}.rf-h-\\[35\\%\\]{height:35%}.rf-h-\\[50\\%\\]{height:50%}.rf-h-\\[calc\\(50vw-3rem\\)\\]{height:calc(50vw - 3rem)}.rf-h-fit{height:fit-content}.rf-h-full{height:100%}.rf-h-max{height:max-content}.rf-h-screen{height:100vh}.rf-max-h-12{max-height:3rem}.rf-max-h-16{max-height:4rem}.rf-max-h-20{max-height:5rem}.rf-max-h-28{max-height:7rem}.rf-max-h-4\\/5{max-height:80%}.rf-max-h-48{max-height:12rem}.rf-max-h-6{max-height:1.5rem}.rf-max-h-8{max-height:2rem}.rf-max-h-80{max-height:20rem}.rf-max-h-full{max-height:100%}.rf-max-h-qrcode{max-height:120px}.rf-max-h-qrcodelarge{max-height:200px}.rf-max-h-screen{max-height:100vh}.rf-min-h-12{min-height:3rem}.rf-min-h-14{min-height:3.5rem}.rf-min-h-16{min-height:4rem}.rf-min-h-2\\/5{min-height:40%}.rf-min-h-6{min-height:1.5rem}.rf-min-h-8{min-height:2rem}.rf-min-h-9{min-height:2.25rem}.rf-min-h-fit{min-height:fit-content}.rf-min-h-full{min-height:100%}.rf-min-h-inherit{min-height:inherit}.rf-w-0{width:0}.rf-w-1\\/2{width:50%}.rf-w-1\\/3{width:33.3333%}.rf-w-1\\/4{width:25%}.rf-w-10{width:2.5rem}.rf-w-12{width:3rem}.rf-w-16{width:4rem}.rf-w-18{width:4.5rem}.rf-w-2{width:.5rem}.rf-w-2\\/3{width:66.6667%}.rf-w-20{width:5rem}.rf-w-24{width:6rem}.rf-w-3{width:.75rem}.rf-w-3\\/20{width:15%}.rf-w-3\\/4{width:75%}.rf-w-3\\/5{width:60%}.rf-w-32{width:8rem}.rf-w-36{width:9rem}.rf-w-4{width:1rem}.rf-w-48{width:12rem}.rf-w-5{width:1.25rem}.rf-w-6{width:1.5rem}.rf-w-64{width:16rem}.rf-w-7{width:1.75rem}.rf-w-8{width:2rem}.rf-w-9{width:2.25rem}.rf-w-\\[45\\%\\]{width:45%}.rf-w-\\[90\\%\\]{width:90%}.rf-w-\\[calc\\(100\\%-4rem\\)\\]{width:calc(100% - 4rem)}.rf-w-fit{width:fit-content}.rf-w-full{width:100%}.rf-w-max{width:max-content}.rf-w-screen{width:100vw}.rf-min-w-12{min-width:3rem}.rf-min-w-24{min-width:6rem}.rf-min-w-3\\/20{min-width:15%}.rf-min-w-6{min-width:1.5rem}.rf-min-w-7{min-width:1.75rem}.rf-min-w-\\[45\\%\\]{min-width:45%}.rf-min-w-full{min-width:100%}.rf-max-w-1\\/2{max-width:50%}.rf-max-w-16{max-width:4rem}.rf-max-w-3\\/20{max-width:15%}.rf-max-w-6{max-width:1.5rem}.rf-max-w-7\\/10{max-width:70%}.rf-max-w-\\[100vw\\]{max-width:100vw}.rf-max-w-\\[45\\%\\]{max-width:45%}.rf-max-w-\\[500px\\]{max-width:500px}.rf-max-w-\\[75\\%\\]{max-width:75%}.rf-max-w-\\[calc\\(100\\%-2rem\\)\\]{max-width:calc(100% - 2rem)}.rf-max-w-full{max-width:100%}.rf-max-w-none{max-width:none}.rf-flex-1{flex:1}.rf-flex-\\[0_0_40\\%\\]{flex:0 0 40%}.rf-flex-\\[2_1_0\\%\\]{flex:2}.rf-flex-\\[4_1_0\\%\\]{flex:4}.rf-border-collapse{border-collapse:collapse}.rf-origin-center{transform-origin:50%}.-rf-translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-rf-translate-y-1\\/2{--tw-translate-y:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-rf-translate-y-full{--tw-translate-y:-100%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rf--translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rf-translate-x-1{--tw-translate-x:.25rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rf-translate-x-5{--tw-translate-x:1.25rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rf-translate-y-8{--tw-translate-y:2rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rf-rotate-0{--tw-rotate:0deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rf-rotate-180{--tw-rotate:180deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rf-rotate-45{--tw-rotate:45deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rf-scale-0{--tw-scale-x:0;--tw-scale-y:0;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rf-transform{transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes rf-blink{0%,to{opacity:.2}50%{opacity:1}}.rf-animate-blink{animation:1.4s infinite both rf-blink}@keyframes rf-fadeIn{0%{opacity:0}to{opacity:1}}.rf-animate-fadeIn{animation:.5s .2s backwards rf-fadeIn}@keyframes rf-hScroll{0%{transform:translate(0)}to{transform:translate(calc(-100% - 2rem))}}.rf-animate-hScroll{animation:20s linear infinite rf-hScroll}@keyframes rf-loader{0%{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}40%{box-shadow:0 1.5rem 0 -.3rem var(--rf-color-loader-animation)}80%{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}to{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}}.rf-animate-loader{animation:1.8s ease-in-out -.16s infinite both rf-loader}.rf-animate-loaderFadeIn{animation:2s rf-fadeIn}@keyframes rf-fadeOut{0%{opacity:1}to{opacity:0}}.rf-animate-loaderFadeOut{animation:1s rf-fadeOut}@keyframes rf-loaderMedium{0%{box-shadow:0 .75rem 0 -.75rem var(--rf-color-loader-animation)}40%{box-shadow:0 .75rem 0 -.25rem var(--rf-color-loader-animation)}80%{box-shadow:0 .75rem 0 -.75rem var(--rf-color-loader-animation)}to{box-shadow:0 .75rem 0 -.75rem var(--rf-color-loader-animation)}}.rf-animate-loaderMedium{animation:1.8s ease-in-out -.16s infinite both rf-loaderMedium}@keyframes rf-loaderMini{0%{box-shadow:0 .5rem 0 -.5rem var(--rf-color-loader-animation)}40%{box-shadow:0 .5rem 0 -.1rem var(--rf-color-loader-animation)}80%{box-shadow:0 .5rem 0 -.5rem var(--rf-color-loader-animation)}to{box-shadow:0 .5rem 0 -.5rem var(--rf-color-loader-animation)}}.rf-animate-loaderMini{animation:1.8s ease-in-out -.16s infinite both rf-loaderMini}@keyframes rf-pulse{50%{opacity:.5}}.rf-animate-pulse{animation:2s cubic-bezier(.4,0,.6,1) infinite rf-pulse}@keyframes rf-slideBottom{0%{opacity:0;transform:translate(0)translateY(20px)}to{opacity:1;transform:translate(0)translateY(0)}}.rf-animate-slideBottom{animation:.5s .2s backwards rf-slideBottom}@keyframes rf-spin{to{transform:rotate(360deg)}}.rf-animate-spin{animation:1s linear infinite rf-spin}.rf-cursor-pointer{cursor:pointer}.rf-select-none{-webkit-user-select:none;user-select:none}.rf-resize-none{resize:none}.rf-scroll-pb-4{scroll-padding-bottom:1rem}.rf-appearance-none{appearance:none}.rf-grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.rf-grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.rf-grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.rf-grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.rf-grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.rf-grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.rf-grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.rf-grid-cols-\\[repeat\\(2\\,30\\%\\)\\]{grid-template-columns:repeat(2,30%)}.rf-grid-cols-\\[repeat\\(2\\,45\\%\\)\\]{grid-template-columns:repeat(2,45%)}.rf-grid-cols-\\[repeat\\(3\\,31\\%\\)\\]{grid-template-columns:repeat(3,31%)}.rf-grid-cols-headerContainer{grid-template-columns:5rem 1rem 1fr 1fr}.rf-grid-cols-printingPreview{grid-template-columns:minmax(0,1fr) 3rem}.rf-grid-cols-routes{grid-template-columns:repeat(3,max-content)}.rf-grid-rows-1{grid-template-rows:repeat(1,minmax(0,1fr))}.rf-grid-rows-12{grid-template-rows:repeat(12,minmax(0,1fr))}.rf-grid-rows-2{grid-template-rows:repeat(2,minmax(0,1fr))}.rf-grid-rows-3{grid-template-rows:repeat(3,minmax(0,1fr))}.rf-grid-rows-4{grid-template-rows:repeat(4,minmax(0,1fr))}.rf-grid-rows-5{grid-template-rows:repeat(5,minmax(0,1fr))}.rf-grid-rows-container{grid-template-rows:repeat(12,minmax(0,1fr))}.rf-grid-rows-headerContainer{grid-template-rows:repeat(2,minmax(0,1fr))}.rf-flex-row{flex-direction:row}.rf-flex-col{flex-direction:column}.rf-flex-col-reverse{flex-direction:column-reverse}.rf-flex-wrap{flex-wrap:wrap}.rf-flex-nowrap{flex-wrap:nowrap}.rf-content-end{align-content:flex-end}.rf-content-around{align-content:space-around}.rf-items-start{align-items:flex-start}.rf-items-end{align-items:flex-end}.rf-items-center{align-items:center}.rf-justify-start{justify-content:flex-start}.rf-justify-end{justify-content:flex-end}.rf-justify-center{justify-content:center}.rf-justify-between{justify-content:space-between}.rf-justify-around{justify-content:space-around}.rf-justify-evenly{justify-content:space-evenly}.rf-justify-items-end{justify-items:end}.rf-gap-1{gap:.25rem}.rf-gap-12{gap:3rem}.rf-gap-2{gap:.5rem}.rf-gap-3{gap:.75rem}.rf-gap-4{gap:1rem}.rf-gap-5{gap:1.25rem}.rf-gap-6{gap:1.5rem}.rf-gap-8{gap:2rem}.rf-gap-9{gap:2.25rem}.rf-gap-\\[10\\%\\]{gap:10%}.rf-gap-x-\\[3\\.5\\%\\]{column-gap:3.5%}.rf-divide-x>:not([hidden])~:not([hidden]){--tw-divide-x-reverse:0;border-right-width:calc(1px * var(--tw-divide-x-reverse));border-left-width:calc(1px * calc(1 - var(--tw-divide-x-reverse)))}.rf-self-auto{align-self:auto}.rf-self-start{align-self:flex-start}.rf-self-end{align-self:flex-end}.rf-self-center{align-self:center}.rf-justify-self-start{justify-self:start}.rf-justify-self-end{justify-self:end}.rf-justify-self-center{justify-self:center}.rf-overflow-hidden{overflow:hidden}.rf-overflow-clip{overflow:clip}.rf-overflow-y-auto{overflow-y:auto}.rf-overflow-x-hidden{overflow-x:hidden}.rf-overflow-y-hidden{overflow-y:hidden}.rf-overflow-y-clip{overflow-y:clip}.rf-overflow-x-visible{overflow-x:visible}.rf-overflow-y-visible{overflow-y:visible}.rf-overflow-x-scroll{overflow-x:scroll}.rf-overflow-y-scroll{overflow-y:scroll}.rf-truncate{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.rf-whitespace-nowrap{white-space:nowrap}.rf-whitespace-break-spaces{white-space:break-spaces}.rf-rounded{border-radius:.3125rem}.rf-rounded-6{border-radius:1.5rem}.rf-rounded-8{border-radius:2rem}.rf-rounded-\\[20px\\]{border-radius:20px}.rf-rounded-half{border-radius:50%}.rf-rounded-lg{border-radius:.5rem}.rf-rounded-max{border-radius:100%}.rf-rounded-b{border-bottom-right-radius:.3125rem;border-bottom-left-radius:.3125rem}.rf-rounded-b-4{border-bottom-right-radius:1rem;border-bottom-left-radius:1rem}.rf-rounded-b-lg{border-bottom-right-radius:.5rem;border-bottom-left-radius:.5rem}.rf-rounded-l-lg{border-top-left-radius:.5rem;border-bottom-left-radius:.5rem}.rf-rounded-t-lg{border-top-left-radius:.5rem;border-top-right-radius:.5rem}.rf-rounded-tl-4{border-top-left-radius:1rem}.rf-rounded-tr-4{border-top-right-radius:1rem}.rf-border{border-width:1px}.rf-border-0{border-width:0}.rf-border-2{border-width:2px}.rf-border-y{border-top-width:1px;border-bottom-width:1px}.rf-border-b{border-bottom-width:1px}.rf-border-b-2{border-bottom-width:2px}.rf-border-l{border-left-width:1px}.rf-border-r{border-right-width:1px}.rf-border-t{border-top-width:1px}.rf-border-t-0{border-top-width:0}.rf-border-none{border-style:none}.rf-border-\\[\\#00000029\\]{border-color:#00000029}.rf-border-\\[\\#1999B1\\]{--tw-border-opacity:1;border-color:rgb(25 153 177/var(--tw-border-opacity,1))}.rf-border-\\[\\#707070\\]{--tw-border-opacity:1;border-color:rgb(112 112 112/var(--tw-border-opacity,1))}.rf-border-\\[\\#8B8888\\]{--tw-border-opacity:1;border-color:rgb(139 136 136/var(--tw-border-opacity,1))}.rf-border-\\[\\#9FA2AA\\]{--tw-border-opacity:1;border-color:rgb(159 162 170/var(--tw-border-opacity,1))}.rf-border-\\[\\#C7C6C6\\]{--tw-border-opacity:1;border-color:rgb(199 198 198/var(--tw-border-opacity,1))}.rf-border-\\[\\#F0F0F0\\]{--tw-border-opacity:1;border-color:rgb(240 240 240/var(--tw-border-opacity,1))}.rf-border-black{border-color:var(--rf-color-black)}.rf-border-cardButtonBorderDefault{border-color:var(--rf-color-cardButtonBorderDefault)}.rf-border-cardButtonBorderHover{border-color:var(--rf-color-cardButtonBorderHover)}.rf-border-cardFrameBorder{border-color:var(--rf-color-cardFrameBorder)}.rf-border-formInputButtonBorderDefault{border-color:var(--rf-color-formInputButtonBorderDefault)}.rf-border-formInputButtonBorderHover{border-color:var(--rf-color-formInputButtonBorderHover)}.rf-border-formInputRadioCheckboxCheckedBorder{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder)}.rf-border-formInputRadioCheckboxUncheckedBorder{border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder)}.rf-border-gray{--tw-border-opacity:1;border-color:rgb(128 128 128/var(--tw-border-opacity,1))}.rf-border-lightgray{--tw-border-opacity:1;border-color:rgb(129 129 129/var(--tw-border-opacity,1))}.rf-border-menuBorder{--tw-border-opacity:1;border-color:rgb(224 225 231/var(--tw-border-opacity,1))}.rf-border-primary{border-color:var(--rf-color-primary)}.rf-border-secondary{border-color:var(--rf-color-secondary)}.rf-border-templateCheckboxBorder{--tw-border-opacity:1;border-color:rgb(112 112 112/var(--tw-border-opacity,1))}.rf-border-textBoxBorder{--tw-border-opacity:1;border-color:rgb(190 190 190/var(--tw-border-opacity,1))}.rf-border-textModePanelBackgroundBot{border-color:var(--rf-color-textModePanelBackgroundBot)}.rf-border-textModePanelBackgroundUser{border-color:var(--rf-color-textModePanelBackgroundUser)}.rf-border-trueblack{--tw-border-opacity:1;border-color:rgb(0 0 0/var(--tw-border-opacity,1))}.rf-border-truewhite{--tw-border-opacity:1;border-color:rgb(255 255 255/var(--tw-border-opacity,1))}.rf-border-x-primary{border-left-color:var(--rf-color-primary);border-right-color:var(--rf-color-primary)}.rf-border-y-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity,1));border-bottom-color:rgb(224 225 231/var(--tw-border-opacity,1))}.rf-border-b-\\[\\#C4C5C8\\]{--tw-border-opacity:1;border-bottom-color:rgb(196 197 200/var(--tw-border-opacity,1))}.rf-border-b-black{border-bottom-color:var(--rf-color-black)}.rf-border-b-menuBorder{--tw-border-opacity:1;border-bottom-color:rgb(224 225 231/var(--tw-border-opacity,1))}.rf-border-b-silver{--tw-border-opacity:1;border-bottom-color:rgb(192 192 192/var(--tw-border-opacity,1))}.rf-border-b-transparent{border-bottom-color:#0000}.rf-border-l-menuBorder{--tw-border-opacity:1;border-left-color:rgb(224 225 231/var(--tw-border-opacity,1))}.rf-border-r-\\[\\#8B8888\\]{--tw-border-opacity:1;border-right-color:rgb(139 136 136/var(--tw-border-opacity,1))}.rf-border-r-silver{--tw-border-opacity:1;border-right-color:rgb(192 192 192/var(--tw-border-opacity,1))}.rf-border-t-\\[\\#8B8888\\]{--tw-border-opacity:1;border-top-color:rgb(139 136 136/var(--tw-border-opacity,1))}.rf-border-t-\\[\\#CBC9C9\\]{--tw-border-opacity:1;border-top-color:rgb(203 201 201/var(--tw-border-opacity,1))}.rf-border-t-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity,1))}.rf-bg-\\[\\#00000050\\]{background-color:#00000050}.rf-bg-\\[\\#000000B3\\]{background-color:#000000b3}.rf-bg-\\[\\#121212F2\\]{background-color:#121212f2}.rf-bg-\\[\\#1999B1\\]{--tw-bg-opacity:1;background-color:rgb(25 153 177/var(--tw-bg-opacity,1))}.rf-bg-\\[\\#F0F0F0\\]{--tw-bg-opacity:1;background-color:rgb(240 240 240/var(--tw-bg-opacity,1))}.rf-bg-\\[\\#F8F8F8\\]{--tw-bg-opacity:1;background-color:rgb(248 248 248/var(--tw-bg-opacity,1))}.rf-bg-black{background-color:var(--rf-color-black)}.rf-bg-blue-500{--tw-bg-opacity:1;background-color:rgb(59 130 246/var(--tw-bg-opacity,1))}.rf-bg-cardButtonBackgroundDefault{background-color:var(--rf-color-cardButtonBackgroundDefault)}.rf-bg-cardButtonBackgroundHover{background-color:var(--rf-color-cardButtonBackgroundHover)}.rf-bg-cardFrameBackground{background-color:var(--rf-color-cardFrameBackground)}.rf-bg-formInputButtonBackgroundDefault{background-color:var(--rf-color-formInputButtonBackgroundDefault)}.rf-bg-formInputButtonBackgroundHover{background-color:var(--rf-color-formInputButtonBackgroundHover)}.rf-bg-formInputRadioCheckboxUncheckedBackground{background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground)}.rf-bg-gray{--tw-bg-opacity:1;background-color:rgb(128 128 128/var(--tw-bg-opacity,1))}.rf-bg-primary{background-color:var(--rf-color-primary)}.rf-bg-red-600{--tw-bg-opacity:1;background-color:rgb(220 38 38/var(--tw-bg-opacity,1))}.rf-bg-secondary{background-color:var(--rf-color-secondary)}.rf-bg-silver{--tw-bg-opacity:1;background-color:rgb(192 192 192/var(--tw-bg-opacity,1))}.rf-bg-templateBackground{--tw-bg-opacity:1;background-color:rgb(241 241 241/var(--tw-bg-opacity,1))}.rf-bg-templateEmptyCard{--tw-bg-opacity:1;background-color:rgb(232 231 231/var(--tw-bg-opacity,1))}.rf-bg-textModePanelBackgroundBot{background-color:var(--rf-color-textModePanelBackgroundBot)}.rf-bg-textModePanelBackgroundUser{background-color:var(--rf-color-textModePanelBackgroundUser)}.rf-bg-transparent{background-color:#0000}.rf-bg-truewhite{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.rf-bg-vocalModeSubtitlesBackground{background-color:var(--rf-color-vocalModeSubtitlesBackground)}.rf-bg-white{--tw-bg-opacity:1;background-color:rgb(247 243 246/var(--tw-bg-opacity,1))}.rf-bg-opacity-100{--tw-bg-opacity:1}.rf-bg-opacity-30{--tw-bg-opacity:.3}.rf-bg-opacity-50{--tw-bg-opacity:.5}.rf-bg-opacity-80{--tw-bg-opacity:.8}.rf-object-cover{object-fit:cover}.rf-p-1{padding:.25rem}.rf-p-2{padding:.5rem}.rf-p-3{padding:.75rem}.rf-p-4{padding:1rem}.rf-p-\\[25px\\]{padding:25px}.rf-p-\\[7px_12px\\]{padding:7px 12px}.rf-px-1{padding-left:.25rem;padding-right:.25rem}.rf-px-16{padding-left:4rem;padding-right:4rem}.rf-px-2{padding-left:.5rem;padding-right:.5rem}.rf-px-3{padding-left:.75rem;padding-right:.75rem}.rf-px-4{padding-left:1rem;padding-right:1rem}.rf-px-48{padding-left:12rem;padding-right:12rem}.rf-px-5,.rf-px-6{padding-left:1.5rem;padding-right:1.5rem}.rf-px-8{padding-left:2rem;padding-right:2rem}.rf-py-0{padding-top:0;padding-bottom:0}.rf-py-1{padding-top:.25rem;padding-bottom:.25rem}.rf-py-12{padding-top:3rem;padding-bottom:3rem}.rf-py-16{padding-top:4rem;padding-bottom:4rem}.rf-py-2{padding-top:.5rem;padding-bottom:.5rem}.rf-py-3{padding-top:.75rem;padding-bottom:.75rem}.rf-py-4{padding-top:1rem;padding-bottom:1rem}.rf-py-6{padding-top:1.5rem;padding-bottom:1.5rem}.rf-py-8{padding-top:2rem;padding-bottom:2rem}.rf-pb-10{padding-bottom:2.5rem}.rf-pb-12{padding-bottom:3rem}.rf-pb-14{padding-bottom:3.5rem}.rf-pb-2{padding-bottom:.5rem}.rf-pb-24{padding-bottom:6rem}.rf-pb-3{padding-bottom:.75rem}.rf-pb-4{padding-bottom:1rem}.rf-pb-5,.rf-pb-6{padding-bottom:1.5rem}.rf-pb-8{padding-bottom:2rem}.rf-pl-0{padding-left:0}.rf-pl-1{padding-left:.25rem}.rf-pl-2{padding-left:.5rem}.rf-pl-4{padding-left:1rem}.rf-pl-6{padding-left:1.5rem}.rf-pl-8{padding-left:2rem}.rf-pr-1{padding-right:.25rem}.rf-pr-2{padding-right:.5rem}.rf-pr-4{padding-right:1rem}.rf-pr-6{padding-right:1.5rem}.rf-pt-1{padding-top:.25rem}.rf-pt-11\\/20{padding-top:55%}.rf-pt-14{padding-top:3.5rem}.rf-pt-2{padding-top:.5rem}.rf-pt-24{padding-top:6rem}.rf-pt-3{padding-top:.75rem}.rf-pt-4{padding-top:1rem}.rf-pt-40{padding-top:10rem}.rf-pt-6{padding-top:1.5rem}.rf-pt-8{padding-top:2rem}.rf-pt-\\[26vh\\]{padding-top:26vh}.rf-text-left{text-align:left}.rf-text-center{text-align:center}.rf-text-right{text-align:right}.rf-text-justify{text-align:justify}.rf-font-default{font-family:Calibri,sans-serif}.rf-text-2xl{font-size:1.5rem;line-height:2rem}.rf-text-3xl{font-size:1.875rem;line-height:2.25rem}.rf-text-4xl{font-size:2.25rem;line-height:2.5rem}.rf-text-5xl{font-size:3rem;line-height:1}.rf-text-6xl{font-size:3.75rem;line-height:1}.rf-text-7xl{font-size:4.5rem;line-height:1}.rf-text-8xl{font-size:6rem;line-height:1}.rf-text-\\[0\\.5rem\\]{font-size:.5rem}.rf-text-arabic{font-size:1.125rem;line-height:1.15rem}.rf-text-base{font-size:1rem;line-height:1.5rem}.rf-text-basecustom{font-size:1rem;line-height:1.3rem}.rf-text-lgcustom{font-size:1.125rem;line-height:1.5rem}.rf-text-sm{font-size:.875rem;line-height:1.25rem}.rf-text-sm\\/4{font-size:.875rem;line-height:1rem}.rf-text-xl{font-size:1.25rem;line-height:1.75rem}.rf-text-xs{font-size:.75rem;line-height:1rem}.rf-text-xsl{font-size:.7rem;line-height:1rem}.rf-text-xsm{font-size:.6rem}.rf-font-bold{font-weight:600}.rf-font-light{font-weight:200}.rf-font-medium{font-weight:300}.rf-font-semibold{font-weight:400}.rf-uppercase{text-transform:uppercase}.rf-capitalize{text-transform:capitalize}.rf-normal-case{text-transform:none}.rf-italic{font-style:italic}.rf-leading-4{line-height:1rem}.rf-text-\\[\\#1999B1\\]{--tw-text-opacity:1;color:rgb(25 153 177/var(--tw-text-opacity,1))}.rf-text-\\[\\#575F6B\\]{--tw-text-opacity:1;color:rgb(87 95 107/var(--tw-text-opacity,1))}.rf-text-\\[\\#9A9A9A\\]{--tw-text-opacity:1;color:rgb(154 154 154/var(--tw-text-opacity,1))}.rf-text-\\[\\#A4A7AF\\]{--tw-text-opacity:1;color:rgb(164 167 175/var(--tw-text-opacity,1))}.rf-text-black{color:var(--rf-color-black)}.rf-text-cardButtonTextDefault{color:var(--rf-color-cardButtonTextDefault)}.rf-text-cardFrameText{color:var(--rf-color-cardFrameText)}.rf-text-formInputButtonTextDefault{color:var(--rf-color-formInputButtonTextDefault)}.rf-text-formInputButtonTextHover{color:var(--rf-color-formInputButtonTextHover)}.rf-text-formInputRadioCheckboxUncheckedBackground{color:var(--rf-color-formInputRadioCheckboxUncheckedBackground)}.rf-text-formInputTextDefault{color:var(--rf-color-formInputTextDefault)}.rf-text-gray{--tw-text-opacity:1;color:rgb(128 128 128/var(--tw-text-opacity,1))}.rf-text-lightgray{--tw-text-opacity:1;color:rgb(129 129 129/var(--tw-text-opacity,1))}.rf-text-primary{color:var(--rf-color-primary)}.rf-text-secondary{color:var(--rf-color-secondary)}.rf-text-textModePanelConversationBot{color:var(--rf-color-textModePanelConversationBot)}.rf-text-textModePanelConversationUser{color:var(--rf-color-textModePanelConversationUser)}.rf-text-trueblack{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity,1))}.rf-text-truewhite{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.rf-text-vocalModeSubtitlesText{color:var(--rf-color-vocalModeSubtitlesText)}.rf-text-white{--tw-text-opacity:1;color:rgb(247 243 246/var(--tw-text-opacity,1))}.rf-underline{text-decoration-line:underline}.rf-shadow-\\[-3px_-3px_10px_\\#00000099\\]{--tw-shadow:-3px -3px 10px #0009;--tw-shadow-colored:-3px -3px 10px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.rf-shadow-\\[0_0_15px_0_silver\\]{--tw-shadow:0 0 15px 0 silver;--tw-shadow-colored:0 0 15px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.rf-shadow-\\[0_0_20px_1px_\\#A4A7AF80\\]{--tw-shadow:0 0 20px 1px #a4a7af80;--tw-shadow-colored:0 0 20px 1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.rf-shadow-\\[0_0_3px_6px_\\#00000029\\]{--tw-shadow:0 0 3px 6px #00000029;--tw-shadow-colored:0 0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.rf-shadow-\\[0_3px_6px_\\#00000029\\]{--tw-shadow:0 3px 6px #00000029;--tw-shadow-colored:0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.rf-shadow-\\[0_3px_6px_\\#606267\\]{--tw-shadow:0 3px 6px #606267;--tw-shadow-colored:0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.rf-shadow-\\[0_6px_6px_\\#00000029\\]{--tw-shadow:0 6px 6px #00000029;--tw-shadow-colored:0 6px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.rf-shadow-\\[3px_3px_16px_\\#00000029\\]{--tw-shadow:3px 3px 16px #00000029;--tw-shadow-colored:3px 3px 16px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.rf-shadow-\\[inset_0_0_6px_\\#0000003B\\]{--tw-shadow:inset 0 0 6px #0000003b;--tw-shadow-colored:inset 0 0 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.rf-shadow-\\[inset_0_12px_12px_-12px_\\#00000029\\,inset_0_-12px_12px_-12px_\\#00000029\\]{--tw-shadow:inset 0 12px 12px -12px #00000029,inset 0 -12px 12px -12px #00000029;--tw-shadow-colored:inset 0 12px 12px -12px var(--tw-shadow-color), inset 0 -12px 12px -12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.rf-outline-none{outline-offset:2px;outline:2px solid #0000}.rf-blur-background{--tw-blur:blur(var(--rf-blur-background));filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.rf-filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.rf-transition-all{transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.rf-transition-transform{transition-property:transform;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.rf-text-shadow-black{text-shadow:2px 0 5px #000,-2px 0 5px #000,0 2px 5px #000,0 -2px 5px #000}ol{padding-left:2rem;list-style-type:decimal}ul{padding-left:2rem;list-style-type:disc}#retorik-container.rf-portrait:not(.rf-large) .ac-image{max-width:100px}.rf-glass-background,#retorik-container.portrait .portrait\\:rf-glass-background{background-color:var(--rf-color-black);--tw-bg-opacity:.62;--tw-backdrop-blur:blur(8px);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.rf-loader-bouncing-bot{aspect-ratio:2;--_g:no-repeat radial-gradient(circle closest-side, var(--rf-color-textModePanelConversationBot) 90%, transparent);background:var(--_g) 0% 50%, var(--_g) 50% 50%, var(--_g) 100% 50%;background-size:33.3333% 50%}@keyframes rf-loaderBouncing{20%{background-position:0 0,50%,100%}40%{background-position:0 100%,50% 0,100%}60%{background-position:0%,50% 100%,100% 0}80%{background-position:0%,50%,100% 100%}}.rf-loader-bouncing-bot{animation:1s linear infinite rf-loaderBouncing}.rf-loader-bouncing-white{aspect-ratio:2;--_g:no-repeat radial-gradient(circle closest-side, #fff 90%, transparent);background:var(--_g) 0% 50%, var(--_g) 50% 50%, var(--_g) 100% 50%;background-size:33.3333% 50%;animation:1s linear infinite rf-loaderBouncing}@keyframes rf-loaderPulsation{0%{transform:scale(1)}50%{transform:scale(1.1)}to{transform:scale(1)}}.rf-loader-pulsation{animation:2s cubic-bezier(.65,0,.34,1) infinite rf-loaderPulsation}.rf-loader-pulsation:before{content:\"\";background-color:var(--rf-color-secondary);z-index:-1;border-radius:50%;width:100%;height:100%;position:absolute}@keyframes rf-loaderRipple{0%{opacity:1;transform:scale(.75)}to{opacity:0;transform:scale(1.5)}}.rf-loader-pulsation:before{animation:2.4s cubic-bezier(.65,0,.34,1) .4s infinite rf-loaderRipple}.rf-loader-pulsation:after{content:\"\";background-color:var(--rf-color-secondary);z-index:-1;border-radius:50%;width:100%;height:100%;animation:2.4s cubic-bezier(.65,0,.34,1) infinite rf-loaderRipple;position:absolute}.rf-loader:before{content:\"\";border-radius:50%;width:1.5rem;height:1.5rem;animation:1.8s ease-in-out -.32s infinite both rf-loader;display:block;position:absolute;right:1.5rem}.rf-loader:after{content:\"\";border-radius:50%;width:1.5rem;height:1.5rem;animation:1.8s ease-in-out infinite both rf-loader;display:block;position:absolute;left:1.5rem}.rf-loader-medium:before{content:\"\";border-radius:50%;width:1rem;height:1rem;animation:1.8s ease-in-out -.32s infinite both rf-loaderMedium;display:block;position:absolute;right:1rem}.rf-loader-medium:after{content:\"\";border-radius:50%;width:1rem;height:1rem;animation:1.8s ease-in-out infinite both rf-loaderMedium;display:block;position:absolute;left:1rem}.rf-loader-mini:before{content:\"\";border-radius:50%;width:.5rem;height:.5rem;animation:1.8s ease-in-out -.32s infinite both rf-loaderMini;display:block;position:absolute;right:.5rem}.rf-loader-mini:after{content:\"\";border-radius:50%;width:.5rem;height:.5rem;animation:1.8s ease-in-out infinite both rf-loaderMini;display:block;position:absolute;left:.5rem}.rf-loader-microphone:before,.rf-loader-microphone:after{content:\"\";--tw-border-opacity:1;border:6px solid #0000;border-top-color:rgb(128 128 128/var(--tw-border-opacity,1));border-radius:100%;width:100%;height:100%;position:absolute;top:0;left:0}.rf-loader-microphone:before{z-index:2;animation:1s linear infinite rf-spin}.rf-loader-microphone:after{--tw-border-opacity:1;border-color:rgb(204 204 204/var(--tw-border-opacity,1))}.rf-loader-microphone-primary:before,.rf-loader-microphone-primary:after{content:\"\";border:6px solid #0000;border-top-color:var(--rf-color-primary);border-radius:100%;width:100%;height:100%;position:absolute;top:0;left:0}.rf-loader-microphone-primary:before{z-index:2;animation:1s linear infinite rf-spin}.rf-loader-microphone-primary:after{--tw-border-opacity:1;border-color:rgb(204 204 204/var(--tw-border-opacity,1))}.rf-loader-microphone-secondary:before,.rf-loader-microphone-secondary:after{content:\"\";border:6px solid #0000;border-top-color:var(--rf-color-secondary);border-radius:100%;width:100%;height:100%;position:absolute;top:0;left:0}.rf-loader-microphone-secondary:before{z-index:2;animation:1s linear infinite rf-spin}.rf-loader-microphone-secondary:after{--tw-border-opacity:1;border-color:rgb(204 204 204/var(--tw-border-opacity,1))}.rf-loader-counter{border-width:8px;border-color:var(--rf-color-primary);border-radius:50%;position:relative}@keyframes rf-loaderCounter{0%{clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}25%{clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}50%{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}75%{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}to{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}}.rf-loader-counter:before{border-width:10px;border-color:var(--rf-color-cardFrameBackground);content:\"\";animation:rf-loaderCounter;animation-duration:var(--duration);border-radius:50%;animation-timing-function:linear;position:absolute;inset:-9px;transform:rotate(45deg)}.rf-touch-action-none{touch-action:none}.rf-unselectable{-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}.rf-title-extralarge-bold-size-auto{font-size:2.25rem;font-weight:600;line-height:2.5rem}#retorik-container.rf-large .rf-title-extralarge-bold-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-title-extralarge-bold-size-auto{font-size:3.75rem;line-height:1}.rf-title-extralarge-size-auto{font-size:2.25rem;font-weight:400;line-height:2.5rem}#retorik-container.rf-large .rf-title-extralarge-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-title-extralarge-size-auto{font-size:3.75rem;line-height:1}.rf-title-large-size-auto{font-size:1.5rem;font-weight:400;line-height:2rem}#retorik-container.rf-large .rf-title-large-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large.rf-portrait .rf-title-large-size-auto{font-size:3rem;line-height:1}.rf-title-large-bold-size-auto{font-size:1.875rem;font-weight:600;line-height:2.25rem}#retorik-container.rf-large .rf-title-large-bold-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large.rf-portrait .rf-title-large-bold-size-auto{font-size:3rem;line-height:1}.rf-title-size-auto{font-size:1.5rem;font-weight:400;line-height:2rem}#retorik-container.rf-large .rf-title-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-title-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-title-bold-size-auto{font-size:1.5rem;font-weight:600;line-height:2rem}#retorik-container.rf-large .rf-title-bold-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-title-bold-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-subtitle-size-auto{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-subtitle-size-auto{font-size:1.25rem;line-height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-subtitle-size-auto{font-size:1.5rem;line-height:2rem}.rf-text-extralarge-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large .rf-text-extralarge-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-text-extralarge-size-auto{font-size:3.75rem;line-height:1}.rf-text-verylarge-size-auto{font-size:1.5rem;line-height:2rem}#retorik-container.rf-large .rf-text-verylarge-size-auto{font-size:3.75rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-text-verylarge-size-auto{font-size:4.5rem;line-height:1}.rf-text-large-size-auto{font-size:1.5rem;line-height:2rem}#retorik-container.rf-large .rf-text-large-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-text-large-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-text-medium-size-auto{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large .rf-text-medium-size-auto{font-size:1.125rem;line-height:1.5rem}.rf-text-size-auto{font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-text-size-auto{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-text-size-auto{font-size:1.125rem;line-height:1.5rem}.rf-text-small-size-auto{font-size:.875rem;line-height:1rem}#retorik-container.rf-large .rf-text-small-size-auto{font-size:1rem;line-height:1.1rem}.rf-text-extra-small-size-auto{font-size:.6rem;line-height:.75rem}#retorik-container.rf-large .rf-text-extra-small-size-auto{font-size:.875rem;line-height:1rem}.rf-small-size-auto{font-size:.6rem}#retorik-container.rf-large .rf-small-size-auto{font-size:.75rem;line-height:1rem}#retorik-container.rf-large.rf-portrait .rf-small-size-auto{font-size:.875rem;line-height:1.25rem}.rf-line-clamp-unknown{hyphens:auto;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-1{hyphens:auto;-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-2{hyphens:auto;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-3{hyphens:auto;-webkit-line-clamp:3;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-4{hyphens:auto;-webkit-line-clamp:4;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-5{hyphens:auto;-webkit-line-clamp:5;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-6{hyphens:auto;-webkit-line-clamp:6;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-7{hyphens:auto;-webkit-line-clamp:7;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-8{hyphens:auto;-webkit-line-clamp:8;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-9{hyphens:auto;-webkit-line-clamp:9;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-10{hyphens:auto;-webkit-line-clamp:10;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-overflow-wrap{overflow-wrap:anywhere}.rf-height-fill-available{height:-webkit-fill-available;height:-moz-available;height:stretch}.rf-width-fill-available{width:-webkit-fill-available;width:-moz-available;width:stretch}.rf-animation-delay-2{animation-delay:.2s}.rf-animation-delay-4{animation-delay:.4s}.rf-scrollbar-thin{scrollbar-width:thin;scrollbar-color:var(--rf-color-secondary) transparent}.rf-scrollbar-thin::-webkit-scrollbar{width:.2rem;height:.2rem;margin:.25rem 0}.rf-scrollbar-thin::-webkit-scrollbar-thumb{background-color:var(--rf-color-secondary);border-radius:.5rem}.rf-scrollbar-x-custom::-webkit-scrollbar{background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:2rem;height:.5rem}.rf-scrollbar-x-custom::-webkit-scrollbar-thumb{background-color:var(--rf-color-primary);border-radius:2rem}.rf-scrollbar-hidden{scrollbar-width:none}.rf-scrollbar-hidden::-webkit-scrollbar{display:none}.rf-opacity-gradient-b{-webkit-mask-image:linear-gradient(#000 50%,#0000 100%)}.rf-opacity-gradient-b-thin{-webkit-mask-image:linear-gradient(#797676 84%,#0000 100%)}.rf-opacity-gradient-l{-webkit-mask-image:linear-gradient(270deg,#000 75%,gray 80%,#0000 85%)}.rf-opacity-gradient-l-thin{-webkit-mask-image:linear-gradient(270deg,#000 90%,gray 95%,#0000 100%)}.rf-opacity-gradient-r{-webkit-mask-image:linear-gradient(90deg,#000 75%,gray 80%,#0000 85%)}.rf-opacity-gradient-r-thin{-webkit-mask-image:linear-gradient(90deg,#000 90%,gray 95%,#0000 100%)}.rf-opacity-gradient-h{-webkit-mask-image:linear-gradient(90deg,#0000 0%,6%,#000,94%,#0000 100%)}.rf-card-button{border-width:1px;border-color:var(--rf-color-cardButtonBorderDefault);background-color:var(--rf-color-cardButtonBackgroundDefault);color:var(--rf-color-cardButtonTextDefault);border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button{padding:.5rem 1rem}.rf-card-button:hover{cursor:pointer;border-color:var(--rf-color-cardButtonBorderHover);background-color:var(--rf-color-cardButtonBackgroundHover);color:var(--rf-color-cardButtonTextHover)}.rf-card-button-clicked{background-color:var(--rf-color-cardButtonBackgroundDefault);border-width:1px;border-color:#0000;padding-top:.25rem;padding-bottom:.25rem}#retorik-container.rf-large .rf-card-button-clicked{padding-top:.5rem;padding-bottom:.5rem}.rf-card-button-positive{border-width:1px;border-color:var(--rf-color-cardFrameBackground);background-color:var(--rf-color-cardButtonTextDefault);color:var(--rf-color-cardFrameBackground);border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-positive{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-positive{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-positive{padding:.5rem 1rem}.rf-card-button-positive:hover{cursor:pointer;border-color:var(--rf-color-cardButtonTextDefault);background-color:var(--rf-color-cardFrameBackground);color:var(--rf-color-cardButtonTextDefault)}.rf-card-button-destructive{--tw-border-opacity:1;border-width:1px;border-color:rgb(220 38 38/var(--tw-border-opacity,1));--tw-bg-opacity:1;background-color:rgb(220 38 38/var(--tw-bg-opacity,1));--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1));border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-destructive{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-destructive{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-destructive{padding:.5rem 1rem}.rf-card-button-destructive:hover{cursor:pointer;--tw-border-opacity:1;border-color:rgb(220 38 38/var(--tw-border-opacity,1));--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1));--tw-text-opacity:1;color:rgb(220 38 38/var(--tw-text-opacity,1))}.rf-card-button-secondary{border-width:1px;border-color:var(--rf-color-secondary);color:var(--rf-color-secondary);background-color:#0000;border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-secondary{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-secondary{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-secondary{padding:.5rem 1rem}.rf-card-button-secondary:hover{cursor:pointer;border-color:var(--rf-color-secondary);background-color:var(--rf-color-secondary);--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.rf-card-button-discover{border-width:1px;border-color:var(--rf-color-cardButtonDiscoverBorderDefault);background-color:var(--rf-color-cardButtonDiscoverBackgroundDefault);color:var(--rf-color-cardButtonDiscoverTextDefault);border-radius:.3125rem;padding:.5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-discover{padding-top:.75rem;padding-bottom:.75rem}.rf-card-button-discover:hover{cursor:pointer;border-color:var(--rf-color-cardButtonDiscoverBorderHover);background-color:var(--rf-color-cardButtonDiscoverBackgroundHover);color:var(--rf-color-cardButtonDiscoverTextHover)}.rf-card-button-history{cursor:default;border-width:1px;border-color:var(--rf-color-cardButtonBorderDefault);background-color:var(--rf-color-cardButtonBackgroundDefault);color:var(--rf-color-cardButtonTextDefault);border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-history{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-history{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-history{padding:.5rem 1rem}.rf-card-button-mini,.rf-card-button-mini-selected,.rf-card-button-mini-disabled{background-color:var(--rf-color-cardFrameBackground);border-width:1px;border-radius:.3125rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-mini,#retorik-container.rf-large .rf-card-button-mini-selected,#retorik-container.rf-large .rf-card-button-mini-disabled{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-mini,#retorik-container.rf-large.rf-portrait .rf-card-button-mini-selected,#retorik-container.rf-large.rf-portrait .rf-card-button-mini-disabled{font-size:1.125rem;line-height:1.5rem}.rf-card-button-mini{border-color:var(--rf-color-cardButtonBorderDefault);background-color:var(--rf-color-cardFrameBackground);color:var(--rf-color-cardButtonTextDefault)}.rf-card-button-mini:hover{cursor:pointer;border-color:var(--rf-color-cardButtonBorderHover);background-color:var(--rf-color-cardFrameBackground);color:var(--rf-color-cardButtonTextHover)}.rf-card-button-mini-selected{border-color:var(--rf-color-cardFrameBackground);background-color:var(--rf-color-cardButtonBorderDefault);color:var(--rf-color-cardFrameBackground)}.lf-player-container{align-items:flex-end;width:100%;height:100%;display:flex;overflow:hidden}.rf-input-label{text-overflow:ellipsis;color:var(--rf-color-formInputTextDefault);margin-top:.1rem;margin-left:.75rem;overflow-x:hidden}#retorik-container.rf-large .rf-input-label{margin-top:.25rem}#retorik-container.rf-large.rf-portrait .rf-input-label{margin-top:.2rem}.rf-radio-custom{appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:50%;place-content:center;width:1.5rem;min-width:1.5rem;height:1.5rem;margin:0;display:grid}.rf-radio-custom:checked{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}#retorik-container.rf-large .rf-radio-custom{width:1.75rem;min-width:1.75rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-radio-custom{width:2rem;min-width:2rem;height:2rem}.rf-radio-custom:before{content:\"\";--tw-scale-x:0;--tw-scale-y:0;width:.5rem;height:.5rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));background-color:var(--rf-color-formInputRadioCheckboxCheckedItem);border-radius:50%;transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}#retorik-container.rf-large .rf-radio-custom:before{width:.75rem;height:.75rem}#retorik-container.rf-large.rf-portrait .rf-radio-custom:before{width:1rem;height:1rem}.rf-radio-custom:checked:before{--tw-scale-x:1;--tw-scale-y:1;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rf-input-hidden{appearance:none;margin:0}.rf-checkbox-custom{appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:.3125rem;place-content:center;width:1.5rem;min-width:1.5rem;height:1.5rem;margin:0;display:grid}#retorik-container.rf-large .rf-checkbox-custom{width:1.75rem;min-width:1.75rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-checkbox-custom{width:2rem;min-width:2rem;height:2rem}.rf-checkbox-custom:checked{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}.rf-toggle-custom{appearance:none;background-color:var(--rf-color-black);border-radius:1.5rem;width:3rem;min-width:3rem;height:1.5rem;margin:0;position:relative}.rf-toggle-custom:checked{background-color:var(--rf-color-primary)}#retorik-container.rf-large .rf-toggle-custom{border-radius:1.75rem;width:3.5rem;min-width:3.5rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-toggle-custom{border-radius:2rem;width:4rem;min-width:4rem;height:2rem}.rf-toggle-custom:before{content:\"\";--tw-translate-x:0px;width:1rem;height:1rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1));border-radius:50%;transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1);position:absolute;top:.25rem;left:.25rem}#retorik-container.rf-large .rf-toggle-custom:before{width:1.25rem;height:1.25rem}#retorik-container.rf-large.rf-portrait .rf-toggle-custom:before{width:1.5rem;height:1.5rem}.rf-toggle-custom:checked:before{--tw-translate-x:1.5rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}#retorik-container.rf-large .rf-toggle-custom:checked:before{--tw-translate-x:1.75rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}#retorik-container.rf-large.rf-portrait .rf-toggle-custom:checked:before{--tw-translate-x:2rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rf-select-custom{appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:.3125rem;margin:0;padding:1rem}.rf-select-custom:hover{cursor:pointer}.rf-select-custom:focus-visible{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder)}.rf-slider-custom{-webkit-appearance:none;-moz-appearance:none;outline-offset:2px;border-radius:.5rem;outline:2px solid #0000;width:100%;height:.25rem;display:block;position:relative}.rf-slider-custom::-webkit-slider-runnable-track{-webkit-appearance:none}.rf-slider-custom::-moz-track{-moz-appearance:none}.rf-slider-custom::-ms-track{appearance:none}.rf-slider-custom::-webkit-slider-thumb{-webkit-appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-webkit-slider-thumb:hover{cursor:pointer}.rf-slider-custom::-moz-range-thumb{-webkit-appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-moz-range-thumb:hover{cursor:pointer}.rf-slider-custom::-ms-thumb{appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-ms-thumb:hover{cursor:pointer}.rf-likert-custom{cursor:pointer;outline-offset:2px;-webkit-text-stroke-width:1px;-webkit-text-stroke-color:white;background-color:#0000;border-style:none;outline:2px solid #0000}.svgButtonMenu>svg *{fill:var(--fill)}.webchat__css-custom-properties{width:100%;height:100%}.rf-range-vertical::-webkit-slider-thumb{cursor:pointer;background-color:var(--rf-color-secondary);border-radius:50%;width:1.5rem;height:1.5rem}.rf-range-vertical::-webkit-slider-thumb:hover{background-color:var(--rf-color-primary)}.rf-range-vertical::-webkit-slider-thumb{appearance:none}.rf-range-vertical::-moz-range-thumb{cursor:pointer;background-color:var(--rf-color-secondary);border-radius:50%;width:1.5rem;height:1.5rem}.rf-range-vertical::-moz-range-thumb:hover{background-color:var(--rf-color-primary)}.rf-range-vertical::-ms-thumb{cursor:pointer;background-color:var(--rf-color-secondary);border-radius:50%;width:1.5rem;height:1.5rem}.rf-range-vertical::-ms-thumb:hover{background-color:var(--rf-color-primary)}.placeholder\\:rf-text-black::placeholder{color:var(--rf-color-black)}.placeholder\\:rf-opacity-100::placeholder{opacity:1}.hover\\:rf-cursor-pointer:hover{cursor:pointer}.hover\\:rf-border-truewhite:hover{--tw-border-opacity:1;border-color:rgb(255 255 255/var(--tw-border-opacity,1))}.hover\\:rf-bg-\\[\\#1999B1\\]:hover{--tw-bg-opacity:1;background-color:rgb(25 153 177/var(--tw-bg-opacity,1))}.hover\\:rf-bg-formInputRadioCheckboxCheckedBackground:hover{background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}.hover\\:rf-bg-transparent:hover{background-color:#0000}.hover\\:rf-bg-truewhite:hover{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.hover\\:rf-text-\\[\\#1999B1\\]:hover{--tw-text-opacity:1;color:rgb(25 153 177/var(--tw-text-opacity,1))}.hover\\:rf-text-formInputRadioCheckboxCheckedItem:hover{color:var(--rf-color-formInputRadioCheckboxCheckedItem)}.hover\\:rf-text-truewhite:hover{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.hover\\:rf-shadow-\\[inset_0_0_12px_\\#00000029\\]:hover{--tw-shadow:inset 0 0 12px #00000029;--tw-shadow-colored:inset 0 0 12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}#retorik-container.rf-portrait .vertical\\:rf-col-span-full{grid-column:1/-1}#retorik-container.rf-portrait .vertical\\:rf-col-start-1{grid-column-start:1}#retorik-container.rf-portrait .vertical\\:rf-w-5\\/6{width:83.3333%}#retorik-container.rf-portrait .vertical\\:rf-w-9\\/10{width:90%}#retorik-container.rf-portrait .vertical\\:rf-w-full{width:100%}#retorik-container.rf-portrait .vertical\\:rf-flex-col{flex-direction:column}#retorik-container.rf-portrait .vertical\\:rf-items-center{align-items:center}#retorik-container.rf-portrait .vertical\\:rf-overflow-x-auto{overflow-x:auto}#retorik-container.rf-portrait .vertical\\:rf-border-r-0{border-right-width:0}#retorik-container.rf-portrait .vertical\\:rf-py-1{padding-top:.25rem;padding-bottom:.25rem}#retorik-container.rf-large .large\\:rf-m-8{margin:2rem}#retorik-container.rf-large .large\\:rf-my-0{margin-top:0;margin-bottom:0}#retorik-container.rf-large .large\\:rf-my-3{margin-top:.75rem;margin-bottom:.75rem}#retorik-container.rf-large .large\\:rf-mb-0{margin-bottom:0}#retorik-container.rf-large .large\\:rf-mb-4{margin-bottom:1rem}#retorik-container.rf-large .large\\:rf-mb-6{margin-bottom:1.5rem}#retorik-container.rf-large .large\\:rf-ml-0{margin-left:0}#retorik-container.rf-large .large\\:rf-ml-8{margin-left:2rem}#retorik-container.rf-large .large\\:rf-mr-3{margin-right:.75rem}#retorik-container.rf-large .large\\:rf-mt-0{margin-top:0}#retorik-container.rf-large .large\\:rf-mt-3{margin-top:.75rem}#retorik-container.rf-large .large\\:rf-block{display:block}#retorik-container.rf-large .large\\:rf-flex{display:flex}#retorik-container.rf-large .large\\:rf-hidden{display:none}#retorik-container.rf-large .large\\:rf-aspect-video{aspect-ratio:16/9}#retorik-container.rf-large .large\\:rf-h-10{height:2.5rem}#retorik-container.rf-large .large\\:rf-h-16{height:4rem}#retorik-container.rf-large .large\\:rf-h-20{height:5rem}#retorik-container.rf-large .large\\:rf-h-3\\/5{height:60%}#retorik-container.rf-large .large\\:rf-h-4{height:1rem}#retorik-container.rf-large .large\\:rf-h-5{height:1.25rem}#retorik-container.rf-large .large\\:rf-h-6{height:1.5rem}#retorik-container.rf-large .large\\:rf-h-8{height:2rem}#retorik-container.rf-large .large\\:rf-h-\\[1\\.3rem\\]{height:1.3rem}#retorik-container.rf-large .large\\:rf-h-\\[60vh\\]{height:60vh}#retorik-container.rf-large .large\\:rf-h-auto{height:auto}#retorik-container.rf-large .large\\:rf-h-full{height:100%}#retorik-container.rf-large .large\\:rf-max-h-28{max-height:7rem}#retorik-container.rf-large .large\\:rf-max-h-\\[2\\.3rem\\]{max-height:2.3rem}#retorik-container.rf-large .large\\:rf-min-h-\\[2\\.3rem\\]{min-height:2.3rem}#retorik-container.rf-large .large\\:rf-w-1\\/8{width:12.5%}#retorik-container.rf-large .large\\:rf-w-14{width:3.5rem}#retorik-container.rf-large .large\\:rf-w-16{width:4rem}#retorik-container.rf-large .large\\:rf-w-4{width:1rem}#retorik-container.rf-large .large\\:rf-w-5{width:1.25rem}#retorik-container.rf-large .large\\:rf-w-6{width:1.5rem}#retorik-container.rf-large .large\\:rf-w-8{width:2rem}#retorik-container.rf-large .large\\:rf-w-full{width:100%}#retorik-container.rf-large .large\\:rf-min-w-1\\/2{min-width:50%}#retorik-container.rf-large .large\\:rf-min-w-1\\/8{min-width:12.5%}#retorik-container.rf-large .large\\:rf-min-w-16{min-width:4rem}#retorik-container.rf-large .large\\:rf-min-w-8{min-width:2rem}#retorik-container.rf-large .large\\:rf-max-w-1\\/8{max-width:12.5%}#retorik-container.rf-large .large\\:rf-max-w-\\[12rem\\]{max-width:12rem}#retorik-container.rf-large .large\\:rf-grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}#retorik-container.rf-large .large\\:rf-flex-row{flex-direction:row}#retorik-container.rf-large .large\\:rf-flex-col{flex-direction:column}#retorik-container.rf-large .large\\:rf-items-center{align-items:center}#retorik-container.rf-large .large\\:rf-items-baseline{align-items:baseline}#retorik-container.rf-large .large\\:rf-justify-start{justify-content:flex-start}#retorik-container.rf-large .large\\:rf-gap-1{gap:.25rem}#retorik-container.rf-large .large\\:rf-gap-3{gap:.75rem}#retorik-container.rf-large .large\\:rf-gap-4{gap:1rem}#retorik-container.rf-large .large\\:rf-gap-6{gap:1.5rem}#retorik-container.rf-large .large\\:rf-overflow-y-scroll{overflow-y:scroll}#retorik-container.rf-large .large\\:rf-border-t-0{border-top-width:0}#retorik-container.rf-large .large\\:rf-bg-truewhite{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}#retorik-container.rf-large .large\\:rf-p-4{padding:1rem}#retorik-container.rf-large .large\\:rf-p-\\[25px\\]{padding:25px}#retorik-container.rf-large .large\\:rf-p-min1{padding:.1rem}#retorik-container.rf-large .large\\:rf-px-0{padding-left:0;padding-right:0}#retorik-container.rf-large .large\\:rf-px-16{padding-left:4rem;padding-right:4rem}#retorik-container.rf-large .large\\:rf-px-4{padding-left:1rem;padding-right:1rem}#retorik-container.rf-large .large\\:rf-px-5,#retorik-container.rf-large .large\\:rf-px-6{padding-left:1.5rem;padding-right:1.5rem}#retorik-container.rf-large .large\\:rf-px-8{padding-left:2rem;padding-right:2rem}#retorik-container.rf-large .large\\:rf-py-0{padding-top:0;padding-bottom:0}#retorik-container.rf-large .large\\:rf-py-1{padding-top:.25rem;padding-bottom:.25rem}#retorik-container.rf-large .large\\:rf-py-2{padding-top:.5rem;padding-bottom:.5rem}#retorik-container.rf-large .large\\:rf-py-3{padding-top:.75rem;padding-bottom:.75rem}#retorik-container.rf-large .large\\:rf-py-4{padding-top:1rem;padding-bottom:1rem}#retorik-container.rf-large .large\\:rf-pb-16{padding-bottom:4rem}#retorik-container.rf-large .large\\:rf-pl-12{padding-left:3rem}#retorik-container.rf-large .large\\:rf-pl-4{padding-left:1rem}#retorik-container.rf-large .large\\:rf-pr-12{padding-right:3rem}#retorik-container.rf-large .large\\:rf-pr-4{padding-right:1rem}#retorik-container.rf-large .large\\:rf-pt-12{padding-top:3rem}#retorik-container.rf-large .large\\:rf-pt-16{padding-top:4rem}#retorik-container.rf-large .large\\:rf-pt-4{padding-top:1rem}#retorik-container.rf-large .large\\:rf-pt-8{padding-top:2rem}#retorik-container.rf-large .large\\:rf-text-5xl{font-size:3rem;line-height:1}#retorik-container.rf-large .large\\:rf-text-6xl{font-size:3.75rem;line-height:1}#retorik-container.rf-large .large\\:rf-text-base{font-size:1rem;line-height:1.5rem}#retorik-container.rf-large .large\\:rf-text-basecustom{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large .large\\:rf-text-sm{font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .large\\:rf-uppercase{text-transform:uppercase}#retorik-container.rf-large .large\\:rf-text-\\[\\#575F6B\\]{--tw-text-opacity:1;color:rgb(87 95 107/var(--tw-text-opacity,1))}#retorik-container.rf-tactile .tactile\\:rf-h-4{height:1rem}#retorik-container.rf-tactile .tactile\\:rf-h-6{height:1.5rem}#retorik-container.rf-tactile .tactile\\:rf-w-6{width:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-absolute{position:absolute}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-left-4{left:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-right-9{right:2.25rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-top-4{top:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-start-1{grid-column-start:1}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-start-2{grid-column-start:2}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-end-8{grid-column-end:8}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-ml-1\\/5{margin-left:20%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mr-1\\/5{margin-right:20%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mt-4{margin-top:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mt-\\[20vh\\]{margin-top:20vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mt-\\[25vh\\]{margin-top:25vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-block{display:block}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-hidden{display:none}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-1\\/2{height:50%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-14{height:3.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-24{height:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-5{height:1.25rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-6{height:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-\\[50vh\\]{height:50vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-11\\/12{max-height:91.67%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-36{max-height:9rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-\\[18vh\\]{max-height:18vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-\\[30vh\\]{max-height:30vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-h-10{min-height:2.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-1\\/2{width:50%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-14{width:3.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-16{width:4rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-24{width:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-3\\/5{width:60%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-6{width:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-full{width:100%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-w-14{min-width:3.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-w-24{min-width:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-w-3\\/5{min-width:60%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-w-\\[45\\%\\]{max-width:45%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-w-\\[60\\%\\]{max-width:60%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-flex-row{flex-direction:row}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-flex-col{flex-direction:column}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-justify-center{justify-content:center}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-gap-4{gap:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-gap-6{gap:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-self-start{align-self:flex-start}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-border-t{border-top-width:1px}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-border-t-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity,1))}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-py-4{padding-top:1rem;padding-bottom:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-py-5{padding-top:1.5rem;padding-bottom:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pl-0{padding-left:0}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-48{padding-top:12rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-8{padding-top:2rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-\\[16\\.67\\%\\]{padding-top:16.67%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-\\[20vh\\]{padding-top:20vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-text-basecustomuppercase{font-size:1rem;line-height:1.1rem}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-col-start-3{grid-column-start:3}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-col-start-4{grid-column-start:4}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:-rf-mt-4{margin-top:-1rem}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-ml-1\\/5{margin-left:20%}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-mr-40{margin-right:10rem}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-h-full{height:100%}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-w-\\[48\\%\\]{width:48%}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-w-\\[calc\\(80\\%-10rem\\)\\]{width:calc(80% - 10rem)}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-min-w-\\[48\\%\\]{min-width:48%}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-max-w-\\[calc\\(\\(80\\%-10rem\\)\\*0\\.75\\)\\]{max-width:calc(60% - 7.5rem)}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:-rf-translate-x-1\\/4{--tw-translate-x:-25%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-translate-x-1\\/4{--tw-translate-x:25%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-flex-col-reverse{flex-direction:column-reverse}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-items-start{align-items:flex-start}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-justify-start{justify-content:flex-start}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-justify-center{justify-content:center}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-self-end{align-self:flex-end}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-justify-self-start{justify-self:start}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-pb-2{padding-bottom:.5rem}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-pl-1\\/5{padding-left:20%}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-pl-\\[calc\\(50\\%-2\\.5rem\\)\\]{padding-left:calc(50% - 2.5rem)}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-pr-40{padding-right:10rem}#retorik-container.rf-mobile .mobile\\:rf-px-4{padding-left:1rem;padding-right:1rem}#retorik-container.rf-tablet .tablet\\:rf-w-28{width:7rem}#retorik-container.rf-tablet .tablet\\:rf-pl-12{padding-left:3rem}#retorik-container.rf-tablet .tablet\\:rf-pr-24{padding-right:6rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-h-10{height:2.5rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-h-20{height:5rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-min-h-20{min-height:5rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-w-40{width:10rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-p-5{padding:1.5rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-pl-32{padding-left:8rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-pr-56{padding-right:14rem}.ltr\\:rf-left-1:where([dir=ltr],[dir=ltr] *){left:.25rem}.ltr\\:rf-col-start-1:where([dir=ltr],[dir=ltr] *){grid-column-start:1}.ltr\\:rf-ml-4:where([dir=ltr],[dir=ltr] *){margin-left:1rem}.ltr\\:rf-self-end:where([dir=ltr],[dir=ltr] *){align-self:flex-end}.ltr\\:rf-pr-2:where([dir=ltr],[dir=ltr] *){padding-right:.5rem}.ltr\\:rf-text-left:where([dir=ltr],[dir=ltr] *){text-align:left}.ltr\\:rf-text-right:where([dir=ltr],[dir=ltr] *){text-align:right}#retorik-container.rf-large .large\\:ltr\\:rf-ml-4:where([dir=ltr],[dir=ltr] *){margin-left:1rem}.rtl\\:rf-right-1:where([dir=rtl],[dir=rtl] *){right:.25rem}.rtl\\:rf-col-end-1:where([dir=rtl],[dir=rtl] *){grid-column-end:1}.rtl\\:rf-mr-4:where([dir=rtl],[dir=rtl] *){margin-right:1rem}.rtl\\:rf-self-start:where([dir=rtl],[dir=rtl] *){align-self:flex-start}.rtl\\:rf-pl-2:where([dir=rtl],[dir=rtl] *){padding-left:.5rem}.rtl\\:rf-text-left:where([dir=rtl],[dir=rtl] *){text-align:left}.rtl\\:rf-text-right:where([dir=rtl],[dir=rtl] *){text-align:right}#retorik-container.rf-large .large\\:rtl\\:rf-mr-4:where([dir=rtl],[dir=rtl] *){margin-right:1rem}";


var $86d04579703ce0df$exports = {};
$86d04579703ce0df$exports = ".leaflet-cluster-anim .leaflet-marker-icon,.leaflet-cluster-anim .leaflet-marker-shadow{-o-transition:-o-transform .3s ease-out,opacity .3s ease-in;-webkit-transition:-webkit-transform .3s ease-out,opacity .3s ease-in;-moz-transition:-moz-transform .3s ease-out,opacity .3s ease-in;transition:transform .3s ease-out,opacity .3s ease-in}.leaflet-cluster-spider-leg{-o-transition:-o-stroke-dashoffset .3s ease-out,-o-stroke-opacity .3s ease-in;-webkit-transition:-webkit-stroke-dashoffset .3s ease-out,-webkit-stroke-opacity .3s ease-in;-moz-transition:-moz-stroke-dashoffset .3s ease-out,-moz-stroke-opacity .3s ease-in;transition:stroke-dashoffset .3s ease-out,stroke-opacity .3s ease-in}.marker-cluster-small{background-color:#b5e28c99}.marker-cluster-small div{background-color:#6ecc3999}.marker-cluster-medium{background-color:#f1d35799}.marker-cluster-medium div{background-color:#f0c20c99}.marker-cluster-large{background-color:#fd9c7399}.marker-cluster-large div{background-color:#f1801799}.leaflet-oldie .marker-cluster-small{background-color:#b5e28c}.leaflet-oldie .marker-cluster-small div{background-color:#6ecc39}.leaflet-oldie .marker-cluster-medium{background-color:#f1d357}.leaflet-oldie .marker-cluster-medium div{background-color:#f0c20c}.leaflet-oldie .marker-cluster-large{background-color:#fd9c73}.leaflet-oldie .marker-cluster-large div{background-color:#f18017}.marker-cluster{background-clip:padding-box;border-radius:20px}.marker-cluster div{text-align:center;border-radius:15px;width:30px;height:30px;margin-top:5px;margin-left:5px;font:12px Helvetica Neue,Arial,Helvetica,sans-serif}.marker-cluster span{line-height:30px}.mapContainer,.leaflet-container{z-index:0;width:100%;height:100%;margin:auto}.leaflet-container .leaflet-pane{z-index:0}.custom-marker-cluster{color:#000;text-align:center;background:#00beff80;border-radius:50%;justify-content:center;align-items:center;width:33px;height:33px;line-height:37px;display:flex}.leaflet-marker-icon{transition:all .2s ease-in-out}.leaflet-popup{bottom:20px!important}.infoPOIPane,.infoPOIPaneWidget{z-index:99;background:#fff;border-radius:5px;flex-direction:column;padding:1rem;display:flex;position:absolute;box-shadow:0 3px 6px #00000029}.infoPOIPane .poiTitle,.infoPOIPaneWidget .poiTitle{font-size:1.25rem;font-weight:700;line-height:1.6rem}.infoPOIPane .poiClose,.infoPOIPaneWidget .poiClose{cursor:pointer;width:40px;height:40px;font-size:0;display:block;position:absolute;top:0;right:0}.infoPOIPane .poiClose:before,.infoPOIPane .poiClose:after,.infoPOIPaneWidget .poiClose:before,.infoPOIPaneWidget .poiClose:after{transform-origin:0 0;content:\"\";background-color:#000;width:2px;height:17px;transition:all .42s;position:absolute;top:50%;left:50%;transform:rotate(45deg)translate(-50%,-50%)}.infoPOIPane .poiClose:after,.infoPOIPaneWidget .poiClose:after{transform:rotate(-45deg)translate(-50%,-50%)}.infoPOIPane .poiClose:hover:before,.infoPOIPane .poiClose:hover:after,.infoPOIPaneWidget .poiClose:hover:before,.infoPOIPaneWidget .poiClose:hover:after{background-color:#000}.infoPOIPane .white,.infoPOIPaneWidget .white{color:#fff}.infoPOIPane .white:before,.infoPOIPane .white:after,.infoPOIPaneWidget .white:before,.infoPOIPaneWidget .white:after{background-color:#fff}.infoPOIPane .poiAddress,.infoPOIPaneWidget .poiAddress{padding-top:1rem;font-size:.8rem;line-height:.7rem}.infoPOIPane .poiPhone,.infoPOIPaneWidget .poiPhone{padding-top:.5rem;font-size:.8rem;line-height:.7rem}.infoPOIPane .poiPhotoAndDescription,.infoPOIPaneWidget .poiPhotoAndDescription{flex-direction:row;gap:1rem;padding-top:1rem;padding-bottom:1rem;display:flex}.infoPOIPane .poiPhotoAndDescription .poiPhoto,.infoPOIPaneWidget .poiPhotoAndDescription .poiPhoto{flex:0 0 9rem;justify-content:center;align-items:center;display:flex}.infoPOIPane .poiPhotoAndDescription .poiPhoto img,.infoPOIPaneWidget .poiPhotoAndDescription .poiPhoto img{object-fit:cover;border-radius:50%;width:9rem;height:9rem}.infoPOIPane .poiPhotoAndDescription .poiDescriptionAndButton,.infoPOIPaneWidget .poiPhotoAndDescription .poiDescriptionAndButton{flex-direction:column;gap:1rem;display:flex;overflow:hidden}.infoPOIPane .poiPhotoAndDescription .poiDescriptionAndButton .poiDesc,.infoPOIPaneWidget .poiPhotoAndDescription .poiDescriptionAndButton .poiDesc{text-overflow:ellipsis;line-clamp:4;-webkit-line-clamp:4;white-space:pre-wrap;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.infoPOIPane .poiPhotoAndDescription .poiDescriptionAndButton .poiButton,.infoPOIPaneWidget .poiPhotoAndDescription .poiDescriptionAndButton .poiButton{border-style:solid;border-width:2px;border-radius:10px;width:fit-content;padding:.5rem;font-weight:700}.infoPOIPane .routes-container,.infoPOIPaneWidget .routes-container{flex-direction:row;justify-content:center;gap:1rem;width:100%;height:4rem;display:flex}.infoPOIPane .routes-container .route-index,.infoPOIPaneWidget .routes-container .route-index{z-index:1}.infoPOIPane .routes-container .route-icon,.infoPOIPaneWidget .routes-container .route-icon{width:2rem;height:2rem}.infoPOIPane .routes-container .route-icon-medium,.infoPOIPaneWidget .routes-container .route-icon-medium{width:1.25rem;height:1.25rem}.infoPOIPane .routes-container .route-icon-small,.infoPOIPaneWidget .routes-container .route-icon-small{width:1.5rem;height:1.5rem}.infoPOIPane .routes-container .route-icon-verysmall,.infoPOIPaneWidget .routes-container .route-icon-verysmall{width:.75rem;height:.75rem}.infoPOIPane .routes-container .route-icon-smallest,.infoPOIPaneWidget .routes-container .route-icon-smallest{width:.5rem;height:.5rem}.infoPOIPane .routes-container .routes-data,.infoPOIPaneWidget .routes-container .routes-data{border-radius:.5rem;grid-template-columns:repeat(3,max-content);gap:1rem;padding:.5rem 1rem .5rem 1.5rem;font-size:.75rem;line-height:1rem;display:grid}.infoPOIPane .routes-container .routes-data .route-item-container,.infoPOIPaneWidget .routes-container .routes-data .route-item-container{flex-direction:column;justify-content:flex-end;display:flex}.infoPOIPane .routes-container .routes-data .route-item-container .route-item,.infoPOIPaneWidget .routes-container .routes-data .route-item-container .route-item{flex-direction:row;align-items:center;gap:.75rem;height:100%;display:flex}.infoPOIPane .routes-container .routes-data .route-item-container .route-item .route-item-icon,.infoPOIPaneWidget .routes-container .routes-data .route-item-container .route-item .route-item-icon{justify-content:center;align-items:center;display:flex;position:relative}.infoPOIPane .routes-container .routes-data .route-item-container .route-item .route-item-icon .route-item-icon-circle,.infoPOIPaneWidget .routes-container .routes-data .route-item-container .route-item .route-item-icon .route-item-icon-circle{border-radius:100%;width:2.25rem;height:2.25rem;position:absolute}.infoPOIPane .routes-container .routes-data .route-item-container .route-item .route-item-icon .route-item-icon-triangle,.infoPOIPaneWidget .routes-container .routes-data .route-item-container .route-item .route-item-icon .route-item-icon-triangle{justify-content:center;width:100%;display:flex;position:absolute}.infoPOIPane .routes-container .routes-data .route-item-container .route-item .route-item-icon .route-item-icon-triangle-car,.infoPOIPaneWidget .routes-container .routes-data .route-item-container .route-item .route-item-icon .route-item-icon-triangle-car{top:-1.15rem}.infoPOIPane .routes-container .routes-data .route-item-container .route-item .route-item-icon .route-item-icon-triangle-other,.infoPOIPaneWidget .routes-container .routes-data .route-item-container .route-item .route-item-icon .route-item-icon-triangle-other{top:-.75rem}.infoPOIPane .routes-container .routes-data .route-item-container .route-item .route-item-text,.infoPOIPaneWidget .routes-container .routes-data .route-item-container .route-item .route-item-text{flex-direction:column;justify-content:center;align-items:flex-start;display:flex}.infoPOIPane .routes-container .routes-data .route-item-container .route-item .route-item-text .route-item-duration,.infoPOIPaneWidget .routes-container .routes-data .route-item-container .route-item .route-item-text .route-item-duration{white-space:nowrap;font-weight:700}.infoPOIPane .routes-container .routes-data .route-item-container .route-item .route-item-text .route-item-distance,.infoPOIPaneWidget .routes-container .routes-data .route-item-container .route-item .route-item-text .route-item-distance{white-space:nowrap}.infoPOIPane .routes-container .routes-data .route-item-container:hover,.infoPOIPaneWidget .routes-container .routes-data .route-item-container:hover{cursor:pointer}.infoPOIPane .routes-container .route-button,.infoPOIPaneWidget .routes-container .route-button{aspect-ratio:1;border:2px solid #000;border-radius:.5rem;flex-direction:column;justify-content:space-evenly;align-items:center;width:15%;min-width:15%;max-width:15%;padding:.25rem;font-size:.75rem;font-weight:700;line-height:1rem;display:flex;overflow-y:hidden}.infoPOIPane .qrcode-container,.infoPOIPaneWidget .qrcode-container{z-index:40;color:#fff;background-color:#121212b3;flex-direction:column;justify-content:center;align-items:center;gap:1rem;width:100%;height:100%;display:flex;position:absolute;top:0;left:0}.infoPOIPane .qrcode-container .qrcode-text-and-icon,.infoPOIPaneWidget .qrcode-container .qrcode-text-and-icon{flex-direction:row;align-items:flex-start;gap:.25rem;font-style:italic;display:flex}.infoPOIPane .qrcode-container .qrcode-text-and-icon .qrcode-text,.infoPOIPaneWidget .qrcode-container .qrcode-text-and-icon .qrcode-text{flex-direction:column;align-items:center;width:fit-content;display:flex}.infoPOIPaneWidget{width:100%;max-width:27rem;bottom:135px}.leaflet-control-zoom{flex-direction:column;gap:10px;display:flex;right:1rem;border:0!important}.leaflet-control-zoom .leaflet-control-zoom-in,.leaflet-control-zoom .leaflet-control-zoom-out{justify-content:center;align-items:center;display:flex;border-radius:50%!important;width:50px!important;height:50px!important}#around-me{opacity:1;background:#fff no-repeat padding-box padding-box;border-radius:70px;justify-content:center;align-items:center;width:50px;height:50px;margin-right:10px;display:flex;position:absolute;right:1rem}.leaflet-div-icon{animation:.5s ease-in-out fadeIn;background-color:#0000!important;border-style:none!important;width:36px!important;height:50px!important}.markerSelected{filter:drop-shadow(var(--pointerColorHightlight,white) 0px 0px 10px);transition:all .2s ease-in-out;width:57px!important;height:80px!important;margin-top:-65px!important;margin-left:-37.5px!important}.loader-container{justify-content:center;align-items:center;width:100%;height:100%;display:flex}.loader-container .loader{border:3px solid #ffffff4d;border-top-color:#fff;border-radius:50%;width:50px;height:50px;animation:1s ease-in-out infinite spin;display:inline-block;position:absolute;top:50%;left:50%}@keyframes spin{to{-webkit-transform:rotate(360deg)}}.loader-container .exit-loader{cursor:pointer;color:#000;z-index:1;background-color:#ffffff4d;border-radius:50%;justify-content:center;align-items:center;width:40px;height:40px;font-size:30px;line-height:30px;display:flex;position:absolute;top:calc(50% + 5px);left:calc(50% + 5px)}@media only screen and (width<=600px){#around-me{bottom:25em}.leaflet-control-zoom{bottom:19em}.infoPOIPane{width:100%;bottom:135px}.leaflet-div-icon{width:28px!important;height:40px!important}.markerSelected{filter:drop-shadow(var(--pointerColorHightlight,white) 0px 0px 10px);transition:all .2s ease-in-out;width:38px!important;height:54px!important;margin-top:-65px!important;margin-left:-37.5px!important}}@media only screen and (width>=601px) and (width<=999px){#around-me{bottom:25em}.leaflet-control-zoom{bottom:19em}.infoPOIPane{width:40rem;bottom:16rem;left:50%;right:50%;transform:translate(-50%)}}@media only screen and (width>=1000px) and (orientation:landscape){#around-me{bottom:25em}.leaflet-control-zoom{bottom:19em}.infoPOIPane{width:27rem;bottom:16rem;right:7rem}}@media only screen and (width>=1921px) and (orientation:landscape){#around-me{bottom:29em}.leaflet-control-zoom{bottom:25em}.markerSelected{filter:drop-shadow(var(--pointerColorHightlight,white) 0px 0px 10px);transition:all .2s ease-in-out}.infoPOIPane{bottom:21rem}}@media only screen and (width>=1000px) and (orientation:portrait){#around-me{bottom:25em}.leaflet-control-zoom{bottom:19em}.infoPOIPane{width:30rem;bottom:30%;right:7rem}}#map-target{margin:10px}.fadeIn{animation:.5s ease-in-out fadeIn}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeOut{animation:.5s ease-in-out fadeOut}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.filterContainer,.filterContainerWidget{z-index:51;flex-direction:column;width:100%;display:flex;position:absolute;bottom:0}.filterContainer.show,.filterContainerWidget.show,.filterContainer.hide,.filterContainerWidget.hide{transition:all .3s ease-in-out}.filterContainer .filterToggler,.filterContainerWidget .filterToggler{cursor:pointer;color:#575f6b;z-index:999;background:#edeef2;border-radius:10px 10px 0 0;align-items:center;width:fit-content;padding:10px 30px;display:flex;box-shadow:0 -4px 5px #24415d1c}.filterContainer .filterToggler .arrow,.filterContainerWidget .filterToggler .arrow{width:10px;height:10px;padding-left:17px;display:inline-block;position:relative}.filterContainer .filterToggler .arrow:before,.filterContainer .filterToggler .arrow:after,.filterContainerWidget .filterToggler .arrow:before,.filterContainerWidget .filterToggler .arrow:after{content:\"\";will-change:transform;background:#000;width:10px;height:3px;transition:all .2s;position:absolute;top:calc(50% - 1px);right:auto}.filterContainer .filterToggler .arrow:before,.filterContainerWidget .filterToggler .arrow:before{transform:rotate(45deg)translate(1px,-1px)}.filterContainer .filterToggler .arrow:after,.filterContainerWidget .filterToggler .arrow:after{transform:rotate(-45deg)translate(-3px,-3px)}.filterContainer .filterToggler .arrow.active:before,.filterContainerWidget .filterToggler .arrow.active:before{transform:rotate(45deg)translate(-2px,2px)}.filterContainer .filterToggler .arrow.active:after,.filterContainerWidget .filterToggler .arrow.active:after{transform:rotate(-45deg)translate(2px,2px)}.filterContainer .filterMenu,.filterContainerWidget .filterMenu{z-index:401;background:#edeef2 no-repeat padding-box padding-box;border-radius:0;justify-content:center;align-items:center;gap:20px;width:100%;display:flex;bottom:0;box-shadow:3px 3px 20px #24415d4d}.filterContainer .filterMenu .filterCategory,.filterContainerWidget .filterMenu .filterCategory{cursor:pointer;background:linear-gradient(307deg,#f2f3f6,#e5e6ec) no-repeat padding-box padding-box;border-radius:10px;align-items:center;gap:10px;display:flex;position:relative;box-shadow:3px 3px 10px #24415d14}.filterContainer .filterMenu .filterCategory ion-img,.filterContainerWidget .filterMenu .filterCategory ion-img{border-radius:50%}.filterContainer .filterMenu .filterCategory .checkbox,.filterContainerWidget .filterMenu .filterCategory .checkbox{color:#fff;visibility:hidden;background-color:#575f6b;border:2px solid #fff;border-radius:20px;justify-content:center;align-items:center;display:flex;position:absolute}.filterContainer .filterMenu .filterCategory .checkbox-selected,.filterContainerWidget .filterMenu .filterCategory .checkbox-selected{visibility:visible}.filterContainer .filterMenu .filterCategory .image,.filterContainerWidget .filterMenu .filterCategory .image{aspect-ratio:1;border-radius:50%}.filterContainer .filterMenu .filterCategory .imageFile,.filterContainerWidget .filterMenu .filterCategory .imageFile{width:100%;height:100%}.filterContainer .filterMenu div:not(.selectedFilter) span,.filterContainerWidget .filterMenu div:not(.selectedFilter) span{color:#575f6b;transition:all .5s;font-weight:400!important}.filterContainerWidget.show .filterMenu{height:90px;transition:all .3s ease-in-out}.filterContainerWidget.hide .filterMenu,.filterContainerWidget.hide .filterToggler{background:#edeef2}.filterContainerWidget.hide .filterMenu{height:10px;transition:all .3s ease-in-out}.filterContainerWidget.hide .filterCategory{display:none}.filterContainerWidget .filterMenu{z-index:19;white-space:nowrap;width:unset;flex-flow:column wrap;display:flex;overflow-x:auto}.filterContainerWidget .filterMenu .filterCategory{flex-flow:row;height:50px;padding:10px}.filterContainerWidget .filterMenu .filterCategory ion-img{width:36.5px;height:36.5px;padding:5%}.filterContainerWidget .filterMenu .filterCategory .checkbox{width:12px;height:12px;padding-top:1px;font-size:12px;top:5px;left:40px}.filterContainerWidget .filterMenu .filterCategory .image{width:36.5px;height:36.5px;padding:5%}.filterContainerWidget .filterMenu .filterCategory span{text-transform:uppercase;text-overflow:ellipsis;white-space:nowrap;font-size:15px;font-weight:500;line-height:18px}.filterContainerWidget .filterMenu .filterCategory.selectedFilter{transition:all .5s;box-shadow:inset -3px -3px 16px #fff}@media only screen and (width<=600px){.filterContainer{bottom:0}.filterContainer.show .filterMenu{height:90px;transition:all .3s ease-in-out}.filterContainer.hide .filterMenu,.filterContainer.hide .filterToggler{background:#edeef2}.filterContainer.hide .filterMenu{height:10px;transition:all .3s ease-in-out}.filterContainer.hide .filterCategory{display:none}.filterContainer .filterMenu{z-index:19;white-space:nowrap;width:unset;flex-flow:column wrap;display:flex;overflow-x:auto}.filterContainer .filterMenu .filterCategory{flex-flow:row;height:50px;padding:10px}.filterContainer .filterMenu .filterCategory ion-img{width:36.5px;height:36.5px;padding:5%}.filterContainer .filterMenu .filterCategory .checkbox{width:12px;height:12px;padding-top:1px;font-size:12px;top:5px;left:40px}.filterContainer .filterMenu .filterCategory .image{width:36.5px;height:36.5px;padding:5%}.filterContainer .filterMenu .filterCategory span{text-transform:uppercase;text-overflow:ellipsis;white-space:nowrap;font-size:15px;font-weight:500;line-height:18px}.filterContainer .filterMenu .filterCategory.selectedFilter{transition:all .5s;box-shadow:inset -3px -3px 16px #fff}}@media only screen and (width>=601px) and (width<=999px){.filterContainer.show{bottom:0}.filterContainer.hide{bottom:-80px}.filterContainer.hide .filterMenu,.filterContainer.hide .filterToggler{background:#edeef2}.filterContainer .filterMenu{white-space:nowrap;height:90px;width:unset;flex-flow:column wrap;display:flex;overflow-x:auto}.filterContainer .filterMenu .filterCategory{flex-flow:row;height:50px;padding:10px}.filterContainer .filterMenu .filterCategory ion-img{width:48px;height:48px;padding:5%}.filterContainer .filterMenu .filterCategory .checkbox{width:17px;height:17px;padding-top:2px;font-size:17px;top:0;left:50px}.filterContainer .filterMenu .filterCategory .image{width:48px;height:48px;padding:5%}.filterContainer .filterMenu .filterCategory span{text-transform:uppercase;text-overflow:ellipsis;white-space:nowrap;font-size:15px;font-weight:500;line-height:18px}.filterContainer .filterMenu .filterCategory.selectedFilter{transition:all .5s;box-shadow:inset -3px -3px 16px #fff}}@media only screen and (width>=1000px) and (orientation:landscape){.filterContainer.show{bottom:0}.filterContainer.hide{bottom:-185px}.filterContainer.hide .filterMenu,.filterContainer.hide .filterToggler{background:#edeef2}.filterContainer .filterToggler{margin-left:100px}.filterContainer .filterMenu{flex-flow:row;height:200px}.filterContainer .filterMenu .filterCategory{flex-direction:column;justify-content:flex-start;width:150px;height:130px;padding-top:1.5rem}.filterContainer .filterMenu .filterCategory ion-img{max-width:60px;max-height:60px;padding:7%}.filterContainer .filterMenu .filterCategory .checkbox{width:20px;height:20px;padding-top:2px;font-size:20px;top:17%;right:25%}.filterContainer .filterMenu .filterCategory .image{max-width:60px;max-height:60px;padding:7%}.filterContainer .filterMenu .filterCategory span{text-transform:uppercase;text-overflow:ellipsis;white-space:nowrap;font-size:15px;font-weight:500;line-height:18px}.filterContainer .filterMenu .filterCategory.selectedFilter{transition:all .5s;box-shadow:inset -3px -3px 16px #fff}}@media only screen and (width>=1921px) and (orientation:landscape){.filterContainer.show{bottom:0}.filterContainer.hide{bottom:-285px}.filterContainer.hide .filterMenu,.filterContainer.hide .filterToggler{background:#edeef2}.filterContainer .filterToggler{margin-left:100px}.filterContainer .filterMenu{flex-flow:row;height:300px}.filterContainer .filterMenu .filterCategory{flex-direction:column;justify-content:space-evenly;width:246px;height:213px;padding:1.5rem}.filterContainer .filterMenu .filterCategory ion-img{max-width:98.5px;max-height:98.5px;padding:8%}.filterContainer .filterMenu .filterCategory .checkbox{width:32px;height:32px;padding-top:8px;font-size:32px;top:15%;right:25%}.filterContainer .filterMenu .filterCategory .image{max-width:98.5px;max-height:98.5px;padding:8%}.filterContainer .filterMenu .filterCategory span{text-transform:uppercase;text-overflow:ellipsis;white-space:nowrap;font-size:22px;font-weight:700;line-height:27px}.filterContainer .filterMenu .filterCategory.selectedFilter{transition:all .5s;box-shadow:inset -3px -3px 16px #fff}}@media only screen and (width>=1000px) and (orientation:portrait){.filterContainer.show{bottom:15%;left:calc(50% - 500px)}.filterContainer .filterToggler{justify-content:center;margin-left:0;left:calc(50% - 500px);width:900px!important}.filterContainer .arrow{display:none!important}.filterContainer .filterMenu{border-radius:0 0 10px 10px;flex-flow:row;width:900px;height:130px}.filterContainer .filterMenu .filterCategory{flex-direction:column;justify-content:center;width:125px;height:110px}.filterContainer .filterMenu .filterCategory ion-img{max-width:48px;max-height:48px;padding:7%}.filterContainer .filterMenu .filterCategory .checkbox{width:20px;height:20px;padding-top:2px;font-size:20px;top:17%;right:25%}.filterContainer .filterMenu .filterCategory .image{max-width:48px;max-height:48px;padding:7%}.filterContainer .filterMenu .filterCategory span{text-transform:uppercase;text-overflow:ellipsis;white-space:nowrap;font-size:14px;font-weight:500;line-height:16px}.filterContainer .filterMenu .filterCategory.selectedFilter{transition:all .5s;box-shadow:inset -3px -3px 16px #fff}}";


var $5bf62910dd3e016b$exports = {};
$5bf62910dd3e016b$exports = ".leaflet-pane,.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile-container,.leaflet-pane>svg,.leaflet-pane>canvas,.leaflet-zoom-box,.leaflet-image-layer,.leaflet-layer{position:absolute;top:0;left:0}.leaflet-container{overflow:hidden}.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow{-webkit-user-select:none;user-select:none;-webkit-user-drag:none}.leaflet-tile::selection{background:0 0}.leaflet-safari .leaflet-tile{image-rendering:-webkit-optimize-contrast}.leaflet-safari .leaflet-tile-container{-webkit-transform-origin:0 0;width:1600px;height:1600px}.leaflet-marker-icon,.leaflet-marker-shadow{display:block}.leaflet-container .leaflet-overlay-pane svg{max-width:none!important;max-height:none!important}.leaflet-container .leaflet-marker-pane img,.leaflet-container .leaflet-shadow-pane img,.leaflet-container .leaflet-tile-pane img,.leaflet-container img.leaflet-image-layer,.leaflet-container .leaflet-tile{width:auto;padding:0;max-width:none!important;max-height:none!important}.leaflet-container img.leaflet-tile{mix-blend-mode:plus-lighter}.leaflet-container.leaflet-touch-zoom{-ms-touch-action:pan-x pan-y;touch-action:pan-x pan-y}.leaflet-container.leaflet-touch-drag{-ms-touch-action:pinch-zoom;touch-action:none;touch-action:pinch-zoom}.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom{-ms-touch-action:none;touch-action:none}.leaflet-container{-webkit-tap-highlight-color:transparent}.leaflet-container a{-webkit-tap-highlight-color:#33b5e566}.leaflet-tile{filter:inherit;visibility:hidden}.leaflet-tile-loaded{visibility:inherit}.leaflet-zoom-box{box-sizing:border-box;z-index:800;width:0;height:0}.leaflet-overlay-pane svg{-moz-user-select:none}.leaflet-pane{z-index:400}.leaflet-tile-pane{z-index:200}.leaflet-overlay-pane{z-index:400}.leaflet-shadow-pane{z-index:500}.leaflet-marker-pane{z-index:600}.leaflet-tooltip-pane{z-index:650}.leaflet-popup-pane{z-index:700}.leaflet-map-pane canvas{z-index:100}.leaflet-map-pane svg{z-index:200}.leaflet-vml-shape{width:1px;height:1px}.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}.leaflet-control{z-index:800;pointer-events:visiblePainted;pointer-events:auto;position:relative}.leaflet-top,.leaflet-bottom{z-index:1000;pointer-events:none;position:absolute}.leaflet-top{top:0}.leaflet-right{right:0}.leaflet-bottom{bottom:0}.leaflet-left{left:0}.leaflet-control{float:left;clear:both}.leaflet-right .leaflet-control{float:right}.leaflet-top .leaflet-control{margin-top:10px}.leaflet-bottom .leaflet-control{margin-bottom:10px}.leaflet-left .leaflet-control{margin-left:10px}.leaflet-right .leaflet-control{margin-right:10px}.leaflet-fade-anim .leaflet-popup{opacity:0;transition:opacity .2s linear}.leaflet-fade-anim .leaflet-map-pane .leaflet-popup{opacity:1}.leaflet-zoom-animated{transform-origin:0 0}svg.leaflet-zoom-animated{will-change:transform}.leaflet-zoom-anim .leaflet-zoom-animated{-webkit-transition:-webkit-transform .25s cubic-bezier(0,0,.25,1);-moz-transition:-moz-transform .25s cubic-bezier(0,0,.25,1);transition:transform .25s cubic-bezier(0,0,.25,1)}.leaflet-zoom-anim .leaflet-tile,.leaflet-pan-anim .leaflet-tile{transition:none}.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}.leaflet-interactive{cursor:pointer}.leaflet-grab{cursor:-webkit-grab;cursor:-moz-grab;cursor:grab}.leaflet-crosshair,.leaflet-crosshair .leaflet-interactive{cursor:crosshair}.leaflet-popup-pane,.leaflet-control{cursor:auto}.leaflet-dragging .leaflet-grab,.leaflet-dragging .leaflet-grab .leaflet-interactive,.leaflet-dragging .leaflet-marker-draggable{cursor:move;cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-image-layer,.leaflet-pane>svg path,.leaflet-tile-container{pointer-events:none}.leaflet-marker-icon.leaflet-interactive,.leaflet-image-layer.leaflet-interactive,.leaflet-pane>svg path.leaflet-interactive,svg.leaflet-image-layer.leaflet-interactive path{pointer-events:visiblePainted;pointer-events:auto}.leaflet-container{outline-offset:1px;background:#ddd}.leaflet-container a{color:#0078a8}.leaflet-zoom-box{background:#ffffff80;border:2px dotted #38f}.leaflet-container{font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:.75rem;line-height:1.5}.leaflet-bar{border-radius:4px;box-shadow:0 1px 5px #000000a6}.leaflet-bar a{text-align:center;color:#000;background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;text-decoration:none;display:block}.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50%;background-repeat:no-repeat;display:block}.leaflet-bar a:hover,.leaflet-bar a:focus{background-color:#f4f4f4}.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.leaflet-bar a:last-child{border-bottom:none;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.leaflet-bar a.leaflet-disabled{cursor:default;color:#bbb;background-color:#f4f4f4}.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}.leaflet-touch .leaflet-bar a:first-child{border-top-left-radius:2px;border-top-right-radius:2px}.leaflet-touch .leaflet-bar a:last-child{border-bottom-right-radius:2px;border-bottom-left-radius:2px}.leaflet-control-zoom-in,.leaflet-control-zoom-out{text-indent:1px;font:700 18px Lucida Console,Monaco,monospace}.leaflet-touch .leaflet-control-zoom-in,.leaflet-touch .leaflet-control-zoom-out{font-size:22px}.leaflet-control-layers{background:#fff;border-radius:5px;box-shadow:0 1px 5px #0006}.leaflet-control-layers-toggle{background-image:url(layers.760a0456.png);width:36px;height:36px}.leaflet-retina .leaflet-control-layers-toggle{background-image:url(layers-2x.b7b89169.png);background-size:26px 26px}.leaflet-touch .leaflet-control-layers-toggle{width:44px;height:44px}.leaflet-control-layers .leaflet-control-layers-list,.leaflet-control-layers-expanded .leaflet-control-layers-toggle{display:none}.leaflet-control-layers-expanded .leaflet-control-layers-list{display:block;position:relative}.leaflet-control-layers-expanded{color:#333;background:#fff;padding:6px 10px 6px 6px}.leaflet-control-layers-scrollbar{padding-right:5px;overflow:hidden scroll}.leaflet-control-layers-selector{margin-top:2px;position:relative;top:1px}.leaflet-control-layers label{font-size:1.08333em;display:block}.leaflet-control-layers-separator{border-top:1px solid #ddd;height:0;margin:5px -10px 5px -6px}.leaflet-default-icon-path{background-image:url(marker-icon.3f7d3721.png)}.leaflet-container .leaflet-control-attribution{background:#fffc;margin:0}.leaflet-control-attribution,.leaflet-control-scale-line{color:#333;padding:0 5px;line-height:1.4}.leaflet-control-attribution a{text-decoration:none}.leaflet-control-attribution a:hover,.leaflet-control-attribution a:focus{text-decoration:underline}.leaflet-attribution-flag{width:1em;height:.6669em;vertical-align:baseline!important;display:inline!important}.leaflet-left .leaflet-control-scale{margin-left:5px}.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}.leaflet-control-scale-line{white-space:nowrap;box-sizing:border-box;text-shadow:1px 1px #fff;background:#fffc;border:2px solid #777;border-top:none;padding:2px 5px 1px;line-height:1.1}.leaflet-control-scale-line:not(:first-child){border-top:2px solid #777;border-bottom:none;margin-top:-2px}.leaflet-control-scale-line:not(:first-child):not(:last-child){border-bottom:2px solid #777}.leaflet-touch .leaflet-control-attribution,.leaflet-touch .leaflet-control-layers,.leaflet-touch .leaflet-bar{box-shadow:none}.leaflet-touch .leaflet-control-layers,.leaflet-touch .leaflet-bar{background-clip:padding-box;border:2px solid #0003}.leaflet-popup{text-align:center;margin-bottom:20px;position:absolute}.leaflet-popup-content-wrapper{text-align:left;border-radius:12px;padding:1px}.leaflet-popup-content{min-height:1px;margin:13px 24px 13px 20px;font-size:1.08333em;line-height:1.3}.leaflet-popup-content p{margin:1.3em 0}.leaflet-popup-tip-container{pointer-events:none;width:40px;height:20px;margin-top:-1px;margin-left:-20px;position:absolute;left:50%;overflow:hidden}.leaflet-popup-tip{pointer-events:auto;width:17px;height:17px;margin:-10px auto 0;padding:1px;transform:rotate(45deg)}.leaflet-popup-content-wrapper,.leaflet-popup-tip{color:#333;background:#fff;box-shadow:0 3px 14px #0006}.leaflet-container a.leaflet-popup-close-button{text-align:center;color:#757575;background:0 0;border:none;width:24px;height:24px;font:16px/24px Tahoma,Verdana,sans-serif;text-decoration:none;position:absolute;top:0;right:0}.leaflet-container a.leaflet-popup-close-button:hover,.leaflet-container a.leaflet-popup-close-button:focus{color:#585858}.leaflet-popup-scrolled{overflow:auto}.leaflet-oldie .leaflet-popup-content-wrapper{-ms-zoom:1}.leaflet-oldie .leaflet-popup-tip{-ms-filter:\"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)\";width:24px;filter:progid:DXImageTransform.Microsoft.Matrix(M11=.707107, M12=.707107, M21=-.707107, M22=.707107);margin:0 auto}.leaflet-oldie .leaflet-control-zoom,.leaflet-oldie .leaflet-control-layers,.leaflet-oldie .leaflet-popup-content-wrapper,.leaflet-oldie .leaflet-popup-tip{border:1px solid #999}.leaflet-div-icon{background:#fff;border:1px solid #666}.leaflet-tooltip{color:#222;white-space:nowrap;-webkit-user-select:none;user-select:none;pointer-events:none;background-color:#fff;border:1px solid #fff;border-radius:3px;padding:6px;position:absolute;box-shadow:0 1px 3px #0006}.leaflet-tooltip.leaflet-interactive{cursor:pointer;pointer-events:auto}.leaflet-tooltip-top:before,.leaflet-tooltip-bottom:before,.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{pointer-events:none;content:\"\";background:0 0;border:6px solid #0000;position:absolute}.leaflet-tooltip-bottom{margin-top:6px}.leaflet-tooltip-top{margin-top:-6px}.leaflet-tooltip-bottom:before,.leaflet-tooltip-top:before{margin-left:-6px;left:50%}.leaflet-tooltip-top:before{border-top-color:#fff;margin-bottom:-12px;bottom:0}.leaflet-tooltip-bottom:before{border-bottom-color:#fff;margin-top:-12px;margin-left:-6px;top:0}.leaflet-tooltip-left{margin-left:-6px}.leaflet-tooltip-right{margin-left:6px}.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{margin-top:-6px;top:50%}.leaflet-tooltip-left:before{border-left-color:#fff;margin-right:-12px;right:0}.leaflet-tooltip-right:before{border-right-color:#fff;margin-left:-12px;left:0}@media print{.leaflet-control{print-color-adjust:exact}}";



var $717Zc = parcelRequire("717Zc");

var $2jBaP = parcelRequire("2jBaP");

var $eyNRs = parcelRequire("eyNRs");
const $3b22c72029a66628$var$DefaultIcon = (0, (/*@__PURE__*/$parcel$interopDefault($2jBaP))).icon({
    iconUrl: `${(0, $717Zc.imageFiles).mapArrival}`,
    shadowUrl: (0, $eyNRs.markerShadow),
    iconSize: [
        32,
        41
    ],
    iconAnchor: [
        10,
        41
    ]
});
(0, (/*@__PURE__*/$parcel$interopDefault($2jBaP))).Marker.prototype.options.icon = $3b22c72029a66628$var$DefaultIcon;
const $3b22c72029a66628$var$ShadowRoot = ({ children: children })=>{
    const visibility = (0, $5FZWK.useSelector)((state)=>state.viewReducer.visibility);
    const customScripts = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.customScripts);
    const customCSS = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.customCSS);
    const [alreadyAppliedCustomScripts, setAlreadyAppliedCustomScripts] = (0, $bxRTa.useState)([]);
    const shadowRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (shadowRef?.current) customScripts.forEach((customScript)=>{
            if (!alreadyAppliedCustomScripts.includes(customScript)) {
                // Add the URL of the script to the already processed ones to prevent duplicate injection
                setAlreadyAppliedCustomScripts((current)=>[
                        ...current,
                        customScript
                    ]);
                // Create a script element and inject it in the shadowroot
                const scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.src = customScript;
                scriptElement.onload = ()=>{
                    console.log(`Retorik Framework > custom script loaded from ${customScript}`);
                };
                shadowRef.current?.appendChild(scriptElement);
            }
        });
    }, [
        customScripts
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $d3b255846a013166$export$2e2bcd8739ae039).div, {
        id: "retorik-shadow",
        ref: shadowRef,
        className: "rf-w-full rf-h-full",
        style: {
            position: 'relative',
            overscrollBehaviorY: 'contain',
            touchAction: 'pan-x pan-y',
            visibility: visibility
        },
        children: [
            children,
            /*#__PURE__*/ (0, $fl9nK.jsx)("style", {
                type: "text/css",
                children: `${$614775580864565d$exports}`
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("style", {
                type: "text/css",
                children: `${$5bf62910dd3e016b$exports}`
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("style", {
                type: "text/css",
                children: `${$86d04579703ce0df$exports}`
            }),
            customCSS.map((css, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsx)("link", {
                    rel: "stylesheet",
                    href: css
                }, key);
            })
        ]
    });
};
var $3b22c72029a66628$export$2e2bcd8739ae039 = $3b22c72029a66628$var$ShadowRoot;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $kdMEA = parcelRequire("kdMEA");
const $410cf9d598c613db$export$4aebf65ed07cf17b = {
    rgb: 'rgb(112, 112, 112)'
};
const $410cf9d598c613db$export$d80fe84b82195dbd = {
    ...(0, $kdMEA.commonColors),
    companyName: '#000',
    loader: {
        animation: (0, $kdMEA.commonColors).primary,
        background: 'rgba(18,18,18,0.7)',
        text: '#FFF',
        toggle: {
            text: '#000',
            background: (0, $kdMEA.commonColors).primary
        },
        button: {
            background: {
                default: 'transparent',
                hover: 'transparent'
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            }
        }
    },
    card: {
        frame: {
            background: '#2B2B2B',
            border: 'transparent',
            text: '#F7F3F6'
        },
        button: {
            background: {
                default: 'transparent',
                hover: 'transparent'
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            }
        },
        discoverButton: {
            background: {
                default: '#eaebf0',
                hover: 'transparent'
            },
            border: {
                default: 'transparent',
                hover: '#FFF'
            },
            text: {
                default: '#575F6B',
                hover: '#FFF'
            }
        }
    },
    textMode: {
        panel: {
            background: 'rgba(255, 255, 255, 0.9)',
            border: 'transparent',
            conversationUser: '#FFF',
            conversationBot: '#2C2C2C',
            backgroundUser: (0, $kdMEA.commonColors).secondary,
            backgroundBot: '#F0F0F0'
        }
    },
    vocalMode: {
        subtitles: {
            text: '#FFF',
            background: '#000'
        }
    },
    formInput: {
        text: {
            default: (0, $kdMEA.commonColors).secondary,
            hover: '#FFF'
        },
        inputRadioCheckbox: {
            unchecked: {
                background: '#434141',
                border: '#818181'
            },
            checked: {
                background: (0, $kdMEA.commonColors).primary,
                border: (0, $kdMEA.commonColors).primary,
                item: '#000'
            }
        },
        inputButton: {
            background: {
                default: (0, $kdMEA.commonColors).black,
                hover: (0, $kdMEA.commonColors).primary
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: '#FFF',
                hover: '#FFF'
            }
        },
        likert: {
            default: 'transparent',
            hover: '#E8B712'
        }
    }
};
const $410cf9d598c613db$export$1196b7bf97f3d16c = {
    ...(0, $kdMEA.commonColors),
    companyName: '#000',
    loader: {
        animation: (0, $kdMEA.commonColors).primary,
        background: 'rgba(18,18,18,0.7)',
        text: '#FFF',
        toggle: {
            text: '#000',
            background: (0, $kdMEA.commonColors).primary
        },
        button: {
            background: {
                default: 'transparent',
                hover: 'transparent'
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            }
        }
    },
    card: {
        frame: {
            background: '#2B2B2B',
            border: 'transparent',
            text: '#F7F3F6'
        },
        button: {
            background: {
                default: 'transparent',
                hover: 'transparent'
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            }
        },
        discoverButton: {
            background: {
                default: '#eaebf0',
                hover: 'transparent'
            },
            border: {
                default: 'transparent',
                hover: '#FFF'
            },
            text: {
                default: '#575F6B',
                hover: '#FFF'
            }
        }
    },
    textMode: {
        panel: {
            background: 'rgba(255, 255, 255, 0.9)',
            border: 'transparent',
            conversationUser: '#FFF',
            conversationBot: '#2C2C2C',
            backgroundUser: (0, $kdMEA.commonColors).secondary,
            backgroundBot: '#F0F0F0'
        }
    },
    vocalMode: {
        subtitles: {
            text: '#FFF',
            background: '#000'
        }
    },
    formInput: {
        text: {
            default: (0, $kdMEA.commonColors).secondary,
            hover: '#FFF'
        },
        inputRadioCheckbox: {
            unchecked: {
                background: '#434141',
                border: '#818181'
            },
            checked: {
                background: (0, $kdMEA.commonColors).primary,
                border: (0, $kdMEA.commonColors).primary,
                item: '#000'
            }
        },
        inputButton: {
            background: {
                default: (0, $kdMEA.commonColors).black,
                hover: (0, $kdMEA.commonColors).primary
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: '#FFF',
                hover: '#FFF'
            }
        },
        likert: {
            default: 'transparent',
            hover: '#E8B712'
        }
    }
};


const $4fe2e42aa167de9f$export$6969335ea1e4e77c = (target, source)=>{
    const isObject = (obj)=>obj && typeof obj === 'object';
    if (!isObject(target) || !isObject(source)) return source;
    try {
        const clonedSource = structuredClone(source);
        Object.keys(clonedSource).forEach((key)=>{
            const targetValue = target[key];
            const sourceValue = clonedSource[key];
            if (targetValue || targetValue === false) {
                if (Array.isArray(targetValue) && Array.isArray(sourceValue)) clonedSource[key] = [
                    ...new Set([
                        ...targetValue,
                        ...sourceValue
                    ])
                ];
                else if (isObject(targetValue) && isObject(sourceValue)) clonedSource[key] = $4fe2e42aa167de9f$export$6969335ea1e4e77c(targetValue, sourceValue);
                else clonedSource[key] = targetValue;
            }
        });
        return clonedSource;
    } catch (e) {
        console.log('Retorik Framework > deep merge error : ', e.message);
        return source;
    }
};
const $4fe2e42aa167de9f$var$getThemeColors = (colors)=>{
    let defaultColors = colors?.theme === 'light' ? (0, $410cf9d598c613db$export$1196b7bf97f3d16c) : (0, $410cf9d598c613db$export$d80fe84b82195dbd);
    defaultColors = $4fe2e42aa167de9f$export$6969335ea1e4e77c(colors, defaultColors);
    return defaultColors;
};
var $4fe2e42aa167de9f$export$2e2bcd8739ae039 = $4fe2e42aa167de9f$var$getThemeColors;


const $6b7b10b90b820580$export$284b58786299e6c5 = async ({ configurationData: configurationData, baseAddress: baseAddress })=>{
    if (configurationData) {
        if (typeof configurationData.userConsent === 'boolean') return {
            displayGDPR: false,
            userConsent: configurationData.userConsent
        };
        else return {
            displayGDPR: true,
            data: configurationData
        };
    } else {
        const fullAddress = `${baseAddress}api/gdpr/settings`;
        const response = await fetch(fullAddress).then((res)=>res.json()).catch((error)=>{
            console.warn(error);
            return undefined;
        });
        if (response) {
            // Format response data to get a GDPR-type object
            const responseToData = {
                title: {},
                message: {},
                link: {},
                linkURL: undefined,
                buttonAccept: {},
                buttonRefuse: {},
                messageAccepted: {},
                messageRefused: {}
            };
            for(const locale in response.localizationContainer){
                // Title
                response.localizationContainer[locale]?.ConsentTitle && (responseToData.title[locale] = response.localizationContainer[locale]?.ConsentTitle);
                // Message
                response.localizationContainer[locale]?.ConsentBody && (responseToData.message[locale] = response.localizationContainer[locale]?.ConsentBody);
                // Link
                response.localizationContainer[locale]?.PrivacyStatementTitle && (responseToData.link[locale] = response.localizationContainer[locale]?.PrivacyStatementTitle);
                // Message accepted
                response.localizationContainer[locale]?.ConsentAknowledgementAccepted && (responseToData.messageAccepted[locale] = response.localizationContainer[locale]?.ConsentAknowledgementAccepted);
                // Message refused
                response.localizationContainer[locale]?.ConsentAknowledgementRefused && (responseToData.messageRefused[locale] = response.localizationContainer[locale]?.ConsentAknowledgementRefused);
            }
            // LinkURl is the same for all languages
            responseToData.linkURL = response.privacyStatementUrl;
            return {
                displayGDPR: response.enableConsent,
                data: responseToData
            };
        }
    }
    return {
        displayGDPR: false,
        userConsent: false
    };
};
const $6b7b10b90b820580$export$5e05ceb0f0c2d3f = async ({ configurationData: configurationData, baseAddress: baseAddress })=>{
    if (configurationData) {
        if (typeof configurationData.userConsent === 'boolean') return {
            displayGDPR: false,
            userConsent: configurationData.userConsent
        };
        else return {
            displayGDPR: true,
            data: configurationData
        };
    } else {
        const fullAddress = `${baseAddress}api/gdpr/settings`;
        const response = await fetch(fullAddress).then((res)=>res.json()).catch((error)=>{
            console.warn(error);
            return undefined;
        });
        if (response) {
            // Format response data to get a GDPR-type object
            const responseToData = {
                title: {},
                message: {},
                link: {},
                linkURL: undefined,
                buttonAccept: {},
                buttonRefuse: {},
                messageAccepted: {},
                messageRefused: {}
            };
            // Title
            response.consentTitle && (responseToData.title = response.consentTitle);
            // Message
            response?.consentBody && (responseToData.message = response?.consentBody);
            // Link
            response?.privacyStatementTitle && (responseToData.link = response?.privacyStatementTitle);
            // Message accepted
            response?.consentAknowledgementAccepted && (responseToData.messageAccepted = response?.consentAknowledgementAccepted);
            // Message refused
            response?.consentAknowledgementRefused && (responseToData.messageRefused = response?.consentAknowledgementRefused);
            // LinkURl is the same for all languages
            responseToData.linkURL = response.privacyStatementUrl;
            return {
                displayGDPR: response.enableConsent,
                data: responseToData
            };
        }
    }
    return {
        displayGDPR: false,
        userConsent: false
    };
};




var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");


var $drUL7 = parcelRequire("drUL7");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

const $76a68eb0f2535c39$export$f23ef6cb462a47f7 = (element)=>{
    const div = document.createElement('div');
    div.style.width = '100%';
    const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(div);
    root.render(element);
    return div;
};



var $6XfIC = parcelRequire("6XfIC");

var $fl9nK = parcelRequire("fl9nK");

var $drUL7 = parcelRequire("drUL7");
parcelRequire("6hiCI");
var $28u6w = parcelRequire("28u6w");

var $bxRTa = parcelRequire("bxRTa");

var $eO5xw = parcelRequire("eO5xw");
const $cff17df49c38af05$var$md = new (0, $28u6w.default)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    linkify: false,
    typographer: true,
    quotes: `""''`
});
const $cff17df49c38af05$var$getSizeFromEnum = (size)=>{
    switch(size){
        case (0, $drUL7.TextSize).Small:
            return 'rf-small-size-auto';
        case (0, $drUL7.TextSize).Medium:
            return 'rf-text-medium-size-auto';
        case (0, $drUL7.TextSize).Large:
            return 'rf-text-large-size-auto';
        case (0, $drUL7.TextSize).ExtraLarge:
            return 'rf-text-extralarge-size-auto';
        case (0, $drUL7.TextSize).Default:
        default:
            return 'rf-text-size-auto';
    }
};
const $cff17df49c38af05$var$TextBlock = ({ text: text, isTitle: isTitle, isSubtitle: isSubtitle, size: size, weight: weight, horizontalAlignment: horizontalAlignment, wrap: wrap, maxLines: maxLines })=>{
    const [style, setStyle] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        if (text) {
            // Text size
            let styleToApply = isTitle ? 'rf-title-size-auto' : isSubtitle ? 'rf-subtitle-size-auto' : size ? $cff17df49c38af05$var$getSizeFromEnum(size) : 'rf-text-size-auto';
            // Text horizontal alignment
            if (horizontalAlignment) switch(horizontalAlignment){
                case 1:
                    styleToApply += ' rf-text-center';
                    break;
                case 2:
                    styleToApply += ' ltr:rf-text-right rtl:rf-text-left';
                    break;
                case 0:
                default:
                    styleToApply += ' ltr:rf-text-left rtl:rf-text-right';
                    break;
            }
            else styleToApply += ' ltr:rf-text-left rtl:rf-text-right';
            // Wrap ?
            wrap ? (isTitle || isSubtitle) && (styleToApply += ' rf-line-clamp-2') : styleToApply += ' rf-truncate';
            // Max lines ? If this is a title it has already been set to 2 lines if wrap is not false
            !isTitle && maxLines && maxLines > 0 && maxLines <= 10 && (styleToApply += ` rf-line-clamp-${maxLines}`);
            switch(weight){
                case (0, $drUL7.TextWeight).Lighter:
                    styleToApply += ' rf-font-light';
                    break;
                case (0, $drUL7.TextWeight).Bolder:
                    styleToApply += ' rf-font-bold';
                    break;
                case (0, $drUL7.TextWeight).Default:
                default:
                    break;
            }
            setStyle(styleToApply);
        }
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-full rf-text-cardFrameText ${style}`,
        dangerouslySetInnerHTML: {
            __html: text ? (0, $eO5xw.capitalizeFirstLetter)($cff17df49c38af05$var$md.render(text)) : '\u00a0'
        }
    });
};
var $cff17df49c38af05$export$2e2bcd8739ae039 = $cff17df49c38af05$var$TextBlock;



var $drUL7 = parcelRequire("drUL7");
class $1737244c1bf4b35d$export$92739f4310a31a0d extends (0, $6XfIC.TextBlock) {
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this.renderReact = ()=>{
            let isTitle = false;
            let isSubtitle = false;
            if (this.size && this.size === (0, $drUL7.TextSize).Large) isTitle = true;
            else if (this.size && this.size === (0, $drUL7.TextSize).Medium) isSubtitle = true;
            const props = {
                text: this.text,
                isTitle: isTitle,
                isSubtitle: isSubtitle,
                size: this.size,
                weight: this.weight,
                horizontalAlignment: this.horizontalAlignment,
                wrap: this.wrap,
                maxLines: this.maxLines
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cff17df49c38af05$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $6XfIC = parcelRequire("6XfIC");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $bxRTa = parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
const $eccbad72ba0d7637$var$useCurrentSubView = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)((0, $2rYkD.CurrentSubView).none);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_currentSubView', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_currentSubView'));
        return ()=>{
            document.removeEventListener('retorik_currentSubView', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $eccbad72ba0d7637$export$2e2bcd8739ae039 = $eccbad72ba0d7637$var$useCurrentSubView;



var $bxRTa = parcelRequire("bxRTa");
const $15499adbaa6d13ef$var$useKioskParameterOpening = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(0);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_askedForKioskParametersOpening', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_askedForKioskParametersOpening'));
        return ()=>{
            document.removeEventListener('retorik_askedForKioskParametersOpening', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $15499adbaa6d13ef$export$2e2bcd8739ae039 = $15499adbaa6d13ef$var$useKioskParameterOpening;



var $bxRTa = parcelRequire("bxRTa");
const $4a79f956c4b70684$var$useRetorikEvent = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(undefined);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_retorikEvent', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_retorikEvent'));
        return ()=>{
            document.removeEventListener('retorik_retorikEvent', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $4a79f956c4b70684$export$2e2bcd8739ae039 = $4a79f956c4b70684$var$useRetorikEvent;



var $bxRTa = parcelRequire("bxRTa");
const $4a109e2b0f2a399a$var$useUnlockClickedButton = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(true);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_unlockClickedButton', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_unlockClickedButton'));
        return ()=>{
            document.removeEventListener('retorik_unlockClickedButton', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $4a109e2b0f2a399a$export$2e2bcd8739ae039 = $4a109e2b0f2a399a$var$useUnlockClickedButton;



var $bxRTa = parcelRequire("bxRTa");
const $65aba44f1f006b87$var$useLocale = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)('fr-FR');
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_locale', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_locale'));
        return ()=>{
            document.removeEventListener('retorik_locale', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $65aba44f1f006b87$export$2e2bcd8739ae039 = $65aba44f1f006b87$var$useLocale;



var $bxRTa = parcelRequire("bxRTa");
const $25dce51cfe3b7644$var$useIsRTL = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_isRTL', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_isRTL'));
        return ()=>{
            document.removeEventListener('retorik_isRTL', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $25dce51cfe3b7644$export$2e2bcd8739ae039 = $25dce51cfe3b7644$var$useIsRTL;



var $bxRTa = parcelRequire("bxRTa");
var $51f44367b693a564$exports = {};
$51f44367b693a564$exports = JSON.parse('{"1":"accueil","2":"cha\xeene info live","3":"m\xe9t\xe9o","4":"num\xe9ros d\'urgence","1000":"historique","1001":"tutoriel","common":{"abort":"annuler","all":"tous","back":"retour","close":"fermer","continue":"continuer","download":"t\xe9l\xe9charger","downloadsheet":"t\xe9l\xe9charger cette fiche","downloadsheetmobile":"t\xe9l\xe9charger cette fiche sur mobile","filter":"filtrer","history":"historique","knowmore":"En savoir +","lang":"langues","menu":"menu","mode":"mode","needhelp":"Besoin d\'aide ?","parameters":"param\xe8tres","print":"imprimer","printsheet":"imprimer cette fiche","result":"r\xe9sultat","results":"r\xe9sultats","singleLang":"langue","sound":"son","submit":"valider","subtitle":"sous-titre","tutorial":"tutoriel","validate":"valider"},"emergency":{"shorttitle":"num\xe9ros d\'urgence","samu":"samu","police":"police","firefighter":"pompiers","general":"g\xe9n\xe9ral","citypolice":"Police municipale","hospital":"H\xf4pital","homeless":"Sans abris (appel gratuit)","poison":"Centre anti-poison","emergency":"Urgences europ\xe9ennes"},"error":{"title":"une erreur est survenue","button":"Relancer l\'application"},"history":{"shorttitle":"historique","title":"historique de conversation"},"home":{"shorttitle":"accueil"},"inputs":{"choose":"Choisissez une r\xe9ponse","noaction":"Une action est attendue"},"language":{"change":"changer la langue","select":"s\xe9lectionnez la langue de votre choix"},"link":{"buttontext":"Voir le document","goto":"Acc\xe9der \xe0 l\'adresse","click":"Cliquez-ici","scanQR":"en scannant le QrCode","scanQRTile":"Scanner le QR Code pour d\xe9couvrir"},"loader":{"loader":{"optimal":"Pour une exp\xe9rience optimale,","classic":"Pour une exp\xe9rience plus classique,","vocal":"j\'\xe9change de vive voix avec l\'agent.","text":"j\'\xe9change \xe0 l\'\xe9crit avec l\'agent."},"modes":{"vocal":"mode vocal","text":"mode texte"},"loaderValidation":"D\xe9marrer la conversation","locale":"v\xe9rification de la langue","supported":"v\xe9rification des langues disponibles","store":"cr\xe9ation du store","directline":"connection au directline","ponyfill":"cr\xe9ation du ponyfill","addressdata":"r\xe9cup\xe9ration des donn\xe9es"},"menu":{"message":"Saisissez votre message","backconversation":"retour \xe0 la conversation","answer":" r\xe9pond \xe0 vos questions"},"mobileLandscapePreventer":{"firstline":"Pour une exp\xe9rience optimale,","secondline":"basculez votre \xe9cran"},"news":{"shorttitle":"cha\xeene info live","warningtext":"Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9","live":"direct","continuous":"en continu"},"poi":{"comment":"avis clients","route":"y Aller","nodata":"Aucun contenu ne correspond \xe0 votre recherche","openinghours":"Horaires","prices":"Tarifs","paymentmethods":"Modes de paiement","numberofplaces":"nombre de couverts","openroutemobile":"ouvrir l\'itin\xe9raire Google Maps sur mobile","FoodEstablishment":"O\xf9 manger","LodgingBusiness":"O\xf9 dormir","TouristDestination":"A voir","TouristAttraction":"A faire","Product":"Produits locaux","Service":"Services","Event":"Ev\xe8nements","City":"Villes","Wine":"Vins"},"suggestion":{"consult":"Consultez","thetutorial":"le tutoriel"},"template":{"reset":"effacer tout","showresults":"Afficher les r\xe9sultats","suggestiontitle":"Suggestions de recherches","reminder":"N\'oubliez pas,\\n je peux r\xe9pondre \xe0 vos questions."},"tutorial":{"shorttitle":"tutoriel"},"GDPR":{"title":"traitement des donn\xe9es personnelles transmises au bot","message":"en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d\'analyse de l\'utilisation de l\'outil et d\'enrichissement de la base de connaissance.\\n\\nVos conversations sont conserv\xe9es 6 mois avant de faire l\'objet d\'une suppression.","link":"lien pour consulter les politiques de confidentialit\xe9","buttonAccept":"j\'ai compris et j\'accepte","buttonRefuse":"je refuse","messageAccepted":"votre consentement est bien pris en compte","messageRefused":"votre refus est bien pris en compte"},"anghello":{"listening":"C\'est \xe0 vous, je vous \xe9coute...","correct":"Corriger","dontknow":"Je ne sais pas"},"microphone":{"allow":"Veuillez autoriser votre navigateur \xe0 acc\xe9der au micro pour continuer.","rejected":"Vous avez refus\xe9 l\'acc\xe8s au micro.","instructions":"Pour utiliser le mode vocal, veuillez autoriser votre navigateur \xe0 acc\xe9der au micro.","listening":"Je vous \xe9coute","trigger":"Appuyez ou dites","triggerwithoutname":"Appuyez pour parler"},"position":{"rejected":"Vous avez refus\xe9 l\'acc\xe8s \xe0 votre position GPS.","instructions":"Pour acc\xe9der aux donn\xe9es m\xe9t\xe9orologiques ou \xe0 la carte interactive, veuillez autoriser votre navigateur \xe0 acc\xe9der \xe0 votre position GPS."},"veille":{"calltoaction":"Appuyez sur l\'\xe9cran pour commencer","emptyveille":"Cliquez ou appuyez sur l\'\xe9cran..."},"weather":{"shorttitle":"m\xe9t\xe9o","attribution":"Donn\xe9es m\xe9t\xe9orologiques fournies par Open-Meteo.com"}}');




const $76f6e43a91b8b1d0$var$useTranslation = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)((0, (/*@__PURE__*/$parcel$interopDefault($51f44367b693a564$exports))));
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_translation', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_translation'));
        return ()=>{
            document.removeEventListener('retorik_translation', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $76f6e43a91b8b1d0$export$2e2bcd8739ae039 = $76f6e43a91b8b1d0$var$useTranslation;



var $bxRTa = parcelRequire("bxRTa");
const $0fc42339098f4095$var$useCurrentValue = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(undefined);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_currentValue', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_currentValue'));
        return ()=>{
            document.removeEventListener('retorik_currentValue', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $0fc42339098f4095$export$2e2bcd8739ae039 = $0fc42339098f4095$var$useCurrentValue;



var $bxRTa = parcelRequire("bxRTa");
const $2799a46b4bf8d2a8$var$useValues = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)({});
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_values', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_values'));
        return ()=>{
            document.removeEventListener('retorik_values', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $2799a46b4bf8d2a8$export$2e2bcd8739ae039 = $2799a46b4bf8d2a8$var$useValues;



var $bxRTa = parcelRequire("bxRTa");
const $557bc5ab6089f8fa$var$useIsMobile = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_isMobile', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_isMobile'));
        return ()=>{
            document.removeEventListener('retorik_isMobile', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $557bc5ab6089f8fa$export$2e2bcd8739ae039 = $557bc5ab6089f8fa$var$useIsMobile;



var $bxRTa = parcelRequire("bxRTa");
const $d3530005f67af227$var$useIsWidget = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_isWidget', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_isWidget'));
        return ()=>{
            document.removeEventListener('retorik_isWidget', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $d3530005f67af227$export$2e2bcd8739ae039 = $d3530005f67af227$var$useIsWidget;



var $bxRTa = parcelRequire("bxRTa");
const $3baf3ec5ddd2bbba$var$useIsTactile = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_isTactile', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_isTactile'));
        return ()=>{
            document.removeEventListener('retorik_isTactile', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $3baf3ec5ddd2bbba$export$2e2bcd8739ae039 = $3baf3ec5ddd2bbba$var$useIsTactile;



var $bxRTa = parcelRequire("bxRTa");

const $7fe23951c4219024$var$useThemeColors = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)((0, $410cf9d598c613db$export$d80fe84b82195dbd));
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_themeColors', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_themeColors'));
        return ()=>{
            document.removeEventListener('retorik_themeColors', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $7fe23951c4219024$export$2e2bcd8739ae039 = $7fe23951c4219024$var$useThemeColors;



var $bxRTa = parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
const $a51c1a855c7da240$var$useActiveRecognitionState = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)((0, $2rYkD.RecognitionState).Closed);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_activeRecognitionState', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_activeRecognitionState'));
        return ()=>{
            document.removeEventListener('retorik_activeRecognitionState', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $a51c1a855c7da240$export$2e2bcd8739ae039 = $a51c1a855c7da240$var$useActiveRecognitionState;



var $bxRTa = parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
const $2745467ede20441e$var$useMode = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)((0, $2rYkD.Mode).text);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_mode', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_mode'));
        return ()=>{
            document.removeEventListener('retorik_mode', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $2745467ede20441e$export$2e2bcd8739ae039 = $2745467ede20441e$var$useMode;



var $bxRTa = parcelRequire("bxRTa");
const $364f5050553dbd09$var$useMuted = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_muted', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_muted'));
        return ()=>{
            document.removeEventListener('retorik_muted', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $364f5050553dbd09$export$2e2bcd8739ae039 = $364f5050553dbd09$var$useMuted;



var $bxRTa = parcelRequire("bxRTa");
const $d5d524d74dc0db7d$var$useLoaderClosed = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_loaderClosed', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_loaderClosed'));
        return ()=>{
            document.removeEventListener('retorik_loaderClosed', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $d5d524d74dc0db7d$export$2e2bcd8739ae039 = $d5d524d74dc0db7d$var$useLoaderClosed;



var $bxRTa = parcelRequire("bxRTa");
const $97a5db449eb3f1a7$var$useConfiguration = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)({});
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_configuration', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_configuration'));
        return ()=>{
            document.removeEventListener('retorik_configuration', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $97a5db449eb3f1a7$export$2e2bcd8739ae039 = $97a5db449eb3f1a7$var$useConfiguration;



var $bxRTa = parcelRequire("bxRTa");
const $77444f6cb9655f3f$var$useIsUsedOnBorne = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_isUsedOnBorne', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_isUsedOnBorne'));
        return ()=>{
            document.removeEventListener('retorik_isUsedOnBorne', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $77444f6cb9655f3f$export$2e2bcd8739ae039 = $77444f6cb9655f3f$var$useIsUsedOnBorne;



var $bxRTa = parcelRequire("bxRTa");
const $3d6e1990faa9300b$var$useInputHintBehaviour = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(undefined);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_inputHintBehaviour', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_inputHintBehaviour'));
        return ()=>{
            document.removeEventListener('retorik_inputHintBehaviour', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $3d6e1990faa9300b$export$2e2bcd8739ae039 = $3d6e1990faa9300b$var$useInputHintBehaviour;



var $bxRTa = parcelRequire("bxRTa");
const $5fd246c35edfbfe1$var$useEnableDocumentPrinting = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_enableDocumentPrinting', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_enableDocumentPrinting'));
        return ()=>{
            document.removeEventListener('retorik_enableDocumentPrinting', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $5fd246c35edfbfe1$export$2e2bcd8739ae039 = $5fd246c35edfbfe1$var$useEnableDocumentPrinting;



var $bxRTa = parcelRequire("bxRTa");
const $22882023547f3d80$var$useConversationId = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(null);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_conversationId', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_conversationId'));
        return ()=>{
            document.removeEventListener('retorik_conversationId', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $22882023547f3d80$export$2e2bcd8739ae039 = $22882023547f3d80$var$useConversationId;



var $bxRTa = parcelRequire("bxRTa");
const $07eaaabf5bd7b352$var$useRetrievingConversation = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_retrievingConversation', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_retrievingConversation'));
        return ()=>{
            document.removeEventListener('retorik_retrievingConversation', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $07eaaabf5bd7b352$export$2e2bcd8739ae039 = $07eaaabf5bd7b352$var$useRetrievingConversation;





var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $9e498129f110ea70$var$InputToggle = ({ id: id, title: title, valueOn: valueOn, defaultValue: defaultValue })=>{
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [on, setOn] = (0, $bxRTa.useState)(values[id] || defaultValue === valueOn);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$ff456dc518e4aa26)(id, defaultValue === valueOn);
    }, []);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call parent's handleChange method
   *  - set on state to its opposite
   */ const handleToggle = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            (0, $7b2cab4dfcfe505d$export$7fc8a028c7b38ace)(id, !on);
            setOn(!on);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-text-size-auto rf-text-white",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
            className: "rf-flex rf-flex-row rf-items-start",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                    type: "checkbox",
                    onChange: handleToggle,
                    className: "rf-toggle-custom",
                    checked: on
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-input-label rf-mx-2",
                    children: (0, $eO5xw.capitalizeFirstLetter)(title || id)
                })
            ]
        })
    });
};
var $9e498129f110ea70$export$2e2bcd8739ae039 = $9e498129f110ea70$var$InputToggle;


class $081e22222a7bb1e5$export$c99bfd6b0ed44fbd extends (0, $6XfIC.ToggleInput) {
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this._value = this.defaultValue || this.valueOff, this.renderReact = ()=>{
            return this.id ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9e498129f110ea70$export$2e2bcd8739ae039), {
                id: this.id,
                title: this.title,
                valueOn: this.valueOn,
                defaultValue: this.defaultValue || this.valueOff
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        };
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $e1a09104fc6ecb2a$var$extendStatics = function(d, b) {
    $e1a09104fc6ecb2a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e1a09104fc6ecb2a$var$extendStatics(d, b);
};
function $e1a09104fc6ecb2a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e1a09104fc6ecb2a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e1a09104fc6ecb2a$export$18ce0697a983be9b = function() {
    $e1a09104fc6ecb2a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e1a09104fc6ecb2a$export$18ce0697a983be9b.apply(this, arguments);
};
function $e1a09104fc6ecb2a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e1a09104fc6ecb2a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e1a09104fc6ecb2a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e1a09104fc6ecb2a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e1a09104fc6ecb2a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e1a09104fc6ecb2a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e1a09104fc6ecb2a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e1a09104fc6ecb2a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e1a09104fc6ecb2a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e1a09104fc6ecb2a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e1a09104fc6ecb2a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e1a09104fc6ecb2a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e1a09104fc6ecb2a$export$45d3717a4c69092e(o, m, p);
}
function $e1a09104fc6ecb2a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e1a09104fc6ecb2a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e1a09104fc6ecb2a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e1a09104fc6ecb2a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e1a09104fc6ecb2a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e1a09104fc6ecb2a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e1a09104fc6ecb2a$export$10c90e4f7922046c(v) {
    return this instanceof $e1a09104fc6ecb2a$export$10c90e4f7922046c ? (this.v = v, this) : new $e1a09104fc6ecb2a$export$10c90e4f7922046c(v);
}
function $e1a09104fc6ecb2a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e1a09104fc6ecb2a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e1a09104fc6ecb2a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e1a09104fc6ecb2a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e1a09104fc6ecb2a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e1a09104fc6ecb2a$export$19a8beecd37a4c45 === "function" ? $e1a09104fc6ecb2a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e1a09104fc6ecb2a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e1a09104fc6ecb2a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $e1a09104fc6ecb2a$var$ownKeys = function(o) {
    $e1a09104fc6ecb2a$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $e1a09104fc6ecb2a$var$ownKeys(o);
};
function $e1a09104fc6ecb2a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $e1a09104fc6ecb2a$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $e1a09104fc6ecb2a$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $e1a09104fc6ecb2a$var$__setModuleDefault(result, mod);
    return result;
}
function $e1a09104fc6ecb2a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e1a09104fc6ecb2a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e1a09104fc6ecb2a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e1a09104fc6ecb2a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e1a09104fc6ecb2a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e1a09104fc6ecb2a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e1a09104fc6ecb2a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e1a09104fc6ecb2a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $e1a09104fc6ecb2a$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $e1a09104fc6ecb2a$export$2e2bcd8739ae039 = {
    __extends: $e1a09104fc6ecb2a$export$a8ba968b8961cb8a,
    __assign: $e1a09104fc6ecb2a$export$18ce0697a983be9b,
    __rest: $e1a09104fc6ecb2a$export$3c9a16f847548506,
    __decorate: $e1a09104fc6ecb2a$export$29e00dfd3077644b,
    __param: $e1a09104fc6ecb2a$export$d5ad3fd78186038f,
    __esDecorate: $e1a09104fc6ecb2a$export$3a84e1ae4e97e9b0,
    __runInitializers: $e1a09104fc6ecb2a$export$d831c04e792af3d,
    __propKey: $e1a09104fc6ecb2a$export$6a2a36740a146cb8,
    __setFunctionName: $e1a09104fc6ecb2a$export$d1a06452d3489bc7,
    __metadata: $e1a09104fc6ecb2a$export$f1db080c865becb9,
    __awaiter: $e1a09104fc6ecb2a$export$1050f835b63b671e,
    __generator: $e1a09104fc6ecb2a$export$67ebef60e6f28a6,
    __createBinding: $e1a09104fc6ecb2a$export$45d3717a4c69092e,
    __exportStar: $e1a09104fc6ecb2a$export$f33643c0debef087,
    __values: $e1a09104fc6ecb2a$export$19a8beecd37a4c45,
    __read: $e1a09104fc6ecb2a$export$8d051b38c9118094,
    __spread: $e1a09104fc6ecb2a$export$afc72e2116322959,
    __spreadArrays: $e1a09104fc6ecb2a$export$6388937ca91ccae8,
    __spreadArray: $e1a09104fc6ecb2a$export$1216008129fb82ed,
    __await: $e1a09104fc6ecb2a$export$10c90e4f7922046c,
    __asyncGenerator: $e1a09104fc6ecb2a$export$e427f37a30a4de9b,
    __asyncDelegator: $e1a09104fc6ecb2a$export$bbd80228419bb833,
    __asyncValues: $e1a09104fc6ecb2a$export$e3b29a3d6162315f,
    __makeTemplateObject: $e1a09104fc6ecb2a$export$4fb47efe1390b86f,
    __importStar: $e1a09104fc6ecb2a$export$c21735bcef00d192,
    __importDefault: $e1a09104fc6ecb2a$export$da59b14a69baef04,
    __classPrivateFieldGet: $e1a09104fc6ecb2a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e1a09104fc6ecb2a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e1a09104fc6ecb2a$export$81fdc39f203e4e04,
    __addDisposableResource: $e1a09104fc6ecb2a$export$88ac25d8e944e405,
    __disposeResources: $e1a09104fc6ecb2a$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $e1a09104fc6ecb2a$export$889dfb5d17574b0b
};



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $6XfIC = parcelRequire("6XfIC");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


const $fc9b9a51d999125b$export$ffedad9fbd47bff0 = (dateAsString)=>{
    if (dateAsString) {
        const resultFromLocal = $fc9b9a51d999125b$var$processSplitDate(dateAsString.split('-'));
        if (resultFromLocal) return resultFromLocal;
    }
    const now = new Date();
    return [
        now.getFullYear(),
        now.getMonth() + 1,
        now.getDate()
    ];
};
const $fc9b9a51d999125b$var$processSplitDate = (splitDate)=>{
    if (splitDate.length === 3) {
        const year = parseInt(splitDate[0]);
        const month = parseInt(splitDate[1]);
        const day = parseInt(splitDate[2]);
        if (!isNaN(year) && !isNaN(month) && !isNaN(day)) return [
            year,
            month,
            day
        ];
    }
    return undefined;
};
const $fc9b9a51d999125b$export$9e9b71dbaf488f87 = (month, locale)=>{
    const date = new Date(`2000-${month}-1`).toLocaleString(locale, {
        month: 'long'
    });
    return date;
};



var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("l9TTE");
var $fEfdX = parcelRequire("fEfdX");
/**
 * Oddmonths used to calculate the max amount of days in a month
 */ const $7e56bbb0bd2a2061$var$oddMonths = [
    4,
    6,
    9,
    11
];
const $7e56bbb0bd2a2061$var$InputDate = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue })=>{
    const locale = (0, $65aba44f1f006b87$export$2e2bcd8739ae039)();
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [year, setYear] = (0, $bxRTa.useState)(new Date().getFullYear());
    const [month, setMonth] = (0, $bxRTa.useState)(new Date().getMonth() + 1);
    const [day, setDay] = (0, $bxRTa.useState)(new Date().getDate());
    const [maxYear, setMaxYear] = (0, $bxRTa.useState)(0);
    const [minYear, setMinYear] = (0, $bxRTa.useState)(100000);
    const [maxMonth, setMaxMonth] = (0, $bxRTa.useState)(12);
    const [minMonth, setMinMonth] = (0, $bxRTa.useState)(1);
    const [maxDay, setMaxDay] = (0, $bxRTa.useState)(31);
    const [minDay, setMinDay] = (0, $bxRTa.useState)(1);
    const [maxValueAsDate, setMaxValueAsDate] = (0, $bxRTa.useState)(undefined);
    const [minValueAsDate, setMinValueAsDate] = (0, $bxRTa.useState)(undefined);
    const [updatingDate, setUpdatingDate] = (0, $bxRTa.useState)(false);
    const [dayWheel, setDayWheel] = (0, $bxRTa.useState)(0);
    const [monthWheel, setMonthWheel] = (0, $bxRTa.useState)(0);
    const [yearWheel, setYearWheel] = (0, $bxRTa.useState)(0);
    const days = (0, $bxRTa.useMemo)(()=>{
        if (month && year) {
            // If we check the february month, either 28 or 29 days depending on the year
            if (month === 2) return year % 4 === 0 ? 29 : 28;
            // 30 days for oddMonths, 31 otherwise
            return $7e56bbb0bd2a2061$var$oddMonths.includes(month) ? 30 : 31;
        }
        return undefined;
    }, [
        month,
        year
    ]);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On days state change :
   *  - set day state if current day is higher than days
   */ (0, $bxRTa.useEffect)(()=>{
        day && days && day > days && setDay(days);
    }, [
        days
    ]);
    /**
   * On component mount :
   *  - set day / month / year from localStorage value if there is one, current Date otherwise
   *  - set max values from props or current Date + 150 years otherwise
   */ (0, $bxRTa.useEffect)(()=>{
        const dateAsArray = (0, $fc9b9a51d999125b$export$ffedad9fbd47bff0)(values[id] || defaultValue);
        setYear(dateAsArray[0]);
        setMonth(dateAsArray[1]);
        setDay(dateAsArray[2]);
        // Set min and max years
        const now = new Date();
        if (maxValue) {
            const maxAsDate = new Date(maxValue);
            setMaxValueAsDate(maxAsDate);
            setMaxYear(maxAsDate.getFullYear());
            setMaxMonth(maxAsDate.getMonth() + 1);
            setMaxDay(maxAsDate.getDate());
        } else setMaxYear(now.getFullYear() + 150);
        if (minValue) {
            const minAsDate = new Date(minValue);
            setMinValueAsDate(minAsDate);
            setMinYear(minAsDate.getFullYear());
            setMinMonth(minAsDate.getMonth() + 1);
            setMinDay(minAsDate.getDate());
        } else setMinYear(now.getFullYear() - 150);
    }, []);
    /**
   * On day / month / year state change :
   *  - check if a day / month / year change is needed to keep the date a proper one
   *  - for example on february, there are either 28 or 29 days depending on the year
   *  - set the value in localStorage
   *  - if an update is needed, set the updatingDate state to true to prevent concurrent modification, update, and set updatingdate back to false to release lock
   */ (0, $bxRTa.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        if (!updatingDate && day && month && year) {
            let updating = false;
            let dateAsString = `${year}-${month}-${day}`;
            const date = new Date(dateAsString);
            if (minValue && minValueAsDate && date < minValueAsDate) {
                dateAsString = minValue;
                updating = true;
            } else if (maxValue && maxValueAsDate && date > maxValueAsDate) {
                dateAsString = maxValue;
                updating = true;
            }
            // Save date
            (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, dateAsString);
            // Update states if necessary
            if (updating) {
                setUpdatingDate(true);
                const dateAsArray = dateAsString.split('-');
                setYear(parseInt(dateAsArray[0]));
                setMonth(parseInt(dateAsArray[1]));
                setDay(parseInt(dateAsArray[2]));
                setUpdatingDate(false);
            }
        }
    }, [
        day,
        month,
        year
    ]);
    /**
   * On dayWheel change, if dayWheel !== 0 :
   *  - try to update the day state
   *  - reset dayWheel state to 0
   */ (0, $bxRTa.useEffect)(()=>{
        if (dayWheel !== 0 && day && days) {
            if (dayWheel > 0) day + 1 > days ? setDay(1) : setDay((day)=>day + 1);
            else day - 1 > 0 ? setDay((day)=>day - 1) : setDay(days);
            // Reset dayWheel
            setDayWheel(0);
        }
    }, [
        dayWheel
    ]);
    /**
   * On monthWheel change, if monthWheel !== 0 :
   *  - try to update the month state
   *  - reset monthWheel state to 0
   */ (0, $bxRTa.useEffect)(()=>{
        if (monthWheel !== 0 && month) {
            if (monthWheel > 0) month + 1 > 12 ? setMonth(1) : setMonth((month)=>month + 1);
            else month - 1 > 0 ? setMonth((month)=>month - 1) : setMonth(12);
            // Reset monthWheel
            setMonthWheel(0);
        }
    }, [
        monthWheel
    ]);
    /**
   * On yearWheel change, if yearWheel !== 0 :
   *  - try to update the year state
   *  - reset yearWheel state to 0
   */ (0, $bxRTa.useEffect)(()=>{
        if (yearWheel !== 0 && year && minYear && maxYear) {
            if (yearWheel > 0) year !== maxYear && setYear((year)=>year + 1);
            else year !== minYear && setYear((year)=>year - 1);
            // Reset yearWheel
            setYearWheel(0);
        }
    }, [
        yearWheel
    ]);
    /**
   * On wheel event on day / month / year part :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - call wheel state depending on the type, that will trigger the related day / month / year state update if possible
   * @param delta : number
   * @param type : string
   */ const handleWheel = (delta, type)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) switch(type){
            case 'day':
                setDayWheel(delta);
                break;
            case 'month':
                setMonthWheel(delta);
                break;
            case 'year':
                setYearWheel(delta);
                break;
            default:
                break;
        }
    };
    /**
   * On click on a day / month / year :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - set chosen day / month / year if it is within the accepted bounds
   * @param value : number
   * @param type : string
   */ const handleClick = (value, type)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) switch(type){
            case 'day':
                day && setDay(value);
                break;
            case 'month':
                month && value !== -1 && setMonth(value);
                break;
            case 'year':
                year && value !== -1 && setYear(value);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg rf-subtitle-size-auto rf-text-formInputRadioCheckboxUncheckedBackground rf-unselectable",
        style: {
            background: 'linear-gradient(rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0.5) 34%, black 34%, black 65%, rgb(0, 0, 0, 0.5) 65%, rgb(0, 0, 0, 0.5) 100%)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                type: "date",
                className: "rf-hidden"
            }),
            year && month && day && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fEfdX.default), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "day",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear && month === minMonth && day === minDay ? -1 : day === 1 ? days || 1 : day - 1, 'day'),
                                children: year === minYear && month === minMonth && day === minDay ? '\u2800' : day === 1 ? `${days}` : `${day - 1}`
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: day
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear && month === maxMonth && day === maxDay ? -1 : day === days ? 1 : day + 1, 'day'),
                                children: year === maxYear && month === maxMonth && day === maxDay ? '\u2800' : day === days ? '1' : `${day + 1}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fEfdX.default), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "month",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear && month === minMonth ? -1 : month === 1 ? 12 : month - 1, 'month'),
                                children: year === minYear && month === minMonth ? '\u2800' : month === 1 ? `${(0, $eO5xw.capitalizeFirstLetter)((0, $fc9b9a51d999125b$export$9e9b71dbaf488f87)(12, locale))}` : `${(0, $eO5xw.capitalizeFirstLetter)((0, $fc9b9a51d999125b$export$9e9b71dbaf488f87)(month - 1, locale))}`
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: `${(0, $eO5xw.capitalizeFirstLetter)((0, $fc9b9a51d999125b$export$9e9b71dbaf488f87)(month, locale))}`
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear && month === maxMonth ? -1 : month === 12 ? 1 : month + 1, 'month'),
                                children: year === maxYear && month === maxMonth ? '\u2800' : month === 12 ? `${(0, $eO5xw.capitalizeFirstLetter)((0, $fc9b9a51d999125b$export$9e9b71dbaf488f87)(1, locale))}` : `${(0, $eO5xw.capitalizeFirstLetter)((0, $fc9b9a51d999125b$export$9e9b71dbaf488f87)(month + 1, locale))}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fEfdX.default), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "year",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear ? -1 : year - 1, 'year'),
                                children: year === minYear ? '\u2800' : year - 1
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: year
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear ? -1 : year + 1, 'year'),
                                children: year === maxYear ? '\u2800' : year + 1
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $7e56bbb0bd2a2061$export$2e2bcd8739ae039 = $7e56bbb0bd2a2061$var$InputDate;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");




var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("7Jjoy");
var $3kuIS = parcelRequire("3kuIS");
var $iyJo4 = parcelRequire("iyJo4");
/**
 * Oddmonths used to calculate the max amount of days in a month
 */ const $458e84cda88f0199$var$oddMonths = [
    4,
    6,
    9,
    11
];
const $458e84cda88f0199$var$InputCalendar = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue, handleChange: handleChange, isFilter: isFilter })=>{
    const locale = (0, $65aba44f1f006b87$export$2e2bcd8739ae039)();
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [year, setYear] = (0, $bxRTa.useState)(new Date().getFullYear());
    const [month, setMonth] = (0, $bxRTa.useState)(new Date().getMonth() + 1);
    const [day, setDay] = (0, $bxRTa.useState)(new Date().getDate());
    const [maxYear, setMaxYear] = (0, $bxRTa.useState)(0);
    const [minYear, setMinYear] = (0, $bxRTa.useState)(100000);
    const [maxMonth, setMaxMonth] = (0, $bxRTa.useState)(12);
    const [minMonth, setMinMonth] = (0, $bxRTa.useState)(1);
    const [maxDay, setMaxDay] = (0, $bxRTa.useState)(31);
    const [minDay, setMinDay] = (0, $bxRTa.useState)(1);
    const [maxValueAsDate, setMaxValueAsDate] = (0, $bxRTa.useState)(undefined);
    const [minValueAsDate, setMinValueAsDate] = (0, $bxRTa.useState)(undefined);
    const [date, setDate] = (0, $bxRTa.useState)(values[id] || `${year}-${month}-${day}`);
    /**
   * On month / year states change :
   *  - calculate and return the number of days of the current month
   */ const days = (0, $bxRTa.useMemo)(()=>{
        if (month && year) {
            // If we check the february month, either 28 or 29 days depending on the year
            if (month === 2) return year % 4 === 0 ? 29 : 28;
            // 30 days for oddMonths, 31 otherwise
            return $458e84cda88f0199$var$oddMonths.includes(month) ? 30 : 31;
        }
        return undefined;
    }, [
        month,
        year
    ]);
    /**
   * On month / year states change :
   *  - check which day is the first day of the month
   *  - return the number of days of week before the first one of the month
   */ const emptyDays = (0, $bxRTa.useMemo)(()=>{
        const firstDay = new Date(year, month - 1, 1).toLocaleString('fr-FR', {
            weekday: 'long'
        });
        switch(firstDay.toLowerCase()){
            case 'lundi':
                return 0;
            case 'mardi':
                return 1;
            case 'mercredi':
                return 2;
            case 'jeudi':
                return 3;
            case 'vendredi':
                return 4;
            case 'samedi':
                return 5;
            case 'dimanche':
                return 6;
        }
        return 0;
    }, [
        month,
        year
    ]);
    const title = (0, $bxRTa.useMemo)(()=>{
        const newDate = new Date(year, month - 1, 1);
        return (0, $eO5xw.capitalizeFirstLetter)(new Date(newDate).toLocaleString(locale, {
            month: 'long',
            year: 'numeric'
        }));
    }, [
        month,
        year
    ]);
    /**
   * On locale change :
   *  - translate the days of week to display depending on the locale
   */ const daysOfWeek = (0, $bxRTa.useMemo)(()=>{
        let tempArray = [];
        for(let i = 1; i < 8; i++){
            // First day of May 2023 is monday, let's get each day one after another beginning by monday
            const newDate = new Date(2023, 4, i);
            tempArray = [
                ...tempArray,
                (0, $eO5xw.capitalizeFirstLetter)(newDate.toLocaleString(locale, {
                    weekday: 'short'
                }))
            ];
        }
        return tempArray;
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On component mount :
   *  - set day / month / year from localStorage value if there is one, current Date otherwise
   *  - set max values from props or current Date + 150 years otherwise
   */ (0, $bxRTa.useEffect)(()=>{
        const dateAsArray = (0, $fc9b9a51d999125b$export$ffedad9fbd47bff0)(values[id] || defaultValue);
        setYear(dateAsArray[0]);
        setMonth(dateAsArray[1]);
        setDay(dateAsArray[2]);
        setDate(`${dateAsArray[0]}-${dateAsArray[1]}-${dateAsArray[2]}`);
        // Set min and max years
        const now = new Date();
        if (maxValue) {
            const maxAsDate = new Date(maxValue);
            setMaxValueAsDate(maxAsDate);
            setMaxYear(maxAsDate.getFullYear());
            setMaxMonth(maxAsDate.getMonth() + 1);
            setMaxDay(maxAsDate.getDate());
        } else setMaxYear(now.getFullYear() + 150);
        if (minValue) {
            const minAsDate = new Date(minValue);
            setMinValueAsDate(minAsDate);
            setMinYear(minAsDate.getFullYear());
            setMinMonth(minAsDate.getMonth() + 1);
            setMinDay(minAsDate.getDate());
        } else setMinYear(now.getFullYear() - 150);
    }, []);
    /**
   * On day / month / year state change :
   *  - check if the date is in the boundaries of minDate / maxDate
   *  - set the value in localStorage
   */ (0, $bxRTa.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        // Explode date to extract each value and substract 1 to the month (begins at 0 in js Date object)
        const dateAsArray = date.split('-');
        const newDate = new Date(parseInt(dateAsArray[0]), parseInt(dateAsArray[1]) - 1, parseInt(dateAsArray[2]));
        if (minValue && minValueAsDate && newDate < minValueAsDate) {
            setDay(minDay);
            setMonth(minMonth);
            setYear(minYear);
            setDate(minValue);
        } else if (maxValue && maxValueAsDate && newDate > maxValueAsDate) {
            setDay(maxDay);
            setMonth(maxMonth);
            setYear(maxYear);
            setDate(maxValue);
        } else // Save date
        id !== 'filterCalendar' && (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, date);
    }, [
        date
    ]);
    const handlePreviousMonth = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            if (year > minYear) {
                setMonth((month)=>month === 1 ? 12 : month - 1);
                month === 1 && setYear((year)=>year - 1);
            } else if (year === minYear && month > minMonth) month > 1 && setMonth((month)=>month - 1);
        }
    };
    const handleNextMonth = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            if (year < maxYear) {
                setMonth((month)=>month === 12 ? 1 : month + 1);
                month === 12 && setYear((year)=>year + 1);
            } else if (year === maxYear && month < maxMonth) month < 12 && setMonth((month)=>month + 1);
        }
    };
    const handleClick = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setDay(value);
            setDate(`${year}-${month}-${value}`);
            id === 'filterCalendar' && handleChange?.(`${year}-${month < 10 ? '0' : ''}${month}-${value < 10 ? '0' : ''}${value}`);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-px-2 rf-flex rf-flex-col rf-rounded-lg ${isFilter ? 'rf-text-trueblack' : 'rf-text-truewhite'} rf-subtitle-size-auto rf-unselectable`,
        style: {
            background: isFilter ? '#FFF' : 'rgba(0, 0, 0, 0.5)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-px-4 rf-py-6 rf-flex rf-flex-row rf-justify-between rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-4 rf-cursor-pointer",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handlePreviousMonth();
                        },
                        children: (year > minYear || year === minYear && month > minMonth) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3kuIS.default), {
                            className: "rf-h-4",
                            color: isFilter ? '#000' : '#FFF'
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: `rf-width-fill-available rf-text-center rf-title-size-auto ${isFilter ? 'rf-text-secondary' : 'rf-text-primary'}`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-4 rf-cursor-pointer",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handleNextMonth();
                        },
                        children: (year < maxYear || year === maxYear && month < maxMonth) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iyJo4.default), {
                            className: "rf-h-4",
                            color: isFilter ? '#000' : '#FFF'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-py-6 rf-grid rf-grid-cols-7 rf-gap-4",
                children: [
                    daysOfWeek.map((weekDay, key)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-flex rf-justify-center rf-items-center rf-aspect-square",
                            children: weekDay
                        }, key);
                    }),
                    [
                        ...Array(emptyDays)
                    ].map((e, key)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-aspect-square",
                            children: e || '\u2800'
                        }, (key + 1) * 10);
                    }),
                    [
                        ...Array(days)
                    ].map((e, key)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: `rf-flex rf-justify-center rf-items-center rf-aspect-square ${key + 1 === day && parseInt(date.split('-')[1]) === month && parseInt(date.split('-')[0]) === year ? `rf-font-bold rf-text-trueblack ${isFilter ? 'rf-bg-secondary' : 'rf-bg-primary'} rf-rounded-half` : year === maxYear && month === maxMonth && key + 1 > maxDay ? 'rf-text-formInputRadioCheckboxUncheckedBackground' : 'rf-cursor-pointer'}`,
                            onClick: (e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                handleClick(key + 1);
                            },
                            children: e || key + 1
                        }, (key + 1) * 100);
                    })
                ]
            })
        ]
    });
};
var $458e84cda88f0199$export$2e2bcd8739ae039 = $458e84cda88f0199$var$InputCalendar;



var $drUL7 = parcelRequire("drUL7");
class $8c9a3349b8312469$export$a9633577dcb92569 extends (0, $6XfIC.DateInput) {
    static{
        // Add custom property to schema
        this.calendarProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'calendar', false);
    }
    // Calendar property accessors
    get calendar() {
        return !!this.getValue($8c9a3349b8312469$export$a9633577dcb92569.calendarProperty);
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this.renderReact = ()=>{
            return this.id ? this.calendar ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $458e84cda88f0199$export$2e2bcd8739ae039), {
                id: this.id,
                defaultValue: this.defaultValue,
                maxValue: this.max,
                minValue: this.min
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7e56bbb0bd2a2061$export$2e2bcd8739ae039), {
                id: this.id,
                defaultValue: this.defaultValue,
                maxValue: this.max,
                minValue: this.min
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($8c9a3349b8312469$export$a9633577dcb92569.calendarProperty)
], $8c9a3349b8312469$export$a9633577dcb92569.prototype, "calendar", null);



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $6XfIC = parcelRequire("6XfIC");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");



var $2rYkD = parcelRequire("2rYkD");

var $fEfdX = parcelRequire("fEfdX");
const $fda5f12a9973a178$var$InputTime = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue })=>{
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [hour, setHour] = (0, $bxRTa.useState)(12);
    const [minute, setMinute] = (0, $bxRTa.useState)(0);
    const [maxHour, setMaxHour] = (0, $bxRTa.useState)(23);
    const [minHour, setMinHour] = (0, $bxRTa.useState)(0);
    const [maxMinute, setMaxMinute] = (0, $bxRTa.useState)(59);
    const [minMinute, setMinMinute] = (0, $bxRTa.useState)(0);
    const [updatingTime, setUpdatingTime] = (0, $bxRTa.useState)(false);
    const [hourWheel, setHourWheel] = (0, $bxRTa.useState)(0);
    const [minuteWheel, setMinuteWheel] = (0, $bxRTa.useState)(0);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On component mount :
   *  - set hour / minute from localStorage value if there is one, or defaultValue, or 12:00 if no other data
   *  - set maxHour and maxMinute states if maxValue prop is set
   *  - set minHour and minMinute states if minValue prop is set
   */ (0, $bxRTa.useEffect)(()=>{
        // Set hour and minute from localstorage or defaultvalue if one of those is set
        const timeFromLocalStorage = values[id] || defaultValue;
        const timeAsArray = timeFromLocalStorage ? timeFromLocalStorage.split(':') : [];
        if (timeAsArray.length === 2) {
            !isNaN(parseInt(timeAsArray[0])) && setHour(parseInt(timeAsArray[0]));
            !isNaN(parseInt(timeAsArray[1])) && setMinute(parseInt(timeAsArray[1]));
        }
        // Set min and max times
        if (maxValue) {
            const maxTimeAsArray = maxValue.split(':');
            setMaxHour(parseInt(maxTimeAsArray[0]));
            setMaxMinute(parseInt(maxTimeAsArray[1]));
        }
        if (minValue) {
            const minTimeAsArray = minValue.split(':');
            setMinHour(parseInt(minTimeAsArray[0]));
            setMinMinute(parseInt(minTimeAsArray[1]));
        }
    }, []);
    /**
   * On hour / minute state change :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - set the value in localStorage
   *  - if an update is needed, set the updatingTime state to true to prevent concurrent modification, update, and set updatingTime back to false to release lock
   */ (0, $bxRTa.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        if (!updatingTime && hour !== undefined && minute !== undefined) {
            let updating = false;
            // Deal with hours and minutes lower than 10 : add a '0' before to keep 2-characters length for each
            const tempHour = hour < 10 ? `0${hour}` : hour;
            const tempMinute = minute < 10 ? `0${minute}` : minute;
            let timeAsString = `${tempHour}:${tempMinute}`;
            // Check if the time is lower than the minimal value if given, or greater than the maximal one if given
            if (minValue && (hour < minHour || hour === minHour && minute < minMinute)) {
                timeAsString = minValue;
                updating = true;
            } else if (maxValue && (hour > maxHour || hour === maxHour && minute > maxMinute)) {
                timeAsString = maxValue;
                updating = true;
            }
            // Save time
            (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, timeAsString);
            // Update states if necessary
            if (updating) {
                setUpdatingTime(true);
                const timeAsArray = timeAsString.split(':');
                setHour(parseInt(timeAsArray[0]));
                setMinute(parseInt(timeAsArray[1]));
                setUpdatingTime(false);
            }
        }
    }, [
        hour,
        minute
    ]);
    /**
   * On hourWheel change, if hourWheel !== 0 :
   *  - try to update the hour state
   *  - reset hourWheel state to 0
   */ (0, $bxRTa.useEffect)(()=>{
        if (hourWheel !== 0 && hour !== undefined) {
            if (hourWheel > 0) hour + 1 > 23 ? setHour(0) : setHour((hour)=>hour + 1);
            else hour - 1 < 0 ? setHour(23) : setHour((hour)=>hour - 1);
            // Reset dayWheel
            setHourWheel(0);
        }
    }, [
        hourWheel
    ]);
    /**
   * On minuteWheel change, if minuteWheel !== 0 :
   *  - try to update the minute state
   *  - reset minuteWheel state to 0
   */ (0, $bxRTa.useEffect)(()=>{
        if (minuteWheel !== 0 && minute !== undefined) {
            if (minuteWheel > 0) minute + 1 > 59 ? setMinute(0) : setMinute((minute)=>minute + 1);
            else minute - 1 < 0 ? setMinute(59) : setMinute((minute)=>minute - 1);
            // Reset monthWheel
            setMinuteWheel(0);
        }
    }, [
        minuteWheel
    ]);
    /**
   * On wheel event on hour / minute part :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call wheel state depending on the type, that will trigger the related hour / minute state update if possible
   * @param delta : number
   * @param type : string
   */ const handleWheel = (delta, type)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) switch(type){
            case 'hour':
                setHourWheel(delta);
                break;
            case 'minute':
                setMinuteWheel(delta);
                break;
            default:
                break;
        }
    };
    /**
   * On click on a hour / minute :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - set chosen hour / minute if it is within the accepted bounds
   * @param value : number
   * @param type : string
   */ const handleClick = (value, type)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) switch(type){
            case 'hour':
                hour !== undefined && value !== -1 && setHour(value);
                break;
            case 'minute':
                minute !== undefined && value !== -1 && setMinute(value);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        dir: "ltr" /*To keep the time in the right direction, as it reads HH:MM universally*/ ,
        className: "rf-w-full rf-mt-4 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg rf-subtitle-size-auto rf-text-formInputRadioCheckboxUncheckedBackground rf-unselectable",
        style: {
            background: 'linear-gradient(rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0.5) 34%, black 34%, black 65%, rgb(0, 0, 0, 0.5) 65%, rgb(0, 0, 0, 0.5) 100%)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                type: "time",
                className: "rf-hidden"
            }),
            hour !== undefined && minute !== undefined && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fEfdX.default), {
                        className: "rf-flex rf-flex-col rf-items-center rf-pr-1 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "hour",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(minValue && hour === minHour ? -1 : hour === 0 ? 23 : hour - 1, 'hour'),
                                children: minValue && hour === minHour ? '\u2800' : hour === 0 ? '23' : hour < 11 ? `0${hour - 1}` : hour - 1
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: hour < 10 ? `0${hour}` : hour
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(maxValue && hour === maxHour ? -1 : hour === 23 ? 0 : hour + 1, 'hour'),
                                children: maxValue && hour === maxHour ? '\u2800' : hour === 23 ? '00' : hour < 9 ? `0${hour + 1}` : hour + 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-flex rf-flex-col rf-items-center rf-py-1",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: '\u2800'
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-text-primary",
                                children: ":"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: '\u2800'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fEfdX.default), {
                        className: "rf-flex rf-flex-col rf-items-center rf-pl-1 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "minute",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(minValue && hour === minHour && minute === minMinute ? -1 : minute === 0 ? 59 : minute - 1, 'minute'),
                                children: minValue && hour === minHour && minute === minMinute ? '\u2800' : minute === 0 ? '59' : minute < 11 ? `0${minute - 1}` : minute - 1
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: minute < 10 ? `0${minute}` : minute
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(maxValue && hour === maxHour && minute === maxMinute ? -1 : minute === 59 ? 0 : minute + 1, 'minute'),
                                children: maxValue && hour === maxHour && minute === maxMinute ? '\u2800' : minute < 9 ? `0${minute + 1}` : minute === 59 ? '00' : minute + 1
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fda5f12a9973a178$export$2e2bcd8739ae039 = $fda5f12a9973a178$var$InputTime;


class $7186f765e3370ce8$export$27dc9c3aadf0815c extends (0, $6XfIC.TimeInput) {
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this._value = this.defaultValue || undefined, this.renderReact = ()=>{
            return this.id ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fda5f12a9973a178$export$2e2bcd8739ae039), {
                id: this.id,
                defaultValue: this.defaultValue,
                maxValue: this.max,
                minValue: this.min
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        };
    }
}




var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");



var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $139d6d494ef941ff$var$Radio = ({ id: id, choices: choices, split: split })=>{
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values[id] || '');
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $bxRTa.useEffect)(()=>{
        if (choices) {
            if (split) {
                const nbRows = Math.ceil(choices.length / 2);
                setDisplay([
                    choices.slice(0, nbRows),
                    choices.slice(nbRows)
                ]);
            } else setDisplay(choices);
        }
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setChosen(value);
            (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, value);
        }
    };
    return display && display.length > 0 ? split ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-text-size-auto rf-text-white",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[0].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-radio-custom",
                                onChange: ()=>handleChange(choice.value)
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("label", {
                                htmlFor: `radio-${key}`,
                                className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                                children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                            })
                        ]
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[1].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-radio-custom",
                                onChange: ()=>handleChange(choice.value)
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("label", {
                                htmlFor: `radio-${key}`,
                                className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                                children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                            })
                        ]
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                        type: "radio",
                        value: choice.value,
                        checked: choice.value === chosen,
                        className: "rf-radio-custom",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("label", {
                        htmlFor: `radio-${key}`,
                        className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                        children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $139d6d494ef941ff$export$2e2bcd8739ae039 = $139d6d494ef941ff$var$Radio;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");



var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $ee499ba1a4538846$var$RadioAsButton = ({ id: id, choices: choices })=>{
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values[id] || '');
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $bxRTa.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setChosen(value);
            (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, value);
        }
    };
    return display?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-flex-wrap rf-justify-center rf-items-center rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                className: `rf-mx-2 rf-flex rf-justify-center rf-items-center rf-px-4 rf-py-2 large:rf-px-5 large:rf-py-3 rf-border rf-rounded-lg ${choice.value === chosen ? 'rf-bg-formInputButtonBackgroundHover rf-text-formInputButtonTextHover rf-border-formInputButtonBorderHover' : 'rf-bg-formInputButtonBackgroundDefault rf-text-formInputButtonTextDefault rf-border-formInputButtonBorderDefault'} rf-mb-4 hover:rf-cursor-pointer`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                        type: "radio",
                        value: choice.value,
                        checked: choice.value === chosen,
                        className: "rf-input-hidden",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $ee499ba1a4538846$export$2e2bcd8739ae039 = $ee499ba1a4538846$var$RadioAsButton;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");



var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("kMAJU");
var $kA2rN = parcelRequire("kA2rN");
const $b9c2f2df8863a08d$var$Checkbox = ({ id: id, choices: choices, split: split })=>{
    const themeColors = (0, $7fe23951c4219024$export$2e2bcd8739ae039)();
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values[id] || []);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $bxRTa.useEffect)(()=>{
        if (choices) {
            if (split) {
                const nbRows = Math.ceil(choices.length / 2);
                setDisplay([
                    choices.slice(0, nbRows),
                    choices.slice(nbRows)
                ]);
            } else setDisplay(choices);
        }
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $bxRTa.useEffect)(()=>{
        (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, chosen);
    }, [
        chosen
    ]);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleChangeCheckbox method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display?.length ? split ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-text-size-auto rf-text-white",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-1/2 ltr:rf-pr-2 rtl:rf-pl-2 rf-flex rf-flex-col rf-items-start",
                children: display[0].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-relative rf-mb-3",
                        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                            className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                    type: "checkbox",
                                    value: choice.value,
                                    checked: chosen.includes(choice.value),
                                    onChange: ()=>handleChange(choice.value),
                                    className: "rf-checkbox-custom"
                                }),
                                chosen.includes(choice.value) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $kA2rN.default), {
                                    className: "rf-absolute ltr:rf-left-1 rtl:rf-right-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                                    color: themeColors.formInput.inputRadioCheckbox.checked.item
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                    className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                                    children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                                })
                            ]
                        })
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[1].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-relative rf-mb-3",
                        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                            className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                    type: "checkbox",
                                    value: choice.value,
                                    checked: chosen.includes(choice.value),
                                    onChange: ()=>handleChange(choice.value),
                                    className: "rf-checkbox-custom"
                                }),
                                chosen.includes(choice.value) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $kA2rN.default), {
                                    className: "rf-absolute ltr:rf-left-1 rtl:rf-right-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                                    color: themeColors.formInput.inputRadioCheckbox.checked.item
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                    className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                                    children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                                })
                            ]
                        })
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-col rf-items-start rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-relative rf-mb-3",
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                    className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                            type: "checkbox",
                            value: choice.value,
                            checked: chosen.includes(choice.value),
                            onChange: ()=>handleChange(choice.value),
                            className: "rf-checkbox-custom"
                        }),
                        chosen.includes(choice.value) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $kA2rN.default), {
                            className: "rf-absolute ltr:rf-left-1 rtl:rf-right-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                            color: themeColors.formInput.inputRadioCheckbox.checked.item
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                            children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                        })
                    ]
                })
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $b9c2f2df8863a08d$export$2e2bcd8739ae039 = $b9c2f2df8863a08d$var$Checkbox;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");



var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $945b84087e337d98$var$CheckboxAsButton = ({ id: id, choices: choices })=>{
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values[id] || []);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $bxRTa.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $bxRTa.useEffect)(()=>{
        (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, chosen);
    }, [
        chosen
    ]);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleChangeCheckbox method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-flex-wrap rf-justify-center rf-items-center rf-text-size-auto",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                className: `rf-mx-2 rf-flex rf-justify-center rf-items-center rf-px-4 rf-py-2 large:rf-px-5 large:rf-py-3 rf-border rf-rounded-lg ${chosen.includes(choice.value) ? 'rf-bg-formInputButtonBackgroundHover rf-text-formInputButtonTextHover rf-border-formInputButtonBorderHover' : 'rf-bg-formInputButtonBackgroundDefault rf-text-formInputButtonTextDefault rf-border-formInputButtonBorderDefault'} rf-mb-4 hover:rf-cursor-pointer`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                        type: "checkbox",
                        value: choice.value,
                        checked: chosen.includes(choice.value),
                        className: "rf-input-hidden",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $945b84087e337d98$export$2e2bcd8739ae039 = $945b84087e337d98$var$CheckboxAsButton;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");



var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("hNqlv");
var $1NaGJ = parcelRequire("1NaGJ");
const $6acb6a669ff438f0$var$Select = ({ id: id, choices: choices, placeholder: placeholder })=>{
    const translation = (0, $76f6e43a91b8b1d0$export$2e2bcd8739ae039)();
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [open, setOpen] = (0, $bxRTa.useState)(false);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values[id] || null);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $bxRTa.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On call :
   *  - set open state to its contrary
   */ const toggleOpen = ()=>{
        setOpen(!open);
    };
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with choice value
   *  - call parent's handleSelect method
   *  - call toggleOpen method
   * @param choice : Choice
   */ const handleChange = (choice)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setChosen(choice);
            (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, choice);
            toggleOpen();
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-text-size-auto rf-text-formInputTextDefault",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                onClick: toggleOpen,
                className: `rf-w-full rf-flex rf-flex-row rf-justify-between rf-items-center rf-p-4 rf-border-2 rf-rounded ${open ? 'rf-border-formInputRadioCheckboxCheckedBorder' : 'rf-border-formInputRadioCheckboxUncheckedBorder'} rf-bg-formInputRadioCheckboxUncheckedBackground`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-truncate",
                        children: chosen?.title || placeholder || translation.inputs.choose
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-h-2",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1NaGJ.default), {
                            className: "rf-h-full"
                        })
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $fl9nK.jsx)("ul", {
                className: "rf-mt-1 rf-max-h-48 rf-pl-0 rf-w-full rf-rounded rf-border-2 rf-border-formInputRadioCheckboxUncheckedBorder rf-bg-formInputRadioCheckboxUncheckedBackground rf-overflow-y-scroll rf-scrollbar-thin",
                style: {
                    listStyle: 'none'
                },
                children: display.map((choice, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("li", {
                        onClick: ()=>handleChange(choice),
                        className: "rf-px-4 rf-py-2 hover:rf-text-formInputRadioCheckboxCheckedItem hover:rf-bg-formInputRadioCheckboxCheckedBackground",
                        children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $6acb6a669ff438f0$export$2e2bcd8739ae039 = $6acb6a669ff438f0$var$Select;



var $drUL7 = parcelRequire("drUL7");
class $6fd633cb7bc51693$export$3d2f970ec3b98a50 extends $drUL7.ChoiceSetInput {
    static{
        this.JsonTypeName = 'ChoiceSetClass';
    }
    getJsonTypeName() {
        return $6fd633cb7bc51693$export$3d2f970ec3b98a50.JsonTypeName;
    }
    static{
        // Add custom preperties to schema
        this.splitProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'split', false);
    }
    static{
        this.displayAsButtonProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'asButtons', false);
    }
    // Split property accessors
    get split() {
        return !!this.getValue($6fd633cb7bc51693$export$3d2f970ec3b98a50.splitProperty);
    }
    set split(value) {
        if (this.split !== value) {
            this.setValue($6fd633cb7bc51693$export$3d2f970ec3b98a50.splitProperty, value);
            this.updateLayout();
        }
    }
    // AsButtons property accessors
    get asButtons() {
        return !!this.getValue($6fd633cb7bc51693$export$3d2f970ec3b98a50.displayAsButtonProperty);
    }
    set asButtons(value) {
        if (this.asButtons !== value) {
            this.setValue($6fd633cb7bc51693$export$3d2f970ec3b98a50.displayAsButtonProperty, value);
            this.updateLayout();
        }
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this.renderReact = ()=>{
            // Return empty fragment if no id provided
            if (!this.id) return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
            // Check if we use checkboxes, radio buttons or select input
            let inputType = 'select';
            if (this.asButtons) inputType = this.isMultiSelect ? 'checkboxbuttons' : 'radiobuttons';
            else if (!this.isCompact) inputType = this.isMultiSelect ? 'checkbox' : 'radio';
            switch(inputType){
                case 'select':
                    break;
                case 'checkbox':
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b9c2f2df8863a08d$export$2e2bcd8739ae039), {
                        id: this.id,
                        choices: this.choices,
                        split: this.split
                    });
                case 'radio':
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $139d6d494ef941ff$export$2e2bcd8739ae039), {
                        id: this.id,
                        choices: this.choices,
                        split: this.split
                    });
                case 'checkboxbuttons':
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $945b84087e337d98$export$2e2bcd8739ae039), {
                        id: this.id,
                        choices: this.choices
                    });
                case 'radiobuttons':
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ee499ba1a4538846$export$2e2bcd8739ae039), {
                        id: this.id,
                        choices: this.choices
                    });
            }
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6acb6a669ff438f0$export$2e2bcd8739ae039), {
                id: this.id,
                choices: this.choices,
                placeholder: this.placeholder
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($6fd633cb7bc51693$export$3d2f970ec3b98a50.splitProperty)
], $6fd633cb7bc51693$export$3d2f970ec3b98a50.prototype, "split", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($6fd633cb7bc51693$export$3d2f970ec3b98a50.displayAsButtonProperty)
], $6fd633cb7bc51693$export$3d2f970ec3b98a50.prototype, "asButtons", null);




var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");



var $2rYkD = parcelRequire("2rYkD");
/**
 * Default data if not given in props :
 *  - defaultEmoji = default displayed object
 */ const $1e42b81147f2f33c$var$defaultEmoji = "\uD83D\uDFCA";
// emoji examples ['🟊', '♠', '✺', 'Ϙ', '◎', '₱', '😔', '😐', '😀']
const $1e42b81147f2f33c$var$Likert = ({ id: id, ratingMin: ratingMin, ratingMax: ratingMax, emojis: emojis, strokeColor: strokeColor })=>{
    const themeColors = (0, $7fe23951c4219024$export$2e2bcd8739ae039)();
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [data, setData] = (0, $bxRTa.useState)([]);
    const [rating, setRating] = (0, $bxRTa.useState)(values[id] || ratingMin || 0);
    const [hover, setHover] = (0, $bxRTa.useState)(0);
    const hoverColor = strokeColor || themeColors.formInput.likert.hover;
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On component mount :
   *  - create array of Dataset to be mapped for display
   *  - set stroke color if given in props
   */ (0, $bxRTa.useEffect)(()=>{
        const min = ratingMin || 0;
        const range = min <= 0 ? Math.abs(min) + ratingMax + 1 : ratingMax;
        let dataArray = [];
        // If there are as many emojis as values, let's use them all
        if (emojis.length === range) for(let i = 0; i < range; i++)dataArray = [
            ...dataArray,
            {
                emoji: emojis[i],
                value: min + i
            }
        ];
        else for(let i = 0; i < range; i++)dataArray = [
            ...dataArray,
            {
                emoji: emojis[0] || $1e42b81147f2f33c$var$defaultEmoji,
                value: min + i
            }
        ];
        setData(dataArray);
    }, []);
    /**
   * On element click :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call parent function from props with the value retrieved
   *  - set rating
   */ const handleClick = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, value);
            setRating(value);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-my-4 rf-flex rf-flex-row rf-flex-nowrap rf-justify-center rf-items-center rf-title-large-size-auto",
        children: data.map((tuple, index)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-px-1 rf-likert-custom",
                style: {
                    color: tuple.value <= (hover || rating) ? hoverColor : themeColors.formInput.likert.default
                },
                onClick: ()=>handleClick(tuple.value),
                onMouseEnter: ()=>setHover(tuple.value),
                onMouseLeave: ()=>setHover(rating),
                children: tuple.emoji
            }, index);
        })
    });
};
var $1e42b81147f2f33c$export$2e2bcd8739ae039 = $1e42b81147f2f33c$var$Likert;



var $drUL7 = parcelRequire("drUL7");
class $38ef32f553c0c76d$export$527d02f4ea70b77 extends $drUL7.Input {
    static{
        this.JsonTypeName = 'Retorik.Likert';
    }
    getJsonTypeName() {
        return $38ef32f553c0c76d$export$527d02f4ea70b77.JsonTypeName;
    }
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    static{
        this.ratingMinProperty = new $drUL7.NumProperty($drUL7.Versions.v1_0, 'ratingMin', 1);
    }
    static{
        this.ratingMaxProperty = new $drUL7.NumProperty($drUL7.Versions.v1_0, 'ratingMax', 5);
    }
    static{
        this.emojisProperty = new $drUL7.StringArrayProperty($drUL7.Versions.v1_0, 'emojis', []);
    }
    static{
        this.strokeColorProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'strokeColor', true);
    }
    // ratingMin property accessors
    get ratingMin() {
        return this.getValue($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMinProperty) || '';
    }
    set ratingMin(val) {
        if (this.ratingMin !== val) this.setValue($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMinProperty, val);
    }
    // ratingMax property accessors
    get ratingMax() {
        return this.getValue($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMaxProperty) || '';
    }
    set ratingMax(val) {
        if (this.ratingMax !== val) this.setValue($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMaxProperty, val);
    }
    // emojis property accessors
    get emojis() {
        return this.getValue($38ef32f553c0c76d$export$527d02f4ea70b77.emojisProperty) || '';
    }
    set emojis(val) {
        if (this.emojis !== val) this.setValue($38ef32f553c0c76d$export$527d02f4ea70b77.emojisProperty, val);
    }
    // strokeColor property accessors
    get strokeColor() {
        return this.getValue($38ef32f553c0c76d$export$527d02f4ea70b77.strokeColorProperty) || '';
    }
    set strokeColor(val) {
        if (this.strokeColor !== val) this.setValue($38ef32f553c0c76d$export$527d02f4ea70b77.strokeColorProperty, val);
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this._value = this.ratingMin, this.renderReact = ()=>{
            return this.id ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1e42b81147f2f33c$export$2e2bcd8739ae039), {
                id: this.id,
                ratingMin: this.ratingMin,
                ratingMax: this.ratingMax,
                emojis: this.emojis,
                strokeColor: this.strokeColor
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMinProperty)
], $38ef32f553c0c76d$export$527d02f4ea70b77.prototype, "ratingMin", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMaxProperty)
], $38ef32f553c0c76d$export$527d02f4ea70b77.prototype, "ratingMax", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($38ef32f553c0c76d$export$527d02f4ea70b77.emojisProperty)
], $38ef32f553c0c76d$export$527d02f4ea70b77.prototype, "emojis", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($38ef32f553c0c76d$export$527d02f4ea70b77.strokeColorProperty)
], $38ef32f553c0c76d$export$527d02f4ea70b77.prototype, "strokeColor", null);




var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $drUL7 = parcelRequire("drUL7");


var $drUL7 = parcelRequire("drUL7");
class $39d8560fb4e8ec95$export$fce58f7f7dbd3025 extends $drUL7.SerializableObject {
    static{
        this.JsonTypeName = 'ChoiceWithUrl';
    }
    getJsonTypeName() {
        return $39d8560fb4e8ec95$export$fce58f7f7dbd3025.JsonTypeName;
    }
    getSchemaKey() {
        return $39d8560fb4e8ec95$export$fce58f7f7dbd3025.JsonTypeName;
    }
    static{
        this.titleProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'title', true);
    }
    static{
        this.valueProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'value', true);
    }
    static{
        // Add url property to schema
        this.urlProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'url', true);
    }
    get title() {
        return this.getValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.titleProperty) || '';
    }
    set title(val) {
        if (this.title !== val) this.setValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.titleProperty, val);
    }
    get value() {
        return this.getValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.valueProperty) || '';
    }
    set value(val) {
        if (this.value !== val) this.setValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.valueProperty, val);
    }
    get url() {
        return this.getValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.urlProperty) || '';
    }
    set url(val) {
        if (this.url !== val) this.setValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.urlProperty, val);
    }
    constructor(title, value, url){
        super();
        this.title = title || '';
        this.value = value || '';
        this.url = url || '';
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($39d8560fb4e8ec95$export$fce58f7f7dbd3025.titleProperty)
], $39d8560fb4e8ec95$export$fce58f7f7dbd3025.prototype, "title", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($39d8560fb4e8ec95$export$fce58f7f7dbd3025.valueProperty)
], $39d8560fb4e8ec95$export$fce58f7f7dbd3025.prototype, "value", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($39d8560fb4e8ec95$export$fce58f7f7dbd3025.urlProperty)
], $39d8560fb4e8ec95$export$fce58f7f7dbd3025.prototype, "url", null);



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");



var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $92da696b1705d533$var$MultiSelect = ({ id: id, choices: choices, smallImages: smallImages, showCaptions: showCaptions })=>{
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values[id] || []);
    const [overflow, setOverflow] = (0, $bxRTa.useState)(false);
    const [style, setStyle] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices props change :
   *  - fill display state with choices value
   *  - set overflow and style states depending on the smallImages boolean prop and the number of choices
   */ (0, $bxRTa.useEffect)(()=>{
        if (choices) {
            setDisplay(choices);
            if (smallImages) {
                if (choices.length > 6) {
                    setOverflow(true);
                    setStyle('rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4');
                } else {
                    setOverflow(false);
                    setStyle('rf-grid rf-grid-rows-2 rf-grid-cols-3');
                }
            } else if (choices.length > 2) {
                setOverflow(true);
                setStyle('rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4');
            } else {
                setOverflow(false);
                setStyle('rf-grid rf-grid-rows-1 rf-grid-cols-2');
            }
        }
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $bxRTa.useEffect)(()=>{
        (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, chosen);
    }, [
        chosen
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-full rf-gap-4 rf-text-size-auto rf-text-white ${style} rf-scrollbar-x-custom`,
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-h-fit rf-flex rf-flex-col rf-items-start ${overflow && 'rf-flex-[0_0_40%]'}`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                        className: `rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center rf-border-2 rf-rounded-lg ${chosen.includes(choice.value) ? 'rf-border-primary' : 'rf-border-formInputRadioCheckboxUncheckedBorder'} hover:rf-cursor-pointer rf-aspect-square rf-overflow-hidden`,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                                src: choice.url,
                                className: "rf-max-w-full rf-max-h-full"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                type: "checkbox",
                                value: choice.value,
                                checked: chosen.includes(choice.value),
                                className: "rf-input-hidden",
                                onChange: ()=>handleChange(choice.value)
                            })
                        ]
                    }),
                    showCaptions && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-mt-2 rf-w-full rf-line-clamp-2",
                        children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $92da696b1705d533$export$2e2bcd8739ae039 = $92da696b1705d533$var$MultiSelect;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");



var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $d7223387b45ac98b$var$MonoSelect = ({ id: id, choices: choices, smallImages: smallImages, showCaptions: showCaptions })=>{
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values[id] || '');
    const [overflow, setOverflow] = (0, $bxRTa.useState)(false);
    const [style, setStyle] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices props change :
   *  - fill display state with choices value
   *  - set overflow and style states depending on the smallImages boolean prop and the number of choices
   */ (0, $bxRTa.useEffect)(()=>{
        if (choices) {
            setDisplay(choices);
            if (smallImages) {
                if (choices.length > 6) {
                    setOverflow(true);
                    setStyle('rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4');
                } else {
                    setOverflow(false);
                    setStyle(`rf-grid ${choices.length > 3 && 'rf-grid-rows-2'} rf-grid-cols-3`);
                }
            } else if (choices.length > 2) {
                setOverflow(true);
                setStyle('rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4');
            } else {
                setOverflow(false);
                setStyle('rf-grid rf-grid-rows-1 rf-grid-cols-2');
            }
        }
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setChosen(value);
            (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, value);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-full rf-gap-4 rf-text-size-auto rf-text-white ${style} rf-scrollbar-x-custom`,
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-h-fit rf-flex rf-flex-col rf-items-start ${overflow && 'rf-flex-[0_0_40%]'}`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                        className: `rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center rf-border-2 rf-rounded-lg ${choice.value === chosen ? 'rf-border-primary' : 'rf-border-formInputRadioCheckboxUncheckedBorder'} hover:rf-cursor-pointer rf-aspect-square rf-overflow-hidden`,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                                src: choice.url,
                                className: "rf-max-w-full rf-max-h-full"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-input-hidden",
                                onChange: ()=>handleChange(choice.value)
                            })
                        ]
                    }),
                    showCaptions && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-pt-2 rf-w-full rf-line-clamp-2",
                        children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $d7223387b45ac98b$export$2e2bcd8739ae039 = $d7223387b45ac98b$var$MonoSelect;


class $4997b971855cf4c9$export$97d8aa00da3f172d extends $drUL7.Input {
    static{
        this.JsonTypeName = 'Retorik.ImageChoiceSet';
    }
    getJsonTypeName() {
        return $4997b971855cf4c9$export$97d8aa00da3f172d.JsonTypeName;
    }
    static{
        // Add custom preperties to schema
        this.isMultiSelectProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'isMultiSelect', false);
    }
    static{
        this.smallImagesProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'smallImages', false);
    }
    static{
        this.showCaptionsProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'showCaptions', false);
    }
    static{
        this.choicesWithUrlProperty = new $drUL7.SerializableObjectCollectionProperty($drUL7.Versions.v1_0, 'choicesWithUrl', (0, $39d8560fb4e8ec95$export$fce58f7f7dbd3025));
    }
    // multiSelect property accessors
    get isMultiSelect() {
        return !!this.getValue($4997b971855cf4c9$export$97d8aa00da3f172d.isMultiSelectProperty);
    }
    set isMultiSelect(value) {
        if (this.isMultiSelect !== value) {
            this.setValue($4997b971855cf4c9$export$97d8aa00da3f172d.isMultiSelectProperty, value);
            this.updateLayout();
        }
    }
    // smallImages property accessors
    get smallImages() {
        return !!this.getValue($4997b971855cf4c9$export$97d8aa00da3f172d.smallImagesProperty);
    }
    set smallImages(value) {
        if (this.smallImages !== value) {
            this.setValue($4997b971855cf4c9$export$97d8aa00da3f172d.smallImagesProperty, value);
            this.updateLayout();
        }
    }
    // showCaptions property accessors
    get showCaptions() {
        return !!this.getValue($4997b971855cf4c9$export$97d8aa00da3f172d.showCaptionsProperty);
    }
    set showCaptions(value) {
        if (this.smallImages !== value) {
            this.setValue($4997b971855cf4c9$export$97d8aa00da3f172d.showCaptionsProperty, value);
            this.updateLayout();
        }
    }
    // choicesWithUrl property accessors
    get choicesWithUrl() {
        return this.getValue($4997b971855cf4c9$export$97d8aa00da3f172d.choicesWithUrlProperty) || [];
    }
    set choicesWithUrl(value) {
        if (this.choicesWithUrl !== value) {
            this.setValue($4997b971855cf4c9$export$97d8aa00da3f172d.choicesWithUrlProperty, value);
            this.updateLayout();
        }
    }
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this.renderReact = ()=>{
            if (!this.id) return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
            if (this.isMultiSelect) return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $92da696b1705d533$export$2e2bcd8739ae039), {
                id: this.id,
                choices: this.choicesWithUrl,
                smallImages: this.smallImages,
                showCaptions: this.showCaptions
            });
            else return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d7223387b45ac98b$export$2e2bcd8739ae039), {
                id: this.id,
                choices: this.choicesWithUrl,
                smallImages: this.smallImages,
                showCaptions: this.showCaptions
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($4997b971855cf4c9$export$97d8aa00da3f172d.isMultiSelectProperty)
], $4997b971855cf4c9$export$97d8aa00da3f172d.prototype, "isMultiSelect", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($4997b971855cf4c9$export$97d8aa00da3f172d.smallImagesProperty)
], $4997b971855cf4c9$export$97d8aa00da3f172d.prototype, "smallImages", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($4997b971855cf4c9$export$97d8aa00da3f172d.showCaptionsProperty)
], $4997b971855cf4c9$export$97d8aa00da3f172d.prototype, "showCaptions", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($4997b971855cf4c9$export$97d8aa00da3f172d.choicesWithUrlProperty)
], $4997b971855cf4c9$export$97d8aa00da3f172d.prototype, "choicesWithUrl", null);




var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");



var $2rYkD = parcelRequire("2rYkD");
const $3f3e72b3ff6623ef$var$Slider = ({ id: id, minValue: minValue, maxValue: maxValue, minLabel: minLabel, maxLabel: maxLabel })=>{
    const themeColors = (0, $7fe23951c4219024$export$2e2bcd8739ae039)();
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const values = (0, $2799a46b4bf8d2a8$export$2e2bcd8739ae039)();
    const [sliderValue, setSliderValue] = (0, $bxRTa.useState)(values[id] || ((minValue || 0) + (maxValue || 100)) / 2);
    const [sliderStyle, setSliderStyle] = (0, $bxRTa.useState)(`linear-gradient(to right, ${themeColors.primary} ${(sliderValue - (minValue || 0)) / ((maxValue || 100) - (minValue || 0)) * 100}%, #7878805C ${(sliderValue - (minValue || 0)) / ((maxValue || 100) - (minValue || 0)) * 100}%)`);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $7b2cab4dfcfe505d$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On slider value change :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - set sliderValue state
   *  - call parent function with event value
   * @param e : changeEvent
   */ const handleChange = (e)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setSliderValue(e.target.value);
            (0, $7b2cab4dfcfe505d$export$80746c6bc6142fc8)(id, e.target.value);
        }
    };
    /**
   * On value input in slider :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - get value as percentage
   *  - set the slider color depending on the percentage obtained
   * @param e : inputEvent
   */ const handleOnInput = (e)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            // Value as percentage, we substract minValue up and down to get the right percentage if minValue !== 0
            const valPourcentage = (e.target.value - (minValue || 0)) / (e.target.max - (minValue || 0)) * 100;
            setSliderStyle(`linear-gradient(to right, ${themeColors.primary} ${valPourcentage}%, #7878805C ${valPourcentage}%)`);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        dir: "ltr" /* To maintain the correct sliding direction */ ,
        className: `rf-w-full rf-px-6 rf-pt-14 ${minLabel || maxLabel ? 'rf-pb-5' : 'rf-pb-14'} rf-rounded-lg rf-text-size-auto rf-text-white`,
        style: {
            background: 'rgba(0, 0, 0, 0.5)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                style: {
                    background: sliderStyle
                },
                onInput: handleOnInput,
                onChange: handleChange,
                value: sliderValue,
                type: "range",
                min: minValue || 0,
                max: maxValue || 100,
                className: "rf-slider-custom"
            }),
            (minLabel || maxLabel) && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-mt-5 rf-flex rf-flex-row rf-justify-between rf-items-center",
                children: [
                    minLabel && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        children: minLabel
                    }),
                    maxLabel && (minLabel ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        children: maxLabel
                    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: '\u2800'
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: maxLabel
                            })
                        ]
                    }))
                ]
            })
        ]
    });
};
var $3f3e72b3ff6623ef$export$2e2bcd8739ae039 = $3f3e72b3ff6623ef$var$Slider;



var $drUL7 = parcelRequire("drUL7");
class $e93900429d4fd801$export$7f21b8f94f2ce32b extends $drUL7.Input {
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    static{
        this.JsonTypeName = 'Retorik.Slider';
    }
    getJsonTypeName() {
        return $e93900429d4fd801$export$7f21b8f94f2ce32b.JsonTypeName;
    }
    static{
        // Add custom properties to schema
        this.minValueProperty = new $drUL7.NumProperty($drUL7.Versions.v1_0, 'minValue');
    }
    static{
        this.maxValueProperty = new $drUL7.NumProperty($drUL7.Versions.v1_0, 'maxValue');
    }
    static{
        this.minLabelProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'minLabel', true);
    }
    static{
        this.maxLabelProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'maxLabel', true);
    }
    // minValue property accessors
    get minValue() {
        return this.getValue($e93900429d4fd801$export$7f21b8f94f2ce32b.minValueProperty);
    }
    set minValue(value) {
        if (this.minValue !== value) {
            this.setValue($e93900429d4fd801$export$7f21b8f94f2ce32b.minValueProperty, value);
            this.updateLayout();
        }
    }
    // maxValue property accessors
    get maxValue() {
        return this.getValue($e93900429d4fd801$export$7f21b8f94f2ce32b.maxValueProperty);
    }
    set maxValue(value) {
        if (this.maxValue !== value) {
            this.setValue($e93900429d4fd801$export$7f21b8f94f2ce32b.maxValueProperty, value);
            this.updateLayout();
        }
    }
    // minLabel property accessors
    get minLabel() {
        return this.getValue($e93900429d4fd801$export$7f21b8f94f2ce32b.minLabelProperty);
    }
    set minLabel(value) {
        if (this.minLabel !== value) {
            this.setValue($e93900429d4fd801$export$7f21b8f94f2ce32b.minLabelProperty, value);
            this.updateLayout();
        }
    }
    // maxLabel property accessors
    get maxLabel() {
        return this.getValue($e93900429d4fd801$export$7f21b8f94f2ce32b.maxLabelProperty);
    }
    set maxLabel(value) {
        if (this.maxLabel !== value) {
            this.setValue($e93900429d4fd801$export$7f21b8f94f2ce32b.maxLabelProperty, value);
            this.updateLayout();
        }
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this._value = this.minValue && this.maxValue ? Math.floor((this.minValue + this.maxValue) / 2) : 50, this.renderReact = ()=>{
            return this.id ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3f3e72b3ff6623ef$export$2e2bcd8739ae039), {
                id: this.id,
                minValue: this.minValue,
                maxValue: this.maxValue,
                minLabel: this.minLabel,
                maxLabel: this.maxLabel
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($e93900429d4fd801$export$7f21b8f94f2ce32b.minValueProperty)
], $e93900429d4fd801$export$7f21b8f94f2ce32b.prototype, "minValue", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($e93900429d4fd801$export$7f21b8f94f2ce32b.maxValueProperty)
], $e93900429d4fd801$export$7f21b8f94f2ce32b.prototype, "maxValue", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($e93900429d4fd801$export$7f21b8f94f2ce32b.minLabelProperty)
], $e93900429d4fd801$export$7f21b8f94f2ce32b.prototype, "minLabel", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($e93900429d4fd801$export$7f21b8f94f2ce32b.maxLabelProperty)
], $e93900429d4fd801$export$7f21b8f94f2ce32b.prototype, "maxLabel", null);



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $6XfIC = parcelRequire("6XfIC");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $cd7931881ca77004$var$FactSet = ({ facts: facts })=>{
    return facts?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-text-cardFrameText rf-text-size-auto",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("table", {
            className: "rf-border-0 rf-border-none rf-border-collapse rf-overflow-hidden rf-box-border",
            children: facts.map((fact, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("td", {
                            className: "rf-font-bold",
                            children: fact.name
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("td", {
                            className: "rf-px-2",
                            children: fact.value
                        })
                    ]
                }, key);
            })
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $cd7931881ca77004$export$2e2bcd8739ae039 = $cd7931881ca77004$var$FactSet;


class $0629d53df50be9f5$export$18920f1d621863a4 extends (0, $6XfIC.FactSet) {
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this.renderReact = ()=>{
            const props = {
                facts: this.facts
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cd7931881ca77004$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}




var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $drUL7 = parcelRequire("drUL7");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7QU6k = parcelRequire("7QU6k");

var $drUL7 = parcelRequire("drUL7");



var $2rYkD = parcelRequire("2rYkD");

var $clTWB = parcelRequire("clTWB");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
var $dH58k = parcelRequire("dH58k");
parcelRequire("kMAJU");
var $d5ZYc = parcelRequire("d5ZYc");

var $iEJNQ = parcelRequire("iEJNQ");

var $85RVQ = parcelRequire("85RVQ");

var $8e5cw = parcelRequire("8e5cw");

const $b79efe63fcf3e678$var$PrintingPreview = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("hiuUm")));
const $b79efe63fcf3e678$var$ActionButton = ({ text: text, fullWidth: fullWidth, position: position, display: display, adaptiveStyle: adaptiveStyle, urlToOpen: urlToOpen, data: data })=>{
    const locale = (0, $65aba44f1f006b87$export$2e2bcd8739ae039)();
    const isRTL = (0, $25dce51cfe3b7644$export$2e2bcd8739ae039)();
    const translation = (0, $76f6e43a91b8b1d0$export$2e2bcd8739ae039)();
    const currentSubView = (0, $eccbad72ba0d7637$export$2e2bcd8739ae039)();
    const unlockClickedButton = (0, $4a109e2b0f2a399a$export$2e2bcd8739ae039)();
    const isUsedOnBorne = (0, $77444f6cb9655f3f$export$2e2bcd8739ae039)();
    const enableDocumentPrinting = (0, $5fd246c35edfbfe1$export$2e2bcd8739ae039)();
    const isMobile = (0, $557bc5ab6089f8fa$export$2e2bcd8739ae039)();
    const themeColors = (0, $7fe23951c4219024$export$2e2bcd8739ae039)();
    const currentValue = (0, $0fc42339098f4095$export$2e2bcd8739ae039)();
    const [style, setStyle] = (0, $bxRTa.useState)();
    const [clicked, setClicked] = (0, $bxRTa.useState)(false);
    const [hover, setHover] = (0, $bxRTa.useState)(false);
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)();
    const [textToDisplay, setTextToDisplay] = (0, $bxRTa.useState)();
    const [triedToValidateWithoutValue, setTriedToValidateWithoutValue] = (0, $bxRTa.useState)(false);
    const animationColor = {
        '--rf-color-loader-animation': themeColors.card.button.text.default
    };
    const defaultText = (0, $bxRTa.useMemo)(()=>{
        return text || (urlToOpen ? translation.link.goto : translation.common.submit);
    }, [
        text,
        locale
    ]);
    const setQrCodeDataAsync = async ()=>{
        if (urlToOpen) {
            const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(encodeURI(urlToOpen));
            setQrCodeData(qrCodeString);
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        setTextToDisplay((0, $eO5xw.capitalizeFirstLetter)(defaultText, locale));
    }, [
        defaultText,
        translation,
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (triedToValidateWithoutValue && currentValue) {
            const values = Object.values(currentValue);
            if (!values.find((value)=>Array.isArray(value) && !value.length)) setTextToDisplay((0, $eO5xw.capitalizeFirstLetter)(defaultText, locale));
        }
    }, [
        triedToValidateWithoutValue,
        currentValue
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (urlToOpen && isUsedOnBorne) setQrCodeDataAsync();
    }, [
        urlToOpen,
        isUsedOnBorne
    ]);
    (0, $bxRTa.useEffect)(()=>{
        unlockClickedButton && setClicked(false);
    }, [
        unlockClickedButton
    ]);
    (0, $bxRTa.useEffect)(()=>{
        // Set width : full or fit
        let temp = fullWidth ? 'rf-w-full' : 'rf-w-fit';
        // Set position if not in full width
        if (!fullWidth && position) switch(position){
            case 'right':
                temp += ' rf-float-right';
                break;
            case 'center':
                temp += ' rf-mx-auto';
                break;
            case 'left':
            default:
                break;
        }
        setStyle(temp);
    }, []);
    const handleOpenPreview = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) urlToOpen && (0, $7b2cab4dfcfe505d$export$4317154639841e84)(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $bxRTa.Suspense), {
            children: /*#__PURE__*/ (0, $fl9nK.jsx)($b79efe63fcf3e678$var$PrintingPreview, {
                url: urlToOpen,
                printingAllowed: !!enableDocumentPrinting
            })
        }));
    };
    const handleClick = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history && !clicked) {
            if (urlToOpen) window.open(urlToOpen, '_blank', 'noopener noreferrer');
            else {
                if (data) {
                    if (data.type) {
                        if (data.type.toLowerCase() === 'message') data.text && (0, $7b2cab4dfcfe505d$export$465cb47180de50f0)(data.text);
                        else if (data.type.toLowerCase() === 'event') (0, $7b2cab4dfcfe505d$export$7329bcdc3edcd90e)(data.name, data.value);
                    } else {
                        if (typeof data === 'string') (0, $7b2cab4dfcfe505d$export$465cb47180de50f0)(data);
                        else if (typeof data === 'object') (0, $7b2cab4dfcfe505d$export$465cb47180de50f0)(undefined, data);
                    }
                } else if (currentValue) {
                    const values = Object.values(currentValue);
                    // Check if a value is an empty array. If so, break the process
                    if (values.find((value)=>Array.isArray(value) && !value.length)) {
                        setTriedToValidateWithoutValue(true);
                        setTextToDisplay((0, $eO5xw.capitalizeFirstLetter)(translation.inputs.noaction, locale));
                        return;
                    } else (0, $7b2cab4dfcfe505d$export$465cb47180de50f0)(undefined, currentValue);
                } else {
                    setTriedToValidateWithoutValue(true);
                    setTextToDisplay((0, $eO5xw.capitalizeFirstLetter)(translation.inputs.noaction, locale));
                    return;
                }
                setClicked(true);
                setHover(false);
                (0, $7b2cab4dfcfe505d$export$5d55805fc8a86c05)();
            }
        }
    };
    const handleEnter = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history && !clicked) setHover(true);
    };
    const handleLeave = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history && !clicked) setHover(false);
    };
    return urlToOpen && isUsedOnBorne ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-flex rf-flex-col rf-justify-center rf-items-center rf-text-cardButtonTextDefault",
        children: [
            urlToOpen.length > 4 && urlToOpen.substring(urlToOpen.length - 4) === '.pdf' && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-pb-6 rf-flex rf-justify-start rf-text-primary rf-underline rf-italic rf-text-sm",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                    className: "rf-cursor-pointer",
                    onClick: handleOpenPreview,
                    children: translation.link.buttontext
                })
            }),
            qrCodeData ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                        src: qrCodeData
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-relative rf-text-center rf-mx-8 rf-mt-2 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d5ZYc.default), {
                                className: `rf-absolute rf-top-[0.125rem] ${isRTL ? 'rf-right-6' : '-rf-left-6'} rf-h-4`
                            }),
                            (0, $clTWB.getTextToDisplayOnLink)({
                                translation: translation,
                                isUsedOnBorne: isUsedOnBorne,
                                data: {
                                    url: urlToOpen,
                                    download: true
                                }
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-6 rf-h-6",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $85RVQ.default), {
                    color: "gray",
                    loaderColor: themeColors.primary,
                    backgroundColor: "transparent"
                })
            })
        ]
    }) : text && display.toLowerCase() === 'link' ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-mt-2 rf-flex rf-justify-start rf-items-center rf-text-cardButtonTextDefault ${currentSubView !== (0, $2rYkD.CurrentSubView).history && 'rf-cursor-pointer'}`,
        onPointerEnter: handleEnter,
        onPointerLeave: handleLeave,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-h-6 rf-w-6 rf-rounded ${hover ? 'rf-bg-cardButtonBackgroundHover' : 'rf-bg-cardButtonBackgroundDefault'}`,
                children: clicked && !urlToOpen ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-h-6 rf-w-6 rf-flex rf-justify-center rf-items-center",
                    style: {
                        ...animationColor
                    },
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-2 rf-h-2",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                            size: (0, $2rYkD.AnimationSize).small
                        })
                    })
                }) : isRTL ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                    className: `rf-h-6 rf-p-1 rf-border rf-rounded ${hover ? 'rf-border-cardButtonBorderHover' : 'rf-border-cardButtonBorderDefault'}`,
                    color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dH58k.default), {
                    className: `rf-h-6 rf-p-1 rf-border rf-rounded ${hover ? 'rf-border-cardButtonBorderHover' : 'rf-border-cardButtonBorderDefault'}`,
                    color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `${isRTL ? 'rf-mr-4' : 'rf-ml-4'}`,
                children: (0, $eO5xw.capitalizeFirstLetter)(text, locale)
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-relative ${currentSubView !== (0, $2rYkD.CurrentSubView).history ? clicked ? 'rf-card-button-clicked' : adaptiveStyle === (0, $drUL7.ActionStyle).Positive ? 'rf-card-button-positive' : adaptiveStyle === (0, $drUL7.ActionStyle).Destructive ? 'rf-card-button-destructive' : 'rf-card-button' : 'rf-card-button-history'} rf-mt-2 ${fullWidth ? 'rf-text-center' : 'rf-text-left'} ${style}`,
        onClick: handleClick,
        children: clicked && !urlToOpen ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: `rf-w-full rf-h-[1.25rem] large:rf-h-[1.3rem] rf-flex rf-justify-center rf-items-center ${fullWidth ? '' : isRTL ? 'rf-pr-6 large:rf-pr-12' : 'rf-pl-6 large:rf-pl-12'}`,
            style: {
                ...animationColor
            },
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                    size: isMobile ? (0, $2rYkD.AnimationSize).medium : (0, $2rYkD.AnimationSize).large
                })
            })
        }) : textToDisplay
    });
};
var $b79efe63fcf3e678$export$2e2bcd8739ae039 = $b79efe63fcf3e678$var$ActionButton;


class $743025c3e54add91$export$ea4365d42c3e8532 extends $drUL7.SubmitAction {
    static{
        this.fullWidthProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'fullWidth', false);
    }
    static{
        this.positionProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'position', true, undefined, 'left');
    }
    static{
        this.displayProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'display', true, undefined, 'button');
    }
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($743025c3e54add91$export$ea4365d42c3e8532.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($743025c3e54add91$export$ea4365d42c3e8532.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($743025c3e54add91$export$ea4365d42c3e8532.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($743025c3e54add91$export$ea4365d42c3e8532.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($743025c3e54add91$export$ea4365d42c3e8532.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($743025c3e54add91$export$ea4365d42c3e8532.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
    }
    constructor(...args){
        super(...args), this.internalRenderedElement = document.createElement('div'), this.renderReact = ()=>{
            const props = {
                text: this.title,
                adaptiveStyle: this.style,
                fullWidth: this.fullWidth,
                position: this.position,
                display: this.display,
                data: this.data
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b79efe63fcf3e678$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($743025c3e54add91$export$ea4365d42c3e8532.fullWidthProperty)
], $743025c3e54add91$export$ea4365d42c3e8532.prototype, "fullWidth", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($743025c3e54add91$export$ea4365d42c3e8532.positionProperty)
], $743025c3e54add91$export$ea4365d42c3e8532.prototype, "position", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($743025c3e54add91$export$ea4365d42c3e8532.displayProperty)
], $743025c3e54add91$export$ea4365d42c3e8532.prototype, "display", null);




var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $drUL7 = parcelRequire("drUL7");

class $cd782299940c1973$export$3226295bbd9dad06 extends $drUL7.OpenUrlAction {
    static{
        this.fullWidthProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'fullWidth', false);
    }
    static{
        this.positionProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'position', true, undefined, 'left');
    }
    static{
        this.displayProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'display', true, undefined, 'button');
    }
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($cd782299940c1973$export$3226295bbd9dad06.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($cd782299940c1973$export$3226295bbd9dad06.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($cd782299940c1973$export$3226295bbd9dad06.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($cd782299940c1973$export$3226295bbd9dad06.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($cd782299940c1973$export$3226295bbd9dad06.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($cd782299940c1973$export$3226295bbd9dad06.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
    }
    constructor(...args){
        super(...args), this.internalRenderedElement = document.createElement('div'), this.renderReact = ()=>{
            const props = {
                text: this.title,
                adaptiveStyle: this.style,
                fullWidth: this.fullWidth,
                position: this.position,
                display: this.display,
                urlToOpen: this.url
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b79efe63fcf3e678$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($cd782299940c1973$export$3226295bbd9dad06.fullWidthProperty)
], $cd782299940c1973$export$3226295bbd9dad06.prototype, "fullWidth", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($cd782299940c1973$export$3226295bbd9dad06.positionProperty)
], $cd782299940c1973$export$3226295bbd9dad06.prototype, "position", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($cd782299940c1973$export$3226295bbd9dad06.displayProperty)
], $cd782299940c1973$export$3226295bbd9dad06.prototype, "display", null);




var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $drUL7 = parcelRequire("drUL7");

class $55672a0bfe73e837$export$17915a7271c45b27 extends $drUL7.ShowCardAction {
    static{
        this.fullWidthProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'fullWidth', false);
    }
    static{
        this.positionProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'position', true, undefined, 'left');
    }
    static{
        this.displayProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'display', true, undefined, 'button');
    }
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($55672a0bfe73e837$export$17915a7271c45b27.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($55672a0bfe73e837$export$17915a7271c45b27.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($55672a0bfe73e837$export$17915a7271c45b27.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($55672a0bfe73e837$export$17915a7271c45b27.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($55672a0bfe73e837$export$17915a7271c45b27.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($55672a0bfe73e837$export$17915a7271c45b27.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
    }
    constructor(...args){
        super(...args), this.internalRenderedElement = document.createElement('div'), this.renderReact = ()=>{
            const props = {
                text: this.title,
                adaptiveStyle: this.style,
                fullWidth: this.fullWidth,
                position: this.position,
                display: this.display
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b79efe63fcf3e678$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($55672a0bfe73e837$export$17915a7271c45b27.fullWidthProperty)
], $55672a0bfe73e837$export$17915a7271c45b27.prototype, "fullWidth", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($55672a0bfe73e837$export$17915a7271c45b27.positionProperty)
], $55672a0bfe73e837$export$17915a7271c45b27.prototype, "position", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($55672a0bfe73e837$export$17915a7271c45b27.displayProperty)
], $55672a0bfe73e837$export$17915a7271c45b27.prototype, "display", null);




var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $drUL7 = parcelRequire("drUL7");

class $ff9197427901ee79$export$e4bbccd75e2f23fc extends $drUL7.ToggleVisibilityAction {
    static{
        this.fullWidthProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'fullWidth', false);
    }
    static{
        this.positionProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'position', true, undefined, 'left');
    }
    static{
        this.displayProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'display', true, undefined, 'button');
    }
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($ff9197427901ee79$export$e4bbccd75e2f23fc.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($ff9197427901ee79$export$e4bbccd75e2f23fc.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($ff9197427901ee79$export$e4bbccd75e2f23fc.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($ff9197427901ee79$export$e4bbccd75e2f23fc.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($ff9197427901ee79$export$e4bbccd75e2f23fc.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($ff9197427901ee79$export$e4bbccd75e2f23fc.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
    }
    constructor(...args){
        super(...args), this.internalRenderedElement = document.createElement('div'), this.renderReact = ()=>{
            const props = {
                text: this.title,
                adaptiveStyle: this.style,
                fullWidth: this.fullWidth,
                position: this.position,
                display: this.display
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b79efe63fcf3e678$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($ff9197427901ee79$export$e4bbccd75e2f23fc.fullWidthProperty)
], $ff9197427901ee79$export$e4bbccd75e2f23fc.prototype, "fullWidth", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($ff9197427901ee79$export$e4bbccd75e2f23fc.positionProperty)
], $ff9197427901ee79$export$e4bbccd75e2f23fc.prototype, "position", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($ff9197427901ee79$export$e4bbccd75e2f23fc.displayProperty)
], $ff9197427901ee79$export$e4bbccd75e2f23fc.prototype, "display", null);


const $9ef4e35797212449$export$6108075486421829 = ()=>{
    // Override existing elements
    $drUL7.GlobalRegistry.elements.register('TextBlock', (0, $1737244c1bf4b35d$export$92739f4310a31a0d));
    $drUL7.GlobalRegistry.elements.register('Input.Toggle', (0, $081e22222a7bb1e5$export$c99bfd6b0ed44fbd));
    $drUL7.GlobalRegistry.elements.register('Input.Date', (0, $8c9a3349b8312469$export$a9633577dcb92569));
    $drUL7.GlobalRegistry.elements.register('Input.Time', (0, $7186f765e3370ce8$export$27dc9c3aadf0815c));
    $drUL7.GlobalRegistry.elements.register('Input.ChoiceSet', (0, $6fd633cb7bc51693$export$3d2f970ec3b98a50));
    $drUL7.GlobalRegistry.elements.register('FactSet', (0, $0629d53df50be9f5$export$18920f1d621863a4));
    // Register new elements
    $drUL7.GlobalRegistry.elements.register('Retorik.ImageChoiceSet', (0, $4997b971855cf4c9$export$97d8aa00da3f172d));
    $drUL7.GlobalRegistry.elements.register('Retorik.Likert', (0, $38ef32f553c0c76d$export$527d02f4ea70b77));
    $drUL7.GlobalRegistry.elements.register('Retorik.Slider', (0, $e93900429d4fd801$export$7f21b8f94f2ce32b));
    // Override existing actions
    $drUL7.GlobalRegistry.actions.register('Action.Submit', (0, $743025c3e54add91$export$ea4365d42c3e8532));
    $drUL7.GlobalRegistry.actions.register('Action.OpenUrl', (0, $cd782299940c1973$export$3226295bbd9dad06));
    $drUL7.GlobalRegistry.actions.register('Action.ShowCard', (0, $55672a0bfe73e837$export$17915a7271c45b27));
    $drUL7.GlobalRegistry.actions.register('Action.ToggleVisibility', (0, $ff9197427901ee79$export$e4bbccd75e2f23fc));
};



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $fzVhJ = parcelRequire("fzVhJ");
const $b4e3e24c87e40d50$var$ContextProvider = ({ skipLoader: skipLoader, mode: mode, viewsConfiguration: viewsConfiguration, veilleConfiguration: veilleConfiguration, mapConfiguration: mapConfiguration, configuration: configuration, customVoice: customVoice, addressData: addressData, agentSource: agentSource, ponyfillFactoryCredentials: ponyfillFactoryCredentials, children: children })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const supported = (0, $5FZWK.useSelector)((state)=>state.localeReducer.supported);
    const defaultLocale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.defaultLocale);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const setLocation = async (data)=>{
        const position = {
            searchForLocation: true,
            latitude: data.coords.latitude,
            longitude: data.coords.longitude
        };
        dispatch((0, $cto9a.storeActions).directline.setPositionToSend({
            latitude: position.latitude,
            longitude: position.longitude
        }));
        dispatch((0, $cto9a.storeActions).retorik.setConfiguration({
            ...configuration,
            position: position
        }));
    };
    (0, $bxRTa.useEffect)(()=>{
        // Set continous recognition state
        dispatch((0, $cto9a.storeActions).speech.setUseContinuousRecognition({
            deviceType: currentDeviceType,
            options: configuration?.speechRecognitionOptions
        }));
    }, [
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).speech.setMode(mode));
    }, [
        mode
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).retorik.setSkipLoader(!!skipLoader));
    }, [
        skipLoader
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).view.setViewsConfiguration(viewsConfiguration));
    }, [
        viewsConfiguration,
        ...Object.values(viewsConfiguration)
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).view.setVeilleConfiguration(veilleConfiguration));
    }, [
        veilleConfiguration,
        ...Object.values(veilleConfiguration)
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).view.setMapConfiguration(mapConfiguration));
    }, [
        mapConfiguration,
        ...Object.values(mapConfiguration)
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).view.setVeilleConfiguration(veilleConfiguration));
    }, [
        veilleConfiguration,
        ...Object.values(veilleConfiguration)
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).retorik.setConfiguration(configuration));
    }, [
        configuration,
        ...Object.values(configuration)
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (configuration.position?.searchForLocation) // Position enabled
        {
            if (configuration.position.latitude === undefined && configuration.position.longitude === undefined) // Try to get the position of the device if no one has been given in the configuration
            navigator.geolocation?.getCurrentPosition(setLocation, (error)=>{
                switch(error.code){
                    case error.PERMISSION_DENIED:
                        console.warn('Geolocation : User denied the request for Geolocation.');
                        break;
                    case error.POSITION_UNAVAILABLE:
                        console.warn('Geolocation : Location information is unavailable.');
                        break;
                    case error.TIMEOUT:
                        console.warn('Geolocation : The request to get user location timed out.');
                        break;
                    default:
                        console.warn('Geolocation : An unknown error occurred.');
                        break;
                }
            }, {
                timeout: 3000
            });
        }
    }, [
        configuration.position
    ]);
    (0, $bxRTa.useEffect)(()=>{
        configuration.position?.latitude && configuration.position.longitude && dispatch((0, $cto9a.storeActions).directline.setPositionToSend({
            latitude: configuration.position.latitude,
            longitude: configuration.position.longitude
        }));
    }, [
        configuration.position?.latitude,
        configuration.position?.longitude
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (configuration.disableSound === true) {
            dispatch((0, $cto9a.storeActions).speech.setMuted(true));
            dispatch((0, $cto9a.storeActions).speech.setDisableSound(true));
        }
        if (configuration.disableSound === false) dispatch((0, $cto9a.storeActions).speech.setDisableSound(false));
    }, [
        configuration.disableSound
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).retorik.setSubtitlesInConfiguration(!!configuration.subtitles));
    }, [
        configuration.subtitles
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).speech.setCustomVoice(customVoice));
    }, [
        customVoice
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).retorik.setAddressData(addressData));
    }, [
        addressData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).retorik.setAgentData(agentSource));
    }, [
        agentSource
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).speech.setPonyfillFactoryCredentials(ponyfillFactoryCredentials));
    }, [
        ponyfillFactoryCredentials
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (supported.length) dispatch((0, $cto9a.storeActions).locale.setLocale((0, $fzVhJ.checkLocale)({
            all: supported,
            default: defaultLocale
        }, configuration.locales)));
    }, [
        supported,
        configuration
    ]);
    return locale && supported ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: children
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $b4e3e24c87e40d50$export$2e2bcd8739ae039 = $b4e3e24c87e40d50$var$ContextProvider;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");
async function $5feda0058508ab46$export$97c24bbbbbd7be8a(address) {
    const token = await fetch(address).then((res)=>{
        return res.json();
    }).catch((error)=>console.warn(`Retorik Framework > error fetching directline token : ${error}`));
    return token;
}



var $7c6BL = parcelRequire("7c6BL");
const $6a60c4ac572a9b7a$var$defaultUser = {
    name: 'default',
    id: `defaultId_${Date.now()}`,
    username: 'default',
    nom: 'defaultName',
    prenom: "\xe0 vous",
    email: '',
    token: '',
    referrer: '',
    ipaddress: ''
};
const $6a60c4ac572a9b7a$var$RetorikComposer = ({ addressData: addressData, userData: userData, externalEventHandler: externalEventHandler, children: children, isRetorikNews: isRetorikNews })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const connectionStatus = (0, $5FZWK.useSelector)((state)=>state.directlineReducer.directLineStatus);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const loaderClosed = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.loaderClosed);
    const agentData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.agentData);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const supported = (0, $5FZWK.useSelector)((state)=>state.localeReducer.supported);
    const calibrationCompleted = (0, $5FZWK.useSelector)((state)=>state.viewReducer.calibrationCompleted);
    const [directLineCreationData, setDirectLineCreationData] = (0, $bxRTa.useState)();
    const [hasConversationCookie, setHasConversationCookie] = (0, $bxRTa.useState)(false);
    const processedUserData = (0, $bxRTa.useMemo)(()=>{
        if (userData) return userData;
        else {
            const userIdFromCookie = document.cookie.split('; ').find((row)=>row.startsWith('retorikUserIdCookie='))?.split('=')[1];
            if (userIdFromCookie) return {
                ...$6a60c4ac572a9b7a$var$defaultUser,
                username: userIdFromCookie,
                id: userIdFromCookie
            };
            else {
                const id = `defaultId_${Date.now()}`;
                dispatch((0, $cto9a.storeActions).activity.addCookie(`retorikUserIdCookie=${id}`));
                return {
                    ...$6a60c4ac572a9b7a$var$defaultUser,
                    username: id,
                    id: id
                };
            }
        }
    }, [
        userData
    ]);
    const processDirectLine = async (directLineData)=>{
        (0, $5feda0058508ab46$export$97c24bbbbbd7be8a)(directLineData.tokenEndpoint).then((token)=>{
            let test = true;
            if (isRetorikNews) {
                const fullTenantName = (addressData.baseURI || `${addressData.prefix || ''}${addressData.tenant}`).replace(/;|,|\s/g, '');
                const newsConversationData = localStorage.getItem(`Retorik.News.Conversation.${fullTenantName}`);
                if (newsConversationData) {
                    const data = JSON.parse(newsConversationData);
                    if (data?.conversationId) // 604800000 = number of milliseconds in 7 days
                    {
                        if (!isNaN(data.startedAt) && data.startedAt + 604800000 > Date.now()) {
                            setDirectLineCreationData({
                                token: token,
                                domain: directLineData.address,
                                conversationId: data.conversationId
                            });
                            test = false;
                        }
                    }
                }
                test && dispatch((0, $cto9a.storeActions).activity.setAddRetorikNewsConversationIdInLocalStorage(fullTenantName));
            } else if (configuration.enableConversationCookie !== false) {
                const conversationCookie = document.cookie.split('; ').find((row)=>row.startsWith('retorikConversationCookie='))?.split('=')[1];
                if (conversationCookie) {
                    const splitCookieData = conversationCookie.split('||');
                    if (splitCookieData.length === 3) {
                        const cookieConversationId = splitCookieData[0];
                        const cookieTenantName = splitCookieData[1];
                        const cookieConversationToken = splitCookieData[2];
                        const fullTenantName = (addressData.baseURI || `${addressData.prefix || ''}${addressData.tenant}`).replace(/;|,|\s/g, '');
                        if (cookieTenantName === fullTenantName) {
                            setDirectLineCreationData({
                                token: cookieConversationToken || token,
                                domain: directLineData.address,
                                conversationId: cookieConversationId,
                                watermark: '0'
                            });
                            // Tell the activity store that we will retrieve several activities from an existing conversation, so that it displays only the last one
                            dispatch((0, $cto9a.storeActions).activity.setRetrievingConversation(true));
                            setHasConversationCookie(true);
                            test = false;
                        }
                    }
                } else {
                    const fullTenantName = (addressData.baseURI || `${addressData.prefix || ''}${addressData.tenant}`).replace(/;|,|\s/g, '');
                    const maxAge = configuration.conversationCookieMaxAge || 3600;
                    dispatch((0, $cto9a.storeActions).activity.addCookie(`retorikConversationCookie=<conversationId>||${fullTenantName}||${token}; max-age=${maxAge}`));
                }
            }
            test && setDirectLineCreationData({
                token: token,
                domain: directLineData.address
            });
        });
    };
    (0, $bxRTa.useEffect)(()=>{
        if (directLineCreationData && locale && processedUserData) connectionStatus === (0, $cto9a.ConnectionStatus).Uninitialized && dispatch((0, $cto9a.storeActions).directline.createDirectline({
            ...directLineCreationData,
            conversationStartProperties: {
                locale: locale
            },
            userId: processedUserData.id,
            externalActivityHandler: externalEventHandler
        }));
    }, [
        locale,
        directLineCreationData,
        processedUserData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        addressData?.directline && processDirectLine(addressData.directline);
        return ()=>{
            console.log('Retorik Framework > disconnect and end directline');
            dispatch((0, $cto9a.storeActions).directline.resetDirectlineStore());
        };
    }, [
        addressData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (locale && supported && agentData && connectionStatus === (0, $cto9a.ConnectionStatus).Online && (isRetorikNews || loaderClosed) && calibrationCompleted) dispatch((0, $cto9a.storeActions).retorik.setAppAvailable(true));
    }, [
        locale,
        supported,
        agentData,
        loaderClosed,
        connectionStatus,
        calibrationCompleted
    ]);
    return agentData && processedUserData ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            connectionStatus === (0, $cto9a.ConnectionStatus).Online && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7c6BL.default), {
                isRetorikNews: isRetorikNews,
                hasConversationCookie: hasConversationCookie,
                userData: processedUserData
            }),
            children
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $6a60c4ac572a9b7a$export$2e2bcd8739ae039 = $6a60c4ac572a9b7a$var$RetorikComposer;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $VZzOq = parcelRequire("VZzOq");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");

var $gQoxd = parcelRequire("gQoxd");
const $a174d1df6657d370$var$springDuration = 1050;
const $a174d1df6657d370$var$VoiceInput = ({ className: className })=>{
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const lastRecognitionInterim = (0, $5FZWK.useSelector)((state)=>state.speechReducer.lastRecognitionInterim);
    const isWaitingForResponse = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.isWaitingForResponse);
    const [remainingLastRecognitionInterim, setRemainingLastRecognitionInterim] = (0, $bxRTa.useState)(null);
    const animationTimerRef = (0, $bxRTa.useRef)();
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 1
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        return ()=>{
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        if (lastRecognitionInterim) setRemainingLastRecognitionInterim(lastRecognitionInterim);
        else if (remainingLastRecognitionInterim) {
            api.start({
                from: {
                    opacity: 1
                },
                to: {
                    opacity: 0
                },
                config: {
                    duration: $a174d1df6657d370$var$springDuration
                }
            });
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
            animationTimerRef.current = setTimeout(()=>{
                api.set({
                    opacity: 1
                });
                setRemainingLastRecognitionInterim(null);
            }, $a174d1df6657d370$var$springDuration);
        }
    }, [
        lastRecognitionInterim
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: isWaitingForResponse ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $gQoxd.default), {
            classname: `rf-flex ${isMobile ? 'rf-justify-center' : 'rf-pl-8 rf-justify-start'} rf-py-3 rf-items-center`,
            subClassname: "rf-w-4 rf-h-4",
            size: (0, $2rYkD.AnimationSize).medium,
            useTextColor: true
        }) : remainingLastRecognitionInterim && (isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bTjo.animated).p, {
            className: className,
            style: {
                ...spring
            },
            children: remainingLastRecognitionInterim
        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bTjo.animated).div, {
            className: "rf-w-full rf-py-3 rf-subtitle-size-auto rf-font-bold rf-text-truewhite rf-text-shadow-black",
            style: {
                ...spring
            },
            children: remainingLastRecognitionInterim
        }))
    });
};
var $a174d1df6657d370$export$2e2bcd8739ae039 = $a174d1df6657d370$var$VoiceInput;



var $dq6kU = parcelRequire("dq6kU");
const $515c6bb01607ffda$var$UserRequest = ()=>{
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const mediumLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.mediumLandscape);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                if (typeof configuration?.answerpanel === 'object') switch(mode){
                    case (0, $2rYkD.Mode).text:
                        if (configuration.answerpanel.landscape?.containerRowEndText) {
                            setGridRowStart(configuration.answerpanel.landscape.containerRowEndText);
                            setGridRowSpan(13 - configuration.answerpanel.landscape.containerRowEndText);
                        } else {
                            setGridRowStart(11);
                            setGridRowSpan(2);
                        }
                        break;
                    case (0, $2rYkD.Mode).vocal:
                        setGridRowStart(1);
                        if (configuration.answerpanel.landscape?.containerRowStart) setGridRowSpan(configuration.answerpanel.landscape.containerRowStart - 1);
                        else setGridRowSpan(3);
                        break;
                    default:
                        break;
                }
                else {
                    setGridRowStart(mode === (0, $2rYkD.Mode).text ? 11 : 1);
                    setGridRowSpan(mode === (0, $2rYkD.Mode).text ? 2 : 3);
                }
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.borne?.containerRowStart) {
                    setGridRowStart(1);
                    setGridRowSpan(configuration.answerpanel.borne.containerRowStart - 1);
                } else {
                    setGridRowStart(4);
                    setGridRowSpan(2);
                }
                break;
        }
    }, [
        mode,
        configuration.answerpanel,
        currentDeviceType
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-userRequest",
        className: `rf-relative rf-z-util rf-h-full rf-w-3/5 landscape-retorik:rf-w-[calc(80%-10rem)] landscape-retorik:rf-ml-1/5 rf-py-4 large-vertical:rf-py-5 rf-flex rf-flex-col rf-justify-self-center rf-justify-end landscape-retorik:rf-justify-self-start
        ${mode === (0, $2rYkD.Mode).text && 'landscape-retorik:rf-justify-start'}
        ${mediumLandscape ? 'landscape-retorik:rf-col-start-3' : 'landscape-retorik:rf-col-start-4'} large-vertical:rf-col-start-1 rf-col-span-full rf-text-size-auto rf-text-trueblack`,
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`
        },
        children: mode === (0, $2rYkD.Mode).text ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dq6kU.default), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a174d1df6657d370$export$2e2bcd8739ae039), {})
    });
};
var $515c6bb01607ffda$export$2e2bcd8739ae039 = $515c6bb01607ffda$var$UserRequest;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");

var $hvWkK = parcelRequire("hvWkK");

var $dq6kU = parcelRequire("dq6kU");
const $5377bf2433391660$var$UserRequest = ()=>{
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const mediumLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.mediumLandscape);
    const currentHeight = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentHeight);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    const [paddingTop, setPaddingTop] = (0, $bxRTa.useState)();
    const [paddingBottom, setPaddingBottom] = (0, $bxRTa.useState)();
    (0, $bxRTa.useEffect)(()=>{
        const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.landscape?.containerRowEndText) {
                    setGridRowStart(configuration.answerpanel.landscape.containerRowEndText);
                    setGridRowSpan(13 - configuration.answerpanel.landscape.containerRowEndText);
                } else {
                    setGridRowStart(10);
                    setGridRowSpan(3);
                }
                setPaddingTop(currentHeight * 1 / 12 - 1.5 * remToPx);
                setPaddingBottom(remToPx);
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.borne?.containerRowStart) {
                    setGridRowStart(1);
                    setGridRowSpan(configuration.answerpanel.borne.containerRowStart - 1);
                } else {
                    setGridRowStart(4);
                    setGridRowSpan(2);
                }
                setPaddingTop(remToPx * 1.25);
                setPaddingBottom(remToPx * 1.25);
                break;
        }
    }, [
        configuration.answerpanel,
        currentDeviceType,
        currentHeight
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-userRequest",
        className: `rf-relative rf-z-[3] rf-h-full rf-w-3/5 landscape-retorik:rf-w-[calc(80%-10rem)] landscape-retorik:rf-ml-1/5 rf-flex rf-flex-col rf-justify-self-center rf-justify-end landscape-retorik:rf-justify-self-start landscape-retorik:rf-justify-start
        ${mediumLandscape ? 'landscape-retorik:rf-col-start-3' : 'landscape-retorik:rf-col-start-4'} large-vertical:rf-col-start-1 rf-col-span-full rf-text-size-auto rf-text-trueblack`,
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`,
            paddingTop: paddingTop,
            paddingBottom: paddingBottom
        },
        children: mode === (0, $2rYkD.Mode).text ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dq6kU.default), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hvWkK.default), {})
    });
};
var $5377bf2433391660$export$2e2bcd8739ae039 = $5377bf2433391660$var$UserRequest;



var $h0yA8 = parcelRequire("h0yA8");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");
const $1659729a48fc4639$var$ListContextProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4mkhB.ListProvider), {
        children: children
    });
};
var $1659729a48fc4639$export$2e2bcd8739ae039 = $1659729a48fc4639$var$ListContextProvider;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("5bTjo");
var $2aMjv = parcelRequire("2aMjv");
var $hzlaD = parcelRequire("hzlaD");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $4mkhB = parcelRequire("4mkhB");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $k4qlo = parcelRequire("k4qlo");

var $gPs3v = parcelRequire("gPs3v");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
const $f0be575cd6d21e61$var$Title = ({ className: className, title: title, numberOfResults: numberOfResults })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-mb-4 rf-flex rf-flex-col rf-items-start rf-justify-center large:rf-flex-row large:rf-items-baseline large:rf-justify-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-text-3xl large:rf-text-5xl rf-font-bold",
                children: title
            }),
            numberOfResults !== undefined && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-text-gray large:ltr:rf-ml-4 large:rtl:rf-mr-4",
                children: [
                    numberOfResults,
                    " ",
                    numberOfResults > 1 ? translation.common.results : translation.common.result
                ]
            })
        ]
    });
};
var $f0be575cd6d21e61$export$2e2bcd8739ae039 = $f0be575cd6d21e61$var$Title;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $4mkhB = parcelRequire("4mkhB");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("kMAJU");
var $04Syy = parcelRequire("04Syy");
const $ea090066eeddb2f1$var$ChosenItem = ({ className: className, filterItem: filterItem, parent: parent })=>{
    const { processFiltersOnChange: processFiltersOnChange } = (0, $4mkhB.useList)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-py-1 rf-text-size-auto rf-text-white rf-bg-gray hover:rf-cursor-pointer rf-rounded-lg rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
        onClick: ()=>processFiltersOnChange([
                {
                    ...parent,
                    filterItems: [
                        filterItem
                    ]
                }
            ]),
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-mr-2 large:rf-mr-3",
                children: parent.id === 'Event.DateRange' ? `${filterItem.name.substring(8, 10)}/${filterItem.name.substring(5, 7)}/${filterItem.name.substring(0, 4)}` : (0, $eO5xw.capitalizeFirstLetter)(filterItem.name, locale)
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $04Syy.default), {
                className: "rf-h-3 rf-w-3"
            })
        ]
    });
};
var $ea090066eeddb2f1$export$2e2bcd8739ae039 = $ea090066eeddb2f1$var$ChosenItem;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
parcelRequire("hNqlv");
var $1NaGJ = parcelRequire("1NaGJ");
var $1dNUX = parcelRequire("1dNUX");

var $eO5xw = parcelRequire("eO5xw");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $4mkhB = parcelRequire("4mkhB");

var $eO5xw = parcelRequire("eO5xw");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("kMAJU");
var $kA2rN = parcelRequire("kA2rN");
const $f22d6e24a3b46ad8$var$CheckBox = ({ className: className, iconClassName: iconClassName, checked: checked, onClick: onClick })=>{
    const [bgColor, setBgColor] = (0, $bxRTa.useState)(checked ? 'rf-bg-secondary' : 'rf-bg-truewhite');
    (0, $bxRTa.useEffect)(()=>{
        setBgColor(checked ? 'rf-bg-secondary' : 'rf-bg-truewhite');
    }, [
        checked
    ]);
    const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onClick && onClick();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-6 rf-h-6 rf-min-w-6 rf-min-h-6 rf-flex rf-justify-center rf-items-center rf-border rf-border-templateCheckboxBorder hover:rf-cursor-pointer ${bgColor} ${className}`,
        onClick: (e)=>handleClick(e),
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $kA2rN.default), {
            className: iconClassName
        })
    });
};
var $f22d6e24a3b46ad8$export$2e2bcd8739ae039 = $f22d6e24a3b46ad8$var$CheckBox;


const $0fa6b229879fa0de$var$SubFilter = ({ className: className, filterItem: filterItem, parent: parent })=>{
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $4mkhB.useList)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const checked = (0, $bxRTa.useMemo)(()=>{
        if (selectedFilters.length) {
            const check = selectedFilters.filter((filter)=>filter.title === parent.title && filter.filterItems.find((item)=>item.name === filterItem.name && item.value === filterItem.value) !== undefined);
            return !!check.length;
        }
        return false;
    }, [
        selectedFilters
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-pt-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center ${className}`,
        children: [
            (0, $eO5xw.capitalizeFirstLetter)(filterItem.name, locale),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f22d6e24a3b46ad8$export$2e2bcd8739ae039), {
                className: "rf-rounded large:rf-ml-8",
                iconClassName: "rf-w-4 rf-h-4 large:rf-p-min1 large:rf-w-6 large:rf-h-6",
                checked: checked,
                onClick: ()=>processFiltersOnChange([
                        {
                            ...parent,
                            filterItems: [
                                filterItem
                            ]
                        }
                    ])
            })
        ]
    });
};
var $0fa6b229879fa0de$export$2e2bcd8739ae039 = $0fa6b229879fa0de$var$SubFilter;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $4mkhB = parcelRequire("4mkhB");

var $eO5xw = parcelRequire("eO5xw");

const $b4f43748975ade6c$var$SubFilterAll = ({ className: className, fullParent: fullParent })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $4mkhB.useList)();
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-py-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center ${className}`,
        children: [
            (0, $eO5xw.capitalizeFirstLetter)(translation.common.all, locale),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f22d6e24a3b46ad8$export$2e2bcd8739ae039), {
                className: "rf-rounded large:rf-ml-8",
                iconClassName: "rf-w-4 rf-h-4 large:rf-p-min1 large:rf-w-6 large:rf-h-6",
                checked: selectedFilters.filter((filter)=>filter.title === fullParent.title && filter.filterItems.length === fullParent.filterItems.length).length === 1,
                onClick: ()=>processFiltersOnChange([
                        {
                            ...fullParent
                        }
                    ], true)
            })
        ]
    });
};
var $b4f43748975ade6c$export$2e2bcd8739ae039 = $b4f43748975ade6c$var$SubFilterAll;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");

const $62341e46b29a229a$var$SubFilterCalendar = ({ parent: parent })=>{
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $4mkhB.useList)();
    const handleCalendarChange = (newDate)=>{
        processFiltersOnChange([
            {
                ...parent,
                filterItems: [
                    {
                        name: newDate,
                        value: newDate
                    }
                ]
            }
        ]);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-pt-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $458e84cda88f0199$export$2e2bcd8739ae039), {
            id: "filterCalendar",
            handleChange: handleCalendarChange,
            defaultValue: selectedFilters.find((filter)=>filter.id === 'Event.DateRange' && filter.filterItems.length > 0)?.filterItems[0].name.substring(0, 11),
            isFilter: true
        })
    });
};
var $62341e46b29a229a$export$2e2bcd8739ae039 = $62341e46b29a229a$var$SubFilterCalendar;


const $c9b44ac92871535d$var$FilterItem = ({ className: className, identifier: identifier, opened: opened, filter: filter, closeOpenedFilters: closeOpenedFilters })=>{
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const [style, setStyle] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        opened ? setStyle('rf-bg-truewhite rf-text-black rf-border-black') : setStyle('rf-bg-templateBackground rf-text-gray rf-border-gray');
    }, [
        opened
    ]);
    const handleOpen = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        closeOpenedFilters(opened ? undefined : identifier);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-relative rf-mt-1",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-px-4 rf-py-3 rf-mr-4 large-vertical:rf-py-4 ${style} rf-border rf-rounded-lg hover:rf-cursor-pointer rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
                onClick: (e)=>handleOpen(e),
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-mr-3",
                        children: (0, $eO5xw.capitalizeFirstLetter)(filter.title, locale)
                    }),
                    opened ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1dNUX.default), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1NaGJ.default), {})
                ]
            }),
            opened && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-absolute rf-left-0 rf-top-110 rf-z-util rf-w-max rf-py-1 rf-px-4 rf-text-black rf-border rf-rounded-lg rf-border-black rf-bg-truewhite rf-flex rf-flex-col rf-items-center rf-justify-center",
                style: {
                    transform: filter.id === 'Event.DateRange' && !isMobile ? 'translate(-20%, -20%) scale(0.6, 0.6)' : ''
                },
                children: filter.id === 'Event.DateRange' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $62341e46b29a229a$export$2e2bcd8739ae039), {
                    parent: {
                        id: filter.id,
                        title: filter.title
                    }
                }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b4f43748975ade6c$export$2e2bcd8739ae039), {
                            fullParent: filter
                        }),
                        filter.filterItems.map((item, key)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $0fa6b229879fa0de$export$2e2bcd8739ae039), {
                                filterItem: item,
                                parent: {
                                    id: filter.id,
                                    title: filter.title
                                }
                            }, key);
                        })
                    ]
                })
            })
        ]
    });
};
var $c9b44ac92871535d$export$2e2bcd8739ae039 = $c9b44ac92871535d$var$FilterItem;


const $30397f6a3d85863f$var$FilterLarge = ({ className: className, openedFilterKey: openedFilterKey, setOpenedFilterKey: setOpenedFilterKey })=>{
    const { filters: filters, selectedFilters: selectedFilters } = (0, $4mkhB.useList)();
    const closeOpenedFilters = (key)=>{
        setOpenedFilterKey(key);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-flex rf-flex-col rf-justify-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-relative rf-flex rf-flex-row rf-flex-wrap",
                children: filters.map((filter, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c9b44ac92871535d$export$2e2bcd8739ae039), {
                        identifier: key + 1,
                        opened: (openedFilterKey && key + 1 === openedFilterKey) === true,
                        filter: filter,
                        closeOpenedFilters: closeOpenedFilters
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-my-2 rf-flex-wrap",
                children: selectedFilters?.map((chosenFilter, key1)=>{
                    return chosenFilter.filterItems.map((item, key2)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ea090066eeddb2f1$export$2e2bcd8739ae039), {
                            className: "rf-px-4 rf-mr-2 rf-mb-1",
                            filterItem: item,
                            parent: {
                                id: chosenFilter.id,
                                title: chosenFilter.title
                            }
                        }, `${key1}-${key2}`);
                    });
                })
            })
        ]
    });
};
var $30397f6a3d85863f$export$2e2bcd8739ae039 = $30397f6a3d85863f$var$FilterLarge;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $4mkhB = parcelRequire("4mkhB");
parcelRequire("kMAJU");
var $cxD1i = parcelRequire("cxD1i");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $4mkhB = parcelRequire("4mkhB");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("7Jjoy");
var $iyJo4 = parcelRequire("iyJo4");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
const $8296733041b86ac0$var$MobileUpperBand = ({ title: title, handleReset: handleReset, handleReturn: handleReturn })=>{
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-py-4 rf-px-4 rf-flex rf-justify-between rf-items-center rf-border-b rf-border-b-black",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                className: "rf-flex rf-flex-row rf-items-center rf-text-size-auto",
                onClick: handleReturn,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                        className: "rf-w-8"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-ml-1",
                        children: (0, $eO5xw.capitalizeFirstLetter)(title, locale)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `${isRTL ? 'rf-text-arabic' : 'rf-text-xsm'} rf-uppercase rf-text-secondary rf-underline`,
                onClick: handleReset,
                children: translation.template.reset
            })
        ]
    });
};
var $8296733041b86ac0$export$2e2bcd8739ae039 = $8296733041b86ac0$var$MobileUpperBand;


const $b1b1a2a161231d77$var$MobileFilterPage = ({ close: close, resetFilters: resetFilters, setCurrentOpened: setCurrentOpened })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const { filters: filters, processFiltersOnChange: processFiltersOnChange } = (0, $4mkhB.useList)();
    const handleSelectAllAndOpen = (filter)=>{
        processFiltersOnChange([
            filter
        ], true);
        setCurrentOpened(filter);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8296733041b86ac0$export$2e2bcd8739ae039), {
                title: translation.common.filter,
                handleReset: resetFilters,
                handleReturn: close
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-px-2",
                children: filters.map((filter, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: `rf-py-4 rf-text-xl rf-font-semibold rf-flex rf-justify-between rf-items-center rf-cursor-pointer ${key !== 0 && 'rf-border-t rf-border-t-[#CBC9C9]'}`,
                        onClick: ()=>setCurrentOpened(filter),
                        children: [
                            (0, $eO5xw.capitalizeFirstLetter)(filter.title, locale),
                            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                                className: "rf-flex rf-items-center",
                                children: [
                                    filter.id !== 'Event.DateRange' && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                        className: "rf-text-sm rf-text-gray rf-mr-5",
                                        onClick: ()=>handleSelectAllAndOpen(filter),
                                        children: (0, $eO5xw.capitalizeFirstLetter)(translation.common.all, locale)
                                    }),
                                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iyJo4.default), {
                                        className: "rf-h-5",
                                        color: "#000"
                                    })
                                ]
                            })
                        ]
                    }, key);
                })
            })
        ]
    });
};
var $b1b1a2a161231d77$export$2e2bcd8739ae039 = $b1b1a2a161231d77$var$MobileFilterPage;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $eO5xw = parcelRequire("eO5xw");




const $3023448913723f56$var$MobileSubFilterPage = ({ filter: filter, close: close, resetFilters: resetFilters })=>{
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8296733041b86ac0$export$2e2bcd8739ae039), {
                title: (0, $eO5xw.capitalizeFirstLetter)(filter.title, locale),
                handleReset: resetFilters,
                handleReturn: close
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-px-2",
                children: filter.id === 'Event.DateRange' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $62341e46b29a229a$export$2e2bcd8739ae039), {
                    parent: {
                        id: filter.id,
                        title: filter.title
                    }
                }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b4f43748975ade6c$export$2e2bcd8739ae039), {
                            className: "rf-text-xl rf-border-b rf-border-b-silver",
                            fullParent: filter
                        }),
                        filter.filterItems.map((item, key)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $0fa6b229879fa0de$export$2e2bcd8739ae039), {
                                className: "rf-text-xl",
                                filterItem: item,
                                parent: {
                                    id: filter.id,
                                    title: filter.title
                                }
                            }, key);
                        })
                    ]
                })
            })
        ]
    });
};
var $3023448913723f56$export$2e2bcd8739ae039 = $3023448913723f56$var$MobileSubFilterPage;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");
const $0b2dd8b6f974754f$var$MobileDisplayResult = ({ onClick: onClick })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-full rf-pt-8 ${mode === (0, $2rYkD.Mode).text ? 'rf-mb-30' : 'rf-mb-16'} rf-flex rf-justify-center rf-justify-self-end`,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
            className: "rf-py-4 rf-px-6 rf-font-bold rf-text-secondary rf-border-2 rf-rounded-lg rf-border-secondary",
            onClick: onClick,
            children: translation.template.showresults
        })
    });
};
var $0b2dd8b6f974754f$export$2e2bcd8739ae039 = $0b2dd8b6f974754f$var$MobileDisplayResult;


parcelRequire("9cEaH");
var $4kqtJ = parcelRequire("4kqtJ");

var $k4qlo = parcelRequire("k4qlo");
const $e4dae391c7af5f7c$var$FilterMobile = ({ className: className, setFiltersOpened: setFiltersOpened, handleClose: handleClose, hasFilters: hasFilters })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const isWidget = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isWidget);
    const { resetFilters: resetFilters } = (0, $4mkhB.useList)();
    const [open, setOpen] = (0, $bxRTa.useState)(false);
    const [currentOpened, setCurrentOpened] = (0, $bxRTa.useState)(undefined);
    const divRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (divRef?.current) isWidget && (0, $k4qlo.default)(null, divRef);
    }, [
        divRef?.current
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setFiltersOpened(open);
    }, [
        open
    ]);
    const handleClick = ()=>{
        setOpen(true);
    };
    const handleReturn = ()=>{
        setOpen(false);
    };
    const handleReset = ()=>{
        setOpen(false);
        resetFilters && resetFilters();
    };
    const closeCurrentSubFilters = ()=>{
        setCurrentOpened(undefined);
    };
    const handleDisplayResults = ()=>{
        setCurrentOpened(undefined);
        setOpen(false);
    };
    return !open ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `large:rf-hidden rf-w-full rf-py-4 rf-px-4 rf-flex rf-flex-row rf-justify-between rf-items-center rf-bg-truewhite rf-shadow-[0_0_15px_0_silver] ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4kqtJ.default), {
                title: translation.menu.backconversation,
                handleBack: handleClose,
                className: "rf-relative rf-text-size-auto"
            }),
            hasFilters && /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                className: "rf-px-4 rf-py-1 rf-flex rf-flex-row rf-items-center rf-border rf-rounded-lg rf-border-black",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cxD1i.default), {
                        className: "rf-h-4 rf-w-4"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-ml-2",
                        children: translation.common.filter
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        ref: divRef,
        className: "rf-absolute rf-z-util large:rf-hidden rf-top-0 rf-left-0 rf-w-full rf-h-full rf-overflow-y-scroll rf-scrollbar-hidden rf-bg-truewhite rf-flex rf-flex-col rf-justify-between",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-col rf-justify-start rf-align-center",
                children: currentOpened ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3023448913723f56$export$2e2bcd8739ae039), {
                    filter: currentOpened,
                    close: closeCurrentSubFilters,
                    resetFilters: handleReset
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b1b1a2a161231d77$export$2e2bcd8739ae039), {
                    setCurrentOpened: setCurrentOpened,
                    close: handleReturn,
                    resetFilters: handleReset
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $0b2dd8b6f974754f$export$2e2bcd8739ae039), {
                onClick: handleDisplayResults
            })
        ]
    });
};
var $e4dae391c7af5f7c$export$2e2bcd8739ae039 = $e4dae391c7af5f7c$var$FilterMobile;




var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $4mkhB = parcelRequire("4mkhB");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");
function $b6c73313d6353629$export$2e2bcd8739ae039() {
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const [currentPagination, setCurrentPagination] = (0, $bxRTa.useState)(10);
    (0, $bxRTa.useEffect)(()=>{
        if (configuration && currentDeviceType) switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).borne:
                setCurrentPagination(configuration.pagination?.borne || 15);
                break;
            case (0, $2rYkD.DeviceType).landscape:
                setCurrentPagination(configuration.pagination?.landscape || 20);
                break;
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                setCurrentPagination(configuration.pagination?.mobile || 12);
                break;
            default:
                break;
        }
        else setCurrentPagination(10);
    }, [
        configuration,
        currentDeviceType
    ]);
    return currentPagination;
}



var $dHUeX = parcelRequire("dHUeX");

var $2rYkD = parcelRequire("2rYkD");

var $k4qlo = parcelRequire("k4qlo");

var $8HSQQ = parcelRequire("8HSQQ");

var $85RVQ = parcelRequire("85RVQ");

var $hC8yR = parcelRequire("hC8yR");
let $055666127e249e5c$var$timer = null;
const $055666127e249e5c$var$ListContainer = ({ hasFilterOrSuggestedAction: hasFilterOrSuggestedAction, numberOfResults: numberOfResults })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const { content: content, selectedFilters: selectedFilters, loadingData: loadingData, setLoadingData: setLoadingData } = (0, $4mkhB.useList)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const isWidget = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isWidget);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const currentPagination = (0, $b6c73313d6353629$export$2e2bcd8739ae039)();
    const [contentToDisplay, setContentToDisplay] = (0, $bxRTa.useState)([]);
    const [landscapeStyle, setLandscapeStyle] = (0, $bxRTa.useState)('large:rf-h-3/5');
    const [limitToFill, setLimitToFill] = (0, $bxRTa.useState)(0);
    const loadingRef = (0, $bxRTa.useRef)(false);
    const scrollRef = (0, $bxRTa.useRef)(null);
    const contentRef = (0, $bxRTa.useRef)(null);
    const numberOfDisplayed = (0, $bxRTa.useRef)();
    const [abortController, setAbortController] = (0, $bxRTa.useState)(null);
    (0, $bxRTa.useEffect)(()=>{
        setLandscapeStyle(hasFilterOrSuggestedAction ? 'large:rf-h-[60vh]' : '');
    }, [
        hasFilterOrSuggestedAction
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
                setLimitToFill(10);
                break;
            case (0, $2rYkD.DeviceType).borne:
                setLimitToFill(9);
                break;
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                setLimitToFill(0);
                break;
        }
    }, [
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (content?.attachments && content.attachments.length > 0) {
            const filteredContent = content.attachments.filter((attachment)=>attachment.contentType === (0, $dHUeX.CONTENT_TYPE_POI));
            if (content?.label === 'Davi.NextPageContent') {
                // If we received new content to add to the current one, check for mobile and display all
                if (isMobile) {
                    // If the last attachment was added to get an even number, remove it before merging data
                    const oldAttachments = contentToDisplay[contentToDisplay.length - 1].contentType === (0, $dHUeX.CONTENT_TYPE_EMPTY) ? [
                        ...contentToDisplay
                    ].slice(0, -1) : contentToDisplay;
                    const tempAttachments = [
                        ...oldAttachments,
                        ...filteredContent
                    ];
                    if (tempAttachments.length % 2 !== 0) setContentToDisplay([
                        ...tempAttachments,
                        {
                            contentType: (0, $dHUeX.CONTENT_TYPE_EMPTY)
                        }
                    ]);
                    else setContentToDisplay(tempAttachments);
                } else setContentToDisplay([
                    ...contentToDisplay,
                    ...filteredContent
                ]);
            } else {
                // On a mobile device, if there is an odd number of attachments, we put a grey one at the end
                if (isMobile && filteredContent.length % 2 !== 0) setContentToDisplay([
                    ...filteredContent,
                    {
                        contentType: (0, $dHUeX.CONTENT_TYPE_EMPTY)
                    }
                ]);
                else if (filteredContent.length < limitToFill) {
                    const tempAttachments = [
                        ...filteredContent
                    ];
                    let i = filteredContent.length;
                    while(i < limitToFill){
                        tempAttachments.push({
                            contentType: (0, $dHUeX.CONTENT_TYPE_EMPTY)
                        });
                        i++;
                    }
                    setContentToDisplay(tempAttachments);
                } else setContentToDisplay(filteredContent);
            }
        } else setContentToDisplay([]);
    }, [
        content,
        limitToFill
    ]);
    (0, $bxRTa.useEffect)(()=>{
        loadingRef.current = loadingData;
    }, [
        loadingData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        numberOfDisplayed.current = contentToDisplay.filter((item)=>item.contentType === (0, $dHUeX.CONTENT_TYPE_POI)).length;
        content?.label !== 'Davi.NextPageContent' && !isMobile ? $055666127e249e5c$var$timer = setTimeout(()=>{
            scrollToRef();
        }, 100) : setLoadingData(false);
        return ()=>{
            $055666127e249e5c$var$timer && clearTimeout($055666127e249e5c$var$timer);
        };
    }, [
        contentToDisplay
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (contentRef?.current && isWidget) {
            if (currentDeviceType === (0, $2rYkD.DeviceType).widgetLandscape) {
                const ab = new AbortController();
                setAbortController(ab);
                (0, $k4qlo.default)(null, contentRef, ab.signal);
            } else {
                abortController?.abort();
                setAbortController(null);
            }
        }
    }, [
        contentRef?.current,
        currentDeviceType
    ]);
    /**
   * Click on 'see more' button in mobile mode or scroll to the end of the list in desktop / borne modes.
   * This will send a postback message with 'hospitality.pointOfInterest.nextPage' name to get new content
   */ const handleClick = ()=>{
        setLoadingData(true);
        numberOfDisplayed.current && dispatch((0, $cto9a.storeActions).directline.sendMessage({
            value: {
                name: 'hospitality.pointOfInterest.nextPage',
                index: numberOfDisplayed.current < currentPagination ? 0 : numberOfDisplayed.current - (currentPagination - 2),
                filters: selectedFilters
            }
        }));
    };
    /**
   * Check if we need to call for next content
   */ const handleScroll = ()=>{
        if (contentRef?.current && contentRef.current.scrollTop + contentRef.current.clientHeight >= contentRef.current.scrollHeight - 5 && numberOfDisplayed?.current && numberOfDisplayed.current !== numberOfResults && !loadingRef.current) handleClick();
    };
    /**
   * Scroll to the scrollRef HTMLDivElement at the top of the view
   */ const scrollToRef = ()=>{
        if (scrollRef && scrollRef.current !== null) scrollRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
        setLoadingData(false);
    };
    return content ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                ref: contentRef,
                className: `rf-relative rf-w-full rf-mb-8 ${landscapeStyle} large-vertical:rf-h-[50vh] rf-overflow-y-visible large:rf-overflow-y-scroll rf-scrollbar-hidden ${!isMobile && 'rf-opacity-gradient-b-thin'} rf-px-2 large:rf-px-0 rf-pb-8 large:rf-pb-16 ${loadingData && 'rf-pointer-events-none'}`,
                onScroll: handleScroll,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        ref: scrollRef
                    }),
                    loadingData && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-absolute rf-z-util rf-w-full rf-flex rf-items-end rf-justify-center rf-bg-white rf-bg-opacity-50 rf-pointer-events-none",
                        style: {
                            height: contentRef?.current?.scrollHeight ? `${contentRef.current.scrollHeight}px` : '100%',
                            paddingBottom: contentRef?.current?.clientHeight ? `calc(${contentRef.current.clientHeight / 2}px - 6rem)` : '6rem'
                        },
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-w-6 rf-h-6 rf-mb-16",
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $85RVQ.default), {
                                color: "gray",
                                loaderColor: "#1999b1",
                                backgroundColor: "transparent"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-grid rf-grid-cols-2 large:rf-grid-cols-5 large-vertical:rf-grid-cols-3 rf-gap-4 large:rf-gap-6",
                        children: contentToDisplay.length === 0 ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            children: translation.poi.nodata
                        }) : contentToDisplay.map((attachment, key)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: (0, $8HSQQ.default)({
                                    attachment: attachment
                                })
                            }, key);
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-justify-end rf-gap-8",
                        children: [
                            numberOfDisplayed.current !== numberOfResults && /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                                className: "rf-w-full rf-py-2 rf-bg-templateBackground rf-border rf-border-black rf-rounded rf-text-black",
                                onClick: handleClick,
                                children: "Voir plus"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hC8yR.default), {
                                direction: "top",
                                display: !!(numberOfDisplayed?.current && numberOfDisplayed.current > currentPagination),
                                scrollHandler: ()=>scrollToRef(),
                                className: "rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
                            })
                        ]
                    })
                ]
            }),
            !isMobile && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hC8yR.default), {
                direction: "top",
                display: !!(numberOfDisplayed?.current && numberOfDisplayed.current > currentPagination),
                scrollHandler: ()=>scrollToRef(),
                className: "rf-absolute rf-bottom-1/4 rf-right-3 rf-z-ui rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $055666127e249e5c$export$2e2bcd8739ae039 = $055666127e249e5c$var$ListContainer;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $4mkhB = parcelRequire("4mkhB");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $eO5xw = parcelRequire("eO5xw");
const $5e3b1b417d809072$var$SuggestionsItem = ({ className: className, title: title, value: value, results: results, handleClick: handleClick })=>{
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        onClick: ()=>handleClick(value),
        className: `rf-h-fit rf-px-4 rf-py-3 rf-mr-4 rf-mb-4 large-vertical:rf-py-4 rf-border rf-rounded-lg rf-bg-templateBackground rf-text-black rf-border-black hover:rf-cursor-pointer rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
        "aria-label": title,
        children: [
            (0, $eO5xw.capitalizeFirstLetter)(title, locale),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-6 rf-text-gray",
                children: results || 0
            })
        ]
    });
};
var $5e3b1b417d809072$export$2e2bcd8739ae039 = $5e3b1b417d809072$var$SuggestionsItem;


const $1b0ab911a8ab27bb$var$Suggestions = ({ className: className, suggestions: suggestions })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const { setSuggestedFilter: setSuggestedFilter } = (0, $4mkhB.useList)();
    const handleClick = (value)=>{
        setSuggestedFilter(value);
        dispatch((0, $cto9a.storeActions).directline.sendMessage({
            value: {
                filters: [
                    value
                ]
            }
        }));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-flex rf-flex-col rf-items-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-text-3xl large:rf-text-5xl rf-font-bold rf-mb-5",
                children: translation.template.suggestiontitle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-flex-wrap",
                children: suggestions.map((suggestion, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5e3b1b417d809072$export$2e2bcd8739ae039), {
                        title: suggestion.title,
                        value: suggestion.value.filter,
                        results: suggestion.value.results !== undefined ? suggestion.value.results : 'NC',
                        handleClick: handleClick
                    }, key);
                })
            })
        ]
    });
};
var $1b0ab911a8ab27bb$export$2e2bcd8739ae039 = $1b0ab911a8ab27bb$var$Suggestions;



var $75jcl = parcelRequire("75jcl");
const $6c6b1b799fd46db4$var$springEnterDuration = 1500;
const $6c6b1b799fd46db4$var$springLeaveDuration = 2500;
const $6c6b1b799fd46db4$var$List = ({ activity: activity, onClose: onClose })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const isWidget = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isWidget);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const { content: content, filters: filters, selectedFilters: selectedFilters, setContent: setContent } = (0, $4mkhB.useList)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const lastListActivity = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.lastListActivity);
    const listStatus = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.listStatus);
    const closeList = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.closeList);
    const [mobileFiltersOpened, setMobileFiltersOpened] = (0, $bxRTa.useState)(false);
    const [largeFilterOpenedKey, setLargeFilterOpenedKey] = (0, $bxRTa.useState)(undefined);
    const scrollRef = (0, $bxRTa.useRef)(null);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                transform: 'translateX(0%)'
            }
        }));
    const timerRef = (0, $bxRTa.useRef)(null);
    const divRef = (0, $bxRTa.useRef)(null);
    const [abortController, setAbortController] = (0, $bxRTa.useState)(null);
    (0, $bxRTa.useEffect)(()=>{
        closeList && handleClose();
    }, [
        closeList
    ]);
    const handleOpen = ()=>{
        dispatch((0, $cto9a.storeActions).utils.setListStatus((0, $2rYkD.ListStatus).opened));
        api.start({
            from: {
                transform: 'translateX(-100%)'
            },
            to: {
                transform: 'translateX(0%)'
            },
            config: {
                duration: $6c6b1b799fd46db4$var$springEnterDuration,
                easing: (0, $2aMjv.easings).easeInBack
            }
        });
    };
    const handleClose = ()=>{
        dispatch((0, $cto9a.storeActions).utils.setListStatus((0, $2rYkD.ListStatus).closing));
        api.start({
            from: {
                transform: 'translateX(0%)'
            },
            to: {
                transform: 'translateX(-100%)'
            },
            config: {
                duration: $6c6b1b799fd46db4$var$springLeaveDuration,
                easing: (0, $2aMjv.easings).easeOutExpo
            }
        });
        if (timerRef) {
            timerRef.current && clearTimeout(timerRef.current);
            timerRef.current = setTimeout(()=>{
                dispatch((0, $cto9a.storeActions).directline.sendEvent({
                    name: 'Davi.CloseWindow',
                    callback: ()=>dispatch((0, $cto9a.storeActions).directline.sendEvent({
                            name: 'Davi.CloseWindowList'
                        }))
                }));
                onClose?.();
                setContent(undefined);
            }, $6c6b1b799fd46db4$var$springLeaveDuration);
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        if (activity?.id !== lastListActivity) {
            setContent(activity);
            if (listStatus !== (0, $2rYkD.ListStatus).opened && timerRef.current) {
                clearTimeout(timerRef.current);
                handleOpen();
            }
        }
        return ()=>{
            activity?.id && dispatch((0, $cto9a.storeActions).utils.setLastListActivity(activity.id));
        };
    }, [
        activity
    ]);
    /**
   * On call :
   *  - scroll to the scrollRef HTML element at the top of the view
   */ const scrollToRef = ()=>{
        if (scrollRef && scrollRef.current !== null) scrollRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
    };
    (0, $bxRTa.useEffect)(()=>{
        if (divRef?.current && isWidget) {
            if (currentDeviceType === (0, $2rYkD.DeviceType).widget) {
                const ab = new AbortController();
                setAbortController(ab);
                (0, $k4qlo.default)(null, divRef, ab.signal);
            } else {
                abortController?.abort();
                setAbortController(null);
            }
        }
    }, [
        divRef?.current,
        currentDeviceType
    ]);
    /**
   * On content change :
   *  - call scrollToRef method
   */ (0, $bxRTa.useEffect)(()=>{
        const timer = content && isMobile && content.label !== 'Davi.NextPageContent' ? setTimeout(()=>{
            scrollToRef();
        }, 100) : null;
        return ()=>{
            timer && clearTimeout(timer);
        };
    }, [
        content
    ]);
    (0, $bxRTa.useEffect)(()=>{
        handleOpen();
        return ()=>{
            dispatch((0, $cto9a.storeActions).utils.setListStatus((0, $2rYkD.ListStatus).closed));
            timerRef?.current && clearTimeout(timerRef.current);
        };
    }, []);
    return content ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $gPs3v.default), {
                onClick: handleClose,
                remote: true,
                target: (0, $2rYkD.TemplateTarget).list,
                animation: spring,
                children: [
                    isMobile && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $e4dae391c7af5f7c$export$2e2bcd8739ae039), {
                        setFiltersOpened: setMobileFiltersOpened,
                        handleClose: handleClose,
                        hasFilters: !!filters.length
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        ref: divRef,
                        className: "rf-w-full rf-px-4 large:rf-px-16 rf-overflow-y-scroll rf-scrollbar-hidden",
                        onClick: isMobile ? ()=>{} : ()=>setLargeFilterOpenedKey(undefined),
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                ref: scrollRef
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                                className: `${mobileFiltersOpened ? 'rf-hidden' : 'rf-flex'} rf-flex-col rf-items-start large:rf-pt-16 large:rf-h-full large-vertical:rf-pt-[20vh]`,
                                children: [
                                    content.text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f0be575cd6d21e61$export$2e2bcd8739ae039), {
                                        className: "rf-ml-2 rf-mt-8 large:rf-ml-0 large:rf-mt-0",
                                        title: (0, $eO5xw.capitalizeFirstLetter)(content.text, locale),
                                        numberOfResults: content.channelData?.numberOfResults || 0
                                    }),
                                    !isMobile && filters.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $30397f6a3d85863f$export$2e2bcd8739ae039), {
                                        openedFilterKey: largeFilterOpenedKey,
                                        setOpenedFilterKey: setLargeFilterOpenedKey
                                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
                                    isMobile && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                        className: "rf-flex rf-flex-row rf-mx-2 rf-gap-2 rf-mb-2 rf-flex-wrap",
                                        children: selectedFilters?.map((chosenFilter, key1)=>{
                                            return chosenFilter.filterItems.map((item, key2)=>{
                                                return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ea090066eeddb2f1$export$2e2bcd8739ae039), {
                                                    className: "rf-px-2",
                                                    filterItem: item,
                                                    parent: {
                                                        id: chosenFilter.id,
                                                        title: chosenFilter.title
                                                    }
                                                }, `${key1}-${key2}`);
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $055666127e249e5c$export$2e2bcd8739ae039), {
                                        hasFilterOrSuggestedAction: filters.length > 0 || content.suggestedActions?.actions?.length > 0,
                                        numberOfResults: content.channelData?.numberOfResults || 0
                                    }),
                                    content.suggestedActions?.actions?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1b0ab911a8ab27bb$export$2e2bcd8739ae039), {
                                        className: "rf-px-2 large:rf-px-0 large:rf-mb-4",
                                        suggestions: content.suggestedActions.actions
                                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $75jcl.default), {
                dashboardVisible: true,
                onClick: handleClose
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $6c6b1b799fd46db4$export$2e2bcd8739ae039 = $6c6b1b799fd46db4$var$List;


const $9118c1ce1df56d35$var$TemplateList = ({ activity: activity, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1659729a48fc4639$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6c6b1b799fd46db4$export$2e2bcd8739ae039), {
            activity: activity,
            onClose: onClose
        })
    });
};
var $9118c1ce1df56d35$export$2e2bcd8739ae039 = $9118c1ce1df56d35$var$TemplateList;



var $2nxul = parcelRequire("2nxul");
const $93405e9c3a3a1a91$var$BotResponse = ()=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const speaking = (0, $5FZWK.useSelector)((state)=>state.speechReducer.speaking);
    const lastRecognitionInterim = (0, $5FZWK.useSelector)((state)=>state.speechReducer.lastRecognitionInterim);
    const currentOrLastPlayedActivity = (0, $5FZWK.useSelector)((state)=>state.speechReducer.currentOrLastPlayedActivity);
    const botMessageActivities = (0, $5FZWK.useSelector)((state)=>state.activityReducer.botMessageActivities);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const currentWidth = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentWidth);
    const currentHeight = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentHeight);
    const mediumLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.mediumLandscape);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const displaySubtitles = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.displaySubtitles);
    const listStatus = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.listStatus);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    const botResponseClassname = (0, $bxRTa.useMemo)(()=>{
        let classname = 'rf-relative rf-w-full rf-h-full rf-z-util rf-overflow-y-scroll rf-scrollbar-thin';
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                {
                    // Special case for very small screens
                    const isSmall = currentHeight < 700 && currentWidth < 300;
                    classname += ' rf-col-start-1 rf-col-span-full';
                    setGridRowStart(isSmall ? 5 : 6);
                    if (displaySubtitles && speaking) setGridRowSpan(isSmall ? 6 : 5);
                    else setGridRowSpan(isSmall ? 7 : 6);
                    break;
                }
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                classname += ` ${mediumLandscape ? 'rf-col-start-3' : 'rf-col-start-4'} rf-col-span-full`;
                if (typeof configuration.answerpanel === 'object' && configuration.answerpanel.landscape) {
                    const start = configuration.answerpanel.landscape.containerRowStart;
                    const end = configuration.answerpanel.landscape.containerRowEnd;
                    if (start && start > 0 && start < 13) {
                        if (end && end < 13) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(13 - start);
                        }
                    } else if (end && end > 0 && end < 13) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(4);
                        setGridRowSpan(9);
                    }
                } else {
                    setGridRowStart(4);
                    setGridRowSpan(9);
                }
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                classname += ' rf-col-start-1 rf-col-span-full';
                if (typeof configuration.answerpanel === 'object' && configuration.answerpanel.borne) {
                    const start = configuration.answerpanel.borne.containerRowStart;
                    const end = configuration.answerpanel.borne.containerRowEnd;
                    if (start && start > 0 && start < 13) {
                        if (end && end < 13) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(13 - start);
                        }
                    } else if (end && end > 0 && end < 13) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(6);
                        setGridRowSpan(5);
                    }
                } else {
                    setGridRowStart(6);
                    setGridRowSpan(5);
                }
                break;
        }
        return classname;
    }, [
        currentDeviceType,
        displaySubtitles,
        speaking,
        configuration.answerpanel,
        currentWidth,
        currentHeight
    ]);
    /**
   * Check if the current activity is a streaming one without attachments.
   * If so, let's check if we already received the message at the end of the streaming asn if it contains attachments to be displayed
   */ const processedCurrentOrLastPlayedActivity = (0, $bxRTa.useMemo)(()=>{
        if (currentOrLastPlayedActivity?.name?.toLowerCase() === 'davi.streammessageactivity' && !currentOrLastPlayedActivity?.attachments?.length) {
            const relatedMessageActivityWithAttachments = botMessageActivities.find((activity)=>activity.value?.streamingCount && activity.replyToId === currentOrLastPlayedActivity.replyToId && activity.attachments?.length);
            if (relatedMessageActivityWithAttachments) return relatedMessageActivityWithAttachments;
        }
        return currentOrLastPlayedActivity;
    }, [
        currentOrLastPlayedActivity,
        botMessageActivities
    ]);
    const currentDisplay = (0, $bxRTa.useMemo)(()=>{
        if (processedCurrentOrLastPlayedActivity) {
            if (processedCurrentOrLastPlayedActivity.attachmentLayout) switch(processedCurrentOrLastPlayedActivity.attachmentLayout.toLowerCase()){
                case 'davilist':
                    return (0, $2rYkD.Displays).list;
                case 'carousel':
                case 'namedlist':
                    return processedCurrentOrLastPlayedActivity.attachments && processedCurrentOrLastPlayedActivity.attachments.length > 1 ? (0, $2rYkD.Displays).carousel : (0, $2rYkD.Displays).normal;
                case 'grid':
                    return (0, $2rYkD.Displays).grid;
            }
            // If we have no attachment layout but attachment(s), we use list display by default is there are several attachments
            if (processedCurrentOrLastPlayedActivity.attachments?.length) return processedCurrentOrLastPlayedActivity.attachments?.length > 1 ? (0, $2rYkD.Displays).list : (0, $2rYkD.Displays).normal;
        }
        return (0, $2rYkD.Displays).none;
    }, [
        processedCurrentOrLastPlayedActivity
    ]);
    return currentDisplay === (0, $2rYkD.Displays).none ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : currentDisplay === (0, $2rYkD.Displays).list ? lastRecognitionInterim === '' && !(listStatus === (0, $2rYkD.ListStatus).closed) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9118c1ce1df56d35$export$2e2bcd8739ae039), {
        activity: processedCurrentOrLastPlayedActivity,
        onClose: ()=>dispatch((0, $cto9a.storeActions).utils.setListStatus((0, $2rYkD.ListStatus).closed))
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-botResponse",
        className: botResponseClassname,
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`
        },
        children: processedCurrentOrLastPlayedActivity && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-w-full rf-h-full rf-flex rf-flex-col landscape-retorik:rf-items-start vertical:rf-items-center rf-gap-2",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2nxul.default), {
                activity: processedCurrentOrLastPlayedActivity
            })
        })
    });
};
var $93405e9c3a3a1a91$export$2e2bcd8739ae039 = $93405e9c3a3a1a91$var$BotResponse;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");


var $2nxul = parcelRequire("2nxul");
const $6fe7ed64ef75b076$var$BotResponse = ()=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const speaking = (0, $5FZWK.useSelector)((state)=>state.speechReducer.speaking);
    const lastRecognitionInterim = (0, $5FZWK.useSelector)((state)=>state.speechReducer.lastRecognitionInterim);
    const currentOrLastPlayedActivity = (0, $5FZWK.useSelector)((state)=>state.speechReducer.currentOrLastPlayedActivity);
    const botMessageActivities = (0, $5FZWK.useSelector)((state)=>state.activityReducer.botMessageActivities);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const currentWidth = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentWidth);
    const currentHeight = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentHeight);
    const mediumLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.mediumLandscape);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const displaySubtitles = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.displaySubtitles);
    const listStatus = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.listStatus);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    const botResponseClassname = (0, $bxRTa.useMemo)(()=>{
        let classname = 'rf-relative rf-w-full rf-h-full rf-z-util rf-overflow-y-scroll rf-scrollbar-hidden';
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                {
                    // Special case for very small screens
                    const isSmall = currentHeight < 700 && currentWidth < 300;
                    classname += ' rf-col-start-1 rf-col-span-full';
                    setGridRowStart(isSmall ? 5 : 6);
                    if (displaySubtitles && speaking) setGridRowSpan(isSmall ? 6 : 5);
                    else setGridRowSpan(isSmall ? 7 : 6);
                    break;
                }
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                classname += ` ${mediumLandscape ? 'rf-col-start-3' : 'rf-col-start-4'} rf-col-span-full rf-py-6`;
                if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.landscape) {
                    const start = configuration.answerpanel.landscape.containerRowStart;
                    const end = configuration.answerpanel.landscape.containerRowEnd;
                    if (start && start > 0 && start < 11) {
                        if (end && end < 11) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(11 - start);
                        }
                    } else if (end && end > 0 && end < 11) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(3);
                        setGridRowSpan(7);
                    }
                } else {
                    setGridRowStart(3);
                    setGridRowSpan(7);
                }
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                classname += ' rf-col-start-1 rf-col-span-full';
                if (typeof configuration.answerpanel === 'object' && configuration.answerpanel.borne) {
                    const start = configuration.answerpanel.borne.containerRowStart;
                    const end = configuration.answerpanel.borne.containerRowEnd;
                    if (start && start > 0 && start < 13) {
                        if (end && end < 13) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(13 - start);
                        }
                    } else if (end && end > 0 && end < 13) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(6);
                        setGridRowSpan(5);
                    }
                } else {
                    setGridRowStart(6);
                    setGridRowSpan(5);
                }
                break;
        }
        return classname;
    }, [
        currentDeviceType,
        displaySubtitles,
        speaking,
        configuration.answerpanel,
        currentWidth,
        currentHeight
    ]);
    /**
   * Check if the current activity is a streaming one without attachments.
   * If so, let's check if we already received the message at the end of the streaming asn if it contains attachments to be displayed
   */ const processedCurrentOrLastPlayedActivity = (0, $bxRTa.useMemo)(()=>{
        if (currentOrLastPlayedActivity?.name?.toLowerCase() === 'davi.streammessageactivity' && !currentOrLastPlayedActivity?.attachments?.length) {
            const relatedMessageActivityWithAttachments = botMessageActivities.find((activity)=>activity.value?.streamingCount && activity.replyToId === currentOrLastPlayedActivity.replyToId && activity.attachments?.length);
            if (relatedMessageActivityWithAttachments) return relatedMessageActivityWithAttachments;
        }
        return currentOrLastPlayedActivity;
    }, [
        currentOrLastPlayedActivity,
        botMessageActivities
    ]);
    const currentDisplay = (0, $bxRTa.useMemo)(()=>{
        if (processedCurrentOrLastPlayedActivity) {
            if (processedCurrentOrLastPlayedActivity.attachmentLayout) switch(processedCurrentOrLastPlayedActivity.attachmentLayout.toLowerCase()){
                case 'davilist':
                    return (0, $2rYkD.Displays).list;
                case 'carousel':
                case 'namedlist':
                    return processedCurrentOrLastPlayedActivity.attachments && processedCurrentOrLastPlayedActivity.attachments.length > 1 ? (0, $2rYkD.Displays).carousel : (0, $2rYkD.Displays).normal;
                case 'grid':
                    return (0, $2rYkD.Displays).grid;
            }
            // If we have no attachment layout but attachment(s), we use list display by default is there are several attachments
            if (processedCurrentOrLastPlayedActivity.attachments?.length) return processedCurrentOrLastPlayedActivity.attachments?.length > 1 ? (0, $2rYkD.Displays).list : (0, $2rYkD.Displays).normal;
        }
        return (0, $2rYkD.Displays).none;
    }, [
        processedCurrentOrLastPlayedActivity
    ]);
    return currentDisplay === (0, $2rYkD.Displays).none ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : currentDisplay === (0, $2rYkD.Displays).list ? lastRecognitionInterim === '' && !(listStatus === (0, $2rYkD.ListStatus).closed) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9118c1ce1df56d35$export$2e2bcd8739ae039), {
        activity: processedCurrentOrLastPlayedActivity,
        onClose: ()=>dispatch((0, $cto9a.storeActions).utils.setListStatus((0, $2rYkD.ListStatus).closed))
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-botResponse",
        className: botResponseClassname,
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`
        },
        children: processedCurrentOrLastPlayedActivity && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-w-full rf-h-full rf-flex rf-flex-col landscape-retorik:rf-justify-center landscape-retorik:rf-items-start vertical:rf-items-center rf-gap-2",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2nxul.default), {
                activity: processedCurrentOrLastPlayedActivity
            })
        })
    });
};
var $6fe7ed64ef75b076$export$2e2bcd8739ae039 = $6fe7ed64ef75b076$var$BotResponse;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
parcelRequire("kMAJU");
var $lHTuW = parcelRequire("lHTuW");
const $6ebf4aa8111d9d5f$var$RetorikLogo = ()=>{
    const isUsedOnBorne = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.isUsedOnBorne);
    return isUsedOnBorne ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-hidden large:rf-block rf-relative rf-z-[1] ltr:rf-col-start-1 rtl:rf-col-end-1 rf-col-span-full rf-row-start-12 rf-row-span-1 ltr:rf-self-end rtl:rf-self-start rf-justify-self-start",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lHTuW.default), {
            className: "ltr:rf-ml-4 rtl:rf-mr-4 rf-mb-4 rf-h-14"
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)("a", {
        href: "https://davi.ai",
        title: "Retorik by Davi",
        target: "_blank",
        rel: "noreferrer",
        className: "rf-hidden large:rf-block rf-relative rf-z-[1] rf-col-start-1 rf-col-span-full rf-row-start-12 rf-row-span-1 rf-self-end rf-justify-self-start",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lHTuW.default), {
            className: "rf-ml-4 rf-mb-4 rf-h-14"
        })
    });
};
var $6ebf4aa8111d9d5f$export$2e2bcd8739ae039 = $6ebf4aa8111d9d5f$var$RetorikLogo;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");
const $7123c24c9dc0e392$var$useShowEmergency = ()=>{
    const lastActivity = (0, $5FZWK.useSelector)((state)=>state.activityReducer.lastActivity);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    const [result, setResult] = (0, $bxRTa.useState)(false);
    (0, $bxRTa.useEffect)(()=>{
        if (lastActivity?.type === 'event' && lastActivity.name === 'Hospitality.ShowEmergency') setResult(currentSubView === (0, $2rYkD.CurrentSubView).map ? false : true);
        else setResult(false);
    }, [
        lastActivity,
        currentSubView
    ]);
    return result;
};
var $7123c24c9dc0e392$export$2e2bcd8739ae039 = $7123c24c9dc0e392$var$useShowEmergency;



var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");
const $649376ba64029917$var$useShowMap = ()=>{
    const lastActivity = (0, $5FZWK.useSelector)((state)=>state.activityReducer.lastActivity);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    const [result, setResult] = (0, $bxRTa.useState)(false);
    (0, $bxRTa.useEffect)(()=>{
        if (lastActivity?.type === 'event' && lastActivity.name === 'Hospitality.ShowMap') setResult(currentSubView === (0, $2rYkD.CurrentSubView).map ? false : true);
        else setResult(false);
    }, [
        lastActivity,
        currentSubView
    ]);
    return result;
};
var $649376ba64029917$export$2e2bcd8739ae039 = $649376ba64029917$var$useShowMap;



var $2rYkD = parcelRequire("2rYkD");

const $2ddb2b8c38f184e3$var$HistoryList = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("b5pvk")));

const $2ddb2b8c38f184e3$var$LanguageChoice = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("5vqr0")));

const $2ddb2b8c38f184e3$var$AttachmentDetails = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("f4HPR")));

const $2ddb2b8c38f184e3$var$FullScreenImage = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("iFNHz")));

const $2ddb2b8c38f184e3$var$Weather = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("VHvle")));

const $2ddb2b8c38f184e3$var$CustomView = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("6JZzf")));

const $2ddb2b8c38f184e3$var$Emergency = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("6BMly")));

const $2ddb2b8c38f184e3$var$Map = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("7EPOg")));
const $2ddb2b8c38f184e3$var$SubViews = ({ externalComponents: externalComponents })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    const currentCustomView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentCustomView);
    const enabledFeatures = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.enabledFeatures);
    const showMap = (0, $649376ba64029917$export$2e2bcd8739ae039)();
    const showEmergency = (0, $7123c24c9dc0e392$export$2e2bcd8739ae039)();
    const [displayCustomComponent, setDisplayCustomComponent] = (0, $bxRTa.useState)(true);
    const [customView, setCustomView] = (0, $bxRTa.useState)(undefined);
    (0, $bxRTa.useEffect)(()=>{
        if (currentCustomView) {
            let label = '';
            if (currentCustomView.label && typeof currentCustomView.label === 'string') label = currentCustomView.label;
            else if (currentCustomView.label && typeof currentCustomView.label === 'object') label = currentCustomView.label[locale];
            if (label && currentCustomView.customDisplay && currentCustomView.icon) setCustomView({
                view: currentCustomView.customDisplay,
                title: label,
                icon: currentCustomView.icon
            });
            dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).custom));
        }
    }, [
        currentCustomView
    ]);
    (0, $bxRTa.useEffect)(()=>{
        showMap && dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).map));
    }, [
        showMap
    ]);
    (0, $bxRTa.useEffect)(()=>{
        showEmergency && dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).emergency));
    }, [
        showEmergency
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).utils.unlockClickedButton());
        setDisplayCustomComponent(currentSubView === (0, $2rYkD.CurrentSubView).custom);
    }, [
        currentSubView
    ]);
    const processedSubView = (0, $bxRTa.useMemo)(()=>{
        switch(currentSubView){
            case (0, $2rYkD.CurrentSubView).none:
            case (0, $2rYkD.CurrentSubView).custom:
                return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
            case (0, $2rYkD.CurrentSubView).history:
                return /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$HistoryList, {});
            case (0, $2rYkD.CurrentSubView).languages:
                return /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$LanguageChoice, {});
            case (0, $2rYkD.CurrentSubView).emergency:
                if (enabledFeatures.includes('emergency')) return /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$Emergency, {});
                else console.log('Retorik Framework > tried to switch to emergency while the feature is not activated in Retorik Studio');
                break;
            case (0, $2rYkD.CurrentSubView).weather:
                if (enabledFeatures.includes('weather')) return /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$Weather, {});
                else console.log('Retorik Framework > tried to switch to weather while the feature is not activated in Retorik Studio');
                break;
            case (0, $2rYkD.CurrentSubView).map:
                if (enabledFeatures.includes('hospitality')) return /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$Map, {});
                else console.log('Retorik Framework > tried to switch to interactive map while the feature is not activated in Retorik Studio');
                break;
        }
        return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
    }, [
        currentSubView,
        enabledFeatures
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $bxRTa.Suspense), {
        children: [
            processedSubView,
            /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$CustomView, {
                display: displayCustomComponent,
                externalComponents: externalComponents,
                customView: customView?.view,
                title: customView?.title,
                icon: customView?.icon,
                setDisplayCustomComponent: setDisplayCustomComponent
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$AttachmentDetails, {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$FullScreenImage, {})
        ]
    });
};
var $2ddb2b8c38f184e3$export$2e2bcd8739ae039 = $2ddb2b8c38f184e3$var$SubViews;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");
/**
 * Check if the activity data need a display as list to be triggered
 * @param activity : RetorikActivity
 * @returns boolean
 */ const $af3086b4a2d8da64$export$7c55936a30618336 = (activity)=>{
    return !!(activity?.attachmentLayout?.toLowerCase() === 'davilist' || activity?.attachmentLayout?.toLowerCase() !== 'carousel' && activity?.attachmentLayout?.toLowerCase() !== 'grid' && activity?.attachmentLayout?.toLowerCase() !== 'namedlist' && activity?.attachments?.length && activity.attachments.length > 1);
};



var $6hEoY = parcelRequire("6hEoY");

var $2rYkD = parcelRequire("2rYkD");


var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");

var $k4qlo = parcelRequire("k4qlo");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
const $48dbcf3910a29a57$var$ConversationHeader = ({ agentName: agentName = "L\xe9a", imageUrl: imageUrl = '' })=>{
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.localeForRetorikStudioContent);
    const localizedCompanyName = (0, $5FZWK.useSelector)((state)=>state.localeReducer.localizedCompanyName);
    const localizedSubCompanyMessage = (0, $5FZWK.useSelector)((state)=>state.localeReducer.localizedSubCompanyMessage);
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const [finalCompanyName, setFinalCompanyName] = (0, $bxRTa.useState)();
    const [finalSubCompanyMessage, setFinalSubCompanyMessage] = (0, $bxRTa.useState)();
    const processedCompanyName = (0, $bxRTa.useMemo)(()=>{
        return configuration.companyNameLocalized?.[locale] || localizedCompanyName || configuration.companyName;
    }, [
        locale,
        localizedCompanyName,
        configuration.companyName,
        configuration.companyNameLocalized
    ]);
    const processedSubCompanyMessage = (0, $bxRTa.useMemo)(()=>{
        return configuration.subCompanyMessageLocalized?.[locale] || localizedSubCompanyMessage || configuration.subCompanyMessage;
    }, [
        locale,
        localizedSubCompanyMessage,
        configuration.subCompanyMessage,
        configuration.subCompanyMessageLocalized
    ]);
    (0, $bxRTa.useEffect)(()=>{
        // If either companyName or subCompanyMessage is given, let's use both. Use default is none is given.
        if (processedCompanyName || processedSubCompanyMessage) {
            setFinalCompanyName(processedCompanyName);
            setFinalSubCompanyMessage(processedSubCompanyMessage);
        } else {
            setFinalCompanyName('Davi');
            setFinalSubCompanyMessage(`${agentName} ${translation.menu.answer}`);
        }
    }, [
        processedCompanyName,
        processedSubCompanyMessage
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-conversation-header",
        className: "rf-w-full rf-h-fit rf-grid rf-grid-cols-headerContainer rf-grid-rows-headerContainer rf-bg-truewhite rf-bg-opacity-80",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-col-start-1 rf-col-end-2 rf-row-start-1 rf-row-end-3 rf-flex rf-items-center rf-px-2 rf-py-2",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                    src: imageUrl,
                    alt: "Agent",
                    className: "rf-w-full rf-max-h-20 rf-aspect-square rf-rounded-half rf-border-secondary rf-border-2 rf-bg-truewhite"
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-col-start-3 rf-col-span-full rf-row-start-1 rf-row-span-full rf-flex rf-flex-col rf-justify-center",
                children: [
                    finalCompanyName && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-font-bold rf-leading-4",
                        style: {
                            color: themeColors.companyName
                        },
                        children: finalCompanyName
                    }),
                    finalSubCompanyMessage && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-text-sm/4 rf-italic",
                        children: finalSubCompanyMessage
                    })
                ]
            })
        ]
    });
};
var $48dbcf3910a29a57$export$2e2bcd8739ae039 = $48dbcf3910a29a57$var$ConversationHeader;



var $hC8yR = parcelRequire("hC8yR");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

parcelRequire("6hiCI");
var $28u6w = parcelRequire("28u6w");

var $3Gcj3 = parcelRequire("3Gcj3");
const $4f72a156fc74e407$var$regexLink = /<\/?a([^>])+>/g;
const $4f72a156fc74e407$var$regexImg = /<\/?img([^>])+>/g;
const $4f72a156fc74e407$export$1b8fbc30fb87d9aa = (text, skipAttachments)=>{
    const md = new (0, $28u6w.default)({
        breaks: true,
        html: true,
        xhtmlOut: true,
        typographer: true,
        quotes: `""''`
    });
    let attachmentsToCreate = {
        images: [],
        urls: []
    };
    // text = `[backgroundaudio:"https://daviretorikcdnstorage.blob.core.windows.net/retorik-framework/audiofiles/audiotest.mp3 0.5 2000 1500"][silence:"Leading 1s"] ((Bonjour, comment  allez-vous)[sentence] ? (Bien, merci, et vous-même ?)[sentence;voice:"Fr-fR-jerOMeNeuRal"])[paragraph] (Je suis de (tomato)[ipa:"təˈmeɪtoʊ"] (sapi)[sapi:"iy eh n y uw eh s"] (ups)[ups:"JH AU"] retour (après avoir été remplacée)[emphasis:"strong"] par Brigitte.[silence:"Sentenceboundary 3s"] Au revoir)[voice:"fr-FR-DeniseNeural";emotion:"calm SeniorMale"] ![image](images/bertranges.jpg)`
    // text = `((Bonjour, comment allez-vous ?)[sentence] [1s] (Bien, et toi Jérôme, ça va ?)[sentence])[paragraph] (Bien, merci, et vous-même ?)[voice:"Fr-fR-jerOMeNeuRal"]. Tout-va-pour-le-mieux. (Hallo Denise, wie geht es dir heute ?)[rate:"slow";vol:"x-loud";lang:"de-DE"] (Bonjour, je suis de retour (ASAP)[characters] après avoir été remplacée par Brigitte.Merci)[voice:"fr-FR-DeniseNeural";vol:"loud"] ![image](images/bertranges.jpg)`
    // text = `(Como estas ?)[lang:"es-ES"][1s] Parti - pour le test - (greenage)[lang:"en-US"]. Mettons une image ![image](images/bertranges.jpg).[500ms] En anglais, (parce-que en Français ce n'est pas ça...) greenage se dit (greenage)[lang:"en-US"]. Fin de message (aufwiedersehen)[lang:"de-DE"]`
    // text = `(Le petit chien va dans sa niche car bien escalader archiduchesse long fiente)[ipa:"lə pəti ʃjɛ̃ va dɑ̃ sa niʃ kaʁ bjɛ̃ ɛskalade ar̥ʃidyʃɛːs lɔ̃ fjɑ̃t"]`
    const speechMarkdownReplacedData = (0, $3Gcj3.replaceSpeechMarkdownTags)(text);
    if (!skipAttachments) {
        const parsed = md.parseInline(speechMarkdownReplacedData.text);
        parsed.length && (attachmentsToCreate = $4f72a156fc74e407$var$createNewAttachments(parsed[0].children));
    }
    const textWithHtmlTags = md.render(text);
    // Strip html tags from rendered text
    const newText = $4f72a156fc74e407$var$stripHtml(textWithHtmlTags);
    const speechMarkdownTagsPosition = [];
    speechMarkdownReplacedData.replacements.forEach((replacement)=>{
        const index = text.indexOf(replacement.speechMarkdown);
        speechMarkdownTagsPosition.push([
            index,
            index + replacement.speechMarkdown.length
        ]);
    });
    return {
        ...attachmentsToCreate,
        text: newText,
        htmlText: $4f72a156fc74e407$var$stripHtmlLinkTags(textWithHtmlTags, speechMarkdownTagsPosition)
    };
};
/**
 * Removes speechmarkdown, <a href ...></a> and <img ... /> tags from the text and keeps the others
 * @param text : string
 * @returns string
 */ const $4f72a156fc74e407$var$stripHtmlLinkTags = (text, speechMarkdownTagsPosition)=>{
    // Replace all characters replaced by mardkdown-it renderer (quotes, <, >)
    let newText = text.replaceAll('&quot;', '"');
    newText = newText.replaceAll('&lt;', '<');
    newText = newText.replaceAll('&gt;', '>');
    // Remove speechMarkdown tags, and link/images html tags
    newText = (0, $3Gcj3.getTextWithoutSpeechMarkdown)(newText, speechMarkdownTagsPosition).replaceAll($4f72a156fc74e407$var$regexLink, '');
    newText = newText.replaceAll($4f72a156fc74e407$var$regexImg, '');
    return newText;
};
/**
 * Removes all html tags from the text
 * @param text : string
 * @returns string
 */ const $4f72a156fc74e407$var$stripHtml = (text)=>{
    const temp = document.createElement('div');
    temp.innerHTML = text;
    return temp.textContent && temp.textContent !== '' ? temp.textContent : '';
};
const $4f72a156fc74e407$var$getDataFromToken = (attributes, type)=>{
    // Check if there are attributes, then if one of these attributes contains data with the desired key, and finally if there is a value attached to this key
    const allData = attributes?.find((data)=>data.length > 1 && data[0] === type && data[1] !== '');
    if (allData && allData.length > 1) return allData[1];
    return type === 'href' ? undefined : '';
};
const $4f72a156fc74e407$var$createNewAttachments = (tokens)=>{
    const images = [];
    const urls = [];
    if (tokens?.length) for(let i = 0; i < tokens.length; i++){
        const attributes = tokens[i].attrs;
        switch(tokens[i].type){
            case 'link_open':
                {
                    // Try to retrieve an URl from the href token
                    const url = $4f72a156fc74e407$var$getDataFromToken(attributes, 'href');
                    // If there is an URL, try to retrieve the text contained in the next token 'content' field
                    if (url && !urls.find((v)=>v.url === url)) {
                        const title = $4f72a156fc74e407$var$getDataFromToken(attributes, 'title') || tokens[i + 1]?.content;
                        urls.push({
                            url: url,
                            title: title
                        });
                    }
                    break;
                }
            case 'image':
                {
                    const url = $4f72a156fc74e407$var$getDataFromToken(attributes, 'src');
                    if (url && !images.find((v)=>v.url === url)) images.push({
                        url: url,
                        title: $4f72a156fc74e407$var$getDataFromToken(attributes, 'title'),
                        alt: $4f72a156fc74e407$var$getDataFromToken(attributes, 'alt')
                    });
                    break;
                }
            default:
                break;
        }
    }
    return {
        images: images,
        urls: urls
    };
};



var $2rYkD = parcelRequire("2rYkD");

var $2nxul = parcelRequire("2nxul");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");

var $3Gcj3 = parcelRequire("3Gcj3");
const $02ee0b23a8a78333$var$interval = 45;
const $02ee0b23a8a78333$var$splitRegex = new RegExp(/<[^<>]+>/g);
const $02ee0b23a8a78333$var$TextBubble = ({ from: from, id: id, text: text, htmlText: htmlText, showWaitingDots: showWaitingDots, isWaitingDots: isWaitingDots, triggerScroll: triggerScroll, onEnded: onEnded, canBeEnded: canBeEnded, isEnded: isEnded })=>{
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    const [currentHtmlText, setCurrentHtmlText] = (0, $bxRTa.useState)('');
    const [ended, setEnded] = (0, $bxRTa.useState)(isEnded);
    const intervalRef = (0, $bxRTa.useRef)(null);
    const streamRef = (0, $bxRTa.useRef)([]);
    const streamIndexRef = (0, $bxRTa.useRef)(0);
    const canBeEndedRef = (0, $bxRTa.useRef)();
    (0, $bxRTa.useEffect)(()=>{
        setEnded(isEnded);
    }, [
        isEnded
    ]);
    (0, $bxRTa.useEffect)(()=>{
        canBeEndedRef.current = canBeEnded;
    }, [
        canBeEnded
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (htmlText) isEnded ? setEnded(true) : handleNewStreaming(htmlText);
        return ()=>{
            intervalRef.current && clearInterval(intervalRef.current);
        };
    }, [
        htmlText,
        ended
    ]);
    (0, $bxRTa.useEffect)(()=>{
        ended && endStreaming();
    }, [
        ended
    ]);
    const endStreaming = ()=>{
        setCurrentHtmlText(htmlText || '');
        onEnded?.();
        intervalRef.current && clearInterval(intervalRef.current);
    };
    const handleNewStreaming = (text)=>{
        streamRef.current = [];
        let test = false;
        while(test === false){
            const index = text.search($02ee0b23a8a78333$var$splitRegex);
            if (index === -1) {
                streamRef.current = [
                    ...streamRef.current,
                    ...Array.from(text)
                ];
                test = true;
            } else {
                const match = text.match($02ee0b23a8a78333$var$splitRegex);
                if (match?.length) {
                    const firstPart = index ? Array.from(text.slice(0, index)) : [];
                    streamRef.current = [
                        ...streamRef.current,
                        ...firstPart,
                        match[0]
                    ];
                    text = text.slice(firstPart.length + match[0].length);
                } else test = true;
            }
        }
        intervalRef.current = setInterval(()=>{
            if (streamIndexRef.current < streamRef.current.length) {
                const current = streamRef.current[streamIndexRef.current];
                setCurrentHtmlText((value)=>`${value}${current}`);
                streamIndexRef.current = streamIndexRef.current + 1;
                streamIndexRef.current % 20 === 0 && triggerScroll();
            } else canBeEndedRef.current && setEnded(true);
        }, $02ee0b23a8a78333$var$interval);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: from === (0, $2rYkD.TextFrom).user ? `retorik-userQuestion-${id}` : `retorik-botResponse-${id}`,
        dir: isRTL ? 'rtl' : 'ltr',
        className: `rf-w-fit ${from === (0, $2rYkD.TextFrom).user ? 'rf-min-h-fit' : 'rf-min-h-9 large-vertical:rf-min-h-10'} rf-px-4 rf-py-2 rf-max-w-[75%] landscape-retorik:rf-max-w-[calc((80%-10rem)*0.75)] large-vertical:rf-max-w-[45%] ${isMobile && 'rf-mx-4'} ${isRTL ? from === (0, $2rYkD.TextFrom).bot ? 'landscape-retorik:rf-mr-40 large-vertical:rf-mr-1/5 rf-self-end rf-text-textModePanelConversationBot rf-bg-textModePanelBackgroundBot rf-border rf-border-textModePanelBackgroundBot rf-rounded-tl-4' : 'landscape-retorik:rf-ml-1/5 large-vertical:rf-ml-1/5 rf-text-textModePanelConversationUser rf-bg-textModePanelBackgroundUser rf-border rf-border-textModePanelBackgroundUser rf-rounded-tr-4' : from === (0, $2rYkD.TextFrom).user ? 'landscape-retorik:rf-mr-40 large-vertical:rf-mr-1/5 rf-self-end rf-text-textModePanelConversationUser rf-bg-textModePanelBackgroundUser rf-border rf-border-textModePanelBackgroundUser rf-rounded-tl-4' : 'landscape-retorik:rf-ml-1/5 large-vertical:rf-ml-1/5 rf-text-textModePanelConversationBot rf-bg-textModePanelBackgroundBot rf-border rf-border-textModePanelBackgroundBot rf-rounded-tr-4'} rf-rounded-b-4 rf-animate-slideBottom rf-flex rf-flex-col rf-text-size-auto rf-shadow-[0_3px_6px_#00000029]`,
        children: isWaitingDots ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-w-8 rf-loader-bouncing-bot"
        }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
            children: [
                currentHtmlText ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: currentHtmlText
                    }
                }) : text ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    children: (0, $3Gcj3.getTextWithoutSpeechMarkdown)(text)
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
                showWaitingDots && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-font-bold rf-animate-blink",
                    children: "..."
                })
            ]
        })
    }, id);
};
var $02ee0b23a8a78333$export$2e2bcd8739ae039 = $02ee0b23a8a78333$var$TextBubble;


const $f776c70e79442292$var$DisplayStandard = ({ currentQuestionId: currentQuestionId, activities: activities, triggerScroll: triggerScroll, isWaitingForResponse: isWaitingForResponse })=>{
    const endedActivities = (0, $5FZWK.useSelector)((state)=>state.activityReducer.endedActivities);
    const watermark = (0, $5FZWK.useSelector)((state)=>state.activityReducer.watermark);
    const forceMobileView = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.forceMobileView);
    const [displayData, setDisplayData] = (0, $bxRTa.useState)([]);
    const [currentDisplayDataIndex, setCurrentDisplayDataIndex] = (0, $bxRTa.useState)(0);
    const [ended, setEnded] = (0, $bxRTa.useState)(!activities.length || endedActivities.includes(activities[activities.length - 1]?.id));
    (0, $bxRTa.useEffect)(()=>{
        setEnded(endedActivities.includes(activities[activities.length - 1]?.id));
        setDisplayData([]);
        setCurrentDisplayDataIndex(0);
    }, [
        currentQuestionId
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (isWaitingForResponse) {
            // Create temporary activity with the id of the next one to prevent re-renders, in order to display waiting dots
            const nextActivityId = `${currentQuestionId.slice(0, currentQuestionId.length - watermark.toString().length)}${watermark.toString()}`;
            const tempActivity = {
                id: nextActivityId,
                from: {
                    id: 'fake-bot-id',
                    role: 'bot'
                },
                type: 'message'
            };
            setDisplayData([
                {
                    activity: tempActivity,
                    type: (0, $2rYkD.DisplayDataTypes).text,
                    isWaitingDots: true,
                    canBeEnded: true,
                    isEnded: false
                }
            ]);
        }
    }, [
        isWaitingForResponse
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (activities.length) {
            let tempDisplayData = [];
            let currentFirstStreamingActivity;
            let streamingActivityHasAttachment = false;
            let streamingTexts = [];
            activities.forEach((activity, index)=>{
                const clonedActivity = structuredClone(activity);
                let splitTextDataToAdd = [];
                // Check the attachments, special case if this is the message activity after streaming : show attachments if the first streaming activity didn't have any
                let attachments = [];
                if (clonedActivity.attachments?.length) {
                    if (clonedActivity.name?.toLowerCase() === 'davi.streammessageactivity') {
                        streamingActivityHasAttachment = true;
                        attachments = [
                            {
                                type: (0, $2rYkD.DisplayDataTypes).attachment,
                                activity: clonedActivity,
                                canBeEnded: true,
                                isEnded: true
                            }
                        ];
                    } else if (!(clonedActivity.value?.streamingCount && streamingActivityHasAttachment) && !(0, $af3086b4a2d8da64$export$7c55936a30618336)(activity)) attachments = [
                        {
                            type: (0, $2rYkD.DisplayDataTypes).attachment,
                            activity: clonedActivity,
                            canBeEnded: true,
                            isEnded: true
                        }
                    ];
                }
                // Deal with streaming activity first, then other activities except the complete streaming message
                if (clonedActivity.name?.toLowerCase() === 'davi.streammessageactivity') {
                    // Set this streaming activity as first one if there is none
                    !currentFirstStreamingActivity && (currentFirstStreamingActivity = clonedActivity);
                    if (clonedActivity.text) {
                        streamingTexts.push(clonedActivity.text);
                        // If this is the last activity or if the next one isn't a streaming one, let's put the data in the array of data to display
                        if (index === activities.length - 1 || activities[index + 1].name?.toLowerCase() !== 'davi.streammessageactivity') splitTextDataToAdd = [
                            {
                                type: (0, $2rYkD.DisplayDataTypes).text,
                                activity: {
                                    ...currentFirstStreamingActivity,
                                    htmlText: (0, $4f72a156fc74e407$export$1b8fbc30fb87d9aa)(streamingTexts.join(''), false).htmlText
                                },
                                canBeEnded: false,
                                isEnded: false
                            }
                        ];
                    }
                } else if (clonedActivity.value?.streamingCount) {
                    if (tempDisplayData.length) {
                        const lastStreamingIndex = tempDisplayData.findLastIndex((d)=>d.type === (0, $2rYkD.DisplayDataTypes).text);
                        if (lastStreamingIndex !== -1) {
                            // Set canBeEnded for the previous streaming
                            tempDisplayData[lastStreamingIndex].canBeEnded = true;
                            // Set previous streaming ended if this activity is ended in speech synthesis
                            tempDisplayData[lastStreamingIndex].isEnded = endedActivities.includes(activity.id);
                        }
                    }
                    // Reset streaming data if the message containing all streaming data is received
                    currentFirstStreamingActivity = undefined;
                    streamingActivityHasAttachment = false;
                    streamingTexts = [];
                } else {
                    let text = clonedActivity.htmlText;
                    if (!text && clonedActivity.text) text = (0, $4f72a156fc74e407$export$1b8fbc30fb87d9aa)(clonedActivity.text, false).htmlText;
                    if (text) {
                        clonedActivity.htmlText = text;
                        splitTextDataToAdd = [
                            {
                                type: (0, $2rYkD.DisplayDataTypes).text,
                                activity: clonedActivity,
                                canBeEnded: true,
                                isEnded: endedActivities.includes(clonedActivity.id)
                            }
                        ];
                    }
                }
                if (attachments.length || splitTextDataToAdd.length) {
                    if (clonedActivity.messageType === 'welcome') tempDisplayData = [
                        ...tempDisplayData,
                        ...attachments,
                        ...splitTextDataToAdd
                    ];
                    else tempDisplayData = [
                        ...tempDisplayData,
                        ...splitTextDataToAdd,
                        ...attachments
                    ];
                }
            });
            setDisplayData(tempDisplayData);
        }
    }, [
        currentQuestionId,
        activities.length,
        endedActivities
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (displayData.length && currentDisplayDataIndex <= displayData.length && !ended) {
            if (currentDisplayDataIndex === displayData.length) setEnded(true);
            else if (displayData[currentDisplayDataIndex].type === (0, $2rYkD.DisplayDataTypes).attachment) {
                setCurrentDisplayDataIndex((current)=>current + 1);
                !ended && triggerScroll();
            }
        }
    }, [
        currentDisplayDataIndex,
        displayData,
        ended
    ]);
    const handleEnded = ()=>{
        setCurrentDisplayDataIndex((current)=>current + 1);
        !ended && triggerScroll();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: displayData.map((data, key)=>{
            if (key <= currentDisplayDataIndex || ended) {
                if (data.type === (0, $2rYkD.DisplayDataTypes).attachment) return data.activity.attachments?.length && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `${forceMobileView ? 'rf-m-auto' : 'rf-w-full'} ${data.activity.attachments.filter((att)=>att.contentType.includes('card')).length === 1 && 'mobile:rf-px-4'} rf-flex rf-flex-col vertical:rf-items-center rf-gap-2`,
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2nxul.default), {
                        activity: data.activity,
                        triggerScroll: triggerScroll
                    })
                }, `${data.activity.id}-${key}`);
                else if (data.type === (0, $2rYkD.DisplayDataTypes).text) return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $02ee0b23a8a78333$export$2e2bcd8739ae039), {
                    from: (0, $2rYkD.TextFrom).bot,
                    id: data.activity.id,
                    htmlText: data.activity.htmlText,
                    triggerScroll: triggerScroll,
                    onEnded: handleEnded,
                    canBeEnded: data.canBeEnded,
                    isEnded: data.isEnded,
                    isWaitingDots: data.isWaitingDots
                }, `${data.activity.id}-${key}`);
            }
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}, `${data.activity.id}-${key}`);
        })
    });
};
var $f776c70e79442292$export$2e2bcd8739ae039 = $f776c70e79442292$var$DisplayStandard;



var $2rYkD = parcelRequire("2rYkD");

const $94f2aceac6df6117$var$ConversationDisplay = ({ userQuestion: userQuestion, botResponses: botResponses, isMobile: isMobile, triggerScroll: triggerScroll, canBeStreaming: canBeStreaming })=>{
    const isLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isLandscape);
    const isWaitingForResponse = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.isWaitingForResponse);
    return isLandscape ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                id: `retorik-botResponses-${userQuestion?.id}`,
                className: "rf-flex rf-flex-col rf-text-size-auto rf-gap-4 rf-scrollbar-hidden",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f776c70e79442292$export$2e2bcd8739ae039), {
                    currentQuestionId: userQuestion?.id || 'fake-question-id',
                    triggerScroll: triggerScroll,
                    activities: botResponses || [],
                    isWaitingForResponse: isWaitingForResponse
                })
            }),
            userQuestion?.text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $02ee0b23a8a78333$export$2e2bcd8739ae039), {
                from: (0, $2rYkD.TextFrom).user,
                id: userQuestion.id,
                text: userQuestion.text,
                triggerScroll: triggerScroll,
                isEnded: true
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            userQuestion?.text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $02ee0b23a8a78333$export$2e2bcd8739ae039), {
                from: (0, $2rYkD.TextFrom).user,
                id: userQuestion.id,
                text: userQuestion.text,
                triggerScroll: triggerScroll,
                isEnded: true
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                id: `retorik-botResponses-${userQuestion?.id}`,
                className: "rf-flex rf-flex-col rf-text-size-auto rf-gap-4 rf-scrollbar-hidden",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f776c70e79442292$export$2e2bcd8739ae039), {
                    currentQuestionId: userQuestion?.id || 'fake-question-id',
                    triggerScroll: triggerScroll,
                    activities: botResponses || [],
                    isWaitingForResponse: isWaitingForResponse && (!isMobile || isMobile && canBeStreaming)
                })
            })
        ]
    });
};
var $94f2aceac6df6117$export$2e2bcd8739ae039 = $94f2aceac6df6117$var$ConversationDisplay;



var $gPs3v = parcelRequire("gPs3v");
const $c2e3409b981f8d9b$var$ConversationPanelMobile = ({ activities: activities, itemsInConversation: itemsInConversation })=>{
    const agentData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.agentData);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const isWidget = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isWidget);
    const listStatus = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.listStatus);
    const open = (0, $5FZWK.useSelector)((state)=>state.widgetReducer.open);
    const [opacityStyle, setOpacityStyle] = (0, $bxRTa.useState)('');
    const [scrollButtonDisplay, setScrollButtonDisplay] = (0, $bxRTa.useState)(false);
    const [scrollButtonDirection, setScrollButtonDirection] = (0, $bxRTa.useState)('bottom');
    const retorikConversationRef = (0, $bxRTa.useRef)(null);
    const botStartRef = (0, $bxRTa.useRef)(null);
    const botEndRef = (0, $bxRTa.useRef)(null);
    const timerRef = (0, $bxRTa.useRef)(null);
    const handleScroll = ()=>{
        if (retorikConversationRef.current) {
            const current = retorikConversationRef.current;
            if (current.scrollHeight > current.offsetHeight) {
                setScrollButtonDisplay(true);
                setScrollButtonDirection(current.scrollTop > -10 ? 'top' : 'bottom');
            }
            const percentage = Math.ceil((current.scrollHeight - current.clientHeight) / Math.abs(current.scrollTop));
            setOpacityStyle(`linear-gradient(to top, black ${100 - Math.min(percentage, 15)}%, transparent 100%)`);
        }
    };
    /**
   * Scroll to the botEndRef HTML element at the bottom of the view
   */ const scrollHandler = (to)=>{
        switch(to){
            case 'top':
                setScrollButtonDirection('bottom');
                botStartRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
                break;
            case 'bottom':
                setScrollButtonDirection('top');
                botEndRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
                break;
        }
        handleScroll();
    };
    (0, $bxRTa.useEffect)(()=>{
        timerRef.current && clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            scrollHandler('bottom');
        }, 100);
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [
        itemsInConversation,
        retorikConversationRef?.current?.scrollHeight
    ]);
    (0, $bxRTa.useLayoutEffect)(()=>{
        if (retorikConversationRef?.current) isWidget && (0, $k4qlo.default)(null, retorikConversationRef, undefined, true);
    });
    (0, $bxRTa.useEffect)(()=>{
        if (listStatus === (0, $2rYkD.ListStatus).closed && botEndRef.current) {
            timerRef.current && clearTimeout(timerRef.current);
            timerRef.current = setTimeout(()=>{
                scrollHandler('bottom');
            }, 100);
        }
    }, [
        listStatus
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $gPs3v.default), {
        target: (0, $2rYkD.TemplateTarget).mobileConversation,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $48dbcf3910a29a57$export$2e2bcd8739ae039), {
                agentName: agentData?.name,
                imageUrl: agentData?.portrait
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                id: "retorik-conversation",
                ref: retorikConversationRef,
                className: "rf-relative rf-h-full rf-max-h-full rf-overflow-y-scroll rf-overflow-x-hidden rf-scrollbar-thin rf-self-auto rf-mb-26 rf-justify-self-center rf-flex rf-flex-col-reverse rf-text-size-auto rf-text-trueblack rf-bg-truewhite rf-bg-opacity-80",
                style: {
                    WebkitMaskImage: currentDeviceType === (0, $2rYkD.DeviceType).mobile ? opacityStyle : undefined
                },
                onScroll: handleScroll,
                onWheel: handleScroll,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        ref: botEndRef
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hC8yR.default), {
                        direction: scrollButtonDirection,
                        display: scrollButtonDisplay && open,
                        scrollHandler: scrollHandler,
                        className: "rf-absolute rf-z-ui rf-bottom-8 rf-right-6 rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-h-max rf-w-full rf-py-4 rf-flex rf-flex-col rf-gap-3",
                        children: activities.map((activity, index)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $94f2aceac6df6117$export$2e2bcd8739ae039), {
                                userQuestion: activity.question,
                                botResponses: activity.answers,
                                isMobile: true,
                                triggerScroll: ()=>scrollHandler('bottom'),
                                canBeStreaming: index === activities.length - 1
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        ref: botStartRef
                    })
                ]
            })
        ]
    });
};
var $c2e3409b981f8d9b$export$2e2bcd8739ae039 = $c2e3409b981f8d9b$var$ConversationPanelMobile;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");

const $9b42b5f316fcc1ce$var$ConversationPanelLarge = ({ activities: activities, itemsInConversation: itemsInConversation })=>{
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const mediumLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.mediumLandscape);
    const isLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isLandscape);
    const [userQuestion, setUserQuestion] = (0, $bxRTa.useState)(undefined);
    const [botResponses, setBotResponses] = (0, $bxRTa.useState)([]);
    const retorikConversationRef = (0, $bxRTa.useRef)(null);
    const botEndRef = (0, $bxRTa.useRef)(null);
    const timerRef = (0, $bxRTa.useRef)(null);
    const isLandscapeRef = (0, $bxRTa.useRef)(true);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    const [opacityStyle, setOpacityStyle] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        setOpacityStyle(undefined);
    }, [
        activities?.length
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                isLandscapeRef.current = true;
                if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.landscape) {
                    const start = configuration.answerpanel.landscape.containerRowStartText;
                    const end = configuration.answerpanel.landscape.containerRowEndText;
                    if (start && start > 0 && start < 11) {
                        if (end && end < 11) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(11 - start);
                        }
                    } else if (end && end > 0 && end < 11) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(1);
                        setGridRowSpan(configuration.useOldRemote ? 10 : 9);
                    }
                } else {
                    setGridRowStart(1);
                    setGridRowSpan(configuration.useOldRemote ? 10 : 9);
                }
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                isLandscapeRef.current = false;
                if (typeof configuration.answerpanel === 'object' && configuration.answerpanel.borne) {
                    const start = configuration.answerpanel.borne.containerRowStart;
                    const end = configuration.answerpanel.borne.containerRowEnd;
                    if (start && start > 0 && start < 13) {
                        if (end && end < 13) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(13 - start);
                        }
                    } else if (end && end > 0 && end < 13) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(6);
                        setGridRowSpan(7);
                    }
                } else {
                    setGridRowStart(6);
                    setGridRowSpan(7);
                }
                break;
        }
    }, [
        currentDeviceType,
        configuration.answerpanel,
        configuration.useOldRemote
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (activities.length) {
            const lastActivity = activities[activities.length - 1];
            setUserQuestion(lastActivity.question);
            setBotResponses([
                ...lastActivity.answers
            ]);
        } else {
            setUserQuestion(undefined);
            setBotResponses([]);
        }
    }, [
        activities,
        itemsInConversation
    ]);
    const handleScroll = ()=>{
        botEndRef?.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
        handleScrollOpacity(false);
    };
    const handleScrollOpacity = (triggeredByUser)=>{
        if (retorikConversationRef.current) {
            const current = retorikConversationRef.current;
            if (current.scrollHeight > current.clientHeight + 5) {
                let percentage = 0;
                if (current.scrollTop || !triggeredByUser) {
                    percentage = Math.ceil((current.scrollHeight - current.clientHeight - Math.abs(current.scrollTop)) * 100 / current.scrollHeight);
                    !isLandscapeRef.current && (percentage = Math.max(25 - percentage, 0));
                    setOpacityStyle(`linear-gradient(to top, black ${100 - Math.min(percentage, 15)}%, transparent 100%)`);
                }
            } else setOpacityStyle('linear-gradient(to top, black 100%, transparent 100%)');
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        timerRef.current && clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            handleScroll();
        }, 100);
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [
        itemsInConversation
    ]);
    return userQuestion || botResponses ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-conversation",
        ref: retorikConversationRef,
        className: `rf-relative rf-w-full rf-max-h-full rf-z-util landscape-retorik:rf-pb-2 ${mediumLandscape ? 'landscape-retorik:rf-col-start-3' : 'landscape-retorik:rf-col-start-4'} vertical:rf-col-start-1 rf-col-end-9 rf-self-start rf-overflow-y-scroll rf-overflow-x-visible rf-scrollbar-hidden vertical:rf-overflow-x-auto rf-justify-self-center rf-flex rf-flex-col landscape-retorik:rf-flex-col-reverse landscape-retorik:rf-self-end rf-gap-4 rf-text-size-auto rf-text-trueblack`,
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`,
            WebkitMaskImage: opacityStyle
        },
        onScroll: ()=>handleScrollOpacity(true),
        children: [
            isLandscape && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                ref: botEndRef
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $94f2aceac6df6117$export$2e2bcd8739ae039), {
                userQuestion: userQuestion,
                botResponses: botResponses,
                triggerScroll: handleScroll,
                canBeStreaming: true
            }),
            !isLandscape && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                ref: botEndRef
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $9b42b5f316fcc1ce$export$2e2bcd8739ae039 = $9b42b5f316fcc1ce$var$ConversationPanelLarge;


const $6c93a27d7818cb69$var$ConversationPanel = ()=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const messageActivities = (0, $5FZWK.useSelector)((state)=>state.activityReducer.messageActivities);
    const streamingActivities = (0, $5FZWK.useSelector)((state)=>state.activityReducer.botStreamingActivities);
    const forceMobileView = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.forceMobileView);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const listStatus = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.listStatus);
    const [listActivity, setListActivity] = (0, $bxRTa.useState)(undefined);
    const [itemsInConversation, setItemsInConversation] = (0, $bxRTa.useState)(0);
    const getActivitiesTextMode = (activities, streamingActivities)=>{
        // processedId contains the ids of the activities already processed (because useActivities gives duplicate activities with different state depending on if it's been spoken or not )
        let processedId = [];
        let history = [];
        let tempItemsInConversation = 0;
        activities.forEach((activity)=>{
            if (activity.id && !processedId.includes(activity.id)) {
                processedId = [
                    ...processedId,
                    activity.id
                ];
                // Check if this is a question or an answer (questions from the user don't have a replyToId field)
                if (activity.replyToId) {
                    const question = history.find((historyItem)=>historyItem.question.id === activity.replyToId);
                    if (question) {
                        if (!question.answers.length || !question.answers.find((item)=>item.id === activity.id)) {
                            question.answers = [
                                ...question.answers,
                                activity
                            ];
                            tempItemsInConversation++;
                        }
                    } else {
                        const newQuestion = (0, $6hEoY.createNewQuestionForTimestamp)(activity);
                        history = [
                            ...history,
                            {
                                question: newQuestion,
                                answers: [
                                    activity
                                ]
                            }
                        ];
                        tempItemsInConversation++;
                    }
                } else // If the activity has a value, it is a need for further informations that don't need to be displayed
                if (!activity.value) {
                    // Hack for Bringup Message to be displayed as bot message
                    if (activity.label === 'Davi.BringupMessage' && activity.text) {
                        const newQuestion = (0, $6hEoY.createNewQuestionForTimestamp)(activity);
                        history = [
                            ...history,
                            {
                                question: newQuestion,
                                answers: [
                                    activity
                                ]
                            }
                        ];
                        tempItemsInConversation++;
                    } else {
                        const streamingAnswers = streamingActivities[activity.id];
                        history = [
                            ...history,
                            {
                                question: activity,
                                answers: streamingAnswers || []
                            }
                        ];
                        tempItemsInConversation += streamingAnswers?.length || 0;
                    }
                }
            }
        });
        setItemsInConversation(tempItemsInConversation);
        return history;
    };
    const activities = (0, $bxRTa.useMemo)(()=>{
        return getActivitiesTextMode(messageActivities, streamingActivities);
    }, [
        messageActivities,
        streamingActivities
    ]);
    /**
   * Check if there is an activity in need of List display in bot's answers.
   */ (0, $bxRTa.useEffect)(()=>{
        const answers = activities.length ? activities[activities.length - 1].answers : [];
        setListActivity(answers.find((activity)=>(0, $af3086b4a2d8da64$export$7c55936a30618336)(activity)));
    }, [
        itemsInConversation
    ]);
    (0, $bxRTa.useEffect)(()=>{
        listStatus === (0, $2rYkD.ListStatus).closed && setListActivity(undefined);
    }, [
        listStatus
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: listActivity && !(listStatus === (0, $2rYkD.ListStatus).closed) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9118c1ce1df56d35$export$2e2bcd8739ae039), {
            activity: listActivity,
            onClose: ()=>dispatch((0, $cto9a.storeActions).utils.setListStatus((0, $2rYkD.ListStatus).closed))
        }) : isMobile || forceMobileView ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c2e3409b981f8d9b$export$2e2bcd8739ae039), {
            activities: activities,
            itemsInConversation: itemsInConversation
        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9b42b5f316fcc1ce$export$2e2bcd8739ae039), {
            activities: activities,
            itemsInConversation: itemsInConversation
        })
    });
};
var $6c93a27d7818cb69$export$2e2bcd8739ae039 = $6c93a27d7818cb69$var$ConversationPanel;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $d9kWL = parcelRequire("d9kWL");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("9cEaH");
var $9UTGN = parcelRequire("9UTGN");

var $iLzAK = parcelRequire("iLzAK");

var $ijq12 = parcelRequire("ijq12");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("9cEaH");
var $3o2AQ = parcelRequire("3o2AQ");
var $91jIt = parcelRequire("91jIt");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $iqpLV = parcelRequire("iqpLV");
parcelRequire("dikAc");
var $9f9kU = parcelRequire("9f9kU");
var $jWbjz = parcelRequire("jWbjz");
const $8a85ad2f2c53ddfa$var$Mode = ()=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const disabledSpeechMode = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableSpeechMode);
    const disabledTextMode = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableTextMode);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const [fromTextToVocal, setFromTextToVocal] = (0, $bxRTa.useState)(false);
    const toggleMode = (newMode)=>{
        setFromTextToVocal(true);
        if (newMode === (0, $2rYkD.Mode).text) {
            dispatch((0, $cto9a.storeActions).retorik.setCanFocusSendBox(true));
            dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing));
        }
        dispatch((0, $cto9a.storeActions).speech.setMode(newMode));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-px-4 rf-grid rf-grid-cols-1 ${disabledSpeechMode ? 'rf-py-4' : disabledTextMode ? 'rf-pb-4' : 'rf-grid-rows-2'} rf-items-center`,
        children: [
            !disabledSpeechMode && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-flex rf-justify-center",
                children: mode === (0, $2rYkD.Mode).text ? /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                    className: "rf-w-full rf-aspect-square rf-flex rf-justify-center rf-items-center rf-border rf-border-menuBorder rf-rounded-half rf-shadow-[0_0_20px_1px_#A4A7AF80]",
                    onClick: ()=>toggleMode((0, $2rYkD.Mode).vocal),
                    "aria-label": "vocal mode",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jWbjz.default), {
                        className: "rf-h-5 rf-w-5 tactile:rf-h-6 tactile:rf-w-6",
                        color: "#A4A7AF"
                    })
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iqpLV.default), {
                    openMicrophone: fromTextToVocal
                })
            }),
            !disabledTextMode && /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-flex rf-justify-center rf-items-center",
                onClick: ()=>toggleMode((0, $2rYkD.Mode).text),
                "aria-label": "text mode",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9f9kU.default), {
                    className: "rf-h-5 rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6",
                    color: mode === (0, $2rYkD.Mode).text ? themeColors.secondary : '#A4A7AF'
                })
            })
        ]
    });
};
var $8a85ad2f2c53ddfa$export$2e2bcd8739ae039 = $8a85ad2f2c53ddfa$var$Mode;


const $a9267bcac2d3faec$var$Remote = ()=>{
    const disableSound = (0, $5FZWK.useSelector)((state)=>state.speechReducer.disableSound);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-framework-remote",
        className: "rf-relative rf-w-full rf-pt-3 rf-pb-4 rf-flex rf-flex-col rf-items-center rf-rounded-l-lg rf-shadow-[0_3px_6px_#606267]",
        style: {
            background: 'linear-gradient(#F8F8FC, #EDEEF3)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8a85ad2f2c53ddfa$export$2e2bcd8739ae039), {}),
            (!disableSound && mode === (0, $2rYkD.Mode).text || mode === (0, $2rYkD.Mode).vocal || isMobile) && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fl9nK.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-[90%] rf-mb-4 rf-border-b-2 rf-border-b-[#C4C5C8]"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-full rf-flex rf-flex-col rf-justify-center rf-gap-5 large-vertical:rf-gap-6",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $91jIt.default), {})
                    })
                ]
            }),
            configuration.languageChoiceBottom?.setUnderRemote && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3o2AQ.default), {})
        ]
    });
};
var $a9267bcac2d3faec$export$2e2bcd8739ae039 = $a9267bcac2d3faec$var$Remote;


const $963fb1bc599ff962$var$RemoteContainer = ({ hideMenu: hideMenu = false })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const top = (0, $d9kWL.default)();
    const menu = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.menu);
    const dashboardOpened = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.dashboardOpened);
    const isRTL = (0, $5FZWK.useSelector)((state)=>state.localeReducer.isRTL);
    /**
   * On call :
   *  - close subview if one is opened and if the parameter is false / undefined
   *  - toggle dashboardOpened state
   * @param doNotCloseViews : boolean
   */ const toggleDashboard = (doNotCloseViews)=>{
        !doNotCloseViews && dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).none));
        dispatch((0, $cto9a.storeActions).utils.setDashboardOpened(!dashboardOpened));
    };
    const handleClick = (e)=>{
        dispatch((0, $cto9a.storeActions).utils.setClickedOnUI((0, $2rYkD.UIPart).remote));
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-absolute rf-z-[19] rf-hidden large:rf-flex rf-flex-col rf-items-center rf-justify-start rf-w-24 rf-right-0 ${isRTL ? 'rf-text-arabic' : 'rf-text-xsm'} rf-text-trueblack`,
                style: {
                    top: top
                },
                onClick: (e)=>handleClick(e),
                children: [
                    !hideMenu && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ijq12.default), {
                        dashboardVisible: false,
                        onClick: ()=>toggleDashboard()
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a9267bcac2d3faec$export$2e2bcd8739ae039), {})
                ]
            }),
            dashboardOpened && (menu?.categories?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iLzAK.default), {
                toggleDashboard: ()=>toggleDashboard(true)
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9UTGN.default), {
                toggleDashboard: ()=>toggleDashboard(true)
            }))
        ]
    });
};
var $963fb1bc599ff962$export$2e2bcd8739ae039 = $963fb1bc599ff962$var$RemoteContainer;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $dq6kU = parcelRequire("dq6kU");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("dikAc");
var $6Nt3V = parcelRequire("6Nt3V");
var $9f9kU = parcelRequire("9f9kU");
var $jWbjz = parcelRequire("jWbjz");
const $462dbc90634eb69d$var$ModeButton = ({ label: label, selected: selected, onClick: onClick })=>{
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
        className: "rf-grid rf-w-full rf-h-12 rf-pb-4 rf-justify-center rf-items-end",
        onClick: ()=>onClick((0, $2rYkD.Mode)[label]),
        "aria-label": label,
        children: label === 'vocal' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jWbjz.default), {
            className: "rf-h-5",
            color: "#A4A7AF"
        }) : label === 'text' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9f9kU.default), {
            className: "rf-h-4",
            color: selected ? themeColors.secondary : '#A4A7AF'
        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6Nt3V.default), {
            className: "rf-h-[0.875rem]",
            color: selected ? themeColors.secondary : '#A4A7AF'
        })
    });
};
var $462dbc90634eb69d$export$2e2bcd8739ae039 = $462dbc90634eb69d$var$ModeButton;


parcelRequire("9cEaH");
var $iqpLV = parcelRequire("iqpLV");

const $b5cd57e79ee3959c$var$Mobile = ({ parametersOpened: parametersOpened, toggleParameters: toggleParameters })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const hideMenu = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.hideMenu);
    const disabledSpeechMode = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableSpeechMode);
    const disabledTextMode = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableTextMode);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const appAvailable = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.appAvailable);
    const [fromTextToVocal, setFromTextToVocal] = (0, $bxRTa.useState)(false);
    const toggleMode = (newMode)=>{
        // If the parameters are opened, no action
        if (!parametersOpened) {
            setFromTextToVocal(true);
            if (newMode === (0, $2rYkD.Mode).text) {
                dispatch((0, $cto9a.storeActions).retorik.setCanFocusSendBox(true));
                dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing));
            }
            dispatch((0, $cto9a.storeActions).speech.setMode(newMode));
        }
    };
    const handleDashboardClick = ()=>{
        toggleParameters();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-framework-menu",
        className: "rf-w-full rf-h-fit rf-max-h-80 rf-flex rf-flex-col-reverse rf-border-t rf-border-t-menuBorder rf-pointer-events-auto",
        style: {
            background: 'linear-gradient(to right, #F8F8FC, #EDEEF3)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-w-full rf-grid rf-flex-1 rf-h-full ${!(disabledSpeechMode || disabledTextMode) ? hideMenu ? 'rf-grid-cols-2' : 'rf-grid-cols-3' : hideMenu ? 'rf-grid-cols-1' : 'rf-grid-cols-2'} rf-min-h-12 rf-grid-rows-1 rf-justify-center rf-items-end`,
                children: [
                    !disabledTextMode && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $462dbc90634eb69d$export$2e2bcd8739ae039), {
                        label: "text",
                        selected: parametersOpened ? false : mode === (0, $2rYkD.Mode).text,
                        onClick: toggleMode
                    }),
                    !disabledSpeechMode && (mode === (0, $2rYkD.Mode).vocal ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-py-2 rf-w-full rf-flex rf-justify-center",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iqpLV.default), {
                            openMicrophone: fromTextToVocal
                        })
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $462dbc90634eb69d$export$2e2bcd8739ae039), {
                        label: "vocal",
                        selected: false,
                        onClick: toggleMode
                    })),
                    !hideMenu && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $462dbc90634eb69d$export$2e2bcd8739ae039), {
                        label: "dashboard",
                        selected: parametersOpened,
                        onClick: handleDashboardClick
                    })
                ]
            }),
            !parametersOpened && mode === (0, $2rYkD.Mode).text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dq6kU.default), {
                className: "rf-mx-4 rf-mt-2"
            }),
            appAvailable && !parametersOpened && mode === (0, $2rYkD.Mode).vocal && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a174d1df6657d370$export$2e2bcd8739ae039), {
                className: "rf-w-full rf-px-6 rf-py-2"
            })
        ]
    });
};
var $b5cd57e79ee3959c$export$2e2bcd8739ae039 = $b5cd57e79ee3959c$var$Mobile;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $eO5xw = parcelRequire("eO5xw");

var $k4qlo = parcelRequire("k4qlo");

var $9UTGN = parcelRequire("9UTGN");

var $91jIt = parcelRequire("91jIt");

var $lRvrG = parcelRequire("lRvrG");

var $3KYvq = parcelRequire("3KYvq");

var $gPs3v = parcelRequire("gPs3v");

var $2rYkD = parcelRequire("2rYkD");
const $cd5ef32a1d0fa8fd$var$ParametersAndDashboardContainer = ({ handleBack: handleBack, hideMenu: hideMenu = false })=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const menu = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.menu);
    const isWidget = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isWidget);
    const divRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        divRef?.current && isWidget && (0, $k4qlo.default)(null, divRef);
    }, [
        divRef.current
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $gPs3v.default), {
        onClick: handleBack,
        target: (0, $2rYkD.TemplateTarget).mobileOther,
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
            ref: divRef,
            className: "rf-w-full rf-flex-rf-flex-col rf-overflow-y-scroll rf-scrollbar-hidden rf-pointer-events-auto",
            children: [
                !hideMenu && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: [
                        menu?.categories?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3KYvq.default), {
                            toggleDashboard: handleBack
                        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9UTGN.default), {
                            toggleDashboard: handleBack
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-h-6 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                    className: "rf-w-full rf-px-5 rf-flex rf-flex-col rf-justify-start",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-py-4 rf-text-lightgray",
                            children: (0, $eO5xw.capitalizeFirstLetter)(translation.common.parameters, locale)
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $91jIt.default), {
                            handleBack: handleBack
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lRvrG.default), {
                    isMobile: true
                })
            ]
        })
    });
};
var $cd5ef32a1d0fa8fd$export$2e2bcd8739ae039 = $cd5ef32a1d0fa8fd$var$ParametersAndDashboardContainer;


const $3f3d8b62c2ca95da$var$MobileContainer = ({ hideMenu: hideMenu })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const dashboardOpened = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.dashboardOpened);
    const toggleParameters = ()=>{
        dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).none));
        dispatch((0, $cto9a.storeActions).utils.setDashboardOpened(!dashboardOpened));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                id: "retorik-framework-mobile-menu-container",
                className: "rf-absolute rf-bottom-0 rf-w-full rf-h-fit rf-flex rf-flex-col-reverse rf-z-[4] rf-bg-transparent",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b5cd57e79ee3959c$export$2e2bcd8739ae039), {
                    parametersOpened: dashboardOpened,
                    toggleParameters: toggleParameters
                })
            }),
            dashboardOpened && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cd5ef32a1d0fa8fd$export$2e2bcd8739ae039), {
                handleBack: toggleParameters,
                hideMenu: hideMenu
            })
        ]
    });
};
var $3f3d8b62c2ca95da$export$2e2bcd8739ae039 = $3f3d8b62c2ca95da$var$MobileContainer;


parcelRequire("9cEaH");
var $3o2AQ = parcelRequire("3o2AQ");
const $39b448c04b4eb972$var$MenuDisplayer = ({ hideMenu: hideMenu })=>{
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const displayControls = (0, $5FZWK.useSelector)((state)=>state.viewReducer.displayControls);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    return !displayControls ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3f3d8b62c2ca95da$export$2e2bcd8739ae039), {
        hideMenu: !!hideMenu
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $963fb1bc599ff962$export$2e2bcd8739ae039), {
                hideMenu: !!hideMenu
            }),
            !configuration.languageChoiceBottom?.setUnderRemote && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3o2AQ.default), {})
        ]
    });
};
var $39b448c04b4eb972$export$2e2bcd8739ae039 = $39b448c04b4eb972$var$MenuDisplayer;



var $3i7uv = parcelRequire("3i7uv");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $c8bd85879b11a2bb$var$ExtendIcon = ({ className: className, color: color, extended: extended })=>{
    if (extended) return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20.018",
        height: "19.382",
        viewBox: "0 0 20.018 19.382",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
            id: "Groupe_841",
            "data-name": "Groupe 841",
            transform: "translate(3.415 3.891)",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                id: "PICTO",
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    id: "Groupe_845",
                    "data-name": "Groupe 845",
                    transform: "translate(0.003 -1)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                            id: "Groupe_843",
                            "data-name": "Groupe 843",
                            transform: "translate(3.99 21.134) rotate(180)",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_15",
                                    "data-name": "Ligne 15",
                                    y2: "5.046",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_16",
                                    "data-name": "Ligne 16",
                                    x1: "5.04",
                                    transform: "translate(0 12.077)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_17",
                                    "data-name": "Ligne 17",
                                    x2: "0.004",
                                    y2: "8.475",
                                    transform: "translate(5.99 6.057) rotate(45)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                            id: "Groupe_844",
                            "data-name": "Groupe 844",
                            transform: "translate(9.162 -7.493)",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_15-2",
                                    "data-name": "Ligne 15",
                                    y2: "5.002",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_16-2",
                                    "data-name": "Ligne 16",
                                    x1: "5.067",
                                    transform: "translate(0 12.033)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_17-2",
                                    "data-name": "Ligne 17",
                                    x1: "0.046",
                                    y2: "8.463",
                                    transform: "translate(5.984 6.024) rotate(45)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
    else // return (
    //   <svg
    //     xmlns='http://www.w3.org/2000/svg'
    //     className={className || 'rf-h-6 rf-w-6'}
    //     fill='none'
    //     viewBox='0 0 24 24'
    //     stroke={color || 'currentColor'}
    //     strokeWidth={2}
    //   >
    //     <path
    //       strokeLinecap='round'
    //       strokeLinejoin='round'
    //       d='M6 18L18 6M6 6l12 12'
    //     />
    //   </svg>
    // )
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20.018",
        height: "19.358",
        viewBox: "0 0 20.018 19.358",
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
            id: "Groupe_841",
            "data-name": "Groupe 841",
            transform: "translate(3.415 3.891)",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                id: "PICTO",
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    id: "Groupe_845",
                    "data-name": "Groupe 845",
                    transform: "translate(0.003 -1)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                            id: "Groupe_843",
                            "data-name": "Groupe 843",
                            transform: "translate(-2 3)",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_15",
                                    "data-name": "Ligne 15",
                                    y2: "5.046",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_16",
                                    "data-name": "Ligne 16",
                                    x1: "5.04",
                                    transform: "translate(0 12.077)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_17",
                                    "data-name": "Ligne 17",
                                    x2: "0.004",
                                    y2: "8.475",
                                    transform: "translate(5.99 6.057) rotate(45)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                            id: "Groupe_844",
                            "data-name": "Groupe 844",
                            transform: "translate(15.178 10.572) rotate(180)",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_15-2",
                                    "data-name": "Ligne 15",
                                    y2: "5.002",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_16-2",
                                    "data-name": "Ligne 16",
                                    x1: "5.067",
                                    transform: "translate(0 12.033)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_17-2",
                                    "data-name": "Ligne 17",
                                    x1: "0.046",
                                    y2: "8.463",
                                    transform: "translate(5.984 6.024) rotate(45)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $c8bd85879b11a2bb$export$2e2bcd8739ae039 = $c8bd85879b11a2bb$var$ExtendIcon;



var $6Iy5P = parcelRequire("6Iy5P");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
parcelRequire("2l6WH");
var $jGi9r = parcelRequire("jGi9r");
const $66c859ffbbdeefa1$var$PositionModal = ()=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-max-w-[500px] rf-px-8 rf-py-8 rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4 rf-text-size-auto",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jGi9r.default), {
                className: "rf-h-10",
                color: "#FFF"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-font-light",
                children: translation.position.rejected
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-text-center",
                children: translation.position.instructions
            })
        ]
    });
};
var $66c859ffbbdeefa1$export$2e2bcd8739ae039 = $66c859ffbbdeefa1$var$PositionModal;


const $c7c960ecf27193cd$var$HomeView = ({ externalComponents: externalComponents })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const currentLayout = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.currentLayout);
    const loaderClosed = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.loaderClosed);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const showPositionModal = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.showPositionModal);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const configurations = (0, $5FZWK.useSelector)((state)=>state.viewReducer.configurations);
    const displayData = (0, $bxRTa.useMemo)(()=>{
        return configurations.views.home;
    }, [
        configurations
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).view.setDisplayControls(!configuration.hideControls));
    }, []);
    const extendButtonHandler = ()=>{
        dispatch((0, $cto9a.storeActions).retorik.setLayout((0, $2rYkD.ContainerParent).widget));
        dispatch((0, $cto9a.storeActions).widget.openWidget());
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            !!configuration.allowSwitchLayout && currentLayout !== (0, $2rYkD.ContainerParent).widget && (currentDeviceType === (0, $2rYkD.DeviceType).widgetLandscape || currentDeviceType === (0, $2rYkD.DeviceType).widgetBorne) && /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                onClick: extendButtonHandler,
                "aria-label": "Minimize",
                className: "rf-absolute rf-z-exitwidget rf-flex rf-top-1 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg rf-right-10",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c8bd85879b11a2bb$export$2e2bcd8739ae039), {
                    className: "rf-h-4 rf-w-4",
                    color: "#000000",
                    extended: true
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $VZzOq.default), {
                config: displayData.background
            }),
            configuration?.logo && (!isMobile || isMobile && mode !== (0, $2rYkD.Mode).text) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $h0yA8.default), {}),
            configuration?.answerpanel !== false && loaderClosed && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    !isMobile && (configuration.useOldRemote ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $515c6bb01607ffda$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5377bf2433391660$export$2e2bcd8739ae039), {})),
                    mode === (0, $2rYkD.Mode).vocal ? configuration.useOldRemote ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $93405e9c3a3a1a91$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6fe7ed64ef75b076$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6c93a27d7818cb69$export$2e2bcd8739ae039), {})
                ]
            }),
            configuration.useOldRemote ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $39b448c04b4eb972$export$2e2bcd8739ae039), {
                hideMenu: configuration?.hideMenu
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3i7uv.default), {
                hideMenu: configuration?.hideMenu
            }),
            loaderClosed && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2ddb2b8c38f184e3$export$2e2bcd8739ae039), {
                externalComponents: externalComponents
            }),
            !configuration?.hideRetorikLogo && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6ebf4aa8111d9d5f$export$2e2bcd8739ae039), {}),
            !(configuration.position?.latitude && configuration.position?.longitude) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6Iy5P.default), {
                isOpened: showPositionModal,
                onClose: ()=>dispatch((0, $cto9a.storeActions).retorik.setShowPositionModal(false)),
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $66c859ffbbdeefa1$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $c7c960ecf27193cd$export$2e2bcd8739ae039 = $c7c960ecf27193cd$var$HomeView;



var $fnPQZ = parcelRequire("fnPQZ");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $fnPQZ = parcelRequire("fnPQZ");
parcelRequire("9cEaH");
var $4kqtJ = parcelRequire("4kqtJ");
const $6289eff125003845$var$WarningBeforeNewsView = ()=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const [waiting, setWaiting] = (0, $bxRTa.useState)(true);
    const handleClick = (goHome)=>{
        dispatch((0, $cto9a.storeActions).directline.sendEvent({
            name: 'Davi.CloseWindow',
            callback: ()=>dispatch((0, $cto9a.storeActions).directline.sendEvent({
                    name: 'Davi.CloseWindowNewsSoundActivated'
                }))
        }));
        goHome ? dispatch((0, $cto9a.storeActions).view.setRoute((0, $2rYkD.Routes).Home)) : setWaiting(false);
    };
    return waiting ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-relative rf-z-util rf-col-start-1 rf-col-span-full rf-row-start-1 rf-row-span-full rf-flex rf-flex-col rf-gap-4 rf-justify-center rf-items-center rf-bg-truewhite",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4kqtJ.default), {
                title: translation.common.back,
                handleBack: ()=>handleClick(true),
                className: "rf-absolute rf-top-4 rf-left-4 rf-text-size-auto"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-px-4 rf-text-center",
                children: translation.news.warningtext
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-card-button-secondary",
                onClick: ()=>handleClick(false),
                children: translation.common.continue
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-card-button-secondary",
                onClick: ()=>handleClick(true),
                children: translation.common.back
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fnPQZ.default), {});
};
var $6289eff125003845$export$2e2bcd8739ae039 = $6289eff125003845$var$WarningBeforeNewsView;


const $8d8907b91df6feae$var$RetorikRouter = (props)=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isUsedOnBorne = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.isUsedOnBorne);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const route = (0, $5FZWK.useSelector)((state)=>state.viewReducer.route);
    const lastBotEvent = (0, $5FZWK.useSelector)((state)=>state.activityReducer.lastBotEventActivity);
    (0, $bxRTa.useEffect)(()=>{
        if (lastBotEvent) switch(lastBotEvent.name){
            case 'news.ShowFlashInfo':
                dispatch((0, $cto9a.storeActions).view.setRoute((0, $2rYkD.Routes).News));
                break;
            case 'weather.ShowWeather':
                dispatch((0, $cto9a.storeActions).utils.setCurrentSubView((0, $2rYkD.CurrentSubView).weather));
                break;
            default:
                break;
        }
    }, [
        lastBotEvent
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            route === (0, $2rYkD.Routes).Home ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c7c960ecf27193cd$export$2e2bcd8739ae039), {
                ...props
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
            route === (0, $2rYkD.Routes).News ? mode === (0, $2rYkD.Mode).vocal || !!isUsedOnBorne ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fnPQZ.default), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6289eff125003845$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {})
        ]
    });
};
var $8d8907b91df6feae$export$2e2bcd8739ae039 = $8d8907b91df6feae$var$RetorikRouter;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $clSD3 = parcelRequire("clSD3");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $lOuaH = parcelRequire("lOuaH");


var $2rYkD = parcelRequire("2rYkD");

var $kdMEA = parcelRequire("kdMEA");

var $k4qlo = parcelRequire("k4qlo");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");
const $a068197de55406c8$var$ModalFullscreen = ()=>{
    const content = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.modalFullscreenContent);
    const handleClick = (event)=>{
        event?.stopPropagation();
    };
    return content ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-absolute rf-z-modal rf-h-full rf-w-full rf-flex rf-flex-col rf-justify-center rf-items-center",
        style: {
            background: 'rgba(18,18,18,0.7)'
        },
        onClick: (event)=>handleClick(event),
        children: content
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $a068197de55406c8$export$2e2bcd8739ae039 = $a068197de55406c8$var$ModalFullscreen;


const $44d007e76c69eba2$var$Container = ({ fullSize: fullSize, width: width, height: height, children: children, parent: parent })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const isTactile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isTactile);
    const doNotDetectDeviceFromUserAgent = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.doNotDetectDeviceFromUserAgent);
    const forceMobileView = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.forceMobileView);
    const container = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(container);
    const [portrait, setPortrait] = (0, $bxRTa.useState)('');
    const [large, setLarge] = (0, $bxRTa.useState)('');
    const [mobile, setMobile] = (0, $bxRTa.useState)('');
    const [tablet, setTablet] = (0, $bxRTa.useState)('');
    // Call useCurrentPagination to update data sent to store. Do not remove
    const pagination = (0, $b6c73313d6353629$export$2e2bcd8739ae039)();
    const widthStyle = (0, $bxRTa.useMemo)(()=>{
        if (typeof width === 'number') return {
            width: `${width}px`
        };
        else if (typeof width === 'string') return {
            width: width === 'full' ? '100%' : width
        };
        return {};
    }, [
        width
    ]);
    const heightStyle = (0, $bxRTa.useMemo)(()=>{
        if (currentDeviceType === (0, $2rYkD.DeviceType).mobile) return {
            height: window.innerHeight,
            minHeight: window.innerHeight,
            maxHeight: window.innerHeight
        };
        else if (typeof height === 'number') return {
            height: `${height}px`
        };
        else if (typeof height === 'string') return height === 'full' ? {
            height: '100%',
            flexGrow: 1
        } : {
            height: height
        };
        return {};
    }, [
        height,
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).directline.setPaginationToSend(pagination));
    }, [
        pagination
    ]);
    const checkPortrait = (width, height)=>{
        return !!(width && height && width < height);
    };
    /**
   * On dimensions change :
   *  - check and set the classes in the main div that will allow us to use tailwind variants
   *  - set the main div dimensions in context
   */ (0, $bxRTa.useEffect)(()=>{
        if (forceMobileView) dispatch((0, $cto9a.storeActions).view.setCurrentDeviceType((0, $2rYkD.DeviceType).mobile));
        else if (dimensions?.width && dimensions?.height) {
            // If we don't want to use the userAgent to get the device type
            if (doNotDetectDeviceFromUserAgent) {
                const isPortrait = checkPortrait(dimensions.width, dimensions.height);
                if (isPortrait) {
                    if (dimensions.width > (0, $kdMEA.mobileBreakpoint)) dispatch((0, $cto9a.storeActions).view.setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widgetBorne : (0, $2rYkD.DeviceType).borne));
                    else dispatch((0, $cto9a.storeActions).view.setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widget : (0, $2rYkD.DeviceType).mobile));
                } else if (dimensions.height > (0, $kdMEA.mobileBreakpoint)) dispatch((0, $cto9a.storeActions).view.setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widgetLandscape : (0, $2rYkD.DeviceType).landscape));
                else dispatch((0, $cto9a.storeActions).view.setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widget : (0, $2rYkD.DeviceType).mobile));
            } else if (0, $clSD3.isMobile) dispatch((0, $cto9a.storeActions).view.setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widget : (0, $2rYkD.DeviceType).mobile));
            else {
                const isPortrait = checkPortrait(dimensions.width, dimensions.height);
                if (isPortrait) dispatch((0, $cto9a.storeActions).view.setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? dimensions.width > (0, $kdMEA.mobileBreakpoint) ? (0, $2rYkD.DeviceType).widgetBorne : (0, $2rYkD.DeviceType).widget : (0, $2rYkD.DeviceType).borne));
                else dispatch((0, $cto9a.storeActions).view.setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widgetLandscape : (0, $2rYkD.DeviceType).landscape));
            }
        }
        dimensions?.height && dispatch((0, $cto9a.storeActions).view.setCurrentHeight(dimensions.height));
        dimensions?.width && dispatch((0, $cto9a.storeActions).view.setCurrentWidth(dimensions.width));
        setTablet(dimensions.height < (0, $kdMEA.mediumBreakpoint) && dimensions.width < (0, $kdMEA.mediumBreakpoint) ? 'rf-tablet' : '');
    }, [
        dimensions
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                setPortrait('rf-portrait');
                setLarge('');
                setMobile('rf-mobile');
                setTablet('');
                break;
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                setPortrait('');
                setLarge('rf-large');
                setMobile('');
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                setPortrait('rf-portrait');
                setLarge('rf-large');
                setMobile('');
                break;
        }
    }, [
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        container?.current && (0, $kdMEA.widgetDisplays).includes(currentDeviceType) && (0, $k4qlo.default)(container.current);
    }, [
        container.current
    ]);
    const customColors = (0, $bxRTa.useMemo)(()=>{
        return themeColors ? {
            '--rf-color-primary': themeColors.primary,
            '--rf-color-secondary': themeColors.secondary,
            '--rf-color-black': themeColors.black,
            '--rf-color-whereToEatColor': themeColors.whereToEatColor,
            '--rf-color-whereToSleepColor': themeColors.whereToSleepColor,
            '--rf-color-tobeSeenColor': themeColors.tobeSeenColor,
            '--rf-color-tobeDoneColor': themeColors.tobeDoneColor,
            '--rf-color-localProductsColor': themeColors.localProductsColor,
            '--rf-color-servicesColor': themeColors.servicesColor,
            '--rf-color-cardFrameBackground': themeColors.card?.frame?.background,
            '--rf-color-cardFrameBorder': themeColors.card?.frame?.border,
            '--rf-color-cardFrameText': themeColors.card?.frame?.text,
            '--rf-color-cardButtonBackgroundDefault': themeColors.card?.button?.background?.default,
            '--rf-color-cardButtonBackgroundHover': themeColors.card?.button?.background?.hover,
            '--rf-color-cardButtonBorderDefault': themeColors.card?.button?.border?.default,
            '--rf-color-cardButtonBorderHover': themeColors.card?.button?.border?.hover,
            '--rf-color-cardButtonTextDefault': themeColors.card?.button?.text?.default,
            '--rf-color-cardButtonTextHover': themeColors.card?.button?.text?.hover,
            '--rf-color-cardButtonDiscoverBackgroundDefault': themeColors.card?.discoverButton?.background?.default,
            '--rf-color-cardButtonDiscoverBackgroundHover': themeColors.card?.discoverButton?.background?.hover,
            '--rf-color-cardButtonDiscoverBorderDefault': themeColors.card?.discoverButton?.border?.default,
            '--rf-color-cardButtonDiscoverBorderHover': themeColors.card?.discoverButton?.border?.hover,
            '--rf-color-cardButtonDiscoverTextDefault': themeColors.card?.discoverButton?.text?.default,
            '--rf-color-cardButtonDiscoverTextHover': themeColors.card?.discoverButton?.text?.hover,
            '--rf-color-textModePanelBackground': themeColors.textMode?.panel?.background,
            '--rf-color-textModePanelBorder': themeColors.textMode?.panel?.border,
            '--rf-color-textModePanelBackgroundUser': themeColors.textMode?.panel?.backgroundUser,
            '--rf-color-textModePanelBackgroundBot': themeColors.textMode?.panel?.backgroundBot,
            '--rf-color-textModePanelConversationUser': themeColors.textMode?.panel?.conversationUser,
            '--rf-color-textModePanelConversationBot': themeColors.textMode?.panel?.conversationBot,
            '--rf-color-vocalModeSubtitlesText': themeColors.vocalMode?.subtitles?.text,
            '--rf-color-vocalModeSubtitlesBackground': themeColors.vocalMode?.subtitles?.background,
            '--rf-color-formInputTextDefault': themeColors.formInput?.text?.default,
            '--rf-color-formInputTextHover': themeColors.formInput?.text?.hover,
            '--rf-color-formInputRadioCheckboxUncheckedBackground': themeColors.formInput?.inputRadioCheckbox?.unchecked?.background,
            '--rf-color-formInputRadioCheckboxUncheckedBorder': themeColors.formInput?.inputRadioCheckbox?.unchecked?.border,
            '--rf-color-formInputRadioCheckboxCheckedBackground': themeColors.formInput?.inputRadioCheckbox?.checked?.background,
            '--rf-color-formInputRadioCheckboxCheckedBorder': themeColors.formInput?.inputRadioCheckbox?.checked?.border,
            '--rf-color-formInputRadioCheckboxCheckedItem': themeColors.formInput?.inputRadioCheckbox?.checked?.item,
            '--rf-color-formInputButtonBackgroundDefault': themeColors.formInput?.inputButton?.background?.default,
            '--rf-color-formInputButtonBackgroundHover': themeColors.formInput?.inputButton?.background?.hover,
            '--rf-color-formInputButtonBorderDefault': themeColors.formInput?.inputButton?.border?.default,
            '--rf-color-formInputButtonBorderHover': themeColors.formInput?.inputButton?.border?.hover,
            '--rf-color-formInputButtonTextDefault': themeColors.formInput?.inputButton?.text?.default,
            '--rf-color-formInputButtonTextHover': themeColors.formInput?.inputButton?.text?.hover
        } : {};
    }, [
        themeColors
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-container",
        ref: container,
        tabIndex: -1,
        className: `rf-relative ${fullSize ? 'rf-w-screen rf-h-screen' : 'rf-w-full rf-h-full'} rf-max-w-screen rf-max-h-screen rf-grid rf-grid-cols-8 rf-grid-rows-container rf-bg-transparent rf-text-trueblack rf-font-default ${portrait} ${large} ${mobile} ${tablet} ${isTactile && 'rf-tactile'} rf-overflow-hidden rf-animate-loaderFadeIn`,
        style: {
            ...widthStyle,
            ...heightStyle,
            ...customColors
        },
        onClick: ()=>dispatch((0, $cto9a.storeActions).utils.setClickedOnUI((0, $2rYkD.UIPart).background)),
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a068197de55406c8$export$2e2bcd8739ae039), {}),
            children
        ]
    });
};
var $44d007e76c69eba2$export$2e2bcd8739ae039 = $44d007e76c69eba2$var$Container;



var $fnPQZ = parcelRequire("fnPQZ");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $lo8xw = parcelRequire("lo8xw");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");
const $2f9f46fd962caacf$export$a2ce4fdd6972d6a7 = async (region, key)=>{
    const tokenRes = await fetch(`https://${region}.api.cognitive.microsoft.com/sts/v1.0/issueToken`, {
        method: 'POST',
        headers: {
            'Ocp-Apim-Subscription-Key': key
        }
    }).then((value)=>{
        return value.text();
    }).catch((error)=>{
        console.log('Error : ', error);
        return undefined;
    });
    return tokenRes;
};


const $57f41e573dafcd6e$export$4bf371fc4fa74a28 = (voices, locale, customVoice, agentData)=>{
    let voice = null;
    // Check if a custom voice is defined in the props
    if (customVoice) {
        if (customVoice.voice) {
            // Search voice with its full name (ex: AriaNeural, GuyNeural)
            const neuralVoice = new RegExp(customVoice.voice, 'iu');
            voice = voices.find(({ name: name })=>neuralVoice.test(name) || name === customVoice.voice);
        } else if (customVoice.gender) // Search voice depending on given gender and locale
        voice = voices.find(({ gender: gender, lang: lang })=>{
            return gender.toLowerCase() === customVoice?.gender?.toLowerCase() && lang === locale;
        });
    }
    // Get voice depending on locale and gender
    if (!voice) voice = voices.find(({ gender: gender, lang: lang })=>{
        return gender.toLowerCase() === (agentData?.gender?.toLowerCase() || 'female') && lang === locale;
    });
    // No voice found, fall back to US default voices : female => Aria / male => Guy
    if (!voice) {
        const genderedVoice = agentData?.gender?.toLowerCase() === 'female' ? 'AriaNeural' : 'GuyNeural';
        const neuralVoice = new RegExp(genderedVoice, 'iu');
        voice = voices.find(({ name: name })=>neuralVoice.test(name));
    }
    return voice;
};



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");


var $2rYkD = parcelRequire("2rYkD");


var $fb1tF = parcelRequire("fb1tF");

var $lo8xw = parcelRequire("lo8xw");
const $32267c4f7fbd2605$var$buildSSML = (activity, locale, speechMarkdownParser, sayAsWords)=>{
    let speech = activity.speak || activity.text;
    // Replace character not recognized in Microsoft TTS
    speech = speech.replaceAll("\u2019", "'");
    let textParsedAsSSML = '';
    try {
        if (sayAsWords?.length) {
            const wordsUsed = [];
            sayAsWords.forEach((tuple)=>{
                if (!wordsUsed.includes(tuple.text.toLocaleLowerCase(locale))) {
                    const regex = new RegExp(`\\b${tuple.text}\\b`, 'gi');
                    speech = speech.replaceAll(regex, `(${tuple.text})[ipa:"${tuple.ipa}"]`);
                    wordsUsed.push(tuple.text.toLocaleLowerCase(locale));
                }
            });
        }
        textParsedAsSSML = speechMarkdownParser.toSSML(speech);
    } catch (e) {
        console.warn('Retorik Framework > error in speechmarkdown parser : ', e);
    }
    return `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="https://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" xml:lang="${locale}">` + textParsedAsSSML + '</speak>';
};
const $32267c4f7fbd2605$var$createUtterance = ({ activity: activity, voice: voice, locale: locale, sayAsWords: sayAsWords })=>{
    // If there is no text to be read, create an empty utterance that will be put in the array of ended activities
    if (!voice || !activity.speak && !activity.text) return new (0, $lo8xw.SpeechSynthesisUtterance)('');
    return new (0, $lo8xw.SpeechSynthesisUtterance)($32267c4f7fbd2605$var$buildSSML(activity, locale, new (0, $fb1tF.SpeechMarkdown)({
        platform: 'microsoft-azure',
        includeSpeakTag: false,
        globalVoiceAndLang: {
            voice: voice.name,
            lang: voice.name.toLowerCase().includes('multilingual') ? locale : undefined
        }
    }), sayAsWords));
};
var $32267c4f7fbd2605$export$2e2bcd8739ae039 = $32267c4f7fbd2605$var$createUtterance;


/**
 * Check if there are some replacement codes for this language, to improve speech synthesis, and then create the utterance
 * @param {CreateUtteranceParams} params - data needed to create an utterance
 * @param {SayAs} sayAs - string that should be replaced by their ipa codes
 * @returns {SpeechSynthesisUtterance}
 */ const $2161e8fb47c6c1a6$export$f969af62bba9a48b = (params, sayAs)=>{
    let sayAsWords = [];
    if (sayAs) {
        sayAs.common?.length && (sayAsWords = [
            ...sayAs.common
        ]);
        sayAs.localized && sayAs.localized[params.locale]?.length && (sayAsWords = [
            ...sayAsWords,
            ...sayAs.localized[params.locale]
        ]);
    }
    return (0, $32267c4f7fbd2605$export$2e2bcd8739ae039)({
        ...params,
        sayAsWords: sayAsWords
    });
};



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $kdMEA = parcelRequire("kdMEA");
const $d1984bac2dac280a$export$52a3c04e084af2a0 = {
    onesecond: `${(0, $kdMEA.CDNAudioAddress)}/onesecond.mp3`,
    speechrecognition: `${(0, $kdMEA.CDNAudioAddress)}/blip.mp3`,
    microphoneopen: `${(0, $kdMEA.CDNAudioAddress)}/microphone-open.mp3`,
    microphoneclose: `${(0, $kdMEA.CDNAudioAddress)}/microphone-close.mp3`
};


class $75efbde667d94667$var$IndexedDbManager {
    constructor(){
        this.version = 1;
        this.storeName = 'speechSynthesisData';
        this.checkDB = async ()=>{
            return new Promise((resolve)=>{
                const request = indexedDB.open('retorik-framework-db', this.version);
                request.onsuccess = ()=>{
                    resolve(true);
                };
                request.onerror = ()=>{
                    resolve(false);
                };
                request.onupgradeneeded = ()=>{
                    const db = request.result;
                    // If the data object store doesn't exist, create it
                    if (!db.objectStoreNames.contains(this.storeName)) db.createObjectStore(this.storeName, {
                        keyPath: 'id'
                    });
                };
            });
        };
        this.addSpeechData = async (data)=>{
            return new Promise((resolve)=>{
                const request = indexedDB.open('retorik-framework-db', this.version);
                request.onsuccess = ()=>{
                    const db = request.result;
                    const tx = db.transaction(this.storeName, 'readwrite');
                    const store = tx.objectStore(this.storeName);
                    // Base 64 encode
                    data.id = window.btoa(encodeURI(data.id));
                    store.add(data);
                    resolve(true);
                };
                request.onerror = ()=>{
                    resolve(false);
                };
            });
        };
        this.getSpeechData = async (id)=>{
            return new Promise((resolve)=>{
                const request = indexedDB.open('retorik-framework-db', this.version);
                request.onsuccess = ()=>{
                    const db = request.result;
                    const tx = db.transaction(this.storeName, 'readonly');
                    const store = tx.objectStore(this.storeName);
                    // Base 64 encode
                    const data = store.get(window.btoa(encodeURI(id)));
                    data.onsuccess = ()=>{
                        resolve(data.result);
                    };
                };
                request.onerror = ()=>{
                    resolve(null);
                };
            });
        };
    }
}
var $75efbde667d94667$export$2e2bcd8739ae039 = $75efbde667d94667$var$IndexedDbManager;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $lOuaH = parcelRequire("lOuaH");

var $k4qlo = parcelRequire("k4qlo");
parcelRequire("kMAJU");
var $lHTuW = parcelRequire("lHTuW");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $6aH4h = parcelRequire("6aH4h");

var $iEJNQ = parcelRequire("iEJNQ");
const $a6f0e9ef461b31d5$var$springEnterDuration = 500;
const $a6f0e9ef461b31d5$var$springLeaveDuration = 1000;
const $a6f0e9ef461b31d5$var$LoaderCallToAction = ({ showContent: showContent, handleValidation: handleValidation })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.localeForRetorikStudioContent);
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const loaderInformationTexts = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.loaderInformationTexts);
    const loaderInformationTextsLocalized = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.loaderInformationTextsLocalized);
    const hideRetorikLogo = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.hideRetorikLogo);
    const disabledSpeechMode = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableSpeechMode);
    const disabledTextMode = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.disableTextMode);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const characterLoaded = (0, $5FZWK.useSelector)((state)=>state.viewReducer.characterLoaded);
    const container = (0, $bxRTa.useRef)(null);
    const [userValidation, setUserValidation] = (0, $bxRTa.useState)(false);
    const [hover, setHover] = (0, $bxRTa.useState)(false);
    const animationColor = {
        '--rf-color-loader-animation': themeColors.loader.animation
    };
    const animationTimerRef = (0, $bxRTa.useRef)();
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $a6f0e9ef461b31d5$var$springEnterDuration
            }
        });
        return ()=>{
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    const handleChange = (modeId)=>{
        dispatch((0, $cto9a.storeActions).speech.setMode(modeId === 1 ? (0, $2rYkD.Mode).vocal : (0, $2rYkD.Mode).text));
    };
    (0, $bxRTa.useEffect)(()=>{
        if (userValidation && characterLoaded) {
            handleValidation();
            api.start({
                from: {
                    opacity: 1
                },
                to: {
                    opacity: 0
                },
                config: {
                    duration: $a6f0e9ef461b31d5$var$springLeaveDuration
                }
            });
        }
    }, [
        userValidation,
        characterLoaded
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
        className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-items-center rf-animate-loaderFadeIn",
        ref: container,
        style: {
            ...animationColor,
            ...spring
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-h-1/2 rf-pb-6 rf-flex rf-flex-col rf-items-center rf-justify-end",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-6 rf-h-6 rf-mb-16",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {})
                    }),
                    showContent && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-text-center",
                        style: {
                            color: themeColors.loader.text
                        },
                        children: [
                            loaderInformationTexts?.vocal.top && loaderInformationTexts.text.top || loaderInformationTextsLocalized?.vocal?.top?.[locale] && loaderInformationTextsLocalized.text?.top?.[locale] ? /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                children: mode === (0, $2rYkD.Mode).vocal ? loaderInformationTextsLocalized?.vocal?.top?.[locale] || loaderInformationTexts?.vocal?.top : loaderInformationTextsLocalized?.text?.top?.[locale] || loaderInformationTexts?.text?.top
                            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                children: mode === (0, $2rYkD.Mode).vocal ? translation.loader.loader.optimal : translation.loader.loader.classic
                            }),
                            loaderInformationTexts?.vocal?.bottom && loaderInformationTexts.text?.bottom || loaderInformationTextsLocalized?.vocal?.bottom?.[locale] && loaderInformationTextsLocalized.text?.bottom?.[locale] ? /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                className: "rf-font-bold",
                                children: mode === (0, $2rYkD.Mode).vocal ? loaderInformationTextsLocalized?.vocal?.bottom?.[locale] || loaderInformationTexts?.vocal?.bottom : loaderInformationTextsLocalized?.text?.bottom?.[locale] || loaderInformationTexts?.text?.bottom
                            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                className: "rf-font-bold",
                                children: mode === (0, $2rYkD.Mode).vocal ? translation.loader.loader.vocal : translation.loader.loader.text
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full rf-h-1/2 rf-flex rf-flex-col ${hideRetorikLogo ? 'rf-justify-start' : 'rf-justify-between'} rf-items-center`,
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                    className: "rf-flex rf-flex-col rf-items-center",
                    children: [
                        showContent && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6aH4h.default), {
                            texts: {
                                left: translation.loader.modes.vocal,
                                leftId: 1,
                                right: translation.loader.modes.text,
                                rightId: 2
                            },
                            colors: themeColors.loader.toggle,
                            defaultChecked: mode,
                            handleChange: handleChange,
                            showLeft: !disabledSpeechMode,
                            showRight: !disabledTextMode
                        }),
                        userValidation ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                            className: "rf-font-bold rf-border-2 rf-rounded-lg rf-px-6 rf-py-3 rf-mt-8",
                            style: {
                                color: hover ? themeColors.loader.button.text.hover : themeColors.loader.button.text.default,
                                borderColor: hover ? themeColors.loader.button.border.hover : themeColors.loader.button.border.default,
                                background: hover ? themeColors.loader.button.background.hover : themeColors.loader.button.background.default
                            },
                            onClick: ()=>setUserValidation(true),
                            onMouseEnter: ()=>setHover(true),
                            onMouseLeave: ()=>setHover(false),
                            children: translation.loader.loaderValidation
                        })
                    ]
                })
            })
        ]
    });
};
var $a6f0e9ef461b31d5$export$2e2bcd8739ae039 = $a6f0e9ef461b31d5$var$LoaderCallToAction;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $eO5xw = parcelRequire("eO5xw");
const $104fac0f2ca32b3a$var$springDuration = 500;
const $104fac0f2ca32b3a$var$finalMessageDisplayDuration = 2500;
const $104fac0f2ca32b3a$var$GdprWindow = ({ titleTextSize: titleTextSize })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const data = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.GDPRWindowData);
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.localeForRetorikStudioContent);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const [finalMessage, setFinalMessage] = (0, $bxRTa.useState)(null);
    const finalMessageTimerRef = (0, $bxRTa.useRef)();
    const animationTimerRef = (0, $bxRTa.useRef)();
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $104fac0f2ca32b3a$var$springDuration
            }
        });
        return ()=>{
            finalMessageTimerRef?.current && clearTimeout(finalMessageTimerRef.current);
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    const texts = (0, $bxRTa.useMemo)(()=>{
        return {
            title: data?.title?.[locale] || translation.GDPR.title,
            message: data?.message?.[locale] || translation.GDPR.message,
            link: data?.link?.[locale] || translation.GDPR.link,
            buttonAccept: data?.buttonAccept?.[locale] || translation.GDPR.buttonAccept,
            buttonRefuse: data?.buttonRefuse?.[locale] || translation.GDPR.buttonRefuse,
            messageAccepted: data?.messageAccepted?.[locale] || translation.GDPR.messageAccepted,
            messageRefused: data?.messageRefused?.[locale] || translation.GDPR.messageRefused
        };
    }, [
        translation,
        locale
    ]);
    const handleCheck = (value)=>{
        dispatch((0, $cto9a.storeActions).utils.setGDPRUserConsent(value));
        setFinalMessage(value ? texts.messageAccepted : texts.messageRefused);
        finalMessageTimerRef.current = setTimeout(()=>{
            api.start({
                from: {
                    opacity: 1
                },
                to: {
                    opacity: 0
                },
                config: {
                    duration: $104fac0f2ca32b3a$var$springDuration
                }
            });
        }, $104fac0f2ca32b3a$var$finalMessageDisplayDuration);
        animationTimerRef.current = setTimeout(()=>{
            dispatch((0, $cto9a.storeActions).utils.setGDPRDisplay(false));
        }, $104fac0f2ca32b3a$var$springDuration + $104fac0f2ca32b3a$var$finalMessageDisplayDuration);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
        className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-gap-12 rf-justify-center rf-items-center rf-text-center",
        style: {
            ...spring
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `${isMobile ? 'rf-w-3/4' : 'rf-w-1/2'} ${titleTextSize}`,
                children: (0, $eO5xw.capitalizeFirstLetter)(texts.title, locale)
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `${isMobile ? 'rf-w-3/4' : 'rf-w-1/2'} rf-flex rf-flex-col rf-items-center rf-gap-4`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: (0, $eO5xw.capitalizeFirstLetter)(texts.message, locale).replaceAll('\n', '<br>')
                        }
                    }),
                    data?.linkURL && /*#__PURE__*/ (0, $fl9nK.jsx)("a", {
                        href: data.linkURL,
                        target: "_blank",
                        rel: "noreferrer noopener",
                        style: {
                            color: themeColors.primary,
                            textDecoration: 'underline'
                        },
                        children: (0, $eO5xw.capitalizeFirstLetter)(texts.link, locale)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-h-16 rf-flex rf-flex-row rf-justify-center rf-gap-4",
                children: finalMessage ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `${isMobile ? 'rf-w-3/4' : 'rf-w-1/2'} rf-animate-fadeIn`,
                    children: (0, $eO5xw.capitalizeFirstLetter)(finalMessage, locale)
                }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                            className: "rf-h-fit rf-px-4 rf-py-2 rf-rounded-lg",
                            onClick: ()=>handleCheck(true),
                            style: {
                                color: themeColors.loader.toggle.text,
                                background: themeColors.loader.toggle.background,
                                borderColor: themeColors.loader.toggle.background
                            },
                            children: (0, $eO5xw.capitalizeFirstLetter)(texts.buttonAccept, locale)
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                            className: "rf-h-fit rf-px-4 rf-py-2 rf-rounded-lg",
                            onClick: ()=>handleCheck(false),
                            style: {
                                color: themeColors.loader.toggle.text,
                                background: themeColors.loader.toggle.background,
                                borderColor: themeColors.loader.toggle.background
                            },
                            children: (0, $eO5xw.capitalizeFirstLetter)(texts.buttonRefuse, locale)
                        })
                    ]
                })
            })
        ]
    });
};
var $104fac0f2ca32b3a$export$2e2bcd8739ae039 = $104fac0f2ca32b3a$var$GdprWindow;


const $7ac27256f2d61bf4$var$springEnterDuration = 500;
const $7ac27256f2d61bf4$var$springLeaveDuration = 1000;
const $7ac27256f2d61bf4$var$GdprAndLoader = ({ appAvailable: appAvailable, handleValidation: handleValidation })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const displayGDPR = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.GDPRDisplay);
    const isUsedOnBorne = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.isUsedOnBorne);
    const skipLoader = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.skipLoader);
    const loaderClosed = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.loaderClosed);
    const hideRetorikLogo = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.hideRetorikLogo);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const isWidget = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isWidget);
    const themeColors = (0, $5FZWK.useSelector)((state)=>state.viewReducer.themeColors);
    const [textSize, setTextSize] = (0, $bxRTa.useState)('');
    const [titleTextSize, setTitleTextSize] = (0, $bxRTa.useState)();
    const [loaderDisplayData, setLoaderDisplayData] = (0, $bxRTa.useState)({
        display: false,
        displayModeChoice: false,
        displayGDPR: false
    });
    const container = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(container);
    const animationTimerRef = (0, $bxRTa.useRef)();
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        // Check if we have to show the loader / GDPR / mode choice or directly the application
        if (loaderClosed || appAvailable) setLoaderDisplayData({
            display: false
        });
        else if (isUsedOnBorne || skipLoader) {
            if (navigator.userActivation.hasBeenActive) {
                dispatch((0, $cto9a.storeActions).utils.setGDPRDisplay(false));
                handleValidation();
            } else setLoaderDisplayData({
                display: true,
                displayModeChoice: false,
                displayGDPR: false
            });
        } else setLoaderDisplayData({
            display: true,
            displayModeChoice: true,
            displayGDPR: displayGDPR
        });
    }, [
        isUsedOnBorne,
        skipLoader,
        displayGDPR,
        appAvailable,
        loaderClosed
    ]);
    (0, $bxRTa.useEffect)(()=>{
        api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $7ac27256f2d61bf4$var$springEnterDuration
            }
        });
        return ()=>{
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        if (dimensions.width && dimensions.height && dimensions.width > 600) {
            if (dimensions.width < dimensions.height) {
                setTextSize('rf-text-lgcustom');
                setTitleTextSize('rf-text-3xl');
            } else {
                setTextSize('rf-text-basecustom');
                setTitleTextSize('rf-text-4xl');
            }
        } else {
            setTextSize('rf-text-sm');
            setTitleTextSize('rf-text-2xl');
        }
    }, [
        dimensions
    ]);
    const handleValidate = ()=>{
        handleValidation();
        api.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $7ac27256f2d61bf4$var$springLeaveDuration
            }
        });
    };
    (0, $bxRTa.useEffect)(()=>{
        container?.current && isWidget && (0, $k4qlo.default)(container.current);
    }, [
        container?.current
    ]);
    return loaderDisplayData.display ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
        id: "retorik-GDPR-and-loader",
        className: `rf-absolute rf-z-modal rf-top-0 rf-left-0 rf-h-full rf-w-full rf-font-default
        ${textSize}`,
        ref: container,
        style: {
            background: themeColors.loader.background,
            color: themeColors.loader.text,
            ...spring
        },
        children: [
            loaderDisplayData.displayGDPR ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $104fac0f2ca32b3a$export$2e2bcd8739ae039), {
                titleTextSize: titleTextSize
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a6f0e9ef461b31d5$export$2e2bcd8739ae039), {
                showContent: loaderDisplayData.displayModeChoice,
                handleValidation: handleValidate
            }),
            !hideRetorikLogo && (isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lHTuW.default), {
                className: "rf-absolute rf-bottom-10 rf-h-14"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lHTuW.default), {
                className: "rf-absolute rf-left-4 rf-bottom-4 rf-h-14"
            }))
        ]
    }) : null;
};
var $7ac27256f2d61bf4$export$2e2bcd8739ae039 = $7ac27256f2d61bf4$var$GdprAndLoader;


const $0673a82084862dad$var$DBManager = new (0, $75efbde667d94667$export$2e2bcd8739ae039)();
const $0673a82084862dad$var$tagsRemoverRegex = /<[^<>]+>/g;
const $0673a82084862dad$var$RetorikSpeech = ({ ponyfill: ponyfill, onEnd: onEnd, onError: onError, onStart: onStart, utterance: utterance, nextUtterance: nextUtterance, appAvailable: appAvailable, forceSpeechCaching: forceSpeechCaching })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const loaderClosed = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.loaderClosed);
    const enableSpeechCaching = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.enableSpeechCaching);
    const speechRecognitionOptions = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.speechRecognitionOptions);
    const useOldRemote = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.useOldRemote);
    const voice = (0, $5FZWK.useSelector)((state)=>state.speechReducer.voice);
    const muted = (0, $5FZWK.useSelector)((state)=>state.speechReducer.muted);
    const activeRecognitionState = (0, $5FZWK.useSelector)((state)=>state.speechReducer.activeRecognitionState);
    const boundaryRef = (0, $bxRTa.useRef)(null);
    const visemeRef = (0, $bxRTa.useRef)(null);
    const audioRef = (0, $bxRTa.useRef)(null);
    const speechRecognitionAudioRef = (0, $bxRTa.useRef)(null);
    const microphoneOpenAudioRef = (0, $bxRTa.useRef)(null);
    const microphoneCloseAudioRef = (0, $bxRTa.useRef)(null);
    const [DBReady, setDBReady] = (0, $bxRTa.useState)(false);
    const [playingBlob, setPlayingBlob] = (0, $bxRTa.useState)(false);
    const nextUtteranceDataRef = (0, $bxRTa.useRef)(null);
    const nextUtteranceTextRef = (0, $bxRTa.useRef)(null);
    const nextUtteranceBoundariesRef = (0, $bxRTa.useRef)([]);
    const nextUtteranceVisemesRef = (0, $bxRTa.useRef)([]);
    const emptyTextUtteranceRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        $0673a82084862dad$var$DBManager.checkDB().then((result)=>setDBReady(result));
        return ()=>{
            stopCurrentPlaying();
            emptyTextUtteranceRef?.current && clearTimeout(emptyTextUtteranceRef.current);
        };
    }, []);
    const stopCurrentPlaying = ()=>{
        if (appAvailable || loaderClosed) {
            // Cancel synthesis if using synthesizer
            if (!playingBlob) ponyfill.speechSynthesis.cancel();
            resetNextUtteranceData();
            if (audioRef.current && !audioRef.current?.paused) {
                audioRef.current.pause();
                handleEnd();
            }
        }
    };
    const attachEvents = (tempUtterance, isMainUtterance)=>{
        tempUtterance.onerror = (event)=>{
            isMainUtterance ? handleError(event) : nextUtteranceDataRef.current = null;
        };
        tempUtterance.onsynthesiscompleted = ()=>{
            const endBoundary = {
                word: '',
                startTime: 0,
                endTime: 0,
                boundaryType: 'EndBoundary'
            };
            if (isMainUtterance) {
                const tempBoundaries = boundaryRef?.current || [];
                boundaryRef.current = [
                    ...tempBoundaries,
                    endBoundary
                ];
                dispatch((0, $cto9a.storeActions).speech.setBoundaryData([
                    ...tempBoundaries,
                    endBoundary
                ]));
            } else nextUtteranceBoundariesRef.current = [
                ...nextUtteranceBoundariesRef.current,
                endBoundary
            ];
        };
        tempUtterance.onboundary = (event)=>{
            if (event.boundaryType !== 'Viseme') {
                const newBoundary = {
                    word: event.name,
                    startTime: event.elapsedTime,
                    endTime: event.elapsedTime + event.duration,
                    boundaryType: event.boundaryType
                };
                if (isMainUtterance) {
                    // Update the boundaryData state with the new data.
                    const tempBoundaries = boundaryRef?.current || [];
                    boundaryRef.current = [
                        ...tempBoundaries,
                        newBoundary
                    ];
                    dispatch((0, $cto9a.storeActions).speech.setBoundaryData([
                        ...tempBoundaries,
                        newBoundary
                    ]));
                } else nextUtteranceBoundariesRef.current = [
                    ...nextUtteranceBoundariesRef.current,
                    newBoundary
                ];
            }
        };
        tempUtterance.onviseme = (event)=>{
            if (isMainUtterance) {
                // Update the boundaryData state with the new data.
                dispatch((0, $cto9a.storeActions).speech.addViseme(event));
                const tempVisemes = visemeRef?.current || [];
                visemeRef.current = [
                    ...tempVisemes,
                    event
                ];
            } else nextUtteranceVisemesRef.current = [
                ...nextUtteranceVisemesRef.current,
                event
            ];
        };
        return tempUtterance;
    };
    const processNextData = (data)=>{
        nextUtteranceDataRef.current = data?.byteLength && nextUtteranceTextRef.current ? {
            text: nextUtteranceTextRef.current,
            data: {
                speechData: data,
                boundaries: nextUtteranceBoundariesRef.current,
                visemes: nextUtteranceVisemesRef.current
            }
        } : null;
        // Reset boundary / viseme data
        resetNextUtteranceData(true);
    };
    const resetNextUtteranceData = (keepArrayBufferData)=>{
        !keepArrayBufferData && (nextUtteranceDataRef.current = null);
        nextUtteranceTextRef.current = null;
        nextUtteranceBoundariesRef.current = [];
        nextUtteranceVisemesRef.current = [];
    };
    (0, $bxRTa.useEffect)(()=>{
        if (utterance) {
            if (utterance.text) {
                if (audioRef?.current) {
                    if (nextUtteranceDataRef.current?.text === utterance.text && nextUtteranceDataRef.current.data) {
                        boundaryRef.current = nextUtteranceDataRef.current.data.boundaries;
                        dispatch((0, $cto9a.storeActions).speech.setBoundaryData(nextUtteranceDataRef.current.data.boundaries));
                        dispatch((0, $cto9a.storeActions).speech.setVisemeData(nextUtteranceDataRef.current.data.visemes));
                        processData(nextUtteranceDataRef.current.data.speechData, true);
                    } else // Play utterance whether by asking for a speech synthesis, or by retrieving data from indexedDB
                    playUtterance(attachEvents(utterance, true));
                } else stopCurrentPlaying();
            } else handleEmptyTextUtterance();
        } else stopCurrentPlaying();
    }, [
        utterance
    ]);
    (0, $bxRTa.useEffect)(()=>{
        // If there are data in nextUtteranceTextRef, this means the previous synthesis data retrieval is not finished, so we don't begin a new one
        if (nextUtterance?.text && !nextUtteranceTextRef.current) {
            const tempUtterance = attachEvents(nextUtterance);
            nextUtteranceTextRef.current = nextUtterance.text;
            ponyfill.speechSynthesis.synthesizeAndGetArrayData(tempUtterance, processNextData);
        } else resetNextUtteranceData();
    }, [
        nextUtterance
    ]);
    const playUtterance = async (utt)=>{
        if (DBReady && (enableSpeechCaching !== false || forceSpeechCaching) && utt) {
            const dataFromIndexedDB = await $0673a82084862dad$var$DBManager.getSpeechData(`${locale}.${voice?.name}.${utt.text.replace($0673a82084862dad$var$tagsRemoverRegex, '')}`);
            if (dataFromIndexedDB) {
                boundaryRef.current = dataFromIndexedDB.boundaries;
                dispatch((0, $cto9a.storeActions).speech.setBoundaryData(dataFromIndexedDB.boundaries));
                dispatch((0, $cto9a.storeActions).speech.setVisemeData(dataFromIndexedDB.visemes || []));
                processData(dataFromIndexedDB.value, true);
            } else ponyfill.speechSynthesis.synthesizeAndGetArrayData(utt, processData);
        } else ponyfill.speechSynthesis.synthesizeAndGetArrayData(utt, processData);
    };
    const processData = (data, alreadyExistsInDB)=>{
        if (data?.byteLength) {
            const blob = new Blob([
                data
            ], {
                type: 'audio/mp3'
            });
            !alreadyExistsInDB && (enableSpeechCaching !== false || forceSpeechCaching) && DBReady && boundaryRef?.current && utterance && $0673a82084862dad$var$DBManager.addSpeechData({
                id: `${locale}.${voice?.name}.${utterance.text.replace($0673a82084862dad$var$tagsRemoverRegex, '')}`,
                value: data,
                boundaries: boundaryRef.current,
                visemes: visemeRef.current || []
            });
            const url = URL.createObjectURL(blob);
            if (audioRef?.current) {
                setPlayingBlob(true);
                audioRef.current.src = url;
                audioRef.current.play().catch((e)=>console.warn(e));
            }
        } else handleEmptyTextUtterance();
    };
    const resetData = ()=>{
        boundaryRef.current = [];
        visemeRef.current = [];
        dispatch((0, $cto9a.storeActions).speech.setBoundaryData([]));
        dispatch((0, $cto9a.storeActions).speech.setVisemeData([]));
        setPlayingBlob(false);
    };
    const handleStart = ()=>{
        if (appAvailable || loaderClosed) onStart?.();
    };
    const handleEnd = ()=>{
        if (appAvailable || loaderClosed) {
            onEnd?.();
            resetData();
        } else dispatch((0, $cto9a.storeActions).retorik.setLoaderClosed(true));
    };
    const handleError = (error)=>{
        console.log('Retorik Framework > speech synthesis error ', error);
        onError?.();
        resetData();
    };
    const handleEmptyTextUtterance = ()=>{
        handleStart();
        emptyTextUtteranceRef?.current && clearTimeout(emptyTextUtteranceRef.current);
        emptyTextUtteranceRef.current = setTimeout(()=>{
            handleEnd();
        }, 50);
    };
    /**
   * On call :
   *  - play 1 second muted sound to prime audio output
   *  - MANDATORY FOR SAFARI IN VOCAL MODE
   */ const primeRetorikSpeech = ()=>{
        if (audioRef.current) {
            audioRef.current.play().catch((e)=>console.warn(e));
            speechRecognitionAudioRef?.current && speechRecognitionAudioRef.current.play().catch((e)=>console.warn(e));
            // Send animation start event to secure animation not playing on safari if permissions are not sufficient
            window.dispatchEvent(new Event('retorikSpiritEnginePlay'));
        }
    };
    /**
   * Play sound on speech recognition activation if it isn't disabled in configuration
   */ (0, $bxRTa.useEffect)(()=>{
        if (useOldRemote) {
            if (!!speechRecognitionOptions?.enableActivationSound && activeRecognitionState === (0, $2rYkD.RecognitionState).Listening) speechRecognitionAudioRef?.current?.play().catch((e)=>console.warn(e));
        } else if (!!speechRecognitionOptions?.enableActivationSound) switch(activeRecognitionState){
            case (0, $2rYkD.RecognitionState).Listening:
                microphoneOpenAudioRef?.current?.play().catch((e)=>console.warn(e));
                break;
            case (0, $2rYkD.RecognitionState).Closing:
            case (0, $2rYkD.RecognitionState).ForceClosing:
                microphoneCloseAudioRef?.current?.play().catch((e)=>console.warn(e));
                break;
            default:
                break;
        }
    }, [
        useOldRemote,
        activeRecognitionState,
        speechRecognitionOptions
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("audio", {
                ref: audioRef,
                src: (0, $d1984bac2dac280a$export$52a3c04e084af2a0).onesecond,
                muted: appAvailable || loaderClosed ? muted : true,
                onPlay: handleStart,
                onEnded: handleEnd
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("audio", {
                ref: speechRecognitionAudioRef,
                src: (0, $d1984bac2dac280a$export$52a3c04e084af2a0).speechrecognition,
                preload: "auto",
                muted: appAvailable || loaderClosed ? muted : true
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("audio", {
                ref: microphoneOpenAudioRef,
                src: (0, $d1984bac2dac280a$export$52a3c04e084af2a0).microphoneopen,
                preload: "auto",
                muted: appAvailable || loaderClosed ? muted : true
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("audio", {
                ref: microphoneCloseAudioRef,
                src: (0, $d1984bac2dac280a$export$52a3c04e084af2a0).microphoneclose,
                preload: "auto",
                muted: appAvailable || loaderClosed ? muted : true
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7ac27256f2d61bf4$export$2e2bcd8739ae039), {
                appAvailable: appAvailable,
                handleValidation: primeRetorikSpeech
            })
        ]
    });
};
var $0673a82084862dad$export$2e2bcd8739ae039 = $0673a82084862dad$var$RetorikSpeech;


const $12d972be73a3588e$var$SynthesisManager = ({ ponyfill: ponyfill, isRetorikNews: isRetorikNews })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const cancel = (0, $5FZWK.useSelector)((state)=>state.speechReducer.cancel);
    const streamingQueue = (0, $5FZWK.useSelector)((state)=>state.speechReducer.streamingQueue);
    const voice = (0, $5FZWK.useSelector)((state)=>state.speechReducer.voice);
    const customVoice = (0, $5FZWK.useSelector)((state)=>state.speechReducer.customVoice);
    const activeRecognitionState = (0, $5FZWK.useSelector)((state)=>state.speechReducer.activeRecognitionState);
    const externalTextToSpeech = (0, $5FZWK.useSelector)((state)=>state.speechReducer.externalTextToSpeech);
    const isMicrophoneAllowed = (0, $5FZWK.useSelector)((state)=>state.speechReducer.isMicrophoneAllowed);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const route = (0, $5FZWK.useSelector)((state)=>state.viewReducer.route);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const replacementLocales = (0, $5FZWK.useSelector)((state)=>state.localeReducer.replacementLocales);
    const agentData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.agentData);
    const appAvailable = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.appAvailable);
    const preventExpectedInputHint = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.preventExpectedInputHint);
    const speechSynthesisOptions = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.speechSynthesisOptions);
    const sendTrace = (0, $f6050bdd136b78fe$export$a15d15518a3ec33d)().sendTrace;
    const [utterance, setUtterance] = (0, $bxRTa.useState)(null);
    const [nextUtterance, setNextUtterance] = (0, $bxRTa.useState)(null);
    const [forceSpeechCaching, setForceSpeechCaching] = (0, $bxRTa.useState)(false);
    const isNewsViewRef = (0, $bxRTa.useRef)(!!isRetorikNews);
    const lastListTextPlayedRef = (0, $bxRTa.useRef)('');
    const streamingQueueRef = (0, $bxRTa.useRef)([]);
    const currentActivityRef = (0, $bxRTa.useRef)(null);
    /**
   * Check activity locale in case of voice change during the speech, to keep the language defined in activity
   * instead of switching languages between answers that are written in the same language
   * @param {string} activityLocale
   * @returns {SpeechSynthesisVoice | null}
   */ const getVoiceAfterCheckingActivityLocale = (activityLocale)=>{
        return activityLocale === locale ? voice : (0, $57f41e573dafcd6e$export$4bf371fc4fa74a28)(ponyfill.speechSynthesis.getVoices(), activityLocale, customVoice, agentData);
    };
    /**
   * Check if the activity is a list one, to prevent text re-reading on state update
   * @param {CreateUtteranceParams} params
   * @returns {SpeechSynthesisUtterance}
   */ const checkActivityAndCreateUtterance = (params)=>{
        if (params.activity.attachmentLayout && params.activity.attachmentLayout.toLowerCase() === 'davilist') {
            const textToSpeak = params.activity.speak || params.activity.text;
            if (textToSpeak) {
                if (textToSpeak === lastListTextPlayedRef.current) return (0, $2161e8fb47c6c1a6$export$f969af62bba9a48b)({
                    ...params,
                    voice: null
                }, speechSynthesisOptions?.sayAs);
                else lastListTextPlayedRef.current = textToSpeak;
            }
        }
        return (0, $2161e8fb47c6c1a6$export$f969af62bba9a48b)(params, speechSynthesisOptions?.sayAs);
    };
    const resetData = ()=>{
        // Set all activities currently in the queue as ended
        streamingQueueRef.current?.forEach((activity)=>{
            dispatch((0, $cto9a.storeActions).activity.addEndedActivity(activity.id));
        });
        streamingQueueRef.current = [];
        dispatch((0, $cto9a.storeActions).speech.killCurrentStreaming());
        currentActivityRef.current = null;
        setUtterance(null);
        setNextUtterance(null);
        dispatch((0, $cto9a.storeActions).speech.resetCancelCurrentUtterance());
        dispatch((0, $cto9a.storeActions).speech.setSpeaking(false));
        dispatch((0, $cto9a.storeActions).speech.setBoundaryData([]));
    };
    const checkReplacementLocaleAndGetUtterance = (activity, checkReplacement = true)=>{
        const replacementLocale = checkReplacement ? replacementLocales?.[locale] || locale : locale;
        const params = {
            activity: activity,
            voice: getVoiceAfterCheckingActivityLocale(replacementLocale),
            locale: replacementLocale
        };
        return checkActivityAndCreateUtterance(params);
    };
    /**
   * Check if the microphone can be opened automatically
   */ const checkDictateState = ()=>{
        if (!preventExpectedInputHint && mode === (0, $2rYkD.Mode).vocal && activeRecognitionState === (0, $2rYkD.RecognitionState).Closed) {
            if (!isMicrophoneAllowed) dispatch((0, $cto9a.storeActions).speech.askPermission());
            else dispatch((0, $cto9a.storeActions).speech.toggleMicrophone(true));
        }
    };
    /**
   * On route change, reset all data and check if we are on the news view
   */ (0, $bxRTa.useEffect)(()=>{
        resetData();
        if (!isRetorikNews) isNewsViewRef.current = route === (0, $2rYkD.Routes).News || route === (0, $2rYkD.Routes).NewsInVeille;
        // Force speech caching when using Retorik News or when using news in veille
        setForceSpeechCaching(isRetorikNews || route === (0, $2rYkD.Routes).NewsInVeille);
    }, [
        route
    ]);
    /**
   * On cancel call, reset all data and kill current streaming
   */ (0, $bxRTa.useEffect)(()=>{
        cancel && resetData();
    }, [
        cancel
    ]);
    /**
   * Play external speech immediately but don't add it to the history
   */ (0, $bxRTa.useEffect)(()=>{
        if (externalTextToSpeech) {
            const activity = {
                speak: externalTextToSpeech,
                locale: locale
            };
            currentActivityRef.current = activity;
            setUtterance(checkReplacementLocaleAndGetUtterance(activity, false));
        }
    }, [
        externalTextToSpeech
    ]);
    const dispatchSpeechEvent = (start)=>{
        const speechEvent = start ? new Event('retorikSpeakStart') : new Event('retorikSpeakStop');
        document.dispatchEvent(speechEvent);
    };
    /**
   * Called when utterance's "start" event is fired
   */ const handleUtteranceStart = ()=>{
        sendTrace((0, $2rYkD.TraceType).utteranceStart, {
            activityId: currentActivityRef.current?.id,
            text: currentActivityRef.current?.speak || currentActivityRef.current?.text
        });
        dispatch((0, $cto9a.storeActions).speech.setSpeaking(true));
        if (!isNewsViewRef.current && currentActivityRef?.current) {
            dispatch((0, $cto9a.storeActions).speech.setCurrentOrLastPlayedActivity(currentActivityRef.current));
            currentActivityRef.current.id && dispatch((0, $cto9a.storeActions).directline.dispatchMarkActivity({
                id: currentActivityRef.current.id,
                speaking: true
            }));
        }
        dispatchSpeechEvent(true);
        // Set next utterance to prepare synthesis data in order to improve fluidity
        if (streamingQueueRef.current.length && !streamingQueueRef.current[0].value?.streamingCount) {
            const utt = checkReplacementLocaleAndGetUtterance(streamingQueueRef.current[0], false);
            setNextUtterance((current)=>utt.text === current?.text ? null : utt);
        } else setNextUtterance(null);
    };
    /**
   * Called when utterance's "end" event is fired
   */ const handleUtteranceEnd = ()=>{
        sendTrace((0, $2rYkD.TraceType).utteranceEnd, {
            activityId: currentActivityRef.current?.id
        });
        dispatch((0, $cto9a.storeActions).speech.setSpeaking(false));
        dispatchSpeechEvent(false);
        if (isNewsViewRef.current) {
            dispatch((0, $cto9a.storeActions).utils.setRetorikNewsEnded(true));
            currentActivityRef.current = null;
        } else handleEnded();
    };
    const handleEnded = ()=>{
        // Add played activity id to context's endedActivities
        if (currentActivityRef.current?.id) {
            dispatch((0, $cto9a.storeActions).activity.addEndedActivity(currentActivityRef.current.id));
            dispatch((0, $cto9a.storeActions).directline.dispatchMarkActivity({
                id: currentActivityRef.current.id,
                speaking: false
            }));
        }
        if (streamingQueueRef.current?.length) {
            // Check if this is the message sent after streaming activities
            if (streamingQueueRef.current[0].value?.streamingCount) {
                dispatch((0, $cto9a.storeActions).activity.addEndedActivity(streamingQueueRef.current[0].id));
                // If there is another activity after this message, play it. If not, let's check if the microphone should be opened
                if (streamingQueueRef.current?.length > 1) {
                    const utt = checkReplacementLocaleAndGetUtterance(streamingQueueRef.current[1]);
                    currentActivityRef.current = streamingQueueRef.current[1];
                    setUtterance(utt);
                    dispatch((0, $cto9a.storeActions).speech.removeFirstFromStreamingQueue(true));
                } else {
                    streamingQueueRef.current[0].inputHint === 'expectingInput' && checkDictateState();
                    currentActivityRef.current = null;
                    setUtterance(null);
                    setNextUtterance(null);
                    dispatch((0, $cto9a.storeActions).speech.removeFirstFromStreamingQueue(false));
                }
            } else {
                const utt = checkReplacementLocaleAndGetUtterance(streamingQueueRef.current[0]);
                currentActivityRef.current = streamingQueueRef.current[0];
                setUtterance(utt);
                dispatch((0, $cto9a.storeActions).speech.removeFirstFromStreamingQueue(false));
            }
        } else {
            currentActivityRef.current?.inputHint === 'expectingInput' && checkDictateState();
            currentActivityRef.current = null;
            setUtterance(null);
            setNextUtterance(null);
        }
    };
    /**
   * Wait for app loading and voice selection to begin playing speech
   */ (0, $bxRTa.useEffect)(()=>{
        // Set ref from the state to use in events
        streamingQueueRef.current = streamingQueue;
        if (appAvailable && voice && streamingQueue.length && !currentActivityRef.current) handleEnded();
    }, [
        appAvailable,
        voice,
        streamingQueue
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $0673a82084862dad$export$2e2bcd8739ae039), {
        ponyfill: ponyfill,
        appAvailable: appAvailable,
        utterance: utterance,
        nextUtterance: nextUtterance,
        forceSpeechCaching: forceSpeechCaching,
        onStart: handleUtteranceStart,
        onError: handleUtteranceEnd,
        onEnd: handleUtteranceEnd
    });
};
var $12d972be73a3588e$export$2e2bcd8739ae039 = $12d972be73a3588e$var$SynthesisManager;


const $33bbcb005e851f61$var$SynthesisPonyfillManager = ({ isRetorikNews: isRetorikNews })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const customVoice = (0, $5FZWK.useSelector)((state)=>state.speechReducer.customVoice);
    const ponyfillCredentials = (0, $5FZWK.useSelector)((state)=>state.speechReducer.ponyfillCredentials);
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const agentData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.agentData);
    const [ponyfillCreated, setPonyfillCreated] = (0, $bxRTa.useState)(false);
    const ponyfillRef = (0, $bxRTa.useRef)(undefined);
    const refreshTimerRef = (0, $bxRTa.useRef)(null);
    /**
   * Async function to retrieve a new token and assign it to the speechConfig inside ponyfill.speechSynthesis
   * @param {string} region
   * @param {string} key
   */ const refreshTokenInNineMinutes = async (region, key)=>{
        // A token is valid during 10 minutes, let's refresh it after 9 minutes
        refreshTimerRef.current = setTimeout(async ()=>{
            const token = await (0, $2f9f46fd962caacf$export$a2ce4fdd6972d6a7)(region, key);
            if (token && ponyfillRef.current?.speechSynthesis?.speechConfig) {
                ponyfillRef.current.speechSynthesis.speechConfig.authorizationToken = token;
                refreshTokenInNineMinutes(region, key);
            }
        }, 540000) // 9 minutes
        ;
    };
    /**
   * Fetch speech synthesis token and create the ponyfill containing all data
   * @param {string} region
   * @param {string} key
   */ const fetchTokenAndCreatePonyfill = async (region, key)=>{
        const token = await (0, $2f9f46fd962caacf$export$a2ce4fdd6972d6a7)(region, key);
        if (token) {
            ponyfillRef.current = (0, $lo8xw.createSpeechSynthesisPonyfill)({
                credentials: {
                    region: ponyfillCredentials?.region,
                    authorizationToken: token
                }
            });
            // Launch token refresh after ponyfill creation
            refreshTokenInNineMinutes(region, key);
            setPonyfillCreated(true);
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        if (ponyfillCredentials?.authorizationToken && ponyfillCredentials.region) {
            const data = {
                credentials: ponyfillCredentials
            };
            ponyfillRef.current = (0, $lo8xw.createSpeechSynthesisPonyfill)(data);
            setPonyfillCreated(true);
        } else if (ponyfillCredentials?.subscriptionKey && ponyfillCredentials.region) fetchTokenAndCreatePonyfill(ponyfillCredentials.region, ponyfillCredentials.subscriptionKey);
        else if (ponyfillCredentials?.speechSynthesisHostname) {
            // To use self-hosted voice containers, we need no 'region', and 'speechSynthesisHostname' and 'speechRecognitionHostname' must both be defined
            // As this ponyfill is for speech synthesis only, we put a mock 'speechRecognitionHostname'
            const data = {
                credentials: {
                    // @ts-ignore
                    speechSynthesisHostname: new URL(ponyfillCredentials.speechSynthesisHostname),
                    speechRecognitionHostname: ponyfillCredentials.speechRecognitionHostname || 'mandatory_recognition_host_name',
                    subscriptionKey: ponyfillCredentials.subscriptionKey || 'mandatory_subscription_key'
                }
            };
            ponyfillRef.current = (0, $lo8xw.createSpeechSynthesisPonyfill)(data);
            setPonyfillCreated(true);
        }
    }, [
        ponyfillCredentials
    ]);
    const onVoicesChanged = ()=>{
        const voices = ponyfillRef.current?.speechSynthesis.getVoices();
        if (voices && Array.isArray(voices) && voices.length) dispatch((0, $cto9a.storeActions).speech.setVoice((0, $57f41e573dafcd6e$export$4bf371fc4fa74a28)(voices, locale, customVoice, agentData) || undefined));
    };
    (0, $bxRTa.useEffect)(()=>{
        if (ponyfillRef.current) {
            const voices = ponyfillRef.current.speechSynthesis.getVoices();
            if (voices && Array.isArray(voices) && voices.length) dispatch((0, $cto9a.storeActions).speech.setVoice((0, $57f41e573dafcd6e$export$4bf371fc4fa74a28)(voices, locale, customVoice, agentData) || undefined));
            else ponyfillRef.current.speechSynthesis.onvoiceschanged = onVoicesChanged;
        }
    }, [
        ponyfillCreated,
        customVoice,
        agentData,
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        return ()=>{
            refreshTimerRef.current && clearTimeout(refreshTimerRef.current);
        };
    }, []);
    return ponyfillCreated && ponyfillRef.current ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $12d972be73a3588e$export$2e2bcd8739ae039), {
        ponyfill: ponyfillRef.current,
        isRetorikNews: isRetorikNews
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $33bbcb005e851f61$export$2e2bcd8739ae039 = $33bbcb005e851f61$var$SynthesisPonyfillManager;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $lo8xw = parcelRequire("lo8xw");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $2rYkD = parcelRequire("2rYkD");
const $5a4bbcc726cceb44$var$getMicrophonePermission = async ()=>{
    try {
        return navigator.mediaDevices.getUserMedia({
            audio: true
        }).then((stream)=>{
            return stream ? (0, $2rYkD.PermissionStatus).allowed : (0, $2rYkD.PermissionStatus).refused;
        }, (reason)=>{
            console.log('Retorik Framework > microphone permission refused : ', reason);
            return (0, $2rYkD.PermissionStatus).refused;
        }).catch((error)=>{
            console.log('Retorik Framework > microphone permission refused : ', error);
            return (0, $2rYkD.PermissionStatus).error;
        });
    } catch (error) {
        console.log('Retorik Framework > microphone permission refused : ', error);
        return (0, $2rYkD.PermissionStatus).error;
    }
};
var $5a4bbcc726cceb44$export$2e2bcd8739ae039 = $5a4bbcc726cceb44$var$getMicrophonePermission;


const $929f3e20ef85e71e$var$timeoutDuration = 1000;
const $929f3e20ef85e71e$var$RecognitionManager = ()=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const appAvailable = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.appAvailable);
    const loaderClosed = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.loaderClosed);
    const agentData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.agentData);
    const delay = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.submitDelayBeforeSendingMessage);
    const speechRecognitionOptions = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration.speechRecognitionOptions);
    const ponyfillCredentials = (0, $5FZWK.useSelector)((state)=>state.speechReducer.ponyfillCredentials);
    const useContinuousRecognition = (0, $5FZWK.useSelector)((state)=>state.speechReducer.useContinuousRecognition);
    const activeRecognitionState = (0, $5FZWK.useSelector)((state)=>state.speechReducer.activeRecognitionState);
    const lastRecognitionInterim = (0, $5FZWK.useSelector)((state)=>state.speechReducer.lastRecognitionInterim);
    const speechRecognitionDynamicGrammars = (0, $5FZWK.useSelector)((state)=>state.speechReducer.speechRecognitionDynamicGrammars);
    const route = (0, $5FZWK.useSelector)((state)=>state.viewReducer.route);
    const [ponyfill, setPonyfill] = (0, $bxRTa.useState)(null);
    const [recognitionAllowed, setRecognitionAllowed] = (0, $bxRTa.useState)(false);
    const [ponyfillReady, setPonyfillReady] = (0, $bxRTa.useState)(false);
    const activeModeRef = (0, $bxRTa.useRef)();
    const timerRef = (0, $bxRTa.useRef)(null);
    const localeRef = (0, $bxRTa.useRef)(undefined);
    const getCommonAndLocalizedWakeWords = (currentLocale, agentName)=>{
        let commonAndlocalizedWakeWords = [];
        if (speechRecognitionOptions?.wakeWords) {
            if (speechRecognitionOptions.wakeWords.common) commonAndlocalizedWakeWords = [
                ...speechRecognitionOptions.wakeWords.common
            ];
            if (speechRecognitionOptions.wakeWords.localized) {
                const localizedWakeWords = speechRecognitionOptions.wakeWords.localized[currentLocale] || [];
                localizedWakeWords.length && (commonAndlocalizedWakeWords = [
                    ...commonAndlocalizedWakeWords,
                    ...localizedWakeWords
                ]);
            }
        }
        // Add agent's name to wake words
        agentName && (commonAndlocalizedWakeWords = [
            ...commonAndlocalizedWakeWords,
            agentName
        ]);
        return commonAndlocalizedWakeWords;
    };
    const getCommonAndLocalizedGrammars = (currentLocale)=>{
        let commonAndlocalizedGrammars = [];
        if (speechRecognitionOptions?.grammars) {
            if (speechRecognitionOptions.grammars.common) commonAndlocalizedGrammars = [
                ...speechRecognitionOptions.grammars.common
            ];
            if (speechRecognitionOptions.grammars.localized) {
                const localizedGrammars = speechRecognitionOptions.grammars.localized[currentLocale] || [];
                localizedGrammars.length && (commonAndlocalizedGrammars = [
                    ...commonAndlocalizedGrammars,
                    ...localizedGrammars
                ]);
            }
        }
        return commonAndlocalizedGrammars;
    };
    const askPermission = ()=>{
        if (recognitionAllowed) ponyfill?.speechRecognition.start();
        else (0, $5a4bbcc726cceb44$export$2e2bcd8739ae039)().then((permission)=>{
            setRecognitionAllowed(permission === (0, $2rYkD.PermissionStatus).allowed);
        }).catch(console.log);
    };
    (0, $bxRTa.useEffect)(()=>{
        // Clear data on component unmount
        return ()=>{
            timerRef?.current && clearTimeout(timerRef.current);
            ponyfill?.speechRecognition?.abort?.();
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        recognitionAllowed && useContinuousRecognition && ponyfill?.speechRecognition.start();
    }, [
        recognitionAllowed
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (ponyfillCredentials && locale && agentData) {
            let currentPonyfill = ponyfill;
            if (locale !== localeRef.current) {
                localeRef.current = locale;
                // We create the ponyfill if it isn't created yet. We recreate a new one if we are using custom endpoints for speech recognition.
                if (!ponyfill || ponyfillCredentials?.speechRecognitionHostnamesRecord) {
                    // Check if we need to use a custom endpoint from speechRecognitionHostnamesRecord
                    const speechRecognitionHostname = ponyfillCredentials?.speechRecognitionHostnamesRecord ? ponyfillCredentials.speechRecognitionHostnamesRecord[locale] || Object.values(ponyfillCredentials.speechRecognitionHostnamesRecord)[0] : undefined;
                    const options = {
                        autoStart: false,
                        continuous: useContinuousRecognition,
                        interimResults: true,
                        grammarsList: getCommonAndLocalizedGrammars(locale),
                        lang: locale,
                        passive: useContinuousRecognition,
                        wakeWords: getCommonAndLocalizedWakeWords(locale),
                        debug: false,
                        timerBeforeSpeechEnd: speechRecognitionOptions?.timerBeforeSpeechEnd
                    };
                    const processedCredentials = {
                        credentials: speechRecognitionHostname ? {
                            region: undefined,
                            subscriptionKey: ponyfillCredentials.subscriptionKey || 'mandatory_subscription_key',
                            speechRecognitionHostname: speechRecognitionHostname,
                            speechSynthesisHostname: 'mandatory_synthesis_host_name'
                        } : {
                            region: ponyfillCredentials.region,
                            subscriptionKey: ponyfillCredentials.subscriptionKey,
                            authorizationToken: ponyfillCredentials.authorizationToken
                        }
                    };
                    // Abort current recognition before setting the new recognition ponyfill if there is a need to
                    currentPonyfill?.speechRecognition?.abort?.();
                    currentPonyfill = (0, $lo8xw.createSpeechRecognitionPonyfill)(processedCredentials, options);
                } else if (currentPonyfill) {
                    // Set wakeworkds
                    currentPonyfill.speechRecognition.wakeWords = getCommonAndLocalizedWakeWords(locale, agentData?.name);
                    // Set language
                    activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? currentPonyfill?.speechRecognition.changeLanguage(locale) : currentPonyfill.speechRecognition.lang = locale;
                }
            }
            if (currentPonyfill) {
                // Set grammar list
                const grammarList = new (0, $lo8xw.SpeechGrammarList)();
                grammarList.phrases = getCommonAndLocalizedGrammars(locale);
                if (speechRecognitionDynamicGrammars.length) speechRecognitionDynamicGrammars.forEach((grammar)=>{
                    !grammarList.phrases.includes(grammar) && grammarList.phrases.push(grammar);
                });
                if (agentData?.name) {
                    // Add raw name
                    !grammarList.phrases.includes(agentData.name) && grammarList.phrases.push(agentData.name);
                    // Add lower-cased name
                    !grammarList.phrases.includes(agentData.name.toLocaleLowerCase(locale)) && grammarList.phrases.push(agentData.name.toLocaleLowerCase(locale));
                }
                currentPonyfill.speechRecognition.grammars = grammarList;
                setPonyfill(currentPonyfill);
            }
        }
    }, [
        ponyfillCredentials,
        locale,
        speechRecognitionDynamicGrammars,
        agentData
    ]);
    /**
   * Abort recognition if we are not on the 'home' page
   */ (0, $bxRTa.useEffect)(()=>{
        route !== (0, $2rYkD.Routes).Home && dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed));
    }, [
        route
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (ponyfill && appAvailable && loaderClosed) {
            if (ponyfill.speechRecognition) {
                ponyfill.speechRecognition.onstart = ()=>{
                    dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).Listening));
                };
                // onend callback is called only whithout using passive speech recognition
                ponyfill.speechRecognition.onend = ()=>{
                    activeModeRef.current !== (0, $2rYkD.RecognitionState).Closed && dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).Closing));
                };
                ponyfill.speechRecognition.onabort = ()=>{
                    dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed));
                };
                ponyfill.speechRecognition.onwakeup = ()=>{
                    if (activeModeRef.current === (0, $2rYkD.RecognitionState).Closed) {
                        console.log('Retorik Framework > wake word found, trying to open microphone');
                        activeModeRef.current === (0, $2rYkD.RecognitionState).Closed && dispatch((0, $cto9a.storeActions).speech.toggleMicrophone(false));
                    } else console.log('Retorik Framework > wake word found, but microphone not ready');
                };
                ponyfill.speechRecognition.onresult = (result)=>{
                    const lastMessage = result.length ? result[result.length - 1].transcript : null;
                    // Only get result in Active mode
                    if (lastMessage && activeModeRef.current === (0, $2rYkD.RecognitionState).Listening) dispatch((0, $cto9a.storeActions).speech.setLastRecognitionInterim(lastMessage));
                };
                setPonyfillReady(true);
            }
        }
    }, [
        ponyfill,
        appAvailable,
        loaderClosed
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (ponyfillReady && mode === (0, $2rYkD.Mode).vocal) // Start passive recognition if not done yet
        useContinuousRecognition && !ponyfill?.speechRecognition.started && askPermission();
    }, [
        mode,
        ponyfillReady
    ]);
    const togglePassiveToActive = ()=>{
        if (ponyfill?.speechRecognition.started) ponyfill.speechRecognition.toggleContinuousPassiveToActive();
        else if (ponyfill) {
            ponyfill.speechRecognition.passive = false;
            ponyfill.speechRecognition.continuous = false;
            ponyfill.speechRecognition.start();
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        activeModeRef.current = activeRecognitionState;
        if (ponyfill?.speechRecognition && appAvailable && loaderClosed) {
            timerRef?.current && clearTimeout(timerRef.current);
            switch(activeRecognitionState){
                // Do nothing if we are in a transition state
                case (0, $2rYkD.RecognitionState).Initializing:
                    useContinuousRecognition ? togglePassiveToActive() : ponyfill.speechRecognition.start();
                    break;
                case (0, $2rYkD.RecognitionState).Listening:
                    break;
                case (0, $2rYkD.RecognitionState).Closing:
                    if (lastRecognitionInterim) {
                        if (!delay) timerRef.current = setTimeout(()=>{
                            dispatch((0, $cto9a.storeActions).directline.sendMessage({
                                text: lastRecognitionInterim
                            }));
                            dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed));
                        }, $929f3e20ef85e71e$var$timeoutDuration);
                    } else dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed));
                    break;
                case (0, $2rYkD.RecognitionState).ForceClosing:
                    dispatch((0, $cto9a.storeActions).speech.setLastRecognitionInterim(''));
                    // Let's abort the current recognition
                    ponyfill.speechRecognition.started ? ponyfill.speechRecognition.abort?.() : dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed));
                    break;
                case (0, $2rYkD.RecognitionState).Closed:
                    if (useContinuousRecognition && mode === (0, $2rYkD.Mode).vocal) timerRef.current = setTimeout(()=>{
                        ponyfill.speechRecognition.toggleContinuousActiveToPassive();
                    }, $929f3e20ef85e71e$var$timeoutDuration);
                    dispatch((0, $cto9a.storeActions).speech.setLastRecognitionInterim(''));
                    break;
            }
        }
    }, [
        activeRecognitionState
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $929f3e20ef85e71e$export$2e2bcd8739ae039 = $929f3e20ef85e71e$var$RecognitionManager;


const $93362ea804fbed50$var$SpeechManager = ({ isRetorikNews: isRetorikNews })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $33bbcb005e851f61$export$2e2bcd8739ae039), {
                isRetorikNews: isRetorikNews
            }),
            !isRetorikNews && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $929f3e20ef85e71e$export$2e2bcd8739ae039), {})
        ]
    });
};
var $93362ea804fbed50$export$2e2bcd8739ae039 = $93362ea804fbed50$var$SpeechManager;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $clSD3 = parcelRequire("clSD3");

var $2rYkD = parcelRequire("2rYkD");
const $7b98e1e71501801c$var$FocusManager = ()=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const isWidget = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isWidget);
    const open = (0, $5FZWK.useSelector)((state)=>state.widgetReducer.open);
    const muted = (0, $5FZWK.useSelector)((state)=>state.speechReducer.muted);
    const activeRecognitionState = (0, $5FZWK.useSelector)((state)=>state.speechReducer.activeRecognitionState);
    const focusedRef = (0, $bxRTa.useRef)(true);
    const oldMutedRef = (0, $bxRTa.useRef)(muted);
    const recognitionStateRef = (0, $bxRTa.useRef)(activeRecognitionState);
    (0, $bxRTa.useEffect)(()=>{
        focusedRef.current && (oldMutedRef.current = muted);
    }, [
        muted
    ]);
    (0, $bxRTa.useEffect)(()=>{
        recognitionStateRef.current = activeRecognitionState;
    }, [
        activeRecognitionState
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if ((0, $clSD3.isMobile) && isWidget) {
            if (open) {
                focusedRef.current = true;
                oldMutedRef.current === false && dispatch((0, $cto9a.storeActions).speech.setMuted(false));
            } else {
                focusedRef.current = false;
                dispatch((0, $cto9a.storeActions).speech.cancelCurrentUtterance());
                dispatch((0, $cto9a.storeActions).speech.setMuted(true));
                recognitionStateRef.current === (0, $2rYkD.RecognitionState).Listening && dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing));
            }
        }
    }, [
        open,
        isWidget,
        (0, $clSD3.isMobile)
    ]);
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === 'visible') {
            focusedRef.current = true;
            oldMutedRef.current === false && dispatch((0, $cto9a.storeActions).speech.setMuted(false));
        } else {
            focusedRef.current = false;
            dispatch((0, $cto9a.storeActions).speech.cancelCurrentUtterance());
            dispatch((0, $cto9a.storeActions).speech.setMuted(true));
            recognitionStateRef.current === (0, $2rYkD.RecognitionState).Listening && dispatch((0, $cto9a.storeActions).speech.setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing));
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        (0, $clSD3.isMobile) && document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [
        (0, $clSD3.isMobile)
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $7b98e1e71501801c$export$2e2bcd8739ae039 = $7b98e1e71501801c$var$FocusManager;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $eyNRs = parcelRequire("eyNRs");
const $aebbface17e3c004$var$MobileLandscapePreventer = ()=>{
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const isMobileLandscape = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobileLandscape);
    return isMobileLandscape ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-absolute rf-w-full rf-h-full rf-z-exitwidget rf-flex rf-flex-col rf-items-center rf-bg-truewhite",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-1/2 rf-flex rf-items-end rf-pb-4",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                    className: "rf-h-2/3",
                    src: (0, $eyNRs.rotatingPhoneFromVerticalToHorizontalPosition)
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-h-1/2 rf-pt-4 rf-flex rf-flex-col rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-font-semibold rf-text-xl",
                        children: translation.mobileLandscapePreventer.firstline
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-font-bold rf-text-3xl",
                        children: translation.mobileLandscapePreventer.secondline
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $aebbface17e3c004$export$2e2bcd8739ae039 = $aebbface17e3c004$var$MobileLandscapePreventer;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");
const $3a939308a60f9856$var$typingTimer = 2000;
const $3a939308a60f9856$var$SendTypingIndicator = ({ isRetorikNews: isRetorikNews })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const speaking = (0, $5FZWK.useSelector)((state)=>state.speechReducer.speaking);
    const streamingQueue = (0, $5FZWK.useSelector)((state)=>state.speechReducer.streamingQueue);
    const activeRecognitionState = (0, $5FZWK.useSelector)((state)=>state.speechReducer.activeRecognitionState);
    const route = (0, $5FZWK.useSelector)((state)=>state.viewReducer.route);
    const loaderClosed = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.loaderClosed);
    const appAvailable = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.appAvailable);
    const isWaitingForResponse = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.isWaitingForResponse);
    const currentSubView = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.currentSubView);
    const listStatus = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.listStatus);
    const retorikEvent = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.retorikEvent);
    const userIsTyping = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.userIsTyping);
    const userIsSwiping = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.userIsSwiping);
    const dataRef = (0, $bxRTa.useRef)(false);
    (0, $bxRTa.useEffect)(()=>{
        // Don't send typing activity when we are receiving streaming events
        const isReceivingStreamingData = !!streamingQueue.length && !!streamingQueue.find((activity)=>activity.name?.toLowerCase() === 'davi.streammessageactivity') && !streamingQueue.find((activity)=>activity.value?.streamingCount);
        dataRef.current = !isWaitingForResponse && // Don't send typing activity when we are receiving streaming events
        !isReceivingStreamingData && (!loaderClosed || activeRecognitionState !== (0, $2rYkD.RecognitionState).Closed || userIsTyping || userIsSwiping || speaking || currentSubView !== (0, $2rYkD.CurrentSubView).none || route === (0, $2rYkD.Routes).News || retorikEvent === (0, $2rYkD.RetorikEvent).DetailViewOpen || listStatus === (0, $2rYkD.ListStatus).opened);
        dispatch((0, $cto9a.storeActions).directline.setApplicationIsBusy(!!dataRef.current));
    }, [
        appAvailable,
        loaderClosed,
        activeRecognitionState,
        userIsTyping,
        userIsSwiping,
        speaking,
        streamingQueue,
        currentSubView,
        route,
        retorikEvent,
        listStatus,
        isWaitingForResponse
    ]);
    const checkShouldSendTypingIndicator = ()=>{
        dataRef.current && !isRetorikNews && dispatch((0, $cto9a.storeActions).directline.sendTyping());
    };
    (0, $bxRTa.useEffect)(()=>{
        const interval = setInterval(()=>{
            checkShouldSendTypingIndicator();
        }, $3a939308a60f9856$var$typingTimer);
        return ()=>{
            interval && clearInterval(interval);
        };
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $3a939308a60f9856$export$2e2bcd8739ae039 = $3a939308a60f9856$var$SendTypingIndicator;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");
const $1fdb6bf67360bb2c$var$Subtitle = ({ isSpeaking: isSpeaking, elapsedTime: elapsedTime })=>{
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const displaySubtitles = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.displaySubtitles);
    const boundaryData = (0, $5FZWK.useSelector)((state)=>state.speechReducer.boundaryData);
    const configuration = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration);
    const currentDeviceType = (0, $5FZWK.useSelector)((state)=>state.viewReducer.currentDeviceType);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    const [sentenceToDisplay, setSentenceToDisplay] = (0, $bxRTa.useState)('');
    const keepLastSentenceRef = (0, $bxRTa.useRef)(null);
    // Generate an array of sentences from boundaryData
    const sentences = (0, $bxRTa.useMemo)(()=>{
        // If no boundary data is available, return an empty array
        if (!boundaryData || boundaryData.length === 0) return [];
        // Prepare an array to store sentences and their durations
        const sentencesArray = [];
        let currentSentence = '';
        let currentStartTime = boundaryData[0].startTime / 10000;
        // Loop over each boundary data item
        for(let i = 0; i < boundaryData.length; i++){
            const boundary = boundaryData[i];
            // Prepare a string based on the word at the boundary
            let boundaryString = '';
            if ([
                '.',
                ',',
                '...'
            ].includes(boundary.word)) boundaryString = boundary.word;
            else if ([
                ':',
                ';',
                '!',
                '?'
            ].includes(boundary.word)) boundaryString = '\u00A0' + boundary.word;
            else boundaryString = i === 0 ? boundary.word : ' ' + boundary.word;
            // Construct a new sentence
            const newSentence = currentSentence + boundaryString;
            // If it's the last boundary of the current array or the end of the boundaries (type 'EndBoundary')
            if (i === boundaryData.length - 1 || boundary.boundaryType === 'EndBoundary') // If there is a sentence to push, add it to the array
            {
                if (newSentence.trim() !== '') sentencesArray.push({
                    sentence: newSentence,
                    startTime: currentStartTime
                });
            } else if (newSentence.length > 50) {
                // If the current word is a punctuation, add it even if it goes beyond 50 characters
                if (boundary.boundaryType === 'PunctuationBoundary') {
                    if (newSentence.trim() !== '') sentencesArray.push({
                        sentence: newSentence,
                        startTime: currentStartTime
                    });
                    currentStartTime = boundaryData[i + 1].startTime / 10000;
                    currentSentence = '';
                } else {
                    if (newSentence.trim() !== '') sentencesArray.push({
                        sentence: currentSentence,
                        startTime: currentStartTime
                    });
                    currentStartTime = boundary.startTime / 10000;
                    currentSentence = boundary.word;
                }
            } else // Continue the current sentence
            currentSentence = newSentence;
        }
        return sentencesArray;
    }, [
        boundaryData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                setGridRowStart(11);
                setGridRowSpan(1);
                break;
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                if (configuration.subtitlesPosition?.landscape) {
                    const start = configuration.subtitlesPosition.landscape.containerRowStart || 9;
                    const end = configuration.subtitlesPosition.landscape.containerRowEnd || 13;
                    setGridRowStart(start);
                    setGridRowSpan(end - start);
                } else {
                    setGridRowStart(9);
                    setGridRowSpan(4);
                }
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                if (configuration.subtitlesPosition?.borne) {
                    const start = configuration.subtitlesPosition.borne.containerRowStart || 11;
                    const end = configuration.subtitlesPosition.borne.containerRowEnd || 13;
                    setGridRowStart(start);
                    setGridRowSpan(end - start);
                } else if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.borne) {
                    if (configuration.answerpanel.borne.containerRowEnd && configuration.answerpanel.borne.containerRowEnd < 12) {
                        setGridRowStart(configuration.answerpanel.borne.containerRowEnd + 1);
                        setGridRowSpan(1);
                    } else {
                        setGridRowStart(11);
                        setGridRowSpan(2);
                    }
                } else {
                    setGridRowStart(11);
                    setGridRowSpan(2);
                }
                break;
        }
    }, [
        configuration.answerpanel,
        configuration.subtitlesPosition,
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (elapsedTime) {
            for(let i = sentences.length - 1; i >= 0; i--)if (sentences[i].startTime < elapsedTime) {
                setSentenceToDisplay(sentences[i].sentence);
                break;
            }
        }
    }, [
        elapsedTime
    ]);
    (0, $bxRTa.useEffect)(()=>{
        keepLastSentenceRef.current && clearTimeout(keepLastSentenceRef.current);
        if (!isSpeaking && sentenceToDisplay && keepLastSentenceRef) keepLastSentenceRef.current = setTimeout(()=>{
            setSentenceToDisplay('');
        }, 1500);
        return ()=>{
            keepLastSentenceRef.current && clearTimeout(keepLastSentenceRef.current);
        };
    }, [
        isSpeaking
    ]);
    return mode === (0, $2rYkD.Mode).vocal && sentenceToDisplay && displaySubtitles ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-framework-subtitles-container",
        className: "rf-relative rf-z-util rf-col-start-1 vertical:rf-col-span-full rf-col-span-4 rf-justify-self-center rf-self-center large-vertical:rf-self-start rf-overflow-y-auto rf-scrollbar-thin rf-w-1/2 vertical:rf-w-5/6 large-vertical:rf-w-3/5 rf-max-h-full rf-py-1 large:rf-py-4",
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            id: "retorik-framework-subtitles",
            className: "rf-relative rf-max-h-full rf-bg-vocalModeSubtitlesBackground rf-text-vocalModeSubtitlesText rf-justify-self-center rf-self-center rf-p-2 large:rf-p-4 rf-text-size-auto rf-text-center",
            children: sentenceToDisplay
        })
    }) : null;
};
var $1fdb6bf67360bb2c$export$2e2bcd8739ae039 = $1fdb6bf67360bb2c$var$Subtitle;



const $0f3dc49c00f92a8a$var$ThreeJsWrapper = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("f9W3H")));

const $0f3dc49c00f92a8a$var$SpiritEngineWrapper = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("hhGYP")));
const $0f3dc49c00f92a8a$var$intervalInMilliseconds = 100;
const $0f3dc49c00f92a8a$var$ChatbotAndSubtitlesContainer = ({ centered: centered, chatbotData: chatbotData, isNewsView: isNewsView, parent: parent })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const agentData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.agentData);
    const speaking = (0, $5FZWK.useSelector)((state)=>state.speechReducer.speaking);
    const boundaryData = (0, $5FZWK.useSelector)((state)=>state.speechReducer.boundaryData);
    const mode = (0, $5FZWK.useSelector)((state)=>state.speechReducer.mode);
    const displayAgentInNews = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.displayAgentInNews);
    const displayAgent = (0, $5FZWK.useSelector)((state)=>state.utilsReducer.displayAgent);
    const route = (0, $5FZWK.useSelector)((state)=>state.viewReducer.route);
    const isMobile = (0, $5FZWK.useSelector)((state)=>state.viewReducer.isMobile);
    const visibility = (0, $5FZWK.useSelector)((state)=>state.viewReducer.visibility);
    const isNews = (0, $bxRTa.useMemo)(()=>{
        return parent === (0, $2rYkD.ContainerParent).news || route === (0, $2rYkD.Routes).News;
    }, [
        parent,
        route
    ]);
    const isAgentVisible = (0, $bxRTa.useMemo)(()=>{
        return displayAgent && !(isNews && !displayAgentInNews) && !(isMobile && mode === (0, $2rYkD.Mode).text) && route !== (0, $2rYkD.Routes).EmptyVeille && route !== (0, $2rYkD.Routes).ScreenSaver && route !== (0, $2rYkD.Routes).SlideShow && visibility === 'visible';
    }, [
        mode,
        isMobile,
        displayAgent,
        displayAgentInNews,
        isNews,
        visibility,
        route
    ]);
    const [speechIntervals, setSpeechIntervals] = (0, $bxRTa.useState)([]);
    const [isSpeaking, setIsSpeaking] = (0, $bxRTa.useState)(false);
    const [elapsedTime, setElapsedTime] = (0, $bxRTa.useState)(0);
    const timerRef = (0, $bxRTa.useRef)(null);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    // Set calibration completed if we don't use bodyengine. Required to start the conversation.
    (0, $bxRTa.useEffect)(()=>{
        (!agentData || !agentData.useBodyEngineThree) && dispatch((0, $cto9a.storeActions).view.setCalibrationCompleted(true));
    }, [
        agentData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (chatbotData?.containerRowStart && chatbotData.containerRowStart > 0 && chatbotData.containerRowStart < 13) {
            if (chatbotData.containerRowEnd && chatbotData.containerRowEnd < 13) {
                if (chatbotData.containerRowStart < chatbotData.containerRowEnd) {
                    setGridRowStart(chatbotData.containerRowStart);
                    setGridRowSpan(chatbotData.containerRowEnd - chatbotData.containerRowStart);
                }
            } else {
                setGridRowStart(chatbotData.containerRowStart);
                setGridRowSpan(13 - chatbotData.containerRowStart);
            }
        } else if (chatbotData?.containerRowEnd && chatbotData.containerRowEnd > 0 && chatbotData.containerRowEnd < 13) {
            setGridRowStart(1);
            setGridRowSpan(chatbotData.containerRowEnd - 1);
        } else {
            setGridRowStart(1);
            setGridRowSpan(12);
        }
    }, [
        chatbotData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (isNewsView) setIsSpeaking(speaking);
        else if (speaking && timerRef) {
            timerRef.current && clearInterval(timerRef.current);
            const now = Date.now();
            timerRef.current = setInterval(()=>{
                setElapsedTime(Date.now() - now);
            }, $0f3dc49c00f92a8a$var$intervalInMilliseconds);
        } else {
            timerRef?.current && clearInterval(timerRef.current);
            setElapsedTime(0);
        }
        return ()=>{
            timerRef?.current && clearInterval(timerRef.current);
        };
    }, [
        speaking
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (boundaryData.length > 0) {
            const tempArray = [];
            // While animations can't keep up, let's just synchronize the beginning and the end of speech
            const firstWord = boundaryData.find((boundary)=>boundary.boundaryType === 'WordBoundary');
            const lastWord = boundaryData.slice().reverse().find((boundary)=>boundary.boundaryType === 'WordBoundary');
            if (firstWord && lastWord) {
                tempArray.push(firstWord.startTime / 10000);
                tempArray.push(lastWord.endTime / 10000);
            }
            setSpeechIntervals(tempArray);
        } else setSpeechIntervals([]);
    }, [
        boundaryData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (elapsedTime && speechIntervals.length > 0) {
            let inside = false;
            for(let i = 0; i < speechIntervals.length; i++)if (speechIntervals[i] > elapsedTime) {
                inside = true;
                setIsSpeaking(!(i % 2 === 0));
                break;
            }
            !inside && setIsSpeaking(false);
        } else setIsSpeaking(false);
    }, [
        elapsedTime
    ]);
    const handleClick = (e)=>{
        dispatch((0, $cto9a.storeActions).utils.setClickedOnUI((0, $2rYkD.UIPart).agent));
        e.stopPropagation();
        e.preventDefault();
    };
    return agentData ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                id: "retorik-animation-container",
                className: `rf-relative rf-z-agent rf-col-start-1 rf-col-end-9 ${(!centered || isNews) && 'landscape-retorik:-rf-translate-x-1/4'} rf-row-span-full rf-self-end rf-h-full`,
                style: {
                    visibility: isAgentVisible ? 'visible' : 'hidden',
                    gridRow: `${gridRowStart} / span ${gridRowSpan}`
                },
                onClick: (e)=>handleClick(e),
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bxRTa.Suspense), {
                    children: agentData.useBodyEngineThree ? /*#__PURE__*/ (0, $fl9nK.jsx)($0f3dc49c00f92a8a$var$ThreeJsWrapper, {
                        agentData: agentData,
                        visible: isAgentVisible,
                        ...chatbotData,
                        centered: !!(centered && !isNews)
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)($0f3dc49c00f92a8a$var$SpiritEngineWrapper, {
                        agentData: agentData,
                        height: chatbotData?.height,
                        size: chatbotData?.size,
                        isSpeaking: isSpeaking
                    })
                })
            }),
            !isNews && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1fdb6bf67360bb2c$export$2e2bcd8739ae039), {
                isSpeaking: isSpeaking,
                elapsedTime: elapsedTime
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $0f3dc49c00f92a8a$export$2e2bcd8739ae039 = $0f3dc49c00f92a8a$var$ChatbotAndSubtitlesContainer;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

const $762945879c549fe9$var$VeilleManager = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("hQGDp")));
const $762945879c549fe9$var$VeilleContainer = ()=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const addressData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.addressData);
    const veilleConfiguration = (0, $5FZWK.useSelector)((state)=>state.viewReducer.veilleConfiguration);
    const veilleEnabled = (0, $5FZWK.useSelector)((state)=>!!state.viewReducer.veilleConfiguration.enabled);
    const loaderClosed = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.loaderClosed);
    const appAvailable = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.appAvailable);
    const typingCount = (0, $5FZWK.useSelector)((state)=>state.directlineReducer.typingCount);
    const [applicationReady, setApplicationReady] = (0, $bxRTa.useState)(false);
    const [veilleLaunched, setVeilleLaunched] = (0, $bxRTa.useState)(false);
    const timerRef = (0, $bxRTa.useRef)(null);
    const veilleConfigurationRef = (0, $bxRTa.useRef)(veilleConfiguration);
    const veilleEnabledRef = (0, $bxRTa.useRef)(veilleEnabled);
    const veilleLaunchedRef = (0, $bxRTa.useRef)(false);
    (0, $bxRTa.useEffect)(()=>{
        if (loaderClosed || appAvailable) setApplicationReady(true);
    }, [
        loaderClosed,
        appAvailable
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (!veilleEnabled) {
            veilleEnabledRef.current = veilleEnabled;
            timerRef.current && clearTimeout(timerRef.current);
            onClose();
        } else if (applicationReady) veilleEnabledRef.current = veilleEnabled;
    }, [
        veilleEnabled,
        applicationReady
    ]);
    (0, $bxRTa.useEffect)(()=>{
        veilleLaunchedRef.current = veilleLaunched;
    }, [
        veilleLaunched
    ]);
    const refreshTimer = async ()=>{
        timerRef.current && clearTimeout(timerRef.current);
        timerRef.current = setTimeout(async ()=>{
            if (veilleConfigurationRef.current?.killConversationOnLaunch) {
                // Reset directline if a new one has already been recreated for the news inside the veille
                veilleConfigurationRef.current.views?.news?.enabled && await dispatch((0, $cto9a.storeActions).directline.endConversation());
                await dispatch((0, $cto9a.storeActions).directline.recreateDirectline({
                    addressData: addressData,
                    userId: `veille_${Date.now()}`,
                    skipWelcome: true
                }));
            }
            setVeilleLaunched(true);
        }, (veilleConfiguration.delayBeforeLaunchInSeconds || 120) * 1000);
    };
    (0, $bxRTa.useEffect)(()=>{
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, []);
    /**
   * Refresh the timer of the veille on each typing activity emitted
   */ (0, $bxRTa.useEffect)(()=>{
        if (!veilleLaunchedRef.current && veilleEnabledRef.current) refreshTimer();
    }, [
        typingCount
    ]);
    const onClose = async ()=>{
        if (veilleLaunchedRef.current) {
            // Kill and recreate directline if needed
            if (veilleConfigurationRef.current?.killConversationOnLaunch) {
                // Reset directline if a new one has already been recreated for the news inside the veille
                veilleConfigurationRef.current.views?.news?.enabled && await dispatch((0, $cto9a.storeActions).directline.endConversation());
                await dispatch((0, $cto9a.storeActions).directline.recreateDirectline({
                    addressData: addressData
                }));
            }
            setVeilleLaunched(false);
        }
        veilleEnabledRef.current && refreshTimer();
    };
    return veilleLaunched ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bxRTa.Suspense), {
        children: /*#__PURE__*/ (0, $fl9nK.jsx)($762945879c549fe9$var$VeilleManager, {
            onClose: onClose
        })
    }) : null;
};
var $762945879c549fe9$export$2e2bcd8739ae039 = $762945879c549fe9$var$VeilleContainer;



const $9d5ff8c24d218fb6$var$VirtualKeyboard = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>Promise.resolve((parcelRequire("7Qm9Q"))).then((module)=>({
            default: module.default ?? module
        })));
// Overload adaptive card rendering classes
(0, $9ef4e35797212449$export$6108075486421829)();
const $9d5ff8c24d218fb6$var$RetorikContainer = ({ config: config, viewsConfig: viewsConfig, veilleConfig: veilleConfig, mapConfig: mapConfig, chatbotData: chatbotData, chatbotDataWidget: chatbotDataWidget, agentData: agentData, ponyfillFactoryCredentials: ponyfillFactoryCredentials, addressData: addressData, userData: userData, skipLoader: skipLoader, defaultMode: defaultMode, customVoice: customVoice, externalEventHandler: externalEventHandler, externalComponents: externalComponents, width: width, height: height, colors: colors, parent: parent, enableVirtualKeyboard: enableVirtualKeyboard })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const locale = (0, $5FZWK.useSelector)((state)=>state.localeReducer.locale);
    const currentLayout = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.currentLayout);
    const processedAgentData = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.agentData);
    (0, $bxRTa.useEffect)(()=>{
        dispatch((0, $cto9a.storeActions).view.setThemeColors((0, $4fe2e42aa167de9f$export$2e2bcd8739ae039)(colors)));
    }, []);
    return config && viewsConfig && veilleConfig && mapConfig && chatbotData && chatbotDataWidget && agentData && ponyfillFactoryCredentials ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $b4e3e24c87e40d50$export$2e2bcd8739ae039), {
        skipLoader: skipLoader,
        mode: defaultMode || (0, $2rYkD.Mode).vocal,
        viewsConfiguration: viewsConfig,
        veilleConfiguration: veilleConfig,
        mapConfiguration: mapConfig,
        configuration: config,
        addressData: addressData,
        agentSource: agentData,
        ponyfillFactoryCredentials: ponyfillFactoryCredentials,
        customVoice: customVoice,
        children: [
            !config.forceMobileView && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $aebbface17e3c004$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $6a60c4ac572a9b7a$export$2e2bcd8739ae039), {
                addressData: addressData,
                userData: userData,
                externalEventHandler: externalEventHandler,
                isRetorikNews: parent === (0, $2rYkD.ContainerParent).news,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $93362ea804fbed50$export$2e2bcd8739ae039), {
                        isRetorikNews: parent === (0, $2rYkD.ContainerParent).news
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7b98e1e71501801c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $44d007e76c69eba2$export$2e2bcd8739ae039), {
                        fullSize: parent !== (0, $2rYkD.ContainerParent).widget && config.fullSize !== false,
                        width: width,
                        height: height,
                        parent: parent,
                        children: [
                            processedAgentData && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $0f3dc49c00f92a8a$export$2e2bcd8739ae039), {
                                centered: chatbotData.fullWidthInDesktopMode,
                                chatbotData: currentLayout === (0, $2rYkD.ContainerParent).agent ? chatbotData : chatbotDataWidget,
                                parent: parent
                            }),
                            parent === (0, $2rYkD.ContainerParent).news ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fnPQZ.default), {
                                hideMenu: true,
                                isRetorikNews: true
                            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8d8907b91df6feae$export$2e2bcd8739ae039), {
                                externalComponents: externalComponents
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $762945879c549fe9$export$2e2bcd8739ae039), {}),
                            enableVirtualKeyboard && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bxRTa.Suspense), {
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)($9d5ff8c24d218fb6$var$VirtualKeyboard, {
                                    locale: locale,
                                    onlyOnTactileDevices: true,
                                    onlyWithRetorikFramework: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3a939308a60f9856$export$2e2bcd8739ae039), {
                        isRetorikNews: parent === (0, $2rYkD.ContainerParent).news
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $9d5ff8c24d218fb6$export$2e2bcd8739ae039 = $9d5ff8c24d218fb6$var$RetorikContainer;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $clSD3 = parcelRequire("clSD3");

var $iEJNQ = parcelRequire("iEJNQ");

var $2rYkD = parcelRequire("2rYkD");
const $a52955ed53ed59b6$var$Loader = ({ className: className, parent: parent, width: width, height: height, fullSize: fullSize })=>{
    const animationColor = {
        '--rf-color-loader-animation': '#00D7FF'
    };
    let widthStyle = {};
    let heightStyle = {};
    if (parent === (0, $2rYkD.ContainerParent).widget) {
        widthStyle = {
            width: '100%'
        };
        heightStyle = {
            height: height
        };
    }
    if (width === 'full') widthStyle = {
        width: '100%'
    };
    else if (typeof width === 'number') widthStyle = {
        width: `${width}px`
    };
    else if (typeof width === 'string') widthStyle = {
        width: width
    };
    if (height === 'full') heightStyle = {
        height: '100%',
        flexGrow: 1
    };
    else if (typeof height === 'number') heightStyle = {
        height: `${height}px`
    };
    else if (typeof height === 'string') heightStyle = {
        height: height
    };
    if (0, $clSD3.isMobile) heightStyle = {
        height: window.innerHeight,
        minHeight: window.innerHeight,
        maxHeight: window.innerHeight
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `${fullSize ? 'rf-w-screen rf-h-screen' : 'rf-w-full rf-h-full'} rf-max-w-screen rf-max-h-screen rf-bg-white ${className}`,
        style: {
            ...widthStyle,
            ...heightStyle
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-items-center",
            style: {
                background: 'rgba(18,18,18,0.7)',
                ...animationColor
            },
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-h-1/2 rf-pb-6 rf-flex rf-flex-col rf-items-center rf-justify-end",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-w-6 rf-h-6 rf-mb-16",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {})
                })
            })
        })
    });
};
var $a52955ed53ed59b6$export$2e2bcd8739ae039 = $a52955ed53ed59b6$var$Loader;




const $522017217b57aa4c$var$RetorikConfigHandler = ({ config: config, viewsConfig: viewsConfig, veilleConfig: veilleConfig, mapConfig: mapConfig, chatbotData: chatbotData, chatbotDataWidget: chatbotDataWidget, agentData: agentData, ponyfillFactoryCredentials: ponyfillFactoryCredentials, customVoice: customVoice, colors: colors, skipLoader: skipLoader, defaultMode: defaultMode, GDPR: GDPR, customScripts: customScripts, customCSS: customCSS, addressData: addressData, externalEventHandler: externalEventHandler, externalComponents: externalComponents, userData: userData, width: width, height: height, menuConfig: menuConfig, environmentPreset: environmentPreset, parent: parent, enableVirtualKeyboard: enableVirtualKeyboard })=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const baseAddress = (0, $5FZWK.useSelector)((state)=>state.localeReducer.baseAddress);
    const [fetchedConfig, setFetchedConfig] = (0, $bxRTa.useState)();
    const [mainConfig, setMainConfig] = (0, $bxRTa.useState)(undefined);
    const [isConfigUpdated, setIsConfigUpdated] = (0, $bxRTa.useState)(false);
    const fetchConfigurationFromRetorikStudio = async (baseAddress)=>{
        const fetchedConfig = await (0, $af55b6b5b4f24adb$export$2e2bcd8739ae039)({
            config: config,
            viewsConfig: viewsConfig,
            veilleConfig: veilleConfig,
            mapConfig: mapConfig,
            chatbotData: chatbotData,
            chatbotDataWidget: chatbotDataWidget,
            agentData: agentData,
            ponyfillFactoryCredentials: ponyfillFactoryCredentials,
            customVoice: customVoice,
            colors: colors,
            skipLoader: skipLoader,
            defaultMode: defaultMode,
            GDPR: GDPR,
            addressData: addressData,
            externalEventHandler: externalEventHandler,
            externalComponents: externalComponents,
            userData: userData,
            width: width,
            height: height,
            menuConfig: menuConfig,
            enableVirtualKeyboard: enableVirtualKeyboard
        }, baseAddress);
        console.log('Retorik Framework > configuration fetched from Retorik Studio');
        fetchedConfig && setFetchedConfig(fetchedConfig);
    };
    const checkGDPR = async (baseAddress)=>{
        const data = await (0, $6b7b10b90b820580$export$284b58786299e6c5)({
            configurationData: GDPR,
            baseAddress: baseAddress
        });
        // Set GDPR data in UtilsContext
        data.data && dispatch((0, $cto9a.storeActions).utils.setGDPRWindowData(data.data));
        dispatch((0, $cto9a.storeActions).utils.setGDPRDisplay(data.displayGDPR));
        typeof data.userConsent === 'boolean' && dispatch((0, $cto9a.storeActions).utils.setGDPRUserConsent(data.userConsent));
    };
    /**
   * Process addressData to get the baseAddress and then :
   * - fetch configuration and save it
   * - get GDPR data and store them
   * - fetch available languages and store them
   * - set baseAddress in store
   */ (0, $bxRTa.useEffect)(()=>{
        if (addressData && (addressData.baseURI || addressData.tenant)) {
            const baseAddress = (0, $39912af9dc3f41d7$export$2e2bcd8739ae039)(addressData);
            dispatch((0, $cto9a.storeActions).locale.setBaseAddress(baseAddress));
        }
    }, [
        addressData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (baseAddress) {
            fetchConfigurationFromRetorikStudio(baseAddress);
            checkGDPR(baseAddress);
        }
    }, [
        baseAddress
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (environmentPreset) dispatch((0, $cto9a.storeActions).retorik.setEnvironmentPreset(environmentPreset));
    }, [
        environmentPreset
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (fetchedConfig) {
            const { skipLoader: _skipLoader, defaultMode: _defaultMode, config: _config, viewsConfig: _viewsConfig, veilleConfig: _veilleConfig, mapConfig: _mapConfig, chatbotData: _chatbotData, chatbotDataWidget: _chatbotDataWidget, agentData: _agentData, addressData: _addressData, ponyfillFactoryCredentials: _ponyfillFactoryCredentials, customVoice: _customVoice, colors: _colors, defaultCulture: defaultCulture, supportedCultures: supportedCultures, customScripts: _customScripts, customCSS: _customCSS, features: features } = fetchedConfig;
            // Language
            if (defaultCulture && supportedCultures) {
                const { processedDefaultLanguage: processedDefaultLanguage, processedSupported: processedSupported } = (0, $de28171980b2041e$export$92cb25ec092104e6)(defaultCulture, supportedCultures, true);
                processedDefaultLanguage && processedSupported && dispatch((0, $cto9a.storeActions).locale.setLanguageData({
                    defaultLocale: processedDefaultLanguage,
                    supported: processedSupported
                }));
            } else dispatch((0, $cto9a.storeActions).locale.fetchSupportedLanguages(baseAddress));
            // Colors
            if (colors?.theme || _colors?.theme) {
                const tempTheme = colors?.theme || _colors?.theme;
                if (tempTheme === (0, $2rYkD.Theme).auto && window.matchMedia) {
                    // Use window.matchMedia to detect navigator's theme and set final theme instead of "auto"
                    const theme = window.matchMedia('(prefers-color-scheme:light)')?.matches ? (0, $2rYkD.Theme).light : (0, $2rYkD.Theme).dark;
                    dispatch((0, $cto9a.storeActions).view.setTheme(theme));
                    colors && (colors.theme = theme);
                    _colors && (_colors.theme = theme);
                } else dispatch((0, $cto9a.storeActions).view.setTheme(tempTheme === (0, $2rYkD.Theme).light ? (0, $2rYkD.Theme).light : (0, $2rYkD.Theme).dark));
            } else if (window.matchMedia) {
                const tempTheme = window.matchMedia('(prefers-color-scheme:light)')?.matches ? (0, $2rYkD.Theme).light : (0, $2rYkD.Theme).dark;
                dispatch((0, $cto9a.storeActions).view.setTheme(tempTheme));
                _colors && (_colors.theme = tempTheme);
            }
            const mergedConfig = config !== undefined ? (0, $4fe2e42aa167de9f$export$6969335ea1e4e77c)(config, _config) : _config;
            const mergedMainConfig = {
                config: mergedConfig,
                viewsConfig: viewsConfig !== undefined ? (0, $4fe2e42aa167de9f$export$6969335ea1e4e77c)(viewsConfig, _viewsConfig) : _viewsConfig,
                veilleConfig: veilleConfig !== undefined ? (0, $4fe2e42aa167de9f$export$6969335ea1e4e77c)(veilleConfig, _veilleConfig) : _veilleConfig,
                mapConfig: mapConfig !== undefined ? (0, $4fe2e42aa167de9f$export$6969335ea1e4e77c)(mapConfig, _mapConfig) : _mapConfig,
                chatbotData: chatbotData !== undefined ? {
                    ..._chatbotData,
                    ...chatbotData
                } : _chatbotData,
                chatbotDataWidget: chatbotDataWidget !== undefined ? {
                    ..._chatbotDataWidget,
                    ...chatbotDataWidget
                } : _chatbotDataWidget,
                agentData: agentData !== undefined ? typeof agentData === 'string' ? agentData : (0, $4fe2e42aa167de9f$export$6969335ea1e4e77c)(agentData, _agentData) : _agentData,
                ponyfillFactoryCredentials: ponyfillFactoryCredentials !== undefined ? ponyfillFactoryCredentials : _ponyfillFactoryCredentials,
                customVoice: customVoice !== undefined ? {
                    ..._customVoice,
                    ...customVoice
                } : _customVoice,
                colors: colors !== undefined ? (0, $4fe2e42aa167de9f$export$6969335ea1e4e77c)(colors, (0, $4fe2e42aa167de9f$export$2e2bcd8739ae039)(_colors)) : (0, $4fe2e42aa167de9f$export$2e2bcd8739ae039)(_colors),
                skipLoader: skipLoader !== undefined ? skipLoader : _skipLoader,
                defaultMode: defaultMode !== undefined ? defaultMode : mergedConfig.disableSpeechMode ? (0, $2rYkD.Mode).text : mergedConfig.disableTextMode ? (0, $2rYkD.Mode).vocal : _defaultMode,
                // Data not retrieved from Retorik Studio
                addressData: _addressData,
                userData: userData,
                externalEventHandler: externalEventHandler,
                externalComponents: externalComponents,
                width: width,
                height: height,
                enableVirtualKeyboard: enableVirtualKeyboard
            };
            // Prevent menus from being copied again after each modification of configuration
            if (mergedMainConfig.config) {
                mergedMainConfig.config.baseMenu = config?.baseMenu || menuConfig?.baseMenu;
                mergedMainConfig.config.customMenu = config?.customMenu || menuConfig?.customMenu;
                mergedMainConfig.config.subMenu = config?.subMenu || menuConfig?.subMenu;
                mergedMainConfig.config.menu = config?.menu || menuConfig?.menu || _config?.menu;
            }
            dispatch((0, $cto9a.storeActions).retorik.setCustomScripts(customScripts || _customScripts || []));
            dispatch((0, $cto9a.storeActions).retorik.setCustomCSS(customCSS || _customCSS || []));
            dispatch((0, $cto9a.storeActions).retorik.setEnabledFeatures(features || []));
            // Save this config and use it in the application
            setMainConfig(mergedMainConfig);
            setIsConfigUpdated(true);
        }
    }, [
        config,
        viewsConfig,
        veilleConfig,
        chatbotData,
        chatbotDataWidget,
        agentData,
        ponyfillFactoryCredentials,
        customVoice,
        colors,
        skipLoader,
        defaultMode,
        GDPR,
        customScripts,
        addressData,
        externalEventHandler,
        externalComponents,
        userData,
        width,
        height,
        menuConfig,
        fetchedConfig
    ]);
    return mainConfig ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9d5ff8c24d218fb6$export$2e2bcd8739ae039), {
        parent: parent,
        ...mainConfig
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a52955ed53ed59b6$export$2e2bcd8739ae039), {
        className: isConfigUpdated ? 'rf-animate-loaderFadeOut' : '',
        parent: parent,
        width: width,
        height: height,
        fullSize: !!(parent !== (0, $2rYkD.ContainerParent).widget && config?.fullSize !== false)
    });
};
var $522017217b57aa4c$export$2e2bcd8739ae039 = $522017217b57aa4c$var$RetorikConfigHandler;


const $da2880bb97fd9e98$var$RetorikAgent = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au retorikAgent
    // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer
    // -------------------------
    (0, $bxRTa.useEffect)(()=>{
        props.renderCallback?.();
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5FZWK.Provider), {
        store: (0, $cto9a.default),
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f6050bdd136b78fe$export$bb3ea6dd2428edb6), {
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bd43c48bdb8caf5f$export$2e2bcd8739ae039), {
                instanceId: props.instanceId,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3b22c72029a66628$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $88f116d8e86f389c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $522017217b57aa4c$export$2e2bcd8739ae039), {
                            parent: (0, $2rYkD.ContainerParent).agent,
                            ...props
                        })
                    })
                })
            })
        })
    });
};
var $da2880bb97fd9e98$export$2e2bcd8739ae039 = $da2880bb97fd9e98$var$RetorikAgent;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $cto9a = parcelRequire("cto9a");

var $5FZWK = parcelRequire("5FZWK");


var $2rYkD = parcelRequire("2rYkD");









var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5FZWK = parcelRequire("5FZWK");

var $cto9a = parcelRequire("cto9a");

var $2rYkD = parcelRequire("2rYkD");
// Get style for widget's border (except colors)
const $fa75495d058a0be6$export$d6ad062ea094ff6f = (borderData)=>{
    if (!borderData || !borderData.color && borderData.thickness === undefined && borderData.rounded === undefined) return 'rf-border rf-rounded rf-border-gray';
    const borderThickness = borderData.thickness !== undefined && borderData.thickness !== 1 ? `rf-border-${borderData.thickness}` : 'rf-border';
    const borderRounded = borderData.rounded === false ? '' : 'rf-rounded-lg';
    return `${borderThickness} ${borderRounded}`;
};
// Get style for widget's button (except colors)
const $fa75495d058a0be6$export$5bc78eab59412c50 = (buttonData)=>{
    if (!buttonData || !buttonData.text && !buttonData.image && !buttonData.border && !buttonData.background && !buttonData.position) return 'rf-rounded-lg rf-font-bold';
    // Button border
    const borderStyle = buttonData.border?.rounded === false ? '' : 'rf-rounded-lg';
    // Button text
    const textStyle = buttonData.text?.bold && buttonData.text.bold === false ? '' : 'rf-font-bold';
    return `${borderStyle} ${textStyle}`;
};




var $04Syy = parcelRequire("04Syy");

const $5bf33bed4d01de5f$var$LayoutHandler = (props)=>{
    const dispatch = (0, $5FZWK.useDispatch)();
    const translation = (0, $5FZWK.useSelector)((state)=>state.localeReducer.currentTranslations);
    const currentLayout = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.currentLayout);
    const displayChangeLayoutButton = (0, $5FZWK.useSelector)((state)=>state.retorikReducer.configuration).allowSwitchLayout;
    const open = (0, $5FZWK.useSelector)((state)=>state.widgetReducer.open);
    const loaded = (0, $5FZWK.useSelector)((state)=>state.widgetReducer.loaded);
    const widgetDisplayType = (0, $5FZWK.useSelector)((state)=>state.widgetReducer.widgetDisplayType);
    const [currentConfiguration, setCurrentConfiguration] = (0, $bxRTa.useState)(props.widgetConfig?.large);
    const [widgetButton, setWidgetButton] = (0, $bxRTa.useState)('');
    const [widgetBorder, setWidgetBorder] = (0, $bxRTa.useState)('');
    const [mobileWidth, setMobileWidth] = (0, $bxRTa.useState)(window.innerWidth < 600);
    const [frameStyle, setFrameStyle] = (0, $bxRTa.useState)({});
    const [hover, setHover] = (0, $bxRTa.useState)(false);
    const handleResize = ()=>{
        setMobileWidth(window.innerWidth < 600);
    };
    (0, $bxRTa.useEffect)(()=>{
        setWidgetButton((0, $fa75495d058a0be6$export$5bc78eab59412c50)(props.widgetConfig?.button));
        window.addEventListener('resize', handleResize);
        dispatch((0, $cto9a.storeActions).retorik.setLayout((0, $2rYkD.ContainerParent).widget));
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        mobileWidth ? setFrameStyle({
            width: open ? '100%' : '0px',
            height: '100%'
        }) : setFrameStyle({
            top: currentConfiguration?.position?.top,
            bottom: currentConfiguration?.position?.bottom ? currentConfiguration?.position?.bottom : currentConfiguration?.position?.top || currentConfiguration?.position?.left || currentConfiguration?.position?.right ? undefined : '1rem',
            left: currentConfiguration?.position?.left,
            right: currentConfiguration?.position?.right ? currentConfiguration?.position?.right : currentConfiguration?.position?.top || currentConfiguration?.position?.bottom || currentConfiguration?.position?.left ? undefined : '1rem',
            borderColor: currentConfiguration?.border?.color || (0, $410cf9d598c613db$export$4aebf65ed07cf17b).rgb
        });
    }, [
        mobileWidth,
        currentConfiguration
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(widgetDisplayType){
            case 'large':
                setCurrentConfiguration(props.widgetConfig?.large);
                setWidgetBorder((0, $fa75495d058a0be6$export$d6ad062ea094ff6f)(props.widgetConfig?.large?.border));
                break;
            case 'thumbnail':
                setCurrentConfiguration(props.widgetConfig?.thumbnail || props.widgetConfig?.large);
                setWidgetBorder((0, $fa75495d058a0be6$export$d6ad062ea094ff6f)(props.widgetConfig?.thumbnail?.border || props.widgetConfig?.large?.border));
                break;
            default:
                break;
        }
    }, [
        widgetDisplayType
    ]);
    const extendButtonHandler = ()=>{
        // if different display type available
        if (props.widgetConfig?.large && props.widgetConfig?.thumbnail) dispatch((0, $cto9a.storeActions).widget.toggleDisplay());
        else dispatch((0, $cto9a.storeActions).retorik.setLayout((0, $2rYkD.ContainerParent).agent));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fl9nK.Fragment), {
        children: [
            props.widgetConfig?.button?.display !== false && /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                id: "retorik-widget-button",
                className: `rf-fixed rf-px-2 rf-flex rf-flex-row rf-items-center ${widgetButton}`,
                style: {
                    color: props.widgetConfig?.button?.text?.color || (0, $410cf9d598c613db$export$4aebf65ed07cf17b).rgb,
                    backgroundColor: hover ? props.widgetConfig?.button?.background?.colorHover || 'transparent' : props.widgetConfig?.button?.background?.color || 'transparent',
                    borderWidth: props.widgetConfig?.button?.border?.thickness !== undefined ? `${props.widgetConfig?.button?.border?.thickness}px` : '1px',
                    borderColor: hover ? props.widgetConfig?.button?.border?.colorHover || (0, $410cf9d598c613db$export$4aebf65ed07cf17b).rgb : props.widgetConfig?.button?.border?.color || (0, $410cf9d598c613db$export$4aebf65ed07cf17b).rgb,
                    top: props.widgetConfig?.button?.position?.top,
                    bottom: props.widgetConfig?.button?.position?.bottom ? props.widgetConfig?.button?.position?.bottom : props.widgetConfig?.button?.position?.top || props.widgetConfig?.button?.position?.left || props.widgetConfig?.button?.position?.right ? undefined : '1rem',
                    left: props.widgetConfig?.button?.position?.left,
                    right: props.widgetConfig?.button?.position?.right ? props.widgetConfig?.button?.position?.right : props.widgetConfig?.button?.position?.top || props.widgetConfig?.button?.position?.bottom || props.widgetConfig?.button?.position?.left ? undefined : '1rem'
                },
                onClick: ()=>dispatch((0, $cto9a.storeActions).widget.toggleWidget()),
                onMouseEnter: ()=>setHover(true),
                onMouseLeave: ()=>setHover(false),
                children: [
                    props.widgetConfig?.button?.image?.hide !== true && props.widgetConfig?.button?.image?.url && props.widgetConfig?.button?.image?.position !== 'right' && /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                        className: `${props.widgetConfig?.button?.image.marginY === false ? '' : 'rf-my-1'}`,
                        src: `${props.widgetConfig.button.image.url}`,
                        alt: "Retorik widget",
                        style: {
                            height: props.widgetConfig?.button?.image.height || '2rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-py-2 rf-mx-2 rf-leading-4 rf-text-justify rf-whitespace-break-spaces",
                        style: {
                            overflowWrap: 'break-word',
                            maxWidth: props.widgetConfig?.button?.text?.maxWidth || 200
                        },
                        children: props.widgetConfig?.button?.text?.content || translation.common.needhelp
                    }),
                    props.widgetConfig?.button?.image?.hide !== true && props.widgetConfig?.button?.image?.url && props.widgetConfig?.button?.image?.position === 'right' && /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                        className: `${props.widgetConfig?.button?.image.marginY === false ? '' : 'rf-my-1'}`,
                        src: `${props.widgetConfig.button.image.url}`,
                        alt: "Retorik widget",
                        style: {
                            height: props.widgetConfig?.button?.image.height || '2rem'
                        }
                    })
                ]
            }),
            loaded && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `${currentLayout === (0, $2rYkD.ContainerParent).widget ? 'rf-fixed rf-pt-8 rf-height-fill-available rf-transition-all rf-overflow-hidden rf-max-w-[100vw]' : ''}`,
                style: currentLayout === (0, $2rYkD.ContainerParent).widget ? {
                    ...frameStyle,
                    width: open ? mobileWidth ? '100%' : currentConfiguration?.width || '400px' : '0px',
                    height: currentConfiguration?.height || (mobileWidth ? '100%' : '630px')
                } : {},
                "data-testid": "widget-wrapper",
                children: [
                    currentLayout === (0, $2rYkD.ContainerParent).widget && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                        children: [
                            !!displayChangeLayoutButton && !mobileWidth && /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                                onClick: extendButtonHandler,
                                "aria-label": "Extend",
                                className: "rf-absolute rf-z-exitwidget rf-flex rf-right-8 rf-top-0 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c8bd85879b11a2bb$export$2e2bcd8739ae039), {
                                    className: "rf-h-4 rf-w-4",
                                    color: "#000000",
                                    extended: false
                                })
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                                onClick: ()=>dispatch((0, $cto9a.storeActions).widget.toggleWidget()),
                                "aria-label": "Close",
                                className: "rf-absolute rf-z-exitwidget rf-flex rf-right-0 rf-top-0 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $04Syy.default), {
                                    className: "rf-h-4 rf-w-4",
                                    color: "#000000"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: `${currentLayout === (0, $2rYkD.ContainerParent).widget ? `rf-relative rf-h-full rf-w-full rf-overflow-hidden ${!mobileWidth && widgetBorder}` : ''}`,
                        style: currentLayout === (0, $2rYkD.ContainerParent).widget ? {
                            borderColor: frameStyle.borderColor
                        } : {},
                        children: props.children
                    })
                ]
            })
        ]
    });
};
var $5bf33bed4d01de5f$export$2e2bcd8739ae039 = $5bf33bed4d01de5f$var$LayoutHandler;



window.Retorik = {
    ...window.Retorik,
    openWidget: $7b2cab4dfcfe505d$export$a1c83309c736819f,
    closeWidget: $7b2cab4dfcfe505d$export$d27f1b0993b666c,
    toggleWidget: $7b2cab4dfcfe505d$export$77c0ba4d0d97cee5,
    toggleDisplay: $7b2cab4dfcfe505d$export$f0e9d14ede4c01bd
};
const $0ea8bb6e9c64ca4d$var$RetorikWidget = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au widget
    // Ce qui est commun avec RetorikAgent ou autres doit aller dans RetorikComposer ou ContextProvider
    // -------------------------
    const [processedProps, setProcessedProps] = (0, $bxRTa.useState)(undefined);
    const fetchAndProcessConfiguration = async (baseAddress)=>{
        const language = await (0, $de28171980b2041e$export$4186cc8c38f709fe)(baseAddress);
        const fetchedConfiguration = await (0, $af55b6b5b4f24adb$export$a6f1a8eda244b334)(baseAddress, language);
        const clonedProps = {
            ...props
        };
        // If we have a widget configuration in the props, let's use its data prior to the fetched ones
        if (clonedProps.widgetConfig) setProcessedProps(fetchedConfiguration ? {
            ...clonedProps,
            widgetConfig: (0, $4fe2e42aa167de9f$export$6969335ea1e4e77c)(clonedProps.widgetConfig, fetchedConfiguration)
        } : clonedProps);
        else setProcessedProps(fetchedConfiguration ? {
            ...clonedProps,
            widgetConfig: fetchedConfiguration
        } : clonedProps);
        props.renderCallback?.();
    };
    (0, $bxRTa.useEffect)(()=>{
        if (props.fromRetorikFrameworkComponent) {
            setProcessedProps(props);
            props.renderCallback?.();
        } else fetchAndProcessConfiguration((0, $39912af9dc3f41d7$export$2e2bcd8739ae039)(props.addressData));
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5FZWK.Provider), {
        store: (0, $cto9a.default),
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f6050bdd136b78fe$export$bb3ea6dd2428edb6), {
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bd43c48bdb8caf5f$export$2e2bcd8739ae039), {
                instanceId: props.instanceId,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3b22c72029a66628$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $88f116d8e86f389c$export$2e2bcd8739ae039), {
                        children: processedProps ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bf33bed4d01de5f$export$2e2bcd8739ae039), {
                            ...processedProps,
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $522017217b57aa4c$export$2e2bcd8739ae039), {
                                ...processedProps,
                                width: 'full',
                                height: 'full',
                                parent: (0, $2rYkD.ContainerParent).widget
                            })
                        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {})
                    })
                })
            })
        })
    });
};
var $0ea8bb6e9c64ca4d$export$2e2bcd8739ae039 = $0ea8bb6e9c64ca4d$var$RetorikWidget;



var $eb1a78537f005d38$var$Integration = /*#__PURE__*/ function(Integration) {
    Integration[Integration["none"] = 0] = "none";
    Integration[Integration["agent"] = 1] = "agent";
    Integration[Integration["widget"] = 2] = "widget";
    return Integration;
}($eb1a78537f005d38$var$Integration || {});
const $eb1a78537f005d38$var$RetorikFramework = (props)=>{
    const [integration, setIntegration] = (0, $bxRTa.useState)(0);
    const [widgetProps, setWidgetProps] = (0, $bxRTa.useState)();
    (0, $bxRTa.useEffect)(()=>{
        const getData = async ()=>{
            const baseAddress = (0, $39912af9dc3f41d7$export$2e2bcd8739ae039)(props.addressData);
            const language = await (0, $de28171980b2041e$export$4186cc8c38f709fe)(baseAddress);
            const data = await (0, $af55b6b5b4f24adb$export$398ec931dbe747c1)(baseAddress, language);
            if (data.integrationMode === 'widget') {
                const clonedProps = {
                    ...props
                };
                // If we have a widget configuration in the props, let's use its data prior to the fetched ones
                if (clonedProps.widgetConfig) data.widgetConfiguration && (clonedProps.widgetConfig = (0, $4fe2e42aa167de9f$export$6969335ea1e4e77c)(props.widgetConfig, data.widgetConfiguration));
                else clonedProps.widgetConfig = data.widgetConfiguration;
                setWidgetProps(clonedProps);
                setIntegration(2);
            } else setIntegration(1);
            // Call the render callback after we have defined which component to render
            props.renderCallback?.();
        };
        getData();
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            integration === 1 && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $da2880bb97fd9e98$export$2e2bcd8739ae039), {
                ...props
            }),
            integration === 2 && widgetProps && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $0ea8bb6e9c64ca4d$export$2e2bcd8739ae039), {
                ...widgetProps,
                fromRetorikFrameworkComponent: true
            })
        ]
    });
};
var $eb1a78537f005d38$export$2e2bcd8739ae039 = $eb1a78537f005d38$var$RetorikFramework;





var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $cto9a = parcelRequire("cto9a");

var $5FZWK = parcelRequire("5FZWK");

var $2rYkD = parcelRequire("2rYkD");





const $d0db728c13b4bca0$var$RetorikNews = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au retorikNews
    // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer ou ContextProvider
    // -------------------------
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5FZWK.Provider), {
        store: (0, $cto9a.default),
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f6050bdd136b78fe$export$bb3ea6dd2428edb6), {
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bd43c48bdb8caf5f$export$2e2bcd8739ae039), {
                instanceId: props.instanceId,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3b22c72029a66628$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $88f116d8e86f389c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $522017217b57aa4c$export$2e2bcd8739ae039), {
                            parent: (0, $2rYkD.ContainerParent).news,
                            ...props
                        })
                    })
                })
            })
        })
    });
};
var $d0db728c13b4bca0$export$2e2bcd8739ae039 = $d0db728c13b4bca0$var$RetorikNews;




function $36d4eaf4bff29fe5$export$2e2bcd8739ae039(RetorikFramework, props, element) {
    const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(element);
    root.render(/*#__PURE__*/ (0, $fl9nK.jsx)(RetorikFramework, {
        ...props
    }));
}
// WebComponent creation
class $36d4eaf4bff29fe5$var$RetorikFrameworkWebComponent extends HTMLElement {
    constructor(){
        super();
    }
    // Mehod called when the element is connected to the DOM
    connectedCallback() {
        const tenant = this.getAttribute('tenant');
        const prefix = this.getAttribute('prefix');
        const props = JSON.parse(this.getAttribute('props') || '{}');
        if (tenant) {
            const addressData = {
                tenant: tenant,
                prefix: prefix
            };
            this._renderAgent({
                ...props,
                addressData: addressData
            });
        }
    }
    // React component rendering
    _renderAgent(props) {
        const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(this);
        root.render(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $eb1a78537f005d38$export$2e2bcd8739ae039), {
            ...props
        }));
    }
}
// WebComponent registering in window
window.customElements.define('retorik-framework', $36d4eaf4bff29fe5$var$RetorikFrameworkWebComponent);



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


function $704c313ba3eba409$export$2e2bcd8739ae039(RetorikAgent, props, element) {
    const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(element);
    root.render(/*#__PURE__*/ (0, $fl9nK.jsx)(RetorikAgent, {
        ...props
    }));
}
// WebComponent creation
class $704c313ba3eba409$var$RetorikAgentWebComponent extends HTMLElement {
    constructor(){
        super();
    }
    // Mehod called when the element is connected to the DOM
    connectedCallback() {
        const tenant = this.getAttribute('tenant');
        const prefix = this.getAttribute('prefix');
        const props = JSON.parse(this.getAttribute('props') || '{}');
        if (tenant) {
            const addressData = {
                tenant: tenant,
                prefix: prefix
            };
            this._renderAgent({
                ...props,
                addressData: addressData
            });
        }
    }
    // React component rendering
    _renderAgent(props) {
        const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(this);
        root.render(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $da2880bb97fd9e98$export$2e2bcd8739ae039), {
            ...props
        }));
    }
}
// WebComponent registering in window
window.customElements.define('retorik-agent', $704c313ba3eba409$var$RetorikAgentWebComponent);



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


function $e8dbe447b062a0b6$export$2e2bcd8739ae039(RetorikWidget, props, element) {
    const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(element);
    root.render(/*#__PURE__*/ (0, $fl9nK.jsx)(RetorikWidget, {
        ...props
    }));
}
// WebComponent creation
class $e8dbe447b062a0b6$var$RetorikWidgetWebComponent extends HTMLElement {
    constructor(){
        super();
    }
    // Mehod called when the element is connected to the DOM
    connectedCallback() {
        const tenant = this.getAttribute('tenant');
        const prefix = this.getAttribute('prefix');
        const props = JSON.parse(this.getAttribute('props') || '{}');
        if (tenant) {
            const addressData = {
                tenant: tenant,
                prefix: prefix
            };
            this._renderWidget({
                ...props,
                addressData: addressData
            });
        }
    }
    // React component rendering
    _renderWidget(props) {
        const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(this);
        root.render(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $0ea8bb6e9c64ca4d$export$2e2bcd8739ae039), {
            ...props
        }));
    }
}
// WebComponent registering in window
window.customElements.define('retorik-widget', $e8dbe447b062a0b6$var$RetorikWidgetWebComponent);




var $itb2K = parcelRequire("itb2K");






var $dHUeX = parcelRequire("dHUeX");

var $2rYkD = parcelRequire("2rYkD");
const $7f785502bdb7babd$export$7a001476a013672 = ()=>{
    (0, $7b2cab4dfcfe505d$export$3118ae18000e2700)();
    (0, $7b2cab4dfcfe505d$export$93b55f822ac81934)();
    (0, $7b2cab4dfcfe505d$export$cd85ac4858c7290c)();
    (0, $7b2cab4dfcfe505d$export$b6d2196a3ce412d8)();
    (0, $7b2cab4dfcfe505d$export$b7b23f8e09258fa6)();
    (0, $7b2cab4dfcfe505d$export$8f3b2f6aa8e2c248)();
    (0, $7b2cab4dfcfe505d$export$64bb98402f29970)();
};
const $7f785502bdb7babd$var$renderFramework = (0, $36d4eaf4bff29fe5$export$2e2bcd8739ae039).bind(null, (0, $eb1a78537f005d38$export$2e2bcd8739ae039));
const $7f785502bdb7babd$export$b69254d879536cde = (0, $704c313ba3eba409$export$2e2bcd8739ae039).bind(null, (0, $da2880bb97fd9e98$export$2e2bcd8739ae039));
const $7f785502bdb7babd$var$renderWidget = (0, $e8dbe447b062a0b6$export$2e2bcd8739ae039).bind(null, (0, $0ea8bb6e9c64ca4d$export$2e2bcd8739ae039));
const $7f785502bdb7babd$export$7f09d7ad7dbdcd2c = (value)=>{
    window.Retorik._printingCallback = value;
};
var $7f785502bdb7babd$export$2e2bcd8739ae039 = (0, $da2880bb97fd9e98$export$2e2bcd8739ae039);
window.Retorik = {
    ...window.Retorik,
    renderFramework: $7f785502bdb7babd$var$renderFramework,
    renderAgent: $7f785502bdb7babd$export$b69254d879536cde,
    renderWidget: $7f785502bdb7babd$var$renderWidget,
    addDetailedAttachmentTrigger: $7b2cab4dfcfe505d$export$d1f60bb847ecc604,
    addExternalActivityHandler: $7b2cab4dfcfe505d$export$28afdcc603412603,
    cancelCurrentUtterance: $7b2cab4dfcfe505d$export$f3aaae0c8197c567,
    changeAgent: (0, $7b2cab4dfcfe505d$export$a72b80ff363563a1),
    displaySubtitles: (0, $7b2cab4dfcfe505d$export$708f3eb1d5828832),
    hideAgent: $7b2cab4dfcfe505d$export$e73dbd7ba351e3e,
    pauseConversation: $7b2cab4dfcfe505d$export$7431bc5a5c7c9317,
    playExternalSynthesis: $7b2cab4dfcfe505d$export$99dcb7840cd85481,
    resumeConversation: $7b2cab4dfcfe505d$export$cceb853b29df842,
    sendActivity: $7b2cab4dfcfe505d$export$d4c8c6daac289378,
    sendEvent: $7b2cab4dfcfe505d$export$7329bcdc3edcd90e,
    sendMessage: $7b2cab4dfcfe505d$export$465cb47180de50f0,
    sendMessageToChatbot: $7b2cab4dfcfe505d$export$255ebd0ca6bfba88,
    setExternalActivityHandlers: $7b2cab4dfcfe505d$export$2c7ae0f34657d605,
    setLocale: $7b2cab4dfcfe505d$export$c8aadf3621e41efb,
    setModalFullscreenContent: $7b2cab4dfcfe505d$export$4317154639841e84,
    setMuted: $7b2cab4dfcfe505d$export$a1680ba91cc9be33,
    setVisibility: $7b2cab4dfcfe505d$export$2c64211ecf98e50d,
    showAgent: $7b2cab4dfcfe505d$export$ae67eb518a2aae74,
    toggleMicrophone: $7b2cab4dfcfe505d$export$39fcdeae376856e7,
    toggleSubtitles: $7b2cab4dfcfe505d$export$3fa7f3a227fc16cb,
    toggleVisibility: $7b2cab4dfcfe505d$export$7396a2167c7f755e
};


//# sourceMappingURL=index.js.map
